// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (modules, entry, mainEntry, parcelRequireName, globalName) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        this
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });

      // <script>
    } else if (globalName) {
      this[globalName] = mainExports;
    }
  }
})({"f7EF9":[function(require,module,exports) {
var _regeneratorRuntime = require("regenerator-runtime");
var _react = require("@storybook/react");
var _clientApi = require("@storybook/client-api");
var _clientLogger = require("@storybook/client-logger");
var _storiesJsJsxTsTsx = require("../../**/stories/*.stories.{js,jsx,ts,tsx}");
var _config = require("../../../node_modules/@storybook/react/dist/esm/client/docs/config");
var _config1 = require("../../../node_modules/@storybook/react/dist/esm/client/preview/config");
var _previewJs = require("../../../node_modules/@storybook/addon-actions/preview.js");
var _previewJs1 = require("../../../node_modules/@storybook/addon-a11y/preview.js");
var _previewJs2 = require("../../../.storybook/preview.js");
let configs = [
    _config,
    _config1,
    _previewJs,
    _previewJs1,
    _previewJs2
];
configs.forEach((config)=>{
    Object.keys(config).forEach((key)=>{
        const value = config[key];
        switch(key){
            case "args":
            case "argTypes":
                return (0, _clientLogger.logger).warn("Invalid args/argTypes in config, ignoring.", JSON.stringify(value));
            case "decorators":
                return value.forEach((decorator)=>(0, _clientApi.addDecorator)(decorator, false));
            case "loaders":
                return value.forEach((loader)=>(0, _clientApi.addLoader)(loader, false));
            case "parameters":
                return (0, _clientApi.addParameters)({
                    ...value
                }, false);
            case "argTypesEnhancers":
                return value.forEach((enhancer)=>(0, _clientApi.addArgTypesEnhancer)(enhancer));
            case "argsEnhancers":
                return value.forEach((enhancer)=>(0, _clientApi.addArgsEnhancer)(enhancer));
            case "globals":
            case "globalTypes":
                {
                    const v = {};
                    v[key] = value;
                    return (0, _clientApi.addParameters)(v, false);
                }
            case "decorateStory":
            case "renderToDOM":
            case "render":
                return null; // This key is not handled directly in v6 mode.
            default:
                // eslint-disable-next-line prefer-template
                return console.log(key + " was not supported :( !");
        }
    });
});
let keyMap = {};
function walk(obj, key) {
    for(let k in obj)if (k === "tsx" || k === "ts" || k === "js" || k === "jsx") keyMap[key + "." + k] = obj[k];
    else walk(obj[k], (key ? key + "/" : "") + k);
}
walk(_storiesJsJsxTsTsx);
function context(key) {
    return keyMap[key];
}
context.keys = ()=>Object.keys(keyMap);
context.resolve = (key)=>key;
(0, _react.configure)(context, module, false);

},{"regenerator-runtime":"ZeHGL","@storybook/react":"8KbKL","@storybook/client-api":"5kgK6","@storybook/client-logger":"iGRus","../../**/stories/*.stories.{js,jsx,ts,tsx}":"iAOb7","../../../node_modules/@storybook/react/dist/esm/client/docs/config":"38Lce","../../../node_modules/@storybook/react/dist/esm/client/preview/config":"4GgrA","../../../node_modules/@storybook/addon-actions/preview.js":"ijWdZ","../../../node_modules/@storybook/addon-a11y/preview.js":"knTti","../../../.storybook/preview.js":"iQ6hh"}],"ZeHGL":[function(require,module,exports) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var runtime = function(exports) {
    "use strict";
    var Op = Object.prototype;
    var hasOwn = Op.hasOwnProperty;
    var undefined; // More compressible than void 0.
    var $Symbol = typeof Symbol === "function" ? Symbol : {};
    var iteratorSymbol = $Symbol.iterator || "@@iterator";
    var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
    var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
    function wrap(innerFn, outerFn, self, tryLocsList) {
        // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
        var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
        var generator = Object.create(protoGenerator.prototype);
        var context = new Context(tryLocsList || []);
        // The ._invoke method unifies the implementations of the .next,
        // .throw, and .return methods.
        generator._invoke = makeInvokeMethod(innerFn, self, context);
        return generator;
    }
    exports.wrap = wrap;
    // Try/catch helper to minimize deoptimizations. Returns a completion
    // record like context.tryEntries[i].completion. This interface could
    // have been (and was previously) designed to take a closure to be
    // invoked without arguments, but in all the cases we care about we
    // already have an existing method we want to call, so there's no need
    // to create a new function object. We can even get away with assuming
    // the method takes exactly one argument, since that happens to be true
    // in every case, so we don't have to touch the arguments object. The
    // only additional allocation required is the completion record, which
    // has a stable shape and so hopefully should be cheap to allocate.
    function tryCatch(fn, obj, arg) {
        try {
            return {
                type: "normal",
                arg: fn.call(obj, arg)
            };
        } catch (err) {
            return {
                type: "throw",
                arg: err
            };
        }
    }
    var GenStateSuspendedStart = "suspendedStart";
    var GenStateSuspendedYield = "suspendedYield";
    var GenStateExecuting = "executing";
    var GenStateCompleted = "completed";
    // Returning this object from the innerFn has the same effect as
    // breaking out of the dispatch switch statement.
    var ContinueSentinel = {};
    // Dummy constructor functions that we use as the .constructor and
    // .constructor.prototype properties for functions that return Generator
    // objects. For full spec compliance, you may wish to configure your
    // minifier not to mangle the names of these two functions.
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    // This is a polyfill for %IteratorPrototype% for environments that
    // don't natively support it.
    var IteratorPrototype = {};
    IteratorPrototype[iteratorSymbol] = function() {
        return this;
    };
    var getProto = Object.getPrototypeOf;
    var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
    if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
    GeneratorFunctionPrototype.constructor = GeneratorFunction;
    GeneratorFunctionPrototype[toStringTagSymbol] = GeneratorFunction.displayName = "GeneratorFunction";
    // Helper for defining the .next, .throw, and .return methods of the
    // Iterator interface in terms of a single ._invoke method.
    function defineIteratorMethods(prototype) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(method) {
            prototype[method] = function(arg) {
                return this._invoke(method, arg);
            };
        });
    }
    exports.isGeneratorFunction = function(genFun) {
        var ctor = typeof genFun === "function" && genFun.constructor;
        return ctor ? ctor === GeneratorFunction || // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
    };
    exports.mark = function(genFun) {
        if (Object.setPrototypeOf) Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
        else {
            genFun.__proto__ = GeneratorFunctionPrototype;
            if (!(toStringTagSymbol in genFun)) genFun[toStringTagSymbol] = "GeneratorFunction";
        }
        genFun.prototype = Object.create(Gp);
        return genFun;
    };
    // Within the body of any async function, `await x` is transformed to
    // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
    // `hasOwn.call(value, "__await")` to determine if the yielded value is
    // meant to be awaited.
    exports.awrap = function(arg) {
        return {
            __await: arg
        };
    };
    function AsyncIterator(generator) {
        function invoke(method, arg, resolve, reject) {
            var record = tryCatch(generator[method], generator, arg);
            if (record.type === "throw") reject(record.arg);
            else {
                var result = record.arg;
                var value = result.value;
                if (value && typeof value === "object" && hasOwn.call(value, "__await")) return Promise.resolve(value.__await).then(function(value) {
                    invoke("next", value, resolve, reject);
                }, function(err) {
                    invoke("throw", err, resolve, reject);
                });
                return Promise.resolve(value).then(function(unwrapped) {
                    // When a yielded Promise is resolved, its final value becomes
                    // the .value of the Promise<{value,done}> result for the
                    // current iteration.
                    result.value = unwrapped;
                    resolve(result);
                }, function(error) {
                    // If a rejected Promise was yielded, throw the rejection back
                    // into the async generator function so it can be handled there.
                    return invoke("throw", error, resolve, reject);
                });
            }
        }
        var previousPromise;
        function enqueue(method, arg) {
            function callInvokeWithMethodAndArg() {
                return new Promise(function(resolve, reject) {
                    invoke(method, arg, resolve, reject);
                });
            }
            return previousPromise = // If enqueue has been called before, then we want to wait until
            // all previous Promises have been resolved before calling invoke,
            // so that results are always delivered in the correct order. If
            // enqueue has not been called before, then it is important to
            // call invoke immediately, without waiting on a callback to fire,
            // so that the async generator function has the opportunity to do
            // any necessary setup in a predictable way. This predictability
            // is why the Promise constructor synchronously invokes its
            // executor callback, and why async functions synchronously
            // execute code before the first await. Since we implement simple
            // async functions in terms of async generators, it is especially
            // important to get this right, even though it requires care.
            previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, // Avoid propagating failures to Promises returned by later
            // invocations of the iterator.
            callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
        }
        // Define the unified helper method that is used to implement .next,
        // .throw, and .return (see defineIteratorMethods).
        this._invoke = enqueue;
    }
    defineIteratorMethods(AsyncIterator.prototype);
    AsyncIterator.prototype[asyncIteratorSymbol] = function() {
        return this;
    };
    exports.AsyncIterator = AsyncIterator;
    // Note that simple async functions are implemented on top of
    // AsyncIterator objects; they just return a Promise for the value of
    // the final result produced by the iterator.
    exports.async = function(innerFn, outerFn, self, tryLocsList) {
        var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList));
        return exports.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
         : iter.next().then(function(result) {
            return result.done ? result.value : iter.next();
        });
    };
    function makeInvokeMethod(innerFn, self, context) {
        var state = GenStateSuspendedStart;
        return function invoke(method, arg) {
            if (state === GenStateExecuting) throw new Error("Generator is already running");
            if (state === GenStateCompleted) {
                if (method === "throw") throw arg;
                // Be forgiving, per 25.3.3.3.3 of the spec:
                // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
                return doneResult();
            }
            context.method = method;
            context.arg = arg;
            while(true){
                var delegate = context.delegate;
                if (delegate) {
                    var delegateResult = maybeInvokeDelegate(delegate, context);
                    if (delegateResult) {
                        if (delegateResult === ContinueSentinel) continue;
                        return delegateResult;
                    }
                }
                if (context.method === "next") // Setting context._sent for legacy support of Babel's
                // function.sent implementation.
                context.sent = context._sent = context.arg;
                else if (context.method === "throw") {
                    if (state === GenStateSuspendedStart) {
                        state = GenStateCompleted;
                        throw context.arg;
                    }
                    context.dispatchException(context.arg);
                } else if (context.method === "return") context.abrupt("return", context.arg);
                state = GenStateExecuting;
                var record = tryCatch(innerFn, self, context);
                if (record.type === "normal") {
                    // If an exception is thrown from innerFn, we leave state ===
                    // GenStateExecuting and loop back for another invocation.
                    state = context.done ? GenStateCompleted : GenStateSuspendedYield;
                    if (record.arg === ContinueSentinel) continue;
                    return {
                        value: record.arg,
                        done: context.done
                    };
                } else if (record.type === "throw") {
                    state = GenStateCompleted;
                    // Dispatch the exception by looping back around to the
                    // context.dispatchException(context.arg) call above.
                    context.method = "throw";
                    context.arg = record.arg;
                }
            }
        };
    }
    // Call delegate.iterator[context.method](context.arg) and handle the
    // result, either by returning a { value, done } result from the
    // delegate iterator, or by modifying context.method and context.arg,
    // setting context.delegate to null, and returning the ContinueSentinel.
    function maybeInvokeDelegate(delegate, context) {
        var method = delegate.iterator[context.method];
        if (method === undefined) {
            // A .throw or .return when the delegate iterator has no .throw
            // method always terminates the yield* loop.
            context.delegate = null;
            if (context.method === "throw") {
                // Note: ["return"] must be used for ES3 parsing compatibility.
                if (delegate.iterator["return"]) {
                    // If the delegate iterator has a return method, give it a
                    // chance to clean up.
                    context.method = "return";
                    context.arg = undefined;
                    maybeInvokeDelegate(delegate, context);
                    if (context.method === "throw") // If maybeInvokeDelegate(context) changed context.method from
                    // "return" to "throw", let that override the TypeError below.
                    return ContinueSentinel;
                }
                context.method = "throw";
                context.arg = new TypeError("The iterator does not provide a 'throw' method");
            }
            return ContinueSentinel;
        }
        var record = tryCatch(method, delegate.iterator, context.arg);
        if (record.type === "throw") {
            context.method = "throw";
            context.arg = record.arg;
            context.delegate = null;
            return ContinueSentinel;
        }
        var info = record.arg;
        if (!info) {
            context.method = "throw";
            context.arg = new TypeError("iterator result is not an object");
            context.delegate = null;
            return ContinueSentinel;
        }
        if (info.done) {
            // Assign the result of the finished delegate to the temporary
            // variable specified by delegate.resultName (see delegateYield).
            context[delegate.resultName] = info.value;
            // Resume execution at the desired location (see delegateYield).
            context.next = delegate.nextLoc;
            // If context.method was "throw" but the delegate handled the
            // exception, let the outer generator proceed normally. If
            // context.method was "next", forget context.arg since it has been
            // "consumed" by the delegate iterator. If context.method was
            // "return", allow the original .return call to continue in the
            // outer generator.
            if (context.method !== "return") {
                context.method = "next";
                context.arg = undefined;
            }
        } else // Re-yield the result returned by the delegate method.
        return info;
        // The delegate iterator is finished, so forget it and continue with
        // the outer generator.
        context.delegate = null;
        return ContinueSentinel;
    }
    // Define Generator.prototype.{next,throw,return} in terms of the
    // unified ._invoke helper method.
    defineIteratorMethods(Gp);
    Gp[toStringTagSymbol] = "Generator";
    // A Generator should always return itself as the iterator object when the
    // @@iterator function is called on it. Some browsers' implementations of the
    // iterator prototype chain incorrectly implement this, causing the Generator
    // object to not be returned from this call. This ensures that doesn't happen.
    // See https://github.com/facebook/regenerator/issues/274 for more details.
    Gp[iteratorSymbol] = function() {
        return this;
    };
    Gp.toString = function() {
        return "[object Generator]";
    };
    function pushTryEntry(locs) {
        var entry = {
            tryLoc: locs[0]
        };
        if (1 in locs) entry.catchLoc = locs[1];
        if (2 in locs) {
            entry.finallyLoc = locs[2];
            entry.afterLoc = locs[3];
        }
        this.tryEntries.push(entry);
    }
    function resetTryEntry(entry) {
        var record = entry.completion || {};
        record.type = "normal";
        delete record.arg;
        entry.completion = record;
    }
    function Context(tryLocsList) {
        // The root entry object (effectively a try statement without a catch
        // or a finally block) gives us a place to store values thrown from
        // locations where there is no enclosing try statement.
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ];
        tryLocsList.forEach(pushTryEntry, this);
        this.reset(true);
    }
    exports.keys = function(object) {
        var keys = [];
        for(var key in object)keys.push(key);
        keys.reverse();
        // Rather than returning an object with a next method, we keep
        // things simple and return the next function itself.
        return function next() {
            while(keys.length){
                var key = keys.pop();
                if (key in object) {
                    next.value = key;
                    next.done = false;
                    return next;
                }
            }
            // To avoid creating an additional object, we just hang the .value
            // and .done properties off the next function object itself. This
            // also ensures that the minifier will not anonymize the function.
            next.done = true;
            return next;
        };
    };
    function values(iterable) {
        if (iterable) {
            var iteratorMethod = iterable[iteratorSymbol];
            if (iteratorMethod) return iteratorMethod.call(iterable);
            if (typeof iterable.next === "function") return iterable;
            if (!isNaN(iterable.length)) {
                var i = -1, next = function next() {
                    while(++i < iterable.length)if (hasOwn.call(iterable, i)) {
                        next.value = iterable[i];
                        next.done = false;
                        return next;
                    }
                    next.value = undefined;
                    next.done = true;
                    return next;
                };
                return next.next = next;
            }
        }
        // Return an iterator with no values.
        return {
            next: doneResult
        };
    }
    exports.values = values;
    function doneResult() {
        return {
            value: undefined,
            done: true
        };
    }
    Context.prototype = {
        constructor: Context,
        reset: function(skipTempReset) {
            this.prev = 0;
            this.next = 0;
            // Resetting context._sent for legacy support of Babel's
            // function.sent implementation.
            this.sent = this._sent = undefined;
            this.done = false;
            this.delegate = null;
            this.method = "next";
            this.arg = undefined;
            this.tryEntries.forEach(resetTryEntry);
            if (!skipTempReset) {
                for(var name in this)// Not sure about the optimal order of these conditions:
                if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) this[name] = undefined;
            }
        },
        stop: function() {
            this.done = true;
            var rootEntry = this.tryEntries[0];
            var rootRecord = rootEntry.completion;
            if (rootRecord.type === "throw") throw rootRecord.arg;
            return this.rval;
        },
        dispatchException: function(exception) {
            if (this.done) throw exception;
            var context = this;
            function handle(loc, caught) {
                record.type = "throw";
                record.arg = exception;
                context.next = loc;
                if (caught) {
                    // If the dispatched exception was caught by a catch block,
                    // then let that catch block handle the exception normally.
                    context.method = "next";
                    context.arg = undefined;
                }
                return !!caught;
            }
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                var record = entry.completion;
                if (entry.tryLoc === "root") // Exception thrown outside of any try block that could handle
                // it, so set the completion value of the entire function to
                // throw the exception.
                return handle("end");
                if (entry.tryLoc <= this.prev) {
                    var hasCatch = hasOwn.call(entry, "catchLoc");
                    var hasFinally = hasOwn.call(entry, "finallyLoc");
                    if (hasCatch && hasFinally) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
                        else if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else if (hasCatch) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
                    } else if (hasFinally) {
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else throw new Error("try statement without catch or finally");
                }
            }
        },
        abrupt: function(type, arg) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
                    var finallyEntry = entry;
                    break;
                }
            }
            if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) // Ignore the finally entry if control is not jumping to a
            // location outside the try/catch block.
            finallyEntry = null;
            var record = finallyEntry ? finallyEntry.completion : {};
            record.type = type;
            record.arg = arg;
            if (finallyEntry) {
                this.method = "next";
                this.next = finallyEntry.finallyLoc;
                return ContinueSentinel;
            }
            return this.complete(record);
        },
        complete: function(record, afterLoc) {
            if (record.type === "throw") throw record.arg;
            if (record.type === "break" || record.type === "continue") this.next = record.arg;
            else if (record.type === "return") {
                this.rval = this.arg = record.arg;
                this.method = "return";
                this.next = "end";
            } else if (record.type === "normal" && afterLoc) this.next = afterLoc;
            return ContinueSentinel;
        },
        finish: function(finallyLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.finallyLoc === finallyLoc) {
                    this.complete(entry.completion, entry.afterLoc);
                    resetTryEntry(entry);
                    return ContinueSentinel;
                }
            }
        },
        "catch": function(tryLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc === tryLoc) {
                    var record = entry.completion;
                    if (record.type === "throw") {
                        var thrown = record.arg;
                        resetTryEntry(entry);
                    }
                    return thrown;
                }
            }
            // The context.catch method must only be called with a location
            // argument that corresponds to a known catch block.
            throw new Error("illegal catch attempt");
        },
        delegateYield: function(iterable, resultName, nextLoc) {
            this.delegate = {
                iterator: values(iterable),
                resultName: resultName,
                nextLoc: nextLoc
            };
            if (this.method === "next") // Deliberately forget the last sent value so that we don't
            // accidentally pass it on to the delegate.
            this.arg = undefined;
            return ContinueSentinel;
        }
    };
    // Regardless of whether this script is executing as a CommonJS module
    // or not, return the runtime object so that we can declare the variable
    // regeneratorRuntime in the outer scope, which allows this module to be
    // injected easily by `bin/regenerator --include-runtime script.js`.
    return exports;
}(// If this script is executing as a CommonJS module, use module.exports
// as the regeneratorRuntime namespace. Otherwise create a new empty
// object. Either way, the resulting object will be used to initialize
// the regeneratorRuntime variable at the top of this file.
(0, module.exports));
try {
    regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
    // This module should not be running in strict mode, so the above
    // assignment should always work unless something is misconfigured. Just
    // in case runtime.js accidentally runs in strict mode, we can escape
    // strict mode using a global Function call. This could conceivably fail
    // if a Content Security Policy forbids using Function, but in that case
    // the proper solution is to fix the accidental strict mode problem. If
    // you've misconfigured your bundler to force strict mode and applied a
    // CSP to forbid Function, and you're not willing to fix either of those
    // problems, please detail your unique predicament in a GitHub issue.
    Function("r", "regeneratorRuntime = r")(runtime);
}

},{}],"8KbKL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "storiesOf", ()=>(0, _preview.storiesOf));
parcelHelpers.export(exports, "setAddon", ()=>(0, _preview.setAddon));
parcelHelpers.export(exports, "addDecorator", ()=>(0, _preview.addDecorator));
parcelHelpers.export(exports, "addParameters", ()=>(0, _preview.addParameters));
parcelHelpers.export(exports, "configure", ()=>(0, _preview.configure));
parcelHelpers.export(exports, "getStorybook", ()=>(0, _preview.getStorybook));
parcelHelpers.export(exports, "raw", ()=>(0, _preview.raw));
parcelHelpers.export(exports, "forceReRender", ()=>(0, _preview.forceReRender));
var _preview = require("./preview");
var _testing = require("./testing");
parcelHelpers.exportAll(_testing, exports);
var _types63 = require("./preview/types-6-3");
parcelHelpers.exportAll(_types63, exports);
if (module && module.hot && module.hot.decline) module.hot.decline();

},{"./preview":"jtYTS","./testing":"lv28k","./preview/types-6-3":"d7CgP","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"jtYTS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "storiesOf", ()=>storiesOf);
parcelHelpers.export(exports, "configure", ()=>configure);
parcelHelpers.export(exports, "addDecorator", ()=>addDecorator);
parcelHelpers.export(exports, "addParameters", ()=>addParameters);
parcelHelpers.export(exports, "clearDecorators", ()=>clearDecorators);
parcelHelpers.export(exports, "setAddon", ()=>setAddon);
parcelHelpers.export(exports, "forceReRender", ()=>forceReRender);
parcelHelpers.export(exports, "getStorybook", ()=>getStorybook);
parcelHelpers.export(exports, "raw", ()=>raw);
var _esArrayConcatJs = require("core-js/modules/es.array.concat.js");
/* eslint-disable prefer-destructuring */ var _core = require("@storybook/core");
var _globals = require("./globals");
var _render = require("./render");
var framework = "react";
var api = (0, _core.start)((0, _render.renderToDOM), {
    render: (0, _render.render)
});
var storiesOf = function storiesOf(kind, m) {
    return api.clientApi.storiesOf(kind, m).addParameters({
        framework: framework
    });
};
var configure = function configure() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return api.configure.apply(api, [
        framework
    ].concat(args));
};
var addDecorator = api.clientApi.addDecorator;
var addParameters = api.clientApi.addParameters;
var clearDecorators = api.clientApi.clearDecorators;
var setAddon = api.clientApi.setAddon;
var forceReRender = api.forceReRender;
var getStorybook = api.clientApi.getStorybook;
var raw = api.clientApi.raw;

},{"core-js/modules/es.array.concat.js":"g1t7q","@storybook/core":"2fVmM","./globals":"8NjRE","./render":"bkYMe","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"g1t7q":[function(require,module,exports) {
"use strict";
var $ = require("ae9bcc3c886d2e43");
var global = require("170ffce8f2b4c62e");
var fails = require("320b7f8f99977d72");
var isArray = require("c9c4d35908c64a9b");
var isObject = require("e40ffb4fd8cdd6ef");
var toObject = require("600c6b55241cb08d");
var lengthOfArrayLike = require("c35064fc908d412e");
var createProperty = require("4da7fb5e70719532");
var arraySpeciesCreate = require("706ee6e3130d3c44");
var arrayMethodHasSpeciesSupport = require("76c3a5d37e98bd2f");
var wellKnownSymbol = require("210a9ec1468bd8f4");
var V8_VERSION = require("b368da136a5325df");
var IS_CONCAT_SPREADABLE = wellKnownSymbol("isConcatSpreadable");
var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF;
var MAXIMUM_ALLOWED_INDEX_EXCEEDED = "Maximum allowed index exceeded";
var TypeError = global.TypeError;
// We can't use this feature detection in V8 since it causes
// deoptimization and serious performance degradation
// https://github.com/zloirock/core-js/issues/679
var IS_CONCAT_SPREADABLE_SUPPORT = V8_VERSION >= 51 || !fails(function() {
    var array = [];
    array[IS_CONCAT_SPREADABLE] = false;
    return array.concat()[0] !== array;
});
var SPECIES_SUPPORT = arrayMethodHasSpeciesSupport("concat");
var isConcatSpreadable = function(O) {
    if (!isObject(O)) return false;
    var spreadable = O[IS_CONCAT_SPREADABLE];
    return spreadable !== undefined ? !!spreadable : isArray(O);
};
var FORCED = !IS_CONCAT_SPREADABLE_SUPPORT || !SPECIES_SUPPORT;
// `Array.prototype.concat` method
// https://tc39.es/ecma262/#sec-array.prototype.concat
// with adding support of @@isConcatSpreadable and @@species
$({
    target: "Array",
    proto: true,
    forced: FORCED
}, {
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    concat: function concat(arg) {
        var O = toObject(this);
        var A = arraySpeciesCreate(O, 0);
        var n = 0;
        var i, k, length, len, E;
        for(i = -1, length = arguments.length; i < length; i++){
            E = i === -1 ? O : arguments[i];
            if (isConcatSpreadable(E)) {
                len = lengthOfArrayLike(E);
                if (n + len > MAX_SAFE_INTEGER) throw TypeError(MAXIMUM_ALLOWED_INDEX_EXCEEDED);
                for(k = 0; k < len; k++, n++)if (k in E) createProperty(A, n, E[k]);
            } else {
                if (n >= MAX_SAFE_INTEGER) throw TypeError(MAXIMUM_ALLOWED_INDEX_EXCEEDED);
                createProperty(A, n++, E);
            }
        }
        A.length = n;
        return A;
    }
});

},{"ae9bcc3c886d2e43":"1OO62","170ffce8f2b4c62e":"1GZc4","320b7f8f99977d72":"keKlS","c9c4d35908c64a9b":"eYGrC","e40ffb4fd8cdd6ef":"bprny","600c6b55241cb08d":"7K2H5","c35064fc908d412e":"ckDDq","4da7fb5e70719532":"3yb4H","706ee6e3130d3c44":"5xBSA","76c3a5d37e98bd2f":"gkuI7","210a9ec1468bd8f4":"kbsMI","b368da136a5325df":"g2xJU"}],"1OO62":[function(require,module,exports) {
var global = require("6643b6592ad59b23");
var getOwnPropertyDescriptor = require("2ec751f39e500b85").f;
var createNonEnumerableProperty = require("b4567636b28a3b3a");
var redefine = require("10edb5de5c8774b1");
var setGlobal = require("63fb8d99c14c1b2a");
var copyConstructorProperties = require("566a383894c688bc");
var isForced = require("f0e2e697f04e8ad9");
/*
  options.target      - name of the target object
  options.global      - target is the global object
  options.stat        - export as static methods of target
  options.proto       - export as prototype methods of target
  options.real        - real prototype method for the `pure` version
  options.forced      - export even if the native feature is available
  options.bind        - bind methods to the target, required for the `pure` version
  options.wrap        - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe      - use the simple assignment of property instead of delete + defineProperty
  options.sham        - add a flag to not completely full polyfills
  options.enumerable  - export as enumerable property
  options.noTargetGet - prevent calling a getter on target
  options.name        - the .name of the function if it does not match the key
*/ module.exports = function(options, source) {
    var TARGET = options.target;
    var GLOBAL = options.global;
    var STATIC = options.stat;
    var FORCED, target, key, targetProperty, sourceProperty, descriptor;
    if (GLOBAL) target = global;
    else if (STATIC) target = global[TARGET] || setGlobal(TARGET, {});
    else target = (global[TARGET] || {}).prototype;
    if (target) for(key in source){
        sourceProperty = source[key];
        if (options.noTargetGet) {
            descriptor = getOwnPropertyDescriptor(target, key);
            targetProperty = descriptor && descriptor.value;
        } else targetProperty = target[key];
        FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? "." : "#") + key, options.forced);
        // contained in target
        if (!FORCED && targetProperty !== undefined) {
            if (typeof sourceProperty == typeof targetProperty) continue;
            copyConstructorProperties(sourceProperty, targetProperty);
        }
        // add a flag to not completely full polyfills
        if (options.sham || targetProperty && targetProperty.sham) createNonEnumerableProperty(sourceProperty, "sham", true);
        // extend global
        redefine(target, key, sourceProperty, options);
    }
};

},{"6643b6592ad59b23":"1GZc4","2ec751f39e500b85":"8cErP","b4567636b28a3b3a":"hol1i","10edb5de5c8774b1":"3ncOy","63fb8d99c14c1b2a":"gbMrI","566a383894c688bc":"2kpr2","f0e2e697f04e8ad9":"j3Sfj"}],"1GZc4":[function(require,module,exports) {
var global = arguments[3];
var check = function(it) {
    return it && it.Math == Math && it;
};
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
module.exports = // eslint-disable-next-line es/no-global-this -- safe
check(typeof globalThis == "object" && globalThis) || check(typeof window == "object" && window) || // eslint-disable-next-line no-restricted-globals -- safe
check(typeof self == "object" && self) || check(typeof global == "object" && global) || // eslint-disable-next-line no-new-func -- fallback
function() {
    return this;
}() || Function("return this")();

},{}],"8cErP":[function(require,module,exports) {
var DESCRIPTORS = require("c04e6fb248689dba");
var call = require("553ec943aa2a4554");
var propertyIsEnumerableModule = require("bbc5e69071aa2fbd");
var createPropertyDescriptor = require("1d2ffbfd99e01f41");
var toIndexedObject = require("c4ea69a78a643d87");
var toPropertyKey = require("8ab18ff766aa2ab9");
var hasOwn = require("3761c5d34b7aa48f");
var IE8_DOM_DEFINE = require("c4dfcc26308f1b4a");
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
exports.f = DESCRIPTORS ? $getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
    O = toIndexedObject(O);
    P = toPropertyKey(P);
    if (IE8_DOM_DEFINE) try {
        return $getOwnPropertyDescriptor(O, P);
    } catch (error) {}
    if (hasOwn(O, P)) return createPropertyDescriptor(!call(propertyIsEnumerableModule.f, O, P), O[P]);
};

},{"c04e6fb248689dba":"7Hk5a","553ec943aa2a4554":"aSvFj","bbc5e69071aa2fbd":"i11pl","1d2ffbfd99e01f41":"81es4","c4ea69a78a643d87":"5DeQ5","8ab18ff766aa2ab9":"60GKb","3761c5d34b7aa48f":"4SzRl","c4dfcc26308f1b4a":"lxNtd"}],"7Hk5a":[function(require,module,exports) {
var fails = require("735b783268fd06c0");
// Detect IE8's incomplete defineProperty implementation
module.exports = !fails(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty({}, 1, {
        get: function() {
            return 7;
        }
    })[1] != 7;
});

},{"735b783268fd06c0":"keKlS"}],"keKlS":[function(require,module,exports) {
module.exports = function(exec) {
    try {
        return !!exec();
    } catch (error) {
        return true;
    }
};

},{}],"aSvFj":[function(require,module,exports) {
var call = Function.prototype.call;
module.exports = call.bind ? call.bind(call) : function() {
    return call.apply(call, arguments);
};

},{}],"i11pl":[function(require,module,exports) {
"use strict";
var $propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor && !$propertyIsEnumerable.call({
    1: 2
}, 1);
// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
exports.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
    var descriptor = getOwnPropertyDescriptor(this, V);
    return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable;

},{}],"81es4":[function(require,module,exports) {
module.exports = function(bitmap, value) {
    return {
        enumerable: !(bitmap & 1),
        configurable: !(bitmap & 2),
        writable: !(bitmap & 4),
        value: value
    };
};

},{}],"5DeQ5":[function(require,module,exports) {
// toObject with fallback for non-array-like ES3 strings
var IndexedObject = require("9d8f8f50ac9468eb");
var requireObjectCoercible = require("f7224aed72953ac4");
module.exports = function(it) {
    return IndexedObject(requireObjectCoercible(it));
};

},{"9d8f8f50ac9468eb":"8iqJB","f7224aed72953ac4":"etuZb"}],"8iqJB":[function(require,module,exports) {
var global = require("9cdb65608dfb6cb0");
var uncurryThis = require("7ba7e65983d7b662");
var fails = require("df551e12a7c872dd");
var classof = require("1d34ea813cebff9c");
var Object = global.Object;
var split = uncurryThis("".split);
// fallback for non-array-like ES3 and non-enumerable old V8 strings
module.exports = fails(function() {
    // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
    // eslint-disable-next-line no-prototype-builtins -- safe
    return !Object("z").propertyIsEnumerable(0);
}) ? function(it) {
    return classof(it) == "String" ? split(it, "") : Object(it);
} : Object;

},{"9cdb65608dfb6cb0":"1GZc4","7ba7e65983d7b662":"fP9tv","df551e12a7c872dd":"keKlS","1d34ea813cebff9c":"6FZJh"}],"fP9tv":[function(require,module,exports) {
var FunctionPrototype = Function.prototype;
var bind = FunctionPrototype.bind;
var call = FunctionPrototype.call;
var callBind = bind && bind.bind(call);
module.exports = bind ? function(fn) {
    return fn && callBind(call, fn);
} : function(fn) {
    return fn && function() {
        return call.apply(fn, arguments);
    };
};

},{}],"6FZJh":[function(require,module,exports) {
var uncurryThis = require("1c71c3f6daac476c");
var toString = uncurryThis({}.toString);
var stringSlice = uncurryThis("".slice);
module.exports = function(it) {
    return stringSlice(toString(it), 8, -1);
};

},{"1c71c3f6daac476c":"fP9tv"}],"etuZb":[function(require,module,exports) {
var global = require("aadfbfc429be7216");
var TypeError = global.TypeError;
// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
module.exports = function(it) {
    if (it == undefined) throw TypeError("Can't call method on " + it);
    return it;
};

},{"aadfbfc429be7216":"1GZc4"}],"60GKb":[function(require,module,exports) {
var toPrimitive = require("53a3a67ac381c4e8");
var isSymbol = require("b992ca9cdcf7937b");
// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
module.exports = function(argument) {
    var key = toPrimitive(argument, "string");
    return isSymbol(key) ? key : key + "";
};

},{"53a3a67ac381c4e8":"epWNE","b992ca9cdcf7937b":"RacQu"}],"epWNE":[function(require,module,exports) {
var global = require("99178678bc7a711a");
var call = require("70235907dc93b4b0");
var isObject = require("46fb53dace408c8e");
var isSymbol = require("677bdc4d74d2f983");
var getMethod = require("80395bcde336a28b");
var ordinaryToPrimitive = require("49552a7324952190");
var wellKnownSymbol = require("aea01c71276624bf");
var TypeError = global.TypeError;
var TO_PRIMITIVE = wellKnownSymbol("toPrimitive");
// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
module.exports = function(input, pref) {
    if (!isObject(input) || isSymbol(input)) return input;
    var exoticToPrim = getMethod(input, TO_PRIMITIVE);
    var result;
    if (exoticToPrim) {
        if (pref === undefined) pref = "default";
        result = call(exoticToPrim, input, pref);
        if (!isObject(result) || isSymbol(result)) return result;
        throw TypeError("Can't convert object to primitive value");
    }
    if (pref === undefined) pref = "number";
    return ordinaryToPrimitive(input, pref);
};

},{"99178678bc7a711a":"1GZc4","70235907dc93b4b0":"aSvFj","46fb53dace408c8e":"bprny","677bdc4d74d2f983":"RacQu","80395bcde336a28b":"llxIw","49552a7324952190":"bLKgc","aea01c71276624bf":"kbsMI"}],"bprny":[function(require,module,exports) {
var isCallable = require("f87cee1cb79cbcca");
module.exports = function(it) {
    return typeof it == "object" ? it !== null : isCallable(it);
};

},{"f87cee1cb79cbcca":"cVxS9"}],"cVxS9":[function(require,module,exports) {
// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
module.exports = function(argument) {
    return typeof argument == "function";
};

},{}],"RacQu":[function(require,module,exports) {
var global = require("3003ac5e19a9d37");
var getBuiltIn = require("6b6c481cdfb7df35");
var isCallable = require("2af44fcbdbf14c83");
var isPrototypeOf = require("76e903e830c40e7c");
var USE_SYMBOL_AS_UID = require("7e2fe930b3598e22");
var Object = global.Object;
module.exports = USE_SYMBOL_AS_UID ? function(it) {
    return typeof it == "symbol";
} : function(it) {
    var $Symbol = getBuiltIn("Symbol");
    return isCallable($Symbol) && isPrototypeOf($Symbol.prototype, Object(it));
};

},{"3003ac5e19a9d37":"1GZc4","6b6c481cdfb7df35":"bQFzp","2af44fcbdbf14c83":"cVxS9","76e903e830c40e7c":"alXpj","7e2fe930b3598e22":"gxbvr"}],"bQFzp":[function(require,module,exports) {
var global = require("dd9e9ae04e8684f7");
var isCallable = require("f1d62079325906cb");
var aFunction = function(argument) {
    return isCallable(argument) ? argument : undefined;
};
module.exports = function(namespace, method) {
    return arguments.length < 2 ? aFunction(global[namespace]) : global[namespace] && global[namespace][method];
};

},{"dd9e9ae04e8684f7":"1GZc4","f1d62079325906cb":"cVxS9"}],"alXpj":[function(require,module,exports) {
var uncurryThis = require("83f14842ef67e16a");
module.exports = uncurryThis({}.isPrototypeOf);

},{"83f14842ef67e16a":"fP9tv"}],"gxbvr":[function(require,module,exports) {
/* eslint-disable es/no-symbol -- required for testing */ var NATIVE_SYMBOL = require("a5910da293cb63f6");
module.exports = NATIVE_SYMBOL && !Symbol.sham && typeof Symbol.iterator == "symbol";

},{"a5910da293cb63f6":"2cImI"}],"2cImI":[function(require,module,exports) {
/* eslint-disable es/no-symbol -- required for testing */ var V8_VERSION = require("677a9f52d6ca4bb0");
var fails = require("c154b223d883c4d1");
// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
module.exports = !!Object.getOwnPropertySymbols && !fails(function() {
    var symbol = Symbol();
    // Chrome 38 Symbol has incorrect toString conversion
    // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
    return !String(symbol) || !(Object(symbol) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && V8_VERSION && V8_VERSION < 41;
});

},{"677a9f52d6ca4bb0":"g2xJU","c154b223d883c4d1":"keKlS"}],"g2xJU":[function(require,module,exports) {
var global = require("705d79ce07ed8cf");
var userAgent = require("5afb83a49cd74e4c");
var process = global.process;
var Deno = global.Deno;
var versions = process && process.versions || Deno && Deno.version;
var v8 = versions && versions.v8;
var match, version;
if (v8) {
    match = v8.split(".");
    // in old Chrome, versions of V8 isn't V8 = Chrome / 10
    // but their correct versions are not interesting for us
    version = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
}
// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!version && userAgent) {
    match = userAgent.match(/Edge\/(\d+)/);
    if (!match || match[1] >= 74) {
        match = userAgent.match(/Chrome\/(\d+)/);
        if (match) version = +match[1];
    }
}
module.exports = version;

},{"705d79ce07ed8cf":"1GZc4","5afb83a49cd74e4c":"lylPP"}],"lylPP":[function(require,module,exports) {
var getBuiltIn = require("16054ed539401f1");
module.exports = getBuiltIn("navigator", "userAgent") || "";

},{"16054ed539401f1":"bQFzp"}],"llxIw":[function(require,module,exports) {
var aCallable = require("bbfed17b24e215f4");
// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
module.exports = function(V, P) {
    var func = V[P];
    return func == null ? undefined : aCallable(func);
};

},{"bbfed17b24e215f4":"keisz"}],"keisz":[function(require,module,exports) {
var global = require("73df398b2b453fec");
var isCallable = require("4094667126ecac05");
var tryToString = require("fce2a7573db493fa");
var TypeError = global.TypeError;
// `Assert: IsCallable(argument) is true`
module.exports = function(argument) {
    if (isCallable(argument)) return argument;
    throw TypeError(tryToString(argument) + " is not a function");
};

},{"73df398b2b453fec":"1GZc4","4094667126ecac05":"cVxS9","fce2a7573db493fa":"1vkHL"}],"1vkHL":[function(require,module,exports) {
var global = require("96da248a1c47aa32");
var String = global.String;
module.exports = function(argument) {
    try {
        return String(argument);
    } catch (error) {
        return "Object";
    }
};

},{"96da248a1c47aa32":"1GZc4"}],"bLKgc":[function(require,module,exports) {
var global = require("4a0e4a1baf2af8c2");
var call = require("abe9ca006f56626e");
var isCallable = require("c96b3a89fec6248a");
var isObject = require("551615fda0214f1b");
var TypeError = global.TypeError;
// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
module.exports = function(input, pref) {
    var fn, val;
    if (pref === "string" && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
    if (isCallable(fn = input.valueOf) && !isObject(val = call(fn, input))) return val;
    if (pref !== "string" && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
    throw TypeError("Can't convert object to primitive value");
};

},{"4a0e4a1baf2af8c2":"1GZc4","abe9ca006f56626e":"aSvFj","c96b3a89fec6248a":"cVxS9","551615fda0214f1b":"bprny"}],"kbsMI":[function(require,module,exports) {
var global = require("dbe74e87464035e3");
var shared = require("6a2cda01df6b4c79");
var hasOwn = require("dccc28ffa5beeb54");
var uid = require("48d6af1225853d44");
var NATIVE_SYMBOL = require("12ccc61b0bbd074c");
var USE_SYMBOL_AS_UID = require("1ce268781e409df2");
var WellKnownSymbolsStore = shared("wks");
var Symbol = global.Symbol;
var symbolFor = Symbol && Symbol["for"];
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol : Symbol && Symbol.withoutSetter || uid;
module.exports = function(name) {
    if (!hasOwn(WellKnownSymbolsStore, name) || !(NATIVE_SYMBOL || typeof WellKnownSymbolsStore[name] == "string")) {
        var description = "Symbol." + name;
        if (NATIVE_SYMBOL && hasOwn(Symbol, name)) WellKnownSymbolsStore[name] = Symbol[name];
        else if (USE_SYMBOL_AS_UID && symbolFor) WellKnownSymbolsStore[name] = symbolFor(description);
        else WellKnownSymbolsStore[name] = createWellKnownSymbol(description);
    }
    return WellKnownSymbolsStore[name];
};

},{"dbe74e87464035e3":"1GZc4","6a2cda01df6b4c79":"adVFA","dccc28ffa5beeb54":"4SzRl","48d6af1225853d44":"6IZd8","12ccc61b0bbd074c":"2cImI","1ce268781e409df2":"gxbvr"}],"adVFA":[function(require,module,exports) {
var IS_PURE = require("fe5f96cb4b2826a2");
var store = require("84eeed9891aafe14");
(module.exports = function(key, value) {
    return store[key] || (store[key] = value !== undefined ? value : {});
})("versions", []).push({
    version: "3.19.1",
    mode: IS_PURE ? "pure" : "global",
    copyright: "\xa9 2021 Denis Pushkarev (zloirock.ru)"
});

},{"fe5f96cb4b2826a2":"bZbjq","84eeed9891aafe14":"On8aL"}],"bZbjq":[function(require,module,exports) {
module.exports = false;

},{}],"On8aL":[function(require,module,exports) {
var global = require("8756de416b94afec");
var setGlobal = require("bde9d812c43e928");
var SHARED = "__core-js_shared__";
var store = global[SHARED] || setGlobal(SHARED, {});
module.exports = store;

},{"8756de416b94afec":"1GZc4","bde9d812c43e928":"gbMrI"}],"gbMrI":[function(require,module,exports) {
var global = require("4785828acf653da3");
// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty = Object.defineProperty;
module.exports = function(key, value) {
    try {
        defineProperty(global, key, {
            value: value,
            configurable: true,
            writable: true
        });
    } catch (error) {
        global[key] = value;
    }
    return value;
};

},{"4785828acf653da3":"1GZc4"}],"4SzRl":[function(require,module,exports) {
var uncurryThis = require("f5dcaa60a713971f");
var toObject = require("ab17c4f45fcf0841");
var hasOwnProperty = uncurryThis({}.hasOwnProperty);
// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
module.exports = Object.hasOwn || function hasOwn(it, key) {
    return hasOwnProperty(toObject(it), key);
};

},{"f5dcaa60a713971f":"fP9tv","ab17c4f45fcf0841":"7K2H5"}],"7K2H5":[function(require,module,exports) {
var global = require("587c79a917566803");
var requireObjectCoercible = require("f45a7b5dcdc4a410");
var Object = global.Object;
// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
module.exports = function(argument) {
    return Object(requireObjectCoercible(argument));
};

},{"587c79a917566803":"1GZc4","f45a7b5dcdc4a410":"etuZb"}],"6IZd8":[function(require,module,exports) {
var uncurryThis = require("5da0fe4507da20a3");
var id = 0;
var postfix = Math.random();
var toString = uncurryThis(1.0.toString);
module.exports = function(key) {
    return "Symbol(" + (key === undefined ? "" : key) + ")_" + toString(++id + postfix, 36);
};

},{"5da0fe4507da20a3":"fP9tv"}],"lxNtd":[function(require,module,exports) {
var DESCRIPTORS = require("9b4278b13c076bf");
var fails = require("8aee5d88a5f9b6b5");
var createElement = require("1db4d60148afcf21");
// Thank's IE8 for his funny defineProperty
module.exports = !DESCRIPTORS && !fails(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- requied for testing
    return Object.defineProperty(createElement("div"), "a", {
        get: function() {
            return 7;
        }
    }).a != 7;
});

},{"9b4278b13c076bf":"7Hk5a","8aee5d88a5f9b6b5":"keKlS","1db4d60148afcf21":"gjZdB"}],"gjZdB":[function(require,module,exports) {
var global = require("f5891d48afd7ec83");
var isObject = require("824df78b2e007250");
var document = global.document;
// typeof document.createElement is 'object' in old IE
var EXISTS = isObject(document) && isObject(document.createElement);
module.exports = function(it) {
    return EXISTS ? document.createElement(it) : {};
};

},{"f5891d48afd7ec83":"1GZc4","824df78b2e007250":"bprny"}],"hol1i":[function(require,module,exports) {
var DESCRIPTORS = require("a8753383ef98ee18");
var definePropertyModule = require("189ab650b8f71085");
var createPropertyDescriptor = require("1168c8162aa30435");
module.exports = DESCRIPTORS ? function(object, key, value) {
    return definePropertyModule.f(object, key, createPropertyDescriptor(1, value));
} : function(object, key, value) {
    object[key] = value;
    return object;
};

},{"a8753383ef98ee18":"7Hk5a","189ab650b8f71085":"dfAo1","1168c8162aa30435":"81es4"}],"dfAo1":[function(require,module,exports) {
var global = require("6d3200cf9dace7d0");
var DESCRIPTORS = require("ca50eb9163928400");
var IE8_DOM_DEFINE = require("d482f9e5478795e8");
var anObject = require("16365a73399e7fe7");
var toPropertyKey = require("fab1d366c47796d9");
var TypeError = global.TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $defineProperty = Object.defineProperty;
// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
exports.f = DESCRIPTORS ? $defineProperty : function defineProperty(O, P, Attributes) {
    anObject(O);
    P = toPropertyKey(P);
    anObject(Attributes);
    if (IE8_DOM_DEFINE) try {
        return $defineProperty(O, P, Attributes);
    } catch (error) {}
    if ("get" in Attributes || "set" in Attributes) throw TypeError("Accessors not supported");
    if ("value" in Attributes) O[P] = Attributes.value;
    return O;
};

},{"6d3200cf9dace7d0":"1GZc4","ca50eb9163928400":"7Hk5a","d482f9e5478795e8":"lxNtd","16365a73399e7fe7":"39qAm","fab1d366c47796d9":"60GKb"}],"39qAm":[function(require,module,exports) {
var global = require("355d917d7054c153");
var isObject = require("2b6c6258a0a6082f");
var String = global.String;
var TypeError = global.TypeError;
// `Assert: Type(argument) is Object`
module.exports = function(argument) {
    if (isObject(argument)) return argument;
    throw TypeError(String(argument) + " is not an object");
};

},{"355d917d7054c153":"1GZc4","2b6c6258a0a6082f":"bprny"}],"3ncOy":[function(require,module,exports) {
var global = require("ad29211ac7a99cf3");
var isCallable = require("3cfec941a7f48f72");
var hasOwn = require("8bc80a88e96e9b1e");
var createNonEnumerableProperty = require("fb5c982780275e5e");
var setGlobal = require("1111dde9b567f8a1");
var inspectSource = require("3e459da4f22431a3");
var InternalStateModule = require("78b34e0c633bdce7");
var CONFIGURABLE_FUNCTION_NAME = require("bc6c6c2ee1bed92c").CONFIGURABLE;
var getInternalState = InternalStateModule.get;
var enforceInternalState = InternalStateModule.enforce;
var TEMPLATE = String(String).split("String");
(module.exports = function(O, key, value, options) {
    var unsafe = options ? !!options.unsafe : false;
    var simple = options ? !!options.enumerable : false;
    var noTargetGet = options ? !!options.noTargetGet : false;
    var name = options && options.name !== undefined ? options.name : key;
    var state;
    if (isCallable(value)) {
        if (String(name).slice(0, 7) === "Symbol(") name = "[" + String(name).replace(/^Symbol\(([^)]*)\)/, "$1") + "]";
        if (!hasOwn(value, "name") || CONFIGURABLE_FUNCTION_NAME && value.name !== name) createNonEnumerableProperty(value, "name", name);
        state = enforceInternalState(value);
        if (!state.source) state.source = TEMPLATE.join(typeof name == "string" ? name : "");
    }
    if (O === global) {
        if (simple) O[key] = value;
        else setGlobal(key, value);
        return;
    } else if (!unsafe) delete O[key];
    else if (!noTargetGet && O[key]) simple = true;
    if (simple) O[key] = value;
    else createNonEnumerableProperty(O, key, value);
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, "toString", function toString() {
    return isCallable(this) && getInternalState(this).source || inspectSource(this);
});

},{"ad29211ac7a99cf3":"1GZc4","3cfec941a7f48f72":"cVxS9","8bc80a88e96e9b1e":"4SzRl","fb5c982780275e5e":"hol1i","1111dde9b567f8a1":"gbMrI","3e459da4f22431a3":"80OOF","78b34e0c633bdce7":"bRWxa","bc6c6c2ee1bed92c":"5TtMA"}],"80OOF":[function(require,module,exports) {
var uncurryThis = require("26e26db98367212e");
var isCallable = require("40ed9a4f6ae66648");
var store = require("485d48d6f4c6739e");
var functionToString = uncurryThis(Function.toString);
// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!isCallable(store.inspectSource)) store.inspectSource = function(it) {
    return functionToString(it);
};
module.exports = store.inspectSource;

},{"26e26db98367212e":"fP9tv","40ed9a4f6ae66648":"cVxS9","485d48d6f4c6739e":"On8aL"}],"bRWxa":[function(require,module,exports) {
var NATIVE_WEAK_MAP = require("f0a2bf6263225aee");
var global = require("ca46b44b6201ccd7");
var uncurryThis = require("3cf24bfdcfe2212f");
var isObject = require("f82e6cc0ac249fa5");
var createNonEnumerableProperty = require("c0ae163eea4ef97");
var hasOwn = require("6dea7358344877bb");
var shared = require("3e035a1241da2f0");
var sharedKey = require("88d6ccc27e779e5a");
var hiddenKeys = require("d40b9b3abdbb956e");
var OBJECT_ALREADY_INITIALIZED = "Object already initialized";
var TypeError = global.TypeError;
var WeakMap = global.WeakMap;
var set, get, has;
var enforce = function(it) {
    return has(it) ? get(it) : set(it, {});
};
var getterFor = function(TYPE) {
    return function(it) {
        var state;
        if (!isObject(it) || (state = get(it)).type !== TYPE) throw TypeError("Incompatible receiver, " + TYPE + " required");
        return state;
    };
};
if (NATIVE_WEAK_MAP || shared.state) {
    var store = shared.state || (shared.state = new WeakMap());
    var wmget = uncurryThis(store.get);
    var wmhas = uncurryThis(store.has);
    var wmset = uncurryThis(store.set);
    set = function(it, metadata) {
        if (wmhas(store, it)) throw new TypeError(OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        wmset(store, it, metadata);
        return metadata;
    };
    get = function(it) {
        return wmget(store, it) || {};
    };
    has = function(it) {
        return wmhas(store, it);
    };
} else {
    var STATE = sharedKey("state");
    hiddenKeys[STATE] = true;
    set = function(it, metadata) {
        if (hasOwn(it, STATE)) throw new TypeError(OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        createNonEnumerableProperty(it, STATE, metadata);
        return metadata;
    };
    get = function(it) {
        return hasOwn(it, STATE) ? it[STATE] : {};
    };
    has = function(it) {
        return hasOwn(it, STATE);
    };
}
module.exports = {
    set: set,
    get: get,
    has: has,
    enforce: enforce,
    getterFor: getterFor
};

},{"f0a2bf6263225aee":"durGo","ca46b44b6201ccd7":"1GZc4","3cf24bfdcfe2212f":"fP9tv","f82e6cc0ac249fa5":"bprny","c0ae163eea4ef97":"hol1i","6dea7358344877bb":"4SzRl","3e035a1241da2f0":"On8aL","88d6ccc27e779e5a":"21CiI","d40b9b3abdbb956e":"8A7bE"}],"durGo":[function(require,module,exports) {
var global = require("6e8e91a63fc6bed5");
var isCallable = require("652e829718ea2acf");
var inspectSource = require("b3ae89ce7d946b9c");
var WeakMap = global.WeakMap;
module.exports = isCallable(WeakMap) && /native code/.test(inspectSource(WeakMap));

},{"6e8e91a63fc6bed5":"1GZc4","652e829718ea2acf":"cVxS9","b3ae89ce7d946b9c":"80OOF"}],"21CiI":[function(require,module,exports) {
var shared = require("dbc8182adeb8c92f");
var uid = require("90b4ffb58508a6e5");
var keys = shared("keys");
module.exports = function(key) {
    return keys[key] || (keys[key] = uid(key));
};

},{"dbc8182adeb8c92f":"adVFA","90b4ffb58508a6e5":"6IZd8"}],"8A7bE":[function(require,module,exports) {
module.exports = {};

},{}],"5TtMA":[function(require,module,exports) {
var DESCRIPTORS = require("8ad2bacb0e20b95c");
var hasOwn = require("4eabfd8f83afc9d5");
var FunctionPrototype = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getDescriptor = DESCRIPTORS && Object.getOwnPropertyDescriptor;
var EXISTS = hasOwn(FunctionPrototype, "name");
// additional protection from minified / mangled / dropped function names
var PROPER = EXISTS && (function something() {}).name === "something";
var CONFIGURABLE = EXISTS && (!DESCRIPTORS || DESCRIPTORS && getDescriptor(FunctionPrototype, "name").configurable);
module.exports = {
    EXISTS: EXISTS,
    PROPER: PROPER,
    CONFIGURABLE: CONFIGURABLE
};

},{"8ad2bacb0e20b95c":"7Hk5a","4eabfd8f83afc9d5":"4SzRl"}],"2kpr2":[function(require,module,exports) {
var hasOwn = require("d91d786cc71453ce");
var ownKeys = require("88cb809f98beddc6");
var getOwnPropertyDescriptorModule = require("10ea642aad5f7c21");
var definePropertyModule = require("39ff598ce822187e");
module.exports = function(target, source) {
    var keys = ownKeys(source);
    var defineProperty = definePropertyModule.f;
    var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        if (!hasOwn(target, key)) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
};

},{"d91d786cc71453ce":"4SzRl","88cb809f98beddc6":"dyvB8","10ea642aad5f7c21":"8cErP","39ff598ce822187e":"dfAo1"}],"dyvB8":[function(require,module,exports) {
var getBuiltIn = require("3cc1e4329d869e34");
var uncurryThis = require("2b8e77cbdbe3db7a");
var getOwnPropertyNamesModule = require("d703bcb62fcda216");
var getOwnPropertySymbolsModule = require("157674bad2772c6d");
var anObject = require("a09e060b9cae3c6c");
var concat = uncurryThis([].concat);
// all object keys, includes non-enumerable and symbols
module.exports = getBuiltIn("Reflect", "ownKeys") || function ownKeys(it) {
    var keys = getOwnPropertyNamesModule.f(anObject(it));
    var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
    return getOwnPropertySymbols ? concat(keys, getOwnPropertySymbols(it)) : keys;
};

},{"3cc1e4329d869e34":"bQFzp","2b8e77cbdbe3db7a":"fP9tv","d703bcb62fcda216":"9QTxj","157674bad2772c6d":"2bAgb","a09e060b9cae3c6c":"39qAm"}],"9QTxj":[function(require,module,exports) {
var internalObjectKeys = require("6d8591e17a49376c");
var enumBugKeys = require("2c933f93dd98f385");
var hiddenKeys = enumBugKeys.concat("length", "prototype");
// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
    return internalObjectKeys(O, hiddenKeys);
};

},{"6d8591e17a49376c":"j7Ows","2c933f93dd98f385":"kSeIZ"}],"j7Ows":[function(require,module,exports) {
var uncurryThis = require("363ee0e6bb4f46a7");
var hasOwn = require("3183fe0b0bf6f6ac");
var toIndexedObject = require("28192ac12e934672");
var indexOf = require("a5f9c5d8e993ccd6").indexOf;
var hiddenKeys = require("57775908f1581bc6");
var push = uncurryThis([].push);
module.exports = function(object, names) {
    var O = toIndexedObject(object);
    var i = 0;
    var result = [];
    var key;
    for(key in O)!hasOwn(hiddenKeys, key) && hasOwn(O, key) && push(result, key);
    // Don't enum bug & hidden keys
    while(names.length > i)if (hasOwn(O, key = names[i++])) ~indexOf(result, key) || push(result, key);
    return result;
};

},{"363ee0e6bb4f46a7":"fP9tv","3183fe0b0bf6f6ac":"4SzRl","28192ac12e934672":"5DeQ5","a5f9c5d8e993ccd6":"3WKfQ","57775908f1581bc6":"8A7bE"}],"3WKfQ":[function(require,module,exports) {
var toIndexedObject = require("d5dcbcd68ac5acd0");
var toAbsoluteIndex = require("212b13aecfa48226");
var lengthOfArrayLike = require("e5a8b3e1da4c5637");
// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod = function(IS_INCLUDES) {
    return function($this, el, fromIndex) {
        var O = toIndexedObject($this);
        var length = lengthOfArrayLike(O);
        var index = toAbsoluteIndex(fromIndex, length);
        var value;
        // Array#includes uses SameValueZero equality algorithm
        // eslint-disable-next-line no-self-compare -- NaN check
        if (IS_INCLUDES && el != el) while(length > index){
            value = O[index++];
            // eslint-disable-next-line no-self-compare -- NaN check
            if (value != value) return true;
        // Array#indexOf ignores holes, Array#includes - not
        }
        else for(; length > index; index++){
            if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
        }
        return !IS_INCLUDES && -1;
    };
};
module.exports = {
    // `Array.prototype.includes` method
    // https://tc39.es/ecma262/#sec-array.prototype.includes
    includes: createMethod(true),
    // `Array.prototype.indexOf` method
    // https://tc39.es/ecma262/#sec-array.prototype.indexof
    indexOf: createMethod(false)
};

},{"d5dcbcd68ac5acd0":"5DeQ5","212b13aecfa48226":"7kdMh","e5a8b3e1da4c5637":"ckDDq"}],"7kdMh":[function(require,module,exports) {
var toIntegerOrInfinity = require("72fe0a53ad43912c");
var max = Math.max;
var min = Math.min;
// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
module.exports = function(index, length) {
    var integer = toIntegerOrInfinity(index);
    return integer < 0 ? max(integer + length, 0) : min(integer, length);
};

},{"72fe0a53ad43912c":"8WXPA"}],"8WXPA":[function(require,module,exports) {
var ceil = Math.ceil;
var floor = Math.floor;
// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
module.exports = function(argument) {
    var number = +argument;
    // eslint-disable-next-line no-self-compare -- safe
    return number !== number || number === 0 ? 0 : (number > 0 ? floor : ceil)(number);
};

},{}],"ckDDq":[function(require,module,exports) {
var toLength = require("23d9716c54a2ab90");
// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
module.exports = function(obj) {
    return toLength(obj.length);
};

},{"23d9716c54a2ab90":"kzWDg"}],"kzWDg":[function(require,module,exports) {
var toIntegerOrInfinity = require("c48d3a8b8ac52b0b");
var min = Math.min;
// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
module.exports = function(argument) {
    return argument > 0 ? min(toIntegerOrInfinity(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};

},{"c48d3a8b8ac52b0b":"8WXPA"}],"kSeIZ":[function(require,module,exports) {
// IE8- don't enum bug keys
module.exports = [
    "constructor",
    "hasOwnProperty",
    "isPrototypeOf",
    "propertyIsEnumerable",
    "toLocaleString",
    "toString",
    "valueOf"
];

},{}],"2bAgb":[function(require,module,exports) {
// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
exports.f = Object.getOwnPropertySymbols;

},{}],"j3Sfj":[function(require,module,exports) {
var fails = require("10299561ea0c7870");
var isCallable = require("8b1ecdaf59f07210");
var replacement = /#|\.prototype\./;
var isForced = function(feature, detection) {
    var value = data[normalize(feature)];
    return value == POLYFILL ? true : value == NATIVE ? false : isCallable(detection) ? fails(detection) : !!detection;
};
var normalize = isForced.normalize = function(string) {
    return String(string).replace(replacement, ".").toLowerCase();
};
var data = isForced.data = {};
var NATIVE = isForced.NATIVE = "N";
var POLYFILL = isForced.POLYFILL = "P";
module.exports = isForced;

},{"10299561ea0c7870":"keKlS","8b1ecdaf59f07210":"cVxS9"}],"eYGrC":[function(require,module,exports) {
var classof = require("ccb261b2d73a4fca");
// `IsArray` abstract operation
// https://tc39.es/ecma262/#sec-isarray
// eslint-disable-next-line es/no-array-isarray -- safe
module.exports = Array.isArray || function isArray(argument) {
    return classof(argument) == "Array";
};

},{"ccb261b2d73a4fca":"6FZJh"}],"3yb4H":[function(require,module,exports) {
"use strict";
var toPropertyKey = require("cbef083007bd70ff");
var definePropertyModule = require("2daa2f41b7310fd4");
var createPropertyDescriptor = require("7bb9efd811e3f83f");
module.exports = function(object, key, value) {
    var propertyKey = toPropertyKey(key);
    if (propertyKey in object) definePropertyModule.f(object, propertyKey, createPropertyDescriptor(0, value));
    else object[propertyKey] = value;
};

},{"cbef083007bd70ff":"60GKb","2daa2f41b7310fd4":"dfAo1","7bb9efd811e3f83f":"81es4"}],"5xBSA":[function(require,module,exports) {
var arraySpeciesConstructor = require("4580767bbbe40f0b");
// `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
module.exports = function(originalArray, length) {
    return new (arraySpeciesConstructor(originalArray))(length === 0 ? 0 : length);
};

},{"4580767bbbe40f0b":"dGzrd"}],"dGzrd":[function(require,module,exports) {
var global = require("a4272d89756473d5");
var isArray = require("a9e5b9af57e551f6");
var isConstructor = require("2b4d84c184e08f4f");
var isObject = require("f4bec83e8d6008c9");
var wellKnownSymbol = require("4a13cf47b259a825");
var SPECIES = wellKnownSymbol("species");
var Array = global.Array;
// a part of `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
module.exports = function(originalArray) {
    var C;
    if (isArray(originalArray)) {
        C = originalArray.constructor;
        // cross-realm fallback
        if (isConstructor(C) && (C === Array || isArray(C.prototype))) C = undefined;
        else if (isObject(C)) {
            C = C[SPECIES];
            if (C === null) C = undefined;
        }
    }
    return C === undefined ? Array : C;
};

},{"a4272d89756473d5":"1GZc4","a9e5b9af57e551f6":"eYGrC","2b4d84c184e08f4f":"9K6ap","f4bec83e8d6008c9":"bprny","4a13cf47b259a825":"kbsMI"}],"9K6ap":[function(require,module,exports) {
var uncurryThis = require("3b3e7fa8cfe4b3ac");
var fails = require("84df2127d2d40501");
var isCallable = require("ae35eceee587c4bc");
var classof = require("7bd40df22601ee7e");
var getBuiltIn = require("271ff92378cbc486");
var inspectSource = require("74840ba4357c1c30");
var noop = function() {};
var empty = [];
var construct = getBuiltIn("Reflect", "construct");
var constructorRegExp = /^\s*(?:class|function)\b/;
var exec = uncurryThis(constructorRegExp.exec);
var INCORRECT_TO_STRING = !constructorRegExp.exec(noop);
var isConstructorModern = function(argument) {
    if (!isCallable(argument)) return false;
    try {
        construct(noop, empty, argument);
        return true;
    } catch (error) {
        return false;
    }
};
var isConstructorLegacy = function(argument) {
    if (!isCallable(argument)) return false;
    switch(classof(argument)){
        case "AsyncFunction":
        case "GeneratorFunction":
        case "AsyncGeneratorFunction":
            return false;
    }
    return INCORRECT_TO_STRING || !!exec(constructorRegExp, inspectSource(argument));
};
// `IsConstructor` abstract operation
// https://tc39.es/ecma262/#sec-isconstructor
module.exports = !construct || fails(function() {
    var called;
    return isConstructorModern(isConstructorModern.call) || !isConstructorModern(Object) || !isConstructorModern(function() {
        called = true;
    }) || called;
}) ? isConstructorLegacy : isConstructorModern;

},{"3b3e7fa8cfe4b3ac":"fP9tv","84df2127d2d40501":"keKlS","ae35eceee587c4bc":"cVxS9","7bd40df22601ee7e":"7lOdl","271ff92378cbc486":"bQFzp","74840ba4357c1c30":"80OOF"}],"7lOdl":[function(require,module,exports) {
var global = require("543c72fa57df0ffb");
var TO_STRING_TAG_SUPPORT = require("397e535b3976d304");
var isCallable = require("eebd8012c2d2c3ae");
var classofRaw = require("8da113eeaf06c4ba");
var wellKnownSymbol = require("df252844008f634");
var TO_STRING_TAG = wellKnownSymbol("toStringTag");
var Object = global.Object;
// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw(function() {
    return arguments;
}()) == "Arguments";
// fallback for IE11 Script Access Denied error
var tryGet = function(it, key) {
    try {
        return it[key];
    } catch (error) {}
};
// getting tag from ES6+ `Object.prototype.toString`
module.exports = TO_STRING_TAG_SUPPORT ? classofRaw : function(it) {
    var O, tag, result;
    return it === undefined ? "Undefined" : it === null ? "Null" : typeof (tag = tryGet(O = Object(it), TO_STRING_TAG)) == "string" ? tag : CORRECT_ARGUMENTS ? classofRaw(O) : (result = classofRaw(O)) == "Object" && isCallable(O.callee) ? "Arguments" : result;
};

},{"543c72fa57df0ffb":"1GZc4","397e535b3976d304":"a8Dmu","eebd8012c2d2c3ae":"cVxS9","8da113eeaf06c4ba":"6FZJh","df252844008f634":"kbsMI"}],"a8Dmu":[function(require,module,exports) {
var wellKnownSymbol = require("6306cd4835715127");
var TO_STRING_TAG = wellKnownSymbol("toStringTag");
var test = {};
test[TO_STRING_TAG] = "z";
module.exports = String(test) === "[object z]";

},{"6306cd4835715127":"kbsMI"}],"gkuI7":[function(require,module,exports) {
var fails = require("bbe4de7ca7a1c6be");
var wellKnownSymbol = require("6cb3e4ca309911dc");
var V8_VERSION = require("2ccd198412508124");
var SPECIES = wellKnownSymbol("species");
module.exports = function(METHOD_NAME) {
    // We can't use this feature detection in V8 since it causes
    // deoptimization and serious performance degradation
    // https://github.com/zloirock/core-js/issues/677
    return V8_VERSION >= 51 || !fails(function() {
        var array = [];
        var constructor = array.constructor = {};
        constructor[SPECIES] = function() {
            return {
                foo: 1
            };
        };
        return array[METHOD_NAME](Boolean).foo !== 1;
    });
};

},{"bbe4de7ca7a1c6be":"keKlS","6cb3e4ca309911dc":"kbsMI","2ccd198412508124":"g2xJU"}],"2fVmM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _coreClient = require("@storybook/core-client");
parcelHelpers.exportAll(_coreClient, exports);

},{"@storybook/core-client":"em7IR","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"em7IR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _preview = require("./preview");
parcelHelpers.exportAll(_preview, exports);
var _types = require("./preview/types");
parcelHelpers.exportAll(_types, exports);

},{"./preview":"5jw7L","./preview/types":"h6fi9","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"5jw7L":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "start", ()=>(0, _start.start));
parcelHelpers.export(exports, "toId", ()=>(0, _csf.toId));
parcelHelpers.export(exports, "ClientApi", ()=>(0, _clientApi.ClientApi));
parcelHelpers.export(exports, "StoryStore", ()=>(0, _store.StoryStore));
var _clientApi = require("@storybook/client-api");
var _store = require("@storybook/store");
var _csf = require("@storybook/csf");
var _start = require("./start");
exports.default = {
    start: (0, _start.start),
    toId: (0, _csf.toId),
    ClientApi: (0, _clientApi.ClientApi),
    StoryStore: (0, _store.StoryStore)
};

},{"@storybook/client-api":"5kgK6","@storybook/store":"26Xer","@storybook/csf":"f7MI8","./start":"8tgIo","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"5kgK6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addArgsEnhancer", ()=>(0, _clientApi.addArgsEnhancer));
parcelHelpers.export(exports, "addArgTypesEnhancer", ()=>(0, _clientApi.addArgTypesEnhancer));
parcelHelpers.export(exports, "addDecorator", ()=>(0, _clientApi.addDecorator));
parcelHelpers.export(exports, "addLoader", ()=>(0, _clientApi.addLoader));
parcelHelpers.export(exports, "addArgs", ()=>(0, _clientApi.addArgs));
parcelHelpers.export(exports, "addArgTypes", ()=>(0, _clientApi.addArgTypes));
parcelHelpers.export(exports, "addParameters", ()=>(0, _clientApi.addParameters));
parcelHelpers.export(exports, "setGlobalRender", ()=>(0, _clientApi.setGlobalRender));
parcelHelpers.export(exports, "ClientApi", ()=>(0, _clientApi.ClientApi));
var _clientApi = require("./ClientApi");
var _types = require("./types");
parcelHelpers.exportAll(_types, exports);
var _queryparams = require("./queryparams");
parcelHelpers.exportAll(_queryparams, exports);
var _store = require("@storybook/store");
parcelHelpers.exportAll(_store, exports);

},{"./ClientApi":"eTdkX","./types":"lxWOQ","./queryparams":"cvJqQ","@storybook/store":"26Xer","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"eTdkX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addDecorator", ()=>addDecorator);
parcelHelpers.export(exports, "addParameters", ()=>addParameters);
parcelHelpers.export(exports, "addLoader", ()=>addLoader);
parcelHelpers.export(exports, "addArgs", ()=>addArgs);
parcelHelpers.export(exports, "addArgTypes", ()=>addArgTypes);
parcelHelpers.export(exports, "addArgsEnhancer", ()=>addArgsEnhancer);
parcelHelpers.export(exports, "addArgTypesEnhancer", ()=>addArgTypesEnhancer);
parcelHelpers.export(exports, "getGlobalRender", ()=>getGlobalRender);
parcelHelpers.export(exports, "setGlobalRender", ()=>setGlobalRender);
parcelHelpers.export(exports, "ClientApi", ()=>ClientApi);
var _esArraySliceJs = require("core-js/modules/es.array.slice.js");
var _esObjectFreezeJs = require("core-js/modules/es.object.freeze.js");
var _esSymbolJs = require("core-js/modules/es.symbol.js");
var _esSymbolDescriptionJs = require("core-js/modules/es.symbol.description.js");
var _esSymbolIteratorJs = require("core-js/modules/es.symbol.iterator.js");
var _esArrayFromJs = require("core-js/modules/es.array.from.js");
var _esRegexpExecJs = require("core-js/modules/es.regexp.exec.js");
var _esArrayIteratorJs = require("core-js/modules/es.array.iterator.js");
var _esObjectToStringJs = require("core-js/modules/es.object.to-string.js");
var _esSetJs = require("core-js/modules/es.set.js");
var _esStringIteratorJs = require("core-js/modules/es.string.iterator.js");
var _webDomCollectionsIteratorJs = require("core-js/modules/web.dom-collections.iterator.js");
var _esObjectAssignJs = require("core-js/modules/es.object.assign.js");
var _esObjectGetPrototypeOfJs = require("core-js/modules/es.object.get-prototype-of.js");
var _esRegexpToStringJs = require("core-js/modules/es.regexp.to-string.js");
var _esObjectKeysJs = require("core-js/modules/es.object.keys.js");
var _esArrayConcatJs = require("core-js/modules/es.array.concat.js");
var _webDomCollectionsForEachJs = require("core-js/modules/web.dom-collections.for-each.js");
var _esObjectEntriesJs = require("core-js/modules/es.object.entries.js");
var _esFunctionNameJs = require("core-js/modules/es.function.name.js");
var _esObjectValuesJs = require("core-js/modules/es.object.values.js");
var _utilDeprecate = require("util-deprecate");
var _utilDeprecateDefault = parcelHelpers.interopDefault(_utilDeprecate);
var _tsDedent = require("ts-dedent");
var _tsDedentDefault = parcelHelpers.interopDefault(_tsDedent);
var _global = require("global");
var _globalDefault = parcelHelpers.interopDefault(_global);
var _clientLogger = require("@storybook/client-logger");
var _csf = require("@storybook/csf");
var _store = require("@storybook/store");
var _storyStoreFacade = require("./StoryStoreFacade");
var _excluded = [
    "globals",
    "globalTypes"
], _excluded2 = [
    "decorators",
    "loaders",
    "component",
    "args",
    "argTypes"
], _excluded3 = [
    "component",
    "args",
    "argTypes"
];
var _templateObject, _templateObject2, _templateObject3, _templateObject4;
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _typeof(obj) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) raw = strings.slice(0);
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
// ClientApi (and StoreStore) are really singletons. However they are not created until the
// relevant framework instanciates them via `start.js`. The good news is this happens right away.
var singleton;
var warningAlternatives = {
    addDecorator: "Instead, use `export const decorators = [];` in your `preview.js`.",
    addParameters: "Instead, use `export const parameters = {};` in your `preview.js`.",
    addLoaders: "Instead, use `export const loaders = [];` in your `preview.js`."
};
var warningMessage = function warningMessage(method) {
    return (0, _utilDeprecateDefault.default)(function() {}, (0, _tsDedentDefault.default)(_templateObject || (_templateObject = _taggedTemplateLiteral([
        "\n  `",
        "` is deprecated, and will be removed in Storybook 7.0.\n\n  ",
        "\n\n  Read more at https://github.com/storybookjs/storybook/blob/next/MIGRATION.md#deprecated-addparameters-and-adddecorator)."
    ], [
        "\n  \\`",
        "\\` is deprecated, and will be removed in Storybook 7.0.\n\n  ",
        "\n\n  Read more at https://github.com/storybookjs/storybook/blob/next/MIGRATION.md#deprecated-addparameters-and-adddecorator)."
    ])), method, warningAlternatives[method]));
};
var warnings = {
    addDecorator: warningMessage("addDecorator"),
    addParameters: warningMessage("addParameters"),
    addLoaders: warningMessage("addLoaders")
};
var checkMethod = function checkMethod(method, deprecationWarning) {
    var _global$FEATURES;
    if ((_global$FEATURES = (0, _globalDefault.default).FEATURES) !== null && _global$FEATURES !== void 0 && _global$FEATURES.storyStoreV7) throw new Error((0, _tsDedentDefault.default)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral([
        "You cannot use `",
        "` with the new Story Store.\n      \n      ",
        ""
    ], [
        "You cannot use \\`",
        "\\` with the new Story Store.\n      \n      ",
        ""
    ])), method, warningAlternatives[method]));
    if (!singleton) throw new Error("Singleton client API not yet initialized, cannot call `".concat(method, "`."));
    if (deprecationWarning) warnings[method]();
};
var addDecorator = function addDecorator(decorator) {
    var deprecationWarning = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    checkMethod("addDecorator", deprecationWarning);
    singleton.addDecorator(decorator);
};
var addParameters = function addParameters(parameters) {
    var deprecationWarning = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    checkMethod("addParameters", deprecationWarning);
    singleton.addParameters(parameters);
};
var addLoader = function addLoader(loader) {
    var deprecationWarning = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    checkMethod("addLoader", deprecationWarning);
    singleton.addLoader(loader);
};
var addArgs = function addArgs(args) {
    checkMethod("addArgs", false);
    singleton.addArgs(args);
};
var addArgTypes = function addArgTypes(argTypes) {
    checkMethod("addArgTypes", false);
    singleton.addArgTypes(argTypes);
};
var addArgsEnhancer = function addArgsEnhancer(enhancer) {
    checkMethod("addArgsEnhancer", false);
    singleton.addArgsEnhancer(enhancer);
};
var addArgTypesEnhancer = function addArgTypesEnhancer(enhancer) {
    checkMethod("addArgTypesEnhancer", false);
    singleton.addArgTypesEnhancer(enhancer);
};
var getGlobalRender = function getGlobalRender() {
    checkMethod("getGlobalRender", false);
    return singleton.facade.projectAnnotations.render;
};
var setGlobalRender = function setGlobalRender(render) {
    checkMethod("setGlobalRender", false);
    singleton.facade.projectAnnotations.render = render;
};
var invalidStoryTypes = new Set([
    "string",
    "number",
    "boolean",
    "symbol"
]);
var ClientApi = /*#__PURE__*/ function() {
    // If we don't get passed modules so don't know filenames, we can
    // just use numeric indexes
    function ClientApi() {
        var _this = this;
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, storyStore = _ref.storyStore;
        _classCallCheck(this, ClientApi);
        this.facade = void 0;
        this.storyStore = void 0;
        this.addons = void 0;
        this.onImportFnChanged = void 0;
        this.lastFileName = 0;
        this.setAddon = (0, _utilDeprecateDefault.default)(function(addon) {
            _this.addons = Object.assign({}, _this.addons, addon);
        }, (0, _tsDedentDefault.default)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral([
            "\n      `setAddon` is deprecated and will be removed in Storybook 7.0.\n\n      https://github.com/storybookjs/storybook/blob/next/MIGRATION.md#deprecated-setaddon\n    "
        ], [
            "\n      \\`setAddon\\` is deprecated and will be removed in Storybook 7.0.\n\n      https://github.com/storybookjs/storybook/blob/next/MIGRATION.md#deprecated-setaddon\n    "
        ]))));
        this.addDecorator = function(decorator) {
            _this.facade.projectAnnotations.decorators.push(decorator);
        };
        this.clearDecorators = (0, _utilDeprecateDefault.default)(function() {
            _this.facade.projectAnnotations.decorators = [];
        }, (0, _tsDedentDefault.default)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral([
            "\n      `clearDecorators` is deprecated and will be removed in Storybook 7.0.\n\n      https://github.com/storybookjs/storybook/blob/next/MIGRATION.md#deprecated-cleardecorators\n    "
        ], [
            "\n      \\`clearDecorators\\` is deprecated and will be removed in Storybook 7.0.\n\n      https://github.com/storybookjs/storybook/blob/next/MIGRATION.md#deprecated-cleardecorators\n    "
        ]))));
        this.addParameters = function(_ref2) {
            var globals = _ref2.globals, globalTypes = _ref2.globalTypes, parameters = _objectWithoutProperties(_ref2, _excluded);
            _this.facade.projectAnnotations.parameters = (0, _store.combineParameters)(_this.facade.projectAnnotations.parameters, parameters);
            if (globals) _this.facade.projectAnnotations.globals = Object.assign({}, _this.facade.projectAnnotations.globals, globals);
            if (globalTypes) _this.facade.projectAnnotations.globalTypes = Object.assign({}, _this.facade.projectAnnotations.globalTypes, (0, _store.normalizeInputTypes)(globalTypes));
        };
        this.addLoader = function(loader) {
            _this.facade.projectAnnotations.loaders.push(loader);
        };
        this.addArgs = function(args) {
            _this.facade.projectAnnotations.args = Object.assign({}, _this.facade.projectAnnotations.args, args);
        };
        this.addArgTypes = function(argTypes) {
            _this.facade.projectAnnotations.argTypes = Object.assign({}, _this.facade.projectAnnotations.argTypes, (0, _store.normalizeInputTypes)(argTypes));
        };
        this.addArgsEnhancer = function(enhancer) {
            _this.facade.projectAnnotations.argsEnhancers.push(enhancer);
        };
        this.addArgTypesEnhancer = function(enhancer) {
            _this.facade.projectAnnotations.argTypesEnhancers.push(enhancer);
        };
        this.storiesOf = function(kind, m) {
            if (!kind && typeof kind !== "string") throw new Error("Invalid or missing kind provided for stories, should be a string");
            if (!m) (0, _clientLogger.logger).warn("Missing 'module' parameter for story with a kind of '".concat(kind, "'. It will break your HMR"));
            if (m) {
                var proto = Object.getPrototypeOf(m);
                if (proto.exports && proto.exports.default) // FIXME: throw an error in SB6.0
                (0, _clientLogger.logger).error("Illegal mix of CSF default export and storiesOf calls in a single file: ".concat(proto.i));
            } // eslint-disable-next-line no-plusplus
            var baseFilename = m && m.id ? "".concat(m.id) : (_this.lastFileName++).toString();
            var fileName = baseFilename;
            var i = 1; // Deal with `storiesOf()` being called twice in the same file.
            // On HMR, `this.csfExports[fileName]` will be reset to `{}`, so an empty object is due
            // to this export, not a second call of `storiesOf()`.
            while(_this.facade.csfExports[fileName] && Object.keys(_this.facade.csfExports[fileName]).length > 0){
                i += 1;
                fileName = "".concat(baseFilename, "-").concat(i);
            }
            if (m && m.hot && m.hot.accept) {
                // This module used storiesOf(), so when it re-runs on HMR, it will reload
                // itself automatically without us needing to look at our imports
                m.hot.accept();
                m.hot.dispose(function() {
                    _this.facade.clearFilenameExports(fileName); // We need to update the importFn as soon as the module re-evaluates
                    // (and calls storiesOf() again, etc). We could call `onImportFnChanged()`
                    // at the end of every setStories call (somehow), but then we'd need to
                    // debounce it somehow for initial startup. Instead, we'll take advantage of
                    // the fact that the evaluation of the module happens immediately in the same tick
                    setTimeout(function() {
                        var _this$onImportFnChang;
                        (_this$onImportFnChang = _this.onImportFnChanged) === null || _this$onImportFnChang === void 0 || _this$onImportFnChang.call(_this, {
                            importFn: _this.importFn.bind(_this)
                        });
                    }, 0);
                });
            }
            var hasAdded = false;
            var api = {
                kind: kind.toString(),
                add: function add() {
                    return api;
                },
                addDecorator: function addDecorator() {
                    return api;
                },
                addLoader: function addLoader() {
                    return api;
                },
                addParameters: function addParameters() {
                    return api;
                }
            }; // apply addons
            Object.keys(_this.addons).forEach(function(name) {
                var addon = _this.addons[name];
                api[name] = function() {
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                    addon.apply(api, args);
                    return api;
                };
            });
            var meta = {
                id: (0, _csf.sanitize)(kind),
                title: kind,
                decorators: [],
                loaders: [],
                parameters: {}
            }; // We map these back to a simple default export, even though we have type guarantees at this point
            _this.facade.csfExports[fileName] = {
                default: meta
            };
            var counter = 0;
            api.add = function(storyName, storyFn) {
                var parameters = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                hasAdded = true;
                if (typeof storyName !== "string") throw new Error('Invalid or missing storyName provided for a "'.concat(kind, '" story.'));
                if (!storyFn || Array.isArray(storyFn) || invalidStoryTypes.has(_typeof(storyFn))) throw new Error('Cannot load story "'.concat(storyName, '" in "').concat(kind, '" due to invalid format. Storybook expected a function/object but received ').concat(_typeof(storyFn), " instead."));
                var decorators = parameters.decorators, loaders = parameters.loaders, component = parameters.component, args = parameters.args, argTypes = parameters.argTypes, storyParameters = _objectWithoutProperties(parameters, _excluded2); // eslint-disable-next-line no-underscore-dangle
                var storyId = parameters.__id || (0, _csf.toId)(kind, storyName);
                var csfExports = _this.facade.csfExports[fileName]; // Whack a _ on the front incase it is "default"
                csfExports["story".concat(counter)] = {
                    name: storyName,
                    parameters: Object.assign({
                        fileName: fileName,
                        __id: storyId
                    }, storyParameters),
                    decorators: decorators,
                    loaders: loaders,
                    args: args,
                    argTypes: argTypes,
                    component: component,
                    render: storyFn
                };
                counter += 1;
                _this.facade.stories[storyId] = {
                    id: storyId,
                    title: csfExports.default.title,
                    name: storyName,
                    importPath: fileName
                };
                return api;
            };
            api.addDecorator = function(decorator) {
                if (hasAdded) throw new Error("You cannot add a decorator after the first story for a kind.\nRead more here: https://github.com/storybookjs/storybook/blob/master/MIGRATION.md#can-no-longer-add-decoratorsparameters-after-stories");
                meta.decorators.push(decorator);
                return api;
            };
            api.addLoader = function(loader) {
                if (hasAdded) throw new Error("You cannot add a loader after the first story for a kind.");
                meta.loaders.push(loader);
                return api;
            };
            api.addParameters = function(_ref3) {
                var component = _ref3.component, args = _ref3.args, argTypes = _ref3.argTypes, parameters = _objectWithoutProperties(_ref3, _excluded3);
                if (hasAdded) throw new Error("You cannot add parameters after the first story for a kind.\nRead more here: https://github.com/storybookjs/storybook/blob/master/MIGRATION.md#can-no-longer-add-decoratorsparameters-after-stories");
                meta.parameters = (0, _store.combineParameters)(meta.parameters, parameters);
                if (component) meta.component = component;
                if (args) meta.args = Object.assign({}, meta.args, args);
                if (argTypes) meta.argTypes = Object.assign({}, meta.argTypes, argTypes);
                return api;
            };
            return api;
        };
        this.getStorybook = function() {
            var stories = _this.storyStore.storyIndex.stories;
            var kinds = {};
            Object.entries(stories).forEach(function(_ref4) {
                var _ref5 = _slicedToArray(_ref4, 2), storyId = _ref5[0], _ref5$ = _ref5[1], title = _ref5$.title, name = _ref5$.name, importPath = _ref5$.importPath;
                if (!kinds[title]) kinds[title] = {
                    kind: title,
                    fileName: importPath,
                    stories: []
                };
                var _this$storyStore$from = _this.storyStore.fromId(storyId), storyFn = _this$storyStore$from.storyFn;
                kinds[title].stories.push({
                    name: name,
                    render: storyFn
                });
            });
            return Object.values(kinds);
        };
        this.raw = function() {
            return _this.storyStore.raw();
        };
        this.facade = new (0, _storyStoreFacade.StoryStoreFacade)();
        this.addons = {};
        this.storyStore = storyStore;
        singleton = this;
    }
    _createClass(ClientApi, [
        {
            key: "importFn",
            value: function importFn(path) {
                return this.facade.importFn(path);
            }
        },
        {
            key: "getStoryIndex",
            value: function getStoryIndex() {
                if (!this.storyStore) throw new Error("Cannot get story index before setting storyStore");
                return this.facade.getStoryIndex(this.storyStore);
            }
        },
        {
            key: "_storyStore",
            get: function get() {
                return this.storyStore;
            }
        }
    ]);
    return ClientApi;
}();

},{"core-js/modules/es.array.slice.js":"8RRh9","core-js/modules/es.object.freeze.js":"9LVYO","core-js/modules/es.symbol.js":"ajw2f","core-js/modules/es.symbol.description.js":"wrlLc","core-js/modules/es.symbol.iterator.js":"fhNIb","core-js/modules/es.array.from.js":"9UCQw","core-js/modules/es.regexp.exec.js":"5q56v","core-js/modules/es.array.iterator.js":"ieU20","core-js/modules/es.object.to-string.js":"lsA9p","core-js/modules/es.set.js":"6FW6g","core-js/modules/es.string.iterator.js":"74a8v","core-js/modules/web.dom-collections.iterator.js":"aXR96","core-js/modules/es.object.assign.js":"8FU8M","core-js/modules/es.object.get-prototype-of.js":"kLLpv","core-js/modules/es.regexp.to-string.js":"bGzly","core-js/modules/es.object.keys.js":"5Q2AT","core-js/modules/es.array.concat.js":"g1t7q","core-js/modules/web.dom-collections.for-each.js":"iYT1M","core-js/modules/es.object.entries.js":"7Wf79","core-js/modules/es.function.name.js":"4LiLL","core-js/modules/es.object.values.js":"bB8XB","util-deprecate":"lYmRJ","ts-dedent":"9RvVa","global":"5PzlO","@storybook/client-logger":"iGRus","@storybook/csf":"f7MI8","@storybook/store":"26Xer","./StoryStoreFacade":"idtQA","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"8RRh9":[function(require,module,exports) {
"use strict";
var $ = require("f4626508f1e86a5e");
var global = require("e3978acd57278328");
var isArray = require("c55f884cac32042");
var isConstructor = require("c7ab28f7c42930d4");
var isObject = require("d62f4c68d4a29c88");
var toAbsoluteIndex = require("598be77178793bf1");
var lengthOfArrayLike = require("f9b9299dc750b2dd");
var toIndexedObject = require("ff620c60ded20435");
var createProperty = require("49168568b59df51b");
var wellKnownSymbol = require("f02f140688adf449");
var arrayMethodHasSpeciesSupport = require("eb9bbc0536d1f202");
var un$Slice = require("88cb1064f5f88f9e");
var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport("slice");
var SPECIES = wellKnownSymbol("species");
var Array = global.Array;
var max = Math.max;
// `Array.prototype.slice` method
// https://tc39.es/ecma262/#sec-array.prototype.slice
// fallback for not array-like ES3 strings and DOM objects
$({
    target: "Array",
    proto: true,
    forced: !HAS_SPECIES_SUPPORT
}, {
    slice: function slice(start, end) {
        var O = toIndexedObject(this);
        var length = lengthOfArrayLike(O);
        var k = toAbsoluteIndex(start, length);
        var fin = toAbsoluteIndex(end === undefined ? length : end, length);
        // inline `ArraySpeciesCreate` for usage native `Array#slice` where it's possible
        var Constructor, result, n;
        if (isArray(O)) {
            Constructor = O.constructor;
            // cross-realm fallback
            if (isConstructor(Constructor) && (Constructor === Array || isArray(Constructor.prototype))) Constructor = undefined;
            else if (isObject(Constructor)) {
                Constructor = Constructor[SPECIES];
                if (Constructor === null) Constructor = undefined;
            }
            if (Constructor === Array || Constructor === undefined) return un$Slice(O, k, fin);
        }
        result = new (Constructor === undefined ? Array : Constructor)(max(fin - k, 0));
        for(n = 0; k < fin; k++, n++)if (k in O) createProperty(result, n, O[k]);
        result.length = n;
        return result;
    }
});

},{"f4626508f1e86a5e":"1OO62","e3978acd57278328":"1GZc4","c55f884cac32042":"eYGrC","c7ab28f7c42930d4":"9K6ap","d62f4c68d4a29c88":"bprny","598be77178793bf1":"7kdMh","f9b9299dc750b2dd":"ckDDq","ff620c60ded20435":"5DeQ5","49168568b59df51b":"3yb4H","f02f140688adf449":"kbsMI","eb9bbc0536d1f202":"gkuI7","88cb1064f5f88f9e":"hloI5"}],"hloI5":[function(require,module,exports) {
var uncurryThis = require("5250b5c9324ccbe");
module.exports = uncurryThis([].slice);

},{"5250b5c9324ccbe":"fP9tv"}],"9LVYO":[function(require,module,exports) {
var $ = require("41df7dcb1db288e9");
var FREEZING = require("fff8fcdf7f021ed");
var fails = require("349eb9a58219946d");
var isObject = require("aba4dbd0c2e0df38");
var onFreeze = require("83d388d2147293dd").onFreeze;
// eslint-disable-next-line es/no-object-freeze -- safe
var $freeze = Object.freeze;
var FAILS_ON_PRIMITIVES = fails(function() {
    $freeze(1);
});
// `Object.freeze` method
// https://tc39.es/ecma262/#sec-object.freeze
$({
    target: "Object",
    stat: true,
    forced: FAILS_ON_PRIMITIVES,
    sham: !FREEZING
}, {
    freeze: function freeze(it) {
        return $freeze && isObject(it) ? $freeze(onFreeze(it)) : it;
    }
});

},{"41df7dcb1db288e9":"1OO62","fff8fcdf7f021ed":"dpxMP","349eb9a58219946d":"keKlS","aba4dbd0c2e0df38":"bprny","83d388d2147293dd":"55X03"}],"dpxMP":[function(require,module,exports) {
var fails = require("388690d33020cebb");
module.exports = !fails(function() {
    // eslint-disable-next-line es/no-object-isextensible, es/no-object-preventextensions -- required for testing
    return Object.isExtensible(Object.preventExtensions({}));
});

},{"388690d33020cebb":"keKlS"}],"55X03":[function(require,module,exports) {
var $ = require("3242fc68c548334b");
var uncurryThis = require("d7dc323978454584");
var hiddenKeys = require("33c7a5cefcfa8a48");
var isObject = require("949cc173e657f4a8");
var hasOwn = require("e6764a7848fbe604");
var defineProperty = require("77d05ce7ff38a94f").f;
var getOwnPropertyNamesModule = require("491415e519a00a7c");
var getOwnPropertyNamesExternalModule = require("1a3edc3a1e92ccaf");
var isExtensible = require("1f8f4e666c381f6");
var uid = require("2f09fd9212a3372e");
var FREEZING = require("858ced62f45384ee");
var REQUIRED = false;
var METADATA = uid("meta");
var id = 0;
var setMetadata = function(it) {
    defineProperty(it, METADATA, {
        value: {
            objectID: "O" + id++,
            weakData: {} // weak collections IDs
        }
    });
};
var fastKey = function(it, create) {
    // return a primitive with prefix
    if (!isObject(it)) return typeof it == "symbol" ? it : (typeof it == "string" ? "S" : "P") + it;
    if (!hasOwn(it, METADATA)) {
        // can't set metadata to uncaught frozen object
        if (!isExtensible(it)) return "F";
        // not necessary to add metadata
        if (!create) return "E";
        // add missing metadata
        setMetadata(it);
    // return object ID
    }
    return it[METADATA].objectID;
};
var getWeakData = function(it, create) {
    if (!hasOwn(it, METADATA)) {
        // can't set metadata to uncaught frozen object
        if (!isExtensible(it)) return true;
        // not necessary to add metadata
        if (!create) return false;
        // add missing metadata
        setMetadata(it);
    // return the store of weak collections IDs
    }
    return it[METADATA].weakData;
};
// add metadata on freeze-family methods calling
var onFreeze = function(it) {
    if (FREEZING && REQUIRED && isExtensible(it) && !hasOwn(it, METADATA)) setMetadata(it);
    return it;
};
var enable = function() {
    meta.enable = function() {};
    REQUIRED = true;
    var getOwnPropertyNames = getOwnPropertyNamesModule.f;
    var splice = uncurryThis([].splice);
    var test = {};
    test[METADATA] = 1;
    // prevent exposing of metadata key
    if (getOwnPropertyNames(test).length) {
        getOwnPropertyNamesModule.f = function(it) {
            var result = getOwnPropertyNames(it);
            for(var i = 0, length = result.length; i < length; i++)if (result[i] === METADATA) {
                splice(result, i, 1);
                break;
            }
            return result;
        };
        $({
            target: "Object",
            stat: true,
            forced: true
        }, {
            getOwnPropertyNames: getOwnPropertyNamesExternalModule.f
        });
    }
};
var meta = module.exports = {
    enable: enable,
    fastKey: fastKey,
    getWeakData: getWeakData,
    onFreeze: onFreeze
};
hiddenKeys[METADATA] = true;

},{"3242fc68c548334b":"1OO62","d7dc323978454584":"fP9tv","33c7a5cefcfa8a48":"8A7bE","949cc173e657f4a8":"bprny","e6764a7848fbe604":"4SzRl","77d05ce7ff38a94f":"dfAo1","491415e519a00a7c":"9QTxj","1a3edc3a1e92ccaf":"liXz7","1f8f4e666c381f6":"zKBd8","2f09fd9212a3372e":"6IZd8","858ced62f45384ee":"dpxMP"}],"liXz7":[function(require,module,exports) {
/* eslint-disable es/no-object-getownpropertynames -- safe */ var classof = require("279dbc8649868a7a");
var toIndexedObject = require("430d7ab8977dd85e");
var $getOwnPropertyNames = require("a5a6278a4291e239").f;
var arraySlice = require("a0e199be640bf61f");
var windowNames = typeof window == "object" && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];
var getWindowNames = function(it) {
    try {
        return $getOwnPropertyNames(it);
    } catch (error) {
        return arraySlice(windowNames);
    }
};
// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
module.exports.f = function getOwnPropertyNames(it) {
    return windowNames && classof(it) == "Window" ? getWindowNames(it) : $getOwnPropertyNames(toIndexedObject(it));
};

},{"279dbc8649868a7a":"6FZJh","430d7ab8977dd85e":"5DeQ5","a5a6278a4291e239":"9QTxj","a0e199be640bf61f":"hloI5"}],"zKBd8":[function(require,module,exports) {
var fails = require("de1e0227a248bfd3");
var isObject = require("68a5b2cef468256c");
var classof = require("cb8542af391c6b0e");
var ARRAY_BUFFER_NON_EXTENSIBLE = require("79d81d484af31adc");
// eslint-disable-next-line es/no-object-isextensible -- safe
var $isExtensible = Object.isExtensible;
var FAILS_ON_PRIMITIVES = fails(function() {
    $isExtensible(1);
});
// `Object.isExtensible` method
// https://tc39.es/ecma262/#sec-object.isextensible
module.exports = FAILS_ON_PRIMITIVES || ARRAY_BUFFER_NON_EXTENSIBLE ? function isExtensible(it) {
    if (!isObject(it)) return false;
    if (ARRAY_BUFFER_NON_EXTENSIBLE && classof(it) == "ArrayBuffer") return false;
    return $isExtensible ? $isExtensible(it) : true;
} : $isExtensible;

},{"de1e0227a248bfd3":"keKlS","68a5b2cef468256c":"bprny","cb8542af391c6b0e":"6FZJh","79d81d484af31adc":"53Vap"}],"53Vap":[function(require,module,exports) {
// FF26- bug: ArrayBuffers are non-extensible, but Object.isExtensible does not report it
var fails = require("5bca09ebe0e39932");
module.exports = fails(function() {
    if (typeof ArrayBuffer == "function") {
        var buffer = new ArrayBuffer(8);
        // eslint-disable-next-line es/no-object-isextensible, es/no-object-defineproperty -- safe
        if (Object.isExtensible(buffer)) Object.defineProperty(buffer, "a", {
            value: 8
        });
    }
});

},{"5bca09ebe0e39932":"keKlS"}],"ajw2f":[function(require,module,exports) {
"use strict";
var $ = require("ff533b41cbd64d4d");
var global = require("88beafd0ffbdbadf");
var getBuiltIn = require("9d4faaba135dc3b1");
var apply = require("3c2b3914b8bdff76");
var call = require("2b91e16b5cb7e5b7");
var uncurryThis = require("7dba3c5244208d51");
var IS_PURE = require("48081354f3ce1663");
var DESCRIPTORS = require("74dde659b0a22b62");
var NATIVE_SYMBOL = require("175f21073c4c29a");
var fails = require("11538abf1ce7e538");
var hasOwn = require("398e7276576c431e");
var isArray = require("21534e3aafbbb3c2");
var isCallable = require("24e7ec9aefbe501d");
var isObject = require("3a5592feb6b2bc0a");
var isPrototypeOf = require("921a0f9150f28419");
var isSymbol = require("1069dc4a4f495851");
var anObject = require("43cc8ea07fd7015b");
var toObject = require("d970a8b5a3fe133f");
var toIndexedObject = require("d2828bc6958bd47d");
var toPropertyKey = require("52fce04b31d80bbc");
var $toString = require("90677240d86edea9");
var createPropertyDescriptor = require("1b9e29686d2fa36e");
var nativeObjectCreate = require("aaae69ef656e3cd2");
var objectKeys = require("ede331e06eadb17");
var getOwnPropertyNamesModule = require("2eaaeece2e1d46b7");
var getOwnPropertyNamesExternal = require("c3c9c19b5ef752ac");
var getOwnPropertySymbolsModule = require("9710f1e3ccf0f8b9");
var getOwnPropertyDescriptorModule = require("2a88bc89ec525257");
var definePropertyModule = require("86a418c0ec898ff8");
var propertyIsEnumerableModule = require("397d1db6bd7f93a3");
var arraySlice = require("d5845f0487f40610");
var redefine = require("20c0ccbe72698b19");
var shared = require("467f36f861e1588d");
var sharedKey = require("e36cbc61198f01d4");
var hiddenKeys = require("62194b6af3fe34be");
var uid = require("a6aed3d36f292666");
var wellKnownSymbol = require("3547b1f843283550");
var wrappedWellKnownSymbolModule = require("9112313ff027fdc9");
var defineWellKnownSymbol = require("b1c40c5dd114a46a");
var setToStringTag = require("28165f17bfc0242d");
var InternalStateModule = require("b7d38a1a586bf59a");
var $forEach = require("f3b56366d75b4a6").forEach;
var HIDDEN = sharedKey("hidden");
var SYMBOL = "Symbol";
var PROTOTYPE = "prototype";
var TO_PRIMITIVE = wellKnownSymbol("toPrimitive");
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(SYMBOL);
var ObjectPrototype = Object[PROTOTYPE];
var $Symbol = global.Symbol;
var SymbolPrototype = $Symbol && $Symbol[PROTOTYPE];
var TypeError = global.TypeError;
var QObject = global.QObject;
var $stringify = getBuiltIn("JSON", "stringify");
var nativeGetOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
var nativeDefineProperty = definePropertyModule.f;
var nativeGetOwnPropertyNames = getOwnPropertyNamesExternal.f;
var nativePropertyIsEnumerable = propertyIsEnumerableModule.f;
var push = uncurryThis([].push);
var AllSymbols = shared("symbols");
var ObjectPrototypeSymbols = shared("op-symbols");
var StringToSymbolRegistry = shared("string-to-symbol-registry");
var SymbolToStringRegistry = shared("symbol-to-string-registry");
var WellKnownSymbolsStore = shared("wks");
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var USE_SETTER = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDescriptor = DESCRIPTORS && fails(function() {
    return nativeObjectCreate(nativeDefineProperty({}, "a", {
        get: function() {
            return nativeDefineProperty(this, "a", {
                value: 7
            }).a;
        }
    })).a != 7;
}) ? function(O, P, Attributes) {
    var ObjectPrototypeDescriptor = nativeGetOwnPropertyDescriptor(ObjectPrototype, P);
    if (ObjectPrototypeDescriptor) delete ObjectPrototype[P];
    nativeDefineProperty(O, P, Attributes);
    if (ObjectPrototypeDescriptor && O !== ObjectPrototype) nativeDefineProperty(ObjectPrototype, P, ObjectPrototypeDescriptor);
} : nativeDefineProperty;
var wrap = function(tag, description) {
    var symbol = AllSymbols[tag] = nativeObjectCreate(SymbolPrototype);
    setInternalState(symbol, {
        type: SYMBOL,
        tag: tag,
        description: description
    });
    if (!DESCRIPTORS) symbol.description = description;
    return symbol;
};
var $defineProperty = function defineProperty(O, P, Attributes) {
    if (O === ObjectPrototype) $defineProperty(ObjectPrototypeSymbols, P, Attributes);
    anObject(O);
    var key = toPropertyKey(P);
    anObject(Attributes);
    if (hasOwn(AllSymbols, key)) {
        if (!Attributes.enumerable) {
            if (!hasOwn(O, HIDDEN)) nativeDefineProperty(O, HIDDEN, createPropertyDescriptor(1, {}));
            O[HIDDEN][key] = true;
        } else {
            if (hasOwn(O, HIDDEN) && O[HIDDEN][key]) O[HIDDEN][key] = false;
            Attributes = nativeObjectCreate(Attributes, {
                enumerable: createPropertyDescriptor(0, false)
            });
        }
        return setSymbolDescriptor(O, key, Attributes);
    }
    return nativeDefineProperty(O, key, Attributes);
};
var $defineProperties = function defineProperties(O, Properties) {
    anObject(O);
    var properties = toIndexedObject(Properties);
    var keys = objectKeys(properties).concat($getOwnPropertySymbols(properties));
    $forEach(keys, function(key) {
        if (!DESCRIPTORS || call($propertyIsEnumerable, properties, key)) $defineProperty(O, key, properties[key]);
    });
    return O;
};
var $create = function create(O, Properties) {
    return Properties === undefined ? nativeObjectCreate(O) : $defineProperties(nativeObjectCreate(O), Properties);
};
var $propertyIsEnumerable = function propertyIsEnumerable(V) {
    var P = toPropertyKey(V);
    var enumerable = call(nativePropertyIsEnumerable, this, P);
    if (this === ObjectPrototype && hasOwn(AllSymbols, P) && !hasOwn(ObjectPrototypeSymbols, P)) return false;
    return enumerable || !hasOwn(this, P) || !hasOwn(AllSymbols, P) || hasOwn(this, HIDDEN) && this[HIDDEN][P] ? enumerable : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(O, P) {
    var it = toIndexedObject(O);
    var key = toPropertyKey(P);
    if (it === ObjectPrototype && hasOwn(AllSymbols, key) && !hasOwn(ObjectPrototypeSymbols, key)) return;
    var descriptor = nativeGetOwnPropertyDescriptor(it, key);
    if (descriptor && hasOwn(AllSymbols, key) && !(hasOwn(it, HIDDEN) && it[HIDDEN][key])) descriptor.enumerable = true;
    return descriptor;
};
var $getOwnPropertyNames = function getOwnPropertyNames(O) {
    var names = nativeGetOwnPropertyNames(toIndexedObject(O));
    var result = [];
    $forEach(names, function(key) {
        if (!hasOwn(AllSymbols, key) && !hasOwn(hiddenKeys, key)) push(result, key);
    });
    return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(O) {
    var IS_OBJECT_PROTOTYPE = O === ObjectPrototype;
    var names = nativeGetOwnPropertyNames(IS_OBJECT_PROTOTYPE ? ObjectPrototypeSymbols : toIndexedObject(O));
    var result = [];
    $forEach(names, function(key) {
        if (hasOwn(AllSymbols, key) && (!IS_OBJECT_PROTOTYPE || hasOwn(ObjectPrototype, key))) push(result, AllSymbols[key]);
    });
    return result;
};
// `Symbol` constructor
// https://tc39.es/ecma262/#sec-symbol-constructor
if (!NATIVE_SYMBOL) {
    $Symbol = function Symbol() {
        if (isPrototypeOf(SymbolPrototype, this)) throw TypeError("Symbol is not a constructor");
        var description = !arguments.length || arguments[0] === undefined ? undefined : $toString(arguments[0]);
        var tag = uid(description);
        var setter = function(value) {
            if (this === ObjectPrototype) call(setter, ObjectPrototypeSymbols, value);
            if (hasOwn(this, HIDDEN) && hasOwn(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
            setSymbolDescriptor(this, tag, createPropertyDescriptor(1, value));
        };
        if (DESCRIPTORS && USE_SETTER) setSymbolDescriptor(ObjectPrototype, tag, {
            configurable: true,
            set: setter
        });
        return wrap(tag, description);
    };
    SymbolPrototype = $Symbol[PROTOTYPE];
    redefine(SymbolPrototype, "toString", function toString() {
        return getInternalState(this).tag;
    });
    redefine($Symbol, "withoutSetter", function(description) {
        return wrap(uid(description), description);
    });
    propertyIsEnumerableModule.f = $propertyIsEnumerable;
    definePropertyModule.f = $defineProperty;
    getOwnPropertyDescriptorModule.f = $getOwnPropertyDescriptor;
    getOwnPropertyNamesModule.f = getOwnPropertyNamesExternal.f = $getOwnPropertyNames;
    getOwnPropertySymbolsModule.f = $getOwnPropertySymbols;
    wrappedWellKnownSymbolModule.f = function(name) {
        return wrap(wellKnownSymbol(name), name);
    };
    if (DESCRIPTORS) {
        // https://github.com/tc39/proposal-Symbol-description
        nativeDefineProperty(SymbolPrototype, "description", {
            configurable: true,
            get: function description() {
                return getInternalState(this).description;
            }
        });
        if (!IS_PURE) redefine(ObjectPrototype, "propertyIsEnumerable", $propertyIsEnumerable, {
            unsafe: true
        });
    }
}
$({
    global: true,
    wrap: true,
    forced: !NATIVE_SYMBOL,
    sham: !NATIVE_SYMBOL
}, {
    Symbol: $Symbol
});
$forEach(objectKeys(WellKnownSymbolsStore), function(name) {
    defineWellKnownSymbol(name);
});
$({
    target: SYMBOL,
    stat: true,
    forced: !NATIVE_SYMBOL
}, {
    // `Symbol.for` method
    // https://tc39.es/ecma262/#sec-symbol.for
    "for": function(key) {
        var string = $toString(key);
        if (hasOwn(StringToSymbolRegistry, string)) return StringToSymbolRegistry[string];
        var symbol = $Symbol(string);
        StringToSymbolRegistry[string] = symbol;
        SymbolToStringRegistry[symbol] = string;
        return symbol;
    },
    // `Symbol.keyFor` method
    // https://tc39.es/ecma262/#sec-symbol.keyfor
    keyFor: function keyFor(sym) {
        if (!isSymbol(sym)) throw TypeError(sym + " is not a symbol");
        if (hasOwn(SymbolToStringRegistry, sym)) return SymbolToStringRegistry[sym];
    },
    useSetter: function() {
        USE_SETTER = true;
    },
    useSimple: function() {
        USE_SETTER = false;
    }
});
$({
    target: "Object",
    stat: true,
    forced: !NATIVE_SYMBOL,
    sham: !DESCRIPTORS
}, {
    // `Object.create` method
    // https://tc39.es/ecma262/#sec-object.create
    create: $create,
    // `Object.defineProperty` method
    // https://tc39.es/ecma262/#sec-object.defineproperty
    defineProperty: $defineProperty,
    // `Object.defineProperties` method
    // https://tc39.es/ecma262/#sec-object.defineproperties
    defineProperties: $defineProperties,
    // `Object.getOwnPropertyDescriptor` method
    // https://tc39.es/ecma262/#sec-object.getownpropertydescriptors
    getOwnPropertyDescriptor: $getOwnPropertyDescriptor
});
$({
    target: "Object",
    stat: true,
    forced: !NATIVE_SYMBOL
}, {
    // `Object.getOwnPropertyNames` method
    // https://tc39.es/ecma262/#sec-object.getownpropertynames
    getOwnPropertyNames: $getOwnPropertyNames,
    // `Object.getOwnPropertySymbols` method
    // https://tc39.es/ecma262/#sec-object.getownpropertysymbols
    getOwnPropertySymbols: $getOwnPropertySymbols
});
// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
$({
    target: "Object",
    stat: true,
    forced: fails(function() {
        getOwnPropertySymbolsModule.f(1);
    })
}, {
    getOwnPropertySymbols: function getOwnPropertySymbols(it) {
        return getOwnPropertySymbolsModule.f(toObject(it));
    }
});
// `JSON.stringify` method behavior with symbols
// https://tc39.es/ecma262/#sec-json.stringify
if ($stringify) {
    var FORCED_JSON_STRINGIFY = !NATIVE_SYMBOL || fails(function() {
        var symbol = $Symbol();
        // MS Edge converts symbol values to JSON as {}
        return $stringify([
            symbol
        ]) != "[null]" || $stringify({
            a: symbol
        }) != "{}" || $stringify(Object(symbol)) != "{}";
    });
    $({
        target: "JSON",
        stat: true,
        forced: FORCED_JSON_STRINGIFY
    }, {
        // eslint-disable-next-line no-unused-vars -- required for `.length`
        stringify: function stringify(it, replacer, space) {
            var args = arraySlice(arguments);
            var $replacer = replacer;
            if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
            if (!isArray(replacer)) replacer = function(key, value) {
                if (isCallable($replacer)) value = call($replacer, this, key, value);
                if (!isSymbol(value)) return value;
            };
            args[1] = replacer;
            return apply($stringify, null, args);
        }
    });
}
// `Symbol.prototype[@@toPrimitive]` method
// https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive
if (!SymbolPrototype[TO_PRIMITIVE]) {
    var valueOf = SymbolPrototype.valueOf;
    // eslint-disable-next-line no-unused-vars -- required for .length
    redefine(SymbolPrototype, TO_PRIMITIVE, function(hint) {
        // TODO: improve hint logic
        return call(valueOf, this);
    });
}
// `Symbol.prototype[@@toStringTag]` property
// https://tc39.es/ecma262/#sec-symbol.prototype-@@tostringtag
setToStringTag($Symbol, SYMBOL);
hiddenKeys[HIDDEN] = true;

},{"ff533b41cbd64d4d":"1OO62","88beafd0ffbdbadf":"1GZc4","9d4faaba135dc3b1":"bQFzp","3c2b3914b8bdff76":"QdiN4","2b91e16b5cb7e5b7":"aSvFj","7dba3c5244208d51":"fP9tv","48081354f3ce1663":"bZbjq","74dde659b0a22b62":"7Hk5a","175f21073c4c29a":"2cImI","11538abf1ce7e538":"keKlS","398e7276576c431e":"4SzRl","21534e3aafbbb3c2":"eYGrC","24e7ec9aefbe501d":"cVxS9","3a5592feb6b2bc0a":"bprny","921a0f9150f28419":"alXpj","1069dc4a4f495851":"RacQu","43cc8ea07fd7015b":"39qAm","d970a8b5a3fe133f":"7K2H5","d2828bc6958bd47d":"5DeQ5","52fce04b31d80bbc":"60GKb","90677240d86edea9":"8RVGu","1b9e29686d2fa36e":"81es4","aaae69ef656e3cd2":"dgTGU","ede331e06eadb17":"jlCln","2eaaeece2e1d46b7":"9QTxj","c3c9c19b5ef752ac":"liXz7","9710f1e3ccf0f8b9":"2bAgb","2a88bc89ec525257":"8cErP","86a418c0ec898ff8":"dfAo1","397d1db6bd7f93a3":"i11pl","d5845f0487f40610":"hloI5","20c0ccbe72698b19":"3ncOy","467f36f861e1588d":"adVFA","e36cbc61198f01d4":"21CiI","62194b6af3fe34be":"8A7bE","a6aed3d36f292666":"6IZd8","3547b1f843283550":"kbsMI","9112313ff027fdc9":"58Qnf","b1c40c5dd114a46a":"jltxQ","28165f17bfc0242d":"hVfEJ","b7d38a1a586bf59a":"bRWxa","f3b56366d75b4a6":"g44dN"}],"QdiN4":[function(require,module,exports) {
var FunctionPrototype = Function.prototype;
var apply = FunctionPrototype.apply;
var bind = FunctionPrototype.bind;
var call = FunctionPrototype.call;
// eslint-disable-next-line es/no-reflect -- safe
module.exports = typeof Reflect == "object" && Reflect.apply || (bind ? call.bind(apply) : function() {
    return call.apply(apply, arguments);
});

},{}],"8RVGu":[function(require,module,exports) {
var global = require("6ff3508f7423eb61");
var classof = require("3e4265f3f6994add");
var String = global.String;
module.exports = function(argument) {
    if (classof(argument) === "Symbol") throw TypeError("Cannot convert a Symbol value to a string");
    return String(argument);
};

},{"6ff3508f7423eb61":"1GZc4","3e4265f3f6994add":"7lOdl"}],"dgTGU":[function(require,module,exports) {
/* global ActiveXObject -- old IE, WSH */ var anObject = require("3bbe31d8f504111f");
var defineProperties = require("a9712f03fc468b49");
var enumBugKeys = require("d9e0c389f84efa79");
var hiddenKeys = require("8a43b6a211717cde");
var html = require("78d31e3a50d79c6e");
var documentCreateElement = require("e29f7e32a0583f3");
var sharedKey = require("a6edaba97f293fc9");
var GT = ">";
var LT = "<";
var PROTOTYPE = "prototype";
var SCRIPT = "script";
var IE_PROTO = sharedKey("IE_PROTO");
var EmptyConstructor = function() {};
var scriptTag = function(content) {
    return LT + SCRIPT + GT + content + LT + "/" + SCRIPT + GT;
};
// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX = function(activeXDocument) {
    activeXDocument.write(scriptTag(""));
    activeXDocument.close();
    var temp = activeXDocument.parentWindow.Object;
    activeXDocument = null; // avoid memory leak
    return temp;
};
// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame = function() {
    // Thrash, waste and sodomy: IE GC bug
    var iframe = documentCreateElement("iframe");
    var JS = "java" + SCRIPT + ":";
    var iframeDocument;
    iframe.style.display = "none";
    html.appendChild(iframe);
    // https://github.com/zloirock/core-js/issues/475
    iframe.src = String(JS);
    iframeDocument = iframe.contentWindow.document;
    iframeDocument.open();
    iframeDocument.write(scriptTag("document.F=Object"));
    iframeDocument.close();
    return iframeDocument.F;
};
// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument;
var NullProtoObject = function() {
    try {
        activeXDocument = new ActiveXObject("htmlfile");
    } catch (error) {}
    NullProtoObject = typeof document != "undefined" ? document.domain && activeXDocument ? NullProtoObjectViaActiveX(activeXDocument) // old IE
     : NullProtoObjectViaIFrame() : NullProtoObjectViaActiveX(activeXDocument); // WSH
    var length = enumBugKeys.length;
    while(length--)delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
    return NullProtoObject();
};
hiddenKeys[IE_PROTO] = true;
// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
module.exports = Object.create || function create(O, Properties) {
    var result;
    if (O !== null) {
        EmptyConstructor[PROTOTYPE] = anObject(O);
        result = new EmptyConstructor();
        EmptyConstructor[PROTOTYPE] = null;
        // add "__proto__" for Object.getPrototypeOf polyfill
        result[IE_PROTO] = O;
    } else result = NullProtoObject();
    return Properties === undefined ? result : defineProperties(result, Properties);
};

},{"3bbe31d8f504111f":"39qAm","a9712f03fc468b49":"gAXUl","d9e0c389f84efa79":"kSeIZ","8a43b6a211717cde":"8A7bE","78d31e3a50d79c6e":"du4gP","e29f7e32a0583f3":"gjZdB","a6edaba97f293fc9":"21CiI"}],"gAXUl":[function(require,module,exports) {
var DESCRIPTORS = require("aa39c539d0a1ec3f");
var definePropertyModule = require("d88f5f00164c2da2");
var anObject = require("12ac356c5e06e57d");
var toIndexedObject = require("3cbdc44082c2f8b8");
var objectKeys = require("634da70e74fce29b");
// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
module.exports = DESCRIPTORS ? Object.defineProperties : function defineProperties(O, Properties) {
    anObject(O);
    var props = toIndexedObject(Properties);
    var keys = objectKeys(Properties);
    var length = keys.length;
    var index = 0;
    var key;
    while(length > index)definePropertyModule.f(O, key = keys[index++], props[key]);
    return O;
};

},{"aa39c539d0a1ec3f":"7Hk5a","d88f5f00164c2da2":"dfAo1","12ac356c5e06e57d":"39qAm","3cbdc44082c2f8b8":"5DeQ5","634da70e74fce29b":"jlCln"}],"jlCln":[function(require,module,exports) {
var internalObjectKeys = require("fb982c683f43ec98");
var enumBugKeys = require("7cabc30df1982d48");
// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
module.exports = Object.keys || function keys(O) {
    return internalObjectKeys(O, enumBugKeys);
};

},{"fb982c683f43ec98":"j7Ows","7cabc30df1982d48":"kSeIZ"}],"du4gP":[function(require,module,exports) {
var getBuiltIn = require("14cb391fa4a0dda8");
module.exports = getBuiltIn("document", "documentElement");

},{"14cb391fa4a0dda8":"bQFzp"}],"58Qnf":[function(require,module,exports) {
var wellKnownSymbol = require("2e34ececd06658d9");
exports.f = wellKnownSymbol;

},{"2e34ececd06658d9":"kbsMI"}],"jltxQ":[function(require,module,exports) {
var path = require("788d21ad2d61305b");
var hasOwn = require("7947c966002af57c");
var wrappedWellKnownSymbolModule = require("531aab59874e3290");
var defineProperty = require("250773b4121a34c2").f;
module.exports = function(NAME) {
    var Symbol = path.Symbol || (path.Symbol = {});
    if (!hasOwn(Symbol, NAME)) defineProperty(Symbol, NAME, {
        value: wrappedWellKnownSymbolModule.f(NAME)
    });
};

},{"788d21ad2d61305b":"duerm","7947c966002af57c":"4SzRl","531aab59874e3290":"58Qnf","250773b4121a34c2":"dfAo1"}],"duerm":[function(require,module,exports) {
var global = require("70f8eb6067a24c7e");
module.exports = global;

},{"70f8eb6067a24c7e":"1GZc4"}],"hVfEJ":[function(require,module,exports) {
var defineProperty = require("93a3d85da48077c").f;
var hasOwn = require("2ebf7179e87d878f");
var wellKnownSymbol = require("5b1eb5d1639e9eb7");
var TO_STRING_TAG = wellKnownSymbol("toStringTag");
module.exports = function(it, TAG, STATIC) {
    if (it && !hasOwn(it = STATIC ? it : it.prototype, TO_STRING_TAG)) defineProperty(it, TO_STRING_TAG, {
        configurable: true,
        value: TAG
    });
};

},{"93a3d85da48077c":"dfAo1","2ebf7179e87d878f":"4SzRl","5b1eb5d1639e9eb7":"kbsMI"}],"g44dN":[function(require,module,exports) {
var bind = require("13e0747865316a42");
var uncurryThis = require("99224cc18a4a792e");
var IndexedObject = require("57aaeabd9d30911");
var toObject = require("3acffc809f3b03fb");
var lengthOfArrayLike = require("1fc4c4e55871562c");
var arraySpeciesCreate = require("76c922b575fbf7bd");
var push = uncurryThis([].push);
// `Array.prototype.{ forEach, map, filter, some, every, find, findIndex, filterReject }` methods implementation
var createMethod = function(TYPE) {
    var IS_MAP = TYPE == 1;
    var IS_FILTER = TYPE == 2;
    var IS_SOME = TYPE == 3;
    var IS_EVERY = TYPE == 4;
    var IS_FIND_INDEX = TYPE == 6;
    var IS_FILTER_REJECT = TYPE == 7;
    var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
    return function($this, callbackfn, that, specificCreate) {
        var O = toObject($this);
        var self = IndexedObject(O);
        var boundFunction = bind(callbackfn, that);
        var length = lengthOfArrayLike(self);
        var index = 0;
        var create = specificCreate || arraySpeciesCreate;
        var target = IS_MAP ? create($this, length) : IS_FILTER || IS_FILTER_REJECT ? create($this, 0) : undefined;
        var value, result;
        for(; length > index; index++)if (NO_HOLES || index in self) {
            value = self[index];
            result = boundFunction(value, index, O);
            if (TYPE) {
                if (IS_MAP) target[index] = result; // map
                else if (result) switch(TYPE){
                    case 3:
                        return true; // some
                    case 5:
                        return value; // find
                    case 6:
                        return index; // findIndex
                    case 2:
                        push(target, value); // filter
                }
                else switch(TYPE){
                    case 4:
                        return false; // every
                    case 7:
                        push(target, value); // filterReject
                }
            }
        }
        return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
    };
};
module.exports = {
    // `Array.prototype.forEach` method
    // https://tc39.es/ecma262/#sec-array.prototype.foreach
    forEach: createMethod(0),
    // `Array.prototype.map` method
    // https://tc39.es/ecma262/#sec-array.prototype.map
    map: createMethod(1),
    // `Array.prototype.filter` method
    // https://tc39.es/ecma262/#sec-array.prototype.filter
    filter: createMethod(2),
    // `Array.prototype.some` method
    // https://tc39.es/ecma262/#sec-array.prototype.some
    some: createMethod(3),
    // `Array.prototype.every` method
    // https://tc39.es/ecma262/#sec-array.prototype.every
    every: createMethod(4),
    // `Array.prototype.find` method
    // https://tc39.es/ecma262/#sec-array.prototype.find
    find: createMethod(5),
    // `Array.prototype.findIndex` method
    // https://tc39.es/ecma262/#sec-array.prototype.findIndex
    findIndex: createMethod(6),
    // `Array.prototype.filterReject` method
    // https://github.com/tc39/proposal-array-filtering
    filterReject: createMethod(7)
};

},{"13e0747865316a42":"lgzZz","99224cc18a4a792e":"fP9tv","57aaeabd9d30911":"8iqJB","3acffc809f3b03fb":"7K2H5","1fc4c4e55871562c":"ckDDq","76c922b575fbf7bd":"5xBSA"}],"lgzZz":[function(require,module,exports) {
var uncurryThis = require("239b95ec6c7aa699");
var aCallable = require("547ee4f9dab0cc76");
var bind = uncurryThis(uncurryThis.bind);
// optional / simple context binding
module.exports = function(fn, that) {
    aCallable(fn);
    return that === undefined ? fn : bind ? bind(fn, that) : function() {
        return fn.apply(that, arguments);
    };
};

},{"239b95ec6c7aa699":"fP9tv","547ee4f9dab0cc76":"keisz"}],"wrlLc":[function(require,module,exports) {
// `Symbol.prototype.description` getter
// https://tc39.es/ecma262/#sec-symbol.prototype.description
"use strict";
var $ = require("97b172d75b2d24d2");
var DESCRIPTORS = require("f4d7d8fd842c0756");
var global = require("aee55f2d7c8a208f");
var uncurryThis = require("3168cbf7cd0b9882");
var hasOwn = require("a16d92d5b8266639");
var isCallable = require("c20ab10c7fc8df3c");
var isPrototypeOf = require("f1577de30367373a");
var toString = require("a801f47d1f3aec6");
var defineProperty = require("34e0c281f711b272").f;
var copyConstructorProperties = require("76bfc13417714c00");
var NativeSymbol = global.Symbol;
var SymbolPrototype = NativeSymbol && NativeSymbol.prototype;
if (DESCRIPTORS && isCallable(NativeSymbol) && (!("description" in SymbolPrototype) || // Safari 12 bug
NativeSymbol().description !== undefined)) {
    var EmptyStringDescriptionStore = {};
    // wrap Symbol constructor for correct work with undefined description
    var SymbolWrapper = function Symbol() {
        var description = arguments.length < 1 || arguments[0] === undefined ? undefined : toString(arguments[0]);
        var result = isPrototypeOf(SymbolPrototype, this) ? new NativeSymbol(description) : description === undefined ? NativeSymbol() : NativeSymbol(description);
        if (description === "") EmptyStringDescriptionStore[result] = true;
        return result;
    };
    copyConstructorProperties(SymbolWrapper, NativeSymbol);
    SymbolWrapper.prototype = SymbolPrototype;
    SymbolPrototype.constructor = SymbolWrapper;
    var NATIVE_SYMBOL = String(NativeSymbol("test")) == "Symbol(test)";
    var symbolToString = uncurryThis(SymbolPrototype.toString);
    var symbolValueOf = uncurryThis(SymbolPrototype.valueOf);
    var regexp = /^Symbol\((.*)\)[^)]+$/;
    var replace = uncurryThis("".replace);
    var stringSlice = uncurryThis("".slice);
    defineProperty(SymbolPrototype, "description", {
        configurable: true,
        get: function description() {
            var symbol = symbolValueOf(this);
            var string = symbolToString(symbol);
            if (hasOwn(EmptyStringDescriptionStore, symbol)) return "";
            var desc = NATIVE_SYMBOL ? stringSlice(string, 7, -1) : replace(string, regexp, "$1");
            return desc === "" ? undefined : desc;
        }
    });
    $({
        global: true,
        forced: true
    }, {
        Symbol: SymbolWrapper
    });
}

},{"97b172d75b2d24d2":"1OO62","f4d7d8fd842c0756":"7Hk5a","aee55f2d7c8a208f":"1GZc4","3168cbf7cd0b9882":"fP9tv","a16d92d5b8266639":"4SzRl","c20ab10c7fc8df3c":"cVxS9","f1577de30367373a":"alXpj","a801f47d1f3aec6":"8RVGu","34e0c281f711b272":"dfAo1","76bfc13417714c00":"2kpr2"}],"fhNIb":[function(require,module,exports) {
var defineWellKnownSymbol = require("921b782e73ec95cc");
// `Symbol.iterator` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.iterator
defineWellKnownSymbol("iterator");

},{"921b782e73ec95cc":"jltxQ"}],"9UCQw":[function(require,module,exports) {
var $ = require("76f1b3b688a029fa");
var from = require("55358907c05b685d");
var checkCorrectnessOfIteration = require("98fd99047e51c8be");
var INCORRECT_ITERATION = !checkCorrectnessOfIteration(function(iterable) {
    // eslint-disable-next-line es/no-array-from -- required for testing
    Array.from(iterable);
});
// `Array.from` method
// https://tc39.es/ecma262/#sec-array.from
$({
    target: "Array",
    stat: true,
    forced: INCORRECT_ITERATION
}, {
    from: from
});

},{"76f1b3b688a029fa":"1OO62","55358907c05b685d":"2sB7j","98fd99047e51c8be":"gUryt"}],"2sB7j":[function(require,module,exports) {
"use strict";
var global = require("302a3c6d60374e70");
var bind = require("c006aee3ec90867f");
var call = require("bdaed06b86eeb767");
var toObject = require("ca05db7523b31410");
var callWithSafeIterationClosing = require("47fe223c8f6c2dd5");
var isArrayIteratorMethod = require("75eba7673a242ae6");
var isConstructor = require("188dc0b37c140076");
var lengthOfArrayLike = require("32c4effc8b33b2c2");
var createProperty = require("a6ed280c439df9d0");
var getIterator = require("3faaa09a63a90825");
var getIteratorMethod = require("13cbec27e4dd055f");
var Array = global.Array;
// `Array.from` method implementation
// https://tc39.es/ecma262/#sec-array.from
module.exports = function from(arrayLike /* , mapfn = undefined, thisArg = undefined */ ) {
    var O = toObject(arrayLike);
    var IS_CONSTRUCTOR = isConstructor(this);
    var argumentsLength = arguments.length;
    var mapfn = argumentsLength > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    if (mapping) mapfn = bind(mapfn, argumentsLength > 2 ? arguments[2] : undefined);
    var iteratorMethod = getIteratorMethod(O);
    var index = 0;
    var length, result, step, iterator, next, value;
    // if the target is not iterable or it's an array with the default iterator - use a simple case
    if (iteratorMethod && !(this == Array && isArrayIteratorMethod(iteratorMethod))) {
        iterator = getIterator(O, iteratorMethod);
        next = iterator.next;
        result = IS_CONSTRUCTOR ? new this() : [];
        for(; !(step = call(next, iterator)).done; index++){
            value = mapping ? callWithSafeIterationClosing(iterator, mapfn, [
                step.value,
                index
            ], true) : step.value;
            createProperty(result, index, value);
        }
    } else {
        length = lengthOfArrayLike(O);
        result = IS_CONSTRUCTOR ? new this(length) : Array(length);
        for(; length > index; index++){
            value = mapping ? mapfn(O[index], index) : O[index];
            createProperty(result, index, value);
        }
    }
    result.length = index;
    return result;
};

},{"302a3c6d60374e70":"1GZc4","c006aee3ec90867f":"lgzZz","bdaed06b86eeb767":"aSvFj","ca05db7523b31410":"7K2H5","47fe223c8f6c2dd5":"i5iul","75eba7673a242ae6":"f0dsD","188dc0b37c140076":"9K6ap","32c4effc8b33b2c2":"ckDDq","a6ed280c439df9d0":"3yb4H","3faaa09a63a90825":"53wfg","13cbec27e4dd055f":"erPau"}],"i5iul":[function(require,module,exports) {
var anObject = require("4afbb4be48dcf066");
var iteratorClose = require("d24fa1ffea48fa52");
// call something on iterator step with safe closing on error
module.exports = function(iterator, fn, value, ENTRIES) {
    try {
        return ENTRIES ? fn(anObject(value)[0], value[1]) : fn(value);
    } catch (error) {
        iteratorClose(iterator, "throw", error);
    }
};

},{"4afbb4be48dcf066":"39qAm","d24fa1ffea48fa52":"6kSRS"}],"6kSRS":[function(require,module,exports) {
var call = require("a4a3a7d4a45c4219");
var anObject = require("feb876e7da2df7bd");
var getMethod = require("2e660cdfabd9c61f");
module.exports = function(iterator, kind, value) {
    var innerResult, innerError;
    anObject(iterator);
    try {
        innerResult = getMethod(iterator, "return");
        if (!innerResult) {
            if (kind === "throw") throw value;
            return value;
        }
        innerResult = call(innerResult, iterator);
    } catch (error) {
        innerError = true;
        innerResult = error;
    }
    if (kind === "throw") throw value;
    if (innerError) throw innerResult;
    anObject(innerResult);
    return value;
};

},{"a4a3a7d4a45c4219":"aSvFj","feb876e7da2df7bd":"39qAm","2e660cdfabd9c61f":"llxIw"}],"f0dsD":[function(require,module,exports) {
var wellKnownSymbol = require("85b004b6ab4bc5da");
var Iterators = require("6de391ad2976ca02");
var ITERATOR = wellKnownSymbol("iterator");
var ArrayPrototype = Array.prototype;
// check on default Array iterator
module.exports = function(it) {
    return it !== undefined && (Iterators.Array === it || ArrayPrototype[ITERATOR] === it);
};

},{"85b004b6ab4bc5da":"kbsMI","6de391ad2976ca02":"dht0b"}],"dht0b":[function(require,module,exports) {
module.exports = {};

},{}],"53wfg":[function(require,module,exports) {
var global = require("7e1ab5bd996be12b");
var call = require("132ebf774107ae29");
var aCallable = require("e248489b4825ceb7");
var anObject = require("18a343d2ef625577");
var tryToString = require("7e576a1564cef99e");
var getIteratorMethod = require("4a7b0311be0471b2");
var TypeError = global.TypeError;
module.exports = function(argument, usingIterator) {
    var iteratorMethod = arguments.length < 2 ? getIteratorMethod(argument) : usingIterator;
    if (aCallable(iteratorMethod)) return anObject(call(iteratorMethod, argument));
    throw TypeError(tryToString(argument) + " is not iterable");
};

},{"7e1ab5bd996be12b":"1GZc4","132ebf774107ae29":"aSvFj","e248489b4825ceb7":"keisz","18a343d2ef625577":"39qAm","7e576a1564cef99e":"1vkHL","4a7b0311be0471b2":"erPau"}],"erPau":[function(require,module,exports) {
var classof = require("32d61dafd81dde78");
var getMethod = require("84e24a6ac7559d3a");
var Iterators = require("1c181d5c49efd5d1");
var wellKnownSymbol = require("d10d0e0ae49498c5");
var ITERATOR = wellKnownSymbol("iterator");
module.exports = function(it) {
    if (it != undefined) return getMethod(it, ITERATOR) || getMethod(it, "@@iterator") || Iterators[classof(it)];
};

},{"32d61dafd81dde78":"7lOdl","84e24a6ac7559d3a":"llxIw","1c181d5c49efd5d1":"dht0b","d10d0e0ae49498c5":"kbsMI"}],"gUryt":[function(require,module,exports) {
var wellKnownSymbol = require("a5154de5c7fcf21e");
var ITERATOR = wellKnownSymbol("iterator");
var SAFE_CLOSING = false;
try {
    var called = 0;
    var iteratorWithReturn = {
        next: function() {
            return {
                done: !!called++
            };
        },
        "return": function() {
            SAFE_CLOSING = true;
        }
    };
    iteratorWithReturn[ITERATOR] = function() {
        return this;
    };
    // eslint-disable-next-line es/no-array-from, no-throw-literal -- required for testing
    Array.from(iteratorWithReturn, function() {
        throw 2;
    });
} catch (error) {}
module.exports = function(exec, SKIP_CLOSING) {
    if (!SKIP_CLOSING && !SAFE_CLOSING) return false;
    var ITERATION_SUPPORT = false;
    try {
        var object = {};
        object[ITERATOR] = function() {
            return {
                next: function() {
                    return {
                        done: ITERATION_SUPPORT = true
                    };
                }
            };
        };
        exec(object);
    } catch (error) {}
    return ITERATION_SUPPORT;
};

},{"a5154de5c7fcf21e":"kbsMI"}],"5q56v":[function(require,module,exports) {
"use strict";
var $ = require("72ba4de9841213e");
var exec = require("d4ebaff1663cc5b9");
// `RegExp.prototype.exec` method
// https://tc39.es/ecma262/#sec-regexp.prototype.exec
$({
    target: "RegExp",
    proto: true,
    forced: /./.exec !== exec
}, {
    exec: exec
});

},{"72ba4de9841213e":"1OO62","d4ebaff1663cc5b9":"7hxGn"}],"7hxGn":[function(require,module,exports) {
"use strict";
/* eslint-disable regexp/no-empty-capturing-group, regexp/no-empty-group, regexp/no-lazy-ends -- testing */ /* eslint-disable regexp/no-useless-quantifier -- testing */ var call = require("698f504b4733b02d");
var uncurryThis = require("6d0d2df39383a10b");
var toString = require("382af5492ddc18e6");
var regexpFlags = require("96e0244464229d3");
var stickyHelpers = require("3bd1d72d4987e0ff");
var shared = require("12c3e6e355312395");
var create = require("38d060dff8e4ab54");
var getInternalState = require("aec1e11e2cd92d19").get;
var UNSUPPORTED_DOT_ALL = require("7d9db6b4177b833a");
var UNSUPPORTED_NCG = require("b26a8ca5152d0a8d");
var nativeReplace = shared("native-string-replace", String.prototype.replace);
var nativeExec = RegExp.prototype.exec;
var patchedExec = nativeExec;
var charAt = uncurryThis("".charAt);
var indexOf = uncurryThis("".indexOf);
var replace = uncurryThis("".replace);
var stringSlice = uncurryThis("".slice);
var UPDATES_LAST_INDEX_WRONG = function() {
    var re1 = /a/;
    var re2 = /b*/g;
    call(nativeExec, re1, "a");
    call(nativeExec, re2, "a");
    return re1.lastIndex !== 0 || re2.lastIndex !== 0;
}();
var UNSUPPORTED_Y = stickyHelpers.UNSUPPORTED_Y || stickyHelpers.BROKEN_CARET;
// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec("")[1] !== undefined;
var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED || UNSUPPORTED_Y || UNSUPPORTED_DOT_ALL || UNSUPPORTED_NCG;
if (PATCH) // eslint-disable-next-line max-statements -- TODO
patchedExec = function exec(string) {
    var re = this;
    var state = getInternalState(re);
    var str = toString(string);
    var raw = state.raw;
    var result, reCopy, lastIndex, match, i, object, group;
    if (raw) {
        raw.lastIndex = re.lastIndex;
        result = call(patchedExec, raw, str);
        re.lastIndex = raw.lastIndex;
        return result;
    }
    var groups = state.groups;
    var sticky = UNSUPPORTED_Y && re.sticky;
    var flags = call(regexpFlags, re);
    var source = re.source;
    var charsAdded = 0;
    var strCopy = str;
    if (sticky) {
        flags = replace(flags, "y", "");
        if (indexOf(flags, "g") === -1) flags += "g";
        strCopy = stringSlice(str, re.lastIndex);
        // Support anchored sticky behavior.
        if (re.lastIndex > 0 && (!re.multiline || re.multiline && charAt(str, re.lastIndex - 1) !== "\n")) {
            source = "(?: " + source + ")";
            strCopy = " " + strCopy;
            charsAdded++;
        }
        // ^(? + rx + ) is needed, in combination with some str slicing, to
        // simulate the 'y' flag.
        reCopy = new RegExp("^(?:" + source + ")", flags);
    }
    if (NPCG_INCLUDED) reCopy = new RegExp("^" + source + "$(?!\\s)", flags);
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re.lastIndex;
    match = call(nativeExec, sticky ? reCopy : re, strCopy);
    if (sticky) {
        if (match) {
            match.input = stringSlice(match.input, charsAdded);
            match[0] = stringSlice(match[0], charsAdded);
            match.index = re.lastIndex;
            re.lastIndex += match[0].length;
        } else re.lastIndex = 0;
    } else if (UPDATES_LAST_INDEX_WRONG && match) re.lastIndex = re.global ? match.index + match[0].length : lastIndex;
    if (NPCG_INCLUDED && match && match.length > 1) // Fix browsers whose `exec` methods don't consistently return `undefined`
    // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
    call(nativeReplace, match[0], reCopy, function() {
        for(i = 1; i < arguments.length - 2; i++)if (arguments[i] === undefined) match[i] = undefined;
    });
    if (match && groups) {
        match.groups = object = create(null);
        for(i = 0; i < groups.length; i++){
            group = groups[i];
            object[group[0]] = match[group[1]];
        }
    }
    return match;
};
module.exports = patchedExec;

},{"698f504b4733b02d":"aSvFj","6d0d2df39383a10b":"fP9tv","382af5492ddc18e6":"8RVGu","96e0244464229d3":"iHyxB","3bd1d72d4987e0ff":"4L3h6","12c3e6e355312395":"adVFA","38d060dff8e4ab54":"dgTGU","aec1e11e2cd92d19":"bRWxa","7d9db6b4177b833a":"5q7zq","b26a8ca5152d0a8d":"jdKB6"}],"iHyxB":[function(require,module,exports) {
"use strict";
var anObject = require("136abace0aec2b5c");
// `RegExp.prototype.flags` getter implementation
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
module.exports = function() {
    var that = anObject(this);
    var result = "";
    if (that.global) result += "g";
    if (that.ignoreCase) result += "i";
    if (that.multiline) result += "m";
    if (that.dotAll) result += "s";
    if (that.unicode) result += "u";
    if (that.sticky) result += "y";
    return result;
};

},{"136abace0aec2b5c":"39qAm"}],"4L3h6":[function(require,module,exports) {
var fails = require("797bef35e651cb5e");
var global = require("89bc0b5a5d5c9f99");
// babel-minify and Closure Compiler transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError
var $RegExp = global.RegExp;
exports.UNSUPPORTED_Y = fails(function() {
    var re = $RegExp("a", "y");
    re.lastIndex = 2;
    return re.exec("abcd") != null;
});
exports.BROKEN_CARET = fails(function() {
    // https://bugzilla.mozilla.org/show_bug.cgi?id=773687
    var re = $RegExp("^r", "gy");
    re.lastIndex = 2;
    return re.exec("str") != null;
});

},{"797bef35e651cb5e":"keKlS","89bc0b5a5d5c9f99":"1GZc4"}],"5q7zq":[function(require,module,exports) {
var fails = require("e4784e58ea762065");
var global = require("16fc714d526e0528");
// babel-minify and Closure Compiler transpiles RegExp('.', 's') -> /./s and it causes SyntaxError
var $RegExp = global.RegExp;
module.exports = fails(function() {
    var re = $RegExp(".", "s");
    return !(re.dotAll && re.exec("\n") && re.flags === "s");
});

},{"e4784e58ea762065":"keKlS","16fc714d526e0528":"1GZc4"}],"jdKB6":[function(require,module,exports) {
var fails = require("b9b1a0fbdd999ded");
var global = require("504ba50ed83b9e32");
// babel-minify and Closure Compiler transpiles RegExp('(?<a>b)', 'g') -> /(?<a>b)/g and it causes SyntaxError
var $RegExp = global.RegExp;
module.exports = fails(function() {
    var re = $RegExp("(?<a>b)", "g");
    return re.exec("b").groups.a !== "b" || "b".replace(re, "$<a>c") !== "bc";
});

},{"b9b1a0fbdd999ded":"keKlS","504ba50ed83b9e32":"1GZc4"}],"ieU20":[function(require,module,exports) {
"use strict";
var toIndexedObject = require("c8e067881939a0cb");
var addToUnscopables = require("275b8f0cb65b77aa");
var Iterators = require("21f4d3653c90f049");
var InternalStateModule = require("85efa8d5848315f6");
var defineIterator = require("4f5a5e5c03ba941b");
var ARRAY_ITERATOR = "Array Iterator";
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(ARRAY_ITERATOR);
// `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator
module.exports = defineIterator(Array, "Array", function(iterated, kind) {
    setInternalState(this, {
        type: ARRAY_ITERATOR,
        target: toIndexedObject(iterated),
        index: 0,
        kind: kind // kind
    });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
}, function() {
    var state = getInternalState(this);
    var target = state.target;
    var kind = state.kind;
    var index = state.index++;
    if (!target || index >= target.length) {
        state.target = undefined;
        return {
            value: undefined,
            done: true
        };
    }
    if (kind == "keys") return {
        value: index,
        done: false
    };
    if (kind == "values") return {
        value: target[index],
        done: false
    };
    return {
        value: [
            index,
            target[index]
        ],
        done: false
    };
}, "values");
// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
// https://tc39.es/ecma262/#sec-createmappedargumentsobject
Iterators.Arguments = Iterators.Array;
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables("keys");
addToUnscopables("values");
addToUnscopables("entries");

},{"c8e067881939a0cb":"5DeQ5","275b8f0cb65b77aa":"cszY9","21f4d3653c90f049":"dht0b","85efa8d5848315f6":"bRWxa","4f5a5e5c03ba941b":"kELHa"}],"cszY9":[function(require,module,exports) {
var wellKnownSymbol = require("d4032cdcc50314e7");
var create = require("3ca2a6909ac2dcef");
var definePropertyModule = require("545ab457bf71d338");
var UNSCOPABLES = wellKnownSymbol("unscopables");
var ArrayPrototype = Array.prototype;
// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if (ArrayPrototype[UNSCOPABLES] == undefined) definePropertyModule.f(ArrayPrototype, UNSCOPABLES, {
    configurable: true,
    value: create(null)
});
// add a key to Array.prototype[@@unscopables]
module.exports = function(key) {
    ArrayPrototype[UNSCOPABLES][key] = true;
};

},{"d4032cdcc50314e7":"kbsMI","3ca2a6909ac2dcef":"dgTGU","545ab457bf71d338":"dfAo1"}],"kELHa":[function(require,module,exports) {
"use strict";
var $ = require("50a096e95a4668f1");
var call = require("5033f15b9ad3f3a7");
var IS_PURE = require("4b8aa334ea87a4fa");
var FunctionName = require("873642ec42e688c");
var isCallable = require("c5c52a34306c7611");
var createIteratorConstructor = require("bee2d4910f40c506");
var getPrototypeOf = require("be6ec4edf1fce477");
var setPrototypeOf = require("83f63730d1e83c51");
var setToStringTag = require("55fa758c9f80e891");
var createNonEnumerableProperty = require("b86898c7e026931f");
var redefine = require("4030cdf312bc60b");
var wellKnownSymbol = require("763cd6d936dad871");
var Iterators = require("49d3afc9d310bb48");
var IteratorsCore = require("b200b233c8a081ad");
var PROPER_FUNCTION_NAME = FunctionName.PROPER;
var CONFIGURABLE_FUNCTION_NAME = FunctionName.CONFIGURABLE;
var IteratorPrototype = IteratorsCore.IteratorPrototype;
var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
var ITERATOR = wellKnownSymbol("iterator");
var KEYS = "keys";
var VALUES = "values";
var ENTRIES = "entries";
var returnThis = function() {
    return this;
};
module.exports = function(Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
    createIteratorConstructor(IteratorConstructor, NAME, next);
    var getIterationMethod = function(KIND) {
        if (KIND === DEFAULT && defaultIterator) return defaultIterator;
        if (!BUGGY_SAFARI_ITERATORS && KIND in IterablePrototype) return IterablePrototype[KIND];
        switch(KIND){
            case KEYS:
                return function keys() {
                    return new IteratorConstructor(this, KIND);
                };
            case VALUES:
                return function values() {
                    return new IteratorConstructor(this, KIND);
                };
            case ENTRIES:
                return function entries() {
                    return new IteratorConstructor(this, KIND);
                };
        }
        return function() {
            return new IteratorConstructor(this);
        };
    };
    var TO_STRING_TAG = NAME + " Iterator";
    var INCORRECT_VALUES_NAME = false;
    var IterablePrototype = Iterable.prototype;
    var nativeIterator = IterablePrototype[ITERATOR] || IterablePrototype["@@iterator"] || DEFAULT && IterablePrototype[DEFAULT];
    var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
    var anyNativeIterator = NAME == "Array" ? IterablePrototype.entries || nativeIterator : nativeIterator;
    var CurrentIteratorPrototype, methods, KEY;
    // fix native
    if (anyNativeIterator) {
        CurrentIteratorPrototype = getPrototypeOf(anyNativeIterator.call(new Iterable()));
        if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
            if (!IS_PURE && getPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype) {
                if (setPrototypeOf) setPrototypeOf(CurrentIteratorPrototype, IteratorPrototype);
                else if (!isCallable(CurrentIteratorPrototype[ITERATOR])) redefine(CurrentIteratorPrototype, ITERATOR, returnThis);
            }
            // Set @@toStringTag to native iterators
            setToStringTag(CurrentIteratorPrototype, TO_STRING_TAG, true, true);
            if (IS_PURE) Iterators[TO_STRING_TAG] = returnThis;
        }
    }
    // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
    if (PROPER_FUNCTION_NAME && DEFAULT == VALUES && nativeIterator && nativeIterator.name !== VALUES) {
        if (!IS_PURE && CONFIGURABLE_FUNCTION_NAME) createNonEnumerableProperty(IterablePrototype, "name", VALUES);
        else {
            INCORRECT_VALUES_NAME = true;
            defaultIterator = function values() {
                return call(nativeIterator, this);
            };
        }
    }
    // export additional methods
    if (DEFAULT) {
        methods = {
            values: getIterationMethod(VALUES),
            keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
            entries: getIterationMethod(ENTRIES)
        };
        if (FORCED) {
            for(KEY in methods)if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) redefine(IterablePrototype, KEY, methods[KEY]);
        } else $({
            target: NAME,
            proto: true,
            forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME
        }, methods);
    }
    // define iterator
    if ((!IS_PURE || FORCED) && IterablePrototype[ITERATOR] !== defaultIterator) redefine(IterablePrototype, ITERATOR, defaultIterator, {
        name: DEFAULT
    });
    Iterators[NAME] = defaultIterator;
    return methods;
};

},{"50a096e95a4668f1":"1OO62","5033f15b9ad3f3a7":"aSvFj","4b8aa334ea87a4fa":"bZbjq","873642ec42e688c":"5TtMA","c5c52a34306c7611":"cVxS9","bee2d4910f40c506":"3eP5G","be6ec4edf1fce477":"gkVld","83f63730d1e83c51":"hT4Io","55fa758c9f80e891":"hVfEJ","b86898c7e026931f":"hol1i","4030cdf312bc60b":"3ncOy","763cd6d936dad871":"kbsMI","49d3afc9d310bb48":"dht0b","b200b233c8a081ad":"ghDDG"}],"3eP5G":[function(require,module,exports) {
"use strict";
var IteratorPrototype = require("b7a148491de7fe49").IteratorPrototype;
var create = require("1e205d6dc45b099b");
var createPropertyDescriptor = require("130facb7f03758e7");
var setToStringTag = require("8ab53435ec60d24c");
var Iterators = require("117fdd68a91a54ab");
var returnThis = function() {
    return this;
};
module.exports = function(IteratorConstructor, NAME, next) {
    var TO_STRING_TAG = NAME + " Iterator";
    IteratorConstructor.prototype = create(IteratorPrototype, {
        next: createPropertyDescriptor(1, next)
    });
    setToStringTag(IteratorConstructor, TO_STRING_TAG, false, true);
    Iterators[TO_STRING_TAG] = returnThis;
    return IteratorConstructor;
};

},{"b7a148491de7fe49":"ghDDG","1e205d6dc45b099b":"dgTGU","130facb7f03758e7":"81es4","8ab53435ec60d24c":"hVfEJ","117fdd68a91a54ab":"dht0b"}],"ghDDG":[function(require,module,exports) {
"use strict";
var fails = require("cdb9dcd93b52b3fc");
var isCallable = require("db955145706fc55a");
var create = require("45d6f1a3c372cdf6");
var getPrototypeOf = require("a97459767d74fdc3");
var redefine = require("470fbda3d026463f");
var wellKnownSymbol = require("d3901e60df7842c9");
var IS_PURE = require("e736fd193ddc96e5");
var ITERATOR = wellKnownSymbol("iterator");
var BUGGY_SAFARI_ITERATORS = false;
// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var IteratorPrototype, PrototypeOfArrayIteratorPrototype, arrayIterator;
/* eslint-disable es/no-array-prototype-keys -- safe */ if ([].keys) {
    arrayIterator = [].keys();
    // Safari 8 has buggy iterators w/o `next`
    if (!("next" in arrayIterator)) BUGGY_SAFARI_ITERATORS = true;
    else {
        PrototypeOfArrayIteratorPrototype = getPrototypeOf(getPrototypeOf(arrayIterator));
        if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype = PrototypeOfArrayIteratorPrototype;
    }
}
var NEW_ITERATOR_PROTOTYPE = IteratorPrototype == undefined || fails(function() {
    var test = {};
    // FF44- legacy iterators case
    return IteratorPrototype[ITERATOR].call(test) !== test;
});
if (NEW_ITERATOR_PROTOTYPE) IteratorPrototype = {};
else if (IS_PURE) IteratorPrototype = create(IteratorPrototype);
// `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
if (!isCallable(IteratorPrototype[ITERATOR])) redefine(IteratorPrototype, ITERATOR, function() {
    return this;
});
module.exports = {
    IteratorPrototype: IteratorPrototype,
    BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS
};

},{"cdb9dcd93b52b3fc":"keKlS","db955145706fc55a":"cVxS9","45d6f1a3c372cdf6":"dgTGU","a97459767d74fdc3":"gkVld","470fbda3d026463f":"3ncOy","d3901e60df7842c9":"kbsMI","e736fd193ddc96e5":"bZbjq"}],"gkVld":[function(require,module,exports) {
var global = require("1b0dd3ba934788a6");
var hasOwn = require("da54a59ea207dd");
var isCallable = require("71ab2a7bcc8c8fc8");
var toObject = require("7a3afd2bb40b0292");
var sharedKey = require("296d7a2db8e23969");
var CORRECT_PROTOTYPE_GETTER = require("58de29d5e883862f");
var IE_PROTO = sharedKey("IE_PROTO");
var Object = global.Object;
var ObjectPrototype = Object.prototype;
// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
module.exports = CORRECT_PROTOTYPE_GETTER ? Object.getPrototypeOf : function(O) {
    var object = toObject(O);
    if (hasOwn(object, IE_PROTO)) return object[IE_PROTO];
    var constructor = object.constructor;
    if (isCallable(constructor) && object instanceof constructor) return constructor.prototype;
    return object instanceof Object ? ObjectPrototype : null;
};

},{"1b0dd3ba934788a6":"1GZc4","da54a59ea207dd":"4SzRl","71ab2a7bcc8c8fc8":"cVxS9","7a3afd2bb40b0292":"7K2H5","296d7a2db8e23969":"21CiI","58de29d5e883862f":"2faqz"}],"2faqz":[function(require,module,exports) {
var fails = require("85ffc28af2e8afc1");
module.exports = !fails(function() {
    function F() {}
    F.prototype.constructor = null;
    // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
    return Object.getPrototypeOf(new F()) !== F.prototype;
});

},{"85ffc28af2e8afc1":"keKlS"}],"hT4Io":[function(require,module,exports) {
/* eslint-disable no-proto -- safe */ var uncurryThis = require("dfcb44c83125348b");
var anObject = require("4b49e5767d221547");
var aPossiblePrototype = require("6e2c833ee2a62cf6");
// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe
module.exports = Object.setPrototypeOf || ("__proto__" in {} ? function() {
    var CORRECT_SETTER = false;
    var test = {};
    var setter;
    try {
        // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
        setter = uncurryThis(Object.getOwnPropertyDescriptor(Object.prototype, "__proto__").set);
        setter(test, []);
        CORRECT_SETTER = test instanceof Array;
    } catch (error) {}
    return function setPrototypeOf(O, proto) {
        anObject(O);
        aPossiblePrototype(proto);
        if (CORRECT_SETTER) setter(O, proto);
        else O.__proto__ = proto;
        return O;
    };
}() : undefined);

},{"dfcb44c83125348b":"fP9tv","4b49e5767d221547":"39qAm","6e2c833ee2a62cf6":"2ZWcC"}],"2ZWcC":[function(require,module,exports) {
var global = require("4499bc835f3e8d45");
var isCallable = require("9a88d96c5b428ce5");
var String = global.String;
var TypeError = global.TypeError;
module.exports = function(argument) {
    if (typeof argument == "object" || isCallable(argument)) return argument;
    throw TypeError("Can't set " + String(argument) + " as a prototype");
};

},{"4499bc835f3e8d45":"1GZc4","9a88d96c5b428ce5":"cVxS9"}],"lsA9p":[function(require,module,exports) {
var TO_STRING_TAG_SUPPORT = require("2f5378debd330ed5");
var redefine = require("705b4386fd2c004");
var toString = require("6b32f4accffdcba8");
// `Object.prototype.toString` method
// https://tc39.es/ecma262/#sec-object.prototype.tostring
if (!TO_STRING_TAG_SUPPORT) redefine(Object.prototype, "toString", toString, {
    unsafe: true
});

},{"2f5378debd330ed5":"a8Dmu","705b4386fd2c004":"3ncOy","6b32f4accffdcba8":"1gUse"}],"1gUse":[function(require,module,exports) {
"use strict";
var TO_STRING_TAG_SUPPORT = require("312e54676af41375");
var classof = require("2dbce13c946fe9d0");
// `Object.prototype.toString` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.tostring
module.exports = TO_STRING_TAG_SUPPORT ? ({}).toString : function toString() {
    return "[object " + classof(this) + "]";
};

},{"312e54676af41375":"a8Dmu","2dbce13c946fe9d0":"7lOdl"}],"6FW6g":[function(require,module,exports) {
"use strict";
var collection = require("79ac49cb605128bd");
var collectionStrong = require("96fdfea8bf42b7de");
// `Set` constructor
// https://tc39.es/ecma262/#sec-set-objects
collection("Set", function(init) {
    return function Set() {
        return init(this, arguments.length ? arguments[0] : undefined);
    };
}, collectionStrong);

},{"79ac49cb605128bd":"755XO","96fdfea8bf42b7de":"3WOKt"}],"755XO":[function(require,module,exports) {
"use strict";
var $ = require("7f7d2ffaf036b70c");
var global = require("8d3df9788dccd036");
var uncurryThis = require("58d7b96f0152237");
var isForced = require("30876c2e1f5df872");
var redefine = require("cede3f8c7625abac");
var InternalMetadataModule = require("6163d338080ca134");
var iterate = require("f05c3889843e7603");
var anInstance = require("38cbb680894f59a3");
var isCallable = require("799d274b4fe226e7");
var isObject = require("9e3db26fb26723ec");
var fails = require("f5cb548db0e3391e");
var checkCorrectnessOfIteration = require("80e8f5144d6954d9");
var setToStringTag = require("4fbd135f98af11c4");
var inheritIfRequired = require("585a6aeda8432eb3");
module.exports = function(CONSTRUCTOR_NAME, wrapper, common) {
    var IS_MAP = CONSTRUCTOR_NAME.indexOf("Map") !== -1;
    var IS_WEAK = CONSTRUCTOR_NAME.indexOf("Weak") !== -1;
    var ADDER = IS_MAP ? "set" : "add";
    var NativeConstructor = global[CONSTRUCTOR_NAME];
    var NativePrototype = NativeConstructor && NativeConstructor.prototype;
    var Constructor = NativeConstructor;
    var exported = {};
    var fixMethod = function(KEY) {
        var uncurriedNativeMethod = uncurryThis(NativePrototype[KEY]);
        redefine(NativePrototype, KEY, KEY == "add" ? function add(value) {
            uncurriedNativeMethod(this, value === 0 ? 0 : value);
            return this;
        } : KEY == "delete" ? function(key) {
            return IS_WEAK && !isObject(key) ? false : uncurriedNativeMethod(this, key === 0 ? 0 : key);
        } : KEY == "get" ? function get(key) {
            return IS_WEAK && !isObject(key) ? undefined : uncurriedNativeMethod(this, key === 0 ? 0 : key);
        } : KEY == "has" ? function has(key) {
            return IS_WEAK && !isObject(key) ? false : uncurriedNativeMethod(this, key === 0 ? 0 : key);
        } : function set(key, value) {
            uncurriedNativeMethod(this, key === 0 ? 0 : key, value);
            return this;
        });
    };
    var REPLACE = isForced(CONSTRUCTOR_NAME, !isCallable(NativeConstructor) || !(IS_WEAK || NativePrototype.forEach && !fails(function() {
        new NativeConstructor().entries().next();
    })));
    if (REPLACE) {
        // create collection constructor
        Constructor = common.getConstructor(wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER);
        InternalMetadataModule.enable();
    } else if (isForced(CONSTRUCTOR_NAME, true)) {
        var instance = new Constructor();
        // early implementations not supports chaining
        var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
        // V8 ~ Chromium 40- weak-collections throws on primitives, but should return false
        var THROWS_ON_PRIMITIVES = fails(function() {
            instance.has(1);
        });
        // most early implementations doesn't supports iterables, most modern - not close it correctly
        // eslint-disable-next-line no-new -- required for testing
        var ACCEPT_ITERABLES = checkCorrectnessOfIteration(function(iterable) {
            new NativeConstructor(iterable);
        });
        // for early implementations -0 and +0 not the same
        var BUGGY_ZERO = !IS_WEAK && fails(function() {
            // V8 ~ Chromium 42- fails only with 5+ elements
            var $instance = new NativeConstructor();
            var index = 5;
            while(index--)$instance[ADDER](index, index);
            return !$instance.has(-0);
        });
        if (!ACCEPT_ITERABLES) {
            Constructor = wrapper(function(dummy, iterable) {
                anInstance(dummy, NativePrototype);
                var that = inheritIfRequired(new NativeConstructor(), dummy, Constructor);
                if (iterable != undefined) iterate(iterable, that[ADDER], {
                    that: that,
                    AS_ENTRIES: IS_MAP
                });
                return that;
            });
            Constructor.prototype = NativePrototype;
            NativePrototype.constructor = Constructor;
        }
        if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
            fixMethod("delete");
            fixMethod("has");
            IS_MAP && fixMethod("get");
        }
        if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
        // weak collections should not contains .clear method
        if (IS_WEAK && NativePrototype.clear) delete NativePrototype.clear;
    }
    exported[CONSTRUCTOR_NAME] = Constructor;
    $({
        global: true,
        forced: Constructor != NativeConstructor
    }, exported);
    setToStringTag(Constructor, CONSTRUCTOR_NAME);
    if (!IS_WEAK) common.setStrong(Constructor, CONSTRUCTOR_NAME, IS_MAP);
    return Constructor;
};

},{"7f7d2ffaf036b70c":"1OO62","8d3df9788dccd036":"1GZc4","58d7b96f0152237":"fP9tv","30876c2e1f5df872":"j3Sfj","cede3f8c7625abac":"3ncOy","6163d338080ca134":"55X03","f05c3889843e7603":"9EwlZ","38cbb680894f59a3":"kZWyK","799d274b4fe226e7":"cVxS9","9e3db26fb26723ec":"bprny","f5cb548db0e3391e":"keKlS","80e8f5144d6954d9":"gUryt","4fbd135f98af11c4":"hVfEJ","585a6aeda8432eb3":"dlT8V"}],"9EwlZ":[function(require,module,exports) {
var global = require("e7034932381ce11e");
var bind = require("2f267ed50e670495");
var call = require("c0af58bb1ef1cc62");
var anObject = require("7fa6542c03ca9239");
var tryToString = require("fa596d1a4c07b72a");
var isArrayIteratorMethod = require("fd753cc641a6f10a");
var lengthOfArrayLike = require("2a15dee148d3db96");
var isPrototypeOf = require("417f9a13deeb58a6");
var getIterator = require("43af53be1b24dae5");
var getIteratorMethod = require("bf7ad32b21aed0b4");
var iteratorClose = require("5241389e1d6eeb73");
var TypeError = global.TypeError;
var Result = function(stopped, result) {
    this.stopped = stopped;
    this.result = result;
};
var ResultPrototype = Result.prototype;
module.exports = function(iterable, unboundFunction, options) {
    var that = options && options.that;
    var AS_ENTRIES = !!(options && options.AS_ENTRIES);
    var IS_ITERATOR = !!(options && options.IS_ITERATOR);
    var INTERRUPTED = !!(options && options.INTERRUPTED);
    var fn = bind(unboundFunction, that);
    var iterator, iterFn, index, length, result, next, step;
    var stop = function(condition) {
        if (iterator) iteratorClose(iterator, "normal", condition);
        return new Result(true, condition);
    };
    var callFn = function(value) {
        if (AS_ENTRIES) {
            anObject(value);
            return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
        }
        return INTERRUPTED ? fn(value, stop) : fn(value);
    };
    if (IS_ITERATOR) iterator = iterable;
    else {
        iterFn = getIteratorMethod(iterable);
        if (!iterFn) throw TypeError(tryToString(iterable) + " is not iterable");
        // optimisation for array iterators
        if (isArrayIteratorMethod(iterFn)) {
            for(index = 0, length = lengthOfArrayLike(iterable); length > index; index++){
                result = callFn(iterable[index]);
                if (result && isPrototypeOf(ResultPrototype, result)) return result;
            }
            return new Result(false);
        }
        iterator = getIterator(iterable, iterFn);
    }
    next = iterator.next;
    while(!(step = call(next, iterator)).done){
        try {
            result = callFn(step.value);
        } catch (error) {
            iteratorClose(iterator, "throw", error);
        }
        if (typeof result == "object" && result && isPrototypeOf(ResultPrototype, result)) return result;
    }
    return new Result(false);
};

},{"e7034932381ce11e":"1GZc4","2f267ed50e670495":"lgzZz","c0af58bb1ef1cc62":"aSvFj","7fa6542c03ca9239":"39qAm","fa596d1a4c07b72a":"1vkHL","fd753cc641a6f10a":"f0dsD","2a15dee148d3db96":"ckDDq","417f9a13deeb58a6":"alXpj","43af53be1b24dae5":"53wfg","bf7ad32b21aed0b4":"erPau","5241389e1d6eeb73":"6kSRS"}],"kZWyK":[function(require,module,exports) {
var global = require("c5ce997a0266134d");
var isPrototypeOf = require("55f8840091c5bf21");
var TypeError = global.TypeError;
module.exports = function(it, Prototype) {
    if (isPrototypeOf(Prototype, it)) return it;
    throw TypeError("Incorrect invocation");
};

},{"c5ce997a0266134d":"1GZc4","55f8840091c5bf21":"alXpj"}],"dlT8V":[function(require,module,exports) {
var isCallable = require("9f474ed504af79a9");
var isObject = require("bd2a6951ff768696");
var setPrototypeOf = require("972057e738a2788f");
// makes subclassing work correct for wrapped built-ins
module.exports = function($this, dummy, Wrapper) {
    var NewTarget, NewTargetPrototype;
    if (// it can work only with native `setPrototypeOf`
    setPrototypeOf && // we haven't completely correct pre-ES6 way for getting `new.target`, so use this
    isCallable(NewTarget = dummy.constructor) && NewTarget !== Wrapper && isObject(NewTargetPrototype = NewTarget.prototype) && NewTargetPrototype !== Wrapper.prototype) setPrototypeOf($this, NewTargetPrototype);
    return $this;
};

},{"9f474ed504af79a9":"cVxS9","bd2a6951ff768696":"bprny","972057e738a2788f":"hT4Io"}],"3WOKt":[function(require,module,exports) {
"use strict";
var defineProperty = require("c89bfb72a3cede5b").f;
var create = require("4087699e0041f387");
var redefineAll = require("6573e235ec150e87");
var bind = require("5aecbe8fa3c5a74e");
var anInstance = require("d3ad95b3aaf27c8a");
var iterate = require("a9a2814559569c97");
var defineIterator = require("10f6bdaa91a1c2a3");
var setSpecies = require("dfd8ed3bea972a50");
var DESCRIPTORS = require("b83fb10f1c8587e6");
var fastKey = require("77d5ccb3a2fbc893").fastKey;
var InternalStateModule = require("79afb9c26314edc8");
var setInternalState = InternalStateModule.set;
var internalStateGetterFor = InternalStateModule.getterFor;
module.exports = {
    getConstructor: function(wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER) {
        var Constructor = wrapper(function(that, iterable) {
            anInstance(that, Prototype);
            setInternalState(that, {
                type: CONSTRUCTOR_NAME,
                index: create(null),
                first: undefined,
                last: undefined,
                size: 0
            });
            if (!DESCRIPTORS) that.size = 0;
            if (iterable != undefined) iterate(iterable, that[ADDER], {
                that: that,
                AS_ENTRIES: IS_MAP
            });
        });
        var Prototype = Constructor.prototype;
        var getInternalState = internalStateGetterFor(CONSTRUCTOR_NAME);
        var define = function(that, key, value) {
            var state = getInternalState(that);
            var entry = getEntry(that, key);
            var previous, index;
            // change existing entry
            if (entry) entry.value = value;
            else {
                state.last = entry = {
                    index: index = fastKey(key, true),
                    key: key,
                    value: value,
                    previous: previous = state.last,
                    next: undefined,
                    removed: false
                };
                if (!state.first) state.first = entry;
                if (previous) previous.next = entry;
                if (DESCRIPTORS) state.size++;
                else that.size++;
                // add to index
                if (index !== "F") state.index[index] = entry;
            }
            return that;
        };
        var getEntry = function(that, key) {
            var state = getInternalState(that);
            // fast case
            var index = fastKey(key);
            var entry;
            if (index !== "F") return state.index[index];
            // frozen object case
            for(entry = state.first; entry; entry = entry.next){
                if (entry.key == key) return entry;
            }
        };
        redefineAll(Prototype, {
            // `{ Map, Set }.prototype.clear()` methods
            // https://tc39.es/ecma262/#sec-map.prototype.clear
            // https://tc39.es/ecma262/#sec-set.prototype.clear
            clear: function clear() {
                var that = this;
                var state = getInternalState(that);
                var data = state.index;
                var entry = state.first;
                while(entry){
                    entry.removed = true;
                    if (entry.previous) entry.previous = entry.previous.next = undefined;
                    delete data[entry.index];
                    entry = entry.next;
                }
                state.first = state.last = undefined;
                if (DESCRIPTORS) state.size = 0;
                else that.size = 0;
            },
            // `{ Map, Set }.prototype.delete(key)` methods
            // https://tc39.es/ecma262/#sec-map.prototype.delete
            // https://tc39.es/ecma262/#sec-set.prototype.delete
            "delete": function(key) {
                var that = this;
                var state = getInternalState(that);
                var entry = getEntry(that, key);
                if (entry) {
                    var next = entry.next;
                    var prev = entry.previous;
                    delete state.index[entry.index];
                    entry.removed = true;
                    if (prev) prev.next = next;
                    if (next) next.previous = prev;
                    if (state.first == entry) state.first = next;
                    if (state.last == entry) state.last = prev;
                    if (DESCRIPTORS) state.size--;
                    else that.size--;
                }
                return !!entry;
            },
            // `{ Map, Set }.prototype.forEach(callbackfn, thisArg = undefined)` methods
            // https://tc39.es/ecma262/#sec-map.prototype.foreach
            // https://tc39.es/ecma262/#sec-set.prototype.foreach
            forEach: function forEach(callbackfn /* , that = undefined */ ) {
                var state = getInternalState(this);
                var boundFunction = bind(callbackfn, arguments.length > 1 ? arguments[1] : undefined);
                var entry;
                while(entry = entry ? entry.next : state.first){
                    boundFunction(entry.value, entry.key, this);
                    // revert to the last existing entry
                    while(entry && entry.removed)entry = entry.previous;
                }
            },
            // `{ Map, Set}.prototype.has(key)` methods
            // https://tc39.es/ecma262/#sec-map.prototype.has
            // https://tc39.es/ecma262/#sec-set.prototype.has
            has: function has(key) {
                return !!getEntry(this, key);
            }
        });
        redefineAll(Prototype, IS_MAP ? {
            // `Map.prototype.get(key)` method
            // https://tc39.es/ecma262/#sec-map.prototype.get
            get: function get(key) {
                var entry = getEntry(this, key);
                return entry && entry.value;
            },
            // `Map.prototype.set(key, value)` method
            // https://tc39.es/ecma262/#sec-map.prototype.set
            set: function set(key, value) {
                return define(this, key === 0 ? 0 : key, value);
            }
        } : {
            // `Set.prototype.add(value)` method
            // https://tc39.es/ecma262/#sec-set.prototype.add
            add: function add(value) {
                return define(this, value = value === 0 ? 0 : value, value);
            }
        });
        if (DESCRIPTORS) defineProperty(Prototype, "size", {
            get: function() {
                return getInternalState(this).size;
            }
        });
        return Constructor;
    },
    setStrong: function(Constructor, CONSTRUCTOR_NAME, IS_MAP) {
        var ITERATOR_NAME = CONSTRUCTOR_NAME + " Iterator";
        var getInternalCollectionState = internalStateGetterFor(CONSTRUCTOR_NAME);
        var getInternalIteratorState = internalStateGetterFor(ITERATOR_NAME);
        // `{ Map, Set }.prototype.{ keys, values, entries, @@iterator }()` methods
        // https://tc39.es/ecma262/#sec-map.prototype.entries
        // https://tc39.es/ecma262/#sec-map.prototype.keys
        // https://tc39.es/ecma262/#sec-map.prototype.values
        // https://tc39.es/ecma262/#sec-map.prototype-@@iterator
        // https://tc39.es/ecma262/#sec-set.prototype.entries
        // https://tc39.es/ecma262/#sec-set.prototype.keys
        // https://tc39.es/ecma262/#sec-set.prototype.values
        // https://tc39.es/ecma262/#sec-set.prototype-@@iterator
        defineIterator(Constructor, CONSTRUCTOR_NAME, function(iterated, kind) {
            setInternalState(this, {
                type: ITERATOR_NAME,
                target: iterated,
                state: getInternalCollectionState(iterated),
                kind: kind,
                last: undefined
            });
        }, function() {
            var state = getInternalIteratorState(this);
            var kind = state.kind;
            var entry = state.last;
            // revert to the last existing entry
            while(entry && entry.removed)entry = entry.previous;
            // get next entry
            if (!state.target || !(state.last = entry = entry ? entry.next : state.state.first)) {
                // or finish the iteration
                state.target = undefined;
                return {
                    value: undefined,
                    done: true
                };
            }
            // return step by kind
            if (kind == "keys") return {
                value: entry.key,
                done: false
            };
            if (kind == "values") return {
                value: entry.value,
                done: false
            };
            return {
                value: [
                    entry.key,
                    entry.value
                ],
                done: false
            };
        }, IS_MAP ? "entries" : "values", !IS_MAP, true);
        // `{ Map, Set }.prototype[@@species]` accessors
        // https://tc39.es/ecma262/#sec-get-map-@@species
        // https://tc39.es/ecma262/#sec-get-set-@@species
        setSpecies(CONSTRUCTOR_NAME);
    }
};

},{"c89bfb72a3cede5b":"dfAo1","4087699e0041f387":"dgTGU","6573e235ec150e87":"b48Cu","5aecbe8fa3c5a74e":"lgzZz","d3ad95b3aaf27c8a":"kZWyK","a9a2814559569c97":"9EwlZ","10f6bdaa91a1c2a3":"kELHa","dfd8ed3bea972a50":"46zEr","b83fb10f1c8587e6":"7Hk5a","77d5ccb3a2fbc893":"55X03","79afb9c26314edc8":"bRWxa"}],"b48Cu":[function(require,module,exports) {
var redefine = require("4c05e0e4659ae2ea");
module.exports = function(target, src, options) {
    for(var key in src)redefine(target, key, src[key], options);
    return target;
};

},{"4c05e0e4659ae2ea":"3ncOy"}],"46zEr":[function(require,module,exports) {
"use strict";
var getBuiltIn = require("b05e11590de6536b");
var definePropertyModule = require("13b179790d9e3e06");
var wellKnownSymbol = require("5145e81a7788c772");
var DESCRIPTORS = require("19428004aa07279c");
var SPECIES = wellKnownSymbol("species");
module.exports = function(CONSTRUCTOR_NAME) {
    var Constructor = getBuiltIn(CONSTRUCTOR_NAME);
    var defineProperty = definePropertyModule.f;
    if (DESCRIPTORS && Constructor && !Constructor[SPECIES]) defineProperty(Constructor, SPECIES, {
        configurable: true,
        get: function() {
            return this;
        }
    });
};

},{"b05e11590de6536b":"bQFzp","13b179790d9e3e06":"dfAo1","5145e81a7788c772":"kbsMI","19428004aa07279c":"7Hk5a"}],"74a8v":[function(require,module,exports) {
"use strict";
var charAt = require("e8b36e9e8f60deb1").charAt;
var toString = require("99724183e9ac759e");
var InternalStateModule = require("75c45c226da41a58");
var defineIterator = require("78da37599faac4dd");
var STRING_ITERATOR = "String Iterator";
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(STRING_ITERATOR);
// `String.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-string.prototype-@@iterator
defineIterator(String, "String", function(iterated) {
    setInternalState(this, {
        type: STRING_ITERATOR,
        string: toString(iterated),
        index: 0
    });
// `%StringIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%stringiteratorprototype%.next
}, function next() {
    var state = getInternalState(this);
    var string = state.string;
    var index = state.index;
    var point;
    if (index >= string.length) return {
        value: undefined,
        done: true
    };
    point = charAt(string, index);
    state.index += point.length;
    return {
        value: point,
        done: false
    };
});

},{"e8b36e9e8f60deb1":"iPGTe","99724183e9ac759e":"8RVGu","75c45c226da41a58":"bRWxa","78da37599faac4dd":"kELHa"}],"iPGTe":[function(require,module,exports) {
var uncurryThis = require("8b9beff9818f042");
var toIntegerOrInfinity = require("d3e375e7697978fb");
var toString = require("545a72c28133c459");
var requireObjectCoercible = require("5bafa9e5b372669c");
var charAt = uncurryThis("".charAt);
var charCodeAt = uncurryThis("".charCodeAt);
var stringSlice = uncurryThis("".slice);
var createMethod = function(CONVERT_TO_STRING) {
    return function($this, pos) {
        var S = toString(requireObjectCoercible($this));
        var position = toIntegerOrInfinity(pos);
        var size = S.length;
        var first, second;
        if (position < 0 || position >= size) return CONVERT_TO_STRING ? "" : undefined;
        first = charCodeAt(S, position);
        return first < 0xD800 || first > 0xDBFF || position + 1 === size || (second = charCodeAt(S, position + 1)) < 0xDC00 || second > 0xDFFF ? CONVERT_TO_STRING ? charAt(S, position) : first : CONVERT_TO_STRING ? stringSlice(S, position, position + 2) : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
    };
};
module.exports = {
    // `String.prototype.codePointAt` method
    // https://tc39.es/ecma262/#sec-string.prototype.codepointat
    codeAt: createMethod(false),
    // `String.prototype.at` method
    // https://github.com/mathiasbynens/String.prototype.at
    charAt: createMethod(true)
};

},{"8b9beff9818f042":"fP9tv","d3e375e7697978fb":"8WXPA","545a72c28133c459":"8RVGu","5bafa9e5b372669c":"etuZb"}],"aXR96":[function(require,module,exports) {
var global = require("bf384c7b7143ed0c");
var DOMIterables = require("b1dd6223fec045b2");
var DOMTokenListPrototype = require("2927608065790e8a");
var ArrayIteratorMethods = require("107ef5eaf95c92b0");
var createNonEnumerableProperty = require("2f02b421bbdb9eb4");
var wellKnownSymbol = require("6a4d2091548e6557");
var ITERATOR = wellKnownSymbol("iterator");
var TO_STRING_TAG = wellKnownSymbol("toStringTag");
var ArrayValues = ArrayIteratorMethods.values;
var handlePrototype = function(CollectionPrototype, COLLECTION_NAME) {
    if (CollectionPrototype) {
        // some Chrome versions have non-configurable methods on DOMTokenList
        if (CollectionPrototype[ITERATOR] !== ArrayValues) try {
            createNonEnumerableProperty(CollectionPrototype, ITERATOR, ArrayValues);
        } catch (error) {
            CollectionPrototype[ITERATOR] = ArrayValues;
        }
        if (!CollectionPrototype[TO_STRING_TAG]) createNonEnumerableProperty(CollectionPrototype, TO_STRING_TAG, COLLECTION_NAME);
        if (DOMIterables[COLLECTION_NAME]) for(var METHOD_NAME in ArrayIteratorMethods){
            // some Chrome versions have non-configurable methods on DOMTokenList
            if (CollectionPrototype[METHOD_NAME] !== ArrayIteratorMethods[METHOD_NAME]) try {
                createNonEnumerableProperty(CollectionPrototype, METHOD_NAME, ArrayIteratorMethods[METHOD_NAME]);
            } catch (error) {
                CollectionPrototype[METHOD_NAME] = ArrayIteratorMethods[METHOD_NAME];
            }
        }
    }
};
for(var COLLECTION_NAME in DOMIterables)handlePrototype(global[COLLECTION_NAME] && global[COLLECTION_NAME].prototype, COLLECTION_NAME);
handlePrototype(DOMTokenListPrototype, "DOMTokenList");

},{"bf384c7b7143ed0c":"1GZc4","b1dd6223fec045b2":"9xzEd","2927608065790e8a":"evZKS","107ef5eaf95c92b0":"ieU20","2f02b421bbdb9eb4":"hol1i","6a4d2091548e6557":"kbsMI"}],"9xzEd":[function(require,module,exports) {
// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
module.exports = {
    CSSRuleList: 0,
    CSSStyleDeclaration: 0,
    CSSValueList: 0,
    ClientRectList: 0,
    DOMRectList: 0,
    DOMStringList: 0,
    DOMTokenList: 1,
    DataTransferItemList: 0,
    FileList: 0,
    HTMLAllCollection: 0,
    HTMLCollection: 0,
    HTMLFormElement: 0,
    HTMLSelectElement: 0,
    MediaList: 0,
    MimeTypeArray: 0,
    NamedNodeMap: 0,
    NodeList: 1,
    PaintRequestList: 0,
    Plugin: 0,
    PluginArray: 0,
    SVGLengthList: 0,
    SVGNumberList: 0,
    SVGPathSegList: 0,
    SVGPointList: 0,
    SVGStringList: 0,
    SVGTransformList: 0,
    SourceBufferList: 0,
    StyleSheetList: 0,
    TextTrackCueList: 0,
    TextTrackList: 0,
    TouchList: 0
};

},{}],"evZKS":[function(require,module,exports) {
// in old WebKit versions, `element.classList` is not an instance of global `DOMTokenList`
var documentCreateElement = require("a6fc44eba1875331");
var classList = documentCreateElement("span").classList;
var DOMTokenListPrototype = classList && classList.constructor && classList.constructor.prototype;
module.exports = DOMTokenListPrototype === Object.prototype ? undefined : DOMTokenListPrototype;

},{"a6fc44eba1875331":"gjZdB"}],"8FU8M":[function(require,module,exports) {
var $ = require("9e39c36176ea9027");
var assign = require("eca15ea3e03a62cf");
// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
// eslint-disable-next-line es/no-object-assign -- required for testing
$({
    target: "Object",
    stat: true,
    forced: Object.assign !== assign
}, {
    assign: assign
});

},{"9e39c36176ea9027":"1OO62","eca15ea3e03a62cf":"aQyRR"}],"aQyRR":[function(require,module,exports) {
"use strict";
var DESCRIPTORS = require("6bef1f1b71c0d15f");
var uncurryThis = require("d01fdbe6acf1dc69");
var call = require("152344c6f1cc0727");
var fails = require("e500b6660dae4ed2");
var objectKeys = require("a51f09aa538cbbc9");
var getOwnPropertySymbolsModule = require("1e00e3b82b1b3cb6");
var propertyIsEnumerableModule = require("df8aa13044dccc97");
var toObject = require("fb90ba2f91e5c029");
var IndexedObject = require("33842bab271c4900");
// eslint-disable-next-line es/no-object-assign -- safe
var $assign = Object.assign;
// eslint-disable-next-line es/no-object-defineproperty -- required for testing
var defineProperty = Object.defineProperty;
var concat = uncurryThis([].concat);
// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
module.exports = !$assign || fails(function() {
    // should have correct order of operations (Edge bug)
    if (DESCRIPTORS && $assign({
        b: 1
    }, $assign(defineProperty({}, "a", {
        enumerable: true,
        get: function() {
            defineProperty(this, "b", {
                value: 3,
                enumerable: false
            });
        }
    }), {
        b: 2
    })).b !== 1) return true;
    // should work with symbols and should have deterministic property order (V8 bug)
    var A = {};
    var B = {};
    // eslint-disable-next-line es/no-symbol -- safe
    var symbol = Symbol();
    var alphabet = "abcdefghijklmnopqrst";
    A[symbol] = 7;
    alphabet.split("").forEach(function(chr) {
        B[chr] = chr;
    });
    return $assign({}, A)[symbol] != 7 || objectKeys($assign({}, B)).join("") != alphabet;
}) ? function assign(target, source) {
    var T = toObject(target);
    var argumentsLength = arguments.length;
    var index = 1;
    var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
    var propertyIsEnumerable = propertyIsEnumerableModule.f;
    while(argumentsLength > index){
        var S = IndexedObject(arguments[index++]);
        var keys = getOwnPropertySymbols ? concat(objectKeys(S), getOwnPropertySymbols(S)) : objectKeys(S);
        var length = keys.length;
        var j = 0;
        var key;
        while(length > j){
            key = keys[j++];
            if (!DESCRIPTORS || call(propertyIsEnumerable, S, key)) T[key] = S[key];
        }
    }
    return T;
} : $assign;

},{"6bef1f1b71c0d15f":"7Hk5a","d01fdbe6acf1dc69":"fP9tv","152344c6f1cc0727":"aSvFj","e500b6660dae4ed2":"keKlS","a51f09aa538cbbc9":"jlCln","1e00e3b82b1b3cb6":"2bAgb","df8aa13044dccc97":"i11pl","fb90ba2f91e5c029":"7K2H5","33842bab271c4900":"8iqJB"}],"kLLpv":[function(require,module,exports) {
var $ = require("9b00c005c1d693fb");
var fails = require("ffe585e19c7a1096");
var toObject = require("a7cc68351642ae12");
var nativeGetPrototypeOf = require("46d7a597f20859a8");
var CORRECT_PROTOTYPE_GETTER = require("765be3ffdd1dfa5d");
var FAILS_ON_PRIMITIVES = fails(function() {
    nativeGetPrototypeOf(1);
});
// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
$({
    target: "Object",
    stat: true,
    forced: FAILS_ON_PRIMITIVES,
    sham: !CORRECT_PROTOTYPE_GETTER
}, {
    getPrototypeOf: function getPrototypeOf(it) {
        return nativeGetPrototypeOf(toObject(it));
    }
});

},{"9b00c005c1d693fb":"1OO62","ffe585e19c7a1096":"keKlS","a7cc68351642ae12":"7K2H5","46d7a597f20859a8":"gkVld","765be3ffdd1dfa5d":"2faqz"}],"bGzly":[function(require,module,exports) {
"use strict";
var uncurryThis = require("735e648dfc1aacf7");
var PROPER_FUNCTION_NAME = require("9e28bead644082e").PROPER;
var redefine = require("5673f2fdd0b05bf8");
var anObject = require("3135197806fbedfd");
var isPrototypeOf = require("f630942e0263257e");
var $toString = require("ce5dcf9b5e077a79");
var fails = require("577ada37101f923c");
var regExpFlags = require("fefd47320df56441");
var TO_STRING = "toString";
var RegExpPrototype = RegExp.prototype;
var n$ToString = RegExpPrototype[TO_STRING];
var getFlags = uncurryThis(regExpFlags);
var NOT_GENERIC = fails(function() {
    return n$ToString.call({
        source: "a",
        flags: "b"
    }) != "/a/b";
});
// FF44- RegExp#toString has a wrong name
var INCORRECT_NAME = PROPER_FUNCTION_NAME && n$ToString.name != TO_STRING;
// `RegExp.prototype.toString` method
// https://tc39.es/ecma262/#sec-regexp.prototype.tostring
if (NOT_GENERIC || INCORRECT_NAME) redefine(RegExp.prototype, TO_STRING, function toString() {
    var R = anObject(this);
    var p = $toString(R.source);
    var rf = R.flags;
    var f = $toString(rf === undefined && isPrototypeOf(RegExpPrototype, R) && !("flags" in RegExpPrototype) ? getFlags(R) : rf);
    return "/" + p + "/" + f;
}, {
    unsafe: true
});

},{"735e648dfc1aacf7":"fP9tv","9e28bead644082e":"5TtMA","5673f2fdd0b05bf8":"3ncOy","3135197806fbedfd":"39qAm","f630942e0263257e":"alXpj","ce5dcf9b5e077a79":"8RVGu","577ada37101f923c":"keKlS","fefd47320df56441":"iHyxB"}],"5Q2AT":[function(require,module,exports) {
var $ = require("928eae3c9269318e");
var toObject = require("bffeb5a63b3d1ddc");
var nativeKeys = require("4e7619f3294f09c8");
var fails = require("16ceb2cf691ec6a8");
var FAILS_ON_PRIMITIVES = fails(function() {
    nativeKeys(1);
});
// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
$({
    target: "Object",
    stat: true,
    forced: FAILS_ON_PRIMITIVES
}, {
    keys: function keys(it) {
        return nativeKeys(toObject(it));
    }
});

},{"928eae3c9269318e":"1OO62","bffeb5a63b3d1ddc":"7K2H5","4e7619f3294f09c8":"jlCln","16ceb2cf691ec6a8":"keKlS"}],"iYT1M":[function(require,module,exports) {
var global = require("740b3a6c05a59a12");
var DOMIterables = require("74a037ab8118876");
var DOMTokenListPrototype = require("a3359ffcd052df79");
var forEach = require("9e6862fbf1bc54d2");
var createNonEnumerableProperty = require("833a1c6e8a10b1ff");
var handlePrototype = function(CollectionPrototype) {
    // some Chrome versions have non-configurable methods on DOMTokenList
    if (CollectionPrototype && CollectionPrototype.forEach !== forEach) try {
        createNonEnumerableProperty(CollectionPrototype, "forEach", forEach);
    } catch (error) {
        CollectionPrototype.forEach = forEach;
    }
};
for(var COLLECTION_NAME in DOMIterables)if (DOMIterables[COLLECTION_NAME]) handlePrototype(global[COLLECTION_NAME] && global[COLLECTION_NAME].prototype);
handlePrototype(DOMTokenListPrototype);

},{"740b3a6c05a59a12":"1GZc4","74a037ab8118876":"9xzEd","a3359ffcd052df79":"evZKS","9e6862fbf1bc54d2":"f9gfl","833a1c6e8a10b1ff":"hol1i"}],"f9gfl":[function(require,module,exports) {
"use strict";
var $forEach = require("1a0535b754110eb5").forEach;
var arrayMethodIsStrict = require("df61bc1b7a92de0f");
var STRICT_METHOD = arrayMethodIsStrict("forEach");
// `Array.prototype.forEach` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.foreach
module.exports = !STRICT_METHOD ? function forEach(callbackfn /* , thisArg */ ) {
    return $forEach(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
// eslint-disable-next-line es/no-array-prototype-foreach -- safe
} : [].forEach;

},{"1a0535b754110eb5":"g44dN","df61bc1b7a92de0f":"h0N6r"}],"h0N6r":[function(require,module,exports) {
"use strict";
var fails = require("77f0d106558781f");
module.exports = function(METHOD_NAME, argument) {
    var method = [][METHOD_NAME];
    return !!method && fails(function() {
        // eslint-disable-next-line no-useless-call,no-throw-literal -- required for testing
        method.call(null, argument || function() {
            throw 1;
        }, 1);
    });
};

},{"77f0d106558781f":"keKlS"}],"7Wf79":[function(require,module,exports) {
var $ = require("f61a79561ef771d5");
var $entries = require("f45db476330e9273").entries;
// `Object.entries` method
// https://tc39.es/ecma262/#sec-object.entries
$({
    target: "Object",
    stat: true
}, {
    entries: function entries(O) {
        return $entries(O);
    }
});

},{"f61a79561ef771d5":"1OO62","f45db476330e9273":"5tWMi"}],"5tWMi":[function(require,module,exports) {
var DESCRIPTORS = require("d3708b44f56d5dbe");
var uncurryThis = require("fae894139558d631");
var objectKeys = require("8ca7d570e80b9ce7");
var toIndexedObject = require("cd0bc0f155d9ce86");
var $propertyIsEnumerable = require("8a6b90d3c1a4843d").f;
var propertyIsEnumerable = uncurryThis($propertyIsEnumerable);
var push = uncurryThis([].push);
// `Object.{ entries, values }` methods implementation
var createMethod = function(TO_ENTRIES) {
    return function(it) {
        var O = toIndexedObject(it);
        var keys = objectKeys(O);
        var length = keys.length;
        var i = 0;
        var result = [];
        var key;
        while(length > i){
            key = keys[i++];
            if (!DESCRIPTORS || propertyIsEnumerable(O, key)) push(result, TO_ENTRIES ? [
                key,
                O[key]
            ] : O[key]);
        }
        return result;
    };
};
module.exports = {
    // `Object.entries` method
    // https://tc39.es/ecma262/#sec-object.entries
    entries: createMethod(true),
    // `Object.values` method
    // https://tc39.es/ecma262/#sec-object.values
    values: createMethod(false)
};

},{"d3708b44f56d5dbe":"7Hk5a","fae894139558d631":"fP9tv","8ca7d570e80b9ce7":"jlCln","cd0bc0f155d9ce86":"5DeQ5","8a6b90d3c1a4843d":"i11pl"}],"4LiLL":[function(require,module,exports) {
var DESCRIPTORS = require("b7ae6c9060bb031e");
var FUNCTION_NAME_EXISTS = require("dbb3f5c37b15a691").EXISTS;
var uncurryThis = require("ba7e18d66fc2fe0e");
var defineProperty = require("5357be996bb1aea").f;
var FunctionPrototype = Function.prototype;
var functionToString = uncurryThis(FunctionPrototype.toString);
var nameRE = /^\s*function ([^ (]*)/;
var regExpExec = uncurryThis(nameRE.exec);
var NAME = "name";
// Function instances `.name` property
// https://tc39.es/ecma262/#sec-function-instances-name
if (DESCRIPTORS && !FUNCTION_NAME_EXISTS) defineProperty(FunctionPrototype, NAME, {
    configurable: true,
    get: function() {
        try {
            return regExpExec(nameRE, functionToString(this))[1];
        } catch (error) {
            return "";
        }
    }
});

},{"b7ae6c9060bb031e":"7Hk5a","dbb3f5c37b15a691":"5TtMA","ba7e18d66fc2fe0e":"fP9tv","5357be996bb1aea":"dfAo1"}],"bB8XB":[function(require,module,exports) {
var $ = require("eb35dc894cb42ba5");
var $values = require("f1b9830bcb61759d").values;
// `Object.values` method
// https://tc39.es/ecma262/#sec-object.values
$({
    target: "Object",
    stat: true
}, {
    values: function values(O) {
        return $values(O);
    }
});

},{"eb35dc894cb42ba5":"1OO62","f1b9830bcb61759d":"5tWMi"}],"lYmRJ":[function(require,module,exports) {
/**
 * Module exports.
 */ var global = arguments[3];
module.exports = deprecate;
/**
 * Mark that a method should not be used.
 * Returns a modified function which warns once by default.
 *
 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
 *
 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
 * will throw an Error when invoked.
 *
 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
 * will invoke `console.trace()` instead of `console.error()`.
 *
 * @param {Function} fn - the function to deprecate
 * @param {String} msg - the string to print to the console when `fn` is invoked
 * @returns {Function} a new "deprecated" version of `fn`
 * @api public
 */ function deprecate(fn, msg) {
    if (config("noDeprecation")) return fn;
    var warned = false;
    function deprecated() {
        if (!warned) {
            if (config("throwDeprecation")) throw new Error(msg);
            else if (config("traceDeprecation")) console.trace(msg);
            else console.warn(msg);
            warned = true;
        }
        return fn.apply(this, arguments);
    }
    return deprecated;
}
/**
 * Checks `localStorage` for boolean values for the given `name`.
 *
 * @param {String} name
 * @returns {Boolean}
 * @api private
 */ function config(name) {
    // accessing global.localStorage can trigger a DOMException in sandboxed iframes
    try {
        if (!global.localStorage) return false;
    } catch (_) {
        return false;
    }
    var val = global.localStorage[name];
    if (null == val) return false;
    return String(val).toLowerCase() === "true";
}

},{}],"9RvVa":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.dedent = void 0;
function dedent(templ) {
    var values = [];
    for(var _i = 1; _i < arguments.length; _i++)values[_i - 1] = arguments[_i];
    var strings = Array.from(typeof templ === "string" ? [
        templ
    ] : templ.raw);
    strings[strings.length - 1] = strings[strings.length - 1].replace(/\r?\n([\t ]*)$/, "");
    var indentLengths = strings.reduce(function(arr, str) {
        var matches = str.match(/\n([\t ]+|(?!\s).)/g);
        if (matches) return arr.concat(matches.map(function(match) {
            var _a, _b;
            return (_b = (_a = match.match(/[\t ]/g)) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0;
        }));
        return arr;
    }, []);
    if (indentLengths.length) {
        var pattern_1 = new RegExp("\n[	 ]{" + Math.min.apply(Math, indentLengths) + "}", "g");
        strings = strings.map(function(str) {
            return str.replace(pattern_1, "\n");
        });
    }
    strings[0] = strings[0].replace(/^\r?\n/, "");
    var string = strings[0];
    values.forEach(function(value, i) {
        string += value + strings[i + 1];
    });
    return string;
}
exports.dedent = dedent;
exports.default = dedent;

},{}],"5PzlO":[function(require,module,exports) {
var global = arguments[3];
var win;
if (typeof window !== "undefined") win = window;
else if (typeof global !== "undefined") win = global;
else if (typeof self !== "undefined") win = self;
else win = {};
module.exports = win;

},{}],"iGRus":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "logger", ()=>logger);
parcelHelpers.export(exports, "once", ()=>once);
parcelHelpers.export(exports, "pretty", ()=>pretty);
var _esArrayConcatJs = require("core-js/modules/es.array.concat.js");
var _esArrayIteratorJs = require("core-js/modules/es.array.iterator.js");
var _esObjectToStringJs = require("core-js/modules/es.object.to-string.js");
var _esSetJs = require("core-js/modules/es.set.js");
var _esStringIteratorJs = require("core-js/modules/es.string.iterator.js");
var _webDomCollectionsIteratorJs = require("core-js/modules/web.dom-collections.iterator.js");
var _esRegexpExecJs = require("core-js/modules/es.regexp.exec.js");
var _esStringReplaceJs = require("core-js/modules/es.string.replace.js");
var _global = require("global");
var _globalDefault = parcelHelpers.interopDefault(_global);
var LOGLEVEL = (0, _globalDefault.default).LOGLEVEL, console = (0, _globalDefault.default).console;
var levels = {
    trace: 1,
    debug: 2,
    info: 3,
    warn: 4,
    error: 5,
    silent: 10
};
var currentLogLevelString = LOGLEVEL;
var currentLogLevelNumber = levels[currentLogLevelString] || levels.info;
var logger = {
    trace: function trace(message) {
        for(var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)rest[_key - 1] = arguments[_key];
        return currentLogLevelNumber <= levels.trace && console.trace.apply(console, [
            message
        ].concat(rest));
    },
    debug: function debug(message) {
        for(var _len2 = arguments.length, rest = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)rest[_key2 - 1] = arguments[_key2];
        return currentLogLevelNumber <= levels.debug && console.debug.apply(console, [
            message
        ].concat(rest));
    },
    info: function info(message) {
        for(var _len3 = arguments.length, rest = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)rest[_key3 - 1] = arguments[_key3];
        return currentLogLevelNumber <= levels.info && console.info.apply(console, [
            message
        ].concat(rest));
    },
    warn: function warn(message) {
        for(var _len4 = arguments.length, rest = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++)rest[_key4 - 1] = arguments[_key4];
        return currentLogLevelNumber <= levels.warn && console.warn.apply(console, [
            message
        ].concat(rest));
    },
    error: function error(message) {
        for(var _len5 = arguments.length, rest = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++)rest[_key5 - 1] = arguments[_key5];
        return currentLogLevelNumber <= levels.error && console.error.apply(console, [
            message
        ].concat(rest));
    },
    log: function log(message) {
        for(var _len6 = arguments.length, rest = new Array(_len6 > 1 ? _len6 - 1 : 0), _key6 = 1; _key6 < _len6; _key6++)rest[_key6 - 1] = arguments[_key6];
        return currentLogLevelNumber < levels.silent && console.log.apply(console, [
            message
        ].concat(rest));
    }
};
var logged = new Set();
var once = function once(type) {
    return function(message) {
        if (logged.has(message)) return undefined;
        logged.add(message);
        for(var _len7 = arguments.length, rest = new Array(_len7 > 1 ? _len7 - 1 : 0), _key7 = 1; _key7 < _len7; _key7++)rest[_key7 - 1] = arguments[_key7];
        return logger[type].apply(logger, [
            message
        ].concat(rest));
    };
};
once.clear = function() {
    return logged.clear();
};
once.trace = once("trace");
once.debug = once("debug");
once.info = once("info");
once.warn = once("warn");
once.error = once("error");
once.log = once("log");
var pretty = function pretty(type) {
    return function() {
        var argArray = [];
        for(var _len8 = arguments.length, args = new Array(_len8), _key8 = 0; _key8 < _len8; _key8++)args[_key8] = arguments[_key8];
        if (args.length) {
            var startTagRe = /<span\s+style=(['"])([^'"]*)\1\s*>/gi;
            var endTagRe = /<\/span>/gi;
            var reResultArray;
            argArray.push(args[0].replace(startTagRe, "%c").replace(endTagRe, "%c")); // eslint-disable-next-line no-cond-assign
            while(reResultArray = startTagRe.exec(args[0])){
                argArray.push(reResultArray[2]);
                argArray.push("");
            } // pass through subsequent args since chrome dev tools does not (yet) support console.log styling of the following form: console.log('%cBlue!', 'color: blue;', '%cRed!', 'color: red;');
            // eslint-disable-next-line no-plusplus
            for(var j = 1; j < args.length; j++)argArray.push(args[j]);
        } // eslint-disable-next-line prefer-spread
        logger[type].apply(logger, argArray);
    };
};
pretty.trace = pretty("trace");
pretty.debug = pretty("debug");
pretty.info = pretty("info");
pretty.warn = pretty("warn");
pretty.error = pretty("error");

},{"core-js/modules/es.array.concat.js":"g1t7q","core-js/modules/es.array.iterator.js":"ieU20","core-js/modules/es.object.to-string.js":"lsA9p","core-js/modules/es.set.js":"6FW6g","core-js/modules/es.string.iterator.js":"74a8v","core-js/modules/web.dom-collections.iterator.js":"aXR96","core-js/modules/es.regexp.exec.js":"5q56v","core-js/modules/es.string.replace.js":"bFiJG","global":"5PzlO","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"bFiJG":[function(require,module,exports) {
"use strict";
var apply = require("f8fd16f994f85406");
var call = require("b5234e1018cb2916");
var uncurryThis = require("c3560c75b4ad1ef2");
var fixRegExpWellKnownSymbolLogic = require("c4a2369a79c5aaa2");
var fails = require("daa534dec0372986");
var anObject = require("317f495e148be81e");
var isCallable = require("36464dd17d2a7224");
var toIntegerOrInfinity = require("3847a5ff118f8ebb");
var toLength = require("effd88adfbb6b4bc");
var toString = require("953b724c90cd8db6");
var requireObjectCoercible = require("154963922e7c9354");
var advanceStringIndex = require("90f011aa61b831b4");
var getMethod = require("af552ab4c89e35be");
var getSubstitution = require("3726cfd8dc51c82c");
var regExpExec = require("6de55154ce28598");
var wellKnownSymbol = require("4b6a0c7e75a1080a");
var REPLACE = wellKnownSymbol("replace");
var max = Math.max;
var min = Math.min;
var concat = uncurryThis([].concat);
var push = uncurryThis([].push);
var stringIndexOf = uncurryThis("".indexOf);
var stringSlice = uncurryThis("".slice);
var maybeToString = function(it) {
    return it === undefined ? it : String(it);
};
// IE <= 11 replaces $0 with the whole match, as if it was $&
// https://stackoverflow.com/questions/6024666/getting-ie-to-replace-a-regex-with-the-literal-string-0
var REPLACE_KEEPS_$0 = function() {
    // eslint-disable-next-line regexp/prefer-escape-replacement-dollar-char -- required for testing
    return "a".replace(/./, "$0") === "$0";
}();
// Safari <= 13.0.3(?) substitutes nth capture where n>m with an empty string
var REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE = function() {
    if (/./[REPLACE]) return /./[REPLACE]("a", "$0") === "";
    return false;
}();
var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function() {
    var re = /./;
    re.exec = function() {
        var result = [];
        result.groups = {
            a: "7"
        };
        return result;
    };
    // eslint-disable-next-line regexp/no-useless-dollar-replacements -- false positive
    return "".replace(re, "$<a>") !== "7";
});
// @@replace logic
fixRegExpWellKnownSymbolLogic("replace", function(_, nativeReplace, maybeCallNative) {
    var UNSAFE_SUBSTITUTE = REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE ? "$" : "$0";
    return [
        // `String.prototype.replace` method
        // https://tc39.es/ecma262/#sec-string.prototype.replace
        function replace(searchValue, replaceValue) {
            var O = requireObjectCoercible(this);
            var replacer = searchValue == undefined ? undefined : getMethod(searchValue, REPLACE);
            return replacer ? call(replacer, searchValue, O, replaceValue) : call(nativeReplace, toString(O), searchValue, replaceValue);
        },
        // `RegExp.prototype[@@replace]` method
        // https://tc39.es/ecma262/#sec-regexp.prototype-@@replace
        function(string, replaceValue) {
            var rx = anObject(this);
            var S = toString(string);
            if (typeof replaceValue == "string" && stringIndexOf(replaceValue, UNSAFE_SUBSTITUTE) === -1 && stringIndexOf(replaceValue, "$<") === -1) {
                var res = maybeCallNative(nativeReplace, rx, S, replaceValue);
                if (res.done) return res.value;
            }
            var functionalReplace = isCallable(replaceValue);
            if (!functionalReplace) replaceValue = toString(replaceValue);
            var global = rx.global;
            if (global) {
                var fullUnicode = rx.unicode;
                rx.lastIndex = 0;
            }
            var results = [];
            while(true){
                var result = regExpExec(rx, S);
                if (result === null) break;
                push(results, result);
                if (!global) break;
                var matchStr = toString(result[0]);
                if (matchStr === "") rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
            }
            var accumulatedResult = "";
            var nextSourcePosition = 0;
            for(var i = 0; i < results.length; i++){
                result = results[i];
                var matched = toString(result[0]);
                var position = max(min(toIntegerOrInfinity(result.index), S.length), 0);
                var captures = [];
                // NOTE: This is equivalent to
                //   captures = result.slice(1).map(maybeToString)
                // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
                // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
                // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
                for(var j = 1; j < result.length; j++)push(captures, maybeToString(result[j]));
                var namedCaptures = result.groups;
                if (functionalReplace) {
                    var replacerArgs = concat([
                        matched
                    ], captures, position, S);
                    if (namedCaptures !== undefined) push(replacerArgs, namedCaptures);
                    var replacement = toString(apply(replaceValue, undefined, replacerArgs));
                } else replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
                if (position >= nextSourcePosition) {
                    accumulatedResult += stringSlice(S, nextSourcePosition, position) + replacement;
                    nextSourcePosition = position + matched.length;
                }
            }
            return accumulatedResult + stringSlice(S, nextSourcePosition);
        }
    ];
}, !REPLACE_SUPPORTS_NAMED_GROUPS || !REPLACE_KEEPS_$0 || REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE);

},{"f8fd16f994f85406":"QdiN4","b5234e1018cb2916":"aSvFj","c3560c75b4ad1ef2":"fP9tv","c4a2369a79c5aaa2":"7ckw7","daa534dec0372986":"keKlS","317f495e148be81e":"39qAm","36464dd17d2a7224":"cVxS9","3847a5ff118f8ebb":"8WXPA","effd88adfbb6b4bc":"kzWDg","953b724c90cd8db6":"8RVGu","154963922e7c9354":"etuZb","90f011aa61b831b4":"lebiR","af552ab4c89e35be":"llxIw","3726cfd8dc51c82c":"fhtSK","6de55154ce28598":"aQ8Du","4b6a0c7e75a1080a":"kbsMI"}],"7ckw7":[function(require,module,exports) {
"use strict";
// TODO: Remove from `core-js@4` since it's moved to entry points
require("a7057ee05361671");
var uncurryThis = require("cc9a4fec274a8890");
var redefine = require("e3b3d83e823812a5");
var regexpExec = require("b286e3fd8e91d745");
var fails = require("f56adef42dd3c42");
var wellKnownSymbol = require("39c5bea895574e43");
var createNonEnumerableProperty = require("1c6881441295e4f4");
var SPECIES = wellKnownSymbol("species");
var RegExpPrototype = RegExp.prototype;
module.exports = function(KEY, exec, FORCED, SHAM) {
    var SYMBOL = wellKnownSymbol(KEY);
    var DELEGATES_TO_SYMBOL = !fails(function() {
        // String methods call symbol-named RegEp methods
        var O = {};
        O[SYMBOL] = function() {
            return 7;
        };
        return ""[KEY](O) != 7;
    });
    var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL && !fails(function() {
        // Symbol-named RegExp methods call .exec
        var execCalled = false;
        var re = /a/;
        if (KEY === "split") {
            // We can't use real regex here since it causes deoptimization
            // and serious performance degradation in V8
            // https://github.com/zloirock/core-js/issues/306
            re = {};
            // RegExp[@@split] doesn't call the regex's exec method, but first creates
            // a new one. We need to return the patched regex when creating the new one.
            re.constructor = {};
            re.constructor[SPECIES] = function() {
                return re;
            };
            re.flags = "";
            re[SYMBOL] = /./[SYMBOL];
        }
        re.exec = function() {
            execCalled = true;
            return null;
        };
        re[SYMBOL]("");
        return !execCalled;
    });
    if (!DELEGATES_TO_SYMBOL || !DELEGATES_TO_EXEC || FORCED) {
        var uncurriedNativeRegExpMethod = uncurryThis(/./[SYMBOL]);
        var methods = exec(SYMBOL, ""[KEY], function(nativeMethod, regexp, str, arg2, forceStringMethod) {
            var uncurriedNativeMethod = uncurryThis(nativeMethod);
            var $exec = regexp.exec;
            if ($exec === regexpExec || $exec === RegExpPrototype.exec) {
                if (DELEGATES_TO_SYMBOL && !forceStringMethod) // The native String method already delegates to @@method (this
                // polyfilled function), leasing to infinite recursion.
                // We avoid it by directly calling the native @@method method.
                return {
                    done: true,
                    value: uncurriedNativeRegExpMethod(regexp, str, arg2)
                };
                return {
                    done: true,
                    value: uncurriedNativeMethod(str, regexp, arg2)
                };
            }
            return {
                done: false
            };
        });
        redefine(String.prototype, KEY, methods[0]);
        redefine(RegExpPrototype, SYMBOL, methods[1]);
    }
    if (SHAM) createNonEnumerableProperty(RegExpPrototype[SYMBOL], "sham", true);
};

},{"a7057ee05361671":"5q56v","cc9a4fec274a8890":"fP9tv","e3b3d83e823812a5":"3ncOy","b286e3fd8e91d745":"7hxGn","f56adef42dd3c42":"keKlS","39c5bea895574e43":"kbsMI","1c6881441295e4f4":"hol1i"}],"lebiR":[function(require,module,exports) {
"use strict";
var charAt = require("7830b1b106fe9c2f").charAt;
// `AdvanceStringIndex` abstract operation
// https://tc39.es/ecma262/#sec-advancestringindex
module.exports = function(S, index, unicode) {
    return index + (unicode ? charAt(S, index).length : 1);
};

},{"7830b1b106fe9c2f":"iPGTe"}],"fhtSK":[function(require,module,exports) {
var uncurryThis = require("3cf51fea5d34c201");
var toObject = require("999f669befd62c27");
var floor = Math.floor;
var charAt = uncurryThis("".charAt);
var replace = uncurryThis("".replace);
var stringSlice = uncurryThis("".slice);
var SUBSTITUTION_SYMBOLS = /\$([$&'`]|\d{1,2}|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&'`]|\d{1,2})/g;
// `GetSubstitution` abstract operation
// https://tc39.es/ecma262/#sec-getsubstitution
module.exports = function(matched, str, position, captures, namedCaptures, replacement) {
    var tailPos = position + matched.length;
    var m = captures.length;
    var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
    if (namedCaptures !== undefined) {
        namedCaptures = toObject(namedCaptures);
        symbols = SUBSTITUTION_SYMBOLS;
    }
    return replace(replacement, symbols, function(match, ch) {
        var capture;
        switch(charAt(ch, 0)){
            case "$":
                return "$";
            case "&":
                return matched;
            case "`":
                return stringSlice(str, 0, position);
            case "'":
                return stringSlice(str, tailPos);
            case "<":
                capture = namedCaptures[stringSlice(ch, 1, -1)];
                break;
            default:
                var n = +ch;
                if (n === 0) return match;
                if (n > m) {
                    var f = floor(n / 10);
                    if (f === 0) return match;
                    if (f <= m) return captures[f - 1] === undefined ? charAt(ch, 1) : captures[f - 1] + charAt(ch, 1);
                    return match;
                }
                capture = captures[n - 1];
        }
        return capture === undefined ? "" : capture;
    });
};

},{"3cf51fea5d34c201":"fP9tv","999f669befd62c27":"7K2H5"}],"aQ8Du":[function(require,module,exports) {
var global = require("f3e1f08332211daa");
var call = require("fe012fd0e62b041c");
var anObject = require("953f0ef3a583db2e");
var isCallable = require("7b1bebb22aa6d09f");
var classof = require("41458309d054e6d9");
var regexpExec = require("2da13aa8500d5870");
var TypeError = global.TypeError;
// `RegExpExec` abstract operation
// https://tc39.es/ecma262/#sec-regexpexec
module.exports = function(R, S) {
    var exec = R.exec;
    if (isCallable(exec)) {
        var result = call(exec, R, S);
        if (result !== null) anObject(result);
        return result;
    }
    if (classof(R) === "RegExp") return call(regexpExec, R, S);
    throw TypeError("RegExp#exec called on incompatible receiver");
};

},{"f3e1f08332211daa":"1GZc4","fe012fd0e62b041c":"aSvFj","953f0ef3a583db2e":"39qAm","7b1bebb22aa6d09f":"cVxS9","41458309d054e6d9":"6FZJh","2da13aa8500d5870":"7hxGn"}],"9A7PF":[function(require,module,exports) {
exports.interopDefault = function(a) {
    return a && a.__esModule ? a : {
        default: a
    };
};
exports.defineInteropFlag = function(a) {
    Object.defineProperty(a, "__esModule", {
        value: true
    });
};
exports.exportAll = function(source, dest) {
    Object.keys(source).forEach(function(key) {
        if (key === "default" || key === "__esModule" || dest.hasOwnProperty(key)) return;
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function() {
                return source[key];
            }
        });
    });
    return dest;
};
exports.export = function(dest, destName, get) {
    Object.defineProperty(dest, destName, {
        enumerable: true,
        get: get
    });
};

},{}],"f7MI8":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {
    sanitize: true,
    toId: true,
    storyNameFromExport: true,
    isExportStory: true,
    parseKind: true,
    includeConditionalArg: true
};
exports.isExportStory = isExportStory;
Object.defineProperty(exports, "includeConditionalArg", {
    enumerable: true,
    get: function get() {
        return _includeConditionalArg.includeConditionalArg;
    }
});
exports.parseKind = exports.storyNameFromExport = exports.toId = exports.sanitize = void 0;
var _startCase = _interopRequireDefault(require("4e95d4f3256d984"));
var _includeConditionalArg = require("49404edb206bf914");
var _story = require("2c5832e2a7f19e52");
Object.keys(_story).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _story[key];
        }
    });
});
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _iterableToArrayLimit(arr, i) {
    if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
/**
 * Remove punctuation and illegal characters from a story ID.
 *
 * See https://gist.github.com/davidjrice/9d2af51100e41c6c4b4a
 */ var sanitize = function sanitize(string) {
    return string.toLowerCase() // eslint-disable-next-line no-useless-escape
    .replace(/[ ’–—―′¿'`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi, "-").replace(/-+/g, "-").replace(/^-+/, "").replace(/-+$/, "");
};
exports.sanitize = sanitize;
var sanitizeSafe = function sanitizeSafe(string, part) {
    var sanitized = sanitize(string);
    if (sanitized === "") throw new Error("Invalid ".concat(part, " '").concat(string, "', must include alphanumeric characters"));
    return sanitized;
};
/**
 * Generate a storybook ID from a component/kind and story name.
 */ var toId = function toId(kind, name) {
    return "".concat(sanitizeSafe(kind, "kind")).concat(name ? "--".concat(sanitizeSafe(name, "name")) : "");
};
/**
 * Transform a CSF named export into a readable story name
 */ exports.toId = toId;
var storyNameFromExport = function storyNameFromExport(key) {
    return (0, _startCase["default"])(key);
};
exports.storyNameFromExport = storyNameFromExport;
function matches(storyKey, arrayOrRegex) {
    if (Array.isArray(arrayOrRegex)) return arrayOrRegex.includes(storyKey);
    return storyKey.match(arrayOrRegex);
}
/**
 * Does a named export match CSF inclusion/exclusion options?
 */ function isExportStory(key, _ref) {
    var includeStories = _ref.includeStories, excludeStories = _ref.excludeStories;
    return key !== "__esModule" && (!includeStories || matches(key, includeStories)) && (!excludeStories || !matches(key, excludeStories));
}
/**
 * Parse out the component/kind name from a path, using the given separator config.
 */ var parseKind = function parseKind(kind, _ref2) {
    var rootSeparator = _ref2.rootSeparator, groupSeparator = _ref2.groupSeparator;
    var _kind$split = kind.split(rootSeparator, 2), _kind$split2 = _slicedToArray(_kind$split, 2), root = _kind$split2[0], remainder = _kind$split2[1];
    var groups = (remainder || kind).split(groupSeparator).filter(function(i) {
        return !!i;
    }); // when there's no remainder, it means the root wasn't found/split
    return {
        root: remainder ? root : null,
        groups: groups
    };
};
exports.parseKind = parseKind;

},{"4e95d4f3256d984":"gRtHx","49404edb206bf914":"cPN2R","2c5832e2a7f19e52":"6qUbd"}],"gRtHx":[function(require,module,exports) {
var createCompounder = require("f10c909a79ea4596"), upperFirst = require("2ac04918aee4665e");
/**
 * Converts `string` to
 * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
 *
 * @static
 * @memberOf _
 * @since 3.1.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the start cased string.
 * @example
 *
 * _.startCase('--foo-bar--');
 * // => 'Foo Bar'
 *
 * _.startCase('fooBar');
 * // => 'Foo Bar'
 *
 * _.startCase('__FOO_BAR__');
 * // => 'FOO BAR'
 */ var startCase = createCompounder(function(result, word, index) {
    return result + (index ? " " : "") + upperFirst(word);
});
module.exports = startCase;

},{"f10c909a79ea4596":"4i91T","2ac04918aee4665e":"cAnV2"}],"4i91T":[function(require,module,exports) {
var arrayReduce = require("cfc95c8ee08dfd6b"), deburr = require("b60ce6efa81a3cef"), words = require("40ddea9252aefad9");
/** Used to compose unicode capture groups. */ var rsApos = "['\u2019]";
/** Used to match apostrophes. */ var reApos = RegExp(rsApos, "g");
/**
 * Creates a function like `_.camelCase`.
 *
 * @private
 * @param {Function} callback The function to combine each word.
 * @returns {Function} Returns the new compounder function.
 */ function createCompounder(callback) {
    return function(string) {
        return arrayReduce(words(deburr(string).replace(reApos, "")), callback, "");
    };
}
module.exports = createCompounder;

},{"cfc95c8ee08dfd6b":"4VyGl","b60ce6efa81a3cef":"7OZp3","40ddea9252aefad9":"hklTg"}],"4VyGl":[function(require,module,exports) {
/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */ function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1, length = array == null ? 0 : array.length;
    if (initAccum && length) accumulator = array[++index];
    while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
    return accumulator;
}
module.exports = arrayReduce;

},{}],"7OZp3":[function(require,module,exports) {
var deburrLetter = require("86c70dfa448b37ae"), toString = require("f68583105b85d455");
/** Used to match Latin Unicode letters (excluding mathematical operators). */ var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
/** Used to compose unicode character classes. */ var rsComboMarksRange = "\\u0300-\\u036f", reComboHalfMarksRange = "\\ufe20-\\ufe2f", rsComboSymbolsRange = "\\u20d0-\\u20ff", rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange;
/** Used to compose unicode capture groups. */ var rsCombo = "[" + rsComboRange + "]";
/**
 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
 */ var reComboMark = RegExp(rsCombo, "g");
/**
 * Deburrs `string` by converting
 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
 * letters to basic Latin letters and removing
 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to deburr.
 * @returns {string} Returns the deburred string.
 * @example
 *
 * _.deburr('déjà vu');
 * // => 'deja vu'
 */ function deburr(string) {
    string = toString(string);
    return string && string.replace(reLatin, deburrLetter).replace(reComboMark, "");
}
module.exports = deburr;

},{"86c70dfa448b37ae":"kPtFs","f68583105b85d455":"kJEDW"}],"kPtFs":[function(require,module,exports) {
var basePropertyOf = require("c95029d8b26d3cfc");
/** Used to map Latin Unicode letters to basic Latin letters. */ var deburredLetters = {
    // Latin-1 Supplement block.
    "\xc0": "A",
    "\xc1": "A",
    "\xc2": "A",
    "\xc3": "A",
    "\xc4": "A",
    "\xc5": "A",
    "\xe0": "a",
    "\xe1": "a",
    "\xe2": "a",
    "\xe3": "a",
    "\xe4": "a",
    "\xe5": "a",
    "\xc7": "C",
    "\xe7": "c",
    "\xd0": "D",
    "\xf0": "d",
    "\xc8": "E",
    "\xc9": "E",
    "\xca": "E",
    "\xcb": "E",
    "\xe8": "e",
    "\xe9": "e",
    "\xea": "e",
    "\xeb": "e",
    "\xcc": "I",
    "\xcd": "I",
    "\xce": "I",
    "\xcf": "I",
    "\xec": "i",
    "\xed": "i",
    "\xee": "i",
    "\xef": "i",
    "\xd1": "N",
    "\xf1": "n",
    "\xd2": "O",
    "\xd3": "O",
    "\xd4": "O",
    "\xd5": "O",
    "\xd6": "O",
    "\xd8": "O",
    "\xf2": "o",
    "\xf3": "o",
    "\xf4": "o",
    "\xf5": "o",
    "\xf6": "o",
    "\xf8": "o",
    "\xd9": "U",
    "\xda": "U",
    "\xdb": "U",
    "\xdc": "U",
    "\xf9": "u",
    "\xfa": "u",
    "\xfb": "u",
    "\xfc": "u",
    "\xdd": "Y",
    "\xfd": "y",
    "\xff": "y",
    "\xc6": "Ae",
    "\xe6": "ae",
    "\xde": "Th",
    "\xfe": "th",
    "\xdf": "ss",
    // Latin Extended-A block.
    "\u0100": "A",
    "\u0102": "A",
    "\u0104": "A",
    "\u0101": "a",
    "\u0103": "a",
    "\u0105": "a",
    "\u0106": "C",
    "\u0108": "C",
    "\u010A": "C",
    "\u010C": "C",
    "\u0107": "c",
    "\u0109": "c",
    "\u010B": "c",
    "\u010D": "c",
    "\u010E": "D",
    "\u0110": "D",
    "\u010F": "d",
    "\u0111": "d",
    "\u0112": "E",
    "\u0114": "E",
    "\u0116": "E",
    "\u0118": "E",
    "\u011A": "E",
    "\u0113": "e",
    "\u0115": "e",
    "\u0117": "e",
    "\u0119": "e",
    "\u011B": "e",
    "\u011C": "G",
    "\u011E": "G",
    "\u0120": "G",
    "\u0122": "G",
    "\u011D": "g",
    "\u011F": "g",
    "\u0121": "g",
    "\u0123": "g",
    "\u0124": "H",
    "\u0126": "H",
    "\u0125": "h",
    "\u0127": "h",
    "\u0128": "I",
    "\u012A": "I",
    "\u012C": "I",
    "\u012E": "I",
    "\u0130": "I",
    "\u0129": "i",
    "\u012B": "i",
    "\u012D": "i",
    "\u012F": "i",
    "\u0131": "i",
    "\u0134": "J",
    "\u0135": "j",
    "\u0136": "K",
    "\u0137": "k",
    "\u0138": "k",
    "\u0139": "L",
    "\u013B": "L",
    "\u013D": "L",
    "\u013F": "L",
    "\u0141": "L",
    "\u013A": "l",
    "\u013C": "l",
    "\u013E": "l",
    "\u0140": "l",
    "\u0142": "l",
    "\u0143": "N",
    "\u0145": "N",
    "\u0147": "N",
    "\u014A": "N",
    "\u0144": "n",
    "\u0146": "n",
    "\u0148": "n",
    "\u014B": "n",
    "\u014C": "O",
    "\u014E": "O",
    "\u0150": "O",
    "\u014D": "o",
    "\u014F": "o",
    "\u0151": "o",
    "\u0154": "R",
    "\u0156": "R",
    "\u0158": "R",
    "\u0155": "r",
    "\u0157": "r",
    "\u0159": "r",
    "\u015A": "S",
    "\u015C": "S",
    "\u015E": "S",
    "\u0160": "S",
    "\u015B": "s",
    "\u015D": "s",
    "\u015F": "s",
    "\u0161": "s",
    "\u0162": "T",
    "\u0164": "T",
    "\u0166": "T",
    "\u0163": "t",
    "\u0165": "t",
    "\u0167": "t",
    "\u0168": "U",
    "\u016A": "U",
    "\u016C": "U",
    "\u016E": "U",
    "\u0170": "U",
    "\u0172": "U",
    "\u0169": "u",
    "\u016B": "u",
    "\u016D": "u",
    "\u016F": "u",
    "\u0171": "u",
    "\u0173": "u",
    "\u0174": "W",
    "\u0175": "w",
    "\u0176": "Y",
    "\u0177": "y",
    "\u0178": "Y",
    "\u0179": "Z",
    "\u017B": "Z",
    "\u017D": "Z",
    "\u017A": "z",
    "\u017C": "z",
    "\u017E": "z",
    "\u0132": "IJ",
    "\u0133": "ij",
    "\u0152": "Oe",
    "\u0153": "oe",
    "\u0149": "'n",
    "\u017F": "s"
};
/**
 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
 * letters to basic Latin letters.
 *
 * @private
 * @param {string} letter The matched letter to deburr.
 * @returns {string} Returns the deburred letter.
 */ var deburrLetter = basePropertyOf(deburredLetters);
module.exports = deburrLetter;

},{"c95029d8b26d3cfc":"lBNZq"}],"lBNZq":[function(require,module,exports) {
/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */ function basePropertyOf(object) {
    return function(key) {
        return object == null ? undefined : object[key];
    };
}
module.exports = basePropertyOf;

},{}],"kJEDW":[function(require,module,exports) {
var baseToString = require("81fca33832a744d9");
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function toString(value) {
    return value == null ? "" : baseToString(value);
}
module.exports = toString;

},{"81fca33832a744d9":"cRcji"}],"cRcji":[function(require,module,exports) {
var Symbol = require("16af83505444e42a"), arrayMap = require("8439a3a1551d0706"), isArray = require("4b12c9f502d3288a"), isSymbol = require("a0ebd327d618908a");
/** Used as references for various `Number` constants. */ var INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == "string") return value;
    if (isArray(value)) // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + "";
    if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : "";
    var result = value + "";
    return result == "0" && 1 / value == -INFINITY ? "-0" : result;
}
module.exports = baseToString;

},{"16af83505444e42a":"eDozn","8439a3a1551d0706":"f5pfU","4b12c9f502d3288a":"9EWOE","a0ebd327d618908a":"7TlbF"}],"eDozn":[function(require,module,exports) {
var root = require("9ff1abd51ad45ac0");
/** Built-in value references. */ var Symbol = root.Symbol;
module.exports = Symbol;

},{"9ff1abd51ad45ac0":"6R5vr"}],"6R5vr":[function(require,module,exports) {
var freeGlobal = require("cd92e8811deaabf5");
/** Detect free variable `self`. */ var freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function("return this")();
module.exports = root;

},{"cd92e8811deaabf5":"adlLD"}],"adlLD":[function(require,module,exports) {
/** Detect free variable `global` from Node.js. */ var global = arguments[3];
var freeGlobal = typeof global == "object" && global && global.Object === Object && global;
module.exports = freeGlobal;

},{}],"f5pfU":[function(require,module,exports) {
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
module.exports = arrayMap;

},{}],"9EWOE":[function(require,module,exports) {
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var isArray = Array.isArray;
module.exports = isArray;

},{}],"7TlbF":[function(require,module,exports) {
var baseGetTag = require("6118c0d5630f51ce"), isObjectLike = require("74644060ad1a1d3c");
/** `Object#toString` result references. */ var symbolTag = "[object Symbol]";
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function isSymbol(value) {
    return typeof value == "symbol" || isObjectLike(value) && baseGetTag(value) == symbolTag;
}
module.exports = isSymbol;

},{"6118c0d5630f51ce":"8STfc","74644060ad1a1d3c":"65GJZ"}],"8STfc":[function(require,module,exports) {
var Symbol = require("68a84eb98c5d3fa2"), getRawTag = require("9b2aaf31b7bdd837"), objectToString = require("46d5beb3375f8a28");
/** `Object#toString` result references. */ var nullTag = "[object Null]", undefinedTag = "[object Undefined]";
/** Built-in value references. */ var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function baseGetTag(value) {
    if (value == null) return value === undefined ? undefinedTag : nullTag;
    return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}
module.exports = baseGetTag;

},{"68a84eb98c5d3fa2":"eDozn","9b2aaf31b7bdd837":"1oYwM","46d5beb3375f8a28":"70Mlk"}],"1oYwM":[function(require,module,exports) {
var Symbol = require("e9b4533b2a68f814");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString = objectProto.toString;
/** Built-in value references. */ var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function getRawTag(value) {
    var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
    try {
        value[symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[symToStringTag] = tag;
        else delete value[symToStringTag];
    }
    return result;
}
module.exports = getRawTag;

},{"e9b4533b2a68f814":"eDozn"}],"70Mlk":[function(require,module,exports) {
/** Used for built-in method references. */ var objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString = objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function objectToString(value) {
    return nativeObjectToString.call(value);
}
module.exports = objectToString;

},{}],"65GJZ":[function(require,module,exports) {
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
    return value != null && typeof value == "object";
}
module.exports = isObjectLike;

},{}],"hklTg":[function(require,module,exports) {
var asciiWords = require("14a2bcc60f9c8c58"), hasUnicodeWord = require("12a5a56673332993"), toString = require("efbc56b55844c665"), unicodeWords = require("e27193a0a134859e");
/**
 * Splits `string` into an array of its words.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {RegExp|string} [pattern] The pattern to match words.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the words of `string`.
 * @example
 *
 * _.words('fred, barney, & pebbles');
 * // => ['fred', 'barney', 'pebbles']
 *
 * _.words('fred, barney, & pebbles', /[^, ]+/g);
 * // => ['fred', 'barney', '&', 'pebbles']
 */ function words(string, pattern, guard) {
    string = toString(string);
    pattern = guard ? undefined : pattern;
    if (pattern === undefined) return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
    return string.match(pattern) || [];
}
module.exports = words;

},{"14a2bcc60f9c8c58":"lHXog","12a5a56673332993":"5k1mS","efbc56b55844c665":"kJEDW","e27193a0a134859e":"47Vke"}],"lHXog":[function(require,module,exports) {
/** Used to match words composed of alphanumeric characters. */ var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
/**
 * Splits an ASCII `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */ function asciiWords(string) {
    return string.match(reAsciiWord) || [];
}
module.exports = asciiWords;

},{}],"5k1mS":[function(require,module,exports) {
/** Used to detect strings that need a more robust regexp to match words. */ var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
/**
 * Checks if `string` contains a word composed of Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a word is found, else `false`.
 */ function hasUnicodeWord(string) {
    return reHasUnicodeWord.test(string);
}
module.exports = hasUnicodeWord;

},{}],"47Vke":[function(require,module,exports) {
/** Used to compose unicode character classes. */ var rsAstralRange = "\ud800-\udfff", rsComboMarksRange = "\\u0300-\\u036f", reComboHalfMarksRange = "\\ufe20-\\ufe2f", rsComboSymbolsRange = "\\u20d0-\\u20ff", rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = "\\u2700-\\u27bf", rsLowerRange = "a-z\\xdf-\\xf6\\xf8-\\xff", rsMathOpRange = "\\xac\\xb1\\xd7\\xf7", rsNonCharRange = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", rsPunctuationRange = "\\u2000-\\u206f", rsSpaceRange = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", rsUpperRange = "A-Z\\xc0-\\xd6\\xd8-\\xde", rsVarRange = "\\ufe0e\\ufe0f", rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
/** Used to compose unicode capture groups. */ var rsApos = "['\u2019]", rsBreak = "[" + rsBreakRange + "]", rsCombo = "[" + rsComboRange + "]", rsDigits = "\\d+", rsDingbat = "[" + rsDingbatRange + "]", rsLower = "[" + rsLowerRange + "]", rsMisc = "[^" + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + "]", rsFitz = "\ud83c[\udffb-\udfff]", rsModifier = "(?:" + rsCombo + "|" + rsFitz + ")", rsNonAstral = "[^" + rsAstralRange + "]", rsRegional = "(?:\ud83c[\udde6-\uddff]){2}", rsSurrPair = "[\ud800-\udbff][\udc00-\udfff]", rsUpper = "[" + rsUpperRange + "]", rsZWJ = "\\u200d";
/** Used to compose unicode regexes. */ var rsMiscLower = "(?:" + rsLower + "|" + rsMisc + ")", rsMiscUpper = "(?:" + rsUpper + "|" + rsMisc + ")", rsOptContrLower = "(?:" + rsApos + "(?:d|ll|m|re|s|t|ve))?", rsOptContrUpper = "(?:" + rsApos + "(?:D|LL|M|RE|S|T|VE))?", reOptMod = rsModifier + "?", rsOptVar = "[" + rsVarRange + "]?", rsOptJoin = "(?:" + rsZWJ + "(?:" + [
    rsNonAstral,
    rsRegional,
    rsSurrPair
].join("|") + ")" + rsOptVar + reOptMod + ")*", rsOrdLower = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", rsOrdUpper = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = "(?:" + [
    rsDingbat,
    rsRegional,
    rsSurrPair
].join("|") + ")" + rsSeq;
/** Used to match complex or compound words. */ var reUnicodeWord = RegExp([
    rsUpper + "?" + rsLower + "+" + rsOptContrLower + "(?=" + [
        rsBreak,
        rsUpper,
        "$"
    ].join("|") + ")",
    rsMiscUpper + "+" + rsOptContrUpper + "(?=" + [
        rsBreak,
        rsUpper + rsMiscLower,
        "$"
    ].join("|") + ")",
    rsUpper + "?" + rsMiscLower + "+" + rsOptContrLower,
    rsUpper + "+" + rsOptContrUpper,
    rsOrdUpper,
    rsOrdLower,
    rsDigits,
    rsEmoji
].join("|"), "g");
/**
 * Splits a Unicode `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */ function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
}
module.exports = unicodeWords;

},{}],"cAnV2":[function(require,module,exports) {
var createCaseFirst = require("9f71ec962d19127");
/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */ var upperFirst = createCaseFirst("toUpperCase");
module.exports = upperFirst;

},{"9f71ec962d19127":"hYSNf"}],"hYSNf":[function(require,module,exports) {
var castSlice = require("6cc0e53be1623a5f"), hasUnicode = require("e28707473345265"), stringToArray = require("32980b84821a53a0"), toString = require("e00796f8e204e98");
/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */ function createCaseFirst(methodName) {
    return function(string) {
        string = toString(string);
        var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined;
        var chr = strSymbols ? strSymbols[0] : string.charAt(0);
        var trailing = strSymbols ? castSlice(strSymbols, 1).join("") : string.slice(1);
        return chr[methodName]() + trailing;
    };
}
module.exports = createCaseFirst;

},{"6cc0e53be1623a5f":"1Ucn5","e28707473345265":"e14s4","32980b84821a53a0":"7eE1d","e00796f8e204e98":"kJEDW"}],"1Ucn5":[function(require,module,exports) {
var baseSlice = require("19fbc2ab8fa927cd");
/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */ function castSlice(array, start, end) {
    var length = array.length;
    end = end === undefined ? length : end;
    return !start && end >= length ? array : baseSlice(array, start, end);
}
module.exports = castSlice;

},{"19fbc2ab8fa927cd":"jFSif"}],"jFSif":[function(require,module,exports) {
/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */ function baseSlice(array, start, end) {
    var index = -1, length = array.length;
    if (start < 0) start = -start > length ? 0 : length + start;
    end = end > length ? length : end;
    if (end < 0) end += length;
    length = start > end ? 0 : end - start >>> 0;
    start >>>= 0;
    var result = Array(length);
    while(++index < length)result[index] = array[index + start];
    return result;
}
module.exports = baseSlice;

},{}],"e14s4":[function(require,module,exports) {
/** Used to compose unicode character classes. */ var rsAstralRange = "\ud800-\udfff", rsComboMarksRange = "\\u0300-\\u036f", reComboHalfMarksRange = "\\ufe20-\\ufe2f", rsComboSymbolsRange = "\\u20d0-\\u20ff", rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsVarRange = "\\ufe0e\\ufe0f";
/** Used to compose unicode capture groups. */ var rsZWJ = "\\u200d";
/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var reHasUnicode = RegExp("[" + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + "]");
/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */ function hasUnicode(string) {
    return reHasUnicode.test(string);
}
module.exports = hasUnicode;

},{}],"7eE1d":[function(require,module,exports) {
var asciiToArray = require("55ec07d60faf873c"), hasUnicode = require("d3e31b390208b2ca"), unicodeToArray = require("2a468ebcd49732b9");
/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function stringToArray(string) {
    return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
}
module.exports = stringToArray;

},{"55ec07d60faf873c":"iZ7RB","d3e31b390208b2ca":"e14s4","2a468ebcd49732b9":"hvbsN"}],"iZ7RB":[function(require,module,exports) {
/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function asciiToArray(string) {
    return string.split("");
}
module.exports = asciiToArray;

},{}],"hvbsN":[function(require,module,exports) {
/** Used to compose unicode character classes. */ var rsAstralRange = "\ud800-\udfff", rsComboMarksRange = "\\u0300-\\u036f", reComboHalfMarksRange = "\\ufe20-\\ufe2f", rsComboSymbolsRange = "\\u20d0-\\u20ff", rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsVarRange = "\\ufe0e\\ufe0f";
/** Used to compose unicode capture groups. */ var rsAstral = "[" + rsAstralRange + "]", rsCombo = "[" + rsComboRange + "]", rsFitz = "\ud83c[\udffb-\udfff]", rsModifier = "(?:" + rsCombo + "|" + rsFitz + ")", rsNonAstral = "[^" + rsAstralRange + "]", rsRegional = "(?:\ud83c[\udde6-\uddff]){2}", rsSurrPair = "[\ud800-\udbff][\udc00-\udfff]", rsZWJ = "\\u200d";
/** Used to compose unicode regexes. */ var reOptMod = rsModifier + "?", rsOptVar = "[" + rsVarRange + "]?", rsOptJoin = "(?:" + rsZWJ + "(?:" + [
    rsNonAstral,
    rsRegional,
    rsSurrPair
].join("|") + ")" + rsOptVar + reOptMod + ")*", rsSeq = rsOptVar + reOptMod + rsOptJoin, rsSymbol = "(?:" + [
    rsNonAstral + rsCombo + "?",
    rsCombo,
    rsRegional,
    rsSurrPair,
    rsAstral
].join("|") + ")";
/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var reUnicode = RegExp(rsFitz + "(?=" + rsFitz + ")|" + rsSymbol + rsSeq, "g");
/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function unicodeToArray(string) {
    return string.match(reUnicode) || [];
}
module.exports = unicodeToArray;

},{}],"cPN2R":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.includeConditionalArg = exports.testValue = void 0;
var _isEqual = _interopRequireDefault(require("ed831ca41a4b9e74"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
var count = function count(vals) {
    return vals.map(function(v) {
        return typeof v !== "undefined";
    }).filter(Boolean).length;
};
var testValue = function testValue(cond, value) {
    var _ref = cond, exists = _ref.exists, eq = _ref.eq, neq = _ref.neq, truthy = _ref.truthy;
    if (count([
        exists,
        eq,
        neq,
        truthy
    ]) > 1) throw new Error("Invalid conditional test ".concat(JSON.stringify({
        exists: exists,
        eq: eq,
        neq: neq
    })));
    if (typeof eq !== "undefined") return (0, _isEqual["default"])(value, eq);
    if (typeof neq !== "undefined") return !(0, _isEqual["default"])(value, neq);
    if (typeof exists !== "undefined") {
        var valueExists = typeof value !== "undefined";
        return exists ? valueExists : !valueExists;
    }
    var shouldBeTruthy = typeof truthy === "undefined" ? true : truthy;
    return shouldBeTruthy ? !!value : !value;
};
/**
 * Helper function to include/exclude an arg based on the value of other other args
 * aka "conditional args"
 */ exports.testValue = testValue;
var includeConditionalArg = function includeConditionalArg(argType, args, globals) {
    if (!argType["if"]) return true;
    var _ref2 = argType["if"], arg = _ref2.arg, global = _ref2.global;
    if (count([
        arg,
        global
    ]) !== 1) throw new Error("Invalid conditional value ".concat(JSON.stringify({
        arg: arg,
        global: global
    })));
    var value = arg ? args[arg] : globals[global];
    return testValue(argType["if"], value);
};
exports.includeConditionalArg = includeConditionalArg;

},{"ed831ca41a4b9e74":"aNBOA"}],"aNBOA":[function(require,module,exports) {
var baseIsEqual = require("7b71d3bc42bb6f3e");
/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */ function isEqual(value, other) {
    return baseIsEqual(value, other);
}
module.exports = isEqual;

},{"7b71d3bc42bb6f3e":"19U3S"}],"19U3S":[function(require,module,exports) {
var baseIsEqualDeep = require("bd1d38ebd4028e5a"), isObjectLike = require("809bbb0c20650dbc");
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
    return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}
module.exports = baseIsEqual;

},{"bd1d38ebd4028e5a":"2H9cu","809bbb0c20650dbc":"65GJZ"}],"2H9cu":[function(require,module,exports) {
var Stack = require("60c73bca87468e58"), equalArrays = require("96bc8a1825db53a5"), equalByTag = require("8bdece495e87fb69"), equalObjects = require("bb94920432a68eca"), getTag = require("45495edff98e5837"), isArray = require("18256411ae9e2858"), isBuffer = require("e5ba7abf54247fc5"), isTypedArray = require("50d786bb5c7366af");
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", objectTag = "[object Object]";
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
    objTag = objTag == argsTag ? objectTag : objTag;
    othTag = othTag == argsTag ? objectTag : othTag;
    var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
    if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty.call(other, "__wrapped__");
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new Stack);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new Stack);
    return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}
module.exports = baseIsEqualDeep;

},{"60c73bca87468e58":"l6sZY","96bc8a1825db53a5":"dMShe","8bdece495e87fb69":"3Qq3D","bb94920432a68eca":"hZ9XR","45495edff98e5837":"8l0YO","18256411ae9e2858":"9EWOE","e5ba7abf54247fc5":"3LsQ4","50d786bb5c7366af":"buHCl"}],"l6sZY":[function(require,module,exports) {
var ListCache = require("cfb30a39eead9e7e"), stackClear = require("ceda2a63c77c915"), stackDelete = require("91ee1b348d9d7172"), stackGet = require("3fe28318f65b9332"), stackHas = require("724ca4def8b84e06"), stackSet = require("e9ceacb40d9582bd");
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Stack(entries) {
    var data = this.__data__ = new ListCache(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype["delete"] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
module.exports = Stack;

},{"cfb30a39eead9e7e":"1YRcH","ceda2a63c77c915":"2emym","91ee1b348d9d7172":"2ovaq","3fe28318f65b9332":"3F60I","724ca4def8b84e06":"buDkV","e9ceacb40d9582bd":"kiVYz"}],"1YRcH":[function(require,module,exports) {
var listCacheClear = require("4b1a0d54aed80a7b"), listCacheDelete = require("b700cb849df2c166"), listCacheGet = require("d76dd90eead6cced"), listCacheHas = require("3d210628ba60ec8"), listCacheSet = require("76026bf2d4cfff93");
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype["delete"] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
module.exports = ListCache;

},{"4b1a0d54aed80a7b":"k1LQs","b700cb849df2c166":"5lswI","d76dd90eead6cced":"ltiQW","3d210628ba60ec8":"IAAtA","76026bf2d4cfff93":"4xVRp"}],"k1LQs":[function(require,module,exports) {
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
module.exports = listCacheClear;

},{}],"5lswI":[function(require,module,exports) {
var assocIndexOf = require("173cad7d48c35f4f");
/** Used for built-in method references. */ var arrayProto = Array.prototype;
/** Built-in value references. */ var splice = arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function listCacheDelete(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else splice.call(data, index, 1);
    --this.size;
    return true;
}
module.exports = listCacheDelete;

},{"173cad7d48c35f4f":"cBgxN"}],"cBgxN":[function(require,module,exports) {
var eq = require("b38bfe408564f7a5");
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if (eq(array[length][0], key)) return length;
    }
    return -1;
}
module.exports = assocIndexOf;

},{"b38bfe408564f7a5":"kLV9d"}],"kLV9d":[function(require,module,exports) {
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function eq(value, other) {
    return value === other || value !== value && other !== other;
}
module.exports = eq;

},{}],"ltiQW":[function(require,module,exports) {
var assocIndexOf = require("c0bae780ed176e2c");
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function listCacheGet(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
module.exports = listCacheGet;

},{"c0bae780ed176e2c":"cBgxN"}],"IAAtA":[function(require,module,exports) {
var assocIndexOf = require("7ed3d4e3adbd64a4");
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
}
module.exports = listCacheHas;

},{"7ed3d4e3adbd64a4":"cBgxN"}],"4xVRp":[function(require,module,exports) {
var assocIndexOf = require("5be4035c2d7ca432");
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function listCacheSet(key, value) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
module.exports = listCacheSet;

},{"5be4035c2d7ca432":"cBgxN"}],"2emym":[function(require,module,exports) {
var ListCache = require("8a0350213da984ae");
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function stackClear() {
    this.__data__ = new ListCache;
    this.size = 0;
}
module.exports = stackClear;

},{"8a0350213da984ae":"1YRcH"}],"2ovaq":[function(require,module,exports) {
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function stackDelete(key) {
    var data = this.__data__, result = data["delete"](key);
    this.size = data.size;
    return result;
}
module.exports = stackDelete;

},{}],"3F60I":[function(require,module,exports) {
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function stackGet(key) {
    return this.__data__.get(key);
}
module.exports = stackGet;

},{}],"buDkV":[function(require,module,exports) {
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function stackHas(key) {
    return this.__data__.has(key);
}
module.exports = stackHas;

},{}],"kiVYz":[function(require,module,exports) {
var ListCache = require("4737651e99b917d2"), Map = require("1494efbafafa9552"), MapCache = require("6049e8027fe9407f");
/** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new MapCache(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
module.exports = stackSet;

},{"4737651e99b917d2":"1YRcH","1494efbafafa9552":"1tUAb","6049e8027fe9407f":"h6D7Y"}],"1tUAb":[function(require,module,exports) {
var getNative = require("ed0752fe9f482107"), root = require("29224713b8d411e6");
/* Built-in method references that are verified to be native. */ var Map = getNative(root, "Map");
module.exports = Map;

},{"ed0752fe9f482107":"4BGPZ","29224713b8d411e6":"6R5vr"}],"4BGPZ":[function(require,module,exports) {
var baseIsNative = require("63e3f1300cdc459f"), getValue = require("16db51a0e009bd8c");
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
}
module.exports = getNative;

},{"63e3f1300cdc459f":"fb5zN","16db51a0e009bd8c":"ljq9J"}],"fb5zN":[function(require,module,exports) {
var isFunction = require("2f9b4543c84c6692"), isMasked = require("cabbc2adfaeb27d9"), isObject = require("cbb5703fe1562e7f"), toSource = require("388b819f47a43aa5");
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var reIsNative = RegExp("^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) return false;
    var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
}
module.exports = baseIsNative;

},{"2f9b4543c84c6692":"9BLtw","cabbc2adfaeb27d9":"lxDar","cbb5703fe1562e7f":"37Lwq","388b819f47a43aa5":"1lp0o"}],"9BLtw":[function(require,module,exports) {
var baseGetTag = require("5419308bd9194e11"), isObject = require("3cba3c966459d528");
/** `Object#toString` result references. */ var asyncTag = "[object AsyncFunction]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", proxyTag = "[object Proxy]";
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction(value) {
    if (!isObject(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = baseGetTag(value);
    return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}
module.exports = isFunction;

},{"5419308bd9194e11":"8STfc","3cba3c966459d528":"37Lwq"}],"37Lwq":[function(require,module,exports) {
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function isObject(value) {
    var type = typeof value;
    return value != null && (type == "object" || type == "function");
}
module.exports = isObject;

},{}],"lxDar":[function(require,module,exports) {
var coreJsData = require("2fa6c734b0792bcf");
/** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
}
module.exports = isMasked;

},{"2fa6c734b0792bcf":"17OO8"}],"17OO8":[function(require,module,exports) {
var root = require("2f0959b2c20d7fb0");
/** Used to detect overreaching core-js shims. */ var coreJsData = root["__core-js_shared__"];
module.exports = coreJsData;

},{"2f0959b2c20d7fb0":"6R5vr"}],"1lp0o":[function(require,module,exports) {
/** Used for built-in method references. */ var funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function toSource(func) {
    if (func != null) {
        try {
            return funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
module.exports = toSource;

},{}],"ljq9J":[function(require,module,exports) {
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function getValue(object, key) {
    return object == null ? undefined : object[key];
}
module.exports = getValue;

},{}],"h6D7Y":[function(require,module,exports) {
var mapCacheClear = require("a5ffecfb6a8bdac1"), mapCacheDelete = require("d2967b0e32ccfa56"), mapCacheGet = require("ca21409ea89624c0"), mapCacheHas = require("f88fd07f8dd1f67d"), mapCacheSet = require("dbf3eae765642a3b");
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype["delete"] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
module.exports = MapCache;

},{"a5ffecfb6a8bdac1":"bQKeI","d2967b0e32ccfa56":"h5nBa","ca21409ea89624c0":"4MvoV","f88fd07f8dd1f67d":"cF1xG","dbf3eae765642a3b":"jZuGB"}],"bQKeI":[function(require,module,exports) {
var Hash = require("4ae82d88051cc92b"), ListCache = require("a07dcf3fd3097a0c"), Map = require("92c01c953ef00ded");
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        "hash": new Hash,
        "map": new (Map || ListCache),
        "string": new Hash
    };
}
module.exports = mapCacheClear;

},{"4ae82d88051cc92b":"9sjAF","a07dcf3fd3097a0c":"1YRcH","92c01c953ef00ded":"1tUAb"}],"9sjAF":[function(require,module,exports) {
var hashClear = require("f47a1723b6e2d79b"), hashDelete = require("bc25d439ccd1fb47"), hashGet = require("f096b37295a92ab0"), hashHas = require("d88173cbc6a133c8"), hashSet = require("afb9b3bae0461cbf");
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype["delete"] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
module.exports = Hash;

},{"f47a1723b6e2d79b":"8D1to","bc25d439ccd1fb47":"244B4","f096b37295a92ab0":"foQ9Q","d88173cbc6a133c8":"7OKfY","afb9b3bae0461cbf":"6kqrH"}],"8D1to":[function(require,module,exports) {
var nativeCreate = require("dc294230a47ca365");
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
    this.size = 0;
}
module.exports = hashClear;

},{"dc294230a47ca365":"dulOv"}],"dulOv":[function(require,module,exports) {
var getNative = require("12f496acdffb7cf7");
/* Built-in method references that are verified to be native. */ var nativeCreate = getNative(Object, "create");
module.exports = nativeCreate;

},{"12f496acdffb7cf7":"4BGPZ"}],"244B4":[function(require,module,exports) {
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = hashDelete;

},{}],"foQ9Q":[function(require,module,exports) {
var nativeCreate = require("627211fa3e1596e1");
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty.call(data, key) ? data[key] : undefined;
}
module.exports = hashGet;

},{"627211fa3e1596e1":"dulOv"}],"7OKfY":[function(require,module,exports) {
var nativeCreate = require("52b3f0bfeddceb45");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}
module.exports = hashHas;

},{"52b3f0bfeddceb45":"dulOv"}],"6kqrH":[function(require,module,exports) {
var nativeCreate = require("67b7d10f53ccd515");
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
    return this;
}
module.exports = hashSet;

},{"67b7d10f53ccd515":"dulOv"}],"h5nBa":[function(require,module,exports) {
var getMapData = require("656d8c5510e0af84");
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function mapCacheDelete(key) {
    var result = getMapData(this, key)["delete"](key);
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = mapCacheDelete;

},{"656d8c5510e0af84":"a4OPf"}],"a4OPf":[function(require,module,exports) {
var isKeyable = require("adfdd2b4101370ed");
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
module.exports = getMapData;

},{"adfdd2b4101370ed":"8SxOZ"}],"8SxOZ":[function(require,module,exports) {
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function isKeyable(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
module.exports = isKeyable;

},{}],"4MvoV":[function(require,module,exports) {
var getMapData = require("d345cdfee2b4007d");
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function mapCacheGet(key) {
    return getMapData(this, key).get(key);
}
module.exports = mapCacheGet;

},{"d345cdfee2b4007d":"a4OPf"}],"cF1xG":[function(require,module,exports) {
var getMapData = require("29ebabd55e2d6074");
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function mapCacheHas(key) {
    return getMapData(this, key).has(key);
}
module.exports = mapCacheHas;

},{"29ebabd55e2d6074":"a4OPf"}],"jZuGB":[function(require,module,exports) {
var getMapData = require("21c5ffca56eeb737");
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function mapCacheSet(key, value) {
    var data = getMapData(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
module.exports = mapCacheSet;

},{"21c5ffca56eeb737":"a4OPf"}],"dMShe":[function(require,module,exports) {
var SetCache = require("9b110ce138e67ce5"), arraySome = require("1ee20de911db0cb0"), cacheHas = require("defff3d81be91b23");
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack["delete"](array);
    stack["delete"](other);
    return result;
}
module.exports = equalArrays;

},{"9b110ce138e67ce5":"lQIx4","1ee20de911db0cb0":"3RKxi","defff3d81be91b23":"iFl1t"}],"lQIx4":[function(require,module,exports) {
var MapCache = require("10fe37252553d0bd"), setCacheAdd = require("9a831e81e9a1f98c"), setCacheHas = require("1a2b6c8a7399c39f");
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new MapCache;
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;
module.exports = SetCache;

},{"10fe37252553d0bd":"h6D7Y","9a831e81e9a1f98c":"gPO50","1a2b6c8a7399c39f":"lTSRw"}],"gPO50":[function(require,module,exports) {
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function setCacheAdd(value) {
    this.__data__.set(value, HASH_UNDEFINED);
    return this;
}
module.exports = setCacheAdd;

},{}],"lTSRw":[function(require,module,exports) {
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function setCacheHas(value) {
    return this.__data__.has(value);
}
module.exports = setCacheHas;

},{}],"3RKxi":[function(require,module,exports) {
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
module.exports = arraySome;

},{}],"iFl1t":[function(require,module,exports) {
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function cacheHas(cache, key) {
    return cache.has(key);
}
module.exports = cacheHas;

},{}],"3Qq3D":[function(require,module,exports) {
var Symbol = require("474c1df4fc722b40"), Uint8Array = require("dbf6aa5033a0f48"), eq = require("539966708f906e61"), equalArrays = require("8142d4017f0a425f"), mapToArray = require("48cddf732eff33ba"), setToArray = require("9dc78b26c5daba20");
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", mapTag = "[object Map]", numberTag = "[object Number]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]";
var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]";
/** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
            return true;
        case boolTag:
        case dateTag:
        case numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return eq(+object, +other);
        case errorTag:
            return object.name == other.name && object.message == other.message;
        case regexpTag:
        case stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + "";
        case mapTag:
            var convert = mapToArray;
        case setTag:
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
            convert || (convert = setToArray);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack["delete"](object);
            return result;
        case symbolTag:
            if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
    }
    return false;
}
module.exports = equalByTag;

},{"474c1df4fc722b40":"eDozn","dbf6aa5033a0f48":"8ygkF","539966708f906e61":"kLV9d","8142d4017f0a425f":"dMShe","48cddf732eff33ba":"cu1Dz","9dc78b26c5daba20":"8RRW7"}],"8ygkF":[function(require,module,exports) {
var root = require("f755339301d6568f");
/** Built-in value references. */ var Uint8Array = root.Uint8Array;
module.exports = Uint8Array;

},{"f755339301d6568f":"6R5vr"}],"cu1Dz":[function(require,module,exports) {
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
module.exports = mapToArray;

},{}],"8RRW7":[function(require,module,exports) {
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
module.exports = setToArray;

},{}],"hZ9XR":[function(require,module,exports) {
var getAllKeys = require("b911593d305cf4a2");
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == "constructor");
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
    }
    stack["delete"](object);
    stack["delete"](other);
    return result;
}
module.exports = equalObjects;

},{"b911593d305cf4a2":"6OjCb"}],"6OjCb":[function(require,module,exports) {
var baseGetAllKeys = require("c3dbe402f6996a21"), getSymbols = require("aa79b69a13f924db"), keys = require("e3ad83e53433bc8a");
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function getAllKeys(object) {
    return baseGetAllKeys(object, keys, getSymbols);
}
module.exports = getAllKeys;

},{"c3dbe402f6996a21":"8XGQ1","aa79b69a13f924db":"5Kz2O","e3ad83e53433bc8a":"73Scx"}],"8XGQ1":[function(require,module,exports) {
var arrayPush = require("abfc70b400ed76c2"), isArray = require("148b85918856c33a");
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}
module.exports = baseGetAllKeys;

},{"abfc70b400ed76c2":"fQzwB","148b85918856c33a":"9EWOE"}],"fQzwB":[function(require,module,exports) {
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
module.exports = arrayPush;

},{}],"5Kz2O":[function(require,module,exports) {
var arrayFilter = require("7fe025254f0b7e4a"), stubArray = require("6b1c62cea92cdb9");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Built-in value references. */ var propertyIsEnumerable = objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
    if (object == null) return [];
    object = Object(object);
    return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
    });
};
module.exports = getSymbols;

},{"7fe025254f0b7e4a":"kCafV","6b1c62cea92cdb9":"RkBgO"}],"kCafV":[function(require,module,exports) {
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
module.exports = arrayFilter;

},{}],"RkBgO":[function(require,module,exports) {
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function stubArray() {
    return [];
}
module.exports = stubArray;

},{}],"73Scx":[function(require,module,exports) {
var arrayLikeKeys = require("4c73ca42c789e5ab"), baseKeys = require("e8453365fdacc8da"), isArrayLike = require("7760b47b02971dfa");
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function keys(object) {
    return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}
module.exports = keys;

},{"4c73ca42c789e5ab":"bQPt0","e8453365fdacc8da":"32eGl","7760b47b02971dfa":"d9OTq"}],"bQPt0":[function(require,module,exports) {
var baseTimes = require("7ed875a0e67be76f"), isArguments = require("9cdb51ffa56f149b"), isArray = require("38cd49f1e493b3d7"), isBuffer = require("b379831fe1873fed"), isIndex = require("f362a34cd8321bb7"), isTypedArray = require("c019db5297494469");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function arrayLikeKeys(value, inherited) {
    var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
    isIndex(key, length)))) result.push(key);
    return result;
}
module.exports = arrayLikeKeys;

},{"7ed875a0e67be76f":"617qV","9cdb51ffa56f149b":"6N1dk","38cd49f1e493b3d7":"9EWOE","b379831fe1873fed":"3LsQ4","f362a34cd8321bb7":"9phJd","c019db5297494469":"buHCl"}],"617qV":[function(require,module,exports) {
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
module.exports = baseTimes;

},{}],"6N1dk":[function(require,module,exports) {
var baseIsArguments = require("b56e5b7d86069686"), isObjectLike = require("bead821d6af018b5");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Built-in value references. */ var propertyIsEnumerable = objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var isArguments = baseIsArguments(function() {
    return arguments;
}()) ? baseIsArguments : function(value) {
    return isObjectLike(value) && hasOwnProperty.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
};
module.exports = isArguments;

},{"b56e5b7d86069686":"knOR7","bead821d6af018b5":"65GJZ"}],"knOR7":[function(require,module,exports) {
var baseGetTag = require("7e8612a4a451f2cc"), isObjectLike = require("b6cdbe52dcf709f8");
/** `Object#toString` result references. */ var argsTag = "[object Arguments]";
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function baseIsArguments(value) {
    return isObjectLike(value) && baseGetTag(value) == argsTag;
}
module.exports = baseIsArguments;

},{"7e8612a4a451f2cc":"8STfc","b6cdbe52dcf709f8":"65GJZ"}],"3LsQ4":[function(require,module,exports) {
var root = require("cef5ec6f0da1ab00"), stubFalse = require("a1e87b138cf75d1d");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? root.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || stubFalse;
module.exports = isBuffer;

},{"cef5ec6f0da1ab00":"6R5vr","a1e87b138cf75d1d":"dGgXZ"}],"dGgXZ":[function(require,module,exports) {
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function stubFalse() {
    return false;
}
module.exports = stubFalse;

},{}],"9phJd":[function(require,module,exports) {
/** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function isIndex(value, length) {
    var type = typeof value;
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (type == "number" || type != "symbol" && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
module.exports = isIndex;

},{}],"buHCl":[function(require,module,exports) {
var baseIsTypedArray = require("75a26f037e65be61"), baseUnary = require("903f50eb1c16d257"), nodeUtil = require("fa49853a82034c30");
/* Node.js helper references. */ var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
module.exports = isTypedArray;

},{"75a26f037e65be61":"dgt9y","903f50eb1c16d257":"7BGL4","fa49853a82034c30":"ffyBd"}],"dgt9y":[function(require,module,exports) {
var baseGetTag = require("67544c3df364a802"), isLength = require("f661b3a120d7a4cb"), isObjectLike = require("cdd86c83797c0618");
/** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", funcTag = "[object Function]", mapTag = "[object Map]", numberTag = "[object Number]", objectTag = "[object Object]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", weakMapTag = "[object WeakMap]";
var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
/** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function baseIsTypedArray(value) {
    return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}
module.exports = baseIsTypedArray;

},{"67544c3df364a802":"8STfc","f661b3a120d7a4cb":"1gZyQ","cdd86c83797c0618":"65GJZ"}],"1gZyQ":[function(require,module,exports) {
/** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
module.exports = isLength;

},{}],"7BGL4":[function(require,module,exports) {
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
module.exports = baseUnary;

},{}],"ffyBd":[function(require,module,exports) {
var freeGlobal = require("94e753dfbe54816e");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require("util").types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding("util");
    } catch (e) {}
}();
module.exports = nodeUtil;

},{"94e753dfbe54816e":"adlLD"}],"32eGl":[function(require,module,exports) {
var isPrototype = require("7da6298814f9bd95"), nativeKeys = require("3ec652610d8dd5d3");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeys(object) {
    if (!isPrototype(object)) return nativeKeys(object);
    var result = [];
    for(var key in Object(object))if (hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
    return result;
}
module.exports = baseKeys;

},{"7da6298814f9bd95":"jZR75","3ec652610d8dd5d3":"2W7GS"}],"jZR75":[function(require,module,exports) {
/** Used for built-in method references. */ var objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
    return value === proto;
}
module.exports = isPrototype;

},{}],"2W7GS":[function(require,module,exports) {
var overArg = require("aa3357c7a3889df");
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeKeys = overArg(Object.keys, Object);
module.exports = nativeKeys;

},{"aa3357c7a3889df":"1gfAV"}],"1gfAV":[function(require,module,exports) {
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
module.exports = overArg;

},{}],"d9OTq":[function(require,module,exports) {
var isFunction = require("bb060d4356645330"), isLength = require("f3db08d4d1110aaf");
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
}
module.exports = isArrayLike;

},{"bb060d4356645330":"9BLtw","f3db08d4d1110aaf":"1gZyQ"}],"8l0YO":[function(require,module,exports) {
var DataView = require("7f038695b2fdb86e"), Map = require("28e3344aae951f13"), Promise = require("b286298be5b1d9a4"), Set = require("3ae50c158f89813"), WeakMap = require("9f458755f627d456"), baseGetTag = require("8e9160b373d7fe66"), toSource = require("b210627dd951641f");
/** `Object#toString` result references. */ var mapTag = "[object Map]", objectTag = "[object Object]", promiseTag = "[object Promise]", setTag = "[object Set]", weakMapTag = "[object WeakMap]";
var dataViewTag = "[object DataView]";
/** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var getTag = baseGetTag;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
    var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : "";
    if (ctorString) switch(ctorString){
        case dataViewCtorString:
            return dataViewTag;
        case mapCtorString:
            return mapTag;
        case promiseCtorString:
            return promiseTag;
        case setCtorString:
            return setTag;
        case weakMapCtorString:
            return weakMapTag;
    }
    return result;
};
module.exports = getTag;

},{"7f038695b2fdb86e":"ajgOa","28e3344aae951f13":"1tUAb","b286298be5b1d9a4":"c6lPz","3ae50c158f89813":"9Sm12","9f458755f627d456":"dWAar","8e9160b373d7fe66":"8STfc","b210627dd951641f":"1lp0o"}],"ajgOa":[function(require,module,exports) {
var getNative = require("a6517d0448dad786"), root = require("f83c375075418382");
/* Built-in method references that are verified to be native. */ var DataView = getNative(root, "DataView");
module.exports = DataView;

},{"a6517d0448dad786":"4BGPZ","f83c375075418382":"6R5vr"}],"c6lPz":[function(require,module,exports) {
var getNative = require("6940648d854355b5"), root = require("a5c6637bac681a0");
/* Built-in method references that are verified to be native. */ var Promise = getNative(root, "Promise");
module.exports = Promise;

},{"6940648d854355b5":"4BGPZ","a5c6637bac681a0":"6R5vr"}],"9Sm12":[function(require,module,exports) {
var getNative = require("56b792d64741a4ff"), root = require("ca486d41cdf819d4");
/* Built-in method references that are verified to be native. */ var Set = getNative(root, "Set");
module.exports = Set;

},{"56b792d64741a4ff":"4BGPZ","ca486d41cdf819d4":"6R5vr"}],"dWAar":[function(require,module,exports) {
var getNative = require("4507415bd8810d3c"), root = require("7a9a6581834a8452");
/* Built-in method references that are verified to be native. */ var WeakMap = getNative(root, "WeakMap");
module.exports = WeakMap;

},{"4507415bd8810d3c":"4BGPZ","7a9a6581834a8452":"6R5vr"}],"6qUbd":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _SBType = require("6e8bebd2e5e3e357");
Object.keys(_SBType).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _SBType[key];
        }
    });
});

},{"6e8bebd2e5e3e357":"kZQzD"}],"kZQzD":[function(require,module,exports) {
"use strict";

},{}],"26Xer":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StoryStore", ()=>(0, _storyStore.StoryStore));
parcelHelpers.export(exports, "combineParameters", ()=>(0, _parameters.combineParameters));
parcelHelpers.export(exports, "filterArgTypes", ()=>(0, _filterArgTypes.filterArgTypes));
parcelHelpers.export(exports, "inferControls", ()=>(0, _inferControls.inferControls));
var _storyStore = require("./StoryStore");
var _parameters = require("./parameters");
var _filterArgTypes = require("./filterArgTypes");
var _inferControls = require("./inferControls");
var _types = require("./types");
parcelHelpers.exportAll(_types, exports);
var _csf = require("./csf");
parcelHelpers.exportAll(_csf, exports);
var _hooks = require("./hooks");
parcelHelpers.exportAll(_hooks, exports);
var _decorators = require("./decorators");
parcelHelpers.exportAll(_decorators, exports);
var _args = require("./args");
parcelHelpers.exportAll(_args, exports);
var _autoTitle = require("./autoTitle");
parcelHelpers.exportAll(_autoTitle, exports);
var _sortStories = require("./sortStories");
parcelHelpers.exportAll(_sortStories, exports);

},{"./StoryStore":"60i2J","./parameters":"8T89l","./filterArgTypes":"gitKw","./inferControls":"lOqr1","./types":"ddLfR","./csf":"fGMu0","./hooks":"csdah","./decorators":"c5Z0N","./args":"58bKx","./autoTitle":"02qN8","./sortStories":"i800W","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"60i2J":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StoryStore", ()=>StoryStore);
var _esObjectAssignJs = require("core-js/modules/es.object.assign.js");
var _esFunctionNameJs = require("core-js/modules/es.function.name.js");
var _esObjectToStringJs = require("core-js/modules/es.object.to-string.js");
var _webDomCollectionsForEachJs = require("core-js/modules/web.dom-collections.for-each.js");
var _esObjectEntriesJs = require("core-js/modules/es.object.entries.js");
var _esArrayMapJs = require("core-js/modules/es.array.map.js");
var _esArrayFilterJs = require("core-js/modules/es.array.filter.js");
var _esObjectKeysJs = require("core-js/modules/es.object.keys.js");
var _esArraySortJs = require("core-js/modules/es.array.sort.js");
var _esArraySliceJs = require("core-js/modules/es.array.slice.js");
var _esObjectValuesJs = require("core-js/modules/es.object.values.js");
var _esPromiseJs = require("core-js/modules/es.promise.js");
var _esSymbolJs = require("core-js/modules/es.symbol.js");
var _esSymbolDescriptionJs = require("core-js/modules/es.symbol.description.js");
var _esSymbolIteratorJs = require("core-js/modules/es.symbol.iterator.js");
var _esArrayIteratorJs = require("core-js/modules/es.array.iterator.js");
var _esStringIteratorJs = require("core-js/modules/es.string.iterator.js");
var _webDomCollectionsIteratorJs = require("core-js/modules/web.dom-collections.iterator.js");
var _esArrayFromJs = require("core-js/modules/es.array.from.js");
var _esRegexpExecJs = require("core-js/modules/es.regexp.exec.js");
var _memoizerific = require("memoizerific");
var _memoizerificDefault = parcelHelpers.interopDefault(_memoizerific);
var _mapValues = require("lodash/mapValues");
var _mapValuesDefault = parcelHelpers.interopDefault(_mapValues);
var _pick = require("lodash/pick");
var _pickDefault = parcelHelpers.interopDefault(_pick);
var _global = require("global");
var _globalDefault = parcelHelpers.interopDefault(_global);
var _synchronousPromise = require("synchronous-promise");
var _storyIndexStore = require("./StoryIndexStore");
var _argsStore = require("./ArgsStore");
var _globalsStore = require("./GlobalsStore");
var _csf = require("./csf");
var _hooks = require("./hooks"); // TODO -- what are reasonable values for these?
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
var CSF_CACHE_SIZE = 1000;
var STORY_CACHE_SIZE = 10000;
var StoryStore = /*#__PURE__*/ function() {
    function StoryStore() {
        var _this = this;
        _classCallCheck(this, StoryStore);
        this.storyIndex = void 0;
        this.importFn = void 0;
        this.projectAnnotations = void 0;
        this.globals = void 0;
        this.args = void 0;
        this.hooks = void 0;
        this.cachedCSFFiles = void 0;
        this.processCSFFileWithCache = void 0;
        this.prepareStoryWithCache = void 0;
        this.initializationPromise = void 0;
        this.resolveInitializationPromise = void 0;
        this.getStoriesJsonData = function() {
            var value = _this.getSetStoriesPayload();
            var allowedParameters = [
                "fileName",
                "docsOnly",
                "framework",
                "__id",
                "__isArgsStory"
            ];
            var stories = (0, _mapValuesDefault.default)(value.stories, function(story) {
                var _global$FEATURES;
                return Object.assign({}, (0, _pickDefault.default)(story, [
                    "id",
                    "name",
                    "title"
                ]), {
                    importPath: _this.storyIndex.stories[story.id].importPath
                }, !((_global$FEATURES = (0, _globalDefault.default).FEATURES) !== null && _global$FEATURES !== void 0 && _global$FEATURES.breakingChangesV7) && {
                    kind: story.title,
                    story: story.name,
                    parameters: Object.assign({}, (0, _pickDefault.default)(story.parameters, allowedParameters), {
                        fileName: _this.storyIndex.stories[story.id].importPath
                    })
                });
            });
            return {
                v: 3,
                stories: stories
            };
        };
        this.globals = new (0, _globalsStore.GlobalsStore)();
        this.args = new (0, _argsStore.ArgsStore)();
        this.hooks = {}; // We use a cache for these two functions for two reasons:
        //  1. For performance
        //  2. To ensure that when the same story is prepared with the same inputs you get the same output
        this.processCSFFileWithCache = (0, _memoizerificDefault.default)(CSF_CACHE_SIZE)((0, _csf.processCSFFile));
        this.prepareStoryWithCache = (0, _memoizerificDefault.default)(STORY_CACHE_SIZE)((0, _csf.prepareStory)); // We cannot call `loadStory()` until we've been initialized properly. But we can wait for it.
        this.initializationPromise = new (0, _synchronousPromise.SynchronousPromise)(function(resolve) {
            _this.resolveInitializationPromise = resolve;
        });
    }
    _createClass(StoryStore, [
        {
            key: "setProjectAnnotations",
            value: function setProjectAnnotations(projectAnnotations) {
                // By changing `this.projectAnnotations, we implicitly invalidate the `prepareStoryWithCache`
                this.projectAnnotations = (0, _csf.normalizeProjectAnnotations)(projectAnnotations);
                var globals = projectAnnotations.globals, globalTypes = projectAnnotations.globalTypes;
                this.globals.set({
                    globals: globals,
                    globalTypes: globalTypes
                });
            }
        },
        {
            key: "initialize",
            value: function initialize(_ref) {
                var storyIndex = _ref.storyIndex, importFn = _ref.importFn, _ref$cache = _ref.cache, cache = _ref$cache === void 0 ? false : _ref$cache;
                this.storyIndex = new (0, _storyIndexStore.StoryIndexStore)(storyIndex);
                this.importFn = importFn; // We don't need the cache to be loaded to call `loadStory`, we just need the index ready
                this.resolveInitializationPromise();
                return cache ? this.cacheAllCSFFiles() : (0, _synchronousPromise.SynchronousPromise).resolve();
            } // This means that one of the CSF files has changed.
        },
        {
            key: "onStoriesChanged",
            value: function() {
                var _onStoriesChanged = _asyncToGenerator(/*#__PURE__*/ regeneratorRuntime.mark(function _callee(_ref2) {
                    var importFn, storyIndex;
                    return regeneratorRuntime.wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                importFn = _ref2.importFn, storyIndex = _ref2.storyIndex;
                                if (importFn) this.importFn = importFn;
                                if (storyIndex) this.storyIndex.stories = storyIndex.stories;
                                if (!this.cachedCSFFiles) {
                                    _context.next = 6;
                                    break;
                                }
                                _context.next = 6;
                                return this.cacheAllCSFFiles();
                            case 6:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function onStoriesChanged(_x) {
                    return _onStoriesChanged.apply(this, arguments);
                }
                return onStoriesChanged;
            }() // To load a single CSF file to service a story we need to look up the importPath in the index
        },
        {
            key: "loadCSFFileByStoryId",
            value: function loadCSFFileByStoryId(storyId) {
                var _this2 = this;
                var _this$storyIndex$stor = this.storyIndex.storyIdToEntry(storyId), importPath = _this$storyIndex$stor.importPath, title = _this$storyIndex$stor.title;
                return this.importFn(importPath).then(function(moduleExports) {
                    return _this2.processCSFFileWithCache(moduleExports, importPath, title);
                });
            }
        },
        {
            key: "loadAllCSFFiles",
            value: function loadAllCSFFiles() {
                var _this3 = this;
                var importPaths = {};
                Object.entries(this.storyIndex.stories).forEach(function(_ref3) {
                    var _ref4 = _slicedToArray(_ref3, 2), storyId = _ref4[0], importPath = _ref4[1].importPath;
                    importPaths[importPath] = storyId;
                });
                var csfFilePromiseList = Object.entries(importPaths).map(function(_ref5) {
                    var _ref6 = _slicedToArray(_ref5, 2), importPath = _ref6[0], storyId = _ref6[1];
                    return _this3.loadCSFFileByStoryId(storyId).then(function(csfFile) {
                        return {
                            importPath: importPath,
                            csfFile: csfFile
                        };
                    });
                });
                return (0, _synchronousPromise.SynchronousPromise).all(csfFilePromiseList).then(function(list) {
                    return list.reduce(function(acc, _ref7) {
                        var importPath = _ref7.importPath, csfFile = _ref7.csfFile;
                        acc[importPath] = csfFile;
                        return acc;
                    }, {});
                });
            }
        },
        {
            key: "cacheAllCSFFiles",
            value: function cacheAllCSFFiles() {
                var _this4 = this;
                return this.initializationPromise.then(function() {
                    return _this4.loadAllCSFFiles().then(function(csfFiles) {
                        _this4.cachedCSFFiles = csfFiles;
                    });
                });
            } // Load the CSF file for a story and prepare the story from it and the project annotations.
        },
        {
            key: "loadStory",
            value: function() {
                var _loadStory = _asyncToGenerator(/*#__PURE__*/ regeneratorRuntime.mark(function _callee2(_ref8) {
                    var storyId, csfFile;
                    return regeneratorRuntime.wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                storyId = _ref8.storyId;
                                _context2.next = 3;
                                return this.initializationPromise;
                            case 3:
                                _context2.next = 5;
                                return this.loadCSFFileByStoryId(storyId);
                            case 5:
                                csfFile = _context2.sent;
                                return _context2.abrupt("return", this.storyFromCSFFile({
                                    storyId: storyId,
                                    csfFile: csfFile
                                }));
                            case 7:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function loadStory(_x2) {
                    return _loadStory.apply(this, arguments);
                }
                return loadStory;
            }() // This function is synchronous for convenience -- often times if you have a CSF file already
        },
        {
            key: "storyFromCSFFile",
            value: function storyFromCSFFile(_ref9) {
                var storyId = _ref9.storyId, csfFile = _ref9.csfFile;
                var storyAnnotations = csfFile.stories[storyId];
                if (!storyAnnotations) throw new Error("Didn't find '".concat(storyId, "' in CSF file, this is unexpected"));
                var componentAnnotations = csfFile.meta;
                var story = this.prepareStoryWithCache(storyAnnotations, componentAnnotations, this.projectAnnotations);
                this.args.setInitial(story);
                this.hooks[story.id] = this.hooks[story.id] || new (0, _hooks.HooksContext)();
                return story;
            } // If we have a CSF file we can get all the stories from it synchronously
        },
        {
            key: "componentStoriesFromCSFFile",
            value: function componentStoriesFromCSFFile(_ref10) {
                var _this5 = this;
                var csfFile = _ref10.csfFile;
                return Object.keys(this.storyIndex.stories).filter(function(storyId) {
                    return !!csfFile.stories[storyId];
                }).map(function(storyId) {
                    return _this5.storyFromCSFFile({
                        storyId: storyId,
                        csfFile: csfFile
                    });
                });
            } // A prepared story does not include args, globals or hooks. These are stored in the story store
        },
        {
            key: "getStoryContext",
            value: function getStoryContext(story) {
                return Object.assign({}, story, {
                    args: this.args.get(story.id),
                    globals: this.globals.get(),
                    hooks: this.hooks[story.id]
                });
            }
        },
        {
            key: "cleanupStory",
            value: function cleanupStory(story) {
                this.hooks[story.id].clean();
            }
        },
        {
            key: "extract",
            value: function extract() {
                var _this6 = this;
                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
                    includeDocsOnly: false
                };
                if (!this.cachedCSFFiles) throw new Error("Cannot call extract() unless you call cacheAllCSFFiles() first.");
                return Object.entries(this.storyIndex.stories).reduce(function(acc, _ref11) {
                    var _ref12 = _slicedToArray(_ref11, 2), storyId = _ref12[0], importPath = _ref12[1].importPath;
                    var csfFile = _this6.cachedCSFFiles[importPath];
                    var story = _this6.storyFromCSFFile({
                        storyId: storyId,
                        csfFile: csfFile
                    });
                    if (!options.includeDocsOnly && story.parameters.docsOnly) return acc;
                    acc[storyId] = Object.entries(story).reduce(function(storyAcc, _ref13) {
                        var _ref14 = _slicedToArray(_ref13, 2), key = _ref14[0], value = _ref14[1];
                        if (typeof value === "function") return storyAcc;
                        if (Array.isArray(value)) return Object.assign(storyAcc, _defineProperty({}, key, value.slice().sort()));
                        return Object.assign(storyAcc, _defineProperty({}, key, value));
                    }, {
                        args: story.initialArgs
                    });
                    return acc;
                }, {});
            }
        },
        {
            key: "getSetStoriesPayload",
            value: function getSetStoriesPayload() {
                var stories = this.extract({
                    includeDocsOnly: true
                });
                var kindParameters = Object.values(stories).reduce(function(acc, _ref15) {
                    var title = _ref15.title;
                    acc[title] = {};
                    return acc;
                }, {});
                return {
                    v: 2,
                    globals: this.globals.get(),
                    globalParameters: {},
                    kindParameters: kindParameters,
                    stories: stories
                };
            }
        },
        {
            key: "raw",
            value: function raw() {
                var _this7 = this;
                return Object.values(this.extract()).map(function(_ref16) {
                    var id = _ref16.id;
                    return _this7.fromId(id);
                });
            }
        },
        {
            key: "fromId",
            value: function fromId(storyId) {
                var _this8 = this;
                if (!this.cachedCSFFiles) throw new Error("Cannot call fromId/raw() unless you call cacheAllCSFFiles() first.");
                var importPath;
                try {
                    var _this$storyIndex$stor2 = this.storyIndex.storyIdToEntry(storyId);
                    importPath = _this$storyIndex$stor2.importPath;
                } catch (err) {
                    return null;
                }
                var csfFile = this.cachedCSFFiles[importPath];
                var story = this.storyFromCSFFile({
                    storyId: storyId,
                    csfFile: csfFile
                });
                return Object.assign({}, story, {
                    storyFn: function storyFn(update) {
                        var context = Object.assign({}, _this8.getStoryContext(story), {
                            viewMode: "story"
                        });
                        return story.unboundStoryFn(Object.assign({}, context, update));
                    }
                });
            }
        }
    ]);
    return StoryStore;
}();

},{"core-js/modules/es.object.assign.js":"8FU8M","core-js/modules/es.function.name.js":"4LiLL","core-js/modules/es.object.to-string.js":"lsA9p","core-js/modules/web.dom-collections.for-each.js":"iYT1M","core-js/modules/es.object.entries.js":"7Wf79","core-js/modules/es.array.map.js":"jTP7e","core-js/modules/es.array.filter.js":"fD2da","core-js/modules/es.object.keys.js":"5Q2AT","core-js/modules/es.array.sort.js":"eO5d0","core-js/modules/es.array.slice.js":"8RRh9","core-js/modules/es.object.values.js":"bB8XB","core-js/modules/es.promise.js":"2jax7","core-js/modules/es.symbol.js":"ajw2f","core-js/modules/es.symbol.description.js":"wrlLc","core-js/modules/es.symbol.iterator.js":"fhNIb","core-js/modules/es.array.iterator.js":"ieU20","core-js/modules/es.string.iterator.js":"74a8v","core-js/modules/web.dom-collections.iterator.js":"aXR96","core-js/modules/es.array.from.js":"9UCQw","core-js/modules/es.regexp.exec.js":"5q56v","memoizerific":"a8Efd","lodash/mapValues":"fBbhh","lodash/pick":"gNBP5","global":"5PzlO","synchronous-promise":"dbZce","./StoryIndexStore":"jK5II","./ArgsStore":"al3SN","./GlobalsStore":"2rD22","./csf":"fGMu0","./hooks":"csdah","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"jTP7e":[function(require,module,exports) {
"use strict";
var $ = require("5fce1361821ac187");
var $map = require("a7a3b0905c6ea58c").map;
var arrayMethodHasSpeciesSupport = require("869912db050ffcc6");
var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport("map");
// `Array.prototype.map` method
// https://tc39.es/ecma262/#sec-array.prototype.map
// with adding support of @@species
$({
    target: "Array",
    proto: true,
    forced: !HAS_SPECIES_SUPPORT
}, {
    map: function map(callbackfn /* , thisArg */ ) {
        return $map(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    }
});

},{"5fce1361821ac187":"1OO62","a7a3b0905c6ea58c":"g44dN","869912db050ffcc6":"gkuI7"}],"fD2da":[function(require,module,exports) {
"use strict";
var $ = require("a465bc55e057d26f");
var $filter = require("fa9926c68c33923f").filter;
var arrayMethodHasSpeciesSupport = require("9232c94be2f9c639");
var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport("filter");
// `Array.prototype.filter` method
// https://tc39.es/ecma262/#sec-array.prototype.filter
// with adding support of @@species
$({
    target: "Array",
    proto: true,
    forced: !HAS_SPECIES_SUPPORT
}, {
    filter: function filter(callbackfn /* , thisArg */ ) {
        return $filter(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    }
});

},{"a465bc55e057d26f":"1OO62","fa9926c68c33923f":"g44dN","9232c94be2f9c639":"gkuI7"}],"eO5d0":[function(require,module,exports) {
"use strict";
var $ = require("bcbafe2730da3578");
var uncurryThis = require("45fd6781824a0ecc");
var aCallable = require("227e835045b72b76");
var toObject = require("d460a9dbedc2e639");
var lengthOfArrayLike = require("eb5d266a4b580e05");
var toString = require("2874e3c4ed670355");
var fails = require("b077ecec4e3b8790");
var internalSort = require("b1c0993c5b4a0232");
var arrayMethodIsStrict = require("fc67c1f531962716");
var FF = require("d69ea6be1bb99924");
var IE_OR_EDGE = require("8253d815c700c0e7");
var V8 = require("6f1ae2ccfb1802c");
var WEBKIT = require("5c6ca60d2186681e");
var test = [];
var un$Sort = uncurryThis(test.sort);
var push = uncurryThis(test.push);
// IE8-
var FAILS_ON_UNDEFINED = fails(function() {
    test.sort(undefined);
});
// V8 bug
var FAILS_ON_NULL = fails(function() {
    test.sort(null);
});
// Old WebKit
var STRICT_METHOD = arrayMethodIsStrict("sort");
var STABLE_SORT = !fails(function() {
    // feature detection can be too slow, so check engines versions
    if (V8) return V8 < 70;
    if (FF && FF > 3) return;
    if (IE_OR_EDGE) return true;
    if (WEBKIT) return WEBKIT < 603;
    var result = "";
    var code, chr, value, index;
    // generate an array with more 512 elements (Chakra and old V8 fails only in this case)
    for(code = 65; code < 76; code++){
        chr = String.fromCharCode(code);
        switch(code){
            case 66:
            case 69:
            case 70:
            case 72:
                value = 3;
                break;
            case 68:
            case 71:
                value = 4;
                break;
            default:
                value = 2;
        }
        for(index = 0; index < 47; index++)test.push({
            k: chr + index,
            v: value
        });
    }
    test.sort(function(a, b) {
        return b.v - a.v;
    });
    for(index = 0; index < test.length; index++){
        chr = test[index].k.charAt(0);
        if (result.charAt(result.length - 1) !== chr) result += chr;
    }
    return result !== "DGBEFHACIJK";
});
var FORCED = FAILS_ON_UNDEFINED || !FAILS_ON_NULL || !STRICT_METHOD || !STABLE_SORT;
var getSortCompare = function(comparefn) {
    return function(x, y) {
        if (y === undefined) return -1;
        if (x === undefined) return 1;
        if (comparefn !== undefined) return +comparefn(x, y) || 0;
        return toString(x) > toString(y) ? 1 : -1;
    };
};
// `Array.prototype.sort` method
// https://tc39.es/ecma262/#sec-array.prototype.sort
$({
    target: "Array",
    proto: true,
    forced: FORCED
}, {
    sort: function sort(comparefn) {
        if (comparefn !== undefined) aCallable(comparefn);
        var array = toObject(this);
        if (STABLE_SORT) return comparefn === undefined ? un$Sort(array) : un$Sort(array, comparefn);
        var items = [];
        var arrayLength = lengthOfArrayLike(array);
        var itemsLength, index;
        for(index = 0; index < arrayLength; index++)if (index in array) push(items, array[index]);
        internalSort(items, getSortCompare(comparefn));
        itemsLength = items.length;
        index = 0;
        while(index < itemsLength)array[index] = items[index++];
        while(index < arrayLength)delete array[index++];
        return array;
    }
});

},{"bcbafe2730da3578":"1OO62","45fd6781824a0ecc":"fP9tv","227e835045b72b76":"keisz","d460a9dbedc2e639":"7K2H5","eb5d266a4b580e05":"ckDDq","2874e3c4ed670355":"8RVGu","b077ecec4e3b8790":"keKlS","b1c0993c5b4a0232":"tC0DW","fc67c1f531962716":"h0N6r","d69ea6be1bb99924":"97ugf","8253d815c700c0e7":"aGn8R","6f1ae2ccfb1802c":"g2xJU","5c6ca60d2186681e":"2dED8"}],"tC0DW":[function(require,module,exports) {
var arraySlice = require("477ba4a4642e124b");
var floor = Math.floor;
var mergeSort = function(array, comparefn) {
    var length = array.length;
    var middle = floor(length / 2);
    return length < 8 ? insertionSort(array, comparefn) : merge(array, mergeSort(arraySlice(array, 0, middle), comparefn), mergeSort(arraySlice(array, middle), comparefn), comparefn);
};
var insertionSort = function(array, comparefn) {
    var length = array.length;
    var i = 1;
    var element, j;
    while(i < length){
        j = i;
        element = array[i];
        while(j && comparefn(array[j - 1], element) > 0)array[j] = array[--j];
        if (j !== i++) array[j] = element;
    }
    return array;
};
var merge = function(array, left, right, comparefn) {
    var llength = left.length;
    var rlength = right.length;
    var lindex = 0;
    var rindex = 0;
    while(lindex < llength || rindex < rlength)array[lindex + rindex] = lindex < llength && rindex < rlength ? comparefn(left[lindex], right[rindex]) <= 0 ? left[lindex++] : right[rindex++] : lindex < llength ? left[lindex++] : right[rindex++];
    return array;
};
module.exports = mergeSort;

},{"477ba4a4642e124b":"hloI5"}],"97ugf":[function(require,module,exports) {
var userAgent = require("c0a07648c54af5d8");
var firefox = userAgent.match(/firefox\/(\d+)/i);
module.exports = !!firefox && +firefox[1];

},{"c0a07648c54af5d8":"lylPP"}],"aGn8R":[function(require,module,exports) {
var UA = require("e9f31963276495fe");
module.exports = /MSIE|Trident/.test(UA);

},{"e9f31963276495fe":"lylPP"}],"2dED8":[function(require,module,exports) {
var userAgent = require("193c3f8d9ac1b969");
var webkit = userAgent.match(/AppleWebKit\/(\d+)\./);
module.exports = !!webkit && +webkit[1];

},{"193c3f8d9ac1b969":"lylPP"}],"2jax7":[function(require,module,exports) {
"use strict";
var $ = require("c6725469b54c1bb1");
var IS_PURE = require("780cc9d7383fadff");
var global = require("9181b3dcdff515a1");
var getBuiltIn = require("144be875f409d36b");
var call = require("c02d6c47f47a1930");
var NativePromise = require("5ed09da120635bec");
var redefine = require("dbd936d592180407");
var redefineAll = require("c7fbabaa84b845e2");
var setPrototypeOf = require("228dcfb0a6d6dba9");
var setToStringTag = require("540bc1ec9f4350c1");
var setSpecies = require("fa526f077d475298");
var aCallable = require("93b4c376210b31f5");
var isCallable = require("c3e32b6ab6e6f605");
var isObject = require("c2d2c7ff7560ba49");
var anInstance = require("ff459fdb105019cb");
var inspectSource = require("65ef37ca6244eae1");
var iterate = require("18d6e61597ea9f81");
var checkCorrectnessOfIteration = require("d0220b95d716898a");
var speciesConstructor = require("f6ccaeb8cb7b8d63");
var task = require("67fe8ae1163d7bcd").set;
var microtask = require("d08460e0bcbc3a48");
var promiseResolve = require("21661d1f60039a65");
var hostReportErrors = require("f1eeb31b4fd2023");
var newPromiseCapabilityModule = require("9bb1631eaaedabf3");
var perform = require("da7df8d41d388b89");
var InternalStateModule = require("9baf9eda61e7a5d0");
var isForced = require("674c2cadbfa1fa11");
var wellKnownSymbol = require("1525113331180acb");
var IS_BROWSER = require("e9a65e9c406c2d9b");
var IS_NODE = require("b0ca43f5c954efeb");
var V8_VERSION = require("60102e45f072af67");
var SPECIES = wellKnownSymbol("species");
var PROMISE = "Promise";
var getInternalState = InternalStateModule.get;
var setInternalState = InternalStateModule.set;
var getInternalPromiseState = InternalStateModule.getterFor(PROMISE);
var NativePromisePrototype = NativePromise && NativePromise.prototype;
var PromiseConstructor = NativePromise;
var PromisePrototype = NativePromisePrototype;
var TypeError = global.TypeError;
var document = global.document;
var process = global.process;
var newPromiseCapability = newPromiseCapabilityModule.f;
var newGenericPromiseCapability = newPromiseCapability;
var DISPATCH_EVENT = !!(document && document.createEvent && global.dispatchEvent);
var NATIVE_REJECTION_EVENT = isCallable(global.PromiseRejectionEvent);
var UNHANDLED_REJECTION = "unhandledrejection";
var REJECTION_HANDLED = "rejectionhandled";
var PENDING = 0;
var FULFILLED = 1;
var REJECTED = 2;
var HANDLED = 1;
var UNHANDLED = 2;
var SUBCLASSING = false;
var Internal, OwnPromiseCapability, PromiseWrapper, nativeThen;
var FORCED = isForced(PROMISE, function() {
    var PROMISE_CONSTRUCTOR_SOURCE = inspectSource(PromiseConstructor);
    var GLOBAL_CORE_JS_PROMISE = PROMISE_CONSTRUCTOR_SOURCE !== String(PromiseConstructor);
    // V8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
    // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
    // We can't detect it synchronously, so just check versions
    if (!GLOBAL_CORE_JS_PROMISE && V8_VERSION === 66) return true;
    // We need Promise#finally in the pure version for preventing prototype pollution
    if (IS_PURE && !PromisePrototype["finally"]) return true;
    // We can't use @@species feature detection in V8 since it causes
    // deoptimization and performance degradation
    // https://github.com/zloirock/core-js/issues/679
    if (V8_VERSION >= 51 && /native code/.test(PROMISE_CONSTRUCTOR_SOURCE)) return false;
    // Detect correctness of subclassing with @@species support
    var promise = new PromiseConstructor(function(resolve) {
        resolve(1);
    });
    var FakePromise = function(exec) {
        exec(function() {}, function() {});
    };
    var constructor = promise.constructor = {};
    constructor[SPECIES] = FakePromise;
    SUBCLASSING = promise.then(function() {}) instanceof FakePromise;
    if (!SUBCLASSING) return true;
    // Unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return !GLOBAL_CORE_JS_PROMISE && IS_BROWSER && !NATIVE_REJECTION_EVENT;
});
var INCORRECT_ITERATION = FORCED || !checkCorrectnessOfIteration(function(iterable) {
    PromiseConstructor.all(iterable)["catch"](function() {});
});
// helpers
var isThenable = function(it) {
    var then;
    return isObject(it) && isCallable(then = it.then) ? then : false;
};
var notify = function(state, isReject) {
    if (state.notified) return;
    state.notified = true;
    var chain = state.reactions;
    microtask(function() {
        var value = state.value;
        var ok = state.state == FULFILLED;
        var index = 0;
        // variable length - can't use forEach
        while(chain.length > index){
            var reaction = chain[index++];
            var handler = ok ? reaction.ok : reaction.fail;
            var resolve = reaction.resolve;
            var reject = reaction.reject;
            var domain = reaction.domain;
            var result, then, exited;
            try {
                if (handler) {
                    if (!ok) {
                        if (state.rejection === UNHANDLED) onHandleUnhandled(state);
                        state.rejection = HANDLED;
                    }
                    if (handler === true) result = value;
                    else {
                        if (domain) domain.enter();
                        result = handler(value); // can throw
                        if (domain) {
                            domain.exit();
                            exited = true;
                        }
                    }
                    if (result === reaction.promise) reject(TypeError("Promise-chain cycle"));
                    else if (then = isThenable(result)) call(then, result, resolve, reject);
                    else resolve(result);
                } else reject(value);
            } catch (error) {
                if (domain && !exited) domain.exit();
                reject(error);
            }
        }
        state.reactions = [];
        state.notified = false;
        if (isReject && !state.rejection) onUnhandled(state);
    });
};
var dispatchEvent = function(name, promise, reason) {
    var event, handler;
    if (DISPATCH_EVENT) {
        event = document.createEvent("Event");
        event.promise = promise;
        event.reason = reason;
        event.initEvent(name, false, true);
        global.dispatchEvent(event);
    } else event = {
        promise: promise,
        reason: reason
    };
    if (!NATIVE_REJECTION_EVENT && (handler = global["on" + name])) handler(event);
    else if (name === UNHANDLED_REJECTION) hostReportErrors("Unhandled promise rejection", reason);
};
var onUnhandled = function(state) {
    call(task, global, function() {
        var promise = state.facade;
        var value = state.value;
        var IS_UNHANDLED = isUnhandled(state);
        var result;
        if (IS_UNHANDLED) {
            result = perform(function() {
                if (IS_NODE) process.emit("unhandledRejection", value, promise);
                else dispatchEvent(UNHANDLED_REJECTION, promise, value);
            });
            // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
            state.rejection = IS_NODE || isUnhandled(state) ? UNHANDLED : HANDLED;
            if (result.error) throw result.value;
        }
    });
};
var isUnhandled = function(state) {
    return state.rejection !== HANDLED && !state.parent;
};
var onHandleUnhandled = function(state) {
    call(task, global, function() {
        var promise = state.facade;
        if (IS_NODE) process.emit("rejectionHandled", promise);
        else dispatchEvent(REJECTION_HANDLED, promise, state.value);
    });
};
var bind = function(fn, state, unwrap) {
    return function(value) {
        fn(state, value, unwrap);
    };
};
var internalReject = function(state, value, unwrap) {
    if (state.done) return;
    state.done = true;
    if (unwrap) state = unwrap;
    state.value = value;
    state.state = REJECTED;
    notify(state, true);
};
var internalResolve = function(state, value, unwrap) {
    if (state.done) return;
    state.done = true;
    if (unwrap) state = unwrap;
    try {
        if (state.facade === value) throw TypeError("Promise can't be resolved itself");
        var then = isThenable(value);
        if (then) microtask(function() {
            var wrapper = {
                done: false
            };
            try {
                call(then, value, bind(internalResolve, wrapper, state), bind(internalReject, wrapper, state));
            } catch (error) {
                internalReject(wrapper, error, state);
            }
        });
        else {
            state.value = value;
            state.state = FULFILLED;
            notify(state, false);
        }
    } catch (error) {
        internalReject({
            done: false
        }, error, state);
    }
};
// constructor polyfill
if (FORCED) {
    // 25.4.3.1 Promise(executor)
    PromiseConstructor = function Promise(executor) {
        anInstance(this, PromisePrototype);
        aCallable(executor);
        call(Internal, this);
        var state = getInternalState(this);
        try {
            executor(bind(internalResolve, state), bind(internalReject, state));
        } catch (error) {
            internalReject(state, error);
        }
    };
    PromisePrototype = PromiseConstructor.prototype;
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    Internal = function Promise(executor) {
        setInternalState(this, {
            type: PROMISE,
            done: false,
            notified: false,
            parent: false,
            reactions: [],
            rejection: false,
            state: PENDING,
            value: undefined
        });
    };
    Internal.prototype = redefineAll(PromisePrototype, {
        // `Promise.prototype.then` method
        // https://tc39.es/ecma262/#sec-promise.prototype.then
        then: function then(onFulfilled, onRejected) {
            var state = getInternalPromiseState(this);
            var reactions = state.reactions;
            var reaction = newPromiseCapability(speciesConstructor(this, PromiseConstructor));
            reaction.ok = isCallable(onFulfilled) ? onFulfilled : true;
            reaction.fail = isCallable(onRejected) && onRejected;
            reaction.domain = IS_NODE ? process.domain : undefined;
            state.parent = true;
            reactions[reactions.length] = reaction;
            if (state.state != PENDING) notify(state, false);
            return reaction.promise;
        },
        // `Promise.prototype.catch` method
        // https://tc39.es/ecma262/#sec-promise.prototype.catch
        "catch": function(onRejected) {
            return this.then(undefined, onRejected);
        }
    });
    OwnPromiseCapability = function() {
        var promise = new Internal();
        var state = getInternalState(promise);
        this.promise = promise;
        this.resolve = bind(internalResolve, state);
        this.reject = bind(internalReject, state);
    };
    newPromiseCapabilityModule.f = newPromiseCapability = function(C) {
        return C === PromiseConstructor || C === PromiseWrapper ? new OwnPromiseCapability(C) : newGenericPromiseCapability(C);
    };
    if (!IS_PURE && isCallable(NativePromise) && NativePromisePrototype !== Object.prototype) {
        nativeThen = NativePromisePrototype.then;
        if (!SUBCLASSING) {
            // make `Promise#then` return a polyfilled `Promise` for native promise-based APIs
            redefine(NativePromisePrototype, "then", function then(onFulfilled, onRejected) {
                var that = this;
                return new PromiseConstructor(function(resolve, reject) {
                    call(nativeThen, that, resolve, reject);
                }).then(onFulfilled, onRejected);
            // https://github.com/zloirock/core-js/issues/640
            }, {
                unsafe: true
            });
            // makes sure that native promise-based APIs `Promise#catch` properly works with patched `Promise#then`
            redefine(NativePromisePrototype, "catch", PromisePrototype["catch"], {
                unsafe: true
            });
        }
        // make `.constructor === Promise` work for native promise-based APIs
        try {
            delete NativePromisePrototype.constructor;
        } catch (error) {}
        // make `instanceof Promise` work for native promise-based APIs
        if (setPrototypeOf) setPrototypeOf(NativePromisePrototype, PromisePrototype);
    }
}
$({
    global: true,
    wrap: true,
    forced: FORCED
}, {
    Promise: PromiseConstructor
});
setToStringTag(PromiseConstructor, PROMISE, false, true);
setSpecies(PROMISE);
PromiseWrapper = getBuiltIn(PROMISE);
// statics
$({
    target: PROMISE,
    stat: true,
    forced: FORCED
}, {
    // `Promise.reject` method
    // https://tc39.es/ecma262/#sec-promise.reject
    reject: function reject(r) {
        var capability = newPromiseCapability(this);
        call(capability.reject, undefined, r);
        return capability.promise;
    }
});
$({
    target: PROMISE,
    stat: true,
    forced: IS_PURE || FORCED
}, {
    // `Promise.resolve` method
    // https://tc39.es/ecma262/#sec-promise.resolve
    resolve: function resolve(x) {
        return promiseResolve(IS_PURE && this === PromiseWrapper ? PromiseConstructor : this, x);
    }
});
$({
    target: PROMISE,
    stat: true,
    forced: INCORRECT_ITERATION
}, {
    // `Promise.all` method
    // https://tc39.es/ecma262/#sec-promise.all
    all: function all(iterable) {
        var C = this;
        var capability = newPromiseCapability(C);
        var resolve = capability.resolve;
        var reject = capability.reject;
        var result = perform(function() {
            var $promiseResolve = aCallable(C.resolve);
            var values = [];
            var counter = 0;
            var remaining = 1;
            iterate(iterable, function(promise) {
                var index = counter++;
                var alreadyCalled = false;
                remaining++;
                call($promiseResolve, C, promise).then(function(value) {
                    if (alreadyCalled) return;
                    alreadyCalled = true;
                    values[index] = value;
                    --remaining || resolve(values);
                }, reject);
            });
            --remaining || resolve(values);
        });
        if (result.error) reject(result.value);
        return capability.promise;
    },
    // `Promise.race` method
    // https://tc39.es/ecma262/#sec-promise.race
    race: function race(iterable) {
        var C = this;
        var capability = newPromiseCapability(C);
        var reject = capability.reject;
        var result = perform(function() {
            var $promiseResolve = aCallable(C.resolve);
            iterate(iterable, function(promise) {
                call($promiseResolve, C, promise).then(capability.resolve, reject);
            });
        });
        if (result.error) reject(result.value);
        return capability.promise;
    }
});

},{"c6725469b54c1bb1":"1OO62","780cc9d7383fadff":"bZbjq","9181b3dcdff515a1":"1GZc4","144be875f409d36b":"bQFzp","c02d6c47f47a1930":"aSvFj","5ed09da120635bec":"8PtRW","dbd936d592180407":"3ncOy","c7fbabaa84b845e2":"b48Cu","228dcfb0a6d6dba9":"hT4Io","540bc1ec9f4350c1":"hVfEJ","fa526f077d475298":"46zEr","93b4c376210b31f5":"keisz","c3e32b6ab6e6f605":"cVxS9","c2d2c7ff7560ba49":"bprny","ff459fdb105019cb":"kZWyK","65ef37ca6244eae1":"80OOF","18d6e61597ea9f81":"9EwlZ","d0220b95d716898a":"gUryt","f6ccaeb8cb7b8d63":"lQLt0","67fe8ae1163d7bcd":"01r34","d08460e0bcbc3a48":"AeAVo","21661d1f60039a65":"2fP53","f1eeb31b4fd2023":"19xVs","9bb1631eaaedabf3":"k36GX","da7df8d41d388b89":"bVqLJ","9baf9eda61e7a5d0":"bRWxa","674c2cadbfa1fa11":"j3Sfj","1525113331180acb":"kbsMI","e9a65e9c406c2d9b":"k5ogb","b0ca43f5c954efeb":"icRys","60102e45f072af67":"g2xJU"}],"8PtRW":[function(require,module,exports) {
var global = require("fdb27afcf58add0b");
module.exports = global.Promise;

},{"fdb27afcf58add0b":"1GZc4"}],"lQLt0":[function(require,module,exports) {
var anObject = require("1dd3546388607f52");
var aConstructor = require("1407b26f20411731");
var wellKnownSymbol = require("16c256a8cc3c03fd");
var SPECIES = wellKnownSymbol("species");
// `SpeciesConstructor` abstract operation
// https://tc39.es/ecma262/#sec-speciesconstructor
module.exports = function(O, defaultConstructor) {
    var C = anObject(O).constructor;
    var S;
    return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? defaultConstructor : aConstructor(S);
};

},{"1dd3546388607f52":"39qAm","1407b26f20411731":"bbx5w","16c256a8cc3c03fd":"kbsMI"}],"bbx5w":[function(require,module,exports) {
var global = require("54d0bd95a2a1da13");
var isConstructor = require("f0753b26326019c1");
var tryToString = require("8e6a26f37529644e");
var TypeError = global.TypeError;
// `Assert: IsConstructor(argument) is true`
module.exports = function(argument) {
    if (isConstructor(argument)) return argument;
    throw TypeError(tryToString(argument) + " is not a constructor");
};

},{"54d0bd95a2a1da13":"1GZc4","f0753b26326019c1":"9K6ap","8e6a26f37529644e":"1vkHL"}],"01r34":[function(require,module,exports) {
var global = require("1e8ed58235e9956a");
var apply = require("e574be68c288c7c8");
var bind = require("df212787338802d3");
var isCallable = require("afdf018c2d01bbc6");
var hasOwn = require("35a3e849940fd612");
var fails = require("b8bf5434d2248ca7");
var html = require("731f9370cc21fc3b");
var arraySlice = require("ec358060964e4bde");
var createElement = require("907adb6d219da7a3");
var IS_IOS = require("fdfdeccf85e81d4f");
var IS_NODE = require("fcf929779abbf29c");
var set = global.setImmediate;
var clear = global.clearImmediate;
var process = global.process;
var Dispatch = global.Dispatch;
var Function = global.Function;
var MessageChannel = global.MessageChannel;
var String = global.String;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = "onreadystatechange";
var location, defer, channel, port;
try {
    // Deno throws a ReferenceError on `location` access without `--location` flag
    location = global.location;
} catch (error) {}
var run = function(id) {
    if (hasOwn(queue, id)) {
        var fn = queue[id];
        delete queue[id];
        fn();
    }
};
var runner = function(id) {
    return function() {
        run(id);
    };
};
var listener = function(event) {
    run(event.data);
};
var post = function(id) {
    // old engines have not location.origin
    global.postMessage(String(id), location.protocol + "//" + location.host);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!set || !clear) {
    set = function setImmediate(fn) {
        var args = arraySlice(arguments, 1);
        queue[++counter] = function() {
            apply(isCallable(fn) ? fn : Function(fn), undefined, args);
        };
        defer(counter);
        return counter;
    };
    clear = function clearImmediate(id) {
        delete queue[id];
    };
    // Node.js 0.8-
    if (IS_NODE) defer = function(id) {
        process.nextTick(runner(id));
    };
    else if (Dispatch && Dispatch.now) defer = function(id) {
        Dispatch.now(runner(id));
    };
    else if (MessageChannel && !IS_IOS) {
        channel = new MessageChannel();
        port = channel.port2;
        channel.port1.onmessage = listener;
        defer = bind(port.postMessage, port);
    // Browsers with postMessage, skip WebWorkers
    // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
    } else if (global.addEventListener && isCallable(global.postMessage) && !global.importScripts && location && location.protocol !== "file:" && !fails(post)) {
        defer = post;
        global.addEventListener("message", listener, false);
    // IE8-
    } else if (ONREADYSTATECHANGE in createElement("script")) defer = function(id) {
        html.appendChild(createElement("script"))[ONREADYSTATECHANGE] = function() {
            html.removeChild(this);
            run(id);
        };
    };
    else defer = function(id) {
        setTimeout(runner(id), 0);
    };
}
module.exports = {
    set: set,
    clear: clear
};

},{"1e8ed58235e9956a":"1GZc4","e574be68c288c7c8":"QdiN4","df212787338802d3":"lgzZz","afdf018c2d01bbc6":"cVxS9","35a3e849940fd612":"4SzRl","b8bf5434d2248ca7":"keKlS","731f9370cc21fc3b":"du4gP","ec358060964e4bde":"hloI5","907adb6d219da7a3":"gjZdB","fdfdeccf85e81d4f":"4Nx8X","fcf929779abbf29c":"icRys"}],"4Nx8X":[function(require,module,exports) {
var userAgent = require("d96985a79ddda108");
module.exports = /(?:ipad|iphone|ipod).*applewebkit/i.test(userAgent);

},{"d96985a79ddda108":"lylPP"}],"icRys":[function(require,module,exports) {
var classof = require("779f783a397f138");
var global = require("1b4555a3a97d5ef1");
module.exports = classof(global.process) == "process";

},{"779f783a397f138":"6FZJh","1b4555a3a97d5ef1":"1GZc4"}],"AeAVo":[function(require,module,exports) {
var global = require("f9ebf18f73555047");
var bind = require("c6f841b26dc6586e");
var getOwnPropertyDescriptor = require("781a5ba2823dd7a6").f;
var macrotask = require("e7b8d665c6b82c12").set;
var IS_IOS = require("78206ea6a34f1432");
var IS_IOS_PEBBLE = require("810a6a1623ff46c9");
var IS_WEBOS_WEBKIT = require("be9a795f3265135a");
var IS_NODE = require("a854b07044df85f9");
var MutationObserver = global.MutationObserver || global.WebKitMutationObserver;
var document = global.document;
var process = global.process;
var Promise = global.Promise;
// Node.js 11 shows ExperimentalWarning on getting `queueMicrotask`
var queueMicrotaskDescriptor = getOwnPropertyDescriptor(global, "queueMicrotask");
var queueMicrotask = queueMicrotaskDescriptor && queueMicrotaskDescriptor.value;
var flush, head, last, notify, toggle, node, promise, then;
// modern engines have queueMicrotask method
if (!queueMicrotask) {
    flush = function() {
        var parent, fn;
        if (IS_NODE && (parent = process.domain)) parent.exit();
        while(head){
            fn = head.fn;
            head = head.next;
            try {
                fn();
            } catch (error) {
                if (head) notify();
                else last = undefined;
                throw error;
            }
        }
        last = undefined;
        if (parent) parent.enter();
    };
    // browsers with MutationObserver, except iOS - https://github.com/zloirock/core-js/issues/339
    // also except WebOS Webkit https://github.com/zloirock/core-js/issues/898
    if (!IS_IOS && !IS_NODE && !IS_WEBOS_WEBKIT && MutationObserver && document) {
        toggle = true;
        node = document.createTextNode("");
        new MutationObserver(flush).observe(node, {
            characterData: true
        });
        notify = function() {
            node.data = toggle = !toggle;
        };
    // environments with maybe non-completely correct, but existent Promise
    } else if (!IS_IOS_PEBBLE && Promise && Promise.resolve) {
        // Promise.resolve without an argument throws an error in LG WebOS 2
        promise = Promise.resolve(undefined);
        // workaround of WebKit ~ iOS Safari 10.1 bug
        promise.constructor = Promise;
        then = bind(promise.then, promise);
        notify = function() {
            then(flush);
        };
    // Node.js without promises
    } else if (IS_NODE) notify = function() {
        process.nextTick(flush);
    };
    else {
        // strange IE + webpack dev server bug - use .bind(global)
        macrotask = bind(macrotask, global);
        notify = function() {
            macrotask(flush);
        };
    }
}
module.exports = queueMicrotask || function(fn) {
    var task = {
        fn: fn,
        next: undefined
    };
    if (last) last.next = task;
    if (!head) {
        head = task;
        notify();
    }
    last = task;
};

},{"f9ebf18f73555047":"1GZc4","c6f841b26dc6586e":"lgzZz","781a5ba2823dd7a6":"8cErP","e7b8d665c6b82c12":"01r34","78206ea6a34f1432":"4Nx8X","810a6a1623ff46c9":"aF5zM","be9a795f3265135a":"6eRU4","a854b07044df85f9":"icRys"}],"aF5zM":[function(require,module,exports) {
var userAgent = require("2c9b1afd0f0a383e");
var global = require("8cacda33afd00cbc");
module.exports = /ipad|iphone|ipod/i.test(userAgent) && global.Pebble !== undefined;

},{"2c9b1afd0f0a383e":"lylPP","8cacda33afd00cbc":"1GZc4"}],"6eRU4":[function(require,module,exports) {
var userAgent = require("da9a948bcd2e316f");
module.exports = /web0s(?!.*chrome)/i.test(userAgent);

},{"da9a948bcd2e316f":"lylPP"}],"2fP53":[function(require,module,exports) {
var anObject = require("5304a07f7517b45f");
var isObject = require("6179ead91f16d16e");
var newPromiseCapability = require("1e7f70c2e43192d5");
module.exports = function(C, x) {
    anObject(C);
    if (isObject(x) && x.constructor === C) return x;
    var promiseCapability = newPromiseCapability.f(C);
    var resolve = promiseCapability.resolve;
    resolve(x);
    return promiseCapability.promise;
};

},{"5304a07f7517b45f":"39qAm","6179ead91f16d16e":"bprny","1e7f70c2e43192d5":"k36GX"}],"k36GX":[function(require,module,exports) {
"use strict";
var aCallable = require("b85cb5089dafddf1");
var PromiseCapability = function(C) {
    var resolve, reject;
    this.promise = new C(function($$resolve, $$reject) {
        if (resolve !== undefined || reject !== undefined) throw TypeError("Bad Promise constructor");
        resolve = $$resolve;
        reject = $$reject;
    });
    this.resolve = aCallable(resolve);
    this.reject = aCallable(reject);
};
// `NewPromiseCapability` abstract operation
// https://tc39.es/ecma262/#sec-newpromisecapability
module.exports.f = function(C) {
    return new PromiseCapability(C);
};

},{"b85cb5089dafddf1":"keisz"}],"19xVs":[function(require,module,exports) {
var global = require("84bdd1d2065acc77");
module.exports = function(a, b) {
    var console = global.console;
    if (console && console.error) arguments.length == 1 ? console.error(a) : console.error(a, b);
};

},{"84bdd1d2065acc77":"1GZc4"}],"bVqLJ":[function(require,module,exports) {
module.exports = function(exec) {
    try {
        return {
            error: false,
            value: exec()
        };
    } catch (error) {
        return {
            error: true,
            value: error
        };
    }
};

},{}],"k5ogb":[function(require,module,exports) {
module.exports = typeof window == "object";

},{}],"a8Efd":[function(require,module,exports) {
(function(f) {
    var g;
    module.exports = f();
})(function() {
    var define, module1, exports;
    return (function e(t, n, r) {
        function s(o, u) {
            if (!n[o]) {
                if (!t[o]) {
                    var a = undefined;
                    if (!u && a) return a(o, !0);
                    if (i) return i(o, !0);
                    var f = new Error("Cannot find module '" + o + "'");
                    throw f.code = "MODULE_NOT_FOUND", f;
                }
                var l = n[o] = {
                    exports: {}
                };
                t[o][0].call(l.exports, function(e) {
                    var n = t[o][1][e];
                    return s(n ? n : e);
                }, l, l.exports, e, t, n, r);
            }
            return n[o].exports;
        }
        var i = undefined;
        for(var o = 0; o < r.length; o++)s(r[o]);
        return s;
    })({
        1: [
            function(_dereq_, module1, exports) {
                module1.exports = function(forceSimilar) {
                    if (typeof Map !== "function" || forceSimilar) {
                        var Similar = _dereq_("./similar");
                        return new Similar();
                    } else return new Map();
                };
            },
            {
                "./similar": 2
            }
        ],
        2: [
            function(_dereq_, module1, exports) {
                function Similar() {
                    this.list = [];
                    this.lastItem = undefined;
                    this.size = 0;
                    return this;
                }
                Similar.prototype.get = function(key) {
                    var index;
                    if (this.lastItem && this.isEqual(this.lastItem.key, key)) return this.lastItem.val;
                    index = this.indexOf(key);
                    if (index >= 0) {
                        this.lastItem = this.list[index];
                        return this.list[index].val;
                    }
                    return undefined;
                };
                Similar.prototype.set = function(key, val) {
                    var index;
                    if (this.lastItem && this.isEqual(this.lastItem.key, key)) {
                        this.lastItem.val = val;
                        return this;
                    }
                    index = this.indexOf(key);
                    if (index >= 0) {
                        this.lastItem = this.list[index];
                        this.list[index].val = val;
                        return this;
                    }
                    this.lastItem = {
                        key: key,
                        val: val
                    };
                    this.list.push(this.lastItem);
                    this.size++;
                    return this;
                };
                Similar.prototype.delete = function(key) {
                    var index;
                    if (this.lastItem && this.isEqual(this.lastItem.key, key)) this.lastItem = undefined;
                    index = this.indexOf(key);
                    if (index >= 0) {
                        this.size--;
                        return this.list.splice(index, 1)[0];
                    }
                    return undefined;
                };
                // important that has() doesn't use get() in case an existing key has a falsy value, in which case has() would return false
                Similar.prototype.has = function(key) {
                    var index;
                    if (this.lastItem && this.isEqual(this.lastItem.key, key)) return true;
                    index = this.indexOf(key);
                    if (index >= 0) {
                        this.lastItem = this.list[index];
                        return true;
                    }
                    return false;
                };
                Similar.prototype.forEach = function(callback, thisArg) {
                    var i;
                    for(i = 0; i < this.size; i++)callback.call(thisArg || this, this.list[i].val, this.list[i].key, this);
                };
                Similar.prototype.indexOf = function(key) {
                    var i;
                    for(i = 0; i < this.size; i++){
                        if (this.isEqual(this.list[i].key, key)) return i;
                    }
                    return -1;
                };
                // check if the numbers are equal, or whether they are both precisely NaN (isNaN returns true for all non-numbers)
                Similar.prototype.isEqual = function(val1, val2) {
                    return val1 === val2 || val1 !== val1 && val2 !== val2;
                };
                module1.exports = Similar;
            },
            {}
        ],
        3: [
            function(_dereq_, module1, exports) {
                var MapOrSimilar = _dereq_("map-or-similar");
                module1.exports = function(limit) {
                    var cache = new MapOrSimilar(false), lru = [];
                    return function(fn) {
                        var memoizerific = function() {
                            var currentCache = cache, newMap, fnResult, argsLengthMinusOne = arguments.length - 1, lruPath = Array(argsLengthMinusOne + 1), isMemoized = true, i;
                            if ((memoizerific.numArgs || memoizerific.numArgs === 0) && memoizerific.numArgs !== argsLengthMinusOne + 1) throw new Error("Memoizerific functions should always be called with the same number of arguments");
                            // loop through each argument to traverse the map tree
                            for(i = 0; i < argsLengthMinusOne; i++){
                                lruPath[i] = {
                                    cacheItem: currentCache,
                                    arg: arguments[i]
                                };
                                // climb through the hierarchical map tree until the second-last argument has been found, or an argument is missing.
                                // if all arguments up to the second-last have been found, this will potentially be a cache hit (determined later)
                                if (currentCache.has(arguments[i])) {
                                    currentCache = currentCache.get(arguments[i]);
                                    continue;
                                }
                                isMemoized = false;
                                // make maps until last value
                                newMap = new MapOrSimilar(false);
                                currentCache.set(arguments[i], newMap);
                                currentCache = newMap;
                            }
                            // we are at the last arg, check if it is really memoized
                            if (isMemoized) {
                                if (currentCache.has(arguments[argsLengthMinusOne])) fnResult = currentCache.get(arguments[argsLengthMinusOne]);
                                else isMemoized = false;
                            }
                            if (!isMemoized) {
                                fnResult = fn.apply(null, arguments);
                                currentCache.set(arguments[argsLengthMinusOne], fnResult);
                            }
                            if (limit > 0) {
                                lruPath[argsLengthMinusOne] = {
                                    cacheItem: currentCache,
                                    arg: arguments[argsLengthMinusOne]
                                };
                                if (isMemoized) moveToMostRecentLru(lru, lruPath);
                                else lru.push(lruPath);
                                if (lru.length > limit) removeCachedResult(lru.shift());
                            }
                            memoizerific.wasMemoized = isMemoized;
                            memoizerific.numArgs = argsLengthMinusOne + 1;
                            return fnResult;
                        };
                        memoizerific.limit = limit;
                        memoizerific.wasMemoized = false;
                        memoizerific.cache = cache;
                        memoizerific.lru = lru;
                        return memoizerific;
                    };
                };
                // move current args to most recent position
                function moveToMostRecentLru(lru, lruPath) {
                    var lruLen = lru.length, lruPathLen = lruPath.length, isMatch, i, ii;
                    for(i = 0; i < lruLen; i++){
                        isMatch = true;
                        for(ii = 0; ii < lruPathLen; ii++)if (!isEqual(lru[i][ii].arg, lruPath[ii].arg)) {
                            isMatch = false;
                            break;
                        }
                        if (isMatch) break;
                    }
                    lru.push(lru.splice(i, 1)[0]);
                }
                // remove least recently used cache item and all dead branches
                function removeCachedResult(removedLru) {
                    var removedLruLen = removedLru.length, currentLru = removedLru[removedLruLen - 1], tmp, i;
                    currentLru.cacheItem.delete(currentLru.arg);
                    // walk down the tree removing dead branches (size 0) along the way
                    for(i = removedLruLen - 2; i >= 0; i--){
                        currentLru = removedLru[i];
                        tmp = currentLru.cacheItem.get(currentLru.arg);
                        if (!tmp || !tmp.size) currentLru.cacheItem.delete(currentLru.arg);
                        else break;
                    }
                }
                // check if the numbers are equal, or whether they are both precisely NaN (isNaN returns true for all non-numbers)
                function isEqual(val1, val2) {
                    return val1 === val2 || val1 !== val1 && val2 !== val2;
                }
            },
            {
                "map-or-similar": 1
            }
        ]
    }, {}, [
        3
    ])(3);
});

},{}],"fBbhh":[function(require,module,exports) {
var baseAssignValue = require("a3dd03284854d1b5"), baseForOwn = require("3fe946fb5f45d4e9"), baseIteratee = require("8671a2b480ab95e2");
/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */ function mapValues(object, iteratee) {
    var result = {};
    iteratee = baseIteratee(iteratee, 3);
    baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, key, iteratee(value, key, object));
    });
    return result;
}
module.exports = mapValues;

},{"a3dd03284854d1b5":"bnwhH","3fe946fb5f45d4e9":"50Y3G","8671a2b480ab95e2":"bZDBu"}],"bnwhH":[function(require,module,exports) {
var defineProperty = require("57c6267f904aee0a");
/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function baseAssignValue(object, key, value) {
    if (key == "__proto__" && defineProperty) defineProperty(object, key, {
        "configurable": true,
        "enumerable": true,
        "value": value,
        "writable": true
    });
    else object[key] = value;
}
module.exports = baseAssignValue;

},{"57c6267f904aee0a":"kfnGR"}],"kfnGR":[function(require,module,exports) {
var getNative = require("7565accd8c33cb8b");
var defineProperty = function() {
    try {
        var func = getNative(Object, "defineProperty");
        func({}, "", {});
        return func;
    } catch (e) {}
}();
module.exports = defineProperty;

},{"7565accd8c33cb8b":"4BGPZ"}],"50Y3G":[function(require,module,exports) {
var baseFor = require("c7da20818a5fe3d6"), keys = require("1fb77c53defe5720");
/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function baseForOwn(object, iteratee) {
    return object && baseFor(object, iteratee, keys);
}
module.exports = baseForOwn;

},{"c7da20818a5fe3d6":"4P1lW","1fb77c53defe5720":"73Scx"}],"4P1lW":[function(require,module,exports) {
var createBaseFor = require("178c767a7be60d59");
/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var baseFor = createBaseFor();
module.exports = baseFor;

},{"178c767a7be60d59":"bgjIp"}],"bgjIp":[function(require,module,exports) {
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
module.exports = createBaseFor;

},{}],"bZDBu":[function(require,module,exports) {
var baseMatches = require("30aeab910fab669"), baseMatchesProperty = require("4f010869f7b63154"), identity = require("28f06147d1eb9502"), isArray = require("3c56f88c4debf449"), property = require("aee920e0ef5bf111");
/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == "function") return value;
    if (value == null) return identity;
    if (typeof value == "object") return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
    return property(value);
}
module.exports = baseIteratee;

},{"30aeab910fab669":"fIXDK","4f010869f7b63154":"9GX2k","28f06147d1eb9502":"4Y9PR","3c56f88c4debf449":"9EWOE","aee920e0ef5bf111":"8ySPP"}],"fIXDK":[function(require,module,exports) {
var baseIsMatch = require("e45515c903dc8f87"), getMatchData = require("89e9034a8071e297"), matchesStrictComparable = require("782598b150762386");
/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function baseMatches(source) {
    var matchData = getMatchData(source);
    if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
    };
}
module.exports = baseMatches;

},{"e45515c903dc8f87":"7dvUN","89e9034a8071e297":"cuzKt","782598b150762386":"2XJp5"}],"7dvUN":[function(require,module,exports) {
var Stack = require("ae43062900bf7e4d"), baseIsEqual = require("9003c0cc8ac007b6");
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new Stack;
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
        }
    }
    return true;
}
module.exports = baseIsMatch;

},{"ae43062900bf7e4d":"l6sZY","9003c0cc8ac007b6":"19U3S"}],"cuzKt":[function(require,module,exports) {
var isStrictComparable = require("8ba18052e16e94fb"), keys = require("94ffded3a85af2f6");
/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function getMatchData(object) {
    var result = keys(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            isStrictComparable(value)
        ];
    }
    return result;
}
module.exports = getMatchData;

},{"8ba18052e16e94fb":"GCd5i","94ffded3a85af2f6":"73Scx"}],"GCd5i":[function(require,module,exports) {
var isObject = require("be1941f960bbf057");
/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function isStrictComparable(value) {
    return value === value && !isObject(value);
}
module.exports = isStrictComparable;

},{"be1941f960bbf057":"37Lwq"}],"2XJp5":[function(require,module,exports) {
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
module.exports = matchesStrictComparable;

},{}],"9GX2k":[function(require,module,exports) {
var baseIsEqual = require("cebe22f5ca0827a7"), get = require("d5ca180f7d6f956a"), hasIn = require("3462bb3f546fa1f7"), isKey = require("f5fef07966a1c4ee"), isStrictComparable = require("2a1cd212d48516"), matchesStrictComparable = require("885e72ee7fc6d296"), toKey = require("cd65eaf4a3af29f6");
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function baseMatchesProperty(path, srcValue) {
    if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
    return function(object) {
        var objValue = get(object, path);
        return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
    };
}
module.exports = baseMatchesProperty;

},{"cebe22f5ca0827a7":"19U3S","d5ca180f7d6f956a":"hbEsl","3462bb3f546fa1f7":"eZKAm","f5fef07966a1c4ee":"55frB","2a1cd212d48516":"GCd5i","885e72ee7fc6d296":"2XJp5","cd65eaf4a3af29f6":"dYvnC"}],"hbEsl":[function(require,module,exports) {
var baseGet = require("446ba3c1be7939a3");
/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function get(object, path, defaultValue) {
    var result = object == null ? undefined : baseGet(object, path);
    return result === undefined ? defaultValue : result;
}
module.exports = get;

},{"446ba3c1be7939a3":"gpxDs"}],"gpxDs":[function(require,module,exports) {
var castPath = require("434ba191fc1dcf09"), toKey = require("c3296f04fad32769");
/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function baseGet(object, path) {
    path = castPath(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[toKey(path[index++])];
    return index && index == length ? object : undefined;
}
module.exports = baseGet;

},{"434ba191fc1dcf09":"e5H3i","c3296f04fad32769":"dYvnC"}],"e5H3i":[function(require,module,exports) {
var isArray = require("26a856890198f45b"), isKey = require("e823e604d75f975b"), stringToPath = require("f5fff1c342107fbd"), toString = require("b04e8cc634273c23");
/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function castPath(value, object) {
    if (isArray(value)) return value;
    return isKey(value, object) ? [
        value
    ] : stringToPath(toString(value));
}
module.exports = castPath;

},{"26a856890198f45b":"9EWOE","e823e604d75f975b":"55frB","f5fff1c342107fbd":"lWbo8","b04e8cc634273c23":"kJEDW"}],"55frB":[function(require,module,exports) {
var isArray = require("1efcc081e9a448a8"), isSymbol = require("4cdff6c9e9ff5d38");
/** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function isKey(value, object) {
    if (isArray(value)) return false;
    var type = typeof value;
    if (type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol(value)) return true;
    return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
}
module.exports = isKey;

},{"1efcc081e9a448a8":"9EWOE","4cdff6c9e9ff5d38":"7TlbF"}],"lWbo8":[function(require,module,exports) {
var memoizeCapped = require("55f565a895f455e5");
/** Used to match property names within property paths. */ var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var stringToPath = memoizeCapped(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push("");
    string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, "$1") : number || match);
    });
    return result;
});
module.exports = stringToPath;

},{"55f565a895f455e5":"7qWFh"}],"7qWFh":[function(require,module,exports) {
var memoize = require("cb456550b1f5dd0a");
/** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function memoizeCapped(func) {
    var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
module.exports = memoizeCapped;

},{"cb456550b1f5dd0a":"bDs61"}],"bDs61":[function(require,module,exports) {
var MapCache = require("b34b26bf235f1cdd");
/** Error message constants. */ var FUNC_ERROR_TEXT = "Expected a function";
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function memoize(func, resolver) {
    if (typeof func != "function" || resolver != null && typeof resolver != "function") throw new TypeError(FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new (memoize.Cache || MapCache);
    return memoized;
}
// Expose `MapCache`.
memoize.Cache = MapCache;
module.exports = memoize;

},{"b34b26bf235f1cdd":"h6D7Y"}],"dYvnC":[function(require,module,exports) {
var isSymbol = require("2aed9f6fd4b7386");
/** Used as references for various `Number` constants. */ var INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function toKey(value) {
    if (typeof value == "string" || isSymbol(value)) return value;
    var result = value + "";
    return result == "0" && 1 / value == -INFINITY ? "-0" : result;
}
module.exports = toKey;

},{"2aed9f6fd4b7386":"7TlbF"}],"eZKAm":[function(require,module,exports) {
var baseHasIn = require("9fbd4bb192f3f572"), hasPath = require("b0aefd36de99e579");
/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function hasIn(object, path) {
    return object != null && hasPath(object, path, baseHasIn);
}
module.exports = hasIn;

},{"9fbd4bb192f3f572":"9KhNf","b0aefd36de99e579":"lCc2H"}],"9KhNf":[function(require,module,exports) {
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function baseHasIn(object, key) {
    return object != null && key in Object(object);
}
module.exports = baseHasIn;

},{}],"lCc2H":[function(require,module,exports) {
var castPath = require("bdbd2cfd212d36f7"), isArguments = require("47ffafdab3ba0d6f"), isArray = require("93ebd263ff0131c1"), isIndex = require("252ef74480e01958"), isLength = require("23c2f64e75e90a2"), toKey = require("af5ade297cb685ee");
/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function hasPath(object, path, hasFunc) {
    path = castPath(path, object);
    var index = -1, length = path.length, result = false;
    while(++index < length){
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result || ++index != length) return result;
    length = object == null ? 0 : object.length;
    return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
}
module.exports = hasPath;

},{"bdbd2cfd212d36f7":"e5H3i","47ffafdab3ba0d6f":"6N1dk","93ebd263ff0131c1":"9EWOE","252ef74480e01958":"9phJd","23c2f64e75e90a2":"1gZyQ","af5ade297cb685ee":"dYvnC"}],"4Y9PR":[function(require,module,exports) {
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function identity(value) {
    return value;
}
module.exports = identity;

},{}],"8ySPP":[function(require,module,exports) {
var baseProperty = require("c7f2d79ee4b1c16a"), basePropertyDeep = require("abf31da39349df22"), isKey = require("a387ef4a4373de2c"), toKey = require("9315973458389ae7");
/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function property(path) {
    return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}
module.exports = property;

},{"c7f2d79ee4b1c16a":"6I8Lv","abf31da39349df22":"jMlqV","a387ef4a4373de2c":"55frB","9315973458389ae7":"dYvnC"}],"6I8Lv":[function(require,module,exports) {
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
module.exports = baseProperty;

},{}],"jMlqV":[function(require,module,exports) {
var baseGet = require("f0f9f03bc3030d02");
/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function basePropertyDeep(path) {
    return function(object) {
        return baseGet(object, path);
    };
}
module.exports = basePropertyDeep;

},{"f0f9f03bc3030d02":"gpxDs"}],"gNBP5":[function(require,module,exports) {
var basePick = require("e13834df88faab8"), flatRest = require("7f4b4cdb31764f87");
/**
 * Creates an object composed of the picked `object` properties.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to pick.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pick(object, ['a', 'c']);
 * // => { 'a': 1, 'c': 3 }
 */ var pick = flatRest(function(object, paths) {
    return object == null ? {} : basePick(object, paths);
});
module.exports = pick;

},{"e13834df88faab8":"45UBF","7f4b4cdb31764f87":"jM8uh"}],"45UBF":[function(require,module,exports) {
var basePickBy = require("4620eb0b3c4f1463"), hasIn = require("c697490fd5f67a25");
/**
 * The base implementation of `_.pick` without support for individual
 * property identifiers.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @returns {Object} Returns the new object.
 */ function basePick(object, paths) {
    return basePickBy(object, paths, function(value, path) {
        return hasIn(object, path);
    });
}
module.exports = basePick;

},{"4620eb0b3c4f1463":"akwGW","c697490fd5f67a25":"eZKAm"}],"akwGW":[function(require,module,exports) {
var baseGet = require("d8aa974fba65e61e"), baseSet = require("b07dbab95dca4167"), castPath = require("64b51364f27b9088");
/**
 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @param {Function} predicate The function invoked per property.
 * @returns {Object} Returns the new object.
 */ function basePickBy(object, paths, predicate) {
    var index = -1, length = paths.length, result = {};
    while(++index < length){
        var path = paths[index], value = baseGet(object, path);
        if (predicate(value, path)) baseSet(result, castPath(path, object), value);
    }
    return result;
}
module.exports = basePickBy;

},{"d8aa974fba65e61e":"gpxDs","b07dbab95dca4167":"2hCra","64b51364f27b9088":"e5H3i"}],"2hCra":[function(require,module,exports) {
var assignValue = require("a01f3b7ce097c710"), castPath = require("56e0b8a492d56399"), isIndex = require("d1eb8acc5a65dc38"), isObject = require("dfb182b16ef275c0"), toKey = require("6a51dc787ca5b6e3");
/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */ function baseSet(object, path, value, customizer) {
    if (!isObject(object)) return object;
    path = castPath(path, object);
    var index = -1, length = path.length, lastIndex = length - 1, nested = object;
    while(nested != null && ++index < length){
        var key = toKey(path[index]), newValue = value;
        if (key === "__proto__" || key === "constructor" || key === "prototype") return object;
        if (index != lastIndex) {
            var objValue = nested[key];
            newValue = customizer ? customizer(objValue, key, nested) : undefined;
            if (newValue === undefined) newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
    }
    return object;
}
module.exports = baseSet;

},{"a01f3b7ce097c710":"c8lZ9","56e0b8a492d56399":"e5H3i","d1eb8acc5a65dc38":"9phJd","dfb182b16ef275c0":"37Lwq","6a51dc787ca5b6e3":"dYvnC"}],"c8lZ9":[function(require,module,exports) {
var baseAssignValue = require("be513dd57a36b3f4"), eq = require("b62ef95b3cf1cde1");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function assignValue(object, key, value) {
    var objValue = object[key];
    if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
}
module.exports = assignValue;

},{"be513dd57a36b3f4":"bnwhH","b62ef95b3cf1cde1":"kLV9d"}],"jM8uh":[function(require,module,exports) {
var flatten = require("199f7cbd69032298"), overRest = require("aa5c38699e42775a"), setToString = require("6a66c8b3fbd122d5");
/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */ function flatRest(func) {
    return setToString(overRest(func, undefined, flatten), func + "");
}
module.exports = flatRest;

},{"199f7cbd69032298":"auTLv","aa5c38699e42775a":"241CL","6a66c8b3fbd122d5":"f40f7"}],"auTLv":[function(require,module,exports) {
var baseFlatten = require("a35d6abfacb4b52b");
/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */ function flatten(array) {
    var length = array == null ? 0 : array.length;
    return length ? baseFlatten(array, 1) : [];
}
module.exports = flatten;

},{"a35d6abfacb4b52b":"956ao"}],"956ao":[function(require,module,exports) {
var arrayPush = require("d752582e5b174691"), isFlattenable = require("ec5f080ebf5764e8");
/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */ function baseFlatten(array, depth, predicate, isStrict, result) {
    var index = -1, length = array.length;
    predicate || (predicate = isFlattenable);
    result || (result = []);
    while(++index < length){
        var value = array[index];
        if (depth > 0 && predicate(value)) {
            if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
            else arrayPush(result, value);
        } else if (!isStrict) result[result.length] = value;
    }
    return result;
}
module.exports = baseFlatten;

},{"d752582e5b174691":"fQzwB","ec5f080ebf5764e8":"bloSs"}],"bloSs":[function(require,module,exports) {
var Symbol = require("dde07f6ab8ba5eb5"), isArguments = require("ee6f325d7f5309b1"), isArray = require("ff8d93236e335297");
/** Built-in value references. */ var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;
/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */ function isFlattenable(value) {
    return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
}
module.exports = isFlattenable;

},{"dde07f6ab8ba5eb5":"eDozn","ee6f325d7f5309b1":"6N1dk","ff8d93236e335297":"9EWOE"}],"241CL":[function(require,module,exports) {
var apply = require("6f683b05f63ed25a");
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeMax = Math.max;
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function overRest(func, start, transform) {
    start = nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
    };
}
module.exports = overRest;

},{"6f683b05f63ed25a":"4rbTx"}],"4rbTx":[function(require,module,exports) {
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
module.exports = apply;

},{}],"f40f7":[function(require,module,exports) {
var baseSetToString = require("eebd487fbab521b6"), shortOut = require("9114f59293388d49");
/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var setToString = shortOut(baseSetToString);
module.exports = setToString;

},{"eebd487fbab521b6":"4Msp9","9114f59293388d49":"iJ6pj"}],"4Msp9":[function(require,module,exports) {
var constant = require("706929c7b4749485"), defineProperty = require("eff1240bc0447727"), identity = require("b00d1e57326793e1");
/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var baseSetToString = !defineProperty ? identity : function(func, string) {
    return defineProperty(func, "toString", {
        "configurable": true,
        "enumerable": false,
        "value": constant(string),
        "writable": true
    });
};
module.exports = baseSetToString;

},{"706929c7b4749485":"92pP7","eff1240bc0447727":"kfnGR","b00d1e57326793e1":"4Y9PR"}],"92pP7":[function(require,module,exports) {
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ function constant(value) {
    return function() {
        return value;
    };
}
module.exports = constant;

},{}],"iJ6pj":[function(require,module,exports) {
/** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeNow = Date.now;
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
module.exports = shortOut;

},{}],"dbZce":[function(require,module,exports) {
/* jshint node: true */ "use strict";
function makeArrayFrom(obj) {
    return Array.prototype.slice.apply(obj);
}
var PENDING = "pending", RESOLVED = "resolved", REJECTED = "rejected";
function SynchronousPromise(handler) {
    this.status = PENDING;
    this._continuations = [];
    this._parent = null;
    this._paused = false;
    if (handler) handler.call(this, this._continueWith.bind(this), this._failWith.bind(this));
}
function looksLikeAPromise(obj) {
    return obj && typeof obj.then === "function";
}
function passThrough(value) {
    return value;
}
SynchronousPromise.prototype = {
    then: function(nextFn, catchFn) {
        var next = SynchronousPromise.unresolved()._setParent(this);
        if (this._isRejected()) {
            if (this._paused) {
                this._continuations.push({
                    promise: next,
                    nextFn: nextFn,
                    catchFn: catchFn
                });
                return next;
            }
            if (catchFn) try {
                var catchResult = catchFn(this._error);
                if (looksLikeAPromise(catchResult)) {
                    this._chainPromiseData(catchResult, next);
                    return next;
                } else return SynchronousPromise.resolve(catchResult)._setParent(this);
            } catch (e) {
                return SynchronousPromise.reject(e)._setParent(this);
            }
            return SynchronousPromise.reject(this._error)._setParent(this);
        }
        this._continuations.push({
            promise: next,
            nextFn: nextFn,
            catchFn: catchFn
        });
        this._runResolutions();
        return next;
    },
    catch: function(handler) {
        if (this._isResolved()) return SynchronousPromise.resolve(this._data)._setParent(this);
        var next = SynchronousPromise.unresolved()._setParent(this);
        this._continuations.push({
            promise: next,
            catchFn: handler
        });
        this._runRejections();
        return next;
    },
    finally: function(callback) {
        var ran = false;
        function runFinally(result, err) {
            if (!ran) {
                ran = true;
                if (!callback) callback = passThrough;
                var callbackResult = callback(result);
                if (looksLikeAPromise(callbackResult)) return callbackResult.then(function() {
                    if (err) throw err;
                    return result;
                });
                else return result;
            }
        }
        return this.then(function(result) {
            return runFinally(result);
        }).catch(function(err) {
            return runFinally(null, err);
        });
    },
    pause: function() {
        this._paused = true;
        return this;
    },
    resume: function() {
        var firstPaused = this._findFirstPaused();
        if (firstPaused) {
            firstPaused._paused = false;
            firstPaused._runResolutions();
            firstPaused._runRejections();
        }
        return this;
    },
    _findAncestry: function() {
        return this._continuations.reduce(function(acc, cur) {
            if (cur.promise) {
                var node = {
                    promise: cur.promise,
                    children: cur.promise._findAncestry()
                };
                acc.push(node);
            }
            return acc;
        }, []);
    },
    _setParent: function(parent) {
        if (this._parent) throw new Error("parent already set");
        this._parent = parent;
        return this;
    },
    _continueWith: function(data) {
        var firstPending = this._findFirstPending();
        if (firstPending) {
            firstPending._data = data;
            firstPending._setResolved();
        }
    },
    _findFirstPending: function() {
        return this._findFirstAncestor(function(test) {
            return test._isPending && test._isPending();
        });
    },
    _findFirstPaused: function() {
        return this._findFirstAncestor(function(test) {
            return test._paused;
        });
    },
    _findFirstAncestor: function(matching) {
        var test = this;
        var result;
        while(test){
            if (matching(test)) result = test;
            test = test._parent;
        }
        return result;
    },
    _failWith: function(error) {
        var firstRejected = this._findFirstPending();
        if (firstRejected) {
            firstRejected._error = error;
            firstRejected._setRejected();
        }
    },
    _takeContinuations: function() {
        return this._continuations.splice(0, this._continuations.length);
    },
    _runRejections: function() {
        if (this._paused || !this._isRejected()) return;
        var error = this._error, continuations = this._takeContinuations(), self = this;
        continuations.forEach(function(cont) {
            if (cont.catchFn) try {
                var catchResult = cont.catchFn(error);
                self._handleUserFunctionResult(catchResult, cont.promise);
            } catch (e) {
                cont.promise.reject(e);
            }
            else cont.promise.reject(error);
        });
    },
    _runResolutions: function() {
        if (this._paused || !this._isResolved() || this._isPending()) return;
        var continuations = this._takeContinuations();
        if (looksLikeAPromise(this._data)) return this._handleWhenResolvedDataIsPromise(this._data);
        var data = this._data;
        var self = this;
        continuations.forEach(function(cont) {
            if (cont.nextFn) try {
                var result = cont.nextFn(data);
                self._handleUserFunctionResult(result, cont.promise);
            } catch (e) {
                self._handleResolutionError(e, cont);
            }
            else if (cont.promise) cont.promise.resolve(data);
        });
    },
    _handleResolutionError: function(e, continuation) {
        this._setRejected();
        if (continuation.catchFn) try {
            continuation.catchFn(e);
            return;
        } catch (e2) {
            e = e2;
        }
        if (continuation.promise) continuation.promise.reject(e);
    },
    _handleWhenResolvedDataIsPromise: function(data) {
        var self = this;
        return data.then(function(result) {
            self._data = result;
            self._runResolutions();
        }).catch(function(error) {
            self._error = error;
            self._setRejected();
            self._runRejections();
        });
    },
    _handleUserFunctionResult: function(data, nextSynchronousPromise) {
        if (looksLikeAPromise(data)) this._chainPromiseData(data, nextSynchronousPromise);
        else nextSynchronousPromise.resolve(data);
    },
    _chainPromiseData: function(promiseData, nextSynchronousPromise) {
        promiseData.then(function(newData) {
            nextSynchronousPromise.resolve(newData);
        }).catch(function(newError) {
            nextSynchronousPromise.reject(newError);
        });
    },
    _setResolved: function() {
        this.status = RESOLVED;
        if (!this._paused) this._runResolutions();
    },
    _setRejected: function() {
        this.status = REJECTED;
        if (!this._paused) this._runRejections();
    },
    _isPending: function() {
        return this.status === PENDING;
    },
    _isResolved: function() {
        return this.status === RESOLVED;
    },
    _isRejected: function() {
        return this.status === REJECTED;
    }
};
SynchronousPromise.resolve = function(result) {
    return new SynchronousPromise(function(resolve, reject) {
        if (looksLikeAPromise(result)) result.then(function(newResult) {
            resolve(newResult);
        }).catch(function(error) {
            reject(error);
        });
        else resolve(result);
    });
};
SynchronousPromise.reject = function(result) {
    return new SynchronousPromise(function(resolve, reject) {
        reject(result);
    });
};
SynchronousPromise.unresolved = function() {
    return new SynchronousPromise(function(resolve, reject) {
        this.resolve = resolve;
        this.reject = reject;
    });
};
SynchronousPromise.all = function() {
    var args = makeArrayFrom(arguments);
    if (Array.isArray(args[0])) args = args[0];
    if (!args.length) return SynchronousPromise.resolve([]);
    return new SynchronousPromise(function(resolve, reject) {
        var allData = [], numResolved = 0, doResolve = function() {
            if (numResolved === args.length) resolve(allData);
        }, rejected = false, doReject = function(err) {
            if (rejected) return;
            rejected = true;
            reject(err);
        };
        args.forEach(function(arg, idx) {
            SynchronousPromise.resolve(arg).then(function(thisResult) {
                allData[idx] = thisResult;
                numResolved += 1;
                doResolve();
            }).catch(function(err) {
                doReject(err);
            });
        });
    });
};
function createAggregateErrorFrom(errors) {
    /* jshint ignore:start */ if (typeof window !== "undefined" && "AggregateError" in window) return new window.AggregateError(errors);
    /* jshint ignore:end */ return {
        errors: errors
    };
}
SynchronousPromise.any = function() {
    var args = makeArrayFrom(arguments);
    if (Array.isArray(args[0])) args = args[0];
    if (!args.length) return SynchronousPromise.reject(createAggregateErrorFrom([]));
    return new SynchronousPromise(function(resolve, reject) {
        var allErrors = [], numRejected = 0, doReject = function() {
            if (numRejected === args.length) reject(createAggregateErrorFrom(allErrors));
        }, resolved = false, doResolve = function(result) {
            if (resolved) return;
            resolved = true;
            resolve(result);
        };
        args.forEach(function(arg, idx) {
            SynchronousPromise.resolve(arg).then(function(thisResult) {
                doResolve(thisResult);
            }).catch(function(err) {
                allErrors[idx] = err;
                numRejected += 1;
                doReject();
            });
        });
    });
};
SynchronousPromise.allSettled = function() {
    var args = makeArrayFrom(arguments);
    if (Array.isArray(args[0])) args = args[0];
    if (!args.length) return SynchronousPromise.resolve([]);
    return new SynchronousPromise(function(resolve) {
        var allData = [], numSettled = 0, doSettled = function() {
            numSettled += 1;
            if (numSettled === args.length) resolve(allData);
        };
        args.forEach(function(arg, idx) {
            SynchronousPromise.resolve(arg).then(function(thisResult) {
                allData[idx] = {
                    status: "fulfilled",
                    value: thisResult
                };
                doSettled();
            }).catch(function(err) {
                allData[idx] = {
                    status: "rejected",
                    reason: err
                };
                doSettled();
            });
        });
    });
};
/* jshint ignore:start */ if (Promise === SynchronousPromise) throw new Error("Please use SynchronousPromise.installGlobally() to install globally");
var RealPromise = Promise;
SynchronousPromise.installGlobally = function(__awaiter) {
    if (Promise === SynchronousPromise) return __awaiter;
    var result = patchAwaiterIfRequired(__awaiter);
    Promise = SynchronousPromise;
    return result;
};
SynchronousPromise.uninstallGlobally = function() {
    if (Promise === SynchronousPromise) Promise = RealPromise;
};
function patchAwaiterIfRequired(__awaiter) {
    if (typeof __awaiter === "undefined" || __awaiter.__patched) return __awaiter;
    var originalAwaiter = __awaiter;
    __awaiter = function() {
        var Promise1 = RealPromise;
        originalAwaiter.apply(this, makeArrayFrom(arguments));
    };
    __awaiter.__patched = true;
    return __awaiter;
}
/* jshint ignore:end */ module.exports = {
    SynchronousPromise: SynchronousPromise
};

},{}],"jK5II":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StoryIndexStore", ()=>StoryIndexStore);
var _esObjectKeysJs = require("core-js/modules/es.object.keys.js");
var _esArrayFindJs = require("core-js/modules/es.array.find.js");
var _esObjectToStringJs = require("core-js/modules/es.object.to-string.js");
var _esStringStartsWithJs = require("core-js/modules/es.string.starts-with.js");
var _esFunctionNameJs = require("core-js/modules/es.function.name.js");
var _esObjectEntriesJs = require("core-js/modules/es.object.entries.js");
var _esSymbolJs = require("core-js/modules/es.symbol.js");
var _esSymbolDescriptionJs = require("core-js/modules/es.symbol.description.js");
var _esSymbolIteratorJs = require("core-js/modules/es.symbol.iterator.js");
var _esArrayIteratorJs = require("core-js/modules/es.array.iterator.js");
var _esStringIteratorJs = require("core-js/modules/es.string.iterator.js");
var _webDomCollectionsIteratorJs = require("core-js/modules/web.dom-collections.iterator.js");
var _esArraySliceJs = require("core-js/modules/es.array.slice.js");
var _esArrayFromJs = require("core-js/modules/es.array.from.js");
var _esRegexpExecJs = require("core-js/modules/es.regexp.exec.js");
var _esObjectFreezeJs = require("core-js/modules/es.object.freeze.js");
var _tsDedent = require("ts-dedent");
var _tsDedentDefault = parcelHelpers.interopDefault(_tsDedent);
var _templateObject;
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) raw = strings.slice(0);
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
var StoryIndexStore = /*#__PURE__*/ function() {
    function StoryIndexStore() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
            v: 3,
            stories: {}
        }, stories = _ref.stories;
        _classCallCheck(this, StoryIndexStore);
        this.channel = void 0;
        this.stories = void 0;
        this.stories = stories;
    }
    _createClass(StoryIndexStore, [
        {
            key: "storyIdFromSpecifier",
            value: function storyIdFromSpecifier(specifier) {
                var storyIds = Object.keys(this.stories);
                if (specifier === "*") // '*' means select the first story. If there is none, we have no selection.
                return storyIds[0];
                if (typeof specifier === "string") {
                    // Find the story with the exact id that matches the specifier (see #11571)
                    if (storyIds.indexOf(specifier) >= 0) return specifier;
                     // Fallback to the first story that starts with the specifier
                    return storyIds.find(function(storyId) {
                        return storyId.startsWith(specifier);
                    });
                } // Try and find a story matching the name/kind, setting no selection if they don't exist.
                var name = specifier.name, title = specifier.title;
                var match = Object.entries(this.stories).find(function(_ref2) {
                    var _ref3 = _slicedToArray(_ref2, 2), id = _ref3[0], story = _ref3[1];
                    return story.name === name && story.title === title;
                });
                return match && match[0];
            }
        },
        {
            key: "storyIdToEntry",
            value: function storyIdToEntry(storyId) {
                var storyEntry = this.stories[storyId];
                if (!storyEntry) throw new Error((0, _tsDedentDefault.default)(_templateObject || (_templateObject = _taggedTemplateLiteral([
                    "Couldn't find story matching '",
                    "' after HMR.\n      - Did you remove it from your CSF file?\n      - Are you sure a story with that id exists?\n      - Please check your stories field of your main.js config.\n      - Also check the browser console and terminal for error messages."
                ])), storyId));
                return storyEntry;
            }
        }
    ]);
    return StoryIndexStore;
}();

},{"core-js/modules/es.object.keys.js":"5Q2AT","core-js/modules/es.array.find.js":"hWBPu","core-js/modules/es.object.to-string.js":"lsA9p","core-js/modules/es.string.starts-with.js":"90lFR","core-js/modules/es.function.name.js":"4LiLL","core-js/modules/es.object.entries.js":"7Wf79","core-js/modules/es.symbol.js":"ajw2f","core-js/modules/es.symbol.description.js":"wrlLc","core-js/modules/es.symbol.iterator.js":"fhNIb","core-js/modules/es.array.iterator.js":"ieU20","core-js/modules/es.string.iterator.js":"74a8v","core-js/modules/web.dom-collections.iterator.js":"aXR96","core-js/modules/es.array.slice.js":"8RRh9","core-js/modules/es.array.from.js":"9UCQw","core-js/modules/es.regexp.exec.js":"5q56v","core-js/modules/es.object.freeze.js":"9LVYO","ts-dedent":"9RvVa","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"hWBPu":[function(require,module,exports) {
"use strict";
var $ = require("a6cb3a492b52d21c");
var $find = require("ad97e1511b32e588").find;
var addToUnscopables = require("62fd950aac3d5249");
var FIND = "find";
var SKIPS_HOLES = true;
// Shouldn't skip holes
if (FIND in []) Array(1)[FIND](function() {
    SKIPS_HOLES = false;
});
// `Array.prototype.find` method
// https://tc39.es/ecma262/#sec-array.prototype.find
$({
    target: "Array",
    proto: true,
    forced: SKIPS_HOLES
}, {
    find: function find(callbackfn /* , that = undefined */ ) {
        return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    }
});
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables(FIND);

},{"a6cb3a492b52d21c":"1OO62","ad97e1511b32e588":"g44dN","62fd950aac3d5249":"cszY9"}],"90lFR":[function(require,module,exports) {
"use strict";
var $ = require("dde854d8a76d436d");
var uncurryThis = require("aeabc68a4b529b64");
var getOwnPropertyDescriptor = require("ff3b80c156be6132").f;
var toLength = require("573cc620487e2f6b");
var toString = require("3d6be1b7c00bafd");
var notARegExp = require("40ed833d044b85cd");
var requireObjectCoercible = require("7b57b8afdd10d7e4");
var correctIsRegExpLogic = require("80ffa3ecff44b920");
var IS_PURE = require("d76fe9fb1319d805");
// eslint-disable-next-line es/no-string-prototype-startswith -- safe
var un$StartsWith = uncurryThis("".startsWith);
var stringSlice = uncurryThis("".slice);
var min = Math.min;
var CORRECT_IS_REGEXP_LOGIC = correctIsRegExpLogic("startsWith");
// https://github.com/zloirock/core-js/pull/702
var MDN_POLYFILL_BUG = !IS_PURE && !CORRECT_IS_REGEXP_LOGIC && !!function() {
    var descriptor = getOwnPropertyDescriptor(String.prototype, "startsWith");
    return descriptor && !descriptor.writable;
}();
// `String.prototype.startsWith` method
// https://tc39.es/ecma262/#sec-string.prototype.startswith
$({
    target: "String",
    proto: true,
    forced: !MDN_POLYFILL_BUG && !CORRECT_IS_REGEXP_LOGIC
}, {
    startsWith: function startsWith(searchString /* , position = 0 */ ) {
        var that = toString(requireObjectCoercible(this));
        notARegExp(searchString);
        var index = toLength(min(arguments.length > 1 ? arguments[1] : undefined, that.length));
        var search = toString(searchString);
        return un$StartsWith ? un$StartsWith(that, search, index) : stringSlice(that, index, index + search.length) === search;
    }
});

},{"dde854d8a76d436d":"1OO62","aeabc68a4b529b64":"fP9tv","ff3b80c156be6132":"8cErP","573cc620487e2f6b":"kzWDg","3d6be1b7c00bafd":"8RVGu","40ed833d044b85cd":"9XS3f","7b57b8afdd10d7e4":"etuZb","80ffa3ecff44b920":"034hA","d76fe9fb1319d805":"bZbjq"}],"9XS3f":[function(require,module,exports) {
var global = require("b98749ab215763fe");
var isRegExp = require("7b932b7711b6ae16");
var TypeError = global.TypeError;
module.exports = function(it) {
    if (isRegExp(it)) throw TypeError("The method doesn't accept regular expressions");
    return it;
};

},{"b98749ab215763fe":"1GZc4","7b932b7711b6ae16":"7lrRe"}],"7lrRe":[function(require,module,exports) {
var isObject = require("4ca57df9821dbfa3");
var classof = require("b867bee476fc5018");
var wellKnownSymbol = require("42cd33b6dbd61bee");
var MATCH = wellKnownSymbol("match");
// `IsRegExp` abstract operation
// https://tc39.es/ecma262/#sec-isregexp
module.exports = function(it) {
    var isRegExp;
    return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : classof(it) == "RegExp");
};

},{"4ca57df9821dbfa3":"bprny","b867bee476fc5018":"6FZJh","42cd33b6dbd61bee":"kbsMI"}],"034hA":[function(require,module,exports) {
var wellKnownSymbol = require("303b9f26f388462e");
var MATCH = wellKnownSymbol("match");
module.exports = function(METHOD_NAME) {
    var regexp = /./;
    try {
        "/./"[METHOD_NAME](regexp);
    } catch (error1) {
        try {
            regexp[MATCH] = false;
            return "/./"[METHOD_NAME](regexp);
        } catch (error2) {}
    }
    return false;
};

},{"303b9f26f388462e":"kbsMI"}],"al3SN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ArgsStore", ()=>ArgsStore);
var _esObjectToStringJs = require("core-js/modules/es.object.to-string.js");
var _webDomCollectionsForEachJs = require("core-js/modules/web.dom-collections.for-each.js");
var _esObjectKeysJs = require("core-js/modules/es.object.keys.js");
var _esObjectAssignJs = require("core-js/modules/es.object.assign.js");
var _args = require("./args");
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function deleteUndefined(obj) {
    // eslint-disable-next-line no-param-reassign
    Object.keys(obj).forEach(function(key) {
        return obj[key] === undefined && delete obj[key];
    });
    return obj;
}
var ArgsStore = /*#__PURE__*/ function() {
    function ArgsStore() {
        _classCallCheck(this, ArgsStore);
        this.initialArgsByStoryId = {};
        this.argsByStoryId = {};
    }
    _createClass(ArgsStore, [
        {
            key: "get",
            value: function get(storyId) {
                if (!(storyId in this.argsByStoryId)) throw new Error("No args known for ".concat(storyId, " -- has it been rendered yet?"));
                return this.argsByStoryId[storyId];
            }
        },
        {
            key: "setInitial",
            value: function setInitial(story) {
                if (!this.initialArgsByStoryId[story.id]) {
                    this.initialArgsByStoryId[story.id] = story.initialArgs;
                    this.argsByStoryId[story.id] = story.initialArgs;
                } else if (this.initialArgsByStoryId[story.id] !== story.initialArgs) {
                    // When we get a new version of a story (with new initialArgs), we re-apply the same diff
                    // that we had previously applied to the old version of the story
                    var delta = (0, _args.deepDiff)(this.initialArgsByStoryId[story.id], this.argsByStoryId[story.id]);
                    this.initialArgsByStoryId[story.id] = story.initialArgs;
                    this.argsByStoryId[story.id] = story.initialArgs;
                    if (delta !== (0, _args.DEEPLY_EQUAL)) this.updateFromDelta(story, delta);
                }
            }
        },
        {
            key: "updateFromDelta",
            value: function updateFromDelta(story, delta) {
                // Use the argType to ensure we setting a type with defined options to something outside of that
                var validatedDelta = (0, _args.validateOptions)(delta, story.argTypes); // NOTE: we use `combineArgs` here rather than `combineParameters` because changes to arg
                // array values are persisted in the URL as sparse arrays, and we have to take that into
                // account when overriding the initialArgs (e.g. we patch [,'changed'] over ['initial', 'val'])
                this.argsByStoryId[story.id] = (0, _args.combineArgs)(this.argsByStoryId[story.id], validatedDelta);
            }
        },
        {
            key: "updateFromPersisted",
            value: function updateFromPersisted(story, persisted) {
                // Use the argType to ensure we aren't persisting the wrong type of value to the type.
                // For instance you could try and set a string-valued arg to a number by changing the URL
                var mappedPersisted = (0, _args.mapArgsToTypes)(persisted, story.argTypes);
                return this.updateFromDelta(story, mappedPersisted);
            }
        },
        {
            key: "update",
            value: function update(storyId, argsUpdate) {
                if (!(storyId in this.argsByStoryId)) throw new Error("No args known for ".concat(storyId, " -- has it been rendered yet?"));
                this.argsByStoryId[storyId] = deleteUndefined(Object.assign({}, this.argsByStoryId[storyId], argsUpdate));
            }
        }
    ]);
    return ArgsStore;
}();

},{"core-js/modules/es.object.to-string.js":"lsA9p","core-js/modules/web.dom-collections.for-each.js":"iYT1M","core-js/modules/es.object.keys.js":"5Q2AT","core-js/modules/es.object.assign.js":"8FU8M","./args":"58bKx","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"58bKx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mapArgsToTypes", ()=>mapArgsToTypes);
parcelHelpers.export(exports, "combineArgs", ()=>combineArgs);
parcelHelpers.export(exports, "validateOptions", ()=>validateOptions);
parcelHelpers.export(exports, "DEEPLY_EQUAL", ()=>DEEPLY_EQUAL);
parcelHelpers.export(exports, "deepDiff", ()=>deepDiff);
parcelHelpers.export(exports, "NO_TARGET_NAME", ()=>NO_TARGET_NAME);
parcelHelpers.export(exports, "groupArgsByTarget", ()=>groupArgsByTarget);
parcelHelpers.export(exports, "noTargetArgs", ()=>noTargetArgs);
var _esSymbolIteratorJs = require("core-js/modules/es.symbol.iterator.js");
var _esArrayIteratorJs = require("core-js/modules/es.array.iterator.js");
var _esStringIteratorJs = require("core-js/modules/es.string.iterator.js");
var _webDomCollectionsIteratorJs = require("core-js/modules/web.dom-collections.iterator.js");
var _esArraySliceJs = require("core-js/modules/es.array.slice.js");
var _esArrayFromJs = require("core-js/modules/es.array.from.js");
var _esRegexpExecJs = require("core-js/modules/es.regexp.exec.js");
var _esObjectFreezeJs = require("core-js/modules/es.object.freeze.js");
var _esSymbolJs = require("core-js/modules/es.symbol.js");
var _esSymbolDescriptionJs = require("core-js/modules/es.symbol.description.js");
var _esObjectToStringJs = require("core-js/modules/es.object.to-string.js");
var _esFunctionNameJs = require("core-js/modules/es.function.name.js");
var _esNumberConstructorJs = require("core-js/modules/es.number.constructor.js");
var _esObjectEntriesJs = require("core-js/modules/es.object.entries.js");
var _esObjectAssignJs = require("core-js/modules/es.object.assign.js");
var _esArrayFilterJs = require("core-js/modules/es.array.filter.js");
var _esObjectKeysJs = require("core-js/modules/es.object.keys.js");
var _esArrayIncludesJs = require("core-js/modules/es.array.includes.js");
var _esArrayFindIndexJs = require("core-js/modules/es.array.find-index.js");
var _esStringIncludesJs = require("core-js/modules/es.string.includes.js");
var _esArrayConcatJs = require("core-js/modules/es.array.concat.js");
var _esArrayJoinJs = require("core-js/modules/es.array.join.js");
var _esArrayMapJs = require("core-js/modules/es.array.map.js");
var _esArrayFillJs = require("core-js/modules/es.array.fill.js");
var _webDomCollectionsForEachJs = require("core-js/modules/web.dom-collections.for-each.js");
var _fastDeepEqual = require("fast-deep-equal");
var _fastDeepEqualDefault = parcelHelpers.interopDefault(_fastDeepEqual);
var _clientLogger = require("@storybook/client-logger");
var _isPlainObject = require("lodash/isPlainObject");
var _isPlainObjectDefault = parcelHelpers.interopDefault(_isPlainObject);
var _tsDedent = require("ts-dedent");
var _tsDedentDefault = parcelHelpers.interopDefault(_tsDedent);
var _templateObject, _templateObject2;
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) raw = strings.slice(0);
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _typeof(obj) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
}
var INCOMPATIBLE = Symbol("incompatible");
var map = function map(arg, argType) {
    var type = argType.type;
    if (arg === undefined || arg === null || !type) return arg;
    if (argType.mapping) return arg;
    switch(type.name){
        case "string":
            return String(arg);
        case "enum":
            return arg;
        case "number":
            return Number(arg);
        case "boolean":
            return arg === "true";
        case "array":
            if (!type.value || !Array.isArray(arg)) return INCOMPATIBLE;
            return arg.reduce(function(acc, item, index) {
                var mapped = map(item, {
                    type: type.value
                });
                if (mapped !== INCOMPATIBLE) acc[index] = mapped;
                return acc;
            }, new Array(arg.length));
        case "object":
            if (typeof arg === "string" || typeof arg === "number") return arg;
            if (!type.value || _typeof(arg) !== "object") return INCOMPATIBLE;
            return Object.entries(arg).reduce(function(acc, _ref) {
                var _ref2 = _slicedToArray(_ref, 2), key = _ref2[0], val = _ref2[1];
                var mapped = map(val, {
                    type: type.value[key]
                });
                return mapped === INCOMPATIBLE ? acc : Object.assign(acc, _defineProperty({}, key, mapped));
            }, {});
        default:
            return INCOMPATIBLE;
    }
};
var mapArgsToTypes = function mapArgsToTypes(args, argTypes) {
    return Object.entries(args).reduce(function(acc, _ref3) {
        var _ref4 = _slicedToArray(_ref3, 2), key = _ref4[0], value = _ref4[1];
        if (!argTypes[key]) return acc;
        var mapped = map(value, argTypes[key]);
        return mapped === INCOMPATIBLE ? acc : Object.assign(acc, _defineProperty({}, key, mapped));
    }, {});
};
var combineArgs = function combineArgs(value, update) {
    if (Array.isArray(value) && Array.isArray(update)) return update.reduce(function(acc, upd, index) {
        acc[index] = combineArgs(value[index], update[index]);
        return acc;
    }, _toConsumableArray(value)).filter(function(v) {
        return v !== undefined;
    });
    if (!(0, _isPlainObjectDefault.default)(value) || !(0, _isPlainObjectDefault.default)(update)) return update;
    return Object.keys(Object.assign({}, value, update)).reduce(function(acc, key) {
        if (key in update) {
            var combined = combineArgs(value[key], update[key]);
            if (combined !== undefined) acc[key] = combined;
        } else acc[key] = value[key];
        return acc;
    }, {});
};
var validateOptions = function validateOptions(args, argTypes) {
    return Object.entries(argTypes).reduce(function(acc, _ref5) {
        var _ref6 = _slicedToArray(_ref5, 2), key = _ref6[0], options = _ref6[1].options;
        // Don't set args that are not defined in `args` (they can be undefined in there)
        // see https://github.com/storybookjs/storybook/issues/15630 and
        //   https://github.com/storybookjs/storybook/issues/17063
        function allowArg() {
            if (key in args) acc[key] = args[key];
            return acc;
        }
        if (!options) return allowArg();
        if (!Array.isArray(options)) {
            (0, _clientLogger.once).error((0, _tsDedentDefault.default)(_templateObject || (_templateObject = _taggedTemplateLiteral([
                "\n        Invalid argType: '",
                ".options' should be an array.\n\n        More info: https://storybook.js.org/docs/react/api/argtypes\n      "
            ])), key));
            return allowArg();
        }
        if (options.some(function(opt) {
            return opt && [
                "object",
                "function"
            ].includes(_typeof(opt));
        })) {
            (0, _clientLogger.once).error((0, _tsDedentDefault.default)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral([
                "\n        Invalid argType: '",
                ".options' should only contain primitives. Use a 'mapping' for complex values.\n\n        More info: https://storybook.js.org/docs/react/writing-stories/args#mapping-to-complex-arg-values\n      "
            ])), key));
            return allowArg();
        }
        var isArray = Array.isArray(args[key]);
        var invalidIndex = isArray && args[key].findIndex(function(val) {
            return !options.includes(val);
        });
        var isValidArray = isArray && invalidIndex === -1;
        if (args[key] === undefined || options.includes(args[key]) || isValidArray) return allowArg();
        var field = isArray ? "".concat(key, "[").concat(invalidIndex, "]") : key;
        var supportedOptions = options.map(function(opt) {
            return typeof opt === "string" ? "'".concat(opt, "'") : String(opt);
        }).join(", ");
        (0, _clientLogger.once).warn("Received illegal value for '".concat(field, "'. Supported options: ").concat(supportedOptions));
        return acc;
    }, {});
}; // TODO -- copied from router, needs to be in a shared location
var DEEPLY_EQUAL = Symbol("Deeply equal");
var deepDiff = function deepDiff(value, update) {
    if (_typeof(value) !== _typeof(update)) return update;
    if ((0, _fastDeepEqualDefault.default)(value, update)) return DEEPLY_EQUAL;
    if (Array.isArray(value) && Array.isArray(update)) {
        var res = update.reduce(function(acc, upd, index) {
            var diff = deepDiff(value[index], upd);
            if (diff !== DEEPLY_EQUAL) acc[index] = diff;
            return acc;
        }, new Array(update.length));
        if (update.length >= value.length) return res;
        return res.concat(new Array(value.length - update.length).fill(undefined));
    }
    if ((0, _isPlainObjectDefault.default)(value) && (0, _isPlainObjectDefault.default)(update)) return Object.keys(Object.assign({}, value, update)).reduce(function(acc, key) {
        var diff = deepDiff(value === null || value === void 0 ? void 0 : value[key], update === null || update === void 0 ? void 0 : update[key]);
        return diff === DEEPLY_EQUAL ? acc : Object.assign(acc, _defineProperty({}, key, diff));
    }, {});
    return update;
};
var NO_TARGET_NAME = "";
function groupArgsByTarget(_ref7) {
    var args = _ref7.args, argTypes = _ref7.argTypes;
    var groupedArgs = {};
    Object.entries(args).forEach(function(_ref8) {
        var _ref9 = _slicedToArray(_ref8, 2), name = _ref9[0], value = _ref9[1];
        var _ref10 = argTypes[name] || {}, _ref10$target = _ref10.target, target = _ref10$target === void 0 ? NO_TARGET_NAME : _ref10$target;
        groupedArgs[target] = groupedArgs[target] || {};
        groupedArgs[target][name] = value;
    });
    return groupedArgs;
}
function noTargetArgs(context) {
    return groupArgsByTarget(context)[NO_TARGET_NAME];
}

},{"core-js/modules/es.symbol.iterator.js":"fhNIb","core-js/modules/es.array.iterator.js":"ieU20","core-js/modules/es.string.iterator.js":"74a8v","core-js/modules/web.dom-collections.iterator.js":"aXR96","core-js/modules/es.array.slice.js":"8RRh9","core-js/modules/es.array.from.js":"9UCQw","core-js/modules/es.regexp.exec.js":"5q56v","core-js/modules/es.object.freeze.js":"9LVYO","core-js/modules/es.symbol.js":"ajw2f","core-js/modules/es.symbol.description.js":"wrlLc","core-js/modules/es.object.to-string.js":"lsA9p","core-js/modules/es.function.name.js":"4LiLL","core-js/modules/es.number.constructor.js":"hVD7l","core-js/modules/es.object.entries.js":"7Wf79","core-js/modules/es.object.assign.js":"8FU8M","core-js/modules/es.array.filter.js":"fD2da","core-js/modules/es.object.keys.js":"5Q2AT","core-js/modules/es.array.includes.js":"dbUjS","core-js/modules/es.array.find-index.js":"SckaK","core-js/modules/es.string.includes.js":"cx9ET","core-js/modules/es.array.concat.js":"g1t7q","core-js/modules/es.array.join.js":"1w71h","core-js/modules/es.array.map.js":"jTP7e","core-js/modules/es.array.fill.js":"fHli8","core-js/modules/web.dom-collections.for-each.js":"iYT1M","fast-deep-equal":"cG6NW","@storybook/client-logger":"iGRus","lodash/isPlainObject":"9m4Iw","ts-dedent":"9RvVa","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"hVD7l":[function(require,module,exports) {
"use strict";
var DESCRIPTORS = require("dac0f49ddd258f02");
var global = require("fd4244c04eaa3f46");
var uncurryThis = require("d6ad03f4a8d178a7");
var isForced = require("b7d12a59a0877cf0");
var redefine = require("8d35574d30cc9c7b");
var hasOwn = require("a63fe8ba771ddd66");
var inheritIfRequired = require("1fa70215a385f43f");
var isPrototypeOf = require("ac9a98828b299940");
var isSymbol = require("a2f71c36cf1dfa06");
var toPrimitive = require("1398c779e833098a");
var fails = require("58c10e766b715db4");
var getOwnPropertyNames = require("eae30770a8520200").f;
var getOwnPropertyDescriptor = require("a3f2314ca43c8870").f;
var defineProperty = require("673bf972e777267f").f;
var thisNumberValue = require("dc2cfe6c86ab9553");
var trim = require("27f6d5a76060ef23").trim;
var NUMBER = "Number";
var NativeNumber = global[NUMBER];
var NumberPrototype = NativeNumber.prototype;
var TypeError = global.TypeError;
var arraySlice = uncurryThis("".slice);
var charCodeAt = uncurryThis("".charCodeAt);
// `ToNumeric` abstract operation
// https://tc39.es/ecma262/#sec-tonumeric
var toNumeric = function(value) {
    var primValue = toPrimitive(value, "number");
    return typeof primValue == "bigint" ? primValue : toNumber(primValue);
};
// `ToNumber` abstract operation
// https://tc39.es/ecma262/#sec-tonumber
var toNumber = function(argument) {
    var it = toPrimitive(argument, "number");
    var first, third, radix, maxCode, digits, length, index, code;
    if (isSymbol(it)) throw TypeError("Cannot convert a Symbol value to a number");
    if (typeof it == "string" && it.length > 2) {
        it = trim(it);
        first = charCodeAt(it, 0);
        if (first === 43 || first === 45) {
            third = charCodeAt(it, 2);
            if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
        } else if (first === 48) {
            switch(charCodeAt(it, 1)){
                case 66:
                case 98:
                    radix = 2;
                    maxCode = 49;
                    break; // fast equal of /^0b[01]+$/i
                case 79:
                case 111:
                    radix = 8;
                    maxCode = 55;
                    break; // fast equal of /^0o[0-7]+$/i
                default:
                    return +it;
            }
            digits = arraySlice(it, 2);
            length = digits.length;
            for(index = 0; index < length; index++){
                code = charCodeAt(digits, index);
                // parseInt parses a string to a first unavailable symbol
                // but ToNumber should return NaN if a string contains unavailable symbols
                if (code < 48 || code > maxCode) return NaN;
            }
            return parseInt(digits, radix);
        }
    }
    return +it;
};
// `Number` constructor
// https://tc39.es/ecma262/#sec-number-constructor
if (isForced(NUMBER, !NativeNumber(" 0o1") || !NativeNumber("0b1") || NativeNumber("+0x1"))) {
    var NumberWrapper = function Number(value) {
        var n = arguments.length < 1 ? 0 : NativeNumber(toNumeric(value));
        var dummy = this;
        // check on 1..constructor(foo) case
        return isPrototypeOf(NumberPrototype, dummy) && fails(function() {
            thisNumberValue(dummy);
        }) ? inheritIfRequired(Object(n), dummy, NumberWrapper) : n;
    };
    for(var keys = DESCRIPTORS ? getOwnPropertyNames(NativeNumber) : // ES3:
    "MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,EPSILON,MAX_SAFE_INTEGER,MIN_SAFE_INTEGER,isFinite,isInteger,isNaN,isSafeInteger,parseFloat,parseInt,fromString,range".split(","), j = 0, key; keys.length > j; j++)if (hasOwn(NativeNumber, key = keys[j]) && !hasOwn(NumberWrapper, key)) defineProperty(NumberWrapper, key, getOwnPropertyDescriptor(NativeNumber, key));
    NumberWrapper.prototype = NumberPrototype;
    NumberPrototype.constructor = NumberWrapper;
    redefine(global, NUMBER, NumberWrapper);
}

},{"dac0f49ddd258f02":"7Hk5a","fd4244c04eaa3f46":"1GZc4","d6ad03f4a8d178a7":"fP9tv","b7d12a59a0877cf0":"j3Sfj","8d35574d30cc9c7b":"3ncOy","a63fe8ba771ddd66":"4SzRl","1fa70215a385f43f":"dlT8V","ac9a98828b299940":"alXpj","a2f71c36cf1dfa06":"RacQu","1398c779e833098a":"epWNE","58c10e766b715db4":"keKlS","eae30770a8520200":"9QTxj","a3f2314ca43c8870":"8cErP","673bf972e777267f":"dfAo1","dc2cfe6c86ab9553":"ca8IP","27f6d5a76060ef23":"d6kyO"}],"ca8IP":[function(require,module,exports) {
var uncurryThis = require("4875831adea9aec3");
// `thisNumberValue` abstract operation
// https://tc39.es/ecma262/#sec-thisnumbervalue
module.exports = uncurryThis(1.0.valueOf);

},{"4875831adea9aec3":"fP9tv"}],"d6kyO":[function(require,module,exports) {
var uncurryThis = require("17f5a3ff1a1c6ce6");
var requireObjectCoercible = require("56083d5e0450dab9");
var toString = require("3c5616504c7d56e9");
var whitespaces = require("eacd32ca91d3c555");
var replace = uncurryThis("".replace);
var whitespace = "[" + whitespaces + "]";
var ltrim = RegExp("^" + whitespace + whitespace + "*");
var rtrim = RegExp(whitespace + whitespace + "*$");
// `String.prototype.{ trim, trimStart, trimEnd, trimLeft, trimRight }` methods implementation
var createMethod = function(TYPE) {
    return function($this) {
        var string = toString(requireObjectCoercible($this));
        if (TYPE & 1) string = replace(string, ltrim, "");
        if (TYPE & 2) string = replace(string, rtrim, "");
        return string;
    };
};
module.exports = {
    // `String.prototype.{ trimLeft, trimStart }` methods
    // https://tc39.es/ecma262/#sec-string.prototype.trimstart
    start: createMethod(1),
    // `String.prototype.{ trimRight, trimEnd }` methods
    // https://tc39.es/ecma262/#sec-string.prototype.trimend
    end: createMethod(2),
    // `String.prototype.trim` method
    // https://tc39.es/ecma262/#sec-string.prototype.trim
    trim: createMethod(3)
};

},{"17f5a3ff1a1c6ce6":"fP9tv","56083d5e0450dab9":"etuZb","3c5616504c7d56e9":"8RVGu","eacd32ca91d3c555":"2Qi68"}],"2Qi68":[function(require,module,exports) {
// a string of all valid unicode whitespaces
module.exports = "	\n\v\f\r \xa0\u1680\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF";

},{}],"dbUjS":[function(require,module,exports) {
"use strict";
var $ = require("ffa5d46bdab873f9");
var $includes = require("abe71b6f5a2c149").includes;
var addToUnscopables = require("9a828f869e1adf81");
// `Array.prototype.includes` method
// https://tc39.es/ecma262/#sec-array.prototype.includes
$({
    target: "Array",
    proto: true
}, {
    includes: function includes(el /* , fromIndex = 0 */ ) {
        return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
    }
});
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables("includes");

},{"ffa5d46bdab873f9":"1OO62","abe71b6f5a2c149":"3WKfQ","9a828f869e1adf81":"cszY9"}],"SckaK":[function(require,module,exports) {
"use strict";
var $ = require("dcce3e96aeb32c26");
var $findIndex = require("25f2fe0b92321096").findIndex;
var addToUnscopables = require("1c93cc746ac8ffb1");
var FIND_INDEX = "findIndex";
var SKIPS_HOLES = true;
// Shouldn't skip holes
if (FIND_INDEX in []) Array(1)[FIND_INDEX](function() {
    SKIPS_HOLES = false;
});
// `Array.prototype.findIndex` method
// https://tc39.es/ecma262/#sec-array.prototype.findindex
$({
    target: "Array",
    proto: true,
    forced: SKIPS_HOLES
}, {
    findIndex: function findIndex(callbackfn /* , that = undefined */ ) {
        return $findIndex(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    }
});
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables(FIND_INDEX);

},{"dcce3e96aeb32c26":"1OO62","25f2fe0b92321096":"g44dN","1c93cc746ac8ffb1":"cszY9"}],"cx9ET":[function(require,module,exports) {
"use strict";
var $ = require("1cde7a4fbe24deb1");
var uncurryThis = require("d9ff51b37cd276ef");
var notARegExp = require("b1c9b74814a0e4ee");
var requireObjectCoercible = require("36f262aff4650984");
var toString = require("c6f2de0a65cb2a09");
var correctIsRegExpLogic = require("30dec888dfe829e2");
var stringIndexOf = uncurryThis("".indexOf);
// `String.prototype.includes` method
// https://tc39.es/ecma262/#sec-string.prototype.includes
$({
    target: "String",
    proto: true,
    forced: !correctIsRegExpLogic("includes")
}, {
    includes: function includes(searchString /* , position = 0 */ ) {
        return !!~stringIndexOf(toString(requireObjectCoercible(this)), toString(notARegExp(searchString)), arguments.length > 1 ? arguments[1] : undefined);
    }
});

},{"1cde7a4fbe24deb1":"1OO62","d9ff51b37cd276ef":"fP9tv","b1c9b74814a0e4ee":"9XS3f","36f262aff4650984":"etuZb","c6f2de0a65cb2a09":"8RVGu","30dec888dfe829e2":"034hA"}],"1w71h":[function(require,module,exports) {
"use strict";
var $ = require("1fd3a81d59354079");
var uncurryThis = require("878a42cfd07db75d");
var IndexedObject = require("c417af28e9abb2b");
var toIndexedObject = require("cdcc2dbc58a28c02");
var arrayMethodIsStrict = require("733e226e143494d1");
var un$Join = uncurryThis([].join);
var ES3_STRINGS = IndexedObject != Object;
var STRICT_METHOD = arrayMethodIsStrict("join", ",");
// `Array.prototype.join` method
// https://tc39.es/ecma262/#sec-array.prototype.join
$({
    target: "Array",
    proto: true,
    forced: ES3_STRINGS || !STRICT_METHOD
}, {
    join: function join(separator) {
        return un$Join(toIndexedObject(this), separator === undefined ? "," : separator);
    }
});

},{"1fd3a81d59354079":"1OO62","878a42cfd07db75d":"fP9tv","c417af28e9abb2b":"8iqJB","cdcc2dbc58a28c02":"5DeQ5","733e226e143494d1":"h0N6r"}],"fHli8":[function(require,module,exports) {
var $ = require("52cb142d804aabd3");
var fill = require("daf335b8230cfcc7");
var addToUnscopables = require("3e31c661bed82a2d");
// `Array.prototype.fill` method
// https://tc39.es/ecma262/#sec-array.prototype.fill
$({
    target: "Array",
    proto: true
}, {
    fill: fill
});
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables("fill");

},{"52cb142d804aabd3":"1OO62","daf335b8230cfcc7":"4W61e","3e31c661bed82a2d":"cszY9"}],"4W61e":[function(require,module,exports) {
"use strict";
var toObject = require("45e35cf118865951");
var toAbsoluteIndex = require("ae17acf5d72570ed");
var lengthOfArrayLike = require("94aaef7256431b15");
// `Array.prototype.fill` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.fill
module.exports = function fill(value /* , start = 0, end = @length */ ) {
    var O = toObject(this);
    var length = lengthOfArrayLike(O);
    var argumentsLength = arguments.length;
    var index = toAbsoluteIndex(argumentsLength > 1 ? arguments[1] : undefined, length);
    var end = argumentsLength > 2 ? arguments[2] : undefined;
    var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
    while(endPos > index)O[index++] = value;
    return O;
};

},{"45e35cf118865951":"7K2H5","ae17acf5d72570ed":"7kdMh","94aaef7256431b15":"ckDDq"}],"cG6NW":[function(require,module,exports) {
"use strict";
// do not edit .js files directly - edit src/index.jst
module.exports = function equal(a, b) {
    if (a === b) return true;
    if (a && b && typeof a == "object" && typeof b == "object") {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!equal(a[i], b[i])) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        for(i = length; i-- !== 0;){
            var key = keys[i];
            if (!equal(a[key], b[key])) return false;
        }
        return true;
    }
    // true if both NaN, false otherwise
    return a !== a && b !== b;
};

},{}],"9m4Iw":[function(require,module,exports) {
var baseGetTag = require("c03dd41ed9922dd2"), getPrototype = require("2ca5b85a120835de"), isObjectLike = require("963b65e043435612");
/** `Object#toString` result references. */ var objectTag = "[object Object]";
/** Used for built-in method references. */ var funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function isPlainObject(value) {
    if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
    var proto = getPrototype(value);
    if (proto === null) return true;
    var Ctor = hasOwnProperty.call(proto, "constructor") && proto.constructor;
    return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
}
module.exports = isPlainObject;

},{"c03dd41ed9922dd2":"8STfc","2ca5b85a120835de":"2Lw50","963b65e043435612":"65GJZ"}],"2Lw50":[function(require,module,exports) {
var overArg = require("11c2fcc01fbb2119");
/** Built-in value references. */ var getPrototype = overArg(Object.getPrototypeOf, Object);
module.exports = getPrototype;

},{"11c2fcc01fbb2119":"1gfAV"}],"2rD22":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GlobalsStore", ()=>GlobalsStore);
var _esArraySliceJs = require("core-js/modules/es.array.slice.js");
var _esObjectFreezeJs = require("core-js/modules/es.object.freeze.js");
var _esSymbolJs = require("core-js/modules/es.symbol.js");
var _esSymbolDescriptionJs = require("core-js/modules/es.symbol.description.js");
var _esSymbolIteratorJs = require("core-js/modules/es.symbol.iterator.js");
var _esArrayFromJs = require("core-js/modules/es.array.from.js");
var _esFunctionNameJs = require("core-js/modules/es.function.name.js");
var _esRegexpExecJs = require("core-js/modules/es.regexp.exec.js");
var _esArrayIteratorJs = require("core-js/modules/es.array.iterator.js");
var _esObjectToStringJs = require("core-js/modules/es.object.to-string.js");
var _esSetJs = require("core-js/modules/es.set.js");
var _esStringIteratorJs = require("core-js/modules/es.string.iterator.js");
var _webDomCollectionsIteratorJs = require("core-js/modules/web.dom-collections.iterator.js");
var _esArrayConcatJs = require("core-js/modules/es.array.concat.js");
var _esObjectKeysJs = require("core-js/modules/es.object.keys.js");
var _esObjectAssignJs = require("core-js/modules/es.object.assign.js");
var _esObjectEntriesJs = require("core-js/modules/es.object.entries.js");
var _webDomCollectionsForEachJs = require("core-js/modules/web.dom-collections.for-each.js");
var _utilDeprecate = require("util-deprecate");
var _utilDeprecateDefault = parcelHelpers.interopDefault(_utilDeprecate);
var _tsDedent = require("ts-dedent");
var _tsDedentDefault = parcelHelpers.interopDefault(_tsDedent);
var _args = require("./args");
var _getValuesFromArgTypes = require("./csf/getValuesFromArgTypes");
var _templateObject;
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) raw = strings.slice(0);
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
var setUndeclaredWarning = (0, _utilDeprecateDefault.default)(function() {}, (0, _tsDedentDefault.default)(_templateObject || (_templateObject = _taggedTemplateLiteral([
    "\n    Setting a global value that is undeclared (i.e. not in the user's initial set of globals\n    or globalTypes) is deprecated and will have no effect in 7.0.\n  "
]))));
var GlobalsStore = /*#__PURE__*/ function() {
    function GlobalsStore() {
        _classCallCheck(this, GlobalsStore);
        this.allowedGlobalNames = void 0;
        this.initialGlobals = void 0;
        this.globals = {};
    }
    _createClass(GlobalsStore, [
        {
            key: "set",
            value: function set(_ref) {
                var _ref$globals = _ref.globals, globals = _ref$globals === void 0 ? {} : _ref$globals, _ref$globalTypes = _ref.globalTypes, globalTypes = _ref$globalTypes === void 0 ? {} : _ref$globalTypes;
                var delta = this.initialGlobals && (0, _args.deepDiff)(this.initialGlobals, this.globals);
                this.allowedGlobalNames = new Set([].concat(_toConsumableArray(Object.keys(globals)), _toConsumableArray(Object.keys(globalTypes))));
                var defaultGlobals = (0, _getValuesFromArgTypes.getValuesFromArgTypes)(globalTypes);
                this.initialGlobals = Object.assign({}, defaultGlobals, globals);
                this.globals = this.initialGlobals;
                if (delta && delta !== (0, _args.DEEPLY_EQUAL)) this.updateFromPersisted(delta);
            }
        },
        {
            key: "filterAllowedGlobals",
            value: function filterAllowedGlobals(globals) {
                var _this = this;
                return Object.entries(globals).reduce(function(acc, _ref2) {
                    var _ref3 = _slicedToArray(_ref2, 2), key = _ref3[0], value = _ref3[1];
                    if (_this.allowedGlobalNames.has(key)) acc[key] = value;
                    return acc;
                }, {});
            }
        },
        {
            key: "updateFromPersisted",
            value: function updateFromPersisted(persisted) {
                var allowedUrlGlobals = this.filterAllowedGlobals(persisted); // Note that unlike args, we do not have the same type information for globals to allow us
                // to type check them here, so we just set them naively
                this.globals = Object.assign({}, this.globals, allowedUrlGlobals);
            }
        },
        {
            key: "get",
            value: function get() {
                return this.globals;
            }
        },
        {
            key: "update",
            value: function update(newGlobals) {
                var _this2 = this;
                Object.keys(newGlobals).forEach(function(key) {
                    if (!_this2.allowedGlobalNames.has(key)) setUndeclaredWarning();
                });
                this.globals = Object.assign({}, this.globals, newGlobals);
            }
        }
    ]);
    return GlobalsStore;
}();

},{"core-js/modules/es.array.slice.js":"8RRh9","core-js/modules/es.object.freeze.js":"9LVYO","core-js/modules/es.symbol.js":"ajw2f","core-js/modules/es.symbol.description.js":"wrlLc","core-js/modules/es.symbol.iterator.js":"fhNIb","core-js/modules/es.array.from.js":"9UCQw","core-js/modules/es.function.name.js":"4LiLL","core-js/modules/es.regexp.exec.js":"5q56v","core-js/modules/es.array.iterator.js":"ieU20","core-js/modules/es.object.to-string.js":"lsA9p","core-js/modules/es.set.js":"6FW6g","core-js/modules/es.string.iterator.js":"74a8v","core-js/modules/web.dom-collections.iterator.js":"aXR96","core-js/modules/es.array.concat.js":"g1t7q","core-js/modules/es.object.keys.js":"5Q2AT","core-js/modules/es.object.assign.js":"8FU8M","core-js/modules/es.object.entries.js":"7Wf79","core-js/modules/web.dom-collections.for-each.js":"iYT1M","util-deprecate":"lYmRJ","ts-dedent":"9RvVa","./args":"58bKx","./csf/getValuesFromArgTypes":"eZRpL","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"eZRpL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getValuesFromArgTypes", ()=>getValuesFromArgTypes);
var _esObjectToStringJs = require("core-js/modules/es.object.to-string.js");
var _esObjectEntriesJs = require("core-js/modules/es.object.entries.js");
var _esSymbolJs = require("core-js/modules/es.symbol.js");
var _esSymbolDescriptionJs = require("core-js/modules/es.symbol.description.js");
var _esSymbolIteratorJs = require("core-js/modules/es.symbol.iterator.js");
var _esArrayIteratorJs = require("core-js/modules/es.array.iterator.js");
var _esStringIteratorJs = require("core-js/modules/es.string.iterator.js");
var _webDomCollectionsIteratorJs = require("core-js/modules/web.dom-collections.iterator.js");
var _esArraySliceJs = require("core-js/modules/es.array.slice.js");
var _esFunctionNameJs = require("core-js/modules/es.function.name.js");
var _esArrayFromJs = require("core-js/modules/es.array.from.js");
var _esRegexpExecJs = require("core-js/modules/es.regexp.exec.js");
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var getValuesFromArgTypes = function getValuesFromArgTypes() {
    var argTypes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return Object.entries(argTypes).reduce(function(acc, _ref) {
        var _ref2 = _slicedToArray(_ref, 2), arg = _ref2[0], defaultValue = _ref2[1].defaultValue;
        if (typeof defaultValue !== "undefined") acc[arg] = defaultValue;
        return acc;
    }, {});
};

},{"core-js/modules/es.object.to-string.js":"lsA9p","core-js/modules/es.object.entries.js":"7Wf79","core-js/modules/es.symbol.js":"ajw2f","core-js/modules/es.symbol.description.js":"wrlLc","core-js/modules/es.symbol.iterator.js":"fhNIb","core-js/modules/es.array.iterator.js":"ieU20","core-js/modules/es.string.iterator.js":"74a8v","core-js/modules/web.dom-collections.iterator.js":"aXR96","core-js/modules/es.array.slice.js":"8RRh9","core-js/modules/es.function.name.js":"4LiLL","core-js/modules/es.array.from.js":"9UCQw","core-js/modules/es.regexp.exec.js":"5q56v","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"fGMu0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _normalizeInputTypes = require("./normalizeInputTypes");
parcelHelpers.exportAll(_normalizeInputTypes, exports);
var _normalizeStory = require("./normalizeStory");
parcelHelpers.exportAll(_normalizeStory, exports);
var _processCSFFile = require("./processCSFFile");
parcelHelpers.exportAll(_processCSFFile, exports);
var _prepareStory = require("./prepareStory");
parcelHelpers.exportAll(_prepareStory, exports);
var _normalizeComponentAnnotations = require("./normalizeComponentAnnotations");
parcelHelpers.exportAll(_normalizeComponentAnnotations, exports);
var _normalizeProjectAnnotations = require("./normalizeProjectAnnotations");
parcelHelpers.exportAll(_normalizeProjectAnnotations, exports);
var _getValuesFromArgTypes = require("./getValuesFromArgTypes");
parcelHelpers.exportAll(_getValuesFromArgTypes, exports);
var _composeConfigs = require("./composeConfigs");
parcelHelpers.exportAll(_composeConfigs, exports);
var _testingUtils = require("./testing-utils");
parcelHelpers.exportAll(_testingUtils, exports);

},{"./normalizeInputTypes":"lnztS","./normalizeStory":"bc556","./processCSFFile":"ahCTv","./prepareStory":"1UoAq","./normalizeComponentAnnotations":"4HK3g","./normalizeProjectAnnotations":"T05nV","./getValuesFromArgTypes":"eZRpL","./composeConfigs":"6xB3G","./testing-utils":"kSP6J","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"lnztS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "normalizeInputType", ()=>normalizeInputType);
parcelHelpers.export(exports, "normalizeInputTypes", ()=>normalizeInputTypes);
var _esObjectKeysJs = require("core-js/modules/es.object.keys.js");
var _esSymbolJs = require("core-js/modules/es.symbol.js");
var _esObjectAssignJs = require("core-js/modules/es.object.assign.js");
var _mapValues = require("lodash/mapValues");
var _mapValuesDefault = parcelHelpers.interopDefault(_mapValues);
var _excluded = [
    "type",
    "control"
];
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var normalizeType = function normalizeType(type) {
    return typeof type === "string" ? {
        name: type
    } : type;
};
var normalizeControl = function normalizeControl(control) {
    return typeof control === "string" ? {
        type: control
    } : control;
};
var normalizeInputType = function normalizeInputType(inputType, key) {
    var type = inputType.type, control = inputType.control, rest = _objectWithoutProperties(inputType, _excluded);
    var normalized = Object.assign({
        name: key
    }, rest);
    if (type) normalized.type = normalizeType(type);
    if (control) normalized.control = normalizeControl(control);
    else if (control === false) normalized.control = {
        disable: true
    };
    return normalized;
};
var normalizeInputTypes = function normalizeInputTypes(inputTypes) {
    return (0, _mapValuesDefault.default)(inputTypes, normalizeInputType);
};

},{"core-js/modules/es.object.keys.js":"5Q2AT","core-js/modules/es.symbol.js":"ajw2f","core-js/modules/es.object.assign.js":"8FU8M","lodash/mapValues":"fBbhh","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"bc556":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "normalizeStory", ()=>normalizeStory);
var _esArraySliceJs = require("core-js/modules/es.array.slice.js");
var _esObjectFreezeJs = require("core-js/modules/es.object.freeze.js");
var _esSymbolJs = require("core-js/modules/es.symbol.js");
var _esSymbolDescriptionJs = require("core-js/modules/es.symbol.description.js");
var _esObjectToStringJs = require("core-js/modules/es.object.to-string.js");
var _esSymbolIteratorJs = require("core-js/modules/es.symbol.iterator.js");
var _esArrayIteratorJs = require("core-js/modules/es.array.iterator.js");
var _esStringIteratorJs = require("core-js/modules/es.string.iterator.js");
var _webDomCollectionsIteratorJs = require("core-js/modules/web.dom-collections.iterator.js");
var _esArrayFromJs = require("core-js/modules/es.array.from.js");
var _esRegexpExecJs = require("core-js/modules/es.regexp.exec.js");
var _esFunctionNameJs = require("core-js/modules/es.function.name.js");
var _esArrayConcatJs = require("core-js/modules/es.array.concat.js");
var _esObjectAssignJs = require("core-js/modules/es.object.assign.js");
var _csf = require("@storybook/csf");
var _tsDedent = require("ts-dedent");
var _tsDedentDefault = parcelHelpers.interopDefault(_tsDedent);
var _clientLogger = require("@storybook/client-logger");
var _utilDeprecate = require("util-deprecate");
var _utilDeprecateDefault = parcelHelpers.interopDefault(_utilDeprecate);
var _normalizeInputTypes = require("./normalizeInputTypes");
var _templateObject;
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) raw = strings.slice(0);
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
var deprecatedStoryAnnotation = (0, _tsDedentDefault.default)(_templateObject || (_templateObject = _taggedTemplateLiteral([
    "\nCSF .story annotations deprecated; annotate story functions directly:\n- StoryFn.story.name => StoryFn.storyName\n- StoryFn.story.(parameters|decorators) => StoryFn.(parameters|decorators)\nSee https://github.com/storybookjs/storybook/blob/next/MIGRATION.md#hoisted-csf-annotations for details and codemod.\n"
])));
var deprecatedStoryAnnotationWarning = (0, _utilDeprecateDefault.default)(function() {}, deprecatedStoryAnnotation);
function normalizeStory(key, storyAnnotations, meta) {
    var userStoryFn;
    var storyObject;
    if (typeof storyAnnotations === "function") {
        userStoryFn = storyAnnotations;
        storyObject = storyAnnotations;
    } else storyObject = storyAnnotations;
    var _storyObject = storyObject, story = _storyObject.story;
    if (story) {
        (0, _clientLogger.logger).debug("deprecated story", story);
        deprecatedStoryAnnotationWarning();
    }
    var exportName = (0, _csf.storyNameFromExport)(key);
    var name = typeof storyObject !== "function" && storyObject.name || storyObject.storyName || (story === null || story === void 0 ? void 0 : story.name) || exportName;
    var decorators = [].concat(_toConsumableArray(storyObject.decorators || []), _toConsumableArray((story === null || story === void 0 ? void 0 : story.decorators) || []));
    var parameters = Object.assign({}, story === null || story === void 0 ? void 0 : story.parameters, storyObject.parameters);
    var args = Object.assign({}, story === null || story === void 0 ? void 0 : story.args, storyObject.args);
    var argTypes = Object.assign({}, story === null || story === void 0 ? void 0 : story.argTypes, storyObject.argTypes);
    var loaders = [].concat(_toConsumableArray(storyObject.loaders || []), _toConsumableArray((story === null || story === void 0 ? void 0 : story.loaders) || []));
    var _storyObject2 = storyObject, render = _storyObject2.render, play = _storyObject2.play; // eslint-disable-next-line no-underscore-dangle
    var id = parameters.__id || (0, _csf.toId)(meta.id || meta.title, exportName);
    return Object.assign({
        id: id,
        name: name,
        decorators: decorators,
        parameters: parameters,
        args: args,
        argTypes: (0, _normalizeInputTypes.normalizeInputTypes)(argTypes),
        loaders: loaders
    }, render && {
        render: render
    }, userStoryFn && {
        userStoryFn: userStoryFn
    }, play && {
        play: play
    });
}

},{"core-js/modules/es.array.slice.js":"8RRh9","core-js/modules/es.object.freeze.js":"9LVYO","core-js/modules/es.symbol.js":"ajw2f","core-js/modules/es.symbol.description.js":"wrlLc","core-js/modules/es.object.to-string.js":"lsA9p","core-js/modules/es.symbol.iterator.js":"fhNIb","core-js/modules/es.array.iterator.js":"ieU20","core-js/modules/es.string.iterator.js":"74a8v","core-js/modules/web.dom-collections.iterator.js":"aXR96","core-js/modules/es.array.from.js":"9UCQw","core-js/modules/es.regexp.exec.js":"5q56v","core-js/modules/es.function.name.js":"4LiLL","core-js/modules/es.array.concat.js":"g1t7q","core-js/modules/es.object.assign.js":"8FU8M","@storybook/csf":"f7MI8","ts-dedent":"9RvVa","@storybook/client-logger":"iGRus","util-deprecate":"lYmRJ","./normalizeInputTypes":"lnztS","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"ahCTv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "processCSFFile", ()=>processCSFFile);
var _esSymbolJs = require("core-js/modules/es.symbol.js");
var _esObjectToStringJs = require("core-js/modules/es.object.to-string.js");
var _webDomCollectionsForEachJs = require("core-js/modules/web.dom-collections.for-each.js");
var _esObjectKeysJs = require("core-js/modules/es.object.keys.js");
var _csf = require("@storybook/csf");
var _clientLogger = require("@storybook/client-logger");
var _normalizeStory = require("./normalizeStory");
var _normalizeComponentAnnotations = require("./normalizeComponentAnnotations");
var _excluded = [
    "default",
    "__namedExportsOrder"
];
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var checkGlobals = function checkGlobals(parameters) {
    var globals = parameters.globals, globalTypes = parameters.globalTypes;
    if (globals || globalTypes) (0, _clientLogger.logger).error("Global args/argTypes can only be set globally", JSON.stringify({
        globals: globals,
        globalTypes: globalTypes
    }));
};
var checkStorySort = function checkStorySort(parameters) {
    var options = parameters.options;
    if (options !== null && options !== void 0 && options.storySort) (0, _clientLogger.logger).error("The storySort option parameter can only be set globally");
};
var checkDisallowedParameters = function checkDisallowedParameters(parameters) {
    if (!parameters) return;
    checkGlobals(parameters);
    checkStorySort(parameters);
}; // Given the raw exports of a CSF file, check and normalize it.
function processCSFFile(moduleExports, importPath, title) {
    var defaultExport = moduleExports.default, __namedExportsOrder = moduleExports.__namedExportsOrder, namedExports = _objectWithoutProperties(moduleExports, _excluded);
    var meta = (0, _normalizeComponentAnnotations.normalizeComponentAnnotations)(defaultExport, title, importPath);
    checkDisallowedParameters(meta.parameters);
    var csfFile = {
        meta: meta,
        stories: {}
    };
    Object.keys(namedExports).forEach(function(key) {
        if ((0, _csf.isExportStory)(key, meta)) {
            var storyMeta = (0, _normalizeStory.normalizeStory)(key, namedExports[key], meta);
            checkDisallowedParameters(storyMeta.parameters);
            csfFile.stories[storyMeta.id] = storyMeta;
        }
    });
    return csfFile;
}

},{"core-js/modules/es.symbol.js":"ajw2f","core-js/modules/es.object.to-string.js":"lsA9p","core-js/modules/web.dom-collections.for-each.js":"iYT1M","core-js/modules/es.object.keys.js":"5Q2AT","@storybook/csf":"f7MI8","@storybook/client-logger":"iGRus","./normalizeStory":"bc556","./normalizeComponentAnnotations":"4HK3g","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"4HK3g":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "normalizeComponentAnnotations", ()=>normalizeComponentAnnotations);
var _esObjectAssignJs = require("core-js/modules/es.object.assign.js");
var _csf = require("@storybook/csf");
var _normalizeInputTypes = require("./normalizeInputTypes");
function normalizeComponentAnnotations(defaultExport) {
    var title = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultExport.title;
    var importPath = arguments.length > 2 ? arguments[2] : undefined;
    var id = defaultExport.id, argTypes = defaultExport.argTypes;
    return Object.assign({
        id: (0, _csf.sanitize)(id || title)
    }, defaultExport, {
        title: title
    }, argTypes && {
        argTypes: (0, _normalizeInputTypes.normalizeInputTypes)(argTypes)
    }, {
        parameters: Object.assign({
            fileName: importPath
        }, defaultExport.parameters)
    });
}

},{"core-js/modules/es.object.assign.js":"8FU8M","@storybook/csf":"f7MI8","./normalizeInputTypes":"lnztS","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"1UoAq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// into a "renderable" story function, with all decorators applied, parameters passed as context etc
//
// Note that this story function is *stateless* in the sense that it does not track args or globals
// Instead, it is expected these are tracked separately (if necessary) and are passed into each invocation.
parcelHelpers.export(exports, "prepareStory", ()=>prepareStory);
var _esArraySliceJs = require("core-js/modules/es.array.slice.js");
var _esSymbolJs = require("core-js/modules/es.symbol.js");
var _esSymbolDescriptionJs = require("core-js/modules/es.symbol.description.js");
var _esSymbolIteratorJs = require("core-js/modules/es.symbol.iterator.js");
var _esArrayFromJs = require("core-js/modules/es.array.from.js");
var _esRegexpExecJs = require("core-js/modules/es.regexp.exec.js");
var _esFunctionNameJs = require("core-js/modules/es.function.name.js");
var _esArrayConcatJs = require("core-js/modules/es.array.concat.js");
var _esObjectAssignJs = require("core-js/modules/es.object.assign.js");
var _esObjectToStringJs = require("core-js/modules/es.object.to-string.js");
var _esObjectKeysJs = require("core-js/modules/es.object.keys.js");
var _esArrayIteratorJs = require("core-js/modules/es.array.iterator.js");
var _esPromiseJs = require("core-js/modules/es.promise.js");
var _esStringIteratorJs = require("core-js/modules/es.string.iterator.js");
var _webDomCollectionsIteratorJs = require("core-js/modules/web.dom-collections.iterator.js");
var _esArrayMapJs = require("core-js/modules/es.array.map.js");
var _esObjectEntriesJs = require("core-js/modules/es.object.entries.js");
var _esObjectFreezeJs = require("core-js/modules/es.object.freeze.js");
var _tsDedent = require("ts-dedent");
var _tsDedentDefault = parcelHelpers.interopDefault(_tsDedent);
var _utilDeprecate = require("util-deprecate");
var _utilDeprecateDefault = parcelHelpers.interopDefault(_utilDeprecate);
var _global = require("global");
var _globalDefault = parcelHelpers.interopDefault(_global);
var _csf = require("@storybook/csf");
var _parameters = require("../parameters");
var _hooks = require("../hooks");
var _decorators = require("../decorators");
var _args = require("../args");
var _getValuesFromArgTypes = require("./getValuesFromArgTypes");
var _templateObject;
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) raw = strings.slice(0);
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
var argTypeDefaultValueWarning = (0, _utilDeprecateDefault.default)(function() {}, (0, _tsDedentDefault.default)(_templateObject || (_templateObject = _taggedTemplateLiteral([
    "\n  `argType.defaultValue` is deprecated and will be removed in Storybook 7.0.\n\n  https://github.com/storybookjs/storybook/blob/next/MIGRATION.md#no-longer-inferring-default-values-of-args"
], [
    "\n  \\`argType.defaultValue\\` is deprecated and will be removed in Storybook 7.0.\n\n  https://github.com/storybookjs/storybook/blob/next/MIGRATION.md#no-longer-inferring-default-values-of-args"
])))); // Combine all the metadata about a story (both direct and inherited from the component/global scope)
function prepareStory(storyAnnotations, componentAnnotations, projectAnnotations) {
    var _global$FEATURES;
    // NOTE: in the current implementation we are doing everything once, up front, rather than doing
    // anything at render time. The assumption is that as we don't load all the stories at once, this
    // will have a limited cost. If this proves misguided, we can refactor it.
    var id = storyAnnotations.id, name = storyAnnotations.name;
    var title = componentAnnotations.title;
    var parameters = (0, _parameters.combineParameters)(projectAnnotations.parameters, componentAnnotations.parameters, storyAnnotations.parameters);
    var decorators = [].concat(_toConsumableArray(storyAnnotations.decorators || []), _toConsumableArray(componentAnnotations.decorators || []), _toConsumableArray(projectAnnotations.decorators || [])); // Currently it is only possible to set these globally
    var _projectAnnotations$a = projectAnnotations.applyDecorators, applyDecorators = _projectAnnotations$a === void 0 ? (0, _decorators.defaultDecorateStory) : _projectAnnotations$a, _projectAnnotations$a2 = projectAnnotations.argTypesEnhancers, argTypesEnhancers = _projectAnnotations$a2 === void 0 ? [] : _projectAnnotations$a2, _projectAnnotations$a3 = projectAnnotations.argsEnhancers, argsEnhancers = _projectAnnotations$a3 === void 0 ? [] : _projectAnnotations$a3;
    var loaders = [].concat(_toConsumableArray(projectAnnotations.loaders || []), _toConsumableArray(componentAnnotations.loaders || []), _toConsumableArray(storyAnnotations.loaders || [])); // The render function on annotations *has* to be an `ArgsStoryFn`, so when we normalize
    // CSFv1/2, we use a new field called `userStoryFn` so we know that it can be a LegacyStoryFn
    var render = storyAnnotations.userStoryFn || storyAnnotations.render || componentAnnotations.render || projectAnnotations.render;
    var passedArgTypes = (0, _parameters.combineParameters)(projectAnnotations.argTypes, componentAnnotations.argTypes, storyAnnotations.argTypes);
    var _parameters$passArgsF = parameters.passArgsFirst, passArgsFirst = _parameters$passArgsF === void 0 ? true : _parameters$passArgsF; // eslint-disable-next-line no-underscore-dangle
    parameters.__isArgsStory = passArgsFirst && render.length > 0; // Pull out args[X] into initialArgs for argTypes enhancers
    var passedArgs = Object.assign({}, projectAnnotations.args, componentAnnotations.args, storyAnnotations.args);
    var contextForEnhancers = {
        componentId: componentAnnotations.id,
        title: title,
        kind: title,
        // Back compat
        id: id,
        name: name,
        story: name,
        // Back compat
        component: componentAnnotations.component,
        subcomponents: componentAnnotations.subcomponents,
        parameters: parameters,
        initialArgs: passedArgs,
        argTypes: passedArgTypes
    };
    contextForEnhancers.argTypes = argTypesEnhancers.reduce(function(accumulatedArgTypes, enhancer) {
        return enhancer(Object.assign({}, contextForEnhancers, {
            argTypes: accumulatedArgTypes
        }));
    }, contextForEnhancers.argTypes); // Add argTypes[X].defaultValue to initial args (note this deprecated)
    // We need to do this *after* the argTypesEnhancers as they may add defaultValues
    var defaultArgs = (0, _getValuesFromArgTypes.getValuesFromArgTypes)(contextForEnhancers.argTypes);
    if (Object.keys(defaultArgs).length > 0) argTypeDefaultValueWarning();
    var initialArgsBeforeEnhancers = Object.assign({}, defaultArgs, passedArgs);
    contextForEnhancers.initialArgs = argsEnhancers.reduce(function(accumulatedArgs, enhancer) {
        return Object.assign({}, accumulatedArgs, enhancer(Object.assign({}, contextForEnhancers, {
            initialArgs: accumulatedArgs
        })));
    }, initialArgsBeforeEnhancers); // Add some of our metadata into parameters as we used to do this in 6.x and users may be relying on it
    if (!((_global$FEATURES = (0, _globalDefault.default).FEATURES) !== null && _global$FEATURES !== void 0 && _global$FEATURES.breakingChangesV7)) contextForEnhancers.parameters = Object.assign({}, contextForEnhancers.parameters, {
        __id: id,
        globals: projectAnnotations.globals,
        globalTypes: projectAnnotations.globalTypes,
        args: contextForEnhancers.initialArgs,
        argTypes: contextForEnhancers.argTypes
    });
    var applyLoaders = /*#__PURE__*/ function() {
        var _ref = _asyncToGenerator(/*#__PURE__*/ regeneratorRuntime.mark(function _callee(context) {
            var loadResults, loaded;
            return regeneratorRuntime.wrap(function _callee$(_context) {
                while(true)switch(_context.prev = _context.next){
                    case 0:
                        _context.next = 2;
                        return Promise.all(loaders.map(function(loader) {
                            return loader(context);
                        }));
                    case 2:
                        loadResults = _context.sent;
                        loaded = Object.assign.apply(Object, [
                            {}
                        ].concat(_toConsumableArray(loadResults)));
                        return _context.abrupt("return", Object.assign({}, context, {
                            loaded: loaded
                        }));
                    case 5:
                    case "end":
                        return _context.stop();
                }
            }, _callee);
        }));
        return function applyLoaders(_x) {
            return _ref.apply(this, arguments);
        };
    }();
    var undecoratedStoryFn = function undecoratedStoryFn(context) {
        var mappedArgs = Object.entries(context.args).reduce(function(acc, _ref2) {
            var _context$argTypes$key;
            var _ref3 = _slicedToArray(_ref2, 2), key = _ref3[0], val = _ref3[1];
            var mapping = (_context$argTypes$key = context.argTypes[key]) === null || _context$argTypes$key === void 0 ? void 0 : _context$argTypes$key.mapping;
            acc[key] = mapping && val in mapping ? mapping[val] : val;
            return acc;
        }, {});
        var includedArgs = Object.entries(mappedArgs).reduce(function(acc, _ref4) {
            var _ref5 = _slicedToArray(_ref4, 2), key = _ref5[0], val = _ref5[1];
            var argType = context.argTypes[key] || {};
            if ((0, _csf.includeConditionalArg)(argType, mappedArgs, context.globals)) acc[key] = val;
            return acc;
        }, {});
        var includedContext = Object.assign({}, context, {
            args: includedArgs
        });
        var _context$parameters$p = context.parameters.passArgsFirst, renderTimePassArgsFirst = _context$parameters$p === void 0 ? true : _context$parameters$p;
        return renderTimePassArgsFirst ? render(includedContext.args, includedContext) : render(includedContext);
    };
    var decoratedStoryFn = (0, _hooks.applyHooks)(applyDecorators)(undecoratedStoryFn, decorators);
    var unboundStoryFn = function unboundStoryFn(context) {
        var _global$FEATURES2;
        var finalContext = context;
        if ((_global$FEATURES2 = (0, _globalDefault.default).FEATURES) !== null && _global$FEATURES2 !== void 0 && _global$FEATURES2.argTypeTargetsV7) {
            var argsByTarget = (0, _args.groupArgsByTarget)(Object.assign({
                args: context.args
            }, context));
            finalContext = Object.assign({}, context, {
                allArgs: context.args,
                argsByTarget: argsByTarget,
                args: argsByTarget[0, _args.NO_TARGET_NAME] || {}
            });
        }
        return decoratedStoryFn(finalContext);
    };
    var playFunction = storyAnnotations.play;
    return Object.freeze(Object.assign({}, contextForEnhancers, {
        originalStoryFn: render,
        undecoratedStoryFn: undecoratedStoryFn,
        unboundStoryFn: unboundStoryFn,
        applyLoaders: applyLoaders,
        playFunction: playFunction
    }));
}

},{"core-js/modules/es.array.slice.js":"8RRh9","core-js/modules/es.symbol.js":"ajw2f","core-js/modules/es.symbol.description.js":"wrlLc","core-js/modules/es.symbol.iterator.js":"fhNIb","core-js/modules/es.array.from.js":"9UCQw","core-js/modules/es.regexp.exec.js":"5q56v","core-js/modules/es.function.name.js":"4LiLL","core-js/modules/es.array.concat.js":"g1t7q","core-js/modules/es.object.assign.js":"8FU8M","core-js/modules/es.object.to-string.js":"lsA9p","core-js/modules/es.object.keys.js":"5Q2AT","core-js/modules/es.array.iterator.js":"ieU20","core-js/modules/es.promise.js":"2jax7","core-js/modules/es.string.iterator.js":"74a8v","core-js/modules/web.dom-collections.iterator.js":"aXR96","core-js/modules/es.array.map.js":"jTP7e","core-js/modules/es.object.entries.js":"7Wf79","core-js/modules/es.object.freeze.js":"9LVYO","ts-dedent":"9RvVa","util-deprecate":"lYmRJ","global":"5PzlO","@storybook/csf":"f7MI8","../parameters":"8T89l","../hooks":"csdah","../decorators":"c5Z0N","../args":"58bKx","./getValuesFromArgTypes":"eZRpL","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"8T89l":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "combineParameters", ()=>combineParameters);
var _esObjectToStringJs = require("core-js/modules/es.object.to-string.js");
var _esArrayFilterJs = require("core-js/modules/es.array.filter.js");
var _webDomCollectionsForEachJs = require("core-js/modules/web.dom-collections.for-each.js");
var _esObjectEntriesJs = require("core-js/modules/es.object.entries.js");
var _esObjectKeysJs = require("core-js/modules/es.object.keys.js");
var _esArrayMapJs = require("core-js/modules/es.array.map.js");
var _esSymbolJs = require("core-js/modules/es.symbol.js");
var _esSymbolDescriptionJs = require("core-js/modules/es.symbol.description.js");
var _esSymbolIteratorJs = require("core-js/modules/es.symbol.iterator.js");
var _esArrayIteratorJs = require("core-js/modules/es.array.iterator.js");
var _esStringIteratorJs = require("core-js/modules/es.string.iterator.js");
var _webDomCollectionsIteratorJs = require("core-js/modules/web.dom-collections.iterator.js");
var _esArraySliceJs = require("core-js/modules/es.array.slice.js");
var _esFunctionNameJs = require("core-js/modules/es.function.name.js");
var _esArrayFromJs = require("core-js/modules/es.array.from.js");
var _esRegexpExecJs = require("core-js/modules/es.regexp.exec.js");
// Utilities for handling parameters
var _isPlainObject = require("lodash/isPlainObject");
var _isPlainObjectDefault = parcelHelpers.interopDefault(_isPlainObject);
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var combineParameters = function combineParameters() {
    for(var _len = arguments.length, parameterSets = new Array(_len), _key = 0; _key < _len; _key++)parameterSets[_key] = arguments[_key];
    var mergeKeys = {};
    var combined = parameterSets.filter(Boolean).reduce(function(acc, p) {
        Object.entries(p).forEach(function(_ref) {
            var _ref2 = _slicedToArray(_ref, 2), key = _ref2[0], value = _ref2[1];
            var existing = acc[key];
            if (Array.isArray(value) || typeof existing === "undefined") acc[key] = value;
            else if ((0, _isPlainObjectDefault.default)(value) && (0, _isPlainObjectDefault.default)(existing)) // do nothing, we'll handle this later
            mergeKeys[key] = true;
            else if (typeof value !== "undefined") acc[key] = value;
        });
        return acc;
    }, {});
    Object.keys(mergeKeys).forEach(function(key) {
        var mergeValues = parameterSets.filter(Boolean).map(function(p) {
            return p[key];
        }).filter(function(value) {
            return typeof value !== "undefined";
        });
        if (mergeValues.every(function(value) {
            return (0, _isPlainObjectDefault.default)(value);
        })) combined[key] = combineParameters.apply(void 0, _toConsumableArray(mergeValues));
        else combined[key] = mergeValues[mergeValues.length - 1];
    });
    return combined;
};

},{"core-js/modules/es.object.to-string.js":"lsA9p","core-js/modules/es.array.filter.js":"fD2da","core-js/modules/web.dom-collections.for-each.js":"iYT1M","core-js/modules/es.object.entries.js":"7Wf79","core-js/modules/es.object.keys.js":"5Q2AT","core-js/modules/es.array.map.js":"jTP7e","core-js/modules/es.symbol.js":"ajw2f","core-js/modules/es.symbol.description.js":"wrlLc","core-js/modules/es.symbol.iterator.js":"fhNIb","core-js/modules/es.array.iterator.js":"ieU20","core-js/modules/es.string.iterator.js":"74a8v","core-js/modules/web.dom-collections.iterator.js":"aXR96","core-js/modules/es.array.slice.js":"8RRh9","core-js/modules/es.function.name.js":"4LiLL","core-js/modules/es.array.from.js":"9UCQw","core-js/modules/es.regexp.exec.js":"5q56v","lodash/isPlainObject":"9m4Iw","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"csdah":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HooksContext", ()=>(0, _addons.HooksContext));
parcelHelpers.export(exports, "applyHooks", ()=>(0, _addons.applyHooks));
parcelHelpers.export(exports, "useMemo", ()=>(0, _addons.useMemo));
parcelHelpers.export(exports, "useCallback", ()=>(0, _addons.useCallback));
parcelHelpers.export(exports, "useRef", ()=>(0, _addons.useRef));
parcelHelpers.export(exports, "useState", ()=>(0, _addons.useState));
parcelHelpers.export(exports, "useReducer", ()=>(0, _addons.useReducer));
parcelHelpers.export(exports, "useEffect", ()=>(0, _addons.useEffect));
parcelHelpers.export(exports, "useChannel", ()=>(0, _addons.useChannel));
parcelHelpers.export(exports, "useStoryContext", ()=>(0, _addons.useStoryContext));
parcelHelpers.export(exports, "useParameter", ()=>(0, _addons.useParameter));
parcelHelpers.export(exports, "useArgs", ()=>(0, _addons.useArgs));
parcelHelpers.export(exports, "useGlobals", ()=>(0, _addons.useGlobals));
parcelHelpers.export(exports, "useSharedState", ()=>useSharedState);
parcelHelpers.export(exports, "useAddonState", ()=>useAddonState);
var _esArrayConcatJs = require("core-js/modules/es.array.concat.js");
var _esSymbolJs = require("core-js/modules/es.symbol.js");
var _esSymbolDescriptionJs = require("core-js/modules/es.symbol.description.js");
var _esObjectToStringJs = require("core-js/modules/es.object.to-string.js");
var _esSymbolIteratorJs = require("core-js/modules/es.symbol.iterator.js");
var _esArrayIteratorJs = require("core-js/modules/es.array.iterator.js");
var _esStringIteratorJs = require("core-js/modules/es.string.iterator.js");
var _webDomCollectionsIteratorJs = require("core-js/modules/web.dom-collections.iterator.js");
var _esArraySliceJs = require("core-js/modules/es.array.slice.js");
var _esFunctionNameJs = require("core-js/modules/es.function.name.js");
var _esArrayFromJs = require("core-js/modules/es.array.from.js");
var _esRegexpExecJs = require("core-js/modules/es.regexp.exec.js");
var _coreEvents = require("@storybook/core-events");
var _addons = require("@storybook/addons");
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function useSharedState(sharedId, defaultState) {
    var channel = (0, _addons.addons).getChannel();
    var _ref = channel.last("".concat((0, _coreEvents.SHARED_STATE_CHANGED), "-manager-").concat(sharedId)) || channel.last("".concat((0, _coreEvents.SHARED_STATE_SET), "-manager-").concat(sharedId)) || [], _ref2 = _slicedToArray(_ref, 1), lastValue = _ref2[0];
    var _useState = (0, _addons.useState)(lastValue || defaultState), _useState2 = _slicedToArray(_useState, 2), state = _useState2[0], setState = _useState2[1];
    var allListeners = (0, _addons.useMemo)(function() {
        var _ref3;
        return _ref3 = {}, _defineProperty(_ref3, "".concat((0, _coreEvents.SHARED_STATE_CHANGED), "-manager-").concat(sharedId), function manager(s) {
            return setState(s);
        }), _defineProperty(_ref3, "".concat((0, _coreEvents.SHARED_STATE_SET), "-manager-").concat(sharedId), function manager(s) {
            return setState(s);
        }), _ref3;
    }, [
        sharedId
    ]);
    var emit = (0, _addons.useChannel)(allListeners, [
        sharedId
    ]);
    (0, _addons.useEffect)(function() {
        // init
        if (defaultState !== undefined && !lastValue) emit("".concat((0, _coreEvents.SHARED_STATE_SET), "-client-").concat(sharedId), defaultState);
    }, [
        sharedId
    ]);
    return [
        state,
        function(s) {
            setState(s);
            emit("".concat((0, _coreEvents.SHARED_STATE_CHANGED), "-client-").concat(sharedId), s);
        }
    ];
}
function useAddonState(addonId, defaultState) {
    return useSharedState(addonId, defaultState);
}

},{"core-js/modules/es.array.concat.js":"g1t7q","core-js/modules/es.symbol.js":"ajw2f","core-js/modules/es.symbol.description.js":"wrlLc","core-js/modules/es.object.to-string.js":"lsA9p","core-js/modules/es.symbol.iterator.js":"fhNIb","core-js/modules/es.array.iterator.js":"ieU20","core-js/modules/es.string.iterator.js":"74a8v","core-js/modules/web.dom-collections.iterator.js":"aXR96","core-js/modules/es.array.slice.js":"8RRh9","core-js/modules/es.function.name.js":"4LiLL","core-js/modules/es.array.from.js":"9UCQw","core-js/modules/es.regexp.exec.js":"5q56v","@storybook/core-events":"bJpgo","@storybook/addons":"88cx9","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"bJpgo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CHANNEL_CREATED", ()=>CHANNEL_CREATED);
parcelHelpers.export(exports, "CONFIG_ERROR", ()=>CONFIG_ERROR);
parcelHelpers.export(exports, "STORY_INDEX_INVALIDATED", ()=>STORY_INDEX_INVALIDATED);
parcelHelpers.export(exports, "STORY_SPECIFIED", ()=>STORY_SPECIFIED);
parcelHelpers.export(exports, "SET_STORIES", ()=>SET_STORIES);
parcelHelpers.export(exports, "SET_CURRENT_STORY", ()=>SET_CURRENT_STORY);
parcelHelpers.export(exports, "CURRENT_STORY_WAS_SET", ()=>CURRENT_STORY_WAS_SET);
parcelHelpers.export(exports, "FORCE_RE_RENDER", ()=>FORCE_RE_RENDER);
parcelHelpers.export(exports, "FORCE_REMOUNT", ()=>FORCE_REMOUNT);
parcelHelpers.export(exports, "STORY_PREPARED", ()=>STORY_PREPARED);
parcelHelpers.export(exports, "STORY_CHANGED", ()=>STORY_CHANGED);
parcelHelpers.export(exports, "STORY_UNCHANGED", ()=>STORY_UNCHANGED);
parcelHelpers.export(exports, "PRELOAD_STORIES", ()=>PRELOAD_STORIES);
parcelHelpers.export(exports, "STORY_RENDERED", ()=>STORY_RENDERED);
parcelHelpers.export(exports, "STORY_MISSING", ()=>STORY_MISSING);
parcelHelpers.export(exports, "STORY_ERRORED", ()=>STORY_ERRORED);
parcelHelpers.export(exports, "STORY_THREW_EXCEPTION", ()=>STORY_THREW_EXCEPTION);
parcelHelpers.export(exports, "STORY_RENDER_PHASE_CHANGED", ()=>STORY_RENDER_PHASE_CHANGED);
parcelHelpers.export(exports, "UPDATE_STORY_ARGS", ()=>UPDATE_STORY_ARGS);
parcelHelpers.export(exports, "STORY_ARGS_UPDATED", ()=>STORY_ARGS_UPDATED);
parcelHelpers.export(exports, "RESET_STORY_ARGS", ()=>RESET_STORY_ARGS);
parcelHelpers.export(exports, "SET_GLOBALS", ()=>SET_GLOBALS);
parcelHelpers.export(exports, "UPDATE_GLOBALS", ()=>UPDATE_GLOBALS);
parcelHelpers.export(exports, "GLOBALS_UPDATED", ()=>GLOBALS_UPDATED);
parcelHelpers.export(exports, "REGISTER_SUBSCRIPTION", ()=>REGISTER_SUBSCRIPTION);
parcelHelpers.export(exports, "PREVIEW_KEYDOWN", ()=>PREVIEW_KEYDOWN);
parcelHelpers.export(exports, "SELECT_STORY", ()=>SELECT_STORY);
parcelHelpers.export(exports, "STORIES_COLLAPSE_ALL", ()=>STORIES_COLLAPSE_ALL);
parcelHelpers.export(exports, "STORIES_EXPAND_ALL", ()=>STORIES_EXPAND_ALL);
parcelHelpers.export(exports, "DOCS_RENDERED", ()=>DOCS_RENDERED);
parcelHelpers.export(exports, "SHARED_STATE_CHANGED", ()=>SHARED_STATE_CHANGED);
parcelHelpers.export(exports, "SHARED_STATE_SET", ()=>SHARED_STATE_SET);
parcelHelpers.export(exports, "NAVIGATE_URL", ()=>NAVIGATE_URL);
parcelHelpers.export(exports, "UPDATE_QUERY_PARAMS", ()=>UPDATE_QUERY_PARAMS);
parcelHelpers.export(exports, "IGNORED_EXCEPTION", ()=>IGNORED_EXCEPTION);
var events; // Enables: `import Events from ...`
(function(events) {
    events["CHANNEL_CREATED"] = "channelCreated";
    events["CONFIG_ERROR"] = "configError";
    events["STORY_INDEX_INVALIDATED"] = "storyIndexInvalidated";
    events["STORY_SPECIFIED"] = "storySpecified";
    events["SET_STORIES"] = "setStories";
    events["SET_CURRENT_STORY"] = "setCurrentStory";
    events["CURRENT_STORY_WAS_SET"] = "currentStoryWasSet";
    events["FORCE_RE_RENDER"] = "forceReRender";
    events["FORCE_REMOUNT"] = "forceRemount";
    events["PRELOAD_STORIES"] = "preloadStories";
    events["STORY_PREPARED"] = "storyPrepared";
    events["STORY_CHANGED"] = "storyChanged";
    events["STORY_UNCHANGED"] = "storyUnchanged";
    events["STORY_RENDERED"] = "storyRendered";
    events["STORY_MISSING"] = "storyMissing";
    events["STORY_ERRORED"] = "storyErrored";
    events["STORY_THREW_EXCEPTION"] = "storyThrewException";
    events["STORY_RENDER_PHASE_CHANGED"] = "storyRenderPhaseChanged";
    events["UPDATE_STORY_ARGS"] = "updateStoryArgs";
    events["STORY_ARGS_UPDATED"] = "storyArgsUpdated";
    events["RESET_STORY_ARGS"] = "resetStoryArgs";
    events["SET_GLOBALS"] = "setGlobals";
    events["UPDATE_GLOBALS"] = "updateGlobals";
    events["GLOBALS_UPDATED"] = "globalsUpdated";
    events["REGISTER_SUBSCRIPTION"] = "registerSubscription";
    events["PREVIEW_KEYDOWN"] = "previewKeydown";
    events["SELECT_STORY"] = "selectStory";
    events["STORIES_COLLAPSE_ALL"] = "storiesCollapseAll";
    events["STORIES_EXPAND_ALL"] = "storiesExpandAll";
    events["DOCS_RENDERED"] = "docsRendered";
    events["SHARED_STATE_CHANGED"] = "sharedStateChanged";
    events["SHARED_STATE_SET"] = "sharedStateSet";
    events["NAVIGATE_URL"] = "navigateUrl";
    events["UPDATE_QUERY_PARAMS"] = "updateQueryParams";
})(events || (events = {}));
exports.default = events; // Enables: `import * as Events from ...` or `import { CHANNEL_CREATED } as Events from ...`
// This is the preferred method
var CHANNEL_CREATED = events.CHANNEL_CREATED, CONFIG_ERROR = events.CONFIG_ERROR, STORY_INDEX_INVALIDATED = events.STORY_INDEX_INVALIDATED, STORY_SPECIFIED = events.STORY_SPECIFIED, SET_STORIES = events.SET_STORIES, SET_CURRENT_STORY = events.SET_CURRENT_STORY, CURRENT_STORY_WAS_SET = events.CURRENT_STORY_WAS_SET, FORCE_RE_RENDER = events.FORCE_RE_RENDER, FORCE_REMOUNT = events.FORCE_REMOUNT, STORY_PREPARED = events.STORY_PREPARED, STORY_CHANGED = events.STORY_CHANGED, STORY_UNCHANGED = events.STORY_UNCHANGED, PRELOAD_STORIES = events.PRELOAD_STORIES, STORY_RENDERED = events.STORY_RENDERED, STORY_MISSING = events.STORY_MISSING, STORY_ERRORED = events.STORY_ERRORED, STORY_THREW_EXCEPTION = events.STORY_THREW_EXCEPTION, STORY_RENDER_PHASE_CHANGED = events.STORY_RENDER_PHASE_CHANGED, UPDATE_STORY_ARGS = events.UPDATE_STORY_ARGS, STORY_ARGS_UPDATED = events.STORY_ARGS_UPDATED, RESET_STORY_ARGS = events.RESET_STORY_ARGS, SET_GLOBALS = events.SET_GLOBALS, UPDATE_GLOBALS = events.UPDATE_GLOBALS, GLOBALS_UPDATED = events.GLOBALS_UPDATED, REGISTER_SUBSCRIPTION = events.REGISTER_SUBSCRIPTION, PREVIEW_KEYDOWN = events.PREVIEW_KEYDOWN, SELECT_STORY = events.SELECT_STORY, STORIES_COLLAPSE_ALL = events.STORIES_COLLAPSE_ALL, STORIES_EXPAND_ALL = events.STORIES_EXPAND_ALL, DOCS_RENDERED = events.DOCS_RENDERED, SHARED_STATE_CHANGED = events.SHARED_STATE_CHANGED, SHARED_STATE_SET = events.SHARED_STATE_SET, NAVIGATE_URL = events.NAVIGATE_URL, UPDATE_QUERY_PARAMS = events.UPDATE_QUERY_PARAMS; // Used to break out of the current render without showing a redbox
var IGNORED_EXCEPTION = new Error("ignoredException");

},{"@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"88cx9":[function(require,module,exports) {
// There can only be 1 default export per entry point and it has to be directly from public_api
// Exporting this twice in order to to be able to import it like { addons } instead of 'addons'
// prefer import { addons } from '@storybook/addons' over import addons from '@storybook/addons'
//
// See index.ts
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _index = require("./index");
var _makeDecorator = require("./make-decorator");
parcelHelpers.exportAll(_makeDecorator, exports);
parcelHelpers.exportAll(_index, exports);
var _types = require("./types");
parcelHelpers.exportAll(_types, exports);
var _storybookChannelMock = require("./storybook-channel-mock");
parcelHelpers.exportAll(_storybookChannelMock, exports);
var _hooks = require("./hooks");
parcelHelpers.exportAll(_hooks, exports);
exports.default = (0, _index.addons);

},{"./index":"ltrEL","./make-decorator":"47sLe","./types":"4ynl0","./storybook-channel-mock":"a1mPD","./hooks":"7jMRO","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"ltrEL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Channel", ()=>(0, _channels.Channel));
parcelHelpers.export(exports, "AddonStore", ()=>AddonStore);
parcelHelpers.export(exports, "addons", ()=>addons);
var _esObjectAssignJs = require("core-js/modules/es.object.assign.js");
var _esObjectToStringJs = require("core-js/modules/es.object.to-string.js");
var _webDomCollectionsForEachJs = require("core-js/modules/web.dom-collections.for-each.js");
var _esObjectValuesJs = require("core-js/modules/es.object.values.js");
var _esPromiseJs = require("core-js/modules/es.promise.js");
var _global = require("global");
var _globalDefault = parcelHelpers.interopDefault(_global);
var _channels = require("@storybook/channels");
var _clientLogger = require("@storybook/client-logger");
var _storybookChannelMock = require("./storybook-channel-mock");
var _types = require("./types");
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
var AddonStore = /*#__PURE__*/ _createClass(function AddonStore() {
    var _this = this;
    _classCallCheck(this, AddonStore);
    this.loaders = {};
    this.elements = {};
    this.config = {};
    this.channel = void 0;
    this.serverChannel = void 0;
    this.promise = void 0;
    this.resolve = void 0;
    this.getChannel = function() {
        // this.channel should get overwritten by setChannel. If it wasn't called (e.g. in non-browser environment), set a mock instead.
        if (!_this.channel) _this.setChannel((0, _storybookChannelMock.mockChannel)());
        return _this.channel;
    };
    this.getServerChannel = function() {
        if (!_this.serverChannel) throw new Error("Accessing non-existent serverChannel");
        return _this.serverChannel;
    };
    this.ready = function() {
        return _this.promise;
    };
    this.hasChannel = function() {
        return !!_this.channel;
    };
    this.hasServerChannel = function() {
        return !!_this.serverChannel;
    };
    this.setChannel = function(channel) {
        _this.channel = channel;
        _this.resolve();
    };
    this.setServerChannel = function(channel) {
        _this.serverChannel = channel;
    };
    this.getElements = function(type) {
        if (!_this.elements[type]) _this.elements[type] = {};
        return _this.elements[type];
    };
    this.addPanel = function(name, options) {
        _this.add(name, Object.assign({
            type: (0, _types.types).PANEL
        }, options));
    };
    this.add = function(name, addon) {
        var type = addon.type;
        var collection = _this.getElements(type);
        collection[name] = Object.assign({
            id: name
        }, addon);
    };
    this.setConfig = function(value) {
        Object.assign(_this.config, value);
    };
    this.getConfig = function() {
        return _this.config;
    };
    this.register = function(name, registerCallback) {
        if (_this.loaders[name]) (0, _clientLogger.logger).warn("".concat(name, " was loaded twice, this could have bad side-effects"));
        _this.loaders[name] = registerCallback;
    };
    this.loadAddons = function(api) {
        Object.values(_this.loaders).forEach(function(value) {
            return value(api);
        });
    };
    this.promise = new Promise(function(res) {
        _this.resolve = function() {
            return res(_this.getChannel());
        };
    });
}); // Enforce addons store to be a singleton
var KEY = "__STORYBOOK_ADDONS";
function getAddonsStore() {
    if (!(0, _globalDefault.default)[KEY]) (0, _globalDefault.default)[KEY] = new AddonStore();
    return (0, _globalDefault.default)[KEY];
} // Exporting this twice in order to to be able to import it like { addons } instead of 'addons'
var addons = getAddonsStore();

},{"core-js/modules/es.object.assign.js":"8FU8M","core-js/modules/es.object.to-string.js":"lsA9p","core-js/modules/web.dom-collections.for-each.js":"iYT1M","core-js/modules/es.object.values.js":"bB8XB","core-js/modules/es.promise.js":"2jax7","global":"5PzlO","@storybook/channels":"7Sg7O","@storybook/client-logger":"iGRus","./storybook-channel-mock":"a1mPD","./types":"4ynl0","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"7Sg7O":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Channel", ()=>Channel);
var _esObjectFreezeJs = require("core-js/modules/es.object.freeze.js");
var _esArraySliceJs = require("core-js/modules/es.array.slice.js");
var _esObjectToStringJs = require("core-js/modules/es.object.to-string.js");
var _esRegexpToStringJs = require("core-js/modules/es.regexp.to-string.js");
var _webImmediateJs = require("core-js/modules/web.immediate.js");
var _esObjectKeysJs = require("core-js/modules/es.object.keys.js");
var _esArrayFilterJs = require("core-js/modules/es.array.filter.js");
var _webDomCollectionsForEachJs = require("core-js/modules/web.dom-collections.for-each.js");
var _utilDeprecate = require("util-deprecate");
var _utilDeprecateDefault = parcelHelpers.interopDefault(_utilDeprecate);
var _tsDedent = require("ts-dedent");
var _tsDedentDefault = parcelHelpers.interopDefault(_tsDedent);
var _templateObject;
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) raw = strings.slice(0);
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
var generateRandomId = function generateRandomId() {
    // generates a random 13 character string
    return Math.random().toString(16).slice(2);
};
var Channel = /*#__PURE__*/ function() {
    function Channel() {
        var _this = this;
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, transport = _ref.transport, _ref$async = _ref.async, async = _ref$async === void 0 ? false : _ref$async;
        _classCallCheck(this, Channel);
        this.isAsync = void 0;
        this.sender = generateRandomId();
        this.events = {};
        this.data = {};
        this.transport = void 0;
        this.addPeerListener = (0, _utilDeprecateDefault.default)(function(eventName, listener) {
            _this.addListener(eventName, listener);
        }, (0, _tsDedentDefault.default)(_templateObject || (_templateObject = _taggedTemplateLiteral([
            "\n      channel.addPeerListener is deprecated\n    "
        ]))));
        this.isAsync = async;
        if (transport) {
            this.transport = transport;
            this.transport.setHandler(function(event) {
                return _this.handleEvent(event);
            });
        }
    }
    _createClass(Channel, [
        {
            key: "hasTransport",
            get: function get() {
                return !!this.transport;
            }
        },
        {
            key: "addListener",
            value: function addListener(eventName, listener) {
                this.events[eventName] = this.events[eventName] || [];
                this.events[eventName].push(listener);
            }
        },
        {
            key: "emit",
            value: function emit(eventName) {
                var _this2 = this;
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
                var event = {
                    type: eventName,
                    args: args,
                    from: this.sender
                };
                var options = {};
                if (args.length >= 1 && args[0] && args[0].options) options = args[0].options;
                var handler = function handler() {
                    if (_this2.transport) _this2.transport.send(event, options);
                    _this2.handleEvent(event);
                };
                if (this.isAsync) // todo I'm not sure how to test this
                setImmediate(handler);
                else handler();
            }
        },
        {
            key: "last",
            value: function last(eventName) {
                return this.data[eventName];
            }
        },
        {
            key: "eventNames",
            value: function eventNames() {
                return Object.keys(this.events);
            }
        },
        {
            key: "listenerCount",
            value: function listenerCount(eventName) {
                var listeners = this.listeners(eventName);
                return listeners ? listeners.length : 0;
            }
        },
        {
            key: "listeners",
            value: function listeners(eventName) {
                var listeners = this.events[eventName];
                return listeners || undefined;
            }
        },
        {
            key: "once",
            value: function once(eventName, listener) {
                var onceListener = this.onceListener(eventName, listener);
                this.addListener(eventName, onceListener);
            }
        },
        {
            key: "removeAllListeners",
            value: function removeAllListeners(eventName) {
                if (!eventName) this.events = {};
                else if (this.events[eventName]) delete this.events[eventName];
            }
        },
        {
            key: "removeListener",
            value: function removeListener(eventName, listener) {
                var listeners = this.listeners(eventName);
                if (listeners) this.events[eventName] = listeners.filter(function(l) {
                    return l !== listener;
                });
            }
        },
        {
            key: "on",
            value: function on(eventName, listener) {
                this.addListener(eventName, listener);
            }
        },
        {
            key: "off",
            value: function off(eventName, listener) {
                this.removeListener(eventName, listener);
            }
        },
        {
            key: "handleEvent",
            value: function handleEvent(event) {
                var listeners = this.listeners(event.type);
                if (listeners && listeners.length) listeners.forEach(function(fn) {
                    fn.apply(event, event.args);
                });
                this.data[event.type] = event.args;
            }
        },
        {
            key: "onceListener",
            value: function onceListener(eventName, listener) {
                var _this3 = this;
                var onceListener = function onceListener() {
                    _this3.removeListener(eventName, onceListener);
                    return listener.apply(void 0, arguments);
                };
                return onceListener;
            }
        }
    ]);
    return Channel;
}();
exports.default = Channel;

},{"core-js/modules/es.object.freeze.js":"9LVYO","core-js/modules/es.array.slice.js":"8RRh9","core-js/modules/es.object.to-string.js":"lsA9p","core-js/modules/es.regexp.to-string.js":"bGzly","core-js/modules/web.immediate.js":"9PmDy","core-js/modules/es.object.keys.js":"5Q2AT","core-js/modules/es.array.filter.js":"fD2da","core-js/modules/web.dom-collections.for-each.js":"iYT1M","util-deprecate":"lYmRJ","ts-dedent":"9RvVa","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"9PmDy":[function(require,module,exports) {
var $ = require("57bd5d59693d84cf");
var global = require("aa05a0a922f6ca2e");
var task = require("7a2807c700a427d7");
var FORCED = !global.setImmediate || !global.clearImmediate;
// http://w3c.github.io/setImmediate/
$({
    global: true,
    bind: true,
    enumerable: true,
    forced: FORCED
}, {
    // `setImmediate` method
    // http://w3c.github.io/setImmediate/#si-setImmediate
    setImmediate: task.set,
    // `clearImmediate` method
    // http://w3c.github.io/setImmediate/#si-clearImmediate
    clearImmediate: task.clear
});

},{"57bd5d59693d84cf":"1OO62","aa05a0a922f6ca2e":"1GZc4","7a2807c700a427d7":"01r34"}],"a1mPD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mockChannel", ()=>mockChannel);
var _channels = require("@storybook/channels");
var _channelsDefault = parcelHelpers.interopDefault(_channels);
function mockChannel() {
    var transport = {
        setHandler: function setHandler() {},
        send: function send() {}
    };
    return new (0, _channelsDefault.default)({
        transport: transport
    });
}

},{"@storybook/channels":"7Sg7O","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"4ynl0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "types", ()=>types);
parcelHelpers.export(exports, "isSupportedType", ()=>isSupportedType);
var _esArrayFindJs = require("core-js/modules/es.array.find.js");
var _esObjectToStringJs = require("core-js/modules/es.object.to-string.js");
var _esObjectValuesJs = require("core-js/modules/es.object.values.js");
var types;
(function(types) {
    types["TAB"] = "tab";
    types["PANEL"] = "panel";
    types["TOOL"] = "tool";
    types["TOOLEXTRA"] = "toolextra";
    types["PREVIEW"] = "preview";
    types["NOTES_ELEMENT"] = "notes-element";
})(types || (types = {}));
function isSupportedType(type) {
    return !!Object.values(types).find(function(typeVal) {
        return typeVal === type;
    });
}

},{"core-js/modules/es.array.find.js":"hWBPu","core-js/modules/es.object.to-string.js":"lsA9p","core-js/modules/es.object.values.js":"bB8XB","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"47sLe":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "makeDecorator", ()=>makeDecorator);
var _esFunctionNameJs = require("core-js/modules/es.function.name.js");
var _esArrayConcatJs = require("core-js/modules/es.array.concat.js");
var makeDecorator = function makeDecorator(_ref) {
    var name = _ref.name, parameterName = _ref.parameterName, wrapper = _ref.wrapper, _ref$skipIfNoParamete = _ref.skipIfNoParametersOrOptions, skipIfNoParametersOrOptions = _ref$skipIfNoParamete === void 0 ? false : _ref$skipIfNoParamete;
    var decorator = function decorator(options) {
        return function(storyFn, context) {
            var parameters = context.parameters && context.parameters[parameterName];
            if (parameters && parameters.disable) return storyFn(context);
            if (skipIfNoParametersOrOptions && !options && !parameters) return storyFn(context);
            return wrapper(storyFn, context, {
                options: options,
                parameters: parameters
            });
        };
    };
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        // Used without options as .addDecorator(decorator)
        if (typeof args[0] === "function") return decorator().apply(void 0, args);
        return function() {
            // Used as [.]addDecorator(decorator(options))
            if (arguments.length > 1) {
                // Used as [.]addDecorator(decorator(option1, option2))
                if (args.length > 1) return decorator(args).apply(void 0, arguments);
                return decorator.apply(void 0, args).apply(void 0, arguments);
            }
            throw new Error("Passing stories directly into ".concat(name, "() is not allowed,\n        instead use addDecorator(").concat(name, ") and pass options with the '").concat(parameterName, "' parameter"));
        };
    };
};

},{"core-js/modules/es.function.name.js":"4LiLL","core-js/modules/es.array.concat.js":"g1t7q","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"7jMRO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HooksContext", ()=>HooksContext);
parcelHelpers.export(exports, "applyHooks", ()=>applyHooks);
/* Returns a memoized value, see https://reactjs.org/docs/hooks-reference.html#usememo */ parcelHelpers.export(exports, "useMemo", ()=>useMemo);
/* Returns a memoized callback, see https://reactjs.org/docs/hooks-reference.html#usecallback */ parcelHelpers.export(exports, "useCallback", ()=>useCallback);
/* Returns a mutable ref object, see https://reactjs.org/docs/hooks-reference.html#useref */ parcelHelpers.export(exports, "useRef", ()=>useRef);
/* Returns a stateful value, and a function to update it, see https://reactjs.org/docs/hooks-reference.html#usestate */ parcelHelpers.export(exports, "useState", ()=>useState);
/* A redux-like alternative to useState, see https://reactjs.org/docs/hooks-reference.html#usereducer */ parcelHelpers.export(exports, "useReducer", ()=>useReducer);
/*
  Triggers a side effect, see https://reactjs.org/docs/hooks-reference.html#usestate
  Effects are triggered synchronously after rendering the story
*/ parcelHelpers.export(exports, "useEffect", ()=>useEffect);
/* Accepts a map of Storybook channel event listeners, returns an emit function */ parcelHelpers.export(exports, "useChannel", ()=>useChannel);
/* Returns current story context */ parcelHelpers.export(exports, "useStoryContext", ()=>useStoryContext);
/* Returns current value of a story parameter */ parcelHelpers.export(exports, "useParameter", ()=>useParameter);
/* Returns current value of story args */ parcelHelpers.export(exports, "useArgs", ()=>useArgs);
/* Returns current value of global args */ parcelHelpers.export(exports, "useGlobals", ()=>useGlobals);
var _esArrayIteratorJs = require("core-js/modules/es.array.iterator.js");
var _esObjectToStringJs = require("core-js/modules/es.object.to-string.js");
var _esStringIteratorJs = require("core-js/modules/es.string.iterator.js");
var _esWeakMapJs = require("core-js/modules/es.weak-map.js");
var _webDomCollectionsIteratorJs = require("core-js/modules/web.dom-collections.iterator.js");
var _esSetJs = require("core-js/modules/es.set.js");
var _webDomCollectionsForEachJs = require("core-js/modules/web.dom-collections.for-each.js");
var _esArrayIncludesJs = require("core-js/modules/es.array.includes.js");
var _esStringIncludesJs = require("core-js/modules/es.string.includes.js");
var _esFunctionNameJs = require("core-js/modules/es.function.name.js");
var _esArrayMapJs = require("core-js/modules/es.array.map.js");
var _esArrayConcatJs = require("core-js/modules/es.array.concat.js");
var _esObjectEntriesJs = require("core-js/modules/es.object.entries.js");
var _esObjectKeysJs = require("core-js/modules/es.object.keys.js");
var _esSymbolJs = require("core-js/modules/es.symbol.js");
var _esSymbolDescriptionJs = require("core-js/modules/es.symbol.description.js");
var _esSymbolIteratorJs = require("core-js/modules/es.symbol.iterator.js");
var _esArrayFromJs = require("core-js/modules/es.array.from.js");
var _esArraySliceJs = require("core-js/modules/es.array.slice.js");
var _esRegexpExecJs = require("core-js/modules/es.regexp.exec.js");
var _global = require("global");
var _globalDefault = parcelHelpers.interopDefault(_global);
var _clientLogger = require("@storybook/client-logger");
var _coreEvents = require("@storybook/core-events");
var _index = require("./index");
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
var globalWindow = (0, _globalDefault.default).window;
var HooksContext = /*#__PURE__*/ function() {
    function HooksContext() {
        var _this = this;
        _classCallCheck(this, HooksContext);
        this.hookListsMap = void 0;
        this.mountedDecorators = void 0;
        this.prevMountedDecorators = void 0;
        this.currentHooks = void 0;
        this.nextHookIndex = void 0;
        this.currentPhase = void 0;
        this.currentEffects = void 0;
        this.prevEffects = void 0;
        this.currentDecoratorName = void 0;
        this.hasUpdates = void 0;
        this.currentContext = void 0;
        this.renderListener = function(storyId) {
            if (storyId !== _this.currentContext.id) return;
            _this.triggerEffects();
            _this.currentContext = null;
            _this.removeRenderListeners();
        };
        this.init();
    }
    _createClass(HooksContext, [
        {
            key: "init",
            value: function init() {
                this.hookListsMap = new WeakMap();
                this.mountedDecorators = new Set();
                this.prevMountedDecorators = this.mountedDecorators;
                this.currentHooks = [];
                this.nextHookIndex = 0;
                this.currentPhase = "NONE";
                this.currentEffects = [];
                this.prevEffects = [];
                this.currentDecoratorName = null;
                this.hasUpdates = false;
                this.currentContext = null;
            }
        },
        {
            key: "clean",
            value: function clean() {
                this.prevEffects.forEach(function(effect) {
                    if (effect.destroy) effect.destroy();
                });
                this.init();
                this.removeRenderListeners();
            }
        },
        {
            key: "getNextHook",
            value: function getNextHook() {
                var hook = this.currentHooks[this.nextHookIndex];
                this.nextHookIndex += 1;
                return hook;
            }
        },
        {
            key: "triggerEffects",
            value: function triggerEffects() {
                var _this2 = this;
                // destroy removed effects
                this.prevEffects.forEach(function(effect) {
                    if (!_this2.currentEffects.includes(effect) && effect.destroy) effect.destroy();
                }); // trigger added effects
                this.currentEffects.forEach(function(effect) {
                    if (!_this2.prevEffects.includes(effect)) // eslint-disable-next-line no-param-reassign
                    effect.destroy = effect.create();
                });
                this.prevEffects = this.currentEffects;
                this.currentEffects = [];
            }
        },
        {
            key: "addRenderListeners",
            value: function addRenderListeners() {
                this.removeRenderListeners();
                var channel = (0, _index.addons).getChannel();
                channel.on((0, _coreEvents.STORY_RENDERED), this.renderListener);
            }
        },
        {
            key: "removeRenderListeners",
            value: function removeRenderListeners() {
                var channel = (0, _index.addons).getChannel();
                channel.removeListener((0, _coreEvents.STORY_RENDERED), this.renderListener);
            }
        }
    ]);
    return HooksContext;
}();
function hookify(fn) {
    return function() {
        var _ref = typeof (arguments.length <= 0 ? undefined : arguments[0]) === "function" ? arguments.length <= 1 ? undefined : arguments[1] : arguments.length <= 0 ? undefined : arguments[0], hooks = _ref.hooks;
        var prevPhase = hooks.currentPhase;
        var prevHooks = hooks.currentHooks;
        var prevNextHookIndex = hooks.nextHookIndex;
        var prevDecoratorName = hooks.currentDecoratorName;
        hooks.currentDecoratorName = fn.name;
        if (hooks.prevMountedDecorators.has(fn)) {
            hooks.currentPhase = "UPDATE";
            hooks.currentHooks = hooks.hookListsMap.get(fn) || [];
        } else {
            hooks.currentPhase = "MOUNT";
            hooks.currentHooks = [];
            hooks.hookListsMap.set(fn, hooks.currentHooks);
            hooks.prevMountedDecorators.add(fn);
        }
        hooks.nextHookIndex = 0;
        var prevContext = globalWindow.STORYBOOK_HOOKS_CONTEXT;
        globalWindow.STORYBOOK_HOOKS_CONTEXT = hooks;
        var result = fn.apply(void 0, arguments);
        globalWindow.STORYBOOK_HOOKS_CONTEXT = prevContext;
        if (hooks.currentPhase === "UPDATE" && hooks.getNextHook() != null) throw new Error("Rendered fewer hooks than expected. This may be caused by an accidental early return statement.");
        hooks.currentPhase = prevPhase;
        hooks.currentHooks = prevHooks;
        hooks.nextHookIndex = prevNextHookIndex;
        hooks.currentDecoratorName = prevDecoratorName;
        return result;
    };
} // Counter to prevent infinite loops.
var numberOfRenders = 0;
var RENDER_LIMIT = 25;
var applyHooks = function applyHooks(applyDecorators) {
    return function(storyFn, decorators) {
        var decorated = applyDecorators(hookify(storyFn), decorators.map(function(decorator) {
            return hookify(decorator);
        }));
        return function(context) {
            var _ref2 = context, hooks = _ref2.hooks;
            hooks.prevMountedDecorators = hooks.mountedDecorators;
            hooks.mountedDecorators = new Set([
                storyFn
            ].concat(_toConsumableArray(decorators)));
            hooks.currentContext = context;
            hooks.hasUpdates = false;
            var result = decorated(context);
            numberOfRenders = 1;
            while(hooks.hasUpdates){
                hooks.hasUpdates = false;
                hooks.currentEffects = [];
                result = decorated(context);
                numberOfRenders += 1;
                if (numberOfRenders > RENDER_LIMIT) throw new Error("Too many re-renders. Storybook limits the number of renders to prevent an infinite loop.");
            }
            hooks.addRenderListeners();
            return result;
        };
    };
};
var areDepsEqual = function areDepsEqual(deps, nextDeps) {
    return deps.length === nextDeps.length && deps.every(function(dep, i) {
        return dep === nextDeps[i];
    });
};
var invalidHooksError = function invalidHooksError() {
    return new Error("Storybook preview hooks can only be called inside decorators and story functions.");
};
function getHooksContextOrNull() {
    return globalWindow.STORYBOOK_HOOKS_CONTEXT || null;
}
function getHooksContextOrThrow() {
    var hooks = getHooksContextOrNull();
    if (hooks == null) throw invalidHooksError();
    return hooks;
}
function useHook(name, callback, deps) {
    var hooks = getHooksContextOrThrow();
    if (hooks.currentPhase === "MOUNT") {
        if (deps != null && !Array.isArray(deps)) (0, _clientLogger.logger).warn("".concat(name, " received a final argument that is not an array (instead, received ").concat(deps, "). When specified, the final argument must be an array."));
        var _hook = {
            name: name,
            deps: deps
        };
        hooks.currentHooks.push(_hook);
        callback(_hook);
        return _hook;
    }
    if (hooks.currentPhase === "UPDATE") {
        var _hook2 = hooks.getNextHook();
        if (_hook2 == null) throw new Error("Rendered more hooks than during the previous render.");
        if (_hook2.name !== name) (0, _clientLogger.logger).warn("Storybook has detected a change in the order of Hooks".concat(hooks.currentDecoratorName ? " called by ".concat(hooks.currentDecoratorName) : "", ". This will lead to bugs and errors if not fixed."));
        if (deps != null && _hook2.deps == null) (0, _clientLogger.logger).warn("".concat(name, " received a final argument during this render, but not during the previous render. Even though the final argument is optional, its type cannot change between renders."));
        if (deps != null && _hook2.deps != null && deps.length !== _hook2.deps.length) (0, _clientLogger.logger).warn("The final argument passed to ".concat(name, " changed size between renders. The order and size of this array must remain constant.\nPrevious: ").concat(_hook2.deps, "\nIncoming: ").concat(deps));
        if (deps == null || _hook2.deps == null || !areDepsEqual(deps, _hook2.deps)) {
            callback(_hook2);
            _hook2.deps = deps;
        }
        return _hook2;
    }
    throw invalidHooksError();
}
function useMemoLike(name, nextCreate, deps) {
    var _useHook = useHook(name, function(hook) {
        // eslint-disable-next-line no-param-reassign
        hook.memoizedState = nextCreate();
    }, deps), memoizedState = _useHook.memoizedState;
    return memoizedState;
}
function useMemo(nextCreate, deps) {
    return useMemoLike("useMemo", nextCreate, deps);
}
function useCallback(callback, deps) {
    return useMemoLike("useCallback", function() {
        return callback;
    }, deps);
}
function useRefLike(name, initialValue) {
    return useMemoLike(name, function() {
        return {
            current: initialValue
        };
    }, []);
}
function useRef(initialValue) {
    return useRefLike("useRef", initialValue);
}
function triggerUpdate() {
    var hooks = getHooksContextOrNull(); // Rerun storyFn if updates were triggered synchronously, force rerender otherwise
    if (hooks != null && hooks.currentPhase !== "NONE") hooks.hasUpdates = true;
    else try {
        (0, _index.addons).getChannel().emit((0, _coreEvents.FORCE_RE_RENDER));
    } catch (e) {
        (0, _clientLogger.logger).warn("State updates of Storybook preview hooks work only in browser");
    }
}
function useStateLike(name, initialState) {
    var stateRef = useRefLike(name, typeof initialState === "function" ? initialState() : initialState);
    var setState = function setState(update) {
        // @ts-ignore S type should never be function, but there's no way to tell that to TypeScript
        stateRef.current = typeof update === "function" ? update(stateRef.current) : update;
        triggerUpdate();
    };
    return [
        stateRef.current,
        setState
    ];
}
function useState(initialState) {
    return useStateLike("useState", initialState);
}
function useReducer(reducer, initialArg, init) {
    var initialState = init != null ? function() {
        return init(initialArg);
    } : initialArg;
    var _useStateLike = useStateLike("useReducer", initialState), _useStateLike2 = _slicedToArray(_useStateLike, 2), state = _useStateLike2[0], setState = _useStateLike2[1];
    var dispatch = function dispatch(action) {
        return setState(function(prevState) {
            return reducer(prevState, action);
        });
    };
    return [
        state,
        dispatch
    ];
}
function useEffect(create, deps) {
    var hooks = getHooksContextOrThrow();
    var effect = useMemoLike("useEffect", function() {
        return {
            create: create
        };
    }, deps);
    if (!hooks.currentEffects.includes(effect)) hooks.currentEffects.push(effect);
}
function useChannel(eventMap) {
    var deps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var channel = (0, _index.addons).getChannel();
    useEffect(function() {
        Object.entries(eventMap).forEach(function(_ref3) {
            var _ref4 = _slicedToArray(_ref3, 2), type = _ref4[0], listener = _ref4[1];
            return channel.on(type, listener);
        });
        return function() {
            Object.entries(eventMap).forEach(function(_ref5) {
                var _ref6 = _slicedToArray(_ref5, 2), type = _ref6[0], listener = _ref6[1];
                return channel.removeListener(type, listener);
            });
        };
    }, [].concat(_toConsumableArray(Object.keys(eventMap)), _toConsumableArray(deps)));
    return useCallback(channel.emit.bind(channel), [
        channel
    ]);
}
function useStoryContext() {
    var _getHooksContextOrThr = getHooksContextOrThrow(), currentContext = _getHooksContextOrThr.currentContext;
    if (currentContext == null) throw invalidHooksError();
    return currentContext;
}
function useParameter(parameterKey, defaultValue) {
    var _useStoryContext = useStoryContext(), parameters = _useStoryContext.parameters;
    if (parameterKey) {
        var _parameters$parameter;
        return (_parameters$parameter = parameters[parameterKey]) !== null && _parameters$parameter !== void 0 ? _parameters$parameter : defaultValue;
    }
    return undefined;
}
function useArgs() {
    var channel = (0, _index.addons).getChannel();
    var _useStoryContext2 = useStoryContext(), storyId = _useStoryContext2.id, args = _useStoryContext2.args;
    var updateArgs = useCallback(function(updatedArgs) {
        return channel.emit((0, _coreEvents.UPDATE_STORY_ARGS), {
            storyId: storyId,
            updatedArgs: updatedArgs
        });
    }, [
        channel,
        storyId
    ]);
    var resetArgs = useCallback(function(argNames) {
        return channel.emit((0, _coreEvents.RESET_STORY_ARGS), {
            storyId: storyId,
            argNames: argNames
        });
    }, [
        channel,
        storyId
    ]);
    return [
        args,
        updateArgs,
        resetArgs
    ];
}
function useGlobals() {
    var channel = (0, _index.addons).getChannel();
    var _useStoryContext3 = useStoryContext(), globals = _useStoryContext3.globals;
    var updateGlobals = useCallback(function(newGlobals) {
        return channel.emit((0, _coreEvents.UPDATE_GLOBALS), {
            globals: newGlobals
        });
    }, [
        channel
    ]);
    return [
        globals,
        updateGlobals
    ];
}

},{"core-js/modules/es.array.iterator.js":"ieU20","core-js/modules/es.object.to-string.js":"lsA9p","core-js/modules/es.string.iterator.js":"74a8v","core-js/modules/es.weak-map.js":"36z2S","core-js/modules/web.dom-collections.iterator.js":"aXR96","core-js/modules/es.set.js":"6FW6g","core-js/modules/web.dom-collections.for-each.js":"iYT1M","core-js/modules/es.array.includes.js":"dbUjS","core-js/modules/es.string.includes.js":"cx9ET","core-js/modules/es.function.name.js":"4LiLL","core-js/modules/es.array.map.js":"jTP7e","core-js/modules/es.array.concat.js":"g1t7q","core-js/modules/es.object.entries.js":"7Wf79","core-js/modules/es.object.keys.js":"5Q2AT","core-js/modules/es.symbol.js":"ajw2f","core-js/modules/es.symbol.description.js":"wrlLc","core-js/modules/es.symbol.iterator.js":"fhNIb","core-js/modules/es.array.from.js":"9UCQw","core-js/modules/es.array.slice.js":"8RRh9","core-js/modules/es.regexp.exec.js":"5q56v","global":"5PzlO","@storybook/client-logger":"iGRus","@storybook/core-events":"bJpgo","./index":"ltrEL","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"36z2S":[function(require,module,exports) {
"use strict";
var global = require("7f66b346b5cc215a");
var uncurryThis = require("cfa8b232e2212e85");
var redefineAll = require("d41a6a386aeaa792");
var InternalMetadataModule = require("353f9e73054affd4");
var collection = require("34c08b09c00149bd");
var collectionWeak = require("9073ccd84344c5d3");
var isObject = require("6033941956ff06bb");
var isExtensible = require("9ccb56a0a9d4b9fe");
var enforceIternalState = require("80632e005c6ae7cc").enforce;
var NATIVE_WEAK_MAP = require("b0da419e6bf91ee4");
var IS_IE11 = !global.ActiveXObject && "ActiveXObject" in global;
var InternalWeakMap;
var wrapper = function(init) {
    return function WeakMap() {
        return init(this, arguments.length ? arguments[0] : undefined);
    };
};
// `WeakMap` constructor
// https://tc39.es/ecma262/#sec-weakmap-constructor
var $WeakMap = collection("WeakMap", wrapper, collectionWeak);
// IE11 WeakMap frozen keys fix
// We can't use feature detection because it crash some old IE builds
// https://github.com/zloirock/core-js/issues/485
if (NATIVE_WEAK_MAP && IS_IE11) {
    InternalWeakMap = collectionWeak.getConstructor(wrapper, "WeakMap", true);
    InternalMetadataModule.enable();
    var WeakMapPrototype = $WeakMap.prototype;
    var nativeDelete = uncurryThis(WeakMapPrototype["delete"]);
    var nativeHas = uncurryThis(WeakMapPrototype.has);
    var nativeGet = uncurryThis(WeakMapPrototype.get);
    var nativeSet = uncurryThis(WeakMapPrototype.set);
    redefineAll(WeakMapPrototype, {
        "delete": function(key) {
            if (isObject(key) && !isExtensible(key)) {
                var state = enforceIternalState(this);
                if (!state.frozen) state.frozen = new InternalWeakMap();
                return nativeDelete(this, key) || state.frozen["delete"](key);
            }
            return nativeDelete(this, key);
        },
        has: function has(key) {
            if (isObject(key) && !isExtensible(key)) {
                var state = enforceIternalState(this);
                if (!state.frozen) state.frozen = new InternalWeakMap();
                return nativeHas(this, key) || state.frozen.has(key);
            }
            return nativeHas(this, key);
        },
        get: function get(key) {
            if (isObject(key) && !isExtensible(key)) {
                var state = enforceIternalState(this);
                if (!state.frozen) state.frozen = new InternalWeakMap();
                return nativeHas(this, key) ? nativeGet(this, key) : state.frozen.get(key);
            }
            return nativeGet(this, key);
        },
        set: function set(key, value) {
            if (isObject(key) && !isExtensible(key)) {
                var state = enforceIternalState(this);
                if (!state.frozen) state.frozen = new InternalWeakMap();
                nativeHas(this, key) ? nativeSet(this, key, value) : state.frozen.set(key, value);
            } else nativeSet(this, key, value);
            return this;
        }
    });
}

},{"7f66b346b5cc215a":"1GZc4","cfa8b232e2212e85":"fP9tv","d41a6a386aeaa792":"b48Cu","353f9e73054affd4":"55X03","34c08b09c00149bd":"755XO","9073ccd84344c5d3":"iN7p7","6033941956ff06bb":"bprny","9ccb56a0a9d4b9fe":"zKBd8","80632e005c6ae7cc":"bRWxa","b0da419e6bf91ee4":"durGo"}],"iN7p7":[function(require,module,exports) {
"use strict";
var uncurryThis = require("1805cb6220d706e7");
var redefineAll = require("b7c53470ce138dc6");
var getWeakData = require("9764e89aab31dc9a").getWeakData;
var anObject = require("602fe1299f06e16c");
var isObject = require("211f42379f0813a");
var anInstance = require("e632c1106cb00cea");
var iterate = require("830bf4bd7bf8261c");
var ArrayIterationModule = require("ffaf20b85e78d82f");
var hasOwn = require("cef0026b9b05e2");
var InternalStateModule = require("96b7fea7b9fcfa28");
var setInternalState = InternalStateModule.set;
var internalStateGetterFor = InternalStateModule.getterFor;
var find = ArrayIterationModule.find;
var findIndex = ArrayIterationModule.findIndex;
var splice = uncurryThis([].splice);
var id = 0;
// fallback for uncaught frozen keys
var uncaughtFrozenStore = function(store) {
    return store.frozen || (store.frozen = new UncaughtFrozenStore());
};
var UncaughtFrozenStore = function() {
    this.entries = [];
};
var findUncaughtFrozen = function(store, key) {
    return find(store.entries, function(it) {
        return it[0] === key;
    });
};
UncaughtFrozenStore.prototype = {
    get: function(key) {
        var entry = findUncaughtFrozen(this, key);
        if (entry) return entry[1];
    },
    has: function(key) {
        return !!findUncaughtFrozen(this, key);
    },
    set: function(key, value) {
        var entry = findUncaughtFrozen(this, key);
        if (entry) entry[1] = value;
        else this.entries.push([
            key,
            value
        ]);
    },
    "delete": function(key) {
        var index = findIndex(this.entries, function(it) {
            return it[0] === key;
        });
        if (~index) splice(this.entries, index, 1);
        return !!~index;
    }
};
module.exports = {
    getConstructor: function(wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER) {
        var Constructor = wrapper(function(that, iterable) {
            anInstance(that, Prototype);
            setInternalState(that, {
                type: CONSTRUCTOR_NAME,
                id: id++,
                frozen: undefined
            });
            if (iterable != undefined) iterate(iterable, that[ADDER], {
                that: that,
                AS_ENTRIES: IS_MAP
            });
        });
        var Prototype = Constructor.prototype;
        var getInternalState = internalStateGetterFor(CONSTRUCTOR_NAME);
        var define = function(that, key, value) {
            var state = getInternalState(that);
            var data = getWeakData(anObject(key), true);
            if (data === true) uncaughtFrozenStore(state).set(key, value);
            else data[state.id] = value;
            return that;
        };
        redefineAll(Prototype, {
            // `{ WeakMap, WeakSet }.prototype.delete(key)` methods
            // https://tc39.es/ecma262/#sec-weakmap.prototype.delete
            // https://tc39.es/ecma262/#sec-weakset.prototype.delete
            "delete": function(key) {
                var state = getInternalState(this);
                if (!isObject(key)) return false;
                var data = getWeakData(key);
                if (data === true) return uncaughtFrozenStore(state)["delete"](key);
                return data && hasOwn(data, state.id) && delete data[state.id];
            },
            // `{ WeakMap, WeakSet }.prototype.has(key)` methods
            // https://tc39.es/ecma262/#sec-weakmap.prototype.has
            // https://tc39.es/ecma262/#sec-weakset.prototype.has
            has: function has(key) {
                var state = getInternalState(this);
                if (!isObject(key)) return false;
                var data = getWeakData(key);
                if (data === true) return uncaughtFrozenStore(state).has(key);
                return data && hasOwn(data, state.id);
            }
        });
        redefineAll(Prototype, IS_MAP ? {
            // `WeakMap.prototype.get(key)` method
            // https://tc39.es/ecma262/#sec-weakmap.prototype.get
            get: function get(key) {
                var state = getInternalState(this);
                if (isObject(key)) {
                    var data = getWeakData(key);
                    if (data === true) return uncaughtFrozenStore(state).get(key);
                    return data ? data[state.id] : undefined;
                }
            },
            // `WeakMap.prototype.set(key, value)` method
            // https://tc39.es/ecma262/#sec-weakmap.prototype.set
            set: function set(key, value) {
                return define(this, key, value);
            }
        } : {
            // `WeakSet.prototype.add(value)` method
            // https://tc39.es/ecma262/#sec-weakset.prototype.add
            add: function add(value) {
                return define(this, value, true);
            }
        });
        return Constructor;
    }
};

},{"1805cb6220d706e7":"fP9tv","b7c53470ce138dc6":"b48Cu","9764e89aab31dc9a":"55X03","602fe1299f06e16c":"39qAm","211f42379f0813a":"bprny","e632c1106cb00cea":"kZWyK","830bf4bd7bf8261c":"9EwlZ","ffaf20b85e78d82f":"g44dN","cef0026b9b05e2":"4SzRl","96b7fea7b9fcfa28":"bRWxa"}],"c5Z0N":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "decorateStory", ()=>decorateStory);
/**
 * Currently StoryContextUpdates are allowed to have any key in the type.
 * However, you cannot overwrite any of the build-it "static" keys.
 *
 * @param inputContextUpdate StoryContextUpdate
 * @returns StoryContextUpdate
 */ parcelHelpers.export(exports, "sanitizeStoryContextUpdate", ()=>sanitizeStoryContextUpdate);
parcelHelpers.export(exports, "defaultDecorateStory", ()=>defaultDecorateStory);
var _esObjectKeysJs = require("core-js/modules/es.object.keys.js");
var _esSymbolJs = require("core-js/modules/es.symbol.js");
var _esFunctionNameJs = require("core-js/modules/es.function.name.js");
var _esObjectAssignJs = require("core-js/modules/es.object.assign.js");
var _esObjectToStringJs = require("core-js/modules/es.object.to-string.js");
var _excluded = [
    "componentId",
    "title",
    "kind",
    "id",
    "name",
    "story",
    "parameters",
    "initialArgs",
    "argTypes"
];
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function decorateStory(storyFn, decorator, bindWithContext) {
    // Bind the partially decorated storyFn so that when it is called it always knows about the story context,
    // no matter what it is passed directly. This is because we cannot guarantee a decorator will
    // pass the context down to the next decorated story in the chain.
    var boundStoryFunction = bindWithContext(storyFn);
    return function(context) {
        return decorator(boundStoryFunction, context);
    };
}
function sanitizeStoryContextUpdate() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var componentId = _ref.componentId, title = _ref.title, kind = _ref.kind, id = _ref.id, name = _ref.name, story = _ref.story, parameters = _ref.parameters, initialArgs = _ref.initialArgs, argTypes = _ref.argTypes, update = _objectWithoutProperties(_ref, _excluded);
    return update;
}
function defaultDecorateStory(storyFn, decorators) {
    // We use a trick to avoid recreating the bound story function inside `decorateStory`.
    // Instead we pass it a context "getter", which is defined once (at "decoration time")
    // The getter reads a variable which is scoped to this call of `decorateStory`
    // (ie to this story), so there is no possibility of overlap.
    // This will break if you call the same story twice interleaved
    // (React might do it if you rendered the same story twice in the one ReactDom.render call, for instance)
    var contextStore = {};
    /**
   * When you call the story function inside a decorator, e.g.:
   *
   * ```jsx
   * <div>{storyFn({ foo: 'bar' })}</div>
   * ```
   *
   * This will override the `foo` property on the `innerContext`, which gets
   * merged in with the default context
   */ var bindWithContext = function bindWithContext(decoratedStoryFn) {
        return function(update) {
            contextStore.value = Object.assign({}, contextStore.value, sanitizeStoryContextUpdate(update));
            return decoratedStoryFn(contextStore.value);
        };
    };
    var decoratedWithContextStore = decorators.reduce(function(story, decorator) {
        return decorateStory(story, decorator, bindWithContext);
    }, storyFn);
    return function(context) {
        contextStore.value = context;
        return decoratedWithContextStore(context); // Pass the context directly into the first decorator
    };
}

},{"core-js/modules/es.object.keys.js":"5Q2AT","core-js/modules/es.symbol.js":"ajw2f","core-js/modules/es.function.name.js":"4LiLL","core-js/modules/es.object.assign.js":"8FU8M","core-js/modules/es.object.to-string.js":"lsA9p","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"T05nV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "normalizeProjectAnnotations", ()=>normalizeProjectAnnotations);
var _esObjectKeysJs = require("core-js/modules/es.object.keys.js");
var _esSymbolJs = require("core-js/modules/es.symbol.js");
var _esSymbolDescriptionJs = require("core-js/modules/es.symbol.description.js");
var _esObjectToStringJs = require("core-js/modules/es.object.to-string.js");
var _esSymbolIteratorJs = require("core-js/modules/es.symbol.iterator.js");
var _esArrayIteratorJs = require("core-js/modules/es.array.iterator.js");
var _esStringIteratorJs = require("core-js/modules/es.string.iterator.js");
var _webDomCollectionsIteratorJs = require("core-js/modules/web.dom-collections.iterator.js");
var _esArrayFromJs = require("core-js/modules/es.array.from.js");
var _esArraySliceJs = require("core-js/modules/es.array.slice.js");
var _esFunctionNameJs = require("core-js/modules/es.function.name.js");
var _esRegexpExecJs = require("core-js/modules/es.regexp.exec.js");
var _esObjectAssignJs = require("core-js/modules/es.object.assign.js");
var _esArrayConcatJs = require("core-js/modules/es.array.concat.js");
var _inferArgTypes = require("../inferArgTypes");
var _inferControls = require("../inferControls");
var _normalizeInputTypes = require("./normalizeInputTypes");
var _excluded = [
    "argTypes",
    "globalTypes",
    "argTypesEnhancers"
];
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function normalizeProjectAnnotations(_ref) {
    var argTypes = _ref.argTypes, globalTypes = _ref.globalTypes, argTypesEnhancers = _ref.argTypesEnhancers, annotations = _objectWithoutProperties(_ref, _excluded);
    return Object.assign({}, argTypes && {
        argTypes: (0, _normalizeInputTypes.normalizeInputTypes)(argTypes)
    }, globalTypes && {
        globalTypes: (0, _normalizeInputTypes.normalizeInputTypes)(globalTypes)
    }, {
        argTypesEnhancers: [].concat(_toConsumableArray(argTypesEnhancers || []), [
            (0, _inferArgTypes.inferArgTypes),
            // and so should be added by a preset there. However, as it seems some code relies on controls
            // annotations (in particular the angular implementation's `cleanArgsDecorator`), for backwards
            // compatibility reasons, we will leave this in the store until 7.0
            (0, _inferControls.inferControls)
        ])
    }, annotations);
}

},{"core-js/modules/es.object.keys.js":"5Q2AT","core-js/modules/es.symbol.js":"ajw2f","core-js/modules/es.symbol.description.js":"wrlLc","core-js/modules/es.object.to-string.js":"lsA9p","core-js/modules/es.symbol.iterator.js":"fhNIb","core-js/modules/es.array.iterator.js":"ieU20","core-js/modules/es.string.iterator.js":"74a8v","core-js/modules/web.dom-collections.iterator.js":"aXR96","core-js/modules/es.array.from.js":"9UCQw","core-js/modules/es.array.slice.js":"8RRh9","core-js/modules/es.function.name.js":"4LiLL","core-js/modules/es.regexp.exec.js":"5q56v","core-js/modules/es.object.assign.js":"8FU8M","core-js/modules/es.array.concat.js":"g1t7q","../inferArgTypes":"4fhLB","../inferControls":"lOqr1","./normalizeInputTypes":"lnztS","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"4fhLB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "inferArgTypes", ()=>inferArgTypes);
var _esArraySliceJs = require("core-js/modules/es.array.slice.js");
var _esObjectFreezeJs = require("core-js/modules/es.object.freeze.js");
var _esArrayIteratorJs = require("core-js/modules/es.array.iterator.js");
var _esObjectToStringJs = require("core-js/modules/es.object.to-string.js");
var _esSetJs = require("core-js/modules/es.set.js");
var _esStringIteratorJs = require("core-js/modules/es.string.iterator.js");
var _webDomCollectionsIteratorJs = require("core-js/modules/web.dom-collections.iterator.js");
var _esArrayConcatJs = require("core-js/modules/es.array.concat.js");
var _esSymbolJs = require("core-js/modules/es.symbol.js");
var _esSymbolDescriptionJs = require("core-js/modules/es.symbol.description.js");
var _esSymbolIteratorJs = require("core-js/modules/es.symbol.iterator.js");
var _mapValues = require("lodash/mapValues");
var _mapValuesDefault = parcelHelpers.interopDefault(_mapValues);
var _tsDedent = require("ts-dedent");
var _tsDedentDefault = parcelHelpers.interopDefault(_tsDedent);
var _clientLogger = require("@storybook/client-logger");
var _parameters = require("./parameters");
var _templateObject;
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) raw = strings.slice(0);
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _typeof(obj) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
}
var inferType = function inferType(value, name, visited) {
    var type = _typeof(value);
    switch(type){
        case "boolean":
        case "string":
        case "number":
        case "function":
        case "symbol":
            return {
                name: type
            };
        default:
            break;
    }
    if (value) {
        if (visited.has(value)) {
            (0, _clientLogger.logger).warn((0, _tsDedentDefault.default)(_templateObject || (_templateObject = _taggedTemplateLiteral([
                "\n        We've detected a cycle in arg '",
                "'. Args should be JSON-serializable.\n\n        Consider using the mapping feature or fully custom args:\n        - Mapping: https://storybook.js.org/docs/react/writing-stories/args#mapping-to-complex-arg-values\n        - Custom args: https://storybook.js.org/docs/react/essentials/controls#fully-custom-args\n      "
            ])), name));
            return {
                name: "other",
                value: "cyclic object"
            };
        }
        visited.add(value);
        if (Array.isArray(value)) {
            var childType = value.length > 0 ? inferType(value[0], name, new Set(visited)) : {
                name: "other",
                value: "unknown"
            };
            return {
                name: "array",
                value: childType
            };
        }
        var fieldTypes = (0, _mapValuesDefault.default)(value, function(field) {
            return inferType(field, name, new Set(visited));
        });
        return {
            name: "object",
            value: fieldTypes
        };
    }
    return {
        name: "object",
        value: {}
    };
};
var inferArgTypes = function inferArgTypes(context) {
    var id = context.id, _context$argTypes = context.argTypes, userArgTypes = _context$argTypes === void 0 ? {} : _context$argTypes, _context$initialArgs = context.initialArgs, initialArgs = _context$initialArgs === void 0 ? {} : _context$initialArgs;
    var argTypes = (0, _mapValuesDefault.default)(initialArgs, function(arg, key) {
        return {
            name: key,
            type: inferType(arg, "".concat(id, ".").concat(key), new Set())
        };
    });
    var userArgTypesNames = (0, _mapValuesDefault.default)(userArgTypes, function(argType, key) {
        return {
            name: key
        };
    });
    return (0, _parameters.combineParameters)(argTypes, userArgTypesNames, userArgTypes);
};
inferArgTypes.secondPass = true;

},{"core-js/modules/es.array.slice.js":"8RRh9","core-js/modules/es.object.freeze.js":"9LVYO","core-js/modules/es.array.iterator.js":"ieU20","core-js/modules/es.object.to-string.js":"lsA9p","core-js/modules/es.set.js":"6FW6g","core-js/modules/es.string.iterator.js":"74a8v","core-js/modules/web.dom-collections.iterator.js":"aXR96","core-js/modules/es.array.concat.js":"g1t7q","core-js/modules/es.symbol.js":"ajw2f","core-js/modules/es.symbol.description.js":"wrlLc","core-js/modules/es.symbol.iterator.js":"fhNIb","lodash/mapValues":"fBbhh","ts-dedent":"9RvVa","@storybook/client-logger":"iGRus","./parameters":"8T89l","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"lOqr1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "inferControls", ()=>inferControls);
parcelHelpers.export(exports, "argTypesEnhancers", ()=>argTypesEnhancers);
var _esRegexpExecJs = require("core-js/modules/es.regexp.exec.js");
var _esFunctionNameJs = require("core-js/modules/es.function.name.js");
var _mapValues = require("lodash/mapValues");
var _mapValuesDefault = parcelHelpers.interopDefault(_mapValues);
var _clientLogger = require("@storybook/client-logger");
var _filterArgTypes = require("./filterArgTypes");
var _parameters = require("./parameters");
var inferControl = function inferControl(argType, name, matchers) {
    var type = argType.type, options = argType.options;
    if (!type && !options) return undefined;
     // args that end with background or color e.g. iconColor
    if (matchers.color && matchers.color.test(name)) {
        var controlType = argType.type.name;
        if (controlType === "string") return {
            control: {
                type: "color"
            }
        };
        (0, _clientLogger.logger).warn('Addon controls: Control of type color only supports string, received "'.concat(controlType, '" instead'));
    } // args that end with date e.g. purchaseDate
    if (matchers.date && matchers.date.test(name)) return {
        control: {
            type: "date"
        }
    };
    switch(type.name){
        case "array":
            return {
                control: {
                    type: "object"
                }
            };
        case "boolean":
            return {
                control: {
                    type: "boolean"
                }
            };
        case "string":
            return {
                control: {
                    type: "text"
                }
            };
        case "number":
            return {
                control: {
                    type: "number"
                }
            };
        case "enum":
            var _ref = type, value = _ref.value;
            return {
                control: {
                    type: (value === null || value === void 0 ? void 0 : value.length) <= 5 ? "radio" : "select"
                },
                options: value
            };
        case "function":
        case "symbol":
            return null;
        default:
            return {
                control: {
                    type: options ? "select" : "object"
                }
            };
    }
};
var inferControls = function inferControls(context) {
    var argTypes = context.argTypes, _context$parameters = context.parameters, __isArgsStory = _context$parameters.__isArgsStory, _context$parameters$c = _context$parameters.controls;
    _context$parameters$c = _context$parameters$c === void 0 ? {} : _context$parameters$c;
    var _context$parameters$c2 = _context$parameters$c.include, include = _context$parameters$c2 === void 0 ? null : _context$parameters$c2, _context$parameters$c3 = _context$parameters$c.exclude, exclude = _context$parameters$c3 === void 0 ? null : _context$parameters$c3, _context$parameters$c4 = _context$parameters$c.matchers, matchers = _context$parameters$c4 === void 0 ? {} : _context$parameters$c4;
    if (!__isArgsStory) return argTypes;
    var filteredArgTypes = (0, _filterArgTypes.filterArgTypes)(argTypes, include, exclude);
    var withControls = (0, _mapValuesDefault.default)(filteredArgTypes, function(argType, name) {
        return (argType === null || argType === void 0 ? void 0 : argType.type) && inferControl(argType, name, matchers);
    });
    return (0, _parameters.combineParameters)(withControls, filteredArgTypes);
};
inferControls.secondPass = true;
var argTypesEnhancers = [
    inferControls
];

},{"core-js/modules/es.regexp.exec.js":"5q56v","core-js/modules/es.function.name.js":"4LiLL","lodash/mapValues":"fBbhh","@storybook/client-logger":"iGRus","./filterArgTypes":"gitKw","./parameters":"8T89l","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"gitKw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "filterArgTypes", ()=>filterArgTypes);
var _esArrayIncludesJs = require("core-js/modules/es.array.includes.js");
var _esStringIncludesJs = require("core-js/modules/es.string.includes.js");
var _esRegexpExecJs = require("core-js/modules/es.regexp.exec.js");
var _esStringMatchJs = require("core-js/modules/es.string.match.js");
var _esFunctionNameJs = require("core-js/modules/es.function.name.js");
var _pickBy = require("lodash/pickBy");
var _pickByDefault = parcelHelpers.interopDefault(_pickBy);
var matches = function matches(name, descriptor) {
    return Array.isArray(descriptor) ? descriptor.includes(name) : name.match(descriptor);
};
var filterArgTypes = function filterArgTypes(argTypes, include, exclude) {
    if (!include && !exclude) return argTypes;
    return argTypes && (0, _pickByDefault.default)(argTypes, function(argType, key) {
        var name = argType.name || key;
        return (!include || matches(name, include)) && (!exclude || !matches(name, exclude));
    });
};

},{"core-js/modules/es.array.includes.js":"dbUjS","core-js/modules/es.string.includes.js":"cx9ET","core-js/modules/es.regexp.exec.js":"5q56v","core-js/modules/es.string.match.js":"e2YpX","core-js/modules/es.function.name.js":"4LiLL","lodash/pickBy":"dLEv3","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"e2YpX":[function(require,module,exports) {
"use strict";
var call = require("1a72ba86dc4099cd");
var fixRegExpWellKnownSymbolLogic = require("3e8300c8dcd37861");
var anObject = require("4e367ba2e602279b");
var toLength = require("3ad5c9f9719d1735");
var toString = require("a1912f278569b4e6");
var requireObjectCoercible = require("d83ac9e10edfa0ef");
var getMethod = require("4fa13f5559b9cbba");
var advanceStringIndex = require("357167b0f8a6ba45");
var regExpExec = require("3b40f00a568e6a6b");
// @@match logic
fixRegExpWellKnownSymbolLogic("match", function(MATCH, nativeMatch, maybeCallNative) {
    return [
        // `String.prototype.match` method
        // https://tc39.es/ecma262/#sec-string.prototype.match
        function match(regexp) {
            var O = requireObjectCoercible(this);
            var matcher = regexp == undefined ? undefined : getMethod(regexp, MATCH);
            return matcher ? call(matcher, regexp, O) : new RegExp(regexp)[MATCH](toString(O));
        },
        // `RegExp.prototype[@@match]` method
        // https://tc39.es/ecma262/#sec-regexp.prototype-@@match
        function(string) {
            var rx = anObject(this);
            var S = toString(string);
            var res = maybeCallNative(nativeMatch, rx, S);
            if (res.done) return res.value;
            if (!rx.global) return regExpExec(rx, S);
            var fullUnicode = rx.unicode;
            rx.lastIndex = 0;
            var A = [];
            var n = 0;
            var result;
            while((result = regExpExec(rx, S)) !== null){
                var matchStr = toString(result[0]);
                A[n] = matchStr;
                if (matchStr === "") rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
                n++;
            }
            return n === 0 ? null : A;
        }
    ];
});

},{"1a72ba86dc4099cd":"aSvFj","3e8300c8dcd37861":"7ckw7","4e367ba2e602279b":"39qAm","3ad5c9f9719d1735":"kzWDg","a1912f278569b4e6":"8RVGu","d83ac9e10edfa0ef":"etuZb","4fa13f5559b9cbba":"llxIw","357167b0f8a6ba45":"lebiR","3b40f00a568e6a6b":"aQ8Du"}],"dLEv3":[function(require,module,exports) {
var arrayMap = require("6fd113b3f5002de4"), baseIteratee = require("1e32e0d8feab18e"), basePickBy = require("85ba60b03da46517"), getAllKeysIn = require("86922ee5dcf85621");
/**
 * Creates an object composed of the `object` properties `predicate` returns
 * truthy for. The predicate is invoked with two arguments: (value, key).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The source object.
 * @param {Function} [predicate=_.identity] The function invoked per property.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pickBy(object, _.isNumber);
 * // => { 'a': 1, 'c': 3 }
 */ function pickBy(object, predicate) {
    if (object == null) return {};
    var props = arrayMap(getAllKeysIn(object), function(prop) {
        return [
            prop
        ];
    });
    predicate = baseIteratee(predicate);
    return basePickBy(object, props, function(value, path) {
        return predicate(value, path[0]);
    });
}
module.exports = pickBy;

},{"6fd113b3f5002de4":"f5pfU","1e32e0d8feab18e":"bZDBu","85ba60b03da46517":"akwGW","86922ee5dcf85621":"erDtN"}],"erDtN":[function(require,module,exports) {
var baseGetAllKeys = require("f6d6a583609f5bf6"), getSymbolsIn = require("feede5d0a2d06427"), keysIn = require("287f70f798405911");
/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function getAllKeysIn(object) {
    return baseGetAllKeys(object, keysIn, getSymbolsIn);
}
module.exports = getAllKeysIn;

},{"f6d6a583609f5bf6":"8XGQ1","feede5d0a2d06427":"eiCAq","287f70f798405911":"jG7oN"}],"eiCAq":[function(require,module,exports) {
var arrayPush = require("2f7c7daf8773557"), getPrototype = require("6ccae2aa7cfa3c66"), getSymbols = require("bdb501682ee9305d"), stubArray = require("7641fe4ae6d2cc96");
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
    var result = [];
    while(object){
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
    }
    return result;
};
module.exports = getSymbolsIn;

},{"2f7c7daf8773557":"fQzwB","6ccae2aa7cfa3c66":"2Lw50","bdb501682ee9305d":"5Kz2O","7641fe4ae6d2cc96":"RkBgO"}],"jG7oN":[function(require,module,exports) {
var arrayLikeKeys = require("635aebb56f3a408f"), baseKeysIn = require("194eb1a802636842"), isArrayLike = require("ac15afdc3ddd76cd");
/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function keysIn(object) {
    return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}
module.exports = keysIn;

},{"635aebb56f3a408f":"bQPt0","194eb1a802636842":"iPxKD","ac15afdc3ddd76cd":"d9OTq"}],"iPxKD":[function(require,module,exports) {
var isObject = require("bd1636f5883f1002"), isPrototype = require("f7d53cd92b2b977b"), nativeKeysIn = require("c039208a16eb68bd");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeysIn(object) {
    if (!isObject(object)) return nativeKeysIn(object);
    var isProto = isPrototype(object), result = [];
    for(var key in object)if (!(key == "constructor" && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
module.exports = baseKeysIn;

},{"bd1636f5883f1002":"37Lwq","f7d53cd92b2b977b":"jZR75","c039208a16eb68bd":"cqOS6"}],"cqOS6":[function(require,module,exports) {
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
module.exports = nativeKeysIn;

},{}],"6xB3G":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getField", ()=>getField);
parcelHelpers.export(exports, "getArrayField", ()=>getArrayField);
parcelHelpers.export(exports, "getObjectField", ()=>getObjectField);
parcelHelpers.export(exports, "getSingletonField", ()=>getSingletonField);
parcelHelpers.export(exports, "composeConfigs", ()=>composeConfigs);
var _esArrayFilterJs = require("core-js/modules/es.array.filter.js");
var _esObjectToStringJs = require("core-js/modules/es.object.to-string.js");
var _esArrayMapJs = require("core-js/modules/es.array.map.js");
var _esArrayConcatJs = require("core-js/modules/es.array.concat.js");
var _esObjectAssignJs = require("core-js/modules/es.object.assign.js");
var _esSymbolJs = require("core-js/modules/es.symbol.js");
var _esSymbolDescriptionJs = require("core-js/modules/es.symbol.description.js");
var _esSymbolIteratorJs = require("core-js/modules/es.symbol.iterator.js");
var _esArrayIteratorJs = require("core-js/modules/es.array.iterator.js");
var _esStringIteratorJs = require("core-js/modules/es.string.iterator.js");
var _webDomCollectionsIteratorJs = require("core-js/modules/web.dom-collections.iterator.js");
var _esArrayFromJs = require("core-js/modules/es.array.from.js");
var _esArraySliceJs = require("core-js/modules/es.array.slice.js");
var _esFunctionNameJs = require("core-js/modules/es.function.name.js");
var _esRegexpExecJs = require("core-js/modules/es.regexp.exec.js");
var _parameters = require("../parameters");
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function getField(moduleExportList, field) {
    return moduleExportList.map(function(xs) {
        return xs[field];
    }).filter(Boolean);
}
function getArrayField(moduleExportList, field) {
    return getField(moduleExportList, field).reduce(function(a, b) {
        return [].concat(_toConsumableArray(a), _toConsumableArray(b));
    }, []);
}
function getObjectField(moduleExportList, field) {
    return Object.assign.apply(Object, [
        {}
    ].concat(_toConsumableArray(getField(moduleExportList, field))));
}
function getSingletonField(moduleExportList, field) {
    return getField(moduleExportList, field).pop();
}
function composeConfigs(moduleExportList) {
    var allArgTypeEnhancers = getArrayField(moduleExportList, "argTypesEnhancers");
    return {
        parameters: (0, _parameters.combineParameters).apply(void 0, _toConsumableArray(getField(moduleExportList, "parameters"))),
        decorators: getArrayField(moduleExportList, "decorators"),
        args: getObjectField(moduleExportList, "args"),
        argsEnhancers: getArrayField(moduleExportList, "argsEnhancers"),
        argTypes: getObjectField(moduleExportList, "argTypes"),
        argTypesEnhancers: [].concat(_toConsumableArray(allArgTypeEnhancers.filter(function(e) {
            return !e.secondPass;
        })), _toConsumableArray(allArgTypeEnhancers.filter(function(e) {
            return e.secondPass;
        }))),
        globals: getObjectField(moduleExportList, "globals"),
        globalTypes: getObjectField(moduleExportList, "globalTypes"),
        loaders: getArrayField(moduleExportList, "loaders"),
        render: getSingletonField(moduleExportList, "render"),
        renderToDOM: getSingletonField(moduleExportList, "renderToDOM"),
        applyDecorators: getSingletonField(moduleExportList, "applyDecorators")
    };
}

},{"core-js/modules/es.array.filter.js":"fD2da","core-js/modules/es.object.to-string.js":"lsA9p","core-js/modules/es.array.map.js":"jTP7e","core-js/modules/es.array.concat.js":"g1t7q","core-js/modules/es.object.assign.js":"8FU8M","core-js/modules/es.symbol.js":"ajw2f","core-js/modules/es.symbol.description.js":"wrlLc","core-js/modules/es.symbol.iterator.js":"fhNIb","core-js/modules/es.array.iterator.js":"ieU20","core-js/modules/es.string.iterator.js":"74a8v","core-js/modules/web.dom-collections.iterator.js":"aXR96","core-js/modules/es.array.from.js":"9UCQw","core-js/modules/es.array.slice.js":"8RRh9","core-js/modules/es.function.name.js":"4LiLL","core-js/modules/es.regexp.exec.js":"5q56v","../parameters":"8T89l","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"kSP6J":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "setProjectAnnotations", ()=>setProjectAnnotations);
parcelHelpers.export(exports, "composeStory", ()=>composeStory);
parcelHelpers.export(exports, "composeStories", ()=>composeStories);
var _esObjectKeysJs = require("core-js/modules/es.object.keys.js");
var _esSymbolJs = require("core-js/modules/es.symbol.js");
var _esSymbolDescriptionJs = require("core-js/modules/es.symbol.description.js");
var _esSymbolIteratorJs = require("core-js/modules/es.symbol.iterator.js");
var _esArrayIteratorJs = require("core-js/modules/es.array.iterator.js");
var _esStringIteratorJs = require("core-js/modules/es.string.iterator.js");
var _webDomCollectionsIteratorJs = require("core-js/modules/web.dom-collections.iterator.js");
var _esArraySliceJs = require("core-js/modules/es.array.slice.js");
var _esArrayFromJs = require("core-js/modules/es.array.from.js");
var _esRegexpExecJs = require("core-js/modules/es.regexp.exec.js");
var _esFunctionNameJs = require("core-js/modules/es.function.name.js");
var _esObjectAssignJs = require("core-js/modules/es.object.assign.js");
var _esObjectToStringJs = require("core-js/modules/es.object.to-string.js");
var _esObjectEntriesJs = require("core-js/modules/es.object.entries.js");
var _csf = require("@storybook/csf");
var _composeConfigs = require("../composeConfigs");
var _prepareStory = require("../prepareStory");
var _normalizeStory = require("../normalizeStory");
var _hooks = require("../../hooks");
var _normalizeComponentAnnotations = require("../normalizeComponentAnnotations");
var _getValuesFromArgTypes = require("../getValuesFromArgTypes");
var _normalizeProjectAnnotations = require("../normalizeProjectAnnotations");
var _types = require("./types");
parcelHelpers.exportAll(_types, exports);
var _excluded = [
    "default",
    "__esModule",
    "__namedExportsOrder"
];
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var GLOBAL_STORYBOOK_PROJECT_ANNOTATIONS = {};
function setProjectAnnotations(projectAnnotations) {
    var annotations = Array.isArray(projectAnnotations) ? projectAnnotations : [
        projectAnnotations
    ];
    GLOBAL_STORYBOOK_PROJECT_ANNOTATIONS = (0, _composeConfigs.composeConfigs)(annotations);
}
function composeStory(storyAnnotations, componentAnnotations) {
    var _componentAnnotations, _storyAnnotations$sto;
    var projectAnnotations = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : GLOBAL_STORYBOOK_PROJECT_ANNOTATIONS;
    var defaultConfig = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var exportsName = arguments.length > 4 ? arguments[4] : undefined;
    if (storyAnnotations === undefined) throw new Error("Expected a story but received undefined.");
     // @TODO: Support auto title
    // eslint-disable-next-line no-param-reassign
    componentAnnotations.title = (_componentAnnotations = componentAnnotations.title) !== null && _componentAnnotations !== void 0 ? _componentAnnotations : "ComposedStory";
    var normalizedComponentAnnotations = (0, _normalizeComponentAnnotations.normalizeComponentAnnotations)(componentAnnotations);
    var storyName = exportsName || storyAnnotations.storyName || ((_storyAnnotations$sto = storyAnnotations.story) === null || _storyAnnotations$sto === void 0 ? void 0 : _storyAnnotations$sto.name) || storyAnnotations.name;
    var normalizedStory = (0, _normalizeStory.normalizeStory)(storyName, storyAnnotations, normalizedComponentAnnotations);
    var normalizedProjectAnnotations = (0, _normalizeProjectAnnotations.normalizeProjectAnnotations)(Object.assign({}, projectAnnotations, defaultConfig));
    var story = (0, _prepareStory.prepareStory)(normalizedStory, normalizedComponentAnnotations, normalizedProjectAnnotations);
    var defaultGlobals = (0, _getValuesFromArgTypes.getValuesFromArgTypes)(projectAnnotations.globalTypes);
    var composedStory = function composedStory(extraArgs) {
        var context = Object.assign({}, story, {
            hooks: new (0, _hooks.HooksContext)(),
            globals: defaultGlobals,
            args: Object.assign({}, story.initialArgs, extraArgs)
        });
        return story.unboundStoryFn(context);
    };
    composedStory.storyName = storyName;
    composedStory.args = story.initialArgs;
    composedStory.play = story.playFunction;
    composedStory.parameters = story.parameters;
    return composedStory;
}
function composeStories(storiesImport, globalConfig, composeStoryFn) {
    var meta = storiesImport.default, __esModule = storiesImport.__esModule, __namedExportsOrder = storiesImport.__namedExportsOrder, stories = _objectWithoutProperties(storiesImport, _excluded);
    var composedStories = Object.entries(stories).reduce(function(storiesMap, _ref) {
        var _ref2 = _slicedToArray(_ref, 2), exportsName = _ref2[0], story = _ref2[1];
        if (!(0, _csf.isExportStory)(exportsName, meta)) return storiesMap;
        var result = Object.assign(storiesMap, _defineProperty({}, exportsName, composeStoryFn(story, meta, globalConfig, exportsName)));
        return result;
    }, {});
    return composedStories;
}

},{"core-js/modules/es.object.keys.js":"5Q2AT","core-js/modules/es.symbol.js":"ajw2f","core-js/modules/es.symbol.description.js":"wrlLc","core-js/modules/es.symbol.iterator.js":"fhNIb","core-js/modules/es.array.iterator.js":"ieU20","core-js/modules/es.string.iterator.js":"74a8v","core-js/modules/web.dom-collections.iterator.js":"aXR96","core-js/modules/es.array.slice.js":"8RRh9","core-js/modules/es.array.from.js":"9UCQw","core-js/modules/es.regexp.exec.js":"5q56v","core-js/modules/es.function.name.js":"4LiLL","core-js/modules/es.object.assign.js":"8FU8M","core-js/modules/es.object.to-string.js":"lsA9p","core-js/modules/es.object.entries.js":"7Wf79","@storybook/csf":"f7MI8","../composeConfigs":"6xB3G","../prepareStory":"1UoAq","../normalizeStory":"bc556","../../hooks":"csdah","../normalizeComponentAnnotations":"4HK3g","../getValuesFromArgTypes":"eZRpL","../normalizeProjectAnnotations":"T05nV","./types":"0fEyC","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"0fEyC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"ddLfR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"02qN8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "userOrAutoTitleFromSpecifier", ()=>userOrAutoTitleFromSpecifier);
parcelHelpers.export(exports, "userOrAutoTitle", ()=>userOrAutoTitle);
var _esSymbolJs = require("core-js/modules/es.symbol.js");
var _esSymbolDescriptionJs = require("core-js/modules/es.symbol.description.js");
var _esSymbolIteratorJs = require("core-js/modules/es.symbol.iterator.js");
var _esArrayIteratorJs = require("core-js/modules/es.array.iterator.js");
var _esStringIteratorJs = require("core-js/modules/es.string.iterator.js");
var _webDomCollectionsIteratorJs = require("core-js/modules/web.dom-collections.iterator.js");
var _esArrayFromJs = require("core-js/modules/es.array.from.js");
var _esFunctionNameJs = require("core-js/modules/es.function.name.js");
var _esObjectFreezeJs = require("core-js/modules/es.object.freeze.js");
var _esArraySliceJs = require("core-js/modules/es.array.slice.js");
var _esArrayFilterJs = require("core-js/modules/es.array.filter.js");
var _esObjectToStringJs = require("core-js/modules/es.object.to-string.js");
var _esRegexpExecJs = require("core-js/modules/es.regexp.exec.js");
var _esRegexpConstructorJs = require("core-js/modules/es.regexp.constructor.js");
var _esRegexpToStringJs = require("core-js/modules/es.regexp.to-string.js");
var _esStringReplaceJs = require("core-js/modules/es.string.replace.js");
var _esArrayJoinJs = require("core-js/modules/es.array.join.js");
var _esStringSplitJs = require("core-js/modules/es.string.split.js");
var _slash = require("slash");
var _slashDefault = parcelHelpers.interopDefault(_slash);
var _tsDedent = require("ts-dedent");
var _tsDedentDefault = parcelHelpers.interopDefault(_tsDedent);
var _clientLogger = require("@storybook/client-logger"); // FIXME: types duplicated type from `core-common', to be
var _templateObject;
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) raw = strings.slice(0);
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _toArray(arr) {
    return _arrayWithHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
// removed when we remove v6 back-compat.
var stripExtension = function stripExtension(path) {
    var parts = _toConsumableArray(path);
    var last = parts[parts.length - 1];
    var dotIndex = last.indexOf(".");
    var stripped = dotIndex > 0 ? last.substr(0, dotIndex) : last;
    parts[parts.length - 1] = stripped;
    var _parts = parts, _parts2 = _toArray(_parts), first = _parts2[0], rest = _parts2.slice(1);
    if (first === "") parts = rest;
    return parts;
};
var indexRe = /^index$/i; // deal with files like "atoms/button/{button,index}.stories.js"
var removeRedundantFilename = function removeRedundantFilename(paths) {
    var prevVal;
    return paths.filter(function(val, index) {
        if (index === paths.length - 1 && (val === prevVal || indexRe.test(val))) return false;
        prevVal = val;
        return true;
    });
};
/**
 * Combines path parts together, without duplicating separators (slashes).  Used instead of `path.join`
 * because this code runs in the browser.
 *
 * @param paths array of paths to join together.
 * @returns joined path string, with single '/' between parts
 */ function pathJoin(paths) {
    var slashes = new RegExp("/{1,}", "g");
    return paths.join("/").replace(slashes, "/");
}
var userOrAutoTitleFromSpecifier = function userOrAutoTitleFromSpecifier(fileName, entry, userTitle) {
    var _ref = entry || {}, directory = _ref.directory, importPathMatcher = _ref.importPathMatcher, _ref$titlePrefix = _ref.titlePrefix, titlePrefix = _ref$titlePrefix === void 0 ? "" : _ref$titlePrefix; // On Windows, backslashes are used in paths, which can cause problems here
    // slash makes sure we always handle paths with unix-style forward slash
    if (typeof fileName === "number") (0, _clientLogger.once).warn((0, _tsDedentDefault.default)(_templateObject || (_templateObject = _taggedTemplateLiteral([
        '\n      CSF Auto-title received a numeric fileName. This typically happens when\n      webpack is mis-configured in production mode. To force webpack to produce\n      filenames, set optimization.moduleIds = "named" in your webpack config.\n    '
    ]))));
    var normalizedFileName = (0, _slashDefault.default)(String(fileName));
    if (importPathMatcher.exec(normalizedFileName)) {
        if (!userTitle) {
            var suffix = normalizedFileName.replace(directory, "");
            var titleAndSuffix = (0, _slashDefault.default)(pathJoin([
                titlePrefix,
                suffix
            ]));
            var path = titleAndSuffix.split("/");
            path = stripExtension(path);
            path = removeRedundantFilename(path);
            return path.join("/");
        }
        if (!titlePrefix) return userTitle;
        return (0, _slashDefault.default)(pathJoin([
            titlePrefix,
            userTitle
        ]));
    }
    return undefined;
};
var userOrAutoTitle = function userOrAutoTitle(fileName, storiesEntries, userTitle) {
    for(var i = 0; i < storiesEntries.length; i += 1){
        var title = userOrAutoTitleFromSpecifier(fileName, storiesEntries[i], userTitle);
        if (title) return title;
    }
    return userTitle || undefined;
};

},{"core-js/modules/es.symbol.js":"ajw2f","core-js/modules/es.symbol.description.js":"wrlLc","core-js/modules/es.symbol.iterator.js":"fhNIb","core-js/modules/es.array.iterator.js":"ieU20","core-js/modules/es.string.iterator.js":"74a8v","core-js/modules/web.dom-collections.iterator.js":"aXR96","core-js/modules/es.array.from.js":"9UCQw","core-js/modules/es.function.name.js":"4LiLL","core-js/modules/es.object.freeze.js":"9LVYO","core-js/modules/es.array.slice.js":"8RRh9","core-js/modules/es.array.filter.js":"fD2da","core-js/modules/es.object.to-string.js":"lsA9p","core-js/modules/es.regexp.exec.js":"5q56v","core-js/modules/es.regexp.constructor.js":"eR7Pe","core-js/modules/es.regexp.to-string.js":"bGzly","core-js/modules/es.string.replace.js":"bFiJG","core-js/modules/es.array.join.js":"1w71h","core-js/modules/es.string.split.js":"12go2","slash":"beAUL","ts-dedent":"9RvVa","@storybook/client-logger":"iGRus","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"eR7Pe":[function(require,module,exports) {
var DESCRIPTORS = require("c8639d3a74e6bb07");
var global = require("599583602923a1c");
var uncurryThis = require("7f079a60fe35f235");
var isForced = require("66b0d772c6e443af");
var inheritIfRequired = require("11d7cdfa8687037e");
var createNonEnumerableProperty = require("5fcf789712ec006");
var defineProperty = require("26e6aa075f47c0bc").f;
var getOwnPropertyNames = require("8b1d3e9ebc10b376").f;
var isPrototypeOf = require("6c4ec99bc7b85243");
var isRegExp = require("28b4ed60c7ffe147");
var toString = require("f00c99d31179ed39");
var regExpFlags = require("ac03d0d10d487776");
var stickyHelpers = require("86e9756a5a6a0176");
var redefine = require("b5512f8a60362474");
var fails = require("5b540f0dbf00266f");
var hasOwn = require("5cfbf10059a84a33");
var enforceInternalState = require("2ff319236881379d").enforce;
var setSpecies = require("7f2183994b17a7e8");
var wellKnownSymbol = require("7edc7513ec6ac4d0");
var UNSUPPORTED_DOT_ALL = require("fbaf905791cdbfe");
var UNSUPPORTED_NCG = require("28f5087d79ccd92a");
var MATCH = wellKnownSymbol("match");
var NativeRegExp = global.RegExp;
var RegExpPrototype = NativeRegExp.prototype;
var SyntaxError = global.SyntaxError;
var getFlags = uncurryThis(regExpFlags);
var exec = uncurryThis(RegExpPrototype.exec);
var charAt = uncurryThis("".charAt);
var replace = uncurryThis("".replace);
var stringIndexOf = uncurryThis("".indexOf);
var stringSlice = uncurryThis("".slice);
// TODO: Use only propper RegExpIdentifierName
var IS_NCG = /^\?<[^\s\d!#%&*+<=>@^][^\s!#%&*+<=>@^]*>/;
var re1 = /a/g;
var re2 = /a/g;
// "new" should create a new object, old webkit bug
var CORRECT_NEW = new NativeRegExp(re1) !== re1;
var UNSUPPORTED_Y = stickyHelpers.UNSUPPORTED_Y;
var BASE_FORCED = DESCRIPTORS && (!CORRECT_NEW || UNSUPPORTED_Y || UNSUPPORTED_DOT_ALL || UNSUPPORTED_NCG || fails(function() {
    re2[MATCH] = false;
    // RegExp constructor can alter flags and IsRegExp works correct with @@match
    return NativeRegExp(re1) != re1 || NativeRegExp(re2) == re2 || NativeRegExp(re1, "i") != "/a/i";
}));
var handleDotAll = function(string) {
    var length = string.length;
    var index = 0;
    var result = "";
    var brackets = false;
    var chr;
    for(; index <= length; index++){
        chr = charAt(string, index);
        if (chr === "\\") {
            result += chr + charAt(string, ++index);
            continue;
        }
        if (!brackets && chr === ".") result += "[\\s\\S]";
        else {
            if (chr === "[") brackets = true;
            else if (chr === "]") brackets = false;
            result += chr;
        }
    }
    return result;
};
var handleNCG = function(string) {
    var length = string.length;
    var index = 0;
    var result = "";
    var named = [];
    var names = {};
    var brackets = false;
    var ncg = false;
    var groupid = 0;
    var groupname = "";
    var chr;
    for(; index <= length; index++){
        chr = charAt(string, index);
        if (chr === "\\") chr = chr + charAt(string, ++index);
        else if (chr === "]") brackets = false;
        else if (!brackets) switch(true){
            case chr === "[":
                brackets = true;
                break;
            case chr === "(":
                if (exec(IS_NCG, stringSlice(string, index + 1))) {
                    index += 2;
                    ncg = true;
                }
                result += chr;
                groupid++;
                continue;
            case chr === ">" && ncg:
                if (groupname === "" || hasOwn(names, groupname)) throw new SyntaxError("Invalid capture group name");
                names[groupname] = true;
                named[named.length] = [
                    groupname,
                    groupid
                ];
                ncg = false;
                groupname = "";
                continue;
        }
        if (ncg) groupname += chr;
        else result += chr;
    }
    return [
        result,
        named
    ];
};
// `RegExp` constructor
// https://tc39.es/ecma262/#sec-regexp-constructor
if (isForced("RegExp", BASE_FORCED)) {
    var RegExpWrapper = function RegExp(pattern, flags) {
        var thisIsRegExp = isPrototypeOf(RegExpPrototype, this);
        var patternIsRegExp = isRegExp(pattern);
        var flagsAreUndefined = flags === undefined;
        var groups = [];
        var rawPattern = pattern;
        var rawFlags, dotAll, sticky, handled, result, state;
        if (!thisIsRegExp && patternIsRegExp && flagsAreUndefined && pattern.constructor === RegExpWrapper) return pattern;
        if (patternIsRegExp || isPrototypeOf(RegExpPrototype, pattern)) {
            pattern = pattern.source;
            if (flagsAreUndefined) flags = "flags" in rawPattern ? rawPattern.flags : getFlags(rawPattern);
        }
        pattern = pattern === undefined ? "" : toString(pattern);
        flags = flags === undefined ? "" : toString(flags);
        rawPattern = pattern;
        if (UNSUPPORTED_DOT_ALL && "dotAll" in re1) {
            dotAll = !!flags && stringIndexOf(flags, "s") > -1;
            if (dotAll) flags = replace(flags, /s/g, "");
        }
        rawFlags = flags;
        if (UNSUPPORTED_Y && "sticky" in re1) {
            sticky = !!flags && stringIndexOf(flags, "y") > -1;
            if (sticky) flags = replace(flags, /y/g, "");
        }
        if (UNSUPPORTED_NCG) {
            handled = handleNCG(pattern);
            pattern = handled[0];
            groups = handled[1];
        }
        result = inheritIfRequired(NativeRegExp(pattern, flags), thisIsRegExp ? this : RegExpPrototype, RegExpWrapper);
        if (dotAll || sticky || groups.length) {
            state = enforceInternalState(result);
            if (dotAll) {
                state.dotAll = true;
                state.raw = RegExpWrapper(handleDotAll(pattern), rawFlags);
            }
            if (sticky) state.sticky = true;
            if (groups.length) state.groups = groups;
        }
        if (pattern !== rawPattern) try {
            // fails in old engines, but we have no alternatives for unsupported regex syntax
            createNonEnumerableProperty(result, "source", rawPattern === "" ? "(?:)" : rawPattern);
        } catch (error) {}
        return result;
    };
    var proxy = function(key) {
        key in RegExpWrapper || defineProperty(RegExpWrapper, key, {
            configurable: true,
            get: function() {
                return NativeRegExp[key];
            },
            set: function(it) {
                NativeRegExp[key] = it;
            }
        });
    };
    for(var keys = getOwnPropertyNames(NativeRegExp), index = 0; keys.length > index;)proxy(keys[index++]);
    RegExpPrototype.constructor = RegExpWrapper;
    RegExpWrapper.prototype = RegExpPrototype;
    redefine(global, "RegExp", RegExpWrapper);
}
// https://tc39.es/ecma262/#sec-get-regexp-@@species
setSpecies("RegExp");

},{"c8639d3a74e6bb07":"7Hk5a","599583602923a1c":"1GZc4","7f079a60fe35f235":"fP9tv","66b0d772c6e443af":"j3Sfj","11d7cdfa8687037e":"dlT8V","5fcf789712ec006":"hol1i","26e6aa075f47c0bc":"dfAo1","8b1d3e9ebc10b376":"9QTxj","6c4ec99bc7b85243":"alXpj","28b4ed60c7ffe147":"7lrRe","f00c99d31179ed39":"8RVGu","ac03d0d10d487776":"iHyxB","86e9756a5a6a0176":"4L3h6","b5512f8a60362474":"3ncOy","5b540f0dbf00266f":"keKlS","5cfbf10059a84a33":"4SzRl","2ff319236881379d":"bRWxa","7f2183994b17a7e8":"46zEr","7edc7513ec6ac4d0":"kbsMI","fbaf905791cdbfe":"5q7zq","28f5087d79ccd92a":"jdKB6"}],"12go2":[function(require,module,exports) {
"use strict";
var apply = require("b556f0157821a821");
var call = require("731f563170e1c210");
var uncurryThis = require("897d2896927b6e02");
var fixRegExpWellKnownSymbolLogic = require("508b20464a6b5517");
var isRegExp = require("35aa8de8d5d95698");
var anObject = require("f367d08a248e8be6");
var requireObjectCoercible = require("9311135c1a422443");
var speciesConstructor = require("55e35ece01e7fba0");
var advanceStringIndex = require("8bb35ae79f87add1");
var toLength = require("49f0536d42765acd");
var toString = require("b9744dd298874d6b");
var getMethod = require("7948c6f9df3714fb");
var arraySlice = require("ecac4c9d4003ecf6");
var callRegExpExec = require("2c9f875738c0535c");
var regexpExec = require("ad9c854bf78e6b31");
var stickyHelpers = require("ff11a5dc8ee4e1e9");
var fails = require("1a700d67237f1f2b");
var UNSUPPORTED_Y = stickyHelpers.UNSUPPORTED_Y;
var MAX_UINT32 = 0xFFFFFFFF;
var min = Math.min;
var $push = [].push;
var exec = uncurryThis(/./.exec);
var push = uncurryThis($push);
var stringSlice = uncurryThis("".slice);
// Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
// Weex JS has frozen built-in prototypes, so use try / catch wrapper
var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = !fails(function() {
    // eslint-disable-next-line regexp/no-empty-group -- required for testing
    var re = /(?:)/;
    var originalExec = re.exec;
    re.exec = function() {
        return originalExec.apply(this, arguments);
    };
    var result = "ab".split(re);
    return result.length !== 2 || result[0] !== "a" || result[1] !== "b";
});
// @@split logic
fixRegExpWellKnownSymbolLogic("split", function(SPLIT, nativeSplit, maybeCallNative) {
    var internalSplit;
    if ("abbc".split(/(b)*/)[1] == "c" || // eslint-disable-next-line regexp/no-empty-group -- required for testing
    "test".split(/(?:)/, -1).length != 4 || "ab".split(/(?:ab)*/).length != 2 || ".".split(/(.?)(.?)/).length != 4 || // eslint-disable-next-line regexp/no-empty-capturing-group, regexp/no-empty-group -- required for testing
    ".".split(/()()/).length > 1 || "".split(/.?/).length) // based on es5-shim implementation, need to rework it
    internalSplit = function(separator, limit) {
        var string = toString(requireObjectCoercible(this));
        var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
        if (lim === 0) return [];
        if (separator === undefined) return [
            string
        ];
        // If `separator` is not a regex, use native split
        if (!isRegExp(separator)) return call(nativeSplit, string, separator, lim);
        var output = [];
        var flags = (separator.ignoreCase ? "i" : "") + (separator.multiline ? "m" : "") + (separator.unicode ? "u" : "") + (separator.sticky ? "y" : "");
        var lastLastIndex = 0;
        // Make `global` and avoid `lastIndex` issues by working with a copy
        var separatorCopy = new RegExp(separator.source, flags + "g");
        var match, lastIndex, lastLength;
        while(match = call(regexpExec, separatorCopy, string)){
            lastIndex = separatorCopy.lastIndex;
            if (lastIndex > lastLastIndex) {
                push(output, stringSlice(string, lastLastIndex, match.index));
                if (match.length > 1 && match.index < string.length) apply($push, output, arraySlice(match, 1));
                lastLength = match[0].length;
                lastLastIndex = lastIndex;
                if (output.length >= lim) break;
            }
            if (separatorCopy.lastIndex === match.index) separatorCopy.lastIndex++; // Avoid an infinite loop
        }
        if (lastLastIndex === string.length) {
            if (lastLength || !exec(separatorCopy, "")) push(output, "");
        } else push(output, stringSlice(string, lastLastIndex));
        return output.length > lim ? arraySlice(output, 0, lim) : output;
    };
    else if ("0".split(undefined, 0).length) internalSplit = function(separator, limit) {
        return separator === undefined && limit === 0 ? [] : call(nativeSplit, this, separator, limit);
    };
    else internalSplit = nativeSplit;
    return [
        // `String.prototype.split` method
        // https://tc39.es/ecma262/#sec-string.prototype.split
        function split(separator, limit) {
            var O = requireObjectCoercible(this);
            var splitter = separator == undefined ? undefined : getMethod(separator, SPLIT);
            return splitter ? call(splitter, separator, O, limit) : call(internalSplit, toString(O), separator, limit);
        },
        // `RegExp.prototype[@@split]` method
        // https://tc39.es/ecma262/#sec-regexp.prototype-@@split
        //
        // NOTE: This cannot be properly polyfilled in engines that don't support
        // the 'y' flag.
        function(string, limit) {
            var rx = anObject(this);
            var S = toString(string);
            var res = maybeCallNative(internalSplit, rx, S, limit, internalSplit !== nativeSplit);
            if (res.done) return res.value;
            var C = speciesConstructor(rx, RegExp);
            var unicodeMatching = rx.unicode;
            var flags = (rx.ignoreCase ? "i" : "") + (rx.multiline ? "m" : "") + (rx.unicode ? "u" : "") + (UNSUPPORTED_Y ? "g" : "y");
            // ^(? + rx + ) is needed, in combination with some S slicing, to
            // simulate the 'y' flag.
            var splitter = new C(UNSUPPORTED_Y ? "^(?:" + rx.source + ")" : rx, flags);
            var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
            if (lim === 0) return [];
            if (S.length === 0) return callRegExpExec(splitter, S) === null ? [
                S
            ] : [];
            var p = 0;
            var q = 0;
            var A = [];
            while(q < S.length){
                splitter.lastIndex = UNSUPPORTED_Y ? 0 : q;
                var z = callRegExpExec(splitter, UNSUPPORTED_Y ? stringSlice(S, q) : S);
                var e;
                if (z === null || (e = min(toLength(splitter.lastIndex + (UNSUPPORTED_Y ? q : 0)), S.length)) === p) q = advanceStringIndex(S, q, unicodeMatching);
                else {
                    push(A, stringSlice(S, p, q));
                    if (A.length === lim) return A;
                    for(var i = 1; i <= z.length - 1; i++){
                        push(A, z[i]);
                        if (A.length === lim) return A;
                    }
                    q = p = e;
                }
            }
            push(A, stringSlice(S, p));
            return A;
        }
    ];
}, !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC, UNSUPPORTED_Y);

},{"b556f0157821a821":"QdiN4","731f563170e1c210":"aSvFj","897d2896927b6e02":"fP9tv","508b20464a6b5517":"7ckw7","35aa8de8d5d95698":"7lrRe","f367d08a248e8be6":"39qAm","9311135c1a422443":"etuZb","55e35ece01e7fba0":"lQLt0","8bb35ae79f87add1":"lebiR","49f0536d42765acd":"kzWDg","b9744dd298874d6b":"8RVGu","7948c6f9df3714fb":"llxIw","ecac4c9d4003ecf6":"hloI5","2c9f875738c0535c":"aQ8Du","ad9c854bf78e6b31":"7hxGn","ff11a5dc8ee4e1e9":"4L3h6","1a700d67237f1f2b":"keKlS"}],"beAUL":[function(require,module,exports) {
"use strict";
module.exports = (path)=>{
    const isExtendedLengthPath = /^\\\\\?\\/.test(path);
    const hasNonAscii = /[^\u0000-\u0080]+/.test(path); // eslint-disable-line no-control-regex
    if (isExtendedLengthPath || hasNonAscii) return path;
    return path.replace(/\\/g, "/");
};

},{}],"i800W":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "sortStoriesV7", ()=>sortStoriesV7);
parcelHelpers.export(exports, "sortStoriesV6", ()=>sortStoriesV6);
var _esArraySliceJs = require("core-js/modules/es.array.slice.js");
var _esObjectFreezeJs = require("core-js/modules/es.object.freeze.js");
var _esFunctionNameJs = require("core-js/modules/es.function.name.js");
var _esArrayMapJs = require("core-js/modules/es.array.map.js");
var _stable = require("stable");
var _stableDefault = parcelHelpers.interopDefault(_stable);
var _tsDedent = require("ts-dedent");
var _tsDedentDefault = parcelHelpers.interopDefault(_tsDedent);
var _storySort = require("./storySort");
var _templateObject;
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) raw = strings.slice(0);
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
var sortStoriesCommon = function sortStoriesCommon(stories, storySortParameter, fileNameOrder) {
    if (storySortParameter) {
        var sortFn;
        if (typeof storySortParameter === "function") sortFn = storySortParameter;
        else sortFn = (0, _storySort.storySort)(storySortParameter);
        (0, _stableDefault.default).inplace(stories, sortFn);
    } else (0, _stableDefault.default).inplace(stories, function(s1, s2) {
        return fileNameOrder.indexOf(s1.importPath) - fileNameOrder.indexOf(s2.importPath);
    });
    return stories;
};
var sortStoriesV7 = function sortStoriesV7(stories, storySortParameter, fileNameOrder) {
    try {
        return sortStoriesCommon(stories, storySortParameter, fileNameOrder);
    } catch (err) {
        throw new Error((0, _tsDedentDefault.default)(_templateObject || (_templateObject = _taggedTemplateLiteral([
            "\n    Error sorting stories with sort parameter ",
            ":\n\n    > ",
            "\n    \n    Are you using a V6-style sort function in V7 mode?\n\n    More info: https://github.com/storybookjs/storybook/blob/next/MIGRATION.md#v7-style-story-sort\n  "
        ])), storySortParameter, err.message));
    }
};
var toIndexEntry = function toIndexEntry(story) {
    var id = story.id, title = story.title, name = story.name, parameters = story.parameters;
    return {
        id: id,
        title: title,
        name: name,
        importPath: parameters.fileName
    };
};
var sortStoriesV6 = function sortStoriesV6(stories, storySortParameter, fileNameOrder) {
    if (storySortParameter && typeof storySortParameter === "function") {
        (0, _stableDefault.default).inplace(stories, storySortParameter);
        return stories.map(function(s) {
            return toIndexEntry(s[1]);
        });
    }
    var storiesV7 = stories.map(function(s) {
        return toIndexEntry(s[1]);
    });
    return sortStoriesCommon(storiesV7, storySortParameter, fileNameOrder);
};

},{"core-js/modules/es.array.slice.js":"8RRh9","core-js/modules/es.object.freeze.js":"9LVYO","core-js/modules/es.function.name.js":"4LiLL","core-js/modules/es.array.map.js":"jTP7e","stable":"kyGHR","ts-dedent":"9RvVa","./storySort":"bcG7P","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"kyGHR":[function(require,module,exports) {
//! stable.js 0.1.8, https://github.com/Two-Screen/stable
//! © 2018 Angry Bytes and contributors. MIT licensed.
(function(global, factory) {
    module.exports = factory();
})(this, function() {
    "use strict";
    // A stable array sort, because `Array#sort()` is not guaranteed stable.
    // This is an implementation of merge sort, without recursion.
    var stable = function(arr, comp) {
        return exec(arr.slice(), comp);
    };
    stable.inplace = function(arr, comp) {
        var result = exec(arr, comp);
        // This simply copies back if the result isn't in the original array,
        // which happens on an odd number of passes.
        if (result !== arr) pass(result, null, arr.length, arr);
        return arr;
    };
    // Execute the sort using the input array and a second buffer as work space.
    // Returns one of those two, containing the final result.
    function exec(arr, comp) {
        if (typeof comp !== "function") comp = function(a, b) {
            return String(a).localeCompare(b);
        };
        // Short-circuit when there's nothing to sort.
        var len = arr.length;
        if (len <= 1) return arr;
        // Rather than dividing input, simply iterate chunks of 1, 2, 4, 8, etc.
        // Chunks are the size of the left or right hand in merge sort.
        // Stop when the left-hand covers all of the array.
        var buffer = new Array(len);
        for(var chk = 1; chk < len; chk *= 2){
            pass(arr, comp, chk, buffer);
            var tmp = arr;
            arr = buffer;
            buffer = tmp;
        }
        return arr;
    }
    // Run a single pass with the given chunk size.
    var pass = function(arr, comp, chk, result) {
        var len = arr.length;
        var i = 0;
        // Step size / double chunk size.
        var dbl = chk * 2;
        // Bounds of the left and right chunks.
        var l, r, e;
        // Iterators over the left and right chunk.
        var li, ri;
        // Iterate over pairs of chunks.
        for(l = 0; l < len; l += dbl){
            r = l + chk;
            e = r + chk;
            if (r > len) r = len;
            if (e > len) e = len;
            // Iterate both chunks in parallel.
            li = l;
            ri = r;
            while(true){
                // Compare the chunks.
                if (li < r && ri < e) {
                    // This works for a regular `sort()` compatible comparator,
                    // but also for a simple comparator like: `a > b`
                    if (comp(arr[li], arr[ri]) <= 0) result[i++] = arr[li++];
                    else result[i++] = arr[ri++];
                } else if (li < r) result[i++] = arr[li++];
                else if (ri < e) result[i++] = arr[ri++];
                else break;
            }
        }
    };
    return stable;
});

},{}],"bcG7P":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "storySort", ()=>storySort);
var _esRegexpExecJs = require("core-js/modules/es.regexp.exec.js");
var _esStringSplitJs = require("core-js/modules/es.string.split.js");
var _esStringTrimJs = require("core-js/modules/es.string.trim.js");
var _esFunctionNameJs = require("core-js/modules/es.function.name.js");
var STORY_KIND_PATH_SEPARATOR = /\s*\/\s*/;
var storySort = function storySort() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return function(a, b) {
        // If the two stories have the same story kind, then use the default
        // ordering, which is the order they are defined in the story file.
        // only when includeNames is falsy
        if (a.title === b.title && !options.includeNames) return 0;
         // Get the StorySortParameter options.
        var method = options.method || "configure";
        var order = options.order || []; // Examine each part of the story title in turn.
        var storyTitleA = a.title.trim().split(STORY_KIND_PATH_SEPARATOR);
        var storyTitleB = b.title.trim().split(STORY_KIND_PATH_SEPARATOR);
        if (options.includeNames) {
            storyTitleA.push(a.name);
            storyTitleB.push(b.name);
        }
        var depth = 0;
        while(storyTitleA[depth] || storyTitleB[depth]){
            // Stories with a shorter depth should go first.
            if (!storyTitleA[depth]) return -1;
            if (!storyTitleB[depth]) return 1;
             // Compare the next part of the story title.
            var nameA = storyTitleA[depth];
            var nameB = storyTitleB[depth];
            if (nameA !== nameB) {
                // Look for the names in the given `order` array.
                var indexA = order.indexOf(nameA);
                var indexB = order.indexOf(nameB);
                var indexWildcard = order.indexOf("*"); // If at least one of the names is found, sort by the `order` array.
                if (indexA !== -1 || indexB !== -1) {
                    // If one of the names is not found and there is a wildcard, insert it at the wildcard position.
                    // Otherwise, list it last.
                    if (indexA === -1) {
                        if (indexWildcard !== -1) indexA = indexWildcard;
                        else indexA = order.length;
                    }
                    if (indexB === -1) {
                        if (indexWildcard !== -1) indexB = indexWildcard;
                        else indexB = order.length;
                    }
                    return indexA - indexB;
                } // Use the default configure() order.
                if (method === "configure") return 0;
                 // Otherwise, use alphabetical order.
                return nameA.localeCompare(nameB, options.locales ? options.locales : undefined, {
                    numeric: true,
                    sensitivity: "accent"
                });
            } // If a nested array is provided for a name, use it for ordering.
            var index = order.indexOf(nameA);
            order = index !== -1 && Array.isArray(order[index + 1]) ? order[index + 1] : []; // We'll need to look at the next part of the name.
            depth += 1;
        } // Identical story titles. The shortcut at the start of this function prevents
        // this from ever being used.
        /* istanbul ignore next */ return 0;
    };
};

},{"core-js/modules/es.regexp.exec.js":"5q56v","core-js/modules/es.string.split.js":"12go2","core-js/modules/es.string.trim.js":"UknJb","core-js/modules/es.function.name.js":"4LiLL","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"UknJb":[function(require,module,exports) {
"use strict";
var $ = require("4a60febef79e9fd2");
var $trim = require("aa85dc53780a7a31").trim;
var forcedStringTrimMethod = require("d62e07fb0a0f0c26");
// `String.prototype.trim` method
// https://tc39.es/ecma262/#sec-string.prototype.trim
$({
    target: "String",
    proto: true,
    forced: forcedStringTrimMethod("trim")
}, {
    trim: function trim() {
        return $trim(this);
    }
});

},{"4a60febef79e9fd2":"1OO62","aa85dc53780a7a31":"d6kyO","d62e07fb0a0f0c26":"kRSQc"}],"kRSQc":[function(require,module,exports) {
var PROPER_FUNCTION_NAME = require("9e0c4c0dbddf03dd").PROPER;
var fails = require("92328d780355dc79");
var whitespaces = require("8c0d7fed4094a2b6");
var non = "\u200B\x85\u180E";
// check that a method works with the correct list
// of whitespaces and has a correct name
module.exports = function(METHOD_NAME) {
    return fails(function() {
        return !!whitespaces[METHOD_NAME]() || non[METHOD_NAME]() !== non || PROPER_FUNCTION_NAME && whitespaces[METHOD_NAME].name !== METHOD_NAME;
    });
};

},{"9e0c4c0dbddf03dd":"5TtMA","92328d780355dc79":"keKlS","8c0d7fed4094a2b6":"2Qi68"}],"idtQA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StoryStoreFacade", ()=>StoryStoreFacade);
var _esSymbolJs = require("core-js/modules/es.symbol.js");
var _esSymbolDescriptionJs = require("core-js/modules/es.symbol.description.js");
var _esSymbolIteratorJs = require("core-js/modules/es.symbol.iterator.js");
var _esArrayIteratorJs = require("core-js/modules/es.array.iterator.js");
var _esStringIteratorJs = require("core-js/modules/es.string.iterator.js");
var _webDomCollectionsIteratorJs = require("core-js/modules/web.dom-collections.iterator.js");
var _esArraySliceJs = require("core-js/modules/es.array.slice.js");
var _esArrayFromJs = require("core-js/modules/es.array.from.js");
var _esObjectFreezeJs = require("core-js/modules/es.object.freeze.js");
var _esObjectKeysJs = require("core-js/modules/es.object.keys.js");
var _esObjectEntriesJs = require("core-js/modules/es.object.entries.js");
var _esArrayMapJs = require("core-js/modules/es.array.map.js");
var _esObjectToStringJs = require("core-js/modules/es.object.to-string.js");
var _webDomCollectionsForEachJs = require("core-js/modules/web.dom-collections.for-each.js");
var _esObjectAssignJs = require("core-js/modules/es.object.assign.js");
var _esRegexpConstructorJs = require("core-js/modules/es.regexp.constructor.js");
var _esRegexpExecJs = require("core-js/modules/es.regexp.exec.js");
var _esRegexpToStringJs = require("core-js/modules/es.regexp.to-string.js");
var _esArrayConcatJs = require("core-js/modules/es.array.concat.js");
var _esArrayFilterJs = require("core-js/modules/es.array.filter.js");
var _esFunctionNameJs = require("core-js/modules/es.function.name.js");
var _global = require("global");
var _globalDefault = parcelHelpers.interopDefault(_global);
var _tsDedent = require("ts-dedent");
var _tsDedentDefault = parcelHelpers.interopDefault(_tsDedent);
var _synchronousPromise = require("synchronous-promise");
var _csf = require("@storybook/csf");
var _store = require("@storybook/store");
var _clientLogger = require("@storybook/client-logger");
var _excluded = [
    "default",
    "__namedExportsOrder"
];
var _templateObject;
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) raw = strings.slice(0);
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
var StoryStoreFacade = /*#__PURE__*/ function() {
    function StoryStoreFacade() {
        _classCallCheck(this, StoryStoreFacade);
        this.projectAnnotations = void 0;
        this.stories = void 0;
        this.csfExports = void 0;
        this.projectAnnotations = {
            loaders: [],
            decorators: [],
            parameters: {},
            argsEnhancers: [],
            argTypesEnhancers: [],
            args: {},
            argTypes: {}
        };
        this.stories = {};
        this.csfExports = {};
    } // This doesn't actually import anything because the client-api loads fully
    // on startup, but this is a shim after all.
    _createClass(StoryStoreFacade, [
        {
            key: "importFn",
            value: function importFn(path) {
                var _this = this;
                return (0, _synchronousPromise.SynchronousPromise).resolve().then(function() {
                    var moduleExports = _this.csfExports[path];
                    if (!moduleExports) throw new Error("Unknown path: ".concat(path));
                    return moduleExports;
                });
            }
        },
        {
            key: "getStoryIndex",
            value: function getStoryIndex(store) {
                var _this$projectAnnotati, _this$projectAnnotati2, _this2 = this;
                var fileNameOrder = Object.keys(this.csfExports);
                var storySortParameter = (_this$projectAnnotati = this.projectAnnotations.parameters) === null || _this$projectAnnotati === void 0 ? void 0 : (_this$projectAnnotati2 = _this$projectAnnotati.options) === null || _this$projectAnnotati2 === void 0 ? void 0 : _this$projectAnnotati2.storySort;
                var storyEntries = Object.entries(this.stories); // Add the kind parameters and global parameters to each entry
                var sortableV6 = storyEntries.map(function(_ref) {
                    var _ref2 = _slicedToArray(_ref, 2), storyId = _ref2[0], importPath = _ref2[1].importPath;
                    var exports = _this2.csfExports[importPath];
                    var csfFile = store.processCSFFileWithCache(exports, importPath, exports.default.title);
                    return [
                        storyId,
                        store.storyFromCSFFile({
                            storyId: storyId,
                            csfFile: csfFile
                        }),
                        csfFile.meta.parameters,
                        _this2.projectAnnotations.parameters
                    ];
                }); // NOTE: the sortStoriesV6 version returns the v7 data format. confusing but more convenient!
                var sortedV7;
                try {
                    sortedV7 = (0, _store.sortStoriesV6)(sortableV6, storySortParameter, fileNameOrder);
                } catch (err) {
                    if (typeof storySortParameter === "function") throw new Error((0, _tsDedentDefault.default)(_templateObject || (_templateObject = _taggedTemplateLiteral([
                        "\n          Error sorting stories with sort parameter ",
                        ":\n\n          > ",
                        "\n          \n          Are you using a V7-style sort function in V6 compatibility mode?\n          \n          More info: https://github.com/storybookjs/storybook/blob/next/MIGRATION.md#v7-style-story-sort\n        "
                    ])), storySortParameter, err.message));
                    throw err;
                }
                var stories = sortedV7.reduce(function(acc, s) {
                    // We use the original entry we stored in `this.stories` because it is possible that the CSF file itself
                    // exports a `parameters.fileName` which can be different and mess up our `importFn`.
                    // In fact, in Storyshots there is a Jest transformer that does exactly that.
                    // NOTE: this doesn't actually change the story object, just the index.
                    acc[s.id] = _this2.stories[s.id];
                    return acc;
                }, {});
                return {
                    v: 3,
                    stories: stories
                };
            }
        },
        {
            key: "clearFilenameExports",
            value: function clearFilenameExports(fileName) {
                var _this3 = this;
                if (!this.csfExports[fileName]) return;
                 // Clear this module's stories from the storyList and existing exports
                Object.entries(this.stories).forEach(function(_ref3) {
                    var _ref4 = _slicedToArray(_ref3, 2), id = _ref4[0], importPath = _ref4[1].importPath;
                    if (importPath === fileName) delete _this3.stories[id];
                }); // We keep this as an empty record so we can use it to maintain component order
                this.csfExports[fileName] = {};
            } // NOTE: we could potentially share some of this code with the stories.json generation
        },
        {
            key: "addStoriesFromExports",
            value: function addStoriesFromExports(fileName, fileExports) {
                var _this4 = this;
                // if the export haven't changed since last time we added them, this is a no-op
                if (this.csfExports[fileName] === fileExports) return;
                 // OTOH, if they have changed, let's clear them out first
                this.clearFilenameExports(fileName);
                var defaultExport = fileExports.default, __namedExportsOrder = fileExports.__namedExportsOrder, namedExports = _objectWithoutProperties(fileExports, _excluded); // eslint-disable-next-line prefer-const
                var _ref5 = defaultExport || {}, componentId = _ref5.id, title = _ref5.title;
                var specifiers = ((0, _globalDefault.default).STORIES || []).map(function(specifier) {
                    return Object.assign({}, specifier, {
                        importPathMatcher: new RegExp(specifier.importPathMatcher)
                    });
                });
                title = (0, _store.userOrAutoTitle)(fileName, specifiers, title);
                if (!title) {
                    (0, _clientLogger.logger).info("Unexpected default export without title in '".concat(fileName, "': ").concat(JSON.stringify(fileExports.default)));
                    return;
                }
                this.csfExports[fileName] = Object.assign({}, fileExports, {
                    default: Object.assign({}, defaultExport, {
                        title: title
                    })
                });
                var sortedExports = namedExports; // prefer a user/loader provided `__namedExportsOrder` array if supplied
                // we do this as es module exports are always ordered alphabetically
                // see https://github.com/storybookjs/storybook/issues/9136
                if (Array.isArray(__namedExportsOrder)) {
                    sortedExports = {};
                    __namedExportsOrder.forEach(function(name) {
                        var namedExport = namedExports[name];
                        if (namedExport) sortedExports[name] = namedExport;
                    });
                }
                Object.entries(sortedExports).filter(function(_ref6) {
                    var _ref7 = _slicedToArray(_ref6, 1), key = _ref7[0];
                    return (0, _csf.isExportStory)(key, defaultExport);
                }).forEach(function(_ref8) {
                    var _storyExport$paramete, _storyExport$story;
                    var _ref9 = _slicedToArray(_ref8, 2), key = _ref9[0], storyExport = _ref9[1];
                    var exportName = (0, _csf.storyNameFromExport)(key);
                    var id = ((_storyExport$paramete = storyExport.parameters) === null || _storyExport$paramete === void 0 ? void 0 : _storyExport$paramete.__id) || (0, _csf.toId)(componentId || title, exportName);
                    var name = typeof storyExport !== "function" && storyExport.name || storyExport.storyName || ((_storyExport$story = storyExport.story) === null || _storyExport$story === void 0 ? void 0 : _storyExport$story.name) || exportName;
                    _this4.stories[id] = {
                        id: id,
                        name: name,
                        title: title,
                        importPath: fileName
                    };
                });
            }
        }
    ]);
    return StoryStoreFacade;
}();

},{"core-js/modules/es.symbol.js":"ajw2f","core-js/modules/es.symbol.description.js":"wrlLc","core-js/modules/es.symbol.iterator.js":"fhNIb","core-js/modules/es.array.iterator.js":"ieU20","core-js/modules/es.string.iterator.js":"74a8v","core-js/modules/web.dom-collections.iterator.js":"aXR96","core-js/modules/es.array.slice.js":"8RRh9","core-js/modules/es.array.from.js":"9UCQw","core-js/modules/es.object.freeze.js":"9LVYO","core-js/modules/es.object.keys.js":"5Q2AT","core-js/modules/es.object.entries.js":"7Wf79","core-js/modules/es.array.map.js":"jTP7e","core-js/modules/es.object.to-string.js":"lsA9p","core-js/modules/web.dom-collections.for-each.js":"iYT1M","core-js/modules/es.object.assign.js":"8FU8M","core-js/modules/es.regexp.constructor.js":"eR7Pe","core-js/modules/es.regexp.exec.js":"5q56v","core-js/modules/es.regexp.to-string.js":"bGzly","core-js/modules/es.array.concat.js":"g1t7q","core-js/modules/es.array.filter.js":"fD2da","core-js/modules/es.function.name.js":"4LiLL","global":"5PzlO","ts-dedent":"9RvVa","synchronous-promise":"dbZce","@storybook/csf":"f7MI8","@storybook/store":"26Xer","@storybook/client-logger":"iGRus","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"lxWOQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"cvJqQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getQueryParams", ()=>getQueryParams);
parcelHelpers.export(exports, "getQueryParam", ()=>getQueryParam);
var _esRegexpExecJs = require("core-js/modules/es.regexp.exec.js");
var _esStringSearchJs = require("core-js/modules/es.string.search.js");
var _global = require("global");
var _globalDefault = parcelHelpers.interopDefault(_global);
var _qs = require("qs");
var document = (0, _globalDefault.default).document;
var getQueryParams = function getQueryParams() {
    // document.location is not defined in react-native
    if (document && document.location && document.location.search) return (0, _qs.parse)(document.location.search, {
        ignoreQueryPrefix: true
    });
    return {};
};
var getQueryParam = function getQueryParam(key) {
    var params = getQueryParams();
    return params[key];
};

},{"core-js/modules/es.regexp.exec.js":"5q56v","core-js/modules/es.string.search.js":"l1Pph","global":"5PzlO","qs":"2jOAs","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"l1Pph":[function(require,module,exports) {
"use strict";
var call = require("8d11f7aaad1fe3c1");
var fixRegExpWellKnownSymbolLogic = require("2fc7060ff2c5a42c");
var anObject = require("80bcaa170d414768");
var requireObjectCoercible = require("87e0667ca38b48b9");
var sameValue = require("fc5195de5b8ec5e0");
var toString = require("ac1a7a91b5d23dc3");
var getMethod = require("d51bcc8729521f43");
var regExpExec = require("d8c3d3bfc882cda6");
// @@search logic
fixRegExpWellKnownSymbolLogic("search", function(SEARCH, nativeSearch, maybeCallNative) {
    return [
        // `String.prototype.search` method
        // https://tc39.es/ecma262/#sec-string.prototype.search
        function search(regexp) {
            var O = requireObjectCoercible(this);
            var searcher = regexp == undefined ? undefined : getMethod(regexp, SEARCH);
            return searcher ? call(searcher, regexp, O) : new RegExp(regexp)[SEARCH](toString(O));
        },
        // `RegExp.prototype[@@search]` method
        // https://tc39.es/ecma262/#sec-regexp.prototype-@@search
        function(string) {
            var rx = anObject(this);
            var S = toString(string);
            var res = maybeCallNative(nativeSearch, rx, S);
            if (res.done) return res.value;
            var previousLastIndex = rx.lastIndex;
            if (!sameValue(previousLastIndex, 0)) rx.lastIndex = 0;
            var result = regExpExec(rx, S);
            if (!sameValue(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
            return result === null ? -1 : result.index;
        }
    ];
});

},{"8d11f7aaad1fe3c1":"aSvFj","2fc7060ff2c5a42c":"7ckw7","80bcaa170d414768":"39qAm","87e0667ca38b48b9":"etuZb","fc5195de5b8ec5e0":"ePaWV","ac1a7a91b5d23dc3":"8RVGu","d51bcc8729521f43":"llxIw","d8c3d3bfc882cda6":"aQ8Du"}],"ePaWV":[function(require,module,exports) {
// `SameValue` abstract operation
// https://tc39.es/ecma262/#sec-samevalue
// eslint-disable-next-line es/no-object-is -- safe
module.exports = Object.is || function is(x, y) {
    // eslint-disable-next-line no-self-compare -- NaN check
    return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
};

},{}],"2jOAs":[function(require,module,exports) {
"use strict";
var stringify = require("a472ccaa2f2351e9");
var parse = require("7ffa4249597bf32b");
var formats = require("454df9476704f887");
module.exports = {
    formats: formats,
    parse: parse,
    stringify: stringify
};

},{"a472ccaa2f2351e9":"8f4XY","7ffa4249597bf32b":"6aaUh","454df9476704f887":"3Jszi"}],"8f4XY":[function(require,module,exports) {
"use strict";
var getSideChannel = require("6246bbb805756d41");
var utils = require("44263cc7b702ebf");
var formats = require("929f8531a94a537c");
var has = Object.prototype.hasOwnProperty;
var arrayPrefixGenerators = {
    brackets: function brackets(prefix) {
        return prefix + "[]";
    },
    comma: "comma",
    indices: function indices(prefix, key) {
        return prefix + "[" + key + "]";
    },
    repeat: function repeat(prefix) {
        return prefix;
    }
};
var isArray = Array.isArray;
var split = String.prototype.split;
var push = Array.prototype.push;
var pushToArray = function(arr, valueOrArray) {
    push.apply(arr, isArray(valueOrArray) ? valueOrArray : [
        valueOrArray
    ]);
};
var toISO = Date.prototype.toISOString;
var defaultFormat = formats["default"];
var defaults = {
    addQueryPrefix: false,
    allowDots: false,
    charset: "utf-8",
    charsetSentinel: false,
    delimiter: "&",
    encode: true,
    encoder: utils.encode,
    encodeValuesOnly: false,
    format: defaultFormat,
    formatter: formats.formatters[defaultFormat],
    // deprecated
    indices: false,
    serializeDate: function serializeDate(date) {
        return toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};
var isNonNullishPrimitive = function isNonNullishPrimitive(v) {
    return typeof v === "string" || typeof v === "number" || typeof v === "boolean" || typeof v === "symbol" || typeof v === "bigint";
};
var sentinel = {};
var stringify = function stringify(object, prefix, generateArrayPrefix, strictNullHandling, skipNulls, encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, sideChannel) {
    var obj = object;
    var tmpSc = sideChannel;
    var step = 0;
    var findFlag = false;
    while((tmpSc = tmpSc.get(sentinel)) !== void 0 && !findFlag){
        // Where object last appeared in the ref tree
        var pos = tmpSc.get(object);
        step += 1;
        if (typeof pos !== "undefined") {
            if (pos === step) throw new RangeError("Cyclic object value");
            else findFlag = true; // Break while
        }
        if (typeof tmpSc.get(sentinel) === "undefined") step = 0;
    }
    if (typeof filter === "function") obj = filter(prefix, obj);
    else if (obj instanceof Date) obj = serializeDate(obj);
    else if (generateArrayPrefix === "comma" && isArray(obj)) obj = utils.maybeMap(obj, function(value) {
        if (value instanceof Date) return serializeDate(value);
        return value;
    });
    if (obj === null) {
        if (strictNullHandling) return encoder && !encodeValuesOnly ? encoder(prefix, defaults.encoder, charset, "key", format) : prefix;
        obj = "";
    }
    if (isNonNullishPrimitive(obj) || utils.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, defaults.encoder, charset, "key", format);
            if (generateArrayPrefix === "comma" && encodeValuesOnly) {
                var valuesArray = split.call(String(obj), ",");
                var valuesJoined = "";
                for(var i = 0; i < valuesArray.length; ++i)valuesJoined += (i === 0 ? "" : ",") + formatter(encoder(valuesArray[i], defaults.encoder, charset, "value", format));
                return [
                    formatter(keyValue) + "=" + valuesJoined
                ];
            }
            return [
                formatter(keyValue) + "=" + formatter(encoder(obj, defaults.encoder, charset, "value", format))
            ];
        }
        return [
            formatter(prefix) + "=" + formatter(String(obj))
        ];
    }
    var values = [];
    if (typeof obj === "undefined") return values;
    var objKeys;
    if (generateArrayPrefix === "comma" && isArray(obj)) // we need to join elements in
    objKeys = [
        {
            value: obj.length > 0 ? obj.join(",") || null : void 0
        }
    ];
    else if (isArray(filter)) objKeys = filter;
    else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }
    for(var j = 0; j < objKeys.length; ++j){
        var key = objKeys[j];
        var value = typeof key === "object" && typeof key.value !== "undefined" ? key.value : obj[key];
        if (skipNulls && value === null) continue;
        var keyPrefix = isArray(obj) ? typeof generateArrayPrefix === "function" ? generateArrayPrefix(prefix, key) : prefix : prefix + (allowDots ? "." + key : "[" + key + "]");
        sideChannel.set(object, step);
        var valueSideChannel = getSideChannel();
        valueSideChannel.set(sentinel, sideChannel);
        pushToArray(values, stringify(value, keyPrefix, generateArrayPrefix, strictNullHandling, skipNulls, encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, valueSideChannel));
    }
    return values;
};
var normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
    if (!opts) return defaults;
    if (opts.encoder !== null && typeof opts.encoder !== "undefined" && typeof opts.encoder !== "function") throw new TypeError("Encoder has to be a function.");
    var charset = opts.charset || defaults.charset;
    if (typeof opts.charset !== "undefined" && opts.charset !== "utf-8" && opts.charset !== "iso-8859-1") throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
    var format = formats["default"];
    if (typeof opts.format !== "undefined") {
        if (!has.call(formats.formatters, opts.format)) throw new TypeError("Unknown format option provided.");
        format = opts.format;
    }
    var formatter = formats.formatters[format];
    var filter = defaults.filter;
    if (typeof opts.filter === "function" || isArray(opts.filter)) filter = opts.filter;
    return {
        addQueryPrefix: typeof opts.addQueryPrefix === "boolean" ? opts.addQueryPrefix : defaults.addQueryPrefix,
        allowDots: typeof opts.allowDots === "undefined" ? defaults.allowDots : !!opts.allowDots,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === "boolean" ? opts.charsetSentinel : defaults.charsetSentinel,
        delimiter: typeof opts.delimiter === "undefined" ? defaults.delimiter : opts.delimiter,
        encode: typeof opts.encode === "boolean" ? opts.encode : defaults.encode,
        encoder: typeof opts.encoder === "function" ? opts.encoder : defaults.encoder,
        encodeValuesOnly: typeof opts.encodeValuesOnly === "boolean" ? opts.encodeValuesOnly : defaults.encodeValuesOnly,
        filter: filter,
        format: format,
        formatter: formatter,
        serializeDate: typeof opts.serializeDate === "function" ? opts.serializeDate : defaults.serializeDate,
        skipNulls: typeof opts.skipNulls === "boolean" ? opts.skipNulls : defaults.skipNulls,
        sort: typeof opts.sort === "function" ? opts.sort : null,
        strictNullHandling: typeof opts.strictNullHandling === "boolean" ? opts.strictNullHandling : defaults.strictNullHandling
    };
};
module.exports = function(object, opts) {
    var obj = object;
    var options = normalizeStringifyOptions(opts);
    var objKeys;
    var filter;
    if (typeof options.filter === "function") {
        filter = options.filter;
        obj = filter("", obj);
    } else if (isArray(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }
    var keys = [];
    if (typeof obj !== "object" || obj === null) return "";
    var arrayFormat;
    if (opts && opts.arrayFormat in arrayPrefixGenerators) arrayFormat = opts.arrayFormat;
    else if (opts && "indices" in opts) arrayFormat = opts.indices ? "indices" : "repeat";
    else arrayFormat = "indices";
    var generateArrayPrefix = arrayPrefixGenerators[arrayFormat];
    if (!objKeys) objKeys = Object.keys(obj);
    if (options.sort) objKeys.sort(options.sort);
    var sideChannel = getSideChannel();
    for(var i = 0; i < objKeys.length; ++i){
        var key = objKeys[i];
        if (options.skipNulls && obj[key] === null) continue;
        pushToArray(keys, stringify(obj[key], key, generateArrayPrefix, options.strictNullHandling, options.skipNulls, options.encode ? options.encoder : null, options.filter, options.sort, options.allowDots, options.serializeDate, options.format, options.formatter, options.encodeValuesOnly, options.charset, sideChannel));
    }
    var joined = keys.join(options.delimiter);
    var prefix = options.addQueryPrefix === true ? "?" : "";
    if (options.charsetSentinel) {
        if (options.charset === "iso-8859-1") // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
        prefix += "utf8=%26%2310003%3B&";
        else // encodeURIComponent('✓')
        prefix += "utf8=%E2%9C%93&";
    }
    return joined.length > 0 ? prefix + joined : "";
};

},{"6246bbb805756d41":"l3w67","44263cc7b702ebf":"26LkM","929f8531a94a537c":"3Jszi"}],"l3w67":[function(require,module,exports) {
"use strict";
var GetIntrinsic = require("7911ec51a2dc9f3e");
var callBound = require("125062ab9035288f");
var inspect = require("9f4f5a92d8c6543");
var $TypeError = GetIntrinsic("%TypeError%");
var $WeakMap = GetIntrinsic("%WeakMap%", true);
var $Map = GetIntrinsic("%Map%", true);
var $weakMapGet = callBound("WeakMap.prototype.get", true);
var $weakMapSet = callBound("WeakMap.prototype.set", true);
var $weakMapHas = callBound("WeakMap.prototype.has", true);
var $mapGet = callBound("Map.prototype.get", true);
var $mapSet = callBound("Map.prototype.set", true);
var $mapHas = callBound("Map.prototype.has", true);
/*
 * This function traverses the list returning the node corresponding to the
 * given key.
 *
 * That node is also moved to the head of the list, so that if it's accessed
 * again we don't need to traverse the whole list. By doing so, all the recently
 * used nodes can be accessed relatively quickly.
 */ var listGetNode = function(list, key) {
    for(var prev = list, curr; (curr = prev.next) !== null; prev = curr)if (curr.key === key) {
        prev.next = curr.next;
        curr.next = list.next;
        list.next = curr; // eslint-disable-line no-param-reassign
        return curr;
    }
};
var listGet = function(objects, key) {
    var node = listGetNode(objects, key);
    return node && node.value;
};
var listSet = function(objects, key, value) {
    var node = listGetNode(objects, key);
    if (node) node.value = value;
    else // Prepend the new node to the beginning of the list
    objects.next = {
        key: key,
        next: objects.next,
        value: value
    };
};
var listHas = function(objects, key) {
    return !!listGetNode(objects, key);
};
module.exports = function getSideChannel() {
    var $wm;
    var $m;
    var $o;
    var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $TypeError("Side channel does not contain " + inspect(key));
        },
        get: function(key) {
            if ($WeakMap && key && (typeof key === "object" || typeof key === "function")) {
                if ($wm) return $weakMapGet($wm, key);
            } else if ($Map) {
                if ($m) return $mapGet($m, key);
            } else {
                if ($o) return listGet($o, key);
            }
        },
        has: function(key) {
            if ($WeakMap && key && (typeof key === "object" || typeof key === "function")) {
                if ($wm) return $weakMapHas($wm, key);
            } else if ($Map) {
                if ($m) return $mapHas($m, key);
            } else {
                if ($o) return listHas($o, key);
            }
            return false;
        },
        set: function(key, value) {
            if ($WeakMap && key && (typeof key === "object" || typeof key === "function")) {
                if (!$wm) $wm = new $WeakMap();
                $weakMapSet($wm, key, value);
            } else if ($Map) {
                if (!$m) $m = new $Map();
                $mapSet($m, key, value);
            } else {
                if (!$o) /*
					 * Initialize the linked list as an empty node, so that we don't have
					 * to special-case handling of the first node: we can always refer to
					 * it as (previous node).next, instead of something like (list).head
					 */ $o = {
                    key: {},
                    next: null
                };
                listSet($o, key, value);
            }
        }
    };
    return channel;
};

},{"7911ec51a2dc9f3e":"fTq9o","125062ab9035288f":"kSjLP","9f4f5a92d8c6543":"5LSEW"}],"fTq9o":[function(require,module,exports) {
"use strict";
var undefined1;
var $SyntaxError = SyntaxError;
var $Function = Function;
var $TypeError = TypeError;
// eslint-disable-next-line consistent-return
var getEvalledConstructor = function(expressionSyntax) {
    try {
        return $Function('"use strict"; return (' + expressionSyntax + ").constructor;")();
    } catch (e) {}
};
var $gOPD = Object.getOwnPropertyDescriptor;
if ($gOPD) try {
    $gOPD({}, "");
} catch (e) {
    $gOPD = null; // this is IE 8, which has a broken gOPD
}
var throwTypeError = function() {
    throw new $TypeError();
};
var ThrowTypeError = $gOPD ? function() {
    try {
        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
        arguments.callee; // IE 8 does not throw here
        return throwTypeError;
    } catch (calleeThrows) {
        try {
            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
            return $gOPD(arguments, "callee").get;
        } catch (gOPDthrows) {
            return throwTypeError;
        }
    }
}() : throwTypeError;
var hasSymbols = require("1f00f712d594ccf")();
var getProto = Object.getPrototypeOf || function(x) {
    return x.__proto__;
}; // eslint-disable-line no-proto
var needsEval = {};
var TypedArray = typeof Uint8Array === "undefined" ? undefined : getProto(Uint8Array);
var INTRINSICS = {
    "%AggregateError%": typeof AggregateError === "undefined" ? undefined : AggregateError,
    "%Array%": Array,
    "%ArrayBuffer%": typeof ArrayBuffer === "undefined" ? undefined : ArrayBuffer,
    "%ArrayIteratorPrototype%": hasSymbols ? getProto([][Symbol.iterator]()) : undefined,
    "%AsyncFromSyncIteratorPrototype%": undefined,
    "%AsyncFunction%": needsEval,
    "%AsyncGenerator%": needsEval,
    "%AsyncGeneratorFunction%": needsEval,
    "%AsyncIteratorPrototype%": needsEval,
    "%Atomics%": typeof Atomics === "undefined" ? undefined : Atomics,
    "%BigInt%": typeof BigInt === "undefined" ? undefined : BigInt,
    "%Boolean%": Boolean,
    "%DataView%": typeof DataView === "undefined" ? undefined : DataView,
    "%Date%": Date,
    "%decodeURI%": decodeURI,
    "%decodeURIComponent%": decodeURIComponent,
    "%encodeURI%": encodeURI,
    "%encodeURIComponent%": encodeURIComponent,
    "%Error%": Error,
    "%eval%": eval,
    "%EvalError%": EvalError,
    "%Float32Array%": typeof Float32Array === "undefined" ? undefined : Float32Array,
    "%Float64Array%": typeof Float64Array === "undefined" ? undefined : Float64Array,
    "%FinalizationRegistry%": typeof FinalizationRegistry === "undefined" ? undefined : FinalizationRegistry,
    "%Function%": $Function,
    "%GeneratorFunction%": needsEval,
    "%Int8Array%": typeof Int8Array === "undefined" ? undefined : Int8Array,
    "%Int16Array%": typeof Int16Array === "undefined" ? undefined : Int16Array,
    "%Int32Array%": typeof Int32Array === "undefined" ? undefined : Int32Array,
    "%isFinite%": isFinite,
    "%isNaN%": isNaN,
    "%IteratorPrototype%": hasSymbols ? getProto(getProto([][Symbol.iterator]())) : undefined,
    "%JSON%": typeof JSON === "object" ? JSON : undefined,
    "%Map%": typeof Map === "undefined" ? undefined : Map,
    "%MapIteratorPrototype%": typeof Map === "undefined" || !hasSymbols ? undefined : getProto(new Map()[Symbol.iterator]()),
    "%Math%": Math,
    "%Number%": Number,
    "%Object%": Object,
    "%parseFloat%": parseFloat,
    "%parseInt%": parseInt,
    "%Promise%": typeof Promise === "undefined" ? undefined : Promise,
    "%Proxy%": typeof Proxy === "undefined" ? undefined : Proxy,
    "%RangeError%": RangeError,
    "%ReferenceError%": ReferenceError,
    "%Reflect%": typeof Reflect === "undefined" ? undefined : Reflect,
    "%RegExp%": RegExp,
    "%Set%": typeof Set === "undefined" ? undefined : Set,
    "%SetIteratorPrototype%": typeof Set === "undefined" || !hasSymbols ? undefined : getProto(new Set()[Symbol.iterator]()),
    "%SharedArrayBuffer%": typeof SharedArrayBuffer === "undefined" ? undefined : SharedArrayBuffer,
    "%String%": String,
    "%StringIteratorPrototype%": hasSymbols ? getProto(""[Symbol.iterator]()) : undefined,
    "%Symbol%": hasSymbols ? Symbol : undefined,
    "%SyntaxError%": $SyntaxError,
    "%ThrowTypeError%": ThrowTypeError,
    "%TypedArray%": TypedArray,
    "%TypeError%": $TypeError,
    "%Uint8Array%": typeof Uint8Array === "undefined" ? undefined : Uint8Array,
    "%Uint8ClampedArray%": typeof Uint8ClampedArray === "undefined" ? undefined : Uint8ClampedArray,
    "%Uint16Array%": typeof Uint16Array === "undefined" ? undefined : Uint16Array,
    "%Uint32Array%": typeof Uint32Array === "undefined" ? undefined : Uint32Array,
    "%URIError%": URIError,
    "%WeakMap%": typeof WeakMap === "undefined" ? undefined : WeakMap,
    "%WeakRef%": typeof WeakRef === "undefined" ? undefined : WeakRef,
    "%WeakSet%": typeof WeakSet === "undefined" ? undefined : WeakSet
};
var doEval = function doEval(name) {
    var value;
    if (name === "%AsyncFunction%") value = getEvalledConstructor("async function () {}");
    else if (name === "%GeneratorFunction%") value = getEvalledConstructor("function* () {}");
    else if (name === "%AsyncGeneratorFunction%") value = getEvalledConstructor("async function* () {}");
    else if (name === "%AsyncGenerator%") {
        var fn = doEval("%AsyncGeneratorFunction%");
        if (fn) value = fn.prototype;
    } else if (name === "%AsyncIteratorPrototype%") {
        var gen = doEval("%AsyncGenerator%");
        if (gen) value = getProto(gen.prototype);
    }
    INTRINSICS[name] = value;
    return value;
};
var LEGACY_ALIASES = {
    "%ArrayBufferPrototype%": [
        "ArrayBuffer",
        "prototype"
    ],
    "%ArrayPrototype%": [
        "Array",
        "prototype"
    ],
    "%ArrayProto_entries%": [
        "Array",
        "prototype",
        "entries"
    ],
    "%ArrayProto_forEach%": [
        "Array",
        "prototype",
        "forEach"
    ],
    "%ArrayProto_keys%": [
        "Array",
        "prototype",
        "keys"
    ],
    "%ArrayProto_values%": [
        "Array",
        "prototype",
        "values"
    ],
    "%AsyncFunctionPrototype%": [
        "AsyncFunction",
        "prototype"
    ],
    "%AsyncGenerator%": [
        "AsyncGeneratorFunction",
        "prototype"
    ],
    "%AsyncGeneratorPrototype%": [
        "AsyncGeneratorFunction",
        "prototype",
        "prototype"
    ],
    "%BooleanPrototype%": [
        "Boolean",
        "prototype"
    ],
    "%DataViewPrototype%": [
        "DataView",
        "prototype"
    ],
    "%DatePrototype%": [
        "Date",
        "prototype"
    ],
    "%ErrorPrototype%": [
        "Error",
        "prototype"
    ],
    "%EvalErrorPrototype%": [
        "EvalError",
        "prototype"
    ],
    "%Float32ArrayPrototype%": [
        "Float32Array",
        "prototype"
    ],
    "%Float64ArrayPrototype%": [
        "Float64Array",
        "prototype"
    ],
    "%FunctionPrototype%": [
        "Function",
        "prototype"
    ],
    "%Generator%": [
        "GeneratorFunction",
        "prototype"
    ],
    "%GeneratorPrototype%": [
        "GeneratorFunction",
        "prototype",
        "prototype"
    ],
    "%Int8ArrayPrototype%": [
        "Int8Array",
        "prototype"
    ],
    "%Int16ArrayPrototype%": [
        "Int16Array",
        "prototype"
    ],
    "%Int32ArrayPrototype%": [
        "Int32Array",
        "prototype"
    ],
    "%JSONParse%": [
        "JSON",
        "parse"
    ],
    "%JSONStringify%": [
        "JSON",
        "stringify"
    ],
    "%MapPrototype%": [
        "Map",
        "prototype"
    ],
    "%NumberPrototype%": [
        "Number",
        "prototype"
    ],
    "%ObjectPrototype%": [
        "Object",
        "prototype"
    ],
    "%ObjProto_toString%": [
        "Object",
        "prototype",
        "toString"
    ],
    "%ObjProto_valueOf%": [
        "Object",
        "prototype",
        "valueOf"
    ],
    "%PromisePrototype%": [
        "Promise",
        "prototype"
    ],
    "%PromiseProto_then%": [
        "Promise",
        "prototype",
        "then"
    ],
    "%Promise_all%": [
        "Promise",
        "all"
    ],
    "%Promise_reject%": [
        "Promise",
        "reject"
    ],
    "%Promise_resolve%": [
        "Promise",
        "resolve"
    ],
    "%RangeErrorPrototype%": [
        "RangeError",
        "prototype"
    ],
    "%ReferenceErrorPrototype%": [
        "ReferenceError",
        "prototype"
    ],
    "%RegExpPrototype%": [
        "RegExp",
        "prototype"
    ],
    "%SetPrototype%": [
        "Set",
        "prototype"
    ],
    "%SharedArrayBufferPrototype%": [
        "SharedArrayBuffer",
        "prototype"
    ],
    "%StringPrototype%": [
        "String",
        "prototype"
    ],
    "%SymbolPrototype%": [
        "Symbol",
        "prototype"
    ],
    "%SyntaxErrorPrototype%": [
        "SyntaxError",
        "prototype"
    ],
    "%TypedArrayPrototype%": [
        "TypedArray",
        "prototype"
    ],
    "%TypeErrorPrototype%": [
        "TypeError",
        "prototype"
    ],
    "%Uint8ArrayPrototype%": [
        "Uint8Array",
        "prototype"
    ],
    "%Uint8ClampedArrayPrototype%": [
        "Uint8ClampedArray",
        "prototype"
    ],
    "%Uint16ArrayPrototype%": [
        "Uint16Array",
        "prototype"
    ],
    "%Uint32ArrayPrototype%": [
        "Uint32Array",
        "prototype"
    ],
    "%URIErrorPrototype%": [
        "URIError",
        "prototype"
    ],
    "%WeakMapPrototype%": [
        "WeakMap",
        "prototype"
    ],
    "%WeakSetPrototype%": [
        "WeakSet",
        "prototype"
    ]
};
var bind = require("7c5e688e48cd07b0");
var hasOwn = require("b03d0058935d00bf");
var $concat = bind.call(Function.call, Array.prototype.concat);
var $spliceApply = bind.call(Function.apply, Array.prototype.splice);
var $replace = bind.call(Function.call, String.prototype.replace);
var $strSlice = bind.call(Function.call, String.prototype.slice);
var $exec = bind.call(Function.call, RegExp.prototype.exec);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */ 
var stringToPath = function stringToPath(string) {
    var first = $strSlice(string, 0, 1);
    var last = $strSlice(string, -1);
    if (first === "%" && last !== "%") throw new $SyntaxError("invalid intrinsic syntax, expected closing `%`");
    else if (last === "%" && first !== "%") throw new $SyntaxError("invalid intrinsic syntax, expected opening `%`");
    var result = [];
    $replace(string, rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $replace(subString, reEscapeChar, "$1") : number || match;
    });
    return result;
};
/* end adaptation */ var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    var intrinsicName = name;
    var alias;
    if (hasOwn(LEGACY_ALIASES, intrinsicName)) {
        alias = LEGACY_ALIASES[intrinsicName];
        intrinsicName = "%" + alias[0] + "%";
    }
    if (hasOwn(INTRINSICS, intrinsicName)) {
        var value = INTRINSICS[intrinsicName];
        if (value === needsEval) value = doEval(intrinsicName);
        if (typeof value === "undefined" && !allowMissing) throw new $TypeError("intrinsic " + name + " exists, but is not available. Please file an issue!");
        return {
            alias: alias,
            name: intrinsicName,
            value: value
        };
    }
    throw new $SyntaxError("intrinsic " + name + " does not exist!");
};
module.exports = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== "string" || name.length === 0) throw new $TypeError("intrinsic name must be a non-empty string");
    if (arguments.length > 1 && typeof allowMissing !== "boolean") throw new $TypeError('"allowMissing" argument must be a boolean');
    if ($exec(/^%?[^%]*%?$/, name) === null) throw new $SyntaxError("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
    var parts = stringToPath(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : "";
    var intrinsic = getBaseIntrinsic("%" + intrinsicBaseName + "%", allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
        intrinsicBaseName = alias[0];
        $spliceApply(parts, $concat([
            0,
            1
        ], alias));
    }
    for(var i = 1, isOwn = true; i < parts.length; i += 1){
        var part = parts[i];
        var first = $strSlice(part, 0, 1);
        var last = $strSlice(part, -1);
        if ((first === '"' || first === "'" || first === "`" || last === '"' || last === "'" || last === "`") && first !== last) throw new $SyntaxError("property names with quotes must have matching quotes");
        if (part === "constructor" || !isOwn) skipFurtherCaching = true;
        intrinsicBaseName += "." + part;
        intrinsicRealName = "%" + intrinsicBaseName + "%";
        if (hasOwn(INTRINSICS, intrinsicRealName)) value = INTRINSICS[intrinsicRealName];
        else if (value != null) {
            if (!(part in value)) {
                if (!allowMissing) throw new $TypeError("base intrinsic for " + name + " exists, but the property is not available.");
                return void 0;
            }
            if ($gOPD && i + 1 >= parts.length) {
                var desc = $gOPD(value, part);
                isOwn = !!desc;
                // By convention, when a data property is converted to an accessor
                // property to emulate a data property that does not suffer from
                // the override mistake, that accessor's getter is marked with
                // an `originalValue` property. Here, when we detect this, we
                // uphold the illusion by pretending to see that original data
                // property, i.e., returning the value rather than the getter
                // itself.
                if (isOwn && "get" in desc && !("originalValue" in desc.get)) value = desc.get;
                else value = value[part];
            } else {
                isOwn = hasOwn(value, part);
                value = value[part];
            }
            if (isOwn && !skipFurtherCaching) INTRINSICS[intrinsicRealName] = value;
        }
    }
    return value;
};

},{"1f00f712d594ccf":"Hzs91","7c5e688e48cd07b0":"jVVtB","b03d0058935d00bf":"3bVv3"}],"Hzs91":[function(require,module,exports) {
"use strict";
var origSymbol = typeof Symbol !== "undefined" && Symbol;
var hasSymbolSham = require("3fb25678c62d2fce");
module.exports = function hasNativeSymbols() {
    if (typeof origSymbol !== "function") return false;
    if (typeof Symbol !== "function") return false;
    if (typeof origSymbol("foo") !== "symbol") return false;
    if (typeof Symbol("bar") !== "symbol") return false;
    return hasSymbolSham();
};

},{"3fb25678c62d2fce":"ldFxD"}],"ldFxD":[function(require,module,exports) {
"use strict";
/* eslint complexity: [2, 18], max-statements: [2, 33] */ module.exports = function hasSymbols() {
    if (typeof Symbol !== "function" || typeof Object.getOwnPropertySymbols !== "function") return false;
    if (typeof Symbol.iterator === "symbol") return true;
    var obj = {};
    var sym = Symbol("test");
    var symObj = Object(sym);
    if (typeof sym === "string") return false;
    if (Object.prototype.toString.call(sym) !== "[object Symbol]") return false;
    if (Object.prototype.toString.call(symObj) !== "[object Symbol]") return false;
    // temp disabled per https://github.com/ljharb/object.assign/issues/17
    // if (sym instanceof Symbol) { return false; }
    // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
    // if (!(symObj instanceof Symbol)) { return false; }
    // if (typeof Symbol.prototype.toString !== 'function') { return false; }
    // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
    var symVal = 42;
    obj[sym] = symVal;
    for(sym in obj)return false;
     // eslint-disable-line no-restricted-syntax, no-unreachable-loop
    if (typeof Object.keys === "function" && Object.keys(obj).length !== 0) return false;
    if (typeof Object.getOwnPropertyNames === "function" && Object.getOwnPropertyNames(obj).length !== 0) return false;
    var syms = Object.getOwnPropertySymbols(obj);
    if (syms.length !== 1 || syms[0] !== sym) return false;
    if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) return false;
    if (typeof Object.getOwnPropertyDescriptor === "function") {
        var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
        if (descriptor.value !== symVal || descriptor.enumerable !== true) return false;
    }
    return true;
};

},{}],"jVVtB":[function(require,module,exports) {
"use strict";
var implementation = require("12e173b4dbaee960");
module.exports = Function.prototype.bind || implementation;

},{"12e173b4dbaee960":"lRhJv"}],"lRhJv":[function(require,module,exports) {
"use strict";
/* eslint no-invalid-this: 1 */ var ERROR_MESSAGE = "Function.prototype.bind called on incompatible ";
var slice = Array.prototype.slice;
var toStr = Object.prototype.toString;
var funcType = "[object Function]";
module.exports = function bind(that) {
    var target = this;
    if (typeof target !== "function" || toStr.call(target) !== funcType) throw new TypeError(ERROR_MESSAGE + target);
    var args = slice.call(arguments, 1);
    var bound;
    var binder = function() {
        if (this instanceof bound) {
            var result = target.apply(this, args.concat(slice.call(arguments)));
            if (Object(result) === result) return result;
            return this;
        } else return target.apply(that, args.concat(slice.call(arguments)));
    };
    var boundLength = Math.max(0, target.length - args.length);
    var boundArgs = [];
    for(var i = 0; i < boundLength; i++)boundArgs.push("$" + i);
    bound = Function("binder", "return function (" + boundArgs.join(",") + "){ return binder.apply(this,arguments); }")(binder);
    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }
    return bound;
};

},{}],"3bVv3":[function(require,module,exports) {
"use strict";
var bind = require("ec4f1e1d3f29fa3e");
module.exports = bind.call(Function.call, Object.prototype.hasOwnProperty);

},{"ec4f1e1d3f29fa3e":"jVVtB"}],"kSjLP":[function(require,module,exports) {
"use strict";
var GetIntrinsic = require("8b08ecb81cf4de17");
var callBind = require("266fc50410cfc4a");
var $indexOf = callBind(GetIntrinsic("String.prototype.indexOf"));
module.exports = function callBoundIntrinsic(name, allowMissing) {
    var intrinsic = GetIntrinsic(name, !!allowMissing);
    if (typeof intrinsic === "function" && $indexOf(name, ".prototype.") > -1) return callBind(intrinsic);
    return intrinsic;
};

},{"8b08ecb81cf4de17":"fTq9o","266fc50410cfc4a":"1LGPW"}],"1LGPW":[function(require,module,exports) {
"use strict";
var bind = require("4f9d84d5de4909bc");
var GetIntrinsic = require("68d2ad3775278f43");
var $apply = GetIntrinsic("%Function.prototype.apply%");
var $call = GetIntrinsic("%Function.prototype.call%");
var $reflectApply = GetIntrinsic("%Reflect.apply%", true) || bind.call($call, $apply);
var $gOPD = GetIntrinsic("%Object.getOwnPropertyDescriptor%", true);
var $defineProperty = GetIntrinsic("%Object.defineProperty%", true);
var $max = GetIntrinsic("%Math.max%");
if ($defineProperty) try {
    $defineProperty({}, "a", {
        value: 1
    });
} catch (e) {
    // IE 8 has a broken defineProperty
    $defineProperty = null;
}
module.exports = function callBind(originalFunction) {
    var func = $reflectApply(bind, $call, arguments);
    if ($gOPD && $defineProperty) {
        var desc = $gOPD(func, "length");
        if (desc.configurable) // original length, plus the receiver, minus any additional arguments (after the receiver)
        $defineProperty(func, "length", {
            value: 1 + $max(0, originalFunction.length - (arguments.length - 1))
        });
    }
    return func;
};
var applyBind = function applyBind() {
    return $reflectApply(bind, $apply, arguments);
};
if ($defineProperty) $defineProperty(module.exports, "apply", {
    value: applyBind
});
else module.exports.apply = applyBind;

},{"4f9d84d5de4909bc":"jVVtB","68d2ad3775278f43":"fTq9o"}],"5LSEW":[function(require,module,exports) {
var hasMap = typeof Map === "function" && Map.prototype;
var mapSizeDescriptor = Object.getOwnPropertyDescriptor && hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, "size") : null;
var mapSize = hasMap && mapSizeDescriptor && typeof mapSizeDescriptor.get === "function" ? mapSizeDescriptor.get : null;
var mapForEach = hasMap && Map.prototype.forEach;
var hasSet = typeof Set === "function" && Set.prototype;
var setSizeDescriptor = Object.getOwnPropertyDescriptor && hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, "size") : null;
var setSize = hasSet && setSizeDescriptor && typeof setSizeDescriptor.get === "function" ? setSizeDescriptor.get : null;
var setForEach = hasSet && Set.prototype.forEach;
var hasWeakMap = typeof WeakMap === "function" && WeakMap.prototype;
var weakMapHas = hasWeakMap ? WeakMap.prototype.has : null;
var hasWeakSet = typeof WeakSet === "function" && WeakSet.prototype;
var weakSetHas = hasWeakSet ? WeakSet.prototype.has : null;
var hasWeakRef = typeof WeakRef === "function" && WeakRef.prototype;
var weakRefDeref = hasWeakRef ? WeakRef.prototype.deref : null;
var booleanValueOf = Boolean.prototype.valueOf;
var objectToString = Object.prototype.toString;
var functionToString = Function.prototype.toString;
var $match = String.prototype.match;
var $slice = String.prototype.slice;
var $replace = String.prototype.replace;
var $toUpperCase = String.prototype.toUpperCase;
var $toLowerCase = String.prototype.toLowerCase;
var $test = RegExp.prototype.test;
var $concat = Array.prototype.concat;
var $join = Array.prototype.join;
var $arrSlice = Array.prototype.slice;
var $floor = Math.floor;
var bigIntValueOf = typeof BigInt === "function" ? BigInt.prototype.valueOf : null;
var gOPS = Object.getOwnPropertySymbols;
var symToString = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? Symbol.prototype.toString : null;
var hasShammedSymbols = typeof Symbol === "function" && typeof Symbol.iterator === "object";
// ie, `has-tostringtag/shams
var toStringTag = typeof Symbol === "function" && Symbol.toStringTag && (typeof Symbol.toStringTag === hasShammedSymbols ? "object" : "symbol") ? Symbol.toStringTag : null;
var isEnumerable = Object.prototype.propertyIsEnumerable;
var gPO = (typeof Reflect === "function" ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype // eslint-disable-line no-proto
 ? function(O) {
    return O.__proto__; // eslint-disable-line no-proto
} : null);
function addNumericSeparator(num, str) {
    if (num === Infinity || num === -Infinity || num !== num || num && num > -1000 && num < 1000 || $test.call(/e/, str)) return str;
    var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof num === "number") {
        var int = num < 0 ? -$floor(-num) : $floor(num); // trunc(num)
        if (int !== num) {
            var intStr = String(int);
            var dec = $slice.call(str, intStr.length + 1);
            return $replace.call(intStr, sepRegex, "$&_") + "." + $replace.call($replace.call(dec, /([0-9]{3})/g, "$&_"), /_$/, "");
        }
    }
    return $replace.call(str, sepRegex, "$&_");
}
var utilInspect = require("faefcb1694f2ad90");
var inspectCustom = utilInspect.custom;
var inspectSymbol = isSymbol(inspectCustom) ? inspectCustom : null;
module.exports = function inspect_(obj, options, depth, seen) {
    var opts = options || {};
    if (has(opts, "quoteStyle") && opts.quoteStyle !== "single" && opts.quoteStyle !== "double") throw new TypeError('option "quoteStyle" must be "single" or "double"');
    if (has(opts, "maxStringLength") && (typeof opts.maxStringLength === "number" ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity : opts.maxStringLength !== null)) throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    var customInspect = has(opts, "customInspect") ? opts.customInspect : true;
    if (typeof customInspect !== "boolean" && customInspect !== "symbol") throw new TypeError("option \"customInspect\", if provided, must be `true`, `false`, or `'symbol'`");
    if (has(opts, "indent") && opts.indent !== null && opts.indent !== "	" && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)) throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    if (has(opts, "numericSeparator") && typeof opts.numericSeparator !== "boolean") throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    var numericSeparator = opts.numericSeparator;
    if (typeof obj === "undefined") return "undefined";
    if (obj === null) return "null";
    if (typeof obj === "boolean") return obj ? "true" : "false";
    if (typeof obj === "string") return inspectString(obj, opts);
    if (typeof obj === "number") {
        if (obj === 0) return Infinity / obj > 0 ? "0" : "-0";
        var str = String(obj);
        return numericSeparator ? addNumericSeparator(obj, str) : str;
    }
    if (typeof obj === "bigint") {
        var bigIntStr = String(obj) + "n";
        return numericSeparator ? addNumericSeparator(obj, bigIntStr) : bigIntStr;
    }
    var maxDepth = typeof opts.depth === "undefined" ? 5 : opts.depth;
    if (typeof depth === "undefined") depth = 0;
    if (depth >= maxDepth && maxDepth > 0 && typeof obj === "object") return isArray(obj) ? "[Array]" : "[Object]";
    var indent = getIndent(opts, depth);
    if (typeof seen === "undefined") seen = [];
    else if (indexOf(seen, obj) >= 0) return "[Circular]";
    function inspect(value, from, noIndent) {
        if (from) {
            seen = $arrSlice.call(seen);
            seen.push(from);
        }
        if (noIndent) {
            var newOpts = {
                depth: opts.depth
            };
            if (has(opts, "quoteStyle")) newOpts.quoteStyle = opts.quoteStyle;
            return inspect_(value, newOpts, depth + 1, seen);
        }
        return inspect_(value, opts, depth + 1, seen);
    }
    if (typeof obj === "function" && !isRegExp(obj)) {
        var name = nameOf(obj);
        var keys = arrObjKeys(obj, inspect);
        return "[Function" + (name ? ": " + name : " (anonymous)") + "]" + (keys.length > 0 ? " { " + $join.call(keys, ", ") + " }" : "");
    }
    if (isSymbol(obj)) {
        var symString = hasShammedSymbols ? $replace.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, "$1") : symToString.call(obj);
        return typeof obj === "object" && !hasShammedSymbols ? markBoxed(symString) : symString;
    }
    if (isElement(obj)) {
        var s = "<" + $toLowerCase.call(String(obj.nodeName));
        var attrs = obj.attributes || [];
        for(var i = 0; i < attrs.length; i++)s += " " + attrs[i].name + "=" + wrapQuotes(quote(attrs[i].value), "double", opts);
        s += ">";
        if (obj.childNodes && obj.childNodes.length) s += "...";
        s += "</" + $toLowerCase.call(String(obj.nodeName)) + ">";
        return s;
    }
    if (isArray(obj)) {
        if (obj.length === 0) return "[]";
        var xs = arrObjKeys(obj, inspect);
        if (indent && !singleLineValues(xs)) return "[" + indentedJoin(xs, indent) + "]";
        return "[ " + $join.call(xs, ", ") + " ]";
    }
    if (isError(obj)) {
        var parts = arrObjKeys(obj, inspect);
        if (!("cause" in Error.prototype) && "cause" in obj && !isEnumerable.call(obj, "cause")) return "{ [" + String(obj) + "] " + $join.call($concat.call("[cause]: " + inspect(obj.cause), parts), ", ") + " }";
        if (parts.length === 0) return "[" + String(obj) + "]";
        return "{ [" + String(obj) + "] " + $join.call(parts, ", ") + " }";
    }
    if (typeof obj === "object" && customInspect) {
        if (inspectSymbol && typeof obj[inspectSymbol] === "function" && utilInspect) return utilInspect(obj, {
            depth: maxDepth - depth
        });
        else if (customInspect !== "symbol" && typeof obj.inspect === "function") return obj.inspect();
    }
    if (isMap(obj)) {
        var mapParts = [];
        mapForEach.call(obj, function(value, key) {
            mapParts.push(inspect(key, obj, true) + " => " + inspect(value, obj));
        });
        return collectionOf("Map", mapSize.call(obj), mapParts, indent);
    }
    if (isSet(obj)) {
        var setParts = [];
        setForEach.call(obj, function(value) {
            setParts.push(inspect(value, obj));
        });
        return collectionOf("Set", setSize.call(obj), setParts, indent);
    }
    if (isWeakMap(obj)) return weakCollectionOf("WeakMap");
    if (isWeakSet(obj)) return weakCollectionOf("WeakSet");
    if (isWeakRef(obj)) return weakCollectionOf("WeakRef");
    if (isNumber(obj)) return markBoxed(inspect(Number(obj)));
    if (isBigInt(obj)) return markBoxed(inspect(bigIntValueOf.call(obj)));
    if (isBoolean(obj)) return markBoxed(booleanValueOf.call(obj));
    if (isString(obj)) return markBoxed(inspect(String(obj)));
    if (!isDate(obj) && !isRegExp(obj)) {
        var ys = arrObjKeys(obj, inspect);
        var isPlainObject = gPO ? gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
        var protoTag = obj instanceof Object ? "" : "null prototype";
        var stringTag = !isPlainObject && toStringTag && Object(obj) === obj && toStringTag in obj ? $slice.call(toStr(obj), 8, -1) : protoTag ? "Object" : "";
        var constructorTag = isPlainObject || typeof obj.constructor !== "function" ? "" : obj.constructor.name ? obj.constructor.name + " " : "";
        var tag = constructorTag + (stringTag || protoTag ? "[" + $join.call($concat.call([], stringTag || [], protoTag || []), ": ") + "] " : "");
        if (ys.length === 0) return tag + "{}";
        if (indent) return tag + "{" + indentedJoin(ys, indent) + "}";
        return tag + "{ " + $join.call(ys, ", ") + " }";
    }
    return String(obj);
};
function wrapQuotes(s, defaultStyle, opts) {
    var quoteChar = (opts.quoteStyle || defaultStyle) === "double" ? '"' : "'";
    return quoteChar + s + quoteChar;
}
function quote(s) {
    return $replace.call(String(s), /"/g, "&quot;");
}
function isArray(obj) {
    return toStr(obj) === "[object Array]" && (!toStringTag || !(typeof obj === "object" && toStringTag in obj));
}
function isDate(obj) {
    return toStr(obj) === "[object Date]" && (!toStringTag || !(typeof obj === "object" && toStringTag in obj));
}
function isRegExp(obj) {
    return toStr(obj) === "[object RegExp]" && (!toStringTag || !(typeof obj === "object" && toStringTag in obj));
}
function isError(obj) {
    return toStr(obj) === "[object Error]" && (!toStringTag || !(typeof obj === "object" && toStringTag in obj));
}
function isString(obj) {
    return toStr(obj) === "[object String]" && (!toStringTag || !(typeof obj === "object" && toStringTag in obj));
}
function isNumber(obj) {
    return toStr(obj) === "[object Number]" && (!toStringTag || !(typeof obj === "object" && toStringTag in obj));
}
function isBoolean(obj) {
    return toStr(obj) === "[object Boolean]" && (!toStringTag || !(typeof obj === "object" && toStringTag in obj));
}
// Symbol and BigInt do have Symbol.toStringTag by spec, so that can't be used to eliminate false positives
function isSymbol(obj) {
    if (hasShammedSymbols) return obj && typeof obj === "object" && obj instanceof Symbol;
    if (typeof obj === "symbol") return true;
    if (!obj || typeof obj !== "object" || !symToString) return false;
    try {
        symToString.call(obj);
        return true;
    } catch (e) {}
    return false;
}
function isBigInt(obj) {
    if (!obj || typeof obj !== "object" || !bigIntValueOf) return false;
    try {
        bigIntValueOf.call(obj);
        return true;
    } catch (e) {}
    return false;
}
var hasOwn = Object.prototype.hasOwnProperty || function(key) {
    return key in this;
};
function has(obj, key) {
    return hasOwn.call(obj, key);
}
function toStr(obj) {
    return objectToString.call(obj);
}
function nameOf(f) {
    if (f.name) return f.name;
    var m = $match.call(functionToString.call(f), /^function\s*([\w$]+)/);
    if (m) return m[1];
    return null;
}
function indexOf(xs, x) {
    if (xs.indexOf) return xs.indexOf(x);
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}
function isMap(x) {
    if (!mapSize || !x || typeof x !== "object") return false;
    try {
        mapSize.call(x);
        try {
            setSize.call(x);
        } catch (s) {
            return true;
        }
        return x instanceof Map; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function isWeakMap(x) {
    if (!weakMapHas || !x || typeof x !== "object") return false;
    try {
        weakMapHas.call(x, weakMapHas);
        try {
            weakSetHas.call(x, weakSetHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function isWeakRef(x) {
    if (!weakRefDeref || !x || typeof x !== "object") return false;
    try {
        weakRefDeref.call(x);
        return true;
    } catch (e) {}
    return false;
}
function isSet(x) {
    if (!setSize || !x || typeof x !== "object") return false;
    try {
        setSize.call(x);
        try {
            mapSize.call(x);
        } catch (m) {
            return true;
        }
        return x instanceof Set; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function isWeakSet(x) {
    if (!weakSetHas || !x || typeof x !== "object") return false;
    try {
        weakSetHas.call(x, weakSetHas);
        try {
            weakMapHas.call(x, weakMapHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function isElement(x) {
    if (!x || typeof x !== "object") return false;
    if (typeof HTMLElement !== "undefined" && x instanceof HTMLElement) return true;
    return typeof x.nodeName === "string" && typeof x.getAttribute === "function";
}
function inspectString(str, opts) {
    if (str.length > opts.maxStringLength) {
        var remaining = str.length - opts.maxStringLength;
        var trailer = "... " + remaining + " more character" + (remaining > 1 ? "s" : "");
        return inspectString($slice.call(str, 0, opts.maxStringLength), opts) + trailer;
    }
    // eslint-disable-next-line no-control-regex
    var s = $replace.call($replace.call(str, /(['\\])/g, "\\$1"), /[\x00-\x1f]/g, lowbyte);
    return wrapQuotes(s, "single", opts);
}
function lowbyte(c) {
    var n = c.charCodeAt(0);
    var x = {
        8: "b",
        9: "t",
        10: "n",
        12: "f",
        13: "r"
    }[n];
    if (x) return "\\" + x;
    return "\\x" + (n < 0x10 ? "0" : "") + $toUpperCase.call(n.toString(16));
}
function markBoxed(str) {
    return "Object(" + str + ")";
}
function weakCollectionOf(type) {
    return type + " { ? }";
}
function collectionOf(type, size, entries, indent) {
    var joinedEntries = indent ? indentedJoin(entries, indent) : $join.call(entries, ", ");
    return type + " (" + size + ") {" + joinedEntries + "}";
}
function singleLineValues(xs) {
    for(var i = 0; i < xs.length; i++){
        if (indexOf(xs[i], "\n") >= 0) return false;
    }
    return true;
}
function getIndent(opts, depth) {
    var baseIndent;
    if (opts.indent === "	") baseIndent = "	";
    else if (typeof opts.indent === "number" && opts.indent > 0) baseIndent = $join.call(Array(opts.indent + 1), " ");
    else return null;
    return {
        base: baseIndent,
        prev: $join.call(Array(depth + 1), baseIndent)
    };
}
function indentedJoin(xs, indent) {
    if (xs.length === 0) return "";
    var lineJoiner = "\n" + indent.prev + indent.base;
    return lineJoiner + $join.call(xs, "," + lineJoiner) + "\n" + indent.prev;
}
function arrObjKeys(obj, inspect) {
    var isArr = isArray(obj);
    var xs = [];
    if (isArr) {
        xs.length = obj.length;
        for(var i = 0; i < obj.length; i++)xs[i] = has(obj, i) ? inspect(obj[i], obj) : "";
    }
    var syms = typeof gOPS === "function" ? gOPS(obj) : [];
    var symMap;
    if (hasShammedSymbols) {
        symMap = {};
        for(var k = 0; k < syms.length; k++)symMap["$" + syms[k]] = syms[k];
    }
    for(var key in obj){
        if (!has(obj, key)) continue;
         // eslint-disable-line no-restricted-syntax, no-continue
        if (isArr && String(Number(key)) === key && key < obj.length) continue;
         // eslint-disable-line no-restricted-syntax, no-continue
        if (hasShammedSymbols && symMap["$" + key] instanceof Symbol) continue; // eslint-disable-line no-restricted-syntax, no-continue
        else if ($test.call(/[^\w$]/, key)) xs.push(inspect(key, obj) + ": " + inspect(obj[key], obj));
        else xs.push(key + ": " + inspect(obj[key], obj));
    }
    if (typeof gOPS === "function") {
        for(var j = 0; j < syms.length; j++)if (isEnumerable.call(obj, syms[j])) xs.push("[" + inspect(syms[j]) + "]: " + inspect(obj[syms[j]], obj));
    }
    return xs;
}

},{"faefcb1694f2ad90":"kXqmx"}],"kXqmx":[function(require,module,exports) {
"use strict";

},{}],"26LkM":[function(require,module,exports) {
"use strict";
var formats = require("7adf3674f81a2c87");
var has = Object.prototype.hasOwnProperty;
var isArray = Array.isArray;
var hexTable = function() {
    var array = [];
    for(var i = 0; i < 256; ++i)array.push("%" + ((i < 16 ? "0" : "") + i.toString(16)).toUpperCase());
    return array;
}();
var compactQueue = function compactQueue(queue) {
    while(queue.length > 1){
        var item = queue.pop();
        var obj = item.obj[item.prop];
        if (isArray(obj)) {
            var compacted = [];
            for(var j = 0; j < obj.length; ++j)if (typeof obj[j] !== "undefined") compacted.push(obj[j]);
            item.obj[item.prop] = compacted;
        }
    }
};
var arrayToObject = function arrayToObject(source, options) {
    var obj = options && options.plainObjects ? Object.create(null) : {};
    for(var i = 0; i < source.length; ++i)if (typeof source[i] !== "undefined") obj[i] = source[i];
    return obj;
};
var merge = function merge(target, source, options) {
    /* eslint no-param-reassign: 0 */ if (!source) return target;
    if (typeof source !== "object") {
        if (isArray(target)) target.push(source);
        else if (target && typeof target === "object") {
            if (options && (options.plainObjects || options.allowPrototypes) || !has.call(Object.prototype, source)) target[source] = true;
        } else return [
            target,
            source
        ];
        return target;
    }
    if (!target || typeof target !== "object") return [
        target
    ].concat(source);
    var mergeTarget = target;
    if (isArray(target) && !isArray(source)) mergeTarget = arrayToObject(target, options);
    if (isArray(target) && isArray(source)) {
        source.forEach(function(item, i) {
            if (has.call(target, i)) {
                var targetItem = target[i];
                if (targetItem && typeof targetItem === "object" && item && typeof item === "object") target[i] = merge(targetItem, item, options);
                else target.push(item);
            } else target[i] = item;
        });
        return target;
    }
    return Object.keys(source).reduce(function(acc, key) {
        var value = source[key];
        if (has.call(acc, key)) acc[key] = merge(acc[key], value, options);
        else acc[key] = value;
        return acc;
    }, mergeTarget);
};
var assign = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function(acc, key) {
        acc[key] = source[key];
        return acc;
    }, target);
};
var decode = function(str, decoder, charset) {
    var strWithoutPlus = str.replace(/\+/g, " ");
    if (charset === "iso-8859-1") // unescape never throws, no try...catch needed:
    return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
    // utf-8
    try {
        return decodeURIComponent(strWithoutPlus);
    } catch (e) {
        return strWithoutPlus;
    }
};
var encode = function encode(str, defaultEncoder, charset, kind, format) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) return str;
    var string = str;
    if (typeof str === "symbol") string = Symbol.prototype.toString.call(str);
    else if (typeof str !== "string") string = String(str);
    if (charset === "iso-8859-1") return escape(string).replace(/%u[0-9a-f]{4}/gi, function($0) {
        return "%26%23" + parseInt($0.slice(2), 16) + "%3B";
    });
    var out = "";
    for(var i = 0; i < string.length; ++i){
        var c = string.charCodeAt(i);
        if (c === 0x2D // -
         || c === 0x2E // .
         || c === 0x5F // _
         || c === 0x7E // ~
         || c >= 0x30 && c <= 0x39 // 0-9
         || c >= 0x41 && c <= 0x5A // a-z
         || c >= 0x61 && c <= 0x7A // A-Z
         || format === formats.RFC1738 && (c === 0x28 || c === 0x29) // ( )
        ) {
            out += string.charAt(i);
            continue;
        }
        if (c < 0x80) {
            out = out + hexTable[c];
            continue;
        }
        if (c < 0x800) {
            out = out + (hexTable[0xC0 | c >> 6] + hexTable[0x80 | c & 0x3F]);
            continue;
        }
        if (c < 0xD800 || c >= 0xE000) {
            out = out + (hexTable[0xE0 | c >> 12] + hexTable[0x80 | c >> 6 & 0x3F] + hexTable[0x80 | c & 0x3F]);
            continue;
        }
        i += 1;
        c = 0x10000 + ((c & 0x3FF) << 10 | string.charCodeAt(i) & 0x3FF);
        /* eslint operator-linebreak: [2, "before"] */ out += hexTable[0xF0 | c >> 18] + hexTable[0x80 | c >> 12 & 0x3F] + hexTable[0x80 | c >> 6 & 0x3F] + hexTable[0x80 | c & 0x3F];
    }
    return out;
};
var compact = function compact(value) {
    var queue = [
        {
            obj: {
                o: value
            },
            prop: "o"
        }
    ];
    var refs = [];
    for(var i = 0; i < queue.length; ++i){
        var item = queue[i];
        var obj = item.obj[item.prop];
        var keys = Object.keys(obj);
        for(var j = 0; j < keys.length; ++j){
            var key = keys[j];
            var val = obj[key];
            if (typeof val === "object" && val !== null && refs.indexOf(val) === -1) {
                queue.push({
                    obj: obj,
                    prop: key
                });
                refs.push(val);
            }
        }
    }
    compactQueue(queue);
    return value;
};
var isRegExp = function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === "[object RegExp]";
};
var isBuffer = function isBuffer(obj) {
    if (!obj || typeof obj !== "object") return false;
    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};
var combine = function combine(a, b) {
    return [].concat(a, b);
};
var maybeMap = function maybeMap(val, fn) {
    if (isArray(val)) {
        var mapped = [];
        for(var i = 0; i < val.length; i += 1)mapped.push(fn(val[i]));
        return mapped;
    }
    return fn(val);
};
module.exports = {
    arrayToObject: arrayToObject,
    assign: assign,
    combine: combine,
    compact: compact,
    decode: decode,
    encode: encode,
    isBuffer: isBuffer,
    isRegExp: isRegExp,
    maybeMap: maybeMap,
    merge: merge
};

},{"7adf3674f81a2c87":"3Jszi"}],"3Jszi":[function(require,module,exports) {
"use strict";
var replace = String.prototype.replace;
var percentTwenties = /%20/g;
var Format = {
    RFC1738: "RFC1738",
    RFC3986: "RFC3986"
};
module.exports = {
    "default": Format.RFC3986,
    formatters: {
        RFC1738: function(value) {
            return replace.call(value, percentTwenties, "+");
        },
        RFC3986: function(value) {
            return String(value);
        }
    },
    RFC1738: Format.RFC1738,
    RFC3986: Format.RFC3986
};

},{}],"6aaUh":[function(require,module,exports) {
"use strict";
var utils = require("e76649c95dd0e736");
var has = Object.prototype.hasOwnProperty;
var isArray = Array.isArray;
var defaults = {
    allowDots: false,
    allowPrototypes: false,
    allowSparse: false,
    arrayLimit: 20,
    charset: "utf-8",
    charsetSentinel: false,
    comma: false,
    decoder: utils.decode,
    delimiter: "&",
    depth: 5,
    ignoreQueryPrefix: false,
    interpretNumericEntities: false,
    parameterLimit: 1000,
    parseArrays: true,
    plainObjects: false,
    strictNullHandling: false
};
var interpretNumericEntities = function(str) {
    return str.replace(/&#(\d+);/g, function($0, numberStr) {
        return String.fromCharCode(parseInt(numberStr, 10));
    });
};
var parseArrayValue = function(val, options) {
    if (val && typeof val === "string" && options.comma && val.indexOf(",") > -1) return val.split(",");
    return val;
};
// This is what browsers will submit when the ✓ character occurs in an
// application/x-www-form-urlencoded body and the encoding of the page containing
// the form is iso-8859-1, or when the submitted form has an accept-charset
// attribute of iso-8859-1. Presumably also with other charsets that do not contain
// the ✓ character, such as us-ascii.
var isoSentinel = "utf8=%26%2310003%3B"; // encodeURIComponent('&#10003;')
// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
var charsetSentinel = "utf8=%E2%9C%93"; // encodeURIComponent('✓')
var parseValues = function parseQueryStringValues(str, options) {
    var obj = {};
    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, "") : str;
    var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
    var parts = cleanStr.split(options.delimiter, limit);
    var skipIndex = -1; // Keep track of where the utf8 sentinel was found
    var i;
    var charset = options.charset;
    if (options.charsetSentinel) {
        for(i = 0; i < parts.length; ++i)if (parts[i].indexOf("utf8=") === 0) {
            if (parts[i] === charsetSentinel) charset = "utf-8";
            else if (parts[i] === isoSentinel) charset = "iso-8859-1";
            skipIndex = i;
            i = parts.length; // The eslint settings do not allow break;
        }
    }
    for(i = 0; i < parts.length; ++i){
        if (i === skipIndex) continue;
        var part = parts[i];
        var bracketEqualsPos = part.indexOf("]=");
        var pos = bracketEqualsPos === -1 ? part.indexOf("=") : bracketEqualsPos + 1;
        var key, val;
        if (pos === -1) {
            key = options.decoder(part, defaults.decoder, charset, "key");
            val = options.strictNullHandling ? null : "";
        } else {
            key = options.decoder(part.slice(0, pos), defaults.decoder, charset, "key");
            val = utils.maybeMap(parseArrayValue(part.slice(pos + 1), options), function(encodedVal) {
                return options.decoder(encodedVal, defaults.decoder, charset, "value");
            });
        }
        if (val && options.interpretNumericEntities && charset === "iso-8859-1") val = interpretNumericEntities(val);
        if (part.indexOf("[]=") > -1) val = isArray(val) ? [
            val
        ] : val;
        if (has.call(obj, key)) obj[key] = utils.combine(obj[key], val);
        else obj[key] = val;
    }
    return obj;
};
var parseObject = function(chain, val, options, valuesParsed) {
    var leaf = valuesParsed ? val : parseArrayValue(val, options);
    for(var i = chain.length - 1; i >= 0; --i){
        var obj;
        var root = chain[i];
        if (root === "[]" && options.parseArrays) obj = [].concat(leaf);
        else {
            obj = options.plainObjects ? Object.create(null) : {};
            var cleanRoot = root.charAt(0) === "[" && root.charAt(root.length - 1) === "]" ? root.slice(1, -1) : root;
            var index = parseInt(cleanRoot, 10);
            if (!options.parseArrays && cleanRoot === "") obj = {
                0: leaf
            };
            else if (!isNaN(index) && root !== cleanRoot && String(index) === cleanRoot && index >= 0 && options.parseArrays && index <= options.arrayLimit) {
                obj = [];
                obj[index] = leaf;
            } else if (cleanRoot !== "__proto__") obj[cleanRoot] = leaf;
        }
        leaf = obj;
    }
    return leaf;
};
var parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
    if (!givenKey) return;
    // Transform dot notation to bracket notation
    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, "[$1]") : givenKey;
    // The regex chunks
    var brackets = /(\[[^[\]]*])/;
    var child = /(\[[^[\]]*])/g;
    // Get the parent
    var segment = options.depth > 0 && brackets.exec(key);
    var parent = segment ? key.slice(0, segment.index) : key;
    // Stash the parent if it exists
    var keys = [];
    if (parent) {
        // If we aren't using plain objects, optionally prefix keys that would overwrite object prototype properties
        if (!options.plainObjects && has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) return;
        }
        keys.push(parent);
    }
    // Loop through children appending to the array until we hit depth
    var i = 0;
    while(options.depth > 0 && (segment = child.exec(key)) !== null && i < options.depth){
        i += 1;
        if (!options.plainObjects && has.call(Object.prototype, segment[1].slice(1, -1))) {
            if (!options.allowPrototypes) return;
        }
        keys.push(segment[1]);
    }
    // If there's a remainder, just add whatever is left
    if (segment) keys.push("[" + key.slice(segment.index) + "]");
    return parseObject(keys, val, options, valuesParsed);
};
var normalizeParseOptions = function normalizeParseOptions(opts) {
    if (!opts) return defaults;
    if (opts.decoder !== null && opts.decoder !== undefined && typeof opts.decoder !== "function") throw new TypeError("Decoder has to be a function.");
    if (typeof opts.charset !== "undefined" && opts.charset !== "utf-8" && opts.charset !== "iso-8859-1") throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
    var charset = typeof opts.charset === "undefined" ? defaults.charset : opts.charset;
    return {
        allowDots: typeof opts.allowDots === "undefined" ? defaults.allowDots : !!opts.allowDots,
        allowPrototypes: typeof opts.allowPrototypes === "boolean" ? opts.allowPrototypes : defaults.allowPrototypes,
        allowSparse: typeof opts.allowSparse === "boolean" ? opts.allowSparse : defaults.allowSparse,
        arrayLimit: typeof opts.arrayLimit === "number" ? opts.arrayLimit : defaults.arrayLimit,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === "boolean" ? opts.charsetSentinel : defaults.charsetSentinel,
        comma: typeof opts.comma === "boolean" ? opts.comma : defaults.comma,
        decoder: typeof opts.decoder === "function" ? opts.decoder : defaults.decoder,
        delimiter: typeof opts.delimiter === "string" || utils.isRegExp(opts.delimiter) ? opts.delimiter : defaults.delimiter,
        // eslint-disable-next-line no-implicit-coercion, no-extra-parens
        depth: typeof opts.depth === "number" || opts.depth === false ? +opts.depth : defaults.depth,
        ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
        interpretNumericEntities: typeof opts.interpretNumericEntities === "boolean" ? opts.interpretNumericEntities : defaults.interpretNumericEntities,
        parameterLimit: typeof opts.parameterLimit === "number" ? opts.parameterLimit : defaults.parameterLimit,
        parseArrays: opts.parseArrays !== false,
        plainObjects: typeof opts.plainObjects === "boolean" ? opts.plainObjects : defaults.plainObjects,
        strictNullHandling: typeof opts.strictNullHandling === "boolean" ? opts.strictNullHandling : defaults.strictNullHandling
    };
};
module.exports = function(str, opts) {
    var options = normalizeParseOptions(opts);
    if (str === "" || str === null || typeof str === "undefined") return options.plainObjects ? Object.create(null) : {};
    var tempObj = typeof str === "string" ? parseValues(str, options) : str;
    var obj = options.plainObjects ? Object.create(null) : {};
    // Iterate over the keys and setup the new object
    var keys = Object.keys(tempObj);
    for(var i = 0; i < keys.length; ++i){
        var key = keys[i];
        var newObj = parseKeys(key, tempObj[key], options, typeof str === "string");
        obj = utils.merge(obj, newObj, options);
    }
    if (options.allowSparse === true) return obj;
    return utils.compact(obj);
};

},{"e76649c95dd0e736":"26LkM"}],"8tgIo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "start", ()=>start);
var _esObjectToStringJs = require("core-js/modules/es.object.to-string.js");
var _webDomCollectionsForEachJs = require("core-js/modules/web.dom-collections.for-each.js");
var _esArrayFromJs = require("core-js/modules/es.array.from.js");
var _esStringIteratorJs = require("core-js/modules/es.string.iterator.js");
var _esArrayIteratorJs = require("core-js/modules/es.array.iterator.js");
var _webDomCollectionsIteratorJs = require("core-js/modules/web.dom-collections.iterator.js");
var _esObjectAssignJs = require("core-js/modules/es.object.assign.js");
var _esSymbolJs = require("core-js/modules/es.symbol.js");
var _esSymbolDescriptionJs = require("core-js/modules/es.symbol.description.js");
var _esSymbolIteratorJs = require("core-js/modules/es.symbol.iterator.js");
var _esArraySliceJs = require("core-js/modules/es.array.slice.js");
var _esFunctionNameJs = require("core-js/modules/es.function.name.js");
var _esRegexpExecJs = require("core-js/modules/es.regexp.exec.js");
var _global = require("global");
var _globalDefault = parcelHelpers.interopDefault(_global);
var _utilDeprecate = require("util-deprecate");
var _utilDeprecateDefault = parcelHelpers.interopDefault(_utilDeprecate);
var _clientApi = require("@storybook/client-api");
var _previewWeb = require("@storybook/preview-web");
var _channelPostmessage = require("@storybook/channel-postmessage");
var _channelPostmessageDefault = parcelHelpers.interopDefault(_channelPostmessage);
var _addons = require("@storybook/addons");
var _coreEvents = require("@storybook/core-events");
var _coreEventsDefault = parcelHelpers.interopDefault(_coreEvents);
var _executeLoadable = require("./executeLoadable");
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var globalWindow = (0, _globalDefault.default).window, FEATURES = (0, _globalDefault.default).FEATURES;
var configureDeprecationWarning = (0, _utilDeprecateDefault.default)(function() {}, "`configure()` is deprecated and will be removed in Storybook 7.0. \nPlease use the `stories` field of `main.js` to load stories.\nRead more at https://github.com/storybookjs/storybook/blob/next/MIGRATION.md#deprecated-configure");
var removedApi = function removedApi(name) {
    return function() {
        throw new Error("@storybook/client-api:".concat(name, " was removed in storyStoreV7."));
    };
};
function start(renderToDOM) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, decorateStory = _ref.decorateStory, render = _ref.render;
    if (globalWindow) // To enable user code to detect if it is running in Storybook
    globalWindow.IS_STORYBOOK = true;
    if (FEATURES !== null && FEATURES !== void 0 && FEATURES.storyStoreV7) return {
        forceReRender: removedApi("forceReRender"),
        getStorybook: removedApi("getStorybook"),
        configure: removedApi("configure"),
        clientApi: {
            addDecorator: removedApi("clientApi.addDecorator"),
            addParameters: removedApi("clientApi.addParameters"),
            clearDecorators: removedApi("clientApi.clearDecorators"),
            addLoader: removedApi("clientApi.addLoader"),
            setAddon: removedApi("clientApi.setAddon"),
            getStorybook: removedApi("clientApi.getStorybook"),
            storiesOf: removedApi("clientApi.storiesOf"),
            raw: removedApi("raw")
        }
    };
    var channel = (0, _channelPostmessageDefault.default)({
        page: "preview"
    });
    (0, _addons.addons).setChannel(channel);
    var clientApi = new (0, _clientApi.ClientApi)();
    var preview = new (0, _previewWeb.PreviewWeb)();
    var initialized = false;
    var importFn = function importFn(path) {
        return clientApi.importFn(path);
    };
    function onStoriesChanged() {
        var storyIndex = clientApi.getStoryIndex();
        preview.onStoriesChanged({
            storyIndex: storyIndex,
            importFn: importFn
        });
    } // These two bits are a bit ugly, but due to dependencies, `ClientApi` cannot have
    // direct reference to `PreviewWeb`, so we need to patch in bits
    clientApi.onImportFnChanged = onStoriesChanged;
    clientApi.storyStore = preview.storyStore;
    if (globalWindow) {
        globalWindow.__STORYBOOK_CLIENT_API__ = clientApi;
        globalWindow.__STORYBOOK_ADDONS_CHANNEL__ = channel; // eslint-disable-next-line no-underscore-dangle
        globalWindow.__STORYBOOK_PREVIEW__ = preview;
        globalWindow.__STORYBOOK_STORY_STORE__ = preview.storyStore;
    }
    return {
        forceReRender: function forceReRender() {
            return channel.emit((0, _coreEventsDefault.default).FORCE_RE_RENDER);
        },
        getStorybook: function getStorybook() {
            return [];
        },
        raw: function raw() {},
        clientApi: clientApi,
        // This gets called each time the user calls configure (i.e. once per HMR)
        // The first time, it constructs the preview, subsequently it updates it
        configure: function configure(framework, loadable, m) {
            var showDeprecationWarning = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
            if (showDeprecationWarning) configureDeprecationWarning();
            clientApi.addParameters({
                framework: framework
            }); // We need to run the `executeLoadableForChanges` function *inside* the `getProjectAnnotations
            // function in case it throws. So we also need to process its output there also
            var getProjectAnnotations = function getProjectAnnotations() {
                var _executeLoadableForCh = (0, _executeLoadable.executeLoadableForChanges)(loadable, m), added = _executeLoadableForCh.added, removed = _executeLoadableForCh.removed;
                Array.from(added.entries()).forEach(function(_ref2) {
                    var _ref3 = _slicedToArray(_ref2, 2), fileName = _ref3[0], fileExports = _ref3[1];
                    return clientApi.facade.addStoriesFromExports(fileName, fileExports);
                });
                Array.from(removed.entries()).forEach(function(_ref4) {
                    var _ref5 = _slicedToArray(_ref4, 1), fileName = _ref5[0];
                    return clientApi.facade.clearFilenameExports(fileName);
                });
                return Object.assign({
                    render: render
                }, clientApi.facade.projectAnnotations, {
                    renderToDOM: renderToDOM,
                    applyDecorators: decorateStory
                });
            };
            if (!initialized) {
                preview.initialize({
                    getStoryIndex: function getStoryIndex() {
                        return clientApi.getStoryIndex();
                    },
                    importFn: importFn,
                    getProjectAnnotations: getProjectAnnotations
                });
                initialized = true;
            } else {
                // TODO -- why don't we care about the new annotations?
                getProjectAnnotations();
                onStoriesChanged();
            }
        }
    };
}

},{"core-js/modules/es.object.to-string.js":"lsA9p","core-js/modules/web.dom-collections.for-each.js":"iYT1M","core-js/modules/es.array.from.js":"9UCQw","core-js/modules/es.string.iterator.js":"74a8v","core-js/modules/es.array.iterator.js":"ieU20","core-js/modules/web.dom-collections.iterator.js":"aXR96","core-js/modules/es.object.assign.js":"8FU8M","core-js/modules/es.symbol.js":"ajw2f","core-js/modules/es.symbol.description.js":"wrlLc","core-js/modules/es.symbol.iterator.js":"fhNIb","core-js/modules/es.array.slice.js":"8RRh9","core-js/modules/es.function.name.js":"4LiLL","core-js/modules/es.regexp.exec.js":"5q56v","global":"5PzlO","util-deprecate":"lYmRJ","@storybook/client-api":"5kgK6","@storybook/preview-web":"d0ORV","@storybook/channel-postmessage":"kWKsA","@storybook/addons":"88cx9","@storybook/core-events":"bJpgo","./executeLoadable":"7YrNK","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"d0ORV":[function(require,module,exports) {
// FIXME: breaks builder-vite, remove this in 7.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "composeConfigs", ()=>(0, _store.composeConfigs));
parcelHelpers.export(exports, "Preview", ()=>(0, _preview.Preview));
parcelHelpers.export(exports, "PreviewWeb", ()=>(0, _previewWeb.PreviewWeb));
parcelHelpers.export(exports, "simulatePageLoad", ()=>(0, _simulatePageload.simulatePageLoad));
parcelHelpers.export(exports, "simulateDOMContentLoaded", ()=>(0, _simulatePageload.simulateDOMContentLoaded));
var _store = require("@storybook/store");
var _preview = require("./Preview");
var _previewWeb = require("./PreviewWeb");
var _simulatePageload = require("./simulate-pageload");
var _types = require("./types");
parcelHelpers.exportAll(_types, exports);

},{"@storybook/store":false,"./Preview":false,"./PreviewWeb":"027l4","./simulate-pageload":false,"./types":false,"@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"7bs7E":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Preview", ()=>Preview);
var _esArraySliceJs = require("core-js/modules/es.array.slice.js");
var _esObjectFreezeJs = require("core-js/modules/es.object.freeze.js");
var _esSymbolJs = require("core-js/modules/es.symbol.js");
var _esSymbolDescriptionJs = require("core-js/modules/es.symbol.description.js");
var _esSymbolIteratorJs = require("core-js/modules/es.symbol.iterator.js");
var _esArrayFromJs = require("core-js/modules/es.array.from.js");
var _esFunctionNameJs = require("core-js/modules/es.function.name.js");
var _esRegexpExecJs = require("core-js/modules/es.regexp.exec.js");
var _esObjectToStringJs = require("core-js/modules/es.object.to-string.js");
var _esPromiseJs = require("core-js/modules/es.promise.js");
var _esArrayIteratorJs = require("core-js/modules/es.array.iterator.js");
var _esStringIteratorJs = require("core-js/modules/es.string.iterator.js");
var _webDomCollectionsIteratorJs = require("core-js/modules/web.dom-collections.iterator.js");
var _esArrayMapJs = require("core-js/modules/es.array.map.js");
var _esArrayFilterJs = require("core-js/modules/es.array.filter.js");
var _esArrayFindJs = require("core-js/modules/es.array.find.js");
var _esSetJs = require("core-js/modules/es.set.js");
var _esArrayConcatJs = require("core-js/modules/es.array.concat.js");
var _esObjectKeysJs = require("core-js/modules/es.object.keys.js");
var _tsDedent = require("ts-dedent");
var _tsDedentDefault = parcelHelpers.interopDefault(_tsDedent);
var _global = require("global");
var _globalDefault = parcelHelpers.interopDefault(_global);
var _synchronousPromise = require("synchronous-promise");
var _coreEvents = require("@storybook/core-events");
var _clientLogger = require("@storybook/client-logger");
var _addons = require("@storybook/addons");
var _store = require("@storybook/store");
var _storyRender = require("./StoryRender");
var _templateObject, _templateObject2;
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) raw = strings.slice(0);
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
var fetch = (0, _globalDefault.default).fetch;
var STORY_INDEX_PATH = "./stories.json";
var Preview = /*#__PURE__*/ function() {
    function Preview() {
        var _global$FEATURES;
        _classCallCheck(this, Preview);
        this.channel = void 0;
        this.serverChannel = void 0;
        this.storyStore = void 0;
        this.getStoryIndex = void 0;
        this.importFn = void 0;
        this.renderToDOM = void 0;
        this.storyRenders = [];
        this.previewEntryError = void 0;
        this.channel = (0, _addons.addons).getChannel();
        if ((_global$FEATURES = (0, _globalDefault.default).FEATURES) !== null && _global$FEATURES !== void 0 && _global$FEATURES.storyStoreV7 && (0, _addons.addons).hasServerChannel()) this.serverChannel = (0, _addons.addons).getServerChannel();
        this.storyStore = new (0, _store.StoryStore)();
    } // INITIALIZATION
    // NOTE: the reason that the preview and store's initialization code is written in a promise
    // style and not `async-await`, and the use of `SynchronousPromise`s is in order to allow
    // storyshots to immediately call `raw()` on the store without waiting for a later tick.
    // (Even simple things like `Promise.resolve()` and `await` involve the callback happening
    // in the next promise "tick").
    // See the comment in `storyshots-core/src/api/index.ts` for more detail.
    _createClass(Preview, [
        {
            key: "initialize",
            value: function initialize(_ref) {
                var _this = this;
                var getStoryIndex = _ref.getStoryIndex, importFn = _ref.importFn, getProjectAnnotations = _ref.getProjectAnnotations;
                // We save these two on initialization in case `getProjectAnnotations` errors,
                // in which case we may need them later when we recover.
                this.getStoryIndex = getStoryIndex;
                this.importFn = importFn;
                this.setupListeners();
                return this.getProjectAnnotationsOrRenderError(getProjectAnnotations).then(function(projectAnnotations) {
                    return _this.initializeWithProjectAnnotations(projectAnnotations);
                });
            }
        },
        {
            key: "setupListeners",
            value: function setupListeners() {
                var _this$serverChannel;
                (_this$serverChannel = this.serverChannel) === null || _this$serverChannel === void 0 || _this$serverChannel.on((0, _coreEvents.STORY_INDEX_INVALIDATED), this.onStoryIndexChanged.bind(this));
                this.channel.on((0, _coreEvents.UPDATE_GLOBALS), this.onUpdateGlobals.bind(this));
                this.channel.on((0, _coreEvents.UPDATE_STORY_ARGS), this.onUpdateArgs.bind(this));
                this.channel.on((0, _coreEvents.RESET_STORY_ARGS), this.onResetArgs.bind(this));
                this.channel.on((0, _coreEvents.FORCE_RE_RENDER), this.onForceReRender.bind(this));
                this.channel.on((0, _coreEvents.FORCE_REMOUNT), this.onForceRemount.bind(this));
            }
        },
        {
            key: "getProjectAnnotationsOrRenderError",
            value: function getProjectAnnotationsOrRenderError(getProjectAnnotations) {
                var _this2 = this;
                return (0, _synchronousPromise.SynchronousPromise).resolve().then(getProjectAnnotations).then(function(projectAnnotations) {
                    _this2.renderToDOM = projectAnnotations.renderToDOM;
                    if (!_this2.renderToDOM) throw new Error((0, _tsDedentDefault.default)(_templateObject || (_templateObject = _taggedTemplateLiteral([
                        "\n            Expected your framework's preset to export a `renderToDOM` field.\n\n            Perhaps it needs to be upgraded for Storybook 6.4?\n\n            More info: https://github.com/storybookjs/storybook/blob/next/MIGRATION.md#mainjs-framework-field          \n          "
                    ], [
                        "\n            Expected your framework's preset to export a \\`renderToDOM\\` field.\n\n            Perhaps it needs to be upgraded for Storybook 6.4?\n\n            More info: https://github.com/storybookjs/storybook/blob/next/MIGRATION.md#mainjs-framework-field          \n          "
                    ]))));
                    return projectAnnotations;
                }).catch(function(err) {
                    // This is an error extracting the projectAnnotations (i.e. evaluating the previewEntries) and
                    // needs to be show to the user as a simple error
                    _this2.renderPreviewEntryError("Error reading preview.js:", err);
                    throw err;
                });
            } // If initialization gets as far as project annotations, this function runs.
        },
        {
            key: "initializeWithProjectAnnotations",
            value: function initializeWithProjectAnnotations(projectAnnotations) {
                var _global$FEATURES2, _this3 = this;
                this.storyStore.setProjectAnnotations(projectAnnotations);
                this.setInitialGlobals();
                var storyIndexPromise;
                if ((_global$FEATURES2 = (0, _globalDefault.default).FEATURES) !== null && _global$FEATURES2 !== void 0 && _global$FEATURES2.storyStoreV7) storyIndexPromise = this.getStoryIndexFromServer();
                else {
                    if (!this.getStoryIndex) throw new Error("No `getStoryIndex` passed defined in v6 mode");
                    storyIndexPromise = (0, _synchronousPromise.SynchronousPromise).resolve().then(this.getStoryIndex);
                }
                return storyIndexPromise.then(function(storyIndex) {
                    return _this3.initializeWithStoryIndex(storyIndex);
                }).catch(function(err) {
                    _this3.renderPreviewEntryError("Error loading story index:", err);
                    throw err;
                });
            }
        },
        {
            key: "setInitialGlobals",
            value: function() {
                var _setInitialGlobals = _asyncToGenerator(/*#__PURE__*/ regeneratorRuntime.mark(function _callee() {
                    return regeneratorRuntime.wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                this.emitGlobals();
                            case 1:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function setInitialGlobals() {
                    return _setInitialGlobals.apply(this, arguments);
                }
                return setInitialGlobals;
            }()
        },
        {
            key: "emitGlobals",
            value: function emitGlobals() {
                this.channel.emit((0, _coreEvents.SET_GLOBALS), {
                    globals: this.storyStore.globals.get() || {},
                    globalTypes: this.storyStore.projectAnnotations.globalTypes || {}
                });
            }
        },
        {
            key: "getStoryIndexFromServer",
            value: function() {
                var _getStoryIndexFromServer = _asyncToGenerator(/*#__PURE__*/ regeneratorRuntime.mark(function _callee2() {
                    var result;
                    return regeneratorRuntime.wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                _context2.next = 2;
                                return fetch(STORY_INDEX_PATH);
                            case 2:
                                result = _context2.sent;
                                if (!(result.status === 200)) {
                                    _context2.next = 5;
                                    break;
                                }
                                return _context2.abrupt("return", result.json());
                            case 5:
                                _context2.t0 = Error;
                                _context2.next = 8;
                                return result.text();
                            case 8:
                                _context2.t1 = _context2.sent;
                                throw new _context2.t0(_context2.t1);
                            case 10:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2);
                }));
                function getStoryIndexFromServer() {
                    return _getStoryIndexFromServer.apply(this, arguments);
                }
                return getStoryIndexFromServer;
            }() // If initialization gets as far as the story index, this function runs.
        },
        {
            key: "initializeWithStoryIndex",
            value: function initializeWithStoryIndex(storyIndex) {
                var _global$FEATURES3;
                return this.storyStore.initialize({
                    storyIndex: storyIndex,
                    importFn: this.importFn,
                    cache: !((_global$FEATURES3 = (0, _globalDefault.default).FEATURES) !== null && _global$FEATURES3 !== void 0 && _global$FEATURES3.storyStoreV7)
                });
            } // EVENT HANDLERS
        },
        {
            key: "onGetProjectAnnotationsChanged",
            value: function() {
                var _onGetProjectAnnotationsChanged = _asyncToGenerator(/*#__PURE__*/ regeneratorRuntime.mark(function _callee3(_ref2) {
                    var getProjectAnnotations, projectAnnotations;
                    return regeneratorRuntime.wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                getProjectAnnotations = _ref2.getProjectAnnotations;
                                delete this.previewEntryError;
                                _context3.next = 4;
                                return this.getProjectAnnotationsOrRenderError(getProjectAnnotations);
                            case 4:
                                projectAnnotations = _context3.sent;
                                if (this.storyStore.projectAnnotations) {
                                    _context3.next = 9;
                                    break;
                                }
                                _context3.next = 8;
                                return this.initializeWithProjectAnnotations(projectAnnotations);
                            case 8:
                                return _context3.abrupt("return");
                            case 9:
                                _context3.next = 11;
                                return this.storyStore.setProjectAnnotations(projectAnnotations);
                            case 11:
                                this.emitGlobals();
                            case 12:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3, this);
                }));
                function onGetProjectAnnotationsChanged(_x) {
                    return _onGetProjectAnnotationsChanged.apply(this, arguments);
                }
                return onGetProjectAnnotationsChanged;
            }()
        },
        {
            key: "onStoryIndexChanged",
            value: function() {
                var _onStoryIndexChanged = _asyncToGenerator(/*#__PURE__*/ regeneratorRuntime.mark(function _callee4() {
                    var storyIndex;
                    return regeneratorRuntime.wrap(function _callee4$(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                delete this.previewEntryError;
                                if (this.storyStore.projectAnnotations) {
                                    _context4.next = 3;
                                    break;
                                }
                                return _context4.abrupt("return");
                            case 3:
                                _context4.prev = 3;
                                _context4.next = 6;
                                return this.getStoryIndexFromServer();
                            case 6:
                                storyIndex = _context4.sent;
                                if (this.storyStore.storyIndex) {
                                    _context4.next = 10;
                                    break;
                                }
                                _context4.next = 10;
                                return this.initializeWithStoryIndex(storyIndex);
                            case 10:
                                _context4.next = 12;
                                return this.onStoriesChanged({
                                    storyIndex: storyIndex
                                });
                            case 12:
                                _context4.next = 18;
                                break;
                            case 14:
                                _context4.prev = 14;
                                _context4.t0 = _context4["catch"](3);
                                this.renderPreviewEntryError("Error loading story index:", _context4.t0);
                                throw _context4.t0;
                            case 18:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4, this, [
                        [
                            3,
                            14
                        ]
                    ]);
                }));
                function onStoryIndexChanged() {
                    return _onStoryIndexChanged.apply(this, arguments);
                }
                return onStoryIndexChanged;
            }() // This happens when a glob gets HMR-ed
        },
        {
            key: "onStoriesChanged",
            value: function() {
                var _onStoriesChanged = _asyncToGenerator(/*#__PURE__*/ regeneratorRuntime.mark(function _callee5(_ref3) {
                    var importFn, storyIndex;
                    return regeneratorRuntime.wrap(function _callee5$(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                importFn = _ref3.importFn, storyIndex = _ref3.storyIndex;
                                _context5.next = 3;
                                return this.storyStore.onStoriesChanged({
                                    importFn: importFn,
                                    storyIndex: storyIndex
                                });
                            case 3:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function onStoriesChanged(_x2) {
                    return _onStoriesChanged.apply(this, arguments);
                }
                return onStoriesChanged;
            }()
        },
        {
            key: "onUpdateGlobals",
            value: function() {
                var _onUpdateGlobals = _asyncToGenerator(/*#__PURE__*/ regeneratorRuntime.mark(function _callee6(_ref4) {
                    var globals;
                    return regeneratorRuntime.wrap(function _callee6$(_context6) {
                        while(true)switch(_context6.prev = _context6.next){
                            case 0:
                                globals = _ref4.globals;
                                this.storyStore.globals.update(globals);
                                _context6.next = 4;
                                return Promise.all(this.storyRenders.map(function(r) {
                                    return r.rerender();
                                }));
                            case 4:
                                this.channel.emit((0, _coreEvents.GLOBALS_UPDATED), {
                                    globals: this.storyStore.globals.get(),
                                    initialGlobals: this.storyStore.globals.initialGlobals
                                });
                            case 5:
                            case "end":
                                return _context6.stop();
                        }
                    }, _callee6, this);
                }));
                function onUpdateGlobals(_x3) {
                    return _onUpdateGlobals.apply(this, arguments);
                }
                return onUpdateGlobals;
            }()
        },
        {
            key: "onUpdateArgs",
            value: function() {
                var _onUpdateArgs = _asyncToGenerator(/*#__PURE__*/ regeneratorRuntime.mark(function _callee7(_ref5) {
                    var storyId, updatedArgs;
                    return regeneratorRuntime.wrap(function _callee7$(_context7) {
                        while(true)switch(_context7.prev = _context7.next){
                            case 0:
                                storyId = _ref5.storyId, updatedArgs = _ref5.updatedArgs;
                                this.storyStore.args.update(storyId, updatedArgs);
                                _context7.next = 4;
                                return Promise.all(this.storyRenders.filter(function(r) {
                                    return r.id === storyId;
                                }).map(function(r) {
                                    return r.rerender();
                                }));
                            case 4:
                                this.channel.emit((0, _coreEvents.STORY_ARGS_UPDATED), {
                                    storyId: storyId,
                                    args: this.storyStore.args.get(storyId)
                                });
                            case 5:
                            case "end":
                                return _context7.stop();
                        }
                    }, _callee7, this);
                }));
                function onUpdateArgs(_x4) {
                    return _onUpdateArgs.apply(this, arguments);
                }
                return onUpdateArgs;
            }()
        },
        {
            key: "onResetArgs",
            value: function() {
                var _onResetArgs = _asyncToGenerator(/*#__PURE__*/ regeneratorRuntime.mark(function _callee8(_ref6) {
                    var storyId, argNames, render, story, argNamesToReset, updatedArgs;
                    return regeneratorRuntime.wrap(function _callee8$(_context8) {
                        while(true)switch(_context8.prev = _context8.next){
                            case 0:
                                storyId = _ref6.storyId, argNames = _ref6.argNames;
                                // NOTE: we have to be careful here and avoid await-ing when updating a rendered's args.
                                // That's because below in `renderStoryToElement` we have also bound to this event and will
                                // render the story in the same tick.
                                // However, we can do that safely as the current story is available in `this.storyRenders`
                                render = this.storyRenders.find(function(r) {
                                    return r.id === storyId;
                                });
                                _context8.t0 = render === null || render === void 0 ? void 0 : render.story;
                                if (_context8.t0) {
                                    _context8.next = 7;
                                    break;
                                }
                                _context8.next = 6;
                                return this.storyStore.loadStory({
                                    storyId: storyId
                                });
                            case 6:
                                _context8.t0 = _context8.sent;
                            case 7:
                                story = _context8.t0;
                                argNamesToReset = argNames || _toConsumableArray(new Set([].concat(_toConsumableArray(Object.keys(story.initialArgs)), _toConsumableArray(Object.keys(this.storyStore.args.get(storyId))))));
                                updatedArgs = argNamesToReset.reduce(function(acc, argName) {
                                    acc[argName] = story.initialArgs[argName];
                                    return acc;
                                }, {});
                                _context8.next = 12;
                                return this.onUpdateArgs({
                                    storyId: storyId,
                                    updatedArgs: updatedArgs
                                });
                            case 12:
                            case "end":
                                return _context8.stop();
                        }
                    }, _callee8, this);
                }));
                function onResetArgs(_x5) {
                    return _onResetArgs.apply(this, arguments);
                }
                return onResetArgs;
            }() // ForceReRender does not include a story id, so we simply must
        },
        {
            key: "onForceReRender",
            value: function() {
                var _onForceReRender = _asyncToGenerator(/*#__PURE__*/ regeneratorRuntime.mark(function _callee9() {
                    return regeneratorRuntime.wrap(function _callee9$(_context9) {
                        while(true)switch(_context9.prev = _context9.next){
                            case 0:
                                _context9.next = 2;
                                return Promise.all(this.storyRenders.map(function(r) {
                                    return r.rerender();
                                }));
                            case 2:
                            case "end":
                                return _context9.stop();
                        }
                    }, _callee9, this);
                }));
                function onForceReRender() {
                    return _onForceReRender.apply(this, arguments);
                }
                return onForceReRender;
            }()
        },
        {
            key: "onForceRemount",
            value: function() {
                var _onForceRemount = _asyncToGenerator(/*#__PURE__*/ regeneratorRuntime.mark(function _callee10(_ref7) {
                    var storyId;
                    return regeneratorRuntime.wrap(function _callee10$(_context10) {
                        while(true)switch(_context10.prev = _context10.next){
                            case 0:
                                storyId = _ref7.storyId;
                                _context10.next = 3;
                                return Promise.all(this.storyRenders.filter(function(r) {
                                    return r.id === storyId;
                                }).map(function(r) {
                                    return r.remount();
                                }));
                            case 3:
                            case "end":
                                return _context10.stop();
                        }
                    }, _callee10, this);
                }));
                function onForceRemount(_x6) {
                    return _onForceRemount.apply(this, arguments);
                }
                return onForceRemount;
            }() // Used by docs' modernInlineRender to render a story to a given element
        },
        {
            key: "renderStoryToElement",
            value: function renderStoryToElement(story, element) {
                var _this4 = this;
                var render = new (0, _storyRender.StoryRender)(this.channel, this.storyStore, this.renderToDOM, this.inlineStoryCallbacks(story.id), story.id, "docs", story);
                render.renderToElement(element);
                this.storyRenders.push(render);
                return /*#__PURE__*/ _asyncToGenerator(/*#__PURE__*/ regeneratorRuntime.mark(function _callee11() {
                    return regeneratorRuntime.wrap(function _callee11$(_context11) {
                        while(true)switch(_context11.prev = _context11.next){
                            case 0:
                                _context11.next = 2;
                                return _this4.teardownRender(render);
                            case 2:
                            case "end":
                                return _context11.stop();
                        }
                    }, _callee11);
                }));
            }
        },
        {
            key: "teardownRender",
            value: function() {
                var _teardownRender = _asyncToGenerator(/*#__PURE__*/ regeneratorRuntime.mark(function _callee12(render) {
                    var _ref9, viewModeChanged, _args12 = arguments;
                    return regeneratorRuntime.wrap(function _callee12$(_context12) {
                        while(true)switch(_context12.prev = _context12.next){
                            case 0:
                                _ref9 = _args12.length > 1 && _args12[1] !== undefined ? _args12[1] : {}, viewModeChanged = _ref9.viewModeChanged;
                                this.storyRenders = this.storyRenders.filter(function(r) {
                                    return r !== render;
                                });
                                _context12.next = 4;
                                return render === null || render === void 0 ? void 0 : render.teardown({
                                    viewModeChanged: viewModeChanged
                                });
                            case 4:
                            case "end":
                                return _context12.stop();
                        }
                    }, _callee12, this);
                }));
                function teardownRender(_x7) {
                    return _teardownRender.apply(this, arguments);
                }
                return teardownRender;
            }() // API
        },
        {
            key: "extract",
            value: function() {
                var _extract = _asyncToGenerator(/*#__PURE__*/ regeneratorRuntime.mark(function _callee13(options) {
                    var _global$FEATURES4;
                    return regeneratorRuntime.wrap(function _callee13$(_context13) {
                        while(true)switch(_context13.prev = _context13.next){
                            case 0:
                                if (!this.previewEntryError) {
                                    _context13.next = 2;
                                    break;
                                }
                                throw this.previewEntryError;
                            case 2:
                                if (this.storyStore.projectAnnotations) {
                                    _context13.next = 4;
                                    break;
                                }
                                throw new Error((0, _tsDedentDefault.default)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral([
                                    "Failed to initialize Storybook.\n      \n      Do you have an error in your `preview.js`? Check your Storybook's browser console for errors."
                                ], [
                                    "Failed to initialize Storybook.\n      \n      Do you have an error in your \\`preview.js\\`? Check your Storybook's browser console for errors."
                                ]))));
                            case 4:
                                if (!((_global$FEATURES4 = (0, _globalDefault.default).FEATURES) !== null && _global$FEATURES4 !== void 0 && _global$FEATURES4.storyStoreV7)) {
                                    _context13.next = 7;
                                    break;
                                }
                                _context13.next = 7;
                                return this.storyStore.cacheAllCSFFiles();
                            case 7:
                                return _context13.abrupt("return", this.storyStore.extract(options));
                            case 8:
                            case "end":
                                return _context13.stop();
                        }
                    }, _callee13, this);
                }));
                function extract(_x8) {
                    return _extract.apply(this, arguments);
                }
                return extract;
            }() // UTILITIES
        },
        {
            key: "inlineStoryCallbacks",
            value: function inlineStoryCallbacks(storyId) {
                return {
                    showMain: function showMain() {},
                    showError: function showError(err) {
                        return (0, _clientLogger.logger).error("Error rendering docs story (".concat(storyId, ")"), err);
                    },
                    showException: function showException(err) {
                        return (0, _clientLogger.logger).error("Error rendering docs story (".concat(storyId, ")"), err);
                    }
                };
            }
        },
        {
            key: "renderPreviewEntryError",
            value: function renderPreviewEntryError(reason, err) {
                this.previewEntryError = err;
                (0, _clientLogger.logger).error(reason);
                (0, _clientLogger.logger).error(err);
                this.channel.emit((0, _coreEvents.CONFIG_ERROR), err);
            }
        }
    ]);
    return Preview;
}();

},{"core-js/modules/es.array.slice.js":"8RRh9","core-js/modules/es.object.freeze.js":"9LVYO","core-js/modules/es.symbol.js":"ajw2f","core-js/modules/es.symbol.description.js":"wrlLc","core-js/modules/es.symbol.iterator.js":"fhNIb","core-js/modules/es.array.from.js":"9UCQw","core-js/modules/es.function.name.js":"4LiLL","core-js/modules/es.regexp.exec.js":"5q56v","core-js/modules/es.object.to-string.js":"lsA9p","core-js/modules/es.promise.js":"2jax7","core-js/modules/es.array.iterator.js":"ieU20","core-js/modules/es.string.iterator.js":"74a8v","core-js/modules/web.dom-collections.iterator.js":"aXR96","core-js/modules/es.array.map.js":"jTP7e","core-js/modules/es.array.filter.js":"fD2da","core-js/modules/es.array.find.js":"hWBPu","core-js/modules/es.set.js":"6FW6g","core-js/modules/es.array.concat.js":"g1t7q","core-js/modules/es.object.keys.js":"5Q2AT","ts-dedent":"9RvVa","global":"5PzlO","synchronous-promise":"dbZce","@storybook/core-events":"bJpgo","@storybook/client-logger":"iGRus","@storybook/addons":"88cx9","@storybook/store":"26Xer","./StoryRender":"4LYsN","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"4LYsN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PREPARE_ABORTED", ()=>PREPARE_ABORTED);
parcelHelpers.export(exports, "StoryRender", ()=>StoryRender);
var _esArrayIncludesJs = require("core-js/modules/es.array.includes.js");
var _esFunctionNameJs = require("core-js/modules/es.function.name.js");
var _esObjectAssignJs = require("core-js/modules/es.object.assign.js");
var _esObjectToStringJs = require("core-js/modules/es.object.to-string.js");
var _esPromiseJs = require("core-js/modules/es.promise.js");
var _global = require("global");
var _globalDefault = parcelHelpers.interopDefault(_global);
var _coreEvents = require("@storybook/core-events");
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
var AbortController = (0, _globalDefault.default).AbortController;
function createController() {
    if (AbortController) return new AbortController(); // Polyfill for IE11
    return {
        signal: {
            aborted: false
        },
        abort: function abort() {
            this.signal.aborted = true;
        }
    };
}
var PREPARE_ABORTED = new Error("prepareAborted");
var StoryRender = /*#__PURE__*/ function() {
    function StoryRender(channel, store, renderToScreen, callbacks, id, viewMode, story) {
        _classCallCheck(this, StoryRender);
        this.channel = channel;
        this.store = store;
        this.renderToScreen = renderToScreen;
        this.callbacks = callbacks;
        this.id = id;
        this.viewMode = viewMode;
        this.story = void 0;
        this.phase = void 0;
        this.abortController = void 0;
        this.canvasElement = void 0;
        this.notYetRendered = true;
        this.disableKeyListeners = false;
        this.abortController = createController(); // Allow short-circuiting preparing if we happen to already
        // have the story (this is used by docs mode)
        if (story) {
            this.story = story; // TODO -- what should the phase be now?
            // TODO -- should we emit the render phase changed event?
            this.phase = "preparing";
        }
    }
    _createClass(StoryRender, [
        {
            key: "runPhase",
            value: function() {
                var _runPhase = _asyncToGenerator(/*#__PURE__*/ regeneratorRuntime.mark(function _callee(signal, phase, phaseFn) {
                    return regeneratorRuntime.wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                this.phase = phase;
                                this.channel.emit((0, _coreEvents.STORY_RENDER_PHASE_CHANGED), {
                                    newPhase: this.phase,
                                    storyId: this.id
                                });
                                if (!phaseFn) {
                                    _context.next = 5;
                                    break;
                                }
                                _context.next = 5;
                                return phaseFn();
                            case 5:
                                if (signal.aborted) {
                                    this.phase = "aborted";
                                    this.channel.emit((0, _coreEvents.STORY_RENDER_PHASE_CHANGED), {
                                        newPhase: this.phase,
                                        storyId: this.id
                                    });
                                }
                            case 6:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function runPhase(_x, _x2, _x3) {
                    return _runPhase.apply(this, arguments);
                }
                return runPhase;
            }()
        },
        {
            key: "prepare",
            value: function() {
                var _prepare = _asyncToGenerator(/*#__PURE__*/ regeneratorRuntime.mark(function _callee3() {
                    var _this = this;
                    return regeneratorRuntime.wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                _context3.next = 2;
                                return this.runPhase(this.abortController.signal, "preparing", /*#__PURE__*/ _asyncToGenerator(/*#__PURE__*/ regeneratorRuntime.mark(function _callee2() {
                                    return regeneratorRuntime.wrap(function _callee2$(_context2) {
                                        while(true)switch(_context2.prev = _context2.next){
                                            case 0:
                                                _context2.next = 2;
                                                return _this.store.loadStory({
                                                    storyId: _this.id
                                                });
                                            case 2:
                                                _this.story = _context2.sent;
                                            case 3:
                                            case "end":
                                                return _context2.stop();
                                        }
                                    }, _callee2);
                                })));
                            case 2:
                                if (!this.abortController.signal.aborted) {
                                    _context3.next = 5;
                                    break;
                                }
                                this.store.cleanupStory(this.story);
                                throw PREPARE_ABORTED;
                            case 5:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3, this);
                }));
                function prepare() {
                    return _prepare.apply(this, arguments);
                }
                return prepare;
            }() // The two story "renders" are equal and have both loaded the same story
        },
        {
            key: "isEqual",
            value: function isEqual(other) {
                return other && this.id === other.id && this.story && this.story === other.story;
            }
        },
        {
            key: "isPreparing",
            value: function isPreparing() {
                return [
                    "preparing"
                ].includes(this.phase);
            }
        },
        {
            key: "isPending",
            value: function isPending() {
                return [
                    "rendering",
                    "playing"
                ].includes(this.phase);
            }
        },
        {
            key: "context",
            value: function context() {
                return this.store.getStoryContext(this.story);
            }
        },
        {
            key: "renderToElement",
            value: function() {
                var _renderToElement = _asyncToGenerator(/*#__PURE__*/ regeneratorRuntime.mark(function _callee4(canvasElement) {
                    return regeneratorRuntime.wrap(function _callee4$(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                this.canvasElement = canvasElement; // FIXME: this comment
                                // Start the first (initial) render. We don't await here because we need to return the "cleanup"
                                // function below right away, so if the user changes story during the first render we can cancel
                                // it without having to first wait for it to finish.
                                // Whenever the selection changes we want to force the component to be remounted.
                                return _context4.abrupt("return", this.render({
                                    initial: true,
                                    forceRemount: true
                                }));
                            case 2:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4, this);
                }));
                function renderToElement(_x4) {
                    return _renderToElement.apply(this, arguments);
                }
                return renderToElement;
            }()
        },
        {
            key: "render",
            value: function() {
                var _render = _asyncToGenerator(/*#__PURE__*/ regeneratorRuntime.mark(function _callee9() {
                    var _this2 = this;
                    var _ref2, _ref2$initial, initial, _ref2$forceRemount, forceRemount, _this$story, id, componentId, title, name, applyLoaders, unboundStoryFn, playFunction, abortSignal, loadedContext, renderStoryContext, _renderContext, _args9 = arguments;
                    return regeneratorRuntime.wrap(function _callee9$(_context9) {
                        while(true)switch(_context9.prev = _context9.next){
                            case 0:
                                _ref2 = _args9.length > 0 && _args9[0] !== undefined ? _args9[0] : {}, _ref2$initial = _ref2.initial, initial = _ref2$initial === void 0 ? false : _ref2$initial, _ref2$forceRemount = _ref2.forceRemount, forceRemount = _ref2$forceRemount === void 0 ? false : _ref2$forceRemount;
                                if (this.story) {
                                    _context9.next = 3;
                                    break;
                                }
                                throw new Error("cannot render when not prepared");
                            case 3:
                                _this$story = this.story, id = _this$story.id, componentId = _this$story.componentId, title = _this$story.title, name = _this$story.name, applyLoaders = _this$story.applyLoaders, unboundStoryFn = _this$story.unboundStoryFn, playFunction = _this$story.playFunction;
                                if (forceRemount && !initial) {
                                    // NOTE: we don't check the cancel actually worked here, so the previous
                                    // render could conceivably still be running after this call.
                                    // We might want to change that in the future.
                                    this.cancelRender();
                                    this.abortController = createController();
                                } // We need a stable reference to the signal -- if a re-mount happens the
                                // abort controller may be torn down (above) before we actually check the signal.
                                abortSignal = this.abortController.signal;
                                _context9.prev = 6;
                                _context9.next = 9;
                                return this.runPhase(abortSignal, "loading", /*#__PURE__*/ _asyncToGenerator(/*#__PURE__*/ regeneratorRuntime.mark(function _callee5() {
                                    return regeneratorRuntime.wrap(function _callee5$(_context5) {
                                        while(true)switch(_context5.prev = _context5.next){
                                            case 0:
                                                _context5.next = 2;
                                                return applyLoaders(Object.assign({}, _this2.context(), {
                                                    viewMode: _this2.viewMode
                                                }));
                                            case 2:
                                                loadedContext = _context5.sent;
                                            case 3:
                                            case "end":
                                                return _context5.stop();
                                        }
                                    }, _callee5);
                                })));
                            case 9:
                                if (!abortSignal.aborted) {
                                    _context9.next = 11;
                                    break;
                                }
                                return _context9.abrupt("return");
                            case 11:
                                renderStoryContext = Object.assign({}, loadedContext, this.context(), {
                                    abortSignal: abortSignal,
                                    canvasElement: this.canvasElement
                                });
                                _renderContext = Object.assign({
                                    componentId: componentId,
                                    title: title,
                                    kind: title,
                                    id: id,
                                    name: name,
                                    story: name
                                }, this.callbacks, {
                                    forceRemount: forceRemount || this.notYetRendered,
                                    storyContext: renderStoryContext,
                                    storyFn: function storyFn() {
                                        return unboundStoryFn(renderStoryContext);
                                    },
                                    unboundStoryFn: unboundStoryFn
                                });
                                _context9.next = 15;
                                return this.runPhase(abortSignal, "rendering", /*#__PURE__*/ _asyncToGenerator(/*#__PURE__*/ regeneratorRuntime.mark(function _callee6() {
                                    return regeneratorRuntime.wrap(function _callee6$(_context6) {
                                        while(true)switch(_context6.prev = _context6.next){
                                            case 0:
                                                return _context6.abrupt("return", _this2.renderToScreen(_renderContext, _this2.canvasElement));
                                            case 1:
                                            case "end":
                                                return _context6.stop();
                                        }
                                    }, _callee6);
                                })));
                            case 15:
                                this.notYetRendered = false;
                                if (!abortSignal.aborted) {
                                    _context9.next = 18;
                                    break;
                                }
                                return _context9.abrupt("return");
                            case 18:
                                if (!(forceRemount && playFunction)) {
                                    _context9.next = 27;
                                    break;
                                }
                                this.disableKeyListeners = true;
                                _context9.next = 22;
                                return this.runPhase(abortSignal, "playing", /*#__PURE__*/ _asyncToGenerator(/*#__PURE__*/ regeneratorRuntime.mark(function _callee7() {
                                    return regeneratorRuntime.wrap(function _callee7$(_context7) {
                                        while(true)switch(_context7.prev = _context7.next){
                                            case 0:
                                                return _context7.abrupt("return", playFunction(_renderContext.storyContext));
                                            case 1:
                                            case "end":
                                                return _context7.stop();
                                        }
                                    }, _callee7);
                                })));
                            case 22:
                                _context9.next = 24;
                                return this.runPhase(abortSignal, "played");
                            case 24:
                                this.disableKeyListeners = false;
                                if (!abortSignal.aborted) {
                                    _context9.next = 27;
                                    break;
                                }
                                return _context9.abrupt("return");
                            case 27:
                                _context9.next = 29;
                                return this.runPhase(abortSignal, "completed", /*#__PURE__*/ _asyncToGenerator(/*#__PURE__*/ regeneratorRuntime.mark(function _callee8() {
                                    return regeneratorRuntime.wrap(function _callee8$(_context8) {
                                        while(true)switch(_context8.prev = _context8.next){
                                            case 0:
                                                return _context8.abrupt("return", _this2.channel.emit((0, _coreEvents.STORY_RENDERED), id));
                                            case 1:
                                            case "end":
                                                return _context8.stop();
                                        }
                                    }, _callee8);
                                })));
                            case 29:
                                _context9.next = 34;
                                break;
                            case 31:
                                _context9.prev = 31;
                                _context9.t0 = _context9["catch"](6);
                                this.callbacks.showException(_context9.t0);
                            case 34:
                            case "end":
                                return _context9.stop();
                        }
                    }, _callee9, this, [
                        [
                            6,
                            31
                        ]
                    ]);
                }));
                function render() {
                    return _render.apply(this, arguments);
                }
                return render;
            }()
        },
        {
            key: "rerender",
            value: function() {
                var _rerender = _asyncToGenerator(/*#__PURE__*/ regeneratorRuntime.mark(function _callee10() {
                    return regeneratorRuntime.wrap(function _callee10$(_context10) {
                        while(true)switch(_context10.prev = _context10.next){
                            case 0:
                                return _context10.abrupt("return", this.render());
                            case 1:
                            case "end":
                                return _context10.stop();
                        }
                    }, _callee10, this);
                }));
                function rerender() {
                    return _rerender.apply(this, arguments);
                }
                return rerender;
            }()
        },
        {
            key: "remount",
            value: function() {
                var _remount = _asyncToGenerator(/*#__PURE__*/ regeneratorRuntime.mark(function _callee11() {
                    return regeneratorRuntime.wrap(function _callee11$(_context11) {
                        while(true)switch(_context11.prev = _context11.next){
                            case 0:
                                return _context11.abrupt("return", this.render({
                                    forceRemount: true
                                }));
                            case 1:
                            case "end":
                                return _context11.stop();
                        }
                    }, _callee11, this);
                }));
                function remount() {
                    return _remount.apply(this, arguments);
                }
                return remount;
            }() // If the story is torn down (either a new story is rendered or the docs page removes it)
        },
        {
            key: "cancelRender",
            value: function cancelRender() {
                this.abortController.abort();
            }
        },
        {
            key: "teardown",
            value: function() {
                var _teardown = _asyncToGenerator(/*#__PURE__*/ regeneratorRuntime.mark(function _callee12() {
                    var options, i, _args12 = arguments;
                    return regeneratorRuntime.wrap(function _callee12$(_context12) {
                        while(true)switch(_context12.prev = _context12.next){
                            case 0:
                                options = _args12.length > 0 && _args12[0] !== undefined ? _args12[0] : {};
                                this.cancelRender(); // If the story has loaded, we need to cleanup
                                if (this.story) this.store.cleanupStory(this.story); // Check if we're done rendering/playing. If not, we may have to reload the page.
                                // Wait several ticks that may be needed to handle the abort, then try again.
                                // Note that there's a max of 5 nested timeouts before they're no longer "instant".
                                i = 0;
                            case 4:
                                if (!(i < 3)) {
                                    _context12.next = 12;
                                    break;
                                }
                                if (this.isPending()) {
                                    _context12.next = 7;
                                    break;
                                }
                                return _context12.abrupt("return");
                            case 7:
                                _context12.next = 9;
                                return new Promise(function(resolve) {
                                    return setTimeout(resolve, 0);
                                });
                            case 9:
                                i += 1;
                                _context12.next = 4;
                                break;
                            case 12:
                                // If we still haven't completed, reload the page (iframe) to ensure we have a clean slate
                                // for the next render. Since the reload can take a brief moment to happen, we want to stop
                                // further rendering by awaiting a never-resolving promise (which is destroyed on reload).
                                (0, _globalDefault.default).window.location.reload();
                                _context12.next = 15;
                                return new Promise(function() {});
                            case 15:
                            case "end":
                                return _context12.stop();
                        }
                    }, _callee12, this);
                }));
                function teardown() {
                    return _teardown.apply(this, arguments);
                }
                return teardown;
            }()
        }
    ]);
    return StoryRender;
}();
StoryRender.displayName = "StoryRender";

},{"core-js/modules/es.array.includes.js":"dbUjS","core-js/modules/es.function.name.js":"4LiLL","core-js/modules/es.object.assign.js":"8FU8M","core-js/modules/es.object.to-string.js":"lsA9p","core-js/modules/es.promise.js":"2jax7","global":"5PzlO","@storybook/core-events":"bJpgo","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"027l4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PreviewWeb", ()=>PreviewWeb);
var _esObjectGetPrototypeOfJs = require("core-js/modules/es.object.get-prototype-of.js");
var _esReflectConstructJs = require("core-js/modules/es.reflect.construct.js");
var _esReflectGetJs = require("core-js/modules/es.reflect.get.js");
var _esObjectGetOwnPropertyDescriptorJs = require("core-js/modules/es.object.get-own-property-descriptor.js");
var _esArraySliceJs = require("core-js/modules/es.array.slice.js");
var _esObjectFreezeJs = require("core-js/modules/es.object.freeze.js");
var _esSymbolIteratorJs = require("core-js/modules/es.symbol.iterator.js");
var _esRegexpExecJs = require("core-js/modules/es.regexp.exec.js");
var _esObjectAssignJs = require("core-js/modules/es.object.assign.js");
var _esArrayIteratorJs = require("core-js/modules/es.array.iterator.js");
var _esObjectToStringJs = require("core-js/modules/es.object.to-string.js");
var _esPromiseJs = require("core-js/modules/es.promise.js");
var _esStringIteratorJs = require("core-js/modules/es.string.iterator.js");
var _webDomCollectionsIteratorJs = require("core-js/modules/web.dom-collections.iterator.js");
var _esArrayMapJs = require("core-js/modules/es.array.map.js");
var _esArrayFilterJs = require("core-js/modules/es.array.filter.js");
var _esSymbolJs = require("core-js/modules/es.symbol.js");
var _esSymbolDescriptionJs = require("core-js/modules/es.symbol.description.js");
var _esArrayConcatJs = require("core-js/modules/es.array.concat.js");
var _utilDeprecate = require("util-deprecate");
var _utilDeprecateDefault = parcelHelpers.interopDefault(_utilDeprecate);
var _tsDedent = require("ts-dedent");
var _tsDedentDefault = parcelHelpers.interopDefault(_tsDedent);
var _global = require("global");
var _globalDefault = parcelHelpers.interopDefault(_global);
var _coreEvents = require("@storybook/core-events");
var _clientLogger = require("@storybook/client-logger");
var _preview = require("./Preview");
var _urlStore = require("./UrlStore");
var _webView = require("./WebView");
var _storyRender = require("./StoryRender");
var _docsRender = require("./DocsRender");
function _typeof(obj) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
}
var _templateObject, _templateObject2, _templateObject3, _templateObject4;
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) raw = strings.slice(0);
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function _get() {
    if (typeof Reflect !== "undefined" && Reflect.get) _get = Reflect.get;
    else _get = function _get(target, property, receiver) {
        var base = _superPropBase(target, property);
        if (!base) return;
        var desc = Object.getOwnPropertyDescriptor(base, property);
        if (desc.get) return desc.get.call(arguments.length < 3 ? target : receiver);
        return desc.value;
    };
    return _get.apply(this, arguments);
}
function _superPropBase(object, property) {
    while(!Object.prototype.hasOwnProperty.call(object, property)){
        object = _getPrototypeOf(object);
        if (object === null) break;
    }
    return object;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return _possibleConstructorReturn(this, result);
    };
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
var globalWindow = (0, _globalDefault.default).window;
function focusInInput(event) {
    var target = event.target;
    return /input|textarea/i.test(target.tagName) || target.getAttribute("contenteditable") !== null;
}
var PreviewWeb = /*#__PURE__*/ function(_Preview) {
    _inherits(PreviewWeb, _Preview);
    var _super = _createSuper(PreviewWeb);
    function PreviewWeb() {
        var _this;
        _classCallCheck(this, PreviewWeb);
        _this = _super.call(this);
        _this.urlStore = void 0;
        _this.view = void 0;
        _this.previewEntryError = void 0;
        _this.currentSelection = void 0;
        _this.currentRender = void 0;
        _this.view = new (0, _webView.WebView)();
        _this.urlStore = new (0, _urlStore.UrlStore)(); // Add deprecated APIs for back-compat
        // @ts-ignore
        _this.storyStore.getSelection = (0, _utilDeprecateDefault.default)(function() {
            return _this.urlStore.selection;
        }, (0, _tsDedentDefault.default)(_templateObject || (_templateObject = _taggedTemplateLiteral([
            "\n        `__STORYBOOK_STORY_STORE__.getSelection()` is deprecated and will be removed in 7.0.\n  \n        To get the current selection, use the `useStoryContext()` hook from `@storybook/addons`.\n      "
        ], [
            "\n        \\`__STORYBOOK_STORY_STORE__.getSelection()\\` is deprecated and will be removed in 7.0.\n  \n        To get the current selection, use the \\`useStoryContext()\\` hook from \\`@storybook/addons\\`.\n      "
        ]))));
        return _this;
    }
    _createClass(PreviewWeb, [
        {
            key: "setupListeners",
            value: function setupListeners() {
                _get(_getPrototypeOf(PreviewWeb.prototype), "setupListeners", this).call(this);
                globalWindow.onkeydown = this.onKeydown.bind(this);
                this.channel.on((0, _coreEvents.SET_CURRENT_STORY), this.onSetCurrentStory.bind(this));
                this.channel.on((0, _coreEvents.UPDATE_QUERY_PARAMS), this.onUpdateQueryParams.bind(this));
                this.channel.on((0, _coreEvents.PRELOAD_STORIES), this.onPreloadStories.bind(this));
            }
        },
        {
            key: "initializeWithProjectAnnotations",
            value: function initializeWithProjectAnnotations(projectAnnotations) {
                var _this2 = this;
                return _get(_getPrototypeOf(PreviewWeb.prototype), "initializeWithProjectAnnotations", this).call(this, projectAnnotations).then(function() {
                    return _this2.setInitialGlobals();
                });
            }
        },
        {
            key: "setInitialGlobals",
            value: function() {
                var _setInitialGlobals = _asyncToGenerator(/*#__PURE__*/ regeneratorRuntime.mark(function _callee() {
                    var _ref, globals;
                    return regeneratorRuntime.wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                _ref = this.urlStore.selectionSpecifier || {}, globals = _ref.globals;
                                if (globals) this.storyStore.globals.updateFromPersisted(globals);
                                this.emitGlobals();
                            case 3:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function setInitialGlobals() {
                    return _setInitialGlobals.apply(this, arguments);
                }
                return setInitialGlobals;
            }() // If initialization gets as far as the story index, this function runs.
        },
        {
            key: "initializeWithStoryIndex",
            value: function initializeWithStoryIndex(storyIndex) {
                var _this3 = this;
                return _get(_getPrototypeOf(PreviewWeb.prototype), "initializeWithStoryIndex", this).call(this, storyIndex).then(function() {
                    var _global$FEATURES;
                    if (!((_global$FEATURES = (0, _globalDefault.default).FEATURES) !== null && _global$FEATURES !== void 0 && _global$FEATURES.storyStoreV7)) _this3.channel.emit((0, _coreEvents.SET_STORIES), _this3.storyStore.getSetStoriesPayload());
                    return _this3.selectSpecifiedStory();
                });
            } // Use the selection specifier to choose a story, then render it
        },
        {
            key: "selectSpecifiedStory",
            value: function() {
                var _selectSpecifiedStory = _asyncToGenerator(/*#__PURE__*/ regeneratorRuntime.mark(function _callee2() {
                    var _this$urlStore$select, storySpecifier, viewMode, args, storyId;
                    return regeneratorRuntime.wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                if (this.urlStore.selectionSpecifier) {
                                    _context2.next = 3;
                                    break;
                                }
                                this.renderMissingStory();
                                return _context2.abrupt("return");
                            case 3:
                                _this$urlStore$select = this.urlStore.selectionSpecifier, storySpecifier = _this$urlStore$select.storySpecifier, viewMode = _this$urlStore$select.viewMode, args = _this$urlStore$select.args;
                                storyId = this.storyStore.storyIndex.storyIdFromSpecifier(storySpecifier);
                                if (storyId) {
                                    _context2.next = 8;
                                    break;
                                }
                                if (storySpecifier === "*") this.renderStoryLoadingException(storySpecifier, new Error((0, _tsDedentDefault.default)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral([
                                    "\n            Couldn't find any stories in your Storybook.\n            - Please check your stories field of your main.js config.\n            - Also check the browser console and terminal for error messages.\n          "
                                ])))));
                                else this.renderStoryLoadingException(storySpecifier, new Error((0, _tsDedentDefault.default)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral([
                                    "\n            Couldn't find story matching '",
                                    "'.\n            - Are you sure a story with that id exists?\n            - Please check your stories field of your main.js config.\n            - Also check the browser console and terminal for error messages.\n          "
                                ])), storySpecifier)));
                                return _context2.abrupt("return");
                            case 8:
                                this.urlStore.setSelection({
                                    storyId: storyId,
                                    viewMode: viewMode
                                });
                                this.channel.emit((0, _coreEvents.STORY_SPECIFIED), this.urlStore.selection);
                                this.channel.emit((0, _coreEvents.CURRENT_STORY_WAS_SET), this.urlStore.selection);
                                _context2.next = 13;
                                return this.renderSelection({
                                    persistedArgs: args
                                });
                            case 13:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function selectSpecifiedStory() {
                    return _selectSpecifiedStory.apply(this, arguments);
                }
                return selectSpecifiedStory;
            }() // EVENT HANDLERS
        },
        {
            key: "onGetProjectAnnotationsChanged",
            value: function() {
                var _onGetProjectAnnotationsChanged = _asyncToGenerator(/*#__PURE__*/ regeneratorRuntime.mark(function _callee3(_ref2) {
                    var getProjectAnnotations;
                    return regeneratorRuntime.wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                getProjectAnnotations = _ref2.getProjectAnnotations;
                                _context3.next = 3;
                                return _get(_getPrototypeOf(PreviewWeb.prototype), "onGetProjectAnnotationsChanged", this).call(this, {
                                    getProjectAnnotations: getProjectAnnotations
                                });
                            case 3:
                                this.renderSelection();
                            case 4:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3, this);
                }));
                function onGetProjectAnnotationsChanged(_x) {
                    return _onGetProjectAnnotationsChanged.apply(this, arguments);
                }
                return onGetProjectAnnotationsChanged;
            }() // This happens when a glob gets HMR-ed
        },
        {
            key: "onStoriesChanged",
            value: function() {
                var _onStoriesChanged = _asyncToGenerator(/*#__PURE__*/ regeneratorRuntime.mark(function _callee4(_ref3) {
                    var _global$FEATURES2;
                    var importFn, storyIndex;
                    return regeneratorRuntime.wrap(function _callee4$(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                importFn = _ref3.importFn, storyIndex = _ref3.storyIndex;
                                _get(_getPrototypeOf(PreviewWeb.prototype), "onStoriesChanged", this).call(this, {
                                    importFn: importFn,
                                    storyIndex: storyIndex
                                });
                                if ((_global$FEATURES2 = (0, _globalDefault.default).FEATURES) !== null && _global$FEATURES2 !== void 0 && _global$FEATURES2.storyStoreV7) {
                                    _context4.next = 9;
                                    break;
                                }
                                _context4.t0 = this.channel;
                                _context4.t1 = (0, _coreEvents.SET_STORIES);
                                _context4.next = 7;
                                return this.storyStore.getSetStoriesPayload();
                            case 7:
                                _context4.t2 = _context4.sent;
                                _context4.t0.emit.call(_context4.t0, _context4.t1, _context4.t2);
                            case 9:
                                if (!this.urlStore.selection) {
                                    _context4.next = 14;
                                    break;
                                }
                                _context4.next = 12;
                                return this.renderSelection();
                            case 12:
                                _context4.next = 16;
                                break;
                            case 14:
                                _context4.next = 16;
                                return this.selectSpecifiedStory();
                            case 16:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4, this);
                }));
                function onStoriesChanged(_x2) {
                    return _onStoriesChanged.apply(this, arguments);
                }
                return onStoriesChanged;
            }()
        },
        {
            key: "onKeydown",
            value: function onKeydown(event) {
                var _this$currentRender;
                if (!((_this$currentRender = this.currentRender) !== null && _this$currentRender !== void 0 && _this$currentRender.disableKeyListeners) && !focusInInput(event)) {
                    // We have to pick off the keys of the event that we need on the other side
                    var altKey = event.altKey, ctrlKey = event.ctrlKey, metaKey = event.metaKey, shiftKey = event.shiftKey, key = event.key, code = event.code, keyCode = event.keyCode;
                    this.channel.emit((0, _coreEvents.PREVIEW_KEYDOWN), {
                        event: {
                            altKey: altKey,
                            ctrlKey: ctrlKey,
                            metaKey: metaKey,
                            shiftKey: shiftKey,
                            key: key,
                            code: code,
                            keyCode: keyCode
                        }
                    });
                }
            }
        },
        {
            key: "onSetCurrentStory",
            value: function onSetCurrentStory(selection) {
                this.urlStore.setSelection(Object.assign({
                    viewMode: "story"
                }, selection));
                this.channel.emit((0, _coreEvents.CURRENT_STORY_WAS_SET), this.urlStore.selection);
                this.renderSelection();
            }
        },
        {
            key: "onUpdateQueryParams",
            value: function onUpdateQueryParams(queryParams) {
                this.urlStore.setQueryParams(queryParams);
            }
        },
        {
            key: "onUpdateGlobals",
            value: function() {
                var _onUpdateGlobals = _asyncToGenerator(/*#__PURE__*/ regeneratorRuntime.mark(function _callee5(_ref4) {
                    var globals;
                    return regeneratorRuntime.wrap(function _callee5$(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                globals = _ref4.globals;
                                _get(_getPrototypeOf(PreviewWeb.prototype), "onUpdateGlobals", this).call(this, {
                                    globals: globals
                                });
                                if (!(this.currentRender instanceof (0, _docsRender.DocsRender))) {
                                    _context5.next = 5;
                                    break;
                                }
                                _context5.next = 5;
                                return this.currentRender.rerender(true);
                            case 5:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function onUpdateGlobals(_x3) {
                    return _onUpdateGlobals.apply(this, arguments);
                }
                return onUpdateGlobals;
            }()
        },
        {
            key: "onUpdateArgs",
            value: function() {
                var _onUpdateArgs = _asyncToGenerator(/*#__PURE__*/ regeneratorRuntime.mark(function _callee6(_ref5) {
                    var storyId, updatedArgs;
                    return regeneratorRuntime.wrap(function _callee6$(_context6) {
                        while(true)switch(_context6.prev = _context6.next){
                            case 0:
                                storyId = _ref5.storyId, updatedArgs = _ref5.updatedArgs;
                                _get(_getPrototypeOf(PreviewWeb.prototype), "onUpdateArgs", this).call(this, {
                                    storyId: storyId,
                                    updatedArgs: updatedArgs
                                }); // NOTE: we aren't checking to see the story args are targetted at the "right" story.
                                // This is because we may render >1 story on the page and there is no easy way to keep track
                                // of which ones were rendered by the docs page.
                                // However, in `modernInlineRender`, the individual stories track their own events as they
                                // each call `renderStoryToElement` below.
                                if (!(this.currentRender instanceof (0, _docsRender.DocsRender))) {
                                    _context6.next = 5;
                                    break;
                                }
                                _context6.next = 5;
                                return this.currentRender.rerender(false);
                            case 5:
                            case "end":
                                return _context6.stop();
                        }
                    }, _callee6, this);
                }));
                function onUpdateArgs(_x4) {
                    return _onUpdateArgs.apply(this, arguments);
                }
                return onUpdateArgs;
            }()
        },
        {
            key: "onPreloadStories",
            value: function() {
                var _onPreloadStories = _asyncToGenerator(/*#__PURE__*/ regeneratorRuntime.mark(function _callee7(ids) {
                    var _this4 = this;
                    return regeneratorRuntime.wrap(function _callee7$(_context7) {
                        while(true)switch(_context7.prev = _context7.next){
                            case 0:
                                _context7.next = 2;
                                return Promise.all(ids.map(function(id) {
                                    return _this4.storyStore.loadStory({
                                        storyId: id
                                    });
                                }));
                            case 2:
                            case "end":
                                return _context7.stop();
                        }
                    }, _callee7);
                }));
                function onPreloadStories(_x5) {
                    return _onPreloadStories.apply(this, arguments);
                }
                return onPreloadStories;
            }() // RENDERING
        },
        {
            key: "renderSelection",
            value: function() {
                var _renderSelection = _asyncToGenerator(/*#__PURE__*/ regeneratorRuntime.mark(function _callee8() {
                    var _this$currentSelectio, _this$currentSelectio2, _lastRender, _this5 = this, _global$FEATURES3;
                    var _ref6, persistedArgs, selection, storyId, storyIdChanged, viewModeChanged, lastSelection, lastRender, storyRender, implementationChanged, _storyRender$context, parameters, initialArgs, argTypes, args, _args8 = arguments;
                    return regeneratorRuntime.wrap(function _callee8$(_context8) {
                        while(true)switch(_context8.prev = _context8.next){
                            case 0:
                                _ref6 = _args8.length > 0 && _args8[0] !== undefined ? _args8[0] : {}, persistedArgs = _ref6.persistedArgs;
                                selection = this.urlStore.selection;
                                if (selection) {
                                    _context8.next = 4;
                                    break;
                                }
                                throw new Error("Cannot render story as no selection was made");
                            case 4:
                                storyId = selection.storyId;
                                storyIdChanged = ((_this$currentSelectio = this.currentSelection) === null || _this$currentSelectio === void 0 ? void 0 : _this$currentSelectio.storyId) !== storyId;
                                viewModeChanged = ((_this$currentSelectio2 = this.currentSelection) === null || _this$currentSelectio2 === void 0 ? void 0 : _this$currentSelectio2.viewMode) !== selection.viewMode; // Show a spinner while we load the next story
                                if (selection.viewMode === "story") this.view.showPreparingStory({
                                    immediate: viewModeChanged
                                });
                                else this.view.showPreparingDocs();
                                lastSelection = this.currentSelection;
                                lastRender = this.currentRender; // If the last render is still preparing, let's drop it right now. Either
                                //   (a) it is a different story, which means we would drop it later, OR
                                //   (b) it is the *same* story, in which case we will resolve our own .prepare() at the
                                //       same moment anyway, and we should just "take over" the rendering.
                                // (We can't tell which it is yet, because it is possible that an HMR is going on and
                                //  even though the storyId is the same, the story itself is not).
                                if (!((_lastRender = lastRender) !== null && _lastRender !== void 0 && _lastRender.isPreparing())) {
                                    _context8.next = 14;
                                    break;
                                }
                                _context8.next = 13;
                                return this.teardownRender(lastRender);
                            case 13:
                                lastRender = null;
                            case 14:
                                storyRender = new (0, _storyRender.StoryRender)(this.channel, this.storyStore, function() {
                                    // At the start of renderToDOM we make the story visible (see note in WebView)
                                    _this5.view.showStoryDuringRender();
                                    return _this5.renderToDOM.apply(_this5, arguments);
                                }, this.mainStoryCallbacks(storyId), storyId, "story"); // We need to store this right away, so if the story changes during
                                // the async `.prepare()` below, we can (potentially) cancel it
                                this.currentSelection = selection; // Note this may be replaced by a docsRender after preparing
                                this.currentRender = storyRender;
                                _context8.prev = 17;
                                _context8.next = 20;
                                return storyRender.prepare();
                            case 20:
                                _context8.next = 29;
                                break;
                            case 22:
                                _context8.prev = 22;
                                _context8.t0 = _context8["catch"](17);
                                if (!(_context8.t0 !== (0, _storyRender.PREPARE_ABORTED))) {
                                    _context8.next = 28;
                                    break;
                                }
                                _context8.next = 27;
                                return this.teardownRender(lastRender);
                            case 27:
                                this.renderStoryLoadingException(storyId, _context8.t0);
                            case 28:
                                return _context8.abrupt("return");
                            case 29:
                                implementationChanged = !storyIdChanged && !storyRender.isEqual(lastRender);
                                if (persistedArgs) this.storyStore.args.updateFromPersisted(storyRender.story, persistedArgs);
                                _storyRender$context = storyRender.context(), parameters = _storyRender$context.parameters, initialArgs = _storyRender$context.initialArgs, argTypes = _storyRender$context.argTypes, args = _storyRender$context.args; // Don't re-render the story if nothing has changed to justify it
                                if (!(lastRender && !storyIdChanged && !implementationChanged && !viewModeChanged)) {
                                    _context8.next = 37;
                                    break;
                                }
                                this.currentRender = lastRender;
                                this.channel.emit((0, _coreEvents.STORY_UNCHANGED), storyId);
                                this.view.showMain();
                                return _context8.abrupt("return");
                            case 37:
                                _context8.next = 39;
                                return this.teardownRender(lastRender, {
                                    viewModeChanged: viewModeChanged
                                });
                            case 39:
                                // If we are rendering something new (as opposed to re-rendering the same or first story), emit
                                if (lastSelection && (storyIdChanged || viewModeChanged)) this.channel.emit((0, _coreEvents.STORY_CHANGED), storyId);
                                if ((_global$FEATURES3 = (0, _globalDefault.default).FEATURES) !== null && _global$FEATURES3 !== void 0 && _global$FEATURES3.storyStoreV7) this.channel.emit((0, _coreEvents.STORY_PREPARED), {
                                    id: storyId,
                                    parameters: parameters,
                                    initialArgs: initialArgs,
                                    argTypes: argTypes,
                                    args: args
                                });
                                 // For v6 mode / compatibility
                                // If the implementation changed, or args were persisted, the args may have changed,
                                // and the STORY_PREPARED event above may not be respected.
                                if (implementationChanged || persistedArgs) this.channel.emit((0, _coreEvents.STORY_ARGS_UPDATED), {
                                    storyId: storyId,
                                    args: args
                                });
                                if (selection.viewMode === "docs" || parameters.docsOnly) {
                                    this.currentRender = (0, _docsRender.DocsRender).fromStoryRender(storyRender);
                                    this.currentRender.renderToElement(this.view.prepareForDocs(), this.renderStoryToElement.bind(this));
                                } else {
                                    this.storyRenders.push(storyRender);
                                    this.currentRender.renderToElement(this.view.prepareForStory(storyRender.story));
                                }
                            case 43:
                            case "end":
                                return _context8.stop();
                        }
                    }, _callee8, this, [
                        [
                            17,
                            22
                        ]
                    ]);
                }));
                function renderSelection() {
                    return _renderSelection.apply(this, arguments);
                }
                return renderSelection;
            }() // Used by docs' modernInlineRender to render a story to a given element
        },
        {
            key: "renderStoryToElement",
            value: function renderStoryToElement(story, element) {
                var _this6 = this;
                var render = new (0, _storyRender.StoryRender)(this.channel, this.storyStore, this.renderToDOM, this.inlineStoryCallbacks(story.id), story.id, "docs", story);
                render.renderToElement(element);
                this.storyRenders.push(render);
                return /*#__PURE__*/ _asyncToGenerator(/*#__PURE__*/ regeneratorRuntime.mark(function _callee9() {
                    return regeneratorRuntime.wrap(function _callee9$(_context9) {
                        while(true)switch(_context9.prev = _context9.next){
                            case 0:
                                _context9.next = 2;
                                return _this6.teardownRender(render);
                            case 2:
                            case "end":
                                return _context9.stop();
                        }
                    }, _callee9);
                }));
            }
        },
        {
            key: "teardownRender",
            value: function() {
                var _teardownRender = _asyncToGenerator(/*#__PURE__*/ regeneratorRuntime.mark(function _callee10(render) {
                    var _ref8, viewModeChanged, _args10 = arguments;
                    return regeneratorRuntime.wrap(function _callee10$(_context10) {
                        while(true)switch(_context10.prev = _context10.next){
                            case 0:
                                _ref8 = _args10.length > 1 && _args10[1] !== undefined ? _args10[1] : {}, viewModeChanged = _ref8.viewModeChanged;
                                this.storyRenders = this.storyRenders.filter(function(r) {
                                    return r !== render;
                                });
                                _context10.next = 4;
                                return render === null || render === void 0 ? void 0 : render.teardown({
                                    viewModeChanged: viewModeChanged
                                });
                            case 4:
                            case "end":
                                return _context10.stop();
                        }
                    }, _callee10, this);
                }));
                function teardownRender(_x6) {
                    return _teardownRender.apply(this, arguments);
                }
                return teardownRender;
            }() // API
        },
        {
            key: "extract",
            value: function() {
                var _extract = _asyncToGenerator(/*#__PURE__*/ regeneratorRuntime.mark(function _callee11(options) {
                    var _global$FEATURES4;
                    return regeneratorRuntime.wrap(function _callee11$(_context11) {
                        while(true)switch(_context11.prev = _context11.next){
                            case 0:
                                if (!this.previewEntryError) {
                                    _context11.next = 2;
                                    break;
                                }
                                throw this.previewEntryError;
                            case 2:
                                if (this.storyStore.projectAnnotations) {
                                    _context11.next = 4;
                                    break;
                                }
                                throw new Error((0, _tsDedentDefault.default)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral([
                                    "Failed to initialize Storybook.\n      \n      Do you have an error in your `preview.js`? Check your Storybook's browser console for errors."
                                ], [
                                    "Failed to initialize Storybook.\n      \n      Do you have an error in your \\`preview.js\\`? Check your Storybook's browser console for errors."
                                ]))));
                            case 4:
                                if (!((_global$FEATURES4 = (0, _globalDefault.default).FEATURES) !== null && _global$FEATURES4 !== void 0 && _global$FEATURES4.storyStoreV7)) {
                                    _context11.next = 7;
                                    break;
                                }
                                _context11.next = 7;
                                return this.storyStore.cacheAllCSFFiles();
                            case 7:
                                return _context11.abrupt("return", this.storyStore.extract(options));
                            case 8:
                            case "end":
                                return _context11.stop();
                        }
                    }, _callee11, this);
                }));
                function extract(_x7) {
                    return _extract.apply(this, arguments);
                }
                return extract;
            }() // UTILITIES
        },
        {
            key: "mainStoryCallbacks",
            value: function mainStoryCallbacks(storyId) {
                var _this7 = this;
                return {
                    showMain: function showMain() {
                        return _this7.view.showMain();
                    },
                    showError: function showError(err) {
                        return _this7.renderError(storyId, err);
                    },
                    showException: function showException(err) {
                        return _this7.renderException(storyId, err);
                    }
                };
            }
        },
        {
            key: "inlineStoryCallbacks",
            value: function inlineStoryCallbacks(storyId) {
                return {
                    showMain: function showMain() {},
                    showError: function showError(err) {
                        return (0, _clientLogger.logger).error("Error rendering docs story (".concat(storyId, ")"), err);
                    },
                    showException: function showException(err) {
                        return (0, _clientLogger.logger).error("Error rendering docs story (".concat(storyId, ")"), err);
                    }
                };
            }
        },
        {
            key: "renderPreviewEntryError",
            value: function renderPreviewEntryError(reason, err) {
                _get(_getPrototypeOf(PreviewWeb.prototype), "renderPreviewEntryError", this).call(this, reason, err);
                this.view.showErrorDisplay(err);
            }
        },
        {
            key: "renderMissingStory",
            value: function renderMissingStory() {
                this.view.showNoPreview();
                this.channel.emit((0, _coreEvents.STORY_MISSING));
            }
        },
        {
            key: "renderStoryLoadingException",
            value: function renderStoryLoadingException(storySpecifier, err) {
                (0, _clientLogger.logger).error("Unable to load story '".concat(storySpecifier, "':"));
                (0, _clientLogger.logger).error(err);
                this.view.showErrorDisplay(err);
                this.channel.emit((0, _coreEvents.STORY_MISSING), storySpecifier);
            } // renderException is used if we fail to render the story and it is uncaught by the app layer
        },
        {
            key: "renderException",
            value: function renderException(storyId, err) {
                this.channel.emit((0, _coreEvents.STORY_THREW_EXCEPTION), err);
                this.channel.emit((0, _coreEvents.STORY_RENDER_PHASE_CHANGED), {
                    newPhase: "errored",
                    storyId: storyId
                }); // Ignored exceptions exist for control flow purposes, and are typically handled elsewhere.
                if (err !== (0, _coreEvents.IGNORED_EXCEPTION)) {
                    this.view.showErrorDisplay(err);
                    (0, _clientLogger.logger).error("Error rendering story '".concat(storyId, "':"));
                    (0, _clientLogger.logger).error(err);
                }
            } // renderError is used by the various app layers to inform the user they have done something
        },
        {
            key: "renderError",
            value: function renderError(storyId, _ref9) {
                var title = _ref9.title, description = _ref9.description;
                (0, _clientLogger.logger).error("Error rendering story ".concat(title, ": ").concat(description));
                this.channel.emit((0, _coreEvents.STORY_ERRORED), {
                    title: title,
                    description: description
                });
                this.channel.emit((0, _coreEvents.STORY_RENDER_PHASE_CHANGED), {
                    newPhase: "errored",
                    storyId: storyId
                });
                this.view.showErrorDisplay({
                    message: title,
                    stack: description
                });
            }
        }
    ]);
    return PreviewWeb;
}((0, _preview.Preview));

},{"core-js/modules/es.object.get-prototype-of.js":"kLLpv","core-js/modules/es.reflect.construct.js":"7ZxAL","core-js/modules/es.reflect.get.js":"i5juf","core-js/modules/es.object.get-own-property-descriptor.js":"cBMA1","core-js/modules/es.array.slice.js":"8RRh9","core-js/modules/es.object.freeze.js":"9LVYO","core-js/modules/es.symbol.iterator.js":"fhNIb","core-js/modules/es.regexp.exec.js":"5q56v","core-js/modules/es.object.assign.js":"8FU8M","core-js/modules/es.array.iterator.js":"ieU20","core-js/modules/es.object.to-string.js":"lsA9p","core-js/modules/es.promise.js":"2jax7","core-js/modules/es.string.iterator.js":"74a8v","core-js/modules/web.dom-collections.iterator.js":"aXR96","core-js/modules/es.array.map.js":"jTP7e","core-js/modules/es.array.filter.js":"fD2da","core-js/modules/es.symbol.js":"ajw2f","core-js/modules/es.symbol.description.js":"wrlLc","core-js/modules/es.array.concat.js":"g1t7q","util-deprecate":"lYmRJ","ts-dedent":"9RvVa","global":"5PzlO","@storybook/core-events":"bJpgo","@storybook/client-logger":"iGRus","./Preview":"7bs7E","./UrlStore":"7GAnn","./WebView":"1XVfn","./StoryRender":"4LYsN","./DocsRender":"lArs7","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"7ZxAL":[function(require,module,exports) {
var $ = require("df593a7c66399ae2");
var getBuiltIn = require("aa786cd255199284");
var apply = require("c585a7fc86970645");
var bind = require("d05ce57b271ff568");
var aConstructor = require("488fff441ba5bfef");
var anObject = require("688b651555d83b8f");
var isObject = require("c7a921b7c24a97c");
var create = require("2ff4acc7df7eb046");
var fails = require("2ad48193afce6a95");
var nativeConstruct = getBuiltIn("Reflect", "construct");
var ObjectPrototype = Object.prototype;
var push = [].push;
// `Reflect.construct` method
// https://tc39.es/ecma262/#sec-reflect.construct
// MS Edge supports only 2 arguments and argumentsList argument is optional
// FF Nightly sets third argument as `new.target`, but does not create `this` from it
var NEW_TARGET_BUG = fails(function() {
    function F() {}
    return !(nativeConstruct(function() {}, [], F) instanceof F);
});
var ARGS_BUG = !fails(function() {
    nativeConstruct(function() {});
});
var FORCED = NEW_TARGET_BUG || ARGS_BUG;
$({
    target: "Reflect",
    stat: true,
    forced: FORCED,
    sham: FORCED
}, {
    construct: function construct(Target, args /* , newTarget */ ) {
        aConstructor(Target);
        anObject(args);
        var newTarget = arguments.length < 3 ? Target : aConstructor(arguments[2]);
        if (ARGS_BUG && !NEW_TARGET_BUG) return nativeConstruct(Target, args, newTarget);
        if (Target == newTarget) {
            // w/o altered newTarget, optimization for 0-4 arguments
            switch(args.length){
                case 0:
                    return new Target();
                case 1:
                    return new Target(args[0]);
                case 2:
                    return new Target(args[0], args[1]);
                case 3:
                    return new Target(args[0], args[1], args[2]);
                case 4:
                    return new Target(args[0], args[1], args[2], args[3]);
            }
            // w/o altered newTarget, lot of arguments case
            var $args = [
                null
            ];
            apply(push, $args, args);
            return new (apply(bind, Target, $args))();
        }
        // with altered newTarget, not support built-in constructors
        var proto = newTarget.prototype;
        var instance = create(isObject(proto) ? proto : ObjectPrototype);
        var result = apply(Target, instance, args);
        return isObject(result) ? result : instance;
    }
});

},{"df593a7c66399ae2":"1OO62","aa786cd255199284":"bQFzp","c585a7fc86970645":"QdiN4","d05ce57b271ff568":"9euWA","488fff441ba5bfef":"bbx5w","688b651555d83b8f":"39qAm","c7a921b7c24a97c":"bprny","2ff4acc7df7eb046":"dgTGU","2ad48193afce6a95":"keKlS"}],"9euWA":[function(require,module,exports) {
"use strict";
var global = require("4010cfaafccb35c0");
var uncurryThis = require("94a95e8ae25b0044");
var aCallable = require("4072cb1aa6784cb2");
var isObject = require("16c540423602bd07");
var hasOwn = require("2a423fe0321fe359");
var arraySlice = require("29b660c46e7d5c44");
var Function = global.Function;
var concat = uncurryThis([].concat);
var join = uncurryThis([].join);
var factories = {};
var construct = function(C, argsLength, args) {
    if (!hasOwn(factories, argsLength)) {
        for(var list = [], i = 0; i < argsLength; i++)list[i] = "a[" + i + "]";
        factories[argsLength] = Function("C,a", "return new C(" + join(list, ",") + ")");
    }
    return factories[argsLength](C, args);
};
// `Function.prototype.bind` method implementation
// https://tc39.es/ecma262/#sec-function.prototype.bind
module.exports = Function.bind || function bind(that /* , ...args */ ) {
    var F = aCallable(this);
    var Prototype = F.prototype;
    var partArgs = arraySlice(arguments, 1);
    var boundFunction = function bound() {
        var args = concat(partArgs, arraySlice(arguments));
        return this instanceof boundFunction ? construct(F, args.length, args) : F.apply(that, args);
    };
    if (isObject(Prototype)) boundFunction.prototype = Prototype;
    return boundFunction;
};

},{"4010cfaafccb35c0":"1GZc4","94a95e8ae25b0044":"fP9tv","4072cb1aa6784cb2":"keisz","16c540423602bd07":"bprny","2a423fe0321fe359":"4SzRl","29b660c46e7d5c44":"hloI5"}],"i5juf":[function(require,module,exports) {
var $ = require("36af64a139a04a9f");
var call = require("2b0e8e0105e0ccfb");
var isObject = require("c12275a56fb80891");
var anObject = require("8afae34daed2ddfd");
var isDataDescriptor = require("a0fe3971b7cb6675");
var getOwnPropertyDescriptorModule = require("64fb71955ccea62a");
var getPrototypeOf = require("42f515e0257c869d");
// `Reflect.get` method
// https://tc39.es/ecma262/#sec-reflect.get
function get(target, propertyKey /* , receiver */ ) {
    var receiver = arguments.length < 3 ? target : arguments[2];
    var descriptor, prototype;
    if (anObject(target) === receiver) return target[propertyKey];
    descriptor = getOwnPropertyDescriptorModule.f(target, propertyKey);
    if (descriptor) return isDataDescriptor(descriptor) ? descriptor.value : descriptor.get === undefined ? undefined : call(descriptor.get, receiver);
    if (isObject(prototype = getPrototypeOf(target))) return get(prototype, propertyKey, receiver);
}
$({
    target: "Reflect",
    stat: true
}, {
    get: get
});

},{"36af64a139a04a9f":"1OO62","2b0e8e0105e0ccfb":"aSvFj","c12275a56fb80891":"bprny","8afae34daed2ddfd":"39qAm","a0fe3971b7cb6675":"8squl","64fb71955ccea62a":"8cErP","42f515e0257c869d":"gkVld"}],"8squl":[function(require,module,exports) {
var hasOwn = require("50fb4bd8f6d0c370");
module.exports = function(descriptor) {
    return descriptor !== undefined && (hasOwn(descriptor, "value") || hasOwn(descriptor, "writable"));
};

},{"50fb4bd8f6d0c370":"4SzRl"}],"cBMA1":[function(require,module,exports) {
var $ = require("5e9e720f67356476");
var fails = require("c8df38aee3cb5769");
var toIndexedObject = require("10375c86bad61030");
var nativeGetOwnPropertyDescriptor = require("3b00a68c12a1896c").f;
var DESCRIPTORS = require("76539d9475dc0bf0");
var FAILS_ON_PRIMITIVES = fails(function() {
    nativeGetOwnPropertyDescriptor(1);
});
var FORCED = !DESCRIPTORS || FAILS_ON_PRIMITIVES;
// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
$({
    target: "Object",
    stat: true,
    forced: FORCED,
    sham: !DESCRIPTORS
}, {
    getOwnPropertyDescriptor: function getOwnPropertyDescriptor(it, key) {
        return nativeGetOwnPropertyDescriptor(toIndexedObject(it), key);
    }
});

},{"5e9e720f67356476":"1OO62","c8df38aee3cb5769":"keKlS","10375c86bad61030":"5DeQ5","3b00a68c12a1896c":"8cErP","76539d9475dc0bf0":"7Hk5a"}],"7GAnn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "pathToId", ()=>pathToId);
parcelHelpers.export(exports, "setPath", ()=>setPath);
parcelHelpers.export(exports, "getSelectionSpecifierFromPath", ()=>getSelectionSpecifierFromPath);
parcelHelpers.export(exports, "UrlStore", ()=>UrlStore);
var _esObjectKeysJs = require("core-js/modules/es.object.keys.js");
var _esSymbolJs = require("core-js/modules/es.symbol.js");
var _esSymbolDescriptionJs = require("core-js/modules/es.symbol.description.js");
var _esObjectToStringJs = require("core-js/modules/es.object.to-string.js");
var _esSymbolIteratorJs = require("core-js/modules/es.symbol.iterator.js");
var _esArrayIteratorJs = require("core-js/modules/es.array.iterator.js");
var _esStringIteratorJs = require("core-js/modules/es.string.iterator.js");
var _webDomCollectionsIteratorJs = require("core-js/modules/web.dom-collections.iterator.js");
var _esRegexpExecJs = require("core-js/modules/es.regexp.exec.js");
var _esStringMatchJs = require("core-js/modules/es.string.match.js");
var _esStringSearchJs = require("core-js/modules/es.string.search.js");
var _esObjectAssignJs = require("core-js/modules/es.object.assign.js");
var _esArrayConcatJs = require("core-js/modules/es.array.concat.js");
var _esObjectValuesJs = require("core-js/modules/es.object.values.js");
var _global = require("global");
var _globalDefault = parcelHelpers.interopDefault(_global);
var _qs = require("qs");
var _qsDefault = parcelHelpers.interopDefault(_qs);
var _utilDeprecate = require("util-deprecate");
var _utilDeprecateDefault = parcelHelpers.interopDefault(_utilDeprecate);
var _parseArgsParam = require("./parseArgsParam");
var _excluded = [
    "path",
    "selectedKind",
    "selectedStory"
];
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function _typeof(obj) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var history = (0, _globalDefault.default).history, document = (0, _globalDefault.default).document;
function pathToId(path) {
    var match = (path || "").match(/^\/story\/(.+)/);
    if (!match) throw new Error("Invalid path '".concat(path, "',  must start with '/story/'"));
    return match[1];
}
var getQueryString = function getQueryString(_ref) {
    var selection = _ref.selection, extraParams = _ref.extraParams;
    var _document$location$se = document.location.search, search = _document$location$se === void 0 ? "" : _document$location$se;
    var _qs$parse = (0, _qsDefault.default).parse(search, {
        ignoreQueryPrefix: true
    }), path = _qs$parse.path, selectedKind = _qs$parse.selectedKind, selectedStory = _qs$parse.selectedStory, rest = _objectWithoutProperties(_qs$parse, _excluded);
    return (0, _qsDefault.default).stringify(Object.assign({}, rest, extraParams, selection && {
        id: selection.storyId,
        viewMode: selection.viewMode
    }), {
        encode: false,
        addQueryPrefix: true
    });
};
var setPath = function setPath(selection) {
    if (!selection) return;
    var query = getQueryString({
        selection: selection
    });
    var _document$location$ha = document.location.hash, hash = _document$location$ha === void 0 ? "" : _document$location$ha;
    document.title = selection.storyId;
    history.replaceState({}, "", "".concat(document.location.pathname).concat(query).concat(hash));
};
var isObject = function isObject(val) {
    return val != null && _typeof(val) === "object" && Array.isArray(val) === false;
};
var getFirstString = function getFirstString(v) {
    if (typeof v === "string") return v;
    if (Array.isArray(v)) return getFirstString(v[0]);
    if (isObject(v)) // @ts-ignore
    return getFirstString(Object.values(v));
    return undefined;
};
var deprecatedLegacyQuery = (0, _utilDeprecateDefault.default)(function() {
    return 0;
}, "URL formats with `selectedKind` and `selectedName` query parameters are deprecated.\nUse `id=$storyId` instead.\nSee https://github.com/storybookjs/storybook/blob/next/MIGRATION.md#new-url-structure");
var getSelectionSpecifierFromPath = function getSelectionSpecifierFromPath() {
    var query = (0, _qsDefault.default).parse(document.location.search, {
        ignoreQueryPrefix: true
    });
    var args = typeof query.args === "string" ? (0, _parseArgsParam.parseArgsParam)(query.args) : undefined;
    var globals = typeof query.globals === "string" ? (0, _parseArgsParam.parseArgsParam)(query.globals) : undefined;
    var viewMode = getFirstString(query.viewMode);
    if (typeof viewMode !== "string" || !viewMode.match(/docs|story/)) viewMode = "story";
    var path = getFirstString(query.path);
    var storyId = path ? pathToId(path) : getFirstString(query.id);
    if (storyId) return {
        storySpecifier: storyId,
        args: args,
        globals: globals,
        viewMode: viewMode
    };
     // Legacy URL format
    var title = getFirstString(query.selectedKind);
    var name = getFirstString(query.selectedStory);
    if (title && name) {
        deprecatedLegacyQuery();
        return {
            storySpecifier: {
                title: title,
                name: name
            },
            args: args,
            globals: globals,
            viewMode: viewMode
        };
    }
    return null;
};
var UrlStore = /*#__PURE__*/ function() {
    function UrlStore() {
        _classCallCheck(this, UrlStore);
        this.selectionSpecifier = void 0;
        this.selection = void 0;
        this.selectionSpecifier = getSelectionSpecifierFromPath();
    }
    _createClass(UrlStore, [
        {
            key: "setSelection",
            value: function setSelection(selection) {
                this.selection = selection;
                setPath(this.selection);
            }
        },
        {
            key: "setQueryParams",
            value: function setQueryParams(queryParams) {
                var query = getQueryString({
                    extraParams: queryParams
                });
                var _document$location$ha2 = document.location.hash, hash = _document$location$ha2 === void 0 ? "" : _document$location$ha2;
                history.replaceState({}, "", "".concat(document.location.pathname).concat(query).concat(hash));
            }
        }
    ]);
    return UrlStore;
}();

},{"core-js/modules/es.object.keys.js":"5Q2AT","core-js/modules/es.symbol.js":"ajw2f","core-js/modules/es.symbol.description.js":"wrlLc","core-js/modules/es.object.to-string.js":"lsA9p","core-js/modules/es.symbol.iterator.js":"fhNIb","core-js/modules/es.array.iterator.js":"ieU20","core-js/modules/es.string.iterator.js":"74a8v","core-js/modules/web.dom-collections.iterator.js":"aXR96","core-js/modules/es.regexp.exec.js":"5q56v","core-js/modules/es.string.match.js":"e2YpX","core-js/modules/es.string.search.js":"l1Pph","core-js/modules/es.object.assign.js":"8FU8M","core-js/modules/es.array.concat.js":"g1t7q","core-js/modules/es.object.values.js":"bB8XB","global":"5PzlO","qs":"2jOAs","util-deprecate":"lYmRJ","./parseArgsParam":"eqQUS","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"eqQUS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parseArgsParam", ()=>parseArgsParam);
var _esSymbolJs = require("core-js/modules/es.symbol.js");
var _esSymbolDescriptionJs = require("core-js/modules/es.symbol.description.js");
var _esSymbolIteratorJs = require("core-js/modules/es.symbol.iterator.js");
var _esArrayIteratorJs = require("core-js/modules/es.array.iterator.js");
var _esStringIteratorJs = require("core-js/modules/es.string.iterator.js");
var _webDomCollectionsIteratorJs = require("core-js/modules/web.dom-collections.iterator.js");
var _esFunctionNameJs = require("core-js/modules/es.function.name.js");
var _esArrayFromJs = require("core-js/modules/es.array.from.js");
var _esObjectFreezeJs = require("core-js/modules/es.object.freeze.js");
var _esRegexpExecJs = require("core-js/modules/es.regexp.exec.js");
var _esObjectToStringJs = require("core-js/modules/es.object.to-string.js");
var _esObjectEntriesJs = require("core-js/modules/es.object.entries.js");
var _esRegexpToStringJs = require("core-js/modules/es.regexp.to-string.js");
var _esStringStartsWithJs = require("core-js/modules/es.string.starts-with.js");
var _esStringEndsWithJs = require("core-js/modules/es.string.ends-with.js");
var _esArraySliceJs = require("core-js/modules/es.array.slice.js");
var _esStringMatchJs = require("core-js/modules/es.string.match.js");
var _esArrayConcatJs = require("core-js/modules/es.array.concat.js");
var _esNumberConstructorJs = require("core-js/modules/es.number.constructor.js");
var _esArrayMapJs = require("core-js/modules/es.array.map.js");
var _esStringSplitJs = require("core-js/modules/es.string.split.js");
var _esStringReplaceJs = require("core-js/modules/es.string.replace.js");
var _esArrayJoinJs = require("core-js/modules/es.array.join.js");
var _esObjectAssignJs = require("core-js/modules/es.object.assign.js");
var _qs = require("qs");
var _qsDefault = parcelHelpers.interopDefault(_qs);
var _tsDedent = require("ts-dedent");
var _tsDedentDefault = parcelHelpers.interopDefault(_tsDedent);
var _clientLogger = require("@storybook/client-logger");
var _isPlainObject = require("lodash/isPlainObject"); // Keep this in sync with validateArgs in router/src/utils.ts
var _isPlainObjectDefault = parcelHelpers.interopDefault(_isPlainObject);
var _templateObject;
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) raw = strings.slice(0);
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var VALIDATION_REGEXP = /^[a-zA-Z0-9 _-]*$/;
var NUMBER_REGEXP = /^-?[0-9]+(\.[0-9]+)?$/;
var HEX_REGEXP = /^#([a-f0-9]{3,4}|[a-f0-9]{6}|[a-f0-9]{8})$/i;
var COLOR_REGEXP = /^(rgba?|hsla?)\(([0-9]{1,3}),\s?([0-9]{1,3})%?,\s?([0-9]{1,3})%?,?\s?([0-9](\.[0-9]{1,2})?)?\)$/i;
var validateArgs = function validateArgs() {
    var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
    var value = arguments.length > 1 ? arguments[1] : undefined;
    if (key === null) return false;
    if (key === "" || !VALIDATION_REGEXP.test(key)) return false;
    if (value === null || value === undefined) return true; // encoded as `!null` or `!undefined`
    if (value instanceof Date) return true; // encoded as modified ISO string
    if (typeof value === "number" || typeof value === "boolean") return true;
    if (typeof value === "string") return VALIDATION_REGEXP.test(value) || NUMBER_REGEXP.test(value) || HEX_REGEXP.test(value) || COLOR_REGEXP.test(value);
    if (Array.isArray(value)) return value.every(function(v) {
        return validateArgs(key, v);
    });
    if ((0, _isPlainObjectDefault.default)(value)) return Object.entries(value).every(function(_ref) {
        var _ref2 = _slicedToArray(_ref, 2), k = _ref2[0], v = _ref2[1];
        return validateArgs(k, v);
    });
    return false;
};
var QS_OPTIONS = {
    delimiter: ";",
    // we're parsing a single query param
    allowDots: true,
    // objects are encoded using dot notation
    allowSparse: true,
    // arrays will be merged on top of their initial value
    decoder: function(_decoder) {
        function decoder(_x, _x2, _x3, _x4) {
            return _decoder.apply(this, arguments);
        }
        decoder.toString = function() {
            return _decoder.toString();
        };
        return decoder;
    }(function(str, defaultDecoder, charset, type) {
        if (type === "value" && str.startsWith("!")) {
            if (str === "!undefined") return undefined;
            if (str === "!null") return null;
            if (str.startsWith("!date(") && str.endsWith(")")) return new Date(str.slice(6, -1));
            if (str.startsWith("!hex(") && str.endsWith(")")) return "#".concat(str.slice(5, -1));
            var color = str.slice(1).match(COLOR_REGEXP);
            if (color) {
                if (str.startsWith("!rgba")) return "".concat(color[1], "(").concat(color[2], ", ").concat(color[3], ", ").concat(color[4], ", ").concat(color[5], ")");
                if (str.startsWith("!hsla")) return "".concat(color[1], "(").concat(color[2], ", ").concat(color[3], "%, ").concat(color[4], "%, ").concat(color[5], ")");
                return str.startsWith("!rgb") ? "".concat(color[1], "(").concat(color[2], ", ").concat(color[3], ", ").concat(color[4], ")") : "".concat(color[1], "(").concat(color[2], ", ").concat(color[3], "%, ").concat(color[4], "%)");
            }
        }
        if (type === "value" && NUMBER_REGEXP.test(str)) return Number(str);
        return defaultDecoder(str, defaultDecoder, charset);
    })
};
var parseArgsParam = function parseArgsParam(argsString) {
    var parts = argsString.split(";").map(function(part) {
        return part.replace("=", "~").replace(":", "=");
    });
    return Object.entries((0, _qsDefault.default).parse(parts.join(";"), QS_OPTIONS)).reduce(function(acc, _ref3) {
        var _ref4 = _slicedToArray(_ref3, 2), key = _ref4[0], value = _ref4[1];
        if (validateArgs(key, value)) return Object.assign(acc, _defineProperty({}, key, value));
        (0, _clientLogger.once).warn((0, _tsDedentDefault.default)(_templateObject || (_templateObject = _taggedTemplateLiteral([
            "\n      Omitted potentially unsafe URL args.\n\n      More info: https://storybook.js.org/docs/react/writing-stories/args#setting-args-through-the-url\n    "
        ]))));
        return acc;
    }, {});
};

},{"core-js/modules/es.symbol.js":"ajw2f","core-js/modules/es.symbol.description.js":"wrlLc","core-js/modules/es.symbol.iterator.js":"fhNIb","core-js/modules/es.array.iterator.js":"ieU20","core-js/modules/es.string.iterator.js":"74a8v","core-js/modules/web.dom-collections.iterator.js":"aXR96","core-js/modules/es.function.name.js":"4LiLL","core-js/modules/es.array.from.js":"9UCQw","core-js/modules/es.object.freeze.js":"9LVYO","core-js/modules/es.regexp.exec.js":"5q56v","core-js/modules/es.object.to-string.js":"lsA9p","core-js/modules/es.object.entries.js":"7Wf79","core-js/modules/es.regexp.to-string.js":"bGzly","core-js/modules/es.string.starts-with.js":"90lFR","core-js/modules/es.string.ends-with.js":"6TCKi","core-js/modules/es.array.slice.js":"8RRh9","core-js/modules/es.string.match.js":"e2YpX","core-js/modules/es.array.concat.js":"g1t7q","core-js/modules/es.number.constructor.js":"hVD7l","core-js/modules/es.array.map.js":"jTP7e","core-js/modules/es.string.split.js":"12go2","core-js/modules/es.string.replace.js":"bFiJG","core-js/modules/es.array.join.js":"1w71h","core-js/modules/es.object.assign.js":"8FU8M","qs":"2jOAs","ts-dedent":"9RvVa","@storybook/client-logger":"iGRus","lodash/isPlainObject":"9m4Iw","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"6TCKi":[function(require,module,exports) {
"use strict";
var $ = require("b3cd31deb9d32a8c");
var uncurryThis = require("aac15dc3adc44891");
var getOwnPropertyDescriptor = require("e75304a6599a5e3c").f;
var toLength = require("99883df659b0f5cb");
var toString = require("e5d8defa036db553");
var notARegExp = require("4c78f4ce8264459e");
var requireObjectCoercible = require("da4ce5f132e95194");
var correctIsRegExpLogic = require("58da9c5323c25a0f");
var IS_PURE = require("e85ff4c5cebafc14");
// eslint-disable-next-line es/no-string-prototype-endswith -- safe
var un$EndsWith = uncurryThis("".endsWith);
var slice = uncurryThis("".slice);
var min = Math.min;
var CORRECT_IS_REGEXP_LOGIC = correctIsRegExpLogic("endsWith");
// https://github.com/zloirock/core-js/pull/702
var MDN_POLYFILL_BUG = !IS_PURE && !CORRECT_IS_REGEXP_LOGIC && !!function() {
    var descriptor = getOwnPropertyDescriptor(String.prototype, "endsWith");
    return descriptor && !descriptor.writable;
}();
// `String.prototype.endsWith` method
// https://tc39.es/ecma262/#sec-string.prototype.endswith
$({
    target: "String",
    proto: true,
    forced: !MDN_POLYFILL_BUG && !CORRECT_IS_REGEXP_LOGIC
}, {
    endsWith: function endsWith(searchString /* , endPosition = @length */ ) {
        var that = toString(requireObjectCoercible(this));
        notARegExp(searchString);
        var endPosition = arguments.length > 1 ? arguments[1] : undefined;
        var len = that.length;
        var end = endPosition === undefined ? len : min(toLength(endPosition), len);
        var search = toString(searchString);
        return un$EndsWith ? un$EndsWith(that, search, end) : slice(that, end - search.length, end) === search;
    }
});

},{"b3cd31deb9d32a8c":"1OO62","aac15dc3adc44891":"fP9tv","e75304a6599a5e3c":"8cErP","99883df659b0f5cb":"kzWDg","e5d8defa036db553":"8RVGu","4c78f4ce8264459e":"9XS3f","da4ce5f132e95194":"etuZb","58da9c5323c25a0f":"034hA","e85ff4c5cebafc14":"bZbjq"}],"1XVfn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "WebView", ()=>WebView);
var _esObjectFreezeJs = require("core-js/modules/es.object.freeze.js");
var _esSymbolJs = require("core-js/modules/es.symbol.js");
var _esSymbolDescriptionJs = require("core-js/modules/es.symbol.description.js");
var _esSymbolIteratorJs = require("core-js/modules/es.symbol.iterator.js");
var _esArrayIteratorJs = require("core-js/modules/es.array.iterator.js");
var _esStringIteratorJs = require("core-js/modules/es.string.iterator.js");
var _webDomCollectionsIteratorJs = require("core-js/modules/web.dom-collections.iterator.js");
var _esFunctionNameJs = require("core-js/modules/es.function.name.js");
var _esArrayFromJs = require("core-js/modules/es.array.from.js");
var _esRegexpExecJs = require("core-js/modules/es.regexp.exec.js");
var _esStringSearchJs = require("core-js/modules/es.string.search.js");
var _esArrayJoinJs = require("core-js/modules/es.array.join.js");
var _esObjectKeysJs = require("core-js/modules/es.object.keys.js");
var _esObjectToStringJs = require("core-js/modules/es.object.to-string.js");
var _webDomCollectionsForEachJs = require("core-js/modules/web.dom-collections.for-each.js");
var _esStringSplitJs = require("core-js/modules/es.string.split.js");
var _esArraySliceJs = require("core-js/modules/es.array.slice.js");
var _global = require("global");
var _globalDefault = parcelHelpers.interopDefault(_global);
var _clientLogger = require("@storybook/client-logger");
var _ansiToHtml = require("ansi-to-html");
var _ansiToHtmlDefault = parcelHelpers.interopDefault(_ansiToHtml);
var _tsDedent = require("ts-dedent");
var _tsDedentDefault = parcelHelpers.interopDefault(_tsDedent);
var _qs = require("qs");
var _qsDefault = parcelHelpers.interopDefault(_qs);
var _templateObject;
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) raw = strings.slice(0);
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
var document = (0, _globalDefault.default).document;
var PREPARING_DELAY = 100;
var layoutClassMap = {
    centered: "sb-main-centered",
    fullscreen: "sb-main-fullscreen",
    padded: "sb-main-padded"
};
var Mode;
(function(Mode) {
    Mode["MAIN"] = "MAIN";
    Mode["NOPREVIEW"] = "NOPREVIEW";
    Mode["PREPARING_STORY"] = "PREPARING_STORY";
    Mode["PREPARING_DOCS"] = "PREPARING_DOCS";
    Mode["ERROR"] = "ERROR";
})(Mode || (Mode = {}));
var classes = {
    PREPARING_STORY: "sb-show-preparing-story",
    PREPARING_DOCS: "sb-show-preparing-docs",
    MAIN: "sb-show-main",
    NOPREVIEW: "sb-show-nopreview",
    ERROR: "sb-show-errordisplay"
};
var ansiConverter = new (0, _ansiToHtmlDefault.default)({
    escapeXML: true
});
var WebView = /*#__PURE__*/ function() {
    function WebView() {
        _classCallCheck(this, WebView);
        this.currentLayoutClass = void 0;
        this.testing = false;
        this.preparingTimeout = null;
        // Special code for testing situations
        var _qs$parse = (0, _qsDefault.default).parse(document.location.search, {
            ignoreQueryPrefix: true
        }), __SPECIAL_TEST_PARAMETER__ = _qs$parse.__SPECIAL_TEST_PARAMETER__;
        switch(__SPECIAL_TEST_PARAMETER__){
            case "preparing-story":
                this.showPreparingStory();
                this.testing = true;
                break;
            case "preparing-docs":
                this.showPreparingDocs();
                this.testing = true;
                break;
            default:
        }
    } // Get ready to render a story, returning the element to render to
    _createClass(WebView, [
        {
            key: "prepareForStory",
            value: function prepareForStory(story) {
                this.showStory();
                this.applyLayout(story.parameters.layout);
                document.documentElement.scrollTop = 0;
                document.documentElement.scrollLeft = 0;
                return this.storyRoot();
            }
        },
        {
            key: "storyRoot",
            value: function storyRoot() {
                return document.getElementById("root");
            }
        },
        {
            key: "prepareForDocs",
            value: function prepareForDocs() {
                this.showMain();
                this.showDocs();
                this.applyLayout("fullscreen");
                return this.docsRoot();
            }
        },
        {
            key: "docsRoot",
            value: function docsRoot() {
                return document.getElementById("docs-root");
            }
        },
        {
            key: "applyLayout",
            value: function applyLayout() {
                var layout = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "padded";
                if (layout === "none") {
                    document.body.classList.remove(this.currentLayoutClass);
                    this.currentLayoutClass = null;
                    return;
                }
                this.checkIfLayoutExists(layout);
                var layoutClass = layoutClassMap[layout];
                document.body.classList.remove(this.currentLayoutClass);
                document.body.classList.add(layoutClass);
                this.currentLayoutClass = layoutClass;
            }
        },
        {
            key: "checkIfLayoutExists",
            value: function checkIfLayoutExists(layout) {
                if (!layoutClassMap[layout]) (0, _clientLogger.logger).warn((0, _tsDedentDefault.default)(_templateObject || (_templateObject = _taggedTemplateLiteral([
                    "The desired layout: ",
                    " is not a valid option.\n         The possible options are: ",
                    ", none."
                ])), layout, Object.keys(layoutClassMap).join(", ")));
            }
        },
        {
            key: "showMode",
            value: function showMode(mode) {
                clearTimeout(this.preparingTimeout);
                Object.keys(Mode).forEach(function(otherMode) {
                    if (otherMode === mode) document.body.classList.add(classes[otherMode]);
                    else document.body.classList.remove(classes[otherMode]);
                });
            }
        },
        {
            key: "showErrorDisplay",
            value: function showErrorDisplay(_ref) {
                var _ref$message = _ref.message, message = _ref$message === void 0 ? "" : _ref$message, _ref$stack = _ref.stack, stack = _ref$stack === void 0 ? "" : _ref$stack;
                var header = message;
                var detail = stack;
                var parts = message.split("\n");
                if (parts.length > 1) {
                    var _parts = _slicedToArray(parts, 1);
                    header = _parts[0];
                    detail = parts.slice(1).join("\n");
                }
                document.getElementById("error-message").innerHTML = ansiConverter.toHtml(header);
                document.getElementById("error-stack").innerHTML = ansiConverter.toHtml(detail);
                this.showMode(Mode.ERROR);
            }
        },
        {
            key: "showNoPreview",
            value: function showNoPreview() {
                var _this$storyRoot, _this$docsRoot;
                if (this.testing) return;
                this.showMode(Mode.NOPREVIEW); // In storyshots this can get called and these two can be null
                (_this$storyRoot = this.storyRoot()) === null || _this$storyRoot === void 0 || _this$storyRoot.setAttribute("hidden", "true");
                (_this$docsRoot = this.docsRoot()) === null || _this$docsRoot === void 0 || _this$docsRoot.setAttribute("hidden", "true");
            }
        },
        {
            key: "showPreparingStory",
            value: function showPreparingStory() {
                var _this = this;
                var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref2$immediate = _ref2.immediate, immediate = _ref2$immediate === void 0 ? false : _ref2$immediate;
                clearTimeout(this.preparingTimeout);
                if (immediate) this.showMode(Mode.PREPARING_STORY);
                else this.preparingTimeout = setTimeout(function() {
                    return _this.showMode(Mode.PREPARING_STORY);
                }, PREPARING_DELAY);
            }
        },
        {
            key: "showPreparingDocs",
            value: function showPreparingDocs() {
                var _this2 = this;
                clearTimeout(this.preparingTimeout);
                this.preparingTimeout = setTimeout(function() {
                    return _this2.showMode(Mode.PREPARING_DOCS);
                }, PREPARING_DELAY);
            }
        },
        {
            key: "showMain",
            value: function showMain() {
                this.showMode(Mode.MAIN);
            }
        },
        {
            key: "showDocs",
            value: function showDocs() {
                this.storyRoot().setAttribute("hidden", "true");
                this.docsRoot().removeAttribute("hidden");
            }
        },
        {
            key: "showStory",
            value: function showStory() {
                this.docsRoot().setAttribute("hidden", "true");
                this.storyRoot().removeAttribute("hidden");
            }
        },
        {
            key: "showStoryDuringRender",
            value: function showStoryDuringRender() {
                // When 'showStory' is called (at the start of rendering) we get rid of our display:none
                // from all children of the root (but keep the preparing spinner visible). This may mean
                // that very weird and high z-index stories are briefly visible.
                // See https://github.com/storybookjs/storybook/issues/16847 and
                //   http://localhost:9011/?path=/story/core-rendering--auto-focus (official SB)
                document.body.classList.add(classes.MAIN);
            }
        }
    ]);
    return WebView;
}();

},{"core-js/modules/es.object.freeze.js":"9LVYO","core-js/modules/es.symbol.js":"ajw2f","core-js/modules/es.symbol.description.js":"wrlLc","core-js/modules/es.symbol.iterator.js":"fhNIb","core-js/modules/es.array.iterator.js":"ieU20","core-js/modules/es.string.iterator.js":"74a8v","core-js/modules/web.dom-collections.iterator.js":"aXR96","core-js/modules/es.function.name.js":"4LiLL","core-js/modules/es.array.from.js":"9UCQw","core-js/modules/es.regexp.exec.js":"5q56v","core-js/modules/es.string.search.js":"l1Pph","core-js/modules/es.array.join.js":"1w71h","core-js/modules/es.object.keys.js":"5Q2AT","core-js/modules/es.object.to-string.js":"lsA9p","core-js/modules/web.dom-collections.for-each.js":"iYT1M","core-js/modules/es.string.split.js":"12go2","core-js/modules/es.array.slice.js":"8RRh9","global":"5PzlO","@storybook/client-logger":"iGRus","ansi-to-html":"a3aIF","ts-dedent":"9RvVa","qs":"2jOAs","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"a3aIF":[function(require,module,exports) {
"use strict";
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
var entities = require("33e3d21bfd612a07");
var defaults = {
    fg: "#FFF",
    bg: "#000",
    newline: false,
    escapeXML: false,
    stream: false,
    colors: getDefaultColors()
};
function getDefaultColors() {
    var colors = {
        0: "#000",
        1: "#A00",
        2: "#0A0",
        3: "#A50",
        4: "#00A",
        5: "#A0A",
        6: "#0AA",
        7: "#AAA",
        8: "#555",
        9: "#F55",
        10: "#5F5",
        11: "#FF5",
        12: "#55F",
        13: "#F5F",
        14: "#5FF",
        15: "#FFF"
    };
    range(0, 5).forEach(function(red) {
        range(0, 5).forEach(function(green) {
            range(0, 5).forEach(function(blue) {
                return setStyleColor(red, green, blue, colors);
            });
        });
    });
    range(0, 23).forEach(function(gray) {
        var c = gray + 232;
        var l = toHexString(gray * 10 + 8);
        colors[c] = "#" + l + l + l;
    });
    return colors;
}
/**
 * @param {number} red
 * @param {number} green
 * @param {number} blue
 * @param {object} colors
 */ function setStyleColor(red, green, blue, colors) {
    var c = 16 + red * 36 + green * 6 + blue;
    var r = red > 0 ? red * 40 + 55 : 0;
    var g = green > 0 ? green * 40 + 55 : 0;
    var b = blue > 0 ? blue * 40 + 55 : 0;
    colors[c] = toColorHexString([
        r,
        g,
        b
    ]);
}
/**
 * Converts from a number like 15 to a hex string like 'F'
 * @param {number} num
 * @returns {string}
 */ function toHexString(num) {
    var str = num.toString(16);
    while(str.length < 2)str = "0" + str;
    return str;
}
/**
 * Converts from an array of numbers like [15, 15, 15] to a hex string like 'FFF'
 * @param {[red, green, blue]} ref
 * @returns {string}
 */ function toColorHexString(ref) {
    var results = [];
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;
    try {
        for(var _iterator = ref[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var r = _step.value;
            results.push(toHexString(r));
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) _iterator["return"]();
        } finally{
            if (_didIteratorError) throw _iteratorError;
        }
    }
    return "#" + results.join("");
}
/**
 * @param {Array} stack
 * @param {string} token
 * @param {*} data
 * @param {object} options
 */ function generateOutput(stack, token, data, options) {
    var result;
    if (token === "text") result = pushText(data, options);
    else if (token === "display") result = handleDisplay(stack, data, options);
    else if (token === "xterm256") result = pushForegroundColor(stack, options.colors[data]);
    else if (token === "rgb") result = handleRgb(stack, data);
    return result;
}
/**
 * @param {Array} stack
 * @param {string} data
 * @returns {*}
 */ function handleRgb(stack, data) {
    data = data.substring(2).slice(0, -1);
    var operation = +data.substr(0, 2);
    var color = data.substring(5).split(";");
    var rgb = color.map(function(value) {
        return ("0" + Number(value).toString(16)).substr(-2);
    }).join("");
    return pushStyle(stack, (operation === 38 ? "color:#" : "background-color:#") + rgb);
}
/**
 * @param {Array} stack
 * @param {number} code
 * @param {object} options
 * @returns {*}
 */ function handleDisplay(stack, code, options) {
    code = parseInt(code, 10);
    var codeMap = {
        "-1": function _() {
            return "<br/>";
        },
        0: function _() {
            return stack.length && resetStyles(stack);
        },
        1: function _() {
            return pushTag(stack, "b");
        },
        3: function _() {
            return pushTag(stack, "i");
        },
        4: function _() {
            return pushTag(stack, "u");
        },
        8: function _() {
            return pushStyle(stack, "display:none");
        },
        9: function _() {
            return pushTag(stack, "strike");
        },
        22: function _() {
            return pushStyle(stack, "font-weight:normal;text-decoration:none;font-style:normal");
        },
        23: function _() {
            return closeTag(stack, "i");
        },
        24: function _() {
            return closeTag(stack, "u");
        },
        39: function _() {
            return pushForegroundColor(stack, options.fg);
        },
        49: function _() {
            return pushBackgroundColor(stack, options.bg);
        },
        53: function _() {
            return pushStyle(stack, "text-decoration:overline");
        }
    };
    var result;
    if (codeMap[code]) result = codeMap[code]();
    else if (4 < code && code < 7) result = pushTag(stack, "blink");
    else if (29 < code && code < 38) result = pushForegroundColor(stack, options.colors[code - 30]);
    else if (39 < code && code < 48) result = pushBackgroundColor(stack, options.colors[code - 40]);
    else if (89 < code && code < 98) result = pushForegroundColor(stack, options.colors[8 + (code - 90)]);
    else if (99 < code && code < 108) result = pushBackgroundColor(stack, options.colors[8 + (code - 100)]);
    return result;
}
/**
 * Clear all the styles
 * @returns {string}
 */ function resetStyles(stack) {
    var stackClone = stack.slice(0);
    stack.length = 0;
    return stackClone.reverse().map(function(tag) {
        return "</" + tag + ">";
    }).join("");
}
/**
 * Creates an array of numbers ranging from low to high
 * @param {number} low
 * @param {number} high
 * @returns {Array}
 * @example range(3, 7); // creates [3, 4, 5, 6, 7]
 */ function range(low, high) {
    var results = [];
    for(var j = low; j <= high; j++)results.push(j);
    return results;
}
/**
 * Returns a new function that is true if value is NOT the same category
 * @param {string} category
 * @returns {function}
 */ function notCategory(category) {
    return function(e) {
        return (category === null || e.category !== category) && category !== "all";
    };
}
/**
 * Converts a code into an ansi token type
 * @param {number} code
 * @returns {string}
 */ function categoryForCode(code) {
    code = parseInt(code, 10);
    var result = null;
    if (code === 0) result = "all";
    else if (code === 1) result = "bold";
    else if (2 < code && code < 5) result = "underline";
    else if (4 < code && code < 7) result = "blink";
    else if (code === 8) result = "hide";
    else if (code === 9) result = "strike";
    else if (29 < code && code < 38 || code === 39 || 89 < code && code < 98) result = "foreground-color";
    else if (39 < code && code < 48 || code === 49 || 99 < code && code < 108) result = "background-color";
    return result;
}
/**
 * @param {string} text
 * @param {object} options
 * @returns {string}
 */ function pushText(text, options) {
    if (options.escapeXML) return entities.encodeXML(text);
    return text;
}
/**
 * @param {Array} stack
 * @param {string} tag
 * @param {string} [style='']
 * @returns {string}
 */ function pushTag(stack, tag, style) {
    if (!style) style = "";
    stack.push(tag);
    return [
        "<" + tag,
        style ? ' style="' + style + '"' : void 0,
        ">"
    ].join("");
}
/**
 * @param {Array} stack
 * @param {string} style
 * @returns {string}
 */ function pushStyle(stack, style) {
    return pushTag(stack, "span", style);
}
function pushForegroundColor(stack, color) {
    return pushTag(stack, "span", "color:" + color);
}
function pushBackgroundColor(stack, color) {
    return pushTag(stack, "span", "background-color:" + color);
}
/**
 * @param {Array} stack
 * @param {string} style
 * @returns {string}
 */ function closeTag(stack, style) {
    var last;
    if (stack.slice(-1)[0] === style) last = stack.pop();
    if (last) return "</" + style + ">";
}
/**
 * @param {string} text
 * @param {object} options
 * @param {function} callback
 * @returns {Array}
 */ function tokenize(text, options, callback) {
    var ansiMatch = false;
    var ansiHandler = 3;
    function remove() {
        return "";
    }
    function removeXterm256(m, g1) {
        callback("xterm256", g1);
        return "";
    }
    function newline(m) {
        if (options.newline) callback("display", -1);
        else callback("text", m);
        return "";
    }
    function ansiMess(m, g1) {
        ansiMatch = true;
        if (g1.trim().length === 0) g1 = "0";
        g1 = g1.trimRight(";").split(";");
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;
        try {
            for(var _iterator2 = g1[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                var g = _step2.value;
                callback("display", g);
            }
        } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion2 && _iterator2["return"] != null) _iterator2["return"]();
            } finally{
                if (_didIteratorError2) throw _iteratorError2;
            }
        }
        return "";
    }
    function realText(m) {
        callback("text", m);
        return "";
    }
    function rgb(m) {
        callback("rgb", m);
        return "";
    }
    /* eslint no-control-regex:0 */ var tokens = [
        {
            pattern: /^\x08+/,
            sub: remove
        },
        {
            pattern: /^\x1b\[[012]?K/,
            sub: remove
        },
        {
            pattern: /^\x1b\[\(B/,
            sub: remove
        },
        {
            pattern: /^\x1b\[[34]8;2;\d+;\d+;\d+m/,
            sub: rgb
        },
        {
            pattern: /^\x1b\[38;5;(\d+)m/,
            sub: removeXterm256
        },
        {
            pattern: /^\n/,
            sub: newline
        },
        {
            pattern: /^\r+\n/,
            sub: newline
        },
        {
            pattern: /^\x1b\[((?:\d{1,3};?)+|)m/,
            sub: ansiMess
        },
        {
            // CSI n J
            // ED - Erase in Display Clears part of the screen.
            // If n is 0 (or missing), clear from cursor to end of screen.
            // If n is 1, clear from cursor to beginning of the screen.
            // If n is 2, clear entire screen (and moves cursor to upper left on DOS ANSI.SYS).
            // If n is 3, clear entire screen and delete all lines saved in the scrollback buffer
            //   (this feature was added for xterm and is supported by other terminal applications).
            pattern: /^\x1b\[\d?J/,
            sub: remove
        },
        {
            // CSI n ; m f
            // HVP - Horizontal Vertical Position Same as CUP
            pattern: /^\x1b\[\d{0,3};\d{0,3}f/,
            sub: remove
        },
        {
            // catch-all for CSI sequences?
            pattern: /^\x1b\[?[\d;]{0,3}/,
            sub: remove
        },
        {
            /**
     * extracts real text - not containing:
     * - `\x1b' - ESC - escape (Ascii 27)
     * - '\x08' - BS - backspace (Ascii 8)
     * - `\n` - Newline - linefeed (LF) (ascii 10)
     * - `\r` - Windows Carriage Return (CR)
     */ pattern: /^(([^\x1b\x08\r\n])+)/,
            sub: realText
        }
    ];
    function process(handler, i) {
        if (i > ansiHandler && ansiMatch) return;
        ansiMatch = false;
        text = text.replace(handler.pattern, handler.sub);
    }
    var results1 = [];
    var _text = text, length = _text.length;
    outer: while(length > 0){
        for(var i = 0, o = 0, len = tokens.length; o < len; i = ++o){
            var handler = tokens[i];
            process(handler, i);
            if (text.length !== length) {
                // We matched a token and removed it from the text. We need to
                // start matching *all* tokens against the new text.
                length = text.length;
                continue outer;
            }
        }
        if (text.length === length) break;
        results1.push(0);
        length = text.length;
    }
    return results1;
}
/**
 * If streaming, then the stack is "sticky"
 *
 * @param {Array} stickyStack
 * @param {string} token
 * @param {*} data
 * @returns {Array}
 */ function updateStickyStack(stickyStack, token, data) {
    if (token !== "text") {
        stickyStack = stickyStack.filter(notCategory(categoryForCode(data)));
        stickyStack.push({
            token: token,
            data: data,
            category: categoryForCode(data)
        });
    }
    return stickyStack;
}
var Filter = /*#__PURE__*/ function() {
    /**
   * @param {object} options
   * @param {string=} options.fg The default foreground color used when reset color codes are encountered.
   * @param {string=} options.bg The default background color used when reset color codes are encountered.
   * @param {boolean=} options.newline Convert newline characters to `<br/>`.
   * @param {boolean=} options.escapeXML Generate HTML/XML entities.
   * @param {boolean=} options.stream Save style state across invocations of `toHtml()`.
   * @param {(string[] | {[code: number]: string})=} options.colors Can override specific colors or the entire ANSI palette.
   */ function Filter(options) {
        _classCallCheck(this, Filter);
        options = options || {};
        if (options.colors) options.colors = Object.assign({}, defaults.colors, options.colors);
        this.options = Object.assign({}, defaults, options);
        this.stack = [];
        this.stickyStack = [];
    }
    /**
   * @param {string | string[]} input
   * @returns {string}
   */ _createClass(Filter, [
        {
            key: "toHtml",
            value: function toHtml(input) {
                var _this = this;
                input = typeof input === "string" ? [
                    input
                ] : input;
                var stack = this.stack, options = this.options;
                var buf = [];
                this.stickyStack.forEach(function(element) {
                    var output = generateOutput(stack, element.token, element.data, options);
                    if (output) buf.push(output);
                });
                tokenize(input.join(""), options, function(token, data) {
                    var output = generateOutput(stack, token, data, options);
                    if (output) buf.push(output);
                    if (options.stream) _this.stickyStack = updateStickyStack(_this.stickyStack, token, data);
                });
                if (stack.length) buf.push(resetStyles(stack));
                return buf.join("");
            }
        }
    ]);
    return Filter;
}();
module.exports = Filter;

},{"33e3d21bfd612a07":"dXT5D"}],"dXT5D":[function(require,module,exports) {
var encode = require("f5e27efae4be6fc3"), decode = require("149fde71211f400f");
exports.decode = function(data, level) {
    return (!level || level <= 0 ? decode.XML : decode.HTML)(data);
};
exports.decodeStrict = function(data, level) {
    return (!level || level <= 0 ? decode.XML : decode.HTMLStrict)(data);
};
exports.encode = function(data, level) {
    return (!level || level <= 0 ? encode.XML : encode.HTML)(data);
};
exports.encodeXML = encode.XML;
exports.encodeHTML4 = exports.encodeHTML5 = exports.encodeHTML = encode.HTML;
exports.decodeXML = exports.decodeXMLStrict = decode.XML;
exports.decodeHTML4 = exports.decodeHTML5 = exports.decodeHTML = decode.HTML;
exports.decodeHTML4Strict = exports.decodeHTML5Strict = exports.decodeHTMLStrict = decode.HTMLStrict;
exports.escape = encode.escape;

},{"f5e27efae4be6fc3":"lqzI9","149fde71211f400f":"lnSgD"}],"lqzI9":[function(require,module,exports) {
var inverseXML = getInverseObj(require("5a2b3570ea00149c")), xmlReplacer = getInverseReplacer(inverseXML);
exports.XML = getInverse(inverseXML, xmlReplacer);
var inverseHTML = getInverseObj(require("df174c242d0d8cb8")), htmlReplacer = getInverseReplacer(inverseHTML);
exports.HTML = getInverse(inverseHTML, htmlReplacer);
function getInverseObj(obj) {
    return Object.keys(obj).sort().reduce(function(inverse, name) {
        inverse[obj[name]] = "&" + name + ";";
        return inverse;
    }, {});
}
function getInverseReplacer(inverse) {
    var single = [], multiple = [];
    Object.keys(inverse).forEach(function(k) {
        if (k.length === 1) single.push("\\" + k);
        else multiple.push(k);
    });
    //TODO add ranges
    multiple.unshift("[" + single.join("") + "]");
    return new RegExp(multiple.join("|"), "g");
}
var re_nonASCII = /[^\0-\x7F]/g, re_astralSymbols = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g;
function singleCharReplacer(c) {
    return "&#x" + c.charCodeAt(0).toString(16).toUpperCase() + ";";
}
function astralReplacer(c) {
    // http://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
    var high = c.charCodeAt(0);
    var low = c.charCodeAt(1);
    var codePoint = (high - 0xd800) * 0x400 + low - 0xdc00 + 0x10000;
    return "&#x" + codePoint.toString(16).toUpperCase() + ";";
}
function getInverse(inverse, re) {
    function func(name) {
        return inverse[name];
    }
    return function(data) {
        return data.replace(re, func).replace(re_astralSymbols, astralReplacer).replace(re_nonASCII, singleCharReplacer);
    };
}
var re_xmlChars = getInverseReplacer(inverseXML);
function escapeXML(data) {
    return data.replace(re_xmlChars, singleCharReplacer).replace(re_astralSymbols, astralReplacer).replace(re_nonASCII, singleCharReplacer);
}
exports.escape = escapeXML;

},{"5a2b3570ea00149c":"ejuI2","df174c242d0d8cb8":"6cmUh"}],"ejuI2":[function(require,module,exports) {
module.exports = JSON.parse('{"amp":"&","apos":"\'","gt":">","lt":"<","quot":"\\""}');

},{}],"6cmUh":[function(require,module,exports) {
module.exports = JSON.parse('{"Aacute":"\xc1","aacute":"\xe1","Abreve":"\u0102","abreve":"\u0103","ac":"\u223E","acd":"\u223F","acE":"\u223E\u0333","Acirc":"\xc2","acirc":"\xe2","acute":"\xb4","Acy":"\u0410","acy":"\u0430","AElig":"\xc6","aelig":"\xe6","af":"\u2061","Afr":"\uD835\uDD04","afr":"\uD835\uDD1E","Agrave":"\xc0","agrave":"\xe0","alefsym":"\u2135","aleph":"\u2135","Alpha":"\u0391","alpha":"\u03B1","Amacr":"\u0100","amacr":"\u0101","amalg":"\u2A3F","amp":"&","AMP":"&","andand":"\u2A55","And":"\u2A53","and":"\u2227","andd":"\u2A5C","andslope":"\u2A58","andv":"\u2A5A","ang":"\u2220","ange":"\u29A4","angle":"\u2220","angmsdaa":"\u29A8","angmsdab":"\u29A9","angmsdac":"\u29AA","angmsdad":"\u29AB","angmsdae":"\u29AC","angmsdaf":"\u29AD","angmsdag":"\u29AE","angmsdah":"\u29AF","angmsd":"\u2221","angrt":"\u221F","angrtvb":"\u22BE","angrtvbd":"\u299D","angsph":"\u2222","angst":"\xc5","angzarr":"\u237C","Aogon":"\u0104","aogon":"\u0105","Aopf":"\uD835\uDD38","aopf":"\uD835\uDD52","apacir":"\u2A6F","ap":"\u2248","apE":"\u2A70","ape":"\u224A","apid":"\u224B","apos":"\'","ApplyFunction":"\u2061","approx":"\u2248","approxeq":"\u224A","Aring":"\xc5","aring":"\xe5","Ascr":"\uD835\uDC9C","ascr":"\uD835\uDCB6","Assign":"\u2254","ast":"*","asymp":"\u2248","asympeq":"\u224D","Atilde":"\xc3","atilde":"\xe3","Auml":"\xc4","auml":"\xe4","awconint":"\u2233","awint":"\u2A11","backcong":"\u224C","backepsilon":"\u03F6","backprime":"\u2035","backsim":"\u223D","backsimeq":"\u22CD","Backslash":"\u2216","Barv":"\u2AE7","barvee":"\u22BD","barwed":"\u2305","Barwed":"\u2306","barwedge":"\u2305","bbrk":"\u23B5","bbrktbrk":"\u23B6","bcong":"\u224C","Bcy":"\u0411","bcy":"\u0431","bdquo":"\u201E","becaus":"\u2235","because":"\u2235","Because":"\u2235","bemptyv":"\u29B0","bepsi":"\u03F6","bernou":"\u212C","Bernoullis":"\u212C","Beta":"\u0392","beta":"\u03B2","beth":"\u2136","between":"\u226C","Bfr":"\uD835\uDD05","bfr":"\uD835\uDD1F","bigcap":"\u22C2","bigcirc":"\u25EF","bigcup":"\u22C3","bigodot":"\u2A00","bigoplus":"\u2A01","bigotimes":"\u2A02","bigsqcup":"\u2A06","bigstar":"\u2605","bigtriangledown":"\u25BD","bigtriangleup":"\u25B3","biguplus":"\u2A04","bigvee":"\u22C1","bigwedge":"\u22C0","bkarow":"\u290D","blacklozenge":"\u29EB","blacksquare":"\u25AA","blacktriangle":"\u25B4","blacktriangledown":"\u25BE","blacktriangleleft":"\u25C2","blacktriangleright":"\u25B8","blank":"\u2423","blk12":"\u2592","blk14":"\u2591","blk34":"\u2593","block":"\u2588","bne":"=\u20E5","bnequiv":"\u2261\u20E5","bNot":"\u2AED","bnot":"\u2310","Bopf":"\uD835\uDD39","bopf":"\uD835\uDD53","bot":"\u22A5","bottom":"\u22A5","bowtie":"\u22C8","boxbox":"\u29C9","boxdl":"\u2510","boxdL":"\u2555","boxDl":"\u2556","boxDL":"\u2557","boxdr":"\u250C","boxdR":"\u2552","boxDr":"\u2553","boxDR":"\u2554","boxh":"\u2500","boxH":"\u2550","boxhd":"\u252C","boxHd":"\u2564","boxhD":"\u2565","boxHD":"\u2566","boxhu":"\u2534","boxHu":"\u2567","boxhU":"\u2568","boxHU":"\u2569","boxminus":"\u229F","boxplus":"\u229E","boxtimes":"\u22A0","boxul":"\u2518","boxuL":"\u255B","boxUl":"\u255C","boxUL":"\u255D","boxur":"\u2514","boxuR":"\u2558","boxUr":"\u2559","boxUR":"\u255A","boxv":"\u2502","boxV":"\u2551","boxvh":"\u253C","boxvH":"\u256A","boxVh":"\u256B","boxVH":"\u256C","boxvl":"\u2524","boxvL":"\u2561","boxVl":"\u2562","boxVL":"\u2563","boxvr":"\u251C","boxvR":"\u255E","boxVr":"\u255F","boxVR":"\u2560","bprime":"\u2035","breve":"\u02D8","Breve":"\u02D8","brvbar":"\xa6","bscr":"\uD835\uDCB7","Bscr":"\u212C","bsemi":"\u204F","bsim":"\u223D","bsime":"\u22CD","bsolb":"\u29C5","bsol":"\\\\","bsolhsub":"\u27C8","bull":"\u2022","bullet":"\u2022","bump":"\u224E","bumpE":"\u2AAE","bumpe":"\u224F","Bumpeq":"\u224E","bumpeq":"\u224F","Cacute":"\u0106","cacute":"\u0107","capand":"\u2A44","capbrcup":"\u2A49","capcap":"\u2A4B","cap":"\u2229","Cap":"\u22D2","capcup":"\u2A47","capdot":"\u2A40","CapitalDifferentialD":"\u2145","caps":"\u2229\uFE00","caret":"\u2041","caron":"\u02C7","Cayleys":"\u212D","ccaps":"\u2A4D","Ccaron":"\u010C","ccaron":"\u010D","Ccedil":"\xc7","ccedil":"\xe7","Ccirc":"\u0108","ccirc":"\u0109","Cconint":"\u2230","ccups":"\u2A4C","ccupssm":"\u2A50","Cdot":"\u010A","cdot":"\u010B","cedil":"\xb8","Cedilla":"\xb8","cemptyv":"\u29B2","cent":"\xa2","centerdot":"\xb7","CenterDot":"\xb7","cfr":"\uD835\uDD20","Cfr":"\u212D","CHcy":"\u0427","chcy":"\u0447","check":"\u2713","checkmark":"\u2713","Chi":"\u03A7","chi":"\u03C7","circ":"\u02C6","circeq":"\u2257","circlearrowleft":"\u21BA","circlearrowright":"\u21BB","circledast":"\u229B","circledcirc":"\u229A","circleddash":"\u229D","CircleDot":"\u2299","circledR":"\xae","circledS":"\u24C8","CircleMinus":"\u2296","CirclePlus":"\u2295","CircleTimes":"\u2297","cir":"\u25CB","cirE":"\u29C3","cire":"\u2257","cirfnint":"\u2A10","cirmid":"\u2AEF","cirscir":"\u29C2","ClockwiseContourIntegral":"\u2232","CloseCurlyDoubleQuote":"\u201D","CloseCurlyQuote":"\u2019","clubs":"\u2663","clubsuit":"\u2663","colon":":","Colon":"\u2237","Colone":"\u2A74","colone":"\u2254","coloneq":"\u2254","comma":",","commat":"@","comp":"\u2201","compfn":"\u2218","complement":"\u2201","complexes":"\u2102","cong":"\u2245","congdot":"\u2A6D","Congruent":"\u2261","conint":"\u222E","Conint":"\u222F","ContourIntegral":"\u222E","copf":"\uD835\uDD54","Copf":"\u2102","coprod":"\u2210","Coproduct":"\u2210","copy":"\xa9","COPY":"\xa9","copysr":"\u2117","CounterClockwiseContourIntegral":"\u2233","crarr":"\u21B5","cross":"\u2717","Cross":"\u2A2F","Cscr":"\uD835\uDC9E","cscr":"\uD835\uDCB8","csub":"\u2ACF","csube":"\u2AD1","csup":"\u2AD0","csupe":"\u2AD2","ctdot":"\u22EF","cudarrl":"\u2938","cudarrr":"\u2935","cuepr":"\u22DE","cuesc":"\u22DF","cularr":"\u21B6","cularrp":"\u293D","cupbrcap":"\u2A48","cupcap":"\u2A46","CupCap":"\u224D","cup":"\u222A","Cup":"\u22D3","cupcup":"\u2A4A","cupdot":"\u228D","cupor":"\u2A45","cups":"\u222A\uFE00","curarr":"\u21B7","curarrm":"\u293C","curlyeqprec":"\u22DE","curlyeqsucc":"\u22DF","curlyvee":"\u22CE","curlywedge":"\u22CF","curren":"\xa4","curvearrowleft":"\u21B6","curvearrowright":"\u21B7","cuvee":"\u22CE","cuwed":"\u22CF","cwconint":"\u2232","cwint":"\u2231","cylcty":"\u232D","dagger":"\u2020","Dagger":"\u2021","daleth":"\u2138","darr":"\u2193","Darr":"\u21A1","dArr":"\u21D3","dash":"\u2010","Dashv":"\u2AE4","dashv":"\u22A3","dbkarow":"\u290F","dblac":"\u02DD","Dcaron":"\u010E","dcaron":"\u010F","Dcy":"\u0414","dcy":"\u0434","ddagger":"\u2021","ddarr":"\u21CA","DD":"\u2145","dd":"\u2146","DDotrahd":"\u2911","ddotseq":"\u2A77","deg":"\xb0","Del":"\u2207","Delta":"\u0394","delta":"\u03B4","demptyv":"\u29B1","dfisht":"\u297F","Dfr":"\uD835\uDD07","dfr":"\uD835\uDD21","dHar":"\u2965","dharl":"\u21C3","dharr":"\u21C2","DiacriticalAcute":"\xb4","DiacriticalDot":"\u02D9","DiacriticalDoubleAcute":"\u02DD","DiacriticalGrave":"`","DiacriticalTilde":"\u02DC","diam":"\u22C4","diamond":"\u22C4","Diamond":"\u22C4","diamondsuit":"\u2666","diams":"\u2666","die":"\xa8","DifferentialD":"\u2146","digamma":"\u03DD","disin":"\u22F2","div":"\xf7","divide":"\xf7","divideontimes":"\u22C7","divonx":"\u22C7","DJcy":"\u0402","djcy":"\u0452","dlcorn":"\u231E","dlcrop":"\u230D","dollar":"$","Dopf":"\uD835\uDD3B","dopf":"\uD835\uDD55","Dot":"\xa8","dot":"\u02D9","DotDot":"\u20DC","doteq":"\u2250","doteqdot":"\u2251","DotEqual":"\u2250","dotminus":"\u2238","dotplus":"\u2214","dotsquare":"\u22A1","doublebarwedge":"\u2306","DoubleContourIntegral":"\u222F","DoubleDot":"\xa8","DoubleDownArrow":"\u21D3","DoubleLeftArrow":"\u21D0","DoubleLeftRightArrow":"\u21D4","DoubleLeftTee":"\u2AE4","DoubleLongLeftArrow":"\u27F8","DoubleLongLeftRightArrow":"\u27FA","DoubleLongRightArrow":"\u27F9","DoubleRightArrow":"\u21D2","DoubleRightTee":"\u22A8","DoubleUpArrow":"\u21D1","DoubleUpDownArrow":"\u21D5","DoubleVerticalBar":"\u2225","DownArrowBar":"\u2913","downarrow":"\u2193","DownArrow":"\u2193","Downarrow":"\u21D3","DownArrowUpArrow":"\u21F5","DownBreve":"\u0311","downdownarrows":"\u21CA","downharpoonleft":"\u21C3","downharpoonright":"\u21C2","DownLeftRightVector":"\u2950","DownLeftTeeVector":"\u295E","DownLeftVectorBar":"\u2956","DownLeftVector":"\u21BD","DownRightTeeVector":"\u295F","DownRightVectorBar":"\u2957","DownRightVector":"\u21C1","DownTeeArrow":"\u21A7","DownTee":"\u22A4","drbkarow":"\u2910","drcorn":"\u231F","drcrop":"\u230C","Dscr":"\uD835\uDC9F","dscr":"\uD835\uDCB9","DScy":"\u0405","dscy":"\u0455","dsol":"\u29F6","Dstrok":"\u0110","dstrok":"\u0111","dtdot":"\u22F1","dtri":"\u25BF","dtrif":"\u25BE","duarr":"\u21F5","duhar":"\u296F","dwangle":"\u29A6","DZcy":"\u040F","dzcy":"\u045F","dzigrarr":"\u27FF","Eacute":"\xc9","eacute":"\xe9","easter":"\u2A6E","Ecaron":"\u011A","ecaron":"\u011B","Ecirc":"\xca","ecirc":"\xea","ecir":"\u2256","ecolon":"\u2255","Ecy":"\u042D","ecy":"\u044D","eDDot":"\u2A77","Edot":"\u0116","edot":"\u0117","eDot":"\u2251","ee":"\u2147","efDot":"\u2252","Efr":"\uD835\uDD08","efr":"\uD835\uDD22","eg":"\u2A9A","Egrave":"\xc8","egrave":"\xe8","egs":"\u2A96","egsdot":"\u2A98","el":"\u2A99","Element":"\u2208","elinters":"\u23E7","ell":"\u2113","els":"\u2A95","elsdot":"\u2A97","Emacr":"\u0112","emacr":"\u0113","empty":"\u2205","emptyset":"\u2205","EmptySmallSquare":"\u25FB","emptyv":"\u2205","EmptyVerySmallSquare":"\u25AB","emsp13":"\u2004","emsp14":"\u2005","emsp":"\u2003","ENG":"\u014A","eng":"\u014B","ensp":"\u2002","Eogon":"\u0118","eogon":"\u0119","Eopf":"\uD835\uDD3C","eopf":"\uD835\uDD56","epar":"\u22D5","eparsl":"\u29E3","eplus":"\u2A71","epsi":"\u03B5","Epsilon":"\u0395","epsilon":"\u03B5","epsiv":"\u03F5","eqcirc":"\u2256","eqcolon":"\u2255","eqsim":"\u2242","eqslantgtr":"\u2A96","eqslantless":"\u2A95","Equal":"\u2A75","equals":"=","EqualTilde":"\u2242","equest":"\u225F","Equilibrium":"\u21CC","equiv":"\u2261","equivDD":"\u2A78","eqvparsl":"\u29E5","erarr":"\u2971","erDot":"\u2253","escr":"\u212F","Escr":"\u2130","esdot":"\u2250","Esim":"\u2A73","esim":"\u2242","Eta":"\u0397","eta":"\u03B7","ETH":"\xd0","eth":"\xf0","Euml":"\xcb","euml":"\xeb","euro":"\u20AC","excl":"!","exist":"\u2203","Exists":"\u2203","expectation":"\u2130","exponentiale":"\u2147","ExponentialE":"\u2147","fallingdotseq":"\u2252","Fcy":"\u0424","fcy":"\u0444","female":"\u2640","ffilig":"\uFB03","fflig":"\uFB00","ffllig":"\uFB04","Ffr":"\uD835\uDD09","ffr":"\uD835\uDD23","filig":"\uFB01","FilledSmallSquare":"\u25FC","FilledVerySmallSquare":"\u25AA","fjlig":"fj","flat":"\u266D","fllig":"\uFB02","fltns":"\u25B1","fnof":"\u0192","Fopf":"\uD835\uDD3D","fopf":"\uD835\uDD57","forall":"\u2200","ForAll":"\u2200","fork":"\u22D4","forkv":"\u2AD9","Fouriertrf":"\u2131","fpartint":"\u2A0D","frac12":"\xbd","frac13":"\u2153","frac14":"\xbc","frac15":"\u2155","frac16":"\u2159","frac18":"\u215B","frac23":"\u2154","frac25":"\u2156","frac34":"\xbe","frac35":"\u2157","frac38":"\u215C","frac45":"\u2158","frac56":"\u215A","frac58":"\u215D","frac78":"\u215E","frasl":"\u2044","frown":"\u2322","fscr":"\uD835\uDCBB","Fscr":"\u2131","gacute":"\u01F5","Gamma":"\u0393","gamma":"\u03B3","Gammad":"\u03DC","gammad":"\u03DD","gap":"\u2A86","Gbreve":"\u011E","gbreve":"\u011F","Gcedil":"\u0122","Gcirc":"\u011C","gcirc":"\u011D","Gcy":"\u0413","gcy":"\u0433","Gdot":"\u0120","gdot":"\u0121","ge":"\u2265","gE":"\u2267","gEl":"\u2A8C","gel":"\u22DB","geq":"\u2265","geqq":"\u2267","geqslant":"\u2A7E","gescc":"\u2AA9","ges":"\u2A7E","gesdot":"\u2A80","gesdoto":"\u2A82","gesdotol":"\u2A84","gesl":"\u22DB\uFE00","gesles":"\u2A94","Gfr":"\uD835\uDD0A","gfr":"\uD835\uDD24","gg":"\u226B","Gg":"\u22D9","ggg":"\u22D9","gimel":"\u2137","GJcy":"\u0403","gjcy":"\u0453","gla":"\u2AA5","gl":"\u2277","glE":"\u2A92","glj":"\u2AA4","gnap":"\u2A8A","gnapprox":"\u2A8A","gne":"\u2A88","gnE":"\u2269","gneq":"\u2A88","gneqq":"\u2269","gnsim":"\u22E7","Gopf":"\uD835\uDD3E","gopf":"\uD835\uDD58","grave":"`","GreaterEqual":"\u2265","GreaterEqualLess":"\u22DB","GreaterFullEqual":"\u2267","GreaterGreater":"\u2AA2","GreaterLess":"\u2277","GreaterSlantEqual":"\u2A7E","GreaterTilde":"\u2273","Gscr":"\uD835\uDCA2","gscr":"\u210A","gsim":"\u2273","gsime":"\u2A8E","gsiml":"\u2A90","gtcc":"\u2AA7","gtcir":"\u2A7A","gt":">","GT":">","Gt":"\u226B","gtdot":"\u22D7","gtlPar":"\u2995","gtquest":"\u2A7C","gtrapprox":"\u2A86","gtrarr":"\u2978","gtrdot":"\u22D7","gtreqless":"\u22DB","gtreqqless":"\u2A8C","gtrless":"\u2277","gtrsim":"\u2273","gvertneqq":"\u2269\uFE00","gvnE":"\u2269\uFE00","Hacek":"\u02C7","hairsp":"\u200A","half":"\xbd","hamilt":"\u210B","HARDcy":"\u042A","hardcy":"\u044A","harrcir":"\u2948","harr":"\u2194","hArr":"\u21D4","harrw":"\u21AD","Hat":"^","hbar":"\u210F","Hcirc":"\u0124","hcirc":"\u0125","hearts":"\u2665","heartsuit":"\u2665","hellip":"\u2026","hercon":"\u22B9","hfr":"\uD835\uDD25","Hfr":"\u210C","HilbertSpace":"\u210B","hksearow":"\u2925","hkswarow":"\u2926","hoarr":"\u21FF","homtht":"\u223B","hookleftarrow":"\u21A9","hookrightarrow":"\u21AA","hopf":"\uD835\uDD59","Hopf":"\u210D","horbar":"\u2015","HorizontalLine":"\u2500","hscr":"\uD835\uDCBD","Hscr":"\u210B","hslash":"\u210F","Hstrok":"\u0126","hstrok":"\u0127","HumpDownHump":"\u224E","HumpEqual":"\u224F","hybull":"\u2043","hyphen":"\u2010","Iacute":"\xcd","iacute":"\xed","ic":"\u2063","Icirc":"\xce","icirc":"\xee","Icy":"\u0418","icy":"\u0438","Idot":"\u0130","IEcy":"\u0415","iecy":"\u0435","iexcl":"\xa1","iff":"\u21D4","ifr":"\uD835\uDD26","Ifr":"\u2111","Igrave":"\xcc","igrave":"\xec","ii":"\u2148","iiiint":"\u2A0C","iiint":"\u222D","iinfin":"\u29DC","iiota":"\u2129","IJlig":"\u0132","ijlig":"\u0133","Imacr":"\u012A","imacr":"\u012B","image":"\u2111","ImaginaryI":"\u2148","imagline":"\u2110","imagpart":"\u2111","imath":"\u0131","Im":"\u2111","imof":"\u22B7","imped":"\u01B5","Implies":"\u21D2","incare":"\u2105","in":"\u2208","infin":"\u221E","infintie":"\u29DD","inodot":"\u0131","intcal":"\u22BA","int":"\u222B","Int":"\u222C","integers":"\u2124","Integral":"\u222B","intercal":"\u22BA","Intersection":"\u22C2","intlarhk":"\u2A17","intprod":"\u2A3C","InvisibleComma":"\u2063","InvisibleTimes":"\u2062","IOcy":"\u0401","iocy":"\u0451","Iogon":"\u012E","iogon":"\u012F","Iopf":"\uD835\uDD40","iopf":"\uD835\uDD5A","Iota":"\u0399","iota":"\u03B9","iprod":"\u2A3C","iquest":"\xbf","iscr":"\uD835\uDCBE","Iscr":"\u2110","isin":"\u2208","isindot":"\u22F5","isinE":"\u22F9","isins":"\u22F4","isinsv":"\u22F3","isinv":"\u2208","it":"\u2062","Itilde":"\u0128","itilde":"\u0129","Iukcy":"\u0406","iukcy":"\u0456","Iuml":"\xcf","iuml":"\xef","Jcirc":"\u0134","jcirc":"\u0135","Jcy":"\u0419","jcy":"\u0439","Jfr":"\uD835\uDD0D","jfr":"\uD835\uDD27","jmath":"\u0237","Jopf":"\uD835\uDD41","jopf":"\uD835\uDD5B","Jscr":"\uD835\uDCA5","jscr":"\uD835\uDCBF","Jsercy":"\u0408","jsercy":"\u0458","Jukcy":"\u0404","jukcy":"\u0454","Kappa":"\u039A","kappa":"\u03BA","kappav":"\u03F0","Kcedil":"\u0136","kcedil":"\u0137","Kcy":"\u041A","kcy":"\u043A","Kfr":"\uD835\uDD0E","kfr":"\uD835\uDD28","kgreen":"\u0138","KHcy":"\u0425","khcy":"\u0445","KJcy":"\u040C","kjcy":"\u045C","Kopf":"\uD835\uDD42","kopf":"\uD835\uDD5C","Kscr":"\uD835\uDCA6","kscr":"\uD835\uDCC0","lAarr":"\u21DA","Lacute":"\u0139","lacute":"\u013A","laemptyv":"\u29B4","lagran":"\u2112","Lambda":"\u039B","lambda":"\u03BB","lang":"\u27E8","Lang":"\u27EA","langd":"\u2991","langle":"\u27E8","lap":"\u2A85","Laplacetrf":"\u2112","laquo":"\xab","larrb":"\u21E4","larrbfs":"\u291F","larr":"\u2190","Larr":"\u219E","lArr":"\u21D0","larrfs":"\u291D","larrhk":"\u21A9","larrlp":"\u21AB","larrpl":"\u2939","larrsim":"\u2973","larrtl":"\u21A2","latail":"\u2919","lAtail":"\u291B","lat":"\u2AAB","late":"\u2AAD","lates":"\u2AAD\uFE00","lbarr":"\u290C","lBarr":"\u290E","lbbrk":"\u2772","lbrace":"{","lbrack":"[","lbrke":"\u298B","lbrksld":"\u298F","lbrkslu":"\u298D","Lcaron":"\u013D","lcaron":"\u013E","Lcedil":"\u013B","lcedil":"\u013C","lceil":"\u2308","lcub":"{","Lcy":"\u041B","lcy":"\u043B","ldca":"\u2936","ldquo":"\u201C","ldquor":"\u201E","ldrdhar":"\u2967","ldrushar":"\u294B","ldsh":"\u21B2","le":"\u2264","lE":"\u2266","LeftAngleBracket":"\u27E8","LeftArrowBar":"\u21E4","leftarrow":"\u2190","LeftArrow":"\u2190","Leftarrow":"\u21D0","LeftArrowRightArrow":"\u21C6","leftarrowtail":"\u21A2","LeftCeiling":"\u2308","LeftDoubleBracket":"\u27E6","LeftDownTeeVector":"\u2961","LeftDownVectorBar":"\u2959","LeftDownVector":"\u21C3","LeftFloor":"\u230A","leftharpoondown":"\u21BD","leftharpoonup":"\u21BC","leftleftarrows":"\u21C7","leftrightarrow":"\u2194","LeftRightArrow":"\u2194","Leftrightarrow":"\u21D4","leftrightarrows":"\u21C6","leftrightharpoons":"\u21CB","leftrightsquigarrow":"\u21AD","LeftRightVector":"\u294E","LeftTeeArrow":"\u21A4","LeftTee":"\u22A3","LeftTeeVector":"\u295A","leftthreetimes":"\u22CB","LeftTriangleBar":"\u29CF","LeftTriangle":"\u22B2","LeftTriangleEqual":"\u22B4","LeftUpDownVector":"\u2951","LeftUpTeeVector":"\u2960","LeftUpVectorBar":"\u2958","LeftUpVector":"\u21BF","LeftVectorBar":"\u2952","LeftVector":"\u21BC","lEg":"\u2A8B","leg":"\u22DA","leq":"\u2264","leqq":"\u2266","leqslant":"\u2A7D","lescc":"\u2AA8","les":"\u2A7D","lesdot":"\u2A7F","lesdoto":"\u2A81","lesdotor":"\u2A83","lesg":"\u22DA\uFE00","lesges":"\u2A93","lessapprox":"\u2A85","lessdot":"\u22D6","lesseqgtr":"\u22DA","lesseqqgtr":"\u2A8B","LessEqualGreater":"\u22DA","LessFullEqual":"\u2266","LessGreater":"\u2276","lessgtr":"\u2276","LessLess":"\u2AA1","lesssim":"\u2272","LessSlantEqual":"\u2A7D","LessTilde":"\u2272","lfisht":"\u297C","lfloor":"\u230A","Lfr":"\uD835\uDD0F","lfr":"\uD835\uDD29","lg":"\u2276","lgE":"\u2A91","lHar":"\u2962","lhard":"\u21BD","lharu":"\u21BC","lharul":"\u296A","lhblk":"\u2584","LJcy":"\u0409","ljcy":"\u0459","llarr":"\u21C7","ll":"\u226A","Ll":"\u22D8","llcorner":"\u231E","Lleftarrow":"\u21DA","llhard":"\u296B","lltri":"\u25FA","Lmidot":"\u013F","lmidot":"\u0140","lmoustache":"\u23B0","lmoust":"\u23B0","lnap":"\u2A89","lnapprox":"\u2A89","lne":"\u2A87","lnE":"\u2268","lneq":"\u2A87","lneqq":"\u2268","lnsim":"\u22E6","loang":"\u27EC","loarr":"\u21FD","lobrk":"\u27E6","longleftarrow":"\u27F5","LongLeftArrow":"\u27F5","Longleftarrow":"\u27F8","longleftrightarrow":"\u27F7","LongLeftRightArrow":"\u27F7","Longleftrightarrow":"\u27FA","longmapsto":"\u27FC","longrightarrow":"\u27F6","LongRightArrow":"\u27F6","Longrightarrow":"\u27F9","looparrowleft":"\u21AB","looparrowright":"\u21AC","lopar":"\u2985","Lopf":"\uD835\uDD43","lopf":"\uD835\uDD5D","loplus":"\u2A2D","lotimes":"\u2A34","lowast":"\u2217","lowbar":"_","LowerLeftArrow":"\u2199","LowerRightArrow":"\u2198","loz":"\u25CA","lozenge":"\u25CA","lozf":"\u29EB","lpar":"(","lparlt":"\u2993","lrarr":"\u21C6","lrcorner":"\u231F","lrhar":"\u21CB","lrhard":"\u296D","lrm":"\u200E","lrtri":"\u22BF","lsaquo":"\u2039","lscr":"\uD835\uDCC1","Lscr":"\u2112","lsh":"\u21B0","Lsh":"\u21B0","lsim":"\u2272","lsime":"\u2A8D","lsimg":"\u2A8F","lsqb":"[","lsquo":"\u2018","lsquor":"\u201A","Lstrok":"\u0141","lstrok":"\u0142","ltcc":"\u2AA6","ltcir":"\u2A79","lt":"<","LT":"<","Lt":"\u226A","ltdot":"\u22D6","lthree":"\u22CB","ltimes":"\u22C9","ltlarr":"\u2976","ltquest":"\u2A7B","ltri":"\u25C3","ltrie":"\u22B4","ltrif":"\u25C2","ltrPar":"\u2996","lurdshar":"\u294A","luruhar":"\u2966","lvertneqq":"\u2268\uFE00","lvnE":"\u2268\uFE00","macr":"\xaf","male":"\u2642","malt":"\u2720","maltese":"\u2720","Map":"\u2905","map":"\u21A6","mapsto":"\u21A6","mapstodown":"\u21A7","mapstoleft":"\u21A4","mapstoup":"\u21A5","marker":"\u25AE","mcomma":"\u2A29","Mcy":"\u041C","mcy":"\u043C","mdash":"\u2014","mDDot":"\u223A","measuredangle":"\u2221","MediumSpace":"\u205F","Mellintrf":"\u2133","Mfr":"\uD835\uDD10","mfr":"\uD835\uDD2A","mho":"\u2127","micro":"\xb5","midast":"*","midcir":"\u2AF0","mid":"\u2223","middot":"\xb7","minusb":"\u229F","minus":"\u2212","minusd":"\u2238","minusdu":"\u2A2A","MinusPlus":"\u2213","mlcp":"\u2ADB","mldr":"\u2026","mnplus":"\u2213","models":"\u22A7","Mopf":"\uD835\uDD44","mopf":"\uD835\uDD5E","mp":"\u2213","mscr":"\uD835\uDCC2","Mscr":"\u2133","mstpos":"\u223E","Mu":"\u039C","mu":"\u03BC","multimap":"\u22B8","mumap":"\u22B8","nabla":"\u2207","Nacute":"\u0143","nacute":"\u0144","nang":"\u2220\u20D2","nap":"\u2249","napE":"\u2A70\u0338","napid":"\u224B\u0338","napos":"\u0149","napprox":"\u2249","natural":"\u266E","naturals":"\u2115","natur":"\u266E","nbsp":"\xa0","nbump":"\u224E\u0338","nbumpe":"\u224F\u0338","ncap":"\u2A43","Ncaron":"\u0147","ncaron":"\u0148","Ncedil":"\u0145","ncedil":"\u0146","ncong":"\u2247","ncongdot":"\u2A6D\u0338","ncup":"\u2A42","Ncy":"\u041D","ncy":"\u043D","ndash":"\u2013","nearhk":"\u2924","nearr":"\u2197","neArr":"\u21D7","nearrow":"\u2197","ne":"\u2260","nedot":"\u2250\u0338","NegativeMediumSpace":"\u200B","NegativeThickSpace":"\u200B","NegativeThinSpace":"\u200B","NegativeVeryThinSpace":"\u200B","nequiv":"\u2262","nesear":"\u2928","nesim":"\u2242\u0338","NestedGreaterGreater":"\u226B","NestedLessLess":"\u226A","NewLine":"\\n","nexist":"\u2204","nexists":"\u2204","Nfr":"\uD835\uDD11","nfr":"\uD835\uDD2B","ngE":"\u2267\u0338","nge":"\u2271","ngeq":"\u2271","ngeqq":"\u2267\u0338","ngeqslant":"\u2A7E\u0338","nges":"\u2A7E\u0338","nGg":"\u22D9\u0338","ngsim":"\u2275","nGt":"\u226B\u20D2","ngt":"\u226F","ngtr":"\u226F","nGtv":"\u226B\u0338","nharr":"\u21AE","nhArr":"\u21CE","nhpar":"\u2AF2","ni":"\u220B","nis":"\u22FC","nisd":"\u22FA","niv":"\u220B","NJcy":"\u040A","njcy":"\u045A","nlarr":"\u219A","nlArr":"\u21CD","nldr":"\u2025","nlE":"\u2266\u0338","nle":"\u2270","nleftarrow":"\u219A","nLeftarrow":"\u21CD","nleftrightarrow":"\u21AE","nLeftrightarrow":"\u21CE","nleq":"\u2270","nleqq":"\u2266\u0338","nleqslant":"\u2A7D\u0338","nles":"\u2A7D\u0338","nless":"\u226E","nLl":"\u22D8\u0338","nlsim":"\u2274","nLt":"\u226A\u20D2","nlt":"\u226E","nltri":"\u22EA","nltrie":"\u22EC","nLtv":"\u226A\u0338","nmid":"\u2224","NoBreak":"\u2060","NonBreakingSpace":"\xa0","nopf":"\uD835\uDD5F","Nopf":"\u2115","Not":"\u2AEC","not":"\xac","NotCongruent":"\u2262","NotCupCap":"\u226D","NotDoubleVerticalBar":"\u2226","NotElement":"\u2209","NotEqual":"\u2260","NotEqualTilde":"\u2242\u0338","NotExists":"\u2204","NotGreater":"\u226F","NotGreaterEqual":"\u2271","NotGreaterFullEqual":"\u2267\u0338","NotGreaterGreater":"\u226B\u0338","NotGreaterLess":"\u2279","NotGreaterSlantEqual":"\u2A7E\u0338","NotGreaterTilde":"\u2275","NotHumpDownHump":"\u224E\u0338","NotHumpEqual":"\u224F\u0338","notin":"\u2209","notindot":"\u22F5\u0338","notinE":"\u22F9\u0338","notinva":"\u2209","notinvb":"\u22F7","notinvc":"\u22F6","NotLeftTriangleBar":"\u29CF\u0338","NotLeftTriangle":"\u22EA","NotLeftTriangleEqual":"\u22EC","NotLess":"\u226E","NotLessEqual":"\u2270","NotLessGreater":"\u2278","NotLessLess":"\u226A\u0338","NotLessSlantEqual":"\u2A7D\u0338","NotLessTilde":"\u2274","NotNestedGreaterGreater":"\u2AA2\u0338","NotNestedLessLess":"\u2AA1\u0338","notni":"\u220C","notniva":"\u220C","notnivb":"\u22FE","notnivc":"\u22FD","NotPrecedes":"\u2280","NotPrecedesEqual":"\u2AAF\u0338","NotPrecedesSlantEqual":"\u22E0","NotReverseElement":"\u220C","NotRightTriangleBar":"\u29D0\u0338","NotRightTriangle":"\u22EB","NotRightTriangleEqual":"\u22ED","NotSquareSubset":"\u228F\u0338","NotSquareSubsetEqual":"\u22E2","NotSquareSuperset":"\u2290\u0338","NotSquareSupersetEqual":"\u22E3","NotSubset":"\u2282\u20D2","NotSubsetEqual":"\u2288","NotSucceeds":"\u2281","NotSucceedsEqual":"\u2AB0\u0338","NotSucceedsSlantEqual":"\u22E1","NotSucceedsTilde":"\u227F\u0338","NotSuperset":"\u2283\u20D2","NotSupersetEqual":"\u2289","NotTilde":"\u2241","NotTildeEqual":"\u2244","NotTildeFullEqual":"\u2247","NotTildeTilde":"\u2249","NotVerticalBar":"\u2224","nparallel":"\u2226","npar":"\u2226","nparsl":"\u2AFD\u20E5","npart":"\u2202\u0338","npolint":"\u2A14","npr":"\u2280","nprcue":"\u22E0","nprec":"\u2280","npreceq":"\u2AAF\u0338","npre":"\u2AAF\u0338","nrarrc":"\u2933\u0338","nrarr":"\u219B","nrArr":"\u21CF","nrarrw":"\u219D\u0338","nrightarrow":"\u219B","nRightarrow":"\u21CF","nrtri":"\u22EB","nrtrie":"\u22ED","nsc":"\u2281","nsccue":"\u22E1","nsce":"\u2AB0\u0338","Nscr":"\uD835\uDCA9","nscr":"\uD835\uDCC3","nshortmid":"\u2224","nshortparallel":"\u2226","nsim":"\u2241","nsime":"\u2244","nsimeq":"\u2244","nsmid":"\u2224","nspar":"\u2226","nsqsube":"\u22E2","nsqsupe":"\u22E3","nsub":"\u2284","nsubE":"\u2AC5\u0338","nsube":"\u2288","nsubset":"\u2282\u20D2","nsubseteq":"\u2288","nsubseteqq":"\u2AC5\u0338","nsucc":"\u2281","nsucceq":"\u2AB0\u0338","nsup":"\u2285","nsupE":"\u2AC6\u0338","nsupe":"\u2289","nsupset":"\u2283\u20D2","nsupseteq":"\u2289","nsupseteqq":"\u2AC6\u0338","ntgl":"\u2279","Ntilde":"\xd1","ntilde":"\xf1","ntlg":"\u2278","ntriangleleft":"\u22EA","ntrianglelefteq":"\u22EC","ntriangleright":"\u22EB","ntrianglerighteq":"\u22ED","Nu":"\u039D","nu":"\u03BD","num":"#","numero":"\u2116","numsp":"\u2007","nvap":"\u224D\u20D2","nvdash":"\u22AC","nvDash":"\u22AD","nVdash":"\u22AE","nVDash":"\u22AF","nvge":"\u2265\u20D2","nvgt":">\u20D2","nvHarr":"\u2904","nvinfin":"\u29DE","nvlArr":"\u2902","nvle":"\u2264\u20D2","nvlt":"<\u20D2","nvltrie":"\u22B4\u20D2","nvrArr":"\u2903","nvrtrie":"\u22B5\u20D2","nvsim":"\u223C\u20D2","nwarhk":"\u2923","nwarr":"\u2196","nwArr":"\u21D6","nwarrow":"\u2196","nwnear":"\u2927","Oacute":"\xd3","oacute":"\xf3","oast":"\u229B","Ocirc":"\xd4","ocirc":"\xf4","ocir":"\u229A","Ocy":"\u041E","ocy":"\u043E","odash":"\u229D","Odblac":"\u0150","odblac":"\u0151","odiv":"\u2A38","odot":"\u2299","odsold":"\u29BC","OElig":"\u0152","oelig":"\u0153","ofcir":"\u29BF","Ofr":"\uD835\uDD12","ofr":"\uD835\uDD2C","ogon":"\u02DB","Ograve":"\xd2","ograve":"\xf2","ogt":"\u29C1","ohbar":"\u29B5","ohm":"\u03A9","oint":"\u222E","olarr":"\u21BA","olcir":"\u29BE","olcross":"\u29BB","oline":"\u203E","olt":"\u29C0","Omacr":"\u014C","omacr":"\u014D","Omega":"\u03A9","omega":"\u03C9","Omicron":"\u039F","omicron":"\u03BF","omid":"\u29B6","ominus":"\u2296","Oopf":"\uD835\uDD46","oopf":"\uD835\uDD60","opar":"\u29B7","OpenCurlyDoubleQuote":"\u201C","OpenCurlyQuote":"\u2018","operp":"\u29B9","oplus":"\u2295","orarr":"\u21BB","Or":"\u2A54","or":"\u2228","ord":"\u2A5D","order":"\u2134","orderof":"\u2134","ordf":"\xaa","ordm":"\xba","origof":"\u22B6","oror":"\u2A56","orslope":"\u2A57","orv":"\u2A5B","oS":"\u24C8","Oscr":"\uD835\uDCAA","oscr":"\u2134","Oslash":"\xd8","oslash":"\xf8","osol":"\u2298","Otilde":"\xd5","otilde":"\xf5","otimesas":"\u2A36","Otimes":"\u2A37","otimes":"\u2297","Ouml":"\xd6","ouml":"\xf6","ovbar":"\u233D","OverBar":"\u203E","OverBrace":"\u23DE","OverBracket":"\u23B4","OverParenthesis":"\u23DC","para":"\xb6","parallel":"\u2225","par":"\u2225","parsim":"\u2AF3","parsl":"\u2AFD","part":"\u2202","PartialD":"\u2202","Pcy":"\u041F","pcy":"\u043F","percnt":"%","period":".","permil":"\u2030","perp":"\u22A5","pertenk":"\u2031","Pfr":"\uD835\uDD13","pfr":"\uD835\uDD2D","Phi":"\u03A6","phi":"\u03C6","phiv":"\u03D5","phmmat":"\u2133","phone":"\u260E","Pi":"\u03A0","pi":"\u03C0","pitchfork":"\u22D4","piv":"\u03D6","planck":"\u210F","planckh":"\u210E","plankv":"\u210F","plusacir":"\u2A23","plusb":"\u229E","pluscir":"\u2A22","plus":"+","plusdo":"\u2214","plusdu":"\u2A25","pluse":"\u2A72","PlusMinus":"\xb1","plusmn":"\xb1","plussim":"\u2A26","plustwo":"\u2A27","pm":"\xb1","Poincareplane":"\u210C","pointint":"\u2A15","popf":"\uD835\uDD61","Popf":"\u2119","pound":"\xa3","prap":"\u2AB7","Pr":"\u2ABB","pr":"\u227A","prcue":"\u227C","precapprox":"\u2AB7","prec":"\u227A","preccurlyeq":"\u227C","Precedes":"\u227A","PrecedesEqual":"\u2AAF","PrecedesSlantEqual":"\u227C","PrecedesTilde":"\u227E","preceq":"\u2AAF","precnapprox":"\u2AB9","precneqq":"\u2AB5","precnsim":"\u22E8","pre":"\u2AAF","prE":"\u2AB3","precsim":"\u227E","prime":"\u2032","Prime":"\u2033","primes":"\u2119","prnap":"\u2AB9","prnE":"\u2AB5","prnsim":"\u22E8","prod":"\u220F","Product":"\u220F","profalar":"\u232E","profline":"\u2312","profsurf":"\u2313","prop":"\u221D","Proportional":"\u221D","Proportion":"\u2237","propto":"\u221D","prsim":"\u227E","prurel":"\u22B0","Pscr":"\uD835\uDCAB","pscr":"\uD835\uDCC5","Psi":"\u03A8","psi":"\u03C8","puncsp":"\u2008","Qfr":"\uD835\uDD14","qfr":"\uD835\uDD2E","qint":"\u2A0C","qopf":"\uD835\uDD62","Qopf":"\u211A","qprime":"\u2057","Qscr":"\uD835\uDCAC","qscr":"\uD835\uDCC6","quaternions":"\u210D","quatint":"\u2A16","quest":"?","questeq":"\u225F","quot":"\\"","QUOT":"\\"","rAarr":"\u21DB","race":"\u223D\u0331","Racute":"\u0154","racute":"\u0155","radic":"\u221A","raemptyv":"\u29B3","rang":"\u27E9","Rang":"\u27EB","rangd":"\u2992","range":"\u29A5","rangle":"\u27E9","raquo":"\xbb","rarrap":"\u2975","rarrb":"\u21E5","rarrbfs":"\u2920","rarrc":"\u2933","rarr":"\u2192","Rarr":"\u21A0","rArr":"\u21D2","rarrfs":"\u291E","rarrhk":"\u21AA","rarrlp":"\u21AC","rarrpl":"\u2945","rarrsim":"\u2974","Rarrtl":"\u2916","rarrtl":"\u21A3","rarrw":"\u219D","ratail":"\u291A","rAtail":"\u291C","ratio":"\u2236","rationals":"\u211A","rbarr":"\u290D","rBarr":"\u290F","RBarr":"\u2910","rbbrk":"\u2773","rbrace":"}","rbrack":"]","rbrke":"\u298C","rbrksld":"\u298E","rbrkslu":"\u2990","Rcaron":"\u0158","rcaron":"\u0159","Rcedil":"\u0156","rcedil":"\u0157","rceil":"\u2309","rcub":"}","Rcy":"\u0420","rcy":"\u0440","rdca":"\u2937","rdldhar":"\u2969","rdquo":"\u201D","rdquor":"\u201D","rdsh":"\u21B3","real":"\u211C","realine":"\u211B","realpart":"\u211C","reals":"\u211D","Re":"\u211C","rect":"\u25AD","reg":"\xae","REG":"\xae","ReverseElement":"\u220B","ReverseEquilibrium":"\u21CB","ReverseUpEquilibrium":"\u296F","rfisht":"\u297D","rfloor":"\u230B","rfr":"\uD835\uDD2F","Rfr":"\u211C","rHar":"\u2964","rhard":"\u21C1","rharu":"\u21C0","rharul":"\u296C","Rho":"\u03A1","rho":"\u03C1","rhov":"\u03F1","RightAngleBracket":"\u27E9","RightArrowBar":"\u21E5","rightarrow":"\u2192","RightArrow":"\u2192","Rightarrow":"\u21D2","RightArrowLeftArrow":"\u21C4","rightarrowtail":"\u21A3","RightCeiling":"\u2309","RightDoubleBracket":"\u27E7","RightDownTeeVector":"\u295D","RightDownVectorBar":"\u2955","RightDownVector":"\u21C2","RightFloor":"\u230B","rightharpoondown":"\u21C1","rightharpoonup":"\u21C0","rightleftarrows":"\u21C4","rightleftharpoons":"\u21CC","rightrightarrows":"\u21C9","rightsquigarrow":"\u219D","RightTeeArrow":"\u21A6","RightTee":"\u22A2","RightTeeVector":"\u295B","rightthreetimes":"\u22CC","RightTriangleBar":"\u29D0","RightTriangle":"\u22B3","RightTriangleEqual":"\u22B5","RightUpDownVector":"\u294F","RightUpTeeVector":"\u295C","RightUpVectorBar":"\u2954","RightUpVector":"\u21BE","RightVectorBar":"\u2953","RightVector":"\u21C0","ring":"\u02DA","risingdotseq":"\u2253","rlarr":"\u21C4","rlhar":"\u21CC","rlm":"\u200F","rmoustache":"\u23B1","rmoust":"\u23B1","rnmid":"\u2AEE","roang":"\u27ED","roarr":"\u21FE","robrk":"\u27E7","ropar":"\u2986","ropf":"\uD835\uDD63","Ropf":"\u211D","roplus":"\u2A2E","rotimes":"\u2A35","RoundImplies":"\u2970","rpar":")","rpargt":"\u2994","rppolint":"\u2A12","rrarr":"\u21C9","Rrightarrow":"\u21DB","rsaquo":"\u203A","rscr":"\uD835\uDCC7","Rscr":"\u211B","rsh":"\u21B1","Rsh":"\u21B1","rsqb":"]","rsquo":"\u2019","rsquor":"\u2019","rthree":"\u22CC","rtimes":"\u22CA","rtri":"\u25B9","rtrie":"\u22B5","rtrif":"\u25B8","rtriltri":"\u29CE","RuleDelayed":"\u29F4","ruluhar":"\u2968","rx":"\u211E","Sacute":"\u015A","sacute":"\u015B","sbquo":"\u201A","scap":"\u2AB8","Scaron":"\u0160","scaron":"\u0161","Sc":"\u2ABC","sc":"\u227B","sccue":"\u227D","sce":"\u2AB0","scE":"\u2AB4","Scedil":"\u015E","scedil":"\u015F","Scirc":"\u015C","scirc":"\u015D","scnap":"\u2ABA","scnE":"\u2AB6","scnsim":"\u22E9","scpolint":"\u2A13","scsim":"\u227F","Scy":"\u0421","scy":"\u0441","sdotb":"\u22A1","sdot":"\u22C5","sdote":"\u2A66","searhk":"\u2925","searr":"\u2198","seArr":"\u21D8","searrow":"\u2198","sect":"\xa7","semi":";","seswar":"\u2929","setminus":"\u2216","setmn":"\u2216","sext":"\u2736","Sfr":"\uD835\uDD16","sfr":"\uD835\uDD30","sfrown":"\u2322","sharp":"\u266F","SHCHcy":"\u0429","shchcy":"\u0449","SHcy":"\u0428","shcy":"\u0448","ShortDownArrow":"\u2193","ShortLeftArrow":"\u2190","shortmid":"\u2223","shortparallel":"\u2225","ShortRightArrow":"\u2192","ShortUpArrow":"\u2191","shy":"\xad","Sigma":"\u03A3","sigma":"\u03C3","sigmaf":"\u03C2","sigmav":"\u03C2","sim":"\u223C","simdot":"\u2A6A","sime":"\u2243","simeq":"\u2243","simg":"\u2A9E","simgE":"\u2AA0","siml":"\u2A9D","simlE":"\u2A9F","simne":"\u2246","simplus":"\u2A24","simrarr":"\u2972","slarr":"\u2190","SmallCircle":"\u2218","smallsetminus":"\u2216","smashp":"\u2A33","smeparsl":"\u29E4","smid":"\u2223","smile":"\u2323","smt":"\u2AAA","smte":"\u2AAC","smtes":"\u2AAC\uFE00","SOFTcy":"\u042C","softcy":"\u044C","solbar":"\u233F","solb":"\u29C4","sol":"/","Sopf":"\uD835\uDD4A","sopf":"\uD835\uDD64","spades":"\u2660","spadesuit":"\u2660","spar":"\u2225","sqcap":"\u2293","sqcaps":"\u2293\uFE00","sqcup":"\u2294","sqcups":"\u2294\uFE00","Sqrt":"\u221A","sqsub":"\u228F","sqsube":"\u2291","sqsubset":"\u228F","sqsubseteq":"\u2291","sqsup":"\u2290","sqsupe":"\u2292","sqsupset":"\u2290","sqsupseteq":"\u2292","square":"\u25A1","Square":"\u25A1","SquareIntersection":"\u2293","SquareSubset":"\u228F","SquareSubsetEqual":"\u2291","SquareSuperset":"\u2290","SquareSupersetEqual":"\u2292","SquareUnion":"\u2294","squarf":"\u25AA","squ":"\u25A1","squf":"\u25AA","srarr":"\u2192","Sscr":"\uD835\uDCAE","sscr":"\uD835\uDCC8","ssetmn":"\u2216","ssmile":"\u2323","sstarf":"\u22C6","Star":"\u22C6","star":"\u2606","starf":"\u2605","straightepsilon":"\u03F5","straightphi":"\u03D5","strns":"\xaf","sub":"\u2282","Sub":"\u22D0","subdot":"\u2ABD","subE":"\u2AC5","sube":"\u2286","subedot":"\u2AC3","submult":"\u2AC1","subnE":"\u2ACB","subne":"\u228A","subplus":"\u2ABF","subrarr":"\u2979","subset":"\u2282","Subset":"\u22D0","subseteq":"\u2286","subseteqq":"\u2AC5","SubsetEqual":"\u2286","subsetneq":"\u228A","subsetneqq":"\u2ACB","subsim":"\u2AC7","subsub":"\u2AD5","subsup":"\u2AD3","succapprox":"\u2AB8","succ":"\u227B","succcurlyeq":"\u227D","Succeeds":"\u227B","SucceedsEqual":"\u2AB0","SucceedsSlantEqual":"\u227D","SucceedsTilde":"\u227F","succeq":"\u2AB0","succnapprox":"\u2ABA","succneqq":"\u2AB6","succnsim":"\u22E9","succsim":"\u227F","SuchThat":"\u220B","sum":"\u2211","Sum":"\u2211","sung":"\u266A","sup1":"\xb9","sup2":"\xb2","sup3":"\xb3","sup":"\u2283","Sup":"\u22D1","supdot":"\u2ABE","supdsub":"\u2AD8","supE":"\u2AC6","supe":"\u2287","supedot":"\u2AC4","Superset":"\u2283","SupersetEqual":"\u2287","suphsol":"\u27C9","suphsub":"\u2AD7","suplarr":"\u297B","supmult":"\u2AC2","supnE":"\u2ACC","supne":"\u228B","supplus":"\u2AC0","supset":"\u2283","Supset":"\u22D1","supseteq":"\u2287","supseteqq":"\u2AC6","supsetneq":"\u228B","supsetneqq":"\u2ACC","supsim":"\u2AC8","supsub":"\u2AD4","supsup":"\u2AD6","swarhk":"\u2926","swarr":"\u2199","swArr":"\u21D9","swarrow":"\u2199","swnwar":"\u292A","szlig":"\xdf","Tab":"\\t","target":"\u2316","Tau":"\u03A4","tau":"\u03C4","tbrk":"\u23B4","Tcaron":"\u0164","tcaron":"\u0165","Tcedil":"\u0162","tcedil":"\u0163","Tcy":"\u0422","tcy":"\u0442","tdot":"\u20DB","telrec":"\u2315","Tfr":"\uD835\uDD17","tfr":"\uD835\uDD31","there4":"\u2234","therefore":"\u2234","Therefore":"\u2234","Theta":"\u0398","theta":"\u03B8","thetasym":"\u03D1","thetav":"\u03D1","thickapprox":"\u2248","thicksim":"\u223C","ThickSpace":"\u205F\u200A","ThinSpace":"\u2009","thinsp":"\u2009","thkap":"\u2248","thksim":"\u223C","THORN":"\xde","thorn":"\xfe","tilde":"\u02DC","Tilde":"\u223C","TildeEqual":"\u2243","TildeFullEqual":"\u2245","TildeTilde":"\u2248","timesbar":"\u2A31","timesb":"\u22A0","times":"\xd7","timesd":"\u2A30","tint":"\u222D","toea":"\u2928","topbot":"\u2336","topcir":"\u2AF1","top":"\u22A4","Topf":"\uD835\uDD4B","topf":"\uD835\uDD65","topfork":"\u2ADA","tosa":"\u2929","tprime":"\u2034","trade":"\u2122","TRADE":"\u2122","triangle":"\u25B5","triangledown":"\u25BF","triangleleft":"\u25C3","trianglelefteq":"\u22B4","triangleq":"\u225C","triangleright":"\u25B9","trianglerighteq":"\u22B5","tridot":"\u25EC","trie":"\u225C","triminus":"\u2A3A","TripleDot":"\u20DB","triplus":"\u2A39","trisb":"\u29CD","tritime":"\u2A3B","trpezium":"\u23E2","Tscr":"\uD835\uDCAF","tscr":"\uD835\uDCC9","TScy":"\u0426","tscy":"\u0446","TSHcy":"\u040B","tshcy":"\u045B","Tstrok":"\u0166","tstrok":"\u0167","twixt":"\u226C","twoheadleftarrow":"\u219E","twoheadrightarrow":"\u21A0","Uacute":"\xda","uacute":"\xfa","uarr":"\u2191","Uarr":"\u219F","uArr":"\u21D1","Uarrocir":"\u2949","Ubrcy":"\u040E","ubrcy":"\u045E","Ubreve":"\u016C","ubreve":"\u016D","Ucirc":"\xdb","ucirc":"\xfb","Ucy":"\u0423","ucy":"\u0443","udarr":"\u21C5","Udblac":"\u0170","udblac":"\u0171","udhar":"\u296E","ufisht":"\u297E","Ufr":"\uD835\uDD18","ufr":"\uD835\uDD32","Ugrave":"\xd9","ugrave":"\xf9","uHar":"\u2963","uharl":"\u21BF","uharr":"\u21BE","uhblk":"\u2580","ulcorn":"\u231C","ulcorner":"\u231C","ulcrop":"\u230F","ultri":"\u25F8","Umacr":"\u016A","umacr":"\u016B","uml":"\xa8","UnderBar":"_","UnderBrace":"\u23DF","UnderBracket":"\u23B5","UnderParenthesis":"\u23DD","Union":"\u22C3","UnionPlus":"\u228E","Uogon":"\u0172","uogon":"\u0173","Uopf":"\uD835\uDD4C","uopf":"\uD835\uDD66","UpArrowBar":"\u2912","uparrow":"\u2191","UpArrow":"\u2191","Uparrow":"\u21D1","UpArrowDownArrow":"\u21C5","updownarrow":"\u2195","UpDownArrow":"\u2195","Updownarrow":"\u21D5","UpEquilibrium":"\u296E","upharpoonleft":"\u21BF","upharpoonright":"\u21BE","uplus":"\u228E","UpperLeftArrow":"\u2196","UpperRightArrow":"\u2197","upsi":"\u03C5","Upsi":"\u03D2","upsih":"\u03D2","Upsilon":"\u03A5","upsilon":"\u03C5","UpTeeArrow":"\u21A5","UpTee":"\u22A5","upuparrows":"\u21C8","urcorn":"\u231D","urcorner":"\u231D","urcrop":"\u230E","Uring":"\u016E","uring":"\u016F","urtri":"\u25F9","Uscr":"\uD835\uDCB0","uscr":"\uD835\uDCCA","utdot":"\u22F0","Utilde":"\u0168","utilde":"\u0169","utri":"\u25B5","utrif":"\u25B4","uuarr":"\u21C8","Uuml":"\xdc","uuml":"\xfc","uwangle":"\u29A7","vangrt":"\u299C","varepsilon":"\u03F5","varkappa":"\u03F0","varnothing":"\u2205","varphi":"\u03D5","varpi":"\u03D6","varpropto":"\u221D","varr":"\u2195","vArr":"\u21D5","varrho":"\u03F1","varsigma":"\u03C2","varsubsetneq":"\u228A\uFE00","varsubsetneqq":"\u2ACB\uFE00","varsupsetneq":"\u228B\uFE00","varsupsetneqq":"\u2ACC\uFE00","vartheta":"\u03D1","vartriangleleft":"\u22B2","vartriangleright":"\u22B3","vBar":"\u2AE8","Vbar":"\u2AEB","vBarv":"\u2AE9","Vcy":"\u0412","vcy":"\u0432","vdash":"\u22A2","vDash":"\u22A8","Vdash":"\u22A9","VDash":"\u22AB","Vdashl":"\u2AE6","veebar":"\u22BB","vee":"\u2228","Vee":"\u22C1","veeeq":"\u225A","vellip":"\u22EE","verbar":"|","Verbar":"\u2016","vert":"|","Vert":"\u2016","VerticalBar":"\u2223","VerticalLine":"|","VerticalSeparator":"\u2758","VerticalTilde":"\u2240","VeryThinSpace":"\u200A","Vfr":"\uD835\uDD19","vfr":"\uD835\uDD33","vltri":"\u22B2","vnsub":"\u2282\u20D2","vnsup":"\u2283\u20D2","Vopf":"\uD835\uDD4D","vopf":"\uD835\uDD67","vprop":"\u221D","vrtri":"\u22B3","Vscr":"\uD835\uDCB1","vscr":"\uD835\uDCCB","vsubnE":"\u2ACB\uFE00","vsubne":"\u228A\uFE00","vsupnE":"\u2ACC\uFE00","vsupne":"\u228B\uFE00","Vvdash":"\u22AA","vzigzag":"\u299A","Wcirc":"\u0174","wcirc":"\u0175","wedbar":"\u2A5F","wedge":"\u2227","Wedge":"\u22C0","wedgeq":"\u2259","weierp":"\u2118","Wfr":"\uD835\uDD1A","wfr":"\uD835\uDD34","Wopf":"\uD835\uDD4E","wopf":"\uD835\uDD68","wp":"\u2118","wr":"\u2240","wreath":"\u2240","Wscr":"\uD835\uDCB2","wscr":"\uD835\uDCCC","xcap":"\u22C2","xcirc":"\u25EF","xcup":"\u22C3","xdtri":"\u25BD","Xfr":"\uD835\uDD1B","xfr":"\uD835\uDD35","xharr":"\u27F7","xhArr":"\u27FA","Xi":"\u039E","xi":"\u03BE","xlarr":"\u27F5","xlArr":"\u27F8","xmap":"\u27FC","xnis":"\u22FB","xodot":"\u2A00","Xopf":"\uD835\uDD4F","xopf":"\uD835\uDD69","xoplus":"\u2A01","xotime":"\u2A02","xrarr":"\u27F6","xrArr":"\u27F9","Xscr":"\uD835\uDCB3","xscr":"\uD835\uDCCD","xsqcup":"\u2A06","xuplus":"\u2A04","xutri":"\u25B3","xvee":"\u22C1","xwedge":"\u22C0","Yacute":"\xdd","yacute":"\xfd","YAcy":"\u042F","yacy":"\u044F","Ycirc":"\u0176","ycirc":"\u0177","Ycy":"\u042B","ycy":"\u044B","yen":"\xa5","Yfr":"\uD835\uDD1C","yfr":"\uD835\uDD36","YIcy":"\u0407","yicy":"\u0457","Yopf":"\uD835\uDD50","yopf":"\uD835\uDD6A","Yscr":"\uD835\uDCB4","yscr":"\uD835\uDCCE","YUcy":"\u042E","yucy":"\u044E","yuml":"\xff","Yuml":"\u0178","Zacute":"\u0179","zacute":"\u017A","Zcaron":"\u017D","zcaron":"\u017E","Zcy":"\u0417","zcy":"\u0437","Zdot":"\u017B","zdot":"\u017C","zeetrf":"\u2128","ZeroWidthSpace":"\u200B","Zeta":"\u0396","zeta":"\u03B6","zfr":"\uD835\uDD37","Zfr":"\u2128","ZHcy":"\u0416","zhcy":"\u0436","zigrarr":"\u21DD","zopf":"\uD835\uDD6B","Zopf":"\u2124","Zscr":"\uD835\uDCB5","zscr":"\uD835\uDCCF","zwj":"\u200D","zwnj":"\u200C"}');

},{}],"lnSgD":[function(require,module,exports) {
var entityMap = require("498437ce89865da"), legacyMap = require("a79af0eb04072101"), xmlMap = require("b25150aa91f40236"), decodeCodePoint = require("1db0720eb5416038");
var decodeXMLStrict = getStrictDecoder(xmlMap), decodeHTMLStrict = getStrictDecoder(entityMap);
function getStrictDecoder(map) {
    var keys = Object.keys(map).join("|"), replace = getReplacer(map);
    keys += "|#[xX][\\da-fA-F]+|#\\d+";
    var re = new RegExp("&(?:" + keys + ");", "g");
    return function(str) {
        return String(str).replace(re, replace);
    };
}
var decodeHTML = function() {
    var legacy = Object.keys(legacyMap).sort(sorter);
    var keys = Object.keys(entityMap).sort(sorter);
    for(var i = 0, j = 0; i < keys.length; i++)if (legacy[j] === keys[i]) {
        keys[i] += ";?";
        j++;
    } else keys[i] += ";";
    var re = new RegExp("&(?:" + keys.join("|") + "|#[xX][\\da-fA-F]+;?|#\\d+;?)", "g"), replace = getReplacer(entityMap);
    function replacer(str) {
        if (str.substr(-1) !== ";") str += ";";
        return replace(str);
    }
    //TODO consider creating a merged map
    return function(str) {
        return String(str).replace(re, replacer);
    };
}();
function sorter(a, b) {
    return a < b ? 1 : -1;
}
function getReplacer(map) {
    return function replace(str) {
        if (str.charAt(1) === "#") {
            if (str.charAt(2) === "X" || str.charAt(2) === "x") return decodeCodePoint(parseInt(str.substr(3), 16));
            return decodeCodePoint(parseInt(str.substr(2), 10));
        }
        return map[str.slice(1, -1)];
    };
}
module.exports = {
    XML: decodeXMLStrict,
    HTML: decodeHTML,
    HTMLStrict: decodeHTMLStrict
};

},{"498437ce89865da":"6cmUh","a79af0eb04072101":"dTMqc","b25150aa91f40236":"ejuI2","1db0720eb5416038":"1tedd"}],"dTMqc":[function(require,module,exports) {
module.exports = JSON.parse('{"Aacute":"\xc1","aacute":"\xe1","Acirc":"\xc2","acirc":"\xe2","acute":"\xb4","AElig":"\xc6","aelig":"\xe6","Agrave":"\xc0","agrave":"\xe0","amp":"&","AMP":"&","Aring":"\xc5","aring":"\xe5","Atilde":"\xc3","atilde":"\xe3","Auml":"\xc4","auml":"\xe4","brvbar":"\xa6","Ccedil":"\xc7","ccedil":"\xe7","cedil":"\xb8","cent":"\xa2","copy":"\xa9","COPY":"\xa9","curren":"\xa4","deg":"\xb0","divide":"\xf7","Eacute":"\xc9","eacute":"\xe9","Ecirc":"\xca","ecirc":"\xea","Egrave":"\xc8","egrave":"\xe8","ETH":"\xd0","eth":"\xf0","Euml":"\xcb","euml":"\xeb","frac12":"\xbd","frac14":"\xbc","frac34":"\xbe","gt":">","GT":">","Iacute":"\xcd","iacute":"\xed","Icirc":"\xce","icirc":"\xee","iexcl":"\xa1","Igrave":"\xcc","igrave":"\xec","iquest":"\xbf","Iuml":"\xcf","iuml":"\xef","laquo":"\xab","lt":"<","LT":"<","macr":"\xaf","micro":"\xb5","middot":"\xb7","nbsp":"\xa0","not":"\xac","Ntilde":"\xd1","ntilde":"\xf1","Oacute":"\xd3","oacute":"\xf3","Ocirc":"\xd4","ocirc":"\xf4","Ograve":"\xd2","ograve":"\xf2","ordf":"\xaa","ordm":"\xba","Oslash":"\xd8","oslash":"\xf8","Otilde":"\xd5","otilde":"\xf5","Ouml":"\xd6","ouml":"\xf6","para":"\xb6","plusmn":"\xb1","pound":"\xa3","quot":"\\"","QUOT":"\\"","raquo":"\xbb","reg":"\xae","REG":"\xae","sect":"\xa7","shy":"\xad","sup1":"\xb9","sup2":"\xb2","sup3":"\xb3","szlig":"\xdf","THORN":"\xde","thorn":"\xfe","times":"\xd7","Uacute":"\xda","uacute":"\xfa","Ucirc":"\xdb","ucirc":"\xfb","Ugrave":"\xd9","ugrave":"\xf9","uml":"\xa8","Uuml":"\xdc","uuml":"\xfc","Yacute":"\xdd","yacute":"\xfd","yen":"\xa5","yuml":"\xff"}');

},{}],"1tedd":[function(require,module,exports) {
var decodeMap = require("3e4da234eb384bf5");
module.exports = decodeCodePoint;
// modified version of https://github.com/mathiasbynens/he/blob/master/src/he.js#L94-L119
function decodeCodePoint(codePoint) {
    if (codePoint >= 0xd800 && codePoint <= 0xdfff || codePoint > 0x10ffff) return "\uFFFD";
    if (codePoint in decodeMap) codePoint = decodeMap[codePoint];
    var output = "";
    if (codePoint > 0xffff) {
        codePoint -= 0x10000;
        output += String.fromCharCode(codePoint >>> 10 & 0x3ff | 0xd800);
        codePoint = 0xdc00 | codePoint & 0x3ff;
    }
    output += String.fromCharCode(codePoint);
    return output;
}

},{"3e4da234eb384bf5":"3tVLG"}],"3tVLG":[function(require,module,exports) {
module.exports = JSON.parse('{"0":65533,"128":8364,"130":8218,"131":402,"132":8222,"133":8230,"134":8224,"135":8225,"136":710,"137":8240,"138":352,"139":8249,"140":338,"142":381,"145":8216,"146":8217,"147":8220,"148":8221,"149":8226,"150":8211,"151":8212,"152":732,"153":8482,"154":353,"155":8250,"156":339,"158":382,"159":376}');

},{}],"lArs7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DocsRender", ()=>DocsRender);
var _esFunctionNameJs = require("core-js/modules/es.function.name.js");
var _esObjectAssignJs = require("core-js/modules/es.object.assign.js");
var _esObjectToStringJs = require("core-js/modules/es.object.to-string.js");
var _esPromiseJs = require("core-js/modules/es.promise.js");
var _global = require("global");
var _globalDefault = parcelHelpers.interopDefault(_global);
var _coreEvents = require("@storybook/core-events");
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
var DocsRender = /*#__PURE__*/ function() {
    // eslint-disable-next-line no-useless-constructor
    function DocsRender(channel, store, id, story) {
        _classCallCheck(this, DocsRender);
        this.channel = channel;
        this.store = store;
        this.id = id;
        this.story = story;
        this.canvasElement = void 0;
        this.context = void 0;
        this.disableKeyListeners = false;
    } // DocsRender doesn't prepare, it is created *from* a prepared StoryRender
    _createClass(DocsRender, [
        {
            key: "isPreparing",
            value: function isPreparing() {
                return false;
            }
        },
        {
            key: "renderToElement",
            value: function() {
                var _renderToElement = _asyncToGenerator(/*#__PURE__*/ regeneratorRuntime.mark(function _callee(canvasElement, renderStoryToElement) {
                    var _this = this, _global$FEATURES;
                    var _this$story, id, title, name, csfFile;
                    return regeneratorRuntime.wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                this.canvasElement = canvasElement;
                                _this$story = this.story, id = _this$story.id, title = _this$story.title, name = _this$story.name;
                                _context.next = 4;
                                return this.store.loadCSFFileByStoryId(this.id);
                            case 4:
                                csfFile = _context.sent;
                                this.context = Object.assign({
                                    id: id,
                                    title: title,
                                    name: name,
                                    // NOTE: these two functions are *sync* so cannot access stories from other CSF files
                                    storyById: function storyById(storyId) {
                                        return _this.store.storyFromCSFFile({
                                            storyId: storyId,
                                            csfFile: csfFile
                                        });
                                    },
                                    componentStories: function componentStories() {
                                        return _this.store.componentStoriesFromCSFFile({
                                            csfFile: csfFile
                                        });
                                    },
                                    loadStory: function loadStory(storyId) {
                                        return _this.store.loadStory({
                                            storyId: storyId
                                        });
                                    },
                                    renderStoryToElement: renderStoryToElement,
                                    getStoryContext: function getStoryContext(renderedStory) {
                                        return Object.assign({}, _this.store.getStoryContext(renderedStory), {
                                            viewMode: "docs"
                                        });
                                    }
                                }, !((_global$FEATURES = (0, _globalDefault.default).FEATURES) !== null && _global$FEATURES !== void 0 && _global$FEATURES.breakingChangesV7) && this.store.getStoryContext(this.story));
                                return _context.abrupt("return", this.render());
                            case 7:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function renderToElement(_x, _x2) {
                    return _renderToElement.apply(this, arguments);
                }
                return renderToElement;
            }()
        },
        {
            key: "render",
            value: function() {
                var _render = _asyncToGenerator(/*#__PURE__*/ regeneratorRuntime.mark(function _callee2() {
                    var _this2 = this;
                    var renderer;
                    return regeneratorRuntime.wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                if (!(!this.story || !this.context || !this.canvasElement)) {
                                    _context2.next = 2;
                                    break;
                                }
                                throw new Error("DocsRender not ready to render");
                            case 2:
                                _context2.next = 4;
                                return require("a0a3624040ca8f80");
                            case 4:
                                renderer = _context2.sent;
                                renderer.renderDocs(this.story, this.context, this.canvasElement, function() {
                                    return _this2.channel.emit((0, _coreEvents.DOCS_RENDERED), _this2.id);
                                });
                            case 6:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function render() {
                    return _render.apply(this, arguments);
                }
                return render;
            }()
        },
        {
            key: "rerender",
            value: function() {
                var _rerender = _asyncToGenerator(/*#__PURE__*/ regeneratorRuntime.mark(function _callee3(isGlobals) {
                    var _global$FEATURES2;
                    return regeneratorRuntime.wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                if (!(!((_global$FEATURES2 = (0, _globalDefault.default).FEATURES) !== null && _global$FEATURES2 !== void 0 && _global$FEATURES2.modernInlineRender) || isGlobals)) {
                                    _context3.next = 3;
                                    break;
                                }
                                _context3.next = 3;
                                return this.render();
                            case 3:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3, this);
                }));
                function rerender(_x3) {
                    return _rerender.apply(this, arguments);
                }
                return rerender;
            }()
        },
        {
            key: "teardown",
            value: function() {
                var _teardown = _asyncToGenerator(/*#__PURE__*/ regeneratorRuntime.mark(function _callee4() {
                    var _ref, viewModeChanged, renderer, _args4 = arguments;
                    return regeneratorRuntime.wrap(function _callee4$(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                _ref = _args4.length > 0 && _args4[0] !== undefined ? _args4[0] : {}, viewModeChanged = _ref.viewModeChanged;
                                if (!(!viewModeChanged || !this.canvasElement)) {
                                    _context4.next = 3;
                                    break;
                                }
                                return _context4.abrupt("return");
                            case 3:
                                _context4.next = 5;
                                return require("a0a3624040ca8f80");
                            case 5:
                                renderer = _context4.sent;
                                renderer.unmountDocs(this.canvasElement);
                            case 7:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4, this);
                }));
                function teardown() {
                    return _teardown.apply(this, arguments);
                }
                return teardown;
            }()
        }
    ], [
        {
            key: "fromStoryRender",
            value: function fromStoryRender(storyRender) {
                var channel = storyRender.channel, store = storyRender.store, id = storyRender.id, story = storyRender.story;
                return new DocsRender(channel, store, id, story);
            }
        }
    ]);
    return DocsRender;
}();
DocsRender.displayName = "DocsRender";

},{"core-js/modules/es.function.name.js":"4LiLL","core-js/modules/es.object.assign.js":"8FU8M","core-js/modules/es.object.to-string.js":"lsA9p","core-js/modules/es.promise.js":"2jax7","global":"5PzlO","@storybook/core-events":"bJpgo","a0a3624040ca8f80":"7DU23","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"7DU23":[function(require,module,exports) {
module.exports = require("9e0b3d43bf020968")(require("88fc29d74a1efe16").resolve("1fi6V")).then(()=>module.bundle.root("ewmtE"));

},{"9e0b3d43bf020968":"egp6W","88fc29d74a1efe16":"f7Lf0"}],"egp6W":[function(require,module,exports) {
"use strict";
var cacheLoader = require("ca2a84f7fa4a3bb0");
module.exports = cacheLoader(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName("script");
        if ([].concat(existingScripts).some(function isCurrentBundle(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement("link");
        preloadLink.href = bundle;
        preloadLink.rel = "preload";
        preloadLink.as = "script";
        document.head.appendChild(preloadLink);
        var script = document.createElement("script");
        script.async = true;
        script.type = "text/javascript";
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName("head")[0].appendChild(script);
    });
});

},{"ca2a84f7fa4a3bb0":"77bJp"}],"77bJp":[function(require,module,exports) {
"use strict";
var cachedBundles = {};
var cachedPreloads = {};
var cachedPrefetches = {};
function getCache(type) {
    switch(type){
        case "preload":
            return cachedPreloads;
        case "prefetch":
            return cachedPrefetches;
        default:
            return cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

},{}],"kWKsA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "KEY", ()=>KEY);
parcelHelpers.export(exports, "PostmsgTransport", ()=>PostmsgTransport);
parcelHelpers.export(exports, "default", ()=>createChannel);
var _esArrayIteratorJs = require("core-js/modules/es.array.iterator.js");
var _esObjectFromEntriesJs = require("core-js/modules/es.object.from-entries.js");
var _esArrayFilterJs = require("core-js/modules/es.array.filter.js");
var _esObjectToStringJs = require("core-js/modules/es.object.to-string.js");
var _esObjectEntriesJs = require("core-js/modules/es.object.entries.js");
var _esObjectAssignJs = require("core-js/modules/es.object.assign.js");
var _esNumberIsIntegerJs = require("core-js/modules/es.number.is-integer.js");
var _esNumberConstructorJs = require("core-js/modules/es.number.constructor.js");
var _esRegexpExecJs = require("core-js/modules/es.regexp.exec.js");
var _esStringSearchJs = require("core-js/modules/es.string.search.js");
var _esPromiseJs = require("core-js/modules/es.promise.js");
var _webDomCollectionsForEachJs = require("core-js/modules/web.dom-collections.for-each.js");
var _esArrayMapJs = require("core-js/modules/es.array.map.js");
var _esArrayIncludesJs = require("core-js/modules/es.array.includes.js");
var _esStringIncludesJs = require("core-js/modules/es.string.includes.js");
var _esObjectValuesJs = require("core-js/modules/es.object.values.js");
var _esArrayConcatJs = require("core-js/modules/es.array.concat.js");
var _esStringIteratorJs = require("core-js/modules/es.string.iterator.js");
var _webDomCollectionsIteratorJs = require("core-js/modules/web.dom-collections.iterator.js");
var _webUrlJs = require("core-js/modules/web.url.js");
var _webUrlSearchParamsJs = require("core-js/modules/web.url-search-params.js");
var _esArraySliceJs = require("core-js/modules/es.array.slice.js");
var _esSymbolJs = require("core-js/modules/es.symbol.js");
var _esSymbolDescriptionJs = require("core-js/modules/es.symbol.description.js");
var _esSymbolIteratorJs = require("core-js/modules/es.symbol.iterator.js");
var _esFunctionNameJs = require("core-js/modules/es.function.name.js");
var _esArrayFromJs = require("core-js/modules/es.array.from.js");
var _global = require("global");
var _globalDefault = parcelHelpers.interopDefault(_global);
var _coreEvents = require("@storybook/core-events");
var _channels = require("@storybook/channels");
var _channelsDefault = parcelHelpers.interopDefault(_channels);
var _clientLogger = require("@storybook/client-logger");
var _telejson = require("telejson");
var _qs = require("qs");
var _qsDefault = parcelHelpers.interopDefault(_qs);
function _toArray(arr) {
    return _arrayWithHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableRest();
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
var globalWindow = (0, _globalDefault.default).window, document = (0, _globalDefault.default).document, location = (0, _globalDefault.default).location;
var KEY = "storybook-channel";
var defaultEventOptions = {
    allowFunction: true,
    maxDepth: 25
}; // TODO: we should export a method for opening child windows here and keep track of em.
var PostmsgTransport = /*#__PURE__*/ function() {
    function PostmsgTransport(config) {
        _classCallCheck(this, PostmsgTransport);
        this.config = config;
        this.buffer = void 0;
        this.handler = void 0;
        this.connected = void 0;
        this.buffer = [];
        this.handler = null;
        globalWindow.addEventListener("message", this.handleEvent.bind(this), false); // Check whether the config.page parameter has a valid value
        if (config.page !== "manager" && config.page !== "preview") throw new Error('postmsg-channel: "config.page" cannot be "'.concat(config.page, '"'));
    }
    _createClass(PostmsgTransport, [
        {
            key: "setHandler",
            value: function setHandler(handler) {
                var _this = this;
                this.handler = function() {
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                    handler.apply(_this, args);
                    if (!_this.connected && _this.getLocalFrame().length) {
                        _this.flush();
                        _this.connected = true;
                    }
                };
            }
        },
        {
            key: "send",
            value: function send(event, options) {
                var _this2 = this;
                var _ref = options || {}, target = _ref.target, allowRegExp = _ref.allowRegExp, allowFunction = _ref.allowFunction, allowSymbol = _ref.allowSymbol, allowDate = _ref.allowDate, allowUndefined = _ref.allowUndefined, allowClass = _ref.allowClass, maxDepth = _ref.maxDepth, space = _ref.space, lazyEval = _ref.lazyEval;
                var eventOptions = Object.fromEntries(Object.entries({
                    allowRegExp: allowRegExp,
                    allowFunction: allowFunction,
                    allowSymbol: allowSymbol,
                    allowDate: allowDate,
                    allowUndefined: allowUndefined,
                    allowClass: allowClass,
                    maxDepth: maxDepth,
                    space: space,
                    lazyEval: lazyEval
                }).filter(function(_ref2) {
                    var _ref3 = _slicedToArray(_ref2, 2), k = _ref3[0], v = _ref3[1];
                    return typeof v !== "undefined";
                }));
                var stringifyOptions = Object.assign({}, defaultEventOptions, (0, _globalDefault.default).CHANNEL_OPTIONS || {}, eventOptions); // backwards compat: convert depth to maxDepth
                if (options && Number.isInteger(options.depth)) stringifyOptions.maxDepth = options.depth;
                var frames = this.getFrames(target);
                var query = (0, _qsDefault.default).parse(location.search, {
                    ignoreQueryPrefix: true
                });
                var data = (0, _telejson.stringify)({
                    key: KEY,
                    event: event,
                    refId: query.refId
                }, stringifyOptions);
                if (!frames.length) return new Promise(function(resolve, reject) {
                    _this2.buffer.push({
                        event: event,
                        resolve: resolve,
                        reject: reject
                    });
                });
                if (this.buffer.length) this.flush();
                frames.forEach(function(f) {
                    try {
                        f.postMessage(data, "*");
                    } catch (e) {
                        console.error("sending over postmessage fail");
                    }
                });
                return Promise.resolve(null);
            }
        },
        {
            key: "flush",
            value: function flush() {
                var _this3 = this;
                var buffer = this.buffer;
                this.buffer = [];
                buffer.forEach(function(item) {
                    _this3.send(item.event).then(item.resolve).catch(item.reject);
                });
            }
        },
        {
            key: "getFrames",
            value: function getFrames(target) {
                if (this.config.page === "manager") {
                    var nodes = _toConsumableArray(document.querySelectorAll("iframe[data-is-storybook][data-is-loaded]"));
                    var list = nodes.filter(function(e) {
                        try {
                            return !!e.contentWindow && e.dataset.isStorybook !== undefined && e.id === target;
                        } catch (er) {
                            return false;
                        }
                    }).map(function(e) {
                        return e.contentWindow;
                    });
                    return list.length ? list : this.getCurrentFrames();
                }
                if (globalWindow && globalWindow.parent && globalWindow.parent !== globalWindow) return [
                    globalWindow.parent
                ];
                return [];
            }
        },
        {
            key: "getCurrentFrames",
            value: function getCurrentFrames() {
                if (this.config.page === "manager") {
                    var list = _toConsumableArray(document.querySelectorAll('[data-is-storybook="true"]'));
                    return list.map(function(e) {
                        return e.contentWindow;
                    });
                }
                if (globalWindow && globalWindow.parent) return [
                    globalWindow.parent
                ];
                return [];
            }
        },
        {
            key: "getLocalFrame",
            value: function getLocalFrame() {
                if (this.config.page === "manager") {
                    var list = _toConsumableArray(document.querySelectorAll("#storybook-preview-iframe"));
                    return list.map(function(e) {
                        return e.contentWindow;
                    });
                }
                if (globalWindow && globalWindow.parent) return [
                    globalWindow.parent
                ];
                return [];
            }
        },
        {
            key: "handleEvent",
            value: function handleEvent(rawEvent) {
                try {
                    var data = rawEvent.data;
                    var _ref4 = typeof data === "string" && (0, _telejson.isJSON)(data) ? (0, _telejson.parse)(data, (0, _globalDefault.default).CHANNEL_OPTIONS || {}) : data, key = _ref4.key, event = _ref4.event, refId = _ref4.refId;
                    if (key === KEY) {
                        var pageString = this.config.page === "manager" ? '<span style="color: #37D5D3; background: black"> manager </span>' : '<span style="color: #1EA7FD; background: black"> preview </span>';
                        var eventString = Object.values(_coreEvents).includes(event.type) ? '<span style="color: #FF4785">'.concat(event.type, "</span>") : '<span style="color: #FFAE00">'.concat(event.type, "</span>");
                        if (refId) event.refId = refId;
                        event.source = this.config.page === "preview" ? rawEvent.origin : getEventSourceUrl(rawEvent);
                        if (!event.source) {
                            (0, _clientLogger.pretty).error("".concat(pageString, " received ").concat(eventString, " but was unable to determine the source of the event"));
                            return;
                        }
                        var message = "".concat(pageString, " received ").concat(eventString, " (").concat(data.length, ")");
                        (0, _clientLogger.pretty).debug.apply((0, _clientLogger.pretty), [
                            location.origin !== event.source ? message : "".concat(message, ' <span style="color: gray">(on ').concat(location.origin, " from ").concat(event.source, ")</span>")
                        ].concat(_toConsumableArray(event.args)));
                        this.handler(event);
                    }
                } catch (error) {
                    (0, _clientLogger.logger).error(error);
                }
            }
        }
    ]);
    return PostmsgTransport;
}();
var getEventSourceUrl = function getEventSourceUrl(event) {
    var frames = _toConsumableArray(document.querySelectorAll("iframe[data-is-storybook]")); // try to find the originating iframe by matching it's contentWindow
    // This might not be cross-origin safe
    var _frames$filter = frames.filter(function(element) {
        try {
            return element.contentWindow === event.source;
        } catch (err) {}
        var src = element.getAttribute("src");
        var origin;
        try {
            var _URL = new URL(src, document.location);
            origin = _URL.origin;
        } catch (err) {
            return false;
        }
        return origin === event.origin;
    }), _frames$filter2 = _toArray(_frames$filter), frame = _frames$filter2[0], remainder = _frames$filter2.slice(1);
    if (frame && remainder.length === 0) {
        var src = frame.getAttribute("src");
        var _URL2 = new URL(src, document.location), protocol = _URL2.protocol, host = _URL2.host, pathname = _URL2.pathname;
        return "".concat(protocol, "//").concat(host).concat(pathname);
    }
    if (remainder.length > 0) // If we found multiple matches, there's going to be trouble
    (0, _clientLogger.logger).error("found multiple candidates for event source");
     // If we found no frames of matches
    return null;
};
function createChannel(_ref5) {
    var page = _ref5.page;
    var transport = new PostmsgTransport({
        page: page
    });
    return new (0, _channelsDefault.default)({
        transport: transport
    });
}

},{"core-js/modules/es.array.iterator.js":"ieU20","core-js/modules/es.object.from-entries.js":"03WLI","core-js/modules/es.array.filter.js":"fD2da","core-js/modules/es.object.to-string.js":"lsA9p","core-js/modules/es.object.entries.js":"7Wf79","core-js/modules/es.object.assign.js":"8FU8M","core-js/modules/es.number.is-integer.js":"hDo3S","core-js/modules/es.number.constructor.js":"hVD7l","core-js/modules/es.regexp.exec.js":"5q56v","core-js/modules/es.string.search.js":"l1Pph","core-js/modules/es.promise.js":"2jax7","core-js/modules/web.dom-collections.for-each.js":"iYT1M","core-js/modules/es.array.map.js":"jTP7e","core-js/modules/es.array.includes.js":"dbUjS","core-js/modules/es.string.includes.js":"cx9ET","core-js/modules/es.object.values.js":"bB8XB","core-js/modules/es.array.concat.js":"g1t7q","core-js/modules/es.string.iterator.js":"74a8v","core-js/modules/web.dom-collections.iterator.js":"aXR96","core-js/modules/web.url.js":"5DoTp","core-js/modules/web.url-search-params.js":"iPcbh","core-js/modules/es.array.slice.js":"8RRh9","core-js/modules/es.symbol.js":"ajw2f","core-js/modules/es.symbol.description.js":"wrlLc","core-js/modules/es.symbol.iterator.js":"fhNIb","core-js/modules/es.function.name.js":"4LiLL","core-js/modules/es.array.from.js":"9UCQw","global":"5PzlO","@storybook/core-events":"bJpgo","@storybook/channels":"7Sg7O","@storybook/client-logger":"iGRus","telejson":"jwiy1","qs":"2jOAs","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"03WLI":[function(require,module,exports) {
var $ = require("48c4d449b4b6a74e");
var iterate = require("ee4e4a7ea4b35347");
var createProperty = require("34466cd01816d06a");
// `Object.fromEntries` method
// https://github.com/tc39/proposal-object-from-entries
$({
    target: "Object",
    stat: true
}, {
    fromEntries: function fromEntries(iterable) {
        var obj = {};
        iterate(iterable, function(k, v) {
            createProperty(obj, k, v);
        }, {
            AS_ENTRIES: true
        });
        return obj;
    }
});

},{"48c4d449b4b6a74e":"1OO62","ee4e4a7ea4b35347":"9EwlZ","34466cd01816d06a":"3yb4H"}],"hDo3S":[function(require,module,exports) {
var $ = require("ce2c3fa51ce7a2b6");
var isIntegralNumber = require("3e3a085edc93c707");
// `Number.isInteger` method
// https://tc39.es/ecma262/#sec-number.isinteger
$({
    target: "Number",
    stat: true
}, {
    isInteger: isIntegralNumber
});

},{"ce2c3fa51ce7a2b6":"1OO62","3e3a085edc93c707":"9llZs"}],"9llZs":[function(require,module,exports) {
var isObject = require("de18539dea9401a");
var floor = Math.floor;
// `IsIntegralNumber` abstract operation
// https://tc39.es/ecma262/#sec-isintegralnumber
// eslint-disable-next-line es/no-number-isinteger -- safe
module.exports = Number.isInteger || function isInteger(it) {
    return !isObject(it) && isFinite(it) && floor(it) === it;
};

},{"de18539dea9401a":"bprny"}],"5DoTp":[function(require,module,exports) {
"use strict";
// TODO: in core-js@4, move /modules/ dependencies to public entries for better optimization by tools like `preset-env`
require("48d02b6823f754a3");
var $ = require("4b410fc1ef369813");
var DESCRIPTORS = require("3abe8324d1016124");
var USE_NATIVE_URL = require("1bc870948d0080f7");
var global = require("24db4633e5dff49d");
var bind = require("15d1849eb27c61dc");
var call = require("f2f868cce847527");
var uncurryThis = require("3031dcd32f1f3b3a");
var defineProperties = require("319e5298f28723ce");
var redefine = require("7f5a901bbb8a4a15");
var anInstance = require("ac338c11bbb228c6");
var hasOwn = require("d9a68dc6fddab42a");
var assign = require("6ad6311b7912d0c8");
var arrayFrom = require("791d9a26e0cd53b0");
var arraySlice = require("94504480081ff26c");
var codeAt = require("43ee1f75c06f27f7").codeAt;
var toASCII = require("3e5709236cb47cf8");
var $toString = require("b33a6669cbd4706");
var setToStringTag = require("dc01ac94ba4d3f1a");
var URLSearchParamsModule = require("fd4537cd0fea278f");
var InternalStateModule = require("e71504e758703d09");
var setInternalState = InternalStateModule.set;
var getInternalURLState = InternalStateModule.getterFor("URL");
var URLSearchParams = URLSearchParamsModule.URLSearchParams;
var getInternalSearchParamsState = URLSearchParamsModule.getState;
var NativeURL = global.URL;
var TypeError = global.TypeError;
var parseInt = global.parseInt;
var floor = Math.floor;
var pow = Math.pow;
var charAt = uncurryThis("".charAt);
var exec = uncurryThis(/./.exec);
var join = uncurryThis([].join);
var numberToString = uncurryThis(1.0.toString);
var pop = uncurryThis([].pop);
var push = uncurryThis([].push);
var replace = uncurryThis("".replace);
var shift = uncurryThis([].shift);
var split = uncurryThis("".split);
var stringSlice = uncurryThis("".slice);
var toLowerCase = uncurryThis("".toLowerCase);
var unshift = uncurryThis([].unshift);
var INVALID_AUTHORITY = "Invalid authority";
var INVALID_SCHEME = "Invalid scheme";
var INVALID_HOST = "Invalid host";
var INVALID_PORT = "Invalid port";
var ALPHA = /[a-z]/i;
// eslint-disable-next-line regexp/no-obscure-range -- safe
var ALPHANUMERIC = /[\d+-.a-z]/i;
var DIGIT = /\d/;
var HEX_START = /^0x/i;
var OCT = /^[0-7]+$/;
var DEC = /^\d+$/;
var HEX = /^[\da-f]+$/i;
/* eslint-disable regexp/no-control-character -- safe */ var FORBIDDEN_HOST_CODE_POINT = /[\0\t\n\r #%/:<>?@[\\\]^|]/;
var FORBIDDEN_HOST_CODE_POINT_EXCLUDING_PERCENT = /[\0\t\n\r #/:<>?@[\\\]^|]/;
var LEADING_AND_TRAILING_C0_CONTROL_OR_SPACE = /^[\u0000-\u0020]+|[\u0000-\u0020]+$/g;
var TAB_AND_NEW_LINE = /[\t\n\r]/g;
/* eslint-enable regexp/no-control-character -- safe */ var EOF;
var parseHost = function(url, input) {
    var result, codePoints, index;
    if (charAt(input, 0) == "[") {
        if (charAt(input, input.length - 1) != "]") return INVALID_HOST;
        result = parseIPv6(stringSlice(input, 1, -1));
        if (!result) return INVALID_HOST;
        url.host = result;
    // opaque host
    } else if (!isSpecial(url)) {
        if (exec(FORBIDDEN_HOST_CODE_POINT_EXCLUDING_PERCENT, input)) return INVALID_HOST;
        result = "";
        codePoints = arrayFrom(input);
        for(index = 0; index < codePoints.length; index++)result += percentEncode(codePoints[index], C0ControlPercentEncodeSet);
        url.host = result;
    } else {
        input = toASCII(input);
        if (exec(FORBIDDEN_HOST_CODE_POINT, input)) return INVALID_HOST;
        result = parseIPv4(input);
        if (result === null) return INVALID_HOST;
        url.host = result;
    }
};
var parseIPv4 = function(input) {
    var parts = split(input, ".");
    var partsLength, numbers, index, part, radix, number, ipv4;
    if (parts.length && parts[parts.length - 1] == "") parts.length--;
    partsLength = parts.length;
    if (partsLength > 4) return input;
    numbers = [];
    for(index = 0; index < partsLength; index++){
        part = parts[index];
        if (part == "") return input;
        radix = 10;
        if (part.length > 1 && charAt(part, 0) == "0") {
            radix = exec(HEX_START, part) ? 16 : 8;
            part = stringSlice(part, radix == 8 ? 1 : 2);
        }
        if (part === "") number = 0;
        else {
            if (!exec(radix == 10 ? DEC : radix == 8 ? OCT : HEX, part)) return input;
            number = parseInt(part, radix);
        }
        push(numbers, number);
    }
    for(index = 0; index < partsLength; index++){
        number = numbers[index];
        if (index == partsLength - 1) {
            if (number >= pow(256, 5 - partsLength)) return null;
        } else if (number > 255) return null;
    }
    ipv4 = pop(numbers);
    for(index = 0; index < numbers.length; index++)ipv4 += numbers[index] * pow(256, 3 - index);
    return ipv4;
};
// eslint-disable-next-line max-statements -- TODO
var parseIPv6 = function(input) {
    var address = [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ];
    var pieceIndex = 0;
    var compress = null;
    var pointer = 0;
    var value, length, numbersSeen, ipv4Piece, number, swaps, swap;
    var chr = function() {
        return charAt(input, pointer);
    };
    if (chr() == ":") {
        if (charAt(input, 1) != ":") return;
        pointer += 2;
        pieceIndex++;
        compress = pieceIndex;
    }
    while(chr()){
        if (pieceIndex == 8) return;
        if (chr() == ":") {
            if (compress !== null) return;
            pointer++;
            pieceIndex++;
            compress = pieceIndex;
            continue;
        }
        value = length = 0;
        while(length < 4 && exec(HEX, chr())){
            value = value * 16 + parseInt(chr(), 16);
            pointer++;
            length++;
        }
        if (chr() == ".") {
            if (length == 0) return;
            pointer -= length;
            if (pieceIndex > 6) return;
            numbersSeen = 0;
            while(chr()){
                ipv4Piece = null;
                if (numbersSeen > 0) {
                    if (chr() == "." && numbersSeen < 4) pointer++;
                    else return;
                }
                if (!exec(DIGIT, chr())) return;
                while(exec(DIGIT, chr())){
                    number = parseInt(chr(), 10);
                    if (ipv4Piece === null) ipv4Piece = number;
                    else if (ipv4Piece == 0) return;
                    else ipv4Piece = ipv4Piece * 10 + number;
                    if (ipv4Piece > 255) return;
                    pointer++;
                }
                address[pieceIndex] = address[pieceIndex] * 256 + ipv4Piece;
                numbersSeen++;
                if (numbersSeen == 2 || numbersSeen == 4) pieceIndex++;
            }
            if (numbersSeen != 4) return;
            break;
        } else if (chr() == ":") {
            pointer++;
            if (!chr()) return;
        } else if (chr()) return;
        address[pieceIndex++] = value;
    }
    if (compress !== null) {
        swaps = pieceIndex - compress;
        pieceIndex = 7;
        while(pieceIndex != 0 && swaps > 0){
            swap = address[pieceIndex];
            address[pieceIndex--] = address[compress + swaps - 1];
            address[compress + --swaps] = swap;
        }
    } else if (pieceIndex != 8) return;
    return address;
};
var findLongestZeroSequence = function(ipv6) {
    var maxIndex = null;
    var maxLength = 1;
    var currStart = null;
    var currLength = 0;
    var index = 0;
    for(; index < 8; index++)if (ipv6[index] !== 0) {
        if (currLength > maxLength) {
            maxIndex = currStart;
            maxLength = currLength;
        }
        currStart = null;
        currLength = 0;
    } else {
        if (currStart === null) currStart = index;
        ++currLength;
    }
    if (currLength > maxLength) {
        maxIndex = currStart;
        maxLength = currLength;
    }
    return maxIndex;
};
var serializeHost = function(host) {
    var result, index, compress, ignore0;
    // ipv4
    if (typeof host == "number") {
        result = [];
        for(index = 0; index < 4; index++){
            unshift(result, host % 256);
            host = floor(host / 256);
        }
        return join(result, ".");
    // ipv6
    } else if (typeof host == "object") {
        result = "";
        compress = findLongestZeroSequence(host);
        for(index = 0; index < 8; index++){
            if (ignore0 && host[index] === 0) continue;
            if (ignore0) ignore0 = false;
            if (compress === index) {
                result += index ? ":" : "::";
                ignore0 = true;
            } else {
                result += numberToString(host[index], 16);
                if (index < 7) result += ":";
            }
        }
        return "[" + result + "]";
    }
    return host;
};
var C0ControlPercentEncodeSet = {};
var fragmentPercentEncodeSet = assign({}, C0ControlPercentEncodeSet, {
    " ": 1,
    '"': 1,
    "<": 1,
    ">": 1,
    "`": 1
});
var pathPercentEncodeSet = assign({}, fragmentPercentEncodeSet, {
    "#": 1,
    "?": 1,
    "{": 1,
    "}": 1
});
var userinfoPercentEncodeSet = assign({}, pathPercentEncodeSet, {
    "/": 1,
    ":": 1,
    ";": 1,
    "=": 1,
    "@": 1,
    "[": 1,
    "\\": 1,
    "]": 1,
    "^": 1,
    "|": 1
});
var percentEncode = function(chr, set) {
    var code = codeAt(chr, 0);
    return code > 0x20 && code < 0x7F && !hasOwn(set, chr) ? chr : encodeURIComponent(chr);
};
var specialSchemes = {
    ftp: 21,
    file: null,
    http: 80,
    https: 443,
    ws: 80,
    wss: 443
};
var isSpecial = function(url) {
    return hasOwn(specialSchemes, url.scheme);
};
var includesCredentials = function(url) {
    return url.username != "" || url.password != "";
};
var cannotHaveUsernamePasswordPort = function(url) {
    return !url.host || url.cannotBeABaseURL || url.scheme == "file";
};
var isWindowsDriveLetter = function(string, normalized) {
    var second;
    return string.length == 2 && exec(ALPHA, charAt(string, 0)) && ((second = charAt(string, 1)) == ":" || !normalized && second == "|");
};
var startsWithWindowsDriveLetter = function(string) {
    var third;
    return string.length > 1 && isWindowsDriveLetter(stringSlice(string, 0, 2)) && (string.length == 2 || (third = charAt(string, 2)) === "/" || third === "\\" || third === "?" || third === "#");
};
var shortenURLsPath = function(url) {
    var path = url.path;
    var pathSize = path.length;
    if (pathSize && (url.scheme != "file" || pathSize != 1 || !isWindowsDriveLetter(path[0], true))) path.length--;
};
var isSingleDot = function(segment) {
    return segment === "." || toLowerCase(segment) === "%2e";
};
var isDoubleDot = function(segment) {
    segment = toLowerCase(segment);
    return segment === ".." || segment === "%2e." || segment === ".%2e" || segment === "%2e%2e";
};
// States:
var SCHEME_START = {};
var SCHEME = {};
var NO_SCHEME = {};
var SPECIAL_RELATIVE_OR_AUTHORITY = {};
var PATH_OR_AUTHORITY = {};
var RELATIVE = {};
var RELATIVE_SLASH = {};
var SPECIAL_AUTHORITY_SLASHES = {};
var SPECIAL_AUTHORITY_IGNORE_SLASHES = {};
var AUTHORITY = {};
var HOST = {};
var HOSTNAME = {};
var PORT = {};
var FILE = {};
var FILE_SLASH = {};
var FILE_HOST = {};
var PATH_START = {};
var PATH = {};
var CANNOT_BE_A_BASE_URL_PATH = {};
var QUERY = {};
var FRAGMENT = {};
// eslint-disable-next-line max-statements -- TODO
var parseURL = function(url, input, stateOverride, base) {
    var state = stateOverride || SCHEME_START;
    var pointer = 0;
    var buffer = "";
    var seenAt = false;
    var seenBracket = false;
    var seenPasswordToken = false;
    var codePoints, chr, bufferCodePoints, failure;
    if (!stateOverride) {
        url.scheme = "";
        url.username = "";
        url.password = "";
        url.host = null;
        url.port = null;
        url.path = [];
        url.query = null;
        url.fragment = null;
        url.cannotBeABaseURL = false;
        input = replace(input, LEADING_AND_TRAILING_C0_CONTROL_OR_SPACE, "");
    }
    input = replace(input, TAB_AND_NEW_LINE, "");
    codePoints = arrayFrom(input);
    while(pointer <= codePoints.length){
        chr = codePoints[pointer];
        switch(state){
            case SCHEME_START:
                if (chr && exec(ALPHA, chr)) {
                    buffer += toLowerCase(chr);
                    state = SCHEME;
                } else if (!stateOverride) {
                    state = NO_SCHEME;
                    continue;
                } else return INVALID_SCHEME;
                break;
            case SCHEME:
                if (chr && (exec(ALPHANUMERIC, chr) || chr == "+" || chr == "-" || chr == ".")) buffer += toLowerCase(chr);
                else if (chr == ":") {
                    if (stateOverride && (isSpecial(url) != hasOwn(specialSchemes, buffer) || buffer == "file" && (includesCredentials(url) || url.port !== null) || url.scheme == "file" && !url.host)) return;
                    url.scheme = buffer;
                    if (stateOverride) {
                        if (isSpecial(url) && specialSchemes[url.scheme] == url.port) url.port = null;
                        return;
                    }
                    buffer = "";
                    if (url.scheme == "file") state = FILE;
                    else if (isSpecial(url) && base && base.scheme == url.scheme) state = SPECIAL_RELATIVE_OR_AUTHORITY;
                    else if (isSpecial(url)) state = SPECIAL_AUTHORITY_SLASHES;
                    else if (codePoints[pointer + 1] == "/") {
                        state = PATH_OR_AUTHORITY;
                        pointer++;
                    } else {
                        url.cannotBeABaseURL = true;
                        push(url.path, "");
                        state = CANNOT_BE_A_BASE_URL_PATH;
                    }
                } else if (!stateOverride) {
                    buffer = "";
                    state = NO_SCHEME;
                    pointer = 0;
                    continue;
                } else return INVALID_SCHEME;
                break;
            case NO_SCHEME:
                if (!base || base.cannotBeABaseURL && chr != "#") return INVALID_SCHEME;
                if (base.cannotBeABaseURL && chr == "#") {
                    url.scheme = base.scheme;
                    url.path = arraySlice(base.path);
                    url.query = base.query;
                    url.fragment = "";
                    url.cannotBeABaseURL = true;
                    state = FRAGMENT;
                    break;
                }
                state = base.scheme == "file" ? FILE : RELATIVE;
                continue;
            case SPECIAL_RELATIVE_OR_AUTHORITY:
                if (chr == "/" && codePoints[pointer + 1] == "/") {
                    state = SPECIAL_AUTHORITY_IGNORE_SLASHES;
                    pointer++;
                } else {
                    state = RELATIVE;
                    continue;
                }
                break;
            case PATH_OR_AUTHORITY:
                if (chr == "/") {
                    state = AUTHORITY;
                    break;
                } else {
                    state = PATH;
                    continue;
                }
            case RELATIVE:
                url.scheme = base.scheme;
                if (chr == EOF) {
                    url.username = base.username;
                    url.password = base.password;
                    url.host = base.host;
                    url.port = base.port;
                    url.path = arraySlice(base.path);
                    url.query = base.query;
                } else if (chr == "/" || chr == "\\" && isSpecial(url)) state = RELATIVE_SLASH;
                else if (chr == "?") {
                    url.username = base.username;
                    url.password = base.password;
                    url.host = base.host;
                    url.port = base.port;
                    url.path = arraySlice(base.path);
                    url.query = "";
                    state = QUERY;
                } else if (chr == "#") {
                    url.username = base.username;
                    url.password = base.password;
                    url.host = base.host;
                    url.port = base.port;
                    url.path = arraySlice(base.path);
                    url.query = base.query;
                    url.fragment = "";
                    state = FRAGMENT;
                } else {
                    url.username = base.username;
                    url.password = base.password;
                    url.host = base.host;
                    url.port = base.port;
                    url.path = arraySlice(base.path);
                    url.path.length--;
                    state = PATH;
                    continue;
                }
                break;
            case RELATIVE_SLASH:
                if (isSpecial(url) && (chr == "/" || chr == "\\")) state = SPECIAL_AUTHORITY_IGNORE_SLASHES;
                else if (chr == "/") state = AUTHORITY;
                else {
                    url.username = base.username;
                    url.password = base.password;
                    url.host = base.host;
                    url.port = base.port;
                    state = PATH;
                    continue;
                }
                break;
            case SPECIAL_AUTHORITY_SLASHES:
                state = SPECIAL_AUTHORITY_IGNORE_SLASHES;
                if (chr != "/" || charAt(buffer, pointer + 1) != "/") continue;
                pointer++;
                break;
            case SPECIAL_AUTHORITY_IGNORE_SLASHES:
                if (chr != "/" && chr != "\\") {
                    state = AUTHORITY;
                    continue;
                }
                break;
            case AUTHORITY:
                if (chr == "@") {
                    if (seenAt) buffer = "%40" + buffer;
                    seenAt = true;
                    bufferCodePoints = arrayFrom(buffer);
                    for(var i = 0; i < bufferCodePoints.length; i++){
                        var codePoint = bufferCodePoints[i];
                        if (codePoint == ":" && !seenPasswordToken) {
                            seenPasswordToken = true;
                            continue;
                        }
                        var encodedCodePoints = percentEncode(codePoint, userinfoPercentEncodeSet);
                        if (seenPasswordToken) url.password += encodedCodePoints;
                        else url.username += encodedCodePoints;
                    }
                    buffer = "";
                } else if (chr == EOF || chr == "/" || chr == "?" || chr == "#" || chr == "\\" && isSpecial(url)) {
                    if (seenAt && buffer == "") return INVALID_AUTHORITY;
                    pointer -= arrayFrom(buffer).length + 1;
                    buffer = "";
                    state = HOST;
                } else buffer += chr;
                break;
            case HOST:
            case HOSTNAME:
                if (stateOverride && url.scheme == "file") {
                    state = FILE_HOST;
                    continue;
                } else if (chr == ":" && !seenBracket) {
                    if (buffer == "") return INVALID_HOST;
                    failure = parseHost(url, buffer);
                    if (failure) return failure;
                    buffer = "";
                    state = PORT;
                    if (stateOverride == HOSTNAME) return;
                } else if (chr == EOF || chr == "/" || chr == "?" || chr == "#" || chr == "\\" && isSpecial(url)) {
                    if (isSpecial(url) && buffer == "") return INVALID_HOST;
                    if (stateOverride && buffer == "" && (includesCredentials(url) || url.port !== null)) return;
                    failure = parseHost(url, buffer);
                    if (failure) return failure;
                    buffer = "";
                    state = PATH_START;
                    if (stateOverride) return;
                    continue;
                } else {
                    if (chr == "[") seenBracket = true;
                    else if (chr == "]") seenBracket = false;
                    buffer += chr;
                }
                break;
            case PORT:
                if (exec(DIGIT, chr)) buffer += chr;
                else if (chr == EOF || chr == "/" || chr == "?" || chr == "#" || chr == "\\" && isSpecial(url) || stateOverride) {
                    if (buffer != "") {
                        var port = parseInt(buffer, 10);
                        if (port > 0xFFFF) return INVALID_PORT;
                        url.port = isSpecial(url) && port === specialSchemes[url.scheme] ? null : port;
                        buffer = "";
                    }
                    if (stateOverride) return;
                    state = PATH_START;
                    continue;
                } else return INVALID_PORT;
                break;
            case FILE:
                url.scheme = "file";
                if (chr == "/" || chr == "\\") state = FILE_SLASH;
                else if (base && base.scheme == "file") {
                    if (chr == EOF) {
                        url.host = base.host;
                        url.path = arraySlice(base.path);
                        url.query = base.query;
                    } else if (chr == "?") {
                        url.host = base.host;
                        url.path = arraySlice(base.path);
                        url.query = "";
                        state = QUERY;
                    } else if (chr == "#") {
                        url.host = base.host;
                        url.path = arraySlice(base.path);
                        url.query = base.query;
                        url.fragment = "";
                        state = FRAGMENT;
                    } else {
                        if (!startsWithWindowsDriveLetter(join(arraySlice(codePoints, pointer), ""))) {
                            url.host = base.host;
                            url.path = arraySlice(base.path);
                            shortenURLsPath(url);
                        }
                        state = PATH;
                        continue;
                    }
                } else {
                    state = PATH;
                    continue;
                }
                break;
            case FILE_SLASH:
                if (chr == "/" || chr == "\\") {
                    state = FILE_HOST;
                    break;
                }
                if (base && base.scheme == "file" && !startsWithWindowsDriveLetter(join(arraySlice(codePoints, pointer), ""))) {
                    if (isWindowsDriveLetter(base.path[0], true)) push(url.path, base.path[0]);
                    else url.host = base.host;
                }
                state = PATH;
                continue;
            case FILE_HOST:
                if (chr == EOF || chr == "/" || chr == "\\" || chr == "?" || chr == "#") {
                    if (!stateOverride && isWindowsDriveLetter(buffer)) state = PATH;
                    else if (buffer == "") {
                        url.host = "";
                        if (stateOverride) return;
                        state = PATH_START;
                    } else {
                        failure = parseHost(url, buffer);
                        if (failure) return failure;
                        if (url.host == "localhost") url.host = "";
                        if (stateOverride) return;
                        buffer = "";
                        state = PATH_START;
                    }
                    continue;
                } else buffer += chr;
                break;
            case PATH_START:
                if (isSpecial(url)) {
                    state = PATH;
                    if (chr != "/" && chr != "\\") continue;
                } else if (!stateOverride && chr == "?") {
                    url.query = "";
                    state = QUERY;
                } else if (!stateOverride && chr == "#") {
                    url.fragment = "";
                    state = FRAGMENT;
                } else if (chr != EOF) {
                    state = PATH;
                    if (chr != "/") continue;
                }
                break;
            case PATH:
                if (chr == EOF || chr == "/" || chr == "\\" && isSpecial(url) || !stateOverride && (chr == "?" || chr == "#")) {
                    if (isDoubleDot(buffer)) {
                        shortenURLsPath(url);
                        if (chr != "/" && !(chr == "\\" && isSpecial(url))) push(url.path, "");
                    } else if (isSingleDot(buffer)) {
                        if (chr != "/" && !(chr == "\\" && isSpecial(url))) push(url.path, "");
                    } else {
                        if (url.scheme == "file" && !url.path.length && isWindowsDriveLetter(buffer)) {
                            if (url.host) url.host = "";
                            buffer = charAt(buffer, 0) + ":"; // normalize windows drive letter
                        }
                        push(url.path, buffer);
                    }
                    buffer = "";
                    if (url.scheme == "file" && (chr == EOF || chr == "?" || chr == "#")) while(url.path.length > 1 && url.path[0] === "")shift(url.path);
                    if (chr == "?") {
                        url.query = "";
                        state = QUERY;
                    } else if (chr == "#") {
                        url.fragment = "";
                        state = FRAGMENT;
                    }
                } else buffer += percentEncode(chr, pathPercentEncodeSet);
                break;
            case CANNOT_BE_A_BASE_URL_PATH:
                if (chr == "?") {
                    url.query = "";
                    state = QUERY;
                } else if (chr == "#") {
                    url.fragment = "";
                    state = FRAGMENT;
                } else if (chr != EOF) url.path[0] += percentEncode(chr, C0ControlPercentEncodeSet);
                break;
            case QUERY:
                if (!stateOverride && chr == "#") {
                    url.fragment = "";
                    state = FRAGMENT;
                } else if (chr != EOF) {
                    if (chr == "'" && isSpecial(url)) url.query += "%27";
                    else if (chr == "#") url.query += "%23";
                    else url.query += percentEncode(chr, C0ControlPercentEncodeSet);
                }
                break;
            case FRAGMENT:
                if (chr != EOF) url.fragment += percentEncode(chr, fragmentPercentEncodeSet);
                break;
        }
        pointer++;
    }
};
// `URL` constructor
// https://url.spec.whatwg.org/#url-class
var URLConstructor = function URL(url /* , base */ ) {
    var that = anInstance(this, URLPrototype);
    var base = arguments.length > 1 ? arguments[1] : undefined;
    var urlString = $toString(url);
    var state = setInternalState(that, {
        type: "URL"
    });
    var baseState, failure;
    if (base !== undefined) try {
        baseState = getInternalURLState(base);
    } catch (error) {
        failure = parseURL(baseState = {}, $toString(base));
        if (failure) throw TypeError(failure);
    }
    failure = parseURL(state, urlString, null, baseState);
    if (failure) throw TypeError(failure);
    var searchParams = state.searchParams = new URLSearchParams();
    var searchParamsState = getInternalSearchParamsState(searchParams);
    searchParamsState.updateSearchParams(state.query);
    searchParamsState.updateURL = function() {
        state.query = $toString(searchParams) || null;
    };
    if (!DESCRIPTORS) {
        that.href = call(serializeURL, that);
        that.origin = call(getOrigin, that);
        that.protocol = call(getProtocol, that);
        that.username = call(getUsername, that);
        that.password = call(getPassword, that);
        that.host = call(getHost, that);
        that.hostname = call(getHostname, that);
        that.port = call(getPort, that);
        that.pathname = call(getPathname, that);
        that.search = call(getSearch, that);
        that.searchParams = call(getSearchParams, that);
        that.hash = call(getHash, that);
    }
};
var URLPrototype = URLConstructor.prototype;
var serializeURL = function() {
    var url = getInternalURLState(this);
    var scheme = url.scheme;
    var username = url.username;
    var password = url.password;
    var host = url.host;
    var port = url.port;
    var path = url.path;
    var query = url.query;
    var fragment = url.fragment;
    var output = scheme + ":";
    if (host !== null) {
        output += "//";
        if (includesCredentials(url)) output += username + (password ? ":" + password : "") + "@";
        output += serializeHost(host);
        if (port !== null) output += ":" + port;
    } else if (scheme == "file") output += "//";
    output += url.cannotBeABaseURL ? path[0] : path.length ? "/" + join(path, "/") : "";
    if (query !== null) output += "?" + query;
    if (fragment !== null) output += "#" + fragment;
    return output;
};
var getOrigin = function() {
    var url = getInternalURLState(this);
    var scheme = url.scheme;
    var port = url.port;
    if (scheme == "blob") try {
        return new URLConstructor(scheme.path[0]).origin;
    } catch (error) {
        return "null";
    }
    if (scheme == "file" || !isSpecial(url)) return "null";
    return scheme + "://" + serializeHost(url.host) + (port !== null ? ":" + port : "");
};
var getProtocol = function() {
    return getInternalURLState(this).scheme + ":";
};
var getUsername = function() {
    return getInternalURLState(this).username;
};
var getPassword = function() {
    return getInternalURLState(this).password;
};
var getHost = function() {
    var url = getInternalURLState(this);
    var host = url.host;
    var port = url.port;
    return host === null ? "" : port === null ? serializeHost(host) : serializeHost(host) + ":" + port;
};
var getHostname = function() {
    var host = getInternalURLState(this).host;
    return host === null ? "" : serializeHost(host);
};
var getPort = function() {
    var port = getInternalURLState(this).port;
    return port === null ? "" : $toString(port);
};
var getPathname = function() {
    var url = getInternalURLState(this);
    var path = url.path;
    return url.cannotBeABaseURL ? path[0] : path.length ? "/" + join(path, "/") : "";
};
var getSearch = function() {
    var query = getInternalURLState(this).query;
    return query ? "?" + query : "";
};
var getSearchParams = function() {
    return getInternalURLState(this).searchParams;
};
var getHash = function() {
    var fragment = getInternalURLState(this).fragment;
    return fragment ? "#" + fragment : "";
};
var accessorDescriptor = function(getter, setter) {
    return {
        get: getter,
        set: setter,
        configurable: true,
        enumerable: true
    };
};
if (DESCRIPTORS) defineProperties(URLPrototype, {
    // `URL.prototype.href` accessors pair
    // https://url.spec.whatwg.org/#dom-url-href
    href: accessorDescriptor(serializeURL, function(href) {
        var url = getInternalURLState(this);
        var urlString = $toString(href);
        var failure = parseURL(url, urlString);
        if (failure) throw TypeError(failure);
        getInternalSearchParamsState(url.searchParams).updateSearchParams(url.query);
    }),
    // `URL.prototype.origin` getter
    // https://url.spec.whatwg.org/#dom-url-origin
    origin: accessorDescriptor(getOrigin),
    // `URL.prototype.protocol` accessors pair
    // https://url.spec.whatwg.org/#dom-url-protocol
    protocol: accessorDescriptor(getProtocol, function(protocol) {
        var url = getInternalURLState(this);
        parseURL(url, $toString(protocol) + ":", SCHEME_START);
    }),
    // `URL.prototype.username` accessors pair
    // https://url.spec.whatwg.org/#dom-url-username
    username: accessorDescriptor(getUsername, function(username) {
        var url = getInternalURLState(this);
        var codePoints = arrayFrom($toString(username));
        if (cannotHaveUsernamePasswordPort(url)) return;
        url.username = "";
        for(var i = 0; i < codePoints.length; i++)url.username += percentEncode(codePoints[i], userinfoPercentEncodeSet);
    }),
    // `URL.prototype.password` accessors pair
    // https://url.spec.whatwg.org/#dom-url-password
    password: accessorDescriptor(getPassword, function(password) {
        var url = getInternalURLState(this);
        var codePoints = arrayFrom($toString(password));
        if (cannotHaveUsernamePasswordPort(url)) return;
        url.password = "";
        for(var i = 0; i < codePoints.length; i++)url.password += percentEncode(codePoints[i], userinfoPercentEncodeSet);
    }),
    // `URL.prototype.host` accessors pair
    // https://url.spec.whatwg.org/#dom-url-host
    host: accessorDescriptor(getHost, function(host) {
        var url = getInternalURLState(this);
        if (url.cannotBeABaseURL) return;
        parseURL(url, $toString(host), HOST);
    }),
    // `URL.prototype.hostname` accessors pair
    // https://url.spec.whatwg.org/#dom-url-hostname
    hostname: accessorDescriptor(getHostname, function(hostname) {
        var url = getInternalURLState(this);
        if (url.cannotBeABaseURL) return;
        parseURL(url, $toString(hostname), HOSTNAME);
    }),
    // `URL.prototype.port` accessors pair
    // https://url.spec.whatwg.org/#dom-url-port
    port: accessorDescriptor(getPort, function(port) {
        var url = getInternalURLState(this);
        if (cannotHaveUsernamePasswordPort(url)) return;
        port = $toString(port);
        if (port == "") url.port = null;
        else parseURL(url, port, PORT);
    }),
    // `URL.prototype.pathname` accessors pair
    // https://url.spec.whatwg.org/#dom-url-pathname
    pathname: accessorDescriptor(getPathname, function(pathname) {
        var url = getInternalURLState(this);
        if (url.cannotBeABaseURL) return;
        url.path = [];
        parseURL(url, $toString(pathname), PATH_START);
    }),
    // `URL.prototype.search` accessors pair
    // https://url.spec.whatwg.org/#dom-url-search
    search: accessorDescriptor(getSearch, function(search) {
        var url = getInternalURLState(this);
        search = $toString(search);
        if (search == "") url.query = null;
        else {
            if ("?" == charAt(search, 0)) search = stringSlice(search, 1);
            url.query = "";
            parseURL(url, search, QUERY);
        }
        getInternalSearchParamsState(url.searchParams).updateSearchParams(url.query);
    }),
    // `URL.prototype.searchParams` getter
    // https://url.spec.whatwg.org/#dom-url-searchparams
    searchParams: accessorDescriptor(getSearchParams),
    // `URL.prototype.hash` accessors pair
    // https://url.spec.whatwg.org/#dom-url-hash
    hash: accessorDescriptor(getHash, function(hash) {
        var url = getInternalURLState(this);
        hash = $toString(hash);
        if (hash == "") {
            url.fragment = null;
            return;
        }
        if ("#" == charAt(hash, 0)) hash = stringSlice(hash, 1);
        url.fragment = "";
        parseURL(url, hash, FRAGMENT);
    })
});
// `URL.prototype.toJSON` method
// https://url.spec.whatwg.org/#dom-url-tojson
redefine(URLPrototype, "toJSON", function toJSON() {
    return call(serializeURL, this);
}, {
    enumerable: true
});
// `URL.prototype.toString` method
// https://url.spec.whatwg.org/#URL-stringification-behavior
redefine(URLPrototype, "toString", function toString() {
    return call(serializeURL, this);
}, {
    enumerable: true
});
if (NativeURL) {
    var nativeCreateObjectURL = NativeURL.createObjectURL;
    var nativeRevokeObjectURL = NativeURL.revokeObjectURL;
    // `URL.createObjectURL` method
    // https://developer.mozilla.org/en-US/docs/Web/API/URL/createObjectURL
    if (nativeCreateObjectURL) redefine(URLConstructor, "createObjectURL", bind(nativeCreateObjectURL, NativeURL));
    // `URL.revokeObjectURL` method
    // https://developer.mozilla.org/en-US/docs/Web/API/URL/revokeObjectURL
    if (nativeRevokeObjectURL) redefine(URLConstructor, "revokeObjectURL", bind(nativeRevokeObjectURL, NativeURL));
}
setToStringTag(URLConstructor, "URL");
$({
    global: true,
    forced: !USE_NATIVE_URL,
    sham: !DESCRIPTORS
}, {
    URL: URLConstructor
});

},{"48d02b6823f754a3":"74a8v","4b410fc1ef369813":"1OO62","3abe8324d1016124":"7Hk5a","1bc870948d0080f7":"dtEWE","24db4633e5dff49d":"1GZc4","15d1849eb27c61dc":"lgzZz","f2f868cce847527":"aSvFj","3031dcd32f1f3b3a":"fP9tv","319e5298f28723ce":"gAXUl","7f5a901bbb8a4a15":"3ncOy","ac338c11bbb228c6":"kZWyK","d9a68dc6fddab42a":"4SzRl","6ad6311b7912d0c8":"aQyRR","791d9a26e0cd53b0":"2sB7j","94504480081ff26c":"hloI5","43ee1f75c06f27f7":"iPGTe","3e5709236cb47cf8":"jzqaD","b33a6669cbd4706":"8RVGu","dc01ac94ba4d3f1a":"hVfEJ","fd4537cd0fea278f":"iPcbh","e71504e758703d09":"bRWxa"}],"dtEWE":[function(require,module,exports) {
var fails = require("8c066ab8db44a287");
var wellKnownSymbol = require("b6911100db72ae16");
var IS_PURE = require("75edd8869f5cf5ad");
var ITERATOR = wellKnownSymbol("iterator");
module.exports = !fails(function() {
    var url = new URL("b?a=1&b=2&c=3", "http://a");
    var searchParams = url.searchParams;
    var result = "";
    url.pathname = "c%20d";
    searchParams.forEach(function(value, key) {
        searchParams["delete"]("b");
        result += key + value;
    });
    return IS_PURE && !url.toJSON || !searchParams.sort || url.href !== "http://a/c%20d?a=1&c=3" || searchParams.get("c") !== "3" || String(new URLSearchParams("?a=1")) !== "a=1" || !searchParams[ITERATOR] || new URL("https://a@b").username !== "a" || new URLSearchParams(new URLSearchParams("a=b")).get("a") !== "b" || new URL("http://\u0442\u0435\u0441\u0442").host !== "xn--e1aybc" || new URL("http://a#\u0431").hash !== "#%D0%B1" || result !== "a1c3" || new URL("http://x", undefined).host !== "x";
});

},{"8c066ab8db44a287":"keKlS","b6911100db72ae16":"kbsMI","75edd8869f5cf5ad":"bZbjq"}],"jzqaD":[function(require,module,exports) {
"use strict";
// based on https://github.com/bestiejs/punycode.js/blob/master/punycode.js
var global = require("1e8e1679e037c5c9");
var uncurryThis = require("5fc1d380e4ee310c");
var maxInt = 2147483647; // aka. 0x7FFFFFFF or 2^31-1
var base = 36;
var tMin = 1;
var tMax = 26;
var skew = 38;
var damp = 700;
var initialBias = 72;
var initialN = 128; // 0x80
var delimiter = "-"; // '\x2D'
var regexNonASCII = /[^\0-\u007E]/; // non-ASCII chars
var regexSeparators = /[.\u3002\uFF0E\uFF61]/g; // RFC 3490 separators
var OVERFLOW_ERROR = "Overflow: input needs wider integers to process";
var baseMinusTMin = base - tMin;
var RangeError = global.RangeError;
var exec = uncurryThis(regexSeparators.exec);
var floor = Math.floor;
var fromCharCode = String.fromCharCode;
var charCodeAt = uncurryThis("".charCodeAt);
var join = uncurryThis([].join);
var push = uncurryThis([].push);
var replace = uncurryThis("".replace);
var split = uncurryThis("".split);
var toLowerCase = uncurryThis("".toLowerCase);
/**
 * Creates an array containing the numeric code points of each Unicode
 * character in the string. While JavaScript uses UCS-2 internally,
 * this function will convert a pair of surrogate halves (each of which
 * UCS-2 exposes as separate characters) into a single code point,
 * matching UTF-16.
 */ var ucs2decode = function(string) {
    var output = [];
    var counter = 0;
    var length = string.length;
    while(counter < length){
        var value = charCodeAt(string, counter++);
        if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
            // It's a high surrogate, and there is a next character.
            var extra = charCodeAt(string, counter++);
            if ((extra & 0xFC00) == 0xDC00) push(output, ((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
            else {
                // It's an unmatched surrogate; only append this code unit, in case the
                // next code unit is the high surrogate of a surrogate pair.
                push(output, value);
                counter--;
            }
        } else push(output, value);
    }
    return output;
};
/**
 * Converts a digit/integer into a basic code point.
 */ var digitToBasic = function(digit) {
    //  0..25 map to ASCII a..z or A..Z
    // 26..35 map to ASCII 0..9
    return digit + 22 + 75 * (digit < 26);
};
/**
 * Bias adaptation function as per section 3.4 of RFC 3492.
 * https://tools.ietf.org/html/rfc3492#section-3.4
 */ var adapt = function(delta, numPoints, firstTime) {
    var k = 0;
    delta = firstTime ? floor(delta / damp) : delta >> 1;
    delta += floor(delta / numPoints);
    for(; delta > baseMinusTMin * tMax >> 1; k += base)delta = floor(delta / baseMinusTMin);
    return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
};
/**
 * Converts a string of Unicode symbols (e.g. a domain name label) to a
 * Punycode string of ASCII-only symbols.
 */ // eslint-disable-next-line max-statements -- TODO
var encode = function(input) {
    var output = [];
    // Convert the input in UCS-2 to an array of Unicode code points.
    input = ucs2decode(input);
    // Cache the length.
    var inputLength = input.length;
    // Initialize the state.
    var n = initialN;
    var delta = 0;
    var bias = initialBias;
    var i, currentValue;
    // Handle the basic code points.
    for(i = 0; i < input.length; i++){
        currentValue = input[i];
        if (currentValue < 0x80) push(output, fromCharCode(currentValue));
    }
    var basicLength = output.length; // number of basic code points.
    var handledCPCount = basicLength; // number of code points that have been handled;
    // Finish the basic string with a delimiter unless it's empty.
    if (basicLength) push(output, delimiter);
    // Main encoding loop:
    while(handledCPCount < inputLength){
        // All non-basic code points < n have been handled already. Find the next larger one:
        var m = maxInt;
        for(i = 0; i < input.length; i++){
            currentValue = input[i];
            if (currentValue >= n && currentValue < m) m = currentValue;
        }
        // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>, but guard against overflow.
        var handledCPCountPlusOne = handledCPCount + 1;
        if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) throw RangeError(OVERFLOW_ERROR);
        delta += (m - n) * handledCPCountPlusOne;
        n = m;
        for(i = 0; i < input.length; i++){
            currentValue = input[i];
            if (currentValue < n && ++delta > maxInt) throw RangeError(OVERFLOW_ERROR);
            if (currentValue == n) {
                // Represent delta as a generalized variable-length integer.
                var q = delta;
                for(var k = base;; k += base){
                    var t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                    if (q < t) break;
                    var qMinusT = q - t;
                    var baseMinusT = base - t;
                    push(output, fromCharCode(digitToBasic(t + qMinusT % baseMinusT)));
                    q = floor(qMinusT / baseMinusT);
                }
                push(output, fromCharCode(digitToBasic(q)));
                bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
                delta = 0;
                ++handledCPCount;
            }
        }
        ++delta;
        ++n;
    }
    return join(output, "");
};
module.exports = function(input) {
    var encoded = [];
    var labels = split(replace(toLowerCase(input), regexSeparators, "."), ".");
    var i, label;
    for(i = 0; i < labels.length; i++){
        label = labels[i];
        push(encoded, exec(regexNonASCII, label) ? "xn--" + encode(label) : label);
    }
    return join(encoded, ".");
};

},{"1e8e1679e037c5c9":"1GZc4","5fc1d380e4ee310c":"fP9tv"}],"iPcbh":[function(require,module,exports) {
"use strict";
// TODO: in core-js@4, move /modules/ dependencies to public entries for better optimization by tools like `preset-env`
require("49e881ba268140e8");
var $ = require("fb5e74806c1e61e9");
var global = require("1c4c3846ccab769d");
var getBuiltIn = require("70c2bf9441608f0e");
var call = require("c95496581cbfeba1");
var uncurryThis = require("47a9f3e9f470a0c7");
var USE_NATIVE_URL = require("d0a8cac1ad9323ef");
var redefine = require("c7d2b99a2daef6de");
var redefineAll = require("47b34c7120e818f1");
var setToStringTag = require("3ca80d3b597aa7df");
var createIteratorConstructor = require("6226a115ac6c4a3c");
var InternalStateModule = require("934c7b6fe6105501");
var anInstance = require("ba0f0cbef03e2a64");
var isCallable = require("ff50adf849d8d57");
var hasOwn = require("305c68122e906458");
var bind = require("82e20ace544d4b87");
var classof = require("fe8fd12be41ba3a6");
var anObject = require("3534c68d8f8f53cb");
var isObject = require("6e5bb35eebc4effa");
var $toString = require("893bd67cae0f20f4");
var create = require("e514925786002059");
var createPropertyDescriptor = require("4ba3c1b86a524f1e");
var getIterator = require("64846cb85f6c5370");
var getIteratorMethod = require("2ea422697f285bab");
var wellKnownSymbol = require("eefbd1eeca45190");
var arraySort = require("45e893154f2fb147");
var ITERATOR = wellKnownSymbol("iterator");
var URL_SEARCH_PARAMS = "URLSearchParams";
var URL_SEARCH_PARAMS_ITERATOR = URL_SEARCH_PARAMS + "Iterator";
var setInternalState = InternalStateModule.set;
var getInternalParamsState = InternalStateModule.getterFor(URL_SEARCH_PARAMS);
var getInternalIteratorState = InternalStateModule.getterFor(URL_SEARCH_PARAMS_ITERATOR);
var n$Fetch = getBuiltIn("fetch");
var N$Request = getBuiltIn("Request");
var Headers = getBuiltIn("Headers");
var RequestPrototype = N$Request && N$Request.prototype;
var HeadersPrototype = Headers && Headers.prototype;
var RegExp = global.RegExp;
var TypeError = global.TypeError;
var decodeURIComponent = global.decodeURIComponent;
var encodeURIComponent = global.encodeURIComponent;
var charAt = uncurryThis("".charAt);
var join = uncurryThis([].join);
var push = uncurryThis([].push);
var replace = uncurryThis("".replace);
var shift = uncurryThis([].shift);
var splice = uncurryThis([].splice);
var split = uncurryThis("".split);
var stringSlice = uncurryThis("".slice);
var plus = /\+/g;
var sequences = Array(4);
var percentSequence = function(bytes) {
    return sequences[bytes - 1] || (sequences[bytes - 1] = RegExp("((?:%[\\da-f]{2}){" + bytes + "})", "gi"));
};
var percentDecode = function(sequence) {
    try {
        return decodeURIComponent(sequence);
    } catch (error) {
        return sequence;
    }
};
var deserialize = function(it) {
    var result = replace(it, plus, " ");
    var bytes = 4;
    try {
        return decodeURIComponent(result);
    } catch (error) {
        while(bytes)result = replace(result, percentSequence(bytes--), percentDecode);
        return result;
    }
};
var find = /[!'()~]|%20/g;
var replacements = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+"
};
var replacer = function(match) {
    return replacements[match];
};
var serialize = function(it) {
    return replace(encodeURIComponent(it), find, replacer);
};
var parseSearchParams = function(result, query) {
    if (query) {
        var attributes = split(query, "&");
        var index = 0;
        var attribute, entry;
        while(index < attributes.length){
            attribute = attributes[index++];
            if (attribute.length) {
                entry = split(attribute, "=");
                push(result, {
                    key: deserialize(shift(entry)),
                    value: deserialize(join(entry, "="))
                });
            }
        }
    }
};
var updateSearchParams = function(query) {
    this.entries.length = 0;
    parseSearchParams(this.entries, query);
};
var validateArgumentsLength = function(passed, required) {
    if (passed < required) throw TypeError("Not enough arguments");
};
var URLSearchParamsIterator = createIteratorConstructor(function Iterator(params, kind) {
    setInternalState(this, {
        type: URL_SEARCH_PARAMS_ITERATOR,
        iterator: getIterator(getInternalParamsState(params).entries),
        kind: kind
    });
}, "Iterator", function next() {
    var state = getInternalIteratorState(this);
    var kind = state.kind;
    var step = state.iterator.next();
    var entry = step.value;
    if (!step.done) step.value = kind === "keys" ? entry.key : kind === "values" ? entry.value : [
        entry.key,
        entry.value
    ];
    return step;
});
// `URLSearchParams` constructor
// https://url.spec.whatwg.org/#interface-urlsearchparams
var URLSearchParamsConstructor = function URLSearchParams() {
    anInstance(this, URLSearchParamsPrototype);
    var init = arguments.length > 0 ? arguments[0] : undefined;
    var that = this;
    var entries = [];
    var iteratorMethod, iterator, next, step, entryIterator, entryNext, first, second, key;
    setInternalState(that, {
        type: URL_SEARCH_PARAMS,
        entries: entries,
        updateURL: function() {},
        updateSearchParams: updateSearchParams
    });
    if (init !== undefined) {
        if (isObject(init)) {
            iteratorMethod = getIteratorMethod(init);
            if (iteratorMethod) {
                iterator = getIterator(init, iteratorMethod);
                next = iterator.next;
                while(!(step = call(next, iterator)).done){
                    entryIterator = getIterator(anObject(step.value));
                    entryNext = entryIterator.next;
                    if ((first = call(entryNext, entryIterator)).done || (second = call(entryNext, entryIterator)).done || !call(entryNext, entryIterator).done) throw TypeError("Expected sequence with length 2");
                    push(entries, {
                        key: $toString(first.value),
                        value: $toString(second.value)
                    });
                }
            } else for(key in init)if (hasOwn(init, key)) push(entries, {
                key: key,
                value: $toString(init[key])
            });
        } else parseSearchParams(entries, typeof init == "string" ? charAt(init, 0) === "?" ? stringSlice(init, 1) : init : $toString(init));
    }
};
var URLSearchParamsPrototype = URLSearchParamsConstructor.prototype;
redefineAll(URLSearchParamsPrototype, {
    // `URLSearchParams.prototype.append` method
    // https://url.spec.whatwg.org/#dom-urlsearchparams-append
    append: function append(name, value) {
        validateArgumentsLength(arguments.length, 2);
        var state = getInternalParamsState(this);
        push(state.entries, {
            key: $toString(name),
            value: $toString(value)
        });
        state.updateURL();
    },
    // `URLSearchParams.prototype.delete` method
    // https://url.spec.whatwg.org/#dom-urlsearchparams-delete
    "delete": function(name) {
        validateArgumentsLength(arguments.length, 1);
        var state = getInternalParamsState(this);
        var entries = state.entries;
        var key = $toString(name);
        var index = 0;
        while(index < entries.length)if (entries[index].key === key) splice(entries, index, 1);
        else index++;
        state.updateURL();
    },
    // `URLSearchParams.prototype.get` method
    // https://url.spec.whatwg.org/#dom-urlsearchparams-get
    get: function get(name) {
        validateArgumentsLength(arguments.length, 1);
        var entries = getInternalParamsState(this).entries;
        var key = $toString(name);
        var index = 0;
        for(; index < entries.length; index++){
            if (entries[index].key === key) return entries[index].value;
        }
        return null;
    },
    // `URLSearchParams.prototype.getAll` method
    // https://url.spec.whatwg.org/#dom-urlsearchparams-getall
    getAll: function getAll(name) {
        validateArgumentsLength(arguments.length, 1);
        var entries = getInternalParamsState(this).entries;
        var key = $toString(name);
        var result = [];
        var index = 0;
        for(; index < entries.length; index++)if (entries[index].key === key) push(result, entries[index].value);
        return result;
    },
    // `URLSearchParams.prototype.has` method
    // https://url.spec.whatwg.org/#dom-urlsearchparams-has
    has: function has(name) {
        validateArgumentsLength(arguments.length, 1);
        var entries = getInternalParamsState(this).entries;
        var key = $toString(name);
        var index = 0;
        while(index < entries.length){
            if (entries[index++].key === key) return true;
        }
        return false;
    },
    // `URLSearchParams.prototype.set` method
    // https://url.spec.whatwg.org/#dom-urlsearchparams-set
    set: function set(name, value) {
        validateArgumentsLength(arguments.length, 1);
        var state = getInternalParamsState(this);
        var entries = state.entries;
        var found = false;
        var key = $toString(name);
        var val = $toString(value);
        var index = 0;
        var entry;
        for(; index < entries.length; index++){
            entry = entries[index];
            if (entry.key === key) {
                if (found) splice(entries, index--, 1);
                else {
                    found = true;
                    entry.value = val;
                }
            }
        }
        if (!found) push(entries, {
            key: key,
            value: val
        });
        state.updateURL();
    },
    // `URLSearchParams.prototype.sort` method
    // https://url.spec.whatwg.org/#dom-urlsearchparams-sort
    sort: function sort() {
        var state = getInternalParamsState(this);
        arraySort(state.entries, function(a, b) {
            return a.key > b.key ? 1 : -1;
        });
        state.updateURL();
    },
    // `URLSearchParams.prototype.forEach` method
    forEach: function forEach(callback /* , thisArg */ ) {
        var entries = getInternalParamsState(this).entries;
        var boundFunction = bind(callback, arguments.length > 1 ? arguments[1] : undefined);
        var index = 0;
        var entry;
        while(index < entries.length){
            entry = entries[index++];
            boundFunction(entry.value, entry.key, this);
        }
    },
    // `URLSearchParams.prototype.keys` method
    keys: function keys() {
        return new URLSearchParamsIterator(this, "keys");
    },
    // `URLSearchParams.prototype.values` method
    values: function values() {
        return new URLSearchParamsIterator(this, "values");
    },
    // `URLSearchParams.prototype.entries` method
    entries: function entries() {
        return new URLSearchParamsIterator(this, "entries");
    }
}, {
    enumerable: true
});
// `URLSearchParams.prototype[@@iterator]` method
redefine(URLSearchParamsPrototype, ITERATOR, URLSearchParamsPrototype.entries, {
    name: "entries"
});
// `URLSearchParams.prototype.toString` method
// https://url.spec.whatwg.org/#urlsearchparams-stringification-behavior
redefine(URLSearchParamsPrototype, "toString", function toString() {
    var entries = getInternalParamsState(this).entries;
    var result = [];
    var index = 0;
    var entry;
    while(index < entries.length){
        entry = entries[index++];
        push(result, serialize(entry.key) + "=" + serialize(entry.value));
    }
    return join(result, "&");
}, {
    enumerable: true
});
setToStringTag(URLSearchParamsConstructor, URL_SEARCH_PARAMS);
$({
    global: true,
    forced: !USE_NATIVE_URL
}, {
    URLSearchParams: URLSearchParamsConstructor
});
// Wrap `fetch` and `Request` for correct work with polyfilled `URLSearchParams`
if (!USE_NATIVE_URL && isCallable(Headers)) {
    var headersHas = uncurryThis(HeadersPrototype.has);
    var headersSet = uncurryThis(HeadersPrototype.set);
    var wrapRequestOptions = function(init) {
        if (isObject(init)) {
            var body = init.body;
            var headers;
            if (classof(body) === URL_SEARCH_PARAMS) {
                headers = init.headers ? new Headers(init.headers) : new Headers();
                if (!headersHas(headers, "content-type")) headersSet(headers, "content-type", "application/x-www-form-urlencoded;charset=UTF-8");
                return create(init, {
                    body: createPropertyDescriptor(0, $toString(body)),
                    headers: createPropertyDescriptor(0, headers)
                });
            }
        }
        return init;
    };
    if (isCallable(n$Fetch)) $({
        global: true,
        enumerable: true,
        forced: true
    }, {
        fetch: function fetch(input /* , init */ ) {
            return n$Fetch(input, arguments.length > 1 ? wrapRequestOptions(arguments[1]) : {});
        }
    });
    if (isCallable(N$Request)) {
        var RequestConstructor = function Request(input /* , init */ ) {
            anInstance(this, RequestPrototype);
            return new N$Request(input, arguments.length > 1 ? wrapRequestOptions(arguments[1]) : {});
        };
        RequestPrototype.constructor = RequestConstructor;
        RequestConstructor.prototype = RequestPrototype;
        $({
            global: true,
            forced: true
        }, {
            Request: RequestConstructor
        });
    }
}
module.exports = {
    URLSearchParams: URLSearchParamsConstructor,
    getState: getInternalParamsState
};

},{"49e881ba268140e8":"ieU20","fb5e74806c1e61e9":"1OO62","1c4c3846ccab769d":"1GZc4","70c2bf9441608f0e":"bQFzp","c95496581cbfeba1":"aSvFj","47a9f3e9f470a0c7":"fP9tv","d0a8cac1ad9323ef":"dtEWE","c7d2b99a2daef6de":"3ncOy","47b34c7120e818f1":"b48Cu","3ca80d3b597aa7df":"hVfEJ","6226a115ac6c4a3c":"3eP5G","934c7b6fe6105501":"bRWxa","ba0f0cbef03e2a64":"kZWyK","ff50adf849d8d57":"cVxS9","305c68122e906458":"4SzRl","82e20ace544d4b87":"lgzZz","fe8fd12be41ba3a6":"7lOdl","3534c68d8f8f53cb":"39qAm","6e5bb35eebc4effa":"bprny","893bd67cae0f20f4":"8RVGu","e514925786002059":"dgTGU","4ba3c1b86a524f1e":"81es4","64846cb85f6c5370":"53wfg","2ea422697f285bab":"erPau","eefbd1eeca45190":"kbsMI","45e893154f2fb147":"tC0DW"}],"jwiy1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isJSON", ()=>isJSON);
parcelHelpers.export(exports, "replacer", ()=>replacer);
parcelHelpers.export(exports, "reviver", ()=>reviver);
parcelHelpers.export(exports, "stringify", ()=>stringify);
parcelHelpers.export(exports, "parse", ()=>parse);
var _isRegex = require("is-regex");
var _isRegexDefault = parcelHelpers.interopDefault(_isRegex);
var _isFunction = require("is-function");
var _isFunctionDefault = parcelHelpers.interopDefault(_isFunction);
var _isSymbol = require("is-symbol");
var _isSymbolDefault = parcelHelpers.interopDefault(_isSymbol);
var _isobject = require("isobject");
var _isobjectDefault = parcelHelpers.interopDefault(_isobject);
var _get = require("lodash/get");
var _getDefault = parcelHelpers.interopDefault(_get);
var _memoizerific = require("memoizerific");
var _memoizerificDefault = parcelHelpers.interopDefault(_memoizerific);
var _domEvent = require("./dom-event");
function ownKeys(object1, enumerableOnly1) {
    var keys1 = Object.keys(object1);
    if (Object.getOwnPropertySymbols) {
        var symbols1 = Object.getOwnPropertySymbols(object1);
        if (enumerableOnly1) symbols1 = symbols1.filter(function(sym1) {
            return Object.getOwnPropertyDescriptor(object1, sym1).enumerable;
        });
        keys1.push.apply(keys1, symbols1);
    }
    return keys1;
}
function _objectSpread(target1) {
    for(var i1 = 1; i1 < arguments.length; i1++){
        var source1 = arguments[i1] != null ? arguments[i1] : {};
        if (i1 % 2) ownKeys(Object(source1), true).forEach(function(key1) {
            _defineProperty(target1, key1, source1[key1]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target1, Object.getOwnPropertyDescriptors(source1));
        else ownKeys(Object(source1)).forEach(function(key1) {
            Object.defineProperty(target1, key1, Object.getOwnPropertyDescriptor(source1, key1));
        });
    }
    return target1;
}
function _defineProperty(obj1, key1, value1) {
    if (key1 in obj1) Object.defineProperty(obj1, key1, {
        value: value1,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj1[key1] = value1;
    return obj1;
}
function _slicedToArray(arr1, i1) {
    return _arrayWithHoles(arr1) || _iterableToArrayLimit(arr1, i1) || _unsupportedIterableToArray(arr1, i1) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o1, minLen1) {
    if (!o1) return;
    if (typeof o1 === "string") return _arrayLikeToArray(o1, minLen1);
    var n1 = Object.prototype.toString.call(o1).slice(8, -1);
    if (n1 === "Object" && o1.constructor) n1 = o1.constructor.name;
    if (n1 === "Map" || n1 === "Set") return Array.from(o1);
    if (n1 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n1)) return _arrayLikeToArray(o1, minLen1);
}
function _arrayLikeToArray(arr1, len1) {
    if (len1 == null || len1 > arr1.length) len1 = arr1.length;
    for(var i1 = 0, arr21 = new Array(len1); i1 < len1; i1++)arr21[i1] = arr1[i1];
    return arr21;
}
function _iterableToArrayLimit(arr1, i1) {
    if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr1))) return;
    var _arr1 = [];
    var _n1 = true;
    var _d1 = false;
    var _e1 = undefined;
    try {
        for(var _i1 = arr1[Symbol.iterator](), _s1; !(_n1 = (_s1 = _i1.next()).done); _n1 = true){
            _arr1.push(_s1.value);
            if (i1 && _arr1.length === i1) break;
        }
    } catch (err1) {
        _d1 = true;
        _e1 = err1;
    } finally{
        try {
            if (!_n1 && _i1["return"] != null) _i1["return"]();
        } finally{
            if (_d1) throw _e1;
        }
    }
    return _arr1;
}
function _arrayWithHoles(arr1) {
    if (Array.isArray(arr1)) return arr1;
}
var isRunningInBrowser = typeof window !== "undefined" && typeof window.document !== "undefined"; // eslint-disable-next-line @typescript-eslint/ban-types, no-use-before-define
var isObject = (0, _isobjectDefault.default);
var removeCodeComments = function removeCodeComments1(code1) {
    var inQuoteChar1 = null;
    var inBlockComment1 = false;
    var inLineComment1 = false;
    var inRegexLiteral1 = false;
    var newCode1 = "";
    if (code1.indexOf("//") >= 0 || code1.indexOf("/*") >= 0) for(var i1 = 0; i1 < code1.length; i1 += 1){
        if (!inQuoteChar1 && !inBlockComment1 && !inLineComment1 && !inRegexLiteral1) {
            if (code1[i1] === '"' || code1[i1] === "'" || code1[i1] === "`") inQuoteChar1 = code1[i1];
            else if (code1[i1] === "/" && code1[i1 + 1] === "*") inBlockComment1 = true;
            else if (code1[i1] === "/" && code1[i1 + 1] === "/") inLineComment1 = true;
            else if (code1[i1] === "/" && code1[i1 + 1] !== "/") inRegexLiteral1 = true;
        } else {
            if (inQuoteChar1 && (code1[i1] === inQuoteChar1 && code1[i1 - 1] !== "\\" || code1[i1] === "\n" && inQuoteChar1 !== "`")) inQuoteChar1 = null;
            if (inRegexLiteral1 && (code1[i1] === "/" && code1[i1 - 1] !== "\\" || code1[i1] === "\n")) inRegexLiteral1 = false;
            if (inBlockComment1 && code1[i1 - 1] === "/" && code1[i1 - 2] === "*") inBlockComment1 = false;
            if (inLineComment1 && code1[i1] === "\n") inLineComment1 = false;
        }
        if (!inBlockComment1 && !inLineComment1) newCode1 += code1[i1];
    }
    else newCode1 = code1;
    return newCode1;
};
var cleanCode = (0, _memoizerificDefault.default)(10000)(function(code1) {
    return removeCodeComments(code1).replace(/\n\s*/g, "") // remove indents & newlines
    .trim();
});
var convertShorthandMethods = function convertShorthandMethods1(key1, stringified1) {
    var fnHead1 = stringified1.slice(0, stringified1.indexOf("{"));
    var fnBody1 = stringified1.slice(stringified1.indexOf("{"));
    if (fnHead1.includes("=>")) // This is an arrow function
    return stringified1;
    if (fnHead1.includes("function")) // This is an anonymous function
    return stringified1;
    var modifiedHead1 = fnHead1;
    modifiedHead1 = modifiedHead1.replace(key1, "function");
    return modifiedHead1 + fnBody1;
};
var dateFormat = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d{3})?Z$/;
var isJSON = function isJSON1(input1) {
    return input1.match(/^[\[\{\"\}].*[\]\}\"]$/);
};
function convertUnconventionalData(data1) {
    if (!isObject(data1)) return data1;
    var result1 = data1;
    var wasMutated1 = false; // `Event` has a weird structure, for details see `extractEventHiddenProperties` doc
    // Plus we need to check if running in a browser to ensure `Event` exist and
    // is really the dom Event class.
    if (isRunningInBrowser && data1 instanceof Event) {
        result1 = (0, _domEvent.extractEventHiddenProperties)(result1);
        wasMutated1 = true;
    }
    result1 = Object.keys(result1).reduce(function(acc1, key1) {
        try {
            var _result$key1;
            // Try accessing a property to test if we are allowed to do so
            // eslint-disable-next-line no-unused-expressions
            (_result$key1 = result1[key1]) === null || _result$key1 === void 0 || _result$key1.toJSON;
            acc1[key1] = result1[key1];
        } catch (err1) {
            wasMutated1 = true;
        }
        return acc1;
    }, {});
    return wasMutated1 ? result1 : data1;
}
var replacer = function replacer1(options1) {
    var objects1;
    var map1;
    var stack1;
    var keys1;
    return function replace1(key1, value1) {
        try {
            //  very first iteration
            if (key1 === "") {
                keys1 = [];
                objects1 = new Map([
                    [
                        value1,
                        "[]"
                    ]
                ]);
                map1 = new Map();
                stack1 = [];
                return value1;
            } // From the JSON.stringify's doc:
            // "The object in which the key was found is provided as the replacer's this parameter." thus one can control the depth
            var origin1 = map1.get(this) || this;
            while(stack1.length && origin1 !== stack1[0]){
                stack1.shift();
                keys1.pop();
            }
            if (typeof value1 === "boolean") return value1;
            if (value1 === undefined) {
                if (!options1.allowUndefined) return undefined;
                return "_undefined_";
            }
            if (value1 === null) return null;
            if (typeof value1 === "number") {
                if (value1 === -Infinity) return "_-Infinity_";
                if (value1 === Infinity) return "_Infinity_";
                if (Number.isNaN(value1)) return "_NaN_";
                return value1;
            }
            if (typeof value1 === "bigint") return "_bigint_".concat(value1.toString());
            if (typeof value1 === "string") {
                if (dateFormat.test(value1)) {
                    if (!options1.allowDate) return undefined;
                    return "_date_".concat(value1);
                }
                return value1;
            }
            if ((0, _isRegexDefault.default)(value1)) {
                if (!options1.allowRegExp) return undefined;
                return "_regexp_".concat(value1.flags, "|").concat(value1.source);
            }
            if ((0, _isFunctionDefault.default)(value1)) {
                if (!options1.allowFunction) return undefined;
                var name1 = value1.name;
                var stringified1 = value1.toString();
                if (!stringified1.match(/(\[native code\]|WEBPACK_IMPORTED_MODULE|__webpack_exports__|__webpack_require__)/)) return "_function_".concat(name1, "|").concat(cleanCode(convertShorthandMethods(key1, stringified1)));
                return "_function_".concat(name1, "|").concat((function() {}).toString());
            }
            if ((0, _isSymbolDefault.default)(value1)) {
                if (!options1.allowSymbol) return undefined;
                var globalRegistryKey1 = Symbol.keyFor(value1);
                if (globalRegistryKey1 !== undefined) return "_gsymbol_".concat(globalRegistryKey1);
                return "_symbol_".concat(value1.toString().slice(7, -1));
            }
            if (stack1.length >= options1.maxDepth) {
                if (Array.isArray(value1)) return "[Array(".concat(value1.length, ")]");
                return "[Object]";
            }
            if (value1 === this) return "_duplicate_".concat(JSON.stringify(keys1));
             // when it's a class and we don't want to support classes, skip
            if (value1.constructor && value1.constructor.name && value1.constructor.name !== "Object" && !Array.isArray(value1) && !options1.allowClass) return undefined;
            var found1 = objects1.get(value1);
            if (!found1) {
                var converted1 = Array.isArray(value1) ? value1 : convertUnconventionalData(value1);
                if (value1.constructor && value1.constructor.name && value1.constructor.name !== "Object" && !Array.isArray(value1) && options1.allowClass) try {
                    Object.assign(converted1, {
                        "_constructor-name_": value1.constructor.name
                    });
                } catch (e1) {
                // we could make a deep copy but if the user values the correct instance name,
                // the user should make the deep copy themselves.
                }
                keys1.push(key1);
                stack1.unshift(converted1);
                objects1.set(value1, JSON.stringify(keys1));
                if (value1 !== converted1) map1.set(value1, converted1);
                return converted1;
            } //  actually, here's the only place where the keys keeping is useful
            return "_duplicate_".concat(found1);
        } catch (e1) {
            return undefined;
        }
    };
};
var reviver = function reviver(options) {
    var refs = [];
    var root;
    return function revive(key, value) {
        // last iteration = root
        if (key === "") {
            root = value; // restore cyclic refs
            refs.forEach(function(_ref1) {
                var target1 = _ref1.target, container1 = _ref1.container, replacement1 = _ref1.replacement;
                var replacementArr1 = isJSON(replacement1) ? JSON.parse(replacement1) : replacement1.split(".");
                if (replacementArr1.length === 0) // eslint-disable-next-line no-param-reassign
                container1[target1] = root;
                else // eslint-disable-next-line no-param-reassign
                container1[target1] = (0, _getDefault.default)(root, replacementArr1);
            });
        }
        if (key === "_constructor-name_") return value;
         // deal with instance names
        if (isObject(value) && value["_constructor-name_"] && options.allowFunction) {
            var name = value["_constructor-name_"];
            if (name !== "Object") {
                // eslint-disable-next-line no-new-func
                var Fn = new Function("return function ".concat(name.replace(/[\W_]+/g, ""), "(){}"))();
                Object.setPrototypeOf(value, new Fn());
            } // eslint-disable-next-line no-param-reassign
            delete value["_constructor-name_"];
            return value;
        }
        if (typeof value === "string" && value.startsWith("_function_") && options.allowFunction) {
            var _ref2 = value.match(/_function_([^|]*)\|(.*)/) || [], _ref3 = _slicedToArray(_ref2, 3), _name = _ref3[1], source = _ref3[2]; // eslint-disable-next-line no-useless-escape
            var sourceSanitized = source.replace(/[(\(\))|\\| |\]|`]*$/, "");
            if (!options.lazyEval) // eslint-disable-next-line no-eval
            return eval("(".concat(sourceSanitized, ")"));
             // lazy eval of the function
            var result = function result() {
                // eslint-disable-next-line no-eval
                var f = eval("(".concat(sourceSanitized, ")"));
                return f.apply(void 0, arguments);
            };
            Object.defineProperty(result, "toString", {
                value: function value1() {
                    return sourceSanitized;
                }
            });
            Object.defineProperty(result, "name", {
                value: _name
            });
            return result;
        }
        if (typeof value === "string" && value.startsWith("_regexp_") && options.allowRegExp) {
            // this split isn't working correctly
            var _ref4 = value.match(/_regexp_([^|]*)\|(.*)/) || [], _ref5 = _slicedToArray(_ref4, 3), flags = _ref5[1], _source = _ref5[2];
            return new RegExp(_source, flags);
        }
        if (typeof value === "string" && value.startsWith("_date_") && options.allowDate) return new Date(value.replace("_date_", ""));
        if (typeof value === "string" && value.startsWith("_duplicate_")) {
            refs.push({
                target: key,
                container: this,
                replacement: value.replace(/^_duplicate_/, "")
            });
            return null;
        }
        if (typeof value === "string" && value.startsWith("_symbol_") && options.allowSymbol) return Symbol(value.replace("_symbol_", ""));
        if (typeof value === "string" && value.startsWith("_gsymbol_") && options.allowSymbol) return Symbol["for"](value.replace("_gsymbol_", ""));
        if (typeof value === "string" && value === "_-Infinity_") return -Infinity;
        if (typeof value === "string" && value === "_Infinity_") return Infinity;
        if (typeof value === "string" && value === "_NaN_") return NaN;
        if (typeof value === "string" && value.startsWith("_bigint_") && typeof BigInt === "function") return BigInt(value.replace("_bigint_", ""));
        return value;
    };
};
var defaultOptions = {
    maxDepth: 10,
    space: undefined,
    allowFunction: true,
    allowRegExp: true,
    allowDate: true,
    allowClass: true,
    allowUndefined: true,
    allowSymbol: true,
    lazyEval: true
};
var stringify = function stringify1(data1) {
    var options1 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var mergedOptions1 = _objectSpread(_objectSpread({}, defaultOptions), options1);
    return JSON.stringify(convertUnconventionalData(data1), replacer(mergedOptions1), options1.space);
};
var mutator = function mutator1() {
    var mutated1 = new Map();
    return function mutateUndefined1(value1) {
        // JSON.parse will not output keys with value of undefined
        // we map over a deeply nester object, if we find any value with `_undefined_`, we mutate it to be undefined
        if (isObject(value1)) Object.entries(value1).forEach(function(_ref61) {
            var _ref71 = _slicedToArray(_ref61, 2), k1 = _ref71[0], v1 = _ref71[1];
            if (v1 === "_undefined_") // eslint-disable-next-line no-param-reassign
            value1[k1] = undefined;
            else if (!mutated1.get(v1)) {
                mutated1.set(v1, true);
                mutateUndefined1(v1);
            }
        });
        if (Array.isArray(value1)) value1.forEach(function(v1, index1) {
            if (v1 === "_undefined_") {
                mutated1.set(v1, true); // eslint-disable-next-line no-param-reassign
                value1[index1] = undefined;
            } else if (!mutated1.get(v1)) {
                mutated1.set(v1, true);
                mutateUndefined1(v1);
            }
        });
    };
};
var parse = function parse1(data1) {
    var options1 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var mergedOptions1 = _objectSpread(_objectSpread({}, defaultOptions), options1);
    var result1 = JSON.parse(data1, reviver(mergedOptions1));
    mutator()(result1);
    return result1;
};

},{"is-regex":"34grm","is-function":"gSKCW","is-symbol":"lWRY6","isobject":"hCKDQ","lodash/get":"hbEsl","memoizerific":"a8Efd","./dom-event":"bgPpJ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"34grm":[function(require,module,exports) {
"use strict";
var callBound = require("5d96af94ba428cfc");
var hasToStringTag = require("a5e890a505b039e5")();
var has;
var $exec;
var isRegexMarker;
var badStringifier;
if (hasToStringTag) {
    has = callBound("Object.prototype.hasOwnProperty");
    $exec = callBound("RegExp.prototype.exec");
    isRegexMarker = {};
    var throwRegexMarker = function() {
        throw isRegexMarker;
    };
    badStringifier = {
        toString: throwRegexMarker,
        valueOf: throwRegexMarker
    };
    if (typeof Symbol.toPrimitive === "symbol") badStringifier[Symbol.toPrimitive] = throwRegexMarker;
}
var $toString = callBound("Object.prototype.toString");
var gOPD = Object.getOwnPropertyDescriptor;
var regexClass = "[object RegExp]";
module.exports = hasToStringTag ? function isRegex(value) {
    if (!value || typeof value !== "object") return false;
    var descriptor = gOPD(value, "lastIndex");
    var hasLastIndexDataProperty = descriptor && has(descriptor, "value");
    if (!hasLastIndexDataProperty) return false;
    try {
        $exec(value, badStringifier);
    } catch (e) {
        return e === isRegexMarker;
    }
} : function isRegex(value) {
    // In older browsers, typeof regex incorrectly returns 'function'
    if (!value || typeof value !== "object" && typeof value !== "function") return false;
    return $toString(value) === regexClass;
};

},{"5d96af94ba428cfc":"kSjLP","a5e890a505b039e5":"3BxV8"}],"3BxV8":[function(require,module,exports) {
"use strict";
var hasSymbols = require("2ef89576d4959bff");
module.exports = function hasToStringTagShams() {
    return hasSymbols() && !!Symbol.toStringTag;
};

},{"2ef89576d4959bff":"ldFxD"}],"gSKCW":[function(require,module,exports) {
module.exports = isFunction;
var toString = Object.prototype.toString;
function isFunction(fn) {
    if (!fn) return false;
    var string = toString.call(fn);
    return string === "[object Function]" || typeof fn === "function" && string !== "[object RegExp]" || typeof window !== "undefined" && // IE8 and below
    (fn === window.setTimeout || fn === window.alert || fn === window.confirm || fn === window.prompt);
}

},{}],"lWRY6":[function(require,module,exports) {
"use strict";
var toStr = Object.prototype.toString;
var hasSymbols = require("19da2b43c74a37a0")();
if (hasSymbols) {
    var symToStr = Symbol.prototype.toString;
    var symStringRegex = /^Symbol\(.*\)$/;
    var isSymbolObject = function isRealSymbolObject(value) {
        if (typeof value.valueOf() !== "symbol") return false;
        return symStringRegex.test(symToStr.call(value));
    };
    module.exports = function isSymbol(value) {
        if (typeof value === "symbol") return true;
        if (toStr.call(value) !== "[object Symbol]") return false;
        try {
            return isSymbolObject(value);
        } catch (e) {
            return false;
        }
    };
} else module.exports = function isSymbol(value) {
    // this environment does not support Symbols.
    return false;
};

},{"19da2b43c74a37a0":"Hzs91"}],"hCKDQ":[function(require,module,exports) {
/*!
 * isobject <https://github.com/jonschlinkert/isobject>
 *
 * Copyright (c) 2014-2017, Jon Schlinkert.
 * Released under the MIT License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isObject);
function isObject(val) {
    return val != null && typeof val === "object" && Array.isArray(val) === false;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"bgPpJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Dom Event (and all its subclasses) is built in a way its internal properties
 * are accessible when querying them directly but "hidden" when iterating its
 * keys.
 *
 * With a code example it means: `Object.keys(new Event('click')) = ["isTrusted"]`
 *
 * So to be able to stringify/parse more than just `isTrusted` info we need to
 * create a new object and set the properties by hand. As there is no way to
 * iterate the properties we rely on a list of hardcoded properties.
 *
 * @param event The event we want to extract properties
 */ parcelHelpers.export(exports, "extractEventHiddenProperties", ()=>extractEventHiddenProperties);
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var eventProperties = [
    "bubbles",
    "cancelBubble",
    "cancelable",
    "composed",
    "currentTarget",
    "defaultPrevented",
    "eventPhase",
    "isTrusted",
    "returnValue",
    "srcElement",
    "target",
    "timeStamp",
    "type"
];
var customEventSpecificProperties = [
    "detail"
];
function extractEventHiddenProperties(event) {
    var rebuildEvent = eventProperties.filter(function(value) {
        return event[value] !== undefined;
    }).reduce(function(acc, value) {
        return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, value, event[value]));
    }, {});
    if (event instanceof CustomEvent) customEventSpecificProperties.filter(function(value) {
        return event[value] !== undefined;
    }).forEach(function(value) {
        rebuildEvent[value] = event[value];
    });
    return rebuildEvent;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"7YrNK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Executes a Loadable (function that returns exports or require context(s))
 * and returns a map of filename => module exports
 *
 * @param loadable Loadable
 * @returns Map<Path, ModuleExports>
 */ parcelHelpers.export(exports, "executeLoadable", ()=>executeLoadable);
/**
 * Executes a Loadable (function that returns exports or require context(s))
 * and compares it's output to the last time it was run (as stored on a node module)
 *
 * @param loadable Loadable
 * @param m NodeModule
 * @returns { added: Map<Path, ModuleExports>, removed: Map<Path, ModuleExports> }
 */ parcelHelpers.export(exports, "executeLoadableForChanges", ()=>executeLoadableForChanges);
var _esArrayIteratorJs = require("core-js/modules/es.array.iterator.js");
var _esObjectToStringJs = require("core-js/modules/es.object.to-string.js");
var _webDomCollectionsIteratorJs = require("core-js/modules/web.dom-collections.iterator.js");
var _esMapJs = require("core-js/modules/es.map.js");
var _esStringIteratorJs = require("core-js/modules/es.string.iterator.js");
var _webDomCollectionsForEachJs = require("core-js/modules/web.dom-collections.for-each.js");
var _esArrayConcatJs = require("core-js/modules/es.array.concat.js");
var _esRegexpToStringJs = require("core-js/modules/es.regexp.to-string.js");
var _esArrayMapJs = require("core-js/modules/es.array.map.js");
var _esArrayFilterJs = require("core-js/modules/es.array.filter.js");
var _esArrayFromJs = require("core-js/modules/es.array.from.js");
var _esSymbolJs = require("core-js/modules/es.symbol.js");
var _esSymbolDescriptionJs = require("core-js/modules/es.symbol.description.js");
var _esSymbolIteratorJs = require("core-js/modules/es.symbol.iterator.js");
var _esArraySliceJs = require("core-js/modules/es.array.slice.js");
var _esFunctionNameJs = require("core-js/modules/es.function.name.js");
var _esRegexpExecJs = require("core-js/modules/es.regexp.exec.js");
var _clientLogger = require("@storybook/client-logger");
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function executeLoadable(loadable) {
    var reqs = null; // todo discuss / improve type check
    if (Array.isArray(loadable)) reqs = loadable;
    else if (loadable.keys) reqs = [
        loadable
    ];
    var exportsMap = new Map();
    if (reqs) reqs.forEach(function(req) {
        req.keys().forEach(function(filename) {
            try {
                var fileExports = req(filename);
                exportsMap.set(typeof req.resolve === "function" ? req.resolve(filename) : filename, fileExports);
            } catch (error) {
                var errorString = error.message && error.stack ? "".concat(error.message, "\n ").concat(error.stack) : error.toString();
                (0, _clientLogger.logger).error("Unexpected error while loading ".concat(filename, ": ").concat(errorString));
            }
        });
    });
    else {
        var exported = loadable();
        if (Array.isArray(exported) && exported.every(function(obj) {
            return obj.default != null;
        })) exportsMap = new Map(exported.map(function(fileExports, index) {
            return [
                "exports-map-".concat(index),
                fileExports
            ];
        }));
        else if (exported) (0, _clientLogger.logger).warn("Loader function passed to 'configure' should return void or an array of module exports that all contain a 'default' export. Received: ".concat(JSON.stringify(exported)));
    }
    return exportsMap;
}
function executeLoadableForChanges(loadable, m) {
    var _m$hot, _m$hot$data, _m$hot2;
    var lastExportsMap = (m === null || m === void 0 ? void 0 : (_m$hot = m.hot) === null || _m$hot === void 0 ? void 0 : (_m$hot$data = _m$hot.data) === null || _m$hot$data === void 0 ? void 0 : _m$hot$data.lastExportsMap) || new Map();
    if (m !== null && m !== void 0 && (_m$hot2 = m.hot) !== null && _m$hot2 !== void 0 && _m$hot2.dispose) {
        m.hot.accept();
        m.hot.dispose(function(data) {
            // eslint-disable-next-line no-param-reassign
            data.lastExportsMap = lastExportsMap;
        });
    }
    var exportsMap = executeLoadable(loadable);
    var added = new Map();
    Array.from(exportsMap.entries()) // Ignore files that do not have a default export
    .filter(function(_ref) {
        var _ref2 = _slicedToArray(_ref, 2), fileExports = _ref2[1];
        return !!fileExports.default;
    }) // Ignore exports that are equal (by reference) to last time, this means the file hasn't changed
    .filter(function(_ref3) {
        var _ref4 = _slicedToArray(_ref3, 2), fileName = _ref4[0], fileExports = _ref4[1];
        return lastExportsMap.get(fileName) !== fileExports;
    }).forEach(function(_ref5) {
        var _ref6 = _slicedToArray(_ref5, 2), fileName = _ref6[0], fileExports = _ref6[1];
        return added.set(fileName, fileExports);
    });
    var removed = new Map();
    Array.from(lastExportsMap.keys()).filter(function(fileName) {
        return !exportsMap.has(fileName);
    }).forEach(function(fileName) {
        return removed.set(fileName, lastExportsMap.get(fileName));
    }); // Save the value for the dispose() call above
    lastExportsMap = exportsMap;
    return {
        added: added,
        removed: removed
    };
}

},{"core-js/modules/es.array.iterator.js":"ieU20","core-js/modules/es.object.to-string.js":"lsA9p","core-js/modules/web.dom-collections.iterator.js":"aXR96","core-js/modules/es.map.js":"bbbTA","core-js/modules/es.string.iterator.js":"74a8v","core-js/modules/web.dom-collections.for-each.js":"iYT1M","core-js/modules/es.array.concat.js":"g1t7q","core-js/modules/es.regexp.to-string.js":"bGzly","core-js/modules/es.array.map.js":"jTP7e","core-js/modules/es.array.filter.js":"fD2da","core-js/modules/es.array.from.js":"9UCQw","core-js/modules/es.symbol.js":"ajw2f","core-js/modules/es.symbol.description.js":"wrlLc","core-js/modules/es.symbol.iterator.js":"fhNIb","core-js/modules/es.array.slice.js":"8RRh9","core-js/modules/es.function.name.js":"4LiLL","core-js/modules/es.regexp.exec.js":"5q56v","@storybook/client-logger":"iGRus","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"bbbTA":[function(require,module,exports) {
"use strict";
var collection = require("22565756c24886ca");
var collectionStrong = require("750758c35c727c0d");
// `Map` constructor
// https://tc39.es/ecma262/#sec-map-objects
collection("Map", function(init) {
    return function Map() {
        return init(this, arguments.length ? arguments[0] : undefined);
    };
}, collectionStrong);

},{"22565756c24886ca":"755XO","750758c35c727c0d":"3WOKt"}],"h6fi9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"8NjRE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
var _global = require("global");
var _globalDefault = parcelHelpers.interopDefault(_global);
var globalWindow = (0, _globalDefault.default).window;
if (globalWindow) globalWindow.STORYBOOK_ENV = "react";

},{"global":"5PzlO","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"bkYMe":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "render", ()=>render);
parcelHelpers.export(exports, "renderToDOM", ()=>renderToDOM);
var _esArrayIteratorJs = require("core-js/modules/es.array.iterator.js");
var _esMapJs = require("core-js/modules/es.map.js");
var _esObjectToStringJs = require("core-js/modules/es.object.to-string.js");
var _esStringIteratorJs = require("core-js/modules/es.string.iterator.js");
var _webDomCollectionsIteratorJs = require("core-js/modules/web.dom-collections.iterator.js");
var _esPromiseJs = require("core-js/modules/es.promise.js");
var _esStringStartsWithJs = require("core-js/modules/es.string.starts-with.js");
var _esArrayConcatJs = require("core-js/modules/es.array.concat.js");
var _esObjectGetPrototypeOfJs = require("core-js/modules/es.object.get-prototype-of.js");
var _esReflectConstructJs = require("core-js/modules/es.reflect.construct.js");
var _esSymbolJs = require("core-js/modules/es.symbol.js");
var _esSymbolDescriptionJs = require("core-js/modules/es.symbol.description.js");
var _esSymbolIteratorJs = require("core-js/modules/es.symbol.iterator.js");
var _global = require("global");
var _globalDefault = parcelHelpers.interopDefault(_global);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactDom = require("react-dom");
var _reactDomDefault = parcelHelpers.interopDefault(_reactDom);
function _typeof(obj) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return _possibleConstructorReturn(this, result);
    };
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
var FRAMEWORK_OPTIONS = (0, _globalDefault.default).FRAMEWORK_OPTIONS; // A map of all rendered React 18 nodes
var nodes = new Map();
var render = function render(args, context) {
    var id = context.id, Component = context.component;
    if (!Component) throw new Error("Unable to render story ".concat(id, " as the component annotation is missing from the default export"));
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Component, args);
};
var WithCallback = function WithCallback(_ref) {
    var callback = _ref.callback, children = _ref.children;
    // See https://github.com/reactwg/react-18/discussions/5#discussioncomment-2276079
    var once = (0, _react.useRef)();
    (0, _react.useLayoutEffect)(function() {
        if (once.current === callback) return;
        once.current = callback;
        callback();
    }, [
        callback
    ]);
    return children;
};
var renderElement = /*#__PURE__*/ function() {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/ regeneratorRuntime.mark(function _callee(node, el) {
        var root;
        return regeneratorRuntime.wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    _context.next = 2;
                    return getReactRoot(el);
                case 2:
                    root = _context.sent;
                    return _context.abrupt("return", new Promise(function(resolve) {
                        if (root) root.render(/*#__PURE__*/ (0, _reactDefault.default).createElement(WithCallback, {
                            callback: function callback() {
                                return resolve(null);
                            }
                        }, node));
                        else (0, _reactDomDefault.default).render(node, el, function() {
                            return resolve(null);
                        });
                    }));
                case 4:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return function renderElement(_x, _x2) {
        return _ref2.apply(this, arguments);
    };
}();
var canUseNewReactRootApi = (0, _reactDom.version) && ((0, _reactDom.version).startsWith("18") || (0, _reactDom.version).startsWith("0.0.0"));
var shouldUseNewRootApi = (FRAMEWORK_OPTIONS === null || FRAMEWORK_OPTIONS === void 0 ? void 0 : FRAMEWORK_OPTIONS.legacyRootApi) !== true;
var isUsingNewReactRootApi = shouldUseNewRootApi && canUseNewReactRootApi;
var unmountElement = function unmountElement(el) {
    var root = nodes.get(el);
    if (root && isUsingNewReactRootApi) {
        root.unmount();
        nodes.delete(el);
    } else (0, _reactDomDefault.default).unmountComponentAtNode(el);
};
var getReactRoot = /*#__PURE__*/ function() {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/ regeneratorRuntime.mark(function _callee2(el) {
        var root, reactDomClient;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while(true)switch(_context2.prev = _context2.next){
                case 0:
                    if (isUsingNewReactRootApi) {
                        _context2.next = 2;
                        break;
                    }
                    return _context2.abrupt("return", null);
                case 2:
                    root = nodes.get(el);
                    if (root) {
                        _context2.next = 9;
                        break;
                    }
                    _context2.next = 6;
                    return require("1184fc762e160b9b");
                case 6:
                    reactDomClient = _context2.sent.default;
                    root = reactDomClient.createRoot(el);
                    nodes.set(el, root);
                case 9:
                    return _context2.abrupt("return", root);
                case 10:
                case "end":
                    return _context2.stop();
            }
        }, _callee2);
    }));
    return function getReactRoot(_x3) {
        return _ref3.apply(this, arguments);
    };
}();
var ErrorBoundary = /*#__PURE__*/ function(_ReactComponent) {
    _inherits(ErrorBoundary, _ReactComponent);
    var _super = _createSuper(ErrorBoundary);
    function ErrorBoundary() {
        var _this;
        _classCallCheck(this, ErrorBoundary);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        _this.state = {
            hasError: false
        };
        return _this;
    }
    _createClass(ErrorBoundary, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var hasError = this.state.hasError;
                var showMain = this.props.showMain;
                if (!hasError) showMain();
            }
        },
        {
            key: "componentDidCatch",
            value: function componentDidCatch(err) {
                var showException = this.props.showException; // message partially duplicates stack, strip it
                showException(err);
            }
        },
        {
            key: "render",
            value: function render() {
                var hasError = this.state.hasError;
                var children = this.props.children;
                return hasError ? null : children;
            }
        }
    ], [
        {
            key: "getDerivedStateFromError",
            value: function getDerivedStateFromError() {
                return {
                    hasError: true
                };
            }
        }
    ]);
    return ErrorBoundary;
}((0, _react.Component));
var Wrapper = FRAMEWORK_OPTIONS !== null && FRAMEWORK_OPTIONS !== void 0 && FRAMEWORK_OPTIONS.strictMode ? (0, _react.StrictMode) : (0, _react.Fragment);
function renderToDOM(_x4, _x5) {
    return _renderToDOM.apply(this, arguments);
}
function _renderToDOM() {
    _renderToDOM = _asyncToGenerator(/*#__PURE__*/ regeneratorRuntime.mark(function _callee3(_ref4, domElement) {
        var storyContext, unboundStoryFn, showMain, showException, forceRemount, Story, content, element;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
            while(true)switch(_context3.prev = _context3.next){
                case 0:
                    storyContext = _ref4.storyContext, unboundStoryFn = _ref4.unboundStoryFn, showMain = _ref4.showMain, showException = _ref4.showException, forceRemount = _ref4.forceRemount;
                    Story = unboundStoryFn;
                    content = /*#__PURE__*/ (0, _reactDefault.default).createElement(ErrorBoundary, {
                        showMain: showMain,
                        showException: showException
                    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Story, storyContext)); // For React 15, StrictMode & Fragment doesn't exists.
                    element = Wrapper ? /*#__PURE__*/ (0, _reactDefault.default).createElement(Wrapper, null, content) : content; // In most cases, we need to unmount the existing set of components in the DOM node.
                    // Otherwise, React may not recreate instances for every story run.
                    // This could leads to issues like below:
                    // https://github.com/storybookjs/react-storybook/issues/81
                    // (This is not the case when we change args or globals to the story however)
                    if (forceRemount) unmountElement(domElement);
                    _context3.next = 7;
                    return renderElement(element, domElement);
                case 7:
                case "end":
                    return _context3.stop();
            }
        }, _callee3);
    }));
    return _renderToDOM.apply(this, arguments);
}

},{"core-js/modules/es.array.iterator.js":"ieU20","core-js/modules/es.map.js":"bbbTA","core-js/modules/es.object.to-string.js":"lsA9p","core-js/modules/es.string.iterator.js":"74a8v","core-js/modules/web.dom-collections.iterator.js":"aXR96","core-js/modules/es.promise.js":"2jax7","core-js/modules/es.string.starts-with.js":"90lFR","core-js/modules/es.array.concat.js":"g1t7q","core-js/modules/es.object.get-prototype-of.js":"kLLpv","core-js/modules/es.reflect.construct.js":"7ZxAL","core-js/modules/es.symbol.js":"ajw2f","core-js/modules/es.symbol.description.js":"wrlLc","core-js/modules/es.symbol.iterator.js":"fhNIb","global":"5PzlO","react":"9yzVZ","react-dom":"cEvV3","1184fc762e160b9b":"iKqHu","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"9yzVZ":[function(require,module,exports) {
"use strict";
module.exports = require("956f36295e4e0134");

},{"956f36295e4e0134":"7pyKl"}],"7pyKl":[function(require,module,exports) {
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var l = Symbol.for("react.element"), n = Symbol.for("react.portal"), p = Symbol.for("react.fragment"), q = Symbol.for("react.strict_mode"), r = Symbol.for("react.profiler"), t = Symbol.for("react.provider"), u = Symbol.for("react.context"), v = Symbol.for("react.forward_ref"), w = Symbol.for("react.suspense"), x = Symbol.for("react.memo"), y = Symbol.for("react.lazy"), z = Symbol.iterator;
function A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = z && a[z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, C = Object.assign, D = {};
function E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = D;
    this.updater = e || B;
}
E.prototype.isReactComponent = {};
E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function F() {}
F.prototype = E.prototype;
function G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = D;
    this.updater = e || B;
}
var H = G.prototype = new F;
H.constructor = G;
C(H, E.prototype);
H.isPureReactComponent = !0;
var I = Array.isArray, J = Object.prototype.hasOwnProperty, K = {
    current: null
}, L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)J.call(b, d) && !L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: K.current
    };
}
function N(a, b) {
    return {
        $$typeof: l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === l;
}
function escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var P = /\/+/g;
function Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? escape("" + a.key) : b.toString(36);
}
function R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case l:
                case n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + Q(h, 0) : d, I(c) ? (e = "", null != a && (e = a.replace(P, "$&/") + "/"), R(c, b, e, "", function(a) {
        return a;
    })) : null != c && (O(c) && (c = N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace(P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if (I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + Q(k, g);
        h += R(k, b, e, f, c);
    }
    else if (f = A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + Q(k, g++), h += R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var U = {
    current: null
}, V = {
    transition: null
}, W = {
    ReactCurrentDispatcher: U,
    ReactCurrentBatchConfig: V,
    ReactCurrentOwner: K
};
exports.Children = {
    map: S,
    forEach: function(a, b, e) {
        S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
exports.Component = E;
exports.Fragment = p;
exports.Profiler = r;
exports.PureComponent = G;
exports.StrictMode = q;
exports.Suspense = w;
exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = W;
exports.cloneElement = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)J.call(b, f) && !L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
exports.createContext = function(a) {
    a = {
        $$typeof: u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: t,
        _context: a
    };
    return a.Consumer = a;
};
exports.createElement = M;
exports.createFactory = function(a) {
    var b = M.bind(null, a);
    b.type = a;
    return b;
};
exports.createRef = function() {
    return {
        current: null
    };
};
exports.forwardRef = function(a) {
    return {
        $$typeof: v,
        render: a
    };
};
exports.isValidElement = O;
exports.lazy = function(a) {
    return {
        $$typeof: y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: T
    };
};
exports.memo = function(a, b) {
    return {
        $$typeof: x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
exports.startTransition = function(a) {
    var b = V.transition;
    V.transition = {};
    try {
        a();
    } finally{
        V.transition = b;
    }
};
exports.unstable_act = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
exports.useCallback = function(a, b) {
    return U.current.useCallback(a, b);
};
exports.useContext = function(a) {
    return U.current.useContext(a);
};
exports.useDebugValue = function() {};
exports.useDeferredValue = function(a) {
    return U.current.useDeferredValue(a);
};
exports.useEffect = function(a, b) {
    return U.current.useEffect(a, b);
};
exports.useId = function() {
    return U.current.useId();
};
exports.useImperativeHandle = function(a, b, e) {
    return U.current.useImperativeHandle(a, b, e);
};
exports.useInsertionEffect = function(a, b) {
    return U.current.useInsertionEffect(a, b);
};
exports.useLayoutEffect = function(a, b) {
    return U.current.useLayoutEffect(a, b);
};
exports.useMemo = function(a, b) {
    return U.current.useMemo(a, b);
};
exports.useReducer = function(a, b, e) {
    return U.current.useReducer(a, b, e);
};
exports.useRef = function(a) {
    return U.current.useRef(a);
};
exports.useState = function(a) {
    return U.current.useState(a);
};
exports.useSyncExternalStore = function(a, b, e) {
    return U.current.useSyncExternalStore(a, b, e);
};
exports.useTransition = function() {
    return U.current.useTransition();
};
exports.version = "18.1.0";

},{}],"cEvV3":[function(require,module,exports) {
"use strict";
function checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
checkDCE();
module.exports = require("9223fb8c5161e54b");

},{"9223fb8c5161e54b":"e5S9x"}],"e5S9x":[function(require,module,exports) {
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ "use strict";
var aa = require("5393afc8c463ef07"), ba = require("ece50e903283a22f");
function p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var da = new Set, ea = {};
function fa(a, b) {
    ha(a, b);
    ha(a + "Capture", b);
}
function ha(a, b) {
    ea[a] = b;
    for(a = 0; a < b.length; a++)da.add(b[a]);
}
var ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), ja = Object.prototype.hasOwnProperty, ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, la = {}, ma = {};
function na(a) {
    if (ja.call(ma, a)) return !0;
    if (ja.call(la, a)) return !1;
    if (ka.test(a)) return ma[a] = !0;
    la[a] = !0;
    return !1;
}
function oa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function pa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || oa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function t(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    z[a] = new t(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    z[b] = new t(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    z[a] = new t(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    z[a] = new t(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    z[a] = new t(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    z[a] = new t(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    z[a] = new t(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    z[a] = new t(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    z[a] = new t(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var qa = /[\-:]([a-z])/g;
function ra(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace(qa, ra);
    z[b] = new t(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace(qa, ra);
    z[b] = new t(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace(qa, ra);
    z[b] = new t(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    z[a] = new t(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
z.xlinkHref = new t("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    z[a] = new t(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function sa(a, b, c, d) {
    var e = z.hasOwnProperty(b) ? z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) pa(b, c, e, d) && (c = null), d || null === e ? na(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var ta = aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, ua = Symbol.for("react.element"), va = Symbol.for("react.portal"), wa = Symbol.for("react.fragment"), xa = Symbol.for("react.strict_mode"), za = Symbol.for("react.profiler"), Aa = Symbol.for("react.provider"), Ba = Symbol.for("react.context"), Ca = Symbol.for("react.forward_ref"), Da = Symbol.for("react.suspense"), Ea = Symbol.for("react.suspense_list"), Fa = Symbol.for("react.memo"), Ga = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var Ha = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var Ia = Symbol.iterator;
function Ja(a) {
    if (null === a || "object" !== typeof a) return null;
    a = Ia && a[Ia] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var A = Object.assign, Ka;
function La(a) {
    if (void 0 === Ka) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        Ka = b && b[1] || "";
    }
    return "\n" + Ka + a;
}
var Ma = !1;
function Na(a, b) {
    if (!a || Ma) return "";
    Ma = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        Ma = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? La(a) : "";
}
function Oa(a) {
    switch(a.tag){
        case 5:
            return La(a.type);
        case 16:
            return La("Lazy");
        case 13:
            return La("Suspense");
        case 19:
            return La("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = Na(a.type, !1), a;
        case 11:
            return a = Na(a.type.render, !1), a;
        case 1:
            return a = Na(a.type, !0), a;
        default:
            return "";
    }
}
function Pa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case wa:
            return "Fragment";
        case va:
            return "Portal";
        case za:
            return "Profiler";
        case xa:
            return "StrictMode";
        case Da:
            return "Suspense";
        case Ea:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case Ba:
            return (a.displayName || "Context") + ".Consumer";
        case Aa:
            return (a._context.displayName || "Context") + ".Provider";
        case Ca:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case Fa:
            return b = a.displayName || null, null !== b ? b : Pa(a.type) || "Memo";
        case Ga:
            b = a._payload;
            a = a._init;
            try {
                return Pa(a(b));
            } catch (c) {}
    }
    return null;
}
function Qa(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return Pa(b);
        case 8:
            return b === xa ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function Ra(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function Sa(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function Ta(a) {
    var b = Sa(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function Ua(a) {
    a._valueTracker || (a._valueTracker = Ta(a));
}
function Va(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = Sa(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function Wa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function Xa(a, b) {
    var c = b.checked;
    return A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function Ya(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = Ra(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function Za(a, b) {
    b = b.checked;
    null != b && sa(a, "checked", b, !1);
}
function $a(a, b) {
    Za(a, b);
    var c = Ra(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? bb(a, b.type, c) : b.hasOwnProperty("defaultValue") && bb(a, b.type, Ra(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function cb(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function bb(a, b, c) {
    if ("number" !== b || Wa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var db = Array.isArray;
function eb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + Ra(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function fb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error(p(91));
    return A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function gb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error(p(92));
            if (db(c)) {
                if (1 < c.length) throw Error(p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: Ra(c)
    };
}
function hb(a, b) {
    var c = Ra(b.value), d = Ra(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function ib(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function jb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function kb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? jb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var lb, mb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        lb = lb || document.createElement("div");
        lb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = lb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function nb(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var ob = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, pb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys(ob).forEach(function(a) {
    pb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        ob[b] = ob[a];
    });
});
function qb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || ob.hasOwnProperty(a) && ob[a] ? ("" + b).trim() : b + "px";
}
function rb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = qb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var sb = A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function tb(a, b) {
    if (b) {
        if (sb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error(p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error(p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error(p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error(p(62));
    }
}
function ub(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var vb = null;
function wb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var xb = null, yb = null, zb = null;
function Ab(a) {
    if (a = Bb(a)) {
        if ("function" !== typeof xb) throw Error(p(280));
        var b = a.stateNode;
        b && (b = Cb(b), xb(a.stateNode, a.type, b));
    }
}
function Db(a) {
    yb ? zb ? zb.push(a) : zb = [
        a
    ] : yb = a;
}
function Eb() {
    if (yb) {
        var a = yb, b = zb;
        zb = yb = null;
        Ab(a);
        if (b) for(a = 0; a < b.length; a++)Ab(b[a]);
    }
}
function Fb(a, b) {
    return a(b);
}
function Gb() {}
var Hb = !1;
function Ib(a, b, c) {
    if (Hb) return a(b, c);
    Hb = !0;
    try {
        return Fb(a, b, c);
    } finally{
        if (Hb = !1, null !== yb || null !== zb) Gb(), Eb();
    }
}
function Jb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = Cb(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error(p(231, b, typeof c));
    return c;
}
var Kb = !1;
if (ia) try {
    var Lb = {};
    Object.defineProperty(Lb, "passive", {
        get: function() {
            Kb = !0;
        }
    });
    window.addEventListener("test", Lb, Lb);
    window.removeEventListener("test", Lb, Lb);
} catch (a) {
    Kb = !1;
}
function Mb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (n) {
        this.onError(n);
    }
}
var Nb = !1, Ob = null, Pb = !1, Qb = null, Rb = {
    onError: function(a) {
        Nb = !0;
        Ob = a;
    }
};
function Sb(a, b, c, d, e, f, g, h, k) {
    Nb = !1;
    Ob = null;
    Mb.apply(Rb, arguments);
}
function Tb(a, b, c, d, e, f, g, h, k) {
    Sb.apply(this, arguments);
    if (Nb) {
        if (Nb) {
            var l = Ob;
            Nb = !1;
            Ob = null;
        } else throw Error(p(198));
        Pb || (Pb = !0, Qb = l);
    }
}
function Ub(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function Vb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function Wb(a) {
    if (Ub(a) !== a) throw Error(p(188));
}
function Xb(a) {
    var b = a.alternate;
    if (!b) {
        b = Ub(a);
        if (null === b) throw Error(p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return Wb(e), a;
                if (f === d) return Wb(e), b;
                f = f.sibling;
            }
            throw Error(p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error(p(189));
            }
        }
        if (c.alternate !== d) throw Error(p(190));
    }
    if (3 !== c.tag) throw Error(p(188));
    return c.stateNode.current === c ? a : b;
}
function Yb(a) {
    a = Xb(a);
    return null !== a ? Zb(a) : null;
}
function Zb(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = Zb(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $b = ba.unstable_scheduleCallback, ac = ba.unstable_cancelCallback, bc = ba.unstable_shouldYield, cc = ba.unstable_requestPaint, B = ba.unstable_now, dc = ba.unstable_getCurrentPriorityLevel, ec = ba.unstable_ImmediatePriority, fc = ba.unstable_UserBlockingPriority, gc = ba.unstable_NormalPriority, hc = ba.unstable_LowPriority, ic = ba.unstable_IdlePriority, jc = null, kc = null;
function lc(a) {
    if (kc && "function" === typeof kc.onCommitFiberRoot) try {
        kc.onCommitFiberRoot(jc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var nc = Math.clz32 ? Math.clz32 : mc, oc = Math.log, pc = Math.LN2;
function mc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - (oc(a) / pc | 0) | 0;
}
var qc = 64, rc = 4194304;
function sc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function tc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = sc(h) : (f &= g, 0 !== f && (d = sc(f)));
    } else g = c & ~e, 0 !== g ? d = sc(g) : 0 !== f && (d = sc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - nc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function uc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function vc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - nc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = uc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function wc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function xc() {
    var a = qc;
    qc <<= 1;
    0 === (qc & 4194240) && (qc = 64);
    return a;
}
function yc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function zc(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - nc(b);
    a[b] = c;
}
function Ac(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - nc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function Bc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - nc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var C = 0;
function Cc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var Dc, Ec, Fc, Gc, Hc, Ic = !1, Jc = [], Kc = null, Lc = null, Mc = null, Nc = new Map, Oc = new Map, Pc = [], Qc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function Rc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            Kc = null;
            break;
        case "dragenter":
        case "dragleave":
            Lc = null;
            break;
        case "mouseover":
        case "mouseout":
            Mc = null;
            break;
        case "pointerover":
        case "pointerout":
            Nc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            Oc.delete(b.pointerId);
    }
}
function Sc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = Bb(b), null !== b && Ec(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function Tc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return Kc = Sc(Kc, a, b, c, d, e), !0;
        case "dragenter":
            return Lc = Sc(Lc, a, b, c, d, e), !0;
        case "mouseover":
            return Mc = Sc(Mc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            Nc.set(f, Sc(Nc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, Oc.set(f, Sc(Oc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function Uc(a) {
    var b = Vc(a.target);
    if (null !== b) {
        var c = Ub(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = Vb(c), null !== b) {
                    a.blockedOn = b;
                    Hc(a.priority, function() {
                        Fc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function Wc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = Xc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            vb = d;
            c.target.dispatchEvent(d);
            vb = null;
        } else return b = Bb(c), null !== b && Ec(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function Yc(a, b, c) {
    Wc(a) && c.delete(b);
}
function Zc() {
    Ic = !1;
    null !== Kc && Wc(Kc) && (Kc = null);
    null !== Lc && Wc(Lc) && (Lc = null);
    null !== Mc && Wc(Mc) && (Mc = null);
    Nc.forEach(Yc);
    Oc.forEach(Yc);
}
function $c(a, b) {
    a.blockedOn === b && (a.blockedOn = null, Ic || (Ic = !0, ba.unstable_scheduleCallback(ba.unstable_NormalPriority, Zc)));
}
function ad(a) {
    function b(b) {
        return $c(b, a);
    }
    if (0 < Jc.length) {
        $c(Jc[0], a);
        for(var c = 1; c < Jc.length; c++){
            var d = Jc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== Kc && $c(Kc, a);
    null !== Lc && $c(Lc, a);
    null !== Mc && $c(Mc, a);
    Nc.forEach(b);
    Oc.forEach(b);
    for(c = 0; c < Pc.length; c++)d = Pc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < Pc.length && (c = Pc[0], null === c.blockedOn);)Uc(c), null === c.blockedOn && Pc.shift();
}
var bd = ta.ReactCurrentBatchConfig, cd = !0;
function dd(a, b, c, d) {
    var e = C, f = bd.transition;
    bd.transition = null;
    try {
        C = 1, ed(a, b, c, d);
    } finally{
        C = e, bd.transition = f;
    }
}
function fd(a, b, c, d) {
    var e = C, f = bd.transition;
    bd.transition = null;
    try {
        C = 4, ed(a, b, c, d);
    } finally{
        C = e, bd.transition = f;
    }
}
function ed(a, b, c, d) {
    if (cd) {
        var e = Xc(a, b, c, d);
        if (null === e) gd(a, b, d, hd, c), Rc(a, d);
        else if (Tc(e, a, b, c, d)) d.stopPropagation();
        else if (Rc(a, d), b & 4 && -1 < Qc.indexOf(a)) {
            for(; null !== e;){
                var f = Bb(e);
                null !== f && Dc(f);
                f = Xc(a, b, c, d);
                null === f && gd(a, b, d, hd, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else gd(a, b, d, null, c);
    }
}
var hd = null;
function Xc(a, b, c, d) {
    hd = null;
    a = wb(d);
    a = Vc(a);
    if (null !== a) {
        if (b = Ub(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = Vb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    hd = a;
    return null;
}
function id(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch(dc()){
                case ec:
                    return 1;
                case fc:
                    return 4;
                case gc:
                case hc:
                    return 16;
                case ic:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var jd = null, kd = null, ld = null;
function md() {
    if (ld) return ld;
    var a, b = kd, c = b.length, d, e = "value" in jd ? jd.value : jd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return ld = e.slice(a, 1 < d ? 1 - d : void 0);
}
function nd(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function od() {
    return !0;
}
function pd() {
    return !1;
}
function qd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? od : pd;
        this.isPropagationStopped = pd;
        return this;
    }
    A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = od);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = od);
        },
        persist: function() {},
        isPersistent: od
    });
    return b;
}
var rd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, sd = qd(rd), td = A({}, rd, {
    view: 0,
    detail: 0
}), ud = qd(td), vd, wd, xd, zd = A({}, td, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: yd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== xd && (xd && "mousemove" === a.type ? (vd = a.screenX - xd.screenX, wd = a.screenY - xd.screenY) : wd = vd = 0, xd = a);
        return vd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : wd;
    }
}), Ad = qd(zd), Bd = A({}, zd, {
    dataTransfer: 0
}), Cd = qd(Bd), Dd = A({}, td, {
    relatedTarget: 0
}), Ed = qd(Dd), Fd = A({}, rd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), Gd = qd(Fd), Hd = A({}, rd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), Id = qd(Hd), Jd = A({}, rd, {
    data: 0
}), Kd = qd(Jd), Ld = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, Md = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, Nd = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function Od(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = Nd[a]) ? !!b[a] : !1;
}
function yd() {
    return Od;
}
var Pd = A({}, td, {
    key: function(a) {
        if (a.key) {
            var b = Ld[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = nd(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? Md[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: yd,
    charCode: function(a) {
        return "keypress" === a.type ? nd(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? nd(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), Qd = qd(Pd), Rd = A({}, zd, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), Sd = qd(Rd), Td = A({}, td, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: yd
}), Ud = qd(Td), Vd = A({}, rd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), Wd = qd(Vd), Xd = A({}, zd, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), Yd = qd(Xd), Zd = [
    9,
    13,
    27,
    32
], $d = ia && "CompositionEvent" in window, ae = null;
ia && "documentMode" in document && (ae = document.documentMode);
var be = ia && "TextEvent" in window && !ae, ce = ia && (!$d || ae && 8 < ae && 11 >= ae), de = String.fromCharCode(32), ee = !1;
function fe(a, b) {
    switch(a){
        case "keyup":
            return -1 !== Zd.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function ge(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var he = !1;
function ie(a, b) {
    switch(a){
        case "compositionend":
            return ge(b);
        case "keypress":
            if (32 !== b.which) return null;
            ee = !0;
            return de;
        case "textInput":
            return a = b.data, a === de && ee ? null : a;
        default:
            return null;
    }
}
function je(a, b) {
    if (he) return "compositionend" === a || !$d && fe(a, b) ? (a = md(), ld = kd = jd = null, he = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return ce && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var ke = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function le(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!ke[a.type] : "textarea" === b ? !0 : !1;
}
function me(a, b, c, d) {
    Db(d);
    b = ne(b, "onChange");
    0 < b.length && (c = new sd("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var oe = null, pe = null;
function qe(a) {
    re(a, 0);
}
function se(a) {
    var b = te(a);
    if (Va(b)) return a;
}
function ue(a, b) {
    if ("change" === a) return b;
}
var ve = !1;
if (ia) {
    var we;
    if (ia) {
        var xe = "oninput" in document;
        if (!xe) {
            var ye = document.createElement("div");
            ye.setAttribute("oninput", "return;");
            xe = "function" === typeof ye.oninput;
        }
        we = xe;
    } else we = !1;
    ve = we && (!document.documentMode || 9 < document.documentMode);
}
function ze() {
    oe && (oe.detachEvent("onpropertychange", Ae), pe = oe = null);
}
function Ae(a) {
    if ("value" === a.propertyName && se(pe)) {
        var b = [];
        me(b, pe, a, wb(a));
        Ib(qe, b);
    }
}
function Be(a, b, c) {
    "focusin" === a ? (ze(), oe = b, pe = c, oe.attachEvent("onpropertychange", Ae)) : "focusout" === a && ze();
}
function Ce(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return se(pe);
}
function De(a, b) {
    if ("click" === a) return se(b);
}
function Ee(a, b) {
    if ("input" === a || "change" === a) return se(b);
}
function Fe(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var Ge = "function" === typeof Object.is ? Object.is : Fe;
function He(a, b) {
    if (Ge(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!ja.call(b, e) || !Ge(a[e], b[e])) return !1;
    }
    return !0;
}
function Ie(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function Je(a, b) {
    var c = Ie(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = Ie(c);
    }
}
function Ke(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? Ke(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function Le() {
    for(var a = window, b = Wa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = Wa(a.document);
    }
    return b;
}
function Me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function Ne(a) {
    var b = Le(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && Ke(c.ownerDocument.documentElement, c)) {
        if (null !== d && Me(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = Je(c, f);
                var g = Je(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var Oe = ia && "documentMode" in document && 11 >= document.documentMode, Pe = null, Qe = null, Re = null, Se = !1;
function Te(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    Se || null == Pe || Pe !== Wa(d) || (d = Pe, "selectionStart" in d && Me(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), Re && He(Re, d) || (Re = d, d = ne(Qe, "onSelect"), 0 < d.length && (b = new sd("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = Pe)));
}
function Ue(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var Ve = {
    animationend: Ue("Animation", "AnimationEnd"),
    animationiteration: Ue("Animation", "AnimationIteration"),
    animationstart: Ue("Animation", "AnimationStart"),
    transitionend: Ue("Transition", "TransitionEnd")
}, We = {}, Xe = {};
ia && (Xe = document.createElement("div").style, "AnimationEvent" in window || (delete Ve.animationend.animation, delete Ve.animationiteration.animation, delete Ve.animationstart.animation), "TransitionEvent" in window || delete Ve.transitionend.transition);
function Ye(a) {
    if (We[a]) return We[a];
    if (!Ve[a]) return a;
    var b = Ve[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in Xe) return We[a] = b[c];
    return a;
}
var Ze = Ye("animationend"), $e = Ye("animationiteration"), af = Ye("animationstart"), bf = Ye("transitionend"), cf = new Map, df = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function ef(a, b) {
    cf.set(a, b);
    fa(b, [
        a
    ]);
}
for(var ff = 0; ff < df.length; ff++){
    var gf = df[ff], hf = gf.toLowerCase(), jf = gf[0].toUpperCase() + gf.slice(1);
    ef(hf, "on" + jf);
}
ef(Ze, "onAnimationEnd");
ef($e, "onAnimationIteration");
ef(af, "onAnimationStart");
ef("dblclick", "onDoubleClick");
ef("focusin", "onFocus");
ef("focusout", "onBlur");
ef(bf, "onTransitionEnd");
ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var kf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), lf = new Set("cancel close invalid load scroll toggle".split(" ").concat(kf));
function mf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    Tb(d, b, void 0, a);
    a.currentTarget = null;
}
function re(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                mf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                mf(e, h, l);
                f = k;
            }
        }
    }
    if (Pb) throw a = Qb, Pb = !1, Qb = null, a;
}
function D(a, b) {
    var c = b[nf];
    void 0 === c && (c = b[nf] = new Set);
    var d = a + "__bubble";
    c.has(d) || (of(b, a, 2, !1), c.add(d));
}
function pf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    of(c, a, d, b);
}
var qf = "_reactListening" + Math.random().toString(36).slice(2);
function rf(a) {
    if (!a[qf]) {
        a[qf] = !0;
        da.forEach(function(b) {
            "selectionchange" !== b && (lf.has(b) || pf(b, !1, a), pf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[qf] || (b[qf] = !0, pf("selectionchange", !1, b));
    }
}
function of(a, b, c, d) {
    switch(id(b)){
        case 1:
            var e = dd;
            break;
        case 4:
            e = fd;
            break;
        default:
            e = ed;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !Kb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function gd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = Vc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    Ib(function() {
        var d = f, e = wb(c), g = [];
        a: {
            var h = cf.get(a);
            if (void 0 !== h) {
                var k = sd, m = a;
                switch(a){
                    case "keypress":
                        if (0 === nd(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = Qd;
                        break;
                    case "focusin":
                        m = "focus";
                        k = Ed;
                        break;
                    case "focusout":
                        m = "blur";
                        k = Ed;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = Ed;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = Ad;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = Cd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = Ud;
                        break;
                    case Ze:
                    case $e:
                    case af:
                        k = Gd;
                        break;
                    case bf:
                        k = Wd;
                        break;
                    case "scroll":
                        k = ud;
                        break;
                    case "wheel":
                        k = Yd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = Id;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = Sd;
                }
                var w = 0 !== (b & 4), J = !w && "scroll" === a, v = w ? null !== h ? h + "Capture" : null : h;
                w = [];
                for(var x = d, r; null !== x;){
                    r = x;
                    var F = r.stateNode;
                    5 === r.tag && null !== F && (r = F, null !== v && (F = Jb(x, v), null != F && w.push(sf(x, F, r))));
                    if (J) break;
                    x = x.return;
                }
                0 < w.length && (h = new k(h, m, null, c, e), g.push({
                    event: h,
                    listeners: w
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== vb && (m = c.relatedTarget || c.fromElement) && (Vc(m) || m[tf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (m = c.relatedTarget || c.toElement, k = d, m = m ? Vc(m) : null, null !== m && (J = Ub(m), m !== J || 5 !== m.tag && 6 !== m.tag)) m = null;
                    } else k = null, m = d;
                    if (k !== m) {
                        w = Ad;
                        F = "onMouseLeave";
                        v = "onMouseEnter";
                        x = "mouse";
                        if ("pointerout" === a || "pointerover" === a) w = Sd, F = "onPointerLeave", v = "onPointerEnter", x = "pointer";
                        J = null == k ? h : te(k);
                        r = null == m ? h : te(m);
                        h = new w(F, x + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = r;
                        F = null;
                        Vc(e) === d && (w = new w(v, x + "enter", m, c, e), w.target = r, w.relatedTarget = J, F = w);
                        J = F;
                        if (k && m) b: {
                            w = k;
                            v = m;
                            x = 0;
                            for(r = w; r; r = uf(r))x++;
                            r = 0;
                            for(F = v; F; F = uf(F))r++;
                            for(; 0 < x - r;)w = uf(w), x--;
                            for(; 0 < r - x;)v = uf(v), r--;
                            for(; x--;){
                                if (w === v || null !== v && w === v.alternate) break b;
                                w = uf(w);
                                v = uf(v);
                            }
                            w = null;
                        }
                        else w = null;
                        null !== k && vf(g, h, k, w, !1);
                        null !== m && null !== J && vf(g, J, m, w, !0);
                    }
                }
            }
            a: {
                h = d ? te(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var Z = ue;
                else if (le(h)) {
                    if (ve) Z = Ee;
                    else {
                        Z = Ce;
                        var ya = Be;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (Z = De);
                if (Z && (Z = Z(a, d))) {
                    me(g, Z, c, e);
                    break a;
                }
                ya && ya(a, h, d);
                "focusout" === a && (ya = h._wrapperState) && ya.controlled && "number" === h.type && bb(h, "number", h.value);
            }
            ya = d ? te(d) : window;
            switch(a){
                case "focusin":
                    if (le(ya) || "true" === ya.contentEditable) Pe = ya, Qe = d, Re = null;
                    break;
                case "focusout":
                    Re = Qe = Pe = null;
                    break;
                case "mousedown":
                    Se = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    Se = !1;
                    Te(g, c, e);
                    break;
                case "selectionchange":
                    if (Oe) break;
                case "keydown":
                case "keyup":
                    Te(g, c, e);
            }
            var ab;
            if ($d) b: {
                switch(a){
                    case "compositionstart":
                        var ca = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ca = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ca = "onCompositionUpdate";
                        break b;
                }
                ca = void 0;
            }
            else he ? fe(a, c) && (ca = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ca = "onCompositionStart");
            ca && (ce && "ko" !== c.locale && (he || "onCompositionStart" !== ca ? "onCompositionEnd" === ca && he && (ab = md()) : (jd = e, kd = "value" in jd ? jd.value : jd.textContent, he = !0)), ya = ne(d, ca), 0 < ya.length && (ca = new Kd(ca, a, null, c, e), g.push({
                event: ca,
                listeners: ya
            }), ab ? ca.data = ab : (ab = ge(c), null !== ab && (ca.data = ab))));
            if (ab = be ? ie(a, c) : je(a, c)) d = ne(d, "onBeforeInput"), 0 < d.length && (e = new Kd("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = ab);
        }
        re(g, b);
    });
}
function sf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function ne(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = Jb(a, c), null != f && d.unshift(sf(a, f, e)), f = Jb(a, b), null != f && d.push(sf(a, f, e)));
        a = a.return;
    }
    return d;
}
function uf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function vf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = Jb(c, f), null != k && g.unshift(sf(c, k, h))) : e || (k = Jb(c, f), null != k && g.push(sf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var wf = /\r\n?/g, xf = /\u0000|\uFFFD/g;
function yf(a) {
    return ("string" === typeof a ? a : "" + a).replace(wf, "\n").replace(xf, "");
}
function zf(a, b, c) {
    b = yf(b);
    if (yf(a) !== b && c) throw Error(p(425));
}
function Af() {}
var Bf = null, Cf = null;
function Df(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var Ef = "function" === typeof setTimeout ? setTimeout : void 0, Ff = "function" === typeof clearTimeout ? clearTimeout : void 0, Gf = "function" === typeof Promise ? Promise : void 0, If = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof Gf ? function(a) {
    return Gf.resolve(null).then(a).catch(Hf);
} : Ef;
function Hf(a) {
    setTimeout(function() {
        throw a;
    });
}
function Jf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    ad(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    ad(b);
}
function Kf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function Lf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var Mf = Math.random().toString(36).slice(2), Nf = "__reactFiber$" + Mf, Of = "__reactProps$" + Mf, tf = "__reactContainer$" + Mf, nf = "__reactEvents$" + Mf, Pf = "__reactListeners$" + Mf, Qf = "__reactHandles$" + Mf;
function Vc(a) {
    var b = a[Nf];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[tf] || c[Nf]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = Lf(a); null !== a;){
                if (c = a[Nf]) return c;
                a = Lf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function Bb(a) {
    a = a[Nf] || a[tf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function te(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error(p(33));
}
function Cb(a) {
    return a[Of] || null;
}
var Rf = [], Sf = -1;
function Tf(a) {
    return {
        current: a
    };
}
function E(a) {
    0 > Sf || (a.current = Rf[Sf], Rf[Sf] = null, Sf--);
}
function G(a, b) {
    Sf++;
    Rf[Sf] = a.current;
    a.current = b;
}
var Uf = {}, H = Tf(Uf), Vf = Tf(!1), Wf = Uf;
function Xf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return Uf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function Yf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function Zf() {
    E(Vf);
    E(H);
}
function $f(a, b, c) {
    if (H.current !== Uf) throw Error(p(168));
    G(H, b);
    G(Vf, c);
}
function ag(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error(p(108, Qa(a) || "Unknown", e));
    return A({}, c, d);
}
function bg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || Uf;
    Wf = H.current;
    G(H, a);
    G(Vf, Vf.current);
    return !0;
}
function cg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error(p(169));
    c ? (a = ag(a, b, Wf), d.__reactInternalMemoizedMergedChildContext = a, E(Vf), E(H), G(H, a)) : E(Vf);
    G(Vf, c);
}
var dg = null, eg = !1, fg = !1;
function gg(a) {
    null === dg ? dg = [
        a
    ] : dg.push(a);
}
function hg(a) {
    eg = !0;
    gg(a);
}
function ig() {
    if (!fg && null !== dg) {
        fg = !0;
        var a = 0, b = C;
        try {
            var c = dg;
            for(C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            dg = null;
            eg = !1;
        } catch (e) {
            throw null !== dg && (dg = dg.slice(a + 1)), $b(ec, ig), e;
        } finally{
            C = b, fg = !1;
        }
    }
    return null;
}
var jg = ta.ReactCurrentBatchConfig;
function kg(a, b) {
    if (a && a.defaultProps) {
        b = A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var lg = Tf(null), mg = null, ng = null, og = null;
function pg() {
    og = ng = mg = null;
}
function qg(a) {
    var b = lg.current;
    E(lg);
    a._currentValue = b;
}
function rg(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function sg(a, b) {
    mg = a;
    og = ng = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && (tg = !0), a.firstContext = null);
}
function ug(a) {
    var b = a._currentValue;
    if (og !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === ng) {
            if (null === mg) throw Error(p(308));
            ng = a;
            mg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else ng = ng.next = a;
    }
    return b;
}
var vg = null, wg = !1;
function xg(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function yg(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function zg(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function Ag(a, b) {
    var c = a.updateQueue;
    null !== c && (c = c.shared, Bg(a) ? (a = c.interleaved, null === a ? (b.next = b, null === vg ? vg = [
        c
    ] : vg.push(c)) : (b.next = a.next, a.next = b), c.interleaved = b) : (a = c.pending, null === a ? b.next = b : (b.next = a.next, a.next = b), c.pending = b));
}
function Cg(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        Bc(a, c);
    }
}
function Dg(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function Eg(a, b, c, d) {
    var e = a.updateQueue;
    wg = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var n = a.alternate;
        null !== n && (n = n.updateQueue, h = n.lastBaseUpdate, h !== g && (null === h ? n.firstBaseUpdate = l : h.next = l, n.lastBaseUpdate = k));
    }
    if (null !== f) {
        var u = e.baseState;
        g = 0;
        n = l = k = null;
        h = f;
        do {
            var q = h.lane, y = h.eventTime;
            if ((d & q) === q) {
                null !== n && (n = n.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var m = a, w = h;
                    q = b;
                    y = c;
                    switch(w.tag){
                        case 1:
                            m = w.payload;
                            if ("function" === typeof m) {
                                u = m.call(y, u, q);
                                break a;
                            }
                            u = m;
                            break a;
                        case 3:
                            m.flags = m.flags & -65537 | 128;
                        case 0:
                            m = w.payload;
                            q = "function" === typeof m ? m.call(y, u, q) : m;
                            if (null === q || void 0 === q) break a;
                            u = A({}, u, q);
                            break a;
                        case 2:
                            wg = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, q = e.effects, null === q ? e.effects = [
                    h
                ] : q.push(h));
            } else y = {
                eventTime: y,
                lane: q,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === n ? (l = n = y, k = u) : n = n.next = y, g |= q;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else q = h, h = q.next, q.next = null, e.lastBaseUpdate = q, e.shared.pending = null;
            }
        }while (1);
        null === n && (k = u);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = n;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        Fg |= g;
        a.lanes = g;
        a.memoizedState = u;
    }
}
function Gg(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error(p(191, e));
            e.call(d);
        }
    }
}
var Hg = (new aa.Component).refs;
function Ig(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var Mg = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? Ub(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = Jg(), e = Kg(a), f = zg(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        Ag(a, f);
        b = Lg(a, e, d);
        null !== b && Cg(b, a, e);
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = Jg(), e = Kg(a), f = zg(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        Ag(a, f);
        b = Lg(a, e, d);
        null !== b && Cg(b, a, e);
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = Jg(), d = Kg(a), e = zg(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        Ag(a, e);
        b = Lg(a, d, c);
        null !== b && Cg(b, a, d);
    }
};
function Ng(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !He(c, d) || !He(e, f) : !0;
}
function Og(a, b, c) {
    var d = !1, e = Uf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = ug(f) : (e = Yf(b) ? Wf : H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? Xf(a, e) : Uf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = Mg;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function Pg(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && Mg.enqueueReplaceState(b, b.state, null);
}
function Qg(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = Hg;
    xg(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = ug(f) : (f = Yf(b) ? Wf : H.current, e.context = Xf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && (Ig(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && Mg.enqueueReplaceState(e, e.state, null), Eg(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
var Rg = [], Sg = 0, Tg = null, Ug = 0, Vg = [], Wg = 0, Xg = null, Yg = 1, Zg = "";
function $g(a, b) {
    Rg[Sg++] = Ug;
    Rg[Sg++] = Tg;
    Tg = a;
    Ug = b;
}
function ah(a, b, c) {
    Vg[Wg++] = Yg;
    Vg[Wg++] = Zg;
    Vg[Wg++] = Xg;
    Xg = a;
    var d = Yg;
    a = Zg;
    var e = 32 - nc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - nc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        Yg = 1 << 32 - nc(b) + e | c << e | d;
        Zg = f + a;
    } else Yg = 1 << f | c << e | d, Zg = a;
}
function bh(a) {
    null !== a.return && ($g(a, 1), ah(a, 1, 0));
}
function ch(a) {
    for(; a === Tg;)Tg = Rg[--Sg], Rg[Sg] = null, Ug = Rg[--Sg], Rg[Sg] = null;
    for(; a === Xg;)Xg = Vg[--Wg], Vg[Wg] = null, Zg = Vg[--Wg], Vg[Wg] = null, Yg = Vg[--Wg], Vg[Wg] = null;
}
var dh = null, eh = null, I = !1, fh = null;
function gh(a, b) {
    var c = hh(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function ih(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, dh = a, eh = Kf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, dh = a, eh = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== Xg ? {
                id: Yg,
                overflow: Zg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = hh(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, dh = a, eh = null, !0) : !1;
        default:
            return !1;
    }
}
function jh(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function kh(a) {
    if (I) {
        var b = eh;
        if (b) {
            var c = b;
            if (!ih(a, b)) {
                if (jh(a)) throw Error(p(418));
                b = Kf(c.nextSibling);
                var d = dh;
                b && ih(a, b) ? gh(d, c) : (a.flags = a.flags & -4097 | 2, I = !1, dh = a);
            }
        } else {
            if (jh(a)) throw Error(p(418));
            a.flags = a.flags & -4097 | 2;
            I = !1;
            dh = a;
        }
    }
}
function lh(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    dh = a;
}
function mh(a) {
    if (a !== dh) return !1;
    if (!I) return lh(a), I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !Df(a.type, a.memoizedProps));
    if (b && (b = eh)) {
        if (jh(a)) {
            for(a = eh; a;)a = Kf(a.nextSibling);
            throw Error(p(418));
        }
        for(; b;)gh(a, b), b = Kf(b.nextSibling);
    }
    lh(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error(p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            eh = Kf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            eh = null;
        }
    } else eh = dh ? Kf(a.stateNode.nextSibling) : null;
    return !0;
}
function nh() {
    eh = dh = null;
    I = !1;
}
function oh(a) {
    null === fh ? fh = [
        a
    ] : fh.push(a);
}
function ph(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error(p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error(p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                b === Hg && (b = e.refs = {});
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error(p(284));
        if (!c._owner) throw Error(p(290, a));
    }
    return a;
}
function qh(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error(p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function rh(a) {
    var b = a._init;
    return b(a._payload);
}
function sh(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = th(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = uh(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === wa) return n(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === Ga && rh(f) === b.type)) return d = e(b, c.props), d.ref = ph(a, b, c), d.return = a, d;
        d = vh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = ph(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = wh(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function n(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = xh(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function u(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = uh("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case ua:
                    return c = vh(b.type, b.key, b.props, null, a.mode, c), c.ref = ph(a, null, b), c.return = a, c;
                case va:
                    return b = wh(b, a.mode, c), b.return = a, b;
                case Ga:
                    var d = b._init;
                    return u(a, d(b._payload), c);
            }
            if (db(b) || Ja(b)) return b = xh(b, a.mode, c, null), b.return = a, b;
            qh(a, b);
        }
        return null;
    }
    function q(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case ua:
                    return c.key === e ? k(a, b, c, d) : null;
                case va:
                    return c.key === e ? l(a, b, c, d) : null;
                case Ga:
                    return e = c._init, q(a, b, e(c._payload), d);
            }
            if (db(c) || Ja(c)) return null !== e ? null : n(a, b, c, d, null);
            qh(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case ua:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case va:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case Ga:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if (db(d) || Ja(d)) return a = a.get(c) || null, n(b, a, d, e, null);
            qh(b, d);
        }
        return null;
    }
    function m(e, g, h, k) {
        for(var l = null, n = null, r = g, m = g = 0, x = null; null !== r && m < h.length; m++){
            r.index > m ? (x = r, r = null) : x = r.sibling;
            var v = q(e, r, h[m], k);
            if (null === v) {
                null === r && (r = x);
                break;
            }
            a && r && null === v.alternate && b(e, r);
            g = f(v, g, m);
            null === n ? l = v : n.sibling = v;
            n = v;
            r = x;
        }
        if (m === h.length) return c(e, r), I && $g(e, m), l;
        if (null === r) {
            for(; m < h.length; m++)r = u(e, h[m], k), null !== r && (g = f(r, g, m), null === n ? l = r : n.sibling = r, n = r);
            I && $g(e, m);
            return l;
        }
        for(r = d(e, r); m < h.length; m++)x = y(r, e, m, h[m], k), null !== x && (a && null !== x.alternate && r.delete(null === x.key ? m : x.key), g = f(x, g, m), null === n ? l = x : n.sibling = x, n = x);
        a && r.forEach(function(a) {
            return b(e, a);
        });
        I && $g(e, m);
        return l;
    }
    function w(e, g, h, k) {
        var l = Ja(h);
        if ("function" !== typeof l) throw Error(p(150));
        h = l.call(h);
        if (null == h) throw Error(p(151));
        for(var n = l = null, m = g, r = g = 0, x = null, v = h.next(); null !== m && !v.done; r++, v = h.next()){
            m.index > r ? (x = m, m = null) : x = m.sibling;
            var w = q(e, m, v.value, k);
            if (null === w) {
                null === m && (m = x);
                break;
            }
            a && m && null === w.alternate && b(e, m);
            g = f(w, g, r);
            null === n ? l = w : n.sibling = w;
            n = w;
            m = x;
        }
        if (v.done) return c(e, m), I && $g(e, r), l;
        if (null === m) {
            for(; !v.done; r++, v = h.next())v = u(e, v.value, k), null !== v && (g = f(v, g, r), null === n ? l = v : n.sibling = v, n = v);
            I && $g(e, r);
            return l;
        }
        for(m = d(e, m); !v.done; r++, v = h.next())v = y(m, e, r, v.value, k), null !== v && (a && null !== v.alternate && m.delete(null === v.key ? r : v.key), g = f(v, g, r), null === n ? l = v : n.sibling = v, n = v);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        I && $g(e, r);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === wa && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case ua:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === wa) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === Ga && rh(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = ph(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === wa ? (d = xh(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = vh(f.type, f.key, f.props, null, a.mode, h), h.ref = ph(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case va:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = wh(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case Ga:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if (db(f)) return m(a, d, f, h);
            if (Ja(f)) return w(a, d, f, h);
            qh(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = uh(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var yh = sh(!0), zh = sh(!1), Ah = {}, Bh = Tf(Ah), Ch = Tf(Ah), Dh = Tf(Ah);
function Eh(a) {
    if (a === Ah) throw Error(p(174));
    return a;
}
function Fh(a, b) {
    G(Dh, b);
    G(Ch, a);
    G(Bh, Ah);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : kb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = kb(b, a);
    }
    E(Bh);
    G(Bh, b);
}
function Gh() {
    E(Bh);
    E(Ch);
    E(Dh);
}
function Hh(a) {
    Eh(Dh.current);
    var b = Eh(Bh.current);
    var c = kb(b, a.type);
    b !== c && (G(Ch, a), G(Bh, c));
}
function Ih(a) {
    Ch.current === a && (E(Bh), E(Ch));
}
var K = Tf(0);
function Jh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var Kh = [];
function Lh() {
    for(var a = 0; a < Kh.length; a++)Kh[a]._workInProgressVersionPrimary = null;
    Kh.length = 0;
}
var Mh = ta.ReactCurrentDispatcher, Nh = ta.ReactCurrentBatchConfig, Oh = 0, L = null, M = null, N = null, Ph = !1, Qh = !1, Rh = 0, Sh = 0;
function O() {
    throw Error(p(321));
}
function Th(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!Ge(a[c], b[c])) return !1;
    return !0;
}
function Uh(a, b, c, d, e, f) {
    Oh = f;
    L = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    Mh.current = null === a || null === a.memoizedState ? Vh : Wh;
    a = c(d, e);
    if (Qh) {
        f = 0;
        do {
            Qh = !1;
            Rh = 0;
            if (25 <= f) throw Error(p(301));
            f += 1;
            N = M = null;
            b.updateQueue = null;
            Mh.current = Xh;
            a = c(d, e);
        }while (Qh);
    }
    Mh.current = Yh;
    b = null !== M && null !== M.next;
    Oh = 0;
    N = M = L = null;
    Ph = !1;
    if (b) throw Error(p(300));
    return a;
}
function Zh() {
    var a = 0 !== Rh;
    Rh = 0;
    return a;
}
function $h() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === N ? L.memoizedState = N = a : N = N.next = a;
    return N;
}
function ai() {
    if (null === M) {
        var a = L.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = M.next;
    var b = null === N ? L.memoizedState : N.next;
    if (null !== b) N = b, M = a;
    else {
        if (null === a) throw Error(p(310));
        M = a;
        a = {
            memoizedState: M.memoizedState,
            baseState: M.baseState,
            baseQueue: M.baseQueue,
            queue: M.queue,
            next: null
        };
        null === N ? L.memoizedState = N = a : N = N.next = a;
    }
    return N;
}
function bi(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function ci(a) {
    var b = ai(), c = b.queue;
    if (null === c) throw Error(p(311));
    c.lastRenderedReducer = a;
    var d = M, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var n = l.lane;
            if ((Oh & n) === n) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var u = {
                    lane: n,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = u, g = d) : k = k.next = u;
                L.lanes |= n;
                Fg |= n;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        Ge(d, b.memoizedState) || (tg = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, L.lanes |= f, Fg |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function di(a) {
    var b = ai(), c = b.queue;
    if (null === c) throw Error(p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        Ge(f, b.memoizedState) || (tg = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function ei() {}
function fi(a, b) {
    var c = L, d = ai(), e = b(), f = !Ge(d.memoizedState, e);
    f && (d.memoizedState = e, tg = !0);
    d = d.queue;
    gi(hi.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== N && N.memoizedState.tag & 1) {
        c.flags |= 2048;
        ii(9, ji.bind(null, c, d, e, b), void 0, null);
        if (null === P) throw Error(p(349));
        0 !== (Oh & 30) || ki(c, b, e);
    }
    return e;
}
function ki(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = L.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, L.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function ji(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    li(b) && Lg(a, 1, -1);
}
function hi(a, b, c) {
    return c(function() {
        li(b) && Lg(a, 1, -1);
    });
}
function li(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !Ge(a, c);
    } catch (d) {
        return !0;
    }
}
function mi(a) {
    var b = $h();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: bi,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = ni.bind(null, L, a);
    return [
        b.memoizedState,
        a
    ];
}
function ii(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = L.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, L.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function oi() {
    return ai().memoizedState;
}
function pi(a, b, c, d) {
    var e = $h();
    L.flags |= a;
    e.memoizedState = ii(1 | b, c, void 0, void 0 === d ? null : d);
}
function qi(a, b, c, d) {
    var e = ai();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== M) {
        var g = M.memoizedState;
        f = g.destroy;
        if (null !== d && Th(d, g.deps)) {
            e.memoizedState = ii(b, c, f, d);
            return;
        }
    }
    L.flags |= a;
    e.memoizedState = ii(1 | b, c, f, d);
}
function ri(a, b) {
    return pi(8390656, 8, a, b);
}
function gi(a, b) {
    return qi(2048, 8, a, b);
}
function si(a, b) {
    return qi(4, 2, a, b);
}
function ti(a, b) {
    return qi(4, 4, a, b);
}
function ui(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function vi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return qi(4, 4, ui.bind(null, b, a), c);
}
function wi() {}
function xi(a, b) {
    var c = ai();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && Th(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function yi(a, b) {
    var c = ai();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && Th(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function zi(a, b, c) {
    if (0 === (Oh & 21)) return a.baseState && (a.baseState = !1, tg = !0), a.memoizedState = c;
    Ge(c, b) || (c = xc(), L.lanes |= c, Fg |= c, a.baseState = !0);
    return b;
}
function Ai(a, b) {
    var c = C;
    C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = Nh.transition;
    Nh.transition = {};
    try {
        a(!1), b();
    } finally{
        C = c, Nh.transition = d;
    }
}
function Bi() {
    return ai().memoizedState;
}
function Ci(a, b, c) {
    var d = Kg(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    Di(a) ? Ei(b, c) : (Fi(a, b, c), c = Jg(), a = Lg(a, d, c), null !== a && Gi(a, b, d));
}
function ni(a, b, c) {
    var d = Kg(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if (Di(a)) Ei(b, e);
    else {
        Fi(a, b, e);
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if (Ge(h, g)) return;
        } catch (k) {} finally{}
        c = Jg();
        a = Lg(a, d, c);
        null !== a && Gi(a, b, d);
    }
}
function Di(a) {
    var b = a.alternate;
    return a === L || null !== b && b === L;
}
function Ei(a, b) {
    Qh = Ph = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function Fi(a, b, c) {
    Bg(a) ? (a = b.interleaved, null === a ? (c.next = c, null === vg ? vg = [
        b
    ] : vg.push(b)) : (c.next = a.next, a.next = c), b.interleaved = c) : (a = b.pending, null === a ? c.next = c : (c.next = a.next, a.next = c), b.pending = c);
}
function Gi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        Bc(a, c);
    }
}
var Yh = {
    readContext: ug,
    useCallback: O,
    useContext: O,
    useEffect: O,
    useImperativeHandle: O,
    useInsertionEffect: O,
    useLayoutEffect: O,
    useMemo: O,
    useReducer: O,
    useRef: O,
    useState: O,
    useDebugValue: O,
    useDeferredValue: O,
    useTransition: O,
    useMutableSource: O,
    useSyncExternalStore: O,
    useId: O,
    unstable_isNewReconciler: !1
}, Vh = {
    readContext: ug,
    useCallback: function(a, b) {
        $h().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: ug,
    useEffect: ri,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return pi(4194308, 4, ui.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return pi(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return pi(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $h();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $h();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = Ci.bind(null, L, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $h();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: mi,
    useDebugValue: wi,
    useDeferredValue: function(a) {
        return $h().memoizedState = a;
    },
    useTransition: function() {
        var a = mi(!1), b = a[0];
        a = Ai.bind(null, a[1]);
        $h().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = L, e = $h();
        if (I) {
            if (void 0 === c) throw Error(p(407));
            c = c();
        } else {
            c = b();
            if (null === P) throw Error(p(349));
            0 !== (Oh & 30) || ki(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        ri(hi.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        ii(9, ji.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $h(), b = P.identifierPrefix;
        if (I) {
            var c = Zg;
            var d = Yg;
            c = (d & ~(1 << 32 - nc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = Rh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = Sh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, Wh = {
    readContext: ug,
    useCallback: xi,
    useContext: ug,
    useEffect: gi,
    useImperativeHandle: vi,
    useInsertionEffect: si,
    useLayoutEffect: ti,
    useMemo: yi,
    useReducer: ci,
    useRef: oi,
    useState: function() {
        return ci(bi);
    },
    useDebugValue: wi,
    useDeferredValue: function(a) {
        var b = ai();
        return zi(b, M.memoizedState, a);
    },
    useTransition: function() {
        var a = ci(bi)[0], b = ai().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: ei,
    useSyncExternalStore: fi,
    useId: Bi,
    unstable_isNewReconciler: !1
}, Xh = {
    readContext: ug,
    useCallback: xi,
    useContext: ug,
    useEffect: gi,
    useImperativeHandle: vi,
    useInsertionEffect: si,
    useLayoutEffect: ti,
    useMemo: yi,
    useReducer: di,
    useRef: oi,
    useState: function() {
        return di(bi);
    },
    useDebugValue: wi,
    useDeferredValue: function(a) {
        var b = ai();
        return null === M ? b.memoizedState = a : zi(b, M.memoizedState, a);
    },
    useTransition: function() {
        var a = di(bi)[0], b = ai().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: ei,
    useSyncExternalStore: fi,
    useId: Bi,
    unstable_isNewReconciler: !1
};
function Hi(a, b) {
    try {
        var c = "", d = b;
        do c += Oa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e
    };
}
function Ii(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var Ji = "function" === typeof WeakMap ? WeakMap : Map;
function Ki(a, b, c) {
    c = zg(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        Li || (Li = !0, Mi = d);
        Ii(a, b);
    };
    return c;
}
function Ni(a, b, c) {
    c = zg(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            Ii(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        Ii(a, b);
        "function" !== typeof d && (null === Oi ? Oi = new Set([
            this
        ]) : Oi.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function Pi(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new Ji;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = Qi.bind(null, a, b, c), b.then(a, a));
}
function Ri(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function Si(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = zg(-1, 1), b.tag = 2, Ag(c, b))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var Ti, Ui, Vi, Wi;
Ti = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
Ui = function() {};
Vi = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        Eh(Bh.current);
        var f = null;
        switch(c){
            case "input":
                e = Xa(a, e);
                d = Xa(a, d);
                f = [];
                break;
            case "select":
                e = A({}, e, {
                    value: void 0
                });
                d = A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = fb(a, e);
                d = fb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = Af);
        }
        tb(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && (ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && (ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
Wi = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function Xi(a, b) {
    if (!I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function Q(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function Yi(a, b, c) {
    var d = b.pendingProps;
    ch(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return Q(b), null;
        case 1:
            return Yf(b.type) && Zf(), Q(b), null;
        case 3:
            d = b.stateNode;
            Gh();
            E(Vf);
            E(H);
            Lh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) mh(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== fh && (Zi(fh), fh = null));
            Ui(a, b);
            Q(b);
            return null;
        case 5:
            Ih(b);
            var e = Eh(Dh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) Vi(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error(p(166));
                    Q(b);
                    return null;
                }
                a = Eh(Bh.current);
                if (mh(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[Nf] = b;
                    d[Of] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            D("cancel", d);
                            D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < kf.length; e++)D(kf[e], d);
                            break;
                        case "source":
                            D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            D("error", d);
                            D("load", d);
                            break;
                        case "details":
                            D("toggle", d);
                            break;
                        case "input":
                            Ya(d, f);
                            D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            D("invalid", d);
                            break;
                        case "textarea":
                            gb(d, f), D("invalid", d);
                    }
                    tb(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && zf(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && zf(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : ea.hasOwnProperty(g) && null != h && "onScroll" === g && D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            Ua(d);
                            cb(d, f, !0);
                            break;
                        case "textarea":
                            Ua(d);
                            ib(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = Af);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = jb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[Nf] = b;
                    a[Of] = d;
                    Ti(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = ub(c, d);
                        switch(c){
                            case "dialog":
                                D("cancel", a);
                                D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < kf.length; e++)D(kf[e], a);
                                e = d;
                                break;
                            case "source":
                                D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                D("error", a);
                                D("load", a);
                                e = d;
                                break;
                            case "details":
                                D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                Ya(a, d);
                                e = Xa(a, d);
                                D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = A({}, d, {
                                    value: void 0
                                });
                                D("invalid", a);
                                break;
                            case "textarea":
                                gb(a, d);
                                e = fb(a, d);
                                D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        tb(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? rb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && mb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && nb(a, k) : "number" === typeof k && nb(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && (ea.hasOwnProperty(f) ? null != k && "onScroll" === f && D("scroll", a) : null != k && sa(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                Ua(a);
                                cb(a, d, !1);
                                break;
                            case "textarea":
                                Ua(a);
                                ib(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + Ra(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? eb(a, !!d.multiple, f, !1) : null != d.defaultValue && eb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = Af);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            Q(b);
            return null;
        case 6:
            if (a && null != b.stateNode) Wi(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error(p(166));
                c = Eh(Dh.current);
                Eh(Bh.current);
                if (mh(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[Nf] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = dh, null !== a) switch(a.tag){
                            case 3:
                                zf(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && zf(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[Nf] = b, b.stateNode = d;
            }
            Q(b);
            return null;
        case 13:
            E(K);
            d = b.memoizedState;
            if (I && null !== eh && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) {
                for(d = eh; d;)d = Kf(d.nextSibling);
                nh();
                b.flags |= 98560;
                return b;
            }
            if (null !== d && null !== d.dehydrated) {
                d = mh(b);
                if (null === a) {
                    if (!d) throw Error(p(318));
                    d = b.memoizedState;
                    d = null !== d ? d.dehydrated : null;
                    if (!d) throw Error(p(317));
                    d[Nf] = b;
                } else nh(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                Q(b);
                return null;
            }
            null !== fh && (Zi(fh), fh = null);
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            c = !1;
            null === a ? mh(b) : c = null !== a.memoizedState;
            d !== c && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== (K.current & 1) ? 0 === R && (R = 3) : $i()));
            null !== b.updateQueue && (b.flags |= 4);
            Q(b);
            return null;
        case 4:
            return Gh(), Ui(a, b), null === a && rf(b.stateNode.containerInfo), Q(b), null;
        case 10:
            return qg(b.type._context), Q(b), null;
        case 17:
            return Yf(b.type) && Zf(), Q(b), null;
        case 19:
            E(K);
            f = b.memoizedState;
            if (null === f) return Q(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) Xi(f, !1);
                else {
                    if (0 !== R || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = Jh(a);
                        if (null !== g) {
                            b.flags |= 128;
                            Xi(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            G(K, K.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && B() > aj && (b.flags |= 128, d = !0, Xi(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = Jh(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), Xi(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !I) return Q(b), null;
                    } else 2 * B() - f.renderingStartTime > aj && 1073741824 !== c && (b.flags |= 128, d = !0, Xi(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = B(), b.sibling = null, c = K.current, G(K, d ? c & 1 | 2 : c & 1), b;
            Q(b);
            return null;
        case 22:
        case 23:
            return bj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== (cj & 1073741824) && (Q(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : Q(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error(p(156, b.tag));
}
var dj = ta.ReactCurrentOwner, tg = !1;
function ej(a, b, c, d) {
    b.child = null === a ? zh(b, null, c, d) : yh(b, a.child, c, d);
}
function fj(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    sg(b, e);
    d = Uh(a, b, c, d, f, e);
    c = Zh();
    if (null !== a && !tg) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, gj(a, b, e);
    I && c && bh(b);
    b.flags |= 1;
    ej(a, b, d, e);
    return b.child;
}
function hj(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !ij(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, jj(a, b, f, d, e);
        a = vh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : He;
        if (c(g, d) && a.ref === b.ref) return gj(a, b, e);
    }
    b.flags |= 1;
    a = th(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function jj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if (He(f, d) && a.ref === b.ref) {
            if (tg = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && (tg = !0);
            else return b.lanes = a.lanes, gj(a, b, e);
        }
    }
    return kj(a, b, c, d, e);
}
function lj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, G(mj, cj), cj |= c;
        else if (0 !== (c & 1073741824)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, d = null !== f ? f.baseLanes : c, G(mj, cj), cj |= d;
        else return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
            baseLanes: a,
            cachePool: null,
            transitions: null
        }, b.updateQueue = null, G(mj, cj), cj |= a, null;
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, G(mj, cj), cj |= d;
    ej(a, b, e, c);
    return b.child;
}
function nj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function kj(a, b, c, d, e) {
    var f = Yf(c) ? Wf : H.current;
    f = Xf(b, f);
    sg(b, e);
    c = Uh(a, b, c, d, f, e);
    d = Zh();
    if (null !== a && !tg) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, gj(a, b, e);
    I && d && bh(b);
    b.flags |= 1;
    ej(a, b, c, e);
    return b.child;
}
function oj(a, b, c, d, e) {
    if (Yf(c)) {
        var f = !0;
        bg(b);
    } else f = !1;
    sg(b, e);
    if (null === b.stateNode) null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2), Og(b, c, d), Qg(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = ug(l) : (l = Yf(c) ? Wf : H.current, l = Xf(b, l));
        var n = c.getDerivedStateFromProps, u = "function" === typeof n || "function" === typeof g.getSnapshotBeforeUpdate;
        u || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && Pg(b, g, d, l);
        wg = !1;
        var q = b.memoizedState;
        g.state = q;
        Eg(b, d, g, e);
        k = b.memoizedState;
        h !== d || q !== k || Vf.current || wg ? ("function" === typeof n && (Ig(b, c, n, d), k = b.memoizedState), (h = wg || Ng(b, c, h, d, q, k, l)) ? (u || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        yg(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : kg(b.type, h);
        g.props = l;
        u = b.pendingProps;
        q = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = ug(k) : (k = Yf(c) ? Wf : H.current, k = Xf(b, k));
        var y = c.getDerivedStateFromProps;
        (n = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== u || q !== k) && Pg(b, g, d, k);
        wg = !1;
        q = b.memoizedState;
        g.state = q;
        Eg(b, d, g, e);
        var m = b.memoizedState;
        h !== u || q !== m || Vf.current || wg ? ("function" === typeof y && (Ig(b, c, y, d), m = b.memoizedState), (l = wg || Ng(b, c, l, d, q, m, k) || !1) ? (n || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, m, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, m, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && q === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && q === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = m), g.props = d, g.state = m, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && q === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && q === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return pj(a, b, c, d, f, e);
}
function pj(a, b, c, d, e, f) {
    nj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && cg(b, c, !1), gj(a, b, f);
    d = b.stateNode;
    dj.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = yh(b, a.child, null, f), b.child = yh(b, null, h, f)) : ej(a, b, h, f);
    b.memoizedState = d.state;
    e && cg(b, c, !0);
    return b.child;
}
function qj(a) {
    var b = a.stateNode;
    b.pendingContext ? $f(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $f(a, b.context, !1);
    Fh(a, b.containerInfo);
}
function rj(a, b, c, d, e) {
    nh();
    oh(e);
    b.flags |= 256;
    ej(a, b, c, d);
    return b.child;
}
var sj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function tj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function uj(a, b) {
    return {
        baseLanes: a.baseLanes | b,
        cachePool: null,
        transitions: a.transitions
    };
}
function vj(a, b, c) {
    var d = b.pendingProps, e = K.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    G(K, e & 1);
    if (null === a) {
        kh(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        e = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, e = {
            mode: "hidden",
            children: e
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = e) : f = wj(e, d, 0, null), a = xh(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = tj(c), b.memoizedState = sj, a) : xj(b, e);
    }
    e = a.memoizedState;
    if (null !== e) {
        h = e.dehydrated;
        if (null !== h) {
            if (g) {
                if (b.flags & 256) return b.flags &= -257, yj(a, b, c, Error(p(422)));
                if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
                f = d.fallback;
                e = b.mode;
                d = wj({
                    mode: "visible",
                    children: d.children
                }, e, 0, null);
                f = xh(f, e, c, null);
                f.flags |= 2;
                d.return = b;
                f.return = b;
                d.sibling = f;
                b.child = d;
                0 !== (b.mode & 1) && yh(b, a.child, null, c);
                b.child.memoizedState = tj(c);
                b.memoizedState = sj;
                return f;
            }
            if (0 === (b.mode & 1)) b = yj(a, b, c, null);
            else if ("$!" === h.data) b = yj(a, b, c, Error(p(419)));
            else if (d = 0 !== (c & a.childLanes), tg || d) {
                d = P;
                if (null !== d) {
                    switch(c & -c){
                        case 4:
                            f = 2;
                            break;
                        case 16:
                            f = 8;
                            break;
                        case 64:
                        case 128:
                        case 256:
                        case 512:
                        case 1024:
                        case 2048:
                        case 4096:
                        case 8192:
                        case 16384:
                        case 32768:
                        case 65536:
                        case 131072:
                        case 262144:
                        case 524288:
                        case 1048576:
                        case 2097152:
                        case 4194304:
                        case 8388608:
                        case 16777216:
                        case 33554432:
                        case 67108864:
                            f = 32;
                            break;
                        case 536870912:
                            f = 268435456;
                            break;
                        default:
                            f = 0;
                    }
                    d = 0 !== (f & (d.suspendedLanes | c)) ? 0 : f;
                    0 !== d && d !== e.retryLane && (e.retryLane = d, Lg(a, d, -1));
                }
                $i();
                b = yj(a, b, c, Error(p(421)));
            } else "$?" === h.data ? (b.flags |= 128, b.child = a.child, b = zj.bind(null, a), h._reactRetry = b, b = null) : (c = e.treeContext, eh = Kf(h.nextSibling), dh = b, I = !0, fh = null, null !== c && (Vg[Wg++] = Yg, Vg[Wg++] = Zg, Vg[Wg++] = Xg, Yg = c.id, Zg = c.overflow, Xg = b), b = xj(b, b.pendingProps.children), b.flags |= 4096);
            return b;
        }
        if (f) return d = Aj(a, b, d.children, d.fallback, c), f = b.child, e = a.child.memoizedState, f.memoizedState = null === e ? tj(c) : uj(e, c), f.childLanes = a.childLanes & ~c, b.memoizedState = sj, d;
        c = Bj(a, b, d.children, c);
        b.memoizedState = null;
        return c;
    }
    if (f) return d = Aj(a, b, d.children, d.fallback, c), f = b.child, e = a.child.memoizedState, f.memoizedState = null === e ? tj(c) : uj(e, c), f.childLanes = a.childLanes & ~c, b.memoizedState = sj, d;
    c = Bj(a, b, d.children, c);
    b.memoizedState = null;
    return c;
}
function xj(a, b) {
    b = wj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function Bj(a, b, c, d) {
    var e = a.child;
    a = e.sibling;
    c = th(e, {
        mode: "visible",
        children: c
    });
    0 === (b.mode & 1) && (c.lanes = d);
    c.return = b;
    c.sibling = null;
    null !== a && (d = b.deletions, null === d ? (b.deletions = [
        a
    ], b.flags |= 16) : d.push(a));
    return b.child = c;
}
function Aj(a, b, c, d, e) {
    var f = b.mode;
    a = a.child;
    var g = a.sibling, h = {
        mode: "hidden",
        children: c
    };
    0 === (f & 1) && b.child !== a ? (c = b.child, c.childLanes = 0, c.pendingProps = h, b.deletions = null) : (c = th(a, h), c.subtreeFlags = a.subtreeFlags & 14680064);
    null !== g ? d = th(g, d) : (d = xh(d, f, e, null), d.flags |= 2);
    d.return = b;
    c.return = b;
    c.sibling = d;
    b.child = c;
    return d;
}
function yj(a, b, c, d) {
    null !== d && oh(d);
    yh(b, a.child, null, c);
    a = xj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function Cj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    rg(a.return, b, c);
}
function Dj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function Ej(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    ej(a, b, d.children, c);
    d = K.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && Cj(a, c, b);
            else if (19 === a.tag) Cj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    G(K, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === Jh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            Dj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === Jh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            Dj(b, !0, c, null, f);
            break;
        case "together":
            Dj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function gj(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    Fg |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error(p(153));
    if (null !== b.child) {
        a = b.child;
        c = th(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = th(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function Fj(a, b, c) {
    switch(b.tag){
        case 3:
            qj(b);
            nh();
            break;
        case 5:
            Hh(b);
            break;
        case 1:
            Yf(b.type) && bg(b);
            break;
        case 4:
            Fh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            G(lg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return G(K, K.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return vj(a, b, c);
                G(K, K.current & 1);
                a = gj(a, b, c);
                return null !== a ? a.sibling : null;
            }
            G(K, K.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return Ej(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            G(K, K.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, lj(a, b, c);
    }
    return gj(a, b, c);
}
function Gj(a, b) {
    ch(b);
    switch(b.tag){
        case 1:
            return Yf(b.type) && Zf(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return Gh(), E(Vf), E(H), Lh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return Ih(b), null;
        case 13:
            E(K);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error(p(340));
                nh();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return E(K), null;
        case 4:
            return Gh(), null;
        case 10:
            return qg(b.type._context), null;
        case 22:
        case 23:
            return bj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var Hj = !1, S = !1, Ij = "function" === typeof WeakSet ? WeakSet : Set, T = null;
function Jj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            U(a, b, d);
        }
        else c.current = null;
    }
}
function Kj(a, b, c) {
    try {
        c();
    } catch (d) {
        U(a, b, d);
    }
}
var Lj = !1;
function Mj(a, b) {
    Bf = cd;
    a = Le();
    if (Me(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (Z) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, n = 0, u = a, q = null;
                b: for(;;){
                    for(var y;;){
                        u !== c || 0 !== e && 3 !== u.nodeType || (h = g + e);
                        u !== f || 0 !== d && 3 !== u.nodeType || (k = g + d);
                        3 === u.nodeType && (g += u.nodeValue.length);
                        if (null === (y = u.firstChild)) break;
                        q = u;
                        u = y;
                    }
                    for(;;){
                        if (u === a) break b;
                        q === c && ++l === e && (h = g);
                        q === f && ++n === d && (k = g);
                        if (null !== (y = u.nextSibling)) break;
                        u = q;
                        q = u.parentNode;
                    }
                    u = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    Cf = {
        focusedElem: a,
        selectionRange: c
    };
    cd = !1;
    for(T = b; null !== T;)if (b = T, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, T = a;
    else for(; null !== T;){
        b = T;
        try {
            var m = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== m) {
                        var w = m.memoizedProps, J = m.memoizedState, v = b.stateNode, x = v.getSnapshotBeforeUpdate(b.elementType === b.type ? w : kg(b.type, w), J);
                        v.__reactInternalSnapshotBeforeUpdate = x;
                    }
                    break;
                case 3:
                    var r = b.stateNode.containerInfo;
                    if (1 === r.nodeType) r.textContent = "";
                    else if (9 === r.nodeType) {
                        var F = r.body;
                        null != F && (F.textContent = "");
                    }
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error(p(163));
            }
        } catch (Z) {
            U(b, b.return, Z);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            T = a;
            break;
        }
        T = b.return;
    }
    m = Lj;
    Lj = !1;
    return m;
}
function Nj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && Kj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function Oj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function Pj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function Qj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, Qj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[Nf], delete b[Of], delete b[nf], delete b[Pf], delete b[Qf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function Rj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function Sj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || Rj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function Tj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = Af));
    else if (4 !== d && (a = a.child, null !== a)) for(Tj(a, b, c), a = a.sibling; null !== a;)Tj(a, b, c), a = a.sibling;
}
function Uj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for(Uj(a, b, c), a = a.sibling; null !== a;)Uj(a, b, c), a = a.sibling;
}
var V = null, Vj = !1;
function Wj(a, b, c) {
    for(c = c.child; null !== c;)Xj(a, b, c), c = c.sibling;
}
function Xj(a, b, c) {
    if (kc && "function" === typeof kc.onCommitFiberUnmount) try {
        kc.onCommitFiberUnmount(jc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            S || Jj(c, b);
        case 6:
            var d = V, e = Vj;
            V = null;
            Wj(a, b, c);
            V = d;
            Vj = e;
            null !== V && (Vj ? (a = V, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : V.removeChild(c.stateNode));
            break;
        case 18:
            null !== V && (Vj ? (a = V, c = c.stateNode, 8 === a.nodeType ? Jf(a.parentNode, c) : 1 === a.nodeType && Jf(a, c), ad(a)) : Jf(V, c.stateNode));
            break;
        case 4:
            d = V;
            e = Vj;
            V = c.stateNode.containerInfo;
            Vj = !0;
            Wj(a, b, c);
            V = d;
            Vj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!S && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? Kj(c, b, g) : 0 !== (f & 4) && Kj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            Wj(a, b, c);
            break;
        case 1:
            if (!S && (Jj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                U(c, b, h);
            }
            Wj(a, b, c);
            break;
        case 21:
            Wj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? (S = (d = S) || null !== c.memoizedState, Wj(a, b, c), S = d) : Wj(a, b, c);
            break;
        default:
            Wj(a, b, c);
    }
}
function Yj(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new Ij);
        b.forEach(function(b) {
            var d = Zj.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function ak(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        V = h.stateNode;
                        Vj = !1;
                        break a;
                    case 3:
                        V = h.stateNode.containerInfo;
                        Vj = !0;
                        break a;
                    case 4:
                        V = h.stateNode.containerInfo;
                        Vj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === V) throw Error(p(160));
            Xj(f, g, e);
            V = null;
            Vj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            U(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)bk(b, a), b = b.sibling;
}
function bk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            ak(b, a);
            ck(a);
            if (d & 4) {
                try {
                    Nj(3, a, a.return), Oj(3, a);
                } catch (m) {
                    U(a, a.return, m);
                }
                try {
                    Nj(5, a, a.return);
                } catch (m) {
                    U(a, a.return, m);
                }
            }
            break;
        case 1:
            ak(b, a);
            ck(a);
            d & 512 && null !== c && Jj(c, c.return);
            break;
        case 5:
            ak(b, a);
            ck(a);
            d & 512 && null !== c && Jj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    nb(e, "");
                } catch (m) {
                    U(a, a.return, m);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && Za(e, f);
                    ub(h, g);
                    var l = ub(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var n = k[g], u = k[g + 1];
                        "style" === n ? rb(e, u) : "dangerouslySetInnerHTML" === n ? mb(e, u) : "children" === n ? nb(e, u) : sa(e, n, u, l);
                    }
                    switch(h){
                        case "input":
                            $a(e, f);
                            break;
                        case "textarea":
                            hb(e, f);
                            break;
                        case "select":
                            var q = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? eb(e, !!f.multiple, y, !1) : q !== !!f.multiple && (null != f.defaultValue ? eb(e, !!f.multiple, f.defaultValue, !0) : eb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[Of] = f;
                } catch (m) {
                    U(a, a.return, m);
                }
            }
            break;
        case 6:
            ak(b, a);
            ck(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error(p(162));
                l = a.stateNode;
                n = a.memoizedProps;
                try {
                    l.nodeValue = n;
                } catch (m) {
                    U(a, a.return, m);
                }
            }
            break;
        case 3:
            ak(b, a);
            ck(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                ad(b.containerInfo);
            } catch (m) {
                U(a, a.return, m);
            }
            break;
        case 4:
            ak(b, a);
            ck(a);
            break;
        case 13:
            ak(b, a);
            ck(a);
            l = a.child;
            l.flags & 8192 && null !== l.memoizedState && (null === l.alternate || null === l.alternate.memoizedState) && (dk = B());
            d & 4 && Yj(a);
            break;
        case 22:
            l = null !== c && null !== c.memoizedState;
            a.mode & 1 ? (S = (n = S) || l, ak(b, a), S = n) : ak(b, a);
            ck(a);
            if (d & 8192) {
                n = null !== a.memoizedState;
                a: for(u = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === u) {
                            u = q;
                            try {
                                e = q.stateNode, n ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = qb("display", g));
                            } catch (m) {
                                U(a, a.return, m);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === u) try {
                            q.stateNode.nodeValue = n ? "" : q.memoizedProps;
                        } catch (m) {
                            U(a, a.return, m);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        u === q && (u = null);
                        q = q.return;
                    }
                    u === q && (u = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
                if (n && !l && 0 !== (a.mode & 1)) for(T = a, a = a.child; null !== a;){
                    for(l = T = a; null !== T;){
                        n = T;
                        u = n.child;
                        switch(n.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                Nj(4, n, n.return);
                                break;
                            case 1:
                                Jj(n, n.return);
                                f = n.stateNode;
                                if ("function" === typeof f.componentWillUnmount) {
                                    q = n;
                                    y = n.return;
                                    try {
                                        e = q, f.props = e.memoizedProps, f.state = e.memoizedState, f.componentWillUnmount();
                                    } catch (m) {
                                        U(q, y, m);
                                    }
                                }
                                break;
                            case 5:
                                Jj(n, n.return);
                                break;
                            case 22:
                                if (null !== n.memoizedState) {
                                    ek(l);
                                    continue;
                                }
                        }
                        null !== u ? (u.return = n, T = u) : ek(l);
                    }
                    a = a.sibling;
                }
            }
            break;
        case 19:
            ak(b, a);
            ck(a);
            d & 4 && Yj(a);
            break;
        case 21:
            break;
        default:
            ak(b, a), ck(a);
    }
}
function ck(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if (Rj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error(p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && (nb(e, ""), d.flags &= -33);
                    var f = Sj(a);
                    Uj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = Sj(a);
                    Tj(a, h, g);
                    break;
                default:
                    throw Error(p(161));
            }
        } catch (k) {
            U(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function fk(a, b, c) {
    T = a;
    gk(a, b, c);
}
function gk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== T;){
        var e = T, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || Hj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || S;
                h = Hj;
                var l = S;
                Hj = g;
                if ((S = k) && !l) for(T = e; null !== T;)g = T, k = g.child, 22 === g.tag && null !== g.memoizedState ? hk(e) : null !== k ? (k.return = g, T = k) : hk(e);
                for(; null !== f;)T = f, gk(f, b, c), f = f.sibling;
                T = e;
                Hj = h;
                S = l;
            }
            ik(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, T = f) : ik(a, b, c);
    }
}
function ik(a) {
    for(; null !== T;){
        var b = T;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        S || Oj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !S) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : kg(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && Gg(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            Gg(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var n = l.memoizedState;
                                if (null !== n) {
                                    var u = n.dehydrated;
                                    null !== u && ad(u);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                        break;
                    default:
                        throw Error(p(163));
                }
                S || b.flags & 512 && Pj(b);
            } catch (q) {
                U(b, b.return, q);
            }
        }
        if (b === a) {
            T = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            T = c;
            break;
        }
        T = b.return;
    }
}
function ek(a) {
    for(; null !== T;){
        var b = T;
        if (b === a) {
            T = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            T = c;
            break;
        }
        T = b.return;
    }
}
function hk(a) {
    for(; null !== T;){
        var b = T;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        Oj(4, b);
                    } catch (k) {
                        U(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            U(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        Pj(b);
                    } catch (k) {
                        U(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        Pj(b);
                    } catch (k) {
                        U(b, g, k);
                    }
            }
        } catch (k) {
            U(b, b.return, k);
        }
        if (b === a) {
            T = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            T = h;
            break;
        }
        T = b.return;
    }
}
var jk = Math.ceil, kk = ta.ReactCurrentDispatcher, lk = ta.ReactCurrentOwner, mk = ta.ReactCurrentBatchConfig, W = 0, P = null, X = null, Y = 0, cj = 0, mj = Tf(0), R = 0, nk = null, Fg = 0, ok = 0, pk = 0, qk = null, rk = null, dk = 0, aj = Infinity, sk = null, Li = !1, Mi = null, Oi = null, tk = !1, uk = null, vk = 0, wk = 0, xk = null, yk = -1, zk = 0;
function Jg() {
    return 0 !== (W & 6) ? B() : -1 !== yk ? yk : yk = B();
}
function Kg(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== (W & 2) && 0 !== Y) return Y & -Y;
    if (null !== jg.transition) return 0 === zk && (zk = xc()), zk;
    a = C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : id(a.type);
    return a;
}
function Lg(a, b, c) {
    if (50 < wk) throw wk = 0, xk = null, Error(p(185));
    var d = Ak(a, b);
    if (null === d) return null;
    zc(d, b, c);
    if (0 === (W & 2) || d !== P) d === P && (0 === (W & 2) && (ok |= b), 4 === R && Bk(d, Y)), Ck(d, c), 1 === b && 0 === W && 0 === (a.mode & 1) && (aj = B() + 500, eg && ig());
    return d;
}
function Ak(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
function Bg(a) {
    return (null !== P || null !== vg) && 0 !== (a.mode & 1) && 0 === (W & 2);
}
function Ck(a, b) {
    var c = a.callbackNode;
    vc(a, b);
    var d = tc(a, a === P ? Y : 0);
    if (0 === d) null !== c && ac(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && ac(c);
        if (1 === b) 0 === a.tag ? hg(Dk.bind(null, a)) : gg(Dk.bind(null, a)), If(function() {
            0 === W && ig();
        }), c = null;
        else {
            switch(Cc(d)){
                case 1:
                    c = ec;
                    break;
                case 4:
                    c = fc;
                    break;
                case 16:
                    c = gc;
                    break;
                case 536870912:
                    c = ic;
                    break;
                default:
                    c = gc;
            }
            c = Ek(c, Fk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function Fk(a, b) {
    yk = -1;
    zk = 0;
    if (0 !== (W & 6)) throw Error(p(327));
    var c = a.callbackNode;
    if (Gk() && a.callbackNode !== c) return null;
    var d = tc(a, a === P ? Y : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = Hk(a, d);
    else {
        b = d;
        var e = W;
        W |= 2;
        var f = Ik();
        if (P !== a || Y !== b) sk = null, aj = B() + 500, Jk(a, b);
        for(;;)try {
            Kk();
            break;
        } catch (h) {
            Lk(a, h);
        }
        pg();
        kk.current = f;
        W = e;
        null !== X ? b = 0 : (P = null, Y = 0, b = R);
    }
    if (0 !== b) {
        2 === b && (e = wc(a), 0 !== e && (d = e, b = Mk(a, e)));
        if (1 === b) throw c = nk, Jk(a, 0), Bk(a, d), Ck(a, B()), c;
        if (6 === b) Bk(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !Nk(e) && (b = Hk(a, d), 2 === b && (f = wc(a), 0 !== f && (d = f, b = Mk(a, f))), 1 === b)) throw c = nk, Jk(a, 0), Bk(a, d), Ck(a, B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error(p(345));
                case 2:
                    Ok(a, rk, sk);
                    break;
                case 3:
                    Bk(a, d);
                    if ((d & 130023424) === d && (b = dk + 500 - B(), 10 < b)) {
                        if (0 !== tc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            Jg();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = Ef(Ok.bind(null, a, rk, sk), b);
                        break;
                    }
                    Ok(a, rk, sk);
                    break;
                case 4:
                    Bk(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - nc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * jk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = Ef(Ok.bind(null, a, rk, sk), d);
                        break;
                    }
                    Ok(a, rk, sk);
                    break;
                case 5:
                    Ok(a, rk, sk);
                    break;
                default:
                    throw Error(p(329));
            }
        }
    }
    Ck(a, B());
    return a.callbackNode === c ? Fk.bind(null, a) : null;
}
function Mk(a, b) {
    var c = qk;
    a.current.memoizedState.isDehydrated && (Jk(a, b).flags |= 256);
    a = Hk(a, b);
    2 !== a && (b = rk, rk = c, null !== b && Zi(b));
    return a;
}
function Zi(a) {
    null === rk ? rk = a : rk.push.apply(rk, a);
}
function Nk(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!Ge(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function Bk(a, b) {
    b &= ~pk;
    b &= ~ok;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - nc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function Dk(a) {
    if (0 !== (W & 6)) throw Error(p(327));
    Gk();
    var b = tc(a, 0);
    if (0 === (b & 1)) return Ck(a, B()), null;
    var c = Hk(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = wc(a);
        0 !== d && (b = d, c = Mk(a, d));
    }
    if (1 === c) throw c = nk, Jk(a, 0), Bk(a, b), Ck(a, B()), c;
    if (6 === c) throw Error(p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    Ok(a, rk, sk);
    Ck(a, B());
    return null;
}
function Pk(a, b) {
    var c = W;
    W |= 1;
    try {
        return a(b);
    } finally{
        W = c, 0 === W && (aj = B() + 500, eg && ig());
    }
}
function Qk(a) {
    null !== uk && 0 === uk.tag && 0 === (W & 6) && Gk();
    var b = W;
    W |= 1;
    var c = mk.transition, d = C;
    try {
        if (mk.transition = null, C = 1, a) return a();
    } finally{
        C = d, mk.transition = c, W = b, 0 === (W & 6) && ig();
    }
}
function bj() {
    cj = mj.current;
    E(mj);
}
function Jk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, Ff(c));
    if (null !== X) for(c = X.return; null !== c;){
        var d = c;
        ch(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && Zf();
                break;
            case 3:
                Gh();
                E(Vf);
                E(H);
                Lh();
                break;
            case 5:
                Ih(d);
                break;
            case 4:
                Gh();
                break;
            case 13:
                E(K);
                break;
            case 19:
                E(K);
                break;
            case 10:
                qg(d.type._context);
                break;
            case 22:
            case 23:
                bj();
        }
        c = c.return;
    }
    P = a;
    X = a = th(a.current, null);
    Y = cj = b;
    R = 0;
    nk = null;
    pk = ok = Fg = 0;
    rk = qk = null;
    if (null !== vg) {
        for(b = 0; b < vg.length; b++)if (c = vg[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        vg = null;
    }
    return a;
}
function Lk(a, b) {
    do {
        var c = X;
        try {
            pg();
            Mh.current = Yh;
            if (Ph) {
                for(var d = L.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                Ph = !1;
            }
            Oh = 0;
            N = M = L = null;
            Qh = !1;
            Rh = 0;
            lk.current = null;
            if (null === c || null === c.return) {
                R = 1;
                nk = b;
                X = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = Y;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, n = h, u = n.tag;
                    if (0 === (n.mode & 1) && (0 === u || 11 === u || 15 === u)) {
                        var q = n.alternate;
                        q ? (n.updateQueue = q.updateQueue, n.memoizedState = q.memoizedState, n.lanes = q.lanes) : (n.updateQueue = null, n.memoizedState = null);
                    }
                    var y = Ri(g);
                    if (null !== y) {
                        y.flags &= -257;
                        Si(y, g, h, f, b);
                        y.mode & 1 && Pi(f, l, b);
                        b = y;
                        k = l;
                        var m = b.updateQueue;
                        if (null === m) {
                            var w = new Set;
                            w.add(k);
                            b.updateQueue = w;
                        } else m.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            Pi(f, l, b);
                            $i();
                            break a;
                        }
                        k = Error(p(426));
                    }
                } else if (I && h.mode & 1) {
                    var J = Ri(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        Si(J, g, h, f, b);
                        oh(k);
                        break a;
                    }
                }
                f = k;
                4 !== R && (R = 2);
                null === qk ? qk = [
                    f
                ] : qk.push(f);
                k = Hi(k, h);
                h = g;
                do {
                    switch(h.tag){
                        case 3:
                            h.flags |= 65536;
                            b &= -b;
                            h.lanes |= b;
                            var v = Ki(h, k, b);
                            Dg(h, v);
                            break a;
                        case 1:
                            f = k;
                            var x = h.type, r = h.stateNode;
                            if (0 === (h.flags & 128) && ("function" === typeof x.getDerivedStateFromError || null !== r && "function" === typeof r.componentDidCatch && (null === Oi || !Oi.has(r)))) {
                                h.flags |= 65536;
                                b &= -b;
                                h.lanes |= b;
                                var F = Ni(h, f, b);
                                Dg(h, F);
                                break a;
                            }
                    }
                    h = h.return;
                }while (null !== h);
            }
            Rk(c);
        } catch (Z) {
            b = Z;
            X === c && null !== c && (X = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function Ik() {
    var a = kk.current;
    kk.current = Yh;
    return null === a ? Yh : a;
}
function $i() {
    if (0 === R || 3 === R || 2 === R) R = 4;
    null === P || 0 === (Fg & 268435455) && 0 === (ok & 268435455) || Bk(P, Y);
}
function Hk(a, b) {
    var c = W;
    W |= 2;
    var d = Ik();
    if (P !== a || Y !== b) sk = null, Jk(a, b);
    for(;;)try {
        Sk();
        break;
    } catch (e) {
        Lk(a, e);
    }
    pg();
    W = c;
    kk.current = d;
    if (null !== X) throw Error(p(261));
    P = null;
    Y = 0;
    return R;
}
function Sk() {
    for(; null !== X;)Tk(X);
}
function Kk() {
    for(; null !== X && !bc();)Tk(X);
}
function Tk(a) {
    var b = Uk(a.alternate, a, cj);
    a.memoizedProps = a.pendingProps;
    null === b ? Rk(a) : X = b;
    lk.current = null;
}
function Rk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = Yi(c, b, cj), null !== c) {
                X = c;
                return;
            }
        } else {
            c = Gj(c, b);
            if (null !== c) {
                c.flags &= 32767;
                X = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                R = 6;
                X = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            X = b;
            return;
        }
        X = b = a;
    }while (null !== b);
    0 === R && (R = 5);
}
function Ok(a, b, c) {
    var d = C, e = mk.transition;
    try {
        mk.transition = null, C = 1, Vk(a, b, c, d);
    } finally{
        mk.transition = e, C = d;
    }
    return null;
}
function Vk(a, b, c, d) {
    do Gk();
    while (null !== uk);
    if (0 !== (W & 6)) throw Error(p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error(p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    Ac(a, f);
    a === P && (X = P = null, Y = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || tk || (tk = !0, Ek(gc, function() {
        Gk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = mk.transition;
        mk.transition = null;
        var g = C;
        C = 1;
        var h = W;
        W |= 4;
        lk.current = null;
        Mj(a, c);
        bk(c, a);
        Ne(Cf);
        cd = !!Bf;
        Cf = Bf = null;
        a.current = c;
        fk(c, a, e);
        cc();
        W = h;
        C = g;
        mk.transition = f;
    } else a.current = c;
    tk && (tk = !1, uk = a, vk = e);
    f = a.pendingLanes;
    0 === f && (Oi = null);
    lc(c.stateNode, d);
    Ck(a, B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)d(b[c]);
    if (Li) throw Li = !1, a = Mi, Mi = null, a;
    0 !== (vk & 1) && 0 !== a.tag && Gk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === xk ? wk++ : (wk = 0, xk = a) : wk = 0;
    ig();
    return null;
}
function Gk() {
    if (null !== uk) {
        var a = Cc(vk), b = mk.transition, c = C;
        try {
            mk.transition = null;
            C = 16 > a ? 16 : a;
            if (null === uk) var d = !1;
            else {
                a = uk;
                uk = null;
                vk = 0;
                if (0 !== (W & 6)) throw Error(p(331));
                var e = W;
                W |= 4;
                for(T = a.current; null !== T;){
                    var f = T, g = f.child;
                    if (0 !== (T.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for(T = l; null !== T;){
                                    var n = T;
                                    switch(n.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            Nj(8, n, f);
                                    }
                                    var u = n.child;
                                    if (null !== u) u.return = n, T = u;
                                    else for(; null !== T;){
                                        n = T;
                                        var q = n.sibling, y = n.return;
                                        Qj(n);
                                        if (n === l) {
                                            T = null;
                                            break;
                                        }
                                        if (null !== q) {
                                            q.return = y;
                                            T = q;
                                            break;
                                        }
                                        T = y;
                                    }
                                }
                            }
                            var m = f.alternate;
                            if (null !== m) {
                                var w = m.child;
                                if (null !== w) {
                                    m.child = null;
                                    do {
                                        var J = w.sibling;
                                        w.sibling = null;
                                        w = J;
                                    }while (null !== w);
                                }
                            }
                            T = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, T = g;
                    else b: for(; null !== T;){
                        f = T;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                Nj(9, f, f.return);
                        }
                        var v = f.sibling;
                        if (null !== v) {
                            v.return = f.return;
                            T = v;
                            break b;
                        }
                        T = f.return;
                    }
                }
                var x = a.current;
                for(T = x; null !== T;){
                    g = T;
                    var r = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== r) r.return = g, T = r;
                    else b: for(g = x; null !== T;){
                        h = T;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    Oj(9, h);
                            }
                        } catch (Z) {
                            U(h, h.return, Z);
                        }
                        if (h === g) {
                            T = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            T = F;
                            break b;
                        }
                        T = h.return;
                    }
                }
                W = e;
                ig();
                if (kc && "function" === typeof kc.onPostCommitFiberRoot) try {
                    kc.onPostCommitFiberRoot(jc, a);
                } catch (Z) {}
                d = !0;
            }
            return d;
        } finally{
            C = c, mk.transition = b;
        }
    }
    return !1;
}
function Wk(a, b, c) {
    b = Hi(c, b);
    b = Ki(a, b, 1);
    Ag(a, b);
    b = Jg();
    a = Ak(a, 1);
    null !== a && (zc(a, 1, b), Ck(a, b));
}
function U(a, b, c) {
    if (3 === a.tag) Wk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            Wk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === Oi || !Oi.has(d))) {
                a = Hi(c, a);
                a = Ni(b, a, 1);
                Ag(b, a);
                a = Jg();
                b = Ak(b, 1);
                null !== b && (zc(b, 1, a), Ck(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function Qi(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = Jg();
    a.pingedLanes |= a.suspendedLanes & c;
    P === a && (Y & c) === c && (4 === R || 3 === R && (Y & 130023424) === Y && 500 > B() - dk ? Jk(a, 0) : pk |= c);
    Ck(a, b);
}
function Xk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = rc, rc <<= 1, 0 === (rc & 130023424) && (rc = 4194304)));
    var c = Jg();
    a = Ak(a, b);
    null !== a && (zc(a, b, c), Ck(a, c));
}
function zj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    Xk(a, c);
}
function Zj(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error(p(314));
    }
    null !== d && d.delete(b);
    Xk(a, c);
}
var Uk;
Uk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || Vf.current) tg = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return tg = !1, Fj(a, b, c);
            tg = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else tg = !1, I && 0 !== (b.flags & 1048576) && ah(b, Ug, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
            a = b.pendingProps;
            var e = Xf(b, H.current);
            sg(b, c);
            e = Uh(null, b, d, a, e, c);
            var f = Zh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, Yf(d) ? (f = !0, bg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, xg(b), e.updater = Mg, b.stateNode = e, e._reactInternals = b, Qg(b, d, a, c), b = pj(null, b, d, !0, f, c)) : (b.tag = 0, I && f && bh(b), ej(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = Yk(d);
                a = kg(d, a);
                switch(e){
                    case 0:
                        b = kj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = oj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = fj(null, b, d, a, c);
                        break a;
                    case 14:
                        b = hj(null, b, d, kg(d.type, a), c);
                        break a;
                }
                throw Error(p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : kg(d, e), kj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : kg(d, e), oj(a, b, d, e, c);
        case 3:
            a: {
                qj(b);
                if (null === a) throw Error(p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                yg(a, b);
                Eg(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = Error(p(423));
                        b = rj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = Error(p(424));
                        b = rj(a, b, d, c, e);
                        break a;
                    } else for(eh = Kf(b.stateNode.containerInfo.firstChild), dh = b, I = !0, fh = null, c = zh(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    nh();
                    if (d === e) {
                        b = gj(a, b, c);
                        break a;
                    }
                    ej(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return Hh(b), null === a && kh(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, Df(d, e) ? g = null : null !== f && Df(d, f) && (b.flags |= 32), nj(a, b), ej(a, b, g, c), b.child;
        case 6:
            return null === a && kh(b), null;
        case 13:
            return vj(a, b, c);
        case 4:
            return Fh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = yh(b, null, d, c) : ej(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : kg(d, e), fj(a, b, d, e, c);
        case 7:
            return ej(a, b, b.pendingProps, c), b.child;
        case 8:
            return ej(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return ej(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                G(lg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if (Ge(f.value, g)) {
                        if (f.children === e.children && !Vf.current) {
                            b = gj(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = zg(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var n = l.pending;
                                            null === n ? k.next = k : (k.next = n.next, n.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    rg(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error(p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            rg(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                ej(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, sg(b, c), e = ug(e), d = d(e), b.flags |= 1, ej(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = kg(d, b.pendingProps), e = kg(d.type, e), hj(a, b, d, e, c);
        case 15:
            return jj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : kg(d, e), null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2), b.tag = 1, Yf(d) ? (a = !0, bg(b)) : a = !1, sg(b, c), Og(b, d, e), Qg(b, d, e, c), pj(null, b, d, !0, a, c);
        case 19:
            return Ej(a, b, c);
        case 22:
            return lj(a, b, c);
    }
    throw Error(p(156, b.tag));
};
function Ek(a, b) {
    return $b(a, b);
}
function Zk(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function hh(a, b, c, d) {
    return new Zk(a, b, c, d);
}
function ij(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function Yk(a) {
    if ("function" === typeof a) return ij(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === Ca) return 11;
        if (a === Fa) return 14;
    }
    return 2;
}
function th(a, b) {
    var c = a.alternate;
    null === c ? (c = hh(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function vh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) ij(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case wa:
            return xh(c.children, e, f, b);
        case xa:
            g = 8;
            e |= 8;
            break;
        case za:
            return a = hh(12, c, b, e | 2), a.elementType = za, a.lanes = f, a;
        case Da:
            return a = hh(13, c, b, e), a.elementType = Da, a.lanes = f, a;
        case Ea:
            return a = hh(19, c, b, e), a.elementType = Ea, a.lanes = f, a;
        case Ha:
            return wj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case Aa:
                    g = 10;
                    break a;
                case Ba:
                    g = 9;
                    break a;
                case Ca:
                    g = 11;
                    break a;
                case Fa:
                    g = 14;
                    break a;
                case Ga:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error(p(130, null == a ? a : typeof a, ""));
    }
    b = hh(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function xh(a, b, c, d) {
    a = hh(7, a, d, b);
    a.lanes = c;
    return a;
}
function wj(a, b, c, d) {
    a = hh(22, a, d, b);
    a.elementType = Ha;
    a.lanes = c;
    a.stateNode = {};
    return a;
}
function uh(a, b, c) {
    a = hh(6, a, null, b);
    a.lanes = c;
    return a;
}
function wh(a, b, c) {
    b = hh(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $k(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = yc(0);
    this.expirationTimes = yc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = yc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function al(a, b, c, d, e, f, g, h, k) {
    a = new $k(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = hh(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    xg(f);
    return a;
}
function bl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: va,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function cl(a) {
    if (!a) return Uf;
    a = a._reactInternals;
    a: {
        if (Ub(a) !== a || 1 !== a.tag) throw Error(p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if (Yf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error(p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if (Yf(c)) return ag(a, c, b);
    }
    return b;
}
function dl(a, b, c, d, e, f, g, h, k) {
    a = al(c, d, !0, a, e, f, g, h, k);
    a.context = cl(null);
    c = a.current;
    d = Jg();
    e = Kg(c);
    f = zg(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    Ag(c, f);
    a.current.lanes = e;
    zc(a, e, d);
    Ck(a, d);
    return a;
}
function el(a, b, c, d) {
    var e = b.current, f = Jg(), g = Kg(e);
    c = cl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = zg(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    Ag(e, b);
    a = Lg(e, g, f);
    null !== a && Cg(a, e, g);
    return g;
}
function fl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function gl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function hl(a, b) {
    gl(a, b);
    (a = a.alternate) && gl(a, b);
}
function il() {
    return null;
}
var jl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function kl(a) {
    this._internalRoot = a;
}
ll.prototype.render = kl.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error(p(409));
    el(a, b, null, null);
};
ll.prototype.unmount = kl.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        Qk(function() {
            el(null, a, null, null);
        });
        b[tf] = null;
    }
};
function ll(a) {
    this._internalRoot = a;
}
ll.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = Gc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < Pc.length && 0 !== b && b < Pc[c].priority; c++);
        Pc.splice(c, 0, a);
        0 === c && Uc(a);
    }
};
function ml(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function ol() {}
function pl(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = fl(g);
                f.call(a);
            };
        }
        var g = dl(b, d, a, 0, null, !1, !1, "", ol);
        a._reactRootContainer = g;
        a[tf] = g.current;
        rf(8 === a.nodeType ? a.parentNode : a);
        Qk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = fl(k);
            h.call(a);
        };
    }
    var k = al(a, 0, !1, null, null, !1, !1, "", ol);
    a._reactRootContainer = k;
    a[tf] = k.current;
    rf(8 === a.nodeType ? a.parentNode : a);
    Qk(function() {
        el(b, k, c, d);
    });
    return k;
}
function ql(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = fl(g);
                h.call(a);
            };
        }
        el(b, g, a, e);
    } else g = pl(c, b, a, e, d);
    return fl(g);
}
Dc = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = sc(b.pendingLanes);
                0 !== c && (Bc(b, c | 1), Ck(b, B()), 0 === (W & 6) && (aj = B() + 500, ig()));
            }
            break;
        case 13:
            var d = Jg();
            Qk(function() {
                return Lg(a, 1, d);
            });
            hl(a, 1);
    }
};
Ec = function(a) {
    if (13 === a.tag) {
        var b = Jg();
        Lg(a, 134217728, b);
        hl(a, 134217728);
    }
};
Fc = function(a) {
    if (13 === a.tag) {
        var b = Jg(), c = Kg(a);
        Lg(a, c, b);
        hl(a, c);
    }
};
Gc = function() {
    return C;
};
Hc = function(a, b) {
    var c = C;
    try {
        return C = a, b();
    } finally{
        C = c;
    }
};
xb = function(a, b, c) {
    switch(b){
        case "input":
            $a(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = Cb(d);
                        if (!e) throw Error(p(90));
                        Va(d);
                        $a(d, e);
                    }
                }
            }
            break;
        case "textarea":
            hb(a, c);
            break;
        case "select":
            b = c.value, null != b && eb(a, !!c.multiple, b, !1);
    }
};
Fb = Pk;
Gb = Qk;
var rl = {
    usingClientEntryPoint: !1,
    Events: [
        Bb,
        te,
        Cb,
        Db,
        Eb,
        Pk
    ]
}, sl = {
    findFiberByHostInstance: Vc,
    bundleType: 0,
    version: "18.1.0",
    rendererPackageName: "react-dom"
};
var tl = {
    bundleType: sl.bundleType,
    version: sl.version,
    rendererPackageName: sl.rendererPackageName,
    rendererConfig: sl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: ta.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = Yb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: sl.findFiberByHostInstance || il,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.1.0-next-22edb9f77-20220426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var ul = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!ul.isDisabled && ul.supportsFiber) try {
        jc = ul.inject(tl), kc = ul;
    } catch (a) {}
}
exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = rl;
exports.createPortal = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!ml(b)) throw Error(p(200));
    return bl(a, b, null, c);
};
exports.createRoot = function(a, b) {
    if (!ml(a)) throw Error(p(299));
    var c = !1, d = "", e = jl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = al(a, 1, !1, null, null, c, !1, d, e);
    a[tf] = b.current;
    rf(8 === a.nodeType ? a.parentNode : a);
    return new kl(b);
};
exports.findDOMNode = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error(p(188));
        a = Object.keys(a).join(",");
        throw Error(p(268, a));
    }
    a = Yb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
exports.flushSync = function(a) {
    return Qk(a);
};
exports.hydrate = function(a, b, c) {
    if (!nl(b)) throw Error(p(200));
    return ql(null, a, b, !0, c);
};
exports.hydrateRoot = function(a, b, c) {
    if (!ml(a)) throw Error(p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = jl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = dl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[tf] = b.current;
    rf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new ll(b);
};
exports.render = function(a, b, c) {
    if (!nl(b)) throw Error(p(200));
    return ql(null, a, b, !1, c);
};
exports.unmountComponentAtNode = function(a) {
    if (!nl(a)) throw Error(p(40));
    return a._reactRootContainer ? (Qk(function() {
        ql(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[tf] = null;
        });
    }), !0) : !1;
};
exports.unstable_batchedUpdates = Pk;
exports.unstable_renderSubtreeIntoContainer = function(a, b, c, d) {
    if (!nl(c)) throw Error(p(200));
    if (null == a || void 0 === a._reactInternals) throw Error(p(38));
    return ql(a, b, c, !1, d);
};
exports.version = "18.1.0-next-22edb9f77-20220426";

},{"5393afc8c463ef07":"9yzVZ","ece50e903283a22f":"e37qW"}],"e37qW":[function(require,module,exports) {
"use strict";
module.exports = require("62f08acde0c8aa34");

},{"62f08acde0c8aa34":"hDzhf"}],"hDzhf":[function(require,module,exports) {
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
function f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function h(a) {
    return 0 === a.length ? null : a[0];
}
function k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > g(C, c)) n < e && 0 > g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var l = performance;
    exports.unstable_now = function() {
        return l.now();
    };
} else {
    var p = Date, q = p.now();
    exports.unstable_now = function() {
        return p.now() - q;
    };
}
var r = [], t = [], u = 1, v = null, y = 3, z = !1, A = !1, B = !1, D = "function" === typeof setTimeout ? setTimeout : null, E = "function" === typeof clearTimeout ? clearTimeout : null, F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function G(a) {
    for(var b = h(t); null !== b;){
        if (null === b.callback) k(t);
        else if (b.startTime <= a) k(t), b.sortIndex = b.expirationTime, f(r, b);
        else break;
        b = h(t);
    }
}
function H(a) {
    B = !1;
    G(a);
    if (!A) {
        if (null !== h(r)) A = !0, I(J);
        else {
            var b = h(t);
            null !== b && K(H, b.startTime - a);
        }
    }
}
function J(a, b) {
    A = !1;
    B && (B = !1, E(L), L = -1);
    z = !0;
    var c = y;
    try {
        G(b);
        for(v = h(r); null !== v && (!(v.expirationTime > b) || a && !M());){
            var d = v.callback;
            if ("function" === typeof d) {
                v.callback = null;
                y = v.priorityLevel;
                var e = d(v.expirationTime <= b);
                b = exports.unstable_now();
                "function" === typeof e ? v.callback = e : v === h(r) && k(r);
                G(b);
            } else k(r);
            v = h(r);
        }
        if (null !== v) var w = !0;
        else {
            var m = h(t);
            null !== m && K(H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        v = null, y = c, z = !1;
    }
}
var N = !1, O = null, L = -1, P = 5, Q = -1;
function M() {
    return exports.unstable_now() - Q < P ? !1 : !0;
}
function R() {
    if (null !== O) {
        var a = exports.unstable_now();
        Q = a;
        var b = !0;
        try {
            b = O(!0, a);
        } finally{
            b ? S() : (N = !1, O = null);
        }
    } else N = !1;
}
var S;
if ("function" === typeof F) S = function() {
    F(R);
};
else if ("undefined" !== typeof MessageChannel) {
    var T = new MessageChannel, U = T.port2;
    T.port1.onmessage = R;
    S = function() {
        U.postMessage(null);
    };
} else S = function() {
    D(R, 0);
};
function I(a) {
    O = a;
    N || (N = !0, S());
}
function K(a, b) {
    L = D(function() {
        a(exports.unstable_now());
    }, b);
}
exports.unstable_IdlePriority = 5;
exports.unstable_ImmediatePriority = 1;
exports.unstable_LowPriority = 4;
exports.unstable_NormalPriority = 3;
exports.unstable_Profiling = null;
exports.unstable_UserBlockingPriority = 2;
exports.unstable_cancelCallback = function(a) {
    a.callback = null;
};
exports.unstable_continueExecution = function() {
    A || z || (A = !0, I(J));
};
exports.unstable_forceFrameRate = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : P = 0 < a ? Math.floor(1E3 / a) : 5;
};
exports.unstable_getCurrentPriorityLevel = function() {
    return y;
};
exports.unstable_getFirstCallbackNode = function() {
    return h(r);
};
exports.unstable_next = function(a) {
    switch(y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = y;
    }
    var c = y;
    y = b;
    try {
        return a();
    } finally{
        y = c;
    }
};
exports.unstable_pauseExecution = function() {};
exports.unstable_requestPaint = function() {};
exports.unstable_runWithPriority = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = y;
    y = a;
    try {
        return b();
    } finally{
        y = c;
    }
};
exports.unstable_scheduleCallback = function(a, b, c) {
    var d = exports.unstable_now();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, f(t, a), null === h(r) && a === h(t) && (B ? (E(L), L = -1) : B = !0, K(H, c - d))) : (a.sortIndex = e, f(r, a), A || z || (A = !0, I(J)));
    return a;
};
exports.unstable_shouldYield = M;
exports.unstable_wrapCallback = function(a) {
    var b = y;
    return function() {
        var c = y;
        y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            y = c;
        }
    };
};

},{}],"iKqHu":[function(require,module,exports) {
module.exports = require("44ed71e83d82adaa")(require("a11858878e94bbf1").resolve("46sOt")).then(()=>module.bundle.root("gtEzC"));

},{"44ed71e83d82adaa":"egp6W","a11858878e94bbf1":"f7Lf0"}],"lv28k":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/** Function that sets the globalConfig of your storybook. The global config is the preview module of your .storybook folder.
 *
 * It should be run a single time, so that your global config (e.g. decorators) is applied to your stories when using `composeStories` or `composeStory`.
 *
 * Example:
 *```jsx
 * // setup.js (for jest)
 * import { setProjectAnnotations } from '@storybook/react';
 * import * as projectAnnotations from './.storybook/preview';
 *
 * setProjectAnnotations(projectAnnotations);
 *```
 *
 * @param projectAnnotations - e.g. (import * as projectAnnotations from '../.storybook/preview')
 */ parcelHelpers.export(exports, "setProjectAnnotations", ()=>setProjectAnnotations);
/** Preserved for users migrating from `@storybook/testing-react`.
 *
 * @deprecated Use setProjectAnnotations instead
 */ parcelHelpers.export(exports, "setGlobalConfig", ()=>setGlobalConfig) // This will not be necessary once we have auto preset loading
;
/**
 * Function that will receive a story along with meta (e.g. a default export from a .stories file)
 * and optionally projectAnnotations e.g. (import * from '../.storybook/preview)
 * and will return a composed component that has all args/parameters/decorators/etc combined and applied to it.
 *
 *
 * It's very useful for reusing a story in scenarios outside of Storybook like unit testing.
 *
 * Example:
 *```jsx
 * import { render } from '@testing-library/react';
 * import { composeStory } from '@storybook/react';
 * import Meta, { Primary as PrimaryStory } from './Button.stories';
 *
 * const Primary = composeStory(PrimaryStory, Meta);
 *
 * test('renders primary button with Hello World', () => {
 *   const { getByText } = render(<Primary>Hello world</Primary>);
 *   expect(getByText(/Hello world/i)).not.toBeNull();
 * });
 *```
 *
 * @param story
 * @param componentAnnotations - e.g. (import Meta from './Button.stories')
 * @param [projectAnnotations] - e.g. (import * as projectAnnotations from '../.storybook/preview') this can be applied automatically if you use `setProjectAnnotations` in your setup files.
 * @param [exportsName] - in case your story does not contain a name and you want it to have a name.
 */ parcelHelpers.export(exports, "composeStory", ()=>composeStory);
/**
 * Function that will receive a stories import (e.g. `import * as stories from './Button.stories'`)
 * and optionally projectAnnotations (e.g. `import * from '../.storybook/preview`)
 * and will return an object containing all the stories passed, but now as a composed component that has all args/parameters/decorators/etc combined and applied to it.
 *
 *
 * It's very useful for reusing stories in scenarios outside of Storybook like unit testing.
 *
 * Example:
 *```jsx
 * import { render } from '@testing-library/react';
 * import { composeStories } from '@storybook/react';
 * import * as stories from './Button.stories';
 *
 * const { Primary, Secondary } = composeStories(stories);
 *
 * test('renders primary button with Hello World', () => {
 *   const { getByText } = render(<Primary>Hello world</Primary>);
 *   expect(getByText(/Hello world/i)).not.toBeNull();
 * });
 *```
 *
 * @param csfExports - e.g. (import * as stories from './Button.stories')
 * @param [projectAnnotations] - e.g. (import * as projectAnnotations from '../.storybook/preview') this can be applied automatically if you use `setProjectAnnotations` in your setup files.
 */ parcelHelpers.export(exports, "composeStories", ()=>composeStories);
var _store = require("@storybook/store");
var _clientLogger = require("@storybook/client-logger");
var _render = require("../preview/render");
function setProjectAnnotations(projectAnnotations) {
    (0, _store.setProjectAnnotations)(projectAnnotations);
}
function setGlobalConfig(projectAnnotations) {
    (0, _clientLogger.once).warn("setGlobalConfig is deprecated. Use setProjectAnnotations instead.");
    setProjectAnnotations(projectAnnotations);
}
var defaultProjectAnnotations = {
    render: (0, _render.render)
};
function composeStory(story, componentAnnotations, projectAnnotations, exportsName) {
    return (0, _store.composeStory)(story, componentAnnotations, projectAnnotations, defaultProjectAnnotations, exportsName);
}
function composeStories(csfExports, projectAnnotations) {
    var composedStories = (0, _store.composeStories)(csfExports, projectAnnotations, composeStory);
    return composedStories;
}

},{"@storybook/store":"26Xer","@storybook/client-logger":"iGRus","../preview/render":"bkYMe","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"d7CgP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _types60 = require("./types-6-0");
parcelHelpers.exportAll(_types60, exports);

},{"./types-6-0":"jmyb0","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"jmyb0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"iAOb7":[function(require,module,exports) {
const _temp0 = require("d8376f1c30f5adc7");
const _temp1 = require("bbdfce5334830240");
const _temp2 = require("5b9580b3bb87abc8");
const _temp3 = require("f8a840053eea32f2");
const _temp4 = require("d71915981c3d9247");
const _temp5 = require("4c2f5a219a675784");
const _temp6 = require("1171d1b3bae2b120");
const _temp7 = require("7d62e9b896c4fe6d");
const _temp8 = require("ecc93a9becf8ed04");
const _temp9 = require("b7375ad4f9547f3d");
const _temp10 = require("1ad263d6edfcc155");
const _temp11 = require("48cacb539d7a82d9");
const _temp12 = require("7d4454f248e4dbc3");
const _temp13 = require("33897a7da9719cc8");
const _temp14 = require("d8980b07f9d28f23");
const _temp15 = require("6a84b7b380f927a3");
const _temp16 = require("cee0d43ab434fe57");
const _temp17 = require("c2beaf2a6d197107");
const _temp18 = require("9afccdd70f898c5b");
const _temp19 = require("6e242b84d2d1cb8");
const _temp20 = require("fdb8b761d62d4964");
const _temp21 = require("5a30c288f69a1884");
const _temp22 = require("363445e62110c83e");
const _temp23 = require("b2e5b8177142b647");
const _temp24 = require("304b286f6d3e2156");
const _temp25 = require("776c5c5436adb654");
const _temp26 = require("98cd83991097adda");
const _temp27 = require("d3e45c02df48a83a");
const _temp28 = require("590942dd16be2b72");
const _temp29 = require("6f95a2a440814dd4");
const _temp30 = require("47ac3c201bef59a0");
const _temp31 = require("d0f532a7252c4a90");
const _temp32 = require("382b22fc74f721d6");
const _temp33 = require("84fdb981b536cc22");
const _temp34 = require("147780957a918b12");
const _temp35 = require("4156aed1b5757c3e");
const _temp36 = require("e64547a9afbbb466");
const _temp37 = require("f8d9f0ec05cc0a6");
const _temp38 = require("ee86c8f154fbbf37");
const _temp39 = require("1974ecc17b3016a2");
const _temp40 = require("cce57b33974b23ef");
const _temp41 = require("132b2d30d6502a86");
const _temp42 = require("a9a7da78c6ebacfa");
const _temp43 = require("d30f9b5cc0933cc1");
const _temp44 = require("4e3a4a915aff06ad");
const _temp45 = require("d759af0c2b8ba25a");
const _temp46 = require("c05de7820d294953");
const _temp47 = require("2632f4d3a03105ff");
const _temp48 = require("28fd440f4cedc74e");
const _temp49 = require("73ce9831f4f59544");
const _temp50 = require("bf748e90548fc603");
const _temp51 = require("df390e5ff3be03e4");
const _temp52 = require("3eddb0ff0264d57b");
const _temp53 = require("bb99607fc791ca56");
const _temp54 = require("89582e13a1cf6a31");
const _temp55 = require("dd4e19d6bd172570");
const _temp56 = require("1e7a43ae6eced724");
const _temp57 = require("af5875d14c3c73ce");
const _temp58 = require("331f82afaae81003");
const _temp59 = require("357c8c6f4ebe5d49");
const _temp60 = require("e989a6a02384e0b0");
const _temp61 = require("5b8e3c3b41e34afb");
const _temp62 = require("c9f2dd8d72f44040");
const _temp63 = require("6a276d53d06d1150");
const _temp64 = require("84165f8b3adfab14");
const _temp65 = require("1e60752b2acb92dc");
const _temp66 = require("f62fda6be4f733c2");
const _temp67 = require("b31752ca3e1ea811");
const _temp68 = require("95d67ea2faacd4e1");
const _temp69 = require("3c25c0573612d5d");
const _temp70 = require("92689192298a64b4");
const _temp71 = require("f0bf5efd1d59766d");
const _temp72 = require("909e74a5c8ebabe7");
const _temp73 = require("4d8c5f87532b9971");
const _temp74 = require("6a8451422d2f0b6b");
const _temp75 = require("ce47e45e369a1638");
const _temp76 = require("956e674caf0a8c4b");
const _temp77 = require("95612b54e78d4d37");
const _temp78 = require("f7d38dcab7868d86");
const _temp79 = require("73f24e3ecb3b3dc9");
const _temp80 = require("f0cad6ab4e284cb4");
const _temp81 = require("c23e7601eed7b85");
const _temp82 = require("78e066e033da65d5");
const _temp83 = require("bd7cca5379be236a");
const _temp84 = require("f00b7fda3ed9bc52");
const _temp85 = require("957421738eb3dbf0");
const _temp86 = require("b0b7d86dd9baa26c");
const _temp87 = require("349f19b13c3b026f");
const _temp88 = require("3fae9fd6fa3c1375");
const _temp89 = require("8938cda55e45fb0c");
const _temp90 = require("34aff34730d1967a");
const _temp91 = require("499a2bc9f31adc8b");
const _temp92 = require("5c62dc93e6a7aa48");
const _temp93 = require("dfd166999715a92e");
const _temp94 = require("b1a1a2311ae029af");
const _temp95 = require("d55133eb106de34a");
const _temp96 = require("80b1f8cf382c9e1b");
const _temp97 = require("bde49ce822a7a7fe");
const _temp98 = require("34063b5de8141bb");
const _temp99 = require("c5e3581a8370db05");
const _temp100 = require("ed90fd17436717c4");
const _temp101 = require("10850090da05a3b2");
const _temp102 = require("53699c0b68f4e75d");
const _temp103 = require("81baf017531a95bd");
const _temp104 = require("ddff6977c2fe58d1");
const _temp105 = require("e783904c77322921");
const _temp106 = require("fdc97049be18fbe4");
const _temp107 = require("3d24c84dec14e969");
const _temp108 = require("2d8cd29d10524941");
const _temp109 = require("d38e83851ae9d8ef");
const _temp110 = require("b739fe581d18d557");
const _temp111 = require("89ea46e172ac3b8c");
const _temp112 = require("d42eb0f4341195b0");
const _temp113 = require("4206f614240a0918");
const _temp114 = require("3fe193f222100d9d");
const _temp115 = require("9d4f9f5721615dfa");
const _temp116 = require("a633e6f6356b59ba");
const _temp117 = require("d5380e7c1a25440d");
const _temp118 = require("cce52af19dc7b8e3");
const _temp119 = require("9ac16bbd751d30c0");
const _temp120 = require("719926e10d334024");
const _temp121 = require("336f662d34c4a2af");
const _temp122 = require("89eb17914017ba2a");
const _temp123 = require("f37847e3e1fd8b92");
const _temp124 = require("55c09fa50b69b55");
const _temp125 = require("969d529b621a2505");
const _temp126 = require("9f1c829305c0da8");
const _temp127 = require("ec3bfd7e62417715");
const _temp128 = require("1c872b5b6f48c6d5");
const _temp129 = require("8c99716bc33f267");
const _temp130 = require("789500002a259efc");
const _temp131 = require("a3f07bfc90f87275");
const _temp132 = require("569ca999e26932a8");
const _temp133 = require("94f584c5db5c9bb6");
const _temp134 = require("22924200bab545eb");
const _temp135 = require("24156e10b9faecac");
const _temp136 = require("2f8f9ae62ff1a859");
const _temp137 = require("91b8e8f04935d315");
const _temp138 = require("216b9a4a60a5e182");
const _temp139 = require("4d687352a5c9d28c");
const _temp140 = require("b967882da592a05b");
const _temp141 = require("c5edbbdb14c37ebc");
const _temp142 = require("25927b6df60cc26e");
const _temp143 = require("60b43f6a976323b4");
const _temp144 = require("a528606b04e7aabf");
const _temp145 = require("3e3b04a3ee525fe2");
const _temp146 = require("2a566a9992b9cc70");
const _temp147 = require("d31d5bd006a6e3f8");
const _temp148 = require("dbaa0ba3fe56c12f");
const _temp149 = require("a1a6346fcd7127fd");
module.exports = {
    "react-aria-components": {
        "Button": {
            "tsx": _temp0
        },
        "Calendar": {
            "tsx": _temp1
        },
        "ComboBox": {
            "tsx": _temp2
        },
        "DateField": {
            "tsx": _temp3
        },
        "DatePicker": {
            "tsx": _temp4
        },
        "Dropzone": {
            "tsx": _temp5
        },
        "FileTrigger": {
            "tsx": _temp6
        },
        "Link": {
            "tsx": _temp7
        },
        "ListBox": {
            "tsx": _temp8
        },
        "Menu": {
            "tsx": _temp9
        },
        "Meter": {
            "tsx": _temp10
        },
        "Modal": {
            "tsx": _temp11
        },
        "NumberField": {
            "tsx": _temp12
        },
        "Popover": {
            "tsx": _temp13
        },
        "ProgressBar": {
            "tsx": _temp14
        },
        "RadioGroup": {
            "tsx": _temp15
        },
        "SearchField": {
            "tsx": _temp16
        },
        "Select": {
            "tsx": _temp17
        },
        "Slider": {
            "tsx": _temp18
        },
        "Switch": {
            "tsx": _temp19
        },
        "Table": {
            "tsx": _temp20
        },
        "Tabs": {
            "tsx": _temp21
        },
        "TagGroup": {
            "tsx": _temp22
        },
        "TextField": {
            "tsx": _temp23
        },
        "TimeField": {
            "tsx": _temp24
        },
        "ToggleButton": {
            "tsx": _temp25
        },
        "Toolbar": {
            "tsx": _temp26
        },
        "Tooltip": {
            "tsx": _temp27
        },
        "animations": {
            "tsx": _temp28
        }
    },
    "@react-aria": {
        "button": {
            "useButton": {
                "tsx": _temp29
            }
        },
        "calendar": {
            "useCalendar": {
                "tsx": _temp30
            }
        },
        "combobox": {
            "useComboBox": {
                "tsx": _temp31
            }
        },
        "dnd": {
            "dnd": {
                "tsx": _temp32
            }
        },
        "focus": {
            "FocusScope": {
                "tsx": _temp33
            }
        },
        "grid": {
            "useGrid": {
                "tsx": _temp34
            }
        },
        "interactions": {
            "useFocusRing": {
                "tsx": _temp35
            },
            "useHover": {
                "tsx": _temp36
            },
            "useInteractOutside": {
                "tsx": _temp37
            },
            "useMove": {
                "tsx": _temp38
            }
        },
        "label": {
            "useField": {
                "tsx": _temp39
            }
        },
        "landmark": {
            "Landmark": {
                "tsx": _temp40
            }
        },
        "menu": {
            "useMenu": {
                "tsx": _temp41
            }
        },
        "overlays": {
            "UseOverlayPosition": {
                "tsx": _temp42
            },
            "useModal": {
                "tsx": _temp43
            },
            "usePreventScroll": {
                "tsx": _temp44
            }
        },
        "select": {
            "useSelect": {
                "tsx": _temp45
            }
        },
        "selection": {
            "useSelectableList": {
                "tsx": _temp46
            }
        },
        "slider": {
            "Slider": {
                "tsx": _temp47
            }
        },
        "table": {
            "useTable": {
                "tsx": _temp48
            }
        },
        "tabs": {
            "useTabList": {
                "tsx": _temp49
            }
        },
        "textfield": {
            "useTextField": {
                "tsx": _temp50
            }
        },
        "toast": {
            "useToast": {
                "tsx": _temp51
            }
        },
        "utils": {
            "platform": {
                "tsx": _temp52
            }
        }
    },
    "@react-stately": {
        "tree": {
            "useTreeState": {
                "tsx": _temp53
            }
        }
    },
    "@react-spectrum": {
        "accordion": {
            "Accordion": {
                "tsx": _temp54
            }
        },
        "actionbar": {
            "ActionBar": {
                "tsx": _temp55
            }
        },
        "actiongroup": {
            "ActionGroup": {
                "tsx": _temp56
            },
            "Toolbar": {
                "tsx": _temp57
            }
        },
        "autocomplete": {
            "SearchAutocomplete": {
                "tsx": _temp58
            }
        },
        "avatar": {
            "Avatar": {
                "tsx": _temp59
            }
        },
        "badge": {
            "Badge": {
                "tsx": _temp60
            }
        },
        "breadcrumbs": {
            "Breadcrumbs": {
                "tsx": _temp61
            }
        },
        "button": {
            "ActionButton": {
                "tsx": _temp62
            },
            "Button": {
                "tsx": _temp63
            },
            "LogicButton": {
                "tsx": _temp64
            },
            "ToggleButton": {
                "tsx": _temp65
            }
        },
        "buttongroup": {
            "ButtonGroup": {
                "tsx": _temp66
            }
        },
        "calendar": {
            "Calendar": {
                "tsx": _temp67
            },
            "RangeCalendar": {
                "tsx": _temp68
            },
            "RangeCalendarCell": {
                "tsx": _temp69
            }
        },
        "card": {
            "Card": {
                "tsx": _temp70
            },
            "GalleryCardView": {
                "tsx": _temp71
            },
            "GridCardView": {
                "tsx": _temp72
            },
            "HorizontalCard": {
                "tsx": _temp73
            },
            "QuietCard": {
                "tsx": _temp74
            },
            "WaterfallCardView": {
                "tsx": _temp75
            }
        },
        "checkbox": {
            "Checkbox": {
                "tsx": _temp76
            },
            "CheckboxGroup": {
                "tsx": _temp77
            }
        },
        "color": {
            "ColorArea": {
                "tsx": _temp78
            },
            "ColorField": {
                "tsx": _temp79
            },
            "ColorSlider": {
                "tsx": _temp80
            },
            "ColorThumb": {
                "tsx": _temp81
            },
            "ColorWheel": {
                "tsx": _temp82
            }
        },
        "combobox": {
            "ComboBox": {
                "tsx": _temp83
            }
        },
        "contextualhelp": {
            "ContextualHelp": {
                "tsx": _temp84
            }
        },
        "datepicker": {
            "DateField": {
                "tsx": _temp85
            },
            "DatePicker": {
                "tsx": _temp86
            },
            "DateRangePicker": {
                "tsx": _temp87
            },
            "DateRangePickerStyling": {
                "tsx": _temp88
            },
            "TimeField": {
                "tsx": _temp89
            },
            "TimeFieldStyling": {
                "tsx": _temp90
            }
        },
        "dialog": {
            "AlertDialog": {
                "tsx": _temp91
            },
            "Dialog": {
                "tsx": _temp92
            },
            "DialogContainer": {
                "tsx": _temp93
            },
            "DialogTrigger": {
                "tsx": _temp94
            }
        },
        "divider": {
            "Divider": {
                "tsx": _temp95
            }
        },
        "dropzone": {
            "DropZone": {
                "tsx": _temp96
            },
            "FileTrigger": {
                "tsx": _temp97
            }
        },
        "form": {
            "Form": {
                "tsx": _temp98
            }
        },
        "icon": {
            "Icon": {
                "tsx": _temp99
            }
        },
        "illustratedmessage": {
            "IllustratedMessage": {
                "tsx": _temp100
            }
        },
        "inlinealert": {
            "InlineAlert": {
                "tsx": _temp101
            }
        },
        "label": {
            "HelpText": {
                "tsx": _temp102
            },
            "Label": {
                "tsx": _temp103
            }
        },
        "labeledvalue": {
            "LabeledValue": {
                "tsx": _temp104
            }
        },
        "layout": {
            "Flex": {
                "tsx": _temp105
            },
            "Grid": {
                "tsx": _temp106
            }
        },
        "link": {
            "Link": {
                "tsx": _temp107
            }
        },
        "list": {
            "ListView": {
                "tsx": _temp108
            },
            "ListViewActions": {
                "tsx": _temp109
            },
            "ListViewDnD": {
                "tsx": _temp110
            },
            "ListViewDnDUtil": {
                "tsx": _temp111
            },
            "ListViewSelection": {
                "tsx": _temp112
            }
        },
        "listbox": {
            "ListBox": {
                "tsx": _temp113
            }
        },
        "menu": {
            "ActionMenu": {
                "tsx": _temp114
            },
            "MenuTrigger": {
                "tsx": _temp115
            },
            "Submenu": {
                "tsx": _temp116
            }
        },
        "meter": {
            "Meter": {
                "tsx": _temp117
            }
        },
        "numberfield": {
            "NumberField": {
                "tsx": _temp118
            }
        },
        "overlays": {
            "Modal": {
                "tsx": _temp119
            }
        },
        "pagination": {
            "pagination": {
                "js": _temp120
            }
        },
        "picker": {
            "Picker": {
                "tsx": _temp121
            }
        },
        "progress": {
            "ProgressBar": {
                "tsx": _temp122
            },
            "ProgressCircle": {
                "tsx": _temp123
            }
        },
        "provider": {
            "Provider": {
                "tsx": _temp124
            }
        },
        "radio": {
            "Radio": {
                "tsx": _temp125
            }
        },
        "searchfield": {
            "SearchField": {
                "tsx": _temp126
            }
        },
        "searchwithin": {
            "SearchWithin": {
                "tsx": _temp127
            }
        },
        "slider": {
            "RangeSlider": {
                "tsx": _temp128
            },
            "Slider": {
                "tsx": _temp129
            }
        },
        "statuslight": {
            "StatusLight": {
                "tsx": _temp130
            }
        },
        "steplist": {
            "StepList": {
                "tsx": _temp131
            }
        },
        "switch": {
            "Switch": {
                "tsx": _temp132
            }
        },
        "table": {
            "Table": {
                "tsx": _temp133
            },
            "TableDnD": {
                "tsx": _temp134
            },
            "TableDnDUtil": {
                "tsx": _temp135
            },
            "TreeGridTable": {
                "tsx": _temp136
            }
        },
        "tabs": {
            "Tabs": {
                "tsx": _temp137
            }
        },
        "tag": {
            "TagGroup": {
                "tsx": _temp138
            }
        },
        "textfield": {
            "TextArea": {
                "tsx": _temp139
            },
            "Textfield": {
                "tsx": _temp140
            }
        },
        "toast": {
            "Toast": {
                "tsx": _temp141
            }
        },
        "tooltip": {
            "Tooltip": {
                "tsx": _temp142
            },
            "TooltipTrigger": {
                "tsx": _temp143
            }
        },
        "tree": {
            "TreeView": {
                "tsx": _temp144
            }
        },
        "view": {
            "View": {
                "tsx": _temp145
            }
        },
        "well": {
            "Well": {
                "tsx": _temp146
            }
        }
    },
    "@spectrum-icons": {
        "color": {
            "IconsColor": {
                "tsx": _temp147
            }
        },
        "express": {
            "IconsExpress": {
                "tsx": _temp148
            }
        },
        "workflow": {
            "IconsWorkflow": {
                "tsx": _temp149
            }
        }
    }
};

},{"d8376f1c30f5adc7":"7fAqo","bbdfce5334830240":"aqktK","5b9580b3bb87abc8":"daxz9","f8a840053eea32f2":"kdWVq","d71915981c3d9247":"77l3O","4c2f5a219a675784":"kvihS","1171d1b3bae2b120":"fYs3Q","7d62e9b896c4fe6d":"8opkK","ecc93a9becf8ed04":"dqs1T","b7375ad4f9547f3d":"9nWqL","1ad263d6edfcc155":"84Xgz","48cacb539d7a82d9":"dScmZ","7d4454f248e4dbc3":"4ZM55","33897a7da9719cc8":"dgwJe","d8980b07f9d28f23":"1tE9F","6a84b7b380f927a3":"aMuws","cee0d43ab434fe57":"cfYeW","c2beaf2a6d197107":"fDr7Z","9afccdd70f898c5b":"3nc13","6e242b84d2d1cb8":"8ASVy","fdb8b761d62d4964":"aDz9A","5a30c288f69a1884":"6WahX","363445e62110c83e":"gp3nI","b2e5b8177142b647":"jtueY","304b286f6d3e2156":"7ACwt","776c5c5436adb654":"lAZkP","98cd83991097adda":"k2xd2","d3e45c02df48a83a":"dyuDw","590942dd16be2b72":"2XHQq","6f95a2a440814dd4":"5agG9","47ac3c201bef59a0":"ar8Lj","d0f532a7252c4a90":"aEObA","382b22fc74f721d6":"6aNDQ","84fdb981b536cc22":"5zk2X","147780957a918b12":"kvNcr","4156aed1b5757c3e":"cRetY","e64547a9afbbb466":"7yTlj","f8d9f0ec05cc0a6":"g7AK5","ee86c8f154fbbf37":"2iPHm","1974ecc17b3016a2":"5KUGQ","cce57b33974b23ef":"T1V9r","132b2d30d6502a86":"1xVvy","a9a7da78c6ebacfa":"h6MHG","d30f9b5cc0933cc1":"52dWO","4e3a4a915aff06ad":"5GMmv","d759af0c2b8ba25a":"bjf4e","c05de7820d294953":"fjWbs","2632f4d3a03105ff":"7bFl8","28fd440f4cedc74e":"iI18R","73ce9831f4f59544":"37MAO","bf748e90548fc603":"4kkq1","df390e5ff3be03e4":"iqK0m","3eddb0ff0264d57b":"8lXQu","bb99607fc791ca56":"fZOgM","89582e13a1cf6a31":"51hPp","dd4e19d6bd172570":"mgIfK","1e7a43ae6eced724":"6ZJnd","af5875d14c3c73ce":"b8wmw","331f82afaae81003":"fn9Bu","357c8c6f4ebe5d49":"jXn5w","e989a6a02384e0b0":"2fJfW","5b8e3c3b41e34afb":"aabfZ","c9f2dd8d72f44040":"hrnbP","6a276d53d06d1150":"cdpVs","84165f8b3adfab14":"gktLq","1e60752b2acb92dc":"9b98N","f62fda6be4f733c2":"kygiG","b31752ca3e1ea811":"7F9uU","95d67ea2faacd4e1":"fSmea","3c25c0573612d5d":"jBc4q","92689192298a64b4":"6Z2Qc","f0bf5efd1d59766d":"cKQBm","909e74a5c8ebabe7":"kI5xv","4d8c5f87532b9971":"jUJAW","6a8451422d2f0b6b":"i9TKx","ce47e45e369a1638":"71boN","956e674caf0a8c4b":"achgo","95612b54e78d4d37":"llbGl","f7d38dcab7868d86":"4HlAn","73f24e3ecb3b3dc9":"1F7cM","f0cad6ab4e284cb4":"ktXAm","c23e7601eed7b85":"d3bsU","78e066e033da65d5":"iZF8g","bd7cca5379be236a":"KOzmH","f00b7fda3ed9bc52":"hytoP","957421738eb3dbf0":"bc8PO","b0b7d86dd9baa26c":"jRHGd","349f19b13c3b026f":"nIrhl","3fae9fd6fa3c1375":"kcJfy","8938cda55e45fb0c":"dDIjw","34aff34730d1967a":"6tToD","499a2bc9f31adc8b":"gH7Kq","5c62dc93e6a7aa48":"gtUDv","dfd166999715a92e":"iEdyP","b1a1a2311ae029af":"ljImx","d55133eb106de34a":"en2uX","80b1f8cf382c9e1b":"aR8GX","bde49ce822a7a7fe":"khMhk","34063b5de8141bb":"9C8rZ","c5e3581a8370db05":"5yi5z","ed90fd17436717c4":"6RGZn","10850090da05a3b2":"9v27c","53699c0b68f4e75d":"foTZt","81baf017531a95bd":"eAZ1D","ddff6977c2fe58d1":"6AFCA","e783904c77322921":"lVcgH","fdc97049be18fbe4":"6kZ47","3d24c84dec14e969":"67sw9","2d8cd29d10524941":"7ktXC","d38e83851ae9d8ef":"2mSZi","b739fe581d18d557":"Afqjm","89ea46e172ac3b8c":"HsCSB","d42eb0f4341195b0":"43BAm","4206f614240a0918":"54byp","3fe193f222100d9d":"4a41n","9d4f9f5721615dfa":"iKKSY","a633e6f6356b59ba":"5dFCD","d5380e7c1a25440d":"eQU5F","cce52af19dc7b8e3":"czANX","9ac16bbd751d30c0":"gnIco","719926e10d334024":"dD9Be","336f662d34c4a2af":"lRoA0","89eb17914017ba2a":"leBCm","f37847e3e1fd8b92":"9DP3B","55c09fa50b69b55":"jjp8O","969d529b621a2505":"bBogr","9f1c829305c0da8":"cETgv","ec3bfd7e62417715":"bdvCe","1c872b5b6f48c6d5":"aEWRO","8c99716bc33f267":"5139p","789500002a259efc":"htgkj","a3f07bfc90f87275":"cEVVO","569ca999e26932a8":"6Ukh5","94f584c5db5c9bb6":"70C9Q","22924200bab545eb":"7aGpT","24156e10b9faecac":"du7S9","2f8f9ae62ff1a859":"b56Ug","91b8e8f04935d315":"cQXcQ","216b9a4a60a5e182":"jvJcZ","4d687352a5c9d28c":"3I358","b967882da592a05b":"a4Pip","c5edbbdb14c37ebc":"bAwHT","25927b6df60cc26e":"brOGJ","60b43f6a976323b4":"dVFHv","a528606b04e7aabf":"apjq2","3e3b04a3ee525fe2":"3lZgj","2a566a9992b9cc70":"aZidy","d31d5bd006a6e3f8":"izdhi","dbaa0ba3fe56c12f":"3x3nV","a1a6346fcd7127fd":"fZXXy"}],"7fAqo":[function(require,module,exports) {
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ButtonExample", ()=>ButtonExample);
var _reactAriaComponents = require("react-aria-components");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
exports.default = {
    title: "React Aria Components"
};
const ButtonExample = ()=>{
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Button), {
        "data-testid": "button-example",
        onPress: ()=>alert("Hello world!")
    }, "Press me");
};

},{"react-aria-components":"lFSUH","react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"lFSUH":[function(require,module,exports) {
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Mark as a client only package. This will cause a build time error if you try 
// to import it from a React Server Component in a framework like Next.js.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Breadcrumbs", ()=>(0, _breadcrumbs.Breadcrumbs));
parcelHelpers.export(exports, "BreadcrumbsContext", ()=>(0, _breadcrumbs.BreadcrumbsContext));
parcelHelpers.export(exports, "Breadcrumb", ()=>(0, _breadcrumbs.Breadcrumb));
parcelHelpers.export(exports, "Button", ()=>(0, _button.Button));
parcelHelpers.export(exports, "ButtonContext", ()=>(0, _button.ButtonContext));
parcelHelpers.export(exports, "Calendar", ()=>(0, _calendar.Calendar));
parcelHelpers.export(exports, "CalendarGrid", ()=>(0, _calendar.CalendarGrid));
parcelHelpers.export(exports, "CalendarGridHeader", ()=>(0, _calendar.CalendarGridHeader));
parcelHelpers.export(exports, "CalendarGridBody", ()=>(0, _calendar.CalendarGridBody));
parcelHelpers.export(exports, "CalendarHeaderCell", ()=>(0, _calendar.CalendarHeaderCell));
parcelHelpers.export(exports, "CalendarCell", ()=>(0, _calendar.CalendarCell));
parcelHelpers.export(exports, "RangeCalendar", ()=>(0, _calendar.RangeCalendar));
parcelHelpers.export(exports, "CalendarContext", ()=>(0, _calendar.CalendarContext));
parcelHelpers.export(exports, "RangeCalendarContext", ()=>(0, _calendar.RangeCalendarContext));
parcelHelpers.export(exports, "CalendarStateContext", ()=>(0, _calendar.CalendarStateContext));
parcelHelpers.export(exports, "RangeCalendarStateContext", ()=>(0, _calendar.RangeCalendarStateContext));
parcelHelpers.export(exports, "Checkbox", ()=>(0, _checkbox.Checkbox));
parcelHelpers.export(exports, "CheckboxGroup", ()=>(0, _checkbox.CheckboxGroup));
parcelHelpers.export(exports, "CheckboxGroupContext", ()=>(0, _checkbox.CheckboxGroupContext));
parcelHelpers.export(exports, "CheckboxContext", ()=>(0, _checkbox.CheckboxContext));
parcelHelpers.export(exports, "CheckboxGroupStateContext", ()=>(0, _checkbox.CheckboxGroupStateContext));
parcelHelpers.export(exports, "ComboBox", ()=>(0, _comboBox.ComboBox));
parcelHelpers.export(exports, "ComboBoxContext", ()=>(0, _comboBox.ComboBoxContext));
parcelHelpers.export(exports, "ComboBoxStateContext", ()=>(0, _comboBox.ComboBoxStateContext));
parcelHelpers.export(exports, "composeRenderProps", ()=>(0, _utils.composeRenderProps));
parcelHelpers.export(exports, "DEFAULT_SLOT", ()=>(0, _utils.DEFAULT_SLOT));
parcelHelpers.export(exports, "Provider", ()=>(0, _utils.Provider));
parcelHelpers.export(exports, "useContextProps", ()=>(0, _utils.useContextProps));
parcelHelpers.export(exports, "useSlottedContext", ()=>(0, _utils.useSlottedContext));
parcelHelpers.export(exports, "DateField", ()=>(0, _dateField.DateField));
parcelHelpers.export(exports, "DateInput", ()=>(0, _dateField.DateInput));
parcelHelpers.export(exports, "DateSegment", ()=>(0, _dateField.DateSegment));
parcelHelpers.export(exports, "TimeField", ()=>(0, _dateField.TimeField));
parcelHelpers.export(exports, "DateFieldContext", ()=>(0, _dateField.DateFieldContext));
parcelHelpers.export(exports, "TimeFieldContext", ()=>(0, _dateField.TimeFieldContext));
parcelHelpers.export(exports, "DateFieldStateContext", ()=>(0, _dateField.DateFieldStateContext));
parcelHelpers.export(exports, "TimeFieldStateContext", ()=>(0, _dateField.TimeFieldStateContext));
parcelHelpers.export(exports, "DatePicker", ()=>(0, _datePicker.DatePicker));
parcelHelpers.export(exports, "DateRangePicker", ()=>(0, _datePicker.DateRangePicker));
parcelHelpers.export(exports, "DatePickerContext", ()=>(0, _datePicker.DatePickerContext));
parcelHelpers.export(exports, "DateRangePickerContext", ()=>(0, _datePicker.DateRangePickerContext));
parcelHelpers.export(exports, "DatePickerStateContext", ()=>(0, _datePicker.DatePickerStateContext));
parcelHelpers.export(exports, "DateRangePickerStateContext", ()=>(0, _datePicker.DateRangePickerStateContext));
parcelHelpers.export(exports, "DialogTrigger", ()=>(0, _dialog.DialogTrigger));
parcelHelpers.export(exports, "Dialog", ()=>(0, _dialog.Dialog));
parcelHelpers.export(exports, "DialogContext", ()=>(0, _dialog.DialogContext));
parcelHelpers.export(exports, "OverlayTriggerStateContext", ()=>(0, _dialog.OverlayTriggerStateContext));
parcelHelpers.export(exports, "DropZone", ()=>(0, _dropZone.DropZone));
parcelHelpers.export(exports, "DropZoneContext", ()=>(0, _dropZone.DropZoneContext));
parcelHelpers.export(exports, "FieldError", ()=>(0, _fieldError.FieldError));
parcelHelpers.export(exports, "FieldErrorContext", ()=>(0, _fieldError.FieldErrorContext));
parcelHelpers.export(exports, "FileTrigger", ()=>(0, _fileTrigger.FileTrigger));
parcelHelpers.export(exports, "Form", ()=>(0, _form.Form));
parcelHelpers.export(exports, "GridList", ()=>(0, _gridList.GridList));
parcelHelpers.export(exports, "GridListItem", ()=>(0, _gridList.GridListItem));
parcelHelpers.export(exports, "GridListContext", ()=>(0, _gridList.GridListContext));
parcelHelpers.export(exports, "Group", ()=>(0, _group.Group));
parcelHelpers.export(exports, "GroupContext", ()=>(0, _group.GroupContext));
parcelHelpers.export(exports, "Header", ()=>(0, _header.Header));
parcelHelpers.export(exports, "HeaderContext", ()=>(0, _header.HeaderContext));
parcelHelpers.export(exports, "Heading", ()=>(0, _heading.Heading));
parcelHelpers.export(exports, "HeadingContext", ()=>(0, _heading.HeadingContext));
parcelHelpers.export(exports, "Input", ()=>(0, _input.Input));
parcelHelpers.export(exports, "InputContext", ()=>(0, _input.InputContext));
parcelHelpers.export(exports, "Section", ()=>(0, _collection.Section));
parcelHelpers.export(exports, "Collection", ()=>(0, _collection.Collection));
parcelHelpers.export(exports, "Keyboard", ()=>(0, _keyboard.Keyboard));
parcelHelpers.export(exports, "KeyboardContext", ()=>(0, _keyboard.KeyboardContext));
parcelHelpers.export(exports, "Label", ()=>(0, _label.Label));
parcelHelpers.export(exports, "LabelContext", ()=>(0, _label.LabelContext));
parcelHelpers.export(exports, "Link", ()=>(0, _link.Link));
parcelHelpers.export(exports, "LinkContext", ()=>(0, _link.LinkContext));
parcelHelpers.export(exports, "ListBox", ()=>(0, _listBox.ListBox));
parcelHelpers.export(exports, "ListBoxItem", ()=>(0, _listBox.ListBoxItem));
parcelHelpers.export(exports, "ListBoxContext", ()=>(0, _listBox.ListBoxContext));
parcelHelpers.export(exports, "ListStateContext", ()=>(0, _listBox.ListStateContext));
parcelHelpers.export(exports, "Menu", ()=>(0, _menu.Menu));
parcelHelpers.export(exports, "MenuItem", ()=>(0, _menu.MenuItem));
parcelHelpers.export(exports, "MenuTrigger", ()=>(0, _menu.MenuTrigger));
parcelHelpers.export(exports, "MenuContext", ()=>(0, _menu.MenuContext));
parcelHelpers.export(exports, "MenuStateContext", ()=>(0, _menu.MenuStateContext));
parcelHelpers.export(exports, "RootMenuTriggerStateContext", ()=>(0, _menu.RootMenuTriggerStateContext));
parcelHelpers.export(exports, "SubmenuTrigger", ()=>(0, _menu.SubmenuTrigger));
parcelHelpers.export(exports, "Meter", ()=>(0, _meter.Meter));
parcelHelpers.export(exports, "MeterContext", ()=>(0, _meter.MeterContext));
parcelHelpers.export(exports, "Modal", ()=>(0, _modal.Modal));
parcelHelpers.export(exports, "ModalOverlay", ()=>(0, _modal.ModalOverlay));
parcelHelpers.export(exports, "ModalContext", ()=>(0, _modal.ModalContext));
parcelHelpers.export(exports, "NumberField", ()=>(0, _numberField.NumberField));
parcelHelpers.export(exports, "NumberFieldContext", ()=>(0, _numberField.NumberFieldContext));
parcelHelpers.export(exports, "NumberFieldStateContext", ()=>(0, _numberField.NumberFieldStateContext));
parcelHelpers.export(exports, "OverlayArrow", ()=>(0, _overlayArrow.OverlayArrow));
parcelHelpers.export(exports, "Popover", ()=>(0, _popover.Popover));
parcelHelpers.export(exports, "PopoverContext", ()=>(0, _popover.PopoverContext));
parcelHelpers.export(exports, "ProgressBar", ()=>(0, _progressBar.ProgressBar));
parcelHelpers.export(exports, "ProgressBarContext", ()=>(0, _progressBar.ProgressBarContext));
parcelHelpers.export(exports, "RadioGroup", ()=>(0, _radioGroup.RadioGroup));
parcelHelpers.export(exports, "Radio", ()=>(0, _radioGroup.Radio));
parcelHelpers.export(exports, "RadioGroupContext", ()=>(0, _radioGroup.RadioGroupContext));
parcelHelpers.export(exports, "RadioContext", ()=>(0, _radioGroup.RadioContext));
parcelHelpers.export(exports, "RadioGroupStateContext", ()=>(0, _radioGroup.RadioGroupStateContext));
parcelHelpers.export(exports, "SearchField", ()=>(0, _searchField.SearchField));
parcelHelpers.export(exports, "SearchFieldContext", ()=>(0, _searchField.SearchFieldContext));
parcelHelpers.export(exports, "Select", ()=>(0, _select.Select));
parcelHelpers.export(exports, "SelectValue", ()=>(0, _select.SelectValue));
parcelHelpers.export(exports, "SelectContext", ()=>(0, _select.SelectContext));
parcelHelpers.export(exports, "SelectValueContext", ()=>(0, _select.SelectValueContext));
parcelHelpers.export(exports, "SelectStateContext", ()=>(0, _select.SelectStateContext));
parcelHelpers.export(exports, "Separator", ()=>(0, _separator.Separator));
parcelHelpers.export(exports, "SeparatorContext", ()=>(0, _separator.SeparatorContext));
parcelHelpers.export(exports, "Slider", ()=>(0, _slider.Slider));
parcelHelpers.export(exports, "SliderOutput", ()=>(0, _slider.SliderOutput));
parcelHelpers.export(exports, "SliderTrack", ()=>(0, _slider.SliderTrack));
parcelHelpers.export(exports, "SliderThumb", ()=>(0, _slider.SliderThumb));
parcelHelpers.export(exports, "SliderContext", ()=>(0, _slider.SliderContext));
parcelHelpers.export(exports, "SliderOutputContext", ()=>(0, _slider.SliderOutputContext));
parcelHelpers.export(exports, "SliderTrackContext", ()=>(0, _slider.SliderTrackContext));
parcelHelpers.export(exports, "SliderStateContext", ()=>(0, _slider.SliderStateContext));
parcelHelpers.export(exports, "Switch", ()=>(0, _switch.Switch));
parcelHelpers.export(exports, "SwitchContext", ()=>(0, _switch.SwitchContext));
parcelHelpers.export(exports, "Table", ()=>(0, _table.Table));
parcelHelpers.export(exports, "Row", ()=>(0, _table.Row));
parcelHelpers.export(exports, "Cell", ()=>(0, _table.Cell));
parcelHelpers.export(exports, "Column", ()=>(0, _table.Column));
parcelHelpers.export(exports, "ColumnResizer", ()=>(0, _table.ColumnResizer));
parcelHelpers.export(exports, "TableHeader", ()=>(0, _table.TableHeader));
parcelHelpers.export(exports, "TableBody", ()=>(0, _table.TableBody));
parcelHelpers.export(exports, "TableContext", ()=>(0, _table.TableContext));
parcelHelpers.export(exports, "ResizableTableContainer", ()=>(0, _table.ResizableTableContainer));
parcelHelpers.export(exports, "useTableOptions", ()=>(0, _table.useTableOptions));
parcelHelpers.export(exports, "TableStateContext", ()=>(0, _table.TableStateContext));
parcelHelpers.export(exports, "TableColumnResizeStateContext", ()=>(0, _table.TableColumnResizeStateContext));
parcelHelpers.export(exports, "Tabs", ()=>(0, _tabs.Tabs));
parcelHelpers.export(exports, "TabList", ()=>(0, _tabs.TabList));
parcelHelpers.export(exports, "TabPanel", ()=>(0, _tabs.TabPanel));
parcelHelpers.export(exports, "Tab", ()=>(0, _tabs.Tab));
parcelHelpers.export(exports, "TabsContext", ()=>(0, _tabs.TabsContext));
parcelHelpers.export(exports, "TabListStateContext", ()=>(0, _tabs.TabListStateContext));
parcelHelpers.export(exports, "TagGroup", ()=>(0, _tagGroup.TagGroup));
parcelHelpers.export(exports, "TagGroupContext", ()=>(0, _tagGroup.TagGroupContext));
parcelHelpers.export(exports, "TagList", ()=>(0, _tagGroup.TagList));
parcelHelpers.export(exports, "TagListContext", ()=>(0, _tagGroup.TagListContext));
parcelHelpers.export(exports, "Tag", ()=>(0, _tagGroup.Tag));
parcelHelpers.export(exports, "Text", ()=>(0, _text.Text));
parcelHelpers.export(exports, "TextContext", ()=>(0, _text.TextContext));
parcelHelpers.export(exports, "TextArea", ()=>(0, _textArea.TextArea));
parcelHelpers.export(exports, "TextAreaContext", ()=>(0, _textArea.TextAreaContext));
parcelHelpers.export(exports, "TextField", ()=>(0, _textField.TextField));
parcelHelpers.export(exports, "TextFieldContext", ()=>(0, _textField.TextFieldContext));
parcelHelpers.export(exports, "ToggleButton", ()=>(0, _toggleButton.ToggleButton));
parcelHelpers.export(exports, "ToggleButtonContext", ()=>(0, _toggleButton.ToggleButtonContext));
parcelHelpers.export(exports, "Toolbar", ()=>(0, _toolbar.Toolbar));
parcelHelpers.export(exports, "ToolbarContext", ()=>(0, _toolbar.ToolbarContext));
parcelHelpers.export(exports, "TooltipTrigger", ()=>(0, _tooltip.TooltipTrigger));
parcelHelpers.export(exports, "Tooltip", ()=>(0, _tooltip.Tooltip));
parcelHelpers.export(exports, "TooltipTriggerStateContext", ()=>(0, _tooltip.TooltipTriggerStateContext));
parcelHelpers.export(exports, "TooltipContext", ()=>(0, _tooltip.TooltipContext));
parcelHelpers.export(exports, "useDragAndDrop", ()=>(0, _useDragAndDrop.useDragAndDrop));
parcelHelpers.export(exports, "DropIndicator", ()=>(0, _useDragAndDrop.DropIndicator));
parcelHelpers.export(exports, "DropIndicatorContext", ()=>(0, _useDragAndDrop.DropIndicatorContext));
parcelHelpers.export(exports, "DragAndDropContext", ()=>(0, _useDragAndDrop.DragAndDropContext));
parcelHelpers.export(exports, "DIRECTORY_DRAG_TYPE", ()=>(0, _reactAria.DIRECTORY_DRAG_TYPE));
parcelHelpers.export(exports, "isDirectoryDropItem", ()=>(0, _reactAria.isDirectoryDropItem));
parcelHelpers.export(exports, "isFileDropItem", ()=>(0, _reactAria.isFileDropItem));
parcelHelpers.export(exports, "isTextDropItem", ()=>(0, _reactAria.isTextDropItem));
parcelHelpers.export(exports, "SSRProvider", ()=>(0, _reactAria.SSRProvider));
parcelHelpers.export(exports, "RouterProvider", ()=>(0, _reactAria.RouterProvider));
parcelHelpers.export(exports, "I18nProvider", ()=>(0, _reactAria.I18nProvider));
parcelHelpers.export(exports, "useLocale", ()=>(0, _reactAria.useLocale));
parcelHelpers.export(exports, "FormValidationContext", ()=>(0, _reactStately.FormValidationContext));
var _clientOnly = require("client-only");
var _breadcrumbs = require("./Breadcrumbs");
var _button = require("./Button");
var _calendar = require("./Calendar");
var _checkbox = require("./Checkbox");
var _comboBox = require("./ComboBox");
var _utils = require("./utils");
var _dateField = require("./DateField");
var _datePicker = require("./DatePicker");
var _dialog = require("./Dialog");
var _dropZone = require("./DropZone");
var _fieldError = require("./FieldError");
var _fileTrigger = require("./FileTrigger");
var _form = require("./Form");
var _gridList = require("./GridList");
var _group = require("./Group");
var _header = require("./Header");
var _heading = require("./Heading");
var _input = require("./Input");
var _collection = require("./Collection");
var _keyboard = require("./Keyboard");
var _label = require("./Label");
var _link = require("./Link");
var _listBox = require("./ListBox");
var _menu = require("./Menu");
var _meter = require("./Meter");
var _modal = require("./Modal");
var _numberField = require("./NumberField");
var _overlayArrow = require("./OverlayArrow");
var _popover = require("./Popover");
var _progressBar = require("./ProgressBar");
var _radioGroup = require("./RadioGroup");
var _searchField = require("./SearchField");
var _select = require("./Select");
var _separator = require("./Separator");
var _slider = require("./Slider");
var _switch = require("./Switch");
var _table = require("./Table");
var _tabs = require("./Tabs");
var _tagGroup = require("./TagGroup");
var _text = require("./Text");
var _textArea = require("./TextArea");
var _textField = require("./TextField");
var _toggleButton = require("./ToggleButton");
var _toolbar = require("./Toolbar");
var _tooltip = require("./Tooltip");
var _useDragAndDrop = require("./useDragAndDrop");
var _reactAria = require("react-aria");
var _reactStately = require("react-stately");

},{"client-only":"cUERd","./Breadcrumbs":false,"./Button":"9McZy","./Calendar":"insxi","./Checkbox":"fxrKi","./ComboBox":"WIt2x","./utils":false,"./DateField":"7GuOQ","./DatePicker":"kKATF","./Dialog":"7F4Zw","./DropZone":"udzkg","./FieldError":false,"./FileTrigger":"gIbtb","./Form":false,"./GridList":false,"./Group":"71duS","./Header":"4dFe5","./Heading":"gl7db","./Input":"3u8zn","./Collection":"lJDFi","./Keyboard":"88PWd","./Label":"jhkeS","./Link":"j9a8x","./ListBox":"katmG","./Menu":"eobpp","./Meter":"42SpS","./Modal":"7M0RZ","./NumberField":"1kIqx","./OverlayArrow":"g8XVt","./Popover":"Gl2h9","./ProgressBar":"fRMDJ","./RadioGroup":"2g6k3","./SearchField":"jgpuY","./Select":"jbClj","./Separator":"fNEee","./Slider":"l17Cl","./Switch":"2EleS","./Table":"CNMZ9","./Tabs":"f0lSN","./TagGroup":"4fzLm","./Text":"iZUDL","./TextArea":false,"./TextField":"atNkR","./ToggleButton":"1woPA","./Toolbar":"8OG3l","./Tooltip":"bqCAj","./useDragAndDrop":"fPav3","react-aria":false,"react-stately":false,"@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"cUERd":[function(require,module,exports) {

},{}],"9McZy":[function(require,module,exports) {
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ButtonContext", ()=>ButtonContext);
parcelHelpers.export(exports, "Button", ()=>_Button);
var _reactAria = require("react-aria");
var _utils = require("./utils");
var _utils1 = require("@react-aria/utils");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const additionalButtonHTMLAttributes = new Set([
    "form",
    "formAction",
    "formEncType",
    "formMethod",
    "formNoValidate",
    "formTarget",
    "name",
    "value"
]);
const ButtonContext = /*#__PURE__*/ (0, _react.createContext)({});
function Button(props, ref) {
    [props, ref] = (0, _utils.useContextProps)(props, ref, ButtonContext);
    let ctx = props;
    let { buttonProps, isPressed } = (0, _reactAria.useButton)(props, ref);
    let { focusProps, isFocused, isFocusVisible } = (0, _reactAria.useFocusRing)(props);
    let { hoverProps, isHovered } = (0, _reactAria.useHover)(props);
    let renderProps = (0, _utils.useRenderProps)({
        ...props,
        values: {
            isHovered,
            isPressed,
            isFocused,
            isFocusVisible,
            isDisabled: props.isDisabled || false
        },
        defaultClassName: "react-aria-Button"
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("button", {
        ...(0, _utils1.filterDOMProps)(props, {
            propNames: additionalButtonHTMLAttributes
        }),
        ...(0, _reactAria.mergeProps)(buttonProps, focusProps, hoverProps),
        ...renderProps,
        ref: ref,
        slot: props.slot || undefined,
        "data-disabled": props.isDisabled || undefined,
        "data-pressed": ctx.isPressed || isPressed || undefined,
        "data-hovered": isHovered || undefined,
        "data-focused": isFocused || undefined,
        "data-focus-visible": isFocusVisible || undefined
    });
}
/**
 * A button allows a user to perform an action, with mouse, touch, and keyboard interactions.
 */ const _Button = /*#__PURE__*/ (0, _utils.createHideableComponent)(Button);

},{"react-aria":"e7jhe","./utils":"iyTLn","@react-aria/utils":"9cLk5","react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"e7jhe":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useBreadcrumbItem", ()=>(0, _breadcrumbs.useBreadcrumbItem));
parcelHelpers.export(exports, "useBreadcrumbs", ()=>(0, _breadcrumbs.useBreadcrumbs));
parcelHelpers.export(exports, "useButton", ()=>(0, _button.useButton));
parcelHelpers.export(exports, "useToggleButton", ()=>(0, _button.useToggleButton));
parcelHelpers.export(exports, "useCalendar", ()=>(0, _calendar.useCalendar));
parcelHelpers.export(exports, "useCalendarCell", ()=>(0, _calendar.useCalendarCell));
parcelHelpers.export(exports, "useCalendarGrid", ()=>(0, _calendar.useCalendarGrid));
parcelHelpers.export(exports, "useRangeCalendar", ()=>(0, _calendar.useRangeCalendar));
parcelHelpers.export(exports, "useCheckbox", ()=>(0, _checkbox.useCheckbox));
parcelHelpers.export(exports, "useCheckboxGroup", ()=>(0, _checkbox.useCheckboxGroup));
parcelHelpers.export(exports, "useCheckboxGroupItem", ()=>(0, _checkbox.useCheckboxGroupItem));
parcelHelpers.export(exports, "useComboBox", ()=>(0, _combobox.useComboBox));
parcelHelpers.export(exports, "useDateField", ()=>(0, _datepicker.useDateField));
parcelHelpers.export(exports, "useDatePicker", ()=>(0, _datepicker.useDatePicker));
parcelHelpers.export(exports, "useDateRangePicker", ()=>(0, _datepicker.useDateRangePicker));
parcelHelpers.export(exports, "useDateSegment", ()=>(0, _datepicker.useDateSegment));
parcelHelpers.export(exports, "useTimeField", ()=>(0, _datepicker.useTimeField));
parcelHelpers.export(exports, "useDialog", ()=>(0, _dialog.useDialog));
parcelHelpers.export(exports, "useDrag", ()=>(0, _dnd.useDrag));
parcelHelpers.export(exports, "useDrop", ()=>(0, _dnd.useDrop));
parcelHelpers.export(exports, "useDraggableCollection", ()=>(0, _dnd.useDraggableCollection));
parcelHelpers.export(exports, "useDroppableCollection", ()=>(0, _dnd.useDroppableCollection));
parcelHelpers.export(exports, "useDroppableItem", ()=>(0, _dnd.useDroppableItem));
parcelHelpers.export(exports, "useDropIndicator", ()=>(0, _dnd.useDropIndicator));
parcelHelpers.export(exports, "useDraggableItem", ()=>(0, _dnd.useDraggableItem));
parcelHelpers.export(exports, "useClipboard", ()=>(0, _dnd.useClipboard));
parcelHelpers.export(exports, "DragPreview", ()=>(0, _dnd.DragPreview));
parcelHelpers.export(exports, "ListDropTargetDelegate", ()=>(0, _dnd.ListDropTargetDelegate));
parcelHelpers.export(exports, "DIRECTORY_DRAG_TYPE", ()=>(0, _dnd.DIRECTORY_DRAG_TYPE));
parcelHelpers.export(exports, "isDirectoryDropItem", ()=>(0, _dnd.isDirectoryDropItem));
parcelHelpers.export(exports, "isFileDropItem", ()=>(0, _dnd.isFileDropItem));
parcelHelpers.export(exports, "isTextDropItem", ()=>(0, _dnd.isTextDropItem));
parcelHelpers.export(exports, "FocusRing", ()=>(0, _focus.FocusRing));
parcelHelpers.export(exports, "FocusScope", ()=>(0, _focus.FocusScope));
parcelHelpers.export(exports, "useFocusManager", ()=>(0, _focus.useFocusManager));
parcelHelpers.export(exports, "useFocusRing", ()=>(0, _focus.useFocusRing));
parcelHelpers.export(exports, "useFocusable", ()=>(0, _focus.useFocusable));
parcelHelpers.export(exports, "I18nProvider", ()=>(0, _i18N.I18nProvider));
parcelHelpers.export(exports, "useCollator", ()=>(0, _i18N.useCollator));
parcelHelpers.export(exports, "useDateFormatter", ()=>(0, _i18N.useDateFormatter));
parcelHelpers.export(exports, "useFilter", ()=>(0, _i18N.useFilter));
parcelHelpers.export(exports, "useLocale", ()=>(0, _i18N.useLocale));
parcelHelpers.export(exports, "useLocalizedStringFormatter", ()=>(0, _i18N.useLocalizedStringFormatter));
parcelHelpers.export(exports, "useMessageFormatter", ()=>(0, _i18N.useMessageFormatter));
parcelHelpers.export(exports, "useNumberFormatter", ()=>(0, _i18N.useNumberFormatter));
parcelHelpers.export(exports, "useFocus", ()=>(0, _interactions.useFocus));
parcelHelpers.export(exports, "useFocusVisible", ()=>(0, _interactions.useFocusVisible));
parcelHelpers.export(exports, "useFocusWithin", ()=>(0, _interactions.useFocusWithin));
parcelHelpers.export(exports, "useHover", ()=>(0, _interactions.useHover));
parcelHelpers.export(exports, "useInteractOutside", ()=>(0, _interactions.useInteractOutside));
parcelHelpers.export(exports, "useKeyboard", ()=>(0, _interactions.useKeyboard));
parcelHelpers.export(exports, "useMove", ()=>(0, _interactions.useMove));
parcelHelpers.export(exports, "usePress", ()=>(0, _interactions.usePress));
parcelHelpers.export(exports, "useLongPress", ()=>(0, _interactions.useLongPress));
parcelHelpers.export(exports, "useField", ()=>(0, _label.useField));
parcelHelpers.export(exports, "useLabel", ()=>(0, _label.useLabel));
parcelHelpers.export(exports, "useGridList", ()=>(0, _gridlist.useGridList));
parcelHelpers.export(exports, "useGridListItem", ()=>(0, _gridlist.useGridListItem));
parcelHelpers.export(exports, "useGridListSelectionCheckbox", ()=>(0, _gridlist.useGridListSelectionCheckbox));
parcelHelpers.export(exports, "useLink", ()=>(0, _link.useLink));
parcelHelpers.export(exports, "useListBox", ()=>(0, _listbox.useListBox));
parcelHelpers.export(exports, "useListBoxSection", ()=>(0, _listbox.useListBoxSection));
parcelHelpers.export(exports, "useOption", ()=>(0, _listbox.useOption));
parcelHelpers.export(exports, "useMenu", ()=>(0, _menu.useMenu));
parcelHelpers.export(exports, "useMenuItem", ()=>(0, _menu.useMenuItem));
parcelHelpers.export(exports, "useMenuSection", ()=>(0, _menu.useMenuSection));
parcelHelpers.export(exports, "useMenuTrigger", ()=>(0, _menu.useMenuTrigger));
parcelHelpers.export(exports, "useMeter", ()=>(0, _meter.useMeter));
parcelHelpers.export(exports, "useNumberField", ()=>(0, _numberfield.useNumberField));
parcelHelpers.export(exports, "DismissButton", ()=>(0, _overlays.DismissButton));
parcelHelpers.export(exports, "ModalProvider", ()=>(0, _overlays.ModalProvider));
parcelHelpers.export(exports, "Overlay", ()=>(0, _overlays.Overlay));
parcelHelpers.export(exports, "OverlayContainer", ()=>(0, _overlays.OverlayContainer));
parcelHelpers.export(exports, "OverlayProvider", ()=>(0, _overlays.OverlayProvider));
parcelHelpers.export(exports, "useModal", ()=>(0, _overlays.useModal));
parcelHelpers.export(exports, "useModalOverlay", ()=>(0, _overlays.useModalOverlay));
parcelHelpers.export(exports, "useModalProvider", ()=>(0, _overlays.useModalProvider));
parcelHelpers.export(exports, "useOverlay", ()=>(0, _overlays.useOverlay));
parcelHelpers.export(exports, "useOverlayPosition", ()=>(0, _overlays.useOverlayPosition));
parcelHelpers.export(exports, "useOverlayTrigger", ()=>(0, _overlays.useOverlayTrigger));
parcelHelpers.export(exports, "usePopover", ()=>(0, _overlays.usePopover));
parcelHelpers.export(exports, "usePreventScroll", ()=>(0, _overlays.usePreventScroll));
parcelHelpers.export(exports, "useProgressBar", ()=>(0, _progress.useProgressBar));
parcelHelpers.export(exports, "useRadio", ()=>(0, _radio.useRadio));
parcelHelpers.export(exports, "useRadioGroup", ()=>(0, _radio.useRadioGroup));
parcelHelpers.export(exports, "useSearchField", ()=>(0, _searchfield.useSearchField));
parcelHelpers.export(exports, "HiddenSelect", ()=>(0, _select.HiddenSelect));
parcelHelpers.export(exports, "useHiddenSelect", ()=>(0, _select.useHiddenSelect));
parcelHelpers.export(exports, "useSelect", ()=>(0, _select.useSelect));
parcelHelpers.export(exports, "ListKeyboardDelegate", ()=>(0, _selection.ListKeyboardDelegate));
parcelHelpers.export(exports, "useSeparator", ()=>(0, _separator.useSeparator));
parcelHelpers.export(exports, "SSRProvider", ()=>(0, _ssr.SSRProvider));
parcelHelpers.export(exports, "useIsSSR", ()=>(0, _ssr.useIsSSR));
parcelHelpers.export(exports, "useSlider", ()=>(0, _slider.useSlider));
parcelHelpers.export(exports, "useSliderThumb", ()=>(0, _slider.useSliderThumb));
parcelHelpers.export(exports, "useSwitch", ()=>(0, _switch.useSwitch));
parcelHelpers.export(exports, "useTable", ()=>(0, _table.useTable));
parcelHelpers.export(exports, "useTableCell", ()=>(0, _table.useTableCell));
parcelHelpers.export(exports, "useTableColumnHeader", ()=>(0, _table.useTableColumnHeader));
parcelHelpers.export(exports, "useTableColumnResize", ()=>(0, _table.useTableColumnResize));
parcelHelpers.export(exports, "useTableHeaderRow", ()=>(0, _table.useTableHeaderRow));
parcelHelpers.export(exports, "useTableRow", ()=>(0, _table.useTableRow));
parcelHelpers.export(exports, "useTableRowGroup", ()=>(0, _table.useTableRowGroup));
parcelHelpers.export(exports, "useTableSelectAllCheckbox", ()=>(0, _table.useTableSelectAllCheckbox));
parcelHelpers.export(exports, "useTableSelectionCheckbox", ()=>(0, _table.useTableSelectionCheckbox));
parcelHelpers.export(exports, "useTab", ()=>(0, _tabs.useTab));
parcelHelpers.export(exports, "useTabList", ()=>(0, _tabs.useTabList));
parcelHelpers.export(exports, "useTabPanel", ()=>(0, _tabs.useTabPanel));
parcelHelpers.export(exports, "useTag", ()=>(0, _tag.useTag));
parcelHelpers.export(exports, "useTagGroup", ()=>(0, _tag.useTagGroup));
parcelHelpers.export(exports, "useTextField", ()=>(0, _textfield.useTextField));
parcelHelpers.export(exports, "useTooltip", ()=>(0, _tooltip.useTooltip));
parcelHelpers.export(exports, "useTooltipTrigger", ()=>(0, _tooltip.useTooltipTrigger));
parcelHelpers.export(exports, "chain", ()=>(0, _utils.chain));
parcelHelpers.export(exports, "mergeProps", ()=>(0, _utils.mergeProps));
parcelHelpers.export(exports, "useId", ()=>(0, _utils.useId));
parcelHelpers.export(exports, "useObjectRef", ()=>(0, _utils.useObjectRef));
parcelHelpers.export(exports, "RouterProvider", ()=>(0, _utils.RouterProvider));
parcelHelpers.export(exports, "VisuallyHidden", ()=>(0, _visuallyHidden.VisuallyHidden));
parcelHelpers.export(exports, "useVisuallyHidden", ()=>(0, _visuallyHidden.useVisuallyHidden));
var _breadcrumbs = require("@react-aria/breadcrumbs");
var _button = require("@react-aria/button");
var _calendar = require("@react-aria/calendar");
var _checkbox = require("@react-aria/checkbox");
var _combobox = require("@react-aria/combobox");
var _datepicker = require("@react-aria/datepicker");
var _dialog = require("@react-aria/dialog");
var _dnd = require("@react-aria/dnd");
var _focus = require("@react-aria/focus");
var _i18N = require("@react-aria/i18n");
var _interactions = require("@react-aria/interactions");
var _label = require("@react-aria/label");
var _gridlist = require("@react-aria/gridlist");
var _link = require("@react-aria/link");
var _listbox = require("@react-aria/listbox");
var _menu = require("@react-aria/menu");
var _meter = require("@react-aria/meter");
var _numberfield = require("@react-aria/numberfield");
var _overlays = require("@react-aria/overlays");
var _progress = require("@react-aria/progress");
var _radio = require("@react-aria/radio");
var _searchfield = require("@react-aria/searchfield");
var _select = require("@react-aria/select");
var _selection = require("@react-aria/selection");
var _separator = require("@react-aria/separator");
var _ssr = require("@react-aria/ssr");
var _slider = require("@react-aria/slider");
var _switch = require("@react-aria/switch");
var _table = require("@react-aria/table");
var _tabs = require("@react-aria/tabs");
var _tag = require("@react-aria/tag");
var _textfield = require("@react-aria/textfield");
var _tooltip = require("@react-aria/tooltip");
var _utils = require("@react-aria/utils");
var _visuallyHidden = require("@react-aria/visually-hidden");

},{"@react-aria/breadcrumbs":false,"@react-aria/button":"fsdLZ","@react-aria/calendar":"98n7T","@react-aria/checkbox":"5e6Tk","@react-aria/combobox":"4enyJ","@react-aria/datepicker":"5gh3m","@react-aria/dialog":"aSQNt","@react-aria/dnd":"hi3Sh","@react-aria/focus":"42mbF","@react-aria/i18n":"411rg","@react-aria/interactions":"ky3G8","@react-aria/label":false,"@react-aria/gridlist":false,"@react-aria/link":"6MxkS","@react-aria/listbox":"bHZSJ","@react-aria/menu":"89bvn","@react-aria/meter":"9oBtl","@react-aria/numberfield":"13aeo","@react-aria/overlays":"5fTCg","@react-aria/progress":"NyXcB","@react-aria/radio":"25mgs","@react-aria/searchfield":"2RKb9","@react-aria/select":"l1sFE","@react-aria/selection":"6Fly5","@react-aria/separator":"iHEIW","@react-aria/ssr":"gmUOW","@react-aria/slider":"eOsko","@react-aria/switch":"dXthB","@react-aria/table":"jm3EF","@react-aria/tabs":"9tXWP","@react-aria/tag":"bGZEL","@react-aria/textfield":"6dEv6","@react-aria/tooltip":"kI5Vx","@react-aria/utils":"9cLk5","@react-aria/visually-hidden":"4jwxT","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"iFNvq":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useBreadcrumbItem", ()=>(0, _useBreadcrumbItem.useBreadcrumbItem));
parcelHelpers.export(exports, "useBreadcrumbs", ()=>(0, _useBreadcrumbs.useBreadcrumbs));
var _useBreadcrumbItem = require("./useBreadcrumbItem");
var _useBreadcrumbs = require("./useBreadcrumbs");

},{"./useBreadcrumbItem":"emACH","./useBreadcrumbs":"i9Unr","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"emACH":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides the behavior and accessibility implementation for an in a breadcrumbs component.
 * See `useBreadcrumbs` for details about breadcrumbs.
 */ parcelHelpers.export(exports, "useBreadcrumbItem", ()=>useBreadcrumbItem);
var _link = require("@react-aria/link");
function useBreadcrumbItem(props, ref) {
    let { isCurrent, isDisabled, "aria-current": ariaCurrent, elementType = "a", ...otherProps } = props;
    let { linkProps } = (0, _link.useLink)({
        isDisabled: isDisabled || isCurrent,
        elementType,
        ...otherProps
    }, ref);
    let isHeading = /^h[1-6]$/.test(elementType);
    let itemProps = {};
    if (!isHeading) itemProps = linkProps;
    if (isCurrent) {
        itemProps["aria-current"] = ariaCurrent || "page";
        // isCurrent sets isDisabled === true for the current item,
        // so we have to restore the tabIndex in order to support autoFocus.
        itemProps.tabIndex = props.autoFocus ? -1 : undefined;
    }
    return {
        itemProps: {
            "aria-disabled": isDisabled,
            ...itemProps
        }
    };
}

},{"@react-aria/link":"6MxkS","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"6MxkS":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useLink", ()=>(0, _useLink.useLink));
var _useLink = require("./useLink");

},{"./useLink":"5VEuS","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"5VEuS":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides the behavior and accessibility implementation for a link component.
 * A link allows a user to navigate to another page or resource within a web page
 * or application.
 */ parcelHelpers.export(exports, "useLink", ()=>useLink);
var _utils = require("@react-aria/utils");
var _focus = require("@react-aria/focus");
var _interactions = require("@react-aria/interactions");
function useLink(props, ref) {
    let { elementType = "a", onPress, onPressStart, onPressEnd, // @ts-ignore
    onClick: deprecatedOnClick, isDisabled, ...otherProps } = props;
    let linkProps = {};
    if (elementType !== "a") linkProps = {
        role: "link",
        tabIndex: !isDisabled ? 0 : undefined
    };
    let { focusableProps } = (0, _focus.useFocusable)(props, ref);
    let { pressProps, isPressed } = (0, _interactions.usePress)({
        onPress,
        onPressStart,
        onPressEnd,
        isDisabled,
        ref
    });
    let domProps = (0, _utils.filterDOMProps)(otherProps, {
        labelable: true,
        isLink: elementType === "a"
    });
    let interactionHandlers = (0, _utils.mergeProps)(focusableProps, pressProps);
    let router = (0, _utils.useRouter)();
    return {
        isPressed,
        linkProps: (0, _utils.mergeProps)(domProps, {
            ...interactionHandlers,
            ...linkProps,
            "aria-disabled": isDisabled || undefined,
            "aria-current": props["aria-current"],
            onClick: (e)=>{
                var _pressProps_onClick;
                (_pressProps_onClick = pressProps.onClick) === null || _pressProps_onClick === void 0 ? void 0 : _pressProps_onClick.call(pressProps, e);
                if (deprecatedOnClick) {
                    deprecatedOnClick(e);
                    console.warn("onClick is deprecated, please use onPress");
                }
                // If a custom router is provided, prevent default and forward if this link should client navigate.
                if (!router.isNative && e.currentTarget instanceof HTMLAnchorElement && e.currentTarget.href && // If props are applied to a router Link component, it may have already prevented default.
                !e.isDefaultPrevented() && (0, _utils.shouldClientNavigate)(e.currentTarget, e)) {
                    e.preventDefault();
                    router.open(e.currentTarget, e);
                }
            }
        })
    };
}

},{"@react-aria/utils":"9cLk5","@react-aria/focus":"42mbF","@react-aria/interactions":"ky3G8","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"9cLk5":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useId", ()=>(0, _useId.useId));
parcelHelpers.export(exports, "mergeIds", ()=>(0, _useId.mergeIds));
parcelHelpers.export(exports, "useSlotId", ()=>(0, _useId.useSlotId));
parcelHelpers.export(exports, "chain", ()=>(0, _chain.chain));
parcelHelpers.export(exports, "getOwnerDocument", ()=>(0, _domHelpers.getOwnerDocument));
parcelHelpers.export(exports, "getOwnerWindow", ()=>(0, _domHelpers.getOwnerWindow));
parcelHelpers.export(exports, "mergeProps", ()=>(0, _mergeProps.mergeProps));
parcelHelpers.export(exports, "mergeRefs", ()=>(0, _mergeRefs.mergeRefs));
parcelHelpers.export(exports, "filterDOMProps", ()=>(0, _filterDOMProps.filterDOMProps));
parcelHelpers.export(exports, "focusWithoutScrolling", ()=>(0, _focusWithoutScrolling.focusWithoutScrolling));
parcelHelpers.export(exports, "getOffset", ()=>(0, _getOffset.getOffset));
parcelHelpers.export(exports, "openLink", ()=>(0, _openLink.openLink));
parcelHelpers.export(exports, "getSyntheticLinkProps", ()=>(0, _openLink.getSyntheticLinkProps));
parcelHelpers.export(exports, "RouterProvider", ()=>(0, _openLink.RouterProvider));
parcelHelpers.export(exports, "shouldClientNavigate", ()=>(0, _openLink.shouldClientNavigate));
parcelHelpers.export(exports, "useRouter", ()=>(0, _openLink.useRouter));
parcelHelpers.export(exports, "runAfterTransition", ()=>(0, _runAfterTransition.runAfterTransition));
parcelHelpers.export(exports, "useDrag1D", ()=>(0, _useDrag1D.useDrag1D));
parcelHelpers.export(exports, "useGlobalListeners", ()=>(0, _useGlobalListeners.useGlobalListeners));
parcelHelpers.export(exports, "useLabels", ()=>(0, _useLabels.useLabels));
parcelHelpers.export(exports, "useObjectRef", ()=>(0, _useObjectRef.useObjectRef));
parcelHelpers.export(exports, "useUpdateEffect", ()=>(0, _useUpdateEffect.useUpdateEffect));
parcelHelpers.export(exports, "useLayoutEffect", ()=>(0, _useLayoutEffect.useLayoutEffect));
parcelHelpers.export(exports, "useResizeObserver", ()=>(0, _useResizeObserver.useResizeObserver));
parcelHelpers.export(exports, "useSyncRef", ()=>(0, _useSyncRef.useSyncRef));
parcelHelpers.export(exports, "getScrollParent", ()=>(0, _getScrollParent.getScrollParent));
parcelHelpers.export(exports, "isScrollable", ()=>(0, _getScrollParent.isScrollable));
parcelHelpers.export(exports, "useViewportSize", ()=>(0, _useViewportSize.useViewportSize));
parcelHelpers.export(exports, "useDescription", ()=>(0, _useDescription.useDescription));
parcelHelpers.export(exports, "isMac", ()=>(0, _platform.isMac));
parcelHelpers.export(exports, "isIPhone", ()=>(0, _platform.isIPhone));
parcelHelpers.export(exports, "isIPad", ()=>(0, _platform.isIPad));
parcelHelpers.export(exports, "isIOS", ()=>(0, _platform.isIOS));
parcelHelpers.export(exports, "isAppleDevice", ()=>(0, _platform.isAppleDevice));
parcelHelpers.export(exports, "isWebKit", ()=>(0, _platform.isWebKit));
parcelHelpers.export(exports, "isChrome", ()=>(0, _platform.isChrome));
parcelHelpers.export(exports, "isAndroid", ()=>(0, _platform.isAndroid));
parcelHelpers.export(exports, "isFirefox", ()=>(0, _platform.isFirefox));
parcelHelpers.export(exports, "useEvent", ()=>(0, _useEvent.useEvent));
parcelHelpers.export(exports, "useValueEffect", ()=>(0, _useValueEffect.useValueEffect));
parcelHelpers.export(exports, "scrollIntoView", ()=>(0, _scrollIntoView.scrollIntoView));
parcelHelpers.export(exports, "scrollIntoViewport", ()=>(0, _scrollIntoView.scrollIntoViewport));
parcelHelpers.export(exports, "clamp", ()=>(0, _utils.clamp));
parcelHelpers.export(exports, "snapValueToStep", ()=>(0, _utils.snapValueToStep));
parcelHelpers.export(exports, "isVirtualClick", ()=>(0, _isVirtualEvent.isVirtualClick));
parcelHelpers.export(exports, "isVirtualPointerEvent", ()=>(0, _isVirtualEvent.isVirtualPointerEvent));
parcelHelpers.export(exports, "useEffectEvent", ()=>(0, _useEffectEvent.useEffectEvent));
parcelHelpers.export(exports, "useDeepMemo", ()=>(0, _useDeepMemo.useDeepMemo));
parcelHelpers.export(exports, "useFormReset", ()=>(0, _useFormReset.useFormReset));
var _useId = require("./useId");
var _chain = require("./chain");
var _domHelpers = require("./domHelpers");
var _mergeProps = require("./mergeProps");
var _mergeRefs = require("./mergeRefs");
var _filterDOMProps = require("./filterDOMProps");
var _focusWithoutScrolling = require("./focusWithoutScrolling");
var _getOffset = require("./getOffset");
var _openLink = require("./openLink");
var _runAfterTransition = require("./runAfterTransition");
var _useDrag1D = require("./useDrag1D");
var _useGlobalListeners = require("./useGlobalListeners");
var _useLabels = require("./useLabels");
var _useObjectRef = require("./useObjectRef");
var _useUpdateEffect = require("./useUpdateEffect");
var _useLayoutEffect = require("./useLayoutEffect");
var _useResizeObserver = require("./useResizeObserver");
var _useSyncRef = require("./useSyncRef");
var _getScrollParent = require("./getScrollParent");
var _useViewportSize = require("./useViewportSize");
var _useDescription = require("./useDescription");
var _platform = require("./platform");
var _useEvent = require("./useEvent");
var _useValueEffect = require("./useValueEffect");
var _scrollIntoView = require("./scrollIntoView");
var _utils = require("@react-stately/utils");
var _isVirtualEvent = require("./isVirtualEvent");
var _useEffectEvent = require("./useEffectEvent");
var _useDeepMemo = require("./useDeepMemo");
var _useFormReset = require("./useFormReset");

},{"./useId":"cPhyT","./chain":"1ak1E","./domHelpers":"lVhtl","./mergeProps":"k86oH","./mergeRefs":"h73y7","./filterDOMProps":"sSr6U","./focusWithoutScrolling":"5LN9J","./getOffset":false,"./openLink":"kRWZ7","./runAfterTransition":"eLFpX","./useDrag1D":false,"./useGlobalListeners":"gWnOe","./useLabels":"hmCod","./useObjectRef":"FWYx9","./useUpdateEffect":"gVJtp","./useLayoutEffect":"2YWAV","./useResizeObserver":"gWrt6","./useSyncRef":"9Rtfq","./getScrollParent":"6pNec","./useViewportSize":"1oFmo","./useDescription":"1RO58","./platform":"7ccvD","./useEvent":"2V2Xv","./useValueEffect":"aKsrM","./scrollIntoView":"lFGgH","@react-stately/utils":"cpDPf","./isVirtualEvent":"bokul","./useEffectEvent":"iogYk","./useDeepMemo":"ddTYK","./useFormReset":"huxwi","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"cPhyT":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * If a default is not provided, generate an id.
 * @param defaultId - Default component id.
 */ parcelHelpers.export(exports, "useId", ()=>useId);
/**
 * Merges two ids.
 * Different ids will trigger a side-effect and re-render components hooked up with `useId`.
 */ parcelHelpers.export(exports, "mergeIds", ()=>mergeIds);
/**
 * Used to generate an id, and after render, check if that id is rendered so we know
 * if we can use it in places such as labelledby.
 * @param depArray - When to recalculate if the id is in the DOM.
 */ parcelHelpers.export(exports, "useSlotId", ()=>useSlotId);
var _react = require("react");
var _useLayoutEffect = require("./useLayoutEffect");
var _ssr = require("@react-aria/ssr");
var _ = require("./");
// copied from SSRProvider.tsx to reduce exports, if needed again, consider sharing
let canUseDOM = Boolean(typeof window !== "undefined" && window.document && window.document.createElement);
let idsUpdaterMap = new Map();
function useId(defaultId) {
    let [value, setValue] = (0, _react.useState)(defaultId);
    let nextId = (0, _react.useRef)(null);
    let res = (0, _ssr.useSSRSafeId)(value);
    let updateValue = (0, _react.useCallback)((val)=>{
        nextId.current = val;
    }, []);
    if (canUseDOM) idsUpdaterMap.set(res, updateValue);
    (0, _useLayoutEffect.useLayoutEffect)(()=>{
        let r = res;
        return ()=>{
            idsUpdaterMap.delete(r);
        };
    }, [
        res
    ]);
    // This cannot cause an infinite loop because the ref is updated first.
    // eslint-disable-next-line
    (0, _react.useEffect)(()=>{
        let newId = nextId.current;
        if (newId) {
            nextId.current = null;
            setValue(newId);
        }
    });
    return res;
}
function mergeIds(idA, idB) {
    if (idA === idB) return idA;
    let setIdA = idsUpdaterMap.get(idA);
    if (setIdA) {
        setIdA(idB);
        return idB;
    }
    let setIdB = idsUpdaterMap.get(idB);
    if (setIdB) {
        setIdB(idA);
        return idA;
    }
    return idB;
}
function useSlotId(depArray = []) {
    let id = useId();
    let [resolvedId, setResolvedId] = (0, _.useValueEffect)(id);
    let updateId = (0, _react.useCallback)(()=>{
        setResolvedId(function*() {
            yield id;
            yield document.getElementById(id) ? id : undefined;
        });
    }, [
        id,
        setResolvedId
    ]);
    (0, _useLayoutEffect.useLayoutEffect)(updateId, [
        id,
        updateId,
        ...depArray
    ]);
    return resolvedId;
}

},{"react":"9yzVZ","./useLayoutEffect":"2YWAV","@react-aria/ssr":"gmUOW","./":"9cLk5","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"2YWAV":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useLayoutEffect", ()=>useLayoutEffect);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const useLayoutEffect = typeof document !== "undefined" ? (0, _reactDefault.default).useLayoutEffect : ()=>{};

},{"react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"gmUOW":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SSRProvider", ()=>(0, _ssrprovider.SSRProvider));
parcelHelpers.export(exports, "useSSRSafeId", ()=>(0, _ssrprovider.useSSRSafeId));
parcelHelpers.export(exports, "useIsSSR", ()=>(0, _ssrprovider.useIsSSR));
var _ssrprovider = require("./SSRProvider");

},{"./SSRProvider":"ksCHA","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"ksCHA":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // We must avoid a circular dependency with @react-aria/utils, and this useLayoutEffect is
// guarded by a check that it only runs on the client side.
// eslint-disable-next-line rulesdir/useLayoutEffectRule
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * When using SSR with React Aria in React 16 or 17, applications must be wrapped in an SSRProvider.
 * This ensures that auto generated ids are consistent between the client and server.
 */ parcelHelpers.export(exports, "SSRProvider", ()=>SSRProvider);
parcelHelpers.export(exports, "useSSRSafeId", ()=>useSSRSafeId);
/**
 * Returns whether the component is currently being server side rendered or
 * hydrated on the client. Can be used to delay browser-specific rendering
 * until after hydration.
 */ parcelHelpers.export(exports, "useIsSSR", ()=>useIsSSR);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
// Default context value to use in case there is no SSRProvider. This is fine for
// client-only apps. In order to support multiple copies of React Aria potentially
// being on the page at once, the prefix is set to a random number. SSRProvider
// will reset this to zero for consistency between server and client, so in the
// SSR case multiple copies of React Aria is not supported.
const defaultContext = {
    prefix: String(Math.round(Math.random() * 10000000000)),
    current: 0
};
const SSRContext = /*#__PURE__*/ (0, _reactDefault.default).createContext(defaultContext);
const IsSSRContext = /*#__PURE__*/ (0, _reactDefault.default).createContext(false);
// This is only used in React < 18.
function LegacySSRProvider(props) {
    let cur = (0, _react.useContext)(SSRContext);
    let counter = useCounter(cur === defaultContext);
    let [isSSR, setIsSSR] = (0, _react.useState)(true);
    let value = (0, _react.useMemo)(()=>({
            // If this is the first SSRProvider, start with an empty string prefix, otherwise
            // append and increment the counter.
            prefix: cur === defaultContext ? "" : `${cur.prefix}-${counter}`,
            current: 0
        }), [
        cur,
        counter
    ]);
    // If on the client, and the component was initially server rendered,
    // then schedule a layout effect to update the component after hydration.
    if (typeof document !== "undefined") // This if statement technically breaks the rules of hooks, but is safe
    // because the condition never changes after mounting.
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, _react.useLayoutEffect)(()=>{
        setIsSSR(false);
    }, []);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(SSRContext.Provider, {
        value: value
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(IsSSRContext.Provider, {
        value: isSSR
    }, props.children));
}
let warnedAboutSSRProvider = false;
function SSRProvider(props) {
    if (typeof (0, _reactDefault.default)["useId"] === "function") {
        if (!warnedAboutSSRProvider) {
            console.warn("In React 18, SSRProvider is not necessary and is a noop. You can remove it from your app.");
            warnedAboutSSRProvider = true;
        }
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, props.children);
    }
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(LegacySSRProvider, props);
}
let canUseDOM = Boolean(typeof window !== "undefined" && window.document && window.document.createElement);
let componentIds = new WeakMap();
function useCounter(isDisabled = false) {
    let ctx = (0, _react.useContext)(SSRContext);
    let ref = (0, _react.useRef)(null);
    // eslint-disable-next-line rulesdir/pure-render
    if (ref.current === null && !isDisabled) {
        var _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner, _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
        // In strict mode, React renders components twice, and the ref will be reset to null on the second render.
        // This means our id counter will be incremented twice instead of once. This is a problem because on the
        // server, components are only rendered once and so ids generated on the server won't match the client.
        // In React 18, useId was introduced to solve this, but it is not available in older versions. So to solve this
        // we need to use some React internals to access the underlying Fiber instance, which is stable between renders.
        // This is exposed as ReactCurrentOwner in development, which is all we need since StrictMode only runs in development.
        // To ensure that we only increment the global counter once, we store the starting id for this component in
        // a weak map associated with the Fiber. On the second render, we reset the global counter to this value.
        // Since React runs the second render immediately after the first, this is safe.
        // @ts-ignore
        let currentOwner = (_React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = (0, _reactDefault.default).__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED) === null || _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED === void 0 ? void 0 : (_React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner = _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner) === null || _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner === void 0 ? void 0 : _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner.current;
        if (currentOwner) {
            let prevComponentValue = componentIds.get(currentOwner);
            if (prevComponentValue == null) // On the first render, and first call to useId, store the id and state in our weak map.
            componentIds.set(currentOwner, {
                id: ctx.current,
                state: currentOwner.memoizedState
            });
            else if (currentOwner.memoizedState !== prevComponentValue.state) {
                // On the second render, the memoizedState gets reset by React.
                // Reset the counter, and remove from the weak map so we don't
                // do this for subsequent useId calls.
                ctx.current = prevComponentValue.id;
                componentIds.delete(currentOwner);
            }
        }
        // eslint-disable-next-line rulesdir/pure-render
        ref.current = ++ctx.current;
    }
    // eslint-disable-next-line rulesdir/pure-render
    return ref.current;
}
function useLegacySSRSafeId(defaultId) {
    let ctx = (0, _react.useContext)(SSRContext);
    // If we are rendering in a non-DOM environment, and there's no SSRProvider,
    // provide a warning to hint to the developer to add one.
    if (ctx === defaultContext && !canUseDOM) console.warn("When server rendering, you must wrap your application in an <SSRProvider> to ensure consistent ids are generated between the client and server.");
    let counter = useCounter(!!defaultId);
    let prefix = `react-aria${ctx.prefix}`;
    return defaultId || `${prefix}-${counter}`;
}
function useModernSSRSafeId(defaultId) {
    // @ts-ignore
    let id = (0, _reactDefault.default).useId();
    let [didSSR] = (0, _react.useState)(useIsSSR());
    let prefix = didSSR || false ? "react-aria" : `react-aria${defaultContext.prefix}`;
    return defaultId || `${prefix}-${id}`;
}
const useSSRSafeId = typeof (0, _reactDefault.default)["useId"] === "function" ? useModernSSRSafeId : useLegacySSRSafeId;
function getSnapshot() {
    return false;
}
function getServerSnapshot() {
    return true;
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function subscribe(onStoreChange) {
    // noop
    return ()=>{};
}
function useIsSSR() {
    // In React 18, we can use useSyncExternalStore to detect if we're server rendering or hydrating.
    if (typeof (0, _reactDefault.default)["useSyncExternalStore"] === "function") return (0, _reactDefault.default)["useSyncExternalStore"](subscribe, getSnapshot, getServerSnapshot);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return (0, _react.useContext)(IsSSRContext);
}

},{"react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"1ak1E":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /**
 * Calls all functions in the order they were chained with the same arguments.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "chain", ()=>chain);
function chain(...callbacks) {
    return (...args)=>{
        for (let callback of callbacks)if (typeof callback === "function") callback(...args);
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"lVhtl":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getOwnerDocument", ()=>getOwnerDocument);
parcelHelpers.export(exports, "getOwnerWindow", ()=>getOwnerWindow);
const getOwnerDocument = (el)=>{
    var _el_ownerDocument;
    return (_el_ownerDocument = el === null || el === void 0 ? void 0 : el.ownerDocument) !== null && _el_ownerDocument !== void 0 ? _el_ownerDocument : document;
};
const getOwnerWindow = (el)=>{
    if (el && "window" in el && el.window === el) return el;
    const doc = getOwnerDocument(el);
    return doc.defaultView || window;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"k86oH":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Merges multiple props objects together. Event handlers are chained,
 * classNames are combined, and ids are deduplicated - different ids
 * will trigger a side-effect and re-render components hooked up with `useId`.
 * For all other props, the last prop object overrides all previous ones.
 * @param args - Multiple sets of props to merge together.
 */ parcelHelpers.export(exports, "mergeProps", ()=>mergeProps);
var _chain = require("./chain");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _useId = require("./useId");
function mergeProps(...args) {
    // Start with a base clone of the first argument. This is a lot faster than starting
    // with an empty object and adding properties as we go.
    let result = {
        ...args[0]
    };
    for(let i = 1; i < args.length; i++){
        let props = args[i];
        for(let key in props){
            let a = result[key];
            let b = props[key];
            // Chain events
            if (typeof a === "function" && typeof b === "function" && // This is a lot faster than a regex.
            key[0] === "o" && key[1] === "n" && key.charCodeAt(2) >= /* 'A' */ 65 && key.charCodeAt(2) <= /* 'Z' */ 90) result[key] = (0, _chain.chain)(a, b);
            else if ((key === "className" || key === "UNSAFE_className") && typeof a === "string" && typeof b === "string") result[key] = (0, _clsxDefault.default)(a, b);
            else if (key === "id" && a && b) result.id = (0, _useId.mergeIds)(a, b);
            else result[key] = b !== undefined ? b : a;
        }
    }
    return result;
}

},{"./chain":"1ak1E","clsx":"fAYNK","./useId":"cPhyT","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"fAYNK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "clsx", ()=>clsx);
function r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) for(t = 0; t < e.length; t++)e[t] && (f = r(e[t])) && (n && (n += " "), n += f);
        else for(t in e)e[t] && (n && (n += " "), n += t);
    }
    return n;
}
function clsx() {
    for(var e, t, f = 0, n = ""; f < arguments.length;)(e = arguments[f++]) && (t = r(e)) && (n && (n += " "), n += t);
    return n;
}
exports.default = clsx;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"h73y7":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Merges multiple refs into one. Works with either callback or object refs.
 */ parcelHelpers.export(exports, "mergeRefs", ()=>mergeRefs);
function mergeRefs(...refs) {
    if (refs.length === 1) return refs[0];
    return (value)=>{
        for (let ref of refs){
            if (typeof ref === "function") ref(value);
            else if (ref != null) ref.current = value;
        }
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"sSr6U":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Filters out all props that aren't valid DOM props or defined via override prop obj.
 * @param props - The component props to be filtered.
 * @param opts - Props to override.
 */ parcelHelpers.export(exports, "filterDOMProps", ()=>filterDOMProps);
const DOMPropNames = new Set([
    "id"
]);
const labelablePropNames = new Set([
    "aria-label",
    "aria-labelledby",
    "aria-describedby",
    "aria-details"
]);
// See LinkDOMProps in dom.d.ts.
const linkPropNames = new Set([
    "href",
    "target",
    "rel",
    "download",
    "ping",
    "referrerPolicy"
]);
const propRe = /^(data-.*)$/;
function filterDOMProps(props, opts = {}) {
    let { labelable, isLink, propNames } = opts;
    let filteredProps = {};
    for(const prop in props)if (Object.prototype.hasOwnProperty.call(props, prop) && (DOMPropNames.has(prop) || labelable && labelablePropNames.has(prop) || isLink && linkPropNames.has(prop) || (propNames === null || propNames === void 0 ? void 0 : propNames.has(prop)) || propRe.test(prop))) filteredProps[prop] = props[prop];
    return filteredProps;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"5LN9J":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "focusWithoutScrolling", ()=>focusWithoutScrolling);
function focusWithoutScrolling(element) {
    if (supportsPreventScroll()) element.focus({
        preventScroll: true
    });
    else {
        let scrollableElements = getScrollableElements(element);
        element.focus();
        restoreScrollPosition(scrollableElements);
    }
}
let supportsPreventScrollCached = null;
function supportsPreventScroll() {
    if (supportsPreventScrollCached == null) {
        supportsPreventScrollCached = false;
        try {
            let focusElem = document.createElement("div");
            focusElem.focus({
                get preventScroll () {
                    supportsPreventScrollCached = true;
                    return true;
                }
            });
        } catch (e) {
        // Ignore
        }
    }
    return supportsPreventScrollCached;
}
function getScrollableElements(element) {
    let parent = element.parentNode;
    let scrollableElements = [];
    let rootScrollingElement = document.scrollingElement || document.documentElement;
    while(parent instanceof HTMLElement && parent !== rootScrollingElement){
        if (parent.offsetHeight < parent.scrollHeight || parent.offsetWidth < parent.scrollWidth) scrollableElements.push({
            element: parent,
            scrollTop: parent.scrollTop,
            scrollLeft: parent.scrollLeft
        });
        parent = parent.parentNode;
    }
    if (rootScrollingElement instanceof HTMLElement) scrollableElements.push({
        element: rootScrollingElement,
        scrollTop: rootScrollingElement.scrollTop,
        scrollLeft: rootScrollingElement.scrollLeft
    });
    return scrollableElements;
}
function restoreScrollPosition(scrollableElements) {
    for (let { element, scrollTop, scrollLeft } of scrollableElements){
        element.scrollTop = scrollTop;
        element.scrollLeft = scrollLeft;
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"kRWZ7":[function(require,module,exports) {
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * A RouterProvider accepts a `navigate` function from a framework or client side router,
 * and provides it to all nested React Aria links to enable client side navigation.
 */ parcelHelpers.export(exports, "RouterProvider", ()=>RouterProvider);
parcelHelpers.export(exports, "useRouter", ()=>useRouter);
parcelHelpers.export(exports, "shouldClientNavigate", ()=>shouldClientNavigate);
parcelHelpers.export(exports, "openLink", ()=>openLink);
parcelHelpers.export(exports, "getSyntheticLinkProps", ()=>getSyntheticLinkProps);
var _index = require("./index");
var _platform = require("./platform");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const RouterContext = /*#__PURE__*/ (0, _react.createContext)({
    isNative: true,
    open: openSyntheticLink
});
function RouterProvider(props) {
    let { children, navigate } = props;
    let ctx = (0, _react.useMemo)(()=>({
            isNative: false,
            open: (target, modifiers)=>{
                getSyntheticLink(target, (link)=>{
                    if (shouldClientNavigate(link, modifiers)) navigate(link.pathname + link.search + link.hash);
                    else openLink(link, modifiers);
                });
            }
        }), [
        navigate
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(RouterContext.Provider, {
        value: ctx
    }, children);
}
function useRouter() {
    return (0, _react.useContext)(RouterContext);
}
function shouldClientNavigate(link, modifiers) {
    // Use getAttribute here instead of link.target. Firefox will default link.target to "_parent" when inside an iframe.
    let target = link.getAttribute("target");
    return (!target || target === "_self") && link.origin === location.origin && !link.hasAttribute("download") && !modifiers.metaKey && // open in new tab (mac)
    !modifiers.ctrlKey && // open in new tab (windows)
    !modifiers.altKey && // download
    !modifiers.shiftKey;
}
function openLink(target, modifiers, setOpening = true) {
    var _window_event_type, _window_event;
    let { metaKey, ctrlKey, altKey, shiftKey } = modifiers;
    // Firefox does not recognize keyboard events as a user action by default, and the popup blocker
    // will prevent links with target="_blank" from opening. However, it does allow the event if the
    // Command/Control key is held, which opens the link in a background tab. This seems like the best we can do.
    // See https://bugzilla.mozilla.org/show_bug.cgi?id=257870 and https://bugzilla.mozilla.org/show_bug.cgi?id=746640.
    if ((0, _platform.isFirefox)() && ((_window_event = window.event) === null || _window_event === void 0 ? void 0 : (_window_event_type = _window_event.type) === null || _window_event_type === void 0 ? void 0 : _window_event_type.startsWith("key")) && target.target === "_blank") {
        if ((0, _index.isMac)()) metaKey = true;
        else ctrlKey = true;
    }
    // WebKit does not support firing click events with modifier keys, but does support keyboard events.
    // https://github.com/WebKit/WebKit/blob/c03d0ac6e6db178f90923a0a63080b5ca210d25f/Source/WebCore/html/HTMLAnchorElement.cpp#L184
    let event = (0, _index.isWebKit)() && (0, _index.isMac)() && !(0, _platform.isIPad)() && true ? new KeyboardEvent("keydown", {
        keyIdentifier: "Enter",
        metaKey,
        ctrlKey,
        altKey,
        shiftKey
    }) : new MouseEvent("click", {
        metaKey,
        ctrlKey,
        altKey,
        shiftKey,
        bubbles: true,
        cancelable: true
    });
    openLink.isOpening = setOpening;
    (0, _index.focusWithoutScrolling)(target);
    target.dispatchEvent(event);
    openLink.isOpening = false;
}
// https://github.com/parcel-bundler/parcel/issues/8724
openLink.isOpening = false;
function getSyntheticLink(target, open) {
    if (target instanceof HTMLAnchorElement) open(target);
    else if (target.hasAttribute("data-href")) {
        let link = document.createElement("a");
        link.href = target.getAttribute("data-href");
        if (target.hasAttribute("data-target")) link.target = target.getAttribute("data-target");
        if (target.hasAttribute("data-rel")) link.rel = target.getAttribute("data-rel");
        if (target.hasAttribute("data-download")) link.download = target.getAttribute("data-download");
        if (target.hasAttribute("data-ping")) link.ping = target.getAttribute("data-ping");
        if (target.hasAttribute("data-referrer-policy")) link.referrerPolicy = target.getAttribute("data-referrer-policy");
        target.appendChild(link);
        open(link);
        target.removeChild(link);
    }
}
function openSyntheticLink(target, modifiers) {
    getSyntheticLink(target, (link)=>openLink(link, modifiers));
}
function getSyntheticLinkProps(props) {
    return {
        "data-href": props.href,
        "data-target": props.target,
        "data-rel": props.rel,
        "data-download": props.download,
        "data-ping": props.ping,
        "data-referrer-policy": props.referrerPolicy
    };
}

},{"./index":"9cLk5","./platform":"7ccvD","react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"7ccvD":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isMac", ()=>isMac);
parcelHelpers.export(exports, "isIPhone", ()=>isIPhone);
parcelHelpers.export(exports, "isIPad", ()=>isIPad);
parcelHelpers.export(exports, "isIOS", ()=>isIOS);
parcelHelpers.export(exports, "isAppleDevice", ()=>isAppleDevice);
parcelHelpers.export(exports, "isWebKit", ()=>isWebKit);
parcelHelpers.export(exports, "isChrome", ()=>isChrome);
parcelHelpers.export(exports, "isAndroid", ()=>isAndroid);
parcelHelpers.export(exports, "isFirefox", ()=>isFirefox);
function testUserAgent(re) {
    var _window_navigator_userAgentData;
    if (typeof window === "undefined" || window.navigator == null) return false;
    return ((_window_navigator_userAgentData = window.navigator["userAgentData"]) === null || _window_navigator_userAgentData === void 0 ? void 0 : _window_navigator_userAgentData.brands.some((brand)=>re.test(brand.brand))) || re.test(window.navigator.userAgent);
}
function testPlatform(re) {
    var _window_navigator_userAgentData;
    return typeof window !== "undefined" && window.navigator != null ? re.test(((_window_navigator_userAgentData = window.navigator["userAgentData"]) === null || _window_navigator_userAgentData === void 0 ? void 0 : _window_navigator_userAgentData.platform) || window.navigator.platform) : false;
}
function isMac() {
    return testPlatform(/^Mac/i);
}
function isIPhone() {
    return testPlatform(/^iPhone/i);
}
function isIPad() {
    return testPlatform(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
    isMac() && navigator.maxTouchPoints > 1;
}
function isIOS() {
    return isIPhone() || isIPad();
}
function isAppleDevice() {
    return isMac() || isIOS();
}
function isWebKit() {
    return testUserAgent(/AppleWebKit/i) && !isChrome();
}
function isChrome() {
    return testUserAgent(/Chrome/i);
}
function isAndroid() {
    return testUserAgent(/Android/i);
}
function isFirefox() {
    return testUserAgent(/Firefox/i);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"eLFpX":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // We store a global list of elements that are currently transitioning,
// mapped to a set of CSS properties that are transitioning for that element.
// This is necessary rather than a simple count of transitions because of browser
// bugs, e.g. Chrome sometimes fires both transitionend and transitioncancel rather
// than one or the other. So we need to track what's actually transitioning so that
// we can ignore these duplicate events.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "runAfterTransition", ()=>runAfterTransition);
let transitionsByElement = new Map();
// A list of callbacks to call once there are no transitioning elements.
let transitionCallbacks = new Set();
function setupGlobalEvents() {
    if (typeof window === "undefined") return;
    function isTransitionEvent(event) {
        return "propertyName" in event;
    }
    let onTransitionStart = (e)=>{
        if (!isTransitionEvent(e) || !e.target) return;
        // Add the transitioning property to the list for this element.
        let transitions = transitionsByElement.get(e.target);
        if (!transitions) {
            transitions = new Set();
            transitionsByElement.set(e.target, transitions);
            // The transitioncancel event must be registered on the element itself, rather than as a global
            // event. This enables us to handle when the node is deleted from the document while it is transitioning.
            // In that case, the cancel event would have nowhere to bubble to so we need to handle it directly.
            e.target.addEventListener("transitioncancel", onTransitionEnd, {
                once: true
            });
        }
        transitions.add(e.propertyName);
    };
    let onTransitionEnd = (e)=>{
        if (!isTransitionEvent(e) || !e.target) return;
        // Remove property from list of transitioning properties.
        let properties = transitionsByElement.get(e.target);
        if (!properties) return;
        properties.delete(e.propertyName);
        // If empty, remove transitioncancel event, and remove the element from the list of transitioning elements.
        if (properties.size === 0) {
            e.target.removeEventListener("transitioncancel", onTransitionEnd);
            transitionsByElement.delete(e.target);
        }
        // If no transitioning elements, call all of the queued callbacks.
        if (transitionsByElement.size === 0) {
            for (let cb of transitionCallbacks)cb();
            transitionCallbacks.clear();
        }
    };
    document.body.addEventListener("transitionrun", onTransitionStart);
    document.body.addEventListener("transitionend", onTransitionEnd);
}
if (typeof document !== "undefined") {
    if (document.readyState !== "loading") setupGlobalEvents();
    else document.addEventListener("DOMContentLoaded", setupGlobalEvents);
}
function runAfterTransition(fn) {
    // Wait one frame to see if an animation starts, e.g. a transition on mount.
    requestAnimationFrame(()=>{
        // If no transitions are running, call the function immediately.
        // Otherwise, add it to a list of callbacks to run at the end of the animation.
        if (transitionsByElement.size === 0) fn();
        else transitionCallbacks.add(fn);
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"gWnOe":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useGlobalListeners", ()=>useGlobalListeners);
var _react = require("react");
function useGlobalListeners() {
    let globalListeners = (0, _react.useRef)(new Map());
    let addGlobalListener = (0, _react.useCallback)((eventTarget, type, listener, options)=>{
        // Make sure we remove the listener after it is called with the `once` option.
        let fn = (options === null || options === void 0 ? void 0 : options.once) ? (...args)=>{
            globalListeners.current.delete(listener);
            listener(...args);
        } : listener;
        globalListeners.current.set(listener, {
            type,
            eventTarget,
            fn,
            options
        });
        eventTarget.addEventListener(type, listener, options);
    }, []);
    let removeGlobalListener = (0, _react.useCallback)((eventTarget, type, listener, options)=>{
        var _globalListeners_current_get;
        let fn = ((_globalListeners_current_get = globalListeners.current.get(listener)) === null || _globalListeners_current_get === void 0 ? void 0 : _globalListeners_current_get.fn) || listener;
        eventTarget.removeEventListener(type, fn, options);
        globalListeners.current.delete(listener);
    }, []);
    let removeAllGlobalListeners = (0, _react.useCallback)(()=>{
        globalListeners.current.forEach((value, key)=>{
            removeGlobalListener(value.eventTarget, value.type, key, value.options);
        });
    }, [
        removeGlobalListener
    ]);
    // eslint-disable-next-line arrow-body-style
    (0, _react.useEffect)(()=>{
        return removeAllGlobalListeners;
    }, [
        removeAllGlobalListeners
    ]);
    return {
        addGlobalListener,
        removeGlobalListener,
        removeAllGlobalListeners
    };
}

},{"react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"hmCod":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Merges aria-label and aria-labelledby into aria-labelledby when both exist.
 * @param props - Aria label props.
 * @param defaultLabel - Default value for aria-label when not present.
 */ parcelHelpers.export(exports, "useLabels", ()=>useLabels);
var _useId = require("./useId");
function useLabels(props, defaultLabel) {
    let { id, "aria-label": label, "aria-labelledby": labelledBy } = props;
    // If there is both an aria-label and aria-labelledby,
    // combine them by pointing to the element itself.
    id = (0, _useId.useId)(id);
    if (labelledBy && label) {
        let ids = new Set([
            id,
            ...labelledBy.trim().split(/\s+/)
        ]);
        labelledBy = [
            ...ids
        ].join(" ");
    } else if (labelledBy) labelledBy = labelledBy.trim().split(/\s+/).join(" ");
    // If no labels are provided, use the default
    if (!label && !labelledBy && defaultLabel) label = defaultLabel;
    return {
        id,
        "aria-label": label,
        "aria-labelledby": labelledBy
    };
}

},{"./useId":"cPhyT","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"FWYx9":[function(require,module,exports) {
/*
 * Copyright 2021 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Offers an object ref for a given callback ref or an object ref. Especially
 * helfpul when passing forwarded refs (created using `React.forwardRef`) to
 * React Aria hooks.
 *
 * @param forwardedRef The original ref intended to be used.
 * @returns An object ref that updates the given ref.
 * @see https://reactjs.org/docs/forwarding-refs.html
 */ parcelHelpers.export(exports, "useObjectRef", ()=>useObjectRef);
var _react = require("react");
function useObjectRef(forwardedRef) {
    const objRef = (0, _react.useRef)(null);
    return (0, _react.useMemo)(()=>({
            get current () {
                return objRef.current;
            },
            set current (value){
                objRef.current = value;
                if (typeof forwardedRef === "function") forwardedRef(value);
                else if (forwardedRef) forwardedRef.current = value;
            }
        }), [
        forwardedRef
    ]);
}

},{"react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"gVJtp":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// Like useEffect, but only called for updates after the initial render.
parcelHelpers.export(exports, "useUpdateEffect", ()=>useUpdateEffect);
var _react = require("react");
function useUpdateEffect(effect, dependencies) {
    const isInitialMount = (0, _react.useRef)(true);
    const lastDeps = (0, _react.useRef)(null);
    (0, _react.useEffect)(()=>{
        isInitialMount.current = true;
        return ()=>{
            isInitialMount.current = false;
        };
    }, []);
    (0, _react.useEffect)(()=>{
        if (isInitialMount.current) isInitialMount.current = false;
        else if (!lastDeps.current || dependencies.some((dep, i)=>!Object.is(dep, lastDeps[i]))) effect();
        lastDeps.current = dependencies;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, dependencies);
}

},{"react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"gWrt6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useResizeObserver", ()=>useResizeObserver);
var _react = require("react");
function hasResizeObserver() {
    return typeof window.ResizeObserver !== "undefined";
}
function useResizeObserver(options) {
    const { ref, onResize } = options;
    (0, _react.useEffect)(()=>{
        let element = ref === null || ref === void 0 ? void 0 : ref.current;
        if (!element) return;
        if (!hasResizeObserver()) {
            window.addEventListener("resize", onResize, false);
            return ()=>{
                window.removeEventListener("resize", onResize, false);
            };
        } else {
            const resizeObserverInstance = new window.ResizeObserver((entries)=>{
                if (!entries.length) return;
                onResize();
            });
            resizeObserverInstance.observe(element);
            return ()=>{
                if (element) resizeObserverInstance.unobserve(element);
            };
        }
    }, [
        onResize,
        ref
    ]);
}

},{"react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"9Rtfq":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// Syncs ref from context with ref passed to hook
parcelHelpers.export(exports, "useSyncRef", ()=>useSyncRef);
var _ = require("./");
function useSyncRef(context, ref) {
    (0, _.useLayoutEffect)(()=>{
        if (context && context.ref && ref) {
            context.ref.current = ref.current;
            return ()=>{
                if (context.ref) context.ref.current = null;
            };
        }
    });
}

},{"./":"9cLk5","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"6pNec":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getScrollParent", ()=>getScrollParent);
parcelHelpers.export(exports, "isScrollable", ()=>isScrollable);
function getScrollParent(node, checkForOverflow) {
    let scrollableNode = node;
    if (isScrollable(scrollableNode, checkForOverflow)) scrollableNode = scrollableNode.parentElement;
    while(scrollableNode && !isScrollable(scrollableNode, checkForOverflow))scrollableNode = scrollableNode.parentElement;
    return scrollableNode || document.scrollingElement || document.documentElement;
}
function isScrollable(node, checkForOverflow) {
    let style = window.getComputedStyle(node);
    let isScrollable = /(auto|scroll)/.test(style.overflow + style.overflowX + style.overflowY);
    if (isScrollable && checkForOverflow) isScrollable = node.scrollHeight !== node.clientHeight || node.scrollWidth !== node.clientWidth;
    return isScrollable;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"1oFmo":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useViewportSize", ()=>useViewportSize);
var _react = require("react");
var _ssr = require("@react-aria/ssr");
// @ts-ignore
let visualViewport = typeof document !== "undefined" && window.visualViewport;
function useViewportSize() {
    let isSSR = (0, _ssr.useIsSSR)();
    let [size, setSize] = (0, _react.useState)(()=>isSSR ? {
            width: 0,
            height: 0
        } : getViewportSize());
    (0, _react.useEffect)(()=>{
        // Use visualViewport api to track available height even on iOS virtual keyboard opening
        let onResize = ()=>{
            setSize((size)=>{
                let newSize = getViewportSize();
                if (newSize.width === size.width && newSize.height === size.height) return size;
                return newSize;
            });
        };
        if (!visualViewport) window.addEventListener("resize", onResize);
        else visualViewport.addEventListener("resize", onResize);
        return ()=>{
            if (!visualViewport) window.removeEventListener("resize", onResize);
            else visualViewport.removeEventListener("resize", onResize);
        };
    }, []);
    return size;
}
function getViewportSize() {
    return {
        width: visualViewport && (visualViewport === null || visualViewport === void 0 ? void 0 : visualViewport.width) || window.innerWidth,
        height: visualViewport && (visualViewport === null || visualViewport === void 0 ? void 0 : visualViewport.height) || window.innerHeight
    };
}

},{"react":"9yzVZ","@react-aria/ssr":"gmUOW","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"1RO58":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useDescription", ()=>useDescription);
var _useLayoutEffect = require("./useLayoutEffect");
var _react = require("react");
let descriptionId = 0;
const descriptionNodes = new Map();
function useDescription(description) {
    let [id, setId] = (0, _react.useState)();
    (0, _useLayoutEffect.useLayoutEffect)(()=>{
        if (!description) return;
        let desc = descriptionNodes.get(description);
        if (!desc) {
            let id = `react-aria-description-${descriptionId++}`;
            setId(id);
            let node = document.createElement("div");
            node.id = id;
            node.style.display = "none";
            node.textContent = description;
            document.body.appendChild(node);
            desc = {
                refCount: 0,
                element: node
            };
            descriptionNodes.set(description, desc);
        } else setId(desc.element.id);
        desc.refCount++;
        return ()=>{
            if (desc && --desc.refCount === 0) {
                desc.element.remove();
                descriptionNodes.delete(description);
            }
        };
    }, [
        description
    ]);
    return {
        "aria-describedby": description ? id : undefined
    };
}

},{"./useLayoutEffect":"2YWAV","react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"2V2Xv":[function(require,module,exports) {
/*
 * Copyright 2021 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useEvent", ()=>useEvent);
var _react = require("react");
var _useEffectEvent = require("./useEffectEvent");
function useEvent(ref, event, handler, options) {
    let handleEvent = (0, _useEffectEvent.useEffectEvent)(handler);
    let isDisabled = handler == null;
    (0, _react.useEffect)(()=>{
        if (isDisabled || !ref.current) return;
        let element = ref.current;
        element.addEventListener(event, handleEvent, options);
        return ()=>{
            element.removeEventListener(event, handleEvent, options);
        };
    }, [
        ref,
        event,
        options,
        isDisabled,
        handleEvent
    ]);
}

},{"react":"9yzVZ","./useEffectEvent":"iogYk","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"iogYk":[function(require,module,exports) {
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useEffectEvent", ()=>useEffectEvent);
var _react = require("react");
var _useLayoutEffect = require("./useLayoutEffect");
function useEffectEvent(fn) {
    const ref = (0, _react.useRef)(null);
    (0, _useLayoutEffect.useLayoutEffect)(()=>{
        ref.current = fn;
    }, [
        fn
    ]);
    // @ts-ignore
    return (0, _react.useCallback)((...args)=>{
        const f = ref.current;
        return f === null || f === void 0 ? void 0 : f(...args);
    }, []);
}

},{"react":"9yzVZ","./useLayoutEffect":"2YWAV","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"aKsrM":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// This hook works like `useState`, but when setting the value, you pass a generator function
// that can yield multiple values. Each yielded value updates the state and waits for the next
// layout effect, then continues the generator. This allows sequential updates to state to be
// written linearly.
parcelHelpers.export(exports, "useValueEffect", ()=>useValueEffect);
var _react = require("react");
var _ = require("./");
function useValueEffect(defaultValue) {
    let [value, setValue] = (0, _react.useState)(defaultValue);
    let effect = (0, _react.useRef)(null);
    // Store the function in a ref so we can always access the current version
    // which has the proper `value` in scope.
    let nextRef = (0, _.useEffectEvent)(()=>{
        if (!effect.current) return;
        // Run the generator to the next yield.
        let newValue = effect.current.next();
        // If the generator is done, reset the effect.
        if (newValue.done) {
            effect.current = null;
            return;
        }
        // If the value is the same as the current value,
        // then continue to the next yield. Otherwise,
        // set the value in state and wait for the next layout effect.
        if (value === newValue.value) nextRef();
        else setValue(newValue.value);
    });
    (0, _.useLayoutEffect)(()=>{
        // If there is an effect currently running, continue to the next yield.
        if (effect.current) nextRef();
    });
    let queue = (0, _.useEffectEvent)((fn)=>{
        effect.current = fn(value);
        nextRef();
    });
    return [
        value,
        queue
    ];
}

},{"react":"9yzVZ","./":"9cLk5","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"lFGgH":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Scrolls `scrollView` so that `element` is visible.
 * Similar to `element.scrollIntoView({block: 'nearest'})` (not supported in Edge),
 * but doesn't affect parents above `scrollView`.
 */ parcelHelpers.export(exports, "scrollIntoView", ()=>scrollIntoView);
/**
 * Scrolls the `targetElement` so it is visible in the viewport. Accepts an optional `opts.containingElement`
 * that will be centered in the viewport prior to scrolling the targetElement into view. If scrolling is prevented on
 * the body (e.g. targetElement is in a popover), this will only scroll the scroll parents of the targetElement up to but not including the body itself.
 */ parcelHelpers.export(exports, "scrollIntoViewport", ()=>scrollIntoViewport);
var _ = require("./");
function scrollIntoView(scrollView, element) {
    let offsetX = relativeOffset(scrollView, element, "left");
    let offsetY = relativeOffset(scrollView, element, "top");
    let width = element.offsetWidth;
    let height = element.offsetHeight;
    let x = scrollView.scrollLeft;
    let y = scrollView.scrollTop;
    // Account for top/left border offsetting the scroll top/Left
    let { borderTopWidth, borderLeftWidth } = getComputedStyle(scrollView);
    let borderAdjustedX = scrollView.scrollLeft + parseInt(borderLeftWidth, 10);
    let borderAdjustedY = scrollView.scrollTop + parseInt(borderTopWidth, 10);
    // Ignore end/bottom border via clientHeight/Width instead of offsetHeight/Width
    let maxX = borderAdjustedX + scrollView.clientWidth;
    let maxY = borderAdjustedY + scrollView.clientHeight;
    if (offsetX <= x) x = offsetX - parseInt(borderLeftWidth, 10);
    else if (offsetX + width > maxX) x += offsetX + width - maxX;
    if (offsetY <= borderAdjustedY) y = offsetY - parseInt(borderTopWidth, 10);
    else if (offsetY + height > maxY) y += offsetY + height - maxY;
    scrollView.scrollLeft = x;
    scrollView.scrollTop = y;
}
/**
 * Computes the offset left or top from child to ancestor by accumulating
 * offsetLeft or offsetTop through intervening offsetParents.
 */ function relativeOffset(ancestor, child, axis) {
    const prop = axis === "left" ? "offsetLeft" : "offsetTop";
    let sum = 0;
    while(child.offsetParent){
        sum += child[prop];
        if (child.offsetParent === ancestor) break;
        else if (child.offsetParent.contains(ancestor)) {
            // If the ancestor is not `position:relative`, then we stop at
            // _its_ offset parent, and we subtract off _its_ offset, so that
            // we end up with the proper offset from child to ancestor.
            sum -= ancestor[prop];
            break;
        }
        child = child.offsetParent;
    }
    return sum;
}
function scrollIntoViewport(targetElement, opts) {
    if (document.contains(targetElement)) {
        let root = document.scrollingElement || document.documentElement;
        let isScrollPrevented = window.getComputedStyle(root).overflow === "hidden";
        // If scrolling is not currently prevented then we aren’t in a overlay nor is a overlay open, just use element.scrollIntoView to bring the element into view
        if (!isScrollPrevented) {
            var // use scrollIntoView({block: 'nearest'}) instead of .focus to check if the element is fully in view or not since .focus()
            // won't cause a scroll if the element is already focused and doesn't behave consistently when an element is partially out of view horizontally vs vertically
            _targetElement_scrollIntoView;
            let { left: originalLeft, top: originalTop } = targetElement.getBoundingClientRect();
            targetElement === null || targetElement === void 0 ? void 0 : (_targetElement_scrollIntoView = targetElement.scrollIntoView) === null || _targetElement_scrollIntoView === void 0 ? void 0 : _targetElement_scrollIntoView.call(targetElement, {
                block: "nearest"
            });
            let { left: newLeft, top: newTop } = targetElement.getBoundingClientRect();
            // Account for sub pixel differences from rounding
            if (Math.abs(originalLeft - newLeft) > 1 || Math.abs(originalTop - newTop) > 1) {
                var _opts_containingElement_scrollIntoView, _opts_containingElement, _targetElement_scrollIntoView1;
                opts === null || opts === void 0 ? void 0 : (_opts_containingElement = opts.containingElement) === null || _opts_containingElement === void 0 ? void 0 : (_opts_containingElement_scrollIntoView = _opts_containingElement.scrollIntoView) === null || _opts_containingElement_scrollIntoView === void 0 ? void 0 : _opts_containingElement_scrollIntoView.call(_opts_containingElement, {
                    block: "center",
                    inline: "center"
                });
                (_targetElement_scrollIntoView1 = targetElement.scrollIntoView) === null || _targetElement_scrollIntoView1 === void 0 ? void 0 : _targetElement_scrollIntoView1.call(targetElement, {
                    block: "nearest"
                });
            }
        } else {
            let scrollParent = (0, _.getScrollParent)(targetElement);
            // If scrolling is prevented, we don't want to scroll the body since it might move the overlay partially offscreen and the user can't scroll it back into view.
            while(targetElement && scrollParent && targetElement !== root && scrollParent !== root){
                scrollIntoView(scrollParent, targetElement);
                targetElement = scrollParent;
                scrollParent = (0, _.getScrollParent)(targetElement);
            }
        }
    }
}

},{"./":"9cLk5","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"cpDPf":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useControlledState", ()=>(0, _useControlledState.useControlledState));
parcelHelpers.export(exports, "clamp", ()=>(0, _number.clamp));
parcelHelpers.export(exports, "snapValueToStep", ()=>(0, _number.snapValueToStep));
parcelHelpers.export(exports, "toFixedNumber", ()=>(0, _number.toFixedNumber));
var _useControlledState = require("./useControlledState");
var _number = require("./number");

},{"./useControlledState":"1rQCX","./number":"aQpQc","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"1rQCX":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useControlledState", ()=>useControlledState);
var _react = require("react");
function useControlledState(value, defaultValue, onChange) {
    let [stateValue, setStateValue] = (0, _react.useState)(value || defaultValue);
    let isControlledRef = (0, _react.useRef)(value !== undefined);
    let isControlled = value !== undefined;
    (0, _react.useEffect)(()=>{
        let wasControlled = isControlledRef.current;
        if (wasControlled !== isControlled) console.warn(`WARN: A component changed from ${wasControlled ? "controlled" : "uncontrolled"} to ${isControlled ? "controlled" : "uncontrolled"}.`);
        isControlledRef.current = isControlled;
    }, [
        isControlled
    ]);
    let currentValue = isControlled ? value : stateValue;
    let setValue = (0, _react.useCallback)((value, ...args)=>{
        let onChangeCaller = (value, ...onChangeArgs)=>{
            if (onChange) {
                if (!Object.is(currentValue, value)) onChange(value, ...onChangeArgs);
            }
            if (!isControlled) // If uncontrolled, mutate the currentValue local variable so that
            // calling setState multiple times with the same value only emits onChange once.
            // We do not use a ref for this because we specifically _do_ want the value to
            // reset every render, and assigning to a ref in render breaks aborted suspended renders.
            // eslint-disable-next-line react-hooks/exhaustive-deps
            currentValue = value;
        };
        if (typeof value === "function") {
            console.warn("We can not support a function callback. See Github Issues for details https://github.com/adobe/react-spectrum/issues/2320");
            // this supports functional updates https://reactjs.org/docs/hooks-reference.html#functional-updates
            // when someone using useControlledState calls setControlledState(myFunc)
            // this will call our useState setState with a function as well which invokes myFunc and calls onChange with the value from myFunc
            // if we're in an uncontrolled state, then we also return the value of myFunc which to setState looks as though it was just called with myFunc from the beginning
            // otherwise we just return the controlled value, which won't cause a rerender because React knows to bail out when the value is the same
            let updateFunction = (oldValue, ...functionArgs)=>{
                let interceptedValue = value(isControlled ? currentValue : oldValue, ...functionArgs);
                onChangeCaller(interceptedValue, ...args);
                if (!isControlled) return interceptedValue;
                return oldValue;
            };
            setStateValue(updateFunction);
        } else {
            if (!isControlled) setStateValue(value);
            onChangeCaller(value, ...args);
        }
    }, [
        isControlled,
        currentValue,
        onChange
    ]);
    return [
        currentValue,
        setValue
    ];
}

},{"react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"aQpQc":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /**
 * Takes a value and forces it to the closest min/max if it's outside. Also forces it to the closest valid step.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "clamp", ()=>clamp);
parcelHelpers.export(exports, "snapValueToStep", ()=>snapValueToStep);
/* Takes a value and rounds off to the number of digits. */ parcelHelpers.export(exports, "toFixedNumber", ()=>toFixedNumber);
function clamp(value, min = -Infinity, max = Infinity) {
    let newValue = Math.min(Math.max(value, min), max);
    return newValue;
}
function snapValueToStep(value, min, max, step) {
    min = Number(min);
    max = Number(max);
    let remainder = (value - (isNaN(min) ? 0 : min)) % step;
    let snappedValue = Math.abs(remainder) * 2 >= step ? value + Math.sign(remainder) * (step - Math.abs(remainder)) : value - remainder;
    if (!isNaN(min)) {
        if (snappedValue < min) snappedValue = min;
        else if (!isNaN(max) && snappedValue > max) snappedValue = min + Math.floor((max - min) / step) * step;
    } else if (!isNaN(max) && snappedValue > max) snappedValue = Math.floor(max / step) * step;
    // correct floating point behavior by rounding to step precision
    let string = step.toString();
    let index = string.indexOf(".");
    let precision = index >= 0 ? string.length - index : 0;
    if (precision > 0) {
        let pow = Math.pow(10, precision);
        snappedValue = Math.round(snappedValue * pow) / pow;
    }
    return snappedValue;
}
function toFixedNumber(value, digits, base = 10) {
    const pow = Math.pow(base, digits);
    return Math.round(value * pow) / pow;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"bokul":[function(require,module,exports) {
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// Original licensing for the following method can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/blob/3c713d513195a53788b3f8bb4b70279d68b15bcc/packages/react-interactions/events/src/dom/shared/index.js#L74-L87
// Keyboards, Assistive Technologies, and element.click() all produce a "virtual"
// click event. This is a method of inferring such clicks. Every browser except
// IE 11 only sets a zero value of "detail" for click events that are "virtual".
// However, IE 11 uses a zero value for all click events. For IE 11 we rely on
// the quirk that it produces click events that are of type PointerEvent, and
// where only the "virtual" click lacks a pointerType field.
parcelHelpers.export(exports, "isVirtualClick", ()=>isVirtualClick);
parcelHelpers.export(exports, "isVirtualPointerEvent", ()=>isVirtualPointerEvent);
var _platform = require("./platform");
function isVirtualClick(event) {
    // JAWS/NVDA with Firefox.
    if (event.mozInputSource === 0 && event.isTrusted) return true;
    // Android TalkBack's detail value varies depending on the event listener providing the event so we have specific logic here instead
    // If pointerType is defined, event is from a click listener. For events from mousedown listener, detail === 0 is a sufficient check
    // to detect TalkBack virtual clicks.
    if ((0, _platform.isAndroid)() && event.pointerType) return event.type === "click" && event.buttons === 1;
    return event.detail === 0 && !event.pointerType;
}
function isVirtualPointerEvent(event) {
    // If the pointer size is zero, then we assume it's from a screen reader.
    // Android TalkBack double tap will sometimes return a event with width and height of 1
    // and pointerType === 'mouse' so we need to check for a specific combination of event attributes.
    // Cannot use "event.pressure === 0" as the sole check due to Safari pointer events always returning pressure === 0
    // instead of .5, see https://bugs.webkit.org/show_bug.cgi?id=206216. event.pointerType === 'mouse' is to distingush
    // Talkback double tap from Windows Firefox touch screen press
    return !(0, _platform.isAndroid)() && event.width === 0 && event.height === 0 || event.width === 1 && event.height === 1 && event.pressure === 0 && event.detail === 0 && event.pointerType === "mouse";
}

},{"./platform":"7ccvD","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"ddTYK":[function(require,module,exports) {
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /* eslint-disable rulesdir/pure-render */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useDeepMemo", ()=>useDeepMemo);
var _react = require("react");
function useDeepMemo(value, isEqual) {
    // Using a ref during render is ok here because it's only an optimization – both values are equivalent.
    // If a render is thrown away, it'll still work the same no matter if the next render is the same or not.
    let lastValue = (0, _react.useRef)(null);
    if (value && lastValue.current && isEqual(value, lastValue.current)) value = lastValue.current;
    lastValue.current = value;
    return value;
}

},{"react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"huxwi":[function(require,module,exports) {
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useFormReset", ()=>useFormReset);
var _react = require("react");
var _useEffectEvent = require("./useEffectEvent");
function useFormReset(ref, initialValue, onReset) {
    let resetValue = (0, _react.useRef)(initialValue);
    let handleReset = (0, _useEffectEvent.useEffectEvent)(()=>{
        if (onReset) onReset(resetValue.current);
    });
    (0, _react.useEffect)(()=>{
        var _ref_current;
        let form = ref === null || ref === void 0 ? void 0 : (_ref_current = ref.current) === null || _ref_current === void 0 ? void 0 : _ref_current.form;
        form === null || form === void 0 ? void 0 : form.addEventListener("reset", handleReset);
        return ()=>{
            form === null || form === void 0 ? void 0 : form.removeEventListener("reset", handleReset);
        };
    }, [
        ref,
        handleReset
    ]);
}

},{"react":"9yzVZ","./useEffectEvent":"iogYk","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"42mbF":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FocusScope", ()=>(0, _focusScope.FocusScope));
parcelHelpers.export(exports, "useFocusManager", ()=>(0, _focusScope.useFocusManager));
parcelHelpers.export(exports, "getFocusableTreeWalker", ()=>(0, _focusScope.getFocusableTreeWalker));
parcelHelpers.export(exports, "createFocusManager", ()=>(0, _focusScope.createFocusManager));
parcelHelpers.export(exports, "isElementInChildOfActiveScope", ()=>(0, _focusScope.isElementInChildOfActiveScope));
parcelHelpers.export(exports, "FocusRing", ()=>(0, _focusRing.FocusRing));
parcelHelpers.export(exports, "FocusableProvider", ()=>(0, _useFocusable.FocusableProvider));
parcelHelpers.export(exports, "useFocusable", ()=>(0, _useFocusable.useFocusable));
parcelHelpers.export(exports, "useFocusRing", ()=>(0, _useFocusRing.useFocusRing));
parcelHelpers.export(exports, "focusSafely", ()=>(0, _focusSafely.focusSafely));
parcelHelpers.export(exports, "useHasTabbableChild", ()=>(0, _useHasTabbableChild.useHasTabbableChild));
var _focusScope = require("./FocusScope");
var _focusRing = require("./FocusRing");
var _useFocusable = require("./useFocusable");
var _useFocusRing = require("./useFocusRing");
var _focusSafely = require("./focusSafely");
var _useHasTabbableChild = require("./useHasTabbableChild");

},{"./FocusScope":"elwTd","./FocusRing":"ieQGF","./useFocusable":"2nBUD","./useFocusRing":"4Z5TJ","./focusSafely":"jPcHT","./useHasTabbableChild":"fjBnq","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"elwTd":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// This is a hacky DOM-based implementation of a FocusScope until this RFC lands in React:
// https://github.com/reactjs/rfcs/pull/109
/**
 * A FocusScope manages focus for its descendants. It supports containing focus inside
 * the scope, restoring focus to the previously focused element on unmount, and auto
 * focusing children on mount. It also acts as a container for a programmatic focus
 * management interface that can be used to move focus forward and back in response
 * to user events.
 */ parcelHelpers.export(exports, "FocusScope", ()=>FocusScope);
/**
 * Returns a FocusManager interface for the parent FocusScope.
 * A FocusManager can be used to programmatically move focus within
 * a FocusScope, e.g. in response to user events like keyboard navigation.
 */ parcelHelpers.export(exports, "useFocusManager", ()=>useFocusManager);
/** @private */ parcelHelpers.export(exports, "isElementInChildOfActiveScope", ()=>isElementInChildOfActiveScope);
/**
 * Create a [TreeWalker]{@link https://developer.mozilla.org/en-US/docs/Web/API/TreeWalker}
 * that matches all focusable/tabbable elements.
 */ parcelHelpers.export(exports, "getFocusableTreeWalker", ()=>getFocusableTreeWalker);
/**
 * Creates a FocusManager object that can be used to move focus within an element.
 */ parcelHelpers.export(exports, "createFocusManager", ()=>createFocusManager);
parcelHelpers.export(exports, "focusScopeTree", ()=>focusScopeTree);
var _focusSafely = require("./focusSafely");
var _utils = require("@react-aria/utils");
var _isElementVisible = require("./isElementVisible");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const FocusContext = /*#__PURE__*/ (0, _reactDefault.default).createContext(null);
let activeScope = null;
function FocusScope(props) {
    let { children, contain, restoreFocus, autoFocus } = props;
    let startRef = (0, _react.useRef)(null);
    let endRef = (0, _react.useRef)(null);
    let scopeRef = (0, _react.useRef)([]);
    let { parentNode } = (0, _react.useContext)(FocusContext) || {};
    // Create a tree node here so we can add children to it even before it is added to the tree.
    let node = (0, _react.useMemo)(()=>new TreeNode({
            scopeRef
        }), [
        scopeRef
    ]);
    (0, _utils.useLayoutEffect)(()=>{
        // If a new scope mounts outside the active scope, (e.g. DialogContainer launched from a menu),
        // use the active scope as the parent instead of the parent from context. Layout effects run bottom
        // up, so if the parent is not yet added to the tree, don't do this. Only the outer-most FocusScope
        // that is being added should get the activeScope as its parent.
        let parent = parentNode || focusScopeTree.root;
        if (focusScopeTree.getTreeNode(parent.scopeRef) && activeScope && !isAncestorScope(activeScope, parent.scopeRef)) {
            let activeNode = focusScopeTree.getTreeNode(activeScope);
            if (activeNode) parent = activeNode;
        }
        // Add the node to the parent, and to the tree.
        parent.addChild(node);
        focusScopeTree.addNode(node);
    }, [
        node,
        parentNode
    ]);
    (0, _utils.useLayoutEffect)(()=>{
        let node = focusScopeTree.getTreeNode(scopeRef);
        if (node) node.contain = !!contain;
    }, [
        contain
    ]);
    (0, _utils.useLayoutEffect)(()=>{
        var _startRef_current;
        // Find all rendered nodes between the sentinels and add them to the scope.
        let node = (_startRef_current = startRef.current) === null || _startRef_current === void 0 ? void 0 : _startRef_current.nextSibling;
        let nodes = [];
        while(node && node !== endRef.current){
            nodes.push(node);
            node = node.nextSibling;
        }
        scopeRef.current = nodes;
    }, [
        children
    ]);
    useActiveScopeTracker(scopeRef, restoreFocus, contain);
    useFocusContainment(scopeRef, contain);
    useRestoreFocus(scopeRef, restoreFocus, contain);
    useAutoFocus(scopeRef, autoFocus);
    // This needs to be an effect so that activeScope is updated after the FocusScope tree is complete.
    // It cannot be a useLayoutEffect because the parent of this node hasn't been attached in the tree yet.
    (0, _react.useEffect)(()=>{
        const activeElement = (0, _utils.getOwnerDocument)(scopeRef.current ? scopeRef.current[0] : undefined).activeElement;
        let scope = null;
        if (isElementInScope(activeElement, scopeRef.current)) {
            // We need to traverse the focusScope tree and find the bottom most scope that
            // contains the active element and set that as the activeScope.
            for (let node of focusScopeTree.traverse())if (node.scopeRef && isElementInScope(activeElement, node.scopeRef.current)) scope = node;
            if (scope === focusScopeTree.getTreeNode(scopeRef)) activeScope = scope.scopeRef;
        }
    }, [
        scopeRef
    ]);
    // This layout effect cleanup is so that the tree node is removed synchronously with react before the RAF
    // in useRestoreFocus cleanup runs.
    (0, _utils.useLayoutEffect)(()=>{
        return ()=>{
            var _focusScopeTree_getTreeNode_parent, _focusScopeTree_getTreeNode;
            var _focusScopeTree_getTreeNode_parent_scopeRef;
            // Scope may have been re-parented.
            let parentScope = (_focusScopeTree_getTreeNode_parent_scopeRef = (_focusScopeTree_getTreeNode = focusScopeTree.getTreeNode(scopeRef)) === null || _focusScopeTree_getTreeNode === void 0 ? void 0 : (_focusScopeTree_getTreeNode_parent = _focusScopeTree_getTreeNode.parent) === null || _focusScopeTree_getTreeNode_parent === void 0 ? void 0 : _focusScopeTree_getTreeNode_parent.scopeRef) !== null && _focusScopeTree_getTreeNode_parent_scopeRef !== void 0 ? _focusScopeTree_getTreeNode_parent_scopeRef : null;
            if ((scopeRef === activeScope || isAncestorScope(scopeRef, activeScope)) && (!parentScope || focusScopeTree.getTreeNode(parentScope))) activeScope = parentScope;
            focusScopeTree.removeTreeNode(scopeRef);
        };
    }, [
        scopeRef
    ]);
    let focusManager = (0, _react.useMemo)(()=>createFocusManagerForScope(scopeRef), []);
    let value = (0, _react.useMemo)(()=>({
            focusManager,
            parentNode: node
        }), [
        node,
        focusManager
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(FocusContext.Provider, {
        value: value
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        "data-focus-scope-start": true,
        hidden: true,
        ref: startRef
    }), children, /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        "data-focus-scope-end": true,
        hidden: true,
        ref: endRef
    }));
}
function useFocusManager() {
    var _useContext;
    return (_useContext = (0, _react.useContext)(FocusContext)) === null || _useContext === void 0 ? void 0 : _useContext.focusManager;
}
function createFocusManagerForScope(scopeRef) {
    return {
        focusNext (opts = {}) {
            let scope = scopeRef.current;
            let { from, tabbable, wrap, accept } = opts;
            let node = from || (0, _utils.getOwnerDocument)(scope[0]).activeElement;
            let sentinel = scope[0].previousElementSibling;
            let scopeRoot = getScopeRoot(scope);
            let walker = getFocusableTreeWalker(scopeRoot, {
                tabbable,
                accept
            }, scope);
            walker.currentNode = isElementInScope(node, scope) ? node : sentinel;
            let nextNode = walker.nextNode();
            if (!nextNode && wrap) {
                walker.currentNode = sentinel;
                nextNode = walker.nextNode();
            }
            if (nextNode) focusElement(nextNode, true);
            return nextNode;
        },
        focusPrevious (opts = {}) {
            let scope = scopeRef.current;
            let { from, tabbable, wrap, accept } = opts;
            let node = from || (0, _utils.getOwnerDocument)(scope[0]).activeElement;
            let sentinel = scope[scope.length - 1].nextElementSibling;
            let scopeRoot = getScopeRoot(scope);
            let walker = getFocusableTreeWalker(scopeRoot, {
                tabbable,
                accept
            }, scope);
            walker.currentNode = isElementInScope(node, scope) ? node : sentinel;
            let previousNode = walker.previousNode();
            if (!previousNode && wrap) {
                walker.currentNode = sentinel;
                previousNode = walker.previousNode();
            }
            if (previousNode) focusElement(previousNode, true);
            return previousNode;
        },
        focusFirst (opts = {}) {
            let scope = scopeRef.current;
            let { tabbable, accept } = opts;
            let scopeRoot = getScopeRoot(scope);
            let walker = getFocusableTreeWalker(scopeRoot, {
                tabbable,
                accept
            }, scope);
            walker.currentNode = scope[0].previousElementSibling;
            let nextNode = walker.nextNode();
            if (nextNode) focusElement(nextNode, true);
            return nextNode;
        },
        focusLast (opts = {}) {
            let scope = scopeRef.current;
            let { tabbable, accept } = opts;
            let scopeRoot = getScopeRoot(scope);
            let walker = getFocusableTreeWalker(scopeRoot, {
                tabbable,
                accept
            }, scope);
            walker.currentNode = scope[scope.length - 1].nextElementSibling;
            let previousNode = walker.previousNode();
            if (previousNode) focusElement(previousNode, true);
            return previousNode;
        }
    };
}
const focusableElements = [
    "input:not([disabled]):not([type=hidden])",
    "select:not([disabled])",
    "textarea:not([disabled])",
    "button:not([disabled])",
    "a[href]",
    "area[href]",
    "summary",
    "iframe",
    "object",
    "embed",
    "audio[controls]",
    "video[controls]",
    "[contenteditable]"
];
const FOCUSABLE_ELEMENT_SELECTOR = focusableElements.join(":not([hidden]),") + ",[tabindex]:not([disabled]):not([hidden])";
focusableElements.push('[tabindex]:not([tabindex="-1"]):not([disabled])');
const TABBABLE_ELEMENT_SELECTOR = focusableElements.join(':not([hidden]):not([tabindex="-1"]),');
function getScopeRoot(scope) {
    return scope[0].parentElement;
}
function shouldContainFocus(scopeRef) {
    let scope = focusScopeTree.getTreeNode(activeScope);
    while(scope && scope.scopeRef !== scopeRef){
        if (scope.contain) return false;
        scope = scope.parent;
    }
    return true;
}
function useFocusContainment(scopeRef, contain) {
    let focusedNode = (0, _react.useRef)();
    let raf = (0, _react.useRef)();
    (0, _utils.useLayoutEffect)(()=>{
        let scope = scopeRef.current;
        if (!contain) {
            // if contain was changed, then we should cancel any ongoing waits to pull focus back into containment
            if (raf.current) {
                cancelAnimationFrame(raf.current);
                raf.current = undefined;
            }
            return;
        }
        const ownerDocument = (0, _utils.getOwnerDocument)(scope ? scope[0] : undefined);
        // Handle the Tab key to contain focus within the scope
        let onKeyDown = (e)=>{
            if (e.key !== "Tab" || e.altKey || e.ctrlKey || e.metaKey || !shouldContainFocus(scopeRef)) return;
            let focusedElement = ownerDocument.activeElement;
            let scope = scopeRef.current;
            if (!scope || !isElementInScope(focusedElement, scope)) return;
            let scopeRoot = getScopeRoot(scope);
            let walker = getFocusableTreeWalker(scopeRoot, {
                tabbable: true
            }, scope);
            if (!focusedElement) return;
            walker.currentNode = focusedElement;
            let nextElement = e.shiftKey ? walker.previousNode() : walker.nextNode();
            if (!nextElement) {
                walker.currentNode = e.shiftKey ? scope[scope.length - 1].nextElementSibling : scope[0].previousElementSibling;
                nextElement = e.shiftKey ? walker.previousNode() : walker.nextNode();
            }
            e.preventDefault();
            if (nextElement) focusElement(nextElement, true);
        };
        let onFocus = (e)=>{
            // If focusing an element in a child scope of the currently active scope, the child becomes active.
            // Moving out of the active scope to an ancestor is not allowed.
            if ((!activeScope || isAncestorScope(activeScope, scopeRef)) && isElementInScope(e.target, scopeRef.current)) {
                activeScope = scopeRef;
                focusedNode.current = e.target;
            } else if (shouldContainFocus(scopeRef) && !isElementInChildScope(e.target, scopeRef)) {
                // If a focus event occurs outside the active scope (e.g. user tabs from browser location bar),
                // restore focus to the previously focused node or the first tabbable element in the active scope.
                if (focusedNode.current) focusedNode.current.focus();
                else if (activeScope && activeScope.current) focusFirstInScope(activeScope.current);
            } else if (shouldContainFocus(scopeRef)) focusedNode.current = e.target;
        };
        let onBlur = (e)=>{
            // Firefox doesn't shift focus back to the Dialog properly without this
            if (raf.current) cancelAnimationFrame(raf.current);
            raf.current = requestAnimationFrame(()=>{
                // Use document.activeElement instead of e.relatedTarget so we can tell if user clicked into iframe
                if (ownerDocument.activeElement && shouldContainFocus(scopeRef) && !isElementInChildScope(ownerDocument.activeElement, scopeRef)) {
                    activeScope = scopeRef;
                    if (ownerDocument.body.contains(e.target)) {
                        var _focusedNode_current;
                        focusedNode.current = e.target;
                        (_focusedNode_current = focusedNode.current) === null || _focusedNode_current === void 0 ? void 0 : _focusedNode_current.focus();
                    } else if (activeScope.current) focusFirstInScope(activeScope.current);
                }
            });
        };
        ownerDocument.addEventListener("keydown", onKeyDown, false);
        ownerDocument.addEventListener("focusin", onFocus, false);
        scope === null || scope === void 0 ? void 0 : scope.forEach((element)=>element.addEventListener("focusin", onFocus, false));
        scope === null || scope === void 0 ? void 0 : scope.forEach((element)=>element.addEventListener("focusout", onBlur, false));
        return ()=>{
            ownerDocument.removeEventListener("keydown", onKeyDown, false);
            ownerDocument.removeEventListener("focusin", onFocus, false);
            scope === null || scope === void 0 ? void 0 : scope.forEach((element)=>element.removeEventListener("focusin", onFocus, false));
            scope === null || scope === void 0 ? void 0 : scope.forEach((element)=>element.removeEventListener("focusout", onBlur, false));
        };
    }, [
        scopeRef,
        contain
    ]);
    // This is a useLayoutEffect so it is guaranteed to run before our async synthetic blur
    // eslint-disable-next-line arrow-body-style
    (0, _utils.useLayoutEffect)(()=>{
        return ()=>{
            if (raf.current) cancelAnimationFrame(raf.current);
        };
    }, [
        raf
    ]);
}
function isElementInAnyScope(element) {
    return isElementInChildScope(element);
}
function isElementInScope(element, scope) {
    if (!element) return false;
    if (!scope) return false;
    return scope.some((node)=>node.contains(element));
}
function isElementInChildScope(element, scope = null) {
    // If the element is within a top layer element (e.g. toasts), always allow moving focus there.
    if (element instanceof Element && element.closest("[data-react-aria-top-layer]")) return true;
    // node.contains in isElementInScope covers child scopes that are also DOM children,
    // but does not cover child scopes in portals.
    for (let { scopeRef: s } of focusScopeTree.traverse(focusScopeTree.getTreeNode(scope))){
        if (s && isElementInScope(element, s.current)) return true;
    }
    return false;
}
function isElementInChildOfActiveScope(element) {
    return isElementInChildScope(element, activeScope);
}
function isAncestorScope(ancestor, scope) {
    var _focusScopeTree_getTreeNode;
    let parent = (_focusScopeTree_getTreeNode = focusScopeTree.getTreeNode(scope)) === null || _focusScopeTree_getTreeNode === void 0 ? void 0 : _focusScopeTree_getTreeNode.parent;
    while(parent){
        if (parent.scopeRef === ancestor) return true;
        parent = parent.parent;
    }
    return false;
}
function focusElement(element, scroll = false) {
    if (element != null && !scroll) try {
        (0, _focusSafely.focusSafely)(element);
    } catch (err) {
    // ignore
    }
    else if (element != null) try {
        element.focus();
    } catch (err) {
    // ignore
    }
}
function focusFirstInScope(scope, tabbable = true) {
    let sentinel = scope[0].previousElementSibling;
    let scopeRoot = getScopeRoot(scope);
    let walker = getFocusableTreeWalker(scopeRoot, {
        tabbable
    }, scope);
    walker.currentNode = sentinel;
    let nextNode = walker.nextNode();
    // If the scope does not contain a tabbable element, use the first focusable element.
    if (tabbable && !nextNode) {
        scopeRoot = getScopeRoot(scope);
        walker = getFocusableTreeWalker(scopeRoot, {
            tabbable: false
        }, scope);
        walker.currentNode = sentinel;
        nextNode = walker.nextNode();
    }
    focusElement(nextNode);
}
function useAutoFocus(scopeRef, autoFocus) {
    const autoFocusRef = (0, _reactDefault.default).useRef(autoFocus);
    (0, _react.useEffect)(()=>{
        if (autoFocusRef.current) {
            activeScope = scopeRef;
            const ownerDocument = (0, _utils.getOwnerDocument)(scopeRef.current ? scopeRef.current[0] : undefined);
            if (!isElementInScope(ownerDocument.activeElement, activeScope.current) && scopeRef.current) focusFirstInScope(scopeRef.current);
        }
        autoFocusRef.current = false;
    }, [
        scopeRef
    ]);
}
function useActiveScopeTracker(scopeRef, restore, contain) {
    // tracks the active scope, in case restore and contain are both false.
    // if either are true, this is tracked in useRestoreFocus or useFocusContainment.
    (0, _utils.useLayoutEffect)(()=>{
        if (restore || contain) return;
        let scope = scopeRef.current;
        const ownerDocument = (0, _utils.getOwnerDocument)(scope ? scope[0] : undefined);
        let onFocus = (e)=>{
            let target = e.target;
            if (isElementInScope(target, scopeRef.current)) activeScope = scopeRef;
            else if (!isElementInAnyScope(target)) activeScope = null;
        };
        ownerDocument.addEventListener("focusin", onFocus, false);
        scope === null || scope === void 0 ? void 0 : scope.forEach((element)=>element.addEventListener("focusin", onFocus, false));
        return ()=>{
            ownerDocument.removeEventListener("focusin", onFocus, false);
            scope === null || scope === void 0 ? void 0 : scope.forEach((element)=>element.removeEventListener("focusin", onFocus, false));
        };
    }, [
        scopeRef,
        restore,
        contain
    ]);
}
function shouldRestoreFocus(scopeRef) {
    let scope = focusScopeTree.getTreeNode(activeScope);
    while(scope && scope.scopeRef !== scopeRef){
        if (scope.nodeToRestore) return false;
        scope = scope.parent;
    }
    return (scope === null || scope === void 0 ? void 0 : scope.scopeRef) === scopeRef;
}
function useRestoreFocus(scopeRef, restoreFocus, contain) {
    // create a ref during render instead of useLayoutEffect so the active element is saved before a child with autoFocus=true mounts.
    // eslint-disable-next-line no-restricted-globals
    const nodeToRestoreRef = (0, _react.useRef)(typeof document !== "undefined" ? (0, _utils.getOwnerDocument)(scopeRef.current ? scopeRef.current[0] : undefined).activeElement : null);
    // restoring scopes should all track if they are active regardless of contain, but contain already tracks it plus logic to contain the focus
    // restoring-non-containing scopes should only care if they become active so they can perform the restore
    (0, _utils.useLayoutEffect)(()=>{
        let scope = scopeRef.current;
        const ownerDocument = (0, _utils.getOwnerDocument)(scope ? scope[0] : undefined);
        if (!restoreFocus || contain) return;
        let onFocus = ()=>{
            // If focusing an element in a child scope of the currently active scope, the child becomes active.
            // Moving out of the active scope to an ancestor is not allowed.
            if ((!activeScope || isAncestorScope(activeScope, scopeRef)) && isElementInScope(ownerDocument.activeElement, scopeRef.current)) activeScope = scopeRef;
        };
        ownerDocument.addEventListener("focusin", onFocus, false);
        scope === null || scope === void 0 ? void 0 : scope.forEach((element)=>element.addEventListener("focusin", onFocus, false));
        return ()=>{
            ownerDocument.removeEventListener("focusin", onFocus, false);
            scope === null || scope === void 0 ? void 0 : scope.forEach((element)=>element.removeEventListener("focusin", onFocus, false));
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        scopeRef,
        contain
    ]);
    (0, _utils.useLayoutEffect)(()=>{
        const ownerDocument = (0, _utils.getOwnerDocument)(scopeRef.current ? scopeRef.current[0] : undefined);
        if (!restoreFocus) return;
        // Handle the Tab key so that tabbing out of the scope goes to the next element
        // after the node that had focus when the scope mounted. This is important when
        // using portals for overlays, so that focus goes to the expected element when
        // tabbing out of the overlay.
        let onKeyDown = (e)=>{
            if (e.key !== "Tab" || e.altKey || e.ctrlKey || e.metaKey || !shouldContainFocus(scopeRef)) return;
            let focusedElement = ownerDocument.activeElement;
            if (!isElementInScope(focusedElement, scopeRef.current)) return;
            let treeNode = focusScopeTree.getTreeNode(scopeRef);
            if (!treeNode) return;
            let nodeToRestore = treeNode.nodeToRestore;
            // Create a DOM tree walker that matches all tabbable elements
            let walker = getFocusableTreeWalker(ownerDocument.body, {
                tabbable: true
            });
            // Find the next tabbable element after the currently focused element
            walker.currentNode = focusedElement;
            let nextElement = e.shiftKey ? walker.previousNode() : walker.nextNode();
            if (!nodeToRestore || !ownerDocument.body.contains(nodeToRestore) || nodeToRestore === ownerDocument.body) {
                nodeToRestore = undefined;
                treeNode.nodeToRestore = undefined;
            }
            // If there is no next element, or it is outside the current scope, move focus to the
            // next element after the node to restore to instead.
            if ((!nextElement || !isElementInScope(nextElement, scopeRef.current)) && nodeToRestore) {
                walker.currentNode = nodeToRestore;
                // Skip over elements within the scope, in case the scope immediately follows the node to restore.
                do nextElement = e.shiftKey ? walker.previousNode() : walker.nextNode();
                while (isElementInScope(nextElement, scopeRef.current));
                e.preventDefault();
                e.stopPropagation();
                if (nextElement) focusElement(nextElement, true);
                else // If there is no next element and the nodeToRestore isn't within a FocusScope (i.e. we are leaving the top level focus scope)
                // then move focus to the body.
                // Otherwise restore focus to the nodeToRestore (e.g menu within a popover -> tabbing to close the menu should move focus to menu trigger)
                if (!isElementInAnyScope(nodeToRestore)) focusedElement.blur();
                else focusElement(nodeToRestore, true);
            }
        };
        if (!contain) ownerDocument.addEventListener("keydown", onKeyDown, true);
        return ()=>{
            if (!contain) ownerDocument.removeEventListener("keydown", onKeyDown, true);
        };
    }, [
        scopeRef,
        restoreFocus,
        contain
    ]);
    // useLayoutEffect instead of useEffect so the active element is saved synchronously instead of asynchronously.
    (0, _utils.useLayoutEffect)(()=>{
        const ownerDocument = (0, _utils.getOwnerDocument)(scopeRef.current ? scopeRef.current[0] : undefined);
        if (!restoreFocus) return;
        let treeNode = focusScopeTree.getTreeNode(scopeRef);
        if (!treeNode) return;
        var _nodeToRestoreRef_current;
        treeNode.nodeToRestore = (_nodeToRestoreRef_current = nodeToRestoreRef.current) !== null && _nodeToRestoreRef_current !== void 0 ? _nodeToRestoreRef_current : undefined;
        return ()=>{
            let treeNode = focusScopeTree.getTreeNode(scopeRef);
            if (!treeNode) return;
            let nodeToRestore = treeNode.nodeToRestore;
            // if we already lost focus to the body and this was the active scope, then we should attempt to restore
            if (restoreFocus && nodeToRestore && // eslint-disable-next-line react-hooks/exhaustive-deps
            (isElementInScope(ownerDocument.activeElement, scopeRef.current) || ownerDocument.activeElement === ownerDocument.body && shouldRestoreFocus(scopeRef))) {
                // freeze the focusScopeTree so it persists after the raf, otherwise during unmount nodes are removed from it
                let clonedTree = focusScopeTree.clone();
                requestAnimationFrame(()=>{
                    // Only restore focus if we've lost focus to the body, the alternative is that focus has been purposefully moved elsewhere
                    if (ownerDocument.activeElement === ownerDocument.body) {
                        // look up the tree starting with our scope to find a nodeToRestore still in the DOM
                        let treeNode = clonedTree.getTreeNode(scopeRef);
                        while(treeNode){
                            if (treeNode.nodeToRestore && treeNode.nodeToRestore.isConnected) {
                                focusElement(treeNode.nodeToRestore);
                                return;
                            }
                            treeNode = treeNode.parent;
                        }
                        // If no nodeToRestore was found, focus the first element in the nearest
                        // ancestor scope that is still in the tree.
                        treeNode = clonedTree.getTreeNode(scopeRef);
                        while(treeNode){
                            if (treeNode.scopeRef && treeNode.scopeRef.current && focusScopeTree.getTreeNode(treeNode.scopeRef)) {
                                focusFirstInScope(treeNode.scopeRef.current, true);
                                return;
                            }
                            treeNode = treeNode.parent;
                        }
                    }
                });
            }
        };
    }, [
        scopeRef,
        restoreFocus
    ]);
}
function getFocusableTreeWalker(root, opts, scope) {
    let selector = (opts === null || opts === void 0 ? void 0 : opts.tabbable) ? TABBABLE_ELEMENT_SELECTOR : FOCUSABLE_ELEMENT_SELECTOR;
    let walker = (0, _utils.getOwnerDocument)(root).createTreeWalker(root, NodeFilter.SHOW_ELEMENT, {
        acceptNode (node) {
            var _opts_from;
            // Skip nodes inside the starting node.
            if (opts === null || opts === void 0 ? void 0 : (_opts_from = opts.from) === null || _opts_from === void 0 ? void 0 : _opts_from.contains(node)) return NodeFilter.FILTER_REJECT;
            if (node.matches(selector) && (0, _isElementVisible.isElementVisible)(node) && (!scope || isElementInScope(node, scope)) && (!(opts === null || opts === void 0 ? void 0 : opts.accept) || opts.accept(node))) return NodeFilter.FILTER_ACCEPT;
            return NodeFilter.FILTER_SKIP;
        }
    });
    if (opts === null || opts === void 0 ? void 0 : opts.from) walker.currentNode = opts.from;
    return walker;
}
function createFocusManager(ref, defaultOptions = {}) {
    return {
        focusNext (opts = {}) {
            let root = ref.current;
            if (!root) return null;
            let { from, tabbable = defaultOptions.tabbable, wrap = defaultOptions.wrap, accept = defaultOptions.accept } = opts;
            let node = from || (0, _utils.getOwnerDocument)(root).activeElement;
            let walker = getFocusableTreeWalker(root, {
                tabbable,
                accept
            });
            if (root.contains(node)) walker.currentNode = node;
            let nextNode = walker.nextNode();
            if (!nextNode && wrap) {
                walker.currentNode = root;
                nextNode = walker.nextNode();
            }
            if (nextNode) focusElement(nextNode, true);
            return nextNode;
        },
        focusPrevious (opts = defaultOptions) {
            let root = ref.current;
            if (!root) return null;
            let { from, tabbable = defaultOptions.tabbable, wrap = defaultOptions.wrap, accept = defaultOptions.accept } = opts;
            let node = from || (0, _utils.getOwnerDocument)(root).activeElement;
            let walker = getFocusableTreeWalker(root, {
                tabbable,
                accept
            });
            if (root.contains(node)) walker.currentNode = node;
            else {
                let next = last(walker);
                if (next) focusElement(next, true);
                return next !== null && next !== void 0 ? next : null;
            }
            let previousNode = walker.previousNode();
            if (!previousNode && wrap) {
                walker.currentNode = root;
                let lastNode = last(walker);
                if (!lastNode) // couldn't wrap
                return null;
                previousNode = lastNode;
            }
            if (previousNode) focusElement(previousNode, true);
            return previousNode !== null && previousNode !== void 0 ? previousNode : null;
        },
        focusFirst (opts = defaultOptions) {
            let root = ref.current;
            if (!root) return null;
            let { tabbable = defaultOptions.tabbable, accept = defaultOptions.accept } = opts;
            let walker = getFocusableTreeWalker(root, {
                tabbable,
                accept
            });
            let nextNode = walker.nextNode();
            if (nextNode) focusElement(nextNode, true);
            return nextNode;
        },
        focusLast (opts = defaultOptions) {
            let root = ref.current;
            if (!root) return null;
            let { tabbable = defaultOptions.tabbable, accept = defaultOptions.accept } = opts;
            let walker = getFocusableTreeWalker(root, {
                tabbable,
                accept
            });
            let next = last(walker);
            if (next) focusElement(next, true);
            return next !== null && next !== void 0 ? next : null;
        }
    };
}
function last(walker) {
    let next = undefined;
    let last;
    do {
        last = walker.lastChild();
        if (last) next = last;
    }while (last);
    return next;
}
class Tree {
    get size() {
        return this.fastMap.size;
    }
    getTreeNode(data) {
        return this.fastMap.get(data);
    }
    addTreeNode(scopeRef, parent, nodeToRestore) {
        let parentNode = this.fastMap.get(parent !== null && parent !== void 0 ? parent : null);
        if (!parentNode) return;
        let node = new TreeNode({
            scopeRef
        });
        parentNode.addChild(node);
        node.parent = parentNode;
        this.fastMap.set(scopeRef, node);
        if (nodeToRestore) node.nodeToRestore = nodeToRestore;
    }
    addNode(node) {
        this.fastMap.set(node.scopeRef, node);
    }
    removeTreeNode(scopeRef) {
        // never remove the root
        if (scopeRef === null) return;
        let node = this.fastMap.get(scopeRef);
        if (!node) return;
        let parentNode = node.parent;
        // when we remove a scope, check if any sibling scopes are trying to restore focus to something inside the scope we're removing
        // if we are, then replace the siblings restore with the restore from the scope we're removing
        for (let current of this.traverse())if (current !== node && node.nodeToRestore && current.nodeToRestore && node.scopeRef && node.scopeRef.current && isElementInScope(current.nodeToRestore, node.scopeRef.current)) current.nodeToRestore = node.nodeToRestore;
        let children = node.children;
        if (parentNode) {
            parentNode.removeChild(node);
            if (children.size > 0) children.forEach((child)=>parentNode && parentNode.addChild(child));
        }
        this.fastMap.delete(node.scopeRef);
    }
    // Pre Order Depth First
    *traverse(node = this.root) {
        if (node.scopeRef != null) yield node;
        if (node.children.size > 0) for (let child of node.children)yield* this.traverse(child);
    }
    clone() {
        var _node_parent;
        let newTree = new Tree();
        var _node_parent_scopeRef;
        for (let node of this.traverse())newTree.addTreeNode(node.scopeRef, (_node_parent_scopeRef = (_node_parent = node.parent) === null || _node_parent === void 0 ? void 0 : _node_parent.scopeRef) !== null && _node_parent_scopeRef !== void 0 ? _node_parent_scopeRef : null, node.nodeToRestore);
        return newTree;
    }
    constructor(){
        this.fastMap = new Map();
        this.root = new TreeNode({
            scopeRef: null
        });
        this.fastMap.set(null, this.root);
    }
}
class TreeNode {
    addChild(node) {
        this.children.add(node);
        node.parent = this;
    }
    removeChild(node) {
        this.children.delete(node);
        node.parent = undefined;
    }
    constructor(props){
        this.children = new Set();
        this.contain = false;
        this.scopeRef = props.scopeRef;
    }
}
let focusScopeTree = new Tree();

},{"./focusSafely":"jPcHT","@react-aria/utils":"9cLk5","./isElementVisible":"dME48","react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"jPcHT":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an 'AS IS' BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * A utility function that focuses an element while avoiding undesired side effects such
 * as page scrolling and screen reader issues with CSS transitions.
 */ parcelHelpers.export(exports, "focusSafely", ()=>focusSafely);
var _utils = require("@react-aria/utils");
var _interactions = require("@react-aria/interactions");
function focusSafely(element) {
    // If the user is interacting with a virtual cursor, e.g. screen reader, then
    // wait until after any animated transitions that are currently occurring on
    // the page before shifting focus. This avoids issues with VoiceOver on iOS
    // causing the page to scroll when moving focus if the element is transitioning
    // from off the screen.
    const ownerDocument = (0, _utils.getOwnerDocument)(element);
    if ((0, _interactions.getInteractionModality)() === "virtual") {
        let lastFocusedElement = ownerDocument.activeElement;
        (0, _utils.runAfterTransition)(()=>{
            // If focus did not move and the element is still in the document, focus it.
            if (ownerDocument.activeElement === lastFocusedElement && element.isConnected) (0, _utils.focusWithoutScrolling)(element);
        });
    } else (0, _utils.focusWithoutScrolling)(element);
}

},{"@react-aria/utils":"9cLk5","@react-aria/interactions":"ky3G8","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"ky3G8":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Pressable", ()=>(0, _pressable.Pressable));
parcelHelpers.export(exports, "PressResponder", ()=>(0, _pressResponder.PressResponder));
parcelHelpers.export(exports, "ClearPressResponder", ()=>(0, _pressResponder.ClearPressResponder));
parcelHelpers.export(exports, "useFocus", ()=>(0, _useFocus.useFocus));
parcelHelpers.export(exports, "isFocusVisible", ()=>(0, _useFocusVisible.isFocusVisible));
parcelHelpers.export(exports, "getInteractionModality", ()=>(0, _useFocusVisible.getInteractionModality));
parcelHelpers.export(exports, "setInteractionModality", ()=>(0, _useFocusVisible.setInteractionModality));
parcelHelpers.export(exports, "addWindowFocusTracking", ()=>(0, _useFocusVisible.addWindowFocusTracking));
parcelHelpers.export(exports, "useInteractionModality", ()=>(0, _useFocusVisible.useInteractionModality));
parcelHelpers.export(exports, "useFocusVisible", ()=>(0, _useFocusVisible.useFocusVisible));
parcelHelpers.export(exports, "useFocusVisibleListener", ()=>(0, _useFocusVisible.useFocusVisibleListener));
parcelHelpers.export(exports, "useFocusWithin", ()=>(0, _useFocusWithin.useFocusWithin));
parcelHelpers.export(exports, "useHover", ()=>(0, _useHover.useHover));
parcelHelpers.export(exports, "useInteractOutside", ()=>(0, _useInteractOutside.useInteractOutside));
parcelHelpers.export(exports, "useKeyboard", ()=>(0, _useKeyboard.useKeyboard));
parcelHelpers.export(exports, "useMove", ()=>(0, _useMove.useMove));
parcelHelpers.export(exports, "usePress", ()=>(0, _usePress.usePress));
parcelHelpers.export(exports, "useScrollWheel", ()=>(0, _useScrollWheel.useScrollWheel));
parcelHelpers.export(exports, "useLongPress", ()=>(0, _useLongPress.useLongPress));
var _pressable = require("./Pressable");
var _pressResponder = require("./PressResponder");
var _useFocus = require("./useFocus");
var _useFocusVisible = require("./useFocusVisible");
var _useFocusWithin = require("./useFocusWithin");
var _useHover = require("./useHover");
var _useInteractOutside = require("./useInteractOutside");
var _useKeyboard = require("./useKeyboard");
var _useMove = require("./useMove");
var _usePress = require("./usePress");
var _useScrollWheel = require("./useScrollWheel");
var _useLongPress = require("./useLongPress");

},{"./Pressable":false,"./PressResponder":"iNBM8","./useFocus":"7K588","./useFocusVisible":"gGWzz","./useFocusWithin":"6AEhO","./useHover":"78hGq","./useInteractOutside":"eX9Kr","./useKeyboard":"iVQgD","./useMove":"3DJAW","./usePress":"bXNrE","./useScrollWheel":"dDrxf","./useLongPress":"Zyjrk","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"iNBM8":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PressResponder", ()=>PressResponder);
parcelHelpers.export(exports, "ClearPressResponder", ()=>ClearPressResponder);
var _utils = require("@react-aria/utils");
var _context = require("./context");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const PressResponder = /*#__PURE__*/ (0, _reactDefault.default).forwardRef(({ children, ...props }, ref)=>{
    let isRegistered = (0, _react.useRef)(false);
    let prevContext = (0, _react.useContext)((0, _context.PressResponderContext));
    ref = (0, _utils.useObjectRef)(ref || (prevContext === null || prevContext === void 0 ? void 0 : prevContext.ref));
    let context = (0, _utils.mergeProps)(prevContext || {}, {
        ...props,
        ref,
        register () {
            isRegistered.current = true;
            if (prevContext) prevContext.register();
        }
    });
    (0, _utils.useSyncRef)(prevContext, ref);
    (0, _react.useEffect)(()=>{
        if (!isRegistered.current) {
            console.warn("A PressResponder was rendered without a pressable child. Either call the usePress hook, or wrap your DOM node with <Pressable> component.");
            isRegistered.current = true; // only warn once in strict mode.
        }
    }, []);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _context.PressResponderContext).Provider, {
        value: context
    }, children);
});
function ClearPressResponder({ children }) {
    let context = (0, _react.useMemo)(()=>({
            register: ()=>{}
        }), []);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _context.PressResponderContext).Provider, {
        value: context
    }, children);
}

},{"@react-aria/utils":"9cLk5","./context":"d3Gry","react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"d3Gry":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PressResponderContext", ()=>PressResponderContext);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const PressResponderContext = (0, _reactDefault.default).createContext({
    register: ()=>{}
});
PressResponderContext.displayName = "PressResponderContext";

},{"react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"7K588":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Handles focus events for the immediate target.
 * Focus events on child elements will be ignored.
 */ parcelHelpers.export(exports, "useFocus", ()=>useFocus);
var _react = require("react");
var _utils = require("./utils");
function useFocus(props) {
    let { isDisabled, onFocus: onFocusProp, onBlur: onBlurProp, onFocusChange } = props;
    const onBlur = (0, _react.useCallback)((e)=>{
        if (e.target === e.currentTarget) {
            if (onBlurProp) onBlurProp(e);
            if (onFocusChange) onFocusChange(false);
            return true;
        }
    }, [
        onBlurProp,
        onFocusChange
    ]);
    const onSyntheticFocus = (0, _utils.useSyntheticBlurEvent)(onBlur);
    const onFocus = (0, _react.useCallback)((e)=>{
        // Double check that document.activeElement actually matches e.target in case a previously chained
        // focus handler already moved focus somewhere else.
        if (e.target === e.currentTarget && document.activeElement === e.target) {
            if (onFocusProp) onFocusProp(e);
            if (onFocusChange) onFocusChange(true);
            onSyntheticFocus(e);
        }
    }, [
        onFocusChange,
        onFocusProp,
        onSyntheticFocus
    ]);
    return {
        focusProps: {
            onFocus: !isDisabled && (onFocusProp || onFocusChange || onBlurProp) ? onFocus : undefined,
            onBlur: !isDisabled && (onBlurProp || onFocusChange) ? onBlur : undefined
        }
    };
}

},{"react":"9yzVZ","./utils":"25RwF","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"25RwF":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SyntheticFocusEvent", ()=>SyntheticFocusEvent);
parcelHelpers.export(exports, "useSyntheticBlurEvent", ()=>useSyntheticBlurEvent);
var _react = require("react");
var _utils = require("@react-aria/utils");
class SyntheticFocusEvent {
    isDefaultPrevented() {
        return this.nativeEvent.defaultPrevented;
    }
    preventDefault() {
        this.defaultPrevented = true;
        this.nativeEvent.preventDefault();
    }
    stopPropagation() {
        this.nativeEvent.stopPropagation();
        this.isPropagationStopped = ()=>true;
    }
    isPropagationStopped() {
        return false;
    }
    persist() {}
    constructor(type, nativeEvent){
        this.nativeEvent = nativeEvent;
        this.target = nativeEvent.target;
        this.currentTarget = nativeEvent.currentTarget;
        this.relatedTarget = nativeEvent.relatedTarget;
        this.bubbles = nativeEvent.bubbles;
        this.cancelable = nativeEvent.cancelable;
        this.defaultPrevented = nativeEvent.defaultPrevented;
        this.eventPhase = nativeEvent.eventPhase;
        this.isTrusted = nativeEvent.isTrusted;
        this.timeStamp = nativeEvent.timeStamp;
        this.type = type;
    }
}
function useSyntheticBlurEvent(onBlur) {
    let stateRef = (0, _react.useRef)({
        isFocused: false,
        observer: null
    });
    // Clean up MutationObserver on unmount. See below.
    // eslint-disable-next-line arrow-body-style
    (0, _utils.useLayoutEffect)(()=>{
        const state = stateRef.current;
        return ()=>{
            if (state.observer) {
                state.observer.disconnect();
                state.observer = null;
            }
        };
    }, []);
    let dispatchBlur = (0, _utils.useEffectEvent)((e)=>{
        onBlur === null || onBlur === void 0 ? void 0 : onBlur(e);
    });
    // This function is called during a React onFocus event.
    return (0, _react.useCallback)((e)=>{
        // React does not fire onBlur when an element is disabled. https://github.com/facebook/react/issues/9142
        // Most browsers fire a native focusout event in this case, except for Firefox. In that case, we use a
        // MutationObserver to watch for the disabled attribute, and dispatch these events ourselves.
        // For browsers that do, focusout fires before the MutationObserver, so onBlur should not fire twice.
        if (e.target instanceof HTMLButtonElement || e.target instanceof HTMLInputElement || e.target instanceof HTMLTextAreaElement || e.target instanceof HTMLSelectElement) {
            stateRef.current.isFocused = true;
            let target = e.target;
            let onBlurHandler = (e)=>{
                stateRef.current.isFocused = false;
                if (target.disabled) // For backward compatibility, dispatch a (fake) React synthetic event.
                dispatchBlur(new SyntheticFocusEvent("blur", e));
                // We no longer need the MutationObserver once the target is blurred.
                if (stateRef.current.observer) {
                    stateRef.current.observer.disconnect();
                    stateRef.current.observer = null;
                }
            };
            target.addEventListener("focusout", onBlurHandler, {
                once: true
            });
            stateRef.current.observer = new MutationObserver(()=>{
                if (stateRef.current.isFocused && target.disabled) {
                    var _stateRef_current_observer;
                    (_stateRef_current_observer = stateRef.current.observer) === null || _stateRef_current_observer === void 0 ? void 0 : _stateRef_current_observer.disconnect();
                    let relatedTargetEl = target === document.activeElement ? null : document.activeElement;
                    target.dispatchEvent(new FocusEvent("blur", {
                        relatedTarget: relatedTargetEl
                    }));
                    target.dispatchEvent(new FocusEvent("focusout", {
                        bubbles: true,
                        relatedTarget: relatedTargetEl
                    }));
                }
            });
            stateRef.current.observer.observe(target, {
                attributes: true,
                attributeFilter: [
                    "disabled"
                ]
            });
        }
    }, [
        dispatchBlur
    ]);
}

},{"react":"9yzVZ","@react-aria/utils":"9cLk5","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"gGWzz":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hasSetupGlobalListeners", ()=>hasSetupGlobalListeners);
/**
 * EXPERIMENTAL
 * Adds a window (i.e. iframe) to the list of windows that are being tracked for focus visible.
 *
 * Sometimes apps render portions of their tree into an iframe. In this case, we cannot accurately track if the focus
 * is visible because we cannot see interactions inside the iframe. If you have this in your application's architecture,
 * then this function will attach event listeners inside the iframe. You should call `addWindowFocusTracking` with an
 * element from inside the window you wish to add. We'll retrieve the relevant elements based on that.
 * Note, you do not need to call this for the default window, as we call it for you.
 *
 * When you are ready to stop listening, but you do not wish to unmount the iframe, you may call the cleanup function
 * returned by `addWindowFocusTracking`. Otherwise, when you unmount the iframe, all listeners and state will be cleaned
 * up automatically for you.
 *
 * @param element @default document.body - The element provided will be used to get the window to add.
 * @returns A function to remove the event listeners and cleanup the state.
 */ parcelHelpers.export(exports, "addWindowFocusTracking", ()=>addWindowFocusTracking);
/**
 * If true, keyboard focus is visible.
 */ parcelHelpers.export(exports, "isFocusVisible", ()=>isFocusVisible);
parcelHelpers.export(exports, "getInteractionModality", ()=>getInteractionModality);
parcelHelpers.export(exports, "setInteractionModality", ()=>setInteractionModality);
/**
 * Keeps state of the current modality.
 */ parcelHelpers.export(exports, "useInteractionModality", ()=>useInteractionModality);
/**
 * Manages focus visible state for the page, and subscribes individual components for updates.
 */ parcelHelpers.export(exports, "useFocusVisible", ()=>useFocusVisible);
/**
 * Listens for trigger change and reports if focus is visible (i.e., modality is not pointer).
 */ parcelHelpers.export(exports, "useFocusVisibleListener", ()=>useFocusVisibleListener);
var _utils = require("@react-aria/utils");
var _react = require("react");
var _ssr = require("@react-aria/ssr");
let currentModality = null;
let changeHandlers = new Set();
let hasSetupGlobalListeners = new Map(); // We use a map here to support setting event listeners across multiple document objects.
let hasEventBeforeFocus = false;
let hasBlurredWindowRecently = false;
// Only Tab or Esc keys will make focus visible on text input elements
const FOCUS_VISIBLE_INPUT_KEYS = {
    Tab: true,
    Escape: true
};
function triggerChangeHandlers(modality, e) {
    for (let handler of changeHandlers)handler(modality, e);
}
/**
 * Helper function to determine if a KeyboardEvent is unmodified and could make keyboard focus styles visible.
 */ function isValidKey(e) {
    // Control and Shift keys trigger when navigating back to the tab with keyboard.
    return !(e.metaKey || !(0, _utils.isMac)() && e.altKey || e.ctrlKey || e.key === "Control" || e.key === "Shift" || e.key === "Meta");
}
function handleKeyboardEvent(e) {
    hasEventBeforeFocus = true;
    if (isValidKey(e)) {
        currentModality = "keyboard";
        triggerChangeHandlers("keyboard", e);
    }
}
function handlePointerEvent(e) {
    currentModality = "pointer";
    if (e.type === "mousedown" || e.type === "pointerdown") {
        hasEventBeforeFocus = true;
        triggerChangeHandlers("pointer", e);
    }
}
function handleClickEvent(e) {
    if ((0, _utils.isVirtualClick)(e)) {
        hasEventBeforeFocus = true;
        currentModality = "virtual";
    }
}
function handleFocusEvent(e) {
    // Firefox fires two extra focus events when the user first clicks into an iframe:
    // first on the window, then on the document. We ignore these events so they don't
    // cause keyboard focus rings to appear.
    if (e.target === window || e.target === document) return;
    // If a focus event occurs without a preceding keyboard or pointer event, switch to virtual modality.
    // This occurs, for example, when navigating a form with the next/previous buttons on iOS.
    if (!hasEventBeforeFocus && !hasBlurredWindowRecently) {
        currentModality = "virtual";
        triggerChangeHandlers("virtual", e);
    }
    hasEventBeforeFocus = false;
    hasBlurredWindowRecently = false;
}
function handleWindowBlur() {
    // When the window is blurred, reset state. This is necessary when tabbing out of the window,
    // for example, since a subsequent focus event won't be fired.
    hasEventBeforeFocus = false;
    hasBlurredWindowRecently = true;
}
/**
 * Setup global event listeners to control when keyboard focus style should be visible.
 */ function setupGlobalFocusEvents(element) {
    if (typeof window === "undefined" || hasSetupGlobalListeners.get((0, _utils.getOwnerWindow)(element))) return;
    const windowObject = (0, _utils.getOwnerWindow)(element);
    const documentObject = (0, _utils.getOwnerDocument)(element);
    // Programmatic focus() calls shouldn't affect the current input modality.
    // However, we need to detect other cases when a focus event occurs without
    // a preceding user event (e.g. screen reader focus). Overriding the focus
    // method on HTMLElement.prototype is a bit hacky, but works.
    let focus = windowObject.HTMLElement.prototype.focus;
    windowObject.HTMLElement.prototype.focus = function() {
        hasEventBeforeFocus = true;
        focus.apply(this, arguments);
    };
    documentObject.addEventListener("keydown", handleKeyboardEvent, true);
    documentObject.addEventListener("keyup", handleKeyboardEvent, true);
    documentObject.addEventListener("click", handleClickEvent, true);
    // Register focus events on the window so they are sure to happen
    // before React's event listeners (registered on the document).
    windowObject.addEventListener("focus", handleFocusEvent, true);
    windowObject.addEventListener("blur", handleWindowBlur, false);
    if (typeof PointerEvent !== "undefined") {
        documentObject.addEventListener("pointerdown", handlePointerEvent, true);
        documentObject.addEventListener("pointermove", handlePointerEvent, true);
        documentObject.addEventListener("pointerup", handlePointerEvent, true);
    } else {
        documentObject.addEventListener("mousedown", handlePointerEvent, true);
        documentObject.addEventListener("mousemove", handlePointerEvent, true);
        documentObject.addEventListener("mouseup", handlePointerEvent, true);
    }
    // Add unmount handler
    windowObject.addEventListener("beforeunload", ()=>{
        tearDownWindowFocusTracking(element);
    }, {
        once: true
    });
    hasSetupGlobalListeners.set(windowObject, {
        focus
    });
}
const tearDownWindowFocusTracking = (element, loadListener)=>{
    const windowObject = (0, _utils.getOwnerWindow)(element);
    const documentObject = (0, _utils.getOwnerDocument)(element);
    if (loadListener) documentObject.removeEventListener("DOMContentLoaded", loadListener);
    if (!hasSetupGlobalListeners.has(windowObject)) return;
    windowObject.HTMLElement.prototype.focus = hasSetupGlobalListeners.get(windowObject).focus;
    documentObject.removeEventListener("keydown", handleKeyboardEvent, true);
    documentObject.removeEventListener("keyup", handleKeyboardEvent, true);
    documentObject.removeEventListener("click", handleClickEvent, true);
    windowObject.removeEventListener("focus", handleFocusEvent, true);
    windowObject.removeEventListener("blur", handleWindowBlur, false);
    if (typeof PointerEvent !== "undefined") {
        documentObject.removeEventListener("pointerdown", handlePointerEvent, true);
        documentObject.removeEventListener("pointermove", handlePointerEvent, true);
        documentObject.removeEventListener("pointerup", handlePointerEvent, true);
    } else {
        documentObject.removeEventListener("mousedown", handlePointerEvent, true);
        documentObject.removeEventListener("mousemove", handlePointerEvent, true);
        documentObject.removeEventListener("mouseup", handlePointerEvent, true);
    }
    hasSetupGlobalListeners.delete(windowObject);
};
function addWindowFocusTracking(element) {
    const documentObject = (0, _utils.getOwnerDocument)(element);
    let loadListener;
    if (documentObject.readyState !== "loading") setupGlobalFocusEvents(element);
    else {
        loadListener = ()=>{
            setupGlobalFocusEvents(element);
        };
        documentObject.addEventListener("DOMContentLoaded", loadListener);
    }
    return ()=>tearDownWindowFocusTracking(element, loadListener);
}
// Server-side rendering does not have the document object defined
// eslint-disable-next-line no-restricted-globals
if (typeof document !== "undefined") addWindowFocusTracking();
function isFocusVisible() {
    return currentModality !== "pointer";
}
function getInteractionModality() {
    return currentModality;
}
function setInteractionModality(modality) {
    currentModality = modality;
    triggerChangeHandlers(modality, null);
}
function useInteractionModality() {
    setupGlobalFocusEvents();
    let [modality, setModality] = (0, _react.useState)(currentModality);
    (0, _react.useEffect)(()=>{
        let handler = ()=>{
            setModality(currentModality);
        };
        changeHandlers.add(handler);
        return ()=>{
            changeHandlers.delete(handler);
        };
    }, []);
    return (0, _ssr.useIsSSR)() ? null : modality;
}
const nonTextInputTypes = new Set([
    "checkbox",
    "radio",
    "range",
    "color",
    "file",
    "image",
    "button",
    "submit",
    "reset"
]);
/**
 * If this is attached to text input component, return if the event is a focus event (Tab/Escape keys pressed) so that
 * focus visible style can be properly set.
 */ function isKeyboardFocusEvent(isTextInput, modality, e) {
    var _e_target;
    const IHTMLInputElement = typeof window !== "undefined" ? (0, _utils.getOwnerWindow)(e === null || e === void 0 ? void 0 : e.target).HTMLInputElement : HTMLInputElement;
    const IHTMLTextAreaElement = typeof window !== "undefined" ? (0, _utils.getOwnerWindow)(e === null || e === void 0 ? void 0 : e.target).HTMLTextAreaElement : HTMLTextAreaElement;
    const IHTMLElement = typeof window !== "undefined" ? (0, _utils.getOwnerWindow)(e === null || e === void 0 ? void 0 : e.target).HTMLElement : HTMLElement;
    const IKeyboardEvent = typeof window !== "undefined" ? (0, _utils.getOwnerWindow)(e === null || e === void 0 ? void 0 : e.target).KeyboardEvent : KeyboardEvent;
    isTextInput = isTextInput || (e === null || e === void 0 ? void 0 : e.target) instanceof IHTMLInputElement && !nonTextInputTypes.has(e === null || e === void 0 ? void 0 : (_e_target = e.target) === null || _e_target === void 0 ? void 0 : _e_target.type) || (e === null || e === void 0 ? void 0 : e.target) instanceof IHTMLTextAreaElement || (e === null || e === void 0 ? void 0 : e.target) instanceof IHTMLElement && (e === null || e === void 0 ? void 0 : e.target.isContentEditable);
    return !(isTextInput && modality === "keyboard" && e instanceof IKeyboardEvent && !FOCUS_VISIBLE_INPUT_KEYS[e.key]);
}
function useFocusVisible(props = {}) {
    let { isTextInput, autoFocus } = props;
    let [isFocusVisibleState, setFocusVisible] = (0, _react.useState)(autoFocus || isFocusVisible());
    useFocusVisibleListener((isFocusVisible)=>{
        setFocusVisible(isFocusVisible);
    }, [
        isTextInput
    ], {
        isTextInput
    });
    return {
        isFocusVisible: isFocusVisibleState
    };
}
function useFocusVisibleListener(fn, deps, opts) {
    setupGlobalFocusEvents();
    (0, _react.useEffect)(()=>{
        let handler = (modality, e)=>{
            if (!isKeyboardFocusEvent(!!(opts === null || opts === void 0 ? void 0 : opts.isTextInput), modality, e)) return;
            fn(isFocusVisible());
        };
        changeHandlers.add(handler);
        return ()=>{
            changeHandlers.delete(handler);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
}

},{"@react-aria/utils":"9cLk5","react":"9yzVZ","@react-aria/ssr":"gmUOW","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"6AEhO":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Handles focus events for the target and its descendants.
 */ parcelHelpers.export(exports, "useFocusWithin", ()=>useFocusWithin);
var _react = require("react");
var _utils = require("./utils");
function useFocusWithin(props) {
    let { isDisabled, onBlurWithin, onFocusWithin, onFocusWithinChange } = props;
    let state = (0, _react.useRef)({
        isFocusWithin: false
    });
    let onBlur = (0, _react.useCallback)((e)=>{
        // We don't want to trigger onBlurWithin and then immediately onFocusWithin again
        // when moving focus inside the element. Only trigger if the currentTarget doesn't
        // include the relatedTarget (where focus is moving).
        if (state.current.isFocusWithin && !e.currentTarget.contains(e.relatedTarget)) {
            state.current.isFocusWithin = false;
            if (onBlurWithin) onBlurWithin(e);
            if (onFocusWithinChange) onFocusWithinChange(false);
        }
    }, [
        onBlurWithin,
        onFocusWithinChange,
        state
    ]);
    let onSyntheticFocus = (0, _utils.useSyntheticBlurEvent)(onBlur);
    let onFocus = (0, _react.useCallback)((e)=>{
        // Double check that document.activeElement actually matches e.target in case a previously chained
        // focus handler already moved focus somewhere else.
        if (!state.current.isFocusWithin && document.activeElement === e.target) {
            if (onFocusWithin) onFocusWithin(e);
            if (onFocusWithinChange) onFocusWithinChange(true);
            state.current.isFocusWithin = true;
            onSyntheticFocus(e);
        }
    }, [
        onFocusWithin,
        onFocusWithinChange,
        onSyntheticFocus
    ]);
    if (isDisabled) return {
        focusWithinProps: {
            // These should not have been null, that would conflict in mergeProps
            onFocus: undefined,
            onBlur: undefined
        }
    };
    return {
        focusWithinProps: {
            onFocus,
            onBlur
        }
    };
}

},{"react":"9yzVZ","./utils":"25RwF","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"78hGq":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Handles pointer hover interactions for an element. Normalizes behavior
 * across browsers and platforms, and ignores emulated mouse events on touch devices.
 */ parcelHelpers.export(exports, "useHover", ()=>useHover);
var _react = require("react");
// iOS fires onPointerEnter twice: once with pointerType="touch" and again with pointerType="mouse".
// We want to ignore these emulated events so they do not trigger hover behavior.
// See https://bugs.webkit.org/show_bug.cgi?id=214609.
let globalIgnoreEmulatedMouseEvents = false;
let hoverCount = 0;
function setGlobalIgnoreEmulatedMouseEvents() {
    globalIgnoreEmulatedMouseEvents = true;
    // Clear globalIgnoreEmulatedMouseEvents after a short timeout. iOS fires onPointerEnter
    // with pointerType="mouse" immediately after onPointerUp and before onFocus. On other
    // devices that don't have this quirk, we don't want to ignore a mouse hover sometime in
    // the distant future because a user previously touched the element.
    setTimeout(()=>{
        globalIgnoreEmulatedMouseEvents = false;
    }, 50);
}
function handleGlobalPointerEvent(e) {
    if (e.pointerType === "touch") setGlobalIgnoreEmulatedMouseEvents();
}
function setupGlobalTouchEvents() {
    if (typeof document === "undefined") return;
    if (typeof PointerEvent !== "undefined") document.addEventListener("pointerup", handleGlobalPointerEvent);
    else document.addEventListener("touchend", setGlobalIgnoreEmulatedMouseEvents);
    hoverCount++;
    return ()=>{
        hoverCount--;
        if (hoverCount > 0) return;
        if (typeof PointerEvent !== "undefined") document.removeEventListener("pointerup", handleGlobalPointerEvent);
        else document.removeEventListener("touchend", setGlobalIgnoreEmulatedMouseEvents);
    };
}
function useHover(props) {
    let { onHoverStart, onHoverChange, onHoverEnd, isDisabled } = props;
    let [isHovered, setHovered] = (0, _react.useState)(false);
    let state = (0, _react.useRef)({
        isHovered: false,
        ignoreEmulatedMouseEvents: false,
        pointerType: "",
        target: null
    }).current;
    (0, _react.useEffect)(setupGlobalTouchEvents, []);
    let { hoverProps, triggerHoverEnd } = (0, _react.useMemo)(()=>{
        let triggerHoverStart = (event, pointerType)=>{
            state.pointerType = pointerType;
            if (isDisabled || pointerType === "touch" || state.isHovered || !event.currentTarget.contains(event.target)) return;
            state.isHovered = true;
            let target = event.currentTarget;
            state.target = target;
            if (onHoverStart) onHoverStart({
                type: "hoverstart",
                target,
                pointerType
            });
            if (onHoverChange) onHoverChange(true);
            setHovered(true);
        };
        let triggerHoverEnd = (event, pointerType)=>{
            state.pointerType = "";
            state.target = null;
            if (pointerType === "touch" || !state.isHovered) return;
            state.isHovered = false;
            let target = event.currentTarget;
            if (onHoverEnd) onHoverEnd({
                type: "hoverend",
                target,
                pointerType
            });
            if (onHoverChange) onHoverChange(false);
            setHovered(false);
        };
        let hoverProps = {};
        if (typeof PointerEvent !== "undefined") {
            hoverProps.onPointerEnter = (e)=>{
                if (globalIgnoreEmulatedMouseEvents && e.pointerType === "mouse") return;
                triggerHoverStart(e, e.pointerType);
            };
            hoverProps.onPointerLeave = (e)=>{
                if (!isDisabled && e.currentTarget.contains(e.target)) triggerHoverEnd(e, e.pointerType);
            };
        } else {
            hoverProps.onTouchStart = ()=>{
                state.ignoreEmulatedMouseEvents = true;
            };
            hoverProps.onMouseEnter = (e)=>{
                if (!state.ignoreEmulatedMouseEvents && !globalIgnoreEmulatedMouseEvents) triggerHoverStart(e, "mouse");
                state.ignoreEmulatedMouseEvents = false;
            };
            hoverProps.onMouseLeave = (e)=>{
                if (!isDisabled && e.currentTarget.contains(e.target)) triggerHoverEnd(e, "mouse");
            };
        }
        return {
            hoverProps,
            triggerHoverEnd
        };
    }, [
        onHoverStart,
        onHoverChange,
        onHoverEnd,
        isDisabled,
        state
    ]);
    (0, _react.useEffect)(()=>{
        // Call the triggerHoverEnd as soon as isDisabled changes to true
        // Safe to call triggerHoverEnd, it will early return if we aren't currently hovering
        if (isDisabled) triggerHoverEnd({
            currentTarget: state.target
        }, state.pointerType);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isDisabled
    ]);
    return {
        hoverProps,
        isHovered
    };
}

},{"react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"eX9Kr":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Example, used in components like Dialogs and Popovers so they can close
 * when a user clicks outside them.
 */ parcelHelpers.export(exports, "useInteractOutside", ()=>useInteractOutside);
var _utils = require("@react-aria/utils");
var _react = require("react");
function useInteractOutside(props) {
    let { ref, onInteractOutside, isDisabled, onInteractOutsideStart } = props;
    let stateRef = (0, _react.useRef)({
        isPointerDown: false,
        ignoreEmulatedMouseEvents: false
    });
    let onPointerDown = (0, _utils.useEffectEvent)((e)=>{
        if (onInteractOutside && isValidEvent(e, ref)) {
            if (onInteractOutsideStart) onInteractOutsideStart(e);
            stateRef.current.isPointerDown = true;
        }
    });
    let triggerInteractOutside = (0, _utils.useEffectEvent)((e)=>{
        if (onInteractOutside) onInteractOutside(e);
    });
    (0, _react.useEffect)(()=>{
        let state = stateRef.current;
        if (isDisabled) return;
        const element = ref.current;
        const documentObject = (0, _utils.getOwnerDocument)(element);
        // Use pointer events if available. Otherwise, fall back to mouse and touch events.
        if (typeof PointerEvent !== "undefined") {
            let onPointerUp = (e)=>{
                if (state.isPointerDown && isValidEvent(e, ref)) triggerInteractOutside(e);
                state.isPointerDown = false;
            };
            // changing these to capture phase fixed combobox
            documentObject.addEventListener("pointerdown", onPointerDown, true);
            documentObject.addEventListener("pointerup", onPointerUp, true);
            return ()=>{
                documentObject.removeEventListener("pointerdown", onPointerDown, true);
                documentObject.removeEventListener("pointerup", onPointerUp, true);
            };
        } else {
            let onMouseUp = (e)=>{
                if (state.ignoreEmulatedMouseEvents) state.ignoreEmulatedMouseEvents = false;
                else if (state.isPointerDown && isValidEvent(e, ref)) triggerInteractOutside(e);
                state.isPointerDown = false;
            };
            let onTouchEnd = (e)=>{
                state.ignoreEmulatedMouseEvents = true;
                if (state.isPointerDown && isValidEvent(e, ref)) triggerInteractOutside(e);
                state.isPointerDown = false;
            };
            documentObject.addEventListener("mousedown", onPointerDown, true);
            documentObject.addEventListener("mouseup", onMouseUp, true);
            documentObject.addEventListener("touchstart", onPointerDown, true);
            documentObject.addEventListener("touchend", onTouchEnd, true);
            return ()=>{
                documentObject.removeEventListener("mousedown", onPointerDown, true);
                documentObject.removeEventListener("mouseup", onMouseUp, true);
                documentObject.removeEventListener("touchstart", onPointerDown, true);
                documentObject.removeEventListener("touchend", onTouchEnd, true);
            };
        }
    }, [
        ref,
        isDisabled,
        onPointerDown,
        triggerInteractOutside
    ]);
}
function isValidEvent(event, ref) {
    if (event.button > 0) return false;
    if (event.target) {
        // if the event target is no longer in the document, ignore
        const ownerDocument = event.target.ownerDocument;
        if (!ownerDocument || !ownerDocument.documentElement.contains(event.target)) return false;
        // If the target is within a top layer element (e.g. toasts), ignore.
        if (event.target.closest("[data-react-aria-top-layer]")) return false;
    }
    return ref.current && !ref.current.contains(event.target);
}

},{"@react-aria/utils":"9cLk5","react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"iVQgD":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Handles keyboard interactions for a focusable element.
 */ parcelHelpers.export(exports, "useKeyboard", ()=>useKeyboard);
var _createEventHandler = require("./createEventHandler");
function useKeyboard(props) {
    return {
        keyboardProps: props.isDisabled ? {} : {
            onKeyDown: (0, _createEventHandler.createEventHandler)(props.onKeyDown),
            onKeyUp: (0, _createEventHandler.createEventHandler)(props.onKeyUp)
        }
    };
}

},{"./createEventHandler":"9sNk7","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"9sNk7":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * This function wraps a React event handler to make stopPropagation the default, and support continuePropagation instead.
 */ parcelHelpers.export(exports, "createEventHandler", ()=>createEventHandler);
function createEventHandler(handler) {
    if (!handler) return undefined;
    let shouldStopPropagation = true;
    return (e)=>{
        let event = {
            ...e,
            preventDefault () {
                e.preventDefault();
            },
            isDefaultPrevented () {
                return e.isDefaultPrevented();
            },
            stopPropagation () {
                console.error("stopPropagation is now the default behavior for events in React Spectrum. You can use continuePropagation() to revert this behavior.");
            },
            continuePropagation () {
                shouldStopPropagation = false;
            }
        };
        handler(event);
        if (shouldStopPropagation) e.stopPropagation();
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"3DJAW":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Handles move interactions across mouse, touch, and keyboard, including dragging with
 * the mouse or touch, and using the arrow keys. Normalizes behavior across browsers and
 * platforms, and ignores emulated mouse events on touch devices.
 */ parcelHelpers.export(exports, "useMove", ()=>useMove);
var _textSelection = require("./textSelection");
var _react = require("react");
var _utils = require("@react-aria/utils");
function useMove(props) {
    let { onMoveStart, onMove, onMoveEnd } = props;
    let state = (0, _react.useRef)({
        didMove: false,
        lastPosition: null,
        id: null
    });
    let { addGlobalListener, removeGlobalListener } = (0, _utils.useGlobalListeners)();
    let move = (0, _utils.useEffectEvent)((originalEvent, pointerType, deltaX, deltaY)=>{
        if (deltaX === 0 && deltaY === 0) return;
        if (!state.current.didMove) {
            state.current.didMove = true;
            onMoveStart === null || onMoveStart === void 0 ? void 0 : onMoveStart({
                type: "movestart",
                pointerType,
                shiftKey: originalEvent.shiftKey,
                metaKey: originalEvent.metaKey,
                ctrlKey: originalEvent.ctrlKey,
                altKey: originalEvent.altKey
            });
        }
        onMove === null || onMove === void 0 ? void 0 : onMove({
            type: "move",
            pointerType,
            deltaX: deltaX,
            deltaY: deltaY,
            shiftKey: originalEvent.shiftKey,
            metaKey: originalEvent.metaKey,
            ctrlKey: originalEvent.ctrlKey,
            altKey: originalEvent.altKey
        });
    });
    let end = (0, _utils.useEffectEvent)((originalEvent, pointerType)=>{
        (0, _textSelection.restoreTextSelection)();
        if (state.current.didMove) onMoveEnd === null || onMoveEnd === void 0 ? void 0 : onMoveEnd({
            type: "moveend",
            pointerType,
            shiftKey: originalEvent.shiftKey,
            metaKey: originalEvent.metaKey,
            ctrlKey: originalEvent.ctrlKey,
            altKey: originalEvent.altKey
        });
    });
    let moveProps = (0, _react.useMemo)(()=>{
        let moveProps = {};
        let start = ()=>{
            (0, _textSelection.disableTextSelection)();
            state.current.didMove = false;
        };
        if (typeof PointerEvent === "undefined") {
            let onMouseMove = (e)=>{
                if (e.button === 0) {
                    var _state_current_lastPosition, _state_current_lastPosition1;
                    var _state_current_lastPosition_pageX, _state_current_lastPosition_pageY;
                    move(e, "mouse", e.pageX - ((_state_current_lastPosition_pageX = (_state_current_lastPosition = state.current.lastPosition) === null || _state_current_lastPosition === void 0 ? void 0 : _state_current_lastPosition.pageX) !== null && _state_current_lastPosition_pageX !== void 0 ? _state_current_lastPosition_pageX : 0), e.pageY - ((_state_current_lastPosition_pageY = (_state_current_lastPosition1 = state.current.lastPosition) === null || _state_current_lastPosition1 === void 0 ? void 0 : _state_current_lastPosition1.pageY) !== null && _state_current_lastPosition_pageY !== void 0 ? _state_current_lastPosition_pageY : 0));
                    state.current.lastPosition = {
                        pageX: e.pageX,
                        pageY: e.pageY
                    };
                }
            };
            let onMouseUp = (e)=>{
                if (e.button === 0) {
                    end(e, "mouse");
                    removeGlobalListener(window, "mousemove", onMouseMove, false);
                    removeGlobalListener(window, "mouseup", onMouseUp, false);
                }
            };
            moveProps.onMouseDown = (e)=>{
                if (e.button === 0) {
                    start();
                    e.stopPropagation();
                    e.preventDefault();
                    state.current.lastPosition = {
                        pageX: e.pageX,
                        pageY: e.pageY
                    };
                    addGlobalListener(window, "mousemove", onMouseMove, false);
                    addGlobalListener(window, "mouseup", onMouseUp, false);
                }
            };
            let onTouchMove = (e)=>{
                let touch = [
                    ...e.changedTouches
                ].findIndex(({ identifier })=>identifier === state.current.id);
                if (touch >= 0) {
                    var _state_current_lastPosition, _state_current_lastPosition1;
                    let { pageX, pageY } = e.changedTouches[touch];
                    var _state_current_lastPosition_pageX, _state_current_lastPosition_pageY;
                    move(e, "touch", pageX - ((_state_current_lastPosition_pageX = (_state_current_lastPosition = state.current.lastPosition) === null || _state_current_lastPosition === void 0 ? void 0 : _state_current_lastPosition.pageX) !== null && _state_current_lastPosition_pageX !== void 0 ? _state_current_lastPosition_pageX : 0), pageY - ((_state_current_lastPosition_pageY = (_state_current_lastPosition1 = state.current.lastPosition) === null || _state_current_lastPosition1 === void 0 ? void 0 : _state_current_lastPosition1.pageY) !== null && _state_current_lastPosition_pageY !== void 0 ? _state_current_lastPosition_pageY : 0));
                    state.current.lastPosition = {
                        pageX,
                        pageY
                    };
                }
            };
            let onTouchEnd = (e)=>{
                let touch = [
                    ...e.changedTouches
                ].findIndex(({ identifier })=>identifier === state.current.id);
                if (touch >= 0) {
                    end(e, "touch");
                    state.current.id = null;
                    removeGlobalListener(window, "touchmove", onTouchMove);
                    removeGlobalListener(window, "touchend", onTouchEnd);
                    removeGlobalListener(window, "touchcancel", onTouchEnd);
                }
            };
            moveProps.onTouchStart = (e)=>{
                if (e.changedTouches.length === 0 || state.current.id != null) return;
                let { pageX, pageY, identifier } = e.changedTouches[0];
                start();
                e.stopPropagation();
                e.preventDefault();
                state.current.lastPosition = {
                    pageX,
                    pageY
                };
                state.current.id = identifier;
                addGlobalListener(window, "touchmove", onTouchMove, false);
                addGlobalListener(window, "touchend", onTouchEnd, false);
                addGlobalListener(window, "touchcancel", onTouchEnd, false);
            };
        } else {
            let onPointerMove = (e)=>{
                if (e.pointerId === state.current.id) {
                    var _state_current_lastPosition, _state_current_lastPosition1;
                    let pointerType = e.pointerType || "mouse";
                    var _state_current_lastPosition_pageX, _state_current_lastPosition_pageY;
                    // Problems with PointerEvent#movementX/movementY:
                    // 1. it is always 0 on macOS Safari.
                    // 2. On Chrome Android, it's scaled by devicePixelRatio, but not on Chrome macOS
                    move(e, pointerType, e.pageX - ((_state_current_lastPosition_pageX = (_state_current_lastPosition = state.current.lastPosition) === null || _state_current_lastPosition === void 0 ? void 0 : _state_current_lastPosition.pageX) !== null && _state_current_lastPosition_pageX !== void 0 ? _state_current_lastPosition_pageX : 0), e.pageY - ((_state_current_lastPosition_pageY = (_state_current_lastPosition1 = state.current.lastPosition) === null || _state_current_lastPosition1 === void 0 ? void 0 : _state_current_lastPosition1.pageY) !== null && _state_current_lastPosition_pageY !== void 0 ? _state_current_lastPosition_pageY : 0));
                    state.current.lastPosition = {
                        pageX: e.pageX,
                        pageY: e.pageY
                    };
                }
            };
            let onPointerUp = (e)=>{
                if (e.pointerId === state.current.id) {
                    let pointerType = e.pointerType || "mouse";
                    end(e, pointerType);
                    state.current.id = null;
                    removeGlobalListener(window, "pointermove", onPointerMove, false);
                    removeGlobalListener(window, "pointerup", onPointerUp, false);
                    removeGlobalListener(window, "pointercancel", onPointerUp, false);
                }
            };
            moveProps.onPointerDown = (e)=>{
                if (e.button === 0 && state.current.id == null) {
                    start();
                    e.stopPropagation();
                    e.preventDefault();
                    state.current.lastPosition = {
                        pageX: e.pageX,
                        pageY: e.pageY
                    };
                    state.current.id = e.pointerId;
                    addGlobalListener(window, "pointermove", onPointerMove, false);
                    addGlobalListener(window, "pointerup", onPointerUp, false);
                    addGlobalListener(window, "pointercancel", onPointerUp, false);
                }
            };
        }
        let triggerKeyboardMove = (e, deltaX, deltaY)=>{
            start();
            move(e, "keyboard", deltaX, deltaY);
            end(e, "keyboard");
        };
        moveProps.onKeyDown = (e)=>{
            switch(e.key){
                case "Left":
                case "ArrowLeft":
                    e.preventDefault();
                    e.stopPropagation();
                    triggerKeyboardMove(e, -1, 0);
                    break;
                case "Right":
                case "ArrowRight":
                    e.preventDefault();
                    e.stopPropagation();
                    triggerKeyboardMove(e, 1, 0);
                    break;
                case "Up":
                case "ArrowUp":
                    e.preventDefault();
                    e.stopPropagation();
                    triggerKeyboardMove(e, 0, -1);
                    break;
                case "Down":
                case "ArrowDown":
                    e.preventDefault();
                    e.stopPropagation();
                    triggerKeyboardMove(e, 0, 1);
                    break;
            }
        };
        return moveProps;
    }, [
        state,
        addGlobalListener,
        removeGlobalListener,
        move,
        end
    ]);
    return {
        moveProps
    };
}

},{"./textSelection":"kRxTp","react":"9yzVZ","@react-aria/utils":"9cLk5","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"kRxTp":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "disableTextSelection", ()=>disableTextSelection);
parcelHelpers.export(exports, "restoreTextSelection", ()=>restoreTextSelection);
var _utils = require("@react-aria/utils");
// Note that state only matters here for iOS. Non-iOS gets user-select: none applied to the target element
// rather than at the document level so we just need to apply/remove user-select: none for each pressed element individually
let state = "default";
let savedUserSelect = "";
let modifiedElementMap = new WeakMap();
function disableTextSelection(target) {
    if ((0, _utils.isIOS)()) {
        if (state === "default") {
            // eslint-disable-next-line no-restricted-globals
            const documentObject = (0, _utils.getOwnerDocument)(target);
            savedUserSelect = documentObject.documentElement.style.webkitUserSelect;
            documentObject.documentElement.style.webkitUserSelect = "none";
        }
        state = "disabled";
    } else if (target instanceof HTMLElement || target instanceof SVGElement) {
        // If not iOS, store the target's original user-select and change to user-select: none
        // Ignore state since it doesn't apply for non iOS
        modifiedElementMap.set(target, target.style.userSelect);
        target.style.userSelect = "none";
    }
}
function restoreTextSelection(target) {
    if ((0, _utils.isIOS)()) {
        // If the state is already default, there's nothing to do.
        // If it is restoring, then there's no need to queue a second restore.
        if (state !== "disabled") return;
        state = "restoring";
        // There appears to be a delay on iOS where selection still might occur
        // after pointer up, so wait a bit before removing user-select.
        setTimeout(()=>{
            // Wait for any CSS transitions to complete so we don't recompute style
            // for the whole page in the middle of the animation and cause jank.
            (0, _utils.runAfterTransition)(()=>{
                // Avoid race conditions
                if (state === "restoring") {
                    // eslint-disable-next-line no-restricted-globals
                    const documentObject = (0, _utils.getOwnerDocument)(target);
                    if (documentObject.documentElement.style.webkitUserSelect === "none") documentObject.documentElement.style.webkitUserSelect = savedUserSelect || "";
                    savedUserSelect = "";
                    state = "default";
                }
            });
        }, 300);
    } else if (target instanceof HTMLElement || target instanceof SVGElement) // If not iOS, restore the target's original user-select if any
    // Ignore state since it doesn't apply for non iOS
    {
        if (target && modifiedElementMap.has(target)) {
            let targetOldUserSelect = modifiedElementMap.get(target);
            if (target.style.userSelect === "none") target.style.userSelect = targetOldUserSelect;
            if (target.getAttribute("style") === "") target.removeAttribute("style");
            modifiedElementMap.delete(target);
        }
    }
}

},{"@react-aria/utils":"9cLk5","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"bXNrE":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Handles press interactions across mouse, touch, keyboard, and screen readers.
 * It normalizes behavior across browsers and platforms, and handles many nuances
 * of dealing with pointer and keyboard events.
 */ parcelHelpers.export(exports, "usePress", ()=>usePress);
var _classPrivateFieldGet = require("@swc/helpers/_/_class_private_field_get");
var _classPrivateFieldInit = require("@swc/helpers/_/_class_private_field_init");
var _classPrivateFieldSet = require("@swc/helpers/_/_class_private_field_set");
var _utils = require("@react-aria/utils");
var _textSelection = require("./textSelection");
var _context = require("./context");
var _react = require("react");
function usePressResponderContext(props) {
    // Consume context from <PressResponder> and merge with props.
    let context = (0, _react.useContext)((0, _context.PressResponderContext));
    if (context) {
        let { register, ...contextProps } = context;
        props = (0, _utils.mergeProps)(contextProps, props);
        register();
    }
    (0, _utils.useSyncRef)(context, props.ref);
    return props;
}
var _shouldStopPropagation = /*#__PURE__*/ new WeakMap();
class PressEvent {
    continuePropagation() {
        (0, _classPrivateFieldSet._)(this, _shouldStopPropagation, false);
    }
    get shouldStopPropagation() {
        return (0, _classPrivateFieldGet._)(this, _shouldStopPropagation);
    }
    constructor(type, pointerType, originalEvent){
        (0, _classPrivateFieldInit._)(this, _shouldStopPropagation, {
            writable: true,
            value: void 0
        });
        (0, _classPrivateFieldSet._)(this, _shouldStopPropagation, true);
        this.type = type;
        this.pointerType = pointerType;
        this.target = originalEvent.currentTarget;
        this.shiftKey = originalEvent.shiftKey;
        this.metaKey = originalEvent.metaKey;
        this.ctrlKey = originalEvent.ctrlKey;
        this.altKey = originalEvent.altKey;
    }
}
const LINK_CLICKED = Symbol("linkClicked");
function usePress(props) {
    let { onPress, onPressChange, onPressStart, onPressEnd, onPressUp, isDisabled, isPressed: isPressedProp, preventFocusOnPress, shouldCancelOnPointerExit, allowTextSelectionOnPress, // eslint-disable-next-line @typescript-eslint/no-unused-vars
    ref: _, ...domProps } = usePressResponderContext(props);
    let [isPressed, setPressed] = (0, _react.useState)(false);
    let ref = (0, _react.useRef)({
        isPressed: false,
        ignoreEmulatedMouseEvents: false,
        ignoreClickAfterPress: false,
        didFirePressStart: false,
        isTriggeringEvent: false,
        activePointerId: null,
        target: null,
        isOverTarget: false,
        pointerType: null
    });
    let { addGlobalListener, removeAllGlobalListeners } = (0, _utils.useGlobalListeners)();
    let triggerPressStart = (0, _utils.useEffectEvent)((originalEvent, pointerType)=>{
        let state = ref.current;
        if (isDisabled || state.didFirePressStart) return false;
        let shouldStopPropagation = true;
        state.isTriggeringEvent = true;
        if (onPressStart) {
            let event = new PressEvent("pressstart", pointerType, originalEvent);
            onPressStart(event);
            shouldStopPropagation = event.shouldStopPropagation;
        }
        if (onPressChange) onPressChange(true);
        state.isTriggeringEvent = false;
        state.didFirePressStart = true;
        setPressed(true);
        return shouldStopPropagation;
    });
    let triggerPressEnd = (0, _utils.useEffectEvent)((originalEvent, pointerType, wasPressed = true)=>{
        let state = ref.current;
        if (!state.didFirePressStart) return false;
        state.ignoreClickAfterPress = true;
        state.didFirePressStart = false;
        state.isTriggeringEvent = true;
        let shouldStopPropagation = true;
        if (onPressEnd) {
            let event = new PressEvent("pressend", pointerType, originalEvent);
            onPressEnd(event);
            shouldStopPropagation = event.shouldStopPropagation;
        }
        if (onPressChange) onPressChange(false);
        setPressed(false);
        if (onPress && wasPressed && !isDisabled) {
            let event = new PressEvent("press", pointerType, originalEvent);
            onPress(event);
            shouldStopPropagation && (shouldStopPropagation = event.shouldStopPropagation);
        }
        state.isTriggeringEvent = false;
        return shouldStopPropagation;
    });
    let triggerPressUp = (0, _utils.useEffectEvent)((originalEvent, pointerType)=>{
        let state = ref.current;
        if (isDisabled) return false;
        if (onPressUp) {
            state.isTriggeringEvent = true;
            let event = new PressEvent("pressup", pointerType, originalEvent);
            onPressUp(event);
            state.isTriggeringEvent = false;
            return event.shouldStopPropagation;
        }
        return true;
    });
    let cancel = (0, _utils.useEffectEvent)((e)=>{
        let state = ref.current;
        if (state.isPressed && state.target) {
            if (state.isOverTarget && state.pointerType != null) triggerPressEnd(createEvent(state.target, e), state.pointerType, false);
            state.isPressed = false;
            state.isOverTarget = false;
            state.activePointerId = null;
            state.pointerType = null;
            removeAllGlobalListeners();
            if (!allowTextSelectionOnPress) (0, _textSelection.restoreTextSelection)(state.target);
        }
    });
    let cancelOnPointerExit = (0, _utils.useEffectEvent)((e)=>{
        if (shouldCancelOnPointerExit) cancel(e);
    });
    let pressProps = (0, _react.useMemo)(()=>{
        let state = ref.current;
        let pressProps = {
            onKeyDown (e) {
                if (isValidKeyboardEvent(e.nativeEvent, e.currentTarget) && e.currentTarget.contains(e.target)) {
                    var _state_metaKeyEvents;
                    if (shouldPreventDefaultKeyboard(e.target, e.key)) e.preventDefault();
                    // If the event is repeating, it may have started on a different element
                    // after which focus moved to the current element. Ignore these events and
                    // only handle the first key down event.
                    let shouldStopPropagation = true;
                    if (!state.isPressed && !e.repeat) {
                        state.target = e.currentTarget;
                        state.isPressed = true;
                        shouldStopPropagation = triggerPressStart(e, "keyboard");
                        // Focus may move before the key up event, so register the event on the document
                        // instead of the same element where the key down event occurred. Make it capturing so that it will trigger
                        // before stopPropagation from useKeyboard on a child element may happen and thus we can still call triggerPress for the parent element.
                        let originalTarget = e.currentTarget;
                        let pressUp = (e)=>{
                            if (isValidKeyboardEvent(e, originalTarget) && !e.repeat && originalTarget.contains(e.target) && state.target) triggerPressUp(createEvent(state.target, e), "keyboard");
                        };
                        addGlobalListener((0, _utils.getOwnerDocument)(e.currentTarget), "keyup", (0, _utils.chain)(pressUp, onKeyUp), true);
                    }
                    if (shouldStopPropagation) e.stopPropagation();
                    // Keep track of the keydown events that occur while the Meta (e.g. Command) key is held.
                    // macOS has a bug where keyup events are not fired while the Meta key is down.
                    // When the Meta key itself is released we will get an event for that, and we'll act as if
                    // all of these other keys were released as well.
                    // https://bugs.chromium.org/p/chromium/issues/detail?id=1393524
                    // https://bugs.webkit.org/show_bug.cgi?id=55291
                    // https://bugzilla.mozilla.org/show_bug.cgi?id=1299553
                    if (e.metaKey && (0, _utils.isMac)()) (_state_metaKeyEvents = state.metaKeyEvents) === null || _state_metaKeyEvents === void 0 ? void 0 : _state_metaKeyEvents.set(e.key, e.nativeEvent);
                } else if (e.key === "Meta") state.metaKeyEvents = new Map();
            },
            onClick (e) {
                if (e && !e.currentTarget.contains(e.target)) return;
                if (e && e.button === 0 && !state.isTriggeringEvent && !(0, _utils.openLink).isOpening) {
                    let shouldStopPropagation = true;
                    if (isDisabled) e.preventDefault();
                    // If triggered from a screen reader or by using element.click(),
                    // trigger as if it were a keyboard click.
                    if (!state.ignoreClickAfterPress && !state.ignoreEmulatedMouseEvents && !state.isPressed && (state.pointerType === "virtual" || (0, _utils.isVirtualClick)(e.nativeEvent))) {
                        // Ensure the element receives focus (VoiceOver on iOS does not do this)
                        if (!isDisabled && !preventFocusOnPress) (0, _utils.focusWithoutScrolling)(e.currentTarget);
                        let stopPressStart = triggerPressStart(e, "virtual");
                        let stopPressUp = triggerPressUp(e, "virtual");
                        let stopPressEnd = triggerPressEnd(e, "virtual");
                        shouldStopPropagation = stopPressStart && stopPressUp && stopPressEnd;
                    }
                    state.ignoreEmulatedMouseEvents = false;
                    state.ignoreClickAfterPress = false;
                    if (shouldStopPropagation) e.stopPropagation();
                }
            }
        };
        let onKeyUp = (e)=>{
            var _state_metaKeyEvents;
            if (state.isPressed && state.target && isValidKeyboardEvent(e, state.target)) {
                var _state_metaKeyEvents1;
                if (shouldPreventDefaultKeyboard(e.target, e.key)) e.preventDefault();
                let target = e.target;
                triggerPressEnd(createEvent(state.target, e), "keyboard", state.target.contains(target));
                removeAllGlobalListeners();
                // If a link was triggered with a key other than Enter, open the URL ourselves.
                // This means the link has a role override, and the default browser behavior
                // only applies when using the Enter key.
                if (e.key !== "Enter" && isHTMLAnchorLink(state.target) && state.target.contains(target) && !e[LINK_CLICKED]) {
                    // Store a hidden property on the event so we only trigger link click once,
                    // even if there are multiple usePress instances attached to the element.
                    e[LINK_CLICKED] = true;
                    (0, _utils.openLink)(state.target, e, false);
                }
                state.isPressed = false;
                (_state_metaKeyEvents1 = state.metaKeyEvents) === null || _state_metaKeyEvents1 === void 0 ? void 0 : _state_metaKeyEvents1.delete(e.key);
            } else if (e.key === "Meta" && ((_state_metaKeyEvents = state.metaKeyEvents) === null || _state_metaKeyEvents === void 0 ? void 0 : _state_metaKeyEvents.size)) {
                var _state_target;
                // If we recorded keydown events that occurred while the Meta key was pressed,
                // and those haven't received keyup events already, fire keyup events ourselves.
                // See comment above for more info about the macOS bug causing this.
                let events = state.metaKeyEvents;
                state.metaKeyEvents = undefined;
                for (let event of events.values())(_state_target = state.target) === null || _state_target === void 0 ? void 0 : _state_target.dispatchEvent(new KeyboardEvent("keyup", event));
            }
        };
        if (typeof PointerEvent !== "undefined") {
            pressProps.onPointerDown = (e)=>{
                // Only handle left clicks, and ignore events that bubbled through portals.
                if (e.button !== 0 || !e.currentTarget.contains(e.target)) return;
                // iOS safari fires pointer events from VoiceOver with incorrect coordinates/target.
                // Ignore and let the onClick handler take care of it instead.
                // https://bugs.webkit.org/show_bug.cgi?id=222627
                // https://bugs.webkit.org/show_bug.cgi?id=223202
                if ((0, _utils.isVirtualPointerEvent)(e.nativeEvent)) {
                    state.pointerType = "virtual";
                    return;
                }
                // Due to browser inconsistencies, especially on mobile browsers, we prevent
                // default on pointer down and handle focusing the pressable element ourselves.
                if (shouldPreventDefault(e.currentTarget)) e.preventDefault();
                state.pointerType = e.pointerType;
                let shouldStopPropagation = true;
                if (!state.isPressed) {
                    state.isPressed = true;
                    state.isOverTarget = true;
                    state.activePointerId = e.pointerId;
                    state.target = e.currentTarget;
                    if (!isDisabled && !preventFocusOnPress) (0, _utils.focusWithoutScrolling)(e.currentTarget);
                    if (!allowTextSelectionOnPress) (0, _textSelection.disableTextSelection)(state.target);
                    shouldStopPropagation = triggerPressStart(e, state.pointerType);
                    addGlobalListener((0, _utils.getOwnerDocument)(e.currentTarget), "pointermove", onPointerMove, false);
                    addGlobalListener((0, _utils.getOwnerDocument)(e.currentTarget), "pointerup", onPointerUp, false);
                    addGlobalListener((0, _utils.getOwnerDocument)(e.currentTarget), "pointercancel", onPointerCancel, false);
                }
                if (shouldStopPropagation) e.stopPropagation();
            };
            pressProps.onMouseDown = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                if (e.button === 0) {
                    // Chrome and Firefox on touch Windows devices require mouse down events
                    // to be canceled in addition to pointer events, or an extra asynchronous
                    // focus event will be fired.
                    if (shouldPreventDefault(e.currentTarget)) e.preventDefault();
                    e.stopPropagation();
                }
            };
            pressProps.onPointerUp = (e)=>{
                // iOS fires pointerup with zero width and height, so check the pointerType recorded during pointerdown.
                if (!e.currentTarget.contains(e.target) || state.pointerType === "virtual") return;
                // Only handle left clicks
                // Safari on iOS sometimes fires pointerup events, even
                // when the touch isn't over the target, so double check.
                if (e.button === 0 && isOverTarget(e, e.currentTarget)) triggerPressUp(e, state.pointerType || e.pointerType);
            };
            // Safari on iOS < 13.2 does not implement pointerenter/pointerleave events correctly.
            // Use pointer move events instead to implement our own hit testing.
            // See https://bugs.webkit.org/show_bug.cgi?id=199803
            let onPointerMove = (e)=>{
                if (e.pointerId !== state.activePointerId) return;
                if (state.target && isOverTarget(e, state.target)) {
                    if (!state.isOverTarget && state.pointerType != null) {
                        state.isOverTarget = true;
                        triggerPressStart(createEvent(state.target, e), state.pointerType);
                    }
                } else if (state.target && state.isOverTarget && state.pointerType != null) {
                    state.isOverTarget = false;
                    triggerPressEnd(createEvent(state.target, e), state.pointerType, false);
                    cancelOnPointerExit(e);
                }
            };
            let onPointerUp = (e)=>{
                if (e.pointerId === state.activePointerId && state.isPressed && e.button === 0 && state.target) {
                    if (isOverTarget(e, state.target) && state.pointerType != null) triggerPressEnd(createEvent(state.target, e), state.pointerType);
                    else if (state.isOverTarget && state.pointerType != null) triggerPressEnd(createEvent(state.target, e), state.pointerType, false);
                    state.isPressed = false;
                    state.isOverTarget = false;
                    state.activePointerId = null;
                    state.pointerType = null;
                    removeAllGlobalListeners();
                    if (!allowTextSelectionOnPress) (0, _textSelection.restoreTextSelection)(state.target);
                }
            };
            let onPointerCancel = (e)=>{
                cancel(e);
            };
            pressProps.onDragStart = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                // Safari does not call onPointerCancel when a drag starts, whereas Chrome and Firefox do.
                cancel(e);
            };
        } else {
            pressProps.onMouseDown = (e)=>{
                // Only handle left clicks
                if (e.button !== 0 || !e.currentTarget.contains(e.target)) return;
                // Due to browser inconsistencies, especially on mobile browsers, we prevent
                // default on mouse down and handle focusing the pressable element ourselves.
                if (shouldPreventDefault(e.currentTarget)) e.preventDefault();
                if (state.ignoreEmulatedMouseEvents) {
                    e.stopPropagation();
                    return;
                }
                state.isPressed = true;
                state.isOverTarget = true;
                state.target = e.currentTarget;
                state.pointerType = (0, _utils.isVirtualClick)(e.nativeEvent) ? "virtual" : "mouse";
                if (!isDisabled && !preventFocusOnPress) (0, _utils.focusWithoutScrolling)(e.currentTarget);
                let shouldStopPropagation = triggerPressStart(e, state.pointerType);
                if (shouldStopPropagation) e.stopPropagation();
                addGlobalListener((0, _utils.getOwnerDocument)(e.currentTarget), "mouseup", onMouseUp, false);
            };
            pressProps.onMouseEnter = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                let shouldStopPropagation = true;
                if (state.isPressed && !state.ignoreEmulatedMouseEvents && state.pointerType != null) {
                    state.isOverTarget = true;
                    shouldStopPropagation = triggerPressStart(e, state.pointerType);
                }
                if (shouldStopPropagation) e.stopPropagation();
            };
            pressProps.onMouseLeave = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                let shouldStopPropagation = true;
                if (state.isPressed && !state.ignoreEmulatedMouseEvents && state.pointerType != null) {
                    state.isOverTarget = false;
                    shouldStopPropagation = triggerPressEnd(e, state.pointerType, false);
                    cancelOnPointerExit(e);
                }
                if (shouldStopPropagation) e.stopPropagation();
            };
            pressProps.onMouseUp = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                if (!state.ignoreEmulatedMouseEvents && e.button === 0) triggerPressUp(e, state.pointerType || "mouse");
            };
            let onMouseUp = (e)=>{
                // Only handle left clicks
                if (e.button !== 0) return;
                state.isPressed = false;
                removeAllGlobalListeners();
                if (state.ignoreEmulatedMouseEvents) {
                    state.ignoreEmulatedMouseEvents = false;
                    return;
                }
                if (state.target && isOverTarget(e, state.target) && state.pointerType != null) triggerPressEnd(createEvent(state.target, e), state.pointerType);
                else if (state.target && state.isOverTarget && state.pointerType != null) triggerPressEnd(createEvent(state.target, e), state.pointerType, false);
                state.isOverTarget = false;
            };
            pressProps.onTouchStart = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                let touch = getTouchFromEvent(e.nativeEvent);
                if (!touch) return;
                state.activePointerId = touch.identifier;
                state.ignoreEmulatedMouseEvents = true;
                state.isOverTarget = true;
                state.isPressed = true;
                state.target = e.currentTarget;
                state.pointerType = "touch";
                // Due to browser inconsistencies, especially on mobile browsers, we prevent default
                // on the emulated mouse event and handle focusing the pressable element ourselves.
                if (!isDisabled && !preventFocusOnPress) (0, _utils.focusWithoutScrolling)(e.currentTarget);
                if (!allowTextSelectionOnPress) (0, _textSelection.disableTextSelection)(state.target);
                let shouldStopPropagation = triggerPressStart(e, state.pointerType);
                if (shouldStopPropagation) e.stopPropagation();
                addGlobalListener((0, _utils.getOwnerWindow)(e.currentTarget), "scroll", onScroll, true);
            };
            pressProps.onTouchMove = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                if (!state.isPressed) {
                    e.stopPropagation();
                    return;
                }
                let touch = getTouchById(e.nativeEvent, state.activePointerId);
                let shouldStopPropagation = true;
                if (touch && isOverTarget(touch, e.currentTarget)) {
                    if (!state.isOverTarget && state.pointerType != null) {
                        state.isOverTarget = true;
                        shouldStopPropagation = triggerPressStart(e, state.pointerType);
                    }
                } else if (state.isOverTarget && state.pointerType != null) {
                    state.isOverTarget = false;
                    shouldStopPropagation = triggerPressEnd(e, state.pointerType, false);
                    cancelOnPointerExit(e);
                }
                if (shouldStopPropagation) e.stopPropagation();
            };
            pressProps.onTouchEnd = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                if (!state.isPressed) {
                    e.stopPropagation();
                    return;
                }
                let touch = getTouchById(e.nativeEvent, state.activePointerId);
                let shouldStopPropagation = true;
                if (touch && isOverTarget(touch, e.currentTarget) && state.pointerType != null) {
                    triggerPressUp(e, state.pointerType);
                    shouldStopPropagation = triggerPressEnd(e, state.pointerType);
                } else if (state.isOverTarget && state.pointerType != null) shouldStopPropagation = triggerPressEnd(e, state.pointerType, false);
                if (shouldStopPropagation) e.stopPropagation();
                state.isPressed = false;
                state.activePointerId = null;
                state.isOverTarget = false;
                state.ignoreEmulatedMouseEvents = true;
                if (state.target && !allowTextSelectionOnPress) (0, _textSelection.restoreTextSelection)(state.target);
                removeAllGlobalListeners();
            };
            pressProps.onTouchCancel = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                e.stopPropagation();
                if (state.isPressed) cancel(e);
            };
            let onScroll = (e)=>{
                if (state.isPressed && e.target.contains(state.target)) cancel({
                    currentTarget: state.target,
                    shiftKey: false,
                    ctrlKey: false,
                    metaKey: false,
                    altKey: false
                });
            };
            pressProps.onDragStart = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                cancel(e);
            };
        }
        return pressProps;
    }, [
        addGlobalListener,
        isDisabled,
        preventFocusOnPress,
        removeAllGlobalListeners,
        allowTextSelectionOnPress,
        cancel,
        cancelOnPointerExit,
        triggerPressEnd,
        triggerPressStart,
        triggerPressUp
    ]);
    // Remove user-select: none in case component unmounts immediately after pressStart
    // eslint-disable-next-line arrow-body-style
    (0, _react.useEffect)(()=>{
        return ()=>{
            var _ref_current_target;
            if (!allowTextSelectionOnPress) // eslint-disable-next-line react-hooks/exhaustive-deps
            (0, _textSelection.restoreTextSelection)((_ref_current_target = ref.current.target) !== null && _ref_current_target !== void 0 ? _ref_current_target : undefined);
        };
    }, [
        allowTextSelectionOnPress
    ]);
    return {
        isPressed: isPressedProp || isPressed,
        pressProps: (0, _utils.mergeProps)(domProps, pressProps)
    };
}
function isHTMLAnchorLink(target) {
    return target.tagName === "A" && target.hasAttribute("href");
}
function isValidKeyboardEvent(event, currentTarget) {
    const { key, code } = event;
    const element = currentTarget;
    const role = element.getAttribute("role");
    // Accessibility for keyboards. Space and Enter only.
    // "Spacebar" is for IE 11
    return (key === "Enter" || key === " " || key === "Spacebar" || code === "Space") && !(element instanceof (0, _utils.getOwnerWindow)(element).HTMLInputElement && !isValidInputKey(element, key) || element instanceof (0, _utils.getOwnerWindow)(element).HTMLTextAreaElement || element.isContentEditable) && // Links should only trigger with Enter key
    !((role === "link" || !role && isHTMLAnchorLink(element)) && key !== "Enter");
}
function getTouchFromEvent(event) {
    const { targetTouches } = event;
    if (targetTouches.length > 0) return targetTouches[0];
    return null;
}
function getTouchById(event, pointerId) {
    const changedTouches = event.changedTouches;
    for(let i = 0; i < changedTouches.length; i++){
        const touch = changedTouches[i];
        if (touch.identifier === pointerId) return touch;
    }
    return null;
}
function createEvent(target, e) {
    return {
        currentTarget: target,
        shiftKey: e.shiftKey,
        ctrlKey: e.ctrlKey,
        metaKey: e.metaKey,
        altKey: e.altKey
    };
}
function getPointClientRect(point) {
    let offsetX = 0;
    let offsetY = 0;
    if (point.width !== undefined) offsetX = point.width / 2;
    else if (point.radiusX !== undefined) offsetX = point.radiusX;
    if (point.height !== undefined) offsetY = point.height / 2;
    else if (point.radiusY !== undefined) offsetY = point.radiusY;
    return {
        top: point.clientY - offsetY,
        right: point.clientX + offsetX,
        bottom: point.clientY + offsetY,
        left: point.clientX - offsetX
    };
}
function areRectanglesOverlapping(a, b) {
    // check if they cannot overlap on x axis
    if (a.left > b.right || b.left > a.right) return false;
    // check if they cannot overlap on y axis
    if (a.top > b.bottom || b.top > a.bottom) return false;
    return true;
}
function isOverTarget(point, target) {
    let rect = target.getBoundingClientRect();
    let pointRect = getPointClientRect(point);
    return areRectanglesOverlapping(rect, pointRect);
}
function shouldPreventDefault(target) {
    // We cannot prevent default if the target is a draggable element.
    return !(target instanceof HTMLElement) || !target.hasAttribute("draggable");
}
function shouldPreventDefaultKeyboard(target, key) {
    if (target instanceof HTMLInputElement) return !isValidInputKey(target, key);
    if (target instanceof HTMLButtonElement) return target.type !== "submit" && target.type !== "reset";
    if (isHTMLAnchorLink(target)) return false;
    return true;
}
const nonTextInputTypes = new Set([
    "checkbox",
    "radio",
    "range",
    "color",
    "file",
    "image",
    "button",
    "submit",
    "reset"
]);
function isValidInputKey(target, key) {
    // Only space should toggle checkboxes and radios, not enter.
    return target.type === "checkbox" || target.type === "radio" ? key === " " : nonTextInputTypes.has(target.type);
}

},{"@swc/helpers/_/_class_private_field_get":"dRwUu","@swc/helpers/_/_class_private_field_init":"cFHKQ","@swc/helpers/_/_class_private_field_set":"7Y42U","@react-aria/utils":"9cLk5","./textSelection":"kRxTp","./context":"d3Gry","react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"dRwUu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_class_private_field_get", ()=>_class_private_field_get);
parcelHelpers.export(exports, "_", ()=>_class_private_field_get);
var _classApplyDescriptorGetJs = require("./_class_apply_descriptor_get.js");
var _classExtractFieldDescriptorJs = require("./_class_extract_field_descriptor.js");
function _class_private_field_get(receiver, privateMap) {
    var descriptor = (0, _classExtractFieldDescriptorJs._class_extract_field_descriptor)(receiver, privateMap, "get");
    return (0, _classApplyDescriptorGetJs._class_apply_descriptor_get)(receiver, descriptor);
}

},{"./_class_apply_descriptor_get.js":"d96fc","./_class_extract_field_descriptor.js":"4ZPzI","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"d96fc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_class_apply_descriptor_get", ()=>_class_apply_descriptor_get);
parcelHelpers.export(exports, "_", ()=>_class_apply_descriptor_get);
function _class_apply_descriptor_get(receiver, descriptor) {
    if (descriptor.get) return descriptor.get.call(receiver);
    return descriptor.value;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"4ZPzI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_class_extract_field_descriptor", ()=>_class_extract_field_descriptor);
parcelHelpers.export(exports, "_", ()=>_class_extract_field_descriptor);
function _class_extract_field_descriptor(receiver, privateMap, action) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to " + action + " private field on non-instance");
    return privateMap.get(receiver);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"cFHKQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_class_private_field_init", ()=>_class_private_field_init);
parcelHelpers.export(exports, "_", ()=>_class_private_field_init);
var _checkPrivateRedeclarationJs = require("./_check_private_redeclaration.js");
function _class_private_field_init(obj, privateMap, value) {
    (0, _checkPrivateRedeclarationJs._check_private_redeclaration)(obj, privateMap);
    privateMap.set(obj, value);
}

},{"./_check_private_redeclaration.js":"fKsg1","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"fKsg1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_check_private_redeclaration", ()=>_check_private_redeclaration);
parcelHelpers.export(exports, "_", ()=>_check_private_redeclaration);
function _check_private_redeclaration(obj, privateCollection) {
    if (privateCollection.has(obj)) throw new TypeError("Cannot initialize the same private elements twice on an object");
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"7Y42U":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_class_private_field_set", ()=>_class_private_field_set);
parcelHelpers.export(exports, "_", ()=>_class_private_field_set);
var _classApplyDescriptorSetJs = require("./_class_apply_descriptor_set.js");
var _classExtractFieldDescriptorJs = require("./_class_extract_field_descriptor.js");
function _class_private_field_set(receiver, privateMap, value) {
    var descriptor = (0, _classExtractFieldDescriptorJs._class_extract_field_descriptor)(receiver, privateMap, "set");
    (0, _classApplyDescriptorSetJs._class_apply_descriptor_set)(receiver, descriptor, value);
    return value;
}

},{"./_class_apply_descriptor_set.js":"4xCBy","./_class_extract_field_descriptor.js":"4ZPzI","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"4xCBy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_class_apply_descriptor_set", ()=>_class_apply_descriptor_set);
parcelHelpers.export(exports, "_", ()=>_class_apply_descriptor_set);
function _class_apply_descriptor_set(receiver, descriptor, value) {
    if (descriptor.set) descriptor.set.call(receiver, value);
    else {
        if (!descriptor.writable) // This should only throw in strict mode, but class bodies are
        // always strict and private fields can only be used inside
        // class bodies.
        throw new TypeError("attempted to set read only private field");
        descriptor.value = value;
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"dDrxf":[function(require,module,exports) {
/*
 * Copyright 2021 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// scroll wheel needs to be added not passively so it's cancelable, small helper hook to remember that
parcelHelpers.export(exports, "useScrollWheel", ()=>useScrollWheel);
var _react = require("react");
var _utils = require("@react-aria/utils");
function useScrollWheel(props, ref) {
    let { onScroll, isDisabled } = props;
    let onScrollHandler = (0, _react.useCallback)((e)=>{
        // If the ctrlKey is pressed, this is a zoom event, do nothing.
        if (e.ctrlKey) return;
        // stop scrolling the page
        e.preventDefault();
        e.stopPropagation();
        if (onScroll) onScroll({
            deltaX: e.deltaX,
            deltaY: e.deltaY
        });
    }, [
        onScroll
    ]);
    (0, _utils.useEvent)(ref, "wheel", isDisabled ? undefined : onScrollHandler);
}

},{"react":"9yzVZ","@react-aria/utils":"9cLk5","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"Zyjrk":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Handles long press interactions across mouse and touch devices. Supports a customizable time threshold,
 * accessibility description, and normalizes behavior across browsers and devices.
 */ parcelHelpers.export(exports, "useLongPress", ()=>useLongPress);
var _utils = require("@react-aria/utils");
var _usePress = require("./usePress");
var _react = require("react");
const DEFAULT_THRESHOLD = 500;
function useLongPress(props) {
    let { isDisabled, onLongPressStart, onLongPressEnd, onLongPress, threshold = DEFAULT_THRESHOLD, accessibilityDescription } = props;
    const timeRef = (0, _react.useRef)();
    let { addGlobalListener, removeGlobalListener } = (0, _utils.useGlobalListeners)();
    let { pressProps } = (0, _usePress.usePress)({
        isDisabled,
        onPressStart (e) {
            e.continuePropagation();
            if (e.pointerType === "mouse" || e.pointerType === "touch") {
                if (onLongPressStart) onLongPressStart({
                    ...e,
                    type: "longpressstart"
                });
                timeRef.current = setTimeout(()=>{
                    // Prevent other usePress handlers from also handling this event.
                    e.target.dispatchEvent(new PointerEvent("pointercancel", {
                        bubbles: true
                    }));
                    if (onLongPress) onLongPress({
                        ...e,
                        type: "longpress"
                    });
                    timeRef.current = undefined;
                }, threshold);
                // Prevent context menu, which may be opened on long press on touch devices
                if (e.pointerType === "touch") {
                    let onContextMenu = (e)=>{
                        e.preventDefault();
                    };
                    addGlobalListener(e.target, "contextmenu", onContextMenu, {
                        once: true
                    });
                    addGlobalListener(window, "pointerup", ()=>{
                        // If no contextmenu event is fired quickly after pointerup, remove the handler
                        // so future context menu events outside a long press are not prevented.
                        setTimeout(()=>{
                            removeGlobalListener(e.target, "contextmenu", onContextMenu);
                        }, 30);
                    }, {
                        once: true
                    });
                }
            }
        },
        onPressEnd (e) {
            if (timeRef.current) clearTimeout(timeRef.current);
            if (onLongPressEnd && (e.pointerType === "mouse" || e.pointerType === "touch")) onLongPressEnd({
                ...e,
                type: "longpressend"
            });
        }
    });
    let descriptionProps = (0, _utils.useDescription)(onLongPress && !isDisabled ? accessibilityDescription : undefined);
    return {
        longPressProps: (0, _utils.mergeProps)(pressProps, descriptionProps)
    };
}

},{"@react-aria/utils":"9cLk5","./usePress":"bXNrE","react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"dME48":[function(require,module,exports) {
/*
 * Copyright 2021 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Adapted from https://github.com/testing-library/jest-dom and
 * https://github.com/vuejs/vue-test-utils-next/.
 * Licensed under the MIT License.
 * @param element - Element to evaluate for display or visibility.
 */ parcelHelpers.export(exports, "isElementVisible", ()=>isElementVisible);
var _utils = require("@react-aria/utils");
function isStyleVisible(element) {
    const windowObject = (0, _utils.getOwnerWindow)(element);
    if (!(element instanceof windowObject.HTMLElement) && !(element instanceof windowObject.SVGElement)) return false;
    let { display, visibility } = element.style;
    let isVisible = display !== "none" && visibility !== "hidden" && visibility !== "collapse";
    if (isVisible) {
        const { getComputedStyle } = element.ownerDocument.defaultView;
        let { display: computedDisplay, visibility: computedVisibility } = getComputedStyle(element);
        isVisible = computedDisplay !== "none" && computedVisibility !== "hidden" && computedVisibility !== "collapse";
    }
    return isVisible;
}
function isAttributeVisible(element, childElement) {
    return !element.hasAttribute("hidden") && (element.nodeName === "DETAILS" && childElement && childElement.nodeName !== "SUMMARY" ? element.hasAttribute("open") : true);
}
function isElementVisible(element, childElement) {
    return element.nodeName !== "#comment" && isStyleVisible(element) && isAttributeVisible(element, childElement) && (!element.parentElement || isElementVisible(element.parentElement, element));
}

},{"@react-aria/utils":"9cLk5","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"ieQGF":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * A utility component that applies a CSS class when an element has keyboard focus.
 * Focus rings are visible only when the user is interacting with a keyboard,
 * not with a mouse, touch, or other input methods.
 */ parcelHelpers.export(exports, "FocusRing", ()=>FocusRing);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _utils = require("@react-aria/utils");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useFocusRing = require("./useFocusRing");
function FocusRing(props) {
    let { children, focusClass, focusRingClass } = props;
    let { isFocused, isFocusVisible, focusProps } = (0, _useFocusRing.useFocusRing)(props);
    let child = (0, _reactDefault.default).Children.only(children);
    return /*#__PURE__*/ (0, _reactDefault.default).cloneElement(child, (0, _utils.mergeProps)(child.props, {
        ...focusProps,
        className: (0, _clsxDefault.default)({
            [focusClass || ""]: isFocused,
            [focusRingClass || ""]: isFocusVisible
        })
    }));
}

},{"clsx":"fAYNK","@react-aria/utils":"9cLk5","react":"9yzVZ","./useFocusRing":"4Z5TJ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"4Z5TJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Determines whether a focus ring should be shown to indicate keyboard focus.
 * Focus rings are visible only when the user is interacting with a keyboard,
 * not with a mouse, touch, or other input methods.
 */ parcelHelpers.export(exports, "useFocusRing", ()=>useFocusRing);
var _interactions = require("@react-aria/interactions");
var _react = require("react");
function useFocusRing(props = {}) {
    let { autoFocus = false, isTextInput, within } = props;
    let state = (0, _react.useRef)({
        isFocused: false,
        isFocusVisible: autoFocus || (0, _interactions.isFocusVisible)()
    });
    let [isFocused, setFocused] = (0, _react.useState)(false);
    let [isFocusVisibleState, setFocusVisible] = (0, _react.useState)(()=>state.current.isFocused && state.current.isFocusVisible);
    let updateState = (0, _react.useCallback)(()=>setFocusVisible(state.current.isFocused && state.current.isFocusVisible), []);
    let onFocusChange = (0, _react.useCallback)((isFocused)=>{
        state.current.isFocused = isFocused;
        setFocused(isFocused);
        updateState();
    }, [
        updateState
    ]);
    (0, _interactions.useFocusVisibleListener)((isFocusVisible)=>{
        state.current.isFocusVisible = isFocusVisible;
        updateState();
    }, [], {
        isTextInput
    });
    let { focusProps } = (0, _interactions.useFocus)({
        isDisabled: within,
        onFocusChange
    });
    let { focusWithinProps } = (0, _interactions.useFocusWithin)({
        isDisabled: !within,
        onFocusWithinChange: onFocusChange
    });
    return {
        isFocused,
        isFocusVisible: isFocusVisibleState,
        focusProps: within ? focusWithinProps : focusProps
    };
}

},{"@react-aria/interactions":"ky3G8","react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"2nBUD":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FocusableProvider", ()=>_FocusableProvider);
/**
 * Used to make an element focusable and capable of auto focus.
 */ parcelHelpers.export(exports, "useFocusable", ()=>useFocusable);
var _ = require("./");
var _utils = require("@react-aria/utils");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _interactions = require("@react-aria/interactions");
let FocusableContext = /*#__PURE__*/ (0, _reactDefault.default).createContext(null);
function useFocusableContext(ref) {
    let context = (0, _react.useContext)(FocusableContext) || {};
    (0, _utils.useSyncRef)(context, ref);
    // eslint-disable-next-line
    let { ref: _, ...otherProps } = context;
    return otherProps;
}
/**
 * Provides DOM props to the nearest focusable child.
 */ function FocusableProvider(props, ref) {
    let { children, ...otherProps } = props;
    let objRef = (0, _utils.useObjectRef)(ref);
    let context = {
        ...otherProps,
        ref: objRef
    };
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(FocusableContext.Provider, {
        value: context
    }, children);
}
let _FocusableProvider = /*#__PURE__*/ (0, _reactDefault.default).forwardRef(FocusableProvider);
function useFocusable(props, domRef) {
    let { focusProps } = (0, _interactions.useFocus)(props);
    let { keyboardProps } = (0, _interactions.useKeyboard)(props);
    let interactions = (0, _utils.mergeProps)(focusProps, keyboardProps);
    let domProps = useFocusableContext(domRef);
    let interactionProps = props.isDisabled ? {} : domProps;
    let autoFocusRef = (0, _react.useRef)(props.autoFocus);
    (0, _react.useEffect)(()=>{
        if (autoFocusRef.current && domRef.current) (0, _.focusSafely)(domRef.current);
        autoFocusRef.current = false;
    }, [
        domRef
    ]);
    return {
        focusableProps: (0, _utils.mergeProps)({
            ...interactions,
            tabIndex: props.excludeFromTabOrder && !props.isDisabled ? -1 : undefined
        }, interactionProps)
    };
}

},{"./":"42mbF","@react-aria/utils":"9cLk5","react":"9yzVZ","@react-aria/interactions":"ky3G8","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"fjBnq":[function(require,module,exports) {
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// This was created for a special empty case of a component that can have child or
// be empty, like Collection/Virtualizer/Table/ListView/etc. When these components
// are empty they can have a message with a tabbable element, which is like them
// being not empty, when it comes to focus and tab order.
/**
 * Returns whether an element has a tabbable child, and updates as children change.
 * @private
 */ parcelHelpers.export(exports, "useHasTabbableChild", ()=>useHasTabbableChild);
var _focusScope = require("./FocusScope");
var _react = require("react");
var _utils = require("@react-aria/utils");
function useHasTabbableChild(ref, options) {
    let isDisabled = options === null || options === void 0 ? void 0 : options.isDisabled;
    let [hasTabbableChild, setHasTabbableChild] = (0, _react.useState)(false);
    (0, _utils.useLayoutEffect)(()=>{
        if ((ref === null || ref === void 0 ? void 0 : ref.current) && !isDisabled) {
            let update = ()=>{
                if (ref.current) {
                    let walker = (0, _focusScope.getFocusableTreeWalker)(ref.current, {
                        tabbable: true
                    });
                    setHasTabbableChild(!!walker.nextNode());
                }
            };
            update();
            // Update when new elements are inserted, or the tabIndex/disabled attribute updates.
            let observer = new MutationObserver(update);
            observer.observe(ref.current, {
                subtree: true,
                childList: true,
                attributes: true,
                attributeFilter: [
                    "tabIndex",
                    "disabled"
                ]
            });
            return ()=>{
                // Disconnect mutation observer when a React update occurs on the top-level component
                // so we update synchronously after re-rendering. Otherwise React will emit act warnings
                // in tests since mutation observers fire asynchronously. The mutation observer is necessary
                // so we also update if a child component re-renders and adds/removes something tabbable.
                observer.disconnect();
            };
        }
    });
    return isDisabled ? false : hasTabbableChild;
}

},{"./FocusScope":"elwTd","react":"9yzVZ","@react-aria/utils":"9cLk5","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"i9Unr":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides the behavior and accessibility implementation for a breadcrumbs component.
 * Breadcrumbs display a hierarchy of links to the current page or resource in an application.
 */ parcelHelpers.export(exports, "useBreadcrumbs", ()=>useBreadcrumbs);
var _utils = require("@react-aria/utils");
// @ts-ignore
var _json = require("../intl/*.json");
var _jsonDefault = parcelHelpers.interopDefault(_json);
var _i18N = require("@react-aria/i18n");
function useBreadcrumbs(props) {
    let { "aria-label": ariaLabel, ...otherProps } = props;
    let strings = (0, _i18N.useLocalizedStringFormatter)((0, _jsonDefault.default), "@react-aria/breadcrumbs");
    return {
        navProps: {
            ...(0, _utils.filterDOMProps)(otherProps, {
                labelable: true
            }),
            "aria-label": ariaLabel || strings.format("breadcrumbs")
        }
    };
}

},{"@react-aria/utils":"9cLk5","../intl/*.json":"bwBFi","@react-aria/i18n":"411rg","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"bwBFi":[function(require,module,exports) {
const _temp0 = require("6a38761146b6fe2e");
const _temp1 = require("f6b69d03e449ab21");
const _temp2 = require("af85e2bc3e34c1d6");
const _temp3 = require("5e32c2de9204e278");
const _temp4 = require("5b11147d5bfedd72");
const _temp5 = require("7c3146921ce52309");
const _temp6 = require("1e79bd5d961c6452");
const _temp7 = require("49e50a05c7963e29");
const _temp8 = require("1373b5c9a222813d");
const _temp9 = require("e11ca0be0ce69fc");
const _temp10 = require("a6f34b0d8c8ad951");
const _temp11 = require("4db20e48e4925567");
const _temp12 = require("b4f2b3bdc84b0026");
const _temp13 = require("18d72bc7e2eacf86");
const _temp14 = require("dce25e6362366691");
const _temp15 = require("23f1fd9676ab8b95");
const _temp16 = require("fa9b35c3cfa226e4");
const _temp17 = require("682acae4c1705d87");
const _temp18 = require("fdce9782f6e0c241");
const _temp19 = require("a70ab25a76745459");
const _temp20 = require("fc9d3bf6a17a9db2");
const _temp21 = require("ce90a8e9c8700853");
const _temp22 = require("2d2a634e6fdc7c2f");
const _temp23 = require("ceb2520a86f131b7");
const _temp24 = require("d9dd24235c7defee");
const _temp25 = require("a6338e819dedcced");
const _temp26 = require("6677c20ef8ad4e3a");
const _temp27 = require("5ed83f537c396fb5");
const _temp28 = require("b46950c97094556d");
const _temp29 = require("6957ceb9bd94292e");
const _temp30 = require("b71d4e4a6b126cb6");
const _temp31 = require("d0e5289e4e461332");
const _temp32 = require("c454a88bb5ffd503");
const _temp33 = require("99f443041faa1e37");
module.exports = {
    "ar-AE": _temp0,
    "bg-BG": _temp1,
    "cs-CZ": _temp2,
    "da-DK": _temp3,
    "de-DE": _temp4,
    "el-GR": _temp5,
    "en-US": _temp6,
    "es-ES": _temp7,
    "et-EE": _temp8,
    "fi-FI": _temp9,
    "fr-FR": _temp10,
    "he-IL": _temp11,
    "hr-HR": _temp12,
    "hu-HU": _temp13,
    "it-IT": _temp14,
    "ja-JP": _temp15,
    "ko-KR": _temp16,
    "lt-LT": _temp17,
    "lv-LV": _temp18,
    "nb-NO": _temp19,
    "nl-NL": _temp20,
    "pl-PL": _temp21,
    "pt-BR": _temp22,
    "pt-PT": _temp23,
    "ro-RO": _temp24,
    "ru-RU": _temp25,
    "sk-SK": _temp26,
    "sl-SI": _temp27,
    "sr-SP": _temp28,
    "sv-SE": _temp29,
    "tr-TR": _temp30,
    "uk-UA": _temp31,
    "zh-CN": _temp32,
    "zh-TW": _temp33
};

},{"6a38761146b6fe2e":"cPJgA","f6b69d03e449ab21":"dINIE","af85e2bc3e34c1d6":"geUmN","5e32c2de9204e278":"6UDo1","5b11147d5bfedd72":"8g2kh","7c3146921ce52309":"ejTsV","1e79bd5d961c6452":"hXHhB","49e50a05c7963e29":"blIaQ","1373b5c9a222813d":"Zd6Dp","e11ca0be0ce69fc":"iLR2d","a6f34b0d8c8ad951":"gkRtp","4db20e48e4925567":"9nh66","b4f2b3bdc84b0026":"e8mrs","18d72bc7e2eacf86":"gcORF","dce25e6362366691":"5RVWN","23f1fd9676ab8b95":"e73mK","fa9b35c3cfa226e4":"fnS6M","682acae4c1705d87":"dduJi","fdce9782f6e0c241":"9AESY","a70ab25a76745459":"b8PoA","fc9d3bf6a17a9db2":"eXn7C","ce90a8e9c8700853":"dzCXR","2d2a634e6fdc7c2f":"7cn8S","ceb2520a86f131b7":"3iP69","d9dd24235c7defee":"a4aYR","a6338e819dedcced":"7ylNp","6677c20ef8ad4e3a":"gRIuh","5ed83f537c396fb5":"8Omwh","b46950c97094556d":"am59f","6957ceb9bd94292e":"iUFHi","b71d4e4a6b126cb6":"gnz2t","d0e5289e4e461332":"eAIwP","c454a88bb5ffd503":"iHDvE","99f443041faa1e37":"6MOY6"}],"cPJgA":[function(require,module,exports) {
module.exports = {
    "breadcrumbs": `\u{639}\u{646}\u{627}\u{635}\u{631} \u{627}\u{644}\u{648}\u{627}\u{62C}\u{647}\u{629}`
};

},{}],"dINIE":[function(require,module,exports) {
module.exports = {
    "breadcrumbs": `\u{422}\u{440}\u{43E}\u{445}\u{438} \u{445}\u{43B}\u{44F}\u{431}`
};

},{}],"geUmN":[function(require,module,exports) {
module.exports = {
    "breadcrumbs": `Popis cesty`
};

},{}],"6UDo1":[function(require,module,exports) {
module.exports = {
    "breadcrumbs": `Br\xf8dkrummer`
};

},{}],"8g2kh":[function(require,module,exports) {
module.exports = {
    "breadcrumbs": `Breadcrumbs`
};

},{}],"ejTsV":[function(require,module,exports) {
module.exports = {
    "breadcrumbs": `\u{3A0}\u{3BB}\u{3BF}\u{3B7}\u{3B3}\u{3AE}\u{3C3}\u{3B5}\u{3B9}\u{3C2} breadcrumb`
};

},{}],"hXHhB":[function(require,module,exports) {
module.exports = {
    "breadcrumbs": `Breadcrumbs`
};

},{}],"blIaQ":[function(require,module,exports) {
module.exports = {
    "breadcrumbs": `Migas de pan`
};

},{}],"Zd6Dp":[function(require,module,exports) {
module.exports = {
    "breadcrumbs": `Lingiread`
};

},{}],"iLR2d":[function(require,module,exports) {
module.exports = {
    "breadcrumbs": `Navigointilinkit`
};

},{}],"gkRtp":[function(require,module,exports) {
module.exports = {
    "breadcrumbs": `Chemin de navigation`
};

},{}],"9nh66":[function(require,module,exports) {
module.exports = {
    "breadcrumbs": `\u{5E9}\u{5D1}\u{5D9}\u{5DC}\u{5D9} \u{5E0}\u{5D9}\u{5D5}\u{5D5}\u{5D8}`
};

},{}],"e8mrs":[function(require,module,exports) {
module.exports = {
    "breadcrumbs": `Navigacijski putovi`
};

},{}],"gcORF":[function(require,module,exports) {
module.exports = {
    "breadcrumbs": `Morzsamen\xfc`
};

},{}],"5RVWN":[function(require,module,exports) {
module.exports = {
    "breadcrumbs": `Breadcrumb`
};

},{}],"e73mK":[function(require,module,exports) {
module.exports = {
    "breadcrumbs": `\u{30D1}\u{30F3}\u{304F}\u{305A}\u{30EA}\u{30B9}\u{30C8}`
};

},{}],"fnS6M":[function(require,module,exports) {
module.exports = {
    "breadcrumbs": `\u{D0D0}\u{C0C9} \u{D45C}\u{C2DC}`
};

},{}],"dduJi":[function(require,module,exports) {
module.exports = {
    "breadcrumbs": `Nar\u{161}ymo kelias`
};

},{}],"9AESY":[function(require,module,exports) {
module.exports = {
    "breadcrumbs": `Atpaka\u{13C}ce\u{13C}i`
};

},{}],"b8PoA":[function(require,module,exports) {
module.exports = {
    "breadcrumbs": `Navigasjonsstier`
};

},{}],"eXn7C":[function(require,module,exports) {
module.exports = {
    "breadcrumbs": `Broodkruimels`
};

},{}],"dzCXR":[function(require,module,exports) {
module.exports = {
    "breadcrumbs": `Struktura nawigacyjna`
};

},{}],"7cn8S":[function(require,module,exports) {
module.exports = {
    "breadcrumbs": `Caminho detalhado`
};

},{}],"3iP69":[function(require,module,exports) {
module.exports = {
    "breadcrumbs": `Categorias`
};

},{}],"a4aYR":[function(require,module,exports) {
module.exports = {
    "breadcrumbs": `Miez de p\xe2ine`
};

},{}],"7ylNp":[function(require,module,exports) {
module.exports = {
    "breadcrumbs": `\u{41D}\u{430}\u{432}\u{438}\u{433}\u{430}\u{446}\u{438}\u{44F}`
};

},{}],"gRIuh":[function(require,module,exports) {
module.exports = {
    "breadcrumbs": `Naviga\u{10D}n\xe9 prvky Breadcrumbs`
};

},{}],"8Omwh":[function(require,module,exports) {
module.exports = {
    "breadcrumbs": `Drobtine`
};

},{}],"am59f":[function(require,module,exports) {
module.exports = {
    "breadcrumbs": `Putanje navigacije`
};

},{}],"iUFHi":[function(require,module,exports) {
module.exports = {
    "breadcrumbs": `S\xf6kv\xe4gar`
};

},{}],"gnz2t":[function(require,module,exports) {
module.exports = {
    "breadcrumbs": `\u{130}\xe7erik haritalar\u{131}`
};

},{}],"eAIwP":[function(require,module,exports) {
module.exports = {
    "breadcrumbs": `\u{41D}\u{430}\u{432}\u{456}\u{433}\u{430}\u{446}\u{456}\u{439}\u{43D}\u{430} \u{441}\u{442}\u{435}\u{436}\u{43A}\u{430}`
};

},{}],"iHDvE":[function(require,module,exports) {
module.exports = {
    "breadcrumbs": `\u{5BFC}\u{822A}\u{680F}`
};

},{}],"6MOY6":[function(require,module,exports) {
module.exports = {
    "breadcrumbs": `\u{5C0E}\u{89BD}\u{5217}`
};

},{}],"411rg":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "I18nProvider", ()=>(0, _context.I18nProvider));
parcelHelpers.export(exports, "useLocale", ()=>(0, _context.useLocale));
parcelHelpers.export(exports, "useMessageFormatter", ()=>(0, _useMessageFormatter.useMessageFormatter));
parcelHelpers.export(exports, "useLocalizedStringFormatter", ()=>(0, _useLocalizedStringFormatter.useLocalizedStringFormatter));
parcelHelpers.export(exports, "useLocalizedStringDictionary", ()=>(0, _useLocalizedStringFormatter.useLocalizedStringDictionary));
parcelHelpers.export(exports, "useListFormatter", ()=>(0, _useListFormatter.useListFormatter));
parcelHelpers.export(exports, "useDateFormatter", ()=>(0, _useDateFormatter.useDateFormatter));
parcelHelpers.export(exports, "useNumberFormatter", ()=>(0, _useNumberFormatter.useNumberFormatter));
parcelHelpers.export(exports, "useCollator", ()=>(0, _useCollator.useCollator));
parcelHelpers.export(exports, "useFilter", ()=>(0, _useFilter.useFilter));
var _context = require("./context");
var _useMessageFormatter = require("./useMessageFormatter");
var _useLocalizedStringFormatter = require("./useLocalizedStringFormatter");
var _useListFormatter = require("./useListFormatter");
var _useDateFormatter = require("./useDateFormatter");
var _useNumberFormatter = require("./useNumberFormatter");
var _useCollator = require("./useCollator");
var _useFilter = require("./useFilter");

},{"./context":"cPMDk","./useMessageFormatter":"kXqmx","./useLocalizedStringFormatter":"2VV1t","./useListFormatter":"pAmvs","./useDateFormatter":"dzmhs","./useNumberFormatter":"gPJri","./useCollator":"bAhV3","./useFilter":"fVAwd","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"cPMDk":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides the locale for the application to all child components.
 */ parcelHelpers.export(exports, "I18nProvider", ()=>I18nProvider);
/**
 * Returns the current locale and layout direction.
 */ parcelHelpers.export(exports, "useLocale", ()=>useLocale);
var _utils = require("./utils");
var _useDefaultLocale = require("./useDefaultLocale");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const I18nContext = /*#__PURE__*/ (0, _reactDefault.default).createContext(null);
function I18nProvider(props) {
    let { locale, children } = props;
    let defaultLocale = (0, _useDefaultLocale.useDefaultLocale)();
    let value = locale ? {
        locale,
        direction: (0, _utils.isRTL)(locale) ? "rtl" : "ltr"
    } : defaultLocale;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(I18nContext.Provider, {
        value: value
    }, children);
}
function useLocale() {
    let defaultLocale = (0, _useDefaultLocale.useDefaultLocale)();
    let context = (0, _react.useContext)(I18nContext);
    return context || defaultLocale;
}

},{"./utils":"jpdbD","./useDefaultLocale":"kDf8c","react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"jpdbD":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // https://en.wikipedia.org/wiki/Right-to-left
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Determines if a locale is read right to left using [Intl.Locale]{@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale}.
 */ parcelHelpers.export(exports, "isRTL", ()=>isRTL);
const RTL_SCRIPTS = new Set([
    "Arab",
    "Syrc",
    "Samr",
    "Mand",
    "Thaa",
    "Mend",
    "Nkoo",
    "Adlm",
    "Rohg",
    "Hebr"
]);
const RTL_LANGS = new Set([
    "ae",
    "ar",
    "arc",
    "bcc",
    "bqi",
    "ckb",
    "dv",
    "fa",
    "glk",
    "he",
    "ku",
    "mzn",
    "nqo",
    "pnb",
    "ps",
    "sd",
    "ug",
    "ur",
    "yi"
]);
function isRTL(localeString) {
    // If the Intl.Locale API is available, use it to get the locale's text direction.
    // @ts-ignore
    if (Intl.Locale) {
        let locale = new Intl.Locale(localeString).maximize();
        // Use the text info object to get the direction if possible.
        // @ts-ignore - this was implemented as a property by some browsers before it was standardized as a function.
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/getTextInfo
        let textInfo = typeof locale.getTextInfo === "function" ? locale.getTextInfo() : locale.textInfo;
        if (textInfo) return textInfo.direction === "rtl";
        // Fallback: guess using the script.
        // This is more accurate than guessing by language, since languages can be written in multiple scripts.
        if (locale.script) return RTL_SCRIPTS.has(locale.script);
    }
    // If not, just guess by the language (first part of the locale)
    let lang = localeString.split("-")[0];
    return RTL_LANGS.has(lang);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"kDf8c":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Gets the locale setting of the browser.
 */ parcelHelpers.export(exports, "getDefaultLocale", ()=>getDefaultLocale);
/**
 * Returns the current browser/system language, and updates when it changes.
 */ parcelHelpers.export(exports, "useDefaultLocale", ()=>useDefaultLocale);
var _utils = require("./utils");
var _react = require("react");
var _ssr = require("@react-aria/ssr");
// Locale passed from server by PackageLocalizationProvider.
const localeSymbol = Symbol.for("react-aria.i18n.locale");
function getDefaultLocale() {
    let locale = typeof window !== "undefined" && window[localeSymbol] || typeof navigator !== "undefined" && (navigator.language || navigator.userLanguage) || "en-US";
    try {
        // @ts-ignore
        Intl.DateTimeFormat.supportedLocalesOf([
            locale
        ]);
    } catch (_err) {
        locale = "en-US";
    }
    return {
        locale,
        direction: (0, _utils.isRTL)(locale) ? "rtl" : "ltr"
    };
}
let currentLocale = getDefaultLocale();
let listeners = new Set();
function updateLocale() {
    currentLocale = getDefaultLocale();
    for (let listener of listeners)listener(currentLocale);
}
function useDefaultLocale() {
    let isSSR = (0, _ssr.useIsSSR)();
    let [defaultLocale, setDefaultLocale] = (0, _react.useState)(currentLocale);
    (0, _react.useEffect)(()=>{
        if (listeners.size === 0) window.addEventListener("languagechange", updateLocale);
        listeners.add(setDefaultLocale);
        return ()=>{
            listeners.delete(setDefaultLocale);
            if (listeners.size === 0) window.removeEventListener("languagechange", updateLocale);
        };
    }, []);
    // We cannot determine the browser's language on the server, so default to
    // en-US. This will be updated after hydration on the client to the correct value.
    if (isSSR) return {
        locale: "en-US",
        direction: "ltr"
    };
    return defaultLocale;
}

},{"./utils":"jpdbD","react":"9yzVZ","@react-aria/ssr":"gmUOW","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"2VV1t":[function(require,module,exports) {
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Returns a cached LocalizedStringDictionary for the given strings.
 */ parcelHelpers.export(exports, "useLocalizedStringDictionary", ()=>useLocalizedStringDictionary);
/**
 * Provides localized string formatting for the current locale. Supports interpolating variables,
 * selecting the correct pluralization, and formatting numbers. Automatically updates when the locale changes.
 * @param strings - A mapping of languages to localized strings by key.
 */ parcelHelpers.export(exports, "useLocalizedStringFormatter", ()=>useLocalizedStringFormatter);
var _string = require("@internationalized/string");
var _context = require("./context");
var _react = require("react");
const cache = new WeakMap();
function getCachedDictionary(strings) {
    let dictionary = cache.get(strings);
    if (!dictionary) {
        dictionary = new (0, _string.LocalizedStringDictionary)(strings);
        cache.set(strings, dictionary);
    }
    return dictionary;
}
function useLocalizedStringDictionary(strings, packageName) {
    return packageName && (0, _string.LocalizedStringDictionary).getGlobalDictionaryForPackage(packageName) || getCachedDictionary(strings);
}
function useLocalizedStringFormatter(strings, packageName) {
    let { locale } = (0, _context.useLocale)();
    let dictionary = useLocalizedStringDictionary(strings, packageName);
    return (0, _react.useMemo)(()=>new (0, _string.LocalizedStringFormatter)(locale, dictionary), [
        locale,
        dictionary
    ]);
}

},{"@internationalized/string":"3QbrG","./context":"cPMDk","react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"3QbrG":[function(require,module,exports) {
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LocalizedStringDictionary", ()=>(0, _localizedStringDictionary.LocalizedStringDictionary));
parcelHelpers.export(exports, "LocalizedStringFormatter", ()=>(0, _localizedStringFormatter.LocalizedStringFormatter));
var _localizedStringDictionary = require("./LocalizedStringDictionary");
var _localizedStringFormatter = require("./LocalizedStringFormatter");

},{"./LocalizedStringDictionary":"1LA49","./LocalizedStringFormatter":"dZ23X","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"1LA49":[function(require,module,exports) {
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Stores a mapping of localized strings. Can be used to find the
 * closest available string for a given locale.
 */ parcelHelpers.export(exports, "LocalizedStringDictionary", ()=>LocalizedStringDictionary);
const localeSymbol = Symbol.for("react-aria.i18n.locale");
const stringsSymbol = Symbol.for("react-aria.i18n.strings");
let cachedGlobalStrings = undefined;
class LocalizedStringDictionary {
    /** Returns a localized string for the given key and locale. */ getStringForLocale(key, locale) {
        let strings = this.getStringsForLocale(locale);
        let string = strings[key];
        if (!string) throw new Error(`Could not find intl message ${key} in ${locale} locale`);
        return string;
    }
    /** Returns all localized strings for the given locale. */ getStringsForLocale(locale) {
        let strings = this.strings[locale];
        if (!strings) {
            strings = getStringsForLocale(locale, this.strings, this.defaultLocale);
            this.strings[locale] = strings;
        }
        return strings;
    }
    static getGlobalDictionaryForPackage(packageName) {
        if (typeof window === "undefined") return null;
        let locale = window[localeSymbol];
        if (cachedGlobalStrings === undefined) {
            let globalStrings = window[stringsSymbol];
            if (!globalStrings) return null;
            cachedGlobalStrings = {};
            for(let pkg in globalStrings)cachedGlobalStrings[pkg] = new LocalizedStringDictionary({
                [locale]: globalStrings[pkg]
            }, locale);
        }
        let dictionary = cachedGlobalStrings === null || cachedGlobalStrings === void 0 ? void 0 : cachedGlobalStrings[packageName];
        if (!dictionary) throw new Error(`Strings for package "${packageName}" were not included by LocalizedStringProvider. Please add it to the list passed to createLocalizedStringDictionary.`);
        return dictionary;
    }
    constructor(messages, defaultLocale = "en-US"){
        // Clone messages so we don't modify the original object.
        this.strings = {
            ...messages
        };
        this.defaultLocale = defaultLocale;
    }
}
function getStringsForLocale(locale, strings, defaultLocale = "en-US") {
    // If there is an exact match, use it.
    if (strings[locale]) return strings[locale];
    // Attempt to find the closest match by language.
    // For example, if the locale is fr-CA (French Canadian), but there is only
    // an fr-FR (France) set of strings, use that.
    // This could be replaced with Intl.LocaleMatcher once it is supported.
    // https://github.com/tc39/proposal-intl-localematcher
    let language = getLanguage(locale);
    if (strings[language]) return strings[language];
    for(let key in strings){
        if (key.startsWith(language + "-")) return strings[key];
    }
    // Nothing close, use english.
    return strings[defaultLocale];
}
function getLanguage(locale) {
    // @ts-ignore
    if (Intl.Locale) // @ts-ignore
    return new Intl.Locale(locale).language;
    return locale.split("-")[0];
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"dZ23X":[function(require,module,exports) {
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Formats localized strings from a LocalizedStringDictionary. Supports interpolating variables,
 * selecting the correct pluralization, and formatting numbers for the locale.
 */ parcelHelpers.export(exports, "LocalizedStringFormatter", ()=>LocalizedStringFormatter);
const pluralRulesCache = new Map();
const numberFormatCache = new Map();
class LocalizedStringFormatter {
    /** Formats a localized string for the given key with the provided variables. */ format(key, variables) {
        let message = this.strings.getStringForLocale(key, this.locale);
        return typeof message === "function" ? message(variables, this) : message;
    }
    plural(count, options, type = "cardinal") {
        let opt = options["=" + count];
        if (opt) return typeof opt === "function" ? opt() : opt;
        let key = this.locale + ":" + type;
        let pluralRules = pluralRulesCache.get(key);
        if (!pluralRules) {
            pluralRules = new Intl.PluralRules(this.locale, {
                type
            });
            pluralRulesCache.set(key, pluralRules);
        }
        let selected = pluralRules.select(count);
        opt = options[selected] || options.other;
        return typeof opt === "function" ? opt() : opt;
    }
    number(value) {
        let numberFormat = numberFormatCache.get(this.locale);
        if (!numberFormat) {
            numberFormat = new Intl.NumberFormat(this.locale);
            numberFormatCache.set(this.locale, numberFormat);
        }
        return numberFormat.format(value);
    }
    select(options, value) {
        let opt = options[value] || options.other;
        return typeof opt === "function" ? opt() : opt;
    }
    constructor(locale, strings){
        this.locale = locale;
        this.strings = strings;
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"pAmvs":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides localized list formatting for the current locale. Automatically updates when the locale changes,
 * and handles caching of the list formatter for performance.
 * @param options - Formatting options.
 */ parcelHelpers.export(exports, "useListFormatter", ()=>useListFormatter);
var _context = require("./context");
var _react = require("react");
function useListFormatter(options = {}) {
    let { locale } = (0, _context.useLocale)();
    return (0, _react.useMemo)(()=>new Intl.ListFormat(locale, options), [
        locale,
        options
    ]);
}

},{"./context":"cPMDk","react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"dzmhs":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides localized date formatting for the current locale. Automatically updates when the locale changes,
 * and handles caching of the date formatter for performance.
 * @param options - Formatting options.
 */ parcelHelpers.export(exports, "useDateFormatter", ()=>useDateFormatter);
var _date = require("@internationalized/date");
var _utils = require("@react-aria/utils");
var _context = require("./context");
var _react = require("react");
function useDateFormatter(options) {
    // Reuse last options object if it is shallowly equal, which allows the useMemo result to also be reused.
    options = (0, _utils.useDeepMemo)(options !== null && options !== void 0 ? options : {}, isEqual);
    let { locale } = (0, _context.useLocale)();
    return (0, _react.useMemo)(()=>new (0, _date.DateFormatter)(locale, options), [
        locale,
        options
    ]);
}
function isEqual(a, b) {
    if (a === b) return true;
    let aKeys = Object.keys(a);
    let bKeys = Object.keys(b);
    if (aKeys.length !== bKeys.length) return false;
    for (let key of aKeys){
        if (b[key] !== a[key]) return false;
    }
    return true;
}

},{"@internationalized/date":"hesBk","@react-aria/utils":"9cLk5","./context":"cPMDk","react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"hesBk":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CalendarDate", ()=>(0, _calendarDate.CalendarDate));
parcelHelpers.export(exports, "CalendarDateTime", ()=>(0, _calendarDate.CalendarDateTime));
parcelHelpers.export(exports, "Time", ()=>(0, _calendarDate.Time));
parcelHelpers.export(exports, "ZonedDateTime", ()=>(0, _calendarDate.ZonedDateTime));
parcelHelpers.export(exports, "GregorianCalendar", ()=>(0, _gregorianCalendar.GregorianCalendar));
parcelHelpers.export(exports, "JapaneseCalendar", ()=>(0, _japaneseCalendar.JapaneseCalendar));
parcelHelpers.export(exports, "BuddhistCalendar", ()=>(0, _buddhistCalendar.BuddhistCalendar));
parcelHelpers.export(exports, "TaiwanCalendar", ()=>(0, _taiwanCalendar.TaiwanCalendar));
parcelHelpers.export(exports, "PersianCalendar", ()=>(0, _persianCalendar.PersianCalendar));
parcelHelpers.export(exports, "IndianCalendar", ()=>(0, _indianCalendar.IndianCalendar));
parcelHelpers.export(exports, "IslamicCivilCalendar", ()=>(0, _islamicCalendar.IslamicCivilCalendar));
parcelHelpers.export(exports, "IslamicTabularCalendar", ()=>(0, _islamicCalendar.IslamicTabularCalendar));
parcelHelpers.export(exports, "IslamicUmalquraCalendar", ()=>(0, _islamicCalendar.IslamicUmalquraCalendar));
parcelHelpers.export(exports, "HebrewCalendar", ()=>(0, _hebrewCalendar.HebrewCalendar));
parcelHelpers.export(exports, "EthiopicCalendar", ()=>(0, _ethiopicCalendar.EthiopicCalendar));
parcelHelpers.export(exports, "EthiopicAmeteAlemCalendar", ()=>(0, _ethiopicCalendar.EthiopicAmeteAlemCalendar));
parcelHelpers.export(exports, "CopticCalendar", ()=>(0, _ethiopicCalendar.CopticCalendar));
parcelHelpers.export(exports, "createCalendar", ()=>(0, _createCalendar.createCalendar));
parcelHelpers.export(exports, "toCalendarDate", ()=>(0, _conversion.toCalendarDate));
parcelHelpers.export(exports, "toCalendarDateTime", ()=>(0, _conversion.toCalendarDateTime));
parcelHelpers.export(exports, "toTime", ()=>(0, _conversion.toTime));
parcelHelpers.export(exports, "toCalendar", ()=>(0, _conversion.toCalendar));
parcelHelpers.export(exports, "toZoned", ()=>(0, _conversion.toZoned));
parcelHelpers.export(exports, "toTimeZone", ()=>(0, _conversion.toTimeZone));
parcelHelpers.export(exports, "toLocalTimeZone", ()=>(0, _conversion.toLocalTimeZone));
parcelHelpers.export(exports, "fromDate", ()=>(0, _conversion.fromDate));
parcelHelpers.export(exports, "fromAbsolute", ()=>(0, _conversion.fromAbsolute));
parcelHelpers.export(exports, "isSameDay", ()=>(0, _queries.isSameDay));
parcelHelpers.export(exports, "isSameMonth", ()=>(0, _queries.isSameMonth));
parcelHelpers.export(exports, "isSameYear", ()=>(0, _queries.isSameYear));
parcelHelpers.export(exports, "isEqualDay", ()=>(0, _queries.isEqualDay));
parcelHelpers.export(exports, "isEqualMonth", ()=>(0, _queries.isEqualMonth));
parcelHelpers.export(exports, "isEqualYear", ()=>(0, _queries.isEqualYear));
parcelHelpers.export(exports, "isToday", ()=>(0, _queries.isToday));
parcelHelpers.export(exports, "getDayOfWeek", ()=>(0, _queries.getDayOfWeek));
parcelHelpers.export(exports, "now", ()=>(0, _queries.now));
parcelHelpers.export(exports, "today", ()=>(0, _queries.today));
parcelHelpers.export(exports, "getHoursInDay", ()=>(0, _queries.getHoursInDay));
parcelHelpers.export(exports, "getLocalTimeZone", ()=>(0, _queries.getLocalTimeZone));
parcelHelpers.export(exports, "startOfMonth", ()=>(0, _queries.startOfMonth));
parcelHelpers.export(exports, "startOfWeek", ()=>(0, _queries.startOfWeek));
parcelHelpers.export(exports, "startOfYear", ()=>(0, _queries.startOfYear));
parcelHelpers.export(exports, "endOfMonth", ()=>(0, _queries.endOfMonth));
parcelHelpers.export(exports, "endOfWeek", ()=>(0, _queries.endOfWeek));
parcelHelpers.export(exports, "endOfYear", ()=>(0, _queries.endOfYear));
parcelHelpers.export(exports, "getMinimumMonthInYear", ()=>(0, _queries.getMinimumMonthInYear));
parcelHelpers.export(exports, "getMinimumDayInMonth", ()=>(0, _queries.getMinimumDayInMonth));
parcelHelpers.export(exports, "getWeeksInMonth", ()=>(0, _queries.getWeeksInMonth));
parcelHelpers.export(exports, "minDate", ()=>(0, _queries.minDate));
parcelHelpers.export(exports, "maxDate", ()=>(0, _queries.maxDate));
parcelHelpers.export(exports, "isWeekend", ()=>(0, _queries.isWeekend));
parcelHelpers.export(exports, "isWeekday", ()=>(0, _queries.isWeekday));
parcelHelpers.export(exports, "parseDate", ()=>(0, _string.parseDate));
parcelHelpers.export(exports, "parseDateTime", ()=>(0, _string.parseDateTime));
parcelHelpers.export(exports, "parseTime", ()=>(0, _string.parseTime));
parcelHelpers.export(exports, "parseAbsolute", ()=>(0, _string.parseAbsolute));
parcelHelpers.export(exports, "parseAbsoluteToLocal", ()=>(0, _string.parseAbsoluteToLocal));
parcelHelpers.export(exports, "parseZonedDateTime", ()=>(0, _string.parseZonedDateTime));
parcelHelpers.export(exports, "parseDuration", ()=>(0, _string.parseDuration));
parcelHelpers.export(exports, "DateFormatter", ()=>(0, _dateFormatter.DateFormatter));
var _calendarDate = require("./CalendarDate");
var _gregorianCalendar = require("./calendars/GregorianCalendar");
var _japaneseCalendar = require("./calendars/JapaneseCalendar");
var _buddhistCalendar = require("./calendars/BuddhistCalendar");
var _taiwanCalendar = require("./calendars/TaiwanCalendar");
var _persianCalendar = require("./calendars/PersianCalendar");
var _indianCalendar = require("./calendars/IndianCalendar");
var _islamicCalendar = require("./calendars/IslamicCalendar");
var _hebrewCalendar = require("./calendars/HebrewCalendar");
var _ethiopicCalendar = require("./calendars/EthiopicCalendar");
var _createCalendar = require("./createCalendar");
var _conversion = require("./conversion");
var _queries = require("./queries");
var _string = require("./string");
var _dateFormatter = require("./DateFormatter");

},{"./CalendarDate":"jcaEo","./calendars/GregorianCalendar":"fE40j","./calendars/JapaneseCalendar":false,"./calendars/BuddhistCalendar":false,"./calendars/TaiwanCalendar":false,"./calendars/PersianCalendar":false,"./calendars/IndianCalendar":false,"./calendars/IslamicCalendar":false,"./calendars/HebrewCalendar":false,"./calendars/EthiopicCalendar":false,"./createCalendar":"3gyh2","./conversion":"gOiVm","./queries":"gtZrq","./string":"4N0ez","./DateFormatter":"5MyYo","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"jcaEo":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/** A CalendarDate represents a date without any time components in a specific calendar system. */ parcelHelpers.export(exports, "CalendarDate", ()=>CalendarDate);
/** A Time represents a clock time without any date components. */ parcelHelpers.export(exports, "Time", ()=>Time);
/** A CalendarDateTime represents a date and time without a time zone, in a specific calendar system. */ parcelHelpers.export(exports, "CalendarDateTime", ()=>CalendarDateTime);
/** A ZonedDateTime represents a date and time in a specific time zone and calendar system. */ parcelHelpers.export(exports, "ZonedDateTime", ()=>ZonedDateTime);
var _classPrivateFieldInit = require("@swc/helpers/_/_class_private_field_init");
var _manipulation = require("./manipulation");
var _queries = require("./queries");
var _string = require("./string");
var _gregorianCalendar = require("./calendars/GregorianCalendar");
var _conversion = require("./conversion");
function shiftArgs(args) {
    let calendar = typeof args[0] === "object" ? args.shift() : new (0, _gregorianCalendar.GregorianCalendar)();
    let era;
    if (typeof args[0] === "string") era = args.shift();
    else {
        let eras = calendar.getEras();
        era = eras[eras.length - 1];
    }
    let year = args.shift();
    let month = args.shift();
    let day = args.shift();
    return [
        calendar,
        era,
        year,
        month,
        day
    ];
}
var // This prevents TypeScript from allowing other types with the same fields to match.
// i.e. a ZonedDateTime should not be be passable to a parameter that expects CalendarDate.
// If that behavior is desired, use the AnyCalendarDate interface instead.
// @ts-ignore
_type = /*#__PURE__*/ new WeakMap();
class CalendarDate {
    /** Returns a copy of this date. */ copy() {
        if (this.era) return new CalendarDate(this.calendar, this.era, this.year, this.month, this.day);
        else return new CalendarDate(this.calendar, this.year, this.month, this.day);
    }
    /** Returns a new `CalendarDate` with the given duration added to it. */ add(duration) {
        return (0, _manipulation.add)(this, duration);
    }
    /** Returns a new `CalendarDate` with the given duration subtracted from it. */ subtract(duration) {
        return (0, _manipulation.subtract)(this, duration);
    }
    /** Returns a new `CalendarDate` with the given fields set to the provided values. Other fields will be constrained accordingly. */ set(fields) {
        return (0, _manipulation.set)(this, fields);
    }
    /**
   * Returns a new `CalendarDate` with the given field adjusted by a specified amount.
   * When the resulting value reaches the limits of the field, it wraps around.
   */ cycle(field, amount, options) {
        return (0, _manipulation.cycleDate)(this, field, amount, options);
    }
    /** Converts the date to a native JavaScript Date object, with the time set to midnight in the given time zone. */ toDate(timeZone) {
        return (0, _conversion.toDate)(this, timeZone);
    }
    /** Converts the date to an ISO 8601 formatted string. */ toString() {
        return (0, _string.dateToString)(this);
    }
    /** Compares this date with another. A negative result indicates that this date is before the given one, and a positive date indicates that it is after. */ compare(b) {
        return (0, _queries.compareDate)(this, b);
    }
    constructor(...args){
        (0, _classPrivateFieldInit._)(this, _type, {
            writable: true,
            value: void 0
        });
        let [calendar, era, year, month, day] = shiftArgs(args);
        this.calendar = calendar;
        this.era = era;
        this.year = year;
        this.month = month;
        this.day = day;
        (0, _manipulation.constrain)(this);
    }
}
var // This prevents TypeScript from allowing other types with the same fields to match.
// @ts-ignore
_type1 = /*#__PURE__*/ new WeakMap();
class Time {
    /** Returns a copy of this time. */ copy() {
        return new Time(this.hour, this.minute, this.second, this.millisecond);
    }
    /** Returns a new `Time` with the given duration added to it. */ add(duration) {
        return (0, _manipulation.addTime)(this, duration);
    }
    /** Returns a new `Time` with the given duration subtracted from it. */ subtract(duration) {
        return (0, _manipulation.subtractTime)(this, duration);
    }
    /** Returns a new `Time` with the given fields set to the provided values. Other fields will be constrained accordingly. */ set(fields) {
        return (0, _manipulation.setTime)(this, fields);
    }
    /**
   * Returns a new `Time` with the given field adjusted by a specified amount.
   * When the resulting value reaches the limits of the field, it wraps around.
   */ cycle(field, amount, options) {
        return (0, _manipulation.cycleTime)(this, field, amount, options);
    }
    /** Converts the time to an ISO 8601 formatted string. */ toString() {
        return (0, _string.timeToString)(this);
    }
    /** Compares this time with another. A negative result indicates that this time is before the given one, and a positive time indicates that it is after. */ compare(b) {
        return (0, _queries.compareTime)(this, b);
    }
    constructor(hour = 0, minute = 0, second = 0, millisecond = 0){
        (0, _classPrivateFieldInit._)(this, _type1, {
            writable: true,
            value: void 0
        });
        this.hour = hour;
        this.minute = minute;
        this.second = second;
        this.millisecond = millisecond;
        (0, _manipulation.constrainTime)(this);
    }
}
var // This prevents TypeScript from allowing other types with the same fields to match.
// @ts-ignore
_type2 = /*#__PURE__*/ new WeakMap();
class CalendarDateTime {
    /** Returns a copy of this date. */ copy() {
        if (this.era) return new CalendarDateTime(this.calendar, this.era, this.year, this.month, this.day, this.hour, this.minute, this.second, this.millisecond);
        else return new CalendarDateTime(this.calendar, this.year, this.month, this.day, this.hour, this.minute, this.second, this.millisecond);
    }
    /** Returns a new `CalendarDateTime` with the given duration added to it. */ add(duration) {
        return (0, _manipulation.add)(this, duration);
    }
    /** Returns a new `CalendarDateTime` with the given duration subtracted from it. */ subtract(duration) {
        return (0, _manipulation.subtract)(this, duration);
    }
    /** Returns a new `CalendarDateTime` with the given fields set to the provided values. Other fields will be constrained accordingly. */ set(fields) {
        return (0, _manipulation.set)((0, _manipulation.setTime)(this, fields), fields);
    }
    /**
   * Returns a new `CalendarDateTime` with the given field adjusted by a specified amount.
   * When the resulting value reaches the limits of the field, it wraps around.
   */ cycle(field, amount, options) {
        switch(field){
            case "era":
            case "year":
            case "month":
            case "day":
                return (0, _manipulation.cycleDate)(this, field, amount, options);
            default:
                return (0, _manipulation.cycleTime)(this, field, amount, options);
        }
    }
    /** Converts the date to a native JavaScript Date object in the given time zone. */ toDate(timeZone, disambiguation) {
        return (0, _conversion.toDate)(this, timeZone, disambiguation);
    }
    /** Converts the date to an ISO 8601 formatted string. */ toString() {
        return (0, _string.dateTimeToString)(this);
    }
    /** Compares this date with another. A negative result indicates that this date is before the given one, and a positive date indicates that it is after. */ compare(b) {
        let res = (0, _queries.compareDate)(this, b);
        if (res === 0) return (0, _queries.compareTime)(this, (0, _conversion.toCalendarDateTime)(b));
        return res;
    }
    constructor(...args){
        (0, _classPrivateFieldInit._)(this, _type2, {
            writable: true,
            value: void 0
        });
        let [calendar, era, year, month, day] = shiftArgs(args);
        this.calendar = calendar;
        this.era = era;
        this.year = year;
        this.month = month;
        this.day = day;
        this.hour = args.shift() || 0;
        this.minute = args.shift() || 0;
        this.second = args.shift() || 0;
        this.millisecond = args.shift() || 0;
        (0, _manipulation.constrain)(this);
    }
}
var // This prevents TypeScript from allowing other types with the same fields to match.
// @ts-ignore
_type3 = /*#__PURE__*/ new WeakMap();
class ZonedDateTime {
    /** Returns a copy of this date. */ copy() {
        if (this.era) return new ZonedDateTime(this.calendar, this.era, this.year, this.month, this.day, this.timeZone, this.offset, this.hour, this.minute, this.second, this.millisecond);
        else return new ZonedDateTime(this.calendar, this.year, this.month, this.day, this.timeZone, this.offset, this.hour, this.minute, this.second, this.millisecond);
    }
    /** Returns a new `ZonedDateTime` with the given duration added to it. */ add(duration) {
        return (0, _manipulation.addZoned)(this, duration);
    }
    /** Returns a new `ZonedDateTime` with the given duration subtracted from it. */ subtract(duration) {
        return (0, _manipulation.subtractZoned)(this, duration);
    }
    /** Returns a new `ZonedDateTime` with the given fields set to the provided values. Other fields will be constrained accordingly. */ set(fields, disambiguation) {
        return (0, _manipulation.setZoned)(this, fields, disambiguation);
    }
    /**
   * Returns a new `ZonedDateTime` with the given field adjusted by a specified amount.
   * When the resulting value reaches the limits of the field, it wraps around.
   */ cycle(field, amount, options) {
        return (0, _manipulation.cycleZoned)(this, field, amount, options);
    }
    /** Converts the date to a native JavaScript Date object. */ toDate() {
        return (0, _conversion.zonedToDate)(this);
    }
    /** Converts the date to an ISO 8601 formatted string, including the UTC offset and time zone identifier. */ toString() {
        return (0, _string.zonedDateTimeToString)(this);
    }
    /** Converts the date to an ISO 8601 formatted string in UTC. */ toAbsoluteString() {
        return this.toDate().toISOString();
    }
    /** Compares this date with another. A negative result indicates that this date is before the given one, and a positive date indicates that it is after. */ compare(b) {
        // TODO: Is this a bad idea??
        return this.toDate().getTime() - (0, _conversion.toZoned)(b, this.timeZone).toDate().getTime();
    }
    constructor(...args){
        (0, _classPrivateFieldInit._)(this, _type3, {
            writable: true,
            value: void 0
        });
        let [calendar, era, year, month, day] = shiftArgs(args);
        let timeZone = args.shift();
        let offset = args.shift();
        this.calendar = calendar;
        this.era = era;
        this.year = year;
        this.month = month;
        this.day = day;
        this.timeZone = timeZone;
        this.offset = offset;
        this.hour = args.shift() || 0;
        this.minute = args.shift() || 0;
        this.second = args.shift() || 0;
        this.millisecond = args.shift() || 0;
        (0, _manipulation.constrain)(this);
    }
}

},{"@swc/helpers/_/_class_private_field_init":"cFHKQ","./manipulation":"g4AdZ","./queries":"gtZrq","./string":"4N0ez","./calendars/GregorianCalendar":"fE40j","./conversion":"gOiVm","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"g4AdZ":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "add", ()=>add);
parcelHelpers.export(exports, "constrain", ()=>constrain);
parcelHelpers.export(exports, "invertDuration", ()=>invertDuration);
parcelHelpers.export(exports, "subtract", ()=>subtract);
parcelHelpers.export(exports, "set", ()=>set);
parcelHelpers.export(exports, "setTime", ()=>setTime);
parcelHelpers.export(exports, "constrainTime", ()=>constrainTime);
parcelHelpers.export(exports, "addTime", ()=>addTime);
parcelHelpers.export(exports, "subtractTime", ()=>subtractTime);
parcelHelpers.export(exports, "cycleDate", ()=>cycleDate);
parcelHelpers.export(exports, "cycleTime", ()=>cycleTime);
parcelHelpers.export(exports, "addZoned", ()=>addZoned);
parcelHelpers.export(exports, "subtractZoned", ()=>subtractZoned);
parcelHelpers.export(exports, "cycleZoned", ()=>cycleZoned);
parcelHelpers.export(exports, "setZoned", ()=>setZoned);
var _conversion = require("./conversion");
var _gregorianCalendar = require("./calendars/GregorianCalendar");
const ONE_HOUR = 3600000;
function add(date, duration) {
    let mutableDate = date.copy();
    let days = "hour" in mutableDate ? addTimeFields(mutableDate, duration) : 0;
    addYears(mutableDate, duration.years || 0);
    if (mutableDate.calendar.balanceYearMonth) mutableDate.calendar.balanceYearMonth(mutableDate, date);
    mutableDate.month += duration.months || 0;
    balanceYearMonth(mutableDate);
    constrainMonthDay(mutableDate);
    mutableDate.day += (duration.weeks || 0) * 7;
    mutableDate.day += duration.days || 0;
    mutableDate.day += days;
    balanceDay(mutableDate);
    if (mutableDate.calendar.balanceDate) mutableDate.calendar.balanceDate(mutableDate);
    // Constrain in case adding ended up with a date outside the valid range for the calendar system.
    // The behavior here is slightly different than when constraining in the `set` function in that
    // we adjust smaller fields to their minimum/maximum values rather than constraining each field
    // individually. This matches the general behavior of `add` vs `set` regarding how fields are balanced.
    if (mutableDate.year < 1) {
        mutableDate.year = 1;
        mutableDate.month = 1;
        mutableDate.day = 1;
    }
    let maxYear = mutableDate.calendar.getYearsInEra(mutableDate);
    if (mutableDate.year > maxYear) {
        var _mutableDate_calendar_isInverseEra, _mutableDate_calendar;
        let isInverseEra = (_mutableDate_calendar_isInverseEra = (_mutableDate_calendar = mutableDate.calendar).isInverseEra) === null || _mutableDate_calendar_isInverseEra === void 0 ? void 0 : _mutableDate_calendar_isInverseEra.call(_mutableDate_calendar, mutableDate);
        mutableDate.year = maxYear;
        mutableDate.month = isInverseEra ? 1 : mutableDate.calendar.getMonthsInYear(mutableDate);
        mutableDate.day = isInverseEra ? 1 : mutableDate.calendar.getDaysInMonth(mutableDate);
    }
    if (mutableDate.month < 1) {
        mutableDate.month = 1;
        mutableDate.day = 1;
    }
    let maxMonth = mutableDate.calendar.getMonthsInYear(mutableDate);
    if (mutableDate.month > maxMonth) {
        mutableDate.month = maxMonth;
        mutableDate.day = mutableDate.calendar.getDaysInMonth(mutableDate);
    }
    mutableDate.day = Math.max(1, Math.min(mutableDate.calendar.getDaysInMonth(mutableDate), mutableDate.day));
    return mutableDate;
}
function addYears(date, years) {
    var _date_calendar_isInverseEra, _date_calendar;
    if ((_date_calendar_isInverseEra = (_date_calendar = date.calendar).isInverseEra) === null || _date_calendar_isInverseEra === void 0 ? void 0 : _date_calendar_isInverseEra.call(_date_calendar, date)) years = -years;
    date.year += years;
}
function balanceYearMonth(date) {
    while(date.month < 1){
        addYears(date, -1);
        date.month += date.calendar.getMonthsInYear(date);
    }
    let monthsInYear = 0;
    while(date.month > (monthsInYear = date.calendar.getMonthsInYear(date))){
        date.month -= monthsInYear;
        addYears(date, 1);
    }
}
function balanceDay(date) {
    while(date.day < 1){
        date.month--;
        balanceYearMonth(date);
        date.day += date.calendar.getDaysInMonth(date);
    }
    while(date.day > date.calendar.getDaysInMonth(date)){
        date.day -= date.calendar.getDaysInMonth(date);
        date.month++;
        balanceYearMonth(date);
    }
}
function constrainMonthDay(date) {
    date.month = Math.max(1, Math.min(date.calendar.getMonthsInYear(date), date.month));
    date.day = Math.max(1, Math.min(date.calendar.getDaysInMonth(date), date.day));
}
function constrain(date) {
    if (date.calendar.constrainDate) date.calendar.constrainDate(date);
    date.year = Math.max(1, Math.min(date.calendar.getYearsInEra(date), date.year));
    constrainMonthDay(date);
}
function invertDuration(duration) {
    let inverseDuration = {};
    for(let key in duration)if (typeof duration[key] === "number") inverseDuration[key] = -duration[key];
    return inverseDuration;
}
function subtract(date, duration) {
    return add(date, invertDuration(duration));
}
function set(date, fields) {
    let mutableDate = date.copy();
    if (fields.era != null) mutableDate.era = fields.era;
    if (fields.year != null) mutableDate.year = fields.year;
    if (fields.month != null) mutableDate.month = fields.month;
    if (fields.day != null) mutableDate.day = fields.day;
    constrain(mutableDate);
    return mutableDate;
}
function setTime(value, fields) {
    let mutableValue = value.copy();
    if (fields.hour != null) mutableValue.hour = fields.hour;
    if (fields.minute != null) mutableValue.minute = fields.minute;
    if (fields.second != null) mutableValue.second = fields.second;
    if (fields.millisecond != null) mutableValue.millisecond = fields.millisecond;
    constrainTime(mutableValue);
    return mutableValue;
}
function balanceTime(time) {
    time.second += Math.floor(time.millisecond / 1000);
    time.millisecond = nonNegativeMod(time.millisecond, 1000);
    time.minute += Math.floor(time.second / 60);
    time.second = nonNegativeMod(time.second, 60);
    time.hour += Math.floor(time.minute / 60);
    time.minute = nonNegativeMod(time.minute, 60);
    let days = Math.floor(time.hour / 24);
    time.hour = nonNegativeMod(time.hour, 24);
    return days;
}
function constrainTime(time) {
    time.millisecond = Math.max(0, Math.min(time.millisecond, 1000));
    time.second = Math.max(0, Math.min(time.second, 59));
    time.minute = Math.max(0, Math.min(time.minute, 59));
    time.hour = Math.max(0, Math.min(time.hour, 23));
}
function nonNegativeMod(a, b) {
    let result = a % b;
    if (result < 0) result += b;
    return result;
}
function addTimeFields(time, duration) {
    time.hour += duration.hours || 0;
    time.minute += duration.minutes || 0;
    time.second += duration.seconds || 0;
    time.millisecond += duration.milliseconds || 0;
    return balanceTime(time);
}
function addTime(time, duration) {
    let res = time.copy();
    addTimeFields(res, duration);
    return res;
}
function subtractTime(time, duration) {
    return addTime(time, invertDuration(duration));
}
function cycleDate(value, field, amount, options) {
    let mutable = value.copy();
    switch(field){
        case "era":
            {
                let eras = value.calendar.getEras();
                let eraIndex = eras.indexOf(value.era);
                if (eraIndex < 0) throw new Error("Invalid era: " + value.era);
                eraIndex = cycleValue(eraIndex, amount, 0, eras.length - 1, options === null || options === void 0 ? void 0 : options.round);
                mutable.era = eras[eraIndex];
                // Constrain the year and other fields within the era, so the era doesn't change when we balance below.
                constrain(mutable);
                break;
            }
        case "year":
            var _mutable_calendar_isInverseEra, _mutable_calendar;
            if ((_mutable_calendar_isInverseEra = (_mutable_calendar = mutable.calendar).isInverseEra) === null || _mutable_calendar_isInverseEra === void 0 ? void 0 : _mutable_calendar_isInverseEra.call(_mutable_calendar, mutable)) amount = -amount;
            // The year field should not cycle within the era as that can cause weird behavior affecting other fields.
            // We need to also allow values < 1 so that decrementing goes to the previous era. If we get -Infinity back
            // we know we wrapped around after reaching 9999 (the maximum), so set the year back to 1.
            mutable.year = cycleValue(value.year, amount, -Infinity, 9999, options === null || options === void 0 ? void 0 : options.round);
            if (mutable.year === -Infinity) mutable.year = 1;
            if (mutable.calendar.balanceYearMonth) mutable.calendar.balanceYearMonth(mutable, value);
            break;
        case "month":
            mutable.month = cycleValue(value.month, amount, 1, value.calendar.getMonthsInYear(value), options === null || options === void 0 ? void 0 : options.round);
            break;
        case "day":
            mutable.day = cycleValue(value.day, amount, 1, value.calendar.getDaysInMonth(value), options === null || options === void 0 ? void 0 : options.round);
            break;
        default:
            throw new Error("Unsupported field " + field);
    }
    if (value.calendar.balanceDate) value.calendar.balanceDate(mutable);
    constrain(mutable);
    return mutable;
}
function cycleTime(value, field, amount, options) {
    let mutable = value.copy();
    switch(field){
        case "hour":
            {
                let hours = value.hour;
                let min = 0;
                let max = 23;
                if ((options === null || options === void 0 ? void 0 : options.hourCycle) === 12) {
                    let isPM = hours >= 12;
                    min = isPM ? 12 : 0;
                    max = isPM ? 23 : 11;
                }
                mutable.hour = cycleValue(hours, amount, min, max, options === null || options === void 0 ? void 0 : options.round);
                break;
            }
        case "minute":
            mutable.minute = cycleValue(value.minute, amount, 0, 59, options === null || options === void 0 ? void 0 : options.round);
            break;
        case "second":
            mutable.second = cycleValue(value.second, amount, 0, 59, options === null || options === void 0 ? void 0 : options.round);
            break;
        case "millisecond":
            mutable.millisecond = cycleValue(value.millisecond, amount, 0, 999, options === null || options === void 0 ? void 0 : options.round);
            break;
        default:
            throw new Error("Unsupported field " + field);
    }
    return mutable;
}
function cycleValue(value, amount, min, max, round = false) {
    if (round) {
        value += Math.sign(amount);
        if (value < min) value = max;
        let div = Math.abs(amount);
        if (amount > 0) value = Math.ceil(value / div) * div;
        else value = Math.floor(value / div) * div;
        if (value > max) value = min;
    } else {
        value += amount;
        if (value < min) value = max - (min - value - 1);
        else if (value > max) value = min + (value - max - 1);
    }
    return value;
}
function addZoned(dateTime, duration) {
    let ms;
    if (duration.years != null && duration.years !== 0 || duration.months != null && duration.months !== 0 || duration.weeks != null && duration.weeks !== 0 || duration.days != null && duration.days !== 0) {
        let res = add((0, _conversion.toCalendarDateTime)(dateTime), {
            years: duration.years,
            months: duration.months,
            weeks: duration.weeks,
            days: duration.days
        });
        // Changing the date may change the timezone offset, so we need to recompute
        // using the 'compatible' disambiguation.
        ms = (0, _conversion.toAbsolute)(res, dateTime.timeZone);
    } else // Otherwise, preserve the offset of the original date.
    ms = (0, _conversion.epochFromDate)(dateTime) - dateTime.offset;
    // Perform time manipulation in milliseconds rather than on the original time fields to account for DST.
    // For example, adding one hour during a DST transition may result in the hour field staying the same or
    // skipping an hour. This results in the offset field changing value instead of the specified field.
    ms += duration.milliseconds || 0;
    ms += (duration.seconds || 0) * 1000;
    ms += (duration.minutes || 0) * 60000;
    ms += (duration.hours || 0) * 3600000;
    let res = (0, _conversion.fromAbsolute)(ms, dateTime.timeZone);
    return (0, _conversion.toCalendar)(res, dateTime.calendar);
}
function subtractZoned(dateTime, duration) {
    return addZoned(dateTime, invertDuration(duration));
}
function cycleZoned(dateTime, field, amount, options) {
    // For date fields, we want the time to remain consistent and the UTC offset to potentially change to account for DST changes.
    // For time fields, we want the time to change by the amount given. This may result in the hour field staying the same, but the UTC
    // offset changing in the case of a backward DST transition, or skipping an hour in the case of a forward DST transition.
    switch(field){
        case "hour":
            {
                let min = 0;
                let max = 23;
                if ((options === null || options === void 0 ? void 0 : options.hourCycle) === 12) {
                    let isPM = dateTime.hour >= 12;
                    min = isPM ? 12 : 0;
                    max = isPM ? 23 : 11;
                }
                // The minimum and maximum hour may be affected by daylight saving time.
                // For example, it might jump forward at midnight, and skip 1am.
                // Or it might end at midnight and repeat the 11pm hour. To handle this, we get
                // the possible absolute times for the min and max, and find the maximum range
                // that is within the current day.
                let plainDateTime = (0, _conversion.toCalendarDateTime)(dateTime);
                let minDate = (0, _conversion.toCalendar)(setTime(plainDateTime, {
                    hour: min
                }), new (0, _gregorianCalendar.GregorianCalendar)());
                let minAbsolute = [
                    (0, _conversion.toAbsolute)(minDate, dateTime.timeZone, "earlier"),
                    (0, _conversion.toAbsolute)(minDate, dateTime.timeZone, "later")
                ].filter((ms)=>(0, _conversion.fromAbsolute)(ms, dateTime.timeZone).day === minDate.day)[0];
                let maxDate = (0, _conversion.toCalendar)(setTime(plainDateTime, {
                    hour: max
                }), new (0, _gregorianCalendar.GregorianCalendar)());
                let maxAbsolute = [
                    (0, _conversion.toAbsolute)(maxDate, dateTime.timeZone, "earlier"),
                    (0, _conversion.toAbsolute)(maxDate, dateTime.timeZone, "later")
                ].filter((ms)=>(0, _conversion.fromAbsolute)(ms, dateTime.timeZone).day === maxDate.day).pop();
                // Since hours may repeat, we need to operate on the absolute time in milliseconds.
                // This is done in hours from the Unix epoch so that cycleValue works correctly,
                // and then converted back to milliseconds.
                let ms = (0, _conversion.epochFromDate)(dateTime) - dateTime.offset;
                let hours = Math.floor(ms / ONE_HOUR);
                let remainder = ms % ONE_HOUR;
                ms = cycleValue(hours, amount, Math.floor(minAbsolute / ONE_HOUR), Math.floor(maxAbsolute / ONE_HOUR), options === null || options === void 0 ? void 0 : options.round) * ONE_HOUR + remainder;
                // Now compute the new timezone offset, and convert the absolute time back to local time.
                return (0, _conversion.toCalendar)((0, _conversion.fromAbsolute)(ms, dateTime.timeZone), dateTime.calendar);
            }
        case "minute":
        case "second":
        case "millisecond":
            // @ts-ignore
            return cycleTime(dateTime, field, amount, options);
        case "era":
        case "year":
        case "month":
        case "day":
            {
                let res = cycleDate((0, _conversion.toCalendarDateTime)(dateTime), field, amount, options);
                let ms = (0, _conversion.toAbsolute)(res, dateTime.timeZone);
                return (0, _conversion.toCalendar)((0, _conversion.fromAbsolute)(ms, dateTime.timeZone), dateTime.calendar);
            }
        default:
            throw new Error("Unsupported field " + field);
    }
}
function setZoned(dateTime, fields, disambiguation) {
    // Set the date/time fields, and recompute the UTC offset to account for DST changes.
    // We also need to validate by converting back to a local time in case hours are skipped during forward DST transitions.
    let plainDateTime = (0, _conversion.toCalendarDateTime)(dateTime);
    let res = setTime(set(plainDateTime, fields), fields);
    // If the resulting plain date time values are equal, return the original time.
    // We don't want to change the offset when setting the time to the same value.
    if (res.compare(plainDateTime) === 0) return dateTime;
    let ms = (0, _conversion.toAbsolute)(res, dateTime.timeZone, disambiguation);
    return (0, _conversion.toCalendar)((0, _conversion.fromAbsolute)(ms, dateTime.timeZone), dateTime.calendar);
}

},{"./conversion":"gOiVm","./calendars/GregorianCalendar":"fE40j","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"gOiVm":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from the TC39 Temporal proposal.
// Original licensing can be found in the NOTICE file in the root directory of this source tree.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "epochFromDate", ()=>epochFromDate);
parcelHelpers.export(exports, "getTimeZoneOffset", ()=>getTimeZoneOffset);
parcelHelpers.export(exports, "possibleAbsolutes", ()=>possibleAbsolutes);
parcelHelpers.export(exports, "toAbsolute", ()=>toAbsolute);
parcelHelpers.export(exports, "toDate", ()=>toDate);
/**
 * Takes a Unix epoch (milliseconds since 1970) and converts it to the provided time zone.
 */ parcelHelpers.export(exports, "fromAbsolute", ()=>fromAbsolute);
/**
 * Takes a `Date` object and converts it to the provided time zone.
 */ parcelHelpers.export(exports, "fromDate", ()=>fromDate);
parcelHelpers.export(exports, "fromDateToLocal", ()=>fromDateToLocal);
/** Converts a value with date components such as a `CalendarDateTime` or `ZonedDateTime` into a `CalendarDate`. */ parcelHelpers.export(exports, "toCalendarDate", ()=>toCalendarDate);
parcelHelpers.export(exports, "toDateFields", ()=>toDateFields);
parcelHelpers.export(exports, "toTimeFields", ()=>toTimeFields);
/**
 * Converts a date value to a `CalendarDateTime`. An optional `Time` value can be passed to set the time
 * of the resulting value, otherwise it will default to midnight.
 */ parcelHelpers.export(exports, "toCalendarDateTime", ()=>toCalendarDateTime);
/** Extracts the time components from a value containing a date and time. */ parcelHelpers.export(exports, "toTime", ()=>toTime);
/** Converts a date from one calendar system to another. */ parcelHelpers.export(exports, "toCalendar", ()=>toCalendar);
/**
 * Converts a date value to a `ZonedDateTime` in the provided time zone. The `disambiguation` option can be set
 * to control how values that fall on daylight saving time changes are interpreted.
 */ parcelHelpers.export(exports, "toZoned", ()=>toZoned);
parcelHelpers.export(exports, "zonedToDate", ()=>zonedToDate);
/** Converts a `ZonedDateTime` from one time zone to another. */ parcelHelpers.export(exports, "toTimeZone", ()=>toTimeZone);
/** Converts the given `ZonedDateTime` into the user's local time zone. */ parcelHelpers.export(exports, "toLocalTimeZone", ()=>toLocalTimeZone);
var _calendarDate = require("./CalendarDate");
var _manipulation = require("./manipulation");
var _gregorianCalendar = require("./calendars/GregorianCalendar");
var _queries = require("./queries");
function epochFromDate(date) {
    date = toCalendar(date, new (0, _gregorianCalendar.GregorianCalendar)());
    let year = (0, _gregorianCalendar.getExtendedYear)(date.era, date.year);
    return epochFromParts(year, date.month, date.day, date.hour, date.minute, date.second, date.millisecond);
}
function epochFromParts(year, month, day, hour, minute, second, millisecond) {
    // Note: Date.UTC() interprets one and two-digit years as being in the
    // 20th century, so don't use it
    let date = new Date();
    date.setUTCHours(hour, minute, second, millisecond);
    date.setUTCFullYear(year, month - 1, day);
    return date.getTime();
}
function getTimeZoneOffset(ms, timeZone) {
    // Fast path for UTC.
    if (timeZone === "UTC") return 0;
    // Fast path: for local timezone after 1970, use native Date.
    if (ms > 0 && timeZone === (0, _queries.getLocalTimeZone)()) return new Date(ms).getTimezoneOffset() * -60000;
    let { year, month, day, hour, minute, second } = getTimeZoneParts(ms, timeZone);
    let utc = epochFromParts(year, month, day, hour, minute, second, 0);
    return utc - Math.floor(ms / 1000) * 1000;
}
const formattersByTimeZone = new Map();
function getTimeZoneParts(ms, timeZone) {
    let formatter = formattersByTimeZone.get(timeZone);
    if (!formatter) {
        formatter = new Intl.DateTimeFormat("en-US", {
            timeZone,
            hour12: false,
            era: "short",
            year: "numeric",
            month: "numeric",
            day: "numeric",
            hour: "numeric",
            minute: "numeric",
            second: "numeric"
        });
        formattersByTimeZone.set(timeZone, formatter);
    }
    let parts = formatter.formatToParts(new Date(ms));
    let namedParts = {};
    for (let part of parts)if (part.type !== "literal") namedParts[part.type] = part.value;
    return {
        // Firefox returns B instead of BC... https://bugzilla.mozilla.org/show_bug.cgi?id=1752253
        year: namedParts.era === "BC" || namedParts.era === "B" ? -namedParts.year + 1 : +namedParts.year,
        month: +namedParts.month,
        day: +namedParts.day,
        hour: namedParts.hour === "24" ? 0 : +namedParts.hour,
        minute: +namedParts.minute,
        second: +namedParts.second
    };
}
const DAYMILLIS = 86400000;
function possibleAbsolutes(date, timeZone) {
    let ms = epochFromDate(date);
    let earlier = ms - getTimeZoneOffset(ms - DAYMILLIS, timeZone);
    let later = ms - getTimeZoneOffset(ms + DAYMILLIS, timeZone);
    return getValidWallTimes(date, timeZone, earlier, later);
}
function getValidWallTimes(date, timeZone, earlier, later) {
    let found = earlier === later ? [
        earlier
    ] : [
        earlier,
        later
    ];
    return found.filter((absolute)=>isValidWallTime(date, timeZone, absolute));
}
function isValidWallTime(date, timeZone, absolute) {
    let parts = getTimeZoneParts(absolute, timeZone);
    return date.year === parts.year && date.month === parts.month && date.day === parts.day && date.hour === parts.hour && date.minute === parts.minute && date.second === parts.second;
}
function toAbsolute(date, timeZone, disambiguation = "compatible") {
    let dateTime = toCalendarDateTime(date);
    // Fast path: if the time zone is UTC, use native Date.
    if (timeZone === "UTC") return epochFromDate(dateTime);
    // Fast path: if the time zone is the local timezone and disambiguation is compatible, use native Date.
    if (timeZone === (0, _queries.getLocalTimeZone)() && disambiguation === "compatible") {
        dateTime = toCalendar(dateTime, new (0, _gregorianCalendar.GregorianCalendar)());
        // Don't use Date constructor here because two-digit years are interpreted in the 20th century.
        let date = new Date();
        let year = (0, _gregorianCalendar.getExtendedYear)(dateTime.era, dateTime.year);
        date.setFullYear(year, dateTime.month - 1, dateTime.day);
        date.setHours(dateTime.hour, dateTime.minute, dateTime.second, dateTime.millisecond);
        return date.getTime();
    }
    let ms = epochFromDate(dateTime);
    let offsetBefore = getTimeZoneOffset(ms - DAYMILLIS, timeZone);
    let offsetAfter = getTimeZoneOffset(ms + DAYMILLIS, timeZone);
    let valid = getValidWallTimes(dateTime, timeZone, ms - offsetBefore, ms - offsetAfter);
    if (valid.length === 1) return valid[0];
    if (valid.length > 1) switch(disambiguation){
        // 'compatible' means 'earlier' for "fall back" transitions
        case "compatible":
        case "earlier":
            return valid[0];
        case "later":
            return valid[valid.length - 1];
        case "reject":
            throw new RangeError("Multiple possible absolute times found");
    }
    switch(disambiguation){
        case "earlier":
            return Math.min(ms - offsetBefore, ms - offsetAfter);
        // 'compatible' means 'later' for "spring forward" transitions
        case "compatible":
        case "later":
            return Math.max(ms - offsetBefore, ms - offsetAfter);
        case "reject":
            throw new RangeError("No such absolute time found");
    }
}
function toDate(dateTime, timeZone, disambiguation = "compatible") {
    return new Date(toAbsolute(dateTime, timeZone, disambiguation));
}
function fromAbsolute(ms, timeZone) {
    let offset = getTimeZoneOffset(ms, timeZone);
    let date = new Date(ms + offset);
    let year = date.getUTCFullYear();
    let month = date.getUTCMonth() + 1;
    let day = date.getUTCDate();
    let hour = date.getUTCHours();
    let minute = date.getUTCMinutes();
    let second = date.getUTCSeconds();
    let millisecond = date.getUTCMilliseconds();
    return new (0, _calendarDate.ZonedDateTime)(year, month, day, timeZone, offset, hour, minute, second, millisecond);
}
function fromDate(date, timeZone) {
    return fromAbsolute(date.getTime(), timeZone);
}
function fromDateToLocal(date) {
    return fromDate(date, (0, _queries.getLocalTimeZone)());
}
function toCalendarDate(dateTime) {
    return new (0, _calendarDate.CalendarDate)(dateTime.calendar, dateTime.era, dateTime.year, dateTime.month, dateTime.day);
}
function toDateFields(date) {
    return {
        era: date.era,
        year: date.year,
        month: date.month,
        day: date.day
    };
}
function toTimeFields(date) {
    return {
        hour: date.hour,
        minute: date.minute,
        second: date.second,
        millisecond: date.millisecond
    };
}
function toCalendarDateTime(date, time) {
    let hour = 0, minute = 0, second = 0, millisecond = 0;
    if ("timeZone" in date) ({ hour, minute, second, millisecond } = date);
    else if ("hour" in date && !time) return date;
    if (time) ({ hour, minute, second, millisecond } = time);
    return new (0, _calendarDate.CalendarDateTime)(date.calendar, date.era, date.year, date.month, date.day, hour, minute, second, millisecond);
}
function toTime(dateTime) {
    return new (0, _calendarDate.Time)(dateTime.hour, dateTime.minute, dateTime.second, dateTime.millisecond);
}
function toCalendar(date, calendar) {
    if (date.calendar.identifier === calendar.identifier) return date;
    let calendarDate = calendar.fromJulianDay(date.calendar.toJulianDay(date));
    let copy = date.copy();
    copy.calendar = calendar;
    copy.era = calendarDate.era;
    copy.year = calendarDate.year;
    copy.month = calendarDate.month;
    copy.day = calendarDate.day;
    (0, _manipulation.constrain)(copy);
    return copy;
}
function toZoned(date, timeZone, disambiguation) {
    if (date instanceof (0, _calendarDate.ZonedDateTime)) {
        if (date.timeZone === timeZone) return date;
        return toTimeZone(date, timeZone);
    }
    let ms = toAbsolute(date, timeZone, disambiguation);
    return fromAbsolute(ms, timeZone);
}
function zonedToDate(date) {
    let ms = epochFromDate(date) - date.offset;
    return new Date(ms);
}
function toTimeZone(date, timeZone) {
    let ms = epochFromDate(date) - date.offset;
    return toCalendar(fromAbsolute(ms, timeZone), date.calendar);
}
function toLocalTimeZone(date) {
    return toTimeZone(date, (0, _queries.getLocalTimeZone)());
}

},{"./CalendarDate":"jcaEo","./manipulation":"g4AdZ","./calendars/GregorianCalendar":"fE40j","./queries":"gtZrq","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"fE40j":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from ICU.
// Original licensing can be found in the NOTICE file in the root directory of this source tree.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "gregorianToJulianDay", ()=>gregorianToJulianDay);
parcelHelpers.export(exports, "isLeapYear", ()=>isLeapYear);
parcelHelpers.export(exports, "getExtendedYear", ()=>getExtendedYear);
parcelHelpers.export(exports, "fromExtendedYear", ()=>fromExtendedYear);
/**
 * The Gregorian calendar is the most commonly used calendar system in the world. It supports two eras: BC, and AD.
 * Years always contain 12 months, and 365 or 366 days depending on whether it is a leap year.
 */ parcelHelpers.export(exports, "GregorianCalendar", ()=>GregorianCalendar);
var _calendarDate = require("../CalendarDate");
var _utils = require("../utils");
const EPOCH = 1721426; // 001/01/03 Julian C.E.
function gregorianToJulianDay(era, year, month, day) {
    year = getExtendedYear(era, year);
    let y1 = year - 1;
    let monthOffset = -2;
    if (month <= 2) monthOffset = 0;
    else if (isLeapYear(year)) monthOffset = -1;
    return EPOCH - 1 + 365 * y1 + Math.floor(y1 / 4) - Math.floor(y1 / 100) + Math.floor(y1 / 400) + Math.floor((367 * month - 362) / 12 + monthOffset + day);
}
function isLeapYear(year) {
    return year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
}
function getExtendedYear(era, year) {
    return era === "BC" ? 1 - year : year;
}
function fromExtendedYear(year) {
    let era = "AD";
    if (year <= 0) {
        era = "BC";
        year = 1 - year;
    }
    return [
        era,
        year
    ];
}
const daysInMonth = {
    standard: [
        31,
        28,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31
    ],
    leapyear: [
        31,
        29,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31
    ]
};
class GregorianCalendar {
    fromJulianDay(jd) {
        let jd0 = jd;
        let depoch = jd0 - EPOCH;
        let quadricent = Math.floor(depoch / 146097);
        let dqc = (0, _utils.mod)(depoch, 146097);
        let cent = Math.floor(dqc / 36524);
        let dcent = (0, _utils.mod)(dqc, 36524);
        let quad = Math.floor(dcent / 1461);
        let dquad = (0, _utils.mod)(dcent, 1461);
        let yindex = Math.floor(dquad / 365);
        let extendedYear = quadricent * 400 + cent * 100 + quad * 4 + yindex + (cent !== 4 && yindex !== 4 ? 1 : 0);
        let [era, year] = fromExtendedYear(extendedYear);
        let yearDay = jd0 - gregorianToJulianDay(era, year, 1, 1);
        let leapAdj = 2;
        if (jd0 < gregorianToJulianDay(era, year, 3, 1)) leapAdj = 0;
        else if (isLeapYear(year)) leapAdj = 1;
        let month = Math.floor(((yearDay + leapAdj) * 12 + 373) / 367);
        let day = jd0 - gregorianToJulianDay(era, year, month, 1) + 1;
        return new (0, _calendarDate.CalendarDate)(era, year, month, day);
    }
    toJulianDay(date) {
        return gregorianToJulianDay(date.era, date.year, date.month, date.day);
    }
    getDaysInMonth(date) {
        return daysInMonth[isLeapYear(date.year) ? "leapyear" : "standard"][date.month - 1];
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    getMonthsInYear(date) {
        return 12;
    }
    getDaysInYear(date) {
        return isLeapYear(date.year) ? 366 : 365;
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    getYearsInEra(date) {
        return 9999;
    }
    getEras() {
        return [
            "BC",
            "AD"
        ];
    }
    isInverseEra(date) {
        return date.era === "BC";
    }
    balanceDate(date) {
        if (date.year <= 0) {
            date.era = date.era === "BC" ? "AD" : "BC";
            date.year = 1 - date.year;
        }
    }
    constructor(){
        this.identifier = "gregory";
    }
}

},{"../CalendarDate":"jcaEo","../utils":"4L3yE","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"4L3yE":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mod", ()=>mod);
parcelHelpers.export(exports, "copy", ()=>copy);
parcelHelpers.export(exports, "copyDateTime", ()=>copyDateTime);
var _calendarDate = require("./CalendarDate");
function mod(amount, numerator) {
    return amount - numerator * Math.floor(amount / numerator);
}
function copy(date) {
    if (date.era) return new (0, _calendarDate.CalendarDate)(date.calendar, date.era, date.year, date.month, date.day);
    else return new (0, _calendarDate.CalendarDate)(date.calendar, date.year, date.month, date.day);
}
function copyDateTime(date) {
    if (date.era) return new (0, _calendarDate.CalendarDateTime)(date.calendar, date.era, date.year, date.month, date.day, date.hour, date.minute, date.second, date.millisecond);
    else return new (0, _calendarDate.CalendarDateTime)(date.calendar, date.year, date.month, date.day, date.hour, date.minute, date.second);
}

},{"./CalendarDate":"jcaEo","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"gtZrq":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/** Returns whether the given dates occur on the same day, regardless of the time or calendar system. */ parcelHelpers.export(exports, "isSameDay", ()=>isSameDay);
/** Returns whether the given dates occur in the same month, using the calendar system of the first date. */ parcelHelpers.export(exports, "isSameMonth", ()=>isSameMonth);
/** Returns whether the given dates occur in the same year, using the calendar system of the first date. */ parcelHelpers.export(exports, "isSameYear", ()=>isSameYear);
/** Returns whether the given dates occur on the same day, and are of the same calendar system. */ parcelHelpers.export(exports, "isEqualDay", ()=>isEqualDay);
/** Returns whether the given dates occur in the same month, and are of the same calendar system. */ parcelHelpers.export(exports, "isEqualMonth", ()=>isEqualMonth);
/** Returns whether the given dates occur in the same year, and are of the same calendar system. */ parcelHelpers.export(exports, "isEqualYear", ()=>isEqualYear);
/** Returns whether the date is today in the given time zone. */ parcelHelpers.export(exports, "isToday", ()=>isToday);
/**
 * Returns the day of week for the given date and locale. Days are numbered from zero to six,
 * where zero is the first day of the week in the given locale. For example, in the United States,
 * the first day of the week is Sunday, but in France it is Monday.
 */ parcelHelpers.export(exports, "getDayOfWeek", ()=>getDayOfWeek);
/** Returns the current time in the given time zone. */ parcelHelpers.export(exports, "now", ()=>now);
/** Returns today's date in the given time zone. */ parcelHelpers.export(exports, "today", ()=>today);
parcelHelpers.export(exports, "compareDate", ()=>compareDate);
parcelHelpers.export(exports, "compareTime", ()=>compareTime);
/**
 * Returns the number of hours in the given date and time zone.
 * Usually this is 24, but it could be 23 or 25 if the date is on a daylight saving transition.
 */ parcelHelpers.export(exports, "getHoursInDay", ()=>getHoursInDay);
/** Returns the time zone identifier for the current user. */ parcelHelpers.export(exports, "getLocalTimeZone", ()=>getLocalTimeZone);
parcelHelpers.export(exports, "startOfMonth", ()=>startOfMonth);
parcelHelpers.export(exports, "endOfMonth", ()=>endOfMonth);
parcelHelpers.export(exports, "startOfYear", ()=>startOfYear);
parcelHelpers.export(exports, "endOfYear", ()=>endOfYear);
parcelHelpers.export(exports, "getMinimumMonthInYear", ()=>getMinimumMonthInYear);
parcelHelpers.export(exports, "getMinimumDayInMonth", ()=>getMinimumDayInMonth);
parcelHelpers.export(exports, "startOfWeek", ()=>startOfWeek);
parcelHelpers.export(exports, "endOfWeek", ()=>endOfWeek);
/** Returns the number of weeks in the given month and locale. */ parcelHelpers.export(exports, "getWeeksInMonth", ()=>getWeeksInMonth);
/** Returns the lesser of the two provider dates. */ parcelHelpers.export(exports, "minDate", ()=>minDate);
/** Returns the greater of the two provider dates. */ parcelHelpers.export(exports, "maxDate", ()=>maxDate);
/** Returns whether the given date is on a weekend in the given locale. */ parcelHelpers.export(exports, "isWeekend", ()=>isWeekend);
/** Returns whether the given date is on a weekday in the given locale. */ parcelHelpers.export(exports, "isWeekday", ()=>isWeekday);
var _conversion = require("./conversion");
var _weekStartData = require("./weekStartData");
function isSameDay(a, b) {
    b = (0, _conversion.toCalendar)(b, a.calendar);
    return a.era === b.era && a.year === b.year && a.month === b.month && a.day === b.day;
}
function isSameMonth(a, b) {
    b = (0, _conversion.toCalendar)(b, a.calendar);
    // In the Japanese calendar, months can span multiple eras/years, so only compare the first of the month.
    a = startOfMonth(a);
    b = startOfMonth(b);
    return a.era === b.era && a.year === b.year && a.month === b.month;
}
function isSameYear(a, b) {
    b = (0, _conversion.toCalendar)(b, a.calendar);
    a = startOfYear(a);
    b = startOfYear(b);
    return a.era === b.era && a.year === b.year;
}
function isEqualDay(a, b) {
    return a.calendar.identifier === b.calendar.identifier && a.era === b.era && a.year === b.year && a.month === b.month && a.day === b.day;
}
function isEqualMonth(a, b) {
    a = startOfMonth(a);
    b = startOfMonth(b);
    return a.calendar.identifier === b.calendar.identifier && a.era === b.era && a.year === b.year && a.month === b.month;
}
function isEqualYear(a, b) {
    a = startOfYear(a);
    b = startOfYear(b);
    return a.calendar.identifier === b.calendar.identifier && a.era === b.era && a.year === b.year;
}
function isToday(date, timeZone) {
    return isSameDay(date, today(timeZone));
}
function getDayOfWeek(date, locale) {
    let julian = date.calendar.toJulianDay(date);
    // If julian is negative, then julian % 7 will be negative, so we adjust
    // accordingly.  Julian day 0 is Monday.
    let dayOfWeek = Math.ceil(julian + 1 - getWeekStart(locale)) % 7;
    if (dayOfWeek < 0) dayOfWeek += 7;
    return dayOfWeek;
}
function now(timeZone) {
    return (0, _conversion.fromAbsolute)(Date.now(), timeZone);
}
function today(timeZone) {
    return (0, _conversion.toCalendarDate)(now(timeZone));
}
function compareDate(a, b) {
    return a.calendar.toJulianDay(a) - b.calendar.toJulianDay(b);
}
function compareTime(a, b) {
    return timeToMs(a) - timeToMs(b);
}
function timeToMs(a) {
    return a.hour * 3600000 + a.minute * 60000 + a.second * 1000 + a.millisecond;
}
function getHoursInDay(a, timeZone) {
    let ms = (0, _conversion.toAbsolute)(a, timeZone);
    let tomorrow = a.add({
        days: 1
    });
    let tomorrowMs = (0, _conversion.toAbsolute)(tomorrow, timeZone);
    return (tomorrowMs - ms) / 3600000;
}
let localTimeZone = null;
function getLocalTimeZone() {
    // TODO: invalidate this somehow?
    if (localTimeZone == null) localTimeZone = new Intl.DateTimeFormat().resolvedOptions().timeZone;
    return localTimeZone;
}
function startOfMonth(date) {
    // Use `subtract` instead of `set` so we don't get constrained in an era.
    return date.subtract({
        days: date.day - 1
    });
}
function endOfMonth(date) {
    return date.add({
        days: date.calendar.getDaysInMonth(date) - date.day
    });
}
function startOfYear(date) {
    return startOfMonth(date.subtract({
        months: date.month - 1
    }));
}
function endOfYear(date) {
    return endOfMonth(date.add({
        months: date.calendar.getMonthsInYear(date) - date.month
    }));
}
function getMinimumMonthInYear(date) {
    if (date.calendar.getMinimumMonthInYear) return date.calendar.getMinimumMonthInYear(date);
    return 1;
}
function getMinimumDayInMonth(date) {
    if (date.calendar.getMinimumDayInMonth) return date.calendar.getMinimumDayInMonth(date);
    return 1;
}
function startOfWeek(date, locale) {
    let dayOfWeek = getDayOfWeek(date, locale);
    return date.subtract({
        days: dayOfWeek
    });
}
function endOfWeek(date, locale) {
    return startOfWeek(date, locale).add({
        days: 6
    });
}
const cachedRegions = new Map();
function getRegion(locale) {
    // If the Intl.Locale API is available, use it to get the region for the locale.
    // @ts-ignore
    if (Intl.Locale) {
        // Constructing an Intl.Locale is expensive, so cache the result.
        let region = cachedRegions.get(locale);
        if (!region) {
            // @ts-ignore
            region = new Intl.Locale(locale).maximize().region;
            if (region) cachedRegions.set(locale, region);
        }
        return region;
    }
    // If not, just try splitting the string.
    // If the second part of the locale string is 'u',
    // then this is a unicode extension, so ignore it.
    // Otherwise, it should be the region.
    let part = locale.split("-")[1];
    return part === "u" ? undefined : part;
}
function getWeekStart(locale) {
    // TODO: use Intl.Locale for this once browsers support the weekInfo property
    // https://github.com/tc39/proposal-intl-locale-info
    let region = getRegion(locale);
    return region ? (0, _weekStartData.weekStartData)[region] || 0 : 0;
}
function getWeeksInMonth(date, locale) {
    let days = date.calendar.getDaysInMonth(date);
    return Math.ceil((getDayOfWeek(startOfMonth(date), locale) + days) / 7);
}
function minDate(a, b) {
    if (a && b) return a.compare(b) <= 0 ? a : b;
    return a || b;
}
function maxDate(a, b) {
    if (a && b) return a.compare(b) >= 0 ? a : b;
    return a || b;
}
const WEEKEND_DATA = {
    AF: [
        4,
        5
    ],
    AE: [
        5,
        6
    ],
    BH: [
        5,
        6
    ],
    DZ: [
        5,
        6
    ],
    EG: [
        5,
        6
    ],
    IL: [
        5,
        6
    ],
    IQ: [
        5,
        6
    ],
    IR: [
        5,
        5
    ],
    JO: [
        5,
        6
    ],
    KW: [
        5,
        6
    ],
    LY: [
        5,
        6
    ],
    OM: [
        5,
        6
    ],
    QA: [
        5,
        6
    ],
    SA: [
        5,
        6
    ],
    SD: [
        5,
        6
    ],
    SY: [
        5,
        6
    ],
    YE: [
        5,
        6
    ]
};
function isWeekend(date, locale) {
    let julian = date.calendar.toJulianDay(date);
    // If julian is negative, then julian % 7 will be negative, so we adjust
    // accordingly.  Julian day 0 is Monday.
    let dayOfWeek = Math.ceil(julian + 1) % 7;
    if (dayOfWeek < 0) dayOfWeek += 7;
    let region = getRegion(locale);
    // Use Intl.Locale for this once weekInfo is supported.
    // https://github.com/tc39/proposal-intl-locale-info
    let [start, end] = WEEKEND_DATA[region] || [
        6,
        0
    ];
    return dayOfWeek === start || dayOfWeek === end;
}
function isWeekday(date, locale) {
    return !isWeekend(date, locale);
}

},{"./conversion":"gOiVm","./weekStartData":"ijtNQ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"ijtNQ":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Data from https://github.com/unicode-cldr/cldr-core/blob/master/supplemental/weekData.json
// Locales starting on Sunday have been removed for compression.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "weekStartData", ()=>weekStartData);
const weekStartData = {
    "001": 1,
    AD: 1,
    AE: 6,
    AF: 6,
    AI: 1,
    AL: 1,
    AM: 1,
    AN: 1,
    AR: 1,
    AT: 1,
    AU: 1,
    AX: 1,
    AZ: 1,
    BA: 1,
    BE: 1,
    BG: 1,
    BH: 6,
    BM: 1,
    BN: 1,
    BY: 1,
    CH: 1,
    CL: 1,
    CM: 1,
    CN: 1,
    CR: 1,
    CY: 1,
    CZ: 1,
    DE: 1,
    DJ: 6,
    DK: 1,
    DZ: 6,
    EC: 1,
    EE: 1,
    EG: 6,
    ES: 1,
    FI: 1,
    FJ: 1,
    FO: 1,
    FR: 1,
    GB: 1,
    GE: 1,
    GF: 1,
    GP: 1,
    GR: 1,
    HR: 1,
    HU: 1,
    IE: 1,
    IQ: 6,
    IR: 6,
    IS: 1,
    IT: 1,
    JO: 6,
    KG: 1,
    KW: 6,
    KZ: 1,
    LB: 1,
    LI: 1,
    LK: 1,
    LT: 1,
    LU: 1,
    LV: 1,
    LY: 6,
    MC: 1,
    MD: 1,
    ME: 1,
    MK: 1,
    MN: 1,
    MQ: 1,
    MV: 5,
    MY: 1,
    NL: 1,
    NO: 1,
    NZ: 1,
    OM: 6,
    PL: 1,
    QA: 6,
    RE: 1,
    RO: 1,
    RS: 1,
    RU: 1,
    SD: 6,
    SE: 1,
    SI: 1,
    SK: 1,
    SM: 1,
    SY: 6,
    TJ: 1,
    TM: 1,
    TR: 1,
    UA: 1,
    UY: 1,
    UZ: 1,
    VA: 1,
    VN: 1,
    XK: 1
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"4N0ez":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/** Parses an ISO 8601 time string. */ parcelHelpers.export(exports, "parseTime", ()=>parseTime);
/** Parses an ISO 8601 date string, with no time components. */ parcelHelpers.export(exports, "parseDate", ()=>parseDate);
/** Parses an ISO 8601 date and time string, with no time zone. */ parcelHelpers.export(exports, "parseDateTime", ()=>parseDateTime);
/**
 * Parses an ISO 8601 date and time string with a time zone extension and optional UTC offset
 * (e.g. "2021-11-07T00:45[America/Los_Angeles]" or "2021-11-07T00:45-07:00[America/Los_Angeles]").
 * Ambiguous times due to daylight saving time transitions are resolved according to the `disambiguation`
 * parameter.
 */ parcelHelpers.export(exports, "parseZonedDateTime", ()=>parseZonedDateTime);
/**
 * Parses an ISO 8601 date and time string with a UTC offset (e.g. "2021-11-07T07:45:00Z"
 * or "2021-11-07T07:45:00-07:00"). The result is converted to the provided time zone.
 */ parcelHelpers.export(exports, "parseAbsolute", ()=>parseAbsolute);
/**
 * Parses an ISO 8601 date and time string with a UTC offset (e.g. "2021-11-07T07:45:00Z"
 * or "2021-11-07T07:45:00-07:00"). The result is converted to the user's local time zone.
 */ parcelHelpers.export(exports, "parseAbsoluteToLocal", ()=>parseAbsoluteToLocal);
parcelHelpers.export(exports, "timeToString", ()=>timeToString);
parcelHelpers.export(exports, "dateToString", ()=>dateToString);
parcelHelpers.export(exports, "dateTimeToString", ()=>dateTimeToString);
parcelHelpers.export(exports, "zonedDateTimeToString", ()=>zonedDateTimeToString);
/**
 * Parses an ISO 8601 duration string (e.g. "P3Y6M6W4DT12H30M5S").
 * @param value An ISO 8601 duration string.
 * @returns A DateTimeDuration object.
 */ parcelHelpers.export(exports, "parseDuration", ()=>parseDuration);
var _calendarDate = require("./CalendarDate");
var _conversion = require("./conversion");
var _queries = require("./queries");
var _gregorianCalendar = require("./calendars/GregorianCalendar");
const TIME_RE = /^(\d{2})(?::(\d{2}))?(?::(\d{2}))?(\.\d+)?$/;
const DATE_RE = /^(\d{4})-(\d{2})-(\d{2})$/;
const DATE_TIME_RE = /^(\d{4})-(\d{2})-(\d{2})(?:T(\d{2}))?(?::(\d{2}))?(?::(\d{2}))?(\.\d+)?$/;
const ZONED_DATE_TIME_RE = /^(\d{4})-(\d{2})-(\d{2})(?:T(\d{2}))?(?::(\d{2}))?(?::(\d{2}))?(\.\d+)?(?:([+-]\d{2})(?::?(\d{2}))?)?\[(.*?)\]$/;
const ABSOLUTE_RE = /^(\d{4})-(\d{2})-(\d{2})(?:T(\d{2}))?(?::(\d{2}))?(?::(\d{2}))?(\.\d+)?(?:(?:([+-]\d{2})(?::?(\d{2}))?)|Z)$/;
const DATE_TIME_DURATION_RE = /^((?<negative>-)|\+)?P((?<years>\d*)Y)?((?<months>\d*)M)?((?<weeks>\d*)W)?((?<days>\d*)D)?((?<time>T)((?<hours>\d*[.,]?\d{1,9})H)?((?<minutes>\d*[.,]?\d{1,9})M)?((?<seconds>\d*[.,]?\d{1,9})S)?)?$/;
const requiredDurationTimeGroups = [
    "hours",
    "minutes",
    "seconds"
];
const requiredDurationGroups = [
    "years",
    "months",
    "weeks",
    "days",
    ...requiredDurationTimeGroups
];
function parseTime(value) {
    let m = value.match(TIME_RE);
    if (!m) throw new Error("Invalid ISO 8601 time string: " + value);
    return new (0, _calendarDate.Time)(parseNumber(m[1], 0, 23), m[2] ? parseNumber(m[2], 0, 59) : 0, m[3] ? parseNumber(m[3], 0, 59) : 0, m[4] ? parseNumber(m[4], 0, Infinity) * 1000 : 0);
}
function parseDate(value) {
    let m = value.match(DATE_RE);
    if (!m) throw new Error("Invalid ISO 8601 date string: " + value);
    let date = new (0, _calendarDate.CalendarDate)(parseNumber(m[1], 0, 9999), parseNumber(m[2], 1, 12), 1);
    date.day = parseNumber(m[3], 0, date.calendar.getDaysInMonth(date));
    return date;
}
function parseDateTime(value) {
    let m = value.match(DATE_TIME_RE);
    if (!m) throw new Error("Invalid ISO 8601 date time string: " + value);
    let date = new (0, _calendarDate.CalendarDateTime)(parseNumber(m[1], 1, 9999), parseNumber(m[2], 1, 12), 1, m[4] ? parseNumber(m[4], 0, 23) : 0, m[5] ? parseNumber(m[5], 0, 59) : 0, m[6] ? parseNumber(m[6], 0, 59) : 0, m[7] ? parseNumber(m[7], 0, Infinity) * 1000 : 0);
    date.day = parseNumber(m[3], 0, date.calendar.getDaysInMonth(date));
    return date;
}
function parseZonedDateTime(value, disambiguation) {
    let m = value.match(ZONED_DATE_TIME_RE);
    if (!m) throw new Error("Invalid ISO 8601 date time string: " + value);
    let date = new (0, _calendarDate.ZonedDateTime)(parseNumber(m[1], 1, 9999), parseNumber(m[2], 1, 12), 1, m[10], 0, m[4] ? parseNumber(m[4], 0, 23) : 0, m[5] ? parseNumber(m[5], 0, 59) : 0, m[6] ? parseNumber(m[6], 0, 59) : 0, m[7] ? parseNumber(m[7], 0, Infinity) * 1000 : 0);
    date.day = parseNumber(m[3], 0, date.calendar.getDaysInMonth(date));
    let plainDateTime = (0, _conversion.toCalendarDateTime)(date);
    let ms;
    if (m[8]) {
        var _m_;
        date.offset = parseNumber(m[8], -23, 23) * 3600000 + parseNumber((_m_ = m[9]) !== null && _m_ !== void 0 ? _m_ : "0", 0, 59) * 60000;
        ms = (0, _conversion.epochFromDate)(date) - date.offset;
        // Validate offset against parsed date.
        let absolutes = (0, _conversion.possibleAbsolutes)(plainDateTime, date.timeZone);
        if (!absolutes.includes(ms)) throw new Error(`Offset ${offsetToString(date.offset)} is invalid for ${dateTimeToString(date)} in ${date.timeZone}`);
    } else // Convert to absolute and back to fix invalid times due to DST.
    ms = (0, _conversion.toAbsolute)((0, _conversion.toCalendarDateTime)(plainDateTime), date.timeZone, disambiguation);
    return (0, _conversion.fromAbsolute)(ms, date.timeZone);
}
function parseAbsolute(value, timeZone) {
    let m = value.match(ABSOLUTE_RE);
    if (!m) throw new Error("Invalid ISO 8601 date time string: " + value);
    let date = new (0, _calendarDate.ZonedDateTime)(parseNumber(m[1], 1, 9999), parseNumber(m[2], 1, 12), 1, timeZone, 0, m[4] ? parseNumber(m[4], 0, 23) : 0, m[5] ? parseNumber(m[5], 0, 59) : 0, m[6] ? parseNumber(m[6], 0, 59) : 0, m[7] ? parseNumber(m[7], 0, Infinity) * 1000 : 0);
    date.day = parseNumber(m[3], 0, date.calendar.getDaysInMonth(date));
    var _m_;
    if (m[8]) date.offset = parseNumber(m[8], -23, 23) * 3600000 + parseNumber((_m_ = m[9]) !== null && _m_ !== void 0 ? _m_ : "0", 0, 59) * 60000;
    return (0, _conversion.toTimeZone)(date, timeZone);
}
function parseAbsoluteToLocal(value) {
    return parseAbsolute(value, (0, _queries.getLocalTimeZone)());
}
function parseNumber(value, min, max) {
    let val = Number(value);
    if (val < min || val > max) throw new RangeError(`Value out of range: ${min} <= ${val} <= ${max}`);
    return val;
}
function timeToString(time) {
    return `${String(time.hour).padStart(2, "0")}:${String(time.minute).padStart(2, "0")}:${String(time.second).padStart(2, "0")}${time.millisecond ? String(time.millisecond / 1000).slice(1) : ""}`;
}
function dateToString(date) {
    let gregorianDate = (0, _conversion.toCalendar)(date, new (0, _gregorianCalendar.GregorianCalendar)());
    return `${String(gregorianDate.year).padStart(4, "0")}-${String(gregorianDate.month).padStart(2, "0")}-${String(gregorianDate.day).padStart(2, "0")}`;
}
function dateTimeToString(date) {
    // @ts-ignore
    return `${dateToString(date)}T${timeToString(date)}`;
}
function offsetToString(offset) {
    let sign = Math.sign(offset) < 0 ? "-" : "+";
    offset = Math.abs(offset);
    let offsetHours = Math.floor(offset / 3600000);
    let offsetMinutes = offset % 3600000 / 60000;
    return `${sign}${String(offsetHours).padStart(2, "0")}:${String(offsetMinutes).padStart(2, "0")}`;
}
function zonedDateTimeToString(date) {
    return `${dateTimeToString(date)}${offsetToString(date.offset)}[${date.timeZone}]`;
}
function parseDuration(value) {
    var _match_groups, _match_groups1, _match_groups2, _match_groups3, _match_groups4, _match_groups5, _match_groups6, _match_groups7, _match_groups8;
    const match = value.match(DATE_TIME_DURATION_RE);
    if (!match) throw new Error(`Invalid ISO 8601 Duration string: ${value}`);
    const parseDurationGroup = (group, isNegative, min, max)=>{
        if (!group) return 0;
        try {
            const sign = isNegative ? -1 : 1;
            return sign * parseNumber(group.replace(",", "."), min, max);
        } catch  {
            throw new Error(`Invalid ISO 8601 Duration string: ${value}`);
        }
    };
    const isNegative = !!((_match_groups = match.groups) === null || _match_groups === void 0 ? void 0 : _match_groups.negative);
    const hasRequiredGroups = requiredDurationGroups.some((group)=>{
        var _match_groups;
        return (_match_groups = match.groups) === null || _match_groups === void 0 ? void 0 : _match_groups[group];
    });
    if (!hasRequiredGroups) throw new Error(`Invalid ISO 8601 Duration string: ${value}`);
    const durationStringIncludesTime = (_match_groups1 = match.groups) === null || _match_groups1 === void 0 ? void 0 : _match_groups1.time;
    if (durationStringIncludesTime) {
        const hasRequiredDurationTimeGroups = requiredDurationTimeGroups.some((group)=>{
            var _match_groups;
            return (_match_groups = match.groups) === null || _match_groups === void 0 ? void 0 : _match_groups[group];
        });
        if (!hasRequiredDurationTimeGroups) throw new Error(`Invalid ISO 8601 Duration string: ${value}`);
    }
    const duration = {
        years: parseDurationGroup((_match_groups2 = match.groups) === null || _match_groups2 === void 0 ? void 0 : _match_groups2.years, isNegative, 0, 9999),
        months: parseDurationGroup((_match_groups3 = match.groups) === null || _match_groups3 === void 0 ? void 0 : _match_groups3.months, isNegative, 0, 12),
        weeks: parseDurationGroup((_match_groups4 = match.groups) === null || _match_groups4 === void 0 ? void 0 : _match_groups4.weeks, isNegative, 0, Infinity),
        days: parseDurationGroup((_match_groups5 = match.groups) === null || _match_groups5 === void 0 ? void 0 : _match_groups5.days, isNegative, 0, 31),
        hours: parseDurationGroup((_match_groups6 = match.groups) === null || _match_groups6 === void 0 ? void 0 : _match_groups6.hours, isNegative, 0, 23),
        minutes: parseDurationGroup((_match_groups7 = match.groups) === null || _match_groups7 === void 0 ? void 0 : _match_groups7.minutes, isNegative, 0, 59),
        seconds: parseDurationGroup((_match_groups8 = match.groups) === null || _match_groups8 === void 0 ? void 0 : _match_groups8.seconds, isNegative, 0, 59)
    };
    if (duration.hours !== undefined && duration.hours % 1 !== 0 && (duration.minutes || duration.seconds)) throw new Error(`Invalid ISO 8601 Duration string: ${value} - only the smallest unit can be fractional`);
    if (duration.minutes !== undefined && duration.minutes % 1 !== 0 && duration.seconds) throw new Error(`Invalid ISO 8601 Duration string: ${value} - only the smallest unit can be fractional`);
    return duration;
}

},{"./CalendarDate":"jcaEo","./conversion":"gOiVm","./queries":"gtZrq","./calendars/GregorianCalendar":"fE40j","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"039SF":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from the TC39 Temporal proposal.
// Original licensing can be found in the NOTICE file in the root directory of this source tree.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The Japanese calendar is based on the Gregorian calendar, but with eras for the reign of each Japanese emperor.
 * Whenever a new emperor ascends to the throne, a new era begins and the year starts again from 1.
 * Note that eras before 1868 (Gregorian) are not currently supported by this implementation.
 */ parcelHelpers.export(exports, "JapaneseCalendar", ()=>JapaneseCalendar);
var _calendarDate = require("../CalendarDate");
var _gregorianCalendar = require("./GregorianCalendar");
const ERA_START_DATES = [
    [
        1868,
        9,
        8
    ],
    [
        1912,
        7,
        30
    ],
    [
        1926,
        12,
        25
    ],
    [
        1989,
        1,
        8
    ],
    [
        2019,
        5,
        1
    ]
];
const ERA_END_DATES = [
    [
        1912,
        7,
        29
    ],
    [
        1926,
        12,
        24
    ],
    [
        1989,
        1,
        7
    ],
    [
        2019,
        4,
        30
    ]
];
const ERA_ADDENDS = [
    1867,
    1911,
    1925,
    1988,
    2018
];
const ERA_NAMES = [
    "meiji",
    "taisho",
    "showa",
    "heisei",
    "reiwa"
];
function findEraFromGregorianDate(date) {
    const idx = ERA_START_DATES.findIndex(([year, month, day])=>{
        if (date.year < year) return true;
        if (date.year === year && date.month < month) return true;
        if (date.year === year && date.month === month && date.day < day) return true;
        return false;
    });
    if (idx === -1) return ERA_START_DATES.length - 1;
    if (idx === 0) return 0;
    return idx - 1;
}
function toGregorian(date) {
    let eraAddend = ERA_ADDENDS[ERA_NAMES.indexOf(date.era)];
    if (!eraAddend) throw new Error("Unknown era: " + date.era);
    return new (0, _calendarDate.CalendarDate)(date.year + eraAddend, date.month, date.day);
}
class JapaneseCalendar extends (0, _gregorianCalendar.GregorianCalendar) {
    fromJulianDay(jd) {
        let date = super.fromJulianDay(jd);
        let era = findEraFromGregorianDate(date);
        return new (0, _calendarDate.CalendarDate)(this, ERA_NAMES[era], date.year - ERA_ADDENDS[era], date.month, date.day);
    }
    toJulianDay(date) {
        return super.toJulianDay(toGregorian(date));
    }
    balanceDate(date) {
        let gregorianDate = toGregorian(date);
        let era = findEraFromGregorianDate(gregorianDate);
        if (ERA_NAMES[era] !== date.era) {
            date.era = ERA_NAMES[era];
            date.year = gregorianDate.year - ERA_ADDENDS[era];
        }
        // Constrain in case we went before the first supported era.
        this.constrainDate(date);
    }
    constrainDate(date) {
        let idx = ERA_NAMES.indexOf(date.era);
        let end = ERA_END_DATES[idx];
        if (end != null) {
            let [endYear, endMonth, endDay] = end;
            // Constrain the year to the maximum possible value in the era.
            // Then constrain the month and day fields within that.
            let maxYear = endYear - ERA_ADDENDS[idx];
            date.year = Math.max(1, Math.min(maxYear, date.year));
            if (date.year === maxYear) {
                date.month = Math.min(endMonth, date.month);
                if (date.month === endMonth) date.day = Math.min(endDay, date.day);
            }
        }
        if (date.year === 1 && idx >= 0) {
            let [, startMonth, startDay] = ERA_START_DATES[idx];
            date.month = Math.max(startMonth, date.month);
            if (date.month === startMonth) date.day = Math.max(startDay, date.day);
        }
    }
    getEras() {
        return ERA_NAMES;
    }
    getYearsInEra(date) {
        // Get the number of years in the era, taking into account the date's month and day fields.
        let era = ERA_NAMES.indexOf(date.era);
        let cur = ERA_START_DATES[era];
        let next = ERA_START_DATES[era + 1];
        if (next == null) // 9999 gregorian is the maximum year allowed.
        return 9999 - cur[0] + 1;
        let years = next[0] - cur[0];
        if (date.month < next[1] || date.month === next[1] && date.day < next[2]) years++;
        return years;
    }
    getDaysInMonth(date) {
        return super.getDaysInMonth(toGregorian(date));
    }
    getMinimumMonthInYear(date) {
        let start = getMinimums(date);
        return start ? start[1] : 1;
    }
    getMinimumDayInMonth(date) {
        let start = getMinimums(date);
        return start && date.month === start[1] ? start[2] : 1;
    }
    constructor(...args){
        super(...args);
        this.identifier = "japanese";
    }
}
function getMinimums(date) {
    if (date.year === 1) {
        let idx = ERA_NAMES.indexOf(date.era);
        return ERA_START_DATES[idx];
    }
}

},{"../CalendarDate":"jcaEo","./GregorianCalendar":"fE40j","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"gPfGA":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from ICU.
// Original licensing can be found in the NOTICE file in the root directory of this source tree.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The Buddhist calendar is the same as the Gregorian calendar, but counts years
 * starting from the birth of Buddha in 543 BC (Gregorian). It supports only one
 * era, identified as 'BE'.
 */ parcelHelpers.export(exports, "BuddhistCalendar", ()=>BuddhistCalendar);
var _calendarDate = require("../CalendarDate");
var _gregorianCalendar = require("./GregorianCalendar");
const BUDDHIST_ERA_START = -543;
class BuddhistCalendar extends (0, _gregorianCalendar.GregorianCalendar) {
    fromJulianDay(jd) {
        let gregorianDate = super.fromJulianDay(jd);
        let year = (0, _gregorianCalendar.getExtendedYear)(gregorianDate.era, gregorianDate.year);
        return new (0, _calendarDate.CalendarDate)(this, year - BUDDHIST_ERA_START, gregorianDate.month, gregorianDate.day);
    }
    toJulianDay(date) {
        return super.toJulianDay(toGregorian(date));
    }
    getEras() {
        return [
            "BE"
        ];
    }
    getDaysInMonth(date) {
        return super.getDaysInMonth(toGregorian(date));
    }
    balanceDate() {}
    constructor(...args){
        super(...args);
        this.identifier = "buddhist";
    }
}
function toGregorian(date) {
    let [era, year] = (0, _gregorianCalendar.fromExtendedYear)(date.year + BUDDHIST_ERA_START);
    return new (0, _calendarDate.CalendarDate)(era, year, date.month, date.day);
}

},{"../CalendarDate":"jcaEo","./GregorianCalendar":"fE40j","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"6voQ0":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from ICU.
// Original licensing can be found in the NOTICE file in the root directory of this source tree.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The Taiwanese calendar is the same as the Gregorian calendar, but years
 * are numbered starting from 1912 (Gregorian). Two eras are supported:
 * 'before_minguo' and 'minguo'.
 */ parcelHelpers.export(exports, "TaiwanCalendar", ()=>TaiwanCalendar);
var _calendarDate = require("../CalendarDate");
var _gregorianCalendar = require("./GregorianCalendar");
const TAIWAN_ERA_START = 1911;
function gregorianYear(date) {
    return date.era === "minguo" ? date.year + TAIWAN_ERA_START : 1 - date.year + TAIWAN_ERA_START;
}
function gregorianToTaiwan(year) {
    let y = year - TAIWAN_ERA_START;
    if (y > 0) return [
        "minguo",
        y
    ];
    else return [
        "before_minguo",
        1 - y
    ];
}
class TaiwanCalendar extends (0, _gregorianCalendar.GregorianCalendar) {
    fromJulianDay(jd) {
        let date = super.fromJulianDay(jd);
        let extendedYear = (0, _gregorianCalendar.getExtendedYear)(date.era, date.year);
        let [era, year] = gregorianToTaiwan(extendedYear);
        return new (0, _calendarDate.CalendarDate)(this, era, year, date.month, date.day);
    }
    toJulianDay(date) {
        return super.toJulianDay(toGregorian(date));
    }
    getEras() {
        return [
            "before_minguo",
            "minguo"
        ];
    }
    balanceDate(date) {
        let [era, year] = gregorianToTaiwan(gregorianYear(date));
        date.era = era;
        date.year = year;
    }
    isInverseEra(date) {
        return date.era === "before_minguo";
    }
    getDaysInMonth(date) {
        return super.getDaysInMonth(toGregorian(date));
    }
    getYearsInEra(date) {
        return date.era === "before_minguo" ? 9999 : 9999 - TAIWAN_ERA_START;
    }
    constructor(...args){
        super(...args);
        this.identifier = "roc" // Republic of China
        ;
    }
}
function toGregorian(date) {
    let [era, year] = (0, _gregorianCalendar.fromExtendedYear)(gregorianYear(date));
    return new (0, _calendarDate.CalendarDate)(era, year, date.month, date.day);
}

},{"../CalendarDate":"jcaEo","./GregorianCalendar":"fE40j","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"hJ7Tr":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from ICU.
// Original licensing can be found in the NOTICE file in the root directory of this source tree.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The Persian calendar is the main calendar used in Iran and Afghanistan. It has 12 months
 * in each year, the first 6 of which have 31 days, and the next 5 have 30 days. The 12th month
 * has either 29 or 30 days depending on whether it is a leap year. The Persian year starts
 * around the March equinox.
 */ parcelHelpers.export(exports, "PersianCalendar", ()=>PersianCalendar);
var _calendarDate = require("../CalendarDate");
var _utils = require("../utils");
const PERSIAN_EPOCH = 1948321; // 622/03/19 Julian C.E.
function isLeapYear(year) {
    let y0 = year > 0 ? year - 474 : year - 473;
    let y1 = (0, _utils.mod)(y0, 2820) + 474;
    return (0, _utils.mod)((y1 + 38) * 31, 128) < 31;
}
function persianToJulianDay(year, month, day) {
    let y0 = year > 0 ? year - 474 : year - 473;
    let y1 = (0, _utils.mod)(y0, 2820) + 474;
    let offset = month <= 7 ? 31 * (month - 1) : 30 * (month - 1) + 6;
    return PERSIAN_EPOCH - 1 + 1029983 * Math.floor(y0 / 2820) + 365 * (y1 - 1) + Math.floor((31 * y1 - 5) / 128) + offset + day;
}
class PersianCalendar {
    fromJulianDay(jd) {
        let d0 = jd - persianToJulianDay(475, 1, 1);
        let n2820 = Math.floor(d0 / 1029983);
        let d1 = (0, _utils.mod)(d0, 1029983);
        let y2820 = d1 === 1029982 ? 2820 : Math.floor((128 * d1 + 46878) / 46751);
        let year = 474 + 2820 * n2820 + y2820;
        if (year <= 0) year--;
        let yDay = jd - persianToJulianDay(year, 1, 1) + 1;
        let month = yDay <= 186 ? Math.ceil(yDay / 31) : Math.ceil((yDay - 6) / 31);
        let day = jd - persianToJulianDay(year, month, 1) + 1;
        return new (0, _calendarDate.CalendarDate)(this, year, month, day);
    }
    toJulianDay(date) {
        return persianToJulianDay(date.year, date.month, date.day);
    }
    getMonthsInYear() {
        return 12;
    }
    getDaysInMonth(date) {
        if (date.month <= 6) return 31;
        if (date.month <= 11) return 30;
        return isLeapYear(date.year) ? 30 : 29;
    }
    getEras() {
        return [
            "AP"
        ];
    }
    getYearsInEra() {
        // 9378-10-10 persian is 9999-12-31 gregorian.
        // Round down to 9377 to set the maximum full year.
        return 9377;
    }
    constructor(){
        this.identifier = "persian";
    }
}

},{"../CalendarDate":"jcaEo","../utils":"4L3yE","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"jjYls":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from ICU.
// Original licensing can be found in the NOTICE file in the root directory of this source tree.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The Indian National Calendar is similar to the Gregorian calendar, but with
 * years numbered since the Saka era in 78 AD (Gregorian). There are 12 months
 * in each year, with either 30 or 31 days. Only one era identifier is supported: 'saka'.
 */ parcelHelpers.export(exports, "IndianCalendar", ()=>IndianCalendar);
var _calendarDate = require("../CalendarDate");
var _gregorianCalendar = require("./GregorianCalendar");
// Starts in 78 AD,
const INDIAN_ERA_START = 78;
// The Indian year starts 80 days later than the Gregorian year.
const INDIAN_YEAR_START = 80;
class IndianCalendar extends (0, _gregorianCalendar.GregorianCalendar) {
    fromJulianDay(jd) {
        // Gregorian date for Julian day
        let date = super.fromJulianDay(jd);
        // Year in Saka era
        let indianYear = date.year - INDIAN_ERA_START;
        // Day number in Gregorian year (starting from 0)
        let yDay = jd - (0, _gregorianCalendar.gregorianToJulianDay)(date.era, date.year, 1, 1);
        let leapMonth;
        if (yDay < INDIAN_YEAR_START) {
            //  Day is at the end of the preceding Saka year
            indianYear--;
            // Days in leapMonth this year, previous Gregorian year
            leapMonth = (0, _gregorianCalendar.isLeapYear)(date.year - 1) ? 31 : 30;
            yDay += leapMonth + 155 + 90 + 10;
        } else {
            // Days in leapMonth this year
            leapMonth = (0, _gregorianCalendar.isLeapYear)(date.year) ? 31 : 30;
            yDay -= INDIAN_YEAR_START;
        }
        let indianMonth;
        let indianDay;
        if (yDay < leapMonth) {
            indianMonth = 1;
            indianDay = yDay + 1;
        } else {
            let mDay = yDay - leapMonth;
            if (mDay < 155) {
                indianMonth = Math.floor(mDay / 31) + 2;
                indianDay = mDay % 31 + 1;
            } else {
                mDay -= 155;
                indianMonth = Math.floor(mDay / 30) + 7;
                indianDay = mDay % 30 + 1;
            }
        }
        return new (0, _calendarDate.CalendarDate)(this, indianYear, indianMonth, indianDay);
    }
    toJulianDay(date) {
        let extendedYear = date.year + INDIAN_ERA_START;
        let [era, year] = (0, _gregorianCalendar.fromExtendedYear)(extendedYear);
        let leapMonth;
        let jd;
        if ((0, _gregorianCalendar.isLeapYear)(year)) {
            leapMonth = 31;
            jd = (0, _gregorianCalendar.gregorianToJulianDay)(era, year, 3, 21);
        } else {
            leapMonth = 30;
            jd = (0, _gregorianCalendar.gregorianToJulianDay)(era, year, 3, 22);
        }
        if (date.month === 1) return jd + date.day - 1;
        jd += leapMonth + Math.min(date.month - 2, 5) * 31;
        if (date.month >= 8) jd += (date.month - 7) * 30;
        jd += date.day - 1;
        return jd;
    }
    getDaysInMonth(date) {
        if (date.month === 1 && (0, _gregorianCalendar.isLeapYear)(date.year + INDIAN_ERA_START)) return 31;
        if (date.month >= 2 && date.month <= 6) return 31;
        return 30;
    }
    getYearsInEra() {
        // 9999-12-31 gregorian is 9920-10-10 indian.
        // Round down to 9919 for the last full year.
        return 9919;
    }
    getEras() {
        return [
            "saka"
        ];
    }
    balanceDate() {}
    constructor(...args){
        super(...args);
        this.identifier = "indian";
    }
}

},{"../CalendarDate":"jcaEo","./GregorianCalendar":"fE40j","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"gu6qZ":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from ICU.
// Original licensing can be found in the NOTICE file in the root directory of this source tree.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The Islamic calendar, also known as the "Hijri" calendar, is used throughout much of the Arab world.
 * The civil variant uses simple arithmetic rules rather than astronomical calculations to approximate
 * the traditional calendar, which is based on sighting of the crescent moon. It uses Friday, July 16 622 CE (Julian) as the epoch.
 * Each year has 12 months, with either 354 or 355 days depending on whether it is a leap year.
 * Learn more about the available Islamic calendars [here](https://cldr.unicode.org/development/development-process/design-proposals/islamic-calendar-types).
 */ parcelHelpers.export(exports, "IslamicCivilCalendar", ()=>IslamicCivilCalendar);
/**
 * The Islamic calendar, also known as the "Hijri" calendar, is used throughout much of the Arab world.
 * The tabular variant uses simple arithmetic rules rather than astronomical calculations to approximate
 * the traditional calendar, which is based on sighting of the crescent moon. It uses Thursday, July 15 622 CE (Julian) as the epoch.
 * Each year has 12 months, with either 354 or 355 days depending on whether it is a leap year.
 * Learn more about the available Islamic calendars [here](https://cldr.unicode.org/development/development-process/design-proposals/islamic-calendar-types).
 */ parcelHelpers.export(exports, "IslamicTabularCalendar", ()=>IslamicTabularCalendar);
/**
 * The Islamic calendar, also known as the "Hijri" calendar, is used throughout much of the Arab world.
 * The Umalqura variant is primarily used in Saudi Arabia. It is a lunar calendar, based on astronomical
 * calculations that predict the sighting of a crescent moon. Month and year lengths vary between years
 * depending on these calculations.
 * Learn more about the available Islamic calendars [here](https://cldr.unicode.org/development/development-process/design-proposals/islamic-calendar-types).
 */ parcelHelpers.export(exports, "IslamicUmalquraCalendar", ()=>IslamicUmalquraCalendar);
var _calendarDate = require("../CalendarDate");
const CIVIL_EPOC = 1948440; // CE 622 July 16 Friday (Julian calendar) / CE 622 July 19 (Gregorian calendar)
const ASTRONOMICAL_EPOC = 1948439; // CE 622 July 15 Thursday (Julian calendar)
const UMALQURA_YEAR_START = 1300;
const UMALQURA_YEAR_END = 1600;
const UMALQURA_START_DAYS = 460322;
function islamicToJulianDay(epoch, year, month, day) {
    return day + Math.ceil(29.5 * (month - 1)) + (year - 1) * 354 + Math.floor((3 + 11 * year) / 30) + epoch - 1;
}
function julianDayToIslamic(calendar, epoch, jd) {
    let year = Math.floor((30 * (jd - epoch) + 10646) / 10631);
    let month = Math.min(12, Math.ceil((jd - (29 + islamicToJulianDay(epoch, year, 1, 1))) / 29.5) + 1);
    let day = jd - islamicToJulianDay(epoch, year, month, 1) + 1;
    return new (0, _calendarDate.CalendarDate)(calendar, year, month, day);
}
function isLeapYear(year) {
    return (14 + 11 * year) % 30 < 11;
}
class IslamicCivilCalendar {
    fromJulianDay(jd) {
        return julianDayToIslamic(this, CIVIL_EPOC, jd);
    }
    toJulianDay(date) {
        return islamicToJulianDay(CIVIL_EPOC, date.year, date.month, date.day);
    }
    getDaysInMonth(date) {
        let length = 29 + date.month % 2;
        if (date.month === 12 && isLeapYear(date.year)) length++;
        return length;
    }
    getMonthsInYear() {
        return 12;
    }
    getDaysInYear(date) {
        return isLeapYear(date.year) ? 355 : 354;
    }
    getYearsInEra() {
        // 9999 gregorian
        return 9665;
    }
    getEras() {
        return [
            "AH"
        ];
    }
    constructor(){
        this.identifier = "islamic-civil";
    }
}
class IslamicTabularCalendar extends IslamicCivilCalendar {
    fromJulianDay(jd) {
        return julianDayToIslamic(this, ASTRONOMICAL_EPOC, jd);
    }
    toJulianDay(date) {
        return islamicToJulianDay(ASTRONOMICAL_EPOC, date.year, date.month, date.day);
    }
    constructor(...args){
        super(...args);
        this.identifier = "islamic-tbla";
    }
}
// Generated by scripts/generate-umalqura.js
const UMALQURA_DATA = "qgpUDckO1AbqBmwDrQpVBakGkgepC9QF2gpcBS0NlQZKB1QLagutBa4ETwoXBYsGpQbVCtYCWwmdBE0KJg2VDawFtgm6AlsKKwWVCsoG6Qr0AnYJtgJWCcoKpAvSC9kF3AJtCU0FpQpSC6ULtAW2CVcFlwJLBaMGUgdlC2oFqworBZUMSg2lDcoF1gpXCasESwmlClILagt1BXYCtwhbBFUFqQW0BdoJ3QRuAjYJqgpUDbIN1QXaAlsJqwRVCkkLZAtxC7QFtQpVCiUNkg7JDtQG6QprCasEkwpJDaQNsg25CroEWworBZUKKgtVC1wFvQQ9Ah0JlQpKC1oLbQW2AjsJmwRVBqkGVAdqC2wFrQpVBSkLkgupC9QF2gpaBasKlQVJB2QHqgu1BbYCVgpNDiULUgtqC60FrgIvCZcESwalBqwG1gpdBZ0ETQoWDZUNqgW1BdoCWwmtBJUFygbkBuoK9QS2AlYJqgpUC9IL2QXqAm0JrQSVCkoLpQuyBbUJ1gSXCkcFkwZJB1ULagVrCisFiwpGDaMNygXWCtsEawJLCaUKUgtpC3UFdgG3CFsCKwVlBbQF2gntBG0BtgimClINqQ3UBdoKWwmrBFMGKQdiB6kLsgW1ClUFJQuSDckO0gbpCmsFqwRVCikNVA2qDbUJugQ7CpsETQqqCtUK2gJdCV4ELgqaDFUNsga5BroEXQotBZUKUguoC7QLuQXaAloJSgukDdEO6AZqC20FNQWVBkoNqA3UDdoGWwWdAisGFQtKC5ULqgWuCi4JjwwnBZUGqgbWCl0FnQI=";
let UMALQURA_MONTHLENGTH;
let UMALQURA_YEAR_START_TABLE;
function umalquraYearStart(year) {
    return UMALQURA_START_DAYS + UMALQURA_YEAR_START_TABLE[year - UMALQURA_YEAR_START];
}
function umalquraMonthLength(year, month) {
    let idx = year - UMALQURA_YEAR_START;
    let mask = 0x01 << 11 - (month - 1);
    if ((UMALQURA_MONTHLENGTH[idx] & mask) === 0) return 29;
    else return 30;
}
function umalquraMonthStart(year, month) {
    let day = umalquraYearStart(year);
    for(let i = 1; i < month; i++)day += umalquraMonthLength(year, i);
    return day;
}
function umalquraYearLength(year) {
    return UMALQURA_YEAR_START_TABLE[year + 1 - UMALQURA_YEAR_START] - UMALQURA_YEAR_START_TABLE[year - UMALQURA_YEAR_START];
}
class IslamicUmalquraCalendar extends IslamicCivilCalendar {
    fromJulianDay(jd) {
        let days = jd - CIVIL_EPOC;
        let startDays = umalquraYearStart(UMALQURA_YEAR_START);
        let endDays = umalquraYearStart(UMALQURA_YEAR_END);
        if (days < startDays || days > endDays) return super.fromJulianDay(jd);
        else {
            let y = UMALQURA_YEAR_START - 1;
            let m = 1;
            let d = 1;
            while(d > 0){
                y++;
                d = days - umalquraYearStart(y) + 1;
                let yearLength = umalquraYearLength(y);
                if (d === yearLength) {
                    m = 12;
                    break;
                } else if (d < yearLength) {
                    let monthLength = umalquraMonthLength(y, m);
                    m = 1;
                    while(d > monthLength){
                        d -= monthLength;
                        m++;
                        monthLength = umalquraMonthLength(y, m);
                    }
                    break;
                }
            }
            return new (0, _calendarDate.CalendarDate)(this, y, m, days - umalquraMonthStart(y, m) + 1);
        }
    }
    toJulianDay(date) {
        if (date.year < UMALQURA_YEAR_START || date.year > UMALQURA_YEAR_END) return super.toJulianDay(date);
        return CIVIL_EPOC + umalquraMonthStart(date.year, date.month) + (date.day - 1);
    }
    getDaysInMonth(date) {
        if (date.year < UMALQURA_YEAR_START || date.year > UMALQURA_YEAR_END) return super.getDaysInMonth(date);
        return umalquraMonthLength(date.year, date.month);
    }
    getDaysInYear(date) {
        if (date.year < UMALQURA_YEAR_START || date.year > UMALQURA_YEAR_END) return super.getDaysInYear(date);
        return umalquraYearLength(date.year);
    }
    constructor(){
        super();
        this.identifier = "islamic-umalqura";
        if (!UMALQURA_MONTHLENGTH) UMALQURA_MONTHLENGTH = new Uint16Array(Uint8Array.from(atob(UMALQURA_DATA), (c)=>c.charCodeAt(0)).buffer);
        if (!UMALQURA_YEAR_START_TABLE) {
            UMALQURA_YEAR_START_TABLE = new Uint32Array(UMALQURA_YEAR_END - UMALQURA_YEAR_START + 1);
            let yearStart = 0;
            for(let year = UMALQURA_YEAR_START; year <= UMALQURA_YEAR_END; year++){
                UMALQURA_YEAR_START_TABLE[year - UMALQURA_YEAR_START] = yearStart;
                for(let i = 1; i <= 12; i++)yearStart += umalquraMonthLength(year, i);
            }
        }
    }
}

},{"../CalendarDate":"jcaEo","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"1TCUc":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from ICU.
// Original licensing can be found in the NOTICE file in the root directory of this source tree.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The Hebrew calendar is used in Israel and around the world by the Jewish faith.
 * Years include either 12 or 13 months depending on whether it is a leap year.
 * In leap years, an extra month is inserted at month 6.
 */ parcelHelpers.export(exports, "HebrewCalendar", ()=>HebrewCalendar);
var _calendarDate = require("../CalendarDate");
var _utils = require("../utils");
const HEBREW_EPOCH = 347997;
// Hebrew date calculations are performed in terms of days, hours, and
// "parts" (or halakim), which are 1/1080 of an hour, or 3 1/3 seconds.
const HOUR_PARTS = 1080;
const DAY_PARTS = 24 * HOUR_PARTS;
// An approximate value for the length of a lunar month.
// It is used to calculate the approximate year and month of a given
// absolute date.
const MONTH_DAYS = 29;
const MONTH_FRACT = 12 * HOUR_PARTS + 793;
const MONTH_PARTS = MONTH_DAYS * DAY_PARTS + MONTH_FRACT;
function isLeapYear(year) {
    return (0, _utils.mod)(year * 7 + 1, 19) < 7;
}
// Test for delay of start of new year and to avoid
// Sunday, Wednesday, and Friday as start of the new year.
function hebrewDelay1(year) {
    let months = Math.floor((235 * year - 234) / 19);
    let parts = 12084 + 13753 * months;
    let day = months * 29 + Math.floor(parts / 25920);
    if ((0, _utils.mod)(3 * (day + 1), 7) < 3) day += 1;
    return day;
}
// Check for delay in start of new year due to length of adjacent years
function hebrewDelay2(year) {
    let last = hebrewDelay1(year - 1);
    let present = hebrewDelay1(year);
    let next = hebrewDelay1(year + 1);
    if (next - present === 356) return 2;
    if (present - last === 382) return 1;
    return 0;
}
function startOfYear(year) {
    return hebrewDelay1(year) + hebrewDelay2(year);
}
function getDaysInYear(year) {
    return startOfYear(year + 1) - startOfYear(year);
}
function getYearType(year) {
    let yearLength = getDaysInYear(year);
    if (yearLength > 380) yearLength -= 30; // Subtract length of leap month.
    switch(yearLength){
        case 353:
            return 0; // deficient
        case 354:
            return 1; // normal
        case 355:
            return 2; // complete
    }
}
function getDaysInMonth(year, month) {
    // Normalize month numbers from 1 - 13, even on non-leap years
    if (month >= 6 && !isLeapYear(year)) month++;
    // First of all, dispose of fixed-length 29 day months
    if (month === 4 || month === 7 || month === 9 || month === 11 || month === 13) return 29;
    let yearType = getYearType(year);
    // If it's Heshvan, days depend on length of year
    if (month === 2) return yearType === 2 ? 30 : 29;
    // Similarly, Kislev varies with the length of year
    if (month === 3) return yearType === 0 ? 29 : 30;
    // Adar I only exists in leap years
    if (month === 6) return isLeapYear(year) ? 30 : 0;
    return 30;
}
class HebrewCalendar {
    fromJulianDay(jd) {
        let d = jd - HEBREW_EPOCH;
        let m = d * DAY_PARTS / MONTH_PARTS; // Months (approx)
        let year = Math.floor((19 * m + 234) / 235) + 1; // Years (approx)
        let ys = startOfYear(year); // 1st day of year
        let dayOfYear = Math.floor(d - ys);
        // Because of the postponement rules, it's possible to guess wrong.  Fix it.
        while(dayOfYear < 1){
            year--;
            ys = startOfYear(year);
            dayOfYear = Math.floor(d - ys);
        }
        // Now figure out which month we're in, and the date within that month
        let month = 1;
        let monthStart = 0;
        while(monthStart < dayOfYear){
            monthStart += getDaysInMonth(year, month);
            month++;
        }
        month--;
        monthStart -= getDaysInMonth(year, month);
        let day = dayOfYear - monthStart;
        return new (0, _calendarDate.CalendarDate)(this, year, month, day);
    }
    toJulianDay(date) {
        let jd = startOfYear(date.year);
        for(let month = 1; month < date.month; month++)jd += getDaysInMonth(date.year, month);
        return jd + date.day + HEBREW_EPOCH;
    }
    getDaysInMonth(date) {
        return getDaysInMonth(date.year, date.month);
    }
    getMonthsInYear(date) {
        return isLeapYear(date.year) ? 13 : 12;
    }
    getDaysInYear(date) {
        return getDaysInYear(date.year);
    }
    getYearsInEra() {
        // 6239 gregorian
        return 9999;
    }
    getEras() {
        return [
            "AM"
        ];
    }
    balanceYearMonth(date, previousDate) {
        // Keep date in the same month when switching between leap years and non leap years
        if (previousDate.year !== date.year) {
            if (isLeapYear(previousDate.year) && !isLeapYear(date.year) && previousDate.month > 6) date.month--;
            else if (!isLeapYear(previousDate.year) && isLeapYear(date.year) && previousDate.month > 6) date.month++;
        }
    }
    constructor(){
        this.identifier = "hebrew";
    }
}

},{"../CalendarDate":"jcaEo","../utils":"4L3yE","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"9rzir":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from ICU.
// Original licensing can be found in the NOTICE file in the root directory of this source tree.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The Ethiopic calendar system is the official calendar used in Ethiopia.
 * It includes 12 months of 30 days each, plus 5 or 6 intercalary days depending
 * on whether it is a leap year. Two eras are supported: 'AA' and 'AM'.
 */ parcelHelpers.export(exports, "EthiopicCalendar", ()=>EthiopicCalendar);
/**
 * The Ethiopic (Amete Alem) calendar is the same as the modern Ethiopic calendar,
 * except years were measured from a different epoch. Only one era is supported: 'AA'.
 */ parcelHelpers.export(exports, "EthiopicAmeteAlemCalendar", ()=>EthiopicAmeteAlemCalendar);
/**
 * The Coptic calendar is similar to the Ethiopic calendar.
 * It includes 12 months of 30 days each, plus 5 or 6 intercalary days depending
 * on whether it is a leap year. Two eras are supported: 'BCE' and 'CE'.
 */ parcelHelpers.export(exports, "CopticCalendar", ()=>CopticCalendar);
var _calendarDate = require("../CalendarDate");
const ETHIOPIC_EPOCH = 1723856;
const COPTIC_EPOCH = 1824665;
// The delta between Amete Alem 1 and Amete Mihret 1
// AA 5501 = AM 1
const AMETE_MIHRET_DELTA = 5500;
function ceToJulianDay(epoch, year, month, day) {
    return epoch // difference from Julian epoch to 1,1,1
     + 365 * year // number of days from years
     + Math.floor(year / 4) // extra day of leap year
     + 30 * (month - 1 // number of days from months (1 based)
    ) + day - 1 // number of days for present month (1 based)
    ;
}
function julianDayToCE(epoch, jd) {
    let year = Math.floor(4 * (jd - epoch) / 1461);
    let month = 1 + Math.floor((jd - ceToJulianDay(epoch, year, 1, 1)) / 30);
    let day = jd + 1 - ceToJulianDay(epoch, year, month, 1);
    return [
        year,
        month,
        day
    ];
}
function getLeapDay(year) {
    return Math.floor(year % 4 / 3);
}
function getDaysInMonth(year, month) {
    // The Ethiopian and Coptic calendars have 13 months, 12 of 30 days each and
    // an intercalary month at the end of the year of 5 or 6 days, depending whether
    // the year is a leap year or not. The Leap Year follows the same rules as the
    // Julian Calendar so that the extra month always has six days in the year before
    // a Julian Leap Year.
    if (month % 13 !== 0) // not intercalary month
    return 30;
    else // intercalary month 5 days + possible leap day
    return getLeapDay(year) + 5;
}
class EthiopicCalendar {
    fromJulianDay(jd) {
        let [year, month, day] = julianDayToCE(ETHIOPIC_EPOCH, jd);
        let era = "AM";
        if (year <= 0) {
            era = "AA";
            year += AMETE_MIHRET_DELTA;
        }
        return new (0, _calendarDate.CalendarDate)(this, era, year, month, day);
    }
    toJulianDay(date) {
        let year = date.year;
        if (date.era === "AA") year -= AMETE_MIHRET_DELTA;
        return ceToJulianDay(ETHIOPIC_EPOCH, year, date.month, date.day);
    }
    getDaysInMonth(date) {
        return getDaysInMonth(date.year, date.month);
    }
    getMonthsInYear() {
        return 13;
    }
    getDaysInYear(date) {
        return 365 + getLeapDay(date.year);
    }
    getYearsInEra(date) {
        // 9999-12-31 gregorian is 9992-20-02 ethiopic.
        // Round down to 9991 for the last full year.
        // AA 9999-01-01 ethiopic is 4506-09-30 gregorian.
        return date.era === "AA" ? 9999 : 9991;
    }
    getEras() {
        return [
            "AA",
            "AM"
        ];
    }
    constructor(){
        this.identifier = "ethiopic";
    }
}
class EthiopicAmeteAlemCalendar extends EthiopicCalendar {
    fromJulianDay(jd) {
        let [year, month, day] = julianDayToCE(ETHIOPIC_EPOCH, jd);
        year += AMETE_MIHRET_DELTA;
        return new (0, _calendarDate.CalendarDate)(this, "AA", year, month, day);
    }
    getEras() {
        return [
            "AA"
        ];
    }
    getYearsInEra() {
        // 9999-13-04 ethioaa is the maximum date, which is equivalent to 4506-09-29 gregorian.
        return 9999;
    }
    constructor(...args){
        super(...args);
        this.identifier = "ethioaa" // also known as 'ethiopic-amete-alem' in ICU
        ;
    }
}
class CopticCalendar extends EthiopicCalendar {
    fromJulianDay(jd) {
        let [year, month, day] = julianDayToCE(COPTIC_EPOCH, jd);
        let era = "CE";
        if (year <= 0) {
            era = "BCE";
            year = 1 - year;
        }
        return new (0, _calendarDate.CalendarDate)(this, era, year, month, day);
    }
    toJulianDay(date) {
        let year = date.year;
        if (date.era === "BCE") year = 1 - year;
        return ceToJulianDay(COPTIC_EPOCH, year, date.month, date.day);
    }
    getDaysInMonth(date) {
        let year = date.year;
        if (date.era === "BCE") year = 1 - year;
        return getDaysInMonth(year, date.month);
    }
    isInverseEra(date) {
        return date.era === "BCE";
    }
    balanceDate(date) {
        if (date.year <= 0) {
            date.era = date.era === "BCE" ? "CE" : "BCE";
            date.year = 1 - date.year;
        }
    }
    getEras() {
        return [
            "BCE",
            "CE"
        ];
    }
    getYearsInEra(date) {
        // 9999-12-30 gregorian is 9716-02-20 coptic.
        // Round down to 9715 for the last full year.
        // BCE 9999-01-01 coptic is BC 9716-06-15 gregorian.
        return date.era === "BCE" ? 9999 : 9715;
    }
    constructor(...args){
        super(...args);
        this.identifier = "coptic";
    }
}

},{"../CalendarDate":"jcaEo","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"3gyh2":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/** Creates a `Calendar` instance from a Unicode calendar identifier string. */ parcelHelpers.export(exports, "createCalendar", ()=>createCalendar);
var _buddhistCalendar = require("./calendars/BuddhistCalendar");
var _ethiopicCalendar = require("./calendars/EthiopicCalendar");
var _gregorianCalendar = require("./calendars/GregorianCalendar");
var _hebrewCalendar = require("./calendars/HebrewCalendar");
var _indianCalendar = require("./calendars/IndianCalendar");
var _islamicCalendar = require("./calendars/IslamicCalendar");
var _japaneseCalendar = require("./calendars/JapaneseCalendar");
var _persianCalendar = require("./calendars/PersianCalendar");
var _taiwanCalendar = require("./calendars/TaiwanCalendar");
function createCalendar(name) {
    switch(name){
        case "buddhist":
            return new (0, _buddhistCalendar.BuddhistCalendar)();
        case "ethiopic":
            return new (0, _ethiopicCalendar.EthiopicCalendar)();
        case "ethioaa":
            return new (0, _ethiopicCalendar.EthiopicAmeteAlemCalendar)();
        case "coptic":
            return new (0, _ethiopicCalendar.CopticCalendar)();
        case "hebrew":
            return new (0, _hebrewCalendar.HebrewCalendar)();
        case "indian":
            return new (0, _indianCalendar.IndianCalendar)();
        case "islamic-civil":
            return new (0, _islamicCalendar.IslamicCivilCalendar)();
        case "islamic-tbla":
            return new (0, _islamicCalendar.IslamicTabularCalendar)();
        case "islamic-umalqura":
            return new (0, _islamicCalendar.IslamicUmalquraCalendar)();
        case "japanese":
            return new (0, _japaneseCalendar.JapaneseCalendar)();
        case "persian":
            return new (0, _persianCalendar.PersianCalendar)();
        case "roc":
            return new (0, _taiwanCalendar.TaiwanCalendar)();
        case "gregory":
        default:
            return new (0, _gregorianCalendar.GregorianCalendar)();
    }
}

},{"./calendars/BuddhistCalendar":"gPfGA","./calendars/EthiopicCalendar":"9rzir","./calendars/GregorianCalendar":"fE40j","./calendars/HebrewCalendar":"1TCUc","./calendars/IndianCalendar":"jjYls","./calendars/IslamicCalendar":"gu6qZ","./calendars/JapaneseCalendar":"039SF","./calendars/PersianCalendar":"hJ7Tr","./calendars/TaiwanCalendar":"6voQ0","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"5MyYo":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/** A wrapper around Intl.DateTimeFormat that fixes various browser bugs, and polyfills new features. */ parcelHelpers.export(exports, "DateFormatter", ()=>DateFormatter);
let formatterCache = new Map();
class DateFormatter {
    /** Formats a date as a string according to the locale and format options passed to the constructor. */ format(value) {
        return this.formatter.format(value);
    }
    /** Formats a date to an array of parts such as separators, numbers, punctuation, and more. */ formatToParts(value) {
        return this.formatter.formatToParts(value);
    }
    /** Formats a date range as a string. */ formatRange(start, end) {
        // @ts-ignore
        if (typeof this.formatter.formatRange === "function") // @ts-ignore
        return this.formatter.formatRange(start, end);
        if (end < start) throw new RangeError("End date must be >= start date");
        // Very basic fallback for old browsers.
        return `${this.formatter.format(start)} \u{2013} ${this.formatter.format(end)}`;
    }
    /** Formats a date range as an array of parts. */ formatRangeToParts(start, end) {
        // @ts-ignore
        if (typeof this.formatter.formatRangeToParts === "function") // @ts-ignore
        return this.formatter.formatRangeToParts(start, end);
        if (end < start) throw new RangeError("End date must be >= start date");
        let startParts = this.formatter.formatToParts(start);
        let endParts = this.formatter.formatToParts(end);
        return [
            ...startParts.map((p)=>({
                    ...p,
                    source: "startRange"
                })),
            {
                type: "literal",
                value: " \u2013 ",
                source: "shared"
            },
            ...endParts.map((p)=>({
                    ...p,
                    source: "endRange"
                }))
        ];
    }
    /** Returns the resolved formatting options based on the values passed to the constructor. */ resolvedOptions() {
        let resolvedOptions = this.formatter.resolvedOptions();
        if (hasBuggyResolvedHourCycle()) {
            if (!this.resolvedHourCycle) this.resolvedHourCycle = getResolvedHourCycle(resolvedOptions.locale, this.options);
            resolvedOptions.hourCycle = this.resolvedHourCycle;
            resolvedOptions.hour12 = this.resolvedHourCycle === "h11" || this.resolvedHourCycle === "h12";
        }
        // Safari uses a different name for the Ethiopic (Amete Alem) calendar.
        // https://bugs.webkit.org/show_bug.cgi?id=241564
        if (resolvedOptions.calendar === "ethiopic-amete-alem") resolvedOptions.calendar = "ethioaa";
        return resolvedOptions;
    }
    constructor(locale, options = {}){
        this.formatter = getCachedDateFormatter(locale, options);
        this.options = options;
    }
}
// There are multiple bugs involving the hour12 and hourCycle options in various browser engines.
//   - Chrome [1] (and the ECMA 402 spec [2]) resolve hour12: false in English and other locales to h24 (24:00 - 23:59)
//     rather than h23 (00:00 - 23:59). Same can happen with hour12: true in French, which Chrome resolves to h11 (00:00 - 11:59)
//     rather than h12 (12:00 - 11:59).
//   - WebKit returns an incorrect hourCycle resolved option in the French locale due to incorrect parsing of 'h' literal
//     in the resolved pattern. It also formats incorrectly when specifying the hourCycle option for the same reason. [3]
// [1] https://bugs.chromium.org/p/chromium/issues/detail?id=1045791
// [2] https://github.com/tc39/ecma402/issues/402
// [3] https://bugs.webkit.org/show_bug.cgi?id=229313
// https://github.com/unicode-org/cldr/blob/018b55eff7ceb389c7e3fc44e2f657eae3b10b38/common/supplemental/supplementalData.xml#L4774-L4802
const hour12Preferences = {
    true: {
        // Only Japanese uses the h11 style for 12 hour time. All others use h12.
        ja: "h11"
    },
    false: {
    }
};
function getCachedDateFormatter(locale, options = {}) {
    // Work around buggy hour12 behavior in Chrome / ECMA 402 spec by using hourCycle instead.
    // Only apply the workaround if the issue is detected, because the hourCycle option is buggy in Safari.
    if (typeof options.hour12 === "boolean" && hasBuggyHour12Behavior()) {
        options = {
            ...options
        };
        let pref = hour12Preferences[String(options.hour12)][locale.split("-")[0]];
        let defaultHourCycle = options.hour12 ? "h12" : "h23";
        options.hourCycle = pref !== null && pref !== void 0 ? pref : defaultHourCycle;
        delete options.hour12;
    }
    let cacheKey = locale + (options ? Object.entries(options).sort((a, b)=>a[0] < b[0] ? -1 : 1).join() : "");
    if (formatterCache.has(cacheKey)) return formatterCache.get(cacheKey);
    let numberFormatter = new Intl.DateTimeFormat(locale, options);
    formatterCache.set(cacheKey, numberFormatter);
    return numberFormatter;
}
let _hasBuggyHour12Behavior = null;
function hasBuggyHour12Behavior() {
    if (_hasBuggyHour12Behavior == null) _hasBuggyHour12Behavior = new Intl.DateTimeFormat("en-US", {
        hour: "numeric",
        hour12: false
    }).format(new Date(2020, 2, 3, 0)) === "24";
    return _hasBuggyHour12Behavior;
}
let _hasBuggyResolvedHourCycle = null;
function hasBuggyResolvedHourCycle() {
    if (_hasBuggyResolvedHourCycle == null) _hasBuggyResolvedHourCycle = new Intl.DateTimeFormat("fr", {
        hour: "numeric",
        hour12: false
    }).resolvedOptions().hourCycle === "h12";
    return _hasBuggyResolvedHourCycle;
}
function getResolvedHourCycle(locale, options) {
    if (!options.timeStyle && !options.hour) return undefined;
    // Work around buggy results in resolved hourCycle and hour12 options in WebKit.
    // Format the minimum possible hour and maximum possible hour in a day and parse the results.
    locale = locale.replace(/(-u-)?-nu-[a-zA-Z0-9]+/, "");
    locale += (locale.includes("-u-") ? "" : "-u") + "-nu-latn";
    let formatter = getCachedDateFormatter(locale, {
        ...options,
        timeZone: undefined // use local timezone
    });
    let min = parseInt(formatter.formatToParts(new Date(2020, 2, 3, 0)).find((p)=>p.type === "hour").value, 10);
    let max = parseInt(formatter.formatToParts(new Date(2020, 2, 3, 23)).find((p)=>p.type === "hour").value, 10);
    if (min === 0 && max === 23) return "h23";
    if (min === 24 && max === 23) return "h24";
    if (min === 0 && max === 11) return "h11";
    if (min === 12 && max === 11) return "h12";
    throw new Error("Unexpected hour cycle result");
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"gPJri":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides localized number formatting for the current locale. Automatically updates when the locale changes,
 * and handles caching of the number formatter for performance.
 * @param options - Formatting options.
 */ parcelHelpers.export(exports, "useNumberFormatter", ()=>useNumberFormatter);
var _number = require("@internationalized/number");
var _context = require("./context");
var _react = require("react");
function useNumberFormatter(options = {}) {
    let { locale } = (0, _context.useLocale)();
    return (0, _react.useMemo)(()=>new (0, _number.NumberFormatter)(locale, options), [
        locale,
        options
    ]);
}

},{"@internationalized/number":"h1VQt","./context":"cPMDk","react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"h1VQt":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NumberFormatter", ()=>(0, _numberFormatter.NumberFormatter));
parcelHelpers.export(exports, "NumberParser", ()=>(0, _numberParser.NumberParser));
var _numberFormatter = require("./NumberFormatter");
var _numberParser = require("./NumberParser");

},{"./NumberFormatter":"5lQMm","./NumberParser":"3Vk7K","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"5lQMm":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * A wrapper around Intl.NumberFormat providing additional options, polyfills, and caching for performance.
 */ parcelHelpers.export(exports, "NumberFormatter", ()=>NumberFormatter);
/** @private - exported for tests */ parcelHelpers.export(exports, "numberFormatSignDisplayPolyfill", ()=>numberFormatSignDisplayPolyfill);
let formatterCache = new Map();
let supportsSignDisplay = false;
try {
    // @ts-ignore
    supportsSignDisplay = new Intl.NumberFormat("de-DE", {
        signDisplay: "exceptZero"
    }).resolvedOptions().signDisplay === "exceptZero";
// eslint-disable-next-line no-empty
} catch (e) {}
let supportsUnit = false;
try {
    // @ts-ignore
    supportsUnit = new Intl.NumberFormat("de-DE", {
        style: "unit",
        unit: "degree"
    }).resolvedOptions().style === "unit";
// eslint-disable-next-line no-empty
} catch (e) {}
// Polyfill for units since Safari doesn't support them yet. See https://bugs.webkit.org/show_bug.cgi?id=215438.
// Currently only polyfilling the unit degree in narrow format for ColorSlider in our supported locales.
// Values were determined by switching to each locale manually in Chrome.
const UNITS = {
    degree: {
        narrow: {
            default: "\xb0",
            "ja-JP": " \u5EA6",
            "zh-TW": "\u5EA6",
            "sl-SI": " \xb0"
        }
    }
};
class NumberFormatter {
    /** Formats a number value as a string, according to the locale and options provided to the constructor. */ format(value) {
        let res = "";
        if (!supportsSignDisplay && this.options.signDisplay != null) res = numberFormatSignDisplayPolyfill(this.numberFormatter, this.options.signDisplay, value);
        else res = this.numberFormatter.format(value);
        if (this.options.style === "unit" && !supportsUnit) {
            var _UNITS_unit;
            let { unit, unitDisplay = "short", locale } = this.resolvedOptions();
            if (!unit) return res;
            let values = (_UNITS_unit = UNITS[unit]) === null || _UNITS_unit === void 0 ? void 0 : _UNITS_unit[unitDisplay];
            res += values[locale] || values.default;
        }
        return res;
    }
    /** Formats a number to an array of parts such as separators, digits, punctuation, and more. */ formatToParts(value) {
        // TODO: implement signDisplay for formatToParts
        // @ts-ignore
        return this.numberFormatter.formatToParts(value);
    }
    /** Formats a number range as a string. */ formatRange(start, end) {
        // @ts-ignore
        if (typeof this.numberFormatter.formatRange === "function") // @ts-ignore
        return this.numberFormatter.formatRange(start, end);
        if (end < start) throw new RangeError("End date must be >= start date");
        // Very basic fallback for old browsers.
        return `${this.format(start)} \u{2013} ${this.format(end)}`;
    }
    /** Formats a number range as an array of parts. */ formatRangeToParts(start, end) {
        // @ts-ignore
        if (typeof this.numberFormatter.formatRangeToParts === "function") // @ts-ignore
        return this.numberFormatter.formatRangeToParts(start, end);
        if (end < start) throw new RangeError("End date must be >= start date");
        let startParts = this.numberFormatter.formatToParts(start);
        let endParts = this.numberFormatter.formatToParts(end);
        return [
            ...startParts.map((p)=>({
                    ...p,
                    source: "startRange"
                })),
            {
                type: "literal",
                value: " \u2013 ",
                source: "shared"
            },
            ...endParts.map((p)=>({
                    ...p,
                    source: "endRange"
                }))
        ];
    }
    /** Returns the resolved formatting options based on the values passed to the constructor. */ resolvedOptions() {
        let options = this.numberFormatter.resolvedOptions();
        if (!supportsSignDisplay && this.options.signDisplay != null) options = {
            ...options,
            signDisplay: this.options.signDisplay
        };
        if (!supportsUnit && this.options.style === "unit") options = {
            ...options,
            style: "unit",
            unit: this.options.unit,
            unitDisplay: this.options.unitDisplay
        };
        return options;
    }
    constructor(locale, options = {}){
        this.numberFormatter = getCachedNumberFormatter(locale, options);
        this.options = options;
    }
}
function getCachedNumberFormatter(locale, options = {}) {
    let { numberingSystem } = options;
    if (numberingSystem && locale.includes("-nu-")) {
        if (!locale.includes("-u-")) locale += "-u-";
        locale += `-nu-${numberingSystem}`;
    }
    if (options.style === "unit" && !supportsUnit) {
        var _UNITS_unit;
        let { unit, unitDisplay = "short" } = options;
        if (!unit) throw new Error('unit option must be provided with style: "unit"');
        if (!((_UNITS_unit = UNITS[unit]) === null || _UNITS_unit === void 0 ? void 0 : _UNITS_unit[unitDisplay])) throw new Error(`Unsupported unit ${unit} with unitDisplay = ${unitDisplay}`);
        options = {
            ...options,
            style: "decimal"
        };
    }
    let cacheKey = locale + (options ? Object.entries(options).sort((a, b)=>a[0] < b[0] ? -1 : 1).join() : "");
    if (formatterCache.has(cacheKey)) return formatterCache.get(cacheKey);
    let numberFormatter = new Intl.NumberFormat(locale, options);
    formatterCache.set(cacheKey, numberFormatter);
    return numberFormatter;
}
function numberFormatSignDisplayPolyfill(numberFormat, signDisplay, num) {
    if (signDisplay === "auto") return numberFormat.format(num);
    else if (signDisplay === "never") return numberFormat.format(Math.abs(num));
    else {
        let needsPositiveSign = false;
        if (signDisplay === "always") needsPositiveSign = num > 0 || Object.is(num, 0);
        else if (signDisplay === "exceptZero") {
            if (Object.is(num, -0) || Object.is(num, 0)) num = Math.abs(num);
            else needsPositiveSign = num > 0;
        }
        if (needsPositiveSign) {
            let negative = numberFormat.format(-num);
            let noSign = numberFormat.format(num);
            // ignore RTL/LTR marker character
            let minus = negative.replace(noSign, "").replace(/\u200e|\u061C/, "");
            if ([
                ...minus
            ].length !== 1) console.warn("@react-aria/i18n polyfill for NumberFormat signDisplay: Unsupported case");
            let positive = negative.replace(noSign, "!!!").replace(minus, "+").replace("!!!", noSign);
            return positive;
        } else return numberFormat.format(num);
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"3Vk7K":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * A NumberParser can be used to perform locale-aware parsing of numbers from Unicode strings,
 * as well as validation of partial user input. It automatically detects the numbering system
 * used in the input, and supports parsing decimals, percentages, currency values, and units
 * according to the locale.
 */ parcelHelpers.export(exports, "NumberParser", ()=>NumberParser);
var _numberFormatter = require("./NumberFormatter");
const CURRENCY_SIGN_REGEX = new RegExp("^.*\\(.*\\).*$");
const NUMBERING_SYSTEMS = [
    "latn",
    "arab",
    "hanidec"
];
class NumberParser {
    /**
   * Parses the given string to a number. Returns NaN if a valid number could not be parsed.
   */ parse(value) {
        return getNumberParserImpl(this.locale, this.options, value).parse(value);
    }
    /**
   * Returns whether the given string could potentially be a valid number. This should be used to
   * validate user input as the user types. If a `minValue` or `maxValue` is provided, the validity
   * of the minus/plus sign characters can be checked.
   */ isValidPartialNumber(value, minValue, maxValue) {
        return getNumberParserImpl(this.locale, this.options, value).isValidPartialNumber(value, minValue, maxValue);
    }
    /**
   * Returns a numbering system for which the given string is valid in the current locale.
   * If no numbering system could be detected, the default numbering system for the current
   * locale is returned.
   */ getNumberingSystem(value) {
        return getNumberParserImpl(this.locale, this.options, value).options.numberingSystem;
    }
    constructor(locale, options = {}){
        this.locale = locale;
        this.options = options;
    }
}
const numberParserCache = new Map();
function getNumberParserImpl(locale, options, value) {
    // First try the default numbering system for the provided locale
    let defaultParser = getCachedNumberParser(locale, options);
    // If that doesn't match, and the locale doesn't include a hard coded numbering system,
    // try each of the other supported numbering systems until we find one that matches.
    if (!locale.includes("-nu-") && !defaultParser.isValidPartialNumber(value)) {
        for (let numberingSystem of NUMBERING_SYSTEMS)if (numberingSystem !== defaultParser.options.numberingSystem) {
            let parser = getCachedNumberParser(locale + (locale.includes("-u-") ? "-nu-" : "-u-nu-") + numberingSystem, options);
            if (parser.isValidPartialNumber(value)) return parser;
        }
    }
    return defaultParser;
}
function getCachedNumberParser(locale, options) {
    let cacheKey = locale + (options ? Object.entries(options).sort((a, b)=>a[0] < b[0] ? -1 : 1).join() : "");
    let parser = numberParserCache.get(cacheKey);
    if (!parser) {
        parser = new NumberParserImpl(locale, options);
        numberParserCache.set(cacheKey, parser);
    }
    return parser;
}
// The actual number parser implementation. Instances of this class are cached
// based on the locale, options, and detected numbering system.
class NumberParserImpl {
    parse(value) {
        // to parse the number, we need to remove anything that isn't actually part of the number, for example we want '-10.40' not '-10.40 USD'
        let fullySanitizedValue = this.sanitize(value);
        if (this.symbols.group) // Remove group characters, and replace decimal points and numerals with ASCII values.
        fullySanitizedValue = replaceAll(fullySanitizedValue, this.symbols.group, "");
        if (this.symbols.decimal) fullySanitizedValue = fullySanitizedValue.replace(this.symbols.decimal, ".");
        if (this.symbols.minusSign) fullySanitizedValue = fullySanitizedValue.replace(this.symbols.minusSign, "-");
        fullySanitizedValue = fullySanitizedValue.replace(this.symbols.numeral, this.symbols.index);
        if (this.options.style === "percent") {
            // javascript is bad at dividing by 100 and maintaining the same significant figures, so perform it on the string before parsing
            let isNegative = fullySanitizedValue.indexOf("-");
            fullySanitizedValue = fullySanitizedValue.replace("-", "");
            let index = fullySanitizedValue.indexOf(".");
            if (index === -1) index = fullySanitizedValue.length;
            fullySanitizedValue = fullySanitizedValue.replace(".", "");
            if (index - 2 === 0) fullySanitizedValue = `0.${fullySanitizedValue}`;
            else if (index - 2 === -1) fullySanitizedValue = `0.0${fullySanitizedValue}`;
            else if (index - 2 === -2) fullySanitizedValue = "0.00";
            else fullySanitizedValue = `${fullySanitizedValue.slice(0, index - 2)}.${fullySanitizedValue.slice(index - 2)}`;
            if (isNegative > -1) fullySanitizedValue = `-${fullySanitizedValue}`;
        }
        let newValue = fullySanitizedValue ? +fullySanitizedValue : NaN;
        if (isNaN(newValue)) return NaN;
        if (this.options.style === "percent") {
            // extra step for rounding percents to what our formatter would output
            let options = {
                ...this.options,
                style: "decimal",
                minimumFractionDigits: Math.min(this.options.minimumFractionDigits + 2, 20),
                maximumFractionDigits: Math.min(this.options.maximumFractionDigits + 2, 20)
            };
            return new NumberParser(this.locale, options).parse(new (0, _numberFormatter.NumberFormatter)(this.locale, options).format(newValue));
        }
        // accounting will always be stripped to a positive number, so if it's accounting and has a () around everything, then we need to make it negative again
        if (this.options.currencySign === "accounting" && CURRENCY_SIGN_REGEX.test(value)) newValue = -1 * newValue;
        return newValue;
    }
    sanitize(value) {
        // Remove literals and whitespace, which are allowed anywhere in the string
        value = value.replace(this.symbols.literals, "");
        // Replace the ASCII minus sign with the minus sign used in the current locale
        // so that both are allowed in case the user's keyboard doesn't have the locale's minus sign.
        if (this.symbols.minusSign) value = value.replace("-", this.symbols.minusSign);
        // In arab numeral system, their decimal character is 1643, but most keyboards don't type that
        // instead they use the , (44) character or apparently the (1548) character.
        if (this.options.numberingSystem === "arab") {
            if (this.symbols.decimal) {
                value = value.replace(",", this.symbols.decimal);
                value = value.replace(String.fromCharCode(1548), this.symbols.decimal);
            }
            if (this.symbols.group) value = replaceAll(value, ".", this.symbols.group);
        }
        // fr-FR group character is char code 8239, but that's not a key on the french keyboard,
        // so allow 'period' as a group char and replace it with a space
        if (this.options.locale === "fr-FR") value = replaceAll(value, ".", String.fromCharCode(8239));
        return value;
    }
    isValidPartialNumber(value, minValue = -Infinity, maxValue = Infinity) {
        value = this.sanitize(value);
        // Remove minus or plus sign, which must be at the start of the string.
        if (this.symbols.minusSign && value.startsWith(this.symbols.minusSign) && minValue < 0) value = value.slice(this.symbols.minusSign.length);
        else if (this.symbols.plusSign && value.startsWith(this.symbols.plusSign) && maxValue > 0) value = value.slice(this.symbols.plusSign.length);
        // Numbers cannot start with a group separator
        if (this.symbols.group && value.startsWith(this.symbols.group)) return false;
        // Numbers that can't have any decimal values fail if a decimal character is typed
        if (this.symbols.decimal && value.indexOf(this.symbols.decimal) > -1 && this.options.maximumFractionDigits === 0) return false;
        // Remove numerals, groups, and decimals
        if (this.symbols.group) value = replaceAll(value, this.symbols.group, "");
        value = value.replace(this.symbols.numeral, "");
        if (this.symbols.decimal) value = value.replace(this.symbols.decimal, "");
        // The number is valid if there are no remaining characters
        return value.length === 0;
    }
    constructor(locale, options = {}){
        this.locale = locale;
        this.formatter = new Intl.NumberFormat(locale, options);
        this.options = this.formatter.resolvedOptions();
        this.symbols = getSymbols(locale, this.formatter, this.options, options);
        var _this_options_minimumFractionDigits, _this_options_maximumFractionDigits;
        if (this.options.style === "percent" && (((_this_options_minimumFractionDigits = this.options.minimumFractionDigits) !== null && _this_options_minimumFractionDigits !== void 0 ? _this_options_minimumFractionDigits : 0) > 18 || ((_this_options_maximumFractionDigits = this.options.maximumFractionDigits) !== null && _this_options_maximumFractionDigits !== void 0 ? _this_options_maximumFractionDigits : 0) > 18)) console.warn("NumberParser cannot handle percentages with greater than 18 decimal places, please reduce the number in your options.");
    }
}
const nonLiteralParts = new Set([
    "decimal",
    "fraction",
    "integer",
    "minusSign",
    "plusSign",
    "group"
]);
// This list is derived from https://www.unicode.org/cldr/charts/43/supplemental/language_plural_rules.html#comparison and includes
// all unique numbers which we need to check in order to determine all the plural forms for a given locale.
// See: https://github.com/adobe/react-spectrum/pull/5134/files#r1337037855 for used script
const pluralNumbers = [
    0,
    4,
    2,
    1,
    11,
    20,
    3,
    7,
    100,
    21,
    0.1,
    1.1
];
function getSymbols(locale, formatter, intlOptions, originalOptions) {
    var _allParts_find, _posAllParts_find, _decimalParts_find, _allParts_find1;
    // formatter needs access to all decimal places in order to generate the correct literal strings for the plural set
    let symbolFormatter = new Intl.NumberFormat(locale, {
        ...intlOptions,
        minimumSignificantDigits: 1,
        maximumSignificantDigits: 21
    });
    // Note: some locale's don't add a group symbol until there is a ten thousands place
    let allParts = symbolFormatter.formatToParts(-10000.111);
    let posAllParts = symbolFormatter.formatToParts(10000.111);
    let pluralParts = pluralNumbers.map((n)=>symbolFormatter.formatToParts(n));
    var _allParts_find_value;
    let minusSign = (_allParts_find_value = (_allParts_find = allParts.find((p)=>p.type === "minusSign")) === null || _allParts_find === void 0 ? void 0 : _allParts_find.value) !== null && _allParts_find_value !== void 0 ? _allParts_find_value : "-";
    let plusSign = (_posAllParts_find = posAllParts.find((p)=>p.type === "plusSign")) === null || _posAllParts_find === void 0 ? void 0 : _posAllParts_find.value;
    // Safari does not support the signDisplay option, but our number parser polyfills it.
    // If no plus sign was returned, but the original options contained signDisplay, default to the '+' character.
    // @ts-ignore
    if (!plusSign && ((originalOptions === null || originalOptions === void 0 ? void 0 : originalOptions.signDisplay) === "exceptZero" || (originalOptions === null || originalOptions === void 0 ? void 0 : originalOptions.signDisplay) === "always")) plusSign = "+";
    // If maximumSignificantDigits is 1 (the minimum) then we won't get decimal characters out of the above formatters
    // Percent also defaults to 0 fractionDigits, so we need to make a new one that isn't percent to get an accurate decimal
    let decimalParts = new Intl.NumberFormat(locale, {
        ...intlOptions,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    }).formatToParts(0.001);
    let decimal = (_decimalParts_find = decimalParts.find((p)=>p.type === "decimal")) === null || _decimalParts_find === void 0 ? void 0 : _decimalParts_find.value;
    let group = (_allParts_find1 = allParts.find((p)=>p.type === "group")) === null || _allParts_find1 === void 0 ? void 0 : _allParts_find1.value;
    // this set is also for a regex, it's all literals that might be in the string we want to eventually parse that
    // don't contribute to the numerical value
    let allPartsLiterals = allParts.filter((p)=>!nonLiteralParts.has(p.type)).map((p)=>escapeRegex(p.value));
    let pluralPartsLiterals = pluralParts.flatMap((p)=>p.filter((p)=>!nonLiteralParts.has(p.type)).map((p)=>escapeRegex(p.value)));
    let sortedLiterals = [
        ...new Set([
            ...allPartsLiterals,
            ...pluralPartsLiterals
        ])
    ].sort((a, b)=>b.length - a.length);
    let literals = sortedLiterals.length === 0 ? new RegExp("[\\p{White_Space}]", "gu") : new RegExp(`${sortedLiterals.join("|")}|[\\p{White_Space}]`, "gu");
    // These are for replacing non-latn characters with the latn equivalent
    let numerals = [
        ...new Intl.NumberFormat(intlOptions.locale, {
            useGrouping: false
        }).format(9876543210)
    ].reverse();
    let indexes = new Map(numerals.map((d, i)=>[
            d,
            i
        ]));
    let numeral = new RegExp(`[${numerals.join("")}]`, "g");
    let index = (d)=>String(indexes.get(d));
    return {
        minusSign,
        plusSign,
        decimal,
        group,
        literals,
        numeral,
        index
    };
}
function replaceAll(str, find, replace) {
    // @ts-ignore
    if (str.replaceAll) // @ts-ignore
    return str.replaceAll(find, replace);
    return str.split(find).join(replace);
}
function escapeRegex(string) {
    return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

},{"./NumberFormatter":"5lQMm","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"bAhV3":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides localized string collation for the current locale. Automatically updates when the locale changes,
 * and handles caching of the collator for performance.
 * @param options - Collator options.
 */ parcelHelpers.export(exports, "useCollator", ()=>useCollator);
var _context = require("./context");
let cache = new Map();
function useCollator(options) {
    let { locale } = (0, _context.useLocale)();
    let cacheKey = locale + (options ? Object.entries(options).sort((a, b)=>a[0] < b[0] ? -1 : 1).join() : "");
    if (cache.has(cacheKey)) return cache.get(cacheKey);
    let formatter = new Intl.Collator(locale, options);
    cache.set(cacheKey, formatter);
    return formatter;
}

},{"./context":"cPMDk","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"fVAwd":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides localized string search functionality that is useful for filtering or matching items
 * in a list. Options can be provided to adjust the sensitivity to case, diacritics, and other parameters.
 */ parcelHelpers.export(exports, "useFilter", ()=>useFilter);
var _react = require("react");
var _useCollator = require("./useCollator");
function useFilter(options) {
    let collator = (0, _useCollator.useCollator)({
        usage: "search",
        ...options
    });
    // TODO(later): these methods don't currently support the ignorePunctuation option.
    let startsWith = (0, _react.useCallback)((string, substring)=>{
        if (substring.length === 0) return true;
        // Normalize both strings so we can slice safely
        // TODO: take into account the ignorePunctuation option as well...
        string = string.normalize("NFC");
        substring = substring.normalize("NFC");
        return collator.compare(string.slice(0, substring.length), substring) === 0;
    }, [
        collator
    ]);
    let endsWith = (0, _react.useCallback)((string, substring)=>{
        if (substring.length === 0) return true;
        string = string.normalize("NFC");
        substring = substring.normalize("NFC");
        return collator.compare(string.slice(-substring.length), substring) === 0;
    }, [
        collator
    ]);
    let contains = (0, _react.useCallback)((string, substring)=>{
        if (substring.length === 0) return true;
        string = string.normalize("NFC");
        substring = substring.normalize("NFC");
        let scan = 0;
        let sliceLen = substring.length;
        for(; scan + sliceLen <= string.length; scan++){
            let slice = string.slice(scan, scan + sliceLen);
            if (collator.compare(substring, slice) === 0) return true;
        }
        return false;
    }, [
        collator
    ]);
    return (0, _react.useMemo)(()=>({
            startsWith,
            endsWith,
            contains
        }), [
        startsWith,
        endsWith,
        contains
    ]);
}

},{"react":"9yzVZ","./useCollator":"bAhV3","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"fsdLZ":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useButton", ()=>(0, _useButton.useButton));
parcelHelpers.export(exports, "useToggleButton", ()=>(0, _useToggleButton.useToggleButton));
var _useButton = require("./useButton");
var _useToggleButton = require("./useToggleButton");

},{"./useButton":"fE8ci","./useToggleButton":"l3jgw","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"fE8ci":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides the behavior and accessibility implementation for a button component. Handles mouse, keyboard, and touch interactions,
 * focus behavior, and ARIA props for both native button elements and custom element types.
 * @param props - Props to be applied to the button.
 * @param ref - A ref to a DOM element for the button.
 */ parcelHelpers.export(exports, "useButton", ()=>useButton);
var _utils = require("@react-aria/utils");
var _focus = require("@react-aria/focus");
var _interactions = require("@react-aria/interactions");
function useButton(props, ref) {
    let { elementType = "button", isDisabled, onPress, onPressStart, onPressEnd, onPressUp, onPressChange, // @ts-ignore - undocumented
    preventFocusOnPress, // @ts-ignore - undocumented
    allowFocusWhenDisabled, // @ts-ignore
    onClick: deprecatedOnClick, href, target, rel, type = "button" } = props;
    let additionalProps;
    if (elementType === "button") additionalProps = {
        type,
        disabled: isDisabled
    };
    else additionalProps = {
        role: "button",
        tabIndex: isDisabled ? undefined : 0,
        href: elementType === "a" && isDisabled ? undefined : href,
        target: elementType === "a" ? target : undefined,
        type: elementType === "input" ? type : undefined,
        disabled: elementType === "input" ? isDisabled : undefined,
        "aria-disabled": !isDisabled || elementType === "input" ? undefined : isDisabled,
        rel: elementType === "a" ? rel : undefined
    };
    let { pressProps, isPressed } = (0, _interactions.usePress)({
        onPressStart,
        onPressEnd,
        onPressChange,
        onPress,
        onPressUp,
        isDisabled,
        preventFocusOnPress,
        ref
    });
    let { focusableProps } = (0, _focus.useFocusable)(props, ref);
    if (allowFocusWhenDisabled) focusableProps.tabIndex = isDisabled ? -1 : focusableProps.tabIndex;
    let buttonProps = (0, _utils.mergeProps)(focusableProps, pressProps, (0, _utils.filterDOMProps)(props, {
        labelable: true
    }));
    return {
        isPressed,
        buttonProps: (0, _utils.mergeProps)(additionalProps, buttonProps, {
            "aria-haspopup": props["aria-haspopup"],
            "aria-expanded": props["aria-expanded"],
            "aria-controls": props["aria-controls"],
            "aria-pressed": props["aria-pressed"],
            onClick: (e)=>{
                if (deprecatedOnClick) {
                    deprecatedOnClick(e);
                    console.warn("onClick is deprecated, please use onPress");
                }
            }
        })
    };
}

},{"@react-aria/utils":"9cLk5","@react-aria/focus":"42mbF","@react-aria/interactions":"ky3G8","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"l3jgw":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides the behavior and accessibility implementation for a toggle button component.
 * ToggleButtons allow users to toggle a selection on or off, for example switching between two states or modes.
 */ parcelHelpers.export(exports, "useToggleButton", ()=>useToggleButton);
var _useButton = require("./useButton");
var _utils = require("@react-aria/utils");
function useToggleButton(props, state, ref) {
    const { isSelected } = state;
    const { isPressed, buttonProps } = (0, _useButton.useButton)({
        ...props,
        onPress: (0, _utils.chain)(state.toggle, props.onPress)
    }, ref);
    return {
        isPressed,
        buttonProps: (0, _utils.mergeProps)(buttonProps, {
            "aria-pressed": isSelected
        })
    };
}

},{"./useButton":"fE8ci","@react-aria/utils":"9cLk5","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"98n7T":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useCalendar", ()=>(0, _useCalendar.useCalendar));
parcelHelpers.export(exports, "useRangeCalendar", ()=>(0, _useRangeCalendar.useRangeCalendar));
parcelHelpers.export(exports, "useCalendarGrid", ()=>(0, _useCalendarGrid.useCalendarGrid));
parcelHelpers.export(exports, "useCalendarCell", ()=>(0, _useCalendarCell.useCalendarCell));
var _useCalendar = require("./useCalendar");
var _useRangeCalendar = require("./useRangeCalendar");
var _useCalendarGrid = require("./useCalendarGrid");
var _useCalendarCell = require("./useCalendarCell");

},{"./useCalendar":"6wRnc","./useRangeCalendar":"9Fa9w","./useCalendarGrid":"gEFSZ","./useCalendarCell":"d0B8w","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"6wRnc":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides the behavior and accessibility implementation for a calendar component.
 * A calendar displays one or more date grids and allows users to select a single date.
 */ parcelHelpers.export(exports, "useCalendar", ()=>useCalendar);
var _useCalendarBase = require("./useCalendarBase");
function useCalendar(props, state) {
    return (0, _useCalendarBase.useCalendarBase)(props, state);
}

},{"./useCalendarBase":"iGNGX","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"iGNGX":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useCalendarBase", ()=>useCalendarBase);
var _liveAnnouncer = require("@react-aria/live-announcer");
var _utils = require("@react-aria/utils");
var _utils1 = require("./utils");
// @ts-ignore
var _json = require("../intl/*.json");
var _jsonDefault = parcelHelpers.interopDefault(_json);
var _i18N = require("@react-aria/i18n");
var _react = require("react");
function useCalendarBase(props, state) {
    let stringFormatter = (0, _i18N.useLocalizedStringFormatter)((0, _jsonDefault.default), "@react-aria/calendar");
    let domProps = (0, _utils.filterDOMProps)(props);
    let title = (0, _utils1.useVisibleRangeDescription)(state.visibleRange.start, state.visibleRange.end, state.timeZone, false);
    let visibleRangeDescription = (0, _utils1.useVisibleRangeDescription)(state.visibleRange.start, state.visibleRange.end, state.timeZone, true);
    // Announce when the visible date range changes
    (0, _utils.useUpdateEffect)(()=>{
        // only when pressing the Previous or Next button
        if (!state.isFocused) (0, _liveAnnouncer.announce)(visibleRangeDescription);
    }, [
        visibleRangeDescription
    ]);
    // Announce when the selected value changes
    let selectedDateDescription = (0, _utils1.useSelectedDateDescription)(state);
    (0, _utils.useUpdateEffect)(()=>{
        if (selectedDateDescription) (0, _liveAnnouncer.announce)(selectedDateDescription, "polite", 4000);
    // handle an update to the caption that describes the currently selected range, to announce the new value
    }, [
        selectedDateDescription
    ]);
    let errorMessageId = (0, _utils.useSlotId)([
        Boolean(props.errorMessage),
        props.isInvalid,
        props.validationState
    ]);
    // Pass the label to the child grid elements.
    (0, _utils1.hookData).set(state, {
        ariaLabel: props["aria-label"],
        ariaLabelledBy: props["aria-labelledby"],
        errorMessageId,
        selectedDateDescription
    });
    // If the next or previous buttons become disabled while they are focused, move focus to the calendar body.
    let [nextFocused, setNextFocused] = (0, _react.useState)(false);
    let nextDisabled = props.isDisabled || state.isNextVisibleRangeInvalid();
    if (nextDisabled && nextFocused) {
        setNextFocused(false);
        state.setFocused(true);
    }
    let [previousFocused, setPreviousFocused] = (0, _react.useState)(false);
    let previousDisabled = props.isDisabled || state.isPreviousVisibleRangeInvalid();
    if (previousDisabled && previousFocused) {
        setPreviousFocused(false);
        state.setFocused(true);
    }
    let labelProps = (0, _utils.useLabels)({
        id: props["id"],
        "aria-label": [
            props["aria-label"],
            visibleRangeDescription
        ].filter(Boolean).join(", "),
        "aria-labelledby": props["aria-labelledby"]
    });
    return {
        calendarProps: (0, _utils.mergeProps)(domProps, labelProps, {
            role: "application",
            "aria-describedby": props["aria-describedby"] || undefined
        }),
        nextButtonProps: {
            onPress: ()=>state.focusNextPage(),
            "aria-label": stringFormatter.format("next"),
            isDisabled: nextDisabled,
            onFocusChange: setNextFocused
        },
        prevButtonProps: {
            onPress: ()=>state.focusPreviousPage(),
            "aria-label": stringFormatter.format("previous"),
            isDisabled: previousDisabled,
            onFocusChange: setPreviousFocused
        },
        errorMessageProps: {
            id: errorMessageId
        },
        title
    };
}

},{"@react-aria/live-announcer":"ipdGY","@react-aria/utils":"9cLk5","./utils":"l7BLF","../intl/*.json":"gIddJ","@react-aria/i18n":"411rg","react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"ipdGY":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "announce", ()=>(0, _liveAnnouncer.announce));
parcelHelpers.export(exports, "clearAnnouncer", ()=>(0, _liveAnnouncer.clearAnnouncer));
parcelHelpers.export(exports, "destroyAnnouncer", ()=>(0, _liveAnnouncer.destroyAnnouncer));
var _liveAnnouncer = require("./LiveAnnouncer");

},{"./LiveAnnouncer":"dmQuK","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"dmQuK":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Announces the message using screen reader technology.
 */ parcelHelpers.export(exports, "announce", ()=>announce);
/**
 * Stops all queued announcements.
 */ parcelHelpers.export(exports, "clearAnnouncer", ()=>clearAnnouncer);
/**
 * Removes the announcer from the DOM.
 */ parcelHelpers.export(exports, "destroyAnnouncer", ()=>destroyAnnouncer);
/* Inspired by https://github.com/AlmeroSteyn/react-aria-live */ const LIVEREGION_TIMEOUT_DELAY = 7000;
let liveAnnouncer = null;
function announce(message, assertiveness = "assertive", timeout = LIVEREGION_TIMEOUT_DELAY) {
    if (!liveAnnouncer) liveAnnouncer = new LiveAnnouncer();
    liveAnnouncer.announce(message, assertiveness, timeout);
}
function clearAnnouncer(assertiveness) {
    if (liveAnnouncer) liveAnnouncer.clear(assertiveness);
}
function destroyAnnouncer() {
    if (liveAnnouncer) {
        liveAnnouncer.destroy();
        liveAnnouncer = null;
    }
}
// LiveAnnouncer is implemented using vanilla DOM, not React. That's because as of React 18
// ReactDOM.render is deprecated, and the replacement, ReactDOM.createRoot is moved into a
// subpath import `react-dom/client`. That makes it hard for us to support multiple React versions.
// As a global API, we can't use portals without introducing a breaking API change. LiveAnnouncer
// is simple enough to implement without React, so that's what we do here.
// See this discussion for more details: https://github.com/reactwg/react-18/discussions/125#discussioncomment-2382638
class LiveAnnouncer {
    createLog(ariaLive) {
        let node = document.createElement("div");
        node.setAttribute("role", "log");
        node.setAttribute("aria-live", ariaLive);
        node.setAttribute("aria-relevant", "additions");
        return node;
    }
    destroy() {
        if (!this.node) return;
        document.body.removeChild(this.node);
        this.node = null;
    }
    announce(message, assertiveness = "assertive", timeout = LIVEREGION_TIMEOUT_DELAY) {
        if (!this.node) return;
        let node = document.createElement("div");
        node.textContent = message;
        if (assertiveness === "assertive") this.assertiveLog.appendChild(node);
        else this.politeLog.appendChild(node);
        if (message !== "") setTimeout(()=>{
            node.remove();
        }, timeout);
    }
    clear(assertiveness) {
        if (!this.node) return;
        if (!assertiveness || assertiveness === "assertive") this.assertiveLog.innerHTML = "";
        if (!assertiveness || assertiveness === "polite") this.politeLog.innerHTML = "";
    }
    constructor(){
        this.node = document.createElement("div");
        this.node.dataset.liveAnnouncer = "true";
        // copied from VisuallyHidden
        Object.assign(this.node.style, {
            border: 0,
            clip: "rect(0 0 0 0)",
            clipPath: "inset(50%)",
            height: "1px",
            margin: "-1px",
            overflow: "hidden",
            padding: 0,
            position: "absolute",
            width: "1px",
            whiteSpace: "nowrap"
        });
        this.assertiveLog = this.createLog("assertive");
        this.node.appendChild(this.assertiveLog);
        this.politeLog = this.createLog("polite");
        this.node.appendChild(this.politeLog);
        document.body.prepend(this.node);
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"l7BLF":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hookData", ()=>hookData);
parcelHelpers.export(exports, "getEraFormat", ()=>getEraFormat);
parcelHelpers.export(exports, "useSelectedDateDescription", ()=>useSelectedDateDescription);
parcelHelpers.export(exports, "useVisibleRangeDescription", ()=>useVisibleRangeDescription);
var _date = require("@internationalized/date");
// @ts-ignore
var _json = require("../intl/*.json");
var _jsonDefault = parcelHelpers.interopDefault(_json);
var _i18N = require("@react-aria/i18n");
var _react = require("react");
const hookData = new WeakMap();
function getEraFormat(date) {
    return (date === null || date === void 0 ? void 0 : date.calendar.identifier) === "gregory" && date.era === "BC" ? "short" : undefined;
}
function useSelectedDateDescription(state) {
    let stringFormatter = (0, _i18N.useLocalizedStringFormatter)((0, _jsonDefault.default), "@react-aria/calendar");
    let start, end;
    if ("highlightedRange" in state) ({ start, end } = state.highlightedRange || {});
    else start = end = state.value;
    let dateFormatter = (0, _i18N.useDateFormatter)({
        weekday: "long",
        month: "long",
        year: "numeric",
        day: "numeric",
        era: getEraFormat(start) || getEraFormat(end),
        timeZone: state.timeZone
    });
    let anchorDate = "anchorDate" in state ? state.anchorDate : null;
    return (0, _react.useMemo)(()=>{
        // No message if currently selecting a range, or there is nothing highlighted.
        if (!anchorDate && start && end) {
            // Use a single date message if the start and end dates are the same day,
            // otherwise include both dates.
            if ((0, _date.isSameDay)(start, end)) {
                let date = dateFormatter.format(start.toDate(state.timeZone));
                return stringFormatter.format("selectedDateDescription", {
                    date
                });
            } else {
                let dateRange = formatRange(dateFormatter, stringFormatter, start, end, state.timeZone);
                return stringFormatter.format("selectedRangeDescription", {
                    dateRange
                });
            }
        }
        return "";
    }, [
        start,
        end,
        anchorDate,
        state.timeZone,
        stringFormatter,
        dateFormatter
    ]);
}
function useVisibleRangeDescription(startDate, endDate, timeZone, isAria) {
    let stringFormatter = (0, _i18N.useLocalizedStringFormatter)((0, _jsonDefault.default), "@react-aria/calendar");
    let era = getEraFormat(startDate) || getEraFormat(endDate);
    let monthFormatter = (0, _i18N.useDateFormatter)({
        month: "long",
        year: "numeric",
        era,
        calendar: startDate.calendar.identifier,
        timeZone
    });
    let dateFormatter = (0, _i18N.useDateFormatter)({
        month: "long",
        year: "numeric",
        day: "numeric",
        era,
        calendar: startDate.calendar.identifier,
        timeZone
    });
    return (0, _react.useMemo)(()=>{
        // Special case for month granularity. Format as a single month if only a
        // single month is visible, otherwise format as a range of months.
        if ((0, _date.isSameDay)(startDate, (0, _date.startOfMonth)(startDate))) {
            if ((0, _date.isSameDay)(endDate, (0, _date.endOfMonth)(startDate))) return monthFormatter.format(startDate.toDate(timeZone));
            else if ((0, _date.isSameDay)(endDate, (0, _date.endOfMonth)(endDate))) return isAria ? formatRange(monthFormatter, stringFormatter, startDate, endDate, timeZone) : monthFormatter.formatRange(startDate.toDate(timeZone), endDate.toDate(timeZone));
        }
        return isAria ? formatRange(dateFormatter, stringFormatter, startDate, endDate, timeZone) : dateFormatter.formatRange(startDate.toDate(timeZone), endDate.toDate(timeZone));
    }, [
        startDate,
        endDate,
        monthFormatter,
        dateFormatter,
        stringFormatter,
        timeZone,
        isAria
    ]);
}
function formatRange(dateFormatter, stringFormatter, start, end, timeZone) {
    let parts = dateFormatter.formatRangeToParts(start.toDate(timeZone), end.toDate(timeZone));
    // Find the separator between the start and end date. This is determined
    // by finding the last shared literal before the end range.
    let separatorIndex = -1;
    for(let i = 0; i < parts.length; i++){
        let part = parts[i];
        if (part.source === "shared" && part.type === "literal") separatorIndex = i;
        else if (part.source === "endRange") break;
    }
    // Now we can combine the parts into start and end strings.
    let startValue = "";
    let endValue = "";
    for(let i = 0; i < parts.length; i++){
        if (i < separatorIndex) startValue += parts[i].value;
        else if (i > separatorIndex) endValue += parts[i].value;
    }
    return stringFormatter.format("dateRange", {
        startDate: startValue,
        endDate: endValue
    });
}

},{"@internationalized/date":"hesBk","../intl/*.json":"gIddJ","@react-aria/i18n":"411rg","react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"gIddJ":[function(require,module,exports) {
const _temp0 = require("fabeed0a0435c9de");
const _temp1 = require("dd10b3c8b09351c9");
const _temp2 = require("7b3b516cb5aec01a");
const _temp3 = require("72459eb739d4dcf2");
const _temp4 = require("6499b48fb333476");
const _temp5 = require("2176029c30f177c5");
const _temp6 = require("81aab66f0b8d4bc9");
const _temp7 = require("208e1ee1ae5d788");
const _temp8 = require("a5a7314086e9d2e9");
const _temp9 = require("9f59ee676a952a65");
const _temp10 = require("7f76614a35070b33");
const _temp11 = require("d3c0ebb9214a0bd1");
const _temp12 = require("ffd2c5b51d8ad5b8");
const _temp13 = require("32fe949349919c34");
const _temp14 = require("d27ef03146717e4e");
const _temp15 = require("26e47c578e0e320f");
const _temp16 = require("87290f4c67834a03");
const _temp17 = require("340eb4bea6f7f4ec");
const _temp18 = require("66e091c23b633623");
const _temp19 = require("f9d6646be40c76b6");
const _temp20 = require("5286d02ef60bfdac");
const _temp21 = require("c49cc919f0f59889");
const _temp22 = require("2731d6cd889cf8b2");
const _temp23 = require("8ac9b6dfb26d24d1");
const _temp24 = require("103133bd6e6242ee");
const _temp25 = require("915e6bc3c0dc08d");
const _temp26 = require("b0c8767776992a21");
const _temp27 = require("1d43dbca0aa2b20b");
const _temp28 = require("d0d5d3d21881633a");
const _temp29 = require("6c768192bc92987e");
const _temp30 = require("d59a0610c5877f1");
const _temp31 = require("803be6faf6a63dfe");
const _temp32 = require("3caf2afe68ba935f");
const _temp33 = require("1eb0d86a07344ff8");
module.exports = {
    "ar-AE": _temp0,
    "bg-BG": _temp1,
    "cs-CZ": _temp2,
    "da-DK": _temp3,
    "de-DE": _temp4,
    "el-GR": _temp5,
    "en-US": _temp6,
    "es-ES": _temp7,
    "et-EE": _temp8,
    "fi-FI": _temp9,
    "fr-FR": _temp10,
    "he-IL": _temp11,
    "hr-HR": _temp12,
    "hu-HU": _temp13,
    "it-IT": _temp14,
    "ja-JP": _temp15,
    "ko-KR": _temp16,
    "lt-LT": _temp17,
    "lv-LV": _temp18,
    "nb-NO": _temp19,
    "nl-NL": _temp20,
    "pl-PL": _temp21,
    "pt-BR": _temp22,
    "pt-PT": _temp23,
    "ro-RO": _temp24,
    "ru-RU": _temp25,
    "sk-SK": _temp26,
    "sl-SI": _temp27,
    "sr-SP": _temp28,
    "sv-SE": _temp29,
    "tr-TR": _temp30,
    "uk-UA": _temp31,
    "zh-CN": _temp32,
    "zh-TW": _temp33
};

},{"fabeed0a0435c9de":"Wm153","dd10b3c8b09351c9":"iYXoP","7b3b516cb5aec01a":"aqfeB","72459eb739d4dcf2":"56OQ4","6499b48fb333476":"a9Kp7","2176029c30f177c5":"hHVsg","81aab66f0b8d4bc9":"eHAfK","208e1ee1ae5d788":"dswwv","a5a7314086e9d2e9":"gOTp0","9f59ee676a952a65":"jsmug","7f76614a35070b33":"kAeRm","d3c0ebb9214a0bd1":"fTGFf","ffd2c5b51d8ad5b8":"lPj1U","32fe949349919c34":"52Cqb","d27ef03146717e4e":"eGZdL","26e47c578e0e320f":"1ryrC","87290f4c67834a03":"fqG8s","340eb4bea6f7f4ec":"3vFdZ","66e091c23b633623":"jAlvh","f9d6646be40c76b6":"cN9Iv","5286d02ef60bfdac":"140UE","c49cc919f0f59889":"kBHrn","2731d6cd889cf8b2":"ikHr8","8ac9b6dfb26d24d1":"8ubTq","103133bd6e6242ee":"1ofMh","915e6bc3c0dc08d":"k32tb","b0c8767776992a21":"g0kUE","1d43dbca0aa2b20b":"2IAmC","d0d5d3d21881633a":"2p4xf","6c768192bc92987e":"2yt58","d59a0610c5877f1":"iq4Ti","803be6faf6a63dfe":"6uhFp","3caf2afe68ba935f":"4SsP1","1eb0d86a07344ff8":"9d2oU"}],"Wm153":[function(require,module,exports) {
module.exports = {
    "dateRange": (args)=>`${args.startDate} \u{625}\u{644}\u{649} ${args.endDate}`,
    "dateSelected": (args)=>`${args.date} \u{627}\u{644}\u{645}\u{62D}\u{62F}\u{62F}`,
    "finishRangeSelectionPrompt": `\u{627}\u{646}\u{642}\u{631} \u{644}\u{625}\u{646}\u{647}\u{627}\u{621} \u{639}\u{645}\u{644}\u{64A}\u{629} \u{62A}\u{62D}\u{62F}\u{64A}\u{62F} \u{646}\u{637}\u{627}\u{642} \u{627}\u{644}\u{62A}\u{627}\u{631}\u{64A}\u{62E}`,
    "maximumDate": `\u{622}\u{62E}\u{631} \u{62A}\u{627}\u{631}\u{64A}\u{62E} \u{645}\u{62A}\u{627}\u{62D}`,
    "minimumDate": `\u{623}\u{648}\u{644} \u{62A}\u{627}\u{631}\u{64A}\u{62E} \u{645}\u{62A}\u{627}\u{62D}`,
    "next": `\u{627}\u{644}\u{62A}\u{627}\u{644}\u{64A}`,
    "previous": `\u{627}\u{644}\u{633}\u{627}\u{628}\u{642}`,
    "selectedDateDescription": (args)=>`\u{62A}\u{627}\u{631}\u{64A}\u{62E} \u{645}\u{62D}\u{62F}\u{62F}: ${args.date}`,
    "selectedRangeDescription": (args)=>`\u{627}\u{644}\u{645}\u{62F}\u{649} \u{627}\u{644}\u{632}\u{645}\u{646}\u{64A} \u{627}\u{644}\u{645}\u{62D}\u{62F}\u{62F}: ${args.dateRange}`,
    "startRangeSelectionPrompt": `\u{627}\u{646}\u{642}\u{631} \u{644}\u{628}\u{62F}\u{621} \u{639}\u{645}\u{644}\u{64A}\u{629} \u{62A}\u{62D}\u{62F}\u{64A}\u{62F} \u{646}\u{637}\u{627}\u{642} \u{627}\u{644}\u{62A}\u{627}\u{631}\u{64A}\u{62E}`,
    "todayDate": (args)=>`\u{627}\u{644}\u{64A}\u{648}\u{645}\u{60C} ${args.date}`,
    "todayDateSelected": (args)=>`\u{627}\u{644}\u{64A}\u{648}\u{645}\u{60C} ${args.date} \u{645}\u{62D}\u{62F}\u{62F}`
};

},{}],"iYXoP":[function(require,module,exports) {
module.exports = {
    "dateRange": (args)=>`${args.startDate} \u{434}\u{43E} ${args.endDate}`,
    "dateSelected": (args)=>`\u{418}\u{437}\u{431}\u{440}\u{430}\u{43D}\u{43E} \u{435} ${args.date}`,
    "finishRangeSelectionPrompt": `\u{41D}\u{430}\u{442}\u{438}\u{441}\u{43D}\u{435}\u{442}\u{435}, \u{437}\u{430} \u{434}\u{430} \u{434}\u{43E}\u{432}\u{44A}\u{440}\u{448}\u{438}\u{442}\u{435} \u{438}\u{437}\u{431}\u{43E}\u{440}\u{430} \u{43D}\u{430} \u{432}\u{440}\u{435}\u{43C}\u{435}\u{432}\u{438} \u{438}\u{43D}\u{442}\u{435}\u{440}\u{432}\u{430}\u{43B}`,
    "maximumDate": `\u{41F}\u{43E}\u{441}\u{43B}\u{435}\u{434}\u{43D}\u{430} \u{43D}\u{430}\u{43B}\u{438}\u{447}\u{43D}\u{430} \u{434}\u{430}\u{442}\u{430}`,
    "minimumDate": `\u{41F}\u{44A}\u{440}\u{432}\u{430} \u{43D}\u{430}\u{43B}\u{438}\u{447}\u{43D}\u{430} \u{434}\u{430}\u{442}\u{430}`,
    "next": `\u{41D}\u{430}\u{43F}\u{440}\u{435}\u{434}`,
    "previous": `\u{41D}\u{430}\u{437}\u{430}\u{434}`,
    "selectedDateDescription": (args)=>`\u{418}\u{437}\u{431}\u{440}\u{430}\u{43D}\u{430} \u{434}\u{430}\u{442}\u{430}: ${args.date}`,
    "selectedRangeDescription": (args)=>`\u{418}\u{437}\u{431}\u{440}\u{430}\u{43D} \u{434}\u{438}\u{430}\u{43F}\u{430}\u{437}\u{43E}\u{43D}: ${args.dateRange}`,
    "startRangeSelectionPrompt": `\u{41D}\u{430}\u{442}\u{438}\u{441}\u{43D}\u{435}\u{442}\u{435}, \u{437}\u{430} \u{434}\u{430} \u{43F}\u{440}\u{438}\u{441}\u{442}\u{44A}\u{43F}\u{438}\u{442}\u{435} \u{43A}\u{44A}\u{43C} \u{438}\u{437}\u{431}\u{43E}\u{440}\u{430} \u{43D}\u{430} \u{432}\u{440}\u{435}\u{43C}\u{435}\u{432}\u{438} \u{438}\u{43D}\u{442}\u{435}\u{440}\u{432}\u{430}\u{43B}`,
    "todayDate": (args)=>`\u{414}\u{43D}\u{435}\u{441}, ${args.date}`,
    "todayDateSelected": (args)=>`\u{414}\u{43D}\u{435}\u{441}, ${args.date} \u{441}\u{430} \u{438}\u{437}\u{431}\u{440}\u{430}\u{43D}\u{438}`
};

},{}],"aqfeB":[function(require,module,exports) {
module.exports = {
    "dateRange": (args)=>`${args.startDate} a\u{17E} ${args.endDate}`,
    "dateSelected": (args)=>`Vybr\xe1no ${args.date}`,
    "finishRangeSelectionPrompt": `Kliknut\xedm dokon\u{10D}\xedte v\xfdb\u{11B}r rozsahu dat`,
    "maximumDate": `Posledn\xed dostupn\xe9 datum`,
    "minimumDate": `Prvn\xed dostupn\xe9 datum`,
    "next": `Dal\u{161}\xed`,
    "previous": `P\u{159}edchoz\xed`,
    "selectedDateDescription": (args)=>`Vybran\xe9 datum: ${args.date}`,
    "selectedRangeDescription": (args)=>`Vybran\xe9 obdob\xed: ${args.dateRange}`,
    "startRangeSelectionPrompt": `Kliknut\xedm zah\xe1j\xedte v\xfdb\u{11B}r rozsahu dat`,
    "todayDate": (args)=>`Dnes, ${args.date}`,
    "todayDateSelected": (args)=>`Dnes, vybr\xe1no ${args.date}`
};

},{}],"56OQ4":[function(require,module,exports) {
module.exports = {
    "dateRange": (args)=>`${args.startDate} til ${args.endDate}`,
    "dateSelected": (args)=>`${args.date} valgt`,
    "finishRangeSelectionPrompt": `Klik for at fuldf\xf8re valg af datoomr\xe5de`,
    "maximumDate": `Sidste ledige dato`,
    "minimumDate": `F\xf8rste ledige dato`,
    "next": `N\xe6ste`,
    "previous": `Forrige`,
    "selectedDateDescription": (args)=>`Valgt dato: ${args.date}`,
    "selectedRangeDescription": (args)=>`Valgt interval: ${args.dateRange}`,
    "startRangeSelectionPrompt": `Klik for at starte valg af datoomr\xe5de`,
    "todayDate": (args)=>`I dag, ${args.date}`,
    "todayDateSelected": (args)=>`I dag, ${args.date} valgt`
};

},{}],"a9Kp7":[function(require,module,exports) {
module.exports = {
    "dateRange": (args)=>`${args.startDate} bis ${args.endDate}`,
    "dateSelected": (args)=>`${args.date} ausgew\xe4hlt`,
    "finishRangeSelectionPrompt": `Klicken, um die Auswahl des Datumsbereichs zu beenden`,
    "maximumDate": `Letztes verf\xfcgbares Datum`,
    "minimumDate": `Erstes verf\xfcgbares Datum`,
    "next": `Weiter`,
    "previous": `Zur\xfcck`,
    "selectedDateDescription": (args)=>`Ausgew\xe4hltes Datum: ${args.date}`,
    "selectedRangeDescription": (args)=>`Ausgew\xe4hlter Bereich: ${args.dateRange}`,
    "startRangeSelectionPrompt": `Klicken, um die Auswahl des Datumsbereichs zu beginnen`,
    "todayDate": (args)=>`Heute, ${args.date}`,
    "todayDateSelected": (args)=>`Heute, ${args.date} ausgew\xe4hlt`
};

},{}],"hHVsg":[function(require,module,exports) {
module.exports = {
    "dateRange": (args)=>`${args.startDate} \u{3AD}\u{3C9}\u{3C2} ${args.endDate}`,
    "dateSelected": (args)=>`\u{395}\u{3C0}\u{3B9}\u{3BB}\u{3AD}\u{3C7}\u{3B8}\u{3B7}\u{3BA}\u{3B5} ${args.date}`,
    "finishRangeSelectionPrompt": `\u{39A}\u{3AC}\u{3BD}\u{3C4}\u{3B5} \u{3BA}\u{3BB}\u{3B9}\u{3BA} \u{3B3}\u{3B9}\u{3B1} \u{3BD}\u{3B1} \u{3BF}\u{3BB}\u{3BF}\u{3BA}\u{3BB}\u{3B7}\u{3C1}\u{3CE}\u{3C3}\u{3B5}\u{3C4}\u{3B5} \u{3C4}\u{3B7}\u{3BD} \u{3B5}\u{3C0}\u{3B9}\u{3BB}\u{3BF}\u{3B3}\u{3AE} \u{3B5}\u{3CD}\u{3C1}\u{3BF}\u{3C5}\u{3C2} \u{3B7}\u{3BC}\u{3B5}\u{3C1}\u{3BF}\u{3BC}\u{3B7}\u{3BD}\u{3B9}\u{3CE}\u{3BD}`,
    "maximumDate": `\u{3A4}\u{3B5}\u{3BB}\u{3B5}\u{3C5}\u{3C4}\u{3B1}\u{3AF}\u{3B1} \u{3B4}\u{3B9}\u{3B1}\u{3B8}\u{3AD}\u{3C3}\u{3B9}\u{3BC}\u{3B7} \u{3B7}\u{3BC}\u{3B5}\u{3C1}\u{3BF}\u{3BC}\u{3B7}\u{3BD}\u{3AF}\u{3B1}`,
    "minimumDate": `\u{3A0}\u{3C1}\u{3CE}\u{3C4}\u{3B7} \u{3B4}\u{3B9}\u{3B1}\u{3B8}\u{3AD}\u{3C3}\u{3B9}\u{3BC}\u{3B7} \u{3B7}\u{3BC}\u{3B5}\u{3C1}\u{3BF}\u{3BC}\u{3B7}\u{3BD}\u{3AF}\u{3B1}`,
    "next": `\u{395}\u{3C0}\u{3CC}\u{3BC}\u{3B5}\u{3BD}\u{3BF}`,
    "previous": `\u{3A0}\u{3C1}\u{3BF}\u{3B7}\u{3B3}\u{3BF}\u{3CD}\u{3BC}\u{3B5}\u{3BD}\u{3BF}`,
    "selectedDateDescription": (args)=>`\u{395}\u{3C0}\u{3B9}\u{3BB}\u{3B5}\u{3B3}\u{3BC}\u{3AD}\u{3BD}\u{3B7} \u{3B7}\u{3BC}\u{3B5}\u{3C1}\u{3BF}\u{3BC}\u{3B7}\u{3BD}\u{3AF}\u{3B1}: ${args.date}`,
    "selectedRangeDescription": (args)=>`\u{395}\u{3C0}\u{3B9}\u{3BB}\u{3B5}\u{3B3}\u{3BC}\u{3AD}\u{3BD}\u{3BF} \u{3B5}\u{3CD}\u{3C1}\u{3BF}\u{3C2}: ${args.dateRange}`,
    "startRangeSelectionPrompt": `\u{39A}\u{3AC}\u{3BD}\u{3C4}\u{3B5} \u{3BA}\u{3BB}\u{3B9}\u{3BA} \u{3B3}\u{3B9}\u{3B1} \u{3BD}\u{3B1} \u{3BE}\u{3B5}\u{3BA}\u{3B9}\u{3BD}\u{3AE}\u{3C3}\u{3B5}\u{3C4}\u{3B5} \u{3C4}\u{3B7}\u{3BD} \u{3B5}\u{3C0}\u{3B9}\u{3BB}\u{3BF}\u{3B3}\u{3AE} \u{3B5}\u{3CD}\u{3C1}\u{3BF}\u{3C5}\u{3C2} \u{3B7}\u{3BC}\u{3B5}\u{3C1}\u{3BF}\u{3BC}\u{3B7}\u{3BD}\u{3B9}\u{3CE}\u{3BD}`,
    "todayDate": (args)=>`\u{3A3}\u{3AE}\u{3BC}\u{3B5}\u{3C1}\u{3B1}, ${args.date}`,
    "todayDateSelected": (args)=>`\u{3A3}\u{3AE}\u{3BC}\u{3B5}\u{3C1}\u{3B1}, \u{3B5}\u{3C0}\u{3B9}\u{3BB}\u{3AD}\u{3C7}\u{3C4}\u{3B7}\u{3BA}\u{3B5} ${args.date}`
};

},{}],"eHAfK":[function(require,module,exports) {
module.exports = {
    "previous": `Previous`,
    "next": `Next`,
    "selectedDateDescription": (args)=>`Selected Date: ${args.date}`,
    "selectedRangeDescription": (args)=>`Selected Range: ${args.dateRange}`,
    "todayDate": (args)=>`Today, ${args.date}`,
    "todayDateSelected": (args)=>`Today, ${args.date} selected`,
    "dateSelected": (args)=>`${args.date} selected`,
    "startRangeSelectionPrompt": `Click to start selecting date range`,
    "finishRangeSelectionPrompt": `Click to finish selecting date range`,
    "minimumDate": `First available date`,
    "maximumDate": `Last available date`,
    "dateRange": (args)=>`${args.startDate} to ${args.endDate}`
};

},{}],"dswwv":[function(require,module,exports) {
module.exports = {
    "dateRange": (args)=>`${args.startDate} a ${args.endDate}`,
    "dateSelected": (args)=>`${args.date} seleccionado`,
    "finishRangeSelectionPrompt": `Haga clic para terminar de seleccionar rango de fechas`,
    "maximumDate": `\xdaltima fecha disponible`,
    "minimumDate": `Primera fecha disponible`,
    "next": `Siguiente`,
    "previous": `Anterior`,
    "selectedDateDescription": (args)=>`Fecha seleccionada: ${args.date}`,
    "selectedRangeDescription": (args)=>`Intervalo seleccionado: ${args.dateRange}`,
    "startRangeSelectionPrompt": `Haga clic para comenzar a seleccionar un rango de fechas`,
    "todayDate": (args)=>`Hoy, ${args.date}`,
    "todayDateSelected": (args)=>`Hoy, ${args.date} seleccionado`
};

},{}],"gOTp0":[function(require,module,exports) {
module.exports = {
    "dateRange": (args)=>`${args.startDate} kuni ${args.endDate}`,
    "dateSelected": (args)=>`${args.date} valitud`,
    "finishRangeSelectionPrompt": `Kl\xf5psake kuup\xe4evavahemiku valimise l\xf5petamiseks`,
    "maximumDate": `Viimane saadaolev kuup\xe4ev`,
    "minimumDate": `Esimene saadaolev kuup\xe4ev`,
    "next": `J\xe4rgmine`,
    "previous": `Eelmine`,
    "selectedDateDescription": (args)=>`Valitud kuup\xe4ev: ${args.date}`,
    "selectedRangeDescription": (args)=>`Valitud vahemik: ${args.dateRange}`,
    "startRangeSelectionPrompt": `Kl\xf5psake kuup\xe4evavahemiku valimiseks`,
    "todayDate": (args)=>`T\xe4na, ${args.date}`,
    "todayDateSelected": (args)=>`T\xe4na, ${args.date} valitud`
};

},{}],"jsmug":[function(require,module,exports) {
module.exports = {
    "dateRange": (args)=>`${args.startDate} \u{2013} ${args.endDate}`,
    "dateSelected": (args)=>`${args.date} valittu`,
    "finishRangeSelectionPrompt": `Lopeta p\xe4iv\xe4m\xe4\xe4r\xe4alueen valinta napsauttamalla t\xe4t\xe4.`,
    "maximumDate": `Viimeinen varattavissa oleva p\xe4iv\xe4m\xe4\xe4r\xe4`,
    "minimumDate": `Ensimm\xe4inen varattavissa oleva p\xe4iv\xe4m\xe4\xe4r\xe4`,
    "next": `Seuraava`,
    "previous": `Edellinen`,
    "selectedDateDescription": (args)=>`Valittu p\xe4iv\xe4m\xe4\xe4r\xe4: ${args.date}`,
    "selectedRangeDescription": (args)=>`Valittu aikav\xe4li: ${args.dateRange}`,
    "startRangeSelectionPrompt": `Aloita p\xe4iv\xe4m\xe4\xe4r\xe4alueen valinta napsauttamalla t\xe4t\xe4.`,
    "todayDate": (args)=>`T\xe4n\xe4\xe4n, ${args.date}`,
    "todayDateSelected": (args)=>`T\xe4n\xe4\xe4n, ${args.date} valittu`
};

},{}],"kAeRm":[function(require,module,exports) {
module.exports = {
    "dateRange": (args)=>`${args.startDate} \xe0 ${args.endDate}`,
    "dateSelected": (args)=>`${args.date} s\xe9lectionn\xe9`,
    "finishRangeSelectionPrompt": `Cliquer pour finir de s\xe9lectionner la plage de dates`,
    "maximumDate": `Derni\xe8re date disponible`,
    "minimumDate": `Premi\xe8re date disponible`,
    "next": `Suivant`,
    "previous": `Pr\xe9c\xe9dent`,
    "selectedDateDescription": (args)=>`Date s\xe9lectionn\xe9e\xa0: ${args.date}`,
    "selectedRangeDescription": (args)=>`Plage s\xe9lectionn\xe9e\xa0: ${args.dateRange}`,
    "startRangeSelectionPrompt": `Cliquer pour commencer \xe0 s\xe9lectionner la plage de dates`,
    "todayDate": (args)=>`Aujourd'hui, ${args.date}`,
    "todayDateSelected": (args)=>`Aujourd\u{2019}hui, ${args.date} s\xe9lectionn\xe9`
};

},{}],"fTGFf":[function(require,module,exports) {
module.exports = {
    "dateRange": (args)=>`${args.startDate} \u{5E2}\u{5D3} ${args.endDate}`,
    "dateSelected": (args)=>`${args.date} \u{5E0}\u{5D1}\u{5D7}\u{5E8}`,
    "finishRangeSelectionPrompt": `\u{5D7}\u{5E5} \u{5DB}\u{5D3}\u{5D9} \u{5DC}\u{5E1}\u{5D9}\u{5D9}\u{5DD} \u{5D0}\u{5EA} \u{5D1}\u{5D7}\u{5D9}\u{5E8}\u{5EA} \u{5D8}\u{5D5}\u{5D5}\u{5D7} \u{5D4}\u{5EA}\u{5D0}\u{5E8}\u{5D9}\u{5DB}\u{5D9}\u{5DD}`,
    "maximumDate": `\u{5EA}\u{5D0}\u{5E8}\u{5D9}\u{5DA} \u{5E4}\u{5E0}\u{5D5}\u{5D9} \u{5D0}\u{5D7}\u{5E8}\u{5D5}\u{5DF}`,
    "minimumDate": `\u{5EA}\u{5D0}\u{5E8}\u{5D9}\u{5DA} \u{5E4}\u{5E0}\u{5D5}\u{5D9} \u{5E8}\u{5D0}\u{5E9}\u{5D5}\u{5DF}`,
    "next": `\u{5D4}\u{5D1}\u{5D0}`,
    "previous": `\u{5D4}\u{5E7}\u{5D5}\u{5D3}\u{5DD}`,
    "selectedDateDescription": (args)=>`\u{5EA}\u{5D0}\u{5E8}\u{5D9}\u{5DA} \u{5E0}\u{5D1}\u{5D7}\u{5E8}: ${args.date}`,
    "selectedRangeDescription": (args)=>`\u{5D8}\u{5D5}\u{5D5}\u{5D7} \u{5E0}\u{5D1}\u{5D7}\u{5E8}: ${args.dateRange}`,
    "startRangeSelectionPrompt": `\u{5DC}\u{5D7}\u{5E5} \u{5DB}\u{5D3}\u{5D9} \u{5DC}\u{5D4}\u{5EA}\u{5D7}\u{5D9}\u{5DC} \u{5D1}\u{5D1}\u{5D7}\u{5D9}\u{5E8}\u{5EA} \u{5D8}\u{5D5}\u{5D5}\u{5D7} \u{5D4}\u{5EA}\u{5D0}\u{5E8}\u{5D9}\u{5DB}\u{5D9}\u{5DD}`,
    "todayDate": (args)=>`\u{5D4}\u{5D9}\u{5D5}\u{5DD}, ${args.date}`,
    "todayDateSelected": (args)=>`\u{5D4}\u{5D9}\u{5D5}\u{5DD}, ${args.date} \u{5E0}\u{5D1}\u{5D7}\u{5E8}`
};

},{}],"lPj1U":[function(require,module,exports) {
module.exports = {
    "dateRange": (args)=>`${args.startDate} do ${args.endDate}`,
    "dateSelected": (args)=>`${args.date} odabran`,
    "finishRangeSelectionPrompt": `Kliknite da dovr\u{161}ite raspon odabranih datuma`,
    "maximumDate": `Posljednji raspolo\u{17E}ivi datum`,
    "minimumDate": `Prvi raspolo\u{17E}ivi datum`,
    "next": `Sljede\u{107}i`,
    "previous": `Prethodni`,
    "selectedDateDescription": (args)=>`Odabrani datum: ${args.date}`,
    "selectedRangeDescription": (args)=>`Odabrani raspon: ${args.dateRange}`,
    "startRangeSelectionPrompt": `Kliknite da zapo\u{10D}nete raspon odabranih datuma`,
    "todayDate": (args)=>`Danas, ${args.date}`,
    "todayDateSelected": (args)=>`Danas, odabran ${args.date}`
};

},{}],"52Cqb":[function(require,module,exports) {
module.exports = {
    "dateRange": (args)=>`${args.startDate}\u{2013}${args.endDate}`,
    "dateSelected": (args)=>`${args.date} kiv\xe1lasztva`,
    "finishRangeSelectionPrompt": `Kattintson a d\xe1tumtartom\xe1ny kijel\xf6l\xe9s\xe9nek befejez\xe9s\xe9hez`,
    "maximumDate": `Utols\xf3 el\xe9rhet\u{151} d\xe1tum`,
    "minimumDate": `Az els\u{151} el\xe9rhet\u{151} d\xe1tum`,
    "next": `K\xf6vetkez\u{151}`,
    "previous": `El\u{151}z\u{151}`,
    "selectedDateDescription": (args)=>`Kijel\xf6lt d\xe1tum: ${args.date}`,
    "selectedRangeDescription": (args)=>`Kijel\xf6lt tartom\xe1ny: ${args.dateRange}`,
    "startRangeSelectionPrompt": `Kattintson a d\xe1tumtartom\xe1ny kijel\xf6l\xe9s\xe9nek ind\xedt\xe1s\xe1hoz`,
    "todayDate": (args)=>`Ma, ${args.date}`,
    "todayDateSelected": (args)=>`Ma, ${args.date} kijel\xf6lve`
};

},{}],"eGZdL":[function(require,module,exports) {
module.exports = {
    "dateRange": (args)=>`Da ${args.startDate} a ${args.endDate}`,
    "dateSelected": (args)=>`${args.date} selezionata`,
    "finishRangeSelectionPrompt": `Fai clic per completare la selezione dell\u{2019}intervallo di date`,
    "maximumDate": `Ultima data disponibile`,
    "minimumDate": `Prima data disponibile`,
    "next": `Successivo`,
    "previous": `Precedente`,
    "selectedDateDescription": (args)=>`Data selezionata: ${args.date}`,
    "selectedRangeDescription": (args)=>`Intervallo selezionato: ${args.dateRange}`,
    "startRangeSelectionPrompt": `Fai clic per selezionare l\u{2019}intervallo di date`,
    "todayDate": (args)=>`Oggi, ${args.date}`,
    "todayDateSelected": (args)=>`Oggi, ${args.date} selezionata`
};

},{}],"1ryrC":[function(require,module,exports) {
module.exports = {
    "dateRange": (args)=>`${args.startDate} \u{304B}\u{3089} ${args.endDate}`,
    "dateSelected": (args)=>`${args.date} \u{3092}\u{9078}\u{629E}`,
    "finishRangeSelectionPrompt": `\u{30AF}\u{30EA}\u{30C3}\u{30AF}\u{3057}\u{3066}\u{65E5}\u{4ED8}\u{7BC4}\u{56F2}\u{306E}\u{9078}\u{629E}\u{3092}\u{7D42}\u{4E86}`,
    "maximumDate": `\u{6700}\u{7D42}\u{5229}\u{7528}\u{53EF}\u{80FD}\u{65E5}`,
    "minimumDate": `\u{6700}\u{521D}\u{306E}\u{5229}\u{7528}\u{53EF}\u{80FD}\u{65E5}`,
    "next": `\u{6B21}\u{3078}`,
    "previous": `\u{524D}\u{3078}`,
    "selectedDateDescription": (args)=>`\u{9078}\u{629E}\u{3057}\u{305F}\u{65E5}\u{4ED8} : ${args.date}`,
    "selectedRangeDescription": (args)=>`\u{9078}\u{629E}\u{7BC4}\u{56F2} : ${args.dateRange}`,
    "startRangeSelectionPrompt": `\u{30AF}\u{30EA}\u{30C3}\u{30AF}\u{3057}\u{3066}\u{65E5}\u{4ED8}\u{7BC4}\u{56F2}\u{306E}\u{9078}\u{629E}\u{3092}\u{958B}\u{59CB}`,
    "todayDate": (args)=>`\u{672C}\u{65E5}\u{3001}${args.date}`,
    "todayDateSelected": (args)=>`\u{672C}\u{65E5}\u{3001}${args.date} \u{3092}\u{9078}\u{629E}`
};

},{}],"fqG8s":[function(require,module,exports) {
module.exports = {
    "dateRange": (args)=>`${args.startDate} ~ ${args.endDate}`,
    "dateSelected": (args)=>`${args.date} \u{C120}\u{D0DD}\u{B428}`,
    "finishRangeSelectionPrompt": `\u{B0A0}\u{C9DC} \u{BC94}\u{C704} \u{C120}\u{D0DD}\u{C744} \u{C644}\u{B8CC}\u{D558}\u{B824}\u{BA74} \u{D074}\u{B9AD}\u{D558}\u{C2ED}\u{C2DC}\u{C624}.`,
    "maximumDate": `\u{B9C8}\u{C9C0}\u{B9C9}\u{C73C}\u{B85C} \u{C0AC}\u{C6A9} \u{AC00}\u{B2A5}\u{D55C} \u{C77C}\u{C790}`,
    "minimumDate": `\u{CC98}\u{C74C}\u{C73C}\u{B85C} \u{C0AC}\u{C6A9} \u{AC00}\u{B2A5}\u{D55C} \u{C77C}\u{C790}`,
    "next": `\u{B2E4}\u{C74C}`,
    "previous": `\u{C774}\u{C804}`,
    "selectedDateDescription": (args)=>`\u{C120}\u{D0DD} \u{C77C}\u{C790}: ${args.date}`,
    "selectedRangeDescription": (args)=>`\u{C120}\u{D0DD} \u{BC94}\u{C704}: ${args.dateRange}`,
    "startRangeSelectionPrompt": `\u{B0A0}\u{C9DC} \u{BC94}\u{C704} \u{C120}\u{D0DD}\u{C744} \u{C2DC}\u{C791}\u{D558}\u{B824}\u{BA74} \u{D074}\u{B9AD}\u{D558}\u{C2ED}\u{C2DC}\u{C624}.`,
    "todayDate": (args)=>`\u{C624}\u{B298}, ${args.date}`,
    "todayDateSelected": (args)=>`\u{C624}\u{B298}, ${args.date} \u{C120}\u{D0DD}\u{B428}`
};

},{}],"3vFdZ":[function(require,module,exports) {
module.exports = {
    "dateRange": (args)=>`Nuo ${args.startDate} iki ${args.endDate}`,
    "dateSelected": (args)=>`Pasirinkta ${args.date}`,
    "finishRangeSelectionPrompt": `Spustel\u{117}kite, kad baigtum\u{117}te pasirinkti dat\u{173} interval\u{105}`,
    "maximumDate": `Paskutin\u{117} galima data`,
    "minimumDate": `Pirmoji galima data`,
    "next": `Paskesnis`,
    "previous": `Ankstesnis`,
    "selectedDateDescription": (args)=>`Pasirinkta data: ${args.date}`,
    "selectedRangeDescription": (args)=>`Pasirinktas intervalas: ${args.dateRange}`,
    "startRangeSelectionPrompt": `Spustel\u{117}kite, kad prad\u{117}tum\u{117}te pasirinkti dat\u{173} interval\u{105}`,
    "todayDate": (args)=>`\u{160}iandien, ${args.date}`,
    "todayDateSelected": (args)=>`\u{160}iandien, pasirinkta ${args.date}`
};

},{}],"jAlvh":[function(require,module,exports) {
module.exports = {
    "dateRange": (args)=>`No ${args.startDate} l\u{12B}dz ${args.endDate}`,
    "dateSelected": (args)=>`Atlas\u{12B}ts: ${args.date}`,
    "finishRangeSelectionPrompt": `Noklik\u{161}\u{137}iniet, lai pabeigtu datumu diapazona atlasi`,
    "maximumDate": `P\u{113}d\u{113}jais pieejamais datums`,
    "minimumDate": `Pirmais pieejamais datums`,
    "next": `T\u{101}l\u{101}k`,
    "previous": `Atpaka\u{13C}`,
    "selectedDateDescription": (args)=>`Atlas\u{12B}tais datums: ${args.date}`,
    "selectedRangeDescription": (args)=>`Atlas\u{12B}tais diapazons: ${args.dateRange}`,
    "startRangeSelectionPrompt": `Noklik\u{161}\u{137}iniet, lai s\u{101}ktu datumu diapazona atlasi`,
    "todayDate": (args)=>`\u{160}odien, ${args.date}`,
    "todayDateSelected": (args)=>`Atlas\u{12B}ta \u{161}odiena, ${args.date}`
};

},{}],"cN9Iv":[function(require,module,exports) {
module.exports = {
    "dateRange": (args)=>`${args.startDate} til ${args.endDate}`,
    "dateSelected": (args)=>`${args.date} valgt`,
    "finishRangeSelectionPrompt": `Klikk for \xe5 fullf\xf8re valg av datoomr\xe5de`,
    "maximumDate": `Siste tilgjengelige dato`,
    "minimumDate": `F\xf8rste tilgjengelige dato`,
    "next": `Neste`,
    "previous": `Forrige`,
    "selectedDateDescription": (args)=>`Valgt dato: ${args.date}`,
    "selectedRangeDescription": (args)=>`Valgt omr\xe5de: ${args.dateRange}`,
    "startRangeSelectionPrompt": `Klikk for \xe5 starte valg av datoomr\xe5de`,
    "todayDate": (args)=>`I dag, ${args.date}`,
    "todayDateSelected": (args)=>`I dag, ${args.date} valgt`
};

},{}],"140UE":[function(require,module,exports) {
module.exports = {
    "dateRange": (args)=>`${args.startDate} tot ${args.endDate}`,
    "dateSelected": (args)=>`${args.date} geselecteerd`,
    "finishRangeSelectionPrompt": `Klik om de selectie van het datumbereik te voltooien`,
    "maximumDate": `Laatste beschikbare datum`,
    "minimumDate": `Eerste beschikbare datum`,
    "next": `Volgende`,
    "previous": `Vorige`,
    "selectedDateDescription": (args)=>`Geselecteerde datum: ${args.date}`,
    "selectedRangeDescription": (args)=>`Geselecteerd bereik: ${args.dateRange}`,
    "startRangeSelectionPrompt": `Klik om het datumbereik te selecteren`,
    "todayDate": (args)=>`Vandaag, ${args.date}`,
    "todayDateSelected": (args)=>`Vandaag, ${args.date} geselecteerd`
};

},{}],"kBHrn":[function(require,module,exports) {
module.exports = {
    "dateRange": (args)=>`${args.startDate} do ${args.endDate}`,
    "dateSelected": (args)=>`Wybrano ${args.date}`,
    "finishRangeSelectionPrompt": `Kliknij, aby zako\u{144}czy\u{107} wyb\xf3r zakresu dat`,
    "maximumDate": `Ostatnia dost\u{119}pna data`,
    "minimumDate": `Pierwsza dost\u{119}pna data`,
    "next": `Dalej`,
    "previous": `Wstecz`,
    "selectedDateDescription": (args)=>`Wybrana data: ${args.date}`,
    "selectedRangeDescription": (args)=>`Wybrany zakres: ${args.dateRange}`,
    "startRangeSelectionPrompt": `Kliknij, aby rozpocz\u{105}\u{107} wyb\xf3r zakresu dat`,
    "todayDate": (args)=>`Dzisiaj, ${args.date}`,
    "todayDateSelected": (args)=>`Dzisiaj wybrano ${args.date}`
};

},{}],"ikHr8":[function(require,module,exports) {
module.exports = {
    "dateRange": (args)=>`${args.startDate} a ${args.endDate}`,
    "dateSelected": (args)=>`${args.date} selecionado`,
    "finishRangeSelectionPrompt": `Clique para concluir a sele\xe7\xe3o do intervalo de datas`,
    "maximumDate": `\xdaltima data dispon\xedvel`,
    "minimumDate": `Primeira data dispon\xedvel`,
    "next": `Pr\xf3ximo`,
    "previous": `Anterior`,
    "selectedDateDescription": (args)=>`Data selecionada: ${args.date}`,
    "selectedRangeDescription": (args)=>`Intervalo selecionado: ${args.dateRange}`,
    "startRangeSelectionPrompt": `Clique para iniciar a sele\xe7\xe3o do intervalo de datas`,
    "todayDate": (args)=>`Hoje, ${args.date}`,
    "todayDateSelected": (args)=>`Hoje, ${args.date} selecionado`
};

},{}],"8ubTq":[function(require,module,exports) {
module.exports = {
    "dateRange": (args)=>`${args.startDate} a ${args.endDate}`,
    "dateSelected": (args)=>`${args.date} selecionado`,
    "finishRangeSelectionPrompt": `Clique para terminar de selecionar o intervalo de datas`,
    "maximumDate": `\xdaltima data dispon\xedvel`,
    "minimumDate": `Primeira data dispon\xedvel`,
    "next": `Pr\xf3ximo`,
    "previous": `Anterior`,
    "selectedDateDescription": (args)=>`Data selecionada: ${args.date}`,
    "selectedRangeDescription": (args)=>`Intervalo selecionado: ${args.dateRange}`,
    "startRangeSelectionPrompt": `Clique para come\xe7ar a selecionar o intervalo de datas`,
    "todayDate": (args)=>`Hoje, ${args.date}`,
    "todayDateSelected": (args)=>`Hoje, ${args.date} selecionado`
};

},{}],"1ofMh":[function(require,module,exports) {
module.exports = {
    "dateRange": (args)=>`De la ${args.startDate} p\xe2n\u{103} la ${args.endDate}`,
    "dateSelected": (args)=>`${args.date} selectat\u{103}`,
    "finishRangeSelectionPrompt": `Ap\u{103}sa\u{163}i pentru a finaliza selec\u{163}ia razei pentru dat\u{103}`,
    "maximumDate": `Ultima dat\u{103} disponibil\u{103}`,
    "minimumDate": `Prima dat\u{103} disponibil\u{103}`,
    "next": `Urm\u{103}torul`,
    "previous": `\xcenainte`,
    "selectedDateDescription": (args)=>`Dat\u{103} selectat\u{103}: ${args.date}`,
    "selectedRangeDescription": (args)=>`Interval selectat: ${args.dateRange}`,
    "startRangeSelectionPrompt": `Ap\u{103}sa\u{163}i pentru a \xeencepe selec\u{163}ia razei pentru dat\u{103}`,
    "todayDate": (args)=>`Ast\u{103}zi, ${args.date}`,
    "todayDateSelected": (args)=>`Azi, ${args.date} selectat\u{103}`
};

},{}],"k32tb":[function(require,module,exports) {
module.exports = {
    "dateRange": (args)=>`\u{421} ${args.startDate} \u{43F}\u{43E} ${args.endDate}`,
    "dateSelected": (args)=>`\u{412}\u{44B}\u{431}\u{440}\u{430}\u{43D}\u{43E} ${args.date}`,
    "finishRangeSelectionPrompt": `\u{429}\u{435}\u{43B}\u{43A}\u{43D}\u{438}\u{442}\u{435}, \u{447}\u{442}\u{43E}\u{431}\u{44B} \u{437}\u{430}\u{432}\u{435}\u{440}\u{448}\u{438}\u{442}\u{44C} \u{432}\u{44B}\u{431}\u{43E}\u{440} \u{434}\u{438}\u{430}\u{43F}\u{430}\u{437}\u{43E}\u{43D}\u{430} \u{434}\u{430}\u{442}`,
    "maximumDate": `\u{41F}\u{43E}\u{441}\u{43B}\u{435}\u{434}\u{43D}\u{44F}\u{44F} \u{434}\u{43E}\u{441}\u{442}\u{443}\u{43F}\u{43D}\u{430}\u{44F} \u{434}\u{430}\u{442}\u{430}`,
    "minimumDate": `\u{41F}\u{435}\u{440}\u{432}\u{430}\u{44F} \u{434}\u{43E}\u{441}\u{442}\u{443}\u{43F}\u{43D}\u{430}\u{44F} \u{434}\u{430}\u{442}\u{430}`,
    "next": `\u{414}\u{430}\u{43B}\u{435}\u{435}`,
    "previous": `\u{41D}\u{430}\u{437}\u{430}\u{434}`,
    "selectedDateDescription": (args)=>`\u{412}\u{44B}\u{431}\u{440}\u{430}\u{43D}\u{43D}\u{430}\u{44F} \u{434}\u{430}\u{442}\u{430}: ${args.date}`,
    "selectedRangeDescription": (args)=>`\u{412}\u{44B}\u{431}\u{440}\u{430}\u{43D}\u{43D}\u{44B}\u{439} \u{434}\u{438}\u{430}\u{43F}\u{430}\u{437}\u{43E}\u{43D}: ${args.dateRange}`,
    "startRangeSelectionPrompt": `\u{429}\u{435}\u{43B}\u{43A}\u{43D}\u{438}\u{442}\u{435}, \u{447}\u{442}\u{43E}\u{431}\u{44B} \u{43D}\u{430}\u{447}\u{430}\u{442}\u{44C} \u{432}\u{44B}\u{431}\u{43E}\u{440} \u{434}\u{438}\u{430}\u{43F}\u{430}\u{437}\u{43E}\u{43D}\u{430} \u{434}\u{430}\u{442}`,
    "todayDate": (args)=>`\u{421}\u{435}\u{433}\u{43E}\u{434}\u{43D}\u{44F}, ${args.date}`,
    "todayDateSelected": (args)=>`\u{421}\u{435}\u{433}\u{43E}\u{434}\u{43D}\u{44F}, \u{432}\u{44B}\u{431}\u{440}\u{430}\u{43D}\u{43E} ${args.date}`
};

},{}],"g0kUE":[function(require,module,exports) {
module.exports = {
    "dateRange": (args)=>`Od ${args.startDate} do ${args.endDate}`,
    "dateSelected": (args)=>`Vybrat\xfd d\xe1tum ${args.date}`,
    "finishRangeSelectionPrompt": `Kliknut\xedm dokon\u{10D}\xedte v\xfdber rozsahu d\xe1tumov`,
    "maximumDate": `Posledn\xfd dostupn\xfd d\xe1tum`,
    "minimumDate": `Prv\xfd dostupn\xfd d\xe1tum`,
    "next": `Nasleduj\xface`,
    "previous": `Predch\xe1dzaj\xface`,
    "selectedDateDescription": (args)=>`Vybrat\xfd d\xe1tum: ${args.date}`,
    "selectedRangeDescription": (args)=>`Vybrat\xfd rozsah: ${args.dateRange}`,
    "startRangeSelectionPrompt": `Kliknut\xedm spust\xedte v\xfdber rozsahu d\xe1tumov`,
    "todayDate": (args)=>`Dnes ${args.date}`,
    "todayDateSelected": (args)=>`Vybrat\xfd dne\u{161}n\xfd d\xe1tum ${args.date}`
};

},{}],"2IAmC":[function(require,module,exports) {
module.exports = {
    "dateRange": (args)=>`${args.startDate} do ${args.endDate}`,
    "dateSelected": (args)=>`${args.date} izbrano`,
    "finishRangeSelectionPrompt": `Kliknite za dokon\u{10D}anje izbire datumskega obsega`,
    "maximumDate": `Zadnji razpolo\u{17E}ljivi datum`,
    "minimumDate": `Prvi razpolo\u{17E}ljivi datum`,
    "next": `Naprej`,
    "previous": `Nazaj`,
    "selectedDateDescription": (args)=>`Izbrani datum: ${args.date}`,
    "selectedRangeDescription": (args)=>`Izbrano obmo\u{10D}je: ${args.dateRange}`,
    "startRangeSelectionPrompt": `Kliknite za za\u{10D}etek izbire datumskega obsega`,
    "todayDate": (args)=>`Danes, ${args.date}`,
    "todayDateSelected": (args)=>`Danes, ${args.date} izbrano`
};

},{}],"2p4xf":[function(require,module,exports) {
module.exports = {
    "dateRange": (args)=>`${args.startDate} do ${args.endDate}`,
    "dateSelected": (args)=>`${args.date} izabran`,
    "finishRangeSelectionPrompt": `Kliknite da dovr\u{161}ite opseg izabranih datuma`,
    "maximumDate": `Zadnji raspolo\u{17E}ivi datum`,
    "minimumDate": `Prvi raspolo\u{17E}ivi datum`,
    "next": `Slede\u{107}i`,
    "previous": `Prethodni`,
    "selectedDateDescription": (args)=>`Izabrani datum: ${args.date}`,
    "selectedRangeDescription": (args)=>`Izabrani period: ${args.dateRange}`,
    "startRangeSelectionPrompt": `Kliknite da zapo\u{10D}nete opseg izabranih datuma`,
    "todayDate": (args)=>`Danas, ${args.date}`,
    "todayDateSelected": (args)=>`Danas, izabran ${args.date}`
};

},{}],"2yt58":[function(require,module,exports) {
module.exports = {
    "dateRange": (args)=>`${args.startDate} till ${args.endDate}`,
    "dateSelected": (args)=>`${args.date} har valts`,
    "finishRangeSelectionPrompt": `Klicka f\xf6r att avsluta val av datumintervall`,
    "maximumDate": `Sista tillg\xe4ngliga datum`,
    "minimumDate": `F\xf6rsta tillg\xe4ngliga datum`,
    "next": `N\xe4sta`,
    "previous": `F\xf6reg\xe5ende`,
    "selectedDateDescription": (args)=>`Valt datum: ${args.date}`,
    "selectedRangeDescription": (args)=>`Valt intervall: ${args.dateRange}`,
    "startRangeSelectionPrompt": `Klicka f\xf6r att v\xe4lja datumintervall`,
    "todayDate": (args)=>`Idag, ${args.date}`,
    "todayDateSelected": (args)=>`Idag, ${args.date} har valts`
};

},{}],"iq4Ti":[function(require,module,exports) {
module.exports = {
    "dateRange": (args)=>`${args.startDate} - ${args.endDate}`,
    "dateSelected": (args)=>`${args.date} se\xe7ildi`,
    "finishRangeSelectionPrompt": `Tarih aral\u{131}\u{11F}\u{131} se\xe7imini tamamlamak i\xe7in t\u{131}klay\u{131}n`,
    "maximumDate": `Son m\xfcsait tarih`,
    "minimumDate": `\u{130}lk m\xfcsait tarih`,
    "next": `Sonraki`,
    "previous": `\xd6nceki`,
    "selectedDateDescription": (args)=>`Se\xe7ilen Tarih: ${args.date}`,
    "selectedRangeDescription": (args)=>`Se\xe7ilen Aral\u{131}k: ${args.dateRange}`,
    "startRangeSelectionPrompt": `Tarih aral\u{131}\u{11F}\u{131} se\xe7imini ba\u{15F}latmak i\xe7in t\u{131}klay\u{131}n`,
    "todayDate": (args)=>`Bug\xfcn, ${args.date}`,
    "todayDateSelected": (args)=>`Bug\xfcn, ${args.date} se\xe7ildi`
};

},{}],"6uhFp":[function(require,module,exports) {
module.exports = {
    "dateRange": (args)=>`${args.startDate} \u{2014} ${args.endDate}`,
    "dateSelected": (args)=>`\u{412}\u{438}\u{431}\u{440}\u{430}\u{43D}\u{43E} ${args.date}`,
    "finishRangeSelectionPrompt": `\u{41D}\u{430}\u{442}\u{438}\u{441}\u{43D}\u{456}\u{442}\u{44C}, \u{449}\u{43E}\u{431} \u{437}\u{430}\u{432}\u{435}\u{440}\u{448}\u{438}\u{442}\u{438} \u{432}\u{438}\u{431}\u{456}\u{440} \u{434}\u{456}\u{430}\u{43F}\u{430}\u{437}\u{43E}\u{43D}\u{443} \u{434}\u{430}\u{442}`,
    "maximumDate": `\u{41E}\u{441}\u{442}\u{430}\u{43D}\u{43D}\u{44F} \u{434}\u{43E}\u{441}\u{442}\u{443}\u{43F}\u{43D}\u{430} \u{434}\u{430}\u{442}\u{430}`,
    "minimumDate": `\u{41F}\u{435}\u{440}\u{448}\u{430} \u{434}\u{43E}\u{441}\u{442}\u{443}\u{43F}\u{43D}\u{430} \u{434}\u{430}\u{442}\u{430}`,
    "next": `\u{41D}\u{430}\u{441}\u{442}\u{443}\u{43F}\u{43D}\u{438}\u{439}`,
    "previous": `\u{41F}\u{43E}\u{43F}\u{435}\u{440}\u{435}\u{434}\u{43D}\u{456}\u{439}`,
    "selectedDateDescription": (args)=>`\u{412}\u{438}\u{431}\u{440}\u{430}\u{43D}\u{430} \u{434}\u{430}\u{442}\u{430}: ${args.date}`,
    "selectedRangeDescription": (args)=>`\u{412}\u{438}\u{431}\u{440}\u{430}\u{43D}\u{438}\u{439} \u{434}\u{456}\u{430}\u{43F}\u{430}\u{437}\u{43E}\u{43D}: ${args.dateRange}`,
    "startRangeSelectionPrompt": `\u{41D}\u{430}\u{442}\u{438}\u{441}\u{43D}\u{456}\u{442}\u{44C}, \u{449}\u{43E}\u{431} \u{43F}\u{43E}\u{447}\u{430}\u{442}\u{438} \u{432}\u{438}\u{431}\u{456}\u{440} \u{434}\u{456}\u{430}\u{43F}\u{430}\u{437}\u{43E}\u{43D}\u{443} \u{434}\u{430}\u{442}`,
    "todayDate": (args)=>`\u{421}\u{44C}\u{43E}\u{433}\u{43E}\u{434}\u{43D}\u{456}, ${args.date}`,
    "todayDateSelected": (args)=>`\u{421}\u{44C}\u{43E}\u{433}\u{43E}\u{434}\u{43D}\u{456}, \u{432}\u{438}\u{431}\u{440}\u{430}\u{43D}\u{43E} ${args.date}`
};

},{}],"4SsP1":[function(require,module,exports) {
module.exports = {
    "dateRange": (args)=>`${args.startDate} \u{81F3} ${args.endDate}`,
    "dateSelected": (args)=>`\u{5DF2}\u{9009}\u{62E9} ${args.date}`,
    "finishRangeSelectionPrompt": `\u{5355}\u{51FB}\u{4EE5}\u{5B8C}\u{6210}\u{9009}\u{62E9}\u{65E5}\u{671F}\u{8303}\u{56F4}`,
    "maximumDate": `\u{6700}\u{540E}\u{4E00}\u{4E2A}\u{53EF}\u{7528}\u{65E5}\u{671F}`,
    "minimumDate": `\u{7B2C}\u{4E00}\u{4E2A}\u{53EF}\u{7528}\u{65E5}\u{671F}`,
    "next": `\u{4E0B}\u{4E00}\u{9875}`,
    "previous": `\u{4E0A}\u{4E00}\u{9875}`,
    "selectedDateDescription": (args)=>`\u{9009}\u{5B9A}\u{7684}\u{65E5}\u{671F}\u{FF1A}${args.date}`,
    "selectedRangeDescription": (args)=>`\u{9009}\u{5B9A}\u{7684}\u{8303}\u{56F4}\u{FF1A}${args.dateRange}`,
    "startRangeSelectionPrompt": `\u{5355}\u{51FB}\u{4EE5}\u{5F00}\u{59CB}\u{9009}\u{62E9}\u{65E5}\u{671F}\u{8303}\u{56F4}`,
    "todayDate": (args)=>`\u{4ECA}\u{5929}\u{FF0C}\u{5373} ${args.date}`,
    "todayDateSelected": (args)=>`\u{5DF2}\u{9009}\u{62E9}\u{4ECA}\u{5929}\u{FF0C}\u{5373} ${args.date}`
};

},{}],"9d2oU":[function(require,module,exports) {
module.exports = {
    "dateRange": (args)=>`${args.startDate} \u{81F3} ${args.endDate}`,
    "dateSelected": (args)=>`\u{5DF2}\u{9078}\u{53D6} ${args.date}`,
    "finishRangeSelectionPrompt": `\u{6309}\u{4E00}\u{4E0B}\u{4EE5}\u{5B8C}\u{6210}\u{9078}\u{53D6}\u{65E5}\u{671F}\u{7BC4}\u{570D}`,
    "maximumDate": `\u{6700}\u{5F8C}\u{4E00}\u{500B}\u{53EF}\u{7528}\u{65E5}\u{671F}`,
    "minimumDate": `\u{7B2C}\u{4E00}\u{500B}\u{53EF}\u{7528}\u{65E5}\u{671F}`,
    "next": `\u{4E0B}\u{4E00}\u{9801}`,
    "previous": `\u{4E0A}\u{4E00}\u{9801}`,
    "selectedDateDescription": (args)=>`\u{9078}\u{5B9A}\u{7684}\u{65E5}\u{671F}\u{FF1A}${args.date}`,
    "selectedRangeDescription": (args)=>`\u{9078}\u{5B9A}\u{7684}\u{7BC4}\u{570D}\u{FF1A}${args.dateRange}`,
    "startRangeSelectionPrompt": `\u{6309}\u{4E00}\u{4E0B}\u{4EE5}\u{958B}\u{59CB}\u{9078}\u{53D6}\u{65E5}\u{671F}\u{7BC4}\u{570D}`,
    "todayDate": (args)=>`\u{4ECA}\u{5929}\u{FF0C}${args.date}`,
    "todayDateSelected": (args)=>`\u{5DF2}\u{9078}\u{53D6}\u{4ECA}\u{5929}\u{FF0C}${args.date}`
};

},{}],"9Fa9w":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides the behavior and accessibility implementation for a range calendar component.
 * A range calendar displays one or more date grids and allows users to select a contiguous range of dates.
 */ parcelHelpers.export(exports, "useRangeCalendar", ()=>useRangeCalendar);
var _useCalendarBase = require("./useCalendarBase");
var _react = require("react");
var _utils = require("@react-aria/utils");
function useRangeCalendar(props, state, ref) {
    let res = (0, _useCalendarBase.useCalendarBase)(props, state);
    // We need to ignore virtual pointer events from VoiceOver due to these bugs.
    // https://bugs.webkit.org/show_bug.cgi?id=222627
    // https://bugs.webkit.org/show_bug.cgi?id=223202
    // usePress also does this and waits for the following click event before firing.
    // We need to match that here otherwise this will fire before the press event in
    // useCalendarCell, causing range selection to not work properly.
    let isVirtualClick = (0, _react.useRef)(false);
    let windowRef = (0, _react.useRef)(typeof window !== "undefined" ? window : null);
    (0, _utils.useEvent)(windowRef, "pointerdown", (e)=>{
        isVirtualClick.current = e.width === 0 && e.height === 0;
    });
    // Stop range selection when pressing or releasing a pointer outside the calendar body,
    // except when pressing the next or previous buttons to switch months.
    let endDragging = (e)=>{
        if (isVirtualClick.current) {
            isVirtualClick.current = false;
            return;
        }
        state.setDragging(false);
        if (!state.anchorDate) return;
        let target = e.target;
        let body = document.getElementById(res.calendarProps.id);
        if (body && body.contains(document.activeElement) && (!body.contains(target) || !target.closest('button, [role="button"]'))) state.selectFocusedDate();
    };
    (0, _utils.useEvent)(windowRef, "pointerup", endDragging);
    (0, _utils.useEvent)(windowRef, "pointercancel", endDragging);
    // Also stop range selection on blur, e.g. tabbing away from the calendar.
    res.calendarProps.onBlur = (e)=>{
        if ((!e.relatedTarget || !ref.current.contains(e.relatedTarget)) && state.anchorDate) state.selectFocusedDate();
    };
    // Prevent touch scrolling while dragging
    (0, _utils.useEvent)(ref, "touchmove", (e)=>{
        if (state.isDragging) e.preventDefault();
    }, {
        passive: false,
        capture: true
    });
    return res;
}

},{"./useCalendarBase":"iGNGX","react":"9yzVZ","@react-aria/utils":"9cLk5","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"gEFSZ":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides the behavior and accessibility implementation for a calendar grid component.
 * A calendar grid displays a single grid of days within a calendar or range calendar which
 * can be keyboard navigated and selected by the user.
 */ parcelHelpers.export(exports, "useCalendarGrid", ()=>useCalendarGrid);
var _date = require("@internationalized/date");
var _utils = require("./utils");
var _react = require("react");
var _utils1 = require("@react-aria/utils");
var _i18N = require("@react-aria/i18n");
function useCalendarGrid(props, state) {
    let { startDate = state.visibleRange.start, endDate = state.visibleRange.end } = props;
    let { direction } = (0, _i18N.useLocale)();
    let onKeyDown = (e)=>{
        switch(e.key){
            case "Enter":
            case " ":
                e.preventDefault();
                state.selectFocusedDate();
                break;
            case "PageUp":
                e.preventDefault();
                e.stopPropagation();
                state.focusPreviousSection(e.shiftKey);
                break;
            case "PageDown":
                e.preventDefault();
                e.stopPropagation();
                state.focusNextSection(e.shiftKey);
                break;
            case "End":
                e.preventDefault();
                e.stopPropagation();
                state.focusSectionEnd();
                break;
            case "Home":
                e.preventDefault();
                e.stopPropagation();
                state.focusSectionStart();
                break;
            case "ArrowLeft":
                e.preventDefault();
                e.stopPropagation();
                if (direction === "rtl") state.focusNextDay();
                else state.focusPreviousDay();
                break;
            case "ArrowUp":
                e.preventDefault();
                e.stopPropagation();
                state.focusPreviousRow();
                break;
            case "ArrowRight":
                e.preventDefault();
                e.stopPropagation();
                if (direction === "rtl") state.focusPreviousDay();
                else state.focusNextDay();
                break;
            case "ArrowDown":
                e.preventDefault();
                e.stopPropagation();
                state.focusNextRow();
                break;
            case "Escape":
                // Cancel the selection.
                if ("setAnchorDate" in state) {
                    e.preventDefault();
                    state.setAnchorDate(null);
                }
                break;
        }
    };
    let visibleRangeDescription = (0, _utils.useVisibleRangeDescription)(startDate, endDate, state.timeZone, true);
    let { ariaLabel, ariaLabelledBy } = (0, _utils.hookData).get(state);
    let labelProps = (0, _utils1.useLabels)({
        "aria-label": [
            ariaLabel,
            visibleRangeDescription
        ].filter(Boolean).join(", "),
        "aria-labelledby": ariaLabelledBy
    });
    let dayFormatter = (0, _i18N.useDateFormatter)({
        weekday: props.weekdayStyle || "narrow",
        timeZone: state.timeZone
    });
    let { locale } = (0, _i18N.useLocale)();
    let weekDays = (0, _react.useMemo)(()=>{
        let weekStart = (0, _date.startOfWeek)((0, _date.today)(state.timeZone), locale);
        return [
            ...new Array(7).keys()
        ].map((index)=>{
            let date = weekStart.add({
                days: index
            });
            let dateDay = date.toDate(state.timeZone);
            return dayFormatter.format(dateDay);
        });
    }, [
        locale,
        state.timeZone,
        dayFormatter
    ]);
    return {
        gridProps: (0, _utils1.mergeProps)(labelProps, {
            role: "grid",
            "aria-readonly": state.isReadOnly || null,
            "aria-disabled": state.isDisabled || null,
            "aria-multiselectable": "highlightedRange" in state || undefined,
            onKeyDown,
            onFocus: ()=>state.setFocused(true),
            onBlur: ()=>state.setFocused(false)
        }),
        headerProps: {
            // Column headers are hidden to screen readers to make navigating with a touch screen reader easier.
            // The day names are already included in the label of each cell, so there's no need to announce them twice.
            "aria-hidden": true
        },
        weekDays
    };
}

},{"@internationalized/date":"hesBk","./utils":"l7BLF","react":"9yzVZ","@react-aria/utils":"9cLk5","@react-aria/i18n":"411rg","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"d0B8w":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides the behavior and accessibility implementation for a calendar cell component.
 * A calendar cell displays a date cell within a calendar grid which can be selected by the user.
 */ parcelHelpers.export(exports, "useCalendarCell", ()=>useCalendarCell);
var _date = require("@internationalized/date");
var _utils = require("@react-aria/utils");
var _utils1 = require("./utils");
var _interactions = require("@react-aria/interactions");
// @ts-ignore
var _json = require("../intl/*.json");
var _jsonDefault = parcelHelpers.interopDefault(_json);
var _react = require("react");
var _i18N = require("@react-aria/i18n");
function useCalendarCell(props, state, ref) {
    let { date, isDisabled } = props;
    let { errorMessageId, selectedDateDescription } = (0, _utils1.hookData).get(state);
    let stringFormatter = (0, _i18N.useLocalizedStringFormatter)((0, _jsonDefault.default), "@react-aria/calendar");
    let dateFormatter = (0, _i18N.useDateFormatter)({
        weekday: "long",
        day: "numeric",
        month: "long",
        year: "numeric",
        era: (0, _utils1.getEraFormat)(date),
        timeZone: state.timeZone
    });
    let isSelected = state.isSelected(date);
    let isFocused = state.isCellFocused(date);
    isDisabled = isDisabled || state.isCellDisabled(date);
    let isUnavailable = state.isCellUnavailable(date);
    let isSelectable = !isDisabled && !isUnavailable;
    let isInvalid = state.isValueInvalid && ("highlightedRange" in state ? !state.anchorDate && state.highlightedRange && date.compare(state.highlightedRange.start) >= 0 && date.compare(state.highlightedRange.end) <= 0 : state.value && (0, _date.isSameDay)(state.value, date));
    if (isInvalid) isSelected = true;
    // For performance, reuse the same date object as before if the new date prop is the same.
    // This allows subsequent useMemo results to be reused.
    date = (0, _utils.useDeepMemo)(date, (0, _date.isEqualDay));
    let nativeDate = (0, _react.useMemo)(()=>date.toDate(state.timeZone), [
        date,
        state.timeZone
    ]);
    // aria-label should be localize Day of week, Month, Day and Year without Time.
    let isDateToday = (0, _date.isToday)(date, state.timeZone);
    let label = (0, _react.useMemo)(()=>{
        let label = "";
        // If this is a range calendar, add a description of the full selected range
        // to the first and last selected date.
        if ("highlightedRange" in state && state.value && !state.anchorDate && ((0, _date.isSameDay)(date, state.value.start) || (0, _date.isSameDay)(date, state.value.end))) label = selectedDateDescription + ", ";
        label += dateFormatter.format(nativeDate);
        if (isDateToday) // If date is today, set appropriate string depending on selected state:
        label = stringFormatter.format(isSelected ? "todayDateSelected" : "todayDate", {
            date: label
        });
        else if (isSelected) // If date is selected but not today:
        label = stringFormatter.format("dateSelected", {
            date: label
        });
        if (state.minValue && (0, _date.isSameDay)(date, state.minValue)) label += ", " + stringFormatter.format("minimumDate");
        else if (state.maxValue && (0, _date.isSameDay)(date, state.maxValue)) label += ", " + stringFormatter.format("maximumDate");
        return label;
    }, [
        dateFormatter,
        nativeDate,
        stringFormatter,
        isSelected,
        isDateToday,
        date,
        state,
        selectedDateDescription
    ]);
    // When a cell is focused and this is a range calendar, add a prompt to help
    // screenreader users know that they are in a range selection mode.
    let rangeSelectionPrompt = "";
    if ("anchorDate" in state && isFocused && !state.isReadOnly && isSelectable) {
        // If selection has started add "click to finish selecting range"
        if (state.anchorDate) rangeSelectionPrompt = stringFormatter.format("finishRangeSelectionPrompt");
        else rangeSelectionPrompt = stringFormatter.format("startRangeSelectionPrompt");
    }
    let descriptionProps = (0, _utils.useDescription)(rangeSelectionPrompt);
    let isAnchorPressed = (0, _react.useRef)(false);
    let isRangeBoundaryPressed = (0, _react.useRef)(false);
    let touchDragTimerRef = (0, _react.useRef)(null);
    let { pressProps, isPressed } = (0, _interactions.usePress)({
        // When dragging to select a range, we don't want dragging over the original anchor
        // again to trigger onPressStart. Cancel presses immediately when the pointer exits.
        shouldCancelOnPointerExit: "anchorDate" in state && !!state.anchorDate,
        preventFocusOnPress: true,
        isDisabled: !isSelectable || state.isReadOnly,
        onPressStart (e) {
            if (state.isReadOnly) {
                state.setFocusedDate(date);
                return;
            }
            if ("highlightedRange" in state && !state.anchorDate && (e.pointerType === "mouse" || e.pointerType === "touch")) {
                // Allow dragging the start or end date of a range to modify it
                // rather than starting a new selection.
                // Don't allow dragging when invalid, or weird jumping behavior may occur as date ranges
                // are constrained to available dates. The user will need to select a new range in this case.
                if (state.highlightedRange && !isInvalid) {
                    if ((0, _date.isSameDay)(date, state.highlightedRange.start)) {
                        state.setAnchorDate(state.highlightedRange.end);
                        state.setFocusedDate(date);
                        state.setDragging(true);
                        isRangeBoundaryPressed.current = true;
                        return;
                    } else if ((0, _date.isSameDay)(date, state.highlightedRange.end)) {
                        state.setAnchorDate(state.highlightedRange.start);
                        state.setFocusedDate(date);
                        state.setDragging(true);
                        isRangeBoundaryPressed.current = true;
                        return;
                    }
                }
                let startDragging = ()=>{
                    state.setDragging(true);
                    touchDragTimerRef.current = null;
                    state.selectDate(date);
                    state.setFocusedDate(date);
                    isAnchorPressed.current = true;
                };
                // Start selection on mouse/touch down so users can drag to select a range.
                // On touch, delay dragging to determine if the user really meant to scroll.
                if (e.pointerType === "touch") touchDragTimerRef.current = setTimeout(startDragging, 200);
                else startDragging();
            }
        },
        onPressEnd () {
            isRangeBoundaryPressed.current = false;
            isAnchorPressed.current = false;
            clearTimeout(touchDragTimerRef.current);
            touchDragTimerRef.current = null;
        },
        onPress () {
            // For non-range selection, always select on press up.
            if (!("anchorDate" in state) && !state.isReadOnly) {
                state.selectDate(date);
                state.setFocusedDate(date);
            }
        },
        onPressUp (e) {
            if (state.isReadOnly) return;
            // If the user tapped quickly, the date won't be selected yet and the
            // timer will still be in progress. In this case, select the date on touch up.
            // Timer is cleared in onPressEnd.
            if ("anchorDate" in state && touchDragTimerRef.current) {
                state.selectDate(date);
                state.setFocusedDate(date);
            }
            if ("anchorDate" in state) {
                if (isRangeBoundaryPressed.current) // When clicking on the start or end date of an already selected range,
                // start a new selection on press up to also allow dragging the date to
                // change the existing range.
                state.setAnchorDate(date);
                else if (state.anchorDate && !isAnchorPressed.current) {
                    // When releasing a drag or pressing the end date of a range, select it.
                    state.selectDate(date);
                    state.setFocusedDate(date);
                } else if (e.pointerType === "keyboard" && !state.anchorDate) {
                    // For range selection, auto-advance the focused date by one if using keyboard.
                    // This gives an indication that you're selecting a range rather than a single date.
                    // For mouse, this is unnecessary because users will see the indication on hover. For screen readers,
                    // there will be an announcement to "click to finish selecting range" (above).
                    state.selectDate(date);
                    let nextDay = date.add({
                        days: 1
                    });
                    if (state.isInvalid(nextDay)) nextDay = date.subtract({
                        days: 1
                    });
                    if (!state.isInvalid(nextDay)) state.setFocusedDate(nextDay);
                } else if (e.pointerType === "virtual") {
                    // For screen readers, just select the date on click.
                    state.selectDate(date);
                    state.setFocusedDate(date);
                }
            }
        }
    });
    let tabIndex = null;
    if (!isDisabled) tabIndex = (0, _date.isSameDay)(date, state.focusedDate) ? 0 : -1;
    // Focus the button in the DOM when the state updates.
    (0, _react.useEffect)(()=>{
        if (isFocused && ref.current) {
            (0, _utils.focusWithoutScrolling)(ref.current);
            // Scroll into view if navigating with a keyboard, otherwise
            // try not to shift the view under the user's mouse/finger.
            // If in a overlay, scrollIntoViewport will only cause scrolling
            // up to the overlay scroll body to prevent overlay shifting.
            // Also only scroll into view if the cell actually got focused.
            // There are some cases where the cell might be disabled or inside,
            // an inert container and we don't want to scroll then.
            if ((0, _interactions.getInteractionModality)() !== "pointer" && document.activeElement === ref.current) (0, _utils.scrollIntoViewport)(ref.current, {
                containingElement: (0, _utils.getScrollParent)(ref.current)
            });
        }
    }, [
        isFocused,
        ref
    ]);
    let cellDateFormatter = (0, _i18N.useDateFormatter)({
        day: "numeric",
        timeZone: state.timeZone,
        calendar: date.calendar.identifier
    });
    let formattedDate = (0, _react.useMemo)(()=>cellDateFormatter.formatToParts(nativeDate).find((part)=>part.type === "day").value, [
        cellDateFormatter,
        nativeDate
    ]);
    return {
        cellProps: {
            role: "gridcell",
            "aria-disabled": !isSelectable || null,
            "aria-selected": isSelected || null,
            "aria-invalid": isInvalid || null
        },
        buttonProps: (0, _utils.mergeProps)(pressProps, {
            onFocus () {
                if (!isDisabled) state.setFocusedDate(date);
            },
            tabIndex,
            role: "button",
            "aria-disabled": !isSelectable || null,
            "aria-label": label,
            "aria-invalid": isInvalid || null,
            "aria-describedby": [
                isInvalid ? errorMessageId : null,
                descriptionProps["aria-describedby"]
            ].filter(Boolean).join(" ") || undefined,
            onPointerEnter (e) {
                // Highlight the date on hover or drag over a date when selecting a range.
                if ("highlightDate" in state && (e.pointerType !== "touch" || state.isDragging) && isSelectable) state.highlightDate(date);
            },
            onPointerDown (e) {
                // This is necessary on touch devices to allow dragging
                // outside the original pressed element.
                // (JSDOM does not support this)
                if ("releasePointerCapture" in e.target) e.target.releasePointerCapture(e.pointerId);
            },
            onContextMenu (e) {
                // Prevent context menu on long press.
                e.preventDefault();
            }
        }),
        isPressed,
        isFocused,
        isSelected,
        isDisabled,
        isUnavailable,
        isOutsideVisibleRange: date.compare(state.visibleRange.start) < 0 || date.compare(state.visibleRange.end) > 0,
        isInvalid,
        formattedDate
    };
}

},{"@internationalized/date":"hesBk","@react-aria/utils":"9cLk5","./utils":"l7BLF","@react-aria/interactions":"ky3G8","../intl/*.json":"gIddJ","react":"9yzVZ","@react-aria/i18n":"411rg","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"5e6Tk":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useCheckbox", ()=>(0, _useCheckbox.useCheckbox));
parcelHelpers.export(exports, "useCheckboxGroup", ()=>(0, _useCheckboxGroup.useCheckboxGroup));
parcelHelpers.export(exports, "useCheckboxGroupItem", ()=>(0, _useCheckboxGroupItem.useCheckboxGroupItem));
var _useCheckbox = require("./useCheckbox");
var _useCheckboxGroup = require("./useCheckboxGroup");
var _useCheckboxGroupItem = require("./useCheckboxGroupItem");

},{"./useCheckbox":"dwpZB","./useCheckboxGroup":"h7qrw","./useCheckboxGroupItem":"gvGRo","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"dwpZB":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides the behavior and accessibility implementation for a checkbox component.
 * Checkboxes allow users to select multiple items from a list of individual items, or
 * to mark one individual item as selected.
 * @param props - Props for the checkbox.
 * @param state - State for the checkbox, as returned by `useToggleState`.
 * @param inputRef - A ref for the HTML input element.
 */ parcelHelpers.export(exports, "useCheckbox", ()=>useCheckbox);
var _react = require("react");
var _form = require("@react-aria/form");
var _form1 = require("@react-stately/form");
var _toggle = require("@react-aria/toggle");
function useCheckbox(props, state, inputRef) {
    // Create validation state here because it doesn't make sense to add to general useToggleState.
    let validationState = (0, _form1.useFormValidationState)({
        ...props,
        value: state.isSelected
    });
    let { isInvalid, validationErrors, validationDetails } = validationState.displayValidation;
    let { labelProps, inputProps, isSelected, isPressed, isDisabled, isReadOnly } = (0, _toggle.useToggle)({
        ...props,
        isInvalid
    }, state, inputRef);
    (0, _form.useFormValidation)(props, validationState, inputRef);
    let { isIndeterminate, isRequired, validationBehavior = "aria" } = props;
    (0, _react.useEffect)(()=>{
        // indeterminate is a property, but it can only be set via javascript
        // https://css-tricks.com/indeterminate-checkboxes/
        if (inputRef.current) inputRef.current.indeterminate = !!isIndeterminate;
    });
    return {
        labelProps,
        inputProps: {
            ...inputProps,
            checked: isSelected,
            "aria-required": isRequired && validationBehavior === "aria" || undefined,
            required: isRequired && validationBehavior === "native"
        },
        isSelected,
        isPressed,
        isDisabled,
        isReadOnly,
        isInvalid,
        validationErrors,
        validationDetails
    };
}

},{"react":"9yzVZ","@react-aria/form":"lerqa","@react-stately/form":"9yZqm","@react-aria/toggle":"2QYP2","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"lerqa":[function(require,module,exports) {
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useFormValidation", ()=>(0, _useFormValidation.useFormValidation));
var _useFormValidation = require("./useFormValidation");

},{"./useFormValidation":"3Bke6","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"3Bke6":[function(require,module,exports) {
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useFormValidation", ()=>useFormValidation);
var _react = require("react");
var _interactions = require("@react-aria/interactions");
var _utils = require("@react-aria/utils");
function useFormValidation(props, state, ref) {
    let { validationBehavior, focus } = props;
    // This is a useLayoutEffect so that it runs before the useEffect in useFormValidationState, which commits the validation change.
    (0, _utils.useLayoutEffect)(()=>{
        if (validationBehavior === "native" && (ref === null || ref === void 0 ? void 0 : ref.current)) {
            let errorMessage = state.realtimeValidation.isInvalid ? state.realtimeValidation.validationErrors.join(" ") || "Invalid value." : "";
            ref.current.setCustomValidity(errorMessage);
            // Prevent default tooltip for validation message.
            // https://bugzilla.mozilla.org/show_bug.cgi?id=605277
            if (!ref.current.hasAttribute("title")) ref.current.title = "";
            if (!state.realtimeValidation.isInvalid) state.updateValidation(getNativeValidity(ref.current));
        }
    });
    let onReset = (0, _utils.useEffectEvent)(()=>{
        state.resetValidation();
    });
    let onInvalid = (0, _utils.useEffectEvent)((e)=>{
        var _ref_current;
        // Only commit validation if we are not already displaying one.
        // This avoids clearing server errors that the user didn't actually fix.
        if (!state.displayValidation.isInvalid) state.commitValidation();
        // Auto focus the first invalid input in a form, unless the error already had its default prevented.
        let form = ref === null || ref === void 0 ? void 0 : (_ref_current = ref.current) === null || _ref_current === void 0 ? void 0 : _ref_current.form;
        if (!e.defaultPrevented && ref && form && getFirstInvalidInput(form) === ref.current) {
            var _ref_current1;
            if (focus) focus();
            else (_ref_current1 = ref.current) === null || _ref_current1 === void 0 ? void 0 : _ref_current1.focus();
            // Always show focus ring.
            (0, _interactions.setInteractionModality)("keyboard");
        }
        // Prevent default browser error UI from appearing.
        e.preventDefault();
    });
    let onChange = (0, _utils.useEffectEvent)(()=>{
        state.commitValidation();
    });
    (0, _react.useEffect)(()=>{
        let input = ref === null || ref === void 0 ? void 0 : ref.current;
        if (!input) return;
        let form = input.form;
        input.addEventListener("invalid", onInvalid);
        input.addEventListener("change", onChange);
        form === null || form === void 0 ? void 0 : form.addEventListener("reset", onReset);
        return ()=>{
            input.removeEventListener("invalid", onInvalid);
            input.removeEventListener("change", onChange);
            form === null || form === void 0 ? void 0 : form.removeEventListener("reset", onReset);
        };
    }, [
        ref,
        onInvalid,
        onChange,
        onReset,
        validationBehavior
    ]);
}
function getValidity(input) {
    // The native ValidityState object is live, meaning each property is a getter that returns the current state.
    // We need to create a snapshot of the validity state at the time this function is called to avoid unpredictable React renders.
    let validity = input.validity;
    return {
        badInput: validity.badInput,
        customError: validity.customError,
        patternMismatch: validity.patternMismatch,
        rangeOverflow: validity.rangeOverflow,
        rangeUnderflow: validity.rangeUnderflow,
        stepMismatch: validity.stepMismatch,
        tooLong: validity.tooLong,
        tooShort: validity.tooShort,
        typeMismatch: validity.typeMismatch,
        valueMissing: validity.valueMissing,
        valid: validity.valid
    };
}
function getNativeValidity(input) {
    return {
        isInvalid: !input.validity.valid,
        validationDetails: getValidity(input),
        validationErrors: input.validationMessage ? [
            input.validationMessage
        ] : []
    };
}
function getFirstInvalidInput(form) {
    for(let i = 0; i < form.elements.length; i++){
        let element = form.elements[i];
        if (!element.validity.valid) return element;
    }
    return null;
}

},{"react":"9yzVZ","@react-aria/interactions":"ky3G8","@react-aria/utils":"9cLk5","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"9yZqm":[function(require,module,exports) {
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FormValidationContext", ()=>(0, _useFormValidationState.FormValidationContext));
parcelHelpers.export(exports, "useFormValidationState", ()=>(0, _useFormValidationState.useFormValidationState));
parcelHelpers.export(exports, "DEFAULT_VALIDATION_RESULT", ()=>(0, _useFormValidationState.DEFAULT_VALIDATION_RESULT));
parcelHelpers.export(exports, "VALID_VALIDITY_STATE", ()=>(0, _useFormValidationState.VALID_VALIDITY_STATE));
parcelHelpers.export(exports, "privateValidationStateProp", ()=>(0, _useFormValidationState.privateValidationStateProp));
parcelHelpers.export(exports, "mergeValidation", ()=>(0, _useFormValidationState.mergeValidation));
var _useFormValidationState = require("./useFormValidationState");

},{"./useFormValidationState":"2ADdn","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"2ADdn":[function(require,module,exports) {
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "VALID_VALIDITY_STATE", ()=>VALID_VALIDITY_STATE);
parcelHelpers.export(exports, "DEFAULT_VALIDATION_RESULT", ()=>DEFAULT_VALIDATION_RESULT);
parcelHelpers.export(exports, "FormValidationContext", ()=>FormValidationContext);
parcelHelpers.export(exports, "privateValidationStateProp", ()=>privateValidationStateProp);
parcelHelpers.export(exports, "useFormValidationState", ()=>useFormValidationState);
parcelHelpers.export(exports, "mergeValidation", ()=>mergeValidation);
var _react = require("react");
const VALID_VALIDITY_STATE = {
    badInput: false,
    customError: false,
    patternMismatch: false,
    rangeOverflow: false,
    rangeUnderflow: false,
    stepMismatch: false,
    tooLong: false,
    tooShort: false,
    typeMismatch: false,
    valueMissing: false,
    valid: true
};
const CUSTOM_VALIDITY_STATE = {
    ...VALID_VALIDITY_STATE,
    customError: true,
    valid: false
};
const DEFAULT_VALIDATION_RESULT = {
    isInvalid: false,
    validationDetails: VALID_VALIDITY_STATE,
    validationErrors: []
};
const FormValidationContext = (0, _react.createContext)({});
const privateValidationStateProp = "__formValidationState" + Date.now();
function useFormValidationState(props) {
    // Private prop for parent components to pass state to children.
    if (props[privateValidationStateProp]) {
        let { realtimeValidation, displayValidation, updateValidation, resetValidation, commitValidation } = props[privateValidationStateProp];
        return {
            realtimeValidation,
            displayValidation,
            updateValidation,
            resetValidation,
            commitValidation
        };
    }
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return useFormValidationStateImpl(props);
}
function useFormValidationStateImpl(props) {
    let { isInvalid, validationState, name, value, builtinValidation, validate, validationBehavior = "aria" } = props;
    // backward compatibility.
    if (validationState) isInvalid || (isInvalid = validationState === "invalid");
    // If the isInvalid prop is true, update validation result in realtime (controlled).
    let controlledError = isInvalid ? {
        isInvalid: true,
        validationErrors: [],
        validationDetails: CUSTOM_VALIDITY_STATE
    } : null;
    // Perform custom client side validation.
    let clientError = (0, _react.useMemo)(()=>getValidationResult(runValidate(validate, value)), [
        validate,
        value
    ]);
    if (builtinValidation === null || builtinValidation === void 0 ? void 0 : builtinValidation.validationDetails.valid) builtinValidation = null;
    // Get relevant server errors from the form.
    let serverErrors = (0, _react.useContext)(FormValidationContext);
    let serverErrorMessages = (0, _react.useMemo)(()=>{
        if (name) return Array.isArray(name) ? name.flatMap((name)=>asArray(serverErrors[name])) : asArray(serverErrors[name]);
        return [];
    }, [
        serverErrors,
        name
    ]);
    // Show server errors when the form gets a new value, and clear when the user changes the value.
    let [lastServerErrors, setLastServerErrors] = (0, _react.useState)(serverErrors);
    let [isServerErrorCleared, setServerErrorCleared] = (0, _react.useState)(false);
    if (serverErrors !== lastServerErrors) {
        setLastServerErrors(serverErrors);
        setServerErrorCleared(false);
    }
    let serverError = (0, _react.useMemo)(()=>getValidationResult(isServerErrorCleared ? [] : serverErrorMessages), [
        isServerErrorCleared,
        serverErrorMessages
    ]);
    // Track the next validation state in a ref until commitValidation is called.
    let nextValidation = (0, _react.useRef)(DEFAULT_VALIDATION_RESULT);
    let [currentValidity, setCurrentValidity] = (0, _react.useState)(DEFAULT_VALIDATION_RESULT);
    let lastError = (0, _react.useRef)(DEFAULT_VALIDATION_RESULT);
    let commitValidation = ()=>{
        if (!commitQueued) return;
        setCommitQueued(false);
        let error = clientError || builtinValidation || nextValidation.current;
        if (!isEqualValidation(error, lastError.current)) {
            lastError.current = error;
            setCurrentValidity(error);
        }
    };
    let [commitQueued, setCommitQueued] = (0, _react.useState)(false);
    (0, _react.useEffect)(commitValidation);
    // realtimeValidation is used to update the native input element's state based on custom validation logic.
    // displayValidation is the currently displayed validation state that the user sees (e.g. on input change/form submit).
    // With validationBehavior="aria", all errors are displayed in realtime rather than on submit.
    let realtimeValidation = controlledError || serverError || clientError || builtinValidation || DEFAULT_VALIDATION_RESULT;
    let displayValidation = validationBehavior === "native" ? controlledError || serverError || currentValidity : controlledError || serverError || clientError || builtinValidation || currentValidity;
    return {
        realtimeValidation,
        displayValidation,
        updateValidation (value) {
            // If validationBehavior is 'aria', update in realtime. Otherwise, store in a ref until commit.
            if (validationBehavior === "aria" && !isEqualValidation(currentValidity, value)) setCurrentValidity(value);
            else nextValidation.current = value;
        },
        resetValidation () {
            // Update the currently displayed validation state to valid on form reset,
            // even if the native validity says it isn't. It'll show again on the next form submit.
            let error = DEFAULT_VALIDATION_RESULT;
            if (!isEqualValidation(error, lastError.current)) {
                lastError.current = error;
                setCurrentValidity(error);
            }
            // Do not commit validation after the next render. This avoids a condition where
            // useSelect calls commitValidation inside an onReset handler.
            if (validationBehavior === "native") setCommitQueued(false);
            setServerErrorCleared(true);
        },
        commitValidation () {
            // Commit validation state so the user sees it on blur/change/submit. Also clear any server errors.
            // Wait until after the next render to commit so that the latest value has been validated.
            if (validationBehavior === "native") setCommitQueued(true);
            setServerErrorCleared(true);
        }
    };
}
function asArray(v) {
    if (!v) return [];
    return Array.isArray(v) ? v : [
        v
    ];
}
function runValidate(validate, value) {
    if (typeof validate === "function") {
        let e = validate(value);
        if (e && typeof e !== "boolean") return asArray(e);
    }
    return [];
}
function getValidationResult(errors) {
    return errors.length ? {
        isInvalid: true,
        validationErrors: errors,
        validationDetails: CUSTOM_VALIDITY_STATE
    } : null;
}
function isEqualValidation(a, b) {
    if (a === b) return true;
    return a && b && a.isInvalid === b.isInvalid && a.validationErrors.length === b.validationErrors.length && a.validationErrors.every((a, i)=>a === b.validationErrors[i]) && Object.entries(a.validationDetails).every(([k, v])=>b.validationDetails[k] === v);
}
function mergeValidation(...results) {
    let errors = new Set();
    let isInvalid = false;
    let validationDetails = {
        ...VALID_VALIDITY_STATE
    };
    for (let v of results){
        var _validationDetails, _key;
        for (let e of v.validationErrors)errors.add(e);
        // Only these properties apply for checkboxes.
        isInvalid || (isInvalid = v.isInvalid);
        for(let key in validationDetails)(_validationDetails = validationDetails)[_key = key] || (_validationDetails[_key] = v.validationDetails[key]);
    }
    validationDetails.valid = !isInvalid;
    return {
        isInvalid,
        validationErrors: [
            ...errors
        ],
        validationDetails
    };
}

},{"react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"2QYP2":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useToggle", ()=>(0, _useToggle.useToggle));
var _useToggle = require("./useToggle");

},{"./useToggle":"ohKfh","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"ohKfh":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Handles interactions for toggle elements, e.g. Checkboxes and Switches.
 */ parcelHelpers.export(exports, "useToggle", ()=>useToggle);
var _utils = require("@react-aria/utils");
var _focus = require("@react-aria/focus");
var _interactions = require("@react-aria/interactions");
function useToggle(props, state, ref) {
    let { isDisabled = false, isReadOnly = false, value, name, children, "aria-label": ariaLabel, "aria-labelledby": ariaLabelledby, validationState = "valid", isInvalid } = props;
    let onChange = (e)=>{
        // since we spread props on label, onChange will end up there as well as in here.
        // so we have to stop propagation at the lowest level that we care about
        e.stopPropagation();
        state.setSelected(e.target.checked);
    };
    let hasChildren = children != null;
    let hasAriaLabel = ariaLabel != null || ariaLabelledby != null;
    if (!hasChildren && !hasAriaLabel) console.warn("If you do not provide children, you must specify an aria-label for accessibility");
    // This handles focusing the input on pointer down, which Safari does not do by default.
    let { pressProps, isPressed } = (0, _interactions.usePress)({
        isDisabled
    });
    // iOS does not toggle checkboxes if you drag off and back onto the label, so handle it ourselves.
    let { pressProps: labelProps, isPressed: isLabelPressed } = (0, _interactions.usePress)({
        isDisabled: isDisabled || isReadOnly,
        onPress () {
            state.toggle();
        }
    });
    let { focusableProps } = (0, _focus.useFocusable)(props, ref);
    let interactions = (0, _utils.mergeProps)(pressProps, focusableProps);
    let domProps = (0, _utils.filterDOMProps)(props, {
        labelable: true
    });
    (0, _utils.useFormReset)(ref, state.isSelected, state.setSelected);
    return {
        labelProps: (0, _utils.mergeProps)(labelProps, {
            onClick: (e)=>e.preventDefault()
        }),
        inputProps: (0, _utils.mergeProps)(domProps, {
            "aria-invalid": isInvalid || validationState === "invalid" || undefined,
            "aria-errormessage": props["aria-errormessage"],
            "aria-controls": props["aria-controls"],
            "aria-readonly": isReadOnly || undefined,
            onChange,
            disabled: isDisabled,
            ...value == null ? {} : {
                value
            },
            name,
            type: "checkbox",
            ...interactions
        }),
        isSelected: state.isSelected,
        isPressed: isPressed || isLabelPressed,
        isDisabled,
        isReadOnly,
        isInvalid: isInvalid || validationState === "invalid"
    };
}

},{"@react-aria/utils":"9cLk5","@react-aria/focus":"42mbF","@react-aria/interactions":"ky3G8","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"h7qrw":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides the behavior and accessibility implementation for a checkbox group component.
 * Checkbox groups allow users to select multiple items from a list of options.
 * @param props - Props for the checkbox group.
 * @param state - State for the checkbox group, as returned by `useCheckboxGroupState`.
 */ parcelHelpers.export(exports, "useCheckboxGroup", ()=>useCheckboxGroup);
var _utils = require("./utils");
var _utils1 = require("@react-aria/utils");
var _label = require("@react-aria/label");
var _interactions = require("@react-aria/interactions");
function useCheckboxGroup(props, state) {
    let { isDisabled, name, validationBehavior = "aria" } = props;
    let { isInvalid, validationErrors, validationDetails } = state.displayValidation;
    let { labelProps, fieldProps, descriptionProps, errorMessageProps } = (0, _label.useField)({
        ...props,
        // Checkbox group is not an HTML input element so it
        // shouldn't be labeled by a <label> element.
        labelElementType: "span",
        isInvalid,
        errorMessage: props.errorMessage || validationErrors
    });
    (0, _utils.checkboxGroupData).set(state, {
        name,
        descriptionId: descriptionProps.id,
        errorMessageId: errorMessageProps.id,
        validationBehavior
    });
    let domProps = (0, _utils1.filterDOMProps)(props, {
        labelable: true
    });
    let { focusWithinProps } = (0, _interactions.useFocusWithin)({
        onBlurWithin: props.onBlur,
        onFocusWithin: props.onFocus,
        onFocusWithinChange: props.onFocusChange
    });
    return {
        groupProps: (0, _utils1.mergeProps)(domProps, {
            role: "group",
            "aria-disabled": isDisabled || undefined,
            ...fieldProps,
            ...focusWithinProps
        }),
        labelProps,
        descriptionProps,
        errorMessageProps,
        isInvalid,
        validationErrors,
        validationDetails
    };
}

},{"./utils":"2ofnU","@react-aria/utils":"9cLk5","@react-aria/label":"74Ccz","@react-aria/interactions":"ky3G8","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"2ofnU":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "checkboxGroupData", ()=>checkboxGroupData);
const checkboxGroupData = new WeakMap();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"74Ccz":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useField", ()=>(0, _useField.useField));
parcelHelpers.export(exports, "useLabel", ()=>(0, _useLabel.useLabel));
var _useField = require("./useField");
var _useLabel = require("./useLabel");

},{"./useField":"djOtk","./useLabel":"S8XNZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"djOtk":[function(require,module,exports) {
/*
 * Copyright 2021 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides the accessibility implementation for input fields.
 * Fields accept user input, gain context from their label, and may display a description or error message.
 * @param props - Props for the Field.
 */ parcelHelpers.export(exports, "useField", ()=>useField);
var _useLabel = require("./useLabel");
var _utils = require("@react-aria/utils");
function useField(props) {
    let { description, errorMessage, isInvalid, validationState } = props;
    let { labelProps, fieldProps } = (0, _useLabel.useLabel)(props);
    let descriptionId = (0, _utils.useSlotId)([
        Boolean(description),
        Boolean(errorMessage),
        isInvalid,
        validationState
    ]);
    let errorMessageId = (0, _utils.useSlotId)([
        Boolean(description),
        Boolean(errorMessage),
        isInvalid,
        validationState
    ]);
    fieldProps = (0, _utils.mergeProps)(fieldProps, {
        "aria-describedby": [
            descriptionId,
            // Use aria-describedby for error message because aria-errormessage is unsupported using VoiceOver or NVDA. See https://github.com/adobe/react-spectrum/issues/1346#issuecomment-740136268
            errorMessageId,
            props["aria-describedby"]
        ].filter(Boolean).join(" ") || undefined
    });
    return {
        labelProps,
        fieldProps,
        descriptionProps: {
            id: descriptionId
        },
        errorMessageProps: {
            id: errorMessageId
        }
    };
}

},{"./useLabel":"S8XNZ","@react-aria/utils":"9cLk5","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"S8XNZ":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides the accessibility implementation for labels and their associated elements.
 * Labels provide context for user inputs.
 * @param props - The props for labels and fields.
 */ parcelHelpers.export(exports, "useLabel", ()=>useLabel);
var _utils = require("@react-aria/utils");
function useLabel(props) {
    let { id, label, "aria-labelledby": ariaLabelledby, "aria-label": ariaLabel, labelElementType = "label" } = props;
    id = (0, _utils.useId)(id);
    let labelId = (0, _utils.useId)();
    let labelProps = {};
    if (label) {
        ariaLabelledby = ariaLabelledby ? `${labelId} ${ariaLabelledby}` : labelId;
        labelProps = {
            id: labelId,
            htmlFor: labelElementType === "label" ? id : undefined
        };
    } else if (!ariaLabelledby && !ariaLabel) console.warn("If you do not provide a visible label, you must specify an aria-label or aria-labelledby attribute for accessibility");
    let fieldProps = (0, _utils.useLabels)({
        id,
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledby
    });
    return {
        labelProps,
        fieldProps
    };
}

},{"@react-aria/utils":"9cLk5","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"gvGRo":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides the behavior and accessibility implementation for a checkbox component contained within a checkbox group.
 * Checkbox groups allow users to select multiple items from a list of options.
 * @param props - Props for the checkbox.
 * @param state - State for the checkbox, as returned by `useCheckboxGroupState`.
 * @param inputRef - A ref for the HTML input element.
 */ parcelHelpers.export(exports, "useCheckboxGroupItem", ()=>useCheckboxGroupItem);
var _useCheckbox = require("./useCheckbox");
var _utils = require("./utils");
var _form = require("@react-stately/form");
var _react = require("react");
var _toggle = require("@react-stately/toggle");
function useCheckboxGroupItem(props, state, inputRef) {
    const toggleState = (0, _toggle.useToggleState)({
        isReadOnly: props.isReadOnly || state.isReadOnly,
        isSelected: state.isSelected(props.value),
        onChange (isSelected) {
            if (isSelected) state.addValue(props.value);
            else state.removeValue(props.value);
            if (props.onChange) props.onChange(isSelected);
        }
    });
    let { name, descriptionId, errorMessageId, validationBehavior } = (0, _utils.checkboxGroupData).get(state);
    var _props_validationBehavior;
    validationBehavior = (_props_validationBehavior = props.validationBehavior) !== null && _props_validationBehavior !== void 0 ? _props_validationBehavior : validationBehavior;
    // Local validation for this checkbox.
    let { realtimeValidation } = (0, _form.useFormValidationState)({
        ...props,
        value: toggleState.isSelected,
        // Server validation is handled at the group level.
        name: undefined,
        validationBehavior: "aria"
    });
    // Update the checkbox group state when realtime validation changes.
    let nativeValidation = (0, _react.useRef)((0, _form.DEFAULT_VALIDATION_RESULT));
    let updateValidation = ()=>{
        state.setInvalid(props.value, realtimeValidation.isInvalid ? realtimeValidation : nativeValidation.current);
    };
    (0, _react.useEffect)(updateValidation);
    // Combine group and checkbox level validation.
    let combinedRealtimeValidation = state.realtimeValidation.isInvalid ? state.realtimeValidation : realtimeValidation;
    let displayValidation = validationBehavior === "native" ? state.displayValidation : combinedRealtimeValidation;
    var _props_isRequired;
    let res = (0, _useCheckbox.useCheckbox)({
        ...props,
        isReadOnly: props.isReadOnly || state.isReadOnly,
        isDisabled: props.isDisabled || state.isDisabled,
        name: props.name || name,
        isRequired: (_props_isRequired = props.isRequired) !== null && _props_isRequired !== void 0 ? _props_isRequired : state.isRequired,
        validationBehavior,
        [(0, _form.privateValidationStateProp)]: {
            realtimeValidation: combinedRealtimeValidation,
            displayValidation,
            resetValidation: state.resetValidation,
            commitValidation: state.commitValidation,
            updateValidation (v) {
                nativeValidation.current = v;
                updateValidation();
            }
        }
    }, toggleState, inputRef);
    return {
        ...res,
        inputProps: {
            ...res.inputProps,
            "aria-describedby": [
                props["aria-describedby"],
                state.isInvalid ? errorMessageId : null,
                descriptionId
            ].filter(Boolean).join(" ") || undefined
        }
    };
}

},{"./useCheckbox":"dwpZB","./utils":"2ofnU","@react-stately/form":"9yZqm","react":"9yzVZ","@react-stately/toggle":"5qaKI","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"5qaKI":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useToggleState", ()=>(0, _useToggleState.useToggleState));
var _useToggleState = require("./useToggleState");

},{"./useToggleState":"7HGJ2","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"7HGJ2":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides state management for toggle components like checkboxes and switches.
 */ parcelHelpers.export(exports, "useToggleState", ()=>useToggleState);
var _utils = require("@react-stately/utils");
function useToggleState(props = {}) {
    let { isReadOnly } = props;
    // have to provide an empty function so useControlledState doesn't throw a fit
    // can't use useControlledState's prop calling because we need the event object from the change
    let [isSelected, setSelected] = (0, _utils.useControlledState)(props.isSelected, props.defaultSelected || false, props.onChange);
    function updateSelected(value) {
        if (!isReadOnly) setSelected(value);
    }
    function toggleState() {
        if (!isReadOnly) setSelected(!isSelected);
    }
    return {
        isSelected,
        setSelected: updateSelected,
        toggle: toggleState
    };
}

},{"@react-stately/utils":"cpDPf","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"4enyJ":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useComboBox", ()=>(0, _useComboBox.useComboBox));
var _useComboBox = require("./useComboBox");

},{"./useComboBox":"mOaNI","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"mOaNI":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides the behavior and accessibility implementation for a combo box component.
 * A combo box combines a text input with a listbox, allowing users to filter a list of options to items matching a query.
 * @param props - Props for the combo box.
 * @param state - State for the select, as returned by `useComboBoxState`.
 */ parcelHelpers.export(exports, "useComboBox", ()=>useComboBox);
var _liveAnnouncer = require("@react-aria/live-announcer");
var _overlays = require("@react-aria/overlays");
var _listbox = require("@react-aria/listbox");
var _utils = require("@react-aria/utils");
var _react = require("react");
var _collections = require("@react-stately/collections");
// @ts-ignore
var _json = require("../intl/*.json");
var _jsonDefault = parcelHelpers.interopDefault(_json);
var _selection = require("@react-aria/selection");
var _form = require("@react-stately/form");
var _i18N = require("@react-aria/i18n");
var _menu = require("@react-aria/menu");
var _textfield = require("@react-aria/textfield");
function useComboBox(props, state) {
    let { buttonRef, popoverRef, inputRef, listBoxRef, keyboardDelegate, // completionMode = 'suggest',
    shouldFocusWrap, isReadOnly, isDisabled } = props;
    let stringFormatter = (0, _i18N.useLocalizedStringFormatter)((0, _jsonDefault.default), "@react-aria/combobox");
    let { menuTriggerProps, menuProps } = (0, _menu.useMenuTrigger)({
        type: "listbox",
        isDisabled: isDisabled || isReadOnly
    }, state, buttonRef);
    // Set listbox id so it can be used when calling getItemId later
    (0, _listbox.listData).set(state, {
        id: menuProps.id
    });
    // By default, a KeyboardDelegate is provided which uses the DOM to query layout information (e.g. for page up/page down).
    // When virtualized, the layout object will be passed in as a prop and override this.
    let delegate = (0, _react.useMemo)(()=>keyboardDelegate || new (0, _selection.ListKeyboardDelegate)(state.collection, state.disabledKeys, listBoxRef), [
        keyboardDelegate,
        state.collection,
        state.disabledKeys,
        listBoxRef
    ]);
    // Use useSelectableCollection to get the keyboard handlers to apply to the textfield
    let { collectionProps } = (0, _selection.useSelectableCollection)({
        selectionManager: state.selectionManager,
        keyboardDelegate: delegate,
        disallowTypeAhead: true,
        disallowEmptySelection: true,
        shouldFocusWrap,
        ref: inputRef,
        // Prevent item scroll behavior from being applied here, should be handled in the user's Popover + ListBox component
        isVirtualized: true
    });
    let router = (0, _utils.useRouter)();
    // For textfield specific keydown operations
    let onKeyDown = (e)=>{
        switch(e.key){
            case "Enter":
            case "Tab":
                // Prevent form submission if menu is open since we may be selecting a option
                if (state.isOpen && e.key === "Enter") e.preventDefault();
                // If the focused item is a link, trigger opening it. Items that are links are not selectable.
                if (state.isOpen && state.selectionManager.focusedKey != null && state.selectionManager.isLink(state.selectionManager.focusedKey)) {
                    if (e.key === "Enter") {
                        let item = listBoxRef.current.querySelector(`[data-key="${CSS.escape(state.selectionManager.focusedKey.toString())}"]`);
                        if (item instanceof HTMLAnchorElement) router.open(item, e);
                    }
                    state.close();
                } else state.commit();
                break;
            case "Escape":
                if (state.selectedKey !== null || state.inputValue === "" || props.allowsCustomValue) e.continuePropagation();
                state.revert();
                break;
            case "ArrowDown":
                state.open("first", "manual");
                break;
            case "ArrowUp":
                state.open("last", "manual");
                break;
            case "ArrowLeft":
            case "ArrowRight":
                state.selectionManager.setFocusedKey(null);
                break;
        }
    };
    let onBlur = (e)=>{
        var _popoverRef_current;
        // Ignore blur if focused moved to the button or into the popover.
        if (e.relatedTarget === (buttonRef === null || buttonRef === void 0 ? void 0 : buttonRef.current) || ((_popoverRef_current = popoverRef.current) === null || _popoverRef_current === void 0 ? void 0 : _popoverRef_current.contains(e.relatedTarget))) return;
        if (props.onBlur) props.onBlur(e);
        state.setFocused(false);
    };
    let onFocus = (e)=>{
        if (state.isFocused) return;
        if (props.onFocus) props.onFocus(e);
        state.setFocused(true);
    };
    let { isInvalid, validationErrors, validationDetails } = state.displayValidation;
    let { labelProps, inputProps, descriptionProps, errorMessageProps } = (0, _textfield.useTextField)({
        ...props,
        onChange: state.setInputValue,
        onKeyDown: !isReadOnly ? (0, _utils.chain)(state.isOpen && collectionProps.onKeyDown, onKeyDown, props.onKeyDown) : props.onKeyDown,
        onBlur,
        value: state.inputValue,
        onFocus,
        autoComplete: "off",
        validate: undefined,
        [(0, _form.privateValidationStateProp)]: state
    }, inputRef);
    // Press handlers for the ComboBox button
    let onPress = (e)=>{
        if (e.pointerType === "touch") {
            // Focus the input field in case it isn't focused yet
            inputRef.current.focus();
            state.toggle(null, "manual");
        }
    };
    let onPressStart = (e)=>{
        if (e.pointerType !== "touch") {
            inputRef.current.focus();
            state.toggle(e.pointerType === "keyboard" || e.pointerType === "virtual" ? "first" : null, "manual");
        }
    };
    let triggerLabelProps = (0, _utils.useLabels)({
        id: menuTriggerProps.id,
        "aria-label": stringFormatter.format("buttonLabel"),
        "aria-labelledby": props["aria-labelledby"] || labelProps.id
    });
    let listBoxProps = (0, _utils.useLabels)({
        id: menuProps.id,
        "aria-label": stringFormatter.format("listboxLabel"),
        "aria-labelledby": props["aria-labelledby"] || labelProps.id
    });
    // If a touch happens on direct center of ComboBox input, might be virtual click from iPad so open ComboBox menu
    let lastEventTime = (0, _react.useRef)(0);
    let onTouchEnd = (e)=>{
        if (isDisabled || isReadOnly) return;
        // Sometimes VoiceOver on iOS fires two touchend events in quick succession. Ignore the second one.
        if (e.timeStamp - lastEventTime.current < 500) {
            e.preventDefault();
            inputRef.current.focus();
            return;
        }
        let rect = e.target.getBoundingClientRect();
        let touch = e.changedTouches[0];
        let centerX = Math.ceil(rect.left + .5 * rect.width);
        let centerY = Math.ceil(rect.top + .5 * rect.height);
        if (touch.clientX === centerX && touch.clientY === centerY) {
            e.preventDefault();
            inputRef.current.focus();
            state.toggle(null, "manual");
            lastEventTime.current = e.timeStamp;
        }
    };
    // VoiceOver has issues with announcing aria-activedescendant properly on change
    // (especially on iOS). We use a live region announcer to announce focus changes
    // manually. In addition, section titles are announced when navigating into a new section.
    let focusedItem = state.selectionManager.focusedKey != null && state.isOpen ? state.collection.getItem(state.selectionManager.focusedKey) : undefined;
    var _focusedItem_parentKey;
    let sectionKey = (_focusedItem_parentKey = focusedItem === null || focusedItem === void 0 ? void 0 : focusedItem.parentKey) !== null && _focusedItem_parentKey !== void 0 ? _focusedItem_parentKey : null;
    var _state_selectionManager_focusedKey;
    let itemKey = (_state_selectionManager_focusedKey = state.selectionManager.focusedKey) !== null && _state_selectionManager_focusedKey !== void 0 ? _state_selectionManager_focusedKey : null;
    let lastSection = (0, _react.useRef)(sectionKey);
    let lastItem = (0, _react.useRef)(itemKey);
    (0, _react.useEffect)(()=>{
        if ((0, _utils.isAppleDevice)() && focusedItem != null && itemKey !== lastItem.current) {
            let isSelected = state.selectionManager.isSelected(itemKey);
            let section = sectionKey != null ? state.collection.getItem(sectionKey) : null;
            let sectionTitle = (section === null || section === void 0 ? void 0 : section["aria-label"]) || (typeof (section === null || section === void 0 ? void 0 : section.rendered) === "string" ? section.rendered : "") || "";
            let announcement = stringFormatter.format("focusAnnouncement", {
                isGroupChange: section && sectionKey !== lastSection.current,
                groupTitle: sectionTitle,
                groupCount: section ? [
                    ...(0, _collections.getChildNodes)(section, state.collection)
                ].length : 0,
                optionText: focusedItem["aria-label"] || focusedItem.textValue || "",
                isSelected
            });
            (0, _liveAnnouncer.announce)(announcement);
        }
        lastSection.current = sectionKey;
        lastItem.current = itemKey;
    });
    // Announce the number of available suggestions when it changes
    let optionCount = (0, _collections.getItemCount)(state.collection);
    let lastSize = (0, _react.useRef)(optionCount);
    let lastOpen = (0, _react.useRef)(state.isOpen);
    (0, _react.useEffect)(()=>{
        // Only announce the number of options available when the menu opens if there is no
        // focused item, otherwise screen readers will typically read e.g. "1 of 6".
        // The exception is VoiceOver since this isn't included in the message above.
        let didOpenWithoutFocusedItem = state.isOpen !== lastOpen.current && (state.selectionManager.focusedKey == null || (0, _utils.isAppleDevice)());
        if (state.isOpen && (didOpenWithoutFocusedItem || optionCount !== lastSize.current)) {
            let announcement = stringFormatter.format("countAnnouncement", {
                optionCount
            });
            (0, _liveAnnouncer.announce)(announcement);
        }
        lastSize.current = optionCount;
        lastOpen.current = state.isOpen;
    });
    // Announce when a selection occurs for VoiceOver. Other screen readers typically do this automatically.
    let lastSelectedKey = (0, _react.useRef)(state.selectedKey);
    (0, _react.useEffect)(()=>{
        if ((0, _utils.isAppleDevice)() && state.isFocused && state.selectedItem && state.selectedKey !== lastSelectedKey.current) {
            let optionText = state.selectedItem["aria-label"] || state.selectedItem.textValue || "";
            let announcement = stringFormatter.format("selectedAnnouncement", {
                optionText
            });
            (0, _liveAnnouncer.announce)(announcement);
        }
        lastSelectedKey.current = state.selectedKey;
    });
    (0, _react.useEffect)(()=>{
        if (state.isOpen) return (0, _overlays.ariaHideOutside)([
            inputRef.current,
            popoverRef.current
        ]);
    }, [
        state.isOpen,
        inputRef,
        popoverRef
    ]);
    return {
        labelProps,
        buttonProps: {
            ...menuTriggerProps,
            ...triggerLabelProps,
            excludeFromTabOrder: true,
            onPress,
            onPressStart,
            isDisabled: isDisabled || isReadOnly
        },
        inputProps: (0, _utils.mergeProps)(inputProps, {
            role: "combobox",
            "aria-expanded": menuTriggerProps["aria-expanded"],
            "aria-controls": state.isOpen ? menuProps.id : undefined,
            // TODO: readd proper logic for completionMode = complete (aria-autocomplete: both)
            "aria-autocomplete": "list",
            "aria-activedescendant": focusedItem ? (0, _listbox.getItemId)(state, focusedItem.key) : undefined,
            onTouchEnd,
            // This disable's iOS's autocorrect suggestions, since the combo box provides its own suggestions.
            autoCorrect: "off",
            // This disable's the macOS Safari spell check auto corrections.
            spellCheck: "false"
        }),
        listBoxProps: (0, _utils.mergeProps)(menuProps, listBoxProps, {
            autoFocus: state.focusStrategy,
            shouldUseVirtualFocus: true,
            shouldSelectOnPressUp: true,
            shouldFocusOnHover: true,
            linkBehavior: "selection"
        }),
        descriptionProps,
        errorMessageProps,
        isInvalid,
        validationErrors,
        validationDetails
    };
}

},{"@react-aria/live-announcer":"ipdGY","@react-aria/overlays":"5fTCg","@react-aria/listbox":"bHZSJ","@react-aria/utils":"9cLk5","react":"9yzVZ","@react-stately/collections":"loANi","../intl/*.json":"5cZRr","@react-aria/selection":"6Fly5","@react-stately/form":"9yZqm","@react-aria/i18n":"411rg","@react-aria/menu":"89bvn","@react-aria/textfield":"6dEv6","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"5fTCg":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useOverlayPosition", ()=>(0, _useOverlayPosition.useOverlayPosition));
parcelHelpers.export(exports, "useOverlay", ()=>(0, _useOverlay.useOverlay));
parcelHelpers.export(exports, "useOverlayTrigger", ()=>(0, _useOverlayTrigger.useOverlayTrigger));
parcelHelpers.export(exports, "usePreventScroll", ()=>(0, _usePreventScroll.usePreventScroll));
parcelHelpers.export(exports, "ModalProvider", ()=>(0, _useModal.ModalProvider));
parcelHelpers.export(exports, "useModalProvider", ()=>(0, _useModal.useModalProvider));
parcelHelpers.export(exports, "OverlayProvider", ()=>(0, _useModal.OverlayProvider));
parcelHelpers.export(exports, "OverlayContainer", ()=>(0, _useModal.OverlayContainer));
parcelHelpers.export(exports, "useModal", ()=>(0, _useModal.useModal));
parcelHelpers.export(exports, "DismissButton", ()=>(0, _dismissButton.DismissButton));
parcelHelpers.export(exports, "ariaHideOutside", ()=>(0, _ariaHideOutside.ariaHideOutside));
parcelHelpers.export(exports, "usePopover", ()=>(0, _usePopover.usePopover));
parcelHelpers.export(exports, "useModalOverlay", ()=>(0, _useModalOverlay.useModalOverlay));
parcelHelpers.export(exports, "Overlay", ()=>(0, _overlay.Overlay));
parcelHelpers.export(exports, "useOverlayFocusContain", ()=>(0, _overlay.useOverlayFocusContain));
var _useOverlayPosition = require("./useOverlayPosition");
var _useOverlay = require("./useOverlay");
var _useOverlayTrigger = require("./useOverlayTrigger");
var _usePreventScroll = require("./usePreventScroll");
var _useModal = require("./useModal");
var _dismissButton = require("./DismissButton");
var _ariaHideOutside = require("./ariaHideOutside");
var _usePopover = require("./usePopover");
var _useModalOverlay = require("./useModalOverlay");
var _overlay = require("./Overlay");

},{"./useOverlayPosition":"dtvF4","./useOverlay":"2gAD2","./useOverlayTrigger":"9uDk7","./usePreventScroll":"dBVf0","./useModal":"lh0FP","./DismissButton":"iG075","./ariaHideOutside":"1mjNB","./usePopover":"llONW","./useModalOverlay":"fTHZz","./Overlay":"Lhjy6","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"dtvF4":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Handles positioning overlays like popovers and menus relative to a trigger
 * element, and updating the position when the window resizes.
 */ parcelHelpers.export(exports, "useOverlayPosition", ()=>useOverlayPosition);
var _calculatePosition = require("./calculatePosition");
var _react = require("react");
var _useCloseOnScroll = require("./useCloseOnScroll");
var _utils = require("@react-aria/utils");
var _i18N = require("@react-aria/i18n");
// @ts-ignore
let visualViewport = typeof document !== "undefined" && window.visualViewport;
function useOverlayPosition(props) {
    let { direction } = (0, _i18N.useLocale)();
    let { arrowSize = 0, targetRef, overlayRef, scrollRef = overlayRef, placement = "bottom", containerPadding = 12, shouldFlip = true, boundaryElement = typeof document !== "undefined" ? document.body : null, offset = 0, crossOffset = 0, shouldUpdatePosition = true, isOpen = true, onClose, maxHeight, arrowBoundaryOffset = 0 } = props;
    let [position, setPosition] = (0, _react.useState)({
        position: {},
        arrowOffsetLeft: undefined,
        arrowOffsetTop: undefined,
        maxHeight: undefined,
        placement: undefined
    });
    let deps = [
        shouldUpdatePosition,
        placement,
        overlayRef.current,
        targetRef.current,
        scrollRef.current,
        containerPadding,
        shouldFlip,
        boundaryElement,
        offset,
        crossOffset,
        isOpen,
        direction,
        maxHeight,
        arrowBoundaryOffset,
        arrowSize
    ];
    // Note, the position freezing breaks if body sizes itself dynamicly with the visual viewport but that might
    // just be a non-realistic use case
    // Upon opening a overlay, record the current visual viewport scale so we can freeze the overlay styles
    let lastScale = (0, _react.useRef)(visualViewport === null || visualViewport === void 0 ? void 0 : visualViewport.scale);
    (0, _react.useEffect)(()=>{
        if (isOpen) lastScale.current = visualViewport === null || visualViewport === void 0 ? void 0 : visualViewport.scale;
    }, [
        isOpen
    ]);
    let updatePosition = (0, _react.useCallback)(()=>{
        if (shouldUpdatePosition === false || !isOpen || !overlayRef.current || !targetRef.current || !scrollRef.current || !boundaryElement) return;
        if ((visualViewport === null || visualViewport === void 0 ? void 0 : visualViewport.scale) !== lastScale.current) return;
        // Always reset the overlay's previous max height if not defined by the user so that we can compensate for
        // RAC collections populating after a second render and properly set a correct max height + positioning when it populates.
        if (!maxHeight && overlayRef.current) overlayRef.current.style.maxHeight = "none";
        let position = (0, _calculatePosition.calculatePosition)({
            placement: translateRTL(placement, direction),
            overlayNode: overlayRef.current,
            targetNode: targetRef.current,
            scrollNode: scrollRef.current,
            padding: containerPadding,
            shouldFlip,
            boundaryElement,
            offset,
            crossOffset,
            maxHeight,
            arrowSize,
            arrowBoundaryOffset
        });
        // Modify overlay styles directly so positioning happens immediately without the need of a second render
        // This is so we don't have to delay autoFocus scrolling or delay applying preventScroll for popovers
        Object.keys(position.position).forEach((key)=>overlayRef.current.style[key] = position.position[key] + "px");
        overlayRef.current.style.maxHeight = position.maxHeight != null ? position.maxHeight + "px" : undefined;
        // Trigger a set state for a second render anyway for arrow positioning
        setPosition(position);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
    // Update position when anything changes
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, _utils.useLayoutEffect)(updatePosition, deps);
    // Update position on window resize
    useResize(updatePosition);
    // Update position when the overlay changes size (might need to flip).
    (0, _utils.useResizeObserver)({
        ref: overlayRef,
        onResize: updatePosition
    });
    // Reposition the overlay and do not close on scroll while the visual viewport is resizing.
    // This will ensure that overlays adjust their positioning when the iOS virtual keyboard appears.
    let isResizing = (0, _react.useRef)(false);
    (0, _utils.useLayoutEffect)(()=>{
        let timeout;
        let onResize = ()=>{
            isResizing.current = true;
            clearTimeout(timeout);
            timeout = setTimeout(()=>{
                isResizing.current = false;
            }, 500);
            updatePosition();
        };
        // Only reposition the overlay if a scroll event happens immediately as a result of resize (aka the virtual keyboard has appears)
        // We don't want to reposition the overlay if the user has pinch zoomed in and is scrolling the viewport around.
        let onScroll = ()=>{
            if (isResizing.current) onResize();
        };
        visualViewport === null || visualViewport === void 0 ? void 0 : visualViewport.addEventListener("resize", onResize);
        visualViewport === null || visualViewport === void 0 ? void 0 : visualViewport.addEventListener("scroll", onScroll);
        return ()=>{
            visualViewport === null || visualViewport === void 0 ? void 0 : visualViewport.removeEventListener("resize", onResize);
            visualViewport === null || visualViewport === void 0 ? void 0 : visualViewport.removeEventListener("scroll", onScroll);
        };
    }, [
        updatePosition
    ]);
    let close = (0, _react.useCallback)(()=>{
        if (!isResizing.current) onClose();
    }, [
        onClose,
        isResizing
    ]);
    // When scrolling a parent scrollable region of the trigger (other than the body),
    // we hide the popover. Otherwise, its position would be incorrect.
    (0, _useCloseOnScroll.useCloseOnScroll)({
        triggerRef: targetRef,
        isOpen,
        onClose: onClose && close
    });
    return {
        overlayProps: {
            style: {
                position: "absolute",
                zIndex: 100000,
                ...position.position,
                maxHeight: position.maxHeight
            }
        },
        placement: position.placement,
        arrowProps: {
            "aria-hidden": "true",
            role: "presentation",
            style: {
                left: position.arrowOffsetLeft,
                top: position.arrowOffsetTop
            }
        },
        updatePosition
    };
}
function useResize(onResize) {
    (0, _utils.useLayoutEffect)(()=>{
        window.addEventListener("resize", onResize, false);
        return ()=>{
            window.removeEventListener("resize", onResize, false);
        };
    }, [
        onResize
    ]);
}
function translateRTL(position, direction) {
    if (direction === "rtl") return position.replace("start", "right").replace("end", "left");
    return position.replace("start", "left").replace("end", "right");
}

},{"./calculatePosition":"1mHyL","react":"9yzVZ","./useCloseOnScroll":"6U3bE","@react-aria/utils":"9cLk5","@react-aria/i18n":"411rg","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"1mHyL":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "calculatePositionInternal", ()=>calculatePositionInternal);
/**
 * Determines where to place the overlay with regards to the target and the position of an optional indicator.
 */ parcelHelpers.export(exports, "calculatePosition", ()=>calculatePosition);
var _utils = require("@react-aria/utils");
const AXIS = {
    top: "top",
    bottom: "top",
    left: "left",
    right: "left"
};
const FLIPPED_DIRECTION = {
    top: "bottom",
    bottom: "top",
    left: "right",
    right: "left"
};
const CROSS_AXIS = {
    top: "left",
    left: "top"
};
const AXIS_SIZE = {
    top: "height",
    left: "width"
};
const TOTAL_SIZE = {
    width: "totalWidth",
    height: "totalHeight"
};
const PARSED_PLACEMENT_CACHE = {};
// @ts-ignore
let visualViewport = typeof document !== "undefined" && window.visualViewport;
function getContainerDimensions(containerNode) {
    let width = 0, height = 0, totalWidth = 0, totalHeight = 0, top = 0, left = 0;
    let scroll = {};
    let isPinchZoomedIn = (visualViewport === null || visualViewport === void 0 ? void 0 : visualViewport.scale) > 1;
    if (containerNode.tagName === "BODY") {
        let documentElement = document.documentElement;
        totalWidth = documentElement.clientWidth;
        totalHeight = documentElement.clientHeight;
        var _visualViewport_width;
        width = (_visualViewport_width = visualViewport === null || visualViewport === void 0 ? void 0 : visualViewport.width) !== null && _visualViewport_width !== void 0 ? _visualViewport_width : totalWidth;
        var _visualViewport_height;
        height = (_visualViewport_height = visualViewport === null || visualViewport === void 0 ? void 0 : visualViewport.height) !== null && _visualViewport_height !== void 0 ? _visualViewport_height : totalHeight;
        scroll.top = documentElement.scrollTop || containerNode.scrollTop;
        scroll.left = documentElement.scrollLeft || containerNode.scrollLeft;
        // The goal of the below is to get a top/left value that represents the top/left of the visual viewport with
        // respect to the layout viewport origin. This combined with the scrollTop/scrollLeft will allow us to calculate
        // coordinates/values with respect to the visual viewport or with respect to the layout viewport.
        if (visualViewport) {
            top = visualViewport.offsetTop;
            left = visualViewport.offsetLeft;
        }
    } else {
        ({ width, height, top, left } = getOffset(containerNode));
        scroll.top = containerNode.scrollTop;
        scroll.left = containerNode.scrollLeft;
        totalWidth = width;
        totalHeight = height;
    }
    if ((0, _utils.isWebKit)() && (containerNode.tagName === "BODY" || containerNode.tagName === "HTML") && isPinchZoomedIn) {
        // Safari will report a non-zero scrollTop/Left for the non-scrolling body/HTML element when pinch zoomed in unlike other browsers.
        // Set to zero for parity calculations so we get consistent positioning of overlays across all browsers.
        // Also switch to visualViewport.pageTop/pageLeft so that we still accomodate for scroll positioning for body/HTML elements that are actually scrollable
        // before pinch zoom happens
        scroll.top = 0;
        scroll.left = 0;
        top = visualViewport.pageTop;
        left = visualViewport.pageLeft;
    }
    return {
        width,
        height,
        totalWidth,
        totalHeight,
        scroll,
        top,
        left
    };
}
function getScroll(node) {
    return {
        top: node.scrollTop,
        left: node.scrollLeft,
        width: node.scrollWidth,
        height: node.scrollHeight
    };
}
// Determines the amount of space required when moving the overlay to ensure it remains in the boundary
function getDelta(axis, offset, size, // The dimensions of the boundary element that the popover is
// positioned within (most of the time this is the <body>).
boundaryDimensions, // The dimensions of the containing block element that the popover is
// positioned relative to (e.g. parent with position: relative).
// Usually this is the same as the boundary element, but if the popover
// is portaled somewhere other than the body and has an ancestor with
// position: relative/absolute, it will be different.
containerDimensions, padding, containerOffsetWithBoundary) {
    let containerScroll = containerDimensions.scroll[axis];
    // The height/width of the boundary. Matches the axis along which we are adjusting the overlay position
    let boundarySize = boundaryDimensions[AXIS_SIZE[axis]];
    // Calculate the edges of the boundary (accomodating for the boundary padding) and the edges of the overlay.
    // Note that these values are with respect to the visual viewport (aka 0,0 is the top left of the viewport)
    let boundaryStartEdge = boundaryDimensions.scroll[AXIS[axis]] + padding;
    let boundaryEndEdge = boundarySize + boundaryDimensions.scroll[AXIS[axis]] - padding;
    let startEdgeOffset = offset - containerScroll + containerOffsetWithBoundary[axis] - boundaryDimensions[AXIS[axis]];
    let endEdgeOffset = offset - containerScroll + size + containerOffsetWithBoundary[axis] - boundaryDimensions[AXIS[axis]];
    // If any of the overlay edges falls outside of the boundary, shift the overlay the required amount to align one of the overlay's
    // edges with the closest boundary edge.
    if (startEdgeOffset < boundaryStartEdge) return boundaryStartEdge - startEdgeOffset;
    else if (endEdgeOffset > boundaryEndEdge) return Math.max(boundaryEndEdge - endEdgeOffset, boundaryStartEdge - startEdgeOffset);
    else return 0;
}
function getMargins(node) {
    let style = window.getComputedStyle(node);
    return {
        top: parseInt(style.marginTop, 10) || 0,
        bottom: parseInt(style.marginBottom, 10) || 0,
        left: parseInt(style.marginLeft, 10) || 0,
        right: parseInt(style.marginRight, 10) || 0
    };
}
function parsePlacement(input) {
    if (PARSED_PLACEMENT_CACHE[input]) return PARSED_PLACEMENT_CACHE[input];
    let [placement, crossPlacement] = input.split(" ");
    let axis = AXIS[placement] || "right";
    let crossAxis = CROSS_AXIS[axis];
    if (!AXIS[crossPlacement]) crossPlacement = "center";
    let size = AXIS_SIZE[axis];
    let crossSize = AXIS_SIZE[crossAxis];
    PARSED_PLACEMENT_CACHE[input] = {
        placement,
        crossPlacement,
        axis,
        crossAxis,
        size,
        crossSize
    };
    return PARSED_PLACEMENT_CACHE[input];
}
function computePosition(childOffset, boundaryDimensions, overlaySize, placementInfo, offset, crossOffset, containerOffsetWithBoundary, isContainerPositioned, arrowSize, arrowBoundaryOffset) {
    let { placement, crossPlacement, axis, crossAxis, size, crossSize } = placementInfo;
    let position = {};
    // button position
    position[crossAxis] = childOffset[crossAxis];
    if (crossPlacement === "center") //  + (button size / 2) - (overlay size / 2)
    // at this point the overlay center should match the button center
    position[crossAxis] += (childOffset[crossSize] - overlaySize[crossSize]) / 2;
    else if (crossPlacement !== crossAxis) //  + (button size) - (overlay size)
    // at this point the overlay bottom should match the button bottom
    position[crossAxis] += childOffset[crossSize] - overlaySize[crossSize];
     /* else {
    the overlay top should match the button top
  } */ 
    position[crossAxis] += crossOffset;
    // overlay top overlapping arrow with button bottom
    const minPosition = childOffset[crossAxis] - overlaySize[crossSize] + arrowSize + arrowBoundaryOffset;
    // overlay bottom overlapping arrow with button top
    const maxPosition = childOffset[crossAxis] + childOffset[crossSize] - arrowSize - arrowBoundaryOffset;
    position[crossAxis] = (0, _utils.clamp)(position[crossAxis], minPosition, maxPosition);
    // Floor these so the position isn't placed on a partial pixel, only whole pixels. Shouldn't matter if it was floored or ceiled, so chose one.
    if (placement === axis) {
        // If the container is positioned (non-static), then we use the container's actual
        // height, as `bottom` will be relative to this height.  But if the container is static,
        // then it can only be the `document.body`, and `bottom` will be relative to _its_
        // container, which should be as large as boundaryDimensions.
        const containerHeight = isContainerPositioned ? containerOffsetWithBoundary[size] : boundaryDimensions[TOTAL_SIZE[size]];
        position[FLIPPED_DIRECTION[axis]] = Math.floor(containerHeight - childOffset[axis] + offset);
    } else position[axis] = Math.floor(childOffset[axis] + childOffset[size] + offset);
    return position;
}
function getMaxHeight(position, boundaryDimensions, containerOffsetWithBoundary, isContainerPositioned, margins, padding, overlayHeight, heightGrowthDirection) {
    const containerHeight = isContainerPositioned ? containerOffsetWithBoundary.height : boundaryDimensions[TOTAL_SIZE.height];
    // For cases where position is set via "bottom" instead of "top", we need to calculate the true overlay top with respect to the boundary. Reverse calculate this with the same method
    // used in computePosition.
    let overlayTop = position.top != null ? containerOffsetWithBoundary.top + position.top : containerOffsetWithBoundary.top + (containerHeight - position.bottom - overlayHeight);
    let maxHeight = heightGrowthDirection !== "top" ? // We want the distance between the top of the overlay to the bottom of the boundary
    Math.max(0, boundaryDimensions.height + boundaryDimensions.top + boundaryDimensions.scroll.top // this is the bottom of the boundary
     - overlayTop // this is the top of the overlay
     - (margins.top + margins.bottom + padding // save additional space for margin and padding
    )) : Math.max(0, overlayTop + overlayHeight // this is the bottom of the overlay
     - (boundaryDimensions.top + boundaryDimensions.scroll.top // this is the top of the boundary
    ) - (margins.top + margins.bottom + padding // save additional space for margin and padding
    ));
    return Math.min(boundaryDimensions.height - padding * 2, maxHeight);
}
function getAvailableSpace(boundaryDimensions, containerOffsetWithBoundary, childOffset, margins, padding, placementInfo) {
    let { placement, axis, size } = placementInfo;
    if (placement === axis) return Math.max(0, childOffset[axis] - boundaryDimensions[axis] - boundaryDimensions.scroll[axis] + containerOffsetWithBoundary[axis] - margins[axis] - margins[FLIPPED_DIRECTION[axis]] - padding);
    return Math.max(0, boundaryDimensions[size] + boundaryDimensions[axis] + boundaryDimensions.scroll[axis] - containerOffsetWithBoundary[axis] - childOffset[axis] - childOffset[size] - margins[axis] - margins[FLIPPED_DIRECTION[axis]] - padding);
}
function calculatePositionInternal(placementInput, childOffset, overlaySize, scrollSize, margins, padding, flip, boundaryDimensions, containerDimensions, containerOffsetWithBoundary, offset, crossOffset, isContainerPositioned, userSetMaxHeight, arrowSize, arrowBoundaryOffset) {
    let placementInfo = parsePlacement(placementInput);
    let { size, crossAxis, crossSize, placement, crossPlacement } = placementInfo;
    let position = computePosition(childOffset, boundaryDimensions, overlaySize, placementInfo, offset, crossOffset, containerOffsetWithBoundary, isContainerPositioned, arrowSize, arrowBoundaryOffset);
    let normalizedOffset = offset;
    let space = getAvailableSpace(boundaryDimensions, containerOffsetWithBoundary, childOffset, margins, padding + offset, placementInfo);
    // Check if the scroll size of the overlay is greater than the available space to determine if we need to flip
    if (flip && scrollSize[size] > space) {
        let flippedPlacementInfo = parsePlacement(`${FLIPPED_DIRECTION[placement]} ${crossPlacement}`);
        let flippedPosition = computePosition(childOffset, boundaryDimensions, overlaySize, flippedPlacementInfo, offset, crossOffset, containerOffsetWithBoundary, isContainerPositioned, arrowSize, arrowBoundaryOffset);
        let flippedSpace = getAvailableSpace(boundaryDimensions, containerOffsetWithBoundary, childOffset, margins, padding + offset, flippedPlacementInfo);
        // If the available space for the flipped position is greater than the original available space, flip.
        if (flippedSpace > space) {
            placementInfo = flippedPlacementInfo;
            position = flippedPosition;
            normalizedOffset = offset;
        }
    }
    // Determine the direction the height of the overlay can grow so that we can choose how to calculate the max height
    let heightGrowthDirection = "bottom";
    if (placementInfo.axis === "top") {
        if (placementInfo.placement === "top") heightGrowthDirection = "top";
        else if (placementInfo.placement === "bottom") heightGrowthDirection = "bottom";
    } else if (placementInfo.crossAxis === "top") {
        if (placementInfo.crossPlacement === "top") heightGrowthDirection = "bottom";
        else if (placementInfo.crossPlacement === "bottom") heightGrowthDirection = "top";
    }
    let delta = getDelta(crossAxis, position[crossAxis], overlaySize[crossSize], boundaryDimensions, containerDimensions, padding, containerOffsetWithBoundary);
    position[crossAxis] += delta;
    let maxHeight = getMaxHeight(position, boundaryDimensions, containerOffsetWithBoundary, isContainerPositioned, margins, padding, overlaySize.height, heightGrowthDirection);
    if (userSetMaxHeight && userSetMaxHeight < maxHeight) maxHeight = userSetMaxHeight;
    overlaySize.height = Math.min(overlaySize.height, maxHeight);
    position = computePosition(childOffset, boundaryDimensions, overlaySize, placementInfo, normalizedOffset, crossOffset, containerOffsetWithBoundary, isContainerPositioned, arrowSize, arrowBoundaryOffset);
    delta = getDelta(crossAxis, position[crossAxis], overlaySize[crossSize], boundaryDimensions, containerDimensions, padding, containerOffsetWithBoundary);
    position[crossAxis] += delta;
    let arrowPosition = {};
    // All values are transformed so that 0 is at the top/left of the overlay depending on the orientation
    // Prefer the arrow being in the center of the trigger/overlay anchor element
    let preferredArrowPosition = childOffset[crossAxis] + .5 * childOffset[crossSize] - overlaySize[crossAxis];
    // Min/Max position limits for the arrow with respect to the overlay
    const arrowMinPosition = arrowSize / 2 + arrowBoundaryOffset;
    const arrowMaxPosition = overlaySize[crossSize] - arrowSize / 2 - arrowBoundaryOffset;
    // Min/Max position limits for the arrow with respect to the trigger/overlay anchor element
    const arrowOverlappingChildMinEdge = childOffset[crossAxis] - overlaySize[crossAxis] + arrowSize / 2;
    const arrowOverlappingChildMaxEdge = childOffset[crossAxis] + childOffset[crossSize] - overlaySize[crossAxis] - arrowSize / 2;
    // Clamp the arrow positioning so that it always is within the bounds of the anchor and the overlay
    const arrowPositionOverlappingChild = (0, _utils.clamp)(preferredArrowPosition, arrowOverlappingChildMinEdge, arrowOverlappingChildMaxEdge);
    arrowPosition[crossAxis] = (0, _utils.clamp)(arrowPositionOverlappingChild, arrowMinPosition, arrowMaxPosition);
    return {
        position,
        maxHeight: maxHeight,
        arrowOffsetLeft: arrowPosition.left,
        arrowOffsetTop: arrowPosition.top,
        placement: placementInfo.placement
    };
}
function calculatePosition(opts) {
    let { placement, targetNode, overlayNode, scrollNode, padding, shouldFlip, boundaryElement, offset, crossOffset, maxHeight, arrowSize = 0, arrowBoundaryOffset = 0 } = opts;
    let container = overlayNode instanceof HTMLElement ? getContainingBlock(overlayNode) : document.documentElement;
    let isViewportContainer = container === document.documentElement;
    const containerPositionStyle = window.getComputedStyle(container).position;
    let isContainerPositioned = !!containerPositionStyle && containerPositionStyle !== "static";
    let childOffset = isViewportContainer ? getOffset(targetNode) : getPosition(targetNode, container);
    if (!isViewportContainer) {
        let { marginTop, marginLeft } = window.getComputedStyle(targetNode);
        childOffset.top += parseInt(marginTop, 10) || 0;
        childOffset.left += parseInt(marginLeft, 10) || 0;
    }
    let overlaySize = getOffset(overlayNode);
    let margins = getMargins(overlayNode);
    overlaySize.width += margins.left + margins.right;
    overlaySize.height += margins.top + margins.bottom;
    let scrollSize = getScroll(scrollNode);
    let boundaryDimensions = getContainerDimensions(boundaryElement);
    let containerDimensions = getContainerDimensions(container);
    // If the container is the HTML element wrapping the body element, the retrieved scrollTop/scrollLeft will be equal to the
    // body element's scroll. Set the container's scroll values to 0 since the overlay's edge position value in getDelta don't then need to be further offset
    // by the container scroll since they are essentially the same containing element and thus in the same coordinate system
    let containerOffsetWithBoundary = boundaryElement.tagName === "BODY" ? getOffset(container) : getPosition(container, boundaryElement);
    if (container.tagName === "HTML" && boundaryElement.tagName === "BODY") {
        containerDimensions.scroll.top = 0;
        containerDimensions.scroll.left = 0;
    }
    return calculatePositionInternal(placement, childOffset, overlaySize, scrollSize, margins, padding, shouldFlip, boundaryDimensions, containerDimensions, containerOffsetWithBoundary, offset, crossOffset, isContainerPositioned, maxHeight, arrowSize, arrowBoundaryOffset);
}
function getOffset(node) {
    let { top, left, width, height } = node.getBoundingClientRect();
    let { scrollTop, scrollLeft, clientTop, clientLeft } = document.documentElement;
    return {
        top: top + scrollTop - clientTop,
        left: left + scrollLeft - clientLeft,
        width,
        height
    };
}
function getPosition(node, parent) {
    let style = window.getComputedStyle(node);
    let offset;
    if (style.position === "fixed") {
        let { top, left, width, height } = node.getBoundingClientRect();
        offset = {
            top,
            left,
            width,
            height
        };
    } else {
        offset = getOffset(node);
        let parentOffset = getOffset(parent);
        let parentStyle = window.getComputedStyle(parent);
        parentOffset.top += (parseInt(parentStyle.borderTopWidth, 10) || 0) - parent.scrollTop;
        parentOffset.left += (parseInt(parentStyle.borderLeftWidth, 10) || 0) - parent.scrollLeft;
        offset.top -= parentOffset.top;
        offset.left -= parentOffset.left;
    }
    offset.top -= parseInt(style.marginTop, 10) || 0;
    offset.left -= parseInt(style.marginLeft, 10) || 0;
    return offset;
}
// Returns the containing block of an element, which is the element that
// this element will be positioned relative to.
// https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block
function getContainingBlock(node) {
    // The offsetParent of an element in most cases equals the containing block.
    // https://w3c.github.io/csswg-drafts/cssom-view/#dom-htmlelement-offsetparent
    let offsetParent = node.offsetParent;
    // The offsetParent algorithm terminates at the document body,
    // even if the body is not a containing block. Double check that
    // and use the documentElement if so.
    if (offsetParent && offsetParent === document.body && window.getComputedStyle(offsetParent).position === "static" && !isContainingBlock(offsetParent)) offsetParent = document.documentElement;
    // TODO(later): handle table elements?
    // The offsetParent can be null if the element has position: fixed, or a few other cases.
    // We have to walk up the tree manually in this case because fixed positioned elements
    // are still positioned relative to their containing block, which is not always the viewport.
    if (offsetParent == null) {
        offsetParent = node.parentElement;
        while(offsetParent && !isContainingBlock(offsetParent))offsetParent = offsetParent.parentElement;
    }
    // Fall back to the viewport.
    return offsetParent || document.documentElement;
}
// https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
function isContainingBlock(node) {
    let style = window.getComputedStyle(node);
    return style.transform !== "none" || /transform|perspective/.test(style.willChange) || style.filter !== "none" || style.contain === "paint" || // @ts-ignore
    "backdropFilter" in style && style.backdropFilter !== "none" || // @ts-ignore
    "WebkitBackdropFilter" in style && style.WebkitBackdropFilter !== "none";
}

},{"@react-aria/utils":"9cLk5","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"6U3bE":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "onCloseMap", ()=>onCloseMap);
/** @private */ parcelHelpers.export(exports, "useCloseOnScroll", ()=>useCloseOnScroll);
var _react = require("react");
const onCloseMap = new WeakMap();
function useCloseOnScroll(opts) {
    let { triggerRef, isOpen, onClose } = opts;
    (0, _react.useEffect)(()=>{
        if (!isOpen || onClose === null) return;
        let onScroll = (e)=>{
            // Ignore if scrolling an scrollable region outside the trigger's tree.
            let target = e.target;
            // window is not a Node and doesn't have contain, but window contains everything
            if (!triggerRef.current || target instanceof Node && !target.contains(triggerRef.current)) return;
            let onCloseHandler = onClose || onCloseMap.get(triggerRef.current);
            if (onCloseHandler) onCloseHandler();
        };
        window.addEventListener("scroll", onScroll, true);
        return ()=>{
            window.removeEventListener("scroll", onScroll, true);
        };
    }, [
        isOpen,
        onClose,
        triggerRef
    ]);
}

},{"react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"2gAD2":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides the behavior for overlays such as dialogs, popovers, and menus.
 * Hides the overlay when the user interacts outside it, when the Escape key is pressed,
 * or optionally, on blur. Only the top-most overlay will close at once.
 */ parcelHelpers.export(exports, "useOverlay", ()=>useOverlay);
var _focus = require("@react-aria/focus");
var _react = require("react");
var _interactions = require("@react-aria/interactions");
const visibleOverlays = [];
function useOverlay(props, ref) {
    let { onClose, shouldCloseOnBlur, isOpen, isDismissable = false, isKeyboardDismissDisabled = false, shouldCloseOnInteractOutside } = props;
    // Add the overlay ref to the stack of visible overlays on mount, and remove on unmount.
    (0, _react.useEffect)(()=>{
        if (isOpen) visibleOverlays.push(ref);
        return ()=>{
            let index = visibleOverlays.indexOf(ref);
            if (index >= 0) visibleOverlays.splice(index, 1);
        };
    }, [
        isOpen,
        ref
    ]);
    // Only hide the overlay when it is the topmost visible overlay in the stack
    let onHide = ()=>{
        if (visibleOverlays[visibleOverlays.length - 1] === ref && onClose) onClose();
    };
    let onInteractOutsideStart = (e)=>{
        if (!shouldCloseOnInteractOutside || shouldCloseOnInteractOutside(e.target)) {
            if (visibleOverlays[visibleOverlays.length - 1] === ref) {
                e.stopPropagation();
                e.preventDefault();
            }
        }
    };
    let onInteractOutside = (e)=>{
        if (!shouldCloseOnInteractOutside || shouldCloseOnInteractOutside(e.target)) {
            if (visibleOverlays[visibleOverlays.length - 1] === ref) {
                e.stopPropagation();
                e.preventDefault();
            }
            onHide();
        }
    };
    // Handle the escape key
    let onKeyDown = (e)=>{
        if (e.key === "Escape" && !isKeyboardDismissDisabled) {
            e.stopPropagation();
            e.preventDefault();
            onHide();
        }
    };
    // Handle clicking outside the overlay to close it
    (0, _interactions.useInteractOutside)({
        ref,
        onInteractOutside: isDismissable && isOpen ? onInteractOutside : null,
        onInteractOutsideStart
    });
    let { focusWithinProps } = (0, _interactions.useFocusWithin)({
        isDisabled: !shouldCloseOnBlur,
        onBlurWithin: (e)=>{
            // Do not close if relatedTarget is null, which means focus is lost to the body.
            // That can happen when switching tabs, or due to a VoiceOver/Chrome bug with Control+Option+Arrow navigation.
            // Clicking on the body to close the overlay should already be handled by useInteractOutside.
            // https://github.com/adobe/react-spectrum/issues/4130
            // https://github.com/adobe/react-spectrum/issues/4922
            //
            // If focus is moving into a child focus scope (e.g. menu inside a dialog),
            // do not close the outer overlay. At this point, the active scope should
            // still be the outer overlay, since blur events run before focus.
            if (!e.relatedTarget || (0, _focus.isElementInChildOfActiveScope)(e.relatedTarget)) return;
            if (!shouldCloseOnInteractOutside || shouldCloseOnInteractOutside(e.relatedTarget)) onClose();
        }
    });
    let onPointerDownUnderlay = (e)=>{
        // fixes a firefox issue that starts text selection https://bugzilla.mozilla.org/show_bug.cgi?id=1675846
        if (e.target === e.currentTarget) e.preventDefault();
    };
    return {
        overlayProps: {
            onKeyDown,
            ...focusWithinProps
        },
        underlayProps: {
            onPointerDown: onPointerDownUnderlay
        }
    };
}

},{"@react-aria/focus":"42mbF","react":"9yzVZ","@react-aria/interactions":"ky3G8","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"9uDk7":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Handles the behavior and accessibility for an overlay trigger, e.g. a button
 * that opens a popover, menu, or other overlay that is positioned relative to the trigger.
 */ parcelHelpers.export(exports, "useOverlayTrigger", ()=>useOverlayTrigger);
var _useCloseOnScroll = require("./useCloseOnScroll");
var _react = require("react");
var _utils = require("@react-aria/utils");
function useOverlayTrigger(props, state, ref) {
    let { type } = props;
    let { isOpen } = state;
    // Backward compatibility. Share state close function with useOverlayPosition so it can close on scroll
    // without forcing users to pass onClose.
    (0, _react.useEffect)(()=>{
        if (ref && ref.current) (0, _useCloseOnScroll.onCloseMap).set(ref.current, state.close);
    });
    // Aria 1.1 supports multiple values for aria-haspopup other than just menus.
    // https://www.w3.org/TR/wai-aria-1.1/#aria-haspopup
    // However, we only add it for menus for now because screen readers often
    // announce it as a menu even for other values.
    let ariaHasPopup = undefined;
    if (type === "menu") ariaHasPopup = true;
    else if (type === "listbox") ariaHasPopup = "listbox";
    let overlayId = (0, _utils.useId)();
    return {
        triggerProps: {
            "aria-haspopup": ariaHasPopup,
            "aria-expanded": isOpen,
            "aria-controls": isOpen ? overlayId : null,
            onPress: state.toggle
        },
        overlayProps: {
            id: overlayId
        }
    };
}

},{"./useCloseOnScroll":"6U3bE","react":"9yzVZ","@react-aria/utils":"9cLk5","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"dBVf0":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Prevents scrolling on the document body on mount, and
 * restores it on unmount. Also ensures that content does not
 * shift due to the scrollbars disappearing.
 */ parcelHelpers.export(exports, "usePreventScroll", ()=>usePreventScroll);
var _utils = require("@react-aria/utils");
// @ts-ignore
const visualViewport = typeof document !== "undefined" && window.visualViewport;
// HTML input types that do not cause the software keyboard to appear.
const nonTextInputTypes = new Set([
    "checkbox",
    "radio",
    "range",
    "color",
    "file",
    "image",
    "button",
    "submit",
    "reset"
]);
// The number of active usePreventScroll calls. Used to determine whether to revert back to the original page style/scroll position
let preventScrollCount = 0;
let restore;
function usePreventScroll(options = {}) {
    let { isDisabled } = options;
    (0, _utils.useLayoutEffect)(()=>{
        if (isDisabled) return;
        preventScrollCount++;
        if (preventScrollCount === 1) {
            if ((0, _utils.isIOS)()) restore = preventScrollMobileSafari();
            else restore = preventScrollStandard();
        }
        return ()=>{
            preventScrollCount--;
            if (preventScrollCount === 0) restore();
        };
    }, [
        isDisabled
    ]);
}
// For most browsers, all we need to do is set `overflow: hidden` on the root element, and
// add some padding to prevent the page from shifting when the scrollbar is hidden.
function preventScrollStandard() {
    return (0, _utils.chain)(setStyle(document.documentElement, "paddingRight", `${window.innerWidth - document.documentElement.clientWidth}px`), setStyle(document.documentElement, "overflow", "hidden"));
}
// Mobile Safari is a whole different beast. Even with overflow: hidden,
// it still scrolls the page in many situations:
//
// 1. When the bottom toolbar and address bar are collapsed, page scrolling is always allowed.
// 2. When the keyboard is visible, the viewport does not resize. Instead, the keyboard covers part of
//    it, so it becomes scrollable.
// 3. When tapping on an input, the page always scrolls so that the input is centered in the visual viewport.
//    This may cause even fixed position elements to scroll off the screen.
// 4. When using the next/previous buttons in the keyboard to navigate between inputs, the whole page always
//    scrolls, even if the input is inside a nested scrollable element that could be scrolled instead.
//
// In order to work around these cases, and prevent scrolling without jankiness, we do a few things:
//
// 1. Prevent default on `touchmove` events that are not in a scrollable element. This prevents touch scrolling
//    on the window.
// 2. Set `overscroll-behavior: contain` on nested scrollable regions so they do not scroll the page when at
//    the top or bottom. Work around a bug where this does not work when the element does not actually overflow
//    by preventing default in a `touchmove` event.
// 3. Prevent default on `touchend` events on input elements and handle focusing the element ourselves.
// 4. When focusing an input, apply a transform to trick Safari into thinking the input is at the top
//    of the page, which prevents it from scrolling the page. After the input is focused, scroll the element
//    into view ourselves, without scrolling the whole page.
// 5. Offset the body by the scroll position using a negative margin and scroll to the top. This should appear the
//    same visually, but makes the actual scroll position always zero. This is required to make all of the
//    above work or Safari will still try to scroll the page when focusing an input.
// 6. As a last resort, handle window scroll events, and scroll back to the top. This can happen when attempting
//    to navigate to an input with the next/previous buttons that's outside a modal.
function preventScrollMobileSafari() {
    let scrollable;
    let restoreScrollableStyles;
    let onTouchStart = (e)=>{
        // Store the nearest scrollable parent element from the element that the user touched.
        scrollable = (0, _utils.getScrollParent)(e.target, true);
        if (scrollable === document.documentElement && scrollable === document.body) return;
        // Prevent scrolling up when at the top and scrolling down when at the bottom
        // of a nested scrollable area, otherwise mobile Safari will start scrolling
        // the window instead.
        if (scrollable instanceof HTMLElement && window.getComputedStyle(scrollable).overscrollBehavior === "auto") restoreScrollableStyles = setStyle(scrollable, "overscrollBehavior", "contain");
    };
    let onTouchMove = (e)=>{
        // Prevent scrolling the window.
        if (!scrollable || scrollable === document.documentElement || scrollable === document.body) {
            e.preventDefault();
            return;
        }
        // overscroll-behavior should prevent scroll chaining, but currently does not
        // if the element doesn't actually overflow. https://bugs.webkit.org/show_bug.cgi?id=243452
        // This checks that both the width and height do not overflow, otherwise we might
        // block horizontal scrolling too. In that case, adding `touch-action: pan-x` to
        // the element will prevent vertical page scrolling. We can't add that automatically
        // because it must be set before the touchstart event.
        if (scrollable.scrollHeight === scrollable.clientHeight && scrollable.scrollWidth === scrollable.clientWidth) e.preventDefault();
    };
    let onTouchEnd = (e)=>{
        let target = e.target;
        // Apply this change if we're not already focused on the target element
        if (willOpenKeyboard(target) && target !== document.activeElement) {
            e.preventDefault();
            setupStyles();
            // Apply a transform to trick Safari into thinking the input is at the top of the page
            // so it doesn't try to scroll it into view. When tapping on an input, this needs to
            // be done before the "focus" event, so we have to focus the element ourselves.
            target.style.transform = "translateY(-2000px)";
            target.focus();
            requestAnimationFrame(()=>{
                target.style.transform = "";
            });
        }
        if (restoreScrollableStyles) restoreScrollableStyles();
    };
    let onFocus = (e)=>{
        let target = e.target;
        if (willOpenKeyboard(target)) {
            setupStyles();
            // Transform also needs to be applied in the focus event in cases where focus moves
            // other than tapping on an input directly, e.g. the next/previous buttons in the
            // software keyboard. In these cases, it seems applying the transform in the focus event
            // is good enough, whereas when tapping an input, it must be done before the focus event. 🤷‍♂️
            target.style.transform = "translateY(-2000px)";
            requestAnimationFrame(()=>{
                target.style.transform = "";
                // This will have prevented the browser from scrolling the focused element into view,
                // so we need to do this ourselves in a way that doesn't cause the whole page to scroll.
                if (visualViewport) {
                    if (visualViewport.height < window.innerHeight) // If the keyboard is already visible, do this after one additional frame
                    // to wait for the transform to be removed.
                    requestAnimationFrame(()=>{
                        scrollIntoView(target);
                    });
                    else // Otherwise, wait for the visual viewport to resize before scrolling so we can
                    // measure the correct position to scroll to.
                    visualViewport.addEventListener("resize", ()=>scrollIntoView(target), {
                        once: true
                    });
                }
            });
        }
    };
    let restoreStyles = null;
    let setupStyles = ()=>{
        if (restoreStyles) return;
        let onWindowScroll = ()=>{
            // Last resort. If the window scrolled, scroll it back to the top.
            // It should always be at the top because the body will have a negative margin (see below).
            window.scrollTo(0, 0);
        };
        // Record the original scroll position so we can restore it.
        // Then apply a negative margin to the body to offset it by the scroll position. This will
        // enable us to scroll the window to the top, which is required for the rest of this to work.
        let scrollX = window.pageXOffset;
        let scrollY = window.pageYOffset;
        restoreStyles = (0, _utils.chain)(addEvent(window, "scroll", onWindowScroll), setStyle(document.documentElement, "paddingRight", `${window.innerWidth - document.documentElement.clientWidth}px`), setStyle(document.documentElement, "overflow", "hidden"), setStyle(document.body, "marginTop", `-${scrollY}px`), ()=>{
            window.scrollTo(scrollX, scrollY);
        });
        // Scroll to the top. The negative margin on the body will make this appear the same.
        window.scrollTo(0, 0);
    };
    let removeEvents = (0, _utils.chain)(addEvent(document, "touchstart", onTouchStart, {
        passive: false,
        capture: true
    }), addEvent(document, "touchmove", onTouchMove, {
        passive: false,
        capture: true
    }), addEvent(document, "touchend", onTouchEnd, {
        passive: false,
        capture: true
    }), addEvent(document, "focus", onFocus, true));
    return ()=>{
        // Restore styles and scroll the page back to where it was.
        restoreScrollableStyles === null || restoreScrollableStyles === void 0 ? void 0 : restoreScrollableStyles();
        restoreStyles === null || restoreStyles === void 0 ? void 0 : restoreStyles();
        removeEvents();
    };
}
// Sets a CSS property on an element, and returns a function to revert it to the previous value.
function setStyle(element, style, value) {
    let cur = element.style[style];
    element.style[style] = value;
    return ()=>{
        element.style[style] = cur;
    };
}
// Adds an event listener to an element, and returns a function to remove it.
function addEvent(target, event, handler, options) {
    target.addEventListener(event, handler, options);
    return ()=>{
        target.removeEventListener(event, handler, options);
    };
}
function scrollIntoView(target) {
    let root = document.scrollingElement || document.documentElement;
    while(target && target !== root){
        // Find the parent scrollable element and adjust the scroll position if the target is not already in view.
        let scrollable = (0, _utils.getScrollParent)(target);
        if (scrollable !== document.documentElement && scrollable !== document.body && scrollable !== target) {
            let scrollableTop = scrollable.getBoundingClientRect().top;
            let targetTop = target.getBoundingClientRect().top;
            if (targetTop > scrollableTop + target.clientHeight) scrollable.scrollTop += targetTop - scrollableTop;
        }
        target = scrollable.parentElement;
    }
}
function willOpenKeyboard(target) {
    return target instanceof HTMLInputElement && !nonTextInputTypes.has(target.type) || target instanceof HTMLTextAreaElement || target instanceof HTMLElement && target.isContentEditable;
}

},{"@react-aria/utils":"9cLk5","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"lh0FP":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Each ModalProvider tracks how many modals are open in its subtree. On mount, the modals
 * trigger `addModal` to increment the count, and trigger `removeModal` on unmount to decrement it.
 * This is done recursively so that all parent providers are incremented and decremented.
 * If the modal count is greater than zero, we add `aria-hidden` to this provider to hide its
 * subtree from screen readers. This is done using React context in order to account for things
 * like portals, which can cause the React tree and the DOM tree to differ significantly in structure.
 */ parcelHelpers.export(exports, "ModalProvider", ()=>ModalProvider);
/**
 * Used to determine if the tree should be aria-hidden based on how many
 * modals are open.
 */ parcelHelpers.export(exports, "useModalProvider", ()=>useModalProvider);
/**
 * An OverlayProvider acts as a container for the top-level application.
 * Any application that uses modal dialogs or other overlays should
 * be wrapped in a `<OverlayProvider>`. This is used to ensure that
 * the main content of the application is hidden from screen readers
 * if a modal or other overlay is opened. Only the top-most modal or
 * overlay should be accessible at once.
 */ parcelHelpers.export(exports, "OverlayProvider", ()=>OverlayProvider);
/**
 * A container for overlays like modals and popovers. Renders the overlay
 * into a Portal which is placed at the end of the document body.
 * Also ensures that the overlay is hidden from screen readers if a
 * nested modal is opened. Only the top-most modal or overlay should
 * be accessible at once.
 */ parcelHelpers.export(exports, "OverlayContainer", ()=>OverlayContainer);
/**
 * Hides content outside the current `<OverlayContainer>` from screen readers
 * on mount and restores it on unmount. Typically used by modal dialogs and
 * other types of overlays to ensure that only the top-most modal is
 * accessible at once.
 */ parcelHelpers.export(exports, "useModal", ()=>useModal);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactDom = require("react-dom");
var _reactDomDefault = parcelHelpers.interopDefault(_reactDom);
var _ssr = require("@react-aria/ssr");
const Context = /*#__PURE__*/ (0, _reactDefault.default).createContext(null);
function ModalProvider(props) {
    let { children } = props;
    let parent = (0, _react.useContext)(Context);
    let [modalCount, setModalCount] = (0, _react.useState)(0);
    let context = (0, _react.useMemo)(()=>({
            parent,
            modalCount,
            addModal () {
                setModalCount((count)=>count + 1);
                if (parent) parent.addModal();
            },
            removeModal () {
                setModalCount((count)=>count - 1);
                if (parent) parent.removeModal();
            }
        }), [
        parent,
        modalCount
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Context.Provider, {
        value: context
    }, children);
}
function useModalProvider() {
    let context = (0, _react.useContext)(Context);
    return {
        modalProviderProps: {
            "aria-hidden": context && context.modalCount > 0 ? true : null
        }
    };
}
/**
 * Creates a root node that will be aria-hidden if there are other modals open.
 */ function OverlayContainerDOM(props) {
    let { modalProviderProps } = useModalProvider();
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        "data-overlay-container": true,
        ...props,
        ...modalProviderProps
    });
}
function OverlayProvider(props) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(ModalProvider, null, /*#__PURE__*/ (0, _reactDefault.default).createElement(OverlayContainerDOM, props));
}
function OverlayContainer(props) {
    let isSSR = (0, _ssr.useIsSSR)();
    let { portalContainer = isSSR ? null : document.body, ...rest } = props;
    (0, _reactDefault.default).useEffect(()=>{
        if (portalContainer === null || portalContainer === void 0 ? void 0 : portalContainer.closest("[data-overlay-container]")) throw new Error("An OverlayContainer must not be inside another container. Please change the portalContainer prop.");
    }, [
        portalContainer
    ]);
    if (!portalContainer) return null;
    let contents = /*#__PURE__*/ (0, _reactDefault.default).createElement(OverlayProvider, rest);
    return /*#__PURE__*/ (0, _reactDomDefault.default).createPortal(contents, portalContainer);
}
function useModal(options) {
    // Add aria-hidden to all parent providers on mount, and restore on unmount.
    let context = (0, _react.useContext)(Context);
    if (!context) throw new Error("Modal is not contained within a provider");
    (0, _react.useEffect)(()=>{
        if ((options === null || options === void 0 ? void 0 : options.isDisabled) || !context || !context.parent) return;
        // The immediate context is from the provider containing this modal, so we only
        // want to trigger aria-hidden on its parents not on the modal provider itself.
        context.parent.addModal();
        return ()=>{
            if (context && context.parent) context.parent.removeModal();
        };
    }, [
        context,
        context.parent,
        options === null || options === void 0 ? void 0 : options.isDisabled
    ]);
    return {
        modalProps: {
            "data-ismodal": !(options === null || options === void 0 ? void 0 : options.isDisabled)
        }
    };
}

},{"react":"9yzVZ","react-dom":"cEvV3","@react-aria/ssr":"gmUOW","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"iG075":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * A visually hidden button that can be used to allow screen reader
 * users to dismiss a modal or popup when there is no visual
 * affordance to do so.
 */ parcelHelpers.export(exports, "DismissButton", ()=>DismissButton);
// @ts-ignore
var _json = require("../intl/*.json");
var _jsonDefault = parcelHelpers.interopDefault(_json);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _utils = require("@react-aria/utils");
var _i18N = require("@react-aria/i18n");
var _visuallyHidden = require("@react-aria/visually-hidden");
function DismissButton(props) {
    let { onDismiss, ...otherProps } = props;
    let stringFormatter = (0, _i18N.useLocalizedStringFormatter)((0, _jsonDefault.default), "@react-aria/overlays");
    let labels = (0, _utils.useLabels)(otherProps, stringFormatter.format("dismiss"));
    let onClick = ()=>{
        if (onDismiss) onDismiss();
    };
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _visuallyHidden.VisuallyHidden), null, /*#__PURE__*/ (0, _reactDefault.default).createElement("button", {
        ...labels,
        tabIndex: -1,
        onClick: onClick,
        style: {
            width: 1,
            height: 1
        }
    }));
}

},{"../intl/*.json":"ate9Y","react":"9yzVZ","@react-aria/utils":"9cLk5","@react-aria/i18n":"411rg","@react-aria/visually-hidden":"4jwxT","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"ate9Y":[function(require,module,exports) {
const _temp0 = require("fb9cd8c40f374ea7");
const _temp1 = require("a70ef199009c6bc");
const _temp2 = require("6d7d9859bbd1508e");
const _temp3 = require("9398db2e1e63d3a1");
const _temp4 = require("727ec5cd6d2d771b");
const _temp5 = require("2b15efe2acc8174a");
const _temp6 = require("152ad9854112850");
const _temp7 = require("325a44e6fea34728");
const _temp8 = require("73f75de9ec78343e");
const _temp9 = require("7d9cc0075877d56c");
const _temp10 = require("d0bde47587c84622");
const _temp11 = require("900b9a4087671619");
const _temp12 = require("7250918f8c99555");
const _temp13 = require("326a7ea5266290");
const _temp14 = require("b14d92ef814f417d");
const _temp15 = require("a3011f7b477adc71");
const _temp16 = require("14e3c1cbf2e5f8ff");
const _temp17 = require("b12b8c0ce27bafc4");
const _temp18 = require("159c6d3b1ec26f78");
const _temp19 = require("57a1f441a85265a");
const _temp20 = require("186e5a0acab13def");
const _temp21 = require("9f729321b82985dc");
const _temp22 = require("86e8c1450c533db8");
const _temp23 = require("d9bf93fb169c4803");
const _temp24 = require("c3e2d6470a649594");
const _temp25 = require("d4fae2e90e6f3b2c");
const _temp26 = require("556e48fafccea7c");
const _temp27 = require("a55605310e2680f7");
const _temp28 = require("2374d5326777a1ce");
const _temp29 = require("eb36c86d33f7d601");
const _temp30 = require("9f997e85300917b2");
const _temp31 = require("763fae833506549b");
const _temp32 = require("fe36a04df3ebb49b");
const _temp33 = require("d89e8e3d5e2f2eb7");
module.exports = {
    "ar-AE": _temp0,
    "bg-BG": _temp1,
    "cs-CZ": _temp2,
    "da-DK": _temp3,
    "de-DE": _temp4,
    "el-GR": _temp5,
    "en-US": _temp6,
    "es-ES": _temp7,
    "et-EE": _temp8,
    "fi-FI": _temp9,
    "fr-FR": _temp10,
    "he-IL": _temp11,
    "hr-HR": _temp12,
    "hu-HU": _temp13,
    "it-IT": _temp14,
    "ja-JP": _temp15,
    "ko-KR": _temp16,
    "lt-LT": _temp17,
    "lv-LV": _temp18,
    "nb-NO": _temp19,
    "nl-NL": _temp20,
    "pl-PL": _temp21,
    "pt-BR": _temp22,
    "pt-PT": _temp23,
    "ro-RO": _temp24,
    "ru-RU": _temp25,
    "sk-SK": _temp26,
    "sl-SI": _temp27,
    "sr-SP": _temp28,
    "sv-SE": _temp29,
    "tr-TR": _temp30,
    "uk-UA": _temp31,
    "zh-CN": _temp32,
    "zh-TW": _temp33
};

},{"fb9cd8c40f374ea7":"bfAXr","a70ef199009c6bc":"VY0g9","6d7d9859bbd1508e":"frdQz","9398db2e1e63d3a1":"ffMzT","727ec5cd6d2d771b":"2HJ9K","2b15efe2acc8174a":"aHlQt","152ad9854112850":"9u9GY","325a44e6fea34728":"1je2j","73f75de9ec78343e":"H83W0","7d9cc0075877d56c":"fWHLZ","d0bde47587c84622":"6nT1O","900b9a4087671619":"568s6","7250918f8c99555":"hNwvt","326a7ea5266290":"fEhru","b14d92ef814f417d":"gUpg7","a3011f7b477adc71":"49qc8","14e3c1cbf2e5f8ff":"2fmHD","b12b8c0ce27bafc4":"40bXd","159c6d3b1ec26f78":"iM5Cf","57a1f441a85265a":"cptJP","186e5a0acab13def":"63Rxm","9f729321b82985dc":"g5P2U","86e8c1450c533db8":"SYqtK","d9bf93fb169c4803":"fFx8H","c3e2d6470a649594":"Oq37E","d4fae2e90e6f3b2c":"cGbLI","556e48fafccea7c":"irgPu","a55605310e2680f7":"jpFGw","2374d5326777a1ce":"4B82y","eb36c86d33f7d601":"9lQDn","9f997e85300917b2":"jKhlk","763fae833506549b":"gXMix","fe36a04df3ebb49b":"aUuyF","d89e8e3d5e2f2eb7":"lMwh2"}],"bfAXr":[function(require,module,exports) {
module.exports = {
    "dismiss": `\u{62A}\u{62C}\u{627}\u{647}\u{644}`
};

},{}],"VY0g9":[function(require,module,exports) {
module.exports = {
    "dismiss": `\u{41E}\u{442}\u{445}\u{432}\u{44A}\u{440}\u{43B}\u{44F}\u{43D}\u{435}`
};

},{}],"frdQz":[function(require,module,exports) {
module.exports = {
    "dismiss": `Odstranit`
};

},{}],"ffMzT":[function(require,module,exports) {
module.exports = {
    "dismiss": `Luk`
};

},{}],"2HJ9K":[function(require,module,exports) {
module.exports = {
    "dismiss": `Schlie\xdfen`
};

},{}],"aHlQt":[function(require,module,exports) {
module.exports = {
    "dismiss": `\u{391}\u{3C0}\u{3CC}\u{3C1}\u{3C1}\u{3B9}\u{3C8}\u{3B7}`
};

},{}],"9u9GY":[function(require,module,exports) {
module.exports = {
    "dismiss": `Dismiss`
};

},{}],"1je2j":[function(require,module,exports) {
module.exports = {
    "dismiss": `Descartar`
};

},{}],"H83W0":[function(require,module,exports) {
module.exports = {
    "dismiss": `L\xf5peta`
};

},{}],"fWHLZ":[function(require,module,exports) {
module.exports = {
    "dismiss": `Hylk\xe4\xe4`
};

},{}],"6nT1O":[function(require,module,exports) {
module.exports = {
    "dismiss": `Rejeter`
};

},{}],"568s6":[function(require,module,exports) {
module.exports = {
    "dismiss": `\u{5D4}\u{5EA}\u{5E2}\u{5DC}\u{5DD}`
};

},{}],"hNwvt":[function(require,module,exports) {
module.exports = {
    "dismiss": `Odbaci`
};

},{}],"fEhru":[function(require,module,exports) {
module.exports = {
    "dismiss": `Elutas\xedt\xe1s`
};

},{}],"gUpg7":[function(require,module,exports) {
module.exports = {
    "dismiss": `Ignora`
};

},{}],"49qc8":[function(require,module,exports) {
module.exports = {
    "dismiss": `\u{9589}\u{3058}\u{308B}`
};

},{}],"2fmHD":[function(require,module,exports) {
module.exports = {
    "dismiss": `\u{BB34}\u{C2DC}`
};

},{}],"40bXd":[function(require,module,exports) {
module.exports = {
    "dismiss": `Atmesti`
};

},{}],"iM5Cf":[function(require,module,exports) {
module.exports = {
    "dismiss": `Ner\u{101}d\u{12B}t`
};

},{}],"cptJP":[function(require,module,exports) {
module.exports = {
    "dismiss": `Lukk`
};

},{}],"63Rxm":[function(require,module,exports) {
module.exports = {
    "dismiss": `Negeren`
};

},{}],"g5P2U":[function(require,module,exports) {
module.exports = {
    "dismiss": `Zignoruj`
};

},{}],"SYqtK":[function(require,module,exports) {
module.exports = {
    "dismiss": `Descartar`
};

},{}],"fFx8H":[function(require,module,exports) {
module.exports = {
    "dismiss": `Dispensar`
};

},{}],"Oq37E":[function(require,module,exports) {
module.exports = {
    "dismiss": `Revocare`
};

},{}],"cGbLI":[function(require,module,exports) {
module.exports = {
    "dismiss": `\u{41F}\u{440}\u{43E}\u{43F}\u{443}\u{441}\u{442}\u{438}\u{442}\u{44C}`
};

},{}],"irgPu":[function(require,module,exports) {
module.exports = {
    "dismiss": `Zru\u{161}i\u{165}`
};

},{}],"jpFGw":[function(require,module,exports) {
module.exports = {
    "dismiss": `Opusti`
};

},{}],"4B82y":[function(require,module,exports) {
module.exports = {
    "dismiss": `Odbaci`
};

},{}],"9lQDn":[function(require,module,exports) {
module.exports = {
    "dismiss": `Avvisa`
};

},{}],"jKhlk":[function(require,module,exports) {
module.exports = {
    "dismiss": `Kapat`
};

},{}],"gXMix":[function(require,module,exports) {
module.exports = {
    "dismiss": `\u{421}\u{43A}\u{430}\u{441}\u{443}\u{432}\u{430}\u{442}\u{438}`
};

},{}],"aUuyF":[function(require,module,exports) {
module.exports = {
    "dismiss": `\u{53D6}\u{6D88}`
};

},{}],"lMwh2":[function(require,module,exports) {
module.exports = {
    "dismiss": `\u{95DC}\u{9589}`
};

},{}],"4jwxT":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useVisuallyHidden", ()=>(0, _visuallyHidden.useVisuallyHidden));
parcelHelpers.export(exports, "VisuallyHidden", ()=>(0, _visuallyHidden.VisuallyHidden));
var _visuallyHidden = require("./VisuallyHidden");

},{"./VisuallyHidden":"6mUuC","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"6mUuC":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides props for an element that hides its children visually
 * but keeps content visible to assistive technology.
 */ parcelHelpers.export(exports, "useVisuallyHidden", ()=>useVisuallyHidden);
/**
 * VisuallyHidden hides its children visually, while keeping content visible
 * to screen readers.
 */ parcelHelpers.export(exports, "VisuallyHidden", ()=>VisuallyHidden);
var _utils = require("@react-aria/utils");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _interactions = require("@react-aria/interactions");
const styles = {
    border: 0,
    clip: "rect(0 0 0 0)",
    clipPath: "inset(50%)",
    height: "1px",
    margin: "-1px",
    overflow: "hidden",
    padding: 0,
    position: "absolute",
    width: "1px",
    whiteSpace: "nowrap"
};
function useVisuallyHidden(props = {}) {
    let { style, isFocusable } = props;
    let [isFocused, setFocused] = (0, _react.useState)(false);
    let { focusWithinProps } = (0, _interactions.useFocusWithin)({
        isDisabled: !isFocusable,
        onFocusWithinChange: (val)=>setFocused(val)
    });
    // If focused, don't hide the element.
    let combinedStyles = (0, _react.useMemo)(()=>{
        if (isFocused) return style;
        else if (style) return {
            ...styles,
            ...style
        };
        else return styles;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isFocused
    ]);
    return {
        visuallyHiddenProps: {
            ...focusWithinProps,
            style: combinedStyles
        }
    };
}
function VisuallyHidden(props) {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    let { children, elementType: Element = "div", isFocusable, style, ...otherProps } = props;
    let { visuallyHiddenProps } = useVisuallyHidden(props);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Element, (0, _utils.mergeProps)(otherProps, visuallyHiddenProps), children);
}

},{"@react-aria/utils":"9cLk5","react":"9yzVZ","@react-aria/interactions":"ky3G8","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"1mjNB":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Keeps a ref count of all hidden elements. Added to when hiding an element, and
// subtracted from when showing it again. When it reaches zero, aria-hidden is removed.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Hides all elements in the DOM outside the given targets from screen readers using aria-hidden,
 * and returns a function to revert these changes. In addition, changes to the DOM are watched
 * and new elements outside the targets are automatically hidden.
 * @param targets - The elements that should remain visible.
 * @param root - Nothing will be hidden above this element.
 * @returns - A function to restore all hidden elements.
 */ parcelHelpers.export(exports, "ariaHideOutside", ()=>ariaHideOutside);
let refCountMap = new WeakMap();
let observerStack = [];
function ariaHideOutside(targets, root = document.body) {
    let visibleNodes = new Set(targets);
    let hiddenNodes = new Set();
    let walk = (root)=>{
        // Keep live announcer and top layer elements (e.g. toasts) visible.
        for (let element of root.querySelectorAll("[data-live-announcer], [data-react-aria-top-layer]"))visibleNodes.add(element);
        let acceptNode = (node)=>{
            // Skip this node and its children if it is one of the target nodes, or a live announcer.
            // Also skip children of already hidden nodes, as aria-hidden is recursive. An exception is
            // made for elements with role="row" since VoiceOver on iOS has issues hiding elements with role="row".
            // For that case we want to hide the cells inside as well (https://bugs.webkit.org/show_bug.cgi?id=222623).
            if (visibleNodes.has(node) || hiddenNodes.has(node.parentElement) && node.parentElement.getAttribute("role") !== "row") return NodeFilter.FILTER_REJECT;
            // Skip this node but continue to children if one of the targets is inside the node.
            for (let target of visibleNodes){
                if (node.contains(target)) return NodeFilter.FILTER_SKIP;
            }
            return NodeFilter.FILTER_ACCEPT;
        };
        let walker = document.createTreeWalker(root, NodeFilter.SHOW_ELEMENT, {
            acceptNode
        });
        // TreeWalker does not include the root.
        let acceptRoot = acceptNode(root);
        if (acceptRoot === NodeFilter.FILTER_ACCEPT) hide(root);
        if (acceptRoot !== NodeFilter.FILTER_REJECT) {
            let node = walker.nextNode();
            while(node != null){
                hide(node);
                node = walker.nextNode();
            }
        }
    };
    let hide = (node)=>{
        var _refCountMap_get;
        let refCount = (_refCountMap_get = refCountMap.get(node)) !== null && _refCountMap_get !== void 0 ? _refCountMap_get : 0;
        // If already aria-hidden, and the ref count is zero, then this element
        // was already hidden and there's nothing for us to do.
        if (node.getAttribute("aria-hidden") === "true" && refCount === 0) return;
        if (refCount === 0) node.setAttribute("aria-hidden", "true");
        hiddenNodes.add(node);
        refCountMap.set(node, refCount + 1);
    };
    // If there is already a MutationObserver listening from a previous call,
    // disconnect it so the new on takes over.
    if (observerStack.length) observerStack[observerStack.length - 1].disconnect();
    walk(root);
    let observer = new MutationObserver((changes)=>{
        for (let change of changes){
            if (change.type !== "childList" || change.addedNodes.length === 0) continue;
            // If the parent element of the added nodes is not within one of the targets,
            // and not already inside a hidden node, hide all of the new children.
            if (![
                ...visibleNodes,
                ...hiddenNodes
            ].some((node)=>node.contains(change.target))) {
                for (let node of change.removedNodes)if (node instanceof Element) {
                    visibleNodes.delete(node);
                    hiddenNodes.delete(node);
                }
                for (let node of change.addedNodes){
                    if ((node instanceof HTMLElement || node instanceof SVGElement) && (node.dataset.liveAnnouncer === "true" || node.dataset.reactAriaTopLayer === "true")) visibleNodes.add(node);
                    else if (node instanceof Element) walk(node);
                }
            }
        }
    });
    observer.observe(root, {
        childList: true,
        subtree: true
    });
    let observerWrapper = {
        observe () {
            observer.observe(root, {
                childList: true,
                subtree: true
            });
        },
        disconnect () {
            observer.disconnect();
        }
    };
    observerStack.push(observerWrapper);
    return ()=>{
        observer.disconnect();
        for (let node of hiddenNodes){
            let count = refCountMap.get(node);
            if (count === 1) {
                node.removeAttribute("aria-hidden");
                refCountMap.delete(node);
            } else refCountMap.set(node, count - 1);
        }
        // Remove this observer from the stack, and start the previous one.
        if (observerWrapper === observerStack[observerStack.length - 1]) {
            observerStack.pop();
            if (observerStack.length) observerStack[observerStack.length - 1].observe();
        } else observerStack.splice(observerStack.indexOf(observerWrapper), 1);
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"llONW":[function(require,module,exports) {
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides the behavior and accessibility implementation for a popover component.
 * A popover is an overlay element positioned relative to a trigger.
 */ parcelHelpers.export(exports, "usePopover", ()=>usePopover);
var _ariaHideOutside = require("./ariaHideOutside");
var _useOverlayPosition = require("./useOverlayPosition");
var _utils = require("@react-aria/utils");
var _useOverlay = require("./useOverlay");
var _usePreventScroll = require("./usePreventScroll");
function usePopover(props, state) {
    let { triggerRef, popoverRef, isNonModal, isKeyboardDismissDisabled, shouldCloseOnInteractOutside, ...otherProps } = props;
    let { overlayProps, underlayProps } = (0, _useOverlay.useOverlay)({
        isOpen: state.isOpen,
        onClose: state.close,
        shouldCloseOnBlur: true,
        isDismissable: !isNonModal,
        isKeyboardDismissDisabled,
        shouldCloseOnInteractOutside
    }, popoverRef);
    let { overlayProps: positionProps, arrowProps, placement } = (0, _useOverlayPosition.useOverlayPosition)({
        ...otherProps,
        targetRef: triggerRef,
        overlayRef: popoverRef,
        isOpen: state.isOpen,
        onClose: isNonModal ? state.close : null
    });
    (0, _usePreventScroll.usePreventScroll)({
        isDisabled: isNonModal || !state.isOpen
    });
    (0, _utils.useLayoutEffect)(()=>{
        if (state.isOpen && !isNonModal && popoverRef.current) return (0, _ariaHideOutside.ariaHideOutside)([
            popoverRef.current
        ]);
    }, [
        isNonModal,
        state.isOpen,
        popoverRef
    ]);
    return {
        popoverProps: (0, _utils.mergeProps)(overlayProps, positionProps),
        arrowProps,
        underlayProps,
        placement
    };
}

},{"./ariaHideOutside":"1mjNB","./useOverlayPosition":"dtvF4","@react-aria/utils":"9cLk5","./useOverlay":"2gAD2","./usePreventScroll":"dBVf0","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"fTHZz":[function(require,module,exports) {
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides the behavior and accessibility implementation for a modal component.
 * A modal is an overlay element which blocks interaction with elements outside it.
 */ parcelHelpers.export(exports, "useModalOverlay", ()=>useModalOverlay);
var _ariaHideOutside = require("./ariaHideOutside");
var _utils = require("@react-aria/utils");
var _react = require("react");
var _useOverlay = require("./useOverlay");
var _overlay = require("./Overlay");
var _usePreventScroll = require("./usePreventScroll");
function useModalOverlay(props, state, ref) {
    let { overlayProps, underlayProps } = (0, _useOverlay.useOverlay)({
        ...props,
        isOpen: state.isOpen,
        onClose: state.close
    }, ref);
    (0, _usePreventScroll.usePreventScroll)({
        isDisabled: !state.isOpen
    });
    (0, _overlay.useOverlayFocusContain)();
    (0, _react.useEffect)(()=>{
        if (state.isOpen) return (0, _ariaHideOutside.ariaHideOutside)([
            ref.current
        ]);
    }, [
        state.isOpen,
        ref
    ]);
    return {
        modalProps: (0, _utils.mergeProps)(overlayProps),
        underlayProps
    };
}

},{"./ariaHideOutside":"1mjNB","@react-aria/utils":"9cLk5","react":"9yzVZ","./useOverlay":"2gAD2","./Overlay":"Lhjy6","./usePreventScroll":"dBVf0","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"Lhjy6":[function(require,module,exports) {
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "OverlayContext", ()=>OverlayContext);
/**
 * A container which renders an overlay such as a popover or modal in a portal,
 * and provides a focus scope for the child elements.
 */ parcelHelpers.export(exports, "Overlay", ()=>Overlay);
/** @private */ parcelHelpers.export(exports, "useOverlayFocusContain", ()=>useOverlayFocusContain);
var _interactions = require("@react-aria/interactions");
var _focus = require("@react-aria/focus");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactDom = require("react-dom");
var _reactDomDefault = parcelHelpers.interopDefault(_reactDom);
var _ssr = require("@react-aria/ssr");
var _utils = require("@react-aria/utils");
const OverlayContext = /*#__PURE__*/ (0, _reactDefault.default).createContext(null);
function Overlay(props) {
    let isSSR = (0, _ssr.useIsSSR)();
    let { portalContainer = isSSR ? null : document.body, isExiting } = props;
    let [contain, setContain] = (0, _react.useState)(false);
    let contextValue = (0, _react.useMemo)(()=>({
            contain,
            setContain
        }), [
        contain,
        setContain
    ]);
    if (!portalContainer) return null;
    let contents = props.children;
    if (!props.disableFocusManagement) contents = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _focus.FocusScope), {
        restoreFocus: true,
        contain: contain && !isExiting
    }, contents);
    contents = /*#__PURE__*/ (0, _reactDefault.default).createElement(OverlayContext.Provider, {
        value: contextValue
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _interactions.ClearPressResponder), null, contents));
    return /*#__PURE__*/ (0, _reactDomDefault.default).createPortal(contents, portalContainer);
}
function useOverlayFocusContain() {
    let ctx = (0, _react.useContext)(OverlayContext);
    let setContain = ctx === null || ctx === void 0 ? void 0 : ctx.setContain;
    (0, _utils.useLayoutEffect)(()=>{
        setContain === null || setContain === void 0 ? void 0 : setContain(true);
    }, [
        setContain
    ]);
}

},{"@react-aria/interactions":"ky3G8","@react-aria/focus":"42mbF","react":"9yzVZ","react-dom":"cEvV3","@react-aria/ssr":"gmUOW","@react-aria/utils":"9cLk5","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"bHZSJ":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useListBox", ()=>(0, _useListBox.useListBox));
parcelHelpers.export(exports, "useOption", ()=>(0, _useOption.useOption));
parcelHelpers.export(exports, "useListBoxSection", ()=>(0, _useListBoxSection.useListBoxSection));
parcelHelpers.export(exports, "listData", ()=>(0, _utils.listData));
parcelHelpers.export(exports, "getItemId", ()=>(0, _utils.getItemId));
var _useListBox = require("./useListBox");
var _useOption = require("./useOption");
var _useListBoxSection = require("./useListBoxSection");
var _utils = require("./utils");

},{"./useListBox":"8dSYM","./useOption":"5s26w","./useListBoxSection":"kdNi0","./utils":"3KRJf","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"8dSYM":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides the behavior and accessibility implementation for a listbox component.
 * A listbox displays a list of options and allows a user to select one or more of them.
 * @param props - Props for the listbox.
 * @param state - State for the listbox, as returned by `useListState`.
 */ parcelHelpers.export(exports, "useListBox", ()=>useListBox);
var _utils = require("@react-aria/utils");
var _utils1 = require("./utils");
var _interactions = require("@react-aria/interactions");
var _label = require("@react-aria/label");
var _selection = require("@react-aria/selection");
function useListBox(props, state, ref) {
    let domProps = (0, _utils.filterDOMProps)(props, {
        labelable: true
    });
    // Use props instead of state here. We don't want this to change due to long press.
    let selectionBehavior = props.selectionBehavior || "toggle";
    let linkBehavior = props.linkBehavior || (selectionBehavior === "replace" ? "action" : "override");
    if (selectionBehavior === "toggle" && linkBehavior === "action") // linkBehavior="action" does not work with selectionBehavior="toggle" because there is no way
    // to initiate selection (checkboxes are not allowed inside a listbox). Link items will not be
    // selectable in this configuration.
    linkBehavior = "override";
    let { listProps } = (0, _selection.useSelectableList)({
        ...props,
        ref,
        selectionManager: state.selectionManager,
        collection: state.collection,
        disabledKeys: state.disabledKeys,
        linkBehavior
    });
    let { focusWithinProps } = (0, _interactions.useFocusWithin)({
        onFocusWithin: props.onFocus,
        onBlurWithin: props.onBlur,
        onFocusWithinChange: props.onFocusChange
    });
    // Share list id and some props with child options.
    let id = (0, _utils.useId)(props.id);
    (0, _utils1.listData).set(state, {
        id,
        shouldUseVirtualFocus: props.shouldUseVirtualFocus,
        shouldSelectOnPressUp: props.shouldSelectOnPressUp,
        shouldFocusOnHover: props.shouldFocusOnHover,
        isVirtualized: props.isVirtualized,
        onAction: props.onAction,
        linkBehavior
    });
    let { labelProps, fieldProps } = (0, _label.useLabel)({
        ...props,
        id,
        // listbox is not an HTML input element so it
        // shouldn't be labeled by a <label> element.
        labelElementType: "span"
    });
    return {
        labelProps,
        listBoxProps: (0, _utils.mergeProps)(domProps, focusWithinProps, state.selectionManager.selectionMode === "multiple" ? {
            "aria-multiselectable": "true"
        } : {}, {
            role: "listbox",
            ...(0, _utils.mergeProps)(fieldProps, listProps)
        })
    };
}

},{"@react-aria/utils":"9cLk5","./utils":"3KRJf","@react-aria/interactions":"ky3G8","@react-aria/label":"74Ccz","@react-aria/selection":"6Fly5","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"3KRJf":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "listData", ()=>listData);
parcelHelpers.export(exports, "getItemId", ()=>getItemId);
const listData = new WeakMap();
function normalizeKey(key) {
    if (typeof key === "string") return key.replace(/\s*/g, "");
    return "" + key;
}
function getItemId(state, itemKey) {
    let data = listData.get(state);
    if (!data) throw new Error("Unknown list");
    return `${data.id}-option-${normalizeKey(itemKey)}`;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"6Fly5":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useSelectableCollection", ()=>(0, _useSelectableCollection.useSelectableCollection));
parcelHelpers.export(exports, "useSelectableItem", ()=>(0, _useSelectableItem.useSelectableItem));
parcelHelpers.export(exports, "useSelectableList", ()=>(0, _useSelectableList.useSelectableList));
parcelHelpers.export(exports, "ListKeyboardDelegate", ()=>(0, _listKeyboardDelegate.ListKeyboardDelegate));
parcelHelpers.export(exports, "useTypeSelect", ()=>(0, _useTypeSelect.useTypeSelect));
var _useSelectableCollection = require("./useSelectableCollection");
var _useSelectableItem = require("./useSelectableItem");
var _useSelectableList = require("./useSelectableList");
var _listKeyboardDelegate = require("./ListKeyboardDelegate");
var _useTypeSelect = require("./useTypeSelect");

},{"./useSelectableCollection":"7sWYu","./useSelectableItem":"5swaO","./useSelectableList":"cDkri","./ListKeyboardDelegate":"glRO1","./useTypeSelect":"hQM0o","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"7sWYu":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Handles interactions with selectable collections.
 */ parcelHelpers.export(exports, "useSelectableCollection", ()=>useSelectableCollection);
var _reactDom = require("react-dom");
var _react = require("react");
var _focus = require("@react-aria/focus");
var _utils = require("@react-aria/utils");
var _interactions = require("@react-aria/interactions");
var _utils1 = require("./utils");
var _i18N = require("@react-aria/i18n");
var _useTypeSelect = require("./useTypeSelect");
function useSelectableCollection(options) {
    let { selectionManager: manager, keyboardDelegate: delegate, ref, autoFocus = false, shouldFocusWrap = false, disallowEmptySelection = false, disallowSelectAll = false, selectOnFocus = manager.selectionBehavior === "replace", disallowTypeAhead = false, shouldUseVirtualFocus, allowsTabNavigation = false, isVirtualized, // If no scrollRef is provided, assume the collection ref is the scrollable region
    scrollRef = ref, linkBehavior = "action" } = options;
    let { direction } = (0, _i18N.useLocale)();
    let router = (0, _utils.useRouter)();
    let onKeyDown = (e)=>{
        // Prevent option + tab from doing anything since it doesn't move focus to the cells, only buttons/checkboxes
        if (e.altKey && e.key === "Tab") e.preventDefault();
        // Keyboard events bubble through portals. Don't handle keyboard events
        // for elements outside the collection (e.g. menus).
        if (!ref.current.contains(e.target)) return;
        const navigateToKey = (key, childFocus)=>{
            if (key != null) {
                if (manager.isLink(key) && linkBehavior === "selection" && selectOnFocus && !(0, _utils1.isNonContiguousSelectionModifier)(e)) {
                    // Set focused key and re-render synchronously to bring item into view if needed.
                    (0, _reactDom.flushSync)(()=>{
                        manager.setFocusedKey(key, childFocus);
                    });
                    let item = scrollRef.current.querySelector(`[data-key="${CSS.escape(key.toString())}"]`);
                    router.open(item, e);
                    return;
                }
                manager.setFocusedKey(key, childFocus);
                if (manager.isLink(key) && linkBehavior === "override") return;
                if (e.shiftKey && manager.selectionMode === "multiple") manager.extendSelection(key);
                else if (selectOnFocus && !(0, _utils1.isNonContiguousSelectionModifier)(e)) manager.replaceSelection(key);
            }
        };
        switch(e.key){
            case "ArrowDown":
                if (delegate.getKeyBelow) {
                    var _delegate_getFirstKey, _delegate_getFirstKey1;
                    e.preventDefault();
                    let nextKey = manager.focusedKey != null ? delegate.getKeyBelow(manager.focusedKey) : (_delegate_getFirstKey = delegate.getFirstKey) === null || _delegate_getFirstKey === void 0 ? void 0 : _delegate_getFirstKey.call(delegate);
                    if (nextKey == null && shouldFocusWrap) nextKey = (_delegate_getFirstKey1 = delegate.getFirstKey) === null || _delegate_getFirstKey1 === void 0 ? void 0 : _delegate_getFirstKey1.call(delegate, manager.focusedKey);
                    navigateToKey(nextKey);
                }
                break;
            case "ArrowUp":
                if (delegate.getKeyAbove) {
                    var _delegate_getLastKey, _delegate_getLastKey1;
                    e.preventDefault();
                    let nextKey = manager.focusedKey != null ? delegate.getKeyAbove(manager.focusedKey) : (_delegate_getLastKey = delegate.getLastKey) === null || _delegate_getLastKey === void 0 ? void 0 : _delegate_getLastKey.call(delegate);
                    if (nextKey == null && shouldFocusWrap) nextKey = (_delegate_getLastKey1 = delegate.getLastKey) === null || _delegate_getLastKey1 === void 0 ? void 0 : _delegate_getLastKey1.call(delegate, manager.focusedKey);
                    navigateToKey(nextKey);
                }
                break;
            case "ArrowLeft":
                if (delegate.getKeyLeftOf) {
                    var _delegate_getFirstKey2, _delegate_getLastKey2;
                    e.preventDefault();
                    let nextKey = delegate.getKeyLeftOf(manager.focusedKey);
                    if (nextKey == null && shouldFocusWrap) nextKey = direction === "rtl" ? (_delegate_getFirstKey2 = delegate.getFirstKey) === null || _delegate_getFirstKey2 === void 0 ? void 0 : _delegate_getFirstKey2.call(delegate, manager.focusedKey) : (_delegate_getLastKey2 = delegate.getLastKey) === null || _delegate_getLastKey2 === void 0 ? void 0 : _delegate_getLastKey2.call(delegate, manager.focusedKey);
                    navigateToKey(nextKey, direction === "rtl" ? "first" : "last");
                }
                break;
            case "ArrowRight":
                if (delegate.getKeyRightOf) {
                    var _delegate_getLastKey3, _delegate_getFirstKey3;
                    e.preventDefault();
                    let nextKey = delegate.getKeyRightOf(manager.focusedKey);
                    if (nextKey == null && shouldFocusWrap) nextKey = direction === "rtl" ? (_delegate_getLastKey3 = delegate.getLastKey) === null || _delegate_getLastKey3 === void 0 ? void 0 : _delegate_getLastKey3.call(delegate, manager.focusedKey) : (_delegate_getFirstKey3 = delegate.getFirstKey) === null || _delegate_getFirstKey3 === void 0 ? void 0 : _delegate_getFirstKey3.call(delegate, manager.focusedKey);
                    navigateToKey(nextKey, direction === "rtl" ? "last" : "first");
                }
                break;
            case "Home":
                if (delegate.getFirstKey) {
                    e.preventDefault();
                    let firstKey = delegate.getFirstKey(manager.focusedKey, (0, _utils1.isCtrlKeyPressed)(e));
                    manager.setFocusedKey(firstKey);
                    if ((0, _utils1.isCtrlKeyPressed)(e) && e.shiftKey && manager.selectionMode === "multiple") manager.extendSelection(firstKey);
                    else if (selectOnFocus) manager.replaceSelection(firstKey);
                }
                break;
            case "End":
                if (delegate.getLastKey) {
                    e.preventDefault();
                    let lastKey = delegate.getLastKey(manager.focusedKey, (0, _utils1.isCtrlKeyPressed)(e));
                    manager.setFocusedKey(lastKey);
                    if ((0, _utils1.isCtrlKeyPressed)(e) && e.shiftKey && manager.selectionMode === "multiple") manager.extendSelection(lastKey);
                    else if (selectOnFocus) manager.replaceSelection(lastKey);
                }
                break;
            case "PageDown":
                if (delegate.getKeyPageBelow) {
                    e.preventDefault();
                    let nextKey = delegate.getKeyPageBelow(manager.focusedKey);
                    navigateToKey(nextKey);
                }
                break;
            case "PageUp":
                if (delegate.getKeyPageAbove) {
                    e.preventDefault();
                    let nextKey = delegate.getKeyPageAbove(manager.focusedKey);
                    navigateToKey(nextKey);
                }
                break;
            case "a":
                if ((0, _utils1.isCtrlKeyPressed)(e) && manager.selectionMode === "multiple" && disallowSelectAll !== true) {
                    e.preventDefault();
                    manager.selectAll();
                }
                break;
            case "Escape":
                e.preventDefault();
                if (!disallowEmptySelection) manager.clearSelection();
                break;
            case "Tab":
                if (!allowsTabNavigation) {
                    // There may be elements that are "tabbable" inside a collection (e.g. in a grid cell).
                    // However, collections should be treated as a single tab stop, with arrow key navigation internally.
                    // We don't control the rendering of these, so we can't override the tabIndex to prevent tabbing.
                    // Instead, we handle the Tab key, and move focus manually to the first/last tabbable element
                    // in the collection, so that the browser default behavior will apply starting from that element
                    // rather than the currently focused one.
                    if (e.shiftKey) ref.current.focus();
                    else {
                        let walker = (0, _focus.getFocusableTreeWalker)(ref.current, {
                            tabbable: true
                        });
                        let next;
                        let last;
                        do {
                            last = walker.lastChild();
                            if (last) next = last;
                        }while (last);
                        if (next && !next.contains(document.activeElement)) (0, _utils.focusWithoutScrolling)(next);
                    }
                    break;
                }
        }
    };
    // Store the scroll position so we can restore it later.
    let scrollPos = (0, _react.useRef)({
        top: 0,
        left: 0
    });
    (0, _utils.useEvent)(scrollRef, "scroll", isVirtualized ? null : ()=>{
        scrollPos.current = {
            top: scrollRef.current.scrollTop,
            left: scrollRef.current.scrollLeft
        };
    });
    let onFocus = (e)=>{
        if (manager.isFocused) {
            // If a focus event bubbled through a portal, reset focus state.
            if (!e.currentTarget.contains(e.target)) manager.setFocused(false);
            return;
        }
        // Focus events can bubble through portals. Ignore these events.
        if (!e.currentTarget.contains(e.target)) return;
        manager.setFocused(true);
        if (manager.focusedKey == null) {
            let navigateToFirstKey = (key)=>{
                if (key != null) {
                    manager.setFocusedKey(key);
                    if (selectOnFocus) manager.replaceSelection(key);
                }
            };
            // If the user hasn't yet interacted with the collection, there will be no focusedKey set.
            // Attempt to detect whether the user is tabbing forward or backward into the collection
            // and either focus the first or last item accordingly.
            let relatedTarget = e.relatedTarget;
            var _manager_lastSelectedKey, _manager_firstSelectedKey;
            if (relatedTarget && e.currentTarget.compareDocumentPosition(relatedTarget) & Node.DOCUMENT_POSITION_FOLLOWING) navigateToFirstKey((_manager_lastSelectedKey = manager.lastSelectedKey) !== null && _manager_lastSelectedKey !== void 0 ? _manager_lastSelectedKey : delegate.getLastKey());
            else navigateToFirstKey((_manager_firstSelectedKey = manager.firstSelectedKey) !== null && _manager_firstSelectedKey !== void 0 ? _manager_firstSelectedKey : delegate.getFirstKey());
        } else if (!isVirtualized) {
            // Restore the scroll position to what it was before.
            scrollRef.current.scrollTop = scrollPos.current.top;
            scrollRef.current.scrollLeft = scrollPos.current.left;
        }
        if (!isVirtualized && manager.focusedKey != null) {
            // Refocus and scroll the focused item into view if it exists within the scrollable region.
            let element = scrollRef.current.querySelector(`[data-key="${CSS.escape(manager.focusedKey.toString())}"]`);
            if (element) {
                // This prevents a flash of focus on the first/last element in the collection, or the collection itself.
                if (!element.contains(document.activeElement)) (0, _utils.focusWithoutScrolling)(element);
                let modality = (0, _interactions.getInteractionModality)();
                if (modality === "keyboard") (0, _utils.scrollIntoViewport)(element, {
                    containingElement: ref.current
                });
            }
        }
    };
    let onBlur = (e)=>{
        // Don't set blurred and then focused again if moving focus within the collection.
        if (!e.currentTarget.contains(e.relatedTarget)) manager.setFocused(false);
    };
    const autoFocusRef = (0, _react.useRef)(autoFocus);
    (0, _react.useEffect)(()=>{
        if (autoFocusRef.current) {
            let focusedKey = null;
            // Check focus strategy to determine which item to focus
            if (autoFocus === "first") focusedKey = delegate.getFirstKey();
            if (autoFocus === "last") focusedKey = delegate.getLastKey();
            // If there are any selected keys, make the first one the new focus target
            let selectedKeys = manager.selectedKeys;
            if (selectedKeys.size) {
                for (let key of selectedKeys)if (manager.canSelectItem(key)) {
                    focusedKey = key;
                    break;
                }
            }
            manager.setFocused(true);
            manager.setFocusedKey(focusedKey);
            // If no default focus key is selected, focus the collection itself.
            if (focusedKey == null && !shouldUseVirtualFocus) (0, _focus.focusSafely)(ref.current);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // If not virtualized, scroll the focused element into view when the focusedKey changes.
    // When virtualized, Virtualizer handles this internally.
    let lastFocusedKey = (0, _react.useRef)(manager.focusedKey);
    (0, _react.useEffect)(()=>{
        let modality = (0, _interactions.getInteractionModality)();
        if (manager.isFocused && manager.focusedKey != null && (scrollRef === null || scrollRef === void 0 ? void 0 : scrollRef.current)) {
            let element = scrollRef.current.querySelector(`[data-key="${CSS.escape(manager.focusedKey.toString())}"]`);
            if (element && (modality === "keyboard" || autoFocusRef.current)) {
                if (!isVirtualized) (0, _utils.scrollIntoView)(scrollRef.current, element);
                // Avoid scroll in iOS VO, since it may cause overlay to close (i.e. RAC submenu)
                if (modality !== "virtual") (0, _utils.scrollIntoViewport)(element, {
                    containingElement: ref.current
                });
            }
        }
        // If the focused key becomes null (e.g. the last item is deleted), focus the whole collection.
        if (manager.isFocused && manager.focusedKey == null && lastFocusedKey.current != null) (0, _focus.focusSafely)(ref.current);
        lastFocusedKey.current = manager.focusedKey;
        autoFocusRef.current = false;
    }, [
        isVirtualized,
        scrollRef,
        manager.focusedKey,
        manager.isFocused,
        ref
    ]);
    let handlers = {
        onKeyDown,
        onFocus,
        onBlur,
        onMouseDown (e) {
            // Ignore events that bubbled through portals.
            if (scrollRef.current === e.target) // Prevent focus going to the collection when clicking on the scrollbar.
            e.preventDefault();
        }
    };
    let { typeSelectProps } = (0, _useTypeSelect.useTypeSelect)({
        keyboardDelegate: delegate,
        selectionManager: manager
    });
    if (!disallowTypeAhead) handlers = (0, _utils.mergeProps)(typeSelectProps, handlers);
    // If nothing is focused within the collection, make the collection itself tabbable.
    // This will be marshalled to either the first or last item depending on where focus came from.
    // If using virtual focus, don't set a tabIndex at all so that VoiceOver on iOS 14 doesn't try
    // to move real DOM focus to the element anyway.
    let tabIndex;
    if (!shouldUseVirtualFocus) tabIndex = manager.focusedKey == null ? 0 : -1;
    return {
        collectionProps: {
            ...handlers,
            tabIndex
        }
    };
}

},{"react-dom":"cEvV3","react":"9yzVZ","@react-aria/focus":"42mbF","@react-aria/utils":"9cLk5","@react-aria/interactions":"ky3G8","./utils":"4vm0e","@react-aria/i18n":"411rg","./useTypeSelect":"hQM0o","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"4vm0e":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isNonContiguousSelectionModifier", ()=>isNonContiguousSelectionModifier);
parcelHelpers.export(exports, "isCtrlKeyPressed", ()=>isCtrlKeyPressed);
var _utils = require("@react-aria/utils");
function isNonContiguousSelectionModifier(e) {
    // Ctrl + Arrow Up/Arrow Down has a system wide meaning on macOS, so use Alt instead.
    // On Windows and Ubuntu, Alt + Space has a system wide meaning.
    return (0, _utils.isAppleDevice)() ? e.altKey : e.ctrlKey;
}
function isCtrlKeyPressed(e) {
    if ((0, _utils.isMac)()) return e.metaKey;
    return e.ctrlKey;
}

},{"@react-aria/utils":"9cLk5","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"hQM0o":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Handles typeahead interactions with collections.
 */ parcelHelpers.export(exports, "useTypeSelect", ()=>useTypeSelect);
var _react = require("react");
/**
 * Controls how long to wait before clearing the typeahead buffer.
 */ const TYPEAHEAD_DEBOUNCE_WAIT_MS = 1000; // 1 second
function useTypeSelect(options) {
    let { keyboardDelegate, selectionManager, onTypeSelect } = options;
    let state = (0, _react.useRef)({
        search: "",
        timeout: null
    }).current;
    let onKeyDown = (e)=>{
        let character = getStringForKey(e.key);
        if (!character || e.ctrlKey || e.metaKey || !e.currentTarget.contains(e.target)) return;
        // Do not propagate the Spacebar event if it's meant to be part of the search.
        // When we time out, the search term becomes empty, hence the check on length.
        // Trimming is to account for the case of pressing the Spacebar more than once,
        // which should cycle through the selection/deselection of the focused item.
        if (character === " " && state.search.trim().length > 0) {
            e.preventDefault();
            if (!("continuePropagation" in e)) e.stopPropagation();
        }
        state.search += character;
        // Use the delegate to find a key to focus.
        // Prioritize items after the currently focused item, falling back to searching the whole list.
        let key = keyboardDelegate.getKeyForSearch(state.search, selectionManager.focusedKey);
        // If no key found, search from the top.
        if (key == null) key = keyboardDelegate.getKeyForSearch(state.search);
        if (key != null) {
            selectionManager.setFocusedKey(key);
            if (onTypeSelect) onTypeSelect(key);
        }
        clearTimeout(state.timeout);
        state.timeout = setTimeout(()=>{
            state.search = "";
        }, TYPEAHEAD_DEBOUNCE_WAIT_MS);
    };
    return {
        typeSelectProps: {
            // Using a capturing listener to catch the keydown event before
            // other hooks in order to handle the Spacebar event.
            onKeyDownCapture: keyboardDelegate.getKeyForSearch ? onKeyDown : null
        }
    };
}
function getStringForKey(key) {
    // If the key is of length 1, it is an ASCII value.
    // Otherwise, if there are no ASCII characters in the key name,
    // it is a Unicode character.
    // See https://www.w3.org/TR/uievents-key/
    if (key.length === 1 || !/^[A-Z]/i.test(key)) return key;
    return "";
}

},{"react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"5swaO":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Handles interactions with an item in a selectable collection.
 */ parcelHelpers.export(exports, "useSelectableItem", ()=>useSelectableItem);
var _focus = require("@react-aria/focus");
var _utils = require("./utils");
var _utils1 = require("@react-aria/utils");
var _interactions = require("@react-aria/interactions");
var _react = require("react");
function useSelectableItem(options) {
    let { selectionManager: manager, key, ref, shouldSelectOnPressUp, shouldUseVirtualFocus, focus, isDisabled, onAction, allowsDifferentPressOrigin, linkBehavior = "action" } = options;
    let router = (0, _utils1.useRouter)();
    let onSelect = (e)=>{
        if (e.pointerType === "keyboard" && (0, _utils.isNonContiguousSelectionModifier)(e)) manager.toggleSelection(key);
        else {
            if (manager.selectionMode === "none") return;
            if (manager.isLink(key)) {
                if (linkBehavior === "selection") {
                    router.open(ref.current, e);
                    // Always set selected keys back to what they were so that select and combobox close.
                    manager.setSelectedKeys(manager.selectedKeys);
                    return;
                } else if (linkBehavior === "override" || linkBehavior === "none") return;
            }
            if (manager.selectionMode === "single") {
                if (manager.isSelected(key) && !manager.disallowEmptySelection) manager.toggleSelection(key);
                else manager.replaceSelection(key);
            } else if (e && e.shiftKey) manager.extendSelection(key);
            else if (manager.selectionBehavior === "toggle" || e && ((0, _utils.isCtrlKeyPressed)(e) || e.pointerType === "touch" || e.pointerType === "virtual")) // if touch or virtual (VO) then we just want to toggle, otherwise it's impossible to multi select because they don't have modifier keys
            manager.toggleSelection(key);
            else manager.replaceSelection(key);
        }
    };
    // Focus the associated DOM node when this item becomes the focusedKey
    (0, _react.useEffect)(()=>{
        let isFocused = key === manager.focusedKey;
        if (isFocused && manager.isFocused && !shouldUseVirtualFocus) {
            if (focus) focus();
            else if (document.activeElement !== ref.current) (0, _focus.focusSafely)(ref.current);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        ref,
        key,
        manager.focusedKey,
        manager.childFocusStrategy,
        manager.isFocused,
        shouldUseVirtualFocus
    ]);
    isDisabled = isDisabled || manager.isDisabled(key);
    // Set tabIndex to 0 if the element is focused, or -1 otherwise so that only the last focused
    // item is tabbable.  If using virtual focus, don't set a tabIndex at all so that VoiceOver
    // on iOS 14 doesn't try to move real DOM focus to the item anyway.
    let itemProps = {};
    if (!shouldUseVirtualFocus && !isDisabled) itemProps = {
        tabIndex: key === manager.focusedKey ? 0 : -1,
        onFocus (e) {
            if (e.target === ref.current) manager.setFocusedKey(key);
        }
    };
    else if (isDisabled) itemProps.onMouseDown = (e)=>{
        // Prevent focus going to the body when clicking on a disabled item.
        e.preventDefault();
    };
    // With checkbox selection, onAction (i.e. navigation) becomes primary, and occurs on a single click of the row.
    // Clicking the checkbox enters selection mode, after which clicking anywhere on any row toggles selection for that row.
    // With highlight selection, onAction is secondary, and occurs on double click. Single click selects the row.
    // With touch, onAction occurs on single tap, and long press enters selection mode.
    let isLinkOverride = manager.isLink(key) && linkBehavior === "override";
    let hasLinkAction = manager.isLink(key) && linkBehavior !== "selection" && linkBehavior !== "none";
    let allowsSelection = !isDisabled && manager.canSelectItem(key) && !isLinkOverride;
    let allowsActions = (onAction || hasLinkAction) && !isDisabled;
    let hasPrimaryAction = allowsActions && (manager.selectionBehavior === "replace" ? !allowsSelection : !allowsSelection || manager.isEmpty);
    let hasSecondaryAction = allowsActions && allowsSelection && manager.selectionBehavior === "replace";
    let hasAction = hasPrimaryAction || hasSecondaryAction;
    let modality = (0, _react.useRef)(null);
    let longPressEnabled = hasAction && allowsSelection;
    let longPressEnabledOnPressStart = (0, _react.useRef)(false);
    let hadPrimaryActionOnPressStart = (0, _react.useRef)(false);
    let performAction = (e)=>{
        if (onAction) onAction();
        if (hasLinkAction) router.open(ref.current, e);
    };
    // By default, selection occurs on pointer down. This can be strange if selecting an
    // item causes the UI to disappear immediately (e.g. menus).
    // If shouldSelectOnPressUp is true, we use onPressUp instead of onPressStart.
    // onPress requires a pointer down event on the same element as pointer up. For menus,
    // we want to be able to have the pointer down on the trigger that opens the menu and
    // the pointer up on the menu item rather than requiring a separate press.
    // For keyboard events, selection still occurs on key down.
    let itemPressProps = {};
    if (shouldSelectOnPressUp) {
        itemPressProps.onPressStart = (e)=>{
            modality.current = e.pointerType;
            longPressEnabledOnPressStart.current = longPressEnabled;
            if (e.pointerType === "keyboard" && (!hasAction || isSelectionKey())) onSelect(e);
        };
        // If allowsDifferentPressOrigin, make selection happen on pressUp (e.g. open menu on press down, selection on menu item happens on press up.)
        // Otherwise, have selection happen onPress (prevents listview row selection when clicking on interactable elements in the row)
        if (!allowsDifferentPressOrigin) itemPressProps.onPress = (e)=>{
            if (hasPrimaryAction || hasSecondaryAction && e.pointerType !== "mouse") {
                if (e.pointerType === "keyboard" && !isActionKey()) return;
                performAction(e);
            } else if (e.pointerType !== "keyboard" && allowsSelection) onSelect(e);
        };
        else {
            itemPressProps.onPressUp = hasPrimaryAction ? null : (e)=>{
                if (e.pointerType !== "keyboard" && allowsSelection) onSelect(e);
            };
            itemPressProps.onPress = hasPrimaryAction ? performAction : null;
        }
    } else {
        itemPressProps.onPressStart = (e)=>{
            modality.current = e.pointerType;
            longPressEnabledOnPressStart.current = longPressEnabled;
            hadPrimaryActionOnPressStart.current = hasPrimaryAction;
            // Select on mouse down unless there is a primary action which will occur on mouse up.
            // For keyboard, select on key down. If there is an action, the Space key selects on key down,
            // and the Enter key performs onAction on key up.
            if (allowsSelection && (e.pointerType === "mouse" && !hasPrimaryAction || e.pointerType === "keyboard" && (!allowsActions || isSelectionKey()))) onSelect(e);
        };
        itemPressProps.onPress = (e)=>{
            // Selection occurs on touch up. Primary actions always occur on pointer up.
            // Both primary and secondary actions occur on Enter key up. The only exception
            // is secondary actions, which occur on double click with a mouse.
            if (e.pointerType === "touch" || e.pointerType === "pen" || e.pointerType === "virtual" || e.pointerType === "keyboard" && hasAction && isActionKey() || e.pointerType === "mouse" && hadPrimaryActionOnPressStart.current) {
                if (hasAction) performAction(e);
                else if (allowsSelection) onSelect(e);
            }
        };
    }
    itemProps["data-key"] = key;
    itemPressProps.preventFocusOnPress = shouldUseVirtualFocus;
    let { pressProps, isPressed } = (0, _interactions.usePress)(itemPressProps);
    // Double clicking with a mouse with selectionBehavior = 'replace' performs an action.
    let onDoubleClick = hasSecondaryAction ? (e)=>{
        if (modality.current === "mouse") {
            e.stopPropagation();
            e.preventDefault();
            performAction(e);
        }
    } : undefined;
    // Long pressing an item with touch when selectionBehavior = 'replace' switches the selection behavior
    // to 'toggle'. This changes the single tap behavior from performing an action (i.e. navigating) to
    // selecting, and may toggle the appearance of a UI affordance like checkboxes on each item.
    let { longPressProps } = (0, _interactions.useLongPress)({
        isDisabled: !longPressEnabled,
        onLongPress (e) {
            if (e.pointerType === "touch") {
                onSelect(e);
                manager.setSelectionBehavior("toggle");
            }
        }
    });
    // Prevent native drag and drop on long press if we also select on long press.
    // Once the user is in selection mode, they can long press again to drag.
    // Use a capturing listener to ensure this runs before useDrag, regardless of
    // the order the props get merged.
    let onDragStartCapture = (e)=>{
        if (modality.current === "touch" && longPressEnabledOnPressStart.current) e.preventDefault();
    };
    // Prevent default on link clicks so that we control exactly
    // when they open (to match selection behavior).
    let onClick = manager.isLink(key) ? (e)=>{
        if (!(0, _utils1.openLink).isOpening) e.preventDefault();
    } : undefined;
    return {
        itemProps: (0, _utils1.mergeProps)(itemProps, allowsSelection || hasPrimaryAction ? pressProps : {}, longPressEnabled ? longPressProps : {}, {
            onDoubleClick,
            onDragStartCapture,
            onClick
        }),
        isPressed,
        isSelected: manager.isSelected(key),
        isFocused: manager.isFocused && manager.focusedKey === key,
        isDisabled,
        allowsSelection,
        hasAction
    };
}
function isActionKey() {
    let event = window.event;
    return (event === null || event === void 0 ? void 0 : event.key) === "Enter";
}
function isSelectionKey() {
    let event = window.event;
    return (event === null || event === void 0 ? void 0 : event.key) === " " || (event === null || event === void 0 ? void 0 : event.code) === "Space";
}

},{"@react-aria/focus":"42mbF","./utils":"4vm0e","@react-aria/utils":"9cLk5","@react-aria/interactions":"ky3G8","react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"cDkri":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Handles interactions with a selectable list.
 */ parcelHelpers.export(exports, "useSelectableList", ()=>useSelectableList);
var _useSelectableCollection = require("./useSelectableCollection");
var _listKeyboardDelegate = require("./ListKeyboardDelegate");
var _i18N = require("@react-aria/i18n");
var _react = require("react");
function useSelectableList(props) {
    let { selectionManager, collection, disabledKeys, ref, keyboardDelegate } = props;
    // By default, a KeyboardDelegate is provided which uses the DOM to query layout information (e.g. for page up/page down).
    // When virtualized, the layout object will be passed in as a prop and override this.
    let collator = (0, _i18N.useCollator)({
        usage: "search",
        sensitivity: "base"
    });
    let disabledBehavior = selectionManager.disabledBehavior;
    let delegate = (0, _react.useMemo)(()=>keyboardDelegate || new (0, _listKeyboardDelegate.ListKeyboardDelegate)(collection, disabledBehavior === "selection" ? new Set() : disabledKeys, ref, collator), [
        keyboardDelegate,
        collection,
        disabledKeys,
        ref,
        collator,
        disabledBehavior
    ]);
    let { collectionProps } = (0, _useSelectableCollection.useSelectableCollection)({
        ...props,
        ref,
        selectionManager,
        keyboardDelegate: delegate
    });
    return {
        listProps: collectionProps
    };
}

},{"./useSelectableCollection":"7sWYu","./ListKeyboardDelegate":"glRO1","@react-aria/i18n":"411rg","react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"glRO1":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ListKeyboardDelegate", ()=>ListKeyboardDelegate);
var _utils = require("@react-aria/utils");
class ListKeyboardDelegate {
    getNextKey(key) {
        key = this.collection.getKeyAfter(key);
        while(key != null){
            let item = this.collection.getItem(key);
            if (item.type === "item" && !this.disabledKeys.has(key)) return key;
            key = this.collection.getKeyAfter(key);
        }
        return null;
    }
    getPreviousKey(key) {
        key = this.collection.getKeyBefore(key);
        while(key != null){
            let item = this.collection.getItem(key);
            if (item.type === "item" && !this.disabledKeys.has(key)) return key;
            key = this.collection.getKeyBefore(key);
        }
        return null;
    }
    findKey(key, nextKey, shouldSkip) {
        let item = this.getItem(key);
        if (!item) return null;
        // Find the item above or below in the same column.
        let prevRect = item.getBoundingClientRect();
        do {
            key = nextKey(key);
            item = this.getItem(key);
        }while (item && shouldSkip(prevRect, item.getBoundingClientRect()));
        return key;
    }
    isSameRow(prevRect, itemRect) {
        return prevRect.top === itemRect.top || prevRect.left !== itemRect.left;
    }
    isSameColumn(prevRect, itemRect) {
        return prevRect.left === itemRect.left || prevRect.top !== itemRect.top;
    }
    getKeyBelow(key) {
        if (this.layout === "grid" && this.orientation === "vertical") return this.findKey(key, (key)=>this.getNextKey(key), this.isSameRow);
        else return this.getNextKey(key);
    }
    getKeyAbove(key) {
        if (this.layout === "grid" && this.orientation === "vertical") return this.findKey(key, (key)=>this.getPreviousKey(key), this.isSameRow);
        else return this.getPreviousKey(key);
    }
    getNextColumn(key, right) {
        return right ? this.getPreviousKey(key) : this.getNextKey(key);
    }
    getKeyRightOf(key) {
        if (this.layout === "grid") {
            if (this.orientation === "vertical") return this.getNextColumn(key, this.direction === "rtl");
            else return this.findKey(key, (key)=>this.getNextColumn(key, this.direction === "rtl"), this.isSameColumn);
        } else if (this.orientation === "horizontal") return this.getNextColumn(key, this.direction === "rtl");
        return null;
    }
    getKeyLeftOf(key) {
        if (this.layout === "grid") {
            if (this.orientation === "vertical") return this.getNextColumn(key, this.direction === "ltr");
            else return this.findKey(key, (key)=>this.getNextColumn(key, this.direction === "ltr"), this.isSameColumn);
        } else if (this.orientation === "horizontal") return this.getNextColumn(key, this.direction === "ltr");
        return null;
    }
    getFirstKey() {
        let key = this.collection.getFirstKey();
        while(key != null){
            let item = this.collection.getItem(key);
            if ((item === null || item === void 0 ? void 0 : item.type) === "item" && !this.disabledKeys.has(key)) return key;
            key = this.collection.getKeyAfter(key);
        }
        return null;
    }
    getLastKey() {
        let key = this.collection.getLastKey();
        while(key != null){
            let item = this.collection.getItem(key);
            if (item.type === "item" && !this.disabledKeys.has(key)) return key;
            key = this.collection.getKeyBefore(key);
        }
        return null;
    }
    getItem(key) {
        return this.ref.current.querySelector(`[data-key="${CSS.escape(key.toString())}"]`);
    }
    getKeyPageAbove(key) {
        let menu = this.ref.current;
        let item = this.getItem(key);
        if (!item) return null;
        if (!(0, _utils.isScrollable)(menu)) return this.getFirstKey();
        let containerRect = menu.getBoundingClientRect();
        let itemRect = item.getBoundingClientRect();
        if (this.orientation === "horizontal") {
            let containerX = containerRect.x - menu.scrollLeft;
            let pageX = Math.max(0, itemRect.x - containerX + itemRect.width - containerRect.width);
            while(item && itemRect.x - containerX > pageX){
                key = this.getKeyAbove(key);
                item = key == null ? null : this.getItem(key);
                itemRect = item === null || item === void 0 ? void 0 : item.getBoundingClientRect();
            }
        } else {
            let containerY = containerRect.y - menu.scrollTop;
            let pageY = Math.max(0, itemRect.y - containerY + itemRect.height - containerRect.height);
            while(item && itemRect.y - containerY > pageY){
                key = this.getKeyAbove(key);
                item = key == null ? null : this.getItem(key);
                itemRect = item === null || item === void 0 ? void 0 : item.getBoundingClientRect();
            }
        }
        return key !== null && key !== void 0 ? key : this.getFirstKey();
    }
    getKeyPageBelow(key) {
        let menu = this.ref.current;
        let item = this.getItem(key);
        if (!item) return null;
        if (!(0, _utils.isScrollable)(menu)) return this.getLastKey();
        let containerRect = menu.getBoundingClientRect();
        let itemRect = item.getBoundingClientRect();
        if (this.orientation === "horizontal") {
            let containerX = containerRect.x - menu.scrollLeft;
            let pageX = Math.min(menu.scrollWidth, itemRect.x - containerX - itemRect.width + containerRect.width);
            while(item && itemRect.x - containerX < pageX){
                key = this.getKeyBelow(key);
                item = key == null ? null : this.getItem(key);
                itemRect = item === null || item === void 0 ? void 0 : item.getBoundingClientRect();
            }
        } else {
            let containerY = containerRect.y - menu.scrollTop;
            let pageY = Math.min(menu.scrollHeight, itemRect.y - containerY - itemRect.height + containerRect.height);
            while(item && itemRect.y - containerY < pageY){
                key = this.getKeyBelow(key);
                item = key == null ? null : this.getItem(key);
                itemRect = item === null || item === void 0 ? void 0 : item.getBoundingClientRect();
            }
        }
        return key !== null && key !== void 0 ? key : this.getLastKey();
    }
    getKeyForSearch(search, fromKey) {
        if (!this.collator) return null;
        let collection = this.collection;
        let key = fromKey || this.getFirstKey();
        while(key != null){
            let item = collection.getItem(key);
            let substring = item.textValue.slice(0, search.length);
            if (item.textValue && this.collator.compare(substring, search) === 0) return key;
            key = this.getKeyBelow(key);
        }
        return null;
    }
    constructor(...args){
        if (args.length === 1) {
            let opts = args[0];
            this.collection = opts.collection;
            this.ref = opts.ref;
            this.collator = opts.collator;
            this.disabledKeys = opts.disabledKeys || new Set();
            this.orientation = opts.orientation;
            this.direction = opts.direction;
            this.layout = opts.layout || "stack";
        } else {
            this.collection = args[0];
            this.disabledKeys = args[1];
            this.ref = args[2];
            this.collator = args[3];
            this.layout = "stack";
            this.orientation = "vertical";
        }
        // If this is a vertical stack, remove the left/right methods completely
        // so they aren't called by useDroppableCollection.
        if (this.layout === "stack" && this.orientation === "vertical") {
            this.getKeyLeftOf = undefined;
            this.getKeyRightOf = undefined;
        }
    }
}

},{"@react-aria/utils":"9cLk5","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"5s26w":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides the behavior and accessibility implementation for an option in a listbox.
 * See `useListBox` for more details about listboxes.
 * @param props - Props for the option.
 * @param state - State for the listbox, as returned by `useListState`.
 */ parcelHelpers.export(exports, "useOption", ()=>useOption);
var _utils = require("@react-aria/utils");
var _collections = require("@react-stately/collections");
var _utils1 = require("./utils");
var _interactions = require("@react-aria/interactions");
var _selection = require("@react-aria/selection");
function useOption(props, state, ref) {
    var _item_props;
    let { key } = props;
    let data = (0, _utils1.listData).get(state);
    var _props_isDisabled;
    let isDisabled = (_props_isDisabled = props.isDisabled) !== null && _props_isDisabled !== void 0 ? _props_isDisabled : state.disabledKeys.has(key);
    var _props_isSelected;
    let isSelected = (_props_isSelected = props.isSelected) !== null && _props_isSelected !== void 0 ? _props_isSelected : state.selectionManager.isSelected(key);
    var _props_shouldSelectOnPressUp;
    let shouldSelectOnPressUp = (_props_shouldSelectOnPressUp = props.shouldSelectOnPressUp) !== null && _props_shouldSelectOnPressUp !== void 0 ? _props_shouldSelectOnPressUp : data === null || data === void 0 ? void 0 : data.shouldSelectOnPressUp;
    var _props_shouldFocusOnHover;
    let shouldFocusOnHover = (_props_shouldFocusOnHover = props.shouldFocusOnHover) !== null && _props_shouldFocusOnHover !== void 0 ? _props_shouldFocusOnHover : data === null || data === void 0 ? void 0 : data.shouldFocusOnHover;
    var _props_shouldUseVirtualFocus;
    let shouldUseVirtualFocus = (_props_shouldUseVirtualFocus = props.shouldUseVirtualFocus) !== null && _props_shouldUseVirtualFocus !== void 0 ? _props_shouldUseVirtualFocus : data === null || data === void 0 ? void 0 : data.shouldUseVirtualFocus;
    var _props_isVirtualized;
    let isVirtualized = (_props_isVirtualized = props.isVirtualized) !== null && _props_isVirtualized !== void 0 ? _props_isVirtualized : data === null || data === void 0 ? void 0 : data.isVirtualized;
    let labelId = (0, _utils.useSlotId)();
    let descriptionId = (0, _utils.useSlotId)();
    let optionProps = {
        role: "option",
        "aria-disabled": isDisabled || undefined,
        "aria-selected": state.selectionManager.selectionMode !== "none" ? isSelected : undefined
    };
    // Safari with VoiceOver on macOS misreads options with aria-labelledby or aria-label as simply "text".
    // We should not map slots to the label and description on Safari and instead just have VoiceOver read the textContent.
    // https://bugs.webkit.org/show_bug.cgi?id=209279
    if (!((0, _utils.isMac)() && (0, _utils.isWebKit)())) {
        optionProps["aria-label"] = props["aria-label"];
        optionProps["aria-labelledby"] = labelId;
        optionProps["aria-describedby"] = descriptionId;
    }
    let item = state.collection.getItem(key);
    if (isVirtualized) {
        let index = Number(item === null || item === void 0 ? void 0 : item.index);
        optionProps["aria-posinset"] = Number.isNaN(index) ? undefined : index + 1;
        optionProps["aria-setsize"] = (0, _collections.getItemCount)(state.collection);
    }
    let { itemProps, isPressed, isFocused, hasAction, allowsSelection } = (0, _selection.useSelectableItem)({
        selectionManager: state.selectionManager,
        key,
        ref,
        shouldSelectOnPressUp,
        allowsDifferentPressOrigin: shouldSelectOnPressUp && shouldFocusOnHover,
        isVirtualized,
        shouldUseVirtualFocus,
        isDisabled,
        onAction: (data === null || data === void 0 ? void 0 : data.onAction) ? ()=>{
            var _data_onAction;
            return data === null || data === void 0 ? void 0 : (_data_onAction = data.onAction) === null || _data_onAction === void 0 ? void 0 : _data_onAction.call(data, key);
        } : undefined,
        linkBehavior: data === null || data === void 0 ? void 0 : data.linkBehavior
    });
    let { hoverProps } = (0, _interactions.useHover)({
        isDisabled: isDisabled || !shouldFocusOnHover,
        onHoverStart () {
            if (!(0, _interactions.isFocusVisible)()) {
                state.selectionManager.setFocused(true);
                state.selectionManager.setFocusedKey(key);
            }
        }
    });
    let domProps = (0, _utils.filterDOMProps)(item === null || item === void 0 ? void 0 : item.props, {
        isLink: !!(item === null || item === void 0 ? void 0 : (_item_props = item.props) === null || _item_props === void 0 ? void 0 : _item_props.href)
    });
    delete domProps.id;
    return {
        optionProps: {
            ...optionProps,
            ...(0, _utils.mergeProps)(domProps, itemProps, hoverProps),
            id: (0, _utils1.getItemId)(state, key)
        },
        labelProps: {
            id: labelId
        },
        descriptionProps: {
            id: descriptionId
        },
        isFocused,
        isFocusVisible: isFocused && (0, _interactions.isFocusVisible)(),
        isSelected,
        isDisabled,
        isPressed,
        allowsSelection,
        hasAction
    };
}

},{"@react-aria/utils":"9cLk5","@react-stately/collections":"loANi","./utils":"3KRJf","@react-aria/interactions":"ky3G8","@react-aria/selection":"6Fly5","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"loANi":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Item", ()=>(0, _item.Item));
parcelHelpers.export(exports, "Section", ()=>(0, _section.Section));
parcelHelpers.export(exports, "useCollection", ()=>(0, _useCollection.useCollection));
parcelHelpers.export(exports, "getItemCount", ()=>(0, _getItemCount.getItemCount));
parcelHelpers.export(exports, "getChildNodes", ()=>(0, _getChildNodes.getChildNodes));
parcelHelpers.export(exports, "getFirstItem", ()=>(0, _getChildNodes.getFirstItem));
parcelHelpers.export(exports, "getLastItem", ()=>(0, _getChildNodes.getLastItem));
parcelHelpers.export(exports, "getNthItem", ()=>(0, _getChildNodes.getNthItem));
parcelHelpers.export(exports, "compareNodeOrder", ()=>(0, _getChildNodes.compareNodeOrder));
parcelHelpers.export(exports, "CollectionBuilder", ()=>(0, _collectionBuilder.CollectionBuilder));
var _item = require("./Item");
var _section = require("./Section");
var _useCollection = require("./useCollection");
var _getItemCount = require("./getItemCount");
var _getChildNodes = require("./getChildNodes");
var _collectionBuilder = require("./CollectionBuilder");

},{"./Item":"glX1U","./Section":"bxS24","./useCollection":"2q55w","./getItemCount":"9FXwG","./getChildNodes":"2zPQa","./CollectionBuilder":"4DvCw","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"glX1U":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Item", ()=>_Item);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
function Item(props) {
    return null;
}
Item.getCollectionNode = function* getCollectionNode(props, context) {
    let { childItems, title, children } = props;
    let rendered = props.title || props.children;
    let textValue = props.textValue || (typeof rendered === "string" ? rendered : "") || props["aria-label"] || "";
    // suppressTextValueWarning is used in components like Tabs, which don't have type to select support.
    if (!textValue && !(context === null || context === void 0 ? void 0 : context.suppressTextValueWarning)) console.warn("<Item> with non-plain text contents is unsupported by type to select for accessibility. Please add a `textValue` prop.");
    yield {
        type: "item",
        props: props,
        rendered,
        textValue,
        "aria-label": props["aria-label"],
        hasChildNodes: hasChildItems(props),
        *childNodes () {
            if (childItems) for (let child of childItems)yield {
                type: "item",
                value: child
            };
            else if (title) {
                let items = [];
                (0, _reactDefault.default).Children.forEach(children, (child)=>{
                    items.push({
                        type: "item",
                        element: child
                    });
                });
                yield* items;
            }
        }
    };
};
function hasChildItems(props) {
    if (props.hasChildItems != null) return props.hasChildItems;
    if (props.childItems) return true;
    if (props.title && (0, _reactDefault.default).Children.count(props.children) > 0) return true;
    return false;
}
// We don't want getCollectionNode to show up in the type definition
let _Item = Item;

},{"react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"bxS24":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Section", ()=>_Section);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
function Section(props) {
    return null;
}
Section.getCollectionNode = function* getCollectionNode(props) {
    let { children, title, items } = props;
    yield {
        type: "section",
        props: props,
        hasChildNodes: true,
        rendered: title,
        "aria-label": props["aria-label"],
        *childNodes () {
            if (typeof children === "function") {
                if (!items) throw new Error("props.children was a function but props.items is missing");
                for (let item of items)yield {
                    type: "item",
                    value: item,
                    renderer: children
                };
            } else {
                let items = [];
                (0, _reactDefault.default).Children.forEach(children, (child)=>{
                    items.push({
                        type: "item",
                        element: child
                    });
                });
                yield* items;
            }
        }
    };
};
// We don't want getCollectionNode to show up in the type definition
let _Section = Section;

},{"react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"2q55w":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useCollection", ()=>useCollection);
var _collectionBuilder = require("./CollectionBuilder");
var _react = require("react");
function useCollection(props, factory, context) {
    let builder = (0, _react.useMemo)(()=>new (0, _collectionBuilder.CollectionBuilder)(), []);
    let { children, items, collection } = props;
    let result = (0, _react.useMemo)(()=>{
        if (collection) return collection;
        let nodes = builder.build({
            children,
            items
        }, context);
        return factory(nodes);
    }, [
        builder,
        children,
        items,
        collection,
        context,
        factory
    ]);
    return result;
}

},{"./CollectionBuilder":"4DvCw","react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"4DvCw":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CollectionBuilder", ()=>CollectionBuilder);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
class CollectionBuilder {
    build(props, context) {
        this.context = context;
        return iterable(()=>this.iterateCollection(props));
    }
    *iterateCollection(props) {
        let { children, items } = props;
        if (typeof children === "function") {
            if (!items) throw new Error("props.children was a function but props.items is missing");
            for (let item of props.items)yield* this.getFullNode({
                value: item
            }, {
                renderer: children
            });
        } else {
            let items = [];
            (0, _reactDefault.default).Children.forEach(children, (child)=>{
                items.push(child);
            });
            let index = 0;
            for (let item of items){
                let nodes = this.getFullNode({
                    element: item,
                    index: index
                }, {});
                for (let node of nodes){
                    index++;
                    yield node;
                }
            }
        }
    }
    getKey(item, partialNode, state, parentKey) {
        if (item.key != null) return item.key;
        if (partialNode.type === "cell" && partialNode.key != null) return `${parentKey}${partialNode.key}`;
        let v = partialNode.value;
        if (v != null) {
            var _v_key;
            let key = (_v_key = v.key) !== null && _v_key !== void 0 ? _v_key : v.id;
            if (key == null) throw new Error("No key found for item");
            return key;
        }
        return parentKey ? `${parentKey}.${partialNode.index}` : `$.${partialNode.index}`;
    }
    getChildState(state, partialNode) {
        return {
            renderer: partialNode.renderer || state.renderer
        };
    }
    *getFullNode(partialNode, state, parentKey, parentNode) {
        // If there's a value instead of an element on the node, and a parent renderer function is available,
        // use it to render an element for the value.
        let element = partialNode.element;
        if (!element && partialNode.value && state && state.renderer) {
            let cached = this.cache.get(partialNode.value);
            if (cached && (!cached.shouldInvalidate || !cached.shouldInvalidate(this.context))) {
                cached.index = partialNode.index;
                cached.parentKey = parentNode ? parentNode.key : null;
                yield cached;
                return;
            }
            element = state.renderer(partialNode.value);
        }
        // If there's an element with a getCollectionNode function on its type, then it's a supported component.
        // Call this function to get a partial node, and recursively build a full node from there.
        if ((0, _reactDefault.default).isValidElement(element)) {
            let type = element.type;
            if (typeof type !== "function" && typeof type.getCollectionNode !== "function") {
                let name = typeof element.type === "function" ? element.type.name : element.type;
                throw new Error(`Unknown element <${name}> in collection.`);
            }
            let childNodes = type.getCollectionNode(element.props, this.context);
            let index = partialNode.index;
            let result = childNodes.next();
            while(!result.done && result.value){
                let childNode = result.value;
                partialNode.index = index;
                let nodeKey = childNode.key;
                if (!nodeKey) nodeKey = childNode.element ? null : this.getKey(element, partialNode, state, parentKey);
                let nodes = this.getFullNode({
                    ...childNode,
                    key: nodeKey,
                    index,
                    wrapper: compose(partialNode.wrapper, childNode.wrapper)
                }, this.getChildState(state, childNode), parentKey ? `${parentKey}${element.key}` : element.key, parentNode);
                let children = [
                    ...nodes
                ];
                for (let node of children){
                    // Cache the node based on its value
                    node.value = childNode.value || partialNode.value;
                    if (node.value) this.cache.set(node.value, node);
                    // The partial node may have specified a type for the child in order to specify a constraint.
                    // Verify that the full node that was built recursively matches this type.
                    if (partialNode.type && node.type !== partialNode.type) throw new Error(`Unsupported type <${capitalize(node.type)}> in <${capitalize(parentNode.type)}>. Only <${capitalize(partialNode.type)}> is supported.`);
                    index++;
                    yield node;
                }
                result = childNodes.next(children);
            }
            return;
        }
        // Ignore invalid elements
        if (partialNode.key == null) return;
        // Create full node
        let builder = this;
        let node = {
            type: partialNode.type,
            props: partialNode.props,
            key: partialNode.key,
            parentKey: parentNode ? parentNode.key : null,
            value: partialNode.value,
            level: parentNode ? parentNode.level + 1 : 0,
            index: partialNode.index,
            rendered: partialNode.rendered,
            textValue: partialNode.textValue,
            "aria-label": partialNode["aria-label"],
            wrapper: partialNode.wrapper,
            shouldInvalidate: partialNode.shouldInvalidate,
            hasChildNodes: partialNode.hasChildNodes,
            childNodes: iterable(function*() {
                if (!partialNode.hasChildNodes) return;
                let index = 0;
                for (let child of partialNode.childNodes()){
                    // Ensure child keys are globally unique by prepending the parent node's key
                    if (child.key != null) // TODO: Remove this line entirely and enforce that users always provide unique keys.
                    // Currently this line will have issues when a parent has a key `a` and a child with key `bc`
                    // but another parent has key `ab` and its child has a key `c`. The combined keys would result in both
                    // children having a key of `abc`.
                    child.key = `${node.key}${child.key}`;
                    child.index = index;
                    let nodes = builder.getFullNode(child, builder.getChildState(state, child), node.key, node);
                    for (let node of nodes){
                        index++;
                        yield node;
                    }
                }
            })
        };
        yield node;
    }
    constructor(){
        this.cache = new WeakMap();
    }
}
// Wraps an iterator function as an iterable object, and caches the results.
function iterable(iterator) {
    let cache = [];
    let iterable = null;
    return {
        *[Symbol.iterator] () {
            for (let item of cache)yield item;
            if (!iterable) iterable = iterator();
            for (let item of iterable){
                cache.push(item);
                yield item;
            }
        }
    };
}
function compose(outer, inner) {
    if (outer && inner) return (element)=>outer(inner(element));
    if (outer) return outer;
    if (inner) return inner;
}
function capitalize(str) {
    return str[0].toUpperCase() + str.slice(1);
}

},{"react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"9FXwG":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getItemCount", ()=>getItemCount);
var _getChildNodes = require("./getChildNodes");
const cache = new WeakMap();
function getItemCount(collection) {
    let count = cache.get(collection);
    if (count != null) return count;
    count = 0;
    let countItems = (items)=>{
        for (let item of items)if (item.type === "section") countItems((0, _getChildNodes.getChildNodes)(item, collection));
        else count++;
    };
    countItems(collection);
    cache.set(collection, count);
    return count;
}

},{"./getChildNodes":"2zPQa","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"2zPQa":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getChildNodes", ()=>getChildNodes);
parcelHelpers.export(exports, "getFirstItem", ()=>getFirstItem);
parcelHelpers.export(exports, "getNthItem", ()=>getNthItem);
parcelHelpers.export(exports, "getLastItem", ()=>getLastItem);
parcelHelpers.export(exports, "compareNodeOrder", ()=>compareNodeOrder);
function getChildNodes(node, collection) {
    // New API: call collection.getChildren with the node key.
    if (typeof collection.getChildren === "function") return collection.getChildren(node.key);
    // Old API: access childNodes directly.
    return node.childNodes;
}
function getFirstItem(iterable) {
    return getNthItem(iterable, 0);
}
function getNthItem(iterable, index) {
    if (index < 0) return undefined;
    let i = 0;
    for (let item of iterable){
        if (i === index) return item;
        i++;
    }
}
function getLastItem(iterable) {
    let lastItem = undefined;
    for (let value of iterable)lastItem = value;
    return lastItem;
}
function compareNodeOrder(collection, a, b) {
    // If the two nodes have the same parent, compare their indices.
    if (a.parentKey === b.parentKey) return a.index - b.index;
    // Otherwise, collect all of the ancestors from each node, and find the first one that doesn't match starting from the root.
    // Include the base nodes in case we are comparing nodes of different levels so that we can compare the higher node to the lower level node's
    // ancestor of the same level
    let aAncestors = [
        ...getAncestors(collection, a),
        a
    ];
    let bAncestors = [
        ...getAncestors(collection, b),
        b
    ];
    let firstNonMatchingAncestor = aAncestors.slice(0, bAncestors.length).findIndex((a, i)=>a !== bAncestors[i]);
    if (firstNonMatchingAncestor !== -1) {
        // Compare the indices of two children within the common ancestor.
        a = aAncestors[firstNonMatchingAncestor];
        b = bAncestors[firstNonMatchingAncestor];
        return a.index - b.index;
    }
    // If there isn't a non matching ancestor, we might be in a case where one of the nodes is the ancestor of the other.
    if (aAncestors.findIndex((node)=>node === b) >= 0) return 1;
    else if (bAncestors.findIndex((node)=>node === a) >= 0) return -1;
    // 🤷
    return -1;
}
function getAncestors(collection, node) {
    let parents = [];
    while((node === null || node === void 0 ? void 0 : node.parentKey) != null){
        node = collection.getItem(node.parentKey);
        parents.unshift(node);
    }
    return parents;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"kdNi0":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides the behavior and accessibility implementation for a section in a listbox.
 * See `useListBox` for more details about listboxes.
 * @param props - Props for the section.
 */ parcelHelpers.export(exports, "useListBoxSection", ()=>useListBoxSection);
var _utils = require("@react-aria/utils");
function useListBoxSection(props) {
    let { heading, "aria-label": ariaLabel } = props;
    let headingId = (0, _utils.useId)();
    return {
        itemProps: {
            role: "presentation"
        },
        headingProps: heading ? {
            // Techincally, listbox cannot contain headings according to ARIA.
            // We hide the heading from assistive technology, using role="presentation",
            // and only use it as a visual label for the nested group.
            id: headingId,
            role: "presentation"
        } : {},
        groupProps: {
            role: "group",
            "aria-label": ariaLabel,
            "aria-labelledby": heading ? headingId : undefined
        }
    };
}

},{"@react-aria/utils":"9cLk5","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"5cZRr":[function(require,module,exports) {
const _temp0 = require("bda209fc0795baf0");
const _temp1 = require("f4fb218734320b1c");
const _temp2 = require("db73d7282e7f0b72");
const _temp3 = require("8a89c20812888ac5");
const _temp4 = require("a90a393d42fd1ac0");
const _temp5 = require("758b19f6dbaa515a");
const _temp6 = require("bc257e3896baaa59");
const _temp7 = require("302f7e60e499de20");
const _temp8 = require("952535943a1235f2");
const _temp9 = require("f92b00de8074435d");
const _temp10 = require("1f9178c7b8f748b");
const _temp11 = require("cd26659b414d8184");
const _temp12 = require("ddcbedac816178a0");
const _temp13 = require("f9345e760610146c");
const _temp14 = require("e01ec2e07d7b968e");
const _temp15 = require("3e57c57b9e92b500");
const _temp16 = require("f46530bb786ed179");
const _temp17 = require("3d6a7d1d727a2430");
const _temp18 = require("855997635d80c698");
const _temp19 = require("91e18e6496db6994");
const _temp20 = require("85f18ef82418793a");
const _temp21 = require("dafe1a7a9b19814b");
const _temp22 = require("174c8dfc91ce423b");
const _temp23 = require("4ca0cd9f2e1674e");
const _temp24 = require("b843c0f0be1a5594");
const _temp25 = require("641171703c4c2319");
const _temp26 = require("e37240b59dce71ee");
const _temp27 = require("6f423c247b201d1c");
const _temp28 = require("4943e512073ce766");
const _temp29 = require("a6dc08871bdb2569");
const _temp30 = require("50874404f5be2ced");
const _temp31 = require("94e3081da8d25736");
const _temp32 = require("d83de5c43e7ebfbc");
const _temp33 = require("2e7e43f150f68960");
module.exports = {
    "ar-AE": _temp0,
    "bg-BG": _temp1,
    "cs-CZ": _temp2,
    "da-DK": _temp3,
    "de-DE": _temp4,
    "el-GR": _temp5,
    "en-US": _temp6,
    "es-ES": _temp7,
    "et-EE": _temp8,
    "fi-FI": _temp9,
    "fr-FR": _temp10,
    "he-IL": _temp11,
    "hr-HR": _temp12,
    "hu-HU": _temp13,
    "it-IT": _temp14,
    "ja-JP": _temp15,
    "ko-KR": _temp16,
    "lt-LT": _temp17,
    "lv-LV": _temp18,
    "nb-NO": _temp19,
    "nl-NL": _temp20,
    "pl-PL": _temp21,
    "pt-BR": _temp22,
    "pt-PT": _temp23,
    "ro-RO": _temp24,
    "ru-RU": _temp25,
    "sk-SK": _temp26,
    "sl-SI": _temp27,
    "sr-SP": _temp28,
    "sv-SE": _temp29,
    "tr-TR": _temp30,
    "uk-UA": _temp31,
    "zh-CN": _temp32,
    "zh-TW": _temp33
};

},{"bda209fc0795baf0":"7Hf9w","f4fb218734320b1c":"5rN8z","db73d7282e7f0b72":"2ZY8Z","8a89c20812888ac5":"gUFHp","a90a393d42fd1ac0":"9JWbv","758b19f6dbaa515a":"7hkZC","bc257e3896baaa59":"LbTzQ","302f7e60e499de20":"2ERGE","952535943a1235f2":"bQcus","f92b00de8074435d":"lxgqm","1f9178c7b8f748b":"dnzVI","cd26659b414d8184":"66ARJ","ddcbedac816178a0":"fl09h","f9345e760610146c":"7Zk7H","e01ec2e07d7b968e":"fU8Sy","3e57c57b9e92b500":"95dVl","f46530bb786ed179":"XNHYI","3d6a7d1d727a2430":"aFOPn","855997635d80c698":"jte32","91e18e6496db6994":"9HERk","85f18ef82418793a":"aBIje","dafe1a7a9b19814b":"fG8tN","174c8dfc91ce423b":"5giwe","4ca0cd9f2e1674e":"cnvop","b843c0f0be1a5594":"iPIYa","641171703c4c2319":"jlODS","e37240b59dce71ee":"igxLU","6f423c247b201d1c":"1XVHU","4943e512073ce766":"dYOWW","a6dc08871bdb2569":"HqLOY","50874404f5be2ced":"4xMOg","94e3081da8d25736":"23JO8","d83de5c43e7ebfbc":"kfJtH","2e7e43f150f68960":"5ZRVz"}],"7Hf9w":[function(require,module,exports) {
module.exports = {
    "buttonLabel": `\u{639}\u{631}\u{636} \u{627}\u{644}\u{645}\u{642}\u{62A}\u{631}\u{62D}\u{627}\u{62A}`,
    "countAnnouncement": (args, formatter)=>`${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} \u{62E}\u{64A}\u{627}\u{631}`,
            other: ()=>`${formatter.number(args.optionCount)} \u{62E}\u{64A}\u{627}\u{631}\u{627}\u{62A}`
        })} \u{645}\u{62A}\u{627}\u{62D}\u{629}.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`\u{627}\u{644}\u{645}\u{62C}\u{645}\u{648}\u{639}\u{629} \u{627}\u{644}\u{645}\u{62F}\u{62E}\u{644}\u{629} ${args.groupTitle}, \u{645}\u{639} ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} \u{62E}\u{64A}\u{627}\u{631}`,
                    other: ()=>`${formatter.number(args.groupCount)} \u{62E}\u{64A}\u{627}\u{631}\u{627}\u{62A}`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, \u{645}\u{62D}\u{62F}\u{62F}`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `\u{645}\u{642}\u{62A}\u{631}\u{62D}\u{627}\u{62A}`,
    "selectedAnnouncement": (args)=>`${args.optionText}\u{60C} \u{645}\u{62D}\u{62F}\u{62F}`
};

},{}],"5rN8z":[function(require,module,exports) {
module.exports = {
    "buttonLabel": `\u{41F}\u{43E}\u{43A}\u{430}\u{436}\u{438} \u{43F}\u{440}\u{435}\u{434}\u{43B}\u{43E}\u{436}\u{435}\u{43D}\u{438}\u{44F}`,
    "countAnnouncement": (args, formatter)=>`${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} \u{43E}\u{43F}\u{446}\u{438}\u{44F}`,
            other: ()=>`${formatter.number(args.optionCount)} \u{43E}\u{43F}\u{446}\u{438}\u{438}`
        })} \u{43D}\u{430} \u{440}\u{430}\u{437}\u{43F}\u{43E}\u{43B}\u{43E}\u{436}\u{435}\u{43D}\u{438}\u{435}.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`\u{412}\u{44A}\u{432}\u{435}\u{434}\u{435}\u{43D}\u{430} \u{433}\u{440}\u{443}\u{43F}\u{430} ${args.groupTitle}, \u{441} ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} \u{43E}\u{43F}\u{446}\u{438}\u{44F}`,
                    other: ()=>`${formatter.number(args.groupCount)} \u{43E}\u{43F}\u{446}\u{438}\u{438}`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, \u{438}\u{437}\u{431}\u{440}\u{430}\u{43D}\u{438}`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `\u{41F}\u{440}\u{435}\u{434}\u{43B}\u{43E}\u{436}\u{435}\u{43D}\u{438}\u{44F}`,
    "selectedAnnouncement": (args)=>`${args.optionText}, \u{438}\u{437}\u{431}\u{440}\u{430}\u{43D}\u{438}`
};

},{}],"2ZY8Z":[function(require,module,exports) {
module.exports = {
    "buttonLabel": `Zobrazit doporu\u{10D}en\xed`,
    "countAnnouncement": (args, formatter)=>`K dispozici ${formatter.plural(args.optionCount, {
            one: ()=>`je ${formatter.number(args.optionCount)} mo\u{17E}nost`,
            other: ()=>`jsou/je ${formatter.number(args.optionCount)} mo\u{17E}nosti/-\xed`
        })}.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`Zadan\xe1 skupina \u{201E}${args.groupTitle}\u{201C} ${formatter.plural(args.groupCount, {
                    one: ()=>`s ${formatter.number(args.groupCount)} mo\u{17E}nost\xed`,
                    other: ()=>`se ${formatter.number(args.groupCount)} mo\u{17E}nostmi`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: ` (vybr\xe1no)`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `N\xe1vrhy`,
    "selectedAnnouncement": (args)=>`${args.optionText}, vybr\xe1no`
};

},{}],"gUFHp":[function(require,module,exports) {
module.exports = {
    "buttonLabel": `Vis forslag`,
    "countAnnouncement": (args, formatter)=>`${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} mulighed tilg\xe6ngelig`,
            other: ()=>`${formatter.number(args.optionCount)} muligheder tilg\xe6ngelige`
        })}.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`Angivet gruppe ${args.groupTitle}, med ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} mulighed`,
                    other: ()=>`${formatter.number(args.groupCount)} muligheder`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, valgt`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `Forslag`,
    "selectedAnnouncement": (args)=>`${args.optionText}, valgt`
};

},{}],"9JWbv":[function(require,module,exports) {
module.exports = {
    "buttonLabel": `Empfehlungen anzeigen`,
    "countAnnouncement": (args, formatter)=>`${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} Option`,
            other: ()=>`${formatter.number(args.optionCount)} Optionen`
        })} verf\xfcgbar.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`Eingetretene Gruppe ${args.groupTitle}, mit ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} Option`,
                    other: ()=>`${formatter.number(args.groupCount)} Optionen`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, ausgew\xe4hlt`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `Empfehlungen`,
    "selectedAnnouncement": (args)=>`${args.optionText}, ausgew\xe4hlt`
};

},{}],"7hkZC":[function(require,module,exports) {
module.exports = {
    "buttonLabel": `\u{3A0}\u{3C1}\u{3BF}\u{3B2}\u{3BF}\u{3BB}\u{3AE} \u{3C0}\u{3C1}\u{3BF}\u{3C4}\u{3AC}\u{3C3}\u{3B5}\u{3C9}\u{3BD}`,
    "countAnnouncement": (args, formatter)=>`${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} \u{3B5}\u{3C0}\u{3B9}\u{3BB}\u{3BF}\u{3B3}\u{3AE}`,
            other: ()=>`${formatter.number(args.optionCount)} \u{3B5}\u{3C0}\u{3B9}\u{3BB}\u{3BF}\u{3B3}\u{3AD}\u{3C2} `
        })} \u{3B4}\u{3B9}\u{3B1}\u{3B8}\u{3AD}\u{3C3}\u{3B9}\u{3BC}\u{3B5}\u{3C2}.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`\u{395}\u{3B9}\u{3C3}\u{3B1}\u{3B3}\u{3BC}\u{3AD}\u{3BD}\u{3B7} \u{3BF}\u{3BC}\u{3AC}\u{3B4}\u{3B1} ${args.groupTitle}, \u{3BC}\u{3B5} ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} \u{3B5}\u{3C0}\u{3B9}\u{3BB}\u{3BF}\u{3B3}\u{3AE}`,
                    other: ()=>`${formatter.number(args.groupCount)} \u{3B5}\u{3C0}\u{3B9}\u{3BB}\u{3BF}\u{3B3}\u{3AD}\u{3C2}`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, \u{3B5}\u{3C0}\u{3B9}\u{3BB}\u{3B5}\u{3B3}\u{3BC}\u{3AD}\u{3BD}\u{3BF}`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `\u{3A0}\u{3C1}\u{3BF}\u{3C4}\u{3AC}\u{3C3}\u{3B5}\u{3B9}\u{3C2}`,
    "selectedAnnouncement": (args)=>`${args.optionText}, \u{3B5}\u{3C0}\u{3B9}\u{3BB}\u{3AD}\u{3C7}\u{3B8}\u{3B7}\u{3BA}\u{3B5}`
};

},{}],"LbTzQ":[function(require,module,exports) {
module.exports = {
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`Entered group ${args.groupTitle}, with ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} option`,
                    other: ()=>`${formatter.number(args.groupCount)} options`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, selected`,
            other: ``
        }, args.isSelected)}`,
    "countAnnouncement": (args, formatter)=>`${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} option`,
            other: ()=>`${formatter.number(args.optionCount)} options`
        })} available.`,
    "selectedAnnouncement": (args)=>`${args.optionText}, selected`,
    "buttonLabel": `Show suggestions`,
    "listboxLabel": `Suggestions`
};

},{}],"2ERGE":[function(require,module,exports) {
module.exports = {
    "buttonLabel": `Mostrar sugerencias`,
    "countAnnouncement": (args, formatter)=>`${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} opci\xf3n`,
            other: ()=>`${formatter.number(args.optionCount)} opciones`
        })} disponible(s).`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`Se ha unido al grupo ${args.groupTitle}, con ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} opci\xf3n`,
                    other: ()=>`${formatter.number(args.groupCount)} opciones`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, seleccionado`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `Sugerencias`,
    "selectedAnnouncement": (args)=>`${args.optionText}, seleccionado`
};

},{}],"bQcus":[function(require,module,exports) {
module.exports = {
    "buttonLabel": `Kuva soovitused`,
    "countAnnouncement": (args, formatter)=>`${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} valik`,
            other: ()=>`${formatter.number(args.optionCount)} valikud`
        })} saadaval.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`Sisestatud r\xfchm ${args.groupTitle}, valikuga ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} valik`,
                    other: ()=>`${formatter.number(args.groupCount)} valikud`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, valitud`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `Soovitused`,
    "selectedAnnouncement": (args)=>`${args.optionText}, valitud`
};

},{}],"lxgqm":[function(require,module,exports) {
module.exports = {
    "buttonLabel": `N\xe4yt\xe4 ehdotukset`,
    "countAnnouncement": (args, formatter)=>`${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} vaihtoehto`,
            other: ()=>`${formatter.number(args.optionCount)} vaihtoehdot`
        })} saatavilla.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`Mentiin ryhm\xe4\xe4n ${args.groupTitle}, ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} vaihtoehdon`,
                    other: ()=>`${formatter.number(args.groupCount)} vaihtoehdon`
                })} kanssa.`,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, valittu`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `Ehdotukset`,
    "selectedAnnouncement": (args)=>`${args.optionText}, valittu`
};

},{}],"dnzVI":[function(require,module,exports) {
module.exports = {
    "buttonLabel": `Afficher les suggestions`,
    "countAnnouncement": (args, formatter)=>`${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} option`,
            other: ()=>`${formatter.number(args.optionCount)} options`
        })} disponible(s).`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`Groupe ${args.groupTitle} rejoint, avec ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} option`,
                    other: ()=>`${formatter.number(args.groupCount)} options`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, s\xe9lectionn\xe9(s)`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `Suggestions`,
    "selectedAnnouncement": (args)=>`${args.optionText}, s\xe9lectionn\xe9`
};

},{}],"66ARJ":[function(require,module,exports) {
module.exports = {
    "buttonLabel": `\u{5D4}\u{5E6}\u{5D2} \u{5D4}\u{5E6}\u{5E2}\u{5D5}\u{5EA}`,
    "countAnnouncement": (args, formatter)=>`${formatter.plural(args.optionCount, {
            one: ()=>`\u{5D0}\u{5E4}\u{5E9}\u{5E8}\u{5D5}\u{5EA} ${formatter.number(args.optionCount)}`,
            other: ()=>`${formatter.number(args.optionCount)} \u{5D0}\u{5E4}\u{5E9}\u{5E8}\u{5D5}\u{5D9}\u{5D5}\u{5EA}`
        })} \u{5D1}\u{5DE}\u{5E6}\u{5D1} \u{5D6}\u{5DE}\u{5D9}\u{5DF}.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`\u{5E0}\u{5DB}\u{5E0}\u{5E1} \u{5DC}\u{5E7}\u{5D1}\u{5D5}\u{5E6}\u{5D4} ${args.groupTitle}, \u{5E2}\u{5DD} ${formatter.plural(args.groupCount, {
                    one: ()=>`\u{5D0}\u{5E4}\u{5E9}\u{5E8}\u{5D5}\u{5EA} ${formatter.number(args.groupCount)}`,
                    other: ()=>`${formatter.number(args.groupCount)} \u{5D0}\u{5E4}\u{5E9}\u{5E8}\u{5D5}\u{5D9}\u{5D5}\u{5EA}`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, \u{5E0}\u{5D1}\u{5D7}\u{5E8}`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `\u{5D4}\u{5E6}\u{5E2}\u{5D5}\u{5EA}`,
    "selectedAnnouncement": (args)=>`${args.optionText}, \u{5E0}\u{5D1}\u{5D7}\u{5E8}`
};

},{}],"fl09h":[function(require,module,exports) {
module.exports = {
    "buttonLabel": `Prika\u{17E}i prijedloge`,
    "countAnnouncement": (args, formatter)=>`Dostupno jo\u{161}: ${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} opcija`,
            other: ()=>`${formatter.number(args.optionCount)} opcije/a`
        })}.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`Unesena skupina ${args.groupTitle}, s ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} opcijom`,
                    other: ()=>`${formatter.number(args.groupCount)} opcije/a`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, odabranih`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `Prijedlozi`,
    "selectedAnnouncement": (args)=>`${args.optionText}, odabrano`
};

},{}],"7Zk7H":[function(require,module,exports) {
module.exports = {
    "buttonLabel": `Javaslatok megjelen\xedt\xe9se`,
    "countAnnouncement": (args, formatter)=>`${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} lehet\u{151}s\xe9g`,
            other: ()=>`${formatter.number(args.optionCount)} lehet\u{151}s\xe9g`
        })} \xe1ll rendelkez\xe9sre.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`Bel\xe9pett a(z) ${args.groupTitle} csoportba, amely ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} lehet\u{151}s\xe9get`,
                    other: ()=>`${formatter.number(args.groupCount)} lehet\u{151}s\xe9get`
                })} tartalmaz. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, kijel\xf6lve`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `Javaslatok`,
    "selectedAnnouncement": (args)=>`${args.optionText}, kijel\xf6lve`
};

},{}],"fU8Sy":[function(require,module,exports) {
module.exports = {
    "buttonLabel": `Mostra suggerimenti`,
    "countAnnouncement": (args, formatter)=>`${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} opzione disponibile`,
            other: ()=>`${formatter.number(args.optionCount)} opzioni disponibili`
        })}.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`Ingresso nel gruppo ${args.groupTitle}, con ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} opzione`,
                    other: ()=>`${formatter.number(args.groupCount)} opzioni`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, selezionato`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `Suggerimenti`,
    "selectedAnnouncement": (args)=>`${args.optionText}, selezionato`
};

},{}],"95dVl":[function(require,module,exports) {
module.exports = {
    "buttonLabel": `\u{5019}\u{88DC}\u{3092}\u{8868}\u{793A}`,
    "countAnnouncement": (args, formatter)=>`${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} \u{500B}\u{306E}\u{30AA}\u{30D7}\u{30B7}\u{30E7}\u{30F3}`,
            other: ()=>`${formatter.number(args.optionCount)} \u{500B}\u{306E}\u{30AA}\u{30D7}\u{30B7}\u{30E7}\u{30F3}`
        })}\u{3092}\u{5229}\u{7528}\u{3067}\u{304D}\u{307E}\u{3059}\u{3002}`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`\u{5165}\u{529B}\u{3055}\u{308C}\u{305F}\u{30B0}\u{30EB}\u{30FC}\u{30D7} ${args.groupTitle}\u{3001}${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} \u{500B}\u{306E}\u{30AA}\u{30D7}\u{30B7}\u{30E7}\u{30F3}`,
                    other: ()=>`${formatter.number(args.groupCount)} \u{500B}\u{306E}\u{30AA}\u{30D7}\u{30B7}\u{30E7}\u{30F3}`
                })}\u{3092}\u{542B}\u{3080}\u{3002}`,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `\u{3001}\u{9078}\u{629E}\u{6E08}\u{307F}`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `\u{5019}\u{88DC}`,
    "selectedAnnouncement": (args)=>`${args.optionText}\u{3001}\u{9078}\u{629E}\u{6E08}\u{307F}`
};

},{}],"XNHYI":[function(require,module,exports) {
module.exports = {
    "buttonLabel": `\u{C81C}\u{C548} \u{C0AC}\u{D56D} \u{D45C}\u{C2DC}`,
    "countAnnouncement": (args, formatter)=>`${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)}\u{AC1C} \u{C635}\u{C158}`,
            other: ()=>`${formatter.number(args.optionCount)}\u{AC1C} \u{C635}\u{C158}`
        })}\u{C744} \u{C0AC}\u{C6A9}\u{D560} \u{C218} \u{C788}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`\u{C785}\u{B825}\u{D55C} \u{ADF8}\u{B8F9} ${args.groupTitle}, ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)}\u{AC1C} \u{C635}\u{C158}`,
                    other: ()=>`${formatter.number(args.groupCount)}\u{AC1C} \u{C635}\u{C158}`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, \u{C120}\u{D0DD}\u{B428}`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `\u{C81C}\u{C548}`,
    "selectedAnnouncement": (args)=>`${args.optionText}, \u{C120}\u{D0DD}\u{B428}`
};

},{}],"aFOPn":[function(require,module,exports) {
module.exports = {
    "buttonLabel": `Rodyti pasi\u{16B}lymus`,
    "countAnnouncement": (args, formatter)=>`Yra ${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} parinktis`,
            other: ()=>`${formatter.number(args.optionCount)} parinktys (-i\u{173})`
        })}.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`\u{12E}vesta grup\u{117} ${args.groupTitle}, su ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} parinktimi`,
                    other: ()=>`${formatter.number(args.groupCount)} parinktimis (-i\u{173})`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, pasirinkta`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `Pasi\u{16B}lymai`,
    "selectedAnnouncement": (args)=>`${args.optionText}, pasirinkta`
};

},{}],"jte32":[function(require,module,exports) {
module.exports = {
    "buttonLabel": `R\u{101}d\u{12B}t ieteikumus`,
    "countAnnouncement": (args, formatter)=>`Pieejamo opciju skaits: ${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} opcija`,
            other: ()=>`${formatter.number(args.optionCount)} opcijas`
        })}.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`Ievad\u{12B}ta grupa ${args.groupTitle}, ar ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} opciju`,
                    other: ()=>`${formatter.number(args.groupCount)} opcij\u{101}m`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, atlas\u{12B}ta`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `Ieteikumi`,
    "selectedAnnouncement": (args)=>`${args.optionText}, atlas\u{12B}ta`
};

},{}],"9HERk":[function(require,module,exports) {
module.exports = {
    "buttonLabel": `Vis forslag`,
    "countAnnouncement": (args, formatter)=>`${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} alternativ`,
            other: ()=>`${formatter.number(args.optionCount)} alternativer`
        })} finnes.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`Angitt gruppe ${args.groupTitle}, med ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} alternativ`,
                    other: ()=>`${formatter.number(args.groupCount)} alternativer`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, valgt`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `Forslag`,
    "selectedAnnouncement": (args)=>`${args.optionText}, valgt`
};

},{}],"aBIje":[function(require,module,exports) {
module.exports = {
    "buttonLabel": `Suggesties weergeven`,
    "countAnnouncement": (args, formatter)=>`${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} optie`,
            other: ()=>`${formatter.number(args.optionCount)} opties`
        })} beschikbaar.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`Groep ${args.groupTitle} ingevoerd met ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} optie`,
                    other: ()=>`${formatter.number(args.groupCount)} opties`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, geselecteerd`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `Suggesties`,
    "selectedAnnouncement": (args)=>`${args.optionText}, geselecteerd`
};

},{}],"fG8tN":[function(require,module,exports) {
module.exports = {
    "buttonLabel": `Wy\u{15B}wietlaj sugestie`,
    "countAnnouncement": (args, formatter)=>`dost\u{119}pna/dost\u{119}pne(-nych) ${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} opcja`,
            other: ()=>`${formatter.number(args.optionCount)} opcje(-i)`
        })}.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`Do\u{142}\u{105}czono do grupy ${args.groupTitle}, z ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} opcj\u{105}`,
                    other: ()=>`${formatter.number(args.groupCount)} opcjami`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, wybrano`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `Sugestie`,
    "selectedAnnouncement": (args)=>`${args.optionText}, wybrano`
};

},{}],"5giwe":[function(require,module,exports) {
module.exports = {
    "buttonLabel": `Mostrar sugest\xf5es`,
    "countAnnouncement": (args, formatter)=>`${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} op\xe7\xe3o`,
            other: ()=>`${formatter.number(args.optionCount)} op\xe7\xf5es`
        })} dispon\xedvel.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`Grupo inserido ${args.groupTitle}, com ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} op\xe7\xe3o`,
                    other: ()=>`${formatter.number(args.groupCount)} op\xe7\xf5es`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, selecionado`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `Sugest\xf5es`,
    "selectedAnnouncement": (args)=>`${args.optionText}, selecionado`
};

},{}],"cnvop":[function(require,module,exports) {
module.exports = {
    "buttonLabel": `Apresentar sugest\xf5es`,
    "countAnnouncement": (args, formatter)=>`${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} op\xe7\xe3o`,
            other: ()=>`${formatter.number(args.optionCount)} op\xe7\xf5es`
        })} dispon\xedvel.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`Grupo introduzido ${args.groupTitle}, com ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} op\xe7\xe3o`,
                    other: ()=>`${formatter.number(args.groupCount)} op\xe7\xf5es`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, selecionado`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `Sugest\xf5es`,
    "selectedAnnouncement": (args)=>`${args.optionText}, selecionado`
};

},{}],"iPIYa":[function(require,module,exports) {
module.exports = {
    "buttonLabel": `Afi\u{219}are sugestii`,
    "countAnnouncement": (args, formatter)=>`${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} op\u{21B}iune`,
            other: ()=>`${formatter.number(args.optionCount)} op\u{21B}iuni`
        })} disponibile.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`Grup ${args.groupTitle} introdus, cu ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} op\u{21B}iune`,
                    other: ()=>`${formatter.number(args.groupCount)} op\u{21B}iuni`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, selectat`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `Sugestii`,
    "selectedAnnouncement": (args)=>`${args.optionText}, selectat`
};

},{}],"jlODS":[function(require,module,exports) {
module.exports = {
    "buttonLabel": `\u{41F}\u{43E}\u{43A}\u{430}\u{437}\u{430}\u{442}\u{44C} \u{43F}\u{440}\u{435}\u{434}\u{43B}\u{43E}\u{436}\u{435}\u{43D}\u{438}\u{44F}`,
    "countAnnouncement": (args, formatter)=>`${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} \u{43F}\u{430}\u{440}\u{430}\u{43C}\u{435}\u{442}\u{440}`,
            other: ()=>`${formatter.number(args.optionCount)} \u{43F}\u{430}\u{440}\u{430}\u{43C}\u{435}\u{442}\u{440}\u{43E}\u{432}`
        })} \u{434}\u{43E}\u{441}\u{442}\u{443}\u{43F}\u{43D}\u{43E}.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`\u{412}\u{432}\u{435}\u{434}\u{435}\u{43D}\u{43D}\u{430}\u{44F} \u{433}\u{440}\u{443}\u{43F}\u{43F}\u{430} ${args.groupTitle}, \u{441} ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} \u{43F}\u{430}\u{440}\u{430}\u{43C}\u{435}\u{442}\u{440}\u{43E}\u{43C}`,
                    other: ()=>`${formatter.number(args.groupCount)} \u{43F}\u{430}\u{440}\u{430}\u{43C}\u{435}\u{442}\u{440}\u{430}\u{43C}\u{438}`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, \u{432}\u{44B}\u{431}\u{440}\u{430}\u{43D}\u{43D}\u{44B}\u{43C}\u{438}`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `\u{41F}\u{440}\u{435}\u{434}\u{43B}\u{43E}\u{436}\u{435}\u{43D}\u{438}\u{44F}`,
    "selectedAnnouncement": (args)=>`${args.optionText}, \u{432}\u{44B}\u{431}\u{440}\u{430}\u{43D}\u{43E}`
};

},{}],"igxLU":[function(require,module,exports) {
module.exports = {
    "buttonLabel": `Zobrazi\u{165} n\xe1vrhy`,
    "countAnnouncement": (args, formatter)=>`${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} mo\u{17E}nos\u{165}`,
            other: ()=>`${formatter.number(args.optionCount)} mo\u{17E}nosti/-\xed`
        })} k dispoz\xedcii.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`Zadan\xe1 skupina ${args.groupTitle}, s ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} mo\u{17E}nos\u{165}ou`,
                    other: ()=>`${formatter.number(args.groupCount)} mo\u{17E}nos\u{165}ami`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, vybrat\xe9`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `N\xe1vrhy`,
    "selectedAnnouncement": (args)=>`${args.optionText}, vybrat\xe9`
};

},{}],"1XVHU":[function(require,module,exports) {
module.exports = {
    "buttonLabel": `Prika\u{17E}i predloge`,
    "countAnnouncement": (args, formatter)=>`Na voljo je ${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} opcija`,
            other: ()=>`${formatter.number(args.optionCount)} opcije`
        })}.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`Vnesena skupina ${args.groupTitle}, z ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} opcija`,
                    other: ()=>`${formatter.number(args.groupCount)} opcije`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, izbrano`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `Predlogi`,
    "selectedAnnouncement": (args)=>`${args.optionText}, izbrano`
};

},{}],"dYOWW":[function(require,module,exports) {
module.exports = {
    "buttonLabel": `Prika\u{17E}i predloge`,
    "countAnnouncement": (args, formatter)=>`Dostupno jo\u{161}: ${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} opcija`,
            other: ()=>`${formatter.number(args.optionCount)} opcije/a`
        })}.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`Unesena grupa ${args.groupTitle}, s ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} opcijom`,
                    other: ()=>`${formatter.number(args.groupCount)} optione/a`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, izabranih`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `Predlozi`,
    "selectedAnnouncement": (args)=>`${args.optionText}, izabrano`
};

},{}],"HqLOY":[function(require,module,exports) {
module.exports = {
    "buttonLabel": `Visa f\xf6rslag`,
    "countAnnouncement": (args, formatter)=>`${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} alternativ`,
            other: ()=>`${formatter.number(args.optionCount)} alternativ`
        })} tillg\xe4ngliga.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`Ingick i gruppen ${args.groupTitle} med ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} alternativ`,
                    other: ()=>`${formatter.number(args.groupCount)} alternativ`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, valda`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `F\xf6rslag`,
    "selectedAnnouncement": (args)=>`${args.optionText}, valda`
};

},{}],"4xMOg":[function(require,module,exports) {
module.exports = {
    "buttonLabel": `\xd6nerileri g\xf6ster`,
    "countAnnouncement": (args, formatter)=>`${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} se\xe7enek`,
            other: ()=>`${formatter.number(args.optionCount)} se\xe7enekler`
        })} kullan\u{131}labilir.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`Girilen grup ${args.groupTitle}, ile ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} se\xe7enek`,
                    other: ()=>`${formatter.number(args.groupCount)} se\xe7enekler`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, se\xe7ildi`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `\xd6neriler`,
    "selectedAnnouncement": (args)=>`${args.optionText}, se\xe7ildi`
};

},{}],"23JO8":[function(require,module,exports) {
module.exports = {
    "buttonLabel": `\u{41F}\u{43E}\u{43A}\u{430}\u{437}\u{430}\u{442}\u{438} \u{43F}\u{440}\u{43E}\u{43F}\u{43E}\u{437}\u{438}\u{446}\u{456}\u{457}`,
    "countAnnouncement": (args, formatter)=>`${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} \u{43F}\u{430}\u{440}\u{430}\u{43C}\u{435}\u{442}\u{440}`,
            other: ()=>`${formatter.number(args.optionCount)} \u{43F}\u{430}\u{440}\u{430}\u{43C}\u{435}\u{442}\u{440}\u{438}(-\u{456}\u{432})`
        })} \u{434}\u{43E}\u{441}\u{442}\u{443}\u{43F}\u{43D}\u{43E}.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`\u{412}\u{432}\u{435}\u{434}\u{435}\u{43D}\u{430} \u{433}\u{440}\u{443}\u{43F}\u{430} ${args.groupTitle}, \u{437} ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} \u{43F}\u{430}\u{440}\u{430}\u{43C}\u{435}\u{442}\u{440}`,
                    other: ()=>`${formatter.number(args.groupCount)} \u{43F}\u{430}\u{440}\u{430}\u{43C}\u{435}\u{442}\u{440}\u{438}(-\u{456}\u{432})`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, \u{432}\u{438}\u{431}\u{440}\u{430}\u{43D}\u{43E}`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `\u{41F}\u{440}\u{43E}\u{43F}\u{43E}\u{437}\u{438}\u{446}\u{456}\u{457}`,
    "selectedAnnouncement": (args)=>`${args.optionText}, \u{432}\u{438}\u{431}\u{440}\u{430}\u{43D}\u{43E}`
};

},{}],"kfJtH":[function(require,module,exports) {
module.exports = {
    "buttonLabel": `\u{663E}\u{793A}\u{5EFA}\u{8BAE}`,
    "countAnnouncement": (args, formatter)=>`\u{6709} ${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} \u{4E2A}\u{9009}\u{9879}`,
            other: ()=>`${formatter.number(args.optionCount)} \u{4E2A}\u{9009}\u{9879}`
        })}\u{53EF}\u{7528}\u{3002}`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`\u{8FDB}\u{5165}\u{4E86} ${args.groupTitle} \u{7EC4}\u{FF0C}\u{5176}\u{4E2D}\u{6709} ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} \u{4E2A}\u{9009}\u{9879}`,
                    other: ()=>`${formatter.number(args.groupCount)} \u{4E2A}\u{9009}\u{9879}`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, \u{5DF2}\u{9009}\u{62E9}`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `\u{5EFA}\u{8BAE}`,
    "selectedAnnouncement": (args)=>`${args.optionText}, \u{5DF2}\u{9009}\u{62E9}`
};

},{}],"5ZRVz":[function(require,module,exports) {
module.exports = {
    "buttonLabel": `\u{986F}\u{793A}\u{5EFA}\u{8B70}`,
    "countAnnouncement": (args, formatter)=>`${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} \u{9078}\u{9805}`,
            other: ()=>`${formatter.number(args.optionCount)} \u{9078}\u{9805}`
        })} \u{53EF}\u{7528}\u{3002}`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`\u{8F38}\u{5165}\u{7684}\u{7FA4}\u{7D44} ${args.groupTitle}, \u{6709} ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} \u{9078}\u{9805}`,
                    other: ()=>`${formatter.number(args.groupCount)} \u{9078}\u{9805}`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, \u{5DF2}\u{9078}\u{53D6}`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `\u{5EFA}\u{8B70}`,
    "selectedAnnouncement": (args)=>`${args.optionText}, \u{5DF2}\u{9078}\u{53D6}`
};

},{}],"89bvn":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useMenuTrigger", ()=>(0, _useMenuTrigger.useMenuTrigger));
parcelHelpers.export(exports, "useMenu", ()=>(0, _useMenu.useMenu));
parcelHelpers.export(exports, "useMenuItem", ()=>(0, _useMenuItem.useMenuItem));
parcelHelpers.export(exports, "useMenuSection", ()=>(0, _useMenuSection.useMenuSection));
parcelHelpers.export(exports, "UNSTABLE_useSubmenuTrigger", ()=>(0, _useSubmenuTrigger.UNSTABLE_useSubmenuTrigger));
var _useMenuTrigger = require("./useMenuTrigger");
var _useMenu = require("./useMenu");
var _useMenuItem = require("./useMenuItem");
var _useMenuSection = require("./useMenuSection");
var _useSubmenuTrigger = require("./useSubmenuTrigger");

},{"./useMenuTrigger":"3qdSL","./useMenu":"blMS5","./useMenuItem":"fvlnj","./useMenuSection":"4IzGK","./useSubmenuTrigger":"fZM4N","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"3qdSL":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides the behavior and accessibility implementation for a menu trigger.
 * @param props - Props for the menu trigger.
 * @param state - State for the menu trigger.
 * @param ref - Ref to the HTML element trigger for the menu.
 */ parcelHelpers.export(exports, "useMenuTrigger", ()=>useMenuTrigger);
// @ts-ignore
var _json = require("../intl/*.json");
var _jsonDefault = parcelHelpers.interopDefault(_json);
var _utils = require("@react-aria/utils");
var _i18N = require("@react-aria/i18n");
var _interactions = require("@react-aria/interactions");
var _overlays = require("@react-aria/overlays");
function useMenuTrigger(props, state, ref) {
    let { type = "menu", isDisabled, trigger = "press" } = props;
    let menuTriggerId = (0, _utils.useId)();
    let { triggerProps, overlayProps } = (0, _overlays.useOverlayTrigger)({
        type
    }, state, ref);
    let onKeyDown = (e)=>{
        if (isDisabled) return;
        if (trigger === "longPress" && !e.altKey) return;
        if (ref && ref.current) switch(e.key){
            case "Enter":
            case " ":
                if (trigger === "longPress") return;
            // fallthrough
            case "ArrowDown":
                // Stop propagation, unless it would already be handled by useKeyboard.
                if (!("continuePropagation" in e)) e.stopPropagation();
                e.preventDefault();
                state.toggle("first");
                break;
            case "ArrowUp":
                if (!("continuePropagation" in e)) e.stopPropagation();
                e.preventDefault();
                state.toggle("last");
                break;
            default:
                // Allow other keys.
                if ("continuePropagation" in e) e.continuePropagation();
        }
    };
    let stringFormatter = (0, _i18N.useLocalizedStringFormatter)((0, _jsonDefault.default), "@react-aria/menu");
    let { longPressProps } = (0, _interactions.useLongPress)({
        isDisabled: isDisabled || trigger !== "longPress",
        accessibilityDescription: stringFormatter.format("longPressMessage"),
        onLongPressStart () {
            state.close();
        },
        onLongPress () {
            state.open("first");
        }
    });
    let pressProps = {
        onPressStart (e) {
            // For consistency with native, open the menu on mouse/key down, but touch up.
            if (e.pointerType !== "touch" && e.pointerType !== "keyboard" && !isDisabled) // If opened with a screen reader, auto focus the first item.
            // Otherwise, the menu itself will be focused.
            state.toggle(e.pointerType === "virtual" ? "first" : null);
        },
        onPress (e) {
            if (e.pointerType === "touch" && !isDisabled) state.toggle();
        }
    };
    // omit onPress from triggerProps since we override it above.
    delete triggerProps.onPress;
    return {
        menuTriggerProps: {
            ...triggerProps,
            ...trigger === "press" ? pressProps : longPressProps,
            id: menuTriggerId,
            onKeyDown
        },
        menuProps: {
            ...overlayProps,
            "aria-labelledby": menuTriggerId,
            autoFocus: state.focusStrategy || true,
            onClose: state.close
        }
    };
}

},{"../intl/*.json":"hclzX","@react-aria/utils":"9cLk5","@react-aria/i18n":"411rg","@react-aria/interactions":"ky3G8","@react-aria/overlays":"5fTCg","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"hclzX":[function(require,module,exports) {
const _temp0 = require("42c83f4548c92833");
const _temp1 = require("6b870756cb68e01e");
const _temp2 = require("a6bddf07cafa43fa");
const _temp3 = require("63a9c652887e3def");
const _temp4 = require("c44985ef38014ee9");
const _temp5 = require("7f605cbffccbd280");
const _temp6 = require("aac274ca22e0368f");
const _temp7 = require("64b41430f7aa6fad");
const _temp8 = require("47f2d88389b064e7");
const _temp9 = require("c6bcc0103498d005");
const _temp10 = require("c47e6d1660527a22");
const _temp11 = require("4164c1159cac0216");
const _temp12 = require("267dc1f5391aaf39");
const _temp13 = require("23e08e97753d7729");
const _temp14 = require("3ae350fe688669df");
const _temp15 = require("766e0fb8965f9cbb");
const _temp16 = require("742256cccce31590");
const _temp17 = require("3d080a7d4b4f4d5c");
const _temp18 = require("d217789518c339d2");
const _temp19 = require("d1bd4e6fdc35a212");
const _temp20 = require("a3c28924612b9303");
const _temp21 = require("6356dbde79c6ea15");
const _temp22 = require("4ec9b1f4e5859552");
const _temp23 = require("e4370f69d1fa2f64");
const _temp24 = require("de4db1a075661abe");
const _temp25 = require("f9574d2d6afa982b");
const _temp26 = require("fbb72d44e94f7abf");
const _temp27 = require("19d0f5a1ce8e4d50");
const _temp28 = require("fdef00026f3249af");
const _temp29 = require("a6ab80a93020e353");
const _temp30 = require("1d6811b2b369005b");
const _temp31 = require("55b10140b14e7779");
const _temp32 = require("483a562258163ecc");
const _temp33 = require("4a3f5bf5ab41e724");
module.exports = {
    "ar-AE": _temp0,
    "bg-BG": _temp1,
    "cs-CZ": _temp2,
    "da-DK": _temp3,
    "de-DE": _temp4,
    "el-GR": _temp5,
    "en-US": _temp6,
    "es-ES": _temp7,
    "et-EE": _temp8,
    "fi-FI": _temp9,
    "fr-FR": _temp10,
    "he-IL": _temp11,
    "hr-HR": _temp12,
    "hu-HU": _temp13,
    "it-IT": _temp14,
    "ja-JP": _temp15,
    "ko-KR": _temp16,
    "lt-LT": _temp17,
    "lv-LV": _temp18,
    "nb-NO": _temp19,
    "nl-NL": _temp20,
    "pl-PL": _temp21,
    "pt-BR": _temp22,
    "pt-PT": _temp23,
    "ro-RO": _temp24,
    "ru-RU": _temp25,
    "sk-SK": _temp26,
    "sl-SI": _temp27,
    "sr-SP": _temp28,
    "sv-SE": _temp29,
    "tr-TR": _temp30,
    "uk-UA": _temp31,
    "zh-CN": _temp32,
    "zh-TW": _temp33
};

},{"42c83f4548c92833":"dkdbU","6b870756cb68e01e":"apaqQ","a6bddf07cafa43fa":"i7jya","63a9c652887e3def":"jzZge","c44985ef38014ee9":"e0dyE","7f605cbffccbd280":"jNJDl","aac274ca22e0368f":"7DfSG","64b41430f7aa6fad":"dl7go","47f2d88389b064e7":"k0njI","c6bcc0103498d005":"f7Jwx","c47e6d1660527a22":"eQ9YT","4164c1159cac0216":"5YNij","267dc1f5391aaf39":"3fPRl","23e08e97753d7729":"gnIrj","3ae350fe688669df":"lF2sP","766e0fb8965f9cbb":"9FnmT","742256cccce31590":"gxMxP","3d080a7d4b4f4d5c":"fFynb","d217789518c339d2":"efzaN","d1bd4e6fdc35a212":"cudcV","a3c28924612b9303":"hbkYf","6356dbde79c6ea15":"eYnOq","4ec9b1f4e5859552":"kbaYp","e4370f69d1fa2f64":"axhrd","de4db1a075661abe":"hjGTK","f9574d2d6afa982b":"jIfch","fbb72d44e94f7abf":"f1qTx","19d0f5a1ce8e4d50":"k5EzQ","fdef00026f3249af":"28xyV","a6ab80a93020e353":"iApxq","1d6811b2b369005b":"eayhB","55b10140b14e7779":"3HgnW","483a562258163ecc":"dng5s","4a3f5bf5ab41e724":"4ADgQ"}],"dkdbU":[function(require,module,exports) {
module.exports = {
    "longPressMessage": `\u{627}\u{636}\u{63A}\u{637} \u{645}\u{637}\u{648}\u{644}\u{627}\u{64B} \u{623}\u{648} \u{627}\u{636}\u{63A}\u{637} \u{639}\u{644}\u{649} Alt + \u{627}\u{644}\u{633}\u{647}\u{645} \u{644}\u{623}\u{633}\u{641}\u{644} \u{644}\u{641}\u{62A}\u{62D} \u{627}\u{644}\u{642}\u{627}\u{626}\u{645}\u{629}`
};

},{}],"apaqQ":[function(require,module,exports) {
module.exports = {
    "longPressMessage": `\u{41D}\u{430}\u{442}\u{438}\u{441}\u{43D}\u{435}\u{442}\u{435} \u{43F}\u{440}\u{43E}\u{434}\u{44A}\u{43B}\u{436}\u{438}\u{442}\u{435}\u{43B}\u{43D}\u{43E} \u{438}\u{43B}\u{438} \u{43D}\u{430}\u{442}\u{438}\u{441}\u{43D}\u{435}\u{442}\u{435} Alt+ \u{441}\u{442}\u{440}\u{435}\u{43B}\u{43A}\u{430} \u{43D}\u{430}\u{434}\u{43E}\u{43B}\u{443}, \u{437}\u{430} \u{434}\u{430} \u{43E}\u{442}\u{432}\u{43E}\u{440}\u{438}\u{442}\u{435} \u{43C}\u{435}\u{43D}\u{44E}\u{442}\u{43E}`
};

},{}],"i7jya":[function(require,module,exports) {
module.exports = {
    "longPressMessage": `Dlouh\xfdm stiskem nebo stisknut\xedm kl\xe1ves Alt + \u{161}ipka dol\u{16F} otev\u{159}ete nab\xeddku`
};

},{}],"jzZge":[function(require,module,exports) {
module.exports = {
    "longPressMessage": `Langt tryk eller tryk p\xe5 Alt + pil ned for at \xe5bne menuen`
};

},{}],"e0dyE":[function(require,module,exports) {
module.exports = {
    "longPressMessage": `Dr\xfccken Sie lange oder dr\xfccken Sie Alt + Nach-unten, um das Men\xfc zu \xf6ffnen`
};

},{}],"jNJDl":[function(require,module,exports) {
module.exports = {
    "longPressMessage": `\u{3A0}\u{3B9}\u{3AD}\u{3C3}\u{3C4}\u{3B5} \u{3C0}\u{3B1}\u{3C1}\u{3B1}\u{3C4}\u{3B5}\u{3C4}\u{3B1}\u{3BC}\u{3AD}\u{3BD}\u{3B1} \u{3AE} \u{3C0}\u{3B1}\u{3C4}\u{3AE}\u{3C3}\u{3C4}\u{3B5} Alt + \u{3BA}\u{3AC}\u{3C4}\u{3C9} \u{3B2}\u{3AD}\u{3BB}\u{3BF}\u{3C2} \u{3B3}\u{3B9}\u{3B1} \u{3BD}\u{3B1} \u{3B1}\u{3BD}\u{3BF}\u{3AF}\u{3BE}\u{3B5}\u{3C4}\u{3B5} \u{3C4}\u{3BF} \u{3BC}\u{3B5}\u{3BD}\u{3BF}\u{3CD}`
};

},{}],"7DfSG":[function(require,module,exports) {
module.exports = {
    "longPressMessage": `Long press or press Alt + ArrowDown to open menu`
};

},{}],"dl7go":[function(require,module,exports) {
module.exports = {
    "longPressMessage": `Mantenga pulsado o pulse Alt + flecha abajo para abrir el men\xfa`
};

},{}],"k0njI":[function(require,module,exports) {
module.exports = {
    "longPressMessage": `Men\xfc\xfc avamiseks vajutage pikalt v\xf5i vajutage klahve Alt + allanool`
};

},{}],"f7Jwx":[function(require,module,exports) {
module.exports = {
    "longPressMessage": `Avaa valikko painamalla pohjassa tai n\xe4pp\xe4inyhdistelm\xe4ll\xe4 Alt + Alanuoli`
};

},{}],"eQ9YT":[function(require,module,exports) {
module.exports = {
    "longPressMessage": `Appuyez de mani\xe8re prolong\xe9e ou appuyez sur Alt\xa0+\xa0Fl\xe8che vers le bas pour ouvrir le menu.`
};

},{}],"5YNij":[function(require,module,exports) {
module.exports = {
    "longPressMessage": `\u{5DC}\u{5D7}\u{5E5} \u{5DC}\u{5D7}\u{5D9}\u{5E6}\u{5D4} \u{5D0}\u{5E8}\u{5D5}\u{5DB}\u{5D4} \u{5D0}\u{5D5} \u{5D4}\u{5E7}\u{5E9} Alt + ArrowDown \u{5DB}\u{5D3}\u{5D9} \u{5DC}\u{5E4}\u{5EA}\u{5D5}\u{5D7} \u{5D0}\u{5EA} \u{5D4}\u{5EA}\u{5E4}\u{5E8}\u{5D9}\u{5D8}`
};

},{}],"3fPRl":[function(require,module,exports) {
module.exports = {
    "longPressMessage": `Dugo pritisnite ili pritisnite Alt + strelicu prema dolje za otvaranje izbornika`
};

},{}],"gnIrj":[function(require,module,exports) {
module.exports = {
    "longPressMessage": `Nyomja meg hosszan, vagy nyomja meg az Alt + lefele ny\xedl gombot a men\xfc megnyit\xe1s\xe1hoz`
};

},{}],"lF2sP":[function(require,module,exports) {
module.exports = {
    "longPressMessage": `Premere a lungo o premere Alt + Freccia gi\xf9 per aprire il menu`
};

},{}],"9FnmT":[function(require,module,exports) {
module.exports = {
    "longPressMessage": `\u{9577}\u{62BC}\u{3057}\u{307E}\u{305F}\u{306F} Alt+\u{4E0B}\u{77E2}\u{5370}\u{30AD}\u{30FC}\u{3067}\u{30E1}\u{30CB}\u{30E5}\u{30FC}\u{3092}\u{958B}\u{304F}`
};

},{}],"gxMxP":[function(require,module,exports) {
module.exports = {
    "longPressMessage": `\u{AE38}\u{AC8C} \u{B204}\u{B974}\u{AC70}\u{B098} Alt + \u{C544}\u{B798}\u{CABD} \u{D654}\u{C0B4}\u{D45C}\u{B97C} \u{B20C}\u{B7EC} \u{BA54}\u{B274} \u{C5F4}\u{AE30}`
};

},{}],"fFynb":[function(require,module,exports) {
module.exports = {
    "longPressMessage": `Nor\u{117}dami atidaryti meniu, nuspaud\u{119} palaikykite arba paspauskite \u{201E}Alt + ArrowDown\u{201C}.`
};

},{}],"efzaN":[function(require,module,exports) {
module.exports = {
    "longPressMessage": `Lai atv\u{113}rtu izv\u{113}lni, turiet nospiestu vai nospiediet tausti\u{146}u kombin\u{101}ciju Alt + lejupv\u{113}rst\u{101} bulti\u{146}a`
};

},{}],"cudcV":[function(require,module,exports) {
module.exports = {
    "longPressMessage": `Langt trykk eller trykk Alt + PilNed for \xe5 \xe5pne menyen`
};

},{}],"hbkYf":[function(require,module,exports) {
module.exports = {
    "longPressMessage": `Druk lang op Alt + pijl-omlaag of druk op Alt om het menu te openen`
};

},{}],"eYnOq":[function(require,module,exports) {
module.exports = {
    "longPressMessage": `Naci\u{15B}nij i przytrzymaj lub naci\u{15B}nij klawisze Alt + Strza\u{142}ka w d\xf3\u{142}, aby otworzy\u{107} menu`
};

},{}],"kbaYp":[function(require,module,exports) {
module.exports = {
    "longPressMessage": `Pressione e segure ou pressione Alt + Seta para baixo para abrir o menu`
};

},{}],"axhrd":[function(require,module,exports) {
module.exports = {
    "longPressMessage": `Prima continuamente ou prima Alt + Seta Para Baixo para abrir o menu`
};

},{}],"hjGTK":[function(require,module,exports) {
module.exports = {
    "longPressMessage": `Ap\u{103}sa\u{21B}i lung sau ap\u{103}sa\u{21B}i pe Alt + s\u{103}geat\u{103} \xeen jos pentru a deschide meniul`
};

},{}],"jIfch":[function(require,module,exports) {
module.exports = {
    "longPressMessage": `\u{41D}\u{430}\u{436}\u{43C}\u{438}\u{442}\u{435} \u{438} \u{443}\u{434}\u{435}\u{440}\u{436}\u{438}\u{432}\u{430}\u{439}\u{442}\u{435} \u{438}\u{43B}\u{438} \u{43D}\u{430}\u{436}\u{43C}\u{438}\u{442}\u{435} Alt + \u{421}\u{442}\u{440}\u{435}\u{43B}\u{43A}\u{430} \u{432}\u{43D}\u{438}\u{437}, \u{447}\u{442}\u{43E}\u{431}\u{44B} \u{43E}\u{442}\u{43A}\u{440}\u{44B}\u{442}\u{44C} \u{43C}\u{435}\u{43D}\u{44E}`
};

},{}],"f1qTx":[function(require,module,exports) {
module.exports = {
    "longPressMessage": `Ponuku otvor\xedte dlh\xfdm stla\u{10D}en\xedm alebo stla\u{10D}en\xedm kl\xe1vesu Alt + kl\xe1vesu so \u{161}\xedpkou nadol`
};

},{}],"k5EzQ":[function(require,module,exports) {
module.exports = {
    "longPressMessage": `Za odprtje menija pritisnite in dr\u{17E}ite gumb ali pritisnite Alt+pu\u{161}\u{10D}ica navzdol`
};

},{}],"28xyV":[function(require,module,exports) {
module.exports = {
    "longPressMessage": `Dugo pritisnite ili pritisnite Alt + strelicu prema dole da otvorite meni`
};

},{}],"iApxq":[function(require,module,exports) {
module.exports = {
    "longPressMessage": `H\xe5ll nedtryckt eller tryck p\xe5 Alt + pil ned\xe5t f\xf6r att \xf6ppna menyn`
};

},{}],"eayhB":[function(require,module,exports) {
module.exports = {
    "longPressMessage": `Men\xfcy\xfc a\xe7mak i\xe7in uzun bas\u{131}n veya Alt + A\u{15F}a\u{11F}\u{131} Ok tu\u{15F}una bas\u{131}n`
};

},{}],"3HgnW":[function(require,module,exports) {
module.exports = {
    "longPressMessage": `\u{414}\u{43E}\u{432}\u{433}\u{43E} \u{430}\u{431}\u{43E} \u{437}\u{432}\u{438}\u{447}\u{430}\u{439}\u{43D}\u{43E} \u{43D}\u{430}\u{442}\u{438}\u{441}\u{43D}\u{456}\u{442}\u{44C} \u{43A}\u{43E}\u{43C}\u{431}\u{456}\u{43D}\u{430}\u{446}\u{456}\u{44E} \u{43A}\u{43B}\u{430}\u{432}\u{456}\u{448} Alt \u{456} \u{441}\u{442}\u{440}\u{456}\u{43B}\u{43A}\u{430} \u{432}\u{43D}\u{438}\u{437}, \u{449}\u{43E}\u{431} \u{432}\u{456}\u{434}\u{43A}\u{440}\u{438}\u{442}\u{438} \u{43C}\u{435}\u{43D}\u{44E}`
};

},{}],"dng5s":[function(require,module,exports) {
module.exports = {
    "longPressMessage": `\u{957F}\u{6309}\u{6216}\u{6309} Alt + \u{5411}\u{4E0B}\u{65B9}\u{5411}\u{952E}\u{4EE5}\u{6253}\u{5F00}\u{83DC}\u{5355}`
};

},{}],"4ADgQ":[function(require,module,exports) {
module.exports = {
    "longPressMessage": `\u{9577}\u{6309}\u{6216}\u{6309} Alt+\u{5411}\u{4E0B}\u{9375}\u{4EE5}\u{958B}\u{555F}\u{529F}\u{80FD}\u{8868}`
};

},{}],"blMS5":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "menuData", ()=>menuData);
/**
 * Provides the behavior and accessibility implementation for a menu component.
 * A menu displays a list of actions or options that a user can choose.
 * @param props - Props for the menu.
 * @param state - State for the menu, as returned by `useListState`.
 */ parcelHelpers.export(exports, "useMenu", ()=>useMenu);
var _utils = require("@react-aria/utils");
var _selection = require("@react-aria/selection");
const menuData = new WeakMap();
function useMenu(props, state, ref) {
    let { shouldFocusWrap = true, onKeyDown, onKeyUp, ...otherProps } = props;
    if (!props["aria-label"] && !props["aria-labelledby"]) console.warn("An aria-label or aria-labelledby prop is required for accessibility.");
    let domProps = (0, _utils.filterDOMProps)(props, {
        labelable: true
    });
    let { listProps } = (0, _selection.useSelectableList)({
        ...otherProps,
        ref,
        selectionManager: state.selectionManager,
        collection: state.collection,
        disabledKeys: state.disabledKeys,
        shouldFocusWrap,
        linkBehavior: "override"
    });
    menuData.set(state, {
        onClose: props.onClose,
        onAction: props.onAction
    });
    return {
        menuProps: (0, _utils.mergeProps)(domProps, {
            onKeyDown,
            onKeyUp
        }, {
            role: "menu",
            ...listProps,
            onKeyDown: (e)=>{
                // don't clear the menu selected keys if the user is presses escape since escape closes the menu
                if (e.key !== "Escape") listProps.onKeyDown(e);
            }
        })
    };
}

},{"@react-aria/utils":"9cLk5","@react-aria/selection":"6Fly5","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"fvlnj":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides the behavior and accessibility implementation for an item in a menu.
 * See `useMenu` for more details about menus.
 * @param props - Props for the item.
 * @param state - State for the menu, as returned by `useTreeState`.
 */ parcelHelpers.export(exports, "useMenuItem", ()=>useMenuItem);
var _utils = require("@react-aria/utils");
var _collections = require("@react-stately/collections");
var _interactions = require("@react-aria/interactions");
var _useMenu = require("./useMenu");
var _selection = require("@react-aria/selection");
function useMenuItem(props, state, ref) {
    var _item_props;
    let { key, closeOnSelect, isVirtualized, "aria-haspopup": hasPopup, onPressStart: pressStartProp, onPressUp: pressUpProp, onPress, onPressChange, onPressEnd, onHoverStart: hoverStartProp, onHoverChange, onHoverEnd, onKeyDown, onKeyUp, onFocus, onFocusChange, onBlur } = props;
    let isTrigger = !!hasPopup;
    var _props_isDisabled;
    let isDisabled = (_props_isDisabled = props.isDisabled) !== null && _props_isDisabled !== void 0 ? _props_isDisabled : state.disabledKeys.has(key);
    var _props_isSelected;
    let isSelected = (_props_isSelected = props.isSelected) !== null && _props_isSelected !== void 0 ? _props_isSelected : state.selectionManager.isSelected(key);
    let data = (0, _useMenu.menuData).get(state);
    let onClose = props.onClose || data.onClose;
    let onAction = isTrigger ? ()=>{} : props.onAction || data.onAction;
    let router = (0, _utils.useRouter)();
    let performAction = (e)=>{
        if (onAction) onAction(key);
        if (e.target instanceof HTMLAnchorElement) router.open(e.target, e);
    };
    let role = "menuitem";
    if (!isTrigger) {
        if (state.selectionManager.selectionMode === "single") role = "menuitemradio";
        else if (state.selectionManager.selectionMode === "multiple") role = "menuitemcheckbox";
    }
    let labelId = (0, _utils.useSlotId)();
    let descriptionId = (0, _utils.useSlotId)();
    let keyboardId = (0, _utils.useSlotId)();
    let ariaProps = {
        "aria-disabled": isDisabled || undefined,
        role,
        "aria-label": props["aria-label"],
        "aria-labelledby": labelId,
        "aria-describedby": [
            descriptionId,
            keyboardId
        ].filter(Boolean).join(" ") || undefined,
        "aria-controls": props["aria-controls"],
        "aria-haspopup": hasPopup,
        "aria-expanded": props["aria-expanded"]
    };
    if (state.selectionManager.selectionMode !== "none" && !isTrigger) ariaProps["aria-checked"] = isSelected;
    let item = state.collection.getItem(key);
    if (isVirtualized) {
        ariaProps["aria-posinset"] = item === null || item === void 0 ? void 0 : item.index;
        ariaProps["aria-setsize"] = (0, _collections.getItemCount)(state.collection);
    }
    let onPressStart = (e)=>{
        if (e.pointerType === "keyboard") performAction(e);
        pressStartProp === null || pressStartProp === void 0 ? void 0 : pressStartProp(e);
    };
    let onPressUp = (e)=>{
        if (e.pointerType !== "keyboard") {
            performAction(e);
            // Pressing a menu item should close by default in single selection mode but not multiple
            // selection mode, except if overridden by the closeOnSelect prop.
            if (!isTrigger && onClose && (closeOnSelect !== null && closeOnSelect !== void 0 ? closeOnSelect : state.selectionManager.selectionMode !== "multiple" || state.selectionManager.isLink(key))) onClose();
        }
        pressUpProp === null || pressUpProp === void 0 ? void 0 : pressUpProp(e);
    };
    let { itemProps, isFocused } = (0, _selection.useSelectableItem)({
        selectionManager: state.selectionManager,
        key,
        ref,
        shouldSelectOnPressUp: true,
        allowsDifferentPressOrigin: true,
        // Disable all handling of links in useSelectable item
        // because we handle it ourselves. The behavior of menus
        // is slightly different from other collections because
        // actions are performed on key down rather than key up.
        linkBehavior: "none"
    });
    let { pressProps, isPressed } = (0, _interactions.usePress)({
        onPressStart,
        onPress,
        onPressUp,
        onPressChange,
        onPressEnd,
        isDisabled
    });
    let { hoverProps } = (0, _interactions.useHover)({
        isDisabled,
        onHoverStart (e) {
            if (!(0, _interactions.isFocusVisible)()) {
                state.selectionManager.setFocused(true);
                state.selectionManager.setFocusedKey(key);
            }
            hoverStartProp === null || hoverStartProp === void 0 ? void 0 : hoverStartProp(e);
        },
        onHoverChange,
        onHoverEnd
    });
    let { keyboardProps } = (0, _interactions.useKeyboard)({
        onKeyDown: (e)=>{
            // Ignore repeating events, which may have started on the menu trigger before moving
            // focus to the menu item. We want to wait for a second complete key press sequence.
            if (e.repeat) {
                e.continuePropagation();
                return;
            }
            switch(e.key){
                case " ":
                    if (!isDisabled && state.selectionManager.selectionMode === "none" && !isTrigger && closeOnSelect !== false && onClose) onClose();
                    break;
                case "Enter":
                    // The Enter key should always close on select, except if overridden.
                    if (!isDisabled && closeOnSelect !== false && !isTrigger && onClose) onClose();
                    break;
                default:
                    if (!isTrigger) e.continuePropagation();
                    onKeyDown === null || onKeyDown === void 0 ? void 0 : onKeyDown(e);
                    break;
            }
        },
        onKeyUp
    });
    let { focusProps } = (0, _interactions.useFocus)({
        onBlur,
        onFocus,
        onFocusChange
    });
    let domProps = (0, _utils.filterDOMProps)(item.props, {
        isLink: !!(item === null || item === void 0 ? void 0 : (_item_props = item.props) === null || _item_props === void 0 ? void 0 : _item_props.href)
    });
    delete domProps.id;
    return {
        menuItemProps: {
            ...ariaProps,
            ...(0, _utils.mergeProps)(domProps, isTrigger ? {
                onFocus: itemProps.onFocus
            } : itemProps, pressProps, hoverProps, keyboardProps, focusProps),
            tabIndex: itemProps.tabIndex != null ? -1 : undefined
        },
        labelProps: {
            id: labelId
        },
        descriptionProps: {
            id: descriptionId
        },
        keyboardShortcutProps: {
            id: keyboardId
        },
        isFocused,
        isSelected,
        isPressed,
        isDisabled
    };
}

},{"@react-aria/utils":"9cLk5","@react-stately/collections":"loANi","@react-aria/interactions":"ky3G8","./useMenu":"blMS5","@react-aria/selection":"6Fly5","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"4IzGK":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides the behavior and accessibility implementation for a section in a menu.
 * See `useMenu` for more details about menus.
 * @param props - Props for the section.
 */ parcelHelpers.export(exports, "useMenuSection", ()=>useMenuSection);
var _utils = require("@react-aria/utils");
function useMenuSection(props) {
    let { heading, "aria-label": ariaLabel } = props;
    let headingId = (0, _utils.useId)();
    return {
        itemProps: {
            role: "presentation"
        },
        headingProps: heading ? {
            // Techincally, menus cannot contain headings according to ARIA.
            // We hide the heading from assistive technology, using role="presentation",
            // and only use it as a label for the nested group.
            id: headingId,
            role: "presentation"
        } : {},
        groupProps: {
            role: "group",
            "aria-label": ariaLabel,
            "aria-labelledby": heading ? headingId : undefined
        }
    };
}

},{"@react-aria/utils":"9cLk5","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"fZM4N":[function(require,module,exports) {
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides the behavior and accessibility implementation for a submenu trigger and its associated submenu.
 * @param props - Props for the submenu trigger and refs attach to its submenu and parent menu.
 * @param state - State for the submenu trigger.
 * @param ref - Ref to the submenu trigger element.
 */ parcelHelpers.export(exports, "UNSTABLE_useSubmenuTrigger", ()=>UNSTABLE_useSubmenuTrigger);
var _react = require("react");
var _utils = require("@react-aria/utils");
var _i18N = require("@react-aria/i18n");
var _useSafelyMouseToSubmenu = require("./useSafelyMouseToSubmenu");
function UNSTABLE_useSubmenuTrigger(props, state, ref) {
    let { parentMenuRef, submenuRef, type = "menu", isDisabled, node, delay = 200 } = props;
    let submenuTriggerId = (0, _utils.useId)();
    let overlayId = (0, _utils.useId)();
    let { direction } = (0, _i18N.useLocale)();
    let openTimeout = (0, _react.useRef)();
    let cancelOpenTimeout = (0, _react.useCallback)(()=>{
        if (openTimeout.current) {
            clearTimeout(openTimeout.current);
            openTimeout.current = undefined;
        }
    }, [
        openTimeout
    ]);
    let onSubmenuOpen = (0, _utils.useEffectEvent)((focusStrategy)=>{
        cancelOpenTimeout();
        state.open(focusStrategy);
    });
    let onSubmenuClose = (0, _utils.useEffectEvent)(()=>{
        cancelOpenTimeout();
        state.close();
    });
    (0, _utils.useLayoutEffect)(()=>{
        return ()=>{
            cancelOpenTimeout();
        };
    }, [
        cancelOpenTimeout
    ]);
    let submenuKeyDown = (e)=>{
        switch(e.key){
            case "ArrowLeft":
                if (direction === "ltr" && e.currentTarget.contains(e.target)) {
                    e.stopPropagation();
                    onSubmenuClose();
                    ref.current.focus();
                }
                break;
            case "ArrowRight":
                if (direction === "rtl" && e.currentTarget.contains(e.target)) {
                    e.stopPropagation();
                    onSubmenuClose();
                    ref.current.focus();
                }
                break;
            case "Escape":
                e.stopPropagation();
                state.closeAll();
                break;
        }
    };
    let submenuProps = {
        id: overlayId,
        "aria-label": node.textValue,
        submenuLevel: state.submenuLevel,
        ...type === "menu" && {
            onClose: state.closeAll,
            autoFocus: state.focusStrategy,
            onKeyDown: submenuKeyDown
        }
    };
    let submenuTriggerKeyDown = (e)=>{
        switch(e.key){
            case "ArrowRight":
                if (!isDisabled) {
                    if (direction === "ltr") {
                        if (!state.isOpen) onSubmenuOpen("first");
                        if (type === "menu" && !!(submenuRef === null || submenuRef === void 0 ? void 0 : submenuRef.current) && document.activeElement === (ref === null || ref === void 0 ? void 0 : ref.current)) submenuRef.current.focus();
                    } else if (state.isOpen) onSubmenuClose();
                    else e.continuePropagation();
                }
                break;
            case "ArrowLeft":
                if (!isDisabled) {
                    if (direction === "rtl") {
                        if (!state.isOpen) onSubmenuOpen("first");
                        if (type === "menu" && !!(submenuRef === null || submenuRef === void 0 ? void 0 : submenuRef.current) && document.activeElement === (ref === null || ref === void 0 ? void 0 : ref.current)) submenuRef.current.focus();
                    } else if (state.isOpen) onSubmenuClose();
                    else e.continuePropagation();
                }
                break;
            case "Escape":
                state.closeAll();
                break;
            default:
                e.continuePropagation();
                break;
        }
    };
    let onPressStart = (e)=>{
        if (!isDisabled && (e.pointerType === "virtual" || e.pointerType === "keyboard")) // If opened with a screen reader or keyboard, auto focus the first submenu item.
        onSubmenuOpen("first");
    };
    let onPress = (e)=>{
        if (!isDisabled && (e.pointerType === "touch" || e.pointerType === "mouse")) // For touch or on a desktop device with a small screen open on press up to possible problems with
        // press up happening on the newly opened tray items
        onSubmenuOpen();
    };
    let onHoverChange = (isHovered)=>{
        if (!isDisabled) {
            if (isHovered && !state.isOpen) {
                if (!openTimeout.current) openTimeout.current = setTimeout(()=>{
                    onSubmenuOpen();
                }, delay);
            } else if (!isHovered) cancelOpenTimeout();
        }
    };
    let onBlur = (e)=>{
        if (state.isOpen && parentMenuRef.current.contains(e.relatedTarget)) onSubmenuClose();
    };
    let shouldCloseOnInteractOutside = (target)=>{
        if (target !== ref.current) return true;
        return false;
    };
    (0, _useSafelyMouseToSubmenu.useSafelyMouseToSubmenu)({
        menuRef: parentMenuRef,
        submenuRef,
        isOpen: state.isOpen,
        isDisabled: isDisabled
    });
    return {
        submenuTriggerProps: {
            id: submenuTriggerId,
            "aria-controls": state.isOpen ? overlayId : undefined,
            "aria-haspopup": !isDisabled ? type : undefined,
            "aria-expanded": state.isOpen ? "true" : "false",
            onPressStart,
            onPress,
            onHoverChange,
            onKeyDown: submenuTriggerKeyDown,
            onBlur,
            isOpen: state.isOpen
        },
        submenuProps,
        popoverProps: {
            isNonModal: true,
            disableFocusManagement: true,
            shouldCloseOnInteractOutside
        }
    };
}

},{"react":"9yzVZ","@react-aria/utils":"9cLk5","@react-aria/i18n":"411rg","./useSafelyMouseToSubmenu":"iwtYi","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"iwtYi":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Allows the user to move their pointer to the submenu without it closing when their mouse leaves the trigger element.
 * Prevents pointer events from going to the underlying menu if the user is moving their pointer towards the sub-menu.
 */ parcelHelpers.export(exports, "useSafelyMouseToSubmenu", ()=>useSafelyMouseToSubmenu);
var _react = require("react");
var _interactions = require("@react-aria/interactions");
var _utils = require("@react-aria/utils");
const ALLOWED_INVALID_MOVEMENTS = 2;
const THROTTLE_TIME = 50;
const TIMEOUT_TIME = 1000;
const ANGLE_PADDING = Math.PI / 12; // 15°
function useSafelyMouseToSubmenu(options) {
    let { menuRef, submenuRef, isOpen, isDisabled } = options;
    let prevPointerPos = (0, _react.useRef)();
    let submenuRect = (0, _react.useRef)();
    let lastProcessedTime = (0, _react.useRef)(0);
    let timeout = (0, _react.useRef)();
    let autoCloseTimeout = (0, _react.useRef)();
    let submenuSide = (0, _react.useRef)();
    let movementsTowardsSubmenuCount = (0, _react.useRef)(2);
    let [preventPointerEvents, setPreventPointerEvents] = (0, _react.useState)(false);
    let updateSubmenuRect = ()=>{
        if (submenuRef.current) {
            submenuRect.current = submenuRef.current.getBoundingClientRect();
            submenuSide.current = undefined;
        }
    };
    (0, _utils.useResizeObserver)({
        ref: submenuRef,
        onResize: updateSubmenuRect
    });
    let reset = ()=>{
        setPreventPointerEvents(false);
        movementsTowardsSubmenuCount.current = ALLOWED_INVALID_MOVEMENTS;
        prevPointerPos.current = undefined;
    };
    let modality = (0, _interactions.useInteractionModality)();
    (0, _react.useEffect)(()=>{
        if (preventPointerEvents && menuRef.current) menuRef.current.style.pointerEvents = "none";
        else menuRef.current.style.pointerEvents = "";
    }, [
        menuRef,
        preventPointerEvents
    ]);
    (0, _react.useEffect)(()=>{
        let submenu = submenuRef.current;
        let menu = menuRef.current;
        if (isDisabled || !submenu || !isOpen || modality !== "pointer") {
            reset();
            return;
        }
        submenuRect.current = submenu.getBoundingClientRect();
        let onPointerMove = (e)=>{
            if (e.pointerType === "touch" || e.pointerType === "pen") return;
            let currentTime = Date.now();
            // Throttle
            if (currentTime - lastProcessedTime.current < THROTTLE_TIME) return;
            clearTimeout(timeout.current);
            clearTimeout(autoCloseTimeout.current);
            let { clientX: mouseX, clientY: mouseY } = e;
            if (!prevPointerPos.current) {
                prevPointerPos.current = {
                    x: mouseX,
                    y: mouseY
                };
                return;
            }
            if (!submenuRect.current) return;
            if (!submenuSide.current) submenuSide.current = mouseX > submenuRect.current.right ? "left" : "right";
            // Pointer is outside of parent menu
            if (mouseX < menu.getBoundingClientRect().left || mouseX > menu.getBoundingClientRect().right || mouseY < menu.getBoundingClientRect().top || mouseY > menu.getBoundingClientRect().bottom) {
                reset();
                return;
            }
            /* Check if pointer is moving towards submenu.
        Uses the 2-argument arctangent (https://en.wikipedia.org/wiki/Atan2) to calculate:
          - angle between previous pointer and top of submenu
          - angle between previous pointer and bottom of submenu
          - angle between previous pointer and current pointer (delta)
        If the pointer delta angle value is between the top and bottom angle values, we know the pointer is moving towards the submenu.
      */ let prevMouseX = prevPointerPos.current.x;
            let prevMouseY = prevPointerPos.current.y;
            let toSubmenuX = submenuSide.current === "right" ? submenuRect.current.left - prevMouseX : prevMouseX - submenuRect.current.right;
            let angleTop = Math.atan2(prevMouseY - submenuRect.current.top, toSubmenuX) + ANGLE_PADDING;
            let angleBottom = Math.atan2(prevMouseY - submenuRect.current.bottom, toSubmenuX) - ANGLE_PADDING;
            let anglePointer = Math.atan2(prevMouseY - mouseY, submenuSide.current === "left" ? -(mouseX - prevMouseX) : mouseX - prevMouseX);
            let isMovingTowardsSubmenu = anglePointer < angleTop && anglePointer > angleBottom;
            movementsTowardsSubmenuCount.current = isMovingTowardsSubmenu ? Math.min(movementsTowardsSubmenuCount.current + 1, ALLOWED_INVALID_MOVEMENTS) : Math.max(movementsTowardsSubmenuCount.current - 1, 0);
            if (movementsTowardsSubmenuCount.current >= ALLOWED_INVALID_MOVEMENTS) setPreventPointerEvents(true);
            else setPreventPointerEvents(false);
            lastProcessedTime.current = currentTime;
            prevPointerPos.current = {
                x: mouseX,
                y: mouseY
            };
            // If the pointer is moving towards the submenu, start a timeout to close if no other movements are made after 500ms.
            if (isMovingTowardsSubmenu) timeout.current = setTimeout(()=>{
                reset();
                autoCloseTimeout.current = setTimeout(()=>{
                    // Fire a pointerover event to trigger the menu to close.
                    // Wait until pointer-events:none is no longer applied
                    let target = document.elementFromPoint(mouseX, mouseY);
                    if (target && menu.contains(target)) target.dispatchEvent(new PointerEvent("pointerover", {
                        bubbles: true,
                        cancelable: true
                    }));
                }, 100);
            }, TIMEOUT_TIME);
        };
        window.addEventListener("pointermove", onPointerMove);
        return ()=>{
            window.removeEventListener("pointermove", onPointerMove);
            clearTimeout(timeout.current);
            clearTimeout(autoCloseTimeout.current);
            movementsTowardsSubmenuCount.current = ALLOWED_INVALID_MOVEMENTS;
        };
    }, [
        isDisabled,
        isOpen,
        menuRef,
        modality,
        setPreventPointerEvents,
        submenuRef
    ]);
}

},{"react":"9yzVZ","@react-aria/interactions":"ky3G8","@react-aria/utils":"9cLk5","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"6dEv6":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useTextField", ()=>(0, _useTextField.useTextField));
parcelHelpers.export(exports, "useFormattedTextField", ()=>(0, _useFormattedTextField.useFormattedTextField));
var _useTextField = require("./useTextField");
var _useFormattedTextField = require("./useFormattedTextField");

},{"./useTextField":"g4tp4","./useFormattedTextField":"ct3c1","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"g4tp4":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides the behavior and accessibility implementation for a text field.
 * @param props - Props for the text field.
 * @param ref - Ref to the HTML input or textarea element.
 */ parcelHelpers.export(exports, "useTextField", ()=>useTextField);
var _react = require("react");
var _utils = require("@react-aria/utils");
var _utils1 = require("@react-stately/utils");
var _label = require("@react-aria/label");
var _focus = require("@react-aria/focus");
var _form = require("@react-aria/form");
var _form1 = require("@react-stately/form");
function useTextField(props, ref) {
    let { inputElementType = "input", isDisabled = false, isRequired = false, isReadOnly = false, type = "text", validationBehavior = "aria" } = props;
    let [value, setValue] = (0, _utils1.useControlledState)(props.value, props.defaultValue || "", props.onChange);
    let { focusableProps } = (0, _focus.useFocusable)(props, ref);
    let validationState = (0, _form1.useFormValidationState)({
        ...props,
        value
    });
    let { isInvalid, validationErrors, validationDetails } = validationState.displayValidation;
    let { labelProps, fieldProps, descriptionProps, errorMessageProps } = (0, _label.useField)({
        ...props,
        isInvalid,
        errorMessage: props.errorMessage || validationErrors
    });
    let domProps = (0, _utils.filterDOMProps)(props, {
        labelable: true
    });
    const inputOnlyProps = {
        type,
        pattern: props.pattern
    };
    (0, _utils.useFormReset)(ref, value, setValue);
    (0, _form.useFormValidation)(props, validationState, ref);
    (0, _react.useEffect)(()=>{
        // This works around a React/Chrome bug that prevents textarea elements from validating when controlled.
        // We prevent React from updating defaultValue (i.e. children) of textarea when `value` changes,
        // which causes Chrome to skip validation. Only updating `value` is ok in our case since our
        // textareas are always controlled. React is planning on removing this synchronization in a
        // future major version.
        // https://github.com/facebook/react/issues/19474
        // https://github.com/facebook/react/issues/11896
        if (ref.current instanceof (0, _utils.getOwnerWindow)(ref.current).HTMLTextAreaElement) {
            let input = ref.current;
            Object.defineProperty(input, "defaultValue", {
                get: ()=>input.value,
                set: ()=>{},
                configurable: true
            });
        }
    }, [
        ref
    ]);
    return {
        labelProps,
        inputProps: (0, _utils.mergeProps)(domProps, inputElementType === "input" && inputOnlyProps, {
            disabled: isDisabled,
            readOnly: isReadOnly,
            required: isRequired && validationBehavior === "native",
            "aria-required": isRequired && validationBehavior === "aria" || undefined,
            "aria-invalid": isInvalid || undefined,
            "aria-errormessage": props["aria-errormessage"],
            "aria-activedescendant": props["aria-activedescendant"],
            "aria-autocomplete": props["aria-autocomplete"],
            "aria-haspopup": props["aria-haspopup"],
            value,
            onChange: (e)=>setValue(e.target.value),
            autoComplete: props.autoComplete,
            autoCapitalize: props.autoCapitalize,
            maxLength: props.maxLength,
            minLength: props.minLength,
            name: props.name,
            placeholder: props.placeholder,
            inputMode: props.inputMode,
            // Clipboard events
            onCopy: props.onCopy,
            onCut: props.onCut,
            onPaste: props.onPaste,
            // Composition events
            onCompositionEnd: props.onCompositionEnd,
            onCompositionStart: props.onCompositionStart,
            onCompositionUpdate: props.onCompositionUpdate,
            // Selection events
            onSelect: props.onSelect,
            // Input events
            onBeforeInput: props.onBeforeInput,
            onInput: props.onInput,
            ...focusableProps,
            ...fieldProps
        }),
        descriptionProps,
        errorMessageProps,
        isInvalid,
        validationErrors,
        validationDetails
    };
}

},{"react":"9yzVZ","@react-aria/utils":"9cLk5","@react-stately/utils":"cpDPf","@react-aria/label":"74Ccz","@react-aria/focus":"42mbF","@react-aria/form":"lerqa","@react-stately/form":"9yZqm","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"ct3c1":[function(require,module,exports) {
/*
 * Copyright 2021 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useFormattedTextField", ()=>useFormattedTextField);
var _utils = require("@react-aria/utils");
var _react = require("react");
var _useTextField = require("./useTextField");
function supportsNativeBeforeInputEvent() {
    return typeof window !== "undefined" && window.InputEvent && // @ts-ignore
    typeof InputEvent.prototype.getTargetRanges === "function";
}
function useFormattedTextField(props, state, inputRef) {
    // All browsers implement the 'beforeinput' event natively except Firefox
    // (currently behind a flag as of Firefox 84). React's polyfill does not
    // run in all cases that the native event fires, e.g. when deleting text.
    // Use the native event if available so that we can prevent invalid deletions.
    // We do not attempt to polyfill this in Firefox since it would be very complicated,
    // the benefit of doing so is fairly minor, and it's going to be natively supported soon.
    let onBeforeInputFallback = (0, _utils.useEffectEvent)((e)=>{
        let input = inputRef.current;
        // Compute the next value of the input if the event is allowed to proceed.
        // See https://www.w3.org/TR/input-events-2/#interface-InputEvent-Attributes for a full list of input types.
        let nextValue;
        switch(e.inputType){
            case "historyUndo":
            case "historyRedo":
                // Explicitly allow undo/redo. e.data is null in this case, but there's no need to validate,
                // because presumably the input would have already been validated previously.
                return;
            case "deleteContent":
            case "deleteByCut":
            case "deleteByDrag":
                nextValue = input.value.slice(0, input.selectionStart) + input.value.slice(input.selectionEnd);
                break;
            case "deleteContentForward":
                // This is potentially incorrect, since the browser may actually delete more than a single UTF-16
                // character. In reality, a full Unicode grapheme cluster consisting of multiple UTF-16 characters
                // or code points may be deleted. However, in our currently supported locales, there are no such cases.
                // If we support additional locales in the future, this may need to change.
                nextValue = input.selectionEnd === input.selectionStart ? input.value.slice(0, input.selectionStart) + input.value.slice(input.selectionEnd + 1) : input.value.slice(0, input.selectionStart) + input.value.slice(input.selectionEnd);
                break;
            case "deleteContentBackward":
                nextValue = input.selectionEnd === input.selectionStart ? input.value.slice(0, input.selectionStart - 1) + input.value.slice(input.selectionStart) : input.value.slice(0, input.selectionStart) + input.value.slice(input.selectionEnd);
                break;
            case "deleteSoftLineBackward":
            case "deleteHardLineBackward":
                nextValue = input.value.slice(input.selectionStart);
                break;
            default:
                if (e.data != null) nextValue = input.value.slice(0, input.selectionStart) + e.data + input.value.slice(input.selectionEnd);
                break;
        }
        // If we did not compute a value, or the new value is invalid, prevent the event
        // so that the browser does not update the input text, move the selection, or add to
        // the undo/redo stack.
        if (nextValue == null || !state.validate(nextValue)) e.preventDefault();
    });
    (0, _react.useEffect)(()=>{
        if (!supportsNativeBeforeInputEvent()) return;
        let input = inputRef.current;
        input.addEventListener("beforeinput", onBeforeInputFallback, false);
        return ()=>{
            input.removeEventListener("beforeinput", onBeforeInputFallback, false);
        };
    }, [
        inputRef,
        onBeforeInputFallback
    ]);
    let onBeforeInput = !supportsNativeBeforeInputEvent() ? (e)=>{
        let nextValue = e.target.value.slice(0, e.target.selectionStart) + e.data + e.target.value.slice(e.target.selectionEnd);
        if (!state.validate(nextValue)) e.preventDefault();
    } : null;
    let { labelProps, inputProps: textFieldProps, descriptionProps, errorMessageProps, ...validation } = (0, _useTextField.useTextField)(props, inputRef);
    let compositionStartState = (0, _react.useRef)(null);
    return {
        inputProps: (0, _utils.mergeProps)(textFieldProps, {
            onBeforeInput,
            onCompositionStart () {
                // Chrome does not implement Input Events Level 2, which specifies the insertFromComposition
                // and deleteByComposition inputType values for the beforeinput event. These are meant to occur
                // at the end of a composition (e.g. Pinyin IME, Android auto correct, etc.), and crucially, are
                // cancelable. The insertCompositionText and deleteCompositionText input types are not cancelable,
                // nor would we want to cancel them because the input from the user is incomplete at that point.
                // In Safari, insertFromComposition/deleteFromComposition will fire, however, allowing us to cancel
                // the final composition result if it is invalid. As a fallback for Chrome and Firefox, which either
                // don't support Input Events Level 2, or beforeinput at all, we store the state of the input when
                // the compositionstart event fires, and undo the changes in compositionend (below) if it is invalid.
                // Unfortunately, this messes up the undo/redo stack, but until insertFromComposition/deleteByComposition
                // are implemented, there is no other way to prevent composed input.
                // See https://bugs.chromium.org/p/chromium/issues/detail?id=1022204
                let { value, selectionStart, selectionEnd } = inputRef.current;
                compositionStartState.current = {
                    value,
                    selectionStart,
                    selectionEnd
                };
            },
            onCompositionEnd () {
                if (!state.validate(inputRef.current.value)) {
                    // Restore the input value in the DOM immediately so we can synchronously update the selection position.
                    // But also update the value in React state as well so it is correct for future updates.
                    let { value, selectionStart, selectionEnd } = compositionStartState.current;
                    inputRef.current.value = value;
                    inputRef.current.setSelectionRange(selectionStart, selectionEnd);
                    state.setInputValue(value);
                }
            }
        }),
        labelProps,
        descriptionProps,
        errorMessageProps,
        ...validation
    };
}

},{"@react-aria/utils":"9cLk5","react":"9yzVZ","./useTextField":"g4tp4","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"5gh3m":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useDatePicker", ()=>(0, _useDatePicker.useDatePicker));
parcelHelpers.export(exports, "useDateSegment", ()=>(0, _useDateSegment.useDateSegment));
parcelHelpers.export(exports, "useDateField", ()=>(0, _useDateField.useDateField));
parcelHelpers.export(exports, "useTimeField", ()=>(0, _useDateField.useTimeField));
parcelHelpers.export(exports, "useDateRangePicker", ()=>(0, _useDateRangePicker.useDateRangePicker));
parcelHelpers.export(exports, "useDisplayNames", ()=>(0, _useDisplayNames.useDisplayNames));
var _useDatePicker = require("./useDatePicker");
var _useDateSegment = require("./useDateSegment");
var _useDateField = require("./useDateField");
var _useDateRangePicker = require("./useDateRangePicker");
var _useDisplayNames = require("./useDisplayNames");

},{"./useDatePicker":"L3ovS","./useDateSegment":"9YG7r","./useDateField":"fp6Rt","./useDateRangePicker":"34COC","./useDisplayNames":"lK4F6","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"L3ovS":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides the behavior and accessibility implementation for a date picker component.
 * A date picker combines a DateField and a Calendar popover to allow users to enter or select a date and time value.
 */ parcelHelpers.export(exports, "useDatePicker", ()=>useDatePicker);
var _focus = require("@react-aria/focus");
var _utils = require("@react-aria/utils");
// @ts-ignore
var _json = require("../intl/*.json");
var _jsonDefault = parcelHelpers.interopDefault(_json);
var _form = require("@react-stately/form");
var _react = require("react");
var _useDateField = require("./useDateField");
var _useDatePickerGroup = require("./useDatePickerGroup");
var _label = require("@react-aria/label");
var _interactions = require("@react-aria/interactions");
var _i18N = require("@react-aria/i18n");
function useDatePicker(props, state, ref) {
    let buttonId = (0, _utils.useId)();
    let dialogId = (0, _utils.useId)();
    let fieldId = (0, _utils.useId)();
    let stringFormatter = (0, _i18N.useLocalizedStringFormatter)((0, _jsonDefault.default), "@react-aria/datepicker");
    let { isInvalid, validationErrors, validationDetails } = state.displayValidation;
    let { labelProps, fieldProps, descriptionProps, errorMessageProps } = (0, _label.useField)({
        ...props,
        labelElementType: "span",
        isInvalid,
        errorMessage: props.errorMessage || validationErrors
    });
    let groupProps = (0, _useDatePickerGroup.useDatePickerGroup)(state, ref);
    let labelledBy = fieldProps["aria-labelledby"] || fieldProps.id;
    let { locale } = (0, _i18N.useLocale)();
    let date = state.formatValue(locale, {
        month: "long"
    });
    let description = date ? stringFormatter.format("selectedDateDescription", {
        date
    }) : "";
    let descProps = (0, _utils.useDescription)(description);
    let ariaDescribedBy = [
        descProps["aria-describedby"],
        fieldProps["aria-describedby"]
    ].filter(Boolean).join(" ") || undefined;
    let domProps = (0, _utils.filterDOMProps)(props);
    let focusManager = (0, _react.useMemo)(()=>(0, _focus.createFocusManager)(ref), [
        ref
    ]);
    let { focusWithinProps } = (0, _interactions.useFocusWithin)({
        ...props,
        isDisabled: state.isOpen,
        onBlurWithin: props.onBlur,
        onFocusWithin: props.onFocus,
        onFocusWithinChange: props.onFocusChange
    });
    return {
        groupProps: (0, _utils.mergeProps)(domProps, groupProps, fieldProps, descProps, focusWithinProps, {
            role: "group",
            "aria-disabled": props.isDisabled || null,
            "aria-labelledby": labelledBy,
            "aria-describedby": ariaDescribedBy,
            onKeyDown (e) {
                if (state.isOpen) return;
                if (props.onKeyDown) props.onKeyDown(e);
            },
            onKeyUp (e) {
                if (state.isOpen) return;
                if (props.onKeyUp) props.onKeyUp(e);
            }
        }),
        labelProps: {
            ...labelProps,
            onClick: ()=>{
                focusManager.focusFirst();
            }
        },
        fieldProps: {
            ...fieldProps,
            id: fieldId,
            [(0, _useDateField.roleSymbol)]: "presentation",
            "aria-describedby": ariaDescribedBy,
            value: state.value,
            onChange: state.setValue,
            placeholderValue: props.placeholderValue,
            hideTimeZone: props.hideTimeZone,
            hourCycle: props.hourCycle,
            shouldForceLeadingZeros: props.shouldForceLeadingZeros,
            granularity: props.granularity,
            isDisabled: props.isDisabled,
            isReadOnly: props.isReadOnly,
            isRequired: props.isRequired,
            validationBehavior: props.validationBehavior,
            // DatePicker owns the validation state for the date field.
            [(0, _form.privateValidationStateProp)]: state,
            autoFocus: props.autoFocus,
            name: props.name
        },
        descriptionProps,
        errorMessageProps,
        buttonProps: {
            ...descProps,
            id: buttonId,
            "aria-haspopup": "dialog",
            "aria-label": stringFormatter.format("calendar"),
            "aria-labelledby": `${buttonId} ${labelledBy}`,
            "aria-describedby": ariaDescribedBy,
            "aria-expanded": state.isOpen,
            isDisabled: props.isDisabled || props.isReadOnly,
            onPress: ()=>state.setOpen(true)
        },
        dialogProps: {
            id: dialogId,
            "aria-labelledby": `${buttonId} ${labelledBy}`
        },
        calendarProps: {
            autoFocus: true,
            value: state.dateValue,
            onChange: state.setDateValue,
            minValue: props.minValue,
            maxValue: props.maxValue,
            isDisabled: props.isDisabled,
            isReadOnly: props.isReadOnly,
            isDateUnavailable: props.isDateUnavailable,
            defaultFocusedValue: state.dateValue ? undefined : props.placeholderValue,
            isInvalid: state.isInvalid,
            errorMessage: typeof props.errorMessage === "function" ? props.errorMessage(state.displayValidation) : props.errorMessage || state.displayValidation.validationErrors.join(" ")
        },
        isInvalid,
        validationErrors,
        validationDetails
    };
}

},{"@react-aria/focus":"42mbF","@react-aria/utils":"9cLk5","../intl/*.json":"dbj9t","@react-stately/form":"9yZqm","react":"9yzVZ","./useDateField":"fp6Rt","./useDatePickerGroup":"bHFNB","@react-aria/label":"74Ccz","@react-aria/interactions":"ky3G8","@react-aria/i18n":"411rg","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"dbj9t":[function(require,module,exports) {
const _temp0 = require("fe2c660e164947ce");
const _temp1 = require("429931c6846b469f");
const _temp2 = require("d83a0ee23577d12e");
const _temp3 = require("492fc55587d24886");
const _temp4 = require("6fe820787f61fc4f");
const _temp5 = require("cb943191f962f634");
const _temp6 = require("df5363622fe50f18");
const _temp7 = require("8d276ae7a7513759");
const _temp8 = require("4f99297d14e3157c");
const _temp9 = require("d3cb4a390aad81f2");
const _temp10 = require("a089aba373e1964b");
const _temp11 = require("4ecd479fa8b4859");
const _temp12 = require("c4987473c1fdee62");
const _temp13 = require("503c8e176106b023");
const _temp14 = require("22711e2a1d6c40e0");
const _temp15 = require("e889d32fa1327227");
const _temp16 = require("4184e21feedbeae5");
const _temp17 = require("8ba6b1655d3fe1ee");
const _temp18 = require("282f401f46721457");
const _temp19 = require("107fae74b923cba7");
const _temp20 = require("af3cefead05127dc");
const _temp21 = require("522cd8de993957f6");
const _temp22 = require("e5c447edb1dcf6a");
const _temp23 = require("f5a92a7855f6f44");
const _temp24 = require("b668e2c7675206f");
const _temp25 = require("91524f82d3e6a37e");
const _temp26 = require("1848d90a5fa05535");
const _temp27 = require("6cdb8d754f478ff8");
const _temp28 = require("74c3cf82bcdd2d30");
const _temp29 = require("e9704ec2c55e2631");
const _temp30 = require("592033111f41600d");
const _temp31 = require("dbb23e974f6621ed");
const _temp32 = require("a6e4ada669598193");
const _temp33 = require("e20243ebd448d0ee");
module.exports = {
    "ar-AE": _temp0,
    "bg-BG": _temp1,
    "cs-CZ": _temp2,
    "da-DK": _temp3,
    "de-DE": _temp4,
    "el-GR": _temp5,
    "en-US": _temp6,
    "es-ES": _temp7,
    "et-EE": _temp8,
    "fi-FI": _temp9,
    "fr-FR": _temp10,
    "he-IL": _temp11,
    "hr-HR": _temp12,
    "hu-HU": _temp13,
    "it-IT": _temp14,
    "ja-JP": _temp15,
    "ko-KR": _temp16,
    "lt-LT": _temp17,
    "lv-LV": _temp18,
    "nb-NO": _temp19,
    "nl-NL": _temp20,
    "pl-PL": _temp21,
    "pt-BR": _temp22,
    "pt-PT": _temp23,
    "ro-RO": _temp24,
    "ru-RU": _temp25,
    "sk-SK": _temp26,
    "sl-SI": _temp27,
    "sr-SP": _temp28,
    "sv-SE": _temp29,
    "tr-TR": _temp30,
    "uk-UA": _temp31,
    "zh-CN": _temp32,
    "zh-TW": _temp33
};

},{"fe2c660e164947ce":"8FqLg","429931c6846b469f":"5Ft12","d83a0ee23577d12e":"dkR2K","492fc55587d24886":"1cxQ3","6fe820787f61fc4f":"6AdZG","cb943191f962f634":"aBGhM","df5363622fe50f18":"b2qLn","8d276ae7a7513759":"fywTw","4f99297d14e3157c":"h4Mvh","d3cb4a390aad81f2":"8HLbQ","a089aba373e1964b":"jM8vA","4ecd479fa8b4859":"a7h9b","c4987473c1fdee62":"jU3M2","503c8e176106b023":"dju8C","22711e2a1d6c40e0":"kVmX7","e889d32fa1327227":"atPfZ","4184e21feedbeae5":"4MpSj","8ba6b1655d3fe1ee":"3Nw3A","282f401f46721457":"3cvXQ","107fae74b923cba7":"hct2Q","af3cefead05127dc":"lCsOq","522cd8de993957f6":"1tmm3","e5c447edb1dcf6a":"jsSDH","f5a92a7855f6f44":"gdz9v","b668e2c7675206f":"jygCb","91524f82d3e6a37e":"8rcJ5","1848d90a5fa05535":"6bfuY","6cdb8d754f478ff8":"jrfrc","74c3cf82bcdd2d30":"27tih","e9704ec2c55e2631":"d8WsS","592033111f41600d":"8Gz3h","dbb23e974f6621ed":"7NK53","a6e4ada669598193":"fS6HT","e20243ebd448d0ee":"6MrR1"}],"8FqLg":[function(require,module,exports) {
module.exports = {
    "calendar": `\u{627}\u{644}\u{62A}\u{642}\u{648}\u{64A}\u{645}`,
    "day": `\u{64A}\u{648}\u{645}`,
    "dayPeriod": `\u{635}/\u{645}`,
    "endDate": `\u{62A}\u{627}\u{631}\u{64A}\u{62E} \u{627}\u{644}\u{627}\u{646}\u{62A}\u{647}\u{627}\u{621}`,
    "era": `\u{627}\u{644}\u{639}\u{635}\u{631}`,
    "hour": `\u{627}\u{644}\u{633}\u{627}\u{639}\u{627}\u{62A}`,
    "minute": `\u{627}\u{644}\u{62F}\u{642}\u{627}\u{626}\u{642}`,
    "month": `\u{627}\u{644}\u{634}\u{647}\u{631}`,
    "second": `\u{627}\u{644}\u{62B}\u{648}\u{627}\u{646}\u{64A}`,
    "selectedDateDescription": (args)=>`\u{62A}\u{627}\u{631}\u{64A}\u{62E} \u{645}\u{62D}\u{62F}\u{62F}: ${args.date}`,
    "selectedRangeDescription": (args)=>`\u{627}\u{644}\u{645}\u{62F}\u{649} \u{627}\u{644}\u{632}\u{645}\u{646}\u{64A} \u{627}\u{644}\u{645}\u{62D}\u{62F}\u{62F}: ${args.startDate} \u{625}\u{644}\u{649} ${args.endDate}`,
    "selectedTimeDescription": (args)=>`\u{627}\u{644}\u{648}\u{642}\u{62A} \u{627}\u{644}\u{645}\u{62D}\u{62F}\u{62F}: ${args.time}`,
    "startDate": `\u{62A}\u{627}\u{631}\u{64A}\u{62E} \u{627}\u{644}\u{628}\u{62F}\u{621}`,
    "timeZoneName": `\u{627}\u{644}\u{62A}\u{648}\u{642}\u{64A}\u{62A}`,
    "weekday": `\u{627}\u{644}\u{64A}\u{648}\u{645}`,
    "year": `\u{627}\u{644}\u{633}\u{646}\u{629}`
};

},{}],"5Ft12":[function(require,module,exports) {
module.exports = {
    "calendar": `\u{41A}\u{430}\u{43B}\u{435}\u{43D}\u{434}\u{430}\u{440}`,
    "day": `\u{434}\u{435}\u{43D}`,
    "dayPeriod": `\u{43F}\u{440}.\u{43E}\u{431}./\u{441}\u{43B}.\u{43E}\u{431}.`,
    "endDate": `\u{41A}\u{440}\u{430}\u{439}\u{43D}\u{430} \u{434}\u{430}\u{442}\u{430}`,
    "era": `\u{435}\u{440}\u{430}`,
    "hour": `\u{447}\u{430}\u{441}`,
    "minute": `\u{43C}\u{438}\u{43D}\u{443}\u{442}\u{430}`,
    "month": `\u{43C}\u{435}\u{441}\u{435}\u{446}`,
    "second": `\u{441}\u{435}\u{43A}\u{443}\u{43D}\u{434}\u{430}`,
    "selectedDateDescription": (args)=>`\u{418}\u{437}\u{431}\u{440}\u{430}\u{43D}\u{430} \u{434}\u{430}\u{442}\u{430}: ${args.date}`,
    "selectedRangeDescription": (args)=>`\u{418}\u{437}\u{431}\u{440}\u{430}\u{43D} \u{434}\u{438}\u{430}\u{43F}\u{430}\u{437}\u{43E}\u{43D}: ${args.startDate} \u{434}\u{43E} ${args.endDate}`,
    "selectedTimeDescription": (args)=>`\u{418}\u{437}\u{431}\u{440}\u{430}\u{43D}\u{43E} \u{432}\u{440}\u{435}\u{43C}\u{435}: ${args.time}`,
    "startDate": `\u{41D}\u{430}\u{447}\u{430}\u{43B}\u{43D}\u{430} \u{434}\u{430}\u{442}\u{430}`,
    "timeZoneName": `\u{447}\u{430}\u{441}\u{43E}\u{432}\u{430} \u{437}\u{43E}\u{43D}\u{430}`,
    "weekday": `\u{434}\u{435}\u{43D} \u{43E}\u{442} \u{441}\u{435}\u{434}\u{43C}\u{438}\u{446}\u{430}\u{442}\u{430}`,
    "year": `\u{433}\u{43E}\u{434}\u{438}\u{43D}\u{430}`
};

},{}],"dkR2K":[function(require,module,exports) {
module.exports = {
    "calendar": `Kalend\xe1\u{159}`,
    "day": `den`,
    "dayPeriod": `\u{10D}\xe1st dne`,
    "endDate": `Kone\u{10D}n\xe9 datum`,
    "era": `letopo\u{10D}et`,
    "hour": `hodina`,
    "minute": `minuta`,
    "month": `m\u{11B}s\xedc`,
    "second": `sekunda`,
    "selectedDateDescription": (args)=>`Vybran\xe9 datum: ${args.date}`,
    "selectedRangeDescription": (args)=>`Vybran\xe9 obdob\xed: ${args.startDate} a\u{17E} ${args.endDate}`,
    "selectedTimeDescription": (args)=>`Vybran\xfd \u{10D}as: ${args.time}`,
    "startDate": `Po\u{10D}\xe1te\u{10D}n\xed datum`,
    "timeZoneName": `\u{10D}asov\xe9 p\xe1smo`,
    "weekday": `den v t\xfddnu`,
    "year": `rok`
};

},{}],"1cxQ3":[function(require,module,exports) {
module.exports = {
    "calendar": `Kalender`,
    "day": `dag`,
    "dayPeriod": `AM/PM`,
    "endDate": `Slutdato`,
    "era": `\xe6ra`,
    "hour": `time`,
    "minute": `minut`,
    "month": `m\xe5ned`,
    "second": `sekund`,
    "selectedDateDescription": (args)=>`Valgt dato: ${args.date}`,
    "selectedRangeDescription": (args)=>`Valgt interval: ${args.startDate} til ${args.endDate}`,
    "selectedTimeDescription": (args)=>`Valgt tidspunkt: ${args.time}`,
    "startDate": `Startdato`,
    "timeZoneName": `tidszone`,
    "weekday": `ugedag`,
    "year": `\xe5r`
};

},{}],"6AdZG":[function(require,module,exports) {
module.exports = {
    "calendar": `Kalender`,
    "day": `Tag`,
    "dayPeriod": `Tagesh\xe4lfte`,
    "endDate": `Enddatum`,
    "era": `Epoche`,
    "hour": `Stunde`,
    "minute": `Minute`,
    "month": `Monat`,
    "second": `Sekunde`,
    "selectedDateDescription": (args)=>`Ausgew\xe4hltes Datum: ${args.date}`,
    "selectedRangeDescription": (args)=>`Ausgew\xe4hlter Bereich: ${args.startDate} bis ${args.endDate}`,
    "selectedTimeDescription": (args)=>`Ausgew\xe4hlte Zeit: ${args.time}`,
    "startDate": `Anfangsdatum`,
    "timeZoneName": `Zeitzone`,
    "weekday": `Wochentag`,
    "year": `Jahr`
};

},{}],"aBGhM":[function(require,module,exports) {
module.exports = {
    "calendar": `\u{397}\u{3BC}\u{3B5}\u{3C1}\u{3BF}\u{3BB}\u{3CC}\u{3B3}\u{3B9}\u{3BF}`,
    "day": `\u{3B7}\u{3BC}\u{3AD}\u{3C1}\u{3B1}`,
    "dayPeriod": `\u{3C0}.\u{3BC}./\u{3BC}.\u{3BC}.`,
    "endDate": `\u{397}\u{3BC}\u{3B5}\u{3C1}\u{3BF}\u{3BC}\u{3B7}\u{3BD}\u{3AF}\u{3B1} \u{3BB}\u{3AE}\u{3BE}\u{3B7}\u{3C2}`,
    "era": `\u{3C0}\u{3B5}\u{3C1}\u{3AF}\u{3BF}\u{3B4}\u{3BF}\u{3C2}`,
    "hour": `\u{3CE}\u{3C1}\u{3B1}`,
    "minute": `\u{3BB}\u{3B5}\u{3C0}\u{3C4}\u{3CC}`,
    "month": `\u{3BC}\u{3AE}\u{3BD}\u{3B1}\u{3C2}`,
    "second": `\u{3B4}\u{3B5}\u{3C5}\u{3C4}\u{3B5}\u{3C1}\u{3CC}\u{3BB}\u{3B5}\u{3C0}\u{3C4}\u{3BF}`,
    "selectedDateDescription": (args)=>`\u{395}\u{3C0}\u{3B9}\u{3BB}\u{3B5}\u{3B3}\u{3BC}\u{3AD}\u{3BD}\u{3B7} \u{3B7}\u{3BC}\u{3B5}\u{3C1}\u{3BF}\u{3BC}\u{3B7}\u{3BD}\u{3AF}\u{3B1}: ${args.date}`,
    "selectedRangeDescription": (args)=>`\u{395}\u{3C0}\u{3B9}\u{3BB}\u{3B5}\u{3B3}\u{3BC}\u{3AD}\u{3BD}\u{3BF} \u{3B5}\u{3CD}\u{3C1}\u{3BF}\u{3C2}: ${args.startDate} \u{3AD}\u{3C9}\u{3C2} ${args.endDate}`,
    "selectedTimeDescription": (args)=>`\u{395}\u{3C0}\u{3B9}\u{3BB}\u{3B5}\u{3B3}\u{3BC}\u{3AD}\u{3BD}\u{3B7} \u{3CE}\u{3C1}\u{3B1}: ${args.time}`,
    "startDate": `\u{397}\u{3BC}\u{3B5}\u{3C1}\u{3BF}\u{3BC}\u{3B7}\u{3BD}\u{3AF}\u{3B1} \u{3AD}\u{3BD}\u{3B1}\u{3C1}\u{3BE}\u{3B7}\u{3C2}`,
    "timeZoneName": `\u{3B6}\u{3CE}\u{3BD}\u{3B7} \u{3CE}\u{3C1}\u{3B1}\u{3C2}`,
    "weekday": `\u{3BA}\u{3B1}\u{3B8}\u{3B7}\u{3BC}\u{3B5}\u{3C1}\u{3B9}\u{3BD}\u{3AE}`,
    "year": `\u{3AD}\u{3C4}\u{3BF}\u{3C2}`
};

},{}],"b2qLn":[function(require,module,exports) {
module.exports = {
    "era": `era`,
    "year": `year`,
    "month": `month`,
    "day": `day`,
    "hour": `hour`,
    "minute": `minute`,
    "second": `second`,
    "dayPeriod": `AM/PM`,
    "calendar": `Calendar`,
    "startDate": `Start Date`,
    "endDate": `End Date`,
    "weekday": `day of the week`,
    "timeZoneName": `time zone`,
    "selectedDateDescription": (args)=>`Selected Date: ${args.date}`,
    "selectedRangeDescription": (args)=>`Selected Range: ${args.startDate} to ${args.endDate}`,
    "selectedTimeDescription": (args)=>`Selected Time: ${args.time}`
};

},{}],"fywTw":[function(require,module,exports) {
module.exports = {
    "calendar": `Calendario`,
    "day": `d\xeda`,
    "dayPeriod": `a.\xa0m./p.\xa0m.`,
    "endDate": `Fecha final`,
    "era": `era`,
    "hour": `hora`,
    "minute": `minuto`,
    "month": `mes`,
    "second": `segundo`,
    "selectedDateDescription": (args)=>`Fecha seleccionada: ${args.date}`,
    "selectedRangeDescription": (args)=>`Rango seleccionado: ${args.startDate} a ${args.endDate}`,
    "selectedTimeDescription": (args)=>`Hora seleccionada: ${args.time}`,
    "startDate": `Fecha de inicio`,
    "timeZoneName": `zona horaria`,
    "weekday": `d\xeda de la semana`,
    "year": `a\xf1o`
};

},{}],"h4Mvh":[function(require,module,exports) {
module.exports = {
    "calendar": `Kalender`,
    "day": `p\xe4ev`,
    "dayPeriod": `enne/p\xe4rast l\xf5unat`,
    "endDate": `L\xf5ppkuup\xe4ev`,
    "era": `ajastu`,
    "hour": `tund`,
    "minute": `minut`,
    "month": `kuu`,
    "second": `sekund`,
    "selectedDateDescription": (args)=>`Valitud kuup\xe4ev: ${args.date}`,
    "selectedRangeDescription": (args)=>`Valitud vahemik: ${args.startDate} kuni ${args.endDate}`,
    "selectedTimeDescription": (args)=>`Valitud aeg: ${args.time}`,
    "startDate": `Alguskuup\xe4ev`,
    "timeZoneName": `ajav\xf6\xf6nd`,
    "weekday": `n\xe4dalap\xe4ev`,
    "year": `aasta`
};

},{}],"8HLbQ":[function(require,module,exports) {
module.exports = {
    "calendar": `Kalenteri`,
    "day": `p\xe4iv\xe4`,
    "dayPeriod": `vuorokaudenaika`,
    "endDate": `P\xe4\xe4ttymisp\xe4iv\xe4`,
    "era": `aikakausi`,
    "hour": `tunti`,
    "minute": `minuutti`,
    "month": `kuukausi`,
    "second": `sekunti`,
    "selectedDateDescription": (args)=>`Valittu p\xe4iv\xe4m\xe4\xe4r\xe4: ${args.date}`,
    "selectedRangeDescription": (args)=>`Valittu aikav\xe4li: ${args.startDate} \u{2013} ${args.endDate}`,
    "selectedTimeDescription": (args)=>`Valittu aika: ${args.time}`,
    "startDate": `Alkamisp\xe4iv\xe4`,
    "timeZoneName": `aikavy\xf6hyke`,
    "weekday": `viikonp\xe4iv\xe4`,
    "year": `vuosi`
};

},{}],"jM8vA":[function(require,module,exports) {
module.exports = {
    "calendar": `Calendrier`,
    "day": `jour`,
    "dayPeriod": `cadran`,
    "endDate": `Date de fin`,
    "era": `\xe8re`,
    "hour": `heure`,
    "minute": `minute`,
    "month": `mois`,
    "second": `seconde`,
    "selectedDateDescription": (args)=>`Date s\xe9lectionn\xe9e\xa0: ${args.date}`,
    "selectedRangeDescription": (args)=>`Plage s\xe9lectionn\xe9e\xa0: ${args.startDate} au ${args.endDate}`,
    "selectedTimeDescription": (args)=>`Heure choisie\xa0: ${args.time}`,
    "startDate": `Date de d\xe9but`,
    "timeZoneName": `fuseau horaire`,
    "weekday": `jour de la semaine`,
    "year": `ann\xe9e`
};

},{}],"a7h9b":[function(require,module,exports) {
module.exports = {
    "calendar": `\u{5DC}\u{5D5}\u{5D7} \u{5E9}\u{5E0}\u{5D4}`,
    "day": `\u{5D9}\u{5D5}\u{5DD}`,
    "dayPeriod": `\u{5DC}\u{5E4}\u{5E0}\u{5D4}\u{5F4}\u{5E6}/\u{5D0}\u{5D7}\u{5D4}\u{5F4}\u{5E6}`,
    "endDate": `\u{5EA}\u{5D0}\u{5E8}\u{5D9}\u{5DA} \u{5E1}\u{5D9}\u{5D5}\u{5DD}`,
    "era": `\u{5EA}\u{5E7}\u{5D5}\u{5E4}\u{5D4}`,
    "hour": `\u{5E9}\u{5E2}\u{5D4}`,
    "minute": `\u{5D3}\u{5E7}\u{5D4}`,
    "month": `\u{5D7}\u{5D5}\u{5D3}\u{5E9}`,
    "second": `\u{5E9}\u{5E0}\u{5D9}\u{5D9}\u{5D4}`,
    "selectedDateDescription": (args)=>`\u{5EA}\u{5D0}\u{5E8}\u{5D9}\u{5DA} \u{5E0}\u{5D1}\u{5D7}\u{5E8}: ${args.date}`,
    "selectedRangeDescription": (args)=>`\u{5D8}\u{5D5}\u{5D5}\u{5D7} \u{5E0}\u{5D1}\u{5D7}\u{5E8}: ${args.startDate} \u{5E2}\u{5D3} ${args.endDate}`,
    "selectedTimeDescription": (args)=>`\u{5D6}\u{5DE}\u{5DF} \u{5E0}\u{5D1}\u{5D7}\u{5E8}: ${args.time}`,
    "startDate": `\u{5EA}\u{5D0}\u{5E8}\u{5D9}\u{5DA} \u{5D4}\u{5EA}\u{5D7}\u{5DC}\u{5D4}`,
    "timeZoneName": `\u{5D0}\u{5D6}\u{5D5}\u{5E8} \u{5D6}\u{5DE}\u{5DF}`,
    "weekday": `\u{5D9}\u{5D5}\u{5DD} \u{5D1}\u{5E9}\u{5D1}\u{5D5}\u{5E2}`,
    "year": `\u{5E9}\u{5E0}\u{5D4}`
};

},{}],"jU3M2":[function(require,module,exports) {
module.exports = {
    "calendar": `Kalendar`,
    "day": `dan`,
    "dayPeriod": `AM/PM`,
    "endDate": `Datum zavr\u{161}etka`,
    "era": `era`,
    "hour": `sat`,
    "minute": `minuta`,
    "month": `mjesec`,
    "second": `sekunda`,
    "selectedDateDescription": (args)=>`Odabrani datum: ${args.date}`,
    "selectedRangeDescription": (args)=>`Odabrani raspon: ${args.startDate} do ${args.endDate}`,
    "selectedTimeDescription": (args)=>`Odabrano vrijeme: ${args.time}`,
    "startDate": `Datum po\u{10D}etka`,
    "timeZoneName": `vremenska zona`,
    "weekday": `dan u tjednu`,
    "year": `godina`
};

},{}],"dju8C":[function(require,module,exports) {
module.exports = {
    "calendar": `Napt\xe1r`,
    "day": `nap`,
    "dayPeriod": `napszak`,
    "endDate": `Befejez\u{151} d\xe1tum`,
    "era": `\xe9ra`,
    "hour": `\xf3ra`,
    "minute": `perc`,
    "month": `h\xf3nap`,
    "second": `m\xe1sodperc`,
    "selectedDateDescription": (args)=>`Kijel\xf6lt d\xe1tum: ${args.date}`,
    "selectedRangeDescription": (args)=>`Kijel\xf6lt tartom\xe1ny: ${args.startDate}\u{2013}${args.endDate}`,
    "selectedTimeDescription": (args)=>`Kijel\xf6lt id\u{151}: ${args.time}`,
    "startDate": `Kezd\u{151} d\xe1tum`,
    "timeZoneName": `id\u{151}z\xf3na`,
    "weekday": `h\xe9t napja`,
    "year": `\xe9v`
};

},{}],"kVmX7":[function(require,module,exports) {
module.exports = {
    "calendar": `Calendario`,
    "day": `giorno`,
    "dayPeriod": `AM/PM`,
    "endDate": `Data finale`,
    "era": `era`,
    "hour": `ora`,
    "minute": `minuto`,
    "month": `mese`,
    "second": `secondo`,
    "selectedDateDescription": (args)=>`Data selezionata: ${args.date}`,
    "selectedRangeDescription": (args)=>`Intervallo selezionato: da ${args.startDate} a ${args.endDate}`,
    "selectedTimeDescription": (args)=>`Ora selezionata: ${args.time}`,
    "startDate": `Data iniziale`,
    "timeZoneName": `fuso orario`,
    "weekday": `giorno della settimana`,
    "year": `anno`
};

},{}],"atPfZ":[function(require,module,exports) {
module.exports = {
    "calendar": `\u{30AB}\u{30EC}\u{30F3}\u{30C0}\u{30FC}`,
    "day": `\u{65E5}`,
    "dayPeriod": `\u{5348}\u{524D}/\u{5348}\u{5F8C}`,
    "endDate": `\u{7D42}\u{4E86}\u{65E5}`,
    "era": `\u{6642}\u{4EE3}`,
    "hour": `\u{6642}`,
    "minute": `\u{5206}`,
    "month": `\u{6708}`,
    "second": `\u{79D2}`,
    "selectedDateDescription": (args)=>`\u{9078}\u{629E}\u{3057}\u{305F}\u{65E5}\u{4ED8} : ${args.date}`,
    "selectedRangeDescription": (args)=>`\u{9078}\u{629E}\u{7BC4}\u{56F2} : ${args.startDate} \u{304B}\u{3089} ${args.endDate}`,
    "selectedTimeDescription": (args)=>`\u{9078}\u{629E}\u{3057}\u{305F}\u{6642}\u{9593} : ${args.time}`,
    "startDate": `\u{958B}\u{59CB}\u{65E5}`,
    "timeZoneName": `\u{30BF}\u{30A4}\u{30E0}\u{30BE}\u{30FC}\u{30F3}`,
    "weekday": `\u{66DC}\u{65E5}`,
    "year": `\u{5E74}`
};

},{}],"4MpSj":[function(require,module,exports) {
module.exports = {
    "calendar": `\u{B2EC}\u{B825}`,
    "day": `\u{C77C}`,
    "dayPeriod": `\u{C624}\u{C804}/\u{C624}\u{D6C4}`,
    "endDate": `\u{C885}\u{B8CC}\u{C77C}`,
    "era": `\u{C5F0}\u{D638}`,
    "hour": `\u{C2DC}`,
    "minute": `\u{BD84}`,
    "month": `\u{C6D4}`,
    "second": `\u{CD08}`,
    "selectedDateDescription": (args)=>`\u{C120}\u{D0DD} \u{C77C}\u{C790}: ${args.date}`,
    "selectedRangeDescription": (args)=>`\u{C120}\u{D0DD} \u{BC94}\u{C704}: ${args.startDate} ~ ${args.endDate}`,
    "selectedTimeDescription": (args)=>`\u{C120}\u{D0DD} \u{C2DC}\u{AC04}: ${args.time}`,
    "startDate": `\u{C2DC}\u{C791}\u{C77C}`,
    "timeZoneName": `\u{C2DC}\u{AC04}\u{B300}`,
    "weekday": `\u{C694}\u{C77C}`,
    "year": `\u{B144}`
};

},{}],"3Nw3A":[function(require,module,exports) {
module.exports = {
    "calendar": `Kalendorius`,
    "day": `diena`,
    "dayPeriod": `iki piet\u{173} / po piet\u{173}`,
    "endDate": `Pabaigos data`,
    "era": `era`,
    "hour": `valanda`,
    "minute": `minut\u{117}`,
    "month": `m\u{117}nuo`,
    "second": `sekund\u{117}`,
    "selectedDateDescription": (args)=>`Pasirinkta data: ${args.date}`,
    "selectedRangeDescription": (args)=>`Pasirinktas intervalas: nuo ${args.startDate} iki ${args.endDate}`,
    "selectedTimeDescription": (args)=>`Pasirinktas laikas: ${args.time}`,
    "startDate": `Prad\u{17E}ios data`,
    "timeZoneName": `laiko juosta`,
    "weekday": `savait\u{117}s diena`,
    "year": `metai`
};

},{}],"3cvXQ":[function(require,module,exports) {
module.exports = {
    "calendar": `Kalend\u{101}rs`,
    "day": `diena`,
    "dayPeriod": `priek\u{161}pusdien\u{101}/p\u{113}cpusdien\u{101}`,
    "endDate": `Beigu datums`,
    "era": `\u{113}ra`,
    "hour": `stundas`,
    "minute": `min\u{16B}tes`,
    "month": `m\u{113}nesis`,
    "second": `sekundes`,
    "selectedDateDescription": (args)=>`Atlas\u{12B}tais datums: ${args.date}`,
    "selectedRangeDescription": (args)=>`Atlas\u{12B}tais diapazons: no ${args.startDate} l\u{12B}dz ${args.endDate}`,
    "selectedTimeDescription": (args)=>`Atlas\u{12B}tais laiks: ${args.time}`,
    "startDate": `S\u{101}kuma datums`,
    "timeZoneName": `laika josla`,
    "weekday": `ned\u{113}\u{13C}as diena`,
    "year": `gads`
};

},{}],"hct2Q":[function(require,module,exports) {
module.exports = {
    "calendar": `Kalender`,
    "day": `dag`,
    "dayPeriod": `a.m./p.m.`,
    "endDate": `Sluttdato`,
    "era": `tidsalder`,
    "hour": `time`,
    "minute": `minutt`,
    "month": `m\xe5ned`,
    "second": `sekund`,
    "selectedDateDescription": (args)=>`Valgt dato: ${args.date}`,
    "selectedRangeDescription": (args)=>`Valgt omr\xe5de: ${args.startDate} til ${args.endDate}`,
    "selectedTimeDescription": (args)=>`Valgt tid: ${args.time}`,
    "startDate": `Startdato`,
    "timeZoneName": `tidssone`,
    "weekday": `ukedag`,
    "year": `\xe5r`
};

},{}],"lCsOq":[function(require,module,exports) {
module.exports = {
    "calendar": `Kalender`,
    "day": `dag`,
    "dayPeriod": `a.m./p.m.`,
    "endDate": `Einddatum`,
    "era": `tijdperk`,
    "hour": `uur`,
    "minute": `minuut`,
    "month": `maand`,
    "second": `seconde`,
    "selectedDateDescription": (args)=>`Geselecteerde datum: ${args.date}`,
    "selectedRangeDescription": (args)=>`Geselecteerd bereik: ${args.startDate} tot ${args.endDate}`,
    "selectedTimeDescription": (args)=>`Geselecteerde tijd: ${args.time}`,
    "startDate": `Startdatum`,
    "timeZoneName": `tijdzone`,
    "weekday": `dag van de week`,
    "year": `jaar`
};

},{}],"1tmm3":[function(require,module,exports) {
module.exports = {
    "calendar": `Kalendarz`,
    "day": `dzie\u{144}`,
    "dayPeriod": `rano / po po\u{142}udniu / wieczorem`,
    "endDate": `Data ko\u{144}cowa`,
    "era": `era`,
    "hour": `godzina`,
    "minute": `minuta`,
    "month": `miesi\u{105}c`,
    "second": `sekunda`,
    "selectedDateDescription": (args)=>`Wybrana data: ${args.date}`,
    "selectedRangeDescription": (args)=>`Wybrany zakres: ${args.startDate} do ${args.endDate}`,
    "selectedTimeDescription": (args)=>`Wybrany czas: ${args.time}`,
    "startDate": `Data pocz\u{105}tkowa`,
    "timeZoneName": `strefa czasowa`,
    "weekday": `dzie\u{144} tygodnia`,
    "year": `rok`
};

},{}],"jsSDH":[function(require,module,exports) {
module.exports = {
    "calendar": `Calend\xe1rio`,
    "day": `dia`,
    "dayPeriod": `AM/PM`,
    "endDate": `Data final`,
    "era": `era`,
    "hour": `hora`,
    "minute": `minuto`,
    "month": `m\xeas`,
    "second": `segundo`,
    "selectedDateDescription": (args)=>`Data selecionada: ${args.date}`,
    "selectedRangeDescription": (args)=>`Intervalo selecionado: ${args.startDate} a ${args.endDate}`,
    "selectedTimeDescription": (args)=>`Hora selecionada: ${args.time}`,
    "startDate": `Data inicial`,
    "timeZoneName": `fuso hor\xe1rio`,
    "weekday": `dia da semana`,
    "year": `ano`
};

},{}],"gdz9v":[function(require,module,exports) {
module.exports = {
    "calendar": `Calend\xe1rio`,
    "day": `dia`,
    "dayPeriod": `am/pm`,
    "endDate": `Data de T\xe9rmino`,
    "era": `era`,
    "hour": `hora`,
    "minute": `minuto`,
    "month": `m\xeas`,
    "second": `segundo`,
    "selectedDateDescription": (args)=>`Data selecionada: ${args.date}`,
    "selectedRangeDescription": (args)=>`Intervalo selecionado: ${args.startDate} a ${args.endDate}`,
    "selectedTimeDescription": (args)=>`Hora selecionada: ${args.time}`,
    "startDate": `Data de In\xedcio`,
    "timeZoneName": `fuso hor\xe1rio`,
    "weekday": `dia da semana`,
    "year": `ano`
};

},{}],"jygCb":[function(require,module,exports) {
module.exports = {
    "calendar": `Calendar`,
    "day": `zi`,
    "dayPeriod": `a.m/p.m.`,
    "endDate": `Dat\u{103} final`,
    "era": `er\u{103}`,
    "hour": `or\u{103}`,
    "minute": `minut`,
    "month": `lun\u{103}`,
    "second": `secund\u{103}`,
    "selectedDateDescription": (args)=>`Dat\u{103} selectat\u{103}: ${args.date}`,
    "selectedRangeDescription": (args)=>`Interval selectat: de la ${args.startDate} p\xe2n\u{103} la ${args.endDate}`,
    "selectedTimeDescription": (args)=>`Ora selectat\u{103}: ${args.time}`,
    "startDate": `Dat\u{103} \xeenceput`,
    "timeZoneName": `fus orar`,
    "weekday": `ziua din s\u{103}pt\u{103}m\xe2n\u{103}`,
    "year": `an`
};

},{}],"8rcJ5":[function(require,module,exports) {
module.exports = {
    "calendar": `\u{41A}\u{430}\u{43B}\u{435}\u{43D}\u{434}\u{430}\u{440}\u{44C}`,
    "day": `\u{434}\u{435}\u{43D}\u{44C}`,
    "dayPeriod": `AM/PM`,
    "endDate": `\u{414}\u{430}\u{442}\u{430} \u{43E}\u{43A}\u{43E}\u{43D}\u{447}\u{430}\u{43D}\u{438}\u{44F}`,
    "era": `\u{44D}\u{440}\u{430}`,
    "hour": `\u{447}\u{430}\u{441}`,
    "minute": `\u{43C}\u{438}\u{43D}\u{443}\u{442}\u{430}`,
    "month": `\u{43C}\u{435}\u{441}\u{44F}\u{446}`,
    "second": `\u{441}\u{435}\u{43A}\u{443}\u{43D}\u{434}\u{430}`,
    "selectedDateDescription": (args)=>`\u{412}\u{44B}\u{431}\u{440}\u{430}\u{43D}\u{43D}\u{430}\u{44F} \u{434}\u{430}\u{442}\u{430}: ${args.date}`,
    "selectedRangeDescription": (args)=>`\u{412}\u{44B}\u{431}\u{440}\u{430}\u{43D}\u{43D}\u{44B}\u{439} \u{434}\u{438}\u{430}\u{43F}\u{430}\u{437}\u{43E}\u{43D}: \u{441} ${args.startDate} \u{43F}\u{43E} ${args.endDate}`,
    "selectedTimeDescription": (args)=>`\u{412}\u{44B}\u{431}\u{440}\u{430}\u{43D}\u{43D}\u{43E}\u{435} \u{432}\u{440}\u{435}\u{43C}\u{44F}: ${args.time}`,
    "startDate": `\u{414}\u{430}\u{442}\u{430} \u{43D}\u{430}\u{447}\u{430}\u{43B}\u{430}`,
    "timeZoneName": `\u{447}\u{430}\u{441}\u{43E}\u{432}\u{43E}\u{439} \u{43F}\u{43E}\u{44F}\u{441}`,
    "weekday": `\u{434}\u{435}\u{43D}\u{44C} \u{43D}\u{435}\u{434}\u{435}\u{43B}\u{438}`,
    "year": `\u{433}\u{43E}\u{434}`
};

},{}],"6bfuY":[function(require,module,exports) {
module.exports = {
    "calendar": `Kalend\xe1r`,
    "day": `de\u{148}`,
    "dayPeriod": `AM/PM`,
    "endDate": `D\xe1tum ukon\u{10D}enia`,
    "era": `letopo\u{10D}et`,
    "hour": `hodina`,
    "minute": `min\xfata`,
    "month": `mesiac`,
    "second": `sekunda`,
    "selectedDateDescription": (args)=>`Vybrat\xfd d\xe1tum: ${args.date}`,
    "selectedRangeDescription": (args)=>`Vybrat\xfd rozsah: od ${args.startDate} do ${args.endDate}`,
    "selectedTimeDescription": (args)=>`Vybrat\xfd \u{10D}as: ${args.time}`,
    "startDate": `D\xe1tum za\u{10D}atia`,
    "timeZoneName": `\u{10D}asov\xe9 p\xe1smo`,
    "weekday": `de\u{148} t\xfd\u{17E}d\u{148}a`,
    "year": `rok`
};

},{}],"jrfrc":[function(require,module,exports) {
module.exports = {
    "calendar": `Koledar`,
    "day": `dan`,
    "dayPeriod": `dop/pop`,
    "endDate": `Datum konca`,
    "era": `doba`,
    "hour": `ura`,
    "minute": `minuta`,
    "month": `mesec`,
    "second": `sekunda`,
    "selectedDateDescription": (args)=>`Izbrani datum: ${args.date}`,
    "selectedRangeDescription": (args)=>`Izbrano obmo\u{10D}je: ${args.startDate} do ${args.endDate}`,
    "selectedTimeDescription": (args)=>`Izbrani \u{10D}as: ${args.time}`,
    "startDate": `Datum za\u{10D}etka`,
    "timeZoneName": `\u{10D}asovni pas`,
    "weekday": `dan v tednu`,
    "year": `leto`
};

},{}],"27tih":[function(require,module,exports) {
module.exports = {
    "calendar": `Kalendar`,
    "day": `\u{434}\u{430}\u{43D}`,
    "dayPeriod": `\u{43F}\u{440}\u{435} \u{43F}\u{43E}\u{434}\u{43D}\u{435}/\u{43F}\u{43E} \u{43F}\u{43E}\u{434}\u{43D}\u{435}`,
    "endDate": `Datum zavr\u{161}etka`,
    "era": `\u{435}\u{440}\u{430}`,
    "hour": `\u{441}\u{430}\u{442}`,
    "minute": `\u{43C}\u{438}\u{43D}\u{443}\u{442}`,
    "month": `\u{43C}\u{435}\u{441}\u{435}\u{446}`,
    "second": `\u{441}\u{435}\u{43A}\u{443}\u{43D}\u{434}`,
    "selectedDateDescription": (args)=>`Izabrani datum: ${args.date}`,
    "selectedRangeDescription": (args)=>`Izabrani opseg: od ${args.startDate} do ${args.endDate}`,
    "selectedTimeDescription": (args)=>`Izabrano vreme: ${args.time}`,
    "startDate": `Datum po\u{10D}etka`,
    "timeZoneName": `\u{432}\u{440}\u{435}\u{43C}\u{435}\u{43D}\u{441}\u{43A}\u{430} \u{437}\u{43E}\u{43D}\u{430}`,
    "weekday": `\u{434}\u{430}\u{43D} \u{443} \u{43D}\u{435}\u{434}\u{435}\u{459}\u{438}`,
    "year": `\u{433}\u{43E}\u{434}\u{438}\u{43D}\u{430}`
};

},{}],"d8WsS":[function(require,module,exports) {
module.exports = {
    "calendar": `Kalender`,
    "day": `dag`,
    "dayPeriod": `fm/em`,
    "endDate": `Slutdatum`,
    "era": `era`,
    "hour": `timme`,
    "minute": `minut`,
    "month": `m\xe5nad`,
    "second": `sekund`,
    "selectedDateDescription": (args)=>`Valt datum: ${args.date}`,
    "selectedRangeDescription": (args)=>`Valt intervall: ${args.startDate} till ${args.endDate}`,
    "selectedTimeDescription": (args)=>`Vald tid: ${args.time}`,
    "startDate": `Startdatum`,
    "timeZoneName": `tidszon`,
    "weekday": `veckodag`,
    "year": `\xe5r`
};

},{}],"8Gz3h":[function(require,module,exports) {
module.exports = {
    "calendar": `Takvim`,
    "day": `g\xfcn`,
    "dayPeriod": `\xd6\xd6/\xd6S`,
    "endDate": `Biti\u{15F} Tarihi`,
    "era": `\xe7a\u{11F}`,
    "hour": `saat`,
    "minute": `dakika`,
    "month": `ay`,
    "second": `saniye`,
    "selectedDateDescription": (args)=>`Se\xe7ilen Tarih: ${args.date}`,
    "selectedRangeDescription": (args)=>`Se\xe7ilen Aral\u{131}k: ${args.startDate} - ${args.endDate}`,
    "selectedTimeDescription": (args)=>`Se\xe7ilen Zaman: ${args.time}`,
    "startDate": `Ba\u{15F}lang\u{131}\xe7 Tarihi`,
    "timeZoneName": `saat dilimi`,
    "weekday": `haftan\u{131}n g\xfcn\xfc`,
    "year": `y\u{131}l`
};

},{}],"7NK53":[function(require,module,exports) {
module.exports = {
    "calendar": `\u{41A}\u{430}\u{43B}\u{435}\u{43D}\u{434}\u{430}\u{440}`,
    "day": `\u{434}\u{435}\u{43D}\u{44C}`,
    "dayPeriod": `\u{434}\u{43F}/\u{43F}\u{43F}`,
    "endDate": `\u{414}\u{430}\u{442}\u{430} \u{437}\u{430}\u{432}\u{435}\u{440}\u{448}\u{435}\u{43D}\u{43D}\u{44F}`,
    "era": `\u{435}\u{440}\u{430}`,
    "hour": `\u{433}\u{43E}\u{434}\u{438}\u{43D}\u{430}`,
    "minute": `\u{445}\u{432}\u{438}\u{43B}\u{438}\u{43D}\u{430}`,
    "month": `\u{43C}\u{456}\u{441}\u{44F}\u{446}\u{44C}`,
    "second": `\u{441}\u{435}\u{43A}\u{443}\u{43D}\u{434}\u{430}`,
    "selectedDateDescription": (args)=>`\u{412}\u{438}\u{431}\u{440}\u{430}\u{43D}\u{430} \u{434}\u{430}\u{442}\u{430}: ${args.date}`,
    "selectedRangeDescription": (args)=>`\u{412}\u{438}\u{431}\u{440}\u{430}\u{43D}\u{438}\u{439} \u{434}\u{456}\u{430}\u{43F}\u{430}\u{437}\u{43E}\u{43D}: ${args.startDate} \u{2014} ${args.endDate}`,
    "selectedTimeDescription": (args)=>`\u{412}\u{438}\u{431}\u{440}\u{430}\u{43D}\u{438}\u{439} \u{447}\u{430}\u{441}: ${args.time}`,
    "startDate": `\u{414}\u{430}\u{442}\u{430} \u{43F}\u{43E}\u{447}\u{430}\u{442}\u{43A}\u{443}`,
    "timeZoneName": `\u{447}\u{430}\u{441}\u{43E}\u{432}\u{438}\u{439} \u{43F}\u{43E}\u{44F}\u{441}`,
    "weekday": `\u{434}\u{435}\u{43D}\u{44C} \u{442}\u{438}\u{436}\u{43D}\u{44F}`,
    "year": `\u{440}\u{456}\u{43A}`
};

},{}],"fS6HT":[function(require,module,exports) {
module.exports = {
    "calendar": `\u{65E5}\u{5386}`,
    "day": `\u{65E5}`,
    "dayPeriod": `\u{4E0A}\u{5348}/\u{4E0B}\u{5348}`,
    "endDate": `\u{7ED3}\u{675F}\u{65E5}\u{671F}`,
    "era": `\u{7EAA}\u{5143}`,
    "hour": `\u{5C0F}\u{65F6}`,
    "minute": `\u{5206}\u{949F}`,
    "month": `\u{6708}`,
    "second": `\u{79D2}`,
    "selectedDateDescription": (args)=>`\u{9009}\u{5B9A}\u{7684}\u{65E5}\u{671F}\u{FF1A}${args.date}`,
    "selectedRangeDescription": (args)=>`\u{9009}\u{5B9A}\u{7684}\u{8303}\u{56F4}\u{FF1A}${args.startDate} \u{81F3} ${args.endDate}`,
    "selectedTimeDescription": (args)=>`\u{9009}\u{5B9A}\u{7684}\u{65F6}\u{95F4}\u{FF1A}${args.time}`,
    "startDate": `\u{5F00}\u{59CB}\u{65E5}\u{671F}`,
    "timeZoneName": `\u{65F6}\u{533A}`,
    "weekday": `\u{5DE5}\u{4F5C}\u{65E5}`,
    "year": `\u{5E74}`
};

},{}],"6MrR1":[function(require,module,exports) {
module.exports = {
    "calendar": `\u{65E5}\u{66C6}`,
    "day": `\u{65E5}`,
    "dayPeriod": `\u{4E0A}\u{5348}/\u{4E0B}\u{5348}`,
    "endDate": `\u{7D50}\u{675F}\u{65E5}\u{671F}`,
    "era": `\u{7EAA}\u{5143}`,
    "hour": `\u{5C0F}\u{65F6}`,
    "minute": `\u{5206}\u{949F}`,
    "month": `\u{6708}`,
    "second": `\u{79D2}`,
    "selectedDateDescription": (args)=>`\u{9078}\u{5B9A}\u{7684}\u{65E5}\u{671F}\u{FF1A}${args.date}`,
    "selectedRangeDescription": (args)=>`\u{9078}\u{5B9A}\u{7684}\u{7BC4}\u{570D}\u{FF1A}${args.startDate} \u{81F3} ${args.endDate}`,
    "selectedTimeDescription": (args)=>`\u{9078}\u{5B9A}\u{7684}\u{6642}\u{9593}\u{FF1A}${args.time}`,
    "startDate": `\u{958B}\u{59CB}\u{65E5}\u{671F}`,
    "timeZoneName": `\u{65F6}\u{533A}`,
    "weekday": `\u{5DE5}\u{4F5C}\u{65E5}`,
    "year": `\u{5E74}`
};

},{}],"fp6Rt":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hookData", ()=>hookData);
parcelHelpers.export(exports, "roleSymbol", ()=>roleSymbol);
parcelHelpers.export(exports, "focusManagerSymbol", ()=>focusManagerSymbol);
/**
 * Provides the behavior and accessibility implementation for a date field component.
 * A date field allows users to enter and edit date and time values using a keyboard.
 * Each part of a date value is displayed in an individually editable segment.
 */ parcelHelpers.export(exports, "useDateField", ()=>useDateField);
/**
 * Provides the behavior and accessibility implementation for a time field component.
 * A time field allows users to enter and edit time values using a keyboard.
 * Each part of a time value is displayed in an individually editable segment.
 */ parcelHelpers.export(exports, "useTimeField", ()=>useTimeField);
var _focus = require("@react-aria/focus");
var _utils = require("@react-aria/utils");
var _react = require("react");
// @ts-ignore
var _json = require("../intl/*.json");
var _jsonDefault = parcelHelpers.interopDefault(_json);
var _useDatePickerGroup = require("./useDatePickerGroup");
var _label = require("@react-aria/label");
var _interactions = require("@react-aria/interactions");
var _form = require("@react-aria/form");
var _i18N = require("@react-aria/i18n");
const hookData = new WeakMap();
const roleSymbol = "__role_" + Date.now();
const focusManagerSymbol = "__focusManager_" + Date.now();
function useDateField(props, state, ref) {
    var _state_value;
    let { isInvalid, validationErrors, validationDetails } = state.displayValidation;
    let { labelProps, fieldProps, descriptionProps, errorMessageProps } = (0, _label.useField)({
        ...props,
        labelElementType: "span",
        isInvalid,
        errorMessage: props.errorMessage || validationErrors
    });
    let valueOnFocus = (0, _react.useRef)(null);
    let { focusWithinProps } = (0, _interactions.useFocusWithin)({
        ...props,
        onFocusWithin (e) {
            var _props_onFocus;
            valueOnFocus.current = state.value;
            (_props_onFocus = props.onFocus) === null || _props_onFocus === void 0 ? void 0 : _props_onFocus.call(props, e);
        },
        onBlurWithin: (e)=>{
            var _props_onBlur;
            state.confirmPlaceholder();
            if (state.value !== valueOnFocus.current) state.commitValidation();
            (_props_onBlur = props.onBlur) === null || _props_onBlur === void 0 ? void 0 : _props_onBlur.call(props, e);
        },
        onFocusWithinChange: props.onFocusChange
    });
    let stringFormatter = (0, _i18N.useLocalizedStringFormatter)((0, _jsonDefault.default), "@react-aria/datepicker");
    let message = state.maxGranularity === "hour" ? "selectedTimeDescription" : "selectedDateDescription";
    let field = state.maxGranularity === "hour" ? "time" : "date";
    let description = state.value ? stringFormatter.format(message, {
        [field]: state.formatValue({
            month: "long"
        })
    }) : "";
    let descProps = (0, _utils.useDescription)(description);
    // If within a date picker or date range picker, the date field will have role="presentation" and an aria-describedby
    // will be passed in that references the value (e.g. entire range). Otherwise, add the field's value description.
    let describedBy = props[roleSymbol] === "presentation" ? fieldProps["aria-describedby"] : [
        descProps["aria-describedby"],
        fieldProps["aria-describedby"]
    ].filter(Boolean).join(" ") || undefined;
    let propsFocusManager = props[focusManagerSymbol];
    let focusManager = (0, _react.useMemo)(()=>propsFocusManager || (0, _focus.createFocusManager)(ref), [
        propsFocusManager,
        ref
    ]);
    let groupProps = (0, _useDatePickerGroup.useDatePickerGroup)(state, ref, props[roleSymbol] === "presentation");
    // Pass labels and other information to segments.
    hookData.set(state, {
        ariaLabel: props["aria-label"],
        ariaLabelledBy: [
            labelProps.id,
            props["aria-labelledby"]
        ].filter(Boolean).join(" ") || undefined,
        ariaDescribedBy: describedBy,
        focusManager
    });
    let autoFocusRef = (0, _react.useRef)(props.autoFocus);
    // When used within a date picker or date range picker, the field gets role="presentation"
    // rather than role="group". Since the date picker/date range picker already has a role="group"
    // with a label and description, and the segments are already labeled by this as well, this
    // avoids very verbose duplicate announcements.
    let fieldDOMProps;
    if (props[roleSymbol] === "presentation") fieldDOMProps = {
        role: "presentation"
    };
    else fieldDOMProps = (0, _utils.mergeProps)(fieldProps, {
        role: "group",
        "aria-disabled": props.isDisabled || undefined,
        "aria-describedby": describedBy
    });
    (0, _react.useEffect)(()=>{
        if (autoFocusRef.current) focusManager.focusFirst();
        autoFocusRef.current = false;
    }, [
        focusManager
    ]);
    (0, _utils.useFormReset)(props.inputRef, state.value, state.setValue);
    (0, _form.useFormValidation)({
        ...props,
        focus () {
            focusManager.focusFirst();
        }
    }, state, props.inputRef);
    let inputProps = {
        type: "hidden",
        name: props.name,
        value: ((_state_value = state.value) === null || _state_value === void 0 ? void 0 : _state_value.toString()) || ""
    };
    if (props.validationBehavior === "native") {
        // Use a hidden <input type="text"> rather than <input type="hidden">
        // so that an empty value blocks HTML form submission when the field is required.
        inputProps.type = "text";
        inputProps.hidden = true;
        inputProps.required = props.isRequired;
        // Ignore react warning.
        inputProps.onChange = ()=>{};
    }
    let domProps = (0, _utils.filterDOMProps)(props);
    return {
        labelProps: {
            ...labelProps,
            onClick: ()=>{
                focusManager.focusFirst();
            }
        },
        fieldProps: (0, _utils.mergeProps)(domProps, fieldDOMProps, groupProps, focusWithinProps, {
            onKeyDown (e) {
                if (props.onKeyDown) props.onKeyDown(e);
            },
            onKeyUp (e) {
                if (props.onKeyUp) props.onKeyUp(e);
            }
        }),
        inputProps,
        descriptionProps,
        errorMessageProps,
        isInvalid,
        validationErrors,
        validationDetails
    };
}
function useTimeField(props, state, ref) {
    var _state_timeValue;
    let res = useDateField(props, state, ref);
    res.inputProps.value = ((_state_timeValue = state.timeValue) === null || _state_timeValue === void 0 ? void 0 : _state_timeValue.toString()) || "";
    return res;
}

},{"@react-aria/focus":"42mbF","@react-aria/utils":"9cLk5","react":"9yzVZ","../intl/*.json":"dbj9t","./useDatePickerGroup":"bHFNB","@react-aria/label":"74Ccz","@react-aria/interactions":"ky3G8","@react-aria/form":"lerqa","@react-aria/i18n":"411rg","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"bHFNB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useDatePickerGroup", ()=>useDatePickerGroup);
var _focus = require("@react-aria/focus");
var _utils = require("@react-aria/utils");
var _react = require("react");
var _i18N = require("@react-aria/i18n");
var _interactions = require("@react-aria/interactions");
function useDatePickerGroup(state, ref, disableArrowNavigation) {
    let { direction } = (0, _i18N.useLocale)();
    let focusManager = (0, _react.useMemo)(()=>(0, _focus.createFocusManager)(ref), [
        ref
    ]);
    // Open the popover on alt + arrow down
    let onKeyDown = (e)=>{
        if (!e.currentTarget.contains(e.target)) return;
        if (e.altKey && (e.key === "ArrowDown" || e.key === "ArrowUp") && "setOpen" in state) {
            e.preventDefault();
            e.stopPropagation();
            state.setOpen(true);
        }
        if (disableArrowNavigation) return;
        switch(e.key){
            case "ArrowLeft":
                e.preventDefault();
                e.stopPropagation();
                if (direction === "rtl") focusManager.focusNext();
                else focusManager.focusPrevious();
                break;
            case "ArrowRight":
                e.preventDefault();
                e.stopPropagation();
                if (direction === "rtl") focusManager.focusPrevious();
                else focusManager.focusNext();
                break;
        }
    };
    // Focus the first placeholder segment from the end on mouse down/touch up in the field.
    let focusLast = ()=>{
        var _window_event;
        // Try to find the segment prior to the element that was clicked on.
        let target = (_window_event = window.event) === null || _window_event === void 0 ? void 0 : _window_event.target;
        let walker = (0, _focus.getFocusableTreeWalker)(ref.current, {
            tabbable: true
        });
        if (target) {
            walker.currentNode = target;
            target = walker.previousNode();
        }
        // If no target found, find the last element from the end.
        if (!target) {
            let last;
            do {
                last = walker.lastChild();
                if (last) target = last;
            }while (last);
        }
        // Now go backwards until we find an element that is not a placeholder.
        while(target === null || target === void 0 ? void 0 : target.hasAttribute("data-placeholder")){
            let prev = walker.previousNode();
            if (prev && prev.hasAttribute("data-placeholder")) target = prev;
            else break;
        }
        if (target) target.focus();
    };
    let { pressProps } = (0, _interactions.usePress)({
        preventFocusOnPress: true,
        allowTextSelectionOnPress: true,
        onPressStart (e) {
            if (e.pointerType === "mouse") focusLast();
        },
        onPress (e) {
            if (e.pointerType !== "mouse") focusLast();
        }
    });
    return (0, _utils.mergeProps)(pressProps, {
        onKeyDown
    });
}

},{"@react-aria/focus":"42mbF","@react-aria/utils":"9cLk5","react":"9yzVZ","@react-aria/i18n":"411rg","@react-aria/interactions":"ky3G8","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"9YG7r":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides the behavior and accessibility implementation for a segment in a date field.
 * A date segment displays an individual unit of a date and time, and allows users to edit
 * the value by typing or using the arrow keys to increment and decrement.
 */ parcelHelpers.export(exports, "useDateSegment", ()=>useDateSegment);
var _date = require("@internationalized/date");
var _utils = require("@react-aria/utils");
var _useDateField = require("./useDateField");
var _number = require("@internationalized/number");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _i18N = require("@react-aria/i18n");
var _useDisplayNames = require("./useDisplayNames");
var _spinbutton = require("@react-aria/spinbutton");
function useDateSegment(segment, state, ref) {
    let enteredKeys = (0, _react.useRef)("");
    let { locale } = (0, _i18N.useLocale)();
    let displayNames = (0, _useDisplayNames.useDisplayNames)();
    let { ariaLabel, ariaLabelledBy, ariaDescribedBy, focusManager } = (0, _useDateField.hookData).get(state);
    let textValue = segment.isPlaceholder ? "" : segment.text;
    let options = (0, _react.useMemo)(()=>state.dateFormatter.resolvedOptions(), [
        state.dateFormatter
    ]);
    let monthDateFormatter = (0, _i18N.useDateFormatter)({
        month: "long",
        timeZone: options.timeZone
    });
    let hourDateFormatter = (0, _i18N.useDateFormatter)({
        hour: "numeric",
        hour12: options.hour12,
        timeZone: options.timeZone
    });
    if (segment.type === "month" && !segment.isPlaceholder) {
        let monthTextValue = monthDateFormatter.format(state.dateValue);
        textValue = monthTextValue !== textValue ? `${textValue} \u{2013} ${monthTextValue}` : monthTextValue;
    } else if (segment.type === "hour" && !segment.isPlaceholder) textValue = hourDateFormatter.format(state.dateValue);
    let { spinButtonProps } = (0, _spinbutton.useSpinButton)({
        // The ARIA spec says aria-valuenow is optional if there's no value, but aXe seems to require it.
        // This doesn't seem to have any negative effects with real AT since we also use aria-valuetext.
        // https://github.com/dequelabs/axe-core/issues/3505
        value: segment.value,
        textValue,
        minValue: segment.minValue,
        maxValue: segment.maxValue,
        isDisabled: state.isDisabled,
        isReadOnly: state.isReadOnly || !segment.isEditable,
        isRequired: state.isRequired,
        onIncrement: ()=>{
            enteredKeys.current = "";
            state.increment(segment.type);
        },
        onDecrement: ()=>{
            enteredKeys.current = "";
            state.decrement(segment.type);
        },
        onIncrementPage: ()=>{
            enteredKeys.current = "";
            state.incrementPage(segment.type);
        },
        onDecrementPage: ()=>{
            enteredKeys.current = "";
            state.decrementPage(segment.type);
        },
        onIncrementToMax: ()=>{
            enteredKeys.current = "";
            state.setSegment(segment.type, segment.maxValue);
        },
        onDecrementToMin: ()=>{
            enteredKeys.current = "";
            state.setSegment(segment.type, segment.minValue);
        }
    });
    let parser = (0, _react.useMemo)(()=>new (0, _number.NumberParser)(locale, {
            maximumFractionDigits: 0
        }), [
        locale
    ]);
    let backspace = ()=>{
        if (parser.isValidPartialNumber(segment.text) && !state.isReadOnly && !segment.isPlaceholder) {
            let newValue = segment.text.slice(0, -1);
            let parsed = parser.parse(newValue);
            if (newValue.length === 0 || parsed === 0) state.clearSegment(segment.type);
            else state.setSegment(segment.type, parsed);
            enteredKeys.current = newValue;
        } else if (segment.type === "dayPeriod") state.clearSegment(segment.type);
    };
    let onKeyDown = (e)=>{
        // Firefox does not fire selectstart for Ctrl/Cmd + A
        // https://bugzilla.mozilla.org/show_bug.cgi?id=1742153
        if (e.key === "a" && ((0, _utils.isMac)() ? e.metaKey : e.ctrlKey)) e.preventDefault();
        if (e.ctrlKey || e.metaKey || e.shiftKey || e.altKey) return;
        switch(e.key){
            case "Backspace":
            case "Delete":
                // Safari on iOS does not fire beforeinput for the backspace key because the cursor is at the start.
                e.preventDefault();
                e.stopPropagation();
                backspace();
                break;
        }
    };
    // Safari dayPeriod option doesn't work...
    let { startsWith } = (0, _i18N.useFilter)({
        sensitivity: "base"
    });
    let amPmFormatter = (0, _i18N.useDateFormatter)({
        hour: "numeric",
        hour12: true
    });
    let am = (0, _react.useMemo)(()=>{
        let date = new Date();
        date.setHours(0);
        return amPmFormatter.formatToParts(date).find((part)=>part.type === "dayPeriod").value;
    }, [
        amPmFormatter
    ]);
    let pm = (0, _react.useMemo)(()=>{
        let date = new Date();
        date.setHours(12);
        return amPmFormatter.formatToParts(date).find((part)=>part.type === "dayPeriod").value;
    }, [
        amPmFormatter
    ]);
    // Get a list of formatted era names so users can type the first character to choose one.
    let eraFormatter = (0, _i18N.useDateFormatter)({
        year: "numeric",
        era: "narrow",
        timeZone: "UTC"
    });
    let eras = (0, _react.useMemo)(()=>{
        if (segment.type !== "era") return [];
        let date = (0, _date.toCalendar)(new (0, _date.CalendarDate)(1, 1, 1), state.calendar);
        let eras = state.calendar.getEras().map((era)=>{
            let eraDate = date.set({
                year: 1,
                month: 1,
                day: 1,
                era
            }).toDate("UTC");
            let parts = eraFormatter.formatToParts(eraDate);
            let formatted = parts.find((p)=>p.type === "era").value;
            return {
                era,
                formatted
            };
        });
        // Remove the common prefix from formatted values. This is so that in calendars with eras like
        // ERA0 and ERA1 (e.g. Ethiopic), users can press "0" and "1" to select an era. In other cases,
        // the first letter is used.
        let prefixLength = commonPrefixLength(eras.map((era)=>era.formatted));
        if (prefixLength) for (let era of eras)era.formatted = era.formatted.slice(prefixLength);
        return eras;
    }, [
        eraFormatter,
        state.calendar,
        segment.type
    ]);
    let onInput = (key)=>{
        if (state.isDisabled || state.isReadOnly) return;
        let newValue = enteredKeys.current + key;
        switch(segment.type){
            case "dayPeriod":
                if (startsWith(am, key)) state.setSegment("dayPeriod", 0);
                else if (startsWith(pm, key)) state.setSegment("dayPeriod", 12);
                else break;
                focusManager.focusNext();
                break;
            case "era":
                {
                    let matched = eras.find((e)=>startsWith(e.formatted, key));
                    if (matched) {
                        state.setSegment("era", matched.era);
                        focusManager.focusNext();
                    }
                    break;
                }
            case "day":
            case "hour":
            case "minute":
            case "second":
            case "month":
            case "year":
                {
                    if (!parser.isValidPartialNumber(newValue)) return;
                    let numberValue = parser.parse(newValue);
                    let segmentValue = numberValue;
                    let allowsZero = segment.minValue === 0;
                    if (segment.type === "hour" && state.dateFormatter.resolvedOptions().hour12) {
                        switch(state.dateFormatter.resolvedOptions().hourCycle){
                            case "h11":
                                if (numberValue > 11) segmentValue = parser.parse(key);
                                break;
                            case "h12":
                                allowsZero = false;
                                if (numberValue > 12) segmentValue = parser.parse(key);
                                break;
                        }
                        if (segment.value >= 12 && numberValue > 1) numberValue += 12;
                    } else if (numberValue > segment.maxValue) segmentValue = parser.parse(key);
                    if (isNaN(numberValue)) return;
                    let shouldSetValue = segmentValue !== 0 || allowsZero;
                    if (shouldSetValue) state.setSegment(segment.type, segmentValue);
                    if (Number(numberValue + "0") > segment.maxValue || newValue.length >= String(segment.maxValue).length) {
                        enteredKeys.current = "";
                        if (shouldSetValue) focusManager.focusNext();
                    } else enteredKeys.current = newValue;
                    break;
                }
        }
    };
    let onFocus = ()=>{
        enteredKeys.current = "";
        (0, _utils.scrollIntoViewport)(ref.current, {
            containingElement: (0, _utils.getScrollParent)(ref.current)
        });
        // Collapse selection to start or Chrome won't fire input events.
        let selection = window.getSelection();
        selection.collapse(ref.current);
    };
    let compositionRef = (0, _react.useRef)("");
    // @ts-ignore - TODO: possibly old TS version? doesn't fail in my editor...
    (0, _utils.useEvent)(ref, "beforeinput", (e)=>{
        e.preventDefault();
        switch(e.inputType){
            case "deleteContentBackward":
            case "deleteContentForward":
                if (parser.isValidPartialNumber(segment.text) && !state.isReadOnly) backspace();
                break;
            case "insertCompositionText":
                // insertCompositionText cannot be canceled.
                // Record the current state of the element so we can restore it in the `input` event below.
                compositionRef.current = ref.current.textContent;
                // Safari gets stuck in a composition state unless we also assign to the value here.
                // eslint-disable-next-line no-self-assign
                ref.current.textContent = ref.current.textContent;
                break;
            default:
                if (e.data != null) onInput(e.data);
                break;
        }
    });
    (0, _utils.useEvent)(ref, "input", (e)=>{
        let { inputType, data } = e;
        switch(inputType){
            case "insertCompositionText":
                // Reset the DOM to how it was in the beforeinput event.
                ref.current.textContent = compositionRef.current;
                // Android sometimes fires key presses of letters as composition events. Need to handle am/pm keys here too.
                // Can also happen e.g. with Pinyin keyboard on iOS.
                if (startsWith(am, data) || startsWith(pm, data)) onInput(data);
                break;
        }
    });
    (0, _utils.useLayoutEffect)(()=>{
        let element = ref.current;
        return ()=>{
            // If the focused segment is removed, focus the previous one, or the next one if there was no previous one.
            if (document.activeElement === element) {
                let prev = focusManager.focusPrevious();
                if (!prev) focusManager.focusNext();
            }
        };
    }, [
        ref,
        focusManager
    ]);
    // spinbuttons cannot be focused with VoiceOver on iOS.
    let touchPropOverrides = (0, _utils.isIOS)() || segment.type === "timeZoneName" ? {
        role: "textbox",
        "aria-valuemax": null,
        "aria-valuemin": null,
        "aria-valuetext": null,
        "aria-valuenow": null
    } : {};
    // Only apply aria-describedby to the first segment, unless the field is invalid. This avoids it being
    // read every time the user navigates to a new segment.
    let firstSegment = (0, _react.useMemo)(()=>state.segments.find((s)=>s.isEditable), [
        state.segments
    ]);
    if (segment !== firstSegment && !state.isInvalid) ariaDescribedBy = undefined;
    let id = (0, _utils.useId)();
    let isEditable = !state.isDisabled && !state.isReadOnly && segment.isEditable;
    // Prepend the label passed from the field to each segment name.
    // This is needed because VoiceOver on iOS does not announce groups.
    let name = segment.type === "literal" ? "" : displayNames.of(segment.type);
    let labelProps = (0, _utils.useLabels)({
        "aria-label": `${name}${ariaLabel ? `, ${ariaLabel}` : ""}${ariaLabelledBy ? ", " : ""}`,
        "aria-labelledby": ariaLabelledBy
    });
    // Literal segments should not be visible to screen readers. We don't really need any of the above,
    // but the rules of hooks mean hooks cannot be conditional so we have to put this condition here.
    if (segment.type === "literal") return {
        segmentProps: {
            "aria-hidden": true
        }
    };
    return {
        segmentProps: (0, _utils.mergeProps)(spinButtonProps, labelProps, {
            id,
            ...touchPropOverrides,
            "aria-invalid": state.isInvalid ? "true" : undefined,
            "aria-describedby": ariaDescribedBy,
            "aria-readonly": state.isReadOnly || !segment.isEditable ? "true" : undefined,
            "data-placeholder": segment.isPlaceholder || undefined,
            contentEditable: isEditable,
            suppressContentEditableWarning: isEditable,
            spellCheck: isEditable ? "false" : undefined,
            autoCapitalize: isEditable ? "off" : undefined,
            autoCorrect: isEditable ? "off" : undefined,
            // Capitalization was changed in React 17...
            [parseInt((0, _reactDefault.default).version, 10) >= 17 ? "enterKeyHint" : "enterkeyhint"]: isEditable ? "next" : undefined,
            inputMode: state.isDisabled || segment.type === "dayPeriod" || segment.type === "era" || !isEditable ? undefined : "numeric",
            tabIndex: state.isDisabled ? undefined : 0,
            onKeyDown,
            onFocus,
            style: {
                caretColor: "transparent"
            },
            // Prevent pointer events from reaching useDatePickerGroup, and allow native browser behavior to focus the segment.
            onPointerDown (e) {
                e.stopPropagation();
            },
            onMouseDown (e) {
                e.stopPropagation();
            }
        })
    };
}
function commonPrefixLength(strings) {
    // Sort the strings, and compare the characters in the first and last to find the common prefix.
    strings.sort();
    let first = strings[0];
    let last = strings[strings.length - 1];
    for(let i = 0; i < first.length; i++){
        if (first[i] !== last[i]) return i;
    }
    return 0;
}

},{"@internationalized/date":"hesBk","@react-aria/utils":"9cLk5","./useDateField":"fp6Rt","@internationalized/number":"h1VQt","react":"9yzVZ","@react-aria/i18n":"411rg","./useDisplayNames":"lK4F6","@react-aria/spinbutton":"3vYfp","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"lK4F6":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // @ts-ignore
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/** @private */ parcelHelpers.export(exports, "useDisplayNames", ()=>useDisplayNames);
var _json = require("../intl/*.json");
var _jsonDefault = parcelHelpers.interopDefault(_json);
var _i18N = require("@react-aria/i18n");
var _react = require("react");
function useDisplayNames() {
    let { locale } = (0, _i18N.useLocale)();
    let dictionary = (0, _i18N.useLocalizedStringDictionary)((0, _jsonDefault.default), "@react-aria/datepicker");
    return (0, _react.useMemo)(()=>{
        // Try to use Intl.DisplayNames if possible. It may be supported in browsers, but not support the dateTimeField
        // type as that was only added in v2. https://github.com/tc39/intl-displaynames-v2
        try {
            // @ts-ignore
            return new Intl.DisplayNames(locale, {
                type: "dateTimeField"
            });
        } catch (err) {
            return new DisplayNamesPolyfill(locale, dictionary);
        }
    }, [
        locale,
        dictionary
    ]);
}
class DisplayNamesPolyfill {
    of(field) {
        return this.dictionary.getStringForLocale(field, this.locale);
    }
    constructor(locale, dictionary){
        this.locale = locale;
        this.dictionary = dictionary;
    }
}

},{"../intl/*.json":"dbj9t","@react-aria/i18n":"411rg","react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"3vYfp":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useSpinButton", ()=>(0, _useSpinButton.useSpinButton));
var _useSpinButton = require("./useSpinButton");

},{"./useSpinButton":"cCLsD","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"cCLsD":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useSpinButton", ()=>useSpinButton);
var _liveAnnouncer = require("@react-aria/live-announcer");
// @ts-ignore
var _json = require("../intl/*.json");
var _jsonDefault = parcelHelpers.interopDefault(_json);
var _react = require("react");
var _utils = require("@react-aria/utils");
var _i18N = require("@react-aria/i18n");
function useSpinButton(props) {
    const _async = (0, _react.useRef)();
    let { value, textValue, minValue, maxValue, isDisabled, isReadOnly, isRequired, onIncrement, onIncrementPage, onDecrement, onDecrementPage, onDecrementToMin, onIncrementToMax } = props;
    const stringFormatter = (0, _i18N.useLocalizedStringFormatter)((0, _jsonDefault.default), "@react-aria/spinbutton");
    const clearAsync = ()=>clearTimeout(_async.current);
    // eslint-disable-next-line arrow-body-style
    (0, _react.useEffect)(()=>{
        return ()=>clearAsync();
    }, []);
    let onKeyDown = (e)=>{
        if (e.ctrlKey || e.metaKey || e.shiftKey || e.altKey || isReadOnly) return;
        switch(e.key){
            case "PageUp":
                if (onIncrementPage) {
                    e.preventDefault();
                    onIncrementPage === null || onIncrementPage === void 0 ? void 0 : onIncrementPage();
                    break;
                }
            // fallthrough!
            case "ArrowUp":
            case "Up":
                if (onIncrement) {
                    e.preventDefault();
                    onIncrement === null || onIncrement === void 0 ? void 0 : onIncrement();
                }
                break;
            case "PageDown":
                if (onDecrementPage) {
                    e.preventDefault();
                    onDecrementPage === null || onDecrementPage === void 0 ? void 0 : onDecrementPage();
                    break;
                }
            // fallthrough
            case "ArrowDown":
            case "Down":
                if (onDecrement) {
                    e.preventDefault();
                    onDecrement === null || onDecrement === void 0 ? void 0 : onDecrement();
                }
                break;
            case "Home":
                if (onDecrementToMin) {
                    e.preventDefault();
                    onDecrementToMin === null || onDecrementToMin === void 0 ? void 0 : onDecrementToMin();
                }
                break;
            case "End":
                if (onIncrementToMax) {
                    e.preventDefault();
                    onIncrementToMax === null || onIncrementToMax === void 0 ? void 0 : onIncrementToMax();
                }
                break;
        }
    };
    let isFocused = (0, _react.useRef)(false);
    let onFocus = ()=>{
        isFocused.current = true;
    };
    let onBlur = ()=>{
        isFocused.current = false;
    };
    // Replace Unicode hyphen-minus (U+002D) with minus sign (U+2212).
    // This ensures that macOS VoiceOver announces it as "minus" even with other characters between the minus sign
    // and the number (e.g. currency symbol). Otherwise it announces nothing because it assumes the character is a hyphen.
    // In addition, replace the empty string with the word "Empty" so that iOS VoiceOver does not read "50%" for an empty field.
    let ariaTextValue = textValue === "" ? stringFormatter.format("Empty") : (textValue || `${value}`).replace("-", "\u2212");
    (0, _react.useEffect)(()=>{
        if (isFocused.current) {
            (0, _liveAnnouncer.clearAnnouncer)("assertive");
            (0, _liveAnnouncer.announce)(ariaTextValue, "assertive");
        }
    }, [
        ariaTextValue
    ]);
    const onIncrementPressStart = (0, _utils.useEffectEvent)((initialStepDelay)=>{
        clearAsync();
        onIncrement === null || onIncrement === void 0 ? void 0 : onIncrement();
        // Start spinning after initial delay
        _async.current = window.setTimeout(()=>{
            if (maxValue === undefined || isNaN(maxValue) || value === undefined || isNaN(value) || value < maxValue) onIncrementPressStart(60);
        }, initialStepDelay);
    });
    const onDecrementPressStart = (0, _utils.useEffectEvent)((initialStepDelay)=>{
        clearAsync();
        onDecrement === null || onDecrement === void 0 ? void 0 : onDecrement();
        // Start spinning after initial delay
        _async.current = window.setTimeout(()=>{
            if (minValue === undefined || isNaN(minValue) || value === undefined || isNaN(value) || value > minValue) onDecrementPressStart(60);
        }, initialStepDelay);
    });
    let cancelContextMenu = (e)=>{
        e.preventDefault();
    };
    let { addGlobalListener, removeAllGlobalListeners } = (0, _utils.useGlobalListeners)();
    return {
        spinButtonProps: {
            role: "spinbutton",
            "aria-valuenow": value !== undefined && !isNaN(value) ? value : undefined,
            "aria-valuetext": ariaTextValue,
            "aria-valuemin": minValue,
            "aria-valuemax": maxValue,
            "aria-disabled": isDisabled || undefined,
            "aria-readonly": isReadOnly || undefined,
            "aria-required": isRequired || undefined,
            onKeyDown,
            onFocus,
            onBlur
        },
        incrementButtonProps: {
            onPressStart: ()=>{
                onIncrementPressStart(400);
                addGlobalListener(window, "contextmenu", cancelContextMenu);
            },
            onPressEnd: ()=>{
                clearAsync();
                removeAllGlobalListeners();
            },
            onFocus,
            onBlur
        },
        decrementButtonProps: {
            onPressStart: ()=>{
                onDecrementPressStart(400);
                addGlobalListener(window, "contextmenu", cancelContextMenu);
            },
            onPressEnd: ()=>{
                clearAsync();
                removeAllGlobalListeners();
            },
            onFocus,
            onBlur
        }
    };
}

},{"@react-aria/live-announcer":"ipdGY","../intl/*.json":"gHKp4","react":"9yzVZ","@react-aria/utils":"9cLk5","@react-aria/i18n":"411rg","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"gHKp4":[function(require,module,exports) {
const _temp0 = require("e2e6d1d7a87a1068");
const _temp1 = require("414310b71025b887");
const _temp2 = require("dd0bafaf5c4a28a0");
const _temp3 = require("d2283b80c234f014");
const _temp4 = require("d6fc1bb7dc8d85b6");
const _temp5 = require("987c7b64af92b3ee");
const _temp6 = require("4913d7132bdfb41d");
const _temp7 = require("a35b1e4258964a66");
const _temp8 = require("940c5203fdf29b00");
const _temp9 = require("119bf55e15c9b210");
const _temp10 = require("a351320a90199fa8");
const _temp11 = require("4c64342ad3ffb260");
const _temp12 = require("728b38d585aad9ed");
const _temp13 = require("d98e674722b576b");
const _temp14 = require("ca759f97e288298");
const _temp15 = require("26928643ba133bc9");
const _temp16 = require("961db255eefe7a9f");
const _temp17 = require("1ade1a0dc3049a27");
const _temp18 = require("c5da72b6c86d5c04");
const _temp19 = require("9dfd0fe49cf3eca8");
const _temp20 = require("5e5bcd1106669804");
const _temp21 = require("dff99ce707b4bb16");
const _temp22 = require("c2032c1e6e3207c2");
const _temp23 = require("8239762010d814c7");
const _temp24 = require("bc9973caf80807ee");
const _temp25 = require("691b643538992d8a");
const _temp26 = require("2d1cae8f1f1a9a7f");
const _temp27 = require("9a3ea1aef8a494a0");
const _temp28 = require("ffd904f000e76fe5");
const _temp29 = require("d5213dfa06f5f7c0");
const _temp30 = require("e79acbf5257f7402");
const _temp31 = require("845d11885c368d14");
const _temp32 = require("1ae1cd48ea8c602");
const _temp33 = require("6f695e77df35ff14");
module.exports = {
    "ar-AE": _temp0,
    "bg-BG": _temp1,
    "cs-CZ": _temp2,
    "da-DK": _temp3,
    "de-DE": _temp4,
    "el-GR": _temp5,
    "en-US": _temp6,
    "es-ES": _temp7,
    "et-EE": _temp8,
    "fi-FI": _temp9,
    "fr-FR": _temp10,
    "he-IL": _temp11,
    "hr-HR": _temp12,
    "hu-HU": _temp13,
    "it-IT": _temp14,
    "ja-JP": _temp15,
    "ko-KR": _temp16,
    "lt-LT": _temp17,
    "lv-LV": _temp18,
    "nb-NO": _temp19,
    "nl-NL": _temp20,
    "pl-PL": _temp21,
    "pt-BR": _temp22,
    "pt-PT": _temp23,
    "ro-RO": _temp24,
    "ru-RU": _temp25,
    "sk-SK": _temp26,
    "sl-SI": _temp27,
    "sr-SP": _temp28,
    "sv-SE": _temp29,
    "tr-TR": _temp30,
    "uk-UA": _temp31,
    "zh-CN": _temp32,
    "zh-TW": _temp33
};

},{"e2e6d1d7a87a1068":"5TkYZ","414310b71025b887":"ezpNf","dd0bafaf5c4a28a0":"lc1pv","d2283b80c234f014":"18c0T","d6fc1bb7dc8d85b6":"a6ZiD","987c7b64af92b3ee":"cxtx4","4913d7132bdfb41d":"kM7Ah","a35b1e4258964a66":"69IU8","940c5203fdf29b00":"kxU9F","119bf55e15c9b210":"jYMTA","a351320a90199fa8":"1SnsU","4c64342ad3ffb260":"fuykV","728b38d585aad9ed":"iaMzb","d98e674722b576b":"c2Ipw","ca759f97e288298":"l4Puo","26928643ba133bc9":"eSWOv","961db255eefe7a9f":"bHk2J","1ade1a0dc3049a27":"4VgrP","c5da72b6c86d5c04":"lEJKy","9dfd0fe49cf3eca8":"lkRfE","5e5bcd1106669804":"bxuPC","dff99ce707b4bb16":"kDhJM","c2032c1e6e3207c2":"6JXQ5","8239762010d814c7":"dDukW","bc9973caf80807ee":"5zbwC","691b643538992d8a":"huabR","2d1cae8f1f1a9a7f":"8jlzh","9a3ea1aef8a494a0":"9ZU5l","ffd904f000e76fe5":"lFCFO","d5213dfa06f5f7c0":"3nEdp","e79acbf5257f7402":"1vEzO","845d11885c368d14":"kJEP9","1ae1cd48ea8c602":"kpf5m","6f695e77df35ff14":"6HufI"}],"5TkYZ":[function(require,module,exports) {
module.exports = {
    "Empty": `\u{641}\u{627}\u{631}\u{63A}`
};

},{}],"ezpNf":[function(require,module,exports) {
module.exports = {
    "Empty": `\u{418}\u{437}\u{43F}\u{440}\u{430}\u{437}\u{43D}\u{438}`
};

},{}],"lc1pv":[function(require,module,exports) {
module.exports = {
    "Empty": `Pr\xe1zdn\xe9`
};

},{}],"18c0T":[function(require,module,exports) {
module.exports = {
    "Empty": `Tom`
};

},{}],"a6ZiD":[function(require,module,exports) {
module.exports = {
    "Empty": `Leer`
};

},{}],"cxtx4":[function(require,module,exports) {
module.exports = {
    "Empty": `\u{386}\u{3B4}\u{3B5}\u{3B9}\u{3BF}`
};

},{}],"kM7Ah":[function(require,module,exports) {
module.exports = {
    "Empty": `Empty`
};

},{}],"69IU8":[function(require,module,exports) {
module.exports = {
    "Empty": `Vac\xedo`
};

},{}],"kxU9F":[function(require,module,exports) {
module.exports = {
    "Empty": `T\xfchjenda`
};

},{}],"jYMTA":[function(require,module,exports) {
module.exports = {
    "Empty": `Tyhj\xe4`
};

},{}],"1SnsU":[function(require,module,exports) {
module.exports = {
    "Empty": `Vide`
};

},{}],"fuykV":[function(require,module,exports) {
module.exports = {
    "Empty": `\u{5E8}\u{5D9}\u{5E7}`
};

},{}],"iaMzb":[function(require,module,exports) {
module.exports = {
    "Empty": `Prazno`
};

},{}],"c2Ipw":[function(require,module,exports) {
module.exports = {
    "Empty": `\xdcres`
};

},{}],"l4Puo":[function(require,module,exports) {
module.exports = {
    "Empty": `Vuoto`
};

},{}],"eSWOv":[function(require,module,exports) {
module.exports = {
    "Empty": `\u{7A7A}`
};

},{}],"bHk2J":[function(require,module,exports) {
module.exports = {
    "Empty": `\u{BE44}\u{C5B4} \u{C788}\u{C74C}`
};

},{}],"4VgrP":[function(require,module,exports) {
module.exports = {
    "Empty": `Tu\u{161}\u{10D}ias`
};

},{}],"lEJKy":[function(require,module,exports) {
module.exports = {
    "Empty": `Tuk\u{161}s`
};

},{}],"lkRfE":[function(require,module,exports) {
module.exports = {
    "Empty": `Tom`
};

},{}],"bxuPC":[function(require,module,exports) {
module.exports = {
    "Empty": `Leeg`
};

},{}],"kDhJM":[function(require,module,exports) {
module.exports = {
    "Empty": `Pusty`
};

},{}],"6JXQ5":[function(require,module,exports) {
module.exports = {
    "Empty": `Vazio`
};

},{}],"dDukW":[function(require,module,exports) {
module.exports = {
    "Empty": `Vazio`
};

},{}],"5zbwC":[function(require,module,exports) {
module.exports = {
    "Empty": `Gol`
};

},{}],"huabR":[function(require,module,exports) {
module.exports = {
    "Empty": `\u{41D}\u{435} \u{437}\u{430}\u{43F}\u{43E}\u{43B}\u{43D}\u{435}\u{43D}\u{43E}`
};

},{}],"8jlzh":[function(require,module,exports) {
module.exports = {
    "Empty": `Pr\xe1zdne`
};

},{}],"9ZU5l":[function(require,module,exports) {
module.exports = {
    "Empty": `Prazen`
};

},{}],"lFCFO":[function(require,module,exports) {
module.exports = {
    "Empty": `Prazno`
};

},{}],"3nEdp":[function(require,module,exports) {
module.exports = {
    "Empty": `Tomt`
};

},{}],"1vEzO":[function(require,module,exports) {
module.exports = {
    "Empty": `Bo\u{15F}`
};

},{}],"kJEP9":[function(require,module,exports) {
module.exports = {
    "Empty": `\u{41F}\u{443}\u{441}\u{442}\u{43E}`
};

},{}],"kpf5m":[function(require,module,exports) {
module.exports = {
    "Empty": `\u{7A7A}`
};

},{}],"6HufI":[function(require,module,exports) {
module.exports = {
    "Empty": `\u{7A7A}\u{767D}`
};

},{}],"34COC":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides the behavior and accessibility implementation for a date picker component.
 * A date range picker combines two DateFields and a RangeCalendar popover to allow
 * users to enter or select a date and time range.
 */ parcelHelpers.export(exports, "useDateRangePicker", ()=>useDateRangePicker);
var _focus = require("@react-aria/focus");
var _form = require("@react-stately/form");
var _utils = require("@react-aria/utils");
var _useDateField = require("./useDateField");
// @ts-ignore
var _json = require("../intl/*.json");
var _jsonDefault = parcelHelpers.interopDefault(_json);
var _react = require("react");
var _useDatePickerGroup = require("./useDatePickerGroup");
var _label = require("@react-aria/label");
var _interactions = require("@react-aria/interactions");
var _i18N = require("@react-aria/i18n");
function useDateRangePicker(props, state, ref) {
    var _state_value, _state_value1;
    let stringFormatter = (0, _i18N.useLocalizedStringFormatter)((0, _jsonDefault.default), "@react-aria/datepicker");
    let { isInvalid, validationErrors, validationDetails } = state.displayValidation;
    let { labelProps, fieldProps, descriptionProps, errorMessageProps } = (0, _label.useField)({
        ...props,
        labelElementType: "span",
        isInvalid,
        errorMessage: props.errorMessage || validationErrors
    });
    let labelledBy = fieldProps["aria-labelledby"] || fieldProps.id;
    let { locale } = (0, _i18N.useLocale)();
    let range = state.formatValue(locale, {
        month: "long"
    });
    let description = range ? stringFormatter.format("selectedRangeDescription", {
        startDate: range.start,
        endDate: range.end
    }) : "";
    let descProps = (0, _utils.useDescription)(description);
    let startFieldProps = {
        "aria-label": stringFormatter.format("startDate"),
        "aria-labelledby": labelledBy
    };
    let endFieldProps = {
        "aria-label": stringFormatter.format("endDate"),
        "aria-labelledby": labelledBy
    };
    let buttonId = (0, _utils.useId)();
    let dialogId = (0, _utils.useId)();
    let groupProps = (0, _useDatePickerGroup.useDatePickerGroup)(state, ref);
    let ariaDescribedBy = [
        descProps["aria-describedby"],
        fieldProps["aria-describedby"]
    ].filter(Boolean).join(" ") || undefined;
    let focusManager = (0, _react.useMemo)(()=>(0, _focus.createFocusManager)(ref, {
            // Exclude the button from the focus manager.
            accept: (element)=>element.id !== buttonId
        }), [
        ref,
        buttonId
    ]);
    let commonFieldProps = {
        [(0, _useDateField.focusManagerSymbol)]: focusManager,
        [(0, _useDateField.roleSymbol)]: "presentation",
        "aria-describedby": ariaDescribedBy,
        placeholderValue: props.placeholderValue,
        hideTimeZone: props.hideTimeZone,
        hourCycle: props.hourCycle,
        granularity: props.granularity,
        shouldForceLeadingZeros: props.shouldForceLeadingZeros,
        isDisabled: props.isDisabled,
        isReadOnly: props.isReadOnly,
        isRequired: props.isRequired,
        validationBehavior: props.validationBehavior
    };
    let domProps = (0, _utils.filterDOMProps)(props);
    let { focusWithinProps } = (0, _interactions.useFocusWithin)({
        ...props,
        isDisabled: state.isOpen,
        onBlurWithin: props.onBlur,
        onFocusWithin: props.onFocus,
        onFocusWithinChange: props.onFocusChange
    });
    let startFieldValidation = (0, _react.useRef)((0, _form.DEFAULT_VALIDATION_RESULT));
    let endFieldValidation = (0, _react.useRef)((0, _form.DEFAULT_VALIDATION_RESULT));
    return {
        groupProps: (0, _utils.mergeProps)(domProps, groupProps, fieldProps, descProps, focusWithinProps, {
            role: "group",
            "aria-disabled": props.isDisabled || null,
            "aria-describedby": ariaDescribedBy,
            onKeyDown (e) {
                if (state.isOpen) return;
                if (props.onKeyDown) props.onKeyDown(e);
            },
            onKeyUp (e) {
                if (state.isOpen) return;
                if (props.onKeyUp) props.onKeyUp(e);
            }
        }),
        labelProps: {
            ...labelProps,
            onClick: ()=>{
                focusManager.focusFirst();
            }
        },
        buttonProps: {
            ...descProps,
            id: buttonId,
            "aria-haspopup": "dialog",
            "aria-label": stringFormatter.format("calendar"),
            "aria-labelledby": `${buttonId} ${labelledBy}`,
            "aria-describedby": ariaDescribedBy,
            "aria-expanded": state.isOpen,
            isDisabled: props.isDisabled || props.isReadOnly,
            onPress: ()=>state.setOpen(true)
        },
        dialogProps: {
            id: dialogId,
            "aria-labelledby": `${buttonId} ${labelledBy}`
        },
        startFieldProps: {
            ...startFieldProps,
            ...commonFieldProps,
            value: (_state_value = state.value) === null || _state_value === void 0 ? void 0 : _state_value.start,
            onChange: (start)=>state.setDateTime("start", start),
            autoFocus: props.autoFocus,
            name: props.startName,
            [(0, _form.privateValidationStateProp)]: {
                realtimeValidation: state.realtimeValidation,
                displayValidation: state.displayValidation,
                updateValidation (e) {
                    startFieldValidation.current = e;
                    state.updateValidation((0, _form.mergeValidation)(e, endFieldValidation.current));
                },
                resetValidation: state.resetValidation,
                commitValidation: state.commitValidation
            }
        },
        endFieldProps: {
            ...endFieldProps,
            ...commonFieldProps,
            value: (_state_value1 = state.value) === null || _state_value1 === void 0 ? void 0 : _state_value1.end,
            onChange: (end)=>state.setDateTime("end", end),
            name: props.endName,
            [(0, _form.privateValidationStateProp)]: {
                realtimeValidation: state.realtimeValidation,
                displayValidation: state.displayValidation,
                updateValidation (e) {
                    endFieldValidation.current = e;
                    state.updateValidation((0, _form.mergeValidation)(startFieldValidation.current, e));
                },
                resetValidation: state.resetValidation,
                commitValidation: state.commitValidation
            }
        },
        descriptionProps,
        errorMessageProps,
        calendarProps: {
            autoFocus: true,
            value: state.dateRange,
            onChange: state.setDateRange,
            minValue: props.minValue,
            maxValue: props.maxValue,
            isDisabled: props.isDisabled,
            isReadOnly: props.isReadOnly,
            isDateUnavailable: props.isDateUnavailable,
            allowsNonContiguousRanges: props.allowsNonContiguousRanges,
            defaultFocusedValue: state.dateRange ? undefined : props.placeholderValue,
            isInvalid: state.isInvalid,
            errorMessage: typeof props.errorMessage === "function" ? props.errorMessage(state.displayValidation) : props.errorMessage || state.displayValidation.validationErrors.join(" ")
        },
        isInvalid,
        validationErrors,
        validationDetails
    };
}

},{"@react-aria/focus":"42mbF","@react-stately/form":"9yZqm","@react-aria/utils":"9cLk5","./useDateField":"fp6Rt","../intl/*.json":"dbj9t","react":"9yzVZ","./useDatePickerGroup":"bHFNB","@react-aria/label":"74Ccz","@react-aria/interactions":"ky3G8","@react-aria/i18n":"411rg","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"aSQNt":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useDialog", ()=>(0, _useDialog.useDialog));
var _useDialog = require("./useDialog");

},{"./useDialog":"qErst","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"qErst":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides the behavior and accessibility implementation for a dialog component.
 * A dialog is an overlay shown above other content in an application.
 */ parcelHelpers.export(exports, "useDialog", ()=>useDialog);
var _utils = require("@react-aria/utils");
var _focus = require("@react-aria/focus");
var _react = require("react");
var _overlays = require("@react-aria/overlays");
function useDialog(props, ref) {
    let { role = "dialog" } = props;
    let titleId = (0, _utils.useSlotId)();
    titleId = props["aria-label"] ? undefined : titleId;
    let isRefocusing = (0, _react.useRef)(false);
    // Focus the dialog itself on mount, unless a child element is already focused.
    (0, _react.useEffect)(()=>{
        if (ref.current && !ref.current.contains(document.activeElement)) {
            (0, _focus.focusSafely)(ref.current);
            // Safari on iOS does not move the VoiceOver cursor to the dialog
            // or announce that it has opened until it has rendered. A workaround
            // is to wait for half a second, then blur and re-focus the dialog.
            let timeout = setTimeout(()=>{
                if (document.activeElement === ref.current) {
                    isRefocusing.current = true;
                    if (ref.current) {
                        ref.current.blur();
                        (0, _focus.focusSafely)(ref.current);
                    }
                    isRefocusing.current = false;
                }
            }, 500);
            return ()=>{
                clearTimeout(timeout);
            };
        }
    }, [
        ref
    ]);
    (0, _overlays.useOverlayFocusContain)();
    // We do not use aria-modal due to a Safari bug which forces the first focusable element to be focused
    // on mount when inside an iframe, no matter which element we programmatically focus.
    // See https://bugs.webkit.org/show_bug.cgi?id=211934.
    // useModal sets aria-hidden on all elements outside the dialog, so the dialog will behave as a modal
    // even without aria-modal on the dialog itself.
    return {
        dialogProps: {
            ...(0, _utils.filterDOMProps)(props, {
                labelable: true
            }),
            role,
            tabIndex: -1,
            "aria-labelledby": props["aria-labelledby"] || titleId,
            // Prevent blur events from reaching useOverlay, which may cause
            // popovers to close. Since focus is contained within the dialog,
            // we don't want this to occur due to the above useEffect.
            onBlur: (e)=>{
                if (isRefocusing.current) e.stopPropagation();
            }
        },
        titleProps: {
            id: titleId
        }
    };
}

},{"@react-aria/utils":"9cLk5","@react-aria/focus":"42mbF","react":"9yzVZ","@react-aria/overlays":"5fTCg","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"hi3Sh":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DIRECTORY_DRAG_TYPE", ()=>(0, _utils.DIRECTORY_DRAG_TYPE));
parcelHelpers.export(exports, "useDrag", ()=>(0, _useDrag.useDrag));
parcelHelpers.export(exports, "useDrop", ()=>(0, _useDrop.useDrop));
parcelHelpers.export(exports, "useDroppableCollection", ()=>(0, _useDroppableCollection.useDroppableCollection));
parcelHelpers.export(exports, "useDroppableItem", ()=>(0, _useDroppableItem.useDroppableItem));
parcelHelpers.export(exports, "useDropIndicator", ()=>(0, _useDropIndicator.useDropIndicator));
parcelHelpers.export(exports, "useDraggableItem", ()=>(0, _useDraggableItem.useDraggableItem));
parcelHelpers.export(exports, "useDraggableCollection", ()=>(0, _useDraggableCollection.useDraggableCollection));
parcelHelpers.export(exports, "useClipboard", ()=>(0, _useClipboard.useClipboard));
parcelHelpers.export(exports, "DragPreview", ()=>(0, _dragPreview.DragPreview));
parcelHelpers.export(exports, "ListDropTargetDelegate", ()=>(0, _listDropTargetDelegate.ListDropTargetDelegate));
parcelHelpers.export(exports, "isVirtualDragging", ()=>(0, _dragManager.isVirtualDragging));
parcelHelpers.export(exports, "isDirectoryDropItem", ()=>(0, _utils.isDirectoryDropItem));
parcelHelpers.export(exports, "isFileDropItem", ()=>(0, _utils.isFileDropItem));
parcelHelpers.export(exports, "isTextDropItem", ()=>(0, _utils.isTextDropItem));
var _utils = require("./utils");
var _useDrag = require("./useDrag");
var _useDrop = require("./useDrop");
var _useDroppableCollection = require("./useDroppableCollection");
var _useDroppableItem = require("./useDroppableItem");
var _useDropIndicator = require("./useDropIndicator");
var _useDraggableItem = require("./useDraggableItem");
var _useDraggableCollection = require("./useDraggableCollection");
var _useClipboard = require("./useClipboard");
var _dragPreview = require("./DragPreview");
var _listDropTargetDelegate = require("./ListDropTargetDelegate");
var _dragManager = require("./DragManager");

},{"./utils":"8X8qs","./useDrag":"c3cpR","./useDrop":"atFXS","./useDroppableCollection":"Eomdz","./useDroppableItem":"gRoNP","./useDropIndicator":"c2K9X","./useDraggableItem":"IV6Ct","./useDraggableCollection":"gL8nv","./useClipboard":"6n6f2","./DragPreview":"dijBK","./ListDropTargetDelegate":"hPa8U","./DragManager":"j7vmC","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"8X8qs":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "droppableCollectionMap", ()=>droppableCollectionMap);
parcelHelpers.export(exports, "DIRECTORY_DRAG_TYPE", ()=>DIRECTORY_DRAG_TYPE);
parcelHelpers.export(exports, "getDroppableCollectionId", ()=>getDroppableCollectionId);
parcelHelpers.export(exports, "getDroppableCollectionRef", ()=>getDroppableCollectionRef);
parcelHelpers.export(exports, "getTypes", ()=>getTypes);
parcelHelpers.export(exports, "useDragModality", ()=>useDragModality);
parcelHelpers.export(exports, "getDragModality", ()=>getDragModality);
parcelHelpers.export(exports, "writeToDataTransfer", ()=>writeToDataTransfer);
parcelHelpers.export(exports, "DragTypes", ()=>DragTypes);
parcelHelpers.export(exports, "readFromDataTransfer", ()=>readFromDataTransfer);
/** Returns whether a drop item contains text data. */ parcelHelpers.export(exports, "isTextDropItem", ()=>isTextDropItem);
/** Returns whether a drop item is a file. */ parcelHelpers.export(exports, "isFileDropItem", ()=>isFileDropItem);
/** Returns whether a drop item is a directory. */ parcelHelpers.export(exports, "isDirectoryDropItem", ()=>isDirectoryDropItem);
parcelHelpers.export(exports, "globalDndState", ()=>globalDndState);
parcelHelpers.export(exports, "setDraggingCollectionRef", ()=>setDraggingCollectionRef);
parcelHelpers.export(exports, "setDraggingKeys", ()=>setDraggingKeys);
parcelHelpers.export(exports, "setDropCollectionRef", ()=>setDropCollectionRef);
parcelHelpers.export(exports, "clearGlobalDnDState", ()=>clearGlobalDnDState);
parcelHelpers.export(exports, "setGlobalDnDState", ()=>setGlobalDnDState);
// Util function to check if the current dragging collection ref is the same as the current targeted droppable collection ref.
// Allows a droppable ref arg in case the global drop collection ref hasn't been set
parcelHelpers.export(exports, "isInternalDropOperation", ()=>isInternalDropOperation);
parcelHelpers.export(exports, "globalDropEffect", ()=>globalDropEffect);
parcelHelpers.export(exports, "setGlobalDropEffect", ()=>setGlobalDropEffect);
parcelHelpers.export(exports, "globalAllowedDropOperations", ()=>globalAllowedDropOperations);
parcelHelpers.export(exports, "setGlobalAllowedDropOperations", ()=>setGlobalAllowedDropOperations);
var _constants = require("./constants");
var _interactions = require("@react-aria/interactions");
const droppableCollectionMap = new WeakMap();
const DIRECTORY_DRAG_TYPE = Symbol();
function getDroppableCollectionId(state) {
    let { id } = droppableCollectionMap.get(state);
    if (!id) throw new Error("Droppable item outside a droppable collection");
    return id;
}
function getDroppableCollectionRef(state) {
    let { ref } = droppableCollectionMap.get(state);
    if (!ref) throw new Error("Droppable item outside a droppable collection");
    return ref;
}
function getTypes(items) {
    let types = new Set();
    for (let item of items)for (let type of Object.keys(item))types.add(type);
    return types;
}
function mapModality(modality) {
    if (!modality) modality = "virtual";
    if (modality === "pointer") modality = "virtual";
    if (modality === "virtual" && typeof window !== "undefined" && "ontouchstart" in window) modality = "touch";
    return modality;
}
function useDragModality() {
    return mapModality((0, _interactions.useInteractionModality)());
}
function getDragModality() {
    return mapModality((0, _interactions.getInteractionModality)());
}
function writeToDataTransfer(dataTransfer, items) {
    // The data transfer API doesn't support more than one item of a given type at once.
    // In addition, only a small set of types are supported natively for transfer between applications.
    // We allow for both multiple items, as well as multiple representations of a single item.
    // In order to make our API work with the native API, we serialize all items to JSON and
    // store as a single native item. We only need to do this if there is more than one item
    // of the same type, or if an item has more than one representation. Otherwise the native
    // API is sufficient.
    //
    // The DataTransferItemList API also theoretically supports adding files, which would enable
    // dragging binary data out of the browser onto the user's desktop for example. Unfortunately,
    // this does not currently work in any browser, so it is not currently supported by our API.
    // See e.g. https://bugs.chromium.org/p/chromium/issues/detail?id=438479.
    let groupedByType = new Map();
    let needsCustomData = false;
    let customData = [];
    for (let item of items){
        let types = Object.keys(item);
        if (types.length > 1) needsCustomData = true;
        let dataByType = {};
        for (let type of types){
            let typeItems = groupedByType.get(type);
            if (!typeItems) {
                typeItems = [];
                groupedByType.set(type, typeItems);
            } else needsCustomData = true;
            let data = item[type];
            dataByType[type] = data;
            typeItems.push(data);
        }
        customData.push(dataByType);
    }
    for (let [type, items] of groupedByType)if ((0, _constants.NATIVE_DRAG_TYPES).has(type)) {
        // Only one item of a given type can be set on a data transfer.
        // Join all of the items together separated by newlines.
        let data = items.join("\n");
        dataTransfer.items.add(data, type);
    } else // Set data to the first item so we have access to the list of types.
    dataTransfer.items.add(items[0], type);
    if (needsCustomData) {
        let data = JSON.stringify(customData);
        dataTransfer.items.add(data, (0, _constants.CUSTOM_DRAG_TYPE));
    }
}
class DragTypes {
    has(type) {
        if (this.includesUnknownTypes || type === DIRECTORY_DRAG_TYPE && this.types.has((0, _constants.GENERIC_TYPE))) return true;
        return typeof type === "string" && this.types.has(type);
    }
    constructor(dataTransfer){
        this.types = new Set();
        let hasFiles = false;
        for (let item of dataTransfer.items)if (item.type !== (0, _constants.CUSTOM_DRAG_TYPE)) {
            if (item.kind === "file") hasFiles = true;
            if (item.type) this.types.add(item.type);
            else // Files with unknown types or extensions that don't map to a known mime type
            // are sometimes exposed as an empty string by the browser. Map to a generic
            // mime type instead. Note that this could also be a directory as there's no
            // way to determine if something is a file or directory until drop.
            this.types.add((0, _constants.GENERIC_TYPE));
        }
        // In Safari, when dragging files, the dataTransfer.items list is empty, but dataTransfer.types contains "Files".
        // Unfortunately, this doesn't tell us what types of files the user is dragging, so we need to assume that any
        // type the user checks for is included. See https://bugs.webkit.org/show_bug.cgi?id=223517.
        this.includesUnknownTypes = !hasFiles && dataTransfer.types.includes("Files");
    }
}
function readFromDataTransfer(dataTransfer) {
    let items = [];
    // If our custom drag type is available, use that. This is a JSON serialized
    // representation of all items in the drag, set when there are multiple items
    // of the same type, or an individual item has multiple representations.
    let hasCustomType = false;
    if (dataTransfer.types.includes((0, _constants.CUSTOM_DRAG_TYPE))) try {
        let data = dataTransfer.getData((0, _constants.CUSTOM_DRAG_TYPE));
        let parsed = JSON.parse(data);
        for (let item of parsed)items.push({
            kind: "text",
            types: new Set(Object.keys(item)),
            getText: (type)=>Promise.resolve(item[type])
        });
        hasCustomType = true;
    } catch (e) {
    // ignore
    }
    // Otherwise, map native drag items to items of a single representation.
    if (!hasCustomType) {
        let stringItems = new Map();
        for (let item of dataTransfer.items){
            if (item.kind === "string") // The data for all formats must be read here because the data transfer gets
            // cleared out after the event handler finishes. If the item has an empty string
            // as a type, the mime type is unknown. Map to a generic mime type instead.
            stringItems.set(item.type || (0, _constants.GENERIC_TYPE), dataTransfer.getData(item.type));
            else if (item.kind === "file") {
                // Despite the name, webkitGetAsEntry is also implemented in Firefox and Edge.
                // In the future, we may use getAsFileSystemHandle instead, but that's currently
                // only implemented in Chrome.
                if (typeof item.webkitGetAsEntry === "function") {
                    let entry = item.webkitGetAsEntry();
                    // eslint-disable-next-line max-depth
                    if (!entry) continue;
                    // eslint-disable-next-line max-depth
                    if (entry.isFile) items.push(createFileItem(item.getAsFile()));
                    else if (entry.isDirectory) items.push(createDirectoryItem(entry));
                } else // Assume it's a file.
                items.push(createFileItem(item.getAsFile()));
            }
        }
        // All string items are different representations of the same item. There's no way to have
        // multiple string items at once in the current DataTransfer API.
        if (stringItems.size > 0) items.push({
            kind: "text",
            types: new Set(stringItems.keys()),
            getText: (type)=>Promise.resolve(stringItems.get(type))
        });
    }
    return items;
}
function blobToString(blob) {
    if (typeof blob.text === "function") return blob.text();
    // Safari doesn't have the Blob#text() method yet...
    return new Promise((resolve, reject)=>{
        let reader = new FileReader;
        reader.onload = ()=>{
            resolve(reader.result);
        };
        reader.onerror = reject;
        reader.readAsText(blob);
    });
}
function createFileItem(file) {
    return {
        kind: "file",
        type: file.type || (0, _constants.GENERIC_TYPE),
        name: file.name,
        getText: ()=>blobToString(file),
        getFile: ()=>Promise.resolve(file)
    };
}
function createDirectoryItem(entry) {
    return {
        kind: "directory",
        name: entry.name,
        getEntries: ()=>getEntries(entry)
    };
}
async function* getEntries(item) {
    let reader = item.createReader();
    // We must call readEntries repeatedly because there may be a limit to the
    // number of entries that are returned at once.
    let entries;
    do {
        entries = await new Promise((resolve, reject)=>{
            reader.readEntries(resolve, reject);
        });
        for (let entry of entries){
            if (entry.isFile) {
                let file = await getEntryFile(entry);
                yield createFileItem(file);
            } else if (entry.isDirectory) yield createDirectoryItem(entry);
        }
    }while (entries.length > 0);
}
function getEntryFile(entry) {
    return new Promise((resolve, reject)=>entry.file(resolve, reject));
}
function isTextDropItem(dropItem) {
    return dropItem.kind === "text";
}
function isFileDropItem(dropItem) {
    return dropItem.kind === "file";
}
function isDirectoryDropItem(dropItem) {
    return dropItem.kind === "directory";
}
let globalDndState = {
    draggingKeys: new Set()
};
function setDraggingCollectionRef(ref) {
    globalDndState.draggingCollectionRef = ref;
}
function setDraggingKeys(keys) {
    globalDndState.draggingKeys = keys;
}
function setDropCollectionRef(ref) {
    globalDndState.dropCollectionRef = ref;
}
function clearGlobalDnDState() {
    globalDndState = {
        draggingKeys: new Set()
    };
}
function setGlobalDnDState(state) {
    globalDndState = state;
}
function isInternalDropOperation(ref) {
    let { draggingCollectionRef, dropCollectionRef } = globalDndState;
    return (draggingCollectionRef === null || draggingCollectionRef === void 0 ? void 0 : draggingCollectionRef.current) != null && draggingCollectionRef.current === ((ref === null || ref === void 0 ? void 0 : ref.current) || (dropCollectionRef === null || dropCollectionRef === void 0 ? void 0 : dropCollectionRef.current));
}
let globalDropEffect;
function setGlobalDropEffect(dropEffect) {
    globalDropEffect = dropEffect;
}
let globalAllowedDropOperations = (0, _constants.DROP_OPERATION).none;
function setGlobalAllowedDropOperations(o) {
    globalAllowedDropOperations = o;
}

},{"./constants":"1EQ3W","@react-aria/interactions":"ky3G8","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"1EQ3W":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DROP_OPERATION", ()=>DROP_OPERATION);
parcelHelpers.export(exports, "DROP_OPERATION_ALLOWED", ()=>DROP_OPERATION_ALLOWED);
parcelHelpers.export(exports, "EFFECT_ALLOWED", ()=>EFFECT_ALLOWED);
parcelHelpers.export(exports, "DROP_EFFECT", ()=>DROP_EFFECT);
parcelHelpers.export(exports, "DROP_EFFECT_TO_DROP_OPERATION", ()=>DROP_EFFECT_TO_DROP_OPERATION);
parcelHelpers.export(exports, "DROP_OPERATION_TO_DROP_EFFECT", ()=>DROP_OPERATION_TO_DROP_EFFECT);
parcelHelpers.export(exports, "NATIVE_DRAG_TYPES", ()=>NATIVE_DRAG_TYPES);
parcelHelpers.export(exports, "CUSTOM_DRAG_TYPE", ()=>CUSTOM_DRAG_TYPE);
parcelHelpers.export(exports, "GENERIC_TYPE", ()=>GENERIC_TYPE);
var DROP_OPERATION;
(function(DROP_OPERATION) {
    DROP_OPERATION[DROP_OPERATION["none"] = 0] = "none";
    DROP_OPERATION[DROP_OPERATION["cancel"] = 0] = "cancel";
    DROP_OPERATION[DROP_OPERATION["move"] = 1] = "move";
    DROP_OPERATION[DROP_OPERATION["copy"] = 2] = "copy";
    DROP_OPERATION[DROP_OPERATION["link"] = 4] = "link";
    DROP_OPERATION[DROP_OPERATION["all"] = 7] = "all";
})(DROP_OPERATION || (DROP_OPERATION = {}));
const DROP_OPERATION_ALLOWED = {
    ...DROP_OPERATION,
    copyMove: 3,
    copyLink: 6,
    linkMove: 5,
    all: 7,
    uninitialized: 7
};
const EFFECT_ALLOWED = invert(DROP_OPERATION_ALLOWED);
EFFECT_ALLOWED[7] = "all"; // ensure we don't map to 'uninitialized'.
const DROP_EFFECT = invert(DROP_OPERATION);
const DROP_EFFECT_TO_DROP_OPERATION = {
    none: "cancel",
    link: "link",
    copy: "copy",
    move: "move"
};
const DROP_OPERATION_TO_DROP_EFFECT = invert(DROP_EFFECT_TO_DROP_OPERATION);
function invert(object) {
    let res = {};
    for(let key in object)res[object[key]] = key;
    return res;
}
const NATIVE_DRAG_TYPES = new Set([
    "text/plain",
    "text/uri-list",
    "text/html"
]);
const CUSTOM_DRAG_TYPE = "application/vnd.react-aria.items+json";
const GENERIC_TYPE = "application/octet-stream";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"c3cpR":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Handles drag interactions for an element, with support for traditional mouse and touch
 * based drag and drop, in addition to full parity for keyboard and screen reader users.
 */ parcelHelpers.export(exports, "useDrag", ()=>useDrag);
var _react = require("react");
var _dragManager = require("./DragManager");
var _constants = require("./constants");
var _utils = require("./utils");
// @ts-ignore
var _json = require("../intl/*.json");
var _jsonDefault = parcelHelpers.interopDefault(_json);
var _utils1 = require("@react-aria/utils");
var _i18N = require("@react-aria/i18n");
const MESSAGES = {
    keyboard: {
        start: "dragDescriptionKeyboard",
        end: "endDragKeyboard"
    },
    touch: {
        start: "dragDescriptionTouch",
        end: "endDragTouch"
    },
    virtual: {
        start: "dragDescriptionVirtual",
        end: "endDragVirtual"
    }
};
function useDrag(options) {
    let { hasDragButton } = options;
    let stringFormatter = (0, _i18N.useLocalizedStringFormatter)((0, _jsonDefault.default), "@react-aria/dnd");
    let state = (0, _react.useRef)({
        options,
        x: 0,
        y: 0
    }).current;
    state.options = options;
    let isDraggingRef = (0, _react.useRef)(false);
    let [isDragging, setDraggingState] = (0, _react.useState)(false);
    let setDragging = (isDragging)=>{
        isDraggingRef.current = isDragging;
        setDraggingState(isDragging);
    };
    let { addGlobalListener, removeAllGlobalListeners } = (0, _utils1.useGlobalListeners)();
    let modalityOnPointerDown = (0, _react.useRef)(null);
    let onDragStart = (e)=>{
        var _options_preview;
        if (e.defaultPrevented) return;
        // Prevent the drag event from propagating to any parent draggables
        e.stopPropagation();
        // If this drag was initiated by a mobile screen reader (e.g. VoiceOver or TalkBack), enter virtual dragging mode.
        if (modalityOnPointerDown.current === "virtual") {
            e.preventDefault();
            startDragging(e.target);
            modalityOnPointerDown.current = null;
            return;
        }
        if (typeof options.onDragStart === "function") options.onDragStart({
            type: "dragstart",
            x: e.clientX,
            y: e.clientY
        });
        let items = options.getItems();
        (0, _utils.writeToDataTransfer)(e.dataTransfer, items);
        let allowed = (0, _constants.DROP_OPERATION).all;
        if (typeof options.getAllowedDropOperations === "function") {
            let allowedOperations = options.getAllowedDropOperations();
            allowed = (0, _constants.DROP_OPERATION).none;
            for (let operation of allowedOperations)allowed |= (0, _constants.DROP_OPERATION)[operation] || (0, _constants.DROP_OPERATION).none;
        }
        (0, _utils.setGlobalAllowedDropOperations)(allowed);
        e.dataTransfer.effectAllowed = (0, _constants.EFFECT_ALLOWED)[allowed] || "none";
        // If there is a preview option, use it to render a custom preview image that will
        // appear under the pointer while dragging. If not, the element itself is dragged by the browser.
        if (typeof ((_options_preview = options.preview) === null || _options_preview === void 0 ? void 0 : _options_preview.current) === "function") options.preview.current(items, (node)=>{
            // Compute the offset that the preview will appear under the mouse.
            // If possible, this is based on the point the user clicked on the target.
            // If the preview is much smaller, then just use the center point of the preview.
            let size = node.getBoundingClientRect();
            let rect = e.currentTarget.getBoundingClientRect();
            let x = e.clientX - rect.x;
            let y = e.clientY - rect.y;
            if (x > size.width || y > size.height) {
                x = size.width / 2;
                y = size.height / 2;
            }
            // Rounding height to an even number prevents blurry preview seen on some screens
            let height = 2 * Math.round(size.height / 2);
            node.style.height = `${height}px`;
            e.dataTransfer.setDragImage(node, x, y);
        });
        // Enforce that drops are handled by useDrop.
        addGlobalListener(window, "drop", (e)=>{
            e.preventDefault();
            e.stopPropagation();
            console.warn("Drags initiated from the React Aria useDrag hook may only be dropped on a target created with useDrop. This ensures that a keyboard and screen reader accessible alternative is available.");
        }, {
            once: true
        });
        state.x = e.clientX;
        state.y = e.clientY;
        // Wait a frame before we set dragging to true so that the browser has time to
        // render the preview image before we update the element that has been dragged.
        requestAnimationFrame(()=>{
            setDragging(true);
        });
    };
    let onDrag = (e)=>{
        // Prevent the drag event from propagating to any parent draggables
        e.stopPropagation();
        if (e.clientX === state.x && e.clientY === state.y) return;
        if (typeof options.onDragMove === "function") options.onDragMove({
            type: "dragmove",
            x: e.clientX,
            y: e.clientY
        });
        state.x = e.clientX;
        state.y = e.clientY;
    };
    let onDragEnd = (e)=>{
        // Prevent the drag event from propagating to any parent draggables
        e.stopPropagation();
        if (typeof options.onDragEnd === "function") {
            let event = {
                type: "dragend",
                x: e.clientX,
                y: e.clientY,
                dropOperation: (0, _constants.DROP_EFFECT_TO_DROP_OPERATION)[e.dataTransfer.dropEffect]
            };
            // Chrome Android always returns none as its dropEffect so we use the drop effect set in useDrop via
            // onDragEnter/onDragOver instead. https://bugs.chromium.org/p/chromium/issues/detail?id=1353951
            if (0, _utils.globalDropEffect) event.dropOperation = (0, _constants.DROP_EFFECT_TO_DROP_OPERATION)[0, _utils.globalDropEffect];
            options.onDragEnd(event);
        }
        setDragging(false);
        removeAllGlobalListeners();
        (0, _utils.setGlobalAllowedDropOperations)((0, _constants.DROP_OPERATION).none);
        (0, _utils.setGlobalDropEffect)(undefined);
    };
    // If the dragged element is removed from the DOM via onDrop, onDragEnd won't fire: https://bugzilla.mozilla.org/show_bug.cgi?id=460801
    // In this case, we need to manually call onDragEnd on cleanup
    // eslint-disable-next-line arrow-body-style
    (0, _utils1.useLayoutEffect)(()=>{
        return ()=>{
            if (isDraggingRef.current) {
                if (typeof state.options.onDragEnd === "function") {
                    let event = {
                        type: "dragend",
                        x: 0,
                        y: 0,
                        dropOperation: (0, _constants.DROP_EFFECT_TO_DROP_OPERATION)[(0, _utils.globalDropEffect) || "none"]
                    };
                    state.options.onDragEnd(event);
                }
                setDragging(false);
                (0, _utils.setGlobalAllowedDropOperations)((0, _constants.DROP_OPERATION).none);
                (0, _utils.setGlobalDropEffect)(undefined);
            }
        };
    }, [
        state
    ]);
    let onPress = (e)=>{
        if (e.pointerType !== "keyboard" && e.pointerType !== "virtual") return;
        startDragging(e.target);
    };
    let startDragging = (target)=>{
        if (typeof state.options.onDragStart === "function") {
            let rect = target.getBoundingClientRect();
            state.options.onDragStart({
                type: "dragstart",
                x: rect.x + rect.width / 2,
                y: rect.y + rect.height / 2
            });
        }
        _dragManager.beginDragging({
            element: target,
            items: state.options.getItems(),
            allowedDropOperations: typeof state.options.getAllowedDropOperations === "function" ? state.options.getAllowedDropOperations() : [
                "move",
                "copy",
                "link"
            ],
            onDragEnd (e) {
                setDragging(false);
                if (typeof state.options.onDragEnd === "function") state.options.onDragEnd(e);
            }
        }, stringFormatter);
        setDragging(true);
    };
    let modality = (0, _utils.useDragModality)();
    let message = !isDragging ? MESSAGES[modality].start : MESSAGES[modality].end;
    let descriptionProps = (0, _utils1.useDescription)(stringFormatter.format(message));
    let interactions;
    if (!hasDragButton) // If there's no separate button to trigger accessible drag and drop mode,
    // then add event handlers to the draggable element itself to start dragging.
    // For keyboard, we use the Enter key in a capturing listener to prevent other
    // events such as selection from also occurring. We attempt to infer whether a
    // pointer event (e.g. long press) came from a touch screen reader, and then initiate
    // dragging in the native onDragStart listener above.
    interactions = {
        ...descriptionProps,
        onPointerDown (e) {
            modalityOnPointerDown.current = (0, _utils1.isVirtualPointerEvent)(e.nativeEvent) ? "virtual" : e.pointerType;
            // Try to detect virtual drag passthrough gestures.
            if (e.width < 1 && e.height < 1) // iOS VoiceOver.
            modalityOnPointerDown.current = "virtual";
            else {
                let rect = e.currentTarget.getBoundingClientRect();
                let offsetX = e.clientX - rect.x;
                let offsetY = e.clientY - rect.y;
                let centerX = rect.width / 2;
                let centerY = rect.height / 2;
                if (Math.abs(offsetX - centerX) <= 0.5 && Math.abs(offsetY - centerY) <= 0.5) // Android TalkBack.
                modalityOnPointerDown.current = "virtual";
                else modalityOnPointerDown.current = e.pointerType;
            }
        },
        onKeyDownCapture (e) {
            if (e.target === e.currentTarget && e.key === "Enter") {
                e.preventDefault();
                e.stopPropagation();
            }
        },
        onKeyUpCapture (e) {
            if (e.target === e.currentTarget && e.key === "Enter") {
                e.preventDefault();
                e.stopPropagation();
                startDragging(e.target);
            }
        },
        onClick (e) {
            // Handle NVDA/JAWS in browse mode, and touch screen readers. In this case, no keyboard events are fired.
            if ((0, _utils1.isVirtualClick)(e.nativeEvent) || modalityOnPointerDown.current === "virtual") {
                e.preventDefault();
                e.stopPropagation();
                startDragging(e.target);
            }
        }
    };
    return {
        dragProps: {
            ...interactions,
            draggable: "true",
            onDragStart,
            onDrag,
            onDragEnd
        },
        dragButtonProps: {
            ...descriptionProps,
            onPress
        },
        isDragging
    };
}

},{"react":"9yzVZ","./DragManager":"j7vmC","./constants":"1EQ3W","./utils":"8X8qs","../intl/*.json":"3FI7M","@react-aria/utils":"9cLk5","@react-aria/i18n":"411rg","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"j7vmC":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "registerDropTarget", ()=>registerDropTarget);
parcelHelpers.export(exports, "registerDropItem", ()=>registerDropItem);
parcelHelpers.export(exports, "beginDragging", ()=>beginDragging);
parcelHelpers.export(exports, "useDragSession", ()=>useDragSession);
/** @private */ parcelHelpers.export(exports, "isVirtualDragging", ()=>isVirtualDragging);
parcelHelpers.export(exports, "isValidDropTarget", ()=>isValidDropTarget);
var _liveAnnouncer = require("@react-aria/live-announcer");
var _overlays = require("@react-aria/overlays");
var _reactDom = require("react-dom");
var _utils = require("./utils");
var _utils1 = require("@react-aria/utils");
var _react = require("react");
let dropTargets = new Map();
let dropItems = new Map();
let dragSession = null;
let subscriptions = new Set();
function registerDropTarget(target) {
    dropTargets.set(target.element, target);
    dragSession === null || dragSession === void 0 ? void 0 : dragSession.updateValidDropTargets();
    return ()=>{
        dropTargets.delete(target.element);
        dragSession === null || dragSession === void 0 ? void 0 : dragSession.updateValidDropTargets();
    };
}
function registerDropItem(item) {
    dropItems.set(item.element, item);
    return ()=>{
        dropItems.delete(item.element);
    };
}
function beginDragging(target, stringFormatter) {
    if (dragSession) throw new Error("Cannot begin dragging while already dragging");
    dragSession = new DragSession(target, stringFormatter);
    requestAnimationFrame(()=>{
        dragSession.setup();
        if ((0, _utils.getDragModality)() === "keyboard") dragSession.next();
    });
    for (let cb of subscriptions)cb();
}
function useDragSession() {
    let [session, setSession] = (0, _react.useState)(dragSession);
    (0, _react.useEffect)(()=>{
        let cb = ()=>setSession(dragSession);
        subscriptions.add(cb);
        return ()=>{
            subscriptions.delete(cb);
        };
    }, []);
    return session;
}
function isVirtualDragging() {
    return !!dragSession;
}
function endDragging() {
    dragSession = null;
    for (let cb of subscriptions)cb();
}
function isValidDropTarget(element) {
    for (let target of dropTargets.keys()){
        if (target.contains(element)) return true;
    }
    return false;
}
const CANCELED_EVENTS = [
    "pointerdown",
    "pointermove",
    "pointerenter",
    "pointerleave",
    "pointerover",
    "pointerout",
    "pointerup",
    "mousedown",
    "mousemove",
    "mouseenter",
    "mouseleave",
    "mouseover",
    "mouseout",
    "mouseup",
    "touchstart",
    "touchmove",
    "touchend",
    "focusin",
    "focusout"
];
const CLICK_EVENTS = [
    "pointerup",
    "mouseup",
    "touchend"
];
const MESSAGES = {
    keyboard: "dragStartedKeyboard",
    touch: "dragStartedTouch",
    virtual: "dragStartedVirtual"
};
class DragSession {
    setup() {
        document.addEventListener("keydown", this.onKeyDown, true);
        document.addEventListener("keyup", this.onKeyUp, true);
        window.addEventListener("focus", this.onFocus, true);
        window.addEventListener("blur", this.onBlur, true);
        document.addEventListener("click", this.onClick, true);
        document.addEventListener("pointerdown", this.onPointerDown, true);
        for (let event of CANCELED_EVENTS)document.addEventListener(event, this.cancelEvent, true);
        this.mutationObserver = new MutationObserver(()=>this.updateValidDropTargets());
        this.updateValidDropTargets();
        (0, _liveAnnouncer.announce)(this.stringFormatter.format(MESSAGES[(0, _utils.getDragModality)()]));
    }
    teardown() {
        document.removeEventListener("keydown", this.onKeyDown, true);
        document.removeEventListener("keyup", this.onKeyUp, true);
        window.removeEventListener("focus", this.onFocus, true);
        window.removeEventListener("blur", this.onBlur, true);
        document.removeEventListener("click", this.onClick, true);
        document.removeEventListener("pointerdown", this.onPointerDown, true);
        for (let event of CANCELED_EVENTS)document.removeEventListener(event, this.cancelEvent, true);
        this.mutationObserver.disconnect();
        this.restoreAriaHidden();
    }
    onKeyDown(e) {
        var _this_currentDropTarget;
        this.cancelEvent(e);
        if (e.key === "Escape") {
            this.cancel();
            return;
        }
        if (e.key === "Tab" && !(e.metaKey || e.altKey || e.ctrlKey)) {
            if (e.shiftKey) this.previous();
            else this.next();
        }
        if (typeof ((_this_currentDropTarget = this.currentDropTarget) === null || _this_currentDropTarget === void 0 ? void 0 : _this_currentDropTarget.onKeyDown) === "function") this.currentDropTarget.onKeyDown(e, this.dragTarget);
    }
    onKeyUp(e) {
        this.cancelEvent(e);
        if (e.key === "Enter") {
            if (e.altKey) this.activate();
            else this.drop();
        }
    }
    onFocus(e) {
        // Prevent focus events, except to the original drag target.
        if (e.target !== this.dragTarget.element) this.cancelEvent(e);
        // Ignore focus events on the window/document (JSDOM). Will be handled in onBlur, below.
        if (!(e.target instanceof HTMLElement) || e.target === this.dragTarget.element) return;
        let dropTarget = this.validDropTargets.find((target)=>target.element === e.target) || this.validDropTargets.find((target)=>target.element.contains(e.target));
        if (!dropTarget) {
            if (this.currentDropTarget) this.currentDropTarget.element.focus();
            else this.dragTarget.element.focus();
            return;
        }
        let item = dropItems.get(e.target);
        this.setCurrentDropTarget(dropTarget, item);
    }
    onBlur(e) {
        if (e.target !== this.dragTarget.element) this.cancelEvent(e);
        // If nothing is gaining focus, or e.relatedTarget is the window/document (JSDOM),
        // restore focus back to the current drop target if any, or the original drag target.
        if (!e.relatedTarget || !(e.relatedTarget instanceof HTMLElement)) {
            if (this.currentDropTarget) this.currentDropTarget.element.focus();
            else this.dragTarget.element.focus();
        }
    }
    onClick(e) {
        this.cancelEvent(e);
        if ((0, _utils1.isVirtualClick)(e) || this.isVirtualClick) {
            if (e.target === this.dragTarget.element) {
                this.cancel();
                return;
            }
            let dropTarget = this.validDropTargets.find((target)=>target.element.contains(e.target));
            if (dropTarget) {
                let item = dropItems.get(e.target);
                this.setCurrentDropTarget(dropTarget, item);
                this.drop(item);
            }
        }
    }
    onPointerDown(e) {
        // Android Talkback double tap has e.detail = 1 for onClick. Detect the virtual click in onPointerDown before onClick fires
        // so we can properly perform cancel and drop operations.
        this.cancelEvent(e);
        this.isVirtualClick = (0, _utils1.isVirtualPointerEvent)(e);
    }
    cancelEvent(e) {
        var _this_dragTarget;
        // Allow focusin and focusout on the drag target so focus ring works properly.
        if ((e.type === "focusin" || e.type === "focusout") && e.target === ((_this_dragTarget = this.dragTarget) === null || _this_dragTarget === void 0 ? void 0 : _this_dragTarget.element)) return;
        // Allow default for events that might cancel a click event
        if (!CLICK_EVENTS.includes(e.type)) e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
    }
    updateValidDropTargets() {
        if (!this.mutationObserver) return;
        this.mutationObserver.disconnect();
        if (this.restoreAriaHidden) this.restoreAriaHidden();
        this.validDropTargets = findValidDropTargets(this.dragTarget);
        // Shuffle drop target order based on starting drag target.
        if (this.validDropTargets.length > 0) {
            let nearestIndex = this.findNearestDropTarget();
            this.validDropTargets = [
                ...this.validDropTargets.slice(nearestIndex),
                ...this.validDropTargets.slice(0, nearestIndex)
            ];
        }
        if (this.currentDropTarget && !this.validDropTargets.includes(this.currentDropTarget)) this.setCurrentDropTarget(this.validDropTargets[0]);
        // Find valid drop items within collections
        let types = (0, _utils.getTypes)(this.dragTarget.items);
        let validDropItems = [
            ...dropItems.values()
        ].filter((item)=>{
            if (typeof item.getDropOperation === "function") return item.getDropOperation(types, this.dragTarget.allowedDropOperations) !== "cancel";
            return true;
        });
        // Filter out drop targets that contain valid items. We don't want to stop hiding elements
        // other than the drop items that exist inside the collection.
        let visibleDropTargets = this.validDropTargets.filter((target)=>!validDropItems.some((item)=>target.element.contains(item.element)));
        this.restoreAriaHidden = (0, _overlays.ariaHideOutside)([
            this.dragTarget.element,
            ...validDropItems.map((item)=>item.element),
            ...visibleDropTargets.map((target)=>target.element)
        ]);
        this.mutationObserver.observe(document.body, {
            subtree: true,
            attributes: true,
            attributeFilter: [
                "aria-hidden"
            ]
        });
    }
    next() {
        if (!this.currentDropTarget) {
            this.setCurrentDropTarget(this.validDropTargets[0]);
            return;
        }
        let index = this.validDropTargets.indexOf(this.currentDropTarget);
        if (index < 0) {
            this.setCurrentDropTarget(this.validDropTargets[0]);
            return;
        }
        // If we've reached the end of the valid drop targets, cycle back to the original drag target.
        // This lets the user cancel the drag in case they don't have an Escape key (e.g. iPad keyboard case).
        if (index === this.validDropTargets.length - 1) {
            if (!this.dragTarget.element.closest('[aria-hidden="true"]')) {
                this.setCurrentDropTarget(null);
                this.dragTarget.element.focus();
            } else this.setCurrentDropTarget(this.validDropTargets[0]);
        } else this.setCurrentDropTarget(this.validDropTargets[index + 1]);
    }
    previous() {
        if (!this.currentDropTarget) {
            this.setCurrentDropTarget(this.validDropTargets[this.validDropTargets.length - 1]);
            return;
        }
        let index = this.validDropTargets.indexOf(this.currentDropTarget);
        if (index < 0) {
            this.setCurrentDropTarget(this.validDropTargets[this.validDropTargets.length - 1]);
            return;
        }
        // If we've reached the start of the valid drop targets, cycle back to the original drag target.
        // This lets the user cancel the drag in case they don't have an Escape key (e.g. iPad keyboard case).
        if (index === 0) {
            if (!this.dragTarget.element.closest('[aria-hidden="true"]')) {
                this.setCurrentDropTarget(null);
                this.dragTarget.element.focus();
            } else this.setCurrentDropTarget(this.validDropTargets[this.validDropTargets.length - 1]);
        } else this.setCurrentDropTarget(this.validDropTargets[index - 1]);
    }
    findNearestDropTarget() {
        let dragTargetRect = this.dragTarget.element.getBoundingClientRect();
        let minDistance = Infinity;
        let nearest = -1;
        for(let i = 0; i < this.validDropTargets.length; i++){
            let dropTarget = this.validDropTargets[i];
            let rect = dropTarget.element.getBoundingClientRect();
            let dx = rect.left - dragTargetRect.left;
            let dy = rect.top - dragTargetRect.top;
            let dist = dx * dx + dy * dy;
            if (dist < minDistance) {
                minDistance = dist;
                nearest = i;
            }
        }
        return nearest;
    }
    setCurrentDropTarget(dropTarget, item) {
        if (dropTarget !== this.currentDropTarget) {
            if (this.currentDropTarget && typeof this.currentDropTarget.onDropExit === "function") {
                let rect = this.currentDropTarget.element.getBoundingClientRect();
                this.currentDropTarget.onDropExit({
                    type: "dropexit",
                    x: rect.left + rect.width / 2,
                    y: rect.top + rect.height / 2
                });
            }
            this.currentDropTarget = dropTarget;
            if (dropTarget) {
                if (typeof dropTarget.onDropEnter === "function") {
                    let rect = dropTarget.element.getBoundingClientRect();
                    dropTarget.onDropEnter({
                        type: "dropenter",
                        x: rect.left + rect.width / 2,
                        y: rect.top + rect.height / 2
                    }, this.dragTarget);
                }
                if (!item) dropTarget === null || dropTarget === void 0 ? void 0 : dropTarget.element.focus();
            }
        }
        if (item !== this.currentDropItem) {
            if (item && typeof this.currentDropTarget.onDropTargetEnter === "function") this.currentDropTarget.onDropTargetEnter(item === null || item === void 0 ? void 0 : item.target);
            item === null || item === void 0 ? void 0 : item.element.focus();
            this.currentDropItem = item;
            // Announce first drop target after drag start announcement finishes.
            // Otherwise, it will never get announced because drag start announcement is assertive.
            if (!this.initialFocused) {
                (0, _liveAnnouncer.announce)(item === null || item === void 0 ? void 0 : item.element.getAttribute("aria-label"), "polite");
                this.initialFocused = true;
            }
        }
    }
    end() {
        this.teardown();
        endDragging();
        if (typeof this.dragTarget.onDragEnd === "function") {
            let target = this.currentDropTarget && this.dropOperation !== "cancel" ? this.currentDropTarget : this.dragTarget;
            let rect = target.element.getBoundingClientRect();
            this.dragTarget.onDragEnd({
                type: "dragend",
                x: rect.x + rect.width / 2,
                y: rect.y + rect.height / 2,
                dropOperation: this.dropOperation || "cancel"
            });
        }
        // Blur and re-focus the drop target so that the focus ring appears.
        if (this.currentDropTarget) {
            // Since we cancel all focus events in drag sessions, refire blur to make sure state gets updated so drag target doesn't think it's still focused
            // i.e. When you from one list to another during a drag session, we need the blur to fire on the first list after the drag.
            if (!this.dragTarget.element.contains(this.currentDropTarget.element)) {
                this.dragTarget.element.dispatchEvent(new FocusEvent("blur"));
                this.dragTarget.element.dispatchEvent(new FocusEvent("focusout", {
                    bubbles: true
                }));
            }
            // Re-focus the focusedKey upon reorder. This requires a React rerender between blurring and focusing.
            (0, _reactDom.flushSync)(()=>{
                this.currentDropTarget.element.blur();
            });
            this.currentDropTarget.element.focus();
        }
        this.setCurrentDropTarget(null);
    }
    cancel() {
        this.setCurrentDropTarget(null);
        this.end();
        if (!this.dragTarget.element.closest('[aria-hidden="true"]')) this.dragTarget.element.focus();
        (0, _liveAnnouncer.announce)(this.stringFormatter.format("dropCanceled"));
    }
    drop(item) {
        if (!this.currentDropTarget) {
            this.cancel();
            return;
        }
        if (typeof (item === null || item === void 0 ? void 0 : item.getDropOperation) === "function") {
            let types = (0, _utils.getTypes)(this.dragTarget.items);
            this.dropOperation = item.getDropOperation(types, this.dragTarget.allowedDropOperations);
        } else if (typeof this.currentDropTarget.getDropOperation === "function") {
            let types = (0, _utils.getTypes)(this.dragTarget.items);
            this.dropOperation = this.currentDropTarget.getDropOperation(types, this.dragTarget.allowedDropOperations);
        } else // TODO: show menu ??
        this.dropOperation = this.dragTarget.allowedDropOperations[0];
        if (typeof this.currentDropTarget.onDrop === "function") {
            let items = this.dragTarget.items.map((item)=>({
                    kind: "text",
                    types: new Set(Object.keys(item)),
                    getText: (type)=>Promise.resolve(item[type])
                }));
            let rect = this.currentDropTarget.element.getBoundingClientRect();
            this.currentDropTarget.onDrop({
                type: "drop",
                x: rect.left + rect.width / 2,
                y: rect.top + rect.height / 2,
                items,
                dropOperation: this.dropOperation
            }, item === null || item === void 0 ? void 0 : item.target);
        }
        this.end();
        (0, _liveAnnouncer.announce)(this.stringFormatter.format("dropComplete"));
    }
    activate() {
        if (this.currentDropTarget && typeof this.currentDropTarget.onDropActivate === "function") {
            let rect = this.currentDropTarget.element.getBoundingClientRect();
            this.currentDropTarget.onDropActivate({
                type: "dropactivate",
                x: rect.left + rect.width / 2,
                y: rect.top + rect.height / 2
            });
        }
    }
    constructor(target, stringFormatter){
        this.dragTarget = target;
        this.stringFormatter = stringFormatter;
        this.onKeyDown = this.onKeyDown.bind(this);
        this.onKeyUp = this.onKeyUp.bind(this);
        this.onFocus = this.onFocus.bind(this);
        this.onBlur = this.onBlur.bind(this);
        this.onClick = this.onClick.bind(this);
        this.onPointerDown = this.onPointerDown.bind(this);
        this.cancelEvent = this.cancelEvent.bind(this);
        this.initialFocused = false;
    }
}
function findValidDropTargets(options) {
    let types = (0, _utils.getTypes)(options.items);
    return [
        ...dropTargets.values()
    ].filter((target)=>{
        if (target.element.closest('[aria-hidden="true"]')) return false;
        if (typeof target.getDropOperation === "function") return target.getDropOperation(types, options.allowedDropOperations) !== "cancel";
        return true;
    });
}

},{"@react-aria/live-announcer":"ipdGY","@react-aria/overlays":"5fTCg","react-dom":"cEvV3","./utils":"8X8qs","@react-aria/utils":"9cLk5","react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"3FI7M":[function(require,module,exports) {
const _temp0 = require("a5470554c5398f2f");
const _temp1 = require("f94e2fb6fc2eca9e");
const _temp2 = require("59efffe3d5691c6c");
const _temp3 = require("63621e5d53b2b100");
const _temp4 = require("a4b139f99f09e002");
const _temp5 = require("1476950103166d07");
const _temp6 = require("60793a86d710176e");
const _temp7 = require("c8b2fb6f92ce08a");
const _temp8 = require("61f17b2be0f8eac7");
const _temp9 = require("cf02e846a09c949b");
const _temp10 = require("368441ff8b77695f");
const _temp11 = require("9cf23f9c048eb851");
const _temp12 = require("ed1b93f75a1de22");
const _temp13 = require("2490f288b02000f9");
const _temp14 = require("e0e4af3ca311a0b1");
const _temp15 = require("886c17e8ef72f71a");
const _temp16 = require("5b5f1b016058024");
const _temp17 = require("9c6a89a5679869da");
const _temp18 = require("7de0c0a1a6dd3f3d");
const _temp19 = require("e18e01a5aec35ac2");
const _temp20 = require("d4416f4205e6fa2c");
const _temp21 = require("29ceef7855d29ae");
const _temp22 = require("949f0a4ad73baa51");
const _temp23 = require("b4aa7a4d4bf482ff");
const _temp24 = require("b0b811f2ea252b2e");
const _temp25 = require("64207dc2fa9e2aaf");
const _temp26 = require("8575baa79b77656d");
const _temp27 = require("51a72cedce94677b");
const _temp28 = require("1cdfa8a6f4429fb4");
const _temp29 = require("7fd3813a8b4696dc");
const _temp30 = require("afb34445f8bc2ee");
const _temp31 = require("61fd90c534b6573d");
const _temp32 = require("d305b8664013cbab");
const _temp33 = require("d66e723225900bbe");
module.exports = {
    "ar-AE": _temp0,
    "bg-BG": _temp1,
    "cs-CZ": _temp2,
    "da-DK": _temp3,
    "de-DE": _temp4,
    "el-GR": _temp5,
    "en-US": _temp6,
    "es-ES": _temp7,
    "et-EE": _temp8,
    "fi-FI": _temp9,
    "fr-FR": _temp10,
    "he-IL": _temp11,
    "hr-HR": _temp12,
    "hu-HU": _temp13,
    "it-IT": _temp14,
    "ja-JP": _temp15,
    "ko-KR": _temp16,
    "lt-LT": _temp17,
    "lv-LV": _temp18,
    "nb-NO": _temp19,
    "nl-NL": _temp20,
    "pl-PL": _temp21,
    "pt-BR": _temp22,
    "pt-PT": _temp23,
    "ro-RO": _temp24,
    "ru-RU": _temp25,
    "sk-SK": _temp26,
    "sl-SI": _temp27,
    "sr-SP": _temp28,
    "sv-SE": _temp29,
    "tr-TR": _temp30,
    "uk-UA": _temp31,
    "zh-CN": _temp32,
    "zh-TW": _temp33
};

},{"a5470554c5398f2f":"dnx0g","f94e2fb6fc2eca9e":"d1iLz","59efffe3d5691c6c":"dZce8","63621e5d53b2b100":"3r3Dy","a4b139f99f09e002":"2fOGC","1476950103166d07":"9jvt2","60793a86d710176e":"hPbOW","c8b2fb6f92ce08a":"6tYHN","61f17b2be0f8eac7":"iVCtS","cf02e846a09c949b":"k8s3C","368441ff8b77695f":"6dt2s","9cf23f9c048eb851":"29SjT","ed1b93f75a1de22":"h4ZZ1","2490f288b02000f9":"2RyHd","e0e4af3ca311a0b1":"13dzl","886c17e8ef72f71a":"8rMUV","5b5f1b016058024":"9sGFt","9c6a89a5679869da":"9Hpk7","7de0c0a1a6dd3f3d":"7r9Y0","e18e01a5aec35ac2":"hfSsm","d4416f4205e6fa2c":"3o0Q3","29ceef7855d29ae":"bkHpn","949f0a4ad73baa51":"ij7hX","b4aa7a4d4bf482ff":"1PaEb","b0b811f2ea252b2e":"dgSUU","64207dc2fa9e2aaf":"9e2RJ","8575baa79b77656d":"hFky4","51a72cedce94677b":"g7XWC","1cdfa8a6f4429fb4":"hOi5K","7fd3813a8b4696dc":"4mPWr","afb34445f8bc2ee":"eNVuG","61fd90c534b6573d":"cszCb","d305b8664013cbab":"jWcTm","d66e723225900bbe":"hce3j"}],"dnx0g":[function(require,module,exports) {
module.exports = {
    "dragDescriptionKeyboard": `\u{627}\u{636}\u{63A}\u{637} Enter \u{644}\u{628}\u{62F}\u{621} \u{627}\u{644}\u{633}\u{62D}\u{628}.`,
    "dragDescriptionKeyboardAlt": `\u{627}\u{636}\u{63A}\u{637} \u{639}\u{644}\u{649} Alt + Enter \u{644}\u{628}\u{62F}\u{621} \u{627}\u{644}\u{633}\u{62D}\u{628}.`,
    "dragDescriptionLongPress": `\u{627}\u{636}\u{63A}\u{637} \u{628}\u{627}\u{633}\u{62A}\u{645}\u{631}\u{627}\u{631} \u{644}\u{628}\u{62F}\u{621} \u{627}\u{644}\u{633}\u{62D}\u{628}.`,
    "dragDescriptionTouch": `\u{627}\u{636}\u{63A}\u{637} \u{645}\u{631}\u{62A}\u{64A}\u{646} \u{644}\u{628}\u{62F}\u{621} \u{627}\u{644}\u{633}\u{62D}\u{628}.`,
    "dragDescriptionVirtual": `\u{627}\u{646}\u{642}\u{631} \u{644}\u{628}\u{62F}\u{621} \u{627}\u{644}\u{633}\u{62D}\u{628}.`,
    "dragItem": (args)=>`\u{627}\u{633}\u{62D}\u{628} ${args.itemText}`,
    "dragSelectedItems": (args, formatter)=>`\u{627}\u{633}\u{62D}\u{628} ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} \u{639}\u{646}\u{635}\u{631} \u{645}\u{62D}\u{62F}\u{62F}`,
            other: ()=>`${formatter.number(args.count)} \u{639}\u{646}\u{627}\u{635}\u{631} \u{645}\u{62D}\u{62F}\u{62F}\u{629}`
        })}`,
    "dragSelectedKeyboard": (args, formatter)=>`\u{627}\u{636}\u{63A}\u{637} \u{639}\u{644}\u{649} Enter \u{644}\u{644}\u{633}\u{62D}\u{628} ${formatter.plural(args.count, {
            one: `\u{639}\u{62F}\u{62F} \u{627}\u{644}\u{639}\u{646}\u{627}\u{635}\u{631} \u{627}\u{644}\u{645}\u{62E}\u{62A}\u{627}\u{631}\u{629}`,
            other: `\u{639}\u{62F}\u{62F} \u{627}\u{644}\u{639}\u{646}\u{627}\u{635}\u{631} \u{627}\u{644}\u{645}\u{62E}\u{62A}\u{627}\u{631}\u{629}`
        })}.`,
    "dragSelectedKeyboardAlt": (args, formatter)=>`\u{627}\u{636}\u{63A}\u{637} \u{639}\u{644}\u{649} \u{645}\u{641}\u{62A}\u{627}\u{62D}\u{64A} Alt + Enter \u{644}\u{644}\u{633}\u{62D}\u{628} ${formatter.plural(args.count, {
            one: `\u{639}\u{62F}\u{62F} \u{627}\u{644}\u{639}\u{646}\u{627}\u{635}\u{631} \u{627}\u{644}\u{645}\u{62E}\u{62A}\u{627}\u{631}\u{629}`,
            other: `\u{639}\u{62F}\u{62F} \u{627}\u{644}\u{639}\u{646}\u{627}\u{635}\u{631} \u{627}\u{644}\u{645}\u{62E}\u{62A}\u{627}\u{631}\u{629}`
        })}.`,
    "dragSelectedLongPress": (args, formatter)=>`\u{627}\u{636}\u{63A}\u{637} \u{628}\u{627}\u{633}\u{62A}\u{645}\u{631}\u{627}\u{631} \u{644}\u{644}\u{633}\u{62D}\u{628} ${formatter.plural(args.count, {
            one: `\u{639}\u{62F}\u{62F} \u{627}\u{644}\u{639}\u{646}\u{627}\u{635}\u{631} \u{627}\u{644}\u{645}\u{62E}\u{62A}\u{627}\u{631}\u{629}`,
            other: `\u{639}\u{62F}\u{62F} \u{627}\u{644}\u{639}\u{646}\u{627}\u{635}\u{631} \u{627}\u{644}\u{645}\u{62E}\u{62A}\u{627}\u{631}\u{629}`
        })}.`,
    "dragStartedKeyboard": `\u{628}\u{62F}\u{623} \u{627}\u{644}\u{633}\u{62D}\u{628}. \u{627}\u{636}\u{63A}\u{637} Tab \u{644}\u{644}\u{627}\u{646}\u{62A}\u{642}\u{627}\u{644} \u{625}\u{644}\u{649} \u{645}\u{648}\u{636}\u{639} \u{627}\u{644}\u{625}\u{641}\u{644}\u{627}\u{62A}\u{60C} \u{62B}\u{645} \u{627}\u{636}\u{63A}\u{637} Enter \u{644}\u{644}\u{625}\u{641}\u{644}\u{627}\u{62A}\u{60C} \u{623}\u{648} \u{627}\u{636}\u{63A}\u{637} Escape \u{644}\u{644}\u{625}\u{644}\u{63A}\u{627}\u{621}.`,
    "dragStartedTouch": `\u{628}\u{62F}\u{623} \u{627}\u{644}\u{633}\u{62D}\u{628}. \u{627}\u{646}\u{62A}\u{642}\u{644} \u{625}\u{644}\u{649} \u{645}\u{648}\u{636}\u{639} \u{627}\u{644}\u{625}\u{641}\u{644}\u{627}\u{62A}\u{60C} \u{62B}\u{645} \u{627}\u{636}\u{63A}\u{637} \u{645}\u{631}\u{62A}\u{64A}\u{646} \u{644}\u{644}\u{625}\u{641}\u{644}\u{627}\u{62A}.`,
    "dragStartedVirtual": `\u{628}\u{62F}\u{623} \u{627}\u{644}\u{633}\u{62D}\u{628}. \u{627}\u{646}\u{62A}\u{642}\u{644} \u{625}\u{644}\u{649} \u{645}\u{643}\u{627}\u{646} \u{627}\u{644}\u{625}\u{641}\u{644}\u{627}\u{62A}\u{60C} \u{62B}\u{645} \u{627}\u{646}\u{642}\u{631} \u{623}\u{648} \u{627}\u{636}\u{63A}\u{637} Enter \u{644}\u{644}\u{625}\u{641}\u{644}\u{627}\u{62A}.`,
    "dropCanceled": `\u{62A}\u{645} \u{625}\u{644}\u{63A}\u{627}\u{621} \u{627}\u{644}\u{625}\u{641}\u{644}\u{627}\u{62A}.`,
    "dropComplete": `\u{627}\u{643}\u{62A}\u{645}\u{644} \u{627}\u{644}\u{625}\u{641}\u{644}\u{627}\u{62A}.`,
    "dropDescriptionKeyboard": `\u{627}\u{636}\u{63A}\u{637} Enter \u{644}\u{644}\u{625}\u{641}\u{644}\u{627}\u{62A}. \u{627}\u{636}\u{63A}\u{637} Escape \u{644}\u{625}\u{644}\u{63A}\u{627}\u{621} \u{627}\u{644}\u{633}\u{62D}\u{628}.`,
    "dropDescriptionTouch": `\u{627}\u{636}\u{63A}\u{637} \u{645}\u{631}\u{62A}\u{64A}\u{646} \u{644}\u{644}\u{625}\u{641}\u{644}\u{627}\u{62A}.`,
    "dropDescriptionVirtual": `\u{627}\u{646}\u{642}\u{631} \u{644}\u{644}\u{625}\u{641}\u{644}\u{627}\u{62A}.`,
    "dropIndicator": `\u{645}\u{624}\u{634}\u{631} \u{627}\u{644}\u{625}\u{641}\u{644}\u{627}\u{62A}`,
    "dropOnItem": (args)=>`\u{625}\u{641}\u{644}\u{627}\u{62A} ${args.itemText}`,
    "dropOnRoot": `\u{627}\u{644}\u{625}\u{641}\u{644}\u{627}\u{62A}`,
    "endDragKeyboard": `\u{627}\u{644}\u{633}\u{62D}\u{628}. \u{627}\u{636}\u{63A}\u{637} Enter \u{644}\u{625}\u{644}\u{63A}\u{627}\u{621} \u{627}\u{644}\u{633}\u{62D}\u{628}.`,
    "endDragTouch": `\u{627}\u{644}\u{633}\u{62D}\u{628}. \u{627}\u{636}\u{63A}\u{637} \u{645}\u{631}\u{62A}\u{64A}\u{646} \u{644}\u{625}\u{644}\u{63A}\u{627}\u{621} \u{627}\u{644}\u{633}\u{62D}\u{628}.`,
    "endDragVirtual": `\u{627}\u{644}\u{633}\u{62D}\u{628}. \u{627}\u{646}\u{642}\u{631} \u{644}\u{625}\u{644}\u{63A}\u{627}\u{621} \u{627}\u{644}\u{633}\u{62D}\u{628}.`,
    "insertAfter": (args)=>`\u{623}\u{62F}\u{62E}\u{644} \u{628}\u{639}\u{62F} ${args.itemText}`,
    "insertBefore": (args)=>`\u{623}\u{62F}\u{62E}\u{644} \u{642}\u{628}\u{644} ${args.itemText}`,
    "insertBetween": (args)=>`\u{623}\u{62F}\u{62E}\u{644} \u{628}\u{64A}\u{646} ${args.beforeItemText} \u{648} ${args.afterItemText}`
};

},{}],"d1iLz":[function(require,module,exports) {
module.exports = {
    "dragDescriptionKeyboard": `\u{41D}\u{430}\u{442}\u{438}\u{441}\u{43D}\u{435}\u{442}\u{435} \u{201E}Enter\u{201C}, \u{437}\u{430} \u{434}\u{430} \u{437}\u{430}\u{43F}\u{43E}\u{447}\u{43D}\u{435}\u{442}\u{435} \u{434}\u{430} \u{43F}\u{43B}\u{44A}\u{437}\u{433}\u{430}\u{442}\u{435}.`,
    "dragDescriptionKeyboardAlt": `\u{41D}\u{430}\u{442}\u{438}\u{441}\u{43D}\u{435}\u{442}\u{435} Alt + Enter, \u{437}\u{430} \u{434}\u{430} \u{437}\u{430}\u{43F}\u{43E}\u{447}\u{43D}\u{435}\u{442}\u{435} \u{434}\u{430} \u{43F}\u{43B}\u{44A}\u{437}\u{433}\u{430}\u{442}\u{435}.`,
    "dragDescriptionLongPress": `\u{41D}\u{430}\u{442}\u{438}\u{441}\u{43D}\u{435}\u{442}\u{435} \u{43F}\u{440}\u{43E}\u{434}\u{44A}\u{43B}\u{436}\u{438}\u{442}\u{435}\u{43B}\u{43D}\u{43E}, \u{437}\u{430} \u{434}\u{430} \u{437}\u{430}\u{43F}\u{43E}\u{447}\u{43D}\u{435}\u{442}\u{435} \u{434}\u{430} \u{43F}\u{43B}\u{44A}\u{437}\u{433}\u{430}\u{442}\u{435}.`,
    "dragDescriptionTouch": `\u{41D}\u{430}\u{442}\u{438}\u{441}\u{43D}\u{435}\u{442}\u{435} \u{434}\u{432}\u{443}\u{43A}\u{440}\u{430}\u{442}\u{43D}\u{43E}, \u{437}\u{430} \u{434}\u{430} \u{437}\u{430}\u{43F}\u{43E}\u{447}\u{43D}\u{435}\u{442}\u{435} \u{434}\u{430} \u{43F}\u{43B}\u{44A}\u{437}\u{433}\u{430}\u{442}\u{435}.`,
    "dragDescriptionVirtual": `\u{429}\u{440}\u{430}\u{43A}\u{43D}\u{435}\u{442}\u{435}, \u{437}\u{430} \u{434}\u{430} \u{437}\u{430}\u{43F}\u{43E}\u{447}\u{43D}\u{435}\u{442}\u{435} \u{434}\u{430} \u{43F}\u{43B}\u{44A}\u{437}\u{433}\u{430}\u{442}\u{435}.`,
    "dragItem": (args)=>`\u{41F}\u{43B}\u{44A}\u{437}\u{43D}\u{438} ${args.itemText}`,
    "dragSelectedItems": (args, formatter)=>`\u{41F}\u{43B}\u{44A}\u{437}\u{43D}\u{438} ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} \u{438}\u{437}\u{431}\u{440}\u{430}\u{43D} \u{435}\u{43B}\u{435}\u{43C}\u{435}\u{43D}\u{442}`,
            other: ()=>`${formatter.number(args.count)} \u{438}\u{437}\u{431}\u{440}\u{430}\u{43D}\u{438} \u{435}\u{43B}\u{435}\u{43C}\u{435}\u{43D}\u{442}\u{430}`
        })}`,
    "dragSelectedKeyboard": (args, formatter)=>`\u{41D}\u{430}\u{442}\u{438}\u{441}\u{43D}\u{435}\u{442}\u{435} Enter, \u{437}\u{430} \u{434}\u{430} \u{43F}\u{43B}\u{44A}\u{437}\u{43D}\u{435}\u{442}\u{435} ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} \u{438}\u{437}\u{431}\u{440}\u{430}\u{43D} \u{435}\u{43B}\u{435}\u{43C}\u{435}\u{43D}\u{442}`,
            other: ()=>`${formatter.number(args.count)} \u{438}\u{437}\u{431}\u{440}\u{430}\u{43D}\u{438} \u{435}\u{43B}\u{435}\u{43C}\u{435}\u{43D}\u{442}\u{438}`
        })}.`,
    "dragSelectedKeyboardAlt": (args, formatter)=>`\u{41D}\u{430}\u{442}\u{438}\u{441}\u{43D}\u{435}\u{442}\u{435} Alt \u{438} Enter, \u{437}\u{430} \u{434}\u{430} \u{43F}\u{43B}\u{44A}\u{437}\u{43D}\u{435}\u{442}\u{435} ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} \u{438}\u{437}\u{431}\u{440}\u{430}\u{43D} \u{435}\u{43B}\u{435}\u{43C}\u{435}\u{43D}\u{442}`,
            other: ()=>`${formatter.number(args.count)} \u{438}\u{437}\u{431}\u{440}\u{430}\u{43D}\u{438} \u{435}\u{43B}\u{435}\u{43C}\u{435}\u{43D}\u{442}\u{438}`
        })}.`,
    "dragSelectedLongPress": (args, formatter)=>`\u{41D}\u{430}\u{442}\u{438}\u{441}\u{43D}\u{435}\u{442}\u{435} \u{43F}\u{440}\u{43E}\u{434}\u{44A}\u{43B}\u{436}\u{438}\u{442}\u{435}\u{43B}\u{43D}\u{43E}, \u{437}\u{430} \u{434}\u{430} \u{43F}\u{43B}\u{44A}\u{437}\u{43D}\u{435}\u{442}\u{435} ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} \u{438}\u{437}\u{431}\u{440}\u{430}\u{43D} \u{435}\u{43B}\u{435}\u{43C}\u{435}\u{43D}\u{442}`,
            other: ()=>`${formatter.number(args.count)} \u{438}\u{437}\u{431}\u{440}\u{430}\u{43D}\u{438} \u{435}\u{43B}\u{435}\u{43C}\u{435}\u{43D}\u{442}\u{438}`
        })}.`,
    "dragStartedKeyboard": `\u{417}\u{430}\u{43F}\u{43E}\u{447}\u{43D}\u{430} \u{43F}\u{43B}\u{44A}\u{437}\u{433}\u{430}\u{43D}\u{435}. \u{41D}\u{430}\u{442}\u{438}\u{441}\u{43D}\u{435}\u{442}\u{435} \u{201E}Tab\u{201C}, \u{437}\u{430} \u{434}\u{430} \u{441}\u{435} \u{43F}\u{440}\u{438}\u{434}\u{432}\u{438}\u{436}\u{438}\u{442}\u{435} \u{434}\u{43E} \u{446}\u{435}\u{43B}\u{442}\u{430}, \u{441}\u{43B}\u{435}\u{434} \u{43A}\u{43E}\u{435}\u{442}\u{43E} \u{43D}\u{430}\u{442}\u{438}\u{441}\u{43D}\u{435}\u{442}\u{435} \u{201E}Enter\u{201C} \u{437}\u{430} \u{43F}\u{443}\u{441}\u{43A}\u{430}\u{43D}\u{435} \u{438}\u{43B}\u{438} \u{43D}\u{430}\u{442}\u{438}\u{441}\u{43D}\u{435}\u{442}\u{435} \u{201E}Escape\u{201C} \u{437}\u{430} \u{43E}\u{442}\u{43C}\u{44F}\u{43D}\u{430}.`,
    "dragStartedTouch": `\u{417}\u{430}\u{43F}\u{43E}\u{447}\u{43D}\u{430} \u{43F}\u{43B}\u{44A}\u{437}\u{433}\u{430}\u{43D}\u{435}. \u{41F}\u{440}\u{438}\u{434}\u{432}\u{438}\u{436}\u{435}\u{442}\u{435} \u{441}\u{435} \u{434}\u{43E} \u{446}\u{435}\u{43B}\u{442}\u{430}, \u{441}\u{43B}\u{435}\u{434} \u{43A}\u{43E}\u{435}\u{442}\u{43E} \u{43D}\u{430}\u{442}\u{438}\u{441}\u{43D}\u{435}\u{442}\u{435} \u{434}\u{432}\u{443}\u{43A}\u{440}\u{430}\u{442}\u{43D}\u{43E}, \u{437}\u{430} \u{434}\u{430} \u{43F}\u{443}\u{441}\u{43D}\u{435}\u{442}\u{435}.`,
    "dragStartedVirtual": `\u{417}\u{430}\u{43F}\u{43E}\u{447}\u{43D}\u{430} \u{43F}\u{43B}\u{44A}\u{437}\u{433}\u{430}\u{43D}\u{435}. \u{41F}\u{440}\u{438}\u{434}\u{432}\u{438}\u{436}\u{435}\u{442}\u{435} \u{441}\u{435} \u{434}\u{43E} \u{446}\u{435}\u{43B}\u{442}\u{430}, \u{441}\u{43B}\u{435}\u{434} \u{43A}\u{43E}\u{435}\u{442}\u{43E} \u{449}\u{440}\u{430}\u{43A}\u{43D}\u{435}\u{442}\u{435} \u{438}\u{43B}\u{438} \u{43D}\u{430}\u{442}\u{438}\u{441}\u{43D}\u{435}\u{442}\u{435} \u{201E}Enter\u{201C} \u{437}\u{430} \u{43F}\u{443}\u{441}\u{43A}\u{430}\u{43D}\u{435}.`,
    "dropCanceled": `\u{41F}\u{443}\u{441}\u{43A}\u{430}\u{43D}\u{435}\u{442}\u{43E} \u{435} \u{43E}\u{442}\u{43C}\u{435}\u{43D}\u{435}\u{43D}\u{43E}.`,
    "dropComplete": `\u{41F}\u{443}\u{441}\u{43A}\u{430}\u{43D}\u{435}\u{442}\u{43E} \u{435} \u{437}\u{430}\u{432}\u{44A}\u{440}\u{448}\u{435}\u{43D}\u{43E}.`,
    "dropDescriptionKeyboard": `\u{41D}\u{430}\u{442}\u{438}\u{441}\u{43D}\u{435}\u{442}\u{435} \u{201E}Enter\u{201C} \u{437}\u{430} \u{43F}\u{443}\u{441}\u{43A}\u{430}\u{43D}\u{435}. \u{41D}\u{430}\u{442}\u{438}\u{441}\u{43D}\u{435}\u{442}\u{435} \u{201E}Escape\u{201C} \u{437}\u{430} \u{43E}\u{442}\u{43C}\u{44F}\u{43D}\u{430} \u{43D}\u{430} \u{43F}\u{43B}\u{44A}\u{437}\u{433}\u{430}\u{43D}\u{435}\u{442}\u{43E}.`,
    "dropDescriptionTouch": `\u{41D}\u{430}\u{442}\u{438}\u{441}\u{43D}\u{435}\u{442}\u{435} \u{434}\u{432}\u{443}\u{43A}\u{440}\u{430}\u{442}\u{43D}\u{43E} \u{437}\u{430} \u{43F}\u{443}\u{441}\u{43A}\u{430}\u{43D}\u{435}.`,
    "dropDescriptionVirtual": `\u{429}\u{440}\u{430}\u{43A}\u{43D}\u{435}\u{442}\u{435} \u{437}\u{430} \u{43F}\u{443}\u{441}\u{43A}\u{430}\u{43D}\u{435}.`,
    "dropIndicator": `\u{438}\u{43D}\u{434}\u{438}\u{43A}\u{430}\u{442}\u{43E}\u{440} \u{437}\u{430} \u{43F}\u{443}\u{441}\u{43A}\u{430}\u{43D}\u{435}`,
    "dropOnItem": (args)=>`\u{41F}\u{443}\u{441}\u{43D}\u{438} \u{432}\u{44A}\u{440}\u{445}\u{443} ${args.itemText}`,
    "dropOnRoot": `\u{41F}\u{443}\u{441}\u{43D}\u{438} \u{432}\u{44A}\u{440}\u{445}\u{443}`,
    "endDragKeyboard": `\u{41F}\u{43B}\u{44A}\u{437}\u{433}\u{430}\u{43D}\u{435}. \u{41D}\u{430}\u{442}\u{438}\u{441}\u{43D}\u{435}\u{442}\u{435} \u{201E}Enter\u{201C} \u{437}\u{430} \u{43E}\u{442}\u{43C}\u{44F}\u{43D}\u{430} \u{43D}\u{430} \u{43F}\u{43B}\u{44A}\u{437}\u{433}\u{430}\u{43D}\u{435}\u{442}\u{43E}.`,
    "endDragTouch": `\u{41F}\u{43B}\u{44A}\u{437}\u{433}\u{430}\u{43D}\u{435}. \u{41D}\u{430}\u{442}\u{438}\u{441}\u{43D}\u{435}\u{442}\u{435} \u{434}\u{432}\u{443}\u{43A}\u{440}\u{430}\u{442}\u{43D}\u{43E} \u{437}\u{430} \u{43E}\u{442}\u{43C}\u{44F}\u{43D}\u{430} \u{43D}\u{430} \u{43F}\u{43B}\u{44A}\u{437}\u{433}\u{430}\u{43D}\u{435}\u{442}\u{43E}.`,
    "endDragVirtual": `\u{41F}\u{43B}\u{44A}\u{437}\u{433}\u{430}\u{43D}\u{435}. \u{429}\u{440}\u{430}\u{43A}\u{43D}\u{435}\u{442}\u{435} \u{437}\u{430} \u{43E}\u{442}\u{43C}\u{44F}\u{43D}\u{430}.`,
    "insertAfter": (args)=>`\u{412}\u{43C}\u{44A}\u{43A}\u{43D}\u{438} \u{441}\u{43B}\u{435}\u{434} ${args.itemText}`,
    "insertBefore": (args)=>`\u{412}\u{43C}\u{44A}\u{43A}\u{43D}\u{438} \u{43F}\u{440}\u{435}\u{434}\u{438} ${args.itemText}`,
    "insertBetween": (args)=>`\u{412}\u{43C}\u{44A}\u{43A}\u{43D}\u{438} \u{43C}\u{435}\u{436}\u{434}\u{443} ${args.beforeItemText} \u{438} ${args.afterItemText}`
};

},{}],"dZce8":[function(require,module,exports) {
module.exports = {
    "dragDescriptionKeyboard": `Stisknut\xedm kl\xe1vesy Enter za\u{10D}nete s p\u{159}etahov\xe1n\xedm.`,
    "dragDescriptionKeyboardAlt": `Stisknut\xedm Alt + Enter zah\xe1j\xedte p\u{159}etahov\xe1n\xed.`,
    "dragDescriptionLongPress": `Dlouh\xfdm stisknut\xedm zah\xe1j\xedte p\u{159}etahov\xe1n\xed.`,
    "dragDescriptionTouch": `Poklep\xe1n\xedm za\u{10D}nete s p\u{159}etahov\xe1n\xedm.`,
    "dragDescriptionVirtual": `Kliknut\xedm za\u{10D}nete s p\u{159}etahov\xe1n\xedm.`,
    "dragItem": (args)=>`P\u{159}et\xe1hnout ${args.itemText}`,
    "dragSelectedItems": (args, formatter)=>`P\u{159}et\xe1hnout ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} vybranou polo\u{17E}ku`,
            few: ()=>`${formatter.number(args.count)} vybran\xe9 polo\u{17E}ky`,
            other: ()=>`${formatter.number(args.count)} vybran\xfdch polo\u{17E}ek`
        })}`,
    "dragSelectedKeyboard": (args, formatter)=>`Stisknut\xedm kl\xe1vesy Enter p\u{159}et\xe1hn\u{11B}te ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} vybranou polo\u{17E}ku`,
            other: ()=>`${formatter.number(args.count)} vybran\xe9 polo\u{17E}ky`
        })}.`,
    "dragSelectedKeyboardAlt": (args, formatter)=>`Stisknut\xedm Alt + Enter p\u{159}et\xe1hn\u{11B}te ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} vybranou polo\u{17E}ku`,
            other: ()=>`${formatter.number(args.count)} vybran\xe9 polo\u{17E}ky`
        })}.`,
    "dragSelectedLongPress": (args, formatter)=>`Dlouh\xfdm stisknut\xedm p\u{159}et\xe1hnete ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} vybranou polo\u{17E}ku`,
            other: ()=>`${formatter.number(args.count)} vybran\xe9 polo\u{17E}ky`
        })}.`,
    "dragStartedKeyboard": `Za\u{10D}n\u{11B}te s p\u{159}etahov\xe1n\xedm. Po stisknut\xed kl\xe1vesy Tab najd\u{11B}te po\u{17E}adovan\xfd c\xedl a stisknut\xedm kl\xe1vesy Enter p\u{159}eta\u{17E}en\xed dokon\u{10D}ete nebo stisknut\xedm kl\xe1vesy Esc akci zru\u{161}te.`,
    "dragStartedTouch": `Za\u{10D}n\u{11B}te s p\u{159}etahov\xe1n\xedm. Najd\u{11B}te po\u{17E}adovan\xfd c\xedl a poklep\xe1n\xedm p\u{159}eta\u{17E}en\xed dokon\u{10D}ete.`,
    "dragStartedVirtual": `Za\u{10D}n\u{11B}te s p\u{159}etahov\xe1n\xedm. Najd\u{11B}te po\u{17E}adovan\xfd c\xedl a kliknut\xedm nebo stisknut\xedm kl\xe1vesy Enter p\u{159}eta\u{17E}en\xed dokon\u{10D}ete.`,
    "dropCanceled": `P\u{159}eta\u{17E}en\xed bylo zru\u{161}eno.`,
    "dropComplete": `P\u{159}eta\u{17E}en\xed bylo dokon\u{10D}eno.`,
    "dropDescriptionKeyboard": `Stisknut\xedm kl\xe1vesy Enter p\u{159}eta\u{17E}en\xed dokon\u{10D}ete nebo stisknut\xedm kl\xe1vesy Esc akci zru\u{161}te.`,
    "dropDescriptionTouch": `Poklep\xe1n\xedm p\u{159}eta\u{17E}en\xed dokon\u{10D}ete.`,
    "dropDescriptionVirtual": `Kliknut\xedm objekt p\u{159}et\xe1hn\u{11B}te.`,
    "dropIndicator": `indik\xe1tor p\u{159}eta\u{17E}en\xed`,
    "dropOnItem": (args)=>`P\u{159}et\xe1hnout na ${args.itemText}`,
    "dropOnRoot": `P\u{159}et\xe1hnout na`,
    "endDragKeyboard": `Prob\xedh\xe1 p\u{159}etahov\xe1n\xed. Stisknut\xedm kl\xe1vesy Enter p\u{159}eta\u{17E}en\xed zru\u{161}\xedte.`,
    "endDragTouch": `Prob\xedh\xe1 p\u{159}etahov\xe1n\xed. Poklep\xe1n\xedm p\u{159}eta\u{17E}en\xed zru\u{161}\xedte.`,
    "endDragVirtual": `Prob\xedh\xe1 p\u{159}etahov\xe1n\xed. Kliknut\xedm p\u{159}eta\u{17E}en\xed zru\u{161}\xedte.`,
    "insertAfter": (args)=>`Vlo\u{17E}it za ${args.itemText}`,
    "insertBefore": (args)=>`Vlo\u{17E}it p\u{159}ed ${args.itemText}`,
    "insertBetween": (args)=>`Vlo\u{17E}it mezi ${args.beforeItemText} a ${args.afterItemText}`
};

},{}],"3r3Dy":[function(require,module,exports) {
module.exports = {
    "dragDescriptionKeyboard": `Tryk p\xe5 Enter for at starte med at tr\xe6kke.`,
    "dragDescriptionKeyboardAlt": `Tryk p\xe5 Alt + Enter for at starte med at tr\xe6kke.`,
    "dragDescriptionLongPress": `Tryk l\xe6nge for at starte med at tr\xe6kke.`,
    "dragDescriptionTouch": `Dobbelttryk for at starte med at tr\xe6kke.`,
    "dragDescriptionVirtual": `Klik for at starte med at tr\xe6kke.`,
    "dragItem": (args)=>`Tr\xe6k ${args.itemText}`,
    "dragSelectedItems": (args, formatter)=>`Tr\xe6k ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} valgt element`,
            other: ()=>`${formatter.number(args.count)} valgte elementer`
        })}`,
    "dragSelectedKeyboard": (args, formatter)=>`Tryk p\xe5 Enter for at tr\xe6kke ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} valgte element`,
            other: ()=>`${formatter.number(args.count)} valgte elementer`
        })}.`,
    "dragSelectedKeyboardAlt": (args, formatter)=>`Tryk p\xe5 Alt + Enter for at tr\xe6kke ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} valgte element`,
            other: ()=>`${formatter.number(args.count)} valgte elementer`
        })}.`,
    "dragSelectedLongPress": (args, formatter)=>`Tryk l\xe6nge for at tr\xe6kke ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} valgte element`,
            other: ()=>`${formatter.number(args.count)} valgte elementer`
        })}.`,
    "dragStartedKeyboard": `Startet med at tr\xe6kke. Tryk p\xe5 Tab for at g\xe5 til et slip-m\xe5l, tryk derefter p\xe5 Enter for at slippe, eller tryk p\xe5 Escape for at annullere.`,
    "dragStartedTouch": `Startet med at tr\xe6kke. G\xe5 til et slip-m\xe5l, og dobbelttryk derefter for at slippe.`,
    "dragStartedVirtual": `Startet med at tr\xe6kke. G\xe5 til et slip-m\xe5l, og klik eller tryk derefter p\xe5 enter for at slippe.`,
    "dropCanceled": `Slip annulleret.`,
    "dropComplete": `Slip fuldf\xf8rt.`,
    "dropDescriptionKeyboard": `Tryk p\xe5 Enter for at slippe. Tryk p\xe5 Escape for at annullere tr\xe6kning.`,
    "dropDescriptionTouch": `Dobbelttryk for at slippe.`,
    "dropDescriptionVirtual": `Klik for at slippe.`,
    "dropIndicator": `slip-indikator`,
    "dropOnItem": (args)=>`Slip p\xe5 ${args.itemText}`,
    "dropOnRoot": `Slip p\xe5`,
    "endDragKeyboard": `Tr\xe6kning. Tryk p\xe5 enter for at annullere tr\xe6k.`,
    "endDragTouch": `Tr\xe6kning. Dobbelttryk for at annullere tr\xe6k.`,
    "endDragVirtual": `Tr\xe6kning. Klik for at annullere tr\xe6kning.`,
    "insertAfter": (args)=>`Inds\xe6t efter ${args.itemText}`,
    "insertBefore": (args)=>`Inds\xe6t f\xf8r ${args.itemText}`,
    "insertBetween": (args)=>`Inds\xe6t mellem ${args.beforeItemText} og ${args.afterItemText}`
};

},{}],"2fOGC":[function(require,module,exports) {
module.exports = {
    "dragDescriptionKeyboard": `Dr\xfccken Sie die Eingabetaste, um den Ziehvorgang zu starten.`,
    "dragDescriptionKeyboardAlt": `Alt + Eingabe dr\xfccken, um den Ziehvorgang zu starten.`,
    "dragDescriptionLongPress": `Lang dr\xfccken, um mit dem Ziehen zu beginnen.`,
    "dragDescriptionTouch": `Tippen Sie doppelt, um den Ziehvorgang zu starten.`,
    "dragDescriptionVirtual": `Zum Starten des Ziehvorgangs klicken.`,
    "dragItem": (args)=>`${args.itemText} ziehen`,
    "dragSelectedItems": (args, formatter)=>`${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} ausgew\xe4hltes Objekt`,
            other: ()=>`${formatter.number(args.count)} ausgew\xe4hlte Objekte`
        })} ziehen`,
    "dragSelectedKeyboard": (args, formatter)=>`Eingabetaste dr\xfccken, um ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} ausgew\xe4hltes Element`,
            other: ()=>`${formatter.number(args.count)} ausgew\xe4hlte Elemente`
        })} zu ziehen.`,
    "dragSelectedKeyboardAlt": (args, formatter)=>`Alt + Eingabetaste dr\xfccken, um ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} ausgew\xe4hltes Element`,
            other: ()=>`${formatter.number(args.count)} ausgew\xe4hlte Elemente`
        })} zu ziehen.`,
    "dragSelectedLongPress": (args, formatter)=>`Lang dr\xfccken, um ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} ausgew\xe4hltes Element`,
            other: ()=>`${formatter.number(args.count)} ausgew\xe4hlte Elemente`
        })} zu ziehen.`,
    "dragStartedKeyboard": `Ziehvorgang gestartet. Dr\xfccken Sie die Tabulatortaste, um zu einem Ablegeziel zu navigieren und dr\xfccken Sie dann die Eingabetaste, um das Objekt abzulegen, oder Escape, um den Vorgang abzubrechen.`,
    "dragStartedTouch": `Ziehvorgang gestartet. Navigieren Sie zu einem Ablegeziel und tippen Sie doppelt, um das Objekt abzulegen.`,
    "dragStartedVirtual": `Ziehvorgang gestartet. Navigieren Sie zu einem Ablegeziel und klicken Sie oder dr\xfccken Sie die Eingabetaste, um das Objekt abzulegen.`,
    "dropCanceled": `Ablegen abgebrochen.`,
    "dropComplete": `Ablegen abgeschlossen.`,
    "dropDescriptionKeyboard": `Dr\xfccken Sie die Eingabetaste, um das Objekt abzulegen. Dr\xfccken Sie Escape, um den Vorgang abzubrechen.`,
    "dropDescriptionTouch": `Tippen Sie doppelt, um das Objekt abzulegen.`,
    "dropDescriptionVirtual": `Zum Ablegen klicken.`,
    "dropIndicator": `Ablegeanzeiger`,
    "dropOnItem": (args)=>`Auf ${args.itemText} ablegen`,
    "dropOnRoot": `Ablegen auf`,
    "endDragKeyboard": `Ziehvorgang l\xe4uft. Dr\xfccken Sie die Eingabetaste, um den Vorgang abzubrechen.`,
    "endDragTouch": `Ziehvorgang l\xe4uft. Tippen Sie doppelt, um den Vorgang abzubrechen.`,
    "endDragVirtual": `Ziehvorgang l\xe4uft. Klicken Sie, um den Vorgang abzubrechen.`,
    "insertAfter": (args)=>`Nach ${args.itemText} einf\xfcgen`,
    "insertBefore": (args)=>`Vor ${args.itemText} einf\xfcgen`,
    "insertBetween": (args)=>`Zwischen ${args.beforeItemText} und ${args.afterItemText} einf\xfcgen`
};

},{}],"9jvt2":[function(require,module,exports) {
module.exports = {
    "dragDescriptionKeyboard": `\u{3A0}\u{3B1}\u{3C4}\u{3AE}\u{3C3}\u{3C4}\u{3B5} Enter \u{3B3}\u{3B9}\u{3B1} \u{3AD}\u{3BD}\u{3B1}\u{3C1}\u{3BE}\u{3B7} \u{3C4}\u{3B7}\u{3C2} \u{3BC}\u{3B5}\u{3C4}\u{3B1}\u{3C6}\u{3BF}\u{3C1}\u{3AC}\u{3C2}.`,
    "dragDescriptionKeyboardAlt": `\u{3A0}\u{3B1}\u{3C4}\u{3AE}\u{3C3}\u{3C4}\u{3B5} Alt + Enter \u{3B3}\u{3B9}\u{3B1} \u{3AD}\u{3BD}\u{3B1}\u{3C1}\u{3BE}\u{3B7} \u{3C4}\u{3B7}\u{3C2} \u{3BC}\u{3B5}\u{3C4}\u{3B1}\u{3C6}\u{3BF}\u{3C1}\u{3AC}\u{3C2}.`,
    "dragDescriptionLongPress": `\u{3A0}\u{3B1}\u{3C4}\u{3AE}\u{3C3}\u{3C4}\u{3B5} \u{3C0}\u{3B1}\u{3C1}\u{3B1}\u{3C4}\u{3B5}\u{3C4}\u{3B1}\u{3BC}\u{3AD}\u{3BD}\u{3B1} \u{3B3}\u{3B9}\u{3B1} \u{3BD}\u{3B1} \u{3BE}\u{3B5}\u{3BA}\u{3B9}\u{3BD}\u{3AE}\u{3C3}\u{3B5}\u{3C4}\u{3B5} \u{3C4}\u{3B7} \u{3BC}\u{3B5}\u{3C4}\u{3B1}\u{3C6}\u{3BF}\u{3C1}\u{3AC}.`,
    "dragDescriptionTouch": `\u{3A0}\u{3B1}\u{3C4}\u{3AE}\u{3C3}\u{3C4}\u{3B5} \u{3B4}\u{3CD}\u{3BF} \u{3C6}\u{3BF}\u{3C1}\u{3AD}\u{3C2} \u{3B3}\u{3B9}\u{3B1} \u{3AD}\u{3BD}\u{3B1}\u{3C1}\u{3BE}\u{3B7} \u{3C4}\u{3B7}\u{3C2} \u{3BC}\u{3B5}\u{3C4}\u{3B1}\u{3C6}\u{3BF}\u{3C1}\u{3AC}\u{3C2}.`,
    "dragDescriptionVirtual": `\u{39A}\u{3AC}\u{3BD}\u{3C4}\u{3B5} \u{3BA}\u{3BB}\u{3B9}\u{3BA} \u{3B3}\u{3B9}\u{3B1} \u{3BD}\u{3B1} \u{3BE}\u{3B5}\u{3BA}\u{3B9}\u{3BD}\u{3AE}\u{3C3}\u{3B5}\u{3C4}\u{3B5} \u{3C4}\u{3B7} \u{3BC}\u{3B5}\u{3C4}\u{3B1}\u{3C6}\u{3BF}\u{3C1}\u{3AC}.`,
    "dragItem": (args)=>`\u{39C}\u{3B5}\u{3C4}\u{3B1}\u{3C6}\u{3BF}\u{3C1}\u{3AC} ${args.itemText}`,
    "dragSelectedItems": (args, formatter)=>`\u{39C}\u{3B5}\u{3C4}\u{3B1}\u{3C6}\u{3BF}\u{3C1}\u{3AC} \u{3C3}\u{3B5} ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} \u{3B5}\u{3C0}\u{3B9}\u{3BB}\u{3B5}\u{3B3}\u{3BC}\u{3AD}\u{3BD}\u{3BF} \u{3C3}\u{3C4}\u{3BF}\u{3B9}\u{3C7}\u{3B5}\u{3AF}\u{3BF}`,
            other: ()=>`${formatter.number(args.count)} \u{3B5}\u{3C0}\u{3B9}\u{3BB}\u{3B5}\u{3B3}\u{3BC}\u{3AD}\u{3BD}\u{3B1} \u{3C3}\u{3C4}\u{3BF}\u{3B9}\u{3C7}\u{3B5}\u{3AF}\u{3B1}`
        })}`,
    "dragSelectedKeyboard": (args, formatter)=>`\u{3A0}\u{3B1}\u{3C4}\u{3AE}\u{3C3}\u{3C4}\u{3B5} Enter \u{3B3}\u{3B9}\u{3B1} \u{3BD}\u{3B1} \u{3C3}\u{3CD}\u{3C1}\u{3B5}\u{3C4}\u{3B5} ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} \u{3B5}\u{3C0}\u{3B9}\u{3BB}\u{3B5}\u{3B3}\u{3BC}\u{3AD}\u{3BD}\u{3BF} \u{3C3}\u{3C4}\u{3BF}\u{3B9}\u{3C7}\u{3B5}\u{3AF}\u{3BF}`,
            other: ()=>`${formatter.number(args.count)} \u{3B5}\u{3C0}\u{3B9}\u{3BB}\u{3B5}\u{3B3}\u{3BC}\u{3AD}\u{3BD}\u{3B1} \u{3C3}\u{3C4}\u{3BF}\u{3B9}\u{3C7}\u{3B5}\u{3AF}\u{3B1}`
        })}.`,
    "dragSelectedKeyboardAlt": (args, formatter)=>`\u{3A0}\u{3B1}\u{3C4}\u{3AE}\u{3C3}\u{3C4}\u{3B5} Alt + Enter \u{3B3}\u{3B9}\u{3B1} \u{3BD}\u{3B1} \u{3C3}\u{3CD}\u{3C1}\u{3B5}\u{3C4}\u{3B5} ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} \u{3B5}\u{3C0}\u{3B9}\u{3BB}\u{3B5}\u{3B3}\u{3BC}\u{3AD}\u{3BD}\u{3BF} \u{3C3}\u{3C4}\u{3BF}\u{3B9}\u{3C7}\u{3B5}\u{3AF}\u{3BF}`,
            other: ()=>`${formatter.number(args.count)} \u{3B5}\u{3C0}\u{3B9}\u{3BB}\u{3B5}\u{3B3}\u{3BC}\u{3AD}\u{3BD}\u{3B1} \u{3C3}\u{3C4}\u{3BF}\u{3B9}\u{3C7}\u{3B5}\u{3AF}\u{3B1}`
        })}.`,
    "dragSelectedLongPress": (args, formatter)=>`\u{3A0}\u{3B1}\u{3C4}\u{3AE}\u{3C3}\u{3C4}\u{3B5} \u{3C0}\u{3B1}\u{3C1}\u{3B1}\u{3C4}\u{3B5}\u{3C4}\u{3B1}\u{3BC}\u{3AD}\u{3BD}\u{3B1} \u{3B3}\u{3B9}\u{3B1} \u{3BD}\u{3B1} \u{3C3}\u{3CD}\u{3C1}\u{3B5}\u{3C4}\u{3B5} ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} \u{3B5}\u{3C0}\u{3B9}\u{3BB}\u{3B5}\u{3B3}\u{3BC}\u{3AD}\u{3BD}\u{3BF} \u{3C3}\u{3C4}\u{3BF}\u{3B9}\u{3C7}\u{3B5}\u{3AF}\u{3BF}`,
            other: ()=>`${formatter.number(args.count)} \u{3B5}\u{3C0}\u{3B9}\u{3BB}\u{3B5}\u{3B3}\u{3BC}\u{3AD}\u{3BD}\u{3B1} \u{3C3}\u{3C4}\u{3BF}\u{3B9}\u{3C7}\u{3B5}\u{3AF}\u{3B1}`
        })}.`,
    "dragStartedKeyboard": `\u{397} \u{3BC}\u{3B5}\u{3C4}\u{3B1}\u{3C6}\u{3BF}\u{3C1}\u{3AC} \u{3BE}\u{3B5}\u{3BA}\u{3AF}\u{3BD}\u{3B7}\u{3C3}\u{3B5}. \u{3A0}\u{3B1}\u{3C4}\u{3AE}\u{3C3}\u{3C4}\u{3B5} \u{3C4}\u{3BF} \u{3C0}\u{3BB}\u{3AE}\u{3BA}\u{3C4}\u{3C1}\u{3BF} Tab \u{3B3}\u{3B9}\u{3B1} \u{3BD}\u{3B1} \u{3BC}\u{3B5}\u{3C4}\u{3B1}\u{3B2}\u{3B5}\u{3AF}\u{3C4}\u{3B5} \u{3C3}\u{3B5} \u{3AD}\u{3BD}\u{3B1}\u{3BD} \u{3C0}\u{3C1}\u{3BF}\u{3BF}\u{3C1}\u{3B9}\u{3C3}\u{3BC}\u{3CC} \u{3B1}\u{3C0}\u{3CC}\u{3B8}\u{3B5}\u{3C3}\u{3B7}\u{3C2} \u{3BA}\u{3B1}\u{3B9}, \u{3C3}\u{3C4}\u{3B7} \u{3C3}\u{3C5}\u{3BD}\u{3AD}\u{3C7}\u{3B5}\u{3B9}\u{3B1}, \u{3C0}\u{3B1}\u{3C4}\u{3AE}\u{3C3}\u{3C4}\u{3B5} Enter \u{3B3}\u{3B9}\u{3B1} \u{3B1}\u{3C0}\u{3CC}\u{3B8}\u{3B5}\u{3C3}\u{3B7} \u{3AE} \u{3C0}\u{3B1}\u{3C4}\u{3AE}\u{3C3}\u{3C4}\u{3B5} Escape \u{3B3}\u{3B9}\u{3B1} \u{3B1}\u{3BA}\u{3CD}\u{3C1}\u{3C9}\u{3C3}\u{3B7}.`,
    "dragStartedTouch": `\u{397} \u{3BC}\u{3B5}\u{3C4}\u{3B1}\u{3C6}\u{3BF}\u{3C1}\u{3AC} \u{3BE}\u{3B5}\u{3BA}\u{3AF}\u{3BD}\u{3B7}\u{3C3}\u{3B5}. \u{39C}\u{3B5}\u{3C4}\u{3B1}\u{3B2}\u{3B5}\u{3AF}\u{3C4}\u{3B5} \u{3C3}\u{3B5} \u{3AD}\u{3BD}\u{3B1}\u{3BD} \u{3C0}\u{3C1}\u{3BF}\u{3BF}\u{3C1}\u{3B9}\u{3C3}\u{3BC}\u{3CC} \u{3B1}\u{3C0}\u{3CC}\u{3B8}\u{3B5}\u{3C3}\u{3B7}\u{3C2} \u{3BA}\u{3B1}\u{3B9}, \u{3C3}\u{3C4}\u{3B7} \u{3C3}\u{3C5}\u{3BD}\u{3AD}\u{3C7}\u{3B5}\u{3B9}\u{3B1}, \u{3C0}\u{3B1}\u{3C4}\u{3AE}\u{3C3}\u{3C4}\u{3B5} \u{3B4}\u{3CD}\u{3BF} \u{3C6}\u{3BF}\u{3C1}\u{3AD}\u{3C2} \u{3B3}\u{3B9}\u{3B1} \u{3B1}\u{3C0}\u{3CC}\u{3B8}\u{3B5}\u{3C3}\u{3B7}.`,
    "dragStartedVirtual": `\u{397} \u{3BC}\u{3B5}\u{3C4}\u{3B1}\u{3C6}\u{3BF}\u{3C1}\u{3AC} \u{3BE}\u{3B5}\u{3BA}\u{3AF}\u{3BD}\u{3B7}\u{3C3}\u{3B5}. \u{39C}\u{3B5}\u{3C4}\u{3B1}\u{3B2}\u{3B5}\u{3AF}\u{3C4}\u{3B5} \u{3C3}\u{3B5} \u{3AD}\u{3BD}\u{3B1}\u{3BD} \u{3C0}\u{3C1}\u{3BF}\u{3BF}\u{3C1}\u{3B9}\u{3C3}\u{3BC}\u{3CC} \u{3B1}\u{3C0}\u{3CC}\u{3B8}\u{3B5}\u{3C3}\u{3B7}\u{3C2} \u{3BA}\u{3B1}\u{3B9}, \u{3C3}\u{3C4}\u{3B7} \u{3C3}\u{3C5}\u{3BD}\u{3AD}\u{3C7}\u{3B5}\u{3B9}\u{3B1}, \u{3BA}\u{3AC}\u{3BD}\u{3C4}\u{3B5} \u{3BA}\u{3BB}\u{3B9}\u{3BA} \u{3AE} \u{3C0}\u{3B1}\u{3C4}\u{3AE}\u{3C3}\u{3C4}\u{3B5} Enter \u{3B3}\u{3B9}\u{3B1} \u{3B1}\u{3C0}\u{3CC}\u{3B8}\u{3B5}\u{3C3}\u{3B7}.`,
    "dropCanceled": `\u{397} \u{3B1}\u{3C0}\u{3CC}\u{3B8}\u{3B5}\u{3C3}\u{3B7} \u{3B1}\u{3BA}\u{3C5}\u{3C1}\u{3CE}\u{3B8}\u{3B7}\u{3BA}\u{3B5}.`,
    "dropComplete": `\u{397} \u{3B1}\u{3C0}\u{3CC}\u{3B8}\u{3B5}\u{3C3}\u{3B7} \u{3BF}\u{3BB}\u{3BF}\u{3BA}\u{3BB}\u{3B7}\u{3C1}\u{3CE}\u{3B8}\u{3B7}\u{3BA}\u{3B5}.`,
    "dropDescriptionKeyboard": `\u{3A0}\u{3B1}\u{3C4}\u{3AE}\u{3C3}\u{3C4}\u{3B5} Enter \u{3B3}\u{3B9}\u{3B1} \u{3B1}\u{3C0}\u{3CC}\u{3B8}\u{3B5}\u{3C3}\u{3B7}. \u{3A0}\u{3B1}\u{3C4}\u{3AE}\u{3C3}\u{3C4}\u{3B5} Escape \u{3B3}\u{3B9}\u{3B1} \u{3B1}\u{3BA}\u{3CD}\u{3C1}\u{3C9}\u{3C3}\u{3B7} \u{3C4}\u{3B7}\u{3C2} \u{3BC}\u{3B5}\u{3C4}\u{3B1}\u{3C6}\u{3BF}\u{3C1}\u{3AC}\u{3C2}.`,
    "dropDescriptionTouch": `\u{3A0}\u{3B1}\u{3C4}\u{3AE}\u{3C3}\u{3C4}\u{3B5} \u{3B4}\u{3CD}\u{3BF} \u{3C6}\u{3BF}\u{3C1}\u{3AD}\u{3C2} \u{3B3}\u{3B9}\u{3B1} \u{3B1}\u{3C0}\u{3CC}\u{3B8}\u{3B5}\u{3C3}\u{3B7}.`,
    "dropDescriptionVirtual": `\u{39A}\u{3AC}\u{3BD}\u{3C4}\u{3B5} \u{3BA}\u{3BB}\u{3B9}\u{3BA} \u{3B3}\u{3B9}\u{3B1} \u{3B1}\u{3C0}\u{3CC}\u{3B8}\u{3B5}\u{3C3}\u{3B7}.`,
    "dropIndicator": `\u{3B4}\u{3B5}\u{3AF}\u{3BA}\u{3C4}\u{3B7}\u{3C2} \u{3B1}\u{3C0}\u{3CC}\u{3B8}\u{3B5}\u{3C3}\u{3B7}\u{3C2}`,
    "dropOnItem": (args)=>`\u{391}\u{3C0}\u{3CC}\u{3B8}\u{3B5}\u{3C3}\u{3B7} \u{3C3}\u{3B5} ${args.itemText}`,
    "dropOnRoot": `\u{391}\u{3C0}\u{3CC}\u{3B8}\u{3B5}\u{3C3}\u{3B7} \u{3C3}\u{3B5}`,
    "endDragKeyboard": `\u{39C}\u{3B5}\u{3C4}\u{3B1}\u{3C6}\u{3BF}\u{3C1}\u{3AC} \u{3C3}\u{3B5} \u{3B5}\u{3BE}\u{3AD}\u{3BB}\u{3B9}\u{3BE}\u{3B7}. \u{3A0}\u{3B1}\u{3C4}\u{3AE}\u{3C3}\u{3C4}\u{3B5} Enter \u{3B3}\u{3B9}\u{3B1} \u{3B1}\u{3BA}\u{3CD}\u{3C1}\u{3C9}\u{3C3}\u{3B7} \u{3C4}\u{3B7}\u{3C2} \u{3BC}\u{3B5}\u{3C4}\u{3B1}\u{3C6}\u{3BF}\u{3C1}\u{3AC}\u{3C2}.`,
    "endDragTouch": `\u{39C}\u{3B5}\u{3C4}\u{3B1}\u{3C6}\u{3BF}\u{3C1}\u{3AC} \u{3C3}\u{3B5} \u{3B5}\u{3BE}\u{3AD}\u{3BB}\u{3B9}\u{3BE}\u{3B7}. \u{3A0}\u{3B1}\u{3C4}\u{3AE}\u{3C3}\u{3C4}\u{3B5} \u{3B4}\u{3CD}\u{3BF} \u{3C6}\u{3BF}\u{3C1}\u{3AD}\u{3C2} \u{3B3}\u{3B9}\u{3B1} \u{3B1}\u{3BA}\u{3CD}\u{3C1}\u{3C9}\u{3C3}\u{3B7} \u{3C4}\u{3B7}\u{3C2} \u{3BC}\u{3B5}\u{3C4}\u{3B1}\u{3C6}\u{3BF}\u{3C1}\u{3AC}\u{3C2}.`,
    "endDragVirtual": `\u{39C}\u{3B5}\u{3C4}\u{3B1}\u{3C6}\u{3BF}\u{3C1}\u{3AC} \u{3C3}\u{3B5} \u{3B5}\u{3BE}\u{3AD}\u{3BB}\u{3B9}\u{3BE}\u{3B7}. \u{39A}\u{3AC}\u{3BD}\u{3C4}\u{3B5} \u{3BA}\u{3BB}\u{3B9}\u{3BA} \u{3B3}\u{3B9}\u{3B1} \u{3B1}\u{3BA}\u{3CD}\u{3C1}\u{3C9}\u{3C3}\u{3B7} \u{3C4}\u{3B7}\u{3C2} \u{3BC}\u{3B5}\u{3C4}\u{3B1}\u{3C6}\u{3BF}\u{3C1}\u{3AC}\u{3C2}.`,
    "insertAfter": (args)=>`\u{395}\u{3B9}\u{3C3}\u{3B1}\u{3B3}\u{3C9}\u{3B3}\u{3AE} \u{3BC}\u{3B5}\u{3C4}\u{3AC} \u{3B1}\u{3C0}\u{3CC} ${args.itemText}`,
    "insertBefore": (args)=>`\u{395}\u{3B9}\u{3C3}\u{3B1}\u{3B3}\u{3C9}\u{3B3}\u{3AE} \u{3C0}\u{3C1}\u{3B9}\u{3BD} \u{3B1}\u{3C0}\u{3CC} ${args.itemText}`,
    "insertBetween": (args)=>`\u{395}\u{3B9}\u{3C3}\u{3B1}\u{3B3}\u{3C9}\u{3B3}\u{3AE} \u{3BC}\u{3B5}\u{3C4}\u{3B1}\u{3BE}\u{3CD} ${args.beforeItemText} \u{3BA}\u{3B1}\u{3B9} ${args.afterItemText}`
};

},{}],"hPbOW":[function(require,module,exports) {
module.exports = {
    "dragItem": (args)=>`Drag ${args.itemText}`,
    "dragSelectedItems": (args, formatter)=>`Drag ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} selected item`,
            other: ()=>`${formatter.number(args.count)} selected items`
        })}`,
    "dragDescriptionKeyboard": `Press Enter to start dragging.`,
    "dragDescriptionKeyboardAlt": `Press Alt + Enter to start dragging.`,
    "dragDescriptionTouch": `Double tap to start dragging.`,
    "dragDescriptionVirtual": `Click to start dragging.`,
    "dragDescriptionLongPress": `Long press to start dragging.`,
    "dragSelectedKeyboard": (args, formatter)=>`Press Enter to drag ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} selected item`,
            other: ()=>`${formatter.number(args.count)} selected items`
        })}.`,
    "dragSelectedKeyboardAlt": (args, formatter)=>`Press Alt + Enter to drag ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} selected item`,
            other: ()=>`${formatter.number(args.count)} selected items`
        })}.`,
    "dragSelectedLongPress": (args, formatter)=>`Long press to drag ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} selected item`,
            other: ()=>`${formatter.number(args.count)} selected items`
        })}.`,
    "dragStartedKeyboard": `Started dragging. Press Tab to navigate to a drop target, then press Enter to drop, or press Escape to cancel.`,
    "dragStartedTouch": `Started dragging. Navigate to a drop target, then double tap to drop.`,
    "dragStartedVirtual": `Started dragging. Navigate to a drop target, then click or press Enter to drop.`,
    "endDragKeyboard": `Dragging. Press Enter to cancel drag.`,
    "endDragTouch": `Dragging. Double tap to cancel drag.`,
    "endDragVirtual": `Dragging. Click to cancel drag.`,
    "dropDescriptionKeyboard": `Press Enter to drop. Press Escape to cancel drag.`,
    "dropDescriptionTouch": `Double tap to drop.`,
    "dropDescriptionVirtual": `Click to drop.`,
    "dropCanceled": `Drop canceled.`,
    "dropComplete": `Drop complete.`,
    "dropIndicator": `drop indicator`,
    "dropOnRoot": `Drop on`,
    "dropOnItem": (args)=>`Drop on ${args.itemText}`,
    "insertBefore": (args)=>`Insert before ${args.itemText}`,
    "insertBetween": (args)=>`Insert between ${args.beforeItemText} and ${args.afterItemText}`,
    "insertAfter": (args)=>`Insert after ${args.itemText}`
};

},{}],"6tYHN":[function(require,module,exports) {
module.exports = {
    "dragDescriptionKeyboard": `Pulse Intro para empezar a arrastrar.`,
    "dragDescriptionKeyboardAlt": `Pulse Intro para empezar a arrastrar.`,
    "dragDescriptionLongPress": `Mantenga pulsado para comenzar a arrastrar.`,
    "dragDescriptionTouch": `Pulse dos veces para iniciar el arrastre.`,
    "dragDescriptionVirtual": `Haga clic para iniciar el arrastre.`,
    "dragItem": (args)=>`Arrastrar ${args.itemText}`,
    "dragSelectedItems": (args, formatter)=>`Arrastrar ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} elemento seleccionado`,
            other: ()=>`${formatter.number(args.count)} elementos seleccionados`
        })}`,
    "dragSelectedKeyboard": (args, formatter)=>`Pulse Intro para arrastrar ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} elemento seleccionado`,
            other: ()=>`${formatter.number(args.count)} elementos seleccionados`
        })}.`,
    "dragSelectedKeyboardAlt": (args, formatter)=>`Pulse Alt + Intro para arrastrar ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} elemento seleccionado`,
            other: ()=>`${formatter.number(args.count)} elementos seleccionados`
        })}.`,
    "dragSelectedLongPress": (args, formatter)=>`Mantenga pulsado para arrastrar ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} elemento seleccionado`,
            other: ()=>`${formatter.number(args.count)} elementos seleccionados`
        })}.`,
    "dragStartedKeyboard": `Se ha empezado a arrastrar. Pulse el tabulador para ir al p\xfablico destinatario donde se vaya a colocar y, a continuaci\xf3n, pulse Intro para soltar, o pulse Escape para cancelar.`,
    "dragStartedTouch": `Se ha empezado a arrastrar. Vaya al p\xfablico destinatario donde se vaya a colocar y, a continuaci\xf3n, pulse dos veces para soltar.`,
    "dragStartedVirtual": `Se ha empezado a arrastrar. Vaya al p\xfablico destinatario donde se vaya a colocar y, a continuaci\xf3n, haga clic o pulse Intro para soltar.`,
    "dropCanceled": `Se ha cancelado la colocaci\xf3n.`,
    "dropComplete": `Colocaci\xf3n finalizada.`,
    "dropDescriptionKeyboard": `Pulse Intro para soltar. Pulse Escape para cancelar el arrastre.`,
    "dropDescriptionTouch": `Pulse dos veces para soltar.`,
    "dropDescriptionVirtual": `Haga clic para soltar.`,
    "dropIndicator": `indicador de colocaci\xf3n`,
    "dropOnItem": (args)=>`Soltar en ${args.itemText}`,
    "dropOnRoot": `Soltar en`,
    "endDragKeyboard": `Arrastrando. Pulse Intro para cancelar el arrastre.`,
    "endDragTouch": `Arrastrando. Pulse dos veces para cancelar el arrastre.`,
    "endDragVirtual": `Arrastrando. Haga clic para cancelar el arrastre.`,
    "insertAfter": (args)=>`Insertar despu\xe9s de ${args.itemText}`,
    "insertBefore": (args)=>`Insertar antes de ${args.itemText}`,
    "insertBetween": (args)=>`Insertar entre ${args.beforeItemText} y ${args.afterItemText}`
};

},{}],"iVCtS":[function(require,module,exports) {
module.exports = {
    "dragDescriptionKeyboard": `Lohistamise alustamiseks vajutage klahvi Enter.`,
    "dragDescriptionKeyboardAlt": `Lohistamise alustamiseks vajutage klahvikombinatsiooni Alt + Enter.`,
    "dragDescriptionLongPress": `Vajutage pikalt lohistamise alustamiseks.`,
    "dragDescriptionTouch": `Topeltpuudutage lohistamise alustamiseks.`,
    "dragDescriptionVirtual": `Kl\xf5psake lohistamise alustamiseks.`,
    "dragItem": (args)=>`Lohista ${args.itemText}`,
    "dragSelectedItems": (args, formatter)=>`Lohista ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} valitud \xfcksust`,
            other: ()=>`${formatter.number(args.count)} valitud \xfcksust`
        })}`,
    "dragSelectedKeyboard": (args, formatter)=>`${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} valitud \xfcksuse`,
            other: ()=>`${formatter.number(args.count)} valitud \xfcksuse`
        })} lohistamiseks vajutage sisestusklahvi Enter.`,
    "dragSelectedKeyboardAlt": (args, formatter)=>`Lohistamiseks vajutage klahvikombinatsiooni Alt + Enter ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} valitud \xfcksuse`,
            other: ()=>`${formatter.number(args.count)} valitud \xfcksuse`
        })} jaoks.`,
    "dragSelectedLongPress": (args, formatter)=>`Pikk vajutus ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} valitud \xfcksuse`,
            other: ()=>`${formatter.number(args.count)} valitud \xfcksuse`
        })} lohistamiseks.`,
    "dragStartedKeyboard": `Alustati lohistamist. Kukutamise sihtm\xe4rgi juurde navigeerimiseks vajutage klahvi Tab, seej\xe4rel vajutage kukutamiseks klahvi Enter v\xf5i loobumiseks klahvi Escape.`,
    "dragStartedTouch": `Alustati lohistamist. Navigeerige kukutamise sihtm\xe4rgi juurde ja topeltpuudutage kukutamiseks.`,
    "dragStartedVirtual": `Alustati lohistamist. Navigeerige kukutamise sihtm\xe4rgi juurde ja kukutamiseks kl\xf5psake v\xf5i vajutage klahvi Enter.`,
    "dropCanceled": `Lohistamisest loobuti.`,
    "dropComplete": `Lohistamine on tehtud.`,
    "dropDescriptionKeyboard": `Kukutamiseks vajutage klahvi Enter. Lohistamisest loobumiseks vajutage klahvi Escape.`,
    "dropDescriptionTouch": `Kukutamiseks topeltpuudutage.`,
    "dropDescriptionVirtual": `Kukutamiseks kl\xf5psake.`,
    "dropIndicator": `lohistamise indikaator`,
    "dropOnItem": (args)=>`Kukuta asukohta ${args.itemText}`,
    "dropOnRoot": `Kukuta asukohta`,
    "endDragKeyboard": `Lohistamine. Lohistamisest loobumiseks vajutage klahvi Enter.`,
    "endDragTouch": `Lohistamine. Lohistamisest loobumiseks topeltpuudutage.`,
    "endDragVirtual": `Lohistamine. Lohistamisest loobumiseks kl\xf5psake.`,
    "insertAfter": (args)=>`Sisesta ${args.itemText} j\xe4rele`,
    "insertBefore": (args)=>`Sisesta ${args.itemText} ette`,
    "insertBetween": (args)=>`Sisesta ${args.beforeItemText} ja ${args.afterItemText} vahele`
};

},{}],"k8s3C":[function(require,module,exports) {
module.exports = {
    "dragDescriptionKeyboard": `Aloita vet\xe4minen painamalla Enter-n\xe4pp\xe4int\xe4.`,
    "dragDescriptionKeyboardAlt": `Aloita vet\xe4minen painamalla Alt + Enter -n\xe4pp\xe4inyhdistelm\xe4\xe4.`,
    "dragDescriptionLongPress": `Aloita vet\xe4minen pit\xe4m\xe4ll\xe4 painettuna.`,
    "dragDescriptionTouch": `Aloita vet\xe4minen kaksoisnapauttamalla.`,
    "dragDescriptionVirtual": `Aloita vet\xe4minen napsauttamalla.`,
    "dragItem": (args)=>`Ved\xe4 kohdetta ${args.itemText}`,
    "dragSelectedItems": (args, formatter)=>`Ved\xe4 ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} valittua kohdetta`,
            other: ()=>`${formatter.number(args.count)} valittua kohdetta`
        })}`,
    "dragSelectedKeyboard": (args, formatter)=>`Ved\xe4 painamalla Enter ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} valittu kohde`,
            other: ()=>`${formatter.number(args.count)} valittua kohdetta`
        })}.`,
    "dragSelectedKeyboardAlt": (args, formatter)=>`Ved\xe4 painamalla Alt + Enter ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} valittu kohde`,
            other: ()=>`${formatter.number(args.count)} valittua kohdetta`
        })}.`,
    "dragSelectedLongPress": (args, formatter)=>`Ved\xe4 pit\xe4m\xe4ll\xe4 painettuna ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} valittu kohde`,
            other: ()=>`${formatter.number(args.count)} valittua kohdetta`
        })}.`,
    "dragStartedKeyboard": `Vet\xe4minen aloitettu. Siirry pudotuskohteeseen painamalla sarkainn\xe4pp\xe4int\xe4 ja sitten pudota painamalla Enter-n\xe4pp\xe4int\xe4 tai peruuta painamalla Escape-n\xe4pp\xe4int\xe4.`,
    "dragStartedTouch": `Vet\xe4minen aloitettu. Siirry pudotuskohteeseen ja pudota kaksoisnapauttamalla.`,
    "dragStartedVirtual": `Vet\xe4minen aloitettu. Siirry pudotuskohteeseen ja pudota napsauttamalla tai painamalla Enter-n\xe4pp\xe4int\xe4.`,
    "dropCanceled": `Pudotus peruutettu.`,
    "dropComplete": `Pudotus suoritettu.`,
    "dropDescriptionKeyboard": `Pudota painamalla Enter-n\xe4pp\xe4int\xe4. Peruuta vet\xe4minen painamalla Escape-n\xe4pp\xe4int\xe4.`,
    "dropDescriptionTouch": `Pudota kaksoisnapauttamalla.`,
    "dropDescriptionVirtual": `Pudota napsauttamalla.`,
    "dropIndicator": `pudotuksen ilmaisin`,
    "dropOnItem": (args)=>`Pudota kohteeseen ${args.itemText}`,
    "dropOnRoot": `Pudota kohteeseen`,
    "endDragKeyboard": `Vedet\xe4\xe4n. Peruuta vet\xe4minen painamalla Enter-n\xe4pp\xe4int\xe4.`,
    "endDragTouch": `Vedet\xe4\xe4n. Peruuta vet\xe4minen kaksoisnapauttamalla.`,
    "endDragVirtual": `Vedet\xe4\xe4n. Peruuta vet\xe4minen napsauttamalla.`,
    "insertAfter": (args)=>`Lis\xe4\xe4 kohteen ${args.itemText} j\xe4lkeen`,
    "insertBefore": (args)=>`Lis\xe4\xe4 ennen kohdetta ${args.itemText}`,
    "insertBetween": (args)=>`Lis\xe4\xe4 kohteiden ${args.beforeItemText} ja ${args.afterItemText} v\xe4liin`
};

},{}],"6dt2s":[function(require,module,exports) {
module.exports = {
    "dragDescriptionKeyboard": `Appuyez sur Entr\xe9e pour commencer le d\xe9placement.`,
    "dragDescriptionKeyboardAlt": `Appuyez sur Alt\xa0+\xa0Entr\xe9e pour commencer \xe0 faire glisser.`,
    "dragDescriptionLongPress": `Appuyez de mani\xe8re prolong\xe9e pour commencer \xe0 faire glisser.`,
    "dragDescriptionTouch": `Touchez deux fois pour commencer le d\xe9placement.`,
    "dragDescriptionVirtual": `Cliquez pour commencer le d\xe9placement.`,
    "dragItem": (args)=>`D\xe9placer ${args.itemText}`,
    "dragSelectedItems": (args, formatter)=>`D\xe9placer ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} \xe9l\xe9ment s\xe9lectionn\xe9`,
            other: ()=>`${formatter.number(args.count)} \xe9l\xe9ments s\xe9lectionn\xe9s`
        })}`,
    "dragSelectedKeyboard": (args, formatter)=>`Appuyez sur Entr\xe9e pour faire glisser ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} \xe9l\xe9ment s\xe9lectionn\xe9`,
            other: ()=>`${formatter.number(args.count)} \xe9l\xe9ments s\xe9lectionn\xe9s`
        })}.`,
    "dragSelectedKeyboardAlt": (args, formatter)=>`Appuyez sur Alt\xa0+\xa0Entr\xe9e pour faire glisser ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} \xe9l\xe9ment s\xe9lectionn\xe9`,
            other: ()=>`${formatter.number(args.count)} \xe9l\xe9ments s\xe9lectionn\xe9s`
        })}.`,
    "dragSelectedLongPress": (args, formatter)=>`Appuyez de mani\xe8re prolong\xe9e pour faire glisser ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} \xe9l\xe9ment s\xe9lectionn\xe9`,
            other: ()=>`${formatter.number(args.count)} \xe9l\xe9ments s\xe9lectionn\xe9s`
        })}.`,
    "dragStartedKeyboard": `D\xe9placement commenc\xe9. Appuyez sur Tabulation pour acc\xe9der \xe0 une cible de d\xe9p\xf4t, puis appuyez sur Entr\xe9e pour d\xe9poser, ou appuyez sur \xc9chap pour annuler.`,
    "dragStartedTouch": `D\xe9placement commenc\xe9. Acc\xe9dez \xe0 une cible de d\xe9p\xf4t, puis touchez deux fois pour d\xe9poser.`,
    "dragStartedVirtual": `D\xe9placement commenc\xe9. Acc\xe9dez \xe0 une cible de d\xe9p\xf4t, puis cliquez ou appuyez sur Entr\xe9e pour d\xe9poser.`,
    "dropCanceled": `D\xe9p\xf4t annul\xe9.`,
    "dropComplete": `D\xe9p\xf4t termin\xe9.`,
    "dropDescriptionKeyboard": `Appuyez sur Entr\xe9e pour d\xe9poser. Appuyez sur \xc9chap pour annuler le d\xe9placement.`,
    "dropDescriptionTouch": `Touchez deux fois pour d\xe9poser.`,
    "dropDescriptionVirtual": `Cliquez pour d\xe9poser.`,
    "dropIndicator": `indicateur de d\xe9p\xf4t`,
    "dropOnItem": (args)=>`D\xe9poser sur ${args.itemText}`,
    "dropOnRoot": `D\xe9poser sur`,
    "endDragKeyboard": `D\xe9placement. Appuyez sur Entr\xe9e pour annuler le d\xe9placement.`,
    "endDragTouch": `D\xe9placement. Touchez deux fois pour annuler le d\xe9placement.`,
    "endDragVirtual": `D\xe9placement. Cliquez pour annuler le d\xe9placement.`,
    "insertAfter": (args)=>`Ins\xe9rer apr\xe8s ${args.itemText}`,
    "insertBefore": (args)=>`Ins\xe9rer avant ${args.itemText}`,
    "insertBetween": (args)=>`Ins\xe9rer entre ${args.beforeItemText} et ${args.afterItemText}`
};

},{}],"29SjT":[function(require,module,exports) {
module.exports = {
    "dragDescriptionKeyboard": `\u{5D4}\u{5E7}\u{5E9} \u{5E2}\u{5DC} Enter \u{5DB}\u{5D3}\u{5D9} \u{5DC}\u{5D4}\u{5EA}\u{5D7}\u{5D9}\u{5DC} \u{5DC}\u{5D2}\u{5E8}\u{5D5}\u{5E8}.`,
    "dragDescriptionKeyboardAlt": `\u{5D4}\u{5E7}\u{5E9} Alt + Enter \u{5DB}\u{5D3}\u{5D9} \u{5DC}\u{5D4}\u{5EA}\u{5D7}\u{5D9}\u{5DC} \u{5DC}\u{5D2}\u{5E8}\u{5D5}\u{5E8}.`,
    "dragDescriptionLongPress": `\u{5DC}\u{5D7}\u{5E5} \u{5DC}\u{5D7}\u{5D9}\u{5E6}\u{5D4} \u{5D0}\u{5E8}\u{5D5}\u{5DB}\u{5D4} \u{5DB}\u{5D3}\u{5D9} \u{5DC}\u{5D4}\u{5EA}\u{5D7}\u{5D9}\u{5DC} \u{5DC}\u{5D2}\u{5E8}\u{5D5}\u{5E8}.`,
    "dragDescriptionTouch": `\u{5D4}\u{5E7}\u{5E9} \u{5E4}\u{5E2}\u{5DE}\u{5D9}\u{5D9}\u{5DD} \u{5DB}\u{5D3}\u{5D9} \u{5DC}\u{5D4}\u{5EA}\u{5D7}\u{5D9}\u{5DC} \u{5D1}\u{5D2}\u{5E8}\u{5D9}\u{5E8}\u{5D4}.`,
    "dragDescriptionVirtual": `\u{5DC}\u{5D7}\u{5E5} \u{5DB}\u{5D3}\u{5D9} \u{5DC}\u{5D4}\u{5EA}\u{5D7}\u{5D9}\u{5DC} \u{5DC}\u{5D2}\u{5E8}\u{5D5}\u{5E8}.`,
    "dragItem": (args)=>`\u{5D2}\u{5E8}\u{5D5}\u{5E8} \u{5D0}\u{5EA} ${args.itemText}`,
    "dragSelectedItems": (args, formatter)=>`\u{5D2}\u{5E8}\u{5D5}\u{5E8} ${formatter.plural(args.count, {
            one: ()=>`\u{5E4}\u{5E8}\u{5D9}\u{5D8} \u{5E0}\u{5D1}\u{5D7}\u{5E8} ${formatter.number(args.count)}`,
            other: ()=>`${formatter.number(args.count)} \u{5E4}\u{5E8}\u{5D9}\u{5D8}\u{5D9}\u{5DD} \u{5E9}\u{5E0}\u{5D1}\u{5D7}\u{5E8}\u{5D5}`
        })}`,
    "dragSelectedKeyboard": (args, formatter)=>`\u{5D4}\u{5E7}\u{5E9} \u{5E2}\u{5DC} Enter \u{5DB}\u{5D3}\u{5D9} \u{5DC}\u{5D2}\u{5E8}\u{5D5}\u{5E8} ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} \u{5E4}\u{5E8}\u{5D9}\u{5D8} \u{5E9}\u{5E0}\u{5D1}\u{5D7}\u{5E8}`,
            other: ()=>`${formatter.number(args.count)} \u{5E4}\u{5E8}\u{5D9}\u{5D8}\u{5D9}\u{5DD} \u{5E9}\u{5E0}\u{5D1}\u{5D7}\u{5E8}\u{5D5}`
        })}.`,
    "dragSelectedKeyboardAlt": (args, formatter)=>`\u{5D4}\u{5E7}\u{5E9} Alt + Enter \u{5DB}\u{5D3}\u{5D9} \u{5DC}\u{5D2}\u{5E8}\u{5D5}\u{5E8} ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} \u{5E4}\u{5E8}\u{5D9}\u{5D8} \u{5E9}\u{5E0}\u{5D1}\u{5D7}\u{5E8}`,
            other: ()=>`${formatter.number(args.count)} \u{5E4}\u{5E8}\u{5D9}\u{5D8}\u{5D9}\u{5DD} \u{5E9}\u{5E0}\u{5D1}\u{5D7}\u{5E8}\u{5D5}`
        })}.`,
    "dragSelectedLongPress": (args, formatter)=>`\u{5DC}\u{5D7}\u{5E5} \u{5DC}\u{5D7}\u{5D9}\u{5E6}\u{5D4} \u{5D0}\u{5E8}\u{5D5}\u{5DB}\u{5D4} \u{5DB}\u{5D3}\u{5D9} \u{5DC}\u{5D2}\u{5E8}\u{5D5}\u{5E8} ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} \u{5E4}\u{5E8}\u{5D9}\u{5D8} \u{5E9}\u{5E0}\u{5D1}\u{5D7}\u{5E8}`,
            other: ()=>`${formatter.number(args.count)} \u{5E4}\u{5E8}\u{5D9}\u{5D8}\u{5D9}\u{5DD} \u{5E9}\u{5E0}\u{5D1}\u{5D7}\u{5E8}\u{5D5}`
        })}.`,
    "dragStartedKeyboard": `\u{5D4}\u{5EA}\u{5D7}\u{5DC}\u{5EA} \u{5DC}\u{5D2}\u{5E8}\u{5D5}\u{5E8}. \u{5D4}\u{5E7}\u{5E9} \u{5E2}\u{5DC} Tab \u{5DB}\u{5D3}\u{5D9} \u{5DC}\u{5E0}\u{5D5}\u{5D5}\u{5D8} \u{5DC}\u{5E0}\u{5E7}\u{5D5}\u{5D3}\u{5EA} \u{5D4}\u{5D2}\u{5E8}\u{5D9}\u{5E8}\u{5D4} \u{5D5}\u{5DC}\u{5D0}\u{5D7}\u{5E8} \u{5DE}\u{5DB}\u{5DF} \u{5D4}\u{5E7}\u{5E9} \u{5E2}\u{5DC} Enter \u{5DB}\u{5D3}\u{5D9} \u{5DC}\u{5E9}\u{5D7}\u{5E8}\u{5E8} \u{5D0}\u{5D5} \u{5E2}\u{5DC} Escape \u{5DB}\u{5D3}\u{5D9} \u{5DC}\u{5D1}\u{5D8}\u{5DC}.`,
    "dragStartedTouch": `\u{5D4}\u{5EA}\u{5D7}\u{5DC}\u{5EA} \u{5DC}\u{5D2}\u{5E8}\u{5D5}\u{5E8}. \u{5E0}\u{5D5}\u{5D5}\u{5D8} \u{5DC}\u{5E0}\u{5E7}\u{5D5}\u{5D3}\u{5EA} \u{5D4}\u{5E9}\u{5D7}\u{5E8}\u{5D5}\u{5E8} \u{5D5}\u{5DC}\u{5D0}\u{5D7}\u{5E8} \u{5DE}\u{5DB}\u{5DF} \u{5D4}\u{5E7}\u{5E9} \u{5E4}\u{5E2}\u{5DE}\u{5D9}\u{5D9}\u{5DD} \u{5DB}\u{5D3}\u{5D9} \u{5DC}\u{5E9}\u{5D7}\u{5E8}\u{5E8}.`,
    "dragStartedVirtual": `\u{5D4}\u{5EA}\u{5D7}\u{5DC}\u{5EA} \u{5DC}\u{5D2}\u{5E8}\u{5D5}\u{5E8}. \u{5E0}\u{5D5}\u{5D5}\u{5D8} \u{5DC}\u{5E0}\u{5E7}\u{5D5}\u{5D3}\u{5EA} \u{5D4}\u{5E9}\u{5D7}\u{5E8}\u{5D5}\u{5E8} \u{5D5}\u{5DC}\u{5D0}\u{5D7}\u{5E8} \u{5DE}\u{5DB}\u{5DF} \u{5DC}\u{5D7}\u{5E5} \u{5D0}\u{5D5} \u{5D4}\u{5E7}\u{5E9} \u{5E2}\u{5DC} Enter \u{5DB}\u{5D3}\u{5D9} \u{5DC}\u{5E9}\u{5D7}\u{5E8}\u{5E8}.`,
    "dropCanceled": `\u{5D4}\u{5E9}\u{5D7}\u{5E8}\u{5D5}\u{5E8} \u{5D1}\u{5D5}\u{5D8}\u{5DC}.`,
    "dropComplete": `\u{5D4}\u{5E9}\u{5D7}\u{5E8}\u{5D5}\u{5E8} \u{5D4}\u{5D5}\u{5E9}\u{5DC}\u{5DD}.`,
    "dropDescriptionKeyboard": `\u{5D4}\u{5E7}\u{5E9} \u{5E2}\u{5DC} Enter \u{5DB}\u{5D3}\u{5D9} \u{5DC}\u{5E9}\u{5D7}\u{5E8}\u{5E8}. \u{5D4}\u{5E7}\u{5E9} \u{5E2}\u{5DC} Escape \u{5DB}\u{5D3}\u{5D9} \u{5DC}\u{5D1}\u{5D8}\u{5DC} \u{5D0}\u{5EA} \u{5D4}\u{5D2}\u{5E8}\u{5D9}\u{5E8}\u{5D4}.`,
    "dropDescriptionTouch": `\u{5D4}\u{5E7}\u{5E9} \u{5E4}\u{5E2}\u{5DE}\u{5D9}\u{5D9}\u{5DD} \u{5DB}\u{5D3}\u{5D9} \u{5DC}\u{5E9}\u{5D7}\u{5E8}\u{5E8}.`,
    "dropDescriptionVirtual": `\u{5DC}\u{5D7}\u{5E5} \u{5DB}\u{5D3}\u{5D9} \u{5DC}\u{5E9}\u{5D7}\u{5E8}\u{5E8}.`,
    "dropIndicator": `\u{5DE}\u{5D7}\u{5D5}\u{5D5}\u{5DF} \u{5E9}\u{5D7}\u{5E8}\u{5D5}\u{5E8}`,
    "dropOnItem": (args)=>`\u{5E9}\u{5D7}\u{5E8}\u{5E8} \u{5E2}\u{5DC} ${args.itemText}`,
    "dropOnRoot": `\u{5E9}\u{5D7}\u{5E8}\u{5E8} \u{5E2}\u{5DC}`,
    "endDragKeyboard": `\u{5D2}\u{5D5}\u{5E8}\u{5E8}. \u{5D4}\u{5E7}\u{5E9} \u{5E2}\u{5DC} Enter \u{5DB}\u{5D3}\u{5D9} \u{5DC}\u{5D1}\u{5D8}\u{5DC} \u{5D0}\u{5EA} \u{5D4}\u{5D2}\u{5E8}\u{5D9}\u{5E8}\u{5D4}.`,
    "endDragTouch": `\u{5D2}\u{5D5}\u{5E8}\u{5E8}. \u{5D4}\u{5E7}\u{5E9} \u{5E4}\u{5E2}\u{5DE}\u{5D9}\u{5D9}\u{5DD} \u{5DB}\u{5D3}\u{5D9} \u{5DC}\u{5D1}\u{5D8}\u{5DC} \u{5D0}\u{5EA} \u{5D4}\u{5D2}\u{5E8}\u{5D9}\u{5E8}\u{5D4}.`,
    "endDragVirtual": `\u{5D2}\u{5D5}\u{5E8}\u{5E8}. \u{5DC}\u{5D7}\u{5E5} \u{5DB}\u{5D3}\u{5D9} \u{5DC}\u{5D1}\u{5D8}\u{5DC} \u{5D0}\u{5EA} \u{5D4}\u{5D2}\u{5E8}\u{5D9}\u{5E8}\u{5D4}.`,
    "insertAfter": (args)=>`\u{5D4}\u{5D5}\u{5E1}\u{5E3} \u{5D0}\u{5D7}\u{5E8}\u{5D9} ${args.itemText}`,
    "insertBefore": (args)=>`\u{5D4}\u{5D5}\u{5E1}\u{5E3} \u{5DC}\u{5E4}\u{5E0}\u{5D9} ${args.itemText}`,
    "insertBetween": (args)=>`\u{5D4}\u{5D5}\u{5E1}\u{5E3} \u{5D1}\u{5D9}\u{5DF} ${args.beforeItemText} \u{5DC}\u{5D1}\u{5D9}\u{5DF} ${args.afterItemText}`
};

},{}],"h4ZZ1":[function(require,module,exports) {
module.exports = {
    "dragDescriptionKeyboard": `Pritisnite Enter da biste po\u{10D}eli povla\u{10D}iti.`,
    "dragDescriptionKeyboardAlt": `Pritisnite Alt + Enter za po\u{10D}etak povla\u{10D}enja.`,
    "dragDescriptionLongPress": `Dugo pritisnite za po\u{10D}etak povla\u{10D}enja.`,
    "dragDescriptionTouch": `Dvaput dodirnite da biste po\u{10D}eli povla\u{10D}iti.`,
    "dragDescriptionVirtual": `Kliknite da biste po\u{10D}eli povla\u{10D}iti.`,
    "dragItem": (args)=>`Povucite stavku ${args.itemText}`,
    "dragSelectedItems": (args, formatter)=>`Povucite ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} odabranu stavku`,
            other: ()=>`ovoliko odabranih stavki: ${formatter.number(args.count)}`
        })}`,
    "dragSelectedKeyboard": (args, formatter)=>`Pritisnite Enter za povla\u{10D}enje ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} odabrana stavka`,
            other: ()=>`${formatter.number(args.count)} odabrane stavke`
        })}.`,
    "dragSelectedKeyboardAlt": (args, formatter)=>`Pritisnite Alt + Enter za povla\u{10D}enje ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} odabrana stavka`,
            other: ()=>`${formatter.number(args.count)} odabrane stavke`
        })}.`,
    "dragSelectedLongPress": (args, formatter)=>`Dugo pritisnite za povla\u{10D}enje ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} odabrana stavka`,
            other: ()=>`${formatter.number(args.count)} odabrane stavke`
        })}.`,
    "dragStartedKeyboard": `Po\u{10D}eli ste povla\u{10D}iti. Pritisnite tipku tabulatora da biste do\u{161}li do cilja ispu\u{161}tanja, a zatim Enter da biste ispustili stavku ili Escape da biste prekinuli povla\u{10D}enje.`,
    "dragStartedTouch": `Po\u{10D}eli ste povla\u{10D}iti. Do\u{111}ite do cilja ispu\u{161}tanja, a zatim dvaput dodirnite da biste ispustili stavku.`,
    "dragStartedVirtual": `Po\u{10D}eli ste povla\u{10D}iti. Do\u{111}ite do cilja ispu\u{161}tanja, a zatim kliknite ili pritisnite Enter da biste ispustili stavku.`,
    "dropCanceled": `Povla\u{10D}enje je prekinuto.`,
    "dropComplete": `Ispu\u{161}tanje je dovr\u{161}eno.`,
    "dropDescriptionKeyboard": `Pritisnite Enter da biste ispustili stavku. Pritisnite Escape da biste prekinuli povla\u{10D}enje.`,
    "dropDescriptionTouch": `Dvaput dodirnite da biste ispustili stavku.`,
    "dropDescriptionVirtual": `Kliknite da biste ispustili stavku.`,
    "dropIndicator": `pokazatelj ispu\u{161}tanja`,
    "dropOnItem": (args)=>`Ispustite na stavku ${args.itemText}`,
    "dropOnRoot": `Ispustite na`,
    "endDragKeyboard": `Povla\u{10D}enje. Pritisnite Enter da biste prekinuli povla\u{10D}enje.`,
    "endDragTouch": `Povla\u{10D}enje. Dvaput dodirnite da biste prekinuli povla\u{10D}enje.`,
    "endDragVirtual": `Povla\u{10D}enje. Kliknite da biste prekinuli povla\u{10D}enje.`,
    "insertAfter": (args)=>`Umetnite iza stavke ${args.itemText}`,
    "insertBefore": (args)=>`Ispustite ispred stavke ${args.itemText}`,
    "insertBetween": (args)=>`Umetnite izme\u{111}u stavki ${args.beforeItemText} i ${args.afterItemText}`
};

},{}],"2RyHd":[function(require,module,exports) {
module.exports = {
    "dragDescriptionKeyboard": `Nyomja le az Enter billenty\u{171}t a h\xfaz\xe1s megkezd\xe9s\xe9hez.`,
    "dragDescriptionKeyboardAlt": `Nyomja le az Alt + Enter billenty\u{171}ket a h\xfaz\xe1s megkezd\xe9s\xe9hez.`,
    "dragDescriptionLongPress": `Hosszan nyomja meg a h\xfaz\xe1s elind\xedt\xe1s\xe1hoz.`,
    "dragDescriptionTouch": `Koppintson dupl\xe1n a h\xfaz\xe1s megkezd\xe9s\xe9hez.`,
    "dragDescriptionVirtual": `Kattintson a h\xfaz\xe1s megkezd\xe9s\xe9hez.`,
    "dragItem": (args)=>`${args.itemText} h\xfaz\xe1sa`,
    "dragSelectedItems": (args, formatter)=>`${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} kijel\xf6lt elem`,
            other: ()=>`${formatter.number(args.count)} kijel\xf6lt elem`
        })} h\xfaz\xe1sa`,
    "dragSelectedKeyboard": (args, formatter)=>`Nyomja meg az Entert ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} kijel\xf6lt elem`,
            other: ()=>`${formatter.number(args.count)} kijel\xf6lt elem`
        })} h\xfaz\xe1s\xe1hoz.`,
    "dragSelectedKeyboardAlt": (args, formatter)=>`Nyomja meg az Alt + Enter billenty\u{171}ket ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} kijel\xf6lt elem`,
            other: ()=>`${formatter.number(args.count)} kijel\xf6lt elem`
        })} h\xfaz\xe1s\xe1hoz.`,
    "dragSelectedLongPress": (args, formatter)=>`Tartsa lenyomva hosszan ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} kijel\xf6lt elem`,
            other: ()=>`${formatter.number(args.count)} kijel\xf6lt elem`
        })} h\xfaz\xe1s\xe1hoz.`,
    "dragStartedKeyboard": `H\xfaz\xe1s megkezdve. Nyomja le a Tab billenty\u{171}t az elenged\xe9si c\xe9lhoz navig\xe1l\xe1s\xe1hoz, majd nyomja le az Enter billenty\u{171}t az elenged\xe9shez, vagy nyomja le az Escape billenty\u{171}t a megszak\xedt\xe1shoz.`,
    "dragStartedTouch": `H\xfaz\xe1s megkezdve. Navig\xe1ljon egy elenged\xe9si c\xe9lhoz, majd koppintson dupl\xe1n az elenged\xe9shez.`,
    "dragStartedVirtual": `H\xfaz\xe1s megkezdve. Navig\xe1ljon egy elenged\xe9si c\xe9lhoz, majd kattintson vagy nyomja le az Enter billenty\u{171}t az elenged\xe9shez.`,
    "dropCanceled": `Elenged\xe9s megszak\xedtva.`,
    "dropComplete": `Elenged\xe9s teljes\xedtve.`,
    "dropDescriptionKeyboard": `Nyomja le az Enter billenty\u{171}t az elenged\xe9shez. Nyomja le az Escape billenty\u{171}t a h\xfaz\xe1s megszak\xedt\xe1s\xe1hoz.`,
    "dropDescriptionTouch": `Koppintson dupl\xe1n az elenged\xe9shez.`,
    "dropDescriptionVirtual": `Kattintson az elenged\xe9shez.`,
    "dropIndicator": `elenged\xe9sjelz\u{151}`,
    "dropOnItem": (args)=>`Elenged\xe9s erre: ${args.itemText}`,
    "dropOnRoot": `Elenged\xe9s erre:`,
    "endDragKeyboard": `H\xfaz\xe1s folyamatban. Nyomja le az Enter billenty\u{171}t a h\xfaz\xe1s megszak\xedt\xe1s\xe1hoz.`,
    "endDragTouch": `H\xfaz\xe1s folyamatban. Koppintson dupl\xe1n a h\xfaz\xe1s megszak\xedt\xe1s\xe1hoz.`,
    "endDragVirtual": `H\xfaz\xe1s folyamatban. Kattintson a h\xfaz\xe1s megszak\xedt\xe1s\xe1hoz.`,
    "insertAfter": (args)=>`Besz\xfar\xe1s ${args.itemText} ut\xe1n`,
    "insertBefore": (args)=>`Besz\xfar\xe1s ${args.itemText} el\xe9`,
    "insertBetween": (args)=>`Besz\xfar\xe1s ${args.beforeItemText} \xe9s ${args.afterItemText} k\xf6z\xe9`
};

},{}],"13dzl":[function(require,module,exports) {
module.exports = {
    "dragDescriptionKeyboard": `Premi Invio per iniziare a trascinare.`,
    "dragDescriptionKeyboardAlt": `Premi Alt + Invio per iniziare a trascinare.`,
    "dragDescriptionLongPress": `Premi a lungo per iniziare a trascinare.`,
    "dragDescriptionTouch": `Tocca due volte per iniziare a trascinare.`,
    "dragDescriptionVirtual": `Fai clic per iniziare a trascinare.`,
    "dragItem": (args)=>`Trascina ${args.itemText}`,
    "dragSelectedItems": (args, formatter)=>`Trascina ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} altro elemento selezionato`,
            other: ()=>`${formatter.number(args.count)} altri elementi selezionati`
        })}`,
    "dragSelectedKeyboard": (args, formatter)=>`Premi Invio per trascinare ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} elemento selezionato`,
            other: ()=>`${formatter.number(args.count)} elementi selezionati`
        })}.`,
    "dragSelectedKeyboardAlt": (args, formatter)=>`Premi Alt + Invio per trascinare ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} elemento selezionato`,
            other: ()=>`${formatter.number(args.count)} elementi selezionati`
        })}.`,
    "dragSelectedLongPress": (args, formatter)=>`Premi a lungo per trascinare ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} elemento selezionato`,
            other: ()=>`${formatter.number(args.count)} elementi selezionati`
        })}.`,
    "dragStartedKeyboard": `Hai iniziato a trascinare. Premi Tab per arrivare sull\u{2019}area di destinazione, quindi premi Invio per rilasciare o Esc per annullare.`,
    "dragStartedTouch": `Hai iniziato a trascinare. Arriva sull\u{2019}area di destinazione, quindi tocca due volte per rilasciare.`,
    "dragStartedVirtual": `Hai iniziato a trascinare. Arriva sull\u{2019}area di destinazione, quindi fai clic o premi Invio per rilasciare.`,
    "dropCanceled": `Rilascio annullato.`,
    "dropComplete": `Rilascio completato.`,
    "dropDescriptionKeyboard": `Premi Invio per rilasciare. Premi Esc per annullare.`,
    "dropDescriptionTouch": `Tocca due volte per rilasciare.`,
    "dropDescriptionVirtual": `Fai clic per rilasciare.`,
    "dropIndicator": `indicatore di rilascio`,
    "dropOnItem": (args)=>`Rilascia su ${args.itemText}`,
    "dropOnRoot": `Rilascia su`,
    "endDragKeyboard": `Trascinamento. Premi Invio per annullare.`,
    "endDragTouch": `Trascinamento. Tocca due volte per annullare.`,
    "endDragVirtual": `Trascinamento. Fai clic per annullare.`,
    "insertAfter": (args)=>`Inserisci dopo ${args.itemText}`,
    "insertBefore": (args)=>`Inserisci prima di ${args.itemText}`,
    "insertBetween": (args)=>`Inserisci tra ${args.beforeItemText} e ${args.afterItemText}`
};

},{}],"8rMUV":[function(require,module,exports) {
module.exports = {
    "dragDescriptionKeyboard": `Enter \u{30AD}\u{30FC}\u{3092}\u{62BC}\u{3057}\u{3066}\u{30C9}\u{30E9}\u{30C3}\u{30B0}\u{3092}\u{958B}\u{59CB}\u{3057}\u{3066}\u{304F}\u{3060}\u{3055}\u{3044}\u{3002}`,
    "dragDescriptionKeyboardAlt": `Alt+Enter \u{30AD}\u{30FC}\u{3092}\u{62BC}\u{3057}\u{3066}\u{30C9}\u{30E9}\u{30C3}\u{30B0}\u{3092}\u{958B}\u{59CB}\u{3057}\u{307E}\u{3059}\u{3002}`,
    "dragDescriptionLongPress": `\u{9577}\u{62BC}\u{3057}\u{3057}\u{3066}\u{30C9}\u{30E9}\u{30C3}\u{30B0}\u{3092}\u{958B}\u{59CB}\u{3057}\u{307E}\u{3059}\u{3002}`,
    "dragDescriptionTouch": `\u{30C0}\u{30D6}\u{30EB}\u{30BF}\u{30C3}\u{30D7}\u{3057}\u{3066}\u{30C9}\u{30E9}\u{30C3}\u{30B0}\u{3092}\u{958B}\u{59CB}\u{3057}\u{307E}\u{3059}\u{3002}`,
    "dragDescriptionVirtual": `\u{30AF}\u{30EA}\u{30C3}\u{30AF}\u{3057}\u{3066}\u{30C9}\u{30E9}\u{30C3}\u{30B0}\u{3092}\u{958B}\u{59CB}\u{3057}\u{307E}\u{3059}\u{3002}`,
    "dragItem": (args)=>`${args.itemText} \u{3092}\u{30C9}\u{30E9}\u{30C3}\u{30B0}`,
    "dragSelectedItems": (args, formatter)=>`${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} \u{500B}\u{306E}\u{9078}\u{629E}\u{9805}\u{76EE}`,
            other: ()=>`${formatter.number(args.count)} \u{500B}\u{306E}\u{9078}\u{629E}\u{9805}\u{76EE}`
        })} \u{3092}\u{30C9}\u{30E9}\u{30C3}\u{30B0}`,
    "dragSelectedKeyboard": (args, formatter)=>`Enter \u{30AD}\u{30FC}\u{3092}\u{62BC}\u{3057}\u{3066}\u{3001}${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} \u{9078}\u{629E}\u{3057}\u{305F}\u{9805}\u{76EE}`,
            other: ()=>`${formatter.number(args.count)} \u{9078}\u{629E}\u{3057}\u{305F}\u{9805}\u{76EE}`
        })}\u{3092}\u{30C9}\u{30E9}\u{30C3}\u{30B0}\u{3057}\u{307E}\u{3059}\u{3002}`,
    "dragSelectedKeyboardAlt": (args, formatter)=>`Alt+Enter \u{30AD}\u{30FC}\u{3092}\u{62BC}\u{3057}\u{3066}\u{3001}${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} \u{9078}\u{629E}\u{3057}\u{305F}\u{9805}\u{76EE}`,
            other: ()=>`${formatter.number(args.count)} \u{9078}\u{629E}\u{3057}\u{305F}\u{9805}\u{76EE}`
        })}\u{3092}\u{30C9}\u{30E9}\u{30C3}\u{30B0}\u{3057}\u{307E}\u{3059}\u{3002}`,
    "dragSelectedLongPress": (args, formatter)=>`\u{9577}\u{62BC}\u{3057}\u{3057}\u{3066}\u{3001}${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} \u{9078}\u{629E}\u{3057}\u{305F}\u{9805}\u{76EE}`,
            other: ()=>`${formatter.number(args.count)} \u{9078}\u{629E}\u{3057}\u{305F}\u{9805}\u{76EE}`
        })}\u{3092}\u{30C9}\u{30E9}\u{30C3}\u{30B0}\u{3057}\u{307E}\u{3059}\u{3002}`,
    "dragStartedKeyboard": `\u{30C9}\u{30E9}\u{30C3}\u{30B0}\u{3092}\u{958B}\u{59CB}\u{3057}\u{307E}\u{3059}\u{3002}Tab \u{30AD}\u{30FC}\u{3092}\u{62BC}\u{3057}\u{3066}\u{30C9}\u{30ED}\u{30C3}\u{30D7}\u{30BF}\u{30FC}\u{30B2}\u{30C3}\u{30C8}\u{306B}\u{3044}\u{3069}\u{3046}\u{3057}\u{3001}Enter \u{30AD}\u{30FC}\u{3092}\u{62BC}\u{3057}\u{3066}\u{30C9}\u{30ED}\u{30C3}\u{30D7}\u{3059}\u{308B}\u{304B}\u{3001}Esc \u{30AD}\u{30FC}\u{3092}\u{62BC}\u{3057}\u{3066}\u{30AD}\u{30E3}\u{30F3}\u{30BB}\u{30EB}\u{3057}\u{307E}\u{3059}\u{3002}`,
    "dragStartedTouch": `\u{30C9}\u{30E9}\u{30C3}\u{30B0}\u{3092}\u{958B}\u{59CB}\u{3057}\u{307E}\u{3057}\u{305F}\u{3002}\u{30C9}\u{30ED}\u{30C3}\u{30D7}\u{306E}\u{30BF}\u{30FC}\u{30B2}\u{30C3}\u{30C8}\u{306B}\u{79FB}\u{52D5}\u{3057}\u{3001}\u{30C0}\u{30D6}\u{30EB}\u{30BF}\u{30C3}\u{30D7}\u{3057}\u{3066}\u{30C9}\u{30ED}\u{30C3}\u{30D7}\u{3057}\u{307E}\u{3059}\u{3002}`,
    "dragStartedVirtual": `\u{30C9}\u{30E9}\u{30C3}\u{30B0}\u{3092}\u{958B}\u{59CB}\u{3057}\u{307E}\u{3057}\u{305F}\u{3002}\u{30C9}\u{30ED}\u{30C3}\u{30D7}\u{306E}\u{30BF}\u{30FC}\u{30B2}\u{30C3}\u{30C8}\u{306B}\u{79FB}\u{52D5}\u{3057}\u{3001}\u{30AF}\u{30EA}\u{30C3}\u{30AF}\u{307E}\u{305F}\u{306F} Enter \u{30AD}\u{30FC}\u{3092}\u{62BC}\u{3057}\u{3066}\u{30C9}\u{30ED}\u{30C3}\u{30D7}\u{3057}\u{307E}\u{3059}\u{3002}`,
    "dropCanceled": `\u{30C9}\u{30ED}\u{30C3}\u{30D7}\u{304C}\u{30AD}\u{30E3}\u{30F3}\u{30BB}\u{30EB}\u{3055}\u{308C}\u{307E}\u{3057}\u{305F}\u{3002}`,
    "dropComplete": `\u{30C9}\u{30ED}\u{30C3}\u{30D7}\u{304C}\u{5B8C}\u{4E86}\u{3057}\u{307E}\u{3057}\u{305F}\u{3002}`,
    "dropDescriptionKeyboard": `Enter \u{30AD}\u{30FC}\u{3092}\u{62BC}\u{3057}\u{3066}\u{30C9}\u{30ED}\u{30C3}\u{30D7}\u{3057}\u{307E}\u{3059}\u{3002}Esc \u{30AD}\u{30FC}\u{3092}\u{62BC}\u{3057}\u{3066}\u{30C9}\u{30E9}\u{30C3}\u{30B0}\u{3092}\u{30AD}\u{30E3}\u{30F3}\u{30BB}\u{30EB}\u{3057}\u{307E}\u{3059}\u{3002}`,
    "dropDescriptionTouch": `\u{30C0}\u{30D6}\u{30EB}\u{30BF}\u{30C3}\u{30D7}\u{3057}\u{3066}\u{30C9}\u{30ED}\u{30C3}\u{30D7}\u{3057}\u{307E}\u{3059}\u{3002}`,
    "dropDescriptionVirtual": `\u{30AF}\u{30EA}\u{30C3}\u{30AF}\u{3057}\u{3066}\u{30C9}\u{30ED}\u{30C3}\u{30D7}\u{3057}\u{307E}\u{3059}\u{3002}`,
    "dropIndicator": `\u{30C9}\u{30ED}\u{30C3}\u{30D7}\u{30A4}\u{30F3}\u{30B8}\u{30B1}\u{30FC}\u{30BF}\u{30FC}`,
    "dropOnItem": (args)=>`${args.itemText} \u{306B}\u{30C9}\u{30ED}\u{30C3}\u{30D7}`,
    "dropOnRoot": `\u{30C9}\u{30ED}\u{30C3}\u{30D7}\u{5834}\u{6240}`,
    "endDragKeyboard": `\u{30C9}\u{30E9}\u{30C3}\u{30B0}\u{3057}\u{3066}\u{3044}\u{307E}\u{3059}\u{3002}Enter \u{30AD}\u{30FC}\u{3092}\u{62BC}\u{3057}\u{3066}\u{30C9}\u{30E9}\u{30C3}\u{30B0}\u{3092}\u{30AD}\u{30E3}\u{30F3}\u{30BB}\u{30EB}\u{3057}\u{307E}\u{3059}\u{3002}`,
    "endDragTouch": `\u{30C9}\u{30E9}\u{30C3}\u{30B0}\u{3057}\u{3066}\u{3044}\u{307E}\u{3059}\u{3002}\u{30C0}\u{30D6}\u{30EB}\u{30BF}\u{30C3}\u{30D7}\u{3057}\u{3066}\u{30C9}\u{30E9}\u{30C3}\u{30B0}\u{3092}\u{30AD}\u{30E3}\u{30F3}\u{30BB}\u{30EB}\u{3057}\u{307E}\u{3059}\u{3002}`,
    "endDragVirtual": `\u{30C9}\u{30E9}\u{30C3}\u{30B0}\u{3057}\u{3066}\u{3044}\u{307E}\u{3059}\u{3002}\u{30AF}\u{30EA}\u{30C3}\u{30AF}\u{3057}\u{3066}\u{30C9}\u{30E9}\u{30C3}\u{30B0}\u{3092}\u{30AD}\u{30E3}\u{30F3}\u{30BB}\u{30EB}\u{3057}\u{307E}\u{3059}\u{3002}`,
    "insertAfter": (args)=>`${args.itemText} \u{306E}\u{5F8C}\u{306B}\u{633F}\u{5165}`,
    "insertBefore": (args)=>`${args.itemText} \u{306E}\u{524D}\u{306B}\u{633F}\u{5165}`,
    "insertBetween": (args)=>`${args.beforeItemText} \u{3068} ${args.afterItemText} \u{306E}\u{9593}\u{306B}\u{633F}\u{5165}`
};

},{}],"9sGFt":[function(require,module,exports) {
module.exports = {
    "dragDescriptionKeyboard": `\u{B4DC}\u{B798}\u{ADF8}\u{B97C} \u{C2DC}\u{C791}\u{D558}\u{B824}\u{BA74} Enter\u{B97C} \u{B204}\u{B974}\u{C138}\u{C694}.`,
    "dragDescriptionKeyboardAlt": `\u{B4DC}\u{B798}\u{ADF8}\u{B97C} \u{C2DC}\u{C791}\u{D558}\u{B824}\u{BA74} Alt + Enter\u{B97C} \u{B204}\u{B974}\u{C2ED}\u{C2DC}\u{C624}.`,
    "dragDescriptionLongPress": `\u{B4DC}\u{B798}\u{ADF8}\u{B97C} \u{C2DC}\u{C791}\u{D558}\u{B824}\u{BA74} \u{AE38}\u{AC8C} \u{B204}\u{B974}\u{C2ED}\u{C2DC}\u{C624}.`,
    "dragDescriptionTouch": `\u{B4DC}\u{B798}\u{ADF8}\u{B97C} \u{C2DC}\u{C791}\u{D558}\u{B824}\u{BA74} \u{B354}\u{BE14} \u{D0ED}\u{D558}\u{C138}\u{C694}.`,
    "dragDescriptionVirtual": `\u{B4DC}\u{B798}\u{ADF8}\u{B97C} \u{C2DC}\u{C791}\u{D558}\u{B824}\u{BA74} \u{D074}\u{B9AD}\u{D558}\u{C138}\u{C694}.`,
    "dragItem": (args)=>`${args.itemText} \u{B4DC}\u{B798}\u{ADF8}`,
    "dragSelectedItems": (args, formatter)=>`${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)}\u{AC1C} \u{C120}\u{D0DD} \u{D56D}\u{BAA9}`,
            other: ()=>`${formatter.number(args.count)}\u{AC1C} \u{C120}\u{D0DD} \u{D56D}\u{BAA9}`
        })} \u{B4DC}\u{B798}\u{ADF8}`,
    "dragSelectedKeyboard": (args, formatter)=>`${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)}\u{AC1C} \u{C120}\u{D0DD} \u{D56D}\u{BAA9}`,
            other: ()=>`${formatter.number(args.count)}\u{AC1C} \u{C120}\u{D0DD} \u{D56D}\u{BAA9}`
        })}\u{C744} \u{B4DC}\u{B798}\u{ADF8}\u{D558}\u{B824}\u{BA74} Enter\u{B97C} \u{B204}\u{B974}\u{C2ED}\u{C2DC}\u{C624}.`,
    "dragSelectedKeyboardAlt": (args, formatter)=>`${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)}\u{AC1C} \u{C120}\u{D0DD} \u{D56D}\u{BAA9}`,
            other: ()=>`${formatter.number(args.count)}\u{AC1C} \u{C120}\u{D0DD} \u{D56D}\u{BAA9}`
        })}\u{C744} \u{B4DC}\u{B798}\u{ADF8}\u{D558}\u{B824}\u{BA74} Alt + Enter\u{B97C} \u{B204}\u{B974}\u{C2ED}\u{C2DC}\u{C624}.`,
    "dragSelectedLongPress": (args, formatter)=>`${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)}\u{AC1C} \u{C120}\u{D0DD} \u{D56D}\u{BAA9}`,
            other: ()=>`${formatter.number(args.count)}\u{AC1C} \u{C120}\u{D0DD} \u{D56D}\u{BAA9}`
        })}\u{C744} \u{B4DC}\u{B798}\u{ADF8}\u{D558}\u{B824}\u{BA74} \u{AE38}\u{AC8C} \u{B204}\u{B974}\u{C2ED}\u{C2DC}\u{C624}.`,
    "dragStartedKeyboard": `\u{B4DC}\u{B798}\u{ADF8}\u{AC00} \u{C2DC}\u{C791}\u{B418}\u{C5C8}\u{C2B5}\u{B2C8}\u{B2E4}. Tab\u{C744} \u{B20C}\u{B7EC} \u{B4DC}\u{B86D} \u{B300}\u{C0C1}\u{C73C}\u{B85C} \u{C774}\u{B3D9}\u{D55C} \u{B2E4}\u{C74C} Enter\u{B97C} \u{B20C}\u{B7EC} \u{B4DC}\u{B86D}\u{D558}\u{AC70}\u{B098} Esc\u{B97C} \u{B20C}\u{B7EC} \u{CDE8}\u{C18C}\u{D558}\u{C138}\u{C694}.`,
    "dragStartedTouch": `\u{B4DC}\u{B798}\u{ADF8}\u{AC00} \u{C2DC}\u{C791}\u{B418}\u{C5C8}\u{C2B5}\u{B2C8}\u{B2E4}. \u{B4DC}\u{B86D} \u{B300}\u{C0C1}\u{C73C}\u{B85C} \u{C774}\u{B3D9}\u{D55C} \u{B2E4}\u{C74C} \u{B354}\u{BE14} \u{D0ED}\u{D558}\u{C5EC} \u{B4DC}\u{B86D}\u{D558}\u{C138}\u{C694}.`,
    "dragStartedVirtual": `\u{B4DC}\u{B798}\u{ADF8}\u{AC00} \u{C2DC}\u{C791}\u{B418}\u{C5C8}\u{C2B5}\u{B2C8}\u{B2E4}. \u{B4DC}\u{B86D} \u{B300}\u{C0C1}\u{C73C}\u{B85C} \u{C774}\u{B3D9}\u{D55C} \u{B2E4}\u{C74C} \u{D074}\u{B9AD}\u{D558}\u{AC70}\u{B098} Enter\u{B97C} \u{B20C}\u{B7EC} \u{B4DC}\u{B86D}\u{D558}\u{C138}\u{C694}.`,
    "dropCanceled": `\u{B4DC}\u{B86D}\u{C774} \u{CDE8}\u{C18C}\u{B418}\u{C5C8}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    "dropComplete": `\u{B4DC}\u{B86D}\u{C774} \u{C644}\u{B8CC}\u{B418}\u{C5C8}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    "dropDescriptionKeyboard": `\u{B4DC}\u{B86D}\u{D558}\u{B824}\u{BA74} Enter\u{B97C} \u{B204}\u{B974}\u{C138}\u{C694}. \u{B4DC}\u{B798}\u{ADF8}\u{B97C} \u{CDE8}\u{C18C}\u{D558}\u{B824}\u{BA74} Esc\u{B97C} \u{B204}\u{B974}\u{C138}\u{C694}.`,
    "dropDescriptionTouch": `\u{B354}\u{BE14} \u{D0ED}\u{D558}\u{C5EC} \u{B4DC}\u{B86D}\u{D558}\u{C138}\u{C694}.`,
    "dropDescriptionVirtual": `\u{B4DC}\u{B86D}\u{D558}\u{B824}\u{BA74} \u{D074}\u{B9AD}\u{D558}\u{C138}\u{C694}.`,
    "dropIndicator": `\u{B4DC}\u{B86D} \u{D45C}\u{C2DC}\u{AE30}`,
    "dropOnItem": (args)=>`${args.itemText}\u{C5D0} \u{B4DC}\u{B86D}`,
    "dropOnRoot": `\u{B4DC}\u{B86D} \u{B300}\u{C0C1}`,
    "endDragKeyboard": `\u{B4DC}\u{B798}\u{ADF8} \u{C911}\u{C785}\u{B2C8}\u{B2E4}. \u{B4DC}\u{B798}\u{ADF8}\u{B97C} \u{CDE8}\u{C18C}\u{D558}\u{B824}\u{BA74} Enter\u{B97C} \u{B204}\u{B974}\u{C138}\u{C694}.`,
    "endDragTouch": `\u{B4DC}\u{B798}\u{ADF8} \u{C911}\u{C785}\u{B2C8}\u{B2E4}. \u{B4DC}\u{B798}\u{ADF8}\u{B97C} \u{CDE8}\u{C18C}\u{D558}\u{B824}\u{BA74} \u{B354}\u{BE14} \u{D0ED}\u{D558}\u{C138}\u{C694}.`,
    "endDragVirtual": `\u{B4DC}\u{B798}\u{ADF8} \u{C911}\u{C785}\u{B2C8}\u{B2E4}. \u{B4DC}\u{B798}\u{ADF8}\u{B97C} \u{CDE8}\u{C18C}\u{D558}\u{B824}\u{BA74} \u{D074}\u{B9AD}\u{D558}\u{C138}\u{C694}.`,
    "insertAfter": (args)=>`${args.itemText} \u{C774}\u{D6C4}\u{C5D0} \u{C0BD}\u{C785}`,
    "insertBefore": (args)=>`${args.itemText} \u{C774}\u{C804}\u{C5D0} \u{C0BD}\u{C785}`,
    "insertBetween": (args)=>`${args.beforeItemText} \u{BC0F} ${args.afterItemText} \u{C0AC}\u{C774}\u{C5D0} \u{C0BD}\u{C785}`
};

},{}],"9Hpk7":[function(require,module,exports) {
module.exports = {
    "dragDescriptionKeyboard": `Paspauskite \u{201E}Enter\u{201C}, kad prad\u{117}tum\u{117}te vilkti.`,
    "dragDescriptionKeyboardAlt": `Paspauskite \u{201E}Alt + Enter\u{201C}, kad prad\u{117}tum\u{117}te vilkti.`,
    "dragDescriptionLongPress": `Palaikykite nuspaud\u{119}, kad prad\u{117}tum\u{117}te vilkti.`,
    "dragDescriptionTouch": `Palieskite dukart, kad prad\u{117}tum\u{117}te vilkti.`,
    "dragDescriptionVirtual": `Spustel\u{117}kite, kad prad\u{117}tum\u{117}te vilkti.`,
    "dragItem": (args)=>`Vilkti ${args.itemText}`,
    "dragSelectedItems": (args, formatter)=>`Vilkti ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} pasirinkt\u{105} element\u{105}`,
            other: ()=>`${formatter.number(args.count)} pasirinktus elementus`
        })}`,
    "dragSelectedKeyboard": (args, formatter)=>`Paspauskite \u{201E}Enter\u{201C}, jei norite nuvilkti ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} pasirinkt\u{105} element\u{105}`,
            other: ()=>`${formatter.number(args.count)} pasirinktus elementus`
        })}.`,
    "dragSelectedKeyboardAlt": (args, formatter)=>`Paspauskite \u{201E}Alt + Enter\u{201C}, kad nuvilktum\u{117}te ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} pasirinkt\u{105} element\u{105}`,
            other: ()=>`${formatter.number(args.count)} pasirinktus elementus`
        })}.`,
    "dragSelectedLongPress": (args, formatter)=>`Nuspaud\u{119} palaikykite, kad nuvilktum\u{117}te ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} pasirinkt\u{105} element\u{105}`,
            other: ()=>`${formatter.number(args.count)} pasirinktus elementus`
        })}.`,
    "dragStartedKeyboard": `Prad\u{117}ta vilkti. Paspauskite \u{201E}Tab\u{201C}, kad pereitum\u{117}te \u{12F} tiesiogin\u{119} paskirties viet\u{105}, tada paspauskite \u{201E}Enter\u{201C}, kad numestum\u{117}te, arba \u{201E}Escape\u{201C}, kad at\u{161}auktum\u{117}te.`,
    "dragStartedTouch": `Prad\u{117}ta vilkti. Eikite \u{12F} tiesiogin\u{119} paskirties viet\u{105}, tada palieskite dukart, kad numestum\u{117}te.`,
    "dragStartedVirtual": `Prad\u{117}ta vilkti. Eikite \u{12F} tiesiogin\u{119} paskirties viet\u{105} ir spustel\u{117}kite arba paspauskite \u{201E}Enter\u{201C}, kad numestum\u{117}te.`,
    "dropCanceled": `Numetimas at\u{161}auktas.`,
    "dropComplete": `Numesta.`,
    "dropDescriptionKeyboard": `Paspauskite \u{201E}Enter\u{201C}, kad numestum\u{117}te. Paspauskite \u{201E}Escape\u{201C}, kad at\u{161}auktum\u{117}te vilkim\u{105}.`,
    "dropDescriptionTouch": `Palieskite dukart, kad numestum\u{117}te.`,
    "dropDescriptionVirtual": `Spustel\u{117}kite, kad numestum\u{117}te.`,
    "dropIndicator": `numetimo indikatorius`,
    "dropOnItem": (args)=>`Numesti ant ${args.itemText}`,
    "dropOnRoot": `Numesti ant`,
    "endDragKeyboard": `Velkama. Paspauskite \u{201E}Enter\u{201C}, kad at\u{161}auktum\u{117}te vilkim\u{105}.`,
    "endDragTouch": `Velkama. Spustel\u{117}kite dukart, kad at\u{161}auktum\u{117}te vilkim\u{105}.`,
    "endDragVirtual": `Velkama. Spustel\u{117}kite, kad at\u{161}auktum\u{117}te vilkim\u{105}.`,
    "insertAfter": (args)=>`\u{12E}terpti po ${args.itemText}`,
    "insertBefore": (args)=>`\u{12E}terpti prie\u{161} ${args.itemText}`,
    "insertBetween": (args)=>`\u{12E}terpti tarp ${args.beforeItemText} ir ${args.afterItemText}`
};

},{}],"7r9Y0":[function(require,module,exports) {
module.exports = {
    "dragDescriptionKeyboard": `Nospiediet Enter, lai s\u{101}ktu vilk\u{161}anu.`,
    "dragDescriptionKeyboardAlt": `Nospiediet tausti\u{146}u kombin\u{101}ciju Alt+Enter, lai s\u{101}ktu vilk\u{161}anu.`,
    "dragDescriptionLongPress": `Turiet nospiestu, lai s\u{101}ktu vilk\u{161}anu.`,
    "dragDescriptionTouch": `Veiciet dubultsk\u{101}rienu, lai s\u{101}ktu vilk\u{161}anu.`,
    "dragDescriptionVirtual": `Noklik\u{161}\u{137}iniet, lai s\u{101}ktu vilk\u{161}anu.`,
    "dragItem": (args)=>`Velciet ${args.itemText}`,
    "dragSelectedItems": (args, formatter)=>`Velciet ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} atlas\u{12B}to vienumu`,
            other: ()=>`${formatter.number(args.count)} atlas\u{12B}tos vienumus`
        })}`,
    "dragSelectedKeyboard": (args, formatter)=>`Nospiediet tausti\u{146}u Enter, lai vilktu ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} atlas\u{12B}to vienumu`,
            other: ()=>`${formatter.number(args.count)} atlas\u{12B}tos vienumus`
        })}.`,
    "dragSelectedKeyboardAlt": (args, formatter)=>`Nospiediet tausti\u{146}u kombin\u{101}ciju Alt+Enter, lai vilktu ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} atlas\u{12B}to vienumu`,
            other: ()=>`${formatter.number(args.count)} atlas\u{12B}tos vienumus`
        })}.`,
    "dragSelectedLongPress": (args, formatter)=>`Turiet nospiestu, lai vilktu ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} atlas\u{12B}to vienumu`,
            other: ()=>`${formatter.number(args.count)} atlas\u{12B}tos vienumus`
        })}.`,
    "dragStartedKeyboard": `Uzs\u{101}kta vilk\u{161}ana. Nospiediet tausti\u{146}u Tab, lai p\u{101}rietu uz nome\u{161}anas m\u{113}r\u{137}i, p\u{113}c tam nospiediet Enter, lai nomestu, vai nospiediet Escape, lai atceltu.`,
    "dragStartedTouch": `Uzs\u{101}kta vilk\u{161}ana. P\u{101}rejiet uz nome\u{161}anas m\u{113}r\u{137}i, p\u{113}c tam veiciet dubultsk\u{101}rienu, lai nomestu.`,
    "dragStartedVirtual": `Uzs\u{101}kta vilk\u{161}ana. P\u{101}rejiet uz nome\u{161}anas m\u{113}r\u{137}i, p\u{113}c tam nospiediet Enter, lai nomestu.`,
    "dropCanceled": `Nome\u{161}ana atcelta.`,
    "dropComplete": `Nome\u{161}ana pabeigta.`,
    "dropDescriptionKeyboard": `Nospiediet Enter, lai nomestu. Nospiediet Escape, lai atceltu vilk\u{161}anu.`,
    "dropDescriptionTouch": `Veiciet dubultsk\u{101}rienu, lai nomestu.`,
    "dropDescriptionVirtual": `Noklik\u{161}\u{137}iniet, lai nomestu.`,
    "dropIndicator": `nome\u{161}anas indikators`,
    "dropOnItem": (args)=>`Nometiet uz ${args.itemText}`,
    "dropOnRoot": `Nometiet uz`,
    "endDragKeyboard": `Notiek vilk\u{161}ana. Nospiediet Enter, lai atceltu vilk\u{161}anu.`,
    "endDragTouch": `Notiek vilk\u{161}ana. Veiciet dubultsk\u{101}rienu, lai atceltu vilk\u{161}anu.`,
    "endDragVirtual": `Notiek vilk\u{161}ana. Noklik\u{161}\u{137}iniet, lai atceltu vilk\u{161}anu.`,
    "insertAfter": (args)=>`Ievietojiet p\u{113}c ${args.itemText}`,
    "insertBefore": (args)=>`Ievietojiet pirms ${args.itemText}`,
    "insertBetween": (args)=>`Ievietojiet starp ${args.beforeItemText} un ${args.afterItemText}`
};

},{}],"hfSsm":[function(require,module,exports) {
module.exports = {
    "dragDescriptionKeyboard": `Trykk p\xe5 Enter for \xe5 begynne \xe5 dra.`,
    "dragDescriptionKeyboardAlt": `Trykk p\xe5 Alt + Enter for \xe5 begynne \xe5 dra.`,
    "dragDescriptionLongPress": `Trykk lenge for \xe5 begynne \xe5 dra.`,
    "dragDescriptionTouch": `Dobbelttrykk for \xe5 begynne \xe5 dra.`,
    "dragDescriptionVirtual": `Klikk for \xe5 begynne \xe5 dra.`,
    "dragItem": (args)=>`Dra ${args.itemText}`,
    "dragSelectedItems": (args, formatter)=>`Dra ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} merket element`,
            other: ()=>`${formatter.number(args.count)} merkede elementer`
        })}`,
    "dragSelectedKeyboard": (args, formatter)=>`Trykk Enter for \xe5 dra ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} valgt element`,
            other: ()=>`${formatter.number(args.count)} valgte elementer`
        })}.`,
    "dragSelectedKeyboardAlt": (args, formatter)=>`Trykk p\xe5 Alt + Enter for \xe5 dra ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} valgt element`,
            other: ()=>`${formatter.number(args.count)} valgte elementer`
        })}.`,
    "dragSelectedLongPress": (args, formatter)=>`Trykk lenge for \xe5 dra ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} valgt element`,
            other: ()=>`${formatter.number(args.count)} valgte elementer`
        })}.`,
    "dragStartedKeyboard": `Begynte \xe5 dra. Trykk p\xe5 Tab for \xe5 navigere til et m\xe5l, og trykk deretter p\xe5 Enter for \xe5 slippe eller p\xe5 Esc for \xe5 avbryte.`,
    "dragStartedTouch": `Begynte \xe5 dra. Naviger til et m\xe5l, og dobbelttrykk for \xe5 slippe.`,
    "dragStartedVirtual": `Begynte \xe5 dra. Naviger til et m\xe5l, og klikk eller trykk p\xe5 Enter for \xe5 slippe.`,
    "dropCanceled": `Avbr\xf8t slipping.`,
    "dropComplete": `Slippingen er fullf\xf8rt.`,
    "dropDescriptionKeyboard": `Trykk p\xe5 Enter for \xe5 slippe. Trykk p\xe5 Esc hvis du vil avbryte draingen.`,
    "dropDescriptionTouch": `Dobbelttrykk for \xe5 slippe.`,
    "dropDescriptionVirtual": `Klikk for \xe5 slippe.`,
    "dropIndicator": `slippeindikator`,
    "dropOnItem": (args)=>`Slipp p\xe5 ${args.itemText}`,
    "dropOnRoot": `Slipp p\xe5`,
    "endDragKeyboard": `Drar. Trykk p\xe5 Enter hvis du vil avbryte.`,
    "endDragTouch": `Drar. Dobbelttrykk hvis du vil avbryte.`,
    "endDragVirtual": `Drar. Klikk hvis du vil avbryte.`,
    "insertAfter": (args)=>`Sett inn etter ${args.itemText}`,
    "insertBefore": (args)=>`Sett inn f\xf8r ${args.itemText}`,
    "insertBetween": (args)=>`Sett inn mellom ${args.beforeItemText} og ${args.afterItemText}`
};

},{}],"3o0Q3":[function(require,module,exports) {
module.exports = {
    "dragDescriptionKeyboard": `Druk op Enter om te slepen.`,
    "dragDescriptionKeyboardAlt": `Druk op Alt + Enter om te slepen.`,
    "dragDescriptionLongPress": `Houd lang ingedrukt om te slepen.`,
    "dragDescriptionTouch": `Dubbeltik om te slepen.`,
    "dragDescriptionVirtual": `Klik om met slepen te starten.`,
    "dragItem": (args)=>`${args.itemText} slepen`,
    "dragSelectedItems": (args, formatter)=>`${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} geselecteerd item`,
            other: ()=>`${formatter.number(args.count)} geselecteerde items`
        })} slepen`,
    "dragSelectedKeyboard": (args, formatter)=>`Druk op Enter om ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} geselecteerd item`,
            other: ()=>`${formatter.number(args.count)} geselecteerde items`
        })} te slepen.`,
    "dragSelectedKeyboardAlt": (args, formatter)=>`Druk op Alt + Enter om ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} geselecteerd item`,
            other: ()=>`${formatter.number(args.count)} geselecteerde items`
        })} te slepen.`,
    "dragSelectedLongPress": (args, formatter)=>`Houd lang ingedrukt om ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} geselecteerd item`,
            other: ()=>`${formatter.number(args.count)} geselecteerde items`
        })} te slepen.`,
    "dragStartedKeyboard": `Begonnen met slepen. Druk op Tab om naar een locatie te gaan. Druk dan op Enter om neer te zetten, of op Esc om te annuleren.`,
    "dragStartedTouch": `Begonnen met slepen. Ga naar de gewenste locatie en dubbeltik om neer te zetten.`,
    "dragStartedVirtual": `Begonnen met slepen. Ga naar de gewenste locatie en klik of druk op Enter om neer te zetten.`,
    "dropCanceled": `Neerzetten geannuleerd.`,
    "dropComplete": `Neerzetten voltooid.`,
    "dropDescriptionKeyboard": `Druk op Enter om neer te zetten. Druk op Esc om het slepen te annuleren.`,
    "dropDescriptionTouch": `Dubbeltik om neer te zetten.`,
    "dropDescriptionVirtual": `Klik om neer te zetten.`,
    "dropIndicator": `aanwijzer voor neerzetten`,
    "dropOnItem": (args)=>`Neerzetten op ${args.itemText}`,
    "dropOnRoot": `Neerzetten op`,
    "endDragKeyboard": `Bezig met slepen. Druk op Enter om te annuleren.`,
    "endDragTouch": `Bezig met slepen. Dubbeltik om te annuleren.`,
    "endDragVirtual": `Bezig met slepen. Klik om te annuleren.`,
    "insertAfter": (args)=>`Plaatsen na ${args.itemText}`,
    "insertBefore": (args)=>`Plaatsen v\xf3\xf3r ${args.itemText}`,
    "insertBetween": (args)=>`Plaatsen tussen ${args.beforeItemText} en ${args.afterItemText}`
};

},{}],"bkHpn":[function(require,module,exports) {
module.exports = {
    "dragDescriptionKeyboard": `Naci\u{15B}nij Enter, aby rozpocz\u{105}\u{107} przeci\u{105}ganie.`,
    "dragDescriptionKeyboardAlt": `Naci\u{15B}nij Alt + Enter, aby rozpocz\u{105}\u{107} przeci\u{105}ganie.`,
    "dragDescriptionLongPress": `Naci\u{15B}nij i przytrzymaj, aby rozpocz\u{105}\u{107} przeci\u{105}ganie.`,
    "dragDescriptionTouch": `Dotknij dwukrotnie, aby rozpocz\u{105}\u{107} przeci\u{105}ganie.`,
    "dragDescriptionVirtual": `Kliknij, aby rozpocz\u{105}\u{107} przeci\u{105}ganie.`,
    "dragItem": (args)=>`Przeci\u{105}gnij ${args.itemText}`,
    "dragSelectedItems": (args, formatter)=>`Przeci\u{105}gnij ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} wybrany element`,
            other: ()=>`${formatter.number(args.count)} wybranych element\xf3w`
        })}`,
    "dragSelectedKeyboard": (args, formatter)=>`Naci\u{15B}nij Enter, aby przeci\u{105}gn\u{105}\u{107} ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} wybrany element`,
            other: ()=>`${formatter.number(args.count)} wybrane(-ych) elementy(-\xf3w)`
        })}.`,
    "dragSelectedKeyboardAlt": (args, formatter)=>`Naci\u{15B}nij Alt + Enter, aby przeci\u{105}gn\u{105}\u{107} ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} wybrany element`,
            other: ()=>`${formatter.number(args.count)} wybrane(-ych) elementy(-\xf3w)`
        })}.`,
    "dragSelectedLongPress": (args, formatter)=>`Naci\u{15B}nij i przytrzymaj, aby przeci\u{105}gn\u{105}\u{107} ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} wybrany element`,
            other: ()=>`${formatter.number(args.count)} wybrane(-ych) elementy(-\xf3w)`
        })}.`,
    "dragStartedKeyboard": `Rozpocz\u{119}to przeci\u{105}ganie. Naci\u{15B}nij Tab, aby wybra\u{107} miejsce docelowe, a nast\u{119}pnie naci\u{15B}nij Enter, aby upu\u{15B}ci\u{107}, lub Escape, aby anulowa\u{107}.`,
    "dragStartedTouch": `Rozpocz\u{119}to przeci\u{105}ganie. Wybierz miejsce, w kt\xf3rym chcesz upu\u{15B}ci\u{107} element, a nast\u{119}pnie dotknij dwukrotnie, aby upu\u{15B}ci\u{107}.F`,
    "dragStartedVirtual": `Rozpocz\u{119}to przeci\u{105}ganie. Wybierz miejsce, w kt\xf3rym chcesz upu\u{15B}ci\u{107} element, a nast\u{119}pnie kliknij lub naci\u{15B}nij Enter, aby upu\u{15B}ci\u{107}.`,
    "dropCanceled": `Anulowano upuszczenie.`,
    "dropComplete": `Zako\u{144}czono upuszczanie.`,
    "dropDescriptionKeyboard": `Naci\u{15B}nij Enter, aby upu\u{15B}ci\u{107}. Naci\u{15B}nij Escape, aby anulowa\u{107} przeci\u{105}gni\u{119}cie.`,
    "dropDescriptionTouch": `Dotknij dwukrotnie, aby upu\u{15B}ci\u{107}.`,
    "dropDescriptionVirtual": `Kliknij, aby upu\u{15B}ci\u{107}.`,
    "dropIndicator": `wska\u{17A}nik upuszczenia`,
    "dropOnItem": (args)=>`Upu\u{15B}\u{107} na ${args.itemText}`,
    "dropOnRoot": `Upu\u{15B}\u{107}`,
    "endDragKeyboard": `Przeci\u{105}ganie. Naci\u{15B}nij Enter, aby anulowa\u{107} przeci\u{105}gni\u{119}cie.`,
    "endDragTouch": `Przeci\u{105}ganie. Kliknij dwukrotnie, aby anulowa\u{107} przeci\u{105}gni\u{119}cie.`,
    "endDragVirtual": `Przeci\u{105}ganie. Kliknij, aby anulowa\u{107} przeci\u{105}ganie.`,
    "insertAfter": (args)=>`Umie\u{15B}\u{107} za ${args.itemText}`,
    "insertBefore": (args)=>`Umie\u{15B}\u{107} przed ${args.itemText}`,
    "insertBetween": (args)=>`Umie\u{15B}\u{107} mi\u{119}dzy ${args.beforeItemText} i ${args.afterItemText}`
};

},{}],"ij7hX":[function(require,module,exports) {
module.exports = {
    "dragDescriptionKeyboard": `Pressione Enter para come\xe7ar a arrastar.`,
    "dragDescriptionKeyboardAlt": `Pressione Alt + Enter para come\xe7ar a arrastar.`,
    "dragDescriptionLongPress": `Pressione e segure para come\xe7ar a arrastar.`,
    "dragDescriptionTouch": `Toque duas vezes para come\xe7ar a arrastar.`,
    "dragDescriptionVirtual": `Clique para come\xe7ar a arrastar.`,
    "dragItem": (args)=>`Arrastar ${args.itemText}`,
    "dragSelectedItems": (args, formatter)=>`Arrastar ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} item selecionado`,
            other: ()=>`${formatter.number(args.count)} itens selecionados`
        })}`,
    "dragSelectedKeyboard": (args, formatter)=>`Pressione Enter para arrastar ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} o item selecionado`,
            other: ()=>`${formatter.number(args.count)} os itens selecionados`
        })}.`,
    "dragSelectedKeyboardAlt": (args, formatter)=>`Pressione Alt + Enter para arrastar ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} o item selecionado`,
            other: ()=>`${formatter.number(args.count)} os itens selecionados`
        })}.`,
    "dragSelectedLongPress": (args, formatter)=>`Pressione e segure para arrastar ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} o item selecionado`,
            other: ()=>`${formatter.number(args.count)} os itens selecionados`
        })}.`,
    "dragStartedKeyboard": `Comece a arrastar. Pressione Tab para navegar at\xe9 um alvo e, em seguida, pressione Enter para soltar ou pressione Escape para cancelar.`,
    "dragStartedTouch": `Comece a arrastar. Navegue at\xe9 um alvo e toque duas vezes para soltar.`,
    "dragStartedVirtual": `Comece a arrastar. Navegue at\xe9 um alvo e clique ou pressione Enter para soltar.`,
    "dropCanceled": `Libera\xe7\xe3o cancelada.`,
    "dropComplete": `Libera\xe7\xe3o conclu\xedda.`,
    "dropDescriptionKeyboard": `Pressione Enter para soltar. Pressione Escape para cancelar.`,
    "dropDescriptionTouch": `Toque duas vezes para soltar.`,
    "dropDescriptionVirtual": `Clique para soltar.`,
    "dropIndicator": `indicador de libera\xe7\xe3o`,
    "dropOnItem": (args)=>`Soltar em ${args.itemText}`,
    "dropOnRoot": `Soltar`,
    "endDragKeyboard": `Arrastando. Pressione Enter para cancelar.`,
    "endDragTouch": `Arrastando. Toque duas vezes para cancelar.`,
    "endDragVirtual": `Arrastando. Clique para cancelar.`,
    "insertAfter": (args)=>`Inserir ap\xf3s ${args.itemText}`,
    "insertBefore": (args)=>`Inserir antes de ${args.itemText}`,
    "insertBetween": (args)=>`Inserir entre ${args.beforeItemText} e ${args.afterItemText}`
};

},{}],"1PaEb":[function(require,module,exports) {
module.exports = {
    "dragDescriptionKeyboard": `Prima Enter para iniciar o arrasto.`,
    "dragDescriptionKeyboardAlt": `Prima Alt + Enter para iniciar o arrasto.`,
    "dragDescriptionLongPress": `Prima longamente para come\xe7ar a arrastar.`,
    "dragDescriptionTouch": `Fa\xe7a duplo toque para come\xe7ar a arrastar.`,
    "dragDescriptionVirtual": `Clique para iniciar o arrasto.`,
    "dragItem": (args)=>`Arrastar ${args.itemText}`,
    "dragSelectedItems": (args, formatter)=>`Arrastar ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} item selecionado`,
            other: ()=>`${formatter.number(args.count)} itens selecionados`
        })}`,
    "dragSelectedKeyboard": (args, formatter)=>`Prima Enter para arrastar ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} o item selecionado`,
            other: ()=>`${formatter.number(args.count)} os itens selecionados`
        })}.`,
    "dragSelectedKeyboardAlt": (args, formatter)=>`Prima Alt + Enter para arrastar ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} o item selecionado`,
            other: ()=>`${formatter.number(args.count)} os itens selecionados`
        })}.`,
    "dragSelectedLongPress": (args, formatter)=>`Prima longamente para arrastar ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} o item selecionado`,
            other: ()=>`${formatter.number(args.count)} os itens selecionados`
        })}.`,
    "dragStartedKeyboard": `Arrasto iniciado. Prima a tecla de tabula\xe7\xe3o para navegar para um destino para largar, e em seguida prima Enter para largar ou prima Escape para cancelar.`,
    "dragStartedTouch": `Arrasto iniciado. Navegue para um destino para largar, e em seguida fa\xe7a duplo toque para largar.`,
    "dragStartedVirtual": `Arrasto iniciado. Navegue para um destino para largar, e em seguida clique ou prima Enter para largar.`,
    "dropCanceled": `Largar cancelado.`,
    "dropComplete": `Largar completo.`,
    "dropDescriptionKeyboard": `Prima Enter para largar. Prima Escape para cancelar o arrasto.`,
    "dropDescriptionTouch": `Fa\xe7a duplo toque para largar.`,
    "dropDescriptionVirtual": `Clique para largar.`,
    "dropIndicator": `Indicador de largar`,
    "dropOnItem": (args)=>`Largar em ${args.itemText}`,
    "dropOnRoot": `Largar em`,
    "endDragKeyboard": `A arrastar. Prima Enter para cancelar o arrasto.`,
    "endDragTouch": `A arrastar. Fa\xe7a duplo toque para cancelar o arrasto.`,
    "endDragVirtual": `A arrastar. Clique para cancelar o arrasto.`,
    "insertAfter": (args)=>`Inserir depois de ${args.itemText}`,
    "insertBefore": (args)=>`Inserir antes de ${args.itemText}`,
    "insertBetween": (args)=>`Inserir entre ${args.beforeItemText} e ${args.afterItemText}`
};

},{}],"dgSUU":[function(require,module,exports) {
module.exports = {
    "dragDescriptionKeyboard": `Ap\u{103}sa\u{21B}i pe Enter pentru a \xeencepe glisarea.`,
    "dragDescriptionKeyboardAlt": `Ap\u{103}sa\u{21B}i pe Alt + Enter pentru a \xeencepe glisarea.`,
    "dragDescriptionLongPress": `Ap\u{103}sa\u{21B}i lung pentru a \xeencepe glisarea.`,
    "dragDescriptionTouch": `Atinge\u{21B}i de dou\u{103} ori pentru a \xeencepe s\u{103} glisa\u{21B}i.`,
    "dragDescriptionVirtual": `Face\u{21B}i clic pentru a \xeencepe glisarea.`,
    "dragItem": (args)=>`Glisa\u{21B}i ${args.itemText}`,
    "dragSelectedItems": (args, formatter)=>`Glisa\u{21B}i ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} element selectat`,
            other: ()=>`${formatter.number(args.count)} elemente selectate`
        })}`,
    "dragSelectedKeyboard": (args, formatter)=>`Ap\u{103}sa\u{21B}i pe Enter pentru a glisa ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} element selectat`,
            other: ()=>`${formatter.number(args.count)} elemente selectate`
        })}.`,
    "dragSelectedKeyboardAlt": (args, formatter)=>`Ap\u{103}sa\u{21B}i pe Alt + Enter pentru a glisa ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} element selectat`,
            other: ()=>`${formatter.number(args.count)} elemente selectate`
        })}.`,
    "dragSelectedLongPress": (args, formatter)=>`Ap\u{103}sa\u{21B}i lung pentru a glisa ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} element selectat`,
            other: ()=>`${formatter.number(args.count)} elemente selectate`
        })}.`,
    "dragStartedKeyboard": `A \xeenceput glisarea. Ap\u{103}sa\u{21B}i pe Tab pentru a naviga la o \u{21B}int\u{103} de fixare, apoi ap\u{103}sa\u{21B}i pe Enter pentru a fixa sau ap\u{103}sa\u{21B}i pe Escape pentru a anula glisarea.`,
    "dragStartedTouch": `A \xeenceput glisarea. Naviga\u{21B}i la o \u{21B}int\u{103} de fixare, apoi atinge\u{21B}i de dou\u{103} ori pentru a fixa.`,
    "dragStartedVirtual": `A \xeenceput glisarea. Naviga\u{21B}i la o \u{21B}int\u{103} de fixare, apoi face\u{21B}i clic sau ap\u{103}sa\u{21B}i pe Enter pentru a fixa.`,
    "dropCanceled": `Fixare anulat\u{103}.`,
    "dropComplete": `Fixare finalizat\u{103}.`,
    "dropDescriptionKeyboard": `Ap\u{103}sa\u{21B}i pe Enter pentru a fixa. Ap\u{103}sa\u{21B}i pe Escape pentru a anula glisarea.`,
    "dropDescriptionTouch": `Atinge\u{21B}i de dou\u{103} ori pentru a fixa.`,
    "dropDescriptionVirtual": `Face\u{21B}i clic pentru a fixa.`,
    "dropIndicator": `indicator de fixare`,
    "dropOnItem": (args)=>`Fixa\u{21B}i pe ${args.itemText}`,
    "dropOnRoot": `Fixare pe`,
    "endDragKeyboard": `Se gliseaz\u{103}. Ap\u{103}sa\u{21B}i pe Enter pentru a anula glisarea.`,
    "endDragTouch": `Se gliseaz\u{103}. Atinge\u{21B}i de dou\u{103} ori pentru a anula glisarea.`,
    "endDragVirtual": `Se gliseaz\u{103}. Face\u{21B}i clic pentru a anula glisarea.`,
    "insertAfter": (args)=>`Insera\u{21B}i dup\u{103} ${args.itemText}`,
    "insertBefore": (args)=>`Insera\u{21B}i \xeenainte de ${args.itemText}`,
    "insertBetween": (args)=>`Insera\u{21B}i \xeentre ${args.beforeItemText} \u{219}i ${args.afterItemText}`
};

},{}],"9e2RJ":[function(require,module,exports) {
module.exports = {
    "dragDescriptionKeyboard": `\u{41D}\u{430}\u{436}\u{43C}\u{438}\u{442}\u{435} \u{43A}\u{43B}\u{430}\u{432}\u{438}\u{448}\u{443} Enter \u{434}\u{43B}\u{44F} \u{43D}\u{430}\u{447}\u{430}\u{43B}\u{430} \u{43F}\u{435}\u{440}\u{435}\u{442}\u{430}\u{441}\u{43A}\u{438}\u{432}\u{430}\u{43D}\u{438}\u{44F}.`,
    "dragDescriptionKeyboardAlt": `\u{41D}\u{430}\u{436}\u{43C}\u{438}\u{442}\u{435} Alt + Enter, \u{447}\u{442}\u{43E}\u{431}\u{44B} \u{43D}\u{430}\u{447}\u{430}\u{442}\u{44C} \u{43F}\u{435}\u{440}\u{435}\u{442}\u{430}\u{441}\u{43A}\u{438}\u{432}\u{430}\u{442}\u{44C}.`,
    "dragDescriptionLongPress": `\u{41D}\u{430}\u{436}\u{43C}\u{438}\u{442}\u{435} \u{438} \u{443}\u{434}\u{435}\u{440}\u{436}\u{438}\u{432}\u{430}\u{439}\u{442}\u{435}, \u{447}\u{442}\u{43E}\u{431}\u{44B} \u{43D}\u{430}\u{447}\u{430}\u{442}\u{44C} \u{43F}\u{435}\u{440}\u{435}\u{442}\u{430}\u{441}\u{43A}\u{438}\u{432}\u{430}\u{442}\u{44C}.`,
    "dragDescriptionTouch": `\u{414}\u{432}\u{430}\u{436}\u{434}\u{44B} \u{43D}\u{430}\u{436}\u{43C}\u{438}\u{442}\u{435} \u{434}\u{43B}\u{44F} \u{43D}\u{430}\u{447}\u{430}\u{43B}\u{430} \u{43F}\u{435}\u{440}\u{435}\u{442}\u{430}\u{441}\u{43A}\u{438}\u{432}\u{430}\u{43D}\u{438}\u{44F}.`,
    "dragDescriptionVirtual": `\u{429}\u{435}\u{43B}\u{43A}\u{43D}\u{438}\u{442}\u{435} \u{434}\u{43B}\u{44F} \u{43D}\u{430}\u{447}\u{430}\u{43B}\u{430} \u{43F}\u{435}\u{440}\u{435}\u{442}\u{430}\u{441}\u{43A}\u{438}\u{432}\u{430}\u{43D}\u{438}\u{44F}.`,
    "dragItem": (args)=>`\u{41F}\u{435}\u{440}\u{435}\u{442}\u{430}\u{449}\u{438}\u{442}\u{44C} ${args.itemText}`,
    "dragSelectedItems": (args, formatter)=>`\u{41F}\u{435}\u{440}\u{435}\u{442}\u{430}\u{449}\u{438}\u{442}\u{44C} ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} \u{432}\u{44B}\u{431}\u{440}\u{430}\u{43D}\u{43D}\u{44B}\u{439} \u{44D}\u{43B}\u{435}\u{43C}\u{435}\u{43D}\u{442}`,
            other: ()=>`${formatter.number(args.count)} \u{432}\u{44B}\u{431}\u{440}\u{430}\u{43D}\u{43D}\u{44B}\u{445} \u{44D}\u{43B}\u{435}\u{43C}`
        })}`,
    "dragSelectedKeyboard": (args, formatter)=>`\u{41D}\u{430}\u{436}\u{43C}\u{438}\u{442}\u{435} Enter \u{434}\u{43B}\u{44F} \u{43F}\u{435}\u{440}\u{435}\u{442}\u{430}\u{441}\u{43A}\u{438}\u{432}\u{430}\u{43D}\u{438}\u{44F} ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} \u{432}\u{44B}\u{431}\u{440}\u{430}\u{43D}\u{43D}\u{43E}\u{433}\u{43E} \u{44D}\u{43B}\u{435}\u{43C}\u{435}\u{43D}\u{442}\u{430}`,
            other: ()=>`${formatter.number(args.count)} \u{432}\u{44B}\u{431}\u{440}\u{430}\u{43D}\u{43D}\u{44B}\u{445} \u{44D}\u{43B}\u{435}\u{43C}\u{435}\u{43D}\u{442}\u{43E}\u{432}`
        })}.`,
    "dragSelectedKeyboardAlt": (args, formatter)=>`\u{41D}\u{430}\u{436}\u{43C}\u{438}\u{442}\u{435} Alt + Enter \u{434}\u{43B}\u{44F} \u{43F}\u{435}\u{440}\u{435}\u{442}\u{430}\u{441}\u{43A}\u{438}\u{432}\u{430}\u{43D}\u{438}\u{44F} ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} \u{432}\u{44B}\u{431}\u{440}\u{430}\u{43D}\u{43D}\u{43E}\u{433}\u{43E} \u{44D}\u{43B}\u{435}\u{43C}\u{435}\u{43D}\u{442}\u{430}`,
            other: ()=>`${formatter.number(args.count)} \u{432}\u{44B}\u{431}\u{440}\u{430}\u{43D}\u{43D}\u{44B}\u{445} \u{44D}\u{43B}\u{435}\u{43C}\u{435}\u{43D}\u{442}\u{43E}\u{432}`
        })}.`,
    "dragSelectedLongPress": (args, formatter)=>`\u{41D}\u{430}\u{436}\u{43C}\u{438}\u{442}\u{435} \u{438} \u{443}\u{434}\u{435}\u{440}\u{436}\u{438}\u{432}\u{430}\u{439}\u{442}\u{435} \u{434}\u{43B}\u{44F} \u{43F}\u{435}\u{440}\u{435}\u{442}\u{430}\u{441}\u{43A}\u{438}\u{432}\u{430}\u{43D}\u{438}\u{44F} ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} \u{432}\u{44B}\u{431}\u{440}\u{430}\u{43D}\u{43D}\u{43E}\u{433}\u{43E} \u{44D}\u{43B}\u{435}\u{43C}\u{435}\u{43D}\u{442}\u{430}`,
            other: ()=>`${formatter.number(args.count)} \u{432}\u{44B}\u{431}\u{440}\u{430}\u{43D}\u{43D}\u{44B}\u{445} \u{44D}\u{43B}\u{435}\u{43C}\u{435}\u{43D}\u{442}\u{43E}\u{432}`
        })}.`,
    "dragStartedKeyboard": `\u{41D}\u{430}\u{447}\u{430}\u{442}\u{43E} \u{43F}\u{435}\u{440}\u{435}\u{442}\u{430}\u{441}\u{43A}\u{438}\u{432}\u{430}\u{43D}\u{438}\u{435}. \u{41D}\u{430}\u{436}\u{43C}\u{438}\u{442}\u{435} \u{43A}\u{43B}\u{430}\u{432}\u{438}\u{448}\u{443} Tab \u{434}\u{43B}\u{44F} \u{432}\u{44B}\u{431}\u{43E}\u{440}\u{430} \u{446}\u{435}\u{43B}\u{438}, \u{437}\u{430}\u{442}\u{435}\u{43C} \u{43D}\u{430}\u{436}\u{43C}\u{438}\u{442}\u{435} \u{43A}\u{43B}\u{430}\u{432}\u{438}\u{448}\u{443} Enter, \u{447}\u{442}\u{43E}\u{431}\u{44B} \u{43F}\u{440}\u{438}\u{43C}\u{435}\u{43D}\u{438}\u{442}\u{44C} \u{43F}\u{435}\u{440}\u{435}\u{442}\u{430}\u{441}\u{43A}\u{438}\u{432}\u{430}\u{43D}\u{438}\u{435}, \u{438}\u{43B}\u{438} \u{43A}\u{43B}\u{430}\u{432}\u{438}\u{448}\u{443} Escape \u{434}\u{43B}\u{44F} \u{43E}\u{442}\u{43C}\u{435}\u{43D}\u{44B} \u{434}\u{435}\u{439}\u{441}\u{442}\u{432}\u{438}\u{44F}.`,
    "dragStartedTouch": `\u{41D}\u{430}\u{447}\u{430}\u{442}\u{43E} \u{43F}\u{435}\u{440}\u{435}\u{442}\u{430}\u{441}\u{43A}\u{438}\u{432}\u{430}\u{43D}\u{438}\u{435}. \u{412}\u{44B}\u{431}\u{435}\u{440}\u{438}\u{442}\u{435} \u{446}\u{435}\u{43B}\u{44C}, \u{437}\u{430}\u{442}\u{435}\u{43C} \u{434}\u{432}\u{430}\u{436}\u{434}\u{44B} \u{43D}\u{430}\u{436}\u{43C}\u{438}\u{442}\u{435}, \u{447}\u{442}\u{43E}\u{431}\u{44B} \u{43F}\u{440}\u{438}\u{43C}\u{435}\u{43D}\u{438}\u{442}\u{44C} \u{43F}\u{435}\u{440}\u{435}\u{442}\u{430}\u{441}\u{43A}\u{438}\u{432}\u{430}\u{43D}\u{438}\u{435}.`,
    "dragStartedVirtual": `\u{41D}\u{430}\u{447}\u{430}\u{442}\u{43E} \u{43F}\u{435}\u{440}\u{435}\u{442}\u{430}\u{441}\u{43A}\u{438}\u{432}\u{430}\u{43D}\u{438}\u{435}. \u{41D}\u{430}\u{436}\u{43C}\u{438}\u{442}\u{435} \u{43A}\u{43B}\u{430}\u{432}\u{438}\u{448}\u{443} Tab \u{434}\u{43B}\u{44F} \u{432}\u{44B}\u{431}\u{43E}\u{440}\u{430} \u{446}\u{435}\u{43B}\u{438}, \u{437}\u{430}\u{442}\u{435}\u{43C} \u{43D}\u{430}\u{436}\u{43C}\u{438}\u{442}\u{435} \u{43A}\u{43B}\u{430}\u{432}\u{438}\u{448}\u{443} Enter, \u{447}\u{442}\u{43E}\u{431}\u{44B} \u{43F}\u{440}\u{438}\u{43C}\u{435}\u{43D}\u{438}\u{442}\u{44C} \u{43F}\u{435}\u{440}\u{435}\u{442}\u{430}\u{441}\u{43A}\u{438}\u{432}\u{430}\u{43D}\u{438}\u{435}.`,
    "dropCanceled": `\u{41F}\u{435}\u{440}\u{435}\u{442}\u{430}\u{441}\u{43A}\u{438}\u{432}\u{430}\u{43D}\u{438}\u{435} \u{43E}\u{442}\u{43C}\u{435}\u{43D}\u{435}\u{43D}\u{43E}.`,
    "dropComplete": `\u{41F}\u{435}\u{440}\u{435}\u{442}\u{430}\u{441}\u{43A}\u{438}\u{432}\u{430}\u{43D}\u{438}\u{435} \u{437}\u{430}\u{432}\u{435}\u{440}\u{448}\u{435}\u{43D}\u{43E}.`,
    "dropDescriptionKeyboard": `\u{41D}\u{430}\u{436}\u{43C}\u{438}\u{442}\u{435} \u{43A}\u{43B}\u{430}\u{432}\u{438}\u{448}\u{443} Enter, \u{447}\u{442}\u{43E}\u{431}\u{44B} \u{43F}\u{440}\u{438}\u{43C}\u{435}\u{43D}\u{438}\u{442}\u{44C} \u{43F}\u{435}\u{440}\u{435}\u{442}\u{430}\u{441}\u{43A}\u{438}\u{432}\u{430}\u{43D}\u{438}\u{435}. \u{41D}\u{430}\u{436}\u{43C}\u{438}\u{442}\u{435} \u{43A}\u{43B}\u{430}\u{432}\u{438}\u{448}\u{443} Escape \u{434}\u{43B}\u{44F} \u{43E}\u{442}\u{43C}\u{435}\u{43D}\u{44B}.`,
    "dropDescriptionTouch": `\u{414}\u{432}\u{430}\u{436}\u{434}\u{44B} \u{43D}\u{430}\u{436}\u{43C}\u{438}\u{442}\u{435}, \u{447}\u{442}\u{43E}\u{431}\u{44B} \u{43F}\u{440}\u{438}\u{43C}\u{435}\u{43D}\u{438}\u{442}\u{44C} \u{43F}\u{435}\u{440}\u{435}\u{442}\u{430}\u{441}\u{43A}\u{438}\u{432}\u{430}\u{43D}\u{438}\u{435}.`,
    "dropDescriptionVirtual": `\u{429}\u{435}\u{43B}\u{43A}\u{43D}\u{438}\u{442}\u{435}, \u{447}\u{442}\u{43E}\u{431}\u{44B} \u{43F}\u{440}\u{438}\u{43C}\u{435}\u{43D}\u{438}\u{442}\u{44C} \u{43F}\u{435}\u{440}\u{435}\u{442}\u{430}\u{441}\u{43A}\u{438}\u{432}\u{430}\u{43D}\u{438}\u{435}.`,
    "dropIndicator": `\u{438}\u{43D}\u{434}\u{438}\u{43A}\u{430}\u{442}\u{43E}\u{440} \u{43F}\u{435}\u{440}\u{435}\u{442}\u{430}\u{441}\u{43A}\u{438}\u{432}\u{430}\u{43D}\u{438}\u{44F}`,
    "dropOnItem": (args)=>`\u{41F}\u{435}\u{440}\u{435}\u{442}\u{430}\u{449}\u{438}\u{442}\u{44C} \u{43D}\u{430} ${args.itemText}`,
    "dropOnRoot": `\u{41F}\u{435}\u{440}\u{435}\u{442}\u{430}\u{449}\u{438}\u{442}\u{44C} \u{43D}\u{430}`,
    "endDragKeyboard": `\u{41F}\u{435}\u{440}\u{435}\u{442}\u{430}\u{441}\u{43A}\u{438}\u{432}\u{430}\u{43D}\u{438}\u{435}. \u{41D}\u{430}\u{436}\u{43C}\u{438}\u{442}\u{435} \u{43A}\u{43B}\u{430}\u{432}\u{438}\u{448}\u{443} Enter \u{434}\u{43B}\u{44F} \u{43E}\u{442}\u{43C}\u{435}\u{43D}\u{44B}.`,
    "endDragTouch": `\u{41F}\u{435}\u{440}\u{435}\u{442}\u{430}\u{441}\u{43A}\u{438}\u{432}\u{430}\u{43D}\u{438}\u{435}. \u{414}\u{432}\u{430}\u{436}\u{434}\u{44B} \u{43D}\u{430}\u{436}\u{43C}\u{438}\u{442}\u{435} \u{434}\u{43B}\u{44F} \u{43E}\u{442}\u{43C}\u{435}\u{43D}\u{44B}.`,
    "endDragVirtual": `\u{41F}\u{435}\u{440}\u{435}\u{442}\u{430}\u{441}\u{43A}\u{438}\u{432}\u{430}\u{43D}\u{438}\u{435}. \u{429}\u{435}\u{43B}\u{43A}\u{43D}\u{438}\u{442}\u{435} \u{434}\u{43B}\u{44F} \u{43E}\u{442}\u{43C}\u{435}\u{43D}\u{44B}.`,
    "insertAfter": (args)=>`\u{412}\u{441}\u{442}\u{430}\u{432}\u{438}\u{442}\u{44C} \u{43F}\u{43E}\u{441}\u{43B}\u{435} ${args.itemText}`,
    "insertBefore": (args)=>`\u{412}\u{441}\u{442}\u{430}\u{432}\u{438}\u{442}\u{44C} \u{43F}\u{435}\u{440}\u{435}\u{434} ${args.itemText}`,
    "insertBetween": (args)=>`\u{412}\u{441}\u{442}\u{430}\u{432}\u{438}\u{442}\u{44C} \u{43C}\u{435}\u{436}\u{434}\u{443} ${args.beforeItemText} \u{438} ${args.afterItemText}`
};

},{}],"hFky4":[function(require,module,exports) {
module.exports = {
    "dragDescriptionKeyboard": `Stla\u{10D}en\xedm kl\xe1vesu Enter za\u{10D}nete pres\xfavanie.`,
    "dragDescriptionKeyboardAlt": `Stla\u{10D}en\xedm kl\xe1vesov Alt + Enter za\u{10D}nete pres\xfavanie.`,
    "dragDescriptionLongPress": `Dlh\xfdm stla\u{10D}en\xedm za\u{10D}nete pres\xfavanie.`,
    "dragDescriptionTouch": `Dvojit\xfdm kliknut\xedm za\u{10D}nete pres\xfavanie.`,
    "dragDescriptionVirtual": `Kliknut\xedm za\u{10D}nete pres\xfavanie.`,
    "dragItem": (args)=>`Presun\xfa\u{165} polo\u{17E}ku ${args.itemText}`,
    "dragSelectedItems": (args, formatter)=>`Presun\xfa\u{165} ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} vybrat\xfa polo\u{17E}ku`,
            other: ()=>`${formatter.number(args.count)} vybrat\xe9 polo\u{17E}ky`
        })}`,
    "dragSelectedKeyboard": (args, formatter)=>`Stla\u{10D}en\xedm kl\xe1vesu Enter presuniete ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} vybrat\xfa polo\u{17E}ku`,
            other: ()=>`${formatter.number(args.count)} vybrat\xfdch polo\u{17E}iek`
        })}.`,
    "dragSelectedKeyboardAlt": (args, formatter)=>`Stla\u{10D}en\xedm kl\xe1vesov Alt + Enter presuniete ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} vybrat\xfa polo\u{17E}ku`,
            other: ()=>`${formatter.number(args.count)} vybrat\xfdch polo\u{17E}iek`
        })}.`,
    "dragSelectedLongPress": (args, formatter)=>`Dlh\xfdm stla\u{10D}en\xedm presuniete ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} vybrat\xfa polo\u{17E}ku`,
            other: ()=>`${formatter.number(args.count)} vybrat\xfdch polo\u{17E}iek`
        })}.`,
    "dragStartedKeyboard": `Pres\xfavanie sa za\u{10D}alo. Do cie\u{13E}ov\xe9ho umiestnenia prejdete stla\u{10D}en\xedm kl\xe1vesu Tab. Ak chcete polo\u{17E}ku umiestni\u{165}, stla\u{10D}te kl\xe1ves Enter alebo stla\u{10D}te kl\xe1ves Esc, ak chcete pres\xfavanie zru\u{161}i\u{165}.`,
    "dragStartedTouch": `Pres\xfavanie sa za\u{10D}alo. Prejdite na cie\u{13E}ov\xe9 umiestnenie a dvojit\xfdm kliknut\xedm umiestnite polo\u{17E}ku.`,
    "dragStartedVirtual": `Pres\xfavanie sa za\u{10D}alo. Prejdite na cie\u{13E}ov\xe9 umiestnenie a kliknut\xedm alebo stla\u{10D}en\xedm kl\xe1vesu Enter umiestnite polo\u{17E}ku.`,
    "dropCanceled": `Umiestnenie zru\u{161}en\xe9.`,
    "dropComplete": `Umiestnenie dokon\u{10D}en\xe9.`,
    "dropDescriptionKeyboard": `Stla\u{10D}en\xedm kl\xe1vesu Enter umiestnite polo\u{17E}ku. Stla\u{10D}en\xedm kl\xe1vesu Esc zru\u{161}\xedte pres\xfavanie.`,
    "dropDescriptionTouch": `Dvojit\xfdm kliknut\xedm umiestnite polo\u{17E}ku.`,
    "dropDescriptionVirtual": `Kliknut\xedm umiestnite polo\u{17E}ku.`,
    "dropIndicator": `indik\xe1tor umiestnenia`,
    "dropOnItem": (args)=>`Umiestni\u{165} na polo\u{17E}ku ${args.itemText}`,
    "dropOnRoot": `Umiestni\u{165} na`,
    "endDragKeyboard": `Prebieha pres\xfavanie. Ak ho chcete zru\u{161}i\u{165}, stla\u{10D}te kl\xe1ves Enter.`,
    "endDragTouch": `Prebieha pres\xfavanie. Dvojit\xfdm kliknut\xedm ho m\xf4\u{17E}ete zru\u{161}i\u{165}.`,
    "endDragVirtual": `Prebieha pres\xfavanie.`,
    "insertAfter": (args)=>`Vlo\u{17E}i\u{165} za polo\u{17E}ku ${args.itemText}`,
    "insertBefore": (args)=>`Vlo\u{17E}i\u{165} pred polo\u{17E}ku ${args.itemText}`,
    "insertBetween": (args)=>`Vlo\u{17E}i\u{165} medzi polo\u{17E}ky ${args.beforeItemText} a ${args.afterItemText}`
};

},{}],"g7XWC":[function(require,module,exports) {
module.exports = {
    "dragDescriptionKeyboard": `Pritisnite tipko Enter za za\u{10D}etek vle\u{10D}enja.`,
    "dragDescriptionKeyboardAlt": `Pritisnite tipki Alt + Enter za za\u{10D}etek vle\u{10D}enja.`,
    "dragDescriptionLongPress": `Pritisnite in zadr\u{17E}ite za za\u{10D}etek vle\u{10D}enja.`,
    "dragDescriptionTouch": `Dvotapnite za za\u{10D}etek vle\u{10D}enja.`,
    "dragDescriptionVirtual": `Kliknite za za\u{10D}etek vle\u{10D}enja.`,
    "dragItem": (args)=>`Povleci ${args.itemText}`,
    "dragSelectedItems": (args, formatter)=>`Povlecite ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} izbran element`,
            other: ()=>`izbrane elemente (${formatter.number(args.count)})`
        })}`,
    "dragSelectedKeyboard": (args, formatter)=>`Pritisnite tipko Enter, da povle\u{10D}ete ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} izbrani element`,
            other: ()=>`${formatter.number(args.count)} izbranih elementov`
        })}.`,
    "dragSelectedKeyboardAlt": (args, formatter)=>`Pritisnite tipki Alt + Enter, da povle\u{10D}ete ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} izbrani element`,
            other: ()=>`${formatter.number(args.count)} izbranih elementov`
        })}.`,
    "dragSelectedLongPress": (args, formatter)=>`Pritisnite in zadr\u{17E}ite, da povle\u{10D}ete ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} izbrani element`,
            other: ()=>`${formatter.number(args.count)} izbranih elementov`
        })}.`,
    "dragStartedKeyboard": `Vle\u{10D}enje se je za\u{10D}elo. Pritisnite tipko Tab za pomik na mesto, kamor \u{17E}elite spustiti elemente, in pritisnite tipko Enter, da jih spustite, ali tipko Escape, da prekli\u{10D}ete postopek.`,
    "dragStartedTouch": `Vle\u{10D}enje se je za\u{10D}elo. Pomaknite se na mesto, kamor \u{17E}elite spustiti elemente, in dvotapnite, da jih spustite.`,
    "dragStartedVirtual": `Vle\u{10D}enje se je za\u{10D}elo. Pomaknite se na mesto, kamor \u{17E}elite spustiti elemente, in kliknite ali pritisnite tipko Enter, da jih spustite.`,
    "dropCanceled": `Spust je preklican.`,
    "dropComplete": `Spust je kon\u{10D}an.`,
    "dropDescriptionKeyboard": `Pritisnite tipko Enter, da spustite. Pritisnite tipko Escape, da prekli\u{10D}ete vle\u{10D}enje.`,
    "dropDescriptionTouch": `Dvotapnite, da spustite.`,
    "dropDescriptionVirtual": `Kliknite, da spustite.`,
    "dropIndicator": `indikator spusta`,
    "dropOnItem": (args)=>`Spusti na mesto ${args.itemText}`,
    "dropOnRoot": `Spusti na mesto`,
    "endDragKeyboard": `Vle\u{10D}enje. Pritisnite tipko Enter za preklic vle\u{10D}enja.`,
    "endDragTouch": `Vle\u{10D}enje. Dvotapnite za preklic vle\u{10D}enja.`,
    "endDragVirtual": `Vle\u{10D}enje. Kliknite, da prekli\u{10D}ete vle\u{10D}enje.`,
    "insertAfter": (args)=>`Vstavi za ${args.itemText}`,
    "insertBefore": (args)=>`Vstavi pred ${args.itemText}`,
    "insertBetween": (args)=>`Vstavi med ${args.beforeItemText} in ${args.afterItemText}`
};

},{}],"hOi5K":[function(require,module,exports) {
module.exports = {
    "dragDescriptionKeyboard": `Pritisnite Enter da biste zapo\u{10D}eli prevla\u{10D}enje.`,
    "dragDescriptionKeyboardAlt": `Pritisnite Alt + Enter da biste zapo\u{10D}eli prevla\u{10D}enje.`,
    "dragDescriptionLongPress": `Pritisnite dugo da biste zapo\u{10D}eli prevla\u{10D}enje.`,
    "dragDescriptionTouch": `Dvaput dodirnite da biste zapo\u{10D}eli prevla\u{10D}enje.`,
    "dragDescriptionVirtual": `Kliknite da biste zapo\u{10D}eli prevla\u{10D}enje.`,
    "dragItem": (args)=>`Prevucite ${args.itemText}`,
    "dragSelectedItems": (args, formatter)=>`Prevucite ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} izabranu stavku`,
            other: ()=>`${formatter.number(args.count)} izabrane stavke`
        })}`,
    "dragSelectedKeyboard": (args, formatter)=>`Pritisnite Enter da biste prevukli ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} izabranu stavku`,
            other: ()=>`${formatter.number(args.count)} izabranih stavki`
        })}.`,
    "dragSelectedKeyboardAlt": (args, formatter)=>`Pritisnite Alt + Enter da biste prevukli ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} izabranu stavku`,
            other: ()=>`${formatter.number(args.count)} izabranih stavki`
        })}.`,
    "dragSelectedLongPress": (args, formatter)=>`Pritisnite dugo da biste prevukli ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} izabranu stavku`,
            other: ()=>`${formatter.number(args.count)} izabranih stavki`
        })}.`,
    "dragStartedKeyboard": `Prevla\u{10D}enje je zapo\u{10D}eto. Pritisnite Tab da biste oti\u{161}li do cilja za otpu\u{161}tanje, zatim pritisnite Enter za ispu\u{161}tanje ili pritisnite Escape za otkazivanje.`,
    "dragStartedTouch": `Prevla\u{10D}enje je zapo\u{10D}eto. Idite do cilja za otpu\u{161}tanje, a zatim dvaput dodirnite za otpu\u{161}tanje.`,
    "dragStartedVirtual": `Prevla\u{10D}enje je zapo\u{10D}eto. Idite do cilja za otpu\u{161}tanje, a zatim kliknite ili pritinite Enter za otpu\u{161}tanje.`,
    "dropCanceled": `Otpu\u{161}tanje je otkazano.`,
    "dropComplete": `Prevla\u{10D}enje je zavr\u{161}eno.`,
    "dropDescriptionKeyboard": `Pritisnite Enter da biste otpustili. Pritisnite Escape da biste otkazali prevla\u{10D}enje.`,
    "dropDescriptionTouch": `Dvaput dodirnite za otpu\u{161}tanje.`,
    "dropDescriptionVirtual": `Kliknite za otpu\u{161}tanje.`,
    "dropIndicator": `Indikator otpu\u{161}tanja`,
    "dropOnItem": (args)=>`Otpusti na ${args.itemText}`,
    "dropOnRoot": `Otpusti na`,
    "endDragKeyboard": `Prevla\u{10D}enje u toku. Pritisnite Enter da biste otkazali prevla\u{10D}enje.`,
    "endDragTouch": `Prevla\u{10D}enje u toku. Dvaput dodirnite da biste otkazali prevla\u{10D}enje.`,
    "endDragVirtual": `Prevla\u{10D}enje u toku. Kliknite da biste otkazali prevla\u{10D}enje.`,
    "insertAfter": (args)=>`Umetnite posle ${args.itemText}`,
    "insertBefore": (args)=>`Umetnite ispred ${args.itemText}`,
    "insertBetween": (args)=>`Umetnite izme\u{111}u ${args.beforeItemText} i ${args.afterItemText}`
};

},{}],"4mPWr":[function(require,module,exports) {
module.exports = {
    "dragDescriptionKeyboard": `Tryck p\xe5 enter f\xf6r att b\xf6rja dra.`,
    "dragDescriptionKeyboardAlt": `Tryck p\xe5 Alt + Retur f\xf6r att b\xf6rja dra.`,
    "dragDescriptionLongPress": `Tryck l\xe4nge f\xf6r att b\xf6rja dra.`,
    "dragDescriptionTouch": `Dubbeltryck f\xf6r att b\xf6rja dra.`,
    "dragDescriptionVirtual": `Klicka f\xf6r att b\xf6rja dra.`,
    "dragItem": (args)=>`Dra ${args.itemText}`,
    "dragSelectedItems": (args, formatter)=>`Dra ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} valt objekt`,
            other: ()=>`${formatter.number(args.count)} valda objekt`
        })}`,
    "dragSelectedKeyboard": (args, formatter)=>`Tryck p\xe5 Retur f\xf6r att dra ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} markerat objekt`,
            other: ()=>`${formatter.number(args.count)} markerade objekt`
        })}.`,
    "dragSelectedKeyboardAlt": (args, formatter)=>`Tryck p\xe5 Alt + Retur f\xf6r att dra ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} markerat objekt`,
            other: ()=>`${formatter.number(args.count)} markerade objekt`
        })}.`,
    "dragSelectedLongPress": (args, formatter)=>`Tryck l\xe4nge f\xf6r att dra ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} markerat objekt`,
            other: ()=>`${formatter.number(args.count)} markerade objekt`
        })}.`,
    "dragStartedKeyboard": `B\xf6rja dra. Tryck p\xe5 tabb f\xf6r att navigera till m\xe5let, tryck p\xe5 enter f\xf6r att sl\xe4ppa eller p\xe5 escape f\xf6r att avbryta.`,
    "dragStartedTouch": `B\xf6rja dra. Navigera till ett m\xe5l och dubbeltryck f\xf6r att sl\xe4ppa.`,
    "dragStartedVirtual": `B\xf6rja dra. Navigera till ett m\xe5l och klicka eller tryck p\xe5 enter f\xf6r att sl\xe4ppa.`,
    "dropCanceled": `Sl\xe4pp\xe5tg\xe4rd avbr\xf6ts.`,
    "dropComplete": `Sl\xe4pp\xe5tg\xe4rd klar.`,
    "dropDescriptionKeyboard": `Tryck p\xe5 enter f\xf6r att sl\xe4ppa. Tryck p\xe5 escape f\xf6r att avbryta drag\xe5tg\xe4rd.`,
    "dropDescriptionTouch": `Dubbeltryck f\xf6r att sl\xe4ppa.`,
    "dropDescriptionVirtual": `Klicka f\xf6r att sl\xe4ppa.`,
    "dropIndicator": `sl\xe4ppindikator`,
    "dropOnItem": (args)=>`Sl\xe4pp p\xe5 ${args.itemText}`,
    "dropOnRoot": `Sl\xe4pp p\xe5`,
    "endDragKeyboard": `Drar. Tryck p\xe5 enter f\xf6r att avbryta drag\xe5tg\xe4rd.`,
    "endDragTouch": `Drar. Dubbeltryck f\xf6r att avbryta drag\xe5tg\xe4rd.`,
    "endDragVirtual": `Drar. Klicka f\xf6r att avbryta drag\xe5tg\xe4rd.`,
    "insertAfter": (args)=>`Infoga efter ${args.itemText}`,
    "insertBefore": (args)=>`Infoga f\xf6re ${args.itemText}`,
    "insertBetween": (args)=>`Infoga mellan ${args.beforeItemText} och ${args.afterItemText}`
};

},{}],"eNVuG":[function(require,module,exports) {
module.exports = {
    "dragDescriptionKeyboard": `S\xfcr\xfcklemeyi ba\u{15F}latmak i\xe7in Enter'a bas\u{131}n.`,
    "dragDescriptionKeyboardAlt": `S\xfcr\xfcklemeyi ba\u{15F}latmak i\xe7in Alt + Enter'a bas\u{131}n.`,
    "dragDescriptionLongPress": `S\xfcr\xfcklemeye ba\u{15F}lamak i\xe7in uzun bas\u{131}n.`,
    "dragDescriptionTouch": `S\xfcr\xfcklemeyi ba\u{15F}latmak i\xe7in \xe7ift t\u{131}klay\u{131}n.`,
    "dragDescriptionVirtual": `S\xfcr\xfcklemeyi ba\u{15F}latmak i\xe7in t\u{131}klay\u{131}n.`,
    "dragItem": (args)=>`${args.itemText}\u{2019}i s\xfcr\xfckle`,
    "dragSelectedItems": (args, formatter)=>`S\xfcr\xfckle ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} se\xe7ili \xf6ge`,
            other: ()=>`${formatter.number(args.count)} se\xe7ili \xf6ge`
        })}`,
    "dragSelectedKeyboard": (args, formatter)=>`${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} se\xe7ilmi\u{15F} \xf6\u{11F}e`,
            other: ()=>`${formatter.number(args.count)} se\xe7ilmi\u{15F} \xf6\u{11F}e`
        })} \xf6\u{11F}esini s\xfcr\xfcklemek i\xe7in Enter'a bas\u{131}n.`,
    "dragSelectedKeyboardAlt": (args, formatter)=>`${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} se\xe7ilmi\u{15F} \xf6\u{11F}e`,
            other: ()=>`${formatter.number(args.count)} se\xe7ilmi\u{15F} \xf6\u{11F}e`
        })} \xf6\u{11F}esini s\xfcr\xfcklemek i\xe7in Alt + Enter tu\u{15F}una bas\u{131}n.`,
    "dragSelectedLongPress": (args, formatter)=>`${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} se\xe7ilmi\u{15F} \xf6\u{11F}e`,
            other: ()=>`${formatter.number(args.count)} se\xe7ilmi\u{15F} \xf6\u{11F}e`
        })} \xf6\u{11F}esini s\xfcr\xfcklemek i\xe7in uzun bas\u{131}n.`,
    "dragStartedKeyboard": `S\xfcr\xfckleme ba\u{15F}lat\u{131}ld\u{131}. Bir b\u{131}rakma hedefine gitmek i\xe7in Tab\u{2019}a bas\u{131}n, ard\u{131}ndan b\u{131}rakmak i\xe7in Enter\u{2019}a bas\u{131}n veya iptal etmek i\xe7in Escape\u{2019}e bas\u{131}n.`,
    "dragStartedTouch": `S\xfcr\xfckleme ba\u{15F}lat\u{131}ld\u{131}. Bir b\u{131}rakma hedefine gidin, ard\u{131}ndan b\u{131}rakmak i\xe7in \xe7ift t\u{131}klay\u{131}n.`,
    "dragStartedVirtual": `S\xfcr\xfckleme ba\u{15F}lat\u{131}ld\u{131}. Bir b\u{131}rakma hedefine gidin, ard\u{131}ndan b\u{131}rakmak i\xe7in Enter\u{2019}a t\u{131}klay\u{131}n veya bas\u{131}n.`,
    "dropCanceled": `B\u{131}rakma iptal edildi.`,
    "dropComplete": `B\u{131}rakma tamamland\u{131}.`,
    "dropDescriptionKeyboard": `B\u{131}rakmak i\xe7in Enter'a bas\u{131}n. S\xfcr\xfcklemeyi iptal etmek i\xe7in Escape'e bas\u{131}n.`,
    "dropDescriptionTouch": `B\u{131}rakmak i\xe7in \xe7ift t\u{131}klay\u{131}n.`,
    "dropDescriptionVirtual": `B\u{131}rakmak i\xe7in t\u{131}klay\u{131}n.`,
    "dropIndicator": `b\u{131}rakma g\xf6stergesi`,
    "dropOnItem": (args)=>`${args.itemText} \xfczerine b\u{131}rak`,
    "dropOnRoot": `B\u{131}rak\u{131}n`,
    "endDragKeyboard": `S\xfcr\xfckleme. S\xfcr\xfcklemeyi iptal etmek i\xe7in Enter'a bas\u{131}n.`,
    "endDragTouch": `S\xfcr\xfckleme. S\xfcr\xfcklemeyi iptal etmek i\xe7in \xe7ift t\u{131}klay\u{131}n.`,
    "endDragVirtual": `S\xfcr\xfckleme. S\xfcr\xfcklemeyi iptal etmek i\xe7in t\u{131}klay\u{131}n.`,
    "insertAfter": (args)=>`${args.itemText}\u{2019}den sonra gir`,
    "insertBefore": (args)=>`${args.itemText}\u{2019}den \xf6nce gir`,
    "insertBetween": (args)=>`${args.beforeItemText} ve ${args.afterItemText} aras\u{131}na gir`
};

},{}],"cszCb":[function(require,module,exports) {
module.exports = {
    "dragDescriptionKeyboard": `\u{41D}\u{430}\u{442}\u{438}\u{441}\u{43D}\u{456}\u{442}\u{44C} Enter, \u{449}\u{43E}\u{431} \u{43F}\u{43E}\u{447}\u{430}\u{442}\u{438} \u{43F}\u{435}\u{440}\u{435}\u{442}\u{44F}\u{433}\u{443}\u{432}\u{430}\u{43D}\u{43D}\u{44F}.`,
    "dragDescriptionKeyboardAlt": `\u{41D}\u{430}\u{442}\u{438}\u{441}\u{43D}\u{456}\u{442}\u{44C} Alt + Enter, \u{449}\u{43E}\u{431} \u{43F}\u{43E}\u{447}\u{430}\u{442}\u{438} \u{43F}\u{435}\u{440}\u{435}\u{442}\u{44F}\u{433}\u{443}\u{432}\u{430}\u{43D}\u{43D}\u{44F}.`,
    "dragDescriptionLongPress": `\u{41D}\u{430}\u{442}\u{438}\u{441}\u{43D}\u{456}\u{442}\u{44C} \u{456} \u{443}\u{442}\u{440}\u{438}\u{43C}\u{443}\u{439}\u{442}\u{435}, \u{449}\u{43E}\u{431} \u{43F}\u{43E}\u{447}\u{430}\u{442}\u{438} \u{43F}\u{435}\u{440}\u{435}\u{442}\u{44F}\u{433}\u{443}\u{432}\u{430}\u{43D}\u{43D}\u{44F}.`,
    "dragDescriptionTouch": `\u{41D}\u{430}\u{442}\u{438}\u{441}\u{43D}\u{456}\u{442}\u{44C} \u{434}\u{432}\u{456}\u{447}\u{456}, \u{449}\u{43E}\u{431} \u{43F}\u{43E}\u{447}\u{430}\u{442}\u{438} \u{43F}\u{435}\u{440}\u{435}\u{442}\u{44F}\u{433}\u{443}\u{432}\u{430}\u{43D}\u{43D}\u{44F}.`,
    "dragDescriptionVirtual": `\u{41D}\u{430}\u{442}\u{438}\u{441}\u{43D}\u{456}\u{442}\u{44C}, \u{449}\u{43E}\u{431} \u{43F}\u{43E}\u{447}\u{430}\u{442}\u{438} \u{43F}\u{435}\u{440}\u{435}\u{442}\u{44F}\u{433}\u{443}\u{432}\u{430}\u{43D}\u{43D}\u{44F}.`,
    "dragItem": (args)=>`\u{41F}\u{435}\u{440}\u{435}\u{442}\u{44F}\u{433}\u{43D}\u{443}\u{442}\u{438} ${args.itemText}`,
    "dragSelectedItems": (args, formatter)=>`\u{41F}\u{435}\u{440}\u{435}\u{442}\u{44F}\u{433}\u{43D}\u{456}\u{442}\u{44C} ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} \u{432}\u{438}\u{431}\u{440}\u{430}\u{43D}\u{438}\u{439} \u{435}\u{43B}\u{435}\u{43C}\u{435}\u{43D}\u{442}`,
            other: ()=>`${formatter.number(args.count)} \u{432}\u{438}\u{431}\u{440}\u{430}\u{43D}\u{438}\u{445} \u{435}\u{43B}\u{435}\u{43C}`
        })}`,
    "dragSelectedKeyboard": (args, formatter)=>`\u{41D}\u{430}\u{442}\u{438}\u{441}\u{43D}\u{456}\u{442}\u{44C} Enter, \u{449}\u{43E}\u{431} \u{43F}\u{435}\u{440}\u{435}\u{442}\u{44F}\u{433}\u{43D}\u{443}\u{442}\u{438} ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} \u{432}\u{438}\u{431}\u{440}\u{430}\u{43D}\u{438}\u{439} \u{435}\u{43B}\u{435}\u{43C}\u{435}\u{43D}\u{442}`,
            other: ()=>`${formatter.number(args.count)} \u{432}\u{438}\u{431}\u{440}\u{430}\u{43D}\u{438}\u{445} \u{435}\u{43B}\u{435}\u{43C}\u{435}\u{43D}\u{442}\u{438}(-\u{456}\u{432})`
        })}.`,
    "dragSelectedKeyboardAlt": (args, formatter)=>`\u{41D}\u{430}\u{442}\u{438}\u{441}\u{43D}\u{456}\u{442}\u{44C} Alt + Enter, \u{449}\u{43E}\u{431} \u{43F}\u{435}\u{440}\u{435}\u{442}\u{44F}\u{433}\u{43D}\u{443}\u{442}\u{438} ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} \u{432}\u{438}\u{431}\u{440}\u{430}\u{43D}\u{438}\u{439} \u{435}\u{43B}\u{435}\u{43C}\u{435}\u{43D}\u{442}`,
            other: ()=>`${formatter.number(args.count)} \u{432}\u{438}\u{431}\u{440}\u{430}\u{43D}\u{438}\u{445} \u{435}\u{43B}\u{435}\u{43C}\u{435}\u{43D}\u{442}\u{438}(-\u{456}\u{432})`
        })}.`,
    "dragSelectedLongPress": (args, formatter)=>`\u{423}\u{442}\u{440}\u{438}\u{43C}\u{443}\u{439}\u{442}\u{435}, \u{449}\u{43E}\u{431} \u{43F}\u{435}\u{440}\u{435}\u{442}\u{44F}\u{433}\u{43D}\u{443}\u{442}\u{438} ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} \u{432}\u{438}\u{431}\u{440}\u{430}\u{43D}\u{438}\u{439} \u{435}\u{43B}\u{435}\u{43C}\u{435}\u{43D}\u{442}`,
            other: ()=>`${formatter.number(args.count)} \u{432}\u{438}\u{431}\u{440}\u{430}\u{43D}\u{438}\u{445} \u{435}\u{43B}\u{435}\u{43C}\u{435}\u{43D}\u{442}\u{438}(-\u{456}\u{432})`
        })}.`,
    "dragStartedKeyboard": `\u{41F}\u{435}\u{440}\u{435}\u{442}\u{44F}\u{433}\u{443}\u{432}\u{430}\u{43D}\u{43D}\u{44F} \u{43F}\u{43E}\u{447}\u{430}\u{43B}\u{43E}\u{441}\u{44F}. \u{41D}\u{430}\u{442}\u{438}\u{441}\u{43D}\u{456}\u{442}\u{44C} Tab, \u{449}\u{43E}\u{431} \u{43F}\u{435}\u{440}\u{435}\u{439}\u{442}\u{438} \u{434}\u{43E} \u{446}\u{456}\u{43B}\u{456} \u{43F}\u{435}\u{440}\u{435}\u{442}\u{44F}\u{433}\u{443}\u{432}\u{430}\u{43D}\u{43D}\u{44F}, \u{43F}\u{43E}\u{442}\u{456}\u{43C} \u{43D}\u{430}\u{442}\u{438}\u{441}\u{43D}\u{456}\u{442}\u{44C} Enter, \u{449}\u{43E}\u{431} \u{43F}\u{435}\u{440}\u{435}\u{442}\u{44F}\u{433}\u{43D}\u{443}\u{442}\u{438}, \u{430}\u{431}\u{43E} Escape, \u{449}\u{43E}\u{431} \u{441}\u{43A}\u{430}\u{441}\u{443}\u{432}\u{430}\u{442}\u{438}.`,
    "dragStartedTouch": `\u{41F}\u{435}\u{440}\u{435}\u{442}\u{44F}\u{433}\u{443}\u{432}\u{430}\u{43D}\u{43D}\u{44F} \u{43F}\u{43E}\u{447}\u{430}\u{43B}\u{43E}\u{441}\u{44F}. \u{41F}\u{435}\u{440}\u{435}\u{439}\u{434}\u{456}\u{442}\u{44C} \u{434}\u{43E} \u{446}\u{456}\u{43B}\u{456} \u{43F}\u{435}\u{440}\u{435}\u{442}\u{44F}\u{433}\u{443}\u{432}\u{430}\u{43D}\u{43D}\u{44F}, \u{43F}\u{43E}\u{442}\u{456}\u{43C} \u{43D}\u{430}\u{442}\u{438}\u{441}\u{43D}\u{456}\u{442}\u{44C} \u{434}\u{432}\u{456}\u{447}\u{456}, \u{449}\u{43E}\u{431} \u{43F}\u{435}\u{440}\u{435}\u{442}\u{44F}\u{433}\u{43D}\u{443}\u{442}\u{438}.`,
    "dragStartedVirtual": `\u{41F}\u{435}\u{440}\u{435}\u{442}\u{44F}\u{433}\u{443}\u{432}\u{430}\u{43D}\u{43D}\u{44F} \u{43F}\u{43E}\u{447}\u{430}\u{43B}\u{43E}\u{441}\u{44F}. \u{41F}\u{435}\u{440}\u{435}\u{439}\u{434}\u{456}\u{442}\u{44C} \u{434}\u{43E} \u{446}\u{456}\u{43B}\u{456} \u{43F}\u{435}\u{440}\u{435}\u{442}\u{44F}\u{433}\u{443}\u{432}\u{430}\u{43D}\u{43D}\u{44F}, \u{43F}\u{43E}\u{442}\u{456}\u{43C} \u{43D}\u{430}\u{442}\u{438}\u{441}\u{43D}\u{456}\u{442}\u{44C} Enter, \u{449}\u{43E}\u{431} \u{43F}\u{435}\u{440}\u{435}\u{442}\u{44F}\u{433}\u{43D}\u{443}\u{442}\u{438}.`,
    "dropCanceled": `\u{41F}\u{435}\u{440}\u{435}\u{442}\u{44F}\u{433}\u{443}\u{432}\u{430}\u{43D}\u{43D}\u{44F} \u{441}\u{43A}\u{430}\u{441}\u{43E}\u{432}\u{430}\u{43D}\u{43E}.`,
    "dropComplete": `\u{41F}\u{435}\u{440}\u{435}\u{442}\u{44F}\u{433}\u{443}\u{432}\u{430}\u{43D}\u{43D}\u{44F} \u{437}\u{430}\u{432}\u{435}\u{440}\u{448}\u{435}\u{43D}\u{43E}.`,
    "dropDescriptionKeyboard": `\u{41D}\u{430}\u{442}\u{438}\u{441}\u{43D}\u{456}\u{442}\u{44C} Enter, \u{449}\u{43E}\u{431} \u{43F}\u{435}\u{440}\u{435}\u{442}\u{44F}\u{433}\u{43D}\u{443}\u{442}\u{438}. \u{41D}\u{430}\u{442}\u{438}\u{441}\u{43D}\u{456}\u{442}\u{44C} Escape, \u{449}\u{43E}\u{431} \u{441}\u{43A}\u{430}\u{441}\u{443}\u{432}\u{430}\u{442}\u{438} \u{43F}\u{435}\u{440}\u{435}\u{442}\u{44F}\u{433}\u{443}\u{432}\u{430}\u{43D}\u{43D}\u{44F}.`,
    "dropDescriptionTouch": `\u{41D}\u{430}\u{442}\u{438}\u{441}\u{43D}\u{456}\u{442}\u{44C} \u{434}\u{432}\u{456}\u{447}\u{456}, \u{449}\u{43E}\u{431} \u{43F}\u{435}\u{440}\u{435}\u{442}\u{44F}\u{433}\u{43D}\u{443}\u{442}\u{438}.`,
    "dropDescriptionVirtual": `\u{41D}\u{430}\u{442}\u{438}\u{441}\u{43D}\u{456}\u{442}\u{44C}, \u{449}\u{43E}\u{431} \u{43F}\u{435}\u{440}\u{435}\u{442}\u{44F}\u{433}\u{43D}\u{443}\u{442}\u{438}.`,
    "dropIndicator": `\u{456}\u{43D}\u{434}\u{438}\u{43A}\u{430}\u{442}\u{43E}\u{440} \u{43F}\u{435}\u{440}\u{435}\u{442}\u{44F}\u{433}\u{443}\u{432}\u{430}\u{43D}\u{43D}\u{44F}`,
    "dropOnItem": (args)=>`\u{41F}\u{435}\u{440}\u{435}\u{442}\u{44F}\u{433}\u{43D}\u{443}\u{442}\u{438} \u{43D}\u{430} ${args.itemText}`,
    "dropOnRoot": `\u{41F}\u{435}\u{440}\u{435}\u{442}\u{44F}\u{433}\u{43D}\u{443}\u{442}\u{438} \u{43D}\u{430}`,
    "endDragKeyboard": `\u{422}\u{440}\u{438}\u{432}\u{430}\u{454} \u{43F}\u{435}\u{440}\u{435}\u{442}\u{44F}\u{433}\u{443}\u{432}\u{430}\u{43D}\u{43D}\u{44F}. \u{41D}\u{430}\u{442}\u{438}\u{441}\u{43D}\u{456}\u{442}\u{44C} Enter, \u{449}\u{43E}\u{431} \u{441}\u{43A}\u{430}\u{441}\u{443}\u{432}\u{430}\u{442}\u{438} \u{43F}\u{435}\u{440}\u{435}\u{442}\u{44F}\u{433}\u{443}\u{432}\u{430}\u{43D}\u{43D}\u{44F}.`,
    "endDragTouch": `\u{422}\u{440}\u{438}\u{432}\u{430}\u{454} \u{43F}\u{435}\u{440}\u{435}\u{442}\u{44F}\u{433}\u{443}\u{432}\u{430}\u{43D}\u{43D}\u{44F}. \u{41D}\u{430}\u{442}\u{438}\u{441}\u{43D}\u{456}\u{442}\u{44C} \u{434}\u{432}\u{456}\u{447}\u{456}, \u{449}\u{43E}\u{431} \u{441}\u{43A}\u{430}\u{441}\u{443}\u{432}\u{430}\u{442}\u{438} \u{43F}\u{435}\u{440}\u{435}\u{442}\u{44F}\u{433}\u{443}\u{432}\u{430}\u{43D}\u{43D}\u{44F}.`,
    "endDragVirtual": `\u{422}\u{440}\u{438}\u{432}\u{430}\u{454} \u{43F}\u{435}\u{440}\u{435}\u{442}\u{44F}\u{433}\u{443}\u{432}\u{430}\u{43D}\u{43D}\u{44F}. \u{41D}\u{430}\u{442}\u{438}\u{441}\u{43D}\u{456}\u{442}\u{44C}, \u{449}\u{43E}\u{431} \u{441}\u{43A}\u{430}\u{441}\u{443}\u{432}\u{430}\u{442}\u{438} \u{43F}\u{435}\u{440}\u{435}\u{442}\u{44F}\u{433}\u{443}\u{432}\u{430}\u{43D}\u{43D}\u{44F}.`,
    "insertAfter": (args)=>`\u{412}\u{441}\u{442}\u{430}\u{432}\u{438}\u{442}\u{438} \u{43F}\u{456}\u{441}\u{43B}\u{44F} ${args.itemText}`,
    "insertBefore": (args)=>`\u{412}\u{441}\u{442}\u{430}\u{432}\u{438}\u{442}\u{438} \u{43F}\u{435}\u{440}\u{435}\u{434} ${args.itemText}`,
    "insertBetween": (args)=>`\u{412}\u{441}\u{442}\u{430}\u{432}\u{438}\u{442}\u{438} \u{43C}\u{456}\u{436} ${args.beforeItemText} \u{456} ${args.afterItemText}`
};

},{}],"jWcTm":[function(require,module,exports) {
module.exports = {
    "dragDescriptionKeyboard": `\u{6309} Enter \u{5F00}\u{59CB}\u{62D6}\u{52A8}\u{3002}`,
    "dragDescriptionKeyboardAlt": `\u{6309} Alt + Enter \u{5F00}\u{59CB}\u{62D6}\u{52A8}\u{3002}`,
    "dragDescriptionLongPress": `\u{957F}\u{6309}\u{4EE5}\u{5F00}\u{59CB}\u{62D6}\u{52A8}\u{3002}`,
    "dragDescriptionTouch": `\u{53CC}\u{51FB}\u{5F00}\u{59CB}\u{62D6}\u{52A8}\u{3002}`,
    "dragDescriptionVirtual": `\u{5355}\u{51FB}\u{5F00}\u{59CB}\u{62D6}\u{52A8}\u{3002}`,
    "dragItem": (args)=>`\u{62D6}\u{52A8} ${args.itemText}`,
    "dragSelectedItems": (args, formatter)=>`\u{62D6}\u{52A8} ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} \u{9009}\u{4E2D}\u{9879}\u{76EE}`,
            other: ()=>`${formatter.number(args.count)} \u{9009}\u{4E2D}\u{9879}\u{76EE}`
        })}`,
    "dragSelectedKeyboard": (args, formatter)=>`\u{6309} Enter \u{4EE5}\u{62D6}\u{52A8} ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} \u{4E2A}\u{9009}\u{5B9A}\u{9879}`,
            other: ()=>`${formatter.number(args.count)} \u{4E2A}\u{9009}\u{5B9A}\u{9879}`
        })}\u{3002}`,
    "dragSelectedKeyboardAlt": (args, formatter)=>`\u{6309} Alt + Enter \u{4EE5}\u{62D6}\u{52A8} ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} \u{4E2A}\u{9009}\u{5B9A}\u{9879}`,
            other: ()=>`${formatter.number(args.count)} \u{4E2A}\u{9009}\u{5B9A}\u{9879}`
        })}\u{3002}`,
    "dragSelectedLongPress": (args, formatter)=>`\u{957F}\u{6309}\u{4EE5}\u{62D6}\u{52A8} ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} \u{4E2A}\u{9009}\u{5B9A}\u{9879}`,
            other: ()=>`${formatter.number(args.count)} \u{4E2A}\u{9009}\u{5B9A}\u{9879}`
        })}\u{3002}`,
    "dragStartedKeyboard": `\u{5DF2}\u{5F00}\u{59CB}\u{62D6}\u{52A8}\u{3002}\u{6309} Tab \u{5BFC}\u{822A}\u{5230}\u{653E}\u{7F6E}\u{76EE}\u{6807}\u{FF0C}\u{7136}\u{540E}\u{6309} Enter \u{653E}\u{7F6E}\u{6216}\u{6309} Escape \u{53D6}\u{6D88}\u{3002}`,
    "dragStartedTouch": `\u{5DF2}\u{5F00}\u{59CB}\u{62D6}\u{52A8}\u{3002}\u{5BFC}\u{822A}\u{5230}\u{653E}\u{7F6E}\u{76EE}\u{6807}\u{FF0C}\u{7136}\u{540E}\u{53CC}\u{51FB}\u{653E}\u{7F6E}\u{3002}`,
    "dragStartedVirtual": `\u{5DF2}\u{5F00}\u{59CB}\u{62D6}\u{52A8}\u{3002}\u{5BFC}\u{822A}\u{5230}\u{653E}\u{7F6E}\u{76EE}\u{6807}\u{FF0C}\u{7136}\u{540E}\u{5355}\u{51FB}\u{6216}\u{6309} Enter \u{653E}\u{7F6E}\u{3002}`,
    "dropCanceled": `\u{653E}\u{7F6E}\u{5DF2}\u{53D6}\u{6D88}\u{3002}`,
    "dropComplete": `\u{653E}\u{7F6E}\u{5DF2}\u{5B8C}\u{6210}\u{3002}`,
    "dropDescriptionKeyboard": `\u{6309} Enter \u{653E}\u{7F6E}\u{3002}\u{6309} Escape \u{53D6}\u{6D88}\u{62D6}\u{52A8}\u{3002}`,
    "dropDescriptionTouch": `\u{53CC}\u{51FB}\u{653E}\u{7F6E}\u{3002}`,
    "dropDescriptionVirtual": `\u{5355}\u{51FB}\u{653E}\u{7F6E}\u{3002}`,
    "dropIndicator": `\u{653E}\u{7F6E}\u{6807}\u{8BB0}`,
    "dropOnItem": (args)=>`\u{653E}\u{7F6E}\u{4E8E} ${args.itemText}`,
    "dropOnRoot": `\u{653E}\u{7F6E}\u{4E8E}`,
    "endDragKeyboard": `\u{6B63}\u{5728}\u{62D6}\u{52A8}\u{3002}\u{6309} Enter \u{53D6}\u{6D88}\u{62D6}\u{52A8}\u{3002}`,
    "endDragTouch": `\u{6B63}\u{5728}\u{62D6}\u{52A8}\u{3002}\u{53CC}\u{51FB}\u{53D6}\u{6D88}\u{62D6}\u{52A8}\u{3002}`,
    "endDragVirtual": `\u{6B63}\u{5728}\u{62D6}\u{52A8}\u{3002}\u{5355}\u{51FB}\u{53D6}\u{6D88}\u{62D6}\u{52A8}\u{3002}`,
    "insertAfter": (args)=>`\u{63D2}\u{5165}\u{5230} ${args.itemText} \u{4E4B}\u{540E}`,
    "insertBefore": (args)=>`\u{63D2}\u{5165}\u{5230} ${args.itemText} \u{4E4B}\u{524D}`,
    "insertBetween": (args)=>`\u{63D2}\u{5165}\u{5230} ${args.beforeItemText} \u{548C} ${args.afterItemText} \u{4E4B}\u{95F4}`
};

},{}],"hce3j":[function(require,module,exports) {
module.exports = {
    "dragDescriptionKeyboard": `\u{6309} Enter \u{9375}\u{4EE5}\u{958B}\u{59CB}\u{62D6}\u{66F3}\u{3002}`,
    "dragDescriptionKeyboardAlt": `\u{6309} Alt+Enter \u{9375}\u{4EE5}\u{958B}\u{59CB}\u{62D6}\u{66F3}\u{3002}`,
    "dragDescriptionLongPress": `\u{9577}\u{6309}\u{4EE5}\u{958B}\u{59CB}\u{62D6}\u{66F3}\u{3002}`,
    "dragDescriptionTouch": `\u{8F15}\u{9EDE}\u{5169}\u{4E0B}\u{4EE5}\u{958B}\u{59CB}\u{62D6}\u{66F3}\u{3002}`,
    "dragDescriptionVirtual": `\u{6309}\u{4E00}\u{4E0B}\u{6ED1}\u{9F20}\u{4EE5}\u{958B}\u{59CB}\u{62D6}\u{66F3}\u{3002}`,
    "dragItem": (args)=>`\u{62D6}\u{66F3}\u{300C}${args.itemText}\u{300D}`,
    "dragSelectedItems": (args, formatter)=>`\u{62D6}\u{66F3} ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} \u{500B}\u{9078}\u{5B9A}\u{9805}\u{76EE}`,
            other: ()=>`${formatter.number(args.count)} \u{500B}\u{9078}\u{5B9A}\u{9805}\u{76EE}`
        })}`,
    "dragSelectedKeyboard": (args, formatter)=>`\u{6309} Enter \u{9375}\u{4EE5}\u{62D6}\u{66F3} ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} \u{500B}\u{9078}\u{5B9A}\u{9805}\u{76EE}`,
            other: ()=>`${formatter.number(args.count)} \u{500B}\u{9078}\u{5B9A}\u{9805}\u{76EE}`
        })}\u{3002}`,
    "dragSelectedKeyboardAlt": (args, formatter)=>`\u{6309} Alt+Enter \u{9375}\u{4EE5}\u{62D6}\u{66F3} ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} \u{500B}\u{9078}\u{5B9A}\u{9805}\u{76EE}`,
            other: ()=>`${formatter.number(args.count)} \u{500B}\u{9078}\u{5B9A}\u{9805}\u{76EE}`
        })}\u{3002}`,
    "dragSelectedLongPress": (args, formatter)=>`\u{9577}\u{6309}\u{4EE5}\u{62D6}\u{66F3} ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} \u{500B}\u{9078}\u{5B9A}\u{9805}\u{76EE}`,
            other: ()=>`${formatter.number(args.count)} \u{500B}\u{9078}\u{5B9A}\u{9805}\u{76EE}`
        })}\u{3002}`,
    "dragStartedKeyboard": `\u{5DF2}\u{958B}\u{59CB}\u{62D6}\u{66F3}\u{3002}\u{6309} Tab \u{9375}\u{4EE5}\u{700F}\u{89BD}\u{81F3}\u{653E}\u{7F6E}\u{76EE}\u{6A19}\u{FF0C}\u{7136}\u{5F8C}\u{6309} Enter \u{9375}\u{4EE5}\u{653E}\u{7F6E}\u{FF0C}\u{6216}\u{6309} Escape \u{9375}\u{4EE5}\u{53D6}\u{6D88}\u{3002}`,
    "dragStartedTouch": `\u{5DF2}\u{958B}\u{59CB}\u{62D6}\u{66F3}\u{3002}\u{700F}\u{89BD}\u{81F3}\u{653E}\u{7F6E}\u{76EE}\u{6A19}\u{FF0C}\u{7136}\u{5F8C}\u{8F15}\u{9EDE}\u{5169}\u{4E0B}\u{4EE5}\u{653E}\u{7F6E}\u{3002}`,
    "dragStartedVirtual": `\u{5DF2}\u{958B}\u{59CB}\u{62D6}\u{66F3}\u{3002}\u{700F}\u{89BD}\u{81F3}\u{653E}\u{7F6E}\u{76EE}\u{6A19}\u{FF0C}\u{7136}\u{5F8C}\u{6309}\u{4E00}\u{4E0B}\u{6ED1}\u{9F20}\u{6216}\u{6309} Enter \u{9375}\u{4EE5}\u{653E}\u{7F6E}\u{3002}`,
    "dropCanceled": `\u{653E}\u{7F6E}\u{5DF2}\u{53D6}\u{6D88}\u{3002}`,
    "dropComplete": `\u{653E}\u{7F6E}\u{5DF2}\u{5B8C}\u{6210}\u{3002}`,
    "dropDescriptionKeyboard": `\u{6309} Enter \u{9375}\u{4EE5}\u{653E}\u{7F6E}\u{3002}\u{6309} Escape \u{9375}\u{4EE5}\u{53D6}\u{6D88}\u{62D6}\u{66F3}\u{3002}`,
    "dropDescriptionTouch": `\u{8F15}\u{9EDE}\u{5169}\u{4E0B}\u{4EE5}\u{653E}\u{7F6E}\u{3002}`,
    "dropDescriptionVirtual": `\u{6309}\u{4E00}\u{4E0B}\u{6ED1}\u{9F20}\u{4EE5}\u{653E}\u{7F6E}\u{3002}`,
    "dropIndicator": `\u{653E}\u{7F6E}\u{6307}\u{793A}\u{5668}`,
    "dropOnItem": (args)=>`\u{653E}\u{7F6E}\u{5728}\u{300C}${args.itemText}\u{300D}\u{4E0A}`,
    "dropOnRoot": `\u{653E}\u{7F6E}\u{5728}`,
    "endDragKeyboard": `\u{62D6}\u{66F3}\u{4E2D}\u{3002}\u{6309} Enter \u{9375}\u{4EE5}\u{53D6}\u{6D88}\u{62D6}\u{66F3}\u{3002}`,
    "endDragTouch": `\u{62D6}\u{66F3}\u{4E2D}\u{3002}\u{8F15}\u{9EDE}\u{5169}\u{4E0B}\u{4EE5}\u{53D6}\u{6D88}\u{62D6}\u{66F3}\u{3002}`,
    "endDragVirtual": `\u{62D6}\u{66F3}\u{4E2D}\u{3002}\u{6309}\u{4E00}\u{4E0B}\u{6ED1}\u{9F20}\u{4EE5}\u{53D6}\u{6D88}\u{62D6}\u{66F3}\u{3002}`,
    "insertAfter": (args)=>`\u{63D2}\u{5165}\u{81F3}\u{300C}${args.itemText}\u{300D}\u{4E4B}\u{5F8C}`,
    "insertBefore": (args)=>`\u{63D2}\u{5165}\u{81F3}\u{300C}${args.itemText}\u{300D}\u{4E4B}\u{524D}`,
    "insertBetween": (args)=>`\u{63D2}\u{5165}\u{81F3}\u{300C}${args.beforeItemText}\u{300D}\u{548C}\u{300C}${args.afterItemText}\u{300D}\u{4E4B}\u{9593}`
};

},{}],"atFXS":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Handles drop interactions for an element, with support for traditional mouse and touch
 * based drag and drop, in addition to full parity for keyboard and screen reader users.
 */ parcelHelpers.export(exports, "useDrop", ()=>useDrop);
var _react = require("react");
var _dragManager = require("./DragManager");
var _utils = require("./utils");
var _constants = require("./constants");
var _utils1 = require("@react-aria/utils");
var _useVirtualDrop = require("./useVirtualDrop");
const DROP_ACTIVATE_TIMEOUT = 800;
function useDrop(options) {
    let { hasDropButton } = options;
    let [isDropTarget, setDropTarget] = (0, _react.useState)(false);
    let state = (0, _react.useRef)({
        x: 0,
        y: 0,
        dragOverElements: new Set(),
        dropEffect: "none",
        allowedOperations: (0, _constants.DROP_OPERATION).all,
        dropActivateTimer: null
    }).current;
    let fireDropEnter = (e)=>{
        setDropTarget(true);
        if (typeof options.onDropEnter === "function") {
            let rect = e.currentTarget.getBoundingClientRect();
            options.onDropEnter({
                type: "dropenter",
                x: e.clientX - rect.x,
                y: e.clientY - rect.y
            });
        }
    };
    let fireDropExit = (e)=>{
        setDropTarget(false);
        if (typeof options.onDropExit === "function") {
            let rect = e.currentTarget.getBoundingClientRect();
            options.onDropExit({
                type: "dropexit",
                x: e.clientX - rect.x,
                y: e.clientY - rect.y
            });
        }
    };
    let onDragOver = (e)=>{
        e.preventDefault();
        e.stopPropagation();
        let allowedOperations = getAllowedOperations(e);
        if (e.clientX === state.x && e.clientY === state.y && allowedOperations === state.allowedOperations) {
            e.dataTransfer.dropEffect = state.dropEffect;
            return;
        }
        state.x = e.clientX;
        state.y = e.clientY;
        let prevDropEffect = state.dropEffect;
        // Update drop effect if allowed drop operations changed (e.g. user pressed modifier key).
        if (allowedOperations !== state.allowedOperations) {
            let allowedOps = allowedOperationsToArray(allowedOperations);
            let dropOperation = allowedOps[0];
            if (typeof options.getDropOperation === "function") {
                let types = new (0, _utils.DragTypes)(e.dataTransfer);
                dropOperation = getDropOperation(allowedOperations, options.getDropOperation(types, allowedOps));
            }
            state.dropEffect = (0, _constants.DROP_OPERATION_TO_DROP_EFFECT)[dropOperation] || "none";
        }
        if (typeof options.getDropOperationForPoint === "function") {
            let types = new (0, _utils.DragTypes)(e.dataTransfer);
            let rect = e.currentTarget.getBoundingClientRect();
            let dropOperation = getDropOperation(allowedOperations, options.getDropOperationForPoint(types, allowedOperationsToArray(allowedOperations), state.x - rect.x, state.y - rect.y));
            state.dropEffect = (0, _constants.DROP_OPERATION_TO_DROP_EFFECT)[dropOperation] || "none";
        }
        state.allowedOperations = allowedOperations;
        e.dataTransfer.dropEffect = state.dropEffect;
        // If the drop operation changes, update state and fire events appropriately.
        if (state.dropEffect === "none" && prevDropEffect !== "none") fireDropExit(e);
        else if (state.dropEffect !== "none" && prevDropEffect === "none") fireDropEnter(e);
        if (typeof options.onDropMove === "function" && state.dropEffect !== "none") {
            let rect = e.currentTarget.getBoundingClientRect();
            options.onDropMove({
                type: "dropmove",
                x: state.x - rect.x,
                y: state.y - rect.y
            });
        }
        clearTimeout(state.dropActivateTimer);
        if (typeof options.onDropActivate === "function" && state.dropEffect !== "none") {
            let rect = e.currentTarget.getBoundingClientRect();
            state.dropActivateTimer = setTimeout(()=>{
                options.onDropActivate({
                    type: "dropactivate",
                    x: state.x - rect.x,
                    y: state.y - rect.y
                });
            }, DROP_ACTIVATE_TIMEOUT);
        }
    };
    let onDragEnter = (e)=>{
        e.preventDefault();
        e.stopPropagation();
        state.dragOverElements.add(e.target);
        if (state.dragOverElements.size > 1) return;
        let allowedOperationsBits = getAllowedOperations(e);
        let allowedOperations = allowedOperationsToArray(allowedOperationsBits);
        let dropOperation = allowedOperations[0];
        if (typeof options.getDropOperation === "function") {
            let types = new (0, _utils.DragTypes)(e.dataTransfer);
            dropOperation = getDropOperation(allowedOperationsBits, options.getDropOperation(types, allowedOperations));
        }
        if (typeof options.getDropOperationForPoint === "function") {
            let types = new (0, _utils.DragTypes)(e.dataTransfer);
            let rect = e.currentTarget.getBoundingClientRect();
            dropOperation = getDropOperation(allowedOperationsBits, options.getDropOperationForPoint(types, allowedOperations, e.clientX - rect.x, e.clientY - rect.y));
        }
        state.x = e.clientX;
        state.y = e.clientY;
        state.allowedOperations = allowedOperationsBits;
        state.dropEffect = (0, _constants.DROP_OPERATION_TO_DROP_EFFECT)[dropOperation] || "none";
        e.dataTransfer.dropEffect = state.dropEffect;
        if (dropOperation !== "cancel") fireDropEnter(e);
    };
    let onDragLeave = (e)=>{
        e.preventDefault();
        e.stopPropagation();
        // We would use e.relatedTarget to detect if the drag is still inside the drop target,
        // but it is always null in WebKit. https://bugs.webkit.org/show_bug.cgi?id=66547
        // Instead, we track all of the targets of dragenter events in a set, and remove them
        // in dragleave. When the set becomes empty, we've left the drop target completely.
        // We must also remove any elements that are no longer in the DOM, because dragleave
        // events will never be fired for these. This can happen, for example, with drop
        // indicators between items, which disappear when the drop target changes.
        state.dragOverElements.delete(e.target);
        for (let element of state.dragOverElements)if (!e.currentTarget.contains(element)) state.dragOverElements.delete(element);
        if (state.dragOverElements.size > 0) return;
        if (state.dropEffect !== "none") fireDropExit(e);
        clearTimeout(state.dropActivateTimer);
    };
    let onDrop = (e)=>{
        e.preventDefault();
        e.stopPropagation();
        // Track drop effect in global state for Chrome Android. https://bugs.chromium.org/p/chromium/issues/detail?id=1353951
        // Android onDragEnd always returns "none" as its drop effect.
        (0, _utils.setGlobalDropEffect)(state.dropEffect);
        if (typeof options.onDrop === "function") {
            let dropOperation = (0, _constants.DROP_EFFECT_TO_DROP_OPERATION)[state.dropEffect];
            let items = (0, _utils.readFromDataTransfer)(e.dataTransfer);
            let rect = e.currentTarget.getBoundingClientRect();
            let event = {
                type: "drop",
                x: e.clientX - rect.x,
                y: e.clientY - rect.y,
                items,
                dropOperation
            };
            options.onDrop(event);
        }
        let dndStateSnapshot = {
            ...(0, _utils.globalDndState)
        };
        state.dragOverElements.clear();
        fireDropExit(e);
        clearTimeout(state.dropActivateTimer);
        // If there wasn't a collection being tracked as a dragged collection, then we are in a case where a non RSP drag is dropped on a
        // RSP collection and thus we don't need to preserve the global drop effect
        if (dndStateSnapshot.draggingCollectionRef == null) (0, _utils.setGlobalDropEffect)(undefined);
        else // Otherwise we need to preserve the global dnd state for onDragEnd's isInternal check.
        // At the moment fireDropExit may clear dropCollectionRef (i.e. useDroppableCollection's provided onDropExit, required to clear dropCollectionRef when exiting a valid drop target)
        (0, _utils.setGlobalDnDState)(dndStateSnapshot);
    };
    let onDropEnter = (0, _utils1.useEffectEvent)((e)=>{
        if (typeof options.onDropEnter === "function") options.onDropEnter(e);
    });
    let onDropExit = (0, _utils1.useEffectEvent)((e)=>{
        if (typeof options.onDropExit === "function") options.onDropExit(e);
    });
    let onDropActivate = (0, _utils1.useEffectEvent)((e)=>{
        if (typeof options.onDropActivate === "function") options.onDropActivate(e);
    });
    let onKeyboardDrop = (0, _utils1.useEffectEvent)((e)=>{
        if (typeof options.onDrop === "function") options.onDrop(e);
    });
    let getDropOperationKeyboard = (0, _utils1.useEffectEvent)((types, allowedOperations)=>{
        if (options.getDropOperation) return options.getDropOperation(types, allowedOperations);
        return allowedOperations[0];
    });
    let { ref } = options;
    (0, _utils1.useLayoutEffect)(()=>_dragManager.registerDropTarget({
            element: ref.current,
            getDropOperation: getDropOperationKeyboard,
            onDropEnter (e) {
                setDropTarget(true);
                onDropEnter(e);
            },
            onDropExit (e) {
                setDropTarget(false);
                onDropExit(e);
            },
            onDrop: onKeyboardDrop,
            onDropActivate
        }), [
        ref,
        getDropOperationKeyboard,
        onDropEnter,
        onDropExit,
        onKeyboardDrop,
        onDropActivate
    ]);
    let { dropProps } = (0, _useVirtualDrop.useVirtualDrop)();
    return {
        dropProps: {
            ...!hasDropButton && dropProps,
            onDragEnter,
            onDragOver,
            onDragLeave,
            onDrop
        },
        dropButtonProps: {
            ...hasDropButton && dropProps
        },
        isDropTarget
    };
}
function getAllowedOperations(e) {
    let allowedOperations = (0, _constants.DROP_OPERATION_ALLOWED)[e.dataTransfer.effectAllowed];
    // WebKit always sets effectAllowed to "copyMove" on macOS, and "all" on iOS, regardless of what was
    // set during the dragstart event: https://bugs.webkit.org/show_bug.cgi?id=178058
    //
    // Android Chrome also sets effectAllowed to "copyMove" in all cases: https://bugs.chromium.org/p/chromium/issues/detail?id=1359182
    //
    // If the drag started within the page, we can use a global variable to get the real allowed operations.
    // This needs to be intersected with the actual effectAllowed, which may have been filtered based on modifier keys.
    // Unfortunately, this means that link operations do not work at all in Safari.
    if (0, _utils.globalAllowedDropOperations) allowedOperations &= (0, _utils.globalAllowedDropOperations);
    // Chrome and Safari on macOS will automatically filter effectAllowed when pressing modifier keys,
    // allowing the user to switch between move, link, and copy operations. Firefox on macOS and all
    // Windows browsers do not do this, so do it ourselves instead. The exact keys are platform dependent.
    // https://ux.stackexchange.com/questions/83748/what-are-the-most-common-modifier-keys-for-dragging-objects-with-a-mouse
    //
    // Note that none of these modifiers are ever set in WebKit due to a bug: https://bugs.webkit.org/show_bug.cgi?id=77465
    // However, Safari does update effectAllowed correctly, so we can just rely on that.
    let allowedModifiers = (0, _constants.DROP_OPERATION).none;
    if ((0, _utils1.isMac)()) {
        if (e.altKey) allowedModifiers |= (0, _constants.DROP_OPERATION).copy;
        // Chrome and Safari both use the Control key for link, even though Finder uses Command + Option.
        // iPadOS doesn't support link operations and will not fire the drop event at all if dropEffect is set to link.
        // https://bugs.webkit.org/show_bug.cgi?id=244701
        if (e.ctrlKey && !(0, _utils1.isIPad)()) allowedModifiers |= (0, _constants.DROP_OPERATION).link;
        if (e.metaKey) allowedModifiers |= (0, _constants.DROP_OPERATION).move;
    } else {
        if (e.altKey) allowedModifiers |= (0, _constants.DROP_OPERATION).link;
        if (e.shiftKey) allowedModifiers |= (0, _constants.DROP_OPERATION).move;
        if (e.ctrlKey) allowedModifiers |= (0, _constants.DROP_OPERATION).copy;
    }
    if (allowedModifiers) return allowedOperations & allowedModifiers;
    return allowedOperations;
}
function allowedOperationsToArray(allowedOperationsBits) {
    let allowedOperations = [];
    if (allowedOperationsBits & (0, _constants.DROP_OPERATION).move) allowedOperations.push("move");
    if (allowedOperationsBits & (0, _constants.DROP_OPERATION).copy) allowedOperations.push("copy");
    if (allowedOperationsBits & (0, _constants.DROP_OPERATION).link) allowedOperations.push("link");
    return allowedOperations;
}
function getDropOperation(allowedOperations, operation) {
    let op = (0, _constants.DROP_OPERATION)[operation];
    return allowedOperations & op ? operation : "cancel";
}

},{"react":"9yzVZ","./DragManager":"j7vmC","./utils":"8X8qs","./constants":"1EQ3W","@react-aria/utils":"9cLk5","./useVirtualDrop":"8sibk","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"8sibk":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useVirtualDrop", ()=>useVirtualDrop);
var _dragManager = require("./DragManager");
// @ts-ignore
var _json = require("../intl/*.json");
var _jsonDefault = parcelHelpers.interopDefault(_json);
var _utils = require("@react-aria/utils");
var _utils1 = require("./utils");
var _i18N = require("@react-aria/i18n");
const MESSAGES = {
    keyboard: "dropDescriptionKeyboard",
    touch: "dropDescriptionTouch",
    virtual: "dropDescriptionVirtual"
};
function useVirtualDrop() {
    let stringFormatter = (0, _i18N.useLocalizedStringFormatter)((0, _jsonDefault.default), "@react-aria/dnd");
    let modality = (0, _utils1.useDragModality)();
    let dragSession = _dragManager.useDragSession();
    let descriptionProps = (0, _utils.useDescription)(dragSession ? stringFormatter.format(MESSAGES[modality]) : "");
    return {
        dropProps: {
            ...descriptionProps,
            // Mobile Safari does not properly bubble click events on elements except links or inputs
            // unless there is an onclick handler bound directly to the element itself. By adding this
            // handler, React will take care of adding that for us, and we are able to handle document
            // level click events in the DragManager.
            // See https://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
            onClick: ()=>{}
        }
    };
}

},{"./DragManager":"j7vmC","../intl/*.json":"3FI7M","@react-aria/utils":"9cLk5","./utils":"8X8qs","@react-aria/i18n":"411rg","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"Eomdz":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Handles drop interactions for a collection component, with support for traditional mouse and touch
 * based drag and drop, in addition to full parity for keyboard and screen reader users.
 */ parcelHelpers.export(exports, "useDroppableCollection", ()=>useDroppableCollection);
var _utils = require("./utils");
var _dragManager = require("./DragManager");
var _react = require("react");
var _utils1 = require("@react-aria/utils");
var _interactions = require("@react-aria/interactions");
var _useAutoScroll = require("./useAutoScroll");
var _useDrop = require("./useDrop");
var _i18N = require("@react-aria/i18n");
const DROP_POSITIONS = [
    "before",
    "on",
    "after"
];
const DROP_POSITIONS_RTL = [
    "after",
    "on",
    "before"
];
function useDroppableCollection(props, state, ref) {
    let localState = (0, _react.useRef)({
        props,
        state,
        nextTarget: null,
        dropOperation: null
    }).current;
    localState.props = props;
    localState.state = state;
    let defaultOnDrop = (0, _react.useCallback)(async (e)=>{
        let { onInsert, onRootDrop, onItemDrop, onReorder, acceptedDragTypes = "all", shouldAcceptItemDrop } = localState.props;
        let { draggingKeys } = (0, _utils.globalDndState);
        let isInternal = (0, _utils.isInternalDropOperation)(ref);
        let { target, dropOperation, items } = e;
        let filteredItems = items;
        if (acceptedDragTypes !== "all" || shouldAcceptItemDrop) filteredItems = items.filter((item)=>{
            let itemTypes;
            if (item.kind === "directory") itemTypes = new Set([
                (0, _utils.DIRECTORY_DRAG_TYPE)
            ]);
            else itemTypes = item.kind === "file" ? new Set([
                item.type
            ]) : item.types;
            if (acceptedDragTypes === "all" || acceptedDragTypes.some((type)=>itemTypes.has(type))) {
                // If we are performing a on item drop, check if the item in question accepts the dropped item since the item may have heavier restrictions
                // than the droppable collection itself
                if (target.type === "item" && target.dropPosition === "on" && shouldAcceptItemDrop) return shouldAcceptItemDrop(target, itemTypes);
                return true;
            }
            return false;
        });
        if (filteredItems.length > 0) {
            if (target.type === "root" && onRootDrop) await onRootDrop({
                items: filteredItems,
                dropOperation
            });
            if (target.type === "item") {
                if (target.dropPosition === "on" && onItemDrop) await onItemDrop({
                    items: filteredItems,
                    dropOperation,
                    isInternal,
                    target
                });
                if (target.dropPosition !== "on") {
                    if (!isInternal && onInsert) await onInsert({
                        items: filteredItems,
                        dropOperation,
                        target
                    });
                    if (isInternal && onReorder) await onReorder({
                        keys: draggingKeys,
                        dropOperation,
                        target
                    });
                }
            }
        }
    }, [
        localState,
        ref
    ]);
    let autoScroll = (0, _useAutoScroll.useAutoScroll)(ref);
    let { dropProps } = (0, _useDrop.useDrop)({
        ref,
        onDropEnter () {
            state.setTarget(localState.nextTarget);
        },
        onDropMove (e) {
            state.setTarget(localState.nextTarget);
            autoScroll.move(e.x, e.y);
        },
        getDropOperationForPoint (types, allowedOperations, x, y) {
            let { draggingKeys, dropCollectionRef } = (0, _utils.globalDndState);
            let isInternal = (0, _utils.isInternalDropOperation)(ref);
            let isValidDropTarget = (target)=>state.getDropOperation({
                    target,
                    types,
                    allowedOperations,
                    isInternal,
                    draggingKeys
                }) !== "cancel";
            let target = props.dropTargetDelegate.getDropTargetFromPoint(x, y, isValidDropTarget);
            if (!target) {
                localState.dropOperation = "cancel";
                localState.nextTarget = null;
                return "cancel";
            }
            localState.dropOperation = state.getDropOperation({
                target,
                types,
                allowedOperations,
                isInternal,
                draggingKeys
            });
            // If the target doesn't accept the drop, see if the root accepts it instead.
            if (localState.dropOperation === "cancel") {
                let rootTarget = {
                    type: "root"
                };
                let dropOperation = state.getDropOperation({
                    target: rootTarget,
                    types,
                    allowedOperations,
                    isInternal,
                    draggingKeys
                });
                if (dropOperation !== "cancel") {
                    target = rootTarget;
                    localState.dropOperation = dropOperation;
                }
            }
            // Only set dropCollectionRef if there is a valid drop target since we cleanup dropCollectionRef in onDropExit
            // which only runs when leaving a valid drop target or if the dropEffect become none (mouse dnd only).
            if (target && localState.dropOperation !== "cancel" && (ref === null || ref === void 0 ? void 0 : ref.current) !== (dropCollectionRef === null || dropCollectionRef === void 0 ? void 0 : dropCollectionRef.current)) (0, _utils.setDropCollectionRef)(ref);
            localState.nextTarget = localState.dropOperation === "cancel" ? null : target;
            return localState.dropOperation;
        },
        onDropExit () {
            (0, _utils.setDropCollectionRef)(undefined);
            state.setTarget(null);
            autoScroll.stop();
        },
        onDropActivate (e) {
            var _state_target, _state_target1;
            if (((_state_target = state.target) === null || _state_target === void 0 ? void 0 : _state_target.type) === "item" && ((_state_target1 = state.target) === null || _state_target1 === void 0 ? void 0 : _state_target1.dropPosition) === "on" && typeof props.onDropActivate === "function") props.onDropActivate({
                type: "dropactivate",
                x: e.x,
                y: e.y,
                target: state.target
            });
        },
        onDrop (e) {
            (0, _utils.setDropCollectionRef)(ref);
            if (state.target) onDrop(e, state.target);
            // If there wasn't a collection being tracked as a dragged collection, then we are in a case where a non RSP drag is dropped on a
            // RSP collection and thus we don't need to preserve the global DnD state for onDragEnd
            let { draggingCollectionRef } = (0, _utils.globalDndState);
            if (draggingCollectionRef == null) (0, _utils.clearGlobalDnDState)();
        }
    });
    let droppingState = (0, _react.useRef)(null);
    let onDrop = (0, _react.useCallback)((e, target)=>{
        var _state_collection_getItem;
        let { state } = localState;
        // Focus the collection.
        state.selectionManager.setFocused(true);
        // Save some state of the collection/selection before the drop occurs so we can compare later.
        let focusedKey = state.selectionManager.focusedKey;
        // If parent key was dragged, we want to use it instead (i.e. focus row instead of cell after dropping)
        if ((0, _utils.globalDndState).draggingKeys.has((_state_collection_getItem = state.collection.getItem(focusedKey)) === null || _state_collection_getItem === void 0 ? void 0 : _state_collection_getItem.parentKey)) {
            focusedKey = state.collection.getItem(focusedKey).parentKey;
            state.selectionManager.setFocusedKey(focusedKey);
        }
        droppingState.current = {
            timeout: null,
            focusedKey,
            collection: state.collection,
            selectedKeys: state.selectionManager.selectedKeys
        };
        let onDropFn = localState.props.onDrop || defaultOnDrop;
        onDropFn({
            type: "drop",
            x: e.x,
            y: e.y,
            target,
            items: e.items,
            dropOperation: e.dropOperation
        });
        // Wait for a short time period after the onDrop is called to allow the data to be read asynchronously
        // and for React to re-render. If an insert occurs during this time, it will be selected/focused below.
        // If items are not "immediately" inserted by the onDrop handler, the application will need to handle
        // selecting and focusing those items themselves.
        droppingState.current.timeout = setTimeout(()=>{
            // If focus didn't move already (e.g. due to an insert), and the user dropped on an item,
            // focus that item and show the focus ring to give the user feedback that the drop occurred.
            // Also show the focus ring if the focused key is not selected, e.g. in case of a reorder.
            let { state } = localState;
            if (target.type === "item" && target.dropPosition === "on" && state.collection.getItem(target.key) != null) {
                state.selectionManager.setFocusedKey(target.key);
                state.selectionManager.setFocused(true);
                (0, _interactions.setInteractionModality)("keyboard");
            } else if (!state.selectionManager.isSelected(focusedKey)) (0, _interactions.setInteractionModality)("keyboard");
            droppingState.current = null;
        }, 50);
    }, [
        localState,
        defaultOnDrop
    ]);
    // eslint-disable-next-line arrow-body-style
    (0, _react.useEffect)(()=>{
        return ()=>{
            if (droppingState.current) clearTimeout(droppingState.current.timeout);
        };
    }, []);
    (0, _utils1.useLayoutEffect)(()=>{
        // If an insert occurs during a drop, we want to immediately select these items to give
        // feedback to the user that a drop occurred. Only do this if the selection didn't change
        // since the drop started so we don't override if the user or application did something.
        if (droppingState.current && state.selectionManager.isFocused && state.collection.size > droppingState.current.collection.size && state.selectionManager.isSelectionEqual(droppingState.current.selectedKeys)) {
            let newKeys = new Set();
            for (let key of state.collection.getKeys())if (!droppingState.current.collection.getItem(key)) newKeys.add(key);
            state.selectionManager.setSelectedKeys(newKeys);
            // If the focused item didn't change since the drop occurred, also focus the first
            // inserted item. If selection is disabled, then also show the focus ring so there
            // is some indication that items were added.
            if (state.selectionManager.focusedKey === droppingState.current.focusedKey) {
                let first = newKeys.keys().next().value;
                let item = state.collection.getItem(first);
                // If this is a cell, focus the parent row.
                if ((item === null || item === void 0 ? void 0 : item.type) === "cell") first = item.parentKey;
                state.selectionManager.setFocusedKey(first);
                if (state.selectionManager.selectionMode === "none") (0, _interactions.setInteractionModality)("keyboard");
            }
            droppingState.current = null;
        }
    });
    let { direction } = (0, _i18N.useLocale)();
    (0, _react.useEffect)(()=>{
        let getNextTarget = (target, wrap = true, horizontal = false)=>{
            if (!target) return {
                type: "root"
            };
            let { keyboardDelegate } = localState.props;
            let nextKey;
            if ((target === null || target === void 0 ? void 0 : target.type) === "item") nextKey = horizontal ? keyboardDelegate.getKeyRightOf(target.key) : keyboardDelegate.getKeyBelow(target.key);
            else nextKey = horizontal && direction === "rtl" ? keyboardDelegate.getLastKey() : keyboardDelegate.getFirstKey();
            let dropPositions = horizontal && direction === "rtl" ? DROP_POSITIONS_RTL : DROP_POSITIONS;
            let dropPosition = dropPositions[0];
            if (target.type === "item") {
                // If the the keyboard delegate returned the next key in the collection,
                // first try the other positions in the current key. Otherwise (e.g. in a grid layout),
                // jump to the same drop position in the new key.
                let nextCollectionKey = horizontal && direction === "rtl" ? localState.state.collection.getKeyBefore(target.key) : localState.state.collection.getKeyAfter(target.key);
                if (nextKey == null || nextKey === nextCollectionKey) {
                    let positionIndex = dropPositions.indexOf(target.dropPosition);
                    let nextDropPosition = dropPositions[positionIndex + 1];
                    if (positionIndex < dropPositions.length - 1 && !(nextDropPosition === dropPositions[2] && nextKey != null)) return {
                        type: "item",
                        key: target.key,
                        dropPosition: nextDropPosition
                    };
                    // If the last drop position was 'after', then 'before' on the next key is equivalent.
                    // Switch to 'on' instead.
                    if (target.dropPosition === dropPositions[2]) dropPosition = "on";
                } else dropPosition = target.dropPosition;
            }
            if (nextKey == null) {
                if (wrap) return {
                    type: "root"
                };
                return null;
            }
            return {
                type: "item",
                key: nextKey,
                dropPosition
            };
        };
        let getPreviousTarget = (target, wrap = true, horizontal = false)=>{
            let { keyboardDelegate } = localState.props;
            let nextKey;
            if ((target === null || target === void 0 ? void 0 : target.type) === "item") nextKey = horizontal ? keyboardDelegate.getKeyLeftOf(target.key) : keyboardDelegate.getKeyAbove(target.key);
            else nextKey = horizontal && direction === "rtl" ? keyboardDelegate.getFirstKey() : keyboardDelegate.getLastKey();
            let dropPositions = horizontal && direction === "rtl" ? DROP_POSITIONS_RTL : DROP_POSITIONS;
            let dropPosition = !target || target.type === "root" ? dropPositions[2] : "on";
            if ((target === null || target === void 0 ? void 0 : target.type) === "item") {
                // If the the keyboard delegate returned the previous key in the collection,
                // first try the other positions in the current key. Otherwise (e.g. in a grid layout),
                // jump to the same drop position in the new key.
                let prevCollectionKey = horizontal && direction === "rtl" ? localState.state.collection.getKeyAfter(target.key) : localState.state.collection.getKeyBefore(target.key);
                if (nextKey == null || nextKey === prevCollectionKey) {
                    let positionIndex = dropPositions.indexOf(target.dropPosition);
                    let nextDropPosition = dropPositions[positionIndex - 1];
                    if (positionIndex > 0 && nextDropPosition !== dropPositions[2]) return {
                        type: "item",
                        key: target.key,
                        dropPosition: nextDropPosition
                    };
                    // If the last drop position was 'before', then 'after' on the previous key is equivalent.
                    // Switch to 'on' instead.
                    if (target.dropPosition === dropPositions[0]) dropPosition = "on";
                } else dropPosition = target.dropPosition;
            }
            if (nextKey == null) {
                if (wrap) return {
                    type: "root"
                };
                return null;
            }
            return {
                type: "item",
                key: nextKey,
                dropPosition
            };
        };
        let nextValidTarget = (target, types, allowedDropOperations, getNextTarget, wrap = true)=>{
            let seenRoot = 0;
            let operation;
            let { draggingKeys } = (0, _utils.globalDndState);
            let isInternal = (0, _utils.isInternalDropOperation)(ref);
            do {
                let nextTarget = getNextTarget(target, wrap);
                if (!nextTarget) return null;
                target = nextTarget;
                operation = localState.state.getDropOperation({
                    target: nextTarget,
                    types,
                    allowedOperations: allowedDropOperations,
                    isInternal,
                    draggingKeys
                });
                if (target.type === "root") seenRoot++;
            }while (operation === "cancel" && !localState.state.isDropTarget(target) && seenRoot < 2);
            if (operation === "cancel") return null;
            return target;
        };
        return _dragManager.registerDropTarget({
            element: ref.current,
            getDropOperation (types, allowedOperations) {
                if (localState.state.target) {
                    let { draggingKeys } = (0, _utils.globalDndState);
                    let isInternal = (0, _utils.isInternalDropOperation)(ref);
                    return localState.state.getDropOperation({
                        target: localState.state.target,
                        types,
                        allowedOperations,
                        isInternal,
                        draggingKeys
                    });
                }
                // Check if any of the targets accept the drop.
                // TODO: should we have a faster way of doing this or e.g. for pagination?
                let target = nextValidTarget(null, types, allowedOperations, getNextTarget);
                return target ? "move" : "cancel";
            },
            onDropEnter (e, drag) {
                let types = (0, _utils.getTypes)(drag.items);
                let selectionManager = localState.state.selectionManager;
                let target;
                // Update the drop collection ref tracker for useDroppableItem's getDropOperation isInternal check
                (0, _utils.setDropCollectionRef)(ref);
                // When entering the droppable collection for the first time, the default drop target
                // is after the focused key.
                let key = selectionManager.focusedKey;
                let dropPosition = "after";
                // If the focused key is a cell, get the parent item instead.
                // For now, we assume that individual cells cannot be dropped on.
                let item = localState.state.collection.getItem(key);
                if ((item === null || item === void 0 ? void 0 : item.type) === "cell") key = item.parentKey;
                // If the focused item is also selected, the default drop target is after the last selected item.
                // But if the focused key is the first selected item, then default to before the first selected item.
                // This is to make reordering lists slightly easier. If you select top down, we assume you want to
                // move the items down. If you select bottom up, we assume you want to move the items up.
                if (selectionManager.isSelected(key)) {
                    if (selectionManager.selectedKeys.size > 1 && selectionManager.firstSelectedKey === key) dropPosition = "before";
                    else key = selectionManager.lastSelectedKey;
                }
                if (key != null) {
                    target = {
                        type: "item",
                        key,
                        dropPosition
                    };
                    let { draggingKeys } = (0, _utils.globalDndState);
                    let isInternal = (0, _utils.isInternalDropOperation)(ref);
                    var _nextValidTarget;
                    // If the default target is not valid, find the next one that is.
                    if (localState.state.getDropOperation({
                        target,
                        types,
                        allowedOperations: drag.allowedDropOperations,
                        isInternal,
                        draggingKeys
                    }) === "cancel") target = (_nextValidTarget = nextValidTarget(target, types, drag.allowedDropOperations, getNextTarget, false)) !== null && _nextValidTarget !== void 0 ? _nextValidTarget : nextValidTarget(target, types, drag.allowedDropOperations, getPreviousTarget, false);
                }
                // If no focused key, then start from the root.
                if (!target) target = nextValidTarget(null, types, drag.allowedDropOperations, getNextTarget);
                localState.state.setTarget(target);
            },
            onDropExit () {
                (0, _utils.setDropCollectionRef)(undefined);
                localState.state.setTarget(null);
            },
            onDropTargetEnter (target) {
                localState.state.setTarget(target);
            },
            onDropActivate (e) {
                var _localState_state_target, _localState_state_target1;
                if (((_localState_state_target = localState.state.target) === null || _localState_state_target === void 0 ? void 0 : _localState_state_target.type) === "item" && ((_localState_state_target1 = localState.state.target) === null || _localState_state_target1 === void 0 ? void 0 : _localState_state_target1.dropPosition) === "on" && typeof localState.props.onDropActivate === "function") localState.props.onDropActivate({
                    type: "dropactivate",
                    x: e.x,
                    y: e.y,
                    target: localState.state.target
                });
            },
            onDrop (e, target) {
                (0, _utils.setDropCollectionRef)(ref);
                if (localState.state.target) onDrop(e, target || localState.state.target);
            },
            onKeyDown (e, drag) {
                let { keyboardDelegate } = localState.props;
                let types = (0, _utils.getTypes)(drag.items);
                switch(e.key){
                    case "ArrowDown":
                        if (keyboardDelegate.getKeyBelow) {
                            let target = nextValidTarget(localState.state.target, types, drag.allowedDropOperations, getNextTarget);
                            localState.state.setTarget(target);
                        }
                        break;
                    case "ArrowUp":
                        if (keyboardDelegate.getKeyAbove) {
                            let target = nextValidTarget(localState.state.target, types, drag.allowedDropOperations, getPreviousTarget);
                            localState.state.setTarget(target);
                        }
                        break;
                    case "ArrowLeft":
                        if (keyboardDelegate.getKeyLeftOf) {
                            let target = nextValidTarget(localState.state.target, types, drag.allowedDropOperations, (target, wrap)=>getPreviousTarget(target, wrap, true));
                            localState.state.setTarget(target);
                        }
                        break;
                    case "ArrowRight":
                        if (keyboardDelegate.getKeyRightOf) {
                            let target = nextValidTarget(localState.state.target, types, drag.allowedDropOperations, (target, wrap)=>getNextTarget(target, wrap, true));
                            localState.state.setTarget(target);
                        }
                        break;
                    case "Home":
                        if (keyboardDelegate.getFirstKey) {
                            let target = nextValidTarget(null, types, drag.allowedDropOperations, getNextTarget);
                            localState.state.setTarget(target);
                        }
                        break;
                    case "End":
                        if (keyboardDelegate.getLastKey) {
                            let target = nextValidTarget(null, types, drag.allowedDropOperations, getPreviousTarget);
                            localState.state.setTarget(target);
                        }
                        break;
                    case "PageDown":
                        if (keyboardDelegate.getKeyPageBelow) {
                            let target = localState.state.target;
                            if (!target) target = nextValidTarget(null, types, drag.allowedDropOperations, getNextTarget);
                            else {
                                // If on the root, go to the item a page below the top. Otherwise a page below the current item.
                                let nextKey = keyboardDelegate.getKeyPageBelow(target.type === "item" ? target.key : keyboardDelegate.getFirstKey());
                                let dropPosition = target.type === "item" ? target.dropPosition : "after";
                                // If there is no next key, or we are starting on the last key, jump to the last possible position.
                                if (nextKey == null || target.type === "item" && target.key === keyboardDelegate.getLastKey()) {
                                    nextKey = keyboardDelegate.getLastKey();
                                    dropPosition = "after";
                                }
                                target = {
                                    type: "item",
                                    key: nextKey,
                                    dropPosition
                                };
                                // If the target does not accept the drop, find the next valid target.
                                // If no next valid target, find the previous valid target.
                                let { draggingCollectionRef, draggingKeys } = (0, _utils.globalDndState);
                                let isInternal = (draggingCollectionRef === null || draggingCollectionRef === void 0 ? void 0 : draggingCollectionRef.current) === (ref === null || ref === void 0 ? void 0 : ref.current);
                                let operation = localState.state.getDropOperation({
                                    target,
                                    types,
                                    allowedOperations: drag.allowedDropOperations,
                                    isInternal,
                                    draggingKeys
                                });
                                var _nextValidTarget;
                                if (operation === "cancel") target = (_nextValidTarget = nextValidTarget(target, types, drag.allowedDropOperations, getNextTarget, false)) !== null && _nextValidTarget !== void 0 ? _nextValidTarget : nextValidTarget(target, types, drag.allowedDropOperations, getPreviousTarget, false);
                            }
                            localState.state.setTarget(target !== null && target !== void 0 ? target : localState.state.target);
                        }
                        break;
                    case "PageUp":
                        {
                            if (!keyboardDelegate.getKeyPageAbove) break;
                            let target = localState.state.target;
                            if (!target) target = nextValidTarget(null, types, drag.allowedDropOperations, getPreviousTarget);
                            else if (target.type === "item") {
                                // If at the top already, switch to the root. Otherwise navigate a page up.
                                if (target.key === keyboardDelegate.getFirstKey()) target = {
                                    type: "root"
                                };
                                else {
                                    let nextKey = keyboardDelegate.getKeyPageAbove(target.key);
                                    let dropPosition = target.dropPosition;
                                    if (nextKey == null) {
                                        nextKey = keyboardDelegate.getFirstKey();
                                        dropPosition = "before";
                                    }
                                    target = {
                                        type: "item",
                                        key: nextKey,
                                        dropPosition
                                    };
                                }
                                // If the target does not accept the drop, find the previous valid target.
                                // If no next valid target, find the next valid target.
                                let { draggingKeys } = (0, _utils.globalDndState);
                                let isInternal = (0, _utils.isInternalDropOperation)(ref);
                                let operation = localState.state.getDropOperation({
                                    target,
                                    types,
                                    allowedOperations: drag.allowedDropOperations,
                                    isInternal,
                                    draggingKeys
                                });
                                var _nextValidTarget1;
                                if (operation === "cancel") target = (_nextValidTarget1 = nextValidTarget(target, types, drag.allowedDropOperations, getPreviousTarget, false)) !== null && _nextValidTarget1 !== void 0 ? _nextValidTarget1 : nextValidTarget(target, types, drag.allowedDropOperations, getNextTarget, false);
                            }
                            localState.state.setTarget(target !== null && target !== void 0 ? target : localState.state.target);
                            break;
                        }
                }
            }
        });
    }, [
        localState,
        ref,
        onDrop,
        direction
    ]);
    let id = (0, _utils1.useId)();
    (0, _utils.droppableCollectionMap).set(state, {
        id,
        ref
    });
    return {
        collectionProps: (0, _utils1.mergeProps)(dropProps, {
            id,
            // Remove description from collection element. If dropping on the entire collection,
            // there should be a drop indicator that has this description, so no need to double announce.
            "aria-describedby": null
        })
    };
}

},{"./utils":"8X8qs","./DragManager":"j7vmC","react":"9yzVZ","@react-aria/utils":"9cLk5","@react-aria/interactions":"ky3G8","./useAutoScroll":"fRA1H","./useDrop":"atFXS","@react-aria/i18n":"411rg","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"fRA1H":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useAutoScroll", ()=>useAutoScroll);
var _utils = require("@react-aria/utils");
var _react = require("react");
const AUTOSCROLL_AREA_SIZE = 20;
function useAutoScroll(ref) {
    let scrollableRef = (0, _react.useRef)(null);
    let scrollableX = (0, _react.useRef)(true);
    let scrollableY = (0, _react.useRef)(true);
    (0, _react.useEffect)(()=>{
        if (ref.current) {
            scrollableRef.current = (0, _utils.isScrollable)(ref.current) ? ref.current : (0, _utils.getScrollParent)(ref.current);
            let style = window.getComputedStyle(scrollableRef.current);
            scrollableX.current = /(auto|scroll)/.test(style.overflowX);
            scrollableY.current = /(auto|scroll)/.test(style.overflowY);
        }
    }, [
        ref
    ]);
    let state = (0, _react.useRef)({
        timer: null,
        dx: 0,
        dy: 0
    }).current;
    (0, _react.useEffect)(()=>{
        return ()=>{
            if (state.timer) {
                cancelAnimationFrame(state.timer);
                state.timer = null;
            }
        };
    // state will become a new object, so it's ok to use in the dependency array for unmount
    }, [
        state
    ]);
    let scroll = (0, _react.useCallback)(()=>{
        if (scrollableX.current) scrollableRef.current.scrollLeft += state.dx;
        if (scrollableY.current) scrollableRef.current.scrollTop += state.dy;
        if (state.timer) state.timer = requestAnimationFrame(scroll);
    }, [
        scrollableRef,
        state
    ]);
    return {
        move (x, y) {
            // Most browsers auto scroll natively, but WebKit on macOS does not (iOS does 🤷‍♂️).
            // https://bugs.webkit.org/show_bug.cgi?id=222636
            if (!(0, _utils.isWebKit)() || (0, _utils.isIOS)() || !scrollableRef.current) return;
            let box = scrollableRef.current.getBoundingClientRect();
            let left = AUTOSCROLL_AREA_SIZE;
            let top = AUTOSCROLL_AREA_SIZE;
            let bottom = box.height - AUTOSCROLL_AREA_SIZE;
            let right = box.width - AUTOSCROLL_AREA_SIZE;
            if (x < left || x > right || y < top || y > bottom) {
                if (x < left) state.dx = x - left;
                else if (x > right) state.dx = x - right;
                if (y < top) state.dy = y - top;
                else if (y > bottom) state.dy = y - bottom;
                if (!state.timer) state.timer = requestAnimationFrame(scroll);
            } else this.stop();
        },
        stop () {
            if (state.timer) {
                cancelAnimationFrame(state.timer);
                state.timer = null;
            }
        }
    };
}

},{"@react-aria/utils":"9cLk5","react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"gRoNP":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Handles drop interactions for an item within a collection component.
 */ parcelHelpers.export(exports, "useDroppableItem", ()=>useDroppableItem);
var _dragManager = require("./DragManager");
var _utils = require("./utils");
var _react = require("react");
var _useVirtualDrop = require("./useVirtualDrop");
function useDroppableItem(options, state, ref) {
    let { dropProps } = (0, _useVirtualDrop.useVirtualDrop)();
    let droppableCollectionRef = (0, _utils.getDroppableCollectionRef)(state);
    (0, _react.useEffect)(()=>{
        if (ref.current) return _dragManager.registerDropItem({
            element: ref.current,
            target: options.target,
            getDropOperation (types, allowedOperations) {
                let { draggingKeys } = (0, _utils.globalDndState);
                let isInternal = (0, _utils.isInternalDropOperation)(droppableCollectionRef);
                return state.getDropOperation({
                    target: options.target,
                    types,
                    allowedOperations,
                    isInternal,
                    draggingKeys
                });
            }
        });
    }, [
        ref,
        options.target,
        state,
        droppableCollectionRef
    ]);
    let dragSession = _dragManager.useDragSession();
    let { draggingKeys } = (0, _utils.globalDndState);
    let isInternal = (0, _utils.isInternalDropOperation)(droppableCollectionRef);
    let isValidDropTarget = dragSession && state.getDropOperation({
        target: options.target,
        types: (0, _utils.getTypes)(dragSession.dragTarget.items),
        allowedOperations: dragSession.dragTarget.allowedDropOperations,
        isInternal,
        draggingKeys
    }) !== "cancel";
    let isDropTarget = state.isDropTarget(options.target);
    (0, _react.useEffect)(()=>{
        if (dragSession && isDropTarget && ref.current) ref.current.focus();
    }, [
        isDropTarget,
        dragSession,
        ref
    ]);
    return {
        dropProps: {
            ...dropProps,
            "aria-hidden": !dragSession || isValidDropTarget ? undefined : "true"
        },
        isDropTarget
    };
}

},{"./DragManager":"j7vmC","./utils":"8X8qs","react":"9yzVZ","./useVirtualDrop":"8sibk","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"c2K9X":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Handles drop interactions for a target within a droppable collection.
 */ parcelHelpers.export(exports, "useDropIndicator", ()=>useDropIndicator);
var _dragManager = require("./DragManager");
var _utils = require("./utils");
// @ts-ignore
var _json = require("../intl/*.json");
var _jsonDefault = parcelHelpers.interopDefault(_json);
var _useDroppableItem = require("./useDroppableItem");
var _utils1 = require("@react-aria/utils");
var _i18N = require("@react-aria/i18n");
function useDropIndicator(props, state, ref) {
    let { target } = props;
    let { collection } = state;
    let stringFormatter = (0, _i18N.useLocalizedStringFormatter)((0, _jsonDefault.default), "@react-aria/dnd");
    let dragSession = _dragManager.useDragSession();
    let { dropProps } = (0, _useDroppableItem.useDroppableItem)(props, state, ref);
    let id = (0, _utils1.useId)();
    let getText = (key)=>{
        var _collection_getTextValue, _collection_getItem;
        var _collection_getTextValue1;
        return (_collection_getTextValue1 = (_collection_getTextValue = collection.getTextValue) === null || _collection_getTextValue === void 0 ? void 0 : _collection_getTextValue.call(collection, key)) !== null && _collection_getTextValue1 !== void 0 ? _collection_getTextValue1 : (_collection_getItem = collection.getItem(key)) === null || _collection_getItem === void 0 ? void 0 : _collection_getItem.textValue;
    };
    let label = "";
    let labelledBy;
    if (target.type === "root") {
        label = stringFormatter.format("dropOnRoot");
        labelledBy = `${id} ${(0, _utils.getDroppableCollectionId)(state)}`;
    } else if (target.dropPosition === "on") label = stringFormatter.format("dropOnItem", {
        itemText: getText(target.key)
    });
    else {
        let before;
        let after;
        if (collection.getFirstKey() === target.key && target.dropPosition === "before") before = null;
        else before = target.dropPosition === "before" ? collection.getKeyBefore(target.key) : target.key;
        if (collection.getLastKey() === target.key && target.dropPosition === "after") after = null;
        else after = target.dropPosition === "after" ? collection.getKeyAfter(target.key) : target.key;
        if (before && after) label = stringFormatter.format("insertBetween", {
            beforeItemText: getText(before),
            afterItemText: getText(after)
        });
        else if (before) label = stringFormatter.format("insertAfter", {
            itemText: getText(before)
        });
        else if (after) label = stringFormatter.format("insertBefore", {
            itemText: getText(after)
        });
    }
    let isDropTarget = state.isDropTarget(target);
    let ariaHidden = !dragSession ? "true" : dropProps["aria-hidden"];
    return {
        dropIndicatorProps: {
            ...dropProps,
            id,
            "aria-roledescription": stringFormatter.format("dropIndicator"),
            "aria-label": label,
            "aria-labelledby": labelledBy,
            "aria-hidden": ariaHidden,
            tabIndex: -1
        },
        isDropTarget,
        // If aria-hidden, we are either not in a drag session or the drop target is invalid.
        // In that case, there's no need to render anything at all unless we need to show the indicator visually.
        // This can happen when dragging using the native DnD API as opposed to keyboard dragging.
        isHidden: !isDropTarget && !!ariaHidden
    };
}

},{"./DragManager":"j7vmC","./utils":"8X8qs","../intl/*.json":"3FI7M","./useDroppableItem":"gRoNP","@react-aria/utils":"9cLk5","@react-aria/i18n":"411rg","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"IV6Ct":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Handles drag interactions for an item within a draggable collection.
 */ parcelHelpers.export(exports, "useDraggableItem", ()=>useDraggableItem);
var _utils = require("./utils");
// @ts-ignore
var _json = require("../intl/*.json");
var _jsonDefault = parcelHelpers.interopDefault(_json);
var _utils1 = require("@react-aria/utils");
var _useDrag = require("./useDrag");
var _i18N = require("@react-aria/i18n");
const MESSAGES = {
    keyboard: {
        selected: "dragSelectedKeyboard",
        notSelected: "dragDescriptionKeyboard"
    },
    touch: {
        selected: "dragSelectedLongPress",
        notSelected: "dragDescriptionLongPress"
    },
    virtual: {
        selected: "dragDescriptionVirtual",
        notSelected: "dragDescriptionVirtual"
    }
};
function useDraggableItem(props, state) {
    let stringFormatter = (0, _i18N.useLocalizedStringFormatter)((0, _jsonDefault.default), "@react-aria/dnd");
    let isDisabled = state.selectionManager.isDisabled(props.key);
    let { dragProps, dragButtonProps } = (0, _useDrag.useDrag)({
        getItems () {
            return state.getItems(props.key);
        },
        preview: state.preview,
        getAllowedDropOperations: state.getAllowedDropOperations,
        hasDragButton: props.hasDragButton,
        onDragStart (e) {
            state.startDrag(props.key, e);
            // Track draggingKeys for useDroppableCollection's default onDrop handler and useDroppableCollectionState's default getDropOperation
            (0, _utils.setDraggingKeys)(state.draggingKeys);
        },
        onDragMove (e) {
            state.moveDrag(e);
        },
        onDragEnd (e) {
            let { dropOperation } = e;
            let isInternal = dropOperation === "cancel" ? false : (0, _utils.isInternalDropOperation)();
            state.endDrag({
                ...e,
                keys: state.draggingKeys,
                isInternal
            });
            (0, _utils.clearGlobalDnDState)();
        }
    });
    let item = state.collection.getItem(props.key);
    let numKeysForDrag = state.getKeysForDrag(props.key).size;
    let isSelected = numKeysForDrag > 1 && state.selectionManager.isSelected(props.key);
    let dragButtonLabel;
    let description;
    // Override description to include selected item count.
    let modality = (0, _utils.useDragModality)();
    if (!props.hasDragButton && state.selectionManager.selectionMode !== "none") {
        let msg = MESSAGES[modality][isSelected ? "selected" : "notSelected"];
        if (props.hasAction && modality === "keyboard") msg += "Alt";
        if (isSelected) description = stringFormatter.format(msg, {
            count: numKeysForDrag
        });
        else description = stringFormatter.format(msg);
        // Remove the onClick handler from useDrag. Long pressing will be required on touch devices,
        // and NVDA/JAWS are always in forms mode within collection components.
        delete dragProps.onClick;
    } else if (isSelected) dragButtonLabel = stringFormatter.format("dragSelectedItems", {
        count: numKeysForDrag
    });
    else {
        var _state_collection_getTextValue, _state_collection;
        var _state_collection_getTextValue1, _ref;
        let itemText = (_ref = (_state_collection_getTextValue1 = (_state_collection_getTextValue = (_state_collection = state.collection).getTextValue) === null || _state_collection_getTextValue === void 0 ? void 0 : _state_collection_getTextValue.call(_state_collection, props.key)) !== null && _state_collection_getTextValue1 !== void 0 ? _state_collection_getTextValue1 : item === null || item === void 0 ? void 0 : item.textValue) !== null && _ref !== void 0 ? _ref : "";
        dragButtonLabel = stringFormatter.format("dragItem", {
            itemText
        });
    }
    let descriptionProps = (0, _utils1.useDescription)(description);
    if (description) Object.assign(dragProps, descriptionProps);
    if (!props.hasDragButton && props.hasAction) {
        let { onKeyDownCapture, onKeyUpCapture } = dragProps;
        if (modality === "touch") // Remove long press description if an action is present, because in that case long pressing selects the item.
        delete dragProps["aria-describedby"];
        // Require Alt key if there is a conflicting action.
        dragProps.onKeyDownCapture = (e)=>{
            if (e.altKey) onKeyDownCapture(e);
        };
        dragProps.onKeyUpCapture = (e)=>{
            if (e.altKey) onKeyUpCapture(e);
        };
    }
    return {
        dragProps: isDisabled ? {} : dragProps,
        dragButtonProps: {
            ...dragButtonProps,
            isDisabled,
            "aria-label": dragButtonLabel
        }
    };
}

},{"./utils":"8X8qs","../intl/*.json":"3FI7M","@react-aria/utils":"9cLk5","./useDrag":"c3cpR","@react-aria/i18n":"411rg","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"gL8nv":[function(require,module,exports) {
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Handles drag interactions for a collection component, with support for traditional mouse and touch
 * based drag and drop, in addition to full parity for keyboard and screen reader users.
 */ parcelHelpers.export(exports, "useDraggableCollection", ()=>useDraggableCollection);
var _utils = require("./utils");
function useDraggableCollection(props, state, ref) {
    // Update global DnD state if this keys within this collection are dragged
    let { draggingCollectionRef } = (0, _utils.globalDndState);
    if (state.draggingKeys.size > 0 && (draggingCollectionRef === null || draggingCollectionRef === void 0 ? void 0 : draggingCollectionRef.current) !== ref.current) (0, _utils.setDraggingCollectionRef)(ref);
}

},{"./utils":"8X8qs","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"6n6f2":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Handles clipboard interactions for a focusable element. Supports items of multiple
 * data types, and integrates with the operating system native clipboard.
 */ parcelHelpers.export(exports, "useClipboard", ()=>useClipboard);
var _utils = require("@react-aria/utils");
var _utils1 = require("./utils");
var _react = require("react");
var _interactions = require("@react-aria/interactions");
const globalEvents = new Map();
function addGlobalEventListener(event, fn) {
    let eventData = globalEvents.get(event);
    if (!eventData) {
        let handlers = new Set();
        let listener = (e)=>{
            for (let handler of handlers)handler(e);
        };
        eventData = {
            listener,
            handlers
        };
        globalEvents.set(event, eventData);
        document.addEventListener(event, listener);
    }
    eventData.handlers.add(fn);
    return ()=>{
        eventData.handlers.delete(fn);
        if (eventData.handlers.size === 0) {
            document.removeEventListener(event, eventData.listener);
            globalEvents.delete(event);
        }
    };
}
function useClipboard(options) {
    let isFocusedRef = (0, _react.useRef)(false);
    let { focusProps } = (0, _interactions.useFocus)({
        onFocusChange: (isFocused)=>{
            isFocusedRef.current = isFocused;
        }
    });
    let onBeforeCopy = (0, _utils.useEffectEvent)((e)=>{
        // Enable the "Copy" menu item in Safari if this element is focused and copying is supported.
        if (isFocusedRef.current && options.getItems) e.preventDefault();
    });
    let onCopy = (0, _utils.useEffectEvent)((e)=>{
        var _options_onCopy;
        if (!isFocusedRef.current || !options.getItems) return;
        e.preventDefault();
        (0, _utils1.writeToDataTransfer)(e.clipboardData, options.getItems());
        (_options_onCopy = options.onCopy) === null || _options_onCopy === void 0 ? void 0 : _options_onCopy.call(options);
    });
    let onBeforeCut = (0, _utils.useEffectEvent)((e)=>{
        if (isFocusedRef.current && options.onCut && options.getItems) e.preventDefault();
    });
    let onCut = (0, _utils.useEffectEvent)((e)=>{
        if (!isFocusedRef.current || !options.onCut || !options.getItems) return;
        e.preventDefault();
        (0, _utils1.writeToDataTransfer)(e.clipboardData, options.getItems());
        options.onCut();
    });
    let onBeforePaste = (0, _utils.useEffectEvent)((e)=>{
        // Unfortunately, e.clipboardData.types is not available in this event so we always
        // have to enable the Paste menu item even if the type of data is unsupported.
        if (isFocusedRef.current && options.onPaste) e.preventDefault();
    });
    let onPaste = (0, _utils.useEffectEvent)((e)=>{
        if (!isFocusedRef.current || !options.onPaste) return;
        e.preventDefault();
        let items = (0, _utils1.readFromDataTransfer)(e.clipboardData);
        options.onPaste(items);
    });
    (0, _react.useEffect)(()=>{
        return (0, _utils.chain)(addGlobalEventListener("beforecopy", onBeforeCopy), addGlobalEventListener("copy", onCopy), addGlobalEventListener("beforecut", onBeforeCut), addGlobalEventListener("cut", onCut), addGlobalEventListener("beforepaste", onBeforePaste), addGlobalEventListener("paste", onPaste));
    }, [
        onBeforeCopy,
        onCopy,
        onBeforeCut,
        onCut,
        onBeforePaste,
        onPaste
    ]);
    return {
        clipboardProps: focusProps
    };
}

},{"@react-aria/utils":"9cLk5","./utils":"8X8qs","react":"9yzVZ","@react-aria/interactions":"ky3G8","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"dijBK":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DragPreview", ()=>_DragPreview);
var _reactDom = require("react-dom");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
function DragPreview(props, ref) {
    let render = props.children;
    let [children, setChildren] = (0, _react.useState)(null);
    let domRef = (0, _react.useRef)(null);
    (0, _react.useImperativeHandle)(ref, ()=>(items, callback)=>{
            // This will be called during the onDragStart event by useDrag. We need to render the
            // preview synchronously before this event returns so we can call event.dataTransfer.setDragImage.
            (0, _reactDom.flushSync)(()=>{
                setChildren(render(items));
            });
            // Yield back to useDrag to set the drag image.
            callback(domRef.current);
            // Remove the preview from the DOM after a frame so the browser has time to paint.
            requestAnimationFrame(()=>{
                setChildren(null);
            });
        }, [
        render
    ]);
    if (!children) return null;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        style: {
            zIndex: -100,
            position: "absolute",
            top: 0,
            left: -100000
        },
        ref: domRef
    }, children);
}
let _DragPreview = /*#__PURE__*/ (0, _reactDefault.default).forwardRef(DragPreview);

},{"react-dom":"cEvV3","react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"hPa8U":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// Terms used in the below code:
//   * "Primary"   – The main layout direction. For stacks, this is the direction
//                   that the stack is arranged in (e.g. horizontal or vertical).
//                   For grids, this is the main scroll direction.
//   * "Secondary" – The secondary layout direction. For stacks, there is no secondary
//                   layout direction. For grids, this is the opposite of the primary direction.
//   * "Flow"      – The flow direction of the items. For stacks, this is the the primary
//                   direction. For grids, it is the secondary direction.
parcelHelpers.export(exports, "ListDropTargetDelegate", ()=>ListDropTargetDelegate);
class ListDropTargetDelegate {
    getPrimaryStart(rect) {
        return this.orientation === "horizontal" ? rect.left : rect.top;
    }
    getPrimaryEnd(rect) {
        return this.orientation === "horizontal" ? rect.right : rect.bottom;
    }
    getSecondaryStart(rect) {
        return this.orientation === "horizontal" ? rect.top : rect.left;
    }
    getSecondaryEnd(rect) {
        return this.orientation === "horizontal" ? rect.bottom : rect.right;
    }
    getFlowStart(rect) {
        return this.layout === "stack" ? this.getPrimaryStart(rect) : this.getSecondaryStart(rect);
    }
    getFlowEnd(rect) {
        return this.layout === "stack" ? this.getPrimaryEnd(rect) : this.getSecondaryEnd(rect);
    }
    getFlowSize(rect) {
        return this.getFlowEnd(rect) - this.getFlowStart(rect);
    }
    getDropTargetFromPoint(x, y, isValidDropTarget) {
        if (this.collection.size === 0) return {
            type: "root"
        };
        let rect = this.ref.current.getBoundingClientRect();
        let primary = this.orientation === "horizontal" ? x : y;
        let secondary = this.orientation === "horizontal" ? y : x;
        primary += this.getPrimaryStart(rect);
        secondary += this.getSecondaryStart(rect);
        let flow = this.layout === "stack" ? primary : secondary;
        let isPrimaryRTL = this.orientation === "horizontal" && this.direction === "rtl";
        let isSecondaryRTL = this.layout === "grid" && this.orientation === "vertical" && this.direction === "rtl";
        let isFlowRTL = this.layout === "stack" ? isPrimaryRTL : isSecondaryRTL;
        let elements = this.ref.current.querySelectorAll("[data-key]");
        let elementMap = new Map();
        for (let item of elements)if (item instanceof HTMLElement) elementMap.set(item.dataset.key, item);
        let items = [
            ...this.collection
        ];
        let low = 0;
        let high = items.length;
        while(low < high){
            let mid = Math.floor((low + high) / 2);
            let item = items[mid];
            let element = elementMap.get(String(item.key));
            let rect = element.getBoundingClientRect();
            let update = (isGreater)=>{
                if (isGreater) low = mid + 1;
                else high = mid;
            };
            if (primary < this.getPrimaryStart(rect)) update(isPrimaryRTL);
            else if (primary > this.getPrimaryEnd(rect)) update(!isPrimaryRTL);
            else if (secondary < this.getSecondaryStart(rect)) update(isSecondaryRTL);
            else if (secondary > this.getSecondaryEnd(rect)) update(!isSecondaryRTL);
            else {
                let target = {
                    type: "item",
                    key: item.key,
                    dropPosition: "on"
                };
                if (isValidDropTarget(target)) {
                    // Otherwise, if dropping on the item is accepted, try the before/after positions if within 5px
                    // of the start or end of the item.
                    if (flow <= this.getFlowStart(rect) + 5 && isValidDropTarget({
                        ...target,
                        dropPosition: "before"
                    })) target.dropPosition = isFlowRTL ? "after" : "before";
                    else if (flow >= this.getFlowEnd(rect) - 5 && isValidDropTarget({
                        ...target,
                        dropPosition: "after"
                    })) target.dropPosition = isFlowRTL ? "before" : "after";
                } else {
                    // If dropping on the item isn't accepted, try the target before or after depending on the position.
                    let mid = this.getFlowStart(rect) + this.getFlowSize(rect) / 2;
                    if (flow <= mid && isValidDropTarget({
                        ...target,
                        dropPosition: "before"
                    })) target.dropPosition = isFlowRTL ? "after" : "before";
                    else if (flow >= mid && isValidDropTarget({
                        ...target,
                        dropPosition: "after"
                    })) target.dropPosition = isFlowRTL ? "before" : "after";
                }
                return target;
            }
        }
        let item = items[Math.min(low, items.length - 1)];
        let element = elementMap.get(String(item.key));
        rect = element.getBoundingClientRect();
        if (primary < this.getPrimaryStart(rect) || Math.abs(flow - this.getFlowStart(rect)) < Math.abs(flow - this.getFlowEnd(rect))) return {
            type: "item",
            key: item.key,
            dropPosition: isFlowRTL ? "after" : "before"
        };
        return {
            type: "item",
            key: item.key,
            dropPosition: isFlowRTL ? "before" : "after"
        };
    }
    constructor(collection, ref, options){
        this.collection = collection;
        this.ref = ref;
        this.layout = (options === null || options === void 0 ? void 0 : options.layout) || "stack";
        this.orientation = (options === null || options === void 0 ? void 0 : options.orientation) || "vertical";
        this.direction = (options === null || options === void 0 ? void 0 : options.direction) || "ltr";
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"g9vQF":[function(require,module,exports) {
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useGridList", ()=>(0, _useGridList.useGridList));
parcelHelpers.export(exports, "useGridListItem", ()=>(0, _useGridListItem.useGridListItem));
parcelHelpers.export(exports, "useGridListSelectionCheckbox", ()=>(0, _useGridListSelectionCheckbox.useGridListSelectionCheckbox));
var _useGridList = require("./useGridList");
var _useGridListItem = require("./useGridListItem");
var _useGridListSelectionCheckbox = require("./useGridListSelectionCheckbox");

},{"./useGridList":"ikhTm","./useGridListItem":"a06cG","./useGridListSelectionCheckbox":"i7lhk","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"ikhTm":[function(require,module,exports) {
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides the behavior and accessibility implementation for a list component with interactive children.
 * A grid list displays data in a single column and enables a user to navigate its contents via directional navigation keys.
 * @param props - Props for the list.
 * @param state - State for the list, as returned by `useListState`.
 * @param ref - The ref attached to the list element.
 */ parcelHelpers.export(exports, "useGridList", ()=>useGridList);
var _utils = require("@react-aria/utils");
var _utils1 = require("./utils");
var _grid = require("@react-aria/grid");
var _focus = require("@react-aria/focus");
var _selection = require("@react-aria/selection");
function useGridList(props, state, ref) {
    let { isVirtualized, keyboardDelegate, onAction, linkBehavior = "action" } = props;
    if (!props["aria-label"] && !props["aria-labelledby"]) console.warn("An aria-label or aria-labelledby prop is required for accessibility.");
    let { listProps } = (0, _selection.useSelectableList)({
        selectionManager: state.selectionManager,
        collection: state.collection,
        disabledKeys: state.disabledKeys,
        ref,
        keyboardDelegate: keyboardDelegate,
        isVirtualized,
        selectOnFocus: state.selectionManager.selectionBehavior === "replace",
        shouldFocusWrap: props.shouldFocusWrap,
        linkBehavior
    });
    let id = (0, _utils.useId)(props.id);
    (0, _utils1.listMap).set(state, {
        id,
        onAction,
        linkBehavior
    });
    let descriptionProps = (0, _grid.useHighlightSelectionDescription)({
        selectionManager: state.selectionManager,
        hasItemActions: !!onAction
    });
    let hasTabbableChild = (0, _focus.useHasTabbableChild)(ref, {
        isDisabled: state.collection.size !== 0
    });
    let domProps = (0, _utils.filterDOMProps)(props, {
        labelable: true
    });
    let gridProps = (0, _utils.mergeProps)(domProps, {
        role: "grid",
        id,
        "aria-multiselectable": state.selectionManager.selectionMode === "multiple" ? "true" : undefined
    }, // If collection is empty, make sure the grid is tabbable unless there is a child tabbable element.
    state.collection.size === 0 ? {
        tabIndex: hasTabbableChild ? -1 : 0
    } : listProps, descriptionProps);
    if (isVirtualized) {
        gridProps["aria-rowcount"] = state.collection.size;
        gridProps["aria-colcount"] = 1;
    }
    (0, _grid.useGridSelectionAnnouncement)({}, state);
    return {
        gridProps
    };
}

},{"@react-aria/utils":"9cLk5","./utils":"coliS","@react-aria/grid":"6tGaN","@react-aria/focus":"42mbF","@react-aria/selection":"6Fly5","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"coliS":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "listMap", ()=>listMap);
parcelHelpers.export(exports, "getRowId", ()=>getRowId);
parcelHelpers.export(exports, "normalizeKey", ()=>normalizeKey);
const listMap = new WeakMap();
function getRowId(state, key) {
    let { id } = listMap.get(state);
    if (!id) throw new Error("Unknown list");
    return `${id}-${normalizeKey(key)}`;
}
function normalizeKey(key) {
    if (typeof key === "string") return key.replace(/\s*/g, "");
    return "" + key;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"6tGaN":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GridKeyboardDelegate", ()=>(0, _gridKeyboardDelegate.GridKeyboardDelegate));
parcelHelpers.export(exports, "useGrid", ()=>(0, _useGrid.useGrid));
parcelHelpers.export(exports, "useGridRowGroup", ()=>(0, _useGridRowGroup.useGridRowGroup));
parcelHelpers.export(exports, "useGridRow", ()=>(0, _useGridRow.useGridRow));
parcelHelpers.export(exports, "useGridCell", ()=>(0, _useGridCell.useGridCell));
parcelHelpers.export(exports, "useGridSelectionCheckbox", ()=>(0, _useGridSelectionCheckbox.useGridSelectionCheckbox));
parcelHelpers.export(exports, "useHighlightSelectionDescription", ()=>(0, _useHighlightSelectionDescription.useHighlightSelectionDescription));
parcelHelpers.export(exports, "useGridSelectionAnnouncement", ()=>(0, _useGridSelectionAnnouncement.useGridSelectionAnnouncement));
var _gridKeyboardDelegate = require("./GridKeyboardDelegate");
var _useGrid = require("./useGrid");
var _useGridRowGroup = require("./useGridRowGroup");
var _useGridRow = require("./useGridRow");
var _useGridCell = require("./useGridCell");
var _useGridSelectionCheckbox = require("./useGridSelectionCheckbox");
var _useHighlightSelectionDescription = require("./useHighlightSelectionDescription");
var _useGridSelectionAnnouncement = require("./useGridSelectionAnnouncement");

},{"./GridKeyboardDelegate":"kOcW0","./useGrid":"9heg9","./useGridRowGroup":"i7FC2","./useGridRow":"3b5RG","./useGridCell":"1nlzP","./useGridSelectionCheckbox":"dAxXr","./useHighlightSelectionDescription":"eiyac","./useGridSelectionAnnouncement":"2EERD","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"kOcW0":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GridKeyboardDelegate", ()=>GridKeyboardDelegate);
var _collections = require("@react-stately/collections");
var _virtualizer = require("@react-stately/virtualizer");
class GridKeyboardDelegate {
    isCell(node) {
        return node.type === "cell";
    }
    isRow(node) {
        return node.type === "row" || node.type === "item";
    }
    findPreviousKey(fromKey, pred) {
        let key = fromKey != null ? this.collection.getKeyBefore(fromKey) : this.collection.getLastKey();
        while(key != null){
            let item = this.collection.getItem(key);
            if (!this.disabledKeys.has(key) && (!pred || pred(item))) return key;
            key = this.collection.getKeyBefore(key);
        }
    }
    findNextKey(fromKey, pred) {
        let key = fromKey != null ? this.collection.getKeyAfter(fromKey) : this.collection.getFirstKey();
        while(key != null){
            let item = this.collection.getItem(key);
            if (!this.disabledKeys.has(key) && (!pred || pred(item))) return key;
            key = this.collection.getKeyAfter(key);
        }
    }
    getKeyBelow(key) {
        let startItem = this.collection.getItem(key);
        if (!startItem) return;
        // If focus was on a cell, start searching from the parent row
        if (this.isCell(startItem)) key = startItem.parentKey;
        // Find the next item
        key = this.findNextKey(key);
        if (key != null) {
            // If focus was on a cell, focus the cell with the same index in the next row.
            if (this.isCell(startItem)) {
                let item = this.collection.getItem(key);
                return (0, _collections.getNthItem)((0, _collections.getChildNodes)(item, this.collection), startItem.index).key;
            }
            // Otherwise, focus the next row
            if (this.focusMode === "row") return key;
        }
    }
    getKeyAbove(key) {
        let startItem = this.collection.getItem(key);
        if (!startItem) return;
        // If focus is on a cell, start searching from the parent row
        if (this.isCell(startItem)) key = startItem.parentKey;
        // Find the previous item
        key = this.findPreviousKey(key);
        if (key != null) {
            // If focus was on a cell, focus the cell with the same index in the previous row.
            if (this.isCell(startItem)) {
                let item = this.collection.getItem(key);
                return (0, _collections.getNthItem)((0, _collections.getChildNodes)(item, this.collection), startItem.index).key;
            }
            // Otherwise, focus the previous row
            if (this.focusMode === "row") return key;
        }
    }
    getKeyRightOf(key) {
        let item = this.collection.getItem(key);
        if (!item) return;
        // If focus is on a row, focus the first child cell.
        if (this.isRow(item)) {
            let children = (0, _collections.getChildNodes)(item, this.collection);
            return this.direction === "rtl" ? (0, _collections.getLastItem)(children).key : (0, _collections.getFirstItem)(children).key;
        }
        // If focus is on a cell, focus the next cell if any,
        // otherwise focus the parent row.
        if (this.isCell(item)) {
            let parent = this.collection.getItem(item.parentKey);
            let children = (0, _collections.getChildNodes)(parent, this.collection);
            let next = this.direction === "rtl" ? (0, _collections.getNthItem)(children, item.index - 1) : (0, _collections.getNthItem)(children, item.index + 1);
            if (next) return next.key;
            // focus row only if focusMode is set to row
            if (this.focusMode === "row") return item.parentKey;
            return this.direction === "rtl" ? this.getFirstKey(key) : this.getLastKey(key);
        }
    }
    getKeyLeftOf(key) {
        let item = this.collection.getItem(key);
        if (!item) return;
        // If focus is on a row, focus the last child cell.
        if (this.isRow(item)) {
            let children = (0, _collections.getChildNodes)(item, this.collection);
            return this.direction === "rtl" ? (0, _collections.getFirstItem)(children).key : (0, _collections.getLastItem)(children).key;
        }
        // If focus is on a cell, focus the previous cell if any,
        // otherwise focus the parent row.
        if (this.isCell(item)) {
            let parent = this.collection.getItem(item.parentKey);
            let children = (0, _collections.getChildNodes)(parent, this.collection);
            let prev = this.direction === "rtl" ? (0, _collections.getNthItem)(children, item.index + 1) : (0, _collections.getNthItem)(children, item.index - 1);
            if (prev) return prev.key;
            // focus row only if focusMode is set to row
            if (this.focusMode === "row") return item.parentKey;
            return this.direction === "rtl" ? this.getLastKey(key) : this.getFirstKey(key);
        }
    }
    getFirstKey(key, global) {
        let item;
        if (key != null) {
            item = this.collection.getItem(key);
            if (!item) return;
            // If global flag is not set, and a cell is currently focused,
            // move focus to the first cell in the parent row.
            if (this.isCell(item) && !global) {
                let parent = this.collection.getItem(item.parentKey);
                return (0, _collections.getFirstItem)((0, _collections.getChildNodes)(parent, this.collection)).key;
            }
        }
        // Find the first row
        key = this.findNextKey();
        // If global flag is set (or if focus mode is cell), focus the first cell in the first row.
        if (key != null && item && this.isCell(item) && global || this.focusMode === "cell") {
            let item = this.collection.getItem(key);
            key = (0, _collections.getFirstItem)((0, _collections.getChildNodes)(item, this.collection)).key;
        }
        // Otherwise, focus the row itself.
        return key;
    }
    getLastKey(key, global) {
        let item;
        if (key != null) {
            item = this.collection.getItem(key);
            if (!item) return;
            // If global flag is not set, and a cell is currently focused,
            // move focus to the last cell in the parent row.
            if (this.isCell(item) && !global) {
                let parent = this.collection.getItem(item.parentKey);
                let children = (0, _collections.getChildNodes)(parent, this.collection);
                return (0, _collections.getLastItem)(children).key;
            }
        }
        // Find the last row
        key = this.findPreviousKey();
        // If global flag is set (or if focus mode is cell), focus the last cell in the last row.
        if (key != null && item && this.isCell(item) && global || this.focusMode === "cell") {
            let item = this.collection.getItem(key);
            let children = (0, _collections.getChildNodes)(item, this.collection);
            key = (0, _collections.getLastItem)(children).key;
        }
        // Otherwise, focus the row itself.
        return key;
    }
    getItem(key) {
        return this.ref.current.querySelector(`[data-key="${CSS.escape(key.toString())}"]`);
    }
    getItemRect(key) {
        var _this_layout_getLayoutInfo;
        if (this.layout) return (_this_layout_getLayoutInfo = this.layout.getLayoutInfo(key)) === null || _this_layout_getLayoutInfo === void 0 ? void 0 : _this_layout_getLayoutInfo.rect;
        let item = this.getItem(key);
        if (item) return new (0, _virtualizer.Rect)(item.offsetLeft, item.offsetTop, item.offsetWidth, item.offsetHeight);
    }
    getPageHeight() {
        var _this_layout_virtualizer, _this_ref_current, _this_ref;
        if (this.layout) return (_this_layout_virtualizer = this.layout.virtualizer) === null || _this_layout_virtualizer === void 0 ? void 0 : _this_layout_virtualizer.visibleRect.height;
        return (_this_ref = this.ref) === null || _this_ref === void 0 ? void 0 : (_this_ref_current = _this_ref.current) === null || _this_ref_current === void 0 ? void 0 : _this_ref_current.offsetHeight;
    }
    getContentHeight() {
        var _this_ref_current, _this_ref;
        if (this.layout) return this.layout.getContentSize().height;
        return (_this_ref = this.ref) === null || _this_ref === void 0 ? void 0 : (_this_ref_current = _this_ref.current) === null || _this_ref_current === void 0 ? void 0 : _this_ref_current.scrollHeight;
    }
    getKeyPageAbove(key) {
        let itemRect = this.getItemRect(key);
        if (!itemRect) return null;
        let pageY = Math.max(0, itemRect.maxY - this.getPageHeight());
        while(itemRect && itemRect.y > pageY){
            key = this.getKeyAbove(key);
            itemRect = this.getItemRect(key);
        }
        return key;
    }
    getKeyPageBelow(key) {
        let itemRect = this.getItemRect(key);
        if (!itemRect) return null;
        let pageHeight = this.getPageHeight();
        let pageY = Math.min(this.getContentHeight(), itemRect.y + pageHeight);
        while(itemRect && itemRect.maxY < pageY){
            let nextKey = this.getKeyBelow(key);
            itemRect = this.getItemRect(nextKey);
            // Guard against case where maxY of the last key is barely less than pageY due to rounding
            // and thus it attempts to set key to null
            if (nextKey != null) key = nextKey;
        }
        return key;
    }
    getKeyForSearch(search, fromKey) {
        if (!this.collator) return null;
        let collection = this.collection;
        let key = fromKey !== null && fromKey !== void 0 ? fromKey : this.getFirstKey();
        // If the starting key is a cell, search from its parent row.
        let startItem = collection.getItem(key);
        if (startItem.type === "cell") key = startItem.parentKey;
        let hasWrapped = false;
        while(key != null){
            let item = collection.getItem(key);
            // check row text value for match
            if (item.textValue) {
                let substring = item.textValue.slice(0, search.length);
                if (this.collator.compare(substring, search) === 0) {
                    if (this.isRow(item) && this.focusMode === "cell") return (0, _collections.getFirstItem)((0, _collections.getChildNodes)(item, this.collection)).key;
                    return item.key;
                }
            }
            key = this.findNextKey(key);
            // Wrap around when reaching the end of the collection
            if (key == null && !hasWrapped) {
                key = this.getFirstKey();
                hasWrapped = true;
            }
        }
        return null;
    }
    constructor(options){
        this.collection = options.collection;
        this.disabledKeys = options.disabledKeys;
        this.ref = options.ref;
        this.direction = options.direction;
        this.collator = options.collator;
        this.layout = options.layout;
        this.focusMode = options.focusMode || "row";
    }
}

},{"@react-stately/collections":"loANi","@react-stately/virtualizer":"lVS5O","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"lVS5O":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Layout", ()=>(0, _layout.Layout));
parcelHelpers.export(exports, "LayoutInfo", ()=>(0, _layoutInfo.LayoutInfo));
parcelHelpers.export(exports, "Point", ()=>(0, _point.Point));
parcelHelpers.export(exports, "Rect", ()=>(0, _rect.Rect));
parcelHelpers.export(exports, "Size", ()=>(0, _size.Size));
parcelHelpers.export(exports, "ReusableView", ()=>(0, _reusableView.ReusableView));
parcelHelpers.export(exports, "useVirtualizerState", ()=>(0, _useVirtualizerState.useVirtualizerState));
var _layout = require("./Layout");
var _layoutInfo = require("./LayoutInfo");
var _point = require("./Point");
var _rect = require("./Rect");
var _size = require("./Size");
var _reusableView = require("./ReusableView");
var _useVirtualizerState = require("./useVirtualizerState");

},{"./Layout":"lDrTB","./LayoutInfo":"7HYyk","./Point":"awNGi","./Rect":"Fehec","./Size":"3ogtw","./ReusableView":false,"./useVirtualizerState":"cfNH4","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"lDrTB":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// import { DragTarget, DropTarget } from '@react-types/shared';
/**
 * [CollectionView]{@link CollectionView} supports arbitrary layout objects, which compute what views are visible, and how
 * to position and style them. However, layouts do not create the views themselves directly. Instead,
 * layouts produce lightweight {@link LayoutInfo} objects which describe various properties of a view,
 * such as its position and size. The {@link CollectionView} is then responsible for creating the actual
 * views as needed, based on this layout information.
 *
 * Every layout extends from the {@link Layout} abstract base class. Layouts must implement a minimum of the
 * two methods listed below. All other methods can be optionally overridden to implement custom behavior.
 *
 * @see {@link getVisibleLayoutInfos}
 * @see {@link getLayoutInfo}
 */ parcelHelpers.export(exports, "Layout", ()=>Layout);
class Layout {
    /**
   * Returns whether the layout should invalidate in response to
   * visible rectangle changes. By default, it only invalidates
   * when the collection view's size changes. Return true always
   * to make the layout invalidate while scrolling (e.g. sticky headers).
   */ shouldInvalidate(newRect, oldRect) {
        // By default, invalidate when the size changes
        return newRect.width !== oldRect.width || newRect.height !== oldRect.height;
    }
    /**
   * This method allows the layout to perform any pre-computation
   * it needs to in order to prepare {@link LayoutInfo}s for retrieval.
   * Called by the collection view before {@link getVisibleLayoutInfos}
   * or {@link getLayoutInfo} are called.
   */ validate(invalidationContext) {}
    /**
   * Returns a {@link DragTarget} describing a view at the given point to be dragged.
   * Return `null` to cancel the drag. The default implementation returns the view at the given point.
   * @param point The point at which the drag occurred.
   */ // getDragTarget(point: Point): DragTarget | null {
    //   let target = this.virtualizer.keyAtPoint(point);
    //   if (!target) {
    //     return null;
    //   }
    //   return {
    //     type: 'item',
    //     key: target
    //   };
    // }
    /**
   * Returns a {@link DragTarget} object describing where a drop should occur. Return `null`
   * to reject the drop. The dropped items will be inserted before the resulting target.
   * @param point The point at which the drop occurred.
   */ // getDropTarget(point: Point): DropTarget | null {
    //   return null;
    // }
    /**
   * Returns the starting attributes for an animated insertion.
   * The view is animated from this {@link LayoutInfo} to the one returned by {@link getLayoutInfo}.
   * The default implementation just returns its input.
   *
   * @param layoutInfo The proposed LayoutInfo for this view.
   */ getInitialLayoutInfo(layoutInfo) {
        return layoutInfo;
    }
    /**
   * Returns the ending attributes for an animated removal.
   * The view is animated from the {@link LayoutInfo} returned by {@link getLayoutInfo}
   * to the one returned by this method. The default implementation returns its input.
   *
   * @param layoutInfo The original LayoutInfo for this view.
   */ getFinalLayoutInfo(layoutInfo) {
        return layoutInfo;
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"7HYyk":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Instances of this lightweight class are created by {@link Layout} subclasses
 * to represent each view in the {@link CollectionView}. LayoutInfo objects describe
 * various properties of a view, such as its position and size, and style information.
 * The collection view uses this information when creating actual views to display.
 */ parcelHelpers.export(exports, "LayoutInfo", ()=>LayoutInfo);
class LayoutInfo {
    /**
   * Returns a copy of the LayoutInfo.
   */ copy() {
        let res = new LayoutInfo(this.type, this.key, this.rect.copy());
        res.estimatedSize = this.estimatedSize;
        res.opacity = this.opacity;
        res.transform = this.transform;
        res.parentKey = this.parentKey;
        res.isSticky = this.isSticky;
        res.zIndex = this.zIndex;
        res.allowOverflow = this.allowOverflow;
        return res;
    }
    /**
   * @param type A string representing the view type. Should be `'item'` for item views.
                            Other types are used by supplementary views.
   * @param key The unique key for this view.
   * @param rect The rectangle describing the size and position of this view.
   */ constructor(type, key, rect){
        this.type = type;
        this.key = key;
        this.parentKey = null;
        this.rect = rect;
        this.estimatedSize = false;
        this.isSticky = false;
        this.opacity = 1;
        this.transform = null;
        this.zIndex = 0;
        this.allowOverflow = false;
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"awNGi":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Point", ()=>Point);
class Point {
    /**
   * Returns a copy of this point.
   */ copy() {
        return new Point(this.x, this.y);
    }
    /**
   * Checks if two points are equal.
   */ equals(point) {
        return this.x === point.x && this.y === point.y;
    }
    /**
   * Returns true if this point is the origin.
   */ isOrigin() {
        return this.x === 0 && this.y === 0;
    }
    constructor(x = 0, y = 0){
        this.x = x;
        this.y = y;
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"Fehec":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Represents a rectangle.
 */ parcelHelpers.export(exports, "Rect", ()=>Rect);
var _point = require("./Point");
class Rect {
    /**
   * The maximum x-coordinate in the rectangle.
   */ get maxX() {
        return this.x + this.width;
    }
    /**
   * The maximum y-coordinate in the rectangle.
   */ get maxY() {
        return this.y + this.height;
    }
    /**
   * The area of the rectangle.
   */ get area() {
        return this.width * this.height;
    }
    /**
   * The top left corner of the rectangle.
   */ get topLeft() {
        return new (0, _point.Point)(this.x, this.y);
    }
    /**
   * The top right corner of the rectangle.
   */ get topRight() {
        return new (0, _point.Point)(this.maxX, this.y);
    }
    /**
   * The bottom left corner of the rectangle.
   */ get bottomLeft() {
        return new (0, _point.Point)(this.x, this.maxY);
    }
    /**
   * The bottom right corner of the rectangle.
   */ get bottomRight() {
        return new (0, _point.Point)(this.maxX, this.maxY);
    }
    /**
   * Returns whether this rectangle intersects another rectangle.
   * @param rect - The rectangle to check.
   */ intersects(rect) {
        return this.x <= rect.x + rect.width && rect.x <= this.x + this.width && this.y <= rect.y + rect.height && rect.y <= this.y + this.height;
    }
    /**
   * Returns whether this rectangle fully contains another rectangle.
   * @param rect - The rectangle to check.
   */ containsRect(rect) {
        return this.x <= rect.x && this.y <= rect.y && this.maxX >= rect.maxX && this.maxY >= rect.maxY;
    }
    /**
   * Returns whether the rectangle contains the given point.
   * @param point - The point to check.
   */ containsPoint(point) {
        return this.x <= point.x && this.y <= point.y && this.maxX >= point.x && this.maxY >= point.y;
    }
    /**
   * Returns the first corner of this rectangle (from top to bottom, left to right)
   * that is contained in the given rectangle, or null of the rectangles do not intersect.
   * @param rect - The rectangle to check.
   */ getCornerInRect(rect) {
        for (let key of [
            "topLeft",
            "topRight",
            "bottomLeft",
            "bottomRight"
        ]){
            if (rect.containsPoint(this[key])) return key;
        }
        return null;
    }
    equals(rect) {
        return rect.x === this.x && rect.y === this.y && rect.width === this.width && rect.height === this.height;
    }
    pointEquals(point) {
        return this.x === point.x && this.y === point.y;
    }
    sizeEquals(size) {
        return this.width === size.width && this.height === size.height;
    }
    /**
   * Returns the union of this Rect and another.
   */ union(other) {
        let x = Math.min(this.x, other.x);
        let y = Math.min(this.y, other.y);
        let width = Math.max(this.maxX, other.maxX) - x;
        let height = Math.max(this.maxY, other.maxY) - y;
        return new Rect(x, y, width, height);
    }
    /**
   * Returns the intersection of this Rect with another.
   * If the rectangles do not intersect, an all zero Rect is returned.
   */ intersection(other) {
        if (!this.intersects(other)) return new Rect(0, 0, 0, 0);
        let x = Math.max(this.x, other.x);
        let y = Math.max(this.y, other.y);
        return new Rect(x, y, Math.min(this.maxX, other.maxX) - x, Math.min(this.maxY, other.maxY) - y);
    }
    /**
   * Returns a copy of this rectangle.
   */ copy() {
        return new Rect(this.x, this.y, this.width, this.height);
    }
    constructor(x = 0, y = 0, width = 0, height = 0){
        this.x = x;
        this.y = y;
        this.width = width;
        this.height = height;
    }
}

},{"./Point":"awNGi","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"3ogtw":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Size", ()=>Size);
class Size {
    /**
   * Returns a copy of this size.
   */ copy() {
        return new Size(this.width, this.height);
    }
    /**
   * Returns whether this size is equal to another one.
   */ equals(other) {
        return this.width === other.width && this.height === other.height;
    }
    /**
   * The total area of the Size.
   */ get area() {
        return this.width * this.height;
    }
    constructor(width = 0, height = 0){
        this.width = width;
        this.height = height;
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"dK1lU":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * [CollectionView]{@link CollectionView} creates instances of the [ReusableView]{@link ReusableView} class to
 * represent views currently being displayed. ReusableViews manage a DOM node, handle
 * applying {@link LayoutInfo} objects to the view, and render content
 * as needed. Subclasses must implement the {@link render} method at a
 * minimum. Other methods can be overridden to customize behavior.
 */ parcelHelpers.export(exports, "ReusableView", ()=>ReusableView);
let KEY = 0;
class ReusableView {
    /**
   * Prepares the view for reuse. Called just before the view is removed from the DOM.
   */ prepareForReuse() {
        this.content = null;
        this.rendered = null;
        this.layoutInfo = null;
    }
    constructor(virtualizer){
        this.virtualizer = virtualizer;
        this.key = ++KEY;
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"cfNH4":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useVirtualizerState", ()=>useVirtualizerState);
var _size = require("./Size");
var _react = require("react");
var _utils = require("@react-aria/utils");
var _virtualizer = require("./Virtualizer");
function useVirtualizerState(opts) {
    let [visibleViews, setVisibleViews] = (0, _react.useState)([]);
    let [contentSize, setContentSize] = (0, _react.useState)(new (0, _size.Size)());
    let [isAnimating, setAnimating] = (0, _react.useState)(false);
    let [isScrolling, setScrolling] = (0, _react.useState)(false);
    let virtualizer = (0, _react.useMemo)(()=>new (0, _virtualizer.Virtualizer)(), []);
    virtualizer.delegate = {
        setVisibleViews,
        setVisibleRect (rect) {
            virtualizer.visibleRect = rect;
            opts.onVisibleRectChange(rect);
        },
        setContentSize,
        renderView: opts.renderView,
        renderWrapper: opts.renderWrapper,
        beginAnimations: ()=>setAnimating(true),
        endAnimations: ()=>setAnimating(false),
        getScrollAnchor: opts.getScrollAnchor
    };
    virtualizer.layout = opts.layout;
    virtualizer.collection = opts.collection;
    virtualizer.transitionDuration = opts.transitionDuration;
    (0, _utils.useLayoutEffect)(()=>{
        virtualizer.afterRender();
    });
    // eslint-disable-next-line arrow-body-style
    (0, _react.useEffect)(()=>{
        return ()=>virtualizer.willUnmount();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let setVisibleRect = (0, _react.useCallback)((rect)=>{
        virtualizer.visibleRect = rect;
    }, [
        virtualizer
    ]);
    let startScrolling = (0, _react.useCallback)(()=>{
        virtualizer.startScrolling();
        setScrolling(true);
    }, [
        virtualizer
    ]);
    let endScrolling = (0, _react.useCallback)(()=>{
        virtualizer.endScrolling();
        setScrolling(false);
    }, [
        virtualizer
    ]);
    let state = (0, _react.useMemo)(()=>({
            virtualizer,
            visibleViews,
            setVisibleRect,
            contentSize,
            isAnimating,
            isScrolling,
            startScrolling,
            endScrolling
        }), [
        virtualizer,
        visibleViews,
        setVisibleRect,
        contentSize,
        isAnimating,
        isScrolling,
        startScrolling,
        endScrolling
    ]);
    return state;
}

},{"./Size":"3ogtw","react":"9yzVZ","@react-aria/utils":"9cLk5","./Virtualizer":"63v5l","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"63v5l":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The CollectionView class renders a scrollable collection of data using customizable layouts,
 * and manages animated updates to the data over time. It supports very large collections by
 * only rendering visible views to the DOM, reusing them as you scroll. Collection views can
 * present any type of view, including non-item views such as section headers and footers.
 * Optionally, the {@link EditableCollectionView} subclass can be used to enable user interaction
 * with the collection, including drag and drop, multiple selection, and keyboard interacton.
 *
 * Collection views get their data from a {@link DataSource} object that you provide. Items are
 * grouped into sections by the data source, and the collection view calls its methods to retrieve
 * the data. When data changes, the data source emits change events, and the collection view
 * updates as appropriate, optionally with an animated transition. There is one built-in data source
 * implementation, {@link ArrayDataSource}, which renders content from a 2d array.
 *
 * Collection views use {@link Layout} objects to compute what views should be visible, and how
 * to position and style them. This means that collection views can have their items arranged in
 * a stack, a grid, a circle, or any other layout you can think of. The layout can be changed
 * dynamically at runtime as well, optionally with an animated transition between the layouts.
 *
 * Layouts produce information on what views should appear in the collection view, but do not create
 * the views themselves directly. It is the responsibility of the {@link CollectionViewDelegate} object
 * to create instances of {@link ReusableView} subclasses which render the items into DOM nodes.
 * The delegate determines what type of view to display for each item, and creates instances of
 * views as needed by the collection view. Those views are then reused by the collection view as
 * the user scrolls through the content.
 */ parcelHelpers.export(exports, "Virtualizer", ()=>Virtualizer);
var _tween = require("./tween");
var _utils = require("./utils");
var _overscanManager = require("./OverscanManager");
var _point = require("./Point");
var _rect = require("./Rect");
var _reusableView = require("./ReusableView");
var _size = require("./Size");
var _transaction = require("./Transaction");
class Virtualizer {
    _setContentSize(size) {
        this._contentSize = size;
        this.delegate.setContentSize(size);
    }
    _setContentOffset(offset) {
        let rect = new (0, _rect.Rect)(offset.x, offset.y, this._visibleRect.width, this._visibleRect.height);
        this.delegate.setVisibleRect(rect);
    }
    /**
   * Get the size of the scrollable content.
   */ get contentSize() {
        return this._contentSize;
    }
    /**
   * Get the collection view's currently visible rectangle.
   */ get visibleRect() {
        return this._visibleRect;
    }
    /**
   * Set the collection view's currently visible rectangle.
   */ set visibleRect(rect) {
        this._setVisibleRect(rect);
    }
    _setVisibleRect(rect, forceUpdate = false) {
        let current = this._visibleRect;
        // Ignore if the rects are equal
        if (rect.equals(current)) return;
        if (this.shouldOverscan) this._overscanManager.setVisibleRect(rect);
        let shouldInvalidate = this.layout && this.layout.shouldInvalidate(rect, this._visibleRect);
        this._resetAnimatedContentOffset();
        this._visibleRect = rect;
        if (shouldInvalidate) // We are already in a layout effect when this method is called, so relayoutNow is appropriate.
        this.relayoutNow({
            offsetChanged: !rect.pointEquals(current),
            sizeChanged: !rect.sizeEquals(current)
        });
        else this.updateSubviews(forceUpdate);
    }
    get collection() {
        return this._collection;
    }
    set collection(data) {
        this._setData(data);
    }
    _setData(data) {
        if (data === this._collection) return;
        if (this._collection) this._runTransaction(()=>{
            this._collection = data;
        }, this.transitionDuration > 0);
        else {
            this._collection = data;
            this.reloadData();
        }
    }
    /**
   * Reloads the data from the data source and relayouts the collection view.
   * Does not animate any changes. Equivalent to re-assigning the same data source
   * to the collection view.
   */ reloadData() {
        this.relayout({
            contentChanged: true
        });
    }
    /**
   * Returns the item with the given key.
   */ getItem(key) {
        return this._collection ? this._collection.getItem(key) : null;
    }
    /** The set of persisted keys are always present in the DOM, even if not currently in view. */ get persistedKeys() {
        return this._persistedKeys;
    }
    /** The set of persisted keys are always present in the DOM, even if not currently in view. */ set persistedKeys(persistedKeys) {
        if (!(0, _utils.isSetEqual)(persistedKeys, this._persistedKeys)) {
            this._persistedKeys = persistedKeys;
            this.updateSubviews();
        }
    }
    /** Returns whether the given key, or an ancestor, is persisted. */ isPersistedKey(key) {
        // Quick check if the key is directly in the set of persisted keys.
        if (this._persistedKeys.has(key)) return true;
        // If not, check if the key is an ancestor of any of the persisted keys.
        for (let k of this._persistedKeys)while(k != null){
            let layoutInfo = this.layout.getLayoutInfo(k);
            if (!layoutInfo) break;
            k = layoutInfo.parentKey;
            if (k === key) return true;
        }
        return false;
    }
    /**
   * Get the collection view's layout.
   */ get layout() {
        return this._layout;
    }
    /**
   * Set the collection view's layout.
   */ set layout(layout) {
        this.setLayout(layout);
    }
    /**
   * Sets the collection view's layout, optionally with an animated transition
   * from the current layout to the new layout.
   * @param layout The layout to switch to.
   * @param animated Whether to animate the layout change.
   */ setLayout(layout, animated = false) {
        if (layout === this._layout) return;
        let applyLayout = ()=>{
            if (this._layout) // @ts-ignore
            this._layout.virtualizer = null;
            layout.virtualizer = this;
            this._layout = layout;
        };
        if (animated) // Animated layout transitions are really simple, thanks to our transaction support.
        // We just set the layout inside a transaction action, which runs after the initial
        // layout infos for the animation are retrieved from the previous layout. Then, the
        // final layout infos are retrieved from the new layout, and animations occur.
        this._runTransaction(applyLayout);
        else {
            applyLayout();
            this.relayout();
        }
    }
    _getReuseType(layoutInfo, content) {
        if (layoutInfo.type === "item" && content) {
            let type = this.delegate.getType ? this.delegate.getType(content) : "item";
            let reuseType = type === "item" ? "item" : layoutInfo.type + "_" + type;
            return {
                type,
                reuseType
            };
        }
        return {
            type: layoutInfo.type,
            reuseType: layoutInfo.type
        };
    }
    getReusableView(layoutInfo) {
        let content = this.getItem(layoutInfo.key);
        let { reuseType } = this._getReuseType(layoutInfo, content);
        if (!this._reusableViews[reuseType]) this._reusableViews[reuseType] = [];
        let reusable = this._reusableViews[reuseType];
        let view = reusable.length > 0 ? reusable.pop() : new (0, _reusableView.ReusableView)(this);
        view.viewType = reuseType;
        if (!this._animatedContentOffset.isOrigin()) {
            layoutInfo = layoutInfo.copy();
            layoutInfo.rect.x += this._animatedContentOffset.x;
            layoutInfo.rect.y += this._animatedContentOffset.y;
        }
        view.layoutInfo = layoutInfo;
        this._renderView(view);
        return view;
    }
    _renderView(reusableView) {
        let { type, key } = reusableView.layoutInfo;
        reusableView.content = this.getItem(key);
        reusableView.rendered = this._renderContent(type, reusableView.content);
    }
    _renderContent(type, content) {
        let cached = this._renderedContent.get(content);
        if (cached != null) return cached;
        let rendered = this.delegate.renderView(type, content);
        if (content) this._renderedContent.set(content, rendered);
        return rendered;
    }
    /**
   * Returns an array of all currently visible views, including both
   * item views and supplementary views.
   */ get visibleViews() {
        return Array.from(this._visibleViews.values());
    }
    /**
   * Gets the visible view for the given type and key. Returns null if
   * the view is not currently visible.
   *
   * @param key The key of the view to retrieve.
   */ getView(key) {
        return this._visibleViews.get(key) || null;
    }
    /**
   * Returns an array of visible views matching the given type.
   * @param type The view type to find.
   */ getViewsOfType(type) {
        return this.visibleViews.filter((v)=>v.layoutInfo && v.layoutInfo.type === type);
    }
    /**
   * Returns the key for the given view. Returns null
   * if the view is not currently visible.
   */ keyForView(view) {
        if (view && view.layoutInfo) return view.layoutInfo.key;
        return null;
    }
    /**
   * Returns the key for the item view currently at the given point.
   */ keyAtPoint(point) {
        let rect = new (0, _rect.Rect)(point.x, point.y, 1, 1);
        let layoutInfos = this.layout.getVisibleLayoutInfos(rect);
        // Layout may return multiple layout infos in the case of
        // persisted keys, so find the first one that actually intersects.
        for (let layoutInfo of layoutInfos){
            if (layoutInfo.rect.intersects(rect)) return layoutInfo.key;
        }
        return null;
    }
    /**
   * Cleanup for when the Virtualizer will be unmounted.
   */ willUnmount() {
        cancelAnimationFrame(this._relayoutRaf);
    }
    /**
   * Triggers a layout invalidation, and updates the visible subviews.
   */ relayout(context = {}) {
        // Ignore relayouts while animating the scroll position
        if (this._scrollAnimation || typeof requestAnimationFrame === "undefined") return;
        // If we already scheduled a relayout, extend the invalidation
        // context so we coalesce multiple relayouts in the same frame.
        if (this._invalidationContext) {
            Object.assign(this._invalidationContext, context);
            return;
        }
        this._invalidationContext = context;
    }
    /**
   * Performs a relayout immediately. Prefer {@link relayout} over this method
   * where possible, since it coalesces multiple layout passes in the same tick.
   */ relayoutNow(context = this._invalidationContext || {}) {
        // Cancel the scheduled relayout, since we're doing it now.
        if (this._relayoutRaf) {
            cancelAnimationFrame(this._relayoutRaf);
            this._relayoutRaf = null;
            // Update the provided context with the current invalidationContext since we are cancelling
            // a scheduled relayoutNow call that has this._invalidationContext set as its default context arg (relayoutNow() in relayout)
            context = {
                ...this._invalidationContext,
                ...context
            };
        }
        // Reset the invalidation context
        this._invalidationContext = null;
        // Do nothing if we don't have a layout or content, or we are
        // in the middle of an animated scroll transition.
        if (!this.layout || !this._collection || this._scrollAnimation) return;
        let scrollAnchor = this._getScrollAnchor();
        // Trigger the beforeLayout hook, if provided
        if (typeof context.beforeLayout === "function") context.beforeLayout();
        // Validate the layout
        this.layout.validate(context);
        this._setContentSize(this.layout.getContentSize());
        // Trigger the afterLayout hook, if provided
        if (typeof context.afterLayout === "function") context.afterLayout();
        // Adjust scroll position based on scroll anchor, and constrain.
        // If the content changed, scroll to the top.
        let visibleRect = this.getVisibleRect();
        let restoredScrollAnchor = this._restoreScrollAnchor(scrollAnchor, context);
        let contentOffsetX = context.contentChanged ? 0 : restoredScrollAnchor.x;
        let contentOffsetY = context.contentChanged ? 0 : restoredScrollAnchor.y;
        contentOffsetX = Math.max(0, Math.min(this.contentSize.width - visibleRect.width, contentOffsetX));
        contentOffsetY = Math.max(0, Math.min(this.contentSize.height - visibleRect.height, contentOffsetY));
        let hasLayoutUpdates = false;
        if (contentOffsetX !== visibleRect.x || contentOffsetY !== visibleRect.y) {
            // If this is an animated relayout, we do not immediately scroll because it would be jittery.
            // Save the difference between the current and new content offsets, and apply it to the
            // individual content items instead. At the end of the animation, we'll reset and set the
            // scroll offset for real. This ensures jitter-free animation since we don't need to sync
            // the scroll animation and the content animation.
            if (context.animated || !this._animatedContentOffset.isOrigin()) {
                this._animatedContentOffset.x += visibleRect.x - contentOffsetX;
                this._animatedContentOffset.y += visibleRect.y - contentOffsetY;
                hasLayoutUpdates = this.updateSubviews(context.contentChanged);
            } else this._setContentOffset(new (0, _point.Point)(contentOffsetX, contentOffsetY));
        } else hasLayoutUpdates = this.updateSubviews(context.contentChanged);
        // Apply layout infos, unless this is coming from an animated transaction
        if (!(context.transaction && context.animated)) this._applyLayoutInfos();
        // Wait for animations, and apply the afterAnimation hook, if provided
        if (context.animated && hasLayoutUpdates) {
            this._enableTransitions();
            let done = ()=>{
                this._disableTransitions();
                // Reset scroll position after animations (see above comment).
                if (!this._animatedContentOffset.isOrigin()) {
                    // Get the content offset to scroll to, taking _animatedContentOffset into account.
                    let { x, y } = this.getVisibleRect();
                    this._resetAnimatedContentOffset();
                    this._setContentOffset(new (0, _point.Point)(x, y));
                }
                if (typeof context.afterAnimation === "function") context.afterAnimation();
            };
            // Sometimes the animation takes slightly longer than expected.
            setTimeout(done, this.transitionDuration + 100);
            return;
        } else if (typeof context.afterAnimation === "function") context.afterAnimation();
    }
    /**
   * Corrects DOM order of visible views to match item order of collection.
   */ _correctItemOrder() {
        // Defer until after scrolling and animated transactions are complete
        if (this._isScrolling || this._transaction) return;
        for (let key of this._visibleLayoutInfos.keys()){
            let view = this._visibleViews.get(key);
            this._children.delete(view);
            this._children.add(view);
        }
    }
    _enableTransitions() {
        this.delegate.beginAnimations();
    }
    _disableTransitions() {
        this.delegate.endAnimations();
    }
    _getScrollAnchor() {
        if (!this.anchorScrollPosition) return null;
        let visibleRect = this.getVisibleRect();
        // Ask the delegate to provide a scroll anchor, if possible
        if (this.delegate.getScrollAnchor) {
            let key = this.delegate.getScrollAnchor(visibleRect);
            if (key != null) {
                let layoutInfo = this.layout.getLayoutInfo(key);
                let corner = layoutInfo.rect.getCornerInRect(visibleRect);
                if (corner) {
                    let key = layoutInfo.key;
                    let offset = layoutInfo.rect[corner].y - visibleRect.y;
                    return {
                        key,
                        layoutInfo,
                        corner,
                        offset
                    };
                }
            }
        }
        // No need to anchor the scroll position if it is at the top
        if (visibleRect.y === 0 && !this.anchorScrollPositionAtTop) return null;
        // Find a view with a visible corner that has the smallest distance to the top of the collection view
        let cornerAnchor = null;
        for (let [key, view] of this._visibleViews){
            let layoutInfo = view.layoutInfo;
            if (layoutInfo && layoutInfo.rect.area > 0) {
                let corner = layoutInfo.rect.getCornerInRect(visibleRect);
                if (corner) {
                    let offset = layoutInfo.rect[corner].y - visibleRect.y;
                    if (!cornerAnchor || offset < cornerAnchor.offset) cornerAnchor = {
                        key,
                        layoutInfo,
                        corner,
                        offset
                    };
                }
            }
        }
        return cornerAnchor;
    }
    _restoreScrollAnchor(scrollAnchor, context) {
        let contentOffset = this.getVisibleRect();
        if (scrollAnchor) {
            var _context_transaction;
            let finalAnchor = ((_context_transaction = context.transaction) === null || _context_transaction === void 0 ? void 0 : _context_transaction.animated) ? context.transaction.finalMap.get(scrollAnchor.key) : this.layout.getLayoutInfo(scrollAnchor.layoutInfo.key);
            if (finalAnchor) {
                let adjustment = finalAnchor.rect[scrollAnchor.corner].y - contentOffset.y - scrollAnchor.offset;
                contentOffset.y += adjustment;
            }
        }
        return contentOffset;
    }
    getVisibleRect() {
        let v = this.visibleRect;
        let x = v.x - this._animatedContentOffset.x;
        let y = v.y - this._animatedContentOffset.y;
        return new (0, _rect.Rect)(x, y, v.width, v.height);
    }
    getVisibleLayoutInfos() {
        let isTestEnv = false;
        let isClientWidthMocked = Object.getOwnPropertyNames(window.HTMLElement.prototype).includes("clientWidth");
        let isClientHeightMocked = Object.getOwnPropertyNames(window.HTMLElement.prototype).includes("clientHeight");
        let rect;
        if (isTestEnv && !(isClientWidthMocked && isClientHeightMocked)) rect = this._getContentRect();
        else rect = this.shouldOverscan ? this._overscanManager.getOverscannedRect() : this.getVisibleRect();
        this._visibleLayoutInfos = this._getLayoutInfoMap(rect);
        return this._visibleLayoutInfos;
    }
    _getLayoutInfoMap(rect, copy = false) {
        let layoutInfos = this.layout.getVisibleLayoutInfos(rect);
        let map = new Map;
        for (let layoutInfo of layoutInfos){
            if (copy) layoutInfo = layoutInfo.copy();
            map.set(layoutInfo.key, layoutInfo);
        }
        return map;
    }
    updateSubviews(forceUpdate = false) {
        if (!this._collection) return;
        let visibleLayoutInfos = this.getVisibleLayoutInfos();
        let currentlyVisible = this._visibleViews;
        let toAdd, toRemove, toUpdate;
        // If this is a force update, remove and re-add all views.
        // Otherwise, find and update the diff.
        if (forceUpdate) {
            toAdd = visibleLayoutInfos;
            toRemove = currentlyVisible;
            toUpdate = new Set();
        } else {
            ({ toAdd, toRemove, toUpdate } = (0, _utils.difference)(currentlyVisible, visibleLayoutInfos));
            for (let key of toUpdate){
                let view = currentlyVisible.get(key);
                if (!view || !view.layoutInfo) continue;
                let item = this.getItem(visibleLayoutInfos.get(key).key);
                if (view.content === item) toUpdate.delete(key);
                else {
                    // If the view type changes, delete and recreate the view instead of updating
                    let { reuseType } = this._getReuseType(view.layoutInfo, item);
                    if (view.viewType !== reuseType) {
                        toUpdate.delete(key);
                        toAdd.add(key);
                        toRemove.add(key);
                    }
                }
            }
            // We are done if the sets are equal
            if (toAdd.size === 0 && toRemove.size === 0 && toUpdate.size === 0) {
                if (this._transaction) this._applyLayoutInfos();
                return;
            }
        }
        // Track views that should be removed. They are not removed from
        // the DOM immediately, since we may reuse and need to re-insert
        // them back into the DOM anyway.
        let removed = new Set();
        for (let key of toRemove.keys()){
            let view = this._visibleViews.get(key);
            if (view) {
                removed.add(view);
                this._visibleViews.delete(key);
                // If we are in the middle of a transaction, wait until the end
                // of the animations to remove the views from the DOM. Also means
                // we can't reuse those views immediately.
                if (this._transaction) this._transaction.toRemove.set(key, view);
                else this.reuseView(view);
            }
        }
        for (let key of toAdd.keys()){
            let layoutInfo = visibleLayoutInfos.get(key);
            let view;
            // If we're in a transaction, and a layout change happens
            // during the animations such that a view that was going
            // to be removed is now not, we don't create a new view
            // since the old one is still in the DOM, marked as toRemove.
            if (this._transaction) {
                // if transaction, get initial layout attributes for the animation
                if (this._transaction.initialLayoutInfo.has(key)) layoutInfo = this._transaction.initialLayoutInfo.get(key);
                view = this._transaction.toRemove.get(key);
                if (view) {
                    this._transaction.toRemove.delete(key);
                    this._applyLayoutInfo(view, layoutInfo);
                }
            }
            if (!view) {
                // Create or reuse a view for this row
                view = this.getReusableView(layoutInfo);
                // Add the view to the DOM if needed
                if (!removed.has(view)) this._children.add(view);
            }
            this._visibleViews.set(key, view);
            removed.delete(view);
        }
        for (let key of toUpdate){
            let view = currentlyVisible.get(key);
            this._renderedContent.delete(key);
            this._renderView(view);
        }
        // Remove the remaining rows to delete from the DOM
        if (!this._transaction) this.removeViews(removed);
        this._correctItemOrder();
        this._flushVisibleViews();
        let hasLayoutUpdates = this._transaction && (toAdd.size > 0 || toRemove.size > 0 || this._hasLayoutUpdates());
        if (hasLayoutUpdates) requestAnimationFrame(()=>{
            // If we're in a transaction, apply animations to visible views
            // and "to be removed" views, which animate off screen.
            if (this._transaction) requestAnimationFrame(()=>this._applyLayoutInfos());
        });
        return hasLayoutUpdates;
    }
    afterRender() {
        if (this._transactionQueue.length > 0) this._processTransactionQueue();
        else if (this._invalidationContext) this.relayoutNow();
        if (this.shouldOverscan) this._overscanManager.collectMetrics();
    }
    _flushVisibleViews() {
        // CollectionVirtualizer deals with a flattened set of LayoutInfos, but they can represent hierarchy
        // by referencing a parentKey. Just before rendering the visible views, we rebuild this hierarchy
        // by creating a mapping of views by parent key and recursively calling the delegate's renderWrapper
        // method to build the final tree.
        let viewsByParentKey = new Map([
            [
                null,
                []
            ]
        ]);
        for (let view of this._children){
            var _view_layoutInfo, _viewsByParentKey_get, _view_layoutInfo1, _view_layoutInfo2, _view_layoutInfo3;
            if (((_view_layoutInfo = view.layoutInfo) === null || _view_layoutInfo === void 0 ? void 0 : _view_layoutInfo.parentKey) != null && !viewsByParentKey.has(view.layoutInfo.parentKey)) viewsByParentKey.set(view.layoutInfo.parentKey, []);
            (_viewsByParentKey_get = viewsByParentKey.get((_view_layoutInfo1 = view.layoutInfo) === null || _view_layoutInfo1 === void 0 ? void 0 : _view_layoutInfo1.parentKey)) === null || _viewsByParentKey_get === void 0 ? void 0 : _viewsByParentKey_get.push(view);
            if (!viewsByParentKey.has((_view_layoutInfo2 = view.layoutInfo) === null || _view_layoutInfo2 === void 0 ? void 0 : _view_layoutInfo2.key)) viewsByParentKey.set((_view_layoutInfo3 = view.layoutInfo) === null || _view_layoutInfo3 === void 0 ? void 0 : _view_layoutInfo3.key, []);
        }
        let buildTree = (parent, views)=>views.map((view)=>{
                let children = viewsByParentKey.get(view.layoutInfo.key);
                return this.delegate.renderWrapper(parent, view, children, (childViews)=>buildTree(view, childViews));
            });
        let children = buildTree(null, viewsByParentKey.get(null));
        this.delegate.setVisibleViews(children);
    }
    _applyLayoutInfo(view, layoutInfo) {
        if (view.layoutInfo === layoutInfo) return false;
        view.layoutInfo = layoutInfo;
        return true;
    }
    _applyLayoutInfos() {
        let updated = false;
        // Apply layout infos to visible views
        for (let view of this._visibleViews.values()){
            let cur = view.layoutInfo;
            if ((cur === null || cur === void 0 ? void 0 : cur.key) != null) {
                let layoutInfo = this.layout.getLayoutInfo(cur.key);
                if (this._applyLayoutInfo(view, layoutInfo)) updated = true;
            }
        }
        // Apply final layout infos for views that will be removed
        if (this._transaction) {
            for (let view of this._transaction.toRemove.values()){
                let cur = view.layoutInfo;
                if ((cur === null || cur === void 0 ? void 0 : cur.key) != null) {
                    let layoutInfo = this.layout.getLayoutInfo(cur.key);
                    if (this._applyLayoutInfo(view, layoutInfo)) updated = true;
                }
            }
            for (let view of this._transaction.removed.values()){
                let cur = view.layoutInfo;
                let layoutInfo = this._transaction.finalLayoutInfo.get(cur.key) || cur;
                layoutInfo = this.layout.getFinalLayoutInfo(layoutInfo.copy());
                if (this._applyLayoutInfo(view, layoutInfo)) updated = true;
            }
        }
        if (updated) this._flushVisibleViews();
    }
    _hasLayoutUpdates() {
        if (!this._transaction) return false;
        for (let view of this._visibleViews.values()){
            let cur = view.layoutInfo;
            if (!cur) return true;
            let layoutInfo = this.layout.getLayoutInfo(cur.key);
            if (// Uses equals rather than pointEquals so that width/height changes are taken into account
            !cur.rect.equals(layoutInfo.rect) || cur.opacity !== layoutInfo.opacity || cur.transform !== layoutInfo.transform) return true;
        }
        return false;
    }
    reuseView(view) {
        view.prepareForReuse();
        this._reusableViews[view.viewType].push(view);
    }
    removeViews(toRemove) {
        for (let view of toRemove)this._children.delete(view);
    }
    updateItemSize(key, size) {
        // TODO: we should be able to invalidate a single index path
        // @ts-ignore
        if (!this.layout.updateItemSize) return;
        // If the scroll position is currently animating, add the update
        // to a queue to be processed after the animation is complete.
        if (this._scrollAnimation) {
            this._sizeUpdateQueue.set(key, size);
            return;
        }
        // @ts-ignore
        let changed = this.layout.updateItemSize(key, size);
        if (changed) this.relayout();
    }
    startScrolling() {
        this._isScrolling = true;
    }
    endScrolling() {
        this._isScrolling = false;
        this._correctItemOrder();
        this._flushVisibleViews();
    }
    _resetAnimatedContentOffset() {
        // Reset the animated content offset of subviews. See comment in relayoutNow for details.
        if (!this._animatedContentOffset.isOrigin()) {
            this._animatedContentOffset = new (0, _point.Point)(0, 0);
            this._applyLayoutInfos();
        }
    }
    /**
   * Scrolls the item with the given key into view, optionally with an animation.
   * @param key The key of the item to scroll into view.
   * @param duration The duration of the scroll animation.
   */ scrollToItem(key, options) {
        // key can be 0, so check if null or undefined
        if (key == null) return;
        let layoutInfo = this.layout.getLayoutInfo(key);
        if (!layoutInfo) return;
        let { duration = 300, shouldScrollX = true, shouldScrollY = true, offsetX = 0, offsetY = 0 } = options;
        let x = this.visibleRect.x;
        let y = this.visibleRect.y;
        let minX = layoutInfo.rect.x - offsetX;
        let minY = layoutInfo.rect.y - offsetY;
        let maxX = x + this.visibleRect.width;
        let maxY = y + this.visibleRect.height;
        if (shouldScrollX) {
            if (minX <= x || maxX === 0) x = minX;
            else if (layoutInfo.rect.maxX > maxX) x += layoutInfo.rect.maxX - maxX;
        }
        if (shouldScrollY) {
            if (minY <= y || maxY === 0) y = minY;
            else if (layoutInfo.rect.maxY > maxY) y += layoutInfo.rect.maxY - maxY;
        }
        return this.scrollTo(new (0, _point.Point)(x, y), duration);
    }
    /**
   * Performs an animated scroll to the given offset.
   * @param offset - The offset to scroll to.
   * @param duration The duration of the animation.
   * @returns A promise that resolves when the animation is complete.
   */ scrollTo(offset, duration = 300) {
        // Cancel the current scroll animation
        if (this._scrollAnimation) {
            this._scrollAnimation.cancel();
            this._scrollAnimation = null;
        }
        // Set the content offset synchronously if the duration is zero
        if (duration <= 0 || this.visibleRect.pointEquals(offset)) {
            this._setContentOffset(offset);
            return Promise.resolve();
        }
        this.startScrolling();
        this._scrollAnimation = (0, _tween.tween)(this.visibleRect, offset, duration, (0, _tween.easeOut), (offset)=>{
            this._setContentOffset(offset);
        });
        this._scrollAnimation.then(()=>{
            this._scrollAnimation = null;
            // Process view size updates that occurred during the animation.
            // Only views that are still visible will be actually updated.
            for (let [key, size] of this._sizeUpdateQueue)this.updateItemSize(key, size);
            this._sizeUpdateQueue.clear();
            this.relayout();
            this._processTransactionQueue();
            this.endScrolling();
        });
        return this._scrollAnimation;
    }
    _runTransaction(action, animated) {
        this._startTransaction();
        if (this._nextTransaction) this._nextTransaction.actions.push(action);
        this._endTransaction(animated);
    }
    _startTransaction() {
        if (!this._nextTransaction) this._nextTransaction = new (0, _transaction.Transaction);
        this._nextTransaction.level++;
    }
    _endTransaction(animated) {
        if (!this._nextTransaction) return false;
        // Save whether the transaction should be animated.
        if (animated != null) this._nextTransaction.animated = animated;
        // If we haven't reached level 0, we are still in a
        // nested transaction. Wait for the parent to end.
        if (--this._nextTransaction.level > 0) return false;
        // Do nothing for empty transactions
        if (this._nextTransaction.actions.length === 0) {
            this._nextTransaction = null;
            return false;
        }
        // Default animations to true
        if (this._nextTransaction.animated == null) this._nextTransaction.animated = true;
        // Enqueue the transaction
        this._transactionQueue.push(this._nextTransaction);
        this._nextTransaction = null;
        return true;
    }
    _processTransactionQueue() {
        // If the current transaction is animating, wait until the end
        // to process the next transaction.
        if (this._transaction || this._scrollAnimation) return;
        let next = this._transactionQueue.shift();
        if (next) this._performTransaction(next);
    }
    _getContentRect() {
        return new (0, _rect.Rect)(0, 0, this.contentSize.width, this.contentSize.height);
    }
    _performTransaction(transaction) {
        this._transaction = transaction;
        this.relayoutNow({
            transaction: transaction,
            animated: transaction.animated,
            beforeLayout: ()=>{
                // Get the initial layout infos for all views before the updates
                // so we can figure out which views to add and remove.
                if (transaction.animated) transaction.initialMap = this._getLayoutInfoMap(this._getContentRect(), true);
                // Apply the actions that occurred during this transaction
                for (let action of transaction.actions)action();
            },
            afterLayout: ()=>{
                // Get the final layout infos after the updates
                if (transaction.animated) {
                    transaction.finalMap = this._getLayoutInfoMap(this._getContentRect());
                    this._setupTransactionAnimations(transaction);
                } else this._transaction = null;
            },
            afterAnimation: ()=>{
                // Remove and reuse views when animations are done
                if (transaction.toRemove.size > 0 || transaction.removed.size > 0) for (let view of (0, _utils.concatIterators)(transaction.toRemove.values(), transaction.removed.values())){
                    this._children.delete(view);
                    this.reuseView(view);
                }
                this._transaction = null;
                // Ensure DOM order is correct for accessibility after animations are complete
                this._correctItemOrder();
                this._flushVisibleViews();
                this._processTransactionQueue();
            }
        });
    }
    _setupTransactionAnimations(transaction) {
        let { initialMap, finalMap } = transaction;
        // Store initial and final layout infos for animations
        for (let [key, layoutInfo] of initialMap)if (finalMap.has(key)) // Store the initial layout info for use during animations.
        transaction.initialLayoutInfo.set(key, layoutInfo);
        else // This view was removed. Store the layout info for use
        // in Layout#getFinalLayoutInfo during animations.
        transaction.finalLayoutInfo.set(layoutInfo.key, layoutInfo);
        // Get initial layout infos for views that were added
        for (let [key, layoutInfo] of finalMap)if (!initialMap.has(key)) {
            let initialLayoutInfo = this.layout.getInitialLayoutInfo(layoutInfo.copy());
            transaction.initialLayoutInfo.set(key, initialLayoutInfo);
        }
        // Figure out which views were removed.
        for (let [key, view] of this._visibleViews)// If an item has a width of 0, there is no need to remove it from the _visibleViews.
        // Removing an item with  width of 0 can cause a loop where the item gets added, removed,
        // added, removed... etc in a loop.
        if (!finalMap.has(key) && view.layoutInfo.rect.width > 0) {
            transaction.removed.set(key, view);
            this._visibleViews.delete(key);
            // In case something weird happened, where we have a view but no
            // initial layout info, use the one attached to the view.
            if (view.layoutInfo) {
                if (!transaction.finalLayoutInfo.has(view.layoutInfo.key)) transaction.finalLayoutInfo.set(view.layoutInfo.key, view.layoutInfo);
            }
        }
    }
    constructor(options = {}){
        this._contentSize = new (0, _size.Size);
        this._visibleRect = new (0, _rect.Rect);
        this._reusableViews = {};
        this._visibleLayoutInfos = new Map();
        this._visibleViews = new Map();
        this._renderedContent = new WeakMap();
        this._children = new Set();
        this._invalidationContext = null;
        this._overscanManager = new (0, _overscanManager.OverscanManager)();
        this._persistedKeys = new Set();
        this._scrollAnimation = null;
        this._isScrolling = false;
        this._sizeUpdateQueue = new Map();
        this._animatedContentOffset = new (0, _point.Point)(0, 0);
        this._transaction = null;
        this._nextTransaction = null;
        this._transactionQueue = [];
        var _options_transitionDuration;
        // Set options from passed object if given
        this.transitionDuration = (_options_transitionDuration = options.transitionDuration) !== null && _options_transitionDuration !== void 0 ? _options_transitionDuration : 500;
        this.anchorScrollPosition = options.anchorScrollPosition || false;
        this.anchorScrollPositionAtTop = options.anchorScrollPositionAtTop || false;
        this.shouldOverscan = options.shouldOverscan !== false;
        for (let key of [
            "delegate",
            "size",
            "layout",
            "collection"
        ])if (options[key]) this[key] = options[key];
    }
}

},{"./tween":"a2bMm","./utils":"eTyt2","./OverscanManager":"4vsmo","./Point":"awNGi","./Rect":"Fehec","./ReusableView":"dK1lU","./Size":"3ogtw","./Transaction":"i4JPG","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"a2bMm":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "tween", ()=>tween);
// easing functions
parcelHelpers.export(exports, "linearEasing", ()=>linearEasing);
parcelHelpers.export(exports, "easeOut", ()=>easeOut);
var _point = require("./Point");
// use high res timer if available
let perf = typeof window !== "undefined" ? window.performance : null;
// @ts-ignore
let perfNow = perf && (perf.now || perf.webkitNow || perf.msNow || perf.mozNow);
let getTime = perfNow ? perfNow.bind(perf) : function() {
    return Date.now ? Date.now() : new Date().getTime();
};
let fixTs;
function tween(begin, end, duration, ease, fn) {
    let canceled = false;
    let raf_id;
    let promise = new Promise((resolve)=>{
        let start = getTime();
        let diffX = end.x - begin.x;
        let diffY = end.y - begin.y;
        raf_id = requestAnimationFrame(function run(t) {
            // if we're using a high res timer, make sure timestamp is not the old epoch-based value.
            // http://updates.html5rocks.com/2012/05/requestAnimationFrame-API-now-with-sub-millisecond-precision
            if (fixTs == null) fixTs = t > 1e12 !== getTime() > 1e12;
            if (fixTs) t = getTime();
            // check if we're done
            let delta = t - start;
            if (delta > duration) {
                fn(end);
                resolve();
            } else {
                // call frame callback after computing eased time and get the next frame
                let proceed = fn(new (0, _point.Point)(begin.x + diffX * ease(delta / duration), begin.y + diffY * ease(delta / duration)));
                if (proceed !== false && !canceled) raf_id = requestAnimationFrame(run);
            }
        });
    });
    promise.cancel = function() {
        canceled = true;
        cancelAnimationFrame(raf_id);
    };
    return promise;
}
function linearEasing(t) {
    return t;
}
function easeOut(t) {
    return Math.sin(t * Math.PI / 2);
}

},{"./Point":"awNGi","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"eTyt2":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "keyDiff", ()=>keyDiff);
/**
 * Returns the key difference between two maps. Returns a set of
 * keys to add to and remove from a to make it equal to b.
 * @private
 */ parcelHelpers.export(exports, "difference", ()=>difference);
/**
 * Returns an iterator that yields the items in all of the given iterators.
 * @private
 */ parcelHelpers.export(exports, "concatIterators", ()=>concatIterators);
/**
 * Inverts the keys and values of an object.
 * @private
 */ parcelHelpers.export(exports, "invert", ()=>invert);
/** Returns whether two sets are equal. */ parcelHelpers.export(exports, "isSetEqual", ()=>isSetEqual);
function keyDiff(a, b) {
    let res = new Set();
    for (let key of a.keys())if (!b.has(key)) res.add(key);
    return res;
}
function difference(a, b) {
    let toRemove = keyDiff(a, b);
    let toAdd = keyDiff(b, a);
    let toUpdate = new Set;
    for (let key of a.keys())if (b.has(key)) toUpdate.add(key);
    return {
        toRemove,
        toAdd,
        toUpdate
    };
}
function* concatIterators(...iterators) {
    for (let iterator of iterators)yield* iterator;
}
function invert(object) {
    let res = {};
    for(let key in object)res[object[key]] = key;
    return res;
}
function isSetEqual(a, b) {
    if (a === b) return true;
    if (a.size !== b.size) return false;
    for (let key of a){
        if (!b.has(key)) return false;
    }
    return true;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"4vsmo":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "OverscanManager", ()=>OverscanManager);
var _point = require("./Point");
var _rect = require("./Rect");
class RollingAverage {
    addSample(sample) {
        this.count++;
        this.value += (sample - this.value) / this.count;
    }
    constructor(){
        this.count = 0;
        this.value = 0;
    }
}
class OverscanManager {
    setVisibleRect(rect) {
        let time = performance.now() - this.startTime;
        if (time < 500) {
            this.averageTime.addSample(time);
            if (rect.x !== this.visibleRect.x && time > 0) this.velocity.x = (rect.x - this.visibleRect.x) / time;
            if (rect.y !== this.visibleRect.y && time > 0) this.velocity.y = (rect.y - this.visibleRect.y) / time;
        }
        this.startTime = performance.now();
        this.visibleRect = rect;
    }
    collectMetrics() {
        let time = performance.now() - this.startTime;
        if (time < 500) this.averagePerf.addSample(time);
        if (this.visibleRect.height > 0) {
            let o = Math.abs(this.velocity.y * (this.averageTime.value + this.averagePerf.value));
            this.overscanY.addSample(o);
        }
        if (this.visibleRect.width > 0) {
            let o = Math.abs(this.velocity.x * (this.averageTime.value + this.averagePerf.value));
            this.overscanX.addSample(o);
        }
    }
    getOverscannedRect() {
        let overscanned = this.visibleRect.copy();
        let overscanY = Math.round(Math.min(this.visibleRect.height * 2, this.overscanY.value) / 100) * 100;
        if (this.velocity.y > 0) {
            overscanned.y -= overscanY * 0.2;
            overscanned.height += overscanY + overscanY * 0.2;
        } else {
            overscanned.y -= overscanY;
            overscanned.height += overscanY + overscanY * 0.2;
        }
        let overscanX = Math.round(Math.min(this.visibleRect.width * 2, this.overscanX.value) / 100) * 100;
        if (this.velocity.x > 0) {
            overscanned.x -= overscanX * 0.2;
            overscanned.width += overscanX + overscanX * 0.2;
        } else {
            overscanned.x -= overscanX;
            overscanned.width += overscanX + overscanX * 0.2;
        }
        return overscanned;
    }
    constructor(){
        this.startTime = 0;
        this.averagePerf = new RollingAverage();
        this.averageTime = new RollingAverage();
        this.velocity = new (0, _point.Point)(5, 5);
        this.overscanX = new RollingAverage();
        this.overscanY = new RollingAverage();
        this.visibleRect = new (0, _rect.Rect)();
    }
}

},{"./Point":"awNGi","./Rect":"Fehec","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"i4JPG":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Transaction", ()=>Transaction);
class Transaction {
    constructor(){
        this.level = 0;
        this.actions = [];
        this.animated = true;
        this.initialMap = new Map();
        this.finalMap = new Map();
        this.initialLayoutInfo = new Map();
        this.finalLayoutInfo = new Map();
        this.removed = new Map();
        this.toRemove = new Map();
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"9heg9":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides the behavior and accessibility implementation for a grid component.
 * A grid displays data in one or more rows and columns and enables a user to navigate its contents via directional navigation keys.
 * @param props - Props for the grid.
 * @param state - State for the grid, as returned by `useGridState`.
 * @param ref - The ref attached to the grid element.
 */ parcelHelpers.export(exports, "useGrid", ()=>useGrid);
var _utils = require("@react-aria/utils");
var _gridKeyboardDelegate = require("./GridKeyboardDelegate");
var _utils1 = require("./utils");
var _react = require("react");
var _i18N = require("@react-aria/i18n");
var _useGridSelectionAnnouncement = require("./useGridSelectionAnnouncement");
var _focus = require("@react-aria/focus");
var _useHighlightSelectionDescription = require("./useHighlightSelectionDescription");
var _selection = require("@react-aria/selection");
function useGrid(props, state, ref) {
    let { isVirtualized, keyboardDelegate, focusMode, scrollRef, getRowText, onRowAction, onCellAction } = props;
    let { selectionManager: manager } = state;
    if (!props["aria-label"] && !props["aria-labelledby"]) console.warn("An aria-label or aria-labelledby prop is required for accessibility.");
    // By default, a KeyboardDelegate is provided which uses the DOM to query layout information (e.g. for page up/page down).
    // When virtualized, the layout object will be passed in as a prop and override this.
    let collator = (0, _i18N.useCollator)({
        usage: "search",
        sensitivity: "base"
    });
    let { direction } = (0, _i18N.useLocale)();
    let disabledBehavior = state.selectionManager.disabledBehavior;
    let delegate = (0, _react.useMemo)(()=>keyboardDelegate || new (0, _gridKeyboardDelegate.GridKeyboardDelegate)({
            collection: state.collection,
            disabledKeys: disabledBehavior === "selection" ? new Set() : state.disabledKeys,
            ref,
            direction,
            collator,
            focusMode
        }), [
        keyboardDelegate,
        state.collection,
        state.disabledKeys,
        disabledBehavior,
        ref,
        direction,
        collator,
        focusMode
    ]);
    let { collectionProps } = (0, _selection.useSelectableCollection)({
        ref,
        selectionManager: manager,
        keyboardDelegate: delegate,
        isVirtualized,
        scrollRef
    });
    let id = (0, _utils.useId)(props.id);
    (0, _utils1.gridMap).set(state, {
        keyboardDelegate: delegate,
        actions: {
            onRowAction,
            onCellAction
        }
    });
    let descriptionProps = (0, _useHighlightSelectionDescription.useHighlightSelectionDescription)({
        selectionManager: manager,
        hasItemActions: !!(onRowAction || onCellAction)
    });
    let domProps = (0, _utils.filterDOMProps)(props, {
        labelable: true
    });
    let onFocus = (0, _react.useCallback)((e)=>{
        if (manager.isFocused) {
            // If a focus event bubbled through a portal, reset focus state.
            if (!e.currentTarget.contains(e.target)) manager.setFocused(false);
            return;
        }
        // Focus events can bubble through portals. Ignore these events.
        if (!e.currentTarget.contains(e.target)) return;
        manager.setFocused(true);
    }, [
        manager
    ]);
    // Continue to track collection focused state even if keyboard navigation is disabled
    let navDisabledHandlers = (0, _react.useMemo)(()=>({
            onBlur: collectionProps.onBlur,
            onFocus
        }), [
        onFocus,
        collectionProps.onBlur
    ]);
    let hasTabbableChild = (0, _focus.useHasTabbableChild)(ref, {
        isDisabled: state.collection.size !== 0
    });
    let gridProps = (0, _utils.mergeProps)(domProps, {
        role: "grid",
        id,
        "aria-multiselectable": manager.selectionMode === "multiple" ? "true" : undefined
    }, state.isKeyboardNavigationDisabled ? navDisabledHandlers : collectionProps, // If collection is empty, make sure the grid is tabbable unless there is a child tabbable element.
    state.collection.size === 0 && {
        tabIndex: hasTabbableChild ? -1 : 0
    }, descriptionProps);
    if (isVirtualized) {
        gridProps["aria-rowcount"] = state.collection.size;
        gridProps["aria-colcount"] = state.collection.columnCount;
    }
    (0, _useGridSelectionAnnouncement.useGridSelectionAnnouncement)({
        getRowText
    }, state);
    return {
        gridProps
    };
}

},{"@react-aria/utils":"9cLk5","./GridKeyboardDelegate":"kOcW0","./utils":"2e0zc","react":"9yzVZ","@react-aria/i18n":"411rg","./useGridSelectionAnnouncement":"2EERD","@react-aria/focus":"42mbF","./useHighlightSelectionDescription":"eiyac","@react-aria/selection":"6Fly5","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"2e0zc":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "gridMap", ()=>gridMap);
const gridMap = new WeakMap();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"2EERD":[function(require,module,exports) {
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useGridSelectionAnnouncement", ()=>useGridSelectionAnnouncement);
var _liveAnnouncer = require("@react-aria/live-announcer");
// @ts-ignore
var _json = require("../intl/*.json");
var _jsonDefault = parcelHelpers.interopDefault(_json);
var _i18N = require("@react-aria/i18n");
var _react = require("react");
var _utils = require("@react-aria/utils");
function useGridSelectionAnnouncement(props, state) {
    let { getRowText = (key)=>{
        var _state_collection_getTextValue, _state_collection, _state_collection_getItem;
        var _state_collection_getTextValue1;
        return (_state_collection_getTextValue1 = (_state_collection_getTextValue = (_state_collection = state.collection).getTextValue) === null || _state_collection_getTextValue === void 0 ? void 0 : _state_collection_getTextValue.call(_state_collection, key)) !== null && _state_collection_getTextValue1 !== void 0 ? _state_collection_getTextValue1 : (_state_collection_getItem = state.collection.getItem(key)) === null || _state_collection_getItem === void 0 ? void 0 : _state_collection_getItem.textValue;
    } } = props;
    let stringFormatter = (0, _i18N.useLocalizedStringFormatter)((0, _jsonDefault.default), "@react-aria/grid");
    // Many screen readers do not announce when items in a grid are selected/deselected.
    // We do this using an ARIA live region.
    let selection = state.selectionManager.rawSelection;
    let lastSelection = (0, _react.useRef)(selection);
    (0, _utils.useUpdateEffect)(()=>{
        var _lastSelection_current;
        if (!state.selectionManager.isFocused) {
            lastSelection.current = selection;
            return;
        }
        let addedKeys = diffSelection(selection, lastSelection.current);
        let removedKeys = diffSelection(lastSelection.current, selection);
        // If adding or removing a single row from the selection, announce the name of that item.
        let isReplace = state.selectionManager.selectionBehavior === "replace";
        let messages = [];
        if (state.selectionManager.selectedKeys.size === 1 && isReplace) {
            if (state.collection.getItem(state.selectionManager.selectedKeys.keys().next().value)) {
                let currentSelectionText = getRowText(state.selectionManager.selectedKeys.keys().next().value);
                if (currentSelectionText) messages.push(stringFormatter.format("selectedItem", {
                    item: currentSelectionText
                }));
            }
        } else if (addedKeys.size === 1 && removedKeys.size === 0) {
            let addedText = getRowText(addedKeys.keys().next().value);
            if (addedText) messages.push(stringFormatter.format("selectedItem", {
                item: addedText
            }));
        } else if (removedKeys.size === 1 && addedKeys.size === 0) {
            if (state.collection.getItem(removedKeys.keys().next().value)) {
                let removedText = getRowText(removedKeys.keys().next().value);
                if (removedText) messages.push(stringFormatter.format("deselectedItem", {
                    item: removedText
                }));
            }
        }
        // Announce how many items are selected, except when selecting the first item.
        if (state.selectionManager.selectionMode === "multiple") {
            if (messages.length === 0 || selection === "all" || selection.size > 1 || lastSelection.current === "all" || ((_lastSelection_current = lastSelection.current) === null || _lastSelection_current === void 0 ? void 0 : _lastSelection_current.size) > 1) messages.push(selection === "all" ? stringFormatter.format("selectedAll") : stringFormatter.format("selectedCount", {
                count: selection.size
            }));
        }
        if (messages.length > 0) (0, _liveAnnouncer.announce)(messages.join(" "));
        lastSelection.current = selection;
    }, [
        selection
    ]);
}
function diffSelection(a, b) {
    let res = new Set();
    if (a === "all" || b === "all") return res;
    for (let key of a.keys())if (!b.has(key)) res.add(key);
    return res;
}

},{"@react-aria/live-announcer":"ipdGY","../intl/*.json":"3Jbrd","@react-aria/i18n":"411rg","react":"9yzVZ","@react-aria/utils":"9cLk5","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"3Jbrd":[function(require,module,exports) {
const _temp0 = require("549f76802fea3145");
const _temp1 = require("99e711b09beafbae");
const _temp2 = require("d822d49a9f50f8f2");
const _temp3 = require("62716c14c7ab3b19");
const _temp4 = require("f993c3bd895f4a55");
const _temp5 = require("87ba517e0d2284cb");
const _temp6 = require("9959e6866268baa2");
const _temp7 = require("a5d29cf49321ccbd");
const _temp8 = require("d4a263166a379f7");
const _temp9 = require("adb7cef23c3e7915");
const _temp10 = require("b85e649d4f0c8fa0");
const _temp11 = require("669dff92f11c15b2");
const _temp12 = require("56a3bfdc95a3af99");
const _temp13 = require("92bd2be1c2e45a26");
const _temp14 = require("ac7b779e60091ebf");
const _temp15 = require("7350c7eb30e615e3");
const _temp16 = require("3260bfccae03c79c");
const _temp17 = require("e01abdb08e203859");
const _temp18 = require("5551bd334b751799");
const _temp19 = require("a555cf93e0917ba2");
const _temp20 = require("f519d273a2594a58");
const _temp21 = require("2ab2dc559350f8cb");
const _temp22 = require("aa7f9e578044416a");
const _temp23 = require("7828f13f1de12a9c");
const _temp24 = require("b776cb1c3588783c");
const _temp25 = require("b2c037c8f99b4b1d");
const _temp26 = require("3656d7d096e21208");
const _temp27 = require("64de068ffd5db517");
const _temp28 = require("6afb03c6be24a7db");
const _temp29 = require("fac4d0e10b154d11");
const _temp30 = require("5207f24182fa30c9");
const _temp31 = require("6c177c75c6c9f015");
const _temp32 = require("1c95bec940ff1fe8");
const _temp33 = require("736ec483e330f374");
module.exports = {
    "ar-AE": _temp0,
    "bg-BG": _temp1,
    "cs-CZ": _temp2,
    "da-DK": _temp3,
    "de-DE": _temp4,
    "el-GR": _temp5,
    "en-US": _temp6,
    "es-ES": _temp7,
    "et-EE": _temp8,
    "fi-FI": _temp9,
    "fr-FR": _temp10,
    "he-IL": _temp11,
    "hr-HR": _temp12,
    "hu-HU": _temp13,
    "it-IT": _temp14,
    "ja-JP": _temp15,
    "ko-KR": _temp16,
    "lt-LT": _temp17,
    "lv-LV": _temp18,
    "nb-NO": _temp19,
    "nl-NL": _temp20,
    "pl-PL": _temp21,
    "pt-BR": _temp22,
    "pt-PT": _temp23,
    "ro-RO": _temp24,
    "ru-RU": _temp25,
    "sk-SK": _temp26,
    "sl-SI": _temp27,
    "sr-SP": _temp28,
    "sv-SE": _temp29,
    "tr-TR": _temp30,
    "uk-UA": _temp31,
    "zh-CN": _temp32,
    "zh-TW": _temp33
};

},{"549f76802fea3145":"ghvOx","99e711b09beafbae":"fAwgv","d822d49a9f50f8f2":"b9AYT","62716c14c7ab3b19":"gxbXM","f993c3bd895f4a55":"g8jv0","87ba517e0d2284cb":"bdHIC","9959e6866268baa2":"iDGLd","a5d29cf49321ccbd":"9fduF","d4a263166a379f7":"aMOJY","adb7cef23c3e7915":"h4Soc","b85e649d4f0c8fa0":"kVFIv","669dff92f11c15b2":"cl9Y0","56a3bfdc95a3af99":"hs6aJ","92bd2be1c2e45a26":"970HB","ac7b779e60091ebf":"lU3k0","7350c7eb30e615e3":"h3vwp","3260bfccae03c79c":"g5fIC","e01abdb08e203859":"8dwZN","5551bd334b751799":"8gaI7","a555cf93e0917ba2":"dx65J","f519d273a2594a58":"ku3WW","2ab2dc559350f8cb":"k9Y0L","aa7f9e578044416a":"dCrIx","7828f13f1de12a9c":"9HZ67","b776cb1c3588783c":"dE7Dk","b2c037c8f99b4b1d":"lEpeA","3656d7d096e21208":"f8Dtf","64de068ffd5db517":"aiYef","6afb03c6be24a7db":"c0QKb","fac4d0e10b154d11":"bbrRS","5207f24182fa30c9":"5Po9O","6c177c75c6c9f015":"48xCY","1c95bec940ff1fe8":"f4NS6","736ec483e330f374":"1Pmqh"}],"ghvOx":[function(require,module,exports) {
module.exports = {
    "deselectedItem": (args)=>`${args.item} \u{63A}\u{64A}\u{631} \u{627}\u{644}\u{645}\u{62D}\u{62F}\u{62F}`,
    "longPressToSelect": `\u{627}\u{636}\u{63A}\u{637} \u{645}\u{637}\u{648}\u{644}\u{64B}\u{627} \u{644}\u{644}\u{62F}\u{62E}\u{648}\u{644} \u{625}\u{644}\u{649} \u{648}\u{636}\u{639} \u{627}\u{644}\u{62A}\u{62D}\u{62F}\u{64A}\u{62F}.`,
    "select": `\u{62A}\u{62D}\u{62F}\u{64A}\u{62F}`,
    "selectedAll": `\u{62C}\u{645}\u{64A}\u{639} \u{627}\u{644}\u{639}\u{646}\u{627}\u{635}\u{631} \u{627}\u{644}\u{645}\u{62D}\u{62F}\u{62F}\u{629}.`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `\u{644}\u{645} \u{64A}\u{62A}\u{645} \u{62A}\u{62D}\u{62F}\u{64A}\u{62F} \u{639}\u{646}\u{627}\u{635}\u{631}`,
            one: ()=>`${formatter.number(args.count)} \u{639}\u{646}\u{635}\u{631} \u{645}\u{62D}\u{62F}\u{62F}`,
            other: ()=>`${formatter.number(args.count)} \u{639}\u{646}\u{635}\u{631} \u{645}\u{62D}\u{62F}\u{62F}`
        })}.`,
    "selectedItem": (args)=>`${args.item} \u{627}\u{644}\u{645}\u{62D}\u{62F}\u{62F}`
};

},{}],"fAwgv":[function(require,module,exports) {
module.exports = {
    "deselectedItem": (args)=>`${args.item} \u{43D}\u{435} \u{435} \u{438}\u{437}\u{431}\u{440}\u{430}\u{43D}.`,
    "longPressToSelect": `\u{41D}\u{430}\u{442}\u{438}\u{441}\u{43D}\u{435}\u{442}\u{435} \u{438} \u{437}\u{430}\u{434}\u{440}\u{44A}\u{436}\u{442}\u{435} \u{437}\u{430} \u{434}\u{430} \u{432}\u{43B}\u{435}\u{437}\u{435}\u{442}\u{435} \u{432} \u{438}\u{437}\u{431}\u{438}\u{440}\u{430}\u{442}\u{435}\u{43B}\u{435}\u{43D} \u{440}\u{435}\u{436}\u{438}\u{43C}.`,
    "select": `\u{418}\u{437}\u{431}\u{435}\u{440}\u{435}\u{442}\u{435}`,
    "selectedAll": `\u{412}\u{441}\u{438}\u{447}\u{43A}\u{438} \u{435}\u{43B}\u{435}\u{43C}\u{435}\u{43D}\u{442}\u{438} \u{441}\u{430} \u{438}\u{437}\u{431}\u{440}\u{430}\u{43D}\u{438}.`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `\u{41D}\u{44F}\u{43C}\u{430} \u{438}\u{437}\u{431}\u{440}\u{430}\u{43D}\u{438} \u{435}\u{43B}\u{435}\u{43C}\u{435}\u{43D}\u{442}\u{438}`,
            one: ()=>`${formatter.number(args.count)} \u{438}\u{437}\u{431}\u{440}\u{430}\u{43D} \u{435}\u{43B}\u{435}\u{43C}\u{435}\u{43D}\u{442}`,
            other: ()=>`${formatter.number(args.count)} \u{438}\u{437}\u{431}\u{440}\u{430}\u{43D}\u{438} \u{435}\u{43B}\u{435}\u{43C}\u{435}\u{43D}\u{442}\u{438}`
        })}.`,
    "selectedItem": (args)=>`${args.item} \u{438}\u{437}\u{431}\u{440}\u{430}\u{43D}.`
};

},{}],"b9AYT":[function(require,module,exports) {
module.exports = {
    "deselectedItem": (args)=>`Polo\u{17E}ka ${args.item} nen\xed vybr\xe1na.`,
    "longPressToSelect": `Dlouh\xfdm stisknut\xedm p\u{159}ejdete do re\u{17E}imu v\xfdb\u{11B}ru.`,
    "select": `Vybrat`,
    "selectedAll": `Vybr\xe1ny v\u{161}echny polo\u{17E}ky.`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `Nevybr\xe1ny \u{17E}\xe1dn\xe9 polo\u{17E}ky`,
            one: ()=>`Vybr\xe1na ${formatter.number(args.count)} polo\u{17E}ka`,
            other: ()=>`Vybr\xe1no ${formatter.number(args.count)} polo\u{17E}ek`
        })}.`,
    "selectedItem": (args)=>`Vybr\xe1na polo\u{17E}ka ${args.item}.`
};

},{}],"gxbXM":[function(require,module,exports) {
module.exports = {
    "deselectedItem": (args)=>`${args.item} ikke valgt.`,
    "longPressToSelect": `Lav et langt tryk for at aktivere valgtilstand.`,
    "select": `V\xe6lg`,
    "selectedAll": `Alle elementer valgt.`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `Ingen elementer valgt`,
            one: ()=>`${formatter.number(args.count)} element valgt`,
            other: ()=>`${formatter.number(args.count)} elementer valgt`
        })}.`,
    "selectedItem": (args)=>`${args.item} valgt.`
};

},{}],"g8jv0":[function(require,module,exports) {
module.exports = {
    "deselectedItem": (args)=>`${args.item} nicht ausgew\xe4hlt.`,
    "longPressToSelect": `Gedr\xfcckt halten, um Auswahlmodus zu \xf6ffnen.`,
    "select": `Ausw\xe4hlen`,
    "selectedAll": `Alle Elemente ausgew\xe4hlt.`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `Keine Elemente ausgew\xe4hlt`,
            one: ()=>`${formatter.number(args.count)} Element ausgew\xe4hlt`,
            other: ()=>`${formatter.number(args.count)} Elemente ausgew\xe4hlt`
        })}.`,
    "selectedItem": (args)=>`${args.item} ausgew\xe4hlt.`
};

},{}],"bdHIC":[function(require,module,exports) {
module.exports = {
    "deselectedItem": (args)=>`\u{394}\u{3B5}\u{3BD} \u{3B5}\u{3C0}\u{3B9}\u{3BB}\u{3AD}\u{3C7}\u{3B8}\u{3B7}\u{3BA}\u{3B5} \u{3C4}\u{3BF} \u{3C3}\u{3C4}\u{3BF}\u{3B9}\u{3C7}\u{3B5}\u{3AF}\u{3BF} ${args.item}.`,
    "longPressToSelect": `\u{3A0}\u{3B1}\u{3C4}\u{3AE}\u{3C3}\u{3C4}\u{3B5} \u{3C0}\u{3B1}\u{3C1}\u{3B1}\u{3C4}\u{3B5}\u{3C4}\u{3B1}\u{3BC}\u{3AD}\u{3BD}\u{3B1} \u{3B3}\u{3B9}\u{3B1} \u{3BD}\u{3B1} \u{3BC}\u{3C0}\u{3B5}\u{3AF}\u{3C4}\u{3B5} \u{3C3}\u{3B5} \u{3BB}\u{3B5}\u{3B9}\u{3C4}\u{3BF}\u{3C5}\u{3C1}\u{3B3}\u{3AF}\u{3B1} \u{3B5}\u{3C0}\u{3B9}\u{3BB}\u{3BF}\u{3B3}\u{3AE}\u{3C2}.`,
    "select": `\u{395}\u{3C0}\u{3B9}\u{3BB}\u{3BF}\u{3B3}\u{3AE}`,
    "selectedAll": `\u{395}\u{3C0}\u{3B9}\u{3BB}\u{3AD}\u{3C7}\u{3B8}\u{3B7}\u{3BA}\u{3B1}\u{3BD} \u{3CC}\u{3BB}\u{3B1} \u{3C4}\u{3B1} \u{3C3}\u{3C4}\u{3BF}\u{3B9}\u{3C7}\u{3B5}\u{3AF}\u{3B1}.`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `\u{394}\u{3B5}\u{3BD} \u{3B5}\u{3C0}\u{3B9}\u{3BB}\u{3AD}\u{3C7}\u{3B8}\u{3B7}\u{3BA}\u{3B1}\u{3BD} \u{3C3}\u{3C4}\u{3BF}\u{3B9}\u{3C7}\u{3B5}\u{3AF}\u{3B1}`,
            one: ()=>`\u{395}\u{3C0}\u{3B9}\u{3BB}\u{3AD}\u{3C7}\u{3B8}\u{3B7}\u{3BA}\u{3B5} ${formatter.number(args.count)} \u{3C3}\u{3C4}\u{3BF}\u{3B9}\u{3C7}\u{3B5}\u{3AF}\u{3BF}`,
            other: ()=>`\u{395}\u{3C0}\u{3B9}\u{3BB}\u{3AD}\u{3C7}\u{3B8}\u{3B7}\u{3BA}\u{3B1}\u{3BD} ${formatter.number(args.count)} \u{3C3}\u{3C4}\u{3BF}\u{3B9}\u{3C7}\u{3B5}\u{3AF}\u{3B1}`
        })}.`,
    "selectedItem": (args)=>`\u{395}\u{3C0}\u{3B9}\u{3BB}\u{3AD}\u{3C7}\u{3B8}\u{3B7}\u{3BA}\u{3B5} \u{3C4}\u{3BF} \u{3C3}\u{3C4}\u{3BF}\u{3B9}\u{3C7}\u{3B5}\u{3AF}\u{3BF} ${args.item}.`
};

},{}],"iDGLd":[function(require,module,exports) {
module.exports = {
    "deselectedItem": (args)=>`${args.item} not selected.`,
    "select": `Select`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `No items selected`,
            one: ()=>`${formatter.number(args.count)} item selected`,
            other: ()=>`${formatter.number(args.count)} items selected`
        })}.`,
    "selectedAll": `All items selected.`,
    "selectedItem": (args)=>`${args.item} selected.`,
    "longPressToSelect": `Long press to enter selection mode.`
};

},{}],"9fduF":[function(require,module,exports) {
module.exports = {
    "deselectedItem": (args)=>`${args.item} no seleccionado.`,
    "longPressToSelect": `Mantenga pulsado para abrir el modo de selecci\xf3n.`,
    "select": `Seleccionar`,
    "selectedAll": `Todos los elementos seleccionados.`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `Ning\xfan elemento seleccionado`,
            one: ()=>`${formatter.number(args.count)} elemento seleccionado`,
            other: ()=>`${formatter.number(args.count)} elementos seleccionados`
        })}.`,
    "selectedItem": (args)=>`${args.item} seleccionado.`
};

},{}],"aMOJY":[function(require,module,exports) {
module.exports = {
    "deselectedItem": (args)=>`${args.item} pole valitud.`,
    "longPressToSelect": `Valikure\u{17E}iimi sisenemiseks vajutage pikalt.`,
    "select": `Vali`,
    "selectedAll": `K\xf5ik \xfcksused valitud.`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `\xdcksusi pole valitud`,
            one: ()=>`${formatter.number(args.count)} \xfcksus valitud`,
            other: ()=>`${formatter.number(args.count)} \xfcksust valitud`
        })}.`,
    "selectedItem": (args)=>`${args.item} valitud.`
};

},{}],"h4Soc":[function(require,module,exports) {
module.exports = {
    "deselectedItem": (args)=>`Kohdetta ${args.item} ei valittu.`,
    "longPressToSelect": `Siirry valintatilaan painamalla pitk\xe4\xe4n.`,
    "select": `Valitse`,
    "selectedAll": `Kaikki kohteet valittu.`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `Ei yht\xe4\xe4n kohdetta valittu`,
            one: ()=>`${formatter.number(args.count)} kohde valittu`,
            other: ()=>`${formatter.number(args.count)} kohdetta valittu`
        })}.`,
    "selectedItem": (args)=>`${args.item} valittu.`
};

},{}],"kVFIv":[function(require,module,exports) {
module.exports = {
    "deselectedItem": (args)=>`${args.item} non s\xe9lectionn\xe9.`,
    "longPressToSelect": `Appuyez de mani\xe8re prolong\xe9e pour passer en mode de s\xe9lection.`,
    "select": `S\xe9lectionner`,
    "selectedAll": `Tous les \xe9l\xe9ments s\xe9lectionn\xe9s.`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `Aucun \xe9l\xe9ment s\xe9lectionn\xe9`,
            one: ()=>`${formatter.number(args.count)} \xe9l\xe9ment s\xe9lectionn\xe9`,
            other: ()=>`${formatter.number(args.count)} \xe9l\xe9ments s\xe9lectionn\xe9s`
        })}.`,
    "selectedItem": (args)=>`${args.item} s\xe9lectionn\xe9.`
};

},{}],"cl9Y0":[function(require,module,exports) {
module.exports = {
    "deselectedItem": (args)=>`${args.item} \u{5DC}\u{5D0} \u{5E0}\u{5D1}\u{5D7}\u{5E8}.`,
    "longPressToSelect": `\u{5D4}\u{5E7}\u{5E9}\u{5D4} \u{5D0}\u{5E8}\u{5D5}\u{5DB}\u{5D4} \u{5DC}\u{5DB}\u{5E0}\u{5D9}\u{5E1}\u{5D4} \u{5DC}\u{5DE}\u{5E6}\u{5D1} \u{5D1}\u{5D7}\u{5D9}\u{5E8}\u{5D4}.`,
    "select": `\u{5D1}\u{5D7}\u{5E8}`,
    "selectedAll": `\u{5DB}\u{5DC} \u{5D4}\u{5E4}\u{5E8}\u{5D9}\u{5D8}\u{5D9}\u{5DD} \u{5E0}\u{5D1}\u{5D7}\u{5E8}\u{5D5}.`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `\u{5DC}\u{5D0} \u{5E0}\u{5D1}\u{5D7}\u{5E8}\u{5D5} \u{5E4}\u{5E8}\u{5D9}\u{5D8}\u{5D9}\u{5DD}`,
            one: ()=>`\u{5E4}\u{5E8}\u{5D9}\u{5D8} ${formatter.number(args.count)} \u{5E0}\u{5D1}\u{5D7}\u{5E8}`,
            other: ()=>`${formatter.number(args.count)} \u{5E4}\u{5E8}\u{5D9}\u{5D8}\u{5D9}\u{5DD} \u{5E0}\u{5D1}\u{5D7}\u{5E8}\u{5D5}`
        })}.`,
    "selectedItem": (args)=>`${args.item} \u{5E0}\u{5D1}\u{5D7}\u{5E8}.`
};

},{}],"hs6aJ":[function(require,module,exports) {
module.exports = {
    "deselectedItem": (args)=>`Stavka ${args.item} nije odabrana.`,
    "longPressToSelect": `Dugo pritisnite za ulazak u na\u{10D}in odabira.`,
    "select": `Odaberite`,
    "selectedAll": `Odabrane su sve stavke.`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `Nije odabrana nijedna stavka`,
            one: ()=>`Odabrana je ${formatter.number(args.count)} stavka`,
            other: ()=>`Odabrano je ${formatter.number(args.count)} stavki`
        })}.`,
    "selectedItem": (args)=>`Stavka ${args.item} je odabrana.`
};

},{}],"970HB":[function(require,module,exports) {
module.exports = {
    "deselectedItem": (args)=>`${args.item} nincs kijel\xf6lve.`,
    "longPressToSelect": `Nyomja hosszan a kijel\xf6l\xe9shez.`,
    "select": `Kijel\xf6l\xe9s`,
    "selectedAll": `Az \xf6sszes elem kijel\xf6lve.`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `Egy elem sincs kijel\xf6lve`,
            one: ()=>`${formatter.number(args.count)} elem kijel\xf6lve`,
            other: ()=>`${formatter.number(args.count)} elem kijel\xf6lve`
        })}.`,
    "selectedItem": (args)=>`${args.item} kijel\xf6lve.`
};

},{}],"lU3k0":[function(require,module,exports) {
module.exports = {
    "deselectedItem": (args)=>`${args.item} non selezionato.`,
    "longPressToSelect": `Premi a lungo per passare alla modalit\xe0 di selezione.`,
    "select": `Seleziona`,
    "selectedAll": `Tutti gli elementi selezionati.`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `Nessun elemento selezionato`,
            one: ()=>`${formatter.number(args.count)} elemento selezionato`,
            other: ()=>`${formatter.number(args.count)} elementi selezionati`
        })}.`,
    "selectedItem": (args)=>`${args.item} selezionato.`
};

},{}],"h3vwp":[function(require,module,exports) {
module.exports = {
    "deselectedItem": (args)=>`${args.item} \u{304C}\u{9078}\u{629E}\u{3055}\u{308C}\u{3066}\u{3044}\u{307E}\u{305B}\u{3093}\u{3002}`,
    "longPressToSelect": `\u{9577}\u{62BC}\u{3057}\u{3057}\u{3066}\u{9078}\u{629E}\u{30E2}\u{30FC}\u{30C9}\u{3092}\u{958B}\u{304D}\u{307E}\u{3059}\u{3002}`,
    "select": `\u{9078}\u{629E}`,
    "selectedAll": `\u{3059}\u{3079}\u{3066}\u{306E}\u{9805}\u{76EE}\u{3092}\u{9078}\u{629E}\u{3057}\u{307E}\u{3057}\u{305F}\u{3002}`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `\u{9805}\u{76EE}\u{304C}\u{9078}\u{629E}\u{3055}\u{308C}\u{3066}\u{3044}\u{307E}\u{305B}\u{3093}`,
            one: ()=>`${formatter.number(args.count)} \u{9805}\u{76EE}\u{3092}\u{9078}\u{629E}\u{3057}\u{307E}\u{3057}\u{305F}`,
            other: ()=>`${formatter.number(args.count)} \u{9805}\u{76EE}\u{3092}\u{9078}\u{629E}\u{3057}\u{307E}\u{3057}\u{305F}`
        })}\u{3002}`,
    "selectedItem": (args)=>`${args.item} \u{3092}\u{9078}\u{629E}\u{3057}\u{307E}\u{3057}\u{305F}\u{3002}`
};

},{}],"g5fIC":[function(require,module,exports) {
module.exports = {
    "deselectedItem": (args)=>`${args.item}\u{C774}(\u{AC00}) \u{C120}\u{D0DD}\u{B418}\u{C9C0} \u{C54A}\u{C558}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    "longPressToSelect": `\u{C120}\u{D0DD} \u{BAA8}\u{B4DC}\u{B85C} \u{B4E4}\u{C5B4}\u{AC00}\u{B824}\u{BA74} \u{AE38}\u{AC8C} \u{B204}\u{B974}\u{C2ED}\u{C2DC}\u{C624}.`,
    "select": `\u{C120}\u{D0DD}`,
    "selectedAll": `\u{BAA8}\u{B4E0} \u{D56D}\u{BAA9}\u{C774} \u{C120}\u{D0DD}\u{B418}\u{C5C8}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `\u{C120}\u{D0DD}\u{B41C} \u{D56D}\u{BAA9}\u{C774} \u{C5C6}\u{C2B5}\u{B2C8}\u{B2E4}`,
            one: ()=>`${formatter.number(args.count)}\u{AC1C} \u{D56D}\u{BAA9}\u{C774} \u{C120}\u{D0DD}\u{B418}\u{C5C8}\u{C2B5}\u{B2C8}\u{B2E4}`,
            other: ()=>`${formatter.number(args.count)}\u{AC1C} \u{D56D}\u{BAA9}\u{C774} \u{C120}\u{D0DD}\u{B418}\u{C5C8}\u{C2B5}\u{B2C8}\u{B2E4}`
        })}.`,
    "selectedItem": (args)=>`${args.item}\u{C774}(\u{AC00}) \u{C120}\u{D0DD}\u{B418}\u{C5C8}\u{C2B5}\u{B2C8}\u{B2E4}.`
};

},{}],"8dwZN":[function(require,module,exports) {
module.exports = {
    "deselectedItem": (args)=>`${args.item} nepasirinkta.`,
    "longPressToSelect": `Nor\u{117}dami \u{12F}jungti pasirinkimo re\u{17E}im\u{105}, paspauskite ir palaikykite.`,
    "select": `Pasirinkti`,
    "selectedAll": `Pasirinkti visi elementai.`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `Nepasirinktas n\u{117} vienas elementas`,
            one: ()=>`Pasirinktas ${formatter.number(args.count)} elementas`,
            other: ()=>`Pasirinkta element\u{173}: ${formatter.number(args.count)}`
        })}.`,
    "selectedItem": (args)=>`Pasirinkta: ${args.item}.`
};

},{}],"8gaI7":[function(require,module,exports) {
module.exports = {
    "deselectedItem": (args)=>`Vienums ${args.item} nav atlas\u{12B}ts.`,
    "longPressToSelect": `Ilgi turiet nospiestu. lai iesl\u{113}gtu atlases re\u{17E}\u{12B}mu.`,
    "select": `Atlas\u{12B}t`,
    "selectedAll": `Atlas\u{12B}ti visi vienumi.`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `Nav atlas\u{12B}ts neviens vienums`,
            one: ()=>`Atlas\u{12B}to vienumu skaits: ${formatter.number(args.count)}`,
            other: ()=>`Atlas\u{12B}to vienumu skaits: ${formatter.number(args.count)}`
        })}.`,
    "selectedItem": (args)=>`Atlas\u{12B}ts vienums ${args.item}.`
};

},{}],"dx65J":[function(require,module,exports) {
module.exports = {
    "deselectedItem": (args)=>`${args.item} er ikke valgt.`,
    "longPressToSelect": `Bruk et langt trykk for \xe5 g\xe5 inn i valgmodus.`,
    "select": `Velg`,
    "selectedAll": `Alle elementer er valgt.`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `Ingen elementer er valgt`,
            one: ()=>`${formatter.number(args.count)} element er valgt`,
            other: ()=>`${formatter.number(args.count)} elementer er valgt`
        })}.`,
    "selectedItem": (args)=>`${args.item} er valgt.`
};

},{}],"ku3WW":[function(require,module,exports) {
module.exports = {
    "deselectedItem": (args)=>`${args.item} niet geselecteerd.`,
    "longPressToSelect": `Druk lang om de selectiemodus te openen.`,
    "select": `Selecteren`,
    "selectedAll": `Alle items geselecteerd.`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `Geen items geselecteerd`,
            one: ()=>`${formatter.number(args.count)} item geselecteerd`,
            other: ()=>`${formatter.number(args.count)} items geselecteerd`
        })}.`,
    "selectedItem": (args)=>`${args.item} geselecteerd.`
};

},{}],"k9Y0L":[function(require,module,exports) {
module.exports = {
    "deselectedItem": (args)=>`Nie zaznaczono ${args.item}.`,
    "longPressToSelect": `Naci\u{15B}nij i przytrzymaj, aby wej\u{15B}\u{107} do trybu wyboru.`,
    "select": `Zaznacz`,
    "selectedAll": `Wszystkie zaznaczone elementy.`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `Nie zaznaczono \u{17C}adnych element\xf3w`,
            one: ()=>`${formatter.number(args.count)} zaznaczony element`,
            other: ()=>`${formatter.number(args.count)} zaznaczonych element\xf3w`
        })}.`,
    "selectedItem": (args)=>`Zaznaczono ${args.item}.`
};

},{}],"dCrIx":[function(require,module,exports) {
module.exports = {
    "deselectedItem": (args)=>`${args.item} n\xe3o selecionado.`,
    "longPressToSelect": `Mantenha pressionado para entrar no modo de sele\xe7\xe3o.`,
    "select": `Selecionar`,
    "selectedAll": `Todos os itens selecionados.`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `Nenhum item selecionado`,
            one: ()=>`${formatter.number(args.count)} item selecionado`,
            other: ()=>`${formatter.number(args.count)} itens selecionados`
        })}.`,
    "selectedItem": (args)=>`${args.item} selecionado.`
};

},{}],"9HZ67":[function(require,module,exports) {
module.exports = {
    "deselectedItem": (args)=>`${args.item} n\xe3o selecionado.`,
    "longPressToSelect": `Prima continuamente para entrar no modo de sele\xe7\xe3o.`,
    "select": `Selecionar`,
    "selectedAll": `Todos os itens selecionados.`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `Nenhum item selecionado`,
            one: ()=>`${formatter.number(args.count)} item selecionado`,
            other: ()=>`${formatter.number(args.count)} itens selecionados`
        })}.`,
    "selectedItem": (args)=>`${args.item} selecionado.`
};

},{}],"dE7Dk":[function(require,module,exports) {
module.exports = {
    "deselectedItem": (args)=>`${args.item} neselectat.`,
    "longPressToSelect": `Ap\u{103}sa\u{21B}i lung pentru a intra \xeen modul de selectare.`,
    "select": `Selectare`,
    "selectedAll": `Toate elementele selectate.`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `Niciun element selectat`,
            one: ()=>`${formatter.number(args.count)} element selectat`,
            other: ()=>`${formatter.number(args.count)} elemente selectate`
        })}.`,
    "selectedItem": (args)=>`${args.item} selectat.`
};

},{}],"lEpeA":[function(require,module,exports) {
module.exports = {
    "deselectedItem": (args)=>`${args.item} \u{43D}\u{435} \u{432}\u{44B}\u{431}\u{440}\u{430}\u{43D}\u{43E}.`,
    "longPressToSelect": `\u{41D}\u{430}\u{436}\u{43C}\u{438}\u{442}\u{435} \u{438} \u{443}\u{434}\u{435}\u{440}\u{436}\u{438}\u{432}\u{430}\u{439}\u{442}\u{435} \u{434}\u{43B}\u{44F} \u{432}\u{445}\u{43E}\u{434}\u{430} \u{432} \u{440}\u{435}\u{436}\u{438}\u{43C} \u{432}\u{44B}\u{431}\u{43E}\u{440}\u{430}.`,
    "select": `\u{412}\u{44B}\u{431}\u{440}\u{430}\u{442}\u{44C}`,
    "selectedAll": `\u{412}\u{44B}\u{431}\u{440}\u{430}\u{43D}\u{44B} \u{432}\u{441}\u{435} \u{44D}\u{43B}\u{435}\u{43C}\u{435}\u{43D}\u{442}\u{44B}.`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `\u{41D}\u{435}\u{442} \u{432}\u{44B}\u{431}\u{440}\u{430}\u{43D}\u{43D}\u{44B}\u{445} \u{44D}\u{43B}\u{435}\u{43C}\u{435}\u{43D}\u{442}\u{43E}\u{432}`,
            one: ()=>`${formatter.number(args.count)} \u{44D}\u{43B}\u{435}\u{43C}\u{435}\u{43D}\u{442} \u{432}\u{44B}\u{431}\u{440}\u{430}\u{43D}`,
            other: ()=>`${formatter.number(args.count)} \u{44D}\u{43B}\u{435}\u{43C}\u{435}\u{43D}\u{442}\u{43E}\u{432} \u{432}\u{44B}\u{431}\u{440}\u{430}\u{43D}\u{43E}`
        })}.`,
    "selectedItem": (args)=>`${args.item} \u{432}\u{44B}\u{431}\u{440}\u{430}\u{43D}\u{43E}.`
};

},{}],"f8Dtf":[function(require,module,exports) {
module.exports = {
    "deselectedItem": (args)=>`Nevybrat\xe9 polo\u{17E}ky: ${args.item}.`,
    "longPressToSelect": `Dlh\u{161}\xedm stla\u{10D}en\xedm prejdite do re\u{17E}imu v\xfdberu.`,
    "select": `Vybra\u{165}`,
    "selectedAll": `V\u{161}etky vybrat\xe9 polo\u{17E}ky.`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `\u{17D}iadne vybrat\xe9 polo\u{17E}ky`,
            one: ()=>`${formatter.number(args.count)} vybrat\xe1 polo\u{17E}ka`,
            other: ()=>`Po\u{10D}et vybrat\xfdch polo\u{17E}iek:${formatter.number(args.count)}`
        })}.`,
    "selectedItem": (args)=>`Vybrat\xe9 polo\u{17E}ky: ${args.item}.`
};

},{}],"aiYef":[function(require,module,exports) {
module.exports = {
    "deselectedItem": (args)=>`Element ${args.item} ni izbran.`,
    "longPressToSelect": `Za izbirni na\u{10D}in pritisnite in dlje \u{10D}asa dr\u{17E}ite.`,
    "select": `Izberite`,
    "selectedAll": `Vsi elementi so izbrani.`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `Noben element ni izbran`,
            one: ()=>`${formatter.number(args.count)} element je izbran`,
            other: ()=>`${formatter.number(args.count)} elementov je izbranih`
        })}.`,
    "selectedItem": (args)=>`Element ${args.item} je izbran.`
};

},{}],"c0QKb":[function(require,module,exports) {
module.exports = {
    "deselectedItem": (args)=>`${args.item} nije izabrano.`,
    "longPressToSelect": `Dugo pritisnite za ulazak u re\u{17E}im biranja.`,
    "select": `Izaberite`,
    "selectedAll": `Izabrane su sve stavke.`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `Nije izabrana nijedna stavka`,
            one: ()=>`Izabrana je ${formatter.number(args.count)} stavka`,
            other: ()=>`Izabrano je ${formatter.number(args.count)} stavki`
        })}.`,
    "selectedItem": (args)=>`${args.item} je izabrano.`
};

},{}],"bbrRS":[function(require,module,exports) {
module.exports = {
    "deselectedItem": (args)=>`${args.item} ej markerat.`,
    "longPressToSelect": `Tryck l\xe4nge n\xe4r du vill \xf6ppna v\xe4ljarl\xe4ge.`,
    "select": `Markera`,
    "selectedAll": `Alla markerade objekt.`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `Inga markerade objekt`,
            one: ()=>`${formatter.number(args.count)} markerat objekt`,
            other: ()=>`${formatter.number(args.count)} markerade objekt`
        })}.`,
    "selectedItem": (args)=>`${args.item} markerat.`
};

},{}],"5Po9O":[function(require,module,exports) {
module.exports = {
    "deselectedItem": (args)=>`${args.item} se\xe7ilmedi.`,
    "longPressToSelect": `Se\xe7im moduna girmek i\xe7in uzun bas\u{131}n.`,
    "select": `Se\xe7`,
    "selectedAll": `T\xfcm \xf6geler se\xe7ildi.`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `Hi\xe7bir \xf6ge se\xe7ilmedi`,
            one: ()=>`${formatter.number(args.count)} \xf6ge se\xe7ildi`,
            other: ()=>`${formatter.number(args.count)} \xf6ge se\xe7ildi`
        })}.`,
    "selectedItem": (args)=>`${args.item} se\xe7ildi.`
};

},{}],"48xCY":[function(require,module,exports) {
module.exports = {
    "deselectedItem": (args)=>`${args.item} \u{43D}\u{435} \u{432}\u{438}\u{431}\u{440}\u{430}\u{43D}\u{43E}.`,
    "longPressToSelect": `\u{412}\u{438}\u{43A}\u{43E}\u{43D}\u{430}\u{439}\u{442}\u{435} \u{434}\u{43E}\u{432}\u{433}\u{435} \u{43D}\u{430}\u{442}\u{438}\u{441}\u{43D}\u{435}\u{43D}\u{43D}\u{44F}, \u{449}\u{43E}\u{431} \u{43F}\u{435}\u{440}\u{435}\u{439}\u{442}\u{438} \u{432} \u{440}\u{435}\u{436}\u{438}\u{43C} \u{432}\u{438}\u{431}\u{43E}\u{440}\u{443}.`,
    "select": `\u{412}\u{438}\u{431}\u{440}\u{430}\u{442}\u{438}`,
    "selectedAll": `\u{423}\u{441}\u{456} \u{435}\u{43B}\u{435}\u{43C}\u{435}\u{43D}\u{442}\u{438} \u{432}\u{438}\u{431}\u{440}\u{430}\u{43D}\u{43E}.`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `\u{416}\u{43E}\u{434}\u{43D}\u{438}\u{445} \u{435}\u{43B}\u{435}\u{43C}\u{435}\u{43D}\u{442}\u{456}\u{432} \u{43D}\u{435} \u{432}\u{438}\u{431}\u{440}\u{430}\u{43D}\u{43E}`,
            one: ()=>`${formatter.number(args.count)} \u{435}\u{43B}\u{435}\u{43C}\u{435}\u{43D}\u{442} \u{432}\u{438}\u{431}\u{440}\u{430}\u{43D}\u{43E}`,
            other: ()=>`\u{412}\u{438}\u{431}\u{440}\u{430}\u{43D}\u{43E} \u{435}\u{43B}\u{435}\u{43C}\u{435}\u{43D}\u{442}\u{456}\u{432}: ${formatter.number(args.count)}`
        })}.`,
    "selectedItem": (args)=>`${args.item} \u{432}\u{438}\u{431}\u{440}\u{430}\u{43D}\u{43E}.`
};

},{}],"f4NS6":[function(require,module,exports) {
module.exports = {
    "deselectedItem": (args)=>`\u{672A}\u{9009}\u{62E9} ${args.item}\u{3002}`,
    "longPressToSelect": `\u{957F}\u{6309}\u{4EE5}\u{8FDB}\u{5165}\u{9009}\u{62E9}\u{6A21}\u{5F0F}\u{3002}`,
    "select": `\u{9009}\u{62E9}`,
    "selectedAll": `\u{5DF2}\u{9009}\u{62E9}\u{6240}\u{6709}\u{9879}\u{76EE}\u{3002}`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `\u{672A}\u{9009}\u{62E9}\u{9879}\u{76EE}`,
            one: ()=>`\u{5DF2}\u{9009}\u{62E9} ${formatter.number(args.count)} \u{4E2A}\u{9879}\u{76EE}`,
            other: ()=>`\u{5DF2}\u{9009}\u{62E9} ${formatter.number(args.count)} \u{4E2A}\u{9879}\u{76EE}`
        })}\u{3002}`,
    "selectedItem": (args)=>`\u{5DF2}\u{9009}\u{62E9} ${args.item}\u{3002}`
};

},{}],"1Pmqh":[function(require,module,exports) {
module.exports = {
    "deselectedItem": (args)=>`\u{672A}\u{9078}\u{53D6}\u{300C}${args.item}\u{300D}\u{3002}`,
    "longPressToSelect": `\u{9577}\u{6309}\u{4EE5}\u{9032}\u{5165}\u{9078}\u{64C7}\u{6A21}\u{5F0F}\u{3002}`,
    "select": `\u{9078}\u{53D6}`,
    "selectedAll": `\u{5DF2}\u{9078}\u{53D6}\u{6240}\u{6709}\u{9805}\u{76EE}\u{3002}`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `\u{672A}\u{9078}\u{53D6}\u{4EFB}\u{4F55}\u{9805}\u{76EE}`,
            one: ()=>`\u{5DF2}\u{9078}\u{53D6} ${formatter.number(args.count)} \u{500B}\u{9805}\u{76EE}`,
            other: ()=>`\u{5DF2}\u{9078}\u{53D6} ${formatter.number(args.count)} \u{500B}\u{9805}\u{76EE}`
        })}\u{3002}`,
    "selectedItem": (args)=>`\u{5DF2}\u{9078}\u{53D6}\u{300C}${args.item}\u{300D}\u{3002}`
};

},{}],"eiyac":[function(require,module,exports) {
/*
 * Copyright 2021 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Computes the description for a grid selectable collection.
 * @param props
 */ parcelHelpers.export(exports, "useHighlightSelectionDescription", ()=>useHighlightSelectionDescription);
// @ts-ignore
var _json = require("../intl/*.json");
var _jsonDefault = parcelHelpers.interopDefault(_json);
var _utils = require("@react-aria/utils");
var _interactions = require("@react-aria/interactions");
var _i18N = require("@react-aria/i18n");
var _react = require("react");
function useHighlightSelectionDescription(props) {
    let stringFormatter = (0, _i18N.useLocalizedStringFormatter)((0, _jsonDefault.default), "@react-aria/grid");
    let modality = (0, _interactions.useInteractionModality)();
    // null is the default if the user hasn't interacted with the table at all yet or the rest of the page
    let shouldLongPress = (modality === "pointer" || modality === "virtual" || modality == null) && typeof window !== "undefined" && "ontouchstart" in window;
    let interactionDescription = (0, _react.useMemo)(()=>{
        let selectionMode = props.selectionManager.selectionMode;
        let selectionBehavior = props.selectionManager.selectionBehavior;
        let message = undefined;
        if (shouldLongPress) message = stringFormatter.format("longPressToSelect");
        return selectionBehavior === "replace" && selectionMode !== "none" && props.hasItemActions ? message : undefined;
    }, [
        props.selectionManager.selectionMode,
        props.selectionManager.selectionBehavior,
        props.hasItemActions,
        stringFormatter,
        shouldLongPress
    ]);
    let descriptionProps = (0, _utils.useDescription)(interactionDescription);
    return descriptionProps;
}

},{"../intl/*.json":"3Jbrd","@react-aria/utils":"9cLk5","@react-aria/interactions":"ky3G8","@react-aria/i18n":"411rg","react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"i7FC2":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides the accessibility implementation for a row group in a grid.
 */ parcelHelpers.export(exports, "useGridRowGroup", ()=>useGridRowGroup);
function useGridRowGroup() {
    return {
        rowGroupProps: {
            role: "rowgroup"
        }
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"3b5RG":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides the behavior and accessibility implementation for a row in a grid.
 * @param props - Props for the row.
 * @param state - State of the parent grid, as returned by `useGridState`.
 */ parcelHelpers.export(exports, "useGridRow", ()=>useGridRow);
var _utils = require("./utils");
var _selection = require("@react-aria/selection");
function useGridRow(props, state, ref) {
    let { node, isVirtualized, shouldSelectOnPressUp, onAction } = props;
    let { actions: { onRowAction } } = (0, _utils.gridMap).get(state);
    let { itemProps, ...states } = (0, _selection.useSelectableItem)({
        selectionManager: state.selectionManager,
        key: node.key,
        ref,
        isVirtualized,
        shouldSelectOnPressUp,
        onAction: onRowAction ? ()=>onRowAction(node.key) : onAction,
        isDisabled: state.collection.size === 0
    });
    let isSelected = state.selectionManager.isSelected(node.key);
    let rowProps = {
        role: "row",
        "aria-selected": state.selectionManager.selectionMode !== "none" ? isSelected : undefined,
        "aria-disabled": states.isDisabled || undefined,
        ...itemProps
    };
    if (isVirtualized) rowProps["aria-rowindex"] = node.index + 1; // aria-rowindex is 1 based
    return {
        rowProps,
        ...states
    };
}

},{"./utils":"2e0zc","@react-aria/selection":"6Fly5","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"1nlzP":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides the behavior and accessibility implementation for a cell in a grid.
 * @param props - Props for the cell.
 * @param state - State of the parent grid, as returned by `useGridState`.
 */ parcelHelpers.export(exports, "useGridCell", ()=>useGridCell);
var _focus = require("@react-aria/focus");
var _utils = require("@react-aria/utils");
var _utils1 = require("./utils");
var _interactions = require("@react-aria/interactions");
var _react = require("react");
var _i18N = require("@react-aria/i18n");
var _selection = require("@react-aria/selection");
function useGridCell(props, state, ref) {
    let { node, isVirtualized, focusMode = "child", shouldSelectOnPressUp, onAction } = props;
    let { direction } = (0, _i18N.useLocale)();
    let { keyboardDelegate, actions: { onCellAction } } = (0, _utils1.gridMap).get(state);
    // We need to track the key of the item at the time it was last focused so that we force
    // focus to go to the item when the DOM node is reused for a different item in a virtualizer.
    let keyWhenFocused = (0, _react.useRef)(null);
    // Handles focusing the cell. If there is a focusable child,
    // it is focused, otherwise the cell itself is focused.
    let focus = ()=>{
        let treeWalker = (0, _focus.getFocusableTreeWalker)(ref.current);
        if (focusMode === "child") {
            // If focus is already on a focusable child within the cell, early return so we don't shift focus
            if (ref.current.contains(document.activeElement) && ref.current !== document.activeElement) return;
            let focusable = state.selectionManager.childFocusStrategy === "last" ? last(treeWalker) : treeWalker.firstChild();
            if (focusable) {
                (0, _focus.focusSafely)(focusable);
                return;
            }
        }
        if (keyWhenFocused.current != null && node.key !== keyWhenFocused.current || !ref.current.contains(document.activeElement)) (0, _focus.focusSafely)(ref.current);
    };
    let { itemProps, isPressed } = (0, _selection.useSelectableItem)({
        selectionManager: state.selectionManager,
        key: node.key,
        ref,
        isVirtualized,
        focus,
        shouldSelectOnPressUp,
        onAction: onCellAction ? ()=>onCellAction(node.key) : onAction,
        isDisabled: state.collection.size === 0
    });
    let onKeyDownCapture = (e)=>{
        if (!e.currentTarget.contains(e.target) || state.isKeyboardNavigationDisabled) return;
        let walker = (0, _focus.getFocusableTreeWalker)(ref.current);
        walker.currentNode = document.activeElement;
        switch(e.key){
            case "ArrowLeft":
                {
                    // Find the next focusable element within the cell.
                    let focusable = direction === "rtl" ? walker.nextNode() : walker.previousNode();
                    // Don't focus the cell itself if focusMode is "child"
                    if (focusMode === "child" && focusable === ref.current) focusable = null;
                    if (focusable) {
                        e.preventDefault();
                        e.stopPropagation();
                        (0, _focus.focusSafely)(focusable);
                        (0, _utils.scrollIntoViewport)(focusable, {
                            containingElement: (0, _utils.getScrollParent)(ref.current)
                        });
                    } else {
                        // If there is no next focusable child, then move to the next cell to the left of this one.
                        // This will be handled by useSelectableCollection. However, if there is no cell to the left
                        // of this one, only one column, and the grid doesn't focus rows, then the next key will be the
                        // same as this one. In that case we need to handle focusing either the cell or the first/last
                        // child, depending on the focus mode.
                        let prev = keyboardDelegate.getKeyLeftOf(node.key);
                        if (prev !== node.key) break;
                        e.preventDefault();
                        e.stopPropagation();
                        if (focusMode === "cell" && direction === "rtl") {
                            (0, _focus.focusSafely)(ref.current);
                            (0, _utils.scrollIntoViewport)(ref.current, {
                                containingElement: (0, _utils.getScrollParent)(ref.current)
                            });
                        } else {
                            walker.currentNode = ref.current;
                            focusable = direction === "rtl" ? walker.firstChild() : last(walker);
                            if (focusable) {
                                (0, _focus.focusSafely)(focusable);
                                (0, _utils.scrollIntoViewport)(focusable, {
                                    containingElement: (0, _utils.getScrollParent)(ref.current)
                                });
                            }
                        }
                    }
                    break;
                }
            case "ArrowRight":
                {
                    let focusable = direction === "rtl" ? walker.previousNode() : walker.nextNode();
                    if (focusMode === "child" && focusable === ref.current) focusable = null;
                    if (focusable) {
                        e.preventDefault();
                        e.stopPropagation();
                        (0, _focus.focusSafely)(focusable);
                        (0, _utils.scrollIntoViewport)(focusable, {
                            containingElement: (0, _utils.getScrollParent)(ref.current)
                        });
                    } else {
                        let next = keyboardDelegate.getKeyRightOf(node.key);
                        if (next !== node.key) break;
                        e.preventDefault();
                        e.stopPropagation();
                        if (focusMode === "cell" && direction === "ltr") {
                            (0, _focus.focusSafely)(ref.current);
                            (0, _utils.scrollIntoViewport)(ref.current, {
                                containingElement: (0, _utils.getScrollParent)(ref.current)
                            });
                        } else {
                            walker.currentNode = ref.current;
                            focusable = direction === "rtl" ? last(walker) : walker.firstChild();
                            if (focusable) {
                                (0, _focus.focusSafely)(focusable);
                                (0, _utils.scrollIntoViewport)(focusable, {
                                    containingElement: (0, _utils.getScrollParent)(ref.current)
                                });
                            }
                        }
                    }
                    break;
                }
            case "ArrowUp":
            case "ArrowDown":
                // Prevent this event from reaching cell children, e.g. menu buttons. We want arrow keys to navigate
                // to the cell above/below instead. We need to re-dispatch the event from a higher parent so it still
                // bubbles and gets handled by useSelectableCollection.
                if (!e.altKey && ref.current.contains(e.target)) {
                    e.stopPropagation();
                    e.preventDefault();
                    ref.current.parentElement.dispatchEvent(new KeyboardEvent(e.nativeEvent.type, e.nativeEvent));
                }
                break;
        }
    };
    // Grid cells can have focusable elements inside them. In this case, focus should
    // be marshalled to that element rather than focusing the cell itself.
    let onFocus = (e)=>{
        keyWhenFocused.current = node.key;
        if (e.target !== ref.current) {
            // useSelectableItem only handles setting the focused key when
            // the focused element is the gridcell itself. We also want to
            // set the focused key when a child element receives focus.
            // If focus is currently visible (e.g. the user is navigating with the keyboard),
            // then skip this. We want to restore focus to the previously focused row/cell
            // in that case since the table should act like a single tab stop.
            if (!(0, _interactions.isFocusVisible)()) state.selectionManager.setFocusedKey(node.key);
            return;
        }
        // If the cell itself is focused, wait a frame so that focus finishes propagatating
        // up to the tree, and move focus to a focusable child if possible.
        requestAnimationFrame(()=>{
            if (focusMode === "child" && document.activeElement === ref.current) focus();
        });
    };
    let gridCellProps = (0, _utils.mergeProps)(itemProps, {
        role: "gridcell",
        onKeyDownCapture,
        onFocus
    });
    var _node_colIndex;
    if (isVirtualized) gridCellProps["aria-colindex"] = ((_node_colIndex = node.colIndex) !== null && _node_colIndex !== void 0 ? _node_colIndex : node.index) + 1; // aria-colindex is 1-based
    // When pressing with a pointer and cell selection is not enabled, usePress will be applied to the
    // row rather than the cell. However, when the row is draggable, usePress cannot preventDefault
    // on pointer down, so the browser will try to focus the cell which has a tabIndex applied.
    // To avoid this, remove the tabIndex from the cell briefly on pointer down.
    if (shouldSelectOnPressUp && gridCellProps.tabIndex != null && gridCellProps.onPointerDown == null) gridCellProps.onPointerDown = (e)=>{
        let el = e.currentTarget;
        let tabindex = el.getAttribute("tabindex");
        el.removeAttribute("tabindex");
        requestAnimationFrame(()=>{
            el.setAttribute("tabindex", tabindex);
        });
    };
    return {
        gridCellProps,
        isPressed
    };
}
function last(walker) {
    let next;
    let last;
    do {
        last = walker.lastChild();
        if (last) next = last;
    }while (last);
    return next;
}

},{"@react-aria/focus":"42mbF","@react-aria/utils":"9cLk5","./utils":"2e0zc","@react-aria/interactions":"ky3G8","react":"9yzVZ","@react-aria/i18n":"411rg","@react-aria/selection":"6Fly5","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"dAxXr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides the behavior and accessibility implementation for a selection checkbox in a grid.
 * @param props - Props for the selection checkbox.
 * @param state - State of the grid, as returned by `useGridState`.
 */ parcelHelpers.export(exports, "useGridSelectionCheckbox", ()=>useGridSelectionCheckbox);
// @ts-ignore
var _json = require("../intl/*.json");
var _jsonDefault = parcelHelpers.interopDefault(_json);
var _utils = require("@react-aria/utils");
var _i18N = require("@react-aria/i18n");
function useGridSelectionCheckbox(props, state) {
    let { key } = props;
    let manager = state.selectionManager;
    let checkboxId = (0, _utils.useId)();
    let isDisabled = !state.selectionManager.canSelectItem(key);
    let isSelected = state.selectionManager.isSelected(key);
    let onChange = ()=>manager.select(key);
    const stringFormatter = (0, _i18N.useLocalizedStringFormatter)((0, _jsonDefault.default), "@react-aria/grid");
    return {
        checkboxProps: {
            id: checkboxId,
            "aria-label": stringFormatter.format("select"),
            isSelected,
            isDisabled,
            onChange
        }
    };
}

},{"../intl/*.json":"3Jbrd","@react-aria/utils":"9cLk5","@react-aria/i18n":"411rg","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"a06cG":[function(require,module,exports) {
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides the behavior and accessibility implementation for a row in a grid list.
 * @param props - Props for the row.
 * @param state - State of the parent list, as returned by `useListState`.
 * @param ref - The ref attached to the row element.
 */ parcelHelpers.export(exports, "useGridListItem", ()=>useGridListItem);
var _focus = require("@react-aria/focus");
var _utils = require("./utils");
var _utils1 = require("@react-aria/utils");
var _interactions = require("@react-aria/interactions");
var _react = require("react");
var _selection = require("@react-aria/selection");
var _i18N = require("@react-aria/i18n");
function useGridListItem(props, state, ref) {
    // Copied from useGridCell + some modifications to make it not so grid specific
    let { node, isVirtualized, shouldSelectOnPressUp } = props;
    let { direction } = (0, _i18N.useLocale)();
    let { onAction, linkBehavior } = (0, _utils.listMap).get(state);
    let descriptionId = (0, _utils1.useSlotId)();
    // We need to track the key of the item at the time it was last focused so that we force
    // focus to go to the item when the DOM node is reused for a different item in a virtualizer.
    let keyWhenFocused = (0, _react.useRef)(null);
    let focus = ()=>{
        // Don't shift focus to the row if the active element is a element within the row already
        // (e.g. clicking on a row button)
        if (keyWhenFocused.current != null && node.key !== keyWhenFocused.current || !ref.current.contains(document.activeElement)) (0, _focus.focusSafely)(ref.current);
    };
    let { itemProps, ...itemStates } = (0, _selection.useSelectableItem)({
        selectionManager: state.selectionManager,
        key: node.key,
        ref,
        isVirtualized,
        shouldSelectOnPressUp,
        onAction: onAction ? ()=>onAction(node.key) : undefined,
        focus,
        linkBehavior
    });
    let onKeyDown = (e)=>{
        if (!e.currentTarget.contains(e.target)) return;
        let walker = (0, _focus.getFocusableTreeWalker)(ref.current);
        walker.currentNode = document.activeElement;
        switch(e.key){
            case "ArrowLeft":
                {
                    // Find the next focusable element within the row.
                    let focusable = direction === "rtl" ? walker.nextNode() : walker.previousNode();
                    if (focusable) {
                        e.preventDefault();
                        e.stopPropagation();
                        (0, _focus.focusSafely)(focusable);
                        (0, _utils1.scrollIntoViewport)(focusable, {
                            containingElement: (0, _utils1.getScrollParent)(ref.current)
                        });
                    } else {
                        // If there is no next focusable child, then return focus back to the row
                        e.preventDefault();
                        e.stopPropagation();
                        if (direction === "rtl") {
                            (0, _focus.focusSafely)(ref.current);
                            (0, _utils1.scrollIntoViewport)(ref.current, {
                                containingElement: (0, _utils1.getScrollParent)(ref.current)
                            });
                        } else {
                            walker.currentNode = ref.current;
                            let lastElement = last(walker);
                            if (lastElement) {
                                (0, _focus.focusSafely)(lastElement);
                                (0, _utils1.scrollIntoViewport)(lastElement, {
                                    containingElement: (0, _utils1.getScrollParent)(ref.current)
                                });
                            }
                        }
                    }
                    break;
                }
            case "ArrowRight":
                {
                    let focusable = direction === "rtl" ? walker.previousNode() : walker.nextNode();
                    if (focusable) {
                        e.preventDefault();
                        e.stopPropagation();
                        (0, _focus.focusSafely)(focusable);
                        (0, _utils1.scrollIntoViewport)(focusable, {
                            containingElement: (0, _utils1.getScrollParent)(ref.current)
                        });
                    } else {
                        e.preventDefault();
                        e.stopPropagation();
                        if (direction === "ltr") {
                            (0, _focus.focusSafely)(ref.current);
                            (0, _utils1.scrollIntoViewport)(ref.current, {
                                containingElement: (0, _utils1.getScrollParent)(ref.current)
                            });
                        } else {
                            walker.currentNode = ref.current;
                            let lastElement = last(walker);
                            if (lastElement) {
                                (0, _focus.focusSafely)(lastElement);
                                (0, _utils1.scrollIntoViewport)(lastElement, {
                                    containingElement: (0, _utils1.getScrollParent)(ref.current)
                                });
                            }
                        }
                    }
                    break;
                }
            case "ArrowUp":
            case "ArrowDown":
                // Prevent this event from reaching row children, e.g. menu buttons. We want arrow keys to navigate
                // to the row above/below instead. We need to re-dispatch the event from a higher parent so it still
                // bubbles and gets handled by useSelectableCollection.
                if (!e.altKey && ref.current.contains(e.target)) {
                    e.stopPropagation();
                    e.preventDefault();
                    ref.current.parentElement.dispatchEvent(new KeyboardEvent(e.nativeEvent.type, e.nativeEvent));
                }
                break;
        }
    };
    let onFocus = (e)=>{
        keyWhenFocused.current = node.key;
        if (e.target !== ref.current) {
            // useSelectableItem only handles setting the focused key when
            // the focused element is the row itself. We also want to
            // set the focused key when a child element receives focus.
            // If focus is currently visible (e.g. the user is navigating with the keyboard),
            // then skip this. We want to restore focus to the previously focused row
            // in that case since the list should act like a single tab stop.
            if (!(0, _interactions.isFocusVisible)()) state.selectionManager.setFocusedKey(node.key);
            return;
        }
    };
    let linkProps = itemStates.hasAction ? (0, _utils1.getSyntheticLinkProps)(node.props) : {};
    let rowProps = (0, _utils1.mergeProps)(itemProps, linkProps, {
        role: "row",
        onKeyDownCapture: onKeyDown,
        onFocus,
        "aria-label": node.textValue || undefined,
        "aria-selected": state.selectionManager.canSelectItem(node.key) ? state.selectionManager.isSelected(node.key) : undefined,
        "aria-disabled": state.selectionManager.isDisabled(node.key) || undefined,
        "aria-labelledby": descriptionId && node.textValue ? `${(0, _utils.getRowId)(state, node.key)} ${descriptionId}` : undefined,
        id: (0, _utils.getRowId)(state, node.key)
    });
    if (isVirtualized) rowProps["aria-rowindex"] = node.index + 1;
    let gridCellProps = {
        role: "gridcell",
        "aria-colindex": 1
    };
    return {
        rowProps,
        gridCellProps,
        descriptionProps: {
            id: descriptionId
        },
        ...itemStates
    };
}
function last(walker) {
    let next;
    let last;
    do {
        last = walker.lastChild();
        if (last) next = last;
    }while (last);
    return next;
}

},{"@react-aria/focus":"42mbF","./utils":"coliS","@react-aria/utils":"9cLk5","@react-aria/interactions":"ky3G8","react":"9yzVZ","@react-aria/selection":"6Fly5","@react-aria/i18n":"411rg","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"i7lhk":[function(require,module,exports) {
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides the behavior and accessibility implementation for a selection checkbox in a grid list.
 * @param props - Props for the selection checkbox.
 * @param state - State of the list, as returned by `useListState`.
 */ parcelHelpers.export(exports, "useGridListSelectionCheckbox", ()=>useGridListSelectionCheckbox);
var _grid = require("@react-aria/grid");
var _utils = require("./utils");
function useGridListSelectionCheckbox(props, state) {
    let { key } = props;
    const { checkboxProps } = (0, _grid.useGridSelectionCheckbox)(props, state);
    return {
        checkboxProps: {
            ...checkboxProps,
            "aria-labelledby": `${checkboxProps.id} ${(0, _utils.getRowId)(state, key)}`
        }
    };
}

},{"@react-aria/grid":"6tGaN","./utils":"coliS","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"9oBtl":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useMeter", ()=>(0, _useMeter.useMeter));
var _useMeter = require("./useMeter");

},{"./useMeter":"axl4o","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"axl4o":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides the accessibility implementation for a meter component.
 * Meters represent a quantity within a known range, or a fractional value.
 */ parcelHelpers.export(exports, "useMeter", ()=>useMeter);
var _progress = require("@react-aria/progress");
function useMeter(props) {
    let { progressBarProps, labelProps } = (0, _progress.useProgressBar)(props);
    return {
        meterProps: {
            ...progressBarProps,
            // Use the meter role if available, but fall back to progressbar if not
            // Chrome currently falls back from meter automatically, and Firefox
            // does not support meter at all. Safari 13+ seems to support meter properly.
            // https://bugs.chromium.org/p/chromium/issues/detail?id=944542
            // https://bugzilla.mozilla.org/show_bug.cgi?id=1460378
            role: "meter progressbar"
        },
        labelProps
    };
}

},{"@react-aria/progress":"NyXcB","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"NyXcB":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useProgressBar", ()=>(0, _useProgressBar.useProgressBar));
var _useProgressBar = require("./useProgressBar");

},{"./useProgressBar":"5Mun9","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"5Mun9":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides the accessibility implementation for a progress bar component.
 * Progress bars show either determinate or indeterminate progress of an operation
 * over time.
 */ parcelHelpers.export(exports, "useProgressBar", ()=>useProgressBar);
var _utils = require("@react-aria/utils");
var _label = require("@react-aria/label");
var _i18N = require("@react-aria/i18n");
function useProgressBar(props) {
    let { value = 0, minValue = 0, maxValue = 100, valueLabel, isIndeterminate, formatOptions = {
        style: "percent"
    } } = props;
    let domProps = (0, _utils.filterDOMProps)(props, {
        labelable: true
    });
    let { labelProps, fieldProps } = (0, _label.useLabel)({
        ...props,
        // Progress bar is not an HTML input element so it
        // shouldn't be labeled by a <label> element.
        labelElementType: "span"
    });
    value = (0, _utils.clamp)(value, minValue, maxValue);
    let percentage = (value - minValue) / (maxValue - minValue);
    let formatter = (0, _i18N.useNumberFormatter)(formatOptions);
    if (!isIndeterminate && !valueLabel) {
        let valueToFormat = formatOptions.style === "percent" ? percentage : value;
        valueLabel = formatter.format(valueToFormat);
    }
    return {
        progressBarProps: (0, _utils.mergeProps)(domProps, {
            ...fieldProps,
            "aria-valuenow": isIndeterminate ? undefined : value,
            "aria-valuemin": minValue,
            "aria-valuemax": maxValue,
            "aria-valuetext": isIndeterminate ? undefined : valueLabel,
            role: "progressbar"
        }),
        labelProps
    };
}

},{"@react-aria/utils":"9cLk5","@react-aria/label":"74Ccz","@react-aria/i18n":"411rg","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"13aeo":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useNumberField", ()=>(0, _useNumberField.useNumberField));
var _useNumberField = require("./useNumberField");

},{"./useNumberField":"kVR5s","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"kVR5s":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides the behavior and accessibility implementation for a number field component.
 * Number fields allow users to enter a number, and increment or decrement the value using stepper buttons.
 */ parcelHelpers.export(exports, "useNumberField", ()=>useNumberField);
var _utils = require("@react-aria/utils");
var _react = require("react");
// @ts-ignore
var _json = require("../intl/*.json");
var _jsonDefault = parcelHelpers.interopDefault(_json);
var _form = require("@react-stately/form");
var _interactions = require("@react-aria/interactions");
var _textfield = require("@react-aria/textfield");
var _i18N = require("@react-aria/i18n");
var _spinbutton = require("@react-aria/spinbutton");
function useNumberField(props, state, inputRef) {
    let { id, decrementAriaLabel, incrementAriaLabel, isDisabled, isReadOnly, isRequired, minValue, maxValue, autoFocus, label, formatOptions, onBlur = ()=>{}, onFocus, onFocusChange, onKeyDown, onKeyUp, description, errorMessage, isWheelDisabled, ...otherProps } = props;
    let { increment, incrementToMax, decrement, decrementToMin, numberValue, inputValue, commit, commitValidation } = state;
    const stringFormatter = (0, _i18N.useLocalizedStringFormatter)((0, _jsonDefault.default), "@react-aria/numberfield");
    let inputId = (0, _utils.useId)(id);
    let { focusProps } = (0, _interactions.useFocus)({
        onBlur () {
            // Set input value to normalized valid value
            commit();
        }
    });
    let numberFormatter = (0, _i18N.useNumberFormatter)(formatOptions);
    let intlOptions = (0, _react.useMemo)(()=>numberFormatter.resolvedOptions(), [
        numberFormatter
    ]);
    // Replace negative textValue formatted using currencySign: 'accounting'
    // with a textValue that can be announced using a minus sign.
    let textValueFormatter = (0, _i18N.useNumberFormatter)({
        ...formatOptions,
        currencySign: undefined
    });
    let textValue = (0, _react.useMemo)(()=>isNaN(numberValue) ? "" : textValueFormatter.format(numberValue), [
        textValueFormatter,
        numberValue
    ]);
    let { spinButtonProps, incrementButtonProps: incButtonProps, decrementButtonProps: decButtonProps } = (0, _spinbutton.useSpinButton)({
        isDisabled,
        isReadOnly,
        isRequired,
        maxValue,
        minValue,
        onIncrement: increment,
        onIncrementToMax: incrementToMax,
        onDecrement: decrement,
        onDecrementToMin: decrementToMin,
        value: numberValue,
        textValue
    });
    let [focusWithin, setFocusWithin] = (0, _react.useState)(false);
    let { focusWithinProps } = (0, _interactions.useFocusWithin)({
        isDisabled,
        onFocusWithinChange: setFocusWithin
    });
    let onWheel = (0, _react.useCallback)((e)=>{
        // if on a trackpad, users can scroll in both X and Y at once, check the magnitude of the change
        // if it's mostly in the X direction, then just return, the user probably doesn't mean to inc/dec
        // this isn't perfect, events come in fast with small deltas and a part of the scroll may give a false indication
        // especially if the user is scrolling near 45deg
        if (Math.abs(e.deltaY) <= Math.abs(e.deltaX)) return;
        if (e.deltaY > 0) increment();
        else if (e.deltaY < 0) decrement();
    }, [
        decrement,
        increment
    ]);
    // If the input isn't supposed to receive input, disable scrolling.
    let scrollingDisabled = isWheelDisabled || isDisabled || isReadOnly || !focusWithin;
    (0, _interactions.useScrollWheel)({
        onScroll: onWheel,
        isDisabled: scrollingDisabled
    }, inputRef);
    // The inputMode attribute influences the software keyboard that is shown on touch devices.
    // Browsers and operating systems are quite inconsistent about what keys are available, however.
    // We choose between numeric and decimal based on whether we allow negative and fractional numbers,
    // and based on testing on various devices to determine what keys are available in each inputMode.
    let hasDecimals = intlOptions.maximumFractionDigits > 0;
    let hasNegative = state.minValue === undefined || isNaN(state.minValue) || state.minValue < 0;
    let inputMode = "numeric";
    if ((0, _utils.isIPhone)()) {
        // iPhone doesn't have a minus sign in either numeric or decimal.
        // Note this is only for iPhone, not iPad, which always has both
        // minus and decimal in numeric.
        if (hasNegative) inputMode = "text";
        else if (hasDecimals) inputMode = "decimal";
    } else if ((0, _utils.isAndroid)()) {
        // Android numeric has both a decimal point and minus key.
        // decimal does not have a minus key.
        if (hasNegative) inputMode = "numeric";
        else if (hasDecimals) inputMode = "decimal";
    }
    let onChange = (value)=>{
        if (state.validate(value)) state.setInputValue(value);
    };
    let domProps = (0, _utils.filterDOMProps)(props);
    let onKeyDownEnter = (0, _react.useCallback)((e)=>{
        if (e.key === "Enter") {
            commit();
            commitValidation();
        } else e.continuePropagation();
    }, [
        commit,
        commitValidation
    ]);
    let { isInvalid, validationErrors, validationDetails } = state.displayValidation;
    let { labelProps, inputProps: textFieldProps, descriptionProps, errorMessageProps } = (0, _textfield.useFormattedTextField)({
        ...otherProps,
        ...domProps,
        name: undefined,
        label,
        autoFocus,
        isDisabled,
        isReadOnly,
        isRequired,
        validate: undefined,
        [(0, _form.privateValidationStateProp)]: state,
        value: inputValue,
        defaultValue: undefined,
        autoComplete: "off",
        "aria-label": props["aria-label"] || undefined,
        "aria-labelledby": props["aria-labelledby"] || undefined,
        id: inputId,
        type: "text",
        inputMode,
        onChange,
        onBlur,
        onFocus,
        onFocusChange,
        onKeyDown: (0, _react.useMemo)(()=>(0, _utils.chain)(onKeyDownEnter, onKeyDown), [
            onKeyDownEnter,
            onKeyDown
        ]),
        onKeyUp,
        description,
        errorMessage
    }, state, inputRef);
    (0, _utils.useFormReset)(inputRef, state.numberValue, state.setNumberValue);
    let inputProps = (0, _utils.mergeProps)(spinButtonProps, focusProps, textFieldProps, {
        // override the spinbutton role, we can't focus a spin button with VO
        role: null,
        // ignore aria-roledescription on iOS so that required state will announce when it is present
        "aria-roledescription": !(0, _utils.isIOS)() ? stringFormatter.format("numberField") : null,
        "aria-valuemax": null,
        "aria-valuemin": null,
        "aria-valuenow": null,
        "aria-valuetext": null,
        autoCorrect: "off",
        spellCheck: "false"
    });
    if (props.validationBehavior === "native") inputProps["aria-required"] = undefined;
    let onButtonPressStart = (e)=>{
        var _inputRef_current;
        // If focus is already on the input, keep it there so we don't hide the
        // software keyboard when tapping the increment/decrement buttons.
        if (document.activeElement === inputRef.current) return;
        // Otherwise, when using a mouse, move focus to the input.
        // On touch, or with a screen reader, focus the button so that the software
        // keyboard does not appear and the screen reader cursor is not moved off the button.
        if (e.pointerType === "mouse") (_inputRef_current = inputRef.current) === null || _inputRef_current === void 0 ? void 0 : _inputRef_current.focus();
        else e.target.focus();
    };
    // Determine the label for the increment and decrement buttons. There are 4 cases:
    //
    // 1. With a visible label that is a string: aria-label: `Increase ${props.label}`
    // 2. With a visible label that is JSX: aria-label: 'Increase', aria-labelledby: '${incrementId} ${labelId}'
    // 3. With an aria-label: aria-label: `Increase ${props['aria-label']}`
    // 4. With an aria-labelledby: aria-label: 'Increase', aria-labelledby: `${incrementId} ${props['aria-labelledby']}`
    //
    // (1) and (2) could possibly be combined and both use aria-labelledby. However, placing the label in
    // the aria-label string rather than using aria-labelledby gives more flexibility to translators to change
    // the order or add additional words around the label if needed.
    let fieldLabel = props["aria-label"] || (typeof props.label === "string" ? props.label : "");
    let ariaLabelledby;
    if (!fieldLabel) ariaLabelledby = props.label != null ? labelProps.id : props["aria-labelledby"];
    let incrementId = (0, _utils.useId)();
    let decrementId = (0, _utils.useId)();
    let incrementButtonProps = (0, _utils.mergeProps)(incButtonProps, {
        "aria-label": incrementAriaLabel || stringFormatter.format("increase", {
            fieldLabel
        }).trim(),
        id: ariaLabelledby && !incrementAriaLabel ? incrementId : null,
        "aria-labelledby": ariaLabelledby && !incrementAriaLabel ? `${incrementId} ${ariaLabelledby}` : null,
        "aria-controls": inputId,
        excludeFromTabOrder: true,
        preventFocusOnPress: true,
        allowFocusWhenDisabled: true,
        isDisabled: !state.canIncrement,
        onPressStart: onButtonPressStart
    });
    let decrementButtonProps = (0, _utils.mergeProps)(decButtonProps, {
        "aria-label": decrementAriaLabel || stringFormatter.format("decrease", {
            fieldLabel
        }).trim(),
        id: ariaLabelledby && !decrementAriaLabel ? decrementId : null,
        "aria-labelledby": ariaLabelledby && !decrementAriaLabel ? `${decrementId} ${ariaLabelledby}` : null,
        "aria-controls": inputId,
        excludeFromTabOrder: true,
        preventFocusOnPress: true,
        allowFocusWhenDisabled: true,
        isDisabled: !state.canDecrement,
        onPressStart: onButtonPressStart
    });
    return {
        groupProps: {
            ...focusWithinProps,
            role: "group",
            "aria-disabled": isDisabled,
            "aria-invalid": isInvalid ? "true" : undefined
        },
        labelProps,
        inputProps,
        incrementButtonProps,
        decrementButtonProps,
        errorMessageProps,
        descriptionProps,
        isInvalid,
        validationErrors,
        validationDetails
    };
}

},{"@react-aria/utils":"9cLk5","react":"9yzVZ","../intl/*.json":"4s1aP","@react-stately/form":"9yZqm","@react-aria/interactions":"ky3G8","@react-aria/textfield":"6dEv6","@react-aria/i18n":"411rg","@react-aria/spinbutton":"3vYfp","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"4s1aP":[function(require,module,exports) {
const _temp0 = require("185fee3035ca863b");
const _temp1 = require("3da6a8e4ed76ec6c");
const _temp2 = require("92021157ee0a262d");
const _temp3 = require("e4fc979f0cb1a0bb");
const _temp4 = require("336aee81b16595ed");
const _temp5 = require("a7cf322fc6e5ac34");
const _temp6 = require("fd0e8468a3bbff35");
const _temp7 = require("1f804eead1266472");
const _temp8 = require("a8dcbe18299f90b8");
const _temp9 = require("1ba4f693512a409e");
const _temp10 = require("f29fb461ab69f34f");
const _temp11 = require("4720ccf3baab71af");
const _temp12 = require("cd5794f7c8320d11");
const _temp13 = require("2c146b929f8ee675");
const _temp14 = require("2d3ecc1480a15d3f");
const _temp15 = require("c7cea25327e9e4f3");
const _temp16 = require("edb352aebb28969a");
const _temp17 = require("8c810638fc8b278d");
const _temp18 = require("b6de8393112d87dc");
const _temp19 = require("d334de30bfd941e4");
const _temp20 = require("c7ceef2128aeed91");
const _temp21 = require("a0fe1a7fd6d8ce74");
const _temp22 = require("932bdb42145ba3d1");
const _temp23 = require("eba100dd9c59ae90");
const _temp24 = require("475054a408226edb");
const _temp25 = require("8a56c91361b72742");
const _temp26 = require("915ea6f6f212c4c4");
const _temp27 = require("af07df4a537a2816");
const _temp28 = require("3156a0852d2e753a");
const _temp29 = require("bb98204977e55e0c");
const _temp30 = require("abb04c1ae90c3b3b");
const _temp31 = require("8ef0d3a5b47edd6");
const _temp32 = require("30cba5c7f09f9771");
const _temp33 = require("d80c2022dd982182");
module.exports = {
    "ar-AE": _temp0,
    "bg-BG": _temp1,
    "cs-CZ": _temp2,
    "da-DK": _temp3,
    "de-DE": _temp4,
    "el-GR": _temp5,
    "en-US": _temp6,
    "es-ES": _temp7,
    "et-EE": _temp8,
    "fi-FI": _temp9,
    "fr-FR": _temp10,
    "he-IL": _temp11,
    "hr-HR": _temp12,
    "hu-HU": _temp13,
    "it-IT": _temp14,
    "ja-JP": _temp15,
    "ko-KR": _temp16,
    "lt-LT": _temp17,
    "lv-LV": _temp18,
    "nb-NO": _temp19,
    "nl-NL": _temp20,
    "pl-PL": _temp21,
    "pt-BR": _temp22,
    "pt-PT": _temp23,
    "ro-RO": _temp24,
    "ru-RU": _temp25,
    "sk-SK": _temp26,
    "sl-SI": _temp27,
    "sr-SP": _temp28,
    "sv-SE": _temp29,
    "tr-TR": _temp30,
    "uk-UA": _temp31,
    "zh-CN": _temp32,
    "zh-TW": _temp33
};

},{"185fee3035ca863b":"cmWkr","3da6a8e4ed76ec6c":"bad0v","92021157ee0a262d":"dPBA2","e4fc979f0cb1a0bb":"i7t9p","336aee81b16595ed":"2Ld97","a7cf322fc6e5ac34":"5Rb71","fd0e8468a3bbff35":"aKJWr","1f804eead1266472":"62ynM","a8dcbe18299f90b8":"7diVL","1ba4f693512a409e":"iIwM5","f29fb461ab69f34f":"csFpp","4720ccf3baab71af":"eW5AI","cd5794f7c8320d11":"igbR4","2c146b929f8ee675":"khHLB","2d3ecc1480a15d3f":"gUs3l","c7cea25327e9e4f3":"4JCM9","edb352aebb28969a":"05fUQ","8c810638fc8b278d":"1zDUB","b6de8393112d87dc":"hcNrD","d334de30bfd941e4":"48Zgz","c7ceef2128aeed91":"iPtVd","a0fe1a7fd6d8ce74":"kBAiH","932bdb42145ba3d1":"dM0T7","eba100dd9c59ae90":"14QlD","475054a408226edb":"b1R1b","8a56c91361b72742":"WRgJo","915ea6f6f212c4c4":"8Z7J7","af07df4a537a2816":"5xtR0","3156a0852d2e753a":"6TKjg","bb98204977e55e0c":"dU9Ae","abb04c1ae90c3b3b":"77yRQ","8ef0d3a5b47edd6":"99iSH","30cba5c7f09f9771":"1tA7Z","d80c2022dd982182":"31cX1"}],"cmWkr":[function(require,module,exports) {
module.exports = {
    "decrease": (args)=>`\u{62E}\u{641}\u{636} ${args.fieldLabel}`,
    "increase": (args)=>`\u{632}\u{64A}\u{627}\u{62F}\u{629} ${args.fieldLabel}`,
    "numberField": `\u{62D}\u{642}\u{644} \u{631}\u{642}\u{645}\u{64A}`
};

},{}],"bad0v":[function(require,module,exports) {
module.exports = {
    "decrease": (args)=>`\u{41D}\u{430}\u{43C}\u{430}\u{43B}\u{44F}\u{432}\u{430}\u{43D}\u{435} ${args.fieldLabel}`,
    "increase": (args)=>`\u{423}\u{441}\u{438}\u{43B}\u{432}\u{430}\u{43D}\u{435} ${args.fieldLabel}`,
    "numberField": `\u{41D}\u{43E}\u{43C}\u{435}\u{440} \u{43D}\u{430} \u{43F}\u{43E}\u{43B}\u{435}\u{442}\u{43E}`
};

},{}],"dPBA2":[function(require,module,exports) {
module.exports = {
    "decrease": (args)=>`Sn\xed\u{17E}it ${args.fieldLabel}`,
    "increase": (args)=>`Zv\xfd\u{161}it ${args.fieldLabel}`,
    "numberField": `\u{10C}\xedseln\xe9 pole`
};

},{}],"i7t9p":[function(require,module,exports) {
module.exports = {
    "decrease": (args)=>`Reducer ${args.fieldLabel}`,
    "increase": (args)=>`\xd8g ${args.fieldLabel}`,
    "numberField": `Talfelt`
};

},{}],"2Ld97":[function(require,module,exports) {
module.exports = {
    "decrease": (args)=>`${args.fieldLabel} verringern`,
    "increase": (args)=>`${args.fieldLabel} erh\xf6hen`,
    "numberField": `Nummernfeld`
};

},{}],"5Rb71":[function(require,module,exports) {
module.exports = {
    "decrease": (args)=>`\u{39C}\u{3B5}\u{3AF}\u{3C9}\u{3C3}\u{3B7} ${args.fieldLabel}`,
    "increase": (args)=>`\u{391}\u{3CD}\u{3BE}\u{3B7}\u{3C3}\u{3B7} ${args.fieldLabel}`,
    "numberField": `\u{3A0}\u{3B5}\u{3B4}\u{3AF}\u{3BF} \u{3B1}\u{3C1}\u{3B9}\u{3B8}\u{3BC}\u{3BF}\u{3CD}`
};

},{}],"aKJWr":[function(require,module,exports) {
module.exports = {
    "decrease": (args)=>`Decrease ${args.fieldLabel}`,
    "increase": (args)=>`Increase ${args.fieldLabel}`,
    "numberField": `Number field`
};

},{}],"62ynM":[function(require,module,exports) {
module.exports = {
    "decrease": (args)=>`Reducir ${args.fieldLabel}`,
    "increase": (args)=>`Aumentar ${args.fieldLabel}`,
    "numberField": `Campo de n\xfamero`
};

},{}],"7diVL":[function(require,module,exports) {
module.exports = {
    "decrease": (args)=>`V\xe4henda ${args.fieldLabel}`,
    "increase": (args)=>`Suurenda ${args.fieldLabel}`,
    "numberField": `Numbri v\xe4li`
};

},{}],"iIwM5":[function(require,module,exports) {
module.exports = {
    "decrease": (args)=>`V\xe4henn\xe4 ${args.fieldLabel}`,
    "increase": (args)=>`Lis\xe4\xe4 ${args.fieldLabel}`,
    "numberField": `Numerokentt\xe4`
};

},{}],"csFpp":[function(require,module,exports) {
module.exports = {
    "decrease": (args)=>`Diminuer ${args.fieldLabel}`,
    "increase": (args)=>`Augmenter ${args.fieldLabel}`,
    "numberField": `Champ de nombre`
};

},{}],"eW5AI":[function(require,module,exports) {
module.exports = {
    "decrease": (args)=>`\u{5D4}\u{5E7}\u{5D8}\u{5DF} ${args.fieldLabel}`,
    "increase": (args)=>`\u{5D4}\u{5D2}\u{5D3}\u{5DC} ${args.fieldLabel}`,
    "numberField": `\u{5E9}\u{5D3}\u{5D4} \u{5DE}\u{5E1}\u{5E4}\u{5E8}`
};

},{}],"igbR4":[function(require,module,exports) {
module.exports = {
    "decrease": (args)=>`Smanji ${args.fieldLabel}`,
    "increase": (args)=>`Pove\u{107}aj ${args.fieldLabel}`,
    "numberField": `Polje broja`
};

},{}],"khHLB":[function(require,module,exports) {
module.exports = {
    "decrease": (args)=>`${args.fieldLabel} cs\xf6kkent\xe9se`,
    "increase": (args)=>`${args.fieldLabel} n\xf6vel\xe9se`,
    "numberField": `Sz\xe1mmez\u{151}`
};

},{}],"gUs3l":[function(require,module,exports) {
module.exports = {
    "decrease": (args)=>`Riduci ${args.fieldLabel}`,
    "increase": (args)=>`Aumenta ${args.fieldLabel}`,
    "numberField": `Campo numero`
};

},{}],"4JCM9":[function(require,module,exports) {
module.exports = {
    "decrease": (args)=>`${args.fieldLabel}\u{3092}\u{7E2E}\u{5C0F}`,
    "increase": (args)=>`${args.fieldLabel}\u{3092}\u{62E1}\u{5927}`,
    "numberField": `\u{6570}\u{5024}\u{30D5}\u{30A3}\u{30FC}\u{30EB}\u{30C9}`
};

},{}],"05fUQ":[function(require,module,exports) {
module.exports = {
    "decrease": (args)=>`${args.fieldLabel} \u{AC10}\u{C18C}`,
    "increase": (args)=>`${args.fieldLabel} \u{C99D}\u{AC00}`,
    "numberField": `\u{BC88}\u{D638} \u{D544}\u{B4DC}`
};

},{}],"1zDUB":[function(require,module,exports) {
module.exports = {
    "decrease": (args)=>`Suma\u{17E}inti ${args.fieldLabel}`,
    "increase": (args)=>`Padidinti ${args.fieldLabel}`,
    "numberField": `Numerio laukas`
};

},{}],"hcNrD":[function(require,module,exports) {
module.exports = {
    "decrease": (args)=>`Samazin\u{101}\u{161}ana ${args.fieldLabel}`,
    "increase": (args)=>`Palielin\u{101}\u{161}ana ${args.fieldLabel}`,
    "numberField": `Skait\u{13C}u lauks`
};

},{}],"48Zgz":[function(require,module,exports) {
module.exports = {
    "decrease": (args)=>`Reduser ${args.fieldLabel}`,
    "increase": (args)=>`\xd8k ${args.fieldLabel}`,
    "numberField": `Tallfelt`
};

},{}],"iPtVd":[function(require,module,exports) {
module.exports = {
    "decrease": (args)=>`${args.fieldLabel} verlagen`,
    "increase": (args)=>`${args.fieldLabel} verhogen`,
    "numberField": `Getalveld`
};

},{}],"kBAiH":[function(require,module,exports) {
module.exports = {
    "decrease": (args)=>`Zmniejsz ${args.fieldLabel}`,
    "increase": (args)=>`Zwi\u{119}ksz ${args.fieldLabel}`,
    "numberField": `Pole numeru`
};

},{}],"dM0T7":[function(require,module,exports) {
module.exports = {
    "decrease": (args)=>`Diminuir ${args.fieldLabel}`,
    "increase": (args)=>`Aumentar ${args.fieldLabel}`,
    "numberField": `Campo de n\xfamero`
};

},{}],"14QlD":[function(require,module,exports) {
module.exports = {
    "decrease": (args)=>`Diminuir ${args.fieldLabel}`,
    "increase": (args)=>`Aumentar ${args.fieldLabel}`,
    "numberField": `Campo num\xe9rico`
};

},{}],"b1R1b":[function(require,module,exports) {
module.exports = {
    "decrease": (args)=>`Sc\u{103}dere ${args.fieldLabel}`,
    "increase": (args)=>`Cre\u{219}tere ${args.fieldLabel}`,
    "numberField": `C\xe2mp numeric`
};

},{}],"WRgJo":[function(require,module,exports) {
module.exports = {
    "decrease": (args)=>`\u{423}\u{43C}\u{435}\u{43D}\u{44C}\u{448}\u{435}\u{43D}\u{438}\u{435} ${args.fieldLabel}`,
    "increase": (args)=>`\u{423}\u{432}\u{435}\u{43B}\u{438}\u{447}\u{435}\u{43D}\u{438}\u{435} ${args.fieldLabel}`,
    "numberField": `\u{427}\u{438}\u{441}\u{43B}\u{43E}\u{432}\u{43E}\u{435} \u{43F}\u{43E}\u{43B}\u{435}`
};

},{}],"8Z7J7":[function(require,module,exports) {
module.exports = {
    "decrease": (args)=>`Zn\xed\u{17E}i\u{165} ${args.fieldLabel}`,
    "increase": (args)=>`Zv\xfd\u{161}i\u{165} ${args.fieldLabel}`,
    "numberField": `\u{10C}\xedseln\xe9 pole`
};

},{}],"5xtR0":[function(require,module,exports) {
module.exports = {
    "decrease": (args)=>`Upadati ${args.fieldLabel}`,
    "increase": (args)=>`Pove\u{10D}ajte ${args.fieldLabel}`,
    "numberField": `\u{160}tevil\u{10D}no polje`
};

},{}],"6TKjg":[function(require,module,exports) {
module.exports = {
    "decrease": (args)=>`Smanji ${args.fieldLabel}`,
    "increase": (args)=>`Pove\u{107}aj ${args.fieldLabel}`,
    "numberField": `Polje broja`
};

},{}],"dU9Ae":[function(require,module,exports) {
module.exports = {
    "decrease": (args)=>`Minska ${args.fieldLabel}`,
    "increase": (args)=>`\xd6ka ${args.fieldLabel}`,
    "numberField": `Nummerf\xe4lt`
};

},{}],"77yRQ":[function(require,module,exports) {
module.exports = {
    "decrease": (args)=>`${args.fieldLabel} azalt`,
    "increase": (args)=>`${args.fieldLabel} artt\u{131}r`,
    "numberField": `Say\u{131} alan\u{131}`
};

},{}],"99iSH":[function(require,module,exports) {
module.exports = {
    "decrease": (args)=>`\u{417}\u{43C}\u{435}\u{43D}\u{448}\u{438}\u{442}\u{438} ${args.fieldLabel}`,
    "increase": (args)=>`\u{417}\u{431}\u{456}\u{43B}\u{44C}\u{448}\u{438}\u{442}\u{438} ${args.fieldLabel}`,
    "numberField": `\u{41F}\u{43E}\u{43B}\u{435} \u{43D}\u{43E}\u{43C}\u{435}\u{440}\u{430}`
};

},{}],"1tA7Z":[function(require,module,exports) {
module.exports = {
    "decrease": (args)=>`\u{964D}\u{4F4E} ${args.fieldLabel}`,
    "increase": (args)=>`\u{63D0}\u{9AD8} ${args.fieldLabel}`,
    "numberField": `\u{6570}\u{5B57}\u{5B57}\u{6BB5}`
};

},{}],"31cX1":[function(require,module,exports) {
module.exports = {
    "decrease": (args)=>`\u{7E2E}\u{5C0F} ${args.fieldLabel}`,
    "increase": (args)=>`\u{653E}\u{5927} ${args.fieldLabel}`,
    "numberField": `\u{6578}\u{5B57}\u{6B04}\u{4F4D}`
};

},{}],"25mgs":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useRadio", ()=>(0, _useRadio.useRadio));
parcelHelpers.export(exports, "useRadioGroup", ()=>(0, _useRadioGroup.useRadioGroup));
var _useRadio = require("./useRadio");
var _useRadioGroup = require("./useRadioGroup");

},{"./useRadio":"cHxlL","./useRadioGroup":"hovcu","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"cHxlL":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides the behavior and accessibility implementation for an individual
 * radio button in a radio group.
 * @param props - Props for the radio.
 * @param state - State for the radio group, as returned by `useRadioGroupState`.
 * @param ref - Ref to the HTML input element.
 */ parcelHelpers.export(exports, "useRadio", ()=>useRadio);
var _utils = require("@react-aria/utils");
var _utils1 = require("./utils");
var _focus = require("@react-aria/focus");
var _form = require("@react-aria/form");
var _interactions = require("@react-aria/interactions");
function useRadio(props, state, ref) {
    let { value, children, "aria-label": ariaLabel, "aria-labelledby": ariaLabelledby } = props;
    const isDisabled = props.isDisabled || state.isDisabled;
    let hasChildren = children != null;
    let hasAriaLabel = ariaLabel != null || ariaLabelledby != null;
    if (!hasChildren && !hasAriaLabel) console.warn("If you do not provide children, you must specify an aria-label for accessibility");
    let checked = state.selectedValue === value;
    let onChange = (e)=>{
        e.stopPropagation();
        state.setSelectedValue(value);
    };
    let { pressProps, isPressed } = (0, _interactions.usePress)({
        isDisabled
    });
    // iOS does not toggle radios if you drag off and back onto the label, so handle it ourselves.
    let { pressProps: labelProps, isPressed: isLabelPressed } = (0, _interactions.usePress)({
        isDisabled,
        onPress () {
            state.setSelectedValue(value);
        }
    });
    let { focusableProps } = (0, _focus.useFocusable)((0, _utils.mergeProps)(props, {
        onFocus: ()=>state.setLastFocusedValue(value)
    }), ref);
    let interactions = (0, _utils.mergeProps)(pressProps, focusableProps);
    let domProps = (0, _utils.filterDOMProps)(props, {
        labelable: true
    });
    let tabIndex = -1;
    if (state.selectedValue != null) {
        if (state.selectedValue === value) tabIndex = 0;
    } else if (state.lastFocusedValue === value || state.lastFocusedValue == null) tabIndex = 0;
    if (isDisabled) tabIndex = undefined;
    let { name, descriptionId, errorMessageId, validationBehavior } = (0, _utils1.radioGroupData).get(state);
    (0, _utils.useFormReset)(ref, state.selectedValue, state.setSelectedValue);
    (0, _form.useFormValidation)({
        validationBehavior
    }, state, ref);
    return {
        labelProps: (0, _utils.mergeProps)(labelProps, {
            onClick: (e)=>e.preventDefault()
        }),
        inputProps: (0, _utils.mergeProps)(domProps, {
            ...interactions,
            type: "radio",
            name,
            tabIndex,
            disabled: isDisabled,
            required: state.isRequired && validationBehavior === "native",
            checked,
            value,
            onChange,
            "aria-describedby": [
                props["aria-describedby"],
                state.isInvalid ? errorMessageId : null,
                descriptionId
            ].filter(Boolean).join(" ") || undefined
        }),
        isDisabled,
        isSelected: checked,
        isPressed: isPressed || isLabelPressed
    };
}

},{"@react-aria/utils":"9cLk5","./utils":"hz95L","@react-aria/focus":"42mbF","@react-aria/form":"lerqa","@react-aria/interactions":"ky3G8","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"hz95L":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "radioGroupData", ()=>radioGroupData);
const radioGroupData = new WeakMap();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"hovcu":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides the behavior and accessibility implementation for a radio group component.
 * Radio groups allow users to select a single item from a list of mutually exclusive options.
 * @param props - Props for the radio group.
 * @param state - State for the radio group, as returned by `useRadioGroupState`.
 */ parcelHelpers.export(exports, "useRadioGroup", ()=>useRadioGroup);
var _utils = require("@react-aria/utils");
var _focus = require("@react-aria/focus");
var _utils1 = require("./utils");
var _label = require("@react-aria/label");
var _interactions = require("@react-aria/interactions");
var _i18N = require("@react-aria/i18n");
function useRadioGroup(props, state) {
    let { name, isReadOnly, isRequired, isDisabled, orientation = "vertical", validationBehavior = "aria" } = props;
    let { direction } = (0, _i18N.useLocale)();
    let { isInvalid, validationErrors, validationDetails } = state.displayValidation;
    let { labelProps, fieldProps, descriptionProps, errorMessageProps } = (0, _label.useField)({
        ...props,
        // Radio group is not an HTML input element so it
        // shouldn't be labeled by a <label> element.
        labelElementType: "span",
        isInvalid: state.isInvalid,
        errorMessage: props.errorMessage || validationErrors
    });
    let domProps = (0, _utils.filterDOMProps)(props, {
        labelable: true
    });
    // When the radio group loses focus, reset the focusable radio to null if
    // there is no selection. This allows tabbing into the group from either
    // direction to go to the first or last radio.
    let { focusWithinProps } = (0, _interactions.useFocusWithin)({
        onBlurWithin (e) {
            var _props_onBlur;
            (_props_onBlur = props.onBlur) === null || _props_onBlur === void 0 ? void 0 : _props_onBlur.call(props, e);
            if (!state.selectedValue) state.setLastFocusedValue(null);
        },
        onFocusWithin: props.onFocus,
        onFocusWithinChange: props.onFocusChange
    });
    let onKeyDown = (e)=>{
        let nextDir;
        switch(e.key){
            case "ArrowRight":
                if (direction === "rtl" && orientation !== "vertical") nextDir = "prev";
                else nextDir = "next";
                break;
            case "ArrowLeft":
                if (direction === "rtl" && orientation !== "vertical") nextDir = "next";
                else nextDir = "prev";
                break;
            case "ArrowDown":
                nextDir = "next";
                break;
            case "ArrowUp":
                nextDir = "prev";
                break;
            default:
                return;
        }
        e.preventDefault();
        let walker = (0, _focus.getFocusableTreeWalker)(e.currentTarget, {
            from: e.target
        });
        let nextElem;
        if (nextDir === "next") {
            nextElem = walker.nextNode();
            if (!nextElem) {
                walker.currentNode = e.currentTarget;
                nextElem = walker.firstChild();
            }
        } else {
            nextElem = walker.previousNode();
            if (!nextElem) {
                walker.currentNode = e.currentTarget;
                nextElem = walker.lastChild();
            }
        }
        if (nextElem) {
            // Call focus on nextElem so that keyboard navigation scrolls the radio into view
            nextElem.focus();
            state.setSelectedValue(nextElem.value);
        }
    };
    let groupName = (0, _utils.useId)(name);
    (0, _utils1.radioGroupData).set(state, {
        name: groupName,
        descriptionId: descriptionProps.id,
        errorMessageId: errorMessageProps.id,
        validationBehavior
    });
    return {
        radioGroupProps: (0, _utils.mergeProps)(domProps, {
            // https://www.w3.org/TR/wai-aria-1.2/#radiogroup
            role: "radiogroup",
            onKeyDown,
            "aria-invalid": state.isInvalid || undefined,
            "aria-errormessage": props["aria-errormessage"],
            "aria-readonly": isReadOnly || undefined,
            "aria-required": isRequired || undefined,
            "aria-disabled": isDisabled || undefined,
            "aria-orientation": orientation,
            ...fieldProps,
            ...focusWithinProps
        }),
        labelProps,
        descriptionProps,
        errorMessageProps,
        isInvalid,
        validationErrors,
        validationDetails
    };
}

},{"@react-aria/utils":"9cLk5","@react-aria/focus":"42mbF","./utils":"hz95L","@react-aria/label":"74Ccz","@react-aria/interactions":"ky3G8","@react-aria/i18n":"411rg","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"2RKb9":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useSearchField", ()=>(0, _useSearchField.useSearchField));
var _useSearchField = require("./useSearchField");

},{"./useSearchField":"14Xt1","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"14Xt1":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides the behavior and accessibility implementation for a search field.
 * @param props - Props for the search field.
 * @param state - State for the search field, as returned by `useSearchFieldState`.
 * @param inputRef - A ref to the input element.
 */ parcelHelpers.export(exports, "useSearchField", ()=>useSearchField);
var _utils = require("@react-aria/utils");
// @ts-ignore
var _json = require("../intl/*.json");
var _jsonDefault = parcelHelpers.interopDefault(_json);
var _i18N = require("@react-aria/i18n");
var _textfield = require("@react-aria/textfield");
function useSearchField(props, state, inputRef) {
    let stringFormatter = (0, _i18N.useLocalizedStringFormatter)((0, _jsonDefault.default), "@react-aria/searchfield");
    let { isDisabled, isReadOnly, onSubmit = ()=>{}, onClear, type = "search" } = props;
    let onKeyDown = (e)=>{
        const key = e.key;
        if (key === "Enter") e.preventDefault();
        if (isDisabled || isReadOnly) return;
        if (key === "Enter") onSubmit(state.value);
        if (key === "Escape") {
            if (state.value === "") e.continuePropagation();
            else {
                state.setValue("");
                if (onClear) onClear();
            }
        }
    };
    let onClearButtonClick = ()=>{
        state.setValue("");
        if (onClear) onClear();
    };
    let onPressStart = ()=>{
        var // this is in PressStart for mobile so that touching the clear button doesn't remove focus from
        // the input and close the keyboard
        _inputRef_current;
        (_inputRef_current = inputRef.current) === null || _inputRef_current === void 0 ? void 0 : _inputRef_current.focus();
    };
    let { labelProps, inputProps, descriptionProps, errorMessageProps, ...validation } = (0, _textfield.useTextField)({
        ...props,
        value: state.value,
        onChange: state.setValue,
        onKeyDown: !isReadOnly ? (0, _utils.chain)(onKeyDown, props.onKeyDown) : props.onKeyDown,
        type
    }, inputRef);
    return {
        labelProps,
        inputProps: {
            ...inputProps,
            // already handled by useSearchFieldState
            defaultValue: undefined
        },
        clearButtonProps: {
            "aria-label": stringFormatter.format("Clear search"),
            excludeFromTabOrder: true,
            // @ts-ignore
            preventFocusOnPress: true,
            isDisabled: isDisabled || isReadOnly,
            onPress: onClearButtonClick,
            onPressStart
        },
        descriptionProps,
        errorMessageProps,
        ...validation
    };
}

},{"@react-aria/utils":"9cLk5","../intl/*.json":"fcEeu","@react-aria/i18n":"411rg","@react-aria/textfield":"6dEv6","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"fcEeu":[function(require,module,exports) {
const _temp0 = require("ecfc0164cdafbc11");
const _temp1 = require("533820a702a6cc4d");
const _temp2 = require("adc1d07960abb370");
const _temp3 = require("959d90d2e1b8754d");
const _temp4 = require("c7bcb7c68ae4d133");
const _temp5 = require("7592b3baca1e1ab7");
const _temp6 = require("377509ed67276db9");
const _temp7 = require("bcdffd9a74290826");
const _temp8 = require("66f96fbb9c6f57b3");
const _temp9 = require("96660d96c61006f6");
const _temp10 = require("e42562491f0a003a");
const _temp11 = require("b2e319db05a47686");
const _temp12 = require("8c2f9a8959ebc6d8");
const _temp13 = require("5d3c12b049cdb778");
const _temp14 = require("11cc1fb3d7f8c195");
const _temp15 = require("c7097d1ca0fc0d82");
const _temp16 = require("6a0de05d519cdbf5");
const _temp17 = require("9741ebd533b2078c");
const _temp18 = require("406b77d2f3fc3437");
const _temp19 = require("53d9d9bd8feb82b1");
const _temp20 = require("7b20791f74309e10");
const _temp21 = require("d06b6fc5dda02e88");
const _temp22 = require("a28a6945ed983bd6");
const _temp23 = require("ebef8b25fee90b36");
const _temp24 = require("84e709af2309f7d7");
const _temp25 = require("2526519e9c0d0e8b");
const _temp26 = require("441fee45de55b70c");
const _temp27 = require("190818b45cb371e");
const _temp28 = require("929004f2e45d5643");
const _temp29 = require("77e5fd88fe39459e");
const _temp30 = require("bbe929569218677b");
const _temp31 = require("d3b3389f28451bb4");
const _temp32 = require("6b83a28d69d9848f");
const _temp33 = require("7fb75107a926411e");
module.exports = {
    "ar-AE": _temp0,
    "bg-BG": _temp1,
    "cs-CZ": _temp2,
    "da-DK": _temp3,
    "de-DE": _temp4,
    "el-GR": _temp5,
    "en-US": _temp6,
    "es-ES": _temp7,
    "et-EE": _temp8,
    "fi-FI": _temp9,
    "fr-FR": _temp10,
    "he-IL": _temp11,
    "hr-HR": _temp12,
    "hu-HU": _temp13,
    "it-IT": _temp14,
    "ja-JP": _temp15,
    "ko-KR": _temp16,
    "lt-LT": _temp17,
    "lv-LV": _temp18,
    "nb-NO": _temp19,
    "nl-NL": _temp20,
    "pl-PL": _temp21,
    "pt-BR": _temp22,
    "pt-PT": _temp23,
    "ro-RO": _temp24,
    "ru-RU": _temp25,
    "sk-SK": _temp26,
    "sl-SI": _temp27,
    "sr-SP": _temp28,
    "sv-SE": _temp29,
    "tr-TR": _temp30,
    "uk-UA": _temp31,
    "zh-CN": _temp32,
    "zh-TW": _temp33
};

},{"ecfc0164cdafbc11":"1YHA4","533820a702a6cc4d":"4cfzR","adc1d07960abb370":"eo6Q4","959d90d2e1b8754d":"acDNi","c7bcb7c68ae4d133":"4gITJ","7592b3baca1e1ab7":"kuefA","377509ed67276db9":"dZO8m","bcdffd9a74290826":"1NnVc","66f96fbb9c6f57b3":"5fTBX","96660d96c61006f6":"kaG4j","e42562491f0a003a":"8srXq","b2e319db05a47686":"iD1UU","8c2f9a8959ebc6d8":"bNhUs","5d3c12b049cdb778":"7X8O2","11cc1fb3d7f8c195":"zySGG","c7097d1ca0fc0d82":"dGN0I","6a0de05d519cdbf5":"8wmsT","9741ebd533b2078c":"8BHmP","406b77d2f3fc3437":"ddy5T","53d9d9bd8feb82b1":"jBtfS","7b20791f74309e10":"13KSn","d06b6fc5dda02e88":"dqgSR","a28a6945ed983bd6":"rk1xY","ebef8b25fee90b36":"dFGxk","84e709af2309f7d7":"8EWfb","2526519e9c0d0e8b":"iJFn3","441fee45de55b70c":"02kW0","190818b45cb371e":"gvCcq","929004f2e45d5643":"kkJNr","77e5fd88fe39459e":"54HLg","bbe929569218677b":"hCj9l","d3b3389f28451bb4":"kbtcy","6b83a28d69d9848f":"3RoHr","7fb75107a926411e":"7NVBK"}],"1YHA4":[function(require,module,exports) {
module.exports = {
    "Clear search": `\u{645}\u{633}\u{62D} \u{627}\u{644}\u{628}\u{62D}\u{62B}`
};

},{}],"4cfzR":[function(require,module,exports) {
module.exports = {
    "Clear search": `\u{418}\u{437}\u{447}\u{438}\u{441}\u{442}\u{432}\u{430}\u{43D}\u{435} \u{43D}\u{430} \u{442}\u{44A}\u{440}\u{441}\u{435}\u{43D}\u{435}`
};

},{}],"eo6Q4":[function(require,module,exports) {
module.exports = {
    "Clear search": `Vymazat hled\xe1n\xed`
};

},{}],"acDNi":[function(require,module,exports) {
module.exports = {
    "Clear search": `Ryd s\xf8gning`
};

},{}],"4gITJ":[function(require,module,exports) {
module.exports = {
    "Clear search": `Suche zur\xfccksetzen`
};

},{}],"kuefA":[function(require,module,exports) {
module.exports = {
    "Clear search": `\u{391}\u{3C0}\u{3B1}\u{3BB}\u{3BF}\u{3B9}\u{3C6}\u{3AE} \u{3B1}\u{3BD}\u{3B1}\u{3B6}\u{3AE}\u{3C4}\u{3B7}\u{3C3}\u{3B7}\u{3C2}`
};

},{}],"dZO8m":[function(require,module,exports) {
module.exports = {
    "Clear search": `Clear search`
};

},{}],"1NnVc":[function(require,module,exports) {
module.exports = {
    "Clear search": `Borrar b\xfasqueda`
};

},{}],"5fTBX":[function(require,module,exports) {
module.exports = {
    "Clear search": `T\xfchjenda otsing`
};

},{}],"kaG4j":[function(require,module,exports) {
module.exports = {
    "Clear search": `Tyhjenn\xe4 haku`
};

},{}],"8srXq":[function(require,module,exports) {
module.exports = {
    "Clear search": `Effacer la recherche`
};

},{}],"iD1UU":[function(require,module,exports) {
module.exports = {
    "Clear search": `\u{5E0}\u{5E7}\u{5D4} \u{5D7}\u{5D9}\u{5E4}\u{5D5}\u{5E9}`
};

},{}],"bNhUs":[function(require,module,exports) {
module.exports = {
    "Clear search": `Obri\u{161}i pretragu`
};

},{}],"7X8O2":[function(require,module,exports) {
module.exports = {
    "Clear search": `Keres\xe9s t\xf6rl\xe9se`
};

},{}],"zySGG":[function(require,module,exports) {
module.exports = {
    "Clear search": `Cancella ricerca`
};

},{}],"dGN0I":[function(require,module,exports) {
module.exports = {
    "Clear search": `\u{691C}\u{7D22}\u{3092}\u{30AF}\u{30EA}\u{30A2}`
};

},{}],"8wmsT":[function(require,module,exports) {
module.exports = {
    "Clear search": `\u{AC80}\u{C0C9} \u{C9C0}\u{C6B0}\u{AE30}`
};

},{}],"8BHmP":[function(require,module,exports) {
module.exports = {
    "Clear search": `I\u{161}valyti ie\u{161}k\u{105}`
};

},{}],"ddy5T":[function(require,module,exports) {
module.exports = {
    "Clear search": `Not\u{12B}r\u{12B}t mekl\u{113}\u{161}anu`
};

},{}],"jBtfS":[function(require,module,exports) {
module.exports = {
    "Clear search": `T\xf8m s\xf8k`
};

},{}],"13KSn":[function(require,module,exports) {
module.exports = {
    "Clear search": `Zoekactie wissen`
};

},{}],"dqgSR":[function(require,module,exports) {
module.exports = {
    "Clear search": `Wyczy\u{15B}\u{107} zawarto\u{15B}\u{107} wyszukiwania`
};

},{}],"rk1xY":[function(require,module,exports) {
module.exports = {
    "Clear search": `Limpar pesquisa`
};

},{}],"dFGxk":[function(require,module,exports) {
module.exports = {
    "Clear search": `Limpar pesquisa`
};

},{}],"8EWfb":[function(require,module,exports) {
module.exports = {
    "Clear search": `\u{15E}terge\u{163}i c\u{103}utarea`
};

},{}],"iJFn3":[function(require,module,exports) {
module.exports = {
    "Clear search": `\u{41E}\u{447}\u{438}\u{441}\u{442}\u{438}\u{442}\u{44C} \u{43F}\u{43E}\u{438}\u{441}\u{43A}`
};

},{}],"02kW0":[function(require,module,exports) {
module.exports = {
    "Clear search": `Vymaza\u{165} vyh\u{13E}ad\xe1vanie`
};

},{}],"gvCcq":[function(require,module,exports) {
module.exports = {
    "Clear search": `Po\u{10D}isti iskanje`
};

},{}],"kkJNr":[function(require,module,exports) {
module.exports = {
    "Clear search": `Obri\u{161}i pretragu`
};

},{}],"54HLg":[function(require,module,exports) {
module.exports = {
    "Clear search": `Rensa s\xf6kning`
};

},{}],"hCj9l":[function(require,module,exports) {
module.exports = {
    "Clear search": `Aramay\u{131} temizle`
};

},{}],"kbtcy":[function(require,module,exports) {
module.exports = {
    "Clear search": `\u{41E}\u{447}\u{438}\u{441}\u{442}\u{438}\u{442}\u{438} \u{43F}\u{43E}\u{448}\u{443}\u{43A}`
};

},{}],"3RoHr":[function(require,module,exports) {
module.exports = {
    "Clear search": `\u{6E05}\u{9664}\u{641C}\u{7D22}`
};

},{}],"7NVBK":[function(require,module,exports) {
module.exports = {
    "Clear search": `\u{6E05}\u{9664}\u{641C}\u{5C0B}\u{689D}\u{4EF6}`
};

},{}],"l1sFE":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useSelect", ()=>(0, _useSelect.useSelect));
parcelHelpers.export(exports, "useHiddenSelect", ()=>(0, _hiddenSelect.useHiddenSelect));
parcelHelpers.export(exports, "HiddenSelect", ()=>(0, _hiddenSelect.HiddenSelect));
var _useSelect = require("./useSelect");
var _hiddenSelect = require("./HiddenSelect");

},{"./useSelect":"5Kgzw","./HiddenSelect":"7INcC","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"5Kgzw":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "selectData", ()=>selectData);
/**
 * Provides the behavior and accessibility implementation for a select component.
 * A select displays a collapsible list of options and allows a user to select one of them.
 * @param props - Props for the select.
 * @param state - State for the select, as returned by `useListState`.
 */ parcelHelpers.export(exports, "useSelect", ()=>useSelect);
var _utils = require("@react-aria/utils");
var _react = require("react");
var _selection = require("@react-aria/selection");
var _interactions = require("@react-aria/interactions");
var _i18N = require("@react-aria/i18n");
var _label = require("@react-aria/label");
var _menu = require("@react-aria/menu");
const selectData = new WeakMap();
function useSelect(props, state, ref) {
    let { keyboardDelegate, isDisabled, isRequired, name, validationBehavior = "aria" } = props;
    // By default, a KeyboardDelegate is provided which uses the DOM to query layout information (e.g. for page up/page down).
    // When virtualized, the layout object will be passed in as a prop and override this.
    let collator = (0, _i18N.useCollator)({
        usage: "search",
        sensitivity: "base"
    });
    let delegate = (0, _react.useMemo)(()=>keyboardDelegate || new (0, _selection.ListKeyboardDelegate)(state.collection, state.disabledKeys, null, collator), [
        keyboardDelegate,
        state.collection,
        state.disabledKeys,
        collator
    ]);
    let { menuTriggerProps, menuProps } = (0, _menu.useMenuTrigger)({
        isDisabled,
        type: "listbox"
    }, state, ref);
    let onKeyDown = (e)=>{
        switch(e.key){
            case "ArrowLeft":
                {
                    // prevent scrolling containers
                    e.preventDefault();
                    let key = state.selectedKey != null ? delegate.getKeyAbove(state.selectedKey) : delegate.getFirstKey();
                    if (key) state.setSelectedKey(key);
                    break;
                }
            case "ArrowRight":
                {
                    // prevent scrolling containers
                    e.preventDefault();
                    let key = state.selectedKey != null ? delegate.getKeyBelow(state.selectedKey) : delegate.getFirstKey();
                    if (key) state.setSelectedKey(key);
                    break;
                }
        }
    };
    let { typeSelectProps } = (0, _selection.useTypeSelect)({
        keyboardDelegate: delegate,
        selectionManager: state.selectionManager,
        onTypeSelect (key) {
            state.setSelectedKey(key);
        }
    });
    let { isInvalid, validationErrors, validationDetails } = state.displayValidation;
    let { labelProps, fieldProps, descriptionProps, errorMessageProps } = (0, _label.useField)({
        ...props,
        labelElementType: "span",
        isInvalid,
        errorMessage: props.errorMessage || validationErrors
    });
    typeSelectProps.onKeyDown = typeSelectProps.onKeyDownCapture;
    delete typeSelectProps.onKeyDownCapture;
    let domProps = (0, _utils.filterDOMProps)(props, {
        labelable: true
    });
    let triggerProps = (0, _utils.mergeProps)(typeSelectProps, menuTriggerProps, fieldProps);
    let valueId = (0, _utils.useId)();
    selectData.set(state, {
        isDisabled,
        isRequired,
        name,
        validationBehavior
    });
    return {
        labelProps: {
            ...labelProps,
            onClick: ()=>{
                if (!props.isDisabled) {
                    ref.current.focus();
                    // Show the focus ring so the user knows where focus went
                    (0, _interactions.setInteractionModality)("keyboard");
                }
            }
        },
        triggerProps: (0, _utils.mergeProps)(domProps, {
            ...triggerProps,
            isDisabled,
            onKeyDown: (0, _utils.chain)(triggerProps.onKeyDown, onKeyDown, props.onKeyDown),
            onKeyUp: props.onKeyUp,
            "aria-labelledby": [
                valueId,
                triggerProps["aria-labelledby"],
                triggerProps["aria-label"] && !triggerProps["aria-labelledby"] ? triggerProps.id : null
            ].filter(Boolean).join(" "),
            onFocus (e) {
                if (state.isFocused) return;
                if (props.onFocus) props.onFocus(e);
                if (props.onFocusChange) props.onFocusChange(true);
                state.setFocused(true);
            },
            onBlur (e) {
                if (state.isOpen) return;
                if (props.onBlur) props.onBlur(e);
                if (props.onFocusChange) props.onFocusChange(false);
                state.setFocused(false);
            }
        }),
        valueProps: {
            id: valueId
        },
        menuProps: {
            ...menuProps,
            autoFocus: state.focusStrategy || true,
            shouldSelectOnPressUp: true,
            shouldFocusOnHover: true,
            disallowEmptySelection: true,
            linkBehavior: "selection",
            onBlur: (e)=>{
                if (e.currentTarget.contains(e.relatedTarget)) return;
                if (props.onBlur) props.onBlur(e);
                if (props.onFocusChange) props.onFocusChange(false);
                state.setFocused(false);
            },
            "aria-labelledby": [
                fieldProps["aria-labelledby"],
                triggerProps["aria-label"] && !fieldProps["aria-labelledby"] ? triggerProps.id : null
            ].filter(Boolean).join(" ")
        },
        descriptionProps,
        errorMessageProps,
        isInvalid,
        validationErrors,
        validationDetails
    };
}

},{"@react-aria/utils":"9cLk5","react":"9yzVZ","@react-aria/selection":"6Fly5","@react-aria/interactions":"ky3G8","@react-aria/i18n":"411rg","@react-aria/label":"74Ccz","@react-aria/menu":"89bvn","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"7INcC":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides the behavior and accessibility implementation for a hidden `<select>` element, which
 * can be used in combination with `useSelect` to support browser form autofill, mobile form
 * navigation, and native HTML form submission.
 */ parcelHelpers.export(exports, "useHiddenSelect", ()=>useHiddenSelect);
/**
 * Renders a hidden native `<select>` element, which can be used to support browser
 * form autofill, mobile form navigation, and native form submission.
 */ parcelHelpers.export(exports, "HiddenSelect", ()=>HiddenSelect);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useSelect = require("./useSelect");
var _utils = require("@react-aria/utils");
var _form = require("@react-aria/form");
var _interactions = require("@react-aria/interactions");
var _visuallyHidden = require("@react-aria/visually-hidden");
function useHiddenSelect(props, state, triggerRef) {
    let data = (0, _useSelect.selectData).get(state) || {};
    let { autoComplete, name = data.name, isDisabled = data.isDisabled } = props;
    let { validationBehavior, isRequired } = data;
    let modality = (0, _interactions.useInteractionModality)();
    let { visuallyHiddenProps } = (0, _visuallyHidden.useVisuallyHidden)();
    (0, _utils.useFormReset)(props.selectRef, state.selectedKey, state.setSelectedKey);
    (0, _form.useFormValidation)({
        validationBehavior,
        focus: ()=>triggerRef.current.focus()
    }, state, props.selectRef);
    var _state_selectedKey;
    // In Safari, the <select> cannot have `display: none` or `hidden` for autofill to work.
    // In Firefox, there must be a <label> to identify the <select> whereas other browsers
    // seem to identify it just by surrounding text.
    // The solution is to use <VisuallyHidden> to hide the elements, which clips the elements to a
    // 1px rectangle. In addition, we hide from screen readers with aria-hidden, and make the <select>
    // non tabbable with tabIndex={-1}.
    //
    // In mobile browsers, there are next/previous buttons above the software keyboard for navigating
    // between fields in a form. These only support native form inputs that are tabbable. In order to
    // support those, an additional hidden input is used to marshall focus to the button. It is tabbable
    // except when the button is focused, so that shift tab works properly to go to the actual previous
    // input in the form. Using the <select> for this also works, but Safari on iOS briefly flashes
    // the native menu on focus, so this isn't ideal. A font-size of 16px or greater is required to
    // prevent Safari from zooming in on the input when it is focused.
    //
    // If the current interaction modality is null, then the user hasn't interacted with the page yet.
    // In this case, we set the tabIndex to -1 on the input element so that automated accessibility
    // checkers don't throw false-positives about focusable elements inside an aria-hidden parent.
    return {
        containerProps: {
            ...visuallyHiddenProps,
            "aria-hidden": true,
            ["data-a11y-ignore"]: "aria-hidden-focus"
        },
        inputProps: {
            type: "text",
            tabIndex: modality == null || state.isFocused || state.isOpen ? -1 : 0,
            style: {
                fontSize: 16
            },
            onFocus: ()=>triggerRef.current.focus(),
            disabled: isDisabled
        },
        selectProps: {
            tabIndex: -1,
            autoComplete,
            disabled: isDisabled,
            required: validationBehavior === "native" && isRequired,
            name,
            value: (_state_selectedKey = state.selectedKey) !== null && _state_selectedKey !== void 0 ? _state_selectedKey : "",
            onChange: (e)=>state.setSelectedKey(e.target.value)
        }
    };
}
function HiddenSelect(props) {
    let { state, triggerRef, label, name, isDisabled } = props;
    let selectRef = (0, _react.useRef)(null);
    let { containerProps, inputProps, selectProps } = useHiddenSelect({
        ...props,
        selectRef
    }, state, triggerRef);
    var _state_selectedKey;
    // If used in a <form>, use a hidden input so the value can be submitted to a server.
    // If the collection isn't too big, use a hidden <select> element for this so that browser
    // autofill will work. Otherwise, use an <input type="hidden">.
    if (state.collection.size <= 300) return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...containerProps,
        "data-testid": "hidden-select-container"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("input", inputProps), /*#__PURE__*/ (0, _reactDefault.default).createElement("label", null, label, /*#__PURE__*/ (0, _reactDefault.default).createElement("select", {
        ...selectProps,
        ref: selectRef
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("option", null), [
        ...state.collection.getKeys()
    ].map((key)=>{
        let item = state.collection.getItem(key);
        if (item.type === "item") return /*#__PURE__*/ (0, _reactDefault.default).createElement("option", {
            key: item.key,
            value: item.key
        }, item.textValue);
    }))));
    else if (name) return /*#__PURE__*/ (0, _reactDefault.default).createElement("input", {
        type: "hidden",
        autoComplete: selectProps.autoComplete,
        name: name,
        disabled: isDisabled,
        value: (_state_selectedKey = state.selectedKey) !== null && _state_selectedKey !== void 0 ? _state_selectedKey : ""
    });
    return null;
}

},{"react":"9yzVZ","./useSelect":"5Kgzw","@react-aria/utils":"9cLk5","@react-aria/form":"lerqa","@react-aria/interactions":"ky3G8","@react-aria/visually-hidden":"4jwxT","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"iHEIW":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useSeparator", ()=>(0, _useSeparator.useSeparator));
var _useSeparator = require("./useSeparator");

},{"./useSeparator":"ZQHJW","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"ZQHJW":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides the accessibility implementation for a separator.
 * A separator is a visual divider between two groups of content,
 * e.g. groups of menu items or sections of a page.
 */ parcelHelpers.export(exports, "useSeparator", ()=>useSeparator);
var _utils = require("@react-aria/utils");
function useSeparator(props) {
    let domProps = (0, _utils.filterDOMProps)(props, {
        labelable: true
    });
    let ariaOrientation;
    // if orientation is horizontal, aria-orientation default is horizontal, so we leave it undefined
    // if it's vertical, we need to specify it
    if (props.orientation === "vertical") ariaOrientation = "vertical";
    // hr elements implicitly have role = separator and a horizontal orientation
    if (props.elementType !== "hr") return {
        separatorProps: {
            ...domProps,
            role: "separator",
            "aria-orientation": ariaOrientation
        }
    };
    return {
        separatorProps: domProps
    };
}

},{"@react-aria/utils":"9cLk5","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"eOsko":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useSlider", ()=>(0, _useSlider.useSlider));
parcelHelpers.export(exports, "useSliderThumb", ()=>(0, _useSliderThumb.useSliderThumb));
var _useSlider = require("./useSlider");
var _useSliderThumb = require("./useSliderThumb");

},{"./useSlider":"h3mPN","./useSliderThumb":"2PaTp","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"h3mPN":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides the behavior and accessibility implementation for a slider component representing one or more values.
 *
 * @param props Props for the slider.
 * @param state State for the slider, as returned by `useSliderState`.
 * @param trackRef Ref for the "track" element.  The width of this element provides the "length"
 * of the track -- the span of one dimensional space that the slider thumb can be.  It also
 * accepts click and drag motions, so that the closest thumb will follow clicks and drags on
 * the track.
 */ parcelHelpers.export(exports, "useSlider", ()=>useSlider);
var _utils = require("@react-aria/utils");
var _utils1 = require("./utils");
var _react = require("react");
var _interactions = require("@react-aria/interactions");
var _label = require("@react-aria/label");
var _i18N = require("@react-aria/i18n");
function useSlider(props, state, trackRef) {
    let { labelProps, fieldProps } = (0, _label.useLabel)(props);
    let isVertical = props.orientation === "vertical";
    var _labelProps_id;
    // Attach id of the label to the state so it can be accessed by useSliderThumb.
    (0, _utils1.sliderData).set(state, {
        id: (_labelProps_id = labelProps.id) !== null && _labelProps_id !== void 0 ? _labelProps_id : fieldProps.id,
        "aria-describedby": props["aria-describedby"],
        "aria-details": props["aria-details"]
    });
    let { direction } = (0, _i18N.useLocale)();
    let { addGlobalListener, removeGlobalListener } = (0, _utils.useGlobalListeners)();
    // When the user clicks or drags the track, we want the motion to set and drag the
    // closest thumb.  Hence we also need to install useMove() on the track element.
    // Here, we keep track of which index is the "closest" to the drag start point.
    // It is set onMouseDown/onTouchDown; see trackProps below.
    const realTimeTrackDraggingIndex = (0, _react.useRef)(null);
    const reverseX = direction === "rtl";
    const currentPosition = (0, _react.useRef)(null);
    const { moveProps } = (0, _interactions.useMove)({
        onMoveStart () {
            currentPosition.current = null;
        },
        onMove ({ deltaX, deltaY }) {
            let { height, width } = trackRef.current.getBoundingClientRect();
            let size = isVertical ? height : width;
            if (currentPosition.current == null) currentPosition.current = state.getThumbPercent(realTimeTrackDraggingIndex.current) * size;
            let delta = isVertical ? deltaY : deltaX;
            if (isVertical || reverseX) delta = -delta;
            currentPosition.current += delta;
            if (realTimeTrackDraggingIndex.current != null && trackRef.current) {
                const percent = (0, _utils.clamp)(currentPosition.current / size, 0, 1);
                state.setThumbPercent(realTimeTrackDraggingIndex.current, percent);
            }
        },
        onMoveEnd () {
            if (realTimeTrackDraggingIndex.current != null) {
                state.setThumbDragging(realTimeTrackDraggingIndex.current, false);
                realTimeTrackDraggingIndex.current = null;
            }
        }
    });
    let currentPointer = (0, _react.useRef)(undefined);
    let onDownTrack = (e, id, clientX, clientY)=>{
        // We only trigger track-dragging if the user clicks on the track itself and nothing is currently being dragged.
        if (trackRef.current && !props.isDisabled && state.values.every((_, i)=>!state.isThumbDragging(i))) {
            let { height, width, top, left } = trackRef.current.getBoundingClientRect();
            let size = isVertical ? height : width;
            // Find the closest thumb
            const trackPosition = isVertical ? top : left;
            const clickPosition = isVertical ? clientY : clientX;
            const offset = clickPosition - trackPosition;
            let percent = offset / size;
            if (direction === "rtl" || isVertical) percent = 1 - percent;
            let value = state.getPercentValue(percent);
            // to find the closet thumb we split the array based on the first thumb position to the "right/end" of the click.
            let closestThumb;
            let split = state.values.findIndex((v)=>value - v < 0);
            if (split === 0) closestThumb = split;
            else if (split === -1) closestThumb = state.values.length - 1;
            else {
                let lastLeft = state.values[split - 1];
                let firstRight = state.values[split];
                // Pick the last left/start thumb, unless they are stacked on top of each other, then pick the right/end one
                if (Math.abs(lastLeft - value) < Math.abs(firstRight - value)) closestThumb = split - 1;
                else closestThumb = split;
            }
            // Confirm that the found closest thumb is editable, not disabled, and move it
            if (closestThumb >= 0 && state.isThumbEditable(closestThumb)) {
                // Don't unfocus anything
                e.preventDefault();
                realTimeTrackDraggingIndex.current = closestThumb;
                state.setFocusedThumb(closestThumb);
                currentPointer.current = id;
                state.setThumbDragging(realTimeTrackDraggingIndex.current, true);
                state.setThumbValue(closestThumb, value);
                addGlobalListener(window, "mouseup", onUpTrack, false);
                addGlobalListener(window, "touchend", onUpTrack, false);
                addGlobalListener(window, "pointerup", onUpTrack, false);
            } else realTimeTrackDraggingIndex.current = null;
        }
    };
    let onUpTrack = (e)=>{
        var _e_changedTouches;
        var _e_pointerId;
        let id = (_e_pointerId = e.pointerId) !== null && _e_pointerId !== void 0 ? _e_pointerId : (_e_changedTouches = e.changedTouches) === null || _e_changedTouches === void 0 ? void 0 : _e_changedTouches[0].identifier;
        if (id === currentPointer.current) {
            if (realTimeTrackDraggingIndex.current != null) {
                state.setThumbDragging(realTimeTrackDraggingIndex.current, false);
                realTimeTrackDraggingIndex.current = null;
            }
            removeGlobalListener(window, "mouseup", onUpTrack, false);
            removeGlobalListener(window, "touchend", onUpTrack, false);
            removeGlobalListener(window, "pointerup", onUpTrack, false);
        }
    };
    if ("htmlFor" in labelProps && labelProps.htmlFor) {
        // Ideally the `for` attribute should point to the first thumb, but VoiceOver on iOS
        // causes this to override the `aria-labelledby` on the thumb. This causes the first
        // thumb to only be announced as the slider label rather than its individual name as well.
        // See https://bugs.webkit.org/show_bug.cgi?id=172464.
        delete labelProps.htmlFor;
        labelProps.onClick = ()=>{
            var // Safari does not focus <input type="range"> elements when clicking on an associated <label>,
            // so do it manually. In addition, make sure we show the focus ring.
            _document_getElementById;
            (_document_getElementById = document.getElementById((0, _utils1.getSliderThumbId)(state, 0))) === null || _document_getElementById === void 0 ? void 0 : _document_getElementById.focus();
            (0, _interactions.setInteractionModality)("keyboard");
        };
    }
    return {
        labelProps,
        // The root element of the Slider will have role="group" to group together
        // all the thumb inputs in the Slider.  The label of the Slider will
        // be used to label the group.
        groupProps: {
            role: "group",
            ...fieldProps
        },
        trackProps: (0, _utils.mergeProps)({
            onMouseDown (e) {
                if (e.button !== 0 || e.altKey || e.ctrlKey || e.metaKey) return;
                onDownTrack(e, undefined, e.clientX, e.clientY);
            },
            onPointerDown (e) {
                if (e.pointerType === "mouse" && (e.button !== 0 || e.altKey || e.ctrlKey || e.metaKey)) return;
                onDownTrack(e, e.pointerId, e.clientX, e.clientY);
            },
            onTouchStart (e) {
                onDownTrack(e, e.changedTouches[0].identifier, e.changedTouches[0].clientX, e.changedTouches[0].clientY);
            },
            style: {
                position: "relative",
                touchAction: "none"
            }
        }, moveProps),
        outputProps: {
            htmlFor: state.values.map((_, index)=>(0, _utils1.getSliderThumbId)(state, index)).join(" "),
            "aria-live": "off"
        }
    };
}

},{"@react-aria/utils":"9cLk5","./utils":"6dfd2","react":"9yzVZ","@react-aria/interactions":"ky3G8","@react-aria/label":"74Ccz","@react-aria/i18n":"411rg","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"6dfd2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "sliderData", ()=>sliderData);
parcelHelpers.export(exports, "getSliderThumbId", ()=>getSliderThumbId);
const sliderData = new WeakMap();
function getSliderThumbId(state, index) {
    let data = sliderData.get(state);
    if (!data) throw new Error("Unknown slider state");
    return `${data.id}-${index}`;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"2PaTp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides behavior and accessibility for a thumb of a slider component.
 *
 * @param opts Options for this Slider thumb.
 * @param state Slider state, created via `useSliderState`.
 */ parcelHelpers.export(exports, "useSliderThumb", ()=>useSliderThumb);
var _utils = require("@react-aria/utils");
var _utils1 = require("./utils");
var _react = require("react");
var _focus = require("@react-aria/focus");
var _interactions = require("@react-aria/interactions");
var _label = require("@react-aria/label");
var _i18N = require("@react-aria/i18n");
function useSliderThumb(opts, state) {
    let { index = 0, isRequired, validationState, isInvalid, trackRef, inputRef, orientation = state.orientation, name } = opts;
    let isDisabled = opts.isDisabled || state.isDisabled;
    let isVertical = orientation === "vertical";
    let { direction } = (0, _i18N.useLocale)();
    let { addGlobalListener, removeGlobalListener } = (0, _utils.useGlobalListeners)();
    let data = (0, _utils1.sliderData).get(state);
    var _opts_arialabelledby;
    const { labelProps, fieldProps } = (0, _label.useLabel)({
        ...opts,
        id: (0, _utils1.getSliderThumbId)(state, index),
        "aria-labelledby": `${data.id} ${(_opts_arialabelledby = opts["aria-labelledby"]) !== null && _opts_arialabelledby !== void 0 ? _opts_arialabelledby : ""}`.trim()
    });
    const value = state.values[index];
    const focusInput = (0, _react.useCallback)(()=>{
        if (inputRef.current) (0, _utils.focusWithoutScrolling)(inputRef.current);
    }, [
        inputRef
    ]);
    const isFocused = state.focusedThumb === index;
    (0, _react.useEffect)(()=>{
        if (isFocused) focusInput();
    }, [
        isFocused,
        focusInput
    ]);
    let reverseX = direction === "rtl";
    let currentPosition = (0, _react.useRef)(null);
    let { keyboardProps } = (0, _interactions.useKeyboard)({
        onKeyDown (e) {
            let { getThumbMaxValue, getThumbMinValue, decrementThumb, incrementThumb, setThumbValue, setThumbDragging, pageSize } = state;
            // these are the cases that useMove or useSlider don't handle
            if (!/^(PageUp|PageDown|Home|End)$/.test(e.key)) {
                e.continuePropagation();
                return;
            }
            // same handling as useMove, stopPropagation to prevent useSlider from handling the event as well.
            e.preventDefault();
            // remember to set this so that onChangeEnd is fired
            setThumbDragging(index, true);
            switch(e.key){
                case "PageUp":
                    incrementThumb(index, pageSize);
                    break;
                case "PageDown":
                    decrementThumb(index, pageSize);
                    break;
                case "Home":
                    setThumbValue(index, getThumbMinValue(index));
                    break;
                case "End":
                    setThumbValue(index, getThumbMaxValue(index));
                    break;
            }
            setThumbDragging(index, false);
        }
    });
    let { moveProps } = (0, _interactions.useMove)({
        onMoveStart () {
            currentPosition.current = null;
            state.setThumbDragging(index, true);
        },
        onMove ({ deltaX, deltaY, pointerType, shiftKey }) {
            const { getThumbPercent, setThumbPercent, decrementThumb, incrementThumb, step, pageSize } = state;
            let { width, height } = trackRef.current.getBoundingClientRect();
            let size = isVertical ? height : width;
            if (currentPosition.current == null) currentPosition.current = getThumbPercent(index) * size;
            if (pointerType === "keyboard") {
                if (deltaX > 0 && reverseX || deltaX < 0 && !reverseX || deltaY > 0) decrementThumb(index, shiftKey ? pageSize : step);
                else incrementThumb(index, shiftKey ? pageSize : step);
            } else {
                let delta = isVertical ? deltaY : deltaX;
                if (isVertical || reverseX) delta = -delta;
                currentPosition.current += delta;
                setThumbPercent(index, (0, _utils.clamp)(currentPosition.current / size, 0, 1));
            }
        },
        onMoveEnd () {
            state.setThumbDragging(index, false);
        }
    });
    // Immediately register editability with the state
    state.setThumbEditable(index, !isDisabled);
    const { focusableProps } = (0, _focus.useFocusable)((0, _utils.mergeProps)(opts, {
        onFocus: ()=>state.setFocusedThumb(index),
        onBlur: ()=>state.setFocusedThumb(undefined)
    }), inputRef);
    let currentPointer = (0, _react.useRef)(undefined);
    let onDown = (id)=>{
        focusInput();
        currentPointer.current = id;
        state.setThumbDragging(index, true);
        addGlobalListener(window, "mouseup", onUp, false);
        addGlobalListener(window, "touchend", onUp, false);
        addGlobalListener(window, "pointerup", onUp, false);
    };
    let onUp = (e)=>{
        var _e_changedTouches;
        var _e_pointerId;
        let id = (_e_pointerId = e.pointerId) !== null && _e_pointerId !== void 0 ? _e_pointerId : (_e_changedTouches = e.changedTouches) === null || _e_changedTouches === void 0 ? void 0 : _e_changedTouches[0].identifier;
        if (id === currentPointer.current) {
            focusInput();
            state.setThumbDragging(index, false);
            removeGlobalListener(window, "mouseup", onUp, false);
            removeGlobalListener(window, "touchend", onUp, false);
            removeGlobalListener(window, "pointerup", onUp, false);
        }
    };
    let thumbPosition = state.getThumbPercent(index);
    if (isVertical || direction === "rtl") thumbPosition = 1 - thumbPosition;
    let interactions = !isDisabled ? (0, _utils.mergeProps)(keyboardProps, moveProps, {
        onMouseDown: (e)=>{
            if (e.button !== 0 || e.altKey || e.ctrlKey || e.metaKey) return;
            onDown();
        },
        onPointerDown: (e)=>{
            if (e.button !== 0 || e.altKey || e.ctrlKey || e.metaKey) return;
            onDown(e.pointerId);
        },
        onTouchStart: (e)=>{
            onDown(e.changedTouches[0].identifier);
        }
    }) : {};
    (0, _utils.useFormReset)(inputRef, value, (v)=>{
        state.setThumbValue(index, v);
    });
    // We install mouse handlers for the drag motion on the thumb div, but
    // not the key handler for moving the thumb with the slider.  Instead,
    // we focus the range input, and let the browser handle the keyboard
    // interactions; we then listen to input's onChange to update state.
    return {
        inputProps: (0, _utils.mergeProps)(focusableProps, fieldProps, {
            type: "range",
            tabIndex: !isDisabled ? 0 : undefined,
            min: state.getThumbMinValue(index),
            max: state.getThumbMaxValue(index),
            step: state.step,
            value: value,
            name,
            disabled: isDisabled,
            "aria-orientation": orientation,
            "aria-valuetext": state.getThumbValueLabel(index),
            "aria-required": isRequired || undefined,
            "aria-invalid": isInvalid || validationState === "invalid" || undefined,
            "aria-errormessage": opts["aria-errormessage"],
            "aria-describedby": [
                data["aria-describedby"],
                opts["aria-describedby"]
            ].filter(Boolean).join(" "),
            "aria-details": [
                data["aria-details"],
                opts["aria-details"]
            ].filter(Boolean).join(" "),
            onChange: (e)=>{
                state.setThumbValue(index, parseFloat(e.target.value));
            }
        }),
        thumbProps: {
            ...interactions,
            style: {
                position: "absolute",
                [isVertical ? "top" : "left"]: `${thumbPosition * 100}%`,
                transform: "translate(-50%, -50%)",
                touchAction: "none"
            }
        },
        labelProps,
        isDragging: state.isThumbDragging(index),
        isDisabled,
        isFocused
    };
}

},{"@react-aria/utils":"9cLk5","./utils":"6dfd2","react":"9yzVZ","@react-aria/focus":"42mbF","@react-aria/interactions":"ky3G8","@react-aria/label":"74Ccz","@react-aria/i18n":"411rg","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"dXthB":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useSwitch", ()=>(0, _useSwitch.useSwitch));
var _useSwitch = require("./useSwitch");

},{"./useSwitch":"iwvzV","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"iwvzV":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides the behavior and accessibility implementation for a switch component.
 * A switch is similar to a checkbox, but represents on/off values as opposed to selection.
 * @param props - Props for the switch.
 * @param state - State for the switch, as returned by `useToggleState`.
 * @param ref - Ref to the HTML input element.
 */ parcelHelpers.export(exports, "useSwitch", ()=>useSwitch);
var _toggle = require("@react-aria/toggle");
function useSwitch(props, state, ref) {
    let { labelProps, inputProps, isSelected, isPressed, isDisabled, isReadOnly } = (0, _toggle.useToggle)(props, state, ref);
    return {
        labelProps,
        inputProps: {
            ...inputProps,
            role: "switch",
            checked: isSelected
        },
        isSelected,
        isPressed,
        isDisabled,
        isReadOnly
    };
}

},{"@react-aria/toggle":"2QYP2","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"jm3EF":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useTable", ()=>(0, _useTable.useTable));
parcelHelpers.export(exports, "useTableColumnHeader", ()=>(0, _useTableColumnHeader.useTableColumnHeader));
parcelHelpers.export(exports, "useTableRow", ()=>(0, _useTableRow.useTableRow));
parcelHelpers.export(exports, "useTableHeaderRow", ()=>(0, _useTableHeaderRow.useTableHeaderRow));
parcelHelpers.export(exports, "useTableCell", ()=>(0, _useTableCell.useTableCell));
parcelHelpers.export(exports, "useTableSelectionCheckbox", ()=>(0, _useTableSelectionCheckbox.useTableSelectionCheckbox));
parcelHelpers.export(exports, "useTableSelectAllCheckbox", ()=>(0, _useTableSelectionCheckbox.useTableSelectAllCheckbox));
parcelHelpers.export(exports, "useTableColumnResize", ()=>(0, _useTableColumnResize.useTableColumnResize));
parcelHelpers.export(exports, "useTableRowGroup", ()=>useTableRowGroup);
var _useTable = require("./useTable");
var _useTableColumnHeader = require("./useTableColumnHeader");
var _useTableRow = require("./useTableRow");
var _useTableHeaderRow = require("./useTableHeaderRow");
var _useTableCell = require("./useTableCell");
var _useTableSelectionCheckbox = require("./useTableSelectionCheckbox");
var _useTableColumnResize = require("./useTableColumnResize");
// Workaround for a Parcel bug where re-exports don't work in the CommonJS output format...
// export {useGridRowGroup as useTableRowGroup} from '@react-aria/grid';
var _grid = require("@react-aria/grid");
function useTableRowGroup() {
    return (0, _grid.useGridRowGroup)();
}

},{"./useTable":"aJmgZ","./useTableColumnHeader":"2H9rY","./useTableRow":"eJ7g5","./useTableHeaderRow":"e59Fw","./useTableCell":"eoGY0","./useTableSelectionCheckbox":"iI6o5","./useTableColumnResize":"41Zet","@react-aria/grid":"6tGaN","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"aJmgZ":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides the behavior and accessibility implementation for a table component.
 * A table displays data in rows and columns and enables a user to navigate its contents via directional navigation keys,
 * and optionally supports row selection and sorting.
 * @param props - Props for the table.
 * @param state - State for the table, as returned by `useTableState`.
 * @param ref - The ref attached to the table element.
 */ parcelHelpers.export(exports, "useTable", ()=>useTable);
var _liveAnnouncer = require("@react-aria/live-announcer");
var _grid = require("@react-aria/grid");
var _utils = require("./utils");
// @ts-ignore
var _json = require("../intl/*.json");
var _jsonDefault = parcelHelpers.interopDefault(_json);
var _utils1 = require("@react-aria/utils");
var _react = require("react");
var _tableKeyboardDelegate = require("./TableKeyboardDelegate");
var _flags = require("@react-stately/flags");
var _i18N = require("@react-aria/i18n");
function useTable(props, state, ref) {
    let { keyboardDelegate, isVirtualized, layout } = props;
    // By default, a KeyboardDelegate is provided which uses the DOM to query layout information (e.g. for page up/page down).
    // When virtualized, the layout object will be passed in as a prop and override this.
    let collator = (0, _i18N.useCollator)({
        usage: "search",
        sensitivity: "base"
    });
    let { direction } = (0, _i18N.useLocale)();
    let disabledBehavior = state.selectionManager.disabledBehavior;
    let delegate = (0, _react.useMemo)(()=>keyboardDelegate || new (0, _tableKeyboardDelegate.TableKeyboardDelegate)({
            collection: state.collection,
            disabledKeys: disabledBehavior === "selection" ? new Set() : state.disabledKeys,
            ref,
            direction,
            collator,
            layout
        }), [
        keyboardDelegate,
        state.collection,
        state.disabledKeys,
        disabledBehavior,
        ref,
        direction,
        collator,
        layout
    ]);
    let id = (0, _utils1.useId)(props.id);
    (0, _utils.gridIds).set(state, id);
    let { gridProps } = (0, _grid.useGrid)({
        ...props,
        id,
        keyboardDelegate: delegate
    }, state, ref);
    // Override to include header rows
    if (isVirtualized) gridProps["aria-rowcount"] = state.collection.size + state.collection.headerRows.length;
    if ((0, _flags.tableNestedRows)() && "expandedKeys" in state) gridProps.role = "treegrid";
    let { column, direction: sortDirection } = state.sortDescriptor || {};
    let stringFormatter = (0, _i18N.useLocalizedStringFormatter)((0, _jsonDefault.default), "@react-aria/table");
    let sortDescription = (0, _react.useMemo)(()=>{
        var _state_collection_columns_find;
        let columnName = (_state_collection_columns_find = state.collection.columns.find((c)=>c.key === column)) === null || _state_collection_columns_find === void 0 ? void 0 : _state_collection_columns_find.textValue;
        return sortDirection && column ? stringFormatter.format(`${sortDirection}Sort`, {
            columnName
        }) : undefined;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        sortDirection,
        column,
        state.collection.columns
    ]);
    let descriptionProps = (0, _utils1.useDescription)(sortDescription);
    // Only announce after initial render, tabbing to the table will tell you the initial sort info already
    (0, _utils1.useUpdateEffect)(()=>{
        (0, _liveAnnouncer.announce)(sortDescription, "assertive", 500);
    }, [
        sortDescription
    ]);
    return {
        gridProps: (0, _utils1.mergeProps)(gridProps, descriptionProps, {
            // merge sort description with long press information
            "aria-describedby": [
                descriptionProps["aria-describedby"],
                gridProps["aria-describedby"]
            ].filter(Boolean).join(" ")
        })
    };
}

},{"@react-aria/live-announcer":"ipdGY","@react-aria/grid":"6tGaN","./utils":"bxsPM","../intl/*.json":"9fot9","@react-aria/utils":"9cLk5","react":"9yzVZ","./TableKeyboardDelegate":"a21Ot","@react-stately/flags":"aEc5X","@react-aria/i18n":"411rg","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"bxsPM":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "gridIds", ()=>gridIds);
parcelHelpers.export(exports, "getColumnHeaderId", ()=>getColumnHeaderId);
parcelHelpers.export(exports, "getCellId", ()=>getCellId);
parcelHelpers.export(exports, "getRowLabelledBy", ()=>getRowLabelledBy);
const gridIds = new WeakMap();
function normalizeKey(key) {
    if (typeof key === "string") return key.replace(/\s*/g, "");
    return "" + key;
}
function getColumnHeaderId(state, columnKey) {
    let gridId = gridIds.get(state);
    if (!gridId) throw new Error("Unknown grid");
    return `${gridId}-${normalizeKey(columnKey)}`;
}
function getCellId(state, rowKey, columnKey) {
    let gridId = gridIds.get(state);
    if (!gridId) throw new Error("Unknown grid");
    return `${gridId}-${normalizeKey(rowKey)}-${normalizeKey(columnKey)}`;
}
function getRowLabelledBy(state, rowKey) {
    // A row is labelled by it's row headers.
    return [
        ...state.collection.rowHeaderColumnKeys
    ].map((columnKey)=>getCellId(state, rowKey, columnKey)).join(" ");
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"9fot9":[function(require,module,exports) {
const _temp0 = require("cf385b94525b9da9");
const _temp1 = require("21b1de6675efcd4e");
const _temp2 = require("4e848cdbb3e50cda");
const _temp3 = require("28014ba945067676");
const _temp4 = require("bf24250431fa0d29");
const _temp5 = require("466a19e6aecaad4a");
const _temp6 = require("2b8cf082e5c964ad");
const _temp7 = require("d1299382a26241ba");
const _temp8 = require("da62e00969cf3b84");
const _temp9 = require("e20492c3c509b59c");
const _temp10 = require("3b72f1796d1a95a4");
const _temp11 = require("48f0666150a5ce03");
const _temp12 = require("1df32252b629f7c3");
const _temp13 = require("a443ca5be4a76559");
const _temp14 = require("f7afc01387d059e3");
const _temp15 = require("895dae6a537aa85e");
const _temp16 = require("620ecf023b4b9ac6");
const _temp17 = require("885e0a25ffaa309d");
const _temp18 = require("4e740a89812e37ed");
const _temp19 = require("830bdfb50de6c13d");
const _temp20 = require("df95933efff5fb42");
const _temp21 = require("f2e110614600509");
const _temp22 = require("7b5ce0175a763448");
const _temp23 = require("951d69b4435a2f5a");
const _temp24 = require("e3d5633943388ce2");
const _temp25 = require("bf47de22f36296f9");
const _temp26 = require("72cc1edfbe51e8b5");
const _temp27 = require("ccf5804239f9a5de");
const _temp28 = require("151623ebfcce50fe");
const _temp29 = require("94523f35554264d4");
const _temp30 = require("ab8288b15f8e207c");
const _temp31 = require("49a4fae5b4131456");
const _temp32 = require("6ccabd597cf0664");
const _temp33 = require("f5f153319d8428bd");
module.exports = {
    "ar-AE": _temp0,
    "bg-BG": _temp1,
    "cs-CZ": _temp2,
    "da-DK": _temp3,
    "de-DE": _temp4,
    "el-GR": _temp5,
    "en-US": _temp6,
    "es-ES": _temp7,
    "et-EE": _temp8,
    "fi-FI": _temp9,
    "fr-FR": _temp10,
    "he-IL": _temp11,
    "hr-HR": _temp12,
    "hu-HU": _temp13,
    "it-IT": _temp14,
    "ja-JP": _temp15,
    "ko-KR": _temp16,
    "lt-LT": _temp17,
    "lv-LV": _temp18,
    "nb-NO": _temp19,
    "nl-NL": _temp20,
    "pl-PL": _temp21,
    "pt-BR": _temp22,
    "pt-PT": _temp23,
    "ro-RO": _temp24,
    "ru-RU": _temp25,
    "sk-SK": _temp26,
    "sl-SI": _temp27,
    "sr-SP": _temp28,
    "sv-SE": _temp29,
    "tr-TR": _temp30,
    "uk-UA": _temp31,
    "zh-CN": _temp32,
    "zh-TW": _temp33
};

},{"cf385b94525b9da9":"1Mdrt","21b1de6675efcd4e":"2KFXI","4e848cdbb3e50cda":"9SCsQ","28014ba945067676":"6ilIQ","bf24250431fa0d29":"klYbd","466a19e6aecaad4a":"cGKyV","2b8cf082e5c964ad":"hRMNh","d1299382a26241ba":"3095d","da62e00969cf3b84":"jXTE7","e20492c3c509b59c":"gvKcO","3b72f1796d1a95a4":"cxWvS","48f0666150a5ce03":"bCKUz","1df32252b629f7c3":"7uLR9","a443ca5be4a76559":"aa62a","f7afc01387d059e3":"BVmRT","895dae6a537aa85e":"8HhAb","620ecf023b4b9ac6":"13gzN","885e0a25ffaa309d":"jBrCL","4e740a89812e37ed":"c6leH","830bdfb50de6c13d":"jfkGE","df95933efff5fb42":"aNRzV","f2e110614600509":"bl6F5","7b5ce0175a763448":"eCYYJ","951d69b4435a2f5a":"aEZAS","e3d5633943388ce2":"l9QYl","bf47de22f36296f9":"bWlSl","72cc1edfbe51e8b5":"k9U0L","ccf5804239f9a5de":"8D0z3","151623ebfcce50fe":"k4TgH","94523f35554264d4":"dSiQl","ab8288b15f8e207c":"2g2Uu","49a4fae5b4131456":"9FM60","6ccabd597cf0664":"1lstA","f5f153319d8428bd":"2AwCv"}],"1Mdrt":[function(require,module,exports) {
module.exports = {
    "ascending": `\u{62A}\u{635}\u{627}\u{639}\u{62F}\u{64A}`,
    "ascendingSort": (args)=>`\u{62A}\u{631}\u{62A}\u{64A}\u{628} \u{62D}\u{633}\u{628} \u{627}\u{644}\u{639}\u{645}\u{648}\u{62F} ${args.columnName} \u{628}\u{62A}\u{631}\u{62A}\u{64A}\u{628} \u{62A}\u{635}\u{627}\u{639}\u{62F}\u{64A}`,
    "columnSize": (args)=>`${args.value} \u{628}\u{627}\u{644}\u{628}\u{643}\u{633}\u{644}`,
    "descending": `\u{62A}\u{646}\u{627}\u{632}\u{644}\u{64A}`,
    "descendingSort": (args)=>`\u{62A}\u{631}\u{62A}\u{64A}\u{628} \u{62D}\u{633}\u{628} \u{627}\u{644}\u{639}\u{645}\u{648}\u{62F} ${args.columnName} \u{628}\u{62A}\u{631}\u{62A}\u{64A}\u{628} \u{62A}\u{646}\u{627}\u{632}\u{644}\u{64A}`,
    "resizerDescription": `\u{627}\u{636}\u{63A}\u{637} \u{639}\u{644}\u{649} \u{645}\u{641}\u{62A}\u{627}\u{62D} Enter \u{644}\u{628}\u{62F}\u{621} \u{62A}\u{63A}\u{64A}\u{64A}\u{631} \u{627}\u{644}\u{62D}\u{62C}\u{645}`,
    "select": `\u{62A}\u{62D}\u{62F}\u{64A}\u{62F}`,
    "selectAll": `\u{62A}\u{62D}\u{62F}\u{64A}\u{62F} \u{627}\u{644}\u{643}\u{644}`,
    "sortable": `\u{639}\u{645}\u{648}\u{62F} \u{642}\u{627}\u{628}\u{644} \u{644}\u{644}\u{62A}\u{631}\u{62A}\u{64A}\u{628}`
};

},{}],"2KFXI":[function(require,module,exports) {
module.exports = {
    "ascending": `\u{432}\u{44A}\u{437}\u{445}\u{43E}\u{434}\u{44F}\u{449}`,
    "ascendingSort": (args)=>`\u{441}\u{43E}\u{440}\u{442}\u{438}\u{440}\u{430}\u{43D}\u{43E} \u{43F}\u{43E} \u{43A}\u{43E}\u{43B}\u{43E}\u{43D}\u{430} ${args.columnName} \u{432}\u{44A}\u{432} \u{432}\u{44A}\u{437}\u{445}\u{43E}\u{434}\u{44F}\u{449} \u{440}\u{435}\u{434}`,
    "columnSize": (args)=>`${args.value} \u{43F}\u{438}\u{43A}\u{441}\u{435}\u{43B}\u{430}`,
    "descending": `\u{43D}\u{438}\u{437}\u{445}\u{43E}\u{434}\u{44F}\u{449}`,
    "descendingSort": (args)=>`\u{441}\u{43E}\u{440}\u{442}\u{438}\u{440}\u{430}\u{43D}\u{43E} \u{43F}\u{43E} \u{43A}\u{43E}\u{43B}\u{43E}\u{43D}\u{430} ${args.columnName} \u{432} \u{43D}\u{438}\u{437}\u{445}\u{43E}\u{434}\u{44F}\u{449} \u{440}\u{435}\u{434}`,
    "resizerDescription": `\u{41D}\u{430}\u{442}\u{438}\u{441}\u{43D}\u{435}\u{442}\u{435} \u{201E}Enter\u{201C}, \u{437}\u{430} \u{434}\u{430} \u{437}\u{430}\u{43F}\u{43E}\u{447}\u{43D}\u{435}\u{442}\u{435} \u{434}\u{430} \u{43F}\u{440}\u{435}\u{43E}\u{440}\u{430}\u{437}\u{43C}\u{435}\u{440}\u{44F}\u{432}\u{430}\u{442}\u{435}`,
    "select": `\u{418}\u{437}\u{431}\u{435}\u{440}\u{435}\u{442}\u{435}`,
    "selectAll": `\u{418}\u{437}\u{431}\u{435}\u{440}\u{435}\u{442}\u{435} \u{432}\u{441}\u{438}\u{447}\u{43A}\u{43E}`,
    "sortable": `\u{441}\u{43E}\u{440}\u{442}\u{438}\u{440}\u{430}\u{449}\u{430} \u{43A}\u{43E}\u{43B}\u{43E}\u{43D}\u{430}`
};

},{}],"9SCsQ":[function(require,module,exports) {
module.exports = {
    "ascending": `vzestupn\u{11B}`,
    "ascendingSort": (args)=>`\u{159}azeno vzestupn\u{11B} podle sloupce ${args.columnName}`,
    "columnSize": (args)=>`${args.value} pixel\u{16F}`,
    "descending": `sestupn\u{11B}`,
    "descendingSort": (args)=>`\u{159}azeno sestupn\u{11B} podle sloupce ${args.columnName}`,
    "resizerDescription": `Stisknut\xedm kl\xe1vesy Enter za\u{10D}nete m\u{11B}nit velikost`,
    "select": `Vybrat`,
    "selectAll": `Vybrat v\u{161}e`,
    "sortable": `sloupec s mo\u{17E}nost\xed \u{159}azen\xed`
};

},{}],"6ilIQ":[function(require,module,exports) {
module.exports = {
    "ascending": `stigende`,
    "ascendingSort": (args)=>`sorteret efter kolonne ${args.columnName} i stigende r\xe6kkef\xf8lge`,
    "columnSize": (args)=>`${args.value} pixels`,
    "descending": `faldende`,
    "descendingSort": (args)=>`sorteret efter kolonne ${args.columnName} i faldende r\xe6kkef\xf8lge`,
    "resizerDescription": `Tryk p\xe5 Enter for at \xe6ndre st\xf8rrelse`,
    "select": `V\xe6lg`,
    "selectAll": `V\xe6lg alle`,
    "sortable": `sorterbar kolonne`
};

},{}],"klYbd":[function(require,module,exports) {
module.exports = {
    "ascending": `aufsteigend`,
    "ascendingSort": (args)=>`sortiert nach Spalte ${args.columnName} in aufsteigender Reihenfolge`,
    "columnSize": (args)=>`${args.value} Pixel`,
    "descending": `absteigend`,
    "descendingSort": (args)=>`sortiert nach Spalte ${args.columnName} in absteigender Reihenfolge`,
    "resizerDescription": `Eingabetaste zum Starten der Gr\xf6\xdfen\xe4nderung dr\xfccken`,
    "select": `Ausw\xe4hlen`,
    "selectAll": `Alles ausw\xe4hlen`,
    "sortable": `sortierbare Spalte`
};

},{}],"cGKyV":[function(require,module,exports) {
module.exports = {
    "ascending": `\u{3B1}\u{3CD}\u{3BE}\u{3BF}\u{3C5}\u{3C3}\u{3B1}`,
    "ascendingSort": (args)=>`\u{3B4}\u{3B9}\u{3B1}\u{3BB}\u{3BF}\u{3B3}\u{3AE} \u{3B1}\u{3BD}\u{3AC} \u{3C3}\u{3C4}\u{3AE}\u{3BB}\u{3B7} ${args.columnName} \u{3C3}\u{3B5} \u{3B1}\u{3CD}\u{3BE}\u{3BF}\u{3C5}\u{3C3}\u{3B1} \u{3C3}\u{3B5}\u{3B9}\u{3C1}\u{3AC}`,
    "columnSize": (args)=>`${args.value} pixel`,
    "descending": `\u{3C6}\u{3B8}\u{3AF}\u{3BD}\u{3BF}\u{3C5}\u{3C3}\u{3B1}`,
    "descendingSort": (args)=>`\u{3B4}\u{3B9}\u{3B1}\u{3BB}\u{3BF}\u{3B3}\u{3AE} \u{3B1}\u{3BD}\u{3AC} \u{3C3}\u{3C4}\u{3AE}\u{3BB}\u{3B7} ${args.columnName} \u{3C3}\u{3B5} \u{3C6}\u{3B8}\u{3AF}\u{3BD}\u{3BF}\u{3C5}\u{3C3}\u{3B1} \u{3C3}\u{3B5}\u{3B9}\u{3C1}\u{3AC}`,
    "resizerDescription": `\u{3A0}\u{3B1}\u{3C4}\u{3AE}\u{3C3}\u{3C4}\u{3B5} Enter \u{3B3}\u{3B9}\u{3B1} \u{3AD}\u{3BD}\u{3B1}\u{3C1}\u{3BE}\u{3B7} \u{3C4}\u{3B7}\u{3C2} \u{3B1}\u{3BB}\u{3BB}\u{3B1}\u{3B3}\u{3AE}\u{3C2} \u{3BC}\u{3B5}\u{3B3}\u{3AD}\u{3B8}\u{3BF}\u{3C5}\u{3C2}`,
    "select": `\u{395}\u{3C0}\u{3B9}\u{3BB}\u{3BF}\u{3B3}\u{3AE}`,
    "selectAll": `\u{395}\u{3C0}\u{3B9}\u{3BB}\u{3BF}\u{3B3}\u{3AE} \u{3CC}\u{3BB}\u{3C9}\u{3BD}`,
    "sortable": `\u{3A3}\u{3C4}\u{3AE}\u{3BB}\u{3B7} \u{3B4}\u{3B9}\u{3B1}\u{3BB}\u{3BF}\u{3B3}\u{3AE}\u{3C2}`
};

},{}],"hRMNh":[function(require,module,exports) {
module.exports = {
    "select": `Select`,
    "selectAll": `Select All`,
    "sortable": `sortable column`,
    "ascending": `ascending`,
    "descending": `descending`,
    "ascendingSort": (args)=>`sorted by column ${args.columnName} in ascending order`,
    "descendingSort": (args)=>`sorted by column ${args.columnName} in descending order`,
    "columnSize": (args)=>`${args.value} pixels`,
    "resizerDescription": `Press Enter to start resizing`
};

},{}],"3095d":[function(require,module,exports) {
module.exports = {
    "ascending": `de subida`,
    "ascendingSort": (args)=>`ordenado por columna ${args.columnName} en orden de subida`,
    "columnSize": (args)=>`${args.value} p\xedxeles`,
    "descending": `de bajada`,
    "descendingSort": (args)=>`ordenado por columna ${args.columnName} en orden de bajada`,
    "resizerDescription": `Pulse Intro para empezar a redimensionar`,
    "select": `Seleccionar`,
    "selectAll": `Seleccionar todos`,
    "sortable": `columna ordenable`
};

},{}],"jXTE7":[function(require,module,exports) {
module.exports = {
    "ascending": `t\xf5usev j\xe4rjestus`,
    "ascendingSort": (args)=>`sorditud veeru j\xe4rgi ${args.columnName} t\xf5usvas j\xe4rjestuses`,
    "columnSize": (args)=>`${args.value} pikslit`,
    "descending": `laskuv j\xe4rjestus`,
    "descendingSort": (args)=>`sorditud veeru j\xe4rgi ${args.columnName} laskuvas j\xe4rjestuses`,
    "resizerDescription": `Suuruse muutmise alustamiseks vajutage klahvi Enter`,
    "select": `Vali`,
    "selectAll": `Vali k\xf5ik`,
    "sortable": `sorditav veerg`
};

},{}],"gvKcO":[function(require,module,exports) {
module.exports = {
    "ascending": `nouseva`,
    "ascendingSort": (args)=>`lajiteltu sarakkeen ${args.columnName} mukaan nousevassa j\xe4rjestyksess\xe4`,
    "columnSize": (args)=>`${args.value} pikseli\xe4`,
    "descending": `laskeva`,
    "descendingSort": (args)=>`lajiteltu sarakkeen ${args.columnName} mukaan laskevassa j\xe4rjestyksess\xe4`,
    "resizerDescription": `Aloita koon muutos painamalla Enter-n\xe4pp\xe4int\xe4`,
    "select": `Valitse`,
    "selectAll": `Valitse kaikki`,
    "sortable": `lajiteltava sarake`
};

},{}],"cxWvS":[function(require,module,exports) {
module.exports = {
    "ascending": `croissant`,
    "ascendingSort": (args)=>`tri\xe9 en fonction de la colonne\xa0${args.columnName} par ordre croissant`,
    "columnSize": (args)=>`${args.value}\xa0pixels`,
    "descending": `d\xe9croissant`,
    "descendingSort": (args)=>`tri\xe9 en fonction de la colonne\xa0${args.columnName} par ordre d\xe9croissant`,
    "resizerDescription": `Appuyez sur Entr\xe9e pour commencer le redimensionnement.`,
    "select": `S\xe9lectionner`,
    "selectAll": `S\xe9lectionner tout`,
    "sortable": `colonne triable`
};

},{}],"bCKUz":[function(require,module,exports) {
module.exports = {
    "ascending": `\u{5E2}\u{5D5}\u{5DC}\u{5D4}`,
    "ascendingSort": (args)=>`\u{5DE}\u{5D5}\u{5D9}\u{5DF} \u{5DC}\u{5E4}\u{5D9} \u{5E2}\u{5DE}\u{5D5}\u{5D3}\u{5D4} ${args.columnName} \u{5D1}\u{5E1}\u{5D3}\u{5E8} \u{5E2}\u{5D5}\u{5DC}\u{5D4}`,
    "columnSize": (args)=>`${args.value} \u{5E4}\u{5D9}\u{5E7}\u{5E1}\u{5DC}\u{5D9}\u{5DD}`,
    "descending": `\u{5D9}\u{5D5}\u{5E8}\u{5D3}`,
    "descendingSort": (args)=>`\u{5DE}\u{5D5}\u{5D9}\u{5DF} \u{5DC}\u{5E4}\u{5D9} \u{5E2}\u{5DE}\u{5D5}\u{5D3}\u{5D4} ${args.columnName} \u{5D1}\u{5E1}\u{5D3}\u{5E8} \u{5D9}\u{5D5}\u{5E8}\u{5D3}`,
    "resizerDescription": `\u{5D4}\u{5E7}\u{5E9} Enter \u{5DB}\u{5D3}\u{5D9} \u{5DC}\u{5E9}\u{5E0}\u{5D5}\u{5EA} \u{5D0}\u{5EA} \u{5D4}\u{5D2}\u{5D5}\u{5D3}\u{5DC}`,
    "select": `\u{5D1}\u{5D7}\u{5E8}`,
    "selectAll": `\u{5D1}\u{5D7}\u{5E8} \u{5D4}\u{5DB}\u{5D5}\u{5DC}`,
    "sortable": `\u{5E2}\u{5DE}\u{5D5}\u{5D3}\u{5D4} \u{5E9}\u{5E0}\u{5D9}\u{5EA}\u{5DF} \u{5DC}\u{5DE}\u{5D9}\u{5D9}\u{5DF}`
};

},{}],"7uLR9":[function(require,module,exports) {
module.exports = {
    "ascending": `rastu\u{107}i`,
    "ascendingSort": (args)=>`razvrstano po stupcima ${args.columnName} rastu\u{107}em redoslijedom`,
    "columnSize": (args)=>`${args.value} piksela`,
    "descending": `padaju\u{107}i`,
    "descendingSort": (args)=>`razvrstano po stupcima ${args.columnName} padaju\u{107}im redoslijedom`,
    "resizerDescription": `Pritisnite Enter da biste zapo\u{10D}eli promenu veli\u{10D}ine`,
    "select": `Odaberite`,
    "selectAll": `Odaberite sve`,
    "sortable": `stupac koji se mo\u{17E}e razvrstati`
};

},{}],"aa62a":[function(require,module,exports) {
module.exports = {
    "ascending": `n\xf6vekv\u{151}`,
    "ascendingSort": (args)=>`rendezve a(z) ${args.columnName} oszlop szerint, n\xf6vekv\u{151} sorrendben`,
    "columnSize": (args)=>`${args.value} k\xe9ppont`,
    "descending": `cs\xf6kken\u{151}`,
    "descendingSort": (args)=>`rendezve a(z) ${args.columnName} oszlop szerint, cs\xf6kken\u{151} sorrendben`,
    "resizerDescription": `Nyomja le az Enter billenty\u{171}t az \xe1tm\xe9retez\xe9s megkezd\xe9s\xe9hez`,
    "select": `Kijel\xf6l\xe9s`,
    "selectAll": `\xd6sszes kijel\xf6l\xe9se`,
    "sortable": `rendezend\u{151} oszlop`
};

},{}],"BVmRT":[function(require,module,exports) {
module.exports = {
    "ascending": `crescente`,
    "ascendingSort": (args)=>`in ordine crescente in base alla colonna ${args.columnName}`,
    "columnSize": (args)=>`${args.value} pixel`,
    "descending": `decrescente`,
    "descendingSort": (args)=>`in ordine decrescente in base alla colonna ${args.columnName}`,
    "resizerDescription": `Premi Invio per iniziare a ridimensionare`,
    "select": `Seleziona`,
    "selectAll": `Seleziona tutto`,
    "sortable": `colonna ordinabile`
};

},{}],"8HhAb":[function(require,module,exports) {
module.exports = {
    "ascending": `\u{6607}\u{9806}`,
    "ascendingSort": (args)=>`\u{5217} ${args.columnName} \u{3092}\u{6607}\u{9806}\u{3067}\u{4E26}\u{3079}\u{66FF}\u{3048}`,
    "columnSize": (args)=>`${args.value} \u{30D4}\u{30AF}\u{30BB}\u{30EB}`,
    "descending": `\u{964D}\u{9806}`,
    "descendingSort": (args)=>`\u{5217} ${args.columnName} \u{3092}\u{964D}\u{9806}\u{3067}\u{4E26}\u{3079}\u{66FF}\u{3048}`,
    "resizerDescription": `Enter \u{30AD}\u{30FC}\u{3092}\u{62BC}\u{3057}\u{3066}\u{30B5}\u{30A4}\u{30BA}\u{5909}\u{66F4}\u{3092}\u{958B}\u{59CB}`,
    "select": `\u{9078}\u{629E}`,
    "selectAll": `\u{3059}\u{3079}\u{3066}\u{9078}\u{629E}`,
    "sortable": `\u{4E26}\u{3079}\u{66FF}\u{3048}\u{53EF}\u{80FD}\u{306A}\u{5217}`
};

},{}],"13gzN":[function(require,module,exports) {
module.exports = {
    "ascending": `\u{C624}\u{B984}\u{CC28}\u{C21C}`,
    "ascendingSort": (args)=>`${args.columnName} \u{C5F4}\u{C744} \u{AE30}\u{C900}\u{C73C}\u{B85C} \u{C624}\u{B984}\u{CC28}\u{C21C}\u{C73C}\u{B85C} \u{C815}\u{B82C}\u{B428}`,
    "columnSize": (args)=>`${args.value} \u{D53D}\u{C140}`,
    "descending": `\u{B0B4}\u{B9BC}\u{CC28}\u{C21C}`,
    "descendingSort": (args)=>`${args.columnName} \u{C5F4}\u{C744} \u{AE30}\u{C900}\u{C73C}\u{B85C} \u{B0B4}\u{B9BC}\u{CC28}\u{C21C}\u{C73C}\u{B85C} \u{C815}\u{B82C}\u{B428}`,
    "resizerDescription": `\u{D06C}\u{AE30} \u{C870}\u{C815}\u{C744} \u{C2DC}\u{C791}\u{D558}\u{B824}\u{BA74} Enter\u{B97C} \u{B204}\u{B974}\u{C138}\u{C694}.`,
    "select": `\u{C120}\u{D0DD}`,
    "selectAll": `\u{BAA8}\u{B450} \u{C120}\u{D0DD}`,
    "sortable": `\u{C815}\u{B82C} \u{AC00}\u{B2A5}\u{D55C} \u{C5F4}`
};

},{}],"jBrCL":[function(require,module,exports) {
module.exports = {
    "ascending": `did\u{117}jan\u{10D}ia tvarka`,
    "ascendingSort": (args)=>`surikiuota pagal stulpel\u{12F} ${args.columnName} did\u{117}jan\u{10D}ia tvarka`,
    "columnSize": (args)=>`${args.value} piks.`,
    "descending": `ma\u{17E}\u{117}jan\u{10D}ia tvarka`,
    "descendingSort": (args)=>`surikiuota pagal stulpel\u{12F} ${args.columnName} ma\u{17E}\u{117}jan\u{10D}ia tvarka`,
    "resizerDescription": `Paspauskite \u{201E}Enter\u{201C}, kad prad\u{117}tum\u{117}te keisti dyd\u{12F}`,
    "select": `Pasirinkti`,
    "selectAll": `Pasirinkti visk\u{105}`,
    "sortable": `rikiuojamas stulpelis`
};

},{}],"c6leH":[function(require,module,exports) {
module.exports = {
    "ascending": `augo\u{161}\u{101} sec\u{12B}b\u{101}`,
    "ascendingSort": (args)=>`k\u{101}rtots p\u{113}c kolonnas ${args.columnName} augo\u{161}\u{101} sec\u{12B}b\u{101}`,
    "columnSize": (args)=>`${args.value} pikse\u{13C}i`,
    "descending": `dilsto\u{161}\u{101} sec\u{12B}b\u{101}`,
    "descendingSort": (args)=>`k\u{101}rtots p\u{113}c kolonnas ${args.columnName} dilsto\u{161}\u{101} sec\u{12B}b\u{101}`,
    "resizerDescription": `Nospiediet Enter, lai s\u{101}ktu izm\u{113}ru main\u{12B}\u{161}anu`,
    "select": `Atlas\u{12B}t`,
    "selectAll": `Atlas\u{12B}t visu`,
    "sortable": `k\u{101}rtojam\u{101} kolonna`
};

},{}],"jfkGE":[function(require,module,exports) {
module.exports = {
    "ascending": `stigende`,
    "ascendingSort": (args)=>`sortert etter kolonne ${args.columnName} i stigende rekkef\xf8lge`,
    "columnSize": (args)=>`${args.value} piksler`,
    "descending": `synkende`,
    "descendingSort": (args)=>`sortert etter kolonne ${args.columnName} i synkende rekkef\xf8lge`,
    "resizerDescription": `Trykk p\xe5 Enter for \xe5 starte st\xf8rrelsesendring`,
    "select": `Velg`,
    "selectAll": `Velg alle`,
    "sortable": `kolonne som kan sorteres`
};

},{}],"aNRzV":[function(require,module,exports) {
module.exports = {
    "ascending": `oplopend`,
    "ascendingSort": (args)=>`gesorteerd in oplopende volgorde in kolom ${args.columnName}`,
    "columnSize": (args)=>`${args.value} pixels`,
    "descending": `aflopend`,
    "descendingSort": (args)=>`gesorteerd in aflopende volgorde in kolom ${args.columnName}`,
    "resizerDescription": `Druk op Enter om het formaat te wijzigen`,
    "select": `Selecteren`,
    "selectAll": `Alles selecteren`,
    "sortable": `sorteerbare kolom`
};

},{}],"bl6F5":[function(require,module,exports) {
module.exports = {
    "ascending": `rosn\u{105}co`,
    "ascendingSort": (args)=>`posortowano wed\u{142}ug kolumny ${args.columnName} w porz\u{105}dku rosn\u{105}cym`,
    "columnSize": (args)=>`Liczba pikseli: ${args.value}`,
    "descending": `malej\u{105}co`,
    "descendingSort": (args)=>`posortowano wed\u{142}ug kolumny ${args.columnName} w porz\u{105}dku malej\u{105}cym`,
    "resizerDescription": `Naci\u{15B}nij Enter, aby rozpocz\u{105}\u{107} zmienianie rozmiaru`,
    "select": `Zaznacz`,
    "selectAll": `Zaznacz wszystko`,
    "sortable": `kolumna z mo\u{17C}liwo\u{15B}ci\u{105} sortowania`
};

},{}],"eCYYJ":[function(require,module,exports) {
module.exports = {
    "ascending": `crescente`,
    "ascendingSort": (args)=>`classificado pela coluna ${args.columnName} em ordem crescente`,
    "columnSize": (args)=>`${args.value} pixels`,
    "descending": `decrescente`,
    "descendingSort": (args)=>`classificado pela coluna ${args.columnName} em ordem decrescente`,
    "resizerDescription": `Pressione Enter para come\xe7ar a redimensionar`,
    "select": `Selecionar`,
    "selectAll": `Selecionar tudo`,
    "sortable": `coluna classific\xe1vel`
};

},{}],"aEZAS":[function(require,module,exports) {
module.exports = {
    "ascending": `ascendente`,
    "ascendingSort": (args)=>`Ordenar por coluna ${args.columnName} em ordem ascendente`,
    "columnSize": (args)=>`${args.value} pixels`,
    "descending": `descendente`,
    "descendingSort": (args)=>`Ordenar por coluna ${args.columnName} em ordem descendente`,
    "resizerDescription": `Prima Enter para iniciar o redimensionamento`,
    "select": `Selecionar`,
    "selectAll": `Selecionar tudo`,
    "sortable": `Coluna orden\xe1vel`
};

},{}],"l9QYl":[function(require,module,exports) {
module.exports = {
    "ascending": `cresc\u{103}toare`,
    "ascendingSort": (args)=>`sortate dup\u{103} coloana ${args.columnName} \xeen ordine cresc\u{103}toare`,
    "columnSize": (args)=>`${args.value} pixeli`,
    "descending": `descresc\u{103}toare`,
    "descendingSort": (args)=>`sortate dup\u{103} coloana ${args.columnName} \xeen ordine descresc\u{103}toare`,
    "resizerDescription": `Ap\u{103}sa\u{21B}i pe Enter pentru a \xeencepe redimensionarea`,
    "select": `Selectare`,
    "selectAll": `Selectare total\u{103}`,
    "sortable": `coloan\u{103} sortabil\u{103}`
};

},{}],"bWlSl":[function(require,module,exports) {
module.exports = {
    "ascending": `\u{432}\u{43E}\u{437}\u{440}\u{430}\u{441}\u{442}\u{430}\u{43D}\u{438}\u{435}`,
    "ascendingSort": (args)=>`\u{441}\u{43E}\u{440}\u{442}\u{438}\u{440}\u{43E}\u{432}\u{430}\u{442}\u{44C} \u{441}\u{442}\u{43E}\u{43B}\u{431}\u{435}\u{446} ${args.columnName} \u{432} \u{43F}\u{43E}\u{440}\u{44F}\u{434}\u{43A}\u{435} \u{432}\u{43E}\u{437}\u{440}\u{430}\u{441}\u{442}\u{430}\u{43D}\u{438}\u{44F}`,
    "columnSize": (args)=>`${args.value} \u{43F}\u{438}\u{43A}\u{441}.`,
    "descending": `\u{443}\u{431}\u{44B}\u{432}\u{430}\u{43D}\u{438}\u{435}`,
    "descendingSort": (args)=>`\u{441}\u{43E}\u{440}\u{442}\u{438}\u{440}\u{43E}\u{432}\u{430}\u{442}\u{44C} \u{441}\u{442}\u{43E}\u{43B}\u{431}\u{435}\u{446} ${args.columnName} \u{432} \u{43F}\u{43E}\u{440}\u{44F}\u{434}\u{43A}\u{435} \u{443}\u{431}\u{44B}\u{432}\u{430}\u{43D}\u{438}\u{44F}`,
    "resizerDescription": `\u{41D}\u{430}\u{436}\u{43C}\u{438}\u{442}\u{435} \u{43A}\u{43B}\u{430}\u{432}\u{438}\u{448}\u{443} Enter \u{434}\u{43B}\u{44F} \u{43D}\u{430}\u{447}\u{430}\u{43B}\u{430} \u{438}\u{437}\u{43C}\u{435}\u{43D}\u{435}\u{43D}\u{438}\u{44F} \u{440}\u{430}\u{437}\u{43C}\u{435}\u{440}\u{43E}\u{432}`,
    "select": `\u{412}\u{44B}\u{431}\u{440}\u{430}\u{442}\u{44C}`,
    "selectAll": `\u{412}\u{44B}\u{431}\u{440}\u{430}\u{442}\u{44C} \u{432}\u{441}\u{435}`,
    "sortable": `\u{441}\u{43E}\u{440}\u{442}\u{438}\u{440}\u{443}\u{435}\u{43C}\u{44B}\u{439} \u{441}\u{442}\u{43E}\u{43B}\u{431}\u{435}\u{446}`
};

},{}],"k9U0L":[function(require,module,exports) {
module.exports = {
    "ascending": `vzostupne`,
    "ascendingSort": (args)=>`zoraden\xe9 zostupne pod\u{13E}a st\u{13A}pca ${args.columnName}`,
    "columnSize": (args)=>`Po\u{10D}et pixelov: ${args.value}`,
    "descending": `zostupne`,
    "descendingSort": (args)=>`zoraden\xe9 zostupne pod\u{13E}a st\u{13A}pca ${args.columnName}`,
    "resizerDescription": `Stla\u{10D}en\xedm kl\xe1vesu Enter za\u{10D}nete zmenu ve\u{13E}kosti`,
    "select": `Vybra\u{165}`,
    "selectAll": `Vybra\u{165} v\u{161}etko`,
    "sortable": `zoradite\u{13E}n\xfd st\u{13A}pec`
};

},{}],"8D0z3":[function(require,module,exports) {
module.exports = {
    "ascending": `nara\u{161}\u{10D}ajo\u{10D}e`,
    "ascendingSort": (args)=>`razvr\u{161}\u{10D}eno po stolpcu ${args.columnName} v nara\u{161}\u{10D}ajo\u{10D}em vrstnem redu`,
    "columnSize": (args)=>`${args.value} slikovnih pik`,
    "descending": `padajo\u{10D}e`,
    "descendingSort": (args)=>`razvr\u{161}\u{10D}eno po stolpcu ${args.columnName} v padajo\u{10D}em vrstnem redu`,
    "resizerDescription": `Pritisnite tipko Enter da za\u{10D}nete spreminjati velikost`,
    "select": `Izberite`,
    "selectAll": `Izberite vse`,
    "sortable": `razvrstljivi stolpec`
};

},{}],"k4TgH":[function(require,module,exports) {
module.exports = {
    "ascending": `rastu\u{107}i`,
    "ascendingSort": (args)=>`sortirano po kolonama ${args.columnName} rastu\u{107}im redosledom`,
    "columnSize": (args)=>`${args.value} piksela`,
    "descending": `padaju\u{107}i`,
    "descendingSort": (args)=>`sortirano po kolonama ${args.columnName} padaju\u{107}im redosledom`,
    "resizerDescription": `Pritisnite Enter da biste zapo\u{10D}eli promenu veli\u{10D}ine`,
    "select": `Izaberite`,
    "selectAll": `Izaberite sve`,
    "sortable": `kolona koja se mo\u{17E}e sortirati`
};

},{}],"dSiQl":[function(require,module,exports) {
module.exports = {
    "ascending": `stigande`,
    "ascendingSort": (args)=>`sorterat p\xe5 kolumn ${args.columnName} i stigande ordning`,
    "columnSize": (args)=>`${args.value} pixlar`,
    "descending": `fallande`,
    "descendingSort": (args)=>`sorterat p\xe5 kolumn ${args.columnName} i fallande ordning`,
    "resizerDescription": `Tryck p\xe5 Retur f\xf6r att b\xf6rja \xe4ndra storlek`,
    "select": `Markera`,
    "selectAll": `Markera allt`,
    "sortable": `sorterbar kolumn`
};

},{}],"2g2Uu":[function(require,module,exports) {
module.exports = {
    "ascending": `artan s\u{131}rada`,
    "ascendingSort": (args)=>`${args.columnName} s\xfctuna g\xf6re artan d\xfczende s\u{131}rala`,
    "columnSize": (args)=>`${args.value} piksel`,
    "descending": `azalan s\u{131}rada`,
    "descendingSort": (args)=>`${args.columnName} s\xfctuna g\xf6re azalan d\xfczende s\u{131}rala`,
    "resizerDescription": `Yeniden boyutland\u{131}rmak i\xe7in Enter'a bas\u{131}n`,
    "select": `Se\xe7`,
    "selectAll": `T\xfcm\xfcn\xfc Se\xe7`,
    "sortable": `S\u{131}ralanabilir s\xfctun`
};

},{}],"9FM60":[function(require,module,exports) {
module.exports = {
    "ascending": `\u{432}\u{438}\u{441}\u{445}\u{456}\u{434}\u{43D}\u{438}\u{439}`,
    "ascendingSort": (args)=>`\u{432}\u{456}\u{434}\u{441}\u{43E}\u{440}\u{442}\u{43E}\u{432}\u{430}\u{43D}\u{43E} \u{437}\u{430} \u{441}\u{442}\u{43E}\u{432}\u{43F}\u{446}\u{435}\u{43C} ${args.columnName} \u{443} \u{432}\u{438}\u{441}\u{445}\u{456}\u{434}\u{43D}\u{43E}\u{43C}\u{443} \u{43F}\u{43E}\u{440}\u{44F}\u{434}\u{43A}\u{443}`,
    "columnSize": (args)=>`${args.value} \u{43F}\u{456}\u{43A}\u{441}.`,
    "descending": `\u{43D}\u{438}\u{437}\u{445}\u{456}\u{434}\u{43D}\u{438}\u{439}`,
    "descendingSort": (args)=>`\u{432}\u{456}\u{434}\u{441}\u{43E}\u{440}\u{442}\u{43E}\u{432}\u{430}\u{43D}\u{43E} \u{437}\u{430} \u{441}\u{442}\u{43E}\u{432}\u{43F}\u{446}\u{435}\u{43C} ${args.columnName} \u{443} \u{43D}\u{438}\u{437}\u{445}\u{456}\u{434}\u{43D}\u{43E}\u{43C}\u{443} \u{43F}\u{43E}\u{440}\u{44F}\u{434}\u{43A}\u{443}`,
    "resizerDescription": `\u{41D}\u{430}\u{442}\u{438}\u{441}\u{43D}\u{456}\u{442}\u{44C} Enter, \u{449}\u{43E}\u{431} \u{43F}\u{43E}\u{447}\u{430}\u{442}\u{438} \u{437}\u{43C}\u{456}\u{43D}\u{443} \u{440}\u{43E}\u{437}\u{43C}\u{456}\u{440}\u{443}`,
    "select": `\u{412}\u{438}\u{431}\u{440}\u{430}\u{442}\u{438}`,
    "selectAll": `\u{412}\u{438}\u{431}\u{440}\u{430}\u{442}\u{438} \u{432}\u{441}\u{435}`,
    "sortable": `\u{441}\u{43E}\u{440}\u{442}\u{443}\u{432}\u{430}\u{43B}\u{44C}\u{43D}\u{438}\u{439} \u{441}\u{442}\u{43E}\u{432}\u{43F}\u{435}\u{446}\u{44C}`
};

},{}],"1lstA":[function(require,module,exports) {
module.exports = {
    "ascending": `\u{5347}\u{5E8F}`,
    "ascendingSort": (args)=>`\u{6309}\u{5217} ${args.columnName} \u{5347}\u{5E8F}\u{6392}\u{5E8F}`,
    "columnSize": (args)=>`${args.value} \u{50CF}\u{7D20}`,
    "descending": `\u{964D}\u{5E8F}`,
    "descendingSort": (args)=>`\u{6309}\u{5217} ${args.columnName} \u{964D}\u{5E8F}\u{6392}\u{5E8F}`,
    "resizerDescription": `\u{6309}\u{201C}\u{8F93}\u{5165}\u{201D}\u{952E}\u{5F00}\u{59CB}\u{8C03}\u{6574}\u{5927}\u{5C0F}\u{3002}`,
    "select": `\u{9009}\u{62E9}`,
    "selectAll": `\u{5168}\u{9009}`,
    "sortable": `\u{53EF}\u{6392}\u{5E8F}\u{7684}\u{5217}`
};

},{}],"2AwCv":[function(require,module,exports) {
module.exports = {
    "ascending": `\u{905E}\u{589E}`,
    "ascendingSort": (args)=>`\u{5DF2}\u{4F9D}\u{64DA}\u{300C}${args.columnName}\u{300D}\u{6B04}\u{905E}\u{589E}\u{6392}\u{5E8F}`,
    "columnSize": (args)=>`${args.value} \u{50CF}\u{7D20}`,
    "descending": `\u{905E}\u{6E1B}`,
    "descendingSort": (args)=>`\u{5DF2}\u{4F9D}\u{64DA}\u{300C}${args.columnName}\u{300D}\u{6B04}\u{905E}\u{6E1B}\u{6392}\u{5E8F}`,
    "resizerDescription": `\u{6309} Enter \u{9375}\u{4EE5}\u{958B}\u{59CB}\u{8ABF}\u{6574}\u{5927}\u{5C0F}`,
    "select": `\u{9078}\u{53D6}`,
    "selectAll": `\u{5168}\u{9078}`,
    "sortable": `\u{53EF}\u{6392}\u{5E8F}\u{7684}\u{6B04}`
};

},{}],"a21Ot":[function(require,module,exports) {
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TableKeyboardDelegate", ()=>TableKeyboardDelegate);
var _collections = require("@react-stately/collections");
var _grid = require("@react-aria/grid");
class TableKeyboardDelegate extends (0, _grid.GridKeyboardDelegate) {
    isCell(node) {
        return node.type === "cell" || node.type === "rowheader" || node.type === "column";
    }
    getKeyBelow(key) {
        let startItem = this.collection.getItem(key);
        if (!startItem) return;
        // If focus was on a column, then focus the first child column if any,
        // or find the corresponding cell in the first row.
        if (startItem.type === "column") {
            let child = (0, _collections.getFirstItem)((0, _collections.getChildNodes)(startItem, this.collection));
            if (child) return child.key;
            let firstKey = this.getFirstKey();
            if (firstKey == null) return;
            let firstItem = this.collection.getItem(firstKey);
            return (0, _collections.getNthItem)((0, _collections.getChildNodes)(firstItem, this.collection), startItem.index).key;
        }
        return super.getKeyBelow(key);
    }
    getKeyAbove(key) {
        let startItem = this.collection.getItem(key);
        if (!startItem) return;
        // If focus was on a column, focus the parent column if any
        if (startItem.type === "column") {
            let parent = this.collection.getItem(startItem.parentKey);
            if (parent && parent.type === "column") return parent.key;
            return;
        }
        // only return above row key if not header row
        let superKey = super.getKeyAbove(key);
        if (superKey != null && this.collection.getItem(superKey).type !== "headerrow") return superKey;
        // If no item was found, and focus was on a cell, then focus the
        // corresponding column header.
        if (this.isCell(startItem)) return this.collection.columns[startItem.index].key;
        // If focus was on a row, then focus the first column header.
        return this.collection.columns[0].key;
    }
    findNextColumnKey(column) {
        // Search following columns
        let key = this.findNextKey(column.key, (item)=>item.type === "column");
        if (key != null) return key;
        // Wrap around to the first column
        let row = this.collection.headerRows[column.level];
        for (let item of (0, _collections.getChildNodes)(row, this.collection)){
            if (item.type === "column") return item.key;
        }
    }
    findPreviousColumnKey(column) {
        // Search previous columns
        let key = this.findPreviousKey(column.key, (item)=>item.type === "column");
        if (key != null) return key;
        // Wrap around to the last column
        let row = this.collection.headerRows[column.level];
        let childNodes = [
            ...(0, _collections.getChildNodes)(row, this.collection)
        ];
        for(let i = childNodes.length - 1; i >= 0; i--){
            let item = childNodes[i];
            if (item.type === "column") return item.key;
        }
    }
    getKeyRightOf(key) {
        let item = this.collection.getItem(key);
        if (!item) return;
        // If focus was on a column, then focus the next column
        if (item.type === "column") return this.direction === "rtl" ? this.findPreviousColumnKey(item) : this.findNextColumnKey(item);
        return super.getKeyRightOf(key);
    }
    getKeyLeftOf(key) {
        let item = this.collection.getItem(key);
        if (!item) return;
        // If focus was on a column, then focus the previous column
        if (item.type === "column") return this.direction === "rtl" ? this.findNextColumnKey(item) : this.findPreviousColumnKey(item);
        return super.getKeyLeftOf(key);
    }
    getKeyForSearch(search, fromKey) {
        if (!this.collator) return null;
        let collection = this.collection;
        let key = fromKey !== null && fromKey !== void 0 ? fromKey : this.getFirstKey();
        if (key == null) return null;
        // If the starting key is a cell, search from its parent row.
        let startItem = collection.getItem(key);
        if (startItem.type === "cell") key = startItem.parentKey;
        let hasWrapped = false;
        while(key != null){
            let item = collection.getItem(key);
            // Check each of the row header cells in this row for a match
            for (let cell of (0, _collections.getChildNodes)(item, this.collection)){
                let column = collection.columns[cell.index];
                if (collection.rowHeaderColumnKeys.has(column.key) && cell.textValue) {
                    let substring = cell.textValue.slice(0, search.length);
                    if (this.collator.compare(substring, search) === 0) {
                        // If we started on a cell, end on the matching cell. Otherwise, end on the row.
                        let fromItem = fromKey != null ? collection.getItem(fromKey) : startItem;
                        return fromItem.type === "cell" ? cell.key : item.key;
                    }
                }
            }
            key = this.getKeyBelow(key);
            // Wrap around when reaching the end of the collection
            if (key == null && !hasWrapped) {
                key = this.getFirstKey();
                hasWrapped = true;
            }
        }
        return null;
    }
}

},{"@react-stately/collections":"loANi","@react-aria/grid":"6tGaN","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"aEc5X":[function(require,module,exports) {
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "enableTableNestedRows", ()=>enableTableNestedRows);
parcelHelpers.export(exports, "tableNestedRows", ()=>tableNestedRows);
let _tableNestedRows = false;
function enableTableNestedRows() {
    _tableNestedRows = true;
}
function tableNestedRows() {
    return _tableNestedRows;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"2H9rY":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides the behavior and accessibility implementation for a column header in a table.
 * @param props - Props for the column header.
 * @param state - State of the table, as returned by `useTableState`.
 * @param ref - The ref attached to the column header element.
 */ parcelHelpers.export(exports, "useTableColumnHeader", ()=>useTableColumnHeader);
var _utils = require("./utils");
// @ts-ignore
var _json = require("../intl/*.json");
var _jsonDefault = parcelHelpers.interopDefault(_json);
var _utils1 = require("@react-aria/utils");
var _react = require("react");
var _focus = require("@react-aria/focus");
var _grid = require("@react-aria/grid");
var _i18N = require("@react-aria/i18n");
var _interactions = require("@react-aria/interactions");
function useTableColumnHeader(props, state, ref) {
    var _state_sortDescriptor, _state_sortDescriptor1;
    let { node } = props;
    let allowsSorting = node.props.allowsSorting;
    // if there are no focusable children, the column header will focus the cell
    let { gridCellProps } = (0, _grid.useGridCell)({
        ...props,
        focusMode: "child"
    }, state, ref);
    let isSelectionCellDisabled = node.props.isSelectionCell && state.selectionManager.selectionMode === "single";
    let { pressProps } = (0, _interactions.usePress)({
        isDisabled: !allowsSorting || isSelectionCellDisabled,
        onPress () {
            state.sort(node.key);
        },
        ref
    });
    // Needed to pick up the focusable context, enabling things like Tooltips for example
    let { focusableProps } = (0, _focus.useFocusable)({}, ref);
    let ariaSort = null;
    let isSortedColumn = ((_state_sortDescriptor = state.sortDescriptor) === null || _state_sortDescriptor === void 0 ? void 0 : _state_sortDescriptor.column) === node.key;
    let sortDirection = (_state_sortDescriptor1 = state.sortDescriptor) === null || _state_sortDescriptor1 === void 0 ? void 0 : _state_sortDescriptor1.direction;
    // aria-sort not supported in Android Talkback
    if (node.props.allowsSorting && !(0, _utils1.isAndroid)()) ariaSort = isSortedColumn ? sortDirection : "none";
    let stringFormatter = (0, _i18N.useLocalizedStringFormatter)((0, _jsonDefault.default), "@react-aria/table");
    let sortDescription;
    if (allowsSorting) {
        sortDescription = `${stringFormatter.format("sortable")}`;
        // Android Talkback doesn't support aria-sort so we add sort order details to the aria-described by here
        if (isSortedColumn && sortDirection && (0, _utils1.isAndroid)()) sortDescription = `${sortDescription}, ${stringFormatter.format(sortDirection)}`;
    }
    let descriptionProps = (0, _utils1.useDescription)(sortDescription);
    let shouldDisableFocus = state.collection.size === 0;
    (0, _react.useEffect)(()=>{
        if (shouldDisableFocus && state.selectionManager.focusedKey === node.key) state.selectionManager.setFocusedKey(null);
    }, [
        shouldDisableFocus,
        state.selectionManager,
        node.key
    ]);
    return {
        columnHeaderProps: {
            ...(0, _utils1.mergeProps)(gridCellProps, pressProps, focusableProps, descriptionProps, // If the table is empty, make all column headers untabbable
            shouldDisableFocus && {
                tabIndex: -1
            }),
            role: "columnheader",
            id: (0, _utils.getColumnHeaderId)(state, node.key),
            "aria-colspan": node.colspan && node.colspan > 1 ? node.colspan : null,
            "aria-sort": ariaSort
        }
    };
}

},{"./utils":"bxsPM","../intl/*.json":"9fot9","@react-aria/utils":"9cLk5","react":"9yzVZ","@react-aria/focus":"42mbF","@react-aria/grid":"6tGaN","@react-aria/i18n":"411rg","@react-aria/interactions":"ky3G8","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"eJ7g5":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides the behavior and accessibility implementation for a row in a table.
 * @param props - Props for the row.
 * @param state - State of the table, as returned by `useTableState`.
 */ parcelHelpers.export(exports, "useTableRow", ()=>useTableRow);
var _collections = require("@react-stately/collections");
var _utils = require("./utils");
var _utils1 = require("@react-aria/utils");
var _grid = require("@react-aria/grid");
var _flags = require("@react-stately/flags");
var _i18N = require("@react-aria/i18n");
const EXPANSION_KEYS = {
    expand: {
        ltr: "ArrowRight",
        rtl: "ArrowLeft"
    },
    "collapse": {
        ltr: "ArrowLeft",
        rtl: "ArrowRight"
    }
};
function useTableRow(props, state, ref) {
    let { node, isVirtualized } = props;
    let { rowProps, ...states } = (0, _grid.useGridRow)(props, state, ref);
    let { direction } = (0, _i18N.useLocale)();
    if (isVirtualized && !((0, _flags.tableNestedRows)() && "expandedKeys" in state)) rowProps["aria-rowindex"] = node.index + 1 + state.collection.headerRows.length; // aria-rowindex is 1 based
    else delete rowProps["aria-rowindex"];
    let treeGridRowProps = {};
    if ((0, _flags.tableNestedRows)() && "expandedKeys" in state) {
        let treeNode = state.keyMap.get(node.key);
        if (treeNode != null) {
            var _treeNode_props, _treeNode_props_children, _treeNode_props1;
            let hasChildRows = ((_treeNode_props = treeNode.props) === null || _treeNode_props === void 0 ? void 0 : _treeNode_props.UNSTABLE_childItems) || ((_treeNode_props1 = treeNode.props) === null || _treeNode_props1 === void 0 ? void 0 : (_treeNode_props_children = _treeNode_props1.children) === null || _treeNode_props_children === void 0 ? void 0 : _treeNode_props_children.length) > state.userColumnCount;
            treeGridRowProps = {
                onKeyDown: (e)=>{
                    if (e.key === EXPANSION_KEYS["expand"][direction] && state.selectionManager.focusedKey === treeNode.key && hasChildRows && state.expandedKeys !== "all" && !state.expandedKeys.has(treeNode.key)) {
                        state.toggleKey(treeNode.key);
                        e.stopPropagation();
                    } else if (e.key === EXPANSION_KEYS["collapse"][direction] && state.selectionManager.focusedKey === treeNode.key && hasChildRows && (state.expandedKeys === "all" || state.expandedKeys.has(treeNode.key))) {
                        state.toggleKey(treeNode.key);
                        e.stopPropagation();
                    }
                },
                "aria-expanded": hasChildRows ? state.expandedKeys === "all" || state.expandedKeys.has(node.key) : undefined,
                "aria-level": treeNode.level,
                "aria-posinset": treeNode.indexOfType + 1,
                "aria-setsize": treeNode.level > 1 ? (0, _collections.getLastItem)(state.keyMap.get(treeNode === null || treeNode === void 0 ? void 0 : treeNode.parentKey).childNodes).indexOfType + 1 : (0, _collections.getLastItem)(state.keyMap.get(state.collection.body.key).childNodes).indexOfType + 1
            };
        }
    }
    let linkProps = states.hasAction ? (0, _utils1.getSyntheticLinkProps)(node.props) : {};
    return {
        rowProps: {
            ...(0, _utils1.mergeProps)(rowProps, treeGridRowProps, linkProps),
            "aria-labelledby": (0, _utils.getRowLabelledBy)(state, node.key)
        },
        ...states
    };
}

},{"@react-stately/collections":"loANi","./utils":"bxsPM","@react-aria/utils":"9cLk5","@react-aria/grid":"6tGaN","@react-stately/flags":"aEc5X","@react-aria/i18n":"411rg","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"e59Fw":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides the behavior and accessibility implementation for a header row in a table.
 * @param props - Props for the row.
 * @param state - State of the table, as returned by `useTableState`.
 */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
parcelHelpers.export(exports, "useTableHeaderRow", ()=>useTableHeaderRow);
var _flags = require("@react-stately/flags");
function useTableHeaderRow(props, state, ref) {
    let { node, isVirtualized } = props;
    let rowProps = {
        role: "row"
    };
    if (isVirtualized && !((0, _flags.tableNestedRows)() && "expandedKeys" in state)) rowProps["aria-rowindex"] = node.index + 1; // aria-rowindex is 1 based
    return {
        rowProps
    };
}

},{"@react-stately/flags":"aEc5X","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"eoGY0":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides the behavior and accessibility implementation for a cell in a table.
 * @param props - Props for the cell.
 * @param state - State of the table, as returned by `useTableState`.
 * @param ref - The ref attached to the cell element.
 */ parcelHelpers.export(exports, "useTableCell", ()=>useTableCell);
var _utils = require("./utils");
var _grid = require("@react-aria/grid");
function useTableCell(props, state, ref) {
    let { gridCellProps, isPressed } = (0, _grid.useGridCell)(props, state, ref);
    let columnKey = props.node.column.key;
    if (state.collection.rowHeaderColumnKeys.has(columnKey)) {
        gridCellProps.role = "rowheader";
        gridCellProps.id = (0, _utils.getCellId)(state, props.node.parentKey, columnKey);
    }
    return {
        gridCellProps,
        isPressed
    };
}

},{"./utils":"bxsPM","@react-aria/grid":"6tGaN","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"iI6o5":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides the behavior and accessibility implementation for a selection checkbox in a table.
 * @param props - Props for the selection checkbox.
 * @param state - State of the table, as returned by `useTableState`.
 */ parcelHelpers.export(exports, "useTableSelectionCheckbox", ()=>useTableSelectionCheckbox);
/**
 * Provides the behavior and accessibility implementation for the select all checkbox in a table.
 * @param props - Props for the select all checkbox.
 * @param state - State of the table, as returned by `useTableState`.
 */ parcelHelpers.export(exports, "useTableSelectAllCheckbox", ()=>useTableSelectAllCheckbox);
var _utils = require("./utils");
// @ts-ignore
var _json = require("../intl/*.json");
var _jsonDefault = parcelHelpers.interopDefault(_json);
var _grid = require("@react-aria/grid");
var _i18N = require("@react-aria/i18n");
function useTableSelectionCheckbox(props, state) {
    let { key } = props;
    const { checkboxProps } = (0, _grid.useGridSelectionCheckbox)(props, state);
    return {
        checkboxProps: {
            ...checkboxProps,
            "aria-labelledby": `${checkboxProps.id} ${(0, _utils.getRowLabelledBy)(state, key)}`
        }
    };
}
function useTableSelectAllCheckbox(state) {
    let { isEmpty, isSelectAll, selectionMode } = state.selectionManager;
    const stringFormatter = (0, _i18N.useLocalizedStringFormatter)((0, _jsonDefault.default), "@react-aria/table");
    return {
        checkboxProps: {
            "aria-label": stringFormatter.format(selectionMode === "single" ? "select" : "selectAll"),
            isSelected: isSelectAll,
            isDisabled: selectionMode !== "multiple" || state.collection.size === 0,
            isIndeterminate: !isEmpty && !isSelectAll,
            onChange: ()=>state.selectionManager.toggleSelectAll()
        }
    };
}

},{"./utils":"bxsPM","../intl/*.json":"9fot9","@react-aria/grid":"6tGaN","@react-aria/i18n":"411rg","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"41Zet":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides the behavior and accessibility implementation for a table column resizer element.
 * @param props - Props for the resizer.
 * @param state - State for the table's resizable columns, as returned by `useTableColumnResizeState`.
 * @param ref - The ref attached to the resizer's visually hidden input element.
 */ parcelHelpers.export(exports, "useTableColumnResize", ()=>useTableColumnResize);
var _react = require("react");
var _focus = require("@react-aria/focus");
var _utils = require("./utils");
// @ts-ignore
var _json = require("../intl/*.json");
var _jsonDefault = parcelHelpers.interopDefault(_json);
var _utils1 = require("@react-aria/utils");
var _interactions = require("@react-aria/interactions");
var _i18N = require("@react-aria/i18n");
var _visuallyHidden = require("@react-aria/visually-hidden");
function useTableColumnResize(props, state, ref) {
    let { column: item, triggerRef, isDisabled, onResizeStart, onResize, onResizeEnd, "aria-label": ariaLabel } = props;
    const stringFormatter = (0, _i18N.useLocalizedStringFormatter)((0, _jsonDefault.default), "@react-aria/table");
    let id = (0, _utils1.useId)();
    let isResizing = state.resizingColumn === item.key;
    let isResizingRef = (0, _react.useRef)(isResizing);
    let lastSize = (0, _react.useRef)(null);
    let wasFocusedOnResizeStart = (0, _react.useRef)(false);
    let editModeEnabled = state.tableState.isKeyboardNavigationDisabled;
    let { direction } = (0, _i18N.useLocale)();
    let { keyboardProps } = (0, _interactions.useKeyboard)({
        onKeyDown: (e)=>{
            if (editModeEnabled) {
                if (e.key === "Escape" || e.key === "Enter" || e.key === " " || e.key === "Tab") {
                    e.preventDefault();
                    endResize(item);
                }
            } else {
                // Continue propagation on keydown events so they still bubbles to useSelectableCollection and are handled there
                e.continuePropagation();
                if (e.key === "Enter") startResize(item);
            }
        }
    });
    let startResize = (0, _utils1.useEffectEvent)((item)=>{
        if (!isResizingRef.current) {
            lastSize.current = state.updateResizedColumns(item.key, state.getColumnWidth(item.key));
            state.startResize(item.key);
            state.tableState.setKeyboardNavigationDisabled(true);
            onResizeStart === null || onResizeStart === void 0 ? void 0 : onResizeStart(lastSize.current);
        }
        isResizingRef.current = true;
    });
    let resize = (0, _utils1.useEffectEvent)((item, newWidth)=>{
        let sizes = state.updateResizedColumns(item.key, newWidth);
        onResize === null || onResize === void 0 ? void 0 : onResize(sizes);
        lastSize.current = sizes;
    });
    let endResize = (0, _utils1.useEffectEvent)((item)=>{
        if (isResizingRef.current) {
            if (lastSize.current == null) lastSize.current = state.updateResizedColumns(item.key, state.getColumnWidth(item.key));
            state.endResize();
            state.tableState.setKeyboardNavigationDisabled(false);
            onResizeEnd === null || onResizeEnd === void 0 ? void 0 : onResizeEnd(lastSize.current);
            isResizingRef.current = false;
            if ((triggerRef === null || triggerRef === void 0 ? void 0 : triggerRef.current) && !wasFocusedOnResizeStart.current) // switch focus back to the column header unless the resizer was already focused when resizing started.
            (0, _focus.focusSafely)(triggerRef.current);
        }
        lastSize.current = null;
    });
    const columnResizeWidthRef = (0, _react.useRef)(0);
    const { moveProps } = (0, _interactions.useMove)({
        onMoveStart () {
            columnResizeWidthRef.current = state.getColumnWidth(item.key);
            startResize(item);
        },
        onMove (e) {
            let { deltaX, deltaY, pointerType } = e;
            if (direction === "rtl") deltaX *= -1;
            if (pointerType === "keyboard") {
                if (deltaY !== 0 && deltaX === 0) deltaX = deltaY * -1;
                deltaX *= 10;
            }
            // if moving up/down only, no need to resize
            if (deltaX !== 0) {
                columnResizeWidthRef.current += deltaX;
                resize(item, columnResizeWidthRef.current);
            }
        },
        onMoveEnd (e) {
            let { pointerType } = e;
            columnResizeWidthRef.current = 0;
            if (pointerType === "mouse" || pointerType === "touch" && wasFocusedOnResizeStart.current) endResize(item);
        }
    });
    let onKeyDown = (0, _react.useCallback)((e)=>{
        if (editModeEnabled) moveProps.onKeyDown(e);
    }, [
        editModeEnabled,
        moveProps
    ]);
    let min = Math.floor(state.getColumnMinWidth(item.key));
    let max = Math.floor(state.getColumnMaxWidth(item.key));
    if (max === Infinity) max = Number.MAX_SAFE_INTEGER;
    let value = Math.floor(state.getColumnWidth(item.key));
    let modality = (0, _interactions.useInteractionModality)();
    if (modality === "virtual" && typeof window !== "undefined" && "ontouchstart" in window) modality = "touch";
    let description = (triggerRef === null || triggerRef === void 0 ? void 0 : triggerRef.current) == null && (modality === "keyboard" || modality === "virtual") && !isResizing ? stringFormatter.format("resizerDescription") : undefined;
    let descriptionProps = (0, _utils1.useDescription)(description);
    let ariaProps = {
        "aria-label": ariaLabel,
        "aria-orientation": "horizontal",
        "aria-labelledby": `${id} ${(0, _utils.getColumnHeaderId)(state.tableState, item.key)}`,
        "aria-valuetext": stringFormatter.format("columnSize", {
            value
        }),
        "type": "range",
        min,
        max,
        value,
        ...descriptionProps
    };
    const focusInput = (0, _react.useCallback)(()=>{
        if (ref.current) (0, _focus.focusSafely)(ref.current);
    }, [
        ref
    ]);
    let resizingColumn = state.resizingColumn;
    let prevResizingColumn = (0, _react.useRef)(null);
    (0, _react.useEffect)(()=>{
        if (prevResizingColumn.current !== resizingColumn && resizingColumn != null && resizingColumn === item.key) {
            wasFocusedOnResizeStart.current = document.activeElement === ref.current;
            startResize(item);
            // Delay focusing input until Android Chrome's delayed click after touchend happens: https://bugs.chromium.org/p/chromium/issues/detail?id=1150073
            let timeout = setTimeout(()=>focusInput(), 0);
            // VoiceOver on iOS has problems focusing the input from a menu.
            let VOTimeout = setTimeout(focusInput, 400);
            return ()=>{
                clearTimeout(timeout);
                clearTimeout(VOTimeout);
            };
        }
        prevResizingColumn.current = resizingColumn;
    }, [
        resizingColumn,
        item,
        focusInput,
        ref,
        startResize
    ]);
    let onChange = (e)=>{
        let currentWidth = state.getColumnWidth(item.key);
        let nextValue = parseFloat(e.target.value);
        if (nextValue > currentWidth) nextValue = currentWidth + 10;
        else nextValue = currentWidth - 10;
        resize(item, nextValue);
    };
    let { pressProps } = (0, _interactions.usePress)({
        onPressStart: (e)=>{
            if (e.ctrlKey || e.altKey || e.metaKey || e.shiftKey || e.pointerType === "keyboard") return;
            if (e.pointerType === "virtual" && state.resizingColumn != null) {
                endResize(item);
                return;
            }
            // Sometimes onPress won't trigger for quick taps on mobile so we want to focus the input so blurring away
            // can cancel resize mode for us.
            focusInput();
            // If resizer is always visible, mobile screenreader user can access the visually hidden resizer directly and thus we don't need
            // to handle a virtual click to start the resizer.
            if (e.pointerType !== "virtual") startResize(item);
        },
        onPress: (e)=>{
            if ((e.pointerType === "touch" && wasFocusedOnResizeStart.current || e.pointerType === "mouse") && state.resizingColumn != null) endResize(item);
        }
    });
    let { visuallyHiddenProps } = (0, _visuallyHidden.useVisuallyHidden)();
    return {
        resizerProps: (0, _utils1.mergeProps)(keyboardProps, {
            ...moveProps,
            onKeyDown
        }, pressProps, {
            style: {
                touchAction: "none"
            }
        }),
        inputProps: (0, _utils1.mergeProps)(visuallyHiddenProps, {
            id,
            onBlur: ()=>{
                endResize(item);
            },
            onChange,
            disabled: isDisabled
        }, ariaProps),
        isResizing
    };
}

},{"react":"9yzVZ","@react-aria/focus":"42mbF","./utils":"bxsPM","../intl/*.json":"9fot9","@react-aria/utils":"9cLk5","@react-aria/interactions":"ky3G8","@react-aria/i18n":"411rg","@react-aria/visually-hidden":"4jwxT","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"9tXWP":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useTab", ()=>(0, _useTab.useTab));
parcelHelpers.export(exports, "useTabPanel", ()=>(0, _useTabPanel.useTabPanel));
parcelHelpers.export(exports, "useTabList", ()=>(0, _useTabList.useTabList));
var _useTab = require("./useTab");
var _useTabPanel = require("./useTabPanel");
var _useTabList = require("./useTabList");

},{"./useTab":"7N95x","./useTabPanel":"fgsTV","./useTabList":"62Ec3","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"7N95x":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides the behavior and accessibility implementation for a tab.
 * When selected, the associated tab panel is shown.
 */ parcelHelpers.export(exports, "useTab", ()=>useTab);
var _utils = require("@react-aria/utils");
var _utils1 = require("./utils");
var _selection = require("@react-aria/selection");
function useTab(props, state, ref) {
    var _item_props;
    let { key, isDisabled: propsDisabled, shouldSelectOnPressUp } = props;
    let { selectionManager: manager, selectedKey } = state;
    let isSelected = key === selectedKey;
    let isDisabled = propsDisabled || state.isDisabled || state.disabledKeys.has(key);
    let { itemProps, isPressed } = (0, _selection.useSelectableItem)({
        selectionManager: manager,
        key,
        ref,
        isDisabled,
        shouldSelectOnPressUp,
        linkBehavior: "selection"
    });
    let tabId = (0, _utils1.generateId)(state, key, "tab");
    let tabPanelId = (0, _utils1.generateId)(state, key, "tabpanel");
    let { tabIndex } = itemProps;
    let item = state.collection.getItem(key);
    let domProps = (0, _utils.filterDOMProps)(item === null || item === void 0 ? void 0 : item.props, {
        isLink: !!(item === null || item === void 0 ? void 0 : (_item_props = item.props) === null || _item_props === void 0 ? void 0 : _item_props.href),
        labelable: true
    });
    delete domProps.id;
    return {
        tabProps: (0, _utils.mergeProps)(domProps, itemProps, {
            id: tabId,
            "aria-selected": isSelected,
            "aria-disabled": isDisabled || undefined,
            "aria-controls": isSelected ? tabPanelId : undefined,
            tabIndex: isDisabled ? undefined : tabIndex,
            role: "tab"
        }),
        isSelected,
        isDisabled,
        isPressed
    };
}

},{"@react-aria/utils":"9cLk5","./utils":"cSU64","@react-aria/selection":"6Fly5","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"cSU64":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "tabsIds", ()=>tabsIds);
parcelHelpers.export(exports, "generateId", ()=>generateId);
const tabsIds = new WeakMap();
function generateId(state, key, role) {
    if (typeof key === "string") key = key.replace(/\s+/g, "");
    let baseId = tabsIds.get(state);
    return `${baseId}-${role}-${key}`;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"fgsTV":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides the behavior and accessibility implementation for a tab panel. A tab panel is a container for
 * the contents of a tab, and is shown when the tab is selected.
 */ parcelHelpers.export(exports, "useTabPanel", ()=>useTabPanel);
var _utils = require("./utils");
var _utils1 = require("@react-aria/utils");
var _focus = require("@react-aria/focus");
function useTabPanel(props, state, ref) {
    // The tabpanel should have tabIndex=0 when there are no tabbable elements within it.
    // Otherwise, tabbing from the focused tab should go directly to the first tabbable element
    // within the tabpanel.
    let tabIndex = (0, _focus.useHasTabbableChild)(ref) ? undefined : 0;
    var _props_id;
    const id = (0, _utils.generateId)(state, (_props_id = props.id) !== null && _props_id !== void 0 ? _props_id : state === null || state === void 0 ? void 0 : state.selectedKey, "tabpanel");
    const tabPanelProps = (0, _utils1.useLabels)({
        ...props,
        id,
        "aria-labelledby": (0, _utils.generateId)(state, state === null || state === void 0 ? void 0 : state.selectedKey, "tab")
    });
    return {
        tabPanelProps: (0, _utils1.mergeProps)(tabPanelProps, {
            tabIndex,
            role: "tabpanel",
            "aria-describedby": props["aria-describedby"],
            "aria-details": props["aria-details"]
        })
    };
}

},{"./utils":"cSU64","@react-aria/utils":"9cLk5","@react-aria/focus":"42mbF","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"62Ec3":[function(require,module,exports) {
/*
* Copyright 2020 Adobe. All rights reserved.
* This file is licensed to you under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License. You may obtain a copy
* of the License at http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software distributed under
* the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
* OF ANY KIND, either express or implied. See the License for the specific language
* governing permissions and limitations under the License.
*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides the behavior and accessibility implementation for a tab list.
 * Tabs organize content into multiple sections and allow users to navigate between them.
 */ parcelHelpers.export(exports, "useTabList", ()=>useTabList);
var _utils = require("@react-aria/utils");
var _react = require("react");
var _utils1 = require("./utils");
var _tabsKeyboardDelegate = require("./TabsKeyboardDelegate");
var _i18N = require("@react-aria/i18n");
var _selection = require("@react-aria/selection");
function useTabList(props, state, ref) {
    let { orientation = "horizontal", keyboardActivation = "automatic" } = props;
    let { collection, selectionManager: manager, disabledKeys } = state;
    let { direction } = (0, _i18N.useLocale)();
    let delegate = (0, _react.useMemo)(()=>new (0, _tabsKeyboardDelegate.TabsKeyboardDelegate)(collection, direction, orientation, disabledKeys), [
        collection,
        disabledKeys,
        orientation,
        direction
    ]);
    let { collectionProps } = (0, _selection.useSelectableCollection)({
        ref,
        selectionManager: manager,
        keyboardDelegate: delegate,
        selectOnFocus: keyboardActivation === "automatic",
        disallowEmptySelection: true,
        scrollRef: ref,
        linkBehavior: "selection"
    });
    // Compute base id for all tabs
    let tabsId = (0, _utils.useId)();
    (0, _utils1.tabsIds).set(state, tabsId);
    let tabListLabelProps = (0, _utils.useLabels)({
        ...props,
        id: tabsId
    });
    return {
        tabListProps: {
            ...(0, _utils.mergeProps)(collectionProps, tabListLabelProps),
            role: "tablist",
            "aria-orientation": orientation,
            tabIndex: undefined
        }
    };
}

},{"@react-aria/utils":"9cLk5","react":"9yzVZ","./utils":"cSU64","./TabsKeyboardDelegate":"2vW02","@react-aria/i18n":"411rg","@react-aria/selection":"6Fly5","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"2vW02":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TabsKeyboardDelegate", ()=>TabsKeyboardDelegate);
class TabsKeyboardDelegate {
    getKeyLeftOf(key) {
        if (this.flipDirection) return this.getNextKey(key);
        return this.getPreviousKey(key);
    }
    getKeyRightOf(key) {
        if (this.flipDirection) return this.getPreviousKey(key);
        return this.getNextKey(key);
    }
    getKeyAbove(key) {
        return this.getPreviousKey(key);
    }
    getKeyBelow(key) {
        return this.getNextKey(key);
    }
    getFirstKey() {
        let key = this.collection.getFirstKey();
        if (key != null && this.disabledKeys.has(key)) key = this.getNextKey(key);
        return key;
    }
    getLastKey() {
        let key = this.collection.getLastKey();
        if (key != null && this.disabledKeys.has(key)) key = this.getPreviousKey(key);
        return key;
    }
    getNextKey(key) {
        do {
            key = this.collection.getKeyAfter(key);
            if (key == null) key = this.collection.getFirstKey();
        }while (this.disabledKeys.has(key));
        return key;
    }
    getPreviousKey(key) {
        do {
            key = this.collection.getKeyBefore(key);
            if (key == null) key = this.collection.getLastKey();
        }while (this.disabledKeys.has(key));
        return key;
    }
    constructor(collection, direction, orientation, disabledKeys = new Set()){
        this.collection = collection;
        this.flipDirection = direction === "rtl" && orientation === "horizontal";
        this.disabledKeys = disabledKeys;
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"bGZEL":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useTag", ()=>(0, _useTag.useTag));
parcelHelpers.export(exports, "useTagGroup", ()=>(0, _useTagGroup.useTagGroup));
var _useTag = require("./useTag");
var _useTagGroup = require("./useTagGroup");

},{"./useTag":"fIHLW","./useTagGroup":"js2pD","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"fIHLW":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides the behavior and accessibility implementation for a tag component.
 * @param props - Props to be applied to the tag.
 * @param state - State for the tag group, as returned by `useListState`.
 * @param ref - A ref to a DOM element for the tag.
 */ parcelHelpers.export(exports, "useTag", ()=>useTag);
var _utils = require("@react-aria/utils");
var _useTagGroup = require("./useTagGroup");
// @ts-ignore
var _json = require("../intl/*.json");
var _jsonDefault = parcelHelpers.interopDefault(_json);
var _gridlist = require("@react-aria/gridlist");
var _interactions = require("@react-aria/interactions");
var _i18N = require("@react-aria/i18n");
function useTag(props, state, ref) {
    let { item } = props;
    let stringFormatter = (0, _i18N.useLocalizedStringFormatter)((0, _jsonDefault.default), "@react-aria/tag");
    let buttonId = (0, _utils.useId)();
    let { onRemove } = (0, _useTagGroup.hookData).get(state) || {};
    let { rowProps, gridCellProps, ...states } = (0, _gridlist.useGridListItem)({
        node: item
    }, state, ref);
    // We want the group to handle keyboard navigation between tags.
    delete rowProps.onKeyDownCapture;
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    let { descriptionProps: _, ...stateWithoutDescription } = states;
    let onKeyDown = (e)=>{
        if (e.key === "Delete" || e.key === "Backspace") {
            e.preventDefault();
            if (state.selectionManager.isSelected(item.key)) onRemove === null || onRemove === void 0 ? void 0 : onRemove(new Set(state.selectionManager.selectedKeys));
            else onRemove === null || onRemove === void 0 ? void 0 : onRemove(new Set([
                item.key
            ]));
        }
    };
    let modality = (0, _interactions.useInteractionModality)();
    if (modality === "virtual" && typeof window !== "undefined" && "ontouchstart" in window) modality = "pointer";
    let description = onRemove && (modality === "keyboard" || modality === "virtual") ? stringFormatter.format("removeDescription") : "";
    let descProps = (0, _utils.useDescription)(description);
    let isFocused = item.key === state.selectionManager.focusedKey;
    // @ts-ignore - data attributes are ok but TS doesn't know about them.
    let domProps = (0, _utils.filterDOMProps)(item.props);
    let linkProps = (0, _utils.getSyntheticLinkProps)(item.props);
    return {
        removeButtonProps: {
            "aria-label": stringFormatter.format("removeButtonLabel"),
            "aria-labelledby": `${buttonId} ${rowProps.id}`,
            id: buttonId,
            onPress: ()=>onRemove ? onRemove(new Set([
                    item.key
                ])) : null,
            excludeFromTabOrder: true
        },
        rowProps: (0, _utils.mergeProps)(rowProps, domProps, linkProps, {
            tabIndex: isFocused || state.selectionManager.focusedKey == null ? 0 : -1,
            onKeyDown: onRemove ? onKeyDown : undefined,
            "aria-describedby": descProps["aria-describedby"]
        }),
        gridCellProps: (0, _utils.mergeProps)(gridCellProps, {
            "aria-errormessage": props["aria-errormessage"],
            "aria-label": props["aria-label"]
        }),
        ...stateWithoutDescription,
        allowsRemoving: !!onRemove
    };
}

},{"@react-aria/utils":"9cLk5","./useTagGroup":"js2pD","../intl/*.json":"lzfnL","@react-aria/gridlist":"g9vQF","@react-aria/interactions":"ky3G8","@react-aria/i18n":"411rg","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"js2pD":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hookData", ()=>hookData);
/**
 * Provides the behavior and accessibility implementation for a tag group component.
 * A tag group is a focusable list of labels, categories, keywords, filters, or other items, with support for keyboard navigation, selection, and removal.
 * @param props - Props to be applied to the tag group.
 * @param state - State for the tag group, as returned by `useListState`.
 * @param ref - A ref to a DOM element for the tag group.
 */ parcelHelpers.export(exports, "useTagGroup", ()=>useTagGroup);
var _utils = require("@react-aria/utils");
var _selection = require("@react-aria/selection");
var _react = require("react");
var _label = require("@react-aria/label");
var _interactions = require("@react-aria/interactions");
var _gridlist = require("@react-aria/gridlist");
var _i18N = require("@react-aria/i18n");
const hookData = new WeakMap();
function useTagGroup(props, state, ref) {
    let { direction } = (0, _i18N.useLocale)();
    let keyboardDelegate = props.keyboardDelegate || new (0, _selection.ListKeyboardDelegate)({
        collection: state.collection,
        ref,
        orientation: "horizontal",
        direction,
        disabledKeys: state.disabledKeys
    });
    let { labelProps, fieldProps, descriptionProps, errorMessageProps } = (0, _label.useField)({
        ...props,
        labelElementType: "span"
    });
    let { gridProps } = (0, _gridlist.useGridList)({
        ...props,
        ...fieldProps,
        keyboardDelegate,
        shouldFocusWrap: true,
        linkBehavior: "override"
    }, state, ref);
    let [isFocusWithin, setFocusWithin] = (0, _react.useState)(false);
    let { focusWithinProps } = (0, _interactions.useFocusWithin)({
        onFocusWithinChange: setFocusWithin
    });
    let domProps = (0, _utils.filterDOMProps)(props);
    // If the last tag is removed, focus the container.
    let prevCount = (0, _react.useRef)(state.collection.size);
    (0, _react.useEffect)(()=>{
        if (ref.current && prevCount.current > 0 && state.collection.size === 0 && isFocusWithin) ref.current.focus();
        prevCount.current = state.collection.size;
    }, [
        state.collection.size,
        isFocusWithin,
        ref
    ]);
    hookData.set(state, {
        onRemove: props.onRemove
    });
    return {
        gridProps: (0, _utils.mergeProps)(gridProps, domProps, {
            role: state.collection.size ? "grid" : null,
            "aria-atomic": false,
            "aria-relevant": "additions",
            "aria-live": isFocusWithin ? "polite" : "off",
            ...focusWithinProps,
            ...fieldProps
        }),
        labelProps,
        descriptionProps,
        errorMessageProps
    };
}

},{"@react-aria/utils":"9cLk5","@react-aria/selection":"6Fly5","react":"9yzVZ","@react-aria/label":"74Ccz","@react-aria/interactions":"ky3G8","@react-aria/gridlist":"g9vQF","@react-aria/i18n":"411rg","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"lzfnL":[function(require,module,exports) {
const _temp0 = require("77a83ec7177562b0");
const _temp1 = require("a71334af04532c88");
const _temp2 = require("b58d6cdda251c3aa");
const _temp3 = require("5abe1fadd4060c75");
const _temp4 = require("d5e4b77bf8cbf1b6");
const _temp5 = require("af6c58bc4aa913a7");
const _temp6 = require("f80071ea6ea9b226");
const _temp7 = require("a07ea0970aff3a28");
const _temp8 = require("305f2330ff46db49");
const _temp9 = require("e2bb2af9b2caa9a7");
const _temp10 = require("96ef4cba68bc2904");
const _temp11 = require("4cfafc72815c42c7");
const _temp12 = require("162b3f6584de7098");
const _temp13 = require("c16a949c07d271bf");
const _temp14 = require("7264e6c6b58c6f21");
const _temp15 = require("cd4e4729b11ebb98");
const _temp16 = require("61c79efe9ef30034");
const _temp17 = require("8c93ae690903e0b7");
const _temp18 = require("9c868c06e19de608");
const _temp19 = require("6555bd162f92c26f");
const _temp20 = require("30a2cd82951abbdc");
const _temp21 = require("2c04b3171a74140f");
const _temp22 = require("78e0def959249052");
const _temp23 = require("de2f5a02362a9049");
const _temp24 = require("72d81f83b00a9fd4");
const _temp25 = require("72d103700fc3184c");
const _temp26 = require("570d9478465ab8ce");
const _temp27 = require("3817966d0f2826e1");
const _temp28 = require("18e95e32239fe4fb");
const _temp29 = require("3d146bae1547c210");
const _temp30 = require("39cf7bc86310651e");
const _temp31 = require("d670b4eaed1fdcb5");
const _temp32 = require("1dbec834c0dadd87");
const _temp33 = require("1cf998e47847bd6b");
module.exports = {
    "ar-AE": _temp0,
    "bg-BG": _temp1,
    "cs-CZ": _temp2,
    "da-DK": _temp3,
    "de-DE": _temp4,
    "el-GR": _temp5,
    "en-US": _temp6,
    "es-ES": _temp7,
    "et-EE": _temp8,
    "fi-FI": _temp9,
    "fr-FR": _temp10,
    "he-IL": _temp11,
    "hr-HR": _temp12,
    "hu-HU": _temp13,
    "it-IT": _temp14,
    "ja-JP": _temp15,
    "ko-KR": _temp16,
    "lt-LT": _temp17,
    "lv-LV": _temp18,
    "nb-NO": _temp19,
    "nl-NL": _temp20,
    "pl-PL": _temp21,
    "pt-BR": _temp22,
    "pt-PT": _temp23,
    "ro-RO": _temp24,
    "ru-RU": _temp25,
    "sk-SK": _temp26,
    "sl-SI": _temp27,
    "sr-SP": _temp28,
    "sv-SE": _temp29,
    "tr-TR": _temp30,
    "uk-UA": _temp31,
    "zh-CN": _temp32,
    "zh-TW": _temp33
};

},{"77a83ec7177562b0":"6sm5e","a71334af04532c88":"fYLCX","b58d6cdda251c3aa":"9Fhkb","5abe1fadd4060c75":"kqIlb","d5e4b77bf8cbf1b6":"lawZc","af6c58bc4aa913a7":"aqDB1","f80071ea6ea9b226":"50SyH","a07ea0970aff3a28":"liONh","305f2330ff46db49":"5v9AO","e2bb2af9b2caa9a7":"dvV6d","96ef4cba68bc2904":"hamza","4cfafc72815c42c7":"2UqD8","162b3f6584de7098":"1TOWw","c16a949c07d271bf":"iO0q9","7264e6c6b58c6f21":"gRvvT","cd4e4729b11ebb98":"aIxec","61c79efe9ef30034":"XbpVN","8c93ae690903e0b7":"iMg66","9c868c06e19de608":"e56Ii","6555bd162f92c26f":"iw0TW","30a2cd82951abbdc":"1ZEUm","2c04b3171a74140f":"b30v7","78e0def959249052":"5HrOY","de2f5a02362a9049":"cxI4m","72d81f83b00a9fd4":"fnQpz","72d103700fc3184c":"lAWsj","570d9478465ab8ce":"bJFzD","3817966d0f2826e1":"g3obV","18e95e32239fe4fb":"1xcv6","3d146bae1547c210":"hLM4F","39cf7bc86310651e":"aPhh6","d670b4eaed1fdcb5":"9EXCj","1dbec834c0dadd87":"luR7s","1cf998e47847bd6b":"e61JJ"}],"6sm5e":[function(require,module,exports) {
module.exports = {
    "removeButtonLabel": `\u{625}\u{632}\u{627}\u{644}\u{629}`,
    "removeDescription": `\u{627}\u{636}\u{63A}\u{637} \u{639}\u{644}\u{649} \u{645}\u{641}\u{62A}\u{627}\u{62D} DELETE \u{644}\u{625}\u{632}\u{627}\u{644}\u{629} \u{639}\u{644}\u{627}\u{645}\u{629}.`
};

},{}],"fYLCX":[function(require,module,exports) {
module.exports = {
    "removeButtonLabel": `\u{41F}\u{440}\u{435}\u{43C}\u{430}\u{445}\u{432}\u{430}\u{43D}\u{435}`,
    "removeDescription": `\u{41D}\u{430}\u{442}\u{438}\u{441}\u{43D}\u{435}\u{442}\u{435} Delete, \u{437}\u{430} \u{434}\u{430} \u{43F}\u{440}\u{435}\u{43C}\u{430}\u{445}\u{43D}\u{435}\u{442}\u{435} \u{43C}\u{430}\u{440}\u{43A}\u{435}\u{440}\u{430}.`
};

},{}],"9Fhkb":[function(require,module,exports) {
module.exports = {
    "removeButtonLabel": `Odebrat`,
    "removeDescription": `Stisknut\xedm kl\xe1vesy Delete odeberete zna\u{10D}ku.`
};

},{}],"kqIlb":[function(require,module,exports) {
module.exports = {
    "removeButtonLabel": `Fjern`,
    "removeDescription": `Tryk p\xe5 Slet for at fjerne tag.`
};

},{}],"lawZc":[function(require,module,exports) {
module.exports = {
    "removeButtonLabel": `Entfernen`,
    "removeDescription": `Auf \u{201E}L\xf6schen\u{201C} dr\xfccken, um das Tag zu entfernen.`
};

},{}],"aqDB1":[function(require,module,exports) {
module.exports = {
    "removeButtonLabel": `\u{39A}\u{3B1}\u{3C4}\u{3AC}\u{3C1}\u{3B3}\u{3B7}\u{3C3}\u{3B7}`,
    "removeDescription": `\u{3A0}\u{3B1}\u{3C4}\u{3AE}\u{3C3}\u{3C4}\u{3B5} \u{394}\u{3B9}\u{3B1}\u{3B3}\u{3C1}\u{3B1}\u{3C6}\u{3AE} \u{3B3}\u{3B9}\u{3B1} \u{3BD}\u{3B1} \u{3BA}\u{3B1}\u{3C4}\u{3B1}\u{3C1}\u{3B3}\u{3AE}\u{3C3}\u{3B5}\u{3C4}\u{3B5} \u{3C4}\u{3B7}\u{3BD} \u{3B5}\u{3C4}\u{3B9}\u{3BA}\u{3AD}\u{3C4}\u{3B1}.`
};

},{}],"50SyH":[function(require,module,exports) {
module.exports = {
    "removeDescription": `Press Delete to remove tag.`,
    "removeButtonLabel": `Remove`
};

},{}],"liONh":[function(require,module,exports) {
module.exports = {
    "removeButtonLabel": `Quitar`,
    "removeDescription": `Pulse Eliminar para quitar la etiqueta.`
};

},{}],"5v9AO":[function(require,module,exports) {
module.exports = {
    "removeButtonLabel": `Eemalda`,
    "removeDescription": `Sildi eemaldamiseks vajutage kustutusklahvi Delete.`
};

},{}],"dvV6d":[function(require,module,exports) {
module.exports = {
    "removeButtonLabel": `Poista`,
    "removeDescription": `Poista tunniste painamalla Poista-painiketta.`
};

},{}],"hamza":[function(require,module,exports) {
module.exports = {
    "removeButtonLabel": `Supprimer`,
    "removeDescription": `Appuyez sur Supprimer pour supprimer l\u{2019}\xe9tiquette.`
};

},{}],"2UqD8":[function(require,module,exports) {
module.exports = {
    "removeButtonLabel": `\u{5D4}\u{5E1}\u{5E8}`,
    "removeDescription": `\u{5DC}\u{5D7}\u{5E5} \u{5E2}\u{5DC} \u{5DE}\u{5D7}\u{5E7} \u{5DB}\u{5D3}\u{5D9} \u{5DC}\u{5D4}\u{5E1}\u{5D9}\u{5E8} \u{5EA}\u{5D2}.`
};

},{}],"1TOWw":[function(require,module,exports) {
module.exports = {
    "removeButtonLabel": `Ukloni`,
    "removeDescription": `Pritisnite Delete za uklanjanje oznake.`
};

},{}],"iO0q9":[function(require,module,exports) {
module.exports = {
    "removeButtonLabel": `Elt\xe1vol\xedt\xe1s`,
    "removeDescription": `Nyomja meg a Delete billenty\u{171}t a c\xedmke elt\xe1vol\xedt\xe1s\xe1hoz.`
};

},{}],"gRvvT":[function(require,module,exports) {
module.exports = {
    "removeButtonLabel": `Rimuovi`,
    "removeDescription": `Premi Elimina per rimuovere il tag.`
};

},{}],"aIxec":[function(require,module,exports) {
module.exports = {
    "removeButtonLabel": `\u{524A}\u{9664}`,
    "removeDescription": `\u{30BF}\u{30B0}\u{3092}\u{524A}\u{9664}\u{3059}\u{308B}\u{306B}\u{306F}\u{3001}Delete \u{30AD}\u{30FC}\u{3092}\u{62BC}\u{3057}\u{307E}\u{3059}\u{3002}`
};

},{}],"XbpVN":[function(require,module,exports) {
module.exports = {
    "removeButtonLabel": `\u{C81C}\u{AC70}`,
    "removeDescription": `\u{D0DC}\u{ADF8}\u{B97C} \u{C81C}\u{AC70}\u{D558}\u{B824}\u{BA74} Delete \u{D0A4}\u{B97C} \u{B204}\u{B974}\u{C2ED}\u{C2DC}\u{C624}.`
};

},{}],"iMg66":[function(require,module,exports) {
module.exports = {
    "removeButtonLabel": `Pa\u{161}alinti`,
    "removeDescription": `Nor\u{117}dami pa\u{161}alinti \u{17E}ym\u{105}, paspauskite \u{201E}Delete\u{201C} klavi\u{161}\u{105}.`
};

},{}],"e56Ii":[function(require,module,exports) {
module.exports = {
    "removeButtonLabel": `No\u{146}emt`,
    "removeDescription": `Nospiediet Delete [Dz\u{113}st], lai no\u{146}emtu tagu.`
};

},{}],"iw0TW":[function(require,module,exports) {
module.exports = {
    "removeButtonLabel": `Fjern`,
    "removeDescription": `Trykk p\xe5 Slett for \xe5 fjerne taggen.`
};

},{}],"1ZEUm":[function(require,module,exports) {
module.exports = {
    "removeButtonLabel": `Verwijderen`,
    "removeDescription": `Druk op Verwijderen om de tag te verwijderen.`
};

},{}],"b30v7":[function(require,module,exports) {
module.exports = {
    "removeButtonLabel": `Usu\u{144}`,
    "removeDescription": `Naci\u{15B}nij Usu\u{144}, aby usun\u{105}\u{107} znacznik.`
};

},{}],"5HrOY":[function(require,module,exports) {
module.exports = {
    "removeButtonLabel": `Remover`,
    "removeDescription": `Pressione Delete para remover a tag.`
};

},{}],"cxI4m":[function(require,module,exports) {
module.exports = {
    "removeButtonLabel": `Eliminar`,
    "removeDescription": `Prima Delete para eliminar a tag.`
};

},{}],"fnQpz":[function(require,module,exports) {
module.exports = {
    "removeButtonLabel": `\xcendep\u{103}rta\u{163}i`,
    "removeDescription": `Ap\u{103}sa\u{21B}i pe Delete (\u{218}tergere) pentru a elimina eticheta.`
};

},{}],"lAWsj":[function(require,module,exports) {
module.exports = {
    "removeButtonLabel": `\u{423}\u{434}\u{430}\u{43B}\u{438}\u{442}\u{44C}`,
    "removeDescription": `\u{41D}\u{430}\u{436}\u{43C}\u{438}\u{442}\u{435} DELETE, \u{447}\u{442}\u{43E}\u{431}\u{44B} \u{443}\u{434}\u{430}\u{43B}\u{438}\u{442}\u{44C} \u{442}\u{435}\u{433}.`
};

},{}],"bJFzD":[function(require,module,exports) {
module.exports = {
    "removeButtonLabel": `Odstr\xe1ni\u{165}`,
    "removeDescription": `Ak chcete odstr\xe1ni\u{165} zna\u{10D}ku, stla\u{10D}te kl\xe1ves Delete.`
};

},{}],"g3obV":[function(require,module,exports) {
module.exports = {
    "removeButtonLabel": `Odstrani`,
    "removeDescription": `Pritisnite Delete, da odstranite oznako.`
};

},{}],"1xcv6":[function(require,module,exports) {
module.exports = {
    "removeButtonLabel": `Ukloni`,
    "removeDescription": `Pritisnite Obri\u{161}i da biste uklonili oznaku.`
};

},{}],"hLM4F":[function(require,module,exports) {
module.exports = {
    "removeButtonLabel": `Ta bort`,
    "removeDescription": `Tryck p\xe5 Radera f\xf6r att ta bort taggen.`
};

},{}],"aPhh6":[function(require,module,exports) {
module.exports = {
    "removeButtonLabel": `Kald\u{131}r`,
    "removeDescription": `Etiketi kald\u{131}rmak i\xe7in Sil tu\u{15F}una bas\u{131}n.`
};

},{}],"9EXCj":[function(require,module,exports) {
module.exports = {
    "removeButtonLabel": `\u{412}\u{438}\u{43B}\u{443}\u{447}\u{438}\u{442}\u{438}`,
    "removeDescription": `\u{41D}\u{430}\u{442}\u{438}\u{441}\u{43D}\u{456}\u{442}\u{44C} Delete, \u{449}\u{43E}\u{431} \u{432}\u{438}\u{43B}\u{443}\u{447}\u{438}\u{442}\u{438} \u{442}\u{435}\u{433}.`
};

},{}],"luR7s":[function(require,module,exports) {
module.exports = {
    "removeButtonLabel": `\u{5220}\u{9664}`,
    "removeDescription": `\u{6309}\u{4E0B}\u{201C}\u{5220}\u{9664}\u{201D}\u{4EE5}\u{5220}\u{9664}\u{6807}\u{8BB0}\u{3002}`
};

},{}],"e61JJ":[function(require,module,exports) {
module.exports = {
    "removeButtonLabel": `\u{79FB}\u{9664}`,
    "removeDescription": `\u{6309} Delete \u{9375}\u{4EE5}\u{79FB}\u{9664}\u{6A19}\u{8A18}\u{3002}`
};

},{}],"kI5Vx":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useTooltip", ()=>(0, _useTooltip.useTooltip));
parcelHelpers.export(exports, "useTooltipTrigger", ()=>(0, _useTooltipTrigger.useTooltipTrigger));
var _useTooltip = require("./useTooltip");
var _useTooltipTrigger = require("./useTooltipTrigger");

},{"./useTooltip":"88LJX","./useTooltipTrigger":"i5Izy","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"88LJX":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides the accessibility implementation for a Tooltip component.
 */ parcelHelpers.export(exports, "useTooltip", ()=>useTooltip);
var _utils = require("@react-aria/utils");
var _interactions = require("@react-aria/interactions");
function useTooltip(props, state) {
    let domProps = (0, _utils.filterDOMProps)(props, {
        labelable: true
    });
    let { hoverProps } = (0, _interactions.useHover)({
        onHoverStart: ()=>state === null || state === void 0 ? void 0 : state.open(true),
        onHoverEnd: ()=>state === null || state === void 0 ? void 0 : state.close()
    });
    return {
        tooltipProps: (0, _utils.mergeProps)(domProps, hoverProps, {
            role: "tooltip"
        })
    };
}

},{"@react-aria/utils":"9cLk5","@react-aria/interactions":"ky3G8","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"i5Izy":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides the behavior and accessibility implementation for a tooltip trigger, e.g. a button
 * that shows a description when focused or hovered.
 */ parcelHelpers.export(exports, "useTooltipTrigger", ()=>useTooltipTrigger);
var _interactions = require("@react-aria/interactions");
var _utils = require("@react-aria/utils");
var _react = require("react");
var _focus = require("@react-aria/focus");
function useTooltipTrigger(props, state, ref) {
    let { isDisabled, trigger } = props;
    let tooltipId = (0, _utils.useId)();
    let isHovered = (0, _react.useRef)(false);
    let isFocused = (0, _react.useRef)(false);
    let handleShow = ()=>{
        if (isHovered.current || isFocused.current) state.open(isFocused.current);
    };
    let handleHide = (immediate)=>{
        if (!isHovered.current && !isFocused.current) state.close(immediate);
    };
    (0, _react.useEffect)(()=>{
        let onKeyDown = (e)=>{
            if (ref && ref.current) // Escape after clicking something can give it keyboard focus
            // dismiss tooltip on esc key press
            {
                if (e.key === "Escape") {
                    e.stopPropagation();
                    state.close(true);
                }
            }
        };
        if (state.isOpen) {
            document.addEventListener("keydown", onKeyDown, true);
            return ()=>{
                document.removeEventListener("keydown", onKeyDown, true);
            };
        }
    }, [
        ref,
        state
    ]);
    let onHoverStart = ()=>{
        if (trigger === "focus") return;
        // In chrome, if you hover a trigger, then another element obscures it, due to keyboard
        // interactions for example, hover will end. When hover is restored after that element disappears,
        // focus moves on for example, then the tooltip will reopen. We check the modality to know if the hover
        // is the result of moving the mouse.
        if ((0, _interactions.getInteractionModality)() === "pointer") isHovered.current = true;
        else isHovered.current = false;
        handleShow();
    };
    let onHoverEnd = ()=>{
        if (trigger === "focus") return;
        // no matter how the trigger is left, we should close the tooltip
        isFocused.current = false;
        isHovered.current = false;
        handleHide();
    };
    let onPressStart = ()=>{
        // no matter how the trigger is pressed, we should close the tooltip
        isFocused.current = false;
        isHovered.current = false;
        handleHide(true);
    };
    let onFocus = ()=>{
        let isVisible = (0, _interactions.isFocusVisible)();
        if (isVisible) {
            isFocused.current = true;
            handleShow();
        }
    };
    let onBlur = ()=>{
        isFocused.current = false;
        isHovered.current = false;
        handleHide(true);
    };
    let { hoverProps } = (0, _interactions.useHover)({
        isDisabled,
        onHoverStart,
        onHoverEnd
    });
    let { focusableProps } = (0, _focus.useFocusable)({
        isDisabled,
        onFocus,
        onBlur
    }, ref);
    return {
        triggerProps: {
            "aria-describedby": state.isOpen ? tooltipId : undefined,
            ...(0, _utils.mergeProps)(focusableProps, hoverProps, {
                onPointerDown: onPressStart,
                onKeyDown: onPressStart
            })
        },
        tooltipProps: {
            id: tooltipId
        }
    };
}

},{"@react-aria/interactions":"ky3G8","@react-aria/utils":"9cLk5","react":"9yzVZ","@react-aria/focus":"42mbF","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"iyTLn":[function(require,module,exports) {
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DEFAULT_SLOT", ()=>DEFAULT_SLOT);
parcelHelpers.export(exports, "Provider", ()=>Provider);
parcelHelpers.export(exports, "useRenderProps", ()=>useRenderProps);
/**
 * A helper function that accepts a user-provided render prop value (either a static value or a function),
 * and combines it with another value to create a final result.
 */ parcelHelpers.export(exports, "composeRenderProps", ()=>composeRenderProps);
parcelHelpers.export(exports, "useSlottedContext", ()=>useSlottedContext);
parcelHelpers.export(exports, "useContextProps", ()=>useContextProps);
parcelHelpers.export(exports, "useSlot", ()=>useSlot);
parcelHelpers.export(exports, "useEnterAnimation", ()=>useEnterAnimation);
parcelHelpers.export(exports, "useExitAnimation", ()=>useExitAnimation);
parcelHelpers.export(exports, "HiddenContext", ()=>HiddenContext);
parcelHelpers.export(exports, "Hidden", ()=>Hidden);
// Creates a component that forwards its ref and returns null if it is in a <Hidden> subtree.
// Note: this function is handled specially in the documentation generator. If you change it, you'll need to update DocsTransformer as well.
parcelHelpers.export(exports, "createHideableComponent", ()=>createHideableComponent);
/**
 * Filters out `data-*` attributes to keep them from being passed down and duplicated.
 * @param props
 */ parcelHelpers.export(exports, "removeDataAttributes", ()=>removeDataAttributes);
var _utils = require("@react-aria/utils");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactDom = require("react-dom");
var _reactDomDefault = parcelHelpers.interopDefault(_reactDom);
var _reactAria = require("react-aria");
const DEFAULT_SLOT = Symbol("default");
function Provider({ values, children }) {
    for (let [Context, value] of values)// @ts-ignore
    children = /*#__PURE__*/ (0, _reactDefault.default).createElement(Context.Provider, {
        value: value
    }, children);
    return children;
}
function useRenderProps(props) {
    let { className, style, children, defaultClassName, defaultChildren, values } = props;
    return (0, _react.useMemo)(()=>{
        let computedClassName;
        let computedStyle;
        let computedChildren;
        if (typeof className === "function") computedClassName = className(values);
        else computedClassName = className;
        if (typeof style === "function") computedStyle = style(values);
        else computedStyle = style;
        if (typeof children === "function") computedChildren = children(values);
        else if (children == null) computedChildren = defaultChildren;
        else computedChildren = children;
        return {
            className: computedClassName !== null && computedClassName !== void 0 ? computedClassName : defaultClassName,
            style: computedStyle,
            children: computedChildren,
            "data-rac": ""
        };
    }, [
        className,
        style,
        children,
        defaultClassName,
        defaultChildren,
        values
    ]);
}
function composeRenderProps(// https://stackoverflow.com/questions/60898079/typescript-type-t-or-function-t-usage
value, wrap) {
    return (renderProps)=>wrap(typeof value === "function" ? value(renderProps) : value, renderProps);
}
function useSlottedContext(context, slot) {
    let ctx = (0, _react.useContext)(context);
    if (slot === null) // An explicit `null` slot means don't use context.
    return null;
    if (ctx && typeof ctx === "object" && "slots" in ctx && ctx.slots) {
        let availableSlots = new Intl.ListFormat().format(Object.keys(ctx.slots).map((p)=>`"${p}"`));
        if (!slot && !ctx.slots[DEFAULT_SLOT]) throw new Error(`A slot prop is required. Valid slot names are ${availableSlots}.`);
        let slotKey = slot || DEFAULT_SLOT;
        if (!ctx.slots[slotKey]) // @ts-ignore
        throw new Error(`Invalid slot "${slot}". Valid slot names are ${availableSlots}.`);
        return ctx.slots[slotKey];
    }
    // @ts-ignore
    return ctx;
}
function useContextProps(props, ref, context) {
    let ctx = useSlottedContext(context, props.slot) || {};
    // @ts-ignore - TS says "Type 'unique symbol' cannot be used as an index type." but not sure why.
    let { ref: contextRef, ...contextProps } = ctx;
    let mergedRef = (0, _utils.useObjectRef)((0, _react.useMemo)(()=>(0, _utils.mergeRefs)(ref, contextRef), [
        ref,
        contextRef
    ]));
    let mergedProps = (0, _utils.mergeProps)(contextProps, props);
    // mergeProps does not merge `style`. Adding this there might be a breaking change.
    if ("style" in contextProps && contextProps.style && typeof contextProps.style === "object" && "style" in props && props.style && typeof props.style === "object") // @ts-ignore
    mergedProps.style = {
        ...contextProps.style,
        ...props.style
    };
    return [
        mergedProps,
        mergedRef
    ];
}
function useSlot() {
    // Assume we do have the slot in the initial render.
    let [hasSlot, setHasSlot] = (0, _react.useState)(true);
    let hasRun = (0, _react.useRef)(false);
    // A callback ref which will run when the slotted element mounts.
    // This should happen before the useLayoutEffect below.
    let ref = (0, _react.useCallback)((el)=>{
        hasRun.current = true;
        setHasSlot(!!el);
    }, []);
    // If the callback hasn't been called, then reset to false.
    (0, _utils.useLayoutEffect)(()=>{
        if (!hasRun.current) setHasSlot(false);
    }, []);
    return [
        ref,
        hasSlot
    ];
}
function useEnterAnimation(ref, isReady = true) {
    let [isEntering, setEntering] = (0, _react.useState)(true);
    useAnimation(ref, isEntering && isReady, (0, _react.useCallback)(()=>setEntering(false), []));
    return isEntering && isReady;
}
function useExitAnimation(ref, isOpen) {
    // State to trigger a re-render after animation is complete, which causes the element to be removed from the DOM.
    // Ref to track the state we're in, so we don't immediately reset isExiting to true after the animation.
    let [isExiting, setExiting] = (0, _react.useState)(false);
    let [exitState, setExitState] = (0, _react.useState)("idle");
    // If isOpen becomes false, set isExiting to true.
    if (!isOpen && ref.current && exitState === "idle") {
        isExiting = true;
        setExiting(true);
        setExitState("exiting");
    }
    // If we exited, and the element has been removed, reset exit state to idle.
    if (!ref.current && exitState === "exited") setExitState("idle");
    useAnimation(ref, isExiting, (0, _react.useCallback)(()=>{
        setExitState("exited");
        setExiting(false);
    }, []));
    return isExiting;
}
function useAnimation(ref, isActive, onEnd) {
    let prevAnimation = (0, _react.useRef)(null);
    if (isActive && ref.current) // This is ok because we only read it in the layout effect below, immediately after the commit phase.
    // We could move this to another effect that runs every render, but this would be unnecessarily slow.
    // We only need the computed style right before the animation becomes active.
    // eslint-disable-next-line rulesdir/pure-render
    prevAnimation.current = window.getComputedStyle(ref.current).animation;
    (0, _utils.useLayoutEffect)(()=>{
        if (isActive && ref.current) {
            // Make sure there's actually an animation, and it wasn't there before we triggered the update.
            let computedStyle = window.getComputedStyle(ref.current);
            if (computedStyle.animationName && computedStyle.animationName !== "none" && computedStyle.animation !== prevAnimation.current) {
                let onAnimationEnd = (e)=>{
                    if (e.target === ref.current) {
                        element.removeEventListener("animationend", onAnimationEnd);
                        (0, _reactDomDefault.default).flushSync(()=>{
                            onEnd();
                        });
                    }
                };
                let element = ref.current;
                element.addEventListener("animationend", onAnimationEnd);
                return ()=>{
                    element.removeEventListener("animationend", onAnimationEnd);
                };
            } else onEnd();
        }
    }, [
        ref,
        isActive,
        onEnd
    ]);
}
// React doesn't understand the <template> element, which doesn't have children like a normal element.
// It will throw an error during hydration when it expects the firstChild to contain content rendered
// on the server, when in reality, the browser will have placed this inside the `content` document fragment.
// This monkey patches the firstChild property for our special hidden template elements to work around this error.
// See https://github.com/facebook/react/issues/19932
if (typeof HTMLTemplateElement !== "undefined") {
    const getFirstChild = Object.getOwnPropertyDescriptor(Node.prototype, "firstChild").get;
    Object.defineProperty(HTMLTemplateElement.prototype, "firstChild", {
        configurable: true,
        enumerable: true,
        get: function() {
            if (this.dataset.reactAriaHidden) return this.content.firstChild;
            else return getFirstChild.call(this);
        }
    });
}
const HiddenContext = /*#__PURE__*/ (0, _react.createContext)(false);
// Portal to nowhere
const hiddenFragment = typeof DocumentFragment !== "undefined" ? new DocumentFragment() : null;
function Hidden(props) {
    let isHidden = (0, _react.useContext)(HiddenContext);
    let isSSR = (0, _reactAria.useIsSSR)();
    if (isHidden) // Don't hide again if we are already hidden.
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, props.children);
    let children = /*#__PURE__*/ (0, _reactDefault.default).createElement(HiddenContext.Provider, {
        value: true
    }, props.children);
    // In SSR, portals are not supported by React. Instead, render into a <template>
    // element, which the browser will never display to the user. In addition, the
    // content is not part of the DOM tree, so it won't affect ids or other accessibility attributes.
    return isSSR ? /*#__PURE__*/ (0, _reactDefault.default).createElement("template", {
        "data-react-aria-hidden": true
    }, children) : /*#__PURE__*/ (0, _reactDomDefault.default).createPortal(children, hiddenFragment);
}
function createHideableComponent(fn) {
    let Wrapper = (props, ref)=>{
        let isHidden = (0, _react.useContext)(HiddenContext);
        if (isHidden) return null;
        return fn(props, ref);
    };
    // @ts-ignore - for react dev tools
    Wrapper.displayName = fn.displayName || fn.name;
    return (0, _reactDefault.default).forwardRef(Wrapper);
}
function removeDataAttributes(props) {
    const prefix = /^(data-.*)$/;
    let filteredProps = {};
    for(const prop in props)if (!prefix.test(prop)) filteredProps[prop] = props[prop];
    return filteredProps;
}

},{"@react-aria/utils":"9cLk5","react":"9yzVZ","react-dom":"cEvV3","react-aria":"e7jhe","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"insxi":[function(require,module,exports) {
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CalendarContext", ()=>CalendarContext);
parcelHelpers.export(exports, "RangeCalendarContext", ()=>RangeCalendarContext);
parcelHelpers.export(exports, "CalendarStateContext", ()=>CalendarStateContext);
parcelHelpers.export(exports, "RangeCalendarStateContext", ()=>RangeCalendarStateContext);
parcelHelpers.export(exports, "Calendar", ()=>_Calendar);
parcelHelpers.export(exports, "RangeCalendar", ()=>_RangeCalendar);
parcelHelpers.export(exports, "CalendarGrid", ()=>_CalendarGrid);
parcelHelpers.export(exports, "CalendarGridHeader", ()=>CalendarGridHeaderForwardRef);
parcelHelpers.export(exports, "CalendarHeaderCell", ()=>CalendarHeaderCellForwardRef);
parcelHelpers.export(exports, "CalendarGridBody", ()=>CalendarGridBodyForwardRef);
parcelHelpers.export(exports, "CalendarCell", ()=>_CalendarCell);
var _reactAria = require("react-aria");
var _button = require("./Button");
var _date = require("@internationalized/date");
var _reactStately = require("react-stately");
var _utils = require("./utils");
var _utils1 = require("@react-aria/utils");
var _heading = require("./Heading");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _text = require("./Text");
const CalendarContext = /*#__PURE__*/ (0, _react.createContext)({});
const RangeCalendarContext = /*#__PURE__*/ (0, _react.createContext)({});
const CalendarStateContext = /*#__PURE__*/ (0, _react.createContext)(null);
const RangeCalendarStateContext = /*#__PURE__*/ (0, _react.createContext)(null);
function Calendar(props, ref) {
    [props, ref] = (0, _utils.useContextProps)(props, ref, CalendarContext);
    let { locale } = (0, _reactAria.useLocale)();
    let state = (0, _reactStately.useCalendarState)({
        ...props,
        locale,
        createCalendar: (0, _date.createCalendar)
    });
    let { calendarProps, prevButtonProps, nextButtonProps, errorMessageProps, title } = (0, _reactAria.useCalendar)(props, state);
    let renderProps = (0, _utils.useRenderProps)({
        ...props,
        values: {
            state,
            isDisabled: props.isDisabled || false,
            isInvalid: state.isValueInvalid
        },
        defaultClassName: "react-aria-Calendar"
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...renderProps,
        ...calendarProps,
        ref: ref,
        slot: props.slot || undefined,
        "data-disabled": props.isDisabled || undefined,
        "data-invalid": state.isValueInvalid || undefined
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.Provider), {
        values: [
            [
                (0, _button.ButtonContext),
                {
                    slots: {
                        previous: prevButtonProps,
                        next: nextButtonProps
                    }
                }
            ],
            [
                (0, _heading.HeadingContext),
                {
                    "aria-hidden": true,
                    level: 2,
                    children: title
                }
            ],
            [
                CalendarStateContext,
                state
            ],
            [
                (0, _text.TextContext),
                {
                    slots: {
                        errorMessage: errorMessageProps
                    }
                }
            ]
        ]
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAria.VisuallyHidden), null, /*#__PURE__*/ (0, _reactDefault.default).createElement("h2", null, calendarProps["aria-label"])), renderProps.children, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAria.VisuallyHidden), null, /*#__PURE__*/ (0, _reactDefault.default).createElement("button", {
        "aria-label": nextButtonProps["aria-label"],
        disabled: nextButtonProps.isDisabled,
        onClick: ()=>state.focusNextPage(),
        tabIndex: -1
    }))));
}
/**
 * A calendar displays one or more date grids and allows users to select a single date.
 */ const _Calendar = /*#__PURE__*/ (0, _react.forwardRef)(Calendar);
function RangeCalendar(props, ref) {
    [props, ref] = (0, _utils.useContextProps)(props, ref, RangeCalendarContext);
    let { locale } = (0, _reactAria.useLocale)();
    let state = (0, _reactStately.useRangeCalendarState)({
        ...props,
        locale,
        createCalendar: (0, _date.createCalendar)
    });
    let { calendarProps, prevButtonProps, nextButtonProps, errorMessageProps, title } = (0, _reactAria.useRangeCalendar)(props, state, ref);
    let renderProps = (0, _utils.useRenderProps)({
        ...props,
        values: {
            state,
            isDisabled: props.isDisabled || false,
            isInvalid: state.isValueInvalid
        },
        defaultClassName: "react-aria-RangeCalendar"
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...renderProps,
        ...calendarProps,
        ref: ref,
        slot: props.slot || undefined,
        "data-disabled": props.isDisabled || undefined,
        "data-invalid": state.isValueInvalid || undefined
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.Provider), {
        values: [
            [
                (0, _button.ButtonContext),
                {
                    slots: {
                        previous: prevButtonProps,
                        next: nextButtonProps
                    }
                }
            ],
            [
                (0, _heading.HeadingContext),
                {
                    "aria-hidden": true,
                    level: 2,
                    children: title
                }
            ],
            [
                RangeCalendarStateContext,
                state
            ],
            [
                (0, _text.TextContext),
                {
                    slots: {
                        errorMessage: errorMessageProps
                    }
                }
            ]
        ]
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAria.VisuallyHidden), null, /*#__PURE__*/ (0, _reactDefault.default).createElement("h2", null, calendarProps["aria-label"])), renderProps.children, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAria.VisuallyHidden), null, /*#__PURE__*/ (0, _reactDefault.default).createElement("button", {
        "aria-label": nextButtonProps["aria-label"],
        disabled: nextButtonProps.isDisabled,
        onClick: ()=>state.focusNextPage(),
        tabIndex: -1
    }))));
}
/**
 * A range calendar displays one or more date grids and allows users to select a contiguous range of dates.
 */ const _RangeCalendar = /*#__PURE__*/ (0, _react.forwardRef)(RangeCalendar);
const InternalCalendarGridContext = /*#__PURE__*/ (0, _react.createContext)(null);
function CalendarGrid(props, ref) {
    let calendarState = (0, _react.useContext)(CalendarStateContext);
    let rangeCalendarState = (0, _react.useContext)(RangeCalendarStateContext);
    let state = calendarState !== null && calendarState !== void 0 ? calendarState : rangeCalendarState;
    let startDate = state.visibleRange.start;
    if (props.offset) startDate = startDate.add(props.offset);
    let { gridProps, headerProps, weekDays } = (0, _reactAria.useCalendarGrid)({
        startDate,
        endDate: (0, _date.endOfMonth)(startDate),
        weekdayStyle: props.weekdayStyle
    }, state);
    var _props_className;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(InternalCalendarGridContext.Provider, {
        value: {
            headerProps,
            weekDays,
            startDate
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("table", {
        ...(0, _utils1.filterDOMProps)(props),
        ...gridProps,
        ref: ref,
        style: props.style,
        className: (_props_className = props.className) !== null && _props_className !== void 0 ? _props_className : "react-aria-CalendarGrid"
    }, typeof props.children !== "function" ? props.children : /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement(CalendarGridHeaderForwardRef, null, (day)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(CalendarHeaderCellForwardRef, null, day)), /*#__PURE__*/ (0, _reactDefault.default).createElement(CalendarGridBodyForwardRef, null, props.children))));
}
/**
 * A calendar grid displays a single grid of days within a calendar or range calendar which
 * can be keyboard navigated and selected by the user.
 */ const _CalendarGrid = /*#__PURE__*/ (0, _react.forwardRef)(CalendarGrid);
function CalendarGridHeader(props, ref) {
    let { children, style, className } = props;
    let { headerProps, weekDays } = (0, _react.useContext)(InternalCalendarGridContext);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("thead", {
        ...(0, _utils1.filterDOMProps)(props),
        ...headerProps,
        ref: ref,
        style: style,
        className: className || "react-aria-CalendarGridHeader"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("tr", null, weekDays.map((day, key)=>/*#__PURE__*/ (0, _reactDefault.default).cloneElement(children(day), {
            key
        }))));
}
/**
 * A calendar grid header displays a row of week day names at the top of a month.
 */ const CalendarGridHeaderForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(CalendarGridHeader);
function CalendarHeaderCell(props, ref) {
    let { children, style, className } = props;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("th", {
        ...(0, _utils1.filterDOMProps)(props),
        ref: ref,
        style: style,
        className: className || "react-aria-CalendarHeaderCell"
    }, children);
}
/**
 * A calendar header cell displays a week day name at the top of a column within a calendar.
 */ const CalendarHeaderCellForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(CalendarHeaderCell);
function CalendarGridBody(props, ref) {
    let { children, style, className } = props;
    let calendarState = (0, _react.useContext)(CalendarStateContext);
    let rangeCalendarState = (0, _react.useContext)(RangeCalendarStateContext);
    let state = calendarState !== null && calendarState !== void 0 ? calendarState : rangeCalendarState;
    let { startDate } = (0, _react.useContext)(InternalCalendarGridContext);
    let { locale } = (0, _reactAria.useLocale)();
    let weeksInMonth = (0, _date.getWeeksInMonth)(startDate, locale);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("tbody", {
        ...(0, _utils1.filterDOMProps)(props),
        ref: ref,
        style: style,
        className: className || "react-aria-CalendarGridBody"
    }, [
        ...new Array(weeksInMonth).keys()
    ].map((weekIndex)=>/*#__PURE__*/ (0, _reactDefault.default).createElement("tr", {
            key: weekIndex
        }, state.getDatesInWeek(weekIndex, startDate).map((date, i)=>date ? /*#__PURE__*/ (0, _reactDefault.default).cloneElement(children(date), {
                key: i
            }) : /*#__PURE__*/ (0, _reactDefault.default).createElement("td", {
                key: i
            })))));
}
/**
 * A calendar grid body displays a grid of calendar cells within a month.
 */ const CalendarGridBodyForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(CalendarGridBody);
function CalendarCell({ date, ...otherProps }, ref) {
    let calendarState = (0, _react.useContext)(CalendarStateContext);
    let rangeCalendarState = (0, _react.useContext)(RangeCalendarStateContext);
    let state = calendarState !== null && calendarState !== void 0 ? calendarState : rangeCalendarState;
    var _useContext;
    let { startDate: currentMonth } = (_useContext = (0, _react.useContext)(InternalCalendarGridContext)) !== null && _useContext !== void 0 ? _useContext : {
        startDate: state.visibleRange.start
    };
    let buttonRef = (0, _react.useRef)(null);
    let { cellProps, buttonProps, ...states } = (0, _reactAria.useCalendarCell)({
        date
    }, state, buttonRef);
    let { hoverProps, isHovered } = (0, _reactAria.useHover)({
        ...otherProps,
        isDisabled: states.isDisabled
    });
    let { focusProps, isFocusVisible } = (0, _reactAria.useFocusRing)();
    isFocusVisible && (isFocusVisible = states.isFocused);
    let isOutsideMonth = !(0, _date.isSameMonth)(currentMonth, date);
    let isSelectionStart = false;
    let isSelectionEnd = false;
    if ("highlightedRange" in state && state.highlightedRange) {
        isSelectionStart = (0, _date.isSameDay)(date, state.highlightedRange.start);
        isSelectionEnd = (0, _date.isSameDay)(date, state.highlightedRange.end);
    }
    let renderProps = (0, _utils.useRenderProps)({
        ...otherProps,
        defaultChildren: states.formattedDate,
        defaultClassName: "react-aria-CalendarCell",
        values: {
            date,
            isHovered,
            isOutsideMonth,
            isFocusVisible,
            isSelectionStart,
            isSelectionEnd,
            ...states
        }
    });
    let dataAttrs = {
        "data-focused": states.isFocused || undefined,
        "data-hovered": isHovered || undefined,
        "data-pressed": states.isPressed || undefined,
        "data-unavailable": states.isUnavailable || undefined,
        "data-disabled": states.isDisabled || undefined,
        "data-focus-visible": isFocusVisible || undefined,
        "data-outside-visible-range": states.isOutsideVisibleRange || undefined,
        "data-outside-month": isOutsideMonth || undefined,
        "data-selected": states.isSelected || undefined,
        "data-selection-start": isSelectionStart || undefined,
        "data-selection-end": isSelectionEnd || undefined,
        "data-invalid": states.isInvalid || undefined
    };
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("td", {
        ...cellProps,
        ref: ref
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...(0, _reactAria.mergeProps)((0, _utils1.filterDOMProps)(otherProps), buttonProps, focusProps, hoverProps, dataAttrs, renderProps),
        ref: buttonRef
    }));
}
/**
 * A calendar cell displays a date cell within a calendar grid which can be selected by the user.
 */ const _CalendarCell = /*#__PURE__*/ (0, _react.forwardRef)(CalendarCell);

},{"react-aria":"e7jhe","./Button":"9McZy","@internationalized/date":"hesBk","react-stately":"ij62t","./utils":"iyTLn","@react-aria/utils":"9cLk5","./Heading":"gl7db","react":"9yzVZ","./Text":"iZUDL","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"ij62t":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useCalendarState", ()=>(0, _calendar.useCalendarState));
parcelHelpers.export(exports, "useRangeCalendarState", ()=>(0, _calendar.useRangeCalendarState));
parcelHelpers.export(exports, "useCheckboxGroupState", ()=>(0, _checkbox.useCheckboxGroupState));
parcelHelpers.export(exports, "useComboBoxState", ()=>(0, _combobox.useComboBoxState));
parcelHelpers.export(exports, "useDateFieldState", ()=>(0, _datepicker.useDateFieldState));
parcelHelpers.export(exports, "useDatePickerState", ()=>(0, _datepicker.useDatePickerState));
parcelHelpers.export(exports, "useDateRangePickerState", ()=>(0, _datepicker.useDateRangePickerState));
parcelHelpers.export(exports, "useTimeFieldState", ()=>(0, _datepicker.useTimeFieldState));
parcelHelpers.export(exports, "useDraggableCollectionState", ()=>(0, _dnd.useDraggableCollectionState));
parcelHelpers.export(exports, "useDroppableCollectionState", ()=>(0, _dnd.useDroppableCollectionState));
parcelHelpers.export(exports, "Item", ()=>(0, _collections.Item));
parcelHelpers.export(exports, "Section", ()=>(0, _collections.Section));
parcelHelpers.export(exports, "useCollection", ()=>(0, _collections.useCollection));
parcelHelpers.export(exports, "useAsyncList", ()=>(0, _data.useAsyncList));
parcelHelpers.export(exports, "useListData", ()=>(0, _data.useListData));
parcelHelpers.export(exports, "useTreeData", ()=>(0, _data.useTreeData));
parcelHelpers.export(exports, "useListState", ()=>(0, _list.useListState));
parcelHelpers.export(exports, "useSingleSelectListState", ()=>(0, _list.useSingleSelectListState));
parcelHelpers.export(exports, "useMenuTriggerState", ()=>(0, _menu.useMenuTriggerState));
parcelHelpers.export(exports, "useNumberFieldState", ()=>(0, _numberfield.useNumberFieldState));
parcelHelpers.export(exports, "useOverlayTriggerState", ()=>(0, _overlays.useOverlayTriggerState));
parcelHelpers.export(exports, "useRadioGroupState", ()=>(0, _radio.useRadioGroupState));
parcelHelpers.export(exports, "useSearchFieldState", ()=>(0, _searchfield.useSearchFieldState));
parcelHelpers.export(exports, "useSelectState", ()=>(0, _select.useSelectState));
parcelHelpers.export(exports, "useSliderState", ()=>(0, _slider.useSliderState));
parcelHelpers.export(exports, "useMultipleSelectionState", ()=>(0, _selection.useMultipleSelectionState));
parcelHelpers.export(exports, "useTableState", ()=>(0, _table.useTableState));
parcelHelpers.export(exports, "TableHeader", ()=>(0, _table.TableHeader));
parcelHelpers.export(exports, "TableBody", ()=>(0, _table.TableBody));
parcelHelpers.export(exports, "Column", ()=>(0, _table.Column));
parcelHelpers.export(exports, "Row", ()=>(0, _table.Row));
parcelHelpers.export(exports, "Cell", ()=>(0, _table.Cell));
parcelHelpers.export(exports, "useTableColumnResizeState", ()=>(0, _table.useTableColumnResizeState));
parcelHelpers.export(exports, "useTabListState", ()=>(0, _tabs.useTabListState));
parcelHelpers.export(exports, "useToggleState", ()=>(0, _toggle.useToggleState));
parcelHelpers.export(exports, "useTooltipTriggerState", ()=>(0, _tooltip.useTooltipTriggerState));
parcelHelpers.export(exports, "useTreeState", ()=>(0, _tree.useTreeState));
parcelHelpers.export(exports, "FormValidationContext", ()=>(0, _form.FormValidationContext));
var _calendar = require("@react-stately/calendar");
var _checkbox = require("@react-stately/checkbox");
var _combobox = require("@react-stately/combobox");
var _datepicker = require("@react-stately/datepicker");
var _dnd = require("@react-stately/dnd");
var _collections = require("@react-stately/collections");
var _data = require("@react-stately/data");
var _list = require("@react-stately/list");
var _menu = require("@react-stately/menu");
var _numberfield = require("@react-stately/numberfield");
var _overlays = require("@react-stately/overlays");
var _radio = require("@react-stately/radio");
var _searchfield = require("@react-stately/searchfield");
var _select = require("@react-stately/select");
var _slider = require("@react-stately/slider");
var _selection = require("@react-stately/selection");
var _table = require("@react-stately/table");
var _tabs = require("@react-stately/tabs");
var _toggle = require("@react-stately/toggle");
var _tooltip = require("@react-stately/tooltip");
var _tree = require("@react-stately/tree");
var _form = require("@react-stately/form");

},{"@react-stately/calendar":"a8x0w","@react-stately/checkbox":"2A2GG","@react-stately/combobox":"j3BhU","@react-stately/datepicker":"ci7Mv","@react-stately/dnd":"bUQOi","@react-stately/collections":false,"@react-stately/data":"gEgJM","@react-stately/list":"Cp0zP","@react-stately/menu":"iqDQI","@react-stately/numberfield":"l3Rr3","@react-stately/overlays":"5uxM4","@react-stately/radio":"qkKdG","@react-stately/searchfield":"iPYi5","@react-stately/select":"4LWw9","@react-stately/slider":"82Whk","@react-stately/selection":false,"@react-stately/table":"6ZM93","@react-stately/tabs":"47SYn","@react-stately/toggle":"5qaKI","@react-stately/tooltip":"6Tizp","@react-stately/tree":"f1QlQ","@react-stately/form":false,"@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"a8x0w":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useCalendarState", ()=>(0, _useCalendarState.useCalendarState));
parcelHelpers.export(exports, "useRangeCalendarState", ()=>(0, _useRangeCalendarState.useRangeCalendarState));
var _useCalendarState = require("./useCalendarState");
var _useRangeCalendarState = require("./useRangeCalendarState");

},{"./useCalendarState":"blUp0","./useRangeCalendarState":"dMt1z","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"blUp0":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides state management for a calendar component.
 * A calendar displays one or more date grids and allows users to select a single date.
 */ parcelHelpers.export(exports, "useCalendarState", ()=>useCalendarState);
var _utils = require("./utils");
var _date = require("@internationalized/date");
var _utils1 = require("@react-stately/utils");
var _react = require("react");
function useCalendarState(props) {
    let defaultFormatter = (0, _react.useMemo)(()=>new (0, _date.DateFormatter)(props.locale), [
        props.locale
    ]);
    let resolvedOptions = (0, _react.useMemo)(()=>defaultFormatter.resolvedOptions(), [
        defaultFormatter
    ]);
    let { locale, createCalendar, visibleDuration = {
        months: 1
    }, minValue, maxValue, selectionAlignment, isDateUnavailable, pageBehavior = "visible" } = props;
    let calendar = (0, _react.useMemo)(()=>createCalendar(resolvedOptions.calendar), [
        createCalendar,
        resolvedOptions.calendar
    ]);
    let [value, setControlledValue] = (0, _utils1.useControlledState)(props.value, props.defaultValue, props.onChange);
    let calendarDateValue = (0, _react.useMemo)(()=>value ? (0, _date.toCalendar)((0, _date.toCalendarDate)(value), calendar) : null, [
        value,
        calendar
    ]);
    let timeZone = (0, _react.useMemo)(()=>value && "timeZone" in value ? value.timeZone : resolvedOptions.timeZone, [
        value,
        resolvedOptions.timeZone
    ]);
    let focusedCalendarDate = (0, _react.useMemo)(()=>props.focusedValue ? (0, _utils.constrainValue)((0, _date.toCalendar)((0, _date.toCalendarDate)(props.focusedValue), calendar), minValue, maxValue) : undefined, [
        props.focusedValue,
        calendar,
        minValue,
        maxValue
    ]);
    let defaultFocusedCalendarDate = (0, _react.useMemo)(()=>(0, _utils.constrainValue)(props.defaultFocusedValue ? (0, _date.toCalendar)((0, _date.toCalendarDate)(props.defaultFocusedValue), calendar) : calendarDateValue || (0, _date.toCalendar)((0, _date.today)(timeZone), calendar), minValue, maxValue), [
        props.defaultFocusedValue,
        calendarDateValue,
        timeZone,
        calendar,
        minValue,
        maxValue
    ]);
    let [focusedDate, setFocusedDate] = (0, _utils1.useControlledState)(focusedCalendarDate, defaultFocusedCalendarDate, props.onFocusChange);
    let [startDate, setStartDate] = (0, _react.useState)(()=>{
        switch(selectionAlignment){
            case "start":
                return (0, _utils.alignStart)(focusedDate, visibleDuration, locale, minValue, maxValue);
            case "end":
                return (0, _utils.alignEnd)(focusedDate, visibleDuration, locale, minValue, maxValue);
            case "center":
            default:
                return (0, _utils.alignCenter)(focusedDate, visibleDuration, locale, minValue, maxValue);
        }
    });
    let [isFocused, setFocused] = (0, _react.useState)(props.autoFocus || false);
    let endDate = (0, _react.useMemo)(()=>{
        let duration = {
            ...visibleDuration
        };
        if (duration.days) duration.days--;
        else duration.days = -1;
        return startDate.add(duration);
    }, [
        startDate,
        visibleDuration
    ]);
    // Reset focused date and visible range when calendar changes.
    let [lastCalendarIdentifier, setLastCalendarIdentifier] = (0, _react.useState)(calendar.identifier);
    if (calendar.identifier !== lastCalendarIdentifier) {
        let newFocusedDate = (0, _date.toCalendar)(focusedDate, calendar);
        setStartDate((0, _utils.alignCenter)(newFocusedDate, visibleDuration, locale, minValue, maxValue));
        setFocusedDate(newFocusedDate);
        setLastCalendarIdentifier(calendar.identifier);
    }
    if ((0, _utils.isInvalid)(focusedDate, minValue, maxValue)) // If the focused date was moved to an invalid value, it can't be focused, so constrain it.
    setFocusedDate((0, _utils.constrainValue)(focusedDate, minValue, maxValue));
    else if (focusedDate.compare(startDate) < 0) setStartDate((0, _utils.alignEnd)(focusedDate, visibleDuration, locale, minValue, maxValue));
    else if (focusedDate.compare(endDate) > 0) setStartDate((0, _utils.alignStart)(focusedDate, visibleDuration, locale, minValue, maxValue));
    // Sets focus to a specific cell date
    function focusCell(date) {
        date = (0, _utils.constrainValue)(date, minValue, maxValue);
        setFocusedDate(date);
    }
    function setValue(newValue) {
        if (!props.isDisabled && !props.isReadOnly) {
            newValue = (0, _utils.constrainValue)(newValue, minValue, maxValue);
            newValue = (0, _utils.previousAvailableDate)(newValue, startDate, isDateUnavailable);
            if (!newValue) return;
            // The display calendar should not have any effect on the emitted value.
            // Emit dates in the same calendar as the original value, if any, otherwise gregorian.
            newValue = (0, _date.toCalendar)(newValue, (value === null || value === void 0 ? void 0 : value.calendar) || new (0, _date.GregorianCalendar)());
            // Preserve time if the input value had one.
            if (value && "hour" in value) setControlledValue(value.set(newValue));
            else setControlledValue(newValue);
        }
    }
    let isUnavailable = (0, _react.useMemo)(()=>{
        if (!calendarDateValue) return false;
        if (isDateUnavailable && isDateUnavailable(calendarDateValue)) return true;
        return (0, _utils.isInvalid)(calendarDateValue, minValue, maxValue);
    }, [
        calendarDateValue,
        isDateUnavailable,
        minValue,
        maxValue
    ]);
    let isValueInvalid = props.isInvalid || props.validationState === "invalid" || isUnavailable;
    let validationState = isValueInvalid ? "invalid" : null;
    let pageDuration = (0, _react.useMemo)(()=>{
        if (pageBehavior === "visible") return visibleDuration;
        return unitDuration(visibleDuration);
    }, [
        pageBehavior,
        visibleDuration
    ]);
    return {
        isDisabled: props.isDisabled,
        isReadOnly: props.isReadOnly,
        value: calendarDateValue,
        setValue,
        visibleRange: {
            start: startDate,
            end: endDate
        },
        minValue,
        maxValue,
        focusedDate,
        timeZone,
        validationState,
        isValueInvalid,
        setFocusedDate (date) {
            focusCell(date);
            setFocused(true);
        },
        focusNextDay () {
            focusCell(focusedDate.add({
                days: 1
            }));
        },
        focusPreviousDay () {
            focusCell(focusedDate.subtract({
                days: 1
            }));
        },
        focusNextRow () {
            if (visibleDuration.days) this.focusNextPage();
            else if (visibleDuration.weeks || visibleDuration.months || visibleDuration.years) focusCell(focusedDate.add({
                weeks: 1
            }));
        },
        focusPreviousRow () {
            if (visibleDuration.days) this.focusPreviousPage();
            else if (visibleDuration.weeks || visibleDuration.months || visibleDuration.years) focusCell(focusedDate.subtract({
                weeks: 1
            }));
        },
        focusNextPage () {
            let start = startDate.add(pageDuration);
            setFocusedDate((0, _utils.constrainValue)(focusedDate.add(pageDuration), minValue, maxValue));
            setStartDate((0, _utils.alignStart)((0, _utils.constrainStart)(focusedDate, start, pageDuration, locale, minValue, maxValue), pageDuration, locale));
        },
        focusPreviousPage () {
            let start = startDate.subtract(pageDuration);
            setFocusedDate((0, _utils.constrainValue)(focusedDate.subtract(pageDuration), minValue, maxValue));
            setStartDate((0, _utils.alignStart)((0, _utils.constrainStart)(focusedDate, start, pageDuration, locale, minValue, maxValue), pageDuration, locale));
        },
        focusSectionStart () {
            if (visibleDuration.days) focusCell(startDate);
            else if (visibleDuration.weeks) focusCell((0, _date.startOfWeek)(focusedDate, locale));
            else if (visibleDuration.months || visibleDuration.years) focusCell((0, _date.startOfMonth)(focusedDate));
        },
        focusSectionEnd () {
            if (visibleDuration.days) focusCell(endDate);
            else if (visibleDuration.weeks) focusCell((0, _date.endOfWeek)(focusedDate, locale));
            else if (visibleDuration.months || visibleDuration.years) focusCell((0, _date.endOfMonth)(focusedDate));
        },
        focusNextSection (larger) {
            if (!larger && !visibleDuration.days) {
                focusCell(focusedDate.add(unitDuration(visibleDuration)));
                return;
            }
            if (visibleDuration.days) this.focusNextPage();
            else if (visibleDuration.weeks) focusCell(focusedDate.add({
                months: 1
            }));
            else if (visibleDuration.months || visibleDuration.years) focusCell(focusedDate.add({
                years: 1
            }));
        },
        focusPreviousSection (larger) {
            if (!larger && !visibleDuration.days) {
                focusCell(focusedDate.subtract(unitDuration(visibleDuration)));
                return;
            }
            if (visibleDuration.days) this.focusPreviousPage();
            else if (visibleDuration.weeks) focusCell(focusedDate.subtract({
                months: 1
            }));
            else if (visibleDuration.months || visibleDuration.years) focusCell(focusedDate.subtract({
                years: 1
            }));
        },
        selectFocusedDate () {
            setValue(focusedDate);
        },
        selectDate (date) {
            setValue(date);
        },
        isFocused,
        setFocused,
        isInvalid (date) {
            return (0, _utils.isInvalid)(date, minValue, maxValue);
        },
        isSelected (date) {
            return calendarDateValue != null && (0, _date.isSameDay)(date, calendarDateValue) && !this.isCellDisabled(date) && !this.isCellUnavailable(date);
        },
        isCellFocused (date) {
            return isFocused && focusedDate && (0, _date.isSameDay)(date, focusedDate);
        },
        isCellDisabled (date) {
            return props.isDisabled || date.compare(startDate) < 0 || date.compare(endDate) > 0 || this.isInvalid(date, minValue, maxValue);
        },
        isCellUnavailable (date) {
            return props.isDateUnavailable && props.isDateUnavailable(date);
        },
        isPreviousVisibleRangeInvalid () {
            let prev = startDate.subtract({
                days: 1
            });
            return (0, _date.isSameDay)(prev, startDate) || this.isInvalid(prev, minValue, maxValue);
        },
        isNextVisibleRangeInvalid () {
            // Adding may return the same date if we reached the end of time
            // according to the calendar system (e.g. 9999-12-31).
            let next = endDate.add({
                days: 1
            });
            return (0, _date.isSameDay)(next, endDate) || this.isInvalid(next, minValue, maxValue);
        },
        getDatesInWeek (weekIndex, from = startDate) {
            // let date = startOfWeek(from, locale);
            let date = from.add({
                weeks: weekIndex
            });
            let dates = [];
            date = (0, _date.startOfWeek)(date, locale);
            // startOfWeek will clamp dates within the calendar system's valid range, which may
            // start in the middle of a week. In this case, add null placeholders.
            let dayOfWeek = (0, _date.getDayOfWeek)(date, locale);
            for(let i = 0; i < dayOfWeek; i++)dates.push(null);
            while(dates.length < 7){
                dates.push(date);
                let nextDate = date.add({
                    days: 1
                });
                if ((0, _date.isSameDay)(date, nextDate)) break;
                date = nextDate;
            }
            // Add null placeholders if at the end of the calendar system.
            while(dates.length < 7)dates.push(null);
            return dates;
        }
    };
}
function unitDuration(duration) {
    let unit = {
        ...duration
    };
    for(let key in duration)unit[key] = 1;
    return unit;
}

},{"./utils":"6B5fl","@internationalized/date":"hesBk","@react-stately/utils":"cpDPf","react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"6B5fl":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isInvalid", ()=>isInvalid);
parcelHelpers.export(exports, "alignCenter", ()=>alignCenter);
parcelHelpers.export(exports, "alignStart", ()=>alignStart);
parcelHelpers.export(exports, "alignEnd", ()=>alignEnd);
parcelHelpers.export(exports, "constrainStart", ()=>constrainStart);
parcelHelpers.export(exports, "constrainValue", ()=>constrainValue);
parcelHelpers.export(exports, "previousAvailableDate", ()=>previousAvailableDate);
var _date = require("@internationalized/date");
function isInvalid(date, minValue, maxValue) {
    return minValue != null && date.compare(minValue) < 0 || maxValue != null && date.compare(maxValue) > 0;
}
function alignCenter(date, duration, locale, minValue, maxValue) {
    let halfDuration = {};
    for(let key in duration){
        halfDuration[key] = Math.floor(duration[key] / 2);
        if (halfDuration[key] > 0 && duration[key] % 2 === 0) halfDuration[key]--;
    }
    let aligned = alignStart(date, duration, locale).subtract(halfDuration);
    return constrainStart(date, aligned, duration, locale, minValue, maxValue);
}
function alignStart(date, duration, locale, minValue, maxValue) {
    // align to the start of the largest unit
    let aligned = date;
    if (duration.years) aligned = (0, _date.startOfYear)(date);
    else if (duration.months) aligned = (0, _date.startOfMonth)(date);
    else if (duration.weeks) aligned = (0, _date.startOfWeek)(date, locale);
    return constrainStart(date, aligned, duration, locale, minValue, maxValue);
}
function alignEnd(date, duration, locale, minValue, maxValue) {
    let d = {
        ...duration
    };
    // subtract 1 from the smallest unit
    if (duration.days) d.days--;
    else if (duration.weeks) d.weeks--;
    else if (duration.months) d.months--;
    else if (duration.years) d.years--;
    let aligned = alignStart(date, duration, locale).subtract(d);
    return constrainStart(date, aligned, duration, locale, minValue, maxValue);
}
function constrainStart(date, aligned, duration, locale, minValue, maxValue) {
    if (minValue && date.compare(minValue) >= 0) aligned = (0, _date.maxDate)(aligned, alignStart((0, _date.toCalendarDate)(minValue), duration, locale));
    if (maxValue && date.compare(maxValue) <= 0) aligned = (0, _date.minDate)(aligned, alignEnd((0, _date.toCalendarDate)(maxValue), duration, locale));
    return aligned;
}
function constrainValue(date, minValue, maxValue) {
    if (minValue) date = (0, _date.maxDate)(date, (0, _date.toCalendarDate)(minValue));
    if (maxValue) date = (0, _date.minDate)(date, (0, _date.toCalendarDate)(maxValue));
    return date;
}
function previousAvailableDate(date, minValue, isDateUnavailable) {
    if (!isDateUnavailable) return date;
    while(date.compare(minValue) >= 0 && isDateUnavailable(date))date = date.subtract({
        days: 1
    });
    if (date.compare(minValue) >= 0) return date;
}

},{"@internationalized/date":"hesBk","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"dMt1z":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides state management for a range calendar component.
 * A range calendar displays one or more date grids and allows users to select a contiguous range of dates.
 */ parcelHelpers.export(exports, "useRangeCalendarState", ()=>useRangeCalendarState);
var _utils = require("./utils");
var _date = require("@internationalized/date");
var _useCalendarState = require("./useCalendarState");
var _utils1 = require("@react-stately/utils");
var _react = require("react");
function useRangeCalendarState(props) {
    let { value: valueProp, defaultValue, onChange, createCalendar, locale, visibleDuration = {
        months: 1
    }, minValue, maxValue, ...calendarProps } = props;
    let [value, setValue] = (0, _utils1.useControlledState)(valueProp, defaultValue || null, onChange);
    let [anchorDate, setAnchorDateState] = (0, _react.useState)(null);
    let alignment = "center";
    if (value && value.start && value.end) {
        let start = (0, _utils.alignCenter)((0, _date.toCalendarDate)(value.start), visibleDuration, locale, minValue, maxValue);
        let end = start.add(visibleDuration).subtract({
            days: 1
        });
        if (value.end.compare(end) > 0) alignment = "start";
    }
    // Available range must be stored in a ref so we have access to the updated version immediately in `isInvalid`.
    let availableRangeRef = (0, _react.useRef)(null);
    let [availableRange, setAvailableRange] = (0, _react.useState)(null);
    let min = (0, _react.useMemo)(()=>(0, _date.maxDate)(minValue, availableRange === null || availableRange === void 0 ? void 0 : availableRange.start), [
        minValue,
        availableRange
    ]);
    let max = (0, _react.useMemo)(()=>(0, _date.minDate)(maxValue, availableRange === null || availableRange === void 0 ? void 0 : availableRange.end), [
        maxValue,
        availableRange
    ]);
    let calendar = (0, _useCalendarState.useCalendarState)({
        ...calendarProps,
        value: value && value.start,
        createCalendar,
        locale,
        visibleDuration,
        minValue: min,
        maxValue: max,
        selectionAlignment: alignment
    });
    let updateAvailableRange = (date)=>{
        if (date && props.isDateUnavailable && !props.allowsNonContiguousRanges) {
            availableRangeRef.current = {
                start: nextUnavailableDate(date, calendar, -1),
                end: nextUnavailableDate(date, calendar, 1)
            };
            setAvailableRange(availableRangeRef.current);
        } else {
            availableRangeRef.current = null;
            setAvailableRange(null);
        }
    };
    // If the visible range changes, we need to update the available range.
    let [lastVisibleRange, setLastVisibleRange] = (0, _react.useState)(calendar.visibleRange);
    if (!(0, _date.isEqualDay)(calendar.visibleRange.start, lastVisibleRange.start) || !(0, _date.isEqualDay)(calendar.visibleRange.end, lastVisibleRange.end)) {
        updateAvailableRange(anchorDate);
        setLastVisibleRange(calendar.visibleRange);
    }
    let setAnchorDate = (date)=>{
        if (date) {
            setAnchorDateState(date);
            updateAvailableRange(date);
        } else {
            setAnchorDateState(null);
            updateAvailableRange(null);
        }
    };
    let highlightedRange = anchorDate ? makeRange(anchorDate, calendar.focusedDate) : value && makeRange(value.start, value.end);
    let selectDate = (date)=>{
        if (props.isReadOnly) return;
        date = (0, _utils.constrainValue)(date, min, max);
        date = (0, _utils.previousAvailableDate)(date, calendar.visibleRange.start, props.isDateUnavailable);
        if (!date) return;
        if (!anchorDate) setAnchorDate(date);
        else {
            let range = makeRange(anchorDate, date);
            setValue({
                start: convertValue(range.start, value === null || value === void 0 ? void 0 : value.start),
                end: convertValue(range.end, value === null || value === void 0 ? void 0 : value.end)
            });
            setAnchorDate(null);
        }
    };
    let [isDragging, setDragging] = (0, _react.useState)(false);
    let { isDateUnavailable } = props;
    let isInvalidSelection = (0, _react.useMemo)(()=>{
        if (!value || anchorDate) return false;
        if (isDateUnavailable && (isDateUnavailable(value.start) || isDateUnavailable(value.end))) return true;
        return (0, _utils.isInvalid)(value.start, minValue, maxValue) || (0, _utils.isInvalid)(value.end, minValue, maxValue);
    }, [
        isDateUnavailable,
        value,
        anchorDate,
        minValue,
        maxValue
    ]);
    let isValueInvalid = props.isInvalid || props.validationState === "invalid" || isInvalidSelection;
    let validationState = isValueInvalid ? "invalid" : null;
    return {
        ...calendar,
        value,
        setValue,
        anchorDate,
        setAnchorDate,
        highlightedRange,
        validationState,
        isValueInvalid,
        selectFocusedDate () {
            selectDate(calendar.focusedDate);
        },
        selectDate,
        highlightDate (date) {
            if (anchorDate) calendar.setFocusedDate(date);
        },
        isSelected (date) {
            return highlightedRange && date.compare(highlightedRange.start) >= 0 && date.compare(highlightedRange.end) <= 0 && !calendar.isCellDisabled(date) && !calendar.isCellUnavailable(date);
        },
        isInvalid (date) {
            var _availableRangeRef_current, _availableRangeRef_current1;
            return calendar.isInvalid(date) || (0, _utils.isInvalid)(date, (_availableRangeRef_current = availableRangeRef.current) === null || _availableRangeRef_current === void 0 ? void 0 : _availableRangeRef_current.start, (_availableRangeRef_current1 = availableRangeRef.current) === null || _availableRangeRef_current1 === void 0 ? void 0 : _availableRangeRef_current1.end);
        },
        isDragging,
        setDragging
    };
}
function makeRange(start, end) {
    if (!start || !end) return null;
    if (end.compare(start) < 0) [start, end] = [
        end,
        start
    ];
    return {
        start: (0, _date.toCalendarDate)(start),
        end: (0, _date.toCalendarDate)(end)
    };
}
function convertValue(newValue, oldValue) {
    // The display calendar should not have any effect on the emitted value.
    // Emit dates in the same calendar as the original value, if any, otherwise gregorian.
    newValue = (0, _date.toCalendar)(newValue, (oldValue === null || oldValue === void 0 ? void 0 : oldValue.calendar) || new (0, _date.GregorianCalendar)());
    // Preserve time if the input value had one.
    if (oldValue && "hour" in oldValue) return oldValue.set(newValue);
    return newValue;
}
function nextUnavailableDate(anchorDate, state, dir) {
    let nextDate = anchorDate.add({
        days: dir
    });
    while((dir < 0 ? nextDate.compare(state.visibleRange.start) >= 0 : nextDate.compare(state.visibleRange.end) <= 0) && !state.isCellUnavailable(nextDate))nextDate = nextDate.add({
        days: dir
    });
    if (state.isCellUnavailable(nextDate)) return nextDate.add({
        days: -dir
    });
    return null;
}

},{"./utils":"6B5fl","@internationalized/date":"hesBk","./useCalendarState":"blUp0","@react-stately/utils":"cpDPf","react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"2A2GG":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useCheckboxGroupState", ()=>(0, _useCheckboxGroupState.useCheckboxGroupState));
var _useCheckboxGroupState = require("./useCheckboxGroupState");

},{"./useCheckboxGroupState":"5H7T5","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"5H7T5":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides state management for a checkbox group component. Provides a name for the group,
 * and manages selection and focus state.
 */ parcelHelpers.export(exports, "useCheckboxGroupState", ()=>useCheckboxGroupState);
var _form = require("@react-stately/form");
var _utils = require("@react-stately/utils");
var _react = require("react");
function useCheckboxGroupState(props = {}) {
    let [selectedValues, setValue] = (0, _utils.useControlledState)(props.value, props.defaultValue || [], props.onChange);
    let isRequired = !!props.isRequired && selectedValues.length === 0;
    let invalidValues = (0, _react.useRef)(new Map());
    let validation = (0, _form.useFormValidationState)({
        ...props,
        value: selectedValues
    });
    let isInvalid = validation.displayValidation.isInvalid;
    var _props_validationState;
    const state = {
        ...validation,
        value: selectedValues,
        setValue (value) {
            if (props.isReadOnly || props.isDisabled) return;
            setValue(value);
        },
        isDisabled: props.isDisabled || false,
        isReadOnly: props.isReadOnly || false,
        isSelected (value) {
            return selectedValues.includes(value);
        },
        addValue (value) {
            if (props.isReadOnly || props.isDisabled) return;
            if (!selectedValues.includes(value)) setValue(selectedValues.concat(value));
        },
        removeValue (value) {
            if (props.isReadOnly || props.isDisabled) return;
            if (selectedValues.includes(value)) setValue(selectedValues.filter((existingValue)=>existingValue !== value));
        },
        toggleValue (value) {
            if (props.isReadOnly || props.isDisabled) return;
            if (selectedValues.includes(value)) setValue(selectedValues.filter((existingValue)=>existingValue !== value));
            else setValue(selectedValues.concat(value));
        },
        setInvalid (value, v) {
            let s = new Map(invalidValues.current);
            if (v.isInvalid) s.set(value, v);
            else s.delete(value);
            invalidValues.current = s;
            validation.updateValidation((0, _form.mergeValidation)(...s.values()));
        },
        validationState: (_props_validationState = props.validationState) !== null && _props_validationState !== void 0 ? _props_validationState : isInvalid ? "invalid" : null,
        isInvalid,
        isRequired
    };
    return state;
}

},{"@react-stately/form":"9yZqm","@react-stately/utils":"cpDPf","react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"j3BhU":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 * 
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useComboBoxState", ()=>(0, _useComboBoxState.useComboBoxState));
var _useComboBoxState = require("./useComboBoxState");

},{"./useComboBoxState":"5OWsZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"5OWsZ":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides state management for a combo box component. Handles building a collection
 * of items from props and manages the option selection state of the combo box. In addition, it tracks the input value,
 * focus state, and other properties of the combo box.
 */ parcelHelpers.export(exports, "useComboBoxState", ()=>useComboBoxState);
var _form = require("@react-stately/form");
var _collections = require("@react-stately/collections");
var _list = require("@react-stately/list");
var _react = require("react");
var _utils = require("@react-stately/utils");
var _overlays = require("@react-stately/overlays");
function useComboBoxState(props) {
    var _collection_getItem, _collection_getItem1;
    let { defaultFilter, menuTrigger = "input", allowsEmptyCollection = false, allowsCustomValue, shouldCloseOnBlur = true } = props;
    let [showAllItems, setShowAllItems] = (0, _react.useState)(false);
    let [isFocused, setFocusedState] = (0, _react.useState)(false);
    let [focusStrategy, setFocusStrategy] = (0, _react.useState)(null);
    let onSelectionChange = (key)=>{
        if (props.onSelectionChange) props.onSelectionChange(key);
        // If key is the same, reset the inputValue and close the menu
        // (scenario: user clicks on already selected option)
        if (key === selectedKey) {
            resetInputValue();
            closeMenu();
        }
    };
    var _props_items;
    let { collection, selectionManager, selectedKey, setSelectedKey, selectedItem, disabledKeys } = (0, _list.useSingleSelectListState)({
        ...props,
        onSelectionChange,
        items: (_props_items = props.items) !== null && _props_items !== void 0 ? _props_items : props.defaultItems
    });
    var _props_defaultInputValue, _ref;
    let [inputValue, setInputValue] = (0, _utils.useControlledState)(props.inputValue, (_ref = (_props_defaultInputValue = props.defaultInputValue) !== null && _props_defaultInputValue !== void 0 ? _props_defaultInputValue : (_collection_getItem = collection.getItem(selectedKey)) === null || _collection_getItem === void 0 ? void 0 : _collection_getItem.textValue) !== null && _ref !== void 0 ? _ref : "", props.onInputChange);
    // Preserve original collection so we can show all items on demand
    let originalCollection = collection;
    let filteredCollection = (0, _react.useMemo)(()=>// No default filter if items are controlled.
        props.items != null || !defaultFilter ? collection : filterCollection(collection, inputValue, defaultFilter), [
        collection,
        inputValue,
        defaultFilter,
        props.items
    ]);
    let [lastCollection, setLastCollection] = (0, _react.useState)(filteredCollection);
    // Track what action is attempting to open the menu
    let menuOpenTrigger = (0, _react.useRef)("focus");
    let onOpenChange = (open)=>{
        if (props.onOpenChange) props.onOpenChange(open, open ? menuOpenTrigger.current : undefined);
        selectionManager.setFocused(open);
        if (!open) selectionManager.setFocusedKey(null);
    };
    let triggerState = (0, _overlays.useOverlayTriggerState)({
        ...props,
        onOpenChange,
        isOpen: undefined,
        defaultOpen: undefined
    });
    let open = (focusStrategy = null, trigger)=>{
        let displayAllItems = trigger === "manual" || trigger === "focus" && menuTrigger === "focus";
        // Prevent open operations from triggering if there is nothing to display
        // Also prevent open operations from triggering if items are uncontrolled but defaultItems is empty, even if displayAllItems is true.
        // This is to prevent comboboxes with empty defaultItems from opening but allow controlled items comboboxes to open even if the inital list is empty (assumption is user will provide swap the empty list with a base list via onOpenChange returning `menuTrigger` manual)
        if (allowsEmptyCollection || filteredCollection.size > 0 || displayAllItems && originalCollection.size > 0 || props.items) {
            if (displayAllItems && !triggerState.isOpen && props.items === undefined) // Show all items if menu is manually opened. Only care about this if items are undefined
            setShowAllItems(true);
            menuOpenTrigger.current = trigger;
            setFocusStrategy(focusStrategy);
            triggerState.open();
        }
    };
    let toggle = (focusStrategy = null, trigger)=>{
        let displayAllItems = trigger === "manual" || trigger === "focus" && menuTrigger === "focus";
        // If the menu is closed and there is nothing to display, early return so toggle isn't called to prevent extraneous onOpenChange
        if (!(allowsEmptyCollection || filteredCollection.size > 0 || displayAllItems && originalCollection.size > 0 || props.items) && !triggerState.isOpen) return;
        if (displayAllItems && !triggerState.isOpen && props.items === undefined) // Show all items if menu is toggled open. Only care about this if items are undefined
        setShowAllItems(true);
        // Only update the menuOpenTrigger if menu is currently closed
        if (!triggerState.isOpen) menuOpenTrigger.current = trigger;
        toggleMenu(focusStrategy);
    };
    let updateLastCollection = (0, _react.useCallback)(()=>{
        setLastCollection(showAllItems ? originalCollection : filteredCollection);
    }, [
        showAllItems,
        originalCollection,
        filteredCollection
    ]);
    // If menu is going to close, save the current collection so we can freeze the displayed collection when the
    // user clicks outside the popover to close the menu. Prevents the menu contents from updating as the menu closes.
    let toggleMenu = (0, _react.useCallback)((focusStrategy = null)=>{
        if (triggerState.isOpen) updateLastCollection();
        setFocusStrategy(focusStrategy);
        triggerState.toggle();
    }, [
        triggerState,
        updateLastCollection
    ]);
    let closeMenu = (0, _react.useCallback)(()=>{
        if (triggerState.isOpen) {
            updateLastCollection();
            triggerState.close();
        }
    }, [
        triggerState,
        updateLastCollection
    ]);
    let [lastValue, setLastValue] = (0, _react.useState)(inputValue);
    let resetInputValue = ()=>{
        var _collection_getItem;
        var _collection_getItem_textValue;
        let itemText = (_collection_getItem_textValue = (_collection_getItem = collection.getItem(selectedKey)) === null || _collection_getItem === void 0 ? void 0 : _collection_getItem.textValue) !== null && _collection_getItem_textValue !== void 0 ? _collection_getItem_textValue : "";
        setLastValue(itemText);
        setInputValue(itemText);
    };
    var _props_selectedKey, _ref1;
    let lastSelectedKey = (0, _react.useRef)((_ref1 = (_props_selectedKey = props.selectedKey) !== null && _props_selectedKey !== void 0 ? _props_selectedKey : props.defaultSelectedKey) !== null && _ref1 !== void 0 ? _ref1 : null);
    var _collection_getItem_textValue;
    let lastSelectedKeyText = (0, _react.useRef)((_collection_getItem_textValue = (_collection_getItem1 = collection.getItem(selectedKey)) === null || _collection_getItem1 === void 0 ? void 0 : _collection_getItem1.textValue) !== null && _collection_getItem_textValue !== void 0 ? _collection_getItem_textValue : "");
    // intentional omit dependency array, want this to happen on every render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, _react.useEffect)(()=>{
        var _collection_getItem;
        // Open and close menu automatically when the input value changes if the input is focused,
        // and there are items in the collection or allowEmptyCollection is true.
        if (isFocused && (filteredCollection.size > 0 || allowsEmptyCollection) && !triggerState.isOpen && inputValue !== lastValue && menuTrigger !== "manual") open(null, "input");
        // Close the menu if the collection is empty. Don't close menu if filtered collection size is 0
        // but we are currently showing all items via button press
        if (!showAllItems && !allowsEmptyCollection && triggerState.isOpen && filteredCollection.size === 0) closeMenu();
        // Close when an item is selected.
        if (selectedKey != null && selectedKey !== lastSelectedKey.current) closeMenu();
        // Clear focused key when input value changes and display filtered collection again.
        if (inputValue !== lastValue) {
            selectionManager.setFocusedKey(null);
            setShowAllItems(false);
            // Set selectedKey to null when the user clears the input.
            // If controlled, this is the application developer's responsibility.
            if (inputValue === "" && (props.inputValue === undefined || props.selectedKey === undefined)) setSelectedKey(null);
        }
        // If the selectedKey changed, update the input value.
        // Do nothing if both inputValue and selectedKey are controlled.
        // In this case, it's the user's responsibility to update inputValue in onSelectionChange.
        if (selectedKey !== lastSelectedKey.current && (props.inputValue === undefined || props.selectedKey === undefined)) resetInputValue();
        else if (lastValue !== inputValue) setLastValue(inputValue);
        var _collection_getItem_textValue;
        // Update the inputValue if the selected item's text changes from its last tracked value.
        // This is to handle cases where a selectedKey is specified but the items aren't available (async loading) or the selected item's text value updates.
        // Only reset if the user isn't currently within the field so we don't erroneously modify user input.
        // If inputValue is controlled, it is the user's responsibility to update the inputValue when items change.
        let selectedItemText = (_collection_getItem_textValue = (_collection_getItem = collection.getItem(selectedKey)) === null || _collection_getItem === void 0 ? void 0 : _collection_getItem.textValue) !== null && _collection_getItem_textValue !== void 0 ? _collection_getItem_textValue : "";
        if (!isFocused && selectedKey != null && props.inputValue === undefined && selectedKey === lastSelectedKey.current) {
            if (lastSelectedKeyText.current !== selectedItemText) {
                setLastValue(selectedItemText);
                setInputValue(selectedItemText);
            }
        }
        lastSelectedKey.current = selectedKey;
        lastSelectedKeyText.current = selectedItemText;
    });
    let validation = (0, _form.useFormValidationState)({
        ...props,
        value: (0, _react.useMemo)(()=>({
                inputValue,
                selectedKey
            }), [
            inputValue,
            selectedKey
        ])
    });
    // Revert input value and close menu
    let revert = ()=>{
        if (allowsCustomValue && selectedKey == null) commitCustomValue();
        else commitSelection();
    };
    let commitCustomValue = ()=>{
        lastSelectedKey.current = null;
        setSelectedKey(null);
        closeMenu();
    };
    let commitSelection = ()=>{
        // If multiple things are controlled, call onSelectionChange
        if (props.selectedKey !== undefined && props.inputValue !== undefined) {
            var _collection_getItem;
            props.onSelectionChange(selectedKey);
            var _collection_getItem_textValue;
            // Stop menu from reopening from useEffect
            let itemText = (_collection_getItem_textValue = (_collection_getItem = collection.getItem(selectedKey)) === null || _collection_getItem === void 0 ? void 0 : _collection_getItem.textValue) !== null && _collection_getItem_textValue !== void 0 ? _collection_getItem_textValue : "";
            setLastValue(itemText);
            closeMenu();
        } else {
            // If only a single aspect of combobox is controlled, reset input value and close menu for the user
            resetInputValue();
            closeMenu();
        }
    };
    const commitValue = ()=>{
        if (allowsCustomValue) {
            var _collection_getItem;
            var _collection_getItem_textValue;
            const itemText = (_collection_getItem_textValue = (_collection_getItem = collection.getItem(selectedKey)) === null || _collection_getItem === void 0 ? void 0 : _collection_getItem.textValue) !== null && _collection_getItem_textValue !== void 0 ? _collection_getItem_textValue : "";
            inputValue === itemText ? commitSelection() : commitCustomValue();
        } else // Reset inputValue and close menu
        commitSelection();
    };
    let commit = ()=>{
        if (triggerState.isOpen && selectionManager.focusedKey != null) {
            // Reset inputValue and close menu here if the selected key is already the focused key. Otherwise
            // fire onSelectionChange to allow the application to control the closing.
            if (selectedKey === selectionManager.focusedKey) commitSelection();
            else setSelectedKey(selectionManager.focusedKey);
        } else commitValue();
    };
    let valueOnFocus = (0, _react.useRef)(inputValue);
    let setFocused = (isFocused)=>{
        if (isFocused) {
            valueOnFocus.current = inputValue;
            if (menuTrigger === "focus") open(null, "focus");
        } else {
            if (shouldCloseOnBlur) commitValue();
            if (inputValue !== valueOnFocus.current) validation.commitValidation();
        }
        setFocusedState(isFocused);
    };
    let displayedCollection = (0, _react.useMemo)(()=>{
        if (triggerState.isOpen) {
            if (showAllItems) return originalCollection;
            else return filteredCollection;
        } else return lastCollection;
    }, [
        triggerState.isOpen,
        originalCollection,
        filteredCollection,
        showAllItems,
        lastCollection
    ]);
    return {
        ...validation,
        ...triggerState,
        focusStrategy,
        toggle,
        open,
        close: commitValue,
        selectionManager,
        selectedKey,
        setSelectedKey,
        disabledKeys,
        isFocused,
        setFocused,
        selectedItem,
        collection: displayedCollection,
        inputValue,
        setInputValue,
        commit,
        revert
    };
}
function filterCollection(collection, inputValue, filter) {
    return new (0, _list.ListCollection)(filterNodes(collection, collection, inputValue, filter));
}
function filterNodes(collection, nodes, inputValue, filter) {
    let filteredNode = [];
    for (let node of nodes){
        if (node.type === "section" && node.hasChildNodes) {
            let filtered = filterNodes(collection, (0, _collections.getChildNodes)(node, collection), inputValue, filter);
            if ([
                ...filtered
            ].some((node)=>node.type === "item")) filteredNode.push({
                ...node,
                childNodes: filtered
            });
        } else if (node.type === "item" && filter(node.textValue, inputValue)) filteredNode.push({
            ...node
        });
        else if (node.type !== "item") filteredNode.push({
            ...node
        });
    }
    return filteredNode;
}

},{"@react-stately/form":"9yZqm","@react-stately/collections":"loANi","@react-stately/list":"Cp0zP","react":"9yzVZ","@react-stately/utils":"cpDPf","@react-stately/overlays":"5uxM4","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"Cp0zP":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useListState", ()=>(0, _useListState.useListState));
parcelHelpers.export(exports, "useSingleSelectListState", ()=>(0, _useSingleSelectListState.useSingleSelectListState));
parcelHelpers.export(exports, "ListCollection", ()=>(0, _listCollection.ListCollection));
var _useListState = require("./useListState");
var _useSingleSelectListState = require("./useSingleSelectListState");
var _listCollection = require("./ListCollection");

},{"./useListState":"cgD4f","./useSingleSelectListState":"3bCqE","./ListCollection":"ham4n","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"cgD4f":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides state management for list-like components. Handles building a collection
 * of items from props, and manages multiple selection state.
 */ parcelHelpers.export(exports, "useListState", ()=>useListState);
var _listCollection = require("./ListCollection");
var _selection = require("@react-stately/selection");
var _react = require("react");
var _collections = require("@react-stately/collections");
function useListState(props) {
    let { filter } = props;
    let selectionState = (0, _selection.useMultipleSelectionState)(props);
    let disabledKeys = (0, _react.useMemo)(()=>props.disabledKeys ? new Set(props.disabledKeys) : new Set(), [
        props.disabledKeys
    ]);
    let factory = (0, _react.useCallback)((nodes)=>filter ? new (0, _listCollection.ListCollection)(filter(nodes)) : new (0, _listCollection.ListCollection)(nodes), [
        filter
    ]);
    let context = (0, _react.useMemo)(()=>({
            suppressTextValueWarning: props.suppressTextValueWarning
        }), [
        props.suppressTextValueWarning
    ]);
    let collection = (0, _collections.useCollection)(props, factory, context);
    let selectionManager = (0, _react.useMemo)(()=>new (0, _selection.SelectionManager)(collection, selectionState), [
        collection,
        selectionState
    ]);
    // Reset focused key if that item is deleted from the collection.
    const cachedCollection = (0, _react.useRef)(null);
    (0, _react.useEffect)(()=>{
        if (selectionState.focusedKey != null && !collection.getItem(selectionState.focusedKey)) {
            const startItem = cachedCollection.current.getItem(selectionState.focusedKey);
            const cachedItemNodes = [
                ...cachedCollection.current.getKeys()
            ].map((key)=>{
                const itemNode = cachedCollection.current.getItem(key);
                return itemNode.type === "item" ? itemNode : null;
            }).filter((node)=>node !== null);
            const itemNodes = [
                ...collection.getKeys()
            ].map((key)=>{
                const itemNode = collection.getItem(key);
                return itemNode.type === "item" ? itemNode : null;
            }).filter((node)=>node !== null);
            const diff = cachedItemNodes.length - itemNodes.length;
            let index = Math.min(diff > 1 ? Math.max(startItem.index - diff + 1, 0) : startItem.index, itemNodes.length - 1);
            let newNode;
            while(index >= 0){
                if (!selectionManager.isDisabled(itemNodes[index].key)) {
                    newNode = itemNodes[index];
                    break;
                }
                // Find next, not disabled item.
                if (index < itemNodes.length - 1) index++;
                else {
                    if (index > startItem.index) index = startItem.index;
                    index--;
                }
            }
            selectionState.setFocusedKey(newNode ? newNode.key : null);
        }
        cachedCollection.current = collection;
    }, [
        collection,
        selectionManager,
        selectionState,
        selectionState.focusedKey
    ]);
    return {
        collection,
        disabledKeys,
        selectionManager
    };
}

},{"./ListCollection":"ham4n","@react-stately/selection":"hM12z","react":"9yzVZ","@react-stately/collections":"loANi","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"ham4n":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ListCollection", ()=>ListCollection);
class ListCollection {
    *[Symbol.iterator]() {
        yield* this.iterable;
    }
    get size() {
        return this.keyMap.size;
    }
    getKeys() {
        return this.keyMap.keys();
    }
    getKeyBefore(key) {
        let node = this.keyMap.get(key);
        return node ? node.prevKey : null;
    }
    getKeyAfter(key) {
        let node = this.keyMap.get(key);
        return node ? node.nextKey : null;
    }
    getFirstKey() {
        return this.firstKey;
    }
    getLastKey() {
        return this.lastKey;
    }
    getItem(key) {
        return this.keyMap.get(key);
    }
    at(idx) {
        const keys = [
            ...this.getKeys()
        ];
        return this.getItem(keys[idx]);
    }
    getChildren(key) {
        let node = this.keyMap.get(key);
        return (node === null || node === void 0 ? void 0 : node.childNodes) || [];
    }
    constructor(nodes){
        this.keyMap = new Map();
        this.iterable = nodes;
        let visit = (node)=>{
            this.keyMap.set(node.key, node);
            if (node.childNodes && node.type === "section") for (let child of node.childNodes)visit(child);
        };
        for (let node of nodes)visit(node);
        let last;
        let index = 0;
        for (let [key, node] of this.keyMap){
            if (last) {
                last.nextKey = key;
                node.prevKey = last.key;
            } else {
                this.firstKey = key;
                node.prevKey = undefined;
            }
            if (node.type === "item") node.index = index++;
            last = node;
            // Set nextKey as undefined since this might be the last node
            // If it isn't the last node, last.nextKey will properly set at start of new loop
            last.nextKey = undefined;
        }
        this.lastKey = last === null || last === void 0 ? void 0 : last.key;
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"hM12z":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useMultipleSelectionState", ()=>(0, _useMultipleSelectionState.useMultipleSelectionState));
parcelHelpers.export(exports, "SelectionManager", ()=>(0, _selectionManager.SelectionManager));
var _useMultipleSelectionState = require("./useMultipleSelectionState");
var _selectionManager = require("./SelectionManager");

},{"./useMultipleSelectionState":"4dVvD","./SelectionManager":"kXpbx","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"4dVvD":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Manages state for multiple selection and focus in a collection.
 */ parcelHelpers.export(exports, "useMultipleSelectionState", ()=>useMultipleSelectionState);
var _selection = require("./Selection");
var _utils = require("@react-stately/utils");
var _react = require("react");
function equalSets(setA, setB) {
    if (setA.size !== setB.size) return false;
    for (let item of setA){
        if (!setB.has(item)) return false;
    }
    return true;
}
function useMultipleSelectionState(props) {
    let { selectionMode = "none", disallowEmptySelection, allowDuplicateSelectionEvents, selectionBehavior: selectionBehaviorProp = "toggle", disabledBehavior = "all" } = props;
    // We want synchronous updates to `isFocused` and `focusedKey` after their setters are called.
    // But we also need to trigger a react re-render. So, we have both a ref (sync) and state (async).
    let isFocusedRef = (0, _react.useRef)(false);
    let [, setFocused] = (0, _react.useState)(false);
    let focusedKeyRef = (0, _react.useRef)(null);
    let childFocusStrategyRef = (0, _react.useRef)(null);
    let [, setFocusedKey] = (0, _react.useState)(null);
    let selectedKeysProp = (0, _react.useMemo)(()=>convertSelection(props.selectedKeys), [
        props.selectedKeys
    ]);
    let defaultSelectedKeys = (0, _react.useMemo)(()=>convertSelection(props.defaultSelectedKeys, new (0, _selection.Selection)()), [
        props.defaultSelectedKeys
    ]);
    let [selectedKeys, setSelectedKeys] = (0, _utils.useControlledState)(selectedKeysProp, defaultSelectedKeys, props.onSelectionChange);
    let disabledKeysProp = (0, _react.useMemo)(()=>props.disabledKeys ? new Set(props.disabledKeys) : new Set(), [
        props.disabledKeys
    ]);
    let [selectionBehavior, setSelectionBehavior] = (0, _react.useState)(selectionBehaviorProp);
    // If the selectionBehavior prop is set to replace, but the current state is toggle (e.g. due to long press
    // to enter selection mode on touch), and the selection becomes empty, reset the selection behavior.
    if (selectionBehaviorProp === "replace" && selectionBehavior === "toggle" && typeof selectedKeys === "object" && selectedKeys.size === 0) setSelectionBehavior("replace");
    // If the selectionBehavior prop changes, update the state as well.
    let lastSelectionBehavior = (0, _react.useRef)(selectionBehaviorProp);
    (0, _react.useEffect)(()=>{
        if (selectionBehaviorProp !== lastSelectionBehavior.current) {
            setSelectionBehavior(selectionBehaviorProp);
            lastSelectionBehavior.current = selectionBehaviorProp;
        }
    }, [
        selectionBehaviorProp
    ]);
    return {
        selectionMode,
        disallowEmptySelection,
        selectionBehavior,
        setSelectionBehavior,
        get isFocused () {
            return isFocusedRef.current;
        },
        setFocused (f) {
            isFocusedRef.current = f;
            setFocused(f);
        },
        get focusedKey () {
            return focusedKeyRef.current;
        },
        get childFocusStrategy () {
            return childFocusStrategyRef.current;
        },
        setFocusedKey (k, childFocusStrategy = "first") {
            focusedKeyRef.current = k;
            childFocusStrategyRef.current = childFocusStrategy;
            setFocusedKey(k);
        },
        selectedKeys,
        setSelectedKeys (keys) {
            if (allowDuplicateSelectionEvents || !equalSets(keys, selectedKeys)) setSelectedKeys(keys);
        },
        disabledKeys: disabledKeysProp,
        disabledBehavior
    };
}
function convertSelection(selection, defaultValue) {
    if (!selection) return defaultValue;
    return selection === "all" ? "all" : new (0, _selection.Selection)(selection);
}

},{"./Selection":"dexee","@react-stately/utils":"cpDPf","react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"dexee":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * A Selection is a special Set containing Keys, which also has an anchor
 * and current selected key for use when range selecting.
 */ parcelHelpers.export(exports, "Selection", ()=>Selection);
class Selection extends Set {
    constructor(keys, anchorKey, currentKey){
        super(keys);
        if (keys instanceof Selection) {
            this.anchorKey = anchorKey || keys.anchorKey;
            this.currentKey = currentKey || keys.currentKey;
        } else {
            this.anchorKey = anchorKey;
            this.currentKey = currentKey;
        }
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"kXpbx":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * An interface for reading and updating multiple selection state.
 */ parcelHelpers.export(exports, "SelectionManager", ()=>SelectionManager);
var _collections = require("@react-stately/collections");
var _selection = require("./Selection");
class SelectionManager {
    /**
   * The type of selection that is allowed in the collection.
   */ get selectionMode() {
        return this.state.selectionMode;
    }
    /**
   * Whether the collection allows empty selection.
   */ get disallowEmptySelection() {
        return this.state.disallowEmptySelection;
    }
    /**
   * The selection behavior for the collection.
   */ get selectionBehavior() {
        return this.state.selectionBehavior;
    }
    /**
   * Sets the selection behavior for the collection.
   */ setSelectionBehavior(selectionBehavior) {
        this.state.setSelectionBehavior(selectionBehavior);
    }
    /**
   * Whether the collection is currently focused.
   */ get isFocused() {
        return this.state.isFocused;
    }
    /**
   * Sets whether the collection is focused.
   */ setFocused(isFocused) {
        this.state.setFocused(isFocused);
    }
    /**
   * The current focused key in the collection.
   */ get focusedKey() {
        return this.state.focusedKey;
    }
    /** Whether the first or last child of the focused key should receive focus. */ get childFocusStrategy() {
        return this.state.childFocusStrategy;
    }
    /**
   * Sets the focused key.
   */ setFocusedKey(key, childFocusStrategy) {
        if (key == null || this.collection.getItem(key)) this.state.setFocusedKey(key, childFocusStrategy);
    }
    /**
   * The currently selected keys in the collection.
   */ get selectedKeys() {
        return this.state.selectedKeys === "all" ? new Set(this.getSelectAllKeys()) : this.state.selectedKeys;
    }
    /**
   * The raw selection value for the collection.
   * Either 'all' for select all, or a set of keys.
   */ get rawSelection() {
        return this.state.selectedKeys;
    }
    /**
   * Returns whether a key is selected.
   */ isSelected(key) {
        if (this.state.selectionMode === "none") return false;
        key = this.getKey(key);
        return this.state.selectedKeys === "all" ? this.canSelectItem(key) : this.state.selectedKeys.has(key);
    }
    /**
   * Whether the selection is empty.
   */ get isEmpty() {
        return this.state.selectedKeys !== "all" && this.state.selectedKeys.size === 0;
    }
    /**
   * Whether all items in the collection are selected.
   */ get isSelectAll() {
        if (this.isEmpty) return false;
        if (this.state.selectedKeys === "all") return true;
        if (this._isSelectAll != null) return this._isSelectAll;
        let allKeys = this.getSelectAllKeys();
        let selectedKeys = this.state.selectedKeys;
        this._isSelectAll = allKeys.every((k)=>selectedKeys.has(k));
        return this._isSelectAll;
    }
    get firstSelectedKey() {
        let first = null;
        for (let key of this.state.selectedKeys){
            let item = this.collection.getItem(key);
            if (!first || item && (0, _collections.compareNodeOrder)(this.collection, item, first) < 0) first = item;
        }
        return first === null || first === void 0 ? void 0 : first.key;
    }
    get lastSelectedKey() {
        let last = null;
        for (let key of this.state.selectedKeys){
            let item = this.collection.getItem(key);
            if (!last || item && (0, _collections.compareNodeOrder)(this.collection, item, last) > 0) last = item;
        }
        return last === null || last === void 0 ? void 0 : last.key;
    }
    get disabledKeys() {
        return this.state.disabledKeys;
    }
    get disabledBehavior() {
        return this.state.disabledBehavior;
    }
    /**
   * Extends the selection to the given key.
   */ extendSelection(toKey) {
        if (this.selectionMode === "none") return;
        if (this.selectionMode === "single") {
            this.replaceSelection(toKey);
            return;
        }
        toKey = this.getKey(toKey);
        let selection;
        // Only select the one key if coming from a select all.
        if (this.state.selectedKeys === "all") selection = new (0, _selection.Selection)([
            toKey
        ], toKey, toKey);
        else {
            let selectedKeys = this.state.selectedKeys;
            let anchorKey = selectedKeys.anchorKey || toKey;
            selection = new (0, _selection.Selection)(selectedKeys, anchorKey, toKey);
            for (let key of this.getKeyRange(anchorKey, selectedKeys.currentKey || toKey))selection.delete(key);
            for (let key of this.getKeyRange(toKey, anchorKey))if (this.canSelectItem(key)) selection.add(key);
        }
        this.state.setSelectedKeys(selection);
    }
    getKeyRange(from, to) {
        let fromItem = this.collection.getItem(from);
        let toItem = this.collection.getItem(to);
        if (fromItem && toItem) {
            if ((0, _collections.compareNodeOrder)(this.collection, fromItem, toItem) <= 0) return this.getKeyRangeInternal(from, to);
            return this.getKeyRangeInternal(to, from);
        }
        return [];
    }
    getKeyRangeInternal(from, to) {
        let keys = [];
        let key = from;
        while(key){
            let item = this.collection.getItem(key);
            if (item && item.type === "item" || item.type === "cell" && this.allowsCellSelection) keys.push(key);
            if (key === to) return keys;
            key = this.collection.getKeyAfter(key);
        }
        return [];
    }
    getKey(key) {
        let item = this.collection.getItem(key);
        if (!item) // ¯\_(ツ)_/¯
        return key;
        // If cell selection is allowed, just return the key.
        if (item.type === "cell" && this.allowsCellSelection) return key;
        // Find a parent item to select
        while(item.type !== "item" && item.parentKey != null)item = this.collection.getItem(item.parentKey);
        if (!item || item.type !== "item") return null;
        return item.key;
    }
    /**
   * Toggles whether the given key is selected.
   */ toggleSelection(key) {
        if (this.selectionMode === "none") return;
        if (this.selectionMode === "single" && !this.isSelected(key)) {
            this.replaceSelection(key);
            return;
        }
        key = this.getKey(key);
        if (key == null) return;
        let keys = new (0, _selection.Selection)(this.state.selectedKeys === "all" ? this.getSelectAllKeys() : this.state.selectedKeys);
        if (keys.has(key)) keys.delete(key);
        else if (this.canSelectItem(key)) {
            keys.add(key);
            keys.anchorKey = key;
            keys.currentKey = key;
        }
        if (this.disallowEmptySelection && keys.size === 0) return;
        this.state.setSelectedKeys(keys);
    }
    /**
   * Replaces the selection with only the given key.
   */ replaceSelection(key) {
        if (this.selectionMode === "none") return;
        key = this.getKey(key);
        if (key == null) return;
        let selection = this.canSelectItem(key) ? new (0, _selection.Selection)([
            key
        ], key, key) : new (0, _selection.Selection)();
        this.state.setSelectedKeys(selection);
    }
    /**
   * Replaces the selection with the given keys.
   */ setSelectedKeys(keys) {
        if (this.selectionMode === "none") return;
        let selection = new (0, _selection.Selection)();
        for (let key of keys){
            key = this.getKey(key);
            if (key != null) {
                selection.add(key);
                if (this.selectionMode === "single") break;
            }
        }
        this.state.setSelectedKeys(selection);
    }
    getSelectAllKeys() {
        let keys = [];
        let addKeys = (key)=>{
            while(key){
                if (this.canSelectItem(key)) {
                    let item = this.collection.getItem(key);
                    if (item.type === "item") keys.push(key);
                    // Add child keys. If cell selection is allowed, then include item children too.
                    if (item.hasChildNodes && (this.allowsCellSelection || item.type !== "item")) addKeys((0, _collections.getFirstItem)((0, _collections.getChildNodes)(item, this.collection)).key);
                }
                key = this.collection.getKeyAfter(key);
            }
        };
        addKeys(this.collection.getFirstKey());
        return keys;
    }
    /**
   * Selects all items in the collection.
   */ selectAll() {
        if (!this.isSelectAll && this.selectionMode === "multiple") this.state.setSelectedKeys("all");
    }
    /**
   * Removes all keys from the selection.
   */ clearSelection() {
        if (!this.disallowEmptySelection && (this.state.selectedKeys === "all" || this.state.selectedKeys.size > 0)) this.state.setSelectedKeys(new (0, _selection.Selection)());
    }
    /**
   * Toggles between select all and an empty selection.
   */ toggleSelectAll() {
        if (this.isSelectAll) this.clearSelection();
        else this.selectAll();
    }
    select(key, e) {
        if (this.selectionMode === "none") return;
        if (this.selectionMode === "single") {
            if (this.isSelected(key) && !this.disallowEmptySelection) this.toggleSelection(key);
            else this.replaceSelection(key);
        } else if (this.selectionBehavior === "toggle" || e && (e.pointerType === "touch" || e.pointerType === "virtual")) // if touch or virtual (VO) then we just want to toggle, otherwise it's impossible to multi select because they don't have modifier keys
        this.toggleSelection(key);
        else this.replaceSelection(key);
    }
    /**
   * Returns whether the current selection is equal to the given selection.
   */ isSelectionEqual(selection) {
        if (selection === this.state.selectedKeys) return true;
        // Check if the set of keys match.
        let selectedKeys = this.selectedKeys;
        if (selection.size !== selectedKeys.size) return false;
        for (let key of selection){
            if (!selectedKeys.has(key)) return false;
        }
        for (let key of selectedKeys){
            if (!selection.has(key)) return false;
        }
        return true;
    }
    canSelectItem(key) {
        if (this.state.selectionMode === "none" || this.state.disabledKeys.has(key)) return false;
        let item = this.collection.getItem(key);
        if (!item || item.type === "cell" && !this.allowsCellSelection) return false;
        return true;
    }
    isDisabled(key) {
        return this.state.disabledKeys.has(key) && this.state.disabledBehavior === "all";
    }
    isLink(key) {
        var _this_collection_getItem_props, _this_collection_getItem;
        return !!((_this_collection_getItem = this.collection.getItem(key)) === null || _this_collection_getItem === void 0 ? void 0 : (_this_collection_getItem_props = _this_collection_getItem.props) === null || _this_collection_getItem_props === void 0 ? void 0 : _this_collection_getItem_props.href);
    }
    constructor(collection, state, options){
        this.collection = collection;
        this.state = state;
        var _options_allowsCellSelection;
        this.allowsCellSelection = (_options_allowsCellSelection = options === null || options === void 0 ? void 0 : options.allowsCellSelection) !== null && _options_allowsCellSelection !== void 0 ? _options_allowsCellSelection : false;
        this._isSelectAll = null;
    }
}

},{"@react-stately/collections":"loANi","./Selection":"dexee","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"3bCqE":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides state management for list-like components with single selection.
 * Handles building a collection of items from props, and manages selection state.
 */ parcelHelpers.export(exports, "useSingleSelectListState", ()=>useSingleSelectListState);
var _useListState = require("./useListState");
var _utils = require("@react-stately/utils");
var _react = require("react");
function useSingleSelectListState(props) {
    var _props_defaultSelectedKey;
    let [selectedKey, setSelectedKey] = (0, _utils.useControlledState)(props.selectedKey, (_props_defaultSelectedKey = props.defaultSelectedKey) !== null && _props_defaultSelectedKey !== void 0 ? _props_defaultSelectedKey : null, props.onSelectionChange);
    let selectedKeys = (0, _react.useMemo)(()=>selectedKey != null ? [
            selectedKey
        ] : [], [
        selectedKey
    ]);
    let { collection, disabledKeys, selectionManager } = (0, _useListState.useListState)({
        ...props,
        selectionMode: "single",
        disallowEmptySelection: true,
        allowDuplicateSelectionEvents: true,
        selectedKeys,
        onSelectionChange: (keys)=>{
            var _keys_values_next_value;
            let key = (_keys_values_next_value = keys.values().next().value) !== null && _keys_values_next_value !== void 0 ? _keys_values_next_value : null;
            // Always fire onSelectionChange, even if the key is the same
            // as the current key (useControlledState does not).
            if (key === selectedKey && props.onSelectionChange) props.onSelectionChange(key);
            setSelectedKey(key);
        }
    });
    let selectedItem = selectedKey != null ? collection.getItem(selectedKey) : null;
    return {
        collection,
        disabledKeys,
        selectionManager,
        selectedKey,
        setSelectedKey,
        selectedItem
    };
}

},{"./useListState":"cgD4f","@react-stately/utils":"cpDPf","react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"5uxM4":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useOverlayTriggerState", ()=>(0, _useOverlayTriggerState.useOverlayTriggerState));
var _useOverlayTriggerState = require("./useOverlayTriggerState");

},{"./useOverlayTriggerState":"dXoXV","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"dXoXV":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Manages state for an overlay trigger. Tracks whether the overlay is open, and provides
 * methods to toggle this state.
 */ parcelHelpers.export(exports, "useOverlayTriggerState", ()=>useOverlayTriggerState);
var _react = require("react");
var _utils = require("@react-stately/utils");
function useOverlayTriggerState(props) {
    let [isOpen, setOpen] = (0, _utils.useControlledState)(props.isOpen, props.defaultOpen || false, props.onOpenChange);
    const open = (0, _react.useCallback)(()=>{
        setOpen(true);
    }, [
        setOpen
    ]);
    const close = (0, _react.useCallback)(()=>{
        setOpen(false);
    }, [
        setOpen
    ]);
    const toggle = (0, _react.useCallback)(()=>{
        setOpen(!isOpen);
    }, [
        setOpen,
        isOpen
    ]);
    return {
        isOpen,
        setOpen,
        open,
        close,
        toggle
    };
}

},{"react":"9yzVZ","@react-stately/utils":"cpDPf","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"ci7Mv":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useDatePickerState", ()=>(0, _useDatePickerState.useDatePickerState));
parcelHelpers.export(exports, "useDateFieldState", ()=>(0, _useDateFieldState.useDateFieldState));
parcelHelpers.export(exports, "useDateRangePickerState", ()=>(0, _useDateRangePickerState.useDateRangePickerState));
parcelHelpers.export(exports, "useTimeFieldState", ()=>(0, _useTimeFieldState.useTimeFieldState));
var _useDatePickerState = require("./useDatePickerState");
var _useDateFieldState = require("./useDateFieldState");
var _useDateRangePickerState = require("./useDateRangePickerState");
var _useTimeFieldState = require("./useTimeFieldState");

},{"./useDatePickerState":"dQcZq","./useDateFieldState":"fyiOZ","./useDateRangePickerState":"llySa","./useTimeFieldState":"5rVnT","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"dQcZq":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides state management for a date picker component.
 * A date picker combines a DateField and a Calendar popover to allow users to enter or select a date and time value.
 */ parcelHelpers.export(exports, "useDatePickerState", ()=>useDatePickerState);
var _date = require("@internationalized/date");
var _utils = require("./utils");
var _form = require("@react-stately/form");
var _overlays = require("@react-stately/overlays");
var _utils1 = require("@react-stately/utils");
var _react = require("react");
function useDatePickerState(props) {
    let overlayState = (0, _overlays.useOverlayTriggerState)(props);
    let [value, setValue] = (0, _utils1.useControlledState)(props.value, props.defaultValue || null, props.onChange);
    let v = value || props.placeholderValue;
    let [granularity, defaultTimeZone] = (0, _utils.useDefaultProps)(v, props.granularity);
    let dateValue = value != null ? value.toDate(defaultTimeZone !== null && defaultTimeZone !== void 0 ? defaultTimeZone : "UTC") : null;
    let hasTime = granularity === "hour" || granularity === "minute" || granularity === "second";
    var _props_shouldCloseOnSelect;
    let shouldCloseOnSelect = (_props_shouldCloseOnSelect = props.shouldCloseOnSelect) !== null && _props_shouldCloseOnSelect !== void 0 ? _props_shouldCloseOnSelect : true;
    let [selectedDate, setSelectedDate] = (0, _react.useState)(null);
    let [selectedTime, setSelectedTime] = (0, _react.useState)(null);
    if (value) {
        selectedDate = value;
        if ("hour" in value) selectedTime = value;
    }
    // props.granularity must actually exist in the value if one is provided.
    if (v && !(granularity in v)) throw new Error("Invalid granularity " + granularity + " for value " + v.toString());
    let showEra = (value === null || value === void 0 ? void 0 : value.calendar.identifier) === "gregory" && value.era === "BC";
    let formatOpts = (0, _react.useMemo)(()=>({
            granularity,
            timeZone: defaultTimeZone,
            hideTimeZone: props.hideTimeZone,
            hourCycle: props.hourCycle,
            shouldForceLeadingZeros: props.shouldForceLeadingZeros,
            showEra
        }), [
        granularity,
        props.hourCycle,
        props.shouldForceLeadingZeros,
        defaultTimeZone,
        props.hideTimeZone,
        showEra
    ]);
    let { minValue, maxValue, isDateUnavailable } = props;
    let builtinValidation = (0, _react.useMemo)(()=>(0, _utils.getValidationResult)(value, minValue, maxValue, isDateUnavailable, formatOpts), [
        value,
        minValue,
        maxValue,
        isDateUnavailable,
        formatOpts
    ]);
    let validation = (0, _form.useFormValidationState)({
        ...props,
        value,
        builtinValidation
    });
    let isValueInvalid = validation.displayValidation.isInvalid;
    let validationState = props.validationState || (isValueInvalid ? "invalid" : null);
    let commitValue = (date, time)=>{
        setValue("timeZone" in time ? time.set((0, _date.toCalendarDate)(date)) : (0, _date.toCalendarDateTime)(date, time));
        setSelectedDate(null);
        setSelectedTime(null);
        validation.commitValidation();
    };
    // Intercept setValue to make sure the Time section is not changed by date selection in Calendar
    let selectDate = (newValue)=>{
        let shouldClose = typeof shouldCloseOnSelect === "function" ? shouldCloseOnSelect() : shouldCloseOnSelect;
        if (hasTime) {
            if (selectedTime || shouldClose) commitValue(newValue, selectedTime || (0, _utils.getPlaceholderTime)(props.placeholderValue));
            else setSelectedDate(newValue);
        } else {
            setValue(newValue);
            validation.commitValidation();
        }
        if (shouldClose) overlayState.setOpen(false);
    };
    let selectTime = (newValue)=>{
        if (selectedDate && newValue) commitValue(selectedDate, newValue);
        else setSelectedTime(newValue);
    };
    return {
        ...validation,
        value,
        setValue,
        dateValue: selectedDate,
        timeValue: selectedTime,
        setDateValue: selectDate,
        setTimeValue: selectTime,
        granularity,
        hasTime,
        ...overlayState,
        setOpen (isOpen) {
            // Commit the selected date when the calendar is closed. Use a placeholder time if one wasn't set.
            // If only the time was set and not the date, don't commit. The state will be preserved until
            // the user opens the popover again.
            if (!isOpen && !value && selectedDate && hasTime) commitValue(selectedDate, selectedTime || (0, _utils.getPlaceholderTime)(props.placeholderValue));
            overlayState.setOpen(isOpen);
        },
        validationState,
        isInvalid: isValueInvalid,
        formatValue (locale, fieldOptions) {
            if (!dateValue) return "";
            let formatOptions = (0, _utils.getFormatOptions)(fieldOptions, formatOpts);
            let formatter = new (0, _date.DateFormatter)(locale, formatOptions);
            return formatter.format(dateValue);
        }
    };
}

},{"@internationalized/date":"hesBk","./utils":"78Io6","@react-stately/form":"9yZqm","@react-stately/overlays":"5uxM4","@react-stately/utils":"cpDPf","react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"78Io6":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getValidationResult", ()=>getValidationResult);
parcelHelpers.export(exports, "getRangeValidationResult", ()=>getRangeValidationResult);
parcelHelpers.export(exports, "getFormatOptions", ()=>getFormatOptions);
parcelHelpers.export(exports, "getPlaceholderTime", ()=>getPlaceholderTime);
parcelHelpers.export(exports, "convertValue", ()=>convertValue);
parcelHelpers.export(exports, "createPlaceholderDate", ()=>createPlaceholderDate);
parcelHelpers.export(exports, "useDefaultProps", ()=>useDefaultProps);
var _date = require("@internationalized/date");
// @ts-ignore
var _json = require("../intl/*.json");
var _jsonDefault = parcelHelpers.interopDefault(_json);
var _string = require("@internationalized/string");
var _form = require("@react-stately/form");
var _react = require("react");
const dictionary = new (0, _string.LocalizedStringDictionary)((0, _jsonDefault.default));
function getLocale() {
    // Match browser language setting here, NOT react-aria's I18nProvider, so that we match other browser-provided
    // validation messages, which to not respect our provider's language.
    // @ts-ignore
    return typeof navigator !== "undefined" && (navigator.language || navigator.userLanguage) || "en-US";
}
function getValidationResult(value, minValue, maxValue, isDateUnavailable, options) {
    let rangeOverflow = value != null && maxValue != null && value.compare(maxValue) > 0;
    let rangeUnderflow = value != null && minValue != null && value.compare(minValue) < 0;
    let isUnavailable = value != null && (isDateUnavailable === null || isDateUnavailable === void 0 ? void 0 : isDateUnavailable(value)) || false;
    let isInvalid = rangeOverflow || rangeUnderflow || isUnavailable;
    let errors = [];
    if (isInvalid) {
        let locale = getLocale();
        let strings = (0, _string.LocalizedStringDictionary).getGlobalDictionaryForPackage("@react-stately/datepicker") || dictionary;
        let formatter = new (0, _string.LocalizedStringFormatter)(locale, strings);
        let dateFormatter = new (0, _date.DateFormatter)(locale, getFormatOptions({}, options));
        let timeZone = dateFormatter.resolvedOptions().timeZone;
        if (rangeUnderflow) errors.push(formatter.format("rangeUnderflow", {
            minValue: dateFormatter.format(minValue.toDate(timeZone))
        }));
        if (rangeOverflow) errors.push(formatter.format("rangeOverflow", {
            maxValue: dateFormatter.format(maxValue.toDate(timeZone))
        }));
        if (isUnavailable) errors.push(formatter.format("unavailableDate"));
    }
    return {
        isInvalid,
        validationErrors: errors,
        validationDetails: {
            badInput: isUnavailable,
            customError: false,
            patternMismatch: false,
            rangeOverflow,
            rangeUnderflow,
            stepMismatch: false,
            tooLong: false,
            tooShort: false,
            typeMismatch: false,
            valueMissing: false,
            valid: !isInvalid
        }
    };
}
function getRangeValidationResult(value, minValue, maxValue, isDateUnavailable, options) {
    let startValidation = getValidationResult(value === null || value === void 0 ? void 0 : value.start, minValue, maxValue, isDateUnavailable, options);
    let endValidation = getValidationResult(value === null || value === void 0 ? void 0 : value.end, minValue, maxValue, isDateUnavailable, options);
    let result = (0, _form.mergeValidation)(startValidation, endValidation);
    if (value.end != null && value.start != null && value.end.compare(value.start) < 0) result = (0, _form.mergeValidation)(result, {
        isInvalid: true,
        validationErrors: [
            dictionary.getStringForLocale("rangeReversed", getLocale())
        ],
        validationDetails: {
            ...(0, _form.VALID_VALIDITY_STATE),
            rangeUnderflow: true,
            rangeOverflow: true,
            valid: false
        }
    });
    return result;
}
const DEFAULT_FIELD_OPTIONS = {
    year: "numeric",
    month: "numeric",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
    second: "2-digit"
};
const TWO_DIGIT_FIELD_OPTIONS = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit"
};
function getFormatOptions(fieldOptions, options) {
    let defaultFieldOptions = options.shouldForceLeadingZeros ? TWO_DIGIT_FIELD_OPTIONS : DEFAULT_FIELD_OPTIONS;
    fieldOptions = {
        ...defaultFieldOptions,
        ...fieldOptions
    };
    let granularity = options.granularity || "minute";
    let keys = Object.keys(fieldOptions);
    var _options_maxGranularity;
    let startIdx = keys.indexOf((_options_maxGranularity = options.maxGranularity) !== null && _options_maxGranularity !== void 0 ? _options_maxGranularity : "year");
    if (startIdx < 0) startIdx = 0;
    let endIdx = keys.indexOf(granularity);
    if (endIdx < 0) endIdx = 2;
    if (startIdx > endIdx) throw new Error("maxGranularity must be greater than granularity");
    let opts = keys.slice(startIdx, endIdx + 1).reduce((opts, key)=>{
        opts[key] = fieldOptions[key];
        return opts;
    }, {});
    if (options.hourCycle != null) opts.hour12 = options.hourCycle === 12;
    opts.timeZone = options.timeZone || "UTC";
    let hasTime = granularity === "hour" || granularity === "minute" || granularity === "second";
    if (hasTime && options.timeZone && !options.hideTimeZone) opts.timeZoneName = "short";
    if (options.showEra && startIdx === 0) opts.era = "short";
    return opts;
}
function getPlaceholderTime(placeholderValue) {
    if (placeholderValue && "hour" in placeholderValue) return placeholderValue;
    return new (0, _date.Time)();
}
function convertValue(value, calendar) {
    if (value === null) return null;
    if (!value) return undefined;
    return (0, _date.toCalendar)(value, calendar);
}
function createPlaceholderDate(placeholderValue, granularity, calendar, timeZone) {
    if (placeholderValue) return convertValue(placeholderValue, calendar);
    let date = (0, _date.toCalendar)((0, _date.now)(timeZone).set({
        hour: 0,
        minute: 0,
        second: 0,
        millisecond: 0
    }), calendar);
    if (granularity === "year" || granularity === "month" || granularity === "day") return (0, _date.toCalendarDate)(date);
    if (!timeZone) return (0, _date.toCalendarDateTime)(date);
    return date;
}
function useDefaultProps(v, granularity) {
    // Compute default granularity and time zone from the value. If the value becomes null, keep the last values.
    let defaultTimeZone = v && "timeZone" in v ? v.timeZone : undefined;
    let defaultGranularity = v && "minute" in v ? "minute" : "day";
    // props.granularity must actually exist in the value if one is provided.
    if (v && granularity && !(granularity in v)) throw new Error("Invalid granularity " + granularity + " for value " + v.toString());
    let [lastValue, setLastValue] = (0, _react.useState)([
        defaultGranularity,
        defaultTimeZone
    ]);
    // If the granularity or time zone changed, update the last value.
    if (v && (lastValue[0] !== defaultGranularity || lastValue[1] !== defaultTimeZone)) setLastValue([
        defaultGranularity,
        defaultTimeZone
    ]);
    if (!granularity) granularity = v ? defaultGranularity : lastValue[0];
    let timeZone = v ? defaultTimeZone : lastValue[1];
    return [
        granularity,
        timeZone
    ];
}

},{"@internationalized/date":"hesBk","../intl/*.json":"ai5tt","@internationalized/string":"3QbrG","@react-stately/form":"9yZqm","react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"ai5tt":[function(require,module,exports) {
const _temp0 = require("4cf87886ed904fe1");
const _temp1 = require("8f39ea57a785c249");
const _temp2 = require("f79fae923340490f");
const _temp3 = require("70a5294a4ad6db9");
const _temp4 = require("b2bfb191cb3593c5");
const _temp5 = require("c2d8eee642057e06");
const _temp6 = require("94051ac11492877c");
const _temp7 = require("4acc308fea9c0f1f");
const _temp8 = require("3de3c21d03036680");
const _temp9 = require("b9c3fc4628169b97");
const _temp10 = require("b71b6173f9cd4537");
const _temp11 = require("a0c128811ffbb38c");
const _temp12 = require("b3d3e34e847bcfc6");
const _temp13 = require("d473c912c46b0fef");
const _temp14 = require("96828565e4c76239");
const _temp15 = require("fcacce5e5d67844e");
const _temp16 = require("6d89521cc9134edd");
const _temp17 = require("340b5ae2b189d95f");
const _temp18 = require("78245fd28dbf1c41");
const _temp19 = require("6dee511f64d67b5e");
const _temp20 = require("81a7a2497a92b00c");
const _temp21 = require("7b91971ea946b9bc");
const _temp22 = require("8027718aedce35e7");
const _temp23 = require("1f5baeccbedc598");
const _temp24 = require("54da2c2d8fbc4fc4");
const _temp25 = require("55a7f4c124eeac64");
const _temp26 = require("24b8ce95303eebf7");
const _temp27 = require("df97b60e798b3b8f");
const _temp28 = require("199f2f775b51d4a5");
const _temp29 = require("81f8d607c3e23a8e");
const _temp30 = require("de21577cda6af50b");
const _temp31 = require("de2f87ac01a71c15");
const _temp32 = require("9ad6aa80922f9322");
const _temp33 = require("4103e6084b1acdca");
module.exports = {
    "ar-AE": _temp0,
    "bg-BG": _temp1,
    "cs-CZ": _temp2,
    "da-DK": _temp3,
    "de-DE": _temp4,
    "el-GR": _temp5,
    "en-US": _temp6,
    "es-ES": _temp7,
    "et-EE": _temp8,
    "fi-FI": _temp9,
    "fr-FR": _temp10,
    "he-IL": _temp11,
    "hr-HR": _temp12,
    "hu-HU": _temp13,
    "it-IT": _temp14,
    "ja-JP": _temp15,
    "ko-KR": _temp16,
    "lt-LT": _temp17,
    "lv-LV": _temp18,
    "nb-NO": _temp19,
    "nl-NL": _temp20,
    "pl-PL": _temp21,
    "pt-BR": _temp22,
    "pt-PT": _temp23,
    "ro-RO": _temp24,
    "ru-RU": _temp25,
    "sk-SK": _temp26,
    "sl-SI": _temp27,
    "sr-SP": _temp28,
    "sv-SE": _temp29,
    "tr-TR": _temp30,
    "uk-UA": _temp31,
    "zh-CN": _temp32,
    "zh-TW": _temp33
};

},{"4cf87886ed904fe1":"79eqt","8f39ea57a785c249":"kQ8hw","f79fae923340490f":"DNfMC","70a5294a4ad6db9":"1zRPr","b2bfb191cb3593c5":"501Rv","c2d8eee642057e06":"cyFkt","94051ac11492877c":"6Muge","4acc308fea9c0f1f":"2VJxy","3de3c21d03036680":"7XPhI","b9c3fc4628169b97":"5UNzJ","b71b6173f9cd4537":"gkoAB","a0c128811ffbb38c":"kUzD3","b3d3e34e847bcfc6":"iuufl","d473c912c46b0fef":"5wpHb","96828565e4c76239":"3S5kQ","fcacce5e5d67844e":"fuLjJ","6d89521cc9134edd":"kb2xO","340b5ae2b189d95f":"4HFm8","78245fd28dbf1c41":"2LObN","6dee511f64d67b5e":"H8537","81a7a2497a92b00c":"7ina2","7b91971ea946b9bc":"3mrPw","8027718aedce35e7":"5o1IO","1f5baeccbedc598":"45jQF","54da2c2d8fbc4fc4":"2x835","55a7f4c124eeac64":"g70RJ","24b8ce95303eebf7":"hCxKH","df97b60e798b3b8f":"dm8AC","199f2f775b51d4a5":"c4DBI","81f8d607c3e23a8e":"4QD8t","de21577cda6af50b":"kWSee","de2f87ac01a71c15":"7a7eg","9ad6aa80922f9322":"3zF17","4103e6084b1acdca":"hhCHp"}],"79eqt":[function(require,module,exports) {
module.exports = {
    "rangeOverflow": (args)=>`\u{64A}\u{62C}\u{628} \u{623}\u{646} \u{62A}\u{643}\u{648}\u{646} \u{627}\u{644}\u{642}\u{64A}\u{645}\u{629} ${args.maxValue} \u{623}\u{648} \u{642}\u{628}\u{644} \u{630}\u{644}\u{643}.`,
    "rangeReversed": `\u{62A}\u{627}\u{631}\u{64A}\u{62E} \u{627}\u{644}\u{628}\u{62F}\u{621} \u{64A}\u{62C}\u{628} \u{623}\u{646} \u{64A}\u{643}\u{648}\u{646} \u{642}\u{628}\u{644} \u{62A}\u{627}\u{631}\u{64A}\u{62E} \u{627}\u{644}\u{627}\u{646}\u{62A}\u{647}\u{627}\u{621}.`,
    "rangeUnderflow": (args)=>`\u{64A}\u{62C}\u{628} \u{623}\u{646} \u{62A}\u{643}\u{648}\u{646} \u{627}\u{644}\u{642}\u{64A}\u{645}\u{629} ${args.minValue} \u{623}\u{648} \u{628}\u{639}\u{62F} \u{630}\u{644}\u{643}.`,
    "unavailableDate": `\u{627}\u{644}\u{628}\u{64A}\u{627}\u{646}\u{627}\u{62A} \u{627}\u{644}\u{645}\u{62D}\u{62F}\u{62F}\u{629} \u{63A}\u{64A}\u{631} \u{645}\u{62A}\u{627}\u{62D}\u{629}.`
};

},{}],"kQ8hw":[function(require,module,exports) {
module.exports = {
    "rangeOverflow": (args)=>`\u{421}\u{442}\u{43E}\u{439}\u{43D}\u{43E}\u{441}\u{442}\u{442}\u{430} \u{442}\u{440}\u{44F}\u{431}\u{432}\u{430} \u{434}\u{430} \u{435} ${args.maxValue} \u{438}\u{43B}\u{438} \u{43F}\u{43E}-\u{440}\u{430}\u{43D}\u{43D}\u{430}.`,
    "rangeReversed": `\u{41D}\u{430}\u{447}\u{430}\u{43B}\u{43D}\u{430}\u{442}\u{430} \u{434}\u{430}\u{442}\u{430} \u{442}\u{440}\u{44F}\u{431}\u{432}\u{430} \u{434}\u{430} \u{435} \u{43F}\u{440}\u{435}\u{434}\u{438} \u{43A}\u{440}\u{430}\u{439}\u{43D}\u{430}\u{442}\u{430}.`,
    "rangeUnderflow": (args)=>`\u{421}\u{442}\u{43E}\u{439}\u{43D}\u{43E}\u{441}\u{442}\u{442}\u{430} \u{442}\u{440}\u{44F}\u{431}\u{432}\u{430} \u{434}\u{430} \u{435} ${args.minValue} \u{438}\u{43B}\u{438} \u{43F}\u{43E}-\u{43A}\u{44A}\u{441}\u{43D}\u{43E}.`,
    "unavailableDate": `\u{418}\u{437}\u{431}\u{440}\u{430}\u{43D}\u{430}\u{442}\u{430} \u{434}\u{430}\u{442}\u{430} \u{43D}\u{435} \u{435} \u{43D}\u{430}\u{43B}\u{438}\u{447}\u{43D}\u{430}.`
};

},{}],"DNfMC":[function(require,module,exports) {
module.exports = {
    "rangeOverflow": (args)=>`Hodnota mus\xed b\xfdt ${args.maxValue} nebo d\u{159}\xedv\u{11B}j\u{161}\xed.`,
    "rangeReversed": `Datum zah\xe1jen\xed mus\xed p\u{159}edch\xe1zet datu ukon\u{10D}en\xed.`,
    "rangeUnderflow": (args)=>`Hodnota mus\xed b\xfdt ${args.minValue} nebo pozd\u{11B}j\u{161}\xed.`,
    "unavailableDate": `Vybran\xe9 datum nen\xed k dispozici.`
};

},{}],"1zRPr":[function(require,module,exports) {
module.exports = {
    "rangeOverflow": (args)=>`V\xe6rdien skal v\xe6re ${args.maxValue} eller tidligere.`,
    "rangeReversed": `Startdatoen skal v\xe6re f\xf8r slutdatoen.`,
    "rangeUnderflow": (args)=>`V\xe6rdien skal v\xe6re ${args.minValue} eller nyere.`,
    "unavailableDate": `Den valgte dato er ikke tilg\xe6ngelig.`
};

},{}],"501Rv":[function(require,module,exports) {
module.exports = {
    "rangeOverflow": (args)=>`Der Wert muss ${args.maxValue} oder fr\xfcher sein.`,
    "rangeReversed": `Das Anfangsdatum muss vor dem Enddatum liegen.`,
    "rangeUnderflow": (args)=>`Der Wert muss ${args.minValue} oder sp\xe4ter sein.`,
    "unavailableDate": `Das ausgew\xe4hlte Datum ist nicht verf\xfcgbar.`
};

},{}],"cyFkt":[function(require,module,exports) {
module.exports = {
    "rangeOverflow": (args)=>`\u{397} \u{3C4}\u{3B9}\u{3BC}\u{3AE} \u{3C0}\u{3C1}\u{3AD}\u{3C0}\u{3B5}\u{3B9} \u{3BD}\u{3B1} \u{3B5}\u{3AF}\u{3BD}\u{3B1}\u{3B9} ${args.maxValue} \u{3AE} \u{3C0}\u{3B1}\u{3BB}\u{3B1}\u{3B9}\u{3CC}\u{3C4}\u{3B5}\u{3C1}\u{3B7}.`,
    "rangeReversed": `\u{397} \u{3B7}\u{3BC}\u{3B5}\u{3C1}\u{3BF}\u{3BC}\u{3B7}\u{3BD}\u{3AF}\u{3B1} \u{3AD}\u{3BD}\u{3B1}\u{3C1}\u{3BE}\u{3B7}\u{3C2} \u{3C0}\u{3C1}\u{3AD}\u{3C0}\u{3B5}\u{3B9} \u{3BD}\u{3B1} \u{3B5}\u{3AF}\u{3BD}\u{3B1}\u{3B9} \u{3C0}\u{3C1}\u{3B9}\u{3BD} \u{3B1}\u{3C0}\u{3CC} \u{3C4}\u{3B7}\u{3BD} \u{3B7}\u{3BC}\u{3B5}\u{3C1}\u{3BF}\u{3BC}\u{3B7}\u{3BD}\u{3AF}\u{3B1} \u{3BB}\u{3AE}\u{3BE}\u{3B7}\u{3C2}.`,
    "rangeUnderflow": (args)=>`\u{397} \u{3C4}\u{3B9}\u{3BC}\u{3AE} \u{3C0}\u{3C1}\u{3AD}\u{3C0}\u{3B5}\u{3B9} \u{3BD}\u{3B1} \u{3B5}\u{3AF}\u{3BD}\u{3B1}\u{3B9} ${args.minValue} \u{3AE} \u{3BC}\u{3B5}\u{3C4}\u{3B1}\u{3B3}\u{3B5}\u{3BD}\u{3AD}\u{3C3}\u{3C4}\u{3B5}\u{3C1}\u{3B7}.`,
    "unavailableDate": `\u{397} \u{3B5}\u{3C0}\u{3B9}\u{3BB}\u{3B5}\u{3B3}\u{3BC}\u{3AD}\u{3BD}\u{3B7} \u{3B7}\u{3BC}\u{3B5}\u{3C1}\u{3BF}\u{3BC}\u{3B7}\u{3BD}\u{3AF}\u{3B1} \u{3B4}\u{3B5}\u{3BD} \u{3B5}\u{3AF}\u{3BD}\u{3B1}\u{3B9} \u{3B4}\u{3B9}\u{3B1}\u{3B8}\u{3AD}\u{3C3}\u{3B9}\u{3BC}\u{3B7}.`
};

},{}],"6Muge":[function(require,module,exports) {
module.exports = {
    "rangeUnderflow": (args)=>`Value must be ${args.minValue} or later.`,
    "rangeOverflow": (args)=>`Value must be ${args.maxValue} or earlier.`,
    "rangeReversed": `Start date must be before end date.`,
    "unavailableDate": `Selected date unavailable.`
};

},{}],"2VJxy":[function(require,module,exports) {
module.exports = {
    "rangeOverflow": (args)=>`El valor debe ser ${args.maxValue} o anterior.`,
    "rangeReversed": `La fecha de inicio debe ser anterior a la fecha de finalizaci\xf3n.`,
    "rangeUnderflow": (args)=>`El valor debe ser ${args.minValue} o posterior.`,
    "unavailableDate": `Fecha seleccionada no disponible.`
};

},{}],"7XPhI":[function(require,module,exports) {
module.exports = {
    "rangeOverflow": (args)=>`V\xe4\xe4rtus peab olema ${args.maxValue} v\xf5i varasem.`,
    "rangeReversed": `Alguskuup\xe4ev peab olema enne l\xf5ppkuup\xe4eva.`,
    "rangeUnderflow": (args)=>`V\xe4\xe4rtus peab olema ${args.minValue} v\xf5i hilisem.`,
    "unavailableDate": `Valitud kuup\xe4ev pole saadaval.`
};

},{}],"5UNzJ":[function(require,module,exports) {
module.exports = {
    "rangeOverflow": (args)=>`Arvon on oltava ${args.maxValue} tai sit\xe4 aikaisempi.`,
    "rangeReversed": `Aloitusp\xe4iv\xe4n on oltava ennen lopetusp\xe4iv\xe4\xe4.`,
    "rangeUnderflow": (args)=>`Arvon on oltava ${args.minValue} tai sit\xe4 my\xf6h\xe4isempi.`,
    "unavailableDate": `Valittu p\xe4iv\xe4m\xe4\xe4r\xe4 ei ole k\xe4ytett\xe4viss\xe4.`
};

},{}],"gkoAB":[function(require,module,exports) {
module.exports = {
    "rangeOverflow": (args)=>`La valeur doit \xeatre ${args.maxValue} ou ant\xe9rieure.`,
    "rangeReversed": `La date de d\xe9but doit \xeatre ant\xe9rieure \xe0 la date de fin.`,
    "rangeUnderflow": (args)=>`La valeur doit \xeatre ${args.minValue} ou ult\xe9rieure.`,
    "unavailableDate": `La date s\xe9lectionn\xe9e n\u{2019}est pas disponible.`
};

},{}],"kUzD3":[function(require,module,exports) {
module.exports = {
    "rangeOverflow": (args)=>`\u{5D4}\u{5E2}\u{5E8}\u{5DA} \u{5D7}\u{5D9}\u{5D9}\u{5D1} \u{5DC}\u{5D4}\u{5D9}\u{5D5}\u{5EA} ${args.maxValue} \u{5D0}\u{5D5} \u{5DE}\u{5D5}\u{5E7}\u{5D3}\u{5DD} \u{5D9}\u{5D5}\u{5EA}\u{5E8}.`,
    "rangeReversed": `\u{5EA}\u{5D0}\u{5E8}\u{5D9}\u{5DA} \u{5D4}\u{5D4}\u{5EA}\u{5D7}\u{5DC}\u{5D4} \u{5D7}\u{5D9}\u{5D9}\u{5D1} \u{5DC}\u{5D4}\u{5D9}\u{5D5}\u{5EA} \u{5DC}\u{5E4}\u{5E0}\u{5D9} \u{5EA}\u{5D0}\u{5E8}\u{5D9}\u{5DA} \u{5D4}\u{5E1}\u{5D9}\u{5D5}\u{5DD}.`,
    "rangeUnderflow": (args)=>`\u{5D4}\u{5E2}\u{5E8}\u{5DA} \u{5D7}\u{5D9}\u{5D9}\u{5D1} \u{5DC}\u{5D4}\u{5D9}\u{5D5}\u{5EA} ${args.minValue} \u{5D0}\u{5D5} \u{5DE}\u{5D0}\u{5D5}\u{5D7}\u{5E8} \u{5D9}\u{5D5}\u{5EA}\u{5E8}.`,
    "unavailableDate": `\u{5D4}\u{5EA}\u{5D0}\u{5E8}\u{5D9}\u{5DA} \u{5D4}\u{5E0}\u{5D1}\u{5D7}\u{5E8} \u{5D0}\u{5D9}\u{5E0}\u{5D5} \u{5D6}\u{5DE}\u{5D9}\u{5DF}.`
};

},{}],"iuufl":[function(require,module,exports) {
module.exports = {
    "rangeOverflow": (args)=>`Vrijednost mora biti ${args.maxValue} ili ranije.`,
    "rangeReversed": `Datum po\u{10D}etka mora biti prije datuma zavr\u{161}etka.`,
    "rangeUnderflow": (args)=>`Vrijednost mora biti ${args.minValue} ili kasnije.`,
    "unavailableDate": `Odabrani datum nije dostupan.`
};

},{}],"5wpHb":[function(require,module,exports) {
module.exports = {
    "rangeOverflow": (args)=>`Az \xe9rt\xe9knek ${args.maxValue} vagy kor\xe1bbinak kell lennie.`,
    "rangeReversed": `A kezd\u{151} d\xe1tumnak a befejez\u{151} d\xe1tumn\xe1l kor\xe1bbinak kell lennie.`,
    "rangeUnderflow": (args)=>`Az \xe9rt\xe9knek ${args.minValue} vagy k\xe9s\u{151}bbinek kell lennie.`,
    "unavailableDate": `A kiv\xe1lasztott d\xe1tum nem \xe9rhet\u{151} el.`
};

},{}],"3S5kQ":[function(require,module,exports) {
module.exports = {
    "rangeOverflow": (args)=>`Il valore deve essere ${args.maxValue} o precedente.`,
    "rangeReversed": `La data di inizio deve essere antecedente alla data di fine.`,
    "rangeUnderflow": (args)=>`Il valore deve essere ${args.minValue} o successivo.`,
    "unavailableDate": `Data selezionata non disponibile.`
};

},{}],"fuLjJ":[function(require,module,exports) {
module.exports = {
    "rangeOverflow": (args)=>`\u{5024}\u{306F} ${args.maxValue} \u{4EE5}\u{4E0B}\u{306B}\u{3059}\u{308B}\u{5FC5}\u{8981}\u{304C}\u{3042}\u{308A}\u{307E}\u{3059}\u{3002}`,
    "rangeReversed": `\u{958B}\u{59CB}\u{65E5}\u{306F}\u{7D42}\u{4E86}\u{65E5}\u{3088}\u{308A}\u{524D}\u{306B}\u{3059}\u{308B}\u{5FC5}\u{8981}\u{304C}\u{3042}\u{308A}\u{307E}\u{3059}\u{3002}`,
    "rangeUnderflow": (args)=>`\u{5024}\u{306F} ${args.minValue} \u{4EE5}\u{4E0A}\u{306B}\u{3059}\u{308B}\u{5FC5}\u{8981}\u{304C}\u{3042}\u{308A}\u{307E}\u{3059}\u{3002}`,
    "unavailableDate": `\u{9078}\u{629E}\u{3057}\u{305F}\u{65E5}\u{4ED8}\u{306F}\u{4F7F}\u{7528}\u{3067}\u{304D}\u{307E}\u{305B}\u{3093}\u{3002}`
};

},{}],"kb2xO":[function(require,module,exports) {
module.exports = {
    "rangeOverflow": (args)=>`\u{AC12}\u{C740} ${args.maxValue} \u{C774}\u{C804}\u{C774}\u{C5B4}\u{C57C} \u{D569}\u{B2C8}\u{B2E4}.`,
    "rangeReversed": `\u{C2DC}\u{C791}\u{C77C}\u{C740} \u{C885}\u{B8CC}\u{C77C} \u{C774}\u{C804}\u{C774}\u{C5B4}\u{C57C} \u{D569}\u{B2C8}\u{B2E4}.`,
    "rangeUnderflow": (args)=>`\u{AC12}\u{C740} ${args.minValue} \u{C774}\u{C0C1}\u{C774}\u{C5B4}\u{C57C} \u{D569}\u{B2C8}\u{B2E4}.`,
    "unavailableDate": `\u{C120}\u{D0DD}\u{D55C} \u{B0A0}\u{C9DC}\u{B97C} \u{C0AC}\u{C6A9}\u{D560} \u{C218} \u{C5C6}\u{C2B5}\u{B2C8}\u{B2E4}.`
};

},{}],"4HFm8":[function(require,module,exports) {
module.exports = {
    "rangeOverflow": (args)=>`Reik\u{161}m\u{117} turi b\u{16B}ti ${args.maxValue} arba ankstesn\u{117}.`,
    "rangeReversed": `Prad\u{17E}ios data turi b\u{16B}ti ankstesn\u{117} nei pabaigos data.`,
    "rangeUnderflow": (args)=>`Reik\u{161}m\u{117} turi b\u{16B}ti ${args.minValue} arba naujesn\u{117}.`,
    "unavailableDate": `Pasirinkta data nepasiekiama.`
};

},{}],"2LObN":[function(require,module,exports) {
module.exports = {
    "rangeOverflow": (args)=>`V\u{113}rt\u{12B}bai ir j\u{101}b\u{16B}t ${args.maxValue} vai agr\u{101}kai.`,
    "rangeReversed": `S\u{101}kuma datumam ir j\u{101}b\u{16B}t pirms beigu datuma.`,
    "rangeUnderflow": (args)=>`V\u{113}rt\u{12B}bai ir j\u{101}b\u{16B}t ${args.minValue} vai v\u{113}l\u{101}kai.`,
    "unavailableDate": `Atlas\u{12B}tais datums nav pieejams.`
};

},{}],"H8537":[function(require,module,exports) {
module.exports = {
    "rangeOverflow": (args)=>`Verdien m\xe5 v\xe6re ${args.maxValue} eller tidligere.`,
    "rangeReversed": `Startdatoen m\xe5 v\xe6re f\xf8r sluttdatoen.`,
    "rangeUnderflow": (args)=>`Verdien m\xe5 v\xe6re ${args.minValue} eller senere.`,
    "unavailableDate": `Valgt dato utilgjengelig.`
};

},{}],"7ina2":[function(require,module,exports) {
module.exports = {
    "rangeOverflow": (args)=>`Waarde moet ${args.maxValue} of eerder zijn.`,
    "rangeReversed": `De startdatum moet voor de einddatum liggen.`,
    "rangeUnderflow": (args)=>`Waarde moet ${args.minValue} of later zijn.`,
    "unavailableDate": `Geselecteerde datum niet beschikbaar.`
};

},{}],"3mrPw":[function(require,module,exports) {
module.exports = {
    "rangeOverflow": (args)=>`Warto\u{15B}\u{107} musi mie\u{107} warto\u{15B}\u{107} ${args.maxValue} lub wcze\u{15B}niejsz\u{105}.`,
    "rangeReversed": `Data rozpocz\u{119}cia musi by\u{107} wcze\u{15B}niejsza ni\u{17C} data zako\u{144}czenia.`,
    "rangeUnderflow": (args)=>`Warto\u{15B}\u{107} musi mie\u{107} warto\u{15B}\u{107} ${args.minValue} lub p\xf3\u{17A}niejsz\u{105}.`,
    "unavailableDate": `Wybrana data jest niedost\u{119}pna.`
};

},{}],"5o1IO":[function(require,module,exports) {
module.exports = {
    "rangeOverflow": (args)=>`O valor deve ser ${args.maxValue} ou anterior.`,
    "rangeReversed": `A data inicial deve ser anterior \xe0 data final.`,
    "rangeUnderflow": (args)=>`O valor deve ser ${args.minValue} ou posterior.`,
    "unavailableDate": `Data selecionada indispon\xedvel.`
};

},{}],"45jQF":[function(require,module,exports) {
module.exports = {
    "rangeOverflow": (args)=>`O valor tem de ser ${args.maxValue} ou anterior.`,
    "rangeReversed": `A data de in\xedcio deve ser anterior \xe0 data de fim.`,
    "rangeUnderflow": (args)=>`O valor tem de ser ${args.minValue} ou posterior.`,
    "unavailableDate": `Data selecionada indispon\xedvel.`
};

},{}],"2x835":[function(require,module,exports) {
module.exports = {
    "rangeOverflow": (args)=>`Valoarea trebuie s\u{103} fie ${args.maxValue} sau anterioar\u{103}.`,
    "rangeReversed": `Data de \xeenceput trebuie s\u{103} fie anterioar\u{103} datei de sf\xe2r\u{219}it.`,
    "rangeUnderflow": (args)=>`Valoarea trebuie s\u{103} fie ${args.minValue} sau ulterioar\u{103}.`,
    "unavailableDate": `Data selectat\u{103} nu este disponibil\u{103}.`
};

},{}],"g70RJ":[function(require,module,exports) {
module.exports = {
    "rangeOverflow": (args)=>`\u{417}\u{43D}\u{430}\u{447}\u{435}\u{43D}\u{438}\u{435} \u{434}\u{43E}\u{43B}\u{436}\u{43D}\u{43E} \u{431}\u{44B}\u{442}\u{44C} \u{43D}\u{435} \u{43F}\u{43E}\u{437}\u{436}\u{435} ${args.maxValue}.`,
    "rangeReversed": `\u{414}\u{430}\u{442}\u{430} \u{43D}\u{430}\u{447}\u{430}\u{43B}\u{430} \u{434}\u{43E}\u{43B}\u{436}\u{43D}\u{430} \u{43F}\u{440}\u{435}\u{434}\u{448}\u{435}\u{441}\u{442}\u{432}\u{43E}\u{432}\u{430}\u{442}\u{44C} \u{434}\u{430}\u{442}\u{435} \u{43E}\u{43A}\u{43E}\u{43D}\u{447}\u{430}\u{43D}\u{438}\u{44F}.`,
    "rangeUnderflow": (args)=>`\u{417}\u{43D}\u{430}\u{447}\u{435}\u{43D}\u{438}\u{435} \u{434}\u{43E}\u{43B}\u{436}\u{43D}\u{43E} \u{431}\u{44B}\u{442}\u{44C} \u{43D}\u{435} \u{440}\u{430}\u{43D}\u{44C}\u{448}\u{435} ${args.minValue}.`,
    "unavailableDate": `\u{412}\u{44B}\u{431}\u{440}\u{430}\u{43D}\u{43D}\u{430}\u{44F} \u{434}\u{430}\u{442}\u{430} \u{43D}\u{435}\u{434}\u{43E}\u{441}\u{442}\u{443}\u{43F}\u{43D}\u{430}.`
};

},{}],"hCxKH":[function(require,module,exports) {
module.exports = {
    "rangeOverflow": (args)=>`Hodnota mus\xed by\u{165} ${args.maxValue} alebo skor\u{161}ia.`,
    "rangeReversed": `D\xe1tum za\u{10D}iatku mus\xed by\u{165} skor\u{161}\xed ako d\xe1tum konca.`,
    "rangeUnderflow": (args)=>`Hodnota mus\xed by\u{165} ${args.minValue} alebo neskor\u{161}ia.`,
    "unavailableDate": `Vybrat\xfd d\xe1tum je nedostupn\xfd.`
};

},{}],"dm8AC":[function(require,module,exports) {
module.exports = {
    "rangeOverflow": (args)=>`Vrednost mora biti ${args.maxValue} ali starej\u{161}a.`,
    "rangeReversed": `Za\u{10D}etni datum mora biti pred kon\u{10D}nim datumom.`,
    "rangeUnderflow": (args)=>`Vrednost mora biti ${args.minValue} ali novej\u{161}a.`,
    "unavailableDate": `Izbrani datum ni na voljo.`
};

},{}],"c4DBI":[function(require,module,exports) {
module.exports = {
    "rangeOverflow": (args)=>`Vrednost mora da bude ${args.maxValue} ili starija.`,
    "rangeReversed": `Datum po\u{10D}etka mora biti pre datuma zavr\u{161}etka.`,
    "rangeUnderflow": (args)=>`Vrednost mora da bude ${args.minValue} ili novija.`,
    "unavailableDate": `Izabrani datum nije dostupan.`
};

},{}],"4QD8t":[function(require,module,exports) {
module.exports = {
    "rangeOverflow": (args)=>`V\xe4rdet m\xe5ste vara ${args.maxValue} eller tidigare.`,
    "rangeReversed": `Startdatumet m\xe5ste vara f\xf6re slutdatumet.`,
    "rangeUnderflow": (args)=>`V\xe4rdet m\xe5ste vara ${args.minValue} eller senare.`,
    "unavailableDate": `Det valda datumet \xe4r inte tillg\xe4ngligt.`
};

},{}],"kWSee":[function(require,module,exports) {
module.exports = {
    "rangeOverflow": (args)=>`De\u{11F}er, ${args.maxValue} veya \xf6ncesi olmal\u{131}d\u{131}r.`,
    "rangeReversed": `Ba\u{15F}lang\u{131}\xe7 tarihi biti\u{15F} tarihinden \xf6nce olmal\u{131}d\u{131}r.`,
    "rangeUnderflow": (args)=>`De\u{11F}er, ${args.minValue} veya sonras\u{131} olmal\u{131}d\u{131}r.`,
    "unavailableDate": `Se\xe7ilen tarih kullan\u{131}lam\u{131}yor.`
};

},{}],"7a7eg":[function(require,module,exports) {
module.exports = {
    "rangeOverflow": (args)=>`\u{417}\u{43D}\u{430}\u{447}\u{435}\u{43D}\u{43D}\u{44F} \u{43C}\u{430}\u{454} \u{431}\u{443}\u{442}\u{438} \u{43D}\u{435} \u{43F}\u{456}\u{437}\u{43D}\u{456}\u{448}\u{435} ${args.maxValue}.`,
    "rangeReversed": `\u{414}\u{430}\u{442}\u{430} \u{43F}\u{43E}\u{447}\u{430}\u{442}\u{43A}\u{443} \u{43C}\u{430}\u{454} \u{43F}\u{435}\u{440}\u{435}\u{434}\u{443}\u{432}\u{430}\u{442}\u{438} \u{434}\u{430}\u{442}\u{456} \u{437}\u{430}\u{432}\u{435}\u{440}\u{448}\u{435}\u{43D}\u{43D}\u{44F}.`,
    "rangeUnderflow": (args)=>`\u{417}\u{43D}\u{430}\u{447}\u{435}\u{43D}\u{43D}\u{44F} \u{43C}\u{430}\u{454} \u{431}\u{443}\u{442}\u{438} \u{43D}\u{435} \u{440}\u{430}\u{43D}\u{456}\u{448}\u{435} ${args.minValue}.`,
    "unavailableDate": `\u{412}\u{438}\u{431}\u{440}\u{430}\u{43D}\u{430} \u{434}\u{430}\u{442}\u{430} \u{43D}\u{435}\u{434}\u{43E}\u{441}\u{442}\u{443}\u{43F}\u{43D}\u{430}.`
};

},{}],"3zF17":[function(require,module,exports) {
module.exports = {
    "rangeOverflow": (args)=>`\u{503C}\u{5FC5}\u{987B}\u{662F} ${args.maxValue} \u{6216}\u{66F4}\u{65E9}\u{65E5}\u{671F}\u{3002}`,
    "rangeReversed": `\u{5F00}\u{59CB}\u{65E5}\u{671F}\u{5FC5}\u{987B}\u{65E9}\u{4E8E}\u{7ED3}\u{675F}\u{65E5}\u{671F}\u{3002}`,
    "rangeUnderflow": (args)=>`\u{503C}\u{5FC5}\u{987B}\u{662F} ${args.minValue} \u{6216}\u{66F4}\u{665A}\u{65E5}\u{671F}\u{3002}`,
    "unavailableDate": `\u{6240}\u{9009}\u{65E5}\u{671F}\u{4E0D}\u{53EF}\u{7528}\u{3002}`
};

},{}],"hhCHp":[function(require,module,exports) {
module.exports = {
    "rangeOverflow": (args)=>`\u{503C}\u{5FC5}\u{9808}\u{662F} ${args.maxValue} \u{6216}\u{66F4}\u{65E9}\u{3002}`,
    "rangeReversed": `\u{958B}\u{59CB}\u{65E5}\u{671F}\u{5FC5}\u{9808}\u{5728}\u{7D50}\u{675F}\u{65E5}\u{671F}\u{4E4B}\u{524D}\u{3002}`,
    "rangeUnderflow": (args)=>`\u{503C}\u{5FC5}\u{9808}\u{662F} ${args.minValue} \u{6216}\u{66F4}\u{665A}\u{3002}`,
    "unavailableDate": `\u{6240}\u{9078}\u{65E5}\u{671F}\u{7121}\u{6CD5}\u{4F7F}\u{7528}\u{3002}`
};

},{}],"fyiOZ":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides state management for a date field component.
 * A date field allows users to enter and edit date and time values using a keyboard.
 * Each part of a date value is displayed in an individually editable segment.
 */ parcelHelpers.export(exports, "useDateFieldState", ()=>useDateFieldState);
var _date = require("@internationalized/date");
var _utils = require("./utils");
var _form = require("@react-stately/form");
var _placeholders = require("./placeholders");
var _utils1 = require("@react-stately/utils");
var _react = require("react");
const EDITABLE_SEGMENTS = {
    year: true,
    month: true,
    day: true,
    hour: true,
    minute: true,
    second: true,
    dayPeriod: true,
    era: true
};
const PAGE_STEP = {
    year: 5,
    month: 2,
    day: 7,
    hour: 2,
    minute: 15,
    second: 15
};
// Node seems to convert everything to lowercase...
const TYPE_MAPPING = {
    dayperiod: "dayPeriod"
};
function useDateFieldState(props) {
    let { locale, createCalendar, hideTimeZone, isDisabled, isReadOnly, isRequired, minValue, maxValue, isDateUnavailable } = props;
    let v = props.value || props.defaultValue || props.placeholderValue;
    let [granularity, defaultTimeZone] = (0, _utils.useDefaultProps)(v, props.granularity);
    let timeZone = defaultTimeZone || "UTC";
    // props.granularity must actually exist in the value if one is provided.
    if (v && !(granularity in v)) throw new Error("Invalid granularity " + granularity + " for value " + v.toString());
    let defaultFormatter = (0, _react.useMemo)(()=>new (0, _date.DateFormatter)(locale), [
        locale
    ]);
    let calendar = (0, _react.useMemo)(()=>createCalendar(defaultFormatter.resolvedOptions().calendar), [
        createCalendar,
        defaultFormatter
    ]);
    let [value, setDate] = (0, _utils1.useControlledState)(props.value, props.defaultValue, props.onChange);
    let calendarValue = (0, _react.useMemo)(()=>(0, _utils.convertValue)(value, calendar), [
        value,
        calendar
    ]);
    // We keep track of the placeholder date separately in state so that onChange is not called
    // until all segments are set. If the value === null (not undefined), then assume the component
    // is controlled, so use the placeholder as the value until all segments are entered so it doesn't
    // change from uncontrolled to controlled and emit a warning.
    let [placeholderDate, setPlaceholderDate] = (0, _react.useState)(()=>(0, _utils.createPlaceholderDate)(props.placeholderValue, granularity, calendar, defaultTimeZone));
    let val = calendarValue || placeholderDate;
    let showEra = calendar.identifier === "gregory" && val.era === "BC";
    let formatOpts = (0, _react.useMemo)(()=>{
        var _props_maxGranularity;
        return {
            granularity,
            maxGranularity: (_props_maxGranularity = props.maxGranularity) !== null && _props_maxGranularity !== void 0 ? _props_maxGranularity : "year",
            timeZone: defaultTimeZone,
            hideTimeZone,
            hourCycle: props.hourCycle,
            showEra,
            shouldForceLeadingZeros: props.shouldForceLeadingZeros
        };
    }, [
        props.maxGranularity,
        granularity,
        props.hourCycle,
        props.shouldForceLeadingZeros,
        defaultTimeZone,
        hideTimeZone,
        showEra
    ]);
    let opts = (0, _react.useMemo)(()=>(0, _utils.getFormatOptions)({}, formatOpts), [
        formatOpts
    ]);
    let dateFormatter = (0, _react.useMemo)(()=>new (0, _date.DateFormatter)(locale, opts), [
        locale,
        opts
    ]);
    let resolvedOptions = (0, _react.useMemo)(()=>dateFormatter.resolvedOptions(), [
        dateFormatter
    ]);
    // Determine how many editable segments there are for validation purposes.
    // The result is cached for performance.
    let allSegments = (0, _react.useMemo)(()=>dateFormatter.formatToParts(new Date()).filter((seg)=>EDITABLE_SEGMENTS[seg.type]).reduce((p, seg)=>(p[seg.type] = true, p), {}), [
        dateFormatter
    ]);
    let [validSegments, setValidSegments] = (0, _react.useState)(()=>props.value || props.defaultValue ? {
            ...allSegments
        } : {});
    let clearedSegment = (0, _react.useRef)();
    // Reset placeholder when calendar changes
    let lastCalendarIdentifier = (0, _react.useRef)(calendar.identifier);
    (0, _react.useEffect)(()=>{
        if (calendar.identifier !== lastCalendarIdentifier.current) {
            lastCalendarIdentifier.current = calendar.identifier;
            setPlaceholderDate((placeholder)=>Object.keys(validSegments).length > 0 ? (0, _date.toCalendar)(placeholder, calendar) : (0, _utils.createPlaceholderDate)(props.placeholderValue, granularity, calendar, defaultTimeZone));
        }
    }, [
        calendar,
        granularity,
        validSegments,
        defaultTimeZone,
        props.placeholderValue
    ]);
    // If there is a value prop, and some segments were previously placeholders, mark them all as valid.
    if (value && Object.keys(validSegments).length < Object.keys(allSegments).length) {
        validSegments = {
            ...allSegments
        };
        setValidSegments(validSegments);
    }
    // If the value is set to null and all segments are valid, reset the placeholder.
    if (value == null && Object.keys(validSegments).length === Object.keys(allSegments).length) {
        validSegments = {};
        setValidSegments(validSegments);
        setPlaceholderDate((0, _utils.createPlaceholderDate)(props.placeholderValue, granularity, calendar, defaultTimeZone));
    }
    // If all segments are valid, use the date from state, otherwise use the placeholder date.
    let displayValue = calendarValue && Object.keys(validSegments).length >= Object.keys(allSegments).length ? calendarValue : placeholderDate;
    let setValue = (newValue)=>{
        if (props.isDisabled || props.isReadOnly) return;
        let validKeys = Object.keys(validSegments);
        let allKeys = Object.keys(allSegments);
        // if all the segments are completed or a timefield with everything but am/pm set the time, also ignore when am/pm cleared
        if (newValue == null) {
            setDate(null);
            setPlaceholderDate((0, _utils.createPlaceholderDate)(props.placeholderValue, granularity, calendar, defaultTimeZone));
            setValidSegments({});
        } else if (validKeys.length >= allKeys.length || validKeys.length === allKeys.length - 1 && allSegments.dayPeriod && !validSegments.dayPeriod && clearedSegment.current !== "dayPeriod") {
            // The display calendar should not have any effect on the emitted value.
            // Emit dates in the same calendar as the original value, if any, otherwise gregorian.
            newValue = (0, _date.toCalendar)(newValue, (v === null || v === void 0 ? void 0 : v.calendar) || new (0, _date.GregorianCalendar)());
            setDate(newValue);
        } else setPlaceholderDate(newValue);
        clearedSegment.current = null;
    };
    let dateValue = (0, _react.useMemo)(()=>displayValue.toDate(timeZone), [
        displayValue,
        timeZone
    ]);
    let segments = (0, _react.useMemo)(()=>dateFormatter.formatToParts(dateValue).map((segment)=>{
            let isEditable = EDITABLE_SEGMENTS[segment.type];
            if (segment.type === "era" && calendar.getEras().length === 1) isEditable = false;
            let isPlaceholder = EDITABLE_SEGMENTS[segment.type] && !validSegments[segment.type];
            let placeholder = EDITABLE_SEGMENTS[segment.type] ? (0, _placeholders.getPlaceholder)(segment.type, segment.value, locale) : null;
            return {
                type: TYPE_MAPPING[segment.type] || segment.type,
                text: isPlaceholder ? placeholder : segment.value,
                ...getSegmentLimits(displayValue, segment.type, resolvedOptions),
                isPlaceholder,
                placeholder,
                isEditable
            };
        }), [
        dateValue,
        validSegments,
        dateFormatter,
        resolvedOptions,
        displayValue,
        calendar,
        locale
    ]);
    // When the era field appears, mark it valid if the year field is already valid.
    // If the era field disappears, remove it from the valid segments.
    if (allSegments.era && validSegments.year && !validSegments.era) {
        validSegments.era = true;
        setValidSegments({
            ...validSegments
        });
    } else if (!allSegments.era && validSegments.era) {
        delete validSegments.era;
        setValidSegments({
            ...validSegments
        });
    }
    let markValid = (part)=>{
        validSegments[part] = true;
        if (part === "year" && allSegments.era) validSegments.era = true;
        setValidSegments({
            ...validSegments
        });
    };
    let adjustSegment = (type, amount)=>{
        if (!validSegments[type]) {
            markValid(type);
            let validKeys = Object.keys(validSegments);
            let allKeys = Object.keys(allSegments);
            if (validKeys.length >= allKeys.length || validKeys.length === allKeys.length - 1 && allSegments.dayPeriod && !validSegments.dayPeriod) setValue(displayValue);
        } else setValue(addSegment(displayValue, type, amount, resolvedOptions));
    };
    let builtinValidation = (0, _react.useMemo)(()=>(0, _utils.getValidationResult)(value, minValue, maxValue, isDateUnavailable, formatOpts), [
        value,
        minValue,
        maxValue,
        isDateUnavailable,
        formatOpts
    ]);
    let validation = (0, _form.useFormValidationState)({
        ...props,
        value,
        builtinValidation
    });
    let isValueInvalid = validation.displayValidation.isInvalid;
    let validationState = props.validationState || (isValueInvalid ? "invalid" : null);
    var _props_maxGranularity;
    return {
        ...validation,
        value: calendarValue,
        dateValue,
        calendar,
        setValue,
        segments,
        dateFormatter,
        validationState,
        isInvalid: isValueInvalid,
        granularity,
        maxGranularity: (_props_maxGranularity = props.maxGranularity) !== null && _props_maxGranularity !== void 0 ? _props_maxGranularity : "year",
        isDisabled,
        isReadOnly,
        isRequired,
        increment (part) {
            adjustSegment(part, 1);
        },
        decrement (part) {
            adjustSegment(part, -1);
        },
        incrementPage (part) {
            adjustSegment(part, PAGE_STEP[part] || 1);
        },
        decrementPage (part) {
            adjustSegment(part, -(PAGE_STEP[part] || 1));
        },
        setSegment (part, v) {
            markValid(part);
            setValue(setSegment(displayValue, part, v, resolvedOptions));
        },
        confirmPlaceholder () {
            if (props.isDisabled || props.isReadOnly) return;
            // Confirm the placeholder if only the day period is not filled in.
            let validKeys = Object.keys(validSegments);
            let allKeys = Object.keys(allSegments);
            if (validKeys.length === allKeys.length - 1 && allSegments.dayPeriod && !validSegments.dayPeriod) {
                validSegments = {
                    ...allSegments
                };
                setValidSegments(validSegments);
                setValue(displayValue.copy());
            }
        },
        clearSegment (part) {
            delete validSegments[part];
            clearedSegment.current = part;
            setValidSegments({
                ...validSegments
            });
            let placeholder = (0, _utils.createPlaceholderDate)(props.placeholderValue, granularity, calendar, defaultTimeZone);
            let value = displayValue;
            // Reset day period to default without changing the hour.
            if (part === "dayPeriod" && "hour" in displayValue && "hour" in placeholder) {
                let isPM = displayValue.hour >= 12;
                let shouldBePM = placeholder.hour >= 12;
                if (isPM && !shouldBePM) value = displayValue.set({
                    hour: displayValue.hour - 12
                });
                else if (!isPM && shouldBePM) value = displayValue.set({
                    hour: displayValue.hour + 12
                });
            } else if (part in displayValue) value = displayValue.set({
                [part]: placeholder[part]
            });
            setDate(null);
            setValue(value);
        },
        formatValue (fieldOptions) {
            if (!calendarValue) return "";
            let formatOptions = (0, _utils.getFormatOptions)(fieldOptions, formatOpts);
            let formatter = new (0, _date.DateFormatter)(locale, formatOptions);
            return formatter.format(dateValue);
        }
    };
}
function getSegmentLimits(date, type, options) {
    switch(type){
        case "era":
            {
                let eras = date.calendar.getEras();
                return {
                    value: eras.indexOf(date.era),
                    minValue: 0,
                    maxValue: eras.length - 1
                };
            }
        case "year":
            return {
                value: date.year,
                minValue: 1,
                maxValue: date.calendar.getYearsInEra(date)
            };
        case "month":
            return {
                value: date.month,
                minValue: (0, _date.getMinimumMonthInYear)(date),
                maxValue: date.calendar.getMonthsInYear(date)
            };
        case "day":
            return {
                value: date.day,
                minValue: (0, _date.getMinimumDayInMonth)(date),
                maxValue: date.calendar.getDaysInMonth(date)
            };
    }
    if ("hour" in date) switch(type){
        case "dayPeriod":
            return {
                value: date.hour >= 12 ? 12 : 0,
                minValue: 0,
                maxValue: 12
            };
        case "hour":
            if (options.hour12) {
                let isPM = date.hour >= 12;
                return {
                    value: date.hour,
                    minValue: isPM ? 12 : 0,
                    maxValue: isPM ? 23 : 11
                };
            }
            return {
                value: date.hour,
                minValue: 0,
                maxValue: 23
            };
        case "minute":
            return {
                value: date.minute,
                minValue: 0,
                maxValue: 59
            };
        case "second":
            return {
                value: date.second,
                minValue: 0,
                maxValue: 59
            };
    }
    return {};
}
function addSegment(value, part, amount, options) {
    switch(part){
        case "era":
        case "year":
        case "month":
        case "day":
            return value.cycle(part, amount, {
                round: part === "year"
            });
    }
    if ("hour" in value) switch(part){
        case "dayPeriod":
            {
                let hours = value.hour;
                let isPM = hours >= 12;
                return value.set({
                    hour: isPM ? hours - 12 : hours + 12
                });
            }
        case "hour":
        case "minute":
        case "second":
            return value.cycle(part, amount, {
                round: part !== "hour",
                hourCycle: options.hour12 ? 12 : 24
            });
    }
}
function setSegment(value, part, segmentValue, options) {
    switch(part){
        case "day":
        case "month":
        case "year":
        case "era":
            return value.set({
                [part]: segmentValue
            });
    }
    if ("hour" in value) switch(part){
        case "dayPeriod":
            {
                let hours = value.hour;
                let wasPM = hours >= 12;
                let isPM = segmentValue >= 12;
                if (isPM === wasPM) return value;
                return value.set({
                    hour: wasPM ? hours - 12 : hours + 12
                });
            }
        case "hour":
            // In 12 hour time, ensure that AM/PM does not change
            if (options.hour12) {
                let hours = value.hour;
                let wasPM = hours >= 12;
                if (!wasPM && segmentValue === 12) segmentValue = 0;
                if (wasPM && segmentValue < 12) segmentValue += 12;
            }
        // fallthrough
        case "minute":
        case "second":
            return value.set({
                [part]: segmentValue
            });
    }
}

},{"@internationalized/date":"hesBk","./utils":"78Io6","@react-stately/form":"9yZqm","./placeholders":"edSKQ","@react-stately/utils":"cpDPf","react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"edSKQ":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getPlaceholder", ()=>getPlaceholder);
var _string = require("@internationalized/string");
// These placeholders are based on the strings used by the <input type="date">
// implementations in Chrome and Firefox. Additional languages are supported
// here than React Spectrum's typical translations.
const placeholders = new (0, _string.LocalizedStringDictionary)({
    ach: {
        year: "mwaka",
        month: "dwe",
        day: "nino"
    },
    af: {
        year: "jjjj",
        month: "mm",
        day: "dd"
    },
    am: {
        year: "\u12D3\u12D3\u12D3\u12D3",
        month: "\u121A\u121C",
        day: "\u1240\u1240"
    },
    an: {
        year: "aaaa",
        month: "mm",
        day: "dd"
    },
    ar: {
        year: "\u0633\u0646\u0629",
        month: "\u0634\u0647\u0631",
        day: "\u064A\u0648\u0645"
    },
    ast: {
        year: "aaaa",
        month: "mm",
        day: "dd"
    },
    az: {
        year: "iiii",
        month: "aa",
        day: "gg"
    },
    be: {
        year: "\u0433\u0433\u0433\u0433",
        month: "\u043C\u043C",
        day: "\u0434\u0434"
    },
    bg: {
        year: "\u0433\u0433\u0433\u0433",
        month: "\u043C\u043C",
        day: "\u0434\u0434"
    },
    bn: {
        year: "yyyy",
        month: "\u09AE\u09BF\u09AE\u09BF",
        day: "dd"
    },
    br: {
        year: "bbbb",
        month: "mm",
        day: "dd"
    },
    bs: {
        year: "gggg",
        month: "mm",
        day: "dd"
    },
    ca: {
        year: "aaaa",
        month: "mm",
        day: "dd"
    },
    cak: {
        year: "jjjj",
        month: "ii",
        day: "q'q'"
    },
    ckb: {
        year: "\u0633\u0627\u06B5",
        month: "\u0645\u0627\u0646\u06AF",
        day: "\u0695\u06C6\u0698"
    },
    cs: {
        year: "rrrr",
        month: "mm",
        day: "dd"
    },
    cy: {
        year: "bbbb",
        month: "mm",
        day: "dd"
    },
    da: {
        year: "\xe5\xe5\xe5\xe5",
        month: "mm",
        day: "dd"
    },
    de: {
        year: "jjjj",
        month: "mm",
        day: "tt"
    },
    dsb: {
        year: "llll",
        month: "mm",
        day: "\u017A\u017A"
    },
    el: {
        year: "\u03B5\u03B5\u03B5\u03B5",
        month: "\u03BC\u03BC",
        day: "\u03B7\u03B7"
    },
    en: {
        year: "yyyy",
        month: "mm",
        day: "dd"
    },
    eo: {
        year: "jjjj",
        month: "mm",
        day: "tt"
    },
    es: {
        year: "aaaa",
        month: "mm",
        day: "dd"
    },
    et: {
        year: "aaaa",
        month: "kk",
        day: "pp"
    },
    eu: {
        year: "uuuu",
        month: "hh",
        day: "ee"
    },
    fa: {
        year: "\u0633\u0627\u0644",
        month: "\u0645\u0627\u0647",
        day: "\u0631\u0648\u0632"
    },
    ff: {
        year: "hhhh",
        month: "ll",
        day: "\xf1\xf1"
    },
    fi: {
        year: "vvvv",
        month: "kk",
        day: "pp"
    },
    fr: {
        year: "aaaa",
        month: "mm",
        day: "jj"
    },
    fy: {
        year: "jjjj",
        month: "mm",
        day: "dd"
    },
    ga: {
        year: "bbbb",
        month: "mm",
        day: "ll"
    },
    gd: {
        year: "bbbb",
        month: "mm",
        day: "ll"
    },
    gl: {
        year: "aaaa",
        month: "mm",
        day: "dd"
    },
    he: {
        year: "\u05E9\u05E0\u05D4",
        month: "\u05D7\u05D5\u05D3\u05E9",
        day: "\u05D9\u05D5\u05DD"
    },
    hr: {
        year: "gggg",
        month: "mm",
        day: "dd"
    },
    hsb: {
        year: "llll",
        month: "mm",
        day: "dd"
    },
    hu: {
        year: "\xe9\xe9\xe9\xe9",
        month: "hh",
        day: "nn"
    },
    ia: {
        year: "aaaa",
        month: "mm",
        day: "dd"
    },
    id: {
        year: "tttt",
        month: "bb",
        day: "hh"
    },
    it: {
        year: "aaaa",
        month: "mm",
        day: "gg"
    },
    ja: {
        year: " \u5E74 ",
        month: "\u6708",
        day: "\u65E5"
    },
    ka: {
        year: "\u10EC\u10EC\u10EC\u10EC",
        month: "\u10D7\u10D7",
        day: "\u10E0\u10E0"
    },
    kk: {
        year: "\u0436\u0436\u0436\u0436",
        month: "\u0430\u0430",
        day: "\u043A\u043A"
    },
    kn: {
        year: "\u0CB5\u0CB5\u0CB5\u0CB5",
        month: "\u0CAE\u0CBF\u0CAE\u0CC0",
        day: "\u0CA6\u0CBF\u0CA6\u0CBF"
    },
    ko: {
        year: "\uC5F0\uB3C4",
        month: "\uC6D4",
        day: "\uC77C"
    },
    lb: {
        year: "jjjj",
        month: "mm",
        day: "dd"
    },
    lo: {
        year: "\u0E9B\u0E9B\u0E9B\u0E9B",
        month: "\u0E94\u0E94",
        day: "\u0EA7\u0EA7"
    },
    lt: {
        year: "mmmm",
        month: "mm",
        day: "dd"
    },
    lv: {
        year: "gggg",
        month: "mm",
        day: "dd"
    },
    meh: {
        year: "aaaa",
        month: "mm",
        day: "dd"
    },
    ml: {
        year: "\u0D35\u0D7C\u0D37\u0D02",
        month: "\u0D2E\u0D3E\u0D38\u0D02",
        day: "\u0D24\u0D40\u0D2F\u0D24\u0D3F"
    },
    ms: {
        year: "tttt",
        month: "mm",
        day: "hh"
    },
    nl: {
        year: "jjjj",
        month: "mm",
        day: "dd"
    },
    nn: {
        year: "\xe5\xe5\xe5\xe5",
        month: "mm",
        day: "dd"
    },
    no: {
        year: "\xe5\xe5\xe5\xe5",
        month: "mm",
        day: "dd"
    },
    oc: {
        year: "aaaa",
        month: "mm",
        day: "jj"
    },
    pl: {
        year: "rrrr",
        month: "mm",
        day: "dd"
    },
    pt: {
        year: "aaaa",
        month: "mm",
        day: "dd"
    },
    rm: {
        year: "oooo",
        month: "mm",
        day: "dd"
    },
    ro: {
        year: "aaaa",
        month: "ll",
        day: "zz"
    },
    ru: {
        year: "\u0433\u0433\u0433\u0433",
        month: "\u043C\u043C",
        day: "\u0434\u0434"
    },
    sc: {
        year: "aaaa",
        month: "mm",
        day: "dd"
    },
    scn: {
        year: "aaaa",
        month: "mm",
        day: "jj"
    },
    sk: {
        year: "rrrr",
        month: "mm",
        day: "dd"
    },
    sl: {
        year: "llll",
        month: "mm",
        day: "dd"
    },
    sr: {
        year: "\u0433\u0433\u0433\u0433",
        month: "\u043C\u043C",
        day: "\u0434\u0434"
    },
    sv: {
        year: "\xe5\xe5\xe5\xe5",
        month: "mm",
        day: "dd"
    },
    szl: {
        year: "rrrr",
        month: "mm",
        day: "dd"
    },
    tg: {
        year: "\u0441\u0441\u0441\u0441",
        month: "\u043C\u043C",
        day: "\u0440\u0440"
    },
    th: {
        year: "\u0E1B\u0E1B\u0E1B\u0E1B",
        month: "\u0E14\u0E14",
        day: "\u0E27\u0E27"
    },
    tr: {
        year: "yyyy",
        month: "aa",
        day: "gg"
    },
    uk: {
        year: "\u0440\u0440\u0440\u0440",
        month: "\u043C\u043C",
        day: "\u0434\u0434"
    },
    "zh-CN": {
        year: "\u5E74",
        month: "\u6708",
        day: "\u65E5"
    },
    "zh-TW": {
        year: "\u5E74",
        month: "\u6708",
        day: "\u65E5"
    }
}, "en");
function getPlaceholder(field, value, locale) {
    // Use the actual placeholder value for the era and day period fields.
    if (field === "era" || field === "dayPeriod") return value;
    if (field === "year" || field === "month" || field === "day") return placeholders.getStringForLocale(field, locale);
    // For time fields (e.g. hour, minute, etc.), use two dashes as the placeholder.
    return "\u2013\u2013";
}

},{"@internationalized/string":"3QbrG","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"llySa":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides state management for a date range picker component.
 * A date range picker combines two DateFields and a RangeCalendar popover to allow
 * users to enter or select a date and time range.
 */ parcelHelpers.export(exports, "useDateRangePickerState", ()=>useDateRangePickerState);
var _date = require("@internationalized/date");
var _utils = require("./utils");
var _form = require("@react-stately/form");
var _overlays = require("@react-stately/overlays");
var _utils1 = require("@react-stately/utils");
var _react = require("react");
function useDateRangePickerState(props) {
    var _value_start, _value_end;
    let overlayState = (0, _overlays.useOverlayTriggerState)(props);
    let [controlledValue, setControlledValue] = (0, _utils1.useControlledState)(props.value, props.defaultValue || null, props.onChange);
    let [placeholderValue, setPlaceholderValue] = (0, _react.useState)(()=>controlledValue || {
            start: null,
            end: null
        });
    // Reset the placeholder if the value prop is set to null.
    if (controlledValue == null && placeholderValue.start && placeholderValue.end) {
        placeholderValue = {
            start: null,
            end: null
        };
        setPlaceholderValue(placeholderValue);
    }
    let value = controlledValue || placeholderValue;
    let setValue = (value)=>{
        setPlaceholderValue(value || {
            start: null,
            end: null
        });
        if ((value === null || value === void 0 ? void 0 : value.start) && value.end) setControlledValue(value);
        else setControlledValue(null);
    };
    let v = (value === null || value === void 0 ? void 0 : value.start) || (value === null || value === void 0 ? void 0 : value.end) || props.placeholderValue;
    let [granularity, defaultTimeZone] = (0, _utils.useDefaultProps)(v, props.granularity);
    let hasTime = granularity === "hour" || granularity === "minute" || granularity === "second";
    var _props_shouldCloseOnSelect;
    let shouldCloseOnSelect = (_props_shouldCloseOnSelect = props.shouldCloseOnSelect) !== null && _props_shouldCloseOnSelect !== void 0 ? _props_shouldCloseOnSelect : true;
    let [dateRange, setSelectedDateRange] = (0, _react.useState)(null);
    let [timeRange, setSelectedTimeRange] = (0, _react.useState)(null);
    if (value && value.start && value.end) {
        dateRange = value;
        if ("hour" in value.start) timeRange = value;
    }
    let commitValue = (dateRange, timeRange)=>{
        setValue({
            start: "timeZone" in timeRange.start ? timeRange.start.set((0, _date.toCalendarDate)(dateRange.start)) : (0, _date.toCalendarDateTime)(dateRange.start, timeRange.start),
            end: "timeZone" in timeRange.end ? timeRange.end.set((0, _date.toCalendarDate)(dateRange.end)) : (0, _date.toCalendarDateTime)(dateRange.end, timeRange.end)
        });
        setSelectedDateRange(null);
        setSelectedTimeRange(null);
        validation.commitValidation();
    };
    // Intercept setValue to make sure the Time section is not changed by date selection in Calendar
    let setDateRange = (range)=>{
        let shouldClose = typeof shouldCloseOnSelect === "function" ? shouldCloseOnSelect() : shouldCloseOnSelect;
        if (hasTime) {
            if (shouldClose || range.start && range.end && (timeRange === null || timeRange === void 0 ? void 0 : timeRange.start) && (timeRange === null || timeRange === void 0 ? void 0 : timeRange.end)) commitValue(range, {
                start: (timeRange === null || timeRange === void 0 ? void 0 : timeRange.start) || (0, _utils.getPlaceholderTime)(props.placeholderValue),
                end: (timeRange === null || timeRange === void 0 ? void 0 : timeRange.end) || (0, _utils.getPlaceholderTime)(props.placeholderValue)
            });
            else setSelectedDateRange(range);
        } else if (range.start && range.end) {
            setValue(range);
            validation.commitValidation();
        } else setSelectedDateRange(range);
        if (shouldClose) overlayState.setOpen(false);
    };
    let setTimeRange = (range)=>{
        if ((dateRange === null || dateRange === void 0 ? void 0 : dateRange.start) && (dateRange === null || dateRange === void 0 ? void 0 : dateRange.end) && range.start && range.end) commitValue(dateRange, range);
        else setSelectedTimeRange(range);
    };
    let showEra = (value === null || value === void 0 ? void 0 : (_value_start = value.start) === null || _value_start === void 0 ? void 0 : _value_start.calendar.identifier) === "gregory" && value.start.era === "BC" || (value === null || value === void 0 ? void 0 : (_value_end = value.end) === null || _value_end === void 0 ? void 0 : _value_end.calendar.identifier) === "gregory" && value.end.era === "BC";
    let formatOpts = (0, _react.useMemo)(()=>({
            granularity,
            timeZone: defaultTimeZone,
            hideTimeZone: props.hideTimeZone,
            hourCycle: props.hourCycle,
            shouldForceLeadingZeros: props.shouldForceLeadingZeros,
            showEra
        }), [
        granularity,
        props.hourCycle,
        props.shouldForceLeadingZeros,
        defaultTimeZone,
        props.hideTimeZone,
        showEra
    ]);
    let { minValue, maxValue, isDateUnavailable } = props;
    let builtinValidation = (0, _react.useMemo)(()=>(0, _utils.getRangeValidationResult)(value, minValue, maxValue, isDateUnavailable, formatOpts), [
        value,
        minValue,
        maxValue,
        isDateUnavailable,
        formatOpts
    ]);
    let validation = (0, _form.useFormValidationState)({
        ...props,
        value: controlledValue,
        name: (0, _react.useMemo)(()=>[
                props.startName,
                props.endName
            ], [
            props.startName,
            props.endName
        ]),
        builtinValidation
    });
    let isValueInvalid = validation.displayValidation.isInvalid;
    let validationState = props.validationState || (isValueInvalid ? "invalid" : null);
    return {
        ...validation,
        value,
        setValue,
        dateRange,
        timeRange,
        granularity,
        hasTime,
        setDate (part, date) {
            setDateRange({
                ...dateRange,
                [part]: date
            });
        },
        setTime (part, time) {
            setTimeRange({
                ...timeRange,
                [part]: time
            });
        },
        setDateTime (part, dateTime) {
            setValue({
                ...value,
                [part]: dateTime
            });
        },
        setDateRange,
        setTimeRange,
        ...overlayState,
        setOpen (isOpen) {
            // Commit the selected date range when the calendar is closed. Use a placeholder time if one wasn't set.
            // If only the time range was set and not the date range, don't commit. The state will be preserved until
            // the user opens the popover again.
            if (!isOpen && !((value === null || value === void 0 ? void 0 : value.start) && (value === null || value === void 0 ? void 0 : value.end)) && (dateRange === null || dateRange === void 0 ? void 0 : dateRange.start) && (dateRange === null || dateRange === void 0 ? void 0 : dateRange.end) && hasTime) commitValue(dateRange, {
                start: (timeRange === null || timeRange === void 0 ? void 0 : timeRange.start) || (0, _utils.getPlaceholderTime)(props.placeholderValue),
                end: (timeRange === null || timeRange === void 0 ? void 0 : timeRange.end) || (0, _utils.getPlaceholderTime)(props.placeholderValue)
            });
            overlayState.setOpen(isOpen);
        },
        validationState,
        isInvalid: isValueInvalid,
        formatValue (locale, fieldOptions) {
            if (!value || !value.start || !value.end) return null;
            let startTimeZone = "timeZone" in value.start ? value.start.timeZone : undefined;
            let startGranularity = props.granularity || (value.start && "minute" in value.start ? "minute" : "day");
            let endTimeZone = "timeZone" in value.end ? value.end.timeZone : undefined;
            let endGranularity = props.granularity || (value.end && "minute" in value.end ? "minute" : "day");
            let startOptions = (0, _utils.getFormatOptions)(fieldOptions, {
                granularity: startGranularity,
                timeZone: startTimeZone,
                hideTimeZone: props.hideTimeZone,
                hourCycle: props.hourCycle,
                showEra: value.start.calendar.identifier === "gregory" && value.start.era === "BC" || value.end.calendar.identifier === "gregory" && value.end.era === "BC"
            });
            let startDate = value.start.toDate(startTimeZone || "UTC");
            let endDate = value.end.toDate(endTimeZone || "UTC");
            let startFormatter = new (0, _date.DateFormatter)(locale, startOptions);
            let endFormatter;
            if (startTimeZone === endTimeZone && startGranularity === endGranularity && value.start.compare(value.end) !== 0) {
                // Use formatRange, as it results in shorter output when some of the fields
                // are shared between the start and end dates (e.g. the same month).
                // Formatting will fail if the end date is before the start date. Fall back below when that happens.
                try {
                    let parts = startFormatter.formatRangeToParts(startDate, endDate);
                    // Find the separator between the start and end date. This is determined
                    // by finding the last shared literal before the end range.
                    let separatorIndex = -1;
                    for(let i = 0; i < parts.length; i++){
                        let part = parts[i];
                        if (part.source === "shared" && part.type === "literal") separatorIndex = i;
                        else if (part.source === "endRange") break;
                    }
                    // Now we can combine the parts into start and end strings.
                    let start = "";
                    let end = "";
                    for(let i = 0; i < parts.length; i++){
                        if (i < separatorIndex) start += parts[i].value;
                        else if (i > separatorIndex) end += parts[i].value;
                    }
                    return {
                        start,
                        end
                    };
                } catch (e) {
                // ignore
                }
                endFormatter = startFormatter;
            } else {
                let endOptions = (0, _utils.getFormatOptions)(fieldOptions, {
                    granularity: endGranularity,
                    timeZone: endTimeZone,
                    hideTimeZone: props.hideTimeZone,
                    hourCycle: props.hourCycle
                });
                endFormatter = new (0, _date.DateFormatter)(locale, endOptions);
            }
            return {
                start: startFormatter.format(startDate),
                end: endFormatter.format(endDate)
            };
        }
    };
}

},{"@internationalized/date":"hesBk","./utils":"78Io6","@react-stately/form":"9yZqm","@react-stately/overlays":"5uxM4","@react-stately/utils":"cpDPf","react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"5rVnT":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an 'AS IS' BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides state management for a time field component.
 * A time field allows users to enter and edit time values using a keyboard.
 * Each part of a time value is displayed in an individually editable segment.
 */ parcelHelpers.export(exports, "useTimeFieldState", ()=>useTimeFieldState);
var _ = require(".");
var _date = require("@internationalized/date");
var _react = require("react");
var _utils = require("@react-stately/utils");
function useTimeFieldState(props) {
    let { placeholderValue = new (0, _date.Time)(), minValue, maxValue, granularity, validate } = props;
    let [value, setValue] = (0, _utils.useControlledState)(props.value, props.defaultValue, props.onChange);
    let v = value || placeholderValue;
    let day = v && "day" in v ? v : undefined;
    let defaultValueTimeZone = props.defaultValue && "timeZone" in props.defaultValue ? props.defaultValue.timeZone : undefined;
    let placeholderDate = (0, _react.useMemo)(()=>{
        let valueTimeZone = v && "timeZone" in v ? v.timeZone : undefined;
        return (valueTimeZone || defaultValueTimeZone) && placeholderValue ? (0, _date.toZoned)(convertValue(placeholderValue), valueTimeZone || defaultValueTimeZone) : convertValue(placeholderValue);
    }, [
        placeholderValue,
        v,
        defaultValueTimeZone
    ]);
    let minDate = (0, _react.useMemo)(()=>convertValue(minValue, day), [
        minValue,
        day
    ]);
    let maxDate = (0, _react.useMemo)(()=>convertValue(maxValue, day), [
        maxValue,
        day
    ]);
    let timeValue = (0, _react.useMemo)(()=>value && "day" in value ? (0, _date.toTime)(value) : value, [
        value
    ]);
    let dateTime = (0, _react.useMemo)(()=>value == null ? null : convertValue(value), [
        value
    ]);
    let onChange = (newValue)=>{
        setValue(day || defaultValueTimeZone ? newValue : newValue && (0, _date.toTime)(newValue));
    };
    let state = (0, _.useDateFieldState)({
        ...props,
        value: dateTime,
        defaultValue: undefined,
        minValue: minDate,
        maxValue: maxDate,
        onChange,
        granularity: granularity || "minute",
        maxGranularity: "hour",
        placeholderValue: placeholderDate,
        // Calendar should not matter for time fields.
        createCalendar: ()=>new (0, _date.GregorianCalendar)(),
        validate: (0, _react.useCallback)(()=>validate === null || validate === void 0 ? void 0 : validate(value), [
            validate,
            value
        ])
    });
    return {
        ...state,
        timeValue
    };
}
function convertValue(value, date = (0, _date.today)((0, _date.getLocalTimeZone)())) {
    if (!value) return null;
    if ("day" in value) return value;
    return (0, _date.toCalendarDateTime)(date, value);
}

},{".":"ci7Mv","@internationalized/date":"hesBk","react":"9yzVZ","@react-stately/utils":"cpDPf","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"bUQOi":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useDraggableCollectionState", ()=>(0, _useDraggableCollectionState.useDraggableCollectionState));
parcelHelpers.export(exports, "useDroppableCollectionState", ()=>(0, _useDroppableCollectionState.useDroppableCollectionState));
var _useDraggableCollectionState = require("./useDraggableCollectionState");
var _useDroppableCollectionState = require("./useDroppableCollectionState");

},{"./useDraggableCollectionState":"aU81X","./useDroppableCollectionState":"3aW6u","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"aU81X":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Manages state for a draggable collection.
 */ parcelHelpers.export(exports, "useDraggableCollectionState", ()=>useDraggableCollectionState);
var _react = require("react");
function useDraggableCollectionState(props) {
    let { getItems, collection, selectionManager, onDragStart, onDragMove, onDragEnd, preview, getAllowedDropOperations } = props;
    let [, setDragging] = (0, _react.useState)(false);
    let draggingKeys = (0, _react.useRef)(new Set());
    let draggedKey = (0, _react.useRef)(null);
    let getKeys = (key)=>{
        // The clicked item is always added to the drag. If it is selected, then all of the
        // other selected items are also dragged. If it is not selected, the only the clicked
        // item is dragged. This matches native macOS behavior.
        let keys = new Set(selectionManager.isSelected(key) ? new Set([
            ...selectionManager.selectedKeys
        ].filter((key)=>!!collection.getItem(key))) : []);
        keys.add(key);
        return keys;
    };
    return {
        collection,
        selectionManager,
        get draggedKey () {
            return draggedKey.current;
        },
        get draggingKeys () {
            return draggingKeys.current;
        },
        isDragging (key) {
            return draggingKeys.current.has(key);
        },
        getKeysForDrag: getKeys,
        getItems (key) {
            return getItems(getKeys(key));
        },
        preview,
        getAllowedDropOperations,
        startDrag (key, event) {
            let keys = getKeys(key);
            draggingKeys.current = keys;
            draggedKey.current = key;
            selectionManager.setFocused(false);
            setDragging(true);
            if (typeof onDragStart === "function") onDragStart({
                ...event,
                keys
            });
        },
        moveDrag (event) {
            if (typeof onDragMove === "function") onDragMove({
                ...event,
                keys: draggingKeys.current
            });
        },
        endDrag (event) {
            let { isInternal } = event;
            if (typeof onDragEnd === "function") onDragEnd({
                ...event,
                keys: draggingKeys.current,
                isInternal
            });
            draggingKeys.current = new Set();
            draggedKey.current = null;
            setDragging(false);
        }
    };
}

},{"react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"3aW6u":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Manages state for a droppable collection.
 */ parcelHelpers.export(exports, "useDroppableCollectionState", ()=>useDroppableCollectionState);
var _react = require("react");
function useDroppableCollectionState(props) {
    let { acceptedDragTypes = "all", onInsert, onRootDrop, onItemDrop, onReorder, shouldAcceptItemDrop, collection, selectionManager, onDropEnter, getDropOperation, onDrop } = props;
    let [target, setTarget] = (0, _react.useState)(null);
    let targetRef = (0, _react.useRef)(null);
    let getOppositeTarget = (target)=>{
        if (target.dropPosition === "before") {
            let key = collection.getKeyBefore(target.key);
            return key != null ? {
                type: "item",
                key,
                dropPosition: "after"
            } : null;
        } else if (target.dropPosition === "after") {
            let key = collection.getKeyAfter(target.key);
            return key != null ? {
                type: "item",
                key,
                dropPosition: "before"
            } : null;
        }
    };
    let defaultGetDropOperation = (0, _react.useCallback)((e)=>{
        let { target, types, allowedOperations, isInternal, draggingKeys } = e;
        if (acceptedDragTypes === "all" || acceptedDragTypes.some((type)=>types.has(type))) {
            let isValidInsert = onInsert && target.type === "item" && !isInternal && (target.dropPosition === "before" || target.dropPosition === "after");
            let isValidReorder = onReorder && target.type === "item" && isInternal && (target.dropPosition === "before" || target.dropPosition === "after");
            // Feedback was that internal root drop was weird so preventing that from happening
            let isValidRootDrop = onRootDrop && target.type === "root" && !isInternal;
            // Automatically prevent items (i.e. folders) from being dropped on themselves.
            let isValidOnItemDrop = onItemDrop && target.type === "item" && target.dropPosition === "on" && !(isInternal && draggingKeys.has(target.key)) && (!shouldAcceptItemDrop || shouldAcceptItemDrop(target, types));
            if (onDrop || isValidInsert || isValidReorder || isValidRootDrop || isValidOnItemDrop) {
                if (getDropOperation) return getDropOperation(target, types, allowedOperations);
                else return allowedOperations[0];
            }
        }
        return "cancel";
    }, [
        acceptedDragTypes,
        getDropOperation,
        onInsert,
        onRootDrop,
        onItemDrop,
        shouldAcceptItemDrop,
        onReorder,
        onDrop
    ]);
    return {
        collection,
        selectionManager,
        target,
        setTarget (newTarget) {
            if (this.isDropTarget(newTarget)) return;
            let target = targetRef.current;
            if (target && typeof props.onDropExit === "function") props.onDropExit({
                type: "dropexit",
                x: 0,
                y: 0,
                target
            });
            if (newTarget && typeof onDropEnter === "function") onDropEnter({
                type: "dropenter",
                x: 0,
                y: 0,
                target: newTarget
            });
            targetRef.current = newTarget;
            setTarget(newTarget);
        },
        isDropTarget (dropTarget) {
            let target = targetRef.current;
            if (isEqualDropTarget(dropTarget, target)) return true;
            // Check if the targets point at the same point between two items, one referring before, and the other after.
            if ((dropTarget === null || dropTarget === void 0 ? void 0 : dropTarget.type) === "item" && (target === null || target === void 0 ? void 0 : target.type) === "item" && dropTarget.key !== target.key && dropTarget.dropPosition !== target.dropPosition && dropTarget.dropPosition !== "on" && target.dropPosition !== "on") return isEqualDropTarget(getOppositeTarget(dropTarget), target) || isEqualDropTarget(dropTarget, getOppositeTarget(target));
            return false;
        },
        getDropOperation (e) {
            return defaultGetDropOperation(e);
        }
    };
}
function isEqualDropTarget(a, b) {
    if (!a) return !b;
    switch(a.type){
        case "root":
            return (b === null || b === void 0 ? void 0 : b.type) === "root";
        case "item":
            return (b === null || b === void 0 ? void 0 : b.type) === "item" && (b === null || b === void 0 ? void 0 : b.key) === a.key && (b === null || b === void 0 ? void 0 : b.dropPosition) === a.dropPosition;
    }
}

},{"react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"gEgJM":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useAsyncList", ()=>(0, _useAsyncList.useAsyncList));
parcelHelpers.export(exports, "useTreeData", ()=>(0, _useTreeData.useTreeData));
parcelHelpers.export(exports, "useListData", ()=>(0, _useListData.useListData));
var _useAsyncList = require("./useAsyncList");
var _useTreeData = require("./useTreeData");
var _useListData = require("./useListData");

},{"./useAsyncList":"1VZls","./useTreeData":"iGNFy","./useListData":"86cBK","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"1VZls":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Manages state for an immutable async loaded list data structure, and provides convenience methods to
 * update the data over time. Manages loading and error states, pagination, and sorting.
 */ parcelHelpers.export(exports, "useAsyncList", ()=>useAsyncList);
var _useListData = require("./useListData");
var _react = require("react");
function reducer(data, action) {
    let selectedKeys;
    switch(data.state){
        case "idle":
        case "error":
            switch(action.type){
                case "loading":
                case "loadingMore":
                case "sorting":
                case "filtering":
                    var _action_filterText, _action_sortDescriptor;
                    return {
                        ...data,
                        filterText: (_action_filterText = action.filterText) !== null && _action_filterText !== void 0 ? _action_filterText : data.filterText,
                        state: action.type,
                        // Reset items to an empty list if loading, but not when sorting.
                        items: action.type === "loading" ? [] : data.items,
                        sortDescriptor: (_action_sortDescriptor = action.sortDescriptor) !== null && _action_sortDescriptor !== void 0 ? _action_sortDescriptor : data.sortDescriptor,
                        abortController: action.abortController
                    };
                case "update":
                    return {
                        ...data,
                        ...action.updater(data)
                    };
                case "success":
                case "error":
                    return data;
                default:
                    throw new Error(`Invalid action "${action.type}" in state "${data.state}"`);
            }
        case "loading":
        case "sorting":
        case "filtering":
            switch(action.type){
                case "success":
                    // Ignore if there is a newer abortcontroller in state.
                    // This means that multiple requests were going at once.
                    // We want to take only the latest result.
                    if (action.abortController !== data.abortController) return data;
                    var _action_selectedKeys;
                    selectedKeys = (_action_selectedKeys = action.selectedKeys) !== null && _action_selectedKeys !== void 0 ? _action_selectedKeys : data.selectedKeys;
                    var _action_filterText1, _action_sortDescriptor1;
                    return {
                        ...data,
                        filterText: (_action_filterText1 = action.filterText) !== null && _action_filterText1 !== void 0 ? _action_filterText1 : data.filterText,
                        state: "idle",
                        items: [
                            ...action.items
                        ],
                        selectedKeys: selectedKeys === "all" ? "all" : new Set(selectedKeys),
                        sortDescriptor: (_action_sortDescriptor1 = action.sortDescriptor) !== null && _action_sortDescriptor1 !== void 0 ? _action_sortDescriptor1 : data.sortDescriptor,
                        abortController: null,
                        cursor: action.cursor
                    };
                case "error":
                    if (action.abortController !== data.abortController) return data;
                    return {
                        ...data,
                        state: "error",
                        error: action.error,
                        abortController: null
                    };
                case "loading":
                case "loadingMore":
                case "sorting":
                case "filtering":
                    // We're already loading, and another load was triggered at the same time.
                    // We need to abort the previous load and start a new one.
                    data.abortController.abort();
                    var _action_filterText2;
                    return {
                        ...data,
                        filterText: (_action_filterText2 = action.filterText) !== null && _action_filterText2 !== void 0 ? _action_filterText2 : data.filterText,
                        state: action.type,
                        // Reset items to an empty list if loading, but not when sorting.
                        items: action.type === "loading" ? [] : data.items,
                        abortController: action.abortController
                    };
                case "update":
                    // We're already loading, and an update happened at the same time (e.g. selectedKey changed).
                    // Update data but don't abort previous load.
                    return {
                        ...data,
                        ...action.updater(data)
                    };
                default:
                    throw new Error(`Invalid action "${action.type}" in state "${data.state}"`);
            }
        case "loadingMore":
            switch(action.type){
                case "success":
                    var _action_selectedKeys1;
                    selectedKeys = data.selectedKeys === "all" || action.selectedKeys === "all" ? "all" : new Set([
                        ...data.selectedKeys,
                        ...(_action_selectedKeys1 = action.selectedKeys) !== null && _action_selectedKeys1 !== void 0 ? _action_selectedKeys1 : []
                    ]);
                    var _action_sortDescriptor2;
                    // Append the new items
                    return {
                        ...data,
                        state: "idle",
                        items: [
                            ...data.items,
                            ...action.items
                        ],
                        selectedKeys,
                        sortDescriptor: (_action_sortDescriptor2 = action.sortDescriptor) !== null && _action_sortDescriptor2 !== void 0 ? _action_sortDescriptor2 : data.sortDescriptor,
                        abortController: null,
                        cursor: action.cursor
                    };
                case "error":
                    if (action.abortController !== data.abortController) return data;
                    return {
                        ...data,
                        state: "error",
                        error: action.error
                    };
                case "loading":
                case "sorting":
                case "filtering":
                    // We're already loading more, and another load was triggered at the same time.
                    // We need to abort the previous load more and start a new one.
                    data.abortController.abort();
                    var _action_filterText3;
                    return {
                        ...data,
                        filterText: (_action_filterText3 = action.filterText) !== null && _action_filterText3 !== void 0 ? _action_filterText3 : data.filterText,
                        state: action.type,
                        // Reset items to an empty list if loading, but not when sorting.
                        items: action.type === "loading" ? [] : data.items,
                        abortController: action.abortController
                    };
                case "loadingMore":
                    // If already loading more and another loading more is triggered, abort the new load more since
                    // it is a duplicate request since the cursor hasn't been updated.
                    // Do not overwrite the data.abortController
                    action.abortController.abort();
                    return data;
                case "update":
                    // We're already loading, and an update happened at the same time (e.g. selectedKey changed).
                    // Update data but don't abort previous load.
                    return {
                        ...data,
                        ...action.updater(data)
                    };
                default:
                    throw new Error(`Invalid action "${action.type}" in state "${data.state}"`);
            }
        default:
            throw new Error(`Invalid state "${data.state}"`);
    }
}
function useAsyncList(options) {
    const { load, sort, initialSelectedKeys, initialSortDescriptor, getKey = (item)=>item.id || item.key, initialFilterText = "" } = options;
    let [data, dispatch] = (0, _react.useReducer)(reducer, {
        state: "idle",
        error: null,
        items: [],
        selectedKeys: initialSelectedKeys === "all" ? "all" : new Set(initialSelectedKeys),
        sortDescriptor: initialSortDescriptor,
        filterText: initialFilterText
    });
    const dispatchFetch = async (action, fn)=>{
        let abortController = new AbortController();
        try {
            dispatch({
                ...action,
                abortController
            });
            var _action_filterText;
            let previousFilterText = (_action_filterText = action.filterText) !== null && _action_filterText !== void 0 ? _action_filterText : data.filterText;
            var _action_sortDescriptor;
            let response = await fn({
                items: data.items.slice(),
                selectedKeys: data.selectedKeys,
                sortDescriptor: (_action_sortDescriptor = action.sortDescriptor) !== null && _action_sortDescriptor !== void 0 ? _action_sortDescriptor : data.sortDescriptor,
                signal: abortController.signal,
                cursor: action.type === "loadingMore" ? data.cursor : null,
                filterText: previousFilterText
            });
            var _response_filterText;
            let filterText = (_response_filterText = response.filterText) !== null && _response_filterText !== void 0 ? _response_filterText : previousFilterText;
            dispatch({
                type: "success",
                ...response,
                abortController
            });
            // Fetch a new filtered list if filterText is updated via `load` response func rather than list.setFilterText
            // Only do this if not aborted (e.g. user triggers another filter action before load completes)
            if (filterText && filterText !== previousFilterText && !abortController.signal.aborted) dispatchFetch({
                type: "filtering",
                filterText
            }, load);
        } catch (e) {
            dispatch({
                type: "error",
                error: e,
                abortController
            });
        }
    };
    let didDispatchInitialFetch = (0, _react.useRef)(false);
    (0, _react.useEffect)(()=>{
        if (!didDispatchInitialFetch.current) {
            dispatchFetch({
                type: "loading"
            }, load);
            didDispatchInitialFetch.current = true;
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return {
        items: data.items,
        selectedKeys: data.selectedKeys,
        sortDescriptor: data.sortDescriptor,
        isLoading: data.state === "loading" || data.state === "loadingMore" || data.state === "sorting" || data.state === "filtering",
        loadingState: data.state,
        error: data.error,
        filterText: data.filterText,
        getItem (key) {
            return data.items.find((item)=>getKey(item) === key);
        },
        reload () {
            dispatchFetch({
                type: "loading"
            }, load);
        },
        loadMore () {
            // Ignore if already loading more or if performing server side filtering.
            if (data.state === "loadingMore" || data.state === "filtering" || data.cursor == null) return;
            dispatchFetch({
                type: "loadingMore"
            }, load);
        },
        sort (sortDescriptor) {
            dispatchFetch({
                type: "sorting",
                sortDescriptor
            }, sort || load);
        },
        ...(0, _useListData.createListActions)({
            ...options,
            getKey,
            cursor: data.cursor
        }, (fn)=>{
            dispatch({
                type: "update",
                updater: fn
            });
        }),
        setFilterText (filterText) {
            dispatchFetch({
                type: "filtering",
                filterText
            }, load);
        }
    };
}

},{"./useListData":"86cBK","react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"86cBK":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Manages state for an immutable list data structure, and provides convenience methods to
 * update the data over time.
 */ parcelHelpers.export(exports, "useListData", ()=>useListData);
parcelHelpers.export(exports, "createListActions", ()=>createListActions);
var _react = require("react");
function useListData(options) {
    let { initialItems = [], initialSelectedKeys, getKey = (item)=>item.id || item.key, filter, initialFilterText = "" } = options;
    // Store both items and filteredItems in state so we can go back to the unfiltered list
    let [state, setState] = (0, _react.useState)({
        items: initialItems,
        selectedKeys: initialSelectedKeys === "all" ? "all" : new Set(initialSelectedKeys || []),
        filterText: initialFilterText
    });
    let filteredItems = (0, _react.useMemo)(()=>filter ? state.items.filter((item)=>filter(item, state.filterText)) : state.items, [
        state.items,
        state.filterText,
        filter
    ]);
    return {
        ...state,
        items: filteredItems,
        ...createListActions({
            getKey
        }, setState),
        getItem (key) {
            return state.items.find((item)=>getKey(item) === key);
        }
    };
}
function createListActions(opts, dispatch) {
    let { cursor, getKey } = opts;
    return {
        setSelectedKeys (selectedKeys) {
            dispatch((state)=>({
                    ...state,
                    selectedKeys
                }));
        },
        setFilterText (filterText) {
            dispatch((state)=>({
                    ...state,
                    filterText
                }));
        },
        insert (index, ...values) {
            dispatch((state)=>insert(state, index, ...values));
        },
        insertBefore (key, ...values) {
            dispatch((state)=>{
                let index = state.items.findIndex((item)=>getKey(item) === key);
                if (index === -1) {
                    if (state.items.length === 0) index = 0;
                    else return state;
                }
                return insert(state, index, ...values);
            });
        },
        insertAfter (key, ...values) {
            dispatch((state)=>{
                let index = state.items.findIndex((item)=>getKey(item) === key);
                if (index === -1) {
                    if (state.items.length === 0) index = 0;
                    else return state;
                }
                return insert(state, index + 1, ...values);
            });
        },
        prepend (...values) {
            dispatch((state)=>insert(state, 0, ...values));
        },
        append (...values) {
            dispatch((state)=>insert(state, state.items.length, ...values));
        },
        remove (...keys) {
            dispatch((state)=>{
                let keySet = new Set(keys);
                let items = state.items.filter((item)=>!keySet.has(getKey(item)));
                let selection = "all";
                if (state.selectedKeys !== "all") {
                    selection = new Set(state.selectedKeys);
                    for (let key of keys)selection.delete(key);
                }
                if (cursor == null && items.length === 0) selection = new Set();
                return {
                    ...state,
                    items,
                    selectedKeys: selection
                };
            });
        },
        removeSelectedItems () {
            dispatch((state)=>{
                if (state.selectedKeys === "all") return {
                    ...state,
                    items: [],
                    selectedKeys: new Set()
                };
                let selectedKeys = state.selectedKeys;
                let items = state.items.filter((item)=>!selectedKeys.has(getKey(item)));
                return {
                    ...state,
                    items,
                    selectedKeys: new Set()
                };
            });
        },
        move (key, toIndex) {
            dispatch((state)=>{
                let index = state.items.findIndex((item)=>getKey(item) === key);
                if (index === -1) return state;
                let copy = state.items.slice();
                let [item] = copy.splice(index, 1);
                copy.splice(toIndex, 0, item);
                return {
                    ...state,
                    items: copy
                };
            });
        },
        moveBefore (key, keys) {
            dispatch((state)=>{
                let toIndex = state.items.findIndex((item)=>getKey(item) === key);
                if (toIndex === -1) return state;
                // Find indices of keys to move. Sort them so that the order in the list is retained.
                let keyArray = Array.isArray(keys) ? keys : [
                    ...keys
                ];
                let indices = keyArray.map((key)=>state.items.findIndex((item)=>getKey(item) === key)).sort((a, b)=>a - b);
                return move(state, indices, toIndex);
            });
        },
        moveAfter (key, keys) {
            dispatch((state)=>{
                let toIndex = state.items.findIndex((item)=>getKey(item) === key);
                if (toIndex === -1) return state;
                let keyArray = Array.isArray(keys) ? keys : [
                    ...keys
                ];
                let indices = keyArray.map((key)=>state.items.findIndex((item)=>getKey(item) === key)).sort((a, b)=>a - b);
                return move(state, indices, toIndex + 1);
            });
        },
        update (key, newValue) {
            dispatch((state)=>{
                let index = state.items.findIndex((item)=>getKey(item) === key);
                if (index === -1) return state;
                return {
                    ...state,
                    items: [
                        ...state.items.slice(0, index),
                        newValue,
                        ...state.items.slice(index + 1)
                    ]
                };
            });
        }
    };
}
function insert(state, index, ...values) {
    return {
        ...state,
        items: [
            ...state.items.slice(0, index),
            ...values,
            ...state.items.slice(index)
        ]
    };
}
function move(state, indices, toIndex) {
    // Shift the target down by the number of items being moved from before the target
    toIndex -= indices.filter((index)=>index < toIndex).length;
    let moves = indices.map((from)=>({
            from,
            to: toIndex++
        }));
    // Shift later from indices down if they have a larger index
    for(let i = 0; i < moves.length; i++){
        let a = moves[i].from;
        for(let j = i; j < moves.length; j++){
            let b = moves[j].from;
            if (b > a) moves[j].from--;
        }
    }
    // Interleave the moves so they can be applied one by one rather than all at once
    for(let i = 0; i < moves.length; i++){
        let a = moves[i];
        for(let j = moves.length - 1; j > i; j--){
            let b = moves[j];
            if (b.from < a.to) a.to++;
            else b.from++;
        }
    }
    let copy = state.items.slice();
    for (let move of moves){
        let [item] = copy.splice(move.from, 1);
        copy.splice(move.to, 0, item);
    }
    return {
        ...state,
        items: copy
    };
}

},{"react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"iGNFy":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Manages state for an immutable tree data structure, and provides convenience methods to
 * update the data over time.
 */ parcelHelpers.export(exports, "useTreeData", ()=>useTreeData);
var _react = require("react");
function useTreeData(options) {
    let { initialItems = [], initialSelectedKeys, getKey = (item)=>item.id || item.key, getChildren = (item)=>item.children } = options;
    // We only want to compute this on initial render.
    let [tree, setItems] = (0, _react.useState)(()=>buildTree(initialItems, new Map()));
    let { items, nodeMap } = tree;
    let [selectedKeys, setSelectedKeys] = (0, _react.useState)(new Set(initialSelectedKeys || []));
    function buildTree(initialItems = [], map, parentKey) {
        return {
            items: initialItems.map((item)=>{
                let node = {
                    key: getKey(item),
                    parentKey: parentKey,
                    value: item,
                    children: null
                };
                node.children = buildTree(getChildren(item), map, node.key).items;
                map.set(node.key, node);
                return node;
            }),
            nodeMap: map
        };
    }
    function updateTree(items, key, update, originalMap) {
        let node = originalMap.get(key);
        if (!node) return {
            items,
            nodeMap: originalMap
        };
        let map = new Map(originalMap);
        // Create a new node. If null, then delete the node, otherwise replace.
        let newNode = update(node);
        if (newNode == null) deleteNode(node, map);
        else addNode(newNode, map);
        // Walk up the tree and update each parent to refer to the new children.
        while(node.parentKey){
            let nextParent = map.get(node.parentKey);
            let copy = {
                key: nextParent.key,
                parentKey: nextParent.parentKey,
                value: nextParent.value,
                children: null
            };
            let children = nextParent.children;
            if (newNode == null) children = children.filter((c)=>c !== node);
            copy.children = children.map((child)=>{
                if (child === node) return newNode;
                return child;
            });
            map.set(copy.key, copy);
            newNode = copy;
            node = nextParent;
        }
        if (newNode == null) items = items.filter((c)=>c !== node);
        return {
            items: items.map((item)=>{
                if (item === node) return newNode;
                return item;
            }),
            nodeMap: map
        };
    }
    function addNode(node, map) {
        map.set(node.key, node);
        for (let child of node.children)addNode(child, map);
    }
    function deleteNode(node, map) {
        map.delete(node.key);
        for (let child of node.children)deleteNode(child, map);
    }
    return {
        items,
        selectedKeys,
        setSelectedKeys,
        getItem (key) {
            return nodeMap.get(key);
        },
        insert (parentKey, index, ...values) {
            setItems(({ items, nodeMap: originalMap })=>{
                let { items: newNodes, nodeMap: newMap } = buildTree(values, originalMap, parentKey);
                // If parentKey is null, insert into the root.
                if (parentKey == null) return {
                    items: [
                        ...items.slice(0, index),
                        ...newNodes,
                        ...items.slice(index)
                    ],
                    nodeMap: newMap
                };
                // Otherwise, update the parent node and its ancestors.
                return updateTree(items, parentKey, (parentNode)=>({
                        key: parentNode.key,
                        parentKey: parentNode.parentKey,
                        value: parentNode.value,
                        children: [
                            ...parentNode.children.slice(0, index),
                            ...newNodes,
                            ...parentNode.children.slice(index)
                        ]
                    }), newMap);
            });
        },
        insertBefore (key, ...values) {
            let node = nodeMap.get(key);
            if (!node) return;
            let parentNode = nodeMap.get(node.parentKey);
            let nodes = parentNode ? parentNode.children : items;
            let index = nodes.indexOf(node);
            this.insert(parentNode === null || parentNode === void 0 ? void 0 : parentNode.key, index, ...values);
        },
        insertAfter (key, ...values) {
            let node = nodeMap.get(key);
            if (!node) return;
            let parentNode = nodeMap.get(node.parentKey);
            let nodes = parentNode ? parentNode.children : items;
            let index = nodes.indexOf(node);
            this.insert(parentNode === null || parentNode === void 0 ? void 0 : parentNode.key, index + 1, ...values);
        },
        prepend (parentKey, ...values) {
            this.insert(parentKey, 0, ...values);
        },
        append (parentKey, ...values) {
            if (parentKey == null) this.insert(null, items.length, ...values);
            else {
                let parentNode = nodeMap.get(parentKey);
                if (!parentNode) return;
                this.insert(parentKey, parentNode.children.length, ...values);
            }
        },
        remove (...keys) {
            if (keys.length === 0) return;
            let newItems = items;
            let prevMap = nodeMap;
            let newTree;
            for (let key of keys){
                newTree = updateTree(newItems, key, ()=>null, prevMap);
                prevMap = newTree.nodeMap;
                newItems = newTree.items;
            }
            setItems(newTree);
            let selection = new Set(selectedKeys);
            for (let key of selectedKeys)if (!newTree.nodeMap.has(key)) selection.delete(key);
            setSelectedKeys(selection);
        },
        removeSelectedItems () {
            this.remove(...selectedKeys);
        },
        move (key, toParentKey, index) {
            setItems(({ items, nodeMap: originalMap })=>{
                let node = originalMap.get(key);
                if (!node) return {
                    items,
                    nodeMap: originalMap
                };
                let { items: newItems, nodeMap: newMap } = updateTree(items, key, ()=>null, originalMap);
                const movedNode = {
                    ...node,
                    parentKey: toParentKey
                };
                // If parentKey is null, insert into the root.
                if (toParentKey == null) return {
                    items: [
                        ...newItems.slice(0, index),
                        movedNode,
                        ...newItems.slice(index)
                    ],
                    nodeMap: newMap
                };
                // Otherwise, update the parent node and its ancestors.
                return updateTree(newItems, toParentKey, (parentNode)=>({
                        key: parentNode.key,
                        parentKey: parentNode.parentKey,
                        value: parentNode.value,
                        children: [
                            ...parentNode.children.slice(0, index),
                            movedNode,
                            ...parentNode.children.slice(index)
                        ]
                    }), newMap);
            });
        },
        update (oldKey, newValue) {
            setItems(({ items, nodeMap: originalMap })=>updateTree(items, oldKey, (oldNode)=>{
                    let node = {
                        key: oldNode.key,
                        parentKey: oldNode.parentKey,
                        value: newValue,
                        children: null
                    };
                    let tree = buildTree(getChildren(newValue), originalMap, node.key);
                    node.children = tree.items;
                    return node;
                }, originalMap));
        }
    };
}

},{"react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"iqDQI":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useMenuTriggerState", ()=>(0, _useMenuTriggerState.useMenuTriggerState));
parcelHelpers.export(exports, "UNSTABLE_useSubmenuTriggerState", ()=>(0, _useSubmenuTriggerState.UNSTABLE_useSubmenuTriggerState));
var _useMenuTriggerState = require("./useMenuTriggerState");
var _useSubmenuTriggerState = require("./useSubmenuTriggerState");

},{"./useMenuTriggerState":"8PkMo","./useSubmenuTriggerState":"cGkAf","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"8PkMo":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Manages state for a menu trigger. Tracks whether the menu is currently open,
 * and controls which item will receive focus when it opens. Also tracks the open submenus within
 * the menu tree via their trigger keys.
 */ parcelHelpers.export(exports, "useMenuTriggerState", ()=>useMenuTriggerState);
var _overlays = require("@react-stately/overlays");
var _react = require("react");
function useMenuTriggerState(props) {
    let overlayTriggerState = (0, _overlays.useOverlayTriggerState)(props);
    let [focusStrategy, setFocusStrategy] = (0, _react.useState)(null);
    let [expandedKeysStack, setExpandedKeysStack] = (0, _react.useState)([]);
    let closeAll = ()=>{
        setExpandedKeysStack([]);
        overlayTriggerState.close();
    };
    let openSubmenu = (triggerKey, level)=>{
        setExpandedKeysStack((oldStack)=>{
            if (level > oldStack.length) return oldStack;
            return [
                ...oldStack.slice(0, level),
                triggerKey
            ];
        });
    };
    let closeSubmenu = (triggerKey, level)=>{
        setExpandedKeysStack((oldStack)=>{
            let key = oldStack[level];
            if (key === triggerKey) return oldStack.slice(0, level);
            else return oldStack;
        });
    };
    return {
        focusStrategy,
        ...overlayTriggerState,
        open (focusStrategy = null) {
            setFocusStrategy(focusStrategy);
            overlayTriggerState.open();
        },
        toggle (focusStrategy = null) {
            setFocusStrategy(focusStrategy);
            overlayTriggerState.toggle();
        },
        close () {
            closeAll();
        },
        UNSTABLE_expandedKeysStack: expandedKeysStack,
        UNSTABLE_openSubmenu: openSubmenu,
        UNSTABLE_closeSubmenu: closeSubmenu
    };
}

},{"@react-stately/overlays":"5uxM4","react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"cGkAf":[function(require,module,exports) {
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Manages state for a submenu trigger. Tracks whether the submenu is currently open, the level of the submenu, and
 * controls which item will receive focus when it opens.
 */ parcelHelpers.export(exports, "UNSTABLE_useSubmenuTriggerState", ()=>UNSTABLE_useSubmenuTriggerState);
var _react = require("react");
function UNSTABLE_useSubmenuTriggerState(props, state) {
    let { triggerKey } = props;
    let { UNSTABLE_expandedKeysStack, UNSTABLE_openSubmenu, UNSTABLE_closeSubmenu, close: closeAll } = state;
    let [submenuLevel] = (0, _react.useState)(UNSTABLE_expandedKeysStack === null || UNSTABLE_expandedKeysStack === void 0 ? void 0 : UNSTABLE_expandedKeysStack.length);
    let isOpen = (0, _react.useMemo)(()=>UNSTABLE_expandedKeysStack[submenuLevel] === triggerKey, [
        UNSTABLE_expandedKeysStack,
        triggerKey,
        submenuLevel
    ]);
    let [focusStrategy, setFocusStrategy] = (0, _react.useState)(null);
    let open = (0, _react.useCallback)((focusStrategy = null)=>{
        setFocusStrategy(focusStrategy);
        UNSTABLE_openSubmenu(triggerKey, submenuLevel);
    }, [
        UNSTABLE_openSubmenu,
        submenuLevel,
        triggerKey
    ]);
    let close = (0, _react.useCallback)(()=>{
        setFocusStrategy(null);
        UNSTABLE_closeSubmenu(triggerKey, submenuLevel);
    }, [
        UNSTABLE_closeSubmenu,
        submenuLevel,
        triggerKey
    ]);
    let toggle = (0, _react.useCallback)((focusStrategy = null)=>{
        setFocusStrategy(focusStrategy);
        if (isOpen) close();
        else open(focusStrategy);
    }, [
        close,
        open,
        isOpen
    ]);
    return (0, _react.useMemo)(()=>({
            focusStrategy,
            isOpen,
            open,
            close,
            closeAll,
            submenuLevel,
            // TODO: Placeholders that aren't used but give us parity with OverlayTriggerState so we can use this in Popover. Refactor if we update Popover via
            // https://github.com/adobe/react-spectrum/pull/4976#discussion_r1336472863
            setOpen: ()=>{},
            toggle
        }), [
        isOpen,
        open,
        close,
        closeAll,
        focusStrategy,
        toggle,
        submenuLevel
    ]);
}

},{"react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"l3Rr3":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useNumberFieldState", ()=>(0, _useNumberFieldState.useNumberFieldState));
var _useNumberFieldState = require("./useNumberFieldState");

},{"./useNumberFieldState":"1xTYl","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"1xTYl":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides state management for a number field component. Number fields allow users to enter a number,
 * and increment or decrement the value using stepper buttons.
 */ parcelHelpers.export(exports, "useNumberFieldState", ()=>useNumberFieldState);
var _utils = require("@react-stately/utils");
var _form = require("@react-stately/form");
var _number = require("@internationalized/number");
var _react = require("react");
function useNumberFieldState(props) {
    let { minValue, maxValue, step, formatOptions, value, defaultValue = NaN, onChange, locale, isDisabled, isReadOnly } = props;
    if (value === null) value = NaN;
    if (value !== undefined && !isNaN(value)) {
        if (step !== undefined && !isNaN(step)) value = (0, _utils.snapValueToStep)(value, minValue, maxValue, step);
        else value = (0, _utils.clamp)(value, minValue, maxValue);
    }
    if (!isNaN(defaultValue)) {
        if (step !== undefined && !isNaN(step)) defaultValue = (0, _utils.snapValueToStep)(defaultValue, minValue, maxValue, step);
        else defaultValue = (0, _utils.clamp)(defaultValue, minValue, maxValue);
    }
    let [numberValue, setNumberValue] = (0, _utils.useControlledState)(value, isNaN(defaultValue) ? NaN : defaultValue, onChange);
    let [inputValue, setInputValue] = (0, _react.useState)(()=>isNaN(numberValue) ? "" : new (0, _number.NumberFormatter)(locale, formatOptions).format(numberValue));
    let numberParser = (0, _react.useMemo)(()=>new (0, _number.NumberParser)(locale, formatOptions), [
        locale,
        formatOptions
    ]);
    let numberingSystem = (0, _react.useMemo)(()=>numberParser.getNumberingSystem(inputValue), [
        numberParser,
        inputValue
    ]);
    let formatter = (0, _react.useMemo)(()=>new (0, _number.NumberFormatter)(locale, {
            ...formatOptions,
            numberingSystem
        }), [
        locale,
        formatOptions,
        numberingSystem
    ]);
    let intlOptions = (0, _react.useMemo)(()=>formatter.resolvedOptions(), [
        formatter
    ]);
    let format = (0, _react.useCallback)((value)=>isNaN(value) || value === null ? "" : formatter.format(value), [
        formatter
    ]);
    let validation = (0, _form.useFormValidationState)({
        ...props,
        value: numberValue
    });
    let clampStep = step !== undefined && !isNaN(step) ? step : 1;
    if (intlOptions.style === "percent" && (step === undefined || isNaN(step))) clampStep = 0.01;
    // Update the input value when the number value or format options change. This is done
    // in a useEffect so that the controlled behavior is correct and we only update the
    // textfield after prop changes.
    let [prevValue, setPrevValue] = (0, _react.useState)(numberValue);
    let [prevLocale, setPrevLocale] = (0, _react.useState)(locale);
    let [prevFormatOptions, setPrevFormatOptions] = (0, _react.useState)(formatOptions);
    if (!Object.is(numberValue, prevValue) || locale !== prevLocale || formatOptions !== prevFormatOptions) {
        setInputValue(format(numberValue));
        setPrevValue(numberValue);
        setPrevLocale(locale);
        setPrevFormatOptions(formatOptions);
    }
    let parsedValue = (0, _react.useMemo)(()=>numberParser.parse(inputValue), [
        numberParser,
        inputValue
    ]);
    let commit = ()=>{
        // Set to empty state if input value is empty
        if (!inputValue.length) {
            setNumberValue(NaN);
            setInputValue(value === undefined ? "" : format(numberValue));
            return;
        }
        // if it failed to parse, then reset input to formatted version of current number
        if (isNaN(parsedValue)) {
            setInputValue(format(numberValue));
            return;
        }
        // Clamp to min and max, round to the nearest step, and round to specified number of digits
        let clampedValue;
        if (step === undefined || isNaN(step)) clampedValue = (0, _utils.clamp)(parsedValue, minValue, maxValue);
        else clampedValue = (0, _utils.snapValueToStep)(parsedValue, minValue, maxValue, step);
        clampedValue = numberParser.parse(format(clampedValue));
        setNumberValue(clampedValue);
        // in a controlled state, the numberValue won't change, so we won't go back to our old input without help
        setInputValue(format(value === undefined ? clampedValue : numberValue));
    };
    let safeNextStep = (operation, minMax = 0)=>{
        let prev = parsedValue;
        if (isNaN(prev)) {
            // if the input is empty, start from the min/max value when incrementing/decrementing,
            // or zero if there is no min/max value defined.
            let newValue = isNaN(minMax) ? 0 : minMax;
            return (0, _utils.snapValueToStep)(newValue, minValue, maxValue, clampStep);
        } else {
            // otherwise, first snap the current value to the nearest step. if it moves in the direction
            // we're going, use that value, otherwise add the step and snap that value.
            let newValue = (0, _utils.snapValueToStep)(prev, minValue, maxValue, clampStep);
            if (operation === "+" && newValue > prev || operation === "-" && newValue < prev) return newValue;
            return (0, _utils.snapValueToStep)(handleDecimalOperation(operation, prev, clampStep), minValue, maxValue, clampStep);
        }
    };
    let increment = ()=>{
        let newValue = safeNextStep("+", minValue);
        // if we've arrived at the same value that was previously in the state, the
        // input value should be updated to match
        // ex type 4, press increment, highlight the number in the input, type 4 again, press increment
        // you'd be at 5, then incrementing to 5 again, so no re-render would happen and 4 would be left in the input
        if (newValue === numberValue) setInputValue(format(newValue));
        setNumberValue(newValue);
        validation.commitValidation();
    };
    let decrement = ()=>{
        let newValue = safeNextStep("-", maxValue);
        if (newValue === numberValue) setInputValue(format(newValue));
        setNumberValue(newValue);
        validation.commitValidation();
    };
    let incrementToMax = ()=>{
        if (maxValue != null) {
            setNumberValue((0, _utils.snapValueToStep)(maxValue, minValue, maxValue, clampStep));
            validation.commitValidation();
        }
    };
    let decrementToMin = ()=>{
        if (minValue != null) {
            setNumberValue(minValue);
            validation.commitValidation();
        }
    };
    let canIncrement = (0, _react.useMemo)(()=>!isDisabled && !isReadOnly && (isNaN(parsedValue) || maxValue === undefined || isNaN(maxValue) || (0, _utils.snapValueToStep)(parsedValue, minValue, maxValue, clampStep) > parsedValue || handleDecimalOperation("+", parsedValue, clampStep) <= maxValue), [
        isDisabled,
        isReadOnly,
        minValue,
        maxValue,
        clampStep,
        parsedValue
    ]);
    let canDecrement = (0, _react.useMemo)(()=>!isDisabled && !isReadOnly && (isNaN(parsedValue) || minValue === undefined || isNaN(minValue) || (0, _utils.snapValueToStep)(parsedValue, minValue, maxValue, clampStep) < parsedValue || handleDecimalOperation("-", parsedValue, clampStep) >= minValue), [
        isDisabled,
        isReadOnly,
        minValue,
        maxValue,
        clampStep,
        parsedValue
    ]);
    let validate = (value)=>numberParser.isValidPartialNumber(value, minValue, maxValue);
    return {
        ...validation,
        validate,
        increment,
        incrementToMax,
        decrement,
        decrementToMin,
        canIncrement,
        canDecrement,
        minValue,
        maxValue,
        numberValue: parsedValue,
        setNumberValue,
        setInputValue,
        inputValue,
        commit
    };
}
function handleDecimalOperation(operator, value1, value2) {
    let result = operator === "+" ? value1 + value2 : value1 - value2;
    // Check if we have decimals
    if (value1 % 1 !== 0 || value2 % 1 !== 0) {
        const value1Decimal = value1.toString().split(".");
        const value2Decimal = value2.toString().split(".");
        const value1DecimalLength = value1Decimal[1] && value1Decimal[1].length || 0;
        const value2DecimalLength = value2Decimal[1] && value2Decimal[1].length || 0;
        const multiplier = Math.pow(10, Math.max(value1DecimalLength, value2DecimalLength));
        // Transform the decimals to integers based on the precision
        value1 = Math.round(value1 * multiplier);
        value2 = Math.round(value2 * multiplier);
        // Perform the operation on integers values to make sure we don't get a fancy decimal value
        result = operator === "+" ? value1 + value2 : value1 - value2;
        // Transform the integer result back to decimal
        result /= multiplier;
    }
    return result;
}

},{"@react-stately/utils":"cpDPf","@react-stately/form":"9yZqm","@internationalized/number":"h1VQt","react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"qkKdG":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useRadioGroupState", ()=>(0, _useRadioGroupState.useRadioGroupState));
var _useRadioGroupState = require("./useRadioGroupState");

},{"./useRadioGroupState":"cELcN","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"cELcN":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides state management for a radio group component. Provides a name for the group,
 * and manages selection and focus state.
 */ parcelHelpers.export(exports, "useRadioGroupState", ()=>useRadioGroupState);
var _form = require("@react-stately/form");
var _utils = require("@react-stately/utils");
var _react = require("react");
let instance = Math.round(Math.random() * 10000000000);
let i = 0;
function useRadioGroupState(props) {
    // Preserved here for backward compatibility. React Aria now generates the name instead of stately.
    let name = (0, _react.useMemo)(()=>props.name || `radio-group-${instance}-${++i}`, [
        props.name
    ]);
    var _props_defaultValue;
    let [selectedValue, setSelected] = (0, _utils.useControlledState)(props.value, (_props_defaultValue = props.defaultValue) !== null && _props_defaultValue !== void 0 ? _props_defaultValue : null, props.onChange);
    let [lastFocusedValue, setLastFocusedValue] = (0, _react.useState)(null);
    let validation = (0, _form.useFormValidationState)({
        ...props,
        value: selectedValue
    });
    let setSelectedValue = (value)=>{
        if (!props.isReadOnly && !props.isDisabled) {
            setSelected(value);
            validation.commitValidation();
        }
    };
    let isInvalid = validation.displayValidation.isInvalid;
    return {
        ...validation,
        name,
        selectedValue: selectedValue,
        setSelectedValue,
        lastFocusedValue,
        setLastFocusedValue,
        isDisabled: props.isDisabled || false,
        isReadOnly: props.isReadOnly || false,
        isRequired: props.isRequired || false,
        validationState: props.validationState || (isInvalid ? "invalid" : null),
        isInvalid
    };
}

},{"@react-stately/form":"9yZqm","@react-stately/utils":"cpDPf","react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"iPYi5":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useSearchFieldState", ()=>(0, _useSearchFieldState.useSearchFieldState));
var _useSearchFieldState = require("./useSearchFieldState");

},{"./useSearchFieldState":"6EJnI","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"6EJnI":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides state management for a search field.
 */ parcelHelpers.export(exports, "useSearchFieldState", ()=>useSearchFieldState);
var _utils = require("@react-stately/utils");
function useSearchFieldState(props) {
    let [value, setValue] = (0, _utils.useControlledState)(toString(props.value), toString(props.defaultValue) || "", props.onChange);
    return {
        value,
        setValue
    };
}
function toString(val) {
    if (val == null) return;
    return val.toString();
}

},{"@react-stately/utils":"cpDPf","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"4LWw9":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useSelectState", ()=>(0, _useSelectState.useSelectState));
var _useSelectState = require("./useSelectState");

},{"./useSelectState":"1BJKr","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"1BJKr":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides state management for a select component. Handles building a collection
 * of items from props, handles the open state for the popup menu, and manages
 * multiple selection state.
 */ parcelHelpers.export(exports, "useSelectState", ()=>useSelectState);
var _form = require("@react-stately/form");
var _overlays = require("@react-stately/overlays");
var _list = require("@react-stately/list");
var _react = require("react");
function useSelectState(props) {
    let triggerState = (0, _overlays.useOverlayTriggerState)(props);
    let [focusStrategy, setFocusStrategy] = (0, _react.useState)(null);
    let listState = (0, _list.useSingleSelectListState)({
        ...props,
        onSelectionChange: (key)=>{
            if (props.onSelectionChange != null) props.onSelectionChange(key);
            triggerState.close();
            validationState.commitValidation();
        }
    });
    let validationState = (0, _form.useFormValidationState)({
        ...props,
        value: listState.selectedKey
    });
    let [isFocused, setFocused] = (0, _react.useState)(false);
    return {
        ...validationState,
        ...listState,
        ...triggerState,
        focusStrategy,
        open (focusStrategy = null) {
            // Don't open if the collection is empty.
            if (listState.collection.size !== 0) {
                setFocusStrategy(focusStrategy);
                triggerState.open();
            }
        },
        toggle (focusStrategy = null) {
            if (listState.collection.size !== 0) {
                setFocusStrategy(focusStrategy);
                triggerState.toggle();
            }
        },
        isFocused,
        setFocused
    };
}

},{"@react-stately/form":"9yZqm","@react-stately/overlays":"5uxM4","@react-stately/list":"Cp0zP","react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"82Whk":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useSliderState", ()=>(0, _useSliderState.useSliderState));
var _useSliderState = require("./useSliderState");

},{"./useSliderState":"bgIcr","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"bgIcr":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides state management for a slider component. Stores values for all thumbs,
 * formats values for localization, and provides methods to update the position
 * of any thumbs.
 * @param props
 */ parcelHelpers.export(exports, "useSliderState", ()=>useSliderState);
var _utils = require("@react-stately/utils");
var _react = require("react");
const DEFAULT_MIN_VALUE = 0;
const DEFAULT_MAX_VALUE = 100;
const DEFAULT_STEP_VALUE = 1;
function useSliderState(props) {
    const { isDisabled = false, minValue = DEFAULT_MIN_VALUE, maxValue = DEFAULT_MAX_VALUE, numberFormatter: formatter, step = DEFAULT_STEP_VALUE, orientation = "horizontal" } = props;
    // Page step should be at least equal to step and always a multiple of the step.
    let pageSize = (0, _react.useMemo)(()=>{
        let calcPageSize = (maxValue - minValue) / 10;
        calcPageSize = (0, _utils.snapValueToStep)(calcPageSize, 0, calcPageSize + step, step);
        return Math.max(calcPageSize, step);
    }, [
        step,
        maxValue,
        minValue
    ]);
    let restrictValues = (0, _react.useCallback)((values)=>values === null || values === void 0 ? void 0 : values.map((val, idx)=>{
            let min = idx === 0 ? minValue : val[idx - 1];
            let max = idx === values.length - 1 ? maxValue : val[idx + 1];
            return (0, _utils.snapValueToStep)(val, min, max, step);
        }), [
        minValue,
        maxValue,
        step
    ]);
    let value = (0, _react.useMemo)(()=>restrictValues(convertValue(props.value)), [
        props.value
    ]);
    let defaultValue = (0, _react.useMemo)(()=>{
        var _convertValue;
        return restrictValues((_convertValue = convertValue(props.defaultValue)) !== null && _convertValue !== void 0 ? _convertValue : [
            minValue
        ]);
    }, [
        props.defaultValue,
        minValue
    ]);
    let onChange = createOnChange(props.value, props.defaultValue, props.onChange);
    let onChangeEnd = createOnChange(props.value, props.defaultValue, props.onChangeEnd);
    const [values, setValuesState] = (0, _utils.useControlledState)(value, defaultValue, onChange);
    const [isDraggings, setDraggingsState] = (0, _react.useState)(new Array(values.length).fill(false));
    const isEditablesRef = (0, _react.useRef)(new Array(values.length).fill(true));
    const [focusedIndex, setFocusedIndex] = (0, _react.useState)(undefined);
    const valuesRef = (0, _react.useRef)(values);
    const isDraggingsRef = (0, _react.useRef)(isDraggings);
    let setValues = (values)=>{
        valuesRef.current = values;
        setValuesState(values);
    };
    let setDraggings = (draggings)=>{
        isDraggingsRef.current = draggings;
        setDraggingsState(draggings);
    };
    function getValuePercent(value) {
        return (value - minValue) / (maxValue - minValue);
    }
    function getThumbMinValue(index) {
        return index === 0 ? minValue : values[index - 1];
    }
    function getThumbMaxValue(index) {
        return index === values.length - 1 ? maxValue : values[index + 1];
    }
    function isThumbEditable(index) {
        return isEditablesRef.current[index];
    }
    function setThumbEditable(index, editable) {
        isEditablesRef.current[index] = editable;
    }
    function updateValue(index, value) {
        if (isDisabled || !isThumbEditable(index)) return;
        const thisMin = getThumbMinValue(index);
        const thisMax = getThumbMaxValue(index);
        // Round value to multiple of step, clamp value between min and max
        value = (0, _utils.snapValueToStep)(value, thisMin, thisMax, step);
        let newValues = replaceIndex(valuesRef.current, index, value);
        setValues(newValues);
    }
    function updateDragging(index, dragging) {
        if (isDisabled || !isThumbEditable(index)) return;
        if (dragging) valuesRef.current = values;
        const wasDragging = isDraggingsRef.current[index];
        isDraggingsRef.current = replaceIndex(isDraggingsRef.current, index, dragging);
        setDraggings(isDraggingsRef.current);
        // Call onChangeEnd if no handles are dragging.
        if (onChangeEnd && wasDragging && !isDraggingsRef.current.some(Boolean)) onChangeEnd(valuesRef.current);
    }
    function getFormattedValue(value) {
        return formatter.format(value);
    }
    function setThumbPercent(index, percent) {
        updateValue(index, getPercentValue(percent));
    }
    function getRoundedValue(value) {
        return Math.round((value - minValue) / step) * step + minValue;
    }
    function getPercentValue(percent) {
        const val = percent * (maxValue - minValue) + minValue;
        return (0, _utils.clamp)(getRoundedValue(val), minValue, maxValue);
    }
    function incrementThumb(index, stepSize = 1) {
        let s = Math.max(stepSize, step);
        updateValue(index, (0, _utils.snapValueToStep)(values[index] + s, minValue, maxValue, step));
    }
    function decrementThumb(index, stepSize = 1) {
        let s = Math.max(stepSize, step);
        updateValue(index, (0, _utils.snapValueToStep)(values[index] - s, minValue, maxValue, step));
    }
    return {
        values: values,
        getThumbValue: (index)=>values[index],
        setThumbValue: updateValue,
        setThumbPercent,
        isThumbDragging: (index)=>isDraggings[index],
        setThumbDragging: updateDragging,
        focusedThumb: focusedIndex,
        setFocusedThumb: setFocusedIndex,
        getThumbPercent: (index)=>getValuePercent(values[index]),
        getValuePercent,
        getThumbValueLabel: (index)=>getFormattedValue(values[index]),
        getFormattedValue,
        getThumbMinValue,
        getThumbMaxValue,
        getPercentValue,
        isThumbEditable,
        setThumbEditable,
        incrementThumb,
        decrementThumb,
        step,
        pageSize,
        orientation,
        isDisabled
    };
}
function replaceIndex(array, index, value) {
    if (array[index] === value) return array;
    return [
        ...array.slice(0, index),
        value,
        ...array.slice(index + 1)
    ];
}
function convertValue(value) {
    if (value == null) return undefined;
    return Array.isArray(value) ? value : [
        value
    ];
}
function createOnChange(value, defaultValue, onChange) {
    return (newValue)=>{
        if (typeof value === "number" || typeof defaultValue === "number") onChange === null || onChange === void 0 ? void 0 : onChange(newValue[0]);
        else onChange === null || onChange === void 0 ? void 0 : onChange(newValue);
    };
}

},{"@react-stately/utils":"cpDPf","react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"6ZM93":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useTableColumnResizeState", ()=>(0, _useTableColumnResizeState.useTableColumnResizeState));
parcelHelpers.export(exports, "useTableState", ()=>(0, _useTableState.useTableState));
parcelHelpers.export(exports, "TableHeader", ()=>(0, _tableHeader.TableHeader));
parcelHelpers.export(exports, "TableBody", ()=>(0, _tableBody.TableBody));
parcelHelpers.export(exports, "Column", ()=>(0, _column.Column));
parcelHelpers.export(exports, "Row", ()=>(0, _row.Row));
parcelHelpers.export(exports, "Cell", ()=>(0, _cell.Cell));
parcelHelpers.export(exports, "Section", ()=>(0, _collections.Section));
parcelHelpers.export(exports, "TableCollection", ()=>(0, _tableCollection.TableCollection));
parcelHelpers.export(exports, "buildHeaderRows", ()=>(0, _tableCollection.buildHeaderRows));
parcelHelpers.export(exports, "TableColumnLayout", ()=>(0, _tableColumnLayout.TableColumnLayout));
parcelHelpers.export(exports, "UNSTABLE_useTreeGridState", ()=>(0, _useTreeGridState.UNSTABLE_useTreeGridState));
var _useTableColumnResizeState = require("./useTableColumnResizeState");
var _useTableState = require("./useTableState");
var _tableHeader = require("./TableHeader");
var _tableBody = require("./TableBody");
var _column = require("./Column");
var _row = require("./Row");
var _cell = require("./Cell");
var _collections = require("@react-stately/collections");
var _tableCollection = require("./TableCollection");
var _tableColumnLayout = require("./TableColumnLayout");
var _useTreeGridState = require("./useTreeGridState");

},{"./useTableColumnResizeState":"al6bw","./useTableState":"iSIWP","./TableHeader":"34XQ6","./TableBody":"9yyiP","./Column":"kTLwm","./Row":"6bplt","./Cell":"aYdkC","@react-stately/collections":false,"./TableCollection":"gNXPB","./TableColumnLayout":"dOXgo","./useTreeGridState":"bAYIZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"al6bw":[function(require,module,exports) {
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides column width state management for a table component with column resizing support. Handles building
 * a map of column widths calculated from the table's width and any provided column width information from the collection.
 * In addition, it tracks the currently resizing column and provides callbacks for updating the widths upon resize operations.
 * @param props - Props for the table.
 * @param state - State for the table, as returned by `useTableState`.
 */ parcelHelpers.export(exports, "useTableColumnResizeState", ()=>useTableColumnResizeState);
var _tableColumnLayout = require("./TableColumnLayout");
var _react = require("react");
function useTableColumnResizeState(props, state) {
    let { getDefaultWidth, getDefaultMinWidth, tableWidth = 0 } = props;
    let [resizingColumn, setResizingColumn] = (0, _react.useState)(null);
    let columnLayout = (0, _react.useMemo)(()=>new (0, _tableColumnLayout.TableColumnLayout)({
            getDefaultWidth,
            getDefaultMinWidth
        }), [
        getDefaultWidth,
        getDefaultMinWidth
    ]);
    let [controlledColumns, uncontrolledColumns] = (0, _react.useMemo)(()=>columnLayout.splitColumnsIntoControlledAndUncontrolled(state.collection.columns), [
        state.collection.columns,
        columnLayout
    ]);
    // uncontrolled column widths
    let [uncontrolledWidths, setUncontrolledWidths] = (0, _react.useState)(()=>columnLayout.getInitialUncontrolledWidths(uncontrolledColumns));
    // Update uncontrolled widths if the columns changed.
    let [lastColumns, setLastColumns] = (0, _react.useState)(state.collection.columns);
    if (state.collection.columns !== lastColumns) {
        if (state.collection.columns.length !== lastColumns.length || state.collection.columns.some((c, i)=>c.key !== lastColumns[i].key)) {
            let newUncontrolledWidths = columnLayout.getInitialUncontrolledWidths(uncontrolledColumns);
            setUncontrolledWidths(newUncontrolledWidths);
        }
        setLastColumns(state.collection.columns);
    }
    // combine columns back into one map that maintains same order as the columns
    let colWidths = (0, _react.useMemo)(()=>columnLayout.recombineColumns(state.collection.columns, uncontrolledWidths, uncontrolledColumns, controlledColumns), [
        state.collection.columns,
        uncontrolledWidths,
        uncontrolledColumns,
        controlledColumns,
        columnLayout
    ]);
    let startResize = (0, _react.useCallback)((key)=>{
        setResizingColumn(key);
    }, [
        setResizingColumn
    ]);
    let updateResizedColumns = (0, _react.useCallback)((key, width)=>{
        let newControlled = new Map(Array.from(controlledColumns).map(([key, entry])=>[
                key,
                entry.props.width
            ]));
        let newSizes = columnLayout.resizeColumnWidth(tableWidth, state.collection, newControlled, uncontrolledWidths, key, width);
        let map = new Map(Array.from(uncontrolledColumns).map(([key])=>[
                key,
                newSizes.get(key)
            ]));
        map.set(key, width);
        setUncontrolledWidths(map);
        return newSizes;
    }, [
        controlledColumns,
        uncontrolledColumns,
        setUncontrolledWidths,
        tableWidth,
        columnLayout,
        state.collection,
        uncontrolledWidths
    ]);
    let endResize = (0, _react.useCallback)(()=>{
        setResizingColumn(null);
    }, [
        setResizingColumn
    ]);
    (0, _react.useMemo)(()=>columnLayout.buildColumnWidths(tableWidth, state.collection, colWidths), [
        tableWidth,
        state.collection,
        colWidths,
        columnLayout
    ]);
    return (0, _react.useMemo)(()=>({
            resizingColumn,
            updateResizedColumns,
            startResize,
            endResize,
            getColumnWidth: (key)=>columnLayout.getColumnWidth(key),
            getColumnMinWidth: (key)=>columnLayout.getColumnMinWidth(key),
            getColumnMaxWidth: (key)=>columnLayout.getColumnMaxWidth(key),
            tableState: state
        }), [
        columnLayout,
        resizingColumn,
        updateResizedColumns,
        startResize,
        endResize,
        state
    ]);
}

},{"./TableColumnLayout":"dOXgo","react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"dOXgo":[function(require,module,exports) {
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TableColumnLayout", ()=>TableColumnLayout);
var _tableUtils = require("./TableUtils");
class TableColumnLayout {
    /** Takes an array of columns and splits it into 2 maps of columns with controlled and columns with uncontrolled widths. */ splitColumnsIntoControlledAndUncontrolled(columns) {
        return columns.reduce((acc, col)=>{
            if (col.props.width != null) acc[0].set(col.key, col);
            else acc[1].set(col.key, col);
            return acc;
        }, [
            new Map(),
            new Map()
        ]);
    }
    /** Takes uncontrolled and controlled widths and joins them into a single Map. */ recombineColumns(columns, uncontrolledWidths, uncontrolledColumns, controlledColumns) {
        return new Map(columns.map((col)=>{
            if (uncontrolledColumns.has(col.key)) return [
                col.key,
                uncontrolledWidths.get(col.key)
            ];
            else return [
                col.key,
                controlledColumns.get(col.key).props.width
            ];
        }));
    }
    /** Used to make an initial Map of the uncontrolled widths based on default widths. */ getInitialUncontrolledWidths(uncontrolledColumns) {
        return new Map(Array.from(uncontrolledColumns).map(([key, col])=>{
            var _this_getDefaultWidth, _this;
            var _col_props_defaultWidth, _ref;
            return [
                key,
                (_ref = (_col_props_defaultWidth = col.props.defaultWidth) !== null && _col_props_defaultWidth !== void 0 ? _col_props_defaultWidth : (_this_getDefaultWidth = (_this = this).getDefaultWidth) === null || _this_getDefaultWidth === void 0 ? void 0 : _this_getDefaultWidth.call(_this, col)) !== null && _ref !== void 0 ? _ref : "1fr"
            ];
        }));
    }
    getColumnWidth(key) {
        var _this_columnWidths_get;
        return (_this_columnWidths_get = this.columnWidths.get(key)) !== null && _this_columnWidths_get !== void 0 ? _this_columnWidths_get : 0;
    }
    getColumnMinWidth(key) {
        var _this_columnMinWidths_get;
        return (_this_columnMinWidths_get = this.columnMinWidths.get(key)) !== null && _this_columnMinWidths_get !== void 0 ? _this_columnMinWidths_get : 0;
    }
    getColumnMaxWidth(key) {
        var _this_columnMaxWidths_get;
        return (_this_columnMaxWidths_get = this.columnMaxWidths.get(key)) !== null && _this_columnMaxWidths_get !== void 0 ? _this_columnMaxWidths_get : 0;
    }
    resizeColumnWidth(tableWidth, collection, controlledWidths, uncontrolledWidths, col = null, width) {
        let prevColumnWidths = this.columnWidths;
        // resizing a column
        let resizeIndex = Infinity;
        let resizingChanged = new Map([
            ...controlledWidths,
            ...uncontrolledWidths
        ]);
        let percentKeys = new Map();
        let frKeysToTheRight = new Map();
        let minWidths = new Map();
        // freeze columns to the left to their previous pixel value
        collection.columns.forEach((column, i)=>{
            var _column_props_width_endsWith, _column_props_width;
            let frKey;
            let frValue;
            minWidths.set(column.key, this.getDefaultMinWidth(collection.columns[i]));
            if (col !== column.key && !column.props.width && !(0, _tableUtils.isStatic)(uncontrolledWidths.get(column.key))) {
                // uncontrolled don't have props.width for us, so instead get from our state
                frKey = column.key;
                frValue = (0, _tableUtils.parseFractionalUnit)(uncontrolledWidths.get(column.key));
            } else if (col !== column.key && !(0, _tableUtils.isStatic)(column.props.width) && !uncontrolledWidths.get(column.key)) {
                // controlledWidths will be the same in the collection
                frKey = column.key;
                frValue = (0, _tableUtils.parseFractionalUnit)(column.props.width);
            } else if (col !== column.key && ((_column_props_width = column.props.width) === null || _column_props_width === void 0 ? void 0 : (_column_props_width_endsWith = _column_props_width.endsWith) === null || _column_props_width_endsWith === void 0 ? void 0 : _column_props_width_endsWith.call(_column_props_width, "%"))) percentKeys.set(column.key, column.props.width);
            // don't freeze columns to the right of the resizing one
            if (resizeIndex < i) {
                if (frKey) frKeysToTheRight.set(frKey, frValue);
                return;
            }
            // we already know the new size of the resizing column
            if (column.key === col) {
                resizeIndex = i;
                resizingChanged.set(column.key, Math.floor(width));
                return;
            }
            // freeze column to previous value
            resizingChanged.set(column.key, prevColumnWidths.get(column.key));
        });
        // predict pixels sizes for all columns based on resize
        let columnWidths = (0, _tableUtils.calculateColumnSizes)(tableWidth, collection.columns.map((col)=>({
                ...col.props,
                key: col.key
            })), resizingChanged, (i)=>this.getDefaultWidth(collection.columns[i]), (i)=>this.getDefaultMinWidth(collection.columns[i]));
        // set all new column widths for onResize event
        // columns going in will be the same order as the columns coming out
        let newWidths = new Map();
        // set all column widths based on calculateColumnSize
        columnWidths.forEach((width, index)=>{
            let key = collection.columns[index].key;
            newWidths.set(key, width);
        });
        // add FR's back as they were to columns to the right
        Array.from(frKeysToTheRight).forEach(([key])=>{
            newWidths.set(key, `${frKeysToTheRight.get(key)}fr`);
        });
        // put back in percents
        Array.from(percentKeys).forEach(([key, width])=>{
            // resizing locks a column to a px width
            if (key === col) return;
            newWidths.set(key, width);
        });
        return newWidths;
    }
    buildColumnWidths(tableWidth, collection, widths) {
        this.columnWidths = new Map();
        this.columnMinWidths = new Map();
        this.columnMaxWidths = new Map();
        // initial layout or table/window resizing
        let columnWidths = (0, _tableUtils.calculateColumnSizes)(tableWidth, collection.columns.map((col)=>({
                ...col.props,
                key: col.key
            })), widths, (i)=>this.getDefaultWidth(collection.columns[i]), (i)=>this.getDefaultMinWidth(collection.columns[i]));
        // columns going in will be the same order as the columns coming out
        columnWidths.forEach((width, index)=>{
            let key = collection.columns[index].key;
            let column = collection.columns[index];
            this.columnWidths.set(key, width);
            var _column_props_minWidth;
            this.columnMinWidths.set(key, (0, _tableUtils.getMinWidth)((_column_props_minWidth = column.props.minWidth) !== null && _column_props_minWidth !== void 0 ? _column_props_minWidth : this.getDefaultMinWidth(column), tableWidth));
            this.columnMaxWidths.set(key, (0, _tableUtils.getMaxWidth)(column.props.maxWidth, tableWidth));
        });
        return this.columnWidths;
    }
    constructor(options){
        this.columnWidths = new Map();
        this.columnMinWidths = new Map();
        this.columnMaxWidths = new Map();
        var _options_getDefaultWidth;
        this.getDefaultWidth = (_options_getDefaultWidth = options === null || options === void 0 ? void 0 : options.getDefaultWidth) !== null && _options_getDefaultWidth !== void 0 ? _options_getDefaultWidth : ()=>"1fr";
        var _options_getDefaultMinWidth;
        this.getDefaultMinWidth = (_options_getDefaultMinWidth = options === null || options === void 0 ? void 0 : options.getDefaultMinWidth) !== null && _options_getDefaultMinWidth !== void 0 ? _options_getDefaultMinWidth : ()=>75;
    }
}

},{"./TableUtils":"9q9tu","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"9q9tu":[function(require,module,exports) {
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// numbers and percents are considered static. *fr units or a lack of units are considered dynamic.
parcelHelpers.export(exports, "isStatic", ()=>isStatic);
parcelHelpers.export(exports, "parseFractionalUnit", ()=>parseFractionalUnit);
parcelHelpers.export(exports, "parseStaticWidth", ()=>parseStaticWidth);
parcelHelpers.export(exports, "getMaxWidth", ()=>getMaxWidth);
// cannot support FR units, we'd need to know everything else in the table to do that
parcelHelpers.export(exports, "getMinWidth", ()=>getMinWidth);
/**
 * Implements the flex algorithm described in https://www.w3.org/TR/css-flexbox-1/#layout-algorithm
 * It makes a few constraint/assumptions:
 * 1. All basis values are 0 unless it is a static width, then the basis is the static width
 * 2. All flex grow and shrink values are equal to the FR specified on the column, grow and shrink for the same column are equal
 * 3. We only have one row
 * An example of the setup can be seen here https://jsfiddle.net/snowystinger/wv0ymjaf/61/ where I let the browser figure out the
 * flex of the columns.
 * Note: We differ in one key aspect, all of our column widths must be whole numbers, so we avoid browser
 * sub pixel rounding errors. To do this, we use a cascading rounding algorithm to ensure that the sum of the widths is maintained
 * while distributing the rounding remainder across the columns.
 *
 * As noted in the chrome source code, this algorithm is very accurate, but has the potential to be quadratic.
 * They have deemed this to be acceptable because the number of elements is usually small and the flex factors
 * are usually not high variance. I believe we can make the same assumptions. Particularly once resizing is
 * started, it will convert all columns to the left to static widths, so it will cut down on the number of FR columns.
 *
 * There are likely faster ways to do this, I've chosen to stick to the spec as closely as possible for readability, accuracy, and for the
 * note that this behaving quadratically is unlikely to be a problem.
 * @param availableWidth - The visible width of the table.
 * @param columns - The table defined columns.
 * @param changedColumns - Any columns we want to override, for example, during resizing.
 * @param getDefaultWidth - A function that returns the default width of a column by its index.
 * @param getDefaultMinWidth - A function that returns the default min width of a column by its index.
 */ parcelHelpers.export(exports, "calculateColumnSizes", ()=>calculateColumnSizes);
function isStatic(width) {
    return width != null && (!isNaN(width) || String(width).match(/^(\d+)(?=%$)/) !== null);
}
function parseFractionalUnit(width) {
    if (!width) return 1;
    let match = width.match(/^(.+)(?=fr$)/);
    // if width is the incorrect format, just default it to a 1fr
    if (!match) {
        console.warn(`width: ${width} is not a supported format, width should be a number (ex. 150), percentage (ex. '50%') or fr unit (ex. '2fr')`, "defaulting to '1fr'");
        return 1;
    }
    return parseFloat(match[0]);
}
function parseStaticWidth(width, tableWidth) {
    if (typeof width === "string") {
        let match = width.match(/^(\d+)(?=%$)/);
        if (!match) throw new Error("Only percentages or numbers are supported for static column widths");
        return tableWidth * (parseFloat(match[0]) / 100);
    }
    return width;
}
function getMaxWidth(maxWidth, tableWidth) {
    return maxWidth != null ? parseStaticWidth(maxWidth, tableWidth) : Number.MAX_SAFE_INTEGER;
}
function getMinWidth(minWidth, tableWidth) {
    return minWidth != null ? parseStaticWidth(minWidth, tableWidth) : 0;
}
function calculateColumnSizes(availableWidth, columns, changedColumns, getDefaultWidth, getDefaultMinWidth) {
    let hasNonFrozenItems = false;
    let flexItems = columns.map((column, index)=>{
        var _column_width, _ref, _ref1;
        let width = changedColumns.get(column.key) != null ? changedColumns.get(column.key) : (_ref1 = (_ref = (_column_width = column.width) !== null && _column_width !== void 0 ? _column_width : column.defaultWidth) !== null && _ref !== void 0 ? _ref : getDefaultWidth === null || getDefaultWidth === void 0 ? void 0 : getDefaultWidth(index)) !== null && _ref1 !== void 0 ? _ref1 : "1fr";
        let frozen = false;
        let baseSize = 0;
        let flex = 0;
        let targetMainSize = null;
        if (isStatic(width)) {
            baseSize = parseStaticWidth(width, availableWidth);
            frozen = true;
        } else {
            flex = parseFractionalUnit(width);
            if (flex <= 0) frozen = true;
        }
        var _column_minWidth, _ref2;
        let min = getMinWidth((_ref2 = (_column_minWidth = column.minWidth) !== null && _column_minWidth !== void 0 ? _column_minWidth : getDefaultMinWidth === null || getDefaultMinWidth === void 0 ? void 0 : getDefaultMinWidth(index)) !== null && _ref2 !== void 0 ? _ref2 : 0, availableWidth);
        let max = getMaxWidth(column.maxWidth, availableWidth);
        let hypotheticalMainSize = Math.max(min, Math.min(baseSize, max));
        // 9.7.1
        // We don't make use of flex basis, it's always 0, so we are always in 'grow' mode.
        // 9.7.2
        if (frozen) targetMainSize = hypotheticalMainSize;
        else if (baseSize > hypotheticalMainSize) {
            frozen = true;
            targetMainSize = hypotheticalMainSize;
        }
        // 9.7.3
        if (!frozen) hasNonFrozenItems = true;
        return {
            frozen,
            baseSize,
            hypotheticalMainSize,
            min,
            max,
            flex,
            targetMainSize,
            violation: 0
        };
    });
    // 9.7.4
    // 9.7.4.a
    while(hasNonFrozenItems){
        // 9.7.4.b
        /**
     * Calculate the remaining free space as for initial free space,
     * above (9.7.3). If the sum of the unfrozen flex items’ flex factors is
     * less than one, multiply the initial free space by this sum (of flex factors).
     * If the magnitude of this value is less than the magnitude of
     * the remaining free space, use this as the remaining free space.
     */ let usedWidth = 0;
        let flexFactors = 0;
        flexItems.forEach((item)=>{
            if (item.frozen) usedWidth += item.targetMainSize;
            else {
                usedWidth += item.baseSize;
                flexFactors += item.flex;
            }
        });
        let remainingFreeSpace = availableWidth - usedWidth;
        // we only support integer FR's, and because of hasNonFrozenItems, we know that flexFactors > 0
        // so no need to check for flexFactors < 1
        // 9.7.4.c
        /**
     * If the remaining free space is zero
     * - Do nothing.
     * Else // remember, we're always in grow mode
     * - Find the ratio of the item’s flex grow factor to the
     * sum of the flex grow factors of all unfrozen items on
     * the line. Set the item’s target main size to its flex
     * base size plus a fraction of the remaining free space
     * proportional to the ratio.
     */ if (remainingFreeSpace > 0) flexItems.forEach((item)=>{
            if (!item.frozen) {
                let ratio = item.flex / flexFactors;
                item.targetMainSize = item.baseSize + ratio * remainingFreeSpace;
            }
        });
        // 9.7.4.d
        /**
     * Fix min/max violations. Clamp each non-frozen item’s
     * target main size by its used min and max main sizes
     * and floor its content-box size at zero. If the item’s
     * target main size was made smaller by this, it’s a max
     * violation. If the item’s target main size was made
     * larger by this, it’s a min violation.
     */ let totalViolation = 0;
        flexItems.forEach((item)=>{
            item.violation = 0;
            if (!item.frozen) {
                let { min, max, targetMainSize } = item;
                item.targetMainSize = Math.max(min, Math.min(targetMainSize, max));
                item.violation = item.targetMainSize - targetMainSize;
                totalViolation += item.violation;
            }
        });
        // 9.7.4.e
        /**
     * Freeze over-flexed items. The total violation is the
     * sum of the adjustments from the previous step
     * ∑(clamped size - unclamped size). If the total violation is:
     * Zero
     * - Freeze all items.
     *
     * Positive
     * - Freeze all the items with min violations.
     *
     * Negative
     * - Freeze all the items with max violations.
     */ hasNonFrozenItems = false;
        flexItems.forEach((item)=>{
            if (totalViolation === 0 || Math.sign(totalViolation) === Math.sign(item.violation)) item.frozen = true;
            else if (!item.frozen) hasNonFrozenItems = true;
        });
    }
    return cascadeRounding(flexItems);
}
function cascadeRounding(flexItems) {
    /*
  Given an array of floats that sum to an integer, this rounds the floats
  and returns an array of integers with the same sum.
  */ let fpTotal = 0;
    let intTotal = 0;
    let roundedArray = [];
    flexItems.forEach(function(item) {
        let float = item.targetMainSize;
        let integer = Math.round(float + fpTotal) - intTotal;
        fpTotal += float;
        intTotal += integer;
        roundedArray.push(integer);
    });
    return roundedArray;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"iSIWP":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides state management for a table component. Handles building a collection
 * of columns and rows from props. In addition, it tracks row selection and manages sort order changes.
 */ parcelHelpers.export(exports, "useTableState", ()=>useTableState);
var _grid = require("@react-stately/grid");
var _react = require("react");
var _tableCollection = require("./TableCollection");
var _collections = require("@react-stately/collections");
const OPPOSITE_SORT_DIRECTION = {
    ascending: "descending",
    descending: "ascending"
};
function useTableState(props) {
    let [isKeyboardNavigationDisabled, setKeyboardNavigationDisabled] = (0, _react.useState)(false);
    let { selectionMode = "none", showSelectionCheckboxes, showDragButtons } = props;
    let context = (0, _react.useMemo)(()=>({
            showSelectionCheckboxes: showSelectionCheckboxes && selectionMode !== "none",
            showDragButtons: showDragButtons,
            selectionMode,
            columns: []
        }), [
        props.children,
        showSelectionCheckboxes,
        selectionMode,
        showDragButtons
    ]);
    let collection = (0, _collections.useCollection)(props, (0, _react.useCallback)((nodes)=>new (0, _tableCollection.TableCollection)(nodes, null, context), [
        context
    ]), context);
    let { disabledKeys, selectionManager } = (0, _grid.useGridState)({
        ...props,
        collection,
        disabledBehavior: props.disabledBehavior || "selection"
    });
    return {
        collection,
        disabledKeys,
        selectionManager,
        showSelectionCheckboxes: props.showSelectionCheckboxes || false,
        sortDescriptor: props.sortDescriptor,
        isKeyboardNavigationDisabled: collection.size === 0 || isKeyboardNavigationDisabled,
        setKeyboardNavigationDisabled,
        sort (columnKey, direction) {
            var _props_sortDescriptor;
            props.onSortChange({
                column: columnKey,
                direction: direction !== null && direction !== void 0 ? direction : ((_props_sortDescriptor = props.sortDescriptor) === null || _props_sortDescriptor === void 0 ? void 0 : _props_sortDescriptor.column) === columnKey ? OPPOSITE_SORT_DIRECTION[props.sortDescriptor.direction] : "ascending"
            });
        }
    };
}

},{"@react-stately/grid":"ehdYF","react":"9yzVZ","./TableCollection":"gNXPB","@react-stately/collections":"loANi","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"ehdYF":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useGridState", ()=>(0, _useGridState.useGridState));
parcelHelpers.export(exports, "GridCollection", ()=>(0, _gridCollection.GridCollection));
var _useGridState = require("./useGridState");
var _gridCollection = require("./GridCollection");

},{"./useGridState":"9dEMn","./GridCollection":"9Ka5P","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"9dEMn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides state management for a grid component. Handles row selection and focusing a grid cell's focusable child if applicable.
 */ parcelHelpers.export(exports, "useGridState", ()=>useGridState);
var _collections = require("@react-stately/collections");
var _selection = require("@react-stately/selection");
var _react = require("react");
function useGridState(props) {
    let { collection, focusMode } = props;
    let selectionState = (0, _selection.useMultipleSelectionState)(props);
    let disabledKeys = (0, _react.useMemo)(()=>props.disabledKeys ? new Set(props.disabledKeys) : new Set(), [
        props.disabledKeys
    ]);
    let setFocusedKey = selectionState.setFocusedKey;
    selectionState.setFocusedKey = (key, child)=>{
        // If focusMode is cell and an item is focused, focus a child cell instead.
        if (focusMode === "cell" && key != null) {
            let item = collection.getItem(key);
            if ((item === null || item === void 0 ? void 0 : item.type) === "item") {
                var _getLastItem, _getFirstItem;
                let children = (0, _collections.getChildNodes)(item, collection);
                if (child === "last") key = (_getLastItem = (0, _collections.getLastItem)(children)) === null || _getLastItem === void 0 ? void 0 : _getLastItem.key;
                else key = (_getFirstItem = (0, _collections.getFirstItem)(children)) === null || _getFirstItem === void 0 ? void 0 : _getFirstItem.key;
            }
        }
        setFocusedKey(key, child);
    };
    let selectionManager = (0, _react.useMemo)(()=>new (0, _selection.SelectionManager)(collection, selectionState), [
        collection,
        selectionState
    ]);
    // Reset focused key if that item is deleted from the collection.
    const cachedCollection = (0, _react.useRef)(null);
    (0, _react.useEffect)(()=>{
        if (selectionState.focusedKey != null && !collection.getItem(selectionState.focusedKey)) {
            const node = cachedCollection.current.getItem(selectionState.focusedKey);
            const parentNode = node.parentKey != null && (node.type === "cell" || node.type === "rowheader" || node.type === "column") ? cachedCollection.current.getItem(node.parentKey) : node;
            const cachedRows = cachedCollection.current.rows;
            const rows = collection.rows;
            const diff = cachedRows.length - rows.length;
            let index = Math.min(diff > 1 ? Math.max(parentNode.index - diff + 1, 0) : parentNode.index, rows.length - 1);
            let newRow;
            while(index >= 0){
                if (!selectionManager.isDisabled(rows[index].key) && rows[index].type !== "headerrow") {
                    newRow = rows[index];
                    break;
                }
                // Find next, not disabled row.
                if (index < rows.length - 1) index++;
                else {
                    if (index > parentNode.index) index = parentNode.index;
                    index--;
                }
            }
            if (newRow) {
                const childNodes = newRow.hasChildNodes ? [
                    ...(0, _collections.getChildNodes)(newRow, collection)
                ] : [];
                const keyToFocus = newRow.hasChildNodes && parentNode !== node && node.index < childNodes.length ? childNodes[node.index].key : newRow.key;
                selectionState.setFocusedKey(keyToFocus);
            } else selectionState.setFocusedKey(null);
        }
        cachedCollection.current = collection;
    }, [
        collection,
        selectionManager,
        selectionState,
        selectionState.focusedKey
    ]);
    return {
        collection,
        disabledKeys,
        isKeyboardNavigationDisabled: false,
        selectionManager
    };
}

},{"@react-stately/collections":"loANi","@react-stately/selection":"hM12z","react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"9Ka5P":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GridCollection", ()=>GridCollection);
class GridCollection {
    *[Symbol.iterator]() {
        yield* [
            ...this.rows
        ];
    }
    get size() {
        return [
            ...this.rows
        ].length;
    }
    getKeys() {
        return this.keyMap.keys();
    }
    getKeyBefore(key) {
        let node = this.keyMap.get(key);
        return node ? node.prevKey : null;
    }
    getKeyAfter(key) {
        let node = this.keyMap.get(key);
        return node ? node.nextKey : null;
    }
    getFirstKey() {
        var _;
        return (_ = [
            ...this.rows
        ][0]) === null || _ === void 0 ? void 0 : _.key;
    }
    getLastKey() {
        var _rows_;
        let rows = [
            ...this.rows
        ];
        return (_rows_ = rows[rows.length - 1]) === null || _rows_ === void 0 ? void 0 : _rows_.key;
    }
    getItem(key) {
        return this.keyMap.get(key);
    }
    at(idx) {
        const keys = [
            ...this.getKeys()
        ];
        return this.getItem(keys[idx]);
    }
    getChildren(key) {
        let node = this.keyMap.get(key);
        return (node === null || node === void 0 ? void 0 : node.childNodes) || [];
    }
    constructor(opts){
        this.keyMap = new Map();
        this.keyMap = new Map();
        this.columnCount = opts === null || opts === void 0 ? void 0 : opts.columnCount;
        this.rows = [];
        let visit = (node)=>{
            // If the node is the same object as the previous node for the same key,
            // we can skip this node and its children. We always visit columns though,
            // because we depend on order to build the columns array.
            let prevNode = this.keyMap.get(node.key);
            if (opts.visitNode) node = opts.visitNode(node);
            this.keyMap.set(node.key, node);
            let childKeys = new Set();
            let last;
            for (let child of node.childNodes){
                if (child.type === "cell" && child.parentKey == null) // if child is a cell parent key isn't already established by the collection, match child node to parent row
                child.parentKey = node.key;
                childKeys.add(child.key);
                if (last) {
                    last.nextKey = child.key;
                    child.prevKey = last.key;
                } else child.prevKey = null;
                visit(child);
                last = child;
            }
            if (last) last.nextKey = null;
            // Remove deleted nodes and their children from the key map
            if (prevNode) {
                for (let child of prevNode.childNodes)if (!childKeys.has(child.key)) remove(child);
            }
        };
        let remove = (node)=>{
            this.keyMap.delete(node.key);
            for (let child of node.childNodes)if (this.keyMap.get(child.key) === child) remove(child);
        };
        let last;
        opts.items.forEach((node, i)=>{
            let rowNode = {
                level: 0,
                key: "row-" + i,
                type: "row",
                value: undefined,
                hasChildNodes: true,
                childNodes: [
                    ...node.childNodes
                ],
                rendered: undefined,
                textValue: undefined,
                ...node
            };
            if (last) {
                last.nextKey = rowNode.key;
                rowNode.prevKey = last.key;
            } else rowNode.prevKey = null;
            this.rows.push(rowNode);
            visit(rowNode);
            last = rowNode;
        });
        if (last) last.nextKey = null;
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"gNXPB":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/** @private */ parcelHelpers.export(exports, "buildHeaderRows", ()=>buildHeaderRows);
parcelHelpers.export(exports, "TableCollection", ()=>TableCollection);
var _collections = require("@react-stately/collections");
var _grid = require("@react-stately/grid");
const ROW_HEADER_COLUMN_KEY = "row-header-column-" + Math.random().toString(36).slice(2);
let ROW_HEADER_COLUMN_KEY_DRAG = "row-header-column-" + Math.random().toString(36).slice(2);
while(ROW_HEADER_COLUMN_KEY === ROW_HEADER_COLUMN_KEY_DRAG)ROW_HEADER_COLUMN_KEY_DRAG = "row-header-column-" + Math.random().toString(36).slice(2);
function buildHeaderRows(keyMap, columnNodes) {
    if (columnNodes.length === 0) return [];
    let columns = [];
    let seen = new Map();
    for (let column of columnNodes){
        let parentKey = column.parentKey;
        let col = [
            column
        ];
        while(parentKey){
            let parent = keyMap.get(parentKey);
            if (!parent) break;
            // If we've already seen this parent, than it is shared
            // with a previous column. If the current column is taller
            // than the previous column, than we need to shift the parent
            // in the previous column so it's level with the current column.
            if (seen.has(parent)) {
                parent.colspan++;
                let { column, index } = seen.get(parent);
                if (index > col.length) break;
                for(let i = index; i < col.length; i++)column.splice(i, 0, null);
                // Adjust shifted indices
                for(let i = col.length; i < column.length; i++)// eslint-disable-next-line max-depth
                if (column[i] && seen.has(column[i])) seen.get(column[i]).index = i;
            } else {
                parent.colspan = 1;
                col.push(parent);
                seen.set(parent, {
                    column: col,
                    index: col.length - 1
                });
            }
            parentKey = parent.parentKey;
        }
        columns.push(col);
        column.index = columns.length - 1;
    }
    let maxLength = Math.max(...columns.map((c)=>c.length));
    let headerRows = Array(maxLength).fill(0).map(()=>[]);
    // Convert columns into rows.
    let colIndex = 0;
    for (let column of columns){
        let i = maxLength - 1;
        for (let item of column){
            if (item) {
                // Fill the space up until the current column with a placeholder
                let row = headerRows[i];
                let rowLength = row.reduce((p, c)=>p + c.colspan, 0);
                if (rowLength < colIndex) {
                    let placeholder = {
                        type: "placeholder",
                        key: "placeholder-" + item.key,
                        colspan: colIndex - rowLength,
                        index: rowLength,
                        value: null,
                        rendered: null,
                        level: i,
                        hasChildNodes: false,
                        childNodes: [],
                        textValue: null
                    };
                    // eslint-disable-next-line max-depth
                    if (row.length > 0) {
                        row[row.length - 1].nextKey = placeholder.key;
                        placeholder.prevKey = row[row.length - 1].key;
                    }
                    row.push(placeholder);
                }
                if (row.length > 0) {
                    row[row.length - 1].nextKey = item.key;
                    item.prevKey = row[row.length - 1].key;
                }
                item.level = i;
                item.colIndex = colIndex;
                row.push(item);
            }
            i--;
        }
        colIndex++;
    }
    // Add placeholders at the end of each row that is shorter than the maximum
    let i = 0;
    for (let row of headerRows){
        let rowLength = row.reduce((p, c)=>p + c.colspan, 0);
        if (rowLength < columnNodes.length) {
            let placeholder = {
                type: "placeholder",
                key: "placeholder-" + row[row.length - 1].key,
                colspan: columnNodes.length - rowLength,
                index: rowLength,
                value: null,
                rendered: null,
                level: i,
                hasChildNodes: false,
                childNodes: [],
                textValue: null,
                prevKey: row[row.length - 1].key
            };
            row.push(placeholder);
        }
        i++;
    }
    return headerRows.map((childNodes, index)=>{
        let row = {
            type: "headerrow",
            key: "headerrow-" + index,
            index,
            value: null,
            rendered: null,
            level: 0,
            hasChildNodes: true,
            childNodes,
            textValue: null
        };
        return row;
    });
}
class TableCollection extends (0, _grid.GridCollection) {
    *[Symbol.iterator]() {
        yield* this.body.childNodes;
    }
    get size() {
        return this._size;
    }
    getKeys() {
        return this.keyMap.keys();
    }
    getKeyBefore(key) {
        let node = this.keyMap.get(key);
        return node ? node.prevKey : null;
    }
    getKeyAfter(key) {
        let node = this.keyMap.get(key);
        return node ? node.nextKey : null;
    }
    getFirstKey() {
        var _getFirstItem;
        return (_getFirstItem = (0, _collections.getFirstItem)(this.body.childNodes)) === null || _getFirstItem === void 0 ? void 0 : _getFirstItem.key;
    }
    getLastKey() {
        var _getLastItem;
        return (_getLastItem = (0, _collections.getLastItem)(this.body.childNodes)) === null || _getLastItem === void 0 ? void 0 : _getLastItem.key;
    }
    getItem(key) {
        return this.keyMap.get(key);
    }
    at(idx) {
        const keys = [
            ...this.getKeys()
        ];
        return this.getItem(keys[idx]);
    }
    getTextValue(key) {
        let row = this.getItem(key);
        if (!row) return "";
        // If the row has a textValue, use that.
        if (row.textValue) return row.textValue;
        // Otherwise combine the text of each of the row header columns.
        let rowHeaderColumnKeys = this.rowHeaderColumnKeys;
        if (rowHeaderColumnKeys) {
            let text = [];
            for (let cell of row.childNodes){
                let column = this.columns[cell.index];
                if (rowHeaderColumnKeys.has(column.key) && cell.textValue) text.push(cell.textValue);
                if (text.length === rowHeaderColumnKeys.size) break;
            }
            return text.join(" ");
        }
        return "";
    }
    constructor(nodes, prev, opts){
        let rowHeaderColumnKeys = new Set();
        let body;
        let columns = [];
        // Add cell for selection checkboxes if needed.
        if (opts === null || opts === void 0 ? void 0 : opts.showSelectionCheckboxes) {
            let rowHeaderColumn = {
                type: "column",
                key: ROW_HEADER_COLUMN_KEY,
                value: null,
                textValue: "",
                level: 0,
                index: (opts === null || opts === void 0 ? void 0 : opts.showDragButtons) ? 1 : 0,
                hasChildNodes: false,
                rendered: null,
                childNodes: [],
                props: {
                    isSelectionCell: true
                }
            };
            columns.unshift(rowHeaderColumn);
        }
        // Add cell for drag buttons if needed.
        if (opts === null || opts === void 0 ? void 0 : opts.showDragButtons) {
            let rowHeaderColumn = {
                type: "column",
                key: ROW_HEADER_COLUMN_KEY_DRAG,
                value: null,
                textValue: "",
                level: 0,
                index: 0,
                hasChildNodes: false,
                rendered: null,
                childNodes: [],
                props: {
                    isDragButtonCell: true
                }
            };
            columns.unshift(rowHeaderColumn);
        }
        let rows = [];
        let columnKeyMap = new Map();
        let visit = (node)=>{
            switch(node.type){
                case "body":
                    body = node;
                    break;
                case "column":
                    columnKeyMap.set(node.key, node);
                    if (!node.hasChildNodes) {
                        columns.push(node);
                        if (node.props.isRowHeader) rowHeaderColumnKeys.add(node.key);
                    }
                    break;
                case "item":
                    rows.push(node);
                    return; // do not go into childNodes
            }
            for (let child of node.childNodes)visit(child);
        };
        for (let node of nodes)visit(node);
        let headerRows = buildHeaderRows(columnKeyMap, columns);
        headerRows.forEach((row, i)=>rows.splice(i, 0, row));
        super({
            columnCount: columns.length,
            items: rows,
            visitNode: (node)=>{
                node.column = columns[node.index];
                return node;
            }
        });
        this._size = 0;
        this.columns = columns;
        this.rowHeaderColumnKeys = rowHeaderColumnKeys;
        this.body = body;
        this.headerRows = headerRows;
        this._size = [
            ...body.childNodes
        ].length;
        // Default row header column to the first one.
        if (this.rowHeaderColumnKeys.size === 0) this.rowHeaderColumnKeys.add(this.columns.find((column)=>{
            var _column_props, _column_props1;
            return !((_column_props = column.props) === null || _column_props === void 0 ? void 0 : _column_props.isDragButtonCell) && !((_column_props1 = column.props) === null || _column_props1 === void 0 ? void 0 : _column_props1.isSelectionCell);
        }).key);
    }
}

},{"@react-stately/collections":"loANi","@react-stately/grid":"ehdYF","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"34XQ6":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TableHeader", ()=>_TableHeader);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
function TableHeader(props) {
    return null;
}
TableHeader.getCollectionNode = function* getCollectionNode(props, context) {
    let { children, columns } = props;
    // Clear columns so they aren't double added in strict mode.
    context.columns = [];
    if (typeof children === "function") {
        if (!columns) throw new Error("props.children was a function but props.columns is missing");
        for (let column of columns)yield {
            type: "column",
            value: column,
            renderer: children
        };
    } else {
        let columns = [];
        (0, _reactDefault.default).Children.forEach(children, (column)=>{
            columns.push({
                type: "column",
                element: column
            });
        });
        yield* columns;
    }
};
/**
 * A TableHeader is a container for the Column elements in a Table. Columns can be statically defined
 * as children, or generated dynamically using a function based on the data passed to the `columns` prop.
 */ // We don't want getCollectionNode to show up in the type definition
let _TableHeader = TableHeader;

},{"react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"9yyiP":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TableBody", ()=>_TableBody);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
function TableBody(props) {
    return null;
}
TableBody.getCollectionNode = function* getCollectionNode(props) {
    let { children, items } = props;
    yield {
        type: "body",
        hasChildNodes: true,
        props,
        *childNodes () {
            if (typeof children === "function") {
                if (!items) throw new Error("props.children was a function but props.items is missing");
                for (let item of items)yield {
                    type: "item",
                    value: item,
                    renderer: children
                };
            } else {
                let items = [];
                (0, _reactDefault.default).Children.forEach(children, (item)=>{
                    items.push({
                        type: "item",
                        element: item
                    });
                });
                yield* items;
            }
        }
    };
};
/**
 * A TableBody is a container for the Row elements of a Table. Rows can be statically defined
 * as children, or generated dynamically using a function based on the data passed to the `items` prop.
 */ // We don't want getCollectionNode to show up in the type definition
let _TableBody = TableBody;

},{"react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"kTLwm":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Column", ()=>_Column);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
function Column(props) {
    return null;
}
Column.getCollectionNode = function* getCollectionNode(props, context) {
    let { title, children, childColumns } = props;
    let rendered = title || children;
    let textValue = props.textValue || (typeof rendered === "string" ? rendered : "") || props["aria-label"];
    let fullNodes = yield {
        type: "column",
        hasChildNodes: !!childColumns || title && (0, _reactDefault.default).Children.count(children) > 0,
        rendered,
        textValue,
        props,
        *childNodes () {
            if (childColumns) for (let child of childColumns)yield {
                type: "column",
                value: child
            };
            else if (title) {
                let childColumns = [];
                (0, _reactDefault.default).Children.forEach(children, (child)=>{
                    childColumns.push({
                        type: "column",
                        element: child
                    });
                });
                yield* childColumns;
            }
        },
        shouldInvalidate (newContext) {
            // This is a bit of a hack, but it works.
            // If this method is called, then there's a cached version of this node available.
            // But, we need to keep the list of columns in the new context up to date.
            updateContext(newContext);
            return false;
        }
    };
    let updateContext = (context)=>{
        // register leaf columns on the context so that <Row> can access them
        for (let node of fullNodes)if (!node.hasChildNodes) context.columns.push(node);
    };
    updateContext(context);
};
/**
 * A Column represents a field of each item within a Table. Columns may also contain nested
 * Column elements to represent column groups. Nested columns can be statically defined as
 * children, or dynamically generated using a function based on the `childColumns` prop.
 */ // We don't want getCollectionNode to show up in the type definition
let _Column = Column;

},{"react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"6bplt":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Row", ()=>_Row);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
function Row(props) {
    return null;
}
Row.getCollectionNode = function* getCollectionNode(props, context) {
    let { children, textValue, UNSTABLE_childItems } = props;
    yield {
        type: "item",
        props: props,
        textValue,
        "aria-label": props["aria-label"],
        hasChildNodes: true,
        *childNodes () {
            // Process cells first
            if (context.showDragButtons) yield {
                type: "cell",
                key: "header-drag",
                props: {
                    isDragButtonCell: true
                }
            };
            if (context.showSelectionCheckboxes && context.selectionMode !== "none") yield {
                type: "cell",
                key: "header",
                props: {
                    isSelectionCell: true
                }
            };
            if (typeof children === "function") {
                for (let column of context.columns)yield {
                    type: "cell",
                    element: children(column.key),
                    key: column.key // this is combined with the row key by CollectionBuilder
                };
                if (UNSTABLE_childItems) for (let child of UNSTABLE_childItems)// Note: in order to reuse the render function of TableBody for our child rows, we just need to yield a type and a value here. CollectionBuilder will then look up
                // the parent renderer and use that to build the full node of this child row, using the value provided here to generate the cells
                yield {
                    type: "item",
                    value: child
                };
            } else {
                let cells = [];
                let childRows = [];
                (0, _reactDefault.default).Children.forEach(children, (node)=>{
                    if (node.type === Row) {
                        if (cells.length < context.columns.length) throw new Error("All of a Row's child Cells must be positioned before any child Rows.");
                        childRows.push({
                            type: "item",
                            element: node
                        });
                    } else cells.push({
                        type: "cell",
                        element: node
                    });
                });
                if (cells.length !== context.columns.length) throw new Error(`Cell count must match column count. Found ${cells.length} cells and ${context.columns.length} columns.`);
                yield* cells;
                yield* childRows;
            }
        },
        shouldInvalidate (newContext) {
            // Invalidate all rows if the columns changed.
            return newContext.columns.length !== context.columns.length || newContext.columns.some((c, i)=>c.key !== context.columns[i].key) || newContext.showSelectionCheckboxes !== context.showSelectionCheckboxes || newContext.showDragButtons !== context.showDragButtons || newContext.selectionMode !== context.selectionMode;
        }
    };
};
/**
 * A Row represents a single item in a Table and contains Cell elements for each column.
 * Cells can be statically defined as children, or generated dynamically using a function
 * based on the columns defined in the TableHeader.
 */ // We don't want getCollectionNode to show up in the type definition
let _Row = Row;

},{"react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"aYdkC":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Cell", ()=>_Cell);
function Cell(props) {
    return null;
}
Cell.getCollectionNode = function* getCollectionNode(props) {
    let { children } = props;
    let textValue = props.textValue || (typeof children === "string" ? children : "") || props["aria-label"] || "";
    yield {
        type: "cell",
        props: props,
        rendered: children,
        textValue,
        "aria-label": props["aria-label"],
        hasChildNodes: false
    };
};
/**
 * A Cell represents the value of a single Column within a Table Row.
 */ // We don't want getCollectionNode to show up in the type definition
let _Cell = Cell;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"bAYIZ":[function(require,module,exports) {
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides state management for a tree grid component. Handles building a collection
 * of columns and rows from props. In addition, it tracks and manages expanded rows, row selection, and sort order changes.
 */ parcelHelpers.export(exports, "UNSTABLE_useTreeGridState", ()=>UNSTABLE_useTreeGridState);
var _collections = require("@react-stately/collections");
var _react = require("react");
var _tableCollection = require("./TableCollection");
var _flags = require("@react-stately/flags");
var _useTableState = require("./useTableState");
var _utils = require("@react-stately/utils");
function UNSTABLE_useTreeGridState(props) {
    let { selectionMode = "none", showSelectionCheckboxes, showDragButtons, UNSTABLE_expandedKeys: propExpandedKeys, UNSTABLE_defaultExpandedKeys: propDefaultExpandedKeys, UNSTABLE_onExpandedChange, children } = props;
    if (!(0, _flags.tableNestedRows)()) throw new Error("Feature flag for table nested rows must be enabled to use useTreeGridState.");
    let [expandedKeys, setExpandedKeys] = (0, _utils.useControlledState)(propExpandedKeys ? convertExpanded(propExpandedKeys) : undefined, propDefaultExpandedKeys ? convertExpanded(propDefaultExpandedKeys) : new Set(), UNSTABLE_onExpandedChange);
    let context = (0, _react.useMemo)(()=>({
            showSelectionCheckboxes: showSelectionCheckboxes && selectionMode !== "none",
            showDragButtons: showDragButtons,
            selectionMode,
            columns: []
        }), [
        children,
        showSelectionCheckboxes,
        selectionMode,
        showDragButtons
    ]);
    let builder = (0, _react.useMemo)(()=>new (0, _collections.CollectionBuilder)(), []);
    let nodes = (0, _react.useMemo)(()=>builder.build({
            children: children
        }, context), [
        builder,
        children,
        context
    ]);
    let treeGridCollection = (0, _react.useMemo)(()=>{
        return generateTreeGridCollection(nodes, {
            showSelectionCheckboxes,
            showDragButtons,
            expandedKeys
        });
    }, [
        nodes,
        showSelectionCheckboxes,
        showDragButtons,
        expandedKeys
    ]);
    let onToggle = (key)=>{
        setExpandedKeys(toggleKey(expandedKeys, key, treeGridCollection));
    };
    let collection = (0, _react.useMemo)(()=>{
        return new (0, _tableCollection.TableCollection)(treeGridCollection.tableNodes, null, context);
    }, [
        context,
        treeGridCollection.tableNodes
    ]);
    let tableState = (0, _useTableState.useTableState)({
        ...props,
        collection
    });
    return {
        ...tableState,
        keyMap: treeGridCollection.keyMap,
        userColumnCount: treeGridCollection.userColumnCount,
        expandedKeys,
        toggleKey: onToggle
    };
}
function toggleKey(currentExpandedKeys, key, collection) {
    let updatedExpandedKeys;
    if (currentExpandedKeys === "all") {
        updatedExpandedKeys = new Set(collection.flattenedRows.filter((row)=>row.props.UNSTABLE_childItems || row.props.children.length > collection.userColumnCount).map((row)=>row.key));
        updatedExpandedKeys.delete(key);
    } else {
        updatedExpandedKeys = new Set(currentExpandedKeys);
        if (updatedExpandedKeys.has(key)) updatedExpandedKeys.delete(key);
        else updatedExpandedKeys.add(key);
    }
    return updatedExpandedKeys;
}
function convertExpanded(expanded) {
    if (!expanded) return new Set();
    return expanded === "all" ? "all" : new Set(expanded);
}
function generateTreeGridCollection(nodes, opts) {
    let { expandedKeys = new Set() } = opts;
    let body;
    let flattenedRows = [];
    let columnCount = 0;
    let userColumnCount = 0;
    let originalColumns = [];
    let keyMap = new Map();
    if (opts === null || opts === void 0 ? void 0 : opts.showSelectionCheckboxes) columnCount++;
    if (opts === null || opts === void 0 ? void 0 : opts.showDragButtons) columnCount++;
    let topLevelRows = [];
    let visit = (node)=>{
        switch(node.type){
            case "body":
                body = node;
                keyMap.set(body.key, body);
                break;
            case "column":
                if (!node.hasChildNodes) userColumnCount++;
                break;
            case "item":
                topLevelRows.push(node);
                return;
        }
        for (let child of node.childNodes)visit(child);
    };
    for (let node of nodes){
        if (node.type === "column") originalColumns.push(node);
        visit(node);
    }
    columnCount += userColumnCount;
    // Update each grid node in the treegrid table with values specific to a treegrid structure. Also store a set of flattened row nodes for TableCollection to consume
    let globalRowCount = 0;
    let visitNode = (node, i)=>{
        // Clone row node and its children so modifications to the node for treegrid specific values aren't applied on the nodes provided
        // to TableCollection. Index, level, and parent keys are all changed to reflect a flattened row structure rather than the treegrid structure
        // values automatically calculated via CollectionBuilder
        if (node.type === "item") {
            let childNodes = [];
            for (let child of node.childNodes)if (child.type === "cell") {
                let cellClone = {
                    ...child
                };
                if (cellClone.index + 1 === columnCount) cellClone.nextKey = null;
                childNodes.push({
                    ...cellClone
                });
            }
            let clone = {
                ...node,
                childNodes: childNodes,
                parentKey: body.key,
                level: 1,
                index: globalRowCount++
            };
            flattenedRows.push(clone);
        }
        let newProps = {};
        // Assign indexOfType to cells and rows for aria-posinset
        if (node.type !== "placeholder" && node.type !== "column") newProps["indexOfType"] = i;
        // Use Object.assign instead of spread to preserve object reference for keyMap. Also ensures retrieving nodes
        // via .childNodes returns the same object as the one found via keyMap look up
        Object.assign(node, newProps);
        keyMap.set(node.key, node);
        let lastNode;
        let rowIndex = 0;
        for (let child of node.childNodes)if (!(child.type === "item" && expandedKeys !== "all" && !expandedKeys.has(node.key))) {
            if (child.parentKey == null) // if child is a cell/expanded row/column and the parent key isn't already established by the collection, match child node to parent row
            child.parentKey = node.key;
            if (lastNode) {
                lastNode.nextKey = child.key;
                child.prevKey = lastNode.key;
            } else child.prevKey = null;
            if (child.type === "item") visitNode(child, rowIndex++);
            else // We enforce that the cells come before rows so can just reuse cell index
            visitNode(child, child.index);
            lastNode = child;
        }
        if (lastNode) lastNode.nextKey = null;
    };
    let last;
    topLevelRows.forEach((node, i)=>{
        visitNode(node, i);
        if (last) {
            last.nextKey = node.key;
            node.prevKey = last.key;
        } else node.prevKey = null;
        last = node;
    });
    if (last) last.nextKey = null;
    return {
        keyMap,
        userColumnCount,
        flattenedRows,
        tableNodes: [
            ...originalColumns,
            {
                ...body,
                childNodes: flattenedRows
            }
        ]
    };
}

},{"@react-stately/collections":"loANi","react":"9yzVZ","./TableCollection":"gNXPB","@react-stately/flags":"aEc5X","./useTableState":"iSIWP","@react-stately/utils":"cpDPf","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"47SYn":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useTabListState", ()=>(0, _useTabListState.useTabListState));
var _useTabListState = require("./useTabListState");

},{"./useTabListState":"i1tep","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"i1tep":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides state management for a Tabs component. Tabs include a TabList which tracks
 * which tab is currently selected and displays the content associated with that Tab in a TabPanel.
 */ parcelHelpers.export(exports, "useTabListState", ()=>useTabListState);
var _list = require("@react-stately/list");
var _react = require("react");
function useTabListState(props) {
    var _props_defaultSelectedKey;
    let state = (0, _list.useSingleSelectListState)({
        ...props,
        suppressTextValueWarning: true,
        defaultSelectedKey: (_props_defaultSelectedKey = props.defaultSelectedKey) !== null && _props_defaultSelectedKey !== void 0 ? _props_defaultSelectedKey : findDefaultSelectedKey(props.collection, props.disabledKeys ? new Set(props.disabledKeys) : new Set())
    });
    let { selectionManager, collection, selectedKey: currentSelectedKey } = state;
    let lastSelectedKey = (0, _react.useRef)(currentSelectedKey);
    (0, _react.useEffect)(()=>{
        // Ensure a tab is always selected (in case no selected key was specified or if selected item was deleted from collection)
        let selectedKey = currentSelectedKey;
        if (selectionManager.isEmpty || !collection.getItem(selectedKey)) {
            selectedKey = findDefaultSelectedKey(collection, state.disabledKeys);
            if (selectedKey != null) // directly set selection because replace/toggle selection won't consider disabled keys
            selectionManager.setSelectedKeys([
                selectedKey
            ]);
        }
        // If the tablist doesn't have focus and the selected key changes or if there isn't a focused key yet, change focused key to the selected key if it exists.
        if (selectedKey != null && selectionManager.focusedKey == null || !selectionManager.isFocused && selectedKey !== lastSelectedKey.current) selectionManager.setFocusedKey(selectedKey);
        lastSelectedKey.current = selectedKey;
    });
    return {
        ...state,
        isDisabled: props.isDisabled || false
    };
}
function findDefaultSelectedKey(collection, disabledKeys) {
    let selectedKey = null;
    if (collection) {
        selectedKey = collection.getFirstKey();
        // loop over tabs until we find one that isn't disabled and select that
        while(disabledKeys.has(selectedKey) && selectedKey !== collection.getLastKey())selectedKey = collection.getKeyAfter(selectedKey);
        // if this check is true, then every item is disabled, it makes more sense to default to the first key than the last
        if (disabledKeys.has(selectedKey) && selectedKey === collection.getLastKey()) selectedKey = collection.getFirstKey();
    }
    return selectedKey;
}

},{"@react-stately/list":"Cp0zP","react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"6Tizp":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useTooltipTriggerState", ()=>(0, _useTooltipTriggerState.useTooltipTriggerState));
var _useTooltipTriggerState = require("./useTooltipTriggerState");

},{"./useTooltipTriggerState":"765ya","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"765ya":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Manages state for a tooltip trigger. Tracks whether the tooltip is open, and provides
 * methods to toggle this state. Ensures only one tooltip is open at a time and controls
 * the delay for showing a tooltip.
 */ parcelHelpers.export(exports, "useTooltipTriggerState", ()=>useTooltipTriggerState);
var _react = require("react");
var _overlays = require("@react-stately/overlays");
const TOOLTIP_DELAY = 1500; // this seems to be a 1.5 second delay, check with design
const TOOLTIP_COOLDOWN = 500;
let tooltips = {};
let tooltipId = 0;
let globalWarmedUp = false;
let globalWarmUpTimeout = null;
let globalCooldownTimeout = null;
function useTooltipTriggerState(props = {}) {
    let { delay = TOOLTIP_DELAY, closeDelay = TOOLTIP_COOLDOWN } = props;
    let { isOpen, open, close } = (0, _overlays.useOverlayTriggerState)(props);
    let id = (0, _react.useMemo)(()=>`${++tooltipId}`, []);
    let closeTimeout = (0, _react.useRef)();
    let ensureTooltipEntry = ()=>{
        tooltips[id] = hideTooltip;
    };
    let closeOpenTooltips = ()=>{
        for(let hideTooltipId in tooltips)if (hideTooltipId !== id) {
            tooltips[hideTooltipId](true);
            delete tooltips[hideTooltipId];
        }
    };
    let showTooltip = ()=>{
        clearTimeout(closeTimeout.current);
        closeTimeout.current = null;
        closeOpenTooltips();
        ensureTooltipEntry();
        globalWarmedUp = true;
        open();
        if (globalWarmUpTimeout) {
            clearTimeout(globalWarmUpTimeout);
            globalWarmUpTimeout = null;
        }
        if (globalCooldownTimeout) {
            clearTimeout(globalCooldownTimeout);
            globalCooldownTimeout = null;
        }
    };
    let hideTooltip = (immediate)=>{
        if (immediate || closeDelay <= 0) {
            clearTimeout(closeTimeout.current);
            closeTimeout.current = null;
            close();
        } else if (!closeTimeout.current) closeTimeout.current = setTimeout(()=>{
            closeTimeout.current = null;
            close();
        }, closeDelay);
        if (globalWarmUpTimeout) {
            clearTimeout(globalWarmUpTimeout);
            globalWarmUpTimeout = null;
        }
        if (globalWarmedUp) {
            if (globalCooldownTimeout) clearTimeout(globalCooldownTimeout);
            globalCooldownTimeout = setTimeout(()=>{
                delete tooltips[id];
                globalCooldownTimeout = null;
                globalWarmedUp = false;
            }, Math.max(TOOLTIP_COOLDOWN, closeDelay));
        }
    };
    let warmupTooltip = ()=>{
        closeOpenTooltips();
        ensureTooltipEntry();
        if (!isOpen && !globalWarmUpTimeout && !globalWarmedUp) globalWarmUpTimeout = setTimeout(()=>{
            globalWarmUpTimeout = null;
            globalWarmedUp = true;
            showTooltip();
        }, delay);
        else if (!isOpen) showTooltip();
    };
    // eslint-disable-next-line arrow-body-style
    (0, _react.useEffect)(()=>{
        return ()=>{
            clearTimeout(closeTimeout.current);
            let tooltip = tooltips[id];
            if (tooltip) delete tooltips[id];
        };
    }, [
        id
    ]);
    return {
        isOpen,
        open: (immediate)=>{
            if (!immediate && delay > 0 && !closeTimeout.current) warmupTooltip();
            else showTooltip();
        },
        close: hideTooltip
    };
}

},{"react":"9yzVZ","@react-stately/overlays":"5uxM4","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"f1QlQ":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useTreeState", ()=>(0, _useTreeState.useTreeState));
parcelHelpers.export(exports, "TreeCollection", ()=>(0, _treeCollection.TreeCollection));
var _useTreeState = require("./useTreeState");
var _treeCollection = require("./TreeCollection");

},{"./useTreeState":"jYeIc","./TreeCollection":false,"@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"jYeIc":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides state management for tree-like components. Handles building a collection
 * of items from props, item expanded state, and manages multiple selection state.
 */ parcelHelpers.export(exports, "useTreeState", ()=>useTreeState);
var _selection = require("@react-stately/selection");
var _treeCollection = require("./TreeCollection");
var _react = require("react");
var _collections = require("@react-stately/collections");
var _utils = require("@react-stately/utils");
function useTreeState(props) {
    let [expandedKeys, setExpandedKeys] = (0, _utils.useControlledState)(props.expandedKeys ? new Set(props.expandedKeys) : undefined, props.defaultExpandedKeys ? new Set(props.defaultExpandedKeys) : new Set(), props.onExpandedChange);
    let selectionState = (0, _selection.useMultipleSelectionState)(props);
    let disabledKeys = (0, _react.useMemo)(()=>props.disabledKeys ? new Set(props.disabledKeys) : new Set(), [
        props.disabledKeys
    ]);
    let tree = (0, _collections.useCollection)(props, (0, _react.useCallback)((nodes)=>new (0, _treeCollection.TreeCollection)(nodes, {
            expandedKeys
        }), [
        expandedKeys
    ]), null);
    // Reset focused key if that item is deleted from the collection.
    (0, _react.useEffect)(()=>{
        if (selectionState.focusedKey != null && !tree.getItem(selectionState.focusedKey)) selectionState.setFocusedKey(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        tree,
        selectionState.focusedKey
    ]);
    let onToggle = (key)=>{
        setExpandedKeys(toggleKey(expandedKeys, key));
    };
    return {
        collection: tree,
        expandedKeys,
        disabledKeys,
        toggleKey: onToggle,
        setExpandedKeys,
        selectionManager: new (0, _selection.SelectionManager)(tree, selectionState)
    };
}
function toggleKey(set, key) {
    let res = new Set(set);
    if (res.has(key)) res.delete(key);
    else res.add(key);
    return res;
}

},{"@react-stately/selection":"hM12z","./TreeCollection":"4YMte","react":"9yzVZ","@react-stately/collections":"loANi","@react-stately/utils":"cpDPf","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"4YMte":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TreeCollection", ()=>TreeCollection);
class TreeCollection {
    *[Symbol.iterator]() {
        yield* this.iterable;
    }
    get size() {
        return this.keyMap.size;
    }
    getKeys() {
        return this.keyMap.keys();
    }
    getKeyBefore(key) {
        let node = this.keyMap.get(key);
        return node ? node.prevKey : null;
    }
    getKeyAfter(key) {
        let node = this.keyMap.get(key);
        return node ? node.nextKey : null;
    }
    getFirstKey() {
        return this.firstKey;
    }
    getLastKey() {
        return this.lastKey;
    }
    getItem(key) {
        return this.keyMap.get(key);
    }
    at(idx) {
        const keys = [
            ...this.getKeys()
        ];
        return this.getItem(keys[idx]);
    }
    constructor(nodes, { expandedKeys } = {}){
        this.keyMap = new Map();
        this.iterable = nodes;
        expandedKeys = expandedKeys || new Set();
        let visit = (node)=>{
            this.keyMap.set(node.key, node);
            if (node.childNodes && (node.type === "section" || expandedKeys.has(node.key))) for (let child of node.childNodes)visit(child);
        };
        for (let node of nodes)visit(node);
        let last;
        let index = 0;
        for (let [key, node] of this.keyMap){
            if (last) {
                last.nextKey = key;
                node.prevKey = last.key;
            } else {
                this.firstKey = key;
                node.prevKey = undefined;
            }
            if (node.type === "item") node.index = index++;
            last = node;
            // Set nextKey as undefined since this might be the last node
            // If it isn't the last node, last.nextKey will properly set at start of new loop
            last.nextKey = undefined;
        }
        this.lastKey = last === null || last === void 0 ? void 0 : last.key;
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"gl7db":[function(require,module,exports) {
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HeadingContext", ()=>HeadingContext);
parcelHelpers.export(exports, "Heading", ()=>_Heading);
var _utils = require("./utils");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const HeadingContext = /*#__PURE__*/ (0, _react.createContext)({});
function Heading(props, ref) {
    [props, ref] = (0, _utils.useContextProps)(props, ref, HeadingContext);
    let { children, level = 3, className, ...domProps } = props;
    let Element = `h${level}`;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Element, {
        ...domProps,
        ref: ref,
        className: className !== null && className !== void 0 ? className : "react-aria-Heading"
    }, children);
}
const _Heading = /*#__PURE__*/ (0, _react.forwardRef)(Heading);

},{"./utils":"iyTLn","react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"iZUDL":[function(require,module,exports) {
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TextContext", ()=>TextContext);
parcelHelpers.export(exports, "Text", ()=>_Text);
var _utils = require("./utils");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const TextContext = /*#__PURE__*/ (0, _react.createContext)({});
function Text(props, ref) {
    [props, ref] = (0, _utils.useContextProps)(props, ref, TextContext);
    let { elementType: ElementType = "span", ...domProps } = props;
    // @ts-ignore
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(ElementType, {
        className: "react-aria-Text",
        ...domProps,
        ref: ref
    });
}
const _Text = /*#__PURE__*/ (0, _react.forwardRef)(Text);

},{"./utils":"iyTLn","react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"fxrKi":[function(require,module,exports) {
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CheckboxGroupContext", ()=>CheckboxGroupContext);
parcelHelpers.export(exports, "CheckboxGroupStateContext", ()=>CheckboxGroupStateContext);
parcelHelpers.export(exports, "CheckboxContext", ()=>CheckboxContext);
parcelHelpers.export(exports, "Checkbox", ()=>_Checkbox);
parcelHelpers.export(exports, "CheckboxGroup", ()=>_CheckboxGroup);
var _reactAria = require("react-aria");
var _reactStately = require("react-stately");
var _utils = require("./utils");
var _fieldError = require("./FieldError");
var _utils1 = require("@react-aria/utils");
var _label = require("./Label");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _text = require("./Text");
const CheckboxGroupContext = /*#__PURE__*/ (0, _react.createContext)(null);
const CheckboxGroupStateContext = /*#__PURE__*/ (0, _react.createContext)(null);
function CheckboxGroup(props, ref) {
    [props, ref] = (0, _utils.useContextProps)(props, ref, CheckboxGroupContext);
    var _props_validationBehavior;
    let state = (0, _reactStately.useCheckboxGroupState)({
        ...props,
        validationBehavior: (_props_validationBehavior = props.validationBehavior) !== null && _props_validationBehavior !== void 0 ? _props_validationBehavior : "native"
    });
    let [labelRef, label] = (0, _utils.useSlot)();
    var _props_validationBehavior1;
    let { groupProps, labelProps, descriptionProps, errorMessageProps, ...validation } = (0, _reactAria.useCheckboxGroup)({
        ...props,
        label,
        validationBehavior: (_props_validationBehavior1 = props.validationBehavior) !== null && _props_validationBehavior1 !== void 0 ? _props_validationBehavior1 : "native"
    }, state);
    let renderProps = (0, _utils.useRenderProps)({
        ...props,
        values: {
            isDisabled: state.isDisabled,
            isReadOnly: state.isReadOnly,
            isRequired: props.isRequired || false,
            isInvalid: state.isInvalid,
            state
        },
        defaultClassName: "react-aria-CheckboxGroup"
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...groupProps,
        ...renderProps,
        ref: ref,
        slot: props.slot || undefined,
        "data-readonly": state.isReadOnly || undefined,
        "data-required": props.isRequired || undefined,
        "data-invalid": state.isInvalid || undefined,
        "data-disabled": props.isDisabled || undefined
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.Provider), {
        values: [
            [
                CheckboxGroupStateContext,
                state
            ],
            [
                (0, _label.LabelContext),
                {
                    ...labelProps,
                    ref: labelRef,
                    elementType: "span"
                }
            ],
            [
                (0, _text.TextContext),
                {
                    slots: {
                        description: descriptionProps,
                        errorMessage: errorMessageProps
                    }
                }
            ],
            [
                (0, _fieldError.FieldErrorContext),
                validation
            ]
        ]
    }, renderProps.children));
}
const CheckboxContext = /*#__PURE__*/ (0, _react.createContext)(null);
function Checkbox(props, ref) {
    [props, ref] = (0, _utils.useContextProps)(props, ref, CheckboxContext);
    let inputRef = (0, _react.useRef)(null);
    let groupState = (0, _react.useContext)(CheckboxGroupStateContext);
    var _props_validationBehavior;
    let { labelProps, inputProps, isSelected, isDisabled, isReadOnly, isPressed, isInvalid } = groupState ? (0, _reactAria.useCheckboxGroupItem)({
        ...props,
        // Value is optional for standalone checkboxes, but required for CheckboxGroup items;
        // it's passed explicitly here to avoid typescript error (requires ignore).
        // @ts-ignore
        value: props.value,
        // ReactNode type doesn't allow function children.
        children: typeof props.children === "function" ? true : props.children
    }, groupState, inputRef) : (0, _reactAria.useCheckbox)({
        ...props,
        children: typeof props.children === "function" ? true : props.children,
        validationBehavior: (_props_validationBehavior = props.validationBehavior) !== null && _props_validationBehavior !== void 0 ? _props_validationBehavior : "native"
    }, (0, _reactStately.useToggleState)(props), inputRef);
    let { isFocused, isFocusVisible, focusProps } = (0, _reactAria.useFocusRing)();
    let isInteractionDisabled = isDisabled || isReadOnly;
    let { hoverProps, isHovered } = (0, _reactAria.useHover)({
        ...props,
        isDisabled: isInteractionDisabled
    });
    let renderProps = (0, _utils.useRenderProps)({
        // TODO: should data attrs go on the label or on the <input>? useCheckbox passes them to the input...
        ...props,
        defaultClassName: "react-aria-Checkbox",
        values: {
            isSelected,
            isIndeterminate: props.isIndeterminate || false,
            isPressed,
            isHovered,
            isFocused,
            isFocusVisible,
            isDisabled,
            isReadOnly,
            isInvalid,
            isRequired: props.isRequired || false
        }
    });
    let DOMProps = (0, _utils1.filterDOMProps)(props);
    delete DOMProps.id;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("label", {
        ...(0, _reactAria.mergeProps)(DOMProps, labelProps, hoverProps, renderProps),
        ref: ref,
        slot: props.slot || undefined,
        "data-selected": isSelected || undefined,
        "data-indeterminate": props.isIndeterminate || undefined,
        "data-pressed": isPressed || undefined,
        "data-hovered": isHovered || undefined,
        "data-focused": isFocused || undefined,
        "data-focus-visible": isFocusVisible || undefined,
        "data-disabled": isDisabled || undefined,
        "data-readonly": isReadOnly || undefined,
        "data-invalid": isInvalid || undefined,
        "data-required": props.isRequired || undefined
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAria.VisuallyHidden), {
        elementType: "span"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("input", {
        ...(0, _reactAria.mergeProps)(inputProps, focusProps),
        ref: inputRef
    })), renderProps.children);
}
/**
 * A checkbox allows a user to select multiple items from a list of individual items, or
 * to mark one individual item as selected.
 */ const _Checkbox = /*#__PURE__*/ (0, _react.forwardRef)(Checkbox);
/**
 * A checkbox group allows a user to select multiple items from a list of options.
 */ const _CheckboxGroup = /*#__PURE__*/ (0, _react.forwardRef)(CheckboxGroup);

},{"react-aria":"e7jhe","react-stately":"ij62t","./utils":"iyTLn","./FieldError":"3acDn","@react-aria/utils":"9cLk5","./Label":"jhkeS","react":"9yzVZ","./Text":"iZUDL","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"3acDn":[function(require,module,exports) {
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FieldErrorContext", ()=>FieldErrorContext);
parcelHelpers.export(exports, "FieldError", ()=>_FieldError);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _utils = require("./utils");
var _text = require("./Text");
const FieldErrorContext = /*#__PURE__*/ (0, _react.createContext)(null);
function FieldError(props, ref) {
    let validation = (0, _react.useContext)(FieldErrorContext);
    if (!(validation === null || validation === void 0 ? void 0 : validation.isInvalid)) return null;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(FieldErrorInner, {
        ...props,
        ref: ref
    });
}
/**
 * A FieldError displays validation errors for a form field.
 */ const _FieldError = /*#__PURE__*/ (0, _react.forwardRef)(FieldError);
const FieldErrorInner = /*#__PURE__*/ (0, _react.forwardRef)((props, ref)=>{
    let validation = (0, _react.useContext)(FieldErrorContext);
    let renderProps = (0, _utils.useRenderProps)({
        ...props,
        defaultClassName: "react-aria-FieldError",
        defaultChildren: validation.validationErrors.join(" "),
        values: validation
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), {
        slot: "errorMessage",
        ...renderProps,
        ref: ref
    });
});

},{"react":"9yzVZ","./utils":"iyTLn","./Text":"iZUDL","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"jhkeS":[function(require,module,exports) {
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LabelContext", ()=>LabelContext);
parcelHelpers.export(exports, "Label", ()=>_Label);
var _utils = require("./utils");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const LabelContext = /*#__PURE__*/ (0, _react.createContext)({});
function Label(props, ref) {
    [props, ref] = (0, _utils.useContextProps)(props, ref, LabelContext);
    let { elementType: ElementType = "label", ...labelProps } = props;
    // @ts-ignore
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(ElementType, {
        className: "react-aria-Label",
        ...labelProps,
        ref: ref
    });
}
const _Label = /*#__PURE__*/ (0, _utils.createHideableComponent)(Label);

},{"./utils":"iyTLn","react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"WIt2x":[function(require,module,exports) {
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ComboBoxContext", ()=>ComboBoxContext);
parcelHelpers.export(exports, "ComboBoxStateContext", ()=>ComboBoxStateContext);
parcelHelpers.export(exports, "ComboBox", ()=>_ComboBox);
var _reactAria = require("react-aria");
var _button = require("./Button");
var _reactStately = require("react-stately");
var _collection = require("./Collection");
var _utils = require("./utils");
var _fieldError = require("./FieldError");
var _utils1 = require("@react-aria/utils");
var _group = require("./Group");
var _input = require("./Input");
var _label = require("./Label");
var _listBox = require("./ListBox");
var _dialog = require("./Dialog");
var _popover = require("./Popover");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _text = require("./Text");
const ComboBoxContext = /*#__PURE__*/ (0, _react.createContext)(null);
const ComboBoxStateContext = /*#__PURE__*/ (0, _react.createContext)(null);
function ComboBox(props, ref) {
    [props, ref] = (0, _utils.useContextProps)(props, ref, ComboBoxContext);
    let { collection, document } = (0, _collection.useCollectionDocument)();
    let { children, isDisabled = false, isInvalid = false, isRequired = false } = props;
    children = (0, _react.useMemo)(()=>typeof children === "function" ? children({
            isOpen: false,
            isDisabled,
            isInvalid,
            isRequired
        }) : children, [
        children,
        isDisabled,
        isInvalid,
        isRequired
    ]);
    var _props_items;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.Hidden), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.Provider), {
        values: [
            [
                (0, _collection.CollectionDocumentContext),
                document
            ],
            [
                (0, _listBox.ListBoxContext),
                {
                    items: (_props_items = props.items) !== null && _props_items !== void 0 ? _props_items : props.defaultItems
                }
            ]
        ]
    }, children)), /*#__PURE__*/ (0, _reactDefault.default).createElement(ComboBoxInner, {
        props: props,
        collection: collection,
        comboBoxRef: ref
    }));
}
function ComboBoxInner({ props, collection, comboBoxRef: ref }) {
    let { name, formValue = "key", allowsCustomValue } = props;
    if (allowsCustomValue) formValue = "text";
    let { contains } = (0, _reactAria.useFilter)({
        sensitivity: "base"
    });
    var _props_validationBehavior;
    let state = (0, _reactStately.useComboBoxState)({
        defaultFilter: props.defaultFilter || contains,
        ...props,
        // If props.items isn't provided, rely on collection filtering (aka listbox.items is provided or defaultItems provided to Combobox)
        items: props.items,
        children: undefined,
        collection,
        validationBehavior: (_props_validationBehavior = props.validationBehavior) !== null && _props_validationBehavior !== void 0 ? _props_validationBehavior : "native"
    });
    let buttonRef = (0, _react.useRef)(null);
    let inputRef = (0, _react.useRef)(null);
    let listBoxRef = (0, _react.useRef)(null);
    let popoverRef = (0, _react.useRef)(null);
    let [labelRef, label] = (0, _utils.useSlot)();
    var _props_validationBehavior1;
    let { buttonProps, inputProps, listBoxProps, labelProps, descriptionProps, errorMessageProps, ...validation } = (0, _reactAria.useComboBox)({
        ...(0, _utils.removeDataAttributes)(props),
        label,
        inputRef,
        buttonRef,
        listBoxRef,
        popoverRef,
        name: formValue === "text" ? name : undefined,
        validationBehavior: (_props_validationBehavior1 = props.validationBehavior) !== null && _props_validationBehavior1 !== void 0 ? _props_validationBehavior1 : "native"
    }, state);
    // Make menu width match input + button
    let [menuWidth, setMenuWidth] = (0, _react.useState)(null);
    let onResize = (0, _react.useCallback)(()=>{
        if (inputRef.current) {
            var _buttonRef_current;
            let buttonRect = (_buttonRef_current = buttonRef.current) === null || _buttonRef_current === void 0 ? void 0 : _buttonRef_current.getBoundingClientRect();
            let inputRect = inputRef.current.getBoundingClientRect();
            let minX = buttonRect ? Math.min(buttonRect.left, inputRect.left) : inputRect.left;
            let maxX = buttonRect ? Math.max(buttonRect.right, inputRect.right) : inputRect.right;
            setMenuWidth(maxX - minX + "px");
        }
    }, [
        buttonRef,
        inputRef,
        setMenuWidth
    ]);
    (0, _utils1.useResizeObserver)({
        ref: inputRef,
        onResize: onResize
    });
    // Only expose a subset of state to renderProps function to avoid infinite render loop
    let renderPropsState = (0, _react.useMemo)(()=>({
            isOpen: state.isOpen,
            isDisabled: props.isDisabled || false,
            isInvalid: validation.isInvalid || false,
            isRequired: props.isRequired || false
        }), [
        state.isOpen,
        props.isDisabled,
        validation.isInvalid,
        props.isRequired
    ]);
    let renderProps = (0, _utils.useRenderProps)({
        ...props,
        values: renderPropsState,
        defaultClassName: "react-aria-ComboBox"
    });
    let DOMProps = (0, _utils1.filterDOMProps)(props);
    delete DOMProps.id;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.Provider), {
        values: [
            [
                ComboBoxStateContext,
                state
            ],
            [
                (0, _label.LabelContext),
                {
                    ...labelProps,
                    ref: labelRef
                }
            ],
            [
                (0, _button.ButtonContext),
                {
                    ...buttonProps,
                    ref: buttonRef,
                    isPressed: state.isOpen
                }
            ],
            [
                (0, _input.InputContext),
                {
                    ...inputProps,
                    ref: inputRef
                }
            ],
            [
                (0, _dialog.OverlayTriggerStateContext),
                state
            ],
            [
                (0, _popover.PopoverContext),
                {
                    ref: popoverRef,
                    triggerRef: inputRef,
                    placement: "bottom start",
                    isNonModal: true,
                    trigger: "ComboBox",
                    style: {
                        "--trigger-width": menuWidth
                    }
                }
            ],
            [
                (0, _listBox.ListBoxContext),
                {
                    ...listBoxProps,
                    ref: listBoxRef
                }
            ],
            [
                (0, _listBox.ListStateContext),
                state
            ],
            [
                (0, _text.TextContext),
                {
                    slots: {
                        description: descriptionProps,
                        errorMessage: errorMessageProps
                    }
                }
            ],
            [
                (0, _group.GroupContext),
                {
                    isInvalid: validation.isInvalid,
                    isDisabled: props.isDisabled || false
                }
            ],
            [
                (0, _fieldError.FieldErrorContext),
                validation
            ]
        ]
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...DOMProps,
        ...renderProps,
        ref: ref,
        slot: props.slot || undefined,
        "data-focused": state.isFocused || undefined,
        "data-open": state.isOpen || undefined,
        "data-disabled": props.isDisabled || undefined,
        "data-invalid": validation.isInvalid || undefined,
        "data-required": props.isRequired || undefined
    }), name && formValue === "key" && /*#__PURE__*/ (0, _reactDefault.default).createElement("input", {
        type: "hidden",
        name: name,
        value: state.selectedKey
    }));
}
/**
 * A combo box combines a text input with a listbox, allowing users to filter a list of options to items matching a query.
 */ const _ComboBox = /*#__PURE__*/ (0, _react.forwardRef)(ComboBox);

},{"react-aria":"e7jhe","./Button":"9McZy","react-stately":"ij62t","./Collection":"lJDFi","./utils":"iyTLn","./FieldError":"3acDn","@react-aria/utils":"9cLk5","./Group":"71duS","./Input":"3u8zn","./Label":"jhkeS","./ListBox":"katmG","./Dialog":"7F4Zw","./Popover":"Gl2h9","react":"9yzVZ","./Text":"iZUDL","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"lJDFi":[function(require,module,exports) {
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/** An immutable object representing a Node in a Collection. */ parcelHelpers.export(exports, "NodeValue", ()=>NodeValue);
/**
 * A mutable element node in the fake DOM tree. It owns an immutable
 * Collection Node which is copied on write.
 */ parcelHelpers.export(exports, "ElementNode", ()=>ElementNode);
/**
 * An immutable Collection implementation. Updates are only allowed
 * when it is not marked as frozen.
 */ parcelHelpers.export(exports, "BaseCollection", ()=>BaseCollection);
/**
 * A mutable Document in the fake DOM. It owns an immutable Collection instance,
 * which is lazily copied on write during updates.
 */ parcelHelpers.export(exports, "Document", ()=>Document);
parcelHelpers.export(exports, "useCachedChildren", ()=>useCachedChildren);
parcelHelpers.export(exports, "useCollectionChildren", ()=>useCollectionChildren);
parcelHelpers.export(exports, "useCollection", ()=>useCollection);
parcelHelpers.export(exports, "useCollectionDocument", ()=>useCollectionDocument);
parcelHelpers.export(exports, "CollectionDocumentContext", ()=>CollectionDocumentContext);
parcelHelpers.export(exports, "useCollectionPortal", ()=>useCollectionPortal);
parcelHelpers.export(exports, "CollectionPortal", ()=>CollectionPortal);
/** Renders a DOM element (e.g. separator or header) shallowly when inside a collection. */ parcelHelpers.export(exports, "useShallowRender", ()=>useShallowRender);
parcelHelpers.export(exports, "useCollectionItemRef", ()=>useCollectionItemRef);
parcelHelpers.export(exports, "useSSRCollectionNode", ()=>useSSRCollectionNode);
parcelHelpers.export(exports, "Section", ()=>_Section);
parcelHelpers.export(exports, "CollectionContext", ()=>CollectionContext);
parcelHelpers.export(exports, "CollectionRendererContext", ()=>CollectionRendererContext);
/** A Collection renders a list of items, automatically managing caching and keys. */ parcelHelpers.export(exports, "Collection", ()=>Collection);
var _reactDom = require("react-dom");
var _reactAria = require("react-aria");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _indexJs = require("use-sync-external-store/shim/index.js");
class NodeValue {
    get childNodes() {
        throw new Error("childNodes is not supported");
    }
    clone() {
        let node = new NodeValue(this.type, this.key);
        node.value = this.value;
        node.level = this.level;
        node.hasChildNodes = this.hasChildNodes;
        node.rendered = this.rendered;
        node.textValue = this.textValue;
        node["aria-label"] = this["aria-label"];
        node.index = this.index;
        node.parentKey = this.parentKey;
        node.prevKey = this.prevKey;
        node.nextKey = this.nextKey;
        node.firstChildKey = this.firstChildKey;
        node.lastChildKey = this.lastChildKey;
        node.props = this.props;
        return node;
    }
    constructor(type, key){
        this.value = null;
        this.level = 0;
        this.hasChildNodes = false;
        this.rendered = null;
        this.textValue = "";
        this["aria-label"] = undefined;
        this.index = 0;
        this.parentKey = null;
        this.prevKey = null;
        this.nextKey = null;
        this.firstChildKey = null;
        this.lastChildKey = null;
        this.props = {};
        this.type = type;
        this.key = key;
    }
}
/**
 * A mutable node in the fake DOM tree. When mutated, it marks itself as dirty
 * and queues an update with the owner document.
 */ class BaseNode {
    *[Symbol.iterator]() {
        let node = this.firstChild;
        while(node){
            yield node;
            node = node.nextSibling;
        }
    }
    get firstChild() {
        return this._firstChild;
    }
    set firstChild(firstChild) {
        this._firstChild = firstChild;
        this.ownerDocument.markDirty(this);
    }
    get lastChild() {
        return this._lastChild;
    }
    set lastChild(lastChild) {
        this._lastChild = lastChild;
        this.ownerDocument.markDirty(this);
    }
    get previousSibling() {
        return this._previousSibling;
    }
    set previousSibling(previousSibling) {
        this._previousSibling = previousSibling;
        this.ownerDocument.markDirty(this);
    }
    get nextSibling() {
        return this._nextSibling;
    }
    set nextSibling(nextSibling) {
        this._nextSibling = nextSibling;
        this.ownerDocument.markDirty(this);
    }
    get parentNode() {
        return this._parentNode;
    }
    set parentNode(parentNode) {
        this._parentNode = parentNode;
        this.ownerDocument.markDirty(this);
    }
    get isConnected() {
        var _this_parentNode;
        return ((_this_parentNode = this.parentNode) === null || _this_parentNode === void 0 ? void 0 : _this_parentNode.isConnected) || false;
    }
    appendChild(child) {
        this.ownerDocument.startTransaction();
        if (child.parentNode) child.parentNode.removeChild(child);
        if (this.firstChild == null) this.firstChild = child;
        if (this.lastChild) {
            this.lastChild.nextSibling = child;
            child.index = this.lastChild.index + 1;
            child.previousSibling = this.lastChild;
        } else {
            child.previousSibling = null;
            child.index = 0;
        }
        child.parentNode = this;
        child.nextSibling = null;
        this.lastChild = child;
        this.ownerDocument.markDirty(this);
        if (child.hasSetProps) // Only add the node to the collection if we already received props for it.
        // Otherwise wait until then so we have the correct id for the node.
        this.ownerDocument.addNode(child);
        this.ownerDocument.endTransaction();
        this.ownerDocument.queueUpdate();
    }
    insertBefore(newNode, referenceNode) {
        if (referenceNode == null) return this.appendChild(newNode);
        this.ownerDocument.startTransaction();
        if (newNode.parentNode) newNode.parentNode.removeChild(newNode);
        newNode.nextSibling = referenceNode;
        newNode.previousSibling = referenceNode.previousSibling;
        newNode.index = referenceNode.index;
        if (this.firstChild === referenceNode) this.firstChild = newNode;
        else if (referenceNode.previousSibling) referenceNode.previousSibling.nextSibling = newNode;
        referenceNode.previousSibling = newNode;
        newNode.parentNode = referenceNode.parentNode;
        let node = referenceNode;
        while(node){
            node.index++;
            node = node.nextSibling;
        }
        if (newNode.hasSetProps) this.ownerDocument.addNode(newNode);
        this.ownerDocument.endTransaction();
        this.ownerDocument.queueUpdate();
    }
    removeChild(child) {
        if (child.parentNode !== this) return;
        this.ownerDocument.startTransaction();
        let node = child.nextSibling;
        while(node){
            node.index--;
            node = node.nextSibling;
        }
        if (child.nextSibling) child.nextSibling.previousSibling = child.previousSibling;
        if (child.previousSibling) child.previousSibling.nextSibling = child.nextSibling;
        if (this.firstChild === child) this.firstChild = child.nextSibling;
        if (this.lastChild === child) this.lastChild = child.previousSibling;
        child.parentNode = null;
        child.nextSibling = null;
        child.previousSibling = null;
        child.index = 0;
        this.ownerDocument.removeNode(child);
        this.ownerDocument.endTransaction();
        this.ownerDocument.queueUpdate();
    }
    addEventListener() {}
    removeEventListener() {}
    constructor(ownerDocument){
        this._firstChild = null;
        this._lastChild = null;
        this._previousSibling = null;
        this._nextSibling = null;
        this._parentNode = null;
        this.ownerDocument = ownerDocument;
    }
}
class ElementNode extends BaseNode {
    get index() {
        return this._index;
    }
    set index(index) {
        this._index = index;
        this.ownerDocument.markDirty(this);
    }
    get level() {
        if (this.parentNode instanceof ElementNode) return this.parentNode.level + (this.node.type === "item" ? 1 : 0);
        return 0;
    }
    updateNode() {
        var _this_previousSibling, _this_nextSibling, _this_firstChild, _this_lastChild;
        let node = this.ownerDocument.getMutableNode(this);
        node.index = this.index;
        node.level = this.level;
        node.parentKey = this.parentNode instanceof ElementNode ? this.parentNode.node.key : null;
        var _this_previousSibling_node_key;
        node.prevKey = (_this_previousSibling_node_key = (_this_previousSibling = this.previousSibling) === null || _this_previousSibling === void 0 ? void 0 : _this_previousSibling.node.key) !== null && _this_previousSibling_node_key !== void 0 ? _this_previousSibling_node_key : null;
        var _this_nextSibling_node_key;
        node.nextKey = (_this_nextSibling_node_key = (_this_nextSibling = this.nextSibling) === null || _this_nextSibling === void 0 ? void 0 : _this_nextSibling.node.key) !== null && _this_nextSibling_node_key !== void 0 ? _this_nextSibling_node_key : null;
        node.hasChildNodes = !!this.firstChild;
        var _this_firstChild_node_key;
        node.firstChildKey = (_this_firstChild_node_key = (_this_firstChild = this.firstChild) === null || _this_firstChild === void 0 ? void 0 : _this_firstChild.node.key) !== null && _this_firstChild_node_key !== void 0 ? _this_firstChild_node_key : null;
        var _this_lastChild_node_key;
        node.lastChildKey = (_this_lastChild_node_key = (_this_lastChild = this.lastChild) === null || _this_lastChild === void 0 ? void 0 : _this_lastChild.node.key) !== null && _this_lastChild_node_key !== void 0 ? _this_lastChild_node_key : null;
    }
    setProps(obj, ref, rendered) {
        let node = this.ownerDocument.getMutableNode(this);
        let { value, textValue, id, ...props } = obj;
        props.ref = ref;
        node.props = props;
        node.rendered = rendered;
        node.value = value;
        node.textValue = textValue || (typeof rendered === "string" ? rendered : "") || obj["aria-label"] || "";
        if (id != null && id !== node.key) {
            if (this.hasSetProps) throw new Error("Cannot change the id of an item");
            node.key = id;
        }
        // If this is the first time props have been set, end the transaction started in the constructor
        // so this node can be emitted.
        if (!this.hasSetProps) {
            this.ownerDocument.addNode(this);
            this.ownerDocument.endTransaction();
            this.hasSetProps = true;
        }
        this.ownerDocument.queueUpdate();
    }
    get style() {
        return {};
    }
    hasAttribute() {}
    setAttribute() {}
    setAttributeNS() {}
    removeAttribute() {}
    constructor(type, ownerDocument){
        super(ownerDocument);
        this.nodeType = 8 // COMMENT_NODE (we'd use ELEMENT_NODE but React DevTools will fail to get its dimensions)
        ;
        this._index = 0;
        this.hasSetProps = false;
        this.node = new NodeValue(type, `react-aria-${++ownerDocument.nodeId}`);
        // Start a transaction so that no updates are emitted from the collection
        // until the props for this node are set. We don't know the real id for the
        // node until then, so we need to avoid emitting collections in an inconsistent state.
        this.ownerDocument.startTransaction();
    }
}
class BaseCollection {
    get size() {
        return this.keyMap.size;
    }
    getKeys() {
        return this.keyMap.keys();
    }
    *[Symbol.iterator]() {
        let node = this.firstKey != null ? this.keyMap.get(this.firstKey) : undefined;
        while(node){
            yield node;
            node = node.nextKey != null ? this.keyMap.get(node.nextKey) : undefined;
        }
    }
    getChildren(key) {
        let keyMap = this.keyMap;
        return {
            *[Symbol.iterator] () {
                let parent = keyMap.get(key);
                let node = (parent === null || parent === void 0 ? void 0 : parent.firstChildKey) != null ? keyMap.get(parent.firstChildKey) : null;
                while(node){
                    yield node;
                    node = node.nextKey != null ? keyMap.get(node.nextKey) : undefined;
                }
            }
        };
    }
    getKeyBefore(key) {
        let node = this.keyMap.get(key);
        if (!node) return null;
        if (node.prevKey != null) {
            node = this.keyMap.get(node.prevKey);
            while(node && node.type !== "item" && node.lastChildKey != null)node = this.keyMap.get(node.lastChildKey);
            var _node_key;
            return (_node_key = node === null || node === void 0 ? void 0 : node.key) !== null && _node_key !== void 0 ? _node_key : null;
        }
        return node.parentKey;
    }
    getKeyAfter(key) {
        let node = this.keyMap.get(key);
        if (!node) return null;
        if (node.type !== "item" && node.firstChildKey != null) return node.firstChildKey;
        while(node){
            if (node.nextKey != null) return node.nextKey;
            if (node.parentKey != null) node = this.keyMap.get(node.parentKey);
            else return null;
        }
        return null;
    }
    getFirstKey() {
        return this.firstKey;
    }
    getLastKey() {
        let node = this.lastKey != null ? this.keyMap.get(this.lastKey) : null;
        while((node === null || node === void 0 ? void 0 : node.lastChildKey) != null)node = this.keyMap.get(node.lastChildKey);
        var _node_key;
        return (_node_key = node === null || node === void 0 ? void 0 : node.key) !== null && _node_key !== void 0 ? _node_key : null;
    }
    getItem(key) {
        var _this_keyMap_get;
        return (_this_keyMap_get = this.keyMap.get(key)) !== null && _this_keyMap_get !== void 0 ? _this_keyMap_get : null;
    }
    at() {
        throw new Error("Not implemented");
    }
    clone() {
        // We need to clone using this.constructor so that subclasses have the right prototype.
        // TypeScript isn't happy about this yet.
        // https://github.com/microsoft/TypeScript/issues/3841
        let Constructor = this.constructor;
        let collection = new Constructor();
        collection.keyMap = new Map(this.keyMap);
        collection.firstKey = this.firstKey;
        collection.lastKey = this.lastKey;
        return collection;
    }
    addNode(node) {
        if (this.frozen) throw new Error("Cannot add a node to a frozen collection");
        this.keyMap.set(node.key, node);
    }
    removeNode(key) {
        if (this.frozen) throw new Error("Cannot remove a node to a frozen collection");
        this.keyMap.delete(key);
    }
    commit(firstKey, lastKey, isSSR = false) {
        if (this.frozen) throw new Error("Cannot commit a frozen collection");
        this.firstKey = firstKey;
        this.lastKey = lastKey;
        this.frozen = !isSSR;
    }
    constructor(){
        this.keyMap = new Map();
        this.firstKey = null;
        this.lastKey = null;
        this.frozen = false;
    }
}
class Document extends BaseNode {
    get isConnected() {
        return true;
    }
    createElement(type) {
        return new ElementNode(type, this);
    }
    /**
   * Lazily gets a mutable instance of a Node. If the node has already
   * been cloned during this update cycle, it just returns the existing one.
   */ getMutableNode(element) {
        let node = element.node;
        if (!this.mutatedNodes.has(element)) {
            node = element.node.clone();
            this.mutatedNodes.add(element);
            element.node = node;
        }
        this.markDirty(element);
        return node;
    }
    getMutableCollection() {
        if (!this.isSSR && !this.collectionMutated) {
            this.collection = this.collection.clone();
            this.collectionMutated = true;
        }
        return this.collection;
    }
    markDirty(node) {
        this.dirtyNodes.add(node);
    }
    startTransaction() {
        this.transactionCount++;
    }
    endTransaction() {
        this.transactionCount--;
    }
    addNode(element) {
        let collection = this.getMutableCollection();
        if (!collection.getItem(element.node.key)) {
            collection.addNode(element.node);
            for (let child of element)this.addNode(child);
        }
        this.markDirty(element);
    }
    removeNode(node) {
        for (let child of node)this.removeNode(child);
        let collection = this.getMutableCollection();
        collection.removeNode(node.node.key);
        this.markDirty(node);
    }
    /** Finalizes the collection update, updating all nodes and freezing the collection. */ getCollection() {
        if (this.transactionCount > 0) return this.collection;
        this.updateCollection();
        return this.collection;
    }
    updateCollection() {
        for (let element of this.dirtyNodes)if (element instanceof ElementNode && element.isConnected) element.updateNode();
        this.dirtyNodes.clear();
        if (this.mutatedNodes.size || this.collectionMutated) {
            var _this_firstChild, _this_lastChild;
            let collection = this.getMutableCollection();
            for (let element of this.mutatedNodes)if (element.isConnected) collection.addNode(element.node);
            var _this_firstChild_node_key, _this_lastChild_node_key;
            collection.commit((_this_firstChild_node_key = (_this_firstChild = this.firstChild) === null || _this_firstChild === void 0 ? void 0 : _this_firstChild.node.key) !== null && _this_firstChild_node_key !== void 0 ? _this_firstChild_node_key : null, (_this_lastChild_node_key = (_this_lastChild = this.lastChild) === null || _this_lastChild === void 0 ? void 0 : _this_lastChild.node.key) !== null && _this_lastChild_node_key !== void 0 ? _this_lastChild_node_key : null, this.isSSR);
            this.mutatedNodes.clear();
        }
        this.collectionMutated = false;
    }
    queueUpdate() {
        // Don't emit any updates if there is a transaction in progress.
        // queueUpdate should be called again after the transaction.
        if (this.dirtyNodes.size === 0 || this.transactionCount > 0) return;
        for (let fn of this.subscriptions)fn();
    }
    subscribe(fn) {
        this.subscriptions.add(fn);
        return ()=>this.subscriptions.delete(fn);
    }
    resetAfterSSR() {
        if (this.isSSR) {
            this.isSSR = false;
            this.firstChild = null;
            this.lastChild = null;
            this.nodeId = 0;
        }
    }
    constructor(collection){
        // @ts-ignore
        super(null);
        this.nodeType = 11 // DOCUMENT_FRAGMENT_NODE
        ;
        this.ownerDocument = this;
        this.dirtyNodes = new Set();
        this.isSSR = false;
        this.nodeId = 0;
        this.nodesByProps = new WeakMap();
        this.mutatedNodes = new Set();
        this.subscriptions = new Set();
        this.transactionCount = 0;
        this.collection = collection;
        this.collectionMutated = true;
    }
}
function useCachedChildren(props) {
    let { children, items, idScope, addIdAndValue, dependencies = [] } = props;
    // Invalidate the cache whenever the parent value changes.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    let cache = (0, _react.useMemo)(()=>new WeakMap(), dependencies);
    return (0, _react.useMemo)(()=>{
        if (items && typeof children === "function") {
            let res = [];
            for (let item of items){
                let rendered = cache.get(item);
                if (!rendered) {
                    rendered = children(item);
                    var _rendered_props_id, _ref;
                    // @ts-ignore
                    let key = (_ref = (_rendered_props_id = rendered.props.id) !== null && _rendered_props_id !== void 0 ? _rendered_props_id : item.key) !== null && _ref !== void 0 ? _ref : item.id;
                    // eslint-disable-next-line max-depth
                    if (key == null) throw new Error("Could not determine key for item");
                    // eslint-disable-next-line max-depth
                    if (idScope) key = idScope + ":" + key;
                    // Note: only works if wrapped Item passes through id...
                    rendered = /*#__PURE__*/ (0, _react.cloneElement)(rendered, addIdAndValue ? {
                        key,
                        id: key,
                        value: item
                    } : {
                        key
                    });
                    cache.set(item, rendered);
                }
                res.push(rendered);
            }
            return res;
        } else if (typeof children !== "function") return children;
    }, [
        children,
        items,
        cache,
        idScope,
        addIdAndValue
    ]);
}
function useCollectionChildren(props) {
    return useCachedChildren({
        ...props,
        addIdAndValue: true
    });
}
const ShallowRenderContext = /*#__PURE__*/ (0, _react.createContext)(false);
function useCollection(props, initialCollection) {
    let { collection, document } = useCollectionDocument(initialCollection);
    let portal = useCollectionPortal(props, document);
    return {
        portal,
        collection
    };
}
// React 16 and 17 don't support useSyncExternalStore natively, and the shim provided by React does not support getServerSnapshot.
// This wrapper uses the shim, but additionally calls getServerSnapshot during SSR (according to SSRProvider).
function useSyncExternalStoreFallback(subscribe, getSnapshot, getServerSnapshot) {
    let isSSR = (0, _reactAria.useIsSSR)();
    let isSSRRef = (0, _react.useRef)(isSSR);
    // This is read immediately inside the wrapper, which also runs during render.
    // We just need a ref to avoid invalidating the callback itself, which
    // would cause React to re-run the callback more than necessary.
    // eslint-disable-next-line rulesdir/pure-render
    isSSRRef.current = isSSR;
    let getSnapshotWrapper = (0, _react.useCallback)(()=>{
        return isSSRRef.current ? getServerSnapshot() : getSnapshot();
    }, [
        getSnapshot,
        getServerSnapshot
    ]);
    return (0, _indexJs.useSyncExternalStore)(subscribe, getSnapshotWrapper);
}
const useSyncExternalStore = typeof (0, _reactDefault.default)["useSyncExternalStore"] === "function" ? (0, _reactDefault.default)["useSyncExternalStore"] : useSyncExternalStoreFallback;
function useCollectionDocument(initialCollection) {
    // The document instance is mutable, and should never change between renders.
    // useSyncExternalStore is used to subscribe to updates, which vends immutable Collection objects.
    let document = (0, _react.useMemo)(()=>new Document(initialCollection || new BaseCollection()), [
        initialCollection
    ]);
    let subscribe = (0, _react.useCallback)((fn)=>document.subscribe(fn), [
        document
    ]);
    let getSnapshot = (0, _react.useCallback)(()=>{
        let collection = document.getCollection();
        if (document.isSSR) // After SSR is complete, reset the document to empty so it is ready for React to render the portal into.
        // We do this _after_ getting the collection above so that the collection still has content in it from SSR
        // during the current render, before React has finished the client render.
        document.resetAfterSSR();
        return collection;
    }, [
        document
    ]);
    let getServerSnapshot = (0, _react.useCallback)(()=>{
        document.isSSR = true;
        return document.getCollection();
    }, [
        document
    ]);
    let collection = useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
    return {
        collection,
        document
    };
}
const SSRContext = /*#__PURE__*/ (0, _react.createContext)(null);
const CollectionDocumentContext = /*#__PURE__*/ (0, _react.createContext)(null);
function useCollectionPortal(props, document) {
    let ctx = (0, _react.useContext)(CollectionDocumentContext);
    let doc = document !== null && document !== void 0 ? document : ctx;
    let children = useCollectionChildren(props);
    let wrappedChildren = (0, _react.useMemo)(()=>/*#__PURE__*/ (0, _reactDefault.default).createElement(ShallowRenderContext.Provider, {
            value: true
        }, children), [
        children
    ]);
    // During SSR, we render the content directly, and append nodes to the document during render.
    // The collection children return null so that nothing is actually rendered into the HTML.
    return (0, _reactAria.useIsSSR)() ? /*#__PURE__*/ (0, _reactDefault.default).createElement(SSRContext.Provider, {
        value: doc
    }, wrappedChildren) : /*#__PURE__*/ (0, _reactDom.createPortal)(wrappedChildren, doc);
}
function CollectionPortal(props) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, useCollectionPortal(props));
}
function useShallowRender(type, props, ref) {
    let isShallow = (0, _react.useContext)(ShallowRenderContext);
    var _useSSRCollectionNode;
    if (isShallow) // Elements cannot be re-parented, so the context will always be there.
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return (_useSSRCollectionNode = useSSRCollectionNode(type, props, ref, "children" in props ? props.children : null)) !== null && _useSSRCollectionNode !== void 0 ? _useSSRCollectionNode : /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null);
    return null;
}
function useCollectionItemRef(props, ref, rendered) {
    // Return a callback ref that sets the props object on the fake DOM node.
    return (0, _react.useCallback)((element)=>{
        element === null || element === void 0 ? void 0 : element.setProps(props, ref, rendered);
    }, [
        props,
        ref,
        rendered
    ]);
}
function useSSRCollectionNode(Type, props, ref, rendered, children) {
    // During SSR, portals are not supported, so the collection children will be wrapped in an SSRContext.
    // Since SSR occurs only once, we assume that the elements are rendered in order and never re-render.
    // Therefore we can create elements in our collection document during render so that they are in the
    // collection by the time we need to use the collection to render to the real DOM.
    // After hydration, we switch to client rendering using the portal.
    let itemRef = useCollectionItemRef(props, ref, rendered);
    let parentNode = (0, _react.useContext)(SSRContext);
    if (parentNode) {
        // Guard against double rendering in strict mode.
        let element = parentNode.ownerDocument.nodesByProps.get(props);
        if (!element) {
            element = parentNode.ownerDocument.createElement(Type);
            element.setProps(props, ref, rendered);
            parentNode.appendChild(element);
            parentNode.ownerDocument.updateCollection();
            parentNode.ownerDocument.nodesByProps.set(props, element);
        }
        return children ? /*#__PURE__*/ (0, _reactDefault.default).createElement(SSRContext.Provider, {
            value: element
        }, children) : null;
    }
    // @ts-ignore
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Type, {
        ref: itemRef
    }, children);
}
function Section(props, ref) {
    let children = useCollectionChildren(props);
    return useSSRCollectionNode("section", props, ref, null, children);
}
const _Section = /*#__PURE__*/ (0, _react.forwardRef)(Section);
const CollectionContext = /*#__PURE__*/ (0, _react.createContext)(null);
const CollectionRendererContext = /*#__PURE__*/ (0, _react.createContext)(null);
function Collection(props) {
    let ctx = (0, _react.useContext)(CollectionContext);
    props = (0, _reactAria.mergeProps)(ctx, props);
    props.dependencies = ((ctx === null || ctx === void 0 ? void 0 : ctx.dependencies) || []).concat(props.dependencies);
    let renderer = typeof props.children === "function" ? props.children : null;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(CollectionRendererContext.Provider, {
        value: renderer
    }, useCollectionChildren(props));
}

},{"react-dom":"cEvV3","react-aria":"e7jhe","react":"9yzVZ","use-sync-external-store/shim/index.js":"41GFF","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"41GFF":[function(require,module,exports) {
"use strict";
module.exports = require("8b974a2950a0796c");

},{"8b974a2950a0796c":"icaQY"}],"icaQY":[function(require,module,exports) {
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var e = require("2f7d03d9688f598f");
function h(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var k = "function" === typeof Object.is ? Object.is : h, l = e.useState, m = e.useEffect, n = e.useLayoutEffect, p = e.useDebugValue;
function q(a, b) {
    var d = b(), f = l({
        inst: {
            value: d,
            getSnapshot: b
        }
    }), c = f[0].inst, g = f[1];
    n(function() {
        c.value = d;
        c.getSnapshot = b;
        r(c) && g({
            inst: c
        });
    }, [
        a,
        d,
        b
    ]);
    m(function() {
        r(c) && g({
            inst: c
        });
        return a(function() {
            r(c) && g({
                inst: c
            });
        });
    }, [
        a
    ]);
    p(d);
    return d;
}
function r(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var d = b();
        return !k(a, d);
    } catch (f) {
        return !0;
    }
}
function t(a, b) {
    return b();
}
var u = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? t : q;
exports.useSyncExternalStore = void 0 !== e.useSyncExternalStore ? e.useSyncExternalStore : u;

},{"2f7d03d9688f598f":"9yzVZ"}],"71duS":[function(require,module,exports) {
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GroupContext", ()=>GroupContext);
parcelHelpers.export(exports, "Group", ()=>_Group);
var _utils = require("./utils");
var _reactAria = require("react-aria");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const GroupContext = /*#__PURE__*/ (0, _react.createContext)({});
function Group(props, ref) {
    [props, ref] = (0, _utils.useContextProps)(props, ref, GroupContext);
    let { isDisabled, isInvalid, onHoverStart, onHoverChange, onHoverEnd, ...otherProps } = props;
    let { hoverProps, isHovered } = (0, _reactAria.useHover)({
        onHoverStart,
        onHoverChange,
        onHoverEnd,
        isDisabled
    });
    let { isFocused, isFocusVisible, focusProps } = (0, _reactAria.useFocusRing)({
        within: true
    });
    isDisabled !== null && isDisabled !== void 0 ? isDisabled : isDisabled = !!props["aria-disabled"] && props["aria-disabled"] !== "false";
    isInvalid !== null && isInvalid !== void 0 ? isInvalid : isInvalid = !!props["aria-invalid"] && props["aria-invalid"] !== "false";
    let renderProps = (0, _utils.useRenderProps)({
        ...props,
        values: {
            isHovered,
            isFocusWithin: isFocused,
            isFocusVisible,
            isDisabled,
            isInvalid
        },
        defaultClassName: "react-aria-Group"
    });
    var _props_role, _props_slot;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...(0, _reactAria.mergeProps)(otherProps, focusProps, hoverProps),
        ...renderProps,
        ref: ref,
        role: (_props_role = props.role) !== null && _props_role !== void 0 ? _props_role : "group",
        slot: (_props_slot = props.slot) !== null && _props_slot !== void 0 ? _props_slot : undefined,
        "data-focus-within": isFocused || undefined,
        "data-hovered": isHovered || undefined,
        "data-focus-visible": isFocusVisible || undefined,
        "data-disabled": isDisabled || undefined,
        "data-invalid": isInvalid || undefined
    }, renderProps.children);
}
/**
 * A group represents a set of related UI controls, and supports interactive states for styling.
 */ const _Group = /*#__PURE__*/ (0, _react.forwardRef)(Group);

},{"./utils":"iyTLn","react-aria":"e7jhe","react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"3u8zn":[function(require,module,exports) {
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InputContext", ()=>InputContext);
parcelHelpers.export(exports, "Input", ()=>_Input);
var _utils = require("./utils");
var _reactAria = require("react-aria");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const InputContext = /*#__PURE__*/ (0, _react.createContext)({});
let filterHoverProps = (props)=>{
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    let { onHoverStart, onHoverChange, onHoverEnd, ...otherProps } = props;
    return otherProps;
};
function Input(props, ref) {
    [props, ref] = (0, _utils.useContextProps)(props, ref, InputContext);
    let { hoverProps, isHovered } = (0, _reactAria.useHover)(props);
    let { isFocused, isFocusVisible, focusProps } = (0, _reactAria.useFocusRing)({
        isTextInput: true,
        autoFocus: props.autoFocus
    });
    let isInvalid = !!props["aria-invalid"] && props["aria-invalid"] !== "false";
    let renderProps = (0, _utils.useRenderProps)({
        ...props,
        values: {
            isHovered,
            isFocused,
            isFocusVisible,
            isDisabled: props.disabled || false,
            isInvalid
        },
        defaultClassName: "react-aria-Input"
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("input", {
        ...(0, _reactAria.mergeProps)(filterHoverProps(props), focusProps, hoverProps),
        ...renderProps,
        ref: ref,
        "data-focused": isFocused || undefined,
        "data-disabled": props.disabled || undefined,
        "data-hovered": isHovered || undefined,
        "data-focus-visible": isFocusVisible || undefined,
        "data-invalid": isInvalid || undefined
    });
}
/**
 * An input allows a user to input text.
 */ const _Input = /*#__PURE__*/ (0, _utils.createHideableComponent)(Input);

},{"./utils":"iyTLn","react-aria":"e7jhe","react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"katmG":[function(require,module,exports) {
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ListBoxContext", ()=>ListBoxContext);
parcelHelpers.export(exports, "ListStateContext", ()=>ListStateContext);
parcelHelpers.export(exports, "ListBox", ()=>_ListBox);
parcelHelpers.export(exports, "ListBoxItem", ()=>_ListBoxItem);
var _reactAria = require("react-aria");
var _collection = require("./Collection");
var _utils = require("./utils");
var _useDragAndDrop = require("./useDragAndDrop");
var _reactStately = require("react-stately");
var _utils1 = require("@react-aria/utils");
var _header = require("./Header");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _separator = require("./Separator");
var _text = require("./Text");
const ListBoxContext = /*#__PURE__*/ (0, _react.createContext)(null);
const ListStateContext = /*#__PURE__*/ (0, _react.createContext)(null);
function ListBox(props, ref) {
    [props, ref] = (0, _utils.useContextProps)(props, ref, ListBoxContext);
    let isHidden = (0, _react.useContext)((0, _utils.HiddenContext));
    let state = (0, _react.useContext)(ListStateContext);
    let document = (0, _react.useContext)((0, _collection.CollectionDocumentContext));
    // The structure of ListBox is a bit strange because it needs to work inside other components like ComboBox and Select.
    // Those components render two copies of their children so that the collection can be built even when the popover is closed.
    // The first copy sends a collection document via context which we render the collection portal into.
    // The second copy sends a ListState object via context which we use to render the ListBox without rebuilding the state.
    // Otherwise, we have a standalone ListBox, so we need to create a collection and state ourselves.
    if (document) return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _collection.CollectionPortal), props);
    if (state) return isHidden ? null : /*#__PURE__*/ (0, _reactDefault.default).createElement(ListBoxInner, {
        state: state,
        props: props,
        listBoxRef: ref
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(StandaloneListBox, {
        props: props,
        listBoxRef: ref
    });
}
function StandaloneListBox({ props, listBoxRef }) {
    let { portal, collection } = (0, _collection.useCollection)(props);
    props = {
        ...props,
        collection,
        children: null,
        items: null
    };
    let state = (0, _reactStately.useListState)(props);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, portal, /*#__PURE__*/ (0, _reactDefault.default).createElement(ListBoxInner, {
        state: state,
        props: props,
        listBoxRef: listBoxRef
    }));
}
/**
 * A listbox displays a list of options and allows a user to select one or more of them.
 */ const _ListBox = /*#__PURE__*/ (0, _react.forwardRef)(ListBox);
function ListBoxInner({ state, props, listBoxRef }) {
    let { dragAndDropHooks, layout = "stack", orientation = "vertical" } = props;
    let { collection, selectionManager } = state;
    let isListDraggable = !!(dragAndDropHooks === null || dragAndDropHooks === void 0 ? void 0 : dragAndDropHooks.useDraggableCollectionState);
    let isListDroppable = !!(dragAndDropHooks === null || dragAndDropHooks === void 0 ? void 0 : dragAndDropHooks.useDroppableCollectionState);
    let { direction } = (0, _reactAria.useLocale)();
    let { disabledBehavior, disabledKeys } = selectionManager;
    let collator = (0, _reactAria.useCollator)({
        usage: "search",
        sensitivity: "base"
    });
    let keyboardDelegate = (0, _react.useMemo)(()=>props.keyboardDelegate || new (0, _reactAria.ListKeyboardDelegate)({
            collection,
            collator,
            ref: listBoxRef,
            disabledKeys: disabledBehavior === "selection" ? new Set() : disabledKeys,
            layout,
            orientation,
            direction
        }), [
        collection,
        collator,
        listBoxRef,
        disabledBehavior,
        disabledKeys,
        orientation,
        direction,
        props.keyboardDelegate,
        layout
    ]);
    let { listBoxProps } = (0, _reactAria.useListBox)({
        ...props,
        shouldSelectOnPressUp: isListDraggable || props.shouldSelectOnPressUp,
        keyboardDelegate
    }, state, listBoxRef);
    let children = (0, _collection.useCachedChildren)({
        items: collection,
        children: (item)=>{
            switch(item.type){
                case "section":
                    return /*#__PURE__*/ (0, _reactDefault.default).createElement(ListBoxSection, {
                        section: item
                    });
                case "separator":
                    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _separator.Separator), item.props);
                case "item":
                    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Option, {
                        item: item
                    });
                default:
                    throw new Error("Unsupported node type in Menu: " + item.type);
            }
        }
    });
    let dragHooksProvided = (0, _react.useRef)(isListDraggable);
    let dropHooksProvided = (0, _react.useRef)(isListDroppable);
    (0, _react.useEffect)(()=>{
        if (dragHooksProvided.current !== isListDraggable) console.warn("Drag hooks were provided during one render, but not another. This should be avoided as it may produce unexpected behavior.");
        if (dropHooksProvided.current !== isListDroppable) console.warn("Drop hooks were provided during one render, but not another. This should be avoided as it may produce unexpected behavior.");
    }, [
        isListDraggable,
        isListDroppable
    ]);
    let dragState = undefined;
    let dropState = undefined;
    let droppableCollection = undefined;
    let isRootDropTarget = false;
    let dragPreview = null;
    let preview = (0, _react.useRef)(null);
    if (isListDraggable && dragAndDropHooks) {
        dragState = dragAndDropHooks.useDraggableCollectionState({
            collection,
            selectionManager,
            preview: dragAndDropHooks.renderDragPreview ? preview : undefined
        });
        dragAndDropHooks.useDraggableCollection({}, dragState, listBoxRef);
        let DragPreview = dragAndDropHooks.DragPreview;
        dragPreview = dragAndDropHooks.renderDragPreview ? /*#__PURE__*/ (0, _reactDefault.default).createElement(DragPreview, {
            ref: preview
        }, dragAndDropHooks.renderDragPreview) : null;
    }
    if (isListDroppable && dragAndDropHooks) {
        dropState = dragAndDropHooks.useDroppableCollectionState({
            collection,
            selectionManager
        });
        let dropTargetDelegate = dragAndDropHooks.dropTargetDelegate || new dragAndDropHooks.ListDropTargetDelegate(collection, listBoxRef, {
            orientation,
            layout,
            direction
        });
        droppableCollection = dragAndDropHooks.useDroppableCollection({
            keyboardDelegate,
            dropTargetDelegate
        }, dropState, listBoxRef);
        isRootDropTarget = dropState.isDropTarget({
            type: "root"
        });
    }
    let { focusProps, isFocused, isFocusVisible } = (0, _reactAria.useFocusRing)();
    let renderValues = {
        isDropTarget: isRootDropTarget,
        isEmpty: state.collection.size === 0,
        isFocused,
        isFocusVisible,
        layout: props.layout || "stack",
        state
    };
    let renderProps = (0, _utils.useRenderProps)({
        className: props.className,
        style: props.style,
        defaultClassName: "react-aria-ListBox",
        values: renderValues
    });
    let emptyState = null;
    if (state.collection.size === 0 && props.renderEmptyState) emptyState = /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        // eslint-disable-next-line
        role: "option",
        style: {
            display: "contents"
        }
    }, props.renderEmptyState(renderValues));
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAria.FocusScope), null, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...(0, _utils1.filterDOMProps)(props),
        ...(0, _reactAria.mergeProps)(listBoxProps, focusProps, droppableCollection === null || droppableCollection === void 0 ? void 0 : droppableCollection.collectionProps),
        ...renderProps,
        ref: listBoxRef,
        slot: props.slot || undefined,
        onScroll: props.onScroll,
        "data-drop-target": isRootDropTarget || undefined,
        "data-empty": state.collection.size === 0 || undefined,
        "data-focused": isFocused || undefined,
        "data-focus-visible": isFocusVisible || undefined,
        "data-layout": props.layout || "stack",
        "data-orientation": props.orientation || "vertical"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.Provider), {
        values: [
            [
                ListBoxContext,
                props
            ],
            [
                ListStateContext,
                state
            ],
            [
                (0, _useDragAndDrop.DragAndDropContext),
                {
                    dragAndDropHooks,
                    dragState,
                    dropState
                }
            ],
            [
                (0, _separator.SeparatorContext),
                {
                    elementType: "div"
                }
            ],
            [
                (0, _useDragAndDrop.DropIndicatorContext),
                {
                    render: ListBoxDropIndicatorWrapper
                }
            ]
        ]
    }, children), emptyState, dragPreview));
}
function ListBoxSection({ section, className, style }) {
    var _section_props, _section_props1;
    let state = (0, _react.useContext)(ListStateContext);
    let [headingRef, heading] = (0, _utils.useSlot)();
    var _section_props_arialabel;
    let { headingProps, groupProps } = (0, _reactAria.useListBoxSection)({
        heading,
        "aria-label": (_section_props_arialabel = section.props["aria-label"]) !== null && _section_props_arialabel !== void 0 ? _section_props_arialabel : undefined
    });
    let children = (0, _collection.useCachedChildren)({
        items: state.collection.getChildren(section.key),
        children: (item)=>{
            switch(item.type){
                case "header":
                    return /*#__PURE__*/ (0, _reactDefault.default).createElement(SectionHeader, {
                        item: item,
                        headingProps: headingProps,
                        headingRef: headingRef
                    });
                case "item":
                    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Option, {
                        item: item
                    });
                default:
                    throw new Error("Unsupported element type in Section: " + item.type);
            }
        }
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("section", {
        ...(0, _utils1.filterDOMProps)(section.props),
        ...groupProps,
        className: className || ((_section_props = section.props) === null || _section_props === void 0 ? void 0 : _section_props.className) || "react-aria-Section",
        style: style || ((_section_props1 = section.props) === null || _section_props1 === void 0 ? void 0 : _section_props1.style),
        ref: section.props.ref
    }, children);
}
// This is a separate component so that headingProps.id doesn't override the item key in useCachedChildren.
function SectionHeader({ item, headingProps, headingRef }) {
    let { ref, ...otherProps } = item.props;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _header.Header), {
        ...headingProps,
        ...otherProps,
        ref: (0, _utils1.mergeRefs)(headingRef, ref)
    }, item.rendered);
}
function ListBoxItem(props, ref) {
    return (0, _collection.useSSRCollectionNode)("item", props, ref, props.children);
}
/**
 * A ListBoxItem represents an individual option in a ListBox.
 */ const _ListBoxItem = /*#__PURE__*/ (0, _react.forwardRef)(ListBoxItem);
function Option({ item }) {
    var _item_props;
    let ref = (0, _utils1.useObjectRef)(item.props.ref);
    let state = (0, _react.useContext)(ListStateContext);
    let { dragAndDropHooks, dragState, dropState } = (0, _react.useContext)((0, _useDragAndDrop.DragAndDropContext));
    let { optionProps, labelProps, descriptionProps, ...states } = (0, _reactAria.useOption)({
        key: item.key,
        "aria-label": (_item_props = item.props) === null || _item_props === void 0 ? void 0 : _item_props["aria-label"]
    }, state, ref);
    let { hoverProps, isHovered } = (0, _reactAria.useHover)({
        isDisabled: !states.allowsSelection && !states.hasAction
    });
    let draggableItem = null;
    if (dragState && dragAndDropHooks) draggableItem = dragAndDropHooks.useDraggableItem({
        key: item.key
    }, dragState);
    let droppableItem = null;
    if (dropState && dragAndDropHooks) droppableItem = dragAndDropHooks.useDroppableItem({
        target: {
            type: "item",
            key: item.key,
            dropPosition: "on"
        }
    }, dropState, ref);
    let props = item.props;
    let isDragging = dragState && dragState.isDragging(item.key);
    let renderProps = (0, _utils.useRenderProps)({
        ...props,
        id: undefined,
        children: item.rendered,
        defaultClassName: "react-aria-ListBoxItem",
        values: {
            ...states,
            isHovered,
            selectionMode: state.selectionManager.selectionMode,
            selectionBehavior: state.selectionManager.selectionBehavior,
            allowsDragging: !!dragState,
            isDragging,
            isDropTarget: droppableItem === null || droppableItem === void 0 ? void 0 : droppableItem.isDropTarget
        }
    });
    let renderDropIndicator = (dragAndDropHooks === null || dragAndDropHooks === void 0 ? void 0 : dragAndDropHooks.renderDropIndicator) || ((target)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _useDragAndDrop.DropIndicator), {
            target: target
        }));
    (0, _react.useEffect)(()=>{
        if (!item.textValue) console.warn("A `textValue` prop is required for <ListBoxItem> elements with non-plain text children in order to support accessibility features such as type to select.");
    }, [
        item.textValue
    ]);
    let ElementType = props.href ? "a" : "div";
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (dragAndDropHooks === null || dragAndDropHooks === void 0 ? void 0 : dragAndDropHooks.useDropIndicator) && renderDropIndicator({
        type: "item",
        key: item.key,
        dropPosition: "before"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement(ElementType, {
        ...(0, _reactAria.mergeProps)(optionProps, hoverProps, draggableItem === null || draggableItem === void 0 ? void 0 : draggableItem.dragProps, droppableItem === null || droppableItem === void 0 ? void 0 : droppableItem.dropProps),
        ...renderProps,
        ref: ref,
        "data-allows-dragging": !!dragState || undefined,
        "data-selected": states.isSelected || undefined,
        "data-disabled": states.isDisabled || undefined,
        "data-hovered": isHovered || undefined,
        "data-focused": states.isFocused || undefined,
        "data-focus-visible": states.isFocusVisible || undefined,
        "data-pressed": states.isPressed || undefined,
        "data-dragging": isDragging || undefined,
        "data-drop-target": (droppableItem === null || droppableItem === void 0 ? void 0 : droppableItem.isDropTarget) || undefined,
        "data-selection-mode": state.selectionManager.selectionMode === "none" ? undefined : state.selectionManager.selectionMode
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.Provider), {
        values: [
            [
                (0, _text.TextContext),
                {
                    slots: {
                        label: labelProps,
                        description: descriptionProps
                    }
                }
            ]
        ]
    }, renderProps.children)), (dragAndDropHooks === null || dragAndDropHooks === void 0 ? void 0 : dragAndDropHooks.useDropIndicator) && state.collection.getKeyAfter(item.key) == null && renderDropIndicator({
        type: "item",
        key: item.key,
        dropPosition: "after"
    }));
}
function ListBoxDropIndicatorWrapper(props, ref) {
    ref = (0, _utils1.useObjectRef)(ref);
    let { dragAndDropHooks, dropState } = (0, _react.useContext)((0, _useDragAndDrop.DragAndDropContext));
    let { dropIndicatorProps, isHidden, isDropTarget } = dragAndDropHooks.useDropIndicator(props, dropState, ref);
    if (isHidden) return null;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(ListBoxtDropIndicatorForwardRef, {
        ...props,
        dropIndicatorProps: dropIndicatorProps,
        isDropTarget: isDropTarget,
        ref: ref
    });
}
function ListBoxtDropIndicator(props, ref) {
    let { dropIndicatorProps, isDropTarget, ...otherProps } = props;
    let renderProps = (0, _utils.useRenderProps)({
        ...otherProps,
        defaultClassName: "react-aria-DropIndicator",
        values: {
            isDropTarget
        }
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...dropIndicatorProps,
        ...renderProps,
        // eslint-disable-next-line
        role: "option",
        ref: ref,
        "data-drop-target": isDropTarget || undefined
    });
}
const ListBoxtDropIndicatorForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(ListBoxtDropIndicator);

},{"react-aria":"e7jhe","./Collection":"lJDFi","./utils":"iyTLn","./useDragAndDrop":"fPav3","react-stately":"ij62t","@react-aria/utils":"9cLk5","./Header":"4dFe5","react":"9yzVZ","./Separator":"fNEee","./Text":"iZUDL","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"fPav3":[function(require,module,exports) {
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides the hooks required to enable drag and drop behavior for a drag and drop compatible collection component.
 */ parcelHelpers.export(exports, "useDragAndDrop", ()=>useDragAndDrop);
parcelHelpers.export(exports, "DropIndicatorContext", ()=>DropIndicatorContext);
parcelHelpers.export(exports, "DropIndicator", ()=>_DropIndicator);
parcelHelpers.export(exports, "DragAndDropContext", ()=>DragAndDropContext);
var _reactAria = require("react-aria");
var _reactStately = require("react-stately");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
function useDragAndDrop(options) {
    let dragAndDropHooks = (0, _react.useMemo)(()=>{
        let { onDrop, onInsert, onItemDrop, onReorder, onRootDrop, getItems, renderDragPreview, renderDropIndicator, dropTargetDelegate } = options;
        let isDraggable = !!getItems;
        let isDroppable = !!(onDrop || onInsert || onItemDrop || onReorder || onRootDrop);
        let hooks = {};
        if (isDraggable) {
            hooks.useDraggableCollectionState = function useDraggableCollectionStateOverride(props) {
                return (0, _reactStately.useDraggableCollectionState)({
                    ...props,
                    ...options
                });
            };
            hooks.useDraggableCollection = (0, _reactAria.useDraggableCollection);
            hooks.useDraggableItem = (0, _reactAria.useDraggableItem);
            hooks.DragPreview = (0, _reactAria.DragPreview);
            hooks.renderDragPreview = renderDragPreview;
        }
        if (isDroppable) {
            hooks.useDroppableCollectionState = function useDroppableCollectionStateOverride(props) {
                return (0, _reactStately.useDroppableCollectionState)({
                    ...props,
                    ...options
                });
            };
            hooks.useDroppableItem = (0, _reactAria.useDroppableItem);
            hooks.useDroppableCollection = function useDroppableCollectionOverride(props, state, ref) {
                return (0, _reactAria.useDroppableCollection)({
                    ...props,
                    ...options
                }, state, ref);
            };
            hooks.useDropIndicator = (0, _reactAria.useDropIndicator);
            hooks.renderDropIndicator = renderDropIndicator;
            hooks.dropTargetDelegate = dropTargetDelegate;
            hooks.ListDropTargetDelegate = (0, _reactAria.ListDropTargetDelegate);
        }
        return hooks;
    }, [
        options
    ]);
    return {
        dragAndDropHooks
    };
}
const DropIndicatorContext = /*#__PURE__*/ (0, _react.createContext)(null);
function DropIndicator(props, ref) {
    let { render } = (0, _react.useContext)(DropIndicatorContext);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, render(props, ref));
}
/**
 * A DropIndicator is rendered between items in a collection to indicate where dropped data will be inserted.
 */ const _DropIndicator = /*#__PURE__*/ (0, _react.forwardRef)(DropIndicator);
const DragAndDropContext = /*#__PURE__*/ (0, _react.createContext)({});

},{"react-aria":"e7jhe","react-stately":"ij62t","react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"4dFe5":[function(require,module,exports) {
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HeaderContext", ()=>HeaderContext);
parcelHelpers.export(exports, "Header", ()=>_Header);
var _utils = require("./utils");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _collection = require("./Collection");
const HeaderContext = /*#__PURE__*/ (0, _react.createContext)({});
function Header(originalProps, originalRef) {
    let [props, ref] = (0, _utils.useContextProps)(originalProps, originalRef, HeaderContext);
    let shallow = (0, _collection.useShallowRender)("header", originalProps, originalRef);
    if (shallow) return shallow;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("header", {
        className: "react-aria-Header",
        ...props,
        ref: ref
    }, props.children);
}
const _Header = /*#__PURE__*/ (0, _react.forwardRef)(Header);

},{"./utils":"iyTLn","react":"9yzVZ","./Collection":"lJDFi","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"fNEee":[function(require,module,exports) {
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SeparatorContext", ()=>SeparatorContext);
parcelHelpers.export(exports, "Separator", ()=>_Separator);
var _reactAria = require("react-aria");
var _utils = require("./utils");
var _utils1 = require("@react-aria/utils");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _collection = require("./Collection");
const SeparatorContext = /*#__PURE__*/ (0, _react.createContext)({});
function Separator(originalProps, originalRef) {
    let [props, ref] = (0, _utils.useContextProps)(originalProps, originalRef, SeparatorContext);
    let { elementType, orientation, style, className } = props;
    let Element = elementType || "hr";
    if (Element === "hr" && orientation === "vertical") Element = "div";
    let { separatorProps } = (0, _reactAria.useSeparator)({
        elementType,
        orientation
    });
    let shallow = (0, _collection.useShallowRender)("separator", originalProps, originalRef);
    if (shallow) return shallow;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Element, {
        ...(0, _utils1.filterDOMProps)(props),
        ...separatorProps,
        style: style,
        className: className !== null && className !== void 0 ? className : "react-aria-Separator",
        ref: ref,
        slot: props.slot || undefined
    });
}
const _Separator = /*#__PURE__*/ (0, _react.forwardRef)(Separator);

},{"react-aria":"e7jhe","./utils":"iyTLn","@react-aria/utils":"9cLk5","react":"9yzVZ","./Collection":"lJDFi","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"7F4Zw":[function(require,module,exports) {
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DialogContext", ()=>DialogContext);
parcelHelpers.export(exports, "OverlayTriggerStateContext", ()=>OverlayTriggerStateContext);
/**
 * A DialogTrigger opens a dialog when a trigger element is pressed.
 */ parcelHelpers.export(exports, "DialogTrigger", ()=>DialogTrigger);
parcelHelpers.export(exports, "Dialog", ()=>_Dialog);
var _reactAria = require("react-aria");
var _utils = require("./utils");
var _utils1 = require("@react-aria/utils");
var _heading = require("./Heading");
var _reactStately = require("react-stately");
var _popover = require("./Popover");
var _interactions = require("@react-aria/interactions");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const DialogContext = /*#__PURE__*/ (0, _react.createContext)(null);
const OverlayTriggerStateContext = /*#__PURE__*/ (0, _react.createContext)(null);
function DialogTrigger(props) {
    let state = (0, _reactStately.useOverlayTriggerState)(props);
    let buttonRef = (0, _react.useRef)(null);
    let { triggerProps, overlayProps } = (0, _reactAria.useOverlayTrigger)({
        type: "dialog"
    }, state, buttonRef);
    // Label dialog by the trigger as a fallback if there is no title slot.
    // This is done in RAC instead of hooks because otherwise we cannot distinguish
    // between context and props. Normally aria-labelledby overrides the title
    // but when sent by context we want the title to win.
    triggerProps.id = (0, _reactAria.useId)();
    overlayProps["aria-labelledby"] = triggerProps.id;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.Provider), {
        values: [
            [
                OverlayTriggerStateContext,
                state
            ],
            [
                DialogContext,
                overlayProps
            ],
            [
                (0, _popover.PopoverContext),
                {
                    trigger: "DialogTrigger",
                    triggerRef: buttonRef
                }
            ]
        ]
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _interactions.PressResponder), {
        ...triggerProps,
        ref: buttonRef,
        isPressed: state.isOpen
    }, props.children));
}
function Dialog(props, ref) {
    let originalAriaLabelledby = props["aria-labelledby"];
    [props, ref] = (0, _utils.useContextProps)(props, ref, DialogContext);
    let { dialogProps, titleProps } = (0, _reactAria.useDialog)({
        ...props,
        // Only pass aria-labelledby from props, not context.
        // Context is used as a fallback below.
        "aria-labelledby": originalAriaLabelledby
    }, ref);
    let state = (0, _react.useContext)(OverlayTriggerStateContext);
    let children = props.children;
    if (typeof children === "function") children = children({
        close: (state === null || state === void 0 ? void 0 : state.close) || (()=>{})
    });
    if (!dialogProps["aria-label"] && !dialogProps["aria-labelledby"]) {
        // If aria-labelledby exists on props, we know it came from context.
        // Use that as a fallback in case there is no title slot.
        if (props["aria-labelledby"]) dialogProps["aria-labelledby"] = props["aria-labelledby"];
        else console.warn('If a Dialog does not contain a <Heading slot="title">, it must have an aria-label or aria-labelledby attribute for accessibility.');
    }
    var _props_className;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("section", {
        ...(0, _utils1.filterDOMProps)(props),
        ...dialogProps,
        ref: ref,
        slot: props.slot || undefined,
        style: props.style,
        className: (_props_className = props.className) !== null && _props_className !== void 0 ? _props_className : "react-aria-Dialog"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.Provider), {
        values: [
            [
                (0, _heading.HeadingContext),
                {
                    slots: {
                        [(0, _utils.DEFAULT_SLOT)]: {},
                        title: {
                            ...titleProps,
                            level: 2
                        }
                    }
                }
            ]
        ]
    }, children));
}
/**
 * A dialog is an overlay shown above other content in an application.
 */ const _Dialog = /*#__PURE__*/ (0, _react.forwardRef)(Dialog);

},{"react-aria":"e7jhe","./utils":"iyTLn","@react-aria/utils":"9cLk5","./Heading":"gl7db","react-stately":"ij62t","./Popover":"Gl2h9","@react-aria/interactions":"ky3G8","react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"Gl2h9":[function(require,module,exports) {
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PopoverContext", ()=>PopoverContext);
parcelHelpers.export(exports, "Popover", ()=>_Popover);
var _reactAria = require("react-aria");
var _utils = require("./utils");
var _utils1 = require("@react-aria/utils");
var _overlayArrow = require("./OverlayArrow");
var _reactStately = require("react-stately");
var _dialog = require("./Dialog");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const PopoverContext = /*#__PURE__*/ (0, _react.createContext)(null);
function Popover(props, ref) {
    [props, ref] = (0, _utils.useContextProps)(props, ref, PopoverContext);
    let contextState = (0, _react.useContext)((0, _dialog.OverlayTriggerStateContext));
    let localState = (0, _reactStately.useOverlayTriggerState)(props);
    let state = props.isOpen != null || props.defaultOpen != null || !contextState ? localState : contextState;
    let isExiting = (0, _utils.useExitAnimation)(ref, state.isOpen) || props.isExiting || false;
    let isHidden = (0, _react.useContext)((0, _utils.HiddenContext));
    // If we are in a hidden tree, we still need to preserve our children.
    if (isHidden) {
        let children = props.children;
        if (typeof children === "function") children = children({
            trigger: props.trigger || null,
            placement: "bottom",
            isEntering: false,
            isExiting: false
        });
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, children);
    }
    if (state && !state.isOpen && !isExiting) return null;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(PopoverInner, {
        ...props,
        triggerRef: props.triggerRef,
        state: state,
        popoverRef: ref,
        isExiting: isExiting
    });
}
/**
 * A popover is an overlay element positioned relative to a trigger.
 */ const _Popover = /*#__PURE__*/ (0, _react.forwardRef)(Popover);
function PopoverInner({ state, isExiting, UNSTABLE_portalContainer, ...props }) {
    var _props_offset;
    let { popoverProps, underlayProps, arrowProps, placement } = (0, _reactAria.usePopover)({
        ...props,
        offset: (_props_offset = props.offset) !== null && _props_offset !== void 0 ? _props_offset : 8
    }, state);
    let ref = props.popoverRef;
    let isEntering = (0, _utils.useEnterAnimation)(ref, !!placement) || props.isEntering || false;
    let renderProps = (0, _utils.useRenderProps)({
        ...props,
        defaultClassName: "react-aria-Popover",
        values: {
            trigger: props.trigger || null,
            placement,
            isEntering,
            isExiting
        }
    });
    let style = {
        ...popoverProps.style,
        ...renderProps.style
    };
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAria.Overlay), {
        isExiting: isExiting,
        portalContainer: UNSTABLE_portalContainer
    }, !props.isNonModal && state.isOpen && /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        "data-testid": "underlay",
        ...underlayProps,
        style: {
            position: "fixed",
            inset: 0
        }
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...(0, _utils1.mergeProps)((0, _utils1.filterDOMProps)(props), popoverProps),
        ...renderProps,
        ref: ref,
        slot: props.slot || undefined,
        style: style,
        "data-trigger": props.trigger,
        "data-placement": placement,
        "data-entering": isEntering || undefined,
        "data-exiting": isExiting || undefined
    }, !props.isNonModal && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAria.DismissButton), {
        onDismiss: state.close
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _overlayArrow.OverlayArrowContext).Provider, {
        value: {
            ...arrowProps,
            placement
        }
    }, renderProps.children), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAria.DismissButton), {
        onDismiss: state.close
    })));
}

},{"react-aria":"e7jhe","./utils":"iyTLn","@react-aria/utils":"9cLk5","./OverlayArrow":"g8XVt","react-stately":"ij62t","./Dialog":"7F4Zw","react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"g8XVt":[function(require,module,exports) {
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "OverlayArrowContext", ()=>OverlayArrowContext);
parcelHelpers.export(exports, "OverlayArrow", ()=>_OverlayArrow);
var _utils = require("./utils");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const OverlayArrowContext = /*#__PURE__*/ (0, _react.createContext)({
    placement: "bottom"
});
function OverlayArrow(props, ref) {
    [props, ref] = (0, _utils.useContextProps)(props, ref, OverlayArrowContext);
    let placement = props.placement;
    let style = {
        position: "absolute",
        [placement]: "100%",
        transform: placement === "top" || placement === "bottom" ? "translateX(-50%)" : "translateY(-50%)"
    };
    let renderProps = (0, _utils.useRenderProps)({
        ...props,
        defaultClassName: "react-aria-OverlayArrow",
        values: {
            placement
        }
    });
    // remove undefined values from renderProps.style object so that it can be
    // spread merged with the other style object
    if (renderProps.style) Object.keys(renderProps.style).forEach((key)=>renderProps.style[key] === undefined && delete renderProps.style[key]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...props,
        ...renderProps,
        style: {
            ...style,
            ...renderProps.style
        },
        ref: ref,
        "data-placement": placement
    });
}
/**
 * An OverlayArrow renders a custom arrow element relative to an overlay element
 * such as a popover or tooltip such that it aligns with a trigger element.
 */ const _OverlayArrow = /*#__PURE__*/ (0, _react.forwardRef)(OverlayArrow);

},{"./utils":"iyTLn","react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"7GuOQ":[function(require,module,exports) {
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DateFieldContext", ()=>DateFieldContext);
parcelHelpers.export(exports, "TimeFieldContext", ()=>TimeFieldContext);
parcelHelpers.export(exports, "DateFieldStateContext", ()=>DateFieldStateContext);
parcelHelpers.export(exports, "TimeFieldStateContext", ()=>TimeFieldStateContext);
parcelHelpers.export(exports, "DateField", ()=>_DateField);
parcelHelpers.export(exports, "TimeField", ()=>_TimeField);
parcelHelpers.export(exports, "DateInput", ()=>_DateInput);
parcelHelpers.export(exports, "DateSegment", ()=>_DateSegment);
var _reactAria = require("react-aria");
var _utils = require("./utils");
var _date = require("@internationalized/date");
var _reactStately = require("react-stately");
var _fieldError = require("./FieldError");
var _utils1 = require("@react-aria/utils");
var _group = require("./Group");
var _input = require("./Input");
var _label = require("./Label");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _text = require("./Text");
const DateFieldContext = /*#__PURE__*/ (0, _react.createContext)(null);
const TimeFieldContext = /*#__PURE__*/ (0, _react.createContext)(null);
const DateFieldStateContext = /*#__PURE__*/ (0, _react.createContext)(null);
const TimeFieldStateContext = /*#__PURE__*/ (0, _react.createContext)(null);
function DateField(props, ref) {
    [props, ref] = (0, _utils.useContextProps)(props, ref, DateFieldContext);
    let { locale } = (0, _reactAria.useLocale)();
    var _props_validationBehavior;
    let state = (0, _reactStately.useDateFieldState)({
        ...props,
        locale,
        createCalendar: (0, _date.createCalendar),
        validationBehavior: (_props_validationBehavior = props.validationBehavior) !== null && _props_validationBehavior !== void 0 ? _props_validationBehavior : "native"
    });
    let fieldRef = (0, _react.useRef)(null);
    let [labelRef, label] = (0, _utils.useSlot)();
    let inputRef = (0, _react.useRef)(null);
    var _props_validationBehavior1;
    let { labelProps, fieldProps, inputProps, descriptionProps, errorMessageProps, ...validation } = (0, _reactAria.useDateField)({
        ...(0, _utils.removeDataAttributes)(props),
        label,
        inputRef,
        validationBehavior: (_props_validationBehavior1 = props.validationBehavior) !== null && _props_validationBehavior1 !== void 0 ? _props_validationBehavior1 : "native"
    }, state, fieldRef);
    let renderProps = (0, _utils.useRenderProps)({
        ...(0, _utils.removeDataAttributes)(props),
        values: {
            state,
            isInvalid: state.isInvalid,
            isDisabled: state.isDisabled
        },
        defaultClassName: "react-aria-DateField"
    });
    let DOMProps = (0, _utils1.filterDOMProps)(props);
    delete DOMProps.id;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.Provider), {
        values: [
            [
                DateFieldStateContext,
                state
            ],
            [
                (0, _group.GroupContext),
                {
                    ...fieldProps,
                    ref: fieldRef,
                    isInvalid: state.isInvalid
                }
            ],
            [
                (0, _input.InputContext),
                {
                    ...inputProps,
                    ref: inputRef
                }
            ],
            [
                (0, _label.LabelContext),
                {
                    ...labelProps,
                    ref: labelRef,
                    elementType: "span"
                }
            ],
            [
                (0, _text.TextContext),
                {
                    slots: {
                        description: descriptionProps,
                        errorMessage: errorMessageProps
                    }
                }
            ],
            [
                (0, _fieldError.FieldErrorContext),
                validation
            ]
        ]
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...DOMProps,
        ...renderProps,
        ref: ref,
        slot: props.slot || undefined,
        "data-invalid": state.isInvalid || undefined
    }));
}
/**
 * A date field allows users to enter and edit date and time values using a keyboard.
 * Each part of a date value is displayed in an individually editable segment.
 */ const _DateField = /*#__PURE__*/ (0, _react.forwardRef)(DateField);
function TimeField(props, ref) {
    [props, ref] = (0, _utils.useContextProps)(props, ref, TimeFieldContext);
    let { locale } = (0, _reactAria.useLocale)();
    var _props_validationBehavior;
    let state = (0, _reactStately.useTimeFieldState)({
        ...props,
        locale,
        validationBehavior: (_props_validationBehavior = props.validationBehavior) !== null && _props_validationBehavior !== void 0 ? _props_validationBehavior : "native"
    });
    let fieldRef = (0, _react.useRef)(null);
    let [labelRef, label] = (0, _utils.useSlot)();
    let inputRef = (0, _react.useRef)(null);
    var _props_validationBehavior1;
    let { labelProps, fieldProps, inputProps, descriptionProps, errorMessageProps, ...validation } = (0, _reactAria.useTimeField)({
        ...(0, _utils.removeDataAttributes)(props),
        label,
        inputRef,
        validationBehavior: (_props_validationBehavior1 = props.validationBehavior) !== null && _props_validationBehavior1 !== void 0 ? _props_validationBehavior1 : "native"
    }, state, fieldRef);
    let renderProps = (0, _utils.useRenderProps)({
        ...props,
        values: {
            state,
            isInvalid: state.isInvalid,
            isDisabled: state.isDisabled
        },
        defaultClassName: "react-aria-TimeField"
    });
    let DOMProps = (0, _utils1.filterDOMProps)(props);
    delete DOMProps.id;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.Provider), {
        values: [
            [
                TimeFieldStateContext,
                state
            ],
            [
                (0, _group.GroupContext),
                {
                    ...fieldProps,
                    ref: fieldRef,
                    isInvalid: state.isInvalid
                }
            ],
            [
                (0, _input.InputContext),
                {
                    ...inputProps,
                    ref: inputRef
                }
            ],
            [
                (0, _label.LabelContext),
                {
                    ...labelProps,
                    ref: labelRef,
                    elementType: "span"
                }
            ],
            [
                (0, _text.TextContext),
                {
                    slots: {
                        description: descriptionProps,
                        errorMessage: errorMessageProps
                    }
                }
            ],
            [
                (0, _fieldError.FieldErrorContext),
                validation
            ]
        ]
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...DOMProps,
        ...renderProps,
        ref: ref,
        slot: props.slot || undefined,
        "data-invalid": state.isInvalid || undefined
    }));
}
/**
 * A time field allows users to enter and edit time values using a keyboard.
 * Each part of a time value is displayed in an individually editable segment.
 */ const _TimeField = /*#__PURE__*/ (0, _react.forwardRef)(TimeField);
function DateInput(props, ref) {
    // If state is provided by DateField/TimeField, just render.
    // Otherwise (e.g. in DatePicker), we need to call hooks and create state ourselves.
    let dateFieldState = (0, _react.useContext)(DateFieldStateContext);
    let timeFieldState = (0, _react.useContext)(TimeFieldStateContext);
    return dateFieldState || timeFieldState ? /*#__PURE__*/ (0, _reactDefault.default).createElement(DateInputInner, {
        ...props,
        ref: ref
    }) : /*#__PURE__*/ (0, _reactDefault.default).createElement(DateInputStandalone, {
        ...props,
        ref: ref
    });
}
const DateInputStandalone = /*#__PURE__*/ (0, _react.forwardRef)((props, ref)=>{
    let [dateFieldProps, fieldRef] = (0, _utils.useContextProps)({
        slot: props.slot
    }, ref, DateFieldContext);
    let { locale } = (0, _reactAria.useLocale)();
    let state = (0, _reactStately.useDateFieldState)({
        ...dateFieldProps,
        locale,
        createCalendar: (0, _date.createCalendar)
    });
    let inputRef = (0, _react.useRef)(null);
    let { fieldProps, inputProps } = (0, _reactAria.useDateField)({
        ...dateFieldProps,
        inputRef
    }, state, fieldRef);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.Provider), {
        values: [
            [
                DateFieldStateContext,
                state
            ],
            [
                (0, _input.InputContext),
                {
                    ...inputProps,
                    ref: inputRef
                }
            ],
            [
                (0, _group.GroupContext),
                {
                    ...fieldProps,
                    ref: fieldRef,
                    isInvalid: state.isInvalid
                }
            ]
        ]
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(DateInputInner, props));
});
const DateInputInner = /*#__PURE__*/ (0, _react.forwardRef)((props, ref)=>{
    let { className, children } = props;
    let dateFieldState = (0, _react.useContext)(DateFieldStateContext);
    let timeFieldState = (0, _react.useContext)(TimeFieldStateContext);
    let state = dateFieldState !== null && dateFieldState !== void 0 ? dateFieldState : timeFieldState;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _group.Group), {
        ...props,
        ref: ref,
        slot: props.slot || undefined,
        className: className !== null && className !== void 0 ? className : "react-aria-DateInput",
        isInvalid: state.isInvalid
    }, state.segments.map((segment, i)=>/*#__PURE__*/ (0, _react.cloneElement)(children(segment), {
            key: i
        }))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _input.Input), null));
});
/**
 * A date input groups the editable date segments within a date field.
 */ const _DateInput = /*#__PURE__*/ (0, _react.forwardRef)(DateInput);
function DateSegment({ segment, ...otherProps }, ref) {
    let dateFieldState = (0, _react.useContext)(DateFieldStateContext);
    let timeFieldState = (0, _react.useContext)(TimeFieldStateContext);
    let state = dateFieldState !== null && dateFieldState !== void 0 ? dateFieldState : timeFieldState;
    let domRef = (0, _utils1.useObjectRef)(ref);
    let { segmentProps } = (0, _reactAria.useDateSegment)(segment, state, domRef);
    let { focusProps, isFocused, isFocusVisible } = (0, _reactAria.useFocusRing)();
    let { hoverProps, isHovered } = (0, _reactAria.useHover)({
        ...otherProps,
        isDisabled: state.isDisabled || segment.type === "literal"
    });
    let renderProps = (0, _utils.useRenderProps)({
        ...otherProps,
        values: {
            ...segment,
            isReadOnly: !segment.isEditable,
            isInvalid: state.isInvalid,
            isDisabled: state.isDisabled,
            isHovered,
            isFocused,
            isFocusVisible
        },
        defaultChildren: segment.text,
        defaultClassName: "react-aria-DateSegment"
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...(0, _reactAria.mergeProps)((0, _utils1.filterDOMProps)(otherProps), segmentProps, focusProps, hoverProps),
        ...renderProps,
        ref: domRef,
        "data-placeholder": segment.isPlaceholder || undefined,
        "data-invalid": state.isInvalid || undefined,
        "data-readonly": !segment.isEditable || undefined,
        "data-disabled": state.isDisabled || undefined,
        "data-type": segment.type,
        "data-hovered": isHovered || undefined,
        "data-focused": isFocused || undefined,
        "data-focus-visible": isFocusVisible || undefined
    });
}
/**
 * A date segment displays an individual unit of a date and time, and allows users to edit
 * the value by typing or using the arrow keys to increment and decrement.
 */ const _DateSegment = /*#__PURE__*/ (0, _react.forwardRef)(DateSegment);

},{"react-aria":"e7jhe","./utils":"iyTLn","@internationalized/date":"hesBk","react-stately":"ij62t","./FieldError":"3acDn","@react-aria/utils":"9cLk5","./Group":"71duS","./Input":"3u8zn","./Label":"jhkeS","react":"9yzVZ","./Text":"iZUDL","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"kKATF":[function(require,module,exports) {
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DatePickerContext", ()=>DatePickerContext);
parcelHelpers.export(exports, "DateRangePickerContext", ()=>DateRangePickerContext);
parcelHelpers.export(exports, "DatePickerStateContext", ()=>DatePickerStateContext);
parcelHelpers.export(exports, "DateRangePickerStateContext", ()=>DateRangePickerStateContext);
parcelHelpers.export(exports, "DatePicker", ()=>_DatePicker);
parcelHelpers.export(exports, "DateRangePicker", ()=>_DateRangePicker);
var _reactAria = require("react-aria");
var _button = require("./Button");
var _calendar = require("./Calendar");
var _utils = require("./utils");
var _dateField = require("./DateField");
var _reactStately = require("react-stately");
var _dialog = require("./Dialog");
var _fieldError = require("./FieldError");
var _utils1 = require("@react-aria/utils");
var _group = require("./Group");
var _label = require("./Label");
var _popover = require("./Popover");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _text = require("./Text");
const DatePickerContext = /*#__PURE__*/ (0, _react.createContext)(null);
const DateRangePickerContext = /*#__PURE__*/ (0, _react.createContext)(null);
const DatePickerStateContext = /*#__PURE__*/ (0, _react.createContext)(null);
const DateRangePickerStateContext = /*#__PURE__*/ (0, _react.createContext)(null);
function DatePicker(props, ref) {
    [props, ref] = (0, _utils.useContextProps)(props, ref, DatePickerContext);
    var _props_validationBehavior;
    let state = (0, _reactStately.useDatePickerState)({
        ...props,
        validationBehavior: (_props_validationBehavior = props.validationBehavior) !== null && _props_validationBehavior !== void 0 ? _props_validationBehavior : "native"
    });
    let groupRef = (0, _react.useRef)(null);
    let [labelRef, label] = (0, _utils.useSlot)();
    var _props_validationBehavior1;
    let { groupProps, labelProps, fieldProps, buttonProps, dialogProps, calendarProps, descriptionProps, errorMessageProps, ...validation } = (0, _reactAria.useDatePicker)({
        ...(0, _utils.removeDataAttributes)(props),
        label,
        validationBehavior: (_props_validationBehavior1 = props.validationBehavior) !== null && _props_validationBehavior1 !== void 0 ? _props_validationBehavior1 : "native"
    }, state, groupRef);
    let { focusProps, isFocused, isFocusVisible } = (0, _reactAria.useFocusRing)({
        within: true
    });
    let renderProps = (0, _utils.useRenderProps)({
        ...props,
        values: {
            state,
            isFocusWithin: isFocused,
            isFocusVisible,
            isDisabled: props.isDisabled || false,
            isInvalid: state.isInvalid,
            isOpen: state.isOpen
        },
        defaultClassName: "react-aria-DatePicker"
    });
    let DOMProps = (0, _utils1.filterDOMProps)(props);
    delete DOMProps.id;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.Provider), {
        values: [
            [
                DatePickerStateContext,
                state
            ],
            [
                (0, _group.GroupContext),
                {
                    ...groupProps,
                    ref: groupRef,
                    isInvalid: state.isInvalid
                }
            ],
            [
                (0, _dateField.DateFieldContext),
                fieldProps
            ],
            [
                (0, _button.ButtonContext),
                {
                    ...buttonProps,
                    isPressed: state.isOpen
                }
            ],
            [
                (0, _label.LabelContext),
                {
                    ...labelProps,
                    ref: labelRef,
                    elementType: "span"
                }
            ],
            [
                (0, _calendar.CalendarContext),
                calendarProps
            ],
            [
                (0, _dialog.OverlayTriggerStateContext),
                state
            ],
            [
                (0, _popover.PopoverContext),
                {
                    trigger: "DatePicker",
                    triggerRef: groupRef,
                    placement: "bottom start"
                }
            ],
            [
                (0, _dialog.DialogContext),
                dialogProps
            ],
            [
                (0, _text.TextContext),
                {
                    slots: {
                        description: descriptionProps,
                        errorMessage: errorMessageProps
                    }
                }
            ],
            [
                (0, _fieldError.FieldErrorContext),
                validation
            ]
        ]
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...focusProps,
        ...DOMProps,
        ...renderProps,
        ref: ref,
        slot: props.slot || undefined,
        "data-focus-within": isFocused || undefined,
        "data-invalid": state.isInvalid || undefined,
        "data-focus-visible": isFocusVisible || undefined,
        "data-disabled": props.isDisabled || undefined,
        "data-open": state.isOpen || undefined
    }));
}
/**
 * A date picker combines a DateField and a Calendar popover to allow users to enter or select a date and time value.
 */ const _DatePicker = /*#__PURE__*/ (0, _react.forwardRef)(DatePicker);
function DateRangePicker(props, ref) {
    [props, ref] = (0, _utils.useContextProps)(props, ref, DateRangePickerContext);
    var _props_validationBehavior;
    let state = (0, _reactStately.useDateRangePickerState)({
        ...props,
        validationBehavior: (_props_validationBehavior = props.validationBehavior) !== null && _props_validationBehavior !== void 0 ? _props_validationBehavior : "native"
    });
    let groupRef = (0, _react.useRef)(null);
    let [labelRef, label] = (0, _utils.useSlot)();
    var _props_validationBehavior1;
    let { groupProps, labelProps, startFieldProps, endFieldProps, buttonProps, dialogProps, calendarProps, descriptionProps, errorMessageProps, ...validation } = (0, _reactAria.useDateRangePicker)({
        ...(0, _utils.removeDataAttributes)(props),
        label,
        validationBehavior: (_props_validationBehavior1 = props.validationBehavior) !== null && _props_validationBehavior1 !== void 0 ? _props_validationBehavior1 : "native"
    }, state, groupRef);
    let { focusProps, isFocused, isFocusVisible } = (0, _reactAria.useFocusRing)({
        within: true
    });
    let renderProps = (0, _utils.useRenderProps)({
        ...props,
        values: {
            state,
            isFocusWithin: isFocused,
            isFocusVisible,
            isDisabled: props.isDisabled || false,
            isInvalid: state.isInvalid,
            isOpen: state.isOpen
        },
        defaultClassName: "react-aria-DateRangePicker"
    });
    let DOMProps = (0, _utils1.filterDOMProps)(props);
    delete DOMProps.id;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.Provider), {
        values: [
            [
                DateRangePickerStateContext,
                state
            ],
            [
                (0, _group.GroupContext),
                {
                    ...groupProps,
                    ref: groupRef,
                    isInvalid: state.isInvalid
                }
            ],
            [
                (0, _button.ButtonContext),
                {
                    ...buttonProps,
                    isPressed: state.isOpen
                }
            ],
            [
                (0, _label.LabelContext),
                {
                    ...labelProps,
                    ref: labelRef,
                    elementType: "span"
                }
            ],
            [
                (0, _calendar.RangeCalendarContext),
                calendarProps
            ],
            [
                (0, _dialog.OverlayTriggerStateContext),
                state
            ],
            [
                (0, _popover.PopoverContext),
                {
                    trigger: "DateRangePicker",
                    triggerRef: groupRef,
                    placement: "bottom start"
                }
            ],
            [
                (0, _dialog.DialogContext),
                dialogProps
            ],
            [
                (0, _dateField.DateFieldContext),
                {
                    slots: {
                        start: startFieldProps,
                        end: endFieldProps
                    }
                }
            ],
            [
                (0, _text.TextContext),
                {
                    slots: {
                        description: descriptionProps,
                        errorMessage: errorMessageProps
                    }
                }
            ],
            [
                (0, _fieldError.FieldErrorContext),
                validation
            ]
        ]
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...focusProps,
        ...DOMProps,
        ...renderProps,
        ref: ref,
        slot: props.slot || undefined,
        "data-focus-within": isFocused || undefined,
        "data-invalid": state.isInvalid || undefined,
        "data-focus-visible": isFocusVisible || undefined,
        "data-disabled": props.isDisabled || undefined,
        "data-open": state.isOpen || undefined
    }));
}
/**
 * A date range picker combines two DateFields and a RangeCalendar popover to allow
 * users to enter or select a date and time range.
 */ const _DateRangePicker = /*#__PURE__*/ (0, _react.forwardRef)(DateRangePicker);

},{"react-aria":"e7jhe","./Button":"9McZy","./Calendar":"insxi","./utils":"iyTLn","./DateField":"7GuOQ","react-stately":"ij62t","./Dialog":"7F4Zw","./FieldError":"3acDn","@react-aria/utils":"9cLk5","./Group":"71duS","./Label":"jhkeS","./Popover":"Gl2h9","react":"9yzVZ","./Text":"iZUDL","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"udzkg":[function(require,module,exports) {
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DropZoneContext", ()=>DropZoneContext);
parcelHelpers.export(exports, "DropZone", ()=>_DropZone);
var _utils = require("./utils");
var _reactAria = require("react-aria");
var _utils1 = require("@react-aria/utils");
// @ts-ignore
var _json = require("../intl/*.json");
var _jsonDefault = parcelHelpers.interopDefault(_json);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _text = require("./Text");
const DropZoneContext = /*#__PURE__*/ (0, _react.createContext)(null);
function DropZone(props, ref) {
    [props, ref] = (0, _utils.useContextProps)(props, ref, DropZoneContext);
    let buttonRef = (0, _react.useRef)(null);
    let { dropProps, dropButtonProps, isDropTarget } = (0, _reactAria.useDrop)({
        ...props,
        ref: buttonRef,
        hasDropButton: true
    });
    let { hoverProps, isHovered } = (0, _reactAria.useHover)(props);
    let { focusProps, isFocused, isFocusVisible } = (0, _reactAria.useFocusRing)();
    let stringFormatter = (0, _reactAria.useLocalizedStringFormatter)((0, _jsonDefault.default), "react-aria-components");
    let textId = (0, _utils1.useSlotId)();
    let dropzoneId = (0, _utils1.useSlotId)();
    let ariaLabel = props["aria-label"] || stringFormatter.format("dropzoneLabel");
    let messageId = props["aria-labelledby"];
    // Chrome + VO will not announce the drop zone's accessible name if useLabels combines an aria-label and aria-labelledby
    let ariaLabelledby = [
        dropzoneId,
        textId,
        messageId
    ].filter(Boolean).join(" ");
    let labelProps = (0, _utils1.useLabels)({
        "aria-labelledby": ariaLabelledby
    });
    let { clipboardProps } = (0, _reactAria.useClipboard)({
        onPaste: (items)=>{
            var _props_onDrop;
            return (_props_onDrop = props.onDrop) === null || _props_onDrop === void 0 ? void 0 : _props_onDrop.call(props, {
                type: "drop",
                items,
                x: 0,
                y: 0,
                dropOperation: "copy"
            });
        }
    });
    let renderProps = (0, _utils.useRenderProps)({
        ...props,
        values: {
            isHovered,
            isFocused,
            isFocusVisible,
            isDropTarget
        },
        defaultClassName: "react-aria-DropZone"
    });
    let DOMProps = (0, _utils1.filterDOMProps)(props);
    delete DOMProps.id;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.Provider), {
        values: [
            [
                (0, _text.TextContext),
                {
                    id: textId,
                    slot: "label"
                }
            ]
        ]
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...(0, _reactAria.mergeProps)(dropProps, hoverProps, DOMProps),
        ...renderProps,
        slot: props.slot || undefined,
        ref: ref,
        onClick: ()=>{
            var _buttonRef_current;
            return (_buttonRef_current = buttonRef.current) === null || _buttonRef_current === void 0 ? void 0 : _buttonRef_current.focus();
        },
        "data-hovered": isHovered || undefined,
        "data-focused": isFocused || undefined,
        "data-focus-visible": isFocusVisible || undefined,
        "data-drop-target": isDropTarget || undefined
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAria.VisuallyHidden), null, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        id: dropzoneId,
        "aria-hidden": "true"
    }, ariaLabel), /*#__PURE__*/ (0, _reactDefault.default).createElement("button", {
        ...(0, _reactAria.mergeProps)(dropButtonProps, focusProps, clipboardProps, labelProps),
        ref: buttonRef
    })), renderProps.children));
}
/**
 * A drop zone is an area into which one or multiple objects can be dragged and dropped.
 */ const _DropZone = /*#__PURE__*/ (0, _react.forwardRef)(DropZone);

},{"./utils":"iyTLn","react-aria":"e7jhe","@react-aria/utils":"9cLk5","../intl/*.json":"cQFjh","react":"9yzVZ","./Text":"iZUDL","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"cQFjh":[function(require,module,exports) {
const _temp0 = require("1dea5186a7872140");
const _temp1 = require("c6f234767f419e16");
const _temp2 = require("f8dd122a33e7f4be");
const _temp3 = require("a06f4d36267896c4");
const _temp4 = require("cdebc762c2e09d83");
const _temp5 = require("5554aad3363e66cd");
const _temp6 = require("23ddc5700a1bb44b");
const _temp7 = require("64095a6b559e4242");
const _temp8 = require("295f717684312f66");
const _temp9 = require("6780fe0832822062");
const _temp10 = require("611646c41f92dad4");
const _temp11 = require("702593b6a8352c9b");
const _temp12 = require("f2792d8df761a0a6");
const _temp13 = require("5067d05b1c4c072e");
const _temp14 = require("f7de28d6ac827017");
const _temp15 = require("4d9923a5fd6d6971");
const _temp16 = require("2d8beed54f7f3dd3");
const _temp17 = require("d1a92d612a460d1b");
const _temp18 = require("7da1b2a97de8424b");
const _temp19 = require("f1389a487de900b3");
const _temp20 = require("c96233d21fec5245");
const _temp21 = require("c948bba5251f26d9");
const _temp22 = require("5d94e7c92f933096");
const _temp23 = require("8eb7edd8181d6d58");
const _temp24 = require("583b413e29c0276a");
const _temp25 = require("95d9e0cce7397706");
const _temp26 = require("3f8d91d0428bc844");
const _temp27 = require("b7375635d7b503a9");
const _temp28 = require("f29aafa0ec29ab84");
const _temp29 = require("307b2973dd4c8661");
const _temp30 = require("bde670a730a5e40e");
const _temp31 = require("c34153bf14b4f238");
const _temp32 = require("36da79f84e2b7c52");
const _temp33 = require("73b64190524074ee");
module.exports = {
    "ar-AE": _temp0,
    "bg-BG": _temp1,
    "cs-CZ": _temp2,
    "da-DK": _temp3,
    "de-DE": _temp4,
    "el-GR": _temp5,
    "en-US": _temp6,
    "es-ES": _temp7,
    "et-EE": _temp8,
    "fi-FI": _temp9,
    "fr-FR": _temp10,
    "he-IL": _temp11,
    "hr-HR": _temp12,
    "hu-HU": _temp13,
    "it-IT": _temp14,
    "ja-JP": _temp15,
    "ko-KR": _temp16,
    "lt-LT": _temp17,
    "lv-LV": _temp18,
    "nb-NO": _temp19,
    "nl-NL": _temp20,
    "pl-PL": _temp21,
    "pt-BR": _temp22,
    "pt-PT": _temp23,
    "ro-RO": _temp24,
    "ru-RU": _temp25,
    "sk-SK": _temp26,
    "sl-SI": _temp27,
    "sr-SP": _temp28,
    "sv-SE": _temp29,
    "tr-TR": _temp30,
    "uk-UA": _temp31,
    "zh-CN": _temp32,
    "zh-TW": _temp33
};

},{"1dea5186a7872140":"fmScs","c6f234767f419e16":"QM4MK","f8dd122a33e7f4be":"l6VdA","a06f4d36267896c4":"eSXMp","cdebc762c2e09d83":"5Bsny","5554aad3363e66cd":"4c81A","23ddc5700a1bb44b":"e3xot","64095a6b559e4242":"di6XH","295f717684312f66":"faU3z","6780fe0832822062":"7XERj","611646c41f92dad4":"l3oGE","702593b6a8352c9b":"lwqtu","f2792d8df761a0a6":"23Rwr","5067d05b1c4c072e":"cxdpw","f7de28d6ac827017":"7PnHf","4d9923a5fd6d6971":"9ZhsJ","2d8beed54f7f3dd3":"dhMSW","d1a92d612a460d1b":"dBJiG","7da1b2a97de8424b":"ivsp7","f1389a487de900b3":"aZWP2","c96233d21fec5245":"1Zjru","c948bba5251f26d9":"9SK9b","5d94e7c92f933096":"hKjRe","8eb7edd8181d6d58":"fBjCa","583b413e29c0276a":"128bY","95d9e0cce7397706":"drI6c","3f8d91d0428bc844":"fGrCL","b7375635d7b503a9":"cpJoO","f29aafa0ec29ab84":"eMnmX","307b2973dd4c8661":"8RU4W","bde670a730a5e40e":"3OfKS","c34153bf14b4f238":"8fEyS","36da79f84e2b7c52":"bZSOA","73b64190524074ee":"czJXG"}],"fmScs":[function(require,module,exports) {
module.exports = JSON.parse('{"dropzoneLabel":"DropZone","selectPlaceholder":"\u062D\u062F\u062F \u0639\u0646\u0635\u0631\u064B\u0627","tableResizer":"\u0623\u062F\u0627\u0629 \u062A\u063A\u064A\u064A\u0631 \u0627\u0644\u062D\u062C\u0645"}');

},{}],"QM4MK":[function(require,module,exports) {
module.exports = JSON.parse('{"dropzoneLabel":"DropZone","selectPlaceholder":"\u0418\u0437\u0431\u0435\u0440\u0435\u0442\u0435 \u043F\u0440\u0435\u0434\u043C\u0435\u0442","tableResizer":"\u041F\u0440\u0435\u043E\u0440\u0430\u0437\u043C\u0435\u0440\u0438\u0442\u0435\u043B"}');

},{}],"l6VdA":[function(require,module,exports) {
module.exports = JSON.parse('{"dropzoneLabel":"M\xedsto pro p\u0159eta\u017Een\xed","selectPlaceholder":"Vyberte polo\u017Eku","tableResizer":"Zm\u011Bna velikosti"}');

},{}],"eSXMp":[function(require,module,exports) {
module.exports = JSON.parse('{"dropzoneLabel":"DropZone","selectPlaceholder":"V\xe6lg et element","tableResizer":"St\xf8rrelses\xe6ndring"}');

},{}],"5Bsny":[function(require,module,exports) {
module.exports = JSON.parse('{"dropzoneLabel":"Ablegebereich","selectPlaceholder":"Element w\xe4hlen","tableResizer":"Gr\xf6\xdfenanpassung"}');

},{}],"4c81A":[function(require,module,exports) {
module.exports = JSON.parse('{"dropzoneLabel":"DropZone","selectPlaceholder":"\u0395\u03C0\u03B9\u03BB\u03AD\u03BE\u03C4\u03B5 \u03AD\u03BD\u03B1 \u03B1\u03BD\u03C4\u03B9\u03BA\u03B5\u03AF\u03BC\u03B5\u03BD\u03BF","tableResizer":"\u0391\u03BB\u03BB\u03B1\u03B3\u03AE \u03BC\u03B5\u03B3\u03AD\u03B8\u03BF\u03C5\u03C2"}');

},{}],"e3xot":[function(require,module,exports) {
module.exports = JSON.parse('{"selectPlaceholder":"Select an item","tableResizer":"Resizer","dropzoneLabel":"DropZone"}');

},{}],"di6XH":[function(require,module,exports) {
module.exports = JSON.parse('{"dropzoneLabel":"DropZone","selectPlaceholder":"Seleccionar un art\xedculo","tableResizer":"Cambiador de tama\xf1o"}');

},{}],"faU3z":[function(require,module,exports) {
module.exports = JSON.parse('{"dropzoneLabel":"DropZone","selectPlaceholder":"Valige \xfcksus","tableResizer":"Suuruse muutja"}');

},{}],"7XERj":[function(require,module,exports) {
module.exports = JSON.parse('{"dropzoneLabel":"DropZone","selectPlaceholder":"Valitse kohde","tableResizer":"Koon muuttaja"}');

},{}],"l3oGE":[function(require,module,exports) {
module.exports = JSON.parse('{"dropzoneLabel":"DropZone","selectPlaceholder":"S\xe9lectionner un \xe9l\xe9ment","tableResizer":"Redimensionneur"}');

},{}],"lwqtu":[function(require,module,exports) {
module.exports = JSON.parse('{"dropzoneLabel":"DropZone","selectPlaceholder":"\u05D1\u05D7\u05E8 \u05E4\u05E8\u05D9\u05D8","tableResizer":"\u05E9\u05D9\u05E0\u05D5\u05D9 \u05D2\u05D5\u05D3\u05DC"}');

},{}],"23Rwr":[function(require,module,exports) {
module.exports = JSON.parse('{"dropzoneLabel":"Zona spu\u0161tanja","selectPlaceholder":"Odaberite stavku","tableResizer":"Promjena veli\u010Dine"}');

},{}],"cxdpw":[function(require,module,exports) {
module.exports = JSON.parse('{"dropzoneLabel":"DropZone","selectPlaceholder":"V\xe1lasszon ki egy elemet","tableResizer":"\xc1tm\xe9retez\u0151"}');

},{}],"7PnHf":[function(require,module,exports) {
module.exports = JSON.parse('{"dropzoneLabel":"Zona di rilascio","selectPlaceholder":"Seleziona un elemento","tableResizer":"Ridimensionamento"}');

},{}],"9ZhsJ":[function(require,module,exports) {
module.exports = JSON.parse('{"dropzoneLabel":"\u30C9\u30ED\u30C3\u30D7\u30BE\u30FC\u30F3","selectPlaceholder":"\u9805\u76EE\u3092\u9078\u629E","tableResizer":"\u30B5\u30A4\u30BA\u5909\u66F4\u30C4\u30FC\u30EB"}');

},{}],"dhMSW":[function(require,module,exports) {
module.exports = JSON.parse('{"dropzoneLabel":"\uB4DC\uB86D \uC601\uC5ED","selectPlaceholder":"\uD56D\uBAA9 \uC120\uD0DD","tableResizer":"\uD06C\uAE30 \uC870\uC815\uAE30"}');

},{}],"dBJiG":[function(require,module,exports) {
module.exports = JSON.parse('{"dropzoneLabel":"\u201EDropZone\u201C","selectPlaceholder":"Pasirinkite element\u0105","tableResizer":"Dyd\u017Eio keitiklis"}');

},{}],"ivsp7":[function(require,module,exports) {
module.exports = JSON.parse('{"dropzoneLabel":"DropZone","selectPlaceholder":"Izv\u0113l\u0113ties vienumu","tableResizer":"Izm\u0113ra main\u012Bt\u0101js"}');

},{}],"aZWP2":[function(require,module,exports) {
module.exports = JSON.parse('{"dropzoneLabel":"Droppsone","selectPlaceholder":"Velg et element","tableResizer":"St\xf8rrelsesendrer"}');

},{}],"1Zjru":[function(require,module,exports) {
module.exports = JSON.parse('{"dropzoneLabel":"DropZone","selectPlaceholder":"Selecteer een item","tableResizer":"Resizer"}');

},{}],"9SK9b":[function(require,module,exports) {
module.exports = JSON.parse('{"dropzoneLabel":"Strefa upuszczania","selectPlaceholder":"Wybierz element","tableResizer":"Zmiana rozmiaru"}');

},{}],"hKjRe":[function(require,module,exports) {
module.exports = JSON.parse('{"dropzoneLabel":"DropZone","selectPlaceholder":"Selecione um item","tableResizer":"Redimensionador"}');

},{}],"fBjCa":[function(require,module,exports) {
module.exports = JSON.parse('{"dropzoneLabel":"DropZone","selectPlaceholder":"Selecione um item","tableResizer":"Redimensionador"}');

},{}],"128bY":[function(require,module,exports) {
module.exports = JSON.parse('{"dropzoneLabel":"Zon\u0103 de plasare","selectPlaceholder":"Selecta\u021Bi un element","tableResizer":"Instrument de redimensionare"}');

},{}],"drI6c":[function(require,module,exports) {
module.exports = JSON.parse('{"dropzoneLabel":"DropZone","selectPlaceholder":"\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u044D\u043B\u0435\u043C\u0435\u043D\u0442","tableResizer":"\u0421\u0440\u0435\u0434\u0441\u0442\u0432\u043E \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u044F \u0440\u0430\u0437\u043C\u0435\u0440\u0430"}');

},{}],"fGrCL":[function(require,module,exports) {
module.exports = JSON.parse('{"dropzoneLabel":"DropZone","selectPlaceholder":"Vyberte polo\u017Eku","tableResizer":"N\xe1stroj na zmenu ve\u013Ekosti"}');

},{}],"cpJoO":[function(require,module,exports) {
module.exports = JSON.parse('{"dropzoneLabel":"DropZone","selectPlaceholder":"Izberite element","tableResizer":"Spreminjanje velikosti"}');

},{}],"eMnmX":[function(require,module,exports) {
module.exports = JSON.parse('{"dropzoneLabel":"DropZone","selectPlaceholder":"Izaberite stavku","tableResizer":"Promena veli\u010Dine"}');

},{}],"8RU4W":[function(require,module,exports) {
module.exports = JSON.parse('{"dropzoneLabel":"DropZone","selectPlaceholder":"V\xe4lj en artikel","tableResizer":"Storleks\xe4ndrare"}');

},{}],"3OfKS":[function(require,module,exports) {
module.exports = JSON.parse('{"dropzoneLabel":"B\u0131rakma B\xf6lgesi","selectPlaceholder":"Bir \xf6\u011Fe se\xe7in","tableResizer":"Yeniden boyutland\u0131r\u0131c\u0131"}');

},{}],"8fEyS":[function(require,module,exports) {
module.exports = JSON.parse('{"dropzoneLabel":"DropZone","selectPlaceholder":"\u0412\u0438\u0431\u0435\u0440\u0456\u0442\u044C \u0435\u043B\u0435\u043C\u0435\u043D\u0442","tableResizer":"\u0417\u0430\u0441\u0456\u0431 \u0437\u043C\u0456\u043D\u0435\u043D\u043D\u044F \u0440\u043E\u0437\u043C\u0456\u0440\u0443"}');

},{}],"bZSOA":[function(require,module,exports) {
module.exports = JSON.parse('{"dropzoneLabel":"\u653E\u7F6E\u533A\u57DF","selectPlaceholder":"\u9009\u62E9\u4E00\u4E2A\u9879\u76EE","tableResizer":"\u5C3A\u5BF8\u8C03\u6574\u5668"}');

},{}],"czJXG":[function(require,module,exports) {
module.exports = JSON.parse('{"dropzoneLabel":"\u653E\u7F6E\u5340","selectPlaceholder":"\u9078\u53D6\u9805\u76EE","tableResizer":"\u5927\u5C0F\u8ABF\u6574\u5668"}');

},{}],"gIbtb":[function(require,module,exports) {
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FileTrigger", ()=>_FileTrigger);
var _utils = require("@react-aria/utils");
var _input = require("./Input");
var _interactions = require("@react-aria/interactions");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
function FileTrigger(props, ref) {
    let { onSelect, acceptedFileTypes, allowsMultiple, defaultCamera, children, acceptDirectory, ...rest } = props;
    let inputRef = (0, _utils.useObjectRef)(ref);
    let domProps = (0, _utils.filterDOMProps)(rest);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _interactions.PressResponder), {
        onPress: ()=>{
            var _inputRef_current, _inputRef_current1;
            if ((_inputRef_current = inputRef.current) === null || _inputRef_current === void 0 ? void 0 : _inputRef_current.value) inputRef.current.value = "";
            (_inputRef_current1 = inputRef.current) === null || _inputRef_current1 === void 0 ? void 0 : _inputRef_current1.click();
        }
    }, children), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _input.Input), {
        ...domProps,
        type: "file",
        ref: inputRef,
        style: {
            display: "none"
        },
        accept: acceptedFileTypes === null || acceptedFileTypes === void 0 ? void 0 : acceptedFileTypes.toString(),
        onChange: (e)=>onSelect === null || onSelect === void 0 ? void 0 : onSelect(e.target.files),
        capture: defaultCamera,
        multiple: allowsMultiple,
        // @ts-expect-error
        webkitdirectory: acceptDirectory ? "" : undefined
    }));
}
/**
 * A FileTrigger allows a user to access the file system with any pressable React Aria or React Spectrum component, or custom components built with usePress.
 */ const _FileTrigger = /*#__PURE__*/ (0, _react.forwardRef)(FileTrigger);

},{"@react-aria/utils":"9cLk5","./Input":"3u8zn","@react-aria/interactions":"ky3G8","react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"88PWd":[function(require,module,exports) {
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "KeyboardContext", ()=>KeyboardContext);
parcelHelpers.export(exports, "Keyboard", ()=>_Keyboard);
var _utils = require("./utils");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const KeyboardContext = /*#__PURE__*/ (0, _react.createContext)({});
function Keyboard(props, ref) {
    [props, ref] = (0, _utils.useContextProps)(props, ref, KeyboardContext);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("kbd", {
        dir: "ltr",
        ...props,
        ref: ref
    });
}
const _Keyboard = /*#__PURE__*/ (0, _react.forwardRef)(Keyboard);

},{"./utils":"iyTLn","react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"j9a8x":[function(require,module,exports) {
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LinkContext", ()=>LinkContext);
parcelHelpers.export(exports, "Link", ()=>_Link);
var _reactAria = require("react-aria");
var _utils = require("./utils");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const LinkContext = /*#__PURE__*/ (0, _react.createContext)(null);
function Link(props, ref) {
    [props, ref] = (0, _utils.useContextProps)(props, ref, LinkContext);
    let ElementType = props.href ? "a" : "span";
    let { linkProps, isPressed } = (0, _reactAria.useLink)({
        ...props,
        elementType: ElementType
    }, ref);
    let { hoverProps, isHovered } = (0, _reactAria.useHover)(props);
    let { focusProps, isFocused, isFocusVisible } = (0, _reactAria.useFocusRing)();
    let renderProps = (0, _utils.useRenderProps)({
        ...props,
        defaultClassName: "react-aria-Link",
        values: {
            isCurrent: !!props["aria-current"],
            isDisabled: props.isDisabled || false,
            isPressed,
            isHovered,
            isFocused,
            isFocusVisible
        }
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(ElementType, {
        ref: ref,
        slot: props.slot || undefined,
        ...(0, _reactAria.mergeProps)(renderProps, linkProps, hoverProps, focusProps),
        "data-focused": isFocused || undefined,
        "data-hovered": isHovered || undefined,
        "data-pressed": isPressed || undefined,
        "data-focus-visible": isFocusVisible || undefined,
        "data-current": !!props["aria-current"] || undefined,
        "data-disabled": props.isDisabled || undefined
    }, renderProps.children);
}
/**
 * A link allows a user to navigate to another page or resource within a web page
 * or application.
 */ const _Link = /*#__PURE__*/ (0, _react.forwardRef)(Link);

},{"react-aria":"e7jhe","./utils":"iyTLn","react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"eobpp":[function(require,module,exports) {
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MenuContext", ()=>MenuContext);
parcelHelpers.export(exports, "MenuStateContext", ()=>MenuStateContext);
parcelHelpers.export(exports, "RootMenuTriggerStateContext", ()=>RootMenuTriggerStateContext);
parcelHelpers.export(exports, "MenuTrigger", ()=>MenuTrigger);
/**
 * A submenu trigger is used to wrap a submenu's trigger item and the submenu itself.
 *
 * @version alpha
 */ parcelHelpers.export(exports, "SubmenuTrigger", ()=>SubmenuTrigger);
parcelHelpers.export(exports, "Menu", ()=>_Menu);
parcelHelpers.export(exports, "MenuItem", ()=>_MenuItem);
var _reactAria = require("react-aria");
var _collection = require("./Collection");
var _reactStately = require("react-stately");
var _utils = require("./utils");
var _utils1 = require("@react-aria/utils");
var _header = require("./Header");
var _keyboard = require("./Keyboard");
var _dialog = require("./Dialog");
var _popover = require("./Popover");
var _interactions = require("@react-aria/interactions");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _menu = require("@react-stately/menu");
var _separator = require("./Separator");
var _text = require("./Text");
var _menu1 = require("@react-aria/menu");
const MenuContext = /*#__PURE__*/ (0, _react.createContext)(null);
const MenuStateContext = /*#__PURE__*/ (0, _react.createContext)(null);
const RootMenuTriggerStateContext = /*#__PURE__*/ (0, _react.createContext)(null);
function MenuTrigger(props) {
    let state = (0, _reactStately.useMenuTriggerState)(props);
    let ref = (0, _react.useRef)(null);
    let { menuTriggerProps, menuProps } = (0, _reactAria.useMenuTrigger)({
        ...props,
        type: "menu"
    }, state, ref);
    // Allows menu width to match button
    let [buttonWidth, setButtonWidth] = (0, _react.useState)(null);
    let onResize = (0, _react.useCallback)(()=>{
        if (ref.current) setButtonWidth(ref.current.offsetWidth + "px");
    }, [
        ref
    ]);
    (0, _utils1.useResizeObserver)({
        ref: ref,
        onResize: onResize
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.Provider), {
        values: [
            [
                MenuContext,
                menuProps
            ],
            [
                (0, _dialog.OverlayTriggerStateContext),
                state
            ],
            [
                RootMenuTriggerStateContext,
                state
            ],
            [
                (0, _popover.PopoverContext),
                {
                    trigger: "MenuTrigger",
                    triggerRef: ref,
                    placement: "bottom start",
                    style: {
                        "--trigger-width": buttonWidth
                    }
                }
            ]
        ]
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _interactions.PressResponder), {
        ...menuTriggerProps,
        ref: ref,
        isPressed: state.isOpen
    }, props.children));
}
function SubmenuTrigger(props, ref) {
    return (0, _collection.useSSRCollectionNode)("submenutrigger", props, ref, props.children, props.children[0]);
}
function SubmenuTriggerInner(props) {
    let { item, parentMenuRef } = props;
    let state = (0, _react.useContext)(MenuStateContext);
    let children = (0, _collection.useCachedChildren)({
        items: state.collection.getChildren(item.key),
        children: (childItem)=>{
            switch(childItem.type){
                case "item":
                    return /*#__PURE__*/ (0, _reactDefault.default).createElement(MenuItemTriggerInner, {
                        item: childItem,
                        popover: item.rendered[1],
                        parentMenuRef: parentMenuRef,
                        delay: item.props.delay
                    });
                default:
                    throw new Error("Unsupported element type in SubmenuTrigger: " + item.type);
            }
        }
    });
    return children;
}
function Menu(props, ref) {
    [props, ref] = (0, _utils.useContextProps)(props, ref, MenuContext);
    let { portal, collection } = (0, _collection.useCollection)(props);
    // Delay rendering the actual menu until we have the collection so that auto focus works properly.
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, collection.size > 0 && /*#__PURE__*/ (0, _reactDefault.default).createElement(MenuInner, {
        props: props,
        collection: collection,
        menuRef: ref
    }), portal);
}
function MenuInner({ props, collection, menuRef: ref }) {
    let state = (0, _reactStately.useTreeState)({
        ...props,
        collection,
        children: undefined
    });
    let [popoverContainer, setPopoverContainer] = (0, _react.useState)(null);
    let { menuProps } = (0, _reactAria.useMenu)(props, state, ref);
    let rootMenuTriggerState = (0, _react.useContext)(RootMenuTriggerStateContext);
    let popoverContext = (0, _react.useContext)((0, _popover.PopoverContext));
    let children = (0, _collection.useCachedChildren)({
        items: state.collection,
        children: (item)=>{
            switch(item.type){
                case "section":
                    return /*#__PURE__*/ (0, _reactDefault.default).createElement(MenuSection, {
                        section: item,
                        parentMenuRef: ref
                    });
                case "separator":
                    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _separator.Separator), item.props);
                case "item":
                    return /*#__PURE__*/ (0, _reactDefault.default).createElement(MenuItemInner, {
                        item: item
                    });
                case "submenutrigger":
                    return /*#__PURE__*/ (0, _reactDefault.default).createElement(SubmenuTriggerInner, {
                        item: item,
                        parentMenuRef: ref
                    });
                default:
                    throw new Error("Unsupported node type in Menu: " + item.type);
            }
        }
    });
    let isSubmenu = (popoverContext === null || popoverContext === void 0 ? void 0 : popoverContext.trigger) === "SubmenuTrigger";
    (0, _interactions.useInteractOutside)({
        ref,
        onInteractOutside: (e)=>{
            if (rootMenuTriggerState && !(popoverContainer === null || popoverContainer === void 0 ? void 0 : popoverContainer.contains(e.target))) rootMenuTriggerState.close();
        },
        isDisabled: isSubmenu || (rootMenuTriggerState === null || rootMenuTriggerState === void 0 ? void 0 : rootMenuTriggerState.UNSTABLE_expandedKeysStack.length) === 0
    });
    var _props_className;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAria.FocusScope), null, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...(0, _utils1.filterDOMProps)(props),
        ...menuProps,
        ref: ref,
        slot: props.slot || undefined,
        onScroll: props.onScroll,
        style: props.style,
        className: (_props_className = props.className) !== null && _props_className !== void 0 ? _props_className : "react-aria-Menu"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.Provider), {
        values: [
            [
                MenuStateContext,
                state
            ],
            [
                (0, _separator.SeparatorContext),
                {
                    elementType: "div"
                }
            ],
            [
                (0, _popover.PopoverContext),
                {
                    UNSTABLE_portalContainer: popoverContainer || undefined
                }
            ]
        ]
    }, children)), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ref: setPopoverContainer,
        style: {
            width: "100vw",
            position: "absolute",
            top: 0
        }
    }));
}
/**
 * A menu displays a list of actions or options that a user can choose.
 */ const _Menu = /*#__PURE__*/ (0, _react.forwardRef)(Menu);
function MenuSection({ section, className, style, parentMenuRef, ...otherProps }) {
    var _section_props, _section_props1;
    let state = (0, _react.useContext)(MenuStateContext);
    let [headingRef, heading] = (0, _utils.useSlot)();
    var _section_arialabel;
    let { headingProps, groupProps } = (0, _reactAria.useMenuSection)({
        heading,
        "aria-label": (_section_arialabel = section["aria-label"]) !== null && _section_arialabel !== void 0 ? _section_arialabel : undefined
    });
    let children = (0, _collection.useCachedChildren)({
        items: state.collection.getChildren(section.key),
        children: (item)=>{
            switch(item.type){
                case "header":
                    {
                        let { ref, ...otherProps } = item.props;
                        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _header.Header), {
                            ...headingProps,
                            ...otherProps,
                            ref: (0, _utils1.mergeRefs)(headingRef, ref)
                        }, item.rendered);
                    }
                case "item":
                    return /*#__PURE__*/ (0, _reactDefault.default).createElement(MenuItemInner, {
                        item: item
                    });
                case "submenutrigger":
                    return /*#__PURE__*/ (0, _reactDefault.default).createElement(SubmenuTriggerInner, {
                        item: item,
                        parentMenuRef: parentMenuRef
                    });
                default:
                    throw new Error("Unsupported element type in Section: " + item.type);
            }
        }
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("section", {
        ...(0, _utils1.filterDOMProps)(otherProps),
        ...groupProps,
        className: className || ((_section_props = section.props) === null || _section_props === void 0 ? void 0 : _section_props.className) || "react-aria-Section",
        style: style || ((_section_props1 = section.props) === null || _section_props1 === void 0 ? void 0 : _section_props1.style),
        ref: section.props.ref
    }, children);
}
function MenuItem(props, ref) {
    return (0, _collection.useSSRCollectionNode)("item", props, ref, props.children);
}
/**
 * A MenuItem represents an individual action in a Menu.
 */ const _MenuItem = /*#__PURE__*/ (0, _react.forwardRef)(MenuItem);
function MenuItemInner({ item }) {
    var _item_props;
    let state = (0, _react.useContext)(MenuStateContext);
    let ref = (0, _utils1.useObjectRef)(item.props.ref);
    let { menuItemProps, labelProps, descriptionProps, keyboardShortcutProps, ...states } = (0, _reactAria.useMenuItem)({
        key: item.key,
        "aria-label": (_item_props = item.props) === null || _item_props === void 0 ? void 0 : _item_props["aria-label"]
    }, state, ref);
    let props = item.props;
    let { isFocusVisible, focusProps } = (0, _reactAria.useFocusRing)();
    let { hoverProps, isHovered } = (0, _interactions.useHover)({
        isDisabled: states.isDisabled
    });
    let renderProps = (0, _utils.useRenderProps)({
        ...props,
        id: undefined,
        children: item.rendered,
        defaultClassName: "react-aria-MenuItem",
        values: {
            ...states,
            isHovered,
            isFocusVisible,
            selectionMode: state.selectionManager.selectionMode,
            selectionBehavior: state.selectionManager.selectionBehavior,
            hasSubmenu: false,
            isOpen: false
        }
    });
    let ElementType = props.href ? "a" : "div";
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(ElementType, {
        ...(0, _reactAria.mergeProps)(menuItemProps, focusProps, hoverProps),
        ...renderProps,
        ref: ref,
        "data-disabled": states.isDisabled || undefined,
        "data-hovered": isHovered || undefined,
        "data-focused": states.isFocused || undefined,
        "data-focus-visible": isFocusVisible || undefined,
        "data-pressed": states.isPressed || undefined,
        "data-selected": states.isSelected || undefined,
        "data-selection-mode": state.selectionManager.selectionMode === "none" ? undefined : state.selectionManager.selectionMode
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.Provider), {
        values: [
            [
                (0, _text.TextContext),
                {
                    slots: {
                        label: labelProps,
                        description: descriptionProps
                    }
                }
            ],
            [
                (0, _keyboard.KeyboardContext),
                keyboardShortcutProps
            ]
        ]
    }, renderProps.children));
}
function MenuItemTriggerInner({ item, popover, parentMenuRef, delay }) {
    let state = (0, _react.useContext)(MenuStateContext);
    let popoverContext = (0, _utils.useSlottedContext)((0, _popover.PopoverContext));
    let ref = (0, _utils1.useObjectRef)(item.props.ref);
    let rootMenuTriggerState = (0, _react.useContext)(RootMenuTriggerStateContext);
    let submenuTriggerState = (0, _menu.UNSTABLE_useSubmenuTriggerState)({
        triggerKey: item.key
    }, rootMenuTriggerState);
    let submenuRef = (0, _react.useRef)(null);
    let { submenuTriggerProps, submenuProps, popoverProps } = (0, _menu1.UNSTABLE_useSubmenuTrigger)({
        node: item,
        parentMenuRef,
        submenuRef,
        delay
    }, submenuTriggerState, ref);
    let { menuItemProps, labelProps, descriptionProps, keyboardShortcutProps, ...states } = (0, _reactAria.useMenuItem)({
        key: item.key,
        ...submenuTriggerProps
    }, state, ref);
    let props = item.props;
    let { hoverProps, isHovered } = (0, _interactions.useHover)({
        isDisabled: states.isDisabled
    });
    let { isFocusVisible, focusProps } = (0, _reactAria.useFocusRing)();
    let renderProps = (0, _utils.useRenderProps)({
        ...props,
        id: undefined,
        children: item.rendered,
        defaultClassName: "react-aria-MenuItem",
        values: {
            ...states,
            isHovered,
            isFocusVisible,
            selectionMode: state.selectionManager.selectionMode,
            selectionBehavior: state.selectionManager.selectionBehavior,
            hasSubmenu: true,
            isOpen: submenuTriggerState.isOpen
        }
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.Provider), {
        values: [
            [
                (0, _text.TextContext),
                {
                    slots: {
                        label: labelProps,
                        description: descriptionProps
                    }
                }
            ],
            [
                (0, _keyboard.KeyboardContext),
                keyboardShortcutProps
            ],
            [
                MenuContext,
                submenuProps
            ],
            [
                (0, _dialog.OverlayTriggerStateContext),
                submenuTriggerState
            ],
            [
                (0, _popover.PopoverContext),
                {
                    ref: submenuRef,
                    trigger: "SubmenuTrigger",
                    triggerRef: ref,
                    placement: "end top",
                    UNSTABLE_portalContainer: popoverContext.UNSTABLE_portalContainer || undefined,
                    ...popoverProps
                }
            ]
        ]
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...(0, _reactAria.mergeProps)(menuItemProps, focusProps, hoverProps),
        ...renderProps,
        ref: ref,
        "data-disabled": states.isDisabled || undefined,
        "data-hovered": isHovered || undefined,
        "data-focused": states.isFocused || undefined,
        "data-focus-visible": isFocusVisible || undefined,
        "data-pressed": states.isPressed || undefined,
        "data-selected": states.isSelected || undefined,
        "data-selection-mode": state.selectionManager.selectionMode === "none" ? undefined : state.selectionManager.selectionMode,
        "data-has-submenu": true,
        "data-open": submenuTriggerState.isOpen || undefined
    }, renderProps.children), popover);
}

},{"react-aria":"e7jhe","./Collection":"lJDFi","react-stately":"ij62t","./utils":"iyTLn","@react-aria/utils":"9cLk5","./Header":"4dFe5","./Keyboard":"88PWd","./Dialog":"7F4Zw","./Popover":"Gl2h9","@react-aria/interactions":"ky3G8","react":"9yzVZ","@react-stately/menu":"iqDQI","./Separator":"fNEee","./Text":"iZUDL","@react-aria/menu":"89bvn","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"42SpS":[function(require,module,exports) {
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MeterContext", ()=>MeterContext);
parcelHelpers.export(exports, "Meter", ()=>_Meter);
var _reactAria = require("react-aria");
var _utils = require("@react-stately/utils");
var _utils1 = require("./utils");
var _label = require("./Label");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const MeterContext = /*#__PURE__*/ (0, _react.createContext)(null);
function Meter(props, ref) {
    [props, ref] = (0, _utils1.useContextProps)(props, ref, MeterContext);
    let { value = 0, minValue = 0, maxValue = 100 } = props;
    value = (0, _utils.clamp)(value, minValue, maxValue);
    let [labelRef, label] = (0, _utils1.useSlot)();
    let { meterProps, labelProps } = (0, _reactAria.useMeter)({
        ...props,
        label
    });
    // Calculate the width of the progress bar as a percentage
    let percentage = (value - minValue) / (maxValue - minValue) * 100;
    let renderProps = (0, _utils1.useRenderProps)({
        ...props,
        defaultClassName: "react-aria-Meter",
        values: {
            percentage,
            valueText: meterProps["aria-valuetext"]
        }
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...meterProps,
        ...renderProps,
        ref: ref,
        slot: props.slot || undefined
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _label.LabelContext).Provider, {
        value: {
            ...labelProps,
            ref: labelRef,
            elementType: "span"
        }
    }, renderProps.children));
}
/**
 * A meter represents a quantity within a known range, or a fractional value.
 */ const _Meter = /*#__PURE__*/ (0, _react.forwardRef)(Meter);

},{"react-aria":"e7jhe","@react-stately/utils":"cpDPf","./utils":"iyTLn","./Label":"jhkeS","react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"7M0RZ":[function(require,module,exports) {
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ModalContext", ()=>ModalContext);
parcelHelpers.export(exports, "Modal", ()=>_Modal);
parcelHelpers.export(exports, "ModalOverlay", ()=>ModalOverlay);
var _reactAria = require("react-aria");
var _utils = require("./utils");
var _utils1 = require("@react-aria/utils");
var _reactStately = require("react-stately");
var _dialog = require("./Dialog");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const ModalContext = /*#__PURE__*/ (0, _react.createContext)(null);
const InternalModalContext = /*#__PURE__*/ (0, _react.createContext)(null);
function Modal(props, ref) {
    let ctx = (0, _react.useContext)(InternalModalContext);
    if (ctx) return /*#__PURE__*/ (0, _reactDefault.default).createElement(ModalContent, {
        ...props,
        modalRef: ref
    }, props.children);
    let { isDismissable, isKeyboardDismissDisabled, isOpen, defaultOpen, onOpenChange, children, isEntering, isExiting, UNSTABLE_portalContainer, ...otherProps } = props;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(ModalOverlay, {
        isDismissable: isDismissable,
        isKeyboardDismissDisabled: isKeyboardDismissDisabled,
        isOpen: isOpen,
        defaultOpen: defaultOpen,
        onOpenChange: onOpenChange,
        isEntering: isEntering,
        isExiting: isExiting,
        UNSTABLE_portalContainer: UNSTABLE_portalContainer
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(ModalContent, {
        ...otherProps,
        modalRef: ref
    }, children));
}
/**
 * A modal is an overlay element which blocks interaction with elements outside it.
 */ const _Modal = /*#__PURE__*/ (0, _react.forwardRef)(Modal);
function ModalOverlayWithForwardRef(props, ref) {
    [props, ref] = (0, _utils.useContextProps)(props, ref, ModalContext);
    let contextState = (0, _react.useContext)((0, _dialog.OverlayTriggerStateContext));
    let localState = (0, _reactStately.useOverlayTriggerState)(props);
    let state = props.isOpen != null || props.defaultOpen != null || !contextState ? localState : contextState;
    let objectRef = (0, _utils1.useObjectRef)(ref);
    let modalRef = (0, _react.useRef)(null);
    let isOverlayExiting = (0, _utils.useExitAnimation)(objectRef, state.isOpen);
    let isModalExiting = (0, _utils.useExitAnimation)(modalRef, state.isOpen);
    let isExiting = isOverlayExiting || isModalExiting || props.isExiting || false;
    let isSSR = (0, _reactAria.useIsSSR)();
    if (!state.isOpen && !isExiting || isSSR) return null;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(ModalOverlayInner, {
        ...props,
        state: state,
        isExiting: isExiting,
        overlayRef: objectRef,
        modalRef: modalRef
    });
}
const ModalOverlay = /*#__PURE__*/ (0, _react.forwardRef)(ModalOverlayWithForwardRef);
function ModalOverlayInner({ UNSTABLE_portalContainer, ...props }) {
    let modalRef = props.modalRef;
    let { state } = props;
    let { modalProps, underlayProps } = (0, _reactAria.useModalOverlay)(props, state, modalRef);
    let entering = (0, _utils.useEnterAnimation)(props.overlayRef) || props.isEntering || false;
    let renderProps = (0, _utils.useRenderProps)({
        ...props,
        defaultClassName: "react-aria-ModalOverlay",
        values: {
            isEntering: entering,
            isExiting: props.isExiting,
            state
        }
    });
    let viewport = (0, _utils1.useViewportSize)();
    let style = {
        ...renderProps.style,
        "--visual-viewport-height": viewport.height + "px"
    };
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAria.Overlay), {
        isExiting: props.isExiting,
        portalContainer: UNSTABLE_portalContainer
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...(0, _utils1.mergeProps)((0, _utils1.filterDOMProps)(props), underlayProps),
        ...renderProps,
        style: style,
        ref: props.overlayRef,
        "data-entering": entering || undefined,
        "data-exiting": props.isExiting || undefined
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.Provider), {
        values: [
            [
                InternalModalContext,
                {
                    modalProps,
                    modalRef,
                    isExiting: props.isExiting,
                    isDismissable: props.isDismissable
                }
            ],
            [
                (0, _dialog.OverlayTriggerStateContext),
                state
            ]
        ]
    }, renderProps.children)));
}
function ModalContent(props) {
    let { modalProps, modalRef, isExiting, isDismissable } = (0, _react.useContext)(InternalModalContext);
    let state = (0, _react.useContext)((0, _dialog.OverlayTriggerStateContext));
    let mergedRefs = (0, _react.useMemo)(()=>(0, _utils1.mergeRefs)(props.modalRef, modalRef), [
        props.modalRef,
        modalRef
    ]);
    let ref = (0, _utils1.useObjectRef)(mergedRefs);
    let entering = (0, _utils.useEnterAnimation)(ref);
    let renderProps = (0, _utils.useRenderProps)({
        ...props,
        defaultClassName: "react-aria-Modal",
        values: {
            isEntering: entering,
            isExiting,
            state
        }
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...(0, _utils1.mergeProps)((0, _utils1.filterDOMProps)(props), modalProps),
        ...renderProps,
        ref: ref,
        "data-entering": entering || undefined,
        "data-exiting": isExiting || undefined
    }, isDismissable && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAria.DismissButton), {
        onDismiss: state.close
    }), renderProps.children);
}

},{"react-aria":"e7jhe","./utils":"iyTLn","@react-aria/utils":"9cLk5","react-stately":"ij62t","./Dialog":"7F4Zw","react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"1kIqx":[function(require,module,exports) {
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NumberFieldContext", ()=>NumberFieldContext);
parcelHelpers.export(exports, "NumberFieldStateContext", ()=>NumberFieldStateContext);
parcelHelpers.export(exports, "NumberField", ()=>_NumberField);
var _reactAria = require("react-aria");
var _button = require("./Button");
var _utils = require("./utils");
var _fieldError = require("./FieldError");
var _utils1 = require("@react-aria/utils");
var _group = require("./Group");
var _input = require("./Input");
var _label = require("./Label");
var _reactStately = require("react-stately");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _text = require("./Text");
const NumberFieldContext = /*#__PURE__*/ (0, _react.createContext)(null);
const NumberFieldStateContext = /*#__PURE__*/ (0, _react.createContext)(null);
function NumberField(props, ref) {
    [props, ref] = (0, _utils.useContextProps)(props, ref, NumberFieldContext);
    let { locale } = (0, _reactAria.useLocale)();
    var _props_validationBehavior;
    let state = (0, _reactStately.useNumberFieldState)({
        ...props,
        locale,
        validationBehavior: (_props_validationBehavior = props.validationBehavior) !== null && _props_validationBehavior !== void 0 ? _props_validationBehavior : "native"
    });
    let inputRef = (0, _react.useRef)(null);
    let [labelRef, label] = (0, _utils.useSlot)();
    var _props_validationBehavior1;
    let { labelProps, groupProps, inputProps, incrementButtonProps, decrementButtonProps, descriptionProps, errorMessageProps, ...validation } = (0, _reactAria.useNumberField)({
        ...(0, _utils.removeDataAttributes)(props),
        label,
        validationBehavior: (_props_validationBehavior1 = props.validationBehavior) !== null && _props_validationBehavior1 !== void 0 ? _props_validationBehavior1 : "native"
    }, state, inputRef);
    let renderProps = (0, _utils.useRenderProps)({
        ...props,
        values: {
            state,
            isDisabled: props.isDisabled || false,
            isInvalid: validation.isInvalid || false
        },
        defaultClassName: "react-aria-NumberField"
    });
    let DOMProps = (0, _utils1.filterDOMProps)(props);
    delete DOMProps.id;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.Provider), {
        values: [
            [
                NumberFieldStateContext,
                state
            ],
            [
                (0, _group.GroupContext),
                groupProps
            ],
            [
                (0, _input.InputContext),
                {
                    ...inputProps,
                    ref: inputRef
                }
            ],
            [
                (0, _label.LabelContext),
                {
                    ...labelProps,
                    ref: labelRef
                }
            ],
            [
                (0, _button.ButtonContext),
                {
                    slots: {
                        increment: incrementButtonProps,
                        decrement: decrementButtonProps
                    }
                }
            ],
            [
                (0, _text.TextContext),
                {
                    slots: {
                        description: descriptionProps,
                        errorMessage: errorMessageProps
                    }
                }
            ],
            [
                (0, _fieldError.FieldErrorContext),
                validation
            ]
        ]
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...DOMProps,
        ...renderProps,
        ref: ref,
        slot: props.slot || undefined,
        "data-disabled": props.isDisabled || undefined,
        "data-invalid": validation.isInvalid || undefined
    }), props.name && /*#__PURE__*/ (0, _reactDefault.default).createElement("input", {
        type: "hidden",
        name: props.name,
        value: isNaN(state.numberValue) ? "" : state.numberValue
    }));
}
/**
 * A number field allows a user to enter a number, and increment or decrement the value using stepper buttons.
 */ const _NumberField = /*#__PURE__*/ (0, _react.forwardRef)(NumberField);

},{"react-aria":"e7jhe","./Button":"9McZy","./utils":"iyTLn","./FieldError":"3acDn","@react-aria/utils":"9cLk5","./Group":"71duS","./Input":"3u8zn","./Label":"jhkeS","react-stately":"ij62t","react":"9yzVZ","./Text":"iZUDL","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"fRMDJ":[function(require,module,exports) {
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ProgressBarContext", ()=>ProgressBarContext);
parcelHelpers.export(exports, "ProgressBar", ()=>_ProgressBar);
var _reactAria = require("react-aria");
var _utils = require("@react-stately/utils");
var _utils1 = require("./utils");
var _label = require("./Label");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const ProgressBarContext = /*#__PURE__*/ (0, _react.createContext)(null);
function ProgressBar(props, ref) {
    [props, ref] = (0, _utils1.useContextProps)(props, ref, ProgressBarContext);
    let { value = 0, minValue = 0, maxValue = 100, isIndeterminate = false } = props;
    value = (0, _utils.clamp)(value, minValue, maxValue);
    let [labelRef, label] = (0, _utils1.useSlot)();
    let { progressBarProps, labelProps } = (0, _reactAria.useProgressBar)({
        ...props,
        label
    });
    // Calculate the width of the progress bar as a percentage
    let percentage = isIndeterminate ? undefined : (value - minValue) / (maxValue - minValue) * 100;
    let renderProps = (0, _utils1.useRenderProps)({
        ...props,
        defaultClassName: "react-aria-ProgressBar",
        values: {
            percentage,
            valueText: progressBarProps["aria-valuetext"],
            isIndeterminate
        }
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...progressBarProps,
        ...renderProps,
        ref: ref,
        slot: props.slot || undefined
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _label.LabelContext).Provider, {
        value: {
            ...labelProps,
            ref: labelRef,
            elementType: "span"
        }
    }, renderProps.children));
}
/**
 * Progress bars show either determinate or indeterminate progress of an operation
 * over time.
 */ const _ProgressBar = /*#__PURE__*/ (0, _react.forwardRef)(ProgressBar);

},{"react-aria":"e7jhe","@react-stately/utils":"cpDPf","./utils":"iyTLn","./Label":"jhkeS","react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"2g6k3":[function(require,module,exports) {
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RadioGroupContext", ()=>RadioGroupContext);
parcelHelpers.export(exports, "RadioContext", ()=>RadioContext);
parcelHelpers.export(exports, "RadioGroupStateContext", ()=>RadioGroupStateContext);
parcelHelpers.export(exports, "RadioGroup", ()=>_RadioGroup);
parcelHelpers.export(exports, "Radio", ()=>_Radio);
var _reactAria = require("react-aria");
var _utils = require("./utils");
var _fieldError = require("./FieldError");
var _utils1 = require("@react-aria/utils");
var _label = require("./Label");
var _reactStately = require("react-stately");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _text = require("./Text");
const RadioGroupContext = /*#__PURE__*/ (0, _react.createContext)(null);
const RadioContext = /*#__PURE__*/ (0, _react.createContext)(null);
const RadioGroupStateContext = /*#__PURE__*/ (0, _react.createContext)(null);
function RadioGroup(props, ref) {
    [props, ref] = (0, _utils.useContextProps)(props, ref, RadioGroupContext);
    var _props_validationBehavior;
    let state = (0, _reactStately.useRadioGroupState)({
        ...props,
        validationBehavior: (_props_validationBehavior = props.validationBehavior) !== null && _props_validationBehavior !== void 0 ? _props_validationBehavior : "native"
    });
    let [labelRef, label] = (0, _utils.useSlot)();
    var _props_validationBehavior1;
    let { radioGroupProps, labelProps, descriptionProps, errorMessageProps, ...validation } = (0, _reactAria.useRadioGroup)({
        ...props,
        label,
        validationBehavior: (_props_validationBehavior1 = props.validationBehavior) !== null && _props_validationBehavior1 !== void 0 ? _props_validationBehavior1 : "native"
    }, state);
    let renderProps = (0, _utils.useRenderProps)({
        ...props,
        values: {
            orientation: props.orientation || "vertical",
            isDisabled: state.isDisabled,
            isReadOnly: state.isReadOnly,
            isRequired: state.isRequired,
            isInvalid: state.isInvalid,
            state
        },
        defaultClassName: "react-aria-RadioGroup"
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...radioGroupProps,
        ...renderProps,
        ref: ref,
        slot: props.slot || undefined,
        "data-orientation": props.orientation || "vertical",
        "data-invalid": state.isInvalid || undefined,
        "data-disabled": state.isDisabled || undefined,
        "data-readonly": state.isReadOnly || undefined,
        "data-required": state.isRequired || undefined
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.Provider), {
        values: [
            [
                RadioGroupStateContext,
                state
            ],
            [
                (0, _label.LabelContext),
                {
                    ...labelProps,
                    ref: labelRef,
                    elementType: "span"
                }
            ],
            [
                (0, _text.TextContext),
                {
                    slots: {
                        description: descriptionProps,
                        errorMessage: errorMessageProps
                    }
                }
            ],
            [
                (0, _fieldError.FieldErrorContext),
                validation
            ]
        ]
    }, renderProps.children));
}
function Radio(props, ref) {
    [props, ref] = (0, _utils.useContextProps)(props, ref, RadioContext);
    let state = (0, _reactDefault.default).useContext(RadioGroupStateContext);
    let inputRef = (0, _react.useRef)(null);
    let { labelProps, inputProps, isSelected, isDisabled, isPressed } = (0, _reactAria.useRadio)({
        ...(0, _utils.removeDataAttributes)(props),
        // ReactNode type doesn't allow function children.
        children: typeof props.children === "function" ? true : props.children
    }, state, inputRef);
    let { isFocused, isFocusVisible, focusProps } = (0, _reactAria.useFocusRing)();
    let interactionDisabled = isDisabled || state.isReadOnly;
    let { hoverProps, isHovered } = (0, _reactAria.useHover)({
        ...props,
        isDisabled: interactionDisabled
    });
    let renderProps = (0, _utils.useRenderProps)({
        ...props,
        defaultClassName: "react-aria-Radio",
        values: {
            isSelected,
            isPressed,
            isHovered,
            isFocused,
            isFocusVisible,
            isDisabled,
            isReadOnly: state.isReadOnly,
            isInvalid: state.isInvalid,
            isRequired: state.isRequired
        }
    });
    let DOMProps = (0, _utils1.filterDOMProps)(props);
    delete DOMProps.id;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("label", {
        ...(0, _utils1.mergeProps)(DOMProps, labelProps, hoverProps, renderProps),
        ref: ref,
        "data-selected": isSelected || undefined,
        "data-pressed": isPressed || undefined,
        "data-hovered": isHovered || undefined,
        "data-focused": isFocused || undefined,
        "data-focus-visible": isFocusVisible || undefined,
        "data-disabled": isDisabled || undefined,
        "data-readonly": state.isReadOnly || undefined,
        "data-invalid": state.isInvalid || undefined,
        "data-required": state.isRequired || undefined
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAria.VisuallyHidden), {
        elementType: "span"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("input", {
        ...(0, _utils1.mergeProps)(inputProps, focusProps),
        ref: inputRef
    })), renderProps.children);
}
/**
 * A radio group allows a user to select a single item from a list of mutually exclusive options.
 */ const _RadioGroup = /*#__PURE__*/ (0, _react.forwardRef)(RadioGroup);
/**
 * A radio represents an individual option within a radio group.
 */ const _Radio = /*#__PURE__*/ (0, _react.forwardRef)(Radio);

},{"react-aria":"e7jhe","./utils":"iyTLn","./FieldError":"3acDn","@react-aria/utils":"9cLk5","./Label":"jhkeS","react-stately":"ij62t","react":"9yzVZ","./Text":"iZUDL","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"jgpuY":[function(require,module,exports) {
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SearchFieldContext", ()=>SearchFieldContext);
parcelHelpers.export(exports, "SearchField", ()=>_SearchField);
var _reactAria = require("react-aria");
var _button = require("./Button");
var _utils = require("./utils");
var _fieldError = require("./FieldError");
var _utils1 = require("@react-aria/utils");
var _group = require("./Group");
var _input = require("./Input");
var _label = require("./Label");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactStately = require("react-stately");
var _text = require("./Text");
const SearchFieldContext = /*#__PURE__*/ (0, _react.createContext)(null);
function SearchField(props, ref) {
    [props, ref] = (0, _utils.useContextProps)(props, ref, SearchFieldContext);
    let inputRef = (0, _react.useRef)(null);
    let [labelRef, label] = (0, _utils.useSlot)();
    var _props_validationBehavior;
    let state = (0, _reactStately.useSearchFieldState)({
        ...props,
        validationBehavior: (_props_validationBehavior = props.validationBehavior) !== null && _props_validationBehavior !== void 0 ? _props_validationBehavior : "native"
    });
    var _props_validationBehavior1;
    let { labelProps, inputProps, clearButtonProps, descriptionProps, errorMessageProps, ...validation } = (0, _reactAria.useSearchField)({
        ...(0, _utils.removeDataAttributes)(props),
        label,
        validationBehavior: (_props_validationBehavior1 = props.validationBehavior) !== null && _props_validationBehavior1 !== void 0 ? _props_validationBehavior1 : "native"
    }, state, inputRef);
    let renderProps = (0, _utils.useRenderProps)({
        ...props,
        values: {
            isEmpty: state.value === "",
            isDisabled: props.isDisabled || false,
            isInvalid: validation.isInvalid || false,
            state
        },
        defaultClassName: "react-aria-SearchField"
    });
    let DOMProps = (0, _utils1.filterDOMProps)(props);
    delete DOMProps.id;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...DOMProps,
        ...renderProps,
        ref: ref,
        slot: props.slot || undefined,
        "data-empty": state.value === "" || undefined,
        "data-disabled": props.isDisabled || undefined,
        "data-invalid": validation.isInvalid || undefined
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.Provider), {
        values: [
            [
                (0, _label.LabelContext),
                {
                    ...labelProps,
                    ref: labelRef
                }
            ],
            [
                (0, _input.InputContext),
                {
                    ...inputProps,
                    ref: inputRef
                }
            ],
            [
                (0, _button.ButtonContext),
                clearButtonProps
            ],
            [
                (0, _text.TextContext),
                {
                    slots: {
                        description: descriptionProps,
                        errorMessage: errorMessageProps
                    }
                }
            ],
            [
                (0, _group.GroupContext),
                {
                    isInvalid: validation.isInvalid,
                    isDisabled: props.isDisabled || false
                }
            ],
            [
                (0, _fieldError.FieldErrorContext),
                validation
            ]
        ]
    }, renderProps.children));
}
/**
 * A search field allows a user to enter and clear a search query.
 */ const _SearchField = /*#__PURE__*/ (0, _react.forwardRef)(SearchField);

},{"react-aria":"e7jhe","./Button":"9McZy","./utils":"iyTLn","./FieldError":"3acDn","@react-aria/utils":"9cLk5","./Group":"71duS","./Input":"3u8zn","./Label":"jhkeS","react":"9yzVZ","react-stately":"ij62t","./Text":"iZUDL","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"jbClj":[function(require,module,exports) {
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SelectContext", ()=>SelectContext);
parcelHelpers.export(exports, "SelectStateContext", ()=>SelectStateContext);
parcelHelpers.export(exports, "Select", ()=>_Select);
parcelHelpers.export(exports, "SelectValueContext", ()=>SelectValueContext);
parcelHelpers.export(exports, "SelectValue", ()=>_SelectValue);
var _reactAria = require("react-aria");
var _button = require("./Button");
var _collection = require("./Collection");
var _utils = require("./utils");
var _fieldError = require("./FieldError");
var _utils1 = require("@react-aria/utils");
// @ts-ignore
var _json = require("../intl/*.json");
var _jsonDefault = parcelHelpers.interopDefault(_json);
var _label = require("./Label");
var _listBox = require("./ListBox");
var _dialog = require("./Dialog");
var _popover = require("./Popover");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactStately = require("react-stately");
var _text = require("./Text");
const SelectContext = /*#__PURE__*/ (0, _react.createContext)(null);
const SelectStateContext = /*#__PURE__*/ (0, _react.createContext)(null);
function Select(props, ref) {
    [props, ref] = (0, _utils.useContextProps)(props, ref, SelectContext);
    let { collection, document } = (0, _collection.useCollectionDocument)();
    var _props_validationBehavior;
    let state = (0, _reactStately.useSelectState)({
        ...props,
        collection,
        children: undefined,
        validationBehavior: (_props_validationBehavior = props.validationBehavior) !== null && _props_validationBehavior !== void 0 ? _props_validationBehavior : "native"
    });
    let { isFocusVisible, focusProps } = (0, _reactAria.useFocusRing)({
        within: true
    });
    // Get props for child elements from useSelect
    let buttonRef = (0, _react.useRef)(null);
    let [labelRef, label] = (0, _utils.useSlot)();
    var _props_validationBehavior1;
    let { labelProps, triggerProps, valueProps, menuProps, descriptionProps, errorMessageProps, ...validation } = (0, _reactAria.useSelect)({
        ...(0, _utils.removeDataAttributes)(props),
        label,
        validationBehavior: (_props_validationBehavior1 = props.validationBehavior) !== null && _props_validationBehavior1 !== void 0 ? _props_validationBehavior1 : "native"
    }, state, buttonRef);
    // Make menu width match input + button
    let [buttonWidth, setButtonWidth] = (0, _react.useState)(null);
    let onResize = (0, _react.useCallback)(()=>{
        if (buttonRef.current) setButtonWidth(buttonRef.current.offsetWidth + "px");
    }, [
        buttonRef
    ]);
    (0, _utils1.useResizeObserver)({
        ref: buttonRef,
        onResize: onResize
    });
    // Only expose a subset of state to renderProps function to avoid infinite render loop
    let renderPropsState = (0, _react.useMemo)(()=>({
            isOpen: state.isOpen,
            isFocused: state.isFocused,
            isFocusVisible,
            isDisabled: props.isDisabled || false,
            isInvalid: validation.isInvalid || false,
            isRequired: props.isRequired || false
        }), [
        state.isOpen,
        state.isFocused,
        isFocusVisible,
        props.isDisabled,
        validation.isInvalid,
        props.isRequired
    ]);
    let renderProps = (0, _utils.useRenderProps)({
        ...props,
        values: renderPropsState,
        defaultClassName: "react-aria-Select"
    });
    let DOMProps = (0, _utils1.filterDOMProps)(props);
    delete DOMProps.id;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.Hidden), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.Provider), {
        values: [
            [
                SelectContext,
                props
            ],
            [
                SelectStateContext,
                state
            ],
            [
                (0, _collection.CollectionDocumentContext),
                document
            ]
        ]
    }, renderProps.children)), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.Provider), {
        values: [
            [
                SelectContext,
                props
            ],
            [
                SelectStateContext,
                state
            ],
            [
                SelectValueContext,
                valueProps
            ],
            [
                (0, _label.LabelContext),
                {
                    ...labelProps,
                    ref: labelRef,
                    elementType: "span"
                }
            ],
            [
                (0, _button.ButtonContext),
                {
                    ...triggerProps,
                    ref: buttonRef,
                    isPressed: state.isOpen
                }
            ],
            [
                (0, _dialog.OverlayTriggerStateContext),
                state
            ],
            [
                (0, _popover.PopoverContext),
                {
                    trigger: "Select",
                    triggerRef: buttonRef,
                    placement: "bottom start",
                    style: {
                        "--trigger-width": buttonWidth
                    }
                }
            ],
            [
                (0, _listBox.ListBoxContext),
                menuProps
            ],
            [
                (0, _listBox.ListStateContext),
                state
            ],
            [
                (0, _text.TextContext),
                {
                    slots: {
                        description: descriptionProps,
                        errorMessage: errorMessageProps
                    }
                }
            ],
            [
                (0, _fieldError.FieldErrorContext),
                validation
            ]
        ]
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...DOMProps,
        ...renderProps,
        ...focusProps,
        ref: ref,
        slot: props.slot || undefined,
        "data-focused": state.isFocused || undefined,
        "data-focus-visible": isFocusVisible || undefined,
        "data-open": state.isOpen || undefined,
        "data-disabled": props.isDisabled || undefined,
        "data-invalid": validation.isInvalid || undefined,
        "data-required": props.isRequired || undefined
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAria.HiddenSelect), {
        state: state,
        triggerRef: buttonRef,
        label: label,
        name: props.name,
        isDisabled: props.isDisabled
    })));
}
/**
 * A select displays a collapsible list of options and allows a user to select one of them.
 */ const _Select = /*#__PURE__*/ (0, _react.forwardRef)(Select);
const SelectValueContext = /*#__PURE__*/ (0, _react.createContext)(null);
function SelectValue(props, ref) {
    var _state_selectedItem, _state_selectedItem1;
    [props, ref] = (0, _utils.useContextProps)(props, ref, SelectValueContext);
    let state = (0, _react.useContext)(SelectStateContext);
    let { placeholder } = (0, _utils.useSlottedContext)(SelectContext);
    let selectedItem = state.selectedKey != null ? state.collection.getItem(state.selectedKey) : null;
    let rendered = selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.rendered;
    if (typeof rendered === "function") {
        // If the selected item has a function as a child, we need to call it to render to React.JSX.
        let fn = rendered;
        rendered = fn({
            isHovered: false,
            isPressed: false,
            isSelected: false,
            isFocused: false,
            isFocusVisible: false,
            isDisabled: false,
            selectionMode: "single",
            selectionBehavior: "toggle"
        });
    }
    let stringFormatter = (0, _reactAria.useLocalizedStringFormatter)((0, _jsonDefault.default), "react-aria-components");
    var _state_selectedItem_value, _state_selectedItem_textValue;
    let renderProps = (0, _utils.useRenderProps)({
        ...props,
        defaultChildren: rendered || placeholder || stringFormatter.format("selectPlaceholder"),
        defaultClassName: "react-aria-SelectValue",
        values: {
            selectedItem: (_state_selectedItem_value = (_state_selectedItem = state.selectedItem) === null || _state_selectedItem === void 0 ? void 0 : _state_selectedItem.value) !== null && _state_selectedItem_value !== void 0 ? _state_selectedItem_value : null,
            selectedText: (_state_selectedItem_textValue = (_state_selectedItem1 = state.selectedItem) === null || _state_selectedItem1 === void 0 ? void 0 : _state_selectedItem1.textValue) !== null && _state_selectedItem_textValue !== void 0 ? _state_selectedItem_textValue : null,
            isPlaceholder: !selectedItem
        }
    });
    let DOMProps = (0, _utils1.filterDOMProps)(props);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        ref: ref,
        ...DOMProps,
        ...renderProps,
        "data-placeholder": !selectedItem || undefined
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.TextContext).Provider, {
        value: undefined
    }, renderProps.children));
}
/**
 * SelectValue renders the current value of a Select, or a placeholder if no value is selected.
 * It is usually placed within the button element.
 */ const _SelectValue = /*#__PURE__*/ (0, _react.forwardRef)(SelectValue);

},{"react-aria":"e7jhe","./Button":"9McZy","./Collection":"lJDFi","./utils":"iyTLn","./FieldError":"3acDn","@react-aria/utils":"9cLk5","../intl/*.json":"cQFjh","./Label":"jhkeS","./ListBox":"katmG","./Dialog":"7F4Zw","./Popover":"Gl2h9","react":"9yzVZ","react-stately":"ij62t","./Text":"iZUDL","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"l17Cl":[function(require,module,exports) {
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SliderContext", ()=>SliderContext);
parcelHelpers.export(exports, "SliderStateContext", ()=>SliderStateContext);
parcelHelpers.export(exports, "SliderTrackContext", ()=>SliderTrackContext);
parcelHelpers.export(exports, "SliderOutputContext", ()=>SliderOutputContext);
parcelHelpers.export(exports, "Slider", ()=>_Slider);
parcelHelpers.export(exports, "SliderOutput", ()=>_SliderOutput);
parcelHelpers.export(exports, "SliderTrack", ()=>_SliderTrack);
parcelHelpers.export(exports, "SliderThumb", ()=>_SliderThumb);
var _reactAria = require("react-aria");
var _utils = require("./utils");
var _utils1 = require("@react-aria/utils");
var _label = require("./Label");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactStately = require("react-stately");
const SliderContext = /*#__PURE__*/ (0, _react.createContext)(null);
const SliderStateContext = /*#__PURE__*/ (0, _react.createContext)(null);
const SliderTrackContext = /*#__PURE__*/ (0, _react.createContext)(null);
const SliderOutputContext = /*#__PURE__*/ (0, _react.createContext)(null);
function Slider(props, ref) {
    [props, ref] = (0, _utils.useContextProps)(props, ref, SliderContext);
    let trackRef = (0, _react.useRef)(null);
    let numberFormatter = (0, _reactAria.useNumberFormatter)(props.formatOptions);
    let state = (0, _reactStately.useSliderState)({
        ...props,
        numberFormatter
    });
    let [labelRef, label] = (0, _utils.useSlot)();
    let { groupProps, trackProps, labelProps, outputProps } = (0, _reactAria.useSlider)({
        ...props,
        label
    }, state, trackRef);
    let renderProps = (0, _utils.useRenderProps)({
        ...props,
        values: {
            orientation: state.orientation,
            isDisabled: state.isDisabled,
            state
        },
        defaultClassName: "react-aria-Slider"
    });
    let DOMProps = (0, _utils1.filterDOMProps)(props);
    delete DOMProps.id;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.Provider), {
        values: [
            [
                SliderStateContext,
                state
            ],
            [
                SliderTrackContext,
                {
                    ...trackProps,
                    ref: trackRef
                }
            ],
            [
                SliderOutputContext,
                outputProps
            ],
            [
                (0, _label.LabelContext),
                {
                    ...labelProps,
                    ref: labelRef
                }
            ]
        ]
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...DOMProps,
        ...groupProps,
        ...renderProps,
        ref: ref,
        slot: props.slot || undefined,
        "data-orientation": state.orientation,
        "data-disabled": state.isDisabled || undefined
    }));
}
/**
 * A slider allows a user to select one or more values within a range.
 */ const _Slider = /*#__PURE__*/ (0, _react.forwardRef)(Slider);
function SliderOutput(props, ref) {
    [props, ref] = (0, _utils.useContextProps)(props, ref, SliderOutputContext);
    let { children, style, className, ...otherProps } = props;
    let state = (0, _react.useContext)(SliderStateContext);
    let renderProps = (0, _utils.useRenderProps)({
        className,
        style,
        children,
        defaultChildren: state.getThumbValueLabel(0),
        defaultClassName: "react-aria-SliderOutput",
        values: {
            orientation: state.orientation,
            isDisabled: state.isDisabled,
            state
        }
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("output", {
        ...otherProps,
        ...renderProps,
        ref: ref,
        "data-orientation": state.orientation || undefined,
        "data-disabled": state.isDisabled || undefined
    });
}
/**
 * A slider output displays the current value of a slider as text.
 */ const _SliderOutput = /*#__PURE__*/ (0, _react.forwardRef)(SliderOutput);
function SliderTrack(props, ref) {
    [props, ref] = (0, _utils.useContextProps)(props, ref, SliderTrackContext);
    let state = (0, _react.useContext)(SliderStateContext);
    let { onHoverStart, onHoverEnd, onHoverChange, ...otherProps } = props;
    let { hoverProps, isHovered } = (0, _reactAria.useHover)({
        onHoverStart,
        onHoverEnd,
        onHoverChange
    });
    let renderProps = (0, _utils.useRenderProps)({
        ...props,
        defaultClassName: "react-aria-SliderTrack",
        values: {
            orientation: state.orientation,
            isDisabled: state.isDisabled,
            isHovered,
            state
        }
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...(0, _reactAria.mergeProps)(otherProps, hoverProps),
        ...renderProps,
        ref: ref,
        "data-hovered": isHovered || undefined,
        "data-orientation": state.orientation || undefined,
        "data-disabled": state.isDisabled || undefined
    });
}
/**
 * A slider track is a container for one or more slider thumbs.
 */ const _SliderTrack = /*#__PURE__*/ (0, _react.forwardRef)(SliderTrack);
function SliderThumb(props, ref) {
    let state = (0, _react.useContext)(SliderStateContext);
    let { ref: trackRef } = (0, _utils.useSlottedContext)(SliderTrackContext);
    let { index = 0 } = props;
    let inputRef = (0, _react.useRef)(null);
    let [labelRef, label] = (0, _utils.useSlot)();
    let { thumbProps, inputProps, labelProps, isDragging, isFocused, isDisabled } = (0, _reactAria.useSliderThumb)({
        ...props,
        index,
        trackRef: trackRef,
        inputRef,
        label
    }, state);
    let { focusProps, isFocusVisible } = (0, _reactAria.useFocusRing)();
    let { hoverProps, isHovered } = (0, _reactAria.useHover)(props);
    let renderProps = (0, _utils.useRenderProps)({
        ...props,
        defaultClassName: "react-aria-SliderThumb",
        values: {
            state,
            isHovered,
            isDragging,
            isFocused,
            isFocusVisible,
            isDisabled
        }
    });
    let DOMProps = (0, _utils1.filterDOMProps)(props);
    delete DOMProps.id;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...(0, _reactAria.mergeProps)(DOMProps, thumbProps, hoverProps),
        ...renderProps,
        ref: ref,
        style: {
            ...thumbProps.style,
            ...renderProps.style
        },
        "data-hovered": isHovered || undefined,
        "data-dragging": isDragging || undefined,
        "data-focused": isFocused || undefined,
        "data-focus-visible": isFocusVisible || undefined,
        "data-disabled": isDisabled || undefined
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAria.VisuallyHidden), null, /*#__PURE__*/ (0, _reactDefault.default).createElement("input", {
        ref: inputRef,
        ...(0, _reactAria.mergeProps)(inputProps, focusProps)
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.Provider), {
        values: [
            [
                (0, _label.LabelContext),
                {
                    ...labelProps,
                    ref: labelRef
                }
            ]
        ]
    }, renderProps.children));
}
/**
 * A slider thumb represents an individual value that the user can adjust within a slider track.
 */ const _SliderThumb = /*#__PURE__*/ (0, _react.forwardRef)(SliderThumb);

},{"react-aria":"e7jhe","./utils":"iyTLn","@react-aria/utils":"9cLk5","./Label":"jhkeS","react":"9yzVZ","react-stately":"ij62t","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"2EleS":[function(require,module,exports) {
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SwitchContext", ()=>SwitchContext);
parcelHelpers.export(exports, "Switch", ()=>_Switch);
var _reactAria = require("react-aria");
var _utils = require("./utils");
var _utils1 = require("@react-aria/utils");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactStately = require("react-stately");
const SwitchContext = /*#__PURE__*/ (0, _react.createContext)(null);
function Switch(props, ref) {
    [props, ref] = (0, _utils.useContextProps)(props, ref, SwitchContext);
    let inputRef = (0, _react.useRef)(null);
    let state = (0, _reactStately.useToggleState)(props);
    let { labelProps, inputProps, isSelected, isDisabled, isReadOnly, isPressed } = (0, _reactAria.useSwitch)({
        ...(0, _utils.removeDataAttributes)(props),
        // ReactNode type doesn't allow function children.
        children: typeof props.children === "function" ? true : props.children
    }, state, inputRef);
    let { isFocused, isFocusVisible, focusProps } = (0, _reactAria.useFocusRing)();
    let isInteractionDisabled = props.isDisabled || props.isReadOnly;
    let { hoverProps, isHovered } = (0, _reactAria.useHover)({
        ...props,
        isDisabled: isInteractionDisabled
    });
    let renderProps = (0, _utils.useRenderProps)({
        ...props,
        defaultClassName: "react-aria-Switch",
        values: {
            isSelected,
            isPressed,
            isHovered,
            isFocused,
            isFocusVisible,
            isDisabled,
            isReadOnly,
            state
        }
    });
    let DOMProps = (0, _utils1.filterDOMProps)(props);
    delete DOMProps.id;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("label", {
        ...(0, _reactAria.mergeProps)(DOMProps, labelProps, hoverProps, renderProps),
        ref: ref,
        slot: props.slot || undefined,
        "data-selected": isSelected || undefined,
        "data-pressed": isPressed || undefined,
        "data-hovered": isHovered || undefined,
        "data-focused": isFocused || undefined,
        "data-focus-visible": isFocusVisible || undefined,
        "data-disabled": isDisabled || undefined,
        "data-readonly": isReadOnly || undefined
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAria.VisuallyHidden), {
        elementType: "span"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("input", {
        ...(0, _reactAria.mergeProps)(inputProps, focusProps),
        ref: inputRef
    })), renderProps.children);
}
/**
 * A switch allows a user to turn a setting on or off.
 */ const _Switch = /*#__PURE__*/ (0, _react.forwardRef)(Switch);

},{"react-aria":"e7jhe","./utils":"iyTLn","@react-aria/utils":"9cLk5","react":"9yzVZ","react-stately":"ij62t","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"CNMZ9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ResizableTableContainer", ()=>_ResizableTableContainer);
parcelHelpers.export(exports, "TableContext", ()=>TableContext);
parcelHelpers.export(exports, "TableStateContext", ()=>TableStateContext);
parcelHelpers.export(exports, "TableColumnResizeStateContext", ()=>TableColumnResizeStateContext);
parcelHelpers.export(exports, "Table", ()=>_Table);
/**
 * Returns options from the parent `<Table>` component.
 */ parcelHelpers.export(exports, "useTableOptions", ()=>useTableOptions);
parcelHelpers.export(exports, "TableHeader", ()=>_TableHeader);
parcelHelpers.export(exports, "Column", ()=>_Column);
parcelHelpers.export(exports, "TableBody", ()=>_TableBody);
parcelHelpers.export(exports, "Row", ()=>_Row);
parcelHelpers.export(exports, "Cell", ()=>_Cell);
parcelHelpers.export(exports, "ColumnResizer", ()=>_ColumnResizer);
var _collection = require("./Collection");
var _table = require("@react-stately/table");
var _button = require("./Button");
var _checkbox = require("./Checkbox");
var _utils = require("./utils");
var _reactStately = require("react-stately");
var _useDragAndDrop = require("./useDragAndDrop");
var _reactAria = require("react-aria");
var _utils1 = require("@react-aria/utils");
// @ts-ignore
var _json = require("../intl/*.json");
var _jsonDefault = parcelHelpers.interopDefault(_json);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactDom = require("react-dom");
var _reactDomDefault = parcelHelpers.interopDefault(_reactDom);
class TableCollection extends (0, _collection.BaseCollection) {
    addNode(node) {
        super.addNode(node);
        this.columnsDirty || (this.columnsDirty = node.type === "column");
        if (node.type === "tableheader") this.head = node;
        if (node.type === "tablebody") this.body = node;
    }
    commit(firstKey, lastKey, isSSR = false) {
        this.updateColumns(isSSR);
        super.commit(firstKey, lastKey, isSSR);
    }
    updateColumns(isSSR) {
        if (!this.columnsDirty) return;
        this.rowHeaderColumnKeys = new Set();
        this.columns = [];
        let columnKeyMap = new Map();
        let visit = (node)=>{
            switch(node.type){
                case "column":
                    columnKeyMap.set(node.key, node);
                    if (!node.hasChildNodes) {
                        node.index = this.columns.length;
                        this.columns.push(node);
                        if (node.props.isRowHeader) this.rowHeaderColumnKeys.add(node.key);
                    }
                    break;
            }
            for (let child of this.getChildren(node.key))visit(child);
        };
        for (let node of this.getChildren(this.head.key))visit(node);
        this.headerRows = (0, _table.buildHeaderRows)(columnKeyMap, this.columns);
        this.columnsDirty = false;
        if (this.rowHeaderColumnKeys.size === 0 && this.columns.length > 0 && !isSSR) throw new Error("A table must have at least one Column with the isRowHeader prop set to true");
    }
    get columnCount() {
        return this.columns.length;
    }
    get rows() {
        return [
            ...this.getChildren(this.body.key)
        ];
    }
    *[Symbol.iterator]() {
        yield* this.getChildren(this.body.key);
    }
    get size() {
        return [
            ...this.getChildren(this.body.key)
        ].length;
    }
    getFirstKey() {
        var _;
        return (_ = [
            ...this.getChildren(this.body.key)
        ][0]) === null || _ === void 0 ? void 0 : _.key;
    }
    getLastKey() {
        var _rows_;
        let rows = [
            ...this.getChildren(this.body.key)
        ];
        return (_rows_ = rows[rows.length - 1]) === null || _rows_ === void 0 ? void 0 : _rows_.key;
    }
    getKeyAfter(key) {
        let node = this.getItem(key);
        var _node_nextKey;
        if ((node === null || node === void 0 ? void 0 : node.type) === "column") return (_node_nextKey = node.nextKey) !== null && _node_nextKey !== void 0 ? _node_nextKey : null;
        return super.getKeyAfter(key);
    }
    getKeyBefore(key) {
        var _this_getItem;
        let node = this.getItem(key);
        var _node_prevKey;
        if ((node === null || node === void 0 ? void 0 : node.type) === "column") return (_node_prevKey = node.prevKey) !== null && _node_prevKey !== void 0 ? _node_prevKey : null;
        let k = super.getKeyBefore(key);
        if (k != null && ((_this_getItem = this.getItem(k)) === null || _this_getItem === void 0 ? void 0 : _this_getItem.type) === "tablebody") return null;
        return k;
    }
    getChildren(key) {
        if (!this.getItem(key)) for (let row of this.headerRows){
            if (row.key === key) return row.childNodes;
        }
        return super.getChildren(key);
    }
    clone() {
        let collection = super.clone();
        collection.headerRows = this.headerRows;
        collection.columns = this.columns;
        collection.rowHeaderColumnKeys = this.rowHeaderColumnKeys;
        collection.head = this.head;
        collection.body = this.body;
        return collection;
    }
    getTextValue(key) {
        let row = this.getItem(key);
        if (!row) return "";
        // If the row has a textValue, use that.
        if (row.textValue) return row.textValue;
        // Otherwise combine the text of each of the row header columns.
        let rowHeaderColumnKeys = this.rowHeaderColumnKeys;
        let text = [];
        for (let cell of this.getChildren(key)){
            let column = this.columns[cell.index];
            if (rowHeaderColumnKeys.has(column.key) && cell.textValue) text.push(cell.textValue);
            if (text.length === rowHeaderColumnKeys.size) break;
        }
        return text.join(" ");
    }
    constructor(...args){
        super(...args);
        this.headerRows = [];
        this.columns = [];
        this.rowHeaderColumnKeys = new Set();
        this.head = new (0, _collection.NodeValue)("tableheader", -1);
        this.body = new (0, _collection.NodeValue)("tablebody", -2);
        this.columnsDirty = true;
    }
}
const ResizableTableContainerContext = /*#__PURE__*/ (0, _react.createContext)(null);
function ResizableTableContainer(props, ref) {
    let objectRef = (0, _utils1.useObjectRef)(ref);
    let [width, setWidth] = (0, _react.useState)(0);
    (0, _utils1.useResizeObserver)({
        ref: objectRef,
        onResize () {
            var _objectRef_current;
            var _objectRef_current_clientWidth;
            setWidth((_objectRef_current_clientWidth = (_objectRef_current = objectRef.current) === null || _objectRef_current === void 0 ? void 0 : _objectRef_current.clientWidth) !== null && _objectRef_current_clientWidth !== void 0 ? _objectRef_current_clientWidth : 0);
        }
    });
    (0, _utils1.useLayoutEffect)(()=>{
        var _objectRef_current;
        var _objectRef_current_clientWidth;
        setWidth((_objectRef_current_clientWidth = (_objectRef_current = objectRef.current) === null || _objectRef_current === void 0 ? void 0 : _objectRef_current.clientWidth) !== null && _objectRef_current_clientWidth !== void 0 ? _objectRef_current_clientWidth : 0);
    }, [
        objectRef
    ]);
    let ctx = (0, _react.useMemo)(()=>({
            tableWidth: width,
            useTableColumnResizeState: (0, _reactStately.useTableColumnResizeState),
            onResizeStart: props.onResizeStart,
            onResize: props.onResize,
            onResizeEnd: props.onResizeEnd
        }), [
        width,
        props.onResizeStart,
        props.onResize,
        props.onResizeEnd
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...(0, _utils1.filterDOMProps)(props),
        ref: objectRef,
        className: props.className || "react-aria-ResizableTableContainer",
        style: props.style,
        onScroll: props.onScroll
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(ResizableTableContainerContext.Provider, {
        value: ctx
    }, props.children));
}
const _ResizableTableContainer = /*#__PURE__*/ (0, _react.forwardRef)(ResizableTableContainer);
const TableContext = /*#__PURE__*/ (0, _react.createContext)(null);
const TableStateContext = /*#__PURE__*/ (0, _react.createContext)(null);
const TableColumnResizeStateContext = /*#__PURE__*/ (0, _react.createContext)(null);
function Table(props, ref) {
    [props, ref] = (0, _utils.useContextProps)(props, ref, TableContext);
    let initialCollection = (0, _react.useMemo)(()=>new TableCollection(), []);
    let { portal, collection } = (0, _collection.useCollection)(props, initialCollection);
    let state = (0, _reactStately.useTableState)({
        ...props,
        collection,
        children: undefined
    });
    let { gridProps } = (0, _reactAria.useTable)(props, state, ref);
    let { dragAndDropHooks } = props;
    let selectionManager = state.selectionManager;
    let isListDraggable = !!(dragAndDropHooks === null || dragAndDropHooks === void 0 ? void 0 : dragAndDropHooks.useDraggableCollectionState);
    let isListDroppable = !!(dragAndDropHooks === null || dragAndDropHooks === void 0 ? void 0 : dragAndDropHooks.useDroppableCollectionState);
    let dragHooksProvided = (0, _react.useRef)(isListDraggable);
    let dropHooksProvided = (0, _react.useRef)(isListDroppable);
    (0, _react.useEffect)(()=>{
        if (dragHooksProvided.current !== isListDraggable) console.warn("Drag hooks were provided during one render, but not another. This should be avoided as it may produce unexpected behavior.");
        if (dropHooksProvided.current !== isListDroppable) console.warn("Drop hooks were provided during one render, but not another. This should be avoided as it may produce unexpected behavior.");
    }, [
        isListDraggable,
        isListDroppable
    ]);
    let dragState = undefined;
    let dropState = undefined;
    let droppableCollection = undefined;
    let isRootDropTarget = false;
    let dragPreview = null;
    let preview = (0, _react.useRef)(null);
    if (isListDraggable && dragAndDropHooks) {
        dragState = dragAndDropHooks.useDraggableCollectionState({
            collection,
            selectionManager,
            preview: dragAndDropHooks.renderDragPreview ? preview : undefined
        });
        dragAndDropHooks.useDraggableCollection({}, dragState, ref);
        let DragPreview = dragAndDropHooks.DragPreview;
        dragPreview = dragAndDropHooks.renderDragPreview ? /*#__PURE__*/ (0, _reactDefault.default).createElement(DragPreview, {
            ref: preview
        }, dragAndDropHooks.renderDragPreview) : null;
    }
    if (isListDroppable && dragAndDropHooks) {
        dropState = dragAndDropHooks.useDroppableCollectionState({
            collection,
            selectionManager
        });
        let keyboardDelegate = new (0, _reactAria.ListKeyboardDelegate)(collection, selectionManager.disabledBehavior === "selection" ? new Set() : selectionManager.disabledKeys, ref);
        let dropTargetDelegate = dragAndDropHooks.dropTargetDelegate || new dragAndDropHooks.ListDropTargetDelegate(collection, ref);
        droppableCollection = dragAndDropHooks.useDroppableCollection({
            keyboardDelegate,
            dropTargetDelegate
        }, dropState, ref);
        isRootDropTarget = dropState.isDropTarget({
            type: "root"
        });
    }
    let { focusProps, isFocused, isFocusVisible } = (0, _reactAria.useFocusRing)();
    let renderProps = (0, _utils.useRenderProps)({
        className: props.className,
        style: props.style,
        defaultClassName: "react-aria-Table",
        values: {
            isDropTarget: isRootDropTarget,
            isFocused,
            isFocusVisible,
            state
        }
    });
    let { selectionBehavior, selectionMode, disallowEmptySelection } = state.selectionManager;
    let ctx = (0, _react.useMemo)(()=>({
            selectionBehavior: selectionMode === "none" ? null : selectionBehavior,
            selectionMode,
            disallowEmptySelection,
            allowsDragging: isListDraggable
        }), [
        selectionBehavior,
        selectionMode,
        disallowEmptySelection,
        isListDraggable
    ]);
    let style = renderProps.style;
    let tableContainerContext = (0, _react.useContext)(ResizableTableContainerContext);
    let layoutState = null;
    if (tableContainerContext) {
        layoutState = tableContainerContext.useTableColumnResizeState({
            tableWidth: tableContainerContext.tableWidth
        }, state);
        style = {
            ...style,
            tableLayout: "fixed",
            width: "fit-content"
        };
    }
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement(TableOptionsContext.Provider, {
        value: ctx
    }, portal), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.Provider), {
        values: [
            [
                TableStateContext,
                state
            ],
            [
                TableColumnResizeStateContext,
                layoutState
            ],
            [
                (0, _useDragAndDrop.DragAndDropContext),
                {
                    dragAndDropHooks,
                    dragState,
                    dropState
                }
            ],
            [
                (0, _useDragAndDrop.DropIndicatorContext),
                {
                    render: TableDropIndicatorWrapper
                }
            ]
        ]
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAria.FocusScope), null, /*#__PURE__*/ (0, _reactDefault.default).createElement("table", {
        ...(0, _utils1.filterDOMProps)(props),
        ...renderProps,
        ...(0, _reactAria.mergeProps)(gridProps, focusProps, droppableCollection === null || droppableCollection === void 0 ? void 0 : droppableCollection.collectionProps),
        style: style,
        ref: ref,
        slot: props.slot || undefined,
        onScroll: props.onScroll,
        "data-allows-dragging": isListDraggable || undefined,
        "data-drop-target": isRootDropTarget || undefined,
        "data-focused": isFocused || undefined,
        "data-focus-visible": isFocusVisible || undefined
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(TableHeaderRowGroup, {
        collection: collection
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement(TableBodyRowGroup, {
        collection: collection,
        isDroppable: isListDroppable
    }))), dragPreview));
}
/**
 * A table displays data in rows and columns and enables a user to navigate its contents via directional navigation keys,
 * and optionally supports row selection and sorting.
 */ const _Table = /*#__PURE__*/ (0, _react.forwardRef)(Table);
const TableOptionsContext = /*#__PURE__*/ (0, _react.createContext)(null);
function useTableOptions() {
    return (0, _react.useContext)(TableOptionsContext);
}
function TableHeader(props, ref) {
    let children = (0, _collection.useCollectionChildren)({
        children: props.children,
        items: props.columns,
        dependencies: props.dependencies
    });
    let renderer = typeof props.children === "function" ? props.children : null;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _collection.CollectionRendererContext).Provider, {
        value: renderer
    }, (0, _collection.useSSRCollectionNode)("tableheader", props, ref, null, children));
}
/**
 * A header within a `<Table>`, containing the table columns.
 */ const _TableHeader = /*#__PURE__*/ (0, _react.forwardRef)(TableHeader);
function Column(props, ref) {
    return (0, _collection.useSSRCollectionNode)("column", props, ref, props.children);
}
/**
 * A column within a `<Table>`.
 */ const _Column = /*#__PURE__*/ (0, _react.forwardRef)(Column);
function TableBody(props, ref) {
    let children = (0, _collection.useCollectionChildren)(props);
    return (0, _collection.useSSRCollectionNode)("tablebody", props, ref, null, children);
}
/**
 * The body of a `<Table>`, containing the table rows.
 */ const _TableBody = /*#__PURE__*/ (0, _react.forwardRef)(TableBody);
function Row(props, ref) {
    let dependencies = [
        props.value
    ].concat(props.dependencies);
    let children = (0, _collection.useCollectionChildren)({
        dependencies,
        children: props.children,
        items: props.columns,
        idScope: props.id
    });
    let ctx = (0, _react.useMemo)(()=>({
            idScope: props.id,
            dependencies
        }), [
        props.id,
        ...dependencies
    ]);
    return (0, _collection.useSSRCollectionNode)("item", props, ref, null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _collection.CollectionContext).Provider, {
        value: ctx
    }, children));
}
/**
 * A row within a `<Table>`.
 */ const _Row = /*#__PURE__*/ (0, _react.forwardRef)(Row);
function Cell(props, ref) {
    return (0, _collection.useSSRCollectionNode)("cell", props, ref, props.children);
}
/**
 * A cell within a table row.
 */ const _Cell = /*#__PURE__*/ (0, _react.forwardRef)(Cell);
function TableHeaderRowGroup({ collection }) {
    let headerRows = (0, _collection.useCachedChildren)({
        items: collection.headerRows,
        children: (0, _react.useCallback)((item)=>{
            switch(item.type){
                case "headerrow":
                    return /*#__PURE__*/ (0, _reactDefault.default).createElement(TableHeaderRow, {
                        item: item
                    });
                default:
                    throw new Error("Unsupported node type in TableHeader: " + item.type);
            }
        }, [])
    });
    let { rowGroupProps } = (0, _reactAria.useTableRowGroup)();
    var _collection_head_props_className;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("thead", {
        ...(0, _utils1.filterDOMProps)(collection.head.props),
        ...rowGroupProps,
        ref: collection.head.props.ref,
        className: (_collection_head_props_className = collection.head.props.className) !== null && _collection_head_props_className !== void 0 ? _collection_head_props_className : "react-aria-TableHeader",
        style: collection.head.props.style
    }, headerRows);
}
function TableBodyRowGroup(props) {
    let { collection, isDroppable } = props;
    let bodyRows = (0, _collection.useCachedChildren)({
        items: collection.rows,
        children: (0, _react.useCallback)((item)=>{
            switch(item.type){
                case "item":
                    return /*#__PURE__*/ (0, _reactDefault.default).createElement(TableRow, {
                        item: item
                    });
                default:
                    throw new Error("Unsupported node type in TableBody: " + item.type);
            }
        }, [])
    });
    let state = (0, _react.useContext)(TableStateContext);
    let { dropState } = (0, _react.useContext)((0, _useDragAndDrop.DragAndDropContext));
    var _dropState_isDropTarget;
    let isRootDropTarget = isDroppable && !!dropState && ((_dropState_isDropTarget = dropState.isDropTarget({
        type: "root"
    })) !== null && _dropState_isDropTarget !== void 0 ? _dropState_isDropTarget : false);
    let bodyProps = collection.body.props;
    let renderValues = {
        isDropTarget: isRootDropTarget,
        isEmpty: collection.size === 0
    };
    let renderProps = (0, _utils.useRenderProps)({
        ...bodyProps,
        id: undefined,
        children: undefined,
        defaultClassName: "react-aria-TableBody",
        values: renderValues
    });
    let emptyState;
    if (collection.size === 0 && bodyProps.renderEmptyState && state) emptyState = /*#__PURE__*/ (0, _reactDefault.default).createElement("tr", {
        role: "row"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("td", {
        role: "gridcell",
        colSpan: collection.columnCount
    }, bodyProps.renderEmptyState(renderValues)));
    let { rowGroupProps } = (0, _reactAria.useTableRowGroup)();
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("tbody", {
        ...(0, _reactAria.mergeProps)((0, _utils1.filterDOMProps)(bodyProps), rowGroupProps),
        ...renderProps,
        ref: collection.body.props.ref,
        "data-empty": collection.size === 0 || undefined
    }, isDroppable && /*#__PURE__*/ (0, _reactDefault.default).createElement(RootDropIndicator, null), bodyRows, emptyState);
}
function TableHeaderRow({ item }) {
    let ref = (0, _react.useRef)(null);
    let state = (0, _react.useContext)(TableStateContext);
    let { rowProps } = (0, _reactAria.useTableHeaderRow)({
        node: item
    }, state, ref);
    let { checkboxProps } = (0, _reactAria.useTableSelectAllCheckbox)(state);
    let cells = (0, _collection.useCachedChildren)({
        items: state.collection.getChildren(item.key),
        children: (item)=>{
            switch(item.type){
                case "column":
                    return /*#__PURE__*/ (0, _reactDefault.default).createElement(TableColumnHeader, {
                        column: item
                    });
                default:
                    throw new Error("Unsupported node type in Row: " + item.type);
            }
        }
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("tr", {
        ...rowProps,
        ref: ref
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.Provider), {
        values: [
            [
                (0, _checkbox.CheckboxContext),
                {
                    slots: {
                        selection: checkboxProps
                    }
                }
            ]
        ]
    }, cells));
}
const ColumnResizerContext = /*#__PURE__*/ (0, _react.createContext)(null);
function TableColumnHeader({ column }) {
    var _state_sortDescriptor, _state_sortDescriptor1;
    let ref = (0, _utils1.useObjectRef)(column.props.ref);
    let state = (0, _react.useContext)(TableStateContext);
    let { columnHeaderProps } = (0, _reactAria.useTableColumnHeader)({
        node: column
    }, state, ref);
    let { isFocused, isFocusVisible, focusProps } = (0, _reactAria.useFocusRing)();
    let layoutState = (0, _react.useContext)(TableColumnResizeStateContext);
    let isResizing = false;
    if (layoutState) isResizing = layoutState.resizingColumn === column.key;
    else {
        for(let prop in [
            "width",
            "defaultWidth",
            "minWidth",
            "maxWidth"
        ])if (prop in column.props) console.warn(`The ${prop} prop on a <Column> only applies when a <Table> is wrapped in a <ResizableTableContainer>. If you aren't using column resizing, you can set the width of a column with CSS.`);
    }
    let props = column.props;
    let { hoverProps, isHovered } = (0, _reactAria.useHover)({
        isDisabled: !props.allowsSorting
    });
    let renderProps = (0, _utils.useRenderProps)({
        ...props,
        id: undefined,
        children: column.rendered,
        defaultClassName: "react-aria-Column",
        values: {
            isHovered,
            isFocused,
            isFocusVisible,
            allowsSorting: column.props.allowsSorting,
            sortDirection: ((_state_sortDescriptor = state.sortDescriptor) === null || _state_sortDescriptor === void 0 ? void 0 : _state_sortDescriptor.column) === column.key ? state.sortDescriptor.direction : undefined,
            isResizing,
            startResize: ()=>{
                if (layoutState) {
                    layoutState.startResize(column.key);
                    state.setKeyboardNavigationDisabled(true);
                } else throw new Error("Wrap your <Table> in a <ResizableTableContainer> to enable column resizing");
            },
            sort: (direction)=>{
                state.sort(column.key, direction);
            }
        }
    });
    let style = renderProps.style;
    if (layoutState) style = {
        ...style,
        width: layoutState.getColumnWidth(column.key)
    };
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("th", {
        ...(0, _reactAria.mergeProps)((0, _utils1.filterDOMProps)(props), columnHeaderProps, focusProps, hoverProps),
        ...renderProps,
        style: style,
        colSpan: column.colspan,
        ref: ref,
        "data-hovered": isHovered || undefined,
        "data-focused": isFocused || undefined,
        "data-focus-visible": isFocusVisible || undefined,
        "data-resizing": isResizing || undefined,
        "data-allows-sorting": column.props.allowsSorting || undefined,
        "data-sort-direction": ((_state_sortDescriptor1 = state.sortDescriptor) === null || _state_sortDescriptor1 === void 0 ? void 0 : _state_sortDescriptor1.column) === column.key ? state.sortDescriptor.direction : undefined
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(ColumnResizerContext.Provider, {
        value: {
            column,
            triggerRef: ref
        }
    }, renderProps.children));
}
function ColumnResizer(props, ref) {
    let layoutState = (0, _react.useContext)(TableColumnResizeStateContext);
    if (!layoutState) throw new Error("Wrap your <Table> in a <ResizableTableContainer> to enable column resizing");
    let stringFormatter = (0, _reactAria.useLocalizedStringFormatter)((0, _jsonDefault.default), "react-aria-components");
    let { onResizeStart, onResize, onResizeEnd } = (0, _react.useContext)(ResizableTableContainerContext);
    let { column, triggerRef } = (0, _react.useContext)(ColumnResizerContext);
    let inputRef = (0, _react.useRef)(null);
    let { resizerProps, inputProps, isResizing } = (0, _reactAria.useTableColumnResize)({
        column,
        "aria-label": props["aria-label"] || stringFormatter.format("tableResizer"),
        onResizeStart,
        onResize,
        onResizeEnd,
        triggerRef
    }, layoutState, inputRef);
    let { focusProps, isFocused, isFocusVisible } = (0, _reactAria.useFocusRing)();
    let { hoverProps, isHovered } = (0, _reactAria.useHover)(props);
    let isEResizable = layoutState.getColumnMinWidth(column.key) >= layoutState.getColumnWidth(column.key);
    let isWResizable = layoutState.getColumnMaxWidth(column.key) <= layoutState.getColumnWidth(column.key);
    let { direction } = (0, _reactAria.useLocale)();
    let resizableDirection = "both";
    if (isEResizable) resizableDirection = direction === "rtl" ? "right" : "left";
    else if (isWResizable) resizableDirection = direction === "rtl" ? "left" : "right";
    else resizableDirection = "both";
    let objectRef = (0, _utils1.useObjectRef)(ref);
    let [cursor, setCursor] = (0, _react.useState)("");
    (0, _react.useEffect)(()=>{
        if (!objectRef.current) return;
        let style = window.getComputedStyle(objectRef.current);
        setCursor(style.cursor);
    }, [
        objectRef,
        resizableDirection
    ]);
    let renderProps = (0, _utils.useRenderProps)({
        ...props,
        defaultClassName: "react-aria-ColumnResizer",
        values: {
            isFocused,
            isFocusVisible,
            isResizing,
            isHovered,
            resizableDirection
        }
    });
    let [isMouseDown, setMouseDown] = (0, _react.useState)(false);
    let onPointerDown = (e)=>{
        if (e.pointerType === "mouse") setMouseDown(true);
    };
    if (!isResizing && isMouseDown) setMouseDown(false);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ref: objectRef,
        role: "presentation",
        ...renderProps,
        ...(0, _reactAria.mergeProps)(resizerProps, {
            onPointerDown
        }, hoverProps),
        "data-hovered": isHovered || undefined,
        "data-focused": isFocused || undefined,
        "data-focus-visible": isFocusVisible || undefined,
        "data-resizing": isResizing || undefined,
        "data-resizable-direction": resizableDirection
    }, renderProps.children, /*#__PURE__*/ (0, _reactDefault.default).createElement("input", {
        ref: inputRef,
        ...(0, _reactAria.mergeProps)(inputProps, focusProps)
    }), isResizing && isMouseDown && /*#__PURE__*/ (0, _reactDomDefault.default).createPortal(/*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        style: {
            position: "fixed",
            top: 0,
            left: 0,
            bottom: 0,
            right: 0,
            cursor
        }
    }), document.body));
}
const _ColumnResizer = /*#__PURE__*/ (0, _react.forwardRef)(ColumnResizer);
function TableRow({ item }) {
    let ref = (0, _utils1.useObjectRef)(item.props.ref);
    let state = (0, _react.useContext)(TableStateContext);
    let { dragAndDropHooks, dragState, dropState } = (0, _react.useContext)((0, _useDragAndDrop.DragAndDropContext));
    let { rowProps, ...states } = (0, _reactAria.useTableRow)({
        node: item,
        shouldSelectOnPressUp: !!dragState
    }, state, ref);
    let { isFocused, isFocusVisible, focusProps } = (0, _reactAria.useFocusRing)();
    let { hoverProps, isHovered } = (0, _reactAria.useHover)({
        isDisabled: !states.allowsSelection && !states.hasAction
    });
    let { checkboxProps } = (0, _reactAria.useTableSelectionCheckbox)({
        key: item.key
    }, state);
    let draggableItem = undefined;
    if (dragState && dragAndDropHooks) draggableItem = dragAndDropHooks.useDraggableItem({
        key: item.key,
        hasDragButton: true
    }, dragState);
    let dropIndicator = undefined;
    let dropIndicatorRef = (0, _react.useRef)(null);
    let { visuallyHiddenProps } = (0, _reactAria.useVisuallyHidden)();
    if (dropState && dragAndDropHooks) dropIndicator = dragAndDropHooks.useDropIndicator({
        target: {
            type: "item",
            key: item.key,
            dropPosition: "on"
        }
    }, dropState, dropIndicatorRef);
    let renderDropIndicator = (dragAndDropHooks === null || dragAndDropHooks === void 0 ? void 0 : dragAndDropHooks.renderDropIndicator) || ((target)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _useDragAndDrop.DropIndicator), {
            target: target
        }));
    let dragButtonRef = (0, _react.useRef)(null);
    (0, _react.useEffect)(()=>{
        if (dragState && !dragButtonRef.current) console.warn('Draggable items in a Table must contain a <Button slot="drag"> element so that keyboard and screen reader users can drag them.');
    // eslint-disable-next-line
    }, []);
    let props = item.props;
    let isDragging = dragState && dragState.isDragging(item.key);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    let { children: _, ...restProps } = props;
    let renderProps = (0, _utils.useRenderProps)({
        ...restProps,
        id: undefined,
        defaultClassName: "react-aria-Row",
        values: {
            ...states,
            isHovered,
            isFocused,
            isFocusVisible,
            selectionMode: state.selectionManager.selectionMode,
            selectionBehavior: state.selectionManager.selectionBehavior,
            isDragging,
            isDropTarget: dropIndicator === null || dropIndicator === void 0 ? void 0 : dropIndicator.isDropTarget
        }
    });
    let cells = (0, _collection.useCachedChildren)({
        items: state.collection.getChildren(item.key),
        children: (item)=>{
            switch(item.type){
                case "cell":
                    return /*#__PURE__*/ (0, _reactDefault.default).createElement(TableCell, {
                        cell: item
                    });
                default:
                    throw new Error("Unsupported node type in Row: " + item.type);
            }
        }
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (dragAndDropHooks === null || dragAndDropHooks === void 0 ? void 0 : dragAndDropHooks.useDropIndicator) && renderDropIndicator({
        type: "item",
        key: item.key,
        dropPosition: "before"
    }), dropIndicator && !dropIndicator.isHidden && /*#__PURE__*/ (0, _reactDefault.default).createElement("tr", {
        role: "row",
        style: {
            height: 0
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("td", {
        role: "gridcell",
        colSpan: state.collection.columnCount,
        style: {
            padding: 0
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        role: "button",
        ...visuallyHiddenProps,
        ...dropIndicator.dropIndicatorProps,
        ref: dropIndicatorRef
    }))), /*#__PURE__*/ (0, _reactDefault.default).createElement("tr", {
        ...(0, _reactAria.mergeProps)((0, _utils1.filterDOMProps)(props), rowProps, focusProps, hoverProps, draggableItem === null || draggableItem === void 0 ? void 0 : draggableItem.dragProps),
        ...renderProps,
        ref: ref,
        "data-disabled": states.isDisabled || undefined,
        "data-selected": states.isSelected || undefined,
        "data-hovered": isHovered || undefined,
        "data-focused": states.isFocused || undefined,
        "data-focus-visible": isFocusVisible || undefined,
        "data-pressed": states.isPressed || undefined,
        "data-dragging": isDragging || undefined,
        "data-drop-target": (dropIndicator === null || dropIndicator === void 0 ? void 0 : dropIndicator.isDropTarget) || undefined,
        "data-selection-mode": state.selectionManager.selectionMode === "none" ? undefined : state.selectionManager.selectionMode
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.Provider), {
        values: [
            [
                (0, _checkbox.CheckboxContext),
                {
                    slots: {
                        selection: checkboxProps
                    }
                }
            ],
            [
                (0, _button.ButtonContext),
                {
                    slots: {
                        [(0, _utils.DEFAULT_SLOT)]: {},
                        drag: {
                            ...draggableItem === null || draggableItem === void 0 ? void 0 : draggableItem.dragButtonProps,
                            ref: dragButtonRef,
                            style: {
                                pointerEvents: "none"
                            }
                        }
                    }
                }
            ]
        ]
    }, cells)), (dragAndDropHooks === null || dragAndDropHooks === void 0 ? void 0 : dragAndDropHooks.useDropIndicator) && state.collection.getKeyAfter(item.key) == null && renderDropIndicator({
        type: "item",
        key: item.key,
        dropPosition: "after"
    }));
}
function TableCell({ cell }) {
    let ref = (0, _utils1.useObjectRef)(cell.props.ref);
    let state = (0, _react.useContext)(TableStateContext);
    let { dragState } = (0, _react.useContext)((0, _useDragAndDrop.DragAndDropContext));
    // @ts-ignore
    cell.column = state.collection.columns[cell.index];
    let { gridCellProps, isPressed } = (0, _reactAria.useTableCell)({
        node: cell,
        shouldSelectOnPressUp: !!dragState
    }, state, ref);
    let { isFocused, isFocusVisible, focusProps } = (0, _reactAria.useFocusRing)();
    let { hoverProps, isHovered } = (0, _reactAria.useHover)({});
    let props = cell.props;
    let renderProps = (0, _utils.useRenderProps)({
        ...props,
        id: undefined,
        defaultClassName: "react-aria-Cell",
        values: {
            isFocused,
            isFocusVisible,
            isPressed,
            isHovered
        }
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("td", {
        ...(0, _reactAria.mergeProps)((0, _utils1.filterDOMProps)(props), gridCellProps, focusProps, hoverProps),
        ...renderProps,
        ref: ref,
        "data-focused": isFocused || undefined,
        "data-focus-visible": isFocusVisible || undefined,
        "data-pressed": isPressed || undefined
    }, renderProps.children);
}
function TableDropIndicatorWrapper(props, ref) {
    ref = (0, _utils1.useObjectRef)(ref);
    let { dragAndDropHooks, dropState } = (0, _react.useContext)((0, _useDragAndDrop.DragAndDropContext));
    let buttonRef = (0, _react.useRef)(null);
    let { dropIndicatorProps, isHidden, isDropTarget } = dragAndDropHooks.useDropIndicator(props, dropState, buttonRef);
    if (isHidden) return null;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(TableDropIndicatorForwardRef, {
        ...props,
        dropIndicatorProps: dropIndicatorProps,
        isDropTarget: isDropTarget,
        buttonRef: buttonRef,
        ref: ref
    });
}
function TableDropIndicator(props, ref) {
    let { dropIndicatorProps, isDropTarget, buttonRef, ...otherProps } = props;
    let state = (0, _react.useContext)(TableStateContext);
    let { visuallyHiddenProps } = (0, _reactAria.useVisuallyHidden)();
    let renderProps = (0, _utils.useRenderProps)({
        ...otherProps,
        defaultClassName: "react-aria-DropIndicator",
        values: {
            isDropTarget
        }
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("tr", {
        ...(0, _utils1.filterDOMProps)(props),
        ...renderProps,
        role: "row",
        ref: ref,
        "data-drop-target": isDropTarget || undefined
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("td", {
        role: "gridcell",
        colSpan: state.collection.columnCount,
        style: {
            padding: 0
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...visuallyHiddenProps,
        role: "button",
        ...dropIndicatorProps,
        ref: buttonRef
    }), renderProps.children));
}
const TableDropIndicatorForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(TableDropIndicator);
function RootDropIndicator() {
    let state = (0, _react.useContext)(TableStateContext);
    let { dragAndDropHooks, dropState } = (0, _react.useContext)((0, _useDragAndDrop.DragAndDropContext));
    let ref = (0, _react.useRef)(null);
    let { dropIndicatorProps } = dragAndDropHooks.useDropIndicator({
        target: {
            type: "root"
        }
    }, dropState, ref);
    let isDropTarget = dropState.isDropTarget({
        type: "root"
    });
    let { visuallyHiddenProps } = (0, _reactAria.useVisuallyHidden)();
    if (!isDropTarget && dropIndicatorProps["aria-hidden"]) return null;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("tr", {
        role: "row",
        "aria-hidden": dropIndicatorProps["aria-hidden"],
        style: {
            height: 0
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("td", {
        role: "gridcell",
        colSpan: state.collection.columnCount,
        style: {
            padding: 0
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        role: "button",
        ...visuallyHiddenProps,
        ...dropIndicatorProps,
        ref: ref
    })));
}

},{"./Collection":"lJDFi","@react-stately/table":"6ZM93","./Button":"9McZy","./Checkbox":"fxrKi","./utils":"iyTLn","react-stately":"ij62t","./useDragAndDrop":"fPav3","react-aria":"e7jhe","@react-aria/utils":"9cLk5","../intl/*.json":"cQFjh","react":"9yzVZ","react-dom":"cEvV3","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"f0lSN":[function(require,module,exports) {
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TabsContext", ()=>TabsContext);
parcelHelpers.export(exports, "TabListStateContext", ()=>TabListStateContext);
parcelHelpers.export(exports, "Tabs", ()=>_Tabs);
parcelHelpers.export(exports, "TabList", ()=>_TabList);
parcelHelpers.export(exports, "Tab", ()=>_Tab);
parcelHelpers.export(exports, "TabPanel", ()=>_TabPanel);
var _reactAria = require("react-aria");
var _reactStately = require("react-stately");
var _collection = require("./Collection");
var _utils = require("./utils");
var _utils1 = require("@react-aria/utils");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const TabsContext = /*#__PURE__*/ (0, _react.createContext)(null);
const TabListStateContext = /*#__PURE__*/ (0, _react.createContext)(null);
function Tabs(props, ref) {
    [props, ref] = (0, _utils.useContextProps)(props, ref, TabsContext);
    let { collection, document } = (0, _collection.useCollectionDocument)();
    let { children, orientation = "horizontal" } = props;
    children = (0, _react.useMemo)(()=>typeof children === "function" ? children({
            orientation
        }) : children, [
        children,
        orientation
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.Hidden), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _collection.CollectionDocumentContext).Provider, {
        value: document
    }, children)), /*#__PURE__*/ (0, _reactDefault.default).createElement(TabsInner, {
        props: props,
        collection: collection,
        tabsRef: ref
    }));
}
function TabsInner({ props, tabsRef: ref, collection }) {
    let { orientation = "horizontal" } = props;
    let state = (0, _reactStately.useTabListState)({
        ...props,
        collection,
        children: undefined
    });
    let { focusProps, isFocused, isFocusVisible } = (0, _reactAria.useFocusRing)({
        within: true
    });
    let values = (0, _react.useMemo)(()=>({
            orientation,
            isFocusWithin: isFocused,
            isFocusVisible
        }), [
        orientation,
        isFocused,
        isFocusVisible
    ]);
    let renderProps = (0, _utils.useRenderProps)({
        ...props,
        defaultClassName: "react-aria-Tabs",
        values
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...(0, _utils1.filterDOMProps)(props),
        ...focusProps,
        ...renderProps,
        ref: ref,
        slot: props.slot || undefined,
        "data-focused": isFocused || undefined,
        "data-orientation": orientation,
        "data-focus-visible": isFocusVisible || undefined,
        "data-disabled": state.isDisabled || undefined
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.Provider), {
        values: [
            [
                TabsContext,
                props
            ],
            [
                TabListStateContext,
                state
            ]
        ]
    }, renderProps.children));
}
/**
 * Tabs organize content into multiple sections and allow users to navigate between them.
 */ const _Tabs = /*#__PURE__*/ (0, _react.forwardRef)(Tabs);
function TabList(props, ref) {
    let document = (0, _react.useContext)((0, _collection.CollectionDocumentContext));
    return document ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _collection.CollectionPortal), props) : /*#__PURE__*/ (0, _reactDefault.default).createElement(TabListInner, {
        props: props,
        forwardedRef: ref
    });
}
function TabListInner({ props, forwardedRef: ref }) {
    let state = (0, _react.useContext)(TabListStateContext);
    let { orientation = "horizontal", keyboardActivation = "automatic" } = (0, _utils.useSlottedContext)(TabsContext);
    let objectRef = (0, _utils1.useObjectRef)(ref);
    let { tabListProps } = (0, _reactAria.useTabList)({
        ...props,
        orientation,
        keyboardActivation
    }, state, objectRef);
    let renderProps = (0, _utils.useRenderProps)({
        ...props,
        children: null,
        defaultClassName: "react-aria-TabList",
        values: {
            orientation,
            state
        }
    });
    let DOMProps = (0, _utils1.filterDOMProps)(props);
    delete DOMProps.id;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...DOMProps,
        ...tabListProps,
        ref: objectRef,
        ...renderProps,
        "data-orientation": orientation || undefined
    }, [
        ...state.collection
    ].map((item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(TabInner, {
            key: item.key,
            item: item,
            state: state
        })));
}
/**
 * A TabList is used within Tabs to group tabs that a user can switch between.
 * The ids of the items within the <TabList> must match up with a corresponding item inside the <TabPanels>.
 */ const _TabList = /*#__PURE__*/ (0, _react.forwardRef)(TabList);
function Tab(props, ref) {
    return (0, _collection.useSSRCollectionNode)("item", props, ref, props.children);
}
/**
 * A Tab provides a title for an individual item within a TabList.
 */ const _Tab = /*#__PURE__*/ (0, _react.forwardRef)(Tab);
function TabInner({ item, state }) {
    let ref = (0, _utils1.useObjectRef)(item.props.ref);
    let { tabProps, isSelected, isDisabled, isPressed } = (0, _reactAria.useTab)({
        key: item.key,
        ...item.props
    }, state, ref);
    let { focusProps, isFocused, isFocusVisible } = (0, _reactAria.useFocusRing)();
    let { hoverProps, isHovered } = (0, _reactAria.useHover)({
        isDisabled
    });
    let renderProps = (0, _utils.useRenderProps)({
        ...item.props,
        children: item.rendered,
        defaultClassName: "react-aria-Tab",
        values: {
            isSelected,
            isDisabled,
            isFocused,
            isFocusVisible,
            isPressed,
            isHovered,
            state
        }
    });
    let ElementType = item.props.href ? "a" : "div";
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(ElementType, {
        ...(0, _reactAria.mergeProps)(tabProps, focusProps, hoverProps, renderProps),
        ref: ref,
        "data-selected": isSelected || undefined,
        "data-disabled": isDisabled || undefined,
        "data-focus-visible": isFocusVisible || undefined,
        "data-pressed": isPressed || undefined,
        "data-hovered": isHovered || undefined
    });
}
function TabPanel(props, forwardedRef) {
    const state = (0, _react.useContext)(TabListStateContext);
    let ref = (0, _utils1.useObjectRef)(forwardedRef);
    let { tabPanelProps } = (0, _reactAria.useTabPanel)(props, state, ref);
    let { focusProps, isFocused, isFocusVisible } = (0, _reactAria.useFocusRing)();
    let isSelected = state.selectedKey === props.id;
    let renderProps = (0, _utils.useRenderProps)({
        ...props,
        defaultClassName: "react-aria-TabPanel",
        values: {
            isFocused,
            isFocusVisible,
            isInert: !isSelected,
            state
        }
    });
    if (!isSelected && !props.shouldForceMount) return null;
    let DOMProps = (0, _utils1.filterDOMProps)(props);
    delete DOMProps.id;
    let domProps = isSelected ? (0, _reactAria.mergeProps)(DOMProps, tabPanelProps, focusProps, renderProps) : renderProps;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...domProps,
        ref: ref,
        "data-focused": isFocused || undefined,
        "data-focus-visible": isFocusVisible || undefined,
        // @ts-ignore
        inert: !isSelected ? "true" : undefined,
        "data-inert": !isSelected ? "true" : undefined
    });
}
/**
 * A TabPanel provides the content for a tab.
 */ const _TabPanel = /*#__PURE__*/ (0, _utils.createHideableComponent)(TabPanel);

},{"react-aria":"e7jhe","react-stately":"ij62t","./Collection":"lJDFi","./utils":"iyTLn","@react-aria/utils":"9cLk5","react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"4fzLm":[function(require,module,exports) {
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TagGroupContext", ()=>TagGroupContext);
parcelHelpers.export(exports, "TagListContext", ()=>TagListContext);
parcelHelpers.export(exports, "TagGroup", ()=>_TagGroup);
parcelHelpers.export(exports, "TagList", ()=>_TagList);
parcelHelpers.export(exports, "Tag", ()=>_Tag);
var _reactAria = require("react-aria");
var _button = require("./Button");
var _collection = require("./Collection");
var _utils = require("./utils");
var _utils1 = require("@react-aria/utils");
var _label = require("./Label");
var _reactStately = require("react-stately");
var _listBox = require("./ListBox");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _text = require("./Text");
const TagGroupContext = /*#__PURE__*/ (0, _react.createContext)(null);
const TagListContext = /*#__PURE__*/ (0, _react.createContext)(null);
function TagGroup(props, ref) {
    [props, ref] = (0, _utils.useContextProps)(props, ref, TagGroupContext);
    let tagListRef = (0, _react.useRef)(null);
    let [labelRef, label] = (0, _utils.useSlot)();
    let { collection, document } = (0, _collection.useCollectionDocument)();
    let state = (0, _reactStately.useListState)({
        ...props,
        children: undefined,
        collection
    });
    // Prevent DOM props from going to two places.
    let domProps = (0, _utils1.filterDOMProps)(props);
    let domPropOverrides = Object.fromEntries(Object.entries(domProps).map(([k])=>[
            k,
            undefined
        ]));
    let { gridProps, labelProps, descriptionProps, errorMessageProps } = (0, _reactAria.useTagGroup)({
        ...props,
        ...domPropOverrides,
        label
    }, state, tagListRef);
    var _props_className;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...domProps,
        ref: ref,
        slot: props.slot || undefined,
        className: (_props_className = props.className) !== null && _props_className !== void 0 ? _props_className : "react-aria-TagGroup",
        style: props.style
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.Provider), {
        values: [
            [
                (0, _label.LabelContext),
                {
                    ...labelProps,
                    elementType: "span",
                    ref: labelRef
                }
            ],
            [
                TagListContext,
                {
                    ...gridProps,
                    ref: tagListRef
                }
            ],
            [
                (0, _listBox.ListStateContext),
                state
            ],
            [
                (0, _collection.CollectionDocumentContext),
                document
            ],
            [
                (0, _text.TextContext),
                {
                    slots: {
                        description: descriptionProps,
                        errorMessage: errorMessageProps
                    }
                }
            ]
        ]
    }, props.children));
}
/**
 * A tag group is a focusable list of labels, categories, keywords, filters, or other items, with support for keyboard navigation, selection, and removal.
 */ const _TagGroup = /*#__PURE__*/ (0, _react.forwardRef)(TagGroup);
function TagList(props, forwardedRef) {
    // Render the portal first so that we have the collection by the time we render the DOM in SSR.
    let portal = (0, _collection.useCollectionPortal)(props);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, portal, /*#__PURE__*/ (0, _reactDefault.default).createElement(TagListInner, {
        props: props,
        forwardedRef: forwardedRef
    }));
}
function TagListInner({ props, forwardedRef }) {
    let state = (0, _react.useContext)((0, _listBox.ListStateContext));
    let [gridProps, ref] = (0, _utils.useContextProps)(props, forwardedRef, TagListContext);
    delete gridProps.items;
    delete gridProps.renderEmptyState;
    let children = (0, _collection.useCachedChildren)({
        items: state.collection,
        children: (item)=>{
            switch(item.type){
                case "item":
                    return /*#__PURE__*/ (0, _reactDefault.default).createElement(TagItem, {
                        item: item
                    });
                default:
                    throw new Error("Unsupported node type in TagList: " + item.type);
            }
        }
    });
    let { focusProps, isFocused, isFocusVisible } = (0, _reactAria.useFocusRing)();
    let renderValues = {
        isEmpty: state.collection.size === 0,
        isFocused,
        isFocusVisible,
        state
    };
    let renderProps = (0, _utils.useRenderProps)({
        className: props.className,
        style: props.style,
        defaultClassName: "react-aria-TagList",
        values: renderValues
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...(0, _utils1.mergeProps)(gridProps, focusProps),
        ...renderProps,
        ref: ref,
        "data-empty": state.collection.size === 0 || undefined,
        "data-focused": isFocused || undefined,
        "data-focus-visible": isFocusVisible || undefined
    }, state.collection.size === 0 && props.renderEmptyState ? props.renderEmptyState(renderValues) : children);
}
/**
 * A tag list is a container for tags within a TagGroup.
 */ const _TagList = /*#__PURE__*/ (0, _react.forwardRef)(TagList);
function Tag(props, ref) {
    return (0, _collection.useSSRCollectionNode)("item", props, ref, props.children);
}
/**
 * A Tag is an individual item within a TagList.
 */ const _Tag = /*#__PURE__*/ (0, _react.forwardRef)(Tag);
function TagItem({ item }) {
    let state = (0, _react.useContext)((0, _listBox.ListStateContext));
    let ref = (0, _utils1.useObjectRef)(item.props.ref);
    let { focusProps, isFocusVisible } = (0, _reactAria.useFocusRing)({
        within: true
    });
    let { rowProps, gridCellProps, removeButtonProps, ...states } = (0, _reactAria.useTag)({
        item
    }, state, ref);
    let { hoverProps, isHovered } = (0, _reactAria.useHover)({
        isDisabled: !states.allowsSelection
    });
    let props = item.props;
    let renderProps = (0, _utils.useRenderProps)({
        ...props,
        id: undefined,
        children: item.rendered,
        defaultClassName: "react-aria-Tag",
        values: {
            ...states,
            isFocusVisible,
            isHovered,
            selectionMode: state.selectionManager.selectionMode,
            selectionBehavior: state.selectionManager.selectionBehavior
        }
    });
    (0, _react.useEffect)(()=>{
        if (!item.textValue) console.warn("A `textValue` prop is required for <Tag> elements with non-plain text children for accessibility.");
    }, [
        item.textValue
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ref: ref,
        ...renderProps,
        ...(0, _utils1.mergeProps)((0, _utils1.filterDOMProps)(props), rowProps, focusProps, hoverProps),
        "data-selected": states.isSelected || undefined,
        "data-disabled": states.isDisabled || undefined,
        "data-hovered": isHovered || undefined,
        "data-focused": states.isFocused || undefined,
        "data-focus-visible": isFocusVisible || undefined,
        "data-pressed": states.isPressed || undefined,
        "data-allows-removing": states.allowsRemoving || undefined,
        "data-selection-mode": state.selectionManager.selectionMode === "none" ? undefined : state.selectionManager.selectionMode
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...gridCellProps,
        style: {
            display: "contents"
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.Provider), {
        values: [
            [
                (0, _button.ButtonContext),
                {
                    slots: {
                        remove: removeButtonProps
                    }
                }
            ]
        ]
    }, renderProps.children)));
}

},{"react-aria":"e7jhe","./Button":"9McZy","./Collection":"lJDFi","./utils":"iyTLn","@react-aria/utils":"9cLk5","./Label":"jhkeS","react-stately":"ij62t","./ListBox":"katmG","react":"9yzVZ","./Text":"iZUDL","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"gqmau":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TextAreaContext", ()=>TextAreaContext);
parcelHelpers.export(exports, "TextArea", ()=>_TextArea);
var _utils = require("./utils");
var _reactAria = require("react-aria");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const TextAreaContext = /*#__PURE__*/ (0, _react.createContext)({});
let filterHoverProps = (props)=>{
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    let { onHoverStart, onHoverChange, onHoverEnd, ...otherProps } = props;
    return otherProps;
};
function TextArea(props, ref) {
    [props, ref] = (0, _utils.useContextProps)(props, ref, TextAreaContext);
    let { hoverProps, isHovered } = (0, _reactAria.useHover)(props);
    let { isFocused, isFocusVisible, focusProps } = (0, _reactAria.useFocusRing)({
        isTextInput: true,
        autoFocus: props.autoFocus
    });
    let isInvalid = !!props["aria-invalid"] && props["aria-invalid"] !== "false";
    let renderProps = (0, _utils.useRenderProps)({
        ...props,
        values: {
            isHovered,
            isFocused,
            isFocusVisible,
            isDisabled: props.disabled || false,
            isInvalid
        },
        defaultClassName: "react-aria-TextArea"
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("textarea", {
        ...(0, _reactAria.mergeProps)(filterHoverProps(props), focusProps, hoverProps),
        ...renderProps,
        ref: ref,
        "data-focused": isFocused || undefined,
        "data-disabled": props.disabled || undefined,
        "data-hovered": isHovered || undefined,
        "data-focus-visible": isFocusVisible || undefined,
        "data-invalid": isInvalid || undefined
    });
}
/**
 * A textarea allows a user to input mult-line text.
 */ const _TextArea = /*#__PURE__*/ (0, _react.forwardRef)(TextArea);

},{"./utils":"iyTLn","react-aria":"e7jhe","react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"atNkR":[function(require,module,exports) {
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TextFieldContext", ()=>TextFieldContext);
parcelHelpers.export(exports, "TextField", ()=>_TextField);
var _reactAria = require("react-aria");
var _utils = require("./utils");
var _fieldError = require("./FieldError");
var _utils1 = require("@react-aria/utils");
var _input = require("./Input");
var _label = require("./Label");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _textArea = require("./TextArea");
var _text = require("./Text");
const TextFieldContext = /*#__PURE__*/ (0, _react.createContext)(null);
function TextField(props, ref) {
    [props, ref] = (0, _utils.useContextProps)(props, ref, TextFieldContext);
    let inputRef = (0, _react.useRef)(null);
    let [labelRef, label] = (0, _utils.useSlot)();
    let [inputElementType, setInputElementType] = (0, _react.useState)("input");
    var _props_validationBehavior;
    let { labelProps, inputProps, descriptionProps, errorMessageProps, ...validation } = (0, _reactAria.useTextField)({
        ...(0, _utils.removeDataAttributes)(props),
        inputElementType,
        label,
        validationBehavior: (_props_validationBehavior = props.validationBehavior) !== null && _props_validationBehavior !== void 0 ? _props_validationBehavior : "native"
    }, inputRef);
    // Intercept setting the input ref so we can determine what kind of element we have.
    // useTextField uses this to determine what props to include.
    let inputOrTextAreaRef = (0, _react.useCallback)((el)=>{
        inputRef.current = el;
        if (el) setInputElementType(el instanceof HTMLTextAreaElement ? "textarea" : "input");
    }, []);
    let renderProps = (0, _utils.useRenderProps)({
        ...props,
        values: {
            isDisabled: props.isDisabled || false,
            isInvalid: validation.isInvalid
        },
        defaultClassName: "react-aria-TextField"
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...(0, _utils1.filterDOMProps)(props),
        ...renderProps,
        ref: ref,
        slot: props.slot || undefined,
        "data-disabled": props.isDisabled || undefined,
        "data-invalid": validation.isInvalid || undefined
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.Provider), {
        values: [
            [
                (0, _label.LabelContext),
                {
                    ...labelProps,
                    ref: labelRef
                }
            ],
            [
                (0, _input.InputContext),
                {
                    ...inputProps,
                    ref: inputOrTextAreaRef
                }
            ],
            [
                (0, _textArea.TextAreaContext),
                {
                    ...inputProps,
                    ref: inputOrTextAreaRef
                }
            ],
            [
                (0, _text.TextContext),
                {
                    slots: {
                        description: descriptionProps,
                        errorMessage: errorMessageProps
                    }
                }
            ],
            [
                (0, _fieldError.FieldErrorContext),
                validation
            ]
        ]
    }, renderProps.children));
}
/**
 * A text field allows a user to enter a plain text value with a keyboard.
 */ const _TextField = /*#__PURE__*/ (0, _react.forwardRef)(TextField);

},{"react-aria":"e7jhe","./utils":"iyTLn","./FieldError":"3acDn","@react-aria/utils":"9cLk5","./Input":"3u8zn","./Label":"jhkeS","react":"9yzVZ","./TextArea":"gqmau","./Text":"iZUDL","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"1woPA":[function(require,module,exports) {
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ToggleButtonContext", ()=>ToggleButtonContext);
parcelHelpers.export(exports, "ToggleButton", ()=>_ToggleButton);
var _reactAria = require("react-aria");
var _utils = require("./utils");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactStately = require("react-stately");
const ToggleButtonContext = /*#__PURE__*/ (0, _react.createContext)({});
function ToggleButton(props, ref) {
    [props, ref] = (0, _utils.useContextProps)(props, ref, ToggleButtonContext);
    let state = (0, _reactStately.useToggleState)(props);
    let { buttonProps, isPressed } = (0, _reactAria.useToggleButton)(props, state, ref);
    let { focusProps, isFocused, isFocusVisible } = (0, _reactAria.useFocusRing)(props);
    let { hoverProps, isHovered } = (0, _reactAria.useHover)(props);
    let renderProps = (0, _utils.useRenderProps)({
        ...props,
        values: {
            isHovered,
            isPressed,
            isFocused,
            isSelected: state.isSelected,
            isFocusVisible,
            isDisabled: props.isDisabled || false,
            state
        },
        defaultClassName: "react-aria-ToggleButton"
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("button", {
        ...(0, _reactAria.mergeProps)(buttonProps, focusProps, hoverProps),
        ...renderProps,
        ref: ref,
        slot: props.slot || undefined,
        "data-focused": isFocused || undefined,
        "data-disabled": props.isDisabled || undefined,
        "data-pressed": isPressed || undefined,
        "data-selected": state.isSelected || undefined,
        "data-hovered": isHovered || undefined,
        "data-focus-visible": isFocusVisible || undefined
    });
}
/**
 * A toggle button allows a user to toggle a selection on or off, for example switching between two states or modes.
 */ const _ToggleButton = /*#__PURE__*/ (0, _react.forwardRef)(ToggleButton);

},{"react-aria":"e7jhe","./utils":"iyTLn","react":"9yzVZ","react-stately":"ij62t","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"8OG3l":[function(require,module,exports) {
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ToolbarContext", ()=>ToolbarContext);
parcelHelpers.export(exports, "Toolbar", ()=>_Toolbar);
var _toolbar = require("@react-aria/toolbar");
var _utils = require("./utils");
var _utils1 = require("@react-aria/utils");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const ToolbarContext = /*#__PURE__*/ (0, _react.createContext)({});
function Toolbar(props, ref) {
    [props, ref] = (0, _utils.useContextProps)(props, ref, ToolbarContext);
    let { toolbarProps } = (0, _toolbar.useToolbar)(props, ref);
    let renderProps = (0, _utils.useRenderProps)({
        ...props,
        values: {
            orientation: props.orientation || "horizontal"
        },
        defaultClassName: "react-aria-Toolbar"
    });
    let DOMProps = (0, _utils1.filterDOMProps)(props);
    delete DOMProps.id;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...(0, _utils1.mergeProps)(toolbarProps, DOMProps),
        ...renderProps,
        ref: ref,
        slot: props.slot || undefined,
        "data-orientation": props.orientation || "horizontal"
    }, renderProps.children);
}
/**
 * A toolbar is a container for a set of interactive controls, such as buttons, dropdown menus, or checkboxes,
 * with arrow key navigation.
 */ const _Toolbar = /*#__PURE__*/ (0, _react.forwardRef)(Toolbar);

},{"@react-aria/toolbar":"4oS6v","./utils":"iyTLn","@react-aria/utils":"9cLk5","react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"4oS6v":[function(require,module,exports) {
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _useToolbar = require("./useToolbar");
parcelHelpers.exportAll(_useToolbar, exports);

},{"./useToolbar":"id3MK","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"id3MK":[function(require,module,exports) {
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides the behavior and accessibility implementation for a toolbar.
 * A toolbar is a container for a set of interactive controls with arrow key navigation.
 * @param props - Props to be applied to the toolbar.
 * @param ref - A ref to a DOM element for the toolbar.
 */ parcelHelpers.export(exports, "useToolbar", ()=>useToolbar);
var _focus = require("@react-aria/focus");
var _react = require("react");
var _utils = require("@react-aria/utils");
var _i18N = require("@react-aria/i18n");
function useToolbar(props, ref) {
    const { "aria-label": ariaLabel, "aria-labelledby": ariaLabelledBy, orientation = "horizontal" } = props;
    let [isInToolbar, setInToolbar] = (0, _react.useState)(false);
    // should be safe because re-calling set state with the same value it already has is a no-op
    // this will allow us to react should a parent re-render and change its role though
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, _utils.useLayoutEffect)(()=>{
        var _ref_current_parentElement;
        setInToolbar(!!(ref.current && ((_ref_current_parentElement = ref.current.parentElement) === null || _ref_current_parentElement === void 0 ? void 0 : _ref_current_parentElement.closest('[role="toolbar"]'))));
    });
    const { direction } = (0, _i18N.useLocale)();
    const shouldReverse = direction === "rtl" && orientation === "horizontal";
    let focusManager = (0, _focus.createFocusManager)(ref);
    const onKeyDown = (e)=>{
        // don't handle portalled events
        if (!e.currentTarget.contains(e.target)) return;
        if (orientation === "horizontal" && e.key === "ArrowRight" || orientation === "vertical" && e.key === "ArrowDown") {
            if (shouldReverse) focusManager.focusPrevious();
            else focusManager.focusNext();
        } else if (orientation === "horizontal" && e.key === "ArrowLeft" || orientation === "vertical" && e.key === "ArrowUp") {
            if (shouldReverse) focusManager.focusNext();
            else focusManager.focusPrevious();
        } else if (e.key === "Tab") {
            // When the tab key is pressed, we want to move focus
            // out of the entire toolbar. To do this, move focus
            // to the first or last focusable child, and let the
            // browser handle the Tab key as usual from there.
            e.stopPropagation();
            lastFocused.current = document.activeElement;
            if (e.shiftKey) focusManager.focusFirst();
            else focusManager.focusLast();
            return;
        } else // if we didn't handle anything, return early so we don't preventDefault
        return;
        // Prevent arrow keys from being handled by nested action groups.
        e.stopPropagation();
        e.preventDefault();
    };
    // Record the last focused child when focus moves out of the toolbar.
    const lastFocused = (0, _react.useRef)(null);
    const onBlur = (e)=>{
        if (!e.currentTarget.contains(e.relatedTarget) && !lastFocused.current) lastFocused.current = e.target;
    };
    // Restore focus to the last focused child when focus returns into the toolbar.
    // If the element was removed, do nothing, either the first item in the first group,
    // or the last item in the last group will be focused, depending on direction.
    const onFocus = (e)=>{
        var _ref_current;
        if (lastFocused.current && !e.currentTarget.contains(e.relatedTarget) && ((_ref_current = ref.current) === null || _ref_current === void 0 ? void 0 : _ref_current.contains(e.target))) {
            var _lastFocused_current;
            (_lastFocused_current = lastFocused.current) === null || _lastFocused_current === void 0 ? void 0 : _lastFocused_current.focus();
            lastFocused.current = null;
        }
    };
    return {
        toolbarProps: {
            role: !isInToolbar ? "toolbar" : "group",
            "aria-orientation": orientation,
            "aria-label": ariaLabel,
            "aria-labelledby": ariaLabel == null ? ariaLabelledBy : undefined,
            onKeyDownCapture: !isInToolbar ? onKeyDown : undefined,
            onFocusCapture: !isInToolbar ? onFocus : undefined,
            onBlurCapture: !isInToolbar ? onBlur : undefined
        }
    };
}

},{"@react-aria/focus":"42mbF","react":"9yzVZ","@react-aria/utils":"9cLk5","@react-aria/i18n":"411rg","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"bqCAj":[function(require,module,exports) {
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TooltipTriggerStateContext", ()=>TooltipTriggerStateContext);
parcelHelpers.export(exports, "TooltipContext", ()=>TooltipContext);
/**
 * TooltipTrigger wraps around a trigger element and a Tooltip. It handles opening and closing
 * the Tooltip when the user hovers over or focuses the trigger, and positioning the Tooltip
 * relative to the trigger.
 */ parcelHelpers.export(exports, "TooltipTrigger", ()=>TooltipTrigger);
parcelHelpers.export(exports, "Tooltip", ()=>_Tooltip);
var _utils = require("./utils");
var _focus = require("@react-aria/focus");
var _reactAria = require("react-aria");
var _overlayArrow = require("./OverlayArrow");
var _reactStately = require("react-stately");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const TooltipTriggerStateContext = /*#__PURE__*/ (0, _react.createContext)(null);
const TooltipContext = /*#__PURE__*/ (0, _react.createContext)(null);
function TooltipTrigger(props) {
    let state = (0, _reactStately.useTooltipTriggerState)(props);
    let ref = (0, _react.useRef)(null);
    let { triggerProps, tooltipProps } = (0, _reactAria.useTooltipTrigger)(props, state, ref);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.Provider), {
        values: [
            [
                TooltipTriggerStateContext,
                state
            ],
            [
                TooltipContext,
                {
                    ...tooltipProps,
                    triggerRef: ref
                }
            ]
        ]
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _focus.FocusableProvider), {
        ...triggerProps,
        ref: ref
    }, props.children));
}
function Tooltip({ UNSTABLE_portalContainer, ...props }, ref) {
    [props, ref] = (0, _utils.useContextProps)(props, ref, TooltipContext);
    let contextState = (0, _react.useContext)(TooltipTriggerStateContext);
    let localState = (0, _reactStately.useTooltipTriggerState)(props);
    let state = props.isOpen != null || props.defaultOpen != null || !contextState ? localState : contextState;
    let isExiting = (0, _utils.useExitAnimation)(ref, state.isOpen) || props.isExiting || false;
    if (!state.isOpen && !isExiting) return null;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAria.OverlayContainer), {
        portalContainer: UNSTABLE_portalContainer
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(TooltipInner, {
        ...props,
        tooltipRef: ref,
        isExiting: isExiting
    }));
}
/**
 * A tooltip displays a description of an element on hover or focus.
 */ const _Tooltip = /*#__PURE__*/ (0, _react.forwardRef)(Tooltip);
function TooltipInner(props) {
    let state = (0, _react.useContext)(TooltipTriggerStateContext);
    let { overlayProps, arrowProps, placement } = (0, _reactAria.useOverlayPosition)({
        placement: props.placement || "top",
        targetRef: props.triggerRef,
        overlayRef: props.tooltipRef,
        offset: props.offset,
        crossOffset: props.crossOffset,
        isOpen: state.isOpen
    });
    let isEntering = (0, _utils.useEnterAnimation)(props.tooltipRef, !!placement) || props.isEntering || false;
    let renderProps = (0, _utils.useRenderProps)({
        ...props,
        defaultClassName: "react-aria-Tooltip",
        values: {
            placement,
            isEntering,
            isExiting: props.isExiting,
            state
        }
    });
    props = (0, _reactAria.mergeProps)(props, overlayProps);
    let { tooltipProps } = (0, _reactAria.useTooltip)(props, state);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...tooltipProps,
        ref: props.tooltipRef,
        ...renderProps,
        style: {
            ...overlayProps.style,
            ...renderProps.style
        },
        "data-placement": placement,
        "data-entering": isEntering || undefined,
        "data-exiting": props.isExiting || undefined
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _overlayArrow.OverlayArrowContext).Provider, {
        value: {
            ...arrowProps,
            placement
        }
    }, renderProps.children));
}

},{"./utils":"iyTLn","@react-aria/focus":"42mbF","react-aria":"e7jhe","./OverlayArrow":"g8XVt","react-stately":"ij62t","react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"aqktK":[function(require,module,exports) {
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CalendarExample", ()=>CalendarExample);
parcelHelpers.export(exports, "CalendarMultiMonth", ()=>CalendarMultiMonth);
parcelHelpers.export(exports, "RangeCalendarExample", ()=>RangeCalendarExample);
var _reactAriaComponents = require("react-aria-components");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
exports.default = {
    title: "React Aria Components"
};
const CalendarExample = ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Calendar), {
        style: {
            width: 220
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        style: {
            display: "flex",
            alignItems: "center"
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Button), {
        slot: "previous"
    }, "<"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Heading), {
        style: {
            flex: 1,
            textAlign: "center"
        }
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Button), {
        slot: "next"
    }, ">")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.CalendarGrid), {
        style: {
            width: "100%"
        }
    }, (date)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.CalendarCell), {
            date: date,
            style: ({ isSelected, isOutsideMonth })=>({
                    display: isOutsideMonth ? "none" : "",
                    textAlign: "center",
                    cursor: "default",
                    background: isSelected ? "blue" : ""
                })
        })));
const CalendarMultiMonth = ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Calendar), {
        style: {
            width: 500
        },
        visibleDuration: {
            months: 2
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        style: {
            display: "flex",
            alignItems: "center"
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Button), {
        slot: "previous"
    }, "<"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Heading), {
        style: {
            flex: 1,
            textAlign: "center"
        }
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Button), {
        slot: "next"
    }, ">")), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        style: {
            display: "flex",
            gap: 20
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.CalendarGrid), {
        style: {
            flex: 1
        }
    }, (date)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.CalendarCell), {
            date: date,
            style: ({ isSelected, isOutsideMonth })=>({
                    display: isOutsideMonth ? "none" : "",
                    textAlign: "center",
                    cursor: "default",
                    background: isSelected ? "blue" : ""
                })
        })), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.CalendarGrid), {
        style: {
            flex: 1
        },
        offset: {
            months: 1
        }
    }, (date)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.CalendarCell), {
            date: date,
            style: ({ isSelected, isOutsideMonth })=>({
                    display: isOutsideMonth ? "none" : "",
                    textAlign: "center",
                    cursor: "default",
                    background: isSelected ? "blue" : ""
                })
        }))));
const RangeCalendarExample = ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.RangeCalendar), {
        style: {
            width: 220
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        style: {
            display: "flex",
            alignItems: "center"
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Button), {
        slot: "previous"
    }, "<"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Heading), {
        style: {
            flex: 1,
            textAlign: "center"
        }
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Button), {
        slot: "next"
    }, ">")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.CalendarGrid), {
        style: {
            width: "100%"
        }
    }, (date)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.CalendarCell), {
            date: date,
            style: ({ isSelected, isOutsideMonth })=>({
                    display: isOutsideMonth ? "none" : "",
                    textAlign: "center",
                    cursor: "default",
                    background: isSelected ? "blue" : ""
                })
        })));

},{"react-aria-components":"lFSUH","react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"daxz9":[function(require,module,exports) {
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ComboBoxExample", ()=>ComboBoxExample);
parcelHelpers.export(exports, "ComboBoxRenderPropsStatic", ()=>ComboBoxRenderPropsStatic);
parcelHelpers.export(exports, "ComboBoxRenderPropsDefaultItems", ()=>ComboBoxRenderPropsDefaultItems);
parcelHelpers.export(exports, "ComboBoxRenderPropsItems", ()=>ComboBoxRenderPropsItems);
parcelHelpers.export(exports, "ComboBoxRenderPropsListBoxDynamic", ()=>ComboBoxRenderPropsListBoxDynamic);
parcelHelpers.export(exports, "ComboBoxAsyncLoadingExample", ()=>ComboBoxAsyncLoadingExample);
var _reactAriaComponents = require("react-aria-components");
var _utils = require("./utils");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _indexCss = require("../example/index.css");
var _indexCssDefault = parcelHelpers.interopDefault(_indexCss);
var _reactStately = require("react-stately");
exports.default = {
    title: "React Aria Components"
};
const ComboBoxExample = ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.ComboBox), {
        "data-testid": "combo-box-example"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Label), {
        style: {
            display: "block"
        }
    }, "Test"), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        style: {
            display: "flex"
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Input), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Button), null, /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        "aria-hidden": "true",
        style: {
            padding: "0 2px"
        }
    }, "\u25BC"))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Popover), {
        placement: "bottom end"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.ListBox), {
        "data-testid": "combo-box-list-box",
        className: (0, _indexCssDefault.default).menu
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.MyListBoxItem), null, "Foo"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.MyListBoxItem), null, "Bar"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.MyListBoxItem), null, "Baz"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.MyListBoxItem), {
        href: "http://google.com"
    }, "Google"))));
let items = [
    {
        id: "1",
        name: "Foo"
    },
    {
        id: "2",
        name: "Bar"
    },
    {
        id: "3",
        name: "Baz"
    }
];
const ComboBoxRenderPropsStatic = ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.ComboBox), {
        "data-testid": "combo-box-render-props-static"
    }, ({ isOpen })=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Label), {
            style: {
                display: "block"
            }
        }, "Test"), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
            style: {
                display: "flex"
            }
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Input), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Button), null, /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
            "aria-hidden": "true",
            style: {
                padding: "0 2px"
            }
        }, isOpen ? "\u25B2" : "\u25BC"))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Popover), {
            placement: "bottom end"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.ListBox), {
            className: (0, _indexCssDefault.default).menu
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.MyListBoxItem), null, "Foo"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.MyListBoxItem), null, "Bar"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.MyListBoxItem), null, "Baz")))));
const ComboBoxRenderPropsDefaultItems = ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.ComboBox), {
        defaultItems: items
    }, ({ isOpen })=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Label), {
            style: {
                display: "block"
            }
        }, "Test"), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
            style: {
                display: "flex"
            }
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Input), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Button), null, /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
            "aria-hidden": "true",
            style: {
                padding: "0 2px"
            }
        }, isOpen ? "\u25B2" : "\u25BC"))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Popover), {
            placement: "bottom end"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.ListBox), {
            className: (0, _indexCssDefault.default).menu
        }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.MyListBoxItem), {
                id: item.id
            }, item.name)))));
const ComboBoxRenderPropsItems = {
    render: ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.ComboBox), {
            items: items
        }, ({ isOpen })=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Label), {
                style: {
                    display: "block"
                }
            }, "Test"), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
                style: {
                    display: "flex"
                }
            }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Input), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Button), null, /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
                "aria-hidden": "true",
                style: {
                    padding: "0 2px"
                }
            }, isOpen ? "\u25B2" : "\u25BC"))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Popover), {
                placement: "bottom end"
            }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.ListBox), {
                className: (0, _indexCssDefault.default).menu
            }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.MyListBoxItem), {
                    id: item.id
                }, item.name))))),
    parameters: {
        description: {
            data: "Note this won't filter the items in the listbox because it is fully controlled"
        }
    }
};
const ComboBoxRenderPropsListBoxDynamic = ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.ComboBox), null, ({ isOpen })=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Label), {
            style: {
                display: "block"
            }
        }, "Test"), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
            style: {
                display: "flex"
            }
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Input), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Button), null, /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
            "aria-hidden": "true",
            style: {
                padding: "0 2px"
            }
        }, isOpen ? "\u25B2" : "\u25BC"))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Popover), {
            placement: "bottom end"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.ListBox), {
            className: (0, _indexCssDefault.default).menu,
            items: items
        }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.MyListBoxItem), {
                id: item.id
            }, item.name)))));
const ComboBoxAsyncLoadingExample = ()=>{
    let list = (0, _reactStately.useAsyncList)({
        async load ({ filterText }) {
            let json = await new Promise((resolve)=>{
                setTimeout(()=>{
                    resolve(filterText ? items.filter((item)=>{
                        let name = item.name.toLowerCase();
                        for (let filterChar of filterText.toLowerCase()){
                            if (!name.includes(filterChar)) return false;
                            name = name.replace(filterChar, "");
                        }
                        return true;
                    }) : items);
                }, 300);
            });
            return {
                items: json
            };
        }
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.ComboBox), {
        items: list.items,
        inputValue: list.filterText,
        onInputChange: list.setFilterText
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Label), {
        style: {
            display: "block"
        }
    }, "Test"), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        style: {
            display: "flex"
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Input), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Button), null, /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        "aria-hidden": "true",
        style: {
            padding: "0 2px"
        }
    }, "\u25BC"))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Popover), {
        placement: "bottom end"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.ListBox), {
        className: (0, _indexCssDefault.default).menu
    }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.MyListBoxItem), null, item.name))));
};

},{"react-aria-components":"lFSUH","./utils":"dnebt","react":"9yzVZ","../example/index.css":"cvBoO","react-stately":"ij62t","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"dnebt":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MyListBoxItem", ()=>MyListBoxItem);
parcelHelpers.export(exports, "MyMenuItem", ()=>MyMenuItem);
var _utils = require("@react-spectrum/utils");
var _reactAriaComponents = require("react-aria-components");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _indexCss = require("../example/index.css");
var _indexCssDefault = parcelHelpers.interopDefault(_indexCss);
const MyListBoxItem = (props)=>{
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.ListBoxItem), {
        ...props,
        className: ({ isFocused, isSelected, isHovered })=>(0, _utils.classNames)((0, _indexCssDefault.default), "item", {
                focused: isFocused,
                selected: isSelected,
                hovered: isHovered
            })
    });
};
const MyMenuItem = (props)=>{
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.MenuItem), {
        ...props,
        className: ({ isFocused, isSelected, isOpen })=>(0, _utils.classNames)((0, _indexCssDefault.default), "item", {
                focused: isFocused,
                selected: isSelected,
                open: isOpen
            })
    });
};

},{"@react-spectrum/utils":"cMIJ6","react-aria-components":"lFSUH","react":"9yzVZ","../example/index.css":"cvBoO","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"cMIJ6":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /// <reference types="css-module-types" />
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "shouldKeepSpectrumClassNames", ()=>(0, _classNames.shouldKeepSpectrumClassNames));
parcelHelpers.export(exports, "keepSpectrumClassNames", ()=>(0, _classNames.keepSpectrumClassNames));
parcelHelpers.export(exports, "classNames", ()=>(0, _classNames.classNames));
parcelHelpers.export(exports, "getWrappedElement", ()=>(0, _getWrappedElement.getWrappedElement));
parcelHelpers.export(exports, "useMediaQuery", ()=>(0, _useMediaQuery.useMediaQuery));
parcelHelpers.export(exports, "createDOMRef", ()=>(0, _useDOMRef.createDOMRef));
parcelHelpers.export(exports, "createFocusableRef", ()=>(0, _useDOMRef.createFocusableRef));
parcelHelpers.export(exports, "useDOMRef", ()=>(0, _useDOMRef.useDOMRef));
parcelHelpers.export(exports, "useFocusableRef", ()=>(0, _useDOMRef.useFocusableRef));
parcelHelpers.export(exports, "unwrapDOMRef", ()=>(0, _useDOMRef.unwrapDOMRef));
parcelHelpers.export(exports, "useUnwrapDOMRef", ()=>(0, _useDOMRef.useUnwrapDOMRef));
parcelHelpers.export(exports, "baseStyleProps", ()=>(0, _styleProps.baseStyleProps));
parcelHelpers.export(exports, "viewStyleProps", ()=>(0, _styleProps.viewStyleProps));
parcelHelpers.export(exports, "dimensionValue", ()=>(0, _styleProps.dimensionValue));
parcelHelpers.export(exports, "responsiveDimensionValue", ()=>(0, _styleProps.responsiveDimensionValue));
parcelHelpers.export(exports, "convertStyleProps", ()=>(0, _styleProps.convertStyleProps));
parcelHelpers.export(exports, "useStyleProps", ()=>(0, _styleProps.useStyleProps));
parcelHelpers.export(exports, "passthroughStyle", ()=>(0, _styleProps.passthroughStyle));
parcelHelpers.export(exports, "getResponsiveProp", ()=>(0, _styleProps.getResponsiveProp));
parcelHelpers.export(exports, "useSlotProps", ()=>(0, _slots.useSlotProps));
parcelHelpers.export(exports, "cssModuleToSlots", ()=>(0, _slots.cssModuleToSlots));
parcelHelpers.export(exports, "SlotProvider", ()=>(0, _slots.SlotProvider));
parcelHelpers.export(exports, "ClearSlots", ()=>(0, _slots.ClearSlots));
parcelHelpers.export(exports, "useHasChild", ()=>(0, _useHasChild.useHasChild));
parcelHelpers.export(exports, "useIsMobileDevice", ()=>(0, _useIsMobileDevice.useIsMobileDevice));
parcelHelpers.export(exports, "useValueEffect", ()=>(0, _utils.useValueEffect));
parcelHelpers.export(exports, "BreakpointProvider", ()=>(0, _breakpointProvider.BreakpointProvider));
parcelHelpers.export(exports, "useMatchedBreakpoints", ()=>(0, _breakpointProvider.useMatchedBreakpoints));
parcelHelpers.export(exports, "useBreakpoint", ()=>(0, _breakpointProvider.useBreakpoint));
parcelHelpers.export(exports, "useResizeObserver", ()=>(0, _utils.useResizeObserver));
var _classNames = require("./classNames");
var _getWrappedElement = require("./getWrappedElement");
var _useMediaQuery = require("./useMediaQuery");
var _useDOMRef = require("./useDOMRef");
var _styleProps = require("./styleProps");
var _slots = require("./Slots");
var _useHasChild = require("./useHasChild");
var _useIsMobileDevice = require("./useIsMobileDevice");
var _utils = require("@react-aria/utils");
var _breakpointProvider = require("./BreakpointProvider");

},{"./classNames":"iZws2","./getWrappedElement":"21JOH","./useMediaQuery":"hnfTJ","./useDOMRef":"aO5yS","./styleProps":"kDtGO","./Slots":"fmsiB","./useHasChild":"g8nbb","./useIsMobileDevice":"3DJfx","@react-aria/utils":"9cLk5","./BreakpointProvider":"1tmsN","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"iZws2":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "shouldKeepSpectrumClassNames", ()=>shouldKeepSpectrumClassNames);
parcelHelpers.export(exports, "keepSpectrumClassNames", ()=>keepSpectrumClassNames);
parcelHelpers.export(exports, "classNames", ()=>classNames);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
let shouldKeepSpectrumClassNames = false;
function keepSpectrumClassNames() {
    shouldKeepSpectrumClassNames = true;
    console.warn("Legacy spectrum-prefixed class names enabled for backward compatibility. We recommend replacing instances of CSS overrides targeting spectrum selectors in your app with custom class names of your own, and disabling this flag.");
}
function classNames(cssModule, ...values) {
    let classes = [];
    for (let value of values){
        if (typeof value === "object" && value) {
            let mapped = {};
            for(let key in value){
                if (cssModule[key]) mapped[cssModule[key]] = value[key];
                if (shouldKeepSpectrumClassNames || !cssModule[key]) mapped[key] = value[key];
            }
            classes.push(mapped);
        } else if (typeof value === "string") {
            if (cssModule[value]) classes.push(cssModule[value]);
            if (shouldKeepSpectrumClassNames || !cssModule[value]) classes.push(value);
        } else classes.push(value);
    }
    return (0, _clsxDefault.default)(...classes);
}

},{"clsx":"fAYNK","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"21JOH":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getWrappedElement", ()=>getWrappedElement);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
function getWrappedElement(children) {
    let element;
    if (typeof children === "string") element = /*#__PURE__*/ (0, _reactDefault.default).createElement("span", null, children);
    else element = (0, _reactDefault.default).Children.only(children);
    return element;
}

},{"react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"hnfTJ":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useMediaQuery", ()=>useMediaQuery);
var _react = require("react");
var _ssr = require("@react-aria/ssr");
function useMediaQuery(query) {
    let supportsMatchMedia = typeof window !== "undefined" && typeof window.matchMedia === "function";
    let [matches, setMatches] = (0, _react.useState)(()=>supportsMatchMedia ? window.matchMedia(query).matches : false);
    (0, _react.useEffect)(()=>{
        if (!supportsMatchMedia) return;
        let mq = window.matchMedia(query);
        let onChange = (evt)=>{
            setMatches(evt.matches);
        };
        mq.addListener(onChange);
        return ()=>{
            mq.removeListener(onChange);
        };
    }, [
        supportsMatchMedia,
        query
    ]);
    // If in SSR, the media query should never match. Once the page hydrates,
    // this will update and the real value will be returned.
    let isSSR = (0, _ssr.useIsSSR)();
    return isSSR ? false : matches;
}

},{"react":"9yzVZ","@react-aria/ssr":"gmUOW","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"aO5yS":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createDOMRef", ()=>createDOMRef);
parcelHelpers.export(exports, "createFocusableRef", ()=>createFocusableRef);
parcelHelpers.export(exports, "useDOMRef", ()=>useDOMRef);
parcelHelpers.export(exports, "useFocusableRef", ()=>useFocusableRef);
parcelHelpers.export(exports, "unwrapDOMRef", ()=>unwrapDOMRef);
parcelHelpers.export(exports, "useUnwrapDOMRef", ()=>useUnwrapDOMRef);
var _react = require("react");
function createDOMRef(ref) {
    return {
        UNSAFE_getDOMNode () {
            return ref.current;
        }
    };
}
function createFocusableRef(domRef, focusableRef = domRef) {
    return {
        ...createDOMRef(domRef),
        focus () {
            if (focusableRef.current) focusableRef.current.focus();
        }
    };
}
function useDOMRef(ref) {
    let domRef = (0, _react.useRef)(null);
    (0, _react.useImperativeHandle)(ref, ()=>createDOMRef(domRef));
    return domRef;
}
function useFocusableRef(ref, focusableRef) {
    let domRef = (0, _react.useRef)(null);
    (0, _react.useImperativeHandle)(ref, ()=>createFocusableRef(domRef, focusableRef));
    return domRef;
}
function unwrapDOMRef(ref) {
    return {
        get current () {
            return ref.current && ref.current.UNSAFE_getDOMNode();
        }
    };
}
function useUnwrapDOMRef(ref) {
    return (0, _react.useMemo)(()=>unwrapDOMRef(ref), [
        ref
    ]);
}

},{"react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"kDtGO":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "baseStyleProps", ()=>baseStyleProps);
parcelHelpers.export(exports, "viewStyleProps", ()=>viewStyleProps);
parcelHelpers.export(exports, "dimensionValue", ()=>dimensionValue);
parcelHelpers.export(exports, "responsiveDimensionValue", ()=>responsiveDimensionValue);
parcelHelpers.export(exports, "convertStyleProps", ()=>convertStyleProps);
parcelHelpers.export(exports, "useStyleProps", ()=>useStyleProps);
parcelHelpers.export(exports, "passthroughStyle", ()=>passthroughStyle);
parcelHelpers.export(exports, "getResponsiveProp", ()=>getResponsiveProp);
var _breakpointProvider = require("./BreakpointProvider");
var _i18N = require("@react-aria/i18n");
const baseStyleProps = {
    margin: [
        "margin",
        dimensionValue
    ],
    marginStart: [
        rtl("marginLeft", "marginRight"),
        dimensionValue
    ],
    marginEnd: [
        rtl("marginRight", "marginLeft"),
        dimensionValue
    ],
    // marginLeft: ['marginLeft', dimensionValue],
    // marginRight: ['marginRight', dimensionValue],
    marginTop: [
        "marginTop",
        dimensionValue
    ],
    marginBottom: [
        "marginBottom",
        dimensionValue
    ],
    marginX: [
        [
            "marginLeft",
            "marginRight"
        ],
        dimensionValue
    ],
    marginY: [
        [
            "marginTop",
            "marginBottom"
        ],
        dimensionValue
    ],
    width: [
        "width",
        dimensionValue
    ],
    height: [
        "height",
        dimensionValue
    ],
    minWidth: [
        "minWidth",
        dimensionValue
    ],
    minHeight: [
        "minHeight",
        dimensionValue
    ],
    maxWidth: [
        "maxWidth",
        dimensionValue
    ],
    maxHeight: [
        "maxHeight",
        dimensionValue
    ],
    isHidden: [
        "display",
        hiddenValue
    ],
    alignSelf: [
        "alignSelf",
        passthroughStyle
    ],
    justifySelf: [
        "justifySelf",
        passthroughStyle
    ],
    position: [
        "position",
        anyValue
    ],
    zIndex: [
        "zIndex",
        anyValue
    ],
    top: [
        "top",
        dimensionValue
    ],
    bottom: [
        "bottom",
        dimensionValue
    ],
    start: [
        rtl("left", "right"),
        dimensionValue
    ],
    end: [
        rtl("right", "left"),
        dimensionValue
    ],
    left: [
        "left",
        dimensionValue
    ],
    right: [
        "right",
        dimensionValue
    ],
    order: [
        "order",
        anyValue
    ],
    flex: [
        "flex",
        flexValue
    ],
    flexGrow: [
        "flexGrow",
        passthroughStyle
    ],
    flexShrink: [
        "flexShrink",
        passthroughStyle
    ],
    flexBasis: [
        "flexBasis",
        passthroughStyle
    ],
    gridArea: [
        "gridArea",
        passthroughStyle
    ],
    gridColumn: [
        "gridColumn",
        passthroughStyle
    ],
    gridColumnEnd: [
        "gridColumnEnd",
        passthroughStyle
    ],
    gridColumnStart: [
        "gridColumnStart",
        passthroughStyle
    ],
    gridRow: [
        "gridRow",
        passthroughStyle
    ],
    gridRowEnd: [
        "gridRowEnd",
        passthroughStyle
    ],
    gridRowStart: [
        "gridRowStart",
        passthroughStyle
    ]
};
const viewStyleProps = {
    ...baseStyleProps,
    backgroundColor: [
        "backgroundColor",
        backgroundColorValue
    ],
    borderWidth: [
        "borderWidth",
        borderSizeValue
    ],
    borderStartWidth: [
        rtl("borderLeftWidth", "borderRightWidth"),
        borderSizeValue
    ],
    borderEndWidth: [
        rtl("borderRightWidth", "borderLeftWidth"),
        borderSizeValue
    ],
    borderLeftWidth: [
        "borderLeftWidth",
        borderSizeValue
    ],
    borderRightWidth: [
        "borderRightWidth",
        borderSizeValue
    ],
    borderTopWidth: [
        "borderTopWidth",
        borderSizeValue
    ],
    borderBottomWidth: [
        "borderBottomWidth",
        borderSizeValue
    ],
    borderXWidth: [
        [
            "borderLeftWidth",
            "borderRightWidth"
        ],
        borderSizeValue
    ],
    borderYWidth: [
        [
            "borderTopWidth",
            "borderBottomWidth"
        ],
        borderSizeValue
    ],
    borderColor: [
        "borderColor",
        borderColorValue
    ],
    borderStartColor: [
        rtl("borderLeftColor", "borderRightColor"),
        borderColorValue
    ],
    borderEndColor: [
        rtl("borderRightColor", "borderLeftColor"),
        borderColorValue
    ],
    borderLeftColor: [
        "borderLeftColor",
        borderColorValue
    ],
    borderRightColor: [
        "borderRightColor",
        borderColorValue
    ],
    borderTopColor: [
        "borderTopColor",
        borderColorValue
    ],
    borderBottomColor: [
        "borderBottomColor",
        borderColorValue
    ],
    borderXColor: [
        [
            "borderLeftColor",
            "borderRightColor"
        ],
        borderColorValue
    ],
    borderYColor: [
        [
            "borderTopColor",
            "borderBottomColor"
        ],
        borderColorValue
    ],
    borderRadius: [
        "borderRadius",
        borderRadiusValue
    ],
    borderTopStartRadius: [
        rtl("borderTopLeftRadius", "borderTopRightRadius"),
        borderRadiusValue
    ],
    borderTopEndRadius: [
        rtl("borderTopRightRadius", "borderTopLeftRadius"),
        borderRadiusValue
    ],
    borderBottomStartRadius: [
        rtl("borderBottomLeftRadius", "borderBottomRightRadius"),
        borderRadiusValue
    ],
    borderBottomEndRadius: [
        rtl("borderBottomRightRadius", "borderBottomLeftRadius"),
        borderRadiusValue
    ],
    borderTopLeftRadius: [
        "borderTopLeftRadius",
        borderRadiusValue
    ],
    borderTopRightRadius: [
        "borderTopRightRadius",
        borderRadiusValue
    ],
    borderBottomLeftRadius: [
        "borderBottomLeftRadius",
        borderRadiusValue
    ],
    borderBottomRightRadius: [
        "borderBottomRightRadius",
        borderRadiusValue
    ],
    padding: [
        "padding",
        dimensionValue
    ],
    paddingStart: [
        rtl("paddingLeft", "paddingRight"),
        dimensionValue
    ],
    paddingEnd: [
        rtl("paddingRight", "paddingLeft"),
        dimensionValue
    ],
    paddingLeft: [
        "paddingLeft",
        dimensionValue
    ],
    paddingRight: [
        "paddingRight",
        dimensionValue
    ],
    paddingTop: [
        "paddingTop",
        dimensionValue
    ],
    paddingBottom: [
        "paddingBottom",
        dimensionValue
    ],
    paddingX: [
        [
            "paddingLeft",
            "paddingRight"
        ],
        dimensionValue
    ],
    paddingY: [
        [
            "paddingTop",
            "paddingBottom"
        ],
        dimensionValue
    ],
    overflow: [
        "overflow",
        passthroughStyle
    ]
};
const borderStyleProps = {
    borderWidth: "borderStyle",
    borderLeftWidth: "borderLeftStyle",
    borderRightWidth: "borderRightStyle",
    borderTopWidth: "borderTopStyle",
    borderBottomWidth: "borderBottomStyle"
};
function rtl(ltr, rtl) {
    return (direction)=>direction === "rtl" ? rtl : ltr;
}
const UNIT_RE = /(%|px|em|rem|vw|vh|auto|cm|mm|in|pt|pc|ex|ch|rem|vmin|vmax|fr)$/;
const FUNC_RE = /^\s*\w+\(/;
const SPECTRUM_VARIABLE_RE = /(static-)?size-\d+|single-line-(height|width)/g;
function dimensionValue(value) {
    if (typeof value === "number") return value + "px";
    if (UNIT_RE.test(value)) return value;
    if (FUNC_RE.test(value)) return value.replace(SPECTRUM_VARIABLE_RE, "var(--spectrum-global-dimension-$&, var(--spectrum-alias-$&))");
    return `var(--spectrum-global-dimension-${value}, var(--spectrum-alias-${value}))`;
}
function responsiveDimensionValue(value, matchedBreakpoints) {
    value = getResponsiveProp(value, matchedBreakpoints);
    return dimensionValue(value);
}
function colorValue(value, type = "default", version = 5) {
    if (version > 5) return `var(--spectrum-${value}, var(--spectrum-semantic-${value}-color-${type}))`;
    return `var(--spectrum-legacy-color-${value}, var(--spectrum-global-color-${value}, var(--spectrum-semantic-${value}-color-${type})))`;
}
function backgroundColorValue(value, version = 5) {
    return `var(--spectrum-alias-background-color-${value}, ${colorValue(value, "background", version)})`;
}
function borderColorValue(value, version = 5) {
    if (value === "default") return "var(--spectrum-alias-border-color)";
    return `var(--spectrum-alias-border-color-${value}, ${colorValue(value, "border", version)})`;
}
function borderSizeValue(value) {
    return value && value !== "none" ? `var(--spectrum-alias-border-size-${value})` : "0";
}
function borderRadiusValue(value) {
    return `var(--spectrum-alias-border-radius-${value})`;
}
function hiddenValue(value) {
    return value ? "none" : undefined;
}
function anyValue(value) {
    return value;
}
function flexValue(value) {
    if (typeof value === "boolean") return value ? "1" : undefined;
    return "" + value;
}
function convertStyleProps(props, handlers, direction, matchedBreakpoints) {
    let style = {};
    for(let key in props){
        let styleProp = handlers[key];
        if (!styleProp || props[key] == null) continue;
        let [name, convert] = styleProp;
        if (typeof name === "function") name = name(direction);
        let prop = getResponsiveProp(props[key], matchedBreakpoints);
        let value = convert(prop, props.colorVersion);
        if (Array.isArray(name)) for (let k of name)style[k] = value;
        else style[name] = value;
    }
    for(let prop in borderStyleProps)if (style[prop]) {
        style[borderStyleProps[prop]] = "solid";
        style.boxSizing = "border-box";
    }
    return style;
}
function useStyleProps(props, handlers = baseStyleProps, options = {}) {
    let { UNSAFE_className, UNSAFE_style, ...otherProps } = props;
    let breakpointProvider = (0, _breakpointProvider.useBreakpoint)();
    let { direction } = (0, _i18N.useLocale)();
    let { matchedBreakpoints = (breakpointProvider === null || breakpointProvider === void 0 ? void 0 : breakpointProvider.matchedBreakpoints) || [
        "base"
    ] } = options;
    let styles = convertStyleProps(props, handlers, direction, matchedBreakpoints);
    let style = {
        ...UNSAFE_style,
        ...styles
    };
    // @ts-ignore
    if (otherProps.className) console.warn("The className prop is unsafe and is unsupported in React Spectrum v3. Please use style props with Spectrum variables, or UNSAFE_className if you absolutely must do something custom. Note that this may break in future versions due to DOM structure changes.");
    // @ts-ignore
    if (otherProps.style) console.warn("The style prop is unsafe and is unsupported in React Spectrum v3. Please use style props with Spectrum variables, or UNSAFE_style if you absolutely must do something custom. Note that this may break in future versions due to DOM structure changes.");
    let styleProps = {
        style,
        className: UNSAFE_className
    };
    if (getResponsiveProp(props.isHidden, matchedBreakpoints)) styleProps.hidden = true;
    return {
        styleProps
    };
}
function passthroughStyle(value) {
    return value;
}
function getResponsiveProp(prop, matchedBreakpoints) {
    if (prop && typeof prop === "object" && !Array.isArray(prop)) {
        for(let i = 0; i < matchedBreakpoints.length; i++){
            let breakpoint = matchedBreakpoints[i];
            if (prop[breakpoint] != null) return prop[breakpoint];
        }
        return prop.base;
    }
    return prop;
}

},{"./BreakpointProvider":"1tmsN","@react-aria/i18n":"411rg","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"1tmsN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BreakpointProvider", ()=>BreakpointProvider);
parcelHelpers.export(exports, "useMatchedBreakpoints", ()=>useMatchedBreakpoints);
parcelHelpers.export(exports, "useBreakpoint", ()=>useBreakpoint);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _ssr = require("@react-aria/ssr");
const Context = /*#__PURE__*/ (0, _reactDefault.default).createContext(null);
Context.displayName = "BreakpointContext";
function BreakpointProvider(props) {
    let { children, matchedBreakpoints } = props;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Context.Provider, {
        value: {
            matchedBreakpoints
        }
    }, children);
}
function useMatchedBreakpoints(breakpoints) {
    let entries = Object.entries(breakpoints).sort(([, valueA], [, valueB])=>valueB - valueA);
    let breakpointQueries = entries.map(([, value])=>`(min-width: ${value}px)`);
    let supportsMatchMedia = typeof window !== "undefined" && typeof window.matchMedia === "function";
    let getBreakpointHandler = ()=>{
        let matched = [];
        for(let i in breakpointQueries){
            let query = breakpointQueries[i];
            if (window.matchMedia(query).matches) matched.push(entries[i][0]);
        }
        matched.push("base");
        return matched;
    };
    let [breakpoint, setBreakpoint] = (0, _react.useState)(()=>supportsMatchMedia ? getBreakpointHandler() : [
            "base"
        ]);
    (0, _react.useEffect)(()=>{
        if (!supportsMatchMedia) return;
        let onResize = ()=>{
            const breakpointHandler = getBreakpointHandler();
            setBreakpoint((previousBreakpointHandler)=>{
                if (previousBreakpointHandler.length !== breakpointHandler.length || previousBreakpointHandler.some((breakpoint, idx)=>breakpoint !== breakpointHandler[idx])) return [
                    ...breakpointHandler
                ]; // Return a new array to force state change
                return previousBreakpointHandler;
            });
        };
        window.addEventListener("resize", onResize);
        return ()=>{
            window.removeEventListener("resize", onResize);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        supportsMatchMedia
    ]);
    // If in SSR, the media query should never match. Once the page hydrates,
    // this will update and the real value will be returned.
    let isSSR = (0, _ssr.useIsSSR)();
    return isSSR ? [
        "base"
    ] : breakpoint;
}
function useBreakpoint() {
    return (0, _react.useContext)(Context);
}

},{"react":"9yzVZ","@react-aria/ssr":"gmUOW","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"fmsiB":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useSlotProps", ()=>useSlotProps);
parcelHelpers.export(exports, "cssModuleToSlots", ()=>cssModuleToSlots);
parcelHelpers.export(exports, "SlotProvider", ()=>SlotProvider);
parcelHelpers.export(exports, "ClearSlots", ()=>ClearSlots);
var _utils = require("@react-aria/utils");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
let SlotContext = /*#__PURE__*/ (0, _reactDefault.default).createContext(null);
function useSlotProps(props, defaultSlot) {
    let slot = props.slot || defaultSlot;
    let { [slot]: slotProps = {} } = (0, _react.useContext)(SlotContext) || {};
    return (0, _utils.mergeProps)(props, (0, _utils.mergeProps)(slotProps, {
        id: props.id
    }));
}
function cssModuleToSlots(cssModule) {
    return Object.keys(cssModule).reduce((acc, slot)=>{
        acc[slot] = {
            UNSAFE_className: cssModule[slot]
        };
        return acc;
    }, {});
}
function SlotProvider(props) {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    let parentSlots = (0, _react.useContext)(SlotContext) || {};
    let { slots = {}, children } = props;
    // Merge props for each slot from parent context and props
    let value = (0, _react.useMemo)(()=>Object.keys(parentSlots).concat(Object.keys(slots)).reduce((o, p)=>({
                ...o,
                [p]: (0, _utils.mergeProps)(parentSlots[p] || {}, slots[p] || {})
            }), {}), [
        parentSlots,
        slots
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(SlotContext.Provider, {
        value: value
    }, children);
}
function ClearSlots(props) {
    let { children, ...otherProps } = props;
    let content = children;
    if ((0, _reactDefault.default).Children.toArray(children).length <= 1) {
        if (typeof children === "function") content = /*#__PURE__*/ (0, _reactDefault.default).cloneElement((0, _reactDefault.default).Children.only(children), otherProps);
    }
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(SlotContext.Provider, {
        value: {}
    }, content);
}

},{"@react-aria/utils":"9cLk5","react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"g8nbb":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useHasChild", ()=>useHasChild);
var _react = require("react");
var _utils = require("@react-aria/utils");
function useHasChild(query, ref) {
    let [hasChild, setHasChild] = (0, _react.useState)(true);
    (0, _utils.useLayoutEffect)(()=>{
        setHasChild(!!(ref.current && ref.current.querySelector(query)));
    }, [
        setHasChild,
        query,
        ref
    ]);
    return hasChild;
}

},{"react":"9yzVZ","@react-aria/utils":"9cLk5","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"3DJfx":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useIsMobileDevice", ()=>useIsMobileDevice);
var _ssr = require("@react-aria/ssr");
const MOBILE_SCREEN_WIDTH = 700;
function useIsMobileDevice() {
    let isSSR = (0, _ssr.useIsSSR)();
    if (isSSR || typeof window === "undefined") return false;
    return window.screen.width <= MOBILE_SCREEN_WIDTH;
}

},{"@react-aria/ssr":"gmUOW","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"cvBoO":[function(require,module,exports) {
module.exports["copyable"] = `mONNNa_copyable`;
module.exports["description"] = `mONNNa_description`;
module.exports["draggable"] = `mONNNa_draggable`;
module.exports["dropzone"] = `mONNNa_dropzone`;
module.exports["field"] = `mONNNa_field`;
module.exports["focus-ring"] = `mONNNa_focus-ring`;
module.exports["focused"] = `mONNNa_focused`;
module.exports["group"] = `mONNNa_group`;
module.exports["hovered"] = `mONNNa_hovered`;
module.exports["item"] = `mONNNa_item`;
module.exports["kbd"] = `mONNNa_kbd`;
module.exports["label"] = `mONNNa_label`;
module.exports["menu"] = `mONNNa_menu`;
module.exports["open"] = `mONNNa_open`;
module.exports["placeholder"] = `mONNNa_placeholder`;
module.exports["popover"] = `mONNNa_popover`;
module.exports["radio"] = `mONNNa_radio`;
module.exports["radiogroup"] = `mONNNa_radiogroup`;
module.exports["searchFieldExample"] = `mONNNa_searchFieldExample`;
module.exports["segment"] = `mONNNa_segment`;
module.exports["selected"] = `mONNNa_selected`;
module.exports["slider"] = `mONNNa_slider`;
module.exports["switchExample"] = `mONNNa_switchExample`;
module.exports["switchExample-indicator"] = `mONNNa_switchExample-indicator`;
module.exports["thumb"] = `mONNNa_thumb`;
module.exports["toggleButtonExample"] = `mONNNa_toggleButtonExample`;
module.exports["track"] = `mONNNa_track`;
module.exports["wrapper"] = `mONNNa_wrapper`;

},{}],"kdWVq":[function(require,module,exports) {
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DateFieldExample", ()=>DateFieldExample);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _reactAriaComponents = require("react-aria-components");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _indexCss = require("../example/index.css");
var _indexCssDefault = parcelHelpers.interopDefault(_indexCss);
exports.default = {
    title: "React Aria Components"
};
const DateFieldExample = ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.DateField), {
        "data-testid": "date-field-example"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Label), {
        style: {
            display: "block"
        }
    }, "Date"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.DateInput), {
        className: (0, _indexCssDefault.default).field,
        "data-testid2": "date-input"
    }, (segment)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.DateSegment), {
            segment: segment,
            className: (0, _clsxDefault.default)((0, _indexCssDefault.default).segment, {
                [(0, _indexCssDefault.default).placeholder]: segment.isPlaceholder
            })
        })));

},{"clsx":"fAYNK","react-aria-components":"lFSUH","react":"9yzVZ","../example/index.css":"cvBoO","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"77l3O":[function(require,module,exports) {
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DatePickerExample", ()=>DatePickerExample);
parcelHelpers.export(exports, "DateRangePickerExample", ()=>DateRangePickerExample);
var _reactAriaComponents = require("react-aria-components");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _indexCss = require("../example/index.css");
var _indexCssDefault = parcelHelpers.interopDefault(_indexCss);
exports.default = {
    title: "React Aria Components"
};
const DatePickerExample = ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.DatePicker), {
        "data-testid": "date-picker-example"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Label), {
        style: {
            display: "block"
        }
    }, "Date"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Group), {
        style: {
            display: "inline-flex"
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.DateInput), {
        className: (0, _indexCssDefault.default).field
    }, (segment)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.DateSegment), {
            segment: segment,
            className: (0, _clsxDefault.default)((0, _indexCssDefault.default).segment, {
                [(0, _indexCssDefault.default).placeholder]: segment.isPlaceholder
            })
        })), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Button), null, "\uD83D\uDDD3")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Popover), {
        placement: "bottom start",
        style: {
            background: "Canvas",
            color: "CanvasText",
            border: "1px solid gray",
            padding: 20
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Dialog), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Calendar), {
        style: {
            width: 220
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        style: {
            display: "flex",
            alignItems: "center"
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Button), {
        slot: "previous"
    }, "<"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Heading), {
        style: {
            flex: 1,
            textAlign: "center"
        }
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Button), {
        slot: "next"
    }, ">")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.CalendarGrid), {
        style: {
            width: "100%"
        }
    }, (date)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.CalendarCell), {
            date: date,
            style: ({ isSelected, isOutsideMonth })=>({
                    display: isOutsideMonth ? "none" : "",
                    textAlign: "center",
                    cursor: "default",
                    background: isSelected ? "blue" : ""
                })
        }))))));
const DateRangePickerExample = ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.DateRangePicker), {
        "data-testid": "date-range-picker-example"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Label), {
        style: {
            display: "block"
        }
    }, "Date"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Group), {
        style: {
            display: "inline-flex"
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _indexCssDefault.default).field
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.DateInput), {
        "data-testid": "date-range-picker-date-input",
        slot: "start",
        style: {
            display: "inline-flex"
        }
    }, (segment)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.DateSegment), {
            segment: segment,
            className: (0, _clsxDefault.default)((0, _indexCssDefault.default).segment, {
                [(0, _indexCssDefault.default).placeholder]: segment.isPlaceholder
            })
        })), /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        "aria-hidden": "true",
        style: {
            padding: "0 4px"
        }
    }, "\u2013"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.DateInput), {
        slot: "end",
        style: {
            display: "inline-flex"
        }
    }, (segment)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.DateSegment), {
            segment: segment,
            className: (0, _clsxDefault.default)((0, _indexCssDefault.default).segment, {
                [(0, _indexCssDefault.default).placeholder]: segment.isPlaceholder
            })
        }))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Button), null, "\uD83D\uDDD3")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Popover), {
        placement: "bottom start",
        style: {
            background: "Canvas",
            color: "CanvasText",
            border: "1px solid gray",
            padding: 20
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Dialog), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.RangeCalendar), {
        style: {
            width: 220
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        style: {
            display: "flex",
            alignItems: "center"
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Button), {
        slot: "previous"
    }, "<"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Heading), {
        style: {
            flex: 1,
            textAlign: "center"
        }
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Button), {
        slot: "next"
    }, ">")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.CalendarGrid), {
        style: {
            width: "100%"
        }
    }, (date)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.CalendarCell), {
            date: date,
            style: ({ isSelected, isOutsideMonth })=>({
                    display: isOutsideMonth ? "none" : "",
                    textAlign: "center",
                    cursor: "default",
                    background: isSelected ? "blue" : ""
                })
        }))))));

},{"react-aria-components":"lFSUH","clsx":"fAYNK","react":"9yzVZ","../example/index.css":"cvBoO","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"kvihS":[function(require,module,exports) {
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DropzoneExampleWithFileTriggerLink", ()=>DropzoneExampleWithFileTriggerLink);
parcelHelpers.export(exports, "DropzoneExampleWithFileTriggerButton", ()=>DropzoneExampleWithFileTriggerButton);
parcelHelpers.export(exports, "DropzoneExampleWithDraggableAndFileTrigger", ()=>DropzoneExampleWithDraggableAndFileTrigger);
parcelHelpers.export(exports, "DropZoneOnlyAcceptPNGWithFileTrigger", ()=>DropZoneOnlyAcceptPNGWithFileTrigger);
parcelHelpers.export(exports, "DropZoneWithCaptureMobileOnly", ()=>DropZoneWithCaptureMobileOnly);
parcelHelpers.export(exports, "DropzoneExampleWithDraggableObject", ()=>DropzoneExampleWithDraggableObject);
parcelHelpers.export(exports, "DropzoneExampleWithCopyableObject", ()=>DropzoneExampleWithCopyableObject);
parcelHelpers.export(exports, "DropzoneWithRenderProps", ()=>DropzoneWithRenderProps);
var _addonActions = require("@storybook/addon-actions");
var _reactAriaComponents = require("react-aria-components");
var _utils = require("@react-spectrum/utils");
var _reactAria = require("react-aria");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _indexCss = require("../example/index.css");
var _indexCssDefault = parcelHelpers.interopDefault(_indexCss);
exports.default = {
    title: "React Aria Components"
};
const DropzoneExampleWithFileTriggerLink = (props)=>/*#__PURE__*/ (0, _reactDefault.default).createElement("div", null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.DropZone), {
        ...props,
        "aria-label": "testing aria-label",
        className: (0, _indexCssDefault.default).dropzone,
        "data-testid": "drop-zone-example-with-file-trigger-link",
        onDrop: (0, _addonActions.action)("OnDrop"),
        onDropEnter: (0, _addonActions.action)("OnDropEnter"),
        onDropExit: (0, _addonActions.action)("OnDropExit")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.FileTrigger), {
        onSelect: (0, _addonActions.action)("onSelect")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Link), null, "Upload"))));
const DropzoneExampleWithFileTriggerButton = (props)=>/*#__PURE__*/ (0, _reactDefault.default).createElement("div", null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.DropZone), {
        ...props,
        className: (0, _indexCssDefault.default).dropzone,
        onDrop: (0, _addonActions.action)("OnDrop"),
        onDropEnter: (0, _addonActions.action)("OnDropEnter"),
        onDropExit: (0, _addonActions.action)("OnDropExit")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.FileTrigger), {
        onSelect: (0, _addonActions.action)("onSelect")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Button), null, "Upload"))));
const DropzoneExampleWithDraggableAndFileTrigger = (props)=>/*#__PURE__*/ (0, _reactDefault.default).createElement("div", null, /*#__PURE__*/ (0, _reactDefault.default).createElement(Draggable, null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.DropZone), {
        ...props,
        className: (0, _indexCssDefault.default).dropzone,
        onDrop: (0, _addonActions.action)("OnDrop"),
        onDropEnter: (0, _addonActions.action)("OnDropEnter"),
        onDropExit: (0, _addonActions.action)("OnDropExit")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.FileTrigger), {
        onSelect: (0, _addonActions.action)("onSelect")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Button), null, "Browse")), "Or drag into here"));
const DropZoneOnlyAcceptPNGWithFileTrigger = (props)=>/*#__PURE__*/ (0, _reactDefault.default).createElement("div", null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.DropZone), {
        ...props,
        getDropOperation: (types)=>types.has("image/png") ? "copy" : "cancel",
        className: (0, _indexCssDefault.default).dropzone,
        onPress: (0, _addonActions.action)("OnPress"),
        onDrop: (0, _addonActions.action)("OnDrop"),
        onDropEnter: (0, _addonActions.action)("OnDropEnter"),
        onDropExit: (0, _addonActions.action)("OnDropExit")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.FileTrigger), {
        onSelect: (0, _addonActions.action)("onSelect"),
        acceptedFileTypes: [
            "image/png"
        ]
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Button), null, "Upload"))));
const DropZoneWithCaptureMobileOnly = (props)=>/*#__PURE__*/ (0, _reactDefault.default).createElement("div", null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.DropZone), {
        ...props,
        getDropOperation: (types)=>types.has("image/png") ? "copy" : "cancel",
        className: (0, _indexCssDefault.default).dropzone,
        onPress: (0, _addonActions.action)("OnPress"),
        onDrop: (0, _addonActions.action)("OnDrop"),
        onDropEnter: (0, _addonActions.action)("OnDropEnter"),
        onDropExit: (0, _addonActions.action)("OnDropExit")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.FileTrigger), {
        onSelect: (0, _addonActions.action)("onSelect"),
        defaultCamera: "environment"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Button), null, "Upload"))));
const DropzoneExampleWithDraggableObject = (props)=>/*#__PURE__*/ (0, _reactDefault.default).createElement("div", null, /*#__PURE__*/ (0, _reactDefault.default).createElement(Draggable, null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.DropZone), {
        ...props,
        className: (0, _indexCssDefault.default).dropzone,
        onDrop: (0, _addonActions.action)("OnDrop"),
        onDropEnter: (0, _addonActions.action)("OnDropEnter"),
        onDropExit: (0, _addonActions.action)("OnDropExit")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Text), {
        slot: "label"
    }, "DropZone Area")));
const DropzoneExampleWithCopyableObject = (props)=>/*#__PURE__*/ (0, _reactDefault.default).createElement("div", null, /*#__PURE__*/ (0, _reactDefault.default).createElement(Copyable, null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.DropZone), {
        ...props,
        className: (0, _indexCssDefault.default).dropzone,
        onDrop: (0, _addonActions.action)("OnDrop"),
        onDropEnter: (0, _addonActions.action)("OnDropEnter"),
        onDropExit: (0, _addonActions.action)("OnDropExit")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Text), {
        slot: "label"
    }, "DropZone Area")));
const DropzoneWithRenderProps = (props)=>/*#__PURE__*/ (0, _reactDefault.default).createElement("div", null, /*#__PURE__*/ (0, _reactDefault.default).createElement(Draggable, null), /*#__PURE__*/ (0, _reactDefault.default).createElement(Copyable, null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.DropZone), {
        ...props,
        className: (0, _indexCssDefault.default).dropzone,
        onPress: (0, _addonActions.action)("OnPress"),
        onDrop: (0, _addonActions.action)("OnDrop"),
        onDropEnter: (0, _addonActions.action)("OnDropEnter"),
        onDropExit: (0, _addonActions.action)("OnDropExit")
    }, ({ isHovered, isFocused, isFocusVisible, isDropTarget })=>/*#__PURE__*/ (0, _reactDefault.default).createElement("div", null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Text), {
            slot: "label"
        }, "DropzoneArea"), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", null, "isHovered: ", isHovered ? "true" : "false"), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", null, "isFocused: ", isFocused ? "true" : "false"), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", null, "isFocusVisible: ", isFocusVisible ? "true" : "false"), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", null, "isDropTarget: ", isDropTarget ? "true" : "false"))));
const Draggable = ()=>{
    let buttonRef = (0, _react.useRef)(null);
    let { dragProps, isDragging } = (0, _reactAria.useDrag)({
        getItems () {
            return [
                {
                    "text/plain": "hello world"
                }
            ];
        }
    });
    let { buttonProps } = (0, _reactAria.useButton)({
        elementType: "div"
    }, buttonRef);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAria.FocusRing), {
        focusRingClass: (0, _utils.classNames)((0, _indexCssDefault.default), "focus-ring")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...(0, _reactAria.mergeProps)(buttonProps, dragProps),
        ref: buttonRef,
        className: (0, _utils.classNames)((0, _indexCssDefault.default), "draggable", {
            ["dragging"]: isDragging
        })
    }, "Drag me"));
};
const Copyable = ()=>{
    let { clipboardProps } = (0, _reactAria.useClipboard)({
        getItems () {
            return [
                {
                    "text/plain": "hello world"
                }
            ];
        }
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAria.FocusRing), {
        focusRingClass: (0, _utils.classNames)((0, _indexCssDefault.default), "focus-ring")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...clipboardProps,
        role: "textbox",
        "aria-label": "copyable element",
        tabIndex: 0,
        className: (0, _indexCssDefault.default).copyable
    }, "Copy me"));
};

},{"@storybook/addon-actions":"coXbW","react-aria-components":"lFSUH","@react-spectrum/utils":"cMIJ6","react-aria":"e7jhe","react":"9yzVZ","../example/index.css":"cvBoO","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"coXbW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _constants = require("./constants");
parcelHelpers.exportAll(_constants, exports);
var _models = require("./models");
parcelHelpers.exportAll(_models, exports);
var _preview = require("./preview");
parcelHelpers.exportAll(_preview, exports);
if (module && module.hot && module.hot.decline) module.hot.decline();

},{"./constants":"hnWWW","./models":"vyCat","./preview":"bgTXj","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"hnWWW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PARAM_KEY", ()=>PARAM_KEY);
parcelHelpers.export(exports, "ADDON_ID", ()=>ADDON_ID);
parcelHelpers.export(exports, "PANEL_ID", ()=>PANEL_ID);
parcelHelpers.export(exports, "EVENT_ID", ()=>EVENT_ID);
parcelHelpers.export(exports, "CYCLIC_KEY", ()=>CYCLIC_KEY);
var PARAM_KEY = "actions";
var ADDON_ID = "storybook/actions";
var PANEL_ID = "".concat(ADDON_ID, "/panel");
var EVENT_ID = "".concat(ADDON_ID, "/action-event");
var CYCLIC_KEY = "$___storybook.isCyclic";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"vyCat":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _actionDisplay = require("./ActionDisplay");
parcelHelpers.exportAll(_actionDisplay, exports);
var _actionsFunction = require("./ActionsFunction");
parcelHelpers.exportAll(_actionsFunction, exports);
var _actionOptions = require("./ActionOptions");
parcelHelpers.exportAll(_actionOptions, exports);
var _actionsMap = require("./ActionsMap");
parcelHelpers.exportAll(_actionsMap, exports);
var _decoratorFunction = require("./DecoratorFunction");
parcelHelpers.exportAll(_decoratorFunction, exports);
var _handlerFunction = require("./HandlerFunction");
parcelHelpers.exportAll(_handlerFunction, exports);

},{"./ActionDisplay":"7A95e","./ActionsFunction":"e1Tml","./ActionOptions":"b4egP","./ActionsMap":"cKxoR","./DecoratorFunction":"faaQu","./HandlerFunction":"7jOu9","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"7A95e":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"e1Tml":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"b4egP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"cKxoR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"faaQu":[function(require,module,exports) {

},{}],"7jOu9":[function(require,module,exports) {

},{}],"bgTXj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _action = require("./action");
parcelHelpers.exportAll(_action, exports);
var _actions = require("./actions");
parcelHelpers.exportAll(_actions, exports);
var _configureActions = require("./configureActions");
parcelHelpers.exportAll(_configureActions, exports);
var _decorateAction = require("./decorateAction");
parcelHelpers.exportAll(_decorateAction, exports);
var _withActions = require("./withActions");
parcelHelpers.exportAll(_withActions, exports);

},{"./action":"eBm3L","./actions":"hI4jj","./configureActions":"9o5xY","./decorateAction":"a2vtq","./withActions":"lTvig","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"eBm3L":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "action", ()=>action);
var _esObjectGetPrototypeOfJs = require("core-js/modules/es.object.get-prototype-of.js");
var _esRegexpExecJs = require("core-js/modules/es.regexp.exec.js");
var _esFunctionNameJs = require("core-js/modules/es.function.name.js");
var _esObjectGetOwnPropertyDescriptorsJs = require("core-js/modules/es.object.get-own-property-descriptors.js");
var _esObjectGetOwnPropertyDescriptorJs = require("core-js/modules/es.object.get-own-property-descriptor.js");
var _esObjectAssignJs = require("core-js/modules/es.object.assign.js");
var _esArrayMapJs = require("core-js/modules/es.array.map.js");
var _esSymbolJs = require("core-js/modules/es.symbol.js");
var _esSymbolDescriptionJs = require("core-js/modules/es.symbol.description.js");
var _esObjectToStringJs = require("core-js/modules/es.object.to-string.js");
var _esSymbolIteratorJs = require("core-js/modules/es.symbol.iterator.js");
var _esArrayIteratorJs = require("core-js/modules/es.array.iterator.js");
var _esStringIteratorJs = require("core-js/modules/es.string.iterator.js");
var _webDomCollectionsIteratorJs = require("core-js/modules/web.dom-collections.iterator.js");
var _v4 = require("uuid-browser/v4");
var _v4Default = parcelHelpers.interopDefault(_v4);
var _addons = require("@storybook/addons");
var _constants = require("../constants");
var _configureActions = require("./configureActions");
function _typeof(obj) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
}
// import('react').SyntheticEvent;
var findProto = function findProto(obj, callback) {
    var proto = Object.getPrototypeOf(obj);
    if (!proto || callback(proto)) return proto;
    return findProto(proto, callback);
};
var isReactSyntheticEvent = function isReactSyntheticEvent(e) {
    return Boolean(_typeof(e) === "object" && e && findProto(e, function(proto) {
        return /^Synthetic(?:Base)?Event$/.test(proto.constructor.name);
    }) && typeof e.persist === "function");
};
var serializeArg = function serializeArg(a) {
    if (isReactSyntheticEvent(a)) {
        var e = Object.create(a.constructor.prototype, Object.getOwnPropertyDescriptors(a));
        e.persist();
        var viewDescriptor = Object.getOwnPropertyDescriptor(e, "view"); // don't send the entire window object over.
        var view = viewDescriptor === null || viewDescriptor === void 0 ? void 0 : viewDescriptor.value;
        if (_typeof(view) === "object" && (view === null || view === void 0 ? void 0 : view.constructor.name) === "Window") Object.defineProperty(e, "view", Object.assign({}, viewDescriptor, {
            value: Object.create(view.constructor.prototype)
        }));
        return e;
    }
    return a;
};
function action(name) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var actionOptions = Object.assign({}, (0, _configureActions.config), options);
    var handler = function actionHandler() {
        var channel = (0, _addons.addons).getChannel();
        var id = (0, _v4Default.default)();
        var minDepth = 5; // anything less is really just storybook internals
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serializedArgs = args.map(serializeArg);
        var normalizedArgs = args.length > 1 ? serializedArgs : serializedArgs[0];
        var actionDisplayToEmit = {
            id: id,
            count: 0,
            data: {
                name: name,
                args: normalizedArgs
            },
            options: Object.assign({}, actionOptions, {
                maxDepth: minDepth + (actionOptions.depth || 3),
                allowFunction: actionOptions.allowFunction || false
            })
        };
        channel.emit((0, _constants.EVENT_ID), actionDisplayToEmit);
    };
    return handler;
}

},{"core-js/modules/es.object.get-prototype-of.js":"kLLpv","core-js/modules/es.regexp.exec.js":"5q56v","core-js/modules/es.function.name.js":"4LiLL","core-js/modules/es.object.get-own-property-descriptors.js":"cdW1C","core-js/modules/es.object.get-own-property-descriptor.js":"cBMA1","core-js/modules/es.object.assign.js":"8FU8M","core-js/modules/es.array.map.js":"jTP7e","core-js/modules/es.symbol.js":"ajw2f","core-js/modules/es.symbol.description.js":"wrlLc","core-js/modules/es.object.to-string.js":"lsA9p","core-js/modules/es.symbol.iterator.js":"fhNIb","core-js/modules/es.array.iterator.js":"ieU20","core-js/modules/es.string.iterator.js":"74a8v","core-js/modules/web.dom-collections.iterator.js":"aXR96","uuid-browser/v4":"boC7G","@storybook/addons":"88cx9","../constants":"hnWWW","./configureActions":"9o5xY","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"cdW1C":[function(require,module,exports) {
var $ = require("40e7403e4fec8fc5");
var DESCRIPTORS = require("4e8e0ded689e341a");
var ownKeys = require("ca8e12f795281afd");
var toIndexedObject = require("2a0629723aea50a6");
var getOwnPropertyDescriptorModule = require("d8f1f7a76c234914");
var createProperty = require("d34666d556a98edd");
// `Object.getOwnPropertyDescriptors` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptors
$({
    target: "Object",
    stat: true,
    sham: !DESCRIPTORS
}, {
    getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
        var O = toIndexedObject(object);
        var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
        var keys = ownKeys(O);
        var result = {};
        var index = 0;
        var key, descriptor;
        while(keys.length > index){
            descriptor = getOwnPropertyDescriptor(O, key = keys[index++]);
            if (descriptor !== undefined) createProperty(result, key, descriptor);
        }
        return result;
    }
});

},{"40e7403e4fec8fc5":"1OO62","4e8e0ded689e341a":"7Hk5a","ca8e12f795281afd":"dyvB8","2a0629723aea50a6":"5DeQ5","d8f1f7a76c234914":"8cErP","d34666d556a98edd":"3yb4H"}],"boC7G":[function(require,module,exports) {
var rng = require("200c257eeef967d9");
var bytesToUuid = require("895520ec61482c4e");
function v4(options, buf, offset) {
    var i = buf && offset || 0;
    if (typeof options == "string") {
        buf = options == "binary" ? new Array(16) : null;
        options = null;
    }
    options = options || {};
    var rnds = options.random || (options.rng || rng)();
    // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80;
    // Copy bytes to buffer, if provided
    if (buf) for(var ii = 0; ii < 16; ++ii)buf[i + ii] = rnds[ii];
    return buf || bytesToUuid(rnds);
}
module.exports = v4;

},{"200c257eeef967d9":"baozF","895520ec61482c4e":"i8Y4w"}],"baozF":[function(require,module,exports) {
// Unique ID creation requires a high quality random # generator.  In the
// browser this is a little complicated due to unknown quality of Math.random()
// and inconsistent support for the `crypto` API.  We do the best we can via
// feature-detection
var global = arguments[3];
var rng;
var crypto = typeof global !== "undefined" && (global.crypto || global.msCrypto); // for IE 11
if (crypto && crypto.getRandomValues) {
    // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
    var rnds8 = new Uint8Array(16); // eslint-disable-line no-undef
    rng = function whatwgRNG() {
        crypto.getRandomValues(rnds8);
        return rnds8;
    };
}
if (!rng) {
    // Math.random()-based (RNG)
    //
    // If all else fails, use Math.random().  It's fast, but is of unspecified
    // quality.
    var rnds = new Array(16);
    rng = function() {
        for(var i = 0, r; i < 16; i++){
            if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
            rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
        }
        return rnds;
    };
}
module.exports = rng;

},{}],"i8Y4w":[function(require,module,exports) {
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var byteToHex = [];
for(var i = 0; i < 256; ++i)byteToHex[i] = (i + 0x100).toString(16).substr(1);
function bytesToUuid(buf, offset) {
    var i = offset || 0;
    var bth = byteToHex;
    return bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + "-" + bth[buf[i++]] + bth[buf[i++]] + "-" + bth[buf[i++]] + bth[buf[i++]] + "-" + bth[buf[i++]] + bth[buf[i++]] + "-" + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]];
}
module.exports = bytesToUuid;

},{}],"9o5xY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "config", ()=>config);
parcelHelpers.export(exports, "configureActions", ()=>configureActions);
var _esObjectAssignJs = require("core-js/modules/es.object.assign.js");
var config = {
    depth: 10,
    clearOnStoryChange: true,
    limit: 50
};
var configureActions = function configureActions() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    Object.assign(config, options);
};

},{"core-js/modules/es.object.assign.js":"8FU8M","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"hI4jj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "actions", ()=>actions);
var _esObjectAssignJs = require("core-js/modules/es.object.assign.js");
var _esObjectToStringJs = require("core-js/modules/es.object.to-string.js");
var _webDomCollectionsForEachJs = require("core-js/modules/web.dom-collections.for-each.js");
var _esObjectKeysJs = require("core-js/modules/es.object.keys.js");
var _esSymbolJs = require("core-js/modules/es.symbol.js");
var _esSymbolDescriptionJs = require("core-js/modules/es.symbol.description.js");
var _esSymbolIteratorJs = require("core-js/modules/es.symbol.iterator.js");
var _esArrayIteratorJs = require("core-js/modules/es.array.iterator.js");
var _esStringIteratorJs = require("core-js/modules/es.string.iterator.js");
var _webDomCollectionsIteratorJs = require("core-js/modules/web.dom-collections.iterator.js");
var _esArraySliceJs = require("core-js/modules/es.array.slice.js");
var _esFunctionNameJs = require("core-js/modules/es.function.name.js");
var _esArrayFromJs = require("core-js/modules/es.array.from.js");
var _esRegexpExecJs = require("core-js/modules/es.regexp.exec.js");
var _action = require("./action");
var _configureActions = require("./configureActions");
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var actions = function actions() {
    var options = (0, _configureActions.config);
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    var names = args; // args argument can be a single argument as an array
    if (names.length === 1 && Array.isArray(names[0])) {
        var _names = names;
        var _names2 = _slicedToArray(_names, 1);
        names = _names2[0];
    } // last argument can be options
    if (names.length !== 1 && typeof names[names.length - 1] !== "string") options = Object.assign({}, (0, _configureActions.config), names.pop());
    var namesObject = names[0];
    if (names.length !== 1 || typeof namesObject === "string") {
        namesObject = {};
        names.forEach(function(name) {
            namesObject[name] = name;
        });
    }
    var actionsObject = {};
    Object.keys(namesObject).forEach(function(name) {
        actionsObject[name] = (0, _action.action)(namesObject[name], options);
    });
    return actionsObject;
};

},{"core-js/modules/es.object.assign.js":"8FU8M","core-js/modules/es.object.to-string.js":"lsA9p","core-js/modules/web.dom-collections.for-each.js":"iYT1M","core-js/modules/es.object.keys.js":"5Q2AT","core-js/modules/es.symbol.js":"ajw2f","core-js/modules/es.symbol.description.js":"wrlLc","core-js/modules/es.symbol.iterator.js":"fhNIb","core-js/modules/es.array.iterator.js":"ieU20","core-js/modules/es.string.iterator.js":"74a8v","core-js/modules/web.dom-collections.iterator.js":"aXR96","core-js/modules/es.array.slice.js":"8RRh9","core-js/modules/es.function.name.js":"4LiLL","core-js/modules/es.array.from.js":"9UCQw","core-js/modules/es.regexp.exec.js":"5q56v","./action":"eBm3L","./configureActions":"9o5xY","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"a2vtq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "decorateAction", ()=>decorateAction);
parcelHelpers.export(exports, "decorate", ()=>decorate);
var _esArraySliceJs = require("core-js/modules/es.array.slice.js");
var _esObjectFreezeJs = require("core-js/modules/es.object.freeze.js");
var _utilDeprecate = require("util-deprecate");
var _utilDeprecateDefault = parcelHelpers.interopDefault(_utilDeprecate);
var _tsDedent = require("ts-dedent");
var _tsDedentDefault = parcelHelpers.interopDefault(_tsDedent);
var _templateObject, _templateObject2;
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) raw = strings.slice(0);
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
var decorateAction = function decorateAction(_decorators) {
    return (0, _utilDeprecateDefault.default)(function() {}, (0, _tsDedentDefault.default)(_templateObject || (_templateObject = _taggedTemplateLiteral([
        "\n    decorateAction is no longer supported as of Storybook 6.0.\n  "
    ]))));
};
var deprecatedCallback = (0, _utilDeprecateDefault.default)(function() {}, "decorate.* is no longer supported as of Storybook 6.0.");
var decorate = function decorate(_decorators) {
    return (0, _utilDeprecateDefault.default)(function() {
        return {
            action: deprecatedCallback,
            actions: deprecatedCallback,
            withActions: deprecatedCallback
        };
    }, (0, _tsDedentDefault.default)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral([
        "\n    decorate is deprecated, please configure addon-actions using the addParameter api:\n      \n      addParameters({\n        actions: {\n          handles: options\n        },\n      });\n    "
    ]))));
};

},{"core-js/modules/es.array.slice.js":"8RRh9","core-js/modules/es.object.freeze.js":"9LVYO","util-deprecate":"lYmRJ","ts-dedent":"9RvVa","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"lTvig":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "withActions", ()=>withActions);
var _esSymbolJs = require("core-js/modules/es.symbol.js");
var _esSymbolDescriptionJs = require("core-js/modules/es.symbol.description.js");
var _esSymbolIteratorJs = require("core-js/modules/es.symbol.iterator.js");
var _esArrayIteratorJs = require("core-js/modules/es.array.iterator.js");
var _esStringIteratorJs = require("core-js/modules/es.string.iterator.js");
var _webDomCollectionsIteratorJs = require("core-js/modules/web.dom-collections.iterator.js");
var _esArraySliceJs = require("core-js/modules/es.array.slice.js");
var _esFunctionNameJs = require("core-js/modules/es.function.name.js");
var _esArrayFromJs = require("core-js/modules/es.array.from.js");
var _esObjectFreezeJs = require("core-js/modules/es.object.freeze.js");
var _esArrayMapJs = require("core-js/modules/es.array.map.js");
var _esObjectEntriesJs = require("core-js/modules/es.object.entries.js");
var _esRegexpExecJs = require("core-js/modules/es.regexp.exec.js");
var _esStringMatchJs = require("core-js/modules/es.string.match.js");
var _esArrayConcatJs = require("core-js/modules/es.array.concat.js");
var _esObjectToStringJs = require("core-js/modules/es.object.to-string.js");
var _webDomCollectionsForEachJs = require("core-js/modules/web.dom-collections.for-each.js");
// Based on http://backbonejs.org/docs/backbone.html#section-164
var _global = require("global");
var _globalDefault = parcelHelpers.interopDefault(_global);
var _addons = require("@storybook/addons");
var _utilDeprecate = require("util-deprecate");
var _utilDeprecateDefault = parcelHelpers.interopDefault(_utilDeprecate);
var _tsDedent = require("ts-dedent");
var _tsDedentDefault = parcelHelpers.interopDefault(_tsDedent);
var _actions = require("./actions");
var _constants = require("../constants");
var _templateObject;
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) raw = strings.slice(0);
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var document = (0, _globalDefault.default).document, Element = (0, _globalDefault.default).Element;
var delegateEventSplitter = /^(\S+)\s*(.*)$/;
var isIE = Element != null && !Element.prototype.matches;
var matchesMethod = isIE ? "msMatchesSelector" : "matches";
var root = document && document.getElementById("root");
var hasMatchInAncestry = function hasMatchInAncestry(element, selector) {
    if (element[matchesMethod](selector)) return true;
    var parent = element.parentElement;
    if (!parent) return false;
    return hasMatchInAncestry(parent, selector);
};
var createHandlers = function createHandlers(actionsFn) {
    for(var _len = arguments.length, handles = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)handles[_key - 1] = arguments[_key];
    var actionsObject = actionsFn.apply(void 0, handles);
    return Object.entries(actionsObject).map(function(_ref) {
        var _ref2 = _slicedToArray(_ref, 2), key = _ref2[0], action = _ref2[1];
        var _key$match = key.match(delegateEventSplitter), _key$match2 = _slicedToArray(_key$match, 3), _ = _key$match2[0], eventName = _key$match2[1], selector = _key$match2[2];
        return {
            eventName: eventName,
            handler: function handler(e) {
                if (!selector || hasMatchInAncestry(e.target, selector)) action(e);
            }
        };
    });
};
var applyEventHandlers = (0, _utilDeprecateDefault.default)(function(actionsFn) {
    for(var _len2 = arguments.length, handles = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)handles[_key2 - 1] = arguments[_key2];
    (0, _addons.useEffect)(function() {
        if (root != null) {
            var handlers = createHandlers.apply(void 0, [
                actionsFn
            ].concat(handles));
            handlers.forEach(function(_ref3) {
                var eventName = _ref3.eventName, handler = _ref3.handler;
                return root.addEventListener(eventName, handler);
            });
            return function() {
                return handlers.forEach(function(_ref4) {
                    var eventName = _ref4.eventName, handler = _ref4.handler;
                    return root.removeEventListener(eventName, handler);
                });
            };
        }
        return undefined;
    }, [
        root,
        actionsFn,
        handles
    ]);
}, (0, _tsDedentDefault.default)(_templateObject || (_templateObject = _taggedTemplateLiteral([
    "\n    withActions(options) is deprecated, please configure addon-actions using the addParameter api:\n\n    addParameters({\n      actions: {\n        handles: options\n      },\n    });\n  "
]))));
var applyDeprecatedOptions = function applyDeprecatedOptions(actionsFn, options) {
    if (options) applyEventHandlers(actionsFn, options);
};
var withActions = (0, _addons.makeDecorator)({
    name: "withActions",
    parameterName: (0, _constants.PARAM_KEY),
    skipIfNoParametersOrOptions: true,
    wrapper: function wrapper(getStory, context, _ref5) {
        var parameters = _ref5.parameters, options = _ref5.options;
        applyDeprecatedOptions((0, _actions.actions), options);
        if (parameters && parameters.handles) applyEventHandlers.apply(void 0, [
            (0, _actions.actions)
        ].concat(_toConsumableArray(parameters.handles)));
        return getStory(context);
    }
});

},{"core-js/modules/es.symbol.js":"ajw2f","core-js/modules/es.symbol.description.js":"wrlLc","core-js/modules/es.symbol.iterator.js":"fhNIb","core-js/modules/es.array.iterator.js":"ieU20","core-js/modules/es.string.iterator.js":"74a8v","core-js/modules/web.dom-collections.iterator.js":"aXR96","core-js/modules/es.array.slice.js":"8RRh9","core-js/modules/es.function.name.js":"4LiLL","core-js/modules/es.array.from.js":"9UCQw","core-js/modules/es.object.freeze.js":"9LVYO","core-js/modules/es.array.map.js":"jTP7e","core-js/modules/es.object.entries.js":"7Wf79","core-js/modules/es.regexp.exec.js":"5q56v","core-js/modules/es.string.match.js":"e2YpX","core-js/modules/es.array.concat.js":"g1t7q","core-js/modules/es.object.to-string.js":"lsA9p","core-js/modules/web.dom-collections.for-each.js":"iYT1M","global":"5PzlO","@storybook/addons":"88cx9","util-deprecate":"lYmRJ","ts-dedent":"9RvVa","./actions":"hI4jj","../constants":"hnWWW","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"fYs3Q":[function(require,module,exports) {
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FileTriggerButton", ()=>FileTriggerButton);
parcelHelpers.export(exports, "FileTriggerDirectories", ()=>FileTriggerDirectories);
parcelHelpers.export(exports, "FileTriggerLinkAllowsMultiple", ()=>FileTriggerLinkAllowsMultiple);
var _addonActions = require("@storybook/addon-actions");
var _reactAriaComponents = require("react-aria-components");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
exports.default = {
    title: "React Aria Components"
};
const FileTriggerButton = (props)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.FileTrigger), {
        onSelect: (0, _addonActions.action)("onSelect"),
        "data-testid": "filetrigger-example",
        ...props
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Button), null, "Upload"));
const FileTriggerDirectories = (props)=>{
    let [files, setFiles] = (0, _reactDefault.default).useState([]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.FileTrigger), {
        ...props,
        acceptDirectory: true,
        onSelect: (e)=>{
            if (e) {
                let fileList = [
                    ...e
                ].map((file)=>file.webkitRelativePath !== "" ? file.webkitRelativePath : file.name);
                setFiles(fileList);
            }
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Button), null, "Upload")), files && /*#__PURE__*/ (0, _reactDefault.default).createElement("ul", null, files.map((file, index)=>/*#__PURE__*/ (0, _reactDefault.default).createElement("li", {
            key: index
        }, file))));
};
const FileTriggerLinkAllowsMultiple = (props)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.FileTrigger), {
        ...props,
        onSelect: (0, _addonActions.action)("onSelect"),
        allowsMultiple: true
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Link), null, "Select a file"));

},{"@storybook/addon-actions":"coXbW","react-aria-components":"lFSUH","react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"8opkK":[function(require,module,exports) {
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LinkExample", ()=>LinkExample);
var _reactAriaComponents = require("react-aria-components");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
exports.default = {
    title: "React Aria Components"
};
const LinkExample = ()=>{
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Link), {
        "data-testid": "link-example",
        href: "https://www.imdb.com/title/tt6348138/",
        target: "_blank"
    }, "The missing link");
};

},{"react-aria-components":"lFSUH","react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"dqs1T":[function(require,module,exports) {
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ListBoxExample", ()=>ListBoxExample);
parcelHelpers.export(exports, "ListBoxSections", ()=>ListBoxSections);
parcelHelpers.export(exports, "ListBoxComplex", ()=>ListBoxComplex);
parcelHelpers.export(exports, "ListBoxDnd", ()=>ListBoxDnd);
var _reactAriaComponents = require("react-aria-components");
var _utils = require("./utils");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _indexCss = require("../example/index.css");
var _indexCssDefault = parcelHelpers.interopDefault(_indexCss);
var _reactStately = require("react-stately");
exports.default = {
    title: "React Aria Components"
};
const ListBoxExample = (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.ListBox), {
        className: (0, _indexCssDefault.default).menu,
        ...args,
        "aria-label": "test listbox"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.MyListBoxItem), null, "Foo"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.MyListBoxItem), null, "Bar"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.MyListBoxItem), null, "Baz"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.MyListBoxItem), {
        href: "http://google.com"
    }, "Google"));
ListBoxExample.story = {
    args: {
        selectionMode: "none",
        selectionBehavior: "toggle",
        shouldFocusOnHover: false
    },
    argTypes: {
        selectionMode: {
            control: {
                type: "radio",
                options: [
                    "none",
                    "single",
                    "multiple"
                ]
            }
        },
        selectionBehavior: {
            control: {
                type: "radio",
                options: [
                    "toggle",
                    "replace"
                ]
            }
        }
    },
    parameters: {
        description: {
            data: "Hover styles should have higher specificity than focus style for testing purposes. Hover style should not be applied on keyboard focus even if shouldFocusOnHover is true"
        }
    }
};
const ListBoxSections = ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.ListBox), {
        className: (0, _indexCssDefault.default).menu,
        selectionMode: "multiple",
        selectionBehavior: "replace",
        "aria-label": "test listbox with section"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Section), {
        className: (0, _indexCssDefault.default).group
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Header), {
        style: {
            fontSize: "1.2em"
        }
    }, "Section 1"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.MyListBoxItem), null, "Foo"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.MyListBoxItem), null, "Bar"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.MyListBoxItem), null, "Baz")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Separator), {
        style: {
            borderTop: "1px solid gray",
            margin: "2px 5px"
        }
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Section), {
        className: (0, _indexCssDefault.default).group,
        "aria-label": "Section 2"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.MyListBoxItem), null, "Foo"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.MyListBoxItem), null, "Bar"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.MyListBoxItem), null, "Baz")));
const ListBoxComplex = ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.ListBox), {
        className: (0, _indexCssDefault.default).menu,
        selectionMode: "multiple",
        selectionBehavior: "replace",
        "aria-label": "listbox complex"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.MyListBoxItem), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Text), {
        slot: "label"
    }, "Item 1"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Text), {
        slot: "description"
    }, "Description")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.MyListBoxItem), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Text), {
        slot: "label"
    }, "Item 2"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Text), {
        slot: "description"
    }, "Description")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.MyListBoxItem), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Text), {
        slot: "label"
    }, "Item 3"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Text), {
        slot: "description"
    }, "Description")));
let albums = [
    {
        id: 1,
        image: "https://images.unsplash.com/photo-1593958812614-2db6a598c71c?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Nnx8ZGlzY298ZW58MHx8MHx8fDA%3D&auto=format&fit=crop&w=900&q=60",
        title: "Euphoric Echoes",
        artist: "Luna Solstice"
    },
    {
        id: 2,
        image: "https://images.unsplash.com/photo-1601042879364-f3947d3f9c16?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8bmVvbnxlbnwwfHwwfHx8MA%3D%3D&auto=format&fit=crop&w=900&q=60",
        title: "Neon Dreamscape",
        artist: "Electra Skyline"
    },
    {
        id: 3,
        image: "https://images.unsplash.com/photo-1528722828814-77b9b83aafb2?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTF8fHNwYWNlfGVufDB8fDB8fHww&auto=format&fit=crop&w=900&q=60",
        title: "Cosmic Serenade",
        artist: "Orion's Symphony"
    },
    {
        id: 4,
        image: "https://images.unsplash.com/photo-1511379938547-c1f69419868d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8bXVzaWN8ZW58MHx8MHx8fDA%3D&auto=format&fit=crop&w=900&q=60",
        title: "Melancholy Melodies",
        artist: "Violet Mistral"
    },
    {
        id: 5,
        image: "https://images.unsplash.com/photo-1608433319511-dfe8ea4cbd3c?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTF8fGJlYXR8ZW58MHx8MHx8fDA%3D&auto=format&fit=crop&w=900&q=60",
        title: "Rhythmic Illusions",
        artist: "Mirage Beats"
    }
];
const ListBoxDnd = (props)=>{
    let list = (0, _reactStately.useListData)({
        initialItems: albums
    });
    let { dragAndDropHooks } = (0, _reactAriaComponents.useDragAndDrop)({
        getItems: (keys)=>[
                ...keys
            ].map((key)=>({
                    "text/plain": list.getItem(key).title
                })),
        onReorder (e) {
            if (e.target.dropPosition === "before") list.moveBefore(e.target.key, e.keys);
            else if (e.target.dropPosition === "after") list.moveAfter(e.target.key, e.keys);
        }
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.ListBox), {
        ...props,
        "aria-label": "Albums",
        items: list.items,
        selectionMode: "multiple",
        dragAndDropHooks: dragAndDropHooks
    }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.ListBoxItem), null, /*#__PURE__*/ (0, _reactDefault.default).createElement("img", {
            src: item.image,
            alt: ""
        }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Text), {
            slot: "label"
        }, item.title), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Text), {
            slot: "description"
        }, item.artist)));
};
ListBoxDnd.story = {
    args: {
        layout: "stack",
        orientation: "horizontal"
    },
    argTypes: {
        layout: {
            control: "radio",
            options: [
                "stack",
                "grid"
            ]
        },
        orientation: {
            control: "radio",
            options: [
                "horizontal",
                "vertical"
            ]
        }
    }
};

},{"react-aria-components":"lFSUH","./utils":"dnebt","react":"9yzVZ","../example/index.css":"cvBoO","react-stately":"ij62t","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"9nWqL":[function(require,module,exports) {
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MenuExample", ()=>MenuExample);
parcelHelpers.export(exports, "MenuComplex", ()=>MenuComplex);
parcelHelpers.export(exports, "SubmenuExample", ()=>SubmenuExample);
parcelHelpers.export(exports, "SubmenuNestedExample", ()=>SubmenuNestedExample);
parcelHelpers.export(exports, "SubmenuManyItemsExample", ()=>SubmenuManyItemsExample);
parcelHelpers.export(exports, "SubmenuDisabledExample", ()=>SubmenuDisabledExample);
parcelHelpers.export(exports, "SubmenuSectionsExample", ()=>SubmenuSectionsExample);
var _addonActions = require("@storybook/addon-actions");
var _reactAriaComponents = require("react-aria-components");
var _utils = require("./utils");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _indexCss = require("../example/index.css");
var _indexCssDefault = parcelHelpers.interopDefault(_indexCss);
exports.default = {
    title: "React Aria Components"
};
const MenuExample = ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.MenuTrigger), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Button), {
        "aria-label": "Menu"
    }, "\u2630"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Popover), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Menu), {
        className: (0, _indexCssDefault.default).menu,
        onAction: (0, _addonActions.action)("onAction")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Section), {
        className: (0, _indexCssDefault.default).group
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Header), {
        style: {
            fontSize: "1.2em"
        }
    }, "Section 1"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.MyMenuItem), null, "Foo"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.MyMenuItem), null, "Bar"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.MyMenuItem), null, "Baz"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.MyMenuItem), {
        href: "https://google.com"
    }, "Google")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Separator), {
        style: {
            borderTop: "1px solid gray",
            margin: "2px 5px"
        }
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Section), {
        className: (0, _indexCssDefault.default).group
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Header), {
        style: {
            fontSize: "1.2em"
        }
    }, "Section 2"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.MyMenuItem), null, "Foo"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.MyMenuItem), null, "Bar"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.MyMenuItem), null, "Baz")))));
const MenuComplex = ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.MenuTrigger), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Button), {
        "aria-label": "Menu"
    }, "\u2630"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Popover), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Menu), {
        className: (0, _indexCssDefault.default).menu
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.MyMenuItem), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Text), {
        slot: "label"
    }, "Copy"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Text), {
        slot: "description"
    }, "Description"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Keyboard), null, "\u2318C")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.MyMenuItem), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Text), {
        slot: "label"
    }, "Cut"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Text), {
        slot: "description"
    }, "Description"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Keyboard), null, "\u2318X")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.MyMenuItem), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Text), {
        slot: "label"
    }, "Paste"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Text), {
        slot: "description"
    }, "Description"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Keyboard), null, "\u2318V")))));
const SubmenuExample = (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.MenuTrigger), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Button), {
        "aria-label": "Menu"
    }, "\u2630"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Popover), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Menu), {
        className: (0, _indexCssDefault.default).menu,
        onAction: (0, _addonActions.action)("onAction")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.MyMenuItem), {
        id: "Foo"
    }, "Foo"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.SubmenuTrigger), args, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.MyMenuItem), {
        id: "Bar"
    }, "Bar"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Popover), {
        className: (0, _indexCssDefault.default).popover
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Menu), {
        className: (0, _indexCssDefault.default).menu,
        onAction: (0, _addonActions.action)("onAction")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.MyMenuItem), {
        id: "Submenu Foo"
    }, "Submenu Foo"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.MyMenuItem), {
        id: "Submenu Bar"
    }, "Submenu Bar"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.MyMenuItem), {
        id: "Submenu Baz"
    }, "Submenu Baz")))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.MyMenuItem), {
        id: "Baz"
    }, "Baz"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.MyMenuItem), {
        id: "Google",
        href: "https://google.com"
    }, "Google"))));
const SubmenuNestedExample = (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.MenuTrigger), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Button), {
        "aria-label": "Menu"
    }, "\u2630"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Popover), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Menu), {
        className: (0, _indexCssDefault.default).menu,
        onAction: (0, _addonActions.action)("onAction")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.MyMenuItem), {
        id: "Foo"
    }, "Foo"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.SubmenuTrigger), args, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.MyMenuItem), {
        id: "Bar"
    }, "Bar"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Popover), {
        className: (0, _indexCssDefault.default).popover
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Menu), {
        className: (0, _indexCssDefault.default).menu,
        onAction: (0, _addonActions.action)("onAction")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.MyMenuItem), {
        id: "Submenu Foo"
    }, "Submenu Foo"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.MyMenuItem), {
        id: "Submenu Bar"
    }, "Submenu Bar"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.SubmenuTrigger), args, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.MyMenuItem), {
        id: "Submenu Baz"
    }, "Submenu Baz"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Popover), {
        className: (0, _indexCssDefault.default).popover
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Menu), {
        className: (0, _indexCssDefault.default).menu,
        onAction: (0, _addonActions.action)("onAction")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.MyMenuItem), {
        id: "Second Submenu Foo"
    }, "Second Submenu Foo"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.MyMenuItem), {
        id: "Second Submenu Bar"
    }, "Second Submenu Bar"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.MyMenuItem), {
        id: "Second Submenu Baz"
    }, "Second Submenu Baz"))))))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.MyMenuItem), {
        id: "Baz"
    }, "Baz"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.MyMenuItem), {
        id: "Google",
        href: "https://google.com"
    }, "Google"))));
let manyItemsSubmenu = [
    {
        id: "Lvl 1 Item 1",
        name: "Lvl 1 Item 1"
    },
    {
        id: "Lvl 1 Item 2",
        name: "Lvl 1 Item 2",
        children: [
            ...[
                ...Array(30)
            ].map((_, i)=>({
                    id: `Lvl 2 Item ${i + 1}`,
                    name: `Lvl 2 Item ${i + 1}`
                })),
            {
                id: "Lvl 2 Item 31",
                name: "Lvl 2 Item 31",
                children: [
                    {
                        id: "Lvl 3 Item 1",
                        name: "Lvl 3 Item 1"
                    },
                    {
                        id: "Lvl 3 Item 2",
                        name: "Lvl 3 Item 2"
                    },
                    {
                        id: "Lvl 3 Item 3",
                        name: "Lvl 3 Item 3"
                    }
                ]
            }
        ]
    },
    ...[
        ...Array(30)
    ].map((_, i)=>({
            id: `Lvl 1 Item ${i + 3}`,
            name: `Lvl 1 Item ${i + 3}`
        }))
];
let dynamicRenderFunc = (item, args)=>{
    if (item.children) return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.SubmenuTrigger), args, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.MyMenuItem), {
        key: item.name
    }, item.name), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Popover), {
        className: (0, _indexCssDefault.default).popover
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Menu), {
        items: item.children,
        className: (0, _indexCssDefault.default).menu,
        onAction: (0, _addonActions.action)("onAction")
    }, (item)=>dynamicRenderFunc(item, args))));
    else return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.MyMenuItem), {
        key: item.name
    }, item.name);
};
const SubmenuManyItemsExample = (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.MenuTrigger), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Button), {
        "aria-label": "Menu"
    }, "\u2630"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Popover), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Menu), {
        items: manyItemsSubmenu,
        className: (0, _indexCssDefault.default).menu,
        onAction: (0, _addonActions.action)("onAction")
    }, (item)=>dynamicRenderFunc(item, args))));
const SubmenuDisabledExample = (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.MenuTrigger), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Button), {
        "aria-label": "Menu"
    }, "\u2630"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Popover), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Menu), {
        className: (0, _indexCssDefault.default).menu,
        onAction: (0, _addonActions.action)("onAction"),
        disabledKeys: [
            "Bar"
        ]
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.MyMenuItem), {
        id: "Foo"
    }, "Foo"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.SubmenuTrigger), args, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.MyMenuItem), {
        id: "Bar"
    }, "Bar"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Popover), {
        className: (0, _indexCssDefault.default).popover
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Menu), {
        className: (0, _indexCssDefault.default).menu,
        onAction: (0, _addonActions.action)("onAction")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.MyMenuItem), {
        id: "Submenu Foo"
    }, "Submenu Foo"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.MyMenuItem), {
        id: "Submenu Bar"
    }, "Submenu Bar"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.MyMenuItem), {
        id: "Submenu Baz"
    }, "Submenu Baz")))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.MyMenuItem), {
        id: "Baz"
    }, "Baz"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.MyMenuItem), {
        id: "Google",
        href: "https://google.com"
    }, "Google"))));
const SubmenuSectionsExample = (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.MenuTrigger), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Button), {
        "aria-label": "Menu"
    }, "\u2630"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Popover), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Menu), {
        className: (0, _indexCssDefault.default).menu,
        onAction: (0, _addonActions.action)("onAction")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Section), {
        className: (0, _indexCssDefault.default).group
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Header), {
        style: {
            fontSize: "1.2em"
        }
    }, "Section 1"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.MyMenuItem), null, "Foo"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.SubmenuTrigger), args, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.MyMenuItem), {
        id: "Bar"
    }, "Bar"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Popover), {
        className: (0, _indexCssDefault.default).popover
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Menu), {
        className: (0, _indexCssDefault.default).menu,
        onAction: (0, _addonActions.action)("onAction")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Section), {
        className: (0, _indexCssDefault.default).group
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Header), {
        style: {
            fontSize: "1.2em"
        }
    }, "Submenu Section 1"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.MyMenuItem), {
        id: "Submenu Foo"
    }, "Submenu Foo"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.MyMenuItem), {
        id: "Submenu Bar"
    }, "Submenu Bar"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.MyMenuItem), {
        id: "Submenu Baz"
    }, "Submenu Baz"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.MyMenuItem), {
        href: "https://google.com"
    }, "Google")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Separator), {
        style: {
            borderTop: "1px solid gray",
            margin: "2px 5px"
        }
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Section), {
        className: (0, _indexCssDefault.default).group
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Header), {
        style: {
            fontSize: "1.2em"
        }
    }, "Submenu Section 2"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.MyMenuItem), {
        id: "Submenu Foo 2"
    }, "Submenu Foo"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.MyMenuItem), {
        id: "Submenu Bar 2"
    }, "Submenu Bar"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.MyMenuItem), {
        id: "Submenu Baz 2"
    }, "Submenu Baz"))))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.MyMenuItem), null, "Baz"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.MyMenuItem), {
        href: "https://google.com"
    }, "Google")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Separator), {
        style: {
            borderTop: "1px solid gray",
            margin: "2px 5px"
        }
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Section), {
        className: (0, _indexCssDefault.default).group
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Header), {
        style: {
            fontSize: "1.2em"
        }
    }, "Section 2"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.MyMenuItem), null, "Foo"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.MyMenuItem), null, "Bar"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.MyMenuItem), null, "Baz")))));
let submenuArgs = {
    args: {
        delay: 200
    },
    argTypes: {
        delay: {
            control: "number"
        }
    }
};
SubmenuExample.story = {
    ...submenuArgs
};
SubmenuNestedExample.story = {
    ...submenuArgs
};
SubmenuManyItemsExample.story = {
    ...submenuArgs
};
SubmenuDisabledExample.story = {
    ...submenuArgs
};

},{"@storybook/addon-actions":"coXbW","react-aria-components":"lFSUH","./utils":"dnebt","react":"9yzVZ","../example/index.css":"cvBoO","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"84Xgz":[function(require,module,exports) {
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MeterExample", ()=>MeterExample);
var _reactAriaComponents = require("react-aria-components");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
exports.default = {
    title: "React Aria Components",
    component: (0, _reactAriaComponents.Meter),
    args: {
        value: 50
    },
    argTypes: {
        value: {
            control: "number"
        },
        minValue: {
            control: "number"
        },
        maxValue: {
            control: "number"
        }
    }
};
const MeterExample = (args)=>{
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Meter), args, ({ percentage, valueText })=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Label), null, "Storage space"), /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
            className: "value"
        }, valueText), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
            className: "bar"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
            className: "fill",
            style: {
                width: percentage + "%"
            }
        }))));
};

},{"react-aria-components":"lFSUH","react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"dScmZ":[function(require,module,exports) {
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ModalExample", ()=>ModalExample);
var _reactAriaComponents = require("react-aria-components");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
exports.default = {
    title: "React Aria Components"
};
const ModalExample = ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.DialogTrigger), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Button), null, "Open modal"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.ModalOverlay), {
        style: {
            position: "fixed",
            zIndex: 100,
            top: 0,
            left: 0,
            bottom: 0,
            right: 0,
            background: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Modal), {
        style: {
            background: "Canvas",
            color: "CanvasText",
            border: "1px solid gray",
            padding: 30
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Dialog), null, ({ close })=>/*#__PURE__*/ (0, _reactDefault.default).createElement("form", {
            style: {
                display: "flex",
                flexDirection: "column"
            }
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Heading), {
            slot: "title",
            style: {
                marginTop: 0
            }
        }, "Sign up"), /*#__PURE__*/ (0, _reactDefault.default).createElement("label", null, "First Name: ", /*#__PURE__*/ (0, _reactDefault.default).createElement("input", {
            placeholder: "John"
        })), /*#__PURE__*/ (0, _reactDefault.default).createElement("label", null, "Last Name: ", /*#__PURE__*/ (0, _reactDefault.default).createElement("input", {
            placeholder: "Smith"
        })), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Button), {
            onPress: close,
            style: {
                marginTop: 10
            }
        }, "Submit"))))));

},{"react-aria-components":"lFSUH","react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"4ZM55":[function(require,module,exports) {
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NumberFieldExample", ()=>NumberFieldExample);
var _reactAriaComponents = require("react-aria-components");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
exports.default = {
    title: "React Aria Components"
};
const NumberFieldExample = {
    args: {
        defaultValue: 0,
        minValue: 0,
        maxValue: 100,
        step: 1,
        formatOptions: {
            style: "currency",
            currency: "USD"
        },
        isWheelDisabled: false
    },
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.NumberField), args, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Label), null, "Test"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Group), {
            style: {
                display: "flex"
            }
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Button), {
            slot: "decrement"
        }, "-"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Input), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Button), {
            slot: "increment"
        }, "+")))
};

},{"react-aria-components":"lFSUH","react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"dgwJe":[function(require,module,exports) {
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PopoverExample", ()=>PopoverExample);
var _reactAriaComponents = require("react-aria-components");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
exports.default = {
    title: "React Aria Components"
};
const PopoverExample = ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.DialogTrigger), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Button), null, "Open popover"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Popover), {
        placement: "bottom start",
        style: {
            background: "Canvas",
            color: "CanvasText",
            border: "1px solid gray",
            padding: 30,
            zIndex: 5
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Dialog), null, ({ close })=>/*#__PURE__*/ (0, _reactDefault.default).createElement("form", {
            style: {
                display: "flex",
                flexDirection: "column"
            }
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Heading), {
            slot: "title"
        }, "Sign up"), /*#__PURE__*/ (0, _reactDefault.default).createElement("label", null, "First Name: ", /*#__PURE__*/ (0, _reactDefault.default).createElement("input", {
            placeholder: "John"
        })), /*#__PURE__*/ (0, _reactDefault.default).createElement("label", null, "Last Name: ", /*#__PURE__*/ (0, _reactDefault.default).createElement("input", {
            placeholder: "Smith"
        })), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Button), {
            onPress: close,
            style: {
                marginTop: 10
            }
        }, "Submit")))));

},{"react-aria-components":"lFSUH","react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"1tE9F":[function(require,module,exports) {
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ProgressBarExample", ()=>ProgressBarExample);
var _reactAriaComponents = require("react-aria-components");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
exports.default = {
    title: "React Aria Components",
    component: (0, _reactAriaComponents.ProgressBar),
    args: {
        value: 50
    },
    argTypes: {
        value: {
            control: "number"
        },
        minValue: {
            control: "number"
        },
        maxValue: {
            control: "number"
        }
    }
};
const ProgressBarExample = (args)=>{
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.ProgressBar), args, ({ percentage, valueText })=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Label), null, "Storage space"), /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
            className: "value"
        }, valueText), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
            className: "bar"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
            className: "fill",
            style: {
                width: percentage + "%"
            }
        }))));
};

},{"react-aria-components":"lFSUH","react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"aMuws":[function(require,module,exports) {
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RadioGroupExample", ()=>RadioGroupExample);
parcelHelpers.export(exports, "RadioGroupInDialogExample", ()=>RadioGroupInDialogExample);
var _reactAriaComponents = require("react-aria-components");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _indexCss = require("../example/index.css");
var _indexCssDefault = parcelHelpers.interopDefault(_indexCss);
exports.default = {
    title: "React Aria Components"
};
const RadioGroupExample = ()=>{
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.RadioGroup), {
        "data-testid": "radio-group-example",
        className: (0, _indexCssDefault.default).radiogroup
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Label), null, "Favorite pet"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Radio), {
        className: (0, _indexCssDefault.default).radio,
        value: "dogs",
        "data-testid": "radio-dog"
    }, "Dog"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Radio), {
        className: (0, _indexCssDefault.default).radio,
        value: "cats"
    }, "Cat"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Radio), {
        className: (0, _indexCssDefault.default).radio,
        value: "dragon"
    }, "Dragon"));
};
const RadioGroupInDialogExample = ()=>{
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.DialogTrigger), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Button), null, "Open dialog"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.ModalOverlay), {
        style: {
            position: "fixed",
            zIndex: 100,
            top: 0,
            left: 0,
            bottom: 0,
            right: 0,
            background: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Modal), {
        style: {
            background: "Canvas",
            color: "CanvasText",
            border: "1px solid gray",
            padding: 30
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Dialog), {
        style: {
            outline: "2px solid transparent",
            outlineOffset: "2px",
            position: "relative"
        }
    }, ({ close })=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", null, /*#__PURE__*/ (0, _reactDefault.default).createElement(RadioGroupExample, null)), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Button), {
            onPress: close,
            style: {
                marginTop: 10
            }
        }, "Close")))))));
};

},{"react-aria-components":"lFSUH","react":"9yzVZ","../example/index.css":"cvBoO","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"cfYeW":[function(require,module,exports) {
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SearchFieldExample", ()=>SearchFieldExample);
var _reactAriaComponents = require("react-aria-components");
var _utils = require("@react-spectrum/utils");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _indexCss = require("../example/index.css");
var _indexCssDefault = parcelHelpers.interopDefault(_indexCss);
exports.default = {
    title: "React Aria Components"
};
const SearchFieldExample = ()=>{
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.SearchField), {
        className: (0, _utils.classNames)((0, _indexCssDefault.default), "searchFieldExample"),
        "data-testid": "search-field-example"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Label), null, "Search"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Input), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Button), null, "\u2715"));
};

},{"react-aria-components":"lFSUH","@react-spectrum/utils":"cMIJ6","react":"9yzVZ","../example/index.css":"cvBoO","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"fDr7Z":[function(require,module,exports) {
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SelectExample", ()=>SelectExample);
parcelHelpers.export(exports, "SelectRenderProps", ()=>SelectRenderProps);
parcelHelpers.export(exports, "SelectManyItems", ()=>SelectManyItems);
var _reactAriaComponents = require("react-aria-components");
var _utils = require("./utils");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _indexCss = require("../example/index.css");
var _indexCssDefault = parcelHelpers.interopDefault(_indexCss);
exports.default = {
    title: "React Aria Components"
};
const SelectExample = ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Select), {
        "data-testid": "select-example",
        id: "select-example-id"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Label), {
        style: {
            display: "block"
        }
    }, "Test"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Button), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.SelectValue), null), /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        "aria-hidden": "true",
        style: {
            paddingLeft: 5
        }
    }, "\u25BC")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Popover), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.OverlayArrow), null, /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        width: 12,
        height: 12
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M0 0,L6 6,L12 0"
    }))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.ListBox), {
        className: (0, _indexCssDefault.default).menu
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.MyListBoxItem), null, "Foo"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.MyListBoxItem), null, "Bar"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.MyListBoxItem), null, "Baz"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.MyListBoxItem), {
        href: "http://google.com"
    }, "Google"))));
const SelectRenderProps = ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Select), {
        "data-testid": "select-render-props"
    }, ({ isOpen })=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Label), {
            style: {
                display: "block"
            }
        }, "Test"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Button), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.SelectValue), null), /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
            "aria-hidden": "true",
            style: {
                paddingLeft: 5
            }
        }, isOpen ? "\u25B2" : "\u25BC")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Popover), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.ListBox), {
            className: (0, _indexCssDefault.default).menu
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.MyListBoxItem), null, "Foo"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.MyListBoxItem), null, "Bar"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.MyListBoxItem), null, "Baz"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.MyListBoxItem), {
            href: "http://google.com"
        }, "Google")))));
let manyItems = [
    ...Array(100)
].map((_, i)=>({
        id: i,
        name: `Item ${i}`
    }));
const SelectManyItems = ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Select), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Label), {
        style: {
            display: "block"
        }
    }, "Test"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Button), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.SelectValue), null), /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        "aria-hidden": "true",
        style: {
            paddingLeft: 5
        }
    }, "\u25BC")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Popover), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.OverlayArrow), null, /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        width: 12,
        height: 12
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M0 0,L6 6,L12 0"
    }))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.ListBox), {
        items: manyItems,
        className: (0, _indexCssDefault.default).menu
    }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.MyListBoxItem), null, item.name))));

},{"react-aria-components":"lFSUH","./utils":"dnebt","react":"9yzVZ","../example/index.css":"cvBoO","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"3nc13":[function(require,module,exports) {
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SliderExample", ()=>SliderExample);
parcelHelpers.export(exports, "SliderCSS", ()=>SliderCSS);
var _reactAriaComponents = require("react-aria-components");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _indexCss = require("../example/index.css");
var _indexCssDefault = parcelHelpers.interopDefault(_indexCss);
exports.default = {
    title: "React Aria Components"
};
const SliderExample = ()=>{
    const [value, setValue] = (0, _reactDefault.default).useState([
        30,
        60
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Slider), {
        "data-testid": "slider-example",
        value: value,
        onChange: setValue,
        style: {
            position: "relative",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            width: 300
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        style: {
            display: "flex",
            alignSelf: "stretch"
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Label), null, "Test"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.SliderOutput), {
        style: {
            flex: "1 0 auto",
            textAlign: "end"
        }
    }, ({ state })=>`${state.getThumbValueLabel(0)} - ${state.getThumbValueLabel(1)}`)), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.SliderTrack), {
        style: {
            position: "relative",
            height: 30,
            width: "100%"
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        style: {
            position: "absolute",
            backgroundColor: "gray",
            height: 3,
            top: 13,
            width: "100%"
        }
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement(CustomThumb, {
        index: 0
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Label), null, "A")), /*#__PURE__*/ (0, _reactDefault.default).createElement(CustomThumb, {
        index: 1
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Label), null, "B")))), /*#__PURE__*/ (0, _reactDefault.default).createElement("button", {
        onClick: ()=>setValue([
                0,
                100
            ])
    }, "reset"));
};
const SliderCSS = (props)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Slider), {
        ...props,
        defaultValue: 30,
        className: (0, _indexCssDefault.default).slider
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _indexCssDefault.default).label
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Label), null, "Test"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.SliderOutput), null)), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.SliderTrack), {
        className: (0, _indexCssDefault.default).track
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.SliderThumb), {
        className: (0, _indexCssDefault.default).thumb
    })));
SliderCSS.args = {
    orientation: "horizontal",
    isDisabled: false,
    minValue: 0,
    maxValue: 100,
    step: 1
};
SliderCSS.argTypes = {
    orientation: {
        control: {
            type: "inline-radio",
            options: [
                "horizontal",
                "vertical"
            ]
        }
    }
};
const CustomThumb = ({ index, children })=>{
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.SliderThumb), {
        index: index,
        style: ({ isDragging, isFocusVisible })=>({
                width: 20,
                height: 20,
                borderRadius: "50%",
                top: "50%",
                // eslint-disable-next-line
                backgroundColor: isFocusVisible ? "orange" : isDragging ? "dimgrey" : "gray"
            })
    }, children);
};

},{"react-aria-components":"lFSUH","react":"9yzVZ","../example/index.css":"cvBoO","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"8ASVy":[function(require,module,exports) {
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SwitchExample", ()=>SwitchExample);
var _utils = require("@react-spectrum/utils");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _indexCss = require("../example/index.css");
var _indexCssDefault = parcelHelpers.interopDefault(_indexCss);
var _reactAriaComponents = require("react-aria-components");
exports.default = {
    title: "React Aria Components"
};
const SwitchExample = ()=>{
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Switch), {
        className: (0, _utils.classNames)((0, _indexCssDefault.default), "switchExample"),
        "data-testid": "switch-example"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _utils.classNames)((0, _indexCssDefault.default), "switchExample-indicator")
    }), "Switch me");
};

},{"@react-spectrum/utils":"cMIJ6","react":"9yzVZ","../example/index.css":"cvBoO","react-aria-components":"lFSUH","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"aDz9A":[function(require,module,exports) {
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReorderableTableExample", ()=>ReorderableTableExample);
parcelHelpers.export(exports, "TableExample", ()=>TableExample);
parcelHelpers.export(exports, "TableDynamicExample", ()=>TableDynamicExample);
var _addonActions = require("@storybook/addon-actions");
var _reactAriaComponents = require("react-aria-components");
var _reactAria = require("react-aria");
var _utils = require("./utils");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _indexCss = require("../example/index.css");
var _indexCssDefault = parcelHelpers.interopDefault(_indexCss);
var _reactStately = require("react-stately");
exports.default = {
    title: "React Aria Components"
};
const ReorderableTable = ({ initialItems })=>{
    let list = (0, _reactStately.useListData)({
        initialItems
    });
    const { dragAndDropHooks } = (0, _reactAriaComponents.useDragAndDrop)({
        getItems: (keys)=>{
            return [
                ...keys
            ].map((k)=>{
                const item = list.getItem(k);
                return {
                    "text/plain": item.id,
                    item: JSON.stringify(item)
                };
            });
        },
        getDropOperation: ()=>"move",
        onReorder: (e)=>{
            if (e.target.dropPosition === "before") list.moveBefore(e.target.key, e.keys);
            else if (e.target.dropPosition === "after") list.moveAfter(e.target.key, e.keys);
        },
        onInsert: async (e)=>{
            const processedItems = await Promise.all(e.items.filter((0, _reactAria.isTextDropItem)).map(async (item)=>JSON.parse(await item.getText("item"))));
            if (e.target.dropPosition === "before") list.insertBefore(e.target.key, ...processedItems);
            else if (e.target.dropPosition === "after") list.insertAfter(e.target.key, ...processedItems);
        },
        onDragEnd: (e)=>{
            if (e.dropOperation === "move" && !e.isInternal) list.remove(...e.keys);
        },
        onRootDrop: async (e)=>{
            const processedItems = await Promise.all(e.items.filter((0, _reactAria.isTextDropItem)).map(async (item)=>JSON.parse(await item.getText("item"))));
            list.append(...processedItems);
        }
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Table), {
        "aria-label": "Reorderable table",
        dragAndDropHooks: dragAndDropHooks
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.TableHeader), null, /*#__PURE__*/ (0, _reactDefault.default).createElement(MyColumn, {
        isRowHeader: true,
        defaultWidth: "50%"
    }, "Id"), /*#__PURE__*/ (0, _reactDefault.default).createElement(MyColumn, null, "Name")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.TableBody), {
        items: list.items,
        renderEmptyState: ({ isDropTarget })=>/*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
                style: {
                    color: isDropTarget ? "red" : "black"
                }
            }, "Drop items here")
    }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Row), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Cell), null, item.id), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Cell), null, item.name))));
};
const ReorderableTableExample = ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.ResizableTableContainer), {
        style: {
            width: 300,
            overflow: "auto"
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(ReorderableTable, {
        initialItems: [
            {
                id: "1",
                name: "Bob"
            }
        ]
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.ResizableTableContainer), {
        style: {
            width: 300,
            overflow: "auto"
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(ReorderableTable, {
        initialItems: [
            {
                id: "2",
                name: "Alex"
            }
        ]
    })));
const TableExample = ()=>{
    let list = (0, _reactStately.useListData)({
        initialItems: [
            {
                id: 1,
                name: "Games",
                date: "6/7/2020",
                type: "File folder"
            },
            {
                id: 2,
                name: "Program Files",
                date: "4/7/2021",
                type: "File folder"
            },
            {
                id: 3,
                name: "bootmgr",
                date: "11/20/2010",
                type: "System file"
            },
            {
                id: 4,
                name: "log.txt",
                date: "1/18/2016",
                type: "Text Document"
            }
        ]
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.ResizableTableContainer), {
        style: {
            width: 300,
            overflow: "auto"
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Table), {
        "aria-label": "Example table"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.TableHeader), null, /*#__PURE__*/ (0, _reactDefault.default).createElement(MyColumn, {
        isRowHeader: true,
        defaultWidth: "50%"
    }, "Name"), /*#__PURE__*/ (0, _reactDefault.default).createElement(MyColumn, null, "Type"), /*#__PURE__*/ (0, _reactDefault.default).createElement(MyColumn, null, "Date Modified"), /*#__PURE__*/ (0, _reactDefault.default).createElement(MyColumn, null, "Actions")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.TableBody), {
        items: list.items
    }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Row), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Cell), null, item.name), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Cell), null, item.type), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Cell), null, item.date), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Cell), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.DialogTrigger), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Button), null, "Delete"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.ModalOverlay), {
            style: {
                position: "fixed",
                zIndex: 100,
                top: 0,
                left: 0,
                bottom: 0,
                right: 0,
                background: "rgba(0, 0, 0, 0.5)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center"
            }
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Modal), {
            style: {
                background: "Canvas",
                color: "CanvasText",
                border: "1px solid gray",
                padding: 30
            }
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Dialog), null, ({ close })=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Heading), {
                slot: "title"
            }, "Delete item"), /*#__PURE__*/ (0, _reactDefault.default).createElement("p", null, "Are you sure?"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Button), {
                onPress: close
            }, "Cancel"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Button), {
                onPress: ()=>{
                    close();
                    list.remove(item.id);
                }
            }, "Delete")))))))))));
};
const TableDynamicExample = ()=>{
    let columns = [
        {
            name: "Name",
            id: "name",
            isRowHeader: true
        },
        {
            name: "Type",
            id: "type"
        },
        {
            name: "Date Modified",
            id: "date"
        }
    ];
    let rows = [
        {
            id: 1,
            name: "Games",
            date: "6/7/2020",
            type: "File folder"
        },
        {
            id: 2,
            name: "Program Files",
            date: "4/7/2021",
            type: "File folder"
        },
        {
            id: 3,
            name: "bootmgr",
            date: "11/20/2010",
            type: "System file"
        },
        {
            id: 4,
            name: "log.txt",
            date: "1/18/20167",
            type: "Text Document"
        }
    ];
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Table), {
        "aria-label": "Files"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.TableHeader), {
        columns: columns
    }, (column)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Column), {
            isRowHeader: column.isRowHeader
        }, column.name)), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.TableBody), {
        items: rows
    }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Row), {
            columns: columns
        }, (column)=>{
            return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Cell), null, item[column.id]);
        })));
};
const MyColumn = (props)=>{
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Column), props, ({ startResize })=>/*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
            style: {
                display: "flex"
            }
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.MenuTrigger), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Button), {
            style: {
                flex: 1,
                textAlign: "left"
            }
        }, props.children), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Popover), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Menu), {
            className: (0, _indexCssDefault.default).menu,
            onAction: ()=>startResize()
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.MyMenuItem), {
            id: "resize"
        }, "Resize")))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.ColumnResizer), {
            onHoverStart: (0, _addonActions.action)("onHoverStart"),
            onHoverChange: (0, _addonActions.action)("onHoverChange"),
            onHoverEnd: (0, _addonActions.action)("onHoverEnd")
        }, "\u2194")));
};

},{"@storybook/addon-actions":"coXbW","react-aria-components":"lFSUH","react-aria":"e7jhe","./utils":"dnebt","react":"9yzVZ","../example/index.css":"cvBoO","react-stately":"ij62t","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"6WahX":[function(require,module,exports) {
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TabsExample", ()=>TabsExample);
parcelHelpers.export(exports, "TabsRenderProps", ()=>TabsRenderProps);
var _reactAriaComponents = require("react-aria-components");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _utils = require("@react-aria/utils");
exports.default = {
    title: "React Aria Components"
};
const TabsExample = ()=>{
    let [url, setUrl] = (0, _react.useState)("/FoR");
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.RouterProvider), {
        navigate: setUrl
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Tabs), {
        selectedKey: url
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.TabList), {
        "aria-label": "History of Ancient Rome",
        style: {
            display: "flex",
            gap: 8
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(CustomTab, {
        id: "/FoR",
        href: "/FoR"
    }, "Founding of Rome"), /*#__PURE__*/ (0, _reactDefault.default).createElement(CustomTab, {
        id: "/MaR",
        href: "/MaR"
    }, "Monarchy and Republic"), /*#__PURE__*/ (0, _reactDefault.default).createElement(CustomTab, {
        id: "/Emp",
        href: "/Emp"
    }, "Empire")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.TabPanel), {
        id: "/FoR"
    }, "Arma virumque cano, Troiae qui primus ab oris."), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.TabPanel), {
        id: "/MaR"
    }, "Senatus Populusque Romanus."), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.TabPanel), {
        id: "/Emp"
    }, "Alea jacta est.")));
};
const TabsRenderProps = ()=>{
    const [tabOrientation, setTabOrientation] = (0, _react.useState)("vertical");
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        style: {
            display: "flex",
            flexDirection: "row",
            gap: 8
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Button), {
        onPress: ()=>setTabOrientation((current)=>current === "vertical" ? "horizontal" : "vertical")
    }, "Change Orientation"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Tabs), {
        orientation: tabOrientation
    }, ({ orientation })=>/*#__PURE__*/ (0, _reactDefault.default).createElement("div", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
            style: {
                display: "flex",
                flexDirection: orientation === "vertical" ? "row" : "column",
                gap: 8
            }
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.TabList), {
            "aria-label": "History of Ancient Rome",
            style: {
                display: "flex",
                flexDirection: orientation === "vertical" ? "column" : "row",
                gap: 8
            }
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement(CustomTab, {
            id: "FoR"
        }, "Founding of Rome"), /*#__PURE__*/ (0, _reactDefault.default).createElement(CustomTab, {
            id: "MaR"
        }, "Monarchy and Republic"), /*#__PURE__*/ (0, _reactDefault.default).createElement(CustomTab, {
            id: "Emp"
        }, "Empire")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.TabPanel), {
            id: "FoR"
        }, "Arma virumque cano, Troiae qui primus ab oris."), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.TabPanel), {
            id: "MaR"
        }, "Senatus Populusque Romanus."), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.TabPanel), {
            id: "Emp"
        }, "Alea jacta est.")))));
};
const CustomTab = (props)=>{
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Tab), {
        ...props,
        style: ({ isSelected })=>({
                borderBottom: "2px solid " + (isSelected ? "slateblue" : "transparent")
            })
    });
};

},{"react-aria-components":"lFSUH","react":"9yzVZ","@react-aria/utils":"9cLk5","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"gp3nI":[function(require,module,exports) {
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TagGroupExample", ()=>TagGroupExample);
var _reactAriaComponents = require("react-aria-components");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
exports.default = {
    title: "React Aria Components"
};
const TagGroupExample = (props)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.TagGroup), props, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Label), null, "Categories"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.TagList), {
        style: {
            display: "flex",
            gap: 4
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(MyTag, {
        href: "https://nytimes.com"
    }, "News"), /*#__PURE__*/ (0, _reactDefault.default).createElement(MyTag, null, "Travel"), /*#__PURE__*/ (0, _reactDefault.default).createElement(MyTag, null, "Gaming"), /*#__PURE__*/ (0, _reactDefault.default).createElement(MyTag, null, "Shopping")));
TagGroupExample.args = {
    selectionMode: "none",
    selectionBehavior: "toggle"
};
TagGroupExample.argTypes = {
    selectionMode: {
        control: {
            type: "inline-radio",
            options: [
                "none",
                "single",
                "multiple"
            ]
        }
    },
    selectionBehavior: {
        control: {
            type: "inline-radio",
            options: [
                "toggle",
                "replace"
            ]
        }
    }
};
function MyTag(props) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Tag), {
        ...props,
        style: ({ isSelected })=>({
                border: "1px solid gray",
                borderRadius: 4,
                padding: "0 4px",
                background: isSelected ? "black" : "",
                color: isSelected ? "white" : "",
                cursor: props.href ? "pointer" : "default"
            })
    });
}

},{"react-aria-components":"lFSUH","react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"jtueY":[function(require,module,exports) {
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TextfieldExample", ()=>TextfieldExample);
var _reactAriaComponents = require("react-aria-components");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
exports.default = {
    title: "React Aria Components"
};
const TextfieldExample = ()=>{
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.TextField), {
        "data-testid": "textfield-example"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Label), null, "First name"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Input), null));
};

},{"react-aria-components":"lFSUH","react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"7ACwt":[function(require,module,exports) {
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TimeFieldExample", ()=>TimeFieldExample);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _reactAriaComponents = require("react-aria-components");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _indexCss = require("../example/index.css");
var _indexCssDefault = parcelHelpers.interopDefault(_indexCss);
exports.default = {
    title: "React Aria Components"
};
const TimeFieldExample = ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.TimeField), {
        "data-testid": "time-field-example"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Label), {
        style: {
            display: "block"
        }
    }, "Time"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.DateInput), {
        className: (0, _indexCssDefault.default).field
    }, (segment)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.DateSegment), {
            segment: segment,
            className: (0, _clsxDefault.default)((0, _indexCssDefault.default).segment, {
                [(0, _indexCssDefault.default).placeholder]: segment.isPlaceholder
            })
        })));

},{"clsx":"fAYNK","react-aria-components":"lFSUH","react":"9yzVZ","../example/index.css":"cvBoO","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"lAZkP":[function(require,module,exports) {
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ToggleButtonExample", ()=>ToggleButtonExample);
var _addonActions = require("@storybook/addon-actions");
var _utils = require("@react-spectrum/utils");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _indexCss = require("../example/index.css");
var _indexCssDefault = parcelHelpers.interopDefault(_indexCss);
var _reactAriaComponents = require("react-aria-components");
exports.default = {
    title: "React Aria Components"
};
const ToggleButtonExample = ()=>{
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.ToggleButton), {
        className: (0, _utils.classNames)((0, _indexCssDefault.default), "toggleButtonExample"),
        "data-testid": "toggle-button-example",
        onKeyUp: (0, _addonActions.action)("keyup"),
        onPress: (0, _addonActions.action)("press")
    }, "Toggle");
};

},{"@storybook/addon-actions":"coXbW","@react-spectrum/utils":"cMIJ6","react":"9yzVZ","../example/index.css":"cvBoO","react-aria-components":"lFSUH","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"k2xd2":[function(require,module,exports) {
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ToolbarExample", ()=>ToolbarExample);
var _reactAriaComponents = require("react-aria-components");
var _utils = require("@react-spectrum/utils");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _indexCss = require("../example/index.css");
var _indexCssDefault = parcelHelpers.interopDefault(_indexCss);
exports.default = {
    title: "React Aria Components"
};
const ToolbarExample = (props)=>{
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("label", {
        htmlFor: "before"
    }, "Input Before Toolbar"), /*#__PURE__*/ (0, _reactDefault.default).createElement("input", {
        id: "before",
        type: "text"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Toolbar), props, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        role: "group",
        "aria-label": "Text style"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.ToggleButton), {
        className: (0, _utils.classNames)((0, _indexCssDefault.default), "toggleButtonExample")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("strong", null, "B")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.ToggleButton), {
        className: (0, _utils.classNames)((0, _indexCssDefault.default), "toggleButtonExample")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        style: {
            textDecoration: "underline"
        }
    }, "U")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.ToggleButton), {
        className: (0, _utils.classNames)((0, _indexCssDefault.default), "toggleButtonExample")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("i", null, "I"))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Checkbox), null, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: "checkbox"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        viewBox: "0 0 18 18",
        "aria-hidden": "true"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("polyline", {
        points: "1 9 7 14 15 4"
    }))), "Night Mode"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Link), {
        href: "https://google.com"
    }, "Help")), /*#__PURE__*/ (0, _reactDefault.default).createElement("label", {
        htmlFor: "after"
    }, "Input After Toolbar"), /*#__PURE__*/ (0, _reactDefault.default).createElement("input", {
        id: "after",
        type: "text"
    }));
};
ToolbarExample.args = {
    orientation: "horizontal"
};
ToolbarExample.argTypes = {
    orientation: {
        control: "radio",
        options: [
            "horizontal",
            "vertical"
        ]
    }
};

},{"react-aria-components":"lFSUH","@react-spectrum/utils":"cMIJ6","react":"9yzVZ","../example/index.css":"cvBoO","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"dyuDw":[function(require,module,exports) {
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TooltipExample", ()=>TooltipExample);
var _reactAriaComponents = require("react-aria-components");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
exports.default = {
    title: "React Aria Components"
};
const TooltipExample = ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.TooltipTrigger), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Button), null, "Tooltip trigger"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Tooltip), {
        offset: 5,
        style: {
            background: "Canvas",
            color: "CanvasText",
            border: "1px solid gray",
            padding: 5,
            borderRadius: 4
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.OverlayArrow), {
        style: {
            transform: "translateX(-50%)"
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        width: "8",
        height: "8",
        style: {
            display: "block"
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M0 0,L4 4,L8 0",
        fill: "white",
        strokeWidth: 1,
        stroke: "gray"
    }))), "I am a tooltip"));

},{"react-aria-components":"lFSUH","react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"2XHQq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ModalAnimation", ()=>ModalAnimation);
var _reactAriaComponents = require("react-aria-components");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _stylesCss = require("./styles.css");
var _stylesCssDefault = parcelHelpers.interopDefault(_stylesCss);
exports.default = {
    title: "React Aria Components - Animations"
};
let ModalAnimation = {
    render: ()=>{
        return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
            className: "App"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.DialogTrigger), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Button), null, "Open modal"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.ModalOverlay), {
            className: (0, _stylesCssDefault.default)["my-overlay"]
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Modal), {
            isDismissable: true,
            className: (0, _stylesCssDefault.default)["my-modal"]
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Dialog), null, ({ close })=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Heading), {
                slot: "title"
            }, "Notice"), /*#__PURE__*/ (0, _reactDefault.default).createElement("p", null, "This is a modal with a custom modal overlay."), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Button), {
                onPress: close
            }, "Close")))))));
    }
};

},{"react-aria-components":"lFSUH","react":"9yzVZ","./styles.css":"4YDWm","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"4YDWm":[function(require,module,exports) {
module.exports["bar"] = `EYl6Ua_bar`;
module.exports["blur"] = `EYl6Ua_blur`;
module.exports["description"] = `EYl6Ua_description`;
module.exports["fade"] = `EYl6Ua_fade`;
module.exports["fade"];
module.exports["image"] = `EYl6Ua_image`;
module.exports["label"] = `EYl6Ua_label`;
module.exports["my-modal"] = `EYl6Ua_my-modal`;
module.exports["my-overlay"] = `EYl6Ua_my-overlay`;
module.exports["slide"] = `EYl6Ua_slide`;
module.exports["slide"];
module.exports["title"] = `EYl6Ua_title`;
module.exports["value"] = `EYl6Ua_value`;

},{}],"5agG9":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InputTypeButton", ()=>InputTypeButton);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _ = require("../");
exports.default = {
    title: "useButton"
};
const InputTypeButton = {
    render: ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement(InputButton, null),
    name: "input type button"
};
function InputButton(props) {
    let { value = "Test" } = props;
    let ref = (0, _react.useRef)(null);
    let { buttonProps, isPressed } = (0, _.useButton)({
        ...props,
        elementType: "input"
    }, ref);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("input", {
        ref: ref,
        value: value,
        style: {
            background: isPressed ? "darkred" : "red"
        },
        ...buttonProps
    });
}

},{"react":"9yzVZ","../":"aZKEv","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"aZKEv":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _src = require("./src");
parcelHelpers.exportAll(_src, exports);

},{"./src":"fsdLZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"ar8Lj":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Days3", ()=>Days3);
parcelHelpers.export(exports, "Weeks1", ()=>Weeks1);
parcelHelpers.export(exports, "Weeks2", ()=>Weeks2);
parcelHelpers.export(exports, "Months1", ()=>Months1);
parcelHelpers.export(exports, "Months2", ()=>Months2);
parcelHelpers.export(exports, "Days7SingleToday", ()=>Days7SingleToday);
parcelHelpers.export(exports, "Weeks5SingleToday", ()=>Weeks5SingleToday);
parcelHelpers.export(exports, "Months2PageBehaviorSingle", ()=>Months2PageBehaviorSingle);
var _example = require("./Example");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _date = require("@internationalized/date");
exports.default = {
    title: "Date and Time/useCalendar"
};
const Days3 = {
    render: ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _example.Example), {
            visibleDuration: {
                days: 3
            }
        }),
    name: "days: 3"
};
const Weeks1 = {
    render: ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _example.Example), {
            visibleDuration: {
                weeks: 1
            }
        }),
    name: "weeks: 1"
};
const Weeks2 = {
    render: ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _example.Example), {
            visibleDuration: {
                weeks: 2
            }
        }),
    name: "weeks: 2"
};
const Months1 = {
    render: ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _example.Example), {
            visibleDuration: {
                months: 1
            }
        }),
    name: "months: 1"
};
const Months2 = {
    render: ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _example.Example), {
            visibleDuration: {
                months: 2
            }
        }),
    name: "months: 2"
};
const Days7SingleToday = {
    render: ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _example.Example), {
            defaultValue: (0, _date.today),
            visibleDuration: {
                days: 7
            },
            pageBehavior: "single"
        }),
    name: "days: 7, pageBehavior: single, defaultValue: today"
};
const Weeks5SingleToday = {
    render: ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _example.Example), {
            defaultValue: (0, _date.today),
            visibleDuration: {
                weeks: 5
            },
            pageBehavior: "single"
        }),
    name: "weeks: 5, pageBehavior: single, defaultValue: today"
};
const Months2PageBehaviorSingle = {
    render: ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _example.Example), {
            visibleDuration: {
                months: 2
            },
            pageBehavior: "single"
        }),
    name: "months: 2, pageBehavior: single"
};

},{"./Example":"jdm4H","react":"9yzVZ","@internationalized/date":"hesBk","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"jdm4H":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Example", ()=>Example);
var _button = require("@react-spectrum/button");
var _calendar = require("@react-stately/calendar");
var _date = require("@internationalized/date");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _src = require("../src");
var _i18N = require("@react-aria/i18n");
function Example(props) {
    let { locale } = (0, _i18N.useLocale)();
    const { visibleDuration } = props;
    let state = (0, _calendar.useCalendarState)({
        ...props,
        locale,
        createCalendar: (0, _date.createCalendar)
    });
    let { calendarProps, prevButtonProps, nextButtonProps } = (0, _src.useCalendar)(props, state);
    let grids = (0, _react.useMemo)(()=>{
        let gridCount = 1;
        if (visibleDuration.months && visibleDuration.months > 0) gridCount = visibleDuration.months;
        let components = [];
        for(let i = 0; i < gridCount; i++)components.push(/*#__PURE__*/ (0, _reactDefault.default).createElement(CalendarGrid, {
            key: i,
            state: state,
            visibleDuration: visibleDuration,
            offset: {
                months: i
            }
        }));
        return components;
    }, [
        visibleDuration,
        state
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", calendarProps, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        style: {
            textAlign: "center"
        },
        "data-testid": "range"
    }, calendarProps["aria-label"]), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        style: {
            display: "grid",
            gridTemplateColumns: `repeat(${grids.length}, 1fr)`,
            gap: "1em"
        }
    }, grids), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.Button), {
        variant: "secondary",
        ...prevButtonProps
    }, "prev"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.Button), {
        variant: "secondary",
        ...nextButtonProps
    }, "next")));
}
function CalendarGrid({ state, visibleDuration, offset = {} }) {
    let { locale } = (0, _i18N.useLocale)();
    let { gridProps } = (0, _src.useCalendarGrid)({}, state);
    var _visibleDuration_weeks;
    let weeks = (_visibleDuration_weeks = visibleDuration.weeks) !== null && _visibleDuration_weeks !== void 0 ? _visibleDuration_weeks : 1;
    let startDate = state.visibleRange.start.add(offset);
    if (visibleDuration.months) {
        weeks = (0, _date.getWeeksInMonth)(state.visibleRange.start, locale);
        startDate = (0, _date.startOfWeek)(startDate, locale);
    }
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", gridProps, [
        ...new Array(weeks).keys()
    ].map((weekIndex)=>/*#__PURE__*/ {
        var _visibleDuration_days;
        return (0, _reactDefault.default).createElement("div", {
            key: weekIndex,
            role: "row"
        }, [
            ...new Array((_visibleDuration_days = visibleDuration.days) !== null && _visibleDuration_days !== void 0 ? _visibleDuration_days : 7).keys()
        ].map((dayIndex)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(Cell, {
                key: dayIndex,
                state: state,
                date: startDate.add({
                    weeks: weekIndex,
                    days: dayIndex
                })
            })));
    }));
}
function Cell(props) {
    let ref = (0, _react.useRef)();
    let { cellProps, buttonProps } = (0, _src.useCalendarCell)(props, props.state, ref);
    let dateFormatter = (0, _i18N.useDateFormatter)({
        day: "numeric",
        timeZone: props.state.timeZone,
        calendar: props.date.calendar.identifier
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...cellProps,
        style: {
            display: "inline-block"
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        ref: ref,
        ...buttonProps,
        style: {
            display: "block",
            width: 42,
            height: 42,
            background: props.state.isSelected(props.date) ? "blue" : ""
        }
    }, dateFormatter.format(props.date.toDate(props.state.timeZone))));
}

},{"@react-spectrum/button":"jZWyP","@react-stately/calendar":"a8x0w","@internationalized/date":"hesBk","react":"9yzVZ","../src":"98n7T","@react-aria/i18n":"411rg","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"jZWyP":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /// <reference types="css-module-types" />
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Button", ()=>(0, _button.Button));
parcelHelpers.export(exports, "ActionButton", ()=>(0, _actionButton.ActionButton));
parcelHelpers.export(exports, "FieldButton", ()=>(0, _fieldButton.FieldButton));
parcelHelpers.export(exports, "LogicButton", ()=>(0, _logicButton.LogicButton));
parcelHelpers.export(exports, "ClearButton", ()=>(0, _clearButton.ClearButton));
parcelHelpers.export(exports, "ToggleButton", ()=>(0, _toggleButton.ToggleButton));
var _button = require("./Button");
var _actionButton = require("./ActionButton");
var _fieldButton = require("./FieldButton");
var _logicButton = require("./LogicButton");
var _clearButton = require("./ClearButton");
var _toggleButton = require("./ToggleButton");

},{"./Button":"2yCgc","./ActionButton":"3x7cD","./FieldButton":"Gn8H0","./LogicButton":"3jxvO","./ClearButton":"2Ltej","./ToggleButton":"cqKMi","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"2yCgc":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Button", ()=>_Button);
var _utils = require("@react-spectrum/utils");
var _focus = require("@react-aria/focus");
// @ts-ignore
var _json = require("../intl/*.json");
var _jsonDefault = parcelHelpers.interopDefault(_json);
var _utils1 = require("@react-aria/utils");
var _progress = require("@react-spectrum/progress");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _varsCss = require("@adobe/spectrum-css-temp/components/button/vars.css");
var _varsCssDefault = parcelHelpers.interopDefault(_varsCss);
var _text = require("@react-spectrum/text");
var _button = require("@react-aria/button");
var _interactions = require("@react-aria/interactions");
var _i18N = require("@react-aria/i18n");
var _provider = require("@react-spectrum/provider");
function disablePendingProps(props) {
    // Don't allow interaction while isPending is true
    if (props.isPending) {
        props.onPress = undefined;
        props.onPressStart = undefined;
        props.onPressEnd = undefined;
        props.onPressChange = undefined;
        props.onPressUp = undefined;
        props.onKeyDown = undefined;
        props.onKeyUp = undefined;
        props.onClick = undefined;
        props.href = undefined;
    }
    return props;
}
function Button(props, ref) {
    var _buttonProps_arialabelledby;
    props = (0, _provider.useProviderProps)(props);
    props = (0, _utils.useSlotProps)(props, "button");
    props = disablePendingProps(props);
    let { elementType: Element = "button", children, variant, style = variant === "accent" || variant === "cta" ? "fill" : "outline", staticColor, isDisabled, isPending, autoFocus, ...otherProps } = props;
    let domRef = (0, _utils.useFocusableRef)(ref);
    let { buttonProps, isPressed } = (0, _button.useButton)(props, domRef);
    let { hoverProps, isHovered } = (0, _interactions.useHover)({
        isDisabled
    });
    let [isFocused, onFocusChange] = (0, _react.useState)(false);
    let { focusProps } = (0, _interactions.useFocus)({
        onFocusChange,
        isDisabled
    });
    let stringFormatter = (0, _i18N.useLocalizedStringFormatter)((0, _jsonDefault.default), "@react-spectrum/button");
    let { styleProps } = (0, _utils.useStyleProps)(otherProps);
    let hasLabel = (0, _utils.useHasChild)(`.${(0, _varsCssDefault.default)["spectrum-Button-label"]}`, domRef);
    let hasIcon = (0, _utils.useHasChild)(`.${(0, _varsCssDefault.default)["spectrum-Icon"]}`, domRef);
    // an aria label will block children and their labels from being read, this is undesirable for pending state
    let hasAriaLabel = !!buttonProps["aria-label"] || !!buttonProps["aria-labelledby"];
    let [isProgressVisible, setIsProgressVisible] = (0, _react.useState)(false);
    let backupButtonId = (0, _utils1.useId)();
    let buttonId = buttonProps.id || backupButtonId;
    let iconId = (0, _utils1.useId)();
    let textId = (0, _utils1.useId)();
    let spinnerId = (0, _utils1.useId)();
    (0, _react.useEffect)(()=>{
        let timeout;
        if (isPending) // Start timer when isPending is set to true.
        timeout = setTimeout(()=>{
            setIsProgressVisible(true);
        }, 1000);
        else // Exit loading state when isPending is set to false. */
        setIsProgressVisible(false);
        return ()=>{
            // Clean up on unmount or when user removes isPending prop before entering loading state.
            clearTimeout(timeout);
        };
    }, [
        isPending
    ]);
    if (variant === "cta") variant = "accent";
    else if (variant === "overBackground") {
        variant = "primary";
        staticColor = "white";
    }
    const isPendingAriaLiveLabel = `${hasAriaLabel ? buttonProps["aria-label"] : ""} ${stringFormatter.format("pending")}`.trim();
    var _buttonProps_arialabelledby_replace;
    const isPendingAriaLiveLabelledby = hasAriaLabel ? (_buttonProps_arialabelledby_replace = (_buttonProps_arialabelledby = buttonProps["aria-labelledby"]) === null || _buttonProps_arialabelledby === void 0 ? void 0 : _buttonProps_arialabelledby.replace(buttonId, spinnerId)) !== null && _buttonProps_arialabelledby_replace !== void 0 ? _buttonProps_arialabelledby_replace : spinnerId : `${hasIcon ? iconId : ""} ${hasLabel ? textId : ""} ${spinnerId}`.trim();
    let ariaLive = "polite";
    if ((0, _utils1.isAppleDevice)() && (!hasAriaLabel || (0, _utils1.isFirefox)())) ariaLive = "off";
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _focus.FocusRing), {
        focusRingClass: (0, _utils.classNames)((0, _varsCssDefault.default), "focus-ring"),
        autoFocus: autoFocus
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Element, {
        ...styleProps,
        ...(0, _utils1.mergeProps)(buttonProps, hoverProps, focusProps),
        id: buttonId,
        ref: domRef,
        "data-variant": variant,
        "data-style": style,
        "data-static-color": staticColor || undefined,
        "aria-disabled": isPending ? "true" : undefined,
        "aria-label": isPending ? isPendingAriaLiveLabel : buttonProps["aria-label"],
        "aria-labelledby": isPending ? isPendingAriaLiveLabelledby : buttonProps["aria-labelledby"],
        className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Button", {
            "spectrum-Button--iconOnly": hasIcon && !hasLabel,
            "is-disabled": isDisabled || isProgressVisible,
            "is-active": isPressed,
            "is-hovered": isHovered,
            "spectrum-Button--pending": isProgressVisible
        }, styleProps.className)
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.SlotProvider), {
        slots: {
            icon: {
                id: iconId,
                size: "S",
                UNSAFE_className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Icon")
            },
            text: {
                id: textId,
                UNSAFE_className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Button-label")
            }
        }
    }, typeof children === "string" ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, children) : children, isPending && /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        "aria-hidden": "true",
        style: {
            visibility: isProgressVisible ? "visible" : "hidden"
        },
        className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Button-circleLoader")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _progress.ProgressCircle), {
        "aria-label": isPendingAriaLiveLabel,
        isIndeterminate: true,
        size: "S",
        staticColor: staticColor
    })), isPending && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        "aria-live": isFocused ? ariaLive : "off"
    }, isProgressVisible && /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        role: "img",
        "aria-labelledby": isPendingAriaLiveLabelledby
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        id: spinnerId,
        role: "img",
        "aria-label": isPendingAriaLiveLabel
    })))));
}
/**
 * Buttons allow users to perform an action or to navigate to another page.
 * They have multiple styles for various needs, and are ideal for calling attention to
 * where a user needs to do something in order to move forward in a flow.
 */ let _Button = /*#__PURE__*/ (0, _reactDefault.default).forwardRef(Button);

},{"@react-spectrum/utils":"cMIJ6","@react-aria/focus":"42mbF","../intl/*.json":"asYmN","@react-aria/utils":"9cLk5","@react-spectrum/progress":"4kHa7","react":"9yzVZ","@adobe/spectrum-css-temp/components/button/vars.css":"cTEhK","@react-spectrum/text":"etCGI","@react-aria/button":"fsdLZ","@react-aria/interactions":"ky3G8","@react-aria/i18n":"411rg","@react-spectrum/provider":"5bCdp","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"asYmN":[function(require,module,exports) {
const _temp0 = require("816c3614a495ab64");
const _temp1 = require("64c6323806ebd32d");
const _temp2 = require("8ef9410058d67198");
const _temp3 = require("f8f3843cd113f204");
const _temp4 = require("c43a7e32c7a8dac6");
const _temp5 = require("72cae3a63de2b028");
const _temp6 = require("4b76708c51fa1e3a");
const _temp7 = require("7fa4b1dad5d35431");
const _temp8 = require("64fd01dcb96b1a91");
const _temp9 = require("7764bce7476cedd3");
const _temp10 = require("c8ba84b5b90789ed");
const _temp11 = require("845b77e7f8602a19");
const _temp12 = require("27781e53e018115b");
const _temp13 = require("c24771ad81ae54d9");
const _temp14 = require("6a8775ec5ebe876a");
const _temp15 = require("5b019c1e1f43425e");
const _temp16 = require("70f5028bb2aff2ee");
const _temp17 = require("7f494aa59374905a");
const _temp18 = require("640bfcb3bbdf42c1");
const _temp19 = require("1cf88ca79faddfb");
const _temp20 = require("cb6650a86d8ad670");
const _temp21 = require("25fe1097f1a0f3c7");
const _temp22 = require("9208175f0f0532ab");
const _temp23 = require("d63882167e597ebe");
const _temp24 = require("78fca7754573990d");
const _temp25 = require("396cef1e4f3578f8");
const _temp26 = require("344fa5fccc386bcb");
const _temp27 = require("2290bd127893638e");
const _temp28 = require("899bd919309a13f2");
const _temp29 = require("400fbf1d7b8d4a39");
const _temp30 = require("624e23dce12eb759");
const _temp31 = require("b7c13cb3afa1c3f");
const _temp32 = require("61d6c0e000ff282");
const _temp33 = require("430f9b26b58537ea");
module.exports = {
    "ar-AE": _temp0,
    "bg-BG": _temp1,
    "cs-CZ": _temp2,
    "da-DK": _temp3,
    "de-DE": _temp4,
    "el-GR": _temp5,
    "en-US": _temp6,
    "es-ES": _temp7,
    "et-EE": _temp8,
    "fi-FI": _temp9,
    "fr-FR": _temp10,
    "he-IL": _temp11,
    "hr-HR": _temp12,
    "hu-HU": _temp13,
    "it-IT": _temp14,
    "ja-JP": _temp15,
    "ko-KR": _temp16,
    "lt-LT": _temp17,
    "lv-LV": _temp18,
    "nb-NO": _temp19,
    "nl-NL": _temp20,
    "pl-PL": _temp21,
    "pt-BR": _temp22,
    "pt-PT": _temp23,
    "ro-RO": _temp24,
    "ru-RU": _temp25,
    "sk-SK": _temp26,
    "sl-SI": _temp27,
    "sr-SP": _temp28,
    "sv-SE": _temp29,
    "tr-TR": _temp30,
    "uk-UA": _temp31,
    "zh-CN": _temp32,
    "zh-TW": _temp33
};

},{"816c3614a495ab64":"5Maxb","64c6323806ebd32d":"4ZhIT","8ef9410058d67198":"69b7b","f8f3843cd113f204":"iQzSH","c43a7e32c7a8dac6":"bXfpk","72cae3a63de2b028":"a05Ek","4b76708c51fa1e3a":"2auCP","7fa4b1dad5d35431":"l1cuA","64fd01dcb96b1a91":"8Jp3b","7764bce7476cedd3":"4G8Ji","c8ba84b5b90789ed":"gCKDY","845b77e7f8602a19":"bxWkq","27781e53e018115b":"jpQLm","c24771ad81ae54d9":"jiLbK","6a8775ec5ebe876a":"04qfa","5b019c1e1f43425e":"cQSHo","70f5028bb2aff2ee":"juJVz","7f494aa59374905a":"t8TTL","640bfcb3bbdf42c1":"k0V0g","1cf88ca79faddfb":"b9QB7","cb6650a86d8ad670":"10Yti","25fe1097f1a0f3c7":"cubDN","9208175f0f0532ab":"3szPu","d63882167e597ebe":"ht04n","78fca7754573990d":"cBWZQ","396cef1e4f3578f8":"87DN7","344fa5fccc386bcb":"7vJ0g","2290bd127893638e":"7kTeB","899bd919309a13f2":"5uSaL","400fbf1d7b8d4a39":"8KqdF","624e23dce12eb759":"1w6yj","b7c13cb3afa1c3f":"EtvXO","61d6c0e000ff282":"9DX6b","430f9b26b58537ea":"9sY3d"}],"5Maxb":[function(require,module,exports) {
module.exports = {
    "pending": `\u{642}\u{64A}\u{62F} \u{627}\u{644}\u{627}\u{646}\u{62A}\u{638}\u{627}\u{631}`
};

},{}],"4ZhIT":[function(require,module,exports) {
module.exports = {
    "pending": `\u{43D}\u{435}\u{434}\u{43E}\u{432}\u{44A}\u{440}\u{448}\u{435}\u{43D}\u{43E}`
};

},{}],"69b7b":[function(require,module,exports) {
module.exports = {
    "pending": `\u{10D}ek\xe1 na vy\u{159}\xedzen\xed`
};

},{}],"iQzSH":[function(require,module,exports) {
module.exports = {
    "pending": `afventende`
};

},{}],"bXfpk":[function(require,module,exports) {
module.exports = {
    "pending": `Ausstehend`
};

},{}],"a05Ek":[function(require,module,exports) {
module.exports = {
    "pending": `\u{3C3}\u{3B5} \u{3B5}\u{3BA}\u{3BA}\u{3C1}\u{3B5}\u{3BC}\u{3CC}\u{3C4}\u{3B7}\u{3C4}\u{3B1}`
};

},{}],"2auCP":[function(require,module,exports) {
module.exports = {
    "pending": `pending`
};

},{}],"l1cuA":[function(require,module,exports) {
module.exports = {
    "pending": `pendiente`
};

},{}],"8Jp3b":[function(require,module,exports) {
module.exports = {
    "pending": `ootel`
};

},{}],"4G8Ji":[function(require,module,exports) {
module.exports = {
    "pending": `odottaa`
};

},{}],"gCKDY":[function(require,module,exports) {
module.exports = {
    "pending": `En attente`
};

},{}],"bxWkq":[function(require,module,exports) {
module.exports = {
    "pending": `\u{5DE}\u{5DE}\u{5EA}\u{5D9}\u{5DF} \u{5DC}`
};

},{}],"jpQLm":[function(require,module,exports) {
module.exports = {
    "pending": `u tijeku`
};

},{}],"jiLbK":[function(require,module,exports) {
module.exports = {
    "pending": `f\xfcgg\u{151}ben lev\u{151}`
};

},{}],"04qfa":[function(require,module,exports) {
module.exports = {
    "pending": `in sospeso`
};

},{}],"cQSHo":[function(require,module,exports) {
module.exports = {
    "pending": `\u{4FDD}\u{7559}`
};

},{}],"juJVz":[function(require,module,exports) {
module.exports = {
    "pending": `\u{BCF4}\u{B958} \u{C911}`
};

},{}],"t8TTL":[function(require,module,exports) {
module.exports = {
    "pending": `laukiama`
};

},{}],"k0V0g":[function(require,module,exports) {
module.exports = {
    "pending": `gaida`
};

},{}],"b9QB7":[function(require,module,exports) {
module.exports = {
    "pending": `avventer`
};

},{}],"10Yti":[function(require,module,exports) {
module.exports = {
    "pending": `in behandeling`
};

},{}],"cubDN":[function(require,module,exports) {
module.exports = {
    "pending": `oczekuj\u{105}ce`
};

},{}],"3szPu":[function(require,module,exports) {
module.exports = {
    "pending": `pendente`
};

},{}],"ht04n":[function(require,module,exports) {
module.exports = {
    "pending": `pendente`
};

},{}],"cBWZQ":[function(require,module,exports) {
module.exports = {
    "pending": `\xeen a\u{219}teptare`
};

},{}],"87DN7":[function(require,module,exports) {
module.exports = {
    "pending": `\u{432} \u{43E}\u{436}\u{438}\u{434}\u{430}\u{43D}\u{438}\u{438}`
};

},{}],"7vJ0g":[function(require,module,exports) {
module.exports = {
    "pending": `\u{10D}akaj\xface`
};

},{}],"7kTeB":[function(require,module,exports) {
module.exports = {
    "pending": `v teku`
};

},{}],"5uSaL":[function(require,module,exports) {
module.exports = {
    "pending": `nere\u{161}eno`
};

},{}],"8KqdF":[function(require,module,exports) {
module.exports = {
    "pending": `v\xe4ntande`
};

},{}],"1w6yj":[function(require,module,exports) {
module.exports = {
    "pending": `beklemede`
};

},{}],"EtvXO":[function(require,module,exports) {
module.exports = {
    "pending": `\u{432} \u{43E}\u{447}\u{456}\u{43A}\u{443}\u{432}\u{430}\u{43D}\u{43D}\u{456}`
};

},{}],"9DX6b":[function(require,module,exports) {
module.exports = {
    "pending": `\u{5F85}\u{5904}\u{7406}`
};

},{}],"9sY3d":[function(require,module,exports) {
module.exports = {
    "pending": `\u{5F85}\u{8655}\u{7406}`
};

},{}],"4kHa7":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /// <reference types="css-module-types" />
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ProgressBar", ()=>(0, _progressBar.ProgressBar));
parcelHelpers.export(exports, "ProgressCircle", ()=>(0, _progressCircle.ProgressCircle));
parcelHelpers.export(exports, "ProgressBarBase", ()=>(0, _progressBarBase.ProgressBarBase));
var _progressBar = require("./ProgressBar");
var _progressCircle = require("./ProgressCircle");
var _progressBarBase = require("./ProgressBarBase");

},{"./ProgressBar":"htISg","./ProgressCircle":"8CDgb","./ProgressBarBase":"ikN4g","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"htISg":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ProgressBar", ()=>_ProgressBar);
var _utils = require("@react-spectrum/utils");
var _progressBarBase = require("./ProgressBarBase");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _varsCss = require("@adobe/spectrum-css-temp/components/barloader/vars.css");
var _varsCssDefault = parcelHelpers.interopDefault(_varsCss);
var _progress = require("@react-aria/progress");
function ProgressBar(props, ref) {
    let { staticColor, variant, ...otherProps } = props;
    const { progressBarProps, labelProps } = (0, _progress.useProgressBar)(props);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _progressBarBase.ProgressBarBase), {
        ...otherProps,
        ref: ref,
        barProps: progressBarProps,
        labelProps: labelProps,
        barClassName: (0, _utils.classNames)((0, _varsCssDefault.default), {
            "spectrum-BarLoader--overBackground": variant === "overBackground",
            "spectrum-BarLoader--staticWhite": staticColor === "white",
            "spectrum-BarLoader--staticBlack": staticColor === "black"
        })
    });
}
/**
 * ProgressBars show the progression of a system operation: downloading, uploading, processing, etc., in a visual way.
 * They can represent either determinate or indeterminate progress.
 */ let _ProgressBar = /*#__PURE__*/ (0, _reactDefault.default).forwardRef(ProgressBar);

},{"@react-spectrum/utils":"cMIJ6","./ProgressBarBase":"ikN4g","react":"9yzVZ","@adobe/spectrum-css-temp/components/barloader/vars.css":"k8y65","@react-aria/progress":"NyXcB","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"ikN4g":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ProgressBarBase", ()=>_ProgressBarBase);
var _utils = require("@react-aria/utils");
var _utils1 = require("@react-spectrum/utils");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _varsCss = require("@adobe/spectrum-css-temp/components/barloader/vars.css");
var _varsCssDefault = parcelHelpers.interopDefault(_varsCss);
// Base ProgressBar component shared with Meter.
function ProgressBarBase(props, ref) {
    let { value = 0, minValue = 0, maxValue = 100, size = "L", label, barClassName, showValueLabel = !!label, labelPosition = "top", isIndeterminate = false, barProps, labelProps, "aria-label": ariaLabel, "aria-labelledby": ariaLabelledby, ...otherProps } = props;
    let domRef = (0, _utils1.useDOMRef)(ref);
    let { styleProps } = (0, _utils1.useStyleProps)(otherProps);
    value = (0, _utils.clamp)(value, minValue, maxValue);
    let barStyle = {};
    if (!isIndeterminate) {
        let percentage = (value - minValue) / (maxValue - minValue);
        barStyle.width = `${Math.round(percentage * 100)}%`;
    }
    // Ideally this should be in useProgressBar, but children
    // are not supported in ProgressCircle which shares that hook...
    if (!label && !ariaLabel && !ariaLabelledby) console.warn("If you do not provide a visible label via children, you must specify an aria-label or aria-labelledby attribute for accessibility");
    // use inline style for fit-content because cssnano is too smart for us and will strip out the -moz prefix in css files
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...barProps,
        ref: domRef,
        className: (0, _utils1.classNames)((0, _varsCssDefault.default), "spectrum-BarLoader", {
            "spectrum-BarLoader--small": size === "S",
            "spectrum-BarLoader--large": size === "L",
            "spectrum-BarLoader--indeterminate": isIndeterminate,
            "spectrum-BarLoader--sideLabel": labelPosition === "side"
        }, barClassName, styleProps.className),
        style: {
            minWidth: "-moz-fit-content",
            ...styleProps.style
        }
    }, label && /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        ...labelProps,
        className: (0, _utils1.classNames)((0, _varsCssDefault.default), "spectrum-BarLoader-label")
    }, label), showValueLabel && barProps && /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _utils1.classNames)((0, _varsCssDefault.default), "spectrum-BarLoader-percentage")
    }, barProps["aria-valuetext"]), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _utils1.classNames)((0, _varsCssDefault.default), "spectrum-BarLoader-track")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _utils1.classNames)((0, _varsCssDefault.default), "spectrum-BarLoader-fill"),
        style: barStyle
    })));
}
let _ProgressBarBase = /*#__PURE__*/ (0, _reactDefault.default).forwardRef(ProgressBarBase);

},{"@react-aria/utils":"9cLk5","@react-spectrum/utils":"cMIJ6","react":"9yzVZ","@adobe/spectrum-css-temp/components/barloader/vars.css":"k8y65","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"k8y65":[function(require,module,exports) {
module.exports["focus-ring"] = `uFrYBa_focus-ring`;
module.exports["i18nFontFamily"] = `uFrYBa_i18nFontFamily`;
module.exports["indeterminate-loop-ltr"] = `uFrYBa_indeterminate-loop-ltr`;
module.exports["indeterminate-loop-ltr"];
module.exports["indeterminate-loop-rtl"] = `uFrYBa_indeterminate-loop-rtl`;
module.exports["indeterminate-loop-rtl"];
module.exports["is-critical"] = `uFrYBa_is-critical`;
module.exports["is-positive"] = `uFrYBa_is-positive`;
module.exports["is-warning"] = `uFrYBa_is-warning`;
module.exports["spectrum-BarLoader"] = `uFrYBa_spectrum-BarLoader`;
module.exports["spectrum-BarLoader--indeterminate"] = `uFrYBa_spectrum-BarLoader--indeterminate`;
module.exports["spectrum-BarLoader--overBackground"] = `uFrYBa_spectrum-BarLoader--overBackground`;
module.exports["spectrum-BarLoader--sideLabel"] = `uFrYBa_spectrum-BarLoader--sideLabel`;
module.exports["spectrum-BarLoader--small"] = `uFrYBa_spectrum-BarLoader--small`;
module.exports["spectrum-BarLoader--staticBlack"] = `uFrYBa_spectrum-BarLoader--staticBlack`;
module.exports["spectrum-BarLoader--staticWhite"] = `uFrYBa_spectrum-BarLoader--staticWhite`;
module.exports["spectrum-BarLoader-fill"] = `uFrYBa_spectrum-BarLoader-fill`;
module.exports["spectrum-BarLoader-label"] = `uFrYBa_spectrum-BarLoader-label`;
module.exports["spectrum-BarLoader-percentage"] = `uFrYBa_spectrum-BarLoader-percentage`;
module.exports["spectrum-BarLoader-track"] = `uFrYBa_spectrum-BarLoader-track`;
module.exports["spectrum-FocusRing-ring"] = `uFrYBa_spectrum-FocusRing-ring`;
module.exports["spectrum-FocusRing"] = `uFrYBa_spectrum-FocusRing ${module.exports["spectrum-FocusRing-ring"]}`;
module.exports["spectrum-FocusRing--quiet"] = `uFrYBa_spectrum-FocusRing--quiet`;

},{}],"8CDgb":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ProgressCircle", ()=>_ProgressCircle);
var _utils = require("@react-aria/utils");
var _utils1 = require("@react-spectrum/utils");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _varsCss = require("@adobe/spectrum-css-temp/components/circleloader/vars.css");
var _varsCssDefault = parcelHelpers.interopDefault(_varsCss);
var _progress = require("@react-aria/progress");
function ProgressCircle(props, ref) {
    let { value = 0, minValue = 0, maxValue = 100, size = "M", staticColor, variant, isIndeterminate = false, "aria-label": ariaLabel, "aria-labelledby": ariaLabelledby, ...otherProps } = props;
    let domRef = (0, _utils1.useDOMRef)(ref);
    let { styleProps } = (0, _utils1.useStyleProps)(otherProps);
    value = (0, _utils.clamp)(value, minValue, maxValue);
    let { progressBarProps } = (0, _progress.useProgressBar)({
        ...props,
        value
    });
    let subMask1Style = {};
    let subMask2Style = {};
    if (!isIndeterminate) {
        let percentage = (value - minValue) / (maxValue - minValue) * 100;
        let angle;
        if (percentage > 0 && percentage <= 50) {
            angle = -180 + percentage / 50 * 180;
            subMask1Style.transform = `rotate(${angle}deg)`;
            subMask2Style.transform = "rotate(-180deg)";
        } else if (percentage > 50) {
            angle = -180 + (percentage - 50) / 50 * 180;
            subMask1Style.transform = "rotate(0deg)";
            subMask2Style.transform = `rotate(${angle}deg)`;
        }
    }
    if (!ariaLabel && !ariaLabelledby) console.warn("ProgressCircle requires an aria-label or aria-labelledby attribute for accessibility");
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...styleProps,
        ...progressBarProps,
        ref: domRef,
        className: (0, _utils1.classNames)((0, _varsCssDefault.default), "spectrum-CircleLoader", {
            "spectrum-CircleLoader--indeterminate": isIndeterminate,
            "spectrum-CircleLoader--small": size === "S",
            "spectrum-CircleLoader--large": size === "L",
            "spectrum-CircleLoader--overBackground": variant === "overBackground",
            "spectrum-CircleLoader--staticWhite": staticColor === "white",
            "spectrum-CircleLoader--staticBlack": staticColor === "black"
        }, styleProps.className)
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _utils1.classNames)((0, _varsCssDefault.default), "spectrum-CircleLoader-track")
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _utils1.classNames)((0, _varsCssDefault.default), "spectrum-CircleLoader-fills")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _utils1.classNames)((0, _varsCssDefault.default), "spectrum-CircleLoader-fillMask1")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _utils1.classNames)((0, _varsCssDefault.default), "spectrum-CircleLoader-fillSubMask1"),
        "data-testid": "fillSubMask1",
        style: subMask1Style
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _utils1.classNames)((0, _varsCssDefault.default), "spectrum-CircleLoader-fill")
    }))), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _utils1.classNames)((0, _varsCssDefault.default), "spectrum-CircleLoader-fillMask2")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _utils1.classNames)((0, _varsCssDefault.default), "spectrum-CircleLoader-fillSubMask2"),
        "data-testid": "fillSubMask2",
        style: subMask2Style
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _utils1.classNames)((0, _varsCssDefault.default), "spectrum-CircleLoader-fill")
    })))));
}
/**
 * ProgressCircles show the progression of a system operation such as downloading, uploading, or processing, in a visual way.
 * They can represent determinate or indeterminate progress.
 */ let _ProgressCircle = /*#__PURE__*/ (0, _reactDefault.default).forwardRef(ProgressCircle);

},{"@react-aria/utils":"9cLk5","@react-spectrum/utils":"cMIJ6","react":"9yzVZ","@adobe/spectrum-css-temp/components/circleloader/vars.css":"cWKC0","@react-aria/progress":"NyXcB","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"cWKC0":[function(require,module,exports) {
module.exports["focus-ring"] = `EQYv7q_focus-ring`;
module.exports["i18nFontFamily"] = `EQYv7q_i18nFontFamily`;
module.exports["spectrum-CircleLoader"] = `EQYv7q_spectrum-CircleLoader`;
module.exports["spectrum-CircleLoader--indeterminate"] = `EQYv7q_spectrum-CircleLoader--indeterminate`;
module.exports["spectrum-CircleLoader--indeterminate-fill-submask-2"] = `EQYv7q_spectrum-CircleLoader--indeterminate-fill-submask-2`;
module.exports["spectrum-CircleLoader--large"] = `EQYv7q_spectrum-CircleLoader--large`;
module.exports["spectrum-CircleLoader--overBackground"] = `EQYv7q_spectrum-CircleLoader--overBackground`;
module.exports["spectrum-CircleLoader--small"] = `EQYv7q_spectrum-CircleLoader--small`;
module.exports["spectrum-CircleLoader--staticBlack"] = `EQYv7q_spectrum-CircleLoader--staticBlack`;
module.exports["spectrum-CircleLoader--staticWhite"] = `EQYv7q_spectrum-CircleLoader--staticWhite`;
module.exports["spectrum-CircleLoader-fill"] = `EQYv7q_spectrum-CircleLoader-fill`;
module.exports["spectrum-CircleLoader-fillMask1"] = `EQYv7q_spectrum-CircleLoader-fillMask1`;
module.exports["spectrum-CircleLoader-fillMask2"] = `EQYv7q_spectrum-CircleLoader-fillMask2`;
module.exports["spectrum-CircleLoader-fillSubMask1"] = `EQYv7q_spectrum-CircleLoader-fillSubMask1`;
module.exports["spectrum-CircleLoader-fillSubMask2"] = `EQYv7q_spectrum-CircleLoader-fillSubMask2`;
module.exports["spectrum-CircleLoader-fills"] = `EQYv7q_spectrum-CircleLoader-fills`;
module.exports["spectrum-CircleLoader-track"] = `EQYv7q_spectrum-CircleLoader-track`;
module.exports["spectrum-FocusRing-ring"] = `EQYv7q_spectrum-FocusRing-ring`;
module.exports["spectrum-FocusRing"] = `EQYv7q_spectrum-FocusRing ${module.exports["spectrum-FocusRing-ring"]}`;
module.exports["spectrum-FocusRing--quiet"] = `EQYv7q_spectrum-FocusRing--quiet`;
module.exports["spectrum-fill-mask-1"] = `EQYv7q_spectrum-fill-mask-1`;
module.exports["spectrum-fill-mask-1"];
module.exports["spectrum-fill-mask-2"] = `EQYv7q_spectrum-fill-mask-2`;
module.exports["spectrum-fill-mask-2"];
module.exports["spectrum-fills-rotate"] = `EQYv7q_spectrum-fills-rotate`;
module.exports["spectrum-fills-rotate"];

},{}],"cTEhK":[function(require,module,exports) {
module.exports["focus-ring"] = `Dniwja_focus-ring`;
module.exports["i18nFontFamily"] = `Dniwja_i18nFontFamily`;
module.exports["is-active"] = `Dniwja_is-active`;
module.exports["is-disabled"] = `Dniwja_is-disabled`;
module.exports["is-focused"] = `Dniwja_is-focused`;
module.exports["is-hovered"] = `Dniwja_is-hovered`;
module.exports["is-open"] = `Dniwja_is-open`;
module.exports["is-placeholder"] = `Dniwja_is-placeholder`;
module.exports["is-selected"] = `Dniwja_is-selected`;
module.exports["spectrum-BaseButton"] = `Dniwja_spectrum-BaseButton ${module.exports["i18nFontFamily"]}`;
module.exports["spectrum-FocusRing-ring"] = `Dniwja_spectrum-FocusRing-ring`;
module.exports["spectrum-FocusRing"] = `Dniwja_spectrum-FocusRing ${module.exports["spectrum-FocusRing-ring"]}`;
module.exports["spectrum-ActionButton"] = `Dniwja_spectrum-ActionButton ${module.exports["spectrum-BaseButton"]} ${module.exports["spectrum-FocusRing"]}`;
module.exports["spectrum-ActionButton--emphasized"] = `Dniwja_spectrum-ActionButton--emphasized`;
module.exports["spectrum-ActionButton--quiet"] = `Dniwja_spectrum-ActionButton--quiet`;
module.exports["spectrum-ActionButton--staticBlack"] = `Dniwja_spectrum-ActionButton--staticBlack`;
module.exports["spectrum-ActionButton--staticColor"] = `Dniwja_spectrum-ActionButton--staticColor`;
module.exports["spectrum-ActionButton--staticWhite"] = `Dniwja_spectrum-ActionButton--staticWhite`;
module.exports["spectrum-ActionButton-hold"] = `Dniwja_spectrum-ActionButton-hold`;
module.exports["spectrum-ActionButton-label"] = `Dniwja_spectrum-ActionButton-label`;
module.exports["spectrum-Button"] = `Dniwja_spectrum-Button ${module.exports["spectrum-BaseButton"]} ${module.exports["spectrum-FocusRing"]}`;
module.exports["spectrum-Button--iconOnly"] = `Dniwja_spectrum-Button--iconOnly`;
module.exports["spectrum-Button--overBackground"] = `Dniwja_spectrum-Button--overBackground`;
module.exports["spectrum-Button--pending"] = `Dniwja_spectrum-Button--pending`;
module.exports["spectrum-Button-circleLoader"] = `Dniwja_spectrum-Button-circleLoader`;
module.exports["spectrum-Button-label"] = `Dniwja_spectrum-Button-label`;
module.exports["spectrum-ClearButton"] = `Dniwja_spectrum-ClearButton ${module.exports["spectrum-BaseButton"]} ${module.exports["spectrum-FocusRing"]}`;
module.exports["spectrum-ClearButton--overBackground"] = `Dniwja_spectrum-ClearButton--overBackground`;
module.exports["spectrum-ClearButton--small"] = `Dniwja_spectrum-ClearButton--small`;
module.exports["spectrum-FieldButton"] = `Dniwja_spectrum-FieldButton ${module.exports["spectrum-BaseButton"]} ${module.exports["spectrum-FocusRing"]}`;
module.exports["spectrum-FieldButton--invalid"] = `Dniwja_spectrum-FieldButton--invalid`;
module.exports["spectrum-FocusRing--quiet"] = `Dniwja_spectrum-FocusRing--quiet`;
module.exports["spectrum-FieldButton--quiet"] = `Dniwja_spectrum-FieldButton--quiet ${module.exports["spectrum-FocusRing--quiet"]}`;
module.exports["spectrum-Icon"] = `Dniwja_spectrum-Icon`;
module.exports["spectrum-LogicButton"] = `Dniwja_spectrum-LogicButton ${module.exports["spectrum-BaseButton"]} ${module.exports["spectrum-FocusRing"]}`;
module.exports["spectrum-LogicButton--and"] = `Dniwja_spectrum-LogicButton--and`;
module.exports["spectrum-LogicButton--or"] = `Dniwja_spectrum-LogicButton--or`;

},{}],"etCGI":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /// <reference types="css-module-types" />
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Text", ()=>(0, _text.Text));
parcelHelpers.export(exports, "Heading", ()=>(0, _heading.Heading));
parcelHelpers.export(exports, "Keyboard", ()=>(0, _keyboard.Keyboard));
var _text = require("./Text");
var _heading = require("./Heading");
var _keyboard = require("./Keyboard");

},{"./Text":"6NJNP","./Heading":"jks89","./Keyboard":"gji5f","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"6NJNP":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Text", ()=>_Text);
var _utils = require("@react-aria/utils");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _utils1 = require("@react-spectrum/utils");
function Text(props, ref) {
    props = (0, _utils1.useSlotProps)(props, "text");
    let { children, ...otherProps } = props;
    let { styleProps } = (0, _utils1.useStyleProps)(otherProps);
    let domRef = (0, _utils1.useDOMRef)(ref);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        ...(0, _utils.filterDOMProps)(otherProps),
        ...styleProps,
        ref: domRef
    }, children);
}
/**
 * Text represents text with no specific semantic meaning.
 */ const _Text = /*#__PURE__*/ (0, _react.forwardRef)(Text);

},{"@react-aria/utils":"9cLk5","react":"9yzVZ","@react-spectrum/utils":"cMIJ6","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"jks89":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Heading", ()=>_Heading);
var _utils = require("@react-aria/utils");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _utils1 = require("@react-spectrum/utils");
function Heading(props, ref) {
    props = (0, _utils1.useSlotProps)(props, "heading");
    let { children, level = 3, ...otherProps } = props;
    let { styleProps } = (0, _utils1.useStyleProps)(otherProps);
    let domRef = (0, _utils1.useDOMRef)(ref);
    let HeadingTag = `h${level}`;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(HeadingTag, {
        ...(0, _utils.filterDOMProps)(otherProps),
        ...styleProps,
        ref: domRef
    }, children);
}
/**
 * Heading is used to create various levels of typographic hierarchies.
 */ const _Heading = /*#__PURE__*/ (0, _react.forwardRef)(Heading);

},{"@react-aria/utils":"9cLk5","react":"9yzVZ","@react-spectrum/utils":"cMIJ6","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"gji5f":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Keyboard", ()=>_Keyboard);
var _utils = require("@react-aria/utils");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _utils1 = require("@react-spectrum/utils");
function Keyboard(props, ref) {
    props = (0, _utils1.useSlotProps)(props, "keyboard");
    let { children, ...otherProps } = props;
    let { styleProps } = (0, _utils1.useStyleProps)(otherProps);
    let domRef = (0, _utils1.useDOMRef)(ref);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("kbd", {
        ...(0, _utils.filterDOMProps)(otherProps),
        ...styleProps,
        ref: domRef
    }, children);
}
/**
 * Keyboard represents text that specifies a keyboard command.
 */ const _Keyboard = /*#__PURE__*/ (0, _react.forwardRef)(Keyboard);

},{"@react-aria/utils":"9cLk5","react":"9yzVZ","@react-spectrum/utils":"cMIJ6","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"5bCdp":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /// <reference types="css-module-types" />
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Provider", ()=>(0, _provider.Provider));
parcelHelpers.export(exports, "useProvider", ()=>(0, _provider.useProvider));
parcelHelpers.export(exports, "useProviderProps", ()=>(0, _provider.useProviderProps));
var _provider = require("./Provider");

},{"./Provider":"1IDnF","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"1IDnF":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Provider", ()=>_Provider);
/**
 * Returns the various settings and styles applied by the nearest parent Provider.
 * Properties explicitly set by the nearest parent Provider override those provided by preceeding Providers.
 */ parcelHelpers.export(exports, "useProvider", ()=>useProvider);
parcelHelpers.export(exports, "useProviderProps", ()=>useProviderProps);
var _utils = require("@react-spectrum/utils");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _context = require("./context");
var _utils1 = require("@react-aria/utils");
var _i18N = require("@react-aria/i18n");
var _overlays = require("@react-aria/overlays");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _varsCss = require("@adobe/spectrum-css-temp/components/page/vars.css");
var _varsCssDefault = parcelHelpers.interopDefault(_varsCss);
var _indexCss = require("@adobe/spectrum-css-temp/components/typography/index.css");
var _indexCssDefault = parcelHelpers.interopDefault(_indexCss);
var _mediaQueries = require("./mediaQueries");
// @ts-ignore
var _packageJson = require("../package.json");
const DEFAULT_BREAKPOINTS = {
    S: 640,
    M: 768,
    L: 1024,
    XL: 1280,
    XXL: 1536
};
function Provider(props, ref) {
    let prevContext = useProvider();
    let prevColorScheme = prevContext && prevContext.colorScheme;
    let prevBreakpoints = prevContext && prevContext.breakpoints;
    let { theme = prevContext && prevContext.theme, defaultColorScheme } = props;
    if (!theme) throw new Error("theme not found, the parent provider must have a theme provided");
    // Hooks must always be called.
    let autoColorScheme = (0, _mediaQueries.useColorScheme)(theme, defaultColorScheme);
    let autoScale = (0, _mediaQueries.useScale)(theme);
    let { locale: prevLocale } = (0, _i18N.useLocale)();
    // if the new theme doesn't support the prevColorScheme, we must resort to the auto
    let usePrevColorScheme = !!theme[prevColorScheme];
    // importance of color scheme props > parent > auto:(OS > default > omitted)
    let { colorScheme = usePrevColorScheme ? prevColorScheme : autoColorScheme, scale = prevContext ? prevContext.scale : autoScale, locale = prevContext ? prevLocale : null, breakpoints = prevContext ? prevBreakpoints : DEFAULT_BREAKPOINTS, children, isQuiet, isEmphasized, isDisabled, isRequired, isReadOnly, validationState, router, ...otherProps } = props;
    // select only the props with values so undefined props don't overwrite prevContext values
    let currentProps = {
        version: (0, _packageJson.version),
        theme,
        breakpoints,
        colorScheme,
        scale,
        isQuiet,
        isEmphasized,
        isDisabled,
        isRequired,
        isReadOnly,
        validationState
    };
    let matchedBreakpoints = (0, _utils.useMatchedBreakpoints)(breakpoints);
    let filteredProps = {};
    Object.entries(currentProps).forEach(([key, value])=>value !== undefined && (filteredProps[key] = value));
    // Merge options with parent provider
    let context = Object.assign({}, prevContext, filteredProps);
    // Only wrap in a DOM node if the theme, colorScheme, or scale changed
    let contents = children;
    let domProps = (0, _utils1.filterDOMProps)(otherProps);
    let { styleProps } = (0, _utils.useStyleProps)(otherProps, undefined, {
        matchedBreakpoints
    });
    if (!prevContext || props.locale || theme !== prevContext.theme || colorScheme !== prevContext.colorScheme || scale !== prevContext.scale || Object.keys(domProps).length > 0 || otherProps.UNSAFE_className || Object.keys(styleProps.style).length > 0) contents = /*#__PURE__*/ (0, _reactDefault.default).createElement(ProviderWrapper, {
        ...props,
        UNSAFE_style: {
            isolation: !prevContext ? "isolate" : undefined,
            ...styleProps.style
        },
        ref: ref
    }, contents);
    if (router) contents = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils1.RouterProvider), router, contents);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _context.Context).Provider, {
        value: context
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _i18N.I18nProvider), {
        locale: locale
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.BreakpointProvider), {
        matchedBreakpoints: matchedBreakpoints
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _overlays.ModalProvider), null, contents))));
}
/**
 * Provider is the container for all React Spectrum applications.
 * It defines the theme, locale, and other application level settings,
 * and can also be used to provide common properties to a group of components.
 */ let _Provider = /*#__PURE__*/ (0, _reactDefault.default).forwardRef(Provider);
const ProviderWrapper = /*#__PURE__*/ (0, _reactDefault.default).forwardRef(function ProviderWrapper(props, ref) {
    let { children, ...otherProps } = props;
    let { locale, direction } = (0, _i18N.useLocale)();
    let { theme, colorScheme, scale } = useProvider();
    let { modalProviderProps } = (0, _overlays.useModalProvider)();
    let { styleProps } = (0, _utils.useStyleProps)(otherProps);
    let domRef = (0, _utils.useDOMRef)(ref);
    let themeKey = Object.keys(theme[colorScheme])[0];
    let scaleKey = Object.keys(theme[scale])[0];
    let className = (0, _clsxDefault.default)(styleProps.className, (0, _varsCssDefault.default)["spectrum"], (0, _indexCssDefault.default)["spectrum"], Object.values(theme[colorScheme]), Object.values(theme[scale]), theme.global ? Object.values(theme.global) : null, {
        "react-spectrum-provider": (0, _utils.shouldKeepSpectrumClassNames),
        spectrum: (0, _utils.shouldKeepSpectrumClassNames),
        [themeKey]: (0, _utils.shouldKeepSpectrumClassNames),
        [scaleKey]: (0, _utils.shouldKeepSpectrumClassNames)
    });
    var _props_colorScheme, _ref;
    let style = {
        ...styleProps.style,
        // This ensures that browser native UI like scrollbars are rendered in the right color scheme.
        // See https://web.dev/color-scheme/.
        colorScheme: (_ref = (_props_colorScheme = props.colorScheme) !== null && _props_colorScheme !== void 0 ? _props_colorScheme : colorScheme) !== null && _ref !== void 0 ? _ref : Object.keys(theme).filter((k)=>k === "light" || k === "dark").join(" ")
    };
    let hasWarned = (0, _react.useRef)(false);
    (0, _react.useEffect)(()=>{
        if (direction && domRef.current) {
            let closestDir = domRef.current.parentElement.closest("[dir]");
            let dir = closestDir && closestDir.getAttribute("dir");
            if (dir && dir !== direction && !hasWarned.current) {
                console.warn(`Language directions cannot be nested. ${direction} inside ${dir}.`);
                hasWarned.current = true;
            }
        }
    }, [
        direction,
        domRef,
        hasWarned
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...(0, _utils1.filterDOMProps)(otherProps),
        ...styleProps,
        ...modalProviderProps,
        className: className,
        style: style,
        lang: locale,
        dir: direction,
        ref: domRef
    }, children);
});
function useProvider() {
    return (0, _react.useContext)((0, _context.Context));
}
function useProviderProps(props) {
    let context = useProvider();
    if (!context) return props;
    return Object.assign({}, {
        isQuiet: context.isQuiet,
        isEmphasized: context.isEmphasized,
        isDisabled: context.isDisabled,
        isRequired: context.isRequired,
        isReadOnly: context.isReadOnly,
        validationState: context.validationState
    }, props);
}

},{"@react-spectrum/utils":"cMIJ6","clsx":"fAYNK","./context":"8zD0U","@react-aria/utils":"9cLk5","@react-aria/i18n":"411rg","@react-aria/overlays":"5fTCg","react":"9yzVZ","@adobe/spectrum-css-temp/components/page/vars.css":"i9k1x","@adobe/spectrum-css-temp/components/typography/index.css":"3wnTB","./mediaQueries":"hHKma","../package.json":"aHIRK","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"8zD0U":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Context", ()=>Context);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const Context = (0, _reactDefault.default).createContext(null);
Context.displayName = "ProviderContext";

},{"react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"i9k1x":[function(require,module,exports) {
module.exports["focus-ring"] = `JuTe6q_focus-ring`;
module.exports["i18nFontFamily"] = `JuTe6q_i18nFontFamily`;
module.exports["spectrum"] = `JuTe6q_spectrum`;
module.exports["spectrum-FocusRing-ring"] = `JuTe6q_spectrum-FocusRing-ring`;
module.exports["spectrum-FocusRing"] = `JuTe6q_spectrum-FocusRing ${module.exports["spectrum-FocusRing-ring"]}`;
module.exports["spectrum-FocusRing--quiet"] = `JuTe6q_spectrum-FocusRing--quiet`;

},{}],"3wnTB":[function(require,module,exports) {
module.exports["focus-ring"] = `_5QszkG_focus-ring`;
module.exports["i18nFontFamily"] = `_5QszkG_i18nFontFamily`;
module.exports["spectrum"] = `_5QszkG_spectrum ${module.exports["i18nFontFamily"]}`;
module.exports["spectrum-Body"] = `_5QszkG_spectrum-Body`;
module.exports["spectrum-Body--italic"] = `_5QszkG_spectrum-Body--italic`;
module.exports["spectrum-FocusRing-ring"] = `_5QszkG_spectrum-FocusRing-ring`;
module.exports["spectrum-FocusRing"] = `_5QszkG_spectrum-FocusRing ${module.exports["spectrum-FocusRing-ring"]}`;
module.exports["spectrum-FocusRing--quiet"] = `_5QszkG_spectrum-FocusRing--quiet`;

},{}],"hHKma":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useColorScheme", ()=>useColorScheme);
parcelHelpers.export(exports, "useScale", ()=>useScale);
var _utils = require("@react-spectrum/utils");
function useColorScheme(theme, defaultColorScheme) {
    let matchesDark = (0, _utils.useMediaQuery)("(prefers-color-scheme: dark)");
    let matchesLight = (0, _utils.useMediaQuery)("(prefers-color-scheme: light)");
    // importance OS > default > omitted
    if (theme.dark && matchesDark) return "dark";
    if (theme.light && matchesLight) return "light";
    if (theme.dark && defaultColorScheme === "dark") return "dark";
    if (theme.light && defaultColorScheme === "light") return "light";
    if (!theme.dark) return "light";
    if (!theme.light) return "dark";
    return "light";
}
function useScale(theme) {
    let matchesFine = (0, _utils.useMediaQuery)("(any-pointer: fine)");
    if (matchesFine && theme.medium) return "medium";
    if (theme.large) return "large";
    return "medium";
}

},{"@react-spectrum/utils":"cMIJ6","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"aHIRK":[function(require,module,exports) {
module.exports = JSON.parse('{"name":"@react-spectrum/provider","version":"3.9.4","description":"Spectrum UI components in React","license":"Apache-2.0","main":"dist/main.js","module":"dist/module.js","exports":{"types":"./dist/types.d.ts","import":"./dist/import.mjs","require":"./dist/main.js"},"types":"dist/types.d.ts","source":"src/index.ts","files":["dist","src"],"sideEffects":["*.css"],"targets":{"main":{"includeNodeModules":["@adobe/spectrum-css-temp"]},"module":{"includeNodeModules":["@adobe/spectrum-css-temp"]}},"repository":{"type":"git","url":"https://github.com/adobe/react-spectrum"},"dependencies":{"@react-aria/i18n":"^3.10.1","@react-aria/overlays":"^3.21.0","@react-aria/utils":"^3.23.1","@react-spectrum/utils":"^3.11.4","@react-types/provider":"^3.7.1","@react-types/shared":"^3.22.0","@swc/helpers":"^0.5.0","clsx":"^2.0.0"},"devDependencies":{"@adobe/spectrum-css-temp":"3.0.0-alpha.1"},"peerDependencies":{"react":"^16.8.0 || ^17.0.0-rc.1 || ^18.0.0","react-dom":"^16.8.0 || ^17.0.0-rc.1 || ^18.0.0"},"publishConfig":{"access":"public"}}');

},{}],"3x7cD":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ActionButton", ()=>_ActionButton);
var _utils = require("@react-spectrum/utils");
var _cornerTriangle = require("@spectrum-icons/ui/CornerTriangle");
var _cornerTriangleDefault = parcelHelpers.interopDefault(_cornerTriangle);
var _focus = require("@react-aria/focus");
var _utils1 = require("@react-aria/utils");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _varsCss = require("@adobe/spectrum-css-temp/components/button/vars.css");
var _varsCssDefault = parcelHelpers.interopDefault(_varsCss);
var _text = require("@react-spectrum/text");
var _button = require("@react-aria/button");
var _interactions = require("@react-aria/interactions");
var _provider = require("@react-spectrum/provider");
function ActionButton(props, ref) {
    props = (0, _provider.useProviderProps)(props);
    props = (0, _utils.useSlotProps)(props, "actionButton");
    let { isQuiet, isDisabled, staticColor, children, autoFocus, // @ts-ignore (private)
    holdAffordance, ...otherProps } = props;
    let domRef = (0, _utils.useFocusableRef)(ref);
    let { buttonProps, isPressed } = (0, _button.useButton)(props, domRef);
    let { hoverProps, isHovered } = (0, _interactions.useHover)({
        isDisabled
    });
    let { styleProps } = (0, _utils.useStyleProps)(otherProps);
    let isTextOnly = (0, _reactDefault.default).Children.toArray(props.children).every((c)=>!/*#__PURE__*/ (0, _reactDefault.default).isValidElement(c));
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _focus.FocusRing), {
        focusRingClass: (0, _utils.classNames)((0, _varsCssDefault.default), "focus-ring"),
        autoFocus: autoFocus
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("button", {
        ...styleProps,
        ...(0, _utils1.mergeProps)(buttonProps, hoverProps),
        ref: domRef,
        className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-ActionButton", {
            "spectrum-ActionButton--quiet": isQuiet,
            "spectrum-ActionButton--staticColor": !!staticColor,
            "spectrum-ActionButton--staticWhite": staticColor === "white",
            "spectrum-ActionButton--staticBlack": staticColor === "black",
            "is-active": isPressed,
            "is-disabled": isDisabled,
            "is-hovered": isHovered
        }, styleProps.className)
    }, holdAffordance && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _cornerTriangleDefault.default), {
        UNSAFE_className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-ActionButton-hold")
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.SlotProvider), {
        slots: {
            icon: {
                size: "S",
                UNSAFE_className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Icon")
            },
            text: {
                UNSAFE_className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-ActionButton-label")
            }
        }
    }, typeof children === "string" || isTextOnly ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, children) : children)));
}
/**
 * ActionButtons allow users to perform an action.
 * They’re used for similar, task-based options within a workflow, and are ideal for interfaces where buttons aren’t meant to draw a lot of attention.
 */ let _ActionButton = /*#__PURE__*/ (0, _reactDefault.default).forwardRef(ActionButton);

},{"@react-spectrum/utils":"cMIJ6","@spectrum-icons/ui/CornerTriangle":"9Tx8t","@react-aria/focus":"42mbF","@react-aria/utils":"9cLk5","react":"9yzVZ","@adobe/spectrum-css-temp/components/button/vars.css":"cTEhK","@react-spectrum/text":"etCGI","@react-aria/button":"fsdLZ","@react-aria/interactions":"ky3G8","@react-spectrum/provider":"5bCdp","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"9Tx8t":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("cce83ce3a484ec70");
exports.__esModule = true;
exports.default = CornerTriangle;
var _CornerTriangle = require("a2aed54821608812");
var _icon = require("b0f3de8dc465c311");
var _react = _interopRequireDefault(require("50c794147575b47a"));
function CornerTriangle(props) {
    return /*#__PURE__*/ _react.default.createElement(_icon.UIIcon, props, /*#__PURE__*/ _react.default.createElement(_CornerTriangle.CornerTriangle, null));
}

},{"cce83ce3a484ec70":"iHubQ","a2aed54821608812":"hgVAj","b0f3de8dc465c311":"k7wem","50c794147575b47a":"9yzVZ"}],"iHubQ":[function(require,module,exports) {
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"hgVAj":[function(require,module,exports) {
/**
* @adobe/react-spectrum-ui (c) by Adobe
* 
* @adobe/react-spectrum-ui is licensed under a
* Creative Commons Attribution-NoDerivatives 4.0 International License.
* 
* You should have received a copy of the license along with this
* work. If not, see <http://creativecommons.org/licenses/by-nd/4.0/>.
**/ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CornerTriangle = CornerTriangle;
var _react = _interopRequireDefault(require("8b2d9b8a1bbbc349"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function CornerTriangle(_ref) {
    var _ref$scale = _ref.scale, scale = _ref$scale === void 0 ? "M" : _ref$scale, props = _objectWithoutProperties(_ref, [
        "scale"
    ]);
    return _react["default"].createElement("svg", _extends({}, props, props), scale === "L" && _react["default"].createElement("path", {
        d: "M5.74.01a.25.25 0 0 0-.177.073l-5.48 5.48a.25.25 0 0 0 .177.427h5.48a.25.25 0 0 0 .25-.25V.26a.25.25 0 0 0-.25-.25z"
    }), scale === "M" && _react["default"].createElement("path", {
        d: "M4.74.01a.25.25 0 0 0-.177.073l-4.48 4.48a.25.25 0 0 0 .177.427h4.48a.25.25 0 0 0 .25-.25V.26a.25.25 0 0 0-.25-.25z"
    }));
}
CornerTriangle.displayName = "CornerTriangle";

},{"8b2d9b8a1bbbc349":"9yzVZ"}],"k7wem":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /// <reference types="css-module-types" />
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Icon", ()=>(0, _icon.Icon));
parcelHelpers.export(exports, "UIIcon", ()=>(0, _uiicon.UIIcon));
parcelHelpers.export(exports, "Illustration", ()=>(0, _illustration.Illustration));
var _icon = require("./Icon");
var _uiicon = require("./UIIcon");
var _illustration = require("./Illustration");

},{"./Icon":"gUaGU","./UIIcon":"j5YUf","./Illustration":"3ECzI","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"gUaGU":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Spectrum icons are clear, minimal, and consistent across platforms. They follow the focused and rational principles of the design system in both metaphor and style.
 */ parcelHelpers.export(exports, "Icon", ()=>Icon);
var _utils = require("@react-spectrum/utils");
var _utils1 = require("@react-aria/utils");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _varsCss = require("@adobe/spectrum-css-temp/components/icon/vars.css");
var _varsCssDefault = parcelHelpers.interopDefault(_varsCss);
var _provider = require("@react-spectrum/provider");
function iconColorValue(value) {
    return `var(--spectrum-semantic-${value}-color-icon)`;
}
const iconStyleProps = {
    ...(0, _utils.baseStyleProps),
    color: [
        "color",
        iconColorValue
    ]
};
function Icon(props) {
    props = (0, _utils.useSlotProps)(props, "icon");
    let { children, size, "aria-label": ariaLabel, "aria-hidden": ariaHidden, ...otherProps } = props;
    let { styleProps } = (0, _utils.useStyleProps)(otherProps, iconStyleProps);
    let provider = (0, _provider.useProvider)();
    let scale = "M";
    if (provider !== null) scale = provider.scale === "large" ? "L" : "M";
    if (!ariaHidden) ariaHidden = undefined;
    // Use user specified size, falling back to provider scale if size is undef
    let iconSize = size ? size : scale;
    return /*#__PURE__*/ (0, _reactDefault.default).cloneElement(children, {
        ...(0, _utils1.filterDOMProps)(otherProps),
        ...styleProps,
        focusable: "false",
        "aria-label": ariaLabel,
        "aria-hidden": ariaLabel ? ariaHidden || undefined : true,
        role: "img",
        className: (0, _utils.classNames)((0, _varsCssDefault.default), children.props.className, "spectrum-Icon", `spectrum-Icon--size${iconSize}`, styleProps.className)
    });
}

},{"@react-spectrum/utils":"cMIJ6","@react-aria/utils":"9cLk5","react":"9yzVZ","@adobe/spectrum-css-temp/components/icon/vars.css":"fZe3K","@react-spectrum/provider":"5bCdp","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"fZe3K":[function(require,module,exports) {
module.exports["spectrum--large"] = `yxBNXG_spectrum--large`;
module.exports["spectrum--medium"] = `yxBNXG_spectrum--medium`;
module.exports["spectrum-Icon"] = `yxBNXG_spectrum-Icon`;
module.exports["spectrum-Icon--sizeL"] = `yxBNXG_spectrum-Icon--sizeL`;
module.exports["spectrum-Icon--sizeM"] = `yxBNXG_spectrum-Icon--sizeM`;
module.exports["spectrum-Icon--sizeS"] = `yxBNXG_spectrum-Icon--sizeS`;
module.exports["spectrum-Icon--sizeXL"] = `yxBNXG_spectrum-Icon--sizeXL`;
module.exports["spectrum-Icon--sizeXS"] = `yxBNXG_spectrum-Icon--sizeXS`;
module.exports["spectrum-Icon--sizeXXL"] = `yxBNXG_spectrum-Icon--sizeXXL`;
module.exports["spectrum-Icon--sizeXXS"] = `yxBNXG_spectrum-Icon--sizeXXS`;
module.exports["spectrum-UIIcon"] = `yxBNXG_spectrum-UIIcon`;
module.exports["spectrum-UIIcon--large"] = `yxBNXG_spectrum-UIIcon--large`;
module.exports["spectrum-UIIcon--medium"] = `yxBNXG_spectrum-UIIcon--medium`;
module.exports["spectrum-UIIcon-AlertMedium"] = `yxBNXG_spectrum-UIIcon-AlertMedium`;
module.exports["spectrum-UIIcon-AlertSmall"] = `yxBNXG_spectrum-UIIcon-AlertSmall`;
module.exports["spectrum-UIIcon-ArrowDownSmall"] = `yxBNXG_spectrum-UIIcon-ArrowDownSmall`;
module.exports["spectrum-UIIcon-ArrowLeftMedium"] = `yxBNXG_spectrum-UIIcon-ArrowLeftMedium`;
module.exports["spectrum-UIIcon-Asterisk"] = `yxBNXG_spectrum-UIIcon-Asterisk`;
module.exports["spectrum-UIIcon-CheckmarkMedium"] = `yxBNXG_spectrum-UIIcon-CheckmarkMedium`;
module.exports["spectrum-UIIcon-CheckmarkSmall"] = `yxBNXG_spectrum-UIIcon-CheckmarkSmall`;
module.exports["spectrum-UIIcon-ChevronDownMedium"] = `yxBNXG_spectrum-UIIcon-ChevronDownMedium`;
module.exports["spectrum-UIIcon-ChevronDownSmall"] = `yxBNXG_spectrum-UIIcon-ChevronDownSmall`;
module.exports["spectrum-UIIcon-ChevronLeftLarge"] = `yxBNXG_spectrum-UIIcon-ChevronLeftLarge`;
module.exports["spectrum-UIIcon-ChevronLeftMedium"] = `yxBNXG_spectrum-UIIcon-ChevronLeftMedium`;
module.exports["spectrum-UIIcon-ChevronRightLarge"] = `yxBNXG_spectrum-UIIcon-ChevronRightLarge`;
module.exports["spectrum-UIIcon-ChevronRightMedium"] = `yxBNXG_spectrum-UIIcon-ChevronRightMedium`;
module.exports["spectrum-UIIcon-ChevronRightSmall"] = `yxBNXG_spectrum-UIIcon-ChevronRightSmall`;
module.exports["spectrum-UIIcon-ChevronUpSmall"] = `yxBNXG_spectrum-UIIcon-ChevronUpSmall`;
module.exports["spectrum-UIIcon-CornerTriangle"] = `yxBNXG_spectrum-UIIcon-CornerTriangle`;
module.exports["spectrum-UIIcon-CrossLarge"] = `yxBNXG_spectrum-UIIcon-CrossLarge`;
module.exports["spectrum-UIIcon-CrossMedium"] = `yxBNXG_spectrum-UIIcon-CrossMedium`;
module.exports["spectrum-UIIcon-CrossSmall"] = `yxBNXG_spectrum-UIIcon-CrossSmall`;
module.exports["spectrum-UIIcon-DashSmall"] = `yxBNXG_spectrum-UIIcon-DashSmall`;
module.exports["spectrum-UIIcon-DoubleGripper"] = `yxBNXG_spectrum-UIIcon-DoubleGripper`;
module.exports["spectrum-UIIcon-FolderBreadcrumb"] = `yxBNXG_spectrum-UIIcon-FolderBreadcrumb`;
module.exports["spectrum-UIIcon-HelpMedium"] = `yxBNXG_spectrum-UIIcon-HelpMedium`;
module.exports["spectrum-UIIcon-HelpSmall"] = `yxBNXG_spectrum-UIIcon-HelpSmall`;
module.exports["spectrum-UIIcon-InfoMedium"] = `yxBNXG_spectrum-UIIcon-InfoMedium`;
module.exports["spectrum-UIIcon-InfoSmall"] = `yxBNXG_spectrum-UIIcon-InfoSmall`;
module.exports["spectrum-UIIcon-ListGripper"] = `yxBNXG_spectrum-UIIcon-ListGripper`;
module.exports["spectrum-UIIcon-Magnifier"] = `yxBNXG_spectrum-UIIcon-Magnifier`;
module.exports["spectrum-UIIcon-SkipLeft"] = `yxBNXG_spectrum-UIIcon-SkipLeft`;
module.exports["spectrum-UIIcon-SkipRight"] = `yxBNXG_spectrum-UIIcon-SkipRight`;
module.exports["spectrum-UIIcon-Star"] = `yxBNXG_spectrum-UIIcon-Star`;
module.exports["spectrum-UIIcon-StarOutline"] = `yxBNXG_spectrum-UIIcon-StarOutline`;
module.exports["spectrum-UIIcon-SuccessMedium"] = `yxBNXG_spectrum-UIIcon-SuccessMedium`;
module.exports["spectrum-UIIcon-SuccessSmall"] = `yxBNXG_spectrum-UIIcon-SuccessSmall`;
module.exports["spectrum-UIIcon-TripleGripper"] = `yxBNXG_spectrum-UIIcon-TripleGripper`;

},{}],"j5YUf":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "UIIcon", ()=>UIIcon);
var _utils = require("@react-spectrum/utils");
var _utils1 = require("@react-aria/utils");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _varsCss = require("@adobe/spectrum-css-temp/components/icon/vars.css");
var _varsCssDefault = parcelHelpers.interopDefault(_varsCss);
var _provider = require("@react-spectrum/provider");
function UIIcon(props) {
    props = (0, _utils.useSlotProps)(props, "icon");
    let { children, "aria-label": ariaLabel, "aria-hidden": ariaHidden, ...otherProps } = props;
    let { styleProps } = (0, _utils.useStyleProps)(otherProps);
    let provider = (0, _provider.useProvider)();
    let scale = "M";
    if (provider !== null) scale = provider.scale === "large" ? "L" : "M";
    if (!ariaHidden) ariaHidden = undefined;
    return /*#__PURE__*/ (0, _reactDefault.default).cloneElement(children, {
        ...(0, _utils1.filterDOMProps)(otherProps),
        ...styleProps,
        scale,
        focusable: "false",
        "aria-label": ariaLabel,
        "aria-hidden": ariaLabel ? ariaHidden || undefined : true,
        role: "img",
        className: (0, _utils.classNames)((0, _varsCssDefault.default), children.props.className, "spectrum-Icon", {
            [`spectrum-UIIcon-${children.type["displayName"]}`]: children.type["displayName"]
        }, styleProps.className)
    });
}

},{"@react-spectrum/utils":"cMIJ6","@react-aria/utils":"9cLk5","react":"9yzVZ","@adobe/spectrum-css-temp/components/icon/vars.css":"fZe3K","@react-spectrum/provider":"5bCdp","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"3ECzI":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Wrapper component for illustrations. Use this to wrap your svg element for a custom illustration.
 */ parcelHelpers.export(exports, "Illustration", ()=>Illustration);
var _utils = require("@react-aria/utils");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _utils1 = require("@react-spectrum/utils");
function Illustration(props) {
    props = (0, _utils1.useSlotProps)(props, "illustration");
    let { children, "aria-label": ariaLabel, "aria-labelledby": ariaLabelledby, "aria-hidden": ariaHidden, ...otherProps } = props;
    let { styleProps } = (0, _utils1.useStyleProps)(otherProps);
    let hasLabel = ariaLabel || ariaLabelledby;
    if (!ariaHidden) ariaHidden = undefined;
    return /*#__PURE__*/ (0, _reactDefault.default).cloneElement(children, {
        ...(0, _utils.filterDOMProps)(otherProps),
        ...styleProps,
        focusable: "false",
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledby,
        "aria-hidden": ariaHidden,
        role: hasLabel ? "img" : undefined
    });
}

},{"@react-aria/utils":"9cLk5","react":"9yzVZ","@react-spectrum/utils":"cMIJ6","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"Gn8H0":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FieldButton", ()=>_FieldButton);
var _utils = require("@react-spectrum/utils");
var _focus = require("@react-aria/focus");
var _utils1 = require("@react-aria/utils");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _varsCss = require("@adobe/spectrum-css-temp/components/button/vars.css");
var _varsCssDefault = parcelHelpers.interopDefault(_varsCss);
var _button = require("@react-aria/button");
var _interactions = require("@react-aria/interactions");
// @private
function FieldButton(props, ref) {
    props = (0, _utils.useSlotProps)(props, "button");
    let { isQuiet, isDisabled, validationState, isInvalid, children, autoFocus, isActive, focusRingClass, ...otherProps } = props;
    let domRef = (0, _utils.useFocusableRef)(ref);
    let { buttonProps, isPressed } = (0, _button.useButton)(props, domRef);
    let { hoverProps, isHovered } = (0, _interactions.useHover)({
        isDisabled
    });
    let { styleProps } = (0, _utils.useStyleProps)(otherProps);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _focus.FocusRing), {
        focusRingClass: (0, _utils.classNames)((0, _varsCssDefault.default), "focus-ring", focusRingClass),
        autoFocus: autoFocus
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("button", {
        ...(0, _utils1.mergeProps)(buttonProps, hoverProps),
        ref: domRef,
        className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-FieldButton", {
            "spectrum-FieldButton--quiet": isQuiet,
            "is-active": isActive || isPressed,
            "is-disabled": isDisabled,
            "spectrum-FieldButton--invalid": isInvalid || validationState === "invalid",
            "is-hovered": isHovered
        }, styleProps.className)
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.SlotProvider), {
        slots: {
            icon: {
                size: "S",
                UNSAFE_className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Icon")
            }
        }
    }, children)));
}
let _FieldButton = /*#__PURE__*/ (0, _reactDefault.default).forwardRef(FieldButton);

},{"@react-spectrum/utils":"cMIJ6","@react-aria/focus":"42mbF","@react-aria/utils":"9cLk5","react":"9yzVZ","@adobe/spectrum-css-temp/components/button/vars.css":"cTEhK","@react-aria/button":"fsdLZ","@react-aria/interactions":"ky3G8","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"3jxvO":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LogicButton", ()=>_LogicButton);
var _utils = require("@react-spectrum/utils");
var _focus = require("@react-aria/focus");
var _utils1 = require("@react-aria/utils");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _varsCss = require("@adobe/spectrum-css-temp/components/button/vars.css");
var _varsCssDefault = parcelHelpers.interopDefault(_varsCss);
var _button = require("@react-aria/button");
var _interactions = require("@react-aria/interactions");
var _provider = require("@react-spectrum/provider");
function LogicButton(props, ref) {
    props = (0, _provider.useProviderProps)(props);
    let { variant, children, isDisabled, autoFocus, ...otherProps } = props;
    let domRef = (0, _utils.useFocusableRef)(ref);
    let { buttonProps, isPressed } = (0, _button.useButton)(props, domRef);
    let { hoverProps, isHovered } = (0, _interactions.useHover)({
        isDisabled
    });
    let { styleProps } = (0, _utils.useStyleProps)(otherProps);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _focus.FocusRing), {
        focusRingClass: (0, _utils.classNames)((0, _varsCssDefault.default), "focus-ring"),
        autoFocus: autoFocus
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("button", {
        ...styleProps,
        ...(0, _utils1.mergeProps)(buttonProps, hoverProps),
        ref: domRef,
        className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-LogicButton", {
            [`spectrum-LogicButton--${variant}`]: variant,
            "is-disabled": isDisabled,
            "is-active": isPressed,
            "is-hovered": isHovered
        }, styleProps.className)
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Button-label")
    }, children)));
}
/**
 * A LogicButton displays an operator within a boolean logic sequence.
 */ let _LogicButton = /*#__PURE__*/ (0, _reactDefault.default).forwardRef(LogicButton);

},{"@react-spectrum/utils":"cMIJ6","@react-aria/focus":"42mbF","@react-aria/utils":"9cLk5","react":"9yzVZ","@adobe/spectrum-css-temp/components/button/vars.css":"cTEhK","@react-aria/button":"fsdLZ","@react-aria/interactions":"ky3G8","@react-spectrum/provider":"5bCdp","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"2Ltej":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ClearButton", ()=>_ClearButton);
var _utils = require("@react-spectrum/utils");
var _crossSmall = require("@spectrum-icons/ui/CrossSmall");
var _crossSmallDefault = parcelHelpers.interopDefault(_crossSmall);
var _focus = require("@react-aria/focus");
var _utils1 = require("@react-aria/utils");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _varsCss = require("@adobe/spectrum-css-temp/components/button/vars.css");
var _varsCssDefault = parcelHelpers.interopDefault(_varsCss);
var _button = require("@react-aria/button");
var _interactions = require("@react-aria/interactions");
function ClearButton(props, ref) {
    let { children = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _crossSmallDefault.default), {
        UNSAFE_className: (0, _varsCssDefault.default)["spectrum-Icon"]
    }), focusClassName, variant, autoFocus, isDisabled, preventFocus, elementType = preventFocus ? "div" : "button", ...otherProps } = props;
    let domRef = (0, _utils.useFocusableRef)(ref);
    let { buttonProps, isPressed } = (0, _button.useButton)({
        ...props,
        elementType
    }, domRef);
    let { hoverProps, isHovered } = (0, _interactions.useHover)({
        isDisabled
    });
    let { styleProps } = (0, _utils.useStyleProps)(otherProps);
    // For cases like the clear button in a search field, remove the tabIndex so
    // iOS 14 with VoiceOver doesn't focus the button and hide the keyboard when
    // moving the cursor over the clear button.
    if (preventFocus) delete buttonProps.tabIndex;
    let ElementType = elementType;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _focus.FocusRing), {
        focusRingClass: (0, _utils.classNames)((0, _varsCssDefault.default), "focus-ring", focusClassName),
        autoFocus: autoFocus
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(ElementType, {
        ...styleProps,
        ...(0, _utils1.mergeProps)(buttonProps, hoverProps),
        ref: domRef,
        className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-ClearButton", {
            [`spectrum-ClearButton--${variant}`]: variant,
            "is-disabled": isDisabled,
            "is-active": isPressed,
            "is-hovered": isHovered
        }, styleProps.className)
    }, children));
}
let _ClearButton = /*#__PURE__*/ (0, _reactDefault.default).forwardRef(ClearButton);

},{"@react-spectrum/utils":"cMIJ6","@spectrum-icons/ui/CrossSmall":"dyozR","@react-aria/focus":"42mbF","@react-aria/utils":"9cLk5","react":"9yzVZ","@adobe/spectrum-css-temp/components/button/vars.css":"cTEhK","@react-aria/button":"fsdLZ","@react-aria/interactions":"ky3G8","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"dyozR":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("6a8efd9c7f0f92f6");
exports.__esModule = true;
exports.default = CrossSmall;
var _CrossSmall = require("5ad6c21ad629f717");
var _icon = require("ea2f47af212e5d7e");
var _react = _interopRequireDefault(require("18647f52e30ecd25"));
function CrossSmall(props) {
    return /*#__PURE__*/ _react.default.createElement(_icon.UIIcon, props, /*#__PURE__*/ _react.default.createElement(_CrossSmall.CrossSmall, null));
}

},{"6a8efd9c7f0f92f6":"iHubQ","5ad6c21ad629f717":"gi6RX","ea2f47af212e5d7e":"k7wem","18647f52e30ecd25":"9yzVZ"}],"gi6RX":[function(require,module,exports) {
/**
* @adobe/react-spectrum-ui (c) by Adobe
* 
* @adobe/react-spectrum-ui is licensed under a
* Creative Commons Attribution-NoDerivatives 4.0 International License.
* 
* You should have received a copy of the license along with this
* work. If not, see <http://creativecommons.org/licenses/by-nd/4.0/>.
**/ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CrossSmall = CrossSmall;
var _react = _interopRequireDefault(require("a3592f018cc1ad91"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function CrossSmall(_ref) {
    var _ref$scale = _ref.scale, scale = _ref$scale === void 0 ? "M" : _ref$scale, props = _objectWithoutProperties(_ref, [
        "scale"
    ]);
    return _react["default"].createElement("svg", _extends({}, props, props), scale === "L" && _react["default"].createElement("path", {
        d: "M9.317 8.433L5.884 5l3.433-3.433a.625.625 0 1 0-.884-.884L5 4.116 1.567.683a.625.625 0 1 0-.884.884C.83 1.713 2.77 3.657 4.116 5L.683 8.433a.625.625 0 1 0 .884.884L5 5.884l3.433 3.433a.625.625 0 0 0 .884-.884z"
    }), scale === "M" && _react["default"].createElement("path", {
        d: "M7.317 6.433L4.884 4l2.433-2.433a.625.625 0 1 0-.884-.884L4 3.116 1.567.683a.625.625 0 1 0-.884.884L3.116 4 .683 6.433a.625.625 0 1 0 .884.884L4 4.884l2.433 2.433a.625.625 0 0 0 .884-.884z"
    }));
}
CrossSmall.displayName = "CrossSmall";

},{"a3592f018cc1ad91":"9yzVZ"}],"cqKMi":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ToggleButton", ()=>_ToggleButton);
var _utils = require("@react-spectrum/utils");
var _focus = require("@react-aria/focus");
var _utils1 = require("@react-aria/utils");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _varsCss = require("@adobe/spectrum-css-temp/components/button/vars.css");
var _varsCssDefault = parcelHelpers.interopDefault(_varsCss);
var _text = require("@react-spectrum/text");
var _interactions = require("@react-aria/interactions");
var _provider = require("@react-spectrum/provider");
var _button = require("@react-aria/button");
var _toggle = require("@react-stately/toggle");
function ToggleButton(props, ref) {
    props = (0, _provider.useProviderProps)(props);
    let { isQuiet, isDisabled, isEmphasized, staticColor, children, autoFocus, ...otherProps } = props;
    let domRef = (0, _utils.useFocusableRef)(ref);
    let state = (0, _toggle.useToggleState)(props);
    let { buttonProps, isPressed } = (0, _button.useToggleButton)(props, state, domRef);
    let { hoverProps, isHovered } = (0, _interactions.useHover)({
        isDisabled
    });
    let { styleProps } = (0, _utils.useStyleProps)(otherProps);
    let isTextOnly = (0, _reactDefault.default).Children.toArray(props.children).every((c)=>!/*#__PURE__*/ (0, _reactDefault.default).isValidElement(c));
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _focus.FocusRing), {
        focusRingClass: (0, _utils.classNames)((0, _varsCssDefault.default), "focus-ring"),
        autoFocus: autoFocus
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("button", {
        ...styleProps,
        ...(0, _utils1.mergeProps)(buttonProps, hoverProps),
        ref: domRef,
        className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-ActionButton", {
            "spectrum-ActionButton--quiet": isQuiet,
            "spectrum-ActionButton--emphasized": isEmphasized,
            "spectrum-ActionButton--staticColor": !!staticColor,
            "spectrum-ActionButton--staticWhite": staticColor === "white",
            "spectrum-ActionButton--staticBlack": staticColor === "black",
            "is-active": isPressed,
            "is-disabled": isDisabled,
            "is-hovered": isHovered,
            "is-selected": state.isSelected
        }, styleProps.className)
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.SlotProvider), {
        slots: {
            icon: {
                size: "S",
                UNSAFE_className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Icon")
            },
            text: {
                UNSAFE_className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-ActionButton-label")
            }
        }
    }, typeof children === "string" || isTextOnly ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, children) : children)));
}
/**
 * ToggleButtons allow users to toggle a selection on or off, for example
 * switching between two states or modes.
 */ let _ToggleButton = /*#__PURE__*/ (0, _reactDefault.default).forwardRef(ToggleButton);

},{"@react-spectrum/utils":"cMIJ6","@react-aria/focus":"42mbF","@react-aria/utils":"9cLk5","react":"9yzVZ","@adobe/spectrum-css-temp/components/button/vars.css":"cTEhK","@react-spectrum/text":"etCGI","@react-aria/interactions":"ky3G8","@react-spectrum/provider":"5bCdp","@react-aria/button":"fsdLZ","@react-stately/toggle":"5qaKI","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"aEObA":[function(require,module,exports) {
/*
 * Copyright 2021 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ScrollTesting", ()=>ScrollTesting);
parcelHelpers.export(exports, "Disabled", ()=>Disabled);
parcelHelpers.export(exports, "FocusWrapping", ()=>FocusWrapping);
var _example = require("./example");
var _collections = require("@react-stately/collections");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
exports.default = {
    title: "useComboBox"
};
let lotsOfItems = [];
for(let i = 0; i < 50; i++)lotsOfItems.push({
    name: "Item " + i
});
const Template = (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _example.ComboBox), {
        ...args,
        label: "Example",
        defaultItems: lotsOfItems
    }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _collections.Item), {
            key: item.name
        }, item.name));
const ScrollTesting = {
    render: Template,
    args: {}
};
const Disabled = {
    render: Template,
    args: {
        isDisabled: true
    }
};
const FocusWrapping = {
    render: Template,
    args: {
        shouldFocusWrap: true
    }
};

},{"./example":"9smhy","@react-stately/collections":"loANi","react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"9smhy":[function(require,module,exports) {
/*
 * Copyright 2021 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ComboBox", ()=>ComboBox);
var _overlays = require("@react-aria/overlays");
var _focus = require("@react-aria/focus");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _button = require("@react-aria/button");
var _combobox = require("@react-aria/combobox");
var _combobox1 = require("@react-stately/combobox");
var _i18N = require("@react-aria/i18n");
var _listbox = require("@react-aria/listbox");
function ComboBox(props) {
    // Setup filter function and state.
    let { contains } = (0, _i18N.useFilter)({
        sensitivity: "base"
    });
    let state = (0, _combobox1.useComboBoxState)({
        ...props,
        defaultFilter: contains
    });
    // Setup refs and get props for child elements.
    let buttonRef = (0, _reactDefault.default).useRef(null);
    let inputRef = (0, _reactDefault.default).useRef(null);
    let listBoxRef = (0, _reactDefault.default).useRef(null);
    let popoverRef = (0, _reactDefault.default).useRef(null);
    let { buttonProps: triggerProps, inputProps, listBoxProps, labelProps } = (0, _combobox.useComboBox)({
        ...props,
        inputRef,
        buttonRef,
        listBoxRef,
        popoverRef
    }, state);
    // Call useButton to get props for the button element. Alternatively, you can
    // pass the triggerProps to a separate Button component using useButton
    // that you might already have in your component library.
    let { buttonProps } = (0, _button.useButton)(triggerProps, buttonRef);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        style: {
            display: "inline-flex",
            flexDirection: "column"
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("label", labelProps, props.label), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        style: {
            position: "relative",
            display: "inline-block"
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("input", {
        ...inputProps,
        ref: inputRef,
        style: {
            height: 24,
            boxSizing: "border-box",
            marginRight: 0,
            fontSize: 16
        }
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("button", {
        ...buttonProps,
        ref: buttonRef,
        style: {
            height: 24,
            marginLeft: 0
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        "aria-hidden": "true",
        style: {
            padding: "0 2px"
        }
    }, "\u25BC")), state.isOpen && /*#__PURE__*/ (0, _reactDefault.default).createElement(Popover, {
        popoverRef: popoverRef,
        isOpen: state.isOpen,
        onClose: state.close
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(ListBox, {
        ...listBoxProps,
        listBoxRef: listBoxRef,
        state: state
    }))));
}
function Popover(props) {
    let ref = (0, _reactDefault.default).useRef();
    let { popoverRef = ref, isOpen, onClose, children } = props;
    // Handle events that should cause the popup to close,
    // e.g. blur, clicking outside, or pressing the escape key.
    let { overlayProps } = (0, _overlays.useOverlay)({
        isOpen,
        onClose,
        shouldCloseOnBlur: true,
        isDismissable: true
    }, popoverRef);
    // Add a hidden <DismissButton> component at the end of the popover
    // to allow screen reader users to dismiss the popup easily.
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _focus.FocusScope), {
        restoreFocus: true
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...overlayProps,
        ref: popoverRef,
        style: {
            position: "absolute",
            width: "100%",
            border: "1px solid gray",
            background: "lightgray",
            marginTop: 4
        }
    }, children, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _overlays.DismissButton), {
        onDismiss: onClose
    })));
}
function ListBox(props) {
    let ref = (0, _reactDefault.default).useRef();
    let { listBoxRef = ref, state } = props;
    let { listBoxProps } = (0, _listbox.useListBox)(props, state, listBoxRef);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("ul", {
        ...listBoxProps,
        ref: listBoxRef,
        style: {
            margin: 0,
            padding: 0,
            listStyle: "none",
            maxHeight: "150px",
            overflow: "auto"
        }
    }, [
        ...state.collection
    ].map((item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(Option, {
            key: item.key,
            item: item,
            state: state
        })));
}
function Option({ item, state }) {
    let ref = (0, _reactDefault.default).useRef();
    let { optionProps, isSelected, isFocused, isDisabled } = (0, _listbox.useOption)({
        key: item.key
    }, state, ref);
    let backgroundColor;
    let color = "black";
    if (isSelected) {
        backgroundColor = "blueviolet";
        color = "white";
    } else if (isFocused) backgroundColor = "gray";
    else if (isDisabled) {
        backgroundColor = "transparent";
        color = "gray";
    }
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("li", {
        ...optionProps,
        ref: ref,
        style: {
            background: backgroundColor,
            color: color,
            padding: "2px 5px",
            outline: "none",
            cursor: "pointer"
        }
    }, item.rendered);
}

},{"@react-aria/overlays":"5fTCg","@react-aria/focus":"42mbF","react":"9yzVZ","@react-aria/button":"fsdLZ","@react-aria/combobox":"4enyJ","@react-stately/combobox":"j3BhU","@react-aria/i18n":"411rg","@react-aria/listbox":"bHZSJ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"6aNDQ":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Default", ()=>Default);
parcelHelpers.export(exports, "NestedDropRegions", ()=>NestedDropRegions);
parcelHelpers.export(exports, "DraggableListbox", ()=>DraggableListbox);
parcelHelpers.export(exports, "DraggableListboxOnAction", ()=>DraggableListboxOnAction);
parcelHelpers.export(exports, "DroppableListbox", ()=>DroppableListbox);
parcelHelpers.export(exports, "InDialog", ()=>InDialog);
parcelHelpers.export(exports, "DraggableGridDroppableListbox", ()=>DraggableGridDroppableListbox);
parcelHelpers.export(exports, "DroppableGrid", ()=>DroppableGrid);
parcelHelpers.export(exports, "DroppableGridWithManyItems", ()=>DroppableGridWithManyItems);
parcelHelpers.export(exports, "VirtualizedListbox", ()=>VirtualizedListbox);
parcelHelpers.export(exports, "MultipleCollectionDropTargets", ()=>MultipleCollectionDropTargets);
parcelHelpers.export(exports, "Reorderable", ()=>Reorderable);
parcelHelpers.export(exports, "Draggable", ()=>Draggable);
parcelHelpers.export(exports, "Droppable", ()=>Droppable);
var _addonActions = require("@storybook/addon-actions");
var _button = require("@react-spectrum/button");
var _actiongroup = require("@react-spectrum/actiongroup");
var _utils = require("@react-aria/utils");
var _utils1 = require("@react-spectrum/utils");
var _view = require("@react-spectrum/view");
var _copy = require("@spectrum-icons/workflow/Copy");
var _copyDefault = parcelHelpers.interopDefault(_copy);
var _cut = require("@spectrum-icons/workflow/Cut");
var _cutDefault = parcelHelpers.interopDefault(_cut);
var _dialog = require("@react-spectrum/dialog");
var _dndCss = require("./dnd.css");
var _dndCssDefault = parcelHelpers.interopDefault(_dndCss);
var _draggableListBox = require("./DraggableListBox");
var _dragPreview = require("../src/DragPreview");
var _droppableGrid = require("./DroppableGrid");
var _droppableListBox = require("./DroppableListBox");
var _varsCss = require("@adobe/spectrum-css-temp/components/dnd/vars.css");
var _varsCssDefault = parcelHelpers.interopDefault(_varsCss);
var _layout = require("@react-spectrum/layout");
var _focus = require("@react-aria/focus");
var _folder = require("@spectrum-icons/workflow/Folder");
var _folderDefault = parcelHelpers.interopDefault(_folder);
var _grid = require("@react-stately/grid");
var _text = require("@react-spectrum/text");
var _collections = require("@react-stately/collections");
var _paste = require("@spectrum-icons/workflow/Paste");
var _pasteDefault = parcelHelpers.interopDefault(_paste);
var _interactions = require("@react-aria/interactions");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reorderable = require("./Reorderable");
var _showMenu = require("@spectrum-icons/workflow/ShowMenu");
var _showMenuDefault = parcelHelpers.interopDefault(_showMenu);
var _button1 = require("@react-aria/button");
var _ = require("..");
var _dnd = require("@react-stately/dnd");
var _grid1 = require("@react-aria/grid");
var _data = require("@react-stately/data");
var _list = require("@react-stately/list");
var _virtualizedListBox = require("./VirtualizedListBox");
let manyItems = [];
for(let i = 0; i < 20; i++)manyItems.push({
    id: "" + i,
    type: "item",
    text: "Item " + i
});
exports.default = {
    title: "Drag and Drop",
    excludeStories: [
        "Droppable"
    ]
};
const Default = ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
        direction: "column",
        gap: "size-200",
        alignItems: "center"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Draggable, null), /*#__PURE__*/ (0, _reactDefault.default).createElement(Droppable, null), /*#__PURE__*/ (0, _reactDefault.default).createElement("input", {
        "aria-label": "test input 1"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement(Droppable, {
        type: "text/html"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("input", {
        "aria-label": "test input 2"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement(Droppable, null));
const NestedDropRegions = {
    render: ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
            direction: "column",
            gap: "size-200",
            alignItems: "center"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Draggable, null), /*#__PURE__*/ (0, _reactDefault.default).createElement(Droppable, {
            actionId: "Parent"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Droppable, {
            actionId: "Child"
        }))),
    name: "nested drop regions",
    parameters: {
        a11y: {
            config: {
                rules: [
                    {
                        id: "nested-interactive",
                        enabled: false
                    }
                ]
            }
        }
    }
};
const DraggableListbox = {
    render: ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
            direction: "column",
            gap: "size-200",
            alignItems: "center"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _draggableListBox.DraggableListBox), {
            selectionMode: "multiple",
            selectionBehavior: "replace"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _collections.Item), null, "Foo"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _collections.Item), null, "Bar"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _collections.Item), null, "Baz")), /*#__PURE__*/ (0, _reactDefault.default).createElement(Droppable, null)),
    name: "Draggable listbox"
};
const DraggableListboxOnAction = {
    render: ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
            direction: "column",
            gap: "size-200",
            alignItems: "center"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _draggableListBox.DraggableListBox), {
            selectionMode: "multiple",
            selectionBehavior: "replace",
            onAction: (0, _addonActions.action)("onAction")
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _collections.Item), null, "Foo"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _collections.Item), {
            key: "bar"
        }, "Bar"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _collections.Item), null, "Baz")), /*#__PURE__*/ (0, _reactDefault.default).createElement(Droppable, null)),
    name: "Draggable listbox, onAction"
};
const DroppableListbox = {
    render: ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
            direction: "row",
            gap: "size-200",
            alignItems: "center"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Draggable, null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _droppableListBox.DroppableListBox), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _collections.Item), {
            key: "1",
            textValue: "One"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _folderDefault.default), {
            size: "S"
        }), /*#__PURE__*/ (0, _reactDefault.default).createElement("span", null, "One")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _collections.Item), {
            key: "2"
        }, "Two"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _collections.Item), {
            key: "3",
            textValue: "Three"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _folderDefault.default), {
            size: "S"
        }), /*#__PURE__*/ (0, _reactDefault.default).createElement("span", null, "Three")))),
    name: "Droppable listbox"
};
const InDialog = {
    render: ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
            direction: "column",
            gap: "size-200",
            alignItems: "center"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Draggable, null), /*#__PURE__*/ (0, _reactDefault.default).createElement(DialogButton, null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _dialog.Dialog), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Heading), null, "Dialog"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Content), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
            direction: "column",
            gap: "size-200",
            alignItems: "center"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Draggable, null), /*#__PURE__*/ (0, _reactDefault.default).createElement(Droppable, null), /*#__PURE__*/ (0, _reactDefault.default).createElement(Droppable, null))))), /*#__PURE__*/ (0, _reactDefault.default).createElement(Droppable, null)),
    name: "In dialog"
};
const DraggableGridDroppableListbox = {
    render: ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
            direction: "row",
            gap: "size-200",
            alignItems: "center",
            wrap: true
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement(DraggableCollectionExample, null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _droppableListBox.DroppableListBoxExample), null)),
    name: "Draggable grid, droppable listbox"
};
const DroppableGrid = {
    render: ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
            direction: "column",
            alignItems: "start"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _actiongroup.ActionGroup), {
            onAction: (action)=>{
                switch(action){
                    case "copy":
                    case "cut":
                        {
                            let selected = document.querySelector('[aria-label="Draggable list"] [aria-selected="true"] [role="gridcell"]');
                            selected === null || selected === void 0 ? void 0 : selected.focus();
                            document.execCommand(action);
                            break;
                        }
                    case "paste":
                        {
                            // This only works in Safari...
                            let selected = document.querySelector('[aria-label="List"] [aria-selected="true"] [role="gridcell"]');
                            selected === null || selected === void 0 ? void 0 : selected.focus();
                            document.execCommand("paste");
                            break;
                        }
                }
            }
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _collections.Item), {
            key: "copy",
            "aria-label": "Copy"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _copyDefault.default), null)), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _collections.Item), {
            key: "cut",
            "aria-label": "Cut"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _cutDefault.default), null)), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _collections.Item), {
            key: "paste",
            "aria-label": "Paste"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _pasteDefault.default), null))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
            direction: "row",
            gap: "size-200",
            alignItems: "center",
            wrap: true
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement(DraggableCollectionExample, null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _droppableGrid.DroppableGridExample), {
            onDropEnter: (0, _addonActions.action)("onDropEnter"),
            onDropExit: (0, _addonActions.action)("onDropExit"),
            onDrop: (0, _addonActions.action)("onDrop")
        }))),
    name: "Droppable grid"
};
const DroppableGridWithManyItems = {
    render: ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
            direction: "row",
            gap: "size-200",
            alignItems: "center",
            wrap: true
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement(DraggableCollectionExample, null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _droppableGrid.DroppableGridExample), {
            items: manyItems
        })),
    name: "Droppable grid with many items"
};
const VirtualizedListbox = {
    render: ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
            direction: "row",
            gap: "size-200",
            alignItems: "center",
            wrap: true
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement(DraggableCollectionExample, null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _virtualizedListBox.VirtualizedListBoxExample), {
            items: manyItems
        })),
    name: "Virtualized listbox"
};
const MultipleCollectionDropTargets = {
    render: ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
            direction: "row",
            gap: "size-200",
            alignItems: "center",
            wrap: true
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement(DraggableCollectionExample, null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _virtualizedListBox.VirtualizedListBoxExample), {
            items: manyItems.map((item)=>({
                    ...item,
                    type: "folder"
                })),
            accept: "folder"
        }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _virtualizedListBox.VirtualizedListBoxExample), {
            items: manyItems,
            accept: "item"
        })),
    name: "Multiple collection drop targets"
};
const Reorderable = ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reorderable.ReorderableGridExample), null);
function Draggable() {
    let { dragProps, isDragging } = (0, _.useDrag)({
        getItems () {
            return [
                {
                    "text/plain": "hello world"
                }
            ];
        },
        getAllowedDropOperations () {
            return [
                "copy"
            ];
        },
        onDragStart: (0, _addonActions.action)("onDragStart"),
        // onDragMove: action('onDragMove'),
        onDragEnd: (0, _addonActions.action)("onDragEnd")
    });
    let { clipboardProps } = (0, _.useClipboard)({
        getItems () {
            return [
                {
                    "text/plain": "hello world"
                }
            ];
        }
    });
    let ref = (0, _reactDefault.default).useRef();
    let { buttonProps } = (0, _button1.useButton)({
        elementType: "div"
    }, ref);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _focus.FocusRing), {
        focusRingClass: (0, _utils1.classNames)((0, _dndCssDefault.default), "focus-ring")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ref: ref,
        ...(0, _utils.mergeProps)(dragProps, buttonProps, clipboardProps),
        className: (0, _utils1.classNames)((0, _dndCssDefault.default), "draggable", {
            "is-dragging": isDragging
        })
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _showMenuDefault.default), {
        size: "XS"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("span", null, "Drag me")));
}
function Droppable({ type, children, actionId = "" }) {
    let ref = (0, _reactDefault.default).useRef();
    let { dropProps, isDropTarget } = (0, _.useDrop)({
        ref,
        onDropEnter: (0, _addonActions.action)(`onDropEnter${actionId}`),
        // onDropMove: action('onDropMove'),
        onDropExit: (0, _addonActions.action)(`onDropExit${actionId}`),
        onDropActivate: (0, _addonActions.action)(`onDropActivate${actionId}`),
        onDrop: (0, _addonActions.action)(`onDrop${actionId}`),
        getDropOperation (types, allowedOperations) {
            return !type || types.has(type) ? allowedOperations[0] : "cancel";
        }
    });
    let { clipboardProps } = (0, _.useClipboard)({
        onPaste: (0, _addonActions.action)(`onPaste${actionId}`)
    });
    let { buttonProps } = (0, _button1.useButton)({
        elementType: "div"
    }, ref);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _focus.FocusRing), {
        focusRingClass: (0, _utils1.classNames)((0, _varsCssDefault.default), "focus-ring")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...(0, _utils.mergeProps)(dropProps, buttonProps, clipboardProps),
        ref: ref,
        className: (0, _utils1.classNames)((0, _varsCssDefault.default), "spectrum-Dropzone", {
            "is-dragged": isDropTarget
        })
    }, "Drop here", children));
}
function DialogButton({ children }) {
    let [isOpen, setOpen] = (0, _reactDefault.default).useState(false);
    let ref = (0, _reactDefault.default).useRef();
    let { dropProps, isDropTarget } = (0, _.useDrop)({
        ref: (0, _utils1.unwrapDOMRef)(ref),
        onDropActivate () {
            setOpen(true);
        }
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _dialog.DialogTrigger), {
        isDismissable: true,
        isOpen: isOpen,
        onOpenChange: setOpen
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _interactions.PressResponder), {
        ...dropProps,
        isPressed: isDropTarget
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), {
        ref: ref
    }, "Open dialog")), children);
}
function DraggableCollectionExample() {
    let list = (0, _data.useListData)({
        initialItems: [
            {
                id: "foo",
                type: "folder",
                text: "Foo"
            },
            {
                id: "bar",
                type: "folder",
                text: "Bar"
            },
            {
                id: "baz",
                type: "item",
                text: "Baz"
            }
        ]
    });
    let onDragEnd = (e)=>{
        if (e.dropOperation === "move") list.remove(...e.keys);
    };
    let onCut = (keys)=>{
        list.remove(...keys);
    };
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(DraggableCollection, {
        items: list.items,
        selectedKeys: list.selectedKeys,
        onSelectionChange: list.setSelectedKeys,
        onDragEnd: onDragEnd,
        onCut: onCut
    }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _collections.Item), {
            textValue: item.text
        }, item.type === "folder" && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _folderDefault.default), {
            size: "S"
        }), /*#__PURE__*/ (0, _reactDefault.default).createElement("span", null, item.text)));
}
function DraggableCollection(props) {
    let ref = (0, _reactDefault.default).useRef(null);
    let state = (0, _list.useListState)(props);
    let gridState = (0, _grid.useGridState)({
        ...props,
        selectionMode: "multiple",
        collection: new (0, _grid.GridCollection)({
            columnCount: 1,
            items: [
                ...state.collection
            ].map((item)=>({
                    ...item,
                    childNodes: [
                        {
                            key: `cell-${item.key}`,
                            type: "cell",
                            index: 0,
                            value: null,
                            level: 0,
                            rendered: null,
                            textValue: item.textValue,
                            hasChildNodes: false,
                            childNodes: []
                        }
                    ]
                }))
        })
    });
    let preview = (0, _react.useRef)(null);
    let dragState = (0, _dnd.useDraggableCollectionState)({
        collection: gridState.collection,
        selectionManager: gridState.selectionManager,
        getItems (keys) {
            return [
                ...keys
            ].map((key)=>{
                let item = gridState.collection.getItem(key);
                return {
                    // @ts-ignore
                    [item.value.type]: item.textValue,
                    "text/plain": item.textValue
                };
            });
        },
        preview,
        onDragStart: (0, _addonActions.action)("onDragStart"),
        onDragEnd: (0, _utils.chain)((0, _addonActions.action)("onDragEnd"), props.onDragEnd)
    });
    (0, _.useDraggableCollection)({}, dragState, ref);
    let { gridProps } = (0, _grid1.useGrid)({
        ...props,
        "aria-label": "Draggable list",
        focusMode: "cell"
    }, gridState, ref);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ref: ref,
        ...gridProps,
        style: {
            display: "flex",
            flexDirection: "column"
        }
    }, [
        ...gridState.collection
    ].map((item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(DraggableCollectionItem, {
            key: item.key,
            item: item,
            state: gridState,
            dragState: dragState,
            onCut: props.onCut
        })), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _dragPreview.DragPreview), {
        ref: preview
    }, ()=>{
        let selectedKeys = dragState.draggingKeys;
        let draggedKey = [
            ...selectedKeys
        ][0];
        let item = state.collection.getItem(draggedKey);
        return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
            className: (0, _utils1.classNames)((0, _dndCssDefault.default), "draggable", "is-drag-preview", {
                "is-dragging-multiple": selectedKeys.size > 1
            })
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
            className: (0, _utils1.classNames)((0, _dndCssDefault.default), "drag-handle")
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _showMenuDefault.default), {
            size: "XS"
        })), /*#__PURE__*/ (0, _reactDefault.default).createElement("span", null, item.rendered), selectedKeys.size > 1 && /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
            className: (0, _utils1.classNames)((0, _dndCssDefault.default), "badge")
        }, selectedKeys.size));
    }));
}
function DraggableCollectionItem({ item, state, dragState, onCut }) {
    let rowRef = (0, _reactDefault.default).useRef();
    let cellRef = (0, _reactDefault.default).useRef();
    let cellNode = [
        ...item.childNodes
    ][0];
    let isSelected = state.selectionManager.isSelected(item.key);
    let { rowProps } = (0, _grid1.useGridRow)({
        node: item,
        shouldSelectOnPressUp: true
    }, state, rowRef);
    let { gridCellProps } = (0, _grid1.useGridCell)({
        node: cellNode,
        focusMode: "cell"
    }, state, cellRef);
    let { dragProps, dragButtonProps } = (0, _.useDraggableItem)({
        key: item.key,
        hasDragButton: true
    }, dragState);
    let { clipboardProps } = (0, _.useClipboard)({
        getItems: ()=>dragState.getItems(item.key),
        onCut: ()=>onCut(dragState.getKeysForDrag(item.key))
    });
    let buttonRef = (0, _reactDefault.default).useRef();
    let { buttonProps } = (0, _button1.useButton)({
        ...dragButtonProps,
        elementType: "div"
    }, buttonRef);
    let id = (0, _utils.useId)();
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...(0, _utils.mergeProps)(rowProps, dragProps),
        ref: rowRef,
        "aria-labelledby": id
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _focus.FocusRing), {
        focusRingClass: (0, _utils1.classNames)((0, _dndCssDefault.default), "focus-ring")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...(0, _utils.mergeProps)(gridCellProps, clipboardProps),
        "aria-labelledby": id,
        ref: cellRef,
        className: (0, _utils1.classNames)((0, _dndCssDefault.default), "draggable", {
            "is-dragging": dragState.isDragging(item.key),
            "is-selected": isSelected
        })
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _focus.FocusRing), {
        focusRingClass: (0, _utils1.classNames)((0, _dndCssDefault.default), "focus-ring")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...buttonProps,
        ref: buttonRef,
        className: (0, _utils1.classNames)((0, _dndCssDefault.default), "drag-handle")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _showMenuDefault.default), {
        size: "XS"
    }))), /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        id: id
    }, item.rendered))));
}

},{"@storybook/addon-actions":"coXbW","@react-spectrum/button":"jZWyP","@react-spectrum/actiongroup":"hkqBV","@react-aria/utils":"9cLk5","@react-spectrum/utils":"cMIJ6","@react-spectrum/view":"dnRjt","@spectrum-icons/workflow/Copy":"jpSBZ","@spectrum-icons/workflow/Cut":"4SMrV","@react-spectrum/dialog":"3G0HV","./dnd.css":"7vfBr","./DraggableListBox":"dZGoj","../src/DragPreview":"dijBK","./DroppableGrid":"3OdA0","./DroppableListBox":"626JG","@adobe/spectrum-css-temp/components/dnd/vars.css":"dbVuU","@react-spectrum/layout":"hzaUY","@react-aria/focus":"42mbF","@spectrum-icons/workflow/Folder":"hFWVZ","@react-stately/grid":"ehdYF","@react-spectrum/text":"etCGI","@react-stately/collections":"loANi","@spectrum-icons/workflow/Paste":"jKZ2V","@react-aria/interactions":"ky3G8","react":"9yzVZ","./Reorderable":"6aYul","@spectrum-icons/workflow/ShowMenu":"jtOrd","@react-aria/button":"fsdLZ","..":"9GGBK","@react-stately/dnd":"bUQOi","@react-aria/grid":"6tGaN","@react-stately/data":"gEgJM","@react-stately/list":"Cp0zP","./VirtualizedListBox":"jRKvD","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"hkqBV":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /// <reference types="css-module-types" />
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ActionGroup", ()=>(0, _actionGroup.ActionGroup));
parcelHelpers.export(exports, "Item", ()=>(0, _collections.Item));
var _actionGroup = require("./ActionGroup");
var _collections = require("@react-stately/collections");

},{"./ActionGroup":"hvje0","@react-stately/collections":"loANi","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"hvje0":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ActionGroup", ()=>_ActionGroup);
var _button = require("@react-spectrum/button");
var _varsCss = require("@adobe/spectrum-css-temp/components/button/vars.css");
var _varsCssDefault = parcelHelpers.interopDefault(_varsCss);
var _chevronDownMedium = require("@spectrum-icons/ui/ChevronDownMedium");
var _chevronDownMediumDefault = parcelHelpers.interopDefault(_chevronDownMedium);
var _utils = require("@react-spectrum/utils");
var _utils1 = require("@react-aria/utils");
var _focus = require("@react-aria/focus");
var _menu = require("@react-spectrum/menu");
var _list = require("@react-stately/list");
var _more = require("@spectrum-icons/workflow/More");
var _moreDefault = parcelHelpers.interopDefault(_more);
var _interactions = require("@react-aria/interactions");
var _provider = require("@react-spectrum/provider");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _varsCss1 = require("@adobe/spectrum-css-temp/components/actiongroup/vars.css");
var _varsCssDefault1 = parcelHelpers.interopDefault(_varsCss1);
var _text = require("@react-spectrum/text");
var _tooltip = require("@react-spectrum/tooltip");
var _actiongroup = require("@react-aria/actiongroup");
function ActionGroup(props, ref) {
    props = (0, _provider.useProviderProps)(props);
    props = (0, _utils.useSlotProps)(props, "actionGroup");
    let { isEmphasized, density, isJustified, isDisabled, orientation = "horizontal", isQuiet, staticColor, overflowMode = "wrap", onAction, buttonLabelBehavior, summaryIcon, ...otherProps } = props;
    let domRef = (0, _utils.useDOMRef)(ref);
    let wrapperRef = (0, _react.useRef)(null);
    let state = (0, _list.useListState)({
        ...props,
        suppressTextValueWarning: true
    });
    let { actionGroupProps } = (0, _actiongroup.useActionGroup)(props, state, domRef);
    let isVertical = orientation === "vertical";
    let providerProps = {
        isEmphasized,
        isDisabled,
        isQuiet
    };
    let { styleProps } = (0, _utils.useStyleProps)(props);
    // Only hide button text if every item contains more than just plain text (we assume an icon).
    let isIconCollapsible = (0, _react.useMemo)(()=>[
            ...state.collection
        ].every((item)=>typeof item.rendered !== "string"), [
        state.collection
    ]);
    let [{ visibleItems, hideButtonText, isMeasuring }, setVisibleItems] = (0, _utils1.useValueEffect)({
        visibleItems: state.collection.size,
        hideButtonText: buttonLabelBehavior === "hide" && isIconCollapsible,
        isMeasuring: false
    });
    let selectionMode = state.selectionManager.selectionMode;
    let updateOverflow = (0, _react.useCallback)(()=>{
        if (overflowMode === "wrap") return;
        if (orientation === "vertical" && selectionMode !== "none") // Collapsing vertical action groups with selection is currently unsupported by Spectrum.
        return;
        let computeVisibleItems = (visibleItems)=>{
            if (domRef.current && wrapperRef.current) {
                let listItems = Array.from(domRef.current.children);
                let containerSize = orientation === "horizontal" ? wrapperRef.current.getBoundingClientRect().width : wrapperRef.current.getBoundingClientRect().height;
                let isShowingMenu = visibleItems < state.collection.size;
                let calculatedSize = 0;
                let newVisibleItems = 0;
                if (isShowingMenu) {
                    let item = listItems.pop();
                    if (item) calculatedSize += orientation === "horizontal" ? outerWidth(item, false, true) : outerHeight(item, false, true);
                }
                for (let [i, item] of listItems.entries()){
                    calculatedSize += orientation === "horizontal" ? outerWidth(item, i === 0, i === listItems.length - 1) : outerHeight(item, i === 0, i === listItems.length - 1);
                    if (Math.round(calculatedSize) <= Math.round(containerSize)) newVisibleItems++;
                    else break;
                }
                // If selection is enabled, and not all of the items fit, collapse all of them into a dropdown
                // immediately rather than having some visible and some not.
                if (selectionMode !== "none" && newVisibleItems < state.collection.size) return 0;
                return newVisibleItems;
            }
            return visibleItems;
        };
        setVisibleItems(function*() {
            let hideButtonText = buttonLabelBehavior === "hide" && isIconCollapsible;
            // Update to show all items.
            yield {
                visibleItems: state.collection.size,
                hideButtonText,
                isMeasuring: true
            };
            // Measure, and update to show the items that fit.
            let newVisibleItems = computeVisibleItems(state.collection.size);
            let isMeasuring = newVisibleItems < state.collection.size && newVisibleItems > 0;
            // If not all of the buttons fit, and buttonLabelBehavior is 'collapse', then first try hiding
            // the button text and only showing icons. Only if that still doesn't fit collapse into a menu.
            if (newVisibleItems < state.collection.size && buttonLabelBehavior === "collapse" && isIconCollapsible) {
                yield {
                    visibleItems: state.collection.size,
                    hideButtonText: true,
                    isMeasuring: true
                };
                newVisibleItems = computeVisibleItems(state.collection.size);
                isMeasuring = newVisibleItems < state.collection.size && newVisibleItems > 0;
                hideButtonText = true;
            }
            yield {
                visibleItems: newVisibleItems,
                hideButtonText,
                isMeasuring
            };
            // If the number of items is less than the number of children,
            // then update again to ensure that the menu fits.
            if (isMeasuring) yield {
                visibleItems: computeVisibleItems(newVisibleItems),
                hideButtonText,
                isMeasuring: false
            };
        });
    }, [
        domRef,
        state.collection,
        setVisibleItems,
        overflowMode,
        selectionMode,
        buttonLabelBehavior,
        isIconCollapsible,
        orientation
    ]);
    // Watch the parent element for size changes. Watching only the action group itself may not work
    // in all scenarios because it may not shrink when available space is reduced.
    let parentRef = (0, _react.useMemo)(()=>({
            get current () {
                var _wrapperRef_current;
                return (_wrapperRef_current = wrapperRef.current) === null || _wrapperRef_current === void 0 ? void 0 : _wrapperRef_current.parentElement;
            }
        }), [
        wrapperRef
    ]);
    (0, _utils1.useResizeObserver)({
        ref: overflowMode !== "wrap" ? parentRef : undefined,
        onResize: updateOverflow
    });
    (0, _utils1.useLayoutEffect)(updateOverflow, [
        updateOverflow,
        state.collection
    ]);
    let children = [
        ...state.collection
    ];
    let menuItem = null;
    let menuProps = {};
    // If there are no visible items, don't apply any props to the action group container
    // and pass all aria labeling props through to the menu button.
    if (overflowMode === "collapse" && visibleItems === 0) {
        menuProps = (0, _utils1.filterDOMProps)(props, {
            labelable: true
        });
        actionGroupProps = {};
    }
    if (overflowMode === "collapse" && visibleItems < state.collection.size) {
        let menuChildren = children.slice(visibleItems);
        children = children.slice(0, visibleItems);
        menuItem = /*#__PURE__*/ (0, _reactDefault.default).createElement(ActionGroupMenu, {
            ...menuProps,
            items: menuChildren,
            onAction: onAction,
            isDisabled: isDisabled,
            isEmphasized: isEmphasized,
            staticColor: staticColor,
            state: state,
            summaryIcon: summaryIcon,
            hideButtonText: hideButtonText,
            isOnlyItem: visibleItems === 0,
            orientation: orientation
        });
    }
    let style = {
        ...styleProps.style,
        // While measuring, take up as much space as possible.
        flexBasis: isMeasuring ? "100%" : undefined
    };
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _focus.FocusScope), null, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...styleProps,
        style: style,
        className: (0, _utils.classNames)((0, _varsCssDefault1.default), "flex-container", styleProps.className),
        ref: wrapperRef
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...actionGroupProps,
        ref: domRef,
        className: (0, _utils.classNames)((0, _varsCssDefault1.default), "flex-gap", "spectrum-ActionGroup", {
            "spectrum-ActionGroup--quiet": isQuiet,
            "spectrum-ActionGroup--vertical": isVertical,
            "spectrum-ActionGroup--compact": density === "compact",
            "spectrum-ActionGroup--justified": isJustified && !isMeasuring,
            "spectrum-ActionGroup--overflowCollapse": overflowMode === "collapse"
        }, otherProps.UNSAFE_className)
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _provider.Provider), providerProps, children.map((item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(ActionGroupItem, {
            key: item.key,
            onAction: onAction,
            isDisabled: isDisabled,
            isEmphasized: isEmphasized,
            staticColor: staticColor,
            item: item,
            state: state,
            hideButtonText: hideButtonText,
            orientation: orientation
        })), menuItem))));
}
/**
 * An ActionGroup is a grouping of ActionButtons that are related to one another.
 */ const _ActionGroup = /*#__PURE__*/ (0, _react.forwardRef)(ActionGroup);
function ActionGroupItem({ item, state, isDisabled, isEmphasized, staticColor, onAction, hideButtonText, orientation }) {
    let ref = (0, _react.useRef)(null);
    let { buttonProps } = (0, _actiongroup.useActionGroupItem)({
        key: item.key
    }, state);
    isDisabled = isDisabled || state.disabledKeys.has(item.key);
    let isSelected = state.selectionManager.isSelected(item.key);
    let { hoverProps, isHovered } = (0, _interactions.useHover)({
        isDisabled
    });
    let domProps = (0, _utils1.filterDOMProps)(item.props);
    if (onAction && !isDisabled) buttonProps = (0, _utils1.mergeProps)(buttonProps, {
        onPress: ()=>onAction(item.key)
    });
    // If button text is hidden, we need to show it as a tooltip instead, so
    // go find the text element in the DOM after rendering.
    let textId = (0, _utils1.useId)();
    let [textContent, setTextContent] = (0, _react.useState)("");
    (0, _utils1.useLayoutEffect)(()=>{
        var _document_getElementById;
        if (hideButtonText) setTextContent((_document_getElementById = document.getElementById(textId)) === null || _document_getElementById === void 0 ? void 0 : _document_getElementById.textContent);
    }, [
        hideButtonText,
        item.rendered,
        textId
    ]);
    let button = // Use a PressResponder to send DOM props through.
    // ActionButton doesn't allow overriding the role by default.
    /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _interactions.PressResponder), (0, _utils1.mergeProps)(buttonProps, hoverProps, domProps), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.ClearSlots), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.SlotProvider), {
        slots: {
            text: {
                id: hideButtonText ? textId : null,
                isHidden: hideButtonText
            },
            icon: {
                UNSAFE_className: hideButtonText ? (0, _utils.classNames)((0, _varsCssDefault1.default), "spectrum-ActionGroup-itemIcon") : null
            }
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), {
        ref: ref,
        UNSAFE_className: (0, _utils.classNames)((0, _varsCssDefault1.default), "spectrum-ActionGroup-item", {
            "is-selected": isSelected,
            "is-hovered": isHovered,
            "spectrum-ActionGroup-item--iconOnly": hideButtonText,
            "spectrum-ActionGroup-item--isDisabled": isDisabled
        }, (0, _utils.classNames)((0, _varsCssDefault.default), {
            "spectrum-ActionButton--emphasized": isEmphasized,
            "is-selected": isSelected
        })),
        isDisabled: isDisabled,
        staticColor: staticColor,
        "aria-label": item["aria-label"],
        "aria-labelledby": item["aria-label"] == null && hideButtonText ? textId : undefined
    }, item.rendered))));
    if (hideButtonText && textContent) button = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _tooltip.TooltipTrigger), {
        placement: orientation === "vertical" ? "end" : "top"
    }, button, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _tooltip.Tooltip), null, textContent));
    if (item.wrapper) button = item.wrapper(button);
    return button;
}
function ActionGroupMenu({ state, isDisabled, isEmphasized, staticColor, items, onAction, summaryIcon, hideButtonText, isOnlyItem, orientation, ...otherProps }) {
    // Use the key of the first item within the menu as the key of the button.
    // The key must actually exist in the collection for focus to work correctly.
    let key = items[0].key;
    let { buttonProps } = (0, _actiongroup.useActionGroupItem)({
        key
    }, state);
    // The menu button shouldn't act like an actual action group item.
    delete buttonProps.onPress;
    delete buttonProps.role;
    delete buttonProps["aria-checked"];
    let { hoverProps, isHovered } = (0, _interactions.useHover)({
        isDisabled
    });
    // If no aria-label or aria-labelledby is given, provide a default one.
    let ariaLabel = otherProps["aria-label"] || (otherProps["aria-labelledby"] ? undefined : "\u2026");
    let ariaLabelledby = otherProps["aria-labelledby"];
    let textId = (0, _utils1.useId)();
    let id = (0, _utils1.useId)();
    // Summary icon only applies when selection is enabled.
    if (state.selectionManager.selectionMode === "none") summaryIcon = null;
    let iconOnly = false;
    // If there is a selection, show the selected state on the menu button.
    let isSelected = state.selectionManager.selectionMode !== "none" && !state.selectionManager.isEmpty;
    // If single selection and empty selection is not allowed, swap the contents of the button to the selected item (like a Picker).
    if (!summaryIcon && state.selectionManager.selectionMode === "single" && state.selectionManager.disallowEmptySelection && state.selectionManager.firstSelectedKey != null) {
        let selectedItem = state.collection.getItem(state.selectionManager.firstSelectedKey);
        if (selectedItem) {
            summaryIcon = selectedItem.rendered;
            if (typeof summaryIcon === "string") summaryIcon = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, summaryIcon);
            iconOnly = !!hideButtonText;
            ariaLabelledby = `${ariaLabelledby !== null && ariaLabelledby !== void 0 ? ariaLabelledby : id} ${textId}`;
        }
    }
    if (summaryIcon) // If there's a custom summary icon, also add a chevron.
    summaryIcon = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _chevronDownMediumDefault.default), {
        UNSAFE_className: (0, _utils.classNames)((0, _varsCssDefault1.default), "spectrum-ActionGroup-menu-chevron")
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        className: (0, _utils.classNames)((0, _varsCssDefault1.default), "spectrum-ActionGroup-menu-contents", {
            "spectrum-ActionGroup-item--iconOnly": iconOnly
        })
    }, summaryIcon));
    return(// Use a PressResponder to send DOM props through.
    /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _menu.MenuTrigger), {
        align: isOnlyItem ? "start" : "end",
        direction: orientation === "vertical" ? "end" : "bottom"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.SlotProvider), {
        slots: {
            text: {
                id: hideButtonText ? textId : null,
                isHidden: hideButtonText,
                UNSAFE_className: (0, _utils.classNames)((0, _varsCssDefault1.default), "spectrum-ActionGroup-menu-text")
            }
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _interactions.PressResponder), (0, _utils1.mergeProps)(buttonProps, hoverProps), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), {
        ...otherProps,
        id: id,
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledby,
        UNSAFE_className: (0, _utils.classNames)((0, _varsCssDefault1.default), "spectrum-ActionGroup-item", "spectrum-ActionGroup-menu", {
            "is-hovered": isHovered,
            "is-selected": isSelected
        }, (0, _utils.classNames)((0, _varsCssDefault.default), {
            "is-selected": isSelected,
            "spectrum-ActionButton--emphasized": isEmphasized
        })),
        isDisabled: isDisabled,
        staticColor: staticColor
    }, summaryIcon || /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _moreDefault.default), null)))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _menu.Menu), {
        items: items,
        disabledKeys: state.disabledKeys,
        selectionMode: state.selectionManager.selectionMode,
        selectedKeys: state.selectionManager.selectedKeys,
        disallowEmptySelection: state.selectionManager.disallowEmptySelection,
        onSelectionChange: (keys)=>state.selectionManager.setSelectedKeys(keys),
        onAction: onAction
    }, (node)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _menu.Item), {
            textValue: node.textValue,
            ...(0, _utils1.filterDOMProps)(node.props)
        }, node.rendered))));
}
function outerWidth(element, ignoreLeftMargin, ignoreRightMargin) {
    let style = window.getComputedStyle(element);
    return element.getBoundingClientRect().width + (ignoreLeftMargin ? 0 : toNumber(style.marginLeft)) + (ignoreRightMargin ? 0 : toNumber(style.marginRight));
}
function outerHeight(element, ignoreTopMargin, ignoreBottomMargin) {
    let style = window.getComputedStyle(element);
    return element.getBoundingClientRect().height + (ignoreTopMargin ? 0 : toNumber(style.marginTop)) + (ignoreBottomMargin ? 0 : toNumber(style.marginBottom));
}
function toNumber(value) {
    let parsed = parseInt(value, 10);
    return isNaN(parsed) ? 0 : parsed;
}

},{"@react-spectrum/button":"jZWyP","@adobe/spectrum-css-temp/components/button/vars.css":"cTEhK","@spectrum-icons/ui/ChevronDownMedium":"bWUHC","@react-spectrum/utils":"cMIJ6","@react-aria/utils":"9cLk5","@react-aria/focus":"42mbF","@react-spectrum/menu":"asqy4","@react-stately/list":"Cp0zP","@spectrum-icons/workflow/More":"khbPp","@react-aria/interactions":"ky3G8","@react-spectrum/provider":"5bCdp","react":"9yzVZ","@adobe/spectrum-css-temp/components/actiongroup/vars.css":"9h6R6","@react-spectrum/text":"etCGI","@react-spectrum/tooltip":"f9wa6","@react-aria/actiongroup":"l9PWo","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"bWUHC":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("3111609ce82a4e21");
exports.__esModule = true;
exports.default = ChevronDownMedium;
var _ChevronDownMedium = require("3a2f69a262acdc0a");
var _icon = require("fce2d4e6178f0b5");
var _react = _interopRequireDefault(require("562dca3fcdebab6a"));
function ChevronDownMedium(props) {
    return /*#__PURE__*/ _react.default.createElement(_icon.UIIcon, props, /*#__PURE__*/ _react.default.createElement(_ChevronDownMedium.ChevronDownMedium, null));
}

},{"3111609ce82a4e21":"iHubQ","3a2f69a262acdc0a":"S6Snr","fce2d4e6178f0b5":"k7wem","562dca3fcdebab6a":"9yzVZ"}],"S6Snr":[function(require,module,exports) {
/**
* @adobe/react-spectrum-ui (c) by Adobe
* 
* @adobe/react-spectrum-ui is licensed under a
* Creative Commons Attribution-NoDerivatives 4.0 International License.
* 
* You should have received a copy of the license along with this
* work. If not, see <http://creativecommons.org/licenses/by-nd/4.0/>.
**/ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ChevronDownMedium = ChevronDownMedium;
var _react = _interopRequireDefault(require("388967124dbb212b"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function ChevronDownMedium(_ref) {
    var _ref$scale = _ref.scale, scale = _ref$scale === void 0 ? "M" : _ref$scale, props = _objectWithoutProperties(_ref, [
        "scale"
    ]);
    return _react["default"].createElement("svg", _extends({}, props, props), scale === "L" && _react["default"].createElement("path", {
        d: "M11.99 1.51a1 1 0 0 0-1.707-.707L6 5.086 1.717.803A1 1 0 1 0 .303 2.217l4.99 4.99a1 1 0 0 0 1.414 0l4.99-4.99a.997.997 0 0 0 .293-.707z"
    }), scale === "M" && _react["default"].createElement("path", {
        d: "M9.99 1.01A1 1 0 0 0 8.283.303L5 3.586 1.717.303A1 1 0 1 0 .303 1.717l3.99 3.98a1 1 0 0 0 1.414 0l3.99-3.98a.997.997 0 0 0 .293-.707z"
    }));
}
ChevronDownMedium.displayName = "ChevronDownMedium";

},{"388967124dbb212b":"9yzVZ"}],"asqy4":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /// <reference types="css-module-types" />
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MenuTrigger", ()=>(0, _menuTrigger.MenuTrigger));
parcelHelpers.export(exports, "SubmenuTrigger", ()=>(0, _submenuTrigger.SubmenuTrigger));
parcelHelpers.export(exports, "Menu", ()=>(0, _menu.Menu));
parcelHelpers.export(exports, "ActionMenu", ()=>(0, _actionMenu.ActionMenu));
parcelHelpers.export(exports, "ContextualHelpTrigger", ()=>(0, _contextualHelpTrigger.ContextualHelpTrigger));
parcelHelpers.export(exports, "Item", ()=>(0, _collections.Item));
parcelHelpers.export(exports, "Section", ()=>(0, _collections.Section));
var _menuTrigger = require("./MenuTrigger");
var _submenuTrigger = require("./SubmenuTrigger");
var _menu = require("./Menu");
var _actionMenu = require("./ActionMenu");
var _contextualHelpTrigger = require("./ContextualHelpTrigger");
var _collections = require("@react-stately/collections");

},{"./MenuTrigger":"2kPmK","./SubmenuTrigger":"hg3eM","./Menu":"4Thgz","./ActionMenu":"jAWPe","./ContextualHelpTrigger":"j4eSN","@react-stately/collections":"loANi","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"2kPmK":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MenuTrigger", ()=>_MenuTrigger);
var _utils = require("@react-spectrum/utils");
var _context = require("./context");
var _overlays = require("@react-spectrum/overlays");
var _interactions = require("@react-aria/interactions");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _varsCss = require("@adobe/spectrum-css-temp/components/menu/vars.css");
var _varsCssDefault = parcelHelpers.interopDefault(_varsCss);
var _menu = require("@react-aria/menu");
var _menu1 = require("@react-stately/menu");
function MenuTrigger(props, ref) {
    let triggerRef = (0, _react.useRef)();
    let domRef = (0, _utils.useDOMRef)(ref);
    let menuTriggerRef = domRef || triggerRef;
    let menuRef = (0, _react.useRef)();
    let { children, align = "start", shouldFlip = true, direction = "bottom", closeOnSelect, trigger = "press" } = props;
    let [menuTrigger, menu] = (0, _reactDefault.default).Children.toArray(children);
    let state = (0, _menu1.useMenuTriggerState)(props);
    let { menuTriggerProps, menuProps } = (0, _menu.useMenuTrigger)({
        trigger
    }, state, menuTriggerRef);
    let initialPlacement;
    switch(direction){
        case "left":
        case "right":
        case "start":
        case "end":
            initialPlacement = `${direction} ${align === "end" ? "bottom" : "top"}`;
            break;
        case "bottom":
        case "top":
        default:
            initialPlacement = `${direction} ${align}`;
    }
    let isMobile = (0, _utils.useIsMobileDevice)();
    let menuContext = {
        ...menuProps,
        ref: menuRef,
        onClose: state.close,
        closeOnSelect,
        autoFocus: state.focusStrategy || true,
        UNSAFE_style: isMobile ? {
            width: "100%",
            maxHeight: "inherit"
        } : undefined,
        UNSAFE_className: (0, _utils.classNames)((0, _varsCssDefault.default), {
            "spectrum-Menu-popover": !isMobile
        }),
        state
    };
    // On small screen devices, the menu is rendered in a tray, otherwise a popover.
    let overlay;
    if (isMobile) overlay = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _overlays.Tray), {
        state: state,
        isFixedHeight: true
    }, menu);
    else overlay = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _overlays.Popover), {
        UNSAFE_style: {
            clipPath: "unset",
            overflow: "visible",
            filter: "unset",
            borderWidth: "0px"
        },
        state: state,
        triggerRef: menuTriggerRef,
        scrollRef: menuRef,
        placement: initialPlacement,
        hideArrow: true,
        shouldFlip: shouldFlip
    }, menu);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _react.Fragment), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.SlotProvider), {
        slots: {
            actionButton: {
                holdAffordance: trigger === "longPress"
            }
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _interactions.PressResponder), {
        ...menuTriggerProps,
        ref: menuTriggerRef,
        isPressed: state.isOpen
    }, menuTrigger)), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _context.MenuContext).Provider, {
        value: menuContext
    }, overlay));
}
/**
 * The MenuTrigger serves as a wrapper around a Menu and its associated trigger,
 * linking the Menu's open state with the trigger's press state.
 */ let _MenuTrigger = /*#__PURE__*/ (0, _react.forwardRef)(MenuTrigger);

},{"@react-spectrum/utils":"cMIJ6","./context":"fEXAZ","@react-spectrum/overlays":"3nwGn","@react-aria/interactions":"ky3G8","react":"9yzVZ","@adobe/spectrum-css-temp/components/menu/vars.css":"gqElf","@react-aria/menu":"89bvn","@react-stately/menu":"iqDQI","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"fEXAZ":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MenuContext", ()=>MenuContext);
parcelHelpers.export(exports, "useMenuContext", ()=>useMenuContext);
parcelHelpers.export(exports, "SubmenuTriggerContext", ()=>SubmenuTriggerContext);
parcelHelpers.export(exports, "useSubmenuTriggerContext", ()=>useSubmenuTriggerContext);
parcelHelpers.export(exports, "MenuStateContext", ()=>MenuStateContext);
parcelHelpers.export(exports, "useMenuStateContext", ()=>useMenuStateContext);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const MenuContext = (0, _reactDefault.default).createContext({});
function useMenuContext() {
    return (0, _react.useContext)(MenuContext);
}
const SubmenuTriggerContext = (0, _reactDefault.default).createContext(undefined);
function useSubmenuTriggerContext() {
    return (0, _react.useContext)(SubmenuTriggerContext);
}
const MenuStateContext = (0, _reactDefault.default).createContext(undefined);
function useMenuStateContext() {
    return (0, _react.useContext)(MenuStateContext);
}

},{"react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"3nwGn":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /// <reference types="css-module-types" />
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Overlay", ()=>(0, _overlay.Overlay));
parcelHelpers.export(exports, "Popover", ()=>(0, _popover.Popover));
parcelHelpers.export(exports, "Modal", ()=>(0, _modal.Modal));
parcelHelpers.export(exports, "Tray", ()=>(0, _tray.Tray));
parcelHelpers.export(exports, "OpenTransition", ()=>(0, _openTransition.OpenTransition));
var _overlay = require("./Overlay");
var _popover = require("./Popover");
var _modal = require("./Modal");
var _tray = require("./Tray");
var _openTransition = require("./OpenTransition");

},{"./Overlay":"4kHiV","./Popover":"dKe1t","./Modal":"9FO5g","./Tray":"l6GDo","./OpenTransition":"1HcMi","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"4kHiV":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Overlay", ()=>_Overlay);
var _openTransition = require("./OpenTransition");
var _provider = require("@react-spectrum/provider");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _overlays = require("@react-aria/overlays");
function Overlay(props, ref) {
    let { children, isOpen, disableFocusManagement, container, onEnter, onEntering, onEntered, onExit, onExiting, onExited, nodeRef } = props;
    let [exited, setExited] = (0, _react.useState)(!isOpen);
    let handleEntered = (0, _react.useCallback)(()=>{
        setExited(false);
        if (onEntered) onEntered();
    }, [
        onEntered
    ]);
    let handleExited = (0, _react.useCallback)(()=>{
        setExited(true);
        if (onExited) onExited();
    }, [
        onExited
    ]);
    // Don't un-render the overlay while it's transitioning out.
    let mountOverlay = isOpen || !exited;
    if (!mountOverlay) // Don't bother showing anything if we don't have to.
    return null;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _overlays.Overlay), {
        portalContainer: container,
        disableFocusManagement: disableFocusManagement,
        isExiting: !isOpen
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _provider.Provider), {
        ref: ref,
        UNSAFE_style: {
            background: "transparent",
            isolation: "isolate"
        },
        isDisabled: false
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _openTransition.OpenTransition), {
        in: isOpen,
        appear: true,
        onExit: onExit,
        onExiting: onExiting,
        onExited: handleExited,
        onEnter: onEnter,
        onEntering: onEntering,
        onEntered: handleEntered,
        nodeRef: nodeRef
    }, children)));
}
let _Overlay = /*#__PURE__*/ (0, _reactDefault.default).forwardRef(Overlay);

},{"./OpenTransition":"1HcMi","@react-spectrum/provider":"5bCdp","react":"9yzVZ","@react-aria/overlays":"5fTCg","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"1HcMi":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Timeout issues adding css animations to enter may be related to
 * https://github.com/reactjs/react-transition-group/issues/189 or
 * https://github.com/reactjs/react-transition-group/issues/22
 * my VM isn't good enough to debug accurately and get a better answer.
 *
 * As a result, use enter 0 so that is-open is applied once entered
 * it doesn't matter if we know when the css-animation is done on entering
 * for exiting though, give time for the css-animation to play
 * before removing from the DOM
 * **note** hitting esc bypasses exit animation for anyone testing.
 */ parcelHelpers.export(exports, "OpenTransition", ()=>OpenTransition);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactTransitionGroup = require("react-transition-group");
const OPEN_STATES = {
    entering: false,
    entered: true
};
function OpenTransition(props) {
    var child;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactTransitionGroup.Transition), {
        timeout: {
            enter: 0,
            exit: 350
        },
        ...props
    }, (state)=>(0, _reactDefault.default).Children.map(props.children, (child)=>child && /*#__PURE__*/ (0, _reactDefault.default).cloneElement(child, {
                isOpen: !!OPEN_STATES[state]
            })));
}

},{"react":"9yzVZ","react-transition-group":"fvo4w","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"fvo4w":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CSSTransition", ()=>(0, _csstransitionDefault.default));
parcelHelpers.export(exports, "ReplaceTransition", ()=>(0, _replaceTransitionDefault.default));
parcelHelpers.export(exports, "SwitchTransition", ()=>(0, _switchTransitionDefault.default));
parcelHelpers.export(exports, "TransitionGroup", ()=>(0, _transitionGroupDefault.default));
parcelHelpers.export(exports, "Transition", ()=>(0, _transitionDefault.default));
parcelHelpers.export(exports, "config", ()=>(0, _configDefault.default));
var _csstransition = require("./CSSTransition");
var _csstransitionDefault = parcelHelpers.interopDefault(_csstransition);
var _replaceTransition = require("./ReplaceTransition");
var _replaceTransitionDefault = parcelHelpers.interopDefault(_replaceTransition);
var _switchTransition = require("./SwitchTransition");
var _switchTransitionDefault = parcelHelpers.interopDefault(_switchTransition);
var _transitionGroup = require("./TransitionGroup");
var _transitionGroupDefault = parcelHelpers.interopDefault(_transitionGroup);
var _transition = require("./Transition");
var _transitionDefault = parcelHelpers.interopDefault(_transition);
var _config = require("./config");
var _configDefault = parcelHelpers.interopDefault(_config);

},{"./CSSTransition":"4LGJ1","./ReplaceTransition":false,"./SwitchTransition":false,"./TransitionGroup":false,"./Transition":"f8Jv0","./config":false,"@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"4LGJ1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _inheritsLoose = require("@babel/runtime/helpers/esm/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _addClass = require("dom-helpers/addClass");
var _addClassDefault = parcelHelpers.interopDefault(_addClass);
var _removeClass = require("dom-helpers/removeClass");
var _removeClassDefault = parcelHelpers.interopDefault(_removeClass);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _transition = require("./Transition");
var _transitionDefault = parcelHelpers.interopDefault(_transition);
var _propTypes1 = require("./utils/PropTypes");
var _reflow = require("./utils/reflow");
var _addClass1 = function addClass(node, classes) {
    return node && classes && classes.split(" ").forEach(function(c) {
        return (0, _addClassDefault.default)(node, c);
    });
};
var removeClass = function removeClass(node, classes) {
    return node && classes && classes.split(" ").forEach(function(c) {
        return (0, _removeClassDefault.default)(node, c);
    });
};
/**
 * A transition component inspired by the excellent
 * [ng-animate](https://docs.angularjs.org/api/ngAnimate) library, you should
 * use it if you're using CSS transitions or animations. It's built upon the
 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
 * component, so it inherits all of its props.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` states of the transition. The first class is applied and then a
 * second `*-active` class in order to activate the CSS transition. After the
 * transition, matching `*-done` class names are applied to persist the
 * transition state.
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
 *         <div>
 *           {"I'll receive my-node-* classes"}
 *         </div>
 *       </CSSTransition>
 *       <button type="button" onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the `in` prop is set to `true`, the child component will first receive
 * the class `example-enter`, then the `example-enter-active` will be added in
 * the next tick. `CSSTransition` [forces a
 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * between before adding the `example-enter-active`. This is an important trick
 * because it allows us to transition between `example-enter` and
 * `example-enter-active` even though they were added immediately one after
 * another. Most notably, this is what makes it possible for us to animate
 * _appearance_.
 *
 * ```css
 * .my-node-enter {
 *   opacity: 0;
 * }
 * .my-node-enter-active {
 *   opacity: 1;
 *   transition: opacity 200ms;
 * }
 * .my-node-exit {
 *   opacity: 1;
 * }
 * .my-node-exit-active {
 *   opacity: 0;
 *   transition: opacity 200ms;
 * }
 * ```
 *
 * `*-active` classes represent which styles you want to animate **to**, so it's
 * important to add `transition` declaration only to them, otherwise transitions
 * might not behave as intended! This might not be obvious when the transitions
 * are symmetrical, i.e. when `*-enter-active` is the same as `*-exit`, like in
 * the example above (minus `transition`), but it becomes apparent in more
 * complex transitions.
 *
 * **Note**: If you're using the
 * [`appear`](http://reactcommunity.org/react-transition-group/transition#Transition-prop-appear)
 * prop, make sure to define styles for `.appear-*` classes as well.
 */ var CSSTransition = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(CSSTransition, _React$Component);
    function CSSTransition() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.appliedClasses = {
            appear: {},
            enter: {},
            exit: {}
        };
        _this.onEnter = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument[0], appearing = _this$resolveArgument[1];
            _this.removeClasses(node, "exit");
            _this.addClass(node, appearing ? "appear" : "enter", "base");
            if (_this.props.onEnter) _this.props.onEnter(maybeNode, maybeAppearing);
        };
        _this.onEntering = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument2 = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument2[0], appearing = _this$resolveArgument2[1];
            var type = appearing ? "appear" : "enter";
            _this.addClass(node, type, "active");
            if (_this.props.onEntering) _this.props.onEntering(maybeNode, maybeAppearing);
        };
        _this.onEntered = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument3 = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument3[0], appearing = _this$resolveArgument3[1];
            var type = appearing ? "appear" : "enter";
            _this.removeClasses(node, type);
            _this.addClass(node, type, "done");
            if (_this.props.onEntered) _this.props.onEntered(maybeNode, maybeAppearing);
        };
        _this.onExit = function(maybeNode) {
            var _this$resolveArgument4 = _this.resolveArguments(maybeNode), node = _this$resolveArgument4[0];
            _this.removeClasses(node, "appear");
            _this.removeClasses(node, "enter");
            _this.addClass(node, "exit", "base");
            if (_this.props.onExit) _this.props.onExit(maybeNode);
        };
        _this.onExiting = function(maybeNode) {
            var _this$resolveArgument5 = _this.resolveArguments(maybeNode), node = _this$resolveArgument5[0];
            _this.addClass(node, "exit", "active");
            if (_this.props.onExiting) _this.props.onExiting(maybeNode);
        };
        _this.onExited = function(maybeNode) {
            var _this$resolveArgument6 = _this.resolveArguments(maybeNode), node = _this$resolveArgument6[0];
            _this.removeClasses(node, "exit");
            _this.addClass(node, "exit", "done");
            if (_this.props.onExited) _this.props.onExited(maybeNode);
        };
        _this.resolveArguments = function(maybeNode, maybeAppearing) {
            return _this.props.nodeRef ? [
                _this.props.nodeRef.current,
                maybeNode
            ] // here `maybeNode` is actually `appearing`
             : [
                maybeNode,
                maybeAppearing
            ];
        };
        _this.getClassNames = function(type) {
            var classNames = _this.props.classNames;
            var isStringClassNames = typeof classNames === "string";
            var prefix = isStringClassNames && classNames ? classNames + "-" : "";
            var baseClassName = isStringClassNames ? "" + prefix + type : classNames[type];
            var activeClassName = isStringClassNames ? baseClassName + "-active" : classNames[type + "Active"];
            var doneClassName = isStringClassNames ? baseClassName + "-done" : classNames[type + "Done"];
            return {
                baseClassName: baseClassName,
                activeClassName: activeClassName,
                doneClassName: doneClassName
            };
        };
        return _this;
    }
    var _proto = CSSTransition.prototype;
    _proto.addClass = function addClass(node, type, phase) {
        var className = this.getClassNames(type)[phase + "ClassName"];
        var _this$getClassNames = this.getClassNames("enter"), doneClassName = _this$getClassNames.doneClassName;
        if (type === "appear" && phase === "done" && doneClassName) className += " " + doneClassName;
         // This is to force a repaint,
        // which is necessary in order to transition styles when adding a class name.
        if (phase === "active") {
            if (node) (0, _reflow.forceReflow)(node);
        }
        if (className) {
            this.appliedClasses[type][phase] = className;
            _addClass1(node, className);
        }
    };
    _proto.removeClasses = function removeClasses(node, type) {
        var _this$appliedClasses$ = this.appliedClasses[type], baseClassName = _this$appliedClasses$.base, activeClassName = _this$appliedClasses$.active, doneClassName = _this$appliedClasses$.done;
        this.appliedClasses[type] = {};
        if (baseClassName) removeClass(node, baseClassName);
        if (activeClassName) removeClass(node, activeClassName);
        if (doneClassName) removeClass(node, doneClassName);
    };
    _proto.render = function render() {
        var _this$props = this.props, _ = _this$props.classNames, props = (0, _objectWithoutPropertiesLooseDefault.default)(_this$props, [
            "classNames"
        ]);
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _transitionDefault.default), (0, _extendsDefault.default)({}, props, {
            onEnter: this.onEnter,
            onEntered: this.onEntered,
            onEntering: this.onEntering,
            onExit: this.onExit,
            onExiting: this.onExiting,
            onExited: this.onExited
        }));
    };
    return CSSTransition;
}((0, _reactDefault.default).Component);
CSSTransition.defaultProps = {
    classNames: ""
};
CSSTransition.propTypes = {};
exports.default = CSSTransition;

},{"@babel/runtime/helpers/esm/extends":"7tw7n","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"lk4xr","@babel/runtime/helpers/esm/inheritsLoose":"l8Wa2","prop-types":"kQxDz","dom-helpers/addClass":"AmhZi","dom-helpers/removeClass":"7efoQ","react":"9yzVZ","./Transition":"f8Jv0","./utils/PropTypes":"ipdMz","./utils/reflow":"5hYzN","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"7tw7n":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_extends);
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"lk4xr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_objectWithoutPropertiesLoose);
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"l8Wa2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_inheritsLoose);
var _setPrototypeOfJs = require("./setPrototypeOf.js");
var _setPrototypeOfJsDefault = parcelHelpers.interopDefault(_setPrototypeOfJs);
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    (0, _setPrototypeOfJsDefault.default)(subClass, superClass);
}

},{"./setPrototypeOf.js":"cDBsP","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"cDBsP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_setPrototypeOf);
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"kQxDz":[function(require,module,exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var ReactIs, throwOnDirectAccess;
// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = require("e98516c5bab4526")();

},{"e98516c5bab4526":"aX0iR"}],"aX0iR":[function(require,module,exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var ReactPropTypesSecret = require("bf7f43a19ae1b960");
function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === ReactPropTypesSecret) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = "Invariant Violation";
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: emptyFunctionWithReset,
        resetWarningCache: emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

},{"bf7f43a19ae1b960":"3OcB1"}],"3OcB1":[function(require,module,exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
module.exports = ReactPropTypesSecret;

},{}],"AmhZi":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>addClass);
var _hasClass = require("./hasClass");
var _hasClassDefault = parcelHelpers.interopDefault(_hasClass);
function addClass(element, className) {
    if (element.classList) element.classList.add(className);
    else if (!(0, _hasClassDefault.default)(element, className)) {
        if (typeof element.className === "string") element.className = element.className + " " + className;
        else element.setAttribute("class", (element.className && element.className.baseVal || "") + " " + className);
    }
}

},{"./hasClass":"8lAl0","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"8lAl0":[function(require,module,exports) {
/**
 * Checks if a given element has a CSS class.
 * 
 * @param element the element
 * @param className the CSS class name
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>hasClass);
function hasClass(element, className) {
    if (element.classList) return !!className && element.classList.contains(className);
    return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"7efoQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>removeClass);
function replaceClassName(origClass, classToRemove) {
    return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", "g"), "$1").replace(/\s+/g, " ").replace(/^\s*|\s*$/g, "");
}
function removeClass(element, className) {
    if (element.classList) element.classList.remove(className);
    else if (typeof element.className === "string") element.className = replaceClassName(element.className, className);
    else element.setAttribute("class", replaceClassName(element.className && element.className.baseVal || "", className));
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"f8Jv0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "UNMOUNTED", ()=>UNMOUNTED);
parcelHelpers.export(exports, "EXITED", ()=>EXITED);
parcelHelpers.export(exports, "ENTERING", ()=>ENTERING);
parcelHelpers.export(exports, "ENTERED", ()=>ENTERED);
parcelHelpers.export(exports, "EXITING", ()=>EXITING);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _inheritsLoose = require("@babel/runtime/helpers/esm/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactDom = require("react-dom");
var _reactDomDefault = parcelHelpers.interopDefault(_reactDom);
var _config = require("./config");
var _configDefault = parcelHelpers.interopDefault(_config);
var _propTypes1 = require("./utils/PropTypes");
var _transitionGroupContext = require("./TransitionGroupContext");
var _transitionGroupContextDefault = parcelHelpers.interopDefault(_transitionGroupContext);
var _reflow = require("./utils/reflow");
var UNMOUNTED = "unmounted";
var EXITED = "exited";
var ENTERING = "entering";
var ENTERED = "entered";
var EXITING = "exiting";
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var Transition = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = EXITED;
                _this.appearStatus = ENTERING;
            } else initialStatus = ENTERED;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = UNMOUNTED;
        else initialStatus = EXITED;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === UNMOUNTED) return {
            status: EXITED
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== ENTERING && status !== ENTERED) nextStatus = ENTERING;
            } else if (status === ENTERING || status === ENTERED) nextStatus = EXITING;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== "number") {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === ENTERING) {
                if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var node = this.props.nodeRef ? this.props.nodeRef.current : (0, _reactDomDefault.default).findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
                    // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
                    // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
                    if (node) (0, _reflow.forceReflow)(node);
                }
                this.performEnter(mounting);
            } else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === EXITED) this.setState({
            status: UNMOUNTED
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, _reactDomDefault.default).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, _configDefault.default).disabled) {
            this.safeSetState({
                status: ENTERED
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: ENTERING
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: ENTERED
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, _reactDomDefault.default).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, _configDefault.default).disabled) {
            this.safeSetState({
                status: EXITED
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: EXITING
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: EXITED
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, _reactDomDefault.default).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === UNMOUNTED) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, _objectWithoutPropertiesLooseDefault.default)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, _reactDefault.default).createElement((0, _transitionGroupContextDefault.default).Provider, {
            value: null
        }, typeof children === "function" ? children(status, childProps) : (0, _reactDefault.default).cloneElement((0, _reactDefault.default).Children.only(children), childProps)));
    };
    return Transition;
}((0, _reactDefault.default).Component);
Transition.contextType = (0, _transitionGroupContextDefault.default);
Transition.propTypes = {}; // Name the function so it is clearer in the documentation
function noop() {}
Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: noop,
    onEntering: noop,
    onEntered: noop,
    onExit: noop,
    onExiting: noop,
    onExited: noop
};
Transition.UNMOUNTED = UNMOUNTED;
Transition.EXITED = EXITED;
Transition.ENTERING = ENTERING;
Transition.ENTERED = ENTERED;
Transition.EXITING = EXITING;
exports.default = Transition;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"lk4xr","@babel/runtime/helpers/esm/inheritsLoose":"l8Wa2","prop-types":"kQxDz","react":"9yzVZ","react-dom":"cEvV3","./config":"9IeIO","./utils/PropTypes":"ipdMz","./TransitionGroupContext":"apSd8","./utils/reflow":"5hYzN","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"9IeIO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = {
    disabled: false
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"ipdMz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "timeoutsShape", ()=>timeoutsShape);
parcelHelpers.export(exports, "classNamesShape", ()=>classNamesShape);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var timeoutsShape = null;
var classNamesShape = null;

},{"prop-types":"kQxDz","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"apSd8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
exports.default = (0, _reactDefault.default).createContext(null);

},{"react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"5hYzN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "forceReflow", ()=>forceReflow);
var forceReflow = function forceReflow(node) {
    return node.scrollTop;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"dKe1t":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Popover", ()=>_Popover) /**
 * More explanation on popover tips.
 * - I tried changing the calculation of the popover placement in an effort to get it squarely onto the pixel grid.
 * This did not work because the problem was in the svg partial pixel end of the path in the popover right and popover bottom.
 * - I tried creating an extra 'bandaid' path that matched the background color and would overlap the popover border.
 * This didn't work because the border on the svg triangle didn't extend all the way to match nicely with the popover border.
 * - I tried getting the client bounding box and setting the svg to that partial pixel value
 * This didn't work because again the issue was inside the svg
 * - I didn't try drawing the svg backwards
 * This could still be tried
 * - I tried changing the calculation of the popover placement AND the svg height/width so that they were all rounded
 * This seems to have done the trick.
 */ ;
var _overlays = require("@react-aria/overlays");
var _utils = require("@react-spectrum/utils");
var _interactions = require("@react-aria/interactions");
var _utils1 = require("@react-aria/utils");
var _overlay = require("./Overlay");
var _overlaysCss = require("./overlays.css");
var _overlaysCssDefault = parcelHelpers.interopDefault(_overlaysCss);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _varsCss = require("@adobe/spectrum-css-temp/components/popover/vars.css");
var _varsCssDefault = parcelHelpers.interopDefault(_varsCss);
var _underlay = require("./Underlay");
/**
 * Arrow placement can be done pointing right or down because those paths start at 0, x or y. Because the
 * other two don't, they start at a fractional pixel value, it introduces rounding differences between browsers and
 * between display types (retina with subpixels vs not retina). By flipping them with CSS we can ensure that
 * the path always starts at 0 so that it perfectly overlaps the popover's border.
 * See bottom of file for more explanation.
 */ let arrowPlacement = {
    left: "right",
    right: "right",
    top: "bottom",
    bottom: "bottom"
};
function Popover(props, ref) {
    let { children, state, ...otherProps } = props;
    let domRef = (0, _utils.useDOMRef)(ref);
    let wrapperRef = (0, _react.useRef)(null);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _overlay.Overlay), {
        ...otherProps,
        isOpen: state.isOpen,
        nodeRef: wrapperRef
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(PopoverWrapper, {
        ref: domRef,
        ...props,
        wrapperRef: wrapperRef
    }, children));
}
const PopoverWrapper = /*#__PURE__*/ (0, _react.forwardRef)((props, ref)=>{
    let { children, isOpen, hideArrow, isNonModal, enableBothDismissButtons, state, wrapperRef, onDismissButtonPress = ()=>state.close() } = props;
    let { styleProps } = (0, _utils.useStyleProps)(props);
    let { size, borderWidth, arrowRef } = useArrowSize();
    const borderRadius = usePopoverBorderRadius(ref);
    let borderDiagonal = borderWidth * Math.SQRT2;
    let primary = size + borderDiagonal;
    let secondary = primary * 2;
    let { popoverProps, arrowProps, underlayProps, placement } = (0, _overlays.usePopover)({
        ...props,
        popoverRef: ref,
        maxHeight: null,
        arrowSize: hideArrow ? 0 : secondary,
        arrowBoundaryOffset: borderRadius
    }, state);
    let { focusWithinProps } = (0, _interactions.useFocusWithin)(props);
    // Attach Transition's nodeRef to outermost wrapper for node.reflow: https://github.com/reactjs/react-transition-group/blob/c89f807067b32eea6f68fd6c622190d88ced82e2/src/Transition.js#L231
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ref: wrapperRef
    }, !isNonModal && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _underlay.Underlay), {
        isTransparent: true,
        ...(0, _utils1.mergeProps)(underlayProps),
        isOpen: isOpen
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...styleProps,
        ...(0, _utils1.mergeProps)(popoverProps, focusWithinProps),
        style: {
            ...styleProps.style,
            ...popoverProps.style
        },
        ref: ref,
        className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Popover", `spectrum-Popover--${placement}`, {
            "spectrum-Popover--withTip": !hideArrow,
            "is-open": isOpen,
            [`is-open--${placement}`]: isOpen
        }, (0, _utils.classNames)((0, _overlaysCssDefault.default), "spectrum-Popover", "react-spectrum-Popover"), styleProps.className),
        role: "presentation",
        "data-testid": "popover"
    }, (!isNonModal || enableBothDismissButtons) && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _overlays.DismissButton), {
        onDismiss: onDismissButtonPress
    }), children, hideArrow ? null : /*#__PURE__*/ (0, _reactDefault.default).createElement(Arrow, {
        arrowProps: arrowProps,
        isLandscape: arrowPlacement[placement] === "bottom",
        arrowRef: arrowRef,
        primary: primary,
        secondary: secondary,
        borderDiagonal: borderDiagonal
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _overlays.DismissButton), {
        onDismiss: onDismissButtonPress
    })));
});
function usePopoverBorderRadius(popoverRef) {
    let [borderRadius, setBorderRadius] = (0, _react.useState)(0);
    (0, _utils1.useLayoutEffect)(()=>{
        if (popoverRef.current) {
            let spectrumBorderRadius = window.getComputedStyle(popoverRef.current).borderRadius;
            if (spectrumBorderRadius !== "") setBorderRadius(parseInt(spectrumBorderRadius, 10));
        }
    }, [
        popoverRef
    ]);
    return borderRadius;
}
function useArrowSize() {
    let [size, setSize] = (0, _react.useState)(20);
    let [borderWidth, setBorderWidth] = (0, _react.useState)(1);
    let arrowRef = (0, _react.useRef)(null);
    // get the css value for the tip size and divide it by 2 for this arrow implementation
    (0, _utils1.useLayoutEffect)(()=>{
        if (arrowRef.current) {
            let spectrumTipWidth = window.getComputedStyle(arrowRef.current).getPropertyValue("--spectrum-popover-tip-size");
            if (spectrumTipWidth !== "") setSize(parseInt(spectrumTipWidth, 10) / 2);
            let spectrumBorderWidth = window.getComputedStyle(arrowRef.current).getPropertyValue("--spectrum-popover-tip-borderWidth");
            if (spectrumBorderWidth !== "") setBorderWidth(parseInt(spectrumBorderWidth, 10));
        }
    }, []);
    return {
        size,
        borderWidth,
        arrowRef
    };
}
function Arrow(props) {
    let { primary, secondary, isLandscape, arrowProps, borderDiagonal, arrowRef } = props;
    let halfBorderDiagonal = borderDiagonal / 2;
    let primaryStart = 0;
    let primaryEnd = primary - halfBorderDiagonal;
    let secondaryStart = halfBorderDiagonal;
    let secondaryMiddle = secondary / 2;
    let secondaryEnd = secondary - halfBorderDiagonal;
    let pathData = isLandscape ? [
        "M",
        secondaryStart,
        primaryStart,
        "L",
        secondaryMiddle,
        primaryEnd,
        "L",
        secondaryEnd,
        primaryStart
    ] : [
        "M",
        primaryStart,
        secondaryStart,
        "L",
        primaryEnd,
        secondaryMiddle,
        "L",
        primaryStart,
        secondaryEnd
    ];
    /* use ceil because the svg needs to always accommodate the path inside it */ return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        xmlns: "http://www.w3.org/svg/2000",
        width: Math.ceil(isLandscape ? secondary : primary),
        height: Math.ceil(isLandscape ? primary : secondary),
        className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Popover-tip"),
        ref: arrowRef,
        ...arrowProps
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Popover-tip-triangle"),
        d: pathData.join(" ")
    }));
}
let _Popover = /*#__PURE__*/ (0, _react.forwardRef)(Popover);

},{"@react-aria/overlays":"5fTCg","@react-spectrum/utils":"cMIJ6","@react-aria/interactions":"ky3G8","@react-aria/utils":"9cLk5","./Overlay":"4kHiV","./overlays.css":"7U84q","react":"9yzVZ","@adobe/spectrum-css-temp/components/popover/vars.css":"8VnVV","./Underlay":"45f2D","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"7U84q":[function(require,module,exports) {
module.exports["react-spectrum-Modal"] = `OhnpTq_react-spectrum-Modal`;
module.exports["react-spectrum-Modal-wrapper"] = `OhnpTq_react-spectrum-Modal-wrapper`;
module.exports["react-spectrum-Popover"] = `OhnpTq_react-spectrum-Popover`;
module.exports["react-spectrum-Tray"] = `OhnpTq_react-spectrum-Tray`;
module.exports["spectrum-Dialog-content"] = `OhnpTq_spectrum-Dialog-content`;
module.exports["spectrum-Modal"] = `OhnpTq_spectrum-Modal`;
module.exports["spectrum-Modal-wrapper"] = `OhnpTq_spectrum-Modal-wrapper`;
module.exports["spectrum-Popover"] = `OhnpTq_spectrum-Popover`;
module.exports["spectrum-Tray"] = `OhnpTq_spectrum-Tray`;

},{}],"8VnVV":[function(require,module,exports) {
module.exports["focus-ring"] = `cH0MeW_focus-ring`;
module.exports["i18nFontFamily"] = `cH0MeW_i18nFontFamily`;
module.exports["spectrum-overlay--open"] = `cH0MeW_spectrum-overlay--open`;
module.exports["is-open"] = `cH0MeW_is-open ${module.exports["spectrum-overlay--open"]}`;
module.exports["spectrum-overlay--bottom--open"] = `cH0MeW_spectrum-overlay--bottom--open`;
module.exports["is-open--bottom"] = `cH0MeW_is-open--bottom ${module.exports["spectrum-overlay--bottom--open"]}`;
module.exports["spectrum-overlay--left--open"] = `cH0MeW_spectrum-overlay--left--open`;
module.exports["is-open--left"] = `cH0MeW_is-open--left ${module.exports["spectrum-overlay--left--open"]}`;
module.exports["spectrum-overlay--right--open"] = `cH0MeW_spectrum-overlay--right--open`;
module.exports["is-open--right"] = `cH0MeW_is-open--right ${module.exports["spectrum-overlay--right--open"]}`;
module.exports["spectrum-overlay--top--open"] = `cH0MeW_spectrum-overlay--top--open`;
module.exports["is-open--top"] = `cH0MeW_is-open--top ${module.exports["spectrum-overlay--top--open"]}`;
module.exports["spectrum-FocusRing-ring"] = `cH0MeW_spectrum-FocusRing-ring`;
module.exports["spectrum-FocusRing"] = `cH0MeW_spectrum-FocusRing ${module.exports["spectrum-FocusRing-ring"]}`;
module.exports["spectrum-FocusRing--quiet"] = `cH0MeW_spectrum-FocusRing--quiet`;
module.exports["spectrum-overlay"] = `cH0MeW_spectrum-overlay`;
module.exports["spectrum-Popover"] = `cH0MeW_spectrum-Popover ${module.exports["spectrum-overlay"]}`;
module.exports["spectrum-Popover--bottom"] = `cH0MeW_spectrum-Popover--bottom`;
module.exports["spectrum-Popover--dialog"] = `cH0MeW_spectrum-Popover--dialog`;
module.exports["spectrum-Popover--left"] = `cH0MeW_spectrum-Popover--left`;
module.exports["spectrum-Popover--right"] = `cH0MeW_spectrum-Popover--right`;
module.exports["spectrum-Popover--top"] = `cH0MeW_spectrum-Popover--top`;
module.exports["spectrum-Popover--withTip"] = `cH0MeW_spectrum-Popover--withTip`;
module.exports["spectrum-Popover-tip"] = `cH0MeW_spectrum-Popover-tip`;
module.exports["spectrum-Popover-tip-triangle"] = `cH0MeW_spectrum-Popover-tip-triangle`;

},{}],"45f2D":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Underlay", ()=>Underlay);
var _utils = require("@react-spectrum/utils");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _varsCss = require("@adobe/spectrum-css-temp/components/underlay/vars.css");
var _varsCssDefault = parcelHelpers.interopDefault(_varsCss);
function Underlay({ isOpen, isTransparent, ...otherProps }) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        "data-testid": "underlay",
        ...otherProps,
        className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Underlay", {
            "is-open": isOpen,
            "spectrum-Underlay--transparent": isTransparent
        })
    });
}

},{"@react-spectrum/utils":"cMIJ6","react":"9yzVZ","@adobe/spectrum-css-temp/components/underlay/vars.css":"kSsUh","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"kSsUh":[function(require,module,exports) {
module.exports["focus-ring"] = `F-oYUa_focus-ring`;
module.exports["i18nFontFamily"] = `F-oYUa_i18nFontFamily`;
module.exports["spectrum-overlay--open"] = `F-oYUa_spectrum-overlay--open`;
module.exports["is-open"] = `F-oYUa_is-open ${module.exports["spectrum-overlay--open"]}`;
module.exports["spectrum-FocusRing-ring"] = `F-oYUa_spectrum-FocusRing-ring`;
module.exports["spectrum-FocusRing"] = `F-oYUa_spectrum-FocusRing ${module.exports["spectrum-FocusRing-ring"]}`;
module.exports["spectrum-FocusRing--quiet"] = `F-oYUa_spectrum-FocusRing--quiet`;
module.exports["spectrum-overlay"] = `F-oYUa_spectrum-overlay`;
module.exports["spectrum-Underlay"] = `F-oYUa_spectrum-Underlay ${module.exports["spectrum-overlay"]}`;
module.exports["spectrum-Underlay--transparent"] = `F-oYUa_spectrum-Underlay--transparent`;
module.exports["spectrum-overlay--bottom--open"] = `F-oYUa_spectrum-overlay--bottom--open`;
module.exports["spectrum-overlay--left--open"] = `F-oYUa_spectrum-overlay--left--open`;
module.exports["spectrum-overlay--right--open"] = `F-oYUa_spectrum-overlay--right--open`;
module.exports["spectrum-overlay--top--open"] = `F-oYUa_spectrum-overlay--top--open`;

},{}],"9FO5g":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Modal", ()=>_Modal);
var _overlays = require("@react-aria/overlays");
var _utils = require("@react-spectrum/utils");
var _varsCss = require("@adobe/spectrum-css-temp/components/modal/vars.css");
var _varsCssDefault = parcelHelpers.interopDefault(_varsCss);
var _overlay = require("./Overlay");
var _overlaysCss = require("./overlays.css");
var _overlaysCssDefault = parcelHelpers.interopDefault(_overlaysCss);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _underlay = require("./Underlay");
var _utils1 = require("@react-aria/utils");
function Modal(props, ref) {
    let { children, state, ...otherProps } = props;
    let domRef = (0, _utils.useDOMRef)(ref);
    let wrapperRef = (0, _react.useRef)(null);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _overlay.Overlay), {
        ...otherProps,
        isOpen: state.isOpen,
        nodeRef: wrapperRef
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(ModalWrapper, {
        ...props,
        wrapperRef: wrapperRef,
        ref: domRef
    }, children));
}
let typeMap = {
    fullscreen: "fullscreen",
    fullscreenTakeover: "fullscreenTakeover"
};
let ModalWrapper = /*#__PURE__*/ (0, _react.forwardRef)(function(props, ref) {
    let { type, children, state, isOpen, wrapperRef } = props;
    let typeVariant = typeMap[type];
    let { styleProps } = (0, _utils.useStyleProps)(props);
    let { modalProps, underlayProps } = (0, _overlays.useModalOverlay)(props, state, ref);
    let wrapperClassName = (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Modal-wrapper", (0, _utils.classNames)((0, _overlaysCssDefault.default), "spectrum-Modal-wrapper", "react-spectrum-Modal-wrapper"));
    let modalClassName = (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Modal", {
        "is-open": isOpen
    }, (0, _utils.classNames)((0, _overlaysCssDefault.default), "spectrum-Modal", "react-spectrum-Modal"), {
        [`spectrum-Modal--${typeVariant}`]: typeVariant
    }, styleProps.className);
    let viewport = (0, _utils1.useViewportSize)();
    let style = {
        "--spectrum-visual-viewport-height": viewport.height + "px"
    };
    // Attach Transition's nodeRef to outer most wrapper for node.reflow: https://github.com/reactjs/react-transition-group/blob/c89f807067b32eea6f68fd6c622190d88ced82e2/src/Transition.js#L231
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ref: wrapperRef
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _underlay.Underlay), {
        ...underlayProps,
        isOpen: isOpen
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: wrapperClassName,
        style: style
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...styleProps,
        ...modalProps,
        ref: ref,
        className: modalClassName,
        "data-testid": "modal"
    }, children)));
});
let _Modal = /*#__PURE__*/ (0, _react.forwardRef)(Modal);

},{"@react-aria/overlays":"5fTCg","@react-spectrum/utils":"cMIJ6","@adobe/spectrum-css-temp/components/modal/vars.css":"04tCh","./Overlay":"4kHiV","./overlays.css":"7U84q","react":"9yzVZ","./Underlay":"45f2D","@react-aria/utils":"9cLk5","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"04tCh":[function(require,module,exports) {
module.exports["focus-ring"] = `_0YML2q_focus-ring`;
module.exports["i18nFontFamily"] = `_0YML2q_i18nFontFamily`;
module.exports["spectrum-overlay--open"] = `_0YML2q_spectrum-overlay--open`;
module.exports["is-open"] = `_0YML2q_is-open ${module.exports["spectrum-overlay--open"]}`;
module.exports["spectrum-FocusRing-ring"] = `_0YML2q_spectrum-FocusRing-ring`;
module.exports["spectrum-FocusRing"] = `_0YML2q_spectrum-FocusRing ${module.exports["spectrum-FocusRing-ring"]}`;
module.exports["spectrum-FocusRing--quiet"] = `_0YML2q_spectrum-FocusRing--quiet`;
module.exports["spectrum-overlay"] = `_0YML2q_spectrum-overlay`;
module.exports["spectrum-Modal"] = `_0YML2q_spectrum-Modal ${module.exports["spectrum-overlay"]}`;
module.exports["spectrum-Modal--fullscreen"] = `_0YML2q_spectrum-Modal--fullscreen`;
module.exports["spectrum-Modal--fullscreenTakeover"] = `_0YML2q_spectrum-Modal--fullscreenTakeover`;
module.exports["spectrum-Modal--responsive"] = `_0YML2q_spectrum-Modal--responsive`;
module.exports["spectrum-Modal-wrapper"] = `_0YML2q_spectrum-Modal-wrapper`;
module.exports["spectrum-overlay--bottom--open"] = `_0YML2q_spectrum-overlay--bottom--open`;
module.exports["spectrum-overlay--left--open"] = `_0YML2q_spectrum-overlay--left--open`;
module.exports["spectrum-overlay--right--open"] = `_0YML2q_spectrum-overlay--right--open`;
module.exports["spectrum-overlay--top--open"] = `_0YML2q_spectrum-overlay--top--open`;

},{}],"l6GDo":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Tray", ()=>_Tray);
var _overlays = require("@react-aria/overlays");
var _utils = require("@react-spectrum/utils");
var _overlay = require("./Overlay");
var _overlaysCss = require("./overlays.css");
var _overlaysCssDefault = parcelHelpers.interopDefault(_overlaysCss);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _varsCss = require("@adobe/spectrum-css-temp/components/tray/vars.css");
var _varsCssDefault = parcelHelpers.interopDefault(_varsCss);
var _underlay = require("./Underlay");
var _utils1 = require("@react-aria/utils");
function Tray(props, ref) {
    let { children, state, ...otherProps } = props;
    let domRef = (0, _utils.useDOMRef)(ref);
    let wrapperRef = (0, _react.useRef)(null);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _overlay.Overlay), {
        ...otherProps,
        isOpen: state.isOpen,
        nodeRef: wrapperRef
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(TrayWrapper, {
        ...props,
        wrapperRef: wrapperRef,
        ref: domRef
    }, children));
}
let TrayWrapper = /*#__PURE__*/ (0, _react.forwardRef)(function(props, ref) {
    let { children, isOpen, isFixedHeight, state, wrapperRef } = props;
    let { styleProps } = (0, _utils.useStyleProps)(props);
    let { modalProps, underlayProps } = (0, _overlays.useModalOverlay)({
        ...props,
        isDismissable: true
    }, state, ref);
    // We need to measure the window's height in JS rather than using percentages in CSS
    // so that contents (e.g. menu) can inherit the max-height properly. Using percentages
    // does not work properly because there is nothing to base the percentage on.
    // We cannot use vh units because mobile browsers adjust the window height dynamically
    // when the address bar/bottom toolbars show and hide on scroll and vh units are fixed.
    // Also, the visual viewport is smaller than the layout viewport when the virtual keyboard
    // is up, so use the VisualViewport API to ensure the tray is displayed above the keyboard.
    let viewport = (0, _utils1.useViewportSize)();
    let wrapperStyle = {
        "--spectrum-visual-viewport-height": viewport.height + "px"
    };
    let wrapperClassName = (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Tray-wrapper");
    let className = (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Tray", {
        "is-open": isOpen,
        "spectrum-Tray--fixedHeight": isFixedHeight
    }, (0, _utils.classNames)((0, _overlaysCssDefault.default), "spectrum-Tray", "react-spectrum-Tray"), styleProps.className);
    // Attach Transition's nodeRef to outer most wrapper for node.reflow: https://github.com/reactjs/react-transition-group/blob/c89f807067b32eea6f68fd6c622190d88ced82e2/src/Transition.js#L231
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ref: wrapperRef
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _underlay.Underlay), {
        ...underlayProps,
        isOpen: isOpen
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: wrapperClassName,
        style: wrapperStyle
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...styleProps,
        ...modalProps,
        className: className,
        ref: ref,
        "data-testid": "tray"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _overlays.DismissButton), {
        onDismiss: state.close
    }), children, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _overlays.DismissButton), {
        onDismiss: state.close
    }))));
});
let _Tray = /*#__PURE__*/ (0, _react.forwardRef)(Tray);

},{"@react-aria/overlays":"5fTCg","@react-spectrum/utils":"cMIJ6","./Overlay":"4kHiV","./overlays.css":"7U84q","react":"9yzVZ","@adobe/spectrum-css-temp/components/tray/vars.css":"f3Ws9","./Underlay":"45f2D","@react-aria/utils":"9cLk5","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"f3Ws9":[function(require,module,exports) {
module.exports["focus-ring"] = `UuxJvG_focus-ring`;
module.exports["i18nFontFamily"] = `UuxJvG_i18nFontFamily`;
module.exports["spectrum-overlay--open"] = `UuxJvG_spectrum-overlay--open`;
module.exports["is-open"] = `UuxJvG_is-open ${module.exports["spectrum-overlay--open"]}`;
module.exports["spectrum-FocusRing-ring"] = `UuxJvG_spectrum-FocusRing-ring`;
module.exports["spectrum-FocusRing"] = `UuxJvG_spectrum-FocusRing ${module.exports["spectrum-FocusRing-ring"]}`;
module.exports["spectrum-FocusRing--quiet"] = `UuxJvG_spectrum-FocusRing--quiet`;
module.exports["spectrum-overlay"] = `UuxJvG_spectrum-overlay`;
module.exports["spectrum-Tray"] = `UuxJvG_spectrum-Tray ${module.exports["spectrum-overlay"]}`;
module.exports["spectrum-Tray--fixedHeight"] = `UuxJvG_spectrum-Tray--fixedHeight`;
module.exports["spectrum-Tray-wrapper"] = `UuxJvG_spectrum-Tray-wrapper`;
module.exports["spectrum-overlay--bottom--open"] = `UuxJvG_spectrum-overlay--bottom--open`;
module.exports["spectrum-overlay--left--open"] = `UuxJvG_spectrum-overlay--left--open`;
module.exports["spectrum-overlay--right--open"] = `UuxJvG_spectrum-overlay--right--open`;
module.exports["spectrum-overlay--top--open"] = `UuxJvG_spectrum-overlay--top--open`;

},{}],"gqElf":[function(require,module,exports) {
module.exports["checkmark"] = `Q7FggG_checkmark`;
module.exports["chevron"] = `Q7FggG_chevron`;
module.exports["description"] = `Q7FggG_description`;
module.exports["end"] = `Q7FggG_end`;
module.exports["focus-ring"] = `Q7FggG_focus-ring`;
module.exports["i18nFontFamily"] = `Q7FggG_i18nFontFamily`;
module.exports["icon"] = `Q7FggG_icon`;
module.exports["is-active"] = `Q7FggG_is-active`;
module.exports["is-disabled"] = `Q7FggG_is-disabled`;
module.exports["is-expanded"] = `Q7FggG_is-expanded`;
module.exports["is-focused"] = `Q7FggG_is-focused`;
module.exports["is-highlighted"] = `Q7FggG_is-highlighted`;
module.exports["is-hovered"] = `Q7FggG_is-hovered`;
module.exports["is-open"] = `Q7FggG_is-open`;
module.exports["is-selectable"] = `Q7FggG_is-selectable`;
module.exports["is-selected"] = `Q7FggG_is-selected`;
module.exports["keyboard"] = `Q7FggG_keyboard`;
module.exports["spectrum-FocusRing-ring"] = `Q7FggG_spectrum-FocusRing-ring`;
module.exports["spectrum-FocusRing"] = `Q7FggG_spectrum-FocusRing ${module.exports["spectrum-FocusRing-ring"]}`;
module.exports["spectrum-FocusRing--quiet"] = `Q7FggG_spectrum-FocusRing--quiet`;
module.exports["spectrum-Icon"] = `Q7FggG_spectrum-Icon`;
module.exports["spectrum-Menu"] = `Q7FggG_spectrum-Menu`;
module.exports["spectrum-Menu-avatar"] = `Q7FggG_spectrum-Menu-avatar`;
module.exports["spectrum-Menu-checkmark"] = `Q7FggG_spectrum-Menu-checkmark`;
module.exports["spectrum-Menu-chevron"] = `Q7FggG_spectrum-Menu-chevron`;
module.exports["spectrum-Menu-description"] = `Q7FggG_spectrum-Menu-description`;
module.exports["spectrum-Menu-divider"] = `Q7FggG_spectrum-Menu-divider`;
module.exports["spectrum-Menu-end"] = `Q7FggG_spectrum-Menu-end`;
module.exports["spectrum-Menu-icon"] = `Q7FggG_spectrum-Menu-icon`;
module.exports["spectrum-Menu-item"] = `Q7FggG_spectrum-Menu-item`;
module.exports["spectrum-Menu-itemGrid"] = `Q7FggG_spectrum-Menu-itemGrid`;
module.exports["spectrum-Menu-itemIcon"] = `Q7FggG_spectrum-Menu-itemIcon`;
module.exports["spectrum-Menu-itemLabel"] = `Q7FggG_spectrum-Menu-itemLabel`;
module.exports["spectrum-Menu-itemLabel--wrapping"] = `Q7FggG_spectrum-Menu-itemLabel--wrapping`;
module.exports["spectrum-Menu-keyboard"] = `Q7FggG_spectrum-Menu-keyboard`;
module.exports["spectrum-Menu-popover"] = `Q7FggG_spectrum-Menu-popover`;
module.exports["spectrum-Menu-section--isFirst"] = `Q7FggG_spectrum-Menu-section--isFirst`;
module.exports["spectrum-Menu-section--isLast"] = `Q7FggG_spectrum-Menu-section--isLast`;
module.exports["spectrum-Menu-section--noHeading"] = `Q7FggG_spectrum-Menu-section--noHeading`;
module.exports["spectrum-Menu-sectionHeading"] = `Q7FggG_spectrum-Menu-sectionHeading`;
module.exports["spectrum-Menu-subdialog"] = `Q7FggG_spectrum-Menu-subdialog`;
module.exports["spectrum-Menu-wrapper"] = `Q7FggG_spectrum-Menu-wrapper`;
module.exports["spectrum-Menu-wrapper--isMobile"] = `Q7FggG_spectrum-Menu-wrapper--isMobile`;
module.exports["spectrum-Submenu-heading"] = `Q7FggG_spectrum-Submenu-heading`;
module.exports["spectrum-Submenu-headingWrapper"] = `Q7FggG_spectrum-Submenu-headingWrapper`;
module.exports["spectrum-Submenu-popover"] = `Q7FggG_spectrum-Submenu-popover`;
module.exports["spectrum-Submenu-wrapper"] = `Q7FggG_spectrum-Submenu-wrapper`;
module.exports["text"] = `Q7FggG_text`;

},{}],"hg3eM":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SubmenuTrigger", ()=>_SubmenuTrigger);
var _utils = require("@react-spectrum/utils");
var _context = require("./context");
var _utils1 = require("@react-aria/utils");
var _overlays = require("@react-spectrum/overlays");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactDom = require("react-dom");
var _reactDomDefault = parcelHelpers.interopDefault(_reactDom);
var _varsCss = require("@adobe/spectrum-css-temp/components/menu/vars.css");
var _varsCssDefault = parcelHelpers.interopDefault(_varsCss);
var _menu = require("@react-aria/menu");
var _menu1 = require("@react-stately/menu");
var _i18N = require("@react-aria/i18n");
function SubmenuTrigger(props) {
    let triggerRef = (0, _react.useRef)();
    let { children, targetKey } = props;
    let [menuTrigger, menu] = (0, _reactDefault.default).Children.toArray(children);
    let { popoverContainer, trayContainerRef, menu: parentMenuRef, submenu: menuRef, rootMenuTriggerState, state } = (0, _context.useMenuStateContext)();
    let triggerNode = state.collection.getItem(targetKey);
    let submenuTriggerState = (0, _menu1.UNSTABLE_useSubmenuTriggerState)({
        triggerKey: targetKey
    }, rootMenuTriggerState);
    let { submenuTriggerProps, submenuProps, popoverProps } = (0, _menu.UNSTABLE_useSubmenuTrigger)({
        node: triggerNode,
        parentMenuRef,
        submenuRef: menuRef
    }, submenuTriggerState, triggerRef);
    let isMobile = (0, _utils.useIsMobileDevice)();
    let onBackButtonPress = ()=>{
        submenuTriggerState.close();
        if (parentMenuRef.current && !parentMenuRef.current.contains(document.activeElement)) parentMenuRef.current.focus();
    };
    let { direction } = (0, _i18N.useLocale)();
    let mobileSubmenuKeyDown = (e)=>{
        switch(e.key){
            case "ArrowLeft":
                if (direction === "ltr") triggerRef.current.focus();
                break;
            case "ArrowRight":
                if (direction === "rtl") triggerRef.current.focus();
                break;
        }
    };
    let overlay;
    let [offset, setOffset] = (0, _react.useState)(0);
    (0, _utils1.useLayoutEffect)(()=>{
        if (parentMenuRef.current) {
            var _window_getComputedStyle, _window;
            let offset = (_window = window) === null || _window === void 0 ? void 0 : (_window_getComputedStyle = _window.getComputedStyle(parentMenuRef === null || parentMenuRef === void 0 ? void 0 : parentMenuRef.current)) === null || _window_getComputedStyle === void 0 ? void 0 : _window_getComputedStyle.getPropertyValue("--spectrum-submenu-offset-distance");
            if (offset !== "") setOffset(-1 * parseInt(offset, 10));
        }
    }, [
        parentMenuRef
    ]);
    if (isMobile) {
        var _submenuProps;
        delete submenuTriggerProps.onBlur;
        delete submenuTriggerProps.onHoverChange;
        var _autoFocus;
        (_autoFocus = (_submenuProps = submenuProps).autoFocus) !== null && _autoFocus !== void 0 ? _autoFocus : _submenuProps.autoFocus = true;
        if (trayContainerRef.current && submenuTriggerState.isOpen) overlay = /*#__PURE__*/ (0, _reactDomDefault.default).createPortal(menu, trayContainerRef.current);
    } else {
        let onDismissButtonPress = ()=>{
            var _parentMenuRef_current;
            submenuTriggerState.close();
            (_parentMenuRef_current = parentMenuRef.current) === null || _parentMenuRef_current === void 0 ? void 0 : _parentMenuRef_current.focus();
        };
        overlay = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _overlays.Popover), {
            ...popoverProps,
            onDismissButtonPress: onDismissButtonPress,
            UNSAFE_className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Submenu-popover"),
            container: popoverContainer,
            containerPadding: 0,
            crossOffset: offset,
            offset: offset,
            enableBothDismissButtons: true,
            UNSAFE_style: {
                clipPath: "unset",
                overflow: "visible",
                borderWidth: "0px"
            },
            state: submenuTriggerState,
            triggerRef: triggerRef,
            scrollRef: menuRef,
            placement: "end top",
            hideArrow: true
        }, menu);
    }
    let menuContext = {
        ...(0, _utils1.mergeProps)(submenuProps, {
            ref: menuRef,
            UNSAFE_style: isMobile ? {
                width: "100%",
                maxHeight: "inherit"
            } : undefined,
            UNSAFE_className: (0, _utils.classNames)((0, _varsCssDefault.default), {
                "spectrum-Menu-popover": !isMobile
            }),
            ...isMobile && {
                onBackButtonPress,
                onKeyDown: mobileSubmenuKeyDown
            }
        })
    };
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _context.SubmenuTriggerContext).Provider, {
        value: {
            triggerRef,
            ...submenuTriggerProps
        }
    }, menuTrigger), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _context.MenuContext).Provider, {
        value: menuContext
    }, overlay));
}
SubmenuTrigger.getCollectionNode = function*(props) {
    let childArray = [];
    (0, _reactDefault.default).Children.forEach(props.children, (child)=>{
        if (/*#__PURE__*/ (0, _reactDefault.default).isValidElement(child)) childArray.push(child);
    });
    let [trigger] = childArray;
    let [, content] = props.children;
    yield {
        element: /*#__PURE__*/ (0, _reactDefault.default).cloneElement(trigger, {
            ...trigger.props,
            hasChildItems: true,
            isTrigger: true
        }),
        wrapper: (element)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(SubmenuTrigger, {
                key: element.key,
                targetKey: element.key,
                ...props
            }, element, content)
    };
};
let _SubmenuTrigger = SubmenuTrigger;

},{"@react-spectrum/utils":"cMIJ6","./context":"fEXAZ","@react-aria/utils":"9cLk5","@react-spectrum/overlays":"3nwGn","react":"9yzVZ","react-dom":"cEvV3","@adobe/spectrum-css-temp/components/menu/vars.css":"gqElf","@react-aria/menu":"89bvn","@react-stately/menu":"iqDQI","@react-aria/i18n":"411rg","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"4Thgz":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TrayHeaderWrapper", ()=>TrayHeaderWrapper);
parcelHelpers.export(exports, "Menu", ()=>_Menu);
var _button = require("@react-spectrum/button");
var _arrowDownSmall = require("@spectrum-icons/ui/ArrowDownSmall");
var _arrowDownSmallDefault = parcelHelpers.interopDefault(_arrowDownSmall);
var _utils = require("@react-spectrum/utils");
var _focus = require("@react-aria/focus");
// @ts-ignore
var _json = require("../intl/*.json");
var _jsonDefault = parcelHelpers.interopDefault(_json);
var _context = require("./context");
var _menuItem = require("./MenuItem");
var _menuSection = require("./MenuSection");
var _utils1 = require("@react-aria/utils");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _varsCss = require("@adobe/spectrum-css-temp/components/menu/vars.css");
var _varsCssDefault = parcelHelpers.interopDefault(_varsCss);
var _interactions = require("@react-aria/interactions");
var _i18N = require("@react-aria/i18n");
var _menu = require("@react-aria/menu");
var _tree = require("@react-stately/tree");
function Menu(props, ref) {
    let isSubmenu = true;
    let contextProps = (0, _react.useContext)((0, _context.MenuContext));
    let parentMenuContext = (0, _context.useMenuStateContext)();
    let { rootMenuTriggerState, state: parentMenuTreeState } = parentMenuContext || {
        rootMenuTriggerState: contextProps.state
    };
    if (!parentMenuContext) isSubmenu = false;
    let completeProps = {
        ...(0, _utils1.mergeProps)(contextProps, props)
    };
    let domRef = (0, _utils.useDOMRef)(ref);
    let [popoverContainer, setPopoverContainer] = (0, _react.useState)(null);
    let trayContainerRef = (0, _react.useRef)(null);
    let state = (0, _tree.useTreeState)(completeProps);
    let submenuRef = (0, _react.useRef)(null);
    let { menuProps } = (0, _menu.useMenu)(completeProps, state, domRef);
    let { styleProps } = (0, _utils.useStyleProps)(completeProps);
    (0, _utils1.useSyncRef)(contextProps, domRef);
    let [leftOffset, setLeftOffset] = (0, _react.useState)({
        left: 0
    });
    let prevPopoverContainer = (0, _react.useRef)(null);
    (0, _react.useEffect)(()=>{
        if (popoverContainer && prevPopoverContainer.current !== popoverContainer && leftOffset.left === 0) {
            prevPopoverContainer.current = popoverContainer;
            let { left } = popoverContainer.getBoundingClientRect();
            setLeftOffset({
                left: -1 * left
            });
        }
    }, [
        leftOffset,
        popoverContainer
    ]);
    var _contextProps_submenuLevel;
    let menuLevel = (_contextProps_submenuLevel = contextProps.submenuLevel) !== null && _contextProps_submenuLevel !== void 0 ? _contextProps_submenuLevel : -1;
    let hasOpenSubmenu = state.collection.getItem(rootMenuTriggerState === null || rootMenuTriggerState === void 0 ? void 0 : rootMenuTriggerState.UNSTABLE_expandedKeysStack[menuLevel + 1]) != null;
    (0, _interactions.useInteractOutside)({
        ref: domRef,
        onInteractOutside: (e)=>{
            var _trayContainerRef_current;
            if (!(popoverContainer === null || popoverContainer === void 0 ? void 0 : popoverContainer.contains(e.target)) && !((_trayContainerRef_current = trayContainerRef.current) === null || _trayContainerRef_current === void 0 ? void 0 : _trayContainerRef_current.contains(e.target))) rootMenuTriggerState.close();
        },
        isDisabled: isSubmenu || !hasOpenSubmenu
    });
    // TODO: add slide transition
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _context.MenuStateContext).Provider, {
        value: {
            popoverContainer,
            trayContainerRef,
            menu: domRef,
            submenu: submenuRef,
            rootMenuTriggerState,
            state
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        style: {
            height: hasOpenSubmenu ? "100%" : undefined
        },
        ref: trayContainerRef
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _focus.FocusScope), null, /*#__PURE__*/ (0, _reactDefault.default).createElement(TrayHeaderWrapper, {
        onBackButtonPress: contextProps.onBackButtonPress,
        hasOpenSubmenu: hasOpenSubmenu,
        isSubmenu: isSubmenu,
        parentMenuTreeState: parentMenuTreeState,
        rootMenuTriggerState: rootMenuTriggerState
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...menuProps,
        style: (0, _utils1.mergeProps)(styleProps.style, menuProps.style),
        ref: domRef,
        className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Menu", styleProps.className)
    }, [
        ...state.collection
    ].map((item)=>{
        if (item.type === "section") return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _menuSection.MenuSection), {
            key: item.key,
            item: item,
            state: state,
            onAction: completeProps.onAction
        });
        let menuItem = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _menuItem.MenuItem), {
            key: item.key,
            item: item,
            state: state,
            onAction: completeProps.onAction
        });
        if (item.wrapper) menuItem = item.wrapper(menuItem);
        return menuItem;
    }))), (rootMenuTriggerState === null || rootMenuTriggerState === void 0 ? void 0 : rootMenuTriggerState.isOpen) && /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ref: setPopoverContainer,
        style: {
            width: "100vw",
            position: "absolute",
            top: -5,
            ...leftOffset
        }
    })));
}
function TrayHeaderWrapper(props) {
    var _parentMenuTreeState_collection_getItem;
    let { children, isSubmenu, hasOpenSubmenu, parentMenuTreeState, rootMenuTriggerState, onBackButtonPress, wrapperKeyDown } = props;
    let stringFormatter = (0, _i18N.useLocalizedStringFormatter)((0, _jsonDefault.default), "@react-spectrum/menu");
    let backButtonText = parentMenuTreeState === null || parentMenuTreeState === void 0 ? void 0 : (_parentMenuTreeState_collection_getItem = parentMenuTreeState.collection.getItem(rootMenuTriggerState === null || rootMenuTriggerState === void 0 ? void 0 : rootMenuTriggerState.UNSTABLE_expandedKeysStack.slice(-1)[0])) === null || _parentMenuTreeState_collection_getItem === void 0 ? void 0 : _parentMenuTreeState_collection_getItem.textValue;
    let backButtonLabel = stringFormatter.format("backButton", {
        prevMenuButton: backButtonText
    });
    let headingId = (0, _utils1.useSlotId)();
    let isMobile = (0, _utils.useIsMobileDevice)();
    let { direction } = (0, _i18N.useLocale)();
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        role: headingId ? "dialog" : undefined,
        "aria-labelledby": headingId,
        "aria-hidden": isMobile && hasOpenSubmenu,
        "data-testid": "menu-wrapper",
        className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Menu-wrapper", {
            "spectrum-Menu-wrapper--isMobile": isMobile,
            "is-expanded": hasOpenSubmenu
        })
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        role: "presentation",
        className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Submenu-wrapper"),
        onKeyDown: wrapperKeyDown
    }, isMobile && isSubmenu && !hasOpenSubmenu && /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Submenu-headingWrapper")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), {
        "aria-label": backButtonLabel,
        isQuiet: true,
        onPress: onBackButtonPress
    }, direction === "rtl" ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _arrowDownSmallDefault.default), {
        UNSAFE_style: {
            rotate: "270deg"
        }
    }) : /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _arrowDownSmallDefault.default), {
        UNSAFE_style: {
            rotate: "90deg"
        }
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("h1", {
        id: headingId,
        className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Submenu-heading")
    }, backButtonText)), children)));
}
/**
 * Menus display a list of actions or options that a user can choose.
 */ // forwardRef doesn't support generic parameters, so cast the result to the correct type
// https://stackoverflow.com/questions/58469229/react-with-typescript-generics-while-using-react-forwardref
const _Menu = /*#__PURE__*/ (0, _reactDefault.default).forwardRef(Menu);

},{"@react-spectrum/button":"jZWyP","@spectrum-icons/ui/ArrowDownSmall":"2XOFR","@react-spectrum/utils":"cMIJ6","@react-aria/focus":"42mbF","../intl/*.json":"9AOsG","./context":"fEXAZ","./MenuItem":"5OAuV","./MenuSection":"iIYBg","@react-aria/utils":"9cLk5","react":"9yzVZ","@adobe/spectrum-css-temp/components/menu/vars.css":"gqElf","@react-aria/interactions":"ky3G8","@react-aria/i18n":"411rg","@react-aria/menu":"89bvn","@react-stately/tree":"f1QlQ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"2XOFR":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("26884f397f557c35");
exports.__esModule = true;
exports.default = ArrowDownSmall;
var _ArrowDownSmall = require("2655c33f5372dd2a");
var _icon = require("e9236e685cf6b78");
var _react = _interopRequireDefault(require("748aa7a67593836e"));
function ArrowDownSmall(props) {
    return /*#__PURE__*/ _react.default.createElement(_icon.UIIcon, props, /*#__PURE__*/ _react.default.createElement(_ArrowDownSmall.ArrowDownSmall, null));
}

},{"26884f397f557c35":"iHubQ","2655c33f5372dd2a":"kjvph","e9236e685cf6b78":"k7wem","748aa7a67593836e":"9yzVZ"}],"kjvph":[function(require,module,exports) {
/**
* @adobe/react-spectrum-ui (c) by Adobe
* 
* @adobe/react-spectrum-ui is licensed under a
* Creative Commons Attribution-NoDerivatives 4.0 International License.
* 
* You should have received a copy of the license along with this
* work. If not, see <http://creativecommons.org/licenses/by-nd/4.0/>.
**/ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ArrowDownSmall = ArrowDownSmall;
var _react = _interopRequireDefault(require("ff83b9b31f609ba1"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function ArrowDownSmall(_ref) {
    var _ref$scale = _ref.scale, scale = _ref$scale === void 0 ? "M" : _ref$scale, props = _objectWithoutProperties(_ref, [
        "scale"
    ]);
    return _react["default"].createElement("svg", _extends({}, props, props), scale === "L" && _react["default"].createElement("path", {
        d: "M9.99 7.01a1 1 0 0 0-1.707-.707L6 8.586V1.01a1 1 0 0 0-2 0v7.576L1.717 6.303A1 1 0 1 0 .303 7.717l3.99 3.98a1 1 0 0 0 1.414 0l3.99-3.98a.997.997 0 0 0 .293-.707z"
    }), scale === "M" && _react["default"].createElement("path", {
        d: "M7.99 6.01a1 1 0 0 0-1.707-.707L5 6.586V1a1 1 0 0 0-2 0v5.586L1.717 5.303A1 1 0 1 0 .303 6.717l2.99 2.98a1 1 0 0 0 1.414 0l2.99-2.98a.997.997 0 0 0 .293-.707z"
    }));
}
ArrowDownSmall.displayName = "ArrowDownSmall";

},{"ff83b9b31f609ba1":"9yzVZ"}],"9AOsG":[function(require,module,exports) {
const _temp0 = require("6757af74e06e5a37");
const _temp1 = require("757092ddc87a8d83");
const _temp2 = require("31524657eb201d1f");
const _temp3 = require("be825a666165c65");
const _temp4 = require("89b4d428f0c494ab");
const _temp5 = require("c60a1094adf6f91c");
const _temp6 = require("5e823c4821c37dbd");
const _temp7 = require("7334bb387fbb541f");
const _temp8 = require("4c3cd4fdfc046119");
const _temp9 = require("cf505e827d20e1b1");
const _temp10 = require("6941570aab32b778");
const _temp11 = require("b40652ff57984a01");
const _temp12 = require("fdfa3df927c9ca4e");
const _temp13 = require("b11330535a3a5ab6");
const _temp14 = require("8027cccb357f724");
const _temp15 = require("4a77502c71bbcbe");
const _temp16 = require("c43bb29fb1cfca0b");
const _temp17 = require("33151498f8e3590c");
const _temp18 = require("2d59f77aea6e3b77");
const _temp19 = require("fe1f5dec275171b7");
const _temp20 = require("a1bbff8739a0658a");
const _temp21 = require("2b9b142be7201e7c");
const _temp22 = require("172ae97402da1d49");
const _temp23 = require("d851d870e62246f4");
const _temp24 = require("44821b892a918e6c");
const _temp25 = require("7faa2d31a234062a");
const _temp26 = require("5c5f0be33ec5ba81");
const _temp27 = require("64d6c30d2ff23167");
const _temp28 = require("fea2140998ff0d13");
const _temp29 = require("7f6bb46ce0487a03");
const _temp30 = require("7f263cec69f15a2c");
const _temp31 = require("35303af8ede7a7f7");
const _temp32 = require("3627813fc5c9ab96");
const _temp33 = require("569d4e9f5cdf769");
module.exports = {
    "ar-AE": _temp0,
    "bg-BG": _temp1,
    "cs-CZ": _temp2,
    "da-DK": _temp3,
    "de-DE": _temp4,
    "el-GR": _temp5,
    "en-US": _temp6,
    "es-ES": _temp7,
    "et-EE": _temp8,
    "fi-FI": _temp9,
    "fr-FR": _temp10,
    "he-IL": _temp11,
    "hr-HR": _temp12,
    "hu-HU": _temp13,
    "it-IT": _temp14,
    "ja-JP": _temp15,
    "ko-KR": _temp16,
    "lt-LT": _temp17,
    "lv-LV": _temp18,
    "nb-NO": _temp19,
    "nl-NL": _temp20,
    "pl-PL": _temp21,
    "pt-BR": _temp22,
    "pt-PT": _temp23,
    "ro-RO": _temp24,
    "ru-RU": _temp25,
    "sk-SK": _temp26,
    "sl-SI": _temp27,
    "sr-SP": _temp28,
    "sv-SE": _temp29,
    "tr-TR": _temp30,
    "uk-UA": _temp31,
    "zh-CN": _temp32,
    "zh-TW": _temp33
};

},{"6757af74e06e5a37":"6XT3f","757092ddc87a8d83":"koVah","31524657eb201d1f":"lHnx9","be825a666165c65":"8buTZ","89b4d428f0c494ab":"lGlqO","c60a1094adf6f91c":"cHNss","5e823c4821c37dbd":"hXvgX","7334bb387fbb541f":"2bOZ1","4c3cd4fdfc046119":"h1pze","cf505e827d20e1b1":"bGrBz","6941570aab32b778":"jL7FI","b40652ff57984a01":"eEf1v","fdfa3df927c9ca4e":"aJvgS","b11330535a3a5ab6":"ejazj","8027cccb357f724":"h10ux","4a77502c71bbcbe":"aRQcF","c43bb29fb1cfca0b":"8mzXC","33151498f8e3590c":"69Dms","2d59f77aea6e3b77":"6BvFH","fe1f5dec275171b7":"ijt5J","a1bbff8739a0658a":"bZCDk","2b9b142be7201e7c":"lUCzh","172ae97402da1d49":"7lLz9","d851d870e62246f4":"bIyWv","44821b892a918e6c":"7YOCS","7faa2d31a234062a":"6E93h","5c5f0be33ec5ba81":"8q249","64d6c30d2ff23167":"8IjIF","fea2140998ff0d13":"6ZSoh","7f6bb46ce0487a03":"32NIv","7f263cec69f15a2c":"e6Zsc","35303af8ede7a7f7":"2siEw","3627813fc5c9ab96":"aWMWR","569d4e9f5cdf769":"9R8Xn"}],"6XT3f":[function(require,module,exports) {
module.exports = {
    "backButton": (args)=>`\u{627}\u{644}\u{631}\u{62C}\u{648}\u{639} \u{625}\u{644}\u{649} ${args.prevMenuButton}`,
    "moreActions": `\u{627}\u{644}\u{645}\u{632}\u{64A}\u{62F} \u{645}\u{646} \u{627}\u{644}\u{625}\u{62C}\u{631}\u{627}\u{621}\u{627}\u{62A}`,
    "unavailable": `\u{63A}\u{64A}\u{631} \u{645}\u{64F}\u{62A}\u{648}\u{641}\u{631}\u{60C} \u{642}\u{64F}\u{645} \u{628}\u{627}\u{644}\u{62A}\u{648}\u{633}\u{64A}\u{639} \u{644}\u{644}\u{62D}\u{635}\u{648}\u{644} \u{639}\u{644}\u{649} \u{627}\u{644}\u{62A}\u{641}\u{627}\u{635}\u{64A}\u{644}`
};

},{}],"koVah":[function(require,module,exports) {
module.exports = {
    "backButton": (args)=>`\u{41D}\u{430}\u{437}\u{430}\u{434} \u{43A}\u{44A}\u{43C} ${args.prevMenuButton}`,
    "moreActions": `\u{41F}\u{43E}\u{432}\u{435}\u{447}\u{435} \u{434}\u{435}\u{439}\u{441}\u{442}\u{432}\u{438}\u{44F}`,
    "unavailable": `\u{41D}\u{435}\u{434}\u{43E}\u{441}\u{442}\u{44A}\u{43F}\u{43D}\u{43E}, \u{440}\u{430}\u{437}\u{433}\u{44A}\u{43D}\u{435}\u{442}\u{435} \u{437}\u{430} \u{43F}\u{43E}\u{434}\u{440}\u{43E}\u{431}\u{43D}\u{43E}\u{441}\u{442}\u{438}`
};

},{}],"lHnx9":[function(require,module,exports) {
module.exports = {
    "backButton": (args)=>`N\xe1vrat na ${args.prevMenuButton}`,
    "moreActions": `Dal\u{161}\xed akce`,
    "unavailable": `Nen\xed k dispozici, rozbalen\xedm zobraz\xedte podrobnosti`
};

},{}],"8buTZ":[function(require,module,exports) {
module.exports = {
    "backButton": (args)=>`Vend tilbage til ${args.prevMenuButton}`,
    "moreActions": `Flere handlinger`,
    "unavailable": `Ikke tilg\xe6ngelig, udvid for detaljer`
};

},{}],"lGlqO":[function(require,module,exports) {
module.exports = {
    "backButton": (args)=>`Zur\xfcck zu ${args.prevMenuButton}`,
    "moreActions": `Mehr Aktionen`,
    "unavailable": `Nicht verf\xfcgbar, f\xfcr Details erweitern`
};

},{}],"cHNss":[function(require,module,exports) {
module.exports = {
    "backButton": (args)=>`\u{395}\u{3C0}\u{3B9}\u{3C3}\u{3C4}\u{3C1}\u{3BF}\u{3C6}\u{3AE} \u{3C3}\u{3C4}\u{3BF} ${args.prevMenuButton}`,
    "moreActions": `\u{3A0}\u{3B5}\u{3C1}\u{3B9}\u{3C3}\u{3C3}\u{3CC}\u{3C4}\u{3B5}\u{3C1}\u{3B5}\u{3C2} \u{3B5}\u{3BD}\u{3AD}\u{3C1}\u{3B3}\u{3B5}\u{3B9}\u{3B5}\u{3C2}`,
    "unavailable": `\u{39C}\u{3B7} \u{3B4}\u{3B9}\u{3B1}\u{3B8}\u{3AD}\u{3C3}\u{3B9}\u{3BC}\u{3BF}, \u{3B1}\u{3BD}\u{3AC}\u{3C0}\u{3C4}\u{3C5}\u{3BE}\u{3B7} \u{3B3}\u{3B9}\u{3B1} \u{3BB}\u{3B5}\u{3C0}\u{3C4}\u{3BF}\u{3BC}\u{3AD}\u{3C1}\u{3B5}\u{3B9}\u{3B5}\u{3C2}`
};

},{}],"hXvgX":[function(require,module,exports) {
module.exports = {
    "moreActions": `More actions`,
    "unavailable": `Unavailable, expand for details`,
    "backButton": (args)=>`Return to ${args.prevMenuButton}`
};

},{}],"2bOZ1":[function(require,module,exports) {
module.exports = {
    "backButton": (args)=>`Volver a ${args.prevMenuButton}`,
    "moreActions": `M\xe1s acciones`,
    "unavailable": `No disponible, ampliar para m\xe1s detalles`
};

},{}],"h1pze":[function(require,module,exports) {
module.exports = {
    "backButton": (args)=>`Tagasi ${args.prevMenuButton}`,
    "moreActions": `Veel toiminguid`,
    "unavailable": `Pole k\xe4ttesaadav, \xfcksikasjade vaatamiseks laiendage`
};

},{}],"bGrBz":[function(require,module,exports) {
module.exports = {
    "backButton": (args)=>`Palaa kohtaan ${args.prevMenuButton}`,
    "moreActions": `Lis\xe4\xe4 toimintoja`,
    "unavailable": `Ei saatavilla, laajenna saadaksesi lis\xe4tietoja`
};

},{}],"jL7FI":[function(require,module,exports) {
module.exports = {
    "backButton": (args)=>`Retour vers ${args.prevMenuButton}`,
    "moreActions": `Autres actions`,
    "unavailable": `Indisponible, d\xe9velopper pour plus de d\xe9tails`
};

},{}],"eEf1v":[function(require,module,exports) {
module.exports = {
    "backButton": (args)=>`\u{5D7}\u{5D6}\u{5D5}\u{5E8} \u{5D0}\u{5DC} ${args.prevMenuButton}`,
    "moreActions": `\u{5E4}\u{5E2}\u{5D5}\u{5DC}\u{5D5}\u{5EA} \u{5E0}\u{5D5}\u{5E1}\u{5E4}\u{5D5}\u{5EA}`,
    "unavailable": `\u{5DC}\u{5D0} \u{5D6}\u{5DE}\u{5D9}\u{5DF}, \u{5D4}\u{5E8}\u{5D7}\u{5D1} \u{5DC}\u{5E4}\u{5E8}\u{5D8}\u{5D9}\u{5DD}`
};

},{}],"aJvgS":[function(require,module,exports) {
module.exports = {
    "backButton": (args)=>`Povratak na ${args.prevMenuButton}`,
    "moreActions": `Dodatne radnje`,
    "unavailable": `Nije dostupno, pro\u{161}iri za detalje`
};

},{}],"ejazj":[function(require,module,exports) {
module.exports = {
    "backButton": (args)=>`Vissza ide: ${args.prevMenuButton}`,
    "moreActions": `Tov\xe1bbi lehet\u{151}s\xe9gek`,
    "unavailable": `Nem \xe9rhet\u{151} el, a r\xe9szletek\xe9rt bontsa ki`
};

},{}],"h10ux":[function(require,module,exports) {
module.exports = {
    "backButton": (args)=>`Torna a ${args.prevMenuButton}`,
    "moreActions": `Altre azioni`,
    "unavailable": `Non disponibile, espandi per i dettagli`
};

},{}],"aRQcF":[function(require,module,exports) {
module.exports = {
    "backButton": (args)=>`${args.prevMenuButton} \u{306B}\u{623B}\u{308B}`,
    "moreActions": `\u{305D}\u{306E}\u{4ED6}\u{306E}\u{30A2}\u{30AF}\u{30B7}\u{30E7}\u{30F3}`,
    "unavailable": `\u{5229}\u{7528}\u{3067}\u{304D}\u{307E}\u{305B}\u{3093}\u{3002}\u{8A73}\u{3057}\u{304F}\u{306F}\u{3001}\u{5C55}\u{958B}\u{3057}\u{3066}\u{78BA}\u{8A8D}\u{3057}\u{3066}\u{304F}\u{3060}\u{3055}\u{3044}`
};

},{}],"8mzXC":[function(require,module,exports) {
module.exports = {
    "backButton": (args)=>`${args.prevMenuButton}(\u{C73C})\u{B85C} \u{B3CC}\u{C544}\u{AC00}\u{AE30}`,
    "moreActions": `\u{AE30}\u{D0C0} \u{C561}\u{C158}`,
    "unavailable": `\u{C0AC}\u{C6A9}\u{D560} \u{C218} \u{C5C6}\u{C74C}, \u{C790}\u{C138}\u{D788} \u{BCF4}\u{B824}\u{BA74} \u{D3BC}\u{CE58}\u{AE30}`
};

},{}],"69Dms":[function(require,module,exports) {
module.exports = {
    "backButton": (args)=>`Gr\u{12F}\u{17E}ti \u{12F} ${args.prevMenuButton}`,
    "moreActions": `Daugiau veiksm\u{173}`,
    "unavailable": `Nepasiekiama, nor\u{117}dami gauti daugiau informacijos, i\u{161}skleiskite`
};

},{}],"6BvFH":[function(require,module,exports) {
module.exports = {
    "backButton": (args)=>`Atgriezties uz ${args.prevMenuButton}`,
    "moreActions": `Citas darb\u{12B}bas`,
    "unavailable": `Nav pieejams, izv\u{113}rsiet, lai skat\u{12B}tu s\u{12B}k\u{101}ku inform\u{101}ciju`
};

},{}],"ijt5J":[function(require,module,exports) {
module.exports = {
    "backButton": (args)=>`G\xe5 tilbake til ${args.prevMenuButton}`,
    "moreActions": `Flere handlinger`,
    "unavailable": `Utilgjengelig, utvid for detaljer`
};

},{}],"bZCDk":[function(require,module,exports) {
module.exports = {
    "backButton": (args)=>`Terug naar ${args.prevMenuButton}`,
    "moreActions": `Meer handelingen`,
    "unavailable": `Niet beschikbaar, uitvouwen voor meer informatie`
};

},{}],"lUCzh":[function(require,module,exports) {
module.exports = {
    "backButton": (args)=>`Wr\xf3\u{107} do: ${args.prevMenuButton}`,
    "moreActions": `Wi\u{119}cej akcji`,
    "unavailable": `Niedost\u{119}pne, rozwi\u{144}, aby zobaczy\u{107} szczeg\xf3\u{142}y`
};

},{}],"7lLz9":[function(require,module,exports) {
module.exports = {
    "backButton": (args)=>`Retornar a ${args.prevMenuButton}`,
    "moreActions": `Mais a\xe7\xf5es`,
    "unavailable": `Indispon\xedvel. Expanda para ver os detalhes`
};

},{}],"bIyWv":[function(require,module,exports) {
module.exports = {
    "backButton": (args)=>`Voltar ao ${args.prevMenuButton}`,
    "moreActions": `Mais a\xe7\xf5es`,
    "unavailable": `Indispon\xedvel, expandir para mais detalhes`
};

},{}],"7YOCS":[function(require,module,exports) {
module.exports = {
    "backButton": (args)=>`Reveni\u{21B}i la ${args.prevMenuButton}`,
    "moreActions": `Mai multe ac\u{21B}iuni`,
    "unavailable": `Indisponibil, extinde\u{21B}i pentru detalii`
};

},{}],"6E93h":[function(require,module,exports) {
module.exports = {
    "backButton": (args)=>`\u{412}\u{435}\u{440}\u{43D}\u{443}\u{442}\u{44C}\u{441}\u{44F} \u{43A} ${args.prevMenuButton}`,
    "moreActions": `\u{414}\u{43E}\u{43F}\u{43E}\u{43B}\u{43D}\u{438}\u{442}\u{435}\u{43B}\u{44C}\u{43D}\u{44B}\u{435} \u{434}\u{435}\u{439}\u{441}\u{442}\u{432}\u{438}\u{44F}`,
    "unavailable": `\u{41D}\u{435}\u{434}\u{43E}\u{441}\u{442}\u{443}\u{43F}\u{43D}\u{43E}, \u{440}\u{430}\u{437}\u{432}\u{435}\u{440}\u{43D}\u{438}\u{442}\u{435} \u{434}\u{43B}\u{44F} \u{43F}\u{43E}\u{434}\u{440}\u{43E}\u{431}\u{43D}\u{43E}\u{441}\u{442}\u{435}\u{439}`
};

},{}],"8q249":[function(require,module,exports) {
module.exports = {
    "backButton": (args)=>`Sp\xe4\u{165} na ${args.prevMenuButton}`,
    "moreActions": `\u{10E}al\u{161}ie akcie`,
    "unavailable": `Nedostupn\xe9, rozba\u{13E}te podrobnosti`
};

},{}],"8IjIF":[function(require,module,exports) {
module.exports = {
    "backButton": (args)=>`Nazaj na ${args.prevMenuButton}`,
    "moreActions": `Ve\u{10D} mo\u{17E}nosti`,
    "unavailable": `Ni na voljo, raz\u{161}irite za podrobnosti`
};

},{}],"6ZSoh":[function(require,module,exports) {
module.exports = {
    "backButton": (args)=>`Povratak na ${args.prevMenuButton}`,
    "moreActions": `Dodatne radnje`,
    "unavailable": `Nije dostupno, pro\u{161}irite za detalje`
};

},{}],"32NIv":[function(require,module,exports) {
module.exports = {
    "backButton": (args)=>`\xc5terg\xe5 till ${args.prevMenuButton}`,
    "moreActions": `Fler \xe5tg\xe4rder`,
    "unavailable": `Ej tillg\xe4nglig, expandera f\xf6r mer information`
};

},{}],"e6Zsc":[function(require,module,exports) {
module.exports = {
    "backButton": (args)=>`Geri d\xf6n: ${args.prevMenuButton}`,
    "moreActions": `Daha fazla eylem`,
    "unavailable": `Kullan\u{131}lam\u{131}yor, ayr\u{131}nt\u{131}lar\u{131} g\xf6rmek i\xe7in geni\u{15F}letin`
};

},{}],"2siEw":[function(require,module,exports) {
module.exports = {
    "backButton": (args)=>`\u{41F}\u{43E}\u{432}\u{435}\u{440}\u{43D}\u{443}\u{442}\u{438}\u{441}\u{44F} \u{434}\u{43E} ${args.prevMenuButton}`,
    "moreActions": `\u{411}\u{456}\u{43B}\u{44C}\u{448}\u{435} \u{434}\u{456}\u{439}`,
    "unavailable": `\u{41D}\u{435}\u{434}\u{43E}\u{441}\u{442}\u{443}\u{43F}\u{43D}\u{43E}, \u{440}\u{43E}\u{437}\u{433}\u{43E}\u{440}\u{43D}\u{456}\u{442}\u{44C} \u{434}\u{43B}\u{44F} \u{434}\u{43E}\u{43A}\u{43B}\u{430}\u{434}\u{43D}\u{456}\u{448}\u{43E}\u{457} \u{456}\u{43D}\u{444}\u{43E}\u{440}\u{43C}\u{430}\u{446}\u{456}\u{457}`
};

},{}],"aWMWR":[function(require,module,exports) {
module.exports = {
    "backButton": (args)=>`\u{8FD4}\u{56DE} ${args.prevMenuButton}`,
    "moreActions": `\u{66F4}\u{591A}\u{64CD}\u{4F5C}`,
    "unavailable": `\u{4E0D}\u{53EF}\u{7528}\u{FF0C}\u{5C55}\u{5F00}\u{4EE5}\u{67E5}\u{770B}\u{8BE6}\u{7EC6}\u{4FE1}\u{606F}`
};

},{}],"9R8Xn":[function(require,module,exports) {
module.exports = {
    "backButton": (args)=>`\u{8FD4}\u{56DE} ${args.prevMenuButton}`,
    "moreActions": `\u{66F4}\u{591A}\u{52D5}\u{4F5C}`,
    "unavailable": `\u{7121}\u{6CD5}\u{4F7F}\u{7528}\u{FF0C}\u{5C55}\u{958B}\u{4EE5}\u{53D6}\u{5F97}\u{8A73}\u{7D30}\u{8CC7}\u{6599}`
};

},{}],"5OAuV":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/** @private */ parcelHelpers.export(exports, "MenuItem", ()=>MenuItem);
var _checkmarkMedium = require("@spectrum-icons/ui/CheckmarkMedium");
var _checkmarkMediumDefault = parcelHelpers.interopDefault(_checkmarkMedium);
var _chevronLeft = require("@spectrum-icons/workflow/ChevronLeft");
var _chevronLeftDefault = parcelHelpers.interopDefault(_chevronLeft);
var _chevronRight = require("@spectrum-icons/workflow/ChevronRight");
var _chevronRightDefault = parcelHelpers.interopDefault(_chevronRight);
var _utils = require("@react-spectrum/utils");
var _focus = require("@react-aria/focus");
var _layout = require("@react-spectrum/layout");
var _infoOutline = require("@spectrum-icons/workflow/InfoOutline");
var _infoOutlineDefault = parcelHelpers.interopDefault(_infoOutline);
// @ts-ignore
var _json = require("../intl/*.json");
var _jsonDefault = parcelHelpers.interopDefault(_json);
var _utils1 = require("@react-aria/utils");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _varsCss = require("@adobe/spectrum-css-temp/components/menu/vars.css");
var _varsCssDefault = parcelHelpers.interopDefault(_varsCss);
var _text = require("@react-spectrum/text");
var _i18N = require("@react-aria/i18n");
var _context = require("./context");
var _menu = require("@react-aria/menu");
function MenuItem(props) {
    let { item, state, isVirtualized, onAction } = props;
    let { closeOnSelect } = (0, _context.useMenuContext)();
    let { rendered, key } = item;
    let stringFormatter = (0, _i18N.useLocalizedStringFormatter)((0, _jsonDefault.default), "@react-spectrum/menu");
    let { direction } = (0, _i18N.useLocale)();
    let submenuTriggerContext = (0, _context.useSubmenuTriggerContext)();
    let { triggerRef, ...submenuTriggerProps } = submenuTriggerContext || {};
    let isSubmenuTrigger = !!submenuTriggerContext;
    let isUnavailable;
    let ElementType = item.props.href ? "a" : "div";
    if (isSubmenuTrigger) isUnavailable = submenuTriggerContext.isUnavailable;
    let isDisabled = state.disabledKeys.has(key);
    let isSelectable = !isSubmenuTrigger && state.selectionManager.selectionMode !== "none";
    let isSelected = isSelectable && state.selectionManager.isSelected(key);
    let itemref = (0, _react.useRef)(null);
    let ref = (0, _utils1.useObjectRef)((0, _react.useMemo)(()=>(0, _utils1.mergeRefs)(itemref, triggerRef), [
        itemref,
        triggerRef
    ]));
    let { menuItemProps, labelProps, descriptionProps, keyboardShortcutProps } = (0, _menu.useMenuItem)({
        isSelected,
        isDisabled,
        "aria-label": item["aria-label"],
        key,
        closeOnSelect,
        isVirtualized,
        onAction,
        ...submenuTriggerProps
    }, state, ref);
    let endId = (0, _utils1.useSlotId)();
    let endProps = {};
    if (endId) {
        endProps.id = endId;
        menuItemProps["aria-describedby"] = [
            menuItemProps["aria-describedby"],
            endId
        ].filter(Boolean).join(" ");
    }
    let contents = typeof rendered === "string" ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, rendered) : rendered;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _focus.FocusRing), {
        focusRingClass: (0, _utils.classNames)((0, _varsCssDefault.default), "focus-ring")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(ElementType, {
        ...menuItemProps,
        ref: ref,
        className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Menu-item", {
            "is-disabled": isDisabled,
            "is-selected": isSelected,
            "is-selectable": isSelectable,
            "is-open": submenuTriggerProps.isOpen
        })
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Grid), {
        UNSAFE_className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Menu-itemGrid")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.ClearSlots), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.SlotProvider), {
        slots: {
            text: {
                UNSAFE_className: (0, _varsCssDefault.default)["spectrum-Menu-itemLabel"],
                ...labelProps
            },
            end: {
                UNSAFE_className: (0, _varsCssDefault.default)["spectrum-Menu-end"],
                ...endProps
            },
            icon: {
                UNSAFE_className: (0, _varsCssDefault.default)["spectrum-Menu-icon"],
                size: "S"
            },
            description: {
                UNSAFE_className: (0, _varsCssDefault.default)["spectrum-Menu-description"],
                ...descriptionProps
            },
            keyboard: {
                UNSAFE_className: (0, _varsCssDefault.default)["spectrum-Menu-keyboard"],
                ...keyboardShortcutProps
            },
            chevron: {
                UNSAFE_className: (0, _varsCssDefault.default)["spectrum-Menu-chevron"],
                size: "S"
            }
        }
    }, contents, isSelected && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _checkmarkMediumDefault.default), {
        slot: "checkmark",
        UNSAFE_className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Menu-checkmark")
    }), isUnavailable && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _infoOutlineDefault.default), {
        slot: "end",
        size: "XS",
        alignSelf: "center",
        "aria-label": stringFormatter.format("unavailable")
    }), isUnavailable == null && isSubmenuTrigger && (direction === "rtl" ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _chevronLeftDefault.default), {
        slot: "chevron"
    }) : /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _chevronRightDefault.default), {
        slot: "chevron"
    })))))));
}

},{"@spectrum-icons/ui/CheckmarkMedium":"e6Ew8","@spectrum-icons/workflow/ChevronLeft":"fYBvr","@spectrum-icons/workflow/ChevronRight":"e6JuZ","@react-spectrum/utils":"cMIJ6","@react-aria/focus":"42mbF","@react-spectrum/layout":"hzaUY","@spectrum-icons/workflow/InfoOutline":"b3t2v","../intl/*.json":"9AOsG","@react-aria/utils":"9cLk5","react":"9yzVZ","@adobe/spectrum-css-temp/components/menu/vars.css":"gqElf","@react-spectrum/text":"etCGI","@react-aria/i18n":"411rg","./context":"fEXAZ","@react-aria/menu":"89bvn","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"e6Ew8":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("77a02e017bb28300");
exports.__esModule = true;
exports.default = CheckmarkMedium;
var _CheckmarkMedium = require("d3417c90d40788eb");
var _icon = require("365454c64e7b3e5f");
var _react = _interopRequireDefault(require("1c93acd4c1681a5a"));
function CheckmarkMedium(props) {
    return /*#__PURE__*/ _react.default.createElement(_icon.UIIcon, props, /*#__PURE__*/ _react.default.createElement(_CheckmarkMedium.CheckmarkMedium, null));
}

},{"77a02e017bb28300":"iHubQ","d3417c90d40788eb":"kyG6w","365454c64e7b3e5f":"k7wem","1c93acd4c1681a5a":"9yzVZ"}],"kyG6w":[function(require,module,exports) {
/**
* @adobe/react-spectrum-ui (c) by Adobe
* 
* @adobe/react-spectrum-ui is licensed under a
* Creative Commons Attribution-NoDerivatives 4.0 International License.
* 
* You should have received a copy of the license along with this
* work. If not, see <http://creativecommons.org/licenses/by-nd/4.0/>.
**/ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CheckmarkMedium = CheckmarkMedium;
var _react = _interopRequireDefault(require("a3b5dfd248936c53"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function CheckmarkMedium(_ref) {
    var _ref$scale = _ref.scale, scale = _ref$scale === void 0 ? "M" : _ref$scale, props = _objectWithoutProperties(_ref, [
        "scale"
    ]);
    return _react["default"].createElement("svg", _extends({}, props, props), scale === "L" && _react["default"].createElement("path", {
        d: "M6 14a1 1 0 0 1-.789-.385l-4-5a1 1 0 1 1 1.577-1.23L6 11.376l7.213-8.99a1 1 0 1 1 1.576 1.23l-8 10a1 1 0 0 1-.789.384z"
    }), scale === "M" && _react["default"].createElement("path", {
        d: "M4.5 10a1.022 1.022 0 0 1-.799-.384l-2.488-3a1 1 0 0 1 1.576-1.233L4.5 7.376l4.712-5.991a1 1 0 1 1 1.576 1.23l-5.51 7A.978.978 0 0 1 4.5 10z"
    }));
}
CheckmarkMedium.displayName = "CheckmarkMedium";

},{"a3b5dfd248936c53":"9yzVZ"}],"fYBvr":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("2fb12906457ed8b2");
exports.__esModule = true;
exports.default = ChevronLeft;
var _ChevronLeft = require("10bab14b5853c417");
var _icon = require("f39d0f4323e04f2a");
var _react = _interopRequireDefault(require("af9b5568b83374dc"));
function ChevronLeft(props) {
    return /*#__PURE__*/ _react.default.createElement(_icon.Icon, props, /*#__PURE__*/ _react.default.createElement(_ChevronLeft.A4uChevronLeft, null));
}

},{"2fb12906457ed8b2":"iHubQ","10bab14b5853c417":"3y8tY","f39d0f4323e04f2a":"k7wem","af9b5568b83374dc":"9yzVZ"}],"3y8tY":[function(require,module,exports) {
/**
* @adobe/react-spectrum-workflow (c) by Adobe
* 
* @adobe/react-spectrum-workflow is licensed under a
* Creative Commons Attribution-NoDerivatives 4.0 International License.
* 
* You should have received a copy of the license along with this
* work. If not, see <http://creativecommons.org/licenses/by-nd/4.0/>.
**/ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.A4uChevronLeft = A4uChevronLeft;
var _react = _interopRequireDefault(require("89f1d5f755ed0949"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function A4uChevronLeft(_ref) {
    var props = _extends({}, _ref);
    return /*#__PURE__*/ _react["default"].createElement("svg", _extends({
        viewBox: "0 0 36 36"
    }, props, props), /*#__PURE__*/ _react["default"].createElement("path", {
        fillRule: "evenodd",
        d: "M12,18v0a1.988,1.988,0,0,0,.585,1.409l7.983,7.98a2,2,0,1,0,2.871-2.772l-.049-.049L16.819,18l6.572-6.57a2,2,0,0,0-2.773-2.87l-.049.049-7.983,7.98A1.988,1.988,0,0,0,12,18Z"
    }));
}

},{"89f1d5f755ed0949":"9yzVZ"}],"e6JuZ":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("ea79f9859c5591d1");
exports.__esModule = true;
exports.default = ChevronRight;
var _ChevronRight = require("b9defb01e76bb764");
var _icon = require("5396c567b0aa1cb6");
var _react = _interopRequireDefault(require("9a6a540d28580ecb"));
function ChevronRight(props) {
    return /*#__PURE__*/ _react.default.createElement(_icon.Icon, props, /*#__PURE__*/ _react.default.createElement(_ChevronRight.A4uChevronRight, null));
}

},{"ea79f9859c5591d1":"iHubQ","b9defb01e76bb764":"819ke","5396c567b0aa1cb6":"k7wem","9a6a540d28580ecb":"9yzVZ"}],"819ke":[function(require,module,exports) {
/**
* @adobe/react-spectrum-workflow (c) by Adobe
* 
* @adobe/react-spectrum-workflow is licensed under a
* Creative Commons Attribution-NoDerivatives 4.0 International License.
* 
* You should have received a copy of the license along with this
* work. If not, see <http://creativecommons.org/licenses/by-nd/4.0/>.
**/ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.A4uChevronRight = A4uChevronRight;
var _react = _interopRequireDefault(require("294968fe8c4d9415"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function A4uChevronRight(_ref) {
    var props = _extends({}, _ref);
    return /*#__PURE__*/ _react["default"].createElement("svg", _extends({
        viewBox: "0 0 36 36"
    }, props, props), /*#__PURE__*/ _react["default"].createElement("path", {
        fillRule: "evenodd",
        d: "M24,18v0a1.988,1.988,0,0,1-.585,1.409l-7.983,7.98a2,2,0,1,1-2.871-2.772l.049-.049L19.181,18l-6.572-6.57a2,2,0,0,1,2.773-2.87l.049.049,7.983,7.98A1.988,1.988,0,0,1,24,18Z"
    }));
}

},{"294968fe8c4d9415":"9yzVZ"}],"hzaUY":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /// <reference types="css-module-types" />
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "repeat", ()=>(0, _grid.repeat));
parcelHelpers.export(exports, "minmax", ()=>(0, _grid.minmax));
parcelHelpers.export(exports, "fitContent", ()=>(0, _grid.fitContent));
parcelHelpers.export(exports, "Grid", ()=>(0, _grid.Grid));
parcelHelpers.export(exports, "Flex", ()=>(0, _flex.Flex));
var _grid = require("./Grid");
var _flex = require("./Flex");

},{"./Grid":"e63yp","./Flex":"bThCU","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"e63yp":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Can be used to make a repeating fragment of the columns or rows list.
 * See [MDN](https://developer.mozilla.org/en-US/docs/Web/CSS/repeat).
 * @param count - The number of times to repeat the fragment.
 * @param repeat - The fragment to repeat.
 */ parcelHelpers.export(exports, "repeat", ()=>repeat);
/**
 * Defines a size range greater than or equal to min and less than or equal to max.
 * See [MDN](https://developer.mozilla.org/en-US/docs/Web/CSS/minmax).
 * @param min - The minimum size.
 * @param max - The maximum size.
 */ parcelHelpers.export(exports, "minmax", ()=>minmax);
/**
 * Clamps a given size to an available size.
 * See [MDN](https://developer.mozilla.org/en-US/docs/Web/CSS/fit-content).
 * @param dimension - The size to clamp.
 */ parcelHelpers.export(exports, "fitContent", ()=>fitContent);
parcelHelpers.export(exports, "Grid", ()=>_Grid);
var _utils = require("@react-spectrum/utils");
var _utils1 = require("@react-aria/utils");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const gridStyleProps = {
    ...(0, _utils.baseStyleProps),
    autoFlow: [
        "gridAutoFlow",
        (0, _utils.passthroughStyle)
    ],
    autoColumns: [
        "gridAutoColumns",
        gridDimensionValue
    ],
    autoRows: [
        "gridAutoRows",
        gridDimensionValue
    ],
    areas: [
        "gridTemplateAreas",
        gridTemplateAreasValue
    ],
    columns: [
        "gridTemplateColumns",
        gridTemplateValue
    ],
    rows: [
        "gridTemplateRows",
        gridTemplateValue
    ],
    gap: [
        "gap",
        (0, _utils.dimensionValue)
    ],
    rowGap: [
        "rowGap",
        (0, _utils.dimensionValue)
    ],
    columnGap: [
        "columnGap",
        (0, _utils.dimensionValue)
    ],
    justifyItems: [
        "justifyItems",
        (0, _utils.passthroughStyle)
    ],
    justifyContent: [
        "justifyContent",
        (0, _utils.passthroughStyle)
    ],
    alignItems: [
        "alignItems",
        (0, _utils.passthroughStyle)
    ],
    alignContent: [
        "alignContent",
        (0, _utils.passthroughStyle)
    ]
};
function Grid(props, ref) {
    let { children, ...otherProps } = props;
    let { styleProps } = (0, _utils.useStyleProps)(otherProps, gridStyleProps);
    styleProps.style.display = "grid"; // inline-grid?
    let domRef = (0, _utils.useDOMRef)(ref);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...(0, _utils1.filterDOMProps)(otherProps),
        ...styleProps,
        ref: domRef
    }, children);
}
function repeat(count, repeat) {
    return `repeat(${count}, ${gridTemplateValue(repeat)})`;
}
function minmax(min, max) {
    return `minmax(${gridDimensionValue(min)}, ${gridDimensionValue(max)})`;
}
function fitContent(dimension) {
    return `fit-content(${gridDimensionValue(dimension)})`;
}
function gridTemplateAreasValue(value) {
    return value.map((v)=>`"${v}"`).join("\n");
}
function gridDimensionValue(value) {
    if (/^max-content|min-content|minmax|auto|fit-content|repeat|subgrid/.test(value)) return value;
    return (0, _utils.dimensionValue)(value);
}
function gridTemplateValue(value) {
    if (Array.isArray(value)) return value.map(gridDimensionValue).join(" ");
    return gridDimensionValue(value);
}
/**
 * A layout container using CSS grid. Supports Spectrum dimensions as values to
 * ensure consistent and adaptive sizing and spacing.
 */ const _Grid = /*#__PURE__*/ (0, _react.forwardRef)(Grid);

},{"@react-spectrum/utils":"cMIJ6","@react-aria/utils":"9cLk5","react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"bThCU":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Flex", ()=>_Flex);
var _utils = require("@react-spectrum/utils");
var _utils1 = require("@react-aria/utils");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _flexGapCss = require("./flex-gap.css");
var _flexGapCssDefault = parcelHelpers.interopDefault(_flexGapCss);
const flexStyleProps = {
    direction: [
        "flexDirection",
        (0, _utils.passthroughStyle)
    ],
    wrap: [
        "flexWrap",
        flexWrapValue
    ],
    justifyContent: [
        "justifyContent",
        flexAlignValue
    ],
    alignItems: [
        "alignItems",
        flexAlignValue
    ],
    alignContent: [
        "alignContent",
        flexAlignValue
    ]
};
function Flex(props, ref) {
    let { children, ...otherProps } = props;
    let breakpointProvider = (0, _utils.useBreakpoint)();
    let matchedBreakpoints = (breakpointProvider === null || breakpointProvider === void 0 ? void 0 : breakpointProvider.matchedBreakpoints) || [
        "base"
    ];
    let { styleProps } = (0, _utils.useStyleProps)(otherProps);
    let { styleProps: flexStyle } = (0, _utils.useStyleProps)(otherProps, flexStyleProps);
    let domRef = (0, _utils.useDOMRef)(ref);
    let style = {
        ...styleProps.style,
        ...flexStyle.style
    };
    if (props.gap != null) style.gap = (0, _utils.responsiveDimensionValue)(props.gap, matchedBreakpoints);
    if (props.columnGap != null) style.columnGap = (0, _utils.responsiveDimensionValue)(props.columnGap, matchedBreakpoints);
    if (props.rowGap != null) style.rowGap = (0, _utils.responsiveDimensionValue)(props.rowGap, matchedBreakpoints);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...(0, _utils1.filterDOMProps)(otherProps),
        className: (0, _utils.classNames)((0, _flexGapCssDefault.default), "flex", styleProps.className),
        style: style,
        ref: domRef
    }, children);
}
/**
 * Normalize 'start' and 'end' alignment values to 'flex-start' and 'flex-end'
 * in flex containers for browser compatibility.
 */ function flexAlignValue(value) {
    if (value === "start") return "flex-start";
    if (value === "end") return "flex-end";
    return value;
}
/**
 * Takes a boolean and translates it to flex wrap or nowrap.
 */ function flexWrapValue(value) {
    if (typeof value === "boolean") return value ? "wrap" : "nowrap";
    return value;
}
/**
 * A layout container using flexbox. Provides Spectrum dimension values, and supports the gap
 * property to define consistent spacing between items.
 */ const _Flex = /*#__PURE__*/ (0, _react.forwardRef)(Flex);

},{"@react-spectrum/utils":"cMIJ6","@react-aria/utils":"9cLk5","react":"9yzVZ","./flex-gap.css":"3KRE8","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"3KRE8":[function(require,module,exports) {
module.exports["flex"] = `NW91UW_flex`;
module.exports["flex-container"] = `NW91UW_flex-container`;
module.exports["flex-gap"] = `NW91UW_flex-gap`;

},{}],"b3t2v":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("2c6c0cff11034ccd");
exports.__esModule = true;
exports.default = InfoOutline;
var _InfoOutline = require("d67f7bbe4694ed5b");
var _icon = require("73d0b4ea4a6f3a5c");
var _react = _interopRequireDefault(require("d6f2155b2c2ee873"));
function InfoOutline(props) {
    return /*#__PURE__*/ _react.default.createElement(_icon.Icon, props, /*#__PURE__*/ _react.default.createElement(_InfoOutline.A4uInfoOutline, null));
}

},{"2c6c0cff11034ccd":"iHubQ","d67f7bbe4694ed5b":"bPu0T","73d0b4ea4a6f3a5c":"k7wem","d6f2155b2c2ee873":"9yzVZ"}],"bPu0T":[function(require,module,exports) {
/**
* @adobe/react-spectrum-workflow (c) by Adobe
* 
* @adobe/react-spectrum-workflow is licensed under a
* Creative Commons Attribution-NoDerivatives 4.0 International License.
* 
* You should have received a copy of the license along with this
* work. If not, see <http://creativecommons.org/licenses/by-nd/4.0/>.
**/ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.A4uInfoOutline = A4uInfoOutline;
var _react = _interopRequireDefault(require("37f214df9fc4ec0"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function A4uInfoOutline(_ref) {
    var props = _extends({}, _ref);
    return /*#__PURE__*/ _react["default"].createElement("svg", _extends({
        viewBox: "0 0 36 36"
    }, props, props), /*#__PURE__*/ _react["default"].createElement("path", {
        fillRule: "evenodd",
        d: "M20.15,12A2.15,2.15,0,1,1,18,9.85,2.15,2.15,0,0,1,20.15,12Zm.1835,12H20V16.3999A.4001.4001,0,0,0,19.60007,16H15.66648S14.5,16.03223,14.5,17c0,.96729,1.16651,1,1.16651,1H16v6h-.33349S14.5,24.03223,14.5,25c0,.96729,1.16651,1,1.16651,1h4.667S21.5,25.96729,21.5,25C21.5,24.03223,20.33347,24,20.33347,24ZM18,1A17,17,0,1,0,35.00008,18,17.00014,17.00014,0,0,0,18,1Zm0,30.34961A13.34961,13.34961,0,1,1,31.34967,18,13.34962,13.34962,0,0,1,18,31.34961Z"
    }));
}

},{"37f214df9fc4ec0":"9yzVZ"}],"iIYBg":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/** @private */ parcelHelpers.export(exports, "MenuSection", ()=>MenuSection);
var _utils = require("@react-spectrum/utils");
var _collections = require("@react-stately/collections");
var _menuItem = require("./MenuItem");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _varsCss = require("@adobe/spectrum-css-temp/components/menu/vars.css");
var _varsCssDefault = parcelHelpers.interopDefault(_varsCss);
var _menu = require("@react-aria/menu");
var _separator = require("@react-aria/separator");
function MenuSection(props) {
    var _filter_at;
    let { item, state, onAction } = props;
    let { itemProps, headingProps, groupProps } = (0, _menu.useMenuSection)({
        heading: item.rendered,
        "aria-label": item["aria-label"]
    });
    let { separatorProps } = (0, _separator.useSeparator)({
        elementType: "div"
    });
    let firstSectionKey = state.collection.getFirstKey();
    let lastSectionKey = (_filter_at = [
        ...state.collection
    ].filter((node)=>node.type === "section").at(-1)) === null || _filter_at === void 0 ? void 0 : _filter_at.key;
    let sectionIsFirst = firstSectionKey === item.key && state.collection.getFirstKey() === firstSectionKey;
    let sectionIsLast = lastSectionKey === item.key && state.collection.getItem(state.collection.getLastKey()).parentKey === lastSectionKey;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _react.Fragment), null, item.key !== state.collection.getFirstKey() && /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...separatorProps,
        className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Menu-divider")
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", itemProps, item.rendered && /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        ...headingProps,
        className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Menu-sectionHeading")
    }, item.rendered), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...groupProps,
        className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Menu", {
            "spectrum-Menu-section--noHeading": item.rendered == null,
            "spectrum-Menu-section--isFirst": sectionIsFirst,
            "spectrum-Menu-section--isLast": sectionIsLast
        })
    }, [
        ...(0, _collections.getChildNodes)(item, state.collection)
    ].map((node)=>{
        let item = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _menuItem.MenuItem), {
            key: node.key,
            item: node,
            state: state,
            onAction: onAction
        });
        if (node.wrapper) item = node.wrapper(item);
        return item;
    }))));
}

},{"@react-spectrum/utils":"cMIJ6","@react-stately/collections":"loANi","./MenuItem":"5OAuV","react":"9yzVZ","@adobe/spectrum-css-temp/components/menu/vars.css":"gqElf","@react-aria/menu":"89bvn","@react-aria/separator":"iHEIW","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"jAWPe":[function(require,module,exports) {
/*
 * Copyright 2021 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ActionMenu", ()=>_ActionMenu);
var _button = require("@react-spectrum/button");
var _utils = require("@react-aria/utils");
// @ts-ignore
var _json = require("../intl/*.json");
var _jsonDefault = parcelHelpers.interopDefault(_json);
var _menu = require("./Menu");
var _menuTrigger = require("./MenuTrigger");
var _more = require("@spectrum-icons/workflow/More");
var _moreDefault = parcelHelpers.interopDefault(_more);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _i18N = require("@react-aria/i18n");
var _utils1 = require("@react-spectrum/utils");
function ActionMenu(props, ref) {
    props = (0, _utils1.useSlotProps)(props, "actionMenu");
    let stringFormatter = (0, _i18N.useLocalizedStringFormatter)((0, _jsonDefault.default), "@react-spectrum/menu");
    let buttonProps = (0, _utils.filterDOMProps)(props, {
        labelable: true
    });
    if (buttonProps["aria-label"] === undefined) buttonProps["aria-label"] = stringFormatter.format("moreActions");
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _menuTrigger.MenuTrigger), {
        isOpen: props.isOpen,
        defaultOpen: props.defaultOpen,
        onOpenChange: props.onOpenChange,
        align: props.align,
        direction: props.direction,
        shouldFlip: props.shouldFlip
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), {
        ref: ref,
        ...props,
        ...buttonProps
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _moreDefault.default), null)), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _menu.Menu), {
        children: props.children,
        items: props.items,
        disabledKeys: props.disabledKeys,
        onAction: props.onAction
    }));
}
/**
 * ActionMenu combines an ActionButton with a Menu for simple "more actions" use cases.
 */ const _ActionMenu = /*#__PURE__*/ (0, _react.forwardRef)(ActionMenu);

},{"@react-spectrum/button":"jZWyP","@react-aria/utils":"9cLk5","../intl/*.json":"9AOsG","./Menu":"4Thgz","./MenuTrigger":"2kPmK","@spectrum-icons/workflow/More":"khbPp","react":"9yzVZ","@react-aria/i18n":"411rg","@react-spectrum/utils":"cMIJ6","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"khbPp":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("a5a8bc8ba6a3988f");
exports.__esModule = true;
exports.default = More;
var _More = require("298960cdd57c4e4d");
var _icon = require("b519faf99b7c1b99");
var _react = _interopRequireDefault(require("f6c41237ddb9e2d1"));
function More(props) {
    return /*#__PURE__*/ _react.default.createElement(_icon.Icon, props, /*#__PURE__*/ _react.default.createElement(_More.A4uMore, null));
}

},{"a5a8bc8ba6a3988f":"iHubQ","298960cdd57c4e4d":"5dDHC","b519faf99b7c1b99":"k7wem","f6c41237ddb9e2d1":"9yzVZ"}],"5dDHC":[function(require,module,exports) {
/**
* @adobe/react-spectrum-workflow (c) by Adobe
* 
* @adobe/react-spectrum-workflow is licensed under a
* Creative Commons Attribution-NoDerivatives 4.0 International License.
* 
* You should have received a copy of the license along with this
* work. If not, see <http://creativecommons.org/licenses/by-nd/4.0/>.
**/ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.A4uMore = A4uMore;
var _react = _interopRequireDefault(require("7ac25b0810584e14"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function A4uMore(_ref) {
    var props = _extends({}, _ref);
    return /*#__PURE__*/ _react["default"].createElement("svg", _extends({
        viewBox: "0 0 36 36"
    }, props, props), /*#__PURE__*/ _react["default"].createElement("circle", {
        fillRule: "evenodd",
        cx: "17.8",
        cy: "18.2",
        r: "3.4"
    }), /*#__PURE__*/ _react["default"].createElement("circle", {
        fillRule: "evenodd",
        cx: "29.5",
        cy: "18.2",
        r: "3.4"
    }), /*#__PURE__*/ _react["default"].createElement("circle", {
        fillRule: "evenodd",
        cx: "6.1",
        cy: "18.2",
        r: "3.4"
    }));
}

},{"7ac25b0810584e14":"9yzVZ"}],"j4eSN":[function(require,module,exports) {
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ContextualHelpTrigger", ()=>_Item);
var _utils = require("@react-spectrum/utils");
var _focus = require("@react-aria/focus");
var _interactions = require("@react-aria/interactions");
var _varsCss = require("@adobe/spectrum-css-temp/components/contextualhelp/vars.css");
var _varsCssDefault = parcelHelpers.interopDefault(_varsCss);
var _overlays = require("@react-spectrum/overlays");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactDom = require("react-dom");
var _reactDomDefault = parcelHelpers.interopDefault(_reactDom);
var _varsCss1 = require("@adobe/spectrum-css-temp/components/menu/vars.css");
var _varsCssDefault1 = parcelHelpers.interopDefault(_varsCss1);
var _context = require("./context");
var _menu = require("./Menu");
var _menu1 = require("@react-aria/menu");
var _menu2 = require("@react-stately/menu");
var _utils1 = require("@react-aria/utils");
function ContextualHelpTrigger(props) {
    let { isUnavailable = false, targetKey } = props;
    let triggerRef = (0, _react.useRef)(null);
    let popoverRef = (0, _react.useRef)(null);
    let { popoverContainer, trayContainerRef, rootMenuTriggerState, menu: parentMenuRef, state } = (0, _context.useMenuStateContext)();
    let triggerNode = state.collection.getItem(targetKey);
    let submenuTriggerState = (0, _menu2.UNSTABLE_useSubmenuTriggerState)({
        triggerKey: targetKey
    }, {
        ...rootMenuTriggerState,
        ...state
    });
    let submenuRef = (0, _utils.unwrapDOMRef)(popoverRef);
    let { submenuTriggerProps, popoverProps } = (0, _menu1.UNSTABLE_useSubmenuTrigger)({
        node: triggerNode,
        parentMenuRef,
        submenuRef,
        type: "dialog",
        isDisabled: !isUnavailable
    }, submenuTriggerState, triggerRef);
    let isMobile = (0, _utils.useIsMobileDevice)();
    let slots = {};
    if (isUnavailable) slots = {
        dialog: {
            UNSAFE_className: (0, _utils.classNames)((0, _varsCssDefault.default), "react-spectrum-ContextualHelp-dialog", {
                "react-spectrum-ContextualHelp-dialog--isMobile": isMobile
            }, (0, _utils.classNames)((0, _varsCssDefault1.default), {
                "spectrum-Menu-subdialog": !isMobile
            }))
        },
        content: {
            UNSAFE_className: (0, _varsCssDefault.default)["react-spectrum-ContextualHelp-content"]
        },
        footer: {
            UNSAFE_className: (0, _varsCssDefault.default)["react-spectrum-ContextualHelp-footer"]
        }
    };
    let [trigger] = (0, _reactDefault.default).Children.toArray(props.children);
    let [, content] = props.children;
    let onBlurWithin = (e)=>{
        var _popoverRef_current_UNSAFE_getDOMNode, _popoverRef_current;
        if (e.relatedTarget && popoverRef.current && !(popoverRef === null || popoverRef === void 0 ? void 0 : (_popoverRef_current = popoverRef.current) === null || _popoverRef_current === void 0 ? void 0 : (_popoverRef_current_UNSAFE_getDOMNode = _popoverRef_current.UNSAFE_getDOMNode()) === null || _popoverRef_current_UNSAFE_getDOMNode === void 0 ? void 0 : _popoverRef_current_UNSAFE_getDOMNode.contains(e.relatedTarget)) && !(e.relatedTarget === triggerRef.current && (0, _interactions.getInteractionModality)() === "pointer")) {
            if (submenuTriggerState.isOpen) submenuTriggerState.close();
        }
    };
    let overlay;
    let tray;
    let onBackButtonPress = ()=>{
        submenuTriggerState.close();
        if (parentMenuRef.current && !parentMenuRef.current.contains(document.activeElement)) parentMenuRef.current.focus();
    };
    let [offset, setOffset] = (0, _react.useState)(0);
    (0, _utils1.useLayoutEffect)(()=>{
        if (parentMenuRef.current) {
            var _window_getComputedStyle, _window;
            let offset = (_window = window) === null || _window === void 0 ? void 0 : (_window_getComputedStyle = _window.getComputedStyle(parentMenuRef === null || parentMenuRef === void 0 ? void 0 : parentMenuRef.current)) === null || _window_getComputedStyle === void 0 ? void 0 : _window_getComputedStyle.getPropertyValue("--spectrum-submenu-offset-distance");
            if (offset !== "") setOffset(-1 * parseInt(offset, 10));
        }
    }, [
        parentMenuRef
    ]);
    if (isMobile) {
        delete submenuTriggerProps.onBlur;
        delete submenuTriggerProps.onHoverChange;
        if (trayContainerRef.current && submenuTriggerState.isOpen) {
            let subDialogKeyDown = (e)=>{
                switch(e.key){
                    case "Escape":
                        e.stopPropagation();
                        onBackButtonPress();
                        break;
                }
            };
            tray = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _menu.TrayHeaderWrapper), {
                isSubmenu: true,
                parentMenuTreeState: state,
                rootMenuTriggerState: rootMenuTriggerState,
                wrapperKeyDown: subDialogKeyDown,
                onBackButtonPress: onBackButtonPress
            }, content);
            overlay = /*#__PURE__*/ (0, _reactDomDefault.default).createPortal(tray, trayContainerRef.current);
        }
    } else {
        let onDismissButtonPress = ()=>{
            var _parentMenuRef_current;
            submenuTriggerState.close();
            (_parentMenuRef_current = parentMenuRef.current) === null || _parentMenuRef_current === void 0 ? void 0 : _parentMenuRef_current.focus();
        };
        overlay = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _overlays.Popover), {
            ...popoverProps,
            UNSAFE_style: {
                clipPath: "unset",
                overflow: "visible",
                filter: "unset",
                borderWidth: "0px"
            },
            UNSAFE_className: (0, _utils.classNames)((0, _varsCssDefault1.default), "spectrum-Submenu-popover"),
            onDismissButtonPress: onDismissButtonPress,
            onBlurWithin: onBlurWithin,
            container: popoverContainer,
            state: submenuTriggerState,
            ref: popoverRef,
            triggerRef: triggerRef,
            placement: "end top",
            containerPadding: 0,
            crossOffset: offset,
            offset: offset,
            hideArrow: true,
            enableBothDismissButtons: true
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _focus.FocusScope), {
            restoreFocus: true
        }, content));
    }
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _context.SubmenuTriggerContext).Provider, {
        value: {
            isUnavailable,
            triggerRef,
            ...submenuTriggerProps
        }
    }, trigger), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.SlotProvider), {
        slots: slots
    }, submenuTriggerState.isOpen && overlay));
}
ContextualHelpTrigger.getCollectionNode = function* getCollectionNode(props) {
    let childArray = [];
    (0, _reactDefault.default).Children.forEach(props.children, (child)=>{
        if (/*#__PURE__*/ (0, _reactDefault.default).isValidElement(child)) childArray.push(child);
    });
    let [trigger] = childArray;
    let [, content] = props.children;
    yield {
        element: /*#__PURE__*/ (0, _reactDefault.default).cloneElement(trigger, {
            ...trigger.props,
            hasChildItems: true,
            isTrigger: true
        }),
        wrapper: (element)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(ContextualHelpTrigger, {
                key: element.key,
                targetKey: element.key,
                ...props
            }, element, content)
    };
};
let _Item = ContextualHelpTrigger;

},{"@react-spectrum/utils":"cMIJ6","@react-aria/focus":"42mbF","@react-aria/interactions":"ky3G8","@adobe/spectrum-css-temp/components/contextualhelp/vars.css":"8C22x","@react-spectrum/overlays":"3nwGn","react":"9yzVZ","react-dom":"cEvV3","@adobe/spectrum-css-temp/components/menu/vars.css":"gqElf","./context":"fEXAZ","./Menu":"4Thgz","@react-aria/menu":"89bvn","@react-stately/menu":"iqDQI","@react-aria/utils":"9cLk5","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"8C22x":[function(require,module,exports) {
module.exports["react-spectrum-ContextualHelp-button"] = `L6gUaa_react-spectrum-ContextualHelp-button`;
module.exports["react-spectrum-ContextualHelp-content"] = `L6gUaa_react-spectrum-ContextualHelp-content`;
module.exports["react-spectrum-ContextualHelp-dialog"] = `L6gUaa_react-spectrum-ContextualHelp-dialog`;
module.exports["react-spectrum-ContextualHelp-dialog--isMobile"] = `L6gUaa_react-spectrum-ContextualHelp-dialog--isMobile`;
module.exports["react-spectrum-ContextualHelp-footer"] = `L6gUaa_react-spectrum-ContextualHelp-footer`;

},{}],"9h6R6":[function(require,module,exports) {
module.exports["flex-container"] = `OizFzW_flex-container`;
module.exports["flex-gap"] = `OizFzW_flex-gap`;
module.exports["is-hovered"] = `OizFzW_is-hovered`;
module.exports["is-selected"] = `OizFzW_is-selected`;
module.exports["spectrum-ActionGroup"] = `OizFzW_spectrum-ActionGroup`;
module.exports["spectrum-ActionGroup--compact"] = `OizFzW_spectrum-ActionGroup--compact`;
module.exports["spectrum-ActionGroup--justified"] = `OizFzW_spectrum-ActionGroup--justified`;
module.exports["spectrum-ActionGroup--overflowCollapse"] = `OizFzW_spectrum-ActionGroup--overflowCollapse`;
module.exports["spectrum-ActionGroup--quiet"] = `OizFzW_spectrum-ActionGroup--quiet`;
module.exports["spectrum-ActionGroup--vertical"] = `OizFzW_spectrum-ActionGroup--vertical`;
module.exports["spectrum-ActionGroup-item"] = `OizFzW_spectrum-ActionGroup-item`;
module.exports["spectrum-ActionGroup-item--iconOnly"] = `OizFzW_spectrum-ActionGroup-item--iconOnly`;
module.exports["spectrum-ActionGroup-item--isDisabled"] = `OizFzW_spectrum-ActionGroup-item--isDisabled`;
module.exports["spectrum-ActionGroup-itemIcon"] = `OizFzW_spectrum-ActionGroup-itemIcon`;
module.exports["spectrum-ActionGroup-menu"] = `OizFzW_spectrum-ActionGroup-menu`;
module.exports["spectrum-ActionGroup-menu-chevron"] = `OizFzW_spectrum-ActionGroup-menu-chevron`;
module.exports["spectrum-ActionGroup-menu-contents"] = `OizFzW_spectrum-ActionGroup-menu-contents`;

},{}],"f9wa6":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /// <reference types="css-module-types" />
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Tooltip", ()=>(0, _tooltip.Tooltip));
parcelHelpers.export(exports, "TooltipTrigger", ()=>(0, _tooltipTrigger.TooltipTrigger));
var _tooltip = require("./Tooltip");
var _tooltipTrigger = require("./TooltipTrigger");

},{"./Tooltip":"8ZHNM","./TooltipTrigger":"aGQKz","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"8ZHNM":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Tooltip", ()=>_Tooltip);
var _alertSmall = require("@spectrum-icons/ui/AlertSmall");
var _alertSmallDefault = parcelHelpers.interopDefault(_alertSmall);
var _utils = require("@react-spectrum/utils");
var _infoSmall = require("@spectrum-icons/ui/InfoSmall");
var _infoSmallDefault = parcelHelpers.interopDefault(_infoSmall);
var _utils1 = require("@react-aria/utils");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _varsCss = require("@adobe/spectrum-css-temp/components/tooltip/vars.css");
var _varsCssDefault = parcelHelpers.interopDefault(_varsCss);
var _successSmall = require("@spectrum-icons/ui/SuccessSmall");
var _successSmallDefault = parcelHelpers.interopDefault(_successSmall);
var _context = require("./context");
var _tooltip = require("@react-aria/tooltip");
let iconMap = {
    info: (0, _infoSmallDefault.default),
    positive: (0, _successSmallDefault.default),
    negative: (0, _alertSmallDefault.default)
};
function Tooltip(props, ref) {
    let { ref: overlayRef, arrowProps, state, arrowRef, ...tooltipProviderProps } = (0, _react.useContext)((0, _context.TooltipContext));
    let defaultRef = (0, _react.useRef)();
    overlayRef = overlayRef || defaultRef;
    props = (0, _utils1.mergeProps)(props, tooltipProviderProps);
    let { variant = "neutral", placement = "top", isOpen, showIcon, ...otherProps } = props;
    let { styleProps } = (0, _utils.useStyleProps)(otherProps);
    let { tooltipProps } = (0, _tooltip.useTooltip)(props, state);
    // Sync ref with overlayRef from context.
    (0, _react.useImperativeHandle)(ref, ()=>(0, _utils.createDOMRef)(overlayRef));
    let Icon = iconMap[variant];
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...styleProps,
        ...tooltipProps,
        className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Tooltip", `spectrum-Tooltip--${variant}`, `spectrum-Tooltip--${placement}`, {
            "is-open": isOpen,
            [`is-open--${placement}`]: isOpen
        }, styleProps.className),
        ref: overlayRef
    }, showIcon && variant !== "neutral" && /*#__PURE__*/ (0, _reactDefault.default).createElement(Icon, {
        UNSAFE_className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Tooltip-typeIcon"),
        "aria-hidden": true
    }), props.children && /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Tooltip-label")
    }, props.children), /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        ...arrowProps,
        ref: arrowRef,
        className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Tooltip-tip")
    }));
}
/**
 * Display container for Tooltip content. Has a directional arrow dependent on its placement.
 */ let _Tooltip = /*#__PURE__*/ (0, _reactDefault.default).forwardRef(Tooltip);

},{"@spectrum-icons/ui/AlertSmall":"2ePSy","@react-spectrum/utils":"cMIJ6","@spectrum-icons/ui/InfoSmall":"4H2nF","@react-aria/utils":"9cLk5","react":"9yzVZ","@adobe/spectrum-css-temp/components/tooltip/vars.css":"iiUAU","@spectrum-icons/ui/SuccessSmall":"jhFFz","./context":"htrAB","@react-aria/tooltip":"kI5Vx","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"2ePSy":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("1d1529c52573785e");
exports.__esModule = true;
exports.default = AlertSmall;
var _extends2 = _interopRequireDefault(require("7a85f7eaf92965ae"));
var _AlertSmall = require("69279d4b23c30623");
var _icon = require("6a8e1b97b750422d");
var _provider = require("afb999190be94a0d");
var _react = _interopRequireDefault(require("5b4d9ff1ea02c9bb"));
const ExpressIcon = (props)=>/*#__PURE__*/ _react.default.createElement("svg", (0, _extends2.default)({
        viewBox: "0 0 14 14"
    }, props), /*#__PURE__*/ _react.default.createElement("path", {
        d: "M12.717 8.678 9 2.175C8.422 1.103 7.058.689 5.954 1.25a2.225 2.225 0 0 0-.95.92L1.278 8.687a2.198 2.198 0 0 0 .058 2.238A2.264 2.264 0 0 0 3.278 12h7.445a2.264 2.264 0 0 0 1.941-1.075 2.2 2.2 0 0 0 .053-2.247ZM6.133 4.133c0-.478.388-.866.866-.867.478 0 .867.388.868.866v3a.868.868 0 0 1-1.734.002V4.133ZM7 11.1c-.661 0-1.2-.538-1.2-1.2 0-.661.538-1.2 1.2-1.2.661 0 1.2.538 1.2 1.2 0 .661-.538 1.2-1.2 1.2Z"
    }));
ExpressIcon.displayName = _AlertSmall.AlertSmall.displayName;
function AlertSmall(props) {
    var _provider$theme, _provider$theme$globa;
    let provider = (0, _provider.useProvider)();
    return /*#__PURE__*/ _react.default.createElement(_icon.UIIcon, props, provider != null && (_provider$theme = provider.theme) != null && (_provider$theme$globa = _provider$theme.global) != null && _provider$theme$globa.express ? /*#__PURE__*/ _react.default.createElement(ExpressIcon, null) : /*#__PURE__*/ _react.default.createElement(_AlertSmall.AlertSmall, null));
}

},{"1d1529c52573785e":"iHubQ","7a85f7eaf92965ae":"l4mXf","69279d4b23c30623":"bnbWb","6a8e1b97b750422d":"k7wem","afb999190be94a0d":"5bCdp","5b4d9ff1ea02c9bb":"9yzVZ"}],"l4mXf":[function(require,module,exports) {
function _extends() {
    module.exports = _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    return _extends.apply(this, arguments);
}
module.exports = _extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"bnbWb":[function(require,module,exports) {
/**
* @adobe/react-spectrum-ui (c) by Adobe
* 
* @adobe/react-spectrum-ui is licensed under a
* Creative Commons Attribution-NoDerivatives 4.0 International License.
* 
* You should have received a copy of the license along with this
* work. If not, see <http://creativecommons.org/licenses/by-nd/4.0/>.
**/ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.AlertSmall = AlertSmall;
var _react = _interopRequireDefault(require("177e197c56f74d31"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function AlertSmall(_ref) {
    var _ref$scale = _ref.scale, scale = _ref$scale === void 0 ? "M" : _ref$scale, props = _objectWithoutProperties(_ref, [
        "scale"
    ]);
    return _react["default"].createElement("svg", _extends({}, props, props), scale === "L" && _react["default"].createElement("path", {
        d: "M8.564 1.289L.2 16.256A.5.5 0 0 0 .636 17h16.728a.5.5 0 0 0 .436-.744L9.436 1.289a.5.5 0 0 0-.872 0zM10 14.75a.25.25 0 0 1-.25.25h-1.5a.25.25 0 0 1-.25-.25v-1.5a.25.25 0 0 1 .25-.25h1.5a.25.25 0 0 1 .25.25zm0-3a.25.25 0 0 1-.25.25h-1.5a.25.25 0 0 1-.25-.25v-6a.25.25 0 0 1 .25-.25h1.5a.25.25 0 0 1 .25.25z"
    }), scale === "M" && _react["default"].createElement("path", {
        d: "M6.66 1.003L.157 12.643a.389.389 0 0 0 .339.58h13.01a.389.389 0 0 0 .34-.58L7.338 1.004a.389.389 0 0 0-.678 0zm1.118 10.47a.194.194 0 0 1-.195.194H6.417a.194.194 0 0 1-.195-.195v-1.166a.194.194 0 0 1 .195-.195h1.166a.194.194 0 0 1 .195.195zm0-2.334a.194.194 0 0 1-.195.194H6.417a.194.194 0 0 1-.195-.194V4.472a.194.194 0 0 1 .195-.194h1.166a.194.194 0 0 1 .195.194z"
    }));
}
AlertSmall.displayName = "AlertSmall";

},{"177e197c56f74d31":"9yzVZ"}],"4H2nF":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("1d2d7d16d84558d6");
exports.__esModule = true;
exports.default = InfoSmall;
var _extends2 = _interopRequireDefault(require("6d5dc9f1da81fa5e"));
var _InfoSmall = require("7e2019fffa1f0584");
var _icon = require("5c64bfe1b65e2533");
var _provider = require("e8f804a446695f00");
var _react = _interopRequireDefault(require("d761d9559d7bc21a"));
const ExpressIcon = (props)=>/*#__PURE__*/ _react.default.createElement("svg", (0, _extends2.default)({
        viewBox: "0 0 14 14"
    }, props), /*#__PURE__*/ _react.default.createElement("path", {
        d: "M7 1a6 6 0 1 0 6 6 6.007 6.007 0 0 0-6-6Zm.867 8.677a.868.868 0 0 1-1.734 0V7a.868.868 0 0 1 1.734 0v2.676ZM7 5.4c-.662 0-1.2-.538-1.2-1.2S6.338 3 7 3s1.2.539 1.2 1.2S7.662 5.4 7 5.4Z"
    }));
ExpressIcon.displayName = _InfoSmall.InfoSmall.displayName;
function InfoSmall(props) {
    var _provider$theme, _provider$theme$globa;
    let provider = (0, _provider.useProvider)();
    return /*#__PURE__*/ _react.default.createElement(_icon.UIIcon, props, provider != null && (_provider$theme = provider.theme) != null && (_provider$theme$globa = _provider$theme.global) != null && _provider$theme$globa.express ? /*#__PURE__*/ _react.default.createElement(ExpressIcon, null) : /*#__PURE__*/ _react.default.createElement(_InfoSmall.InfoSmall, null));
}

},{"1d2d7d16d84558d6":"iHubQ","6d5dc9f1da81fa5e":"l4mXf","7e2019fffa1f0584":"6SlgB","5c64bfe1b65e2533":"k7wem","e8f804a446695f00":"5bCdp","d761d9559d7bc21a":"9yzVZ"}],"6SlgB":[function(require,module,exports) {
/**
* @adobe/react-spectrum-ui (c) by Adobe
* 
* @adobe/react-spectrum-ui is licensed under a
* Creative Commons Attribution-NoDerivatives 4.0 International License.
* 
* You should have received a copy of the license along with this
* work. If not, see <http://creativecommons.org/licenses/by-nd/4.0/>.
**/ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.InfoSmall = InfoSmall;
var _react = _interopRequireDefault(require("dc3f5c7db105c891"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function InfoSmall(_ref) {
    var _ref$scale = _ref.scale, scale = _ref$scale === void 0 ? "M" : _ref$scale, props = _objectWithoutProperties(_ref, [
        "scale"
    ]);
    return _react["default"].createElement("svg", _extends({}, props, props), scale === "L" && _react["default"].createElement("path", {
        d: "M9 1a8 8 0 1 0 8 8 8 8 0 0 0-8-8zm-.15 2.15a1.359 1.359 0 0 1 1.431 1.283q.004.064.001.129A1.332 1.332 0 0 1 8.85 5.994a1.353 1.353 0 0 1-1.432-1.433 1.359 1.359 0 0 1 1.304-1.412q.064-.002.128.001zM11 13.5a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5H8V9h-.5a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5V12h.5a.5.5 0 0 1 .5.5z"
    }), scale === "M" && _react["default"].createElement("path", {
        d: "M7 .778A6.222 6.222 0 1 0 13.222 7 6.222 6.222 0 0 0 7 .778zM6.883 2.45a1.057 1.057 0 0 1 1.113.998q.003.05.001.1a1.036 1.036 0 0 1-1.114 1.114A1.052 1.052 0 0 1 5.77 3.547 1.057 1.057 0 0 1 6.784 2.45q.05-.002.1.001zm1.673 8.05a.389.389 0 0 1-.39.389H5.834a.389.389 0 0 1-.389-.389v-.778a.389.389 0 0 1 .39-.389h.388V7h-.389a.389.389 0 0 1-.389-.389v-.778a.389.389 0 0 1 .39-.389h1.555a.389.389 0 0 1 .389.39v3.5h.389a.389.389 0 0 1 .389.388z"
    }));
}
InfoSmall.displayName = "InfoSmall";

},{"dc3f5c7db105c891":"9yzVZ"}],"iiUAU":[function(require,module,exports) {
module.exports["focus-ring"] = `KF3Kcq_focus-ring`;
module.exports["i18nFontFamily"] = `KF3Kcq_i18nFontFamily`;
module.exports["is-focused"] = `KF3Kcq_is-focused`;
module.exports["is-hovered"] = `KF3Kcq_is-hovered`;
module.exports["spectrum-overlay--open"] = `KF3Kcq_spectrum-overlay--open`;
module.exports["is-open"] = `KF3Kcq_is-open ${module.exports["spectrum-overlay--open"]}`;
module.exports["spectrum-overlay--bottom--open"] = `KF3Kcq_spectrum-overlay--bottom--open`;
module.exports["is-open--bottom"] = `KF3Kcq_is-open--bottom ${module.exports["spectrum-overlay--bottom--open"]}`;
module.exports["spectrum-overlay--left--open"] = `KF3Kcq_spectrum-overlay--left--open`;
module.exports["is-open--left"] = `KF3Kcq_is-open--left ${module.exports["spectrum-overlay--left--open"]}`;
module.exports["spectrum-overlay--right--open"] = `KF3Kcq_spectrum-overlay--right--open`;
module.exports["is-open--right"] = `KF3Kcq_is-open--right ${module.exports["spectrum-overlay--right--open"]}`;
module.exports["spectrum-overlay--top--open"] = `KF3Kcq_spectrum-overlay--top--open`;
module.exports["is-open--top"] = `KF3Kcq_is-open--top ${module.exports["spectrum-overlay--top--open"]}`;
module.exports["spectrum-FocusRing-ring"] = `KF3Kcq_spectrum-FocusRing-ring`;
module.exports["spectrum-FocusRing"] = `KF3Kcq_spectrum-FocusRing ${module.exports["spectrum-FocusRing-ring"]}`;
module.exports["spectrum-FocusRing--quiet"] = `KF3Kcq_spectrum-FocusRing--quiet`;
module.exports["spectrum-overlay"] = `KF3Kcq_spectrum-overlay`;
module.exports["spectrum-Tooltip"] = `KF3Kcq_spectrum-Tooltip ${module.exports["spectrum-overlay"]}`;
module.exports["spectrum-Tooltip--bottom"] = `KF3Kcq_spectrum-Tooltip--bottom`;
module.exports["spectrum-Tooltip--error"] = `KF3Kcq_spectrum-Tooltip--error`;
module.exports["spectrum-Tooltip--help"] = `KF3Kcq_spectrum-Tooltip--help`;
module.exports["spectrum-Tooltip--info"] = `KF3Kcq_spectrum-Tooltip--info`;
module.exports["spectrum-Tooltip--left"] = `KF3Kcq_spectrum-Tooltip--left`;
module.exports["spectrum-Tooltip--negative"] = `KF3Kcq_spectrum-Tooltip--negative`;
module.exports["spectrum-Tooltip--positive"] = `KF3Kcq_spectrum-Tooltip--positive`;
module.exports["spectrum-Tooltip--right"] = `KF3Kcq_spectrum-Tooltip--right`;
module.exports["spectrum-Tooltip--success"] = `KF3Kcq_spectrum-Tooltip--success`;
module.exports["spectrum-Tooltip--top"] = `KF3Kcq_spectrum-Tooltip--top`;
module.exports["spectrum-Tooltip-label"] = `KF3Kcq_spectrum-Tooltip-label`;
module.exports["spectrum-Tooltip-tip"] = `KF3Kcq_spectrum-Tooltip-tip`;
module.exports["spectrum-Tooltip-typeIcon"] = `KF3Kcq_spectrum-Tooltip-typeIcon`;
module.exports["u-tooltip-showOnHover"] = `KF3Kcq_u-tooltip-showOnHover`;

},{}],"jhFFz":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("2df0a5325dfd3780");
exports.__esModule = true;
exports.default = SuccessSmall;
var _extends2 = _interopRequireDefault(require("754d4494f6874091"));
var _SuccessSmall = require("f3b5e3dbc671ce26");
var _icon = require("4e15a9757be14356");
var _provider = require("280e96353713a99a");
var _react = _interopRequireDefault(require("635c0c12c060dda"));
const ExpressIcon = (props)=>/*#__PURE__*/ _react.default.createElement("svg", (0, _extends2.default)({
        viewBox: "0 0 14 14"
    }, props), /*#__PURE__*/ _react.default.createElement("path", {
        d: "M11.523 3.057a6 6 0 1 0-9.046 7.887 6 6 0 0 0 9.046-7.887Zm-1.166 2.275L7.075 9.696a.867.867 0 0 1-.617.342l-.076.004a.864.864 0 0 1-.592-.235L3.55 7.704c-.17-.159-.266-.373-.274-.604s.077-.453.235-.621a.87.87 0 0 1 1.225-.04L6.27 7.881 8.973 4.29a.86.86 0 0 1 .693-.346.867.867 0 0 1 .692 1.388Z"
    }));
ExpressIcon.displayName = _SuccessSmall.SuccessSmall.displayName;
function SuccessSmall(props) {
    var _provider$theme, _provider$theme$globa;
    let provider = (0, _provider.useProvider)();
    return /*#__PURE__*/ _react.default.createElement(_icon.UIIcon, props, provider != null && (_provider$theme = provider.theme) != null && (_provider$theme$globa = _provider$theme.global) != null && _provider$theme$globa.express ? /*#__PURE__*/ _react.default.createElement(ExpressIcon, null) : /*#__PURE__*/ _react.default.createElement(_SuccessSmall.SuccessSmall, null));
}

},{"2df0a5325dfd3780":"iHubQ","754d4494f6874091":"l4mXf","f3b5e3dbc671ce26":"414I4","4e15a9757be14356":"k7wem","280e96353713a99a":"5bCdp","635c0c12c060dda":"9yzVZ"}],"414I4":[function(require,module,exports) {
/**
* @adobe/react-spectrum-ui (c) by Adobe
* 
* @adobe/react-spectrum-ui is licensed under a
* Creative Commons Attribution-NoDerivatives 4.0 International License.
* 
* You should have received a copy of the license along with this
* work. If not, see <http://creativecommons.org/licenses/by-nd/4.0/>.
**/ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SuccessSmall = SuccessSmall;
var _react = _interopRequireDefault(require("e63c0e1650c58737"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function SuccessSmall(_ref) {
    var _ref$scale = _ref.scale, scale = _ref$scale === void 0 ? "M" : _ref$scale, props = _objectWithoutProperties(_ref, [
        "scale"
    ]);
    return _react["default"].createElement("svg", _extends({}, props, props), scale === "L" && _react["default"].createElement("path", {
        d: "M9 1a8 8 0 1 0 8 8 8 8 0 0 0-8-8zm5.333 4.54l-6.324 8.13a.6.6 0 0 1-.437.23h-.037a.6.6 0 0 1-.425-.176l-3.893-3.9a.6.6 0 0 1 0-.849l.663-.663a.6.6 0 0 1 .848 0L7.4 10.991l5.256-6.754a.6.6 0 0 1 .843-.1l.728.566a.6.6 0 0 1 .106.837z"
    }), scale === "M" && _react["default"].createElement("path", {
        d: "M7 .778A6.222 6.222 0 1 0 13.222 7 6.222 6.222 0 0 0 7 .778zm4.148 3.53l-4.919 6.324a.467.467 0 0 1-.34.18h-.028a.467.467 0 0 1-.331-.138L2.502 7.641a.467.467 0 0 1 0-.66l.516-.516a.467.467 0 0 1 .66 0l2.078 2.084 4.088-5.254a.467.467 0 0 1 .655-.078l.566.44a.467.467 0 0 1 .083.652z"
    }));
}
SuccessSmall.displayName = "SuccessSmall";

},{"e63c0e1650c58737":"9yzVZ"}],"htrAB":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TooltipContext", ()=>TooltipContext);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const TooltipContext = (0, _reactDefault.default).createContext({});

},{"react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"aGQKz":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TooltipTrigger", ()=>_TooltipTrigger);
var _focus = require("@react-aria/focus");
var _overlays = require("@react-spectrum/overlays");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _context = require("./context");
var _utils = require("@react-aria/utils");
var _overlays1 = require("@react-aria/overlays");
var _tooltip = require("@react-aria/tooltip");
var _tooltip1 = require("@react-stately/tooltip");
const DEFAULT_OFFSET = -1; // Offset needed to reach 4px/5px (med/large) distance between tooltip and trigger button
const DEFAULT_CROSS_OFFSET = 0;
function TooltipTrigger(props) {
    let { children, crossOffset = DEFAULT_CROSS_OFFSET, isDisabled, offset = DEFAULT_OFFSET, trigger: triggerAction } = props;
    let [trigger, tooltip] = (0, _reactDefault.default).Children.toArray(children);
    let state = (0, _tooltip1.useTooltipTriggerState)(props);
    let tooltipTriggerRef = (0, _react.useRef)();
    let overlayRef = (0, _react.useRef)();
    let { triggerProps, tooltipProps } = (0, _tooltip.useTooltipTrigger)({
        isDisabled,
        trigger: triggerAction
    }, state, tooltipTriggerRef);
    let [borderRadius, setBorderRadius] = (0, _react.useState)(0);
    (0, _utils.useLayoutEffect)(()=>{
        if (overlayRef.current && state.isOpen) {
            let spectrumBorderRadius = window.getComputedStyle(overlayRef.current).borderRadius;
            if (spectrumBorderRadius !== "") setBorderRadius(parseInt(spectrumBorderRadius, 10));
        }
    }, [
        state.isOpen,
        overlayRef
    ]);
    let arrowRef = (0, _react.useRef)(null);
    let [arrowWidth, setArrowWidth] = (0, _react.useState)(0);
    (0, _utils.useLayoutEffect)(()=>{
        if (arrowRef.current && state.isOpen) setArrowWidth(arrowRef.current.getBoundingClientRect().width);
    }, [
        state.isOpen,
        arrowRef
    ]);
    let { overlayProps, arrowProps, placement } = (0, _overlays1.useOverlayPosition)({
        placement: props.placement || "top",
        targetRef: tooltipTriggerRef,
        overlayRef,
        offset,
        crossOffset,
        isOpen: state.isOpen,
        shouldFlip: props.shouldFlip,
        containerPadding: props.containerPadding,
        arrowSize: arrowWidth,
        arrowBoundaryOffset: borderRadius
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _focus.FocusableProvider), {
        ...triggerProps,
        ref: tooltipTriggerRef
    }, trigger, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _context.TooltipContext).Provider, {
        value: {
            state,
            placement,
            ref: overlayRef,
            UNSAFE_style: overlayProps.style,
            arrowProps,
            arrowRef: arrowRef,
            ...tooltipProps
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _overlays.Overlay), {
        isOpen: state.isOpen,
        nodeRef: overlayRef
    }, tooltip)));
}
// Support TooltipTrigger inside components using CollectionBuilder.
TooltipTrigger.getCollectionNode = function*(props) {
    // Replaced the use of React.Childern.toArray because it mutates the key prop.
    let childArray = [];
    (0, _reactDefault.default).Children.forEach(props.children, (child)=>{
        if (/*#__PURE__*/ (0, _reactDefault.default).isValidElement(child)) childArray.push(child);
    });
    let [trigger, tooltip] = childArray;
    yield {
        element: trigger,
        wrapper: (element)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(TooltipTrigger, {
                key: element.key,
                ...props
            }, element, tooltip)
    };
};
/**
 * TooltipTrigger wraps around a trigger element and a Tooltip. It handles opening and closing
 * the Tooltip when the user hovers over or focuses the trigger, and positioning the Tooltip
 * relative to the trigger.
 */ // We don't want getCollectionNode to show up in the type definition
let _TooltipTrigger = TooltipTrigger;

},{"@react-aria/focus":"42mbF","@react-spectrum/overlays":"3nwGn","react":"9yzVZ","./context":"htrAB","@react-aria/utils":"9cLk5","@react-aria/overlays":"5fTCg","@react-aria/tooltip":"kI5Vx","@react-stately/tooltip":"6Tizp","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"l9PWo":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 * 
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useActionGroup", ()=>(0, _useActionGroup.useActionGroup));
parcelHelpers.export(exports, "useActionGroupItem", ()=>(0, _useActionGroupItem.useActionGroupItem));
var _useActionGroup = require("./useActionGroup");
var _useActionGroupItem = require("./useActionGroupItem");

},{"./useActionGroup":"hIFtP","./useActionGroupItem":"jptP5","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"hIFtP":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useActionGroup", ()=>useActionGroup);
var _focus = require("@react-aria/focus");
var _utils = require("@react-aria/utils");
var _react = require("react");
var _i18N = require("@react-aria/i18n");
const BUTTON_GROUP_ROLES = {
    "none": "toolbar",
    "single": "radiogroup",
    "multiple": "toolbar"
};
function useActionGroup(props, state, ref) {
    let { isDisabled, orientation = "horizontal" } = props;
    let [isInToolbar, setInToolbar] = (0, _react.useState)(false);
    (0, _utils.useLayoutEffect)(()=>{
        var _ref_current_parentElement;
        setInToolbar(!!(ref.current && ((_ref_current_parentElement = ref.current.parentElement) === null || _ref_current_parentElement === void 0 ? void 0 : _ref_current_parentElement.closest('[role="toolbar"]'))));
    }, [
        ref
    ]);
    let allKeys = [
        ...state.collection.getKeys()
    ];
    if (!allKeys.some((key)=>!state.disabledKeys.has(key))) isDisabled = true;
    let { direction } = (0, _i18N.useLocale)();
    let focusManager = (0, _focus.createFocusManager)(ref);
    let flipDirection = direction === "rtl" && orientation === "horizontal";
    let onKeyDown = (e)=>{
        if (!e.currentTarget.contains(e.target)) return;
        switch(e.key){
            case "ArrowRight":
            case "ArrowDown":
                e.preventDefault();
                e.stopPropagation();
                if (e.key === "ArrowRight" && flipDirection) focusManager.focusPrevious({
                    wrap: true
                });
                else focusManager.focusNext({
                    wrap: true
                });
                break;
            case "ArrowLeft":
            case "ArrowUp":
                e.preventDefault();
                e.stopPropagation();
                if (e.key === "ArrowLeft" && flipDirection) focusManager.focusNext({
                    wrap: true
                });
                else focusManager.focusPrevious({
                    wrap: true
                });
                break;
        }
    };
    let role = BUTTON_GROUP_ROLES[state.selectionManager.selectionMode];
    if (isInToolbar && role === "toolbar") role = "group";
    return {
        actionGroupProps: {
            ...(0, _utils.filterDOMProps)(props, {
                labelable: true
            }),
            role,
            "aria-orientation": role === "toolbar" ? orientation : undefined,
            "aria-disabled": isDisabled,
            onKeyDown
        }
    };
}

},{"@react-aria/focus":"42mbF","@react-aria/utils":"9cLk5","react":"9yzVZ","@react-aria/i18n":"411rg","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"jptP5":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// eslint-disable-next-line @typescript-eslint/no-unused-vars
parcelHelpers.export(exports, "useActionGroupItem", ()=>useActionGroupItem);
var _utils = require("@react-aria/utils");
var _react = require("react");
const BUTTON_ROLES = {
    "none": undefined,
    "single": "radio",
    "multiple": "checkbox"
};
function useActionGroupItem(props, state, ref) {
    let selectionMode = state.selectionManager.selectionMode;
    let buttonProps = {
        role: BUTTON_ROLES[selectionMode]
    };
    if (selectionMode !== "none") {
        let isSelected = state.selectionManager.isSelected(props.key);
        buttonProps["aria-checked"] = isSelected;
    }
    let isFocused = props.key === state.selectionManager.focusedKey;
    let onRemovedWithFocus = (0, _utils.useEffectEvent)(()=>{
        if (isFocused) state.selectionManager.setFocusedKey(null);
    });
    // If the focused item is removed from the DOM, reset the focused key to null.
    (0, _react.useEffect)(()=>{
        return ()=>{
            onRemovedWithFocus();
        };
    }, [
        onRemovedWithFocus
    ]);
    return {
        buttonProps: (0, _utils.mergeProps)(buttonProps, {
            tabIndex: isFocused || state.selectionManager.focusedKey == null ? 0 : -1,
            onFocus () {
                state.selectionManager.setFocusedKey(props.key);
            },
            onPress () {
                state.selectionManager.select(props.key);
            }
        })
    };
}

},{"@react-aria/utils":"9cLk5","react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"dnRjt":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /// <reference types="css-module-types" />
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "View", ()=>(0, _view.View));
parcelHelpers.export(exports, "Content", ()=>(0, _content.Content));
parcelHelpers.export(exports, "Footer", ()=>(0, _footer.Footer));
parcelHelpers.export(exports, "Header", ()=>(0, _header.Header));
var _view = require("./View");
var _content = require("./Content");
var _footer = require("./Footer");
var _header = require("./Header");

},{"./View":"gFeK5","./Content":"7E5PE","./Footer":"btLEv","./Header":"fT1wt","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"gFeK5":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "View", ()=>_View);
var _utils = require("@react-spectrum/utils");
var _utils1 = require("@react-aria/utils");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
function View(props, ref) {
    props = (0, _utils.useSlotProps)(props);
    let { elementType: ElementType = "div", children, ...otherProps } = props;
    let { styleProps } = (0, _utils.useStyleProps)(props, (0, _utils.viewStyleProps));
    let domRef = (0, _utils.useDOMRef)(ref);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(ElementType, {
        ...(0, _utils1.filterDOMProps)(otherProps),
        ...styleProps,
        ref: domRef
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.ClearSlots), null, children));
}
/**
 * View is a general purpose container with no specific semantics that can be used for custom styling purposes.
 * It supports Spectrum style props to ensure consistency with other Spectrum components.
 */ const _View = /*#__PURE__*/ (0, _react.forwardRef)(View);

},{"@react-spectrum/utils":"cMIJ6","@react-aria/utils":"9cLk5","react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"7E5PE":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Content", ()=>_Content);
var _utils = require("@react-spectrum/utils");
var _utils1 = require("@react-aria/utils");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
function Content(props, ref) {
    props = (0, _utils.useSlotProps)(props, "content");
    let { children, ...otherProps } = props;
    let { styleProps } = (0, _utils.useStyleProps)(otherProps);
    let domRef = (0, _utils.useDOMRef)(ref);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("section", {
        ...(0, _utils1.filterDOMProps)(otherProps),
        ...styleProps,
        ref: domRef
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.ClearSlots), null, children));
}
/**
 * Content represents the primary content within a Spectrum container.
 */ const _Content = /*#__PURE__*/ (0, _react.forwardRef)(Content);

},{"@react-spectrum/utils":"cMIJ6","@react-aria/utils":"9cLk5","react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"btLEv":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Footer", ()=>_Footer);
var _utils = require("@react-spectrum/utils");
var _utils1 = require("@react-aria/utils");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
function Footer(props, ref) {
    props = (0, _utils.useSlotProps)(props, "footer");
    let { children, ...otherProps } = props;
    let { styleProps } = (0, _utils.useStyleProps)(otherProps);
    let domRef = (0, _utils.useDOMRef)(ref);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("footer", {
        ...(0, _utils1.filterDOMProps)(otherProps),
        ...styleProps,
        ref: domRef
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.ClearSlots), null, children));
}
/**
 * Footer represents a footer within a Spectrum container.
 */ const _Footer = /*#__PURE__*/ (0, _react.forwardRef)(Footer);

},{"@react-spectrum/utils":"cMIJ6","@react-aria/utils":"9cLk5","react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"fT1wt":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Header", ()=>_Header);
var _utils = require("@react-spectrum/utils");
var _utils1 = require("@react-aria/utils");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
function Header(props, ref) {
    props = (0, _utils.useSlotProps)(props, "header");
    let { children, ...otherProps } = props;
    let { styleProps } = (0, _utils.useStyleProps)(otherProps);
    let domRef = (0, _utils.useDOMRef)(ref);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("header", {
        ...(0, _utils1.filterDOMProps)(otherProps),
        ...styleProps,
        ref: domRef
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.ClearSlots), null, children));
}
/**
 * Header represents a header within a Spectrum container.
 */ const _Header = /*#__PURE__*/ (0, _react.forwardRef)(Header);

},{"@react-spectrum/utils":"cMIJ6","@react-aria/utils":"9cLk5","react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"jpSBZ":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("1159bdfea4914f1e");
exports.__esModule = true;
exports.default = Copy;
var _Copy = require("76884d22bd1fcced");
var _icon = require("84754fdcc98900dc");
var _react = _interopRequireDefault(require("c00e2e415c3457a9"));
function Copy(props) {
    return /*#__PURE__*/ _react.default.createElement(_icon.Icon, props, /*#__PURE__*/ _react.default.createElement(_Copy.A4uCopy, null));
}

},{"1159bdfea4914f1e":"iHubQ","76884d22bd1fcced":"cnpz6","84754fdcc98900dc":"k7wem","c00e2e415c3457a9":"9yzVZ"}],"cnpz6":[function(require,module,exports) {
/**
* @adobe/react-spectrum-workflow (c) by Adobe
* 
* @adobe/react-spectrum-workflow is licensed under a
* Creative Commons Attribution-NoDerivatives 4.0 International License.
* 
* You should have received a copy of the license along with this
* work. If not, see <http://creativecommons.org/licenses/by-nd/4.0/>.
**/ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.A4uCopy = A4uCopy;
var _react = _interopRequireDefault(require("d66f1aefb04d8870"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function A4uCopy(_ref) {
    var props = _extends({}, _ref);
    return /*#__PURE__*/ _react["default"].createElement("svg", _extends({
        viewBox: "0 0 36 36"
    }, props, props), /*#__PURE__*/ _react["default"].createElement("rect", {
        fillRule: "evenodd",
        height: "2",
        rx: "0.5",
        ry: "0.5",
        width: "2",
        x: "32",
        y: "22"
    }), /*#__PURE__*/ _react["default"].createElement("rect", {
        fillRule: "evenodd",
        height: "2",
        rx: "0.5",
        ry: "0.5",
        width: "2",
        x: "32",
        y: "18"
    }), /*#__PURE__*/ _react["default"].createElement("rect", {
        fillRule: "evenodd",
        height: "2",
        rx: "0.5",
        ry: "0.5",
        width: "2",
        x: "32",
        y: "14"
    }), /*#__PURE__*/ _react["default"].createElement("rect", {
        fillRule: "evenodd",
        height: "2",
        rx: "0.5",
        ry: "0.5",
        width: "2",
        x: "32",
        y: "10"
    }), /*#__PURE__*/ _react["default"].createElement("rect", {
        fillRule: "evenodd",
        height: "2",
        rx: "0.5",
        ry: "0.5",
        width: "2",
        x: "32",
        y: "6"
    }), /*#__PURE__*/ _react["default"].createElement("rect", {
        fillRule: "evenodd",
        height: "2",
        rx: "0.5",
        ry: "0.5",
        width: "2",
        x: "32",
        y: "2"
    }), /*#__PURE__*/ _react["default"].createElement("rect", {
        fillRule: "evenodd",
        height: "2",
        rx: "0.5",
        ry: "0.5",
        width: "2",
        x: "28",
        y: "2"
    }), /*#__PURE__*/ _react["default"].createElement("rect", {
        fillRule: "evenodd",
        height: "2",
        rx: "0.5",
        ry: "0.5",
        width: "2",
        x: "24",
        y: "2"
    }), /*#__PURE__*/ _react["default"].createElement("rect", {
        fillRule: "evenodd",
        height: "2",
        rx: "0.5",
        ry: "0.5",
        width: "2",
        x: "20",
        y: "2"
    }), /*#__PURE__*/ _react["default"].createElement("rect", {
        fillRule: "evenodd",
        height: "2",
        rx: "0.5",
        ry: "0.5",
        width: "2",
        x: "16",
        y: "2"
    }), /*#__PURE__*/ _react["default"].createElement("rect", {
        fillRule: "evenodd",
        height: "2",
        rx: "0.5",
        ry: "0.5",
        width: "2",
        x: "12",
        y: "2"
    }), /*#__PURE__*/ _react["default"].createElement("rect", {
        fillRule: "evenodd",
        height: "2",
        rx: "0.5",
        ry: "0.5",
        width: "2",
        x: "12",
        y: "6"
    }), /*#__PURE__*/ _react["default"].createElement("rect", {
        fillRule: "evenodd",
        height: "2",
        rx: "0.5",
        ry: "0.5",
        width: "2",
        x: "12",
        y: "10"
    }), /*#__PURE__*/ _react["default"].createElement("rect", {
        fillRule: "evenodd",
        height: "2",
        rx: "0.5",
        ry: "0.5",
        width: "2",
        x: "12",
        y: "14"
    }), /*#__PURE__*/ _react["default"].createElement("rect", {
        fillRule: "evenodd",
        height: "2",
        rx: "0.5",
        ry: "0.5",
        width: "2",
        x: "12",
        y: "18"
    }), /*#__PURE__*/ _react["default"].createElement("rect", {
        fillRule: "evenodd",
        height: "2",
        rx: "0.5",
        ry: "0.5",
        width: "2",
        x: "12",
        y: "22"
    }), /*#__PURE__*/ _react["default"].createElement("rect", {
        fillRule: "evenodd",
        height: "2",
        rx: "0.5",
        ry: "0.5",
        width: "2",
        x: "16",
        y: "22"
    }), /*#__PURE__*/ _react["default"].createElement("rect", {
        fillRule: "evenodd",
        height: "2",
        rx: "0.5",
        ry: "0.5",
        width: "2",
        x: "20",
        y: "22"
    }), /*#__PURE__*/ _react["default"].createElement("rect", {
        fillRule: "evenodd",
        height: "2",
        rx: "0.5",
        ry: "0.5",
        width: "2",
        x: "24",
        y: "22"
    }), /*#__PURE__*/ _react["default"].createElement("rect", {
        fillRule: "evenodd",
        height: "2",
        rx: "0.5",
        ry: "0.5",
        width: "2",
        x: "28",
        y: "22"
    }), /*#__PURE__*/ _react["default"].createElement("path", {
        fillRule: "evenodd",
        d: "M10,12H3a1,1,0,0,0-1,1V33a1,1,0,0,0,1,1H23a1,1,0,0,0,1-1V26H11a1,1,0,0,1-1-1Z"
    }));
}

},{"d66f1aefb04d8870":"9yzVZ"}],"4SMrV":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("da981a33bbd17906");
exports.__esModule = true;
exports.default = Cut;
var _Cut = require("2dc30f15d6c369b1");
var _icon = require("1fefb54780b4c7d5");
var _react = _interopRequireDefault(require("80b4a8e528553d67"));
function Cut(props) {
    return /*#__PURE__*/ _react.default.createElement(_icon.Icon, props, /*#__PURE__*/ _react.default.createElement(_Cut.A4uCut, null));
}

},{"da981a33bbd17906":"iHubQ","2dc30f15d6c369b1":"jNbF9","1fefb54780b4c7d5":"k7wem","80b4a8e528553d67":"9yzVZ"}],"jNbF9":[function(require,module,exports) {
/**
* @adobe/react-spectrum-workflow (c) by Adobe
* 
* @adobe/react-spectrum-workflow is licensed under a
* Creative Commons Attribution-NoDerivatives 4.0 International License.
* 
* You should have received a copy of the license along with this
* work. If not, see <http://creativecommons.org/licenses/by-nd/4.0/>.
**/ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.A4uCut = A4uCut;
var _react = _interopRequireDefault(require("b5094c81682eee9d"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function A4uCut(_ref) {
    var props = _extends({}, _ref);
    return /*#__PURE__*/ _react["default"].createElement("svg", _extends({
        viewBox: "0 0 36 36"
    }, props, props), /*#__PURE__*/ _react["default"].createElement("path", {
        fillRule: "evenodd",
        d: "M29.912,22.12c0-.007.035-.028.026-.028A8.481,8.481,0,0,1,22.8,18.074c-.017-.028-.046-.047-.065-.074.019-.027.048-.046.065-.074a8.481,8.481,0,0,1,7.142-4.018c.009,0-.023-.021-.026-.028a5.917,5.917,0,1,0-3.93-1.588l-6.47,3.444-12.6-6.7a4,4,0,0,0-3.8.023L.822,10.313,15.26,18,.822,25.687l2.292,1.255a4,4,0,0,0,3.8.023l12.6-6.7,6.47,3.444a5.892,5.892,0,1,0,3.93-1.588Zm.367-18.038a3.933,3.933,0,1,1-4.2,3.641A3.932,3.932,0,0,1,30.279,4.082Zm0,27.836a3.933,3.933,0,1,1,3.641-4.2A3.933,3.933,0,0,1,30.279,31.918Z"
    }));
}

},{"b5094c81682eee9d":"9yzVZ"}],"3G0HV":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /// <reference types="css-module-types" />
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AlertDialog", ()=>(0, _alertDialog.AlertDialog));
parcelHelpers.export(exports, "Dialog", ()=>(0, _dialog.Dialog));
parcelHelpers.export(exports, "DialogTrigger", ()=>(0, _dialogTrigger.DialogTrigger));
parcelHelpers.export(exports, "DialogContainer", ()=>(0, _dialogContainer.DialogContainer));
parcelHelpers.export(exports, "useDialogContainer", ()=>(0, _useDialogContainer.useDialogContainer));
var _alertDialog = require("./AlertDialog");
var _dialog = require("./Dialog");
var _dialogTrigger = require("./DialogTrigger");
var _dialogContainer = require("./DialogContainer");
var _useDialogContainer = require("./useDialogContainer");

},{"./AlertDialog":"jl6Hp","./Dialog":"j9RkN","./DialogTrigger":"ityjA","./DialogContainer":"5MsDj","./useDialogContainer":"gsvMq","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"jl6Hp":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AlertDialog", ()=>_AlertDialog);
var _alertMedium = require("@spectrum-icons/ui/AlertMedium");
var _alertMediumDefault = parcelHelpers.interopDefault(_alertMedium);
var _button = require("@react-spectrum/button");
var _buttongroup = require("@react-spectrum/buttongroup");
var _utils = require("@react-aria/utils");
var _utils1 = require("@react-spectrum/utils");
var _view = require("@react-spectrum/view");
var _dialog = require("./Dialog");
var _context = require("./context");
var _divider = require("@react-spectrum/divider");
var _text = require("@react-spectrum/text");
// @ts-ignore
var _json = require("../intl/*.json");
var _jsonDefault = parcelHelpers.interopDefault(_json);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _varsCss = require("@adobe/spectrum-css-temp/components/dialog/vars.css");
var _varsCssDefault = parcelHelpers.interopDefault(_varsCss);
var _i18N = require("@react-aria/i18n");
/**
 * AlertDialogs are a specific type of Dialog. They display important information that users need to acknowledge.
 */ function AlertDialog(props, ref) {
    let { onClose = ()=>{} } = (0, _react.useContext)((0, _context.DialogContext)) || {};
    let { variant, children, primaryActionLabel, secondaryActionLabel, cancelLabel, autoFocusButton, title, isPrimaryActionDisabled, isSecondaryActionDisabled, onCancel = ()=>{}, onPrimaryAction = ()=>{}, onSecondaryAction = ()=>{}, ...otherProps } = props;
    let { styleProps } = (0, _utils1.useStyleProps)(otherProps);
    let stringFormatter = (0, _i18N.useLocalizedStringFormatter)((0, _jsonDefault.default), "@react-spectrum/dialog");
    let confirmVariant = "primary";
    if (variant) {
        if (variant === "confirmation") confirmVariant = "cta";
        else if (variant === "destructive") confirmVariant = "negative";
    }
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _dialog.Dialog), {
        UNSAFE_style: styleProps.style,
        UNSAFE_className: (0, _utils1.classNames)((0, _varsCssDefault.default), {
            [`spectrum-Dialog--${variant}`]: variant
        }, styleProps.className),
        isHidden: styleProps.hidden,
        size: "M",
        role: "alertdialog",
        ref: ref
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Heading), null, title), (variant === "error" || variant === "warning") && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _alertMediumDefault.default), {
        slot: "typeIcon",
        "aria-label": stringFormatter.format("alert")
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _divider.Divider), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Content), null, children), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _buttongroup.ButtonGroup), {
        align: "end"
    }, cancelLabel && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.Button), {
        variant: "secondary",
        onPress: ()=>(0, _utils.chain)(onClose(), onCancel()),
        autoFocus: autoFocusButton === "cancel"
    }, cancelLabel), secondaryActionLabel && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.Button), {
        variant: "secondary",
        onPress: ()=>(0, _utils.chain)(onClose(), onSecondaryAction()),
        isDisabled: isSecondaryActionDisabled,
        autoFocus: autoFocusButton === "secondary"
    }, secondaryActionLabel), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.Button), {
        variant: confirmVariant,
        onPress: ()=>(0, _utils.chain)(onClose(), onPrimaryAction()),
        isDisabled: isPrimaryActionDisabled,
        autoFocus: autoFocusButton === "primary"
    }, primaryActionLabel)));
}
/**
 * AlertDialogs are a specific type of Dialog. They display important information that users need to acknowledge.
 */ let _AlertDialog = /*#__PURE__*/ (0, _react.forwardRef)(AlertDialog);

},{"@spectrum-icons/ui/AlertMedium":"2v5QX","@react-spectrum/button":"jZWyP","@react-spectrum/buttongroup":"anP11","@react-aria/utils":"9cLk5","@react-spectrum/utils":"cMIJ6","@react-spectrum/view":"dnRjt","./Dialog":"j9RkN","./context":"5cYYD","@react-spectrum/divider":"dxmqN","@react-spectrum/text":"etCGI","../intl/*.json":"21NEj","react":"9yzVZ","@adobe/spectrum-css-temp/components/dialog/vars.css":"jheU5","@react-aria/i18n":"411rg","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"2v5QX":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("45277d9e3df93d6d");
exports.__esModule = true;
exports.default = AlertMedium;
var _extends2 = _interopRequireDefault(require("acc48a9e1dcbdfb"));
var _AlertMedium = require("24388f28be701b07");
var _icon = require("cf4e06b38b879631");
var _provider = require("854d264222fabe4b");
var _react = _interopRequireDefault(require("acd8f3ae4c6a6d7d"));
const ExpressIcon = (props)=>/*#__PURE__*/ _react.default.createElement("svg", (0, _extends2.default)({
        viewBox: "0 0 18 18"
    }, props), /*#__PURE__*/ _react.default.createElement("path", {
        d: "M9 10.5a1 1 0 0 1-1-1V5a1 1 0 1 1 2 0v4.5a1 1 0 0 1-1 1Zm0 1.25A1.25 1.25 0 1 0 10.25 13 1.25 1.25 0 0 0 9 11.75Zm8.497 3.589a3.49 3.49 0 0 0 .079-3.474L12 1.815a3.385 3.385 0 0 0-5.994-.007L.416 11.88a3.485 3.485 0 0 0 .089 3.459A3.375 3.375 0 0 0 3.416 17h11.169a3.375 3.375 0 0 0 2.912-1.661ZM10.244 2.77l5.575 10.05a1.497 1.497 0 0 1-.037 1.489 1.374 1.374 0 0 1-1.197.69H3.416a1.374 1.374 0 0 1-1.197-.69 1.493 1.493 0 0 1-.046-1.474l5.593-10.08a1.386 1.386 0 0 1 2.478.015Z"
    }));
ExpressIcon.displayName = _AlertMedium.AlertMedium.displayName;
function AlertMedium(props) {
    var _provider$theme, _provider$theme$globa;
    let provider = (0, _provider.useProvider)();
    return /*#__PURE__*/ _react.default.createElement(_icon.UIIcon, props, provider != null && (_provider$theme = provider.theme) != null && (_provider$theme$globa = _provider$theme.global) != null && _provider$theme$globa.express ? /*#__PURE__*/ _react.default.createElement(ExpressIcon, null) : /*#__PURE__*/ _react.default.createElement(_AlertMedium.AlertMedium, null));
}

},{"45277d9e3df93d6d":"iHubQ","acc48a9e1dcbdfb":"l4mXf","24388f28be701b07":"h6GlQ","cf4e06b38b879631":"k7wem","854d264222fabe4b":"5bCdp","acd8f3ae4c6a6d7d":"9yzVZ"}],"h6GlQ":[function(require,module,exports) {
/**
* @adobe/react-spectrum-ui (c) by Adobe
* 
* @adobe/react-spectrum-ui is licensed under a
* Creative Commons Attribution-NoDerivatives 4.0 International License.
* 
* You should have received a copy of the license along with this
* work. If not, see <http://creativecommons.org/licenses/by-nd/4.0/>.
**/ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.AlertMedium = AlertMedium;
var _react = _interopRequireDefault(require("96a8dd2bf834bc9d"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function AlertMedium(_ref) {
    var _ref$scale = _ref.scale, scale = _ref$scale === void 0 ? "M" : _ref$scale, props = _objectWithoutProperties(_ref, [
        "scale"
    ]);
    return _react["default"].createElement("svg", _extends({}, props, props), scale === "L" && _react["default"].createElement("path", {
        d: "M10.563 2.206l-9.249 16.55a.5.5 0 0 0 .436.744h18.5a.5.5 0 0 0 .436-.744l-9.251-16.55a.5.5 0 0 0-.872 0zm1.436 15.044a.25.25 0 0 1-.25.25h-1.5a.25.25 0 0 1-.25-.25v-1.5a.25.25 0 0 1 .25-.25h1.5a.25.25 0 0 1 .25.25zm0-3.5a.25.25 0 0 1-.25.25h-1.5a.25.25 0 0 1-.25-.25v-6a.25.25 0 0 1 .25-.25h1.5a.25.25 0 0 1 .25.25z"
    }), scale === "M" && _react["default"].createElement("path", {
        d: "M8.564 1.289L.2 16.256A.5.5 0 0 0 .636 17h16.728a.5.5 0 0 0 .436-.744L9.436 1.289a.5.5 0 0 0-.872 0zM10 14.75a.25.25 0 0 1-.25.25h-1.5a.25.25 0 0 1-.25-.25v-1.5a.25.25 0 0 1 .25-.25h1.5a.25.25 0 0 1 .25.25zm0-3a.25.25 0 0 1-.25.25h-1.5a.25.25 0 0 1-.25-.25v-6a.25.25 0 0 1 .25-.25h1.5a.25.25 0 0 1 .25.25z"
    }));
}
AlertMedium.displayName = "AlertMedium";

},{"96a8dd2bf834bc9d":"9yzVZ"}],"anP11":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /// <reference types="css-module-types" />
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ButtonGroup", ()=>(0, _buttonGroup.ButtonGroup));
var _buttonGroup = require("./ButtonGroup");

},{"./ButtonGroup":"1Izq6","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"1Izq6":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ButtonGroup", ()=>_ButtonGroup);
var _utils = require("@react-spectrum/utils");
var _utils1 = require("@react-aria/utils");
var _provider = require("@react-spectrum/provider");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _varsCss = require("@adobe/spectrum-css-temp/components/buttongroup/vars.css");
var _varsCssDefault = parcelHelpers.interopDefault(_varsCss);
function ButtonGroup(props, ref) {
    let { scale } = (0, _provider.useProvider)();
    props = (0, _provider.useProviderProps)(props);
    props = (0, _utils.useSlotProps)(props, "buttonGroup");
    let { children, orientation = "horizontal", isDisabled, align = "start", ...otherProps } = props;
    let { styleProps } = (0, _utils.useStyleProps)(otherProps);
    let domRef = (0, _utils.useDOMRef)(ref);
    let [hasOverflow, setHasOverflow] = (0, _utils1.useValueEffect)(false);
    let checkForOverflow = (0, _react.useCallback)(()=>{
        let computeHasOverflow = ()=>{
            if (domRef.current && orientation === "horizontal") {
                let buttonGroupChildren = Array.from(domRef.current.children);
                let maxX = domRef.current.offsetWidth + 1; // + 1 to account for rounding errors
                // If any buttons have negative X positions (align="end") or extend beyond
                // the width of the button group (align="start"), then switch to vertical.
                if (buttonGroupChildren.some((child)=>child.offsetLeft < 0 || child.offsetLeft + child.offsetWidth > maxX)) return true;
                return false;
            }
        };
        if (orientation === "horizontal") setHasOverflow(function*() {
            // Force to horizontal for measurement.
            yield false;
            // Measure, and update if there is overflow.
            yield computeHasOverflow();
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        domRef,
        orientation,
        scale,
        setHasOverflow,
        children
    ]);
    // There are two main reasons we need to remeasure:
    // 1. Internal changes: Check for initial overflow or when orientation/scale/children change (from checkForOverflow dep array)
    (0, _utils1.useLayoutEffect)(()=>{
        checkForOverflow();
    }, [
        checkForOverflow
    ]);
    // 2. External changes: buttongroup won't change size due to any parents changing size, so listen to its container for size changes to figure out if we should remeasure
    let parent = (0, _react.useRef)();
    (0, _utils1.useLayoutEffect)(()=>{
        if (domRef.current) parent.current = domRef.current.parentElement;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        domRef.current
    ]);
    (0, _utils.useResizeObserver)({
        ref: parent,
        onResize: checkForOverflow
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...(0, _utils1.filterDOMProps)(otherProps),
        ...styleProps,
        ref: domRef,
        className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-ButtonGroup", {
            "spectrum-ButtonGroup--vertical": orientation === "vertical" || hasOverflow,
            "spectrum-ButtonGroup--alignEnd": align === "end",
            "spectrum-ButtonGroup--alignCenter": align === "center"
        }, styleProps.className)
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.SlotProvider), {
        slots: {
            button: {
                UNSAFE_className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-ButtonGroup-Button")
            }
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _provider.Provider), {
        isDisabled: isDisabled
    }, children)));
}
/**
 * ButtonGroup handles overflow for a grouping of buttons whose actions are related to each other.
 */ let _ButtonGroup = /*#__PURE__*/ (0, _reactDefault.default).forwardRef(ButtonGroup);

},{"@react-spectrum/utils":"cMIJ6","@react-aria/utils":"9cLk5","@react-spectrum/provider":"5bCdp","react":"9yzVZ","@adobe/spectrum-css-temp/components/buttongroup/vars.css":"d5GFR","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"d5GFR":[function(require,module,exports) {
module.exports["spectrum-ButtonGroup"] = `aaz5ma_spectrum-ButtonGroup`;
module.exports["spectrum-ButtonGroup--alignCenter"] = `aaz5ma_spectrum-ButtonGroup--alignCenter`;
module.exports["spectrum-ButtonGroup--alignEnd"] = `aaz5ma_spectrum-ButtonGroup--alignEnd`;
module.exports["spectrum-ButtonGroup--vertical"] = `aaz5ma_spectrum-ButtonGroup--vertical`;
module.exports["spectrum-ButtonGroup-Button"] = `aaz5ma_spectrum-ButtonGroup-Button`;

},{}],"j9RkN":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Dialog", ()=>_Dialog);
var _button = require("@react-spectrum/button");
var _utils = require("@react-spectrum/utils");
var _crossLarge = require("@spectrum-icons/ui/CrossLarge");
var _crossLargeDefault = parcelHelpers.interopDefault(_crossLarge);
var _context = require("./context");
var _layout = require("@react-spectrum/layout");
// @ts-ignore
var _json = require("../intl/*.json");
var _jsonDefault = parcelHelpers.interopDefault(_json);
var _utils1 = require("@react-aria/utils");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _varsCss = require("@adobe/spectrum-css-temp/components/dialog/vars.css");
var _varsCssDefault = parcelHelpers.interopDefault(_varsCss);
var _dialog = require("@react-aria/dialog");
var _i18N = require("@react-aria/i18n");
let sizeMap = {
    S: "small",
    M: "medium",
    L: "large",
    fullscreen: "fullscreen",
    fullscreenTakeover: "fullscreenTakeover"
};
function Dialog(props, ref) {
    props = (0, _utils.useSlotProps)(props, "dialog");
    let { type = "modal", ...contextProps } = (0, _react.useContext)((0, _context.DialogContext)) || {};
    let { children, isDismissable = contextProps.isDismissable, onDismiss = contextProps.onClose, size, ...otherProps } = props;
    let stringFormatter = (0, _i18N.useLocalizedStringFormatter)((0, _jsonDefault.default), "@react-spectrum/dialog");
    let { styleProps } = (0, _utils.useStyleProps)(otherProps);
    size = type === "popover" ? size || "S" : size || "L";
    let domRef = (0, _utils.useDOMRef)(ref);
    let gridRef = (0, _react.useRef)(null);
    let sizeVariant = sizeMap[type] || sizeMap[size];
    let { dialogProps, titleProps } = (0, _dialog.useDialog)((0, _utils1.mergeProps)(contextProps, props), domRef);
    let hasHeader = (0, _utils.useHasChild)(`.${(0, _varsCssDefault.default)["spectrum-Dialog-header"]}`, (0, _utils.unwrapDOMRef)(gridRef));
    let hasHeading = (0, _utils.useHasChild)(`.${(0, _varsCssDefault.default)["spectrum-Dialog-heading"]}`, (0, _utils.unwrapDOMRef)(gridRef));
    let hasFooter = (0, _utils.useHasChild)(`.${(0, _varsCssDefault.default)["spectrum-Dialog-footer"]}`, (0, _utils.unwrapDOMRef)(gridRef));
    let hasTypeIcon = (0, _utils.useHasChild)(`.${(0, _varsCssDefault.default)["spectrum-Dialog-typeIcon"]}`, (0, _utils.unwrapDOMRef)(gridRef));
    let slots = (0, _react.useMemo)(()=>({
            hero: {
                UNSAFE_className: (0, _varsCssDefault.default)["spectrum-Dialog-hero"]
            },
            heading: {
                UNSAFE_className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Dialog-heading", {
                    "spectrum-Dialog-heading--noHeader": !hasHeader,
                    "spectrum-Dialog-heading--noTypeIcon": !hasTypeIcon
                }),
                level: 2,
                ...titleProps
            },
            header: {
                UNSAFE_className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Dialog-header", {
                    "spectrum-Dialog-header--noHeading": !hasHeading,
                    "spectrum-Dialog-header--noTypeIcon": !hasTypeIcon
                })
            },
            typeIcon: {
                UNSAFE_className: (0, _varsCssDefault.default)["spectrum-Dialog-typeIcon"]
            },
            divider: {
                UNSAFE_className: (0, _varsCssDefault.default)["spectrum-Dialog-divider"],
                size: "M"
            },
            content: {
                UNSAFE_className: (0, _varsCssDefault.default)["spectrum-Dialog-content"]
            },
            footer: {
                UNSAFE_className: (0, _varsCssDefault.default)["spectrum-Dialog-footer"]
            },
            buttonGroup: {
                UNSAFE_className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Dialog-buttonGroup", {
                    "spectrum-Dialog-buttonGroup--noFooter": !hasFooter
                }),
                align: "end"
            }
        }), [
        hasFooter,
        hasHeader,
        titleProps
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("section", {
        ...styleProps,
        ...dialogProps,
        className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Dialog", {
            [`spectrum-Dialog--${sizeVariant}`]: sizeVariant,
            "spectrum-Dialog--dismissable": isDismissable
        }, styleProps.className),
        ref: domRef
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Grid), {
        ref: gridRef,
        UNSAFE_className: (0, _varsCssDefault.default)["spectrum-Dialog-grid"]
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.SlotProvider), {
        slots: slots
    }, children), isDismissable && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), {
        UNSAFE_className: (0, _varsCssDefault.default)["spectrum-Dialog-closeButton"],
        isQuiet: true,
        "aria-label": stringFormatter.format("dismiss"),
        onPress: onDismiss
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _crossLargeDefault.default), null))));
}
/**
 * Dialogs are windows containing contextual information, tasks, or workflows that appear over the user interface.
 * Depending on the kind of Dialog, further interactions may be blocked until the Dialog is acknowledged.
 */ let _Dialog = /*#__PURE__*/ (0, _reactDefault.default).forwardRef(Dialog);

},{"@react-spectrum/button":"jZWyP","@react-spectrum/utils":"cMIJ6","@spectrum-icons/ui/CrossLarge":"3emYD","./context":"5cYYD","@react-spectrum/layout":"hzaUY","../intl/*.json":"21NEj","@react-aria/utils":"9cLk5","react":"9yzVZ","@adobe/spectrum-css-temp/components/dialog/vars.css":"jheU5","@react-aria/dialog":"aSQNt","@react-aria/i18n":"411rg","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"3emYD":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("af159aad037455a6");
exports.__esModule = true;
exports.default = CrossLarge;
var _CrossLarge = require("3bd056b0e4431fc1");
var _icon = require("64028bbb04e1d32d");
var _react = _interopRequireDefault(require("8b0d069da8eb7507"));
function CrossLarge(props) {
    return /*#__PURE__*/ _react.default.createElement(_icon.UIIcon, props, /*#__PURE__*/ _react.default.createElement(_CrossLarge.CrossLarge, null));
}

},{"af159aad037455a6":"iHubQ","3bd056b0e4431fc1":"7cpXR","64028bbb04e1d32d":"k7wem","8b0d069da8eb7507":"9yzVZ"}],"7cpXR":[function(require,module,exports) {
/**
* @adobe/react-spectrum-ui (c) by Adobe
* 
* @adobe/react-spectrum-ui is licensed under a
* Creative Commons Attribution-NoDerivatives 4.0 International License.
* 
* You should have received a copy of the license along with this
* work. If not, see <http://creativecommons.org/licenses/by-nd/4.0/>.
**/ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CrossLarge = CrossLarge;
var _react = _interopRequireDefault(require("45a0fd81243595c4"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function CrossLarge(_ref) {
    var _ref$scale = _ref.scale, scale = _ref$scale === void 0 ? "M" : _ref$scale, props = _objectWithoutProperties(_ref, [
        "scale"
    ]);
    return _react["default"].createElement("svg", _extends({}, props, props), scale === "L" && _react["default"].createElement("path", {
        d: "M15.697 14.283L9.414 8l6.283-6.283A1 1 0 1 0 14.283.303L8 6.586 1.717.303A1 1 0 1 0 .303 1.717L6.586 8 .303 14.283a1 1 0 1 0 1.414 1.414L8 9.414l6.283 6.283a1 1 0 1 0 1.414-1.414z"
    }), scale === "M" && _react["default"].createElement("path", {
        d: "M11.697 10.283L7.414 6l4.283-4.283A1 1 0 1 0 10.283.303L6 4.586 1.717.303A1 1 0 1 0 .303 1.717L4.586 6 .303 10.283a1 1 0 1 0 1.414 1.414L6 7.414l4.283 4.283a1 1 0 1 0 1.414-1.414z"
    }));
}
CrossLarge.displayName = "CrossLarge";

},{"45a0fd81243595c4":"9yzVZ"}],"5cYYD":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DialogContext", ()=>DialogContext);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const DialogContext = (0, _reactDefault.default).createContext(null);

},{"react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"21NEj":[function(require,module,exports) {
const _temp0 = require("5d348bf6b184816b");
const _temp1 = require("40f7ce3747388f42");
const _temp2 = require("175fb7df96b484b5");
const _temp3 = require("6f9cd22801d99d75");
const _temp4 = require("48d3dd69bca28f46");
const _temp5 = require("c0e166193995c177");
const _temp6 = require("781b6fa58549ee8a");
const _temp7 = require("4cf8dc55c1859add");
const _temp8 = require("205092ac7e35d524");
const _temp9 = require("660bdc154909e295");
const _temp10 = require("4d9c511967428338");
const _temp11 = require("3145b1f62b457bb2");
const _temp12 = require("238f16a2d858ce1");
const _temp13 = require("d39010303c99ff21");
const _temp14 = require("558d6fdfeaf14029");
const _temp15 = require("4620d5108f6042cc");
const _temp16 = require("d173f270f6d1d7c");
const _temp17 = require("158ec9770f7096c");
const _temp18 = require("4b28eca26de142aa");
const _temp19 = require("e381971e5607aa10");
const _temp20 = require("5625529f23391751");
const _temp21 = require("30ee4ed10ed3504f");
const _temp22 = require("8c4e0171702f372c");
const _temp23 = require("4507e8d52dde3967");
const _temp24 = require("f2b78f88a2de366e");
const _temp25 = require("7710454241abdc9b");
const _temp26 = require("4e0e80fb0fc05a31");
const _temp27 = require("1e8a748554b92a57");
const _temp28 = require("4ed5a3960aa5e840");
const _temp29 = require("84358f9ff7019ed4");
const _temp30 = require("801ab67dc130da08");
const _temp31 = require("bb8abcad6ef7cb9a");
const _temp32 = require("fda9ad21ee6a8c07");
const _temp33 = require("6645374721d85580");
module.exports = {
    "ar-AE": _temp0,
    "bg-BG": _temp1,
    "cs-CZ": _temp2,
    "da-DK": _temp3,
    "de-DE": _temp4,
    "el-GR": _temp5,
    "en-US": _temp6,
    "es-ES": _temp7,
    "et-EE": _temp8,
    "fi-FI": _temp9,
    "fr-FR": _temp10,
    "he-IL": _temp11,
    "hr-HR": _temp12,
    "hu-HU": _temp13,
    "it-IT": _temp14,
    "ja-JP": _temp15,
    "ko-KR": _temp16,
    "lt-LT": _temp17,
    "lv-LV": _temp18,
    "nb-NO": _temp19,
    "nl-NL": _temp20,
    "pl-PL": _temp21,
    "pt-BR": _temp22,
    "pt-PT": _temp23,
    "ro-RO": _temp24,
    "ru-RU": _temp25,
    "sk-SK": _temp26,
    "sl-SI": _temp27,
    "sr-SP": _temp28,
    "sv-SE": _temp29,
    "tr-TR": _temp30,
    "uk-UA": _temp31,
    "zh-CN": _temp32,
    "zh-TW": _temp33
};

},{"5d348bf6b184816b":"fVOA5","40f7ce3747388f42":"5VQe0","175fb7df96b484b5":"h0P9Z","6f9cd22801d99d75":"hZO5H","48d3dd69bca28f46":"iuS9k","c0e166193995c177":"9w8be","781b6fa58549ee8a":"kQbr1","4cf8dc55c1859add":"aJjXv","205092ac7e35d524":"beW72","660bdc154909e295":"c4CIU","4d9c511967428338":"bb0dT","3145b1f62b457bb2":"5D9l9","238f16a2d858ce1":"7Hou5","d39010303c99ff21":"e6CFz","558d6fdfeaf14029":"rzDkP","4620d5108f6042cc":"2UKTo","d173f270f6d1d7c":"38yIQ","158ec9770f7096c":"4qE3X","4b28eca26de142aa":"kMrYV","e381971e5607aa10":"l7N34","5625529f23391751":"jVjSq","30ee4ed10ed3504f":"f0gJS","8c4e0171702f372c":"c2wkl","4507e8d52dde3967":"4lzwk","f2b78f88a2de366e":"alfkc","7710454241abdc9b":"dfCgI","4e0e80fb0fc05a31":"3GRfT","1e8a748554b92a57":"f4isw","4ed5a3960aa5e840":"5JKV1","84358f9ff7019ed4":"hWWnE","801ab67dc130da08":"8Hg10","bb8abcad6ef7cb9a":"1Tkhk","fda9ad21ee6a8c07":"35WQH","6645374721d85580":"gGXrR"}],"fVOA5":[function(require,module,exports) {
module.exports = {
    "alert": `\u{62A}\u{646}\u{628}\u{64A}\u{647}`,
    "dismiss": `\u{62A}\u{62C}\u{627}\u{647}\u{644}`
};

},{}],"5VQe0":[function(require,module,exports) {
module.exports = {
    "alert": `\u{421}\u{438}\u{433}\u{43D}\u{430}\u{43B}`,
    "dismiss": `\u{41E}\u{442}\u{445}\u{432}\u{44A}\u{440}\u{43B}\u{44F}\u{43D}\u{435}`
};

},{}],"h0P9Z":[function(require,module,exports) {
module.exports = {
    "alert": `V\xfdstraha`,
    "dismiss": `Odstranit`
};

},{}],"hZO5H":[function(require,module,exports) {
module.exports = {
    "alert": `Advarsel`,
    "dismiss": `Luk`
};

},{}],"iuS9k":[function(require,module,exports) {
module.exports = {
    "alert": `Warnhinweis`,
    "dismiss": `Schlie\xdfen`
};

},{}],"9w8be":[function(require,module,exports) {
module.exports = {
    "alert": `\u{395}\u{3B9}\u{3B4}\u{3BF}\u{3C0}\u{3BF}\u{3AF}\u{3B7}\u{3C3}\u{3B7}`,
    "dismiss": `\u{391}\u{3C0}\u{3CC}\u{3C1}\u{3C1}\u{3B9}\u{3C8}\u{3B7}`
};

},{}],"kQbr1":[function(require,module,exports) {
module.exports = {
    "dismiss": `Dismiss`,
    "alert": `Alert`
};

},{}],"aJjXv":[function(require,module,exports) {
module.exports = {
    "alert": `Alerta`,
    "dismiss": `Descartar`
};

},{}],"beW72":[function(require,module,exports) {
module.exports = {
    "alert": `Teade`,
    "dismiss": `L\xf5peta`
};

},{}],"c4CIU":[function(require,module,exports) {
module.exports = {
    "alert": `H\xe4lytys`,
    "dismiss": `Hylk\xe4\xe4`
};

},{}],"bb0dT":[function(require,module,exports) {
module.exports = {
    "alert": `Alerte`,
    "dismiss": `Rejeter`
};

},{}],"5D9l9":[function(require,module,exports) {
module.exports = {
    "alert": `\u{5D4}\u{5EA}\u{5E8}\u{5D0}\u{5D4}`,
    "dismiss": `\u{5D4}\u{5EA}\u{5E2}\u{5DC}\u{5DD}`
};

},{}],"7Hou5":[function(require,module,exports) {
module.exports = {
    "alert": `Upozorenje`,
    "dismiss": `Odbaci`
};

},{}],"e6CFz":[function(require,module,exports) {
module.exports = {
    "alert": `Figyelmeztet\xe9s`,
    "dismiss": `Elutas\xedt\xe1s`
};

},{}],"rzDkP":[function(require,module,exports) {
module.exports = {
    "alert": `Avviso`,
    "dismiss": `Ignora`
};

},{}],"2UKTo":[function(require,module,exports) {
module.exports = {
    "alert": `\u{30A2}\u{30E9}\u{30FC}\u{30C8}`,
    "dismiss": `\u{9589}\u{3058}\u{308B}`
};

},{}],"38yIQ":[function(require,module,exports) {
module.exports = {
    "alert": `\u{ACBD}\u{ACE0}`,
    "dismiss": `\u{BB34}\u{C2DC}`
};

},{}],"4qE3X":[function(require,module,exports) {
module.exports = {
    "alert": `\u{12E}sp\u{117}jimas`,
    "dismiss": `Atmesti`
};

},{}],"kMrYV":[function(require,module,exports) {
module.exports = {
    "alert": `Br\u{12B}din\u{101}jums`,
    "dismiss": `Ner\u{101}d\u{12B}t`
};

},{}],"l7N34":[function(require,module,exports) {
module.exports = {
    "alert": `Varsel`,
    "dismiss": `Lukk`
};

},{}],"jVjSq":[function(require,module,exports) {
module.exports = {
    "alert": `Melding`,
    "dismiss": `Negeren`
};

},{}],"f0gJS":[function(require,module,exports) {
module.exports = {
    "alert": `Ostrze\u{17C}enie`,
    "dismiss": `Zignoruj`
};

},{}],"c2wkl":[function(require,module,exports) {
module.exports = {
    "alert": `Alerta`,
    "dismiss": `Descartar`
};

},{}],"4lzwk":[function(require,module,exports) {
module.exports = {
    "alert": `Alerta`,
    "dismiss": `Dispensar`
};

},{}],"alfkc":[function(require,module,exports) {
module.exports = {
    "alert": `Alert\u{103}`,
    "dismiss": `Revocare`
};

},{}],"dfCgI":[function(require,module,exports) {
module.exports = {
    "alert": `\u{41F}\u{440}\u{435}\u{434}\u{443}\u{43F}\u{440}\u{435}\u{436}\u{434}\u{435}\u{43D}\u{438}\u{435}`,
    "dismiss": `\u{41F}\u{440}\u{43E}\u{43F}\u{443}\u{441}\u{442}\u{438}\u{442}\u{44C}`
};

},{}],"3GRfT":[function(require,module,exports) {
module.exports = {
    "alert": `Upozornenie`,
    "dismiss": `Zru\u{161}i\u{165}`
};

},{}],"f4isw":[function(require,module,exports) {
module.exports = {
    "alert": `Opozorilo`,
    "dismiss": `Opusti`
};

},{}],"5JKV1":[function(require,module,exports) {
module.exports = {
    "alert": `Upozorenje`,
    "dismiss": `Odbaci`
};

},{}],"hWWnE":[function(require,module,exports) {
module.exports = {
    "alert": `Varning`,
    "dismiss": `Avvisa`
};

},{}],"8Hg10":[function(require,module,exports) {
module.exports = {
    "alert": `Uyar\u{131}`,
    "dismiss": `Kapat`
};

},{}],"1Tkhk":[function(require,module,exports) {
module.exports = {
    "alert": `\u{421}\u{438}\u{433}\u{43D}\u{430}\u{43B} \u{442}\u{440}\u{438}\u{432}\u{43E}\u{433}\u{438}`,
    "dismiss": `\u{421}\u{43A}\u{430}\u{441}\u{443}\u{432}\u{430}\u{442}\u{438}`
};

},{}],"35WQH":[function(require,module,exports) {
module.exports = {
    "alert": `\u{8B66}\u{62A5}`,
    "dismiss": `\u{53D6}\u{6D88}`
};

},{}],"gGXrR":[function(require,module,exports) {
module.exports = {
    "alert": `\u{8B66}\u{793A}`,
    "dismiss": `\u{95DC}\u{9589}`
};

},{}],"jheU5":[function(require,module,exports) {
module.exports["buttonGroup"] = `h_OVWW_buttonGroup`;
module.exports["buttonGroup-end"] = `h_OVWW_buttonGroup-end`;
module.exports["closeButton"] = `h_OVWW_closeButton`;
module.exports["content"] = `h_OVWW_content`;
module.exports["divider"] = `h_OVWW_divider`;
module.exports["focus-ring"] = `h_OVWW_focus-ring`;
module.exports["footer"] = `h_OVWW_footer`;
module.exports["footer-start"] = `h_OVWW_footer-start`;
module.exports["header"] = `h_OVWW_header`;
module.exports["header-end"] = `h_OVWW_header-end`;
module.exports["header-start"] = `h_OVWW_header-start`;
module.exports["heading"] = `h_OVWW_heading`;
module.exports["heading-start"] = `h_OVWW_heading-start`;
module.exports["hero"] = `h_OVWW_hero`;
module.exports["i18nFontFamily"] = `h_OVWW_i18nFontFamily`;
module.exports["spectrum-Button"] = `h_OVWW_spectrum-Button`;
module.exports["spectrum-Dialog"] = `h_OVWW_spectrum-Dialog`;
module.exports["spectrum-Dialog--dismissable"] = `h_OVWW_spectrum-Dialog--dismissable`;
module.exports["spectrum-Dialog--error"] = `h_OVWW_spectrum-Dialog--error`;
module.exports["spectrum-Dialog--fullscreen"] = `h_OVWW_spectrum-Dialog--fullscreen`;
module.exports["spectrum-Dialog--fullscreenTakeover"] = `h_OVWW_spectrum-Dialog--fullscreenTakeover`;
module.exports["spectrum-Dialog--large"] = `h_OVWW_spectrum-Dialog--large`;
module.exports["spectrum-Dialog--medium"] = `h_OVWW_spectrum-Dialog--medium`;
module.exports["spectrum-Dialog--noDivider"] = `h_OVWW_spectrum-Dialog--noDivider`;
module.exports["spectrum-Dialog--small"] = `h_OVWW_spectrum-Dialog--small`;
module.exports["spectrum-Dialog--warning"] = `h_OVWW_spectrum-Dialog--warning`;
module.exports["spectrum-Dialog-buttonGroup"] = `h_OVWW_spectrum-Dialog-buttonGroup`;
module.exports["spectrum-Dialog-buttonGroup--noFooter"] = `h_OVWW_spectrum-Dialog-buttonGroup--noFooter`;
module.exports["spectrum-Dialog-closeButton"] = `h_OVWW_spectrum-Dialog-closeButton`;
module.exports["spectrum-Dialog-content"] = `h_OVWW_spectrum-Dialog-content`;
module.exports["spectrum-Dialog-divider"] = `h_OVWW_spectrum-Dialog-divider`;
module.exports["spectrum-Dialog-footer"] = `h_OVWW_spectrum-Dialog-footer`;
module.exports["spectrum-Dialog-grid"] = `h_OVWW_spectrum-Dialog-grid`;
module.exports["spectrum-Dialog-header"] = `h_OVWW_spectrum-Dialog-header`;
module.exports["spectrum-Dialog-header--noTypeIcon"] = `h_OVWW_spectrum-Dialog-header--noTypeIcon`;
module.exports["spectrum-Dialog-heading"] = `h_OVWW_spectrum-Dialog-heading`;
module.exports["spectrum-Dialog-heading--noHeader"] = `h_OVWW_spectrum-Dialog-heading--noHeader`;
module.exports["spectrum-Dialog-heading--noTypeIcon"] = `h_OVWW_spectrum-Dialog-heading--noTypeIcon`;
module.exports["spectrum-Dialog-hero"] = `h_OVWW_spectrum-Dialog-hero`;
module.exports["spectrum-Dialog-typeIcon"] = `h_OVWW_spectrum-Dialog-typeIcon`;
module.exports["spectrum-FocusRing-ring"] = `h_OVWW_spectrum-FocusRing-ring`;
module.exports["spectrum-FocusRing"] = `h_OVWW_spectrum-FocusRing ${module.exports["spectrum-FocusRing-ring"]}`;
module.exports["spectrum-FocusRing--quiet"] = `h_OVWW_spectrum-FocusRing--quiet`;
module.exports["spectrum-overlay"] = `h_OVWW_spectrum-overlay`;
module.exports["spectrum-overlay--bottom--open"] = `h_OVWW_spectrum-overlay--bottom--open`;
module.exports["spectrum-overlay--left--open"] = `h_OVWW_spectrum-overlay--left--open`;
module.exports["spectrum-overlay--open"] = `h_OVWW_spectrum-overlay--open`;
module.exports["spectrum-overlay--right--open"] = `h_OVWW_spectrum-overlay--right--open`;
module.exports["spectrum-overlay--top--open"] = `h_OVWW_spectrum-overlay--top--open`;
module.exports["typeIcon"] = `h_OVWW_typeIcon`;
module.exports["typeIcon-end"] = `h_OVWW_typeIcon-end`;

},{}],"dxmqN":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /// <reference types="css-module-types" />
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Divider", ()=>(0, _divider.Divider));
var _divider = require("./Divider");

},{"./Divider":"8jDUQ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"8jDUQ":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Divider", ()=>_Divider);
var _utils = require("@react-spectrum/utils");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _varsCss = require("@adobe/spectrum-css-temp/components/rule/vars.css");
var _varsCssDefault = parcelHelpers.interopDefault(_varsCss);
var _separator = require("@react-aria/separator");
let sizeMap = {
    S: "small",
    M: "medium",
    L: "large"
};
function Divider(props, ref) {
    props = (0, _utils.useSlotProps)(props, "divider");
    let { size = "L", orientation = "horizontal", ...otherProps } = props;
    let domRef = (0, _utils.useDOMRef)(ref);
    let { styleProps } = (0, _utils.useStyleProps)(otherProps);
    let weight = sizeMap[size];
    let Element = "hr";
    if (orientation === "vertical") Element = "div";
    let { separatorProps } = (0, _separator.useSeparator)({
        ...props,
        elementType: Element
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Element, {
        ...styleProps,
        className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Rule", `spectrum-Rule--${weight}`, {
            "spectrum-Rule--vertical": orientation === "vertical",
            "spectrum-Rule--horizontal": orientation === "horizontal"
        }, styleProps.className),
        // @ts-ignore https://github.com/Microsoft/TypeScript/issues/28892
        ref: domRef,
        ...separatorProps
    });
}
/**
 * Dividers bring clarity to a layout by grouping and dividing content in close proximity.
 * They can also be used to establish rhythm and hierarchy.
 */ let _Divider = /*#__PURE__*/ (0, _reactDefault.default).forwardRef(Divider);

},{"@react-spectrum/utils":"cMIJ6","react":"9yzVZ","@adobe/spectrum-css-temp/components/rule/vars.css":"04g7Z","@react-aria/separator":"iHEIW","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"04g7Z":[function(require,module,exports) {
module.exports["focus-ring"] = `cTbPrq_focus-ring`;
module.exports["i18nFontFamily"] = `cTbPrq_i18nFontFamily`;
module.exports["spectrum-FocusRing-ring"] = `cTbPrq_spectrum-FocusRing-ring`;
module.exports["spectrum-FocusRing"] = `cTbPrq_spectrum-FocusRing ${module.exports["spectrum-FocusRing-ring"]}`;
module.exports["spectrum-FocusRing--quiet"] = `cTbPrq_spectrum-FocusRing--quiet`;
module.exports["spectrum-Rule"] = `cTbPrq_spectrum-Rule`;
module.exports["spectrum-Rule--horizontal"] = `cTbPrq_spectrum-Rule--horizontal`;
module.exports["spectrum-Rule--large"] = `cTbPrq_spectrum-Rule--large`;
module.exports["spectrum-Rule--medium"] = `cTbPrq_spectrum-Rule--medium`;
module.exports["spectrum-Rule--small"] = `cTbPrq_spectrum-Rule--small`;
module.exports["spectrum-Rule--vertical"] = `cTbPrq_spectrum-Rule--vertical`;

},{}],"ityjA":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DialogTrigger", ()=>_DialogTrigger);
var _context = require("./context");
var _overlays = require("@react-spectrum/overlays");
var _overlays1 = require("@react-stately/overlays");
var _interactions = require("@react-aria/interactions");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _utils = require("@react-spectrum/utils");
var _overlays2 = require("@react-aria/overlays");
function DialogTrigger(props) {
    let { children, type = "modal", mobileType = type === "popover" ? "modal" : type, hideArrow, targetRef, isDismissable, isKeyboardDismissDisabled, ...positionProps } = props;
    if (!Array.isArray(children) || children.length > 2) throw new Error("DialogTrigger must have exactly 2 children");
    // if a function is passed as the second child, it won't appear in toArray
    let [trigger, content] = children;
    // On small devices, show a modal or tray instead of a popover.
    let isMobile = (0, _utils.useIsMobileDevice)();
    if (isMobile) {
        // handle cases where desktop popovers need a close button for the mobile modal view
        if (type !== "modal" && mobileType === "modal") isDismissable = true;
        type = mobileType;
    }
    let state = (0, _overlays1.useOverlayTriggerState)(props);
    let wasOpen = (0, _react.useRef)(false);
    (0, _react.useEffect)(()=>{
        wasOpen.current = state.isOpen;
    }, [
        state.isOpen
    ]);
    let isExiting = (0, _react.useRef)(false);
    let onExiting = ()=>isExiting.current = true;
    let onExited = ()=>isExiting.current = false;
    // eslint-disable-next-line arrow-body-style
    (0, _react.useEffect)(()=>{
        return ()=>{
            if ((wasOpen.current || isExiting.current) && type !== "popover" && type !== "tray") console.warn("A DialogTrigger unmounted while open. This is likely due to being placed within a trigger that unmounts or inside a conditional. Consider using a DialogContainer instead.");
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    if (type === "popover") return /*#__PURE__*/ (0, _reactDefault.default).createElement(PopoverTrigger, {
        ...positionProps,
        state: state,
        targetRef: targetRef,
        trigger: trigger,
        content: content,
        isKeyboardDismissDisabled: isKeyboardDismissDisabled,
        hideArrow: hideArrow
    });
    let renderOverlay = ()=>{
        switch(type){
            case "fullscreen":
            case "fullscreenTakeover":
            case "modal":
                return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _overlays.Modal), {
                    state: state,
                    isDismissable: type === "modal" ? isDismissable : false,
                    type: type,
                    isKeyboardDismissDisabled: isKeyboardDismissDisabled,
                    onExiting: onExiting,
                    onExited: onExited
                }, typeof content === "function" ? content(state.close) : content);
            case "tray":
                return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _overlays.Tray), {
                    state: state,
                    isKeyboardDismissDisabled: isKeyboardDismissDisabled
                }, typeof content === "function" ? content(state.close) : content);
        }
    };
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(DialogTriggerBase, {
        type: type,
        state: state,
        isDismissable: isDismissable,
        trigger: trigger,
        overlay: renderOverlay()
    });
}
// Support DialogTrigger inside components using CollectionBuilder.
DialogTrigger.getCollectionNode = function*(props) {
    // @ts-ignore - seems like types are wrong. Function children work fine.
    let [trigger] = (0, _reactDefault.default).Children.toArray(props.children);
    let [, content] = props.children;
    yield {
        element: trigger,
        wrapper: (element)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(DialogTrigger, {
                key: element.key,
                ...props
            }, element, content)
    };
};
/**
 * DialogTrigger serves as a wrapper around a Dialog and its associated trigger, linking the Dialog's
 * open state with the trigger's press state. Additionally, it allows you to customize the type and
 * positioning of the Dialog.
 */ // We don't want getCollectionNode to show up in the type definition
let _DialogTrigger = DialogTrigger;
function PopoverTrigger({ state, targetRef, trigger, content, hideArrow, ...props }) {
    let triggerRef = (0, _react.useRef)(null);
    let { triggerProps, overlayProps } = (0, _overlays2.useOverlayTrigger)({
        type: "dialog"
    }, state, triggerRef);
    let triggerPropsWithRef = {
        ...triggerProps,
        ref: targetRef ? undefined : triggerRef
    };
    let overlay = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _overlays.Popover), {
        ...props,
        hideArrow: hideArrow,
        triggerRef: targetRef || triggerRef,
        state: state
    }, typeof content === "function" ? content(state.close) : content);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(DialogTriggerBase, {
        type: "popover",
        state: state,
        triggerProps: triggerPropsWithRef,
        dialogProps: overlayProps,
        trigger: trigger,
        overlay: overlay
    });
}
function DialogTriggerBase({ type, state, isDismissable, dialogProps = {}, triggerProps = {}, overlay, trigger }) {
    let context = {
        type,
        onClose: state.close,
        isDismissable,
        ...dialogProps
    };
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _react.Fragment), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _interactions.PressResponder), {
        ...triggerProps,
        onPress: state.toggle,
        isPressed: state.isOpen && type !== "modal" && type !== "fullscreen" && type !== "fullscreenTakeover"
    }, trigger), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _context.DialogContext).Provider, {
        value: context
    }, overlay));
}

},{"./context":"5cYYD","@react-spectrum/overlays":"3nwGn","@react-stately/overlays":"5uxM4","@react-aria/interactions":"ky3G8","react":"9yzVZ","@react-spectrum/utils":"cMIJ6","@react-aria/overlays":"5fTCg","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"5MsDj":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * A DialogContainer accepts a single Dialog as a child, and manages showing and hiding
 * it in a modal. Useful in cases where there is no trigger element
 * or when the trigger unmounts while the dialog is open.
 */ parcelHelpers.export(exports, "DialogContainer", ()=>DialogContainer);
var _context = require("./context");
var _overlays = require("@react-spectrum/overlays");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _overlays1 = require("@react-stately/overlays");
function DialogContainer(props) {
    let { children, type = "modal", onDismiss, isDismissable, isKeyboardDismissDisabled } = props;
    let childArray = (0, _reactDefault.default).Children.toArray(children);
    if (childArray.length > 1) throw new Error("Only a single child can be passed to DialogContainer.");
    let [lastChild, setLastChild] = (0, _react.useState)(null);
    // React.Children.toArray mutates the children, and we need them to be stable
    // between renders so that the lastChild comparison works.
    let child = undefined;
    if (Array.isArray(children)) child = children.find((0, _reactDefault.default).isValidElement);
    else if (/*#__PURE__*/ (0, _reactDefault.default).isValidElement(children)) child = children;
    if (child && child !== lastChild) setLastChild(child);
    let context = {
        type,
        onClose: onDismiss,
        isDismissable
    };
    let state = (0, _overlays1.useOverlayTriggerState)({
        isOpen: !!child,
        onOpenChange: (isOpen)=>{
            if (!isOpen) onDismiss();
        }
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _overlays.Modal), {
        state: state,
        type: type,
        isDismissable: isDismissable,
        isKeyboardDismissDisabled: isKeyboardDismissDisabled
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _context.DialogContext).Provider, {
        value: context
    }, lastChild));
}

},{"./context":"5cYYD","@react-spectrum/overlays":"3nwGn","react":"9yzVZ","@react-stately/overlays":"5uxM4","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"gsvMq":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useDialogContainer", ()=>useDialogContainer);
var _context = require("./context");
var _react = require("react");
function useDialogContainer() {
    let context = (0, _react.useContext)((0, _context.DialogContext));
    if (!context) throw new Error("Cannot call useDialogContext outside a <DialogTrigger> or <DialogContainer>.");
    return {
        type: context.type,
        dismiss () {
            context === null || context === void 0 ? void 0 : context.onClose();
        }
    };
}

},{"./context":"5cYYD","react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"7vfBr":[function(require,module,exports) {
module.exports["badge"] = `_2VtgtG_badge`;
module.exports["cell"] = `_2VtgtG_cell`;
module.exports["drag-handle"] = `_2VtgtG_drag-handle`;
module.exports["draggable"] = `_2VtgtG_draggable`;
module.exports["draggable-listbox"] = `_2VtgtG_draggable-listbox`;
module.exports["drop-target"] = `_2VtgtG_drop-target`;
module.exports["droppable"] = `_2VtgtG_droppable`;
module.exports["droppable-collection"] = `_2VtgtG_droppable-collection`;
module.exports["focus-ring"] = `_2VtgtG_focus-ring`;
module.exports["focus-visible"] = `_2VtgtG_focus-visible`;
module.exports["is-drag-preview"] = `_2VtgtG_is-drag-preview`;
module.exports["is-dragging"] = `_2VtgtG_is-dragging`;
module.exports["is-dragging-multiple"] = `_2VtgtG_is-dragging-multiple`;
module.exports["is-drop-target"] = `_2VtgtG_is-drop-target`;
module.exports["is-selected"] = `_2VtgtG_is-selected`;
module.exports["is-virtualized"] = `_2VtgtG_is-virtualized`;
module.exports["option"] = `_2VtgtG_option`;
module.exports["pressed"] = `_2VtgtG_pressed`;

},{}],"dZGoj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DraggableListBox", ()=>DraggableListBox);
var _utils = require("@react-spectrum/utils");
var _dndCss = require("./dnd.css");
var _dndCssDefault = parcelHelpers.interopDefault(_dndCss);
var _utils1 = require("@react-aria/utils");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _dnd = require("@react-aria/dnd");
var _dnd1 = require("@react-stately/dnd");
var _focus = require("@react-aria/focus");
var _listbox = require("@react-aria/listbox");
var _list = require("@react-stately/list");
function DraggableListBox(props) {
    let state = (0, _list.useListState)(props);
    let ref = (0, _reactDefault.default).useRef();
    let { listBoxProps } = (0, _listbox.useListBox)({
        ...props,
        shouldSelectOnPressUp: true
    }, state, ref);
    let dragState = (0, _dnd1.useDraggableCollectionState)({
        ...props,
        collection: state.collection,
        selectionManager: state.selectionManager,
        getItems: props.getItems || ((keys)=>[
                ...keys
            ].map((key)=>{
                let item = state.collection.getItem(key);
                return {
                    "text/plain": item.textValue
                };
            }))
    });
    (0, _dnd.useDraggableCollection)({}, dragState, ref);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("ul", {
        ...listBoxProps,
        ref: ref,
        className: (0, _dndCssDefault.default)["draggable-listbox"],
        "aria-label": "example draggable listbox"
    }, [
        ...state.collection
    ].map((item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(Option, {
            key: item.key,
            item: item,
            state: state,
            dragState: dragState
        })));
}
function Option({ item, state, dragState }) {
    let ref = (0, _reactDefault.default).useRef();
    let { optionProps, isPressed, hasAction } = (0, _listbox.useOption)({
        key: item.key
    }, state, ref);
    let { isFocusVisible, focusProps } = (0, _focus.useFocusRing)();
    let { dragProps } = (0, _dnd.useDraggableItem)({
        key: item.key,
        hasAction
    }, dragState);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("li", {
        ...(0, _utils1.mergeProps)(dragProps, optionProps, focusProps),
        ref: ref,
        className: (0, _utils.classNames)((0, _dndCssDefault.default), "option", {
            "focus-visible": isFocusVisible,
            "pressed": isPressed
        })
    }, item.rendered);
}

},{"@react-spectrum/utils":"cMIJ6","./dnd.css":"7vfBr","@react-aria/utils":"9cLk5","react":"9yzVZ","@react-aria/dnd":"hi3Sh","@react-stately/dnd":"bUQOi","@react-aria/focus":"42mbF","@react-aria/listbox":"bHZSJ","@react-stately/list":"Cp0zP","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"3OdA0":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DroppableGridExample", ()=>DroppableGridExample);
var _utils = require("@react-spectrum/utils");
var _dndCss = require("./dnd.css");
var _dndCssDefault = parcelHelpers.interopDefault(_dndCss);
var _varsCss = require("@adobe/spectrum-css-temp/components/dropindicator/vars.css");
var _varsCssDefault = parcelHelpers.interopDefault(_varsCss);
var _focus = require("@react-aria/focus");
var _folder = require("@spectrum-icons/workflow/Folder");
var _folderDefault = parcelHelpers.interopDefault(_folder);
var _grid = require("@react-stately/grid");
var _collections = require("@react-stately/collections");
var _dnd = require("@react-aria/dnd");
var _selection = require("@react-aria/selection");
var _utils1 = require("@react-aria/utils");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _ = require("..");
var _dnd1 = require("@react-stately/dnd");
var _grid1 = require("@react-aria/grid");
var _data = require("@react-stately/data");
var _list = require("@react-stately/list");
var _visuallyHidden = require("@react-aria/visually-hidden");
function DroppableGridExample(props) {
    var _props_items;
    let id = (0, _reactDefault.default).useRef(((_props_items = props.items) === null || _props_items === void 0 ? void 0 : _props_items.length) || 3);
    let list = (0, _data.useListData)({
        initialItems: props.items || [
            {
                id: "1",
                type: "folder",
                text: "One"
            },
            {
                id: "2",
                type: "item",
                text: "Two"
            },
            {
                id: "3",
                type: "folder",
                text: "Three"
            }
        ]
    });
    let ref = (0, _reactDefault.default).useRef(null);
    let onDrop = async (e)=>{
        if (props.onDrop) props.onDrop(e);
        if (e.target.type === "root" || e.target.dropPosition !== "on") {
            let items = [];
            for (let item of e.items){
                let type;
                if (item.kind === "text") {
                    if (item.types.has("folder")) type = "folder";
                    else if (item.types.has("item")) type = "item";
                    else if (item.types.has("text/plain")) type = "text/plain";
                    if (!type) continue;
                    items.push({
                        id: String(++id.current),
                        type,
                        text: await item.getText(type)
                    });
                } else if (item.kind === "file") items.push({
                    id: String(++id.current),
                    type: "file",
                    text: item.name
                });
                else if (item.kind === "directory") for await (let entry of item.getEntries())items.push({
                    id: String(++id.current),
                    type: entry.kind === "directory" ? "folder" : "file",
                    text: entry.name
                });
            }
            if (e.target.type === "root") list.prepend(...items);
            else if (e.target.dropPosition === "before") list.insertBefore(e.target.key, ...items);
            else list.insertAfter(e.target.key, ...items);
        }
    };
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(DroppableGrid, {
        ...props,
        items: list.items,
        onDrop: onDrop,
        ref: ref
    }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _collections.Item), {
            textValue: item.text
        }, item.type === "folder" && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _folderDefault.default), {
            size: "S"
        }), /*#__PURE__*/ (0, _reactDefault.default).createElement("span", null, item.text)));
}
const DroppableGrid = /*#__PURE__*/ (0, _reactDefault.default).forwardRef(function(props, ref) {
    let domRef = (0, _reactDefault.default).useRef(null);
    let state = (0, _list.useListState)(props);
    let keyboardDelegate = new (0, _selection.ListKeyboardDelegate)(state.collection, new Set(), domRef);
    let gridState = (0, _grid.useGridState)({
        selectionMode: "multiple",
        focusMode: "cell",
        selectedKeys: props.selectedKeys,
        onSelectionChange: props.onSelectionChange,
        collection: new (0, _grid.GridCollection)({
            columnCount: 1,
            items: [
                ...state.collection
            ].map((item)=>({
                    ...item,
                    childNodes: [
                        {
                            key: `cell-${item.key}`,
                            type: "cell",
                            index: 0,
                            value: null,
                            level: 0,
                            rendered: null,
                            textValue: item.textValue,
                            hasChildNodes: false,
                            childNodes: []
                        }
                    ]
                }))
        })
    });
    (0, _reactDefault.default).useImperativeHandle(ref, ()=>({
            focusItem (key) {
                gridState.selectionManager.setFocusedKey(`cell-${key}`);
                gridState.selectionManager.setFocused(true);
            }
        }));
    let defaultGetDropOperation = (target, items, allowedOperations)=>{
        if (target.type === "root") return "move";
        if (target.key === "2" && target.dropPosition === "on") return "cancel";
        return target.dropPosition !== "on" ? allowedOperations[0] : "copy";
    };
    let dropState = (0, _dnd1.useDroppableCollectionState)({
        collection: gridState.collection,
        selectionManager: gridState.selectionManager,
        getDropOperation: props.getDropOperation || defaultGetDropOperation,
        onDropEnter: props.onDropEnter,
        onDropExit: props.onDropExit,
        onDrop: props.onDrop
    });
    let { collectionProps } = (0, _.useDroppableCollection)({
        keyboardDelegate,
        dropTargetDelegate: new (0, _dnd.ListDropTargetDelegate)(gridState.collection, domRef),
        onDropActivate: props.onDropActivate,
        onDrop: props.onDrop
    }, dropState, domRef);
    let { gridProps } = (0, _grid1.useGrid)({
        ...props,
        "aria-label": "List",
        focusMode: "cell"
    }, gridState, domRef);
    let isDropTarget = dropState.isDropTarget({
        type: "root"
    });
    let dropRef = (0, _reactDefault.default).useRef();
    let { dropIndicatorProps } = (0, _.useDropIndicator)({
        target: {
            type: "root"
        }
    }, dropState, dropRef);
    let { visuallyHiddenProps } = (0, _visuallyHidden.useVisuallyHidden)();
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...(0, _utils1.mergeProps)(collectionProps, gridProps),
        ref: domRef,
        className: (0, _utils.classNames)((0, _dndCssDefault.default), "droppable-collection", {
            "is-drop-target": isDropTarget
        }),
        style: props.style,
        "data-droptarget": isDropTarget,
        role: "grid"
    }, !dropIndicatorProps["aria-hidden"] && /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        role: "row"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        role: "gridcell",
        "aria-selected": "false"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...visuallyHiddenProps,
        role: "button",
        tabIndex: -1,
        ...dropIndicatorProps,
        ref: dropRef
    }))), [
        ...gridState.collection
    ].map((item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, {
            key: item.key
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement(InsertionIndicator, {
            key: item.key + "-before",
            collectionRef: domRef,
            target: {
                type: "item",
                key: item.key,
                dropPosition: "before"
            },
            dropState: dropState
        }), /*#__PURE__*/ (0, _reactDefault.default).createElement(CollectionItem, {
            key: item.key,
            item: item,
            state: gridState,
            dropState: dropState,
            onPaste: (items)=>props.onDrop({
                    target: {
                        type: "item",
                        key: item.key,
                        dropPosition: "before"
                    },
                    items
                })
        }), state.collection.getKeyAfter(item.key) == null && /*#__PURE__*/ (0, _reactDefault.default).createElement(InsertionIndicator, {
            key: item.key + "-after",
            target: {
                type: "item",
                key: item.key,
                dropPosition: "after"
            },
            collectionRef: domRef,
            dropState: dropState
        }))));
});
function CollectionItem({ item, state, dropState, onPaste }) {
    let rowRef = (0, _reactDefault.default).useRef();
    let cellRef = (0, _reactDefault.default).useRef();
    let cellNode = [
        ...item.childNodes
    ][0];
    let { rowProps } = (0, _grid1.useGridRow)({
        node: item
    }, state, rowRef);
    let { gridCellProps } = (0, _grid1.useGridCell)({
        node: cellNode,
        focusMode: "cell"
    }, state, cellRef);
    let dropIndicatorRef = (0, _reactDefault.default).useRef();
    let { dropIndicatorProps } = (0, _.useDropIndicator)({
        target: {
            type: "item",
            key: item.key,
            dropPosition: "on"
        }
    }, dropState, dropIndicatorRef);
    let { visuallyHiddenProps } = (0, _visuallyHidden.useVisuallyHidden)();
    let { clipboardProps } = (0, _.useClipboard)({
        onPaste
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...rowProps,
        ref: rowRef,
        style: {
            outline: "none"
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _focus.FocusRing), {
        focusRingClass: (0, _utils.classNames)((0, _dndCssDefault.default), "focus-ring")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...(0, _utils1.mergeProps)(gridCellProps, clipboardProps),
        ref: cellRef,
        className: (0, _utils.classNames)((0, _dndCssDefault.default), "droppable", {
            "is-drop-target": dropState.isDropTarget({
                type: "item",
                key: item.key,
                dropPosition: "on"
            }),
            "is-selected": state.selectionManager.isSelected(item.key)
        })
    }, item.rendered, !dropIndicatorProps["aria-hidden"] && /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...visuallyHiddenProps,
        role: "button",
        ...dropIndicatorProps,
        ref: dropIndicatorRef
    }))));
}
function InsertionIndicator(props) {
    let ref = (0, _reactDefault.default).useRef();
    let { dropIndicatorProps } = (0, _.useDropIndicator)(props, props.dropState, ref);
    let { visuallyHiddenProps } = (0, _visuallyHidden.useVisuallyHidden)();
    // If aria-hidden, we are either not in a drag session or the drop target is invalid.
    // In that case, there's no need to render anything at all unless we need to show the indicator visually.
    // This can happen when dragging using the native DnD API as opposed to keyboard dragging.
    if (!props.dropState.isDropTarget(props.target) && dropIndicatorProps["aria-hidden"]) return null;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        role: "row",
        "aria-hidden": dropIndicatorProps["aria-hidden"],
        style: {
            margin: "-5px 0"
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        role: "gridcell",
        "aria-selected": "false",
        className: props.dropState.isDropTarget(props.target) ? (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-DropIndicator", "spectrum-DropIndicator--horizontal") : null,
        style: {
            width: "100%",
            marginLeft: 0,
            height: 2,
            outline: "none"
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...visuallyHiddenProps,
        role: "button",
        ...dropIndicatorProps,
        ref: ref
    })));
}

},{"@react-spectrum/utils":"cMIJ6","./dnd.css":"7vfBr","@adobe/spectrum-css-temp/components/dropindicator/vars.css":"ckNpt","@react-aria/focus":"42mbF","@spectrum-icons/workflow/Folder":"hFWVZ","@react-stately/grid":"ehdYF","@react-stately/collections":"loANi","@react-aria/dnd":"hi3Sh","@react-aria/selection":"6Fly5","@react-aria/utils":"9cLk5","react":"9yzVZ","..":"9GGBK","@react-stately/dnd":"bUQOi","@react-aria/grid":"6tGaN","@react-stately/data":"gEgJM","@react-stately/list":"Cp0zP","@react-aria/visually-hidden":"4jwxT","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"ckNpt":[function(require,module,exports) {
module.exports["spectrum-DropIndicator"] = `_0zqLyW_spectrum-DropIndicator`;
module.exports["spectrum-DropIndicator--horizontal"] = `_0zqLyW_spectrum-DropIndicator--horizontal`;
module.exports["spectrum-DropIndicator--vertical"] = `_0zqLyW_spectrum-DropIndicator--vertical`;

},{}],"hFWVZ":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("a99d919b4ff6ba4a");
exports.__esModule = true;
exports.default = Folder;
var _Folder = require("e0e11029f6913420");
var _icon = require("3013d423180b33ca");
var _react = _interopRequireDefault(require("1171a8cf427a91bd"));
function Folder(props) {
    return /*#__PURE__*/ _react.default.createElement(_icon.Icon, props, /*#__PURE__*/ _react.default.createElement(_Folder.A4uFolder, null));
}

},{"a99d919b4ff6ba4a":"iHubQ","e0e11029f6913420":"32aa0","3013d423180b33ca":"k7wem","1171a8cf427a91bd":"9yzVZ"}],"32aa0":[function(require,module,exports) {
/**
* @adobe/react-spectrum-workflow (c) by Adobe
* 
* @adobe/react-spectrum-workflow is licensed under a
* Creative Commons Attribution-NoDerivatives 4.0 International License.
* 
* You should have received a copy of the license along with this
* work. If not, see <http://creativecommons.org/licenses/by-nd/4.0/>.
**/ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.A4uFolder = A4uFolder;
var _react = _interopRequireDefault(require("656e176cddba4d5e"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function A4uFolder(_ref) {
    var props = _extends({}, _ref);
    return /*#__PURE__*/ _react["default"].createElement("svg", _extends({
        viewBox: "0 0 36 36"
    }, props, props), /*#__PURE__*/ _react["default"].createElement("path", {
        fillRule: "evenodd",
        d: "M33,8h0l-14.332.008-3.3-3.4A2,2,0,0,0,13.929,4H4A2,2,0,0,0,2,6V29a1,1,0,0,0,1,1H33a1,1,0,0,0,1-1V9A1,1,0,0,0,33,8ZM4,6h9.929l3.887,4H4Z"
    }));
}

},{"656e176cddba4d5e":"9yzVZ"}],"9GGBK":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _src = require("./src");
parcelHelpers.exportAll(_src, exports);

},{"./src":"hi3Sh","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"626JG":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DroppableListBoxExample", ()=>DroppableListBoxExample);
parcelHelpers.export(exports, "DroppableListBox", ()=>DroppableListBox);
var _addonActions = require("@storybook/addon-actions");
var _utils = require("@react-aria/utils");
var _utils1 = require("@react-spectrum/utils");
var _dndCss = require("./dnd.css");
var _dndCssDefault = parcelHelpers.interopDefault(_dndCss);
var _varsCss = require("@adobe/spectrum-css-temp/components/dropindicator/vars.css");
var _varsCssDefault = parcelHelpers.interopDefault(_varsCss);
var _focus = require("@react-aria/focus");
var _folder = require("@spectrum-icons/workflow/Folder");
var _folderDefault = parcelHelpers.interopDefault(_folder);
var _collections = require("@react-stately/collections");
var _dnd = require("@react-aria/dnd");
var _selection = require("@react-aria/selection");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _ = require("..");
var _dnd1 = require("@react-stately/dnd");
var _listbox = require("@react-aria/listbox");
var _data = require("@react-stately/data");
var _list = require("@react-stately/list");
var _visuallyHidden = require("@react-aria/visually-hidden");
function DroppableListBoxExample(props) {
    var _props_items;
    let id = (0, _reactDefault.default).useRef(((_props_items = props.items) === null || _props_items === void 0 ? void 0 : _props_items.length) || 3);
    let list = (0, _data.useListData)({
        initialItems: props.items || [
            {
                id: "1",
                type: "folder",
                text: "One"
            },
            {
                id: "2",
                type: "item",
                text: "Two"
            },
            {
                id: "3",
                type: "folder",
                text: "Three"
            }
        ]
    });
    let ref = (0, _reactDefault.default).useRef(null);
    let onDrop = async (e)=>{
        if (e.target.type === "root" || e.target.dropPosition !== "on") {
            let items = [];
            for (let item of e.items){
                let type;
                if (item.kind === "text") {
                    if (item.types.has("folder")) type = "folder";
                    else if (item.types.has("item")) type = "item";
                    if (!type) continue;
                    items.push({
                        id: String(++id.current),
                        type,
                        text: await item.getText(type)
                    });
                }
            }
            if (e.target.type === "root") list.prepend(...items);
            else if (e.target.dropPosition === "before") list.insertBefore(e.target.key, ...items);
            else list.insertAfter(e.target.key, ...items);
        }
    };
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(DroppableListBox, {
        items: list.items,
        onDrop: onDrop,
        ref: ref
    }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _collections.Item), {
            textValue: item.text
        }, item.type === "folder" && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _folderDefault.default), {
            size: "S"
        }), /*#__PURE__*/ (0, _reactDefault.default).createElement("span", null, item.text)));
}
const DroppableListBox = /*#__PURE__*/ (0, _reactDefault.default).forwardRef(function(props, ref) {
    let domRef = (0, _reactDefault.default).useRef(null);
    let onDrop = async (e)=>{
        var _props_onDrop;
        (0, _addonActions.action)("onDrop")(e);
        (_props_onDrop = props.onDrop) === null || _props_onDrop === void 0 ? void 0 : _props_onDrop.call(props, e);
    };
    let state = (0, _list.useListState)({
        ...props,
        selectionMode: "multiple"
    });
    let keyboardDelegate = new (0, _selection.ListKeyboardDelegate)(state.collection, new Set(), domRef);
    (0, _reactDefault.default).useImperativeHandle(ref, ()=>({
            focusItem (key) {
                state.selectionManager.setFocusedKey(key);
                state.selectionManager.setFocused(true);
            }
        }));
    let dropState = (0, _dnd1.useDroppableCollectionState)({
        collection: state.collection,
        selectionManager: state.selectionManager,
        getDropOperation: (target, _, allowedOperations)=>{
            if (target.type === "root") return "move";
            if (target.key === "2" && target.dropPosition === "on") return "cancel";
            return target.dropPosition !== "on" ? allowedOperations[0] : "copy";
        },
        onDrop
    });
    let { collectionProps } = (0, _.useDroppableCollection)({
        keyboardDelegate,
        dropTargetDelegate: new (0, _dnd.ListDropTargetDelegate)(state.collection, domRef),
        onDropActivate: (0, _utils.chain)((0, _addonActions.action)("onDropActivate"), console.log),
        onDrop
    }, dropState, domRef);
    let { listBoxProps } = (0, _listbox.useListBox)({
        ...props,
        "aria-label": "List",
        keyboardDelegate
    }, state, domRef);
    let isDropTarget = dropState.isDropTarget({
        type: "root"
    });
    let dropRef = (0, _reactDefault.default).useRef();
    let { dropIndicatorProps } = (0, _.useDropIndicator)({
        target: {
            type: "root"
        }
    }, dropState, dropRef);
    let { visuallyHiddenProps } = (0, _visuallyHidden.useVisuallyHidden)();
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...(0, _utils.mergeProps)(collectionProps, listBoxProps),
        ref: domRef,
        className: (0, _utils1.classNames)((0, _dndCssDefault.default), "droppable-collection", {
            "is-drop-target": isDropTarget
        })
    }, !dropIndicatorProps["aria-hidden"] && /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        role: "option",
        "aria-selected": "false",
        ...visuallyHiddenProps,
        ...dropIndicatorProps,
        ref: dropRef
    }), [
        ...state.collection
    ].map((item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement(InsertionIndicator, {
            key: item.key + "-before",
            collectionRef: domRef,
            target: {
                type: "item",
                key: item.key,
                dropPosition: "before"
            },
            dropState: dropState
        }), /*#__PURE__*/ (0, _reactDefault.default).createElement(CollectionItem, {
            key: item.key,
            item: item,
            state: state,
            dropState: dropState
        }), state.collection.getKeyAfter(item.key) == null && /*#__PURE__*/ (0, _reactDefault.default).createElement(InsertionIndicator, {
            key: item.key + "-after",
            target: {
                type: "item",
                key: item.key,
                dropPosition: "after"
            },
            collectionRef: domRef,
            dropState: dropState
        }))));
});
function CollectionItem({ item, state, dropState }) {
    let ref = (0, _reactDefault.default).useRef();
    let { optionProps } = (0, _listbox.useOption)({
        key: item.key,
        isSelected: state.selectionManager.isSelected(item.key)
    }, state, ref);
    let { dropProps } = (0, _.useDroppableItem)({
        target: {
            type: "item",
            key: item.key,
            dropPosition: "on"
        }
    }, dropState, ref);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _focus.FocusRing), {
        focusRingClass: (0, _utils1.classNames)((0, _dndCssDefault.default), "focus-ring")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...(0, _utils.mergeProps)(optionProps, dropProps),
        ref: ref,
        className: (0, _utils1.classNames)((0, _dndCssDefault.default), "droppable", {
            "is-drop-target": dropState.isDropTarget({
                type: "item",
                key: item.key,
                dropPosition: "on"
            }),
            "is-selected": state.selectionManager.isSelected(item.key)
        })
    }, item.rendered));
}
function InsertionIndicator(props) {
    let ref = (0, _reactDefault.default).useRef();
    let { dropIndicatorProps } = (0, _.useDropIndicator)(props, props.dropState, ref);
    // If aria-hidden, we are either not in a drag session or the drop target is invalid.
    // In that case, there's no need to render anything at all unless we need to show the indicator visually.
    // This can happen when dragging using the native DnD API as opposed to keyboard dragging.
    if (!props.dropState.isDropTarget(props.target) && dropIndicatorProps["aria-hidden"]) return null;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        role: "option",
        "aria-selected": "false",
        ...dropIndicatorProps,
        ref: ref,
        className: props.dropState.isDropTarget(props.target) ? (0, _utils1.classNames)((0, _varsCssDefault.default), "spectrum-DropIndicator", "spectrum-DropIndicator--horizontal") : null,
        style: {
            width: "100%",
            margin: "-5px 0",
            height: 2,
            outline: "none"
        }
    });
}

},{"@storybook/addon-actions":"coXbW","@react-aria/utils":"9cLk5","@react-spectrum/utils":"cMIJ6","./dnd.css":"7vfBr","@adobe/spectrum-css-temp/components/dropindicator/vars.css":"ckNpt","@react-aria/focus":"42mbF","@spectrum-icons/workflow/Folder":"hFWVZ","@react-stately/collections":"loANi","@react-aria/dnd":"hi3Sh","@react-aria/selection":"6Fly5","react":"9yzVZ","..":"9GGBK","@react-stately/dnd":"bUQOi","@react-aria/listbox":"bHZSJ","@react-stately/data":"gEgJM","@react-stately/list":"Cp0zP","@react-aria/visually-hidden":"4jwxT","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"dbVuU":[function(require,module,exports) {
module.exports["focus-ring"] = `_6Xff-a_focus-ring`;
module.exports["i18nFontFamily"] = `_6Xff-a_i18nFontFamily`;
module.exports["is-dragged"] = `_6Xff-a_is-dragged`;
module.exports["spectrum-Dropzone"] = `_6Xff-a_spectrum-Dropzone`;
module.exports["spectrum-FocusRing-ring"] = `_6Xff-a_spectrum-FocusRing-ring`;
module.exports["spectrum-FocusRing"] = `_6Xff-a_spectrum-FocusRing ${module.exports["spectrum-FocusRing-ring"]}`;
module.exports["spectrum-FocusRing--quiet"] = `_6Xff-a_spectrum-FocusRing--quiet`;
module.exports["spectrum-IllustratedMessage-illustration"] = `_6Xff-a_spectrum-IllustratedMessage-illustration`;

},{}],"jKZ2V":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("9d79fe12c02f1a25");
exports.__esModule = true;
exports.default = Paste;
var _Paste = require("9b0700f79b2863e1");
var _icon = require("5216d855e68d37ee");
var _react = _interopRequireDefault(require("91fe9626a0345b4f"));
function Paste(props) {
    return /*#__PURE__*/ _react.default.createElement(_icon.Icon, props, /*#__PURE__*/ _react.default.createElement(_Paste.A4uPaste, null));
}

},{"9d79fe12c02f1a25":"iHubQ","9b0700f79b2863e1":"fjDNm","5216d855e68d37ee":"k7wem","91fe9626a0345b4f":"9yzVZ"}],"fjDNm":[function(require,module,exports) {
/**
* @adobe/react-spectrum-workflow (c) by Adobe
* 
* @adobe/react-spectrum-workflow is licensed under a
* Creative Commons Attribution-NoDerivatives 4.0 International License.
* 
* You should have received a copy of the license along with this
* work. If not, see <http://creativecommons.org/licenses/by-nd/4.0/>.
**/ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.A4uPaste = A4uPaste;
var _react = _interopRequireDefault(require("4224cc1b3718e4a1"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function A4uPaste(_ref) {
    var props = _extends({}, _ref);
    return /*#__PURE__*/ _react["default"].createElement("svg", _extends({
        viewBox: "0 0 36 36"
    }, props, props), /*#__PURE__*/ _react["default"].createElement("path", {
        fillRule: "evenodd",
        d: "M28,6v5a1,1,0,0,1-1,1H9a1,1,0,0,1-1-1V6H5A1,1,0,0,0,4,7V33a1,1,0,0,0,1,1H31a1,1,0,0,0,1-1V7a1,1,0,0,0-1-1Z"
    }), /*#__PURE__*/ _react["default"].createElement("path", {
        fillRule: "evenodd",
        d: "M22,6V4a4,4,0,0,0-8,0V6H10v4H26V6ZM20,6H16V4a2,2,0,0,1,4,0Z"
    }));
}

},{"4224cc1b3718e4a1":"9yzVZ"}],"6aYul":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReorderableGridExample", ()=>ReorderableGridExample);
var _addonActions = require("@storybook/addon-actions");
var _utils = require("@react-aria/utils");
var _utils1 = require("@react-spectrum/utils");
var _dndCss = require("./dnd.css");
var _dndCssDefault = parcelHelpers.interopDefault(_dndCss);
var _src = require("../src");
var _varsCss = require("@adobe/spectrum-css-temp/components/dropindicator/vars.css");
var _varsCssDefault = parcelHelpers.interopDefault(_varsCss);
var _focus = require("@react-aria/focus");
var _folder = require("@spectrum-icons/workflow/Folder");
var _folderDefault = parcelHelpers.interopDefault(_folder);
var _grid = require("@react-stately/grid");
var _collections = require("@react-stately/collections");
var _dnd = require("@react-aria/dnd");
var _selection = require("@react-aria/selection");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _showMenu = require("@spectrum-icons/workflow/ShowMenu");
var _showMenuDefault = parcelHelpers.interopDefault(_showMenu);
var _button = require("@react-aria/button");
var _ = require("..");
var _dnd1 = require("@react-stately/dnd");
var _grid1 = require("@react-aria/grid");
var _data = require("@react-stately/data");
var _list = require("@react-stately/list");
var _visuallyHidden = require("@react-aria/visually-hidden");
function ReorderableGridExample(props) {
    let list = (0, _data.useListData)({
        initialItems: props.items || [
            {
                id: "1",
                type: "item",
                text: "One"
            },
            {
                id: "2",
                type: "item",
                text: "Two"
            },
            {
                id: "3",
                type: "item",
                text: "Three"
            },
            {
                id: "4",
                type: "item",
                text: "Four"
            },
            {
                id: "5",
                type: "item",
                text: "Five"
            },
            {
                id: "6",
                type: "item",
                text: "Six"
            }
        ]
    });
    let onMove = (keys, target)=>{
        if (target.dropPosition === "before") list.moveBefore(target.key, keys);
        else list.moveAfter(target.key, keys);
    };
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(ReorderableGrid, {
        items: list.items,
        onMove: onMove
    }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _collections.Item), {
            textValue: item.text
        }, item.type === "folder" && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _folderDefault.default), {
            size: "S"
        }), /*#__PURE__*/ (0, _reactDefault.default).createElement("span", null, item.text)));
}
function ReorderableGrid(props) {
    let ref = (0, _reactDefault.default).useRef(null);
    let state = (0, _list.useListState)(props);
    let keyboardDelegate = new (0, _selection.ListKeyboardDelegate)(state.collection, new Set(), ref);
    let gridState = (0, _grid.useGridState)({
        selectionMode: "multiple",
        collection: new (0, _grid.GridCollection)({
            columnCount: 1,
            items: [
                ...state.collection
            ].map((item)=>({
                    ...item,
                    childNodes: [
                        {
                            key: `cell-${item.key}`,
                            type: "cell",
                            index: 0,
                            value: null,
                            level: 0,
                            rendered: null,
                            textValue: item.textValue,
                            hasChildNodes: false,
                            childNodes: []
                        }
                    ]
                }))
        })
    });
    // Use a random drag type so the items can only be reordered within this list and not dragged elsewhere.
    let dragType = (0, _reactDefault.default).useMemo(()=>`keys-${Math.random().toString(36).slice(2)}`, []);
    let preview = (0, _react.useRef)(null);
    let dragState = (0, _dnd1.useDraggableCollectionState)({
        collection: gridState.collection,
        selectionManager: gridState.selectionManager,
        getItems (keys) {
            return [
                ...keys
            ].map((key)=>({
                    [dragType]: JSON.stringify(key)
                }));
        },
        preview,
        onDragStart: (0, _addonActions.action)("onDragStart"),
        onDragEnd: (0, _utils.chain)((0, _addonActions.action)("onDragEnd"), props.onDragEnd)
    });
    (0, _.useDraggableCollection)({}, dragState, ref);
    let onDrop = async (e)=>{
        if (e.target.type !== "root" && e.target.dropPosition !== "on" && props.onMove) {
            let keys = [];
            for (let item of e.items)if (item.kind === "text" && item.types.has(dragType)) {
                let key = JSON.parse(await item.getText(dragType));
                keys.push(key);
            }
            props.onMove(keys, e.target);
        }
    };
    let dropState = (0, _dnd1.useDroppableCollectionState)({
        collection: gridState.collection,
        selectionManager: gridState.selectionManager,
        getDropOperation (target) {
            if (target.type === "root" || target.dropPosition === "on") return "cancel";
            return "move";
        },
        onDrop
    });
    let { collectionProps } = (0, _.useDroppableCollection)({
        keyboardDelegate,
        dropTargetDelegate: new (0, _dnd.ListDropTargetDelegate)(state.collection, ref),
        onDropActivate: (0, _utils.chain)((0, _addonActions.action)("onDropActivate"), console.log),
        onDrop
    }, dropState, ref);
    let { gridProps } = (0, _grid1.useGrid)({
        ...props,
        "aria-label": "Reorderable list",
        focusMode: "cell"
    }, gridState, ref);
    let isDropTarget = dropState.isDropTarget({
        type: "root"
    });
    let dropRef = (0, _reactDefault.default).useRef();
    let { dropIndicatorProps } = (0, _.useDropIndicator)({
        target: {
            type: "root"
        }
    }, dropState, dropRef);
    let { visuallyHiddenProps } = (0, _visuallyHidden.useVisuallyHidden)();
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...(0, _utils.mergeProps)(collectionProps, gridProps),
        ref: ref,
        className: (0, _utils1.classNames)((0, _dndCssDefault.default), "droppable-collection", {
            "is-drop-target": isDropTarget
        })
    }, !dropIndicatorProps["aria-hidden"] && /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        role: "row",
        "aria-hidden": dropIndicatorProps["aria-hidden"]
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        role: "gridcell",
        "aria-selected": "false"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...visuallyHiddenProps,
        role: "button",
        tabIndex: -1,
        ...dropIndicatorProps,
        ref: dropRef
    }))), [
        ...gridState.collection
    ].map((item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement(InsertionIndicator, {
            key: item.key + "-before",
            collectionRef: ref,
            target: {
                type: "item",
                key: item.key,
                dropPosition: "before"
            },
            dropState: dropState
        }), /*#__PURE__*/ (0, _reactDefault.default).createElement(CollectionItem, {
            key: item.key,
            item: item,
            state: gridState,
            dragState: dragState,
            dropState: dropState
        }), gridState.collection.getKeyAfter(item.key) == null && /*#__PURE__*/ (0, _reactDefault.default).createElement(InsertionIndicator, {
            key: item.key + "-after",
            target: {
                type: "item",
                key: item.key,
                dropPosition: "after"
            },
            collectionRef: ref,
            dropState: dropState
        }))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _src.DragPreview), {
        ref: preview
    }, ()=>{
        let item = state.collection.getItem(dragState.draggedKey);
        return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
            className: (0, _utils1.classNames)((0, _dndCssDefault.default), "draggable", "is-drag-preview", {
                "is-dragging-multiple": dragState.draggingKeys.size > 1
            })
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
            className: (0, _utils1.classNames)((0, _dndCssDefault.default), "drag-handle")
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _showMenuDefault.default), {
            size: "XS"
        })), /*#__PURE__*/ (0, _reactDefault.default).createElement("span", null, item.rendered), dragState.draggingKeys.size > 1 && /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
            className: (0, _utils1.classNames)((0, _dndCssDefault.default), "badge")
        }, dragState.draggingKeys.size));
    }));
}
function CollectionItem({ item, state, dragState, dropState }) {
    let rowRef = (0, _reactDefault.default).useRef();
    let cellRef = (0, _reactDefault.default).useRef();
    let cellNode = [
        ...item.childNodes
    ][0];
    let { rowProps } = (0, _grid1.useGridRow)({
        node: item
    }, state, rowRef);
    let { gridCellProps } = (0, _grid1.useGridCell)({
        node: cellNode,
        focusMode: "cell",
        shouldSelectOnPressUp: true
    }, state, cellRef);
    let { dragProps, dragButtonProps } = (0, _.useDraggableItem)({
        key: item.key,
        hasDragButton: true
    }, dragState);
    let dragButtonRef = (0, _reactDefault.default).useRef();
    let { buttonProps } = (0, _button.useButton)({
        ...dragButtonProps,
        elementType: "div"
    }, dragButtonRef);
    let dropIndicatorRef = (0, _reactDefault.default).useRef();
    let { dropIndicatorProps } = (0, _.useDropIndicator)({
        target: {
            type: "item",
            key: item.key,
            dropPosition: "on"
        }
    }, dropState, dropIndicatorRef);
    let { visuallyHiddenProps } = (0, _visuallyHidden.useVisuallyHidden)();
    let id = (0, _utils.useId)();
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...(0, _utils.mergeProps)(rowProps, dragProps),
        ref: rowRef,
        style: {
            outline: "none"
        },
        "aria-labelledby": id
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _focus.FocusRing), {
        focusRingClass: (0, _utils1.classNames)((0, _dndCssDefault.default), "focus-ring")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...gridCellProps,
        "aria-labelledby": id,
        ref: cellRef,
        className: (0, _utils1.classNames)((0, _dndCssDefault.default), "draggable", "droppable", {
            "is-dragging": dragState.isDragging(item.key),
            "is-drop-target": dropState.isDropTarget({
                type: "item",
                key: item.key,
                dropPosition: "on"
            }),
            "is-selected": state.selectionManager.isSelected(item.key)
        })
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _focus.FocusRing), {
        focusRingClass: (0, _utils1.classNames)((0, _dndCssDefault.default), "focus-ring")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...buttonProps,
        ref: dragButtonRef,
        className: (0, _utils1.classNames)((0, _dndCssDefault.default), "drag-handle")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _showMenuDefault.default), {
        size: "XS"
    }))), /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        id: id
    }, item.rendered), !dropIndicatorProps["aria-hidden"] && /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...visuallyHiddenProps,
        role: "button",
        ...dropIndicatorProps,
        ref: dropIndicatorRef
    }))));
}
function InsertionIndicator(props) {
    let ref = (0, _reactDefault.default).useRef();
    let { dropIndicatorProps } = (0, _.useDropIndicator)(props, props.dropState, ref);
    let { visuallyHiddenProps } = (0, _visuallyHidden.useVisuallyHidden)();
    // If aria-hidden, we are either not in a drag session or the drop target is invalid.
    // In that case, there's no need to render anything at all unless we need to show the indicator visually.
    // This can happen when dragging using the native DnD API as opposed to keyboard dragging.
    if (!props.dropState.isDropTarget(props.target) && dropIndicatorProps["aria-hidden"]) return null;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        role: "row",
        "aria-hidden": dropIndicatorProps["aria-hidden"]
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        role: "gridcell",
        "aria-selected": "false",
        className: props.dropState.isDropTarget(props.target) ? (0, _utils1.classNames)((0, _varsCssDefault.default), "spectrum-DropIndicator", "spectrum-DropIndicator--horizontal") : null,
        style: {
            width: "100%",
            marginLeft: 0,
            height: 2,
            marginBottom: -2,
            outline: "none"
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...visuallyHiddenProps,
        role: "button",
        ...dropIndicatorProps,
        ref: ref
    })));
}

},{"@storybook/addon-actions":"coXbW","@react-aria/utils":"9cLk5","@react-spectrum/utils":"cMIJ6","./dnd.css":"7vfBr","../src":"hi3Sh","@adobe/spectrum-css-temp/components/dropindicator/vars.css":"ckNpt","@react-aria/focus":"42mbF","@spectrum-icons/workflow/Folder":"hFWVZ","@react-stately/grid":"ehdYF","@react-stately/collections":"loANi","@react-aria/dnd":"hi3Sh","@react-aria/selection":"6Fly5","react":"9yzVZ","@spectrum-icons/workflow/ShowMenu":"jtOrd","@react-aria/button":"fsdLZ","..":"9GGBK","@react-stately/dnd":"bUQOi","@react-aria/grid":"6tGaN","@react-stately/data":"gEgJM","@react-stately/list":"Cp0zP","@react-aria/visually-hidden":"4jwxT","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"jtOrd":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("10f394463160aedb");
exports.__esModule = true;
exports.default = ShowMenu;
var _ShowMenu = require("eb27788bbdb04ea1");
var _icon = require("71c10aa2ef219a65");
var _react = _interopRequireDefault(require("2438b36a18fdb420"));
function ShowMenu(props) {
    return /*#__PURE__*/ _react.default.createElement(_icon.Icon, props, /*#__PURE__*/ _react.default.createElement(_ShowMenu.A4uShowMenu, null));
}

},{"10f394463160aedb":"iHubQ","eb27788bbdb04ea1":"8Z04f","71c10aa2ef219a65":"k7wem","2438b36a18fdb420":"9yzVZ"}],"8Z04f":[function(require,module,exports) {
/**
* @adobe/react-spectrum-workflow (c) by Adobe
* 
* @adobe/react-spectrum-workflow is licensed under a
* Creative Commons Attribution-NoDerivatives 4.0 International License.
* 
* You should have received a copy of the license along with this
* work. If not, see <http://creativecommons.org/licenses/by-nd/4.0/>.
**/ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.A4uShowMenu = A4uShowMenu;
var _react = _interopRequireDefault(require("f48107c5153a083a"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function A4uShowMenu(_ref) {
    var props = _extends({}, _ref);
    return /*#__PURE__*/ _react["default"].createElement("svg", _extends({
        viewBox: "0 0 36 36"
    }, props, props), /*#__PURE__*/ _react["default"].createElement("rect", {
        fillRule: "evenodd",
        height: "4",
        rx: "1",
        ry: "1",
        width: "28",
        x: "4",
        y: "16"
    }), /*#__PURE__*/ _react["default"].createElement("rect", {
        fillRule: "evenodd",
        height: "4",
        rx: "1",
        ry: "1",
        width: "28",
        x: "4",
        y: "6"
    }), /*#__PURE__*/ _react["default"].createElement("rect", {
        fillRule: "evenodd",
        height: "4",
        rx: "1",
        ry: "1",
        width: "28",
        x: "4",
        y: "26"
    }));
}

},{"f48107c5153a083a":"9yzVZ"}],"jRKvD":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "VirtualizedListBoxExample", ()=>VirtualizedListBoxExample);
parcelHelpers.export(exports, "VirtualizedListBox", ()=>VirtualizedListBox);
var _addonActions = require("@storybook/addon-actions");
var _utils = require("@react-aria/utils");
var _utils1 = require("@react-spectrum/utils");
var _dndCss = require("./dnd.css");
var _dndCssDefault = parcelHelpers.interopDefault(_dndCss);
var _varsCss = require("@adobe/spectrum-css-temp/components/dropindicator/vars.css");
var _varsCssDefault = parcelHelpers.interopDefault(_varsCss);
var _focus = require("@react-aria/focus");
var _folder = require("@spectrum-icons/workflow/Folder");
var _folderDefault = parcelHelpers.interopDefault(_folder);
var _collections = require("@react-stately/collections");
var _layout = require("@react-stately/layout");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _i18N = require("@react-aria/i18n");
var _ = require("..");
var _dnd = require("@react-stately/dnd");
var _listbox = require("@react-aria/listbox");
var _data = require("@react-stately/data");
var _list = require("@react-stately/list");
var _visuallyHidden = require("@react-aria/visually-hidden");
var _virtualizer = require("@react-aria/virtualizer");
function VirtualizedListBoxExample(props) {
    var _props_items;
    let id = (0, _reactDefault.default).useRef(((_props_items = props.items) === null || _props_items === void 0 ? void 0 : _props_items.length) || 3);
    let list = (0, _data.useListData)({
        initialItems: props.items || [
            {
                id: "1",
                type: "folder",
                text: "One"
            },
            {
                id: "2",
                type: "item",
                text: "Two"
            },
            {
                id: "3",
                type: "folder",
                text: "Three"
            }
        ]
    });
    let ref = (0, _reactDefault.default).useRef(null);
    let onDrop = async (e)=>{
        if (e.target.type === "root" || e.target.dropPosition !== "on") {
            let items = [];
            for (let item of e.items)if (item.kind === "text") {
                let type;
                if (props.accept && item.types.has(props.accept)) type = props.accept;
                else if (item.types.has("folder")) type = "folder";
                else if (item.types.has("item")) type = "item";
                if (!type) continue;
                items.push({
                    id: String(++id.current),
                    type,
                    text: await item.getText(type)
                });
            }
            if (e.target.type === "root") list.prepend(...items);
            else if (e.target.dropPosition === "before") list.insertBefore(e.target.key, ...items);
            else list.insertAfter(e.target.key, ...items);
        }
    };
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(VirtualizedListBox, {
        items: list.items,
        onDrop: onDrop,
        accept: props.accept,
        ref: ref
    }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _collections.Item), {
            textValue: item.text
        }, item.type === "folder" && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _folderDefault.default), {
            size: "S"
        }), /*#__PURE__*/ (0, _reactDefault.default).createElement("span", null, item.text)));
}
const Context = /*#__PURE__*/ (0, _reactDefault.default).createContext(null);
const acceptedTypes = [
    "item",
    "folder"
];
const VirtualizedListBox = /*#__PURE__*/ (0, _reactDefault.default).forwardRef(function(props, ref) {
    var _dropState_target;
    let domRef = (0, _reactDefault.default).useRef(null);
    let onDrop = async (e)=>{
        var _props_onDrop;
        (0, _addonActions.action)("onDrop")(e);
        (_props_onDrop = props.onDrop) === null || _props_onDrop === void 0 ? void 0 : _props_onDrop.call(props, e);
    };
    let state = (0, _list.useListState)({
        ...props,
        selectionMode: "multiple"
    });
    (0, _reactDefault.default).useImperativeHandle(ref, ()=>({
            focusItem (key) {
                state.selectionManager.setFocusedKey(key);
                state.selectionManager.setFocused(true);
            }
        }));
    let dropState = (0, _dnd.useDroppableCollectionState)({
        collection: state.collection,
        selectionManager: state.selectionManager,
        getDropOperation (target, types, allowedOperations) {
            if (props.accept) {
                // Don't accept if types includes both items and folders.
                let rejected = acceptedTypes.filter((type)=>type !== props.accept);
                if (!types.has(props.accept) || rejected.some((type)=>types.has(type))) return "cancel";
            } else if (!acceptedTypes.some((type)=>types.has(type))) return "cancel";
            if (target.type === "root") return "move";
            if (target.key === "2" && target.dropPosition === "on") return "cancel";
            return target.dropPosition !== "on" ? allowedOperations[0] : "copy";
        },
        onDrop
    });
    let collator = (0, _i18N.useCollator)({
        usage: "search",
        sensitivity: "base"
    });
    let layout = (0, _reactDefault.default).useMemo(()=>new (0, _layout.ListLayout)({
            estimatedRowHeight: 32,
            padding: 8,
            loaderHeight: 40,
            placeholderHeight: 32,
            collator
        }), [
        collator
    ]);
    layout.collection = state.collection;
    let { collectionProps } = (0, _.useDroppableCollection)({
        keyboardDelegate: layout,
        dropTargetDelegate: layout,
        onDropActivate: (0, _utils.chain)((0, _addonActions.action)("onDropActivate"), console.log),
        onDrop
    }, dropState, domRef);
    let { listBoxProps } = (0, _listbox.useListBox)({
        ...props,
        "aria-label": "List",
        keyboardDelegate: layout,
        isVirtualized: true
    }, state, domRef);
    let isDropTarget = dropState.isDropTarget({
        type: "root"
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Context.Provider, {
        value: {
            state,
            dropState
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _virtualizer.Virtualizer), {
        ...(0, _utils.mergeProps)(collectionProps, listBoxProps),
        ref: domRef,
        className: (0, _utils1.classNames)((0, _dndCssDefault.default), "droppable-collection", "is-virtualized", {
            "is-drop-target": isDropTarget
        }),
        sizeToFit: "height",
        scrollDirection: "vertical",
        layout: layout,
        collection: state.collection,
        focusedKey: ((_dropState_target = dropState.target) === null || _dropState_target === void 0 ? void 0 : _dropState_target.type) === "item" ? dropState.target.key : state.selectionManager.focusedKey
    }, (type, item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, state.collection.getKeyBefore(item.key) == null && /*#__PURE__*/ (0, _reactDefault.default).createElement(RootDropIndicator, null), /*#__PURE__*/ (0, _reactDefault.default).createElement(InsertionIndicator, {
            key: item.key + "-before",
            target: {
                type: "item",
                key: item.key,
                dropPosition: "before"
            }
        }), /*#__PURE__*/ (0, _reactDefault.default).createElement(CollectionItem, {
            key: item.key,
            item: item
        }), state.collection.getKeyAfter(item.key) == null && /*#__PURE__*/ (0, _reactDefault.default).createElement(InsertionIndicator, {
            key: item.key + "-after",
            target: {
                type: "item",
                key: item.key,
                dropPosition: "after"
            }
        }))));
});
function CollectionItem({ item }) {
    let { state, dropState } = (0, _reactDefault.default).useContext(Context);
    let ref = (0, _reactDefault.default).useRef();
    let { optionProps } = (0, _listbox.useOption)({
        key: item.key,
        isSelected: state.selectionManager.isSelected(item.key),
        isVirtualized: true
    }, state, ref);
    let { dropProps } = (0, _.useDroppableItem)({
        target: {
            type: "item",
            key: item.key,
            dropPosition: "on"
        }
    }, dropState, ref);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _focus.FocusRing), {
        focusRingClass: (0, _utils1.classNames)((0, _dndCssDefault.default), "focus-ring")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...(0, _utils.mergeProps)(optionProps, dropProps),
        ref: ref,
        className: (0, _utils1.classNames)((0, _dndCssDefault.default), "droppable", {
            "is-drop-target": dropState.isDropTarget({
                type: "item",
                key: item.key,
                dropPosition: "on"
            }),
            "is-selected": state.selectionManager.isSelected(item.key)
        }),
        style: {
            margin: "4px 12px"
        }
    }, item.rendered));
}
function InsertionIndicator(props) {
    let { dropState } = (0, _reactDefault.default).useContext(Context);
    let ref = (0, _reactDefault.default).useRef();
    let { dropIndicatorProps } = (0, _.useDropIndicator)(props, dropState, ref);
    // If aria-hidden, we are either not in a drag session or the drop target is invalid.
    // In that case, there's no need to render anything at all unless we need to show the indicator visually.
    // This can happen when dragging using the native DnD API as opposed to keyboard dragging.
    if (!dropState.isDropTarget(props.target) && dropIndicatorProps["aria-hidden"]) return null;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        role: "option",
        "aria-selected": "false",
        ...dropIndicatorProps,
        ref: ref,
        className: dropState.isDropTarget(props.target) ? (0, _utils1.classNames)((0, _varsCssDefault.default), "spectrum-DropIndicator", "spectrum-DropIndicator--horizontal") : null,
        style: {
            width: "calc(100% - 24px)",
            margin: "0 12px 0 12px",
            height: 2,
            marginBottom: -2,
            outline: "none"
        }
    });
}
function RootDropIndicator() {
    let { dropState } = (0, _reactDefault.default).useContext(Context);
    let dropRef = (0, _reactDefault.default).useRef();
    let { dropIndicatorProps } = (0, _.useDropIndicator)({
        target: {
            type: "root"
        }
    }, dropState, dropRef);
    let { visuallyHiddenProps } = (0, _visuallyHidden.useVisuallyHidden)();
    if (dropIndicatorProps["aria-hidden"]) return null;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        role: "option",
        "aria-selected": "false",
        ...visuallyHiddenProps,
        ...dropIndicatorProps,
        ref: dropRef
    });
}

},{"@storybook/addon-actions":"coXbW","@react-aria/utils":"9cLk5","@react-spectrum/utils":"cMIJ6","./dnd.css":"7vfBr","@adobe/spectrum-css-temp/components/dropindicator/vars.css":"ckNpt","@react-aria/focus":"42mbF","@spectrum-icons/workflow/Folder":"hFWVZ","@react-stately/collections":"loANi","@react-stately/layout":"6Mwz5","react":"9yzVZ","@react-aria/i18n":"411rg","..":"9GGBK","@react-stately/dnd":"bUQOi","@react-aria/listbox":"bHZSJ","@react-stately/data":"gEgJM","@react-stately/list":"Cp0zP","@react-aria/visually-hidden":"4jwxT","@react-aria/virtualizer":"gAPsK","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"6Mwz5":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ListLayout", ()=>(0, _listLayout.ListLayout));
parcelHelpers.export(exports, "TableLayout", ()=>(0, _tableLayout.TableLayout));
var _listLayout = require("./ListLayout");
var _tableLayout = require("./TableLayout");

},{"./ListLayout":"lftKz","./TableLayout":"fxSwb","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"lftKz":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The ListLayout class is an implementation of a collection view {@link Layout}
 * it is used for creating lists and lists with indented sub-lists.
 *
 * To configure a ListLayout, you can use the properties to define the
 * layouts and/or use the method for defining indentation.
 * The {@link ListKeyboardDelegate} extends the existing collection view
 * delegate with an additional method to do this (it uses the same delegate object as
 * the collection view itself).
 */ parcelHelpers.export(exports, "ListLayout", ()=>ListLayout);
var _collections = require("@react-stately/collections");
var _virtualizer = require("@react-stately/virtualizer");
const DEFAULT_HEIGHT = 48;
class ListLayout extends (0, _virtualizer.Layout) {
    getLayoutInfo(key) {
        let res = this.layoutInfos.get(key);
        // If the layout info wasn't found, it might be outside the bounds of the area that we've
        // computed layout for so far. This can happen when accessing a random key, e.g pressing Home/End.
        // Compute the full layout and try again.
        if (!res && this.validRect.area < this.contentSize.area && this.lastCollection) {
            this.lastValidRect = this.validRect;
            this.validRect = new (0, _virtualizer.Rect)(0, 0, Infinity, Infinity);
            this.rootNodes = this.buildCollection();
            this.validRect = new (0, _virtualizer.Rect)(0, 0, this.contentSize.width, this.contentSize.height);
            res = this.layoutInfos.get(key);
        }
        return res;
    }
    getVisibleLayoutInfos(rect) {
        // If layout hasn't yet been done for the requested rect, union the
        // new rect with the existing valid rect, and recompute.
        if (!this.validRect.containsRect(rect) && this.lastCollection) {
            this.lastValidRect = this.validRect;
            this.validRect = this.validRect.union(rect);
            this.rootNodes = this.buildCollection();
        }
        let res = [];
        let addNodes = (nodes)=>{
            for (let node of nodes)if (this.isVisible(node, rect)) {
                res.push(node.layoutInfo);
                if (node.header) res.push(node.header);
                if (node.children) addNodes(node.children);
            }
        };
        addNodes(this.rootNodes);
        return res;
    }
    isVisible(node, rect) {
        return node.layoutInfo.rect.intersects(rect) || node.layoutInfo.isSticky || this.virtualizer.isPersistedKey(node.layoutInfo.key);
    }
    shouldInvalidateEverything(invalidationContext) {
        // Invalidate cache if the size of the collection changed.
        // In this case, we need to recalculate the entire layout.
        return invalidationContext.sizeChanged;
    }
    validate(invalidationContext) {
        this.collection = this.virtualizer.collection;
        // Reset valid rect if we will have to invalidate everything.
        // Otherwise we can reuse cached layout infos outside the current visible rect.
        this.invalidateEverything = this.shouldInvalidateEverything(invalidationContext);
        if (this.invalidateEverything) {
            this.lastValidRect = this.validRect;
            this.validRect = this.virtualizer.getVisibleRect();
        }
        this.rootNodes = this.buildCollection();
        // Remove deleted layout nodes
        if (this.lastCollection && this.collection !== this.lastCollection) {
            for (let key of this.lastCollection.getKeys())if (!this.collection.getItem(key)) {
                let layoutNode = this.layoutNodes.get(key);
                if (layoutNode) {
                    var _layoutNode_header;
                    this.layoutInfos.delete(layoutNode.layoutInfo.key);
                    this.layoutInfos.delete((_layoutNode_header = layoutNode.header) === null || _layoutNode_header === void 0 ? void 0 : _layoutNode_header.key);
                    this.layoutNodes.delete(key);
                }
            }
        }
        this.lastWidth = this.virtualizer.visibleRect.width;
        this.lastCollection = this.collection;
        this.invalidateEverything = false;
    }
    buildCollection() {
        let y = this.padding;
        let skipped = 0;
        let nodes = [];
        for (let node of this.collection){
            var _this_rowHeight;
            let rowHeight = (_this_rowHeight = this.rowHeight) !== null && _this_rowHeight !== void 0 ? _this_rowHeight : this.estimatedRowHeight;
            // Skip rows before the valid rectangle unless they are already cached.
            if (node.type === "item" && y + rowHeight < this.validRect.y && !this.isValid(node, y)) {
                y += rowHeight;
                skipped++;
                continue;
            }
            let layoutNode = this.buildChild(node, 0, y);
            y = layoutNode.layoutInfo.rect.maxY;
            nodes.push(layoutNode);
            if (node.type === "item" && y > this.validRect.maxY) {
                y += (this.collection.size - (nodes.length + skipped)) * rowHeight;
                break;
            }
        }
        if (this.isLoading) {
            var _this_loaderHeight;
            let rect = new (0, _virtualizer.Rect)(0, y, this.virtualizer.visibleRect.width, (_this_loaderHeight = this.loaderHeight) !== null && _this_loaderHeight !== void 0 ? _this_loaderHeight : this.virtualizer.visibleRect.height);
            let loader = new (0, _virtualizer.LayoutInfo)("loader", "loader", rect);
            this.layoutInfos.set("loader", loader);
            nodes.push({
                layoutInfo: loader
            });
            y = loader.rect.maxY;
        }
        if (nodes.length === 0) {
            var _this_placeholderHeight;
            let rect = new (0, _virtualizer.Rect)(0, y, this.virtualizer.visibleRect.width, (_this_placeholderHeight = this.placeholderHeight) !== null && _this_placeholderHeight !== void 0 ? _this_placeholderHeight : this.virtualizer.visibleRect.height);
            let placeholder = new (0, _virtualizer.LayoutInfo)("placeholder", "placeholder", rect);
            this.layoutInfos.set("placeholder", placeholder);
            nodes.push({
                layoutInfo: placeholder
            });
            y = placeholder.rect.maxY;
        }
        this.contentSize = new (0, _virtualizer.Size)(this.virtualizer.visibleRect.width, y + this.padding);
        return nodes;
    }
    isValid(node, y) {
        let cached = this.layoutNodes.get(node.key);
        return !this.invalidateEverything && cached && cached.node === node && y === (cached.header || cached.layoutInfo).rect.y && cached.layoutInfo.rect.intersects(this.lastValidRect) && cached.validRect.containsRect(cached.layoutInfo.rect.intersection(this.validRect));
    }
    buildChild(node, x, y) {
        if (this.isValid(node, y)) return this.layoutNodes.get(node.key);
        let layoutNode = this.buildNode(node, x, y);
        layoutNode.node = node;
        var _node_parentKey;
        layoutNode.layoutInfo.parentKey = (_node_parentKey = node.parentKey) !== null && _node_parentKey !== void 0 ? _node_parentKey : null;
        this.layoutInfos.set(layoutNode.layoutInfo.key, layoutNode.layoutInfo);
        if (layoutNode.header) this.layoutInfos.set(layoutNode.header.key, layoutNode.header);
        this.layoutNodes.set(node.key, layoutNode);
        return layoutNode;
    }
    buildNode(node, x, y) {
        switch(node.type){
            case "section":
                return this.buildSection(node, x, y);
            case "item":
                return this.buildItem(node, x, y);
        }
    }
    buildSection(node, x, y) {
        let width = this.virtualizer.visibleRect.width;
        let rectHeight = this.headingHeight;
        let isEstimated = false;
        // If no explicit height is available, use an estimated height.
        if (rectHeight == null) {
            // If a previous version of this layout info exists, reuse its height.
            // Mark as estimated if the size of the overall collection view changed,
            // or the content of the item changed.
            let previousLayoutNode = this.layoutNodes.get(node.key);
            if (previousLayoutNode && previousLayoutNode.header) {
                let curNode = this.collection.getItem(node.key);
                let lastNode = this.lastCollection ? this.lastCollection.getItem(node.key) : null;
                rectHeight = previousLayoutNode.header.rect.height;
                isEstimated = width !== this.lastWidth || curNode !== lastNode || previousLayoutNode.header.estimatedSize;
            } else {
                rectHeight = node.rendered ? this.estimatedHeadingHeight : 0;
                isEstimated = true;
            }
        }
        if (rectHeight == null) rectHeight = DEFAULT_HEIGHT;
        let headerRect = new (0, _virtualizer.Rect)(0, y, width, rectHeight);
        let header = new (0, _virtualizer.LayoutInfo)("header", node.key + ":header", headerRect);
        header.estimatedSize = isEstimated;
        header.parentKey = node.key;
        y += header.rect.height;
        let rect = new (0, _virtualizer.Rect)(0, y, width, 0);
        let layoutInfo = new (0, _virtualizer.LayoutInfo)(node.type, node.key, rect);
        let startY = y;
        let skipped = 0;
        let children = [];
        for (let child of (0, _collections.getChildNodes)(node, this.collection)){
            var _this_rowHeight;
            let rowHeight = (_this_rowHeight = this.rowHeight) !== null && _this_rowHeight !== void 0 ? _this_rowHeight : this.estimatedRowHeight;
            // Skip rows before the valid rectangle unless they are already cached.
            if (y + rowHeight < this.validRect.y && !this.isValid(node, y)) {
                y += rowHeight;
                skipped++;
                continue;
            }
            let layoutNode = this.buildChild(child, x, y);
            y = layoutNode.layoutInfo.rect.maxY;
            children.push(layoutNode);
            if (y > this.validRect.maxY) {
                // Estimate the remaining height for rows that we don't need to layout right now.
                y += ([
                    ...(0, _collections.getChildNodes)(node, this.collection)
                ].length - (children.length + skipped)) * rowHeight;
                break;
            }
        }
        rect.height = y - startY;
        return {
            header,
            layoutInfo,
            children,
            validRect: layoutInfo.rect.intersection(this.validRect)
        };
    }
    buildItem(node, x, y) {
        let width = this.virtualizer.visibleRect.width;
        let rectHeight = this.rowHeight;
        let isEstimated = false;
        // If no explicit height is available, use an estimated height.
        if (rectHeight == null) {
            // If a previous version of this layout info exists, reuse its height.
            // Mark as estimated if the size of the overall collection view changed,
            // or the content of the item changed.
            let previousLayoutNode = this.layoutNodes.get(node.key);
            if (previousLayoutNode) {
                rectHeight = previousLayoutNode.layoutInfo.rect.height;
                isEstimated = width !== this.lastWidth || node !== previousLayoutNode.node || previousLayoutNode.layoutInfo.estimatedSize;
            } else {
                rectHeight = this.estimatedRowHeight;
                isEstimated = true;
            }
        }
        if (rectHeight == null) rectHeight = DEFAULT_HEIGHT;
        if (typeof this.indentationForItem === "function") x += this.indentationForItem(this.collection, node.key) || 0;
        let rect = new (0, _virtualizer.Rect)(x, y, width - x, rectHeight);
        let layoutInfo = new (0, _virtualizer.LayoutInfo)(node.type, node.key, rect);
        // allow overflow so the focus ring/selection ring can extend outside to overlap with the adjacent items borders
        layoutInfo.allowOverflow = true;
        layoutInfo.estimatedSize = isEstimated;
        return {
            layoutInfo,
            validRect: layoutInfo.rect
        };
    }
    updateItemSize(key, size) {
        let layoutInfo = this.layoutInfos.get(key);
        // If no layoutInfo, item has been deleted/removed.
        if (!layoutInfo) return false;
        layoutInfo.estimatedSize = false;
        if (layoutInfo.rect.height !== size.height) {
            // Copy layout info rather than mutating so that later caches are invalidated.
            let newLayoutInfo = layoutInfo.copy();
            newLayoutInfo.rect.height = size.height;
            this.layoutInfos.set(key, newLayoutInfo);
            // Invalidate layout for this layout node and all parents
            this.updateLayoutNode(key, layoutInfo, newLayoutInfo);
            let node = this.collection.getItem(layoutInfo.parentKey);
            while(node){
                this.updateLayoutNode(node.key, layoutInfo, newLayoutInfo);
                node = this.collection.getItem(node.parentKey);
            }
            return true;
        }
        return false;
    }
    updateLayoutNode(key, oldLayoutInfo, newLayoutInfo) {
        let n = this.layoutNodes.get(key);
        if (n) {
            // Invalidate by reseting validRect.
            n.validRect = new (0, _virtualizer.Rect)();
            // Replace layout info in LayoutNode
            if (n.header === oldLayoutInfo) n.header = newLayoutInfo;
            else if (n.layoutInfo === oldLayoutInfo) n.layoutInfo = newLayoutInfo;
        }
    }
    getContentSize() {
        return this.contentSize;
    }
    getKeyAbove(key) {
        let collection = this.collection;
        key = collection.getKeyBefore(key);
        while(key != null){
            let item = collection.getItem(key);
            if (item.type === "item" && (this.allowDisabledKeyFocus || !this.disabledKeys.has(item.key))) return key;
            key = collection.getKeyBefore(key);
        }
    }
    getKeyBelow(key) {
        let collection = this.collection;
        key = collection.getKeyAfter(key);
        while(key != null){
            let item = collection.getItem(key);
            if (item.type === "item" && (this.allowDisabledKeyFocus || !this.disabledKeys.has(item.key))) return key;
            key = collection.getKeyAfter(key);
        }
    }
    getKeyPageAbove(key) {
        let layoutInfo = this.getLayoutInfo(key);
        if (layoutInfo) {
            let pageY = Math.max(0, layoutInfo.rect.y + layoutInfo.rect.height - this.virtualizer.visibleRect.height);
            while(layoutInfo && layoutInfo.rect.y > pageY){
                let keyAbove = this.getKeyAbove(layoutInfo.key);
                layoutInfo = this.getLayoutInfo(keyAbove);
            }
            if (layoutInfo) return layoutInfo.key;
        }
        return this.getFirstKey();
    }
    getKeyPageBelow(key) {
        let layoutInfo = this.getLayoutInfo(key != null ? key : this.getFirstKey());
        if (layoutInfo) {
            let pageY = Math.min(this.virtualizer.contentSize.height, layoutInfo.rect.y - layoutInfo.rect.height + this.virtualizer.visibleRect.height);
            while(layoutInfo && layoutInfo.rect.y < pageY){
                let keyBelow = this.getKeyBelow(layoutInfo.key);
                layoutInfo = this.getLayoutInfo(keyBelow);
            }
            if (layoutInfo) return layoutInfo.key;
        }
        return this.getLastKey();
    }
    getFirstKey() {
        let collection = this.collection;
        let key = collection.getFirstKey();
        while(key != null){
            let item = collection.getItem(key);
            if (item.type === "item" && (this.allowDisabledKeyFocus || !this.disabledKeys.has(item.key))) return key;
            key = collection.getKeyAfter(key);
        }
    }
    getLastKey() {
        let collection = this.collection;
        let key = collection.getLastKey();
        while(key != null){
            let item = collection.getItem(key);
            if (item.type === "item" && (this.allowDisabledKeyFocus || !this.disabledKeys.has(item.key))) return key;
            key = collection.getKeyBefore(key);
        }
    }
    getKeyForSearch(search, fromKey) {
        if (!this.collator) return null;
        let collection = this.collection;
        let key = fromKey || this.getFirstKey();
        while(key != null){
            let item = collection.getItem(key);
            let substring = item.textValue.slice(0, search.length);
            if (item.textValue && this.collator.compare(substring, search) === 0) return key;
            key = this.getKeyBelow(key);
        }
        return null;
    }
    getInitialLayoutInfo(layoutInfo) {
        layoutInfo.opacity = 0;
        layoutInfo.transform = "scale3d(0.8, 0.8, 0.8)";
        return layoutInfo;
    }
    getFinalLayoutInfo(layoutInfo) {
        layoutInfo.opacity = 0;
        layoutInfo.transform = "scale3d(0.8, 0.8, 0.8)";
        return layoutInfo;
    }
    getDropTargetFromPoint(x, y, isValidDropTarget) {
        x += this.virtualizer.visibleRect.x;
        y += this.virtualizer.visibleRect.y;
        let key = this.virtualizer.keyAtPoint(new (0, _virtualizer.Point)(x, y));
        if (key == null || this.collection.size === 0) return {
            type: "root"
        };
        let layoutInfo = this.getLayoutInfo(key);
        let rect = layoutInfo.rect;
        let target = {
            type: "item",
            key: layoutInfo.key,
            dropPosition: "on"
        };
        // If dropping on the item isn't accepted, try the target before or after depending on the y position.
        // Otherwise, if dropping on the item is accepted, still try the before/after positions if within 10px
        // of the top or bottom of the item.
        if (!isValidDropTarget(target)) {
            if (y <= rect.y + rect.height / 2 && isValidDropTarget({
                ...target,
                dropPosition: "before"
            })) target.dropPosition = "before";
            else if (isValidDropTarget({
                ...target,
                dropPosition: "after"
            })) target.dropPosition = "after";
        } else if (y <= rect.y + 10 && isValidDropTarget({
            ...target,
            dropPosition: "before"
        })) target.dropPosition = "before";
        else if (y >= rect.maxY - 10 && isValidDropTarget({
            ...target,
            dropPosition: "after"
        })) target.dropPosition = "after";
        return target;
    }
    /**
   * Creates a new ListLayout with options. See the list of properties below for a description
   * of the options that can be provided.
   */ constructor(options = {}){
        super();
        this.disabledKeys = new Set();
        this.allowDisabledKeyFocus = false;
        this.rowHeight = options.rowHeight;
        this.estimatedRowHeight = options.estimatedRowHeight;
        this.headingHeight = options.headingHeight;
        this.estimatedHeadingHeight = options.estimatedHeadingHeight;
        this.padding = options.padding || 0;
        this.indentationForItem = options.indentationForItem;
        this.collator = options.collator;
        this.loaderHeight = options.loaderHeight;
        this.placeholderHeight = options.placeholderHeight;
        this.layoutInfos = new Map();
        this.layoutNodes = new Map();
        this.rootNodes = [];
        this.lastWidth = 0;
        this.lastCollection = null;
        this.allowDisabledKeyFocus = options.allowDisabledKeyFocus;
        this.lastValidRect = new (0, _virtualizer.Rect)();
        this.validRect = new (0, _virtualizer.Rect)();
        this.contentSize = new (0, _virtualizer.Size)();
    }
}

},{"@react-stately/collections":"loANi","@react-stately/virtualizer":"lVS5O","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"fxSwb":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TableLayout", ()=>TableLayout);
var _collections = require("@react-stately/collections");
var _virtualizer = require("@react-stately/virtualizer");
var _listLayout = require("./ListLayout");
class TableLayout extends (0, _listLayout.ListLayout) {
    shouldInvalidateEverything(invalidationContext) {
        // If columns changed, clear layout cache.
        return super.shouldInvalidateEverything(invalidationContext) || !this.lastCollection || this.collection.columns.length !== this.lastCollection.columns.length || this.collection.columns.some((c, i)=>c.key !== this.lastCollection.columns[i].key || c.props.width !== this.lastCollection.columns[i].props.width || c.props.minWidth !== this.lastCollection.columns[i].props.minWidth || c.props.maxWidth !== this.lastCollection.columns[i].props.maxWidth);
    }
    getResizerPosition() {
        var _this_getLayoutInfo;
        return (_this_getLayoutInfo = this.getLayoutInfo(this.resizingColumn)) === null || _this_getLayoutInfo === void 0 ? void 0 : _this_getLayoutInfo.rect.maxX;
    }
    getColumnWidth(key) {
        var _this_columnLayout_getColumnWidth;
        return (_this_columnLayout_getColumnWidth = this.columnLayout.getColumnWidth(key)) !== null && _this_columnLayout_getColumnWidth !== void 0 ? _this_columnLayout_getColumnWidth : 0;
    }
    getColumnMinWidth(key) {
        let column = this.collection.columns.find((col)=>col.key === key);
        if (!column) return 0;
        return this.columnLayout.getColumnMinWidth(key);
    }
    getColumnMaxWidth(key) {
        let column = this.collection.columns.find((col)=>col.key === key);
        if (!column) return 0;
        return this.columnLayout.getColumnMaxWidth(key);
    }
    // outside, where this is called, should call props.onColumnResizeStart...
    startResize(key) {
        this.resizingColumn = key;
    }
    // only way to call props.onColumnResize with the new size outside of Layout is to send the result back
    updateResizedColumns(key, width) {
        let newControlled = new Map(Array.from(this.controlledColumns).map(([key, entry])=>[
                key,
                entry.props.width
            ]));
        let newSizes = this.columnLayout.resizeColumnWidth(this.virtualizer.visibleRect.width, this.collection, newControlled, this.uncontrolledWidths, key, width);
        let map = new Map(Array.from(this.uncontrolledColumns).map(([key])=>[
                key,
                newSizes.get(key)
            ]));
        map.set(key, width);
        this.uncontrolledWidths = map;
        // relayoutNow still uses setState, should happen at the same time the parent
        // component's state is processed as a result of props.onColumnResize
        if (this.uncontrolledWidths.size > 0) this.virtualizer.relayoutNow({
            sizeChanged: true
        });
        return newSizes;
    }
    endResize() {
        this.resizingColumn = null;
    }
    buildCollection() {
        // Track whether we were previously loading. This is used to adjust the animations of async loading vs inserts.
        let loadingState = this.collection.body.props.loadingState;
        this.wasLoading = this.isLoading;
        this.isLoading = loadingState === "loading" || loadingState === "loadingMore";
        this.stickyColumnIndices = [];
        for (let column of this.collection.columns)// The selection cell and any other sticky columns always need to be visible.
        // In addition, row headers need to be in the DOM for accessibility labeling.
        if (column.props.isDragButtonCell || column.props.isSelectionCell || this.collection.rowHeaderColumnKeys.has(column.key)) this.stickyColumnIndices.push(column.index);
        let [controlledColumns, uncontrolledColumns] = this.columnLayout.splitColumnsIntoControlledAndUncontrolled(this.collection.columns);
        this.controlledColumns = controlledColumns;
        this.uncontrolledColumns = uncontrolledColumns;
        let colWidths = this.columnLayout.recombineColumns(this.collection.columns, this.uncontrolledWidths, uncontrolledColumns, controlledColumns);
        this.columnWidths = this.columnLayout.buildColumnWidths(this.virtualizer.visibleRect.width, this.collection, colWidths);
        let header = this.buildHeader();
        let body = this.buildBody(0);
        this.lastPersistedKeys = null;
        body.layoutInfo.rect.width = Math.max(header.layoutInfo.rect.width, body.layoutInfo.rect.width);
        this.contentSize = new (0, _virtualizer.Size)(body.layoutInfo.rect.width, body.layoutInfo.rect.maxY);
        return [
            header,
            body
        ];
    }
    buildHeader() {
        let rect = new (0, _virtualizer.Rect)(0, 0, 0, 0);
        let layoutInfo = new (0, _virtualizer.LayoutInfo)("header", "header", rect);
        let y = 0;
        let width = 0;
        let children = [];
        for (let headerRow of this.collection.headerRows){
            let layoutNode = this.buildChild(headerRow, 0, y);
            layoutNode.layoutInfo.parentKey = "header";
            y = layoutNode.layoutInfo.rect.maxY;
            width = Math.max(width, layoutNode.layoutInfo.rect.width);
            layoutNode.index = children.length;
            children.push(layoutNode);
        }
        rect.width = width;
        rect.height = y;
        this.layoutInfos.set("header", layoutInfo);
        return {
            layoutInfo,
            children,
            validRect: layoutInfo.rect
        };
    }
    buildHeaderRow(headerRow, x, y) {
        let rect = new (0, _virtualizer.Rect)(0, y, 0, 0);
        let row = new (0, _virtualizer.LayoutInfo)("headerrow", headerRow.key, rect);
        let height = 0;
        let columns = [];
        for (let cell of (0, _collections.getChildNodes)(headerRow, this.collection)){
            let layoutNode = this.buildChild(cell, x, y);
            layoutNode.layoutInfo.parentKey = row.key;
            x = layoutNode.layoutInfo.rect.maxX;
            height = Math.max(height, layoutNode.layoutInfo.rect.height);
            layoutNode.index = columns.length;
            columns.push(layoutNode);
        }
        for (let [i, layout] of columns.entries())layout.layoutInfo.zIndex = columns.length - i + 1;
        this.setChildHeights(columns, height);
        rect.height = height;
        rect.width = x;
        return {
            layoutInfo: row,
            children: columns,
            validRect: rect
        };
    }
    setChildHeights(children, height) {
        for (let child of children)if (child.layoutInfo.rect.height !== height) {
            // Need to copy the layout info before we mutate it.
            child.layoutInfo = child.layoutInfo.copy();
            this.layoutInfos.set(child.layoutInfo.key, child.layoutInfo);
            child.layoutInfo.rect.height = height;
        }
    }
    // used to get the column widths when rendering to the DOM
    getRenderedColumnWidth(node) {
        var _node_colspan;
        let colspan = (_node_colspan = node.colspan) !== null && _node_colspan !== void 0 ? _node_colspan : 1;
        var _node_colIndex;
        let colIndex = (_node_colIndex = node.colIndex) !== null && _node_colIndex !== void 0 ? _node_colIndex : node.index;
        let width = 0;
        for(let i = colIndex; i < colIndex + colspan; i++){
            let column = this.collection.columns[i];
            if ((column === null || column === void 0 ? void 0 : column.key) != null) width += this.columnWidths.get(column.key);
        }
        return width;
    }
    getEstimatedHeight(node, width, height, estimatedHeight) {
        let isEstimated = false;
        // If no explicit height is available, use an estimated height.
        if (height == null) {
            // If a previous version of this layout info exists, reuse its height.
            // Mark as estimated if the size of the overall collection view changed,
            // or the content of the item changed.
            let previousLayoutNode = this.layoutNodes.get(node.key);
            if (previousLayoutNode) {
                height = previousLayoutNode.layoutInfo.rect.height;
                isEstimated = node !== previousLayoutNode.node || width !== previousLayoutNode.layoutInfo.rect.width || previousLayoutNode.layoutInfo.estimatedSize;
            } else {
                height = estimatedHeight;
                isEstimated = true;
            }
        }
        return {
            height,
            isEstimated
        };
    }
    buildColumn(node, x, y) {
        var _node_props, _node_props1;
        let width = this.getRenderedColumnWidth(node);
        let { height, isEstimated } = this.getEstimatedHeight(node, width, this.headingHeight, this.estimatedHeadingHeight);
        let rect = new (0, _virtualizer.Rect)(x, y, width, height);
        let layoutInfo = new (0, _virtualizer.LayoutInfo)(node.type, node.key, rect);
        layoutInfo.isSticky = !this.disableSticky && (((_node_props = node.props) === null || _node_props === void 0 ? void 0 : _node_props.isDragButtonCell) || ((_node_props1 = node.props) === null || _node_props1 === void 0 ? void 0 : _node_props1.isSelectionCell));
        layoutInfo.zIndex = layoutInfo.isSticky ? 2 : 1;
        layoutInfo.estimatedSize = isEstimated;
        return {
            layoutInfo,
            validRect: layoutInfo.rect
        };
    }
    buildBody(y) {
        let rect = new (0, _virtualizer.Rect)(0, y, 0, 0);
        let layoutInfo = new (0, _virtualizer.LayoutInfo)("rowgroup", "body", rect);
        let startY = y;
        let skipped = 0;
        let width = 0;
        let children = [];
        for (let [i, node] of [
            ...this.collection
        ].entries()){
            var _this_rowHeight;
            let rowHeight = ((_this_rowHeight = this.rowHeight) !== null && _this_rowHeight !== void 0 ? _this_rowHeight : this.estimatedRowHeight) + 1;
            // Skip rows before the valid rectangle unless they are already cached.
            if (y + rowHeight < this.validRect.y && !this.isValid(node, y)) {
                y += rowHeight;
                skipped++;
                continue;
            }
            let layoutNode = this.buildChild(node, 0, y);
            layoutNode.layoutInfo.parentKey = "body";
            layoutNode.index = i;
            y = layoutNode.layoutInfo.rect.maxY;
            width = Math.max(width, layoutNode.layoutInfo.rect.width);
            children.push(layoutNode);
            if (y > this.validRect.maxY) {
                // Estimate the remaining height for rows that we don't need to layout right now.
                y += (this.collection.size - (skipped + children.length)) * rowHeight;
                break;
            }
        }
        if (this.isLoading) {
            // Add some margin around the loader to ensure that scrollbars don't flicker in and out.
            let rect = new (0, _virtualizer.Rect)(40, Math.max(y, 40), (width || this.virtualizer.visibleRect.width) - 80, children.length === 0 ? this.virtualizer.visibleRect.height - 80 : 60);
            let loader = new (0, _virtualizer.LayoutInfo)("loader", "loader", rect);
            loader.parentKey = "body";
            loader.isSticky = !this.disableSticky && children.length === 0;
            this.layoutInfos.set("loader", loader);
            children.push({
                layoutInfo: loader,
                validRect: loader.rect
            });
            y = loader.rect.maxY;
            width = Math.max(width, rect.width);
        } else if (children.length === 0) {
            let rect = new (0, _virtualizer.Rect)(40, Math.max(y, 40), this.virtualizer.visibleRect.width - 80, this.virtualizer.visibleRect.height - 80);
            let empty = new (0, _virtualizer.LayoutInfo)("empty", "empty", rect);
            empty.parentKey = "body";
            empty.isSticky = !this.disableSticky;
            this.layoutInfos.set("empty", empty);
            children.push({
                layoutInfo: empty,
                validRect: empty.rect
            });
            y = empty.rect.maxY;
            width = Math.max(width, rect.width);
        }
        rect.width = width;
        rect.height = y - startY;
        this.layoutInfos.set("body", layoutInfo);
        return {
            layoutInfo,
            children,
            validRect: layoutInfo.rect.intersection(this.validRect)
        };
    }
    buildNode(node, x, y) {
        switch(node.type){
            case "headerrow":
                return this.buildHeaderRow(node, x, y);
            case "item":
                return this.buildRow(node, x, y);
            case "column":
            case "placeholder":
                return this.buildColumn(node, x, y);
            case "cell":
                return this.buildCell(node, x, y);
            default:
                throw new Error("Unknown node type " + node.type);
        }
    }
    buildRow(node, x, y) {
        let rect = new (0, _virtualizer.Rect)(x, y, 0, 0);
        let layoutInfo = new (0, _virtualizer.LayoutInfo)("row", node.key, rect);
        let children = [];
        let height = 0;
        for (let [i, child] of [
            ...(0, _collections.getChildNodes)(node, this.collection)
        ].entries())if (child.type === "cell") {
            if (x > this.validRect.maxX) {
                // Adjust existing cached layoutInfo to ensure that it is out of view.
                // This can happen due to column resizing.
                let layoutNode = this.layoutNodes.get(child.key);
                if (layoutNode) {
                    layoutNode.layoutInfo.rect.x = x;
                    x += layoutNode.layoutInfo.rect.width;
                }
            } else {
                let layoutNode = this.buildChild(child, x, y);
                x = layoutNode.layoutInfo.rect.maxX;
                height = Math.max(height, layoutNode.layoutInfo.rect.height);
                layoutNode.index = i;
                children.push(layoutNode);
            }
        }
        this.setChildHeights(children, height);
        rect.width = this.layoutInfos.get("header").rect.width;
        rect.height = height + 1; // +1 for bottom border
        return {
            layoutInfo,
            children,
            validRect: rect.intersection(this.validRect)
        };
    }
    buildCell(node, x, y) {
        var _node_props, _node_props1;
        let width = this.getRenderedColumnWidth(node);
        let { height, isEstimated } = this.getEstimatedHeight(node, width, this.rowHeight, this.estimatedRowHeight);
        let rect = new (0, _virtualizer.Rect)(x, y, width, height);
        let layoutInfo = new (0, _virtualizer.LayoutInfo)(node.type, node.key, rect);
        layoutInfo.isSticky = !this.disableSticky && (((_node_props = node.props) === null || _node_props === void 0 ? void 0 : _node_props.isDragButtonCell) || ((_node_props1 = node.props) === null || _node_props1 === void 0 ? void 0 : _node_props1.isSelectionCell));
        layoutInfo.zIndex = layoutInfo.isSticky ? 2 : 1;
        layoutInfo.estimatedSize = isEstimated;
        return {
            layoutInfo,
            validRect: rect
        };
    }
    getVisibleLayoutInfos(rect) {
        // If layout hasn't yet been done for the requested rect, union the
        // new rect with the existing valid rect, and recompute.
        if (!this.validRect.containsRect(rect) && this.lastCollection) {
            this.lastValidRect = this.validRect;
            this.validRect = this.validRect.union(rect);
            this.rootNodes = this.buildCollection();
        }
        let res = [];
        this.buildPersistedIndices();
        for (let node of this.rootNodes){
            res.push(node.layoutInfo);
            this.addVisibleLayoutInfos(res, node, rect);
        }
        return res;
    }
    addVisibleLayoutInfos(res, node, rect) {
        if (!node.children || node.children.length === 0) return;
        switch(node.layoutInfo.type){
            case "header":
                for (let child of node.children){
                    res.push(child.layoutInfo);
                    this.addVisibleLayoutInfos(res, child, rect);
                }
                break;
            case "rowgroup":
                {
                    let firstVisibleRow = this.binarySearch(node.children, rect.topLeft, "y");
                    let lastVisibleRow = this.binarySearch(node.children, rect.bottomRight, "y");
                    // Add persisted rows before the visible rows.
                    let persistedRowIndices = this.persistedIndices.get(node.layoutInfo.key);
                    let persistIndex = 0;
                    while(persistedRowIndices && persistIndex < persistedRowIndices.length && persistedRowIndices[persistIndex] < firstVisibleRow){
                        let idx = persistedRowIndices[persistIndex];
                        if (idx < node.children.length) {
                            res.push(node.children[idx].layoutInfo);
                            this.addVisibleLayoutInfos(res, node.children[idx], rect);
                        }
                        persistIndex++;
                    }
                    for(let i = firstVisibleRow; i <= lastVisibleRow; i++){
                        // Skip persisted rows that overlap with visible cells.
                        while(persistedRowIndices && persistIndex < persistedRowIndices.length && persistedRowIndices[persistIndex] < i)persistIndex++;
                        res.push(node.children[i].layoutInfo);
                        this.addVisibleLayoutInfos(res, node.children[i], rect);
                    }
                    // Add persisted rows after the visible rows.
                    while(persistedRowIndices && persistIndex < persistedRowIndices.length){
                        let idx = persistedRowIndices[persistIndex++];
                        if (idx < node.children.length) res.push(node.children[idx].layoutInfo);
                    }
                    break;
                }
            case "headerrow":
            case "row":
                {
                    let firstVisibleCell = this.binarySearch(node.children, rect.topLeft, "x");
                    let lastVisibleCell = this.binarySearch(node.children, rect.topRight, "x");
                    let stickyIndex = 0;
                    // Add persisted/sticky cells before the visible cells.
                    let persistedCellIndices = this.persistedIndices.get(node.layoutInfo.key) || this.stickyColumnIndices;
                    while(stickyIndex < persistedCellIndices.length && persistedCellIndices[stickyIndex] < firstVisibleCell){
                        let idx = persistedCellIndices[stickyIndex];
                        if (idx < node.children.length) res.push(node.children[idx].layoutInfo);
                        stickyIndex++;
                    }
                    for(let i = firstVisibleCell; i <= lastVisibleCell; i++){
                        // Skip sticky cells that overlap with visible cells.
                        while(stickyIndex < persistedCellIndices.length && persistedCellIndices[stickyIndex] < i)stickyIndex++;
                        res.push(node.children[i].layoutInfo);
                    }
                    // Add any remaining sticky cells after the visible cells.
                    while(stickyIndex < persistedCellIndices.length){
                        let idx = persistedCellIndices[stickyIndex++];
                        if (idx < node.children.length) res.push(node.children[idx].layoutInfo);
                    }
                    break;
                }
            default:
                throw new Error("Unknown node type " + node.layoutInfo.type);
        }
    }
    binarySearch(items, point, axis) {
        let low = 0;
        let high = items.length - 1;
        while(low <= high){
            let mid = low + high >> 1;
            let item = items[mid];
            if (axis === "x" && item.layoutInfo.rect.maxX < point.x || axis === "y" && item.layoutInfo.rect.maxY < point.y) low = mid + 1;
            else if (axis === "x" && item.layoutInfo.rect.x > point.x || axis === "y" && item.layoutInfo.rect.y > point.y) high = mid - 1;
            else return mid;
        }
        return Math.max(0, Math.min(items.length - 1, low));
    }
    buildPersistedIndices() {
        if (this.virtualizer.persistedKeys === this.lastPersistedKeys) return;
        this.lastPersistedKeys = this.virtualizer.persistedKeys;
        this.persistedIndices.clear();
        // Build a map of parentKey => indices of children to persist.
        for (let key of this.virtualizer.persistedKeys){
            let layoutInfo = this.layoutInfos.get(key);
            // Walk up ancestors so parents are also persisted if children are.
            while(layoutInfo && layoutInfo.parentKey){
                let collectionNode = this.collection.getItem(layoutInfo.key);
                let indices = this.persistedIndices.get(layoutInfo.parentKey);
                if (!indices) {
                    // stickyColumnIndices are always persisted along with any cells from persistedKeys.
                    indices = collectionNode.type === "cell" || collectionNode.type === "column" ? [
                        ...this.stickyColumnIndices
                    ] : [];
                    this.persistedIndices.set(layoutInfo.parentKey, indices);
                }
                let index = this.layoutNodes.get(layoutInfo.key).index;
                if (!indices.includes(index)) indices.push(index);
                layoutInfo = this.layoutInfos.get(layoutInfo.parentKey);
            }
        }
        for (let indices of this.persistedIndices.values())indices.sort((a, b)=>a - b);
    }
    getInitialLayoutInfo(layoutInfo) {
        let res = super.getInitialLayoutInfo(layoutInfo);
        res.transform = null;
        return res;
    }
    getFinalLayoutInfo(layoutInfo) {
        let res = super.getFinalLayoutInfo(layoutInfo);
        res.transform = null;
        return res;
    }
    // Checks if Chrome version is 105 or greater
    checkChrome105() {
        var _window_navigator_userAgentData;
        if (typeof window === "undefined" || window.navigator == null) return false;
        let isChrome105;
        if (window.navigator["userAgentData"]) isChrome105 = (_window_navigator_userAgentData = window.navigator["userAgentData"]) === null || _window_navigator_userAgentData === void 0 ? void 0 : _window_navigator_userAgentData.brands.some((b)=>b.brand === "Chromium" && Number(b.version) === 105);
        else {
            let regex = /Chrome\/(\d+)/;
            let matches = regex.exec(window.navigator.userAgent);
            isChrome105 = matches && matches.length >= 2 && Number(matches[1]) === 105;
        }
        return isChrome105;
    }
    getDropTargetFromPoint(x, y, isValidDropTarget) {
        var _this_virtualizer_layout_getVisibleLayoutInfos_find;
        x += this.virtualizer.visibleRect.x;
        y += this.virtualizer.visibleRect.y;
        // Offset for height of header row
        y -= (_this_virtualizer_layout_getVisibleLayoutInfos_find = this.virtualizer.layout.getVisibleLayoutInfos(new (0, _virtualizer.Rect)(x, y, 1, 1)).find((info)=>info.type === "headerrow")) === null || _this_virtualizer_layout_getVisibleLayoutInfos_find === void 0 ? void 0 : _this_virtualizer_layout_getVisibleLayoutInfos_find.rect.height;
        // Custom variation of this.virtualizer.keyAtPoint that ignores body
        let key;
        let point = new (0, _virtualizer.Point)(x, y);
        let rectAtPoint = new (0, _virtualizer.Rect)(point.x, point.y, 1, 1);
        let layoutInfos = this.virtualizer.layout.getVisibleLayoutInfos(rectAtPoint).filter((info)=>info.type === "row");
        // Layout may return multiple layout infos in the case of
        // persisted keys, so find the first one that actually intersects.
        for (let layoutInfo of layoutInfos)if (layoutInfo.rect.intersects(rectAtPoint)) key = layoutInfo.key;
        if (key == null || this.collection.size === 0) return {
            type: "root"
        };
        let layoutInfo = this.getLayoutInfo(key);
        let rect = layoutInfo.rect;
        let target = {
            type: "item",
            key: layoutInfo.key,
            dropPosition: "on"
        };
        // If dropping on the item isn't accepted, try the target before or after depending on the y position.
        // Otherwise, if dropping on the item is accepted, still try the before/after positions if within 10px
        // of the top or bottom of the item.
        if (!isValidDropTarget(target)) {
            if (y <= rect.y + rect.height / 2 && isValidDropTarget({
                ...target,
                dropPosition: "before"
            })) target.dropPosition = "before";
            else if (isValidDropTarget({
                ...target,
                dropPosition: "after"
            })) target.dropPosition = "after";
        } else if (y <= rect.y + 10 && isValidDropTarget({
            ...target,
            dropPosition: "before"
        })) target.dropPosition = "before";
        else if (y >= rect.maxY - 10 && isValidDropTarget({
            ...target,
            dropPosition: "after"
        })) target.dropPosition = "after";
        return target;
    }
    constructor(options){
        super(options);
        this.columnWidths = new Map();
        this.wasLoading = false;
        this.isLoading = false;
        this.lastPersistedKeys = null;
        this.persistedIndices = new Map();
        this.collection = options.initialCollection;
        this.stickyColumnIndices = [];
        this.disableSticky = this.checkChrome105();
        this.columnLayout = options.columnLayout;
        let [controlledColumns, uncontrolledColumns] = this.columnLayout.splitColumnsIntoControlledAndUncontrolled(this.collection.columns);
        this.controlledColumns = controlledColumns;
        this.uncontrolledColumns = uncontrolledColumns;
        this.uncontrolledWidths = this.columnLayout.getInitialUncontrolledWidths(uncontrolledColumns);
    }
}

},{"@react-stately/collections":"loANi","@react-stately/virtualizer":"lVS5O","./ListLayout":"lftKz","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"gAPsK":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useVirtualizer", ()=>(0, _virtualizer.useVirtualizer));
parcelHelpers.export(exports, "Virtualizer", ()=>(0, _virtualizer.Virtualizer));
parcelHelpers.export(exports, "useVirtualizerItem", ()=>(0, _useVirtualizerItem.useVirtualizerItem));
parcelHelpers.export(exports, "VirtualizerItem", ()=>(0, _virtualizerItem.VirtualizerItem));
parcelHelpers.export(exports, "layoutInfoToStyle", ()=>(0, _virtualizerItem.layoutInfoToStyle));
parcelHelpers.export(exports, "ScrollView", ()=>(0, _scrollView.ScrollView));
parcelHelpers.export(exports, "getRTLOffsetType", ()=>(0, _utils.getRTLOffsetType));
parcelHelpers.export(exports, "getScrollLeft", ()=>(0, _utils.getScrollLeft));
parcelHelpers.export(exports, "setScrollLeft", ()=>(0, _utils.setScrollLeft));
var _virtualizer = require("./Virtualizer");
var _useVirtualizerItem = require("./useVirtualizerItem");
var _virtualizerItem = require("./VirtualizerItem");
var _scrollView = require("./ScrollView");
var _utils = require("./utils");

},{"./Virtualizer":"aRyKT","./useVirtualizerItem":"2dkmR","./VirtualizerItem":"feVQP","./ScrollView":"fsn3L","./utils":"4p3ig","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"aRyKT":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useVirtualizer", ()=>useVirtualizer);
parcelHelpers.export(exports, "Virtualizer", ()=>_Virtualizer);
var _interactions = require("@react-aria/interactions");
var _virtualizer = require("@react-stately/virtualizer");
var _utils = require("@react-aria/utils");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _scrollView = require("./ScrollView");
var _virtualizerItem = require("./VirtualizerItem");
function Virtualizer(props, ref) {
    let { children: renderView, renderWrapper, layout, collection, sizeToFit, scrollDirection, transitionDuration, // eslint-disable-next-line @typescript-eslint/no-unused-vars
    isLoading, // eslint-disable-next-line @typescript-eslint/no-unused-vars
    onLoadMore, // eslint-disable-next-line @typescript-eslint/no-unused-vars
    focusedKey, // eslint-disable-next-line @typescript-eslint/no-unused-vars
    shouldUseVirtualFocus, // eslint-disable-next-line @typescript-eslint/no-unused-vars
    scrollToItem, // eslint-disable-next-line @typescript-eslint/no-unused-vars
    autoFocus, ...otherProps } = props;
    let fallbackRef = (0, _react.useRef)();
    ref = ref || fallbackRef;
    let state = (0, _virtualizer.useVirtualizerState)({
        transitionDuration,
        layout,
        collection,
        renderView,
        renderWrapper: renderWrapper || defaultRenderWrapper,
        onVisibleRectChange (rect) {
            ref.current.scrollLeft = rect.x;
            ref.current.scrollTop = rect.y;
        }
    });
    let { virtualizerProps, scrollViewProps } = useVirtualizer(props, state, ref);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _scrollView.ScrollView), {
        ...(0, _utils.mergeProps)(otherProps, virtualizerProps, scrollViewProps),
        ref: ref,
        innerStyle: state.isAnimating ? {
            transition: `none ${state.virtualizer.transitionDuration}ms`
        } : undefined,
        contentSize: state.contentSize,
        onScrollStart: state.startScrolling,
        onScrollEnd: state.endScrolling,
        sizeToFit: sizeToFit,
        scrollDirection: scrollDirection
    }, state.visibleViews);
}
function useVirtualizer(props, state, ref) {
    let { focusedKey, scrollToItem, shouldUseVirtualFocus, isLoading, onLoadMore } = props;
    let { virtualizer } = state;
    // Scroll to the focusedKey when it changes. Actually focusing the focusedKey
    // is up to the implementation using Virtualizer since we don't have refs
    // to all of the item DOM nodes.
    let lastFocusedKey = (0, _react.useRef)(null);
    let isFocusWithin = (0, _react.useRef)(false);
    let autoFocus = (0, _react.useRef)(props.autoFocus);
    (0, _react.useEffect)(()=>{
        if (virtualizer.visibleRect.height === 0) return;
        // Only scroll the focusedKey into view if the modality is not pointer to avoid jumps in position when clicking/pressing tall items.
        let modality = (0, _interactions.getInteractionModality)();
        if (focusedKey !== lastFocusedKey.current && (modality !== "pointer" || autoFocus.current)) {
            autoFocus.current = false;
            if (scrollToItem) // If user provides scrolltoitem, then it is their responsibility to call scrollIntoViewport if desired
            // since we don't know if their scrollToItem may take some time to actually bring the active element into the virtualizer's visible rect.
            scrollToItem(focusedKey);
            else virtualizer.scrollToItem(focusedKey, {
                duration: 0
            });
        }
        lastFocusedKey.current = focusedKey;
    }, [
        focusedKey,
        virtualizer.visibleRect.height,
        virtualizer,
        lastFocusedKey,
        scrollToItem,
        ref
    ]);
    // Persist the focusedKey and prevent it from being removed from the DOM when scrolled out of view.
    virtualizer.persistedKeys = (0, _react.useMemo)(()=>focusedKey ? new Set([
            focusedKey
        ]) : new Set(), [
        focusedKey
    ]);
    let onFocus = (0, _react.useCallback)((e)=>{
        // If the focused item is scrolled out of view and is not in the DOM, the collection
        // will have tabIndex={0}. When tabbing in from outside, scroll the focused item into view.
        // Ignore focus events that bubble through portals (e.g. focus that happens on a menu popover child of the virtualizer)
        // Don't scroll focused key into view if modality is pointer to prevent sudden jump in position (e.g. CardView).
        let modality = (0, _interactions.getInteractionModality)();
        if (!isFocusWithin.current && ref.current.contains(e.target) && modality !== "pointer") {
            if (scrollToItem) scrollToItem(focusedKey);
            else virtualizer.scrollToItem(focusedKey, {
                duration: 0
            });
        }
        isFocusWithin.current = e.target !== ref.current;
    }, [
        ref,
        virtualizer,
        focusedKey,
        scrollToItem
    ]);
    let onBlur = (0, _react.useCallback)((e)=>{
        isFocusWithin.current = ref.current.contains(e.relatedTarget);
    }, [
        ref
    ]);
    // Set tabIndex to -1 if there is a focused key, otherwise 0 so that the collection
    // itself is tabbable. When the collection receives focus, we scroll the focused item back into
    // view, which will allow it to be properly focused. If using virtual focus, don't set a
    // tabIndex at all so that VoiceOver on iOS 14 doesn't try to move real DOM focus to the element anyway.
    let tabIndex;
    if (!shouldUseVirtualFocus) {
        // When there is no focusedKey the default tabIndex is 0. We include logic for empty collections too.
        // For collections that are empty, but have a link in the empty children we want to skip focusing this
        // and let focus move to the link similar to link moving to children.
        tabIndex = focusedKey != null ? -1 : 0;
        // If the collection is empty, we want the tabIndex provided from props (if any)
        // so that we handle when tabbable items are added to the empty state.
        if (virtualizer.collection.size === 0 && props.tabIndex != null) tabIndex = props.tabIndex;
    }
    // Handle scrolling, and call onLoadMore when nearing the bottom.
    let isLoadingRef = (0, _react.useRef)(isLoading);
    let prevProps = (0, _react.useRef)(props);
    let onVisibleRectChange = (0, _react.useCallback)((rect)=>{
        state.setVisibleRect(rect);
        if (!isLoadingRef.current && onLoadMore) {
            let scrollOffset = state.virtualizer.contentSize.height - rect.height * 2;
            if (rect.y > scrollOffset) {
                isLoadingRef.current = true;
                onLoadMore();
            }
        }
    }, [
        onLoadMore,
        state
    ]);
    let lastContentSize = (0, _react.useRef)(0);
    (0, _utils.useLayoutEffect)(()=>{
        // If animating, wait until we're done.
        if (state.isAnimating) return;
        // Only update isLoadingRef if props object actually changed,
        // not if a local state change occurred.
        let wasLoading = isLoadingRef.current;
        if (props !== prevProps.current) {
            isLoadingRef.current = isLoading;
            prevProps.current = props;
        }
        let shouldLoadMore = !isLoadingRef.current && onLoadMore && state.contentSize.height > 0 && state.contentSize.height <= state.virtualizer.visibleRect.height && (wasLoading || state.contentSize.height !== lastContentSize.current);
        if (shouldLoadMore) {
            isLoadingRef.current = true;
            onLoadMore();
        }
        lastContentSize.current = state.contentSize.height;
    }, [
        state.contentSize,
        state.isAnimating,
        state.virtualizer,
        isLoading,
        onLoadMore,
        props
    ]);
    return {
        virtualizerProps: {
            tabIndex,
            onFocus,
            onBlur
        },
        scrollViewProps: {
            onVisibleRectChange
        }
    };
}
// forwardRef doesn't support generic parameters, so cast the result to the correct type
// https://stackoverflow.com/questions/58469229/react-with-typescript-generics-while-using-react-forwardref
const _Virtualizer = /*#__PURE__*/ (0, _reactDefault.default).forwardRef(Virtualizer);
function defaultRenderWrapper(parent, reusableView) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _virtualizerItem.VirtualizerItem), {
        key: reusableView.key,
        layoutInfo: reusableView.layoutInfo,
        virtualizer: reusableView.virtualizer,
        parent: parent === null || parent === void 0 ? void 0 : parent.layoutInfo
    }, reusableView.rendered);
}

},{"@react-aria/interactions":"ky3G8","@react-stately/virtualizer":"lVS5O","@react-aria/utils":"9cLk5","react":"9yzVZ","./ScrollView":"fsn3L","./VirtualizerItem":"feVQP","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"fsn3L":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // @ts-ignore
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ScrollView", ()=>ScrollViewForwardRef);
var _reactDom = require("react-dom");
var _utils = require("./utils");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _virtualizer = require("@react-stately/virtualizer");
var _utils1 = require("@react-aria/utils");
var _i18N = require("@react-aria/i18n");
let isOldReact = (0, _reactDefault.default).version.startsWith("16.") || (0, _reactDefault.default).version.startsWith("17.");
function ScrollView(props, ref) {
    let { contentSize, onVisibleRectChange, children, innerStyle, sizeToFit, onScrollStart, onScrollEnd, scrollDirection = "both", ...otherProps } = props;
    let defaultRef = (0, _react.useRef)();
    ref = ref || defaultRef;
    let state = (0, _react.useRef)({
        scrollTop: 0,
        scrollLeft: 0,
        scrollEndTime: 0,
        scrollTimeout: null,
        width: 0,
        height: 0,
        isScrolling: false
    }).current;
    let { direction } = (0, _i18N.useLocale)();
    let [isScrolling, setScrolling] = (0, _react.useState)(false);
    let onScroll = (0, _react.useCallback)((e)=>{
        if (e.target !== e.currentTarget) return;
        if (props.onScroll) props.onScroll(e);
        (0, _reactDom.flushSync)(()=>{
            let scrollTop = e.currentTarget.scrollTop;
            let scrollLeft = (0, _utils.getScrollLeft)(e.currentTarget, direction);
            // Prevent rubber band scrolling from shaking when scrolling out of bounds
            state.scrollTop = Math.max(0, Math.min(scrollTop, contentSize.height - state.height));
            state.scrollLeft = Math.max(0, Math.min(scrollLeft, contentSize.width - state.width));
            onVisibleRectChange(new (0, _virtualizer.Rect)(state.scrollLeft, state.scrollTop, state.width, state.height));
            if (!state.isScrolling) {
                state.isScrolling = true;
                setScrolling(true);
                if (onScrollStart) onScrollStart();
            }
            // So we don't constantly call clearTimeout and setTimeout,
            // keep track of the current timeout time and only reschedule
            // the timer when it is getting close.
            let now = Date.now();
            if (state.scrollEndTime <= now + 50) {
                state.scrollEndTime = now + 300;
                clearTimeout(state.scrollTimeout);
                state.scrollTimeout = setTimeout(()=>{
                    state.isScrolling = false;
                    setScrolling(false);
                    state.scrollTimeout = null;
                    if (onScrollEnd) onScrollEnd();
                }, 300);
            }
        });
    }, [
        props,
        direction,
        state,
        contentSize,
        onVisibleRectChange,
        onScrollStart,
        onScrollEnd
    ]);
    // eslint-disable-next-line arrow-body-style
    (0, _react.useEffect)(()=>{
        return ()=>{
            clearTimeout(state.scrollTimeout);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let updateSize = (0, _react.useCallback)(()=>{
        let dom = ref.current;
        if (!dom) return;
        let isTestEnv = false;
        let isClientWidthMocked = Object.getOwnPropertyNames(window.HTMLElement.prototype).includes("clientWidth");
        let isClientHeightMocked = Object.getOwnPropertyNames(window.HTMLElement.prototype).includes("clientHeight");
        let w = isTestEnv && !isClientWidthMocked ? Infinity : dom.clientWidth;
        let h = isTestEnv && !isClientHeightMocked ? Infinity : dom.clientHeight;
        if (sizeToFit && contentSize.width > 0 && contentSize.height > 0) {
            if (sizeToFit === "width") w = Math.min(w, contentSize.width);
            else if (sizeToFit === "height") h = Math.min(h, contentSize.height);
        }
        if (state.width !== w || state.height !== h) {
            state.width = w;
            state.height = h;
            onVisibleRectChange(new (0, _virtualizer.Rect)(state.scrollLeft, state.scrollTop, w, h));
        }
    }, [
        onVisibleRectChange,
        ref,
        state,
        sizeToFit,
        contentSize
    ]);
    (0, _utils1.useLayoutEffect)(()=>{
        updateSize();
    }, [
        updateSize
    ]);
    let raf = (0, _react.useRef)();
    let onResize = ()=>{
        var _raf;
        var _current;
        if (isOldReact) (_current = (_raf = raf).current) !== null && _current !== void 0 ? _current : _raf.current = requestAnimationFrame(()=>{
            updateSize();
            raf.current = null;
        });
        else updateSize();
    };
    (0, _utils1.useResizeObserver)({
        ref,
        onResize
    });
    (0, _react.useEffect)(()=>{
        return ()=>{
            if (raf.current) cancelAnimationFrame(raf.current);
        };
    }, []);
    let style = {
        // Reset padding so that relative positioning works correctly. Padding will be done in JS layout.
        padding: 0,
        ...otherProps.style
    };
    if (scrollDirection === "horizontal") {
        style.overflowX = "auto";
        style.overflowY = "hidden";
    } else if (scrollDirection === "vertical" || contentSize.width === state.width) {
        // Set overflow-x: hidden if content size is equal to the width of the scroll view.
        // This prevents horizontal scrollbars from flickering during resizing due to resize observer
        // firing slower than the frame rate, which may cause an infinite re-render loop.
        style.overflowY = "auto";
        style.overflowX = "hidden";
    } else style.overflow = "auto";
    innerStyle = {
        width: Number.isFinite(contentSize.width) ? contentSize.width : undefined,
        height: Number.isFinite(contentSize.height) ? contentSize.height : undefined,
        pointerEvents: isScrolling ? "none" : "auto",
        position: "relative",
        ...innerStyle
    };
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...otherProps,
        style: style,
        ref: ref,
        onScroll: onScroll
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        role: "presentation",
        style: innerStyle
    }, children));
}
const ScrollViewForwardRef = /*#__PURE__*/ (0, _reactDefault.default).forwardRef(ScrollView);

},{"react-dom":"cEvV3","./utils":"4p3ig","react":"9yzVZ","@react-stately/virtualizer":"lVS5O","@react-aria/utils":"9cLk5","@react-aria/i18n":"411rg","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"4p3ig":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// Original licensing for the following methods can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/bvaughn/react-window/blob/master/src/createGridComponent.js
// According to the spec, scrollLeft should be negative for RTL aligned elements.
// Chrome does not seem to adhere; its scrollLeft values are positive (measured relative to the left).
// Safari's elastic bounce makes detecting this even more complicated wrt potential false positives.
// The safest way to check this is to intentionally set a negative offset,
// and then verify that the subsequent "scroll" event matches the negative offset.
// If it does not match, then we can assume a non-standard RTL scroll implementation.
parcelHelpers.export(exports, "getRTLOffsetType", ()=>getRTLOffsetType);
parcelHelpers.export(exports, "getScrollLeft", ()=>getScrollLeft);
parcelHelpers.export(exports, "setScrollLeft", ()=>setScrollLeft);
let cachedRTLResult = null;
function getRTLOffsetType(recalculate = false) {
    if (cachedRTLResult === null || recalculate) {
        const outerDiv = document.createElement("div");
        const outerStyle = outerDiv.style;
        outerStyle.width = "50px";
        outerStyle.height = "50px";
        outerStyle.overflow = "scroll";
        outerStyle.direction = "rtl";
        const innerDiv = document.createElement("div");
        const innerStyle = innerDiv.style;
        innerStyle.width = "100px";
        innerStyle.height = "100px";
        outerDiv.appendChild(innerDiv);
        document.body.appendChild(outerDiv);
        if (outerDiv.scrollLeft > 0) cachedRTLResult = "positive-descending";
        else {
            outerDiv.scrollLeft = 1;
            if (outerDiv.scrollLeft === 0) cachedRTLResult = "negative";
            else cachedRTLResult = "positive-ascending";
        }
        document.body.removeChild(outerDiv);
        return cachedRTLResult;
    }
    return cachedRTLResult;
}
function getScrollLeft(node, direction) {
    let { scrollLeft } = node;
    // scrollLeft in rtl locales differs across browsers, so normalize.
    // See comment by getRTLOffsetType below for details.
    if (direction === "rtl") {
        let { scrollWidth, clientWidth } = node;
        switch(getRTLOffsetType()){
            case "negative":
                scrollLeft = -scrollLeft;
                break;
            case "positive-descending":
                scrollLeft = scrollWidth - clientWidth - scrollLeft;
                break;
        }
    }
    return scrollLeft;
}
function setScrollLeft(node, direction, scrollLeft) {
    if (direction === "rtl") switch(getRTLOffsetType()){
        case "negative":
            scrollLeft = -scrollLeft;
            break;
        case "positive-ascending":
            break;
        default:
            {
                const { clientWidth, scrollWidth } = node;
                scrollLeft = scrollWidth - clientWidth - scrollLeft;
                break;
            }
    }
    node.scrollLeft = scrollLeft;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"feVQP":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "VirtualizerItem", ()=>VirtualizerItem);
parcelHelpers.export(exports, "layoutInfoToStyle", ()=>layoutInfoToStyle);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _i18N = require("@react-aria/i18n");
var _useVirtualizerItem = require("./useVirtualizerItem");
function VirtualizerItem(props) {
    let { className, layoutInfo, virtualizer, parent, children } = props;
    let { direction } = (0, _i18N.useLocale)();
    let ref = (0, _react.useRef)();
    (0, _useVirtualizerItem.useVirtualizerItem)({
        layoutInfo,
        virtualizer,
        ref
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        role: "presentation",
        ref: ref,
        className: className,
        style: layoutInfoToStyle(layoutInfo, direction, parent)
    }, children);
}
let cache = new WeakMap();
function layoutInfoToStyle(layoutInfo, dir, parent) {
    let xProperty = dir === "rtl" ? "right" : "left";
    let cached = cache.get(layoutInfo);
    if (cached && cached[xProperty] != null) {
        if (!parent) return cached;
        // Invalidate if the parent position changed.
        let top = layoutInfo.rect.y - parent.rect.y;
        let x = layoutInfo.rect.x - parent.rect.x;
        if (cached.top === top && cached[xProperty] === x) return cached;
    }
    let rectStyles = {
        top: layoutInfo.rect.y - (parent ? parent.rect.y : 0),
        [xProperty]: layoutInfo.rect.x - (parent ? parent.rect.x : 0),
        width: layoutInfo.rect.width,
        height: layoutInfo.rect.height
    };
    // Get rid of any non finite values since they aren't valid css values
    Object.entries(rectStyles).forEach(([key, value])=>{
        if (!Number.isFinite(value)) rectStyles[key] = undefined;
    });
    let style = {
        position: layoutInfo.isSticky ? "sticky" : "absolute",
        // Sticky elements are positioned in normal document flow. Display inline-block so that they don't push other sticky columns onto the following rows.
        display: layoutInfo.isSticky ? "inline-block" : undefined,
        overflow: layoutInfo.allowOverflow ? "visible" : "hidden",
        transition: "all",
        WebkitTransition: "all",
        WebkitTransitionDuration: "inherit",
        transitionDuration: "inherit",
        opacity: layoutInfo.opacity,
        zIndex: layoutInfo.zIndex,
        transform: layoutInfo.transform,
        contain: "size layout style",
        ...rectStyles
    };
    cache.set(layoutInfo, style);
    return style;
}

},{"react":"9yzVZ","@react-aria/i18n":"411rg","./useVirtualizerItem":"2dkmR","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"2dkmR":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useVirtualizerItem", ()=>useVirtualizerItem);
var _virtualizer = require("@react-stately/virtualizer");
var _react = require("react");
var _utils = require("@react-aria/utils");
function useVirtualizerItem(options) {
    let { layoutInfo, virtualizer, ref } = options;
    let updateSize = (0, _react.useCallback)(()=>{
        let size = getSize(ref.current);
        virtualizer.updateItemSize(layoutInfo.key, size);
    }, [
        virtualizer,
        layoutInfo.key,
        ref
    ]);
    (0, _utils.useLayoutEffect)(()=>{
        if (layoutInfo.estimatedSize) updateSize();
    });
    return {
        updateSize
    };
}
function getSize(node) {
    // Reset height before measuring so we get the intrinsic size
    let height = node.style.height;
    node.style.height = "";
    let size = new (0, _virtualizer.Size)(node.scrollWidth, node.scrollHeight);
    node.style.height = height;
    return size;
}

},{"@react-stately/virtualizer":"lVS5O","react":"9yzVZ","@react-aria/utils":"9cLk5","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"5zk2X":[function(require,module,exports) {
/*
 * Copyright 2021 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Example", ()=>Example);
parcelHelpers.export(exports, "KeyboardNavigation", ()=>KeyboardNavigation);
parcelHelpers.export(exports, "KeyboardNavigationInsidePortal", ()=>KeyboardNavigationInsidePortal);
parcelHelpers.export(exports, "KeyboardNavigationNoContain", ()=>KeyboardNavigationNoContain);
parcelHelpers.export(exports, "KeyboardNavigationInsidePortalNoContain", ()=>KeyboardNavigationInsidePortalNoContain);
parcelHelpers.export(exports, "IgnoreRestoreFocus", ()=>IgnoreRestoreFocus);
parcelHelpers.export(exports, "FocusableFirstInScope", ()=>FocusableFirstInScope);
var _ = require("../");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactDom = require("react-dom");
var _reactDomDefault = parcelHelpers.interopDefault(_reactDom);
const dialogsRoot = "dialogsRoot";
const meta = {
    title: "FocusScope",
    component: (0, _.FocusScope),
    parameters: {
        description: {
            data: 'Should not be able to click or navigate back into inputs from previous "dialogs".'
        }
    }
};
exports.default = meta;
const Template = ({ isPortaled, contain = true })=>/*#__PURE__*/ (0, _reactDefault.default).createElement(Example, {
        isPortaled: isPortaled,
        contain: contain
    });
function MaybePortal({ children, isPortaled }) {
    if (!isPortaled) return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, children);
    return /*#__PURE__*/ (0, _reactDomDefault.default).createPortal(/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, children), document.getElementById(dialogsRoot));
}
function NestedDialog({ onClose, isPortaled, contain }) {
    let [open, setOpen] = (0, _react.useState)(false);
    let [showNew, setShowNew] = (0, _react.useState)(false);
    let onKeyDown = (e)=>{
        if (e.key === "Escape") {
            e.stopPropagation();
            onClose();
        }
    };
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(MaybePortal, {
        isPortaled: isPortaled
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.FocusScope), {
        contain: contain,
        restoreFocus: true,
        autoFocus: true
    }, !showNew && // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
    /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        role: "dialog",
        onKeyDown: onKeyDown
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("input", null), /*#__PURE__*/ (0, _reactDefault.default).createElement("input", null), /*#__PURE__*/ (0, _reactDefault.default).createElement("input", null), /*#__PURE__*/ (0, _reactDefault.default).createElement("button", {
        onClick: ()=>setShowNew(true)
    }, "replace focusscope children"), /*#__PURE__*/ (0, _reactDefault.default).createElement("button", {
        type: "button",
        onClick: ()=>setOpen(true)
    }, "Open dialog"), /*#__PURE__*/ (0, _reactDefault.default).createElement("button", {
        type: "button",
        onClick: onClose
    }, "close"), open && /*#__PURE__*/ (0, _reactDefault.default).createElement(NestedDialog, {
        contain: contain,
        onClose: ()=>setOpen(false),
        isPortaled: isPortaled
    })), showNew && // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
    /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        role: "dialog",
        onKeyDown: onKeyDown
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("input", null), /*#__PURE__*/ (0, _reactDefault.default).createElement("input", {
        autoFocus: true
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("input", null))));
}
function Example({ isPortaled, contain }) {
    let [open, setOpen] = (0, _react.useState)(false);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("input", {
        "aria-label": "input before"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("button", {
        type: "button",
        onClick: ()=>setOpen(true)
    }, "Open dialog"), /*#__PURE__*/ (0, _reactDefault.default).createElement("input", {
        "aria-label": "input after"
    }), open && /*#__PURE__*/ (0, _reactDefault.default).createElement(NestedDialog, {
        onClose: ()=>setOpen(false),
        isPortaled: isPortaled,
        contain: contain
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        id: dialogsRoot
    }));
}
function FocusableFirstInScopeExample() {
    let [contentIndex, setContentIndex] = (0, _react.useState)(0);
    let [buttonRemoved, setButtonRemoved] = (0, _react.useState)(false);
    function DialogContent(index = 0) {
        const nextIndex = index === 2 ? 0 : index + 1;
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement("h1", {
            id: `heading-${index}`
        }, "Dialog ", index + 1), index === 2 ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement("p", null, "The end of the road."), /*#__PURE__*/ (0, _reactDefault.default).createElement("button", {
            id: `button-${index}`,
            key: `button-${index}`,
            onClick: (e)=>{
                e.target.remove();
                setButtonRemoved(true);
            }
        }, "Remove Me"), buttonRemoved && /*#__PURE__*/ (0, _reactDefault.default).createElement("p", null, "With no tabbable elements within the scope, FocusScope will try to focus the first focusable element within the scope, in this case, the dialog itself.")) : /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement("p", null, "Content that will be replaced by ", /*#__PURE__*/ (0, _reactDefault.default).createElement("strong", null, "Dialog ", nextIndex + 1), "."), /*#__PURE__*/ (0, _reactDefault.default).createElement("button", {
            id: `button-${index}`,
            key: `button-${index}`,
            onClick: ()=>setContentIndex(nextIndex)
        }, "Go to Dialog ", nextIndex + 1)));
    }
    const contents = [];
    for(let i = 0; i < 3; i++)contents.push(DialogContent(i));
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.FocusScope), {
        contain: true
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        role: "dialog",
        tabIndex: -1,
        "aria-labelledby": `heading-${contentIndex}`,
        style: {
            border: "1px solid currentColor",
            borderRadius: "5px",
            padding: "0 1.5rem 1.5rem",
            width: "15rem"
        }
    }, contents[contentIndex]));
}
function IgnoreRestoreFocusExample() {
    const [display, setDisplay] = (0, _react.useState)(false);
    (0, _react.useEffect)(()=>{
        let handleKeyDown = (e)=>{
            if (e.key === "Escape") setDisplay(false);
        };
        document.body.addEventListener("keyup", handleKeyDown);
        return ()=>{
            document.body.removeEventListener("keyup", handleKeyDown);
        };
    }, []);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("button", {
        type: "button",
        onClick: ()=>setDisplay((state)=>!state)
    }, display ? "Close dialog 1" : "Open dialog 1"), /*#__PURE__*/ (0, _reactDefault.default).createElement("button", {
        type: "button",
        onClick: ()=>setDisplay((state)=>!state)
    }, display ? "Close dialog 2" : "Open dialog 2"), display && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.FocusScope), {
        restoreFocus: true
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        role: "dialog"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("input", null), /*#__PURE__*/ (0, _reactDefault.default).createElement("input", null), /*#__PURE__*/ (0, _reactDefault.default).createElement("input", null))));
}
const KeyboardNavigation = {
    render: Template,
    args: {
        isPortaled: false
    }
};
const KeyboardNavigationInsidePortal = {
    render: Template,
    args: {
        isPortaled: true
    }
};
const KeyboardNavigationNoContain = {
    render: Template,
    args: {
        isPortaled: false,
        contain: false
    }
};
const KeyboardNavigationInsidePortalNoContain = {
    render: Template,
    args: {
        isPortaled: true,
        contain: false
    }
};
const IgnoreRestoreFocus = {
    render: ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement(IgnoreRestoreFocusExample, null)
};
const FocusableFirstInScope = {
    render: ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement(FocusableFirstInScopeExample, null)
};

},{"../":"6gtGH","react":"9yzVZ","react-dom":"cEvV3","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"6gtGH":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _src = require("./src");
parcelHelpers.exportAll(_src, exports);

},{"./src":"42mbF","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"kvNcr":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GridFocusModeRowCellFocusModeCell", ()=>GridFocusModeRowCellFocusModeCell);
parcelHelpers.export(exports, "GridFocusModeRowCellFocusModeChild", ()=>GridFocusModeRowCellFocusModeChild);
parcelHelpers.export(exports, "GridFocusModeCellCellFocusModeChild", ()=>GridFocusModeCellCellFocusModeChild);
parcelHelpers.export(exports, "GridFocusModeCellCellFocusModeCell", ()=>GridFocusModeCellCellFocusModeCell);
var _example = require("./example");
var _collections = require("@react-stately/collections");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _switch = require("@react-spectrum/switch");
exports.default = {
    title: "useGrid"
};
const GridFocusModeRowCellFocusModeCell = {
    render: ()=>render({
            gridFocusMode: "row",
            cellFocusMode: "cell"
        }),
    name: "gridFocusMode = row, cellFocusMode = cell"
};
const GridFocusModeRowCellFocusModeChild = {
    render: ()=>render({
            gridFocusMode: "row",
            cellFocusMode: "child"
        }),
    name: "gridFocusMode = row, cellFocusMode = child"
};
const GridFocusModeCellCellFocusModeChild = {
    render: ()=>render({
            gridFocusMode: "cell",
            cellFocusMode: "child"
        }),
    name: "gridFocusMode = cell, cellFocusMode = child"
};
const GridFocusModeCellCellFocusModeCell = {
    render: ()=>render({
            gridFocusMode: "cell",
            cellFocusMode: "cell"
        }),
    name: "gridFocusMode = cell, cellFocusMode = cell"
};
function render(props = {}) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _example.Grid), props, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _collections.Item), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _switch.Switch), {
        "aria-label": "Switch 1"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _switch.Switch), {
        "aria-label": "Switch 2"
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _collections.Item), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _switch.Switch), {
        "aria-label": "Switch 1"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _switch.Switch), {
        "aria-label": "Switch 2"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _switch.Switch), {
        "aria-label": "Switch 3"
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _collections.Item), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _switch.Switch), {
        "aria-label": "Switch 1"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _switch.Switch), {
        "aria-label": "Switch 2"
    })));
}

},{"./example":"4hit0","@react-stately/collections":"loANi","react":"9yzVZ","@react-spectrum/switch":"fzqJX","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"4hit0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Grid", ()=>Grid);
var _grid = require("@react-stately/grid");
var _utils = require("@react-aria/utils");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _interactions = require("@react-aria/interactions");
var _ = require("../");
var _list = require("@react-stately/list");
function Grid(props) {
    let { gridFocusMode = "row", cellFocusMode = "child" } = props;
    let state = (0, _list.useListState)(props);
    let gridState = (0, _grid.useGridState)({
        ...props,
        selectionMode: "multiple",
        collection: new (0, _grid.GridCollection)({
            columnCount: 1,
            items: [
                ...state.collection
            ].map((item)=>({
                    type: "item",
                    childNodes: [
                        {
                            ...item,
                            index: 0,
                            type: "cell"
                        }
                    ]
                }))
        })
    });
    let ref = (0, _reactDefault.default).useRef();
    let { gridProps } = (0, _.useGrid)({
        "aria-label": "Grid",
        focusMode: gridFocusMode
    }, gridState, ref);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...gridProps,
        ref: ref
    }, [
        ...gridState.collection
    ].map((item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(Row, {
            key: item.key,
            state: gridState,
            item: item,
            focusMode: cellFocusMode
        })));
}
function Row({ state, item, focusMode }) {
    let rowRef = (0, _reactDefault.default).useRef();
    let cellRef = (0, _reactDefault.default).useRef();
    let cellNode = [
        ...item.childNodes
    ][0];
    let { rowProps } = (0, _.useGridRow)({
        node: item
    }, state, rowRef);
    let { gridCellProps } = (0, _.useGridCell)({
        node: cellNode,
        focusMode
    }, state, cellRef);
    let [isRowFocused, setRowFocused] = (0, _reactDefault.default).useState(false);
    let { focusProps: rowFocusProps } = (0, _interactions.useFocus)({
        onFocusChange: setRowFocused
    });
    let [isCellFocused, setCellFocused] = (0, _reactDefault.default).useState(false);
    let { focusProps: cellFocusProps } = (0, _interactions.useFocus)({
        onFocusChange: setCellFocused
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...(0, _utils.mergeProps)(rowProps, rowFocusProps),
        ref: rowRef,
        style: {
            outline: isRowFocused ? "2px solid red" : null
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...(0, _utils.mergeProps)(gridCellProps, cellFocusProps),
        ref: cellRef,
        style: {
            outline: isCellFocused ? "2px solid green" : null
        }
    }, cellNode.rendered));
}

},{"@react-stately/grid":"ehdYF","@react-aria/utils":"9cLk5","react":"9yzVZ","@react-aria/interactions":"ky3G8","../":"4ew5e","@react-stately/list":"Cp0zP","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"4ew5e":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 * 
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _src = require("./src");
parcelHelpers.exportAll(_src, exports);

},{"./src":"6tGaN","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"fzqJX":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /// <reference types="css-module-types" />
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Switch", ()=>(0, _switch.Switch));
var _switch = require("./Switch");

},{"./Switch":"8siq9","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"8siq9":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Switch", ()=>_Switch);
var _utils = require("@react-spectrum/utils");
var _focus = require("@react-aria/focus");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _varsCss = require("@adobe/spectrum-css-temp/components/toggle/vars.css");
var _varsCssDefault = parcelHelpers.interopDefault(_varsCss);
var _interactions = require("@react-aria/interactions");
var _provider = require("@react-spectrum/provider");
var _switch = require("@react-aria/switch");
var _toggle = require("@react-stately/toggle");
function Switch(props, ref) {
    props = (0, _provider.useProviderProps)(props);
    let { isEmphasized = false, isDisabled = false, autoFocus, children, ...otherProps } = props;
    let { styleProps } = (0, _utils.useStyleProps)(otherProps);
    let { hoverProps, isHovered } = (0, _interactions.useHover)({
        isDisabled
    });
    let inputRef = (0, _react.useRef)(null);
    let domRef = (0, _utils.useFocusableRef)(ref, inputRef);
    let state = (0, _toggle.useToggleState)(props);
    let { inputProps } = (0, _switch.useSwitch)(props, state, inputRef);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("label", {
        ...styleProps,
        ...hoverProps,
        ref: domRef,
        className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-ToggleSwitch", {
            "spectrum-ToggleSwitch--quiet": !isEmphasized,
            "is-disabled": isDisabled,
            "is-hovered": isHovered
        }, styleProps.className)
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _focus.FocusRing), {
        focusRingClass: (0, _utils.classNames)((0, _varsCssDefault.default), "focus-ring"),
        autoFocus: autoFocus
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("input", {
        ...inputProps,
        ref: inputRef,
        className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-ToggleSwitch-input")
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-ToggleSwitch-switch")
    }), children && /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-ToggleSwitch-label")
    }, children));
}
/**
 * Switches allow users to turn an individual option on or off.
 * They are usually used to activate or deactivate a specific setting.
 */ const _Switch = /*#__PURE__*/ (0, _react.forwardRef)(Switch);

},{"@react-spectrum/utils":"cMIJ6","@react-aria/focus":"42mbF","react":"9yzVZ","@adobe/spectrum-css-temp/components/toggle/vars.css":"8jc4S","@react-aria/interactions":"ky3G8","@react-spectrum/provider":"5bCdp","@react-aria/switch":"dXthB","@react-stately/toggle":"5qaKI","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"8jc4S":[function(require,module,exports) {
module.exports["focus-ring"] = `XHynUq_focus-ring`;
module.exports["i18nFontFamily"] = `XHynUq_i18nFontFamily`;
module.exports["is-hovered"] = `XHynUq_is-hovered`;
module.exports["spectrum-FocusRing-ring"] = `XHynUq_spectrum-FocusRing-ring`;
module.exports["spectrum-FocusRing"] = `XHynUq_spectrum-FocusRing ${module.exports["spectrum-FocusRing-ring"]}`;
module.exports["spectrum-FocusRing--quiet"] = `XHynUq_spectrum-FocusRing--quiet`;
module.exports["spectrum-ToggleSwitch"] = `XHynUq_spectrum-ToggleSwitch`;
module.exports["spectrum-ToggleSwitch--ab"] = `XHynUq_spectrum-ToggleSwitch--ab`;
module.exports["spectrum-ToggleSwitch--quiet"] = `XHynUq_spectrum-ToggleSwitch--quiet`;
module.exports["spectrum-ToggleSwitch-input"] = `XHynUq_spectrum-ToggleSwitch-input`;
module.exports["spectrum-ToggleSwitch-label"] = `XHynUq_spectrum-ToggleSwitch-label`;
module.exports["spectrum-ToggleSwitch-switch"] = `XHynUq_spectrum-ToggleSwitch-switch`;

},{}],"cRetY":[function(require,module,exports) {
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SearchTableview", ()=>SearchTableview);
var _table = require("@react-spectrum/table");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _searchfield = require("@react-spectrum/searchfield");
let manyColumns = [];
for(let i = 0; i < 100; i++)manyColumns.push(i === 0 ? {
    name: "Column name",
    key: "C0"
} : {
    name: "Column " + i,
    key: "C" + i
});
let manyRows = [];
for(let i = 0; i < 1000; i++){
    let row = {
        key: "R" + i
    };
    for(let j = 0; j < 100; j++)row["C" + j] = j === 0 ? `Row ${i}` : `${i}, ${j}`;
    manyRows.push(row);
}
exports.default = {
    title: "useFocusRing"
};
const SearchTableview = {
    render: ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement(SearchExample, null),
    name: "search + tableview",
    parameters: {
        a11y: {
            config: {
                // Fails due to TableView's known issue, ignoring here since it isn't pertinent to the story
                rules: [
                    {
                        id: "aria-required-children",
                        selector: '*:not([role="grid"])'
                    }
                ]
            }
        }
    }
};
function SearchExample() {
    const [items, setItems] = (0, _react.useState)(manyRows);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _searchfield.SearchField), {
        "aria-label": "table searchfield",
        onChange: (value)=>{
            const newItems = manyRows.filter((item)=>item["C0"].toLowerCase().includes(value.toLowerCase()));
            setItems(newItems);
        }
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _table.TableView), {
        "aria-label": "Searchable table with many columns and rows",
        selectionMode: "multiple",
        width: 700,
        height: 500
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _table.TableHeader), {
        columns: manyColumns
    }, (column)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _table.Column), {
            minWidth: 100
        }, column.name)), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _table.TableBody), {
        items: items
    }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _table.Row), {
            key: item.key
        }, (key)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _table.Cell), null, item[key])))));
}

},{"@react-spectrum/table":"gptJH","react":"9yzVZ","@react-spectrum/searchfield":"2pivm","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"gptJH":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /// <reference types="css-module-types" />
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TableView", ()=>(0, _tableViewWrapper.TableView));
parcelHelpers.export(exports, "TableHeader", ()=>(0, _table.TableHeader));
parcelHelpers.export(exports, "TableBody", ()=>(0, _table.TableBody));
parcelHelpers.export(exports, "Section", ()=>(0, _table.Section));
parcelHelpers.export(exports, "Row", ()=>(0, _table.Row));
parcelHelpers.export(exports, "Cell", ()=>(0, _table.Cell));
parcelHelpers.export(exports, "Column", ()=>SpectrumColumn);
var _tableViewWrapper = require("./TableViewWrapper");
var _table = require("@react-stately/table");
// Override TS for Column to support spectrum specific props.
const SpectrumColumn = (0, _table.Column);

},{"./TableViewWrapper":"8E616","@react-stately/table":"6ZM93","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"8E616":[function(require,module,exports) {
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TableView", ()=>_TableViewWrapper);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _flags = require("@react-stately/flags");
var _tableView = require("./TableView");
var _treeGridTableView = require("./TreeGridTableView");
function TableViewWrapper(props, ref) {
    let { UNSTABLE_allowsExpandableRows, ...otherProps } = props;
    if ((0, _flags.tableNestedRows)() && UNSTABLE_allowsExpandableRows) return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _treeGridTableView.TreeGridTableView), {
        ...otherProps,
        ref: ref
    });
    else return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _tableView.TableView), {
        ...otherProps,
        ref: ref
    });
}
/**
 * Tables are containers for displaying information. They allow users to quickly scan, sort, compare, and take action on large amounts of data.
 */ const _TableViewWrapper = /*#__PURE__*/ (0, _reactDefault.default).forwardRef(TableViewWrapper);

},{"react":"9yzVZ","@react-stately/flags":"aEc5X","./TableView":"9MtlT","./TreeGridTableView":"hjrBb","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"9MtlT":[function(require,module,exports) {
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TableView", ()=>_TableView);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _tableViewBase = require("./TableViewBase");
var _table = require("@react-stately/table");
function TableView(props, ref) {
    let { selectionStyle, dragAndDropHooks } = props;
    let [showSelectionCheckboxes, setShowSelectionCheckboxes] = (0, _react.useState)(selectionStyle !== "highlight");
    let isTableDraggable = !!(dragAndDropHooks === null || dragAndDropHooks === void 0 ? void 0 : dragAndDropHooks.useDraggableCollectionState);
    let state = (0, _table.useTableState)({
        ...props,
        showSelectionCheckboxes,
        showDragButtons: isTableDraggable,
        selectionBehavior: props.selectionStyle === "highlight" ? "replace" : "toggle"
    });
    // If the selection behavior changes in state, we need to update showSelectionCheckboxes here due to the circular dependency...
    let shouldShowCheckboxes = state.selectionManager.selectionBehavior !== "replace";
    if (shouldShowCheckboxes !== showSelectionCheckboxes) setShowSelectionCheckboxes(shouldShowCheckboxes);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _tableViewBase.TableViewBase), {
        ...props,
        state: state,
        ref: ref
    });
}
const _TableView = /*#__PURE__*/ (0, _reactDefault.default).forwardRef(TableView);

},{"react":"9yzVZ","./TableViewBase":"w8HhS","@react-stately/table":"6ZM93","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"w8HhS":[function(require,module,exports) {
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TableContext", ()=>TableContext);
parcelHelpers.export(exports, "useTableContext", ()=>useTableContext);
parcelHelpers.export(exports, "VirtualizerContext", ()=>VirtualizerContext);
parcelHelpers.export(exports, "useVirtualizerContext", ()=>useVirtualizerContext);
parcelHelpers.export(exports, "useTableRowContext", ()=>useTableRowContext);
parcelHelpers.export(exports, "TableViewBase", ()=>_TableViewBase);
var _arrowDownSmall = require("@spectrum-icons/ui/ArrowDownSmall");
var _arrowDownSmallDefault = parcelHelpers.interopDefault(_arrowDownSmall);
var _utils = require("@react-aria/utils");
var _checkbox = require("@react-spectrum/checkbox");
var _chevronDownMedium = require("@spectrum-icons/ui/ChevronDownMedium");
var _chevronDownMediumDefault = parcelHelpers.interopDefault(_chevronDownMedium);
var _chevronLeftMedium = require("@spectrum-icons/ui/ChevronLeftMedium");
var _chevronLeftMediumDefault = parcelHelpers.interopDefault(_chevronLeftMedium);
var _chevronRightMedium = require("@spectrum-icons/ui/ChevronRightMedium");
var _chevronRightMediumDefault = parcelHelpers.interopDefault(_chevronRightMedium);
var _utils1 = require("@react-spectrum/utils");
var _focus = require("@react-aria/focus");
var _interactions = require("@react-aria/interactions");
var _insertionIndicator = require("./InsertionIndicator");
// @ts-ignore
var _json = require("../intl/*.json");
var _jsonDefault = parcelHelpers.interopDefault(_json);
var _menu = require("@react-spectrum/menu");
var _virtualizer = require("@react-aria/virtualizer");
var _listGripper = require("@spectrum-icons/ui/ListGripper");
var _listGripperDefault = parcelHelpers.interopDefault(_listGripper);
var _nubbin = require("./Nubbin");
var _progress = require("@react-spectrum/progress");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _resizer = require("./Resizer");
var _virtualizer1 = require("@react-stately/virtualizer");
var _rootDropIndicator = require("./RootDropIndicator");
var _dragPreview = require("./DragPreview");
var _varsCss = require("@adobe/spectrum-css-temp/components/table/vars.css");
var _varsCssDefault = parcelHelpers.interopDefault(_varsCss);
var _tableCss = require("./table.css");
var _tableCssDefault = parcelHelpers.interopDefault(_tableCss);
var _table = require("@react-stately/table");
var _layout = require("@react-stately/layout");
var _tooltip = require("@react-spectrum/tooltip");
var _button = require("@react-aria/button");
var _i18N = require("@react-aria/i18n");
var _provider = require("@react-spectrum/provider");
var _table1 = require("@react-aria/table");
var _visuallyHidden = require("@react-aria/visually-hidden");
const DEFAULT_HEADER_HEIGHT = {
    medium: 34,
    large: 40
};
const DEFAULT_HIDE_HEADER_CELL_WIDTH = {
    medium: 38,
    large: 46
};
const ROW_HEIGHTS = {
    compact: {
        medium: 32,
        large: 40
    },
    regular: {
        medium: 40,
        large: 50
    },
    spacious: {
        medium: 48,
        large: 60
    }
};
const SELECTION_CELL_DEFAULT_WIDTH = {
    medium: 38,
    large: 48
};
const DRAG_BUTTON_CELL_DEFAULT_WIDTH = {
    medium: 16,
    large: 20
};
const LEVEL_OFFSET_WIDTH = {
    medium: 16,
    large: 20
};
const TableContext = /*#__PURE__*/ (0, _reactDefault.default).createContext(null);
function useTableContext() {
    return (0, _react.useContext)(TableContext);
}
const VirtualizerContext = /*#__PURE__*/ (0, _reactDefault.default).createContext(null);
function useVirtualizerContext() {
    return (0, _react.useContext)(VirtualizerContext);
}
function TableViewBase(props, ref) {
    var _dropState_target;
    props = (0, _provider.useProviderProps)(props);
    let { isQuiet, onAction, onResizeStart: propsOnResizeStart, onResizeEnd: propsOnResizeEnd, dragAndDropHooks, state } = props;
    let isTableDraggable = !!(dragAndDropHooks === null || dragAndDropHooks === void 0 ? void 0 : dragAndDropHooks.useDraggableCollectionState);
    let isTableDroppable = !!(dragAndDropHooks === null || dragAndDropHooks === void 0 ? void 0 : dragAndDropHooks.useDroppableCollectionState);
    let dragHooksProvided = (0, _react.useRef)(isTableDraggable);
    let dropHooksProvided = (0, _react.useRef)(isTableDroppable);
    (0, _react.useEffect)(()=>{
        if (dragHooksProvided.current !== isTableDraggable) console.warn("Drag hooks were provided during one render, but not another. This should be avoided as it may produce unexpected behavior.");
        if (dropHooksProvided.current !== isTableDroppable) console.warn("Drop hooks were provided during one render, but not another. This should be avoided as it may produce unexpected behavior.");
        if ("expandedKeys" in state && (isTableDraggable || isTableDroppable)) console.warn("Drag and drop is not yet fully supported with expandable rows and may produce unexpected results.");
    }, [
        isTableDraggable,
        isTableDroppable,
        state
    ]);
    let { styleProps } = (0, _utils1.useStyleProps)(props);
    let { direction } = (0, _i18N.useLocale)();
    let { scale } = (0, _provider.useProvider)();
    const getDefaultWidth = (0, _react.useCallback)(({ props: { hideHeader, isSelectionCell, showDivider, isDragButtonCell } })=>{
        if (hideHeader) {
            let width = DEFAULT_HIDE_HEADER_CELL_WIDTH[scale];
            return showDivider ? width + 1 : width;
        } else if (isSelectionCell) return SELECTION_CELL_DEFAULT_WIDTH[scale];
        else if (isDragButtonCell) return DRAG_BUTTON_CELL_DEFAULT_WIDTH[scale];
    }, [
        scale
    ]);
    const getDefaultMinWidth = (0, _react.useCallback)(({ props: { hideHeader, isSelectionCell, showDivider, isDragButtonCell } })=>{
        if (hideHeader) {
            let width = DEFAULT_HIDE_HEADER_CELL_WIDTH[scale];
            return showDivider ? width + 1 : width;
        } else if (isSelectionCell) return SELECTION_CELL_DEFAULT_WIDTH[scale];
        else if (isDragButtonCell) return DRAG_BUTTON_CELL_DEFAULT_WIDTH[scale];
        return 75;
    }, [
        scale
    ]);
    // Starts when the user selects resize from the menu, ends when resizing ends
    // used to control the visibility of the resizer Nubbin
    let [isInResizeMode, setIsInResizeMode] = (0, _react.useState)(false);
    // Starts when the resizer is actually moved
    // entering resizing/exiting resizing doesn't trigger a render
    // with table layout, so we need to track it here
    let [, setIsResizing] = (0, _react.useState)(false);
    let domRef = (0, _utils1.useDOMRef)(ref);
    let headerRef = (0, _react.useRef)();
    let bodyRef = (0, _react.useRef)();
    let stringFormatter = (0, _i18N.useLocalizedStringFormatter)((0, _jsonDefault.default), "@react-spectrum/table");
    let density = props.density || "regular";
    let columnLayout = (0, _react.useMemo)(()=>new (0, _table.TableColumnLayout)({
            getDefaultWidth,
            getDefaultMinWidth
        }), [
        getDefaultWidth,
        getDefaultMinWidth
    ]);
    let tableLayout = (0, _react.useMemo)(()=>new (0, _layout.TableLayout)({
            // If props.rowHeight is auto, then use estimated heights based on scale, otherwise use fixed heights.
            rowHeight: props.overflowMode === "wrap" ? null : ROW_HEIGHTS[density][scale],
            estimatedRowHeight: props.overflowMode === "wrap" ? ROW_HEIGHTS[density][scale] : null,
            headingHeight: props.overflowMode === "wrap" ? null : DEFAULT_HEADER_HEIGHT[scale],
            estimatedHeadingHeight: props.overflowMode === "wrap" ? DEFAULT_HEADER_HEIGHT[scale] : null,
            columnLayout,
            initialCollection: state.collection
        }), // don't recompute when state.collection changes, only used for initial value
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        props.overflowMode,
        scale,
        density,
        columnLayout
    ]);
    // Use a proxy so that a new object is created for each render so that alternate instances aren't affected by mutation.
    // This can be thought of as equivalent to `{…tableLayout, tableState: state}`, but works with classes as well.
    let layout = (0, _react.useMemo)(()=>{
        let proxy = new Proxy(tableLayout, {
            get (target, prop, receiver) {
                return prop === "tableState" ? state : Reflect.get(target, prop, receiver);
            }
        });
        return proxy;
    }, [
        state,
        tableLayout
    ]);
    let dragState;
    let preview = (0, _react.useRef)(null);
    if (isTableDraggable) {
        dragState = dragAndDropHooks.useDraggableCollectionState({
            collection: state.collection,
            selectionManager: state.selectionManager,
            preview
        });
        dragAndDropHooks.useDraggableCollection({}, dragState, domRef);
    }
    let DragPreview = dragAndDropHooks === null || dragAndDropHooks === void 0 ? void 0 : dragAndDropHooks.DragPreview;
    let dropState;
    let droppableCollection;
    let isRootDropTarget;
    if (isTableDroppable) {
        dropState = dragAndDropHooks.useDroppableCollectionState({
            collection: state.collection,
            selectionManager: state.selectionManager
        });
        droppableCollection = dragAndDropHooks.useDroppableCollection({
            keyboardDelegate: layout,
            dropTargetDelegate: layout
        }, dropState, domRef);
        isRootDropTarget = dropState.isDropTarget({
            type: "root"
        });
    }
    let { gridProps } = (0, _table1.useTable)({
        ...props,
        isVirtualized: true,
        layout,
        onRowAction: onAction
    }, state, domRef);
    let [headerMenuOpen, setHeaderMenuOpen] = (0, _react.useState)(false);
    let [headerRowHovered, setHeaderRowHovered] = (0, _react.useState)(false);
    let renderWrapper = (parent, reusableView, children, renderChildren)=>{
        let style = (0, _virtualizer.layoutInfoToStyle)(reusableView.layoutInfo, direction, parent && parent.layoutInfo);
        if (style.overflow === "hidden") style.overflow = "visible"; // needed to support position: sticky
        if (reusableView.viewType === "rowgroup") return /*#__PURE__*/ (0, _reactDefault.default).createElement(TableRowGroup, {
            key: reusableView.key,
            style: style
        }, isTableDroppable && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _rootDropIndicator.RootDropIndicator), {
            key: "root"
        }), renderChildren(children));
        if (reusableView.viewType === "header") return /*#__PURE__*/ (0, _reactDefault.default).createElement(TableHeader, {
            key: reusableView.key,
            style: style
        }, renderChildren(children));
        if (reusableView.viewType === "row") return /*#__PURE__*/ (0, _reactDefault.default).createElement(TableRow, {
            key: reusableView.key,
            item: reusableView.content,
            style: style,
            hasActions: onAction,
            isTableDroppable: isTableDroppable,
            isTableDraggable: isTableDraggable
        }, renderChildren(children));
        if (reusableView.viewType === "headerrow") return /*#__PURE__*/ (0, _reactDefault.default).createElement(TableHeaderRow, {
            onHoverChange: setHeaderRowHovered,
            key: reusableView.key,
            style: style,
            item: reusableView.content
        }, renderChildren(children));
        let isDropTarget;
        let isRootDroptarget;
        if (isTableDroppable) {
            if (parent.content) isDropTarget = dropState.isDropTarget({
                type: "item",
                dropPosition: "on",
                key: parent.content.key
            });
            isRootDroptarget = dropState.isDropTarget({
                type: "root"
            });
        }
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _virtualizer.VirtualizerItem), {
            key: reusableView.key,
            layoutInfo: reusableView.layoutInfo,
            virtualizer: reusableView.virtualizer,
            parent: parent === null || parent === void 0 ? void 0 : parent.layoutInfo,
            className: (0, _utils1.classNames)((0, _varsCssDefault.default), "spectrum-Table-cellWrapper", (0, _utils1.classNames)((0, _tableCssDefault.default), {
                "react-spectrum-Table-cellWrapper": !reusableView.layoutInfo.estimatedSize,
                "react-spectrum-Table-cellWrapper--dropTarget": isDropTarget || isRootDroptarget
            }))
        }, reusableView.rendered);
    };
    let renderView = (type, item)=>{
        switch(type){
            case "header":
            case "rowgroup":
            case "section":
            case "row":
            case "headerrow":
                return null;
            case "cell":
                if (item.props.isSelectionCell) return /*#__PURE__*/ (0, _reactDefault.default).createElement(TableCheckboxCell, {
                    cell: item
                });
                if (item.props.isDragButtonCell) return /*#__PURE__*/ (0, _reactDefault.default).createElement(TableDragCell, {
                    cell: item
                });
                return /*#__PURE__*/ (0, _reactDefault.default).createElement(TableCell, {
                    cell: item
                });
            case "placeholder":
                // TODO: move to react-aria?
                return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
                    role: "gridcell",
                    "aria-colindex": item.index + 1,
                    "aria-colspan": item.colspan > 1 ? item.colspan : null
                });
            case "column":
                if (item.props.isSelectionCell) return /*#__PURE__*/ (0, _reactDefault.default).createElement(TableSelectAllCell, {
                    column: item
                });
                if (item.props.isDragButtonCell) return /*#__PURE__*/ (0, _reactDefault.default).createElement(TableDragHeaderCell, {
                    column: item
                });
                // TODO: consider this case, what if we have hidden headers and a empty table
                if (item.props.hideHeader) return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _tooltip.TooltipTrigger), {
                    placement: "top",
                    trigger: "focus"
                }, /*#__PURE__*/ (0, _reactDefault.default).createElement(TableColumnHeader, {
                    column: item
                }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _tooltip.Tooltip), {
                    placement: "top"
                }, item.rendered));
                if (item.props.allowsResizing && !item.hasChildNodes) return /*#__PURE__*/ (0, _reactDefault.default).createElement(ResizableTableColumnHeader, {
                    tableRef: domRef,
                    column: item
                });
                return /*#__PURE__*/ (0, _reactDefault.default).createElement(TableColumnHeader, {
                    column: item
                });
            case "loader":
                return /*#__PURE__*/ (0, _reactDefault.default).createElement(CenteredWrapper, null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _progress.ProgressCircle), {
                    isIndeterminate: true,
                    "aria-label": state.collection.size > 0 ? stringFormatter.format("loadingMore") : stringFormatter.format("loading")
                }));
            case "empty":
                {
                    let emptyState = props.renderEmptyState ? props.renderEmptyState() : null;
                    if (emptyState == null) return null;
                    return /*#__PURE__*/ (0, _reactDefault.default).createElement(CenteredWrapper, null, emptyState);
                }
        }
    };
    let [isVerticalScrollbarVisible, setVerticalScollbarVisible] = (0, _react.useState)(false);
    let [isHorizontalScrollbarVisible, setHorizontalScollbarVisible] = (0, _react.useState)(false);
    let viewport = (0, _react.useRef)({
        x: 0,
        y: 0,
        width: 0,
        height: 0
    });
    let onVisibleRectChange = (0, _react.useCallback)((e)=>{
        if (viewport.current.width === e.width && viewport.current.height === e.height) return;
        viewport.current = e;
        if (bodyRef.current) {
            setVerticalScollbarVisible(bodyRef.current.clientWidth + 2 < bodyRef.current.offsetWidth);
            setHorizontalScollbarVisible(bodyRef.current.clientHeight + 2 < bodyRef.current.offsetHeight);
        }
    }, []);
    let { isFocusVisible, focusProps } = (0, _focus.useFocusRing)();
    let isEmpty = state.collection.size === 0;
    let onFocusedResizer = ()=>{
        bodyRef.current.scrollLeft = headerRef.current.scrollLeft;
    };
    let onResizeStart = (0, _react.useCallback)((widths)=>{
        setIsResizing(true);
        propsOnResizeStart === null || propsOnResizeStart === void 0 ? void 0 : propsOnResizeStart(widths);
    }, [
        setIsResizing,
        propsOnResizeStart
    ]);
    let onResizeEnd = (0, _react.useCallback)((widths)=>{
        setIsInResizeMode(false);
        setIsResizing(false);
        propsOnResizeEnd === null || propsOnResizeEnd === void 0 ? void 0 : propsOnResizeEnd(widths);
    }, [
        propsOnResizeEnd,
        setIsInResizeMode,
        setIsResizing
    ]);
    let focusedKey = state.selectionManager.focusedKey;
    if ((dropState === null || dropState === void 0 ? void 0 : (_dropState_target = dropState.target) === null || _dropState_target === void 0 ? void 0 : _dropState_target.type) === "item") focusedKey = dropState.target.key;
    let mergedProps = (0, _utils.mergeProps)(isTableDroppable && (droppableCollection === null || droppableCollection === void 0 ? void 0 : droppableCollection.collectionProps), gridProps, focusProps, (dragAndDropHooks === null || dragAndDropHooks === void 0 ? void 0 : dragAndDropHooks.isVirtualDragging()) && {
        tabIndex: null
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(TableContext.Provider, {
        value: {
            state,
            dragState,
            dropState,
            dragAndDropHooks,
            isTableDraggable,
            isTableDroppable,
            layout,
            onResizeStart,
            onResize: props.onResize,
            onResizeEnd,
            headerRowHovered,
            isInResizeMode,
            setIsInResizeMode,
            isEmpty,
            onFocusedResizer,
            headerMenuOpen,
            setHeaderMenuOpen
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(TableVirtualizer, {
        ...mergedProps,
        ...styleProps,
        className: (0, _utils1.classNames)((0, _varsCssDefault.default), "spectrum-Table", `spectrum-Table--${density}`, {
            "spectrum-Table--quiet": isQuiet,
            "spectrum-Table--wrap": props.overflowMode === "wrap",
            "spectrum-Table--loadingMore": state.collection.body.props.loadingState === "loadingMore",
            "spectrum-Table--isVerticalScrollbarVisible": isVerticalScrollbarVisible,
            "spectrum-Table--isHorizontalScrollbarVisible": isHorizontalScrollbarVisible
        }, (0, _utils1.classNames)((0, _tableCssDefault.default), "react-spectrum-Table"), styleProps.className),
        layout: layout,
        collection: state.collection,
        focusedKey: focusedKey,
        renderView: renderView,
        renderWrapper: renderWrapper,
        onVisibleRectChange: onVisibleRectChange,
        domRef: domRef,
        headerRef: headerRef,
        bodyRef: bodyRef,
        isFocusVisible: isFocusVisible,
        isVirtualDragging: dragAndDropHooks === null || dragAndDropHooks === void 0 ? void 0 : dragAndDropHooks.isVirtualDragging(),
        isRootDropTarget: isRootDropTarget
    }), DragPreview && isTableDraggable && /*#__PURE__*/ (0, _reactDefault.default).createElement(DragPreview, {
        ref: preview
    }, ()=>{
        if (dragAndDropHooks.renderPreview) return dragAndDropHooks.renderPreview(dragState.draggingKeys, dragState.draggedKey);
        let itemCount = dragState.draggingKeys.size;
        let maxWidth = bodyRef.current.getBoundingClientRect().width;
        let height = ROW_HEIGHTS[density][scale];
        let itemText = state.collection.getTextValue(dragState.draggedKey);
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _dragPreview.DragPreview), {
            itemText: itemText,
            itemCount: itemCount,
            height: height,
            maxWidth: maxWidth
        });
    }));
}
// This is a custom Virtualizer that also has a header that syncs its scroll position with the body.
function TableVirtualizer(props) {
    var _layout_getLayoutInfo;
    let { layout, collection, focusedKey, renderView, renderWrapper, domRef, bodyRef, headerRef, onVisibleRectChange: onVisibleRectChangeProp, isFocusVisible, isVirtualDragging, isRootDropTarget, ...otherProps } = props;
    let { direction } = (0, _i18N.useLocale)();
    let loadingState = collection.body.props.loadingState;
    let isLoading = loadingState === "loading" || loadingState === "loadingMore";
    let onLoadMore = collection.body.props.onLoadMore;
    let transitionDuration = 220;
    if (isLoading) transitionDuration = 160;
    if (layout.resizingColumn != null) // while resizing, prop changes should not cause animations
    transitionDuration = 0;
    let state = (0, _virtualizer1.useVirtualizerState)({
        layout,
        collection,
        renderView,
        renderWrapper,
        onVisibleRectChange (rect) {
            bodyRef.current.scrollTop = rect.y;
            (0, _virtualizer.setScrollLeft)(bodyRef.current, direction, rect.x);
        },
        transitionDuration
    });
    let scrollToItem = (0, _react.useCallback)((key)=>{
        let item = collection.getItem(key);
        let column = collection.columns[0];
        let virtualizer = state.virtualizer;
        virtualizer.scrollToItem(key, {
            duration: 0,
            // Prevent scrolling to the top when clicking on column headers.
            shouldScrollY: (item === null || item === void 0 ? void 0 : item.type) !== "column",
            // Offset scroll position by width of selection cell
            // (which is sticky and will overlap the cell we're scrolling to).
            offsetX: column.props.isSelectionCell || column.props.isDragButtonCell ? layout.getColumnWidth(column.key) : 0
        });
        // Sync the scroll positions of the column headers and the body so scrollIntoViewport can
        // properly decide if the column is outside the viewport or not
        headerRef.current.scrollLeft = bodyRef.current.scrollLeft;
    }, [
        collection,
        bodyRef,
        headerRef,
        layout,
        state.virtualizer
    ]);
    let memoedVirtualizerProps = (0, _react.useMemo)(()=>({
            tabIndex: otherProps.tabIndex,
            focusedKey,
            scrollToItem,
            isLoading,
            onLoadMore
        }), [
        otherProps.tabIndex,
        focusedKey,
        scrollToItem,
        isLoading,
        onLoadMore
    ]);
    let { virtualizerProps, scrollViewProps: { onVisibleRectChange } } = (0, _virtualizer.useVirtualizer)(memoedVirtualizerProps, state, domRef);
    // this effect runs whenever the contentSize changes, it doesn't matter what the content size is
    // only that it changes in a resize, and when that happens, we want to sync the body to the
    // header scroll position
    (0, _react.useEffect)(()=>{
        if ((0, _interactions.getInteractionModality)() === "keyboard" && headerRef.current.contains(document.activeElement)) {
            (0, _utils.scrollIntoView)(headerRef.current, document.activeElement);
            (0, _utils.scrollIntoViewport)(document.activeElement, {
                containingElement: domRef.current
            });
            bodyRef.current.scrollLeft = headerRef.current.scrollLeft;
        }
    }, [
        state.contentSize,
        headerRef,
        bodyRef,
        domRef
    ]);
    let headerHeight = ((_layout_getLayoutInfo = layout.getLayoutInfo("header")) === null || _layout_getLayoutInfo === void 0 ? void 0 : _layout_getLayoutInfo.rect.height) || 0;
    // Sync the scroll position from the table body to the header container.
    let onScroll = (0, _react.useCallback)(()=>{
        headerRef.current.scrollLeft = bodyRef.current.scrollLeft;
    }, [
        bodyRef,
        headerRef
    ]);
    let resizerPosition = layout.getResizerPosition() - 2;
    let resizerAtEdge = resizerPosition > Math.max(state.virtualizer.contentSize.width, state.virtualizer.visibleRect.width) - 3;
    // this should be fine, every movement of the resizer causes a rerender
    // scrolling can cause it to lag for a moment, but it's always updated
    let resizerInVisibleRegion = resizerPosition < state.virtualizer.visibleRect.maxX;
    let shouldHardCornerResizeCorner = resizerAtEdge && resizerInVisibleRegion;
    // minimize re-render caused on Resizers by memoing this
    let resizingColumnWidth = layout.getColumnWidth(layout.resizingColumn);
    let resizingColumn = (0, _react.useMemo)(()=>({
            width: resizingColumnWidth,
            key: layout.resizingColumn
        }), [
        resizingColumnWidth,
        layout.resizingColumn
    ]);
    let mergedProps = (0, _utils.mergeProps)(otherProps, virtualizerProps, isVirtualDragging && {
        tabIndex: null
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(VirtualizerContext.Provider, {
        value: resizingColumn
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _focus.FocusScope), null, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...mergedProps,
        ref: domRef
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        role: "presentation",
        className: (0, _utils1.classNames)((0, _varsCssDefault.default), "spectrum-Table-headWrapper"),
        style: {
            height: headerHeight,
            overflow: "hidden",
            position: "relative",
            willChange: state.isScrolling ? "scroll-position" : undefined,
            transition: state.isAnimating ? `none ${state.virtualizer.transitionDuration}ms` : undefined
        },
        ref: headerRef
    }, state.visibleViews[0]), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _virtualizer.ScrollView), {
        role: "presentation",
        className: (0, _utils1.classNames)((0, _varsCssDefault.default), "spectrum-Table-body", {
            "focus-ring": isFocusVisible,
            "spectrum-Table-body--resizerAtTableEdge": shouldHardCornerResizeCorner
        }, (0, _utils1.classNames)((0, _tableCssDefault.default), "react-spectrum-Table-body", {
            "react-spectrum-Table-body--dropTarget": !!isRootDropTarget
        })),
        tabIndex: isVirtualDragging ? null : -1,
        style: {
            flex: 1
        },
        innerStyle: {
            overflow: "visible",
            transition: state.isAnimating ? `none ${state.virtualizer.transitionDuration}ms` : undefined
        },
        ref: bodyRef,
        contentSize: state.contentSize,
        onVisibleRectChange: (0, _utils.chain)(onVisibleRectChange, onVisibleRectChangeProp),
        onScrollStart: state.startScrolling,
        onScrollEnd: state.endScrolling,
        onScroll: onScroll
    }, state.visibleViews[1], /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _utils1.classNames)((0, _varsCssDefault.default), "spectrum-Table-bodyResizeIndicator"),
        style: {
            [direction === "ltr" ? "left" : "right"]: `${resizerPosition}px`,
            height: `${Math.max(state.virtualizer.contentSize.height, state.virtualizer.visibleRect.height)}px`,
            display: layout.resizingColumn ? "block" : "none"
        }
    })))));
}
function TableHeader({ children, ...otherProps }) {
    let { rowGroupProps } = (0, _table1.useTableRowGroup)();
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...rowGroupProps,
        ...otherProps,
        className: (0, _utils1.classNames)((0, _varsCssDefault.default), "spectrum-Table-head")
    }, children);
}
function TableColumnHeader(props) {
    var _state_sortDescriptor, _state_sortDescriptor1, _state_sortDescriptor2, _state_sortDescriptor3;
    let { column } = props;
    let ref = (0, _react.useRef)(null);
    let { state, isEmpty } = useTableContext();
    let { pressProps, isPressed } = (0, _interactions.usePress)({
        isDisabled: isEmpty
    });
    let columnProps = column.props;
    (0, _react.useEffect)(()=>{
        if (column.hasChildNodes && columnProps.allowsResizing) console.warn(`Column key: ${column.key}. Columns with child columns don't allow resizing.`);
    }, [
        column.hasChildNodes,
        column.key,
        columnProps.allowsResizing
    ]);
    let { columnHeaderProps } = (0, _table1.useTableColumnHeader)({
        node: column,
        isVirtualized: true
    }, state, ref);
    let { hoverProps, isHovered } = (0, _interactions.useHover)({
        ...props,
        isDisabled: isEmpty
    });
    const allProps = [
        columnHeaderProps,
        hoverProps,
        pressProps
    ];
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _focus.FocusRing), {
        focusRingClass: (0, _utils1.classNames)((0, _varsCssDefault.default), "focus-ring")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...(0, _utils.mergeProps)(...allProps),
        ref: ref,
        className: (0, _utils1.classNames)((0, _varsCssDefault.default), "spectrum-Table-headCell", {
            "is-active": isPressed,
            "is-sortable": columnProps.allowsSorting,
            "is-sorted-desc": ((_state_sortDescriptor = state.sortDescriptor) === null || _state_sortDescriptor === void 0 ? void 0 : _state_sortDescriptor.column) === column.key && ((_state_sortDescriptor1 = state.sortDescriptor) === null || _state_sortDescriptor1 === void 0 ? void 0 : _state_sortDescriptor1.direction) === "descending",
            "is-sorted-asc": ((_state_sortDescriptor2 = state.sortDescriptor) === null || _state_sortDescriptor2 === void 0 ? void 0 : _state_sortDescriptor2.column) === column.key && ((_state_sortDescriptor3 = state.sortDescriptor) === null || _state_sortDescriptor3 === void 0 ? void 0 : _state_sortDescriptor3.direction) === "ascending",
            "is-hovered": isHovered,
            "spectrum-Table-cell--hideHeader": columnProps.hideHeader
        }, (0, _utils1.classNames)((0, _tableCssDefault.default), "react-spectrum-Table-cell", {
            "react-spectrum-Table-cell--alignCenter": columnProps.align === "center" || column.colspan > 1,
            "react-spectrum-Table-cell--alignEnd": columnProps.align === "end"
        }))
    }, columnProps.allowsSorting && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _arrowDownSmallDefault.default), {
        UNSAFE_className: (0, _utils1.classNames)((0, _varsCssDefault.default), "spectrum-Table-sortedIcon")
    }), columnProps.hideHeader ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _visuallyHidden.VisuallyHidden), null, column.rendered) : /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _utils1.classNames)((0, _varsCssDefault.default), "spectrum-Table-headCellContents")
    }, column.rendered)));
}
let _TableColumnHeaderButton = (props, ref)=>{
    let { focusProps, alignment, ...otherProps } = props;
    let { isEmpty } = useTableContext();
    let domRef = (0, _utils1.useFocusableRef)(ref);
    let { buttonProps } = (0, _button.useButton)({
        ...otherProps,
        elementType: "div",
        isDisabled: isEmpty
    }, domRef);
    let { hoverProps, isHovered } = (0, _interactions.useHover)({
        ...otherProps,
        isDisabled: isEmpty
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _utils1.classNames)((0, _varsCssDefault.default), "spectrum-Table-headCellContents", {
            "is-hovered": isHovered
        }),
        ...hoverProps
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _utils1.classNames)((0, _varsCssDefault.default), "spectrum-Table-headCellButton", {
            "spectrum-Table-headCellButton--alignStart": alignment === "start",
            "spectrum-Table-headCellButton--alignCenter": alignment === "center",
            "spectrum-Table-headCellButton--alignEnd": alignment === "end"
        }),
        ...(0, _utils.mergeProps)(buttonProps, focusProps),
        ref: domRef
    }, props.children));
};
let TableColumnHeaderButton = /*#__PURE__*/ (0, _reactDefault.default).forwardRef(_TableColumnHeaderButton);
function ResizableTableColumnHeader(props) {
    var _column_props, _state_sortDescriptor, _state_sortDescriptor1, _state_sortDescriptor2, _state_sortDescriptor3;
    let { column } = props;
    let ref = (0, _react.useRef)(null);
    let triggerRef = (0, _react.useRef)(null);
    let resizingRef = (0, _react.useRef)(null);
    let { state, layout, onResizeStart, onResize, onResizeEnd, headerRowHovered, setIsInResizeMode, isEmpty, isInResizeMode, headerMenuOpen, setHeaderMenuOpen } = useTableContext();
    let stringFormatter = (0, _i18N.useLocalizedStringFormatter)((0, _jsonDefault.default), "@react-spectrum/table");
    let { pressProps, isPressed } = (0, _interactions.usePress)({
        isDisabled: isEmpty
    });
    let { columnHeaderProps } = (0, _table1.useTableColumnHeader)({
        node: column,
        isVirtualized: true
    }, state, ref);
    let { hoverProps, isHovered } = (0, _interactions.useHover)({
        ...props,
        isDisabled: isEmpty || headerMenuOpen
    });
    const allProps = [
        columnHeaderProps,
        pressProps,
        hoverProps
    ];
    let columnProps = column.props;
    let { isFocusVisible, focusProps } = (0, _focus.useFocusRing)();
    const onMenuSelect = (key)=>{
        switch(key){
            case "sort-asc":
                state.sort(column.key, "ascending");
                break;
            case "sort-desc":
                state.sort(column.key, "descending");
                break;
            case "resize":
                layout.startResize(column.key);
                setIsInResizeMode(true);
                state.setKeyboardNavigationDisabled(true);
                break;
        }
    };
    let allowsSorting = (_column_props = column.props) === null || _column_props === void 0 ? void 0 : _column_props.allowsSorting;
    let items = (0, _react.useMemo)(()=>{
        let options = [
            allowsSorting ? {
                label: stringFormatter.format("sortAscending"),
                id: "sort-asc"
            } : undefined,
            allowsSorting ? {
                label: stringFormatter.format("sortDescending"),
                id: "sort-desc"
            } : undefined,
            {
                label: stringFormatter.format("resizeColumn"),
                id: "resize"
            }
        ];
        return options;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        allowsSorting
    ]);
    let resizingColumn = layout.resizingColumn;
    let showResizer = !isEmpty && (headerRowHovered && (0, _interactions.getInteractionModality)() !== "keyboard" || resizingColumn != null);
    let alignment = "start";
    let menuAlign = "start";
    if (columnProps.align === "center" || column.colspan > 1) alignment = "center";
    else if (columnProps.align === "end") {
        alignment = "end";
        menuAlign = "end";
    }
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _focus.FocusRing), {
        focusRingClass: (0, _utils1.classNames)((0, _varsCssDefault.default), "focus-ring")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...(0, _utils.mergeProps)(...allProps),
        ref: ref,
        className: (0, _utils1.classNames)((0, _varsCssDefault.default), "spectrum-Table-headCell", {
            "is-active": isPressed,
            "is-resizable": columnProps.allowsResizing,
            "is-sortable": columnProps.allowsSorting,
            "is-sorted-desc": ((_state_sortDescriptor = state.sortDescriptor) === null || _state_sortDescriptor === void 0 ? void 0 : _state_sortDescriptor.column) === column.key && ((_state_sortDescriptor1 = state.sortDescriptor) === null || _state_sortDescriptor1 === void 0 ? void 0 : _state_sortDescriptor1.direction) === "descending",
            "is-sorted-asc": ((_state_sortDescriptor2 = state.sortDescriptor) === null || _state_sortDescriptor2 === void 0 ? void 0 : _state_sortDescriptor2.column) === column.key && ((_state_sortDescriptor3 = state.sortDescriptor) === null || _state_sortDescriptor3 === void 0 ? void 0 : _state_sortDescriptor3.direction) === "ascending",
            "is-hovered": isHovered,
            "focus-ring": isFocusVisible,
            "spectrum-Table-cell--hideHeader": columnProps.hideHeader
        }, (0, _utils1.classNames)((0, _tableCssDefault.default), "react-spectrum-Table-cell", {
            "react-spectrum-Table-cell--alignCenter": alignment === "center",
            "react-spectrum-Table-cell--alignEnd": alignment === "end"
        }))
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _menu.MenuTrigger), {
        onOpenChange: setHeaderMenuOpen,
        align: menuAlign
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(TableColumnHeaderButton, {
        alignment: alignment,
        ref: triggerRef,
        focusProps: focusProps
    }, columnProps.allowsSorting && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _arrowDownSmallDefault.default), {
        UNSAFE_className: (0, _utils1.classNames)((0, _varsCssDefault.default), "spectrum-Table-sortedIcon")
    }), columnProps.hideHeader ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _visuallyHidden.VisuallyHidden), null, column.rendered) : /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _utils1.classNames)((0, _varsCssDefault.default), "spectrum-Table-headerCellText")
    }, column.rendered), columnProps.allowsResizing && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _chevronDownMediumDefault.default), {
        UNSAFE_className: (0, _utils1.classNames)((0, _varsCssDefault.default), "spectrum-Table-menuChevron")
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _menu.Menu), {
        onAction: onMenuSelect,
        minWidth: "size-2000",
        items: items
    }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _menu.Item), null, item.label))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _resizer.Resizer), {
        ref: resizingRef,
        column: column,
        showResizer: showResizer,
        onResizeStart: onResizeStart,
        onResize: onResize,
        onResizeEnd: onResizeEnd,
        triggerRef: (0, _utils1.useUnwrapDOMRef)(triggerRef)
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        "aria-hidden": true,
        className: (0, _utils1.classNames)((0, _varsCssDefault.default), "spectrum-Table-colResizeIndicator", {
            "spectrum-Table-colResizeIndicator--visible": resizingColumn != null,
            "spectrum-Table-colResizeIndicator--resizing": resizingColumn === column.key
        })
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _utils1.classNames)((0, _varsCssDefault.default), "spectrum-Table-colResizeNubbin", {
            "spectrum-Table-colResizeNubbin--visible": isInResizeMode && resizingColumn === column.key
        })
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _nubbin.Nubbin), null)))));
}
function TableSelectAllCell({ column }) {
    let ref = (0, _react.useRef)();
    let { state } = useTableContext();
    let isSingleSelectionMode = state.selectionManager.selectionMode === "single";
    let { columnHeaderProps } = (0, _table1.useTableColumnHeader)({
        node: column,
        isVirtualized: true
    }, state, ref);
    let { checkboxProps } = (0, _table1.useTableSelectAllCheckbox)(state);
    let { hoverProps, isHovered } = (0, _interactions.useHover)({});
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _focus.FocusRing), {
        focusRingClass: (0, _utils1.classNames)((0, _varsCssDefault.default), "focus-ring")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...(0, _utils.mergeProps)(columnHeaderProps, hoverProps),
        ref: ref,
        className: (0, _utils1.classNames)((0, _varsCssDefault.default), "spectrum-Table-headCell", "spectrum-Table-checkboxCell", {
            "is-hovered": isHovered
        })
    }, /*
            In single selection mode, the checkbox will be hidden.
            So to avoid leaving a column header with no accessible content,
            we use a VisuallyHidden component to include the aria-label from the checkbox,
            which for single selection will be "Select."
          */ isSingleSelectionMode && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _visuallyHidden.VisuallyHidden), null, checkboxProps["aria-label"]), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _checkbox.Checkbox), {
        ...checkboxProps,
        isEmphasized: true,
        UNSAFE_style: isSingleSelectionMode ? {
            visibility: "hidden"
        } : undefined,
        UNSAFE_className: (0, _utils1.classNames)((0, _varsCssDefault.default), "spectrum-Table-checkbox")
    })));
}
function TableDragHeaderCell({ column }) {
    let ref = (0, _react.useRef)();
    let { state } = useTableContext();
    let { columnHeaderProps } = (0, _table1.useTableColumnHeader)({
        node: column,
        isVirtualized: true
    }, state, ref);
    let stringFormatter = (0, _i18N.useLocalizedStringFormatter)((0, _jsonDefault.default), "@react-spectrum/table");
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _focus.FocusRing), {
        focusRingClass: (0, _utils1.classNames)((0, _varsCssDefault.default), "focus-ring")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...columnHeaderProps,
        ref: ref,
        className: (0, _utils1.classNames)((0, _varsCssDefault.default), "spectrum-Table-headCell", (0, _utils1.classNames)((0, _tableCssDefault.default), "react-spectrum-Table-headCell", "react-spectrum-Table-dragButtonHeadCell"))
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _visuallyHidden.VisuallyHidden), null, stringFormatter.format("drag"))));
}
function TableRowGroup({ children, ...otherProps }) {
    let { rowGroupProps } = (0, _table1.useTableRowGroup)();
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...rowGroupProps,
        ...otherProps
    }, children);
}
function DragButton() {
    let { dragButtonProps, dragButtonRef, isFocusVisibleWithin } = useTableRowContext();
    let { visuallyHiddenProps } = (0, _visuallyHidden.useVisuallyHidden)();
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _focus.FocusRing), {
        focusRingClass: (0, _utils1.classNames)((0, _tableCssDefault.default), "focus-ring")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...dragButtonProps,
        className: (0, _utils1.classNames)((0, _tableCssDefault.default), "react-spectrum-Table-dragButton"),
        style: !isFocusVisibleWithin ? {
            ...visuallyHiddenProps.style
        } : {},
        ref: dragButtonRef,
        draggable: "true"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _listGripperDefault.default), {
        UNSAFE_className: (0, _utils1.classNames)((0, _tableCssDefault.default))
    })));
}
const TableRowContext = /*#__PURE__*/ (0, _reactDefault.default).createContext(null);
function useTableRowContext() {
    return (0, _react.useContext)(TableRowContext);
}
function TableRow({ item, children, hasActions, isTableDraggable, isTableDroppable, ...otherProps }) {
    var _state_collection_rows_find, _layout_getContentSize, _layout_virtualizer;
    let ref = (0, _react.useRef)();
    let { state, layout, dragAndDropHooks, dragState, dropState } = useTableContext();
    let allowsInteraction = state.selectionManager.selectionMode !== "none" || hasActions;
    let isDisabled = !allowsInteraction || state.disabledKeys.has(item.key);
    let isDroppable = isTableDroppable && !isDisabled;
    let isSelected = state.selectionManager.isSelected(item.key);
    let { rowProps } = (0, _table1.useTableRow)({
        node: item,
        isVirtualized: true,
        shouldSelectOnPressUp: isTableDraggable
    }, state, ref);
    let { pressProps, isPressed } = (0, _interactions.usePress)({
        isDisabled
    });
    // The row should show the focus background style when any cell inside it is focused.
    // If the row itself is focused, then it should have a blue focus indicator on the left.
    let { isFocusVisible: isFocusVisibleWithin, focusProps: focusWithinProps } = (0, _focus.useFocusRing)({
        within: true
    });
    let { isFocusVisible, focusProps } = (0, _focus.useFocusRing)();
    let { hoverProps, isHovered } = (0, _interactions.useHover)({
        isDisabled
    });
    let isFirstRow = ((_state_collection_rows_find = state.collection.rows.find((row)=>row.level === 1)) === null || _state_collection_rows_find === void 0 ? void 0 : _state_collection_rows_find.key) === item.key;
    let isLastRow = item.nextKey == null;
    // Figure out if the TableView content is equal or greater in height to the container. If so, we'll need to round the bottom
    // border corners of the last row when selected.
    let isFlushWithContainerBottom = false;
    if (isLastRow) {
        if (((_layout_getContentSize = layout.getContentSize()) === null || _layout_getContentSize === void 0 ? void 0 : _layout_getContentSize.height) >= ((_layout_virtualizer = layout.virtualizer) === null || _layout_virtualizer === void 0 ? void 0 : _layout_virtualizer.getVisibleRect().height)) isFlushWithContainerBottom = true;
    }
    let draggableItem;
    if (isTableDraggable) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        draggableItem = dragAndDropHooks.useDraggableItem({
            key: item.key,
            hasDragButton: true
        }, dragState);
        if (isDisabled) draggableItem = null;
    }
    let droppableItem;
    let isDropTarget;
    let dropIndicator;
    let dropIndicatorRef = (0, _react.useRef)();
    if (isTableDroppable) {
        let target = {
            type: "item",
            key: item.key,
            dropPosition: "on"
        };
        isDropTarget = dropState.isDropTarget(target);
        // eslint-disable-next-line react-hooks/rules-of-hooks
        dropIndicator = dragAndDropHooks.useDropIndicator({
            target
        }, dropState, dropIndicatorRef);
    }
    let dragButtonRef = (0, _reactDefault.default).useRef();
    let { buttonProps: dragButtonProps } = (0, _button.useButton)({
        ...draggableItem === null || draggableItem === void 0 ? void 0 : draggableItem.dragButtonProps,
        elementType: "div"
    }, dragButtonRef);
    let props = (0, _utils.mergeProps)(rowProps, otherProps, focusWithinProps, focusProps, hoverProps, pressProps, draggableItem === null || draggableItem === void 0 ? void 0 : draggableItem.dragProps, // Remove tab index from list row if performing a screenreader drag. This prevents TalkBack from focusing the row,
    // allowing for single swipe navigation between row drop indicator
    (dragAndDropHooks === null || dragAndDropHooks === void 0 ? void 0 : dragAndDropHooks.isVirtualDragging()) && {
        tabIndex: null
    });
    let dropProps = isDroppable ? droppableItem === null || droppableItem === void 0 ? void 0 : droppableItem.dropProps : {
        "aria-hidden": droppableItem === null || droppableItem === void 0 ? void 0 : droppableItem.dropProps["aria-hidden"]
    };
    let { visuallyHiddenProps } = (0, _visuallyHidden.useVisuallyHidden)();
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(TableRowContext.Provider, {
        value: {
            dragButtonProps,
            dragButtonRef,
            isFocusVisibleWithin
        }
    }, isTableDroppable && isFirstRow && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _insertionIndicator.InsertionIndicator), {
        rowProps: props,
        key: `${item.key}-before`,
        target: {
            key: item.key,
            type: "item",
            dropPosition: "before"
        }
    }), isTableDroppable && !(dropIndicator === null || dropIndicator === void 0 ? void 0 : dropIndicator.isHidden) && /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        role: "row",
        ...visuallyHiddenProps
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        role: "gridcell"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        role: "button",
        ...dropIndicator === null || dropIndicator === void 0 ? void 0 : dropIndicator.dropIndicatorProps,
        ref: dropIndicatorRef
    }))), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...(0, _utils.mergeProps)(props, dropProps),
        ref: ref,
        className: (0, _utils1.classNames)((0, _varsCssDefault.default), "spectrum-Table-row", {
            "is-active": isPressed,
            "is-selected": isSelected,
            "spectrum-Table-row--highlightSelection": state.selectionManager.selectionBehavior === "replace",
            "is-next-selected": state.selectionManager.isSelected(item.nextKey),
            "is-focused": isFocusVisibleWithin,
            "focus-ring": isFocusVisible,
            "is-hovered": isHovered,
            "is-disabled": isDisabled,
            "spectrum-Table-row--firstRow": isFirstRow,
            "spectrum-Table-row--lastRow": isLastRow,
            "spectrum-Table-row--isFlushBottom": isFlushWithContainerBottom
        }, (0, _utils1.classNames)((0, _tableCssDefault.default), "react-spectrum-Table-row", {
            "react-spectrum-Table-row--dropTarget": isDropTarget
        }))
    }, children), isTableDroppable && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _insertionIndicator.InsertionIndicator), {
        rowProps: props,
        key: `${item.key}-after`,
        target: {
            key: item.key,
            type: "item",
            dropPosition: "after"
        }
    }));
}
function TableHeaderRow({ item, children, style, ...props }) {
    let { state, headerMenuOpen } = useTableContext();
    let ref = (0, _react.useRef)();
    let { rowProps } = (0, _table1.useTableHeaderRow)({
        node: item,
        isVirtualized: true
    }, state, ref);
    let { hoverProps } = (0, _interactions.useHover)({
        ...props,
        isDisabled: headerMenuOpen
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...(0, _utils.mergeProps)(rowProps, hoverProps),
        ref: ref,
        style: style
    }, children);
}
function TableDragCell({ cell }) {
    let ref = (0, _react.useRef)();
    let { state, isTableDraggable } = useTableContext();
    let isDisabled = state.disabledKeys.has(cell.parentKey);
    let { gridCellProps } = (0, _table1.useTableCell)({
        node: cell,
        isVirtualized: true
    }, state, ref);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _focus.FocusRing), {
        focusRingClass: (0, _utils1.classNames)((0, _varsCssDefault.default), "focus-ring")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...gridCellProps,
        ref: ref,
        className: (0, _utils1.classNames)((0, _varsCssDefault.default), "spectrum-Table-cell", {
            "is-disabled": isDisabled
        }, (0, _utils1.classNames)((0, _tableCssDefault.default), "react-spectrum-Table-cell", "react-spectrum-Table-dragButtonCell"))
    }, isTableDraggable && !isDisabled && /*#__PURE__*/ (0, _reactDefault.default).createElement(DragButton, null)));
}
function TableCheckboxCell({ cell }) {
    let ref = (0, _react.useRef)();
    let { state } = useTableContext();
    let isDisabled = state.disabledKeys.has(cell.parentKey);
    let { gridCellProps } = (0, _table1.useTableCell)({
        node: cell,
        isVirtualized: true
    }, state, ref);
    let { checkboxProps } = (0, _table1.useTableSelectionCheckbox)({
        key: cell.parentKey
    }, state);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _focus.FocusRing), {
        focusRingClass: (0, _utils1.classNames)((0, _varsCssDefault.default), "focus-ring")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...gridCellProps,
        ref: ref,
        className: (0, _utils1.classNames)((0, _varsCssDefault.default), "spectrum-Table-cell", "spectrum-Table-checkboxCell", {
            "is-disabled": isDisabled
        }, (0, _utils1.classNames)((0, _tableCssDefault.default), "react-spectrum-Table-cell"))
    }, state.selectionManager.selectionMode !== "none" && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _checkbox.Checkbox), {
        ...checkboxProps,
        isEmphasized: true,
        isDisabled: isDisabled,
        UNSAFE_className: (0, _utils1.classNames)((0, _varsCssDefault.default), "spectrum-Table-checkbox")
    })));
}
function TableCell({ cell }) {
    let { scale } = (0, _provider.useProvider)();
    let { state } = useTableContext();
    let isExpandableTable = "expandedKeys" in state;
    let ref = (0, _react.useRef)();
    let columnProps = cell.column.props;
    let isDisabled = state.disabledKeys.has(cell.parentKey);
    let { gridCellProps } = (0, _table1.useTableCell)({
        node: cell,
        isVirtualized: true
    }, state, ref);
    let { id, ...otherGridCellProps } = gridCellProps;
    let isFirstRowHeaderCell = state.collection.rowHeaderColumnKeys.keys().next().value === cell.column.key;
    let isRowExpandable = false;
    let showExpandCollapseButton = false;
    let levelOffset = 0;
    if ("expandedKeys" in state) {
        var _state_keyMap_get_props_UNSTABLE_childItems, _state_keyMap_get, _state_keyMap_get_props_children, _state_keyMap_get_props, _state_keyMap_get1;
        isRowExpandable = ((_state_keyMap_get = state.keyMap.get(cell.parentKey)) === null || _state_keyMap_get === void 0 ? void 0 : (_state_keyMap_get_props_UNSTABLE_childItems = _state_keyMap_get.props.UNSTABLE_childItems) === null || _state_keyMap_get_props_UNSTABLE_childItems === void 0 ? void 0 : _state_keyMap_get_props_UNSTABLE_childItems.length) > 0 || ((_state_keyMap_get1 = state.keyMap.get(cell.parentKey)) === null || _state_keyMap_get1 === void 0 ? void 0 : (_state_keyMap_get_props = _state_keyMap_get1.props) === null || _state_keyMap_get_props === void 0 ? void 0 : (_state_keyMap_get_props_children = _state_keyMap_get_props.children) === null || _state_keyMap_get_props_children === void 0 ? void 0 : _state_keyMap_get_props_children.length) > state.userColumnCount;
        showExpandCollapseButton = isFirstRowHeaderCell && isRowExpandable;
        // Offset based on level, and add additional offset if there is no expand/collapse button on a row
        levelOffset = (cell.level - 2) * LEVEL_OFFSET_WIDTH[scale] + (!showExpandCollapseButton ? LEVEL_OFFSET_WIDTH[scale] * 2 : 0);
    }
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _focus.FocusRing), {
        focusRingClass: (0, _utils1.classNames)((0, _varsCssDefault.default), "focus-ring")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...otherGridCellProps,
        "aria-labelledby": id,
        ref: ref,
        style: isExpandableTable && isFirstRowHeaderCell ? {
            paddingInlineStart: levelOffset
        } : {},
        className: (0, _utils1.classNames)((0, _varsCssDefault.default), "spectrum-Table-cell", {
            "spectrum-Table-cell--divider": columnProps.showDivider && cell.column.nextKey !== null,
            "spectrum-Table-cell--hideHeader": columnProps.hideHeader,
            "spectrum-Table-cell--hasExpandCollapseButton": showExpandCollapseButton,
            "is-disabled": isDisabled
        }, (0, _utils1.classNames)((0, _tableCssDefault.default), "react-spectrum-Table-cell", {
            "react-spectrum-Table-cell--alignStart": columnProps.align === "start",
            "react-spectrum-Table-cell--alignCenter": columnProps.align === "center",
            "react-spectrum-Table-cell--alignEnd": columnProps.align === "end"
        }))
    }, showExpandCollapseButton && /*#__PURE__*/ (0, _reactDefault.default).createElement(ExpandableRowChevron, {
        cell: cell
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        id: id,
        className: (0, _utils1.classNames)((0, _varsCssDefault.default), "spectrum-Table-cellContents")
    }, cell.rendered)));
}
function ExpandableRowChevron({ cell }) {
    // TODO: move some/all of the chevron button setup into a separate hook?
    let { direction } = (0, _i18N.useLocale)();
    let { state } = useTableContext();
    let expandButtonRef = (0, _react.useRef)();
    let stringFormatter = (0, _i18N.useLocalizedStringFormatter)((0, _jsonDefault.default), "@react-spectrum/table");
    let isExpanded;
    if ("expandedKeys" in state) isExpanded = state.expandedKeys === "all" || state.expandedKeys.has(cell.parentKey);
    // Will need to keep the chevron as a button for iOS VO at all times since VO doesn't focus the cell. Also keep as button if cellAction is defined by the user in the future
    let { buttonProps } = (0, _button.useButton)({
        // Desktop and mobile both toggle expansion of a native expandable row on mouse/touch up
        onPress: ()=>{
            state.toggleKey(cell.parentKey);
            if (!(0, _interactions.isFocusVisible)()) {
                state.selectionManager.setFocused(true);
                state.selectionManager.setFocusedKey(cell.parentKey);
            }
        },
        elementType: "span",
        "aria-label": isExpanded ? stringFormatter.format("collapse") : stringFormatter.format("expand")
    }, expandButtonRef);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        ...buttonProps,
        ref: expandButtonRef,
        // Override tabindex so that grid keyboard nav skips over it. Needs -1 so android talkback can actually "focus" it
        tabIndex: (0, _utils.isAndroid)() ? -1 : undefined,
        className: (0, _utils1.classNames)((0, _varsCssDefault.default), "spectrum-Table-expandButton", {
            "is-open": isExpanded
        })
    }, direction === "ltr" ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _chevronRightMediumDefault.default), null) : /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _chevronLeftMediumDefault.default), null));
}
function CenteredWrapper({ children }) {
    let { state } = useTableContext();
    let rowProps;
    if ("expandedKeys" in state) {
        let topLevelRowCount = [
            ...state.keyMap.get(state.collection.body.key).childNodes
        ].length;
        rowProps = {
            "aria-level": 1,
            "aria-posinset": topLevelRowCount + 1,
            "aria-setsize": topLevelRowCount + 1
        };
    } else rowProps = {
        "aria-rowindex": state.collection.headerRows.length + state.collection.size + 1
    };
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        role: "row",
        ...rowProps,
        className: (0, _utils1.classNames)((0, _tableCssDefault.default), "react-spectrum-Table-centeredWrapper")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        role: "rowheader",
        "aria-colspan": state.collection.columns.length
    }, children));
}
const _TableViewBase = /*#__PURE__*/ (0, _reactDefault.default).forwardRef(TableViewBase);

},{"@spectrum-icons/ui/ArrowDownSmall":"2XOFR","@react-aria/utils":"9cLk5","@react-spectrum/checkbox":"1r19j","@spectrum-icons/ui/ChevronDownMedium":"bWUHC","@spectrum-icons/ui/ChevronLeftMedium":"eZUPs","@spectrum-icons/ui/ChevronRightMedium":"6amCu","@react-spectrum/utils":"cMIJ6","@react-aria/focus":"42mbF","@react-aria/interactions":"ky3G8","./InsertionIndicator":"8uraN","../intl/*.json":"5Wmph","@react-spectrum/menu":"asqy4","@react-aria/virtualizer":"gAPsK","@spectrum-icons/ui/ListGripper":"6Lck0","./Nubbin":"3kMEi","@react-spectrum/progress":"4kHa7","react":"9yzVZ","./Resizer":"cT1al","@react-stately/virtualizer":"lVS5O","./RootDropIndicator":"iUmqB","./DragPreview":"4zOF7","@adobe/spectrum-css-temp/components/table/vars.css":"gCdiM","./table.css":"5RNXu","@react-stately/table":"6ZM93","@react-stately/layout":"6Mwz5","@react-spectrum/tooltip":"f9wa6","@react-aria/button":"fsdLZ","@react-aria/i18n":"411rg","@react-spectrum/provider":"5bCdp","@react-aria/table":"jm3EF","@react-aria/visually-hidden":"4jwxT","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"1r19j":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /// <reference types="css-module-types" />
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Checkbox", ()=>(0, _checkbox.Checkbox));
parcelHelpers.export(exports, "CheckboxGroup", ()=>(0, _checkboxGroup.CheckboxGroup));
var _checkbox = require("./Checkbox");
var _checkboxGroup = require("./CheckboxGroup");

},{"./Checkbox":"7akUu","./CheckboxGroup":"284xh","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"7akUu":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Checkbox", ()=>_Checkbox);
var _context = require("./context");
var _checkmarkSmall = require("@spectrum-icons/ui/CheckmarkSmall");
var _checkmarkSmallDefault = parcelHelpers.interopDefault(_checkmarkSmall);
var _utils = require("@react-spectrum/utils");
var _dashSmall = require("@spectrum-icons/ui/DashSmall");
var _dashSmallDefault = parcelHelpers.interopDefault(_dashSmall);
var _focus = require("@react-aria/focus");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _varsCss = require("@adobe/spectrum-css-temp/components/checkbox/vars.css");
var _varsCssDefault = parcelHelpers.interopDefault(_varsCss);
var _checkbox = require("@react-aria/checkbox");
var _form = require("@react-spectrum/form");
var _interactions = require("@react-aria/interactions");
var _provider = require("@react-spectrum/provider");
var _toggle = require("@react-stately/toggle");
function Checkbox(props, ref) {
    let originalProps = props;
    props = (0, _provider.useProviderProps)(props);
    props = (0, _form.useFormProps)(props);
    let { isIndeterminate = false, isEmphasized = false, autoFocus, children, ...otherProps } = props;
    let { styleProps } = (0, _utils.useStyleProps)(otherProps);
    let inputRef = (0, _react.useRef)(null);
    let domRef = (0, _utils.useFocusableRef)(ref, inputRef);
    // Swap hooks depending on whether this checkbox is inside a CheckboxGroup.
    // This is a bit unorthodox. Typically, hooks cannot be called in a conditional,
    // but since the checkbox won't move in and out of a group, it should be safe.
    let groupState = (0, _react.useContext)((0, _context.CheckboxGroupContext));
    let { inputProps, isInvalid, isDisabled } = groupState ? (0, _checkbox.useCheckboxGroupItem)({
        ...props,
        // Value is optional for standalone checkboxes, but required for CheckboxGroup items;
        // it's passed explicitly here to avoid typescript error (requires ignore).
        // @ts-ignore
        value: props.value,
        // Only pass isRequired and validationState to react-aria if they came from
        // the props for this individual checkbox, and not from the group via context.
        isRequired: originalProps.isRequired,
        validationState: originalProps.validationState,
        isInvalid: originalProps.isInvalid
    }, groupState, inputRef) : (0, _checkbox.useCheckbox)(props, (0, _toggle.useToggleState)(props), inputRef);
    let { hoverProps, isHovered } = (0, _interactions.useHover)({
        isDisabled
    });
    let markIcon = isIndeterminate ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _dashSmallDefault.default), {
        UNSAFE_className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Checkbox-partialCheckmark")
    }) : /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _checkmarkSmallDefault.default), {
        UNSAFE_className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Checkbox-checkmark")
    });
    if (groupState) {
        for (let key of [
            "isSelected",
            "defaultSelected",
            "isEmphasized"
        ])if (originalProps[key] != null) console.warn(`${key} is unsupported on individual <Checkbox> elements within a <CheckboxGroup>. Please apply these props to the group instead.`);
        if (props.value == null) console.warn("A <Checkbox> element within a <CheckboxGroup> requires a `value` property.");
    }
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("label", {
        ...styleProps,
        ...hoverProps,
        ref: domRef,
        className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Checkbox", {
            "is-checked": inputProps.checked,
            "is-indeterminate": isIndeterminate,
            "spectrum-Checkbox--quiet": !isEmphasized,
            "is-invalid": isInvalid,
            "is-disabled": isDisabled,
            "is-hovered": isHovered
        }, styleProps.className)
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _focus.FocusRing), {
        focusRingClass: (0, _utils.classNames)((0, _varsCssDefault.default), "focus-ring"),
        autoFocus: autoFocus
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("input", {
        ...inputProps,
        ref: inputRef,
        className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Checkbox-input")
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Checkbox-box")
    }, markIcon), children && /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Checkbox-label")
    }, children));
}
/**
 * Checkboxes allow users to select multiple items from a list of individual items,
 * or to mark one individual item as selected.
 */ let _Checkbox = /*#__PURE__*/ (0, _react.forwardRef)(Checkbox);

},{"./context":"dgF9P","@spectrum-icons/ui/CheckmarkSmall":"6nTpB","@react-spectrum/utils":"cMIJ6","@spectrum-icons/ui/DashSmall":"9Dgf1","@react-aria/focus":"42mbF","react":"9yzVZ","@adobe/spectrum-css-temp/components/checkbox/vars.css":"847rj","@react-aria/checkbox":"5e6Tk","@react-spectrum/form":"bGDqA","@react-aria/interactions":"ky3G8","@react-spectrum/provider":"5bCdp","@react-stately/toggle":"5qaKI","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"dgF9P":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CheckboxGroupContext", ()=>CheckboxGroupContext);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const CheckboxGroupContext = (0, _reactDefault.default).createContext(null);

},{"react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"6nTpB":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("10641af46e6d8e9d");
exports.__esModule = true;
exports.default = CheckmarkSmall;
var _CheckmarkSmall = require("573caec3414f2c70");
var _icon = require("dc0e638cba4658e4");
var _react = _interopRequireDefault(require("d2176a6f009ca8e3"));
function CheckmarkSmall(props) {
    return /*#__PURE__*/ _react.default.createElement(_icon.UIIcon, props, /*#__PURE__*/ _react.default.createElement(_CheckmarkSmall.CheckmarkSmall, null));
}

},{"10641af46e6d8e9d":"iHubQ","573caec3414f2c70":"kPHT4","dc0e638cba4658e4":"k7wem","d2176a6f009ca8e3":"9yzVZ"}],"kPHT4":[function(require,module,exports) {
/**
* @adobe/react-spectrum-ui (c) by Adobe
* 
* @adobe/react-spectrum-ui is licensed under a
* Creative Commons Attribution-NoDerivatives 4.0 International License.
* 
* You should have received a copy of the license along with this
* work. If not, see <http://creativecommons.org/licenses/by-nd/4.0/>.
**/ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CheckmarkSmall = CheckmarkSmall;
var _react = _interopRequireDefault(require("cf93ddf827d4c14b"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function CheckmarkSmall(_ref) {
    var _ref$scale = _ref.scale, scale = _ref$scale === void 0 ? "M" : _ref$scale, props = _objectWithoutProperties(_ref, [
        "scale"
    ]);
    return _react["default"].createElement("svg", _extends({}, props, props), scale === "L" && _react["default"].createElement("path", {
        d: "M4.5 11a.999.999 0 0 1-.788-.385l-3-4a1 1 0 1 1 1.576-1.23L4.5 8.376l5.212-6.99a1 1 0 1 1 1.576 1.23l-6 8A.999.999 0 0 1 4.5 11z"
    }), scale === "M" && _react["default"].createElement("path", {
        d: "M3.788 9A.999.999 0 0 1 3 8.615l-2.288-3a1 1 0 1 1 1.576-1.23l1.5 1.991 3.924-4.991a1 1 0 1 1 1.576 1.23l-4.712 6A.999.999 0 0 1 3.788 9z"
    }));
}
CheckmarkSmall.displayName = "CheckmarkSmall";

},{"cf93ddf827d4c14b":"9yzVZ"}],"9Dgf1":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("d147c0e58e9f9dbd");
exports.__esModule = true;
exports.default = DashSmall;
var _DashSmall = require("b42586f1ea461dd0");
var _icon = require("eec9c8f5401b2824");
var _react = _interopRequireDefault(require("846a8cba6c97b3d5"));
function DashSmall(props) {
    return /*#__PURE__*/ _react.default.createElement(_icon.UIIcon, props, /*#__PURE__*/ _react.default.createElement(_DashSmall.DashSmall, null));
}

},{"d147c0e58e9f9dbd":"iHubQ","b42586f1ea461dd0":"8nw8U","eec9c8f5401b2824":"k7wem","846a8cba6c97b3d5":"9yzVZ"}],"8nw8U":[function(require,module,exports) {
/**
* @adobe/react-spectrum-ui (c) by Adobe
* 
* @adobe/react-spectrum-ui is licensed under a
* Creative Commons Attribution-NoDerivatives 4.0 International License.
* 
* You should have received a copy of the license along with this
* work. If not, see <http://creativecommons.org/licenses/by-nd/4.0/>.
**/ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DashSmall = DashSmall;
var _react = _interopRequireDefault(require("4362c8292d0cd92"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function DashSmall(_ref) {
    var _ref$scale = _ref.scale, scale = _ref$scale === void 0 ? "M" : _ref$scale, props = _objectWithoutProperties(_ref, [
        "scale"
    ]);
    return _react["default"].createElement("svg", _extends({}, props, props), scale === "L" && _react["default"].createElement("path", {
        d: "M10.99 5H1.01a1 1 0 0 0 0 2h9.98a1 1 0 1 0 0-2z"
    }), scale === "M" && _react["default"].createElement("path", {
        d: "M8 4H2a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2z"
    }));
}
DashSmall.displayName = "DashSmall";

},{"4362c8292d0cd92":"9yzVZ"}],"847rj":[function(require,module,exports) {
module.exports["focus-ring"] = `ISsn1a_focus-ring`;
module.exports["i18nFontFamily"] = `ISsn1a_i18nFontFamily`;
module.exports["is-checked"] = `ISsn1a_is-checked`;
module.exports["is-disabled"] = `ISsn1a_is-disabled`;
module.exports["is-hovered"] = `ISsn1a_is-hovered`;
module.exports["is-indeterminate"] = `ISsn1a_is-indeterminate`;
module.exports["is-invalid"] = `ISsn1a_is-invalid`;
module.exports["spectrum-Checkbox"] = `ISsn1a_spectrum-Checkbox`;
module.exports["spectrum-Checkbox--quiet"] = `ISsn1a_spectrum-Checkbox--quiet`;
module.exports["spectrum-Checkbox-box"] = `ISsn1a_spectrum-Checkbox-box`;
module.exports["spectrum-Checkbox-checkmark"] = `ISsn1a_spectrum-Checkbox-checkmark`;
module.exports["spectrum-Checkbox-input"] = `ISsn1a_spectrum-Checkbox-input`;
module.exports["spectrum-Checkbox-label"] = `ISsn1a_spectrum-Checkbox-label`;
module.exports["spectrum-Checkbox-partialCheckmark"] = `ISsn1a_spectrum-Checkbox-partialCheckmark`;
module.exports["spectrum-FocusRing-ring"] = `ISsn1a_spectrum-FocusRing-ring`;
module.exports["spectrum-FocusRing"] = `ISsn1a_spectrum-FocusRing ${module.exports["spectrum-FocusRing-ring"]}`;
module.exports["spectrum-FocusRing--quiet"] = `ISsn1a_spectrum-FocusRing--quiet`;

},{}],"bGDqA":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /// <reference types="css-module-types" />
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useFormProps", ()=>(0, _form.useFormProps));
parcelHelpers.export(exports, "Form", ()=>(0, _form.Form));
var _form = require("./Form");

},{"./Form":"lt5np","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"lt5np":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useFormProps", ()=>useFormProps);
parcelHelpers.export(exports, "Form", ()=>_Form);
var _utils = require("@react-spectrum/utils");
var _utils1 = require("@react-aria/utils");
var _form = require("@react-stately/form");
var _provider = require("@react-spectrum/provider");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _varsCss = require("@adobe/spectrum-css-temp/components/fieldlabel/vars.css");
var _varsCssDefault = parcelHelpers.interopDefault(_varsCss);
let FormContext = /*#__PURE__*/ (0, _reactDefault.default).createContext(null);
function useFormProps(props) {
    let ctx = (0, _react.useContext)(FormContext);
    if (ctx) return {
        ...ctx,
        ...props
    };
    return props;
}
const formPropNames = new Set([
    "action",
    "autoComplete",
    "encType",
    "method",
    "target",
    "onSubmit",
    "onReset",
    "onInvalid"
]);
function Form(props, ref) {
    props = (0, _provider.useProviderProps)(props);
    let { children, labelPosition = "top", labelAlign = "start", isRequired, necessityIndicator, isQuiet, isEmphasized, isDisabled, isReadOnly, validationState, validationBehavior, validationErrors, ...otherProps } = props;
    let { styleProps } = (0, _utils.useStyleProps)(otherProps);
    let domRef = (0, _utils.useDOMRef)(ref);
    let ctx = {
        labelPosition,
        labelAlign,
        necessityIndicator,
        validationBehavior
    };
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("form", {
        ...(0, _utils1.filterDOMProps)(otherProps, {
            labelable: true,
            propNames: formPropNames
        }),
        ...styleProps,
        noValidate: validationBehavior !== "native",
        ref: domRef,
        className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Form", {
            "spectrum-Form--positionSide": labelPosition === "side",
            "spectrum-Form--positionTop": labelPosition === "top"
        }, styleProps.className)
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(FormContext.Provider, {
        value: ctx
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _provider.Provider), {
        isQuiet: isQuiet,
        isEmphasized: isEmphasized,
        isDisabled: isDisabled,
        isReadOnly: isReadOnly,
        isRequired: isRequired,
        validationState: validationState
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _form.FormValidationContext).Provider, {
        value: validationErrors || {}
    }, children))));
}
/**
 * Forms allow users to enter data that can be submitted while providing alignment and styling for form fields.
 */ const _Form = /*#__PURE__*/ (0, _reactDefault.default).forwardRef(Form);

},{"@react-spectrum/utils":"cMIJ6","@react-aria/utils":"9cLk5","@react-stately/form":"9yZqm","@react-spectrum/provider":"5bCdp","react":"9yzVZ","@adobe/spectrum-css-temp/components/fieldlabel/vars.css":"cEUOQ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"cEUOQ":[function(require,module,exports) {
module.exports["contextualHelp"] = `A-HlBa_contextualHelp`;
module.exports["field"] = `A-HlBa_field`;
module.exports["focus-ring"] = `A-HlBa_focus-ring`;
module.exports["helpText"] = `A-HlBa_helpText`;
module.exports["i18nFontFamily"] = `A-HlBa_i18nFontFamily`;
module.exports["is-disabled"] = `A-HlBa_is-disabled`;
module.exports["label"] = `A-HlBa_label`;
module.exports["spectrum-Field"] = `A-HlBa_spectrum-Field`;
module.exports["spectrum-Field--alignEnd"] = `A-HlBa_spectrum-Field--alignEnd`;
module.exports["spectrum-Field--hasContextualHelp"] = `A-HlBa_spectrum-Field--hasContextualHelp`;
module.exports["spectrum-Field--positionSide"] = `A-HlBa_spectrum-Field--positionSide`;
module.exports["spectrum-Field--positionTop"] = `A-HlBa_spectrum-Field--positionTop`;
module.exports["spectrum-Field-contextualHelp"] = `A-HlBa_spectrum-Field-contextualHelp`;
module.exports["spectrum-Field-field"] = `A-HlBa_spectrum-Field-field`;
module.exports["spectrum-Field-labelCell"] = `A-HlBa_spectrum-Field-labelCell`;
module.exports["spectrum-Field-labelWrapper"] = `A-HlBa_spectrum-Field-labelWrapper`;
module.exports["spectrum-Field-wrapper"] = `A-HlBa_spectrum-Field-wrapper`;
module.exports["spectrum-FieldLabel"] = `A-HlBa_spectrum-FieldLabel`;
module.exports["spectrum-FieldLabel--alignEnd"] = `A-HlBa_spectrum-FieldLabel--alignEnd`;
module.exports["spectrum-FieldLabel--positionSide"] = `A-HlBa_spectrum-FieldLabel--positionSide`;
module.exports["spectrum-FieldLabel-requiredIcon"] = `A-HlBa_spectrum-FieldLabel-requiredIcon`;
module.exports["spectrum-FocusRing-ring"] = `A-HlBa_spectrum-FocusRing-ring`;
module.exports["spectrum-FocusRing"] = `A-HlBa_spectrum-FocusRing ${module.exports["spectrum-FocusRing-ring"]}`;
module.exports["spectrum-FocusRing--quiet"] = `A-HlBa_spectrum-FocusRing--quiet`;
module.exports["spectrum-Form"] = `A-HlBa_spectrum-Form`;
module.exports["spectrum-Form--positionSide"] = `A-HlBa_spectrum-Form--positionSide`;
module.exports["spectrum-Form--positionTop"] = `A-HlBa_spectrum-Form--positionTop`;
module.exports["spectrum-Form-itemLabel"] = `A-HlBa_spectrum-Form-itemLabel`;
module.exports["spectrum-LabeledValue"] = `A-HlBa_spectrum-LabeledValue`;

},{}],"284xh":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CheckboxGroup", ()=>_CheckboxGroup);
var _context = require("./context");
var _utils = require("@react-spectrum/utils");
var _label = require("@react-spectrum/label");
var _provider = require("@react-spectrum/provider");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _varsCss = require("@adobe/spectrum-css-temp/components/fieldgroup/vars.css");
var _varsCssDefault = parcelHelpers.interopDefault(_varsCss);
var _checkbox = require("@react-aria/checkbox");
var _checkbox1 = require("@react-stately/checkbox");
var _form = require("@react-spectrum/form");
function CheckboxGroup(props, ref) {
    props = (0, _provider.useProviderProps)(props);
    props = (0, _form.useFormProps)(props);
    let { isEmphasized, children, orientation = "vertical" } = props;
    let domRef = (0, _utils.useDOMRef)(ref);
    let state = (0, _checkbox1.useCheckboxGroupState)(props);
    let { groupProps, ...otherProps } = (0, _checkbox.useCheckboxGroup)(props, state);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _label.Field), {
        ...props,
        ...otherProps,
        ref: domRef,
        wrapperClassName: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-FieldGroup"),
        elementType: "span",
        includeNecessityIndicatorInAccessibilityName: true
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...groupProps,
        className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-FieldGroup-group", {
            "spectrum-FieldGroup-group--horizontal": orientation === "horizontal"
        })
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _provider.Provider), {
        isEmphasized: isEmphasized
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _context.CheckboxGroupContext).Provider, {
        value: state
    }, children))));
}
/**
 * A CheckboxGroup allows users to select one or more items from a list of choices.
 */ const _CheckboxGroup = /*#__PURE__*/ (0, _reactDefault.default).forwardRef(CheckboxGroup);

},{"./context":"dgF9P","@react-spectrum/utils":"cMIJ6","@react-spectrum/label":"6qv6N","@react-spectrum/provider":"5bCdp","react":"9yzVZ","@adobe/spectrum-css-temp/components/fieldgroup/vars.css":"ly32V","@react-aria/checkbox":"5e6Tk","@react-stately/checkbox":"2A2GG","@react-spectrum/form":"bGDqA","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"6qv6N":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /// <reference types="css-module-types" />
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Field", ()=>(0, _field.Field));
parcelHelpers.export(exports, "Label", ()=>(0, _label.Label));
parcelHelpers.export(exports, "HelpText", ()=>(0, _helpText.HelpText));
var _field = require("./Field");
var _label = require("./Label");
var _helpText = require("./HelpText");

},{"./Field":"icbdj","./Label":"jHTbK","./HelpText":"enhBD","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"icbdj":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Field", ()=>_Field);
var _utils = require("@react-spectrum/utils");
var _layout = require("@react-spectrum/layout");
var _helpText = require("./HelpText");
var _label = require("./Label");
var _varsCss = require("@adobe/spectrum-css-temp/components/fieldlabel/vars.css");
var _varsCssDefault = parcelHelpers.interopDefault(_varsCss);
var _utils1 = require("@react-aria/utils");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _form = require("@react-spectrum/form");
function Field(props, ref) {
    let formProps = (0, _form.useFormProps)(props);
    let isInForm = formProps !== props;
    props = formProps;
    let { label, labelPosition = "top", labelAlign, isRequired, necessityIndicator, includeNecessityIndicatorInAccessibilityName, validationState, isInvalid, description, errorMessage = (e)=>e.validationErrors.join(" "), validationErrors, validationDetails, isDisabled, showErrorIcon, contextualHelp, children, labelProps = {}, // Not every component that uses <Field> supports help text.
    descriptionProps = {}, errorMessageProps = {}, elementType, wrapperClassName, wrapperProps = {}, ...otherProps } = props;
    let { styleProps } = (0, _utils.useStyleProps)(otherProps);
    let errorMessageString = null;
    if (typeof errorMessage === "function") errorMessageString = isInvalid != null && validationErrors != null && validationDetails != null ? errorMessage({
        isInvalid,
        validationErrors,
        validationDetails
    }) : null;
    else errorMessageString = errorMessage;
    let hasHelpText = !!description || errorMessageString && (isInvalid || validationState === "invalid");
    let contextualHelpId = (0, _utils1.useId)();
    let fallbackLabelPropsId = (0, _utils1.useId)();
    if (label && contextualHelp && !labelProps.id) labelProps.id = fallbackLabelPropsId;
    let labelWrapperClass = (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Field", {
        "spectrum-Field--positionTop": labelPosition === "top",
        "spectrum-Field--positionSide": labelPosition === "side",
        "spectrum-Field--alignEnd": labelAlign === "end",
        "spectrum-Field--hasContextualHelp": !!props.contextualHelp
    }, styleProps.className, wrapperClassName);
    children = /*#__PURE__*/ (0, _reactDefault.default).cloneElement(children, (0, _utils1.mergeProps)(children.props, {
        className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Field-field")
    }));
    let renderHelpText = ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _helpText.HelpText), {
            descriptionProps: descriptionProps,
            errorMessageProps: errorMessageProps,
            description: description,
            errorMessage: errorMessageString,
            validationState: validationState,
            isInvalid: isInvalid,
            isDisabled: isDisabled,
            showErrorIcon: showErrorIcon,
            gridArea: (0, _varsCssDefault.default).helpText
        });
    let renderChildren = ()=>{
        if (labelPosition === "side") return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
            direction: "column",
            UNSAFE_className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Field-wrapper")
        }, children, hasHelpText && renderHelpText());
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, children, hasHelpText && renderHelpText());
    };
    let labelAndContextualHelp = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, label && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _label.Label), {
        ...labelProps,
        labelPosition: labelPosition,
        labelAlign: labelAlign,
        isRequired: isRequired,
        necessityIndicator: necessityIndicator,
        includeNecessityIndicatorInAccessibilityName: includeNecessityIndicatorInAccessibilityName,
        elementType: elementType
    }, label), label && contextualHelp && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.SlotProvider), {
        slots: {
            actionButton: {
                UNSAFE_className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Field-contextualHelp"),
                id: contextualHelpId,
                "aria-labelledby": (labelProps === null || labelProps === void 0 ? void 0 : labelProps.id) ? `${labelProps.id} ${contextualHelpId}` : undefined
            }
        }
    }, contextualHelp));
    // Need to add an extra wrapper for the label and contextual help if labelPosition is side,
    // so that the table layout works inside forms.
    if (isInForm && labelPosition === "side" && label && contextualHelp) labelAndContextualHelp = /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Field-labelCell")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Field-labelWrapper")
    }, labelAndContextualHelp));
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...styleProps,
        ...wrapperProps,
        ref: ref,
        className: labelWrapperClass
    }, labelAndContextualHelp, renderChildren());
}
let _Field = /*#__PURE__*/ (0, _reactDefault.default).forwardRef(Field);

},{"@react-spectrum/utils":"cMIJ6","@react-spectrum/layout":"hzaUY","./HelpText":"enhBD","./Label":"jHTbK","@adobe/spectrum-css-temp/components/fieldlabel/vars.css":"cEUOQ","@react-aria/utils":"9cLk5","react":"9yzVZ","@react-spectrum/form":"bGDqA","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"enhBD":[function(require,module,exports) {
/*
 * Copyright 2021 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HelpText", ()=>_HelpText);
var _alertMedium = require("@spectrum-icons/ui/AlertMedium");
var _alertMediumDefault = parcelHelpers.interopDefault(_alertMedium);
var _utils = require("@react-spectrum/utils");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _varsCss = require("@adobe/spectrum-css-temp/components/helptext/vars.css");
var _varsCssDefault = parcelHelpers.interopDefault(_varsCss);
function HelpText(props, ref) {
    let { description, errorMessage, validationState, isInvalid, isDisabled, showErrorIcon, descriptionProps, errorMessageProps } = props;
    let domRef = (0, _utils.useDOMRef)(ref);
    let isErrorMessage = errorMessage && (isInvalid || validationState === "invalid");
    let { styleProps } = (0, _utils.useStyleProps)(props);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...styleProps,
        className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-HelpText", `spectrum-HelpText--${isErrorMessage ? "negative" : "neutral"}`, {
            "is-disabled": isDisabled
        }, styleProps.className),
        ref: domRef
    }, isErrorMessage ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, showErrorIcon && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _alertMediumDefault.default), {
        UNSAFE_className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-HelpText-validationIcon")
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...errorMessageProps,
        className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-HelpText-text")
    }, errorMessage)) : /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...descriptionProps,
        className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-HelpText-text")
    }, description));
}
/**
 * Help text provides either an informative description or an error message that gives more context about what a user needs to input. It's commonly used in forms.
 */ const _HelpText = /*#__PURE__*/ (0, _reactDefault.default).forwardRef(HelpText);

},{"@spectrum-icons/ui/AlertMedium":"2v5QX","@react-spectrum/utils":"cMIJ6","react":"9yzVZ","@adobe/spectrum-css-temp/components/helptext/vars.css":"eWXJ2","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"eWXJ2":[function(require,module,exports) {
module.exports["focus-ring"] = `a1Qy2q_focus-ring`;
module.exports["i18nFontFamily"] = `a1Qy2q_i18nFontFamily`;
module.exports["is-disabled"] = `a1Qy2q_is-disabled`;
module.exports["spectrum-FocusRing-ring"] = `a1Qy2q_spectrum-FocusRing-ring`;
module.exports["spectrum-FocusRing"] = `a1Qy2q_spectrum-FocusRing ${module.exports["spectrum-FocusRing-ring"]}`;
module.exports["spectrum-FocusRing--quiet"] = `a1Qy2q_spectrum-FocusRing--quiet`;
module.exports["spectrum-HelpText"] = `a1Qy2q_spectrum-HelpText`;
module.exports["spectrum-HelpText--negative"] = `a1Qy2q_spectrum-HelpText--negative`;
module.exports["spectrum-HelpText--neutral"] = `a1Qy2q_spectrum-HelpText--neutral`;
module.exports["spectrum-HelpText-text"] = `a1Qy2q_spectrum-HelpText-text`;
module.exports["spectrum-HelpText-validationIcon"] = `a1Qy2q_spectrum-HelpText-validationIcon`;

},{}],"jHTbK":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Label", ()=>_Label);
var _asterisk = require("@spectrum-icons/ui/Asterisk");
var _asteriskDefault = parcelHelpers.interopDefault(_asterisk);
var _utils = require("@react-spectrum/utils");
var _utils1 = require("@react-aria/utils");
// @ts-ignore
var _json = require("../intl/*.json");
var _jsonDefault = parcelHelpers.interopDefault(_json);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _varsCss = require("@adobe/spectrum-css-temp/components/fieldlabel/vars.css");
var _varsCssDefault = parcelHelpers.interopDefault(_varsCss);
var _i18N = require("@react-aria/i18n");
var _provider = require("@react-spectrum/provider");
function Label(props, ref) {
    props = (0, _provider.useProviderProps)(props);
    let { children, labelPosition = "top", labelAlign = labelPosition === "side" ? "start" : null, isRequired, necessityIndicator = isRequired != null ? "icon" : null, includeNecessityIndicatorInAccessibilityName = false, htmlFor, for: labelFor, elementType: ElementType = "label", onClick, ...otherProps } = props;
    let domRef = (0, _utils.useDOMRef)(ref);
    let { styleProps } = (0, _utils.useStyleProps)(otherProps);
    let stringFormatter = (0, _i18N.useLocalizedStringFormatter)((0, _jsonDefault.default), "@react-spectrum/label");
    let necessityLabel = isRequired ? stringFormatter.format("(required)") : stringFormatter.format("(optional)");
    let icon = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _asteriskDefault.default), {
        UNSAFE_className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-FieldLabel-requiredIcon"),
        "aria-label": includeNecessityIndicatorInAccessibilityName ? stringFormatter.format("(required)") : undefined
    });
    let labelClassNames = (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-FieldLabel", {
        "spectrum-FieldLabel--positionSide": labelPosition === "side",
        "spectrum-FieldLabel--alignEnd": labelAlign === "end"
    }, styleProps.className);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(ElementType, {
        ...(0, _utils1.filterDOMProps)(otherProps),
        ...styleProps,
        onClick: onClick,
        ref: domRef,
        className: labelClassNames,
        htmlFor: ElementType === "label" ? labelFor || htmlFor : undefined
    }, children, (necessityIndicator === "label" || necessityIndicator === "icon" && isRequired) && " \u200B", necessityIndicator === "label" && /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        "aria-hidden": !includeNecessityIndicatorInAccessibilityName ? isRequired : undefined
    }, necessityLabel), necessityIndicator === "icon" && isRequired && icon);
}
let _Label = /*#__PURE__*/ (0, _reactDefault.default).forwardRef(Label);

},{"@spectrum-icons/ui/Asterisk":"1yO9Q","@react-spectrum/utils":"cMIJ6","@react-aria/utils":"9cLk5","../intl/*.json":"azEgc","react":"9yzVZ","@adobe/spectrum-css-temp/components/fieldlabel/vars.css":"cEUOQ","@react-aria/i18n":"411rg","@react-spectrum/provider":"5bCdp","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"1yO9Q":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("7ffcbe2c835b6388");
exports.__esModule = true;
exports.default = Asterisk;
var _Asterisk = require("7f1df2bc34aa26e1");
var _icon = require("7062d8415074095c");
var _react = _interopRequireDefault(require("6bea687caf317384"));
function Asterisk(props) {
    return /*#__PURE__*/ _react.default.createElement(_icon.UIIcon, props, /*#__PURE__*/ _react.default.createElement(_Asterisk.Asterisk, null));
}

},{"7ffcbe2c835b6388":"iHubQ","7f1df2bc34aa26e1":"6bY8S","7062d8415074095c":"k7wem","6bea687caf317384":"9yzVZ"}],"6bY8S":[function(require,module,exports) {
/**
* @adobe/react-spectrum-ui (c) by Adobe
* 
* @adobe/react-spectrum-ui is licensed under a
* Creative Commons Attribution-NoDerivatives 4.0 International License.
* 
* You should have received a copy of the license along with this
* work. If not, see <http://creativecommons.org/licenses/by-nd/4.0/>.
**/ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Asterisk = Asterisk;
var _react = _interopRequireDefault(require("661a767f8fb5a4d4"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function Asterisk(_ref) {
    var _ref$scale = _ref.scale, scale = _ref$scale === void 0 ? "M" : _ref$scale, props = _objectWithoutProperties(_ref, [
        "scale"
    ]);
    return _react["default"].createElement("svg", _extends({}, props, props), scale === "L" && _react["default"].createElement("path", {
        d: "M7.867 7.872c.061.062.103.145 0 .228l-1.283.827c-.104.061-.145.02-.186-.083L4.804 6.07l-2.09 2.297c-.021.042-.083.083-.145 0l-.994-1.035c-.103-.062-.082-.124 0-.186l2.36-1.966-2.691-1.014c-.042 0-.104-.083-.062-.186l.703-1.41a.11.11 0 0 1 .187-.04L4.43 4.06l.145-3.02A.109.109 0 0 1 4.7.917l1.718.227c.104 0 .124.042.104.145l-.808 2.96 2.734-.828c.061-.042.124-.042.165.082l.27 1.532c.02.103 0 .145-.084.145l-2.856.227z"
    }), scale === "M" && _react["default"].createElement("path", {
        d: "M6.573 6.558c.056.055.092.13 0 .204l-1.148.74c-.093.056-.13.02-.167-.073L3.832 4.947l-1.87 2.055c-.02.037-.075.074-.13 0l-.889-.926c-.092-.055-.074-.111 0-.167l2.111-1.76-2.408-.906c-.037 0-.092-.074-.055-.167l.63-1.259a.097.097 0 0 1 .166-.036l2.111 1.37.13-2.704a.097.097 0 0 1 .111-.11L5.277.54c.092 0 .11.037.092.13l-.722 2.647 2.444-.74c.056-.038.111-.038.148.073l.241 1.37c.019.093 0 .13-.074.13l-2.556.204z"
    }));
}
Asterisk.displayName = "Asterisk";

},{"661a767f8fb5a4d4":"9yzVZ"}],"azEgc":[function(require,module,exports) {
const _temp0 = require("2bfb4d497771281d");
const _temp1 = require("9fe31fc8b821e915");
const _temp2 = require("be1d593fe675cb5e");
const _temp3 = require("ea132c82fcce344b");
const _temp4 = require("223d6e8df067052d");
const _temp5 = require("618b3a44d402b39d");
const _temp6 = require("631dc76ccef81f62");
const _temp7 = require("ac16f0833e9fb325");
const _temp8 = require("1d030b7551e06d7e");
const _temp9 = require("3ee3310ab1344642");
const _temp10 = require("6def8779041b5a4");
const _temp11 = require("71e0468396c6340e");
const _temp12 = require("268ec23f8cb0b2bb");
const _temp13 = require("9139206aa6189511");
const _temp14 = require("3cc45d1915e24e9f");
const _temp15 = require("11c02c803513cef2");
const _temp16 = require("bb56caddd698ca25");
const _temp17 = require("9549474a3dc7f5ea");
const _temp18 = require("73475cc06fa04f65");
const _temp19 = require("7db1a097996f468c");
const _temp20 = require("40540c2453f98dcb");
const _temp21 = require("f26de163f08e8b8e");
const _temp22 = require("be0378ba9d612dc9");
const _temp23 = require("f5b8791453a91c8d");
const _temp24 = require("680d80cf800efd5d");
const _temp25 = require("373e5a9aae7e5fb7");
const _temp26 = require("80ddd443cc947960");
const _temp27 = require("323c8b6cbcef675b");
const _temp28 = require("2b6d134d5b4c3031");
const _temp29 = require("8dafa196ef9a1129");
const _temp30 = require("d7f4588a3c514984");
const _temp31 = require("67c9418c63cd65e9");
const _temp32 = require("9fbef7c353909f63");
const _temp33 = require("88a3c5faa299eb0e");
module.exports = {
    "ar-AE": _temp0,
    "bg-BG": _temp1,
    "cs-CZ": _temp2,
    "da-DK": _temp3,
    "de-DE": _temp4,
    "el-GR": _temp5,
    "en-US": _temp6,
    "es-ES": _temp7,
    "et-EE": _temp8,
    "fi-FI": _temp9,
    "fr-FR": _temp10,
    "he-IL": _temp11,
    "hr-HR": _temp12,
    "hu-HU": _temp13,
    "it-IT": _temp14,
    "ja-JP": _temp15,
    "ko-KR": _temp16,
    "lt-LT": _temp17,
    "lv-LV": _temp18,
    "nb-NO": _temp19,
    "nl-NL": _temp20,
    "pl-PL": _temp21,
    "pt-BR": _temp22,
    "pt-PT": _temp23,
    "ro-RO": _temp24,
    "ru-RU": _temp25,
    "sk-SK": _temp26,
    "sl-SI": _temp27,
    "sr-SP": _temp28,
    "sv-SE": _temp29,
    "tr-TR": _temp30,
    "uk-UA": _temp31,
    "zh-CN": _temp32,
    "zh-TW": _temp33
};

},{"2bfb4d497771281d":"exZc2","9fe31fc8b821e915":"3voyY","be1d593fe675cb5e":"czjLx","ea132c82fcce344b":"6gfbo","223d6e8df067052d":"ikXqa","618b3a44d402b39d":"7UTgj","631dc76ccef81f62":"6syQf","ac16f0833e9fb325":"04E3I","1d030b7551e06d7e":"8QMHk","3ee3310ab1344642":"hqoYs","6def8779041b5a4":"edIHs","71e0468396c6340e":"4uQyC","268ec23f8cb0b2bb":"8kv1K","9139206aa6189511":"eNfuL","3cc45d1915e24e9f":"cwltV","11c02c803513cef2":"kYBB5","bb56caddd698ca25":"kBYzw","9549474a3dc7f5ea":"kHHFL","73475cc06fa04f65":"2NkIr","7db1a097996f468c":"8MTvJ","40540c2453f98dcb":"k6Ica","f26de163f08e8b8e":"eB3Zo","be0378ba9d612dc9":"4uSzK","f5b8791453a91c8d":"dOJZC","680d80cf800efd5d":"b68U4","373e5a9aae7e5fb7":"611ma","80ddd443cc947960":"jLKbi","323c8b6cbcef675b":"iV9CG","2b6d134d5b4c3031":"hCafs","8dafa196ef9a1129":"cYDhI","d7f4588a3c514984":"hgcm9","67c9418c63cd65e9":"kATG9","9fbef7c353909f63":"2ThyW","88a3c5faa299eb0e":"i9skn"}],"exZc2":[function(require,module,exports) {
module.exports = {
    "(optional)": `(\u{627}\u{62E}\u{62A}\u{64A}\u{627}\u{631}\u{64A})`,
    "(required)": `(\u{645}\u{637}\u{644}\u{648}\u{628})`
};

},{}],"3voyY":[function(require,module,exports) {
module.exports = {
    "(optional)": `(\u{43D}\u{435}\u{437}\u{430}\u{434}\u{44A}\u{43B}\u{436}\u{438}\u{442}\u{435}\u{43B}\u{43D}\u{43E})`,
    "(required)": `(\u{437}\u{430}\u{434}\u{44A}\u{43B}\u{436}\u{438}\u{442}\u{435}\u{43B}\u{43D}\u{43E})`
};

},{}],"czjLx":[function(require,module,exports) {
module.exports = {
    "(optional)": `(voliteln\u{11B})`,
    "(required)": `(po\u{17E}adov\xe1no)`
};

},{}],"6gfbo":[function(require,module,exports) {
module.exports = {
    "(optional)": `(valgfrit)`,
    "(required)": `(obligatorisk)`
};

},{}],"ikXqa":[function(require,module,exports) {
module.exports = {
    "(optional)": `(optional)`,
    "(required)": `(erforderlich)`
};

},{}],"7UTgj":[function(require,module,exports) {
module.exports = {
    "(optional)": `(\u{3C0}\u{3C1}\u{3BF}\u{3B1}\u{3B9}\u{3C1}\u{3B5}\u{3C4}\u{3B9}\u{3BA}\u{3CC})`,
    "(required)": `(\u{3B1}\u{3C0}\u{3B1}\u{3B9}\u{3C4}\u{3B5}\u{3AF}\u{3C4}\u{3B1}\u{3B9})`
};

},{}],"6syQf":[function(require,module,exports) {
module.exports = {
    "(required)": `(required)`,
    "(optional)": `(optional)`
};

},{}],"04E3I":[function(require,module,exports) {
module.exports = {
    "(optional)": `(opcional)`,
    "(required)": `(obligatorio)`
};

},{}],"8QMHk":[function(require,module,exports) {
module.exports = {
    "(optional)": `(valikuline)`,
    "(required)": `(n\xf5utav)`
};

},{}],"hqoYs":[function(require,module,exports) {
module.exports = {
    "(optional)": `(valinnainen)`,
    "(required)": `(pakollinen)`
};

},{}],"edIHs":[function(require,module,exports) {
module.exports = {
    "(optional)": `(facultatif)`,
    "(required)": `(requis)`
};

},{}],"4uQyC":[function(require,module,exports) {
module.exports = {
    "(optional)": `(\u{5D0}\u{5D5}\u{5E4}\u{5E6}\u{5D9}\u{5D5}\u{5E0}\u{5DC}\u{5D9})`,
    "(required)": `(\u{5E0}\u{5D3}\u{5E8}\u{5E9})`
};

},{}],"8kv1K":[function(require,module,exports) {
module.exports = {
    "(optional)": `(opcionalno)`,
    "(required)": `(obvezno)`
};

},{}],"eNfuL":[function(require,module,exports) {
module.exports = {
    "(optional)": `(opcion\xe1lis)`,
    "(required)": `(k\xf6telez\u{151})`
};

},{}],"cwltV":[function(require,module,exports) {
module.exports = {
    "(optional)": `(facoltativo)`,
    "(required)": `(obbligatorio)`
};

},{}],"kYBB5":[function(require,module,exports) {
module.exports = {
    "(optional)": `\u{FF08}\u{30AA}\u{30D7}\u{30B7}\u{30E7}\u{30F3}\u{FF09}`,
    "(required)": `\u{FF08}\u{5FC5}\u{9808}\u{FF09}`
};

},{}],"kBYzw":[function(require,module,exports) {
module.exports = {
    "(optional)": `(\u{C120}\u{D0DD} \u{C0AC}\u{D56D})`,
    "(required)": `(\u{D544}\u{C218} \u{C0AC}\u{D56D})`
};

},{}],"kHHFL":[function(require,module,exports) {
module.exports = {
    "(optional)": `(pasirenkama)`,
    "(required)": `(privaloma)`
};

},{}],"2NkIr":[function(require,module,exports) {
module.exports = {
    "(optional)": `(neoblig\u{101}ti)`,
    "(required)": `(oblig\u{101}ti)`
};

},{}],"8MTvJ":[function(require,module,exports) {
module.exports = {
    "(optional)": `(valgfritt)`,
    "(required)": `(obligatorisk)`
};

},{}],"k6Ica":[function(require,module,exports) {
module.exports = {
    "(optional)": `(optioneel)`,
    "(required)": `(vereist)`
};

},{}],"eB3Zo":[function(require,module,exports) {
module.exports = {
    "(optional)": `(opcjonalne)`,
    "(required)": `(wymagane)`
};

},{}],"4uSzK":[function(require,module,exports) {
module.exports = {
    "(optional)": `(opcional)`,
    "(required)": `(obrigat\xf3rio)`
};

},{}],"dOJZC":[function(require,module,exports) {
module.exports = {
    "(optional)": `(opcional)`,
    "(required)": `(obrigat\xf3rio)`
};

},{}],"b68U4":[function(require,module,exports) {
module.exports = {
    "(optional)": `(op\u{163}ional)`,
    "(required)": `(obligatoriu)`
};

},{}],"611ma":[function(require,module,exports) {
module.exports = {
    "(optional)": `(\u{434}\u{43E}\u{43F}\u{43E}\u{43B}\u{43D}\u{438}\u{442}\u{435}\u{43B}\u{44C}\u{43D}\u{43E})`,
    "(required)": `(\u{43E}\u{431}\u{44F}\u{437}\u{430}\u{442}\u{435}\u{43B}\u{44C}\u{43D}\u{43E})`
};

},{}],"jLKbi":[function(require,module,exports) {
module.exports = {
    "(optional)": `(nepovinn\xe9)`,
    "(required)": `(povinn\xe9)`
};

},{}],"iV9CG":[function(require,module,exports) {
module.exports = {
    "(optional)": `(opcijsko)`,
    "(required)": `(obvezno)`
};

},{}],"hCafs":[function(require,module,exports) {
module.exports = {
    "(optional)": `(opciono)`,
    "(required)": `(obavezno)`
};

},{}],"cYDhI":[function(require,module,exports) {
module.exports = {
    "(optional)": `(valfritt)`,
    "(required)": `(kr\xe4vs)`
};

},{}],"hgcm9":[function(require,module,exports) {
module.exports = {
    "(optional)": `(iste\u{11F}e ba\u{11F}l\u{131})`,
    "(required)": `(gerekli)`
};

},{}],"kATG9":[function(require,module,exports) {
module.exports = {
    "(optional)": `(\u{43D}\u{435}\u{43E}\u{431}\u{43E}\u{432}\u{2019}\u{44F}\u{437}\u{43A}\u{43E}\u{432}\u{43E})`,
    "(required)": `(\u{43E}\u{431}\u{43E}\u{432}\u{2019}\u{44F}\u{437}\u{43A}\u{43E}\u{432}\u{43E})`
};

},{}],"2ThyW":[function(require,module,exports) {
module.exports = {
    "(optional)": `\u{FF08}\u{53EF}\u{9009}\u{FF09}`,
    "(required)": `\u{FF08}\u{5FC5}\u{586B}\u{FF09}`
};

},{}],"i9skn":[function(require,module,exports) {
module.exports = {
    "(optional)": `(\u{9078}\u{586B})`,
    "(required)": `(\u{5FC5}\u{586B})`
};

},{}],"ly32V":[function(require,module,exports) {
module.exports["focus-ring"] = `hyn22G_focus-ring`;
module.exports["i18nFontFamily"] = `hyn22G_i18nFontFamily`;
module.exports["spectrum-FieldGroup"] = `hyn22G_spectrum-FieldGroup`;
module.exports["spectrum-FieldGroup-group"] = `hyn22G_spectrum-FieldGroup-group`;
module.exports["spectrum-FieldGroup-group--horizontal"] = `hyn22G_spectrum-FieldGroup-group--horizontal`;
module.exports["spectrum-FocusRing-ring"] = `hyn22G_spectrum-FocusRing-ring`;
module.exports["spectrum-FocusRing"] = `hyn22G_spectrum-FocusRing ${module.exports["spectrum-FocusRing-ring"]}`;
module.exports["spectrum-FocusRing--quiet"] = `hyn22G_spectrum-FocusRing--quiet`;

},{}],"eZUPs":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("1faefabb9ef844fd");
exports.__esModule = true;
exports.default = ChevronLeftMedium;
var _ChevronLeftMedium = require("3a25ad57ff15c69c");
var _icon = require("8261842ce391f086");
var _react = _interopRequireDefault(require("afa28aa1ce9da833"));
function ChevronLeftMedium(props) {
    return /*#__PURE__*/ _react.default.createElement(_icon.UIIcon, props, /*#__PURE__*/ _react.default.createElement(_ChevronLeftMedium.ChevronLeftMedium, null));
}

},{"1faefabb9ef844fd":"iHubQ","3a25ad57ff15c69c":"e8VME","8261842ce391f086":"k7wem","afa28aa1ce9da833":"9yzVZ"}],"e8VME":[function(require,module,exports) {
/**
* @adobe/react-spectrum-ui (c) by Adobe
* 
* @adobe/react-spectrum-ui is licensed under a
* Creative Commons Attribution-NoDerivatives 4.0 International License.
* 
* You should have received a copy of the license along with this
* work. If not, see <http://creativecommons.org/licenses/by-nd/4.0/>.
**/ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ChevronLeftMedium = ChevronLeftMedium;
var _react = _interopRequireDefault(require("1b3c34a5b549daca"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function ChevronLeftMedium(_ref) {
    var _ref$scale = _ref.scale, scale = _ref$scale === void 0 ? "M" : _ref$scale, props = _objectWithoutProperties(_ref, [
        "scale"
    ]);
    return _react["default"].createElement("svg", _extends({}, props, props), scale === "L" && _react["default"].createElement("path", {
        d: "M7.197 10.283L2.914 6l4.283-4.283A1 1 0 1 0 5.783.303l-4.99 4.99a1 1 0 0 0 0 1.414l4.99 4.99a1 1 0 1 0 1.414-1.414z"
    }), scale === "M" && _react["default"].createElement("path", {
        d: "M5.697 8.283L2.414 5l3.283-3.283A1 1 0 1 0 4.283.303l-3.98 3.99a1 1 0 0 0 0 1.414l3.98 3.99a1 1 0 1 0 1.414-1.414z"
    }));
}
ChevronLeftMedium.displayName = "ChevronLeftMedium";

},{"1b3c34a5b549daca":"9yzVZ"}],"6amCu":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("3cc9384f17c3a592");
exports.__esModule = true;
exports.default = ChevronRightMedium;
var _ChevronRightMedium = require("c0321fddde647e8b");
var _icon = require("3cd7a27d910f2d7f");
var _react = _interopRequireDefault(require("cc1c8eda33cd174e"));
function ChevronRightMedium(props) {
    return /*#__PURE__*/ _react.default.createElement(_icon.UIIcon, props, /*#__PURE__*/ _react.default.createElement(_ChevronRightMedium.ChevronRightMedium, null));
}

},{"3cc9384f17c3a592":"iHubQ","c0321fddde647e8b":"i2e6h","3cd7a27d910f2d7f":"k7wem","cc1c8eda33cd174e":"9yzVZ"}],"i2e6h":[function(require,module,exports) {
/**
* @adobe/react-spectrum-ui (c) by Adobe
* 
* @adobe/react-spectrum-ui is licensed under a
* Creative Commons Attribution-NoDerivatives 4.0 International License.
* 
* You should have received a copy of the license along with this
* work. If not, see <http://creativecommons.org/licenses/by-nd/4.0/>.
**/ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ChevronRightMedium = ChevronRightMedium;
var _react = _interopRequireDefault(require("8884942f7149d760"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function ChevronRightMedium(_ref) {
    var _ref$scale = _ref.scale, scale = _ref$scale === void 0 ? "M" : _ref$scale, props = _objectWithoutProperties(_ref, [
        "scale"
    ]);
    return _react["default"].createElement("svg", _extends({}, props, props), scale === "L" && _react["default"].createElement("path", {
        d: "M7.5 6a.997.997 0 0 0-.293-.707L2.217.303A1 1 0 1 0 .803 1.717L5.086 6 .803 10.283a1 1 0 1 0 1.414 1.414l4.99-4.99A.997.997 0 0 0 7.5 6z"
    }), scale === "M" && _react["default"].createElement("path", {
        d: "M5.99 5a.997.997 0 0 0-.293-.707L1.717.303A1 1 0 1 0 .303 1.717L3.586 5 .303 8.283a1 1 0 1 0 1.414 1.414l3.98-3.99A.997.997 0 0 0 5.99 5z"
    }));
}
ChevronRightMedium.displayName = "ChevronRightMedium";

},{"8884942f7149d760":"9yzVZ"}],"8uraN":[function(require,module,exports) {
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InsertionIndicator", ()=>InsertionIndicator);
var _utils = require("@react-spectrum/utils");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _tableCss = require("./table.css");
var _tableCssDefault = parcelHelpers.interopDefault(_tableCss);
var _tableViewBase = require("./TableViewBase");
var _visuallyHidden = require("@react-aria/visually-hidden");
function InsertionIndicator(props) {
    let { dropState, dragAndDropHooks } = (0, _tableViewBase.useTableContext)();
    const { target, rowProps } = props;
    let ref = (0, _react.useRef)();
    let { dropIndicatorProps } = dragAndDropHooks.useDropIndicator(props, dropState, ref);
    let { visuallyHiddenProps } = (0, _visuallyHidden.useVisuallyHidden)();
    let isDropTarget = dropState.isDropTarget(target);
    if (!isDropTarget && dropIndicatorProps["aria-hidden"]) return null;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        style: {
            position: "absolute",
            top: rowProps.style.top + (target.dropPosition === "after" ? rowProps.style.height : 0),
            width: rowProps.style.width
        },
        role: "row",
        "aria-hidden": dropIndicatorProps["aria-hidden"]
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        role: "gridcell",
        className: (0, _utils.classNames)((0, _tableCssDefault.default), "react-spectrum-Table-InsertionIndicator", {
            "react-spectrum-Table-InsertionIndicator--dropTarget": isDropTarget
        })
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...visuallyHiddenProps,
        role: "button",
        ...dropIndicatorProps,
        ref: ref
    })));
}

},{"@react-spectrum/utils":"cMIJ6","react":"9yzVZ","./table.css":"5RNXu","./TableViewBase":"w8HhS","@react-aria/visually-hidden":"4jwxT","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"5RNXu":[function(require,module,exports) {
module.exports["focus-ring"] = `EfWbna_focus-ring`;
module.exports["react-spectrum-Table"] = `EfWbna_react-spectrum-Table`;
module.exports["react-spectrum-Table-InsertionIndicator"] = `EfWbna_react-spectrum-Table-InsertionIndicator`;
module.exports["react-spectrum-Table-InsertionIndicator--dropTarget"] = `EfWbna_react-spectrum-Table-InsertionIndicator--dropTarget`;
module.exports["react-spectrum-Table-body"] = `EfWbna_react-spectrum-Table-body`;
module.exports["react-spectrum-Table-body--dropTarget"] = `EfWbna_react-spectrum-Table-body--dropTarget`;
module.exports["react-spectrum-Table-cell"] = `EfWbna_react-spectrum-Table-cell`;
module.exports["react-spectrum-Table-cell--alignCenter"] = `EfWbna_react-spectrum-Table-cell--alignCenter`;
module.exports["react-spectrum-Table-cell--alignEnd"] = `EfWbna_react-spectrum-Table-cell--alignEnd`;
module.exports["react-spectrum-Table-cell--alignStart"] = `EfWbna_react-spectrum-Table-cell--alignStart`;
module.exports["react-spectrum-Table-cellWrapper"] = `EfWbna_react-spectrum-Table-cellWrapper`;
module.exports["react-spectrum-Table-cellWrapper--dropTarget"] = `EfWbna_react-spectrum-Table-cellWrapper--dropTarget`;
module.exports["react-spectrum-Table-centeredWrapper"] = `EfWbna_react-spectrum-Table-centeredWrapper`;
module.exports["react-spectrum-Table-dragButton"] = `EfWbna_react-spectrum-Table-dragButton`;
module.exports["react-spectrum-Table-dragButtonCell"] = `EfWbna_react-spectrum-Table-dragButtonCell`;
module.exports["react-spectrum-Table-dragButtonHeadCell"] = `EfWbna_react-spectrum-Table-dragButtonHeadCell`;
module.exports["react-spectrum-Table-headCell"] = `EfWbna_react-spectrum-Table-headCell`;
module.exports["react-spectrum-Table-row"] = `EfWbna_react-spectrum-Table-row`;
module.exports["react-spectrum-Table-row--dropTarget"] = `EfWbna_react-spectrum-Table-row--dropTarget`;
module.exports["react-spectrum-Table-row-badge"] = `EfWbna_react-spectrum-Table-row-badge`;
module.exports["react-spectrum-Table-row-dragPreview"] = `EfWbna_react-spectrum-Table-row-dragPreview`;
module.exports["react-spectrum-Table-row-dragPreview--multiple"] = `EfWbna_react-spectrum-Table-row-dragPreview--multiple`;

},{}],"5Wmph":[function(require,module,exports) {
const _temp0 = require("da9ba0213cb3f0bc");
const _temp1 = require("937e6ffd48e011b3");
const _temp2 = require("acf0f34652cabc3");
const _temp3 = require("43a0af869967e09b");
const _temp4 = require("1ed1fab79326a259");
const _temp5 = require("4a6d19f6e2357074");
const _temp6 = require("7527b21adad9facf");
const _temp7 = require("e21dcb5f0bf6bced");
const _temp8 = require("7ac792297b9aeb34");
const _temp9 = require("104a3981814bffa8");
const _temp10 = require("2878440a4642bed1");
const _temp11 = require("73014e08f2fc38e6");
const _temp12 = require("91c87cefe4dc8659");
const _temp13 = require("83852f5526602c81");
const _temp14 = require("2d021dada983ac0b");
const _temp15 = require("37ba2e35f689ec3d");
const _temp16 = require("c2a647bb9446e409");
const _temp17 = require("436ff374ba5758ea");
const _temp18 = require("fd3b45b8319a767a");
const _temp19 = require("da8acc16dade57fb");
const _temp20 = require("88cd7471e0f8ab31");
const _temp21 = require("2e5af3efe81afe6");
const _temp22 = require("b045221d74e71621");
const _temp23 = require("6d778c83408414aa");
const _temp24 = require("92ddc2659ed46f34");
const _temp25 = require("77f09d4bfc47177f");
const _temp26 = require("30edc57acf93e00e");
const _temp27 = require("a8383daf8004175f");
const _temp28 = require("f385b383b68a59e0");
const _temp29 = require("ad883b03c96afe68");
const _temp30 = require("e300e1c37e29555e");
const _temp31 = require("2d75896f3b5def5f");
const _temp32 = require("fbd7b0ac5b4131a7");
const _temp33 = require("a4a6968b0adde6f2");
module.exports = {
    "ar-AE": _temp0,
    "bg-BG": _temp1,
    "cs-CZ": _temp2,
    "da-DK": _temp3,
    "de-DE": _temp4,
    "el-GR": _temp5,
    "en-US": _temp6,
    "es-ES": _temp7,
    "et-EE": _temp8,
    "fi-FI": _temp9,
    "fr-FR": _temp10,
    "he-IL": _temp11,
    "hr-HR": _temp12,
    "hu-HU": _temp13,
    "it-IT": _temp14,
    "ja-JP": _temp15,
    "ko-KR": _temp16,
    "lt-LT": _temp17,
    "lv-LV": _temp18,
    "nb-NO": _temp19,
    "nl-NL": _temp20,
    "pl-PL": _temp21,
    "pt-BR": _temp22,
    "pt-PT": _temp23,
    "ro-RO": _temp24,
    "ru-RU": _temp25,
    "sk-SK": _temp26,
    "sl-SI": _temp27,
    "sr-SP": _temp28,
    "sv-SE": _temp29,
    "tr-TR": _temp30,
    "uk-UA": _temp31,
    "zh-CN": _temp32,
    "zh-TW": _temp33
};

},{"da9ba0213cb3f0bc":"EznP3","937e6ffd48e011b3":"9GEvd","acf0f34652cabc3":"avc2Y","43a0af869967e09b":"l6awS","1ed1fab79326a259":"asxxt","4a6d19f6e2357074":"iDEdj","7527b21adad9facf":"9cUuC","e21dcb5f0bf6bced":"87CK4","7ac792297b9aeb34":"dSYsU","104a3981814bffa8":"8wAQs","2878440a4642bed1":"2Isst","73014e08f2fc38e6":"k3TNb","91c87cefe4dc8659":"gNMvZ","83852f5526602c81":"k8ovy","2d021dada983ac0b":"2kAx4","37ba2e35f689ec3d":"4EoTP","c2a647bb9446e409":"ihP8Y","436ff374ba5758ea":"2Cb3q","fd3b45b8319a767a":"7Xgyt","da8acc16dade57fb":"7zv5P","88cd7471e0f8ab31":"762L2","2e5af3efe81afe6":"v57yB","b045221d74e71621":"eAqMr","6d778c83408414aa":"5JO7b","92ddc2659ed46f34":"hd1jo","77f09d4bfc47177f":"2IwbJ","30edc57acf93e00e":"2sQYG","a8383daf8004175f":"8noNq","f385b383b68a59e0":"4n9Nj","ad883b03c96afe68":"hG0r3","e300e1c37e29555e":"6hiyE","2d75896f3b5def5f":"hKKg0","fbd7b0ac5b4131a7":"286BB","a4a6968b0adde6f2":"d3QPZ"}],"EznP3":[function(require,module,exports) {
module.exports = {
    "collapse": `\u{637}\u{64A}`,
    "columnResizer": `\u{623}\u{62F}\u{627}\u{629} \u{62A}\u{63A}\u{64A}\u{64A}\u{631} \u{62D}\u{62C}\u{645} \u{627}\u{644}\u{639}\u{645}\u{648}\u{62F}`,
    "drag": `\u{633}\u{62D}\u{628}`,
    "expand": `\u{645}\u{62F}`,
    "loading": `\u{62C}\u{627}\u{631}\u{64D} \u{627}\u{644}\u{62A}\u{62D}\u{645}\u{64A}\u{644}...`,
    "loadingMore": `\u{62C}\u{627}\u{631}\u{64D} \u{62A}\u{62D}\u{645}\u{64A}\u{644} \u{627}\u{644}\u{645}\u{632}\u{64A}\u{62F}...`,
    "resizeColumn": `\u{62A}\u{63A}\u{64A}\u{64A}\u{631} \u{62D}\u{62C}\u{645} \u{627}\u{644}\u{639}\u{645}\u{648}\u{62F}`,
    "sortAscending": `\u{641}\u{631}\u{632} \u{628}\u{62A}\u{631}\u{62A}\u{64A}\u{628} \u{62A}\u{635}\u{627}\u{639}\u{62F}\u{64A}`,
    "sortDescending": `\u{641}\u{631}\u{632} \u{628}\u{62A}\u{631}\u{62A}\u{64A}\u{628} \u{62A}\u{646}\u{627}\u{632}\u{644}\u{64A}`
};

},{}],"9GEvd":[function(require,module,exports) {
module.exports = {
    "collapse": `\u{421}\u{432}\u{438}\u{432}\u{430}\u{43D}\u{435}`,
    "columnResizer": `\u{41F}\u{440}\u{435}\u{43E}\u{440}\u{430}\u{437}\u{43C}\u{435}\u{440}\u{44F}\u{432}\u{430}\u{43D}\u{435} \u{43D}\u{430} \u{43A}\u{43E}\u{43B}\u{43E}\u{43D}\u{438}`,
    "drag": `\u{41F}\u{43B}\u{44A}\u{437}\u{43D}\u{435}\u{442}\u{435}`,
    "expand": `\u{420}\u{430}\u{437}\u{448}\u{438}\u{440}\u{44F}\u{432}\u{430}\u{43D}\u{435}`,
    "loading": `\u{417}\u{430}\u{440}\u{435}\u{436}\u{434}\u{430}\u{43D}\u{435}...`,
    "loadingMore": `\u{417}\u{430}\u{440}\u{435}\u{436}\u{434}\u{430}\u{43D}\u{435} \u{43D}\u{430} \u{43E}\u{449}\u{435}...`,
    "resizeColumn": `\u{41F}\u{440}\u{435}\u{43E}\u{440}\u{430}\u{437}\u{43C}\u{435}\u{440}\u{44F}\u{432}\u{430}\u{43D}\u{435} \u{43D}\u{430} \u{43A}\u{43E}\u{43B}\u{43E}\u{43D}\u{430}`,
    "sortAscending": `\u{412}\u{44A}\u{437}\u{445}\u{43E}\u{434}\u{44F}\u{449}\u{43E} \u{441}\u{43E}\u{440}\u{442}\u{438}\u{440}\u{430}\u{43D}\u{435}`,
    "sortDescending": `\u{41D}\u{438}\u{437}\u{445}\u{43E}\u{434}\u{44F}\u{449}\u{43E} \u{441}\u{43E}\u{440}\u{442}\u{438}\u{440}\u{430}\u{43D}\u{435} `
};

},{}],"avc2Y":[function(require,module,exports) {
module.exports = {
    "collapse": `Zmen\u{161}it`,
    "columnResizer": `Zm\u{11B}na velikosti sloupce`,
    "drag": `P\u{159}et\xe1hnout`,
    "expand": `Rozt\xe1hnout`,
    "loading": `Na\u{10D}\xedt\xe1n\xed...`,
    "loadingMore": `Na\u{10D}\xedt\xe1n\xed dal\u{161}\xedch...`,
    "resizeColumn": `Zm\u{11B}nit velikost sloupce`,
    "sortAscending": `Se\u{159}adit vzestupn\u{11B}`,
    "sortDescending": `Se\u{159}adit sestupn\u{11B}`
};

},{}],"l6awS":[function(require,module,exports) {
module.exports = {
    "collapse": `Skjul`,
    "columnResizer": `Kolonne\xe6ndring`,
    "drag": `Tr\xe6k`,
    "expand": `Udvid`,
    "loading": `Indl\xe6ser ...`,
    "loadingMore": `Indl\xe6ser flere ...`,
    "resizeColumn": `Tilpas st\xf8rrelse p\xe5 kolonne`,
    "sortAscending": `Sorter stigende`,
    "sortDescending": `Sorter faldende`
};

},{}],"asxxt":[function(require,module,exports) {
module.exports = {
    "collapse": `Reduzieren`,
    "columnResizer": `Spaltenanpassung`,
    "drag": `Ziehen`,
    "expand": `Erweitern`,
    "loading": `Laden...`,
    "loadingMore": `Mehr laden ...`,
    "resizeColumn": `Spaltengr\xf6\xdfe \xe4ndern`,
    "sortAscending": `Aufsteigend sortieren`,
    "sortDescending": `Absteigend sortieren`
};

},{}],"iDEdj":[function(require,module,exports) {
module.exports = {
    "collapse": `\u{3A3}\u{3CD}\u{3BC}\u{3C0}\u{3C4}\u{3C5}\u{3BE}\u{3B7}`,
    "columnResizer": `\u{391}\u{3BB}\u{3BB}\u{3B1}\u{3B3}\u{3AE} \u{3BC}\u{3B5}\u{3B3}\u{3AD}\u{3B8}\u{3BF}\u{3C5}\u{3C2} \u{3C3}\u{3C4}\u{3AE}\u{3BB}\u{3B7}\u{3C2}`,
    "drag": `\u{39C}\u{3B5}\u{3C4}\u{3B1}\u{3C6}\u{3BF}\u{3C1}\u{3AC}`,
    "expand": `\u{391}\u{3BD}\u{3AC}\u{3C0}\u{3C4}\u{3C5}\u{3BE}\u{3B7}`,
    "loading": `\u{3A6}\u{3CC}\u{3C1}\u{3C4}\u{3C9}\u{3C3}\u{3B7}...`,
    "loadingMore": `\u{3A6}\u{3CC}\u{3C1}\u{3C4}\u{3C9}\u{3C3}\u{3B7} \u{3C0}\u{3B5}\u{3C1}\u{3B9}\u{3C3}\u{3C3}\u{3CC}\u{3C4}\u{3B5}\u{3C1}\u{3C9}\u{3BD}...`,
    "resizeColumn": `\u{391}\u{3BB}\u{3BB}\u{3B1}\u{3B3}\u{3AE} \u{3BC}\u{3B5}\u{3B3}\u{3AD}\u{3B8}\u{3BF}\u{3C5}\u{3C2} \u{3C3}\u{3C4}\u{3AE}\u{3BB}\u{3B7}\u{3C2}`,
    "sortAscending": `\u{3A4}\u{3B1}\u{3BE}\u{3B9}\u{3BD}\u{3CC}\u{3BC}\u{3B7}\u{3C3}\u{3B7} \u{3BA}\u{3B1}\u{3C4}\u{3AC} \u{3B1}\u{3CD}\u{3BE}\u{3BF}\u{3C5}\u{3C3}\u{3B1} \u{3C3}\u{3B5}\u{3B9}\u{3C1}\u{3AC}`,
    "sortDescending": `\u{3A4}\u{3B1}\u{3BE}\u{3B9}\u{3BD}\u{3CC}\u{3BC}\u{3B7}\u{3C3}\u{3B7} \u{3BA}\u{3B1}\u{3C4}\u{3AC} \u{3C6}\u{3B8}\u{3AF}\u{3BD}\u{3BF}\u{3C5}\u{3C3}\u{3B1} \u{3C3}\u{3B5}\u{3B9}\u{3C1}\u{3AC}`
};

},{}],"9cUuC":[function(require,module,exports) {
module.exports = {
    "loading": `Loading\u{2026}`,
    "loadingMore": `Loading more\u{2026}`,
    "sortAscending": `Sort Ascending`,
    "sortDescending": `Sort Descending`,
    "resizeColumn": `Resize column`,
    "columnResizer": `Column resizer`,
    "drag": `Drag`,
    "expand": `Expand`,
    "collapse": `Collapse`
};

},{}],"87CK4":[function(require,module,exports) {
module.exports = {
    "collapse": `Contraer`,
    "columnResizer": `Redimensionador de columnas`,
    "drag": `Arrastrar`,
    "expand": `Ampliar`,
    "loading": `Cargando\u{2026}`,
    "loadingMore": `Cargando m\xe1s\u{2026}`,
    "resizeColumn": `Cambiar el tama\xf1o de la columna`,
    "sortAscending": `Orden de subida`,
    "sortDescending": `Orden de bajada`
};

},{}],"dSYsU":[function(require,module,exports) {
module.exports = {
    "collapse": `Ahenda`,
    "columnResizer": `Veeru suuruse muutja`,
    "drag": `Lohista`,
    "expand": `Laienda`,
    "loading": `Laadimine...`,
    "loadingMore": `Laadi rohkem...`,
    "resizeColumn": `Muuda veeru suurust`,
    "sortAscending": `Sordi kasvavalt`,
    "sortDescending": `Sordi kahanevalt`
};

},{}],"8wAQs":[function(require,module,exports) {
module.exports = {
    "collapse": `Pienenn\xe4`,
    "columnResizer": `Sarakekoon muuttaja`,
    "drag": `Ved\xe4`,
    "expand": `Laajenna`,
    "loading": `Ladataan\u{2026}`,
    "loadingMore": `Ladataan lis\xe4\xe4\u{2026}`,
    "resizeColumn": `Muuta sarakkeen kokoa`,
    "sortAscending": `Lajitteluj\xe4rjestys: nouseva`,
    "sortDescending": `Lajitteluj\xe4rjestys: laskeva`
};

},{}],"2Isst":[function(require,module,exports) {
module.exports = {
    "collapse": `R\xe9duire`,
    "columnResizer": `Redimensionnement de colonne`,
    "drag": `Faire glisser`,
    "expand": `D\xe9velopper`,
    "loading": `Chargement...`,
    "loadingMore": `Chargement suppl\xe9mentaire...`,
    "resizeColumn": `Redimensionner la colonne`,
    "sortAscending": `Trier par ordre croissant`,
    "sortDescending": `Trier par ordre d\xe9croissant`
};

},{}],"k3TNb":[function(require,module,exports) {
module.exports = {
    "collapse": `\u{5DB}\u{5D5}\u{5D5}\u{5E5}`,
    "columnResizer": `\u{5E9}\u{5D9}\u{5E0}\u{5D5}\u{5D9} \u{5D2}\u{5D5}\u{5D3}\u{5DC} \u{5E2}\u{5DE}\u{5D5}\u{5D3}\u{5D4}`,
    "drag": `\u{5D2}\u{5E8}\u{5D5}\u{5E8}`,
    "expand": `\u{5D4}\u{5E8}\u{5D7}\u{5D1}`,
    "loading": `\u{5D8}\u{5D5}\u{5E2}\u{5DF}...`,
    "loadingMore": `\u{5D8}\u{5D5}\u{5E2}\u{5DF} \u{5E2}\u{5D5}\u{5D3}...`,
    "resizeColumn": `\u{5E9}\u{5E0}\u{5D4} \u{5D0}\u{5EA} \u{5D2}\u{5D5}\u{5D3}\u{5DC} \u{5D4}\u{5E2}\u{5DE}\u{5D5}\u{5D3}\u{5D4}`,
    "sortAscending": `\u{5DE}\u{5D9}\u{5D9}\u{5DF} \u{5D1}\u{5E1}\u{5D3}\u{5E8} \u{5E2}\u{5D5}\u{5DC}\u{5D4}`,
    "sortDescending": `\u{5DE}\u{5D9}\u{5D9}\u{5DF} \u{5D1}\u{5E1}\u{5D3}\u{5E8} \u{5D9}\u{5D5}\u{5E8}\u{5D3}`
};

},{}],"gNMvZ":[function(require,module,exports) {
module.exports = {
    "collapse": `Sa\u{17E}mi`,
    "columnResizer": `Alat za promjenu veli\u{10D}ine stupca`,
    "drag": `Povucite`,
    "expand": `Pro\u{161}iri`,
    "loading": `U\u{10D}itavam...`,
    "loadingMore": `U\u{10D}itavam jo\u{161}...`,
    "resizeColumn": `Promijeni veli\u{10D}inu stupca`,
    "sortAscending": `Sortiraj uzlazno`,
    "sortDescending": `Sortiraj silazno`
};

},{}],"k8ovy":[function(require,module,exports) {
module.exports = {
    "collapse": `\xd6sszecsuk\xe1s`,
    "columnResizer": `Oszlop\xe1tm\xe9retez\u{151}`,
    "drag": `H\xfaz\xe1s`,
    "expand": `Kibont\xe1s`,
    "loading": `Bet\xf6lt\xe9s folyamatban\u{2026}`,
    "loadingMore": `Tov\xe1bbiak bet\xf6lt\xe9se folyamatban\u{2026}`,
    "resizeColumn": `Oszlop \xe1tm\xe9retez\xe9se`,
    "sortAscending": `N\xf6vekv\u{151} rendez\xe9s`,
    "sortDescending": `Cs\xf6kken\u{151} rendez\xe9s`
};

},{}],"2kAx4":[function(require,module,exports) {
module.exports = {
    "collapse": `Comprimi`,
    "columnResizer": `Ridimensionamento colonne`,
    "drag": `Trascina`,
    "expand": `Espandi`,
    "loading": `Caricamento...`,
    "loadingMore": `Caricamento altri...`,
    "resizeColumn": `Ridimensiona colonna`,
    "sortAscending": `Ordinamento crescente`,
    "sortDescending": `Ordinamento decrescente`
};

},{}],"4EoTP":[function(require,module,exports) {
module.exports = {
    "collapse": `\u{6298}\u{308A}\u{305F}\u{305F}\u{3080}`,
    "columnResizer": `\u{5217}\u{30EA}\u{30B5}\u{30A4}\u{30B6}\u{30FC}`,
    "drag": `\u{30C9}\u{30E9}\u{30C3}\u{30B0}`,
    "expand": `\u{5C55}\u{958B}`,
    "loading": `\u{8AAD}\u{307F}\u{8FBC}\u{307F}\u{4E2D}...`,
    "loadingMore": `\u{3055}\u{3089}\u{306B}\u{8AAD}\u{307F}\u{8FBC}\u{307F}\u{4E2D}...`,
    "resizeColumn": `\u{5217}\u{5E45}\u{3092}\u{5909}\u{66F4}`,
    "sortAscending": `\u{6607}\u{9806}\u{306B}\u{4E26}\u{3079}\u{66FF}\u{3048}`,
    "sortDescending": `\u{964D}\u{9806}\u{306B}\u{4E26}\u{3079}\u{66FF}\u{3048}`
};

},{}],"ihP8Y":[function(require,module,exports) {
module.exports = {
    "collapse": `\u{C811}\u{AE30}`,
    "columnResizer": `\u{C5F4} \u{D06C}\u{AE30} \u{C870}\u{C815}\u{AE30}`,
    "drag": `\u{B4DC}\u{B798}\u{ADF8}`,
    "expand": `\u{D3BC}\u{CE58}\u{AE30}`,
    "loading": `\u{B85C}\u{B4DC} \u{C911}`,
    "loadingMore": `\u{CD94}\u{AC00} \u{B85C}\u{B4DC} \u{C911}`,
    "resizeColumn": `\u{C5F4} \u{D06C}\u{AE30} \u{C870}\u{C815}`,
    "sortAscending": `\u{C624}\u{B984}\u{CC28}\u{C21C} \u{C815}\u{B82C}`,
    "sortDescending": `\u{B0B4}\u{B9BC}\u{CC28}\u{C21C} \u{C815}\u{B82C}`
};

},{}],"2Cb3q":[function(require,module,exports) {
module.exports = {
    "collapse": `Sutraukti`,
    "columnResizer": `Stulpelio dyd\u{17E}io keitiklis`,
    "drag": `Vilkti`,
    "expand": `I\u{161}skleisti`,
    "loading": `\u{12E}keliama...`,
    "loadingMore": `\u{12E}keliama daugiau...`,
    "resizeColumn": `Keisti stulpelio dyd\u{12F}`,
    "sortAscending": `Rikiuoti did\u{117}jimo tvarka`,
    "sortDescending": `Rikiuoti ma\u{17E}\u{117}jimo tvarka`
};

},{}],"7Xgyt":[function(require,module,exports) {
module.exports = {
    "collapse": `Sak\u{13C}aut`,
    "columnResizer": `Kolonnas izm\u{113}ru main\u{12B}t\u{101}js`,
    "drag": `Vilk\u{161}ana`,
    "expand": `Izv\u{113}rst`,
    "loading": `Notiek iel\u{101}de...`,
    "loadingMore": `Tiek iel\u{101}d\u{113}ts v\u{113}l...`,
    "resizeColumn": `Main\u{12B}t kolonnas lielumu`,
    "sortAscending": `K\u{101}rtot augo\u{161}\u{101} sec\u{12B}b\u{101}`,
    "sortDescending": `K\u{101}rtot dilsto\u{161}\u{101} sec\u{12B}b\u{101}`
};

},{}],"7zv5P":[function(require,module,exports) {
module.exports = {
    "collapse": `Skjul`,
    "columnResizer": `St\xf8rrelsesendring av kolonne`,
    "drag": `Dra`,
    "expand": `Utvid`,
    "loading": `Laster inn ...`,
    "loadingMore": `Laster inn flere ...`,
    "resizeColumn": `Endre st\xf8rrelse p\xe5 kolonne`,
    "sortAscending": `Sorter stigende`,
    "sortDescending": `Sorter synkende`
};

},{}],"762L2":[function(require,module,exports) {
module.exports = {
    "collapse": `Samenvouwen`,
    "columnResizer": `Groottewijziging van kolom`,
    "drag": `Slepen`,
    "expand": `Uitvouwen`,
    "loading": `Laden...`,
    "loadingMore": `Meer laden...`,
    "resizeColumn": `Kolomgrootte wijzigen`,
    "sortAscending": `Oplopend sorteren`,
    "sortDescending": `Aflopend sorteren`
};

},{}],"v57yB":[function(require,module,exports) {
module.exports = {
    "collapse": `Zwi\u{144}`,
    "columnResizer": `Narz\u{119}dzie zmiany rozmiaru kolumny`,
    "drag": `Przeci\u{105}gnij`,
    "expand": `Rozwi\u{144}`,
    "loading": `\u{141}adowanie...`,
    "loadingMore": `Wczytywanie wi\u{119}kszej liczby...`,
    "resizeColumn": `Zmie\u{144} rozmiar kolumny`,
    "sortAscending": `Sortuj rosn\u{105}co`,
    "sortDescending": `Sortuj malej\u{105}co`
};

},{}],"eAqMr":[function(require,module,exports) {
module.exports = {
    "collapse": `Recolher`,
    "columnResizer": `Redimensionamento de colunas`,
    "drag": `Arraste`,
    "expand": `Expandir`,
    "loading": `Carregando...`,
    "loadingMore": `Carregando mais...`,
    "resizeColumn": `Redimensionar coluna`,
    "sortAscending": `Ordenar por ordem crescente`,
    "sortDescending": `Ordenar por ordem decrescente`
};

},{}],"5JO7b":[function(require,module,exports) {
module.exports = {
    "collapse": `Colapsar`,
    "columnResizer": `Redimensionador de coluna`,
    "drag": `Arrastar`,
    "expand": `Expandir`,
    "loading": `A carregar...`,
    "loadingMore": `A carregar mais...`,
    "resizeColumn": `Redimensionar coluna`,
    "sortAscending": `Ordenar por ordem ascendente`,
    "sortDescending": `Ordenar por ordem decrescente`
};

},{}],"hd1jo":[function(require,module,exports) {
module.exports = {
    "collapse": `Restr\xe2nge\u{21B}i`,
    "columnResizer": `Instrument redimensionare coloane`,
    "drag": `Trage\u{21B}i`,
    "expand": `Extinde\u{21B}i`,
    "loading": `Se \xeencarc\u{103}...`,
    "loadingMore": `Se \xeencarc\u{103} mai multe...`,
    "resizeColumn": `Redimensiona\u{21B}i coloana`,
    "sortAscending": `Sorta\u{21B}i cresc\u{103}tor`,
    "sortDescending": `Sorta\u{21B}i descresc\u{103}tor`
};

},{}],"2IwbJ":[function(require,module,exports) {
module.exports = {
    "collapse": `\u{421}\u{432}\u{435}\u{440}\u{43D}\u{443}\u{442}\u{44C}`,
    "columnResizer": `\u{421}\u{440}\u{435}\u{434}\u{441}\u{442}\u{432}\u{43E} \u{438}\u{437}\u{43C}\u{435}\u{43D}\u{435}\u{43D}\u{438}\u{44F} \u{440}\u{430}\u{437}\u{43C}\u{435}\u{440}\u{430} \u{441}\u{442}\u{43E}\u{43B}\u{431}\u{446}\u{43E}\u{432}`,
    "drag": `\u{41F}\u{435}\u{440}\u{435}\u{442}\u{430}\u{441}\u{43A}\u{438}\u{432}\u{430}\u{43D}\u{438}\u{435}`,
    "expand": `\u{420}\u{430}\u{437}\u{432}\u{435}\u{440}\u{43D}\u{443}\u{442}\u{44C}`,
    "loading": `\u{417}\u{430}\u{433}\u{440}\u{443}\u{437}\u{43A}\u{430}...`,
    "loadingMore": `\u{414}\u{43E}\u{43F}\u{43E}\u{43B}\u{43D}\u{438}\u{442}\u{435}\u{43B}\u{44C}\u{43D}\u{430}\u{44F} \u{437}\u{430}\u{433}\u{440}\u{443}\u{437}\u{43A}\u{430}...`,
    "resizeColumn": `\u{418}\u{437}\u{43C}\u{435}\u{43D}\u{438}\u{442}\u{44C} \u{440}\u{430}\u{437}\u{43C}\u{435}\u{440} \u{441}\u{442}\u{43E}\u{43B}\u{431}\u{446}\u{430}`,
    "sortAscending": `\u{421}\u{43E}\u{440}\u{442}\u{438}\u{440}\u{43E}\u{432}\u{430}\u{442}\u{44C} \u{43F}\u{43E} \u{432}\u{43E}\u{437}\u{440}\u{430}\u{441}\u{442}\u{430}\u{43D}\u{438}\u{44E}`,
    "sortDescending": `\u{421}\u{43E}\u{440}\u{442}\u{438}\u{440}\u{43E}\u{432}\u{430}\u{442}\u{44C} \u{43F}\u{43E} \u{443}\u{431}\u{44B}\u{432}\u{430}\u{43D}\u{438}\u{44E}`
};

},{}],"2sQYG":[function(require,module,exports) {
module.exports = {
    "collapse": `Zbali\u{165}`,
    "columnResizer": `N\xe1stroj na zmenu ve\u{13E}kosti st\u{13A}pcov`,
    "drag": `Presun\xfa\u{165}`,
    "expand": `Rozbali\u{165}`,
    "loading": `Na\u{10D}\xedtava sa...`,
    "loadingMore": `Na\u{10D}\xedtava sa viac...`,
    "resizeColumn": `Zmeni\u{165} ve\u{13E}kos\u{165} st\u{13A}pca`,
    "sortAscending": `Zoradi\u{165} vzostupne`,
    "sortDescending": `Zoradi\u{165} zostupne`
};

},{}],"8noNq":[function(require,module,exports) {
module.exports = {
    "collapse": `Strni`,
    "columnResizer": `Prilagojevalnik velikosti stolpcev`,
    "drag": `Povleci`,
    "expand": `Raz\u{161}iri`,
    "loading": `Nalaganje...`,
    "loadingMore": `Nalaganje ve\u{10D} vsebine...`,
    "resizeColumn": `Spremeni velikost stolpca`,
    "sortAscending": `Razvrsti nara\u{161}\u{10D}ajo\u{10D}e`,
    "sortDescending": `Razvrsti padajo\u{10D}e`
};

},{}],"4n9Nj":[function(require,module,exports) {
module.exports = {
    "collapse": `Sa\u{17E}mi`,
    "columnResizer": `Alat za promenu veli\u{10D}ine kolone`,
    "drag": `Prevuci`,
    "expand": `Pro\u{161}iri`,
    "loading": `U\u{10D}itavam...`,
    "loadingMore": `U\u{10D}itavam jo\u{161}...`,
    "resizeColumn": `Promeni veli\u{10D}inu kolone`,
    "sortAscending": `Sortiraj po rastu\u{107}em redosledu`,
    "sortDescending": `Sortiraj po opadaju\u{107}em redosledu`
};

},{}],"hG0r3":[function(require,module,exports) {
module.exports = {
    "collapse": `D\xf6lj`,
    "columnResizer": `\xc4ndra storlek p\xe5 kolumn`,
    "drag": `Dra`,
    "expand": `Expandera`,
    "loading": `L\xe4ser in...`,
    "loadingMore": `L\xe4ser in mer...`,
    "resizeColumn": `\xc4ndra storlek p\xe5 kolumn`,
    "sortAscending": `Sortera i stigande ordning`,
    "sortDescending": `Sortera i fallande ordning`
};

},{}],"6hiyE":[function(require,module,exports) {
module.exports = {
    "collapse": `Daralt`,
    "columnResizer": `Yeniden s\xfctun boyutland\u{131}r\u{131}c\u{131}`,
    "drag": `S\xfcr\xfckle`,
    "expand": `Geni\u{15F}let`,
    "loading": `Y\xfckleniyor...`,
    "loadingMore": `Daha fazla y\xfckleniyor...`,
    "resizeColumn": `S\xfctunu yeniden boyutland\u{131}r`,
    "sortAscending": `Artan S\u{131}ralama`,
    "sortDescending": `Azalan S\u{131}ralama`
};

},{}],"hKKg0":[function(require,module,exports) {
module.exports = {
    "collapse": `\u{417}\u{433}\u{43E}\u{440}\u{43D}\u{443}\u{442}\u{438}`,
    "columnResizer": `\u{417}\u{430}\u{441}\u{456}\u{431} \u{437}\u{43C}\u{456}\u{43D}\u{435}\u{43D}\u{43D}\u{44F} \u{440}\u{43E}\u{437}\u{43C}\u{456}\u{440}\u{443} \u{441}\u{442}\u{43E}\u{432}\u{43F}\u{446}\u{44F}`,
    "drag": `\u{41F}\u{435}\u{440}\u{435}\u{442}\u{44F}\u{433}\u{43D}\u{443}\u{442}\u{438}`,
    "expand": `\u{420}\u{43E}\u{437}\u{433}\u{43E}\u{440}\u{43D}\u{443}\u{442}\u{438}`,
    "loading": `\u{417}\u{430}\u{432}\u{430}\u{43D}\u{442}\u{430}\u{436}\u{435}\u{43D}\u{43D}\u{44F}\u{2026}`,
    "loadingMore": `\u{417}\u{430}\u{432}\u{430}\u{43D}\u{442}\u{430}\u{436}\u{435}\u{43D}\u{43D}\u{44F} \u{456}\u{43D}\u{448}\u{438}\u{445} \u{43E}\u{431}\u{2019}\u{454}\u{43A}\u{442}\u{456}\u{432}...`,
    "resizeColumn": `\u{417}\u{43C}\u{456}\u{43D}\u{438}\u{442}\u{438} \u{440}\u{43E}\u{437}\u{43C}\u{456}\u{440} \u{441}\u{442}\u{43E}\u{432}\u{43F}\u{446}\u{44F}`,
    "sortAscending": `\u{421}\u{43E}\u{440}\u{442}\u{443}\u{432}\u{430}\u{442}\u{438} \u{437}\u{430} \u{437}\u{440}\u{43E}\u{441}\u{442}\u{430}\u{43D}\u{43D}\u{44F}\u{43C}`,
    "sortDescending": `\u{421}\u{43E}\u{440}\u{442}\u{443}\u{432}\u{430}\u{442}\u{438} \u{437}\u{430} \u{441}\u{43F}\u{430}\u{434}\u{430}\u{43D}\u{43D}\u{44F}\u{43C}`
};

},{}],"286BB":[function(require,module,exports) {
module.exports = {
    "collapse": `\u{6298}\u{53E0}`,
    "columnResizer": `\u{5217}\u{5C3A}\u{5BF8}\u{8C03}\u{6574}\u{5668}`,
    "drag": `\u{62D6}\u{52A8}`,
    "expand": `\u{6269}\u{5C55}`,
    "loading": `\u{6B63}\u{5728}\u{52A0}\u{8F7D}...`,
    "loadingMore": `\u{6B63}\u{5728}\u{52A0}\u{8F7D}\u{66F4}\u{591A}...`,
    "resizeColumn": `\u{8C03}\u{6574}\u{5217}\u{5927}\u{5C0F}`,
    "sortAscending": `\u{5347}\u{5E8F}\u{6392}\u{5E8F}`,
    "sortDescending": `\u{964D}\u{5E8F}\u{6392}\u{5E8F}`
};

},{}],"d3QPZ":[function(require,module,exports) {
module.exports = {
    "collapse": `\u{6536}\u{5408}`,
    "columnResizer": `\u{6B04}\u{5927}\u{5C0F}\u{8ABF}\u{6574}\u{5668}`,
    "drag": `\u{62D6}\u{66F3}`,
    "expand": `\u{5C55}\u{958B}`,
    "loading": `\u{6B63}\u{5728}\u{8F09}\u{5165}`,
    "loadingMore": `\u{6B63}\u{5728}\u{8F09}\u{5165}\u{66F4}\u{591A}\u{2026}`,
    "resizeColumn": `\u{8ABF}\u{6574}\u{6B04}\u{5927}\u{5C0F}`,
    "sortAscending": `\u{5347}\u{5E8F}\u{6392}\u{5E8F}`,
    "sortDescending": `\u{964D}\u{5E8F}\u{6392}\u{5E8F}`
};

},{}],"6Lck0":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("1bec68f7f1d77c0");
exports.__esModule = true;
exports.default = ListGripper;
var _ListGripper = require("b73caaa63255c540");
var _icon = require("5321f83d773b45be");
var _react = _interopRequireDefault(require("9dd9ae98daf67cba"));
function ListGripper(props) {
    return /*#__PURE__*/ _react.default.createElement(_icon.UIIcon, props, /*#__PURE__*/ _react.default.createElement(_ListGripper.ListGripper, null));
}

},{"1bec68f7f1d77c0":"iHubQ","b73caaa63255c540":"6fgAd","5321f83d773b45be":"k7wem","9dd9ae98daf67cba":"9yzVZ"}],"6fgAd":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ListGripper = ListGripper;
var _react = _interopRequireDefault(require("84d0baad7f17a0d1"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/*
@adobe/react-spectrum-ui (c) by Adobe

@adobe/react-spectrum-ui is licensed under a
Creative Commons Attribution-NoDerivatives 4.0 International License.

You should have received a copy of the license along with this
work. If not, see <http://creativecommons.org/licenses/by-nd/4.0/>.
*/ function ListGripper({ scale = "M", ...props }) {
    return /*#__PURE__*/ _react.default.createElement("svg", props, scale === "L" && /*#__PURE__*/ _react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/ _react.default.createElement("circle", {
        cx: "5.375",
        cy: "12.625",
        r: "1.25"
    }), /*#__PURE__*/ _react.default.createElement("circle", {
        cx: "1.625",
        cy: "12.625",
        r: "1.25"
    }), /*#__PURE__*/ _react.default.createElement("circle", {
        cx: "5.375",
        cy: "8.875",
        r: "1.25"
    }), /*#__PURE__*/ _react.default.createElement("circle", {
        cx: "1.625",
        cy: "8.875",
        r: "1.25"
    }), /*#__PURE__*/ _react.default.createElement("circle", {
        cx: "5.375",
        cy: "5.125",
        r: "1.25"
    }), /*#__PURE__*/ _react.default.createElement("circle", {
        cx: "1.625",
        cy: "5.125",
        r: "1.25"
    }), /*#__PURE__*/ _react.default.createElement("circle", {
        cx: "5.375",
        cy: "1.375",
        r: "1.25"
    }), /*#__PURE__*/ _react.default.createElement("circle", {
        cx: "1.625",
        cy: "1.375",
        r: "1.25"
    })), scale === "M" && /*#__PURE__*/ _react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/ _react.default.createElement("circle", {
        cx: "4",
        cy: "10.5",
        r: "1"
    }), /*#__PURE__*/ _react.default.createElement("circle", {
        cx: "1",
        cy: "10.5",
        r: "1"
    }), /*#__PURE__*/ _react.default.createElement("circle", {
        cx: "4",
        cy: "7.5",
        r: "1"
    }), /*#__PURE__*/ _react.default.createElement("circle", {
        cx: "1",
        cy: "7.5",
        r: "1"
    }), /*#__PURE__*/ _react.default.createElement("circle", {
        cx: "4",
        cy: "4.5",
        r: "1"
    }), /*#__PURE__*/ _react.default.createElement("circle", {
        cx: "1",
        cy: "4.5",
        r: "1"
    }), /*#__PURE__*/ _react.default.createElement("circle", {
        cx: "4",
        cy: "1.5",
        r: "1"
    }), /*#__PURE__*/ _react.default.createElement("circle", {
        cx: "1",
        cy: "1.5",
        r: "1"
    })));
}
ListGripper.displayName = "ListGripper";

},{"84d0baad7f17a0d1":"9yzVZ"}],"3kMEi":[function(require,module,exports) {
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// TODO resize with scale? colors should be variables
parcelHelpers.export(exports, "Nubbin", ()=>Nubbin);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
function Nubbin() {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        viewBox: "0 0 16 16"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        fill: "var(--spectrum-global-color-blue-600)",
        stroke: "var(--spectrum-global-color-blue-600)",
        strokeWidth: "2"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("circle", {
        cx: "8",
        cy: "8",
        r: "8",
        stroke: "none"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("circle", {
        cx: "8",
        cy: "8",
        r: "7",
        fill: "none"
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M-2106-7380.263v5l2.5-2.551Z",
        transform: "translate(2116 7385.763)",
        fill: "#fff",
        stroke: "#fff",
        strokeLinejoin: "round",
        strokeWidth: "2"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M-2106-7380.263v5l2.5-2.551Z",
        transform: "translate(-2100 -7369.763) rotate(180)",
        fill: "#fff",
        stroke: "#fff",
        strokeLinejoin: "round",
        strokeWidth: "2"
    }));
}

},{"react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"cT1al":[function(require,module,exports) {
/* eslint-disable jsx-a11y/role-supports-aria-props */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Resizer", ()=>_Resizer);
var _utils = require("@react-spectrum/utils");
// @ts-ignore
var _curMoveToRight99Svg = require("bundle-text:./cursors/Cur_MoveToRight_9_9.svg");
var _curMoveToRight99SvgDefault = parcelHelpers.interopDefault(_curMoveToRight99Svg);
// @ts-ignore
var _curMoveHorizontal99Svg = require("bundle-text:./cursors/Cur_MoveHorizontal_9_9.svg");
var _curMoveHorizontal99SvgDefault = parcelHelpers.interopDefault(_curMoveHorizontal99Svg);
var _focus = require("@react-aria/focus");
// @ts-ignore
var _json = require("../intl/*.json");
var _jsonDefault = parcelHelpers.interopDefault(_json);
var _utils1 = require("@react-aria/utils");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactDom = require("react-dom");
var _reactDomDefault = parcelHelpers.interopDefault(_reactDom);
var _varsCss = require("@adobe/spectrum-css-temp/components/table/vars.css");
var _varsCssDefault = parcelHelpers.interopDefault(_varsCss);
var _i18N = require("@react-aria/i18n");
var _table = require("@react-aria/table");
var _tableViewBase = require("./TableViewBase");
// @ts-ignore
var _curMoveToLeft99Svg = require("bundle-text:./cursors/Cur_MoveToLeft_9_9.svg");
var _curMoveToLeft99SvgDefault = parcelHelpers.interopDefault(_curMoveToLeft99Svg);
function getCursor(svg, fallback) {
    // WebKit renders SVG cursors blurry on 2x screens: https://bugs.webkit.org/show_bug.cgi?id=160657
    // To work around this, we generate two SVGs at different sizes and use image-set to pick between them.
    // Only do this in WebKit to avoid Firefox rendering the cursor at twice the size.
    if ((0, _utils1.isWebKit)()) return `image-set(url("data:image/svg+xml,${encodeURIComponent(svg)}") 1x, url("data:image/svg+xml,${encodeURIComponent(svg.replace('width="32" height="32"', 'width="64" height="64"'))}") 2x) 8 8, ${fallback}`;
    else return `url("data:image/svg+xml,${encodeURIComponent(svg)}") 8 8, ${fallback}`;
}
const CURSORS = {
    ew: getCursor((0, _curMoveHorizontal99SvgDefault.default), "ew-resize"),
    w: getCursor((0, _curMoveToLeft99SvgDefault.default), "w-resize"),
    e: getCursor((0, _curMoveToRight99SvgDefault.default), "e-resize")
};
function Resizer(props, ref) {
    let { column, showResizer } = props;
    let { isEmpty, layout, onFocusedResizer } = (0, _tableViewBase.useTableContext)();
    // Virtualizer re-renders, but these components are all cached
    // in order to get around that and cause a rerender here, we use context
    // but we don't actually need any value, they are available on the layout object
    (0, _tableViewBase.useVirtualizerContext)();
    let stringFormatter = (0, _i18N.useLocalizedStringFormatter)((0, _jsonDefault.default), "@react-spectrum/table");
    let { direction } = (0, _i18N.useLocale)();
    let [isPointerDown, setIsPointerDown] = (0, _react.useState)(false);
    (0, _react.useEffect)(()=>{
        let setDown = (e)=>{
            if (e.pointerType === "mouse") setIsPointerDown(true);
        };
        let setUp = (e)=>{
            if (e.pointerType === "mouse") setIsPointerDown(false);
        };
        document.addEventListener("pointerdown", setDown, {
            capture: true
        });
        document.addEventListener("pointerup", setUp, {
            capture: true
        });
        return ()=>{
            document.removeEventListener("pointerdown", setDown, {
                capture: true
            });
            document.removeEventListener("pointerup", setUp, {
                capture: true
            });
        };
    }, []);
    let { inputProps, resizerProps } = (0, _table.useTableColumnResize)((0, _utils1.mergeProps)(props, {
        "aria-label": stringFormatter.format("columnResizer"),
        isDisabled: isEmpty
    }), layout, ref);
    let isEResizable = layout.getColumnMinWidth(column.key) >= layout.getColumnWidth(column.key);
    let isWResizable = layout.getColumnMaxWidth(column.key) <= layout.getColumnWidth(column.key);
    let isResizing = layout.resizingColumn === column.key;
    let cursor = "";
    if (isEResizable) cursor = direction === "rtl" ? CURSORS.w : CURSORS.e;
    else if (isWResizable) cursor = direction === "rtl" ? CURSORS.e : CURSORS.w;
    else cursor = CURSORS.ew;
    let style = {
        ...resizerProps.style,
        height: "100%",
        display: showResizer ? undefined : "none",
        cursor
    };
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _focus.FocusRing), {
        within: true,
        focusRingClass: (0, _utils.classNames)((0, _varsCssDefault.default), "focus-ring")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...resizerProps,
        role: "presentation",
        style: style,
        className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Table-columnResizer")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("input", {
        ref: ref,
        ...(0, _utils1.mergeProps)(inputProps, {
            onFocus: onFocusedResizer
        })
    }))), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        "aria-hidden": true,
        role: "presentation",
        className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Table-columnResizerPlaceholder")
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement(CursorOverlay, {
        show: isResizing && isPointerDown
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        style: {
            position: "fixed",
            top: 0,
            left: 0,
            bottom: 0,
            right: 0,
            cursor
        }
    })));
}
function CursorOverlay(props) {
    let { show, children } = props;
    return show ? /*#__PURE__*/ (0, _reactDomDefault.default).createPortal(children, document.body) : null;
}
const _Resizer = /*#__PURE__*/ (0, _reactDefault.default).forwardRef(Resizer);

},{"@react-spectrum/utils":"cMIJ6","bundle-text:./cursors/Cur_MoveToRight_9_9.svg":"fcDRO","bundle-text:./cursors/Cur_MoveHorizontal_9_9.svg":"8MGRv","@react-aria/focus":"42mbF","../intl/*.json":"5Wmph","@react-aria/utils":"9cLk5","react":"9yzVZ","react-dom":"cEvV3","@adobe/spectrum-css-temp/components/table/vars.css":"gCdiM","@react-aria/i18n":"411rg","@react-aria/table":"jm3EF","./TableViewBase":"w8HhS","bundle-text:./cursors/Cur_MoveToLeft_9_9.svg":"bsfFF","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"fcDRO":[function(require,module,exports) {
module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"-1 0 31 32\"><filter id=\"shadow\"><feDropShadow dx=\"0\" dy=\".5\" stdDeviation=\"1.2\" flood-opacity=\".7\"/></filter><g filter=\"url('#shadow')\" transform=\"translate(.5)\"><path d=\"M9.5 2a.5.5 0 0 1 .5.5V9h3V7.25a.25.25 0 0 1 .41-.192L16 9.5l-2.59 2.442a.25.25 0 0 1-.41-.192V10h-3v6.5a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-14a.5.5 0 0 1 .5-.5h1Zm0-1h-1A1.5 1.5 0 0 0 7 2.5v14A1.5 1.5 0 0 0 8.5 18h1a1.5 1.5 0 0 0 1.5-1.5V11h1v.678c0 .404.163.805.482 1.053a1.24 1.24 0 0 0 1.568-.021l.024-.02.022-.02 2.976-2.806a.5.5 0 0 0 0-.728l-2.976-2.805-.022-.021-.024-.02a1.25 1.25 0 0 0-2.05.96V8h-1V2.5A1.5 1.5 0 0 0 9.5 1Z\" fill=\"#fff\"/><path d=\"M10 16.5V10h3v1.75a.25.25 0 0 0 .41.192L16 9.5l-2.59-2.442a.25.25 0 0 0-.41.192V9h-3V2.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v14a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5Z\"/></g></svg>";

},{}],"8MGRv":[function(require,module,exports) {
module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"-1 0 31 32\"><filter id=\"shadow\"><feDropShadow dx=\"0\" dy=\".5\" stdDeviation=\"1.2\" flood-opacity=\".7\"/></filter><g filter=\"url('#shadow')\" transform=\"translate(.5)\"><path fill=\"#fff\" d=\"M9.5 2a.5.5 0 0 1 .5.5V9h3V7.25a.25.25 0 0 1 .25-.25h.001a.246.246 0 0 1 .159.058L16 9.5l-2.59 2.442a.246.246 0 0 1-.159.058.25.25 0 0 1-.251-.249V10h-3v6.5a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5V10H5v1.75a.25.25 0 0 1-.25.25H4.75a.246.246 0 0 1-.159-.058L2 9.5l2.59-2.442A.246.246 0 0 1 4.749 7 .25.25 0 0 1 5 7.249V9h3V2.5a.5.5 0 0 1 .5-.5Zm0-1h-1A1.5 1.5 0 0 0 7 2.5V8H6v-.676a1.33 1.33 0 0 0-.482-1.055 1.24 1.24 0 0 0-1.568.021l-.024.02-.022.02L.928 9.137a.5.5 0 0 0-.02.707l.02.02 2.976 2.806.022.021.024.02a1.24 1.24 0 0 0 1.568.02A1.33 1.33 0 0 0 6 11.678V11h1v5.5A1.5 1.5 0 0 0 8.5 18h1a1.5 1.5 0 0 0 1.5-1.5V11h1v.678a1.328 1.328 0 0 0 .482 1.053 1.24 1.24 0 0 0 1.568-.021l.024-.02.022-.02 2.976-2.806a.5.5 0 0 0 .02-.707l-.02-.02-2.976-2.806-.022-.021-.024-.02a1.25 1.25 0 0 0-2.05.96V8h-1V2.5A1.5 1.5 0 0 0 9.5 1Z\"/><path d=\"M10 16.5V10h3v1.75a.25.25 0 0 0 .41.192L16 9.5l-2.59-2.442a.25.25 0 0 0-.41.192V9h-3V2.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5V9H5V7.25a.25.25 0 0 0-.41-.192L2 9.5l2.59 2.442a.25.25 0 0 0 .41-.193V10h3v6.5a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5Z\"/></g></svg>";

},{}],"gCdiM":[function(require,module,exports) {
module.exports["contents"] = `_5uzlQq_contents`;
module.exports["expand-button"] = `_5uzlQq_expand-button`;
module.exports["focus-ring"] = `_5uzlQq_focus-ring`;
module.exports["i18nFontFamily"] = `_5uzlQq_i18nFontFamily`;
module.exports["is-active"] = `_5uzlQq_is-active`;
module.exports["is-disabled"] = `_5uzlQq_is-disabled`;
module.exports["is-drop-target"] = `_5uzlQq_is-drop-target`;
module.exports["is-focused"] = `_5uzlQq_is-focused`;
module.exports["is-hovered"] = `_5uzlQq_is-hovered`;
module.exports["is-next-selected"] = `_5uzlQq_is-next-selected`;
module.exports["is-open"] = `_5uzlQq_is-open`;
module.exports["is-resizable"] = `_5uzlQq_is-resizable`;
module.exports["is-selected"] = `_5uzlQq_is-selected`;
module.exports["is-sortable"] = `_5uzlQq_is-sortable`;
module.exports["is-sorted-asc"] = `_5uzlQq_is-sorted-asc`;
module.exports["is-sorted-desc"] = `_5uzlQq_is-sorted-desc`;
module.exports["spectrum-FocusRing-ring"] = `_5uzlQq_spectrum-FocusRing-ring`;
module.exports["spectrum-FocusRing"] = `_5uzlQq_spectrum-FocusRing ${module.exports["spectrum-FocusRing-ring"]}`;
module.exports["spectrum-FocusRing--quiet"] = `_5uzlQq_spectrum-FocusRing--quiet`;
module.exports["spectrum-Table"] = `_5uzlQq_spectrum-Table`;
module.exports["spectrum-Table--compact"] = `_5uzlQq_spectrum-Table--compact`;
module.exports["spectrum-Table--isHorizontalScrollbarVisible"] = `_5uzlQq_spectrum-Table--isHorizontalScrollbarVisible`;
module.exports["spectrum-Table--isVerticalScrollbarVisible"] = `_5uzlQq_spectrum-Table--isVerticalScrollbarVisible`;
module.exports["spectrum-Table--loadingMore"] = `_5uzlQq_spectrum-Table--loadingMore`;
module.exports["spectrum-Table--quiet"] = `_5uzlQq_spectrum-Table--quiet`;
module.exports["spectrum-Table--regular"] = `_5uzlQq_spectrum-Table--regular`;
module.exports["spectrum-Table--spacious"] = `_5uzlQq_spectrum-Table--spacious`;
module.exports["spectrum-Table--wrap"] = `_5uzlQq_spectrum-Table--wrap`;
module.exports["spectrum-Table-body"] = `_5uzlQq_spectrum-Table-body`;
module.exports["spectrum-Table-body--resizerAtTableEdge"] = `_5uzlQq_spectrum-Table-body--resizerAtTableEdge`;
module.exports["spectrum-Table-bodyResizeIndicator"] = `_5uzlQq_spectrum-Table-bodyResizeIndicator`;
module.exports["spectrum-Table-cell"] = `_5uzlQq_spectrum-Table-cell`;
module.exports["spectrum-Table-cell--alignCenter"] = `_5uzlQq_spectrum-Table-cell--alignCenter`;
module.exports["spectrum-Table-cell--alignEnd"] = `_5uzlQq_spectrum-Table-cell--alignEnd`;
module.exports["spectrum-Table-cell--divider"] = `_5uzlQq_spectrum-Table-cell--divider`;
module.exports["spectrum-Table-cell--hasExpandCollapseButton"] = `_5uzlQq_spectrum-Table-cell--hasExpandCollapseButton`;
module.exports["spectrum-Table-cell--hideHeader"] = `_5uzlQq_spectrum-Table-cell--hideHeader`;
module.exports["spectrum-Table-cellContents"] = `_5uzlQq_spectrum-Table-cellContents`;
module.exports["spectrum-Table-cellWrapper"] = `_5uzlQq_spectrum-Table-cellWrapper`;
module.exports["spectrum-Table-checkbox"] = `_5uzlQq_spectrum-Table-checkbox`;
module.exports["spectrum-Table-checkboxCell"] = `_5uzlQq_spectrum-Table-checkboxCell`;
module.exports["spectrum-Table-colResizeIndicator"] = `_5uzlQq_spectrum-Table-colResizeIndicator`;
module.exports["spectrum-Table-colResizeIndicator--resizing"] = `_5uzlQq_spectrum-Table-colResizeIndicator--resizing`;
module.exports["spectrum-Table-colResizeIndicator--visible"] = `_5uzlQq_spectrum-Table-colResizeIndicator--visible`;
module.exports["spectrum-Table-colResizeNubbin"] = `_5uzlQq_spectrum-Table-colResizeNubbin`;
module.exports["spectrum-Table-colResizeNubbin--visible"] = `_5uzlQq_spectrum-Table-colResizeNubbin--visible`;
module.exports["spectrum-Table-columnResizer"] = `_5uzlQq_spectrum-Table-columnResizer`;
module.exports["spectrum-Table-columnResizerPlaceholder"] = `_5uzlQq_spectrum-Table-columnResizerPlaceholder`;
module.exports["spectrum-Table-expandButton"] = `_5uzlQq_spectrum-Table-expandButton`;
module.exports["spectrum-Table-headCell"] = `_5uzlQq_spectrum-Table-headCell`;
module.exports["spectrum-Table-headCellButton"] = `_5uzlQq_spectrum-Table-headCellButton`;
module.exports["spectrum-Table-headCellButton--alignCenter"] = `_5uzlQq_spectrum-Table-headCellButton--alignCenter`;
module.exports["spectrum-Table-headCellButton--alignEnd"] = `_5uzlQq_spectrum-Table-headCellButton--alignEnd`;
module.exports["spectrum-Table-headCellButton--alignStart"] = `_5uzlQq_spectrum-Table-headCellButton--alignStart`;
module.exports["spectrum-Table-headCellContents"] = `_5uzlQq_spectrum-Table-headCellContents`;
module.exports["spectrum-Table-headWrapper"] = `_5uzlQq_spectrum-Table-headWrapper`;
module.exports["spectrum-Table-headerCellText"] = `_5uzlQq_spectrum-Table-headerCellText`;
module.exports["spectrum-Table-menuChevron"] = `_5uzlQq_spectrum-Table-menuChevron`;
module.exports["spectrum-Table-row"] = `_5uzlQq_spectrum-Table-row`;
module.exports["spectrum-Table-row--firstRow"] = `_5uzlQq_spectrum-Table-row--firstRow`;
module.exports["spectrum-Table-row--isFlushBottom"] = `_5uzlQq_spectrum-Table-row--isFlushBottom`;
module.exports["spectrum-Table-row--lastRow"] = `_5uzlQq_spectrum-Table-row--lastRow`;
module.exports["spectrum-Table-sortedIcon"] = `_5uzlQq_spectrum-Table-sortedIcon`;

},{}],"bsfFF":[function(require,module,exports) {
module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"-1 0 31 32\"><filter id=\"shadow\"><feDropShadow dx=\"0\" dy=\".5\" stdDeviation=\"1.2\" flood-opacity=\".7\"/></filter><g filter=\"url('#shadow')\" transform=\"translate(.5)\"><path d=\"M9.5 2a.5.5 0 0 1 .5.5v14a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5V10H5v1.75a.25.25 0 0 1-.41.192L2 9.5l2.59-2.442A.25.25 0 0 1 5 7.25V9h3V2.5a.5.5 0 0 1 .5-.5h1Zm0-1h-1A1.5 1.5 0 0 0 7 2.5V8H6v-.676c0-.404-.163-.806-.482-1.055a1.24 1.24 0 0 0-1.568.021l-.024.02-.022.02L.928 9.137a.5.5 0 0 0 0 .728l2.976 2.805.022.021.024.02a1.24 1.24 0 0 0 1.568.02c.319-.248.482-.65.482-1.053V11h1v5.5A1.5 1.5 0 0 0 8.5 18h1a1.5 1.5 0 0 0 1.5-1.5v-14A1.5 1.5 0 0 0 9.5 1Z\" fill=\"#fff\"/><path d=\"M10 16.5v-14a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5V9H5V7.25a.25.25 0 0 0-.41-.192L2 9.5l2.59 2.442A.25.25 0 0 0 5 11.75V10h3v6.5a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5Z\"/></g></svg>";

},{}],"iUmqB":[function(require,module,exports) {
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RootDropIndicator", ()=>RootDropIndicator);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _tableViewBase = require("./TableViewBase");
var _visuallyHidden = require("@react-aria/visually-hidden");
function RootDropIndicator() {
    let { dropState, dragAndDropHooks, state } = (0, _tableViewBase.useTableContext)();
    let ref = (0, _react.useRef)();
    let { dropIndicatorProps } = dragAndDropHooks.useDropIndicator({
        target: {
            type: "root"
        }
    }, dropState, ref);
    let isDropTarget = dropState.isDropTarget({
        type: "root"
    });
    let { visuallyHiddenProps } = (0, _visuallyHidden.useVisuallyHidden)();
    if (!isDropTarget && dropIndicatorProps["aria-hidden"]) return null;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        role: "row",
        "aria-hidden": dropIndicatorProps["aria-hidden"]
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        role: "gridcell",
        "aria-selected": "false",
        "aria-colspan": state.collection.columns.length
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        role: "button",
        ...visuallyHiddenProps,
        ...dropIndicatorProps,
        ref: ref
    })));
}

},{"react":"9yzVZ","./TableViewBase":"w8HhS","@react-aria/visually-hidden":"4jwxT","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"4zOF7":[function(require,module,exports) {
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DragPreview", ()=>DragPreview);
var _utils = require("@react-spectrum/utils");
var _layout = require("@react-spectrum/layout");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _varsCss = require("@adobe/spectrum-css-temp/components/table/vars.css");
var _varsCssDefault = parcelHelpers.interopDefault(_varsCss);
var _tableCss = require("./table.css");
var _tableCssDefault = parcelHelpers.interopDefault(_tableCss);
function DragPreview(props) {
    let { itemText, itemCount, height, maxWidth } = props;
    let isDraggingMultiple = itemCount > 1;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
        justifyContent: "space-between",
        height: height,
        maxWidth: maxWidth,
        UNSAFE_className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Table-row", (0, _utils.classNames)((0, _tableCssDefault.default), "react-spectrum-Table-row", "react-spectrum-Table-row-dragPreview", {
            "react-spectrum-Table-row-dragPreview--multiple": isDraggingMultiple
        }))
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Table-cell", (0, _utils.classNames)((0, _tableCssDefault.default), "react-spectrum-Table-cell"))
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Table-cellContents")
    }, itemText)), isDraggingMultiple && /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _utils.classNames)((0, _tableCssDefault.default), "react-spectrum-Table-row-badge")
    }, itemCount));
}

},{"@react-spectrum/utils":"cMIJ6","@react-spectrum/layout":"hzaUY","react":"9yzVZ","@adobe/spectrum-css-temp/components/table/vars.css":"gCdiM","./table.css":"5RNXu","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"hjrBb":[function(require,module,exports) {
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TreeGridTableView", ()=>_TreeGridTableView);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _tableViewBase = require("./TableViewBase");
var _table = require("@react-stately/table");
function TreeGridTableView(props, ref) {
    let { selectionStyle, dragAndDropHooks } = props;
    let [showSelectionCheckboxes, setShowSelectionCheckboxes] = (0, _react.useState)(selectionStyle !== "highlight");
    let isTableDraggable = !!(dragAndDropHooks === null || dragAndDropHooks === void 0 ? void 0 : dragAndDropHooks.useDraggableCollectionState);
    let state = (0, _table.UNSTABLE_useTreeGridState)({
        ...props,
        showSelectionCheckboxes,
        showDragButtons: isTableDraggable,
        selectionBehavior: props.selectionStyle === "highlight" ? "replace" : "toggle"
    });
    // If the selection behavior changes in state, we need to update showSelectionCheckboxes here due to the circular dependency...
    let shouldShowCheckboxes = state.selectionManager.selectionBehavior !== "replace";
    if (shouldShowCheckboxes !== showSelectionCheckboxes) setShowSelectionCheckboxes(shouldShowCheckboxes);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _tableViewBase.TableViewBase), {
        ...props,
        state: state,
        ref: ref
    });
}
const _TreeGridTableView = /*#__PURE__*/ (0, _reactDefault.default).forwardRef(TreeGridTableView);

},{"react":"9yzVZ","./TableViewBase":"w8HhS","@react-stately/table":"6ZM93","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"2pivm":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /// <reference types="css-module-types" />
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SearchField", ()=>(0, _searchField.SearchField));
var _searchField = require("./SearchField");

},{"./SearchField":"7gwV1","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"7gwV1":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SearchField", ()=>_SearchField);
var _utils = require("@react-spectrum/utils");
var _button = require("@react-spectrum/button");
var _magnifier = require("@spectrum-icons/ui/Magnifier");
var _magnifierDefault = parcelHelpers.interopDefault(_magnifier);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _varsCss = require("@adobe/spectrum-css-temp/components/search/vars.css");
var _varsCssDefault = parcelHelpers.interopDefault(_varsCss);
var _textfield = require("@react-spectrum/textfield");
var _form = require("@react-spectrum/form");
var _provider = require("@react-spectrum/provider");
var _searchfield = require("@react-aria/searchfield");
var _searchfield1 = require("@react-stately/searchfield");
function SearchField(props, ref) {
    props = (0, _utils.useSlotProps)(props, "searchfield");
    props = (0, _provider.useProviderProps)(props);
    props = (0, _form.useFormProps)(props);
    let defaultIcon = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _magnifierDefault.default), {
        "data-testid": "searchicon"
    });
    let { icon = defaultIcon, isDisabled, UNSAFE_className, placeholder, ...otherProps } = props;
    if (placeholder) console.warn("Placeholders are deprecated due to accessibility issues. Please use help text instead. See the docs for details: https://react-spectrum.adobe.com/react-spectrum/SearchField.html#help-text");
    let state = (0, _searchfield1.useSearchFieldState)(props);
    let inputRef = (0, _react.useRef)(null);
    let { clearButtonProps, ...result } = (0, _searchfield.useSearchField)(props, state, inputRef);
    let clearButton = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ClearButton), {
        ...clearButtonProps,
        preventFocus: true,
        UNSAFE_className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-ClearButton"),
        isDisabled: isDisabled
    });
    let validationState = props.validationState || (result.isInvalid ? "invalid" : undefined);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textfield.TextFieldBase), {
        ...otherProps,
        ...result,
        validationState: validationState,
        UNSAFE_className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Search", "spectrum-Textfield", {
            "is-disabled": isDisabled,
            "is-quiet": props.isQuiet,
            "spectrum-Search--invalid": validationState === "invalid" && !isDisabled,
            "spectrum-Search--valid": validationState === "valid" && !isDisabled
        }, UNSAFE_className),
        inputClassName: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Search-input"),
        ref: ref,
        inputRef: inputRef,
        isDisabled: isDisabled,
        icon: icon,
        wrapperChildren: state.value !== "" && !props.isReadOnly ? clearButton : undefined
    });
}
/**
 * A SearchField is a text field designed for searches.
 */ let _SearchField = /*#__PURE__*/ (0, _react.forwardRef)(SearchField);

},{"@react-spectrum/utils":"cMIJ6","@react-spectrum/button":"jZWyP","@spectrum-icons/ui/Magnifier":"fLimS","react":"9yzVZ","@adobe/spectrum-css-temp/components/search/vars.css":"1Ppz4","@react-spectrum/textfield":"hOmtq","@react-spectrum/form":"bGDqA","@react-spectrum/provider":"5bCdp","@react-aria/searchfield":"2RKb9","@react-stately/searchfield":"iPYi5","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"fLimS":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("4e6e4b3d7b1fe5a7");
exports.__esModule = true;
exports.default = Magnifier;
var _Magnifier = require("2e29dd699c5425fd");
var _icon = require("d16efa67c76317a0");
var _react = _interopRequireDefault(require("d7f909352392f4d2"));
function Magnifier(props) {
    return /*#__PURE__*/ _react.default.createElement(_icon.UIIcon, props, /*#__PURE__*/ _react.default.createElement(_Magnifier.Magnifier, null));
}

},{"4e6e4b3d7b1fe5a7":"iHubQ","2e29dd699c5425fd":"jWPJh","d16efa67c76317a0":"k7wem","d7f909352392f4d2":"9yzVZ"}],"jWPJh":[function(require,module,exports) {
/**
* @adobe/react-spectrum-ui (c) by Adobe
* 
* @adobe/react-spectrum-ui is licensed under a
* Creative Commons Attribution-NoDerivatives 4.0 International License.
* 
* You should have received a copy of the license along with this
* work. If not, see <http://creativecommons.org/licenses/by-nd/4.0/>.
**/ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Magnifier = Magnifier;
var _react = _interopRequireDefault(require("71b1b9cc9f103550"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function Magnifier(_ref) {
    var _ref$scale = _ref.scale, scale = _ref$scale === void 0 ? "M" : _ref$scale, props = _objectWithoutProperties(_ref, [
        "scale"
    ]);
    return _react["default"].createElement("svg", _extends({}, props, props), scale === "L" && _react["default"].createElement("path", {
        d: "M19.77 18.71l-5.464-5.464a7.503 7.503 0 1 0-1.06 1.06l5.463 5.464a.75.75 0 1 0 1.061-1.06zM2.5 8.5a6 6 0 1 1 6 6 6.007 6.007 0 0 1-6-6z"
    }), scale === "M" && _react["default"].createElement("path", {
        d: "M15.77 14.71l-4.534-4.535a6.014 6.014 0 1 0-1.06 1.06l4.533 4.535a.75.75 0 1 0 1.061-1.06zM6.5 11A4.5 4.5 0 1 1 11 6.5 4.505 4.505 0 0 1 6.5 11z"
    }));
}
Magnifier.displayName = "Magnifier";

},{"71b1b9cc9f103550":"9yzVZ"}],"1Ppz4":[function(require,module,exports) {
module.exports["focus-ring"] = `SOkmSG_focus-ring`;
module.exports["i18nFontFamily"] = `SOkmSG_i18nFontFamily`;
module.exports["is-quiet"] = `SOkmSG_is-quiet`;
module.exports["spectrum-ClearButton"] = `SOkmSG_spectrum-ClearButton`;
module.exports["spectrum-FocusRing-ring"] = `SOkmSG_spectrum-FocusRing-ring`;
module.exports["spectrum-FocusRing"] = `SOkmSG_spectrum-FocusRing ${module.exports["spectrum-FocusRing-ring"]}`;
module.exports["spectrum-FocusRing--quiet"] = `SOkmSG_spectrum-FocusRing--quiet`;
module.exports["spectrum-Search"] = `SOkmSG_spectrum-Search`;
module.exports["spectrum-Search--invalid"] = `SOkmSG_spectrum-Search--invalid`;
module.exports["spectrum-Search--loadable"] = `SOkmSG_spectrum-Search--loadable`;
module.exports["spectrum-Search--valid"] = `SOkmSG_spectrum-Search--valid`;
module.exports["spectrum-Search-circleLoader"] = `SOkmSG_spectrum-Search-circleLoader`;
module.exports["spectrum-Search-input"] = `SOkmSG_spectrum-Search-input`;
module.exports["spectrum-Search-validationIcon"] = `SOkmSG_spectrum-Search-validationIcon`;
module.exports["spectrum-Textfield"] = `SOkmSG_spectrum-Textfield`;

},{}],"hOmtq":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /// <reference types="css-module-types" />
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TextArea", ()=>(0, _textArea.TextArea));
parcelHelpers.export(exports, "TextField", ()=>(0, _textField.TextField));
parcelHelpers.export(exports, "TextFieldBase", ()=>(0, _textFieldBase.TextFieldBase));
var _textArea = require("./TextArea");
var _textField = require("./TextField");
var _textFieldBase = require("./TextFieldBase");

},{"./TextArea":"f6BL3","./TextField":"jSUcK","./TextFieldBase":"lokOZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"f6BL3":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TextArea", ()=>_TextArea);
var _utils = require("@react-aria/utils");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _textFieldBase = require("./TextFieldBase");
var _utils1 = require("@react-stately/utils");
var _form = require("@react-spectrum/form");
var _provider = require("@react-spectrum/provider");
var _textfield = require("@react-aria/textfield");
function TextArea(props, ref) {
    props = (0, _provider.useProviderProps)(props);
    props = (0, _form.useFormProps)(props);
    let { isDisabled = false, isQuiet = false, isReadOnly = false, isRequired = false, onChange, ...otherProps } = props;
    var _props_defaultValue;
    // not in stately because this is so we know when to re-measure, which is a spectrum design
    let [inputValue, setInputValue] = (0, _utils1.useControlledState)(props.value, (_props_defaultValue = props.defaultValue) !== null && _props_defaultValue !== void 0 ? _props_defaultValue : "", ()=>{});
    let inputRef = (0, _react.useRef)(null);
    let onHeightChange = (0, _react.useCallback)(()=>{
        // Quiet textareas always grow based on their text content.
        // Standard textareas also grow by default, unless an explicit height is set.
        if ((isQuiet || !props.height) && inputRef.current) {
            let input = inputRef.current;
            let prevAlignment = input.style.alignSelf;
            let prevOverflow = input.style.overflow;
            // Firefox scroll position is lost when overflow: 'hidden' is applied so we skip applying it.
            // The measure/applied height is also incorrect/reset if we turn on and off
            // overflow: hidden in Firefox https://bugzilla.mozilla.org/show_bug.cgi?id=1787062
            let isFirefox = "MozAppearance" in input.style;
            if (!isFirefox) input.style.overflow = "hidden";
            input.style.alignSelf = "start";
            input.style.height = "auto";
            // offsetHeight - clientHeight accounts for the border/padding.
            input.style.height = `${input.scrollHeight + (input.offsetHeight - input.clientHeight)}px`;
            input.style.overflow = prevOverflow;
            input.style.alignSelf = prevAlignment;
        }
    }, [
        isQuiet,
        inputRef,
        props.height
    ]);
    (0, _utils.useLayoutEffect)(()=>{
        if (inputRef.current) onHeightChange();
    }, [
        onHeightChange,
        inputValue,
        inputRef
    ]);
    if (props.placeholder) console.warn("Placeholders are deprecated due to accessibility issues. Please use help text instead. See the docs for details: https://react-spectrum.adobe.com/react-spectrum/TextArea.html#help-text");
    let result = (0, _textfield.useTextField)({
        ...props,
        onChange: (0, _utils.chain)(onChange, setInputValue),
        inputElementType: "textarea"
    }, inputRef);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textFieldBase.TextFieldBase), {
        ...otherProps,
        ref: ref,
        inputRef: inputRef,
        ...result,
        multiLine: true,
        isDisabled: isDisabled,
        isQuiet: isQuiet,
        isReadOnly: isReadOnly,
        isRequired: isRequired
    });
}
/**
 * TextAreas are multiline text inputs, useful for cases where users have
 * a sizable amount of text to enter. They allow for all customizations that
 * are available to text fields.
 */ let _TextArea = /*#__PURE__*/ (0, _reactDefault.default).forwardRef(TextArea);

},{"@react-aria/utils":"9cLk5","react":"9yzVZ","./TextFieldBase":"lokOZ","@react-stately/utils":"cpDPf","@react-spectrum/form":"bGDqA","@react-spectrum/provider":"5bCdp","@react-aria/textfield":"6dEv6","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"lokOZ":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TextFieldBase", ()=>_TextFieldBase);
var _alertMedium = require("@spectrum-icons/ui/AlertMedium");
var _alertMediumDefault = parcelHelpers.interopDefault(_alertMedium);
var _checkmarkMedium = require("@spectrum-icons/ui/CheckmarkMedium");
var _checkmarkMediumDefault = parcelHelpers.interopDefault(_checkmarkMedium);
var _utils = require("@react-spectrum/utils");
var _label = require("@react-spectrum/label");
var _utils1 = require("@react-aria/utils");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _varsCss = require("@adobe/spectrum-css-temp/components/textfield/vars.css");
var _varsCssDefault = parcelHelpers.interopDefault(_varsCss);
var _focus = require("@react-aria/focus");
var _interactions = require("@react-aria/interactions");
function TextFieldBase(props, ref) {
    let { validationState = props.isInvalid ? "invalid" : null, icon, isQuiet = false, isDisabled, multiLine, autoFocus, inputClassName, wrapperChildren, labelProps, inputProps, descriptionProps, errorMessageProps, inputRef: userInputRef, isLoading, loadingIndicator, validationIconClassName, disableFocusRing } = props;
    let { hoverProps, isHovered } = (0, _interactions.useHover)({
        isDisabled
    });
    let domRef = (0, _react.useRef)(null);
    let defaultInputRef = (0, _react.useRef)(null);
    let inputRef = userInputRef || defaultInputRef;
    // Expose imperative interface for ref
    (0, _react.useImperativeHandle)(ref, ()=>({
            ...(0, _utils.createFocusableRef)(domRef, inputRef),
            select () {
                if (inputRef.current) inputRef.current.select();
            },
            getInputElement () {
                return inputRef.current;
            }
        }));
    let ElementType = multiLine ? "textarea" : "input";
    let isInvalid = validationState === "invalid" && !isDisabled;
    if (icon) {
        let UNSAFE_className = (0, _utils.classNames)((0, _varsCssDefault.default), icon.props && icon.props.UNSAFE_className, "spectrum-Textfield-icon");
        icon = /*#__PURE__*/ (0, _react.cloneElement)(icon, {
            UNSAFE_className,
            size: "S"
        });
    }
    let validationIcon = isInvalid ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _alertMediumDefault.default), null) : /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _checkmarkMediumDefault.default), null);
    let validation = /*#__PURE__*/ (0, _react.cloneElement)(validationIcon, {
        UNSAFE_className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Textfield-validationIcon", validationIconClassName)
    });
    let { focusProps, isFocusVisible } = (0, _focus.useFocusRing)({
        isTextInput: true,
        autoFocus
    });
    let textField = /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Textfield", {
            "spectrum-Textfield--invalid": isInvalid,
            "spectrum-Textfield--valid": validationState === "valid" && !isDisabled,
            "spectrum-Textfield--loadable": loadingIndicator,
            "spectrum-Textfield--quiet": isQuiet,
            "spectrum-Textfield--multiline": multiLine,
            "focus-ring": !disableFocusRing && isFocusVisible
        })
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(ElementType, {
        ...(0, _utils1.mergeProps)(inputProps, hoverProps, focusProps),
        ref: inputRef,
        rows: multiLine ? 1 : undefined,
        className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Textfield-input", {
            "spectrum-Textfield-inputIcon": icon,
            "is-hovered": isHovered
        }, inputClassName)
    }), icon, validationState && !isLoading && !isDisabled ? validation : null, isLoading && loadingIndicator, wrapperChildren);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _label.Field), {
        ...props,
        labelProps: labelProps,
        descriptionProps: descriptionProps,
        errorMessageProps: errorMessageProps,
        wrapperClassName: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Textfield-wrapper", {
            "spectrum-Textfield-wrapper--quiet": isQuiet
        }),
        showErrorIcon: false,
        ref: domRef
    }, textField);
}
const _TextFieldBase = /*#__PURE__*/ (0, _react.forwardRef)(TextFieldBase);

},{"@spectrum-icons/ui/AlertMedium":"2v5QX","@spectrum-icons/ui/CheckmarkMedium":"e6Ew8","@react-spectrum/utils":"cMIJ6","@react-spectrum/label":"6qv6N","@react-aria/utils":"9cLk5","react":"9yzVZ","@adobe/spectrum-css-temp/components/textfield/vars.css":"c3yAu","@react-aria/focus":"42mbF","@react-aria/interactions":"ky3G8","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"c3yAu":[function(require,module,exports) {
module.exports["focus-ring"] = `YO3Nla_focus-ring`;
module.exports["i18nFontFamily"] = `YO3Nla_i18nFontFamily`;
module.exports["is-disabled"] = `YO3Nla_is-disabled`;
module.exports["is-focused"] = `YO3Nla_is-focused`;
module.exports["is-hovered"] = `YO3Nla_is-hovered`;
module.exports["is-placeholder"] = `YO3Nla_is-placeholder`;
module.exports["spectrum-FocusRing-ring"] = `YO3Nla_spectrum-FocusRing-ring`;
module.exports["spectrum-FocusRing"] = `YO3Nla_spectrum-FocusRing ${module.exports["spectrum-FocusRing-ring"]}`;
module.exports["spectrum-FocusRing--quiet"] = `YO3Nla_spectrum-FocusRing--quiet`;
module.exports["spectrum-Textfield"] = `YO3Nla_spectrum-Textfield ${module.exports["spectrum-FocusRing"]}`;
module.exports["spectrum-Textfield--invalid"] = `YO3Nla_spectrum-Textfield--invalid`;
module.exports["spectrum-Textfield--loadable"] = `YO3Nla_spectrum-Textfield--loadable`;
module.exports["spectrum-Textfield--multiline"] = `YO3Nla_spectrum-Textfield--multiline`;
module.exports["spectrum-Textfield--quiet"] = `YO3Nla_spectrum-Textfield--quiet ${module.exports["spectrum-FocusRing--quiet"]}`;
module.exports["spectrum-Textfield--valid"] = `YO3Nla_spectrum-Textfield--valid`;
module.exports["spectrum-Textfield-circleLoader"] = `YO3Nla_spectrum-Textfield-circleLoader`;
module.exports["spectrum-Textfield-icon"] = `YO3Nla_spectrum-Textfield-icon`;
module.exports["spectrum-Textfield-input"] = `YO3Nla_spectrum-Textfield-input ${module.exports["i18nFontFamily"]}`;
module.exports["spectrum-Textfield-inputIcon"] = `YO3Nla_spectrum-Textfield-inputIcon`;
module.exports["spectrum-Textfield-validationIcon"] = `YO3Nla_spectrum-Textfield-validationIcon`;
module.exports["spectrum-Textfield-wrapper"] = `YO3Nla_spectrum-Textfield-wrapper`;
module.exports["spectrum-Textfield-wrapper--quiet"] = `YO3Nla_spectrum-Textfield-wrapper--quiet`;

},{}],"jSUcK":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TextField", ()=>_TextField);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _textFieldBase = require("./TextFieldBase");
var _form = require("@react-spectrum/form");
var _provider = require("@react-spectrum/provider");
var _textfield = require("@react-aria/textfield");
function TextField(props, ref) {
    props = (0, _provider.useProviderProps)(props);
    props = (0, _form.useFormProps)(props);
    let inputRef = (0, _react.useRef)(null);
    let result = (0, _textfield.useTextField)(props, inputRef);
    if (props.placeholder) console.warn("Placeholders are deprecated due to accessibility issues. Please use help text instead. See the docs for details: https://react-spectrum.adobe.com/react-spectrum/TextField.html#help-text");
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textFieldBase.TextFieldBase), {
        ...props,
        ...result,
        ref: ref,
        inputRef: inputRef
    });
}
/**
 * TextFields are text inputs that allow users to input custom text entries
 * with a keyboard. Various decorations can be displayed around the field to
 * communicate the entry requirements.
 */ const _TextField = /*#__PURE__*/ (0, _react.forwardRef)(TextField);

},{"react":"9yzVZ","./TextFieldBase":"lokOZ","@react-spectrum/form":"bGDqA","@react-spectrum/provider":"5bCdp","@react-aria/textfield":"6dEv6","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"7yTlj":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HoverDisabling", ()=>HoverDisabling);
var _utils = require("@react-spectrum/utils");
var _utils1 = require("@react-aria/utils");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _button = require("@react-aria/button");
var _ = require("../");
exports.default = {
    title: "useHover"
};
const HoverDisabling = {
    render: ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement(App, null),
    name: "hover disabling"
};
function Button(props) {
    let { children, isDisabled } = props;
    let buttonRef = (0, _react.useRef)(null);
    let { buttonProps } = (0, _button.useButton)(props, buttonRef);
    let { hoverProps, isHovered } = (0, _.useHover)({
        isDisabled
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("button", {
        className: (0, _utils.classNames)({}, {
            isHovered
        }),
        "data-hover": isHovered || null,
        ...(0, _utils1.mergeProps)(buttonProps, hoverProps),
        ref: buttonRef
    }, children);
}
function App() {
    let [isDisabled, setIsDisabled] = (0, _react.useState)(false);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement("style", null, `
        .isHovered {
          background-color: purple;
        }
      `), /*#__PURE__*/ (0, _reactDefault.default).createElement(Button, {
        isDisabled: isDisabled,
        onPress: ()=>setIsDisabled(true)
    }, "Hover & Press"), /*#__PURE__*/ (0, _reactDefault.default).createElement("button", {
        onClick: ()=>setIsDisabled(false)
    }, "Reset"));
}

},{"@react-spectrum/utils":"cMIJ6","@react-aria/utils":"9cLk5","react":"9yzVZ","@react-aria/button":"fsdLZ","../":"dnaok","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"dnaok":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _src = require("./src");
parcelHelpers.exportAll(_src, exports);

},{"./src":"ky3G8","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"g7AK5":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "OutsideBody", ()=>OutsideBody);
parcelHelpers.export(exports, "ClickingButtonShouldFireOnInteractOutside", ()=>ClickingButtonShouldFireOnInteractOutside);
var _addonActions = require("@storybook/addon-actions");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _ = require("../");
exports.default = {
    title: "useInteractOutside"
};
const OutsideBody = ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement(Demo, null);
OutsideBody.decorators = [
    (Story)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(BodyStyler, null, /*#__PURE__*/ (0, _reactDefault.default).createElement(Story, null))
];
const ClickingButtonShouldFireOnInteractOutside = ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement(App, null);
function Demo() {
    let ref = (0, _react.useRef)(null);
    let onInteractOutside = (0, _addonActions.action)("outside");
    (0, _.useInteractOutside)({
        ref,
        onInteractOutside
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ref: ref,
        style: {
            marginInlineStart: "50px",
            marginBlockStart: "50px"
        }
    }, "Click anywhere but this text");
}
function BodyStyler(props) {
    (0, _react.useEffect)(()=>{
        let story = document.querySelector(".react-spectrum-story");
        let prev = {
            body: {
                height: document.body.style.height,
                width: document.body.style.width
            },
            story: {
                minHeight: story.style.minHeight
            }
        };
        document.body.style.height = "fit-content";
        document.body.style.width = "fit-content";
        story.style.minHeight = "initial";
        return ()=>{
            document.body.style.height = prev.body.height;
            document.body.style.width = prev.body.width;
            story.style.minHeight = prev.story.minHeight;
        };
    });
    return props.children;
}
function MyButton() {
    let ref = (0, _reactDefault.default).useRef(null);
    let { pressProps } = (0, _.usePress)({
        ref
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("button", {
        ...pressProps,
        ref: ref
    }, "My Button");
}
function App() {
    let ref = (0, _reactDefault.default).useRef(null);
    (0, _.useInteractOutside)({
        // Clicking on "My Button" should fire this callback
        onInteractOutside: (0, _addonActions.action)("clicked outside of orange div"),
        ref
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: "App"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", null, "Clicking 'My Button' should fire onInteractOutside"), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ref: ref,
        style: {
            width: "100px",
            height: "100px",
            background: "orange"
        }
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement(MyButton, null));
}

},{"@storybook/addon-actions":"coXbW","react":"9yzVZ","../":"dnaok","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"2iPHm":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /* eslint-disable jsx-a11y/no-noninteractive-tabindex */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Log", ()=>Log);
parcelHelpers.export(exports, "_Ball1D", ()=>_Ball1D);
parcelHelpers.export(exports, "Ball2D", ()=>Ball2D);
parcelHelpers.export(exports, "BallNested", ()=>BallNested);
var _addonActions = require("@storybook/addon-actions");
var _utils = require("@react-aria/utils");
var _layout = require("@react-spectrum/layout");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _ = require("../");
function useClampedMove(props) {
    let currentPosition = (0, _react.useRef)();
    let { getCurrentState, onMoveTo, onMoveStart, onMoveEnd, reverseX = false, reverseY = false } = props;
    let { moveProps } = (0, _.useMove)({
        onMoveStart (e) {
            currentPosition.current = null;
            onMoveStart === null || onMoveStart === void 0 ? void 0 : onMoveStart(e);
        },
        onMove ({ deltaX, deltaY, pointerType }) {
            if (!currentPosition.current) currentPosition.current = getCurrentState();
            currentPosition.current.x += reverseX ? -deltaX : deltaX;
            currentPosition.current.y += reverseY ? -deltaY : deltaY;
            onMoveTo({
                pointerType,
                x: currentPosition.current.x,
                y: currentPosition.current.y
            });
        },
        onMoveEnd
    });
    return moveProps;
}
function Ball1D() {
    let [state, setState] = (0, _react.useState)({
        x: 0,
        color: "black"
    });
    let props = useClampedMove({
        reverseY: true,
        onMoveStart () {
            setState((state)=>({
                    ...state,
                    color: "red"
                }));
        },
        onMoveTo ({ x }) {
            setState((state)=>({
                    ...state,
                    x: (0, _utils.clamp)(x, 0, 170),
                    y: 0
                }));
        },
        getCurrentState () {
            return {
                x: state.x,
                y: 0
            };
        },
        onMoveEnd () {
            setState((state)=>({
                    ...state,
                    color: "black"
                }));
        }
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        style: {
            width: "200px",
            height: "30px",
            background: "white",
            border: "1px solid black",
            position: "relative",
            touchAction: "none"
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        tabIndex: 0,
        ...props,
        style: {
            width: "30px",
            height: "30px",
            borderRadius: "100%",
            position: "absolute",
            left: state.x + "px",
            background: state.color
        }
    }));
}
exports.default = {
    title: "useMove"
};
const Log = ()=>{
    let { moveProps } = (0, _.useMove)({
        onMoveStart (e) {
            (0, _addonActions.action)("onMoveStart")(JSON.stringify(e));
        },
        onMove (e) {
            (0, _addonActions.action)("onMove")(JSON.stringify(e));
        },
        onMoveEnd (e) {
            (0, _addonActions.action)("onMoveEnd")(JSON.stringify(e));
        }
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...moveProps,
        style: {
            width: "200px",
            height: "200px",
            background: "white",
            border: "1px solid black",
            touchAction: "none"
        }
    });
};
const _Ball1D = {
    render: ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
            direction: "column",
            gap: "size-1000"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Ball1D, null), /*#__PURE__*/ (0, _reactDefault.default).createElement(Ball1D, null)),
    name: "Ball 1D"
};
function Ball2DStory() {
    let [state, setState] = (0, _react.useState)({
        x: 0,
        y: 0,
        color: "black"
    });
    let props = useClampedMove({
        onMoveStart () {
            setState((state)=>({
                    ...state,
                    color: "red"
                }));
        },
        onMoveTo ({ x, y }) {
            setState((state)=>({
                    ...state,
                    x: (0, _utils.clamp)(x, 0, 170),
                    y: (0, _utils.clamp)(y, 0, 170)
                }));
        },
        getCurrentState () {
            return {
                x: state.x,
                y: state.y
            };
        },
        onMoveEnd () {
            setState((state)=>({
                    ...state,
                    color: "black"
                }));
        }
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        style: {
            width: "200px",
            height: "200px",
            background: "white",
            border: "1px solid black",
            position: "relative",
            touchAction: "none"
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        tabIndex: 0,
        ...props,
        style: {
            width: "30px",
            height: "30px",
            borderRadius: "100%",
            position: "absolute",
            left: state.x + "px",
            top: state.y + "px",
            background: state.color
        }
    }));
}
const Ball2D = {
    render: ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement(Ball2DStory, null),
    name: "Ball 2D"
};
function BallNestedStory() {
    let [ballState, setBallState] = (0, _react.useState)({
        x: 0,
        y: 0,
        color: "black"
    });
    let [boxState, setBoxState] = (0, _react.useState)({
        x: 100,
        y: 100,
        color: "grey"
    });
    let { moveProps: ballProps } = (0, _.useMove)({
        onMoveStart () {
            setBallState((state)=>({
                    ...state,
                    color: "red"
                }));
        },
        onMove (e) {
            setBallState((state)=>({
                    ...state,
                    x: state.x + e.deltaX,
                    y: state.y + e.deltaY
                }));
        },
        onMoveEnd () {
            setBallState((state)=>({
                    ...state,
                    color: "black"
                }));
        }
    });
    let { moveProps: boxProps } = (0, _.useMove)({
        onMoveStart () {
            setBoxState((state)=>({
                    ...state,
                    color: "orange"
                }));
        },
        onMove (e) {
            setBoxState((state)=>({
                    ...state,
                    x: state.x + e.deltaX,
                    y: state.y + e.deltaY
                }));
        },
        onMoveEnd () {
            setBoxState((state)=>({
                    ...state,
                    color: "grey"
                }));
        }
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        tabIndex: 0,
        ...boxProps,
        style: {
            width: "100px",
            height: "100px",
            touchAction: "none",
            position: "absolute",
            left: boxState.x + "px",
            top: boxState.y + "px",
            background: boxState.color
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        tabIndex: 0,
        ...ballProps,
        style: {
            width: "30px",
            height: "30px",
            borderRadius: "100%",
            position: "absolute",
            left: ballState.x + "px",
            top: ballState.y + "px",
            background: ballState.color
        }
    }));
}
const BallNested = {
    render: ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement(BallNestedStory, null),
    name: "Ball nested"
};

},{"@storybook/addon-actions":"coXbW","@react-aria/utils":"9cLk5","@react-spectrum/layout":"hzaUY","react":"9yzVZ","../":"dnaok","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"5KUGQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NoError", ()=>NoError);
parcelHelpers.export(exports, "WithError", ()=>WithError);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _ = require("../");
const TextInputField = (props)=>{
    const { label, description, errorMessage, validationState } = props;
    const ref = (0, _react.useRef)(null);
    const { labelProps, fieldProps, descriptionProps, errorMessageProps } = (0, _.useField)(props);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("label", labelProps, label), /*#__PURE__*/ (0, _reactDefault.default).createElement("input", {
        ...fieldProps,
        ref: ref
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", descriptionProps, description), validationState === "invalid" && /*#__PURE__*/ (0, _reactDefault.default).createElement("div", errorMessageProps, errorMessage));
};
exports.default = {
    title: "useField"
};
const TextInputFieldTemplate = (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(TextInputField, args);
const NoError = {
    render: TextInputFieldTemplate,
    args: {
        label: "Test label",
        value: "Test value",
        description: "I describe the field.",
        errorMessage: "I'm a helpful error for the field."
    }
};
const WithError = {
    render: TextInputFieldTemplate,
    args: {
        label: "Test label",
        value: "Test value",
        description: "I describe the field.",
        errorMessage: "I'm a helpful error for the field.",
        validationState: "invalid"
    }
};

},{"react":"9yzVZ","../":"4zmFM","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"4zmFM":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _src = require("./src");
parcelHelpers.exportAll(_src, exports);

},{"./src":"74Ccz","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"T1V9r":[function(require,module,exports) {
/*
 * Copyright 2021 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FlatLandmarks", ()=>FlatLandmarks);
parcelHelpers.export(exports, "NestedLandmarks", ()=>NestedLandmarks);
parcelHelpers.export(exports, "TableLandmark", ()=>TableLandmark);
parcelHelpers.export(exports, "ApplicationWithLandmarks", ()=>ApplicationWithLandmarks);
parcelHelpers.export(exports, "DuplicateRolesWithLabels", ()=>DuplicateRolesWithLabels);
parcelHelpers.export(exports, "DuplicateRolesWithNoLabels", ()=>DuplicateRolesWithNoLabels);
parcelHelpers.export(exports, "DuplicateRolesWithSameLabels", ()=>DuplicateRolesWithSameLabels);
parcelHelpers.export(exports, "OneWithNoFocusableChildren", ()=>OneWithNoFocusableChildren);
parcelHelpers.export(exports, "AllWithNoFocusableChildren", ()=>AllWithNoFocusableChildren);
parcelHelpers.export(exports, "IframeExampleStory", ()=>IframeExampleStory);
var _actiongroup = require("@react-spectrum/actiongroup");
var _table = require("@react-spectrum/table");
var _checkbox = require("@react-spectrum/checkbox");
var _utils = require("@react-spectrum/utils");
var _ = require("../");
var _layout = require("@react-spectrum/layout");
var _link = require("@react-spectrum/link");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _searchfield = require("@react-spectrum/searchfield");
var _indexCss = require("./index.css");
var _indexCssDefault = parcelHelpers.interopDefault(_indexCss);
var _textfield = require("@react-spectrum/textfield");
const meta = {
    title: "Landmark",
    parameters: {
        providerSwitcher: {
            mainElement: false
        }
    }
};
exports.default = meta;
const Template = (props)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(Example, props);
const NestedTemplate = (props)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(NestedExample, props);
const TableTemplate = (props)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(TableExample, props);
const ApplicationTemplate = (props)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(ApplicationExample, props);
const DuplicateRolesWithLabelsTemplate = (props)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(DuplicateRolesWithLabelsExample, props);
const DuplicateRolesWithNoLabelsTemplate = (props)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(DuplicateRolesNoLabelExample, props);
const DuplicateRolesWithSameLabelsTemplate = (props)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(DuplicateRolesWithSameLabelsExample, props);
const OneWithNoFocusableChildrenExampleTemplate = (props)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(OneWithNoFocusableChildrenExample, props);
const AllWithNoFocusableChildrenExampleTemplate = (props)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(AllWithNoFocusableChildrenExample, props);
function Main(props) {
    let ref = (0, _utils.useFocusableRef)(null);
    let { styleProps } = (0, _utils.useStyleProps)(props);
    let { landmarkProps } = (0, _.useLandmark)({
        ...props,
        role: "main"
    }, ref);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("main", {
        "aria-label": "Danni's unicorn corral",
        ref: ref,
        ...props,
        ...landmarkProps,
        ...styleProps
    }, props.children);
}
function Navigation(props) {
    let ref = (0, _utils.useFocusableRef)(null);
    let { styleProps } = (0, _utils.useStyleProps)(props);
    let { landmarkProps } = (0, _.useLandmark)({
        ...props,
        role: "navigation"
    }, ref);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("nav", {
        "aria-label": "Rainbow lookout",
        ref: ref,
        ...props,
        ...landmarkProps,
        ...styleProps
    }, props.children);
}
function Region(props) {
    let ref = (0, _utils.useFocusableRef)(null);
    let { styleProps } = (0, _utils.useStyleProps)(props);
    let { landmarkProps } = (0, _.useLandmark)({
        ...props,
        role: "region"
    }, ref);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("article", {
        "aria-label": "The greens",
        ref: ref,
        ...props,
        ...landmarkProps,
        ...styleProps
    }, props.children);
}
function Search(props) {
    let ref = (0, _utils.useFocusableRef)(null);
    let { styleProps } = (0, _utils.useStyleProps)(props);
    let { landmarkProps } = (0, _.useLandmark)({
        ...props,
        role: "search"
    }, ref);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("form", {
        "aria-label": "Magic seeing eye",
        ref: ref,
        ...props,
        ...landmarkProps,
        ...styleProps,
        className: (0, _utils.classNames)((0, _indexCssDefault.default), "landmark")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _searchfield.SearchField), {
        label: "Search"
    }));
}
function Example() {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", null, /*#__PURE__*/ (0, _reactDefault.default).createElement(Navigation, null, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", null, "Navigation Landmark"), /*#__PURE__*/ (0, _reactDefault.default).createElement("ul", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("li", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("a", {
        href: "/home"
    }, "Home")), /*#__PURE__*/ (0, _reactDefault.default).createElement("li", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("a", {
        href: "/about"
    }, "About")), /*#__PURE__*/ (0, _reactDefault.default).createElement("li", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("a", {
        href: "/contact"
    }, "Contact")))), /*#__PURE__*/ (0, _reactDefault.default).createElement(Main, null, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", null, "Main Landmark"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textfield.TextField), {
        label: "First Name"
    })));
}
function DuplicateRolesWithLabelsExample() {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", null, /*#__PURE__*/ (0, _reactDefault.default).createElement(Navigation, {
        "aria-label": "First Nav"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", null, "Navigation Landmark with 'First Nav' label"), /*#__PURE__*/ (0, _reactDefault.default).createElement("ul", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("li", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("a", {
        href: "/home"
    }, "Home")), /*#__PURE__*/ (0, _reactDefault.default).createElement("li", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("a", {
        href: "/about"
    }, "About")), /*#__PURE__*/ (0, _reactDefault.default).createElement("li", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("a", {
        href: "/contact"
    }, "Contact")))), /*#__PURE__*/ (0, _reactDefault.default).createElement(Navigation, {
        "aria-label": "Second Nav"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", null, "Navigation Landmark with 'Second Nav' label"), /*#__PURE__*/ (0, _reactDefault.default).createElement("ul", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("li", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("a", {
        href: "/home"
    }, "Home")), /*#__PURE__*/ (0, _reactDefault.default).createElement("li", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("a", {
        href: "/about"
    }, "About")), /*#__PURE__*/ (0, _reactDefault.default).createElement("li", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("a", {
        href: "/contact"
    }, "Contact")))), /*#__PURE__*/ (0, _reactDefault.default).createElement(Main, null, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", null, "Main Landmark"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textfield.TextField), {
        label: "First Name"
    })));
}
function DuplicateRolesWithSameLabelsExample() {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", null, /*#__PURE__*/ (0, _reactDefault.default).createElement(Navigation, {
        "aria-label": "First Nav"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", null, "Navigation Landmark with 'First Nav' label"), /*#__PURE__*/ (0, _reactDefault.default).createElement("ul", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("li", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("a", {
        href: "/home"
    }, "Home")), /*#__PURE__*/ (0, _reactDefault.default).createElement("li", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("a", {
        href: "/about"
    }, "About")), /*#__PURE__*/ (0, _reactDefault.default).createElement("li", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("a", {
        href: "/contact"
    }, "Contact")))), /*#__PURE__*/ (0, _reactDefault.default).createElement(Navigation, {
        "aria-label": "First Nav"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", null, "Navigation Landmark with 'First Nav' label"), /*#__PURE__*/ (0, _reactDefault.default).createElement("ul", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("li", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("a", {
        href: "/home"
    }, "Home")), /*#__PURE__*/ (0, _reactDefault.default).createElement("li", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("a", {
        href: "/about"
    }, "About")), /*#__PURE__*/ (0, _reactDefault.default).createElement("li", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("a", {
        href: "/contact"
    }, "Contact")))), /*#__PURE__*/ (0, _reactDefault.default).createElement(Main, null, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", null, "Main Landmark"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textfield.TextField), {
        label: "First Name"
    })));
}
function DuplicateRolesNoLabelExample() {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", null, /*#__PURE__*/ (0, _reactDefault.default).createElement(Navigation, {
        "aria-label": undefined
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", null, "Navigation Landmark with no label"), /*#__PURE__*/ (0, _reactDefault.default).createElement("ul", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("li", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("a", {
        href: "/home"
    }, "Home")), /*#__PURE__*/ (0, _reactDefault.default).createElement("li", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("a", {
        href: "/about"
    }, "About")), /*#__PURE__*/ (0, _reactDefault.default).createElement("li", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("a", {
        href: "/contact"
    }, "Contact")))), /*#__PURE__*/ (0, _reactDefault.default).createElement(Navigation, {
        "aria-label": undefined
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", null, "Navigation Landmark with no label"), /*#__PURE__*/ (0, _reactDefault.default).createElement("ul", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("li", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("a", {
        href: "/home"
    }, "Home")), /*#__PURE__*/ (0, _reactDefault.default).createElement("li", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("a", {
        href: "/about"
    }, "About")), /*#__PURE__*/ (0, _reactDefault.default).createElement("li", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("a", {
        href: "/contact"
    }, "Contact")))), /*#__PURE__*/ (0, _reactDefault.default).createElement(Main, {
        "aria-label": undefined
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", null, "Main Landmark"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textfield.TextField), {
        label: "First Name"
    })));
}
function OneWithNoFocusableChildrenExample() {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textfield.TextField), {
        label: "First Name"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement(Main, null, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", null, "Main Landmark"), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", null, "No focusable children")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textfield.TextField), {
        label: "First Name"
    }));
}
function AllWithNoFocusableChildrenExample() {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", null, /*#__PURE__*/ (0, _reactDefault.default).createElement(Region, null, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", null, "Region Landmark"), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", null, "No focusable children")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textfield.TextField), {
        label: "First Name"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement(Main, null, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", null, "Main Landmark"), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", null, "No focusable children")));
}
function NestedExample() {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", null, /*#__PURE__*/ (0, _reactDefault.default).createElement(Main, null, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", null, "Main Landmark"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textfield.TextField), {
        label: "First Name"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement(Region, null, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", null, "Region Landmark inside Main"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _checkbox.Checkbox), null, "Checkbox label"))));
}
// TODO: known accessiblity failure https://github.com/adobe/react-spectrum/wiki/Known-accessibility-false-positives#tableview
function TableExample() {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", null, /*#__PURE__*/ (0, _reactDefault.default).createElement(Navigation, null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _actiongroup.ActionGroup), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _actiongroup.Item), null, "One"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _actiongroup.Item), null, "Two"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _actiongroup.Item), null, "Three"))), /*#__PURE__*/ (0, _reactDefault.default).createElement(Main, null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _table.TableView), {
        "aria-label": "Table"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _table.TableHeader), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _table.Column), {
        key: "foo",
        allowsSorting: true
    }, "Foo"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _table.Column), {
        key: "bar",
        allowsSorting: true
    }, "Bar"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _table.Column), {
        key: "baz"
    }, "Baz")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _table.TableBody), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _table.Row), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _table.Cell), null, "Foo 1"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _table.Cell), null, "Bar 1"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _table.Cell), null, "Baz 1")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _table.Row), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _table.Cell), null, "Foo 2"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _table.Cell), null, "Bar 2"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _table.Cell), null, "Baz 2")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _table.Row), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _table.Cell), null, "Foo 3"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _table.Cell), null, "Bar 3"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _table.Cell), null, "Baz 3"))))));
}
// ['main', 'region', 'search', 'navigation', 'form', 'banner', 'contentinfo', 'complementary']
function ApplicationExample() {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _utils.classNames)((0, _indexCssDefault.default), "application")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Region, {
        UNSAFE_className: (0, _utils.classNames)((0, _indexCssDefault.default), "globalnav")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
        justifyContent: "space-between"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _link.Link), null, /*#__PURE__*/ (0, _reactDefault.default).createElement("a", {
        href: "//react-spectrum.com"
    }, "React Spectrum")), /*#__PURE__*/ (0, _reactDefault.default).createElement(Search, null))), /*#__PURE__*/ (0, _reactDefault.default).createElement(Navigation, {
        UNSAFE_className: (0, _utils.classNames)((0, _indexCssDefault.default), "navigation"),
        "aria-label": "Site Nav"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _actiongroup.ActionGroup), {
        orientation: "vertical"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _actiongroup.Item), null, "One"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _actiongroup.Item), null, "Two"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _actiongroup.Item), null, "Three"))), /*#__PURE__*/ (0, _reactDefault.default).createElement(Main, {
        UNSAFE_className: (0, _utils.classNames)((0, _indexCssDefault.default), "main")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _table.TableView), {
        "aria-label": "Table",
        justifySelf: "stretch"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _table.TableHeader), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _table.Column), {
        key: "foo",
        allowsSorting: true
    }, "Foo"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _table.Column), {
        key: "bar",
        allowsSorting: true
    }, "Bar"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _table.Column), {
        key: "baz"
    }, "Baz")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _table.TableBody), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _table.Row), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _table.Cell), null, "Foo 1"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _table.Cell), null, "Bar 1"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _table.Cell), null, "Baz 1")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _table.Row), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _table.Cell), null, "Foo 2"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _table.Cell), null, "Bar 2"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _table.Cell), null, "Baz 2")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _table.Row), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _table.Cell), null, "Foo 3"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _table.Cell), null, "Bar 3"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _table.Cell), null, "Baz 3"))))), /*#__PURE__*/ (0, _reactDefault.default).createElement(Navigation, {
        UNSAFE_className: (0, _utils.classNames)((0, _indexCssDefault.default), "navigation-content"),
        "aria-label": "Content Nav"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _actiongroup.ActionGroup), {
        orientation: "vertical"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _actiongroup.Item), null, "One"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _actiongroup.Item), null, "Two"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _actiongroup.Item), null, "Three"))));
}
function IframeExample() {
    let controller = (0, _react.useMemo)(()=>(0, _.createLandmarkController)(), []);
    (0, _react.useEffect)(()=>()=>controller.dispose(), [
        controller
    ]);
    let onLoad = (e)=>{
        let iframe = e.target;
        let window1 = iframe.contentWindow;
        let document = window1 === null || window1 === void 0 ? void 0 : window1.document;
        if (!window1 || !document) return;
        let prevFocusedElement = null;
        window1.addEventListener("react-aria-landmark-navigation", (e)=>{
            e.preventDefault();
            if (!window1 || !document) return;
            let el = document.activeElement;
            if (el !== document.body) prevFocusedElement = el;
            // Prevent focus scope from stealing focus back when we move focus to the iframe.
            document.body.setAttribute("data-react-aria-top-layer", "true");
            window1.parent.postMessage({
                type: "landmark-navigation",
                direction: e.detail.direction
            });
            setTimeout(()=>{
                document === null || document === void 0 ? void 0 : document.body.removeAttribute("data-react-aria-top-layer");
            }, 100);
        });
        // When the iframe is re-focused, restore focus back inside where it was before.
        window1.addEventListener("focus", ()=>{
            if (prevFocusedElement) {
                prevFocusedElement.focus();
                prevFocusedElement = null;
            }
        });
        // Move focus to first or last landmark when we receive a message from the parent page.
        window1.addEventListener("message", (e)=>{
            if (e.data.type === "landmark-navigation") // (Can't use LandmarkController in this example because we need the controller instance inside the iframe)
            document === null || document === void 0 ? void 0 : document.body.dispatchEvent(new KeyboardEvent("keydown", {
                key: "F6",
                shiftKey: e.data.direction === "backward",
                bubbles: true
            }));
        });
    };
    let ref = (0, _react.useRef)(null);
    (0, _react.useEffect)(()=>{
        let onMessage = (e)=>{
            let iframe = ref.current;
            if (e.data.type === "landmark-navigation") {
                // Move focus to the iframe so that when focus is restored there, and we can redirect it back inside (below).
                iframe === null || iframe === void 0 ? void 0 : iframe.focus();
                // Now re-dispatch the keyboard event so landmark navigation outside the iframe picks it up.
                controller.navigate(e.data.direction);
            }
        };
        window.addEventListener("message", onMessage);
        return ()=>window.removeEventListener("message", onMessage);
    }, [
        controller
    ]);
    let { landmarkProps } = (0, _.useLandmark)({
        role: "main",
        focus (direction) {
            var // when iframe landmark receives focus via landmark navigation, go to first/last landmark inside iframe.
            _ref_current_contentWindow, _ref_current;
            (_ref_current = ref.current) === null || _ref_current === void 0 ? void 0 : (_ref_current_contentWindow = _ref_current.contentWindow) === null || _ref_current_contentWindow === void 0 ? void 0 : _ref_current_contentWindow.postMessage({
                type: "landmark-navigation",
                direction
            });
        }
    }, ref);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _utils.classNames)((0, _indexCssDefault.default), "application")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Region, {
        UNSAFE_className: (0, _utils.classNames)((0, _indexCssDefault.default), "globalnav")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
        justifyContent: "space-between"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _link.Link), null, /*#__PURE__*/ (0, _reactDefault.default).createElement("a", {
        href: "//react-spectrum.com"
    }, "React Spectrum")), /*#__PURE__*/ (0, _reactDefault.default).createElement(Search, null))), /*#__PURE__*/ (0, _reactDefault.default).createElement(Navigation, {
        UNSAFE_className: (0, _utils.classNames)((0, _indexCssDefault.default), "navigation"),
        "aria-label": "Site Nav"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _actiongroup.ActionGroup), {
        orientation: "vertical"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _actiongroup.Item), null, "One"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _actiongroup.Item), null, "Two"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _actiongroup.Item), null, "Three"))), /*#__PURE__*/ (0, _reactDefault.default).createElement("iframe", {
        ref: ref,
        ...landmarkProps,
        title: "iframe",
        style: {
            width: "100%",
            height: "100%"
        },
        src: "iframe.html?providerSwitcher-express=false&providerSwitcher-toastPosition=bottom&providerSwitcher-locale=&providerSwitcher-theme=&providerSwitcher-scale=&args=&id=landmark--application-with-landmarks&viewMode=story",
        onLoad: onLoad,
        tabIndex: -1
    }));
}
const FlatLandmarks = {
    render: Template
};
const NestedLandmarks = {
    render: NestedTemplate
};
const TableLandmark = {
    render: TableTemplate,
    parameters: {
        a11y: {
            config: {
                // Fails due to TableView's known issue, ignoring here since it isn't pertinent to the story
                rules: [
                    {
                        id: "aria-required-children",
                        selector: '*:not([role="grid"])'
                    }
                ]
            }
        }
    }
};
const ApplicationWithLandmarks = {
    render: ApplicationTemplate,
    parameters: {
        a11y: {
            config: {
                // Fails due to TableView's known issue, ignoring here since it isn't pertinent to the story
                rules: [
                    {
                        id: "aria-required-children",
                        selector: '*:not([role="grid"])'
                    }
                ]
            }
        }
    }
};
const DuplicateRolesWithLabels = {
    render: DuplicateRolesWithLabelsTemplate
};
const DuplicateRolesWithNoLabels = {
    render: DuplicateRolesWithNoLabelsTemplate,
    parameters: {
        a11y: {
            config: {
                rules: [
                    {
                        id: "landmark-unique",
                        enabled: false
                    }
                ]
            }
        }
    }
};
const DuplicateRolesWithSameLabels = {
    render: DuplicateRolesWithSameLabelsTemplate,
    parameters: {
        a11y: {
            config: {
                rules: [
                    {
                        id: "landmark-unique",
                        enabled: false
                    }
                ]
            }
        }
    }
};
const OneWithNoFocusableChildren = {
    render: OneWithNoFocusableChildrenExampleTemplate
};
const AllWithNoFocusableChildren = {
    render: AllWithNoFocusableChildrenExampleTemplate
};
const IframeExampleStory = {
    render: IframeExample,
    parameters: {
        a11y: {
            config: {
                rules: [
                    {
                        id: "aria-allowed-role",
                        enabled: false
                    }
                ]
            }
        }
    },
    name: "iframe example"
};

},{"@react-spectrum/actiongroup":"hkqBV","@react-spectrum/table":"gptJH","@react-spectrum/checkbox":"1r19j","@react-spectrum/utils":"cMIJ6","../":"duzQE","@react-spectrum/layout":"hzaUY","@react-spectrum/link":"lNoiB","react":"9yzVZ","@react-spectrum/searchfield":"2pivm","./index.css":"iIy0J","@react-spectrum/textfield":"hOmtq","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"duzQE":[function(require,module,exports) {
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _src = require("./src");
parcelHelpers.exportAll(_src, exports);

},{"./src":"8X64T","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"8X64T":[function(require,module,exports) {
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useLandmark", ()=>(0, _useLandmark.useLandmark));
parcelHelpers.export(exports, "createLandmarkController", ()=>(0, _useLandmark.createLandmarkController));
var _useLandmark = require("./useLandmark");

},{"./useLandmark":"kls4d","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"kls4d":[function(require,module,exports) {
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/** Creates a LandmarkController, which allows programmatic navigation of landmarks. */ parcelHelpers.export(exports, "createLandmarkController", ()=>createLandmarkController);
/**
 * Provides landmark navigation in an application. Call this with a role and label to register a landmark navigable with F6.
 * @param props - Props for the landmark.
 * @param ref - Ref to the landmark.
 */ parcelHelpers.export(exports, "useLandmark", ()=>useLandmark);
var _react = require("react");
var _utils = require("@react-aria/utils");
var _indexJs = require("use-sync-external-store/shim/index.js");
// Increment this version number whenever the
// LandmarkManagerApi or Landmark interfaces change.
const LANDMARK_API_VERSION = 1;
// Symbol under which the singleton landmark manager instance is attached to the document.
const landmarkSymbol = Symbol.for("react-aria-landmark-manager");
function subscribe(fn) {
    document.addEventListener("react-aria-landmark-manager-change", fn);
    return ()=>document.removeEventListener("react-aria-landmark-manager-change", fn);
}
function getLandmarkManager() {
    if (typeof document === "undefined") return null;
    // Reuse an existing instance if it has the same or greater version.
    let instance = document[landmarkSymbol];
    if (instance && instance.version >= LANDMARK_API_VERSION) return instance;
    // Otherwise, create a new instance and dispatch an event so anything using the existing
    // instance updates and re-registers their landmarks with the new one.
    document[landmarkSymbol] = new LandmarkManager();
    document.dispatchEvent(new CustomEvent("react-aria-landmark-manager-change"));
    return document[landmarkSymbol];
}
// Subscribes a React component to the current landmark manager instance.
function useLandmarkManager() {
    return (0, _indexJs.useSyncExternalStore)(subscribe, getLandmarkManager, getLandmarkManager);
}
class LandmarkManager {
    setupIfNeeded() {
        if (this.isListening) return;
        document.addEventListener("keydown", this.f6Handler, {
            capture: true
        });
        document.addEventListener("focusin", this.focusinHandler, {
            capture: true
        });
        document.addEventListener("focusout", this.focusoutHandler, {
            capture: true
        });
        this.isListening = true;
    }
    teardownIfNeeded() {
        if (!this.isListening || this.landmarks.length > 0 || this.refCount > 0) return;
        document.removeEventListener("keydown", this.f6Handler, {
            capture: true
        });
        document.removeEventListener("focusin", this.focusinHandler, {
            capture: true
        });
        document.removeEventListener("focusout", this.focusoutHandler, {
            capture: true
        });
        this.isListening = false;
    }
    focusLandmark(landmark, direction) {
        var _this_landmarks_find_focus, _this_landmarks_find;
        (_this_landmarks_find = this.landmarks.find((l)=>l.ref.current === landmark)) === null || _this_landmarks_find === void 0 ? void 0 : (_this_landmarks_find_focus = _this_landmarks_find.focus) === null || _this_landmarks_find_focus === void 0 ? void 0 : _this_landmarks_find_focus.call(_this_landmarks_find, direction);
    }
    /**
   * Return set of landmarks with a specific role.
   */ getLandmarksByRole(role) {
        return new Set(this.landmarks.filter((l)=>l.role === role));
    }
    /**
   * Return first landmark with a specific role.
   */ getLandmarkByRole(role) {
        return this.landmarks.find((l)=>l.role === role);
    }
    addLandmark(newLandmark) {
        this.setupIfNeeded();
        if (this.landmarks.find((landmark)=>landmark.ref === newLandmark.ref) || !newLandmark.ref.current) return;
        if (this.landmarks.filter((landmark)=>landmark.role === "main").length > 1) console.error('Page can contain no more than one landmark with the role "main".');
        if (this.landmarks.length === 0) {
            this.landmarks = [
                newLandmark
            ];
            this.checkLabels(newLandmark.role);
            return;
        }
        // Binary search to insert new landmark based on position in document relative to existing landmarks.
        // https://developer.mozilla.org/en-US/docs/Web/API/Node/compareDocumentPosition
        let start = 0;
        let end = this.landmarks.length - 1;
        while(start <= end){
            let mid = Math.floor((start + end) / 2);
            let comparedPosition = newLandmark.ref.current.compareDocumentPosition(this.landmarks[mid].ref.current);
            let isNewAfterExisting = Boolean(comparedPosition & Node.DOCUMENT_POSITION_PRECEDING || comparedPosition & Node.DOCUMENT_POSITION_CONTAINS);
            if (isNewAfterExisting) start = mid + 1;
            else end = mid - 1;
        }
        this.landmarks.splice(start, 0, newLandmark);
        this.checkLabels(newLandmark.role);
    }
    updateLandmark(landmark) {
        let index = this.landmarks.findIndex((l)=>l.ref === landmark.ref);
        if (index >= 0) {
            this.landmarks[index] = {
                ...this.landmarks[index],
                ...landmark
            };
            this.checkLabels(this.landmarks[index].role);
        }
    }
    removeLandmark(ref) {
        this.landmarks = this.landmarks.filter((landmark)=>landmark.ref !== ref);
        this.teardownIfNeeded();
    }
    /**
   * Warn if there are 2+ landmarks with the same role but no label.
   * Labels for landmarks with the same role must also be unique.
   *
   * See https://www.w3.org/WAI/ARIA/apg/practices/landmark-regions/.
   */ checkLabels(role) {
        let landmarksWithRole = this.getLandmarksByRole(role);
        if (landmarksWithRole.size > 1) {
            let duplicatesWithoutLabel = [
                ...landmarksWithRole
            ].filter((landmark)=>!landmark.label);
            if (duplicatesWithoutLabel.length > 0) console.warn(`Page contains more than one landmark with the '${role}' role. If two or more landmarks on a page share the same role, all must be labeled with an aria-label or aria-labelledby attribute: `, duplicatesWithoutLabel.map((landmark)=>landmark.ref.current));
            else {
                let labels = [
                    ...landmarksWithRole
                ].map((landmark)=>landmark.label);
                let duplicateLabels = labels.filter((item, index)=>labels.indexOf(item) !== index);
                duplicateLabels.forEach((label)=>{
                    console.warn(`Page contains more than one landmark with the '${role}' role and '${label}' label. If two or more landmarks on a page share the same role, they must have unique labels: `, [
                        ...landmarksWithRole
                    ].filter((landmark)=>landmark.label === label).map((landmark)=>landmark.ref.current));
                });
            }
        }
    }
    /**
   * Get the landmark that is the closest parent in the DOM.
   * Returns undefined if no parent is a landmark.
   */ closestLandmark(element) {
        let landmarkMap = new Map(this.landmarks.map((l)=>[
                l.ref.current,
                l
            ]));
        let currentElement = element;
        while(currentElement && !landmarkMap.has(currentElement) && currentElement !== document.body && currentElement.parentElement)currentElement = currentElement.parentElement;
        return landmarkMap.get(currentElement);
    }
    /**
   * Gets the next landmark, in DOM focus order, or previous if backwards is specified.
   * If last landmark, next should be the first landmark.
   * If not inside a landmark, will return first landmark.
   * Returns undefined if there are no landmarks.
   */ getNextLandmark(element, { backward }) {
        var _this_landmarks_nextLandmarkIndex_ref_current;
        let currentLandmark = this.closestLandmark(element);
        let nextLandmarkIndex = backward ? this.landmarks.length - 1 : 0;
        if (currentLandmark) nextLandmarkIndex = this.landmarks.indexOf(currentLandmark) + (backward ? -1 : 1);
        let wrapIfNeeded = ()=>{
            // When we reach the end of the landmark sequence, fire a custom event that can be listened for by applications.
            // If this event is canceled, we return immediately. This can be used to implement landmark navigation across iframes.
            if (nextLandmarkIndex < 0) {
                if (!element.dispatchEvent(new CustomEvent("react-aria-landmark-navigation", {
                    detail: {
                        direction: "backward"
                    },
                    bubbles: true,
                    cancelable: true
                }))) return true;
                nextLandmarkIndex = this.landmarks.length - 1;
            } else if (nextLandmarkIndex >= this.landmarks.length) {
                if (!element.dispatchEvent(new CustomEvent("react-aria-landmark-navigation", {
                    detail: {
                        direction: "forward"
                    },
                    bubbles: true,
                    cancelable: true
                }))) return true;
                nextLandmarkIndex = 0;
            }
            if (nextLandmarkIndex < 0 || nextLandmarkIndex >= this.landmarks.length) return true;
            return false;
        };
        if (wrapIfNeeded()) return undefined;
        // Skip over hidden landmarks.
        let i = nextLandmarkIndex;
        while((_this_landmarks_nextLandmarkIndex_ref_current = this.landmarks[nextLandmarkIndex].ref.current) === null || _this_landmarks_nextLandmarkIndex_ref_current === void 0 ? void 0 : _this_landmarks_nextLandmarkIndex_ref_current.closest("[aria-hidden=true]")){
            nextLandmarkIndex += backward ? -1 : 1;
            if (wrapIfNeeded()) return undefined;
            if (nextLandmarkIndex === i) break;
        }
        return this.landmarks[nextLandmarkIndex];
    }
    /**
   * Look at next landmark. If an element was previously focused inside, restore focus there.
   * If not, focus the landmark itself.
   * If no landmarks at all, or none with focusable elements, don't move focus.
   */ f6Handler(e) {
        if (e.key === "F6") {
            // If alt key pressed, focus main landmark, otherwise navigate forward or backward based on shift key.
            let handled = e.altKey ? this.focusMain() : this.navigate(e.target, e.shiftKey);
            if (handled) {
                e.preventDefault();
                e.stopPropagation();
            }
        }
    }
    focusMain() {
        let main = this.getLandmarkByRole("main");
        if (main && main.ref.current && document.contains(main.ref.current)) {
            this.focusLandmark(main.ref.current, "forward");
            return true;
        }
        return false;
    }
    navigate(from, backward) {
        let nextLandmark = this.getNextLandmark(from, {
            backward
        });
        if (!nextLandmark) return false;
        // If something was previously focused in the next landmark, then return focus to it
        if (nextLandmark.lastFocused) {
            let lastFocused = nextLandmark.lastFocused;
            if (document.body.contains(lastFocused)) {
                lastFocused.focus();
                return true;
            }
        }
        // Otherwise, focus the landmark itself
        if (nextLandmark.ref.current && document.contains(nextLandmark.ref.current)) {
            this.focusLandmark(nextLandmark.ref.current, backward ? "backward" : "forward");
            return true;
        }
        return false;
    }
    /**
   * Sets lastFocused for a landmark, if focus is moved within that landmark.
   * Lets the last focused landmark know it was blurred if something else is focused.
   */ focusinHandler(e) {
        let currentLandmark = this.closestLandmark(e.target);
        if (currentLandmark && currentLandmark.ref.current !== e.target) this.updateLandmark({
            ref: currentLandmark.ref,
            lastFocused: e.target
        });
        let previousFocusedElement = e.relatedTarget;
        if (previousFocusedElement) {
            let closestPreviousLandmark = this.closestLandmark(previousFocusedElement);
            if (closestPreviousLandmark && closestPreviousLandmark.ref.current === previousFocusedElement) closestPreviousLandmark.blur();
        }
    }
    /**
   * Track if the focus is lost to the body. If it is, do cleanup on the landmark that last had focus.
   */ focusoutHandler(e) {
        let previousFocusedElement = e.target;
        let nextFocusedElement = e.relatedTarget;
        // the === document seems to be a jest thing for focus to go there on generic blur event such as landmark.blur();
        // browsers appear to send focus instead to document.body and the relatedTarget is null when that happens
        if (!nextFocusedElement || nextFocusedElement === document) {
            let closestPreviousLandmark = this.closestLandmark(previousFocusedElement);
            if (closestPreviousLandmark && closestPreviousLandmark.ref.current === previousFocusedElement) closestPreviousLandmark.blur();
        }
    }
    createLandmarkController() {
        let instance = this;
        instance.refCount++;
        instance.setupIfNeeded();
        return {
            navigate (direction, opts) {
                let element = (opts === null || opts === void 0 ? void 0 : opts.from) || document.activeElement;
                return instance.navigate(element, direction === "backward");
            },
            focusNext (opts) {
                let element = (opts === null || opts === void 0 ? void 0 : opts.from) || document.activeElement;
                return instance.navigate(element, false);
            },
            focusPrevious (opts) {
                let element = (opts === null || opts === void 0 ? void 0 : opts.from) || document.activeElement;
                return instance.navigate(element, true);
            },
            focusMain () {
                return instance.focusMain();
            },
            dispose () {
                if (instance) {
                    instance.refCount--;
                    instance.teardownIfNeeded();
                    instance = null;
                }
            }
        };
    }
    registerLandmark(landmark) {
        if (this.landmarks.find((l)=>l.ref === landmark.ref)) this.updateLandmark(landmark);
        else this.addLandmark(landmark);
        return ()=>this.removeLandmark(landmark.ref);
    }
    constructor(){
        this.landmarks = [];
        this.isListening = false;
        this.refCount = 0;
        this.version = LANDMARK_API_VERSION;
        this.f6Handler = this.f6Handler.bind(this);
        this.focusinHandler = this.focusinHandler.bind(this);
        this.focusoutHandler = this.focusoutHandler.bind(this);
    }
}
function createLandmarkController() {
    // Get the current landmark manager and create a controller using it.
    let instance = getLandmarkManager();
    let controller = instance === null || instance === void 0 ? void 0 : instance.createLandmarkController();
    let unsubscribe = subscribe(()=>{
        // If the landmark manager changes, dispose the old
        // controller and create a new one.
        controller === null || controller === void 0 ? void 0 : controller.dispose();
        instance = getLandmarkManager();
        controller = instance === null || instance === void 0 ? void 0 : instance.createLandmarkController();
    });
    // Return a wrapper that proxies requests to the current controller instance.
    return {
        navigate (direction, opts) {
            return controller.navigate(direction, opts);
        },
        focusNext (opts) {
            return controller.focusNext(opts);
        },
        focusPrevious (opts) {
            return controller.focusPrevious(opts);
        },
        focusMain () {
            return controller.focusMain();
        },
        dispose () {
            controller === null || controller === void 0 ? void 0 : controller.dispose();
            unsubscribe();
            controller = undefined;
            instance = null;
        }
    };
}
function useLandmark(props, ref) {
    const { role, "aria-label": ariaLabel, "aria-labelledby": ariaLabelledby, focus } = props;
    let manager = useLandmarkManager();
    let label = ariaLabel || ariaLabelledby;
    let [isLandmarkFocused, setIsLandmarkFocused] = (0, _react.useState)(false);
    let defaultFocus = (0, _react.useCallback)(()=>{
        setIsLandmarkFocused(true);
    }, [
        setIsLandmarkFocused
    ]);
    let blur = (0, _react.useCallback)(()=>{
        setIsLandmarkFocused(false);
    }, [
        setIsLandmarkFocused
    ]);
    (0, _utils.useLayoutEffect)(()=>{
        if (manager) return manager.registerLandmark({
            ref,
            label,
            role,
            focus: focus || defaultFocus,
            blur
        });
    }, [
        manager,
        label,
        ref,
        role,
        focus,
        defaultFocus,
        blur
    ]);
    (0, _react.useEffect)(()=>{
        var _ref_current;
        if (isLandmarkFocused) (_ref_current = ref.current) === null || _ref_current === void 0 ? void 0 : _ref_current.focus();
    }, [
        isLandmarkFocused,
        ref
    ]);
    return {
        landmarkProps: {
            role,
            tabIndex: isLandmarkFocused ? -1 : undefined,
            "aria-label": ariaLabel,
            "aria-labelledby": ariaLabelledby
        }
    };
}

},{"react":"9yzVZ","@react-aria/utils":"9cLk5","use-sync-external-store/shim/index.js":"41GFF","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"lNoiB":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /// <reference types="css-module-types" />
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Link", ()=>(0, _link.Link));
var _link = require("./Link");

},{"./Link":"h6F6L","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"h6F6L":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Links allow users to navigate to a different location.
 * They can be presented inline inside a paragraph or as standalone text.
 */ parcelHelpers.export(exports, "Link", ()=>Link);
var _utils = require("@react-spectrum/utils");
var _focus = require("@react-aria/focus");
var _utils1 = require("@react-aria/utils");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _varsCss = require("@adobe/spectrum-css-temp/components/link/vars.css");
var _varsCssDefault = parcelHelpers.interopDefault(_varsCss);
var _interactions = require("@react-aria/interactions");
var _link = require("@react-aria/link");
var _provider = require("@react-spectrum/provider");
function Link(props) {
    props = (0, _provider.useProviderProps)(props);
    props = (0, _utils.useSlotProps)(props, "link");
    let { variant = "primary", isQuiet, children, // @ts-ignore
    href } = props;
    let { styleProps } = (0, _utils.useStyleProps)(props);
    let { hoverProps, isHovered } = (0, _interactions.useHover)({});
    let ref = (0, _react.useRef)(null);
    let { linkProps } = (0, _link.useLink)({
        ...props,
        elementType: !href && typeof children === "string" ? "span" : "a"
    }, ref);
    let domProps = {
        ...styleProps,
        ...(0, _utils1.mergeProps)(linkProps, hoverProps),
        ref,
        className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Link", {
            "spectrum-Link--quiet": isQuiet,
            [`spectrum-Link--${variant}`]: variant,
            "is-hovered": isHovered
        }, styleProps.className)
    };
    let link;
    if (href) link = /*#__PURE__*/ (0, _reactDefault.default).createElement("a", domProps, children);
    else {
        // Backward compatibility.
        let wrappedChild = (0, _utils.getWrappedElement)(children);
        link = /*#__PURE__*/ (0, _reactDefault.default).cloneElement(wrappedChild, {
            ...(0, _utils1.mergeProps)(wrappedChild.props, domProps),
            // @ts-ignore https://github.com/facebook/react/issues/8873
            ref: wrappedChild.ref ? (0, _utils1.mergeRefs)(ref, wrappedChild.ref) : ref
        });
    }
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _focus.FocusRing), {
        focusRingClass: (0, _utils.classNames)((0, _varsCssDefault.default), "focus-ring")
    }, link);
}

},{"@react-spectrum/utils":"cMIJ6","@react-aria/focus":"42mbF","@react-aria/utils":"9cLk5","react":"9yzVZ","@adobe/spectrum-css-temp/components/link/vars.css":"fmdAO","@react-aria/interactions":"ky3G8","@react-aria/link":"6MxkS","@react-spectrum/provider":"5bCdp","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"fmdAO":[function(require,module,exports) {
module.exports["focus-ring"] = `WBgRPa_focus-ring`;
module.exports["i18nFontFamily"] = `WBgRPa_i18nFontFamily`;
module.exports["is-disabled"] = `WBgRPa_is-disabled`;
module.exports["is-hovered"] = `WBgRPa_is-hovered`;
module.exports["spectrum-FocusRing-ring"] = `WBgRPa_spectrum-FocusRing-ring`;
module.exports["spectrum-FocusRing"] = `WBgRPa_spectrum-FocusRing ${module.exports["spectrum-FocusRing-ring"]}`;
module.exports["spectrum-FocusRing--quiet"] = `WBgRPa_spectrum-FocusRing--quiet`;
module.exports["spectrum-Link"] = `WBgRPa_spectrum-Link`;
module.exports["spectrum-Link--overBackground"] = `WBgRPa_spectrum-Link--overBackground`;
module.exports["spectrum-Link--quiet"] = `WBgRPa_spectrum-Link--quiet`;
module.exports["spectrum-Link--secondary"] = `WBgRPa_spectrum-Link--secondary`;

},{}],"iIy0J":[function(require,module,exports) {
module.exports["application"] = `Mbh6wG_application`;
module.exports["content"] = `Mbh6wG_content`;
module.exports["landmark"] = `Mbh6wG_landmark`;
module.exports["globalnav"] = `Mbh6wG_globalnav ${module.exports["landmark"]}`;
module.exports["main"] = `Mbh6wG_main ${module.exports["landmark"]}`;
module.exports["navcontent"] = `Mbh6wG_navcontent`;
module.exports["navigation"] = `Mbh6wG_navigation ${module.exports["landmark"]}`;
module.exports["navigation-content"] = `Mbh6wG_navigation-content ${module.exports["landmark"]}`;

},{}],"1xVvy":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DoubleMenuFiresOnInteractOutside", ()=>DoubleMenuFiresOnInteractOutside);
var _addonActions = require("@storybook/addon-actions");
var _overlays = require("@react-aria/overlays");
var _focus = require("@react-aria/focus");
var _collections = require("@react-stately/collections");
var _utils = require("@react-aria/utils");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _button = require("@react-aria/button");
var _interactions = require("@react-aria/interactions");
var _menu = require("@react-aria/menu");
var _menu1 = require("@react-stately/menu");
var _tree = require("@react-stately/tree");
exports.default = {
    title: "useMenu"
};
const DoubleMenuFiresOnInteractOutside = {
    render: ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement("div", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", null, "This should just be there to show that onInteractOutside fires when clicking on another trigger."), /*#__PURE__*/ (0, _reactDefault.default).createElement(MenuButton, {
            label: "Actions"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _collections.Item), {
            key: "copy"
        }, "Copy"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _collections.Item), {
            key: "cut"
        }, "Cut"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _collections.Item), {
            key: "paste"
        }, "Paste")), /*#__PURE__*/ (0, _reactDefault.default).createElement(MenuButton, {
            label: "Actions2"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _collections.Item), {
            key: "copy"
        }, "Copy"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _collections.Item), {
            key: "cut"
        }, "Cut"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _collections.Item), {
            key: "paste"
        }, "Paste")), /*#__PURE__*/ (0, _reactDefault.default).createElement("input", {
            "aria-label": "input after"
        })),
    name: "double menu fires onInteractOutside"
};
function MenuButton(props) {
    // Create state based on the incoming props
    let state = (0, _menu1.useMenuTriggerState)(props);
    // Get props for the menu trigger and menu elements
    let ref = (0, _reactDefault.default).useRef();
    let { menuTriggerProps, menuProps } = (0, _menu.useMenuTrigger)({}, state, ref);
    // Get props for the button based on the trigger props from useMenuTrigger
    let { buttonProps } = (0, _button.useButton)(menuTriggerProps, ref);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        style: {
            position: "relative",
            display: "inline-block"
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("button", {
        ...buttonProps,
        ref: ref,
        style: {
            height: 30,
            fontSize: 14
        }
    }, props.label, /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        "aria-hidden": "true",
        style: {
            paddingLeft: 5
        }
    }, "\u25BC")), state.isOpen && /*#__PURE__*/ (0, _reactDefault.default).createElement(MenuPopup, {
        ...props,
        domProps: menuProps,
        autoFocus: state.focusStrategy,
        onClose: ()=>state.close()
    }));
}
function MenuPopup(props) {
    // Create menu state based on the incoming props
    let state = (0, _tree.useTreeState)({
        ...props,
        selectionMode: "none"
    });
    // Get props for the menu element
    let ref = (0, _reactDefault.default).useRef();
    let { menuProps } = (0, _menu.useMenu)(props, state, ref);
    // Handle events that should cause the menu to close,
    // e.g. blur, clicking outside, or pressing the escape key.
    let overlayRef = (0, _reactDefault.default).useRef();
    // before useOverlay so this action will get called
    (0, _interactions.useInteractOutside)({
        ref: overlayRef,
        onInteractOutside: (0, _addonActions.action)("onInteractOutside")
    });
    let { overlayProps } = (0, _overlays.useOverlay)({
        onClose: props.onClose,
        shouldCloseOnBlur: true,
        isOpen: true,
        isDismissable: true
    }, overlayRef);
    // Wrap in <FocusScope> so that focus is restored back to the
    // trigger when the menu is closed. In addition, add hidden
    // <DismissButton> components at the start and end of the list
    // to allow screen reader users to dismiss the popup easily.
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _focus.FocusScope), {
        restoreFocus: true
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...overlayProps,
        ref: overlayRef
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _overlays.DismissButton), {
        onDismiss: props.onClose
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("ul", {
        ...(0, _utils.mergeProps)(menuProps, props.domProps),
        ref: ref,
        style: {
            position: "absolute",
            width: "100%",
            margin: "4px 0 0 0",
            padding: 0,
            listStyle: "none",
            border: "1px solid gray",
            background: "lightgray"
        }
    }, [
        ...state.collection
    ].map((item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(MenuItem, {
            key: item.key,
            item: item,
            state: state,
            onAction: props.onAction,
            onClose: props.onClose
        }))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _overlays.DismissButton), {
        onDismiss: props.onClose
    })));
}
function MenuItem({ item, state, onAction, onClose }) {
    // Get props for the menu item element
    let ref = (0, _reactDefault.default).useRef();
    let { menuItemProps } = (0, _menu.useMenuItem)({
        key: item.key,
        isDisabled: item.isDisabled,
        onAction,
        onClose
    }, state, ref);
    // Handle focus events so we can apply highlighted
    // style to the focused menu item
    let [isFocused, setFocused] = (0, _reactDefault.default).useState(false);
    let { focusProps } = (0, _interactions.useFocus)({
        onFocusChange: setFocused
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("li", {
        ...(0, _utils.mergeProps)(menuItemProps, focusProps),
        ref: ref,
        style: {
            background: isFocused ? "gray" : "transparent",
            color: isFocused ? "white" : "black",
            padding: "2px 5px",
            outline: "none",
            cursor: "pointer"
        }
    }, item.rendered);
}

},{"@storybook/addon-actions":"coXbW","@react-aria/overlays":"5fTCg","@react-aria/focus":"42mbF","@react-stately/collections":"loANi","@react-aria/utils":"9cLk5","react":"9yzVZ","@react-aria/button":"fsdLZ","@react-aria/interactions":"ky3G8","@react-aria/menu":"89bvn","@react-stately/menu":"iqDQI","@react-stately/tree":"f1QlQ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"h6MHG":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DocumentBodyContainerBottom", ()=>DocumentBodyContainerBottom);
parcelHelpers.export(exports, "DocumentBodyContainerTop", ()=>DocumentBodyContainerTop);
parcelHelpers.export(exports, "PositionedContainerBottom", ()=>PositionedContainerBottom);
parcelHelpers.export(exports, "PositionedContainerTop", ()=>PositionedContainerTop);
parcelHelpers.export(exports, "ButtonWidth500DocumentBodyBottomStart", ()=>ButtonWidth500DocumentBodyBottomStart);
parcelHelpers.export(exports, "MaxHeight200ContainerBottom", ()=>MaxHeight200ContainerBottom);
parcelHelpers.export(exports, "MaxHeight200ContainerTop", ()=>MaxHeight200ContainerTop);
var _utils = require("@react-aria/utils");
var _react = require("react");
var _reactDom = require("react-dom");
var _src = require("../src");
var _overlays = require("@react-stately/overlays");
function Trigger(props) {
    const { withPortal, placement, maxHeight, buttonWidth } = props;
    const targetRef = _react.useRef(null);
    const overlayRef = _react.useRef(null);
    const state = (0, _overlays.useOverlayTriggerState)({
        defaultOpen: false
    });
    const { triggerProps, overlayProps } = (0, _src.useOverlayTrigger)({
        type: "menu"
    }, state, targetRef);
    const { overlayProps: overlayPositionProps } = (0, _src.useOverlayPosition)({
        targetRef,
        overlayRef,
        shouldFlip: false,
        isOpen: state.isOpen,
        offset: 10,
        placement,
        maxHeight
    });
    let overlay = /*#__PURE__*/ _react.createElement("div", {
        ref: overlayRef,
        ...(0, _utils.mergeProps)(overlayProps, overlayPositionProps),
        style: {
            ...overlayPositionProps.style,
            boxShadow: "0 0 4px 0 rgba(0,0,0,0.25)",
            backgroundColor: "white",
            overflow: "auto"
        }
    }, /*#__PURE__*/ _react.createElement("ul", {
        style: {
            padding: 10,
            margin: 0,
            listStyleType: "none"
        }
    }, maxHeight ? [
        ...Array(20)
    ].map((_, i)=>/*#__PURE__*/ _react.createElement("li", null, "Hello ", i)) : [
        ...Array(5)
    ].map((_, i)=>/*#__PURE__*/ _react.createElement("li", null, "Hello ", i))));
    if (withPortal) overlay = /*#__PURE__*/ _reactDom.createPortal(overlay, document.body);
    return /*#__PURE__*/ _react.createElement("div", {
        style: {
            position: "relative",
            margin: "auto"
        }
    }, /*#__PURE__*/ _react.createElement("button", {
        ref: targetRef,
        ...triggerProps,
        style: {
            width: buttonWidth
        },
        onClick: ()=>state.toggle()
    }, "Trigger (open: ", `${state.isOpen}`, ")"), state.isOpen && overlay);
}
exports.default = {
    title: "UseOverlayPosition"
};
const DocumentBodyContainerBottom = ()=>/*#__PURE__*/ _react.createElement(Trigger, {
        withPortal: true,
        placement: "bottom"
    });
DocumentBodyContainerBottom.story = {
    name: "document.body container bottom"
};
const DocumentBodyContainerTop = ()=>/*#__PURE__*/ _react.createElement(Trigger, {
        withPortal: true,
        placement: "top"
    });
DocumentBodyContainerTop.story = {
    name: "document.body container top"
};
const PositionedContainerBottom = ()=>/*#__PURE__*/ _react.createElement(Trigger, {
        withPortal: false,
        placement: "bottom"
    });
PositionedContainerBottom.story = {
    name: "positioned container bottom"
};
const PositionedContainerTop = ()=>/*#__PURE__*/ _react.createElement(Trigger, {
        withPortal: false,
        placement: "top"
    });
PositionedContainerTop.story = {
    name: "positioned container top"
};
const ButtonWidth500DocumentBodyBottomStart = ()=>/*#__PURE__*/ _react.createElement(Trigger, {
        withPortal: true,
        buttonWidth: 500,
        placement: "bottom start"
    });
ButtonWidth500DocumentBodyBottomStart.story = {
    name: "buttonWidth=500 document.body bottom start"
};
const MaxHeight200ContainerBottom = ()=>/*#__PURE__*/ _react.createElement(Trigger, {
        withPortal: true,
        maxHeight: 200,
        placement: "bottom"
    });
MaxHeight200ContainerBottom.story = {
    name: "maxHeight=200 container bottom"
};
const MaxHeight200ContainerTop = ()=>/*#__PURE__*/ _react.createElement(Trigger, {
        withPortal: true,
        maxHeight: 200,
        placement: "top"
    });
MaxHeight200ContainerTop.story = {
    name: "maxHeight=200 container top"
};

},{"@react-aria/utils":"9cLk5","react":"9yzVZ","react-dom":"cEvV3","../src":"5fTCg","@react-stately/overlays":"5uxM4","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"52dWO":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DefaultContainer", ()=>DefaultContainer);
parcelHelpers.export(exports, "DifferentContainer", ()=>DifferentContainer);
var _button = require("@react-spectrum/button");
var _src = require("../src");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
exports.default = {
    title: "useModal"
};
const DefaultContainer = {
    render: ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement(App, null),
    name: "default container"
};
const DifferentContainer = {
    render: ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement(App, {
            useAlternateContainer: true
        }),
    name: "different container"
};
function App(props) {
    let [showModal, setShowModal] = (0, _react.useState)(false);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), {
        onPress: ()=>setShowModal((prev)=>!prev)
    }, "Toggle"), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        id: "alternateContainer",
        "data-testid": "alternate-container"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Example, {
        showModal: showModal,
        ...props
    }, "The Modal")));
}
function ModalDOM(props) {
    let { modalProps } = (0, _src.useModal)();
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        "data-testid": props.modalId || "modal",
        ...modalProps
    }, props.children);
}
function Modal(props) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _src.OverlayContainer), {
        portalContainer: props.container,
        "data-testid": props.providerId || "modal-provider"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(ModalDOM, {
        modalId: props.modalId
    }, props.children));
}
function Example(props) {
    let container = props.useAlternateContainer ? document.getElementById("alternateContainer") : undefined;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _src.OverlayProvider), {
        "data-testid": "root-provider"
    }, "This is the root provider.", props.showModal && /*#__PURE__*/ (0, _reactDefault.default).createElement(Modal, {
        container: container
    }, props.children));
}

},{"@react-spectrum/button":"jZWyP","../src":"5fTCg","react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"5GMmv":[function(require,module,exports) {
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Default", ()=>Default);
var _button = require("@react-spectrum/button");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _src = require("../src");
exports.default = {
    title: "usePreventScroll"
};
const Default = {
    render: ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement(App, null),
    name: "default",
    parameters: {
        description: {
            data: "Visit this story on a touch device. Click the button, then scroll. You should actively be scrolling when the prevent scroll kicks it. It should happen without an error."
        }
    }
};
function App() {
    const [preventScroll, setPreventScroll] = (0, _react.useState)(false);
    (0, _src.usePreventScroll)({
        isDisabled: !preventScroll
    });
    const startPreventScroll = ()=>{
        setInterval(()=>{
            setPreventScroll(true);
        }, 1000);
    };
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        style: {
            height: "300vh"
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), {
        onPress: startPreventScroll,
        margin: "20px"
    }, "Click Me in safari and then scroll"));
}

},{"@react-spectrum/button":"jZWyP","react":"9yzVZ","../src":"5fTCg","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"bjf4e":[function(require,module,exports) {
/*
 * Copyright 2021 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ScrollTesting", ()=>ScrollTesting);
var _collections = require("@react-stately/collections");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _example = require("./example");
const meta = {
    title: "useSelect"
};
exports.default = meta;
let lotsOfItems = [];
for(let i = 0; i < 50; i++)lotsOfItems.push({
    name: "Item " + i
});
const Template = ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _example.Select), {
        label: "Example",
        items: lotsOfItems
    }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _collections.Item), {
            key: item.name
        }, item.name));
const ScrollTesting = {
    render: Template
};

},{"@react-stately/collections":"loANi","react":"9yzVZ","./example":"9DSdl","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"9DSdl":[function(require,module,exports) {
/*
 * Copyright 2021 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Select", ()=>Select);
var _overlays = require("@react-aria/overlays");
var _focus = require("@react-aria/focus");
var _select = require("@react-aria/select");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _button = require("@react-aria/button");
var _listbox = require("@react-aria/listbox");
var _select1 = require("@react-stately/select");
function Select(props) {
    // Create state based on the incoming props
    let state = (0, _select1.useSelectState)(props);
    // Get props for child elements from useSelect
    let ref = (0, _reactDefault.default).useRef();
    let { labelProps, triggerProps, valueProps, menuProps } = (0, _select.useSelect)(props, state, ref);
    // Get props for the button based on the trigger props from useSelect
    let { buttonProps } = (0, _button.useButton)(triggerProps, ref);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        style: {
            position: "relative",
            display: "inline-block"
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", labelProps, props.label), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _select.HiddenSelect), {
        state: state,
        triggerRef: ref,
        label: props.label,
        name: props.name
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("button", {
        ...buttonProps,
        ref: ref,
        style: {
            height: 30,
            fontSize: 14
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("span", valueProps, state.selectedItem ? state.selectedItem.rendered : "Select an option"), /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        "aria-hidden": "true",
        style: {
            paddingLeft: 5
        }
    }, "\u25BC")), state.isOpen && /*#__PURE__*/ (0, _reactDefault.default).createElement(Popover, {
        isOpen: state.isOpen,
        onClose: state.close
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(ListBox, {
        ...menuProps,
        state: state
    })));
}
function Popover(props) {
    let ref = (0, _reactDefault.default).useRef();
    let { popoverRef = ref, isOpen, onClose, children } = props;
    // Handle events that should cause the popup to close,
    // e.g. blur, clicking outside, or pressing the escape key.
    let { overlayProps } = (0, _overlays.useOverlay)({
        isOpen,
        onClose,
        shouldCloseOnBlur: true,
        isDismissable: true
    }, popoverRef);
    // Add a hidden <DismissButton> component at the end of the popover
    // to allow screen reader users to dismiss the popup easily.
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _focus.FocusScope), {
        restoreFocus: true
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...overlayProps,
        ref: popoverRef,
        style: {
            position: "absolute",
            width: "100%",
            border: "1px solid gray",
            background: "lightgray",
            marginTop: 4
        }
    }, children, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _overlays.DismissButton), {
        onDismiss: onClose
    })));
}
function ListBox(props) {
    let ref = (0, _reactDefault.default).useRef();
    let { listBoxRef = ref, state } = props;
    let { listBoxProps } = (0, _listbox.useListBox)(props, state, listBoxRef);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("ul", {
        ...listBoxProps,
        ref: listBoxRef,
        style: {
            margin: 0,
            padding: 0,
            listStyle: "none",
            maxHeight: "150px",
            overflow: "auto"
        }
    }, [
        ...state.collection
    ].map((item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(Option, {
            key: item.key,
            item: item,
            state: state
        })));
}
function Option({ item, state }) {
    let ref = (0, _reactDefault.default).useRef();
    let { optionProps, isSelected, isFocused, isDisabled } = (0, _listbox.useOption)({
        key: item.key
    }, state, ref);
    let backgroundColor;
    let color = "black";
    if (isSelected) {
        backgroundColor = "blueviolet";
        color = "white";
    } else if (isFocused) backgroundColor = "gray";
    else if (isDisabled) {
        backgroundColor = "transparent";
        color = "gray";
    }
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("li", {
        ...optionProps,
        ref: ref,
        style: {
            background: backgroundColor,
            color: color,
            padding: "2px 5px",
            outline: "none",
            cursor: "pointer"
        }
    }, item.rendered);
}

},{"@react-aria/overlays":"5fTCg","@react-aria/focus":"42mbF","@react-aria/select":"l1sFE","react":"9yzVZ","@react-aria/button":"fsdLZ","@react-aria/listbox":"bHZSJ","@react-stately/select":"4LWw9","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"fjWbs":[function(require,module,exports) {
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StaticUlStaticSubUl", ()=>StaticUlStaticSubUl);
parcelHelpers.export(exports, "StaticUlRelativeSubUl", ()=>StaticUlRelativeSubUl);
parcelHelpers.export(exports, "RelativeUlStaticSubUl", ()=>RelativeUlStaticSubUl);
parcelHelpers.export(exports, "RelativeUlRelativeSubUl", ()=>RelativeUlRelativeSubUl);
parcelHelpers.export(exports, "SingleSelectAllowEmptySelectOnFocus", ()=>SingleSelectAllowEmptySelectOnFocus);
parcelHelpers.export(exports, "SingleSelectDisallowEmptySelectionSelectOnFocus", ()=>SingleSelectDisallowEmptySelectionSelectOnFocus);
parcelHelpers.export(exports, "MultiSelectReplaceOnPressSelectOnFocus", ()=>MultiSelectReplaceOnPressSelectOnFocus);
parcelHelpers.export(exports, "MultiSelectAllowEmptySelectOnFocus", ()=>MultiSelectAllowEmptySelectOnFocus);
parcelHelpers.export(exports, "MultiSelectDisallowEmptySelectOnFocus", ()=>MultiSelectDisallowEmptySelectOnFocus);
var _actiongroup = require("@react-spectrum/actiongroup");
var _list = require("./List");
var _list1 = require("@react-stately/list");
var _react = require("react");
var _menu = require("@react-spectrum/menu");
var _stylesCss = require("./styles.css");
var _stylesCssDefault = parcelHelpers.interopDefault(_stylesCss);
var _src = require("../src");
function SelectableList(props) {
    const state = (0, _list1.useListState)(props);
    const listRef = _react.useRef(null);
    const { listProps } = (0, _src.useSelectableList)({
        ref: listRef,
        selectionManager: state.selectionManager,
        collection: state.collection,
        disabledKeys: state.disabledKeys,
        isVirtualized: false,
        autoFocus: true
    });
    const renderLeaf = (node)=>/*#__PURE__*/ _react.createElement(SelectableItem, {
            node: node,
            state: state
        });
    return /*#__PURE__*/ _react.createElement("ul", {
        ...listProps,
        className: (0, _stylesCssDefault.default).list,
        style: {
            height: 200,
            overflow: "auto",
            padding: 10,
            margin: 0,
            listStyle: "none",
            position: props.isUlRelativelyPositioned ? "relative" : "static",
            borderTopWidth: "10px",
            borderBottomWidth: "20px"
        },
        ref: listRef
    }, Array.from(state.collection).map((node)=>{
        if (node.hasChildNodes) return /*#__PURE__*/ _react.createElement(_react.Fragment, null, /*#__PURE__*/ _react.createElement("div", {
            style: {
                textTransform: "uppercase"
            }
        }, node.rendered), /*#__PURE__*/ _react.createElement("ul", {
            key: node.key,
            style: {
                position: props.isSubUlRelativelyPositioned ? "relative" : "static",
                padding: 0,
                margin: 0,
                listStyle: "none"
            }
        }, Array.from(node.childNodes).map(renderLeaf)));
        else return renderLeaf(node);
    }));
}
function SelectableItem(props) {
    const { state, node } = props;
    const ref = _react.useRef(null);
    const { itemProps } = (0, _src.useSelectableItem)({
        selectionManager: state.selectionManager,
        key: node.key,
        isVirtualized: false,
        ref
    });
    const isFocused = node.key === state.selectionManager.focusedKey;
    return /*#__PURE__*/ _react.createElement("li", {
        ...itemProps,
        key: node.key,
        style: {
            backgroundColor: isFocused ? "gray" : "white",
            fontWeight: isFocused ? "bold" : "normal"
        },
        ref: ref
    }, node.rendered);
}
const options = [
    /*#__PURE__*/ _react.createElement((0, _menu.Section), {
        title: "Brass"
    }, /*#__PURE__*/ _react.createElement((0, _actiongroup.Item), null, "Trumpet"), /*#__PURE__*/ _react.createElement((0, _actiongroup.Item), null, "Horn"), /*#__PURE__*/ _react.createElement((0, _actiongroup.Item), null, "Trombone"), /*#__PURE__*/ _react.createElement((0, _actiongroup.Item), null, "Tuba")),
    /*#__PURE__*/ _react.createElement((0, _menu.Section), {
        title: "String"
    }, /*#__PURE__*/ _react.createElement((0, _actiongroup.Item), null, "Violin"), /*#__PURE__*/ _react.createElement((0, _actiongroup.Item), null, "Viola"), /*#__PURE__*/ _react.createElement((0, _actiongroup.Item), null, "Cello"), /*#__PURE__*/ _react.createElement((0, _actiongroup.Item), null, "Harp")),
    /*#__PURE__*/ _react.createElement((0, _menu.Section), {
        title: "Wind"
    }, /*#__PURE__*/ _react.createElement((0, _actiongroup.Item), null, "Flute"), /*#__PURE__*/ _react.createElement((0, _actiongroup.Item), null, "Oboe"), /*#__PURE__*/ _react.createElement((0, _actiongroup.Item), null, "Clarinet")),
    /*#__PURE__*/ _react.createElement((0, _menu.Section), {
        title: "Percussion"
    }, /*#__PURE__*/ _react.createElement((0, _actiongroup.Item), null, "Piano"), /*#__PURE__*/ _react.createElement((0, _actiongroup.Item), null, "Drums"))
];
exports.default = {
    title: "useSelectableList",
    parameters: {
        a11y: {
            config: {
                rules: [
                    // Ignore landmark accessibility failure since the list is to test for selection/scrolling only
                    {
                        id: "list",
                        enabled: false
                    }
                ]
            }
        }
    }
};
const StaticUlStaticSubUl = ()=>/*#__PURE__*/ _react.createElement(SelectableList, {
        isSubUlRelativelyPositioned: false,
        isUlRelativelyPositioned: false
    }, options);
StaticUlStaticSubUl.story = {
    name: "Static ul, static sub ul",
    parameters: {
        description: {
            data: "Built to test if focusing an element scrolls into view."
        }
    }
};
const StaticUlRelativeSubUl = ()=>/*#__PURE__*/ _react.createElement(SelectableList, {
        isSubUlRelativelyPositioned: true,
        isUlRelativelyPositioned: false
    }, options);
StaticUlRelativeSubUl.story = {
    name: "Static ul, relative sub ul"
};
const RelativeUlStaticSubUl = ()=>/*#__PURE__*/ _react.createElement(SelectableList, {
        isSubUlRelativelyPositioned: false,
        isUlRelativelyPositioned: true
    }, options);
RelativeUlStaticSubUl.story = {
    name: "Relative ul, static sub ul"
};
const RelativeUlRelativeSubUl = ()=>/*#__PURE__*/ _react.createElement(SelectableList, {
        isSubUlRelativelyPositioned: true,
        isUlRelativelyPositioned: true
    }, options);
RelativeUlRelativeSubUl.story = {
    name: "Relative ul, relative sub ul"
};
const SingleSelectAllowEmptySelectOnFocus = ()=>/*#__PURE__*/ _react.createElement((0, _list.List), {
        selectionMode: "single"
    }, /*#__PURE__*/ _react.createElement((0, _actiongroup.Item), null, "Paco de Lucia"), /*#__PURE__*/ _react.createElement((0, _actiongroup.Item), null, "Vicente Amigo"), /*#__PURE__*/ _react.createElement((0, _actiongroup.Item), null, "Gerardo Nunez"));
SingleSelectAllowEmptySelectOnFocus.story = {
    name: "single select, allow empty, select on focus"
};
const SingleSelectDisallowEmptySelectionSelectOnFocus = ()=>/*#__PURE__*/ _react.createElement((0, _list.List), {
        selectionMode: "single",
        disallowEmptySelection: true
    }, /*#__PURE__*/ _react.createElement((0, _actiongroup.Item), null, "Paco de Lucia"), /*#__PURE__*/ _react.createElement((0, _actiongroup.Item), null, "Vicente Amigo"), /*#__PURE__*/ _react.createElement((0, _actiongroup.Item), null, "Gerardo Nunez"));
SingleSelectDisallowEmptySelectionSelectOnFocus.story = {
    name: "single select, disallow empty selection, select on focus"
};
const MultiSelectReplaceOnPressSelectOnFocus = ()=>/*#__PURE__*/ _react.createElement((0, _list.List), {
        selectionMode: "multiple",
        selectionBehavior: "replace"
    }, /*#__PURE__*/ _react.createElement((0, _actiongroup.Item), null, "Paco de Lucia"), /*#__PURE__*/ _react.createElement((0, _actiongroup.Item), null, "Vicente Amigo"), /*#__PURE__*/ _react.createElement((0, _actiongroup.Item), null, "Gerardo Nunez"));
MultiSelectReplaceOnPressSelectOnFocus.story = {
    name: "multi select, replace on press, select on focus"
};
const MultiSelectAllowEmptySelectOnFocus = ()=>/*#__PURE__*/ _react.createElement((0, _list.List), {
        selectionMode: "multiple"
    }, /*#__PURE__*/ _react.createElement((0, _actiongroup.Item), null, "Paco de Lucia"), /*#__PURE__*/ _react.createElement((0, _actiongroup.Item), null, "Vicente Amigo"), /*#__PURE__*/ _react.createElement((0, _actiongroup.Item), null, "Gerardo Nunez"));
MultiSelectAllowEmptySelectOnFocus.story = {
    name: "multi select, allow empty, select on focus"
};
const MultiSelectDisallowEmptySelectOnFocus = ()=>/*#__PURE__*/ _react.createElement((0, _list.List), {
        selectionMode: "multiple",
        disallowEmptySelection: true
    }, /*#__PURE__*/ _react.createElement((0, _actiongroup.Item), null, "Paco de Lucia"), /*#__PURE__*/ _react.createElement((0, _actiongroup.Item), null, "Vicente Amigo"), /*#__PURE__*/ _react.createElement((0, _actiongroup.Item), null, "Gerardo Nunez"));
MultiSelectDisallowEmptySelectOnFocus.story = {
    name: "multi select, disallow empty, select on focus"
};

},{"@react-spectrum/actiongroup":"hkqBV","./List":"d9lPg","@react-stately/list":"Cp0zP","react":"9yzVZ","@react-spectrum/menu":"asqy4","./styles.css":"dt7TC","../src":"6Fly5","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"d9lPg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "List", ()=>List);
var _list = require("@react-stately/list");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _selection = require("@react-aria/selection");
function ListItem({ item, state }) {
    const ref = (0, _react.useRef)(null);
    const { itemProps } = (0, _selection.useSelectableItem)({
        key: item.key,
        ref,
        selectionManager: state.selectionManager
    });
    const selected = state.selectionManager.isSelected(item.key);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("li", {
        role: "option",
        ref: ref,
        ...itemProps,
        style: {
            background: selected ? "dodgerblue" : undefined,
            color: selected ? "#fff" : undefined
        },
        "aria-selected": selected ? "true" : undefined
    }, item.rendered);
}
function List(props) {
    const ref = (0, _react.useRef)(null);
    const state = (0, _list.useListState)(props);
    const { listProps } = (0, _selection.useSelectableList)({
        ...props,
        selectionManager: state.selectionManager,
        collection: state.collection,
        disabledKeys: state.disabledKeys,
        selectOnFocus: true,
        ref
    });
    var _props_arialabel;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("ul", {
        ref: ref,
        ...listProps,
        role: "listbox",
        "aria-label": (_props_arialabel = props["aria-label"]) !== null && _props_arialabel !== void 0 ? _props_arialabel : "test listbox"
    }, [
        ...state.collection
    ].map((item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(ListItem, {
            key: item.key,
            item: item,
            state: state
        })));
}

},{"@react-stately/list":"Cp0zP","react":"9yzVZ","@react-aria/selection":"6Fly5","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"dt7TC":[function(require,module,exports) {
module.exports["list"] = `_2WYSLq_list`;

},{}],"7bFl8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Single", ()=>Single);
parcelHelpers.export(exports, "SingleWithBigSteps", ()=>SingleWithBigSteps);
parcelHelpers.export(exports, "SingleWithOrigin", ()=>SingleWithOrigin);
parcelHelpers.export(exports, "SingleWithAriaLabel", ()=>SingleWithAriaLabel);
parcelHelpers.export(exports, "Range", ()=>Range);
parcelHelpers.export(exports, "RangeWithAriaLabel", ()=>RangeWithAriaLabel);
parcelHelpers.export(exports, "_3Thumbs", ()=>_3Thumbs);
parcelHelpers.export(exports, "_3ThumbsWithDisabled", ()=>_3ThumbsWithDisabled);
parcelHelpers.export(exports, "_8ThumbsWithDisabled", ()=>_8ThumbsWithDisabled);
parcelHelpers.export(exports, "_3ThumbsWithAriaLabel", ()=>_3ThumbsWithAriaLabel);
var _addonActions = require("@storybook/addon-actions");
var _storyUtils = require("@react-spectrum/story-utils");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _storyMultiSlider = require("./StoryMultiSlider");
var _storyRangeSlider = require("./StoryRangeSlider");
var _storySlider = require("./StorySlider");
let message = "Your browser may not support this set of format options.";
exports.default = {
    title: "Slider (hooks)",
    decorators: [
        (story)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _storyUtils.ErrorBoundary), {
                message: message
            }, story())
    ]
};
const Single = ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _storySlider.StorySlider), {
        label: "Size",
        onChange: (0, _addonActions.action)("onChange"),
        onChangeEnd: (0, _addonActions.action)("onChangeEnd"),
        showTip: true
    });
Single.story = {
    name: "single"
};
const SingleWithBigSteps = ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _storySlider.StorySlider), {
        label: "Size",
        onChange: (0, _addonActions.action)("onChange"),
        onChangeEnd: (0, _addonActions.action)("onChangeEnd"),
        step: 10,
        showTip: true
    });
SingleWithBigSteps.story = {
    name: "single with big steps"
};
const SingleWithOrigin = ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _storySlider.StorySlider), {
        label: "Exposure",
        origin: 0,
        minValue: -5,
        maxValue: 5,
        step: 0.1,
        onChange: (0, _addonActions.action)("onChange"),
        onChangeEnd: (0, _addonActions.action)("onChangeEnd"),
        showTip: true
    });
SingleWithOrigin.story = {
    name: "single with origin"
};
const SingleWithAriaLabel = ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _storySlider.StorySlider), {
        "aria-label": "Size",
        onChange: (0, _addonActions.action)("onChange"),
        onChangeEnd: (0, _addonActions.action)("onChangeEnd"),
        showTip: true
    });
SingleWithAriaLabel.story = {
    name: "single with aria label"
};
const Range = ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _storyRangeSlider.StoryRangeSlider), {
        label: "Temperature",
        defaultValue: [
            25,
            75
        ],
        onChange: (0, _addonActions.action)("onChange"),
        onChangeEnd: (0, _addonActions.action)("onChangeEnd"),
        showTip: true,
        formatOptions: {
            style: "unit",
            unit: "celsius",
            unitDisplay: "narrow"
        }
    });
Range.story = {
    name: "range"
};
const RangeWithAriaLabel = ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _storyRangeSlider.StoryRangeSlider), {
        "aria-label": "Temperature",
        defaultValue: [
            25,
            75
        ],
        onChange: (0, _addonActions.action)("onChange"),
        onChangeEnd: (0, _addonActions.action)("onChangeEnd"),
        showTip: true,
        formatOptions: {
            style: "unit",
            unit: "celsius",
            unitDisplay: "narrow"
        }
    });
RangeWithAriaLabel.story = {
    name: "range with aria-label"
};
const _3Thumbs = ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _storyMultiSlider.StoryMultiSlider), {
        label: "Three thumbs",
        onChange: (0, _addonActions.action)("onChange"),
        onChangeEnd: (0, _addonActions.action)("onChangeEnd"),
        defaultValue: [
            10,
            40,
            80
        ]
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _storyMultiSlider.StoryThumb), {
        label: "A"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _storyMultiSlider.StoryThumb), {
        label: "B"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _storyMultiSlider.StoryThumb), {
        label: "C"
    }));
_3Thumbs.story = {
    name: "3 thumbs"
};
const _3ThumbsWithDisabled = ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _storyMultiSlider.StoryMultiSlider), {
        label: "Three thumbs",
        onChange: (0, _addonActions.action)("onChange"),
        onChangeEnd: (0, _addonActions.action)("onChangeEnd"),
        defaultValue: [
            10,
            40,
            80
        ]
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _storyMultiSlider.StoryThumb), {
        label: "A"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _storyMultiSlider.StoryThumb), {
        label: "B",
        isDisabled: true
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _storyMultiSlider.StoryThumb), {
        label: "C"
    }));
_3ThumbsWithDisabled.story = {
    name: "3 thumbs with disabled"
};
const _8ThumbsWithDisabled = ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _storyMultiSlider.StoryMultiSlider), {
        label: "9 thumbs - 5 disabled",
        onChange: (0, _addonActions.action)("onChange"),
        onChangeEnd: (0, _addonActions.action)("onChangeEnd"),
        defaultValue: [
            5,
            10,
            15,
            30,
            35,
            40,
            50,
            75,
            90
        ]
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _storyMultiSlider.StoryThumb), {
        label: "A",
        isDisabled: true
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _storyMultiSlider.StoryThumb), {
        label: "B"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _storyMultiSlider.StoryThumb), {
        label: "C"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _storyMultiSlider.StoryThumb), {
        label: "D",
        isDisabled: true
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _storyMultiSlider.StoryThumb), {
        label: "E",
        isDisabled: true
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _storyMultiSlider.StoryThumb), {
        label: "F"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _storyMultiSlider.StoryThumb), {
        label: "G"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _storyMultiSlider.StoryThumb), {
        label: "H",
        isDisabled: true
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _storyMultiSlider.StoryThumb), {
        label: "I",
        isDisabled: true
    }));
_8ThumbsWithDisabled.story = {
    name: "8 thumbs with disabled"
};
const _3ThumbsWithAriaLabel = ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _storyMultiSlider.StoryMultiSlider), {
        "aria-label": "Three thumbs",
        onChange: (0, _addonActions.action)("onChange"),
        onChangeEnd: (0, _addonActions.action)("onChangeEnd"),
        defaultValue: [
            10,
            40,
            80
        ]
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _storyMultiSlider.StoryThumb), {
        "aria-label": "A"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _storyMultiSlider.StoryThumb), {
        "aria-label": "B"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _storyMultiSlider.StoryThumb), {
        "aria-label": "C"
    }));
_3ThumbsWithAriaLabel.story = {
    name: "3 thumbs with aria-label"
};

},{"@storybook/addon-actions":"coXbW","@react-spectrum/story-utils":"gPtIF","react":"9yzVZ","./StoryMultiSlider":"ahHRz","./StoryRangeSlider":"8xzN5","./StorySlider":"3UIqE","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"gPtIF":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /// <reference types="css-module-types" />
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ErrorBoundary", ()=>(0, _errorBoundary.ErrorBoundary));
parcelHelpers.export(exports, "generatePowerset", ()=>(0, _generatePowerset.generatePowerset));
var _errorBoundary = require("./ErrorBoundary");
var _generatePowerset = require("./GeneratePowerset");

},{"./ErrorBoundary":"2Eon7","./GeneratePowerset":"4ENY5","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"2Eon7":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ErrorBoundary", ()=>ErrorBoundary);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
class ErrorBoundary extends (0, _react.Component) {
    static getDerivedStateFromError() {
        // Update state so the next render will show the fallback UI.
        return {
            hasError: true
        };
    }
    render() {
        if (this.state.hasError) // You can render any custom fallback UI
        return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", null, this.props.message);
        return this.props.children;
    }
    constructor(props){
        super(props);
        this.state = {
            hasError: false
        };
    }
}

},{"react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"4ENY5":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// Generate a powerset from a given array of states/options,
parcelHelpers.export(exports, "generatePowerset", ()=>generatePowerset);
var _utils = require("@react-aria/utils");
function generatePowerset(states, exclude) {
    let combinations = [
        {}
    ];
    for(let i = 0; i < states.length; i++){
        let len = combinations.length;
        for(let j = 0; j < len; j++){
            let [key, value] = Object.entries(states[i])[0];
            // If one of the states/options has multiple values, create a combination for each
            if (Array.isArray(value)) value.forEach((state)=>{
                let merged = (0, _utils.mergeProps)(combinations[j], {
                    [key]: state
                });
                if (!(exclude && exclude(merged))) combinations.push(merged);
            });
            else {
                let merged = (0, _utils.mergeProps)(combinations[j], states[i]);
                let s = JSON.stringify(merged);
                if (combinations.some((c)=>JSON.stringify(c) === s)) continue;
                if (!(exclude && exclude(merged))) combinations.push(merged);
            }
        }
    }
    return combinations;
}

},{"@react-aria/utils":"9cLk5","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"ahHRz":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StoryMultiSlider", ()=>StoryMultiSlider);
parcelHelpers.export(exports, "StoryThumb", ()=>StoryThumb);
var _utils = require("@react-spectrum/utils");
var _focus = require("@react-aria/focus");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _slider = require("@react-stately/slider");
var _storySliderCss = require("./story-slider.css");
var _storySliderCssDefault = parcelHelpers.interopDefault(_storySliderCss);
var _i18N = require("@react-aria/i18n");
var _slider1 = require("@react-aria/slider");
var _visuallyHidden = require("@react-aria/visually-hidden");
function StoryMultiSlider(props) {
    const { children } = props;
    const trackRef = (0, _reactDefault.default).useRef(null);
    const formatter = (0, _i18N.useNumberFormatter)(props.formatOptions);
    const state = (0, _slider.useSliderState)({
        ...props,
        numberFormatter: formatter
    });
    const { trackProps, labelProps, groupProps, outputProps } = (0, _slider1.useSlider)(props, state, trackRef);
    const numThumbs = (0, _reactDefault.default).Children.count(children);
    if (numThumbs !== state.values.length) throw new Error("You must have the same number of StoryThumb as the number of values in `defaultValue` or `value`.");
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...groupProps,
        className: (0, _storySliderCssDefault.default).slider
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _storySliderCssDefault.default).sliderLabel
    }, props.label && /*#__PURE__*/ (0, _reactDefault.default).createElement("label", {
        ...labelProps,
        className: (0, _storySliderCssDefault.default).label
    }, props.label), /*#__PURE__*/ (0, _reactDefault.default).createElement("output", {
        ...outputProps,
        className: (0, _storySliderCssDefault.default).value
    }, JSON.stringify(state.values))), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ref: trackRef,
        className: (0, _storySliderCssDefault.default).track,
        ...trackProps
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _storySliderCssDefault.default).rail
    }), (0, _reactDefault.default).Children.map(children, (child, index)=>/*#__PURE__*/ (0, _reactDefault.default).cloneElement(child, {
            __context: {
                sliderProps: props,
                state,
                trackRef,
                index
            }
        }))));
}
function StoryThumb(props) {
    if (!props.__context) throw new Error("Cannot use StoryThumb outside of a StoryMultiSlider!");
    const { label, isDisabled } = props;
    const context = props.__context;
    const { index, state, sliderProps } = context;
    const inputRef = (0, _reactDefault.default).useRef(null);
    const { inputProps, thumbProps, labelProps } = (0, _slider1.useSliderThumb)({
        index,
        ...props,
        isDisabled: sliderProps.isDisabled || props.isDisabled,
        trackRef: context.trackRef,
        inputRef
    }, state);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _focus.FocusRing), {
        within: true,
        focusRingClass: (0, _storySliderCssDefault.default).thumbFocusVisible,
        focusClass: (0, _storySliderCssDefault.default).thumbFocused
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...thumbProps,
        className: (0, _utils.classNames)((0, _storySliderCssDefault.default), "thumb", "thumbHandle", {
            thumbDisabled: isDisabled
        }),
        style: {
            "left": `${state.getThumbPercent(index) * 100}%`
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _visuallyHidden.VisuallyHidden), {
        isFocusable: true
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("input", {
        className: (0, _storySliderCssDefault.default).input,
        ref: inputRef,
        ...inputProps
    })), label && /*#__PURE__*/ (0, _reactDefault.default).createElement("label", labelProps, label)));
}

},{"@react-spectrum/utils":"cMIJ6","@react-aria/focus":"42mbF","react":"9yzVZ","@react-stately/slider":"82Whk","./story-slider.css":"iY2Vi","@react-aria/i18n":"411rg","@react-aria/slider":"eOsko","@react-aria/visually-hidden":"4jwxT","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"iY2Vi":[function(require,module,exports) {
module.exports["filledRail"] = `THwnhq_filledRail`;
module.exports["label"] = `THwnhq_label`;
module.exports["rail"] = `THwnhq_rail`;
module.exports["slider"] = `THwnhq_slider`;
module.exports["sliderLabel"] = `THwnhq_sliderLabel`;
module.exports["thumb"] = `THwnhq_thumb`;
module.exports["thumbDisabled"] = `THwnhq_thumbDisabled`;
module.exports["thumbFocusVisible"] = `THwnhq_thumbFocusVisible`;
module.exports["thumbFocused"] = `THwnhq_thumbFocused`;
module.exports["thumbHandle"] = `THwnhq_thumbHandle`;
module.exports["tip"] = `THwnhq_tip`;
module.exports["track"] = `THwnhq_track`;
module.exports["trackContainer"] = `THwnhq_trackContainer`;
module.exports["value"] = `THwnhq_value`;

},{}],"8xzN5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StoryRangeSlider", ()=>StoryRangeSlider);
var _focus = require("@react-aria/focus");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _storySliderCss = require("./story-slider.css");
var _storySliderCssDefault = parcelHelpers.interopDefault(_storySliderCss);
var _i18N = require("@react-aria/i18n");
var _slider = require("@react-aria/slider");
var _slider1 = require("@react-stately/slider");
var _visuallyHidden = require("@react-aria/visually-hidden");
function StoryRangeSlider(props) {
    const trackRef = (0, _reactDefault.default).useRef(null);
    const minInputRef = (0, _reactDefault.default).useRef(null);
    const maxInputRef = (0, _reactDefault.default).useRef(null);
    const formatter = (0, _i18N.useNumberFormatter)(props.formatOptions);
    const state = (0, _slider1.useSliderState)({
        ...props,
        numberFormatter: formatter
    });
    if (state.values.length !== 2) throw new Error("Must specify an array of two numbers");
    const { trackProps, labelProps, groupProps, outputProps } = (0, _slider.useSlider)(props, state, trackRef);
    const { thumbProps: minThumbProps, inputProps: minInputProps } = (0, _slider.useSliderThumb)({
        index: 0,
        "aria-label": "Minimum",
        isDisabled: props.isDisabled,
        trackRef,
        inputRef: minInputRef
    }, state);
    const { thumbProps: maxThumbProps, inputProps: maxInputProps } = (0, _slider.useSliderThumb)({
        index: 1,
        "aria-label": "Maximum",
        isDisabled: props.isDisabled,
        trackRef,
        inputRef: maxInputRef
    }, state);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...groupProps,
        className: (0, _storySliderCssDefault.default).slider
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _storySliderCssDefault.default).sliderLabel
    }, props.label && /*#__PURE__*/ (0, _reactDefault.default).createElement("label", {
        ...labelProps,
        className: (0, _storySliderCssDefault.default).label
    }, props.label), /*#__PURE__*/ (0, _reactDefault.default).createElement("output", {
        ...outputProps,
        className: (0, _storySliderCssDefault.default).value
    }, state.getThumbValueLabel(0), " to ", state.getThumbValueLabel(1))), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _storySliderCssDefault.default).trackContainer
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ref: trackRef,
        className: (0, _storySliderCssDefault.default).track,
        ...trackProps
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _storySliderCssDefault.default).rail
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _storySliderCssDefault.default).filledRail,
        style: {
            left: `${state.getThumbPercent(0) * 100}%`,
            width: `${(state.getThumbPercent(1) - state.getThumbPercent(0)) * 100}%`
        }
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _focus.FocusRing), {
        within: true,
        focusRingClass: (0, _storySliderCssDefault.default).thumbFocusVisible,
        focusClass: (0, _storySliderCssDefault.default).thumbFocused
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _storySliderCssDefault.default).thumb,
        style: {
            "left": `${state.getThumbPercent(0) * 100}%`
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...minThumbProps,
        className: (0, _storySliderCssDefault.default).thumbHandle
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _visuallyHidden.VisuallyHidden), null, /*#__PURE__*/ (0, _reactDefault.default).createElement("input", {
        className: (0, _storySliderCssDefault.default).input,
        ref: minInputRef,
        ...minInputProps
    }))), props.showTip && /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _storySliderCssDefault.default).tip
    }, state.getThumbValueLabel(0)))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _focus.FocusRing), {
        within: true,
        focusRingClass: (0, _storySliderCssDefault.default).thumbFocusVisible,
        focusClass: (0, _storySliderCssDefault.default).thumbFocused
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _storySliderCssDefault.default).thumb,
        ...maxThumbProps,
        style: {
            "left": `${state.getThumbPercent(1) * 100}%`
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _storySliderCssDefault.default).thumbHandle
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _visuallyHidden.VisuallyHidden), null, /*#__PURE__*/ (0, _reactDefault.default).createElement("input", {
        className: (0, _storySliderCssDefault.default).input,
        ref: maxInputRef,
        ...maxInputProps
    }))), props.showTip && /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _storySliderCssDefault.default).tip
    }, state.getThumbValueLabel(1), " (can drag by tip)")))));
}

},{"@react-aria/focus":"42mbF","react":"9yzVZ","./story-slider.css":"iY2Vi","@react-aria/i18n":"411rg","@react-aria/slider":"eOsko","@react-stately/slider":"82Whk","@react-aria/visually-hidden":"4jwxT","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"3UIqE":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StorySlider", ()=>StorySlider);
var _focus = require("@react-aria/focus");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _storySliderCss = require("./story-slider.css");
var _storySliderCssDefault = parcelHelpers.interopDefault(_storySliderCss);
var _i18N = require("@react-aria/i18n");
var _slider = require("@react-aria/slider");
var _slider1 = require("@react-stately/slider");
var _visuallyHidden = require("@react-aria/visually-hidden");
function StorySlider(props) {
    const trackRef = (0, _reactDefault.default).useRef(null);
    const inputRef = (0, _reactDefault.default).useRef(null);
    var _props_origin, _ref;
    const origin = (_ref = (_props_origin = props.origin) !== null && _props_origin !== void 0 ? _props_origin : props.minValue) !== null && _ref !== void 0 ? _ref : 0;
    const multiProps = {
        ...props,
        value: props.value == null ? undefined : [
            props.value
        ],
        defaultValue: props.defaultValue == null ? undefined : [
            props.defaultValue
        ],
        onChange: props.onChange == null ? undefined : (vals)=>props.onChange(vals[0]),
        onChangeEnd: props.onChangeEnd == null ? undefined : (vals)=>props.onChangeEnd(vals[0])
    };
    const formatter = (0, _i18N.useNumberFormatter)(props.formatOptions);
    const state = (0, _slider1.useSliderState)({
        ...multiProps,
        numberFormatter: formatter
    });
    const { groupProps, trackProps, labelProps, outputProps } = (0, _slider.useSlider)(multiProps, state, trackRef);
    const { thumbProps, inputProps } = (0, _slider.useSliderThumb)({
        index: 0,
        isDisabled: props.isDisabled,
        trackRef,
        inputRef
    }, state);
    const value = state.values[0];
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _storySliderCssDefault.default).slider,
        ...groupProps
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _storySliderCssDefault.default).sliderLabel
    }, props.label && /*#__PURE__*/ (0, _reactDefault.default).createElement("label", {
        ...labelProps,
        className: (0, _storySliderCssDefault.default).label
    }, props.label), /*#__PURE__*/ (0, _reactDefault.default).createElement("output", {
        ...outputProps,
        className: (0, _storySliderCssDefault.default).value
    }, state.getThumbValueLabel(0))), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _storySliderCssDefault.default).trackContainer
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _storySliderCssDefault.default).rail
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _storySliderCssDefault.default).filledRail,
        style: {
            left: `${state.getValuePercent(Math.min(value, origin)) * 100}%`,
            width: `${(state.getValuePercent(Math.max(value, origin)) - state.getValuePercent(Math.min(value, origin))) * 100}%`
        }
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ref: trackRef,
        className: (0, _storySliderCssDefault.default).track,
        ...trackProps
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _focus.FocusRing), {
        within: true,
        focusRingClass: (0, _storySliderCssDefault.default).thumbFocusVisible,
        focusClass: (0, _storySliderCssDefault.default).thumbFocused
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _storySliderCssDefault.default).thumb,
        style: {
            "left": `${state.getThumbPercent(0) * 100}%`
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...thumbProps,
        className: (0, _storySliderCssDefault.default).thumbHandle
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _visuallyHidden.VisuallyHidden), null, /*#__PURE__*/ (0, _reactDefault.default).createElement("input", {
        className: (0, _storySliderCssDefault.default).input,
        ref: inputRef,
        ...inputProps
    }))), props.showTip && /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _storySliderCssDefault.default).tip
    }, state.getThumbValueLabel(0))))));
}

},{"@react-aria/focus":"42mbF","react":"9yzVZ","./story-slider.css":"iY2Vi","@react-aria/i18n":"411rg","@react-aria/slider":"eOsko","@react-stately/slider":"82Whk","@react-aria/visually-hidden":"4jwxT","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"iI18R":[function(require,module,exports) {
/*
 * Copyright 2021 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ScrollTesting", ()=>ScrollTesting);
parcelHelpers.export(exports, "ActionTesting", ()=>ActionTesting);
parcelHelpers.export(exports, "BackwardCompatActionTesting", ()=>BackwardCompatActionTesting);
parcelHelpers.export(exports, "TableWithResizingNoProps", ()=>TableWithResizingNoProps);
parcelHelpers.export(exports, "TableWithResizingFRs", ()=>TableWithResizingFRs);
parcelHelpers.export(exports, "TableWithResizingFRsControlled", ()=>TableWithResizingFRsControlled);
parcelHelpers.export(exports, "TableWithSomeResizingFRsControlled", ()=>TableWithSomeResizingFRsControlled);
parcelHelpers.export(exports, "DocExample", ()=>DocExample);
parcelHelpers.export(exports, "DocExampleControlled", ()=>DocExampleControlled);
var _addonActions = require("@storybook/addon-actions");
var _exampleBackwardsCompat = require("./example-backwards-compat");
var _table = require("@react-stately/table");
var _exampleDocs = require("./example-docs");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _exampleResizing = require("./example-resizing");
var _example = require("./example");
const meta = {
    title: "useTable"
};
exports.default = meta;
let columns = [
    {
        name: "Name",
        uid: "name"
    },
    {
        name: "Type",
        uid: "type"
    },
    {
        name: "Level",
        uid: "level"
    }
];
let defaultRows = [
    {
        id: 1,
        name: "Charizard",
        type: "Fire, Flying",
        level: "67",
        weight: "200lbs",
        height: "5'7\""
    },
    {
        id: 2,
        name: "Blastoise",
        type: "Water",
        level: "56",
        weight: "188lbs",
        height: "5'3\""
    },
    {
        id: 3,
        name: "Venusaur",
        type: "Grass, Poison",
        level: "83",
        weight: "220lbs",
        height: "6'7\""
    },
    {
        id: 4,
        name: "Pikachu",
        type: "Electric",
        level: "100",
        weight: "13lbs",
        height: "1'4\""
    },
    {
        id: 5,
        name: "Charizard",
        type: "Fire, Flying",
        level: "67",
        weight: "200lbs",
        height: "5'7\""
    },
    {
        id: 6,
        name: "Blastoise",
        type: "Water",
        level: "56",
        weight: "188lbs",
        height: "5'3\""
    },
    {
        id: 7,
        name: "Venusaur",
        type: "Grass, Poison",
        level: "83",
        weight: "220lbs",
        height: "6'7\""
    },
    {
        id: 8,
        name: "Pikachu",
        type: "Electric",
        level: "100",
        weight: "13lbs",
        height: "1'4\""
    },
    {
        id: 9,
        name: "Charizard",
        type: "Fire, Flying",
        level: "67",
        weight: "200lbs",
        height: "5'7\""
    },
    {
        id: 10,
        name: "Blastoise",
        type: "Water",
        level: "56",
        weight: "188lbs",
        height: "5'3\""
    },
    {
        id: 11,
        name: "Venusaur",
        type: "Grass, Poison",
        level: "83",
        weight: "220lbs",
        height: "6'7\""
    },
    {
        id: 12,
        name: "Pikachu",
        type: "Electric",
        level: "100",
        weight: "13lbs",
        height: "1'4\""
    }
];
const Template = (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement("label", {
        htmlFor: "focusable-before"
    }, "Focusable before"), /*#__PURE__*/ (0, _reactDefault.default).createElement("input", {
        id: "focusable-before"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _example.Table), {
        "aria-label": "Table with selection",
        selectionMode: "multiple",
        ...args
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _table.TableHeader), {
        columns: columns
    }, (column)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _table.Column), {
            key: column.uid
        }, column.name)), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _table.TableBody), {
        items: defaultRows
    }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _table.Row), null, (columnKey)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _table.Cell), null, item[columnKey])))), /*#__PURE__*/ (0, _reactDefault.default).createElement("label", {
        htmlFor: "focus-after"
    }, "Focusable after"), /*#__PURE__*/ (0, _reactDefault.default).createElement("input", {
        id: "focus-after"
    }));
const TemplateBackwardsCompat = (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement("label", {
        htmlFor: "focusable-before"
    }, "Focusable before"), /*#__PURE__*/ (0, _reactDefault.default).createElement("input", {
        id: "focusable-before"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _exampleBackwardsCompat.Table), {
        "aria-label": "Table with selection",
        selectionMode: "multiple",
        ...args
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _table.TableHeader), {
        columns: columns
    }, (column)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _table.Column), {
            key: column.uid
        }, column.name)), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _table.TableBody), {
        items: defaultRows
    }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _table.Row), null, (columnKey)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _table.Cell), null, item[columnKey])))), /*#__PURE__*/ (0, _reactDefault.default).createElement("label", {
        htmlFor: "focusable-after"
    }, "Focusable after"), /*#__PURE__*/ (0, _reactDefault.default).createElement("input", {
        id: "focusable-after"
    }));
const ScrollTesting = {
    render: Template
};
const ActionTesting = {
    render: Template,
    args: {
        selectionBehavior: "replace",
        selectionStyle: "highlight",
        onAction: (0, _addonActions.action)("onAction")
    },
    parameters: {
        a11y: {
            config: {
                // False positive, tabbing into the table is handled by us and will focus the row
                rules: [
                    {
                        id: "scrollable-region-focusable",
                        enabled: false
                    }
                ]
            }
        }
    }
};
const BackwardCompatActionTesting = {
    render: TemplateBackwardsCompat,
    args: {
        selectionBehavior: "replace",
        selectionStyle: "highlight",
        onAction: (0, _addonActions.action)("onAction")
    },
    parameters: {
        a11y: {
            config: {
                // False positive, tabbing into the table is handled by us and will focus the row
                rules: [
                    {
                        id: "scrollable-region-focusable",
                        enabled: false
                    }
                ]
            }
        }
    }
};
const TableWithResizingNoProps = {
    args: {},
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _exampleResizing.Table), args, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _table.TableHeader), {
            columns: columns
        }, (column)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _table.Column), {
                key: column.uid,
                allowsResizing: true
            }, column.name)), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _table.TableBody), {
            items: defaultRows
        }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _table.Row), null, (columnKey)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _table.Cell), null, item[columnKey]))))
};
let columnsDefaultFR = [
    {
        name: "Name",
        uid: "name",
        defaultWidth: "1fr"
    },
    {
        name: "Type",
        uid: "type",
        defaultWidth: "1fr"
    },
    {
        name: "Level",
        uid: "level",
        defaultWidth: "4fr"
    }
];
const TableWithResizingFRs = {
    args: {},
    render: ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _exampleResizing.Table), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _table.TableHeader), {
            columns: columnsDefaultFR
        }, (column)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _table.Column), {
                key: column.uid,
                defaultWidth: column.defaultWidth,
                width: column.width,
                allowsResizing: true
            }, column.name)), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _table.TableBody), {
            items: defaultRows
        }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _table.Row), null, (columnKey)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _table.Cell), null, item[columnKey]))))
};
function ControlledTableResizing(props) {
    let { columns, rows = defaultRows, onResize, ...otherProps } = props;
    let [widths, _setWidths] = (0, _react.useState)(()=>new Map(columns.filter((col)=>col.width).map((col)=>[
                col.uid,
                col.width
            ])));
    let setWidths = (0, _react.useCallback)((vals)=>{
        let controlledKeys = new Set(columns.filter((col)=>col.width).map((col)=>col.uid));
        let newVals = new Map(Array.from(vals).filter(([key])=>controlledKeys.has(key)));
        _setWidths(newVals);
        onResize === null || onResize === void 0 ? void 0 : onResize(vals);
    }, [
        columns,
        onResize
    ]);
    let [savedCols, setSavedCols] = (0, _react.useState)(widths);
    let [renderKey, setRenderKey] = (0, _react.useState)(Math.random());
    // eslint-disable-next-line react-hooks/exhaustive-deps
    let cols = (0, _react.useMemo)(()=>columns.map((col)=>({
                ...col
            })), [
        columns,
        widths
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("button", {
        onClick: ()=>setSavedCols(widths)
    }, "Save Cols"), /*#__PURE__*/ (0, _reactDefault.default).createElement("button", {
        onClick: ()=>{
            _setWidths(savedCols);
            setRenderKey(Math.random());
        }
    }, "Restore Cols"), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", null, "Current saved column state: ", "{", Array.from(savedCols).map(([key, entry])=>`${key} => ${entry}`).join(","), "}"), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        key: renderKey
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _exampleResizing.Table), {
        onResize: setWidths,
        ...otherProps
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _table.TableHeader), {
        columns: cols
    }, (column)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _table.Column), {
            ...column,
            key: column.uid,
            width: widths.get(column.uid),
            allowsResizing: true
        }, column.name)), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _table.TableBody), {
        items: rows
    }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _table.Row), null, (columnKey)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _table.Cell), null, item[columnKey]))))));
}
let columnsFR = [
    {
        name: "Name",
        uid: "name",
        width: "1fr"
    },
    {
        name: "Type",
        uid: "type",
        width: "1fr"
    },
    {
        name: "Level",
        uid: "level",
        width: "5fr"
    }
];
const TableWithResizingFRsControlled = {
    args: {
        columns: columnsFR
    },
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(ControlledTableResizing, args),
    parameters: {
        description: {
            data: `
  You can use the buttons to save and restore the column widths. When restoring,
  you will see a quick flash because the entire table is re-rendered. This
  mimics what would happen if an app reloaded the whole page and restored a saved
  column width state.
  `
        }
    }
};
let columnsSomeFR = [
    {
        name: "Name",
        uid: "name",
        width: "1fr"
    },
    {
        name: "Type",
        uid: "type",
        width: "1fr"
    },
    {
        name: "Height",
        uid: "height"
    },
    {
        name: "Weight",
        uid: "weight"
    },
    {
        name: "Level",
        uid: "level",
        width: "5fr"
    }
];
const TableWithSomeResizingFRsControlled = {
    args: {
        columns: columnsSomeFR
    },
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(ControlledTableResizing, args),
    parameters: {
        description: {
            data: `
  You can use the buttons to save and restore the column widths. When restoring,
  you will see a quick flash because the entire table is re-rendered. This
  mimics what would happen if an app reloaded the whole page and restored a saved
  column width state.
  `
        }
    }
};
const DocExample = {
    args: {},
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _exampleDocs.Table), {
            "aria-label": "Table with always visible resizers",
            onResizeStart: (0, _addonActions.action)("onResizeStart"),
            onResize: (0, _addonActions.action)("onResize"),
            onResizeEnd: (0, _addonActions.action)("onResizeEnd"),
            ...args
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _table.TableHeader), {
            columns: columns
        }, (column)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _table.Column), {
                allowsResizing: true,
                key: column.uid
            }, column.name)), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _table.TableBody), {
            items: defaultRows
        }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _table.Row), null, (columnKey)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _table.Cell), null, item[columnKey]))))
};
const DocExampleControlled = {
    args: {
        columns: columnsFR
    },
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(ControlledDocsTable, args)
};
function ControlledDocsTable(props) {
    let { columns, ...otherProps } = props;
    let [widths, _setWidths] = (0, _react.useState)(()=>new Map(columns.filter((col)=>col.width).map((col)=>[
                col.uid,
                col.width
            ])));
    let setWidths = (0, _react.useCallback)((newWidths)=>{
        let controlledKeys = new Set(columns.filter((col)=>col.width).map((col)=>col.uid));
        let newVals = new Map(Array.from(newWidths).filter(([key])=>controlledKeys.has(key)));
        _setWidths(newVals);
    }, [
        columns
    ]);
    // Needed to get past column caching so new sizes actually are rendered
    // eslint-disable-next-line react-hooks/exhaustive-deps
    let cols = (0, _react.useMemo)(()=>columns.map((col)=>({
                ...col
            })), [
        widths,
        columns
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _exampleDocs.Table), {
        "aria-label": "Table with selection",
        selectionMode: "multiple",
        onResize: setWidths,
        ...otherProps
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _table.TableHeader), {
        columns: cols
    }, (column)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _table.Column), {
            allowsResizing: true,
            key: column.uid,
            width: widths.get(column.uid)
        }, column.name)), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _table.TableBody), {
        items: defaultRows
    }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _table.Row), null, (columnKey)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _table.Cell), null, item[columnKey]))));
}

},{"@storybook/addon-actions":"coXbW","./example-backwards-compat":"hJbaM","@react-stately/table":"6ZM93","./example-docs":"i5bLb","react":"9yzVZ","./example-resizing":"bEG3Z","./example":"9LYWT","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"hJbaM":[function(require,module,exports) {
/*
 * Copyright 2021 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Table", ()=>Table);
parcelHelpers.export(exports, "TableRowGroup", ()=>TableRowGroup);
parcelHelpers.export(exports, "TableHeaderRow", ()=>TableHeaderRow);
parcelHelpers.export(exports, "TableColumnHeader", ()=>TableColumnHeader);
parcelHelpers.export(exports, "TableRow", ()=>TableRow);
parcelHelpers.export(exports, "TableCell", ()=>TableCell);
parcelHelpers.export(exports, "TableCheckboxCell", ()=>TableCheckboxCell);
parcelHelpers.export(exports, "TableSelectAllCell", ()=>TableSelectAllCell);
var _utils = require("@react-aria/utils");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _checkbox = require("@react-aria/checkbox");
var _focus = require("@react-aria/focus");
var _src = require("../src");
var _table = require("@react-stately/table");
var _toggle = require("@react-stately/toggle");
var _visuallyHidden = require("@react-aria/visually-hidden");
function Table(props) {
    let { onAction } = props;
    let [showSelectionCheckboxes, setShowSelectionCheckboxes] = (0, _react.useState)(props.selectionStyle !== "highlight");
    let state = (0, _table.useTableState)({
        ...props,
        showSelectionCheckboxes,
        selectionBehavior: props.selectionStyle === "highlight" ? "replace" : "toggle"
    });
    // If the selection behavior changes in state, we need to update showSelectionCheckboxes here due to the circular dependency...
    let shouldShowCheckboxes = state.selectionManager.selectionBehavior !== "replace";
    if (shouldShowCheckboxes !== showSelectionCheckboxes) setShowSelectionCheckboxes(shouldShowCheckboxes);
    let ref = (0, _react.useRef)();
    let bodyRef = (0, _react.useRef)();
    let { collection } = state;
    let { gridProps } = (0, _src.useTable)({
        ...props,
        scrollRef: bodyRef
    }, state, ref);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("table", {
        ...gridProps,
        ref: ref,
        style: {
            borderCollapse: "collapse"
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(TableRowGroup, {
        type: "thead",
        style: {
            borderBottom: "2px solid gray",
            display: "block"
        }
    }, collection.headerRows.map((headerRow)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(TableHeaderRow, {
            key: headerRow.key,
            item: headerRow,
            state: state
        }, [
            ...state.collection.getChildren(headerRow.key)
        ].map((column)=>column.props.isSelectionCell ? /*#__PURE__*/ (0, _reactDefault.default).createElement(TableSelectAllCell, {
                key: column.key,
                column: column,
                state: state
            }) : /*#__PURE__*/ (0, _reactDefault.default).createElement(TableColumnHeader, {
                key: column.key,
                column: column,
                state: state
            }))))), /*#__PURE__*/ (0, _reactDefault.default).createElement(TableRowGroup, {
        ref: bodyRef,
        type: "tbody",
        style: {
            display: "block",
            overflow: "auto",
            maxHeight: "200px"
        }
    }, [
        ...collection
    ].map((row)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(TableRow, {
            key: row.key,
            item: row,
            state: state,
            onAction: onAction
        }, [
            ...state.collection.getChildren(row.key)
        ].map((cell)=>cell.props.isSelectionCell ? /*#__PURE__*/ (0, _reactDefault.default).createElement(TableCheckboxCell, {
                key: cell.key,
                cell: cell,
                state: state
            }) : /*#__PURE__*/ (0, _reactDefault.default).createElement(TableCell, {
                key: cell.key,
                cell: cell,
                state: state
            }))))));
}
const TableRowGroup = /*#__PURE__*/ (0, _reactDefault.default).forwardRef((props, ref)=>{
    let { type: Element, style, children } = props;
    let { rowGroupProps } = (0, _src.useTableRowGroup)();
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Element, {
        ref: ref,
        ...rowGroupProps,
        style: style
    }, children);
});
function TableHeaderRow({ item, state, children }) {
    let ref = (0, _react.useRef)();
    let { rowProps } = (0, _src.useTableHeaderRow)({
        node: item
    }, state, ref);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("tr", {
        ...rowProps,
        ref: ref
    }, children);
}
function TableColumnHeader({ column, state }) {
    var _state_sortDescriptor, _state_sortDescriptor1;
    let ref = (0, _react.useRef)();
    let { columnHeaderProps } = (0, _src.useTableColumnHeader)({
        node: column
    }, state, ref);
    let { isFocusVisible, focusProps } = (0, _focus.useFocusRing)();
    let arrowIcon = ((_state_sortDescriptor = state.sortDescriptor) === null || _state_sortDescriptor === void 0 ? void 0 : _state_sortDescriptor.direction) === "ascending" ? "\u25B2" : "\u25BC";
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("th", {
        ...(0, _utils.mergeProps)(columnHeaderProps, focusProps),
        colSpan: column.colspan,
        style: {
            textAlign: column.colspan > 1 ? "center" : "left",
            padding: "5px 10px",
            outline: isFocusVisible ? "2px solid orange" : "none",
            cursor: "default"
        },
        ref: ref
    }, column.rendered, column.props.allowsSorting && /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        "aria-hidden": "true",
        style: {
            padding: "0 2px",
            visibility: ((_state_sortDescriptor1 = state.sortDescriptor) === null || _state_sortDescriptor1 === void 0 ? void 0 : _state_sortDescriptor1.column) === column.key ? "visible" : "hidden"
        }
    }, arrowIcon));
}
function TableRow({ item, children, state, onAction }) {
    let ref = (0, _react.useRef)();
    let isSelected = state.selectionManager.isSelected(item.key);
    let { rowProps } = (0, _src.useTableRow)({
        node: item,
        onAction: onAction ? ()=>onAction(item.key) : undefined
    }, state, ref);
    let { isFocusVisible, focusProps } = (0, _focus.useFocusRing)();
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("tr", {
        style: {
            // eslint-disable-next-line no-nested-ternary
            background: isSelected ? "blueviolet" : item.index % 2 ? "lightgray" : "none",
            color: isSelected ? "white" : null,
            outline: isFocusVisible ? "2px solid orange" : "none"
        },
        ...(0, _utils.mergeProps)(rowProps, focusProps),
        ref: ref
    }, children);
}
function TableCell({ cell, state }) {
    let ref = (0, _react.useRef)();
    let { gridCellProps } = (0, _src.useTableCell)({
        node: cell
    }, state, ref);
    let { isFocusVisible, focusProps } = (0, _focus.useFocusRing)();
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("td", {
        ...(0, _utils.mergeProps)(gridCellProps, focusProps),
        style: {
            padding: "5px 10px",
            outline: isFocusVisible ? "2px solid orange" : "none",
            cursor: "default"
        },
        ref: ref
    }, cell.rendered);
}
function TableCheckboxCell({ cell, state }) {
    let ref = (0, _react.useRef)();
    let { gridCellProps } = (0, _src.useTableCell)({
        node: cell
    }, state, ref);
    let { checkboxProps } = (0, _src.useTableSelectionCheckbox)({
        key: cell.parentKey
    }, state);
    let inputRef = (0, _react.useRef)(null);
    let { inputProps } = (0, _checkbox.useCheckbox)(checkboxProps, (0, _toggle.useToggleState)(checkboxProps), inputRef);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("td", {
        ...gridCellProps,
        ref: ref
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("input", inputProps));
}
function TableSelectAllCell({ column, state }) {
    let ref = (0, _react.useRef)();
    let isSingleSelectionMode = state.selectionManager.selectionMode === "single";
    let { columnHeaderProps } = (0, _src.useTableColumnHeader)({
        node: column
    }, state, ref);
    let { checkboxProps } = (0, _src.useTableSelectAllCheckbox)(state);
    let inputRef = (0, _react.useRef)(null);
    let { inputProps } = (0, _checkbox.useCheckbox)(checkboxProps, (0, _toggle.useToggleState)(checkboxProps), inputRef);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("th", {
        ...columnHeaderProps,
        ref: ref
    }, /*
          In single selection mode, the checkbox will be hidden.
          So to avoid leaving a column header with no accessible content,
          use a VisuallyHidden component to include the aria-label from the checkbox,
          which for single selection will be "Select."
        */ isSingleSelectionMode && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _visuallyHidden.VisuallyHidden), null, inputProps["aria-label"]), /*#__PURE__*/ (0, _reactDefault.default).createElement("input", {
        ...inputProps,
        ref: inputRef,
        style: isSingleSelectionMode ? {
            visibility: "hidden"
        } : undefined
    }));
}

},{"@react-aria/utils":"9cLk5","react":"9yzVZ","@react-aria/checkbox":"5e6Tk","@react-aria/focus":"42mbF","../src":"jm3EF","@react-stately/table":"6ZM93","@react-stately/toggle":"5qaKI","@react-aria/visually-hidden":"4jwxT","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"i5bLb":[function(require,module,exports) {
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Table", ()=>Table);
var _docsExampleCss = require("./docs-example.css");
var _docsExampleCssDefault = parcelHelpers.interopDefault(_docsExampleCss);
var _utils = require("@react-spectrum/utils");
var _utils1 = require("@react-aria/utils");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactAria = require("react-aria");
var _focus = require("@react-aria/focus");
var _table = require("@react-aria/table");
var _table1 = require("@react-stately/table");
function Table(props) {
    let { onResizeStart, onResize, onResizeEnd } = props;
    let state = (0, _table1.useTableState)(props);
    let ref = (0, _react.useRef)();
    let { collection } = state;
    let { gridProps } = (0, _table.useTable)({
        ...props,
        // The table itself is scrollable rather than just the body
        scrollRef: ref
    }, state, ref);
    let getDefaultMinWidth = (0, _react.useCallback)(()=>{
        return 40;
    }, []);
    let layoutState = (0, _table1.useTableColumnResizeState)({
        // Matches the width of the table itself
        tableWidth: 300,
        getDefaultMinWidth
    }, state);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("table", {
        ...gridProps,
        ref: ref,
        className: (0, _utils.classNames)((0, _docsExampleCssDefault.default), "aria-table")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(ResizableTableRowGroup, {
        type: "thead",
        className: (0, _utils.classNames)((0, _docsExampleCssDefault.default), "aria-table-rowGroupHeader")
    }, collection.headerRows.map((headerRow)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(ResizableTableHeaderRow, {
            key: headerRow.key,
            item: headerRow,
            state: state
        }, [
            ...headerRow.childNodes
        ].map((column)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(ResizableTableColumnHeader, {
                key: column.key,
                column: column,
                state: state,
                layoutState: layoutState,
                onResizeStart: onResizeStart,
                onResize: onResize,
                onResizeEnd: onResizeEnd
            }))))), /*#__PURE__*/ (0, _reactDefault.default).createElement(ResizableTableRowGroup, {
        className: (0, _utils.classNames)((0, _docsExampleCssDefault.default), "aria-table-rowGroupBody"),
        type: "tbody"
    }, [
        ...collection.body.childNodes
    ].map((row)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(ResizableTableRow, {
            key: row.key,
            item: row,
            state: state
        }, [
            ...row.childNodes
        ].map((cell)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(ResizableTableCell, {
                key: cell.key,
                cell: cell,
                state: state,
                layoutState: layoutState
            }))))));
}
function ResizableTableRowGroup({ type: Element, children, className }) {
    let { rowGroupProps } = (0, _table.useTableRowGroup)();
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Element, {
        ...rowGroupProps,
        className: (0, _utils.classNames)((0, _docsExampleCssDefault.default), "aria-table-rowGroup", className)
    }, children);
}
function ResizableTableHeaderRow({ item, state, children }) {
    let ref = (0, _react.useRef)();
    let { rowProps } = (0, _table.useTableHeaderRow)({
        node: item
    }, state, ref);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("tr", {
        ...rowProps,
        ref: ref,
        className: (0, _utils.classNames)((0, _docsExampleCssDefault.default), "aria-table-row")
    }, children);
}
function ResizableTableColumnHeader({ column, state, layoutState, onResizeStart, onResize, onResizeEnd }) {
    let ref = (0, _react.useRef)(null);
    let { columnHeaderProps } = (0, _table.useTableColumnHeader)({
        node: column
    }, state, ref);
    let allowsResizing = column.props.allowsResizing;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("th", {
        ...(0, _utils1.mergeProps)(columnHeaderProps),
        className: (0, _utils.classNames)((0, _docsExampleCssDefault.default), "aria-table-headerCell"),
        style: {
            width: layoutState.getColumnWidth(column.key)
        },
        ref: ref
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        style: {
            display: "flex",
            position: "relative"
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Button, {
        className: (0, _utils.classNames)((0, _docsExampleCssDefault.default), "aria-table-headerTitle")
    }, column.rendered), allowsResizing && /*#__PURE__*/ (0, _reactDefault.default).createElement(Resizer, {
        column: column,
        layoutState: layoutState,
        onResizeStart: onResizeStart,
        onResize: onResize,
        onResizeEnd: onResizeEnd
    })));
}
function Button(props) {
    let ref = props.buttonRef;
    let { focusProps, isFocusVisible } = (0, _focus.useFocusRing)();
    let { buttonProps } = (0, _reactAria.useButton)(props, ref);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("button", {
        ...(0, _utils1.mergeProps)(buttonProps, focusProps),
        ref: ref,
        className: (0, _utils.classNames)((0, _docsExampleCssDefault.default), props.className, {
            "focus": isFocusVisible
        })
    }, props.children);
}
function Resizer(props) {
    let { column, layoutState, onResizeStart, onResize, onResizeEnd } = props;
    let ref = (0, _react.useRef)();
    let { resizerProps, inputProps, isResizing } = (0, _table.useTableColumnResize)({
        column,
        "aria-label": "Resizer",
        onResizeStart,
        onResize,
        onResizeEnd
    }, layoutState, ref);
    let { focusProps, isFocusVisible } = (0, _focus.useFocusRing)();
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        role: "presentation",
        className: (0, _utils.classNames)((0, _docsExampleCssDefault.default), "aria-table-resizer", {
            "focus": isFocusVisible,
            "resizing": isResizing
        }),
        ...resizerProps
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("input", {
        ref: ref,
        ...(0, _utils1.mergeProps)(inputProps, focusProps)
    }));
}
function ResizableTableRow({ item, children, state }) {
    let ref = (0, _react.useRef)();
    let isSelected = state.selectionManager.isSelected(item.key);
    let { rowProps, isPressed } = (0, _table.useTableRow)({
        node: item
    }, state, ref);
    let { isFocusVisible, focusProps } = (0, _focus.useFocusRing)();
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("tr", {
        className: (0, _utils.classNames)((0, _docsExampleCssDefault.default), "aria-table-row"),
        style: {
            // eslint-disable-next-line no-nested-ternary
            background: isSelected ? "blueviolet" : isPressed ? "var(--spectrum-global-color-gray-400)" : item.index % 2 ? "var(--spectrum-alias-highlight-hover)" : "none",
            color: isSelected ? "white" : null,
            outline: "none",
            boxShadow: isFocusVisible ? "inset 0 0 0 2px orange" : "none"
        },
        ...(0, _utils1.mergeProps)(rowProps, focusProps),
        ref: ref
    }, children);
}
function ResizableTableCell({ cell, state, layoutState }) {
    let ref = (0, _react.useRef)();
    let { gridCellProps } = (0, _table.useTableCell)({
        node: cell
    }, state, ref);
    let { isFocusVisible, focusProps } = (0, _focus.useFocusRing)();
    let column = cell.column;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("td", {
        ...(0, _utils1.mergeProps)(gridCellProps, focusProps),
        className: (0, _utils.classNames)((0, _docsExampleCssDefault.default), "aria-table-cell", {
            "focus": isFocusVisible
        }),
        style: {
            width: layoutState.getColumnWidth(column.key)
        },
        ref: ref
    }, cell.rendered);
}

},{"./docs-example.css":"iQ6gS","@react-spectrum/utils":"cMIJ6","@react-aria/utils":"9cLk5","react":"9yzVZ","react-aria":"e7jhe","@react-aria/focus":"42mbF","@react-aria/table":"jm3EF","@react-stately/table":"6ZM93","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"iQ6gS":[function(require,module,exports) {
module.exports["aria-table"] = `Wvci_q_aria-table`;
module.exports["aria-table-cell"] = `Wvci_q_aria-table-cell`;
module.exports["aria-table-headerCell"] = `Wvci_q_aria-table-headerCell`;
module.exports["aria-table-headerTitle"] = `Wvci_q_aria-table-headerTitle`;
module.exports["aria-table-resizer"] = `Wvci_q_aria-table-resizer`;
module.exports["aria-table-row"] = `Wvci_q_aria-table-row`;
module.exports["aria-table-rowGroup"] = `Wvci_q_aria-table-rowGroup`;
module.exports["aria-table-rowGroupBody"] = `Wvci_q_aria-table-rowGroupBody`;
module.exports["aria-table-rowGroupHeader"] = `Wvci_q_aria-table-rowGroupHeader`;
module.exports["focus"] = `Wvci_q_focus`;
module.exports["resizing"] = `Wvci_q_resizing`;

},{}],"bEG3Z":[function(require,module,exports) {
/*
 * Copyright 2021 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Table", ()=>Table);
parcelHelpers.export(exports, "TableRowGroup", ()=>TableRowGroup);
parcelHelpers.export(exports, "TableHeaderRow", ()=>TableHeaderRow);
parcelHelpers.export(exports, "TableColumnHeader", ()=>TableColumnHeader);
parcelHelpers.export(exports, "TableRow", ()=>TableRow);
parcelHelpers.export(exports, "TableCell", ()=>TableCell);
parcelHelpers.export(exports, "TableCheckboxCell", ()=>TableCheckboxCell);
parcelHelpers.export(exports, "TableSelectAllCell", ()=>TableSelectAllCell);
var _resizingCss = require("./resizing.css");
var _resizingCssDefault = parcelHelpers.interopDefault(_resizingCss);
var _table = require("@react-aria/table");
var _utils = require("@react-spectrum/utils");
var _focus = require("@react-aria/focus");
var _utils1 = require("@react-aria/utils");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _varsCss = require("@adobe/spectrum-css-temp/components/table/vars.css");
var _varsCssDefault = parcelHelpers.interopDefault(_varsCss);
var _checkbox = require("@react-aria/checkbox");
var _table1 = require("@react-stately/table");
var _toggle = require("@react-stately/toggle");
var _visuallyHidden = require("@react-aria/visually-hidden");
function Table(props) {
    let [showSelectionCheckboxes, setShowSelectionCheckboxes] = (0, _react.useState)(props.selectionStyle !== "highlight");
    let state = (0, _table1.useTableState)({
        ...props,
        showSelectionCheckboxes,
        selectionBehavior: props.selectionStyle === "highlight" ? "replace" : "toggle"
    });
    let [tableWidth, setTableWidth] = (0, _react.useState)(0);
    let getDefaultWidth = (0, _react.useCallback)(()=>undefined, []);
    let getDefaultMinWidth = (0, _react.useCallback)(()=>75, []);
    let layoutState = (0, _table1.useTableColumnResizeState)({
        getDefaultWidth,
        getDefaultMinWidth,
        tableWidth
    }, state);
    // If the selection behavior changes in state, we need to update showSelectionCheckboxes here due to the circular dependency...
    let shouldShowCheckboxes = state.selectionManager.selectionBehavior !== "replace";
    if (shouldShowCheckboxes !== showSelectionCheckboxes) setShowSelectionCheckboxes(shouldShowCheckboxes);
    let ref = (0, _react.useRef)(null);
    let bodyRef = (0, _react.useRef)(null);
    let { collection } = state;
    let { gridProps } = (0, _table.useTable)({
        ...props,
        onRowAction: props.onAction,
        scrollRef: bodyRef,
        "aria-label": "example table"
    }, state, ref);
    let layout = (0, _react.useMemo)(()=>({
            ...layoutState,
            tableState: state
        }), [
        layoutState,
        state
    ]);
    (0, _utils1.useLayoutEffect)(()=>{
        if (bodyRef && bodyRef.current) setTableWidth(bodyRef.current.clientWidth);
    }, []);
    (0, _utils1.useResizeObserver)({
        ref,
        onResize: ()=>setTableWidth(bodyRef.current.clientWidth)
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("table", {
        ...gridProps,
        ref: ref,
        className: (0, _utils.classNames)((0, _resizingCssDefault.default), "aria-table")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(TableRowGroup, {
        type: "thead",
        className: (0, _utils.classNames)((0, _resizingCssDefault.default), "aria-table-rowGroup", "aria-table-rowGroupHeader")
    }, collection.headerRows.map((headerRow)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(TableHeaderRow, {
            key: headerRow.key,
            item: headerRow,
            state: state,
            className: (0, _utils.classNames)((0, _resizingCssDefault.default), "aria-table-row", "aria-table-headerRow")
        }, [
            ...state.collection.getChildren(headerRow.key)
        ].map((column)=>column.props.isSelectionCell ? /*#__PURE__*/ (0, _reactDefault.default).createElement(TableSelectAllCell, {
                key: column.key,
                column: column,
                state: state,
                layout: layout
            }) : /*#__PURE__*/ (0, _reactDefault.default).createElement(TableColumnHeader, {
                key: column.key,
                column: column,
                state: state,
                layout: layout,
                onResizeStart: props.onResizeStart,
                onResize: props.onResize,
                onResizeEnd: props.onResizeEnd
            }))))), /*#__PURE__*/ (0, _reactDefault.default).createElement(TableRowGroup, {
        type: "tbody",
        ref: bodyRef,
        className: (0, _utils.classNames)((0, _resizingCssDefault.default), "aria-table-rowGroup")
    }, [
        ...collection
    ].map((row)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(TableRow, {
            key: row.key,
            item: row,
            state: state,
            className: (0, _utils.classNames)((0, _resizingCssDefault.default), "aria-table-row")
        }, [
            ...state.collection.getChildren(row.key)
        ].map((cell)=>cell.props.isSelectionCell ? /*#__PURE__*/ (0, _reactDefault.default).createElement(TableCheckboxCell, {
                key: cell.key,
                cell: cell,
                state: state,
                layout: layout
            }) : /*#__PURE__*/ (0, _reactDefault.default).createElement(TableCell, {
                key: cell.key,
                cell: cell,
                state: state,
                layout: layout
            }))))));
}
const TableRowGroup = /*#__PURE__*/ (0, _reactDefault.default).forwardRef((props, ref)=>{
    let { type: Element, style, children, className } = props;
    let { rowGroupProps } = (0, _table.useTableRowGroup)();
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Element, {
        ref: ref,
        ...rowGroupProps,
        style: style,
        className: className
    }, children);
});
function TableHeaderRow({ item, state, children, className }) {
    let ref = (0, _react.useRef)();
    let { rowProps } = (0, _table.useTableHeaderRow)({
        node: item
    }, state, ref);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("tr", {
        ...rowProps,
        ref: ref,
        className: className
    }, children);
}
function Resizer({ column, layout, onResizeStart, onResize, onResizeEnd }) {
    let ref = (0, _react.useRef)(null);
    let { resizerProps, inputProps } = (0, _table.useTableColumnResize)({
        column,
        "aria-label": "Resizer",
        onResizeStart,
        onResize,
        onResizeEnd
    }, layout, ref);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _focus.FocusRing), {
        within: true,
        focusRingClass: (0, _utils.classNames)((0, _varsCssDefault.default), "focus-ring")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        role: "presentation",
        style: {
            cursor: undefined,
            alignSelf: "stretch",
            width: "20px",
            border: "1px solid red",
            touchAction: "none",
            flex: "0 0 auto",
            position: "absolute",
            insetInlineEnd: 0,
            height: "100%"
        },
        ...resizerProps
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _visuallyHidden.VisuallyHidden), null, /*#__PURE__*/ (0, _reactDefault.default).createElement("input", {
        ref: ref,
        ...inputProps
    })))));
}
function TableColumnHeader({ column, state, layout, onResizeStart, onResize, onResizeEnd }) {
    var _state_sortDescriptor, _state_sortDescriptor1;
    let ref = (0, _react.useRef)();
    let { columnHeaderProps } = (0, _table.useTableColumnHeader)({
        node: column
    }, state, ref);
    let { isFocusVisible, focusProps } = (0, _focus.useFocusRing)();
    let arrowIcon = ((_state_sortDescriptor = state.sortDescriptor) === null || _state_sortDescriptor === void 0 ? void 0 : _state_sortDescriptor.direction) === "ascending" ? "\u25B2" : "\u25BC";
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("th", {
        ...(0, _utils1.mergeProps)(columnHeaderProps, focusProps),
        colSpan: column.colspan,
        style: {
            width: layout.getColumnWidth(column.key),
            textAlign: column.colspan > 1 ? "center" : "left",
            padding: "5px 10px",
            outline: isFocusVisible ? "2px solid orange" : "none",
            cursor: "default",
            overflow: "hidden",
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
            display: "block",
            flex: "0 0 auto"
        },
        ref: ref
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        style: {
            display: "flex",
            position: "relative"
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        style: {
            flex: "1 1 auto"
        }
    }, column.rendered, column.props.allowsSorting && /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        "aria-hidden": "true",
        style: {
            padding: "0 2px",
            visibility: ((_state_sortDescriptor1 = state.sortDescriptor) === null || _state_sortDescriptor1 === void 0 ? void 0 : _state_sortDescriptor1.column) === column.key ? "visible" : "hidden"
        }
    }, arrowIcon)), column.props.allowsResizing && /*#__PURE__*/ (0, _reactDefault.default).createElement(Resizer, {
        column: column,
        layout: layout,
        onResizeStart: onResizeStart,
        onResize: onResize,
        onResizeEnd: onResizeEnd
    })));
}
function TableRow({ item, children, state, className }) {
    let ref = (0, _react.useRef)();
    let isSelected = state.selectionManager.isSelected(item.key);
    let { rowProps } = (0, _table.useTableRow)({
        node: item
    }, state, ref);
    let { isFocusVisible, focusProps } = (0, _focus.useFocusRing)();
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("tr", {
        style: {
            color: isSelected ? "white" : null,
            outline: isFocusVisible ? "2px solid orange" : "none"
        },
        className: className,
        ...(0, _utils1.mergeProps)(rowProps, focusProps),
        ref: ref
    }, children);
}
function TableCell({ cell, state, layout }) {
    let ref = (0, _react.useRef)();
    let { gridCellProps } = (0, _table.useTableCell)({
        node: cell
    }, state, ref);
    let { isFocusVisible, focusProps } = (0, _focus.useFocusRing)();
    let column = cell.column;
    let isSelected = state.selectionManager.isSelected(cell.parentKey);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("td", {
        ...(0, _utils1.mergeProps)(gridCellProps, focusProps),
        style: {
            width: layout.getColumnWidth(column.key),
            padding: "5px 10px",
            outline: isFocusVisible ? "2px solid orange inset" : "none",
            cursor: "default",
            overflow: "hidden",
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
            display: "block",
            flex: "0 0 auto",
            // eslint-disable-next-line no-nested-ternary
            background: isSelected ? "blueviolet" : cell.parentKey % 2 ? "var(--spectrum-gray-75)" : "var(--spectrum-gray-100)"
        },
        ref: ref
    }, cell.rendered);
}
function TableCheckboxCell({ cell, state, layout }) {
    let ref = (0, _react.useRef)();
    let { gridCellProps } = (0, _table.useTableCell)({
        node: cell
    }, state, ref);
    let { checkboxProps } = (0, _table.useTableSelectionCheckbox)({
        key: cell.parentKey
    }, state);
    let inputRef = (0, _react.useRef)(null);
    let { inputProps } = (0, _checkbox.useCheckbox)(checkboxProps, (0, _toggle.useToggleState)(checkboxProps), inputRef);
    let column = cell.column;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("td", {
        ...gridCellProps,
        style: {
            width: layout.getColumnWidth(column.key)
        },
        ref: ref
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("input", inputProps));
}
function TableSelectAllCell({ column, state, layout }) {
    let ref = (0, _react.useRef)();
    let isSingleSelectionMode = state.selectionManager.selectionMode === "single";
    let { columnHeaderProps } = (0, _table.useTableColumnHeader)({
        node: column
    }, state, ref);
    let { checkboxProps } = (0, _table.useTableSelectAllCheckbox)(state);
    let inputRef = (0, _react.useRef)(null);
    let { inputProps } = (0, _checkbox.useCheckbox)(checkboxProps, (0, _toggle.useToggleState)(checkboxProps), inputRef);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("th", {
        ...columnHeaderProps,
        style: {
            width: layout.getColumnWidth(column.key)
        },
        ref: ref
    }, /*
          In single selection mode, the checkbox will be hidden.
          So to avoid leaving a column header with no accessible content,
          use a VisuallyHidden component to include the aria-label from the checkbox,
          which for single selection will be "Select."
        */ isSingleSelectionMode && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _visuallyHidden.VisuallyHidden), null, inputProps["aria-label"]), /*#__PURE__*/ (0, _reactDefault.default).createElement("input", {
        ...inputProps,
        ref: inputRef,
        style: isSingleSelectionMode ? {
            visibility: "hidden"
        } : undefined
    }));
}

},{"./resizing.css":"5GvmG","@react-aria/table":"jm3EF","@react-spectrum/utils":"cMIJ6","@react-aria/focus":"42mbF","@react-aria/utils":"9cLk5","react":"9yzVZ","@adobe/spectrum-css-temp/components/table/vars.css":"gCdiM","@react-aria/checkbox":"5e6Tk","@react-stately/table":"6ZM93","@react-stately/toggle":"5qaKI","@react-aria/visually-hidden":"4jwxT","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"5GvmG":[function(require,module,exports) {
module.exports["aria-table"] = `s4WDMa_aria-table`;
module.exports["aria-table-headerRow"] = `s4WDMa_aria-table-headerRow`;
module.exports["aria-table-row"] = `s4WDMa_aria-table-row`;
module.exports["aria-table-rowGroup"] = `s4WDMa_aria-table-rowGroup`;
module.exports["aria-table-rowGroupHeader"] = `s4WDMa_aria-table-rowGroupHeader`;

},{}],"9LYWT":[function(require,module,exports) {
/*
 * Copyright 2021 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Table", ()=>Table);
parcelHelpers.export(exports, "TableRowGroup", ()=>TableRowGroup);
parcelHelpers.export(exports, "TableHeaderRow", ()=>TableHeaderRow);
parcelHelpers.export(exports, "TableColumnHeader", ()=>TableColumnHeader);
parcelHelpers.export(exports, "TableRow", ()=>TableRow);
parcelHelpers.export(exports, "TableCell", ()=>TableCell);
parcelHelpers.export(exports, "TableCheckboxCell", ()=>TableCheckboxCell);
parcelHelpers.export(exports, "TableSelectAllCell", ()=>TableSelectAllCell);
var _utils = require("@react-aria/utils");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _checkbox = require("@react-aria/checkbox");
var _focus = require("@react-aria/focus");
var _table = require("@react-aria/table");
var _table1 = require("@react-stately/table");
var _toggle = require("@react-stately/toggle");
var _visuallyHidden = require("@react-aria/visually-hidden");
function Table(props) {
    let [showSelectionCheckboxes, setShowSelectionCheckboxes] = (0, _react.useState)(props.selectionStyle !== "highlight");
    let state = (0, _table1.useTableState)({
        ...props,
        showSelectionCheckboxes,
        selectionBehavior: props.selectionStyle === "highlight" ? "replace" : "toggle"
    });
    // If the selection behavior changes in state, we need to update showSelectionCheckboxes here due to the circular dependency...
    let shouldShowCheckboxes = state.selectionManager.selectionBehavior !== "replace";
    if (shouldShowCheckboxes !== showSelectionCheckboxes) setShowSelectionCheckboxes(shouldShowCheckboxes);
    let ref = (0, _react.useRef)();
    let bodyRef = (0, _react.useRef)();
    let { collection } = state;
    let { gridProps } = (0, _table.useTable)({
        ...props,
        onRowAction: props.onAction,
        scrollRef: bodyRef
    }, state, ref);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("table", {
        ...gridProps,
        ref: ref,
        style: {
            borderCollapse: "collapse"
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(TableRowGroup, {
        type: "thead",
        style: {
            borderBottom: "2px solid gray",
            display: "block"
        }
    }, collection.headerRows.map((headerRow)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(TableHeaderRow, {
            key: headerRow.key,
            item: headerRow,
            state: state
        }, [
            ...state.collection.getChildren(headerRow.key)
        ].map((column)=>column.props.isSelectionCell ? /*#__PURE__*/ (0, _reactDefault.default).createElement(TableSelectAllCell, {
                key: column.key,
                column: column,
                state: state
            }) : /*#__PURE__*/ (0, _reactDefault.default).createElement(TableColumnHeader, {
                key: column.key,
                column: column,
                state: state
            }))))), /*#__PURE__*/ (0, _reactDefault.default).createElement(TableRowGroup, {
        ref: bodyRef,
        type: "tbody",
        style: {
            display: "block",
            overflow: "auto",
            maxHeight: "200px"
        }
    }, [
        ...collection
    ].map((row)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(TableRow, {
            key: row.key,
            item: row,
            state: state
        }, [
            ...state.collection.getChildren(row.key)
        ].map((cell)=>cell.props.isSelectionCell ? /*#__PURE__*/ (0, _reactDefault.default).createElement(TableCheckboxCell, {
                key: cell.key,
                cell: cell,
                state: state
            }) : /*#__PURE__*/ (0, _reactDefault.default).createElement(TableCell, {
                key: cell.key,
                cell: cell,
                state: state
            }))))));
}
const TableRowGroup = /*#__PURE__*/ (0, _reactDefault.default).forwardRef((props, ref)=>{
    let { type: Element, style, children } = props;
    let { rowGroupProps } = (0, _table.useTableRowGroup)();
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Element, {
        ref: ref,
        ...rowGroupProps,
        style: style
    }, children);
});
function TableHeaderRow({ item, state, children }) {
    let ref = (0, _react.useRef)();
    let { rowProps } = (0, _table.useTableHeaderRow)({
        node: item
    }, state, ref);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("tr", {
        ...rowProps,
        ref: ref
    }, children);
}
function TableColumnHeader({ column, state }) {
    var _state_sortDescriptor, _state_sortDescriptor1;
    let ref = (0, _react.useRef)();
    let { columnHeaderProps } = (0, _table.useTableColumnHeader)({
        node: column
    }, state, ref);
    let { isFocusVisible, focusProps } = (0, _focus.useFocusRing)();
    let arrowIcon = ((_state_sortDescriptor = state.sortDescriptor) === null || _state_sortDescriptor === void 0 ? void 0 : _state_sortDescriptor.direction) === "ascending" ? "\u25B2" : "\u25BC";
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("th", {
        ...(0, _utils.mergeProps)(columnHeaderProps, focusProps),
        colSpan: column.colspan,
        style: {
            textAlign: column.colspan > 1 ? "center" : "left",
            padding: "5px 10px",
            outline: isFocusVisible ? "2px solid orange" : "none",
            cursor: "default"
        },
        ref: ref
    }, column.rendered, column.props.allowsSorting && /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        "aria-hidden": "true",
        style: {
            padding: "0 2px",
            visibility: ((_state_sortDescriptor1 = state.sortDescriptor) === null || _state_sortDescriptor1 === void 0 ? void 0 : _state_sortDescriptor1.column) === column.key ? "visible" : "hidden"
        }
    }, arrowIcon));
}
function TableRow({ item, children, state }) {
    let ref = (0, _react.useRef)();
    let isSelected = state.selectionManager.isSelected(item.key);
    let { rowProps } = (0, _table.useTableRow)({
        node: item
    }, state, ref);
    let { isFocusVisible, focusProps } = (0, _focus.useFocusRing)();
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("tr", {
        style: {
            // eslint-disable-next-line no-nested-ternary
            background: isSelected ? "blueviolet" : item.index % 2 ? "lightgray" : "none",
            color: isSelected ? "white" : null,
            outline: isFocusVisible ? "2px solid orange" : "none"
        },
        ...(0, _utils.mergeProps)(rowProps, focusProps),
        ref: ref
    }, children);
}
function TableCell({ cell, state }) {
    let ref = (0, _react.useRef)();
    let { gridCellProps } = (0, _table.useTableCell)({
        node: cell
    }, state, ref);
    let { isFocusVisible, focusProps } = (0, _focus.useFocusRing)();
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("td", {
        ...(0, _utils.mergeProps)(gridCellProps, focusProps),
        style: {
            padding: "5px 10px",
            outline: isFocusVisible ? "2px solid orange" : "none",
            cursor: "default"
        },
        ref: ref
    }, cell.rendered);
}
function TableCheckboxCell({ cell, state }) {
    let ref = (0, _react.useRef)();
    let { gridCellProps } = (0, _table.useTableCell)({
        node: cell
    }, state, ref);
    let { checkboxProps } = (0, _table.useTableSelectionCheckbox)({
        key: cell.parentKey
    }, state);
    let inputRef = (0, _react.useRef)(null);
    let { inputProps } = (0, _checkbox.useCheckbox)(checkboxProps, (0, _toggle.useToggleState)(checkboxProps), inputRef);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("td", {
        ...gridCellProps,
        ref: ref
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("input", inputProps));
}
function TableSelectAllCell({ column, state }) {
    let ref = (0, _react.useRef)();
    let isSingleSelectionMode = state.selectionManager.selectionMode === "single";
    let { columnHeaderProps } = (0, _table.useTableColumnHeader)({
        node: column
    }, state, ref);
    let { checkboxProps } = (0, _table.useTableSelectAllCheckbox)(state);
    let inputRef = (0, _react.useRef)(null);
    let { inputProps } = (0, _checkbox.useCheckbox)(checkboxProps, (0, _toggle.useToggleState)(checkboxProps), inputRef);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("th", {
        ...columnHeaderProps,
        ref: ref
    }, /*
          In single selection mode, the checkbox will be hidden.
          So to avoid leaving a column header with no accessible content,
          use a VisuallyHidden component to include the aria-label from the checkbox,
          which for single selection will be "Select."
        */ isSingleSelectionMode && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _visuallyHidden.VisuallyHidden), null, inputProps["aria-label"]), /*#__PURE__*/ (0, _reactDefault.default).createElement("input", {
        ...inputProps,
        ref: inputRef,
        style: isSingleSelectionMode ? {
            visibility: "hidden"
        } : undefined
    }));
}

},{"@react-aria/utils":"9cLk5","react":"9yzVZ","@react-aria/checkbox":"5e6Tk","@react-aria/focus":"42mbF","@react-aria/table":"jm3EF","@react-stately/table":"6ZM93","@react-stately/toggle":"5qaKI","@react-aria/visually-hidden":"4jwxT","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"37MAO":[function(require,module,exports) {
/*
 * Copyright 2021 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ScrollTesting", ()=>ScrollTesting);
parcelHelpers.export(exports, "OnPressEndSelection", ()=>OnPressEndSelection);
var _collections = require("@react-stately/collections");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _example = require("./example");
const meta = {
    title: "useTabList"
};
exports.default = meta;
let lotsOfItems = [];
for(let i = 0; i < 50; i++)lotsOfItems.push({
    name: "Item " + i,
    contents: "Contents " + i
});
const Template = (props)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _example.Tabs), {
        "aria-label": "example",
        items: lotsOfItems,
        ...props
    }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _collections.Item), {
            key: item.name,
            title: item.name
        }, item.contents));
const ScrollTesting = {
    render: Template
};
const OnPressEndSelection = {
    render: Template,
    args: {
        shouldSelectOnPressUp: true
    }
};

},{"@react-stately/collections":"loANi","react":"9yzVZ","./example":"8vGQ8","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"8vGQ8":[function(require,module,exports) {
/*
 * Copyright 2021 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Tabs", ()=>Tabs);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _tabs = require("@react-aria/tabs");
var _tabs1 = require("@react-stately/tabs");
function Tabs({ shouldSelectOnPressUp, ...props }) {
    var _state_selectedItem;
    let state = (0, _tabs1.useTabListState)(props);
    let ref = (0, _reactDefault.default).useRef(null);
    let { tabListProps } = (0, _tabs.useTabList)(props, state, ref);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        style: {
            height: "150px"
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...tabListProps,
        ref: ref,
        style: {
            display: "flex",
            borderBottom: "1px solid grey",
            borderLeft: "10px solid grey",
            borderRight: "20px solid grey",
            maxWidth: "400px",
            overflow: "auto"
        }
    }, [
        ...state.collection
    ].map((item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(Tab, {
            key: item.key,
            item: item,
            state: state,
            shouldSelectOnPressUp: shouldSelectOnPressUp
        }))), /*#__PURE__*/ (0, _reactDefault.default).createElement(TabPanel, {
        key: (_state_selectedItem = state.selectedItem) === null || _state_selectedItem === void 0 ? void 0 : _state_selectedItem.key,
        state: state
    }));
}
function Tab({ shouldSelectOnPressUp, item, state }) {
    let { key, rendered } = item;
    let ref = (0, _reactDefault.default).useRef(null);
    let { tabProps } = (0, _tabs.useTab)({
        key,
        shouldSelectOnPressUp
    }, state, ref);
    let isSelected = state.selectedKey === key;
    let isDisabled = state.disabledKeys.has(key);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...tabProps,
        ref: ref,
        style: {
            padding: "10px",
            borderBottom: isSelected ? "3px solid blue" : undefined,
            opacity: isDisabled ? "0.5" : undefined
        }
    }, rendered);
}
function TabPanel({ state, ...props }) {
    var _state_selectedItem;
    let ref = (0, _reactDefault.default).useRef(null);
    let { tabPanelProps } = (0, _tabs.useTabPanel)(props, state, ref);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...tabPanelProps,
        ref: ref,
        style: {
            padding: "10px"
        }
    }, (_state_selectedItem = state.selectedItem) === null || _state_selectedItem === void 0 ? void 0 : _state_selectedItem.props.children);
}

},{"react":"9yzVZ","@react-aria/tabs":"9tXWP","@react-stately/tabs":"47SYn","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"4kkq1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "WithHTMLInputElement", ()=>WithHTMLInputElement);
parcelHelpers.export(exports, "WithHTMLTextAreaElement", ()=>WithHTMLTextAreaElement);
parcelHelpers.export(exports, "WithAutoCapitalization", ()=>WithAutoCapitalization);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _ = require("../");
const TextInputField = (props)=>{
    const { label } = props;
    const ref = (0, _react.useRef)();
    const { labelProps, inputProps } = (0, _.useTextField)(props, ref);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("label", labelProps, label), /*#__PURE__*/ (0, _reactDefault.default).createElement("input", {
        ...inputProps,
        ref: ref
    }));
};
const TextAreaField = (props)=>{
    const { label } = props;
    const ref = (0, _react.useRef)();
    const { labelProps, inputProps } = (0, _.useTextField)({
        ...props,
        inputElementType: "textarea"
    }, ref);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("label", labelProps, label), /*#__PURE__*/ (0, _reactDefault.default).createElement("textarea", {
        ...inputProps,
        ref: ref
    }));
};
exports.default = {
    title: "useTextField"
};
const TextInputFieldTemplate = (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(TextInputField, args);
const TextAreaFieldTemplate = (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(TextAreaField, args);
const WithHTMLInputElement = {
    render: TextInputFieldTemplate,
    args: {
        label: "Test label",
        value: "Test value"
    }
};
const WithHTMLTextAreaElement = {
    render: TextAreaFieldTemplate,
    args: {
        inputElementType: "textarea",
        label: "Test label",
        value: "Test value"
    }
};
const WithAutoCapitalization = {
    render: TextInputFieldTemplate,
    args: {
        label: "Test label",
        autoCapitalize: undefined
    },
    argTypes: {
        autoCapitalize: {
            options: [
                undefined,
                "off",
                "none",
                "on",
                "sentences",
                "words",
                "characters"
            ]
        }
    }
};

},{"react":"9yzVZ","../":"1pcUF","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"1pcUF":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _src = require("./src");
parcelHelpers.exportAll(_src, exports);

},{"./src":"6dEv6","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"iqK0m":[function(require,module,exports) {
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Default", ()=>Default);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _example = require("./Example");
exports.default = {
    title: "useToast",
    args: {
        maxVisibleToasts: 1
    }
};
let count = 0;
const Default = (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _example.ToastContainer), args, (state)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement("button", {
            onClick: ()=>state.add("High " + ++count, {
                    priority: 10
                })
        }, "Add high priority toast"), /*#__PURE__*/ (0, _reactDefault.default).createElement("button", {
            onClick: ()=>state.add("Medium " + ++count, {
                    priority: 5
                })
        }, "Add medium priority toast"), /*#__PURE__*/ (0, _reactDefault.default).createElement("button", {
            onClick: ()=>state.add("Low " + ++count, {
                    priority: 1
                })
        }, "Add low priority toast")));

},{"react":"9yzVZ","./Example":"hiSlW","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"hiSlW":[function(require,module,exports) {
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ToastContainer", ()=>ToastContainer);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _toast = require("@react-stately/toast");
var _reactAria = require("react-aria");
var _src = require("../src");
const ToastContext = /*#__PURE__*/ (0, _react.createContext)(null);
function ToastContainer({ children, ...otherProps }) {
    let state = (0, _toast.useToastState)(otherProps);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(ToastContext.Provider, {
        value: state
    }, children(state), /*#__PURE__*/ (0, _reactDefault.default).createElement(ToastRegion, null));
}
function ToastRegion() {
    let state = (0, _react.useContext)(ToastContext);
    let ref = (0, _react.useRef)();
    let { regionProps } = (0, _src.useToastRegion)({}, state, ref);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...regionProps,
        ref: ref,
        style: {
            position: "fixed",
            bottom: 0,
            right: 0
        }
    }, state.visibleToasts.map((toast)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(Toast, {
            key: toast.key,
            toast: toast
        })));
}
function Toast(props) {
    let state = (0, _react.useContext)(ToastContext);
    let ref = (0, _react.useRef)(null);
    let { toastProps, titleProps, closeButtonProps } = (0, _src.useToast)(props, state, ref);
    let buttonRef = (0, _react.useRef)();
    let { buttonProps } = (0, _reactAria.useButton)(closeButtonProps, buttonRef);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...toastProps,
        ref: ref,
        style: {
            margin: 20,
            display: "flex",
            gap: 5
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", titleProps, props.toast.content), /*#__PURE__*/ (0, _reactDefault.default).createElement("button", {
        ...buttonProps,
        ref: buttonRef
    }, "x"));
}

},{"react":"9yzVZ","@react-stately/toast":"3XbaS","react-aria":"e7jhe","../src":"l9hgR","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"3XbaS":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useToastState", ()=>(0, _useToastState.useToastState));
parcelHelpers.export(exports, "ToastQueue", ()=>(0, _useToastState.ToastQueue));
parcelHelpers.export(exports, "useToastQueue", ()=>(0, _useToastState.useToastQueue));
var _useToastState = require("./useToastState");

},{"./useToastState":"1z8NL","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"1z8NL":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides state management for a toast queue. Toasts display brief, temporary notifications
 * of actions, errors, or other events in an application.
 */ parcelHelpers.export(exports, "useToastState", ()=>useToastState);
/**
 * Subscribes to a provided toast queue and provides methods to update it.
 */ parcelHelpers.export(exports, "useToastQueue", ()=>useToastQueue);
/**
 * A ToastQueue is a priority queue of toasts.
 */ parcelHelpers.export(exports, "ToastQueue", ()=>ToastQueue);
var _react = require("react");
// Shim to support React 17 and below.
var _indexJs = require("use-sync-external-store/shim/index.js");
function useToastState(props = {}) {
    let { maxVisibleToasts = 1, hasExitAnimation = false } = props;
    let queue = (0, _react.useMemo)(()=>new ToastQueue({
            maxVisibleToasts,
            hasExitAnimation
        }), [
        maxVisibleToasts,
        hasExitAnimation
    ]);
    return useToastQueue(queue);
}
function useToastQueue(queue) {
    let subscribe = (0, _react.useCallback)((fn)=>queue.subscribe(fn), [
        queue
    ]);
    let getSnapshot = (0, _react.useCallback)(()=>queue.visibleToasts, [
        queue
    ]);
    let visibleToasts = (0, _indexJs.useSyncExternalStore)(subscribe, getSnapshot, getSnapshot);
    return {
        visibleToasts,
        add: (content, options)=>queue.add(content, options),
        close: (key)=>queue.close(key),
        remove: (key)=>queue.remove(key),
        pauseAll: ()=>queue.pauseAll(),
        resumeAll: ()=>queue.resumeAll()
    };
}
class ToastQueue {
    /** Subscribes to updates to the visible toasts. */ subscribe(fn) {
        this.subscriptions.add(fn);
        return ()=>this.subscriptions.delete(fn);
    }
    /** Adds a new toast to the queue. */ add(content, options = {}) {
        let toastKey = Math.random().toString(36);
        let toast = {
            ...options,
            content,
            key: toastKey,
            timer: options.timeout ? new Timer(()=>this.close(toastKey), options.timeout) : null
        };
        let low = 0;
        let high = this.queue.length;
        while(low < high){
            let mid = Math.floor((low + high) / 2);
            if ((toast.priority || 0) > (this.queue[mid].priority || 0)) high = mid;
            else low = mid + 1;
        }
        this.queue.splice(low, 0, toast);
        toast.animation = low < this.maxVisibleToasts ? "entering" : "queued";
        let i = this.maxVisibleToasts;
        while(i < this.queue.length)this.queue[i++].animation = "queued";
        this.updateVisibleToasts();
        return toastKey;
    }
    /**
   * Closes a toast. If `hasExitAnimation` is true, the toast
   * transitions to an "exiting" state instead of being removed immediately.
   */ close(key) {
        let index = this.queue.findIndex((t)=>t.key === key);
        if (index >= 0) {
            var _this_queue_index_onClose, _this_queue_index;
            (_this_queue_index_onClose = (_this_queue_index = this.queue[index]).onClose) === null || _this_queue_index_onClose === void 0 ? void 0 : _this_queue_index_onClose.call(_this_queue_index);
            this.queue.splice(index, 1);
        }
        this.updateVisibleToasts();
    }
    /** Removes a toast from the visible toasts after an exiting animation. */ remove(key) {
        this.visibleToasts = this.visibleToasts.filter((t)=>t.key !== key);
        this.updateVisibleToasts();
    }
    updateVisibleToasts() {
        let toasts = this.queue.slice(0, this.maxVisibleToasts);
        if (this.hasExitAnimation) {
            let prevToasts = this.visibleToasts.filter((t)=>!toasts.some((t2)=>t.key === t2.key)).map((t)=>({
                    ...t,
                    animation: "exiting"
                }));
            this.visibleToasts = prevToasts.concat(toasts).sort((a, b)=>b.priority - a.priority);
        } else this.visibleToasts = toasts;
        for (let fn of this.subscriptions)fn();
    }
    /** Pauses the timers for all visible toasts. */ pauseAll() {
        for (let toast of this.visibleToasts)if (toast.timer) toast.timer.pause();
    }
    /** Resumes the timers for all visible toasts. */ resumeAll() {
        for (let toast of this.visibleToasts)if (toast.timer) toast.timer.resume();
    }
    constructor(options){
        this.queue = [];
        this.subscriptions = new Set();
        /** The currently visible toasts. */ this.visibleToasts = [];
        var _options_maxVisibleToasts;
        this.maxVisibleToasts = (_options_maxVisibleToasts = options === null || options === void 0 ? void 0 : options.maxVisibleToasts) !== null && _options_maxVisibleToasts !== void 0 ? _options_maxVisibleToasts : 1;
        var _options_hasExitAnimation;
        this.hasExitAnimation = (_options_hasExitAnimation = options === null || options === void 0 ? void 0 : options.hasExitAnimation) !== null && _options_hasExitAnimation !== void 0 ? _options_hasExitAnimation : false;
    }
}
class Timer {
    reset(delay) {
        this.remaining = delay;
        this.resume();
    }
    pause() {
        if (this.timerId == null) return;
        clearTimeout(this.timerId);
        this.timerId = null;
        this.remaining -= Date.now() - this.startTime;
    }
    resume() {
        if (this.remaining <= 0) return;
        this.startTime = Date.now();
        this.timerId = setTimeout(()=>{
            this.timerId = null;
            this.remaining = 0;
            this.callback();
        }, this.remaining);
    }
    constructor(callback, delay){
        this.remaining = delay;
        this.callback = callback;
    }
}

},{"react":"9yzVZ","use-sync-external-store/shim/index.js":"41GFF","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"l9hgR":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useToast", ()=>(0, _useToast.useToast));
parcelHelpers.export(exports, "useToastRegion", ()=>(0, _useToastRegion.useToastRegion));
var _useToast = require("./useToast");
var _useToastRegion = require("./useToastRegion");

},{"./useToast":"i6J2n","./useToastRegion":"d20UQ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"i6J2n":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides the behavior and accessibility implementation for a toast component.
 * Toasts display brief, temporary notifications of actions, errors, or other events in an application.
 */ parcelHelpers.export(exports, "useToast", ()=>useToast);
// @ts-ignore
var _json = require("../intl/*.json");
var _jsonDefault = parcelHelpers.interopDefault(_json);
var _react = require("react");
var _utils = require("@react-aria/utils");
var _i18N = require("@react-aria/i18n");
function useToast(props, state, ref) {
    let { key, timer, timeout, animation } = props.toast;
    (0, _react.useEffect)(()=>{
        if (!timer) return;
        timer.reset(timeout);
        return ()=>{
            timer.pause();
        };
    }, [
        timer,
        timeout
    ]);
    // Restore focus to the toast container on unmount.
    // If there are no more toasts, the container will be unmounted
    // and will restore focus to wherever focus was before the user
    // focused the toast region.
    let focusOnUnmount = (0, _react.useRef)(null);
    (0, _utils.useLayoutEffect)(()=>{
        let container = ref.current.closest("[role=region]");
        return ()=>{
            if (container && container.contains(document.activeElement)) // Focus must be delayed for focus ring to appear, but we can't wait
            // until useEffect cleanup to check if focus was inside the container.
            focusOnUnmount.current = container;
        };
    }, [
        ref
    ]);
    // eslint-disable-next-line
    (0, _react.useEffect)(()=>{
        return ()=>{
            if (focusOnUnmount.current) focusOnUnmount.current.focus();
        };
    }, [
        ref
    ]);
    let titleId = (0, _utils.useId)();
    let descriptionId = (0, _utils.useSlotId)();
    let stringFormatter = (0, _i18N.useLocalizedStringFormatter)((0, _jsonDefault.default), "@react-aria/toast");
    return {
        toastProps: {
            role: "alert",
            "aria-label": props["aria-label"],
            "aria-labelledby": props["aria-labelledby"] || titleId,
            "aria-describedby": props["aria-describedby"] || descriptionId,
            "aria-details": props["aria-details"],
            // Hide toasts that are animating out so VoiceOver doesn't announce them.
            "aria-hidden": animation === "exiting" ? "true" : undefined
        },
        titleProps: {
            id: titleId
        },
        descriptionProps: {
            id: descriptionId
        },
        closeButtonProps: {
            "aria-label": stringFormatter.format("close"),
            onPress: ()=>state.close(key)
        }
    };
}

},{"../intl/*.json":"8GoCL","react":"9yzVZ","@react-aria/utils":"9cLk5","@react-aria/i18n":"411rg","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"8GoCL":[function(require,module,exports) {
const _temp0 = require("a235226c8b0aa43f");
const _temp1 = require("fddd1fffd90138dc");
const _temp2 = require("4db25eb52b246676");
const _temp3 = require("8d4d96346d9a5df9");
const _temp4 = require("289d5835e3af1404");
const _temp5 = require("70f1daa5fd8409d6");
const _temp6 = require("7f4cffe4226e276c");
const _temp7 = require("e8b4ceff72672e8e");
const _temp8 = require("4efe71ce14603aee");
const _temp9 = require("fd35f814f0be145a");
const _temp10 = require("cd8f4f09f1becfac");
const _temp11 = require("39b37b04c6542844");
const _temp12 = require("2ead5c920f1cd0b1");
const _temp13 = require("c8eb7ed8cc71c6d3");
const _temp14 = require("c377d9a4790c23a4");
const _temp15 = require("280c14ce7f49927d");
const _temp16 = require("6baff32cda8c5e40");
const _temp17 = require("88218782d00e6662");
const _temp18 = require("2b9dc5243594df37");
const _temp19 = require("7177d5b4693fd394");
const _temp20 = require("2e862ab8860fa971");
const _temp21 = require("6b238e4dafdf4da7");
const _temp22 = require("a433daa12d943c12");
const _temp23 = require("a66c21477afabba0");
const _temp24 = require("8405e5b3353044db");
const _temp25 = require("dc5e8960d06e5e77");
const _temp26 = require("653494489899e692");
const _temp27 = require("290e1881314038e9");
const _temp28 = require("235aceeac94bc2c8");
const _temp29 = require("a2bd7a6f4a775b90");
const _temp30 = require("24f26bc2763b0ac5");
const _temp31 = require("b6e6aa64ef3ea06a");
const _temp32 = require("98b0b28b076dfc5b");
const _temp33 = require("1ef8938ba38447e9");
module.exports = {
    "ar-AE": _temp0,
    "bg-BG": _temp1,
    "cs-CZ": _temp2,
    "da-DK": _temp3,
    "de-DE": _temp4,
    "el-GR": _temp5,
    "en-US": _temp6,
    "es-ES": _temp7,
    "et-EE": _temp8,
    "fi-FI": _temp9,
    "fr-FR": _temp10,
    "he-IL": _temp11,
    "hr-HR": _temp12,
    "hu-HU": _temp13,
    "it-IT": _temp14,
    "ja-JP": _temp15,
    "ko-KR": _temp16,
    "lt-LT": _temp17,
    "lv-LV": _temp18,
    "nb-NO": _temp19,
    "nl-NL": _temp20,
    "pl-PL": _temp21,
    "pt-BR": _temp22,
    "pt-PT": _temp23,
    "ro-RO": _temp24,
    "ru-RU": _temp25,
    "sk-SK": _temp26,
    "sl-SI": _temp27,
    "sr-SP": _temp28,
    "sv-SE": _temp29,
    "tr-TR": _temp30,
    "uk-UA": _temp31,
    "zh-CN": _temp32,
    "zh-TW": _temp33
};

},{"a235226c8b0aa43f":"9VkJW","fddd1fffd90138dc":"97UBs","4db25eb52b246676":"9zoX3","8d4d96346d9a5df9":"iglUj","289d5835e3af1404":"w4w6i","70f1daa5fd8409d6":"3HQwU","7f4cffe4226e276c":"1QUyQ","e8b4ceff72672e8e":"fRDwt","4efe71ce14603aee":"63eQb","fd35f814f0be145a":"7KZkA","cd8f4f09f1becfac":"h7jem","39b37b04c6542844":"ilgKP","2ead5c920f1cd0b1":"jb49V","c8eb7ed8cc71c6d3":"fZGQl","c377d9a4790c23a4":"hPtDl","280c14ce7f49927d":"icneG","6baff32cda8c5e40":"hGKaB","88218782d00e6662":"dTSgI","2b9dc5243594df37":"f3Vwk","7177d5b4693fd394":"ax6Qx","2e862ab8860fa971":"4ixHU","6b238e4dafdf4da7":"eYJZw","a433daa12d943c12":"aui3K","a66c21477afabba0":"dlyP5","8405e5b3353044db":"kbFS9","dc5e8960d06e5e77":"9fNlF","653494489899e692":"fZypi","290e1881314038e9":"il4yw","235aceeac94bc2c8":"5aNo7","a2bd7a6f4a775b90":"8veDa","24f26bc2763b0ac5":"4bJMy","b6e6aa64ef3ea06a":"2Rg6A","98b0b28b076dfc5b":"edgBZ","1ef8938ba38447e9":"94fWZ"}],"9VkJW":[function(require,module,exports) {
module.exports = {
    "close": `\u{625}\u{63A}\u{644}\u{627}\u{642}`,
    "notifications": `\u{625}\u{634}\u{639}\u{627}\u{631}\u{627}\u{62A}`
};

},{}],"97UBs":[function(require,module,exports) {
module.exports = {
    "close": `\u{417}\u{430}\u{442}\u{432}\u{43E}\u{440}\u{438}`,
    "notifications": `\u{418}\u{437}\u{432}\u{435}\u{441}\u{442}\u{438}\u{44F}`
};

},{}],"9zoX3":[function(require,module,exports) {
module.exports = {
    "close": `Zav\u{159}\xedt`,
    "notifications": `Upozorn\u{11B}n\xed`
};

},{}],"iglUj":[function(require,module,exports) {
module.exports = {
    "close": `Luk`,
    "notifications": `P\xe5mindelser`
};

},{}],"w4w6i":[function(require,module,exports) {
module.exports = {
    "close": `Schlie\xdfen`,
    "notifications": `Benachrichtigungen`
};

},{}],"3HQwU":[function(require,module,exports) {
module.exports = {
    "close": `\u{39A}\u{3BB}\u{3B5}\u{3AF}\u{3C3}\u{3B9}\u{3BC}\u{3BF}`,
    "notifications": `\u{395}\u{3B9}\u{3B4}\u{3BF}\u{3C0}\u{3BF}\u{3B9}\u{3AE}\u{3C3}\u{3B5}\u{3B9}\u{3C2}`
};

},{}],"1QUyQ":[function(require,module,exports) {
module.exports = {
    "close": `Close`,
    "notifications": `Notifications`
};

},{}],"fRDwt":[function(require,module,exports) {
module.exports = {
    "close": `Cerrar`,
    "notifications": `Notificaciones`
};

},{}],"63eQb":[function(require,module,exports) {
module.exports = {
    "close": `Sule`,
    "notifications": `Teated`
};

},{}],"7KZkA":[function(require,module,exports) {
module.exports = {
    "close": `Sulje`,
    "notifications": `Ilmoitukset`
};

},{}],"h7jem":[function(require,module,exports) {
module.exports = {
    "close": `Fermer`,
    "notifications": `Notifications`
};

},{}],"ilgKP":[function(require,module,exports) {
module.exports = {
    "close": `\u{5E1}\u{5D2}\u{5D5}\u{5E8}`,
    "notifications": `\u{5D4}\u{5EA}\u{5E8}\u{5D0}\u{5D5}\u{5EA}`
};

},{}],"jb49V":[function(require,module,exports) {
module.exports = {
    "close": `Zatvori`,
    "notifications": `Obavijesti`
};

},{}],"fZGQl":[function(require,module,exports) {
module.exports = {
    "close": `Bez\xe1r\xe1s`,
    "notifications": `\xc9rtes\xedt\xe9sek`
};

},{}],"hPtDl":[function(require,module,exports) {
module.exports = {
    "close": `Chiudi`,
    "notifications": `Notifiche`
};

},{}],"icneG":[function(require,module,exports) {
module.exports = {
    "close": `\u{9589}\u{3058}\u{308B}`,
    "notifications": `\u{901A}\u{77E5}`
};

},{}],"hGKaB":[function(require,module,exports) {
module.exports = {
    "close": `\u{B2EB}\u{AE30}`,
    "notifications": `\u{C54C}\u{B9BC}`
};

},{}],"dTSgI":[function(require,module,exports) {
module.exports = {
    "close": `U\u{17E}daryti`,
    "notifications": `Prane\u{161}imai`
};

},{}],"f3Vwk":[function(require,module,exports) {
module.exports = {
    "close": `Aizv\u{113}rt`,
    "notifications": `Pazi\u{146}ojumi`
};

},{}],"ax6Qx":[function(require,module,exports) {
module.exports = {
    "close": `Lukk`,
    "notifications": `Varsler`
};

},{}],"4ixHU":[function(require,module,exports) {
module.exports = {
    "close": `Sluiten`,
    "notifications": `Meldingen`
};

},{}],"eYJZw":[function(require,module,exports) {
module.exports = {
    "close": `Zamknij`,
    "notifications": `Powiadomienia`
};

},{}],"aui3K":[function(require,module,exports) {
module.exports = {
    "close": `Fechar`,
    "notifications": `Notifica\xe7\xf5es`
};

},{}],"dlyP5":[function(require,module,exports) {
module.exports = {
    "close": `Fechar`,
    "notifications": `Notifica\xe7\xf5es`
};

},{}],"kbFS9":[function(require,module,exports) {
module.exports = {
    "close": `\xcenchide\u{163}i`,
    "notifications": `Notific\u{103}ri`
};

},{}],"9fNlF":[function(require,module,exports) {
module.exports = {
    "close": `\u{417}\u{430}\u{43A}\u{440}\u{44B}\u{442}\u{44C}`,
    "notifications": `\u{423}\u{432}\u{435}\u{434}\u{43E}\u{43C}\u{43B}\u{435}\u{43D}\u{438}\u{44F}`
};

},{}],"fZypi":[function(require,module,exports) {
module.exports = {
    "close": `Zatvori\u{165}`,
    "notifications": `Ozn\xe1menia`
};

},{}],"il4yw":[function(require,module,exports) {
module.exports = {
    "close": `Zapri`,
    "notifications": `Obvestila`
};

},{}],"5aNo7":[function(require,module,exports) {
module.exports = {
    "close": `Zatvori`,
    "notifications": `Obave\u{161}tenja`
};

},{}],"8veDa":[function(require,module,exports) {
module.exports = {
    "close": `St\xe4ng`,
    "notifications": `Aviseringar`
};

},{}],"4bJMy":[function(require,module,exports) {
module.exports = {
    "close": `Kapat`,
    "notifications": `Bildirimler`
};

},{}],"2Rg6A":[function(require,module,exports) {
module.exports = {
    "close": `\u{417}\u{430}\u{43A}\u{440}\u{438}\u{442}\u{438}`,
    "notifications": `\u{421}\u{43F}\u{43E}\u{432}\u{456}\u{449}\u{435}\u{43D}\u{43D}\u{44F}`
};

},{}],"edgBZ":[function(require,module,exports) {
module.exports = {
    "close": `\u{5173}\u{95ED}`,
    "notifications": `\u{901A}\u{77E5}`
};

},{}],"94fWZ":[function(require,module,exports) {
module.exports = {
    "close": `\u{95DC}\u{9589}`,
    "notifications": `\u{901A}\u{77E5}`
};

},{}],"d20UQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides the behavior and accessibility implementation for a toast region containing one or more toasts.
 * Toasts display brief, temporary notifications of actions, errors, or other events in an application.
 */ parcelHelpers.export(exports, "useToastRegion", ()=>useToastRegion);
var _utils = require("@react-aria/utils");
var _interactions = require("@react-aria/interactions");
// @ts-ignore
var _json = require("../intl/*.json");
var _jsonDefault = parcelHelpers.interopDefault(_json);
var _react = require("react");
var _landmark = require("@react-aria/landmark");
var _i18N = require("@react-aria/i18n");
function useToastRegion(props, state, ref) {
    let stringFormatter = (0, _i18N.useLocalizedStringFormatter)((0, _jsonDefault.default), "@react-aria/toast");
    let { landmarkProps } = (0, _landmark.useLandmark)({
        role: "region",
        "aria-label": props["aria-label"] || stringFormatter.format("notifications")
    }, ref);
    let { hoverProps } = (0, _interactions.useHover)({
        onHoverStart: state.pauseAll,
        onHoverEnd: state.resumeAll
    });
    let lastFocused = (0, _react.useRef)(null);
    let { focusWithinProps } = (0, _interactions.useFocusWithin)({
        onFocusWithin: (e)=>{
            state.pauseAll();
            lastFocused.current = e.relatedTarget;
        },
        onBlurWithin: ()=>{
            state.resumeAll();
            lastFocused.current = null;
        }
    });
    // When the region unmounts, restore focus to the last element that had focus
    // before the user moved focus into the region.
    // TODO: handle when the element has unmounted like FocusScope does?
    // eslint-disable-next-line arrow-body-style
    (0, _react.useEffect)(()=>{
        return ()=>{
            if (lastFocused.current && document.body.contains(lastFocused.current)) {
                if ((0, _interactions.getInteractionModality)() === "pointer") (0, _utils.focusWithoutScrolling)(lastFocused.current);
                else lastFocused.current.focus();
            }
        };
    }, [
        ref
    ]);
    return {
        regionProps: (0, _utils.mergeProps)(landmarkProps, hoverProps, focusWithinProps, {
            tabIndex: -1,
            // Mark the toast region as a "top layer", so that it:
            //   - is not aria-hidden when opening an overlay
            //   - allows focus even outside a containing focus scope
            //   - doesn’t dismiss overlays when clicking on it, even though it is outside
            // @ts-ignore
            "data-react-aria-top-layer": true
        })
    };
}

},{"@react-aria/utils":"9cLk5","@react-aria/interactions":"ky3G8","../intl/*.json":"8GoCL","react":"9yzVZ","@react-aria/landmark":"8X64T","@react-aria/i18n":"411rg","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"8lXQu":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Default", ()=>Default);
var _src = require("../src");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
exports.default = {
    title: "platform"
};
const Template = (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement("table", args, /*#__PURE__*/ (0, _reactDefault.default).createElement("tr", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("th", null, "Platform"), /*#__PURE__*/ (0, _reactDefault.default).createElement("th", null, "Current")), /*#__PURE__*/ (0, _reactDefault.default).createElement("tr", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("td", null, "isAndroid: "), /*#__PURE__*/ (0, _reactDefault.default).createElement("td", null, (0, _src.isAndroid)().toString())), /*#__PURE__*/ (0, _reactDefault.default).createElement("tr", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("td", null, "isAppleDevice: "), /*#__PURE__*/ (0, _reactDefault.default).createElement("td", null, (0, _src.isAppleDevice)().toString())), /*#__PURE__*/ (0, _reactDefault.default).createElement("tr", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("td", null, "isChrome: "), /*#__PURE__*/ (0, _reactDefault.default).createElement("td", null, (0, _src.isChrome)().toString())), /*#__PURE__*/ (0, _reactDefault.default).createElement("tr", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("td", null, "isIOS: "), /*#__PURE__*/ (0, _reactDefault.default).createElement("td", null, (0, _src.isIOS)().toString())), /*#__PURE__*/ (0, _reactDefault.default).createElement("tr", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("td", null, "isIPad: "), /*#__PURE__*/ (0, _reactDefault.default).createElement("td", null, (0, _src.isIPad)().toString())), /*#__PURE__*/ (0, _reactDefault.default).createElement("tr", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("td", null, "isIPhone: "), /*#__PURE__*/ (0, _reactDefault.default).createElement("td", null, (0, _src.isIPhone)().toString())), /*#__PURE__*/ (0, _reactDefault.default).createElement("tr", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("td", null, "isMac: "), /*#__PURE__*/ (0, _reactDefault.default).createElement("td", null, (0, _src.isMac)().toString())), /*#__PURE__*/ (0, _reactDefault.default).createElement("tr", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("td", null, "isWebKit: "), /*#__PURE__*/ (0, _reactDefault.default).createElement("td", null, (0, _src.isWebKit)().toString())));
const Default = {
    render: Template,
    name: "all platforms",
    args: {}
};

},{"../src":"9cLk5","react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"fZOgM":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "KeyboardNavigation", ()=>KeyboardNavigation);
var _collections = require("@react-stately/collections");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _interactions = require("@react-aria/interactions");
var _selection = require("@react-aria/selection");
var _ = require("../");
exports.default = {
    title: "useTreeState"
};
const KeyboardNavigation = ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement(TreeExample, null);
function TreeExample(props = {}) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Tree, props, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _collections.Item), {
        key: "1",
        title: "Animals"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _collections.Item), null, "Aardvark"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _collections.Item), {
        title: "Bear"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _collections.Item), null, "Black Bear"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _collections.Item), null, "Brown Bear")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _collections.Item), null, "Kangaroo"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _collections.Item), null, "Snake")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _collections.Item), {
        key: "2",
        title: "Fruits"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _collections.Item), null, "Apple"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _collections.Item), null, "Orange"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _collections.Item), {
        title: "Kiwi"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _collections.Item), null, "Golden Kiwi"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _collections.Item), null, "Fuzzy Kiwi"))));
}
function Tree(props) {
    let state = (0, _.useTreeState)(props);
    let ref = (0, _react.useRef)();
    let keyboardDelegate = (0, _react.useMemo)(()=>new TreeKeyboardDelegate(state.collection, state.disabledKeys), [
        state.collection,
        state.disabledKeys
    ]);
    let { collectionProps } = (0, _selection.useSelectableCollection)({
        keyboardDelegate,
        ref,
        selectionManager: state.selectionManager
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...collectionProps,
        ref: ref,
        role: "tree"
    }, TreeNodes({
        nodes: state.collection,
        state
    }));
}
function TreeNodes({ nodes, state }) {
    return Array.from(nodes).map((node)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(TreeItem, {
            node: node,
            key: node.key,
            state: state
        }));
}
function TreeItem({ node, state }) {
    let ref = (0, _react.useRef)();
    let { itemProps } = (0, _selection.useSelectableItem)({
        key: node.key,
        selectionManager: state.selectionManager,
        ref: ref
    });
    let { pressProps } = (0, _interactions.usePress)({
        ...itemProps,
        onPress: ()=>state.toggleKey(node.key)
    });
    let isExpanded = node.hasChildNodes && state.expandedKeys.has(node.key);
    let isSelected = state.selectionManager.isSelected(node.key);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...pressProps,
        "aria-expanded": node.hasChildNodes ? isExpanded : null,
        "aria-selected": isSelected,
        ref: ref,
        role: "treeitem"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: "title"
    }, node.rendered), isExpanded && /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: "children",
        role: "group"
    }, TreeNodes({
        nodes: node.childNodes,
        state
    })));
}
class TreeKeyboardDelegate {
    getKeyAbove(key) {
        let { collection, disabledKeys } = this;
        let keyBefore = collection.getKeyBefore(key);
        while(keyBefore !== null){
            let item = collection.getItem(keyBefore);
            if ((item === null || item === void 0 ? void 0 : item.type) === "item" && !disabledKeys.has(item.key)) return keyBefore;
            keyBefore = collection.getKeyBefore(keyBefore);
        }
        return null;
    }
    getKeyBelow(key) {
        let { collection, disabledKeys } = this;
        let keyBelow = collection.getKeyAfter(key);
        while(keyBelow !== null){
            let item = collection.getItem(keyBelow);
            if ((item === null || item === void 0 ? void 0 : item.type) === "item" && !disabledKeys.has(item.key)) return keyBelow;
            keyBelow = collection.getKeyAfter(keyBelow);
        }
        return null;
    }
    getFirstKey() {
        let { collection, disabledKeys } = this;
        let key = collection.getFirstKey();
        while(key !== null){
            let item = collection.getItem(key);
            if ((item === null || item === void 0 ? void 0 : item.type) === "item" && !disabledKeys.has(item.key)) return key;
            key = collection.getKeyAfter(key);
        }
        return null;
    }
    getLastKey() {
        let { collection, disabledKeys } = this;
        let key = collection.getLastKey();
        while(key !== null){
            let item = collection.getItem(key);
            if ((item === null || item === void 0 ? void 0 : item.type) === "item" && !disabledKeys.has(item.key)) return key;
            key = collection.getKeyBefore(key);
        }
        return null;
    }
    getKeyForSearch(search, fromKey = this.getFirstKey()) {
        let { collator, collection } = this;
        let key = fromKey;
        while(key !== null){
            let item = collection.getItem(key);
            if ((item === null || item === void 0 ? void 0 : item.textValue) && collator.compare(search, item.textValue.slice(0, search.length)) === 0) return key;
            key = this.getKeyBelow(key);
        }
        return null;
    }
    constructor(collection, disabledKeys){
        this.collator = new Intl.Collator("en");
        this.collection = collection;
        this.disabledKeys = disabledKeys;
    }
}

},{"@react-stately/collections":"loANi","react":"9yzVZ","@react-aria/interactions":"ky3G8","@react-aria/selection":"6Fly5","../":"9Z2rg","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"9Z2rg":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _src = require("./src");
parcelHelpers.exportAll(_src, exports);

},{"./src":"f1QlQ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"51hPp":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Default", ()=>Default);
parcelHelpers.export(exports, "DefaultExpandedKeys", ()=>DefaultExpandedKeys);
parcelHelpers.export(exports, "DisabledKeys", ()=>DisabledKeys);
parcelHelpers.export(exports, "DisabledDefaultExpandedKeys", ()=>DisabledDefaultExpandedKeys);
parcelHelpers.export(exports, "ControlledExpandedKeys", ()=>ControlledExpandedKeys);
var _src = require("../src");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
exports.default = {
    title: "Accordion",
    component: (0, _src.Accordion),
    argTypes: {}
};
const Default = {
    args: {
        items: [
            {
                key: "files",
                title: "Your files"
            },
            {
                key: "shared",
                title: "Shared with you"
            },
            {
                key: "last",
                title: "Last item"
            }
        ]
    },
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _src.Accordion), args, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _src.Item), {
                key: item.key,
                title: item.title
            }, item.key))
};
const DefaultExpandedKeys = {
    args: {
        ...Default.args,
        defaultExpandedKeys: [
            "files"
        ]
    },
    render: Default.render,
    name: "defaultExpandedKeys: files"
};
const DisabledKeys = {
    args: {
        ...Default.args,
        disabledKeys: [
            "files",
            "shared"
        ]
    },
    render: Default.render,
    name: "disabledKeys: files, shared"
};
const DisabledDefaultExpandedKeys = {
    args: {
        ...Default.args,
        defaultExpandedKeys: [
            "files"
        ],
        disabledKeys: [
            "files",
            "shared"
        ]
    },
    render: Default.render,
    name: "defaultExpandedKeys: files, disabledKeys: files, shared"
};
const ControlledExpandedKeys = {
    args: {
        ...Default.args,
        defaultExpandedKeys: [
            "files"
        ]
    },
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(ControlledAccordion, args),
    name: "controlled ExpandedKeys"
};
function ControlledAccordion(props) {
    let [openKeys, setOpenKeys] = (0, _react.useState)(new Set([
        "files"
    ]));
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _src.Accordion), {
        ...props,
        expandedKeys: openKeys,
        onExpandedChange: setOpenKeys
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _src.Item), {
        key: "files",
        title: "Your files"
    }, "files"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _src.Item), {
        key: "shared",
        title: "Shared with you"
    }, "shared"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _src.Item), {
        key: "last",
        title: "Last item"
    }, "last"));
}

},{"../src":"1KBoU","react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"1KBoU":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /// <reference types="css-module-types" />
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Accordion", ()=>(0, _accordion.Accordion));
parcelHelpers.export(exports, "Item", ()=>(0, _collections.Item));
var _accordion = require("./Accordion");
var _collections = require("@react-stately/collections");

},{"./Accordion":"iMScL","@react-stately/collections":"loANi","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"iMScL":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Accordion", ()=>_Accordion);
var _chevronLeftMedium = require("@spectrum-icons/ui/ChevronLeftMedium");
var _chevronLeftMediumDefault = parcelHelpers.interopDefault(_chevronLeftMedium);
var _chevronRightMedium = require("@spectrum-icons/ui/ChevronRightMedium");
var _chevronRightMediumDefault = parcelHelpers.interopDefault(_chevronRightMedium);
var _utils = require("@react-spectrum/utils");
var _utils1 = require("@react-aria/utils");
var _focus = require("@react-aria/focus");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _varsCss = require("@adobe/spectrum-css-temp/components/accordion/vars.css");
var _varsCssDefault = parcelHelpers.interopDefault(_varsCss);
var _tree = require("@react-stately/tree");
var _accordion = require("@react-aria/accordion");
var _interactions = require("@react-aria/interactions");
var _i18N = require("@react-aria/i18n");
var _provider = require("@react-spectrum/provider");
function Accordion(props, ref) {
    props = (0, _provider.useProviderProps)(props);
    let state = (0, _tree.useTreeState)(props);
    let { styleProps } = (0, _utils.useStyleProps)(props);
    let domRef = (0, _utils.useDOMRef)(ref);
    let { accordionProps } = (0, _accordion.useAccordion)(props, state, domRef);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...(0, _utils1.filterDOMProps)(props),
        ...accordionProps,
        ...styleProps,
        ref: domRef,
        className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Accordion", styleProps.className)
    }, [
        ...state.collection
    ].map((item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(AccordionItem, {
            key: item.key,
            item: item,
            state: state
        })));
}
function AccordionItem(props) {
    props = (0, _provider.useProviderProps)(props);
    let ref = (0, _react.useRef)(null);
    let { state, item } = props;
    let { buttonProps, regionProps } = (0, _accordion.useAccordionItem)(props, state, ref);
    let isOpen = state.expandedKeys.has(item.key);
    let isDisabled = state.disabledKeys.has(item.key);
    let { isHovered, hoverProps } = (0, _interactions.useHover)({
        isDisabled
    });
    let { direction } = (0, _i18N.useLocale)();
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Accordion-item", {
            "is-open": isOpen,
            "is-disabled": isDisabled
        })
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("h3", {
        className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Accordion-itemHeading")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _focus.FocusRing), {
        within: true,
        focusRingClass: (0, _utils.classNames)((0, _varsCssDefault.default), "focus-ring")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("button", {
        ...(0, _utils1.mergeProps)(buttonProps, hoverProps),
        ref: ref,
        className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Accordion-itemHeader", {
            "is-hovered": isHovered
        })
    }, direction === "ltr" ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _chevronRightMediumDefault.default), {
        "aria-hidden": "true",
        UNSAFE_className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Accordion-itemIndicator")
    }) : /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _chevronLeftMediumDefault.default), {
        "aria-hidden": "true",
        UNSAFE_className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Accordion-itemIndicator")
    }), item.props.title))), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...regionProps,
        className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Accordion-itemContent")
    }, item.props.children));
}
const _Accordion = /*#__PURE__*/ (0, _react.forwardRef)(Accordion);

},{"@spectrum-icons/ui/ChevronLeftMedium":"eZUPs","@spectrum-icons/ui/ChevronRightMedium":"6amCu","@react-spectrum/utils":"cMIJ6","@react-aria/utils":"9cLk5","@react-aria/focus":"42mbF","react":"9yzVZ","@adobe/spectrum-css-temp/components/accordion/vars.css":"2ZlF0","@react-stately/tree":"f1QlQ","@react-aria/accordion":"5VAyN","@react-aria/interactions":"ky3G8","@react-aria/i18n":"411rg","@react-spectrum/provider":"5bCdp","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"2ZlF0":[function(require,module,exports) {
module.exports["focus-ring"] = `_7gO6Sq_focus-ring`;
module.exports["is-disabled"] = `_7gO6Sq_is-disabled`;
module.exports["is-hovered"] = `_7gO6Sq_is-hovered`;
module.exports["is-open"] = `_7gO6Sq_is-open`;
module.exports["spectrum-Accordion"] = `_7gO6Sq_spectrum-Accordion`;
module.exports["spectrum-Accordion-item"] = `_7gO6Sq_spectrum-Accordion-item`;
module.exports["spectrum-Accordion-itemContent"] = `_7gO6Sq_spectrum-Accordion-itemContent`;
module.exports["spectrum-Accordion-itemHeader"] = `_7gO6Sq_spectrum-Accordion-itemHeader`;
module.exports["spectrum-Accordion-itemHeading"] = `_7gO6Sq_spectrum-Accordion-itemHeading`;
module.exports["spectrum-Accordion-itemIndicator"] = `_7gO6Sq_spectrum-Accordion-itemIndicator`;

},{}],"5VAyN":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 * 
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useAccordionItem", ()=>(0, _useAccordion.useAccordionItem));
parcelHelpers.export(exports, "useAccordion", ()=>(0, _useAccordion.useAccordion));
var _useAccordion = require("./useAccordion");

},{"./useAccordion":"7xEOI","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"7xEOI":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an 'AS IS' BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useAccordionItem", ()=>useAccordionItem);
parcelHelpers.export(exports, "useAccordion", ()=>useAccordion);
var _utils = require("@react-aria/utils");
var _button = require("@react-aria/button");
var _selection = require("@react-aria/selection");
function useAccordionItem(props, state, ref) {
    let { item } = props;
    let buttonId = (0, _utils.useId)();
    let regionId = (0, _utils.useId)();
    let isDisabled = state.disabledKeys.has(item.key);
    let { itemProps } = (0, _selection.useSelectableItem)({
        selectionManager: state.selectionManager,
        key: item.key,
        ref
    });
    let { buttonProps } = (0, _button.useButton)((0, _utils.mergeProps)(itemProps, {
        id: buttonId,
        elementType: "button",
        isDisabled,
        onPress: ()=>state.toggleKey(item.key)
    }), ref);
    let isExpanded = state.expandedKeys.has(item.key);
    return {
        buttonProps: {
            ...buttonProps,
            "aria-expanded": isExpanded,
            "aria-controls": isExpanded ? regionId : undefined
        },
        regionProps: {
            id: regionId,
            role: "region",
            "aria-labelledby": buttonId
        }
    };
}
function useAccordion(props, state, ref) {
    let { listProps } = (0, _selection.useSelectableList)({
        ...props,
        ...state,
        allowsTabNavigation: true,
        ref
    });
    return {
        accordionProps: {
            ...listProps,
            tabIndex: undefined
        }
    };
}

},{"@react-aria/utils":"9cLk5","@react-aria/button":"fsdLZ","@react-aria/selection":"6Fly5","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"mgIfK":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Default", ()=>Default);
parcelHelpers.export(exports, "FullWidthStory", ()=>FullWidthStory);
var _addonActions = require("@storybook/addon-actions");
var _src = require("../src");
var _example = require("./Example");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _utils = require("@react-aria/utils");
exports.default = {
    title: "ActionBar",
    component: (0, _src.ActionBar),
    args: {
        onAction: (0, _addonActions.action)("onAction")
    },
    argTypes: {
        onAction: {
            table: {
                disable: true
            }
        },
        isEmphasized: {
            control: "boolean"
        }
    }
};
const Default = {
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _example.Example), args),
    parameters: {
        a11y: {
            config: {
                // Fails due to TableView's known issue, ignoring here since it isn't pertinent to the story
                rules: [
                    {
                        id: "aria-required-children",
                        selector: '*:not([role="grid"])'
                    }
                ]
            }
        }
    }
};
const FullWidthStory = {
    ...Default,
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(FullWidth, args)
};
function FullWidth(props) {
    let viewport = (0, _utils.useViewportSize)();
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _example.Example), {
        tableWidth: "100vw",
        containerHeight: viewport.height,
        isQuiet: true,
        ...props
    });
}

},{"@storybook/addon-actions":"coXbW","../src":"3NgxP","./Example":"6YR74","react":"9yzVZ","@react-aria/utils":"9cLk5","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"3NgxP":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /// <reference types="css-module-types" />
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ActionBar", ()=>(0, _actionBar.ActionBar));
parcelHelpers.export(exports, "ActionBarContainer", ()=>(0, _actionBarContainer.ActionBarContainer));
parcelHelpers.export(exports, "Item", ()=>(0, _collections.Item));
var _actionBar = require("./ActionBar");
var _actionBarContainer = require("./ActionBarContainer");
var _collections = require("@react-stately/collections");

},{"./ActionBar":"40B11","./ActionBarContainer":"bhK18","@react-stately/collections":"loANi","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"40B11":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ActionBar", ()=>_ActionBar);
var _button = require("@react-spectrum/button");
var _actiongroup = require("@react-spectrum/actiongroup");
var _liveAnnouncer = require("@react-aria/live-announcer");
var _utils = require("@react-spectrum/utils");
var _crossLarge = require("@spectrum-icons/ui/CrossLarge");
var _crossLargeDefault = parcelHelpers.interopDefault(_crossLarge);
var _utils1 = require("@react-aria/utils");
var _focus = require("@react-aria/focus");
// @ts-ignore
var _json = require("../intl/*.json");
var _jsonDefault = parcelHelpers.interopDefault(_json);
var _overlays = require("@react-spectrum/overlays");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _actionbarCss = require("./actionbar.css");
var _actionbarCssDefault = parcelHelpers.interopDefault(_actionbarCss);
var _text = require("@react-spectrum/text");
var _interactions = require("@react-aria/interactions");
var _i18N = require("@react-aria/i18n");
var _provider = require("@react-spectrum/provider");
function ActionBar(props, ref) {
    let isOpen = props.selectedItemCount !== 0;
    let domRef = (0, _utils.useDOMRef)(ref);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _overlays.OpenTransition), {
        nodeRef: domRef,
        in: isOpen,
        mountOnEnter: true,
        unmountOnExit: true
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(ActionBarInnerWithRef, {
        ...props,
        ref: domRef
    }));
}
function ActionBarInner(props, ref) {
    props = (0, _provider.useProviderProps)(props);
    let { children, isEmphasized, onAction, onClearSelection, selectedItemCount, isOpen, items } = props;
    let { styleProps } = (0, _utils.useStyleProps)(props);
    let stringFormatter = (0, _i18N.useLocalizedStringFormatter)((0, _jsonDefault.default), "@react-spectrum/actionbar");
    // Store the last count greater than zero in a ref so that we can retain it while rendering the fade-out animation.
    let [lastCount, setLastCount] = (0, _react.useState)(selectedItemCount);
    if ((selectedItemCount === "all" || selectedItemCount > 0) && selectedItemCount !== lastCount) setLastCount(selectedItemCount);
    let { keyboardProps } = (0, _interactions.useKeyboard)({
        onKeyDown (e) {
            if (e.key === "Escape") {
                e.preventDefault();
                onClearSelection();
            }
        }
    });
    // Announce "actions available" on mount.
    let isInitial = (0, _react.useRef)(true);
    (0, _react.useEffect)(()=>{
        if (isInitial.current) {
            isInitial.current = false;
            (0, _liveAnnouncer.announce)(stringFormatter.format("actionsAvailable"));
        }
    }, [
        stringFormatter
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _focus.FocusScope), {
        restoreFocus: true
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...(0, _utils1.filterDOMProps)(props),
        ...styleProps,
        ...keyboardProps,
        ref: ref,
        className: (0, _utils.classNames)((0, _actionbarCssDefault.default), "react-spectrum-ActionBar", {
            "react-spectrum-ActionBar--emphasized": isEmphasized,
            "is-open": isOpen
        }, styleProps.className)
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _utils.classNames)((0, _actionbarCssDefault.default), "react-spectrum-ActionBar-bar")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _actiongroup.ActionGroup), {
        items: items,
        "aria-label": stringFormatter.format("actions"),
        isQuiet: true,
        staticColor: isEmphasized ? "white" : undefined,
        overflowMode: "collapse",
        buttonLabelBehavior: "collapse",
        onAction: onAction,
        UNSAFE_className: (0, _utils.classNames)((0, _actionbarCssDefault.default), "react-spectrum-ActionBar-actionGroup")
    }, children), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), {
        gridArea: (0, _actionbarCssDefault.default).clear,
        "aria-label": stringFormatter.format("clearSelection"),
        onPress: ()=>onClearSelection(),
        isQuiet: true,
        staticColor: isEmphasized ? "white" : undefined
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _crossLargeDefault.default), null)), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), {
        UNSAFE_className: (0, _utils.classNames)((0, _actionbarCssDefault.default), "react-spectrum-ActionBar-selectedCount")
    }, lastCount === "all" ? stringFormatter.format("selectedAll") : stringFormatter.format("selected", {
        count: lastCount
    })))));
}
const ActionBarInnerWithRef = /*#__PURE__*/ (0, _reactDefault.default).forwardRef(ActionBarInner);
/**
 * Action bars are used for single and bulk selection patterns when a user needs to perform actions on one or more items at the same time.
 */ const _ActionBar = /*#__PURE__*/ (0, _reactDefault.default).forwardRef(ActionBar);

},{"@react-spectrum/button":"jZWyP","@react-spectrum/actiongroup":"hkqBV","@react-aria/live-announcer":"ipdGY","@react-spectrum/utils":"cMIJ6","@spectrum-icons/ui/CrossLarge":"3emYD","@react-aria/utils":"9cLk5","@react-aria/focus":"42mbF","../intl/*.json":"6dyZn","@react-spectrum/overlays":"3nwGn","react":"9yzVZ","./actionbar.css":"j2ol3","@react-spectrum/text":"etCGI","@react-aria/interactions":"ky3G8","@react-aria/i18n":"411rg","@react-spectrum/provider":"5bCdp","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"6dyZn":[function(require,module,exports) {
const _temp0 = require("f57c0379d81d3348");
const _temp1 = require("e6d9338213965c05");
const _temp2 = require("a1126c3108da33ff");
const _temp3 = require("6099216088f9530f");
const _temp4 = require("611833a72604cd3d");
const _temp5 = require("3682979199cf9015");
const _temp6 = require("44da0f7100ad07cf");
const _temp7 = require("5fd25423561599d8");
const _temp8 = require("5d88e659b3d46554");
const _temp9 = require("7b89eabad3afeffd");
const _temp10 = require("ceec0818af7bc476");
const _temp11 = require("b26828d28f8cf319");
const _temp12 = require("5d8c31d3895d682b");
const _temp13 = require("7815a00b63df3a4d");
const _temp14 = require("4ef39fbc0cafb03c");
const _temp15 = require("6517b5c2d01068e1");
const _temp16 = require("67148f4945fdf35c");
const _temp17 = require("54331121849b7f7");
const _temp18 = require("50fd6eda0ad475c9");
const _temp19 = require("297c6a75003d232c");
const _temp20 = require("e3a2b69b39e71dd7");
const _temp21 = require("2393d7170abeda89");
const _temp22 = require("31d5c93148c822f5");
const _temp23 = require("169d73d234813e3d");
const _temp24 = require("b94eea66e61400a9");
const _temp25 = require("b8994a839790862b");
const _temp26 = require("b80190ff96780502");
const _temp27 = require("4820e09868afaa79");
const _temp28 = require("beab3b64a7e8ad0b");
const _temp29 = require("32dcfa47cf9e69e9");
const _temp30 = require("201871c5749a8bae");
const _temp31 = require("b17bc2de61a6ad4e");
const _temp32 = require("9ddaccff6482c7d0");
const _temp33 = require("2a3eeb373e42cc3f");
module.exports = {
    "ar-AE": _temp0,
    "bg-BG": _temp1,
    "cs-CZ": _temp2,
    "da-DK": _temp3,
    "de-DE": _temp4,
    "el-GR": _temp5,
    "en-US": _temp6,
    "es-ES": _temp7,
    "et-EE": _temp8,
    "fi-FI": _temp9,
    "fr-FR": _temp10,
    "he-IL": _temp11,
    "hr-HR": _temp12,
    "hu-HU": _temp13,
    "it-IT": _temp14,
    "ja-JP": _temp15,
    "ko-KR": _temp16,
    "lt-LT": _temp17,
    "lv-LV": _temp18,
    "nb-NO": _temp19,
    "nl-NL": _temp20,
    "pl-PL": _temp21,
    "pt-BR": _temp22,
    "pt-PT": _temp23,
    "ro-RO": _temp24,
    "ru-RU": _temp25,
    "sk-SK": _temp26,
    "sl-SI": _temp27,
    "sr-SP": _temp28,
    "sv-SE": _temp29,
    "tr-TR": _temp30,
    "uk-UA": _temp31,
    "zh-CN": _temp32,
    "zh-TW": _temp33
};

},{"f57c0379d81d3348":"7TR08","e6d9338213965c05":"dB78x","a1126c3108da33ff":"3INMS","6099216088f9530f":"jDCRp","611833a72604cd3d":"AFPa5","3682979199cf9015":"b4kbt","44da0f7100ad07cf":"drKBj","5fd25423561599d8":"1oIYG","5d88e659b3d46554":"8FihB","7b89eabad3afeffd":"cqVO2","ceec0818af7bc476":"buzej","b26828d28f8cf319":"7Xswx","5d8c31d3895d682b":"cF3GM","7815a00b63df3a4d":"exTql","4ef39fbc0cafb03c":"9TYEU","6517b5c2d01068e1":"kKvyk","67148f4945fdf35c":"jsdJa","54331121849b7f7":"4F8Mo","50fd6eda0ad475c9":"8CxuK","297c6a75003d232c":"2A8Bk","e3a2b69b39e71dd7":"dzfkg","2393d7170abeda89":"75jNh","31d5c93148c822f5":"eK5Se","169d73d234813e3d":"cvn0W","b94eea66e61400a9":"7XzLg","b8994a839790862b":"kKUrq","b80190ff96780502":"8yWvr","4820e09868afaa79":"jRPzY","beab3b64a7e8ad0b":"ht4ua","32dcfa47cf9e69e9":"lTxmX","201871c5749a8bae":"bAXqt","b17bc2de61a6ad4e":"6UmW0","9ddaccff6482c7d0":"jInuF","2a3eeb373e42cc3f":"9COKD"}],"7TR08":[function(require,module,exports) {
module.exports = {
    "actions": `\u{627}\u{644}\u{625}\u{62C}\u{631}\u{627}\u{621}\u{627}\u{62A}`,
    "actionsAvailable": `\u{627}\u{644}\u{625}\u{62C}\u{631}\u{627}\u{621}\u{627}\u{62A} \u{627}\u{644}\u{645}\u{62A}\u{627}\u{62D}\u{629}.`,
    "clearSelection": `\u{625}\u{632}\u{627}\u{644}\u{629} \u{627}\u{644}\u{62A}\u{62D}\u{62F}\u{64A}\u{62F}`,
    "selected": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `\u{63A}\u{64A}\u{631} \u{645}\u{62D}\u{62F}\u{62F}`,
            other: ()=>`${formatter.number(args.count)} \u{645}\u{62D}\u{62F}\u{62F}`
        })}`,
    "selectedAll": `\u{62A}\u{645} \u{62A}\u{62D}\u{62F}\u{64A}\u{62F} \u{627}\u{644}\u{643}\u{644}`
};

},{}],"dB78x":[function(require,module,exports) {
module.exports = {
    "actions": `\u{414}\u{435}\u{439}\u{441}\u{442}\u{432}\u{438}\u{44F}`,
    "actionsAvailable": `\u{41D}\u{430}\u{43B}\u{438}\u{447}\u{43D}\u{438} \u{434}\u{435}\u{439}\u{441}\u{442}\u{432}\u{438}\u{44F}.`,
    "clearSelection": `\u{418}\u{437}\u{447}\u{438}\u{441}\u{442}\u{432}\u{430}\u{43D}\u{435} \u{43D}\u{430} \u{438}\u{437}\u{431}\u{43E}\u{440}\u{430}`,
    "selected": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `\u{41D}\u{44F}\u{43C}\u{430} \u{438}\u{437}\u{431}\u{440}\u{430}\u{43D}\u{438}`,
            one: ()=>`${formatter.number(args.count)} \u{438}\u{437}\u{431}\u{440}\u{430}\u{43D}`,
            other: ()=>`${formatter.number(args.count)} \u{438}\u{437}\u{431}\u{440}\u{430}\u{43D}\u{438}`
        })}`,
    "selectedAll": `\u{412}\u{441}\u{438}\u{447}\u{43A}\u{438} \u{438}\u{437}\u{431}\u{440}\u{430}\u{43D}\u{438}`
};

},{}],"3INMS":[function(require,module,exports) {
module.exports = {
    "actions": `Akce`,
    "actionsAvailable": `Dostupn\xe9 akce.`,
    "clearSelection": `Vymazat v\xfdb\u{11B}r`,
    "selected": (args)=>`Vybr\xe1no: ${args.count}`,
    "selectedAll": `Vybr\xe1no v\u{161}e`
};

},{}],"jDCRp":[function(require,module,exports) {
module.exports = {
    "actions": `Handlinger`,
    "actionsAvailable": `Tilg\xe6ngelige handlinger.`,
    "clearSelection": `Ryd markering`,
    "selected": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `Ingen valgt`,
            other: ()=>`${formatter.number(args.count)} valgt`
        })}`,
    "selectedAll": `Alle valgt`
};

},{}],"AFPa5":[function(require,module,exports) {
module.exports = {
    "actions": `Aktionen`,
    "actionsAvailable": `Aktionen verf\xfcgbar.`,
    "clearSelection": `Auswahl l\xf6schen`,
    "selected": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `Nichts ausgew\xe4hlt`,
            one: ()=>`${formatter.number(args.count)} ausgew\xe4hlt`,
            other: ()=>`${formatter.number(args.count)} ausgew\xe4hlt`
        })}`,
    "selectedAll": `Alles ausgew\xe4hlt`
};

},{}],"b4kbt":[function(require,module,exports) {
module.exports = {
    "actions": `\u{395}\u{3BD}\u{3AD}\u{3C1}\u{3B3}\u{3B5}\u{3B9}\u{3B5}\u{3C2}`,
    "actionsAvailable": `\u{3A5}\u{3C0}\u{3AC}\u{3C1}\u{3C7}\u{3BF}\u{3C5}\u{3BD} \u{3B4}\u{3B9}\u{3B1}\u{3B8}\u{3AD}\u{3C3}\u{3B9}\u{3BC}\u{3B5}\u{3C2} \u{3B5}\u{3BD}\u{3AD}\u{3C1}\u{3B3}\u{3B5}\u{3B9}\u{3B5}\u{3C2}.`,
    "clearSelection": `\u{395}\u{3BA}\u{3BA}\u{3B1}\u{3B8}\u{3AC}\u{3C1}\u{3B9}\u{3C3}\u{3B7} \u{3B5}\u{3C0}\u{3B9}\u{3BB}\u{3BF}\u{3B3}\u{3AE}\u{3C2}`,
    "selected": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `\u{394}\u{3B5}\u{3BD} \u{3B5}\u{3C0}\u{3B9}\u{3BB}\u{3AD}\u{3C7}\u{3B8}\u{3B7}\u{3BA}\u{3B5} \u{3BA}\u{3B1}\u{3BD}\u{3AD}\u{3BD}\u{3B1}`,
            one: ()=>`${formatter.number(args.count)} \u{3B5}\u{3C0}\u{3B9}\u{3BB}\u{3B5}\u{3B3}\u{3BC}\u{3AD}\u{3BD}\u{3BF}`,
            other: ()=>`${formatter.number(args.count)} \u{3B5}\u{3C0}\u{3B9}\u{3BB}\u{3B5}\u{3B3}\u{3BC}\u{3AD}\u{3BD}\u{3B1}`
        })}`,
    "selectedAll": `\u{395}\u{3C0}\u{3B9}\u{3BB}\u{3AD}\u{3C7}\u{3B8}\u{3B7}\u{3BA}\u{3B1}\u{3BD} \u{3CC}\u{3BB}\u{3B1}`
};

},{}],"drKBj":[function(require,module,exports) {
module.exports = {
    "clearSelection": `Clear selection`,
    "selected": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `None selected`,
            other: ()=>`${formatter.number(args.count)} selected`
        })}`,
    "selectedAll": `All selected`,
    "actions": `Actions`,
    "actionsAvailable": `Actions available.`
};

},{}],"1oIYG":[function(require,module,exports) {
module.exports = {
    "actions": `Acciones`,
    "actionsAvailable": `Acciones disponibles.`,
    "clearSelection": `Borrar selecci\xf3n`,
    "selected": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `Nada seleccionado`,
            one: ()=>`${formatter.number(args.count)} seleccionado`,
            other: ()=>`${formatter.number(args.count)} seleccionados`
        })}`,
    "selectedAll": `Todo seleccionado`
};

},{}],"8FihB":[function(require,module,exports) {
module.exports = {
    "actions": `Toimingud`,
    "actionsAvailable": `Toimingud saadaval.`,
    "clearSelection": `Puhasta valik`,
    "selected": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `Pole valitud`,
            other: ()=>`${formatter.number(args.count)} valitud`
        })}`,
    "selectedAll": `K\xf5ik valitud`
};

},{}],"cqVO2":[function(require,module,exports) {
module.exports = {
    "actions": `Toiminnot`,
    "actionsAvailable": `Toiminnot k\xe4ytett\xe4viss\xe4.`,
    "clearSelection": `Poista valinta`,
    "selected": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `Ei mit\xe4\xe4n valittu`,
            other: ()=>`${formatter.number(args.count)} valittu`
        })}`,
    "selectedAll": `Kaikki valittu`
};

},{}],"buzej":[function(require,module,exports) {
module.exports = {
    "actions": `Actions`,
    "actionsAvailable": `Actions disponibles.`,
    "clearSelection": `Supprimer la s\xe9lection`,
    "selected": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `Aucun \xe9l\xe9ment s\xe9lectionn\xe9`,
            one: ()=>`${formatter.number(args.count)} s\xe9lectionn\xe9`,
            other: ()=>`${formatter.number(args.count)} s\xe9lectionn\xe9s`
        })}`,
    "selectedAll": `Toute la s\xe9lection`
};

},{}],"7Xswx":[function(require,module,exports) {
module.exports = {
    "actions": `\u{5E4}\u{5E2}\u{5D5}\u{5DC}\u{5D5}\u{5EA}`,
    "actionsAvailable": `\u{5E4}\u{5E2}\u{5D5}\u{5DC}\u{5D5}\u{5EA} \u{5D6}\u{5DE}\u{5D9}\u{5E0}\u{5D5}\u{5EA}.`,
    "clearSelection": `\u{5E0}\u{5E7}\u{5D4} \u{5D1}\u{5D7}\u{5D9}\u{5E8}\u{5D4}`,
    "selected": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `\u{5DC}\u{5D0} \u{5D1}\u{5D5}\u{5E6}\u{5E2}\u{5D4} \u{5D1}\u{5D7}\u{5D9}\u{5E8}\u{5D4}`,
            one: ()=>` ${formatter.number(args.count)} \u{5D1}\u{5D7}\u{5E8}`,
            other: ()=>`${formatter.number(args.count)} \u{5E0}\u{5D1}\u{5D7}\u{5E8}\u{5D5}`
        })}",`,
    "selectedAll": `\u{5DB}\u{5DC} \u{5D4}\u{5E4}\u{5E8}\u{5D9}\u{5D8}\u{5D9}\u{5DD} \u{5E9}\u{5E0}\u{5D1}\u{5D7}\u{5E8}\u{5D5}`
};

},{}],"cF3GM":[function(require,module,exports) {
module.exports = {
    "actions": `Radnje`,
    "actionsAvailable": `Dostupne radnje.`,
    "clearSelection": `Poni\u{161}ti odabir`,
    "selected": (args)=>`Odabrano: ${args.count}`,
    "selectedAll": `Sve je odabrano`
};

},{}],"exTql":[function(require,module,exports) {
module.exports = {
    "actions": `M\u{171}veletek`,
    "actionsAvailable": `M\u{171}veletek \xe1llnak rendelkez\xe9sre.`,
    "clearSelection": `Kijel\xf6l\xe9s t\xf6rl\xe9se`,
    "selected": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `Egy sincs kijel\xf6lve`,
            other: ()=>`${formatter.number(args.count)} kijel\xf6lve`
        })}`,
    "selectedAll": `Mind kijel\xf6lve`
};

},{}],"9TYEU":[function(require,module,exports) {
module.exports = {
    "actions": `Azioni`,
    "actionsAvailable": `Azioni disponibili.`,
    "clearSelection": `Annulla selezione`,
    "selected": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `Nessuno selezionato`,
            one: ()=>`${formatter.number(args.count)} selezionato`,
            other: ()=>`${formatter.number(args.count)} selezionati`
        })}`,
    "selectedAll": `Tutti selezionati`
};

},{}],"kKvyk":[function(require,module,exports) {
module.exports = {
    "actions": `\u{30A2}\u{30AF}\u{30B7}\u{30E7}\u{30F3}`,
    "actionsAvailable": `\u{30A2}\u{30AF}\u{30B7}\u{30E7}\u{30F3}\u{3092}\u{5229}\u{7528}\u{3067}\u{304D}\u{307E}\u{3059}\u{3002}`,
    "clearSelection": `\u{9078}\u{629E}\u{3092}\u{30AF}\u{30EA}\u{30A2}`,
    "selected": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `\u{9078}\u{629E}\u{3055}\u{308C}\u{3066}\u{3044}\u{307E}\u{305B}\u{3093}`,
            other: ()=>`${formatter.number(args.count)} \u{500B}\u{3092}\u{9078}\u{629E}\u{3057}\u{307E}\u{3057}\u{305F}`
        })}`,
    "selectedAll": `\u{3059}\u{3079}\u{3066}\u{3092}\u{9078}\u{629E}`
};

},{}],"jsdJa":[function(require,module,exports) {
module.exports = {
    "actions": `\u{C561}\u{C158}`,
    "actionsAvailable": `\u{C0AC}\u{C6A9} \u{AC00}\u{B2A5}\u{D55C} \u{C561}\u{C158}`,
    "clearSelection": `\u{C120}\u{D0DD} \u{D56D}\u{BAA9} \u{C9C0}\u{C6B0}\u{AE30}`,
    "selected": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `\u{C120}\u{D0DD}\u{B41C} \u{D56D}\u{BAA9} \u{C5C6}\u{C74C}`,
            other: ()=>`${formatter.number(args.count)}\u{AC1C} \u{C120}\u{D0DD}\u{B428}`
        })}`,
    "selectedAll": `\u{BAA8}\u{B450} \u{C120}\u{D0DD}\u{B428}`
};

},{}],"4F8Mo":[function(require,module,exports) {
module.exports = {
    "actions": `Veiksmai`,
    "actionsAvailable": `Galimi veiksmai.`,
    "clearSelection": `I\u{161}valyti pasirinkim\u{105}`,
    "selected": (args)=>`Pasirinkta: ${args.count}`,
    "selectedAll": `Pasirinkta viskas`
};

},{}],"8CxuK":[function(require,module,exports) {
module.exports = {
    "actions": `Darb\u{12B}bas`,
    "actionsAvailable": `Pieejamas darb\u{12B}bas.`,
    "clearSelection": `Not\u{12B}r\u{12B}t atlasi`,
    "selected": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `Nav atlas\u{12B}ts nekas`,
            other: ()=>`Atlas\u{12B}ts(-i): ${formatter.number(args.count)}`
        })}`,
    "selectedAll": `Atlas\u{12B}ts viss`
};

},{}],"2A8Bk":[function(require,module,exports) {
module.exports = {
    "actions": `Handlinger`,
    "actionsAvailable": `Tilgjengelige handlinger.`,
    "clearSelection": `T\xf8m utvalg`,
    "selected": (args)=>`Valde element: ${args.count}`,
    "selectedAll": `Alle er valgt`
};

},{}],"dzfkg":[function(require,module,exports) {
module.exports = {
    "actions": `Acties`,
    "actionsAvailable": `Acties beschikbaar.`,
    "clearSelection": `Selectie wissen`,
    "selected": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `Niets geselecteerd`,
            other: ()=>`${formatter.number(args.count)} geselecteerd`
        })}`,
    "selectedAll": `Alles geselecteerd`
};

},{}],"75jNh":[function(require,module,exports) {
module.exports = {
    "actions": `Dzia\u{142}ania`,
    "actionsAvailable": `Dost\u{119}pne dzia\u{142}ania.`,
    "clearSelection": `Wyczy\u{15B}\u{107} zaznaczenie`,
    "selected": (args)=>`Zaznaczono: ${args.count}`,
    "selectedAll": `Wszystkie zaznaczone`
};

},{}],"eK5Se":[function(require,module,exports) {
module.exports = {
    "actions": `A\xe7\xf5es`,
    "actionsAvailable": `A\xe7\xf5es dispon\xedveis.`,
    "clearSelection": `Limpar sele\xe7\xe3o`,
    "selected": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `Nenhum selecionado`,
            one: ()=>`${formatter.number(args.count)} selecionado`,
            other: ()=>`${formatter.number(args.count)} selecionados`
        })}`,
    "selectedAll": `Todos selecionados`
};

},{}],"cvn0W":[function(require,module,exports) {
module.exports = {
    "actions": `A\xe7\xf5es`,
    "actionsAvailable": `A\xe7\xf5es dispon\xedveis.`,
    "clearSelection": `Limpar sele\xe7\xe3o`,
    "selected": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `Nenhum selecionado`,
            one: ()=>`${formatter.number(args.count)} selecionado`,
            other: ()=>`${formatter.number(args.count)} selecionados`
        })}`,
    "selectedAll": `Tudo selecionado`
};

},{}],"7XzLg":[function(require,module,exports) {
module.exports = {
    "actions": `Ac\u{21B}iuni`,
    "actionsAvailable": `Ac\u{21B}iuni disponibile.`,
    "clearSelection": `Goli\u{21B}i selec\u{21B}ia`,
    "selected": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `Niciunul selectat`,
            one: ()=>` ${formatter.number(args.count)} selectat`,
            other: ()=>`${formatter.number(args.count)} selectate`
        })}`,
    "selectedAll": `Toate selectate`
};

},{}],"kKUrq":[function(require,module,exports) {
module.exports = {
    "actions": `\u{414}\u{435}\u{439}\u{441}\u{442}\u{432}\u{438}\u{44F}`,
    "actionsAvailable": `\u{412}\u{43E}\u{437}\u{43C}\u{43E}\u{436}\u{43D}\u{43E} \u{432}\u{44B}\u{43F}\u{43E}\u{43B}\u{43D}\u{435}\u{43D}\u{438}\u{435} \u{434}\u{435}\u{439}\u{441}\u{442}\u{432}\u{438}\u{439}.`,
    "clearSelection": `\u{41E}\u{447}\u{438}\u{441}\u{442}\u{438}\u{442}\u{44C} \u{432}\u{44B}\u{431}\u{43E}\u{440}`,
    "selected": (args)=>`\u{412}\u{44B}\u{431}\u{440}\u{430}\u{43D}\u{43E}: ${args.count}`,
    "selectedAll": `\u{412}\u{44B}\u{431}\u{440}\u{430}\u{43D}\u{43E} \u{432}\u{441}\u{435}`
};

},{}],"8yWvr":[function(require,module,exports) {
module.exports = {
    "actions": `Akcie`,
    "actionsAvailable": `Dostupn\xe9 akcie.`,
    "clearSelection": `Vymaza\u{165} v\xfdber`,
    "selected": (args)=>`Vybran\xe9 polo\u{17E}ky: ${args.count}`,
    "selectedAll": `V\u{161}etky vybrat\xe9 polo\u{17E}ky`
};

},{}],"jRPzY":[function(require,module,exports) {
module.exports = {
    "actions": `Dejanja`,
    "actionsAvailable": `Na voljo so dejanja.`,
    "clearSelection": `Po\u{10D}isti izbor`,
    "selected": (args)=>`Izbrano: ${args.count}`,
    "selectedAll": `Vsi izbrani`
};

},{}],"ht4ua":[function(require,module,exports) {
module.exports = {
    "actions": `Radnje`,
    "actionsAvailable": `Dostupne su radnje.`,
    "clearSelection": `Poni\u{161}ti izbor`,
    "selected": (args)=>`Izabrano: ${args.count}`,
    "selectedAll": `Sve je izabrano`
};

},{}],"lTxmX":[function(require,module,exports) {
module.exports = {
    "actions": `\xc5tg\xe4rder`,
    "actionsAvailable": `\xc5tg\xe4rder finns.`,
    "clearSelection": `Rensa markering`,
    "selected": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `Inga valda`,
            one: ()=>`${formatter.number(args.count)} vald`,
            other: ()=>`${formatter.number(args.count)} valda`
        })}`,
    "selectedAll": `Alla markerade`
};

},{}],"bAXqt":[function(require,module,exports) {
module.exports = {
    "actions": `Eylemler`,
    "actionsAvailable": `Eylemler mevcut.`,
    "clearSelection": `Se\xe7imi temizle`,
    "selected": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `Hi\xe7biri se\xe7ilmedi`,
            other: ()=>`${formatter.number(args.count)} se\xe7ildi`
        })}`,
    "selectedAll": `T\xfcm\xfc se\xe7ildi`
};

},{}],"6UmW0":[function(require,module,exports) {
module.exports = {
    "actions": `\u{414}\u{456}\u{457}`,
    "actionsAvailable": `\u{414}\u{43E}\u{441}\u{442}\u{443}\u{43F}\u{43D}\u{456} \u{434}\u{456}\u{457}.`,
    "clearSelection": `\u{41E}\u{447}\u{438}\u{441}\u{442}\u{438}\u{442}\u{438} \u{432}\u{438}\u{431}\u{456}\u{440}`,
    "selected": (args)=>`\u{412}\u{438}\u{431}\u{440}\u{430}\u{43D}\u{43E}: ${args.count}`,
    "selectedAll": `\u{423}\u{441}\u{435} \u{432}\u{438}\u{431}\u{440}\u{430}\u{43D}\u{43E}`
};

},{}],"jInuF":[function(require,module,exports) {
module.exports = {
    "actions": `\u{64CD}\u{4F5C}`,
    "actionsAvailable": `\u{6709}\u{53EF}\u{7528}\u{64CD}\u{4F5C}\u{3002}`,
    "clearSelection": `\u{6E05}\u{9664}\u{9009}\u{62E9}`,
    "selected": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `\u{65E0}\u{9009}\u{62E9}`,
            other: ()=>`\u{5DF2}\u{9009}\u{62E9} ${formatter.number(args.count)} \u{4E2A}`
        })}`,
    "selectedAll": `\u{5168}\u{9009}`
};

},{}],"9COKD":[function(require,module,exports) {
module.exports = {
    "actions": `\u{52D5}\u{4F5C}`,
    "actionsAvailable": `\u{53EF}\u{57F7}\u{884C}\u{7684}\u{52D5}\u{4F5C}\u{3002}`,
    "clearSelection": `\u{6E05}\u{9664}\u{9078}\u{53D6}\u{9805}\u{76EE}`,
    "selected": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `\u{672A}\u{9078}\u{53D6}\u{4EFB}\u{4F55}\u{9805}\u{76EE}`,
            other: ()=>`\u{5DF2}\u{9078}\u{53D6} ${formatter.number(args.count)} \u{500B}`
        })}`,
    "selectedAll": `\u{5DF2}\u{9078}\u{53D6}\u{6240}\u{6709}\u{9805}\u{76EE}`
};

},{}],"j2ol3":[function(require,module,exports) {
module.exports["ActionBarContainer"] = `R4yOqG_ActionBarContainer`;
module.exports["actiongroup"] = `R4yOqG_actiongroup`;
module.exports["clear"] = `R4yOqG_clear`;
module.exports["is-open"] = `R4yOqG_is-open`;
module.exports["react-spectrum-ActionBar"] = `R4yOqG_react-spectrum-ActionBar`;
module.exports["react-spectrum-ActionBar--emphasized"] = `R4yOqG_react-spectrum-ActionBar--emphasized`;
module.exports["react-spectrum-ActionBar-actionGroup"] = `R4yOqG_react-spectrum-ActionBar-actionGroup`;
module.exports["react-spectrum-ActionBar-bar"] = `R4yOqG_react-spectrum-ActionBar-bar`;
module.exports["react-spectrum-ActionBar-selectedCount"] = `R4yOqG_react-spectrum-ActionBar-selectedCount`;
module.exports["selected"] = `R4yOqG_selected`;

},{}],"bhK18":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ActionBarContainer", ()=>_ActionBarContainer);
var _utils = require("@react-spectrum/utils");
var _utils1 = require("@react-aria/utils");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _actionbarCss = require("./actionbar.css");
var _actionbarCssDefault = parcelHelpers.interopDefault(_actionbarCss);
var _provider = require("@react-spectrum/provider");
function ActionBarContainer(props, ref) {
    // Grabs specific props from the closest Provider (see https://react-spectrum.adobe.com/react-spectrum/Provider.html#property-groups). Remove if your component doesn't support any of the listed props.
    props = (0, _provider.useProviderProps)(props);
    let { children } = props;
    let { styleProps } = (0, _utils.useStyleProps)(props);
    let domRef = (0, _utils.useDOMRef)(ref);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...(0, _utils1.filterDOMProps)(props),
        ...styleProps,
        ref: domRef,
        className: (0, _utils.classNames)((0, _actionbarCssDefault.default), "ActionBarContainer", styleProps.className)
    }, children);
}
/**
 * ActionBarContainer wraps around an ActionBar and a component that supports selection. It handles
 * the ActionBar's position with respect to its linked component.
 */ const _ActionBarContainer = /*#__PURE__*/ (0, _reactDefault.default).forwardRef(ActionBarContainer);

},{"@react-spectrum/utils":"cMIJ6","@react-aria/utils":"9cLk5","react":"9yzVZ","./actionbar.css":"j2ol3","@react-spectrum/provider":"5bCdp","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"6YR74":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Example", ()=>Example);
parcelHelpers.export(exports, "Example2", ()=>Example2);
var _ = require("../");
var _table = require("@react-spectrum/table");
var _copy = require("@spectrum-icons/workflow/Copy");
var _copyDefault = parcelHelpers.interopDefault(_copy);
var _dataAdd = require("@spectrum-icons/workflow/DataAdd");
var _dataAddDefault = parcelHelpers.interopDefault(_dataAdd);
var _delete = require("@spectrum-icons/workflow/Delete");
var _deleteDefault = parcelHelpers.interopDefault(_delete);
var _duplicate = require("@spectrum-icons/workflow/Duplicate");
var _duplicateDefault = parcelHelpers.interopDefault(_duplicate);
var _edit = require("@spectrum-icons/workflow/Edit");
var _editDefault = parcelHelpers.interopDefault(_edit);
var _utils = require("@react-aria/utils");
var _move = require("@spectrum-icons/workflow/Move");
var _moveDefault = parcelHelpers.interopDefault(_move);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _text = require("@react-spectrum/text");
let columns = [
    {
        name: "Foo",
        key: "foo"
    },
    {
        name: "Bar",
        key: "bar"
    },
    {
        name: "Baz",
        key: "baz"
    }
];
let defaultItems = [
    {
        test: "Test 1",
        foo: "Foo 1",
        bar: "Bar 1",
        yay: "Yay 1",
        baz: "Baz 1"
    },
    {
        test: "Test 2",
        foo: "Foo 2",
        bar: "Bar 2",
        yay: "Yay 2",
        baz: "Baz 2"
    },
    {
        test: "Test 1",
        foo: "Foo 3",
        bar: "Bar 1",
        yay: "Yay 1",
        baz: "Baz 1"
    },
    {
        test: "Test 2",
        foo: "Foo 4",
        bar: "Bar 2",
        yay: "Yay 2",
        baz: "Baz 2"
    },
    {
        test: "Test 1",
        foo: "Foo 5",
        bar: "Bar 1",
        yay: "Yay 1",
        baz: "Baz 1"
    },
    {
        test: "Test 2",
        foo: "Foo 6",
        bar: "Bar 2",
        yay: "Yay 2",
        baz: "Baz 2"
    },
    {
        test: "Test 1",
        foo: "Foo 7",
        bar: "Bar 1",
        yay: "Yay 1",
        baz: "Baz 1"
    },
    {
        test: "Test 2",
        foo: "Foo 8",
        bar: "Bar 2",
        yay: "Yay 2",
        baz: "Baz 2"
    },
    {
        test: "Test 1",
        foo: "Foo 9",
        bar: "Bar 1",
        yay: "Yay 1",
        baz: "Baz 1"
    },
    {
        test: "Test 2",
        foo: "Foo 10",
        bar: "Bar 2",
        yay: "Yay 2",
        baz: "Baz 2"
    },
    {
        test: "Test 1",
        foo: "Foo 11",
        bar: "Bar 1",
        yay: "Yay 1",
        baz: "Baz 1"
    },
    {
        test: "Test 2",
        foo: "Foo 12",
        bar: "Bar 2",
        yay: "Yay 2",
        baz: "Baz 2"
    },
    {
        test: "Test 1",
        foo: "Foo 13",
        bar: "Bar 1",
        yay: "Yay 1",
        baz: "Baz 1"
    },
    {
        test: "Test 2",
        foo: "Foo 14",
        bar: "Bar 2",
        yay: "Yay 2",
        baz: "Baz 2"
    },
    {
        test: "Test 1",
        foo: "Foo 15",
        bar: "Bar 1",
        yay: "Yay 1",
        baz: "Baz 1"
    },
    {
        test: "Test 2",
        foo: "Foo 16",
        bar: "Bar 2",
        yay: "Yay 2",
        baz: "Baz 2"
    }
];
function Example(props = {}) {
    const [selectedKeys, setSelectedKeys] = (0, _react.useState)(props.defaultSelectedKeys || new Set());
    let [items, setItems] = (0, _react.useState)(defaultItems);
    let ref = (0, _react.useRef)(null);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ActionBarContainer), {
        height: props.containerHeight || 300
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _table.TableView), {
        ref: ref,
        "aria-label": "Table",
        isQuiet: props.isQuiet,
        width: props.tableWidth,
        selectedKeys: selectedKeys,
        selectionMode: "multiple",
        onSelectionChange: (keys)=>setSelectedKeys(keys)
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _table.TableHeader), {
        columns: columns
    }, (column)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _table.Column), null, column.name)), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _table.TableBody), {
        items: items
    }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _table.Row), {
            key: item.foo
        }, (key)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _table.Cell), null, item[key])))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ActionBar), {
        selectedItemCount: selectedKeys === "all" ? selectedKeys : selectedKeys.size,
        onClearSelection: ()=>{
            setSelectedKeys(new Set());
        },
        ...(0, _utils.mergeProps)(props, {
            onAction: (key)=>{
                if (key === "delete") {
                    let newItems = items;
                    if (selectedKeys instanceof Set) newItems = items.filter((item)=>!selectedKeys.has(item.foo));
                    else if (selectedKeys === "all") newItems = [];
                    setItems(newItems);
                    setSelectedKeys(new Set());
                }
            }
        })
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
        key: "edit",
        textValue: "Edit"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _editDefault.default), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, "Edit")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
        key: "copy",
        textValue: "Copy"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _copyDefault.default), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, "Copy")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
        key: "delete",
        textValue: "Delete"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _deleteDefault.default), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, "Delete")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
        key: "move",
        textValue: "Move"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _moveDefault.default), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, "Move")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
        key: "duplicate",
        textValue: "Duplicate"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _duplicateDefault.default), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, "Duplicate"))));
}
function Example2(props = {}) {
    const [selectedKeys, setSelectedKeys] = (0, _react.useState)(props.defaultSelectedKeys || new Set());
    let [items, setItems] = (0, _react.useState)(defaultItems);
    let ref = (0, _react.useRef)(null);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ActionBarContainer), {
        height: props.containerHeight || 300
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _table.TableView), {
        ref: ref,
        "aria-label": "Table",
        isQuiet: props.isQuiet,
        width: props.tableWidth,
        selectedKeys: selectedKeys,
        selectionMode: "multiple",
        onSelectionChange: (keys)=>setSelectedKeys(keys)
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _table.TableHeader), {
        columns: columns
    }, (column)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _table.Column), null, column.name)), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _table.TableBody), {
        items: items
    }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _table.Row), {
            key: item.foo
        }, (key)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _table.Cell), null, item[key])))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ActionBar), {
        selectedItemCount: selectedKeys === "all" ? selectedKeys : selectedKeys.size,
        onClearSelection: ()=>{
            setSelectedKeys(new Set());
        },
        ...(0, _utils.mergeProps)(props, {
            onAction: (key)=>{
                if (key === "delete") {
                    let newItems = items;
                    if (selectedKeys instanceof Set) newItems = items.filter((item)=>!selectedKeys.has(item.foo));
                    else if (selectedKeys === "all") newItems = [];
                    setItems(newItems);
                    setSelectedKeys(new Set());
                }
            }
        })
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
        key: "edit",
        textValue: "Edit"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _editDefault.default), {
        size: "S"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, "Bearbeiten")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
        key: "loschen",
        textValue: "Delete"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _deleteDefault.default), {
        size: "S"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, "L\xf6schen")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
        key: "dataadd",
        textValue: "DataAdd"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _dataAddDefault.default), {
        size: "S"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, "Datenansicht erstellen"))));
}

},{"../":"5knYA","@react-spectrum/table":"gptJH","@spectrum-icons/workflow/Copy":"jpSBZ","@spectrum-icons/workflow/DataAdd":"a8iVN","@spectrum-icons/workflow/Delete":"foJ71","@spectrum-icons/workflow/Duplicate":"8Lk94","@spectrum-icons/workflow/Edit":"ijmhW","@react-aria/utils":"9cLk5","@spectrum-icons/workflow/Move":"1BcnR","react":"9yzVZ","@react-spectrum/text":"etCGI","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"5knYA":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _src = require("./src");
parcelHelpers.exportAll(_src, exports);

},{"./src":"3NgxP","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"a8iVN":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("373d6de54b6a5c03");
exports.__esModule = true;
exports.default = DataAdd;
var _DataAdd = require("b9a454b58a58533f");
var _icon = require("276c2de238b0ea21");
var _react = _interopRequireDefault(require("e32f3db631484081"));
function DataAdd(props) {
    return /*#__PURE__*/ _react.default.createElement(_icon.Icon, props, /*#__PURE__*/ _react.default.createElement(_DataAdd.A4uDataAdd, null));
}

},{"373d6de54b6a5c03":"iHubQ","b9a454b58a58533f":"4MxH5","276c2de238b0ea21":"k7wem","e32f3db631484081":"9yzVZ"}],"4MxH5":[function(require,module,exports) {
/**
* @adobe/react-spectrum-workflow (c) by Adobe
* 
* @adobe/react-spectrum-workflow is licensed under a
* Creative Commons Attribution-NoDerivatives 4.0 International License.
* 
* You should have received a copy of the license along with this
* work. If not, see <http://creativecommons.org/licenses/by-nd/4.0/>.
**/ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.A4uDataAdd = A4uDataAdd;
var _react = _interopRequireDefault(require("f49c344acd970113"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function A4uDataAdd(_ref) {
    var props = _extends({}, _ref);
    return /*#__PURE__*/ _react["default"].createElement("svg", _extends({
        viewBox: "0 0 36 36"
    }, props, props), /*#__PURE__*/ _react["default"].createElement("ellipse", {
        fillRule: "evenodd",
        cx: "18",
        cy: "7",
        rx: "16",
        ry: "5"
    }), /*#__PURE__*/ _react["default"].createElement("path", {
        fillRule: "evenodd",
        d: "M27,18.1A8.9,8.9,0,1,0,35.9,27,8.9,8.9,0,0,0,27,18.1Zm4.9,10.4H28.5v3.4a.5.5,0,0,1-.5.5H26a.5.5,0,0,1-.5-.5V28.5H22.1a.5.5,0,0,1-.5-.5V26a.5.5,0,0,1,.5-.5h3.4V22.1a.5.5,0,0,1,.5-.5h2a.5.5,0,0,1,.5.5v3.4h3.4a.5.5,0,0,1,.5.5v2A.5.5,0,0,1,31.9,28.5Z"
    }), /*#__PURE__*/ _react["default"].createElement("path", {
        fillRule: "evenodd",
        d: "M15,27a11.972,11.972,0,0,1,.347-2.82C10.288,23.856,3.5,22.653,2,20.27V29c0,2.683,6.769,4.866,15.258,4.988A11.932,11.932,0,0,1,15,27Z"
    }), /*#__PURE__*/ _react["default"].createElement("path", {
        fillRule: "evenodd",
        d: "M27,15a11.924,11.924,0,0,1,6.961,2.238A1.5,1.5,0,0,0,34,17V10.27c-2.447,3.1-11.064,4-16,4s-14.212-1.168-16-4V17c0,2.562,6.171,4.671,14.12,4.963A11.989,11.989,0,0,1,27,15Z"
    }));
}

},{"f49c344acd970113":"9yzVZ"}],"foJ71":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("7ce2baa8915e84c0");
exports.__esModule = true;
exports.default = Delete;
var _Delete = require("257a7e0d06581598");
var _icon = require("ee83246e8511bd4d");
var _react = _interopRequireDefault(require("9df487d93c8dc886"));
function Delete(props) {
    return /*#__PURE__*/ _react.default.createElement(_icon.Icon, props, /*#__PURE__*/ _react.default.createElement(_Delete.A4uDelete, null));
}

},{"7ce2baa8915e84c0":"iHubQ","257a7e0d06581598":"aIgHd","ee83246e8511bd4d":"k7wem","9df487d93c8dc886":"9yzVZ"}],"aIgHd":[function(require,module,exports) {
/**
* @adobe/react-spectrum-workflow (c) by Adobe
* 
* @adobe/react-spectrum-workflow is licensed under a
* Creative Commons Attribution-NoDerivatives 4.0 International License.
* 
* You should have received a copy of the license along with this
* work. If not, see <http://creativecommons.org/licenses/by-nd/4.0/>.
**/ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.A4uDelete = A4uDelete;
var _react = _interopRequireDefault(require("1fb21df36522a66c"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function A4uDelete(_ref) {
    var props = _extends({}, _ref);
    return /*#__PURE__*/ _react["default"].createElement("svg", _extends({
        viewBox: "0 0 36 36"
    }, props, props), /*#__PURE__*/ _react["default"].createElement("path", {
        fillRule: "evenodd",
        d: "M31.5,6H24V4a2,2,0,0,0-2-2H12a2,2,0,0,0-2,2V6H2.5a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5h2L6.913,33.1a1,1,0,0,0,1,.9H26.092a1,1,0,0,0,1-.9L29.5,8h2a.5.5,0,0,0,.5-.5v-1A.5.5,0,0,0,31.5,6ZM11.065,29A1,1,0,0,1,10,28.068l-1.071-16a1,1,0,1,1,2-.134l1.071,16A1,1,0,0,1,11.065,29ZM18,28a1,1,0,0,1-2,0V12a1,1,0,0,1,2,0ZM22,6H12V4H22Zm2,22.068A1,1,0,1,1,22,27.934l1.071-16a1,1,0,1,1,2,.134Z"
    }));
}

},{"1fb21df36522a66c":"9yzVZ"}],"8Lk94":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("b688fb0e41701426");
exports.__esModule = true;
exports.default = Duplicate;
var _Duplicate = require("b84ff96c074aa6cc");
var _icon = require("e6827c1aacd9a11a");
var _react = _interopRequireDefault(require("587ca37be07dbc6d"));
function Duplicate(props) {
    return /*#__PURE__*/ _react.default.createElement(_icon.Icon, props, /*#__PURE__*/ _react.default.createElement(_Duplicate.A4uDuplicate, null));
}

},{"b688fb0e41701426":"iHubQ","b84ff96c074aa6cc":"2hka3","e6827c1aacd9a11a":"k7wem","587ca37be07dbc6d":"9yzVZ"}],"2hka3":[function(require,module,exports) {
/**
* @adobe/react-spectrum-workflow (c) by Adobe
* 
* @adobe/react-spectrum-workflow is licensed under a
* Creative Commons Attribution-NoDerivatives 4.0 International License.
* 
* You should have received a copy of the license along with this
* work. If not, see <http://creativecommons.org/licenses/by-nd/4.0/>.
**/ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.A4uDuplicate = A4uDuplicate;
var _react = _interopRequireDefault(require("1458c680a8df8723"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function A4uDuplicate(_ref) {
    var props = _extends({}, _ref);
    return /*#__PURE__*/ _react["default"].createElement("svg", _extends({
        viewBox: "0 0 36 36"
    }, props, props), /*#__PURE__*/ _react["default"].createElement("path", {
        fillRule: "evenodd",
        d: "M9,8H26V3a1,1,0,0,0-1-1H3A1,1,0,0,0,2,3V25a1,1,0,0,0,1,1H8V9A1,1,0,0,1,9,8Z"
    }), /*#__PURE__*/ _react["default"].createElement("path", {
        fillRule: "evenodd",
        d: "M33,10H11a1,1,0,0,0-1,1V33a1,1,0,0,0,1,1H33a1,1,0,0,0,1-1V11A1,1,0,0,0,33,10ZM29,23.5H23.5V29h-3V23.5H15v-3h5.5V15h3v5.5H29Z"
    }));
}

},{"1458c680a8df8723":"9yzVZ"}],"ijmhW":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("258c98e95b680293");
exports.__esModule = true;
exports.default = Edit;
var _Edit = require("c23f9f0d8fa065e");
var _icon = require("73232a6ffa9a1848");
var _react = _interopRequireDefault(require("67e67e382f3741fd"));
function Edit(props) {
    return /*#__PURE__*/ _react.default.createElement(_icon.Icon, props, /*#__PURE__*/ _react.default.createElement(_Edit.A4uEdit, null));
}

},{"258c98e95b680293":"iHubQ","c23f9f0d8fa065e":"43qVa","73232a6ffa9a1848":"k7wem","67e67e382f3741fd":"9yzVZ"}],"43qVa":[function(require,module,exports) {
/**
* @adobe/react-spectrum-workflow (c) by Adobe
* 
* @adobe/react-spectrum-workflow is licensed under a
* Creative Commons Attribution-NoDerivatives 4.0 International License.
* 
* You should have received a copy of the license along with this
* work. If not, see <http://creativecommons.org/licenses/by-nd/4.0/>.
**/ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.A4uEdit = A4uEdit;
var _react = _interopRequireDefault(require("65da74d584ead710"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function A4uEdit(_ref) {
    var props = _extends({}, _ref);
    return /*#__PURE__*/ _react["default"].createElement("svg", _extends({
        viewBox: "0 0 36 36"
    }, props, props), /*#__PURE__*/ _react["default"].createElement("path", {
        fillRule: "evenodd",
        d: "M33.567,8.2,27.8,2.432a1.215,1.215,0,0,0-.866-.353H26.9a1.371,1.371,0,0,0-.927.406L5.084,23.372a.99.99,0,0,0-.251.422L2.055,33.1c-.114.377.459.851.783.851a.251.251,0,0,0,.062-.007c.276-.063,7.866-2.344,9.311-2.778a.972.972,0,0,0,.414-.249L33.513,10.028a1.372,1.372,0,0,0,.4-.883A1.221,1.221,0,0,0,33.567,8.2ZM11.4,29.316c-2.161.649-4.862,1.465-6.729,2.022l2.009-6.73Z"
    }));
}

},{"65da74d584ead710":"9yzVZ"}],"1BcnR":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("7eb668c387eaf916");
exports.__esModule = true;
exports.default = Move;
var _Move = require("30e30cf32e6a12cf");
var _icon = require("31dbd22472399e3e");
var _react = _interopRequireDefault(require("bfc49120abb6ab8a"));
function Move(props) {
    return /*#__PURE__*/ _react.default.createElement(_icon.Icon, props, /*#__PURE__*/ _react.default.createElement(_Move.A4uMove, null));
}

},{"7eb668c387eaf916":"iHubQ","30e30cf32e6a12cf":"7iWW4","31dbd22472399e3e":"k7wem","bfc49120abb6ab8a":"9yzVZ"}],"7iWW4":[function(require,module,exports) {
/**
* @adobe/react-spectrum-workflow (c) by Adobe
* 
* @adobe/react-spectrum-workflow is licensed under a
* Creative Commons Attribution-NoDerivatives 4.0 International License.
* 
* You should have received a copy of the license along with this
* work. If not, see <http://creativecommons.org/licenses/by-nd/4.0/>.
**/ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.A4uMove = A4uMove;
var _react = _interopRequireDefault(require("bacfac85403b044f"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function A4uMove(_ref) {
    var props = _extends({}, _ref);
    return /*#__PURE__*/ _react["default"].createElement("svg", _extends({
        viewBox: "0 0 36 36"
    }, props, props), /*#__PURE__*/ _react["default"].createElement("path", {
        fillRule: "evenodd",
        d: "M34,18a.5.5,0,0,0-.113-.316L32,16.029V16h-.033l-2.113-1.853A.49.49,0,0,0,29.5,14a.5.5,0,0,0-.5.5V16H20V7h1.5a.5.5,0,0,0,.5-.5.489.489,0,0,0-.147-.35L20,4.033V4h-.029L18.316,2.113a.5.5,0,0,0-.632,0L16.029,4H16v.033L14.147,6.146A.489.489,0,0,0,14,6.5a.5.5,0,0,0,.5.5H16v9H7V14.5a.5.5,0,0,0-.5-.5.49.49,0,0,0-.35.147L4.033,16H4v.029L2.113,17.684a.5.5,0,0,0,0,.632L4,19.971V20h.033l2.113,1.852A.491.491,0,0,0,6.5,22a.5.5,0,0,0,.5-.5V20h9v9H14.5a.5.5,0,0,0-.5.5.487.487,0,0,0,.147.35L16,31.967V32h.029l1.655,1.887a.5.5,0,0,0,.632,0L19.971,32H20v-.033l1.853-2.114A.487.487,0,0,0,22,29.5a.5.5,0,0,0-.5-.5H20V20h9v1.5a.5.5,0,0,0,.5.5.491.491,0,0,0,.35-.148L31.967,20H32v-.029l1.887-1.655A.5.5,0,0,0,34,18Z"
    }));
}

},{"bacfac85403b044f":"9yzVZ"}],"6ZJnd":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Default", ()=>Default);
parcelHelpers.export(exports, "FalsyKeys", ()=>FalsyKeys);
parcelHelpers.export(exports, "AllKeysDisabled", ()=>AllKeysDisabled);
parcelHelpers.export(exports, "SomeKeysDisabled", ()=>SomeKeysDisabled);
parcelHelpers.export(exports, "StaticColorWhite", ()=>StaticColorWhite);
parcelHelpers.export(exports, "StaticColorBlack", ()=>StaticColorBlack);
parcelHelpers.export(exports, "WithTooltips", ()=>WithTooltips);
parcelHelpers.export(exports, "Overflow", ()=>Overflow);
parcelHelpers.export(exports, "SummaryIcon", ()=>SummaryIcon);
parcelHelpers.export(exports, "VerticalOverflow", ()=>VerticalOverflow);
var _addonActions = require("@storybook/addon-actions");
var _ = require("../");
var _book = require("@spectrum-icons/workflow/Book");
var _bookDefault = parcelHelpers.interopDefault(_book);
var _brush = require("@spectrum-icons/workflow/Brush");
var _brushDefault = parcelHelpers.interopDefault(_brush);
var _copy = require("@spectrum-icons/workflow/Copy");
var _copyDefault = parcelHelpers.interopDefault(_copy);
var _delete = require("@spectrum-icons/workflow/Delete");
var _deleteDefault = parcelHelpers.interopDefault(_delete);
var _document = require("@spectrum-icons/workflow/Document");
var _documentDefault = parcelHelpers.interopDefault(_document);
var _draw = require("@spectrum-icons/workflow/Draw");
var _drawDefault = parcelHelpers.interopDefault(_draw);
var _duplicate = require("@spectrum-icons/workflow/Duplicate");
var _duplicateDefault = parcelHelpers.interopDefault(_duplicate);
var _layout = require("@react-spectrum/layout");
var _heal = require("@spectrum-icons/workflow/Heal");
var _healDefault = parcelHelpers.interopDefault(_heal);
var _info = require("@spectrum-icons/workflow/Info");
var _infoDefault = parcelHelpers.interopDefault(_info);
var _collections = require("@react-stately/collections");
var _moveTo = require("@spectrum-icons/workflow/MoveTo");
var _moveToDefault = parcelHelpers.interopDefault(_moveTo);
var _properties = require("@spectrum-icons/workflow/Properties");
var _propertiesDefault = parcelHelpers.interopDefault(_properties);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _sampler = require("@spectrum-icons/workflow/Sampler");
var _samplerDefault = parcelHelpers.interopDefault(_sampler);
var _select = require("@spectrum-icons/workflow/Select");
var _selectDefault = parcelHelpers.interopDefault(_select);
var _settings = require("@spectrum-icons/workflow/Settings");
var _settingsDefault = parcelHelpers.interopDefault(_settings);
var _text = require("@react-spectrum/text");
var _text1 = require("@spectrum-icons/workflow/Text");
var _textDefault = parcelHelpers.interopDefault(_text1);
var _tooltip = require("@react-spectrum/tooltip");
var _vectorDraw = require("@spectrum-icons/workflow/VectorDraw");
var _vectorDrawDefault = parcelHelpers.interopDefault(_vectorDraw);
var _view = require("@react-spectrum/view");
var _viewCard = require("@spectrum-icons/workflow/ViewCard");
var _viewCardDefault = parcelHelpers.interopDefault(_viewCard);
var _viewGrid = require("@spectrum-icons/workflow/ViewGrid");
var _viewGridDefault = parcelHelpers.interopDefault(_viewGrid);
var _viewList = require("@spectrum-icons/workflow/ViewList");
var _viewListDefault = parcelHelpers.interopDefault(_viewList);
const viewItems = [
    {
        children: "Grid view",
        name: "1"
    },
    {
        children: "List view",
        name: "2"
    },
    {
        children: "Gallery view",
        name: "3"
    }
];
let onSelectionChange = (0, _addonActions.action)("onSelectionChange");
let iconMap = {
    "Document setup": (0, _documentDefault.default),
    "Settings": (0, _settingsDefault.default),
    "Grid view": (0, _viewGridDefault.default),
    "List view": (0, _viewListDefault.default),
    "Gallery view": (0, _viewCardDefault.default),
    "Edit": (0, _drawDefault.default),
    "Copy": (0, _copyDefault.default),
    "Delete": (0, _deleteDefault.default),
    "Properties": (0, _propertiesDefault.default),
    "Info": (0, _infoDefault.default),
    "Keywords": (0, _bookDefault.default)
};
exports.default = {
    title: "ActionGroup",
    component: (0, _.ActionGroup),
    args: {
        onAction: (0, _addonActions.action)("onAction"),
        onSelectionChange: (s)=>onSelectionChange([
                ...s
            ])
    },
    argTypes: {
        onAction: {
            table: {
                disable: true
            }
        },
        onSelectionChange: {
            table: {
                disable: true
            }
        },
        disabledKeys: {
            table: {
                disable: true
            }
        },
        items: {
            table: {
                disable: true
            }
        },
        summaryIcon: {
            table: {
                disable: true
            }
        },
        selectionMode: {
            control: "select",
            options: [
                "none",
                "single",
                "multiple"
            ]
        },
        isDisabled: {
            control: "boolean"
        },
        density: {
            control: "select",
            options: [
                "compact",
                "regular",
                "spacious"
            ]
        },
        isJustified: {
            control: "boolean"
        },
        isQuiet: {
            control: "boolean"
        },
        isEmphasized: {
            control: "boolean"
        },
        disallowEmptySelection: {
            control: "boolean"
        },
        orientation: {
            control: "select",
            options: [
                "horizontal",
                "vertical"
            ]
        },
        overflowMode: {
            control: "select",
            options: [
                "wrap",
                "collapse"
            ]
        },
        buttonLabelBehavior: {
            control: "select",
            options: [
                "show",
                "hide",
                "collapse"
            ]
        }
    }
};
const Default = {
    args: {
        items: viewItems
    },
    render: (args)=>render(args)
};
const FalsyKeys = {
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ActionGroup), args, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _collections.Item), {
            key: "add"
        }, "Add"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _collections.Item), {
            key: ""
        }, "Delete"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _collections.Item), {
            key: "edit"
        }, "Edit"))
};
const AllKeysDisabled = {
    ...Default,
    args: {
        disabledKeys: [
            "1",
            "2",
            "3"
        ],
        items: viewItems
    }
};
const SomeKeysDisabled = {
    ...Default,
    args: {
        disabledKeys: [
            "1",
            "2"
        ],
        items: viewItems
    }
};
const StaticColorWhite = {
    args: {
        staticColor: "white",
        defaultSelectedKeys: [
            "1"
        ],
        items: viewItems
    },
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.View), {
            backgroundColor: "static-blue-700",
            padding: "size-1000"
        }, render(args)),
    name: "staticColor=white"
};
const StaticColorBlack = {
    args: {
        staticColor: "black",
        defaultSelectedKeys: [
            "1"
        ],
        items: viewItems
    },
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.View), {
            backgroundColor: "static-yellow-400",
            padding: "size-1000"
        }, render(args)),
    name: "staticColor=black"
};
const WithTooltips = {
    args: {
        items: viewItems
    },
    render: (args)=>renderTooltips(args)
};
const Overflow = {
    args: {
        disabledKeys: [
            "1",
            "5"
        ]
    },
    render: (args)=>renderOverflow(args),
    name: "overflowMode"
};
const SummaryIcon = {
    ...Overflow,
    args: {
        disabledKeys: [
            "1",
            "5"
        ],
        summaryIcon: /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textDefault.default), null)
    },
    name: "summary icon overflow"
};
const VerticalOverflow = {
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
            direction: "column"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement("p", null, "Note: this is currently unsupported by Spectrum. Container should scroll."), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
            style: {
                padding: "10px",
                resize: "vertical",
                overflow: "auto",
                width: 32,
                backgroundColor: "var(--spectrum-global-color-gray-50)"
            }
        }, renderTools({
            orientation: "vertical",
            buttonLabelBehavior: "hide",
            maxHeight: "100%",
            ...args
        }))),
    name: "special vertical overflow case"
};
function render(props) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
        gap: "size-300",
        margin: "size-100",
        width: "100%",
        direction: "column"
    }, renderText(props), renderBoth(props), renderIcons(props));
}
function renderText(props) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ActionGroup), props, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _collections.Item), {
            key: item.name,
            textValue: item.name
        }, item.children));
}
function renderBoth(props) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ActionGroup), props, (item)=>{
        let IconElement = iconMap[item.children];
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _collections.Item), {
            key: item.name,
            textValue: item.name,
            "aria-label": item.children
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, item.children), /*#__PURE__*/ (0, _reactDefault.default).createElement(IconElement, null));
    });
}
function renderIcons(props) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ActionGroup), props, (item)=>{
        let IconElement = iconMap[item.children];
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _collections.Item), {
            key: item.name,
            textValue: item.name,
            "aria-label": item.children
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement(IconElement, null));
    });
}
function renderTooltips(props) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ActionGroup), props, (item)=>{
        let IconElement = iconMap[item.children];
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _tooltip.TooltipTrigger), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _collections.Item), {
            key: item.name,
            textValue: item.children,
            "aria-label": item.children
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement(IconElement, null)), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _tooltip.Tooltip), null, item.children));
    });
}
function renderOverflow(props) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        style: {
            padding: "10px",
            resize: "both",
            overflow: "auto",
            width: 250,
            backgroundColor: "var(--spectrum-global-color-gray-50)"
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ActionGroup), {
        ...props,
        summaryIcon: /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textDefault.default), null),
        maxHeight: "100%"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _collections.Item), {
        key: "1",
        "data-testid": "edit"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _drawDefault.default), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, "Edit")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _collections.Item), {
        key: "2",
        "data-testid": "copy"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _copyDefault.default), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, "Copy")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _collections.Item), {
        key: "3",
        "data-testid": "delete"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _deleteDefault.default), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, "Delete")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _collections.Item), {
        key: "4",
        "data-testid": "move"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _moveToDefault.default), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, "Move")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _collections.Item), {
        key: "5",
        "data-testid": "duplicate"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _duplicateDefault.default), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, "Duplicate"))));
}
function renderTools(props = {}) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ActionGroup), {
        "aria-label": "Tools",
        overflowMode: "collapse",
        selectionMode: "single",
        disallowEmptySelection: true,
        defaultSelectedKeys: [
            "select"
        ],
        onSelectionChange: (0, _addonActions.action)("onSelectionChange"),
        buttonLabelBehavior: "hide",
        isEmphasized: true,
        isQuiet: true,
        ...props
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _collections.Item), {
        key: "select"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _selectDefault.default), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, "Select")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _collections.Item), {
        key: "text"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textDefault.default), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, "Text")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _collections.Item), {
        key: "heal"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _healDefault.default), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, "Heal")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _collections.Item), {
        key: "brush"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _brushDefault.default), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, "Brush")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _collections.Item), {
        key: "pen"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _vectorDrawDefault.default), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, "Pen")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _collections.Item), {
        key: "eyedropper"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _samplerDefault.default), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, "Eye dropper")));
}

},{"@storybook/addon-actions":"coXbW","../":"gmT2K","@spectrum-icons/workflow/Book":"e9BS5","@spectrum-icons/workflow/Brush":"izQkQ","@spectrum-icons/workflow/Copy":"jpSBZ","@spectrum-icons/workflow/Delete":"foJ71","@spectrum-icons/workflow/Document":"iJXFA","@spectrum-icons/workflow/Draw":"gXEyB","@spectrum-icons/workflow/Duplicate":"8Lk94","@react-spectrum/layout":"hzaUY","@spectrum-icons/workflow/Heal":"iaGUz","@spectrum-icons/workflow/Info":"dNHFs","@react-stately/collections":"loANi","@spectrum-icons/workflow/MoveTo":"iJg51","@spectrum-icons/workflow/Properties":"9QEfS","react":"9yzVZ","@spectrum-icons/workflow/Sampler":"eGuWl","@spectrum-icons/workflow/Select":"cF4is","@spectrum-icons/workflow/Settings":"6eNaP","@react-spectrum/text":"etCGI","@spectrum-icons/workflow/Text":"9ewtj","@react-spectrum/tooltip":"f9wa6","@spectrum-icons/workflow/VectorDraw":"22122","@react-spectrum/view":"dnRjt","@spectrum-icons/workflow/ViewCard":"cySDp","@spectrum-icons/workflow/ViewGrid":"9ARPt","@spectrum-icons/workflow/ViewList":"31TWb","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"gmT2K":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 * 
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _src = require("./src");
parcelHelpers.exportAll(_src, exports);

},{"./src":"hkqBV","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"e9BS5":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("96461d7d0e51ee45");
exports.__esModule = true;
exports.default = Book;
var _Book = require("85fbec389bac7d99");
var _icon = require("bc41e3b7b6f77033");
var _react = _interopRequireDefault(require("25b4013ab2dc1db5"));
function Book(props) {
    return /*#__PURE__*/ _react.default.createElement(_icon.Icon, props, /*#__PURE__*/ _react.default.createElement(_Book.A4uBook, null));
}

},{"96461d7d0e51ee45":"iHubQ","85fbec389bac7d99":"7Cc5o","bc41e3b7b6f77033":"k7wem","25b4013ab2dc1db5":"9yzVZ"}],"7Cc5o":[function(require,module,exports) {
/**
* @adobe/react-spectrum-workflow (c) by Adobe
* 
* @adobe/react-spectrum-workflow is licensed under a
* Creative Commons Attribution-NoDerivatives 4.0 International License.
* 
* You should have received a copy of the license along with this
* work. If not, see <http://creativecommons.org/licenses/by-nd/4.0/>.
**/ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.A4uBook = A4uBook;
var _react = _interopRequireDefault(require("1b0c2c2381ce14fc"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function A4uBook(_ref) {
    var props = _extends({}, _ref);
    return /*#__PURE__*/ _react["default"].createElement("svg", _extends({
        viewBox: "0 0 36 36"
    }, props, props), /*#__PURE__*/ _react["default"].createElement("path", {
        fillRule: "evenodd",
        d: "M19.782,28H9.995a4,4,0,0,1,0-8H20.518a1,1,0,0,0,.8-.4l11.1-14.8a.5.5,0,0,0-.4-.8H16.025a1,1,0,0,0-.8.4L3.522,19.328A7.981,7.981,0,0,0,9.969,32l10.549,0a1,1,0,0,0,.8-.4l11.1-14.8a.5.5,0,0,0-.4-.8H28.782Z"
    }));
}

},{"1b0c2c2381ce14fc":"9yzVZ"}],"izQkQ":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("3a05835cc7e60d3b");
exports.__esModule = true;
exports.default = Brush;
var _Brush = require("c2ea5a18e4ca263a");
var _icon = require("1e47e8a5bd130c01");
var _react = _interopRequireDefault(require("4de29bf3987761b5"));
function Brush(props) {
    return /*#__PURE__*/ _react.default.createElement(_icon.Icon, props, /*#__PURE__*/ _react.default.createElement(_Brush.A4uBrush, null));
}

},{"3a05835cc7e60d3b":"iHubQ","c2ea5a18e4ca263a":"hpJLb","1e47e8a5bd130c01":"k7wem","4de29bf3987761b5":"9yzVZ"}],"hpJLb":[function(require,module,exports) {
/**
* @adobe/react-spectrum-workflow (c) by Adobe
* 
* @adobe/react-spectrum-workflow is licensed under a
* Creative Commons Attribution-NoDerivatives 4.0 International License.
* 
* You should have received a copy of the license along with this
* work. If not, see <http://creativecommons.org/licenses/by-nd/4.0/>.
**/ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.A4uBrush = A4uBrush;
var _react = _interopRequireDefault(require("ff3dfa4dd1b86a8f"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function A4uBrush(_ref) {
    var props = _extends({}, _ref);
    return /*#__PURE__*/ _react["default"].createElement("svg", _extends({
        viewBox: "0 0 36 36"
    }, props, props), /*#__PURE__*/ _react["default"].createElement("path", {
        fillRule: "evenodd",
        d: "M12.50879,21.03041A4.91741,4.91741,0,0,0,8.3144,22.23434a12.92375,12.92375,0,0,0-2.67981,4.78211C5.172,28.95625,4.73525,30.788,2.27511,31.7883a.59927.59927,0,0,0-.3407.71187.89787.89787,0,0,0,.64413.65762c.58521.14594,1.25345.28416,1.97712.39787,2.60758.40972,7.48017.738,10.80656-1.6515,1.23744-.84779,2.83646-2.98169,2.82212-4.54659A6.813,6.813,0,0,0,12.50879,21.03041Z"
    }), /*#__PURE__*/ _react["default"].createElement("path", {
        fillRule: "evenodd",
        d: "M19.9,24.1C27.13475,15.87336,36.32182,4.565,33.91572,2.15888S21.546,10.97629,14.38,18.83A10.05145,10.05145,0,0,1,19.9,24.1Z"
    }));
}

},{"ff3dfa4dd1b86a8f":"9yzVZ"}],"iJXFA":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("15c1c50beace47ec");
exports.__esModule = true;
exports.default = Document;
var _Document = require("46695fb7c913766a");
var _icon = require("3202543d79266342");
var _react = _interopRequireDefault(require("4d6be5b8b7018673"));
function Document(props) {
    return /*#__PURE__*/ _react.default.createElement(_icon.Icon, props, /*#__PURE__*/ _react.default.createElement(_Document.A4uDocument, null));
}

},{"15c1c50beace47ec":"iHubQ","46695fb7c913766a":"2QF4K","3202543d79266342":"k7wem","4d6be5b8b7018673":"9yzVZ"}],"2QF4K":[function(require,module,exports) {
/**
* @adobe/react-spectrum-workflow (c) by Adobe
* 
* @adobe/react-spectrum-workflow is licensed under a
* Creative Commons Attribution-NoDerivatives 4.0 International License.
* 
* You should have received a copy of the license along with this
* work. If not, see <http://creativecommons.org/licenses/by-nd/4.0/>.
**/ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.A4uDocument = A4uDocument;
var _react = _interopRequireDefault(require("1459449ca63090a0"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function A4uDocument(_ref) {
    var props = _extends({}, _ref);
    return /*#__PURE__*/ _react["default"].createElement("svg", _extends({
        viewBox: "0 0 36 36"
    }, props, props), /*#__PURE__*/ _react["default"].createElement("path", {
        fillRule: "evenodd",
        d: "M20,11V2H7A1,1,0,0,0,6,3V33a1,1,0,0,0,1,1H29a1,1,0,0,0,1-1V12H21A1,1,0,0,1,20,11Z"
    }), /*#__PURE__*/ _react["default"].createElement("path", {
        fillRule: "evenodd",
        d: "M22,2h.086a1,1,0,0,1,.707.293l6.914,6.914A1,1,0,0,1,30,9.914V10H22Z"
    }));
}

},{"1459449ca63090a0":"9yzVZ"}],"gXEyB":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("d29dc74d24a4a83c");
exports.__esModule = true;
exports.default = Draw;
var _Draw = require("98e044606e97c80c");
var _icon = require("2e90fe0f32681855");
var _react = _interopRequireDefault(require("50e2c20c6f0e1c6e"));
function Draw(props) {
    return /*#__PURE__*/ _react.default.createElement(_icon.Icon, props, /*#__PURE__*/ _react.default.createElement(_Draw.A4uDraw, null));
}

},{"d29dc74d24a4a83c":"iHubQ","98e044606e97c80c":"eht9F","2e90fe0f32681855":"k7wem","50e2c20c6f0e1c6e":"9yzVZ"}],"eht9F":[function(require,module,exports) {
/**
* @adobe/react-spectrum-workflow (c) by Adobe
* 
* @adobe/react-spectrum-workflow is licensed under a
* Creative Commons Attribution-NoDerivatives 4.0 International License.
* 
* You should have received a copy of the license along with this
* work. If not, see <http://creativecommons.org/licenses/by-nd/4.0/>.
**/ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.A4uDraw = A4uDraw;
var _react = _interopRequireDefault(require("6fc516545b8026b8"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function A4uDraw(_ref) {
    var props = _extends({}, _ref);
    return /*#__PURE__*/ _react["default"].createElement("svg", _extends({
        viewBox: "0 0 36 36"
    }, props, props), /*#__PURE__*/ _react["default"].createElement("path", {
        fillRule: "evenodd",
        d: "M20.454,8,5.084,23.372a.992.992,0,0,0-.251.421L2.055,33.1c-.114.376.459.85.783.85a.311.311,0,0,0,.062-.006c.276-.064,7.867-2.344,9.311-2.778a.984.984,0,0,0,.415-.25L28,15.544ZM11.4,29.316c-2.161.649-4.862,1.465-6.729,2.022l2.009-6.73Z"
    }), /*#__PURE__*/ _react["default"].createElement("path", {
        fillRule: "evenodd",
        d: "M33.567,8.2,27.8,2.432a1.215,1.215,0,0,0-.866-.353H26.9a1.372,1.372,0,0,0-.927.407l-4.1,4.1,7.543,7.543,4.1-4.1a1.372,1.372,0,0,0,.4-.883A1.224,1.224,0,0,0,33.567,8.2Z"
    }));
}

},{"6fc516545b8026b8":"9yzVZ"}],"iaGUz":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("469512f408ea902");
exports.__esModule = true;
exports.default = Heal;
var _Heal = require("46f21ed9a4dc2f4d");
var _icon = require("21adb2f457beb31e");
var _react = _interopRequireDefault(require("58a619c4668144c9"));
function Heal(props) {
    return /*#__PURE__*/ _react.default.createElement(_icon.Icon, props, /*#__PURE__*/ _react.default.createElement(_Heal.A4uHeal, null));
}

},{"469512f408ea902":"iHubQ","46f21ed9a4dc2f4d":"iaZqS","21adb2f457beb31e":"k7wem","58a619c4668144c9":"9yzVZ"}],"iaZqS":[function(require,module,exports) {
/**
* @adobe/react-spectrum-workflow (c) by Adobe
* 
* @adobe/react-spectrum-workflow is licensed under a
* Creative Commons Attribution-NoDerivatives 4.0 International License.
* 
* You should have received a copy of the license along with this
* work. If not, see <http://creativecommons.org/licenses/by-nd/4.0/>.
**/ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.A4uHeal = A4uHeal;
var _react = _interopRequireDefault(require("1cfa0a48992fe877"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function A4uHeal(_ref) {
    var props = _extends({}, _ref);
    return /*#__PURE__*/ _react["default"].createElement("svg", _extends({
        viewBox: "0 0 36 36"
    }, props, props), /*#__PURE__*/ _react["default"].createElement("path", {
        fillRule: "evenodd",
        d: "M32.728,3.272a6,6,0,0,0-8.485,0L17.787,9.728,3.272,24.243a6,6,0,0,0,8.485,8.485L17.7,26.781,32.728,11.757a6,6,0,0,0,0-8.485ZM19,11a2,2,0,1,1-2,2A2,2,0,0,1,19,11ZM13,21a2,2,0,1,1,2-2A2,2,0,0,1,13,21Zm4,4a2,2,0,1,1,2-2A2,2,0,0,1,17,25Zm6-6a2,2,0,1,1,2-2A2,2,0,0,1,23,19Z"
    }));
}

},{"1cfa0a48992fe877":"9yzVZ"}],"dNHFs":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("1b9dc0a8cacef9ba");
exports.__esModule = true;
exports.default = Info;
var _Info = require("51dde2020cbca6fc");
var _icon = require("22c3883fb78625b5");
var _react = _interopRequireDefault(require("96559b9496d0ad79"));
function Info(props) {
    return /*#__PURE__*/ _react.default.createElement(_icon.Icon, props, /*#__PURE__*/ _react.default.createElement(_Info.A4uInfo, null));
}

},{"1b9dc0a8cacef9ba":"iHubQ","51dde2020cbca6fc":"gxdOT","22c3883fb78625b5":"k7wem","96559b9496d0ad79":"9yzVZ"}],"gxdOT":[function(require,module,exports) {
/**
* @adobe/react-spectrum-workflow (c) by Adobe
* 
* @adobe/react-spectrum-workflow is licensed under a
* Creative Commons Attribution-NoDerivatives 4.0 International License.
* 
* You should have received a copy of the license along with this
* work. If not, see <http://creativecommons.org/licenses/by-nd/4.0/>.
**/ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.A4uInfo = A4uInfo;
var _react = _interopRequireDefault(require("69020c8cd5011999"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function A4uInfo(_ref) {
    var props = _extends({}, _ref);
    return /*#__PURE__*/ _react["default"].createElement("svg", _extends({
        viewBox: "0 0 36 36"
    }, props, props), /*#__PURE__*/ _react["default"].createElement("path", {
        fillRule: "evenodd",
        d: "M18,2A16,16,0,1,0,34,18,16,16,0,0,0,18,2Zm-.3,4.3a2.718,2.718,0,0,1,2.864,2.824A2.664,2.664,0,0,1,17.7,11.987a2.705,2.705,0,0,1-2.864-2.864A2.717,2.717,0,0,1,17.7,6.3ZM22,27a1,1,0,0,1-1,1H15a1,1,0,0,1-1-1V25a1,1,0,0,1,1-1h1V18H15a1,1,0,0,1-1-1V15a1,1,0,0,1,1-1h4a1,1,0,0,1,1,1v9h1a1,1,0,0,1,1,1Z"
    }));
}

},{"69020c8cd5011999":"9yzVZ"}],"iJg51":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("c89d656881244619");
exports.__esModule = true;
exports.default = MoveTo;
var _MoveTo = require("ebac07633ec4bbba");
var _icon = require("e055b7e8a123c5dc");
var _react = _interopRequireDefault(require("35ba16488a011fae"));
function MoveTo(props) {
    return /*#__PURE__*/ _react.default.createElement(_icon.Icon, props, /*#__PURE__*/ _react.default.createElement(_MoveTo.A4uMoveTo, null));
}

},{"c89d656881244619":"iHubQ","ebac07633ec4bbba":"eeAcQ","e055b7e8a123c5dc":"k7wem","35ba16488a011fae":"9yzVZ"}],"eeAcQ":[function(require,module,exports) {
/**
* @adobe/react-spectrum-workflow (c) by Adobe
* 
* @adobe/react-spectrum-workflow is licensed under a
* Creative Commons Attribution-NoDerivatives 4.0 International License.
* 
* You should have received a copy of the license along with this
* work. If not, see <http://creativecommons.org/licenses/by-nd/4.0/>.
**/ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.A4uMoveTo = A4uMoveTo;
var _react = _interopRequireDefault(require("c81aae2cc89bc50b"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function A4uMoveTo(_ref) {
    var props = _extends({}, _ref);
    return /*#__PURE__*/ _react["default"].createElement("svg", _extends({
        viewBox: "0 0 36 36"
    }, props, props), /*#__PURE__*/ _react["default"].createElement("path", {
        fillRule: "evenodd",
        d: "M21.879,20.344a1,1,0,0,1-1.414,0l-4.809-4.809a1,1,0,0,1,0-1.414L23.777,6H3A1,1,0,0,0,2,7V33a1,1,0,0,0,1,1H29a1,1,0,0,0,1-1V12.223Z"
    }), /*#__PURE__*/ _react["default"].createElement("path", {
        fillRule: "evenodd",
        d: "M23.707,2a.5.5,0,0,0-.353.854l3.482,3.482L18.7,14.475a.5.5,0,0,0,0,.707L20.818,17.3a.5.5,0,0,0,.707,0l8.139-8.139,3.482,3.483A.5.5,0,0,0,34,12.293V2Z"
    }));
}

},{"c81aae2cc89bc50b":"9yzVZ"}],"9QEfS":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("3fd2ff4b3279faf8");
exports.__esModule = true;
exports.default = Properties;
var _Properties = require("dec0cf90ee622b8f");
var _icon = require("43bda302b00d5a6d");
var _react = _interopRequireDefault(require("3e77d385479fb942"));
function Properties(props) {
    return /*#__PURE__*/ _react.default.createElement(_icon.Icon, props, /*#__PURE__*/ _react.default.createElement(_Properties.A4uProperties, null));
}

},{"3fd2ff4b3279faf8":"iHubQ","dec0cf90ee622b8f":"dPl7q","43bda302b00d5a6d":"k7wem","3e77d385479fb942":"9yzVZ"}],"dPl7q":[function(require,module,exports) {
/**
* @adobe/react-spectrum-workflow (c) by Adobe
* 
* @adobe/react-spectrum-workflow is licensed under a
* Creative Commons Attribution-NoDerivatives 4.0 International License.
* 
* You should have received a copy of the license along with this
* work. If not, see <http://creativecommons.org/licenses/by-nd/4.0/>.
**/ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.A4uProperties = A4uProperties;
var _react = _interopRequireDefault(require("8b25361442fdedfc"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function A4uProperties(_ref) {
    var props = _extends({}, _ref);
    return /*#__PURE__*/ _react["default"].createElement("svg", _extends({
        viewBox: "0 0 36 36"
    }, props, props), /*#__PURE__*/ _react["default"].createElement("path", {
        fillRule: "evenodd",
        d: "M33.5,6H15.9A5,5,0,0,0,6.1,6H2.5a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5H6.1a5,5,0,0,0,9.8,0H33.5a.5.5,0,0,0,.5-.5v-1A.5.5,0,0,0,33.5,6ZM11,10a3,3,0,1,1,3-3A3,3,0,0,1,11,10Z"
    }), /*#__PURE__*/ _react["default"].createElement("path", {
        fillRule: "evenodd",
        d: "M33.5,26H19.9a5,5,0,0,0-9.8,0H2.5a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5h7.6a5,5,0,0,0,9.8,0H33.5a.5.5,0,0,0,.5-.5v-1A.5.5,0,0,0,33.5,26ZM15,30a3,3,0,1,1,3-3A3,3,0,0,1,15,30Z"
    }), /*#__PURE__*/ _react["default"].createElement("path", {
        fillRule: "evenodd",
        d: "M2,16.5v1a.5.5,0,0,0,.5.5H20.1a5,5,0,0,0,9.8,0h3.6a.5.5,0,0,0,.5-.5v-1a.5.5,0,0,0-.5-.5H29.9a5,5,0,0,0-9.8,0H2.5A.5.5,0,0,0,2,16.5ZM22,17a3,3,0,1,1,3,3A3,3,0,0,1,22,17Z"
    }));
}

},{"8b25361442fdedfc":"9yzVZ"}],"eGuWl":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("516cee12cbd66513");
exports.__esModule = true;
exports.default = Sampler;
var _Sampler = require("aea0701321ed7ff1");
var _icon = require("f66ef708657559f8");
var _react = _interopRequireDefault(require("8e6c799ca8b2f378"));
function Sampler(props) {
    return /*#__PURE__*/ _react.default.createElement(_icon.Icon, props, /*#__PURE__*/ _react.default.createElement(_Sampler.A4uSampler, null));
}

},{"516cee12cbd66513":"iHubQ","aea0701321ed7ff1":"lY5Rh","f66ef708657559f8":"k7wem","8e6c799ca8b2f378":"9yzVZ"}],"lY5Rh":[function(require,module,exports) {
/**
* @adobe/react-spectrum-workflow (c) by Adobe
* 
* @adobe/react-spectrum-workflow is licensed under a
* Creative Commons Attribution-NoDerivatives 4.0 International License.
* 
* You should have received a copy of the license along with this
* work. If not, see <http://creativecommons.org/licenses/by-nd/4.0/>.
**/ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.A4uSampler = A4uSampler;
var _react = _interopRequireDefault(require("f4453a845d003c1b"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function A4uSampler(_ref) {
    var props = _extends({}, _ref);
    return /*#__PURE__*/ _react["default"].createElement("svg", _extends({
        viewBox: "0 0 36 36"
    }, props, props), /*#__PURE__*/ _react["default"].createElement("path", {
        fillRule: "evenodd",
        d: "M22.457,17.037,8.232,31.262a2.471,2.471,0,1,1-3.494-3.494L18.963,13.543ZM29.728,2.106a3.591,3.591,0,0,0-2.546,1.055L22.657,7.686,21.243,6.272a1,1,0,0,0-1.414,0L16.467,9.633a1,1,0,0,0,0,1.414l1.081,1.082L3.324,26.354a4.47,4.47,0,1,0,6.322,6.322L23.871,18.452l1.082,1.081a1,1,0,0,0,1.414,0l3.361-3.361a1,1,0,0,0,0-1.415l-1.414-1.414,4.525-4.525a3.6,3.6,0,0,0,0-5.092l-.565-.565a3.592,3.592,0,0,0-2.546-1.055Z"
    }));
}

},{"f4453a845d003c1b":"9yzVZ"}],"cF4is":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("926bbaaf08267772");
exports.__esModule = true;
exports.default = Select;
var _Select = require("95aa97e53e3e82a2");
var _icon = require("c421991263537c6f");
var _react = _interopRequireDefault(require("1ed3965bb353e4eb"));
function Select(props) {
    return /*#__PURE__*/ _react.default.createElement(_icon.Icon, props, /*#__PURE__*/ _react.default.createElement(_Select.A4uSelect, null));
}

},{"926bbaaf08267772":"iHubQ","95aa97e53e3e82a2":"5ytvR","c421991263537c6f":"k7wem","1ed3965bb353e4eb":"9yzVZ"}],"5ytvR":[function(require,module,exports) {
/**
* @adobe/react-spectrum-workflow (c) by Adobe
* 
* @adobe/react-spectrum-workflow is licensed under a
* Creative Commons Attribution-NoDerivatives 4.0 International License.
* 
* You should have received a copy of the license along with this
* work. If not, see <http://creativecommons.org/licenses/by-nd/4.0/>.
**/ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.A4uSelect = A4uSelect;
var _react = _interopRequireDefault(require("4a8666572318b9b0"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function A4uSelect(_ref) {
    var props = _extends({}, _ref);
    return /*#__PURE__*/ _react["default"].createElement("svg", _extends({
        viewBox: "0 0 36 36"
    }, props, props), /*#__PURE__*/ _react["default"].createElement("path", {
        fillRule: "evenodd",
        d: "M8.5,2.054a.5.5,0,0,0-.5.5v32.78a.5.5,0,0,0,.5.5.49.49,0,0,0,.35-.147L18.524,26h13a.5.5,0,0,0,.354-.854L8.854,2.2A.49.49,0,0,0,8.5,2.054Z"
    }));
}

},{"4a8666572318b9b0":"9yzVZ"}],"6eNaP":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("3c03b9cf1e7f4d9");
exports.__esModule = true;
exports.default = Settings;
var _Settings = require("c476bed6f3a5a372");
var _icon = require("b307397feb620a08");
var _react = _interopRequireDefault(require("8d53fdc37beed0fb"));
function Settings(props) {
    return /*#__PURE__*/ _react.default.createElement(_icon.Icon, props, /*#__PURE__*/ _react.default.createElement(_Settings.A4uSettings, null));
}

},{"3c03b9cf1e7f4d9":"iHubQ","c476bed6f3a5a372":"8bw5R","b307397feb620a08":"k7wem","8d53fdc37beed0fb":"9yzVZ"}],"8bw5R":[function(require,module,exports) {
/**
* @adobe/react-spectrum-workflow (c) by Adobe
* 
* @adobe/react-spectrum-workflow is licensed under a
* Creative Commons Attribution-NoDerivatives 4.0 International License.
* 
* You should have received a copy of the license along with this
* work. If not, see <http://creativecommons.org/licenses/by-nd/4.0/>.
**/ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.A4uSettings = A4uSettings;
var _react = _interopRequireDefault(require("d6cca7edc812de93"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function A4uSettings(_ref) {
    var props = _extends({}, _ref);
    return /*#__PURE__*/ _react["default"].createElement("svg", _extends({
        viewBox: "0 0 36 36"
    }, props, props), /*#__PURE__*/ _react["default"].createElement("path", {
        fillRule: "evenodd",
        d: "M32.9,15.793H29.789a11.953,11.953,0,0,0-1.842-4.507L30.152,9.08a1.1,1.1,0,0,0,0-1.56L28.479,5.848a1.1,1.1,0,0,0-1.56,0L24.714,8.053a11.925,11.925,0,0,0-4.507-1.841V3.1A1.1,1.1,0,0,0,19.1,2H16.9a1.1,1.1,0,0,0-1.1,1.1V6.212a11.925,11.925,0,0,0-4.507,1.841l-2.2-2.205a1.1,1.1,0,0,0-1.56,0L5.848,7.52a1.1,1.1,0,0,0,0,1.56l2.205,2.206a11.953,11.953,0,0,0-1.842,4.507H3.1A1.1,1.1,0,0,0,2,16.9V19.1a1.1,1.1,0,0,0,1.1,1.1H6.211a11.934,11.934,0,0,0,1.842,4.507L5.848,26.919a1.1,1.1,0,0,0,0,1.56l1.673,1.673a1.1,1.1,0,0,0,1.56,0l2.205-2.205a11.925,11.925,0,0,0,4.507,1.841V32.9A1.1,1.1,0,0,0,16.9,34H19.1a1.1,1.1,0,0,0,1.1-1.1V29.788a11.925,11.925,0,0,0,4.507-1.841l2.205,2.205a1.1,1.1,0,0,0,1.56,0l1.673-1.673a1.1,1.1,0,0,0,0-1.56l-2.205-2.205a11.934,11.934,0,0,0,1.842-4.507H32.9A1.1,1.1,0,0,0,34,19.1V16.9A1.1,1.1,0,0,0,32.9,15.793ZM22.414,18A4.414,4.414,0,1,1,18,13.586,4.414,4.414,0,0,1,22.414,18Z"
    }));
}

},{"d6cca7edc812de93":"9yzVZ"}],"9ewtj":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("94f11dd2a560acfe");
exports.__esModule = true;
exports.default = Text;
var _Text = require("feb331c030b34685");
var _icon = require("8157795d6ac26898");
var _react = _interopRequireDefault(require("75ce70176c3c44a5"));
function Text(props) {
    return /*#__PURE__*/ _react.default.createElement(_icon.Icon, props, /*#__PURE__*/ _react.default.createElement(_Text.A4uText, null));
}

},{"94f11dd2a560acfe":"iHubQ","feb331c030b34685":"8Rtlb","8157795d6ac26898":"k7wem","75ce70176c3c44a5":"9yzVZ"}],"8Rtlb":[function(require,module,exports) {
/**
* @adobe/react-spectrum-workflow (c) by Adobe
* 
* @adobe/react-spectrum-workflow is licensed under a
* Creative Commons Attribution-NoDerivatives 4.0 International License.
* 
* You should have received a copy of the license along with this
* work. If not, see <http://creativecommons.org/licenses/by-nd/4.0/>.
**/ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.A4uText = A4uText;
var _react = _interopRequireDefault(require("35064851c436c7c5"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function A4uText(_ref) {
    var props = _extends({}, _ref);
    return /*#__PURE__*/ _react["default"].createElement("svg", _extends({
        viewBox: "0 0 36 36"
    }, props, props), /*#__PURE__*/ _react["default"].createElement("path", {
        fillRule: "evenodd",
        d: "M5,4A1.00294,1.00294,0,0,0,4,5v6a1,1,0,0,0,1,1H7a1,1,0,0,0,1-1V8h8V28H13a1,1,0,0,0-1,1v2a1,1,0,0,0,1,1H23a1,1,0,0,0,1-1V29a1,1,0,0,0-1-1H20V8h8v3a1,1,0,0,0,1,1h2a1,1,0,0,0,1-1V5a1.00294,1.00294,0,0,0-1-1Z"
    }));
}

},{"35064851c436c7c5":"9yzVZ"}],"22122":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("13cf1c1692aa3d90");
exports.__esModule = true;
exports.default = VectorDraw;
var _VectorDraw = require("1161831768e08251");
var _icon = require("edae5a3127f14915");
var _react = _interopRequireDefault(require("b2bcfaa07e417442"));
function VectorDraw(props) {
    return /*#__PURE__*/ _react.default.createElement(_icon.Icon, props, /*#__PURE__*/ _react.default.createElement(_VectorDraw.A4uVectorDraw, null));
}

},{"13cf1c1692aa3d90":"iHubQ","1161831768e08251":"dbxZ8","edae5a3127f14915":"k7wem","b2bcfaa07e417442":"9yzVZ"}],"dbxZ8":[function(require,module,exports) {
/**
* @adobe/react-spectrum-workflow (c) by Adobe
* 
* @adobe/react-spectrum-workflow is licensed under a
* Creative Commons Attribution-NoDerivatives 4.0 International License.
* 
* You should have received a copy of the license along with this
* work. If not, see <http://creativecommons.org/licenses/by-nd/4.0/>.
**/ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.A4uVectorDraw = A4uVectorDraw;
var _react = _interopRequireDefault(require("f1dc14aa94fb832b"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function A4uVectorDraw(_ref) {
    var props = _extends({}, _ref);
    return /*#__PURE__*/ _react["default"].createElement("svg", _extends({
        viewBox: "0 0 36 36"
    }, props, props), /*#__PURE__*/ _react["default"].createElement("path", {
        fillRule: "evenodd",
        d: "M33.134,11.26,24.718,2.846a1.068,1.068,0,0,0-1.51,0L19.491,6.562a1.052,1.052,0,0,0-.147,1.289l8.42,8.42.008-.017.186.183a1.066,1.066,0,0,0,1.509,0l3.667-3.666A1.066,1.066,0,0,0,33.134,11.26Z"
    }), /*#__PURE__*/ _react["default"].createElement("path", {
        fillRule: "evenodd",
        d: "M17.462,9.383,9.585,13.011a2,2,0,0,0-1.011,1.051L1.979,29.973a1,1,0,0,0,.216,1.09l.523.523,8.156-8.157a1.619,1.619,0,0,1-.037-.254,2,2,0,1,1,2,2,1.684,1.684,0,0,1-.276-.04L4.414,33.283l.592.592a1,1,0,0,0,1.09.217l15.913-6.6a2,2,0,0,0,1.05-1.011l3.628-7.876Z"
    }));
}

},{"f1dc14aa94fb832b":"9yzVZ"}],"cySDp":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("bb8f1d310afee1ba");
exports.__esModule = true;
exports.default = ViewCard;
var _ViewCard = require("1ff8d3e0d58ebb14");
var _icon = require("af7f6e23c888c445");
var _react = _interopRequireDefault(require("afdff8441f8cb2ec"));
function ViewCard(props) {
    return /*#__PURE__*/ _react.default.createElement(_icon.Icon, props, /*#__PURE__*/ _react.default.createElement(_ViewCard.A4uViewCard, null));
}

},{"bb8f1d310afee1ba":"iHubQ","1ff8d3e0d58ebb14":"6VOjy","af7f6e23c888c445":"k7wem","afdff8441f8cb2ec":"9yzVZ"}],"6VOjy":[function(require,module,exports) {
/**
* @adobe/react-spectrum-workflow (c) by Adobe
* 
* @adobe/react-spectrum-workflow is licensed under a
* Creative Commons Attribution-NoDerivatives 4.0 International License.
* 
* You should have received a copy of the license along with this
* work. If not, see <http://creativecommons.org/licenses/by-nd/4.0/>.
**/ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.A4uViewCard = A4uViewCard;
var _react = _interopRequireDefault(require("16df56360cde14b8"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function A4uViewCard(_ref) {
    var props = _extends({}, _ref);
    return /*#__PURE__*/ _react["default"].createElement("svg", _extends({
        viewBox: "0 0 36 36"
    }, props, props), /*#__PURE__*/ _react["default"].createElement("path", {
        fillRule: "evenodd",
        d: "M2,33a1,1,0,0,0,1,1h7V18H2Z"
    }), /*#__PURE__*/ _react["default"].createElement("path", {
        fillRule: "evenodd",
        d: "M3,2A1,1,0,0,0,2,3V14h8V2Z"
    }), /*#__PURE__*/ _react["default"].createElement("path", {
        fillRule: "evenodd",
        d: "M26,34h7a1,1,0,0,0,1-1V28H26Z"
    }), /*#__PURE__*/ _react["default"].createElement("path", {
        fillRule: "evenodd",
        d: "M33,2H26V8h8V3A1,1,0,0,0,33,2Z"
    }), /*#__PURE__*/ _react["default"].createElement("rect", {
        fillRule: "evenodd",
        height: "12",
        width: "8",
        x: "14",
        y: "22"
    }), /*#__PURE__*/ _react["default"].createElement("rect", {
        fillRule: "evenodd",
        height: "16",
        width: "8",
        x: "14",
        y: "2"
    }), /*#__PURE__*/ _react["default"].createElement("rect", {
        fillRule: "evenodd",
        height: "12",
        width: "8",
        x: "26",
        y: "12"
    }));
}

},{"16df56360cde14b8":"9yzVZ"}],"9ARPt":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("1e42b2f02af8375c");
exports.__esModule = true;
exports.default = ViewGrid;
var _ViewGrid = require("367bce57f46372c6");
var _icon = require("99f6b0bd39046aa5");
var _react = _interopRequireDefault(require("38d9bcd6f203ff19"));
function ViewGrid(props) {
    return /*#__PURE__*/ _react.default.createElement(_icon.Icon, props, /*#__PURE__*/ _react.default.createElement(_ViewGrid.A4uViewGrid, null));
}

},{"1e42b2f02af8375c":"iHubQ","367bce57f46372c6":"adTvj","99f6b0bd39046aa5":"k7wem","38d9bcd6f203ff19":"9yzVZ"}],"adTvj":[function(require,module,exports) {
/**
* @adobe/react-spectrum-workflow (c) by Adobe
* 
* @adobe/react-spectrum-workflow is licensed under a
* Creative Commons Attribution-NoDerivatives 4.0 International License.
* 
* You should have received a copy of the license along with this
* work. If not, see <http://creativecommons.org/licenses/by-nd/4.0/>.
**/ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.A4uViewGrid = A4uViewGrid;
var _react = _interopRequireDefault(require("612899a9d7161c5b"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function A4uViewGrid(_ref) {
    var props = _extends({}, _ref);
    return /*#__PURE__*/ _react["default"].createElement("svg", _extends({
        viewBox: "0 0 36 36"
    }, props, props), /*#__PURE__*/ _react["default"].createElement("path", {
        fillRule: "evenodd",
        d: "M10,10H2V3A1,1,0,0,1,3,2h7Z"
    }), /*#__PURE__*/ _react["default"].createElement("rect", {
        fillRule: "evenodd",
        height: "8",
        width: "8",
        x: "14",
        y: "2"
    }), /*#__PURE__*/ _react["default"].createElement("path", {
        fillRule: "evenodd",
        d: "M34,10H26V2h7a1,1,0,0,1,1,1Z"
    }), /*#__PURE__*/ _react["default"].createElement("rect", {
        fillRule: "evenodd",
        height: "8",
        width: "8",
        x: "2",
        y: "14"
    }), /*#__PURE__*/ _react["default"].createElement("rect", {
        fillRule: "evenodd",
        height: "8",
        width: "8",
        x: "14",
        y: "14"
    }), /*#__PURE__*/ _react["default"].createElement("rect", {
        fillRule: "evenodd",
        height: "8",
        width: "8",
        x: "26",
        y: "14"
    }), /*#__PURE__*/ _react["default"].createElement("path", {
        fillRule: "evenodd",
        d: "M10,34H3a1,1,0,0,1-1-1V26h8Z"
    }), /*#__PURE__*/ _react["default"].createElement("rect", {
        fillRule: "evenodd",
        height: "8",
        width: "8",
        x: "14",
        y: "26"
    }), /*#__PURE__*/ _react["default"].createElement("path", {
        fillRule: "evenodd",
        d: "M33,34H26V26h8v7A1,1,0,0,1,33,34Z"
    }));
}

},{"612899a9d7161c5b":"9yzVZ"}],"31TWb":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("c0d7ad2552a62fbf");
exports.__esModule = true;
exports.default = ViewList;
var _ViewList = require("a9b62e5ae9d73f90");
var _icon = require("435b2e85b9356d8");
var _react = _interopRequireDefault(require("dee0227f40935fa8"));
function ViewList(props) {
    return /*#__PURE__*/ _react.default.createElement(_icon.Icon, props, /*#__PURE__*/ _react.default.createElement(_ViewList.A4uViewList, null));
}

},{"c0d7ad2552a62fbf":"iHubQ","a9b62e5ae9d73f90":"gN5OL","435b2e85b9356d8":"k7wem","dee0227f40935fa8":"9yzVZ"}],"gN5OL":[function(require,module,exports) {
/**
* @adobe/react-spectrum-workflow (c) by Adobe
* 
* @adobe/react-spectrum-workflow is licensed under a
* Creative Commons Attribution-NoDerivatives 4.0 International License.
* 
* You should have received a copy of the license along with this
* work. If not, see <http://creativecommons.org/licenses/by-nd/4.0/>.
**/ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.A4uViewList = A4uViewList;
var _react = _interopRequireDefault(require("142871cb829da09f"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function A4uViewList(_ref) {
    var props = _extends({}, _ref);
    return /*#__PURE__*/ _react["default"].createElement("svg", _extends({
        viewBox: "0 0 36 36"
    }, props, props), /*#__PURE__*/ _react["default"].createElement("rect", {
        fillRule: "evenodd",
        height: "8",
        rx: "1",
        ry: "1",
        width: "8",
        x: "2",
        y: "2"
    }), /*#__PURE__*/ _react["default"].createElement("rect", {
        fillRule: "evenodd",
        height: "4",
        rx: "0.5",
        ry: "0.5",
        width: "22",
        x: "12",
        y: "4"
    }), /*#__PURE__*/ _react["default"].createElement("rect", {
        fillRule: "evenodd",
        height: "4",
        rx: "0.5",
        ry: "0.5",
        width: "22",
        x: "12",
        y: "16"
    }), /*#__PURE__*/ _react["default"].createElement("rect", {
        fillRule: "evenodd",
        height: "4",
        rx: "0.5",
        ry: "0.5",
        width: "22",
        x: "12",
        y: "28"
    }), /*#__PURE__*/ _react["default"].createElement("rect", {
        fillRule: "evenodd",
        height: "8",
        rx: "1",
        ry: "1",
        width: "8",
        x: "2",
        y: "14"
    }), /*#__PURE__*/ _react["default"].createElement("rect", {
        fillRule: "evenodd",
        height: "8",
        rx: "1",
        ry: "1",
        width: "8",
        x: "2",
        y: "26"
    }));
}

},{"142871cb829da09f":"9yzVZ"}],"b8wmw":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Toolbar", ()=>Toolbar);
parcelHelpers.export(exports, "Default", ()=>Default);
parcelHelpers.export(exports, "DisabledKeys", ()=>DisabledKeys);
var _ = require("../");
var _utils = require("@react-spectrum/utils");
var _copy = require("@spectrum-icons/workflow/Copy");
var _copyDefault = parcelHelpers.interopDefault(_copy);
var _delete = require("@spectrum-icons/workflow/Delete");
var _deleteDefault = parcelHelpers.interopDefault(_delete);
var _divider = require("@react-spectrum/divider");
var _draw = require("@spectrum-icons/workflow/Draw");
var _drawDefault = parcelHelpers.interopDefault(_draw);
var _info = require("@spectrum-icons/workflow/Info");
var _infoDefault = parcelHelpers.interopDefault(_info);
var _collections = require("@react-stately/collections");
var _properties = require("@spectrum-icons/workflow/Properties");
var _propertiesDefault = parcelHelpers.interopDefault(_properties);
var _reactAriaComponents = require("react-aria-components");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _toolbarCss = require("./toolbar.css");
var _toolbarCssDefault = parcelHelpers.interopDefault(_toolbarCss);
var _tooltip = require("@react-spectrum/tooltip");
var _provider = require("@react-spectrum/provider");
var _viewCard = require("@spectrum-icons/workflow/ViewCard");
var _viewCardDefault = parcelHelpers.interopDefault(_viewCard);
var _viewGrid = require("@spectrum-icons/workflow/ViewGrid");
var _viewGridDefault = parcelHelpers.interopDefault(_viewGrid);
var _viewList = require("@spectrum-icons/workflow/ViewList");
var _viewListDefault = parcelHelpers.interopDefault(_viewList);
const Toolbar = /*#__PURE__*/ (0, _react.forwardRef)((props, ref)=>{
    props = (0, _provider.useProviderProps)(props);
    props = (0, _utils.useSlotProps)(props, "toolbar");
    let { orientation = "horizontal" } = props;
    let slots = (0, _react.useMemo)(()=>({
            actionGroup: {
                orientation
            },
            divider: {
                orientation: orientation === "horizontal" ? "vertical" : "horizontal",
                size: "S"
            }
        }), [
        orientation
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Toolbar), {
        ...props,
        ref: ref,
        className: (0, _utils.classNames)((0, _toolbarCssDefault.default), "spectrum-Toolbar")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.SlotProvider), {
        slots: slots
    }, props.children));
});
exports.default = {
    title: "Toolbar",
    component: Toolbar,
    argTypes: {
        children: {
            table: {
                disable: true
            }
        },
        orientation: {
            control: "radio",
            options: [
                "horizontal",
                "vertical"
            ]
        }
    },
    excludeStories: [
        "Toolbar"
    ]
};
let items1 = [
    {
        id: "edit",
        textValue: "Edit",
        icon: (0, _drawDefault.default)
    },
    {
        id: "copy",
        textValue: "Copy",
        icon: (0, _copyDefault.default)
    },
    {
        id: "delete",
        textValue: "Delete",
        icon: (0, _deleteDefault.default)
    }
];
let items2 = [
    {
        id: "grid",
        textValue: "Grid view",
        icon: (0, _viewGridDefault.default)
    },
    {
        id: "list",
        textValue: "List view",
        icon: (0, _viewListDefault.default)
    },
    {
        id: "card",
        textValue: "Gallery view",
        icon: (0, _viewCardDefault.default)
    }
];
let items3 = [
    {
        id: "properties",
        textValue: "Properties",
        icon: (0, _propertiesDefault.default)
    },
    {
        id: "info",
        textValue: "Info",
        icon: (0, _infoDefault.default)
    }
];
const Default = {
    args: {
        children: /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ActionGroup), {
            items: items1,
            "aria-label": "manage",
            selectionMode: "single"
        }, (item)=>{
            let Icon = item.icon;
            return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _tooltip.TooltipTrigger), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _collections.Item), {
                key: item.id,
                textValue: item.textValue
            }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Icon, {
                "aria-label": item.textValue
            })), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _tooltip.Tooltip), null, item.textValue));
        }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _divider.Divider), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ActionGroup), {
            items: items2,
            "aria-label": "view",
            selectionMode: "single"
        }, (item)=>{
            let Icon = item.icon;
            return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _collections.Item), {
                key: item.id,
                textValue: item.textValue
            }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Icon, {
                "aria-label": item.textValue
            }));
        }))
    },
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(Toolbar, args)
};
const DisabledKeys = {
    args: {
        "aria-label": "The big toolbar",
        children: /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ActionGroup), {
            items: items1,
            disabledKeys: new Set([
                "copy"
            ]),
            "aria-label": "manage",
            selectionMode: "multiple"
        }, (item)=>{
            let Icon = item.icon;
            return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _tooltip.TooltipTrigger), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _collections.Item), {
                key: item.id,
                textValue: item.textValue
            }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Icon, {
                "aria-label": item.textValue
            })), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _tooltip.Tooltip), null, item.textValue));
        }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _divider.Divider), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ActionGroup), {
            items: items2,
            isDisabled: true,
            "aria-label": "view"
        }, (item)=>{
            let Icon = item.icon;
            return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _collections.Item), {
                key: item.id,
                textValue: item.textValue
            }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Icon, {
                "aria-label": item.textValue
            }));
        }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _divider.Divider), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ActionGroup), {
            items: items3,
            "aria-label": "inspect",
            selectionMode: "single"
        }, (item)=>{
            let Icon = item.icon;
            return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _collections.Item), {
                key: item.id,
                textValue: item.textValue
            }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Icon, {
                "aria-label": item.textValue
            }));
        }))
    }
};

},{"../":"gmT2K","@react-spectrum/utils":"cMIJ6","@spectrum-icons/workflow/Copy":"jpSBZ","@spectrum-icons/workflow/Delete":"foJ71","@react-spectrum/divider":"dxmqN","@spectrum-icons/workflow/Draw":"gXEyB","@spectrum-icons/workflow/Info":"dNHFs","@react-stately/collections":"loANi","@spectrum-icons/workflow/Properties":"9QEfS","react-aria-components":"lFSUH","react":"9yzVZ","./toolbar.css":"4A1zj","@react-spectrum/tooltip":"f9wa6","@react-spectrum/provider":"5bCdp","@spectrum-icons/workflow/ViewCard":"cySDp","@spectrum-icons/workflow/ViewGrid":"9ARPt","@spectrum-icons/workflow/ViewList":"31TWb","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"4A1zj":[function(require,module,exports) {
module.exports["spectrum-Toolbar"] = `MsQiSq_spectrum-Toolbar`;

},{}],"fn9Bu":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Default", ()=>Default);
parcelHelpers.export(exports, "Dynamic", ()=>Dynamic);
parcelHelpers.export(exports, "NoItems", ()=>NoItems);
parcelHelpers.export(exports, "MappedItems", ()=>MappedItems);
parcelHelpers.export(exports, "noVisibleLabel", ()=>noVisibleLabel);
parcelHelpers.export(exports, "customOnSubmit", ()=>customOnSubmit);
parcelHelpers.export(exports, "iconFilter", ()=>iconFilter);
parcelHelpers.export(exports, "iconNull", ()=>iconNull);
parcelHelpers.export(exports, "WithAvatars", ()=>WithAvatars);
var _addonActions = require("@storybook/addon-actions");
var _avatar = require("@react-spectrum/avatar");
var _filter = require("@spectrum-icons/workflow/Filter");
var _filterDefault = parcelHelpers.interopDefault(_filter);
var _layout = require("@react-spectrum/layout");
var _autocomplete = require("@react-spectrum/autocomplete");
var _utils = require("@react-aria/utils");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _text = require("@react-spectrum/text");
exports.default = {
    title: "SearchAutocomplete",
    component: (0, _autocomplete.SearchAutocomplete),
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _autocomplete.SearchAutocomplete), {
            label: "Search with Autocomplete",
            ...args
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _autocomplete.Item), null, "Aerospace"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _autocomplete.Item), null, "Mechanical"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _autocomplete.Item), null, "Civil"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _autocomplete.Item), null, "Biomedical"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _autocomplete.Item), null, "Nuclear"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _autocomplete.Item), null, "Industrial"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _autocomplete.Item), null, "Chemical"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _autocomplete.Item), null, "Agricultural"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _autocomplete.Item), null, "Electrical")),
    args: {
        label: "Search with Autocomplete",
        onOpenChange: (0, _addonActions.action)("onOpenChange"),
        onInputChange: (0, _addonActions.action)("onInputChange"),
        onSelectionChange: (0, _addonActions.action)("onSelectionChange"),
        onBlur: (0, _addonActions.action)("onBlur"),
        onFocus: (0, _addonActions.action)("onFocus"),
        onSubmit: (0, _addonActions.action)("onSubmit"),
        onClear: (0, _addonActions.action)("onClear")
    },
    argTypes: {
        defaultItems: {
            table: {
                disable: true
            }
        },
        contextualHelp: {
            table: {
                disable: true
            }
        },
        onOpenChange: {
            table: {
                disable: true
            }
        },
        disabledKeys: {
            table: {
                disable: true
            }
        },
        inputValue: {
            table: {
                disable: true
            }
        },
        defaultInputValue: {
            table: {
                disable: true
            }
        },
        defaultSelectedKey: {
            table: {
                disable: true
            }
        },
        selectedKey: {
            table: {
                disable: true
            }
        },
        onInputChange: {
            table: {
                disable: true
            }
        },
        onSelectionChange: {
            table: {
                disable: true
            }
        },
        onBlur: {
            table: {
                disable: true
            }
        },
        onFocus: {
            table: {
                disable: true
            }
        },
        label: {
            control: "text"
        },
        "aria-label": {
            control: "text"
        },
        isDisabled: {
            control: "boolean"
        },
        isQuiet: {
            control: "boolean"
        },
        isReadOnly: {
            control: "boolean"
        },
        autoFocus: {
            control: "boolean"
        },
        isRequired: {
            control: "boolean"
        },
        necessityIndicator: {
            control: "select",
            options: [
                "icon",
                "label"
            ]
        },
        labelAlign: {
            control: "select",
            options: [
                "end",
                "start"
            ]
        },
        labelPosition: {
            control: "select",
            options: [
                "top",
                "side"
            ]
        },
        loadingState: {
            control: "select",
            options: [
                "idle",
                "loading",
                "loadingMore",
                "filtering"
            ]
        },
        validationState: {
            control: "select",
            options: [
                null,
                "valid",
                "invalid"
            ]
        },
        description: {
            control: "text"
        },
        errorMessage: {
            control: "text"
        },
        menuTrigger: {
            control: "select",
            options: [
                "focus",
                "manual"
            ]
        },
        direction: {
            control: "radio",
            options: [
                "top",
                "bottom"
            ]
        },
        align: {
            control: "radio",
            options: [
                "start",
                "end"
            ]
        },
        width: {
            control: {
                type: "radio",
                options: [
                    null,
                    "100px",
                    "480px",
                    "size-4600"
                ]
            }
        },
        menuWidth: {
            control: {
                type: "radio",
                options: [
                    null,
                    "100px",
                    "480px",
                    "size-4600"
                ]
            }
        }
    }
};
let items = [
    {
        id: 1,
        name: "Aerospace"
    },
    {
        id: 2,
        name: "Mechanical"
    },
    {
        id: 3,
        name: "Civil"
    },
    {
        id: 4,
        name: "Biomedical"
    },
    {
        id: 5,
        name: "Nuclear"
    },
    {
        id: 6,
        name: "Industrial"
    },
    {
        id: 7,
        name: "Chemical"
    },
    {
        id: 8,
        name: "Agricultural"
    },
    {
        id: 9,
        name: "Electrical"
    }
];
const Default = {
    name: "static items"
};
const Dynamic = {
    args: {
        defaultItems: items
    },
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _autocomplete.SearchAutocomplete), {
            defaultItems: items,
            ...args
        }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _autocomplete.Item), null, item.name)),
    name: "dynamic items"
};
const NoItems = {
    ...Dynamic,
    args: {
        defaultItems: []
    },
    name: "no items"
};
const MappedItems = {
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _autocomplete.SearchAutocomplete), {
            label: "Search with Autocomplete",
            ...args
        }, items.map((item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _autocomplete.Item), {
                key: item.id
            }, item.name))),
    name: "with mapped items"
};
function CustomOnSubmit(props) {
    let [searchTerm, setSearchTerm] = (0, _reactDefault.default).useState("");
    let onSubmit = (value, key)=>{
        if (value) setSearchTerm(value);
        else if (key) {
            var _items_find;
            let term = (_items_find = items.find((o)=>o.id === key)) === null || _items_find === void 0 ? void 0 : _items_find.name;
            setSearchTerm(term ? term : "");
        }
    };
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
        direction: "column"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _autocomplete.SearchAutocomplete), {
        defaultItems: items,
        label: "Search with Autocomplete",
        ...(0, _utils.mergeProps)(props, {
            onSubmit
        })
    }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _autocomplete.Item), null, item.name)), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", null, "Search results for: ", searchTerm));
}
const noVisibleLabel = {
    args: {
        label: undefined,
        "aria-label": "Search Autocomplete"
    },
    name: "No visible label"
};
const customOnSubmit = {
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(CustomOnSubmit, args),
    name: "custom onSubmit"
};
const iconFilter = {
    args: {
        icon: /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _filterDefault.default), null)
    },
    name: "icon: Filter"
};
const iconNull = {
    args: {
        icon: null
    },
    name: "icon: null"
};
const WithAvatars = {
    args: {
        label: "Search users"
    },
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _autocomplete.SearchAutocomplete), args, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _autocomplete.Item), {
            textValue: "User 1"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _avatar.Avatar), {
            src: "https://i.imgur.com/kJOwAdv.png"
        }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, "User 1")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _autocomplete.Item), {
            textValue: "User 2"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _avatar.Avatar), {
            src: "https://i.imgur.com/kJOwAdv.png"
        }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, "User 2")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _autocomplete.Item), {
            textValue: "User 3"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _avatar.Avatar), {
            src: "https://i.imgur.com/kJOwAdv.png"
        }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, "User 3")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _autocomplete.Item), {
            textValue: "User 4"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _avatar.Avatar), {
            src: "https://i.imgur.com/kJOwAdv.png"
        }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, "User 4")))
};

},{"@storybook/addon-actions":"coXbW","@react-spectrum/avatar":"kHDr1","@spectrum-icons/workflow/Filter":"9GjEj","@react-spectrum/layout":"hzaUY","@react-spectrum/autocomplete":"9Ircl","@react-aria/utils":"9cLk5","react":"9yzVZ","@react-spectrum/text":"etCGI","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"kHDr1":[function(require,module,exports) {
/*
 * Copyright 2021 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /// <reference types="css-module-types" />
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Avatar", ()=>(0, _avatar.Avatar));
var _avatar = require("./Avatar");

},{"./Avatar":"9XsWH","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"9XsWH":[function(require,module,exports) {
/*
 * Copyright 2021 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Avatar", ()=>_Avatar);
var _utils = require("@react-spectrum/utils");
var _utils1 = require("@react-aria/utils");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _varsCss = require("@adobe/spectrum-css-temp/components/avatar/vars.css");
var _varsCssDefault = parcelHelpers.interopDefault(_varsCss);
var _provider = require("@react-spectrum/provider");
const DEFAULT_SIZE = "avatar-size-100";
const SIZE_RE = /^size-\d+/;
function Avatar(props, ref) {
    props = (0, _utils.useSlotProps)(props, "avatar");
    const { alt = "", isDisabled, size = DEFAULT_SIZE, src, ...otherProps } = (0, _provider.useProviderProps)(props);
    const { styleProps } = (0, _utils.useStyleProps)(otherProps);
    const domRef = (0, _utils.useDOMRef)(ref);
    const domProps = (0, _utils1.filterDOMProps)(otherProps);
    // Casting `size` as `any` since `isNaN` expects a `number`, but we want it
    // to handle `string` numbers; e.g. '300' as opposed to 300
    const sizeValue = typeof size !== "number" && (SIZE_RE.test(size) || !isNaN(size)) ? (0, _utils.dimensionValue)(DEFAULT_SIZE) // override disallowed size values
     : (0, _utils.dimensionValue)(size || DEFAULT_SIZE);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("img", {
        ...styleProps,
        ...domProps,
        alt: alt,
        className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Avatar", {
            "is-disabled": isDisabled
        }, styleProps.className),
        ref: domRef,
        src: src,
        style: {
            ...styleProps.style,
            ...sizeValue && {
                height: sizeValue,
                width: sizeValue
            }
        }
    });
}
/**
 * An avatar is a thumbnail representation of an entity, such as a user or an organization.
 */ const _Avatar = /*#__PURE__*/ (0, _react.forwardRef)(Avatar);

},{"@react-spectrum/utils":"cMIJ6","@react-aria/utils":"9cLk5","react":"9yzVZ","@adobe/spectrum-css-temp/components/avatar/vars.css":"bApXI","@react-spectrum/provider":"5bCdp","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"bApXI":[function(require,module,exports) {
module.exports["is-disabled"] = `IFaZJG_is-disabled`;
module.exports["spectrum-Avatar"] = `IFaZJG_spectrum-Avatar`;

},{}],"9GjEj":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("97ee97baa03c8836");
exports.__esModule = true;
exports.default = Filter;
var _Filter = require("959548994528f0f1");
var _icon = require("188375b6e45e8644");
var _react = _interopRequireDefault(require("c5bfcfb784cc9f52"));
function Filter(props) {
    return /*#__PURE__*/ _react.default.createElement(_icon.Icon, props, /*#__PURE__*/ _react.default.createElement(_Filter.A4uFilter, null));
}

},{"97ee97baa03c8836":"iHubQ","959548994528f0f1":"9yCyi","188375b6e45e8644":"k7wem","c5bfcfb784cc9f52":"9yzVZ"}],"9yCyi":[function(require,module,exports) {
/**
* @adobe/react-spectrum-workflow (c) by Adobe
* 
* @adobe/react-spectrum-workflow is licensed under a
* Creative Commons Attribution-NoDerivatives 4.0 International License.
* 
* You should have received a copy of the license along with this
* work. If not, see <http://creativecommons.org/licenses/by-nd/4.0/>.
**/ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.A4uFilter = A4uFilter;
var _react = _interopRequireDefault(require("b3b8616c29d62ffc"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function A4uFilter(_ref) {
    var props = _extends({}, _ref);
    return /*#__PURE__*/ _react["default"].createElement("svg", _extends({
        viewBox: "0 0 36 36"
    }, props, props), /*#__PURE__*/ _react["default"].createElement("path", {
        fillRule: "evenodd",
        d: "M30.946,2H3.054a1,1,0,0,0-.787,1.617L14,18.589V33.9a.992.992,0,0,0,1.68.824l3.981-4.153A1.219,1.219,0,0,0,20,29.728V18.589L31.733,3.617A1,1,0,0,0,30.946,2Z"
    }));
}

},{"b3b8616c29d62ffc":"9yzVZ"}],"9Ircl":[function(require,module,exports) {
/*
 * Copyright 2021 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /// <reference types="css-module-types" />
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SearchAutocomplete", ()=>(0, _searchAutocomplete.SearchAutocomplete));
parcelHelpers.export(exports, "Item", ()=>(0, _collections.Item));
parcelHelpers.export(exports, "Section", ()=>(0, _collections.Section));
var _searchAutocomplete = require("./SearchAutocomplete");
var _collections = require("@react-stately/collections");

},{"./SearchAutocomplete":"5VqeI","@react-stately/collections":"loANi","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"5VqeI":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SearchAutocomplete", ()=>_SearchAutocomplete);
var _utils = require("@react-spectrum/utils");
var _button = require("@react-spectrum/button");
var _label = require("@react-spectrum/label");
var _utils1 = require("@react-aria/utils");
var _focus = require("@react-aria/focus");
// @ts-ignore
var _json = require("../intl/*.json");
var _jsonDefault = parcelHelpers.interopDefault(_json);
var _listbox = require("@react-spectrum/listbox");
var _magnifier = require("@spectrum-icons/ui/Magnifier");
var _magnifierDefault = parcelHelpers.interopDefault(_magnifier);
var _mobileSearchAutocomplete = require("./MobileSearchAutocomplete");
var _overlays = require("@react-spectrum/overlays");
var _progress = require("@react-spectrum/progress");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _searchautocompleteCss = require("./searchautocomplete.css");
var _searchautocompleteCssDefault = parcelHelpers.interopDefault(_searchautocompleteCss);
var _varsCss = require("@adobe/spectrum-css-temp/components/search/vars.css");
var _varsCssDefault = parcelHelpers.interopDefault(_varsCss);
var _varsCss1 = require("@adobe/spectrum-css-temp/components/inputgroup/vars.css");
var _varsCssDefault1 = parcelHelpers.interopDefault(_varsCss1);
var _textfield = require("@react-spectrum/textfield");
var _varsCss2 = require("@adobe/spectrum-css-temp/components/textfield/vars.css");
var _varsCssDefault2 = parcelHelpers.interopDefault(_varsCss2);
var _combobox = require("@react-stately/combobox");
var _i18N = require("@react-aria/i18n");
var _form = require("@react-spectrum/form");
var _interactions = require("@react-aria/interactions");
var _provider = require("@react-spectrum/provider");
var _autocomplete = require("@react-aria/autocomplete");
function SearchAutocomplete(props, ref) {
    props = (0, _provider.useProviderProps)(props);
    props = (0, _form.useFormProps)(props);
    if (props.placeholder) console.warn("Placeholders are deprecated due to accessibility issues. Please use help text instead.");
    let isMobile = (0, _utils.useIsMobileDevice)();
    if (isMobile) // menuTrigger=focus/manual don't apply to mobile searchwithin
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _mobileSearchAutocomplete.MobileSearchAutocomplete), {
        ...props,
        menuTrigger: "input",
        ref: ref
    });
    else return /*#__PURE__*/ (0, _reactDefault.default).createElement(SearchAutocompleteBase, {
        ...props,
        ref: ref
    });
}
function _SearchAutocompleteBase(props, ref) {
    props = (0, _provider.useProviderProps)(props);
    let { menuTrigger = "input", shouldFlip = true, direction = "bottom", align = "start", isQuiet, menuWidth: customMenuWidth, loadingState, onLoadMore, onSubmit = ()=>{}, validate } = props;
    let stringFormatter = (0, _i18N.useLocalizedStringFormatter)((0, _jsonDefault.default), "@react-spectrum/autocomplete");
    let isAsync = loadingState != null;
    let popoverRef = (0, _react.useRef)(null);
    let unwrappedPopoverRef = (0, _utils.useUnwrapDOMRef)(popoverRef);
    let listBoxRef = (0, _react.useRef)(null);
    let inputRef = (0, _react.useRef)(null);
    let domRef = (0, _utils.useFocusableRef)(ref, inputRef);
    let { contains } = (0, _i18N.useFilter)({
        sensitivity: "base"
    });
    let state = (0, _combobox.useComboBoxState)({
        ...props,
        defaultFilter: contains,
        allowsEmptyCollection: isAsync,
        allowsCustomValue: true,
        onSelectionChange: (key)=>key !== null && onSubmit(null, key),
        selectedKey: undefined,
        defaultSelectedKey: undefined,
        validate: (0, _react.useCallback)((v)=>validate === null || validate === void 0 ? void 0 : validate(v.inputValue), [
            validate
        ])
    });
    let layout = (0, _listbox.useListBoxLayout)(state, loadingState === "loadingMore");
    let { inputProps, listBoxProps, labelProps, clearButtonProps, descriptionProps, errorMessageProps, isInvalid, validationErrors, validationDetails } = (0, _autocomplete.useSearchAutocomplete)({
        ...props,
        keyboardDelegate: layout,
        popoverRef: unwrappedPopoverRef,
        listBoxRef,
        inputRef,
        menuTrigger
    }, state);
    // Measure the width of the inputfield to inform the width of the menu (below).
    let [menuWidth, setMenuWidth] = (0, _react.useState)(0);
    let { scale } = (0, _provider.useProvider)();
    let onResize = (0, _react.useCallback)(()=>{
        if (inputRef.current) {
            let inputWidth = inputRef.current.offsetWidth;
            setMenuWidth(inputWidth);
        }
    }, [
        inputRef,
        setMenuWidth
    ]);
    (0, _utils.useResizeObserver)({
        ref: domRef,
        onResize: onResize
    });
    (0, _utils1.useLayoutEffect)(onResize, [
        scale,
        onResize
    ]);
    let width = isQuiet ? undefined : menuWidth;
    let style = {
        width: customMenuWidth ? (0, _utils.dimensionValue)(customMenuWidth) : width,
        minWidth: isQuiet ? `calc(${menuWidth}px + calc(2 * var(--spectrum-dropdown-quiet-offset)))` : menuWidth
    };
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _label.Field), {
        ...props,
        descriptionProps: descriptionProps,
        errorMessageProps: errorMessageProps,
        labelProps: labelProps,
        isInvalid: isInvalid,
        validationErrors: validationErrors,
        validationDetails: validationDetails,
        ref: domRef
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(SearchAutocompleteInput, {
        ...props,
        isOpen: state.isOpen,
        loadingState: loadingState,
        inputProps: inputProps,
        inputRef: inputRef,
        clearButtonProps: clearButtonProps,
        validationState: props.validationState || (isInvalid ? "invalid" : undefined)
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _overlays.Popover), {
        state: state,
        UNSAFE_style: style,
        UNSAFE_className: (0, _utils.classNames)((0, _varsCssDefault1.default), "spectrum-InputGroup-popover", {
            "spectrum-InputGroup-popover--quiet": isQuiet
        }),
        ref: popoverRef,
        triggerRef: inputRef,
        placement: `${direction} ${align}`,
        hideArrow: true,
        isNonModal: true,
        shouldFlip: shouldFlip
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _listbox.ListBoxBase), {
        ...listBoxProps,
        ref: listBoxRef,
        disallowEmptySelection: true,
        autoFocus: state.focusStrategy,
        shouldSelectOnPressUp: true,
        focusOnPointerEnter: true,
        layout: layout,
        state: state,
        shouldUseVirtualFocus: true,
        isLoading: loadingState === "loading" || loadingState === "loadingMore",
        onLoadMore: onLoadMore,
        renderEmptyState: ()=>isAsync && /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
                className: (0, _utils.classNames)((0, _searchautocompleteCssDefault.default), "no-results")
            }, stringFormatter.format("noResults"))
    })));
}
let SearchAutocompleteBase = /*#__PURE__*/ (0, _reactDefault.default).forwardRef(_SearchAutocompleteBase);
// any type is because we don't want to call useObjectRef because this is an internal component and we know
// we are always passing an object ref
function _SearchAutocompleteInput(props, ref) {
    let searchIcon = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _magnifierDefault.default), {
        "data-testid": "searchicon"
    });
    let { icon = searchIcon, isQuiet, isDisabled, isReadOnly, validationState, inputProps, inputRef, autoFocus, style, className, loadingState, isOpen, menuTrigger, clearButtonProps } = props;
    let { hoverProps, isHovered } = (0, _interactions.useHover)({});
    let stringFormatter = (0, _i18N.useLocalizedStringFormatter)((0, _jsonDefault.default), "@react-spectrum/autocomplete");
    let domProps = (0, _utils1.filterDOMProps)(props);
    let timeout = (0, _react.useRef)(null);
    let [showLoading, setShowLoading] = (0, _react.useState)(false);
    let loadingCircle = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _progress.ProgressCircle), {
        "aria-label": stringFormatter.format("loading"),
        size: "S",
        isIndeterminate: true,
        UNSAFE_className: (0, _utils.classNames)((0, _varsCssDefault2.default), "spectrum-Textfield-circleLoader", (0, _utils.classNames)((0, _varsCssDefault1.default), "spectrum-InputGroup-input-circleLoader"), (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Search-circleLoader"))
    });
    let clearButton = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ClearButton), {
        ...clearButtonProps,
        preventFocus: true,
        UNSAFE_className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-ClearButton"),
        isDisabled: isDisabled
    });
    let isLoading = loadingState === "loading" || loadingState === "filtering";
    let inputValue = inputProps.value;
    let lastInputValue = (0, _react.useRef)(inputValue);
    (0, _react.useEffect)(()=>{
        if (isLoading && !showLoading) {
            if (timeout.current === null) timeout.current = setTimeout(()=>{
                setShowLoading(true);
            }, 500);
            // If user is typing, clear the timer and restart since it is a new request
            if (inputValue !== lastInputValue.current) {
                clearTimeout(timeout.current);
                timeout.current = setTimeout(()=>{
                    setShowLoading(true);
                }, 500);
            }
        } else if (!isLoading) {
            // If loading is no longer happening, clear any timers and hide the loading circle
            setShowLoading(false);
            if (timeout.current != null) {
                clearTimeout(timeout.current);
                timeout.current = null;
            }
        }
        lastInputValue.current = inputValue;
    }, [
        isLoading,
        showLoading,
        inputValue
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _focus.FocusRing), {
        within: true,
        isTextInput: true,
        focusClass: (0, _utils.classNames)((0, _varsCssDefault1.default), "is-focused"),
        focusRingClass: (0, _utils.classNames)((0, _varsCssDefault1.default), "focus-ring"),
        autoFocus: autoFocus
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...hoverProps,
        ref: ref,
        style: style,
        className: (0, _utils.classNames)((0, _varsCssDefault1.default), "spectrum-InputGroup", {
            "spectrum-InputGroup--quiet": isQuiet,
            "is-disabled": isDisabled,
            "spectrum-InputGroup--invalid": validationState === "invalid" && !isDisabled,
            "is-hovered": isHovered
        }, (0, _utils.classNames)((0, _searchautocompleteCssDefault.default), "searchautocomplete"), className)
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textfield.TextFieldBase), {
        ...domProps,
        inputProps: inputProps,
        inputRef: inputRef,
        UNSAFE_className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Search", "spectrum-Search--loadable", "spectrum-Textfield", {
            "is-disabled": isDisabled,
            "is-quiet": isQuiet,
            "spectrum-Search--invalid": validationState === "invalid" && !isDisabled,
            "spectrum-Search--valid": validationState === "valid" && !isDisabled
        }, (0, _utils.classNames)((0, _varsCssDefault1.default), "spectrum-InputGroup-field")),
        inputClassName: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Search-input"),
        validationIconClassName: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Search-validationIcon"),
        isDisabled: isDisabled,
        isQuiet: isQuiet,
        validationState: validationState,
        isLoading: showLoading && (isOpen || menuTrigger === "manual" || loadingState === "loading"),
        loadingIndicator: loadingState != null ? loadingCircle : undefined,
        icon: icon,
        wrapperChildren: (inputValue !== "" || loadingState === "filtering" || validationState != null) && !isReadOnly ? clearButton : undefined,
        disableFocusRing: true
    })));
}
let SearchAutocompleteInput = /*#__PURE__*/ (0, _reactDefault.default).forwardRef(_SearchAutocompleteInput);
/**
 * A SearchAutocomplete is a searchfield that supports a dynamic list of suggestions.
 */ let _SearchAutocomplete = /*#__PURE__*/ (0, _react.forwardRef)(SearchAutocomplete);

},{"@react-spectrum/utils":"cMIJ6","@react-spectrum/button":"jZWyP","@react-spectrum/label":"6qv6N","@react-aria/utils":"9cLk5","@react-aria/focus":"42mbF","../intl/*.json":"3Ike1","@react-spectrum/listbox":"kF7kO","@spectrum-icons/ui/Magnifier":"fLimS","./MobileSearchAutocomplete":"ehKio","@react-spectrum/overlays":"3nwGn","@react-spectrum/progress":"4kHa7","react":"9yzVZ","./searchautocomplete.css":"1e8HE","@adobe/spectrum-css-temp/components/search/vars.css":"1Ppz4","@adobe/spectrum-css-temp/components/inputgroup/vars.css":"fZm3Z","@react-spectrum/textfield":"hOmtq","@adobe/spectrum-css-temp/components/textfield/vars.css":"c3yAu","@react-stately/combobox":"j3BhU","@react-aria/i18n":"411rg","@react-spectrum/form":"bGDqA","@react-aria/interactions":"ky3G8","@react-spectrum/provider":"5bCdp","@react-aria/autocomplete":"7AJGo","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"3Ike1":[function(require,module,exports) {
const _temp0 = require("c4074e17b26aa195");
const _temp1 = require("a66884e03d86f822");
const _temp2 = require("f078930cd73eb891");
const _temp3 = require("59c8c904b3962939");
const _temp4 = require("d0ff317abfdda3c4");
const _temp5 = require("718d1cc2f56ec069");
const _temp6 = require("2c757b105a8e42ec");
const _temp7 = require("b207172d83a7eed0");
const _temp8 = require("fc4d2a985524fa7e");
const _temp9 = require("63568f24258319b0");
const _temp10 = require("5470a3f8a886a48f");
const _temp11 = require("86cd4463ef6ac866");
const _temp12 = require("d93ed8008a9e36db");
const _temp13 = require("48169fa01e20bb46");
const _temp14 = require("219f6cf77e23fd8d");
const _temp15 = require("caddd23751a5d95c");
const _temp16 = require("ba1578b024ce8060");
const _temp17 = require("659696b95c7e4a52");
const _temp18 = require("4ca450319a7dea9c");
const _temp19 = require("5b0c5bfab91bdacd");
const _temp20 = require("6e62848838989ce7");
const _temp21 = require("6188019fe18d1962");
const _temp22 = require("efd4227cf95b49bd");
const _temp23 = require("b8aab34cad8f5573");
const _temp24 = require("296ddb5b8fa29490");
const _temp25 = require("200d551e7002db8d");
const _temp26 = require("cd721f764765fc51");
const _temp27 = require("43db2a1429c76a86");
const _temp28 = require("9328971d2a9eccb0");
const _temp29 = require("5c1867cd0211a18c");
const _temp30 = require("c0609b04f8df8f6d");
const _temp31 = require("90747a5cca36b88e");
const _temp32 = require("1459f15b944c25f9");
const _temp33 = require("7e84297b0d8aa786");
module.exports = {
    "ar-AE": _temp0,
    "bg-BG": _temp1,
    "cs-CZ": _temp2,
    "da-DK": _temp3,
    "de-DE": _temp4,
    "el-GR": _temp5,
    "en-US": _temp6,
    "es-ES": _temp7,
    "et-EE": _temp8,
    "fi-FI": _temp9,
    "fr-FR": _temp10,
    "he-IL": _temp11,
    "hr-HR": _temp12,
    "hu-HU": _temp13,
    "it-IT": _temp14,
    "ja-JP": _temp15,
    "ko-KR": _temp16,
    "lt-LT": _temp17,
    "lv-LV": _temp18,
    "nb-NO": _temp19,
    "nl-NL": _temp20,
    "pl-PL": _temp21,
    "pt-BR": _temp22,
    "pt-PT": _temp23,
    "ro-RO": _temp24,
    "ru-RU": _temp25,
    "sk-SK": _temp26,
    "sl-SI": _temp27,
    "sr-SP": _temp28,
    "sv-SE": _temp29,
    "tr-TR": _temp30,
    "uk-UA": _temp31,
    "zh-CN": _temp32,
    "zh-TW": _temp33
};

},{"c4074e17b26aa195":"69ALq","a66884e03d86f822":"1EDUJ","f078930cd73eb891":"lWEkZ","59c8c904b3962939":"31d0h","d0ff317abfdda3c4":"ksYKI","718d1cc2f56ec069":"kJrSn","2c757b105a8e42ec":"a8Yka","b207172d83a7eed0":"6YoGF","fc4d2a985524fa7e":"fwZxI","63568f24258319b0":"5hK9y","5470a3f8a886a48f":"1X5no","86cd4463ef6ac866":"9FN89","d93ed8008a9e36db":"fzcC7","48169fa01e20bb46":"c9WEH","219f6cf77e23fd8d":"2wirW","caddd23751a5d95c":"f505m","ba1578b024ce8060":"60oSC","659696b95c7e4a52":"8RxRM","4ca450319a7dea9c":"i1yoR","5b0c5bfab91bdacd":"e9QGW","6e62848838989ce7":"3XM4J","6188019fe18d1962":"kKLGd","efd4227cf95b49bd":"iqONk","b8aab34cad8f5573":"aNjSQ","296ddb5b8fa29490":"hTF1s","200d551e7002db8d":"2srLI","cd721f764765fc51":"fyul5","43db2a1429c76a86":"izb8i","9328971d2a9eccb0":"dWqmo","5c1867cd0211a18c":"bCAYn","c0609b04f8df8f6d":"g8HEx","90747a5cca36b88e":"cpix3","1459f15b944c25f9":"j4FFw","7e84297b0d8aa786":"bCI7Q"}],"69ALq":[function(require,module,exports) {
module.exports = {
    "clear": `\u{645}\u{633}\u{62D}`,
    "invalid": `(\u{63A}\u{64A}\u{631} \u{635}\u{627}\u{644}\u{62D})`,
    "loading": `\u{62C}\u{627}\u{631}\u{64D} \u{627}\u{644}\u{62A}\u{62D}\u{645}\u{64A}\u{644}...`,
    "noResults": `\u{644}\u{627} \u{62A}\u{648}\u{62C}\u{62F} \u{646}\u{62A}\u{627}\u{626}\u{62C}`
};

},{}],"1EDUJ":[function(require,module,exports) {
module.exports = {
    "clear": `\u{418}\u{437}\u{447}\u{438}\u{441}\u{442}\u{438}`,
    "invalid": `(\u{43D}\u{435}\u{432}\u{430}\u{43B}\u{438}\u{434}\u{435}\u{43D})`,
    "loading": `\u{417}\u{430}\u{440}\u{435}\u{436}\u{434}\u{430}\u{43D}\u{435}...`,
    "noResults": `\u{41D}\u{44F}\u{43C}\u{430} \u{440}\u{435}\u{437}\u{443}\u{43B}\u{442}\u{430}\u{442}\u{438}`
};

},{}],"lWEkZ":[function(require,module,exports) {
module.exports = {
    "clear": `Vymazat`,
    "invalid": `(neplatn\xe9)`,
    "loading": `Na\u{10D}\xedt\xe1n\xed...`,
    "noResults": `\u{17D}\xe1dn\xe9 v\xfdsledky`
};

},{}],"31d0h":[function(require,module,exports) {
module.exports = {
    "clear": `Ryd`,
    "invalid": `(ugyldig)`,
    "loading": `Indl\xe6ser...`,
    "noResults": `Ingen resultater`
};

},{}],"ksYKI":[function(require,module,exports) {
module.exports = {
    "clear": `L\xf6schen`,
    "invalid": `(ung\xfcltig)`,
    "loading": `Wird geladen...`,
    "noResults": `Keine Ergebnisse`
};

},{}],"kJrSn":[function(require,module,exports) {
module.exports = {
    "clear": `\u{39A}\u{3B1}\u{3B8}\u{3B1}\u{3C1}\u{3B9}\u{3C3}\u{3BC}\u{3CC}\u{3C2}`,
    "invalid": `(\u{3B4}\u{3B5}\u{3BD} \u{3B9}\u{3C3}\u{3C7}\u{3CD}\u{3B5}\u{3B9})`,
    "loading": `\u{3A6}\u{3CC}\u{3C1}\u{3C4}\u{3C9}\u{3C3}\u{3B7}...`,
    "noResults": `\u{3A7}\u{3C9}\u{3C1}\u{3AF}\u{3C2} \u{3B1}\u{3C0}\u{3BF}\u{3C4}\u{3AD}\u{3BB}\u{3B5}\u{3C3}\u{3BC}\u{3B1}`
};

},{}],"a8Yka":[function(require,module,exports) {
module.exports = {
    "loading": `Loading...`,
    "noResults": `No results`,
    "clear": `Clear`,
    "invalid": `(invalid)`
};

},{}],"6YoGF":[function(require,module,exports) {
module.exports = {
    "clear": `Borrar`,
    "invalid": `(no v\xe1lido)`,
    "loading": `Cargando\u{2026}`,
    "noResults": `Sin resultados`
};

},{}],"fwZxI":[function(require,module,exports) {
module.exports = {
    "clear": `Kustuta`,
    "invalid": `(kehtetu)`,
    "loading": `Laadimine...`,
    "noResults": `Tulemusi pole`
};

},{}],"5hK9y":[function(require,module,exports) {
module.exports = {
    "clear": `Kirkas`,
    "invalid": `(ep\xe4kelpo)`,
    "loading": `Ladataan...`,
    "noResults": `Ei tuloksia`
};

},{}],"1X5no":[function(require,module,exports) {
module.exports = {
    "clear": `Effacer`,
    "invalid": `(non valide)`,
    "loading": `Chargement en cours\u{2026}`,
    "noResults": `Aucun r\xe9sultat`
};

},{}],"9FN89":[function(require,module,exports) {
module.exports = {
    "clear": `\u{5E0}\u{5E7}\u{5D4}`,
    "invalid": `(\u{5DC}\u{5D0} \u{5D7}\u{5D5}\u{5E7}\u{5D9})`,
    "loading": `\u{5D8}\u{5D5}\u{5E2}\u{5DF}...`,
    "noResults": `\u{5D0}\u{5D9}\u{5DF} \u{5EA}\u{5D5}\u{5E6}\u{5D0}\u{5D5}\u{5EA}`
};

},{}],"fzcC7":[function(require,module,exports) {
module.exports = {
    "clear": `Izbri\u{161}i`,
    "invalid": `(neva\u{17E}e\u{107}e)`,
    "loading": `U\u{10D}itavam...`,
    "noResults": `Nema rezultata`
};

},{}],"c9WEH":[function(require,module,exports) {
module.exports = {
    "clear": `T\xf6rl\xe9s`,
    "invalid": `(\xe9rv\xe9nytelen)`,
    "loading": `Bet\xf6lt\xe9s folyamatban\u{2026}`,
    "noResults": `Nincsenek tal\xe1latok`
};

},{}],"2wirW":[function(require,module,exports) {
module.exports = {
    "clear": `Cancella`,
    "invalid": `(non valido)`,
    "loading": `Caricamento...`,
    "noResults": `Nessun risultato`
};

},{}],"f505m":[function(require,module,exports) {
module.exports = {
    "clear": `\u{30AF}\u{30EA}\u{30A2}`,
    "invalid": `(\u{7121}\u{52B9})`,
    "loading": `\u{8AAD}\u{307F}\u{8FBC}\u{307F}\u{4E2D}...`,
    "noResults": `\u{7D50}\u{679C}\u{306A}\u{3057}`
};

},{}],"60oSC":[function(require,module,exports) {
module.exports = {
    "clear": `\u{C9C0}\u{C6B0}\u{AE30}`,
    "invalid": `(\u{C720}\u{D6A8}\u{D558}\u{C9C0} \u{C54A}\u{C74C})`,
    "loading": `\u{B85C}\u{B4DC} \u{C911}...`,
    "noResults": `\u{ACB0}\u{ACFC} \u{C5C6}\u{C74C}`
};

},{}],"8RxRM":[function(require,module,exports) {
module.exports = {
    "clear": `I\u{161}valyti`,
    "invalid": `(netinkama)`,
    "loading": `\u{12E}keliama...`,
    "noResults": `Rezultat\u{173} n\u{117}ra`
};

},{}],"i1yoR":[function(require,module,exports) {
module.exports = {
    "clear": `Not\u{12B}r\u{12B}t`,
    "invalid": `(neder\u{12B}gs)`,
    "loading": `Notiek iel\u{101}de...`,
    "noResults": `Nav rezult\u{101}tu`
};

},{}],"e9QGW":[function(require,module,exports) {
module.exports = {
    "clear": `T\xf8m`,
    "invalid": `(ugyldig)`,
    "loading": `Laster inn...`,
    "noResults": `Ingen resultater`
};

},{}],"3XM4J":[function(require,module,exports) {
module.exports = {
    "clear": `Wissen`,
    "invalid": `(ongeldig)`,
    "loading": `Laden...`,
    "noResults": `Geen resultaten`
};

},{}],"kKLGd":[function(require,module,exports) {
module.exports = {
    "clear": `Wyczy\u{15B}\u{107}`,
    "invalid": `(nieprawid\u{142}owy)`,
    "loading": `Wczytywanie...`,
    "noResults": `Brak wynik\xf3w`
};

},{}],"iqONk":[function(require,module,exports) {
module.exports = {
    "clear": `Limpar`,
    "invalid": `(inv\xe1lido)`,
    "loading": `Carregando...`,
    "noResults": `Nenhum resultado`
};

},{}],"aNjSQ":[function(require,module,exports) {
module.exports = {
    "clear": `Limpar`,
    "invalid": `(inv\xe1lido)`,
    "loading": `A carregar...`,
    "noResults": `Sem resultados`
};

},{}],"hTF1s":[function(require,module,exports) {
module.exports = {
    "clear": `Golire`,
    "invalid": `(nevalid)`,
    "loading": `Se \xeencarc\u{103}...`,
    "noResults": `Niciun rezultat`
};

},{}],"2srLI":[function(require,module,exports) {
module.exports = {
    "clear": `\u{41E}\u{447}\u{438}\u{441}\u{442}\u{438}\u{442}\u{44C}`,
    "invalid": `(\u{43D}\u{435}\u{434}\u{435}\u{439}\u{441}\u{442}\u{432}\u{438}\u{442}\u{435}\u{43B}\u{44C}\u{43D}\u{43E})`,
    "loading": `\u{417}\u{430}\u{433}\u{440}\u{443}\u{437}\u{43A}\u{430}...`,
    "noResults": `\u{420}\u{435}\u{437}\u{443}\u{43B}\u{44C}\u{442}\u{430}\u{442}\u{44B} \u{43E}\u{442}\u{441}\u{443}\u{442}\u{441}\u{442}\u{432}\u{443}\u{44E}\u{442}`
};

},{}],"fyul5":[function(require,module,exports) {
module.exports = {
    "clear": `Vymaza\u{165}`,
    "invalid": `(neplatn\xe9)`,
    "loading": `Na\u{10D}\xedtava sa...`,
    "noResults": `\u{17D}iadne v\xfdsledky`
};

},{}],"izb8i":[function(require,module,exports) {
module.exports = {
    "clear": `Pobri\u{161}ite`,
    "invalid": `(neveljavno)`,
    "loading": `Nalaganje...`,
    "noResults": `Ni rezultatov`
};

},{}],"dWqmo":[function(require,module,exports) {
module.exports = {
    "clear": `Izbri\u{161}i`,
    "invalid": `(neva\u{17E}e\u{107}e)`,
    "loading": `U\u{10D}itavam...`,
    "noResults": `Nema rezultata`
};

},{}],"bCAYn":[function(require,module,exports) {
module.exports = {
    "clear": `Rensa`,
    "invalid": `(ogiltigt)`,
    "loading": `L\xe4ser in...`,
    "noResults": `Inga resultat`
};

},{}],"g8HEx":[function(require,module,exports) {
module.exports = {
    "clear": `Temizle`,
    "invalid": `(ge\xe7ersiz)`,
    "loading": `Y\xfckleniyor...`,
    "noResults": `Sonu\xe7 yok`
};

},{}],"cpix3":[function(require,module,exports) {
module.exports = {
    "clear": `\u{41E}\u{447}\u{438}\u{441}\u{442}\u{438}\u{442}\u{438}`,
    "invalid": `(\u{43D}\u{435}\u{434}\u{456}\u{439}\u{441}\u{43D}\u{435})`,
    "loading": `\u{417}\u{430}\u{432}\u{430}\u{43D}\u{442}\u{430}\u{436}\u{435}\u{43D}\u{43D}\u{44F}...`,
    "noResults": `\u{420}\u{435}\u{437}\u{443}\u{43B}\u{44C}\u{442}\u{430}\u{442}\u{456}\u{432} \u{43D}\u{435}\u{43C}\u{430}\u{454}`
};

},{}],"j4FFw":[function(require,module,exports) {
module.exports = {
    "clear": `\u{6E05}\u{9664}`,
    "invalid": `\u{FF08}\u{65E0}\u{6548}\u{FF09}`,
    "loading": `\u{6B63}\u{5728}\u{52A0}\u{8F7D}...`,
    "noResults": `\u{65E0}\u{7ED3}\u{679C}`
};

},{}],"bCI7Q":[function(require,module,exports) {
module.exports = {
    "clear": `\u{6E05}\u{9664}`,
    "invalid": `(\u{7121}\u{6548})`,
    "loading": `\u{6B63}\u{5728}\u{8F09}\u{5165}...`,
    "noResults": `\u{7121}\u{4EFB}\u{4F55}\u{7D50}\u{679C}`
};

},{}],"kF7kO":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /// <reference types="css-module-types" />
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ListBox", ()=>(0, _listBox.ListBox));
parcelHelpers.export(exports, "useListBoxLayout", ()=>(0, _listBoxBase.useListBoxLayout));
parcelHelpers.export(exports, "ListBoxBase", ()=>(0, _listBoxBase.ListBoxBase));
parcelHelpers.export(exports, "Item", ()=>(0, _collections.Item));
parcelHelpers.export(exports, "Section", ()=>(0, _collections.Section));
var _listBox = require("./ListBox");
var _listBoxBase = require("./ListBoxBase");
var _collections = require("@react-stately/collections");

},{"./ListBox":"cJ1vW","./ListBoxBase":"3cKt7","@react-stately/collections":"loANi","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"cJ1vW":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ListBox", ()=>_ListBox);
var _listBoxBase = require("./ListBoxBase");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _utils = require("@react-spectrum/utils");
var _list = require("@react-stately/list");
function ListBox(props, ref) {
    let state = (0, _list.useListState)(props);
    let layout = (0, _listBoxBase.useListBoxLayout)(state, props.isLoading);
    let domRef = (0, _utils.useDOMRef)(ref);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _listBoxBase.ListBoxBase), {
        ...props,
        ref: domRef,
        state: state,
        layout: layout
    });
}
// forwardRef doesn't support generic parameters, so cast the result to the correct type
// https://stackoverflow.com/questions/58469229/react-with-typescript-generics-while-using-react-forwardref
/**
 * A list of options that can allow selection of one or more.
 */ const _ListBox = /*#__PURE__*/ (0, _reactDefault.default).forwardRef(ListBox);

},{"./ListBoxBase":"3cKt7","react":"9yzVZ","@react-spectrum/utils":"cMIJ6","@react-stately/list":"Cp0zP","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"3cKt7":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/** @private */ parcelHelpers.export(exports, "useListBoxLayout", ()=>useListBoxLayout);
parcelHelpers.export(exports, "ListBoxBase", ()=>_ListBoxBase);
var _listbox = require("@react-aria/listbox");
var _utils = require("@react-spectrum/utils");
var _focus = require("@react-aria/focus");
// @ts-ignore
var _json = require("../intl/*.json");
var _jsonDefault = parcelHelpers.interopDefault(_json);
var _listBoxContext = require("./ListBoxContext");
var _listBoxOption = require("./ListBoxOption");
var _listBoxSection = require("./ListBoxSection");
var _layout = require("@react-stately/layout");
var _utils1 = require("@react-aria/utils");
var _progress = require("@react-spectrum/progress");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _varsCss = require("@adobe/spectrum-css-temp/components/menu/vars.css");
var _varsCssDefault = parcelHelpers.interopDefault(_varsCss);
var _i18N = require("@react-aria/i18n");
var _provider = require("@react-spectrum/provider");
var _virtualizer = require("@react-aria/virtualizer");
function useListBoxLayout(state, isLoading) {
    let { scale } = (0, _provider.useProvider)();
    let collator = (0, _i18N.useCollator)({
        usage: "search",
        sensitivity: "base"
    });
    let layout = (0, _react.useMemo)(()=>new (0, _layout.ListLayout)({
            estimatedRowHeight: scale === "large" ? 48 : 32,
            estimatedHeadingHeight: scale === "large" ? 33 : 26,
            padding: scale === "large" ? 5 : 4,
            loaderHeight: 40,
            placeholderHeight: scale === "large" ? 48 : 32,
            collator
        }), [
        collator,
        scale
    ]);
    layout.collection = state.collection;
    layout.disabledKeys = state.disabledKeys;
    (0, _utils1.useLayoutEffect)(()=>{
        // Sync loading state into the layout.
        if (layout.isLoading !== isLoading) {
            var _layout_virtualizer;
            layout.isLoading = isLoading;
            (_layout_virtualizer = layout.virtualizer) === null || _layout_virtualizer === void 0 ? void 0 : _layout_virtualizer.relayoutNow();
        }
    }, [
        layout,
        isLoading
    ]);
    return layout;
}
/** @private */ function ListBoxBase(props, ref) {
    let { layout, state, shouldSelectOnPressUp, focusOnPointerEnter, shouldUseVirtualFocus, domProps = {}, transitionDuration = 0, onScroll } = props;
    let { listBoxProps } = (0, _listbox.useListBox)({
        ...props,
        keyboardDelegate: layout,
        isVirtualized: true
    }, state, ref);
    let { styleProps } = (0, _utils.useStyleProps)(props);
    let stringFormatter = (0, _i18N.useLocalizedStringFormatter)((0, _jsonDefault.default), "@react-spectrum/listbox");
    let renderWrapper = (parent, reusableView, children, renderChildren)=>{
        if (reusableView.viewType === "section") return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _listBoxSection.ListBoxSection), {
            key: reusableView.key,
            item: reusableView.content,
            layoutInfo: reusableView.layoutInfo,
            virtualizer: reusableView.virtualizer,
            headerLayoutInfo: children.find((c)=>c.viewType === "header").layoutInfo
        }, renderChildren(children.filter((c)=>c.viewType === "item")));
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _virtualizer.VirtualizerItem), {
            key: reusableView.key,
            layoutInfo: reusableView.layoutInfo,
            virtualizer: reusableView.virtualizer,
            parent: parent === null || parent === void 0 ? void 0 : parent.layoutInfo
        }, reusableView.rendered);
    };
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _listBoxContext.ListBoxContext).Provider, {
        value: state
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _focus.FocusScope), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _virtualizer.Virtualizer), {
        ...styleProps,
        ...(0, _utils1.mergeProps)(listBoxProps, domProps),
        ref: ref,
        focusedKey: state.selectionManager.focusedKey,
        autoFocus: !!props.autoFocus,
        sizeToFit: "height",
        scrollDirection: "vertical",
        className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Menu", styleProps.className),
        layout: layout,
        collection: state.collection,
        renderWrapper: renderWrapper,
        transitionDuration: transitionDuration,
        isLoading: props.isLoading,
        onLoadMore: props.onLoadMore,
        shouldUseVirtualFocus: shouldUseVirtualFocus,
        onScroll: onScroll
    }, (type, item)=>{
        if (type === "item") return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _listBoxOption.ListBoxOption), {
            item: item,
            shouldSelectOnPressUp: shouldSelectOnPressUp,
            shouldFocusOnHover: focusOnPointerEnter,
            shouldUseVirtualFocus: shouldUseVirtualFocus
        });
        else if (type === "loader") return(// aria-selected isn't needed here since this option is not selectable.
        // eslint-disable-next-line jsx-a11y/role-has-required-aria-props
        /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
            role: "option",
            style: {
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                height: "100%"
            }
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _progress.ProgressCircle), {
            isIndeterminate: true,
            size: "S",
            "aria-label": state.collection.size > 0 ? stringFormatter.format("loadingMore") : stringFormatter.format("loading"),
            UNSAFE_className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Dropdown-progressCircle")
        })));
        else if (type === "placeholder") {
            let emptyState = props.renderEmptyState ? props.renderEmptyState() : null;
            if (emptyState == null) return null;
            return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
                // aria-selected isn't needed here since this option is not selectable.
                // eslint-disable-next-line jsx-a11y/role-has-required-aria-props
                role: "option"
            }, emptyState);
        }
    })));
}
// forwardRef doesn't support generic parameters, so cast the result to the correct type
// https://stackoverflow.com/questions/58469229/react-with-typescript-generics-while-using-react-forwardref
const _ListBoxBase = /*#__PURE__*/ (0, _reactDefault.default).forwardRef(ListBoxBase);

},{"@react-aria/listbox":"bHZSJ","@react-spectrum/utils":"cMIJ6","@react-aria/focus":"42mbF","../intl/*.json":"6LfWi","./ListBoxContext":"jPnu6","./ListBoxOption":"k9zDq","./ListBoxSection":"5OYn7","@react-stately/layout":"6Mwz5","@react-aria/utils":"9cLk5","@react-spectrum/progress":"4kHa7","react":"9yzVZ","@adobe/spectrum-css-temp/components/menu/vars.css":"gqElf","@react-aria/i18n":"411rg","@react-spectrum/provider":"5bCdp","@react-aria/virtualizer":"gAPsK","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"6LfWi":[function(require,module,exports) {
const _temp0 = require("e071b2523c8f0b4f");
const _temp1 = require("b366ff82efdfb25");
const _temp2 = require("590481e11b2d0e35");
const _temp3 = require("439c07b4d02328fd");
const _temp4 = require("49fac98605cabc94");
const _temp5 = require("385bd2742b947f58");
const _temp6 = require("7483b8412f02872");
const _temp7 = require("9357c54fdd7af6ee");
const _temp8 = require("c6348f3243d4b68e");
const _temp9 = require("37a68086405238d4");
const _temp10 = require("8add74b43f73d458");
const _temp11 = require("b5bca72854b82fa2");
const _temp12 = require("2a50fd1f859f5e31");
const _temp13 = require("676d0298627a908a");
const _temp14 = require("b528119da684edd0");
const _temp15 = require("b00b8df77193044b");
const _temp16 = require("b6e108f3f3cfff56");
const _temp17 = require("e46ab69b0953afbe");
const _temp18 = require("3d82f8c9e904717f");
const _temp19 = require("56b361041bf30e17");
const _temp20 = require("cb598eb2b7d1a7f7");
const _temp21 = require("7a34fde1e4705571");
const _temp22 = require("d52613ca06dc0512");
const _temp23 = require("51f120a8e805a5c7");
const _temp24 = require("1c10facf267849b5");
const _temp25 = require("e2f92056ce7f5bf9");
const _temp26 = require("c845ac3e223f4543");
const _temp27 = require("28268d818d55f6ff");
const _temp28 = require("87695363fcecdf94");
const _temp29 = require("a836f3f13ae433f9");
const _temp30 = require("4fa725fe6617ccdd");
const _temp31 = require("5d9e0d54c9073d16");
const _temp32 = require("a2b533d7512e8605");
const _temp33 = require("a877f7460370f708");
module.exports = {
    "ar-AE": _temp0,
    "bg-BG": _temp1,
    "cs-CZ": _temp2,
    "da-DK": _temp3,
    "de-DE": _temp4,
    "el-GR": _temp5,
    "en-US": _temp6,
    "es-ES": _temp7,
    "et-EE": _temp8,
    "fi-FI": _temp9,
    "fr-FR": _temp10,
    "he-IL": _temp11,
    "hr-HR": _temp12,
    "hu-HU": _temp13,
    "it-IT": _temp14,
    "ja-JP": _temp15,
    "ko-KR": _temp16,
    "lt-LT": _temp17,
    "lv-LV": _temp18,
    "nb-NO": _temp19,
    "nl-NL": _temp20,
    "pl-PL": _temp21,
    "pt-BR": _temp22,
    "pt-PT": _temp23,
    "ro-RO": _temp24,
    "ru-RU": _temp25,
    "sk-SK": _temp26,
    "sl-SI": _temp27,
    "sr-SP": _temp28,
    "sv-SE": _temp29,
    "tr-TR": _temp30,
    "uk-UA": _temp31,
    "zh-CN": _temp32,
    "zh-TW": _temp33
};

},{"e071b2523c8f0b4f":"a2ocb","b366ff82efdfb25":"7tY9u","590481e11b2d0e35":"jiagv","439c07b4d02328fd":"cJab3","49fac98605cabc94":"2Xfqh","385bd2742b947f58":"gVVfY","7483b8412f02872":"YUpdp","9357c54fdd7af6ee":"dKpEF","c6348f3243d4b68e":"693cH","37a68086405238d4":"4c48Q","8add74b43f73d458":"eg9zT","b5bca72854b82fa2":"6MBww","2a50fd1f859f5e31":"iZC58","676d0298627a908a":"an7Cf","b528119da684edd0":"aGOYv","b00b8df77193044b":"1Xqzd","b6e108f3f3cfff56":"858vA","e46ab69b0953afbe":"bc1gf","3d82f8c9e904717f":"6IJ1C","56b361041bf30e17":"2QUBa","cb598eb2b7d1a7f7":"7lvzI","7a34fde1e4705571":"azeFl","d52613ca06dc0512":"2L0Ac","51f120a8e805a5c7":"bcUVp","1c10facf267849b5":"aggFk","e2f92056ce7f5bf9":"hIyLY","c845ac3e223f4543":"gbXrv","28268d818d55f6ff":"7FHFa","87695363fcecdf94":"27Tms","a836f3f13ae433f9":"8jPQK","4fa725fe6617ccdd":"gqBKE","5d9e0d54c9073d16":"jLhDA","a2b533d7512e8605":"aHtKY","a877f7460370f708":"fCkN4"}],"a2ocb":[function(require,module,exports) {
module.exports = {
    "loading": `\u{62C}\u{627}\u{631}\u{64D} \u{627}\u{644}\u{62A}\u{62D}\u{645}\u{64A}\u{644}...`,
    "loadingMore": `\u{62C}\u{627}\u{631}\u{64D} \u{62A}\u{62D}\u{645}\u{64A}\u{644} \u{627}\u{644}\u{645}\u{632}\u{64A}\u{62F}...`
};

},{}],"7tY9u":[function(require,module,exports) {
module.exports = {
    "loading": `\u{417}\u{430}\u{440}\u{435}\u{436}\u{434}\u{430}\u{43D}\u{435}...`,
    "loadingMore": `\u{417}\u{430}\u{440}\u{435}\u{436}\u{434}\u{430}\u{43D}\u{435} \u{43D}\u{430} \u{43E}\u{449}\u{435}...`
};

},{}],"jiagv":[function(require,module,exports) {
module.exports = {
    "loading": `Na\u{10D}\xedt\xe1n\xed...`,
    "loadingMore": `Na\u{10D}\xedt\xe1n\xed dal\u{161}\xedch...`
};

},{}],"cJab3":[function(require,module,exports) {
module.exports = {
    "loading": `Indl\xe6ser ...`,
    "loadingMore": `Indl\xe6ser flere ...`
};

},{}],"2Xfqh":[function(require,module,exports) {
module.exports = {
    "loading": `Laden...`,
    "loadingMore": `Mehr laden ...`
};

},{}],"gVVfY":[function(require,module,exports) {
module.exports = {
    "loading": `\u{3A6}\u{3CC}\u{3C1}\u{3C4}\u{3C9}\u{3C3}\u{3B7}...`,
    "loadingMore": `\u{3A6}\u{3CC}\u{3C1}\u{3C4}\u{3C9}\u{3C3}\u{3B7} \u{3C0}\u{3B5}\u{3C1}\u{3B9}\u{3C3}\u{3C3}\u{3CC}\u{3C4}\u{3B5}\u{3C1}\u{3C9}\u{3BD}...`
};

},{}],"YUpdp":[function(require,module,exports) {
module.exports = {
    "loading": `Loading\u{2026}`,
    "loadingMore": `Loading more\u{2026}`
};

},{}],"dKpEF":[function(require,module,exports) {
module.exports = {
    "loading": `Cargando\u{2026}`,
    "loadingMore": `Cargando m\xe1s\u{2026}`
};

},{}],"693cH":[function(require,module,exports) {
module.exports = {
    "loading": `Laadimine...`,
    "loadingMore": `Laadi rohkem...`
};

},{}],"4c48Q":[function(require,module,exports) {
module.exports = {
    "loading": `Ladataan\u{2026}`,
    "loadingMore": `Ladataan lis\xe4\xe4\u{2026}`
};

},{}],"eg9zT":[function(require,module,exports) {
module.exports = {
    "loading": `Chargement...`,
    "loadingMore": `Chargement suppl\xe9mentaire...`
};

},{}],"6MBww":[function(require,module,exports) {
module.exports = {
    "loading": `\u{5D8}\u{5D5}\u{5E2}\u{5DF}...`,
    "loadingMore": `\u{5D8}\u{5D5}\u{5E2}\u{5DF} \u{5E2}\u{5D5}\u{5D3}...`
};

},{}],"iZC58":[function(require,module,exports) {
module.exports = {
    "loading": `U\u{10D}itavam...`,
    "loadingMore": `U\u{10D}itavam jo\u{161}...`
};

},{}],"an7Cf":[function(require,module,exports) {
module.exports = {
    "loading": `Bet\xf6lt\xe9s folyamatban\u{2026}`,
    "loadingMore": `Tov\xe1bbiak bet\xf6lt\xe9se folyamatban\u{2026}`
};

},{}],"aGOYv":[function(require,module,exports) {
module.exports = {
    "loading": `Caricamento...`,
    "loadingMore": `Caricamento altri...`
};

},{}],"1Xqzd":[function(require,module,exports) {
module.exports = {
    "loading": `\u{8AAD}\u{307F}\u{8FBC}\u{307F}\u{4E2D}...`,
    "loadingMore": `\u{3055}\u{3089}\u{306B}\u{8AAD}\u{307F}\u{8FBC}\u{307F}\u{4E2D}...`
};

},{}],"858vA":[function(require,module,exports) {
module.exports = {
    "loading": `\u{B85C}\u{B4DC} \u{C911}`,
    "loadingMore": `\u{CD94}\u{AC00} \u{B85C}\u{B4DC} \u{C911}`
};

},{}],"bc1gf":[function(require,module,exports) {
module.exports = {
    "loading": `\u{12E}keliama...`,
    "loadingMore": `\u{12E}keliama daugiau...`
};

},{}],"6IJ1C":[function(require,module,exports) {
module.exports = {
    "loading": `Notiek iel\u{101}de...`,
    "loadingMore": `Tiek iel\u{101}d\u{113}ts v\u{113}l...`
};

},{}],"2QUBa":[function(require,module,exports) {
module.exports = {
    "loading": `Laster inn ...`,
    "loadingMore": `Laster inn flere ...`
};

},{}],"7lvzI":[function(require,module,exports) {
module.exports = {
    "loading": `Laden...`,
    "loadingMore": `Meer laden...`
};

},{}],"azeFl":[function(require,module,exports) {
module.exports = {
    "loading": `\u{141}adowanie...`,
    "loadingMore": `Wczytywanie wi\u{119}kszej liczby...`
};

},{}],"2L0Ac":[function(require,module,exports) {
module.exports = {
    "loading": `Carregando...`,
    "loadingMore": `Carregando mais...`
};

},{}],"bcUVp":[function(require,module,exports) {
module.exports = {
    "loading": `A carregar...`,
    "loadingMore": `A carregar mais...`
};

},{}],"aggFk":[function(require,module,exports) {
module.exports = {
    "loading": `Se \xeencarc\u{103}...`,
    "loadingMore": `Se \xeencarc\u{103} mai multe...`
};

},{}],"hIyLY":[function(require,module,exports) {
module.exports = {
    "loading": `\u{417}\u{430}\u{433}\u{440}\u{443}\u{437}\u{43A}\u{430}...`,
    "loadingMore": `\u{414}\u{43E}\u{43F}\u{43E}\u{43B}\u{43D}\u{438}\u{442}\u{435}\u{43B}\u{44C}\u{43D}\u{430}\u{44F} \u{437}\u{430}\u{433}\u{440}\u{443}\u{437}\u{43A}\u{430}...`
};

},{}],"gbXrv":[function(require,module,exports) {
module.exports = {
    "loading": `Na\u{10D}\xedtava sa...`,
    "loadingMore": `Na\u{10D}\xedtava sa viac...`
};

},{}],"7FHFa":[function(require,module,exports) {
module.exports = {
    "loading": `Nalaganje...`,
    "loadingMore": `Nalaganje ve\u{10D} vsebine...`
};

},{}],"27Tms":[function(require,module,exports) {
module.exports = {
    "loading": `U\u{10D}itavam...`,
    "loadingMore": `U\u{10D}itavam jo\u{161}...`
};

},{}],"8jPQK":[function(require,module,exports) {
module.exports = {
    "loading": `L\xe4ser in...`,
    "loadingMore": `L\xe4ser in mer...`
};

},{}],"gqBKE":[function(require,module,exports) {
module.exports = {
    "loading": `Y\xfckleniyor...`,
    "loadingMore": `Daha fazla y\xfckleniyor...`
};

},{}],"jLhDA":[function(require,module,exports) {
module.exports = {
    "loading": `\u{417}\u{430}\u{432}\u{430}\u{43D}\u{442}\u{430}\u{436}\u{435}\u{43D}\u{43D}\u{44F}\u{2026}`,
    "loadingMore": `\u{417}\u{430}\u{432}\u{430}\u{43D}\u{442}\u{430}\u{436}\u{435}\u{43D}\u{43D}\u{44F} \u{456}\u{43D}\u{448}\u{438}\u{445} \u{43E}\u{431}\u{2019}\u{454}\u{43A}\u{442}\u{456}\u{432}...`
};

},{}],"aHtKY":[function(require,module,exports) {
module.exports = {
    "loading": `\u{6B63}\u{5728}\u{52A0}\u{8F7D}...`,
    "loadingMore": `\u{6B63}\u{5728}\u{52A0}\u{8F7D}\u{66F4}\u{591A}...`
};

},{}],"fCkN4":[function(require,module,exports) {
module.exports = {
    "loading": `\u{6B63}\u{5728}\u{8F09}\u{5165}`,
    "loadingMore": `\u{6B63}\u{5728}\u{8F09}\u{5165}\u{66F4}\u{591A}\u{2026}`
};

},{}],"jPnu6":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ListBoxContext", ()=>ListBoxContext);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const ListBoxContext = (0, _reactDefault.default).createContext(null);

},{"react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"k9zDq":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/** @private */ parcelHelpers.export(exports, "ListBoxOption", ()=>ListBoxOption);
var _checkmarkMedium = require("@spectrum-icons/ui/CheckmarkMedium");
var _checkmarkMediumDefault = parcelHelpers.interopDefault(_checkmarkMedium);
var _utils = require("@react-spectrum/utils");
var _focus = require("@react-aria/focus");
var _layout = require("@react-spectrum/layout");
var _interactions = require("@react-aria/interactions");
var _listBoxContext = require("./ListBoxContext");
var _utils1 = require("@react-aria/utils");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _varsCss = require("@adobe/spectrum-css-temp/components/menu/vars.css");
var _varsCssDefault = parcelHelpers.interopDefault(_varsCss);
var _text = require("@react-spectrum/text");
var _listbox = require("@react-aria/listbox");
function ListBoxOption(props) {
    let { item, shouldSelectOnPressUp, shouldFocusOnHover, shouldUseVirtualFocus } = props;
    let { rendered, key } = item;
    let ElementType = item.props.href ? "a" : "div";
    let state = (0, _react.useContext)((0, _listBoxContext.ListBoxContext));
    let ref = (0, _react.useRef)();
    let { optionProps, labelProps, descriptionProps, isSelected, isDisabled, isFocused } = (0, _listbox.useOption)({
        "aria-label": item["aria-label"],
        key,
        shouldSelectOnPressUp,
        shouldFocusOnHover,
        isVirtualized: true,
        shouldUseVirtualFocus
    }, state, ref);
    let { hoverProps, isHovered } = (0, _interactions.useHover)({
        ...props,
        isDisabled
    });
    let contents = typeof rendered === "string" ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, rendered) : rendered;
    let isKeyboardModality = (0, _interactions.isFocusVisible)();
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _focus.FocusRing), {
        focusRingClass: (0, _utils.classNames)((0, _varsCssDefault.default), "focus-ring")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(ElementType, {
        ...(0, _utils1.mergeProps)(optionProps, shouldFocusOnHover ? {} : hoverProps),
        ref: ref,
        className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Menu-item", {
            // If using virtual focus, apply focused styles to the item when the user is interacting with keyboard modality
            "is-focused": shouldUseVirtualFocus && isFocused && isKeyboardModality,
            "is-disabled": isDisabled,
            "is-selected": isSelected,
            "is-selectable": state.selectionManager.selectionMode !== "none",
            // When shouldFocusOnHover is false, apply hover styles both when hovered with the mouse.
            // Otherwise, apply hover styles when focused using non-keyboard modality.
            "is-hovered": isHovered && !shouldFocusOnHover || isFocused && !isKeyboardModality
        })
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Grid), {
        UNSAFE_className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Menu-itemGrid")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.ClearSlots), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.SlotProvider), {
        slots: {
            text: {
                UNSAFE_className: (0, _varsCssDefault.default)["spectrum-Menu-itemLabel"],
                ...labelProps
            },
            icon: {
                size: "S",
                UNSAFE_className: (0, _varsCssDefault.default)["spectrum-Menu-icon"]
            },
            avatar: {
                size: "avatar-size-100",
                UNSAFE_className: (0, _varsCssDefault.default)["spectrum-Menu-avatar"]
            },
            description: {
                UNSAFE_className: (0, _varsCssDefault.default)["spectrum-Menu-description"],
                ...descriptionProps
            }
        }
    }, contents, isSelected && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _checkmarkMediumDefault.default), {
        slot: "checkmark",
        UNSAFE_className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Menu-checkmark")
    }))))));
}

},{"@spectrum-icons/ui/CheckmarkMedium":"e6Ew8","@react-spectrum/utils":"cMIJ6","@react-aria/focus":"42mbF","@react-spectrum/layout":"hzaUY","@react-aria/interactions":"ky3G8","./ListBoxContext":"jPnu6","@react-aria/utils":"9cLk5","react":"9yzVZ","@adobe/spectrum-css-temp/components/menu/vars.css":"gqElf","@react-spectrum/text":"etCGI","@react-aria/listbox":"bHZSJ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"5OYn7":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/** @private */ parcelHelpers.export(exports, "ListBoxSection", ()=>ListBoxSection);
var _utils = require("@react-spectrum/utils");
var _virtualizer = require("@react-aria/virtualizer");
var _listBoxContext = require("./ListBoxContext");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _varsCss = require("@adobe/spectrum-css-temp/components/menu/vars.css");
var _varsCssDefault = parcelHelpers.interopDefault(_varsCss);
var _listbox = require("@react-aria/listbox");
var _i18N = require("@react-aria/i18n");
function ListBoxSection(props) {
    let { children, layoutInfo, headerLayoutInfo, virtualizer, item } = props;
    let { headingProps, groupProps } = (0, _listbox.useListBoxSection)({
        heading: item.rendered,
        "aria-label": item["aria-label"]
    });
    let headerRef = (0, _react.useRef)();
    (0, _virtualizer.useVirtualizerItem)({
        layoutInfo: headerLayoutInfo,
        virtualizer,
        ref: headerRef
    });
    let { direction } = (0, _i18N.useLocale)();
    let state = (0, _react.useContext)((0, _listBoxContext.ListBoxContext));
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _react.Fragment), null, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        role: "presentation",
        ref: headerRef,
        style: (0, _virtualizer.layoutInfoToStyle)(headerLayoutInfo, direction)
    }, item.key !== state.collection.getFirstKey() && /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        role: "presentation",
        className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Menu-divider")
    }), item.rendered && /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...headingProps,
        className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Menu-sectionHeading")
    }, item.rendered)), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...groupProps,
        style: (0, _virtualizer.layoutInfoToStyle)(layoutInfo, direction),
        className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Menu")
    }, children));
}

},{"@react-spectrum/utils":"cMIJ6","@react-aria/virtualizer":"gAPsK","./ListBoxContext":"jPnu6","react":"9yzVZ","@adobe/spectrum-css-temp/components/menu/vars.css":"gqElf","@react-aria/listbox":"bHZSJ","@react-aria/i18n":"411rg","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"ehKio":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MobileSearchAutocomplete", ()=>MobileSearchAutocomplete);
var _alertMedium = require("@spectrum-icons/ui/AlertMedium");
var _alertMediumDefault = parcelHelpers.interopDefault(_alertMedium);
var _checkmarkMedium = require("@spectrum-icons/ui/CheckmarkMedium");
var _checkmarkMediumDefault = parcelHelpers.interopDefault(_checkmarkMedium);
var _utils = require("@react-spectrum/utils");
var _button = require("@react-spectrum/button");
var _combobox = require("@react-stately/combobox");
var _overlays = require("@react-aria/overlays");
var _label = require("@react-spectrum/label");
var _focus = require("@react-aria/focus");
// @ts-ignore
var _json = require("../intl/*.json");
var _jsonDefault = parcelHelpers.interopDefault(_json);
var _listbox = require("@react-spectrum/listbox");
var _magnifier = require("@spectrum-icons/ui/Magnifier");
var _magnifierDefault = parcelHelpers.interopDefault(_magnifier);
var _utils1 = require("@react-aria/utils");
var _progress = require("@react-spectrum/progress");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _searchautocompleteCss = require("./searchautocomplete.css");
var _searchautocompleteCssDefault = parcelHelpers.interopDefault(_searchautocompleteCss);
var _varsCss = require("@adobe/spectrum-css-temp/components/search/vars.css");
var _varsCssDefault = parcelHelpers.interopDefault(_varsCss);
var _interactions = require("@react-aria/interactions");
var _varsCss1 = require("@adobe/spectrum-css-temp/components/inputgroup/vars.css");
var _varsCssDefault1 = parcelHelpers.interopDefault(_varsCss1);
var _textfield = require("@react-spectrum/textfield");
var _varsCss2 = require("@adobe/spectrum-css-temp/components/textfield/vars.css");
var _varsCssDefault2 = parcelHelpers.interopDefault(_varsCss2);
var _overlays1 = require("@react-spectrum/overlays");
var _button1 = require("@react-aria/button");
var _dialog = require("@react-aria/dialog");
var _label1 = require("@react-aria/label");
var _i18N = require("@react-aria/i18n");
var _form = require("@react-aria/form");
var _provider = require("@react-spectrum/provider");
var _autocomplete = require("@react-aria/autocomplete");
function _MobileSearchAutocomplete(props, ref) {
    props = (0, _provider.useProviderProps)(props);
    let { isQuiet, isDisabled, isRequired, validationBehavior, validate, name, isReadOnly, onSubmit = ()=>{} } = props;
    let { contains } = (0, _i18N.useFilter)({
        sensitivity: "base"
    });
    let state = (0, _combobox.useComboBoxState)({
        ...props,
        defaultFilter: contains,
        allowsEmptyCollection: true,
        // Needs to be false here otherwise we double up on commitSelection/commitCustomValue calls when
        // user taps on underlay (i.e. initial tap will call setFocused(false) -> commitSelection/commitCustomValue via onBlur,
        // then the closing of the tray will call setFocused(false) again due to cleanup effect)
        shouldCloseOnBlur: false,
        allowsCustomValue: true,
        onSelectionChange: (key)=>key !== null && onSubmit(null, key),
        selectedKey: undefined,
        defaultSelectedKey: undefined,
        validate: (0, _react.useCallback)((v)=>validate === null || validate === void 0 ? void 0 : validate(v.inputValue), [
            validate
        ])
    });
    let buttonRef = (0, _react.useRef)(null);
    let domRef = (0, _utils.useFocusableRef)(ref, buttonRef);
    let { triggerProps, overlayProps } = (0, _overlays.useOverlayTrigger)({
        type: "listbox"
    }, state, buttonRef);
    let inputRef = (0, _react.useRef)(null);
    (0, _form.useFormValidation)({
        ...props,
        focus: ()=>{
            var _buttonRef_current;
            return (_buttonRef_current = buttonRef.current) === null || _buttonRef_current === void 0 ? void 0 : _buttonRef_current.focus();
        }
    }, state, inputRef);
    let { isInvalid, validationErrors, validationDetails } = state.displayValidation;
    let validationState = props.validationState || (isInvalid ? "invalid" : undefined);
    var _props_errorMessage;
    let errorMessage = (_props_errorMessage = props.errorMessage) !== null && _props_errorMessage !== void 0 ? _props_errorMessage : validationErrors.join(" ");
    let { labelProps, fieldProps, descriptionProps, errorMessageProps } = (0, _label1.useField)({
        ...props,
        labelElementType: "span",
        isInvalid,
        errorMessage
    });
    // Focus the button and show focus ring when clicking on the label
    labelProps.onClick = ()=>{
        if (!props.isDisabled && buttonRef.current) {
            buttonRef.current.focus();
            (0, _interactions.setInteractionModality)("keyboard");
        }
    };
    let inputProps = {
        type: "hidden",
        name,
        value: state.inputValue
    };
    if (validationBehavior === "native") {
        // Use a hidden <input type="text"> rather than <input type="hidden">
        // so that an empty value blocks HTML form submission when the field is required.
        inputProps.type = "text";
        inputProps.hidden = true;
        inputProps.required = isRequired;
        // Ignore react warning.
        inputProps.onChange = ()=>{};
    }
    (0, _utils1.useFormReset)(inputRef, state.inputValue, state.setInputValue);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _label.Field), {
        ...props,
        labelProps: labelProps,
        descriptionProps: descriptionProps,
        errorMessageProps: errorMessageProps,
        isInvalid: isInvalid,
        validationErrors: validationErrors,
        validationDetails: validationDetails,
        elementType: "span",
        ref: domRef,
        includeNecessityIndicatorInAccessibilityName: true
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(SearchAutocompleteButton, {
        ...(0, _utils1.mergeProps)(triggerProps, fieldProps, {
            autoFocus: props.autoFocus,
            icon: props.icon
        }),
        ref: buttonRef,
        isQuiet: isQuiet,
        isDisabled: isDisabled,
        isReadOnly: isReadOnly,
        isPlaceholder: !state.inputValue,
        validationState: validationState,
        inputValue: state.inputValue,
        clearInput: ()=>state.setInputValue(""),
        onPress: ()=>!isReadOnly && state.open(null, "manual")
    }, state.inputValue || props.placeholder || "")), /*#__PURE__*/ (0, _reactDefault.default).createElement("input", {
        ...inputProps,
        ref: inputRef
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _overlays1.Tray), {
        state: state,
        isFixedHeight: true,
        ...overlayProps
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(SearchAutocompleteTray, {
        ...props,
        onClose: state.close,
        overlayProps: overlayProps,
        state: state
    })));
}
let MobileSearchAutocomplete = /*#__PURE__*/ (0, _reactDefault.default).forwardRef(_MobileSearchAutocomplete);
// any type is because we don't want to call useObjectRef because this is an internal component and we know
// we are always passing an object ref
const SearchAutocompleteButton = /*#__PURE__*/ (0, _reactDefault.default).forwardRef(function SearchAutocompleteButton(props, ref) {
    let searchIcon = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _magnifierDefault.default), {
        "data-testid": "searchicon"
    });
    let { icon = searchIcon, isQuiet, isDisabled, isReadOnly, isPlaceholder, validationState, inputValue, clearInput, children, style, className } = props;
    let stringFormatter = (0, _i18N.useLocalizedStringFormatter)((0, _jsonDefault.default), "@react-spectrum/autocomplete");
    let valueId = (0, _utils1.useId)();
    let invalidId = (0, _utils1.useId)();
    let validationIcon = validationState === "invalid" ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _alertMediumDefault.default), {
        id: invalidId,
        "aria-label": stringFormatter.format("invalid")
    }) : /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _checkmarkMediumDefault.default), null);
    if (icon) icon = /*#__PURE__*/ (0, _reactDefault.default).cloneElement(icon, {
        UNSAFE_className: (0, _utils.classNames)((0, _varsCssDefault2.default), "spectrum-Textfield-icon"),
        size: "S"
    });
    let clearButton = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ClearButton), {
        onPress: (e)=>{
            var _props_onPress;
            clearInput === null || clearInput === void 0 ? void 0 : clearInput();
            props === null || props === void 0 ? void 0 : (_props_onPress = props.onPress) === null || _props_onPress === void 0 ? void 0 : _props_onPress.call(props, e);
        },
        preventFocus: true,
        "aria-label": stringFormatter.format("clear"),
        excludeFromTabOrder: true,
        UNSAFE_className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-ClearButton"),
        isDisabled: isDisabled
    });
    let validation = /*#__PURE__*/ (0, _reactDefault.default).cloneElement(validationIcon, {
        UNSAFE_className: (0, _utils.classNames)((0, _varsCssDefault2.default), "spectrum-Textfield-validationIcon", (0, _utils.classNames)((0, _varsCssDefault1.default), "spectrum-InputGroup-input-validationIcon"), (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Search-validationIcon"))
    });
    let { hoverProps, isHovered } = (0, _interactions.useHover)({});
    let { isFocused, isFocusVisible, focusProps } = (0, _focus.useFocusRing)();
    let { buttonProps } = (0, _button1.useButton)({
        ...props,
        "aria-labelledby": [
            props["aria-labelledby"],
            props["aria-label"] && !props["aria-labelledby"] ? props.id : null,
            valueId,
            validationState === "invalid" ? invalidId : null
        ].filter(Boolean).join(" "),
        elementType: "div"
    }, ref);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...(0, _utils1.mergeProps)(hoverProps, focusProps, buttonProps),
        "aria-haspopup": "dialog",
        ref: ref,
        style: {
            ...style,
            outline: "none"
        },
        className: (0, _utils.classNames)((0, _varsCssDefault1.default), "spectrum-InputGroup", {
            "spectrum-InputGroup--quiet": isQuiet,
            "is-disabled": isDisabled,
            "spectrum-InputGroup--invalid": validationState === "invalid" && !isDisabled,
            "is-hovered": isHovered,
            "is-focused": isFocused,
            "focus-ring": isFocusVisible
        }, (0, _utils.classNames)((0, _searchautocompleteCssDefault.default), "searchautocomplete", "mobile-searchautocomplete"), className)
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _utils.classNames)((0, _varsCssDefault2.default), "spectrum-Textfield", {
            "spectrum-Textfield--invalid": validationState === "invalid" && !isDisabled,
            "spectrum-Textfield--valid": validationState === "valid" && !isDisabled,
            "spectrum-Textfield--quiet": isQuiet
        }, (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Search", "spectrum-Search--loadable", {
            "is-disabled": isDisabled,
            "is-quiet": isQuiet,
            "spectrum-Search--invalid": validationState === "invalid" && !isDisabled,
            "spectrum-Search--valid": validationState === "valid" && !isDisabled
        }), (0, _utils.classNames)((0, _varsCssDefault1.default), "spectrum-InputGroup-field"))
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _utils.classNames)((0, _varsCssDefault2.default), "spectrum-Textfield-input", {
            "spectrum-Textfield-inputIcon": !!icon,
            "is-hovered": isHovered,
            "is-placeholder": isPlaceholder,
            "is-disabled": isDisabled,
            "is-quiet": isQuiet,
            "is-focused": isFocused
        }, (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Search-input"), (0, _utils.classNames)((0, _searchautocompleteCssDefault.default), "mobile-input"))
    }, icon, /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        id: valueId,
        className: (0, _utils.classNames)((0, _searchautocompleteCssDefault.default), "mobile-value")
    }, children)), validationState && !isDisabled ? validation : null, (inputValue !== "" || validationState != null) && !isReadOnly && clearButton));
});
function SearchAutocompleteTray(props) {
    let searchIcon = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _magnifierDefault.default), {
        "data-testid": "searchicon"
    });
    let { // completionMode = 'suggest',
    state, icon = searchIcon, isDisabled, validationState, label, overlayProps, loadingState, onLoadMore, onClose, onSubmit } = props;
    let timeout = (0, _react.useRef)(null);
    let [showLoading, setShowLoading] = (0, _react.useState)(false);
    let inputRef = (0, _react.useRef)(null);
    let popoverRef = (0, _react.useRef)(null);
    let listBoxRef = (0, _react.useRef)(null);
    let isLoading = loadingState === "loading" || loadingState === "loadingMore";
    let layout = (0, _listbox.useListBoxLayout)(state, isLoading);
    let stringFormatter = (0, _i18N.useLocalizedStringFormatter)((0, _jsonDefault.default), "@react-spectrum/autocomplete");
    let { inputProps, listBoxProps, labelProps, clearButtonProps } = (0, _autocomplete.useSearchAutocomplete)({
        ...props,
        keyboardDelegate: layout,
        popoverRef: popoverRef,
        listBoxRef,
        inputRef,
        // Handled outside the tray.
        name: undefined
    }, state);
    (0, _reactDefault.default).useEffect(()=>{
        if (inputRef.current) (0, _focus.focusSafely)(inputRef.current);
    }, []);
    (0, _reactDefault.default).useEffect(()=>{
        // When the tray closes, set state.isFocused (i.e. the tray input's focus tracker) to false.
        // This is to prevent state.isFocused from being set to true when the tray closes via tapping on the underlay
        // (FocusScope attempts to restore focus to the tray input when tapping outside the tray due to "contain")
        // Have to do this manually since React doesn't call onBlur when a component is unmounted: https://github.com/facebook/react/issues/12363
        if (!state.isOpen && state.isFocused) state.setFocused(false);
    });
    let { dialogProps } = (0, _dialog.useDialog)({
        "aria-labelledby": (0, _utils1.useId)(labelProps.id)
    }, popoverRef);
    // Override the role of the input to "searchbox" instead of "combobox".
    // Since the listbox is always visible, the combobox role doesn't really give us anything.
    // VoiceOver on iOS reads "double tap to collapse" when focused on the input rather than
    // "double tap to edit text", as with a textbox or searchbox. We'd like double tapping to
    // open the virtual keyboard rather than closing the tray.
    inputProps.role = "searchbox";
    inputProps["aria-haspopup"] = "listbox";
    delete inputProps.onTouchEnd;
    let clearButton = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ClearButton), {
        ...clearButtonProps,
        preventFocus: true,
        "aria-label": stringFormatter.format("clear"),
        excludeFromTabOrder: true,
        UNSAFE_className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-ClearButton"),
        isDisabled: isDisabled
    });
    let loadingCircle = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _progress.ProgressCircle), {
        "aria-label": stringFormatter.format("loading"),
        size: "S",
        isIndeterminate: true,
        UNSAFE_className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Search-circleLoader", (0, _utils.classNames)((0, _varsCssDefault2.default), "spectrum-Textfield-circleLoader"))
    });
    // Close the software keyboard on scroll to give the user a bigger area to scroll.
    // But only do this if scrolling with touch, otherwise it can cause issues with touch
    // screen readers.
    let isTouchDown = (0, _react.useRef)(false);
    let onTouchStart = ()=>{
        isTouchDown.current = true;
    };
    let onTouchEnd = ()=>{
        isTouchDown.current = false;
    };
    let onScroll = (0, _react.useCallback)(()=>{
        if (!inputRef.current || document.activeElement !== inputRef.current || !isTouchDown.current) return;
        if (popoverRef.current) popoverRef.current.focus();
    }, [
        inputRef,
        popoverRef,
        isTouchDown
    ]);
    let inputValue = inputProps.value;
    let lastInputValue = (0, _react.useRef)(inputValue);
    (0, _react.useEffect)(()=>{
        if (loadingState === "filtering" && !showLoading) {
            if (timeout.current === null) timeout.current = setTimeout(()=>{
                setShowLoading(true);
            }, 500);
            // If user is typing, clear the timer and restart since it is a new request
            if (inputValue !== lastInputValue.current) {
                clearTimeout(timeout.current);
                timeout.current = setTimeout(()=>{
                    setShowLoading(true);
                }, 500);
            }
        } else if (loadingState !== "filtering") {
            // If loading is no longer happening, clear any timers and hide the loading circle
            setShowLoading(false);
            if (timeout.current !== null) {
                clearTimeout(timeout.current);
                timeout.current = null;
            }
        }
        lastInputValue.current = inputValue;
    }, [
        loadingState,
        inputValue,
        showLoading
    ]);
    let onKeyDown = (e)=>{
        // Close virtual keyboard, close tray, and fire onSubmit if user hits Enter w/o any focused options
        if (e.key === "Enter" && state.selectionManager.focusedKey == null) {
            var _popoverRef_current;
            (_popoverRef_current = popoverRef.current) === null || _popoverRef_current === void 0 ? void 0 : _popoverRef_current.focus();
            if (onClose) onClose();
            if (onSubmit) onSubmit(inputValue == null ? null : inputValue.toString(), null);
        } else if (inputProps.onKeyDown) inputProps.onKeyDown(e);
    };
    if (icon) icon = /*#__PURE__*/ (0, _reactDefault.default).cloneElement(icon, {
        UNSAFE_className: (0, _utils.classNames)((0, _varsCssDefault2.default), "spectrum-Textfield-icon"),
        size: "S"
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _focus.FocusScope), {
        restoreFocus: true,
        contain: true
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...(0, _utils1.mergeProps)(overlayProps, dialogProps),
        ref: popoverRef,
        className: (0, _utils.classNames)((0, _searchautocompleteCssDefault.default), "tray-dialog")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _overlays.DismissButton), {
        onDismiss: onClose
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textfield.TextFieldBase), {
        label: label,
        labelProps: labelProps,
        inputProps: {
            ...inputProps,
            onKeyDown
        },
        inputRef: inputRef,
        isDisabled: isDisabled,
        isLoading: showLoading && loadingState === "filtering",
        loadingIndicator: loadingState != null ? loadingCircle : undefined,
        validationState: validationState,
        wrapperChildren: (state.inputValue !== "" || loadingState === "filtering" || validationState != null) && !props.isReadOnly ? clearButton : undefined,
        icon: icon,
        UNSAFE_className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Search", "spectrum-Textfield", "spectrum-Search--loadable", {
            "spectrum-Search--invalid": validationState === "invalid" && !isDisabled,
            "spectrum-Search--valid": validationState === "valid" && !isDisabled
        }, (0, _utils.classNames)((0, _searchautocompleteCssDefault.default), "tray-textfield", {
            "has-label": !!props.label
        })),
        inputClassName: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Search-input"),
        validationIconClassName: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Search-validationIcon")
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _listbox.ListBoxBase), {
        ...listBoxProps,
        domProps: {
            onTouchStart,
            onTouchEnd
        },
        disallowEmptySelection: true,
        shouldSelectOnPressUp: true,
        focusOnPointerEnter: true,
        layout: layout,
        state: state,
        shouldUseVirtualFocus: true,
        renderEmptyState: ()=>loadingState !== "loading" && /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
                className: (0, _utils.classNames)((0, _searchautocompleteCssDefault.default), "no-results")
            }, stringFormatter.format("noResults")),
        UNSAFE_className: (0, _utils.classNames)((0, _searchautocompleteCssDefault.default), "tray-listbox"),
        ref: listBoxRef,
        onScroll: onScroll,
        onLoadMore: onLoadMore,
        isLoading: isLoading
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _overlays.DismissButton), {
        onDismiss: onClose
    })));
}

},{"@spectrum-icons/ui/AlertMedium":"2v5QX","@spectrum-icons/ui/CheckmarkMedium":"e6Ew8","@react-spectrum/utils":"cMIJ6","@react-spectrum/button":"jZWyP","@react-stately/combobox":"j3BhU","@react-aria/overlays":"5fTCg","@react-spectrum/label":"6qv6N","@react-aria/focus":"42mbF","../intl/*.json":"3Ike1","@react-spectrum/listbox":"kF7kO","@spectrum-icons/ui/Magnifier":"fLimS","@react-aria/utils":"9cLk5","@react-spectrum/progress":"4kHa7","react":"9yzVZ","./searchautocomplete.css":"1e8HE","@adobe/spectrum-css-temp/components/search/vars.css":"1Ppz4","@react-aria/interactions":"ky3G8","@adobe/spectrum-css-temp/components/inputgroup/vars.css":"fZm3Z","@react-spectrum/textfield":"hOmtq","@adobe/spectrum-css-temp/components/textfield/vars.css":"c3yAu","@react-spectrum/overlays":"3nwGn","@react-aria/button":"fsdLZ","@react-aria/dialog":"aSQNt","@react-aria/label":"74Ccz","@react-aria/i18n":"411rg","@react-aria/form":"lerqa","@react-spectrum/provider":"5bCdp","@react-aria/autocomplete":"7AJGo","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"1e8HE":[function(require,module,exports) {
module.exports["has-label"] = `JdB_7q_has-label`;
module.exports["mobile-input"] = `JdB_7q_mobile-input`;
module.exports["mobile-searchautocomplete"] = `JdB_7q_mobile-searchautocomplete`;
module.exports["mobile-value"] = `JdB_7q_mobile-value`;
module.exports["no-results"] = `JdB_7q_no-results`;
module.exports["searchautocomplete"] = `JdB_7q_searchautocomplete`;
module.exports["tray-dialog"] = `JdB_7q_tray-dialog`;
module.exports["tray-listbox"] = `JdB_7q_tray-listbox`;
module.exports["tray-textfield"] = `JdB_7q_tray-textfield`;
module.exports["tray-textfield-input"] = `JdB_7q_tray-textfield-input`;

},{}],"fZm3Z":[function(require,module,exports) {
module.exports["focus-ring"] = `ZTA2ya_focus-ring`;
module.exports["i18nFontFamily"] = `ZTA2ya_i18nFontFamily`;
module.exports["is-disabled"] = `ZTA2ya_is-disabled`;
module.exports["is-focused"] = `ZTA2ya_is-focused`;
module.exports["is-hovered"] = `ZTA2ya_is-hovered`;
module.exports["is-selected"] = `ZTA2ya_is-selected`;
module.exports["spectrum-Datepicker--datetimeRange"] = `ZTA2ya_spectrum-Datepicker--datetimeRange`;
module.exports["spectrum-Datepicker--range"] = `ZTA2ya_spectrum-Datepicker--range`;
module.exports["spectrum-Datepicker--rangeDash"] = `ZTA2ya_spectrum-Datepicker--rangeDash`;
module.exports["spectrum-Datepicker-endField"] = `ZTA2ya_spectrum-Datepicker-endField`;
module.exports["spectrum-Datepicker-focusRing"] = `ZTA2ya_spectrum-Datepicker-focusRing`;
module.exports["spectrum-Datepicker-startField"] = `ZTA2ya_spectrum-Datepicker-startField`;
module.exports["spectrum-FieldButton"] = `ZTA2ya_spectrum-FieldButton`;
module.exports["spectrum-FieldButton--invalid"] = `ZTA2ya_spectrum-FieldButton--invalid`;
module.exports["spectrum-FocusRing-ring"] = `ZTA2ya_spectrum-FocusRing-ring`;
module.exports["spectrum-FocusRing"] = `ZTA2ya_spectrum-FocusRing ${module.exports["spectrum-FocusRing-ring"]}`;
module.exports["spectrum-FocusRing--quiet"] = `ZTA2ya_spectrum-FocusRing--quiet`;
module.exports["spectrum-InputGroup"] = `ZTA2ya_spectrum-InputGroup ${module.exports["spectrum-FocusRing"]}`;
module.exports["spectrum-InputGroup--invalid"] = `ZTA2ya_spectrum-InputGroup--invalid`;
module.exports["spectrum-InputGroup--quiet"] = `ZTA2ya_spectrum-InputGroup--quiet ${module.exports["spectrum-FocusRing--quiet"]}`;
module.exports["spectrum-InputGroup-field"] = `ZTA2ya_spectrum-InputGroup-field`;
module.exports["spectrum-InputGroup-icon"] = `ZTA2ya_spectrum-InputGroup-icon`;
module.exports["spectrum-InputGroup-input"] = `ZTA2ya_spectrum-InputGroup-input`;
module.exports["spectrum-InputGroup-input-circleLoader"] = `ZTA2ya_spectrum-InputGroup-input-circleLoader`;
module.exports["spectrum-InputGroup-input-validationIcon"] = `ZTA2ya_spectrum-InputGroup-input-validationIcon`;
module.exports["spectrum-InputGroup-popover--quiet"] = `ZTA2ya_spectrum-InputGroup-popover--quiet`;

},{}],"7AJGo":[function(require,module,exports) {
/*
 * Copyright 2021 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useSearchAutocomplete", ()=>(0, _useSearchAutocomplete.useSearchAutocomplete));
var _useSearchAutocomplete = require("./useSearchAutocomplete");

},{"./useSearchAutocomplete":"2i70Y","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"2i70Y":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides the behavior and accessibility implementation for a search autocomplete component.
 * A search autocomplete combines a combobox with a searchfield, allowing users to filter a list of options to items matching a query.
 * @param props - Props for the search autocomplete.
 * @param state - State for the search autocomplete, as returned by `useSearchAutocomplete`.
 */ parcelHelpers.export(exports, "useSearchAutocomplete", ()=>useSearchAutocomplete);
var _utils = require("@react-aria/utils");
var _combobox = require("@react-aria/combobox");
var _searchfield = require("@react-aria/searchfield");
function useSearchAutocomplete(props, state) {
    let { popoverRef, inputRef, listBoxRef, keyboardDelegate, onSubmit = ()=>{}, onClear, onKeyDown, onKeyUp, isInvalid, validationState, validationBehavior, isRequired, ...otherProps } = props;
    let { inputProps, clearButtonProps } = (0, _searchfield.useSearchField)({
        ...otherProps,
        value: state.inputValue,
        onChange: state.setInputValue,
        autoComplete: "off",
        onClear: ()=>{
            state.setInputValue("");
            if (onClear) onClear();
        },
        onSubmit: (value)=>{
            // Prevent submission from search field if menu item was selected
            if (state.selectionManager.focusedKey === null) onSubmit(value, null);
        },
        onKeyDown,
        onKeyUp
    }, {
        value: state.inputValue,
        setValue: state.setInputValue
    }, inputRef);
    let { listBoxProps, labelProps, inputProps: comboBoxInputProps, ...validation } = (0, _combobox.useComboBox)({
        ...otherProps,
        keyboardDelegate,
        popoverRef,
        listBoxRef,
        inputRef,
        onFocus: undefined,
        onFocusChange: undefined,
        onBlur: undefined,
        onKeyDown: undefined,
        onKeyUp: undefined,
        isInvalid,
        validationState,
        validationBehavior,
        isRequired,
        validate: undefined
    }, state);
    return {
        labelProps,
        inputProps: (0, _utils.mergeProps)(inputProps, comboBoxInputProps),
        listBoxProps,
        clearButtonProps,
        ...validation
    };
}

},{"@react-aria/utils":"9cLk5","@react-aria/combobox":"4enyJ","@react-aria/searchfield":"2RKb9","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"jXn5w":[function(require,module,exports) {
/*
 * Copyright 2021 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Default", ()=>Default);
parcelHelpers.export(exports, "Disabled", ()=>Disabled);
parcelHelpers.export(exports, "WithAltText", ()=>WithAltText);
parcelHelpers.export(exports, "CustomSize", ()=>CustomSize);
var _ = require("../");
const SRC_URL_1 = "https://mir-s3-cdn-cf.behance.net/project_modules/disp/690bc6105945313.5f84bfc9de488.png";
const SRC_URL_2 = "https://i.imgur.com/xIe7Wlb.png";
const meta = {
    title: "Avatar",
    component: (0, _.Avatar)
};
exports.default = meta;
const Default = {
    args: {
        src: SRC_URL_1
    },
    name: "default"
};
const Disabled = {
    args: {
        isDisabled: true,
        src: SRC_URL_1
    },
    name: "isDisabled"
};
const WithAltText = {
    args: {
        alt: "Pensive",
        src: SRC_URL_2
    },
    name: "with alt text"
};
const CustomSize = {
    args: {
        ...WithAltText.args,
        size: "avatar-size-700"
    },
    name: "with custom size"
};

},{"../":"l1pOB","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"l1pOB":[function(require,module,exports) {
/*
 * Copyright 2021 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _src = require("./src");
parcelHelpers.exportAll(_src, exports);

},{"./src":"kHDr1","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"2fJfW":[function(require,module,exports) {
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Default", ()=>Default);
parcelHelpers.export(exports, "WithIcon", ()=>WithIcon);
parcelHelpers.export(exports, "WithIconReverseOrder", ()=>WithIconReverseOrder);
parcelHelpers.export(exports, "IconOnly", ()=>IconOnly);
parcelHelpers.export(exports, "Overflow", ()=>Overflow);
var _ = require("../");
var _checkmarkCircle = require("@spectrum-icons/workflow/CheckmarkCircle");
var _checkmarkCircleDefault = parcelHelpers.interopDefault(_checkmarkCircle);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _text = require("@react-spectrum/text");
exports.default = {
    title: "Badge",
    component: (0, _.Badge),
    argTypes: {
        variant: {
            control: {
                type: "select",
                options: [
                    "positive",
                    "negative",
                    "neutral",
                    "info",
                    "indigo",
                    "yellow",
                    "magenta",
                    "fuchsia",
                    "purple",
                    "seafoam"
                ]
            }
        }
    }
};
const Default = {
    args: {
        children: "Licensed",
        variant: "positive"
    },
    name: "Default"
};
const WithIcon = {
    args: {
        children: /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _checkmarkCircleDefault.default), {
            "aria-label": "Done"
        }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, "Licensed")),
        variant: "positive"
    },
    name: "With icon"
};
const WithIconReverseOrder = {
    args: {
        children: /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, "Licensed"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _checkmarkCircleDefault.default), {
            "aria-label": "Done"
        })),
        variant: "positive"
    },
    name: "With icon, order reversed"
};
const IconOnly = {
    args: {
        children: /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _checkmarkCircleDefault.default), {
            "aria-label": "Licensed"
        }),
        variant: "positive"
    },
    name: "Icon only"
};
const Overflow = {
    args: {
        children: "24 days left in trial",
        variant: "positive",
        UNSAFE_style: {
            width: "74px"
        }
    }
};

},{"../":"fSIlW","@spectrum-icons/workflow/CheckmarkCircle":"1ovP2","react":"9yzVZ","@react-spectrum/text":"etCGI","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"fSIlW":[function(require,module,exports) {
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _src = require("./src");
parcelHelpers.exportAll(_src, exports);

},{"./src":"5dI71","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"5dI71":[function(require,module,exports) {
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /// <reference types="css-module-types" />
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Badge", ()=>(0, _badge.Badge));
var _badge = require("./Badge");

},{"./Badge":"5QOWN","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"5QOWN":[function(require,module,exports) {
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Badge", ()=>_Badge);
var _utils = require("@react-spectrum/utils");
var _utils1 = require("@react-aria/utils");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _varsCss = require("@adobe/spectrum-css-temp/components/badge/vars.css");
var _varsCssDefault = parcelHelpers.interopDefault(_varsCss);
var _text = require("@react-spectrum/text");
var _provider = require("@react-spectrum/provider");
function Badge(props, ref) {
    let { children, variant, ...otherProps } = (0, _provider.useProviderProps)(props);
    let domRef = (0, _utils.useDOMRef)(ref);
    let { styleProps } = (0, _utils.useStyleProps)(otherProps);
    let isTextOnly = (0, _reactDefault.default).Children.toArray(props.children).every((c)=>!/*#__PURE__*/ (0, _reactDefault.default).isValidElement(c));
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        ...(0, _utils1.filterDOMProps)(otherProps),
        ...styleProps,
        role: "presentation",
        className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Badge", {
            [`spectrum-Badge--${variant}`]: variant
        }, styleProps.className),
        ref: domRef
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.SlotProvider), {
        slots: {
            icon: {
                size: "S",
                UNSAFE_className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Badge-icon")
            },
            text: {
                UNSAFE_className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Badge-label")
            }
        }
    }, typeof children === "string" || isTextOnly ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, children) : children));
}
/**
 * Badges are used for showing a small amount of color-categorized metadata, ideal for getting a user's attention.
 */ let _Badge = /*#__PURE__*/ (0, _react.forwardRef)(Badge);

},{"@react-spectrum/utils":"cMIJ6","@react-aria/utils":"9cLk5","react":"9yzVZ","@adobe/spectrum-css-temp/components/badge/vars.css":"bYvOb","@react-spectrum/text":"etCGI","@react-spectrum/provider":"5bCdp","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"bYvOb":[function(require,module,exports) {
module.exports["focus-ring"] = `CIB44a_focus-ring`;
module.exports["i18nFontFamily"] = `CIB44a_i18nFontFamily`;
module.exports["spectrum-Badge"] = `CIB44a_spectrum-Badge`;
module.exports["spectrum-Badge--fuchsia"] = `CIB44a_spectrum-Badge--fuchsia`;
module.exports["spectrum-Badge--indigo"] = `CIB44a_spectrum-Badge--indigo`;
module.exports["spectrum-Badge--info"] = `CIB44a_spectrum-Badge--info`;
module.exports["spectrum-Badge--large"] = `CIB44a_spectrum-Badge--large`;
module.exports["spectrum-Badge--magenta"] = `CIB44a_spectrum-Badge--magenta`;
module.exports["spectrum-Badge--negative"] = `CIB44a_spectrum-Badge--negative`;
module.exports["spectrum-Badge--neutral"] = `CIB44a_spectrum-Badge--neutral`;
module.exports["spectrum-Badge--positive"] = `CIB44a_spectrum-Badge--positive`;
module.exports["spectrum-Badge--purple"] = `CIB44a_spectrum-Badge--purple`;
module.exports["spectrum-Badge--seafoam"] = `CIB44a_spectrum-Badge--seafoam`;
module.exports["spectrum-Badge--small"] = `CIB44a_spectrum-Badge--small`;
module.exports["spectrum-Badge--yellow"] = `CIB44a_spectrum-Badge--yellow`;
module.exports["spectrum-Badge-icon"] = `CIB44a_spectrum-Badge-icon`;
module.exports["spectrum-Badge-label"] = `CIB44a_spectrum-Badge-label`;
module.exports["spectrum-FocusRing-ring"] = `CIB44a_spectrum-FocusRing-ring`;
module.exports["spectrum-FocusRing"] = `CIB44a_spectrum-FocusRing ${module.exports["spectrum-FocusRing-ring"]}`;
module.exports["spectrum-FocusRing--quiet"] = `CIB44a_spectrum-FocusRing--quiet`;

},{}],"1ovP2":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("788452eed0732af");
exports.__esModule = true;
exports.default = CheckmarkCircle;
var _CheckmarkCircle = require("9012af8b7285403c");
var _icon = require("edf315dfb98f7d41");
var _react = _interopRequireDefault(require("b3a227019abb1b99"));
function CheckmarkCircle(props) {
    return /*#__PURE__*/ _react.default.createElement(_icon.Icon, props, /*#__PURE__*/ _react.default.createElement(_CheckmarkCircle.A4uCheckmarkCircle, null));
}

},{"788452eed0732af":"iHubQ","9012af8b7285403c":"16KML","edf315dfb98f7d41":"k7wem","b3a227019abb1b99":"9yzVZ"}],"16KML":[function(require,module,exports) {
/**
* @adobe/react-spectrum-workflow (c) by Adobe
* 
* @adobe/react-spectrum-workflow is licensed under a
* Creative Commons Attribution-NoDerivatives 4.0 International License.
* 
* You should have received a copy of the license along with this
* work. If not, see <http://creativecommons.org/licenses/by-nd/4.0/>.
**/ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.A4uCheckmarkCircle = A4uCheckmarkCircle;
var _react = _interopRequireDefault(require("e5fc26a9b2d59ea4"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function A4uCheckmarkCircle(_ref) {
    var props = _extends({}, _ref);
    return /*#__PURE__*/ _react["default"].createElement("svg", _extends({
        viewBox: "0 0 36 36"
    }, props, props), /*#__PURE__*/ _react["default"].createElement("path", {
        fillRule: "evenodd",
        d: "M18,2A16,16,0,1,0,34,18,16.00008,16.00008,0,0,0,18,2Zm10.666,9.08044L16.01758,27.34119a1.20831,1.20831,0,0,1-.875.46093c-.02344.002-.04883.002-.07227.002a1.19938,1.19938,0,0,1-.84961-.35157L6.43555,19.65759a1.2,1.2,0,0,1,0-1.69726l1.32617-1.3252a1.20121,1.20121,0,0,1,1.69531,0l5.3457,5.34668L25.31445,8.473A1.20291,1.20291,0,0,1,27,8.26306l1.45508,1.13281A1.20477,1.20477,0,0,1,28.666,11.08044Z"
    }));
}

},{"e5fc26a9b2d59ea4":"9yzVZ"}],"aabfZ":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Default", ()=>Default);
parcelHelpers.export(exports, "DefaultTruncated", ()=>DefaultTruncated);
parcelHelpers.export(exports, "RenderMany", ()=>RenderMany);
parcelHelpers.export(exports, "OneItem", ()=>OneItem);
parcelHelpers.export(exports, "Links", ()=>Links);
var _addonActions = require("@storybook/addon-actions");
var _ = require("../");
// import {Heading} from '@react-spectrum/text';
var _collections = require("@react-stately/collections");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
let styles = {
    width: "100vw"
};
const CenterDecorator = (storyFn)=>/*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        style: styles
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", null, storyFn()));
exports.default = {
    title: "Breadcrumbs",
    component: (0, _.Breadcrumbs),
    decorators: [
        (storyFn)=>CenterDecorator(storyFn)
    ],
    args: {
        onAction: (0, _addonActions.action)("onAction")
    },
    argTypes: {
        onAction: {
            table: {
                disable: true
            }
        },
        isMultiline: {
            control: "boolean"
        },
        showRoot: {
            control: "boolean"
        },
        isDisabled: {
            control: "boolean"
        },
        autoFocusCurrent: {
            control: "boolean"
        },
        size: {
            control: "select",
            options: [
                "S",
                "M",
                "L"
            ]
        }
    }
};
const Default = {
    render: (args)=>render(args),
    name: "3 items"
};
const DefaultTruncated = {
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
            style: {
                width: "120px"
            }
        }, render(args)),
    name: "truncated"
};
const RenderMany = {
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
            style: {
                minWidth: "100px",
                width: "300px",
                padding: "10px",
                resize: "horizontal",
                overflow: "auto",
                backgroundColor: "var(--spectrum-global-color-gray-50)"
            }
        }, renderMany(args)),
    name: "7 items, resizable container"
};
const OneItem = {
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Breadcrumbs), args, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _collections.Item), null, "Root")),
    name: "1 item"
};
const Links = {
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Breadcrumbs), args, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _collections.Item), {
            href: "https://example.com"
        }, "Example.com"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _collections.Item), {
            href: "https://example.com/foo"
        }, "Foo"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _collections.Item), {
            href: "https://example.com/foo/bar"
        }, "Bar"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _collections.Item), {
            href: "https://example.com/foo/bar/baz"
        }, "Baz"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _collections.Item), {
            href: "https://example.com/foo/bar/baz/qux"
        }, "Qux"))
};
function render(props) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Breadcrumbs), props, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _collections.Item), {
        key: "Folder 1"
    }, "The quick brown fox jumps over"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _collections.Item), {
        key: "Folder 2"
    }, "My Documents"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _collections.Item), {
        key: "Folder 3"
    }, "Kangaroos jump high"));
}
function renderMany(props = {}) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Breadcrumbs), {
        ...props,
        onAction: (0, _addonActions.action)("onAction")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _collections.Item), {
        key: "Folder 1"
    }, "The quick brown fox jumps over"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _collections.Item), {
        key: "Folder 2"
    }, "My Documents"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _collections.Item), {
        key: "Folder 3"
    }, "Kangaroos jump high"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _collections.Item), {
        key: "Folder 4"
    }, "Koalas are very cute"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _collections.Item), {
        key: "Folder 5"
    }, "Wombat's noses"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _collections.Item), {
        key: "Folder 6"
    }, "Wattle trees"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _collections.Item), {
        key: "Folder 7"
    }, "April 7"));
} // TODO: add back in when heading case is fixed?
 // .add(
 //   'last item Heading',
 //   () => renderHeading()
 // )
 // .add(
 //   'last item Heading, size: S',
 //   () => renderHeading({size: 'S'})
 // )
 // .add(
 //   'last item Heading, size: M',
 //   () => renderHeading({size: 'M'})
 // )
 // .add(
 //   'last item Heading, isMultiline',
 //   () => renderHeading({isMultiline: true})
 // )
 // .add(
 //   'last item Heading, size: S, isMultiline',
 //   () => renderHeading({isMultiline: true, size: 'S'})
 // )
 // .add(
 //   'last item Heading, size: M, isMultiline',
 //   () => renderHeading({isMultiline: true, size: 'M'})
 // )
 // function renderHeading(props = {}) {
 //   return (
 //     <Breadcrumbs {...props} onAction={action('onAction')}>
 //       <Item key="Folder 1">
 //         The quick brown fox jumps over
 //       </Item>
 //       <Item key="Folder 2">
 //         My Documents
 //       </Item>
 //       <Item key="Folder 3">
 //         <Heading level={1}>
 //           Kangaroos jump high
 //         </Heading>
 //       </Item>
 //     </Breadcrumbs>
 //   );
 // }

},{"@storybook/addon-actions":"coXbW","../":"ekwSp","@react-stately/collections":"loANi","react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"ekwSp":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _src = require("./src");
parcelHelpers.exportAll(_src, exports);

},{"./src":"2lBZC","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"2lBZC":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /// <reference types="css-module-types" />
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Breadcrumbs", ()=>(0, _breadcrumbs.Breadcrumbs));
parcelHelpers.export(exports, "Item", ()=>(0, _collections.Item));
var _breadcrumbs = require("./Breadcrumbs");
var _collections = require("@react-stately/collections");

},{"./Breadcrumbs":"9vPR2","@react-stately/collections":"loANi","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"9vPR2":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Breadcrumbs", ()=>_Breadcrumbs);
var _button = require("@react-spectrum/button");
var _breadcrumbItem = require("./BreadcrumbItem");
var _utils = require("@react-spectrum/utils");
var _folderBreadcrumb = require("@spectrum-icons/ui/FolderBreadcrumb");
var _folderBreadcrumbDefault = parcelHelpers.interopDefault(_folderBreadcrumb);
var _menu = require("@react-spectrum/menu");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _varsCss = require("@adobe/spectrum-css-temp/components/breadcrumb/vars.css");
var _varsCssDefault = parcelHelpers.interopDefault(_varsCss);
var _breadcrumbs = require("@react-aria/breadcrumbs");
var _utils1 = require("@react-aria/utils");
var _provider = require("@react-spectrum/provider");
const MIN_VISIBLE_ITEMS = 1;
const MAX_VISIBLE_ITEMS = 4;
function Breadcrumbs(props, ref) {
    props = (0, _provider.useProviderProps)(props);
    let { size = "L", isMultiline, children, showRoot, isDisabled, onAction, autoFocusCurrent, ...otherProps } = props;
    // Not using React.Children.toArray because it mutates the key prop.
    let childArray = [];
    (0, _reactDefault.default).Children.forEach(children, (child, index)=>{
        if (/*#__PURE__*/ (0, _reactDefault.default).isValidElement(child)) {
            if (child.key == null) child = /*#__PURE__*/ (0, _reactDefault.default).cloneElement(child, {
                key: index
            });
            childArray.push(child);
        }
    });
    let domRef = (0, _utils.useDOMRef)(ref);
    let listRef = (0, _react.useRef)(null);
    let [visibleItems, setVisibleItems] = (0, _utils1.useValueEffect)(childArray.length);
    let { navProps } = (0, _breadcrumbs.useBreadcrumbs)(props);
    let { styleProps } = (0, _utils.useStyleProps)(otherProps);
    let updateOverflow = (0, _react.useCallback)(()=>{
        let computeVisibleItems = (visibleItems)=>{
            // Refs can be null at runtime.
            let currListRef = listRef.current;
            if (!currListRef) return visibleItems;
            let listItems = Array.from(currListRef.children);
            if (listItems.length <= 0) return visibleItems;
            let containerWidth = currListRef.offsetWidth;
            let isShowingMenu = childArray.length > visibleItems;
            let calculatedWidth = 0;
            let newVisibleItems = 0;
            let maxVisibleItems = MAX_VISIBLE_ITEMS;
            if (showRoot) {
                calculatedWidth += listItems.shift().offsetWidth;
                newVisibleItems++;
            }
            if (isShowingMenu) {
                calculatedWidth += listItems.shift().offsetWidth;
                maxVisibleItems--;
            }
            if (showRoot && calculatedWidth >= containerWidth) newVisibleItems--;
            // TODO: what if multiline and only one breadcrumb??
            if (isMultiline) {
                listItems.pop();
                newVisibleItems++;
            } else if (listItems.length > 0) {
                // Ensure the last breadcrumb isn't truncated when we measure it.
                let last = listItems.pop();
                last.style.overflow = "visible";
                calculatedWidth += last.offsetWidth;
                if (calculatedWidth < containerWidth) newVisibleItems++;
                last.style.overflow = "";
            }
            for (let breadcrumb of listItems.reverse()){
                calculatedWidth += breadcrumb.offsetWidth;
                if (calculatedWidth < containerWidth) newVisibleItems++;
            }
            return Math.max(MIN_VISIBLE_ITEMS, Math.min(maxVisibleItems, newVisibleItems));
        };
        setVisibleItems(function*() {
            // Update to show all items.
            yield childArray.length;
            // Measure, and update to show the items that fit.
            let newVisibleItems = computeVisibleItems(childArray.length);
            yield newVisibleItems;
            // If the number of items is less than the number of children,
            // then update again to ensure that the menu fits.
            if (newVisibleItems < childArray.length && newVisibleItems > 1) yield computeVisibleItems(newVisibleItems);
        });
    }, [
        childArray.length,
        setVisibleItems,
        showRoot,
        isMultiline
    ]);
    (0, _utils1.useResizeObserver)({
        ref: domRef,
        onResize: updateOverflow
    });
    let lastChildren = (0, _react.useRef)(null);
    (0, _utils1.useLayoutEffect)(()=>{
        if (children !== lastChildren.current) {
            lastChildren.current = children;
            updateOverflow();
        }
    });
    let contents = childArray;
    if (childArray.length > visibleItems) {
        let selectedItem = childArray[childArray.length - 1];
        var _selectedItem_key;
        let selectedKey = (_selectedItem_key = selectedItem.key) !== null && _selectedItem_key !== void 0 ? _selectedItem_key : childArray.length - 1;
        let onMenuAction = (key)=>{
            // Don't fire onAction when clicking on the last item
            if (key !== selectedKey && onAction) onAction(key);
        };
        let menuItem = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _breadcrumbItem.BreadcrumbItem), {
            key: "menu",
            isMenu: true
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _menu.MenuTrigger), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), {
            UNSAFE_className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Breadcrumbs-actionButton"),
            "aria-label": "\u2026",
            isQuiet: true,
            isDisabled: isDisabled
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _folderBreadcrumbDefault.default), null)), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _menu.Menu), {
            selectionMode: "single",
            selectedKeys: [
                selectedKey
            ],
            onAction: onMenuAction
        }, childArray)));
        contents = [
            menuItem
        ];
        let breadcrumbs = [
            ...childArray
        ];
        let endItems = visibleItems;
        if (showRoot && visibleItems > 1) {
            let rootItem = breadcrumbs.shift();
            if (rootItem) contents.unshift(rootItem);
            endItems--;
        }
        contents.push(...breadcrumbs.slice(-endItems));
    }
    let lastIndex = contents.length - 1;
    let breadcrumbItems = contents.map((child, index)=>{
        let isCurrent = index === lastIndex;
        var _child_key;
        let key = (_child_key = child.key) !== null && _child_key !== void 0 ? _child_key : index;
        let onPress = ()=>{
            if (onAction) onAction(key);
        };
        return /*#__PURE__*/ (0, _reactDefault.default).createElement("li", {
            key: index,
            className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Breadcrumbs-item")
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _breadcrumbItem.BreadcrumbItem), {
            ...child.props,
            key: key,
            isCurrent: isCurrent,
            isDisabled: isDisabled,
            onPress: onPress,
            autoFocus: isCurrent && autoFocusCurrent
        }, child.props.children));
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("nav", {
        ...styleProps,
        ...navProps,
        ref: domRef
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("ul", {
        ref: listRef,
        className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Breadcrumbs", {
            "spectrum-Breadcrumbs--small": size === "S",
            "spectrum-Breadcrumbs--medium": size === "M",
            "spectrum-Breadcrumbs--multiline": isMultiline,
            "spectrum-Breadcrumbs--showRoot": showRoot,
            "is-disabled": isDisabled
        }, styleProps.className)
    }, breadcrumbItems));
}
/**
 * Breadcrumbs show hierarchy and navigational context for a user’s location within an application.
 */ let _Breadcrumbs = /*#__PURE__*/ (0, _reactDefault.default).forwardRef(Breadcrumbs);

},{"@react-spectrum/button":"jZWyP","./BreadcrumbItem":"79i7i","@react-spectrum/utils":"cMIJ6","@spectrum-icons/ui/FolderBreadcrumb":"7nQay","@react-spectrum/menu":"asqy4","react":"9yzVZ","@adobe/spectrum-css-temp/components/breadcrumb/vars.css":"3yUek","@react-aria/breadcrumbs":"iFNvq","@react-aria/utils":"9cLk5","@react-spectrum/provider":"5bCdp","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"79i7i":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BreadcrumbItem", ()=>BreadcrumbItem);
var _chevronRightSmall = require("@spectrum-icons/ui/ChevronRightSmall");
var _chevronRightSmallDefault = parcelHelpers.interopDefault(_chevronRightSmall);
var _utils = require("@react-spectrum/utils");
var _focus = require("@react-aria/focus");
var _utils1 = require("@react-aria/utils");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _varsCss = require("@adobe/spectrum-css-temp/components/breadcrumb/vars.css");
var _varsCssDefault = parcelHelpers.interopDefault(_varsCss);
var _breadcrumbs = require("@react-aria/breadcrumbs");
var _interactions = require("@react-aria/interactions");
var _i18N = require("@react-aria/i18n");
function BreadcrumbItem(props) {
    let { children, isCurrent, isDisabled, isMenu } = props;
    let { direction } = (0, _i18N.useLocale)();
    let ref = (0, _react.useRef)(null);
    let ElementType = props.href ? "a" : "span";
    let { itemProps } = (0, _breadcrumbs.useBreadcrumbItem)({
        ...props,
        elementType: ElementType
    }, ref);
    let { hoverProps, isHovered } = (0, _interactions.useHover)(props);
    // If this item contains a menu button, then it shouldn't be a link.
    if (isMenu) itemProps = {};
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _react.Fragment), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _focus.FocusRing), {
        focusRingClass: (0, _utils.classNames)((0, _varsCssDefault.default), "focus-ring")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(ElementType, {
        ...(0, _utils1.mergeProps)(itemProps, hoverProps),
        ref: ref,
        className: (0, _utils.classNames)((0, _varsCssDefault.default), {
            "spectrum-Breadcrumbs-itemLink": !isMenu,
            "is-disabled": !isCurrent && isDisabled,
            "is-hovered": isHovered
        })
    }, children)), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _chevronRightSmallDefault.default), {
        UNSAFE_className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Breadcrumbs-itemSeparator", {
            "is-reversed": direction === "rtl"
        })
    }));
}

},{"@spectrum-icons/ui/ChevronRightSmall":"83HIt","@react-spectrum/utils":"cMIJ6","@react-aria/focus":"42mbF","@react-aria/utils":"9cLk5","react":"9yzVZ","@adobe/spectrum-css-temp/components/breadcrumb/vars.css":"3yUek","@react-aria/breadcrumbs":"iFNvq","@react-aria/interactions":"ky3G8","@react-aria/i18n":"411rg","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"83HIt":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("5dee168af8bfaa03");
exports.__esModule = true;
exports.default = ChevronRightSmall;
var _extends2 = _interopRequireDefault(require("d93b57df6f3aef65"));
var _ChevronRightSmall = require("a76eff0741db443d");
var _icon = require("fddb4ed6bd6dafb0");
var _provider = require("1177153f32abf9d6");
var _react = _interopRequireDefault(require("59690449bd9ec541"));
const ExpressIcon = (props)=>/*#__PURE__*/ _react.default.createElement("svg", (0, _extends2.default)({
        viewBox: "0 0 18 18"
    }, props), /*#__PURE__*/ _react.default.createElement("path", {
        d: "M7.707 4.293a1 1 0 1 0-1.414 1.414L9.586 9l-3.293 3.293a1 1 0 1 0 1.414 1.414l4-4a1 1 0 0 0 0-1.414l-4-4Z"
    }));
ExpressIcon.displayName = _ChevronRightSmall.ChevronRightSmall.displayName;
function ChevronRightSmall(props) {
    var _provider$theme, _provider$theme$globa;
    let provider = (0, _provider.useProvider)();
    return /*#__PURE__*/ _react.default.createElement(_icon.UIIcon, props, provider != null && (_provider$theme = provider.theme) != null && (_provider$theme$globa = _provider$theme.global) != null && _provider$theme$globa.express ? /*#__PURE__*/ _react.default.createElement(ExpressIcon, null) : /*#__PURE__*/ _react.default.createElement(_ChevronRightSmall.ChevronRightSmall, null));
}

},{"5dee168af8bfaa03":"iHubQ","d93b57df6f3aef65":"l4mXf","a76eff0741db443d":"gzkUR","fddb4ed6bd6dafb0":"k7wem","1177153f32abf9d6":"5bCdp","59690449bd9ec541":"9yzVZ"}],"gzkUR":[function(require,module,exports) {
/**
* @adobe/react-spectrum-ui (c) by Adobe
* 
* @adobe/react-spectrum-ui is licensed under a
* Creative Commons Attribution-NoDerivatives 4.0 International License.
* 
* You should have received a copy of the license along with this
* work. If not, see <http://creativecommons.org/licenses/by-nd/4.0/>.
**/ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ChevronRightSmall = ChevronRightSmall;
var _react = _interopRequireDefault(require("1ae4a13d781495f2"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function ChevronRightSmall(_ref) {
    var _ref$scale = _ref.scale, scale = _ref$scale === void 0 ? "M" : _ref$scale, props = _objectWithoutProperties(_ref, [
        "scale"
    ]);
    return _react["default"].createElement("svg", _extends({}, props, props), scale === "L" && _react["default"].createElement("path", {
        d: "M7 5a.747.747 0 0 0-.22-.53L2.54.23a.75.75 0 1 0-1.06 1.06L5.19 5 1.48 8.71a.75.75 0 1 0 1.06 1.06l4.24-4.24A.747.747 0 0 0 7 5z"
    }), scale === "M" && _react["default"].createElement("path", {
        d: "M5.5 4a.747.747 0 0 0-.22-.53C4.703 2.862 3.242 1.5 2.04.23A.75.75 0 1 0 .98 1.29L3.69 4 .98 6.71a.75.75 0 1 0 1.06 1.06l3.24-3.24A.747.747 0 0 0 5.5 4z"
    }));
}
ChevronRightSmall.displayName = "ChevronRightSmall";

},{"1ae4a13d781495f2":"9yzVZ"}],"3yUek":[function(require,module,exports) {
module.exports["focus-ring"] = `_1gDPVa_focus-ring`;
module.exports["i18nFontFamily"] = `_1gDPVa_i18nFontFamily`;
module.exports["is-disabled"] = `_1gDPVa_is-disabled`;
module.exports["is-dragged"] = `_1gDPVa_is-dragged`;
module.exports["is-hovered"] = `_1gDPVa_is-hovered`;
module.exports["is-reversed"] = `_1gDPVa_is-reversed`;
module.exports["is-selected"] = `_1gDPVa_is-selected`;
module.exports["spectrum-Breadcrumb"] = `_1gDPVa_spectrum-Breadcrumb`;
module.exports["spectrum-Breadcrumbs"] = `_1gDPVa_spectrum-Breadcrumbs`;
module.exports["spectrum-Breadcrumbs--medium"] = `_1gDPVa_spectrum-Breadcrumbs--medium`;
module.exports["spectrum-Breadcrumbs--multiline"] = `_1gDPVa_spectrum-Breadcrumbs--multiline`;
module.exports["spectrum-Breadcrumbs--small"] = `_1gDPVa_spectrum-Breadcrumbs--small`;
module.exports["spectrum-Breadcrumbs-actionButton"] = `_1gDPVa_spectrum-Breadcrumbs-actionButton`;
module.exports["spectrum-Breadcrumbs-item"] = `_1gDPVa_spectrum-Breadcrumbs-item`;
module.exports["spectrum-Breadcrumbs-itemLink"] = `_1gDPVa_spectrum-Breadcrumbs-itemLink`;
module.exports["spectrum-Breadcrumbs-itemSeparator"] = `_1gDPVa_spectrum-Breadcrumbs-itemSeparator`;
module.exports["spectrum-FocusRing-ring"] = `_1gDPVa_spectrum-FocusRing-ring`;
module.exports["spectrum-FocusRing"] = `_1gDPVa_spectrum-FocusRing ${module.exports["spectrum-FocusRing-ring"]}`;
module.exports["spectrum-FocusRing--quiet"] = `_1gDPVa_spectrum-FocusRing--quiet`;
module.exports["spectrum-Heading--pageTitle"] = `_1gDPVa_spectrum-Heading--pageTitle`;

},{}],"7nQay":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("5f46f6c5a3020790");
exports.__esModule = true;
exports.default = FolderBreadcrumb;
var _extends2 = _interopRequireDefault(require("421d59cf2a43c2e"));
var _FolderBreadcrumb = require("517b1a5bc9da1543");
var _icon = require("eb853c3cdb3524cc");
var _provider = require("aae641ea81afbaa5");
var _react = _interopRequireDefault(require("ab7f31f63fbb7b36"));
const ExpressIcon = (props)=>/*#__PURE__*/ _react.default.createElement("svg", (0, _extends2.default)({
        viewBox: "0 0 18 18"
    }, props), /*#__PURE__*/ _react.default.createElement("circle", {
        cx: 9,
        cy: 9,
        r: 2
    }), /*#__PURE__*/ _react.default.createElement("circle", {
        cx: 15,
        cy: 9,
        r: 2
    }), /*#__PURE__*/ _react.default.createElement("circle", {
        cx: 3,
        cy: 9,
        r: 2
    }));
ExpressIcon.displayName = _FolderBreadcrumb.FolderBreadcrumb.displayName;
function FolderBreadcrumb(props) {
    var _provider$theme, _provider$theme$globa;
    let provider = (0, _provider.useProvider)();
    return /*#__PURE__*/ _react.default.createElement(_icon.UIIcon, props, provider != null && (_provider$theme = provider.theme) != null && (_provider$theme$globa = _provider$theme.global) != null && _provider$theme$globa.express ? /*#__PURE__*/ _react.default.createElement(ExpressIcon, null) : /*#__PURE__*/ _react.default.createElement(_FolderBreadcrumb.FolderBreadcrumb, null));
}

},{"5f46f6c5a3020790":"iHubQ","421d59cf2a43c2e":"l4mXf","517b1a5bc9da1543":"9nTTf","eb853c3cdb3524cc":"k7wem","aae641ea81afbaa5":"5bCdp","ab7f31f63fbb7b36":"9yzVZ"}],"9nTTf":[function(require,module,exports) {
/**
* @adobe/react-spectrum-ui (c) by Adobe
* 
* @adobe/react-spectrum-ui is licensed under a
* Creative Commons Attribution-NoDerivatives 4.0 International License.
* 
* You should have received a copy of the license along with this
* work. If not, see <http://creativecommons.org/licenses/by-nd/4.0/>.
**/ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.FolderBreadcrumb = FolderBreadcrumb;
var _react = _interopRequireDefault(require("80c55bc047ed326e"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function FolderBreadcrumb(_ref) {
    var _ref$scale = _ref.scale, scale = _ref$scale === void 0 ? "M" : _ref$scale, props = _objectWithoutProperties(_ref, [
        "scale"
    ]);
    return _react["default"].createElement("svg", _extends({}, props, props), scale === "L" && _react["default"].createElement("path", {
        d: "M19.5 6l-9.166.004-1.668-1.7A.998.998 0 0 0 7.946 4H3a1 1 0 0 0-1 1v13a.5.5 0 0 0 .5.5h17a.5.5 0 0 0 .5-.5V6.5a.5.5 0 0 0-.5-.5zm-16-.5h4.237l1.964 2H3.5zm11.544 6.044l-3.5 3.5a.77.77 0 0 1-1.088 0l-3.5-3.5a.77.77 0 0 1 1.088-1.088L11 13.41l2.956-2.955a.77.77 0 0 1 1.088 1.088z"
    }), scale === "M" && _react["default"].createElement("path", {
        d: "M16.5 4l-7.166.004-1.652-1.7A1 1 0 0 0 6.965 2H2a1 1 0 0 0-1 1v11.5a.5.5 0 0 0 .5.5h15a.5.5 0 0 0 .5-.5v-10a.5.5 0 0 0-.5-.5zM2 3h4.965l1.943 2H2zm10.354 5.854l-3 3a.5.5 0 0 1-.707 0l-3-3a.5.5 0 0 1 .707-.707L9 10.793l2.646-2.646a.5.5 0 0 1 .707.707z"
    }));
}
FolderBreadcrumb.displayName = "FolderBreadcrumb";

},{"80c55bc047ed326e":"9yzVZ"}],"hrnbP":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Default", ()=>Default);
parcelHelpers.export(exports, "WithIcon", ()=>WithIcon);
parcelHelpers.export(exports, "IconOnly", ()=>IconOnly);
parcelHelpers.export(exports, "StaticWhite", ()=>StaticWhite);
parcelHelpers.export(exports, "StaticBlack", ()=>StaticBlack);
var _addonActions = require("@storybook/addon-actions");
var _ = require("../");
var _add = require("@spectrum-icons/workflow/Add");
var _addDefault = parcelHelpers.interopDefault(_add);
var _layout = require("@react-spectrum/layout");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _text = require("@react-spectrum/text");
var _view = require("@react-spectrum/view");
exports.default = {
    title: "Button/ActionButton",
    component: (0, _.ActionButton),
    args: {
        onPress: (0, _addonActions.action)("press"),
        onPressStart: (0, _addonActions.action)("pressstart"),
        onPressEnd: (0, _addonActions.action)("pressend")
    },
    argTypes: {
        onPress: {
            table: {
                disable: true
            }
        },
        onPressStart: {
            table: {
                disable: true
            }
        },
        onPressEnd: {
            table: {
                disable: true
            }
        },
        staticColor: {
            table: {
                disable: true
            }
        },
        isQuiet: {
            control: "boolean"
        },
        autoFocus: {
            control: "boolean"
        }
    }
};
const Default = {
    render: (args)=>render(args)
};
const WithIcon = {
    render: (args)=>renderWithIcon(args)
};
const IconOnly = {
    render: (args)=>renderOnlyIcon(args)
};
const StaticWhite = {
    args: {
        staticColor: "white"
    },
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.View), {
            backgroundColor: "static-blue-700",
            padding: "size-1000"
        }, renderWithIcon(args)),
    name: "staticColor: white"
};
const StaticBlack = {
    args: {
        staticColor: "black"
    },
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.View), {
            backgroundColor: "static-yellow-400",
            padding: "size-1000"
        }, renderWithIcon(args)),
    name: "staticColor: black"
};
function render(props = {}) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
        gap: "size-100"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ActionButton), props, "Default"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ActionButton), {
        isDisabled: true,
        ...props
    }, "Disabled"));
}
function renderWithIcon(props = {}) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
        gap: "size-100"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ActionButton), props, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _addDefault.default), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, "Default")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ActionButton), {
        isDisabled: true,
        ...props
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, "Disabled"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _addDefault.default), null)));
}
function renderOnlyIcon(props = {}) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
        gap: "size-100"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ActionButton), {
        ...props,
        "aria-label": "Add button"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _addDefault.default), null)), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ActionButton), {
        isDisabled: true,
        ...props,
        "aria-label": "Disabled add button"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _addDefault.default), null)));
}

},{"@storybook/addon-actions":"coXbW","../":"eMlIM","@spectrum-icons/workflow/Add":"evYih","@react-spectrum/layout":"hzaUY","react":"9yzVZ","@react-spectrum/text":"etCGI","@react-spectrum/view":"dnRjt","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"eMlIM":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _src = require("./src");
parcelHelpers.exportAll(_src, exports);

},{"./src":"jZWyP","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"evYih":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("4d6163fcdf2ca481");
exports.__esModule = true;
exports.default = Add;
var _Add = require("837bae49042417cc");
var _icon = require("b50023c484467e7a");
var _react = _interopRequireDefault(require("d9abcf8d4b624f0e"));
function Add(props) {
    return /*#__PURE__*/ _react.default.createElement(_icon.Icon, props, /*#__PURE__*/ _react.default.createElement(_Add.A4uAdd, null));
}

},{"4d6163fcdf2ca481":"iHubQ","837bae49042417cc":"9U7Kc","b50023c484467e7a":"k7wem","d9abcf8d4b624f0e":"9yzVZ"}],"9U7Kc":[function(require,module,exports) {
/**
* @adobe/react-spectrum-workflow (c) by Adobe
* 
* @adobe/react-spectrum-workflow is licensed under a
* Creative Commons Attribution-NoDerivatives 4.0 International License.
* 
* You should have received a copy of the license along with this
* work. If not, see <http://creativecommons.org/licenses/by-nd/4.0/>.
**/ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.A4uAdd = A4uAdd;
var _react = _interopRequireDefault(require("b1e01adf16b06bb8"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function A4uAdd(_ref) {
    var props = _extends({}, _ref);
    return /*#__PURE__*/ _react["default"].createElement("svg", _extends({
        viewBox: "0 0 36 36"
    }, props, props), /*#__PURE__*/ _react["default"].createElement("path", {
        fillRule: "evenodd",
        d: "M29,16H20V7a1,1,0,0,0-1-1H17a1,1,0,0,0-1,1v9H7a1,1,0,0,0-1,1v2a1,1,0,0,0,1,1h9v9a1,1,0,0,0,1,1h2a1,1,0,0,0,1-1V20h9a1,1,0,0,0,1-1V17A1,1,0,0,0,29,16Z"
    }));
}

},{"b1e01adf16b06bb8":"9yzVZ"}],"cdpVs":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Default", ()=>Default);
parcelHelpers.export(exports, "WithIcon", ()=>WithIcon);
parcelHelpers.export(exports, "IconOnly", ()=>IconOnly);
parcelHelpers.export(exports, "AnchorElement", ()=>AnchorElement);
parcelHelpers.export(exports, "AnchorElementWithSelf", ()=>AnchorElementWithSelf);
parcelHelpers.export(exports, "AnchorElementNoRefferer", ()=>AnchorElementNoRefferer);
parcelHelpers.export(exports, "UserSelect", ()=>UserSelect);
parcelHelpers.export(exports, "PendingSpinner", ()=>PendingSpinner);
var _addonActions = require("@storybook/addon-actions");
var _bell = require("@spectrum-icons/workflow/Bell");
var _bellDefault = parcelHelpers.interopDefault(_bell);
var _ = require("../");
var _layout = require("@react-spectrum/layout");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _text = require("@react-spectrum/text");
var _tooltip = require("@react-spectrum/tooltip");
var _view = require("@react-spectrum/view");
exports.default = {
    title: "Button",
    component: (0, _.Button),
    args: {
        onPress: (0, _addonActions.action)("press"),
        onPressStart: (0, _addonActions.action)("pressstart"),
        onPressEnd: (0, _addonActions.action)("pressend"),
        onPressChange: (0, _addonActions.action)("presschange"),
        onPressUp: (0, _addonActions.action)("pressup"),
        onFocus: (0, _addonActions.action)("focus"),
        onBlur: (0, _addonActions.action)("blur"),
        onKeyUp: (0, _addonActions.action)("keyup")
    },
    argTypes: {
        onPress: {
            table: {
                disable: true
            }
        },
        onPressStart: {
            table: {
                disable: true
            }
        },
        onPressEnd: {
            table: {
                disable: true
            }
        },
        onPressUp: {
            table: {
                disable: true
            }
        },
        autoFocus: {
            control: "boolean"
        },
        variant: {
            control: "select",
            options: [
                "accent",
                "primary",
                "secondary",
                "negative",
                "cta",
                "overBackground"
            ],
            defaultValue: "accent"
        },
        style: {
            control: "select",
            options: [
                undefined,
                "fill",
                "outline"
            ]
        },
        staticColor: {
            control: "select",
            options: [
                undefined,
                "white",
                "black"
            ]
        },
        isPending: {
            control: "boolean",
            defaultValue: false
        }
    }
};
const Default = {
    render: (args)=>render(args)
};
const WithIcon = {
    render: (args)=>renderIconText(args)
};
const IconOnly = {
    render: (args)=>renderIconOnly(args)
};
const AnchorElement = {
    render: (args)=>render({
            elementType: "a",
            ...args
        }),
    name: "element: a"
};
const AnchorElementWithSelf = {
    render: (args)=>render({
            elementType: "a",
            href: "//example.com",
            target: "_self",
            ...args
        }),
    name: "element: a, href: '//example.com', target: '_self'"
};
const AnchorElementNoRefferer = {
    render: (args)=>render({
            elementType: "a",
            href: "//example.com",
            rel: "noopener noreferrer",
            ...args
        }),
    name: "element: a, rel: 'noopener noreferrer'"
};
const UserSelect = {
    render: ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement(Example, null),
    parameters: {
        description: {
            data: "Pressing and holding on either buttons shouldn't trigger text selection on the button labels (wait for buttons to turn red)."
        }
    }
};
const PendingSpinner = {
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(Pending, args)
};
function render(props = {
    variant: "primary"
}) {
    let buttons = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
        gap: "size-200"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Button), props, "Default"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Button), {
        ...props,
        isDisabled: true
    }, "Disabled"));
    if (props.variant === "overBackground" || props.staticColor === "white") return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.View), {
        backgroundColor: "static-blue-700",
        UNSAFE_style: {
            padding: "15px 20px",
            display: "inline-block"
        }
    }, buttons);
    if (props.staticColor === "black") return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        style: {
            backgroundColor: "rgb(206, 247, 243)",
            color: "rgb(15, 121, 125)",
            padding: "15px 20px",
            display: "inline-block"
        }
    }, buttons);
    return buttons;
}
function renderIconText(props = {
    variant: "primary"
}) {
    let buttons = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
        gap: "size-200"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Button), props, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _bellDefault.default), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, "Default")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Button), {
        ...props,
        isDisabled: true
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _bellDefault.default), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, "Disabled")));
    if (props.variant === "overBackground" || props.staticColor === "white") return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.View), {
        backgroundColor: "static-blue-700",
        UNSAFE_style: {
            padding: "15px 20px",
            display: "inline-block"
        }
    }, buttons);
    if (props.staticColor === "black") return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        style: {
            backgroundColor: "rgb(206, 247, 243)",
            color: "rgb(15, 121, 125)",
            padding: "15px 20px",
            display: "inline-block"
        }
    }, buttons);
    return buttons;
}
function renderIconOnly(props = {
    variant: "primary"
}) {
    let buttons = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
        gap: "size-200"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _tooltip.TooltipTrigger), {
        offset: 2
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Button), {
        ...props,
        "aria-label": "Notifications"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _bellDefault.default), null)), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _tooltip.Tooltip), null, "Notifications")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _tooltip.TooltipTrigger), {
        offset: 2
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Button), {
        ...props,
        "aria-label": "Notifications (disabled)",
        isDisabled: true
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _bellDefault.default), null)), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _tooltip.Tooltip), null, "Notifications")));
    if (props.variant === "overBackground" || props.staticColor === "white") return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.View), {
        backgroundColor: "static-blue-700",
        UNSAFE_style: {
            padding: "15px 20px",
            display: "inline-block"
        }
    }, buttons);
    if (props.staticColor === "black") return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        style: {
            backgroundColor: "rgb(206, 247, 243)",
            color: "rgb(15, 121, 125)",
            padding: "15px 20px",
            display: "inline-block"
        }
    }, buttons);
    return buttons;
}
function Example() {
    let [show, setShow] = (0, _reactDefault.default).useState(false);
    let [show2, setShow2] = (0, _reactDefault.default).useState(false);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
        gap: "size-200"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Button), {
        variant: "cta",
        UNSAFE_style: show ? undefined : {
            background: "red",
            userSelect: "text"
        },
        onPressStart: ()=>setTimeout(()=>setShow(true), 3000)
    }, "Press and hold (overwrite)"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Button), {
        variant: "cta",
        UNSAFE_style: show2 ? undefined : {
            background: "red"
        },
        onPressStart: ()=>setTimeout(()=>setShow2(true), 3000)
    }, "Press and hold (no overwrite)"));
}
function PendingButtonContainerComponent(props) {
    let { children, ...otherProps } = props;
    function containerBackgroundColor(variant, staticColor) {
        if (variant === "overBackground" || staticColor === "white") return "static-blue-700";
        if (staticColor === "black") return "static-yellow-200";
        return;
    }
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.View), {
        backgroundColor: containerBackgroundColor(otherProps.variant, otherProps.staticColor),
        padding: 16,
        ...otherProps
    }, children);
}
function Pending(props) {
    let [tooltipPending, setTooltipPending] = (0, _react.useState)(false);
    let handlePress = (e)=>{
        (0, _addonActions.action)("press")(e);
        setTooltipPending(true);
        setTimeout(()=>{
            setTooltipPending(false);
        }, timerValue);
    };
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
        wrap: "wrap"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(PendingButtonContainerComponent, props, /*#__PURE__*/ (0, _reactDefault.default).createElement(PendingButtonComponent, props, "click me!")), /*#__PURE__*/ (0, _reactDefault.default).createElement(PendingButtonContainerComponent, props, /*#__PURE__*/ (0, _reactDefault.default).createElement(PendingButtonComponent, props, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _bellDefault.default), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, "I have an icon"))), /*#__PURE__*/ (0, _reactDefault.default).createElement(PendingButtonContainerComponent, props, /*#__PURE__*/ (0, _reactDefault.default).createElement(PendingButtonOnClickComponent, props, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, "with onClick"))), /*#__PURE__*/ (0, _reactDefault.default).createElement(PendingButtonContainerComponent, props, /*#__PURE__*/ (0, _reactDefault.default).createElement(PendingButtonComponent, {
        isDisabled: true,
        ...props
    }, "disabled"))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
        wrap: "wrap",
        alignItems: "center"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, 'Aria-label "Button label" on button'), /*#__PURE__*/ (0, _reactDefault.default).createElement(PendingButtonContainerComponent, props, /*#__PURE__*/ (0, _reactDefault.default).createElement(PendingButtonComponent, {
        ...props,
        "aria-label": "Button label"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _bellDefault.default), null))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, 'Aria-label "icon label" on icon'), /*#__PURE__*/ (0, _reactDefault.default).createElement(PendingButtonContainerComponent, props, /*#__PURE__*/ (0, _reactDefault.default).createElement(PendingButtonComponent, props, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _bellDefault.default), {
        "aria-label": "icon label"
    }))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, "No aria-labels--bad implementation"), /*#__PURE__*/ (0, _reactDefault.default).createElement(PendingButtonContainerComponent, props, /*#__PURE__*/ (0, _reactDefault.default).createElement(PendingButtonComponent, props, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _bellDefault.default), null))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, 'Tooltip and aria-label "Notifications" on button'), /*#__PURE__*/ (0, _reactDefault.default).createElement(PendingButtonContainerComponent, props, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _tooltip.TooltipTrigger), {
        offset: 2
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Button), {
        ...props,
        isPending: tooltipPending,
        onPress: handlePress,
        "aria-label": "Notifications"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _bellDefault.default), null)), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _tooltip.Tooltip), null, "Click here to view")))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
        wrap: "wrap",
        alignItems: "center"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(PendingButtonContainerComponent, props, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Button), {
        ...props,
        isPending: props.isPending,
        onPress: ()=>{
            window.alert("use storybook control to change this button isPending prop");
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, "Controlled")))));
}
let timerValue = 5000;
function PendingButtonComponent(props) {
    let [isPending, setPending] = (0, _react.useState)(false);
    let handlePress = (e)=>{
        (0, _addonActions.action)("press")(e);
        setPending(true);
        setTimeout(()=>{
            setPending(false);
        }, timerValue);
    };
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Button), {
        ...props,
        isPending: isPending,
        onPress: handlePress
    }, props.children);
}
function PendingButtonOnClickComponent(props) {
    let [isPending, setPending] = (0, _react.useState)(false);
    let handlePress = (e)=>{
        (0, _addonActions.action)("click")(e);
        setPending(true);
        setTimeout(()=>{
            setPending(false);
        }, timerValue);
    };
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Button), {
        ...props,
        isPending: isPending,
        onClick: handlePress
    }, props.children);
}

},{"@storybook/addon-actions":"coXbW","@spectrum-icons/workflow/Bell":"5FeJ6","../":"eMlIM","@react-spectrum/layout":"hzaUY","react":"9yzVZ","@react-spectrum/text":"etCGI","@react-spectrum/tooltip":"f9wa6","@react-spectrum/view":"dnRjt","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"5FeJ6":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("24c2d05a1ecf22b");
exports.__esModule = true;
exports.default = Bell;
var _Bell = require("5a8b3b5b54e3022c");
var _icon = require("c6cea259cc818313");
var _react = _interopRequireDefault(require("565e402e1e7bc640"));
function Bell(props) {
    return /*#__PURE__*/ _react.default.createElement(_icon.Icon, props, /*#__PURE__*/ _react.default.createElement(_Bell.A4uBell, null));
}

},{"24c2d05a1ecf22b":"iHubQ","5a8b3b5b54e3022c":"bNM4B","c6cea259cc818313":"k7wem","565e402e1e7bc640":"9yzVZ"}],"bNM4B":[function(require,module,exports) {
/**
* @adobe/react-spectrum-workflow (c) by Adobe
* 
* @adobe/react-spectrum-workflow is licensed under a
* Creative Commons Attribution-NoDerivatives 4.0 International License.
* 
* You should have received a copy of the license along with this
* work. If not, see <http://creativecommons.org/licenses/by-nd/4.0/>.
**/ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.A4uBell = A4uBell;
var _react = _interopRequireDefault(require("e208b523dcda009b"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function A4uBell(_ref) {
    var props = _extends({}, _ref);
    return /*#__PURE__*/ _react["default"].createElement("svg", _extends({
        viewBox: "0 0 36 36"
    }, props, props), /*#__PURE__*/ _react["default"].createElement("path", {
        fillRule: "evenodd",
        d: "M18,36a4.406,4.406,0,0,0,4-4H14A4.406,4.406,0,0,0,18,36Z"
    }), /*#__PURE__*/ _react["default"].createElement("path", {
        fillRule: "evenodd",
        d: "M27.143,11.385c0-3.437-3.206-4.891-7.143-5.268V3a1.079,1.079,0,0,0-1.143-1H17.143A1.079,1.079,0,0,0,16,3V6.117c-3.937.377-7.143,1.831-7.143,5.268C8.857,26.8,4,26.111,4,28.154V30H32V28.154C32,26,27.143,26.8,27.143,11.385Z"
    }));
}

},{"e208b523dcda009b":"9yzVZ"}],"gktLq":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Default", ()=>Default);
var _addonActions = require("@storybook/addon-actions");
var _ = require("../");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
exports.default = {
    title: "Button/LogicButton",
    component: (0, _.LogicButton),
    args: {
        onPress: (0, _addonActions.action)("press"),
        onPressStart: (0, _addonActions.action)("pressstart"),
        onPressEnd: (0, _addonActions.action)("pressend")
    },
    argTypes: {
        onPress: {
            table: {
                disable: true
            }
        },
        onPressStart: {
            table: {
                disable: true
            }
        },
        onPressEnd: {
            table: {
                disable: true
            }
        },
        autoFocus: {
            control: "boolean"
        },
        variant: {
            control: "select",
            options: [
                "and",
                "or"
            ],
            defaultValue: "and"
        }
    }
};
const Default = {
    render: (args)=>render(args)
};
function render(props = {}) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.LogicButton), props, "Default"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.LogicButton), {
        marginStart: "10px",
        isDisabled: true,
        ...props
    }, "Disabled"));
}

},{"@storybook/addon-actions":"coXbW","../":"eMlIM","react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"9b98N":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Default", ()=>Default);
parcelHelpers.export(exports, "StaticWhite", ()=>StaticWhite);
parcelHelpers.export(exports, "StaticBlack", ()=>StaticBlack);
parcelHelpers.export(exports, "WHCM", ()=>WHCM);
parcelHelpers.export(exports, "Controlled", ()=>Controlled);
var _addonActions = require("@storybook/addon-actions");
var _add = require("@spectrum-icons/workflow/Add");
var _addDefault = parcelHelpers.interopDefault(_add);
var _reactSpectrum = require("@adobe/react-spectrum");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _ = require("../");
exports.default = {
    title: "Button/ToggleButton",
    component: (0, _.ToggleButton),
    args: {
        onPress: (0, _addonActions.action)("press"),
        onPressStart: (0, _addonActions.action)("pressstart"),
        onPressEnd: (0, _addonActions.action)("pressend"),
        variant: "cta"
    },
    argTypes: {
        onPress: {
            table: {
                disable: true
            }
        },
        onPressStart: {
            table: {
                disable: true
            }
        },
        onPressEnd: {
            table: {
                disable: true
            }
        },
        staticColor: {
            table: {
                disable: true
            }
        },
        isQuiet: {
            control: "boolean"
        },
        isEmphasized: {
            control: "boolean"
        },
        isDisabled: {
            control: "boolean"
        },
        autoFocus: {
            control: "boolean"
        }
    }
};
const Default = {
    render: (args)=>render(args)
};
const StaticWhite = {
    args: {
        staticColor: "white"
    },
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSpectrum.View), {
            backgroundColor: "static-blue-700",
            padding: "size-1000"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSpectrum.Flex), {
            direction: "column",
            rowGap: "size-150"
        }, render(args))),
    name: "staticColor: white"
};
const StaticBlack = {
    args: {
        staticColor: "black"
    },
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSpectrum.View), {
            backgroundColor: "static-yellow-400",
            padding: "size-1000"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSpectrum.Flex), {
            direction: "column",
            rowGap: "size-150"
        }, render(args))),
    name: "staticColor: black"
};
const WHCM = {
    render: ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSpectrum.View), {
            backgroundColor: "static-yellow-400",
            padding: "size-1000"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSpectrum.Flex), {
            direction: "column",
            rowGap: "size-150"
        }, render(), render({
            isEmphasized: true
        }), render({
            isQuiet: true
        }), render({
            isQuiet: true,
            isEmphasized: true
        }))),
    name: "styles to check WHCM support"
};
const Controlled = {
    render: ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement(ControlledToggleButton, null),
    name: "controlled state"
};
function render(props = {}) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSpectrum.Flex), {
        gap: "size-100"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ToggleButton), {
        onChange: (0, _addonActions.action)("change"),
        onPress: (0, _addonActions.action)("press"),
        ...props
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _addDefault.default), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSpectrum.Text), null, "Default")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ToggleButton), {
        onChange: (0, _addonActions.action)("change"),
        onPress: (0, _addonActions.action)("press"),
        defaultSelected: true,
        ...props
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _addDefault.default), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSpectrum.Text), null, "Selected")));
}
function ControlledToggleButton() {
    let [selected, setSelected] = (0, _react.useState)(false);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ToggleButton), {
        isSelected: selected,
        onChange: setSelected
    }, "Press Me"), /*#__PURE__*/ (0, _reactDefault.default).createElement("br", null), selected ? "true" : "false");
}

},{"@storybook/addon-actions":"coXbW","@spectrum-icons/workflow/Add":"evYih","@adobe/react-spectrum":"cwANo","react":"9yzVZ","../":"eMlIM","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"cwANo":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Mark as a client only package. This will cause a build time error if you try 
// to import it from a React Server Component in a framework like Next.js.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ActionGroup", ()=>(0, _actiongroup.ActionGroup));
parcelHelpers.export(exports, "Badge", ()=>(0, _badge.Badge));
parcelHelpers.export(exports, "Breadcrumbs", ()=>(0, _breadcrumbs.Breadcrumbs));
parcelHelpers.export(exports, "ActionBar", ()=>(0, _actionbar.ActionBar));
parcelHelpers.export(exports, "ActionBarContainer", ()=>(0, _actionbar.ActionBarContainer));
parcelHelpers.export(exports, "ActionButton", ()=>(0, _button.ActionButton));
parcelHelpers.export(exports, "Button", ()=>(0, _button.Button));
parcelHelpers.export(exports, "LogicButton", ()=>(0, _button.LogicButton));
parcelHelpers.export(exports, "ToggleButton", ()=>(0, _button.ToggleButton));
parcelHelpers.export(exports, "Avatar", ()=>(0, _avatar.Avatar));
parcelHelpers.export(exports, "ButtonGroup", ()=>(0, _buttongroup.ButtonGroup));
parcelHelpers.export(exports, "Calendar", ()=>(0, _calendar.Calendar));
parcelHelpers.export(exports, "RangeCalendar", ()=>(0, _calendar.RangeCalendar));
parcelHelpers.export(exports, "Checkbox", ()=>(0, _checkbox.Checkbox));
parcelHelpers.export(exports, "CheckboxGroup", ()=>(0, _checkbox.CheckboxGroup));
parcelHelpers.export(exports, "ComboBox", ()=>(0, _combobox.ComboBox));
parcelHelpers.export(exports, "ContextualHelp", ()=>(0, _contextualhelp.ContextualHelp));
parcelHelpers.export(exports, "AlertDialog", ()=>(0, _dialog.AlertDialog));
parcelHelpers.export(exports, "Dialog", ()=>(0, _dialog.Dialog));
parcelHelpers.export(exports, "DialogTrigger", ()=>(0, _dialog.DialogTrigger));
parcelHelpers.export(exports, "DialogContainer", ()=>(0, _dialog.DialogContainer));
parcelHelpers.export(exports, "useDialogContainer", ()=>(0, _dialog.useDialogContainer));
parcelHelpers.export(exports, "DateField", ()=>(0, _datepicker.DateField));
parcelHelpers.export(exports, "DatePicker", ()=>(0, _datepicker.DatePicker));
parcelHelpers.export(exports, "DateRangePicker", ()=>(0, _datepicker.DateRangePicker));
parcelHelpers.export(exports, "TimeField", ()=>(0, _datepicker.TimeField));
parcelHelpers.export(exports, "Divider", ()=>(0, _divider.Divider));
parcelHelpers.export(exports, "Form", ()=>(0, _form.Form));
parcelHelpers.export(exports, "Icon", ()=>(0, _icon.Icon));
parcelHelpers.export(exports, "IllustratedMessage", ()=>(0, _illustratedmessage.IllustratedMessage));
parcelHelpers.export(exports, "InlineAlert", ()=>(0, _inlinealert.InlineAlert));
parcelHelpers.export(exports, "Image", ()=>(0, _image.Image));
parcelHelpers.export(exports, "Flex", ()=>(0, _layout.Flex));
parcelHelpers.export(exports, "Grid", ()=>(0, _layout.Grid));
parcelHelpers.export(exports, "fitContent", ()=>(0, _layout.fitContent));
parcelHelpers.export(exports, "minmax", ()=>(0, _layout.minmax));
parcelHelpers.export(exports, "repeat", ()=>(0, _layout.repeat));
parcelHelpers.export(exports, "LabeledValue", ()=>(0, _labeledvalue.LabeledValue));
parcelHelpers.export(exports, "Link", ()=>(0, _link.Link));
parcelHelpers.export(exports, "ListBox", ()=>(0, _listbox.ListBox));
parcelHelpers.export(exports, "ListView", ()=>(0, _list.ListView));
parcelHelpers.export(exports, "ActionMenu", ()=>(0, _menu.ActionMenu));
parcelHelpers.export(exports, "Menu", ()=>(0, _menu.Menu));
parcelHelpers.export(exports, "MenuTrigger", ()=>(0, _menu.MenuTrigger));
parcelHelpers.export(exports, "Meter", ()=>(0, _meter.Meter));
parcelHelpers.export(exports, "NumberField", ()=>(0, _numberfield.NumberField));
parcelHelpers.export(exports, "Picker", ()=>(0, _picker.Picker));
parcelHelpers.export(exports, "ProgressBar", ()=>(0, _progress.ProgressBar));
parcelHelpers.export(exports, "ProgressCircle", ()=>(0, _progress.ProgressCircle));
parcelHelpers.export(exports, "Provider", ()=>(0, _provider.Provider));
parcelHelpers.export(exports, "useProvider", ()=>(0, _provider.useProvider));
parcelHelpers.export(exports, "Radio", ()=>(0, _radio.Radio));
parcelHelpers.export(exports, "RadioGroup", ()=>(0, _radio.RadioGroup));
parcelHelpers.export(exports, "RangeSlider", ()=>(0, _slider.RangeSlider));
parcelHelpers.export(exports, "Slider", ()=>(0, _slider.Slider));
parcelHelpers.export(exports, "SearchField", ()=>(0, _searchfield.SearchField));
parcelHelpers.export(exports, "StatusLight", ()=>(0, _statuslight.StatusLight));
parcelHelpers.export(exports, "Switch", ()=>(0, _switch.Switch));
parcelHelpers.export(exports, "Heading", ()=>(0, _text.Heading));
parcelHelpers.export(exports, "Keyboard", ()=>(0, _text.Keyboard));
parcelHelpers.export(exports, "Text", ()=>(0, _text.Text));
parcelHelpers.export(exports, "TableView", ()=>(0, _table.TableView));
parcelHelpers.export(exports, "TableHeader", ()=>(0, _table.TableHeader));
parcelHelpers.export(exports, "TableBody", ()=>(0, _table.TableBody));
parcelHelpers.export(exports, "Column", ()=>(0, _table.Column));
parcelHelpers.export(exports, "Row", ()=>(0, _table.Row));
parcelHelpers.export(exports, "Cell", ()=>(0, _table.Cell));
parcelHelpers.export(exports, "Tabs", ()=>(0, _tabs.Tabs));
parcelHelpers.export(exports, "TabList", ()=>(0, _tabs.TabList));
parcelHelpers.export(exports, "TabPanels", ()=>(0, _tabs.TabPanels));
parcelHelpers.export(exports, "TagGroup", ()=>(0, _tag.TagGroup));
parcelHelpers.export(exports, "TextArea", ()=>(0, _textfield.TextArea));
parcelHelpers.export(exports, "TextField", ()=>(0, _textfield.TextField));
parcelHelpers.export(exports, "darkTheme", ()=>(0, _themeDark.theme));
parcelHelpers.export(exports, "defaultTheme", ()=>(0, _themeDefault.theme));
parcelHelpers.export(exports, "lightTheme", ()=>(0, _themeLight.theme));
parcelHelpers.export(exports, "Tooltip", ()=>(0, _tooltip.Tooltip));
parcelHelpers.export(exports, "TooltipTrigger", ()=>(0, _tooltip.TooltipTrigger));
parcelHelpers.export(exports, "Content", ()=>(0, _view.Content));
parcelHelpers.export(exports, "Footer", ()=>(0, _view.Footer));
parcelHelpers.export(exports, "Header", ()=>(0, _view.Header));
parcelHelpers.export(exports, "View", ()=>(0, _view.View));
parcelHelpers.export(exports, "Well", ()=>(0, _well.Well));
parcelHelpers.export(exports, "Item", ()=>(0, _collections.Item));
parcelHelpers.export(exports, "Section", ()=>(0, _collections.Section));
parcelHelpers.export(exports, "useAsyncList", ()=>(0, _data.useAsyncList));
parcelHelpers.export(exports, "useListData", ()=>(0, _data.useListData));
parcelHelpers.export(exports, "useTreeData", ()=>(0, _data.useTreeData));
parcelHelpers.export(exports, "VisuallyHidden", ()=>(0, _visuallyHidden.VisuallyHidden));
parcelHelpers.export(exports, "useCollator", ()=>(0, _i18N.useCollator));
parcelHelpers.export(exports, "useDateFormatter", ()=>(0, _i18N.useDateFormatter));
parcelHelpers.export(exports, "useFilter", ()=>(0, _i18N.useFilter));
parcelHelpers.export(exports, "useLocale", ()=>(0, _i18N.useLocale));
parcelHelpers.export(exports, "useLocalizedStringFormatter", ()=>(0, _i18N.useLocalizedStringFormatter));
parcelHelpers.export(exports, "useMessageFormatter", ()=>(0, _i18N.useMessageFormatter));
parcelHelpers.export(exports, "useNumberFormatter", ()=>(0, _i18N.useNumberFormatter));
parcelHelpers.export(exports, "SSRProvider", ()=>(0, _ssr.SSRProvider));
parcelHelpers.export(exports, "useDragAndDrop", ()=>(0, _dnd.useDragAndDrop));
parcelHelpers.export(exports, "DIRECTORY_DRAG_TYPE", ()=>(0, _dnd.DIRECTORY_DRAG_TYPE));
var _clientOnly = require("client-only");
var _actiongroup = require("@react-spectrum/actiongroup");
var _badge = require("@react-spectrum/badge");
var _breadcrumbs = require("@react-spectrum/breadcrumbs");
var _actionbar = require("@react-spectrum/actionbar");
var _button = require("@react-spectrum/button");
var _avatar = require("@react-spectrum/avatar");
var _buttongroup = require("@react-spectrum/buttongroup");
var _calendar = require("@react-spectrum/calendar");
var _checkbox = require("@react-spectrum/checkbox");
var _combobox = require("@react-spectrum/combobox");
var _contextualhelp = require("@react-spectrum/contextualhelp");
var _dialog = require("@react-spectrum/dialog");
var _datepicker = require("@react-spectrum/datepicker");
var _divider = require("@react-spectrum/divider");
var _form = require("@react-spectrum/form");
var _icon = require("@react-spectrum/icon");
var _illustratedmessage = require("@react-spectrum/illustratedmessage");
var _inlinealert = require("@react-spectrum/inlinealert");
var _image = require("@react-spectrum/image");
var _layout = require("@react-spectrum/layout");
var _labeledvalue = require("@react-spectrum/labeledvalue");
var _link = require("@react-spectrum/link");
var _listbox = require("@react-spectrum/listbox");
var _list = require("@react-spectrum/list");
var _menu = require("@react-spectrum/menu");
var _meter = require("@react-spectrum/meter");
var _numberfield = require("@react-spectrum/numberfield");
var _picker = require("@react-spectrum/picker");
var _progress = require("@react-spectrum/progress");
var _provider = require("@react-spectrum/provider");
var _radio = require("@react-spectrum/radio");
var _slider = require("@react-spectrum/slider");
var _searchfield = require("@react-spectrum/searchfield");
var _statuslight = require("@react-spectrum/statuslight");
var _switch = require("@react-spectrum/switch");
var _text = require("@react-spectrum/text");
var _table = require("@react-spectrum/table");
var _tabs = require("@react-spectrum/tabs");
var _tag = require("@react-spectrum/tag");
var _textfield = require("@react-spectrum/textfield");
var _themeDark = require("@react-spectrum/theme-dark");
var _themeDefault = require("@react-spectrum/theme-default");
var _themeLight = require("@react-spectrum/theme-light");
var _tooltip = require("@react-spectrum/tooltip");
var _view = require("@react-spectrum/view");
var _well = require("@react-spectrum/well");
var _collections = require("@react-stately/collections");
var _data = require("@react-stately/data");
var _visuallyHidden = require("@react-aria/visually-hidden");
var _i18N = require("@react-aria/i18n");
var _ssr = require("@react-aria/ssr");
var _dnd = require("@react-spectrum/dnd");

},{"client-only":"cUERd","@react-spectrum/actiongroup":"hkqBV","@react-spectrum/badge":false,"@react-spectrum/breadcrumbs":false,"@react-spectrum/actionbar":false,"@react-spectrum/button":"jZWyP","@react-spectrum/avatar":"kHDr1","@react-spectrum/buttongroup":false,"@react-spectrum/calendar":false,"@react-spectrum/checkbox":false,"@react-spectrum/combobox":false,"@react-spectrum/contextualhelp":"jA6za","@react-spectrum/dialog":"3G0HV","@react-spectrum/datepicker":false,"@react-spectrum/divider":false,"@react-spectrum/form":false,"@react-spectrum/icon":false,"@react-spectrum/illustratedmessage":false,"@react-spectrum/inlinealert":false,"@react-spectrum/image":false,"@react-spectrum/layout":"hzaUY","@react-spectrum/labeledvalue":false,"@react-spectrum/link":"lNoiB","@react-spectrum/listbox":false,"@react-spectrum/list":false,"@react-spectrum/menu":false,"@react-spectrum/meter":false,"@react-spectrum/numberfield":false,"@react-spectrum/picker":false,"@react-spectrum/progress":false,"@react-spectrum/provider":"5bCdp","@react-spectrum/radio":false,"@react-spectrum/slider":false,"@react-spectrum/searchfield":false,"@react-spectrum/statuslight":false,"@react-spectrum/switch":false,"@react-spectrum/text":"etCGI","@react-spectrum/table":false,"@react-spectrum/tabs":false,"@react-spectrum/tag":false,"@react-spectrum/textfield":false,"@react-spectrum/theme-dark":false,"@react-spectrum/theme-default":false,"@react-spectrum/theme-light":false,"@react-spectrum/tooltip":false,"@react-spectrum/view":"dnRjt","@react-spectrum/well":false,"@react-stately/collections":false,"@react-stately/data":false,"@react-aria/visually-hidden":false,"@react-aria/i18n":"411rg","@react-aria/ssr":false,"@react-spectrum/dnd":false,"@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"9d2lg":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /// <reference types="css-module-types" />
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Calendar", ()=>(0, _calendar.Calendar));
parcelHelpers.export(exports, "RangeCalendar", ()=>(0, _rangeCalendar.RangeCalendar));
var _calendar = require("./Calendar");
var _rangeCalendar = require("./RangeCalendar");

},{"./Calendar":"7liqQ","./RangeCalendar":"fMCdY","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"7liqQ":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Calendar", ()=>_Calendar);
var _calendarBase = require("./CalendarBase");
var _date = require("@internationalized/date");
var _utils = require("@react-spectrum/utils");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _calendar = require("@react-aria/calendar");
var _calendar1 = require("@react-stately/calendar");
var _i18N = require("@react-aria/i18n");
var _provider = require("@react-spectrum/provider");
function Calendar(props, ref) {
    props = (0, _provider.useProviderProps)(props);
    let { visibleMonths = 1 } = props;
    visibleMonths = Math.max(visibleMonths, 1);
    let visibleDuration = (0, _react.useMemo)(()=>({
            months: visibleMonths
        }), [
        visibleMonths
    ]);
    let { locale } = (0, _i18N.useLocale)();
    let state = (0, _calendar1.useCalendarState)({
        ...props,
        locale,
        visibleDuration,
        createCalendar: (0, _date.createCalendar)
    });
    let domRef = (0, _react.useRef)();
    (0, _react.useImperativeHandle)(ref, ()=>({
            ...(0, _utils.createDOMRef)(domRef),
            focus () {
                state.setFocused(true);
            }
        }));
    let { calendarProps, prevButtonProps, nextButtonProps, errorMessageProps } = (0, _calendar.useCalendar)(props, state);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _calendarBase.CalendarBase), {
        ...props,
        visibleMonths: visibleMonths,
        state: state,
        calendarRef: domRef,
        calendarProps: calendarProps,
        prevButtonProps: prevButtonProps,
        nextButtonProps: nextButtonProps,
        errorMessageProps: errorMessageProps
    });
}
/**
 * Calendars display a grid of days in one or more months and allow users to select a single date.
 */ const _Calendar = /*#__PURE__*/ (0, _reactDefault.default).forwardRef(Calendar);

},{"./CalendarBase":"8g1x3","@internationalized/date":"hesBk","@react-spectrum/utils":"cMIJ6","react":"9yzVZ","@react-aria/calendar":"98n7T","@react-stately/calendar":"a8x0w","@react-aria/i18n":"411rg","@react-spectrum/provider":"5bCdp","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"8g1x3":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CalendarBase", ()=>CalendarBase);
var _button = require("@react-spectrum/button");
var _calendarMonth = require("./CalendarMonth");
var _chevronLeftLarge = require("@spectrum-icons/ui/ChevronLeftLarge");
var _chevronLeftLargeDefault = parcelHelpers.interopDefault(_chevronLeftLarge);
var _chevronRightLarge = require("@spectrum-icons/ui/ChevronRightLarge");
var _chevronRightLargeDefault = parcelHelpers.interopDefault(_chevronRightLarge);
var _utils = require("@react-spectrum/utils");
var _label = require("@react-spectrum/label");
// @ts-ignore
var _json = require("../intl/*.json");
var _jsonDefault = parcelHelpers.interopDefault(_json);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _varsCss = require("@adobe/spectrum-css-temp/components/calendar/vars.css");
var _varsCssDefault = parcelHelpers.interopDefault(_varsCss);
var _i18N = require("@react-aria/i18n");
var _visuallyHidden = require("@react-aria/visually-hidden");
function CalendarBase(props) {
    let { state, calendarProps, nextButtonProps, prevButtonProps, errorMessageProps, calendarRef: ref, visibleMonths = 1 } = props;
    let { styleProps } = (0, _utils.useStyleProps)(props);
    let stringFormatter = (0, _i18N.useLocalizedStringFormatter)((0, _jsonDefault.default), "@react-spectrum/calendar");
    let { direction } = (0, _i18N.useLocale)();
    let currentMonth = state.visibleRange.start;
    let monthDateFormatter = (0, _i18N.useDateFormatter)({
        month: "long",
        year: "numeric",
        era: currentMonth.calendar.identifier === "gregory" && currentMonth.era === "BC" ? "short" : undefined,
        calendar: currentMonth.calendar.identifier,
        timeZone: state.timeZone
    });
    let titles = [];
    let calendars = [];
    for(let i = 0; i < visibleMonths; i++){
        let d = currentMonth.add({
            months: i
        });
        titles.push(/*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
            key: i,
            className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Calendar-monthHeader")
        }, i === 0 && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), {
            ...prevButtonProps,
            UNSAFE_className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Calendar-prevMonth"),
            isQuiet: true
        }, direction === "rtl" ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _chevronRightLargeDefault.default), null) : /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _chevronLeftLargeDefault.default), null)), /*#__PURE__*/ (0, _reactDefault.default).createElement("h2", {
            // We have a visually hidden heading describing the entire visible range,
            // and the calendar itself describes the individual month
            // so we don't need to repeat that here for screen reader users.
            "aria-hidden": true,
            className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Calendar-title")
        }, monthDateFormatter.format(d.toDate(state.timeZone))), i === visibleMonths - 1 && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), {
            ...nextButtonProps,
            UNSAFE_className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Calendar-nextMonth"),
            isQuiet: true
        }, direction === "rtl" ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _chevronLeftLargeDefault.default), null) : /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _chevronRightLargeDefault.default), null))));
        calendars.push(/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _calendarMonth.CalendarMonth), {
            ...props,
            key: i,
            state: state,
            startDate: d
        }));
    }
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...styleProps,
        ...calendarProps,
        ref: ref,
        className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Calendar", styleProps.className)
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _visuallyHidden.VisuallyHidden), null, /*#__PURE__*/ (0, _reactDefault.default).createElement("h2", null, calendarProps["aria-label"])), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Calendar-header")
    }, titles), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Calendar-months")
    }, calendars), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _visuallyHidden.VisuallyHidden), null, /*#__PURE__*/ (0, _reactDefault.default).createElement("button", {
        "aria-label": nextButtonProps["aria-label"],
        disabled: nextButtonProps.isDisabled,
        onClick: ()=>state.focusNextPage(),
        tabIndex: -1
    })), state.isValueInvalid && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _label.HelpText), {
        showErrorIcon: true,
        errorMessage: props.errorMessage || stringFormatter.format("invalidSelection", {
            selectedCount: "highlightedRange" in state ? 2 : 1
        }),
        errorMessageProps: errorMessageProps,
        isInvalid: true,
        // Intentionally a global class name so it can be targeted in DatePicker CSS...
        UNSAFE_className: "spectrum-Calendar-helpText"
    }));
}

},{"@react-spectrum/button":"jZWyP","./CalendarMonth":"cpMVo","@spectrum-icons/ui/ChevronLeftLarge":"jZC4w","@spectrum-icons/ui/ChevronRightLarge":"8eJMc","@react-spectrum/utils":"cMIJ6","@react-spectrum/label":"6qv6N","../intl/*.json":"hh0Mm","react":"9yzVZ","@adobe/spectrum-css-temp/components/calendar/vars.css":"cpOyi","@react-aria/i18n":"411rg","@react-aria/visually-hidden":"4jwxT","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"cpMVo":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CalendarMonth", ()=>CalendarMonth);
var _calendarCell = require("./CalendarCell");
var _date = require("@internationalized/date");
var _utils = require("@react-spectrum/utils");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _varsCss = require("@adobe/spectrum-css-temp/components/calendar/vars.css");
var _varsCssDefault = parcelHelpers.interopDefault(_varsCss);
var _calendar = require("@react-aria/calendar");
var _i18N = require("@react-aria/i18n");
function CalendarMonth(props) {
    let { state, startDate } = props;
    let { gridProps, headerProps, weekDays } = (0, _calendar.useCalendarGrid)({
        ...props,
        endDate: (0, _date.endOfMonth)(startDate)
    }, state);
    let { locale } = (0, _i18N.useLocale)();
    let weeksInMonth = (0, _date.getWeeksInMonth)(startDate, locale);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("table", {
        ...gridProps,
        className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Calendar-body", "spectrum-Calendar-table")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("thead", headerProps, /*#__PURE__*/ (0, _reactDefault.default).createElement("tr", null, weekDays.map((day, index)=>/*#__PURE__*/ (0, _reactDefault.default).createElement("th", {
            key: index,
            className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Calendar-tableCell")
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
            className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Calendar-dayOfWeek")
        }, day))))), /*#__PURE__*/ (0, _reactDefault.default).createElement("tbody", null, [
        ...new Array(weeksInMonth).keys()
    ].map((weekIndex)=>/*#__PURE__*/ (0, _reactDefault.default).createElement("tr", {
            key: weekIndex
        }, state.getDatesInWeek(weekIndex, startDate).map((date, i)=>date ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _calendarCell.CalendarCell), {
                key: i,
                state: state,
                date: date,
                currentMonth: startDate
            }) : /*#__PURE__*/ (0, _reactDefault.default).createElement("td", {
                key: i
            }))))));
}

},{"./CalendarCell":"aCAvh","@internationalized/date":"hesBk","@react-spectrum/utils":"cMIJ6","react":"9yzVZ","@adobe/spectrum-css-temp/components/calendar/vars.css":"cpOyi","@react-aria/calendar":"98n7T","@react-aria/i18n":"411rg","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"aCAvh":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CalendarCell", ()=>CalendarCell);
var _calendar = require("@react-aria/calendar");
var _date = require("@internationalized/date");
var _utils = require("@react-spectrum/utils");
var _utils1 = require("@react-aria/utils");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _varsCss = require("@adobe/spectrum-css-temp/components/calendar/vars.css");
var _varsCssDefault = parcelHelpers.interopDefault(_varsCss);
var _focus = require("@react-aria/focus");
var _interactions = require("@react-aria/interactions");
var _i18N = require("@react-aria/i18n");
function CalendarCell({ state, currentMonth, ...props }) {
    let ref = (0, _react.useRef)();
    let { cellProps, buttonProps, isPressed, isSelected, isDisabled, isFocused, isInvalid, formattedDate } = (0, _calendar.useCalendarCell)({
        ...props,
        isDisabled: !(0, _date.isSameMonth)(props.date, currentMonth)
    }, state, ref);
    let isUnavailable = state.isCellUnavailable(props.date) && !isDisabled;
    let isLastSelectedBeforeDisabled = !isDisabled && !isInvalid && state.isCellUnavailable(props.date.add({
        days: 1
    }));
    let isFirstSelectedAfterDisabled = !isDisabled && !isInvalid && state.isCellUnavailable(props.date.subtract({
        days: 1
    }));
    let highlightedRange = "highlightedRange" in state && state.highlightedRange;
    let isSelectionStart = isSelected && highlightedRange && (0, _date.isSameDay)(props.date, highlightedRange.start);
    let isSelectionEnd = isSelected && highlightedRange && (0, _date.isSameDay)(props.date, highlightedRange.end);
    let { locale } = (0, _i18N.useLocale)();
    let dayOfWeek = (0, _date.getDayOfWeek)(props.date, locale);
    let isRangeStart = isSelected && (isFirstSelectedAfterDisabled || dayOfWeek === 0 || props.date.day === 1);
    let isRangeEnd = isSelected && (isLastSelectedBeforeDisabled || dayOfWeek === 6 || props.date.day === currentMonth.calendar.getDaysInMonth(currentMonth));
    let { focusProps, isFocusVisible } = (0, _focus.useFocusRing)();
    let { hoverProps, isHovered } = (0, _interactions.useHover)({
        isDisabled: isDisabled || isUnavailable || state.isReadOnly
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("td", {
        ...cellProps,
        className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Calendar-tableCell")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        ...(0, _utils1.mergeProps)(buttonProps, hoverProps, focusProps),
        ref: ref,
        className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Calendar-date", {
            "is-today": (0, _date.isToday)(props.date, state.timeZone),
            "is-selected": isSelected,
            "is-focused": isFocused && isFocusVisible,
            // Style disabled (i.e. out of min/max range), but selected dates as unavailable
            // since it is more clear than trying to dim the selection.
            "is-disabled": isDisabled && !isInvalid,
            "is-unavailable": isUnavailable || isInvalid && isDisabled,
            "is-outsideMonth": !(0, _date.isSameMonth)(props.date, currentMonth),
            "is-range-start": isRangeStart,
            "is-range-end": isRangeEnd,
            "is-range-selection": isSelected && "highlightedRange" in state,
            "is-selection-start": isSelectionStart,
            "is-selection-end": isSelectionEnd,
            "is-hovered": isHovered,
            "is-pressed": isPressed && !state.isReadOnly,
            "is-invalid": isInvalid
        })
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Calendar-dateText")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("span", null, formattedDate))));
}

},{"@react-aria/calendar":"98n7T","@internationalized/date":"hesBk","@react-spectrum/utils":"cMIJ6","@react-aria/utils":"9cLk5","react":"9yzVZ","@adobe/spectrum-css-temp/components/calendar/vars.css":"cpOyi","@react-aria/focus":"42mbF","@react-aria/interactions":"ky3G8","@react-aria/i18n":"411rg","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"cpOyi":[function(require,module,exports) {
module.exports["focus-ring"] = `EuwYBq_focus-ring`;
module.exports["i18nFontFamily"] = `EuwYBq_i18nFontFamily`;
module.exports["is-disabled"] = `EuwYBq_is-disabled`;
module.exports["is-focused"] = `EuwYBq_is-focused`;
module.exports["is-hovered"] = `EuwYBq_is-hovered`;
module.exports["is-invalid"] = `EuwYBq_is-invalid`;
module.exports["is-outsideMonth"] = `EuwYBq_is-outsideMonth`;
module.exports["is-pressed"] = `EuwYBq_is-pressed`;
module.exports["is-range-end"] = `EuwYBq_is-range-end`;
module.exports["is-range-selection"] = `EuwYBq_is-range-selection`;
module.exports["is-range-start"] = `EuwYBq_is-range-start`;
module.exports["is-selected"] = `EuwYBq_is-selected`;
module.exports["is-selection-end"] = `EuwYBq_is-selection-end`;
module.exports["is-selection-start"] = `EuwYBq_is-selection-start`;
module.exports["is-today"] = `EuwYBq_is-today`;
module.exports["is-unavailable"] = `EuwYBq_is-unavailable`;
module.exports["next"] = `EuwYBq_next`;
module.exports["prev"] = `EuwYBq_prev`;
module.exports["spectrum-Calendar"] = `EuwYBq_spectrum-Calendar`;
module.exports["spectrum-Calendar--padded"] = `EuwYBq_spectrum-Calendar--padded`;
module.exports["spectrum-Calendar-body"] = `EuwYBq_spectrum-Calendar-body`;
module.exports["spectrum-Calendar-date"] = `EuwYBq_spectrum-Calendar-date`;
module.exports["spectrum-Calendar-dateText"] = `EuwYBq_spectrum-Calendar-dateText`;
module.exports["spectrum-Calendar-dayOfWeek"] = `EuwYBq_spectrum-Calendar-dayOfWeek`;
module.exports["spectrum-Calendar-header"] = `EuwYBq_spectrum-Calendar-header`;
module.exports["spectrum-Calendar-monthHeader"] = `EuwYBq_spectrum-Calendar-monthHeader`;
module.exports["spectrum-Calendar-months"] = `EuwYBq_spectrum-Calendar-months`;
module.exports["spectrum-Calendar-nextMonth"] = `EuwYBq_spectrum-Calendar-nextMonth`;
module.exports["spectrum-Calendar-prevMonth"] = `EuwYBq_spectrum-Calendar-prevMonth`;
module.exports["spectrum-Calendar-table"] = `EuwYBq_spectrum-Calendar-table`;
module.exports["spectrum-Calendar-tableCell"] = `EuwYBq_spectrum-Calendar-tableCell`;
module.exports["spectrum-Calendar-title"] = `EuwYBq_spectrum-Calendar-title`;
module.exports["spectrum-FocusRing-ring"] = `EuwYBq_spectrum-FocusRing-ring`;
module.exports["spectrum-FocusRing"] = `EuwYBq_spectrum-FocusRing ${module.exports["spectrum-FocusRing-ring"]}`;
module.exports["spectrum-FocusRing--quiet"] = `EuwYBq_spectrum-FocusRing--quiet`;
module.exports["title"] = `EuwYBq_title`;

},{}],"jZC4w":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("f668d7fe13324f3b");
exports.__esModule = true;
exports.default = ChevronLeftLarge;
var _ChevronLeftLarge = require("8e613a2679acb5e0");
var _icon = require("298467df3fb5ec1");
var _react = _interopRequireDefault(require("a476ca40dc9f9d23"));
function ChevronLeftLarge(props) {
    return /*#__PURE__*/ _react.default.createElement(_icon.UIIcon, props, /*#__PURE__*/ _react.default.createElement(_ChevronLeftLarge.ChevronLeftLarge, null));
}

},{"f668d7fe13324f3b":"iHubQ","8e613a2679acb5e0":"lAcHR","298467df3fb5ec1":"k7wem","a476ca40dc9f9d23":"9yzVZ"}],"lAcHR":[function(require,module,exports) {
/**
* @adobe/react-spectrum-ui (c) by Adobe
* 
* @adobe/react-spectrum-ui is licensed under a
* Creative Commons Attribution-NoDerivatives 4.0 International License.
* 
* You should have received a copy of the license along with this
* work. If not, see <http://creativecommons.org/licenses/by-nd/4.0/>.
**/ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ChevronLeftLarge = ChevronLeftLarge;
var _react = _interopRequireDefault(require("2d99549919fdd7df"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function ChevronLeftLarge(_ref) {
    var _ref$scale = _ref.scale, scale = _ref$scale === void 0 ? "M" : _ref$scale, props = _objectWithoutProperties(_ref, [
        "scale"
    ]);
    return _react["default"].createElement("svg", _extends({}, props, props), scale === "L" && _react["default"].createElement("path", {
        d: "M12.109 17.853l-8.066-7.849 8.066-7.84a1.243 1.243 0 0 0 .381-.894 1.24 1.24 0 0 0-2.12-.894L1.379 9.108a1.246 1.246 0 0 0 .003 1.79l8.99 8.744a1.247 1.247 0 1 0 1.738-1.789z"
    }), scale === "M" && _react["default"].createElement("path", {
        d: "M9.605 13.843L3.55 8l6.056-5.84A1.248 1.248 0 1 0 7.876.363L.882 7.1a1.243 1.243 0 0 0 .003 1.797l6.988 6.742a1.248 1.248 0 1 0 1.732-1.796z"
    }));
}
ChevronLeftLarge.displayName = "ChevronLeftLarge";

},{"2d99549919fdd7df":"9yzVZ"}],"8eJMc":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("8175a8fe411c3c1a");
exports.__esModule = true;
exports.default = ChevronRightLarge;
var _ChevronRightLarge = require("2839b04f35647f77");
var _icon = require("d16d075839f9a5e5");
var _react = _interopRequireDefault(require("614fa68b62df3480"));
function ChevronRightLarge(props) {
    return /*#__PURE__*/ _react.default.createElement(_icon.UIIcon, props, /*#__PURE__*/ _react.default.createElement(_ChevronRightLarge.ChevronRightLarge, null));
}

},{"8175a8fe411c3c1a":"iHubQ","2839b04f35647f77":"gLEtv","d16d075839f9a5e5":"k7wem","614fa68b62df3480":"9yzVZ"}],"gLEtv":[function(require,module,exports) {
/**
* @adobe/react-spectrum-ui (c) by Adobe
* 
* @adobe/react-spectrum-ui is licensed under a
* Creative Commons Attribution-NoDerivatives 4.0 International License.
* 
* You should have received a copy of the license along with this
* work. If not, see <http://creativecommons.org/licenses/by-nd/4.0/>.
**/ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ChevronRightLarge = ChevronRightLarge;
var _react = _interopRequireDefault(require("971c1e238f42bcc3"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function ChevronRightLarge(_ref) {
    var _ref$scale = _ref.scale, scale = _ref$scale === void 0 ? "M" : _ref$scale, props = _objectWithoutProperties(_ref, [
        "scale"
    ]);
    return _react["default"].createElement("svg", _extends({}, props, props), scale === "L" && _react["default"].createElement("path", {
        d: "M15 10.004a1.243 1.243 0 0 0-.38-.894L5.631.364a1.249 1.249 0 1 0-1.741 1.79l8.066 7.85-8.069 7.847a1.249 1.249 0 0 0 1.741 1.79l8.992-8.74a1.246 1.246 0 0 0 .379-.897z"
    }), scale === "M" && _react["default"].createElement("path", {
        d: "M11.5 8a1.241 1.241 0 0 0-.386-.897L4.128.36a1.248 1.248 0 1 0-1.733 1.797L8.45 8l-6.058 5.84a1.248 1.248 0 1 0 1.733 1.797L11.117 8.9A1.245 1.245 0 0 0 11.5 8z"
    }));
}
ChevronRightLarge.displayName = "ChevronRightLarge";

},{"971c1e238f42bcc3":"9yzVZ"}],"hh0Mm":[function(require,module,exports) {
const _temp0 = require("1fd7049e0fe289b6");
const _temp1 = require("f861a2e8f7f44505");
const _temp2 = require("378fbd2383cf4c03");
const _temp3 = require("cad49d0eea6378a1");
const _temp4 = require("dd9bd57bc924b41a");
const _temp5 = require("d9193c8c6a6008a");
const _temp6 = require("dd8456efc8cfcf72");
const _temp7 = require("9f49aba4e3c89da4");
const _temp8 = require("da1fca48ed465db3");
const _temp9 = require("8f36cb3051e36c3b");
const _temp10 = require("d71c1086d81417ab");
const _temp11 = require("60a503535d7e45a5");
const _temp12 = require("614a4a0fd3d0a3d0");
const _temp13 = require("e3b2368f62b7b319");
const _temp14 = require("da728be0554d5a49");
const _temp15 = require("89cd3f67b385ddbd");
const _temp16 = require("634061c9b060546f");
const _temp17 = require("cdcda18e12a750b");
const _temp18 = require("32e47e97fa3aaa5c");
const _temp19 = require("b738222776fc1375");
const _temp20 = require("77ec52d5bbf34707");
const _temp21 = require("972f46d034c2383d");
const _temp22 = require("2148e6033bb1ea93");
const _temp23 = require("f183dc7a3349699e");
const _temp24 = require("a9e97e46dd1d1150");
const _temp25 = require("2b6aa50ad36c9956");
const _temp26 = require("ceb9a9104ba8c0b2");
const _temp27 = require("dcc88d0ed9c5a026");
const _temp28 = require("308e99404a8ff55f");
const _temp29 = require("ab00840b04a597e9");
const _temp30 = require("1092eca705fc0a44");
const _temp31 = require("8d1238fedb172627");
const _temp32 = require("f3d3b744e9929929");
const _temp33 = require("b48d6f109b1746a7");
module.exports = {
    "ar-AE": _temp0,
    "bg-BG": _temp1,
    "cs-CZ": _temp2,
    "da-DK": _temp3,
    "de-DE": _temp4,
    "el-GR": _temp5,
    "en-US": _temp6,
    "es-ES": _temp7,
    "et-EE": _temp8,
    "fi-FI": _temp9,
    "fr-FR": _temp10,
    "he-IL": _temp11,
    "hr-HR": _temp12,
    "hu-HU": _temp13,
    "it-IT": _temp14,
    "ja-JP": _temp15,
    "ko-KR": _temp16,
    "lt-LT": _temp17,
    "lv-LV": _temp18,
    "nb-NO": _temp19,
    "nl-NL": _temp20,
    "pl-PL": _temp21,
    "pt-BR": _temp22,
    "pt-PT": _temp23,
    "ro-RO": _temp24,
    "ru-RU": _temp25,
    "sk-SK": _temp26,
    "sl-SI": _temp27,
    "sr-SP": _temp28,
    "sv-SE": _temp29,
    "tr-TR": _temp30,
    "uk-UA": _temp31,
    "zh-CN": _temp32,
    "zh-TW": _temp33
};

},{"1fd7049e0fe289b6":"hlKNy","f861a2e8f7f44505":"epZnn","378fbd2383cf4c03":"7OabR","cad49d0eea6378a1":"lkzwK","dd9bd57bc924b41a":"2lxMf","d9193c8c6a6008a":"cpINt","dd8456efc8cfcf72":"kk8ms","9f49aba4e3c89da4":"edpRB","da1fca48ed465db3":"2Z81C","8f36cb3051e36c3b":"lqGv6","d71c1086d81417ab":"allwk","60a503535d7e45a5":"3TGgs","614a4a0fd3d0a3d0":"4hriS","e3b2368f62b7b319":"gmTm7","da728be0554d5a49":"jD7Rv","89cd3f67b385ddbd":"ix8B9","634061c9b060546f":"l6nCd","cdcda18e12a750b":"4xhTx","32e47e97fa3aaa5c":"vll2n","b738222776fc1375":"g2gXn","77ec52d5bbf34707":"jgqWe","972f46d034c2383d":"eG6EE","2148e6033bb1ea93":"kbgQZ","f183dc7a3349699e":"Kdf0A","a9e97e46dd1d1150":"aaXpa","2b6aa50ad36c9956":"jW06q","ceb9a9104ba8c0b2":"72bVj","dcc88d0ed9c5a026":"30GDe","308e99404a8ff55f":"lWhQ9","ab00840b04a597e9":"fc1nU","1092eca705fc0a44":"iJbsa","8d1238fedb172627":"hgVXF","f3d3b744e9929929":"jgWDH","b48d6f109b1746a7":"lY3Uf"}],"hlKNy":[function(require,module,exports) {
module.exports = {
    "invalidSelection": (args, formatter)=>`${formatter.plural(args.selectedCount, {
            one: `\u{627}\u{644}\u{62A}\u{627}\u{631}\u{64A}\u{62E}`,
            other: `\u{627}\u{644}\u{62A}\u{648}\u{627}\u{631}\u{64A}\u{62E}`
        })} \u{627}\u{644}\u{645}\u{62D}\u{62F}\u{62F}/\u{627}\u{644}\u{645}\u{62D}\u{62F}\u{62F}\u{629} \u{63A}\u{64A}\u{631} \u{645}\u{62A}\u{648}\u{641}\u{631}\u{629}.`
};

},{}],"epZnn":[function(require,module,exports) {
module.exports = {
    "invalidSelection": (args, formatter)=>`${formatter.plural(args.selectedCount, {
            one: `\u{418}\u{437}\u{431}\u{440}\u{430}\u{43D}\u{430}\u{442}\u{430} \u{434}\u{430}\u{442}\u{430} \u{43D}\u{435} \u{435} \u{43D}\u{430}\u{43B}\u{438}\u{447}\u{43D}\u{430}`,
            other: `\u{418}\u{437}\u{431}\u{440}\u{430}\u{43D}\u{438}\u{442}\u{435} \u{434}\u{430}\u{442}\u{438} \u{43D}\u{435} \u{441}\u{430} \u{43D}\u{430}\u{43B}\u{438}\u{447}\u{43D}\u{438}`
        })}.`
};

},{}],"7OabR":[function(require,module,exports) {
module.exports = {
    "invalidSelection": (args, formatter)=>`${formatter.plural(args.selectedCount, {
            one: `Vybran\xe9 datum nen\xed`,
            other: `Vybran\xe1 data nejsou`
        })} k dispozici.`
};

},{}],"lkzwK":[function(require,module,exports) {
module.exports = {
    "invalidSelection": (args, formatter)=>`Valgte ${formatter.plural(args.selectedCount, {
            one: `dato`,
            other: `datoer`
        })} ikke ledige.`
};

},{}],"2lxMf":[function(require,module,exports) {
module.exports = {
    "invalidSelection": (args, formatter)=>`Ausgew\xe4hlte(s) ${formatter.plural(args.selectedCount, {
            one: `Datum`,
            other: `Daten`
        })} nicht verf\xfcgbar.`
};

},{}],"cpINt":[function(require,module,exports) {
module.exports = {
    "invalidSelection": (args, formatter)=>`${formatter.plural(args.selectedCount, {
            one: `\u{397} \u{3B5}\u{3C0}\u{3B9}\u{3BB}\u{3B5}\u{3B3}\u{3BC}\u{3AD}\u{3BD}\u{3B7} \u{3B7}\u{3BC}\u{3B5}\u{3C1}\u{3BF}\u{3BC}\u{3B7}\u{3BD}\u{3AF}\u{3B1} \u{3B4}\u{3B5}\u{3BD} \u{3B5}\u{3AF}\u{3BD}\u{3B1}\u{3B9} \u{3B4}\u{3B9}\u{3B1}\u{3B8}\u{3AD}\u{3C3}\u{3B9}\u{3BC}\u{3B7}`,
            other: `\u{39F}\u{3B9} \u{3B5}\u{3C0}\u{3B9}\u{3BB}\u{3B5}\u{3B3}\u{3BC}\u{3AD}\u{3BD}\u{3B5}\u{3C2} \u{3B7}\u{3BC}\u{3B5}\u{3C1}\u{3BF}\u{3BC}\u{3B7}\u{3BD}\u{3AF}\u{3B5}\u{3C2} \u{3B4}\u{3B5}\u{3BD} \u{3B5}\u{3AF}\u{3BD}\u{3B1}\u{3B9} \u{3B4}\u{3B9}\u{3B1}\u{3B8}\u{3AD}\u{3C3}\u{3B9}\u{3BC}\u{3B5}\u{3C2}`
        })}.`
};

},{}],"kk8ms":[function(require,module,exports) {
module.exports = {
    "invalidSelection": (args, formatter)=>`Selected ${formatter.plural(args.selectedCount, {
            one: `date`,
            other: `dates`
        })} unavailable.`
};

},{}],"edpRB":[function(require,module,exports) {
module.exports = {
    "invalidSelection": (args, formatter)=>`${formatter.plural(args.selectedCount, {
            one: `La fecha seleccionada no est\xe1 disponible`,
            other: `Las fechas seleccionadas no est\xe1n disponibles`
        })}.`
};

},{}],"2Z81C":[function(require,module,exports) {
module.exports = {
    "invalidSelection": (args, formatter)=>`Valitud ${formatter.plural(args.selectedCount, {
            one: `kuup\xe4ev`,
            other: `kuup\xe4evad`
        })} pole saadaval.`
};

},{}],"lqGv6":[function(require,module,exports) {
module.exports = {
    "invalidSelection": (args, formatter)=>`${formatter.plural(args.selectedCount, {
            one: `Valittu p\xe4iv\xe4m\xe4\xe4r\xe4 ei ole`,
            other: `Valitut p\xe4iv\xe4m\xe4\xe4r\xe4t eiv\xe4t ole`
        })} saatavilla.`
};

},{}],"allwk":[function(require,module,exports) {
module.exports = {
    "invalidSelection": (args, formatter)=>`${formatter.plural(args.selectedCount, {
            one: `La date s\xe9lectionn\xe9e est indisponible`,
            other: `Les dates s\xe9lectionn\xe9es sont indisponibles`
        })}.`
};

},{}],"3TGgs":[function(require,module,exports) {
module.exports = {
    "invalidSelection": (args, formatter)=>`\u{5E0}\u{5D1}\u{5D7}\u{5E8} ${formatter.plural(args.selectedCount, {
            one: `\u{5EA}\u{5D0}\u{5E8}\u{5D9}\u{5DA}`,
            other: `\u{5EA}\u{5D0}\u{5E8}\u{5D9}\u{5DB}\u{5D9}\u{5DD}`
        })} \u{5D0}\u{5D9}\u{5E0}\u{5D5} \u{5D6}\u{5DE}\u{5D9}\u{5DF}.`
};

},{}],"4hriS":[function(require,module,exports) {
module.exports = {
    "invalidSelection": (args, formatter)=>`${formatter.plural(args.selectedCount, {
            one: `Odabrani datum nije dostupan`,
            other: `Odabrani datumi nisu dostupni`
        })}.`
};

},{}],"gmTm7":[function(require,module,exports) {
module.exports = {
    "invalidSelection": (args, formatter)=>`A kijel\xf6lt ${formatter.plural(args.selectedCount, {
            one: `d\xe1tum nem \xe9rhet\u{151} el`,
            other: `d\xe1tumok nem \xe9rhet\u{151}ek el`
        })}.`
};

},{}],"jD7Rv":[function(require,module,exports) {
module.exports = {
    "invalidSelection": (args, formatter)=>`${formatter.plural(args.selectedCount, {
            one: `Data selezionata non disponibile`,
            other: `Date selezionate non disponibili`
        })}.`
};

},{}],"ix8B9":[function(require,module,exports) {
module.exports = {
    "invalidSelection": (args, formatter)=>`\u{9078}\u{629E}\u{3057}\u{305F}${formatter.plural(args.selectedCount, {
            one: `\u{65E5}\u{4ED8}`,
            other: `\u{65E5}\u{4ED8}`
        })}\u{306F}\u{4F7F}\u{7528}\u{3067}\u{304D}\u{307E}\u{305B}\u{3093}\u{3002}`
};

},{}],"l6nCd":[function(require,module,exports) {
module.exports = {
    "invalidSelection": (args, formatter)=>`\u{C120}\u{D0DD}\u{D55C} ${formatter.plural(args.selectedCount, {
            one: `\u{C77C}\u{C790}\u{B97C}`,
            other: `\u{C77C}\u{C790}\u{B97C}`
        })} \u{C0AC}\u{C6A9}\u{D560} \u{C218} \u{C5C6}\u{C2B5}\u{B2C8}\u{B2E4}.`
};

},{}],"4xhTx":[function(require,module,exports) {
module.exports = {
    "invalidSelection": (args, formatter)=>`${formatter.plural(args.selectedCount, {
            one: `Datos`,
            other: `Dat\u{173}`
        })} pasirinkimas negalimas.`
};

},{}],"vll2n":[function(require,module,exports) {
module.exports = {
    "invalidSelection": (args, formatter)=>`Atlas\u{12B}tais(-ie) ${formatter.plural(args.selectedCount, {
            one: `date`,
            other: `dates`
        })} nav pieejams(-i).`
};

},{}],"g2gXn":[function(require,module,exports) {
module.exports = {
    "invalidSelection": (args, formatter)=>`Valgt(e) ${formatter.plural(args.selectedCount, {
            one: `dato`,
            other: `datoer`
        })} er utilgjengelig.`
};

},{}],"jgqWe":[function(require,module,exports) {
module.exports = {
    "invalidSelection": (args, formatter)=>`Geselecteerde ${formatter.plural(args.selectedCount, {
            one: `datum`,
            other: `datums`
        })} niet beschikbaar.`
};

},{}],"eG6EE":[function(require,module,exports) {
module.exports = {
    "invalidSelection": (args, formatter)=>`${formatter.plural(args.selectedCount, {
            one: `Wybrana data jest niedost\u{119}pna`,
            other: `Wybrane daty s\u{105} niedost\u{119}pne`
        })}.`
};

},{}],"kbgQZ":[function(require,module,exports) {
module.exports = {
    "invalidSelection": (args, formatter)=>`${formatter.plural(args.selectedCount, {
            one: `Data`,
            other: `Datas`
        })} selecionada(s) indispon\xedvel(is).`
};

},{}],"Kdf0A":[function(require,module,exports) {
module.exports = {
    "invalidSelection": (args, formatter)=>`A(s) ${formatter.plural(args.selectedCount, {
            one: `data`,
            other: `datas`
        })} selecionada(s) n\xe3o est\xe1(\xe3o) dispon\xedvel/dispon\xedvel(eis).`
};

},{}],"aaXpa":[function(require,module,exports) {
module.exports = {
    "invalidSelection": (args, formatter)=>`${formatter.plural(args.selectedCount, {
            one: `Data selectat\u{103} nu este disponibil\u{103}`,
            other: `Datele selectate nu sunt disponibile`
        })}.`
};

},{}],"jW06q":[function(require,module,exports) {
module.exports = {
    "invalidSelection": (args, formatter)=>`\u{412}\u{44B}\u{431}\u{440}\u{430}\u{43D}\u{43D}\u{44B}\u{435} ${formatter.plural(args.selectedCount, {
            one: `\u{434}\u{430}\u{442}\u{430}`,
            other: `\u{434}\u{430}\u{442}\u{44B}`
        })} \u{43D}\u{435}\u{434}\u{43E}\u{441}\u{442}\u{443}\u{43F}\u{43D}\u{44B}.`
};

},{}],"72bVj":[function(require,module,exports) {
module.exports = {
    "invalidSelection": (args, formatter)=>`${formatter.plural(args.selectedCount, {
            one: `Vybrat\xfd d\xe1tum`,
            other: `Vybrat\xe9 d\xe1tumy`
        })}: nedostupn\xe9.`
};

},{}],"30GDe":[function(require,module,exports) {
module.exports = {
    "invalidSelection": (args, formatter)=>`Izbrano ${formatter.plural(args.selectedCount, {
            one: `date`,
            other: `dates`
        })} ni na voljo.`
};

},{}],"lWhQ9":[function(require,module,exports) {
module.exports = {
    "invalidSelection": (args, formatter)=>`Izabrani ${formatter.plural(args.selectedCount, {
            one: `date`,
            other: `dates`
        })} nije dostupan.`
};

},{}],"fc1nU":[function(require,module,exports) {
module.exports = {
    "invalidSelection": (args, formatter)=>`${formatter.plural(args.selectedCount, {
            one: `Valt datum \xe4r inte tillg\xe4ngligt.`,
            other: `Valda datum \xe4r inte tillg\xe4ngliga.`
        })}`
};

},{}],"iJbsa":[function(require,module,exports) {
module.exports = {
    "invalidSelection": (args, formatter)=>`Se\xe7ilen ${formatter.plural(args.selectedCount, {
            one: `tarih`,
            other: `tarihler`
        })} m\xfcsait de\u{11F}il.`
};

},{}],"hgVXF":[function(require,module,exports) {
module.exports = {
    "invalidSelection": (args, formatter)=>`${formatter.plural(args.selectedCount, {
            one: `\u{412}\u{438}\u{431}\u{440}\u{430}\u{43D}\u{430} \u{434}\u{430}\u{442}\u{430} \u{43D}\u{435}\u{434}\u{43E}\u{441}\u{442}\u{443}\u{43F}\u{43D}\u{430}`,
            other: `\u{412}\u{438}\u{431}\u{440}\u{430}\u{43D}\u{456} \u{434}\u{430}\u{442}\u{438} \u{43D}\u{435}\u{434}\u{43E}\u{441}\u{442}\u{443}\u{43F}\u{43D}\u{456}`
        })}.`
};

},{}],"jgWDH":[function(require,module,exports) {
module.exports = {
    "invalidSelection": (args, formatter)=>`\u{9009}\u{5B9A}\u{7684} ${formatter.plural(args.selectedCount, {
            one: `\u{4E2A}\u{65E5}\u{671F}`,
            other: `\u{4E2A}\u{65E5}\u{671F}`
        })} \u{4E0D}\u{53EF}\u{7528}\u{3002}`
};

},{}],"lY3Uf":[function(require,module,exports) {
module.exports = {
    "invalidSelection": (args, formatter)=>`\u{6240}\u{9078}\u{7684}${formatter.plural(args.selectedCount, {
            one: `\u{65E5}\u{671F}`,
            other: `\u{65E5}\u{671F}`
        })}\u{7121}\u{6CD5}\u{4F7F}\u{7528}\u{3002}`
};

},{}],"fMCdY":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RangeCalendar", ()=>_RangeCalendar);
var _calendarBase = require("./CalendarBase");
var _date = require("@internationalized/date");
var _utils = require("@react-spectrum/utils");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _i18N = require("@react-aria/i18n");
var _provider = require("@react-spectrum/provider");
var _calendar = require("@react-aria/calendar");
var _calendar1 = require("@react-stately/calendar");
function RangeCalendar(props, ref) {
    props = (0, _provider.useProviderProps)(props);
    let { visibleMonths = 1 } = props;
    visibleMonths = Math.max(visibleMonths, 1);
    let visibleDuration = (0, _react.useMemo)(()=>({
            months: visibleMonths
        }), [
        visibleMonths
    ]);
    let { locale } = (0, _i18N.useLocale)();
    let state = (0, _calendar1.useRangeCalendarState)({
        ...props,
        locale,
        visibleDuration,
        createCalendar: (0, _date.createCalendar)
    });
    let domRef = (0, _react.useRef)();
    (0, _react.useImperativeHandle)(ref, ()=>({
            ...(0, _utils.createDOMRef)(domRef),
            focus () {
                state.setFocused(true);
            }
        }));
    let { calendarProps, prevButtonProps, nextButtonProps, errorMessageProps } = (0, _calendar.useRangeCalendar)(props, state, domRef);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _calendarBase.CalendarBase), {
        ...props,
        visibleMonths: visibleMonths,
        state: state,
        calendarRef: domRef,
        calendarProps: calendarProps,
        prevButtonProps: prevButtonProps,
        nextButtonProps: nextButtonProps,
        errorMessageProps: errorMessageProps
    });
}
/**
 * RangeCalendars display a grid of days in one or more months and allow users to select a contiguous range of dates.
 */ const _RangeCalendar = /*#__PURE__*/ (0, _reactDefault.default).forwardRef(RangeCalendar);

},{"./CalendarBase":"8g1x3","@internationalized/date":"hesBk","@react-spectrum/utils":"cMIJ6","react":"9yzVZ","@react-aria/i18n":"411rg","@react-spectrum/provider":"5bCdp","@react-aria/calendar":"98n7T","@react-stately/calendar":"a8x0w","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"bO8KM":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /// <reference types="css-module-types" />
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ComboBox", ()=>(0, _comboBox.ComboBox));
parcelHelpers.export(exports, "Item", ()=>(0, _collections.Item));
parcelHelpers.export(exports, "Section", ()=>(0, _collections.Section));
var _comboBox = require("./ComboBox");
var _collections = require("@react-stately/collections");

},{"./ComboBox":"8hNtz","@react-stately/collections":"loANi","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"8hNtz":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ComboBox", ()=>_ComboBox);
var _chevronDownMedium = require("@spectrum-icons/ui/ChevronDownMedium");
var _chevronDownMediumDefault = parcelHelpers.interopDefault(_chevronDownMedium);
var _utils = require("@react-spectrum/utils");
var _comboboxCss = require("./combobox.css");
var _comboboxCssDefault = parcelHelpers.interopDefault(_comboboxCss);
var _label = require("@react-spectrum/label");
var _button = require("@react-spectrum/button");
var _focus = require("@react-aria/focus");
// @ts-ignore
var _json = require("../intl/*.json");
var _jsonDefault = parcelHelpers.interopDefault(_json);
var _listbox = require("@react-spectrum/listbox");
var _mobileComboBox = require("./MobileComboBox");
var _overlays = require("@react-spectrum/overlays");
var _interactions = require("@react-aria/interactions");
var _progress = require("@react-spectrum/progress");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _varsCss = require("@adobe/spectrum-css-temp/components/inputgroup/vars.css");
var _varsCssDefault = parcelHelpers.interopDefault(_varsCss);
var _textfield = require("@react-spectrum/textfield");
var _varsCss1 = require("@adobe/spectrum-css-temp/components/textfield/vars.css");
var _varsCssDefault1 = parcelHelpers.interopDefault(_varsCss1);
var _combobox = require("@react-aria/combobox");
var _combobox1 = require("@react-stately/combobox");
var _i18N = require("@react-aria/i18n");
var _form = require("@react-spectrum/form");
var _utils1 = require("@react-aria/utils");
var _provider = require("@react-spectrum/provider");
function ComboBox(props, ref) {
    props = (0, _provider.useProviderProps)(props);
    props = (0, _form.useFormProps)(props);
    if (props.placeholder) console.warn("Placeholders are deprecated due to accessibility issues. Please use help text instead. See the docs for details: https://react-spectrum.adobe.com/react-spectrum/ComboBox.html#help-text");
    let isMobile = (0, _utils.useIsMobileDevice)();
    if (isMobile) // menuTrigger=focus/manual don't apply to mobile combobox
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _mobileComboBox.MobileComboBox), {
        ...props,
        menuTrigger: "input",
        ref: ref
    });
    else return /*#__PURE__*/ (0, _reactDefault.default).createElement(ComboBoxBase, {
        ...props,
        ref: ref
    });
}
const ComboBoxBase = /*#__PURE__*/ (0, _reactDefault.default).forwardRef(function ComboBoxBase(props, ref) {
    let { menuTrigger = "input", shouldFlip = true, direction = "bottom", align = "start", isQuiet, loadingState, onLoadMore, allowsCustomValue, menuWidth: customMenuWidth, name, formValue = "text" } = props;
    if (allowsCustomValue) formValue = "text";
    let stringFormatter = (0, _i18N.useLocalizedStringFormatter)((0, _jsonDefault.default), "@react-spectrum/combobox");
    let isAsync = loadingState != null;
    let popoverRef = (0, _react.useRef)();
    let unwrappedPopoverRef = (0, _utils.useUnwrapDOMRef)(popoverRef);
    let buttonRef = (0, _react.useRef)();
    let unwrappedButtonRef = (0, _utils.useUnwrapDOMRef)(buttonRef);
    let listBoxRef = (0, _react.useRef)();
    let inputRef = (0, _react.useRef)();
    // serve as the new popover `triggerRef` instead of `unwrappedButtonRef` before for better positioning.
    let inputGroupRef = (0, _react.useRef)();
    let domRef = (0, _utils.useFocusableRef)(ref, inputRef);
    let { contains } = (0, _i18N.useFilter)({
        sensitivity: "base"
    });
    let state = (0, _combobox1.useComboBoxState)({
        ...props,
        defaultFilter: contains,
        allowsEmptyCollection: isAsync
    });
    let layout = (0, _listbox.useListBoxLayout)(state, loadingState === "loadingMore");
    let { buttonProps, inputProps, listBoxProps, labelProps, descriptionProps, errorMessageProps, isInvalid, validationErrors, validationDetails } = (0, _combobox.useComboBox)({
        ...props,
        keyboardDelegate: layout,
        buttonRef: unwrappedButtonRef,
        popoverRef: unwrappedPopoverRef,
        listBoxRef,
        inputRef: inputRef,
        menuTrigger,
        name: formValue === "text" ? name : undefined
    }, state);
    // Measure the width of the inputfield and the button to inform the width of the menu (below).
    let [menuWidth, setMenuWidth] = (0, _react.useState)(null);
    let { scale } = (0, _provider.useProvider)();
    let onResize = (0, _react.useCallback)(()=>{
        if (unwrappedButtonRef.current && inputRef.current) {
            let buttonWidth = unwrappedButtonRef.current.offsetWidth;
            let inputWidth = inputRef.current.offsetWidth;
            setMenuWidth(buttonWidth + inputWidth);
        }
    }, [
        unwrappedButtonRef,
        inputRef,
        setMenuWidth
    ]);
    (0, _utils.useResizeObserver)({
        ref: domRef,
        onResize: onResize
    });
    (0, _utils1.useLayoutEffect)(onResize, [
        scale,
        onResize
    ]);
    let width = isQuiet ? null : menuWidth;
    let style = {
        width: customMenuWidth ? (0, _utils.dimensionValue)(customMenuWidth) : width,
        minWidth: isQuiet ? `calc(${menuWidth}px + calc(2 * var(--spectrum-dropdown-quiet-offset)))` : menuWidth
    };
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _label.Field), {
        ...props,
        descriptionProps: descriptionProps,
        errorMessageProps: errorMessageProps,
        isInvalid: isInvalid,
        validationErrors: validationErrors,
        validationDetails: validationDetails,
        labelProps: labelProps,
        ref: domRef
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(ComboBoxInput, {
        ...props,
        isOpen: state.isOpen,
        loadingState: loadingState,
        inputProps: inputProps,
        inputRef: inputRef,
        triggerProps: buttonProps,
        triggerRef: buttonRef,
        validationState: props.validationState || (isInvalid ? "invalid" : null),
        ref: inputGroupRef
    })), name && formValue === "key" && /*#__PURE__*/ (0, _reactDefault.default).createElement("input", {
        type: "hidden",
        name: name,
        value: state.selectedKey
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _overlays.Popover), {
        state: state,
        UNSAFE_style: style,
        UNSAFE_className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-InputGroup-popover", {
            "spectrum-InputGroup-popover--quiet": isQuiet
        }),
        ref: popoverRef,
        triggerRef: inputGroupRef,
        scrollRef: listBoxRef,
        placement: `${direction} ${align}`,
        hideArrow: true,
        isNonModal: true,
        shouldFlip: shouldFlip
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _listbox.ListBoxBase), {
        ...listBoxProps,
        ref: listBoxRef,
        disallowEmptySelection: true,
        autoFocus: state.focusStrategy,
        shouldSelectOnPressUp: true,
        focusOnPointerEnter: true,
        layout: layout,
        state: state,
        shouldUseVirtualFocus: true,
        isLoading: loadingState === "loading" || loadingState === "loadingMore",
        onLoadMore: onLoadMore,
        renderEmptyState: ()=>isAsync && /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
                className: (0, _utils.classNames)((0, _comboboxCssDefault.default), "no-results")
            }, loadingState === "loading" ? stringFormatter.format("loading") : stringFormatter.format("noResults"))
    })));
});
const ComboBoxInput = /*#__PURE__*/ (0, _reactDefault.default).forwardRef(function ComboBoxInput(props, ref) {
    let { isQuiet, isDisabled, validationState, inputProps, inputRef, triggerProps, triggerRef, autoFocus, style, className, loadingState, isOpen, menuTrigger } = props;
    let { hoverProps, isHovered } = (0, _interactions.useHover)({});
    let stringFormatter = (0, _i18N.useLocalizedStringFormatter)((0, _jsonDefault.default), "@react-spectrum/combobox");
    let timeout = (0, _react.useRef)(null);
    let [showLoading, setShowLoading] = (0, _react.useState)(false);
    let loadingCircle = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _progress.ProgressCircle), {
        "aria-label": stringFormatter.format("loading"),
        size: "S",
        isIndeterminate: true,
        UNSAFE_className: (0, _utils.classNames)((0, _varsCssDefault1.default), "spectrum-Textfield-circleLoader", (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-InputGroup-input-circleLoader"))
    });
    let isLoading = loadingState === "loading" || loadingState === "filtering";
    let inputValue = inputProps.value;
    let lastInputValue = (0, _react.useRef)(inputValue);
    (0, _react.useEffect)(()=>{
        if (isLoading && !showLoading) {
            if (timeout.current === null) timeout.current = setTimeout(()=>{
                setShowLoading(true);
            }, 500);
            // If user is typing, clear the timer and restart since it is a new request
            if (inputValue !== lastInputValue.current) {
                clearTimeout(timeout.current);
                timeout.current = setTimeout(()=>{
                    setShowLoading(true);
                }, 500);
            }
        } else if (!isLoading) {
            // If loading is no longer happening, clear any timers and hide the loading circle
            setShowLoading(false);
            clearTimeout(timeout.current);
            timeout.current = null;
        }
        lastInputValue.current = inputValue;
    }, [
        isLoading,
        showLoading,
        inputValue
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _focus.FocusRing), {
        within: true,
        isTextInput: true,
        focusClass: (0, _utils.classNames)((0, _varsCssDefault.default), "is-focused"),
        focusRingClass: (0, _utils.classNames)((0, _varsCssDefault.default), "focus-ring"),
        autoFocus: autoFocus
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...hoverProps,
        ref: ref,
        style: style,
        className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-InputGroup", {
            "spectrum-InputGroup--quiet": isQuiet,
            "is-disabled": isDisabled,
            "spectrum-InputGroup--invalid": validationState === "invalid" && !isDisabled,
            "is-hovered": isHovered
        }, className)
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textfield.TextFieldBase), {
        inputProps: inputProps,
        inputRef: inputRef,
        UNSAFE_className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-InputGroup-field"),
        inputClassName: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-InputGroup-input"),
        validationIconClassName: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-InputGroup-input-validationIcon"),
        isDisabled: isDisabled,
        isQuiet: isQuiet,
        validationState: validationState,
        // loading circle should only be displayed if menu is open, if menuTrigger is "manual", or first time load (to stop circle from showing up when user selects an option)
        // TODO: add special case for completionMode: complete as well
        isLoading: showLoading && (isOpen || menuTrigger === "manual" || loadingState === "loading"),
        loadingIndicator: loadingState != null && loadingCircle,
        disableFocusRing: true
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _interactions.PressResponder), {
        preventFocusOnPress: true,
        isPressed: isOpen
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.FieldButton), {
        ...triggerProps,
        ref: triggerRef,
        UNSAFE_className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-FieldButton"),
        isQuiet: isQuiet,
        validationState: validationState
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _chevronDownMediumDefault.default), {
        UNSAFE_className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Dropdown-chevron")
    })))));
});
/**
 * ComboBoxes combine a text entry with a picker menu, allowing users to filter longer lists to only the selections matching a query.
 */ const _ComboBox = /*#__PURE__*/ (0, _reactDefault.default).forwardRef(ComboBox);

},{"@spectrum-icons/ui/ChevronDownMedium":"bWUHC","@react-spectrum/utils":"cMIJ6","./combobox.css":"kVWNO","@react-spectrum/label":"6qv6N","@react-spectrum/button":"jZWyP","@react-aria/focus":"42mbF","../intl/*.json":"akCse","@react-spectrum/listbox":"kF7kO","./MobileComboBox":"dglO1","@react-spectrum/overlays":"3nwGn","@react-aria/interactions":"ky3G8","@react-spectrum/progress":"4kHa7","react":"9yzVZ","@adobe/spectrum-css-temp/components/inputgroup/vars.css":"fZm3Z","@react-spectrum/textfield":"hOmtq","@adobe/spectrum-css-temp/components/textfield/vars.css":"c3yAu","@react-aria/combobox":"4enyJ","@react-stately/combobox":"j3BhU","@react-aria/i18n":"411rg","@react-spectrum/form":"bGDqA","@react-aria/utils":"9cLk5","@react-spectrum/provider":"5bCdp","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"kVWNO":[function(require,module,exports) {
module.exports["has-label"] = `P1vhCW_has-label`;
module.exports["mobile-combobox"] = `P1vhCW_mobile-combobox`;
module.exports["mobile-input"] = `P1vhCW_mobile-input`;
module.exports["mobile-value"] = `P1vhCW_mobile-value`;
module.exports["no-results"] = `P1vhCW_no-results`;
module.exports["tray-dialog"] = `P1vhCW_tray-dialog`;
module.exports["tray-listbox"] = `P1vhCW_tray-listbox`;
module.exports["tray-textfield"] = `P1vhCW_tray-textfield`;
module.exports["tray-textfield-input"] = `P1vhCW_tray-textfield-input`;

},{}],"akCse":[function(require,module,exports) {
const _temp0 = require("33e420fca3278add");
const _temp1 = require("dde88d4c1b9190bf");
const _temp2 = require("a6849c32541384b8");
const _temp3 = require("a2e3079b3a9fe95b");
const _temp4 = require("6f0ed7b00096fead");
const _temp5 = require("6fd5ed8de4091f52");
const _temp6 = require("30a48908c18de743");
const _temp7 = require("b4bf1b7c482a28d9");
const _temp8 = require("b85757fc9958957");
const _temp9 = require("1d2df349195b1d21");
const _temp10 = require("4a910c9b776ef6fc");
const _temp11 = require("6bd19b0b34da74f");
const _temp12 = require("b2fb5ca227d0eef6");
const _temp13 = require("c0cfd655e7cec281");
const _temp14 = require("fce78b456adc9c8e");
const _temp15 = require("473ae8c8cb8461cb");
const _temp16 = require("e005fccabb570157");
const _temp17 = require("777a143db61ce604");
const _temp18 = require("9bb0db69004eea02");
const _temp19 = require("1214d2f2d470bfb8");
const _temp20 = require("a997198214f394ed");
const _temp21 = require("6f0cb3b0b71ae9e9");
const _temp22 = require("2c9b260adcd2e67a");
const _temp23 = require("1cab7c01c6fcdbf");
const _temp24 = require("6903e266335fe36c");
const _temp25 = require("8fb906c37608f6fa");
const _temp26 = require("94130fa19d91ef3a");
const _temp27 = require("b7f0670eed089087");
const _temp28 = require("7feb012146c51cff");
const _temp29 = require("7be83f71f4d8cfe3");
const _temp30 = require("6c90b90f100757ac");
const _temp31 = require("d6d5cb9200567e08");
const _temp32 = require("92d8d2602007c65");
const _temp33 = require("d9e56819441d3b6b");
module.exports = {
    "ar-AE": _temp0,
    "bg-BG": _temp1,
    "cs-CZ": _temp2,
    "da-DK": _temp3,
    "de-DE": _temp4,
    "el-GR": _temp5,
    "en-US": _temp6,
    "es-ES": _temp7,
    "et-EE": _temp8,
    "fi-FI": _temp9,
    "fr-FR": _temp10,
    "he-IL": _temp11,
    "hr-HR": _temp12,
    "hu-HU": _temp13,
    "it-IT": _temp14,
    "ja-JP": _temp15,
    "ko-KR": _temp16,
    "lt-LT": _temp17,
    "lv-LV": _temp18,
    "nb-NO": _temp19,
    "nl-NL": _temp20,
    "pl-PL": _temp21,
    "pt-BR": _temp22,
    "pt-PT": _temp23,
    "ro-RO": _temp24,
    "ru-RU": _temp25,
    "sk-SK": _temp26,
    "sl-SI": _temp27,
    "sr-SP": _temp28,
    "sv-SE": _temp29,
    "tr-TR": _temp30,
    "uk-UA": _temp31,
    "zh-CN": _temp32,
    "zh-TW": _temp33
};

},{"33e420fca3278add":"dwCM2","dde88d4c1b9190bf":"eHVcm","a6849c32541384b8":"eMPep","a2e3079b3a9fe95b":"hycaK","6f0ed7b00096fead":"4nL16","6fd5ed8de4091f52":"9Cuxg","30a48908c18de743":"c6JDZ","b4bf1b7c482a28d9":"eQzjr","b85757fc9958957":"d5YSs","1d2df349195b1d21":"kZFks","4a910c9b776ef6fc":"jyK1d","6bd19b0b34da74f":"cwvsJ","b2fb5ca227d0eef6":"3bHHO","c0cfd655e7cec281":"ei9dK","fce78b456adc9c8e":"lKfCt","473ae8c8cb8461cb":"jPOwy","e005fccabb570157":"30pTR","777a143db61ce604":"lIbmb","9bb0db69004eea02":"agMtT","1214d2f2d470bfb8":"iM93F","a997198214f394ed":"39brt","6f0cb3b0b71ae9e9":"bTQF3","2c9b260adcd2e67a":"9GnT0","1cab7c01c6fcdbf":"1ZnZp","6903e266335fe36c":"6U2Fw","8fb906c37608f6fa":"9xPf3","94130fa19d91ef3a":"lta08","b7f0670eed089087":"2UOYv","7feb012146c51cff":"5CAp9","7be83f71f4d8cfe3":"2U6KB","6c90b90f100757ac":"drDd2","d6d5cb9200567e08":"kV5WH","92d8d2602007c65":"VSxhU","d9e56819441d3b6b":"4oiau"}],"dwCM2":[function(require,module,exports) {
module.exports = {
    "clear": `\u{645}\u{633}\u{62D}`,
    "invalid": `(\u{63A}\u{64A}\u{631} \u{635}\u{627}\u{644}\u{62D})`,
    "loading": `\u{62C}\u{627}\u{631}\u{64D} \u{627}\u{644}\u{62A}\u{62D}\u{645}\u{64A}\u{644}...`,
    "noResults": `\u{644}\u{627} \u{62A}\u{648}\u{62C}\u{62F} \u{646}\u{62A}\u{627}\u{626}\u{62C}`
};

},{}],"eHVcm":[function(require,module,exports) {
module.exports = {
    "clear": `\u{418}\u{437}\u{447}\u{438}\u{441}\u{442}\u{438}`,
    "invalid": `(\u{43D}\u{435}\u{432}\u{430}\u{43B}\u{438}\u{434}\u{435}\u{43D})`,
    "loading": `\u{417}\u{430}\u{440}\u{435}\u{436}\u{434}\u{430}\u{43D}\u{435}...`,
    "noResults": `\u{41D}\u{44F}\u{43C}\u{430} \u{440}\u{435}\u{437}\u{443}\u{43B}\u{442}\u{430}\u{442}\u{438}`
};

},{}],"eMPep":[function(require,module,exports) {
module.exports = {
    "clear": `Vymazat`,
    "invalid": `(neplatn\xe9)`,
    "loading": `Na\u{10D}\xedt\xe1n\xed...`,
    "noResults": `\u{17D}\xe1dn\xe9 v\xfdsledky`
};

},{}],"hycaK":[function(require,module,exports) {
module.exports = {
    "clear": `Ryd`,
    "invalid": `(ugyldig)`,
    "loading": `Indl\xe6ser ...`,
    "noResults": `Ingen resultater`
};

},{}],"4nL16":[function(require,module,exports) {
module.exports = {
    "clear": `L\xf6schen`,
    "invalid": `(ung\xfcltig)`,
    "loading": `Wird geladen...`,
    "noResults": `Keine Ergebnisse`
};

},{}],"9Cuxg":[function(require,module,exports) {
module.exports = {
    "clear": `\u{39A}\u{3B1}\u{3B8}\u{3B1}\u{3C1}\u{3B9}\u{3C3}\u{3BC}\u{3CC}\u{3C2}`,
    "invalid": `(\u{3B4}\u{3B5}\u{3BD} \u{3B9}\u{3C3}\u{3C7}\u{3CD}\u{3B5}\u{3B9})`,
    "loading": `\u{3A6}\u{3CC}\u{3C1}\u{3C4}\u{3C9}\u{3C3}\u{3B7}...`,
    "noResults": `\u{3A7}\u{3C9}\u{3C1}\u{3AF}\u{3C2} \u{3B1}\u{3C0}\u{3BF}\u{3C4}\u{3AD}\u{3BB}\u{3B5}\u{3C3}\u{3BC}\u{3B1}`
};

},{}],"c6JDZ":[function(require,module,exports) {
module.exports = {
    "loading": `Loading...`,
    "noResults": `No results`,
    "clear": `Clear`,
    "invalid": `(invalid)`
};

},{}],"eQzjr":[function(require,module,exports) {
module.exports = {
    "clear": `Borrar`,
    "invalid": `(no v\xe1lido)`,
    "loading": `Cargando\u{2026}`,
    "noResults": `Sin resultados`
};

},{}],"d5YSs":[function(require,module,exports) {
module.exports = {
    "clear": `Puhasta`,
    "invalid": `(kehtetu)`,
    "loading": `Laadimine...`,
    "noResults": `Tulemusi pole`
};

},{}],"kZFks":[function(require,module,exports) {
module.exports = {
    "clear": `Kirkas`,
    "invalid": `(ep\xe4kelpo)`,
    "loading": `Ladataan...`,
    "noResults": `Ei tuloksia`
};

},{}],"jyK1d":[function(require,module,exports) {
module.exports = {
    "clear": `Effacer`,
    "invalid": `(non valide)`,
    "loading": `Chargement en cours...`,
    "noResults": `Aucun r\xe9sultat`
};

},{}],"cwvsJ":[function(require,module,exports) {
module.exports = {
    "clear": `\u{5E0}\u{5E7}\u{5D9}`,
    "invalid": `(\u{5DC}\u{5D0} \u{5D7}\u{5D5}\u{5E7}\u{5D9})`,
    "loading": `\u{5D8}\u{5D5}\u{5E2}\u{5DF}...`,
    "noResults": `\u{5D0}\u{5D9}\u{5DF} \u{5EA}\u{5D5}\u{5E6}\u{5D0}\u{5D5}\u{5EA}`
};

},{}],"3bHHO":[function(require,module,exports) {
module.exports = {
    "clear": `Izbri\u{161}i`,
    "invalid": `(neva\u{17E}e\u{107}e)`,
    "loading": `U\u{10D}itavam...`,
    "noResults": `Nema rezultata`
};

},{}],"ei9dK":[function(require,module,exports) {
module.exports = {
    "clear": `T\xf6rl\xe9s`,
    "invalid": `(\xe9rv\xe9nytelen)`,
    "loading": `Bet\xf6lt\xe9s folyamatban\u{2026}`,
    "noResults": `Nincsenek tal\xe1latok`
};

},{}],"lKfCt":[function(require,module,exports) {
module.exports = {
    "clear": `Cancella`,
    "invalid": `(non valido)`,
    "loading": `Caricamento in corso...`,
    "noResults": `Nessun risultato`
};

},{}],"jPOwy":[function(require,module,exports) {
module.exports = {
    "clear": `\u{30AF}\u{30EA}\u{30A2}`,
    "invalid": `(\u{7121}\u{52B9})`,
    "loading": `\u{8AAD}\u{307F}\u{8FBC}\u{307F}\u{4E2D}...`,
    "noResults": `\u{7D50}\u{679C}\u{306A}\u{3057}`
};

},{}],"30pTR":[function(require,module,exports) {
module.exports = {
    "clear": `\u{C9C0}\u{C6B0}\u{AE30}`,
    "invalid": `(\u{C720}\u{D6A8}\u{D558}\u{C9C0} \u{C54A}\u{C74C})`,
    "loading": `\u{B85C}\u{B4DC} \u{C911}...`,
    "noResults": `\u{ACB0}\u{ACFC} \u{C5C6}\u{C74C}`
};

},{}],"lIbmb":[function(require,module,exports) {
module.exports = {
    "clear": `Skaidrus`,
    "invalid": `(netinkama)`,
    "loading": `\u{12E}keliama...`,
    "noResults": `Be rezultat\u{173}`
};

},{}],"agMtT":[function(require,module,exports) {
module.exports = {
    "clear": `Not\u{12B}r\u{12B}t`,
    "invalid": `(neder\u{12B}gs)`,
    "loading": `Notiek iel\u{101}de...`,
    "noResults": `Nav rezult\u{101}tu`
};

},{}],"iM93F":[function(require,module,exports) {
module.exports = {
    "clear": `T\xf8m`,
    "invalid": `(ugyldig)`,
    "loading": `Laster inn ...`,
    "noResults": `Ingen resultater`
};

},{}],"39brt":[function(require,module,exports) {
module.exports = {
    "clear": `Helder`,
    "invalid": `(ongeldig)`,
    "loading": `Laden...`,
    "noResults": `Geen resultaten`
};

},{}],"bTQF3":[function(require,module,exports) {
module.exports = {
    "clear": `Wyczy\u{15B}\u{107}`,
    "invalid": `(nieprawid\u{142}owy)`,
    "loading": `Trwa \u{142}adowanie...`,
    "noResults": `Brak wynik\xf3w`
};

},{}],"9GnT0":[function(require,module,exports) {
module.exports = {
    "clear": `Limpar`,
    "invalid": `(inv\xe1lido)`,
    "loading": `Carregando...`,
    "noResults": `Nenhum resultado`
};

},{}],"1ZnZp":[function(require,module,exports) {
module.exports = {
    "clear": `Limpar`,
    "invalid": `(inv\xe1lido)`,
    "loading": `A carregar...`,
    "noResults": `Sem resultados`
};

},{}],"6U2Fw":[function(require,module,exports) {
module.exports = {
    "clear": `Golire`,
    "invalid": `(nevalid)`,
    "loading": `Se \xeencarc\u{103}...`,
    "noResults": `Niciun rezultat`
};

},{}],"9xPf3":[function(require,module,exports) {
module.exports = {
    "clear": `\u{41E}\u{447}\u{438}\u{441}\u{442}\u{438}\u{442}\u{44C}`,
    "invalid": `(\u{43D}\u{435}\u{434}\u{435}\u{439}\u{441}\u{442}\u{432}\u{438}\u{442}\u{435}\u{43B}\u{44C}\u{43D}\u{43E})`,
    "loading": `\u{417}\u{430}\u{433}\u{440}\u{443}\u{437}\u{43A}\u{430}...`,
    "noResults": `\u{420}\u{435}\u{437}\u{443}\u{43B}\u{44C}\u{442}\u{430}\u{442}\u{44B} \u{43E}\u{442}\u{441}\u{443}\u{442}\u{441}\u{442}\u{432}\u{443}\u{44E}\u{442}`
};

},{}],"lta08":[function(require,module,exports) {
module.exports = {
    "clear": `Vymaza\u{165}`,
    "invalid": `(neplatn\xe9)`,
    "loading": `Na\u{10D}\xedtava sa...`,
    "noResults": `\u{17D}iadne v\xfdsledky`
};

},{}],"2UOYv":[function(require,module,exports) {
module.exports = {
    "clear": `Jasen`,
    "invalid": `(neveljavno)`,
    "loading": `Nalaganje...`,
    "noResults": `Ni rezultatov`
};

},{}],"5CAp9":[function(require,module,exports) {
module.exports = {
    "clear": `Izbri\u{161}i`,
    "invalid": `(neva\u{17E}e\u{107}e)`,
    "loading": `U\u{10D}itavam...`,
    "noResults": `Nema rezultata`
};

},{}],"2U6KB":[function(require,module,exports) {
module.exports = {
    "clear": `Rensa`,
    "invalid": `(ogiltigt)`,
    "loading": `L\xe4ser in...`,
    "noResults": `Inga resultat`
};

},{}],"drDd2":[function(require,module,exports) {
module.exports = {
    "clear": `Temizle`,
    "invalid": `(ge\xe7ersiz)`,
    "loading": `Y\xfckleniyor...`,
    "noResults": `Sonu\xe7 yok`
};

},{}],"kV5WH":[function(require,module,exports) {
module.exports = {
    "clear": `\u{41E}\u{447}\u{438}\u{441}\u{442}\u{438}\u{442}\u{438}`,
    "invalid": `(\u{43D}\u{435}\u{434}\u{456}\u{439}\u{441}\u{43D}\u{435})`,
    "loading": `\u{417}\u{430}\u{432}\u{430}\u{43D}\u{442}\u{430}\u{436}\u{435}\u{43D}\u{43D}\u{44F}...`,
    "noResults": `\u{420}\u{435}\u{437}\u{443}\u{43B}\u{44C}\u{442}\u{430}\u{442}\u{456}\u{432} \u{43D}\u{435}\u{43C}\u{430}\u{454}`
};

},{}],"VSxhU":[function(require,module,exports) {
module.exports = {
    "clear": `\u{900F}\u{660E}`,
    "invalid": `\u{FF08}\u{65E0}\u{6548}\u{FF09}`,
    "loading": `\u{6B63}\u{5728}\u{52A0}\u{8F7D}...`,
    "noResults": `\u{65E0}\u{7ED3}\u{679C}`
};

},{}],"4oiau":[function(require,module,exports) {
module.exports = {
    "clear": `\u{6E05}\u{9664}`,
    "invalid": `(\u{7121}\u{6548})`,
    "loading": `\u{6B63}\u{5728}\u{8F09}\u{5165}...`,
    "noResults": `\u{7121}\u{4EFB}\u{4F55}\u{7D50}\u{679C}`
};

},{}],"dglO1":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MobileComboBox", ()=>MobileComboBox);
var _alertMedium = require("@spectrum-icons/ui/AlertMedium");
var _alertMediumDefault = parcelHelpers.interopDefault(_alertMedium);
var _varsCss = require("@adobe/spectrum-css-temp/components/button/vars.css");
var _varsCssDefault = parcelHelpers.interopDefault(_varsCss);
var _checkmarkMedium = require("@spectrum-icons/ui/CheckmarkMedium");
var _checkmarkMediumDefault = parcelHelpers.interopDefault(_checkmarkMedium);
var _chevronDownMedium = require("@spectrum-icons/ui/ChevronDownMedium");
var _chevronDownMediumDefault = parcelHelpers.interopDefault(_chevronDownMedium);
var _utils = require("@react-spectrum/utils");
var _button = require("@react-spectrum/button");
var _combobox = require("@react-stately/combobox");
var _comboboxCss = require("./combobox.css");
var _comboboxCssDefault = parcelHelpers.interopDefault(_comboboxCss);
var _overlays = require("@react-aria/overlays");
var _label = require("@react-spectrum/label");
var _focus = require("@react-aria/focus");
// @ts-ignore
var _json = require("../intl/*.json");
var _jsonDefault = parcelHelpers.interopDefault(_json);
var _varsCss1 = require("@adobe/spectrum-css-temp/components/fieldlabel/vars.css");
var _varsCssDefault1 = parcelHelpers.interopDefault(_varsCss1);
var _listbox = require("@react-spectrum/listbox");
var _utils1 = require("@react-aria/utils");
var _progress = require("@react-spectrum/progress");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _varsCss2 = require("@adobe/spectrum-css-temp/components/search/vars.css");
var _varsCssDefault2 = parcelHelpers.interopDefault(_varsCss2);
var _interactions = require("@react-aria/interactions");
var _varsCss3 = require("@adobe/spectrum-css-temp/components/inputgroup/vars.css");
var _varsCssDefault3 = parcelHelpers.interopDefault(_varsCss3);
var _textfield = require("@react-spectrum/textfield");
var _varsCss4 = require("@adobe/spectrum-css-temp/components/textfield/vars.css");
var _varsCssDefault4 = parcelHelpers.interopDefault(_varsCss4);
var _overlays1 = require("@react-spectrum/overlays");
var _button1 = require("@react-aria/button");
var _combobox1 = require("@react-aria/combobox");
var _dialog = require("@react-aria/dialog");
var _label1 = require("@react-aria/label");
var _i18N = require("@react-aria/i18n");
var _form = require("@react-aria/form");
var _provider = require("@react-spectrum/provider");
const MobileComboBox = /*#__PURE__*/ (0, _reactDefault.default).forwardRef(function MobileComboBox(props, ref) {
    props = (0, _provider.useProviderProps)(props);
    let { isQuiet, isDisabled, isReadOnly, isRequired, validationBehavior, name, formValue = "text", allowsCustomValue } = props;
    if (allowsCustomValue) formValue = "text";
    let { contains } = (0, _i18N.useFilter)({
        sensitivity: "base"
    });
    let state = (0, _combobox.useComboBoxState)({
        ...props,
        defaultFilter: contains,
        allowsEmptyCollection: true,
        // Needs to be false here otherwise we double up on commitSelection/commitCustomValue calls when
        // user taps on underlay (i.e. initial tap will call setFocused(false) -> commitSelection/commitCustomValue via onBlur,
        // then the closing of the tray will call setFocused(false) again due to cleanup effect)
        shouldCloseOnBlur: false
    });
    let buttonRef = (0, _react.useRef)();
    let domRef = (0, _utils.useFocusableRef)(ref, buttonRef);
    let { triggerProps, overlayProps } = (0, _overlays.useOverlayTrigger)({
        type: "listbox"
    }, state, buttonRef);
    let inputRef = (0, _react.useRef)(null);
    (0, _form.useFormValidation)({
        ...props,
        focus: ()=>buttonRef.current.focus()
    }, state, inputRef);
    let { isInvalid, validationErrors, validationDetails } = state.displayValidation;
    let validationState = props.validationState || (isInvalid ? "invalid" : null);
    var _props_errorMessage;
    let errorMessage = (_props_errorMessage = props.errorMessage) !== null && _props_errorMessage !== void 0 ? _props_errorMessage : validationErrors.join(" ");
    let { labelProps, fieldProps, descriptionProps, errorMessageProps } = (0, _label1.useField)({
        ...props,
        labelElementType: "span",
        isInvalid,
        errorMessage
    });
    // Focus the button and show focus ring when clicking on the label
    labelProps.onClick = ()=>{
        if (!props.isDisabled) {
            buttonRef.current.focus();
            (0, _interactions.setInteractionModality)("keyboard");
        }
    };
    let inputProps = {
        type: "hidden",
        name,
        value: formValue === "text" ? state.inputValue : state.selectedKey
    };
    if (validationBehavior === "native") {
        // Use a hidden <input type="text"> rather than <input type="hidden">
        // so that an empty value blocks HTML form submission when the field is required.
        inputProps.type = "text";
        inputProps.hidden = true;
        inputProps.required = isRequired;
        // Ignore react warning.
        inputProps.onChange = ()=>{};
    }
    (0, _utils1.useFormReset)(inputRef, inputProps.value, formValue === "text" ? state.setInputValue : state.setSelectedKey);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _label.Field), {
        ...props,
        labelProps: labelProps,
        descriptionProps: descriptionProps,
        errorMessageProps: errorMessageProps,
        validationState: validationState,
        isInvalid: isInvalid,
        validationErrors: validationErrors,
        validationDetails: validationDetails,
        elementType: "span",
        ref: domRef,
        includeNecessityIndicatorInAccessibilityName: true
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(ComboBoxButton, {
        ...(0, _utils1.mergeProps)(triggerProps, fieldProps, {
            autoFocus: props.autoFocus
        }),
        ref: buttonRef,
        isQuiet: isQuiet,
        isDisabled: isDisabled,
        isPlaceholder: !state.inputValue,
        validationState: validationState,
        onPress: ()=>!isReadOnly && state.open(null, "manual")
    }, state.inputValue || props.placeholder || "")), /*#__PURE__*/ (0, _reactDefault.default).createElement("input", {
        ...inputProps,
        ref: inputRef
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _overlays1.Tray), {
        state: state,
        isFixedHeight: true,
        ...overlayProps
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(ComboBoxTray, {
        ...props,
        onClose: state.close,
        overlayProps: overlayProps,
        state: state
    })));
});
const ComboBoxButton = /*#__PURE__*/ (0, _reactDefault.default).forwardRef(function ComboBoxButton(props, ref) {
    let { isQuiet, isDisabled, isPlaceholder, validationState, children, style, className } = props;
    let stringFormatter = (0, _i18N.useLocalizedStringFormatter)((0, _jsonDefault.default), "@react-spectrum/combobox");
    let valueId = (0, _utils1.useId)();
    let invalidId = (0, _utils1.useId)();
    let validationIcon = validationState === "invalid" ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _alertMediumDefault.default), {
        id: invalidId,
        "aria-label": stringFormatter.format("invalid")
    }) : /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _checkmarkMediumDefault.default), null);
    let validation = /*#__PURE__*/ (0, _reactDefault.default).cloneElement(validationIcon, {
        UNSAFE_className: (0, _utils.classNames)((0, _varsCssDefault4.default), "spectrum-Textfield-validationIcon", (0, _utils.classNames)((0, _varsCssDefault3.default), "spectrum-InputGroup-input-validationIcon"))
    });
    let { hoverProps, isHovered } = (0, _interactions.useHover)({});
    let { buttonProps, isPressed } = (0, _button1.useButton)({
        ...props,
        "aria-labelledby": [
            props["aria-labelledby"],
            props["aria-label"] && !props["aria-labelledby"] ? props.id : null,
            valueId,
            validationState === "invalid" ? invalidId : null
        ].filter(Boolean).join(" "),
        elementType: "div"
    }, ref);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _focus.FocusRing), {
        focusClass: (0, _utils.classNames)((0, _varsCssDefault3.default), "is-focused"),
        focusRingClass: (0, _utils.classNames)((0, _varsCssDefault3.default), "focus-ring")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...(0, _utils1.mergeProps)(hoverProps, buttonProps),
        "aria-haspopup": "dialog",
        ref: ref,
        style: {
            ...style,
            outline: "none"
        },
        className: (0, _utils.classNames)((0, _varsCssDefault3.default), "spectrum-InputGroup", {
            "spectrum-InputGroup--quiet": isQuiet,
            "is-disabled": isDisabled,
            "spectrum-InputGroup--invalid": validationState === "invalid" && !isDisabled,
            "is-hovered": isHovered
        }, (0, _utils.classNames)((0, _comboboxCssDefault.default), "mobile-combobox"), className)
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _utils.classNames)((0, _varsCssDefault4.default), "spectrum-Textfield", {
            "spectrum-Textfield--invalid": validationState === "invalid" && !isDisabled,
            "spectrum-Textfield--valid": validationState === "valid" && !isDisabled,
            "spectrum-Textfield--quiet": isQuiet
        }, (0, _utils.classNames)((0, _varsCssDefault3.default), "spectrum-InputGroup-field"))
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _utils.classNames)((0, _varsCssDefault4.default), "spectrum-Textfield-input", {
            "is-hovered": isHovered,
            "is-placeholder": isPlaceholder,
            "is-disabled": isDisabled
        }, (0, _utils.classNames)((0, _varsCssDefault3.default), "spectrum-InputGroup-input", (0, _utils.classNames)((0, _varsCssDefault1.default), "spectrum-Field-field")), (0, _utils.classNames)((0, _comboboxCssDefault.default), "mobile-input"))
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        id: valueId,
        className: (0, _utils.classNames)((0, _comboboxCssDefault.default), "mobile-value")
    }, children)), validationState && !isDisabled ? validation : null), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-FieldButton", {
            "spectrum-FieldButton--quiet": isQuiet,
            "is-active": isPressed,
            "is-disabled": isDisabled,
            "spectrum-FieldButton--invalid": validationState === "invalid" && !isDisabled,
            "is-hovered": isHovered
        }, (0, _utils.classNames)((0, _varsCssDefault3.default), "spectrum-FieldButton"))
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _chevronDownMediumDefault.default), {
        UNSAFE_className: (0, _utils.classNames)((0, _varsCssDefault3.default), "spectrum-Dropdown-chevron")
    }))));
});
function ComboBoxTray(props) {
    let { // completionMode = 'suggest',
    state, isDisabled, validationState, label, overlayProps, loadingState, onLoadMore, onClose } = props;
    let timeout = (0, _react.useRef)(null);
    let [showLoading, setShowLoading] = (0, _react.useState)(false);
    let inputRef = (0, _react.useRef)();
    let buttonRef = (0, _react.useRef)();
    let popoverRef = (0, _react.useRef)();
    let listBoxRef = (0, _react.useRef)();
    let isLoading = loadingState === "loading" || loadingState === "loadingMore";
    let layout = (0, _listbox.useListBoxLayout)(state, isLoading);
    let stringFormatter = (0, _i18N.useLocalizedStringFormatter)((0, _jsonDefault.default), "@react-spectrum/combobox");
    let { inputProps, listBoxProps, labelProps } = (0, _combobox1.useComboBox)({
        ...props,
        // completionMode,
        keyboardDelegate: layout,
        buttonRef: (0, _utils.unwrapDOMRef)(buttonRef),
        popoverRef: popoverRef,
        listBoxRef,
        inputRef,
        // Handled outside the tray.
        name: undefined
    }, state);
    (0, _reactDefault.default).useEffect(()=>{
        (0, _focus.focusSafely)(inputRef.current);
    }, []);
    (0, _reactDefault.default).useEffect(()=>{
        // When the tray closes, set state.isFocused (i.e. the tray input's focus tracker) to false.
        // This is to prevent state.isFocused from being set to true when the tray closes via tapping on the underlay
        // (FocusScope attempts to restore focus to the tray input when tapping outside the tray due to "contain")
        // Have to do this manually since React doesn't call onBlur when a component is unmounted: https://github.com/facebook/react/issues/12363
        if (!state.isOpen && state.isFocused) state.setFocused(false);
    });
    let { dialogProps } = (0, _dialog.useDialog)({
        "aria-labelledby": (0, _utils1.useId)(labelProps.id)
    }, popoverRef);
    // Override the role of the input to "searchbox" instead of "combobox".
    // Since the listbox is always visible, the combobox role doesn't really give us anything.
    // VoiceOver on iOS reads "double tap to collapse" when focused on the input rather than
    // "double tap to edit text", as with a textbox or searchbox. We'd like double tapping to
    // open the virtual keyboard rather than closing the tray.
    // Unlike "combobox", "aria-expanded" is not a valid attribute on "searchbox".
    inputProps.role = "searchbox";
    inputProps["aria-haspopup"] = "listbox";
    delete inputProps["aria-expanded"];
    delete inputProps.onTouchEnd;
    let clearButton = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ClearButton), {
        preventFocus: true,
        "aria-label": stringFormatter.format("clear"),
        excludeFromTabOrder: true,
        onPress: ()=>{
            state.setInputValue("");
            inputRef.current.focus();
        },
        UNSAFE_className: (0, _utils.classNames)((0, _varsCssDefault2.default), "spectrum-ClearButton"),
        isDisabled: isDisabled
    });
    let loadingCircle = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _progress.ProgressCircle), {
        "aria-label": stringFormatter.format("loading"),
        size: "S",
        isIndeterminate: true,
        UNSAFE_className: (0, _utils.classNames)((0, _varsCssDefault2.default), "spectrum-Search-circleLoader", (0, _utils.classNames)((0, _varsCssDefault4.default), "spectrum-Textfield-circleLoader"))
    });
    // Close the software keyboard on scroll to give the user a bigger area to scroll.
    // But only do this if scrolling with touch, otherwise it can cause issues with touch
    // screen readers.
    let isTouchDown = (0, _react.useRef)(false);
    let onTouchStart = ()=>{
        isTouchDown.current = true;
    };
    let onTouchEnd = ()=>{
        isTouchDown.current = false;
    };
    let onScroll = (0, _react.useCallback)(()=>{
        if (!inputRef.current || document.activeElement !== inputRef.current || !isTouchDown.current) return;
        popoverRef.current.focus();
    }, [
        inputRef,
        popoverRef,
        isTouchDown
    ]);
    let inputValue = inputProps.value;
    let lastInputValue = (0, _react.useRef)(inputValue);
    (0, _react.useEffect)(()=>{
        if (loadingState === "filtering" && !showLoading) {
            if (timeout.current === null) timeout.current = setTimeout(()=>{
                setShowLoading(true);
            }, 500);
            // If user is typing, clear the timer and restart since it is a new request
            if (inputValue !== lastInputValue.current) {
                clearTimeout(timeout.current);
                timeout.current = setTimeout(()=>{
                    setShowLoading(true);
                }, 500);
            }
        } else if (loadingState !== "filtering") {
            // If loading is no longer happening, clear any timers and hide the loading circle
            setShowLoading(false);
            clearTimeout(timeout.current);
            timeout.current = null;
        }
        lastInputValue.current = inputValue;
    }, [
        loadingState,
        inputValue,
        showLoading
    ]);
    let onKeyDown = (e)=>{
        // Close virtual keyboard if user hits Enter w/o any focused options
        if (e.key === "Enter" && state.selectionManager.focusedKey == null) popoverRef.current.focus();
        else inputProps.onKeyDown(e);
    };
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _focus.FocusScope), {
        restoreFocus: true,
        contain: true
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...(0, _utils1.mergeProps)(overlayProps, dialogProps),
        ref: popoverRef,
        className: (0, _utils.classNames)((0, _comboboxCssDefault.default), "tray-dialog")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _overlays.DismissButton), {
        onDismiss: onClose
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textfield.TextFieldBase), {
        label: label,
        labelProps: labelProps,
        inputProps: {
            ...inputProps,
            onKeyDown
        },
        inputRef: inputRef,
        isDisabled: isDisabled,
        isLoading: showLoading && loadingState === "filtering",
        loadingIndicator: loadingState != null && loadingCircle,
        validationState: validationState,
        labelAlign: "start",
        labelPosition: "top",
        wrapperChildren: (state.inputValue !== "" || loadingState === "filtering" || validationState != null) && !props.isReadOnly && clearButton,
        UNSAFE_className: (0, _utils.classNames)((0, _varsCssDefault2.default), "spectrum-Search", "spectrum-Textfield", "spectrum-Search--loadable", {
            "spectrum-Search--invalid": validationState === "invalid" && !isDisabled,
            "spectrum-Search--valid": validationState === "valid" && !isDisabled
        }, (0, _utils.classNames)((0, _comboboxCssDefault.default), "tray-textfield", {
            "has-label": !!props.label
        })),
        inputClassName: (0, _utils.classNames)((0, _comboboxCssDefault.default), "tray-textfield-input", (0, _utils.classNames)((0, _varsCssDefault2.default), "spectrum-Search-input")),
        validationIconClassName: (0, _utils.classNames)((0, _varsCssDefault2.default), "spectrum-Search-validationIcon")
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _listbox.ListBoxBase), {
        ...listBoxProps,
        domProps: {
            onTouchStart,
            onTouchEnd
        },
        disallowEmptySelection: true,
        shouldSelectOnPressUp: true,
        focusOnPointerEnter: true,
        layout: layout,
        state: state,
        shouldUseVirtualFocus: true,
        renderEmptyState: ()=>loadingState !== "loading" && /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
                className: (0, _utils.classNames)((0, _comboboxCssDefault.default), "no-results")
            }, stringFormatter.format("noResults")),
        UNSAFE_className: (0, _utils.classNames)((0, _comboboxCssDefault.default), "tray-listbox"),
        ref: listBoxRef,
        onScroll: onScroll,
        onLoadMore: onLoadMore,
        isLoading: isLoading
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _overlays.DismissButton), {
        onDismiss: onClose
    })));
}

},{"@spectrum-icons/ui/AlertMedium":"2v5QX","@adobe/spectrum-css-temp/components/button/vars.css":"cTEhK","@spectrum-icons/ui/CheckmarkMedium":"e6Ew8","@spectrum-icons/ui/ChevronDownMedium":"bWUHC","@react-spectrum/utils":"cMIJ6","@react-spectrum/button":"jZWyP","@react-stately/combobox":"j3BhU","./combobox.css":"kVWNO","@react-aria/overlays":"5fTCg","@react-spectrum/label":"6qv6N","@react-aria/focus":"42mbF","../intl/*.json":"akCse","@adobe/spectrum-css-temp/components/fieldlabel/vars.css":"cEUOQ","@react-spectrum/listbox":"kF7kO","@react-aria/utils":"9cLk5","@react-spectrum/progress":"4kHa7","react":"9yzVZ","@adobe/spectrum-css-temp/components/search/vars.css":"1Ppz4","@react-aria/interactions":"ky3G8","@adobe/spectrum-css-temp/components/inputgroup/vars.css":"fZm3Z","@react-spectrum/textfield":"hOmtq","@adobe/spectrum-css-temp/components/textfield/vars.css":"c3yAu","@react-spectrum/overlays":"3nwGn","@react-aria/button":"fsdLZ","@react-aria/combobox":"4enyJ","@react-aria/dialog":"aSQNt","@react-aria/label":"74Ccz","@react-aria/i18n":"411rg","@react-aria/form":"lerqa","@react-spectrum/provider":"5bCdp","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"jA6za":[function(require,module,exports) {
/*
 * Copyright 2021 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ContextualHelp", ()=>(0, _contextualHelp.ContextualHelp));
var _contextualHelp = require("./ContextualHelp");

},{"./ContextualHelp":"2U7YN","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"2U7YN":[function(require,module,exports) {
/*
 * Copyright 2021 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ContextualHelp", ()=>_ContextualHelp);
var _button = require("@react-spectrum/button");
var _utils = require("@react-spectrum/utils");
var _dialog = require("@react-spectrum/dialog");
var _helpOutline = require("@spectrum-icons/workflow/HelpOutline");
var _helpOutlineDefault = parcelHelpers.interopDefault(_helpOutline);
var _varsCss = require("@adobe/spectrum-css-temp/components/contextualhelp/vars.css");
var _varsCssDefault = parcelHelpers.interopDefault(_varsCss);
var _infoOutline = require("@spectrum-icons/workflow/InfoOutline");
var _infoOutlineDefault = parcelHelpers.interopDefault(_infoOutline);
// @ts-ignore
var _json = require("../intl/*.json");
var _jsonDefault = parcelHelpers.interopDefault(_json);
var _utils1 = require("@react-aria/utils");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _i18N = require("@react-aria/i18n");
function ContextualHelp(props, ref) {
    let { variant = "help", placement = "bottom start", children, ...otherProps } = props;
    let stringFormatter = (0, _i18N.useLocalizedStringFormatter)((0, _jsonDefault.default), "@react-spectrum/contextualhelp");
    let icon = variant === "info" ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _infoOutlineDefault.default), null) : /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _helpOutlineDefault.default), null);
    let slots = {
        content: {
            UNSAFE_className: (0, _varsCssDefault.default)["react-spectrum-ContextualHelp-content"]
        },
        footer: {
            UNSAFE_className: (0, _varsCssDefault.default)["react-spectrum-ContextualHelp-footer"]
        }
    };
    let labelProps = (0, _utils1.useLabels)(otherProps, stringFormatter.format(variant));
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _dialog.DialogTrigger), {
        ...otherProps,
        type: "popover",
        placement: placement,
        hideArrow: true
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), {
        ...(0, _utils1.mergeProps)(otherProps, labelProps, {
            isDisabled: false
        }),
        ref: ref,
        UNSAFE_className: (0, _utils.classNames)((0, _varsCssDefault.default), "react-spectrum-ContextualHelp-button", otherProps.UNSAFE_className),
        isQuiet: true
    }, icon), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.ClearSlots), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.SlotProvider), {
        slots: slots
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _dialog.Dialog), {
        UNSAFE_className: (0, _utils.classNames)((0, _varsCssDefault.default), "react-spectrum-ContextualHelp-dialog")
    }, children))));
}
/**
 * Contextual help shows a user extra information about the state of an adjacent component, or a total view.
 */ let _ContextualHelp = /*#__PURE__*/ (0, _reactDefault.default).forwardRef(ContextualHelp);

},{"@react-spectrum/button":"jZWyP","@react-spectrum/utils":"cMIJ6","@react-spectrum/dialog":"3G0HV","@spectrum-icons/workflow/HelpOutline":"1Iqmu","@adobe/spectrum-css-temp/components/contextualhelp/vars.css":"8C22x","@spectrum-icons/workflow/InfoOutline":"b3t2v","../intl/*.json":"lVDa9","@react-aria/utils":"9cLk5","react":"9yzVZ","@react-aria/i18n":"411rg","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"1Iqmu":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("9ac2616158f22b49");
exports.__esModule = true;
exports.default = HelpOutline;
var _HelpOutline = require("ca4327ec58e8849");
var _icon = require("238b89acacc18a09");
var _react = _interopRequireDefault(require("5d1eca3df200f81a"));
function HelpOutline(props) {
    return /*#__PURE__*/ _react.default.createElement(_icon.Icon, props, /*#__PURE__*/ _react.default.createElement(_HelpOutline.A4uHelpOutline, null));
}

},{"9ac2616158f22b49":"iHubQ","ca4327ec58e8849":"1hViS","238b89acacc18a09":"k7wem","5d1eca3df200f81a":"9yzVZ"}],"1hViS":[function(require,module,exports) {
/**
* @adobe/react-spectrum-workflow (c) by Adobe
* 
* @adobe/react-spectrum-workflow is licensed under a
* Creative Commons Attribution-NoDerivatives 4.0 International License.
* 
* You should have received a copy of the license along with this
* work. If not, see <http://creativecommons.org/licenses/by-nd/4.0/>.
**/ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.A4uHelpOutline = A4uHelpOutline;
var _react = _interopRequireDefault(require("f7ce75dd61c9b212"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function A4uHelpOutline(_ref) {
    var props = _extends({}, _ref);
    return /*#__PURE__*/ _react["default"].createElement("svg", _extends({
        viewBox: "0 0 36 36"
    }, props, props), /*#__PURE__*/ _react["default"].createElement("path", {
        fillRule: "evenodd",
        d: "M20.18127,25.932a1.83345,1.83345,0,0,1-1.95444,2.01521A1.86185,1.86185,0,0,1,16.27145,25.932a1.95513,1.95513,0,1,1,3.90982,0ZM17.95316,8.00006a9.23221,9.23221,0,0,0-4.5182,1.0724c-.11848.06278-.11848.1843-.11848.30683v2.97112a.14919.14919,0,0,0,.23709.12152,7.38464,7.38464,0,0,1,3.74491-1.00961c1.81265,0,2.52657.76556,2.52657,1.86834,0,.94987-.56506,1.5929-1.54518,2.60353C16.8533,17.40557,15.99052,18.323,15.99052,19.763a3.41737,3.41737,0,0,0,.71392,2.11441A.488.488,0,0,0,17.09038,22h2.58581a.13062.13062,0,0,0,.11861-.21469,3.3024,3.3024,0,0,1-.47557-1.68606c0-.91747,1.09987-1.92809,2.2591-3.06226a5.4743,5.4743,0,0,0,1.90214-4.2258C23.48047,10.11549,21.51909,8.00006,17.95316,8.00006ZM35,18A17,17,0,1,1,18,1.0001,17.00005,17.00005,0,0,1,35,18Zm-3.65039,0A13.34961,13.34961,0,1,0,18,31.34953,13.34954,13.34954,0,0,0,31.34961,18Z"
    }));
}

},{"f7ce75dd61c9b212":"9yzVZ"}],"lVDa9":[function(require,module,exports) {
const _temp0 = require("89dbaacc80555003");
const _temp1 = require("caed0cbd371fd35");
const _temp2 = require("f3662d9c4637e5ff");
const _temp3 = require("65f98ebc3e797d47");
const _temp4 = require("e4fdce2846a02a6b");
const _temp5 = require("16f541ee58cb9a7a");
const _temp6 = require("cf85606303f35514");
const _temp7 = require("861a8c46323cf9ee");
const _temp8 = require("b2b8faf1494af5ca");
const _temp9 = require("7672f94fe673d647");
const _temp10 = require("4420562285ed675e");
const _temp11 = require("58b654d258723ad1");
const _temp12 = require("593d705827ea884f");
const _temp13 = require("2f34cc66ab6f8a68");
const _temp14 = require("d94ce9c1ed3d4cfd");
const _temp15 = require("b983f0e2263973f0");
const _temp16 = require("d190a6ed1d01fd17");
const _temp17 = require("3539e1a0df3f1afe");
const _temp18 = require("383755bd8d5f45ac");
const _temp19 = require("9e3f2717bf0ed189");
const _temp20 = require("229bc98ff81bf017");
const _temp21 = require("a995b435aaf5c57c");
const _temp22 = require("a5cff7b60ef2672e");
const _temp23 = require("144e27538caac8aa");
const _temp24 = require("f8d5f80c314ecb0f");
const _temp25 = require("39a33c396989cea1");
const _temp26 = require("776eab080de87aa4");
const _temp27 = require("41f35c98a12f0c83");
const _temp28 = require("1541367599487a5d");
const _temp29 = require("563e0cedeeacae20");
const _temp30 = require("bb9506c5a2c70ede");
const _temp31 = require("9723da1c056c382");
const _temp32 = require("87e5468019ead50a");
const _temp33 = require("db511b52d46902ae");
module.exports = {
    "ar-AE": _temp0,
    "bg-BG": _temp1,
    "cs-CZ": _temp2,
    "da-DK": _temp3,
    "de-DE": _temp4,
    "el-GR": _temp5,
    "en-US": _temp6,
    "es-ES": _temp7,
    "et-EE": _temp8,
    "fi-FI": _temp9,
    "fr-FR": _temp10,
    "he-IL": _temp11,
    "hr-HR": _temp12,
    "hu-HU": _temp13,
    "it-IT": _temp14,
    "ja-JP": _temp15,
    "ko-KR": _temp16,
    "lt-LT": _temp17,
    "lv-LV": _temp18,
    "nb-NO": _temp19,
    "nl-NL": _temp20,
    "pl-PL": _temp21,
    "pt-BR": _temp22,
    "pt-PT": _temp23,
    "ro-RO": _temp24,
    "ru-RU": _temp25,
    "sk-SK": _temp26,
    "sl-SI": _temp27,
    "sr-SP": _temp28,
    "sv-SE": _temp29,
    "tr-TR": _temp30,
    "uk-UA": _temp31,
    "zh-CN": _temp32,
    "zh-TW": _temp33
};

},{"89dbaacc80555003":"bUUGR","caed0cbd371fd35":"4BzBQ","f3662d9c4637e5ff":"9iCgn","65f98ebc3e797d47":"86CpT","e4fdce2846a02a6b":"aW9kw","16f541ee58cb9a7a":"jefcm","cf85606303f35514":"HGbT7","861a8c46323cf9ee":"g70Ft","b2b8faf1494af5ca":"63G9i","7672f94fe673d647":"3VoMe","4420562285ed675e":"iRhtK","58b654d258723ad1":"k7RRC","593d705827ea884f":"huLwP","2f34cc66ab6f8a68":"8KjIF","d94ce9c1ed3d4cfd":"jHOQo","b983f0e2263973f0":"6XbOn","d190a6ed1d01fd17":"6Ttf1","3539e1a0df3f1afe":"bswG2","383755bd8d5f45ac":"jID4p","9e3f2717bf0ed189":"fuG6o","229bc98ff81bf017":"2XEeo","a995b435aaf5c57c":"26rtz","a5cff7b60ef2672e":"igeuT","144e27538caac8aa":"cNyPT","f8d5f80c314ecb0f":"dzzCb","39a33c396989cea1":"hBBJK","776eab080de87aa4":"hSAdP","41f35c98a12f0c83":"1cbLK","1541367599487a5d":"1ilq1","563e0cedeeacae20":"30TMh","bb9506c5a2c70ede":"iqH5z","9723da1c056c382":"aLurv","87e5468019ead50a":"jLv4o","db511b52d46902ae":"heaX6"}],"bUUGR":[function(require,module,exports) {
module.exports = {
    "help": `\u{645}\u{633}\u{627}\u{639}\u{62F}\u{629}`,
    "info": `\u{645}\u{639}\u{644}\u{648}\u{645}\u{627}\u{62A}`
};

},{}],"4BzBQ":[function(require,module,exports) {
module.exports = {
    "help": `\u{41F}\u{43E}\u{43C}\u{43E}\u{449}`,
    "info": `\u{418}\u{43D}\u{444}\u{43E}\u{440}\u{43C}\u{430}\u{446}\u{438}\u{44F}`
};

},{}],"9iCgn":[function(require,module,exports) {
module.exports = {
    "help": `N\xe1pov\u{11B}da`,
    "info": `Informace`
};

},{}],"86CpT":[function(require,module,exports) {
module.exports = {
    "help": `Hj\xe6lp`,
    "info": `Oplysninger`
};

},{}],"aW9kw":[function(require,module,exports) {
module.exports = {
    "help": `Hilfe`,
    "info": `Informationen`
};

},{}],"jefcm":[function(require,module,exports) {
module.exports = {
    "help": `\u{392}\u{3BF}\u{3AE}\u{3B8}\u{3B5}\u{3B9}\u{3B1}`,
    "info": `\u{3A0}\u{3BB}\u{3B7}\u{3C1}\u{3BF}\u{3C6}\u{3BF}\u{3C1}\u{3AF}\u{3B5}\u{3C2}`
};

},{}],"HGbT7":[function(require,module,exports) {
module.exports = {
    "info": `Information`,
    "help": `Help`
};

},{}],"g70Ft":[function(require,module,exports) {
module.exports = {
    "help": `Ayuda`,
    "info": `Informaci\xf3n`
};

},{}],"63G9i":[function(require,module,exports) {
module.exports = {
    "help": `Spikker`,
    "info": `Teave`
};

},{}],"3VoMe":[function(require,module,exports) {
module.exports = {
    "help": `Ohje`,
    "info": `Tiedot`
};

},{}],"iRhtK":[function(require,module,exports) {
module.exports = {
    "help": `Aide`,
    "info": `Informations`
};

},{}],"k7RRC":[function(require,module,exports) {
module.exports = {
    "help": `\u{5E2}\u{5D6}\u{5E8}\u{5D4}`,
    "info": `\u{5DE}\u{5D9}\u{5D3}\u{5E2}`
};

},{}],"huLwP":[function(require,module,exports) {
module.exports = {
    "help": `Pomo\u{107}`,
    "info": `Informacije`
};

},{}],"8KjIF":[function(require,module,exports) {
module.exports = {
    "help": `S\xfag\xf3`,
    "info": `Inform\xe1ci\xf3`
};

},{}],"jHOQo":[function(require,module,exports) {
module.exports = {
    "help": `Aiuto`,
    "info": `Informazioni`
};

},{}],"6XbOn":[function(require,module,exports) {
module.exports = {
    "help": `\u{30D8}\u{30EB}\u{30D7}`,
    "info": `\u{60C5}\u{5831}`
};

},{}],"6Ttf1":[function(require,module,exports) {
module.exports = {
    "help": `\u{B3C4}\u{C6C0}\u{B9D0}`,
    "info": `\u{C815}\u{BCF4}`
};

},{}],"bswG2":[function(require,module,exports) {
module.exports = {
    "help": `\u{17D}inynas`,
    "info": `Informacija`
};

},{}],"jID4p":[function(require,module,exports) {
module.exports = {
    "help": `Pal\u{12B}dz\u{12B}ba`,
    "info": `Inform\u{101}cija`
};

},{}],"fuG6o":[function(require,module,exports) {
module.exports = {
    "help": `Hjelp`,
    "info": `Informasjon`
};

},{}],"2XEeo":[function(require,module,exports) {
module.exports = {
    "help": `Help`,
    "info": `Informatie`
};

},{}],"26rtz":[function(require,module,exports) {
module.exports = {
    "help": `Pomoc`,
    "info": `Informacja`
};

},{}],"igeuT":[function(require,module,exports) {
module.exports = {
    "help": `Ajuda`,
    "info": `Informa\xe7\xf5es`
};

},{}],"cNyPT":[function(require,module,exports) {
module.exports = {
    "help": `Ajuda`,
    "info": `Informa\xe7\xe3o`
};

},{}],"dzzCb":[function(require,module,exports) {
module.exports = {
    "help": `Ajutor`,
    "info": `Informa\u{163}ii`
};

},{}],"hBBJK":[function(require,module,exports) {
module.exports = {
    "help": `\u{421}\u{43F}\u{440}\u{430}\u{432}\u{43A}\u{430}`,
    "info": `\u{418}\u{43D}\u{444}\u{43E}\u{440}\u{43C}\u{430}\u{446}\u{438}\u{44F}`
};

},{}],"hSAdP":[function(require,module,exports) {
module.exports = {
    "help": `Pomoc`,
    "info": `Inform\xe1cie`
};

},{}],"1cbLK":[function(require,module,exports) {
module.exports = {
    "help": `Pomo\u{10D}`,
    "info": `Informacije`
};

},{}],"1ilq1":[function(require,module,exports) {
module.exports = {
    "help": `Pomo\u{107}`,
    "info": `Informacije`
};

},{}],"30TMh":[function(require,module,exports) {
module.exports = {
    "help": `Hj\xe4lp`,
    "info": `Information`
};

},{}],"iqH5z":[function(require,module,exports) {
module.exports = {
    "help": `Yard\u{131}m`,
    "info": `Bilgiler`
};

},{}],"aLurv":[function(require,module,exports) {
module.exports = {
    "help": `\u{414}\u{43E}\u{432}\u{456}\u{434}\u{43A}\u{430}`,
    "info": `\u{406}\u{43D}\u{444}\u{43E}\u{440}\u{43C}\u{430}\u{446}\u{456}\u{44F}`
};

},{}],"jLv4o":[function(require,module,exports) {
module.exports = {
    "help": `\u{5E2E}\u{52A9}`,
    "info": `\u{4FE1}\u{606F}`
};

},{}],"heaX6":[function(require,module,exports) {
module.exports = {
    "help": `\u{8AAA}\u{660E}`,
    "info": `\u{8CC7}\u{8A0A}`
};

},{}],"2xkLK":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /// <reference types="css-module-types" />
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DatePicker", ()=>(0, _datePicker.DatePicker));
parcelHelpers.export(exports, "DateRangePicker", ()=>(0, _dateRangePicker.DateRangePicker));
parcelHelpers.export(exports, "TimeField", ()=>(0, _timeField.TimeField));
parcelHelpers.export(exports, "DateField", ()=>(0, _dateField.DateField));
var _datePicker = require("./DatePicker");
var _dateRangePicker = require("./DateRangePicker");
var _timeField = require("./TimeField");
var _dateField = require("./DateField");

},{"./DatePicker":"gAYaG","./DateRangePicker":"9xK8Q","./TimeField":"77Uzq","./DateField":"2vxNC","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"gAYaG":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DatePicker", ()=>_DatePicker);
var _calendar = require("@react-spectrum/calendar");
var _calendar1 = require("@spectrum-icons/workflow/Calendar");
var _calendarDefault = parcelHelpers.interopDefault(_calendar1);
var _utils = require("@react-spectrum/utils");
var _view = require("@react-spectrum/view");
var _datePickerField = require("./DatePickerField");
var _stylesCss = require("./styles.css");
var _stylesCssDefault = parcelHelpers.interopDefault(_stylesCss);
var _dialog = require("@react-spectrum/dialog");
var _label = require("@react-spectrum/label");
var _button = require("@react-spectrum/button");
var _input = require("./Input");
// @ts-ignore
var _json = require("../intl/*.json");
var _jsonDefault = parcelHelpers.interopDefault(_json);
var _utils1 = require("@react-aria/utils");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _varsCss = require("@adobe/spectrum-css-temp/components/textfield/vars.css"); // HACK: must be included BEFORE inputgroup
var _varsCss1 = require("@adobe/spectrum-css-temp/components/inputgroup/vars.css");
var _varsCssDefault = parcelHelpers.interopDefault(_varsCss1);
var _timeField = require("./TimeField");
var _datepicker = require("@react-aria/datepicker");
var _datepicker1 = require("@react-stately/datepicker");
var _utils2 = require("./utils");
var _focus = require("@react-aria/focus");
var _form = require("@react-spectrum/form");
var _interactions = require("@react-aria/interactions");
var _i18N = require("@react-aria/i18n");
var _provider = require("@react-spectrum/provider");
function DatePicker(props, ref) {
    props = (0, _provider.useProviderProps)(props);
    props = (0, _form.useFormProps)(props);
    let { autoFocus, isQuiet, isDisabled, placeholderValue, maxVisibleMonths = 1, pageBehavior } = props;
    let { hoverProps, isHovered } = (0, _interactions.useHover)({
        isDisabled
    });
    let targetRef = (0, _react.useRef)();
    let state = (0, _datepicker1.useDatePickerState)({
        ...props,
        shouldCloseOnSelect: ()=>!state.hasTime
    });
    let { groupProps, labelProps, fieldProps, descriptionProps, errorMessageProps, buttonProps, dialogProps, calendarProps, isInvalid, validationErrors, validationDetails } = (0, _datepicker.useDatePicker)(props, state, targetRef);
    let { isOpen, setOpen } = state;
    let { direction } = (0, _i18N.useLocale)();
    let domRef = (0, _utils2.useFocusManagerRef)(ref);
    let stringFormatter = (0, _i18N.useLocalizedStringFormatter)((0, _jsonDefault.default), "@react-spectrum/datepicker");
    let { isFocused, isFocusVisible, focusProps } = (0, _focus.useFocusRing)({
        within: true,
        isTextInput: true,
        autoFocus
    });
    let { isFocused: isFocusedButton, focusProps: focusPropsButton } = (0, _focus.useFocusRing)({
        within: false,
        isTextInput: false,
        autoFocus
    });
    let className = (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-InputGroup", {
        "spectrum-InputGroup--quiet": isQuiet,
        "spectrum-InputGroup--invalid": isInvalid && !isDisabled,
        "is-disabled": isDisabled,
        "is-hovered": isHovered,
        "is-focused": isFocused,
        "focus-ring": isFocusVisible && !isFocusedButton
    });
    let fieldClassName = (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-InputGroup-input", {
        "is-disabled": isDisabled,
        "is-invalid": isInvalid && !isDisabled
    });
    // Note: this description is intentionally not passed to useDatePicker.
    // The format help text is unnecessary for screen reader users because each segment already has a label.
    let description = (0, _utils2.useFormatHelpText)(props);
    if (description && !props.description) descriptionProps.id = null;
    let placeholder = placeholderValue;
    let timePlaceholder = placeholder && "hour" in placeholder ? placeholder : null;
    let timeMinValue = props.minValue && "hour" in props.minValue ? props.minValue : null;
    let timeMaxValue = props.maxValue && "hour" in props.maxValue ? props.maxValue : null;
    let timeGranularity = state.granularity === "hour" || state.granularity === "minute" || state.granularity === "second" ? state.granularity : null;
    let showTimeField = !!timeGranularity;
    let visibleMonths = (0, _utils2.useVisibleMonths)(maxVisibleMonths);
    let validationState = state.validationState || (isInvalid ? "invalid" : null);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _label.Field), {
        ...props,
        ref: domRef,
        elementType: "span",
        description: description,
        labelProps: labelProps,
        descriptionProps: descriptionProps,
        errorMessageProps: errorMessageProps,
        validationState: validationState,
        isInvalid: isInvalid,
        validationErrors: validationErrors,
        validationDetails: validationDetails,
        wrapperClassName: (0, _utils.classNames)((0, _stylesCssDefault.default), "react-spectrum-Datepicker-fieldWrapper")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...(0, _utils1.mergeProps)(groupProps, hoverProps, focusProps),
        className: className,
        ref: targetRef
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _input.Input), {
        isDisabled: isDisabled,
        isQuiet: isQuiet,
        validationState: validationState,
        className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-InputGroup-field"),
        inputClassName: fieldClassName,
        disableFocusRing: true
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _datePickerField.DatePickerField), {
        ...fieldProps,
        "data-testid": "date-field",
        isQuiet: isQuiet
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _dialog.DialogTrigger), {
        type: "popover",
        mobileType: "tray",
        placement: direction === "rtl" ? "bottom right" : "bottom left",
        targetRef: targetRef,
        hideArrow: true,
        isOpen: isOpen,
        onOpenChange: setOpen,
        shouldFlip: props.shouldFlip
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.FieldButton), {
        ...(0, _utils1.mergeProps)(buttonProps, focusPropsButton),
        UNSAFE_className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-FieldButton"),
        isQuiet: isQuiet,
        validationState: validationState
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _calendarDefault.default), null)), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _dialog.Dialog), {
        UNSAFE_className: (0, _utils.classNames)((0, _stylesCssDefault.default), "react-spectrum-Datepicker-dialog"),
        ...dialogProps
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Content), null, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _utils.classNames)((0, _stylesCssDefault.default), "react-spectrum-Datepicker-dialogContent")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _calendar.Calendar), {
        ...calendarProps,
        visibleMonths: visibleMonths,
        pageBehavior: pageBehavior,
        UNSAFE_className: (0, _utils.classNames)((0, _stylesCssDefault.default), "react-spectrum-Datepicker-calendar", {
            "is-invalid": isInvalid
        })
    }), showTimeField && /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _utils.classNames)((0, _stylesCssDefault.default), "react-spectrum-Datepicker-timeFields")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _timeField.TimeField), {
        label: stringFormatter.format("time"),
        value: state.timeValue,
        onChange: state.setTimeValue,
        placeholderValue: timePlaceholder,
        granularity: timeGranularity,
        minValue: timeMinValue,
        maxValue: timeMaxValue,
        hourCycle: props.hourCycle,
        hideTimeZone: props.hideTimeZone,
        marginTop: "size-100"
    }))))))));
}
/**
 * DatePickers combine a DateField and a Calendar popover to allow users to enter or select a date and time value.
 */ const _DatePicker = /*#__PURE__*/ (0, _reactDefault.default).forwardRef(DatePicker);

},{"@react-spectrum/calendar":"9d2lg","@spectrum-icons/workflow/Calendar":"bJMhf","@react-spectrum/utils":"cMIJ6","@react-spectrum/view":"dnRjt","./DatePickerField":"7xJop","./styles.css":"58Z98","@react-spectrum/dialog":"3G0HV","@react-spectrum/label":"6qv6N","@react-spectrum/button":"jZWyP","./Input":"8AsUB","../intl/*.json":"hRuFY","@react-aria/utils":"9cLk5","react":"9yzVZ","@adobe/spectrum-css-temp/components/textfield/vars.css":"c3yAu","@adobe/spectrum-css-temp/components/inputgroup/vars.css":"fZm3Z","./TimeField":"77Uzq","@react-aria/datepicker":"5gh3m","@react-stately/datepicker":"ci7Mv","./utils":"d42tP","@react-aria/focus":"42mbF","@react-spectrum/form":"bGDqA","@react-aria/interactions":"ky3G8","@react-aria/i18n":"411rg","@react-spectrum/provider":"5bCdp","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"bJMhf":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("944240d8aefb5478");
exports.__esModule = true;
exports.default = Calendar;
var _Calendar = require("f7dc77a7913e245f");
var _icon = require("11af7b9aafd564b3");
var _react = _interopRequireDefault(require("93ce1dea8b85a3c"));
function Calendar(props) {
    return /*#__PURE__*/ _react.default.createElement(_icon.Icon, props, /*#__PURE__*/ _react.default.createElement(_Calendar.A4uCalendar, null));
}

},{"944240d8aefb5478":"iHubQ","f7dc77a7913e245f":"bTNiu","11af7b9aafd564b3":"k7wem","93ce1dea8b85a3c":"9yzVZ"}],"bTNiu":[function(require,module,exports) {
/**
* @adobe/react-spectrum-workflow (c) by Adobe
* 
* @adobe/react-spectrum-workflow is licensed under a
* Creative Commons Attribution-NoDerivatives 4.0 International License.
* 
* You should have received a copy of the license along with this
* work. If not, see <http://creativecommons.org/licenses/by-nd/4.0/>.
**/ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.A4uCalendar = A4uCalendar;
var _react = _interopRequireDefault(require("f718e1cf8e274eb8"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function A4uCalendar(_ref) {
    var props = _extends({}, _ref);
    return /*#__PURE__*/ _react["default"].createElement("svg", _extends({
        viewBox: "0 0 36 36"
    }, props, props), /*#__PURE__*/ _react["default"].createElement("path", {
        fillRule: "evenodd",
        d: "M33,6H28V3a1,1,0,0,0-1-1H25a1,1,0,0,0-1,1V6H10V3A1,1,0,0,0,9,2H7A1,1,0,0,0,6,3V6H1A1,1,0,0,0,0,7V33a1,1,0,0,0,1,1H33a1,1,0,0,0,1-1V7A1,1,0,0,0,33,6ZM32,32H2V8H6V9a1,1,0,0,0,1,1H9a1,1,0,0,0,1-1V8H24V9a1,1,0,0,0,1,1h2a1,1,0,0,0,1-1V8h4Z"
    }), /*#__PURE__*/ _react["default"].createElement("rect", {
        fillRule: "evenodd",
        x: "6",
        y: "12",
        width: "4",
        height: "4"
    }), /*#__PURE__*/ _react["default"].createElement("rect", {
        fillRule: "evenodd",
        x: "12",
        y: "12",
        width: "4",
        height: "4"
    }), /*#__PURE__*/ _react["default"].createElement("rect", {
        fillRule: "evenodd",
        x: "18",
        y: "12",
        width: "4",
        height: "4"
    }), /*#__PURE__*/ _react["default"].createElement("rect", {
        fillRule: "evenodd",
        x: "24",
        y: "12",
        width: "4",
        height: "4"
    }), /*#__PURE__*/ _react["default"].createElement("rect", {
        fillRule: "evenodd",
        x: "6",
        y: "18",
        width: "4",
        height: "4"
    }), /*#__PURE__*/ _react["default"].createElement("rect", {
        fillRule: "evenodd",
        x: "12",
        y: "18",
        width: "4",
        height: "4"
    }), /*#__PURE__*/ _react["default"].createElement("rect", {
        fillRule: "evenodd",
        x: "18",
        y: "18",
        width: "4",
        height: "4"
    }), /*#__PURE__*/ _react["default"].createElement("rect", {
        fillRule: "evenodd",
        x: "24",
        y: "18",
        width: "4",
        height: "4"
    }), /*#__PURE__*/ _react["default"].createElement("rect", {
        fillRule: "evenodd",
        x: "6",
        y: "24",
        width: "4",
        height: "4"
    }), /*#__PURE__*/ _react["default"].createElement("rect", {
        fillRule: "evenodd",
        x: "12",
        y: "24",
        width: "4",
        height: "4"
    }), /*#__PURE__*/ _react["default"].createElement("rect", {
        fillRule: "evenodd",
        x: "18",
        y: "24",
        width: "4",
        height: "4"
    }), /*#__PURE__*/ _react["default"].createElement("rect", {
        fillRule: "evenodd",
        x: "24",
        y: "24",
        width: "4",
        height: "4"
    }));
}

},{"f718e1cf8e274eb8":"9yzVZ"}],"7xJop":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DatePickerField", ()=>DatePickerField);
var _utils = require("@react-spectrum/utils");
var _date = require("@internationalized/date");
var _datePickerSegment = require("./DatePickerSegment");
var _stylesCss = require("./styles.css");
var _stylesCssDefault = parcelHelpers.interopDefault(_stylesCss);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _datepicker = require("@react-aria/datepicker");
var _datepicker1 = require("@react-stately/datepicker");
var _i18N = require("@react-aria/i18n");
function DatePickerField(props) {
    let { isDisabled, isReadOnly, isRequired, inputClassName } = props;
    let ref = (0, _react.useRef)();
    let { locale } = (0, _i18N.useLocale)();
    let state = (0, _datepicker1.useDateFieldState)({
        ...props,
        locale,
        createCalendar: (0, _date.createCalendar)
    });
    let inputRef = (0, _react.useRef)();
    let { fieldProps, inputProps } = (0, _datepicker.useDateField)({
        ...props,
        inputRef
    }, state, ref);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...fieldProps,
        "data-testid": props["data-testid"],
        className: (0, _utils.classNames)((0, _stylesCssDefault.default), "react-spectrum-Datepicker-segments", inputClassName),
        ref: ref
    }, state.segments.map((segment, i)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _datePickerSegment.DatePickerSegment), {
            key: i,
            segment: segment,
            state: state,
            isDisabled: isDisabled,
            isReadOnly: isReadOnly,
            isRequired: isRequired
        })), /*#__PURE__*/ (0, _reactDefault.default).createElement("input", {
        ...inputProps,
        ref: inputRef
    }));
}

},{"@react-spectrum/utils":"cMIJ6","@internationalized/date":"hesBk","./DatePickerSegment":"aKPrh","./styles.css":"58Z98","react":"9yzVZ","@react-aria/datepicker":"5gh3m","@react-stately/datepicker":"ci7Mv","@react-aria/i18n":"411rg","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"aKPrh":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DatePickerSegment", ()=>DatePickerSegment);
var _utils = require("@react-spectrum/utils");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _stylesCss = require("./styles.css");
var _stylesCssDefault = parcelHelpers.interopDefault(_stylesCss);
var _datepicker = require("@react-aria/datepicker");
function DatePickerSegment({ segment, state, ...otherProps }) {
    switch(segment.type){
        // A separator, e.g. punctuation
        case "literal":
            return /*#__PURE__*/ (0, _reactDefault.default).createElement(LiteralSegment, {
                segment: segment
            });
        // Editable segment
        default:
            return /*#__PURE__*/ (0, _reactDefault.default).createElement(EditableSegment, {
                segment: segment,
                state: state,
                ...otherProps
            });
    }
}
function LiteralSegment({ segment }) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        "aria-hidden": "true",
        className: (0, _utils.classNames)((0, _stylesCssDefault.default), "react-spectrum-Datepicker-literal"),
        "data-testid": segment.type === "literal" ? undefined : segment.type
    }, segment.text);
}
function EditableSegment({ segment, state }) {
    let ref = (0, _react.useRef)();
    let { segmentProps } = (0, _datepicker.useDateSegment)(segment, state, ref);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...segmentProps,
        ref: ref,
        className: (0, _utils.classNames)((0, _stylesCssDefault.default), "react-spectrum-DatePicker-cell", {
            "is-placeholder": segment.isPlaceholder,
            "is-read-only": !segment.isEditable
        }),
        style: {
            ...segmentProps.style,
            minWidth: segment.maxValue != null ? String(segment.maxValue).length + "ch" : null
        },
        "data-testid": segment.type
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        "aria-hidden": "true",
        className: (0, _utils.classNames)((0, _stylesCssDefault.default), "react-spectrum-DatePicker-placeholder")
    }, segment.placeholder), segment.isPlaceholder ? "" : segment.text);
}

},{"@react-spectrum/utils":"cMIJ6","react":"9yzVZ","./styles.css":"58Z98","@react-aria/datepicker":"5gh3m","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"58Z98":[function(require,module,exports) {
module.exports["is-invalid"] = `_2n04KW_is-invalid`;
module.exports["is-placeholder"] = `_2n04KW_is-placeholder`;
module.exports["is-read-only"] = `_2n04KW_is-read-only`;
module.exports["react-spectrum-DateField"] = `_2n04KW_react-spectrum-DateField`;
module.exports["react-spectrum-DateField-Input"] = `_2n04KW_react-spectrum-DateField-Input`;
module.exports["react-spectrum-DatePicker-cell"] = `_2n04KW_react-spectrum-DatePicker-cell`;
module.exports["react-spectrum-DatePicker-placeholder"] = `_2n04KW_react-spectrum-DatePicker-placeholder`;
module.exports["react-spectrum-Datepicker-calendar"] = `_2n04KW_react-spectrum-Datepicker-calendar`;
module.exports["react-spectrum-Datepicker-dialog"] = `_2n04KW_react-spectrum-Datepicker-dialog`;
module.exports["react-spectrum-Datepicker-dialogContent"] = `_2n04KW_react-spectrum-Datepicker-dialogContent`;
module.exports["react-spectrum-Datepicker-endField"] = `_2n04KW_react-spectrum-Datepicker-endField`;
module.exports["react-spectrum-Datepicker-field"] = `_2n04KW_react-spectrum-Datepicker-field`;
module.exports["react-spectrum-Datepicker-fieldWrapper"] = `_2n04KW_react-spectrum-Datepicker-fieldWrapper`;
module.exports["react-spectrum-Datepicker-input"] = `_2n04KW_react-spectrum-Datepicker-input`;
module.exports["react-spectrum-Datepicker-inputContents"] = `_2n04KW_react-spectrum-Datepicker-inputContents`;
module.exports["react-spectrum-Datepicker-literal"] = `_2n04KW_react-spectrum-Datepicker-literal`;
module.exports["react-spectrum-Datepicker-rangeDash"] = `_2n04KW_react-spectrum-Datepicker-rangeDash`;
module.exports["react-spectrum-Datepicker-segments"] = `_2n04KW_react-spectrum-Datepicker-segments`;
module.exports["react-spectrum-Datepicker-startField"] = `_2n04KW_react-spectrum-Datepicker-startField`;
module.exports["react-spectrum-Datepicker-timeFields"] = `_2n04KW_react-spectrum-Datepicker-timeFields`;
module.exports["react-spectrum-TimeField"] = `_2n04KW_react-spectrum-TimeField`;
module.exports["react-spectrum-TimeField-fieldWrapper"] = `_2n04KW_react-spectrum-TimeField-fieldWrapper`;

},{}],"8AsUB":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Input", ()=>_Input);
var _alertMedium = require("@spectrum-icons/ui/AlertMedium");
var _alertMediumDefault = parcelHelpers.interopDefault(_alertMedium);
var _checkmarkMedium = require("@spectrum-icons/ui/CheckmarkMedium");
var _checkmarkMediumDefault = parcelHelpers.interopDefault(_checkmarkMedium);
var _utils = require("@react-spectrum/utils");
var _stylesCss = require("./styles.css");
var _stylesCssDefault = parcelHelpers.interopDefault(_stylesCss);
var _utils1 = require("@react-aria/utils");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _varsCss = require("@adobe/spectrum-css-temp/components/textfield/vars.css");
var _varsCssDefault = parcelHelpers.interopDefault(_varsCss);
var _focus = require("@react-aria/focus");
function Input(props, ref) {
    let inputRef = (0, _react.useRef)(null);
    let { isDisabled, isQuiet, inputClassName, validationState, children, fieldProps, className, style, disableFocusRing } = props;
    // Reserve padding for the error icon when the width of the input is unconstrained.
    // When constrained, don't reserve space because adding it only when invalid will
    // not cause a layout shift.
    let [reservePadding, setReservePadding] = (0, _utils.useValueEffect)(false);
    let onResize = (0, _react.useCallback)(()=>setReservePadding(function*(reservePadding) {
            if (inputRef.current) {
                if (reservePadding) // Try to collapse padding if the content is clipped.
                {
                    if (inputRef.current.scrollWidth > inputRef.current.offsetWidth) {
                        let width = inputRef.current.parentElement.offsetWidth;
                        yield false;
                        // If removing padding causes a layout shift, add it back.
                        if (inputRef.current.parentElement.offsetWidth !== width) yield true;
                    }
                } else // Try to add padding if the content is not clipped.
                if (inputRef.current.offsetWidth >= inputRef.current.scrollWidth) {
                    let width = inputRef.current.parentElement.offsetWidth;
                    yield true;
                    // If adding padding does not change the width (i.e. width is constrained), remove it again.
                    if (inputRef.current.parentElement.offsetWidth === width) yield false;
                }
            }
        }), [
        inputRef,
        setReservePadding
    ]);
    (0, _utils1.useLayoutEffect)(onResize, [
        onResize
    ]);
    (0, _utils1.useResizeObserver)({
        ref: inputRef,
        onResize
    });
    // We also need to listen for resize events of the window so we can detect
    // when there is enough space for the padding to be re-added. Ideally we'd
    // use a resize observer on a parent element, but it's hard to know _what_
    // parent element.
    (0, _utils1.useEvent)((0, _react.useRef)(typeof window !== "undefined" ? window : null), "resize", onResize);
    let { focusProps, isFocusVisible, isFocused } = (0, _focus.useFocusRing)({
        isTextInput: true,
        within: true
    });
    let isInvalid = validationState === "invalid" && !isDisabled;
    let textfieldClass = (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Textfield", {
        "spectrum-Textfield--invalid": isInvalid,
        "spectrum-Textfield--valid": validationState === "valid" && !isDisabled,
        "spectrum-Textfield--quiet": isQuiet,
        "focus-ring": isFocusVisible && !disableFocusRing
    }, (0, _utils.classNames)((0, _stylesCssDefault.default), "react-spectrum-Datepicker-field"), className);
    let inputClass = (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Textfield-input", {
        "is-disabled": isDisabled,
        "is-focused": isFocused
    }, (0, _utils.classNames)((0, _stylesCssDefault.default), "react-spectrum-DateField-Input"), reservePadding && (0, _utils.classNames)((0, _stylesCssDefault.default), "react-spectrum-Datepicker-input"), inputClassName);
    let iconClass = (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Textfield-validationIcon");
    let validationIcon = null;
    if (validationState === "invalid" && !isDisabled) validationIcon = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _alertMediumDefault.default), {
        "data-testid": "invalid-icon",
        UNSAFE_className: iconClass
    });
    else if (validationState === "valid" && !isDisabled) validationIcon = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _checkmarkMediumDefault.default), {
        "data-testid": "valid-icon",
        UNSAFE_className: iconClass
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        role: "presentation",
        ...(0, _utils1.mergeProps)(fieldProps, focusProps),
        className: textfieldClass,
        style: style
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        role: "presentation",
        className: inputClass
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        role: "presentation",
        className: (0, _utils.classNames)((0, _stylesCssDefault.default), "react-spectrum-Datepicker-inputContents"),
        ref: (0, _utils1.mergeRefs)(ref, inputRef)
    }, children)), validationIcon);
}
const _Input = /*#__PURE__*/ (0, _reactDefault.default).forwardRef(Input);

},{"@spectrum-icons/ui/AlertMedium":"2v5QX","@spectrum-icons/ui/CheckmarkMedium":"e6Ew8","@react-spectrum/utils":"cMIJ6","./styles.css":"58Z98","@react-aria/utils":"9cLk5","react":"9yzVZ","@adobe/spectrum-css-temp/components/textfield/vars.css":"c3yAu","@react-aria/focus":"42mbF","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"hRuFY":[function(require,module,exports) {
const _temp0 = require("b3f5bd00b696aa76");
const _temp1 = require("27369e7a55c5a96e");
const _temp2 = require("87d29df59a1b13e2");
const _temp3 = require("4d91103c669b70ad");
const _temp4 = require("b47dd2383651dba4");
const _temp5 = require("938c4bebd8290adf");
const _temp6 = require("fe6732f54b84de72");
const _temp7 = require("ac186add69941954");
const _temp8 = require("35e4089104e7a6ea");
const _temp9 = require("5994345af444da28");
const _temp10 = require("5f69df66dd2b86f6");
const _temp11 = require("9c62cb0d60d998c8");
const _temp12 = require("a6bc830e25299a24");
const _temp13 = require("8e1004feab2a7333");
const _temp14 = require("e80b684bed7574c0");
const _temp15 = require("77b4141e57a966eb");
const _temp16 = require("f7742e9a85991a5c");
const _temp17 = require("d6209e0045cab1cd");
const _temp18 = require("2d1c6c2a8ff91656");
const _temp19 = require("2663e489f5e77d77");
const _temp20 = require("ab8012d83ffa5850");
const _temp21 = require("c92e4e57ea7c91a");
const _temp22 = require("ddbec3dbe3bf58e5");
const _temp23 = require("9f2b365ffd34a380");
const _temp24 = require("5a8259bd3876dfa9");
const _temp25 = require("890298cf1837f094");
const _temp26 = require("3b19262181346131");
const _temp27 = require("5aa2096b5a1fd59e");
const _temp28 = require("18397b0834aea7a8");
const _temp29 = require("ed978c9151ffe28d");
const _temp30 = require("baf82fc5e27d64ee");
const _temp31 = require("6d7b59b12591d6b6");
const _temp32 = require("cdcfe91274f39d1b");
const _temp33 = require("e600d0718fb74f78");
module.exports = {
    "ar-AE": _temp0,
    "bg-BG": _temp1,
    "cs-CZ": _temp2,
    "da-DK": _temp3,
    "de-DE": _temp4,
    "el-GR": _temp5,
    "en-US": _temp6,
    "es-ES": _temp7,
    "et-EE": _temp8,
    "fi-FI": _temp9,
    "fr-FR": _temp10,
    "he-IL": _temp11,
    "hr-HR": _temp12,
    "hu-HU": _temp13,
    "it-IT": _temp14,
    "ja-JP": _temp15,
    "ko-KR": _temp16,
    "lt-LT": _temp17,
    "lv-LV": _temp18,
    "nb-NO": _temp19,
    "nl-NL": _temp20,
    "pl-PL": _temp21,
    "pt-BR": _temp22,
    "pt-PT": _temp23,
    "ro-RO": _temp24,
    "ru-RU": _temp25,
    "sk-SK": _temp26,
    "sl-SI": _temp27,
    "sr-SP": _temp28,
    "sv-SE": _temp29,
    "tr-TR": _temp30,
    "uk-UA": _temp31,
    "zh-CN": _temp32,
    "zh-TW": _temp33
};

},{"b3f5bd00b696aa76":"4ITPj","27369e7a55c5a96e":"1Yi09","87d29df59a1b13e2":"4VmiK","4d91103c669b70ad":"gaOIz","b47dd2383651dba4":"9uRs6","938c4bebd8290adf":"lGWhr","fe6732f54b84de72":"3pvyL","ac186add69941954":"eFpKo","35e4089104e7a6ea":"03JVg","5994345af444da28":"3vAhE","5f69df66dd2b86f6":"hvIsf","9c62cb0d60d998c8":"3oT73","a6bc830e25299a24":"5XQPJ","8e1004feab2a7333":"769KI","e80b684bed7574c0":"dqb48","77b4141e57a966eb":"cM2zm","f7742e9a85991a5c":"bMHJa","d6209e0045cab1cd":"gkeA6","2d1c6c2a8ff91656":"24YAr","2663e489f5e77d77":"3WUHV","ab8012d83ffa5850":"24oz4","c92e4e57ea7c91a":"lPpml","ddbec3dbe3bf58e5":"jvWZu","9f2b365ffd34a380":"gBO7P","5a8259bd3876dfa9":"3aZDm","890298cf1837f094":"cRwxT","3b19262181346131":"eMzOf","5aa2096b5a1fd59e":"b6jf7","18397b0834aea7a8":"aI3gx","ed978c9151ffe28d":"5qLiL","baf82fc5e27d64ee":"6fKZt","6d7b59b12591d6b6":"jKhF9","cdcfe91274f39d1b":"74pTQ","e600d0718fb74f78":"kE4jL"}],"4ITPj":[function(require,module,exports) {
module.exports = {
    "endTime": `\u{648}\u{642}\u{62A} \u{627}\u{644}\u{627}\u{646}\u{62A}\u{647}\u{627}\u{621}`,
    "startTime": `\u{648}\u{642}\u{62A} \u{627}\u{644}\u{628}\u{62F}\u{621}`,
    "time": `\u{627}\u{644}\u{648}\u{642}\u{62A}`
};

},{}],"1Yi09":[function(require,module,exports) {
module.exports = {
    "endTime": `\u{41A}\u{440}\u{430}\u{435}\u{43D} \u{447}\u{430}\u{441}`,
    "startTime": `\u{41D}\u{430}\u{447}\u{430}\u{43B}\u{435}\u{43D} \u{447}\u{430}\u{441}`,
    "time": `\u{412}\u{440}\u{435}\u{43C}\u{435}`
};

},{}],"4VmiK":[function(require,module,exports) {
module.exports = {
    "endTime": `Kone\u{10D}n\xfd \u{10D}as`,
    "startTime": `Po\u{10D}\xe1te\u{10D}n\xed \u{10D}as`,
    "time": `\u{10C}as`
};

},{}],"gaOIz":[function(require,module,exports) {
module.exports = {
    "endTime": `Sluttidspunkt`,
    "startTime": `Starttidspunkt`,
    "time": `Klokkesl\xe6t`
};

},{}],"9uRs6":[function(require,module,exports) {
module.exports = {
    "endTime": `Endzeit`,
    "startTime": `Startzeit`,
    "time": `Uhrzeit`
};

},{}],"lGWhr":[function(require,module,exports) {
module.exports = {
    "endTime": `\u{3A7}\u{3C1}\u{3CC}\u{3BD}\u{3BF}\u{3C2} \u{3BB}\u{3AE}\u{3BE}\u{3B7}\u{3C2}`,
    "startTime": `\u{38F}\u{3C1}\u{3B1} \u{3AD}\u{3BD}\u{3B1}\u{3C1}\u{3BE}\u{3B7}\u{3C2}`,
    "time": `\u{3A7}\u{3C1}\u{3CC}\u{3BD}\u{3BF}\u{3C2}`
};

},{}],"3pvyL":[function(require,module,exports) {
module.exports = {
    "time": `Time`,
    "startTime": `Start time`,
    "endTime": `End time`
};

},{}],"eFpKo":[function(require,module,exports) {
module.exports = {
    "endTime": `Hora de finalizaci\xf3n`,
    "startTime": `Hora de inicio`,
    "time": `Hora`
};

},{}],"03JVg":[function(require,module,exports) {
module.exports = {
    "endTime": `L\xf5puaeg`,
    "startTime": `Algusaeg`,
    "time": `Aeg`
};

},{}],"3vAhE":[function(require,module,exports) {
module.exports = {
    "endTime": `P\xe4\xe4ttymisaika`,
    "startTime": `Alkamisaika`,
    "time": `Aika`
};

},{}],"hvIsf":[function(require,module,exports) {
module.exports = {
    "endTime": `Heure de fin`,
    "startTime": `Heure de d\xe9but`,
    "time": `Heure`
};

},{}],"3oT73":[function(require,module,exports) {
module.exports = {
    "endTime": `\u{5E9}\u{5E2}\u{5EA} \u{5E1}\u{5D9}\u{5D5}\u{5DD}`,
    "startTime": `\u{5E9}\u{5E2}\u{5EA} \u{5D4}\u{5EA}\u{5D7}\u{5DC}\u{5D4}`,
    "time": `\u{5D6}\u{5DE}\u{5DF}`
};

},{}],"5XQPJ":[function(require,module,exports) {
module.exports = {
    "endTime": `Vrijeme zavr\u{161}etka`,
    "startTime": `Vrijeme po\u{10D}etka`,
    "time": `Vrijeme`
};

},{}],"769KI":[function(require,module,exports) {
module.exports = {
    "endTime": `Befejez\xe9s ideje`,
    "startTime": `Kezd\xe9s ideje`,
    "time": `Id\u{151}`
};

},{}],"dqb48":[function(require,module,exports) {
module.exports = {
    "endTime": `Ora di fine`,
    "startTime": `Ora di inizio`,
    "time": `Ora`
};

},{}],"cM2zm":[function(require,module,exports) {
module.exports = {
    "endTime": `\u{7D42}\u{4E86}\u{6642}\u{523B}`,
    "startTime": `\u{958B}\u{59CB}\u{6642}\u{523B}`,
    "time": `\u{6642}\u{523B}`
};

},{}],"bMHJa":[function(require,module,exports) {
module.exports = {
    "endTime": `\u{C885}\u{B8CC} \u{C2DC}\u{AC04}`,
    "startTime": `\u{C2DC}\u{C791} \u{C2DC}\u{AC04}`,
    "time": `\u{C2DC}\u{AC04}`
};

},{}],"gkeA6":[function(require,module,exports) {
module.exports = {
    "endTime": `Pabaigos laikas`,
    "startTime": `Prad\u{17E}ios laikas`,
    "time": `Laikas`
};

},{}],"24YAr":[function(require,module,exports) {
module.exports = {
    "endTime": `Beigu laiks`,
    "startTime": `S\u{101}kuma laiks`,
    "time": `Laiks`
};

},{}],"3WUHV":[function(require,module,exports) {
module.exports = {
    "endTime": `Sluttid`,
    "startTime": `Starttid`,
    "time": `Tid`
};

},{}],"24oz4":[function(require,module,exports) {
module.exports = {
    "endTime": `Eindtijd`,
    "startTime": `Starttijd`,
    "time": `Tijd`
};

},{}],"lPpml":[function(require,module,exports) {
module.exports = {
    "endTime": `Godzina ko\u{144}cowa`,
    "startTime": `Godzina pocz\u{105}tkowa`,
    "time": `Godzina`
};

},{}],"jvWZu":[function(require,module,exports) {
module.exports = {
    "endTime": `Hora final`,
    "startTime": `Hora inicial`,
    "time": `Hora`
};

},{}],"gBO7P":[function(require,module,exports) {
module.exports = {
    "endTime": `Terminar tempo`,
    "startTime": `Iniciar tempo`,
    "time": `Tempo`
};

},{}],"3aZDm":[function(require,module,exports) {
module.exports = {
    "endTime": `Ora de sf\xe2r\u{219}it`,
    "startTime": `Ora de \xeenceput`,
    "time": `Ora`
};

},{}],"cRwxT":[function(require,module,exports) {
module.exports = {
    "endTime": `\u{412}\u{440}\u{435}\u{43C}\u{44F} \u{43E}\u{43A}\u{43E}\u{43D}\u{447}\u{430}\u{43D}\u{438}\u{44F}`,
    "startTime": `\u{412}\u{440}\u{435}\u{43C}\u{44F} \u{43D}\u{430}\u{447}\u{430}\u{43B}\u{430}`,
    "time": `\u{412}\u{440}\u{435}\u{43C}\u{44F}`
};

},{}],"eMzOf":[function(require,module,exports) {
module.exports = {
    "endTime": `\u{10C}as ukon\u{10D}enia`,
    "startTime": `\u{10C}as za\u{10D}iatku`,
    "time": `\u{10C}as`
};

},{}],"b6jf7":[function(require,module,exports) {
module.exports = {
    "endTime": `Kon\u{10D}ni \u{10D}as`,
    "startTime": `Za\u{10D}etni \u{10D}as`,
    "time": `\u{10C}as`
};

},{}],"aI3gx":[function(require,module,exports) {
module.exports = {
    "endTime": `Zavr\u{161}no vreme`,
    "startTime": `Po\u{10D}etno vreme`,
    "time": `Vreme`
};

},{}],"5qLiL":[function(require,module,exports) {
module.exports = {
    "endTime": `Sluttid`,
    "startTime": `Starttid`,
    "time": `Tid`
};

},{}],"6fKZt":[function(require,module,exports) {
module.exports = {
    "endTime": `Biti\u{15F} saati`,
    "startTime": `Ba\u{15F}lang\u{131}\xe7 saati`,
    "time": `Saat`
};

},{}],"jKhF9":[function(require,module,exports) {
module.exports = {
    "endTime": `\u{427}\u{430}\u{441} \u{437}\u{430}\u{432}\u{435}\u{440}\u{448}\u{435}\u{43D}\u{43D}\u{44F}`,
    "startTime": `\u{427}\u{430}\u{441} \u{43F}\u{43E}\u{447}\u{430}\u{442}\u{43A}\u{443}`,
    "time": `\u{427}\u{430}\u{441}`
};

},{}],"74pTQ":[function(require,module,exports) {
module.exports = {
    "endTime": `\u{7ED3}\u{675F}\u{65F6}\u{95F4}`,
    "startTime": `\u{5F00}\u{59CB}\u{65F6}\u{95F4}`,
    "time": `\u{65F6}\u{95F4}`
};

},{}],"kE4jL":[function(require,module,exports) {
module.exports = {
    "endTime": `\u{7D50}\u{675F}\u{6642}\u{9593}`,
    "startTime": `\u{958B}\u{59CB}\u{6642}\u{9593}`,
    "time": `\u{6642}\u{9593}`
};

},{}],"77Uzq":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TimeField", ()=>_TimeField);
var _utils = require("@react-spectrum/utils");
var _datePickerSegment = require("./DatePickerSegment");
var _stylesCss = require("./styles.css");
var _stylesCssDefault = parcelHelpers.interopDefault(_stylesCss);
var _label = require("@react-spectrum/label");
var _input = require("./Input");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _utils1 = require("./utils");
var _form = require("@react-spectrum/form");
var _i18N = require("@react-aria/i18n");
var _provider = require("@react-spectrum/provider");
var _datepicker = require("@react-aria/datepicker");
var _datepicker1 = require("@react-stately/datepicker");
function TimeField(props, ref) {
    props = (0, _provider.useProviderProps)(props);
    props = (0, _form.useFormProps)(props);
    let { autoFocus, isDisabled, isReadOnly, isRequired, isQuiet } = props;
    let domRef = (0, _utils1.useFocusManagerRef)(ref);
    let { locale } = (0, _i18N.useLocale)();
    let state = (0, _datepicker1.useTimeFieldState)({
        ...props,
        locale
    });
    let fieldRef = (0, _react.useRef)(null);
    let inputRef = (0, _react.useRef)(null);
    let { labelProps, fieldProps, inputProps, descriptionProps, errorMessageProps, isInvalid, validationErrors, validationDetails } = (0, _datepicker.useTimeField)({
        ...props,
        inputRef
    }, state, fieldRef);
    let validationState = state.validationState || (isInvalid ? "invalid" : null);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _label.Field), {
        ...props,
        ref: domRef,
        elementType: "span",
        labelProps: labelProps,
        descriptionProps: descriptionProps,
        errorMessageProps: errorMessageProps,
        validationState: validationState,
        isInvalid: isInvalid,
        validationErrors: validationErrors,
        validationDetails: validationDetails,
        wrapperClassName: (0, _utils.classNames)((0, _stylesCssDefault.default), "react-spectrum-TimeField-fieldWrapper")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _input.Input), {
        ref: fieldRef,
        fieldProps: fieldProps,
        isDisabled: isDisabled,
        isQuiet: isQuiet,
        autoFocus: autoFocus,
        validationState: validationState,
        className: (0, _utils.classNames)((0, _stylesCssDefault.default), "react-spectrum-TimeField")
    }, state.segments.map((segment, i)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _datePickerSegment.DatePickerSegment), {
            key: i,
            segment: segment,
            state: state,
            isDisabled: isDisabled,
            isReadOnly: isReadOnly,
            isRequired: isRequired
        })), /*#__PURE__*/ (0, _reactDefault.default).createElement("input", {
        ...inputProps,
        ref: inputRef
    })));
}
/**
 * TimeFields allow users to enter and edit time values using a keyboard.
 * Each part of the time is displayed in an individually editable segment.
 */ const _TimeField = /*#__PURE__*/ (0, _reactDefault.default).forwardRef(TimeField);

},{"@react-spectrum/utils":"cMIJ6","./DatePickerSegment":"aKPrh","./styles.css":"58Z98","@react-spectrum/label":"6qv6N","./Input":"8AsUB","react":"9yzVZ","./utils":"d42tP","@react-spectrum/form":"bGDqA","@react-aria/i18n":"411rg","@react-spectrum/provider":"5bCdp","@react-aria/datepicker":"5gh3m","@react-stately/datepicker":"ci7Mv","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"d42tP":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useFormatHelpText", ()=>useFormatHelpText);
parcelHelpers.export(exports, "useVisibleMonths", ()=>useVisibleMonths);
parcelHelpers.export(exports, "useFocusManagerRef", ()=>useFocusManagerRef);
var _utils = require("@react-spectrum/utils");
var _focus = require("@react-aria/focus");
var _i18N = require("@react-aria/i18n");
var _datepicker = require("@react-aria/datepicker");
var _react = require("react");
var _utils1 = require("@react-aria/utils");
var _provider = require("@react-spectrum/provider");
function useFormatHelpText(props) {
    let formatter = (0, _i18N.useDateFormatter)({
        dateStyle: "short"
    });
    let displayNames = (0, _datepicker.useDisplayNames)();
    return (0, _react.useMemo)(()=>{
        if (props.description) return props.description;
        if (props.showFormatHelpText) return formatter.formatToParts(new Date()).map((s)=>{
            if (s.type === "literal") return s.value;
            return displayNames.of(s.type);
        }).join(" ");
        return "";
    }, [
        props.description,
        props.showFormatHelpText,
        formatter,
        displayNames
    ]);
}
function useVisibleMonths(maxVisibleMonths) {
    let { scale } = (0, _provider.useProvider)();
    let [visibleMonths, setVisibleMonths] = (0, _react.useState)(getVisibleMonths(scale));
    (0, _utils1.useLayoutEffect)(()=>{
        let onResize = ()=>setVisibleMonths(getVisibleMonths(scale));
        onResize();
        window.addEventListener("resize", onResize);
        return ()=>{
            window.removeEventListener("resize", onResize);
        };
    }, [
        scale
    ]);
    return Math.max(1, Math.min(visibleMonths, maxVisibleMonths, 3));
}
function getVisibleMonths(scale) {
    if (typeof window === "undefined") return 1;
    let monthWidth = scale === "large" ? 336 : 280;
    let gap = scale === "large" ? 30 : 24;
    let popoverPadding = scale === "large" ? 32 : 48;
    return Math.floor((window.innerWidth - popoverPadding * 2) / (monthWidth + gap));
}
function useFocusManagerRef(ref) {
    let domRef = (0, _react.useRef)();
    (0, _react.useImperativeHandle)(ref, ()=>({
            ...(0, _utils.createDOMRef)(domRef),
            focus () {
                (0, _focus.createFocusManager)(domRef).focusFirst({
                    tabbable: true
                });
            }
        }));
    return domRef;
}

},{"@react-spectrum/utils":"cMIJ6","@react-aria/focus":"42mbF","@react-aria/i18n":"411rg","@react-aria/datepicker":"5gh3m","react":"9yzVZ","@react-aria/utils":"9cLk5","@react-spectrum/provider":"5bCdp","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"9xK8Q":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DateRangePicker", ()=>_DateRangePicker);
var _calendar = require("@spectrum-icons/workflow/Calendar");
var _calendarDefault = parcelHelpers.interopDefault(_calendar);
var _utils = require("@react-spectrum/utils");
var _view = require("@react-spectrum/view");
var _datePickerField = require("./DatePickerField");
var _stylesCss = require("./styles.css");
var _stylesCssDefault = parcelHelpers.interopDefault(_stylesCss);
var _dialog = require("@react-spectrum/dialog");
var _label = require("@react-spectrum/label");
var _button = require("@react-spectrum/button");
var _layout = require("@react-spectrum/layout");
var _input = require("./Input");
// @ts-ignore
var _json = require("../intl/*.json");
var _jsonDefault = parcelHelpers.interopDefault(_json);
var _utils1 = require("@react-aria/utils");
var _calendar1 = require("@react-spectrum/calendar");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _varsCss = require("@adobe/spectrum-css-temp/components/inputgroup/vars.css");
var _varsCssDefault = parcelHelpers.interopDefault(_varsCss);
var _timeField = require("./TimeField");
var _datepicker = require("@react-aria/datepicker");
var _datepicker1 = require("@react-stately/datepicker");
var _utils2 = require("./utils");
var _focus = require("@react-aria/focus");
var _form = require("@react-spectrum/form");
var _interactions = require("@react-aria/interactions");
var _i18N = require("@react-aria/i18n");
var _provider = require("@react-spectrum/provider");
function DateRangePicker(props, ref) {
    var _state_timeRange, _state_timeRange1;
    props = (0, _provider.useProviderProps)(props);
    props = (0, _form.useFormProps)(props);
    let { isQuiet, isDisabled, autoFocus, placeholderValue, maxVisibleMonths = 1, pageBehavior } = props;
    let { hoverProps, isHovered } = (0, _interactions.useHover)({
        isDisabled
    });
    let targetRef = (0, _react.useRef)();
    let state = (0, _datepicker1.useDateRangePickerState)({
        ...props,
        shouldCloseOnSelect: ()=>!state.hasTime
    });
    let { labelProps, groupProps, buttonProps, dialogProps, startFieldProps, endFieldProps, descriptionProps, errorMessageProps, calendarProps, isInvalid, validationErrors, validationDetails } = (0, _datepicker.useDateRangePicker)(props, state, targetRef);
    let { isOpen, setOpen } = state;
    let { direction } = (0, _i18N.useLocale)();
    let domRef = (0, _utils2.useFocusManagerRef)(ref);
    let stringFormatter = (0, _i18N.useLocalizedStringFormatter)((0, _jsonDefault.default), "@react-spectrum/datepicker");
    let { isFocused, isFocusVisible, focusProps } = (0, _focus.useFocusRing)({
        within: true,
        isTextInput: true,
        autoFocus
    });
    let { isFocused: isFocusedButton, focusProps: focusPropsButton } = (0, _focus.useFocusRing)({
        within: false,
        isTextInput: false,
        autoFocus
    });
    let className = (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-InputGroup", {
        "spectrum-InputGroup--quiet": isQuiet,
        "spectrum-InputGroup--invalid": isInvalid && !isDisabled,
        "is-disabled": isDisabled,
        "is-hovered": isHovered,
        "is-focused": isFocused,
        "focus-ring": isFocusVisible && !isFocusedButton
    });
    let fieldClassName = (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-InputGroup-input", {
        "is-disabled": isDisabled,
        "is-invalid": isInvalid && !isDisabled
    });
    // Note: this description is intentionally not passed to useDatePicker.
    // The format help text is unnecessary for screen reader users because each segment already has a label.
    let description = (0, _utils2.useFormatHelpText)(props);
    if (description && !props.description) descriptionProps.id = null;
    let placeholder = placeholderValue;
    let timePlaceholder = placeholder && "hour" in placeholder ? placeholder : null;
    let timeMinValue = props.minValue && "hour" in props.minValue ? props.minValue : null;
    let timeMaxValue = props.maxValue && "hour" in props.maxValue ? props.maxValue : null;
    let timeGranularity = state.granularity === "hour" || state.granularity === "minute" || state.granularity === "second" ? state.granularity : null;
    let showTimeField = !!timeGranularity;
    let visibleMonths = (0, _utils2.useVisibleMonths)(maxVisibleMonths);
    let validationState = state.validationState || (isInvalid ? "invalid" : null);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _label.Field), {
        ...props,
        ref: domRef,
        elementType: "span",
        description: description,
        labelProps: labelProps,
        descriptionProps: descriptionProps,
        errorMessageProps: errorMessageProps,
        validationState: validationState,
        isInvalid: isInvalid,
        validationErrors: validationErrors,
        validationDetails: validationDetails,
        wrapperClassName: (0, _utils.classNames)((0, _stylesCssDefault.default), "react-spectrum-Datepicker-fieldWrapper")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...(0, _utils1.mergeProps)(groupProps, hoverProps, focusProps),
        className: className,
        ref: targetRef
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _input.Input), {
        isDisabled: isDisabled,
        isQuiet: isQuiet,
        validationState: validationState,
        className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-InputGroup-field"),
        inputClassName: fieldClassName,
        disableFocusRing: true
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _datePickerField.DatePickerField), {
        ...startFieldProps,
        "data-testid": "start-date",
        isQuiet: props.isQuiet,
        inputClassName: (0, _utils.classNames)((0, _stylesCssDefault.default), "react-spectrum-Datepicker-startField")
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement(DateRangeDash, null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _datePickerField.DatePickerField), {
        ...endFieldProps,
        "data-testid": "end-date",
        isQuiet: props.isQuiet,
        inputClassName: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Datepicker-endField", (0, _utils.classNames)((0, _stylesCssDefault.default), "react-spectrum-Datepicker-endField"))
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _dialog.DialogTrigger), {
        type: "popover",
        mobileType: "tray",
        placement: direction === "rtl" ? "bottom right" : "bottom left",
        targetRef: targetRef,
        hideArrow: true,
        isOpen: isOpen,
        onOpenChange: setOpen,
        shouldFlip: props.shouldFlip
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.FieldButton), {
        ...(0, _utils1.mergeProps)(buttonProps, focusPropsButton),
        UNSAFE_className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-FieldButton"),
        isQuiet: isQuiet,
        validationState: validationState
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _calendarDefault.default), null)), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _dialog.Dialog), {
        UNSAFE_className: (0, _utils.classNames)((0, _stylesCssDefault.default), "react-spectrum-Datepicker-dialog"),
        ...dialogProps
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Content), null, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _utils.classNames)((0, _stylesCssDefault.default), "react-spectrum-Datepicker-dialogContent")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _calendar1.RangeCalendar), {
        ...calendarProps,
        visibleMonths: visibleMonths,
        pageBehavior: pageBehavior,
        UNSAFE_className: (0, _utils.classNames)((0, _stylesCssDefault.default), "react-spectrum-Datepicker-calendar", {
            "is-invalid": validationState === "invalid"
        })
    }), showTimeField && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
        gap: "size-100",
        marginTop: "size-100",
        UNSAFE_className: (0, _utils.classNames)((0, _stylesCssDefault.default), "react-spectrum-Datepicker-timeFields")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _timeField.TimeField), {
        label: stringFormatter.format("startTime"),
        value: ((_state_timeRange = state.timeRange) === null || _state_timeRange === void 0 ? void 0 : _state_timeRange.start) || null,
        onChange: (v)=>state.setTime("start", v),
        placeholderValue: timePlaceholder,
        granularity: timeGranularity,
        minValue: timeMinValue,
        maxValue: timeMaxValue,
        hourCycle: props.hourCycle,
        hideTimeZone: props.hideTimeZone,
        flex: true
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _timeField.TimeField), {
        label: stringFormatter.format("endTime"),
        value: ((_state_timeRange1 = state.timeRange) === null || _state_timeRange1 === void 0 ? void 0 : _state_timeRange1.end) || null,
        onChange: (v)=>state.setTime("end", v),
        placeholderValue: timePlaceholder,
        granularity: timeGranularity,
        minValue: timeMinValue,
        maxValue: timeMaxValue,
        hourCycle: props.hourCycle,
        hideTimeZone: props.hideTimeZone,
        flex: true
    }))))))));
}
function DateRangeDash() {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        "aria-hidden": "true",
        "data-testid": "date-range-dash",
        className: (0, _utils.classNames)((0, _stylesCssDefault.default), "react-spectrum-Datepicker-rangeDash")
    });
}
/**
 * DateRangePickers combine two DateFields and a RangeCalendar popover to allow users
 * to enter or select a date and time range.
 */ const _DateRangePicker = /*#__PURE__*/ (0, _reactDefault.default).forwardRef(DateRangePicker);

},{"@spectrum-icons/workflow/Calendar":"bJMhf","@react-spectrum/utils":"cMIJ6","@react-spectrum/view":"dnRjt","./DatePickerField":"7xJop","./styles.css":"58Z98","@react-spectrum/dialog":"3G0HV","@react-spectrum/label":"6qv6N","@react-spectrum/button":"jZWyP","@react-spectrum/layout":"hzaUY","./Input":"8AsUB","../intl/*.json":"hRuFY","@react-aria/utils":"9cLk5","@react-spectrum/calendar":"9d2lg","react":"9yzVZ","@adobe/spectrum-css-temp/components/inputgroup/vars.css":"fZm3Z","./TimeField":"77Uzq","@react-aria/datepicker":"5gh3m","@react-stately/datepicker":"ci7Mv","./utils":"d42tP","@react-aria/focus":"42mbF","@react-spectrum/form":"bGDqA","@react-aria/interactions":"ky3G8","@react-aria/i18n":"411rg","@react-spectrum/provider":"5bCdp","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"2vxNC":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DateField", ()=>_DateField);
var _utils = require("@react-spectrum/utils");
var _date = require("@internationalized/date");
var _datePickerSegment = require("./DatePickerSegment");
var _stylesCss = require("./styles.css");
var _stylesCssDefault = parcelHelpers.interopDefault(_stylesCss);
var _label = require("@react-spectrum/label");
var _input = require("./Input");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _datepicker = require("@react-aria/datepicker");
var _datepicker1 = require("@react-stately/datepicker");
var _utils1 = require("./utils");
var _form = require("@react-spectrum/form");
var _i18N = require("@react-aria/i18n");
var _provider = require("@react-spectrum/provider");
function DateField(props, ref) {
    props = (0, _provider.useProviderProps)(props);
    props = (0, _form.useFormProps)(props);
    let { autoFocus, isDisabled, isReadOnly, isRequired, isQuiet } = props;
    let domRef = (0, _utils1.useFocusManagerRef)(ref);
    let { locale } = (0, _i18N.useLocale)();
    let state = (0, _datepicker1.useDateFieldState)({
        ...props,
        locale,
        createCalendar: (0, _date.createCalendar)
    });
    let fieldRef = (0, _react.useRef)(null);
    let inputRef = (0, _react.useRef)(null);
    let { labelProps, fieldProps, inputProps, descriptionProps, errorMessageProps, isInvalid, validationErrors, validationDetails } = (0, _datepicker.useDateField)({
        ...props,
        inputRef
    }, state, fieldRef);
    // Note: this description is intentionally not passed to useDatePicker.
    // The format help text is unnecessary for screen reader users because each segment already has a label.
    let description = (0, _utils1.useFormatHelpText)(props);
    if (description && !props.description) descriptionProps.id = null;
    let validationState = state.validationState || (isInvalid ? "invalid" : null);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _label.Field), {
        ...props,
        ref: domRef,
        elementType: "span",
        description: description,
        labelProps: labelProps,
        descriptionProps: descriptionProps,
        errorMessageProps: errorMessageProps,
        validationState: validationState,
        isInvalid: isInvalid,
        validationErrors: validationErrors,
        validationDetails: validationDetails,
        wrapperClassName: (0, _utils.classNames)((0, _stylesCssDefault.default), "react-spectrum-Datepicker-fieldWrapper")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _input.Input), {
        ref: fieldRef,
        fieldProps: fieldProps,
        isDisabled: isDisabled,
        isQuiet: isQuiet,
        autoFocus: autoFocus,
        validationState: validationState,
        className: (0, _utils.classNames)((0, _stylesCssDefault.default), "react-spectrum-DateField")
    }, state.segments.map((segment, i)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _datePickerSegment.DatePickerSegment), {
            key: i,
            segment: segment,
            state: state,
            isDisabled: isDisabled,
            isReadOnly: isReadOnly,
            isRequired: isRequired
        })), /*#__PURE__*/ (0, _reactDefault.default).createElement("input", {
        ...inputProps,
        ref: inputRef
    })));
}
/**
 * DateFields allow users to enter and edit date and time values using a keyboard.
 * Each part of a date value is displayed in an individually editable segment.
 */ const _DateField = /*#__PURE__*/ (0, _reactDefault.default).forwardRef(DateField);

},{"@react-spectrum/utils":"cMIJ6","@internationalized/date":"hesBk","./DatePickerSegment":"aKPrh","./styles.css":"58Z98","@react-spectrum/label":"6qv6N","./Input":"8AsUB","react":"9yzVZ","@react-aria/datepicker":"5gh3m","@react-stately/datepicker":"ci7Mv","./utils":"d42tP","@react-spectrum/form":"bGDqA","@react-aria/i18n":"411rg","@react-spectrum/provider":"5bCdp","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"cV05z":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /// <reference types="css-module-types" />
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IllustratedMessage", ()=>(0, _illustratedMessage.IllustratedMessage));
var _illustratedMessage = require("./IllustratedMessage");

},{"./IllustratedMessage":"gdFEd","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"gdFEd":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IllustratedMessage", ()=>_IllustratedMessage);
var _utils = require("@react-spectrum/utils");
var _utils1 = require("@react-aria/utils");
var _layout = require("@react-spectrum/layout");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _varsCss = require("@adobe/spectrum-css-temp/components/illustratedmessage/vars.css");
var _varsCssDefault = parcelHelpers.interopDefault(_varsCss);
function IllustratedMessage(props, ref) {
    props = (0, _utils.useSlotProps)(props, "illustration");
    let { children, ...otherProps } = props;
    let { styleProps } = (0, _utils.useStyleProps)(otherProps);
    let headingClassName = (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-IllustratedMessage-heading");
    let contentClassName = (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-IllustratedMessage-description");
    let slots = {
        heading: {
            UNSAFE_className: headingClassName
        },
        content: {
            UNSAFE_className: contentClassName
        }
    };
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
        ...(0, _utils1.filterDOMProps)(otherProps),
        UNSAFE_style: styleProps.style,
        isHidden: styleProps.hidden,
        UNSAFE_className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-IllustratedMessage", styleProps.className),
        ref: ref
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.ClearSlots), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.SlotProvider), {
        slots: slots
    }, children)));
}
/**
 * An IllustratedMessage displays an illustration and a message, usually
 * for an empty state or an error page.
 */ let _IllustratedMessage = /*#__PURE__*/ (0, _react.forwardRef)(IllustratedMessage);

},{"@react-spectrum/utils":"cMIJ6","@react-aria/utils":"9cLk5","@react-spectrum/layout":"hzaUY","react":"9yzVZ","@adobe/spectrum-css-temp/components/illustratedmessage/vars.css":"51cWB","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"51cWB":[function(require,module,exports) {
module.exports["spectrum-IllustratedMessage"] = `uhJ7Ra_spectrum-IllustratedMessage`;
module.exports["spectrum-IllustratedMessage--cta"] = `uhJ7Ra_spectrum-IllustratedMessage--cta`;
module.exports["spectrum-IllustratedMessage-description"] = `uhJ7Ra_spectrum-IllustratedMessage-description`;
module.exports["spectrum-IllustratedMessage-heading"] = `uhJ7Ra_spectrum-IllustratedMessage-heading`;

},{}],"5XTuR":[function(require,module,exports) {
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /// <reference types="css-module-types" />
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InlineAlert", ()=>(0, _inlineAlert.InlineAlert));
var _inlineAlert = require("./InlineAlert");

},{"./InlineAlert":"eq5NZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"eq5NZ":[function(require,module,exports) {
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InlineAlert", ()=>_InlineAlert);
var _alertMedium = require("@spectrum-icons/ui/AlertMedium");
var _alertMediumDefault = parcelHelpers.interopDefault(_alertMedium);
var _utils = require("@react-spectrum/utils");
var _utils1 = require("@react-aria/utils");
var _focus = require("@react-aria/focus");
var _layout = require("@react-spectrum/layout");
var _infoMedium = require("@spectrum-icons/ui/InfoMedium");
var _infoMediumDefault = parcelHelpers.interopDefault(_infoMedium);
// @ts-ignore
var _json = require("../intl/*.json");
var _jsonDefault = parcelHelpers.interopDefault(_json);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _varsCss = require("@adobe/spectrum-css-temp/components/inlinealert/vars.css");
var _varsCssDefault = parcelHelpers.interopDefault(_varsCss);
var _successMedium = require("@spectrum-icons/ui/SuccessMedium");
var _successMediumDefault = parcelHelpers.interopDefault(_successMedium);
var _i18N = require("@react-aria/i18n");
var _provider = require("@react-spectrum/provider");
let ICONS = {
    info: (0, _infoMediumDefault.default),
    positive: (0, _successMediumDefault.default),
    notice: (0, _alertMediumDefault.default),
    negative: (0, _alertMediumDefault.default)
};
function InlineAlert(props, ref) {
    props = (0, _provider.useProviderProps)(props);
    let { children, variant = "neutral", autoFocus, ...otherProps } = props;
    let { styleProps } = (0, _utils.useStyleProps)(otherProps);
    let domRef = (0, _utils.useDOMRef)(ref);
    let slots = {
        heading: {
            UNSAFE_className: (0, _varsCssDefault.default)["spectrum-InLineAlert-heading"]
        },
        content: {
            UNSAFE_className: (0, _varsCssDefault.default)["spectrum-InLineAlert-content"]
        }
    };
    let stringFormatter = (0, _i18N.useLocalizedStringFormatter)((0, _jsonDefault.default), "@react-spectrum/inlinealert");
    let Icon = null;
    let iconAlt = "";
    if (variant in ICONS) {
        Icon = ICONS[variant];
        iconAlt = stringFormatter.format(variant);
    }
    let autoFocusRef = (0, _react.useRef)(props.autoFocus);
    (0, _react.useEffect)(()=>{
        if (autoFocusRef.current && domRef.current) domRef.current.focus();
        autoFocusRef.current = false;
    }, [
        domRef
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _focus.FocusRing), {
        focusRingClass: (0, _varsCssDefault.default)["focus-ring"]
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...(0, _utils1.filterDOMProps)(props),
        ...styleProps,
        ref: domRef,
        tabIndex: autoFocus ? -1 : undefined,
        autoFocus: autoFocus,
        className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-InLineAlert", `spectrum-InLineAlert--${variant}`, styleProps.className),
        role: "alert"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Grid), {
        UNSAFE_className: (0, _varsCssDefault.default)["spectrum-InLineAlert-grid"]
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.SlotProvider), {
        slots: slots
    }, Icon && /*#__PURE__*/ (0, _reactDefault.default).createElement(Icon, {
        UNSAFE_className: (0, _varsCssDefault.default)["spectrum-InLineAlert-icon"],
        "aria-label": iconAlt
    }), children))));
}
/**
 * Inline alerts display a non-modal message associated with objects in a view.
 * These are often used in form validation, providing a place to aggregate feedback related to multiple fields.
 */ const _InlineAlert = /*#__PURE__*/ (0, _reactDefault.default).forwardRef(InlineAlert);

},{"@spectrum-icons/ui/AlertMedium":"2v5QX","@react-spectrum/utils":"cMIJ6","@react-aria/utils":"9cLk5","@react-aria/focus":"42mbF","@react-spectrum/layout":"hzaUY","@spectrum-icons/ui/InfoMedium":"kEEGF","../intl/*.json":"3cvAG","react":"9yzVZ","@adobe/spectrum-css-temp/components/inlinealert/vars.css":"fyRfY","@spectrum-icons/ui/SuccessMedium":"7xKnN","@react-aria/i18n":"411rg","@react-spectrum/provider":"5bCdp","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"kEEGF":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("360c7364e3307988");
exports.__esModule = true;
exports.default = InfoMedium;
var _extends2 = _interopRequireDefault(require("94d6bfff879d13d0"));
var _InfoMedium = require("5bdce7180027d2fa");
var _icon = require("9502b407c2428dfb");
var _provider = require("b515e805a6502c87");
var _react = _interopRequireDefault(require("c23beb7e467f00fa"));
const ExpressIcon = (props)=>/*#__PURE__*/ _react.default.createElement("svg", (0, _extends2.default)({
        viewBox: "0 0 18 18"
    }, props), /*#__PURE__*/ _react.default.createElement("path", {
        d: "M9 8a1 1 0 0 0-1 1v4a1 1 0 0 0 2 0V9a1 1 0 0 0-1-1Z"
    }), /*#__PURE__*/ _react.default.createElement("circle", {
        cx: 9,
        cy: 5.5,
        r: 1.5
    }), /*#__PURE__*/ _react.default.createElement("path", {
        d: "M9 0a9 9 0 1 0 9 9 9.01 9.01 0 0 0-9-9Zm0 16a7 7 0 1 1 7-7 7.008 7.008 0 0 1-7 7Z"
    }));
ExpressIcon.displayName = _InfoMedium.InfoMedium.displayName;
function InfoMedium(props) {
    var _provider$theme, _provider$theme$globa;
    let provider = (0, _provider.useProvider)();
    return /*#__PURE__*/ _react.default.createElement(_icon.UIIcon, props, provider != null && (_provider$theme = provider.theme) != null && (_provider$theme$globa = _provider$theme.global) != null && _provider$theme$globa.express ? /*#__PURE__*/ _react.default.createElement(ExpressIcon, null) : /*#__PURE__*/ _react.default.createElement(_InfoMedium.InfoMedium, null));
}

},{"360c7364e3307988":"iHubQ","94d6bfff879d13d0":"l4mXf","5bdce7180027d2fa":"eSoAZ","9502b407c2428dfb":"k7wem","b515e805a6502c87":"5bCdp","c23beb7e467f00fa":"9yzVZ"}],"eSoAZ":[function(require,module,exports) {
/**
* @adobe/react-spectrum-ui (c) by Adobe
* 
* @adobe/react-spectrum-ui is licensed under a
* Creative Commons Attribution-NoDerivatives 4.0 International License.
* 
* You should have received a copy of the license along with this
* work. If not, see <http://creativecommons.org/licenses/by-nd/4.0/>.
**/ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.InfoMedium = InfoMedium;
var _react = _interopRequireDefault(require("e7e4ab52a8d8c76b"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function InfoMedium(_ref) {
    var _ref$scale = _ref.scale, scale = _ref$scale === void 0 ? "M" : _ref$scale, props = _objectWithoutProperties(_ref, [
        "scale"
    ]);
    return _react["default"].createElement("svg", _extends({}, props, props), scale === "L" && _react["default"].createElement("path", {
        d: "M11 2a9 9 0 1 0 9 9 9 9 0 0 0-9-9zm-.15 2.65a1.359 1.359 0 0 1 1.431 1.283q.004.064.001.129a1.332 1.332 0 0 1-1.432 1.432 1.353 1.353 0 0 1-1.432-1.433 1.359 1.359 0 0 1 1.304-1.412q.064-.002.128.001zM13.5 16a.5.5 0 0 1-.5.5H9a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h1v-4H9a.5.5 0 0 1-.5-.5V9a.5.5 0 0 1 .5-.5h2.5a.5.5 0 0 1 .5.5v5.5h1a.5.5 0 0 1 .5.5z"
    }), scale === "M" && _react["default"].createElement("path", {
        d: "M9 1a8 8 0 1 0 8 8 8 8 0 0 0-8-8zm-.15 2.15a1.359 1.359 0 0 1 1.431 1.283q.004.064.001.129A1.332 1.332 0 0 1 8.85 5.994a1.353 1.353 0 0 1-1.432-1.433 1.359 1.359 0 0 1 1.304-1.412q.064-.002.128.001zM11 13.5a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5H8V9h-.5a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5V12h.5a.5.5 0 0 1 .5.5z"
    }));
}
InfoMedium.displayName = "InfoMedium";

},{"e7e4ab52a8d8c76b":"9yzVZ"}],"3cvAG":[function(require,module,exports) {
const _temp0 = require("3541ecc396430478");
const _temp1 = require("3eda2ca2634a2698");
const _temp2 = require("28000c7bc7f80055");
const _temp3 = require("e75a60945e3ecd51");
const _temp4 = require("14505a0cba18e57c");
const _temp5 = require("b7561d5be01f9b58");
const _temp6 = require("91488d68b9a1dbe0");
const _temp7 = require("c260020cdfede100");
const _temp8 = require("a3b0718d1eaa81ed");
const _temp9 = require("9b23029d834d49cd");
const _temp10 = require("ab85924fd967a74d");
const _temp11 = require("7d398a2e7def95ef");
const _temp12 = require("b5e2bcba789f2ba5");
const _temp13 = require("a2db8ba40d8fe1e1");
const _temp14 = require("607fd3f0e3d582b2");
const _temp15 = require("e89d037c23e7ddba");
const _temp16 = require("437744a593a068b8");
const _temp17 = require("8c9a1a342b08dcba");
const _temp18 = require("39041bef6101b99c");
const _temp19 = require("b9736b6f135cb490");
const _temp20 = require("221b0e51d8aeea0a");
const _temp21 = require("1b604875a6dbdc04");
const _temp22 = require("e1f50f9ffbd17989");
const _temp23 = require("276a3359921af847");
const _temp24 = require("fff04c5878f4105");
const _temp25 = require("46946ac47029e71d");
const _temp26 = require("2e08ca639dca437");
const _temp27 = require("839e106ed1cd8289");
const _temp28 = require("31f470621dda083a");
const _temp29 = require("6bc2f497af1205af");
const _temp30 = require("21346c185349c369");
const _temp31 = require("6a10862dae8bbf02");
const _temp32 = require("e129eea0048e6cb5");
const _temp33 = require("e71b384879d1e31");
module.exports = {
    "ar-AE": _temp0,
    "bg-BG": _temp1,
    "cs-CZ": _temp2,
    "da-DK": _temp3,
    "de-DE": _temp4,
    "el-GR": _temp5,
    "en-US": _temp6,
    "es-ES": _temp7,
    "et-EE": _temp8,
    "fi-FI": _temp9,
    "fr-FR": _temp10,
    "he-IL": _temp11,
    "hr-HR": _temp12,
    "hu-HU": _temp13,
    "it-IT": _temp14,
    "ja-JP": _temp15,
    "ko-KR": _temp16,
    "lt-LT": _temp17,
    "lv-LV": _temp18,
    "nb-NO": _temp19,
    "nl-NL": _temp20,
    "pl-PL": _temp21,
    "pt-BR": _temp22,
    "pt-PT": _temp23,
    "ro-RO": _temp24,
    "ru-RU": _temp25,
    "sk-SK": _temp26,
    "sl-SI": _temp27,
    "sr-SP": _temp28,
    "sv-SE": _temp29,
    "tr-TR": _temp30,
    "uk-UA": _temp31,
    "zh-CN": _temp32,
    "zh-TW": _temp33
};

},{"3541ecc396430478":"9MvZI","3eda2ca2634a2698":"icBDe","28000c7bc7f80055":"6ruth","e75a60945e3ecd51":"i6hIp","14505a0cba18e57c":"fthxy","b7561d5be01f9b58":"kGJZm","91488d68b9a1dbe0":"95gf8","c260020cdfede100":"bRynd","a3b0718d1eaa81ed":"89DvA","9b23029d834d49cd":"glBC8","ab85924fd967a74d":"4jRxQ","7d398a2e7def95ef":"k5pYk","b5e2bcba789f2ba5":"4QAjx","a2db8ba40d8fe1e1":"klhWs","607fd3f0e3d582b2":"3Iwbo","e89d037c23e7ddba":"5zsWg","437744a593a068b8":"e0pNQ","8c9a1a342b08dcba":"7Bxoq","39041bef6101b99c":"01KmK","b9736b6f135cb490":"dS09I","221b0e51d8aeea0a":"8wjqJ","1b604875a6dbdc04":"gbYAt","e1f50f9ffbd17989":"Hjgij","276a3359921af847":"4hw3c","fff04c5878f4105":"itaoy","46946ac47029e71d":"31S9a","2e08ca639dca437":"fTce9","839e106ed1cd8289":"fiycz","31f470621dda083a":"4xZ46","6bc2f497af1205af":"2Dyzx","21346c185349c369":"eoRaK","6a10862dae8bbf02":"8Uovp","e129eea0048e6cb5":"arNZE","e71b384879d1e31":"2FD7h"}],"9MvZI":[function(require,module,exports) {
module.exports = {
    "info": `\u{645}\u{639}\u{644}\u{648}\u{645}\u{627}\u{62A}`,
    "negative": `\u{62E}\u{637}\u{623}`,
    "notice": `\u{62A}\u{62D}\u{630}\u{64A}\u{631}`,
    "positive": `\u{62A}\u{645} \u{628}\u{646}\u{62C}\u{627}\u{62D}`
};

},{}],"icBDe":[function(require,module,exports) {
module.exports = {
    "info": `\u{418}\u{43D}\u{444}\u{43E}\u{440}\u{43C}\u{430}\u{446}\u{438}\u{44F}`,
    "negative": `\u{413}\u{440}\u{435}\u{448}\u{43A}\u{430}`,
    "notice": `\u{41F}\u{440}\u{435}\u{434}\u{443}\u{43F}\u{440}\u{435}\u{436}\u{434}\u{435}\u{43D}\u{438}\u{435}`,
    "positive": `\u{423}\u{441}\u{43F}\u{435}\u{448}\u{43D}\u{43E}`
};

},{}],"6ruth":[function(require,module,exports) {
module.exports = {
    "info": `Informace`,
    "negative": `Chyba`,
    "notice": `Varov\xe1n\xed`,
    "positive": `\xdasp\u{11B}ch`
};

},{}],"i6hIp":[function(require,module,exports) {
module.exports = {
    "info": `Oplysninger`,
    "negative": `Fejl`,
    "notice": `Advarsel`,
    "positive": `Fuldf\xf8rt`
};

},{}],"fthxy":[function(require,module,exports) {
module.exports = {
    "info": `Informationen`,
    "negative": `Fehler`,
    "notice": `Warnung`,
    "positive": `Erfolg`
};

},{}],"kGJZm":[function(require,module,exports) {
module.exports = {
    "info": `\u{3A0}\u{3BB}\u{3B7}\u{3C1}\u{3BF}\u{3C6}\u{3BF}\u{3C1}\u{3AF}\u{3B5}\u{3C2}`,
    "negative": `\u{3A3}\u{3C6}\u{3AC}\u{3BB}\u{3BC}\u{3B1}`,
    "notice": `\u{3A0}\u{3C1}\u{3BF}\u{3B5}\u{3B9}\u{3B4}\u{3BF}\u{3C0}\u{3BF}\u{3AF}\u{3B7}\u{3C3}\u{3B7}`,
    "positive": `\u{395}\u{3C0}\u{3B9}\u{3C4}\u{3C5}\u{3C7}\u{3AF}\u{3B1}`
};

},{}],"95gf8":[function(require,module,exports) {
module.exports = {
    "negative": `Error`,
    "notice": `Warning`,
    "info": `Information`,
    "positive": `Success`
};

},{}],"bRynd":[function(require,module,exports) {
module.exports = {
    "info": `Informaci\xf3n`,
    "negative": `Error`,
    "notice": `Advertencia`,
    "positive": `\xc9xito`
};

},{}],"89DvA":[function(require,module,exports) {
module.exports = {
    "info": `Teave`,
    "negative": `T\xf5rge`,
    "notice": `Hoiatus`,
    "positive": `Valmis`
};

},{}],"glBC8":[function(require,module,exports) {
module.exports = {
    "info": `Tiedot`,
    "negative": `Virhe`,
    "notice": `Varoitus`,
    "positive": `Onnistui`
};

},{}],"4jRxQ":[function(require,module,exports) {
module.exports = {
    "info": `Informations`,
    "negative": `Erreur`,
    "notice": `Avertissement`,
    "positive": `Succ\xe8s`
};

},{}],"k5pYk":[function(require,module,exports) {
module.exports = {
    "info": `\u{5DE}\u{5D9}\u{5D3}\u{5E2}`,
    "negative": `\u{5E9}\u{5D2}\u{5D9}\u{5D0}\u{5D4}`,
    "notice": `\u{5D0}\u{5D6}\u{5D4}\u{5E8}\u{5D4}`,
    "positive": `\u{5D4}\u{5E6}\u{5DC}\u{5D7}\u{5D4}`
};

},{}],"4QAjx":[function(require,module,exports) {
module.exports = {
    "info": `Informacije`,
    "negative": `Pogre\u{161}ka`,
    "notice": `Upozorenje`,
    "positive": `Uspje\u{161}no`
};

},{}],"klhWs":[function(require,module,exports) {
module.exports = {
    "info": `Inform\xe1ci\xf3`,
    "negative": `Hiba`,
    "notice": `Figyelmeztet\xe9s`,
    "positive": `Siker`
};

},{}],"3Iwbo":[function(require,module,exports) {
module.exports = {
    "info": `Informazioni`,
    "negative": `Errore`,
    "notice": `Avviso`,
    "positive": `Operazione riuscita`
};

},{}],"5zsWg":[function(require,module,exports) {
module.exports = {
    "info": `\u{60C5}\u{5831}`,
    "negative": `\u{30A8}\u{30E9}\u{30FC}`,
    "notice": `\u{8B66}\u{544A}`,
    "positive": `\u{6210}\u{529F}`
};

},{}],"e0pNQ":[function(require,module,exports) {
module.exports = {
    "info": `\u{C815}\u{BCF4}`,
    "negative": `\u{C624}\u{B958}`,
    "notice": `\u{ACBD}\u{ACE0}`,
    "positive": `\u{C131}\u{ACF5}`
};

},{}],"7Bxoq":[function(require,module,exports) {
module.exports = {
    "info": `Informacija`,
    "negative": `Klaida`,
    "notice": `\u{12E}sp\u{117}jimas`,
    "positive": `S\u{117}kmingai`
};

},{}],"01KmK":[function(require,module,exports) {
module.exports = {
    "info": `Inform\u{101}cija`,
    "negative": `K\u{13C}\u{16B}da`,
    "notice": `Br\u{12B}din\u{101}jums`,
    "positive": `Izdev\u{101}s`
};

},{}],"dS09I":[function(require,module,exports) {
module.exports = {
    "info": `Informasjon`,
    "negative": `Feil`,
    "notice": `Advarsel`,
    "positive": `Vellykket`
};

},{}],"8wjqJ":[function(require,module,exports) {
module.exports = {
    "info": `Informatie`,
    "negative": `Fout`,
    "notice": `Waarschuwing`,
    "positive": `Geslaagd`
};

},{}],"gbYAt":[function(require,module,exports) {
module.exports = {
    "info": `Informacja`,
    "negative": `B\u{142}\u{105}d`,
    "notice": `Ostrze\u{17C}enie`,
    "positive": `Powodzenie`
};

},{}],"Hjgij":[function(require,module,exports) {
module.exports = {
    "info": `Informa\xe7\xf5es`,
    "negative": `Erro`,
    "notice": `Aviso`,
    "positive": `Sucesso`
};

},{}],"4hw3c":[function(require,module,exports) {
module.exports = {
    "info": `Informa\xe7\xe3o`,
    "negative": `Erro`,
    "notice": `Aviso`,
    "positive": `Sucesso`
};

},{}],"itaoy":[function(require,module,exports) {
module.exports = {
    "info": `Informa\u{21B}ii`,
    "negative": `Eroare`,
    "notice": `Avertisment`,
    "positive": `Succes`
};

},{}],"31S9a":[function(require,module,exports) {
module.exports = {
    "info": `\u{418}\u{43D}\u{444}\u{43E}\u{440}\u{43C}\u{430}\u{446}\u{438}\u{44F}`,
    "negative": `\u{41E}\u{448}\u{438}\u{431}\u{43A}\u{430}`,
    "notice": `\u{41F}\u{440}\u{435}\u{434}\u{443}\u{43F}\u{440}\u{435}\u{436}\u{434}\u{435}\u{43D}\u{438}\u{435}`,
    "positive": `\u{423}\u{441}\u{43F}\u{435}\u{448}\u{43D}\u{43E}`
};

},{}],"fTce9":[function(require,module,exports) {
module.exports = {
    "info": `Inform\xe1cie`,
    "negative": `Chyba`,
    "notice": `Upozornenie`,
    "positive": `\xdaspech`
};

},{}],"fiycz":[function(require,module,exports) {
module.exports = {
    "info": `Informacije`,
    "negative": `Napaka`,
    "notice": `Opozorilo`,
    "positive": `Uspe\u{161}no`
};

},{}],"4xZ46":[function(require,module,exports) {
module.exports = {
    "info": `Informacije`,
    "negative": `Gre\u{161}ka`,
    "notice": `Upozorenje`,
    "positive": `Uspe\u{161}no`
};

},{}],"2Dyzx":[function(require,module,exports) {
module.exports = {
    "info": `Information`,
    "negative": `Fel`,
    "notice": `Varning`,
    "positive": `Lyckades`
};

},{}],"eoRaK":[function(require,module,exports) {
module.exports = {
    "info": `Bilgiler`,
    "negative": `Hata`,
    "notice": `Uyar\u{131}`,
    "positive": `Ba\u{15F}ar\u{131}l\u{131}`
};

},{}],"8Uovp":[function(require,module,exports) {
module.exports = {
    "info": `\u{406}\u{43D}\u{444}\u{43E}\u{440}\u{43C}\u{430}\u{446}\u{456}\u{44F}`,
    "negative": `\u{41F}\u{43E}\u{43C}\u{438}\u{43B}\u{43A}\u{430}`,
    "notice": `\u{41F}\u{43E}\u{43F}\u{435}\u{440}\u{435}\u{434}\u{436}\u{435}\u{43D}\u{43D}\u{44F}`,
    "positive": `\u{423}\u{441}\u{43F}\u{456}\u{448}\u{43D}\u{43E}`
};

},{}],"arNZE":[function(require,module,exports) {
module.exports = {
    "info": `\u{4FE1}\u{606F}`,
    "negative": `\u{9519}\u{8BEF}`,
    "notice": `\u{8B66}\u{544A}`,
    "positive": `\u{6210}\u{529F}`
};

},{}],"2FD7h":[function(require,module,exports) {
module.exports = {
    "info": `\u{8CC7}\u{8A0A}`,
    "negative": `\u{932F}\u{8AA4}`,
    "notice": `\u{8B66}\u{544A}`,
    "positive": `\u{6210}\u{529F}`
};

},{}],"fyRfY":[function(require,module,exports) {
module.exports["content"] = `G_feca_content`;
module.exports["focus-ring"] = `G_feca_focus-ring`;
module.exports["heading"] = `G_feca_heading`;
module.exports["i18nFontFamily"] = `G_feca_i18nFontFamily`;
module.exports["icon"] = `G_feca_icon`;
module.exports["spectrum-FocusRing-ring"] = `G_feca_spectrum-FocusRing-ring`;
module.exports["spectrum-FocusRing"] = `G_feca_spectrum-FocusRing ${module.exports["spectrum-FocusRing-ring"]}`;
module.exports["spectrum-FocusRing--quiet"] = `G_feca_spectrum-FocusRing--quiet`;
module.exports["spectrum-InLineAlert"] = `G_feca_spectrum-InLineAlert ${module.exports["spectrum-FocusRing"]}`;
module.exports["spectrum-InLineAlert--info"] = `G_feca_spectrum-InLineAlert--info`;
module.exports["spectrum-InLineAlert--negative"] = `G_feca_spectrum-InLineAlert--negative`;
module.exports["spectrum-InLineAlert--neutral"] = `G_feca_spectrum-InLineAlert--neutral`;
module.exports["spectrum-InLineAlert--notice"] = `G_feca_spectrum-InLineAlert--notice`;
module.exports["spectrum-InLineAlert--positive"] = `G_feca_spectrum-InLineAlert--positive`;
module.exports["spectrum-InLineAlert-content"] = `G_feca_spectrum-InLineAlert-content`;
module.exports["spectrum-InLineAlert-grid"] = `G_feca_spectrum-InLineAlert-grid`;
module.exports["spectrum-InLineAlert-heading"] = `G_feca_spectrum-InLineAlert-heading`;
module.exports["spectrum-InLineAlert-icon"] = `G_feca_spectrum-InLineAlert-icon`;

},{}],"7xKnN":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("3219b9fb24cbf368");
exports.__esModule = true;
exports.default = SuccessMedium;
var _extends2 = _interopRequireDefault(require("f142b655756977e0"));
var _SuccessMedium = require("fc631a737e288f87");
var _icon = require("5783d3213e5c090c");
var _provider = require("d605c2d6a02b35f8");
var _react = _interopRequireDefault(require("b6606ee24148b927"));
const ExpressIcon = (props)=>/*#__PURE__*/ _react.default.createElement("svg", (0, _extends2.default)({
        viewBox: "0 0 18 18"
    }, props), /*#__PURE__*/ _react.default.createElement("path", {
        d: "M9.014 18.001a9.68 9.68 0 0 1-.628-.021 9 9 0 0 1-5.3-15.764 9 9 0 0 1 11.829 13.568 8.934 8.934 0 0 1-5.901 2.217ZM8.99 1.999a7 7 0 0 0-5.265 11.6A7 7 0 1 0 14.276 4.4 6.947 6.947 0 0 0 9.48 2.017a6.817 6.817 0 0 0-.489-.018Zm-.83 11.26a1 1 0 0 0 .713-.395l4.924-6.546a1 1 0 0 0-1.598-1.203L7.945 10.77 5.4 8.38A1 1 0 0 0 4.03 9.838l3.36 3.154a1 1 0 0 0 .684.27.843.843 0 0 0 .086-.003Z"
    }));
ExpressIcon.displayName = _SuccessMedium.SuccessMedium.displayName;
function SuccessMedium(props) {
    var _provider$theme, _provider$theme$globa;
    let provider = (0, _provider.useProvider)();
    return /*#__PURE__*/ _react.default.createElement(_icon.UIIcon, props, provider != null && (_provider$theme = provider.theme) != null && (_provider$theme$globa = _provider$theme.global) != null && _provider$theme$globa.express ? /*#__PURE__*/ _react.default.createElement(ExpressIcon, null) : /*#__PURE__*/ _react.default.createElement(_SuccessMedium.SuccessMedium, null));
}

},{"3219b9fb24cbf368":"iHubQ","f142b655756977e0":"l4mXf","fc631a737e288f87":"6IF64","5783d3213e5c090c":"k7wem","d605c2d6a02b35f8":"5bCdp","b6606ee24148b927":"9yzVZ"}],"6IF64":[function(require,module,exports) {
/**
* @adobe/react-spectrum-ui (c) by Adobe
* 
* @adobe/react-spectrum-ui is licensed under a
* Creative Commons Attribution-NoDerivatives 4.0 International License.
* 
* You should have received a copy of the license along with this
* work. If not, see <http://creativecommons.org/licenses/by-nd/4.0/>.
**/ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SuccessMedium = SuccessMedium;
var _react = _interopRequireDefault(require("f4ecc271e1d1b0ac"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function SuccessMedium(_ref) {
    var _ref$scale = _ref.scale, scale = _ref$scale === void 0 ? "M" : _ref$scale, props = _objectWithoutProperties(_ref, [
        "scale"
    ]);
    return _react["default"].createElement("svg", _extends({}, props, props), scale === "L" && _react["default"].createElement("path", {
        d: "M11 2a9 9 0 1 0 9 9 9 9 0 0 0-9-9zm5.638 5.609L10.1 15.652a.5.5 0 0 1-.742.038L5.086 11.5a.5.5 0 0 1 0-.707l.707-.707a.5.5 0 0 1 .707 0L9.6 13.1l5.486-6.751a.5.5 0 0 1 .7-.073l.776.631a.5.5 0 0 1 .076.702z"
    }), scale === "M" && _react["default"].createElement("path", {
        d: "M9 1a8 8 0 1 0 8 8 8 8 0 0 0-8-8zm5.333 4.54l-6.324 8.13a.6.6 0 0 1-.437.23h-.037a.6.6 0 0 1-.425-.176l-3.893-3.9a.6.6 0 0 1 0-.849l.663-.663a.6.6 0 0 1 .848 0L7.4 10.991l5.256-6.754a.6.6 0 0 1 .843-.1l.728.566a.6.6 0 0 1 .106.837z"
    }));
}
SuccessMedium.displayName = "SuccessMedium";

},{"f4ecc271e1d1b0ac":"9yzVZ"}],"2GFZF":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /// <reference types="css-module-types" />
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Image", ()=>(0, _image.Image));
var _image = require("./Image");

},{"./Image":"ky5DH","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"ky5DH":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Image", ()=>_Image);
var _utils = require("@react-spectrum/utils");
var _utils1 = require("@react-aria/utils");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _varsCss = require("@adobe/spectrum-css-temp/components/image/vars.css");
var _varsCssDefault = parcelHelpers.interopDefault(_varsCss);
var _provider = require("@react-spectrum/provider");
// incomplete component for show right now
function Image(props, ref) {
    /* Slots should be able to pass an alt for default behavior, but in Images, the child may know better. */ let userProvidedAlt = props.alt;
    props = (0, _utils.useSlotProps)(props, "image");
    props = (0, _provider.useProviderProps)(props);
    let { objectFit, src, alt, ...otherProps } = props;
    let { styleProps } = (0, _utils.useStyleProps)(otherProps);
    let domRef = (0, _utils.useDOMRef)(ref);
    if (alt == null) console.warn('The `alt` prop was not provided to an image. Add `alt` text for screen readers, or set `alt=""` prop to indicate that the image is decorative or redundant with displayed text and should not be announced by screen readers.');
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...(0, _utils1.filterDOMProps)(props),
        ...styleProps,
        className: (0, _utils.classNames)((0, _varsCssDefault.default), styleProps.className),
        style: {
            ...styleProps.style,
            overflow: "hidden"
        },
        ref: domRef
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("img", {
        src: src,
        alt: userProvidedAlt || alt,
        style: {
            objectFit
        },
        className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Image-img")
    }));
}
/**
 * Image is used to insert and display an image within a component.
 */ const _Image = /*#__PURE__*/ (0, _reactDefault.default).forwardRef(Image);

},{"@react-spectrum/utils":"cMIJ6","@react-aria/utils":"9cLk5","react":"9yzVZ","@adobe/spectrum-css-temp/components/image/vars.css":"1lVIJ","@react-spectrum/provider":"5bCdp","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"1lVIJ":[function(require,module,exports) {
module.exports["spectrum-Image-img"] = `Gv9sRq_spectrum-Image-img`;

},{}],"cPWzw":[function(require,module,exports) {
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /// <reference types="css-module-types" />
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LabeledValue", ()=>(0, _labeledValue.LabeledValue));
var _labeledValue = require("./LabeledValue");

},{"./LabeledValue":"fATh4","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"fATh4":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LabeledValue", ()=>_LabeledValue);
var _date = require("@internationalized/date");
var _utils = require("@react-spectrum/utils");
var _label = require("@react-spectrum/label");
var _utils1 = require("@react-aria/utils");
var _varsCss = require("@adobe/spectrum-css-temp/components/fieldlabel/vars.css");
var _varsCssDefault = parcelHelpers.interopDefault(_varsCss);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _i18N = require("@react-aria/i18n");
function LabeledValue(props, ref) {
    let { value, formatOptions } = props;
    let domRef = (0, _utils.useDOMRef)(ref);
    let children;
    if (Array.isArray(value)) children = /*#__PURE__*/ (0, _reactDefault.default).createElement(FormattedStringList, {
        value: value,
        formatOptions: formatOptions
    });
    if (typeof value === "object" && "start" in value && typeof value.start === "number" && typeof value.end === "number") children = /*#__PURE__*/ (0, _reactDefault.default).createElement(FormattedNumber, {
        value: value,
        formatOptions: formatOptions
    });
    if (typeof value === "object" && "start" in value && typeof value.start !== "number" && typeof value.end !== "number") children = /*#__PURE__*/ (0, _reactDefault.default).createElement(FormattedDate, {
        value: value,
        formatOptions: formatOptions
    });
    if (typeof value === "number") children = /*#__PURE__*/ (0, _reactDefault.default).createElement(FormattedNumber, {
        value: value,
        formatOptions: formatOptions
    });
    if (typeof value === "object" && ("calendar" in value || "hour" in value) || value instanceof Date) children = /*#__PURE__*/ (0, _reactDefault.default).createElement(FormattedDate, {
        value: value,
        formatOptions: formatOptions
    });
    if (typeof value === "string") children = value;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _label.Field), {
        ...props,
        wrapperProps: (0, _utils1.filterDOMProps)(props),
        ref: domRef,
        elementType: "span",
        wrapperClassName: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-LabeledValue")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("span", null, children));
}
function FormattedStringList(props) {
    let stringFormatter = (0, _i18N.useListFormatter)(props.formatOptions);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, stringFormatter.format(props.value));
}
function FormattedNumber(props) {
    let numberFormatter = (0, _i18N.useNumberFormatter)(props.formatOptions);
    let value = props.value;
    if (typeof value === "object") return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, numberFormatter.formatRange(value.start, value.end));
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, numberFormatter.format(value));
}
function FormattedDate(props) {
    let { value, formatOptions } = props;
    if (!formatOptions) formatOptions = getDefaultFormatOptions("start" in value ? value.start : value);
    let dateFormatter = (0, _i18N.useDateFormatter)(formatOptions);
    let timeZone = dateFormatter.resolvedOptions().timeZone || (0, _date.getLocalTimeZone)();
    let final;
    if ("start" in value && "end" in value) {
        let start = value.start;
        let end = value.end;
        start = convertDateTime(start, timeZone);
        end = convertDateTime(end, timeZone);
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, dateFormatter.formatRange(start, end));
    }
    final = convertDateTime(value, timeZone);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, dateFormatter.format(final));
}
function convertDateTime(value, timeZone) {
    if ("timeZone" in value) return value.toDate();
    else if ("calendar" in value) return value.toDate(timeZone);
    else if (!(value instanceof Date)) return convertValue(value).toDate(timeZone);
    return value;
}
function getDefaultFormatOptions(value) {
    if (value instanceof Date) return {
        dateStyle: "long",
        timeStyle: "short"
    };
    else if ("timeZone" in value) return {
        year: "numeric",
        month: "long",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
        timeZone: value.timeZone,
        timeZoneName: "short"
    };
    else if ("hour" in value && "year" in value) return {
        dateStyle: "long",
        timeStyle: "short"
    };
    else if ("hour" in value) return {
        timeStyle: "short"
    };
    else return {
        dateStyle: "long"
    };
}
function convertValue(value) {
    let date = (0, _date.today)((0, _date.getLocalTimeZone)());
    return (0, _date.toCalendarDateTime)(date, value);
}
/**
 * A LabeledValue displays a non-editable value with a label. It formats numbers, dates, times, and lists according to the user's locale.
 */ let _LabeledValue = /*#__PURE__*/ (0, _reactDefault.default).forwardRef(LabeledValue);

},{"@internationalized/date":"hesBk","@react-spectrum/utils":"cMIJ6","@react-spectrum/label":"6qv6N","@react-aria/utils":"9cLk5","@adobe/spectrum-css-temp/components/fieldlabel/vars.css":"cEUOQ","react":"9yzVZ","@react-aria/i18n":"411rg","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"h7MYZ":[function(require,module,exports) {
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ListView", ()=>(0, _listView.ListView));
parcelHelpers.export(exports, "Item", ()=>(0, _collections.Item));
var _listView = require("./ListView");
var _collections = require("@react-stately/collections");

},{"./ListView":"9X3vR","@react-stately/collections":"loANi","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"9X3vR":[function(require,module,exports) {
/*
 * Copyright 2021 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ListViewContext", ()=>ListViewContext);
parcelHelpers.export(exports, "ListView", ()=>_ListView);
var _gridlist = require("@react-aria/gridlist");
var _utils = require("@react-spectrum/utils");
var _utils1 = require("@react-aria/utils");
var _focus = require("@react-aria/focus");
var _insertionIndicator = require("./InsertionIndicator");
var _insertionIndicatorDefault = parcelHelpers.interopDefault(_insertionIndicator);
// @ts-ignore
var _json = require("../intl/*.json");
var _jsonDefault = parcelHelpers.interopDefault(_json);
var _layout = require("@react-stately/layout");
var _list = require("@react-stately/list");
var _stylesCss = require("./styles.css");
var _stylesCssDefault = parcelHelpers.interopDefault(_stylesCss);
var _listViewItem = require("./ListViewItem");
var _progress = require("@react-spectrum/progress");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _rootDropIndicator = require("./RootDropIndicator");
var _rootDropIndicatorDefault = parcelHelpers.interopDefault(_rootDropIndicator);
var _dragPreview = require("./DragPreview");
var _i18N = require("@react-aria/i18n");
var _provider = require("@react-spectrum/provider");
var _virtualizer = require("@react-aria/virtualizer");
const ListViewContext = /*#__PURE__*/ (0, _reactDefault.default).createContext(null);
const ROW_HEIGHTS = {
    compact: {
        medium: 32,
        large: 40
    },
    regular: {
        medium: 40,
        large: 50
    },
    spacious: {
        medium: 48,
        large: 60
    }
};
function useListLayout(state, density, overflowMode) {
    let { scale } = (0, _provider.useProvider)();
    let collator = (0, _i18N.useCollator)({
        usage: "search",
        sensitivity: "base"
    });
    let isEmpty = state.collection.size === 0;
    let layout = (0, _react.useMemo)(()=>new (0, _layout.ListLayout)({
            estimatedRowHeight: ROW_HEIGHTS[density][scale],
            padding: 0,
            collator,
            loaderHeight: isEmpty ? null : ROW_HEIGHTS[density][scale]
        }), [
        collator,
        scale,
        density,
        isEmpty,
        overflowMode
    ]);
    layout.collection = state.collection;
    layout.disabledKeys = state.disabledKeys;
    return layout;
}
function ListView(props, ref) {
    var _dropState_target;
    let { density = "regular", loadingState, onLoadMore, isQuiet, overflowMode = "truncate", onAction, dragAndDropHooks, ...otherProps } = props;
    let isListDraggable = !!(dragAndDropHooks === null || dragAndDropHooks === void 0 ? void 0 : dragAndDropHooks.useDraggableCollectionState);
    let isListDroppable = !!(dragAndDropHooks === null || dragAndDropHooks === void 0 ? void 0 : dragAndDropHooks.useDroppableCollectionState);
    let dragHooksProvided = (0, _react.useRef)(isListDraggable);
    let dropHooksProvided = (0, _react.useRef)(isListDroppable);
    (0, _react.useEffect)(()=>{
        if (dragHooksProvided.current !== isListDraggable) console.warn("Drag hooks were provided during one render, but not another. This should be avoided as it may produce unexpected behavior.");
        if (dropHooksProvided.current !== isListDroppable) console.warn("Drop hooks were provided during one render, but not another. This should be avoided as it may produce unexpected behavior.");
    }, [
        isListDraggable,
        isListDroppable
    ]);
    let domRef = (0, _utils.useDOMRef)(ref);
    let state = (0, _list.useListState)({
        ...props,
        selectionBehavior: props.selectionStyle === "highlight" ? "replace" : "toggle"
    });
    let { collection, selectionManager } = state;
    let stringFormatter = (0, _i18N.useLocalizedStringFormatter)((0, _jsonDefault.default), "@react-spectrum/list");
    let isLoading = loadingState === "loading" || loadingState === "loadingMore";
    let { styleProps } = (0, _utils.useStyleProps)(props);
    let dragState;
    let preview = (0, _react.useRef)(null);
    if (isListDraggable) {
        dragState = dragAndDropHooks.useDraggableCollectionState({
            collection,
            selectionManager,
            preview
        });
        dragAndDropHooks.useDraggableCollection({}, dragState, domRef);
    }
    let layout = useListLayout(state, props.density || "regular", overflowMode);
    // !!0 is false, so we can cast size or undefined and they'll be falsy
    layout.allowDisabledKeyFocus = state.selectionManager.disabledBehavior === "selection" || !!(dragState === null || dragState === void 0 ? void 0 : dragState.draggingKeys.size);
    let DragPreview = dragAndDropHooks === null || dragAndDropHooks === void 0 ? void 0 : dragAndDropHooks.DragPreview;
    let dropState;
    let droppableCollection;
    let isRootDropTarget;
    if (isListDroppable) {
        dropState = dragAndDropHooks.useDroppableCollectionState({
            collection,
            selectionManager
        });
        droppableCollection = dragAndDropHooks.useDroppableCollection({
            keyboardDelegate: layout,
            dropTargetDelegate: layout
        }, dropState, domRef);
        isRootDropTarget = dropState.isDropTarget({
            type: "root"
        });
    }
    let { gridProps } = (0, _gridlist.useGridList)({
        ...props,
        isVirtualized: true,
        keyboardDelegate: layout,
        onAction
    }, state, domRef);
    // Sync loading state into the layout.
    layout.isLoading = isLoading;
    let focusedKey = selectionManager.focusedKey;
    if ((dropState === null || dropState === void 0 ? void 0 : (_dropState_target = dropState.target) === null || _dropState_target === void 0 ? void 0 : _dropState_target.type) === "item") focusedKey = dropState.target.key;
    // wait for layout to get accurate measurements
    let [isVerticalScrollbarVisible, setVerticalScollbarVisible] = (0, _react.useState)(false);
    let [isHorizontalScrollbarVisible, setHorizontalScollbarVisible] = (0, _react.useState)(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, _utils1.useLayoutEffect)(()=>{
        if (domRef.current) {
            // 2 is the width of the border which is not part of the box size
            setVerticalScollbarVisible(domRef.current.clientWidth + 2 < domRef.current.offsetWidth);
            setHorizontalScollbarVisible(domRef.current.clientHeight + 2 < domRef.current.offsetHeight);
        }
    });
    let hasAnyChildren = (0, _react.useMemo)(()=>[
            ...collection
        ].some((item)=>item.hasChildNodes), [
        collection
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(ListViewContext.Provider, {
        value: {
            state,
            dragState,
            dropState,
            dragAndDropHooks,
            onAction,
            isListDraggable,
            isListDroppable,
            layout,
            loadingState
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _focus.FocusScope), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _focus.FocusRing), {
        focusRingClass: (0, _utils.classNames)((0, _stylesCssDefault.default), "focus-ring")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _virtualizer.Virtualizer), {
        ...(0, _utils1.mergeProps)(isListDroppable && (droppableCollection === null || droppableCollection === void 0 ? void 0 : droppableCollection.collectionProps), gridProps),
        ...(0, _utils1.filterDOMProps)(otherProps),
        ...gridProps,
        ...styleProps,
        isLoading: isLoading,
        onLoadMore: onLoadMore,
        ref: domRef,
        focusedKey: focusedKey,
        scrollDirection: "vertical",
        className: (0, _utils.classNames)((0, _stylesCssDefault.default), "react-spectrum-ListView", `react-spectrum-ListView--${density}`, "react-spectrum-ListView--emphasized", {
            "react-spectrum-ListView--quiet": isQuiet,
            "react-spectrum-ListView--loadingMore": loadingState === "loadingMore",
            "react-spectrum-ListView--draggable": !!isListDraggable,
            "react-spectrum-ListView--dropTarget": !!isRootDropTarget,
            "react-spectrum-ListView--isVerticalScrollbarVisible": isVerticalScrollbarVisible,
            "react-spectrum-ListView--isHorizontalScrollbarVisible": isHorizontalScrollbarVisible,
            "react-spectrum-ListView--hasAnyChildren": hasAnyChildren,
            "react-spectrum-ListView--wrap": overflowMode === "wrap"
        }, styleProps.className),
        layout: layout,
        collection: collection,
        transitionDuration: isLoading ? 160 : 220
    }, (type, item)=>{
        if (type === "item") return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, isListDroppable && collection.getKeyBefore(item.key) == null && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _rootDropIndicatorDefault.default), {
            key: "root"
        }), isListDroppable && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _insertionIndicatorDefault.default), {
            key: `${item.key}-before`,
            target: {
                key: item.key,
                type: "item",
                dropPosition: "before"
            }
        }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _listViewItem.ListViewItem), {
            item: item,
            isEmphasized: true,
            hasActions: !!onAction
        }), isListDroppable && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _insertionIndicatorDefault.default), {
            key: `${item.key}-after`,
            target: {
                key: item.key,
                type: "item",
                dropPosition: "after"
            },
            isPresentationOnly: collection.getKeyAfter(item.key) != null
        }));
        else if (type === "loader") return /*#__PURE__*/ (0, _reactDefault.default).createElement(CenteredWrapper, null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _progress.ProgressCircle), {
            isIndeterminate: true,
            "aria-label": collection.size > 0 ? stringFormatter.format("loadingMore") : stringFormatter.format("loading")
        }));
        else if (type === "placeholder") {
            let emptyState = props.renderEmptyState ? props.renderEmptyState() : null;
            if (emptyState == null) return null;
            return /*#__PURE__*/ (0, _reactDefault.default).createElement(CenteredWrapper, null, emptyState);
        }
    }))), DragPreview && isListDraggable && /*#__PURE__*/ (0, _reactDefault.default).createElement(DragPreview, {
        ref: preview
    }, ()=>{
        if (dragAndDropHooks.renderPreview) return dragAndDropHooks.renderPreview(dragState.draggingKeys, dragState.draggedKey);
        let item = state.collection.getItem(dragState.draggedKey);
        let itemCount = dragState.draggingKeys.size;
        let itemHeight = layout.getLayoutInfo(dragState.draggedKey).rect.height;
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _dragPreview.DragPreview), {
            item: item,
            itemCount: itemCount,
            itemHeight: itemHeight,
            density: density
        });
    }));
}
function CenteredWrapper({ children }) {
    let { state } = (0, _react.useContext)(ListViewContext);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        role: "row",
        "aria-rowindex": state.collection.size + 1,
        className: (0, _utils.classNames)((0, _stylesCssDefault.default), "react-spectrum-ListView-centeredWrapper", {
            "react-spectrum-ListView-centeredWrapper--loadingMore": state.collection.size > 0
        })
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        role: "gridcell"
    }, children));
}
/**
 * A ListView displays a list of interactive items, and allows a user to navigate, select, or perform an action.
 */ const _ListView = /*#__PURE__*/ (0, _reactDefault.default).forwardRef(ListView);

},{"@react-aria/gridlist":"g9vQF","@react-spectrum/utils":"cMIJ6","@react-aria/utils":"9cLk5","@react-aria/focus":"42mbF","./InsertionIndicator":"dOXkP","../intl/*.json":"2Y46l","@react-stately/layout":"6Mwz5","@react-stately/list":"Cp0zP","./styles.css":"dovNV","./ListViewItem":"kI18T","@react-spectrum/progress":"4kHa7","react":"9yzVZ","./RootDropIndicator":"9LZrS","./DragPreview":"1BVOK","@react-aria/i18n":"411rg","@react-spectrum/provider":"5bCdp","@react-aria/virtualizer":"gAPsK","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"dOXkP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>InsertionIndicator);
var _utils = require("@react-spectrum/utils");
var _stylesCss = require("./styles.css");
var _stylesCssDefault = parcelHelpers.interopDefault(_stylesCss);
var _listView = require("./ListView");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _visuallyHidden = require("@react-aria/visually-hidden");
function InsertionIndicator(props) {
    let { dropState, dragAndDropHooks } = (0, _react.useContext)((0, _listView.ListViewContext));
    const { target, isPresentationOnly } = props;
    let ref = (0, _react.useRef)();
    let { dropIndicatorProps } = dragAndDropHooks.useDropIndicator(props, dropState, ref);
    let { visuallyHiddenProps } = (0, _visuallyHidden.useVisuallyHidden)();
    let isDropTarget = dropState.isDropTarget(target);
    if (!isDropTarget && dropIndicatorProps["aria-hidden"]) return null;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        role: "row",
        "aria-hidden": dropIndicatorProps["aria-hidden"]
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        role: "gridcell",
        "aria-selected": "false",
        className: (0, _utils.classNames)((0, _stylesCssDefault.default), "react-spectrum-ListViewInsertionIndicator", {
            "react-spectrum-ListViewInsertionIndicator--dropTarget": isDropTarget
        })
    }, !isPresentationOnly && /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...visuallyHiddenProps,
        role: "button",
        ...dropIndicatorProps,
        ref: ref
    })));
}

},{"@react-spectrum/utils":"cMIJ6","./styles.css":"dovNV","./ListView":"9X3vR","react":"9yzVZ","@react-aria/visually-hidden":"4jwxT","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"dovNV":[function(require,module,exports) {
module.exports["actionmenu"] = `C64cMW_actionmenu`;
module.exports["actions"] = `C64cMW_actions`;
module.exports["badge"] = `C64cMW_badge`;
module.exports["checkbox"] = `C64cMW_checkbox`;
module.exports["chevron"] = `C64cMW_chevron`;
module.exports["content"] = `C64cMW_content`;
module.exports["description"] = `C64cMW_description`;
module.exports["draghandle"] = `C64cMW_draghandle`;
module.exports["focus-ring"] = `C64cMW_focus-ring`;
module.exports["has-checkbox"] = `C64cMW_has-checkbox`;
module.exports["is-active"] = `C64cMW_is-active`;
module.exports["is-disabled"] = `C64cMW_is-disabled`;
module.exports["is-focused"] = `C64cMW_is-focused`;
module.exports["is-hovered"] = `C64cMW_is-hovered`;
module.exports["is-next-selected"] = `C64cMW_is-next-selected`;
module.exports["is-selected"] = `C64cMW_is-selected`;
module.exports["react-spectrum-ListView"] = `C64cMW_react-spectrum-ListView`;
module.exports["react-spectrum-ListView--compact"] = `C64cMW_react-spectrum-ListView--compact`;
module.exports["react-spectrum-ListView--draggable"] = `C64cMW_react-spectrum-ListView--draggable`;
module.exports["react-spectrum-ListView--dropTarget"] = `C64cMW_react-spectrum-ListView--dropTarget`;
module.exports["react-spectrum-ListView--emphasized"] = `C64cMW_react-spectrum-ListView--emphasized`;
module.exports["react-spectrum-ListView--hasAnyChildren"] = `C64cMW_react-spectrum-ListView--hasAnyChildren`;
module.exports["react-spectrum-ListView--hasDescription"] = `C64cMW_react-spectrum-ListView--hasDescription`;
module.exports["react-spectrum-ListView--isHorizontalScrollbarVisible"] = `C64cMW_react-spectrum-ListView--isHorizontalScrollbarVisible`;
module.exports["react-spectrum-ListView--isVerticalScrollbarVisible"] = `C64cMW_react-spectrum-ListView--isVerticalScrollbarVisible`;
module.exports["react-spectrum-ListView--loadingMore"] = `C64cMW_react-spectrum-ListView--loadingMore`;
module.exports["react-spectrum-ListView--quiet"] = `C64cMW_react-spectrum-ListView--quiet`;
module.exports["react-spectrum-ListView--spacious"] = `C64cMW_react-spectrum-ListView--spacious`;
module.exports["react-spectrum-ListView--wrap"] = `C64cMW_react-spectrum-ListView--wrap`;
module.exports["react-spectrum-ListView-centeredWrapper"] = `C64cMW_react-spectrum-ListView-centeredWrapper`;
module.exports["react-spectrum-ListView-centeredWrapper--loadingMore"] = `C64cMW_react-spectrum-ListView-centeredWrapper--loadingMore`;
module.exports["react-spectrum-ListView-row"] = `C64cMW_react-spectrum-ListView-row`;
module.exports["react-spectrum-ListViewInsertionIndicator"] = `C64cMW_react-spectrum-ListViewInsertionIndicator`;
module.exports["react-spectrum-ListViewInsertionIndicator--dropTarget"] = `C64cMW_react-spectrum-ListViewInsertionIndicator--dropTarget`;
module.exports["react-spectrum-ListViewItem"] = `C64cMW_react-spectrum-ListViewItem`;
module.exports["react-spectrum-ListViewItem--dropTarget"] = `C64cMW_react-spectrum-ListViewItem--dropTarget`;
module.exports["react-spectrum-ListViewItem--firstRow"] = `C64cMW_react-spectrum-ListViewItem--firstRow`;
module.exports["react-spectrum-ListViewItem--isFlushBottom"] = `C64cMW_react-spectrum-ListViewItem--isFlushBottom`;
module.exports["react-spectrum-ListViewItem--lastRow"] = `C64cMW_react-spectrum-ListViewItem--lastRow`;
module.exports["react-spectrum-ListViewItem-actionmenu"] = `C64cMW_react-spectrum-ListViewItem-actionmenu`;
module.exports["react-spectrum-ListViewItem-actions"] = `C64cMW_react-spectrum-ListViewItem-actions`;
module.exports["react-spectrum-ListViewItem-badge"] = `C64cMW_react-spectrum-ListViewItem-badge`;
module.exports["react-spectrum-ListViewItem-checkbox"] = `C64cMW_react-spectrum-ListViewItem-checkbox`;
module.exports["react-spectrum-ListViewItem-checkbox--enter"] = `C64cMW_react-spectrum-ListViewItem-checkbox--enter`;
module.exports["react-spectrum-ListViewItem-checkbox--enterActive"] = `C64cMW_react-spectrum-ListViewItem-checkbox--enterActive`;
module.exports["react-spectrum-ListViewItem-checkbox--exit"] = `C64cMW_react-spectrum-ListViewItem-checkbox--exit`;
module.exports["react-spectrum-ListViewItem-checkbox--exitActive"] = `C64cMW_react-spectrum-ListViewItem-checkbox--exitActive`;
module.exports["react-spectrum-ListViewItem-checkboxWrapper"] = `C64cMW_react-spectrum-ListViewItem-checkboxWrapper`;
module.exports["react-spectrum-ListViewItem-content"] = `C64cMW_react-spectrum-ListViewItem-content`;
module.exports["react-spectrum-ListViewItem-description"] = `C64cMW_react-spectrum-ListViewItem-description`;
module.exports["react-spectrum-ListViewItem-dragPreview"] = `C64cMW_react-spectrum-ListViewItem-dragPreview`;
module.exports["react-spectrum-ListViewItem-dragPreview--compact"] = `C64cMW_react-spectrum-ListViewItem-dragPreview--compact`;
module.exports["react-spectrum-ListViewItem-dragPreview--multiple"] = `C64cMW_react-spectrum-ListViewItem-dragPreview--multiple`;
module.exports["react-spectrum-ListViewItem-dragPreview--spacious"] = `C64cMW_react-spectrum-ListViewItem-dragPreview--spacious`;
module.exports["react-spectrum-ListViewItem-draghandle-button"] = `C64cMW_react-spectrum-ListViewItem-draghandle-button`;
module.exports["react-spectrum-ListViewItem-draghandle-container"] = `C64cMW_react-spectrum-ListViewItem-draghandle-container`;
module.exports["react-spectrum-ListViewItem-grid"] = `C64cMW_react-spectrum-ListViewItem-grid`;
module.exports["react-spectrum-ListViewItem-parentIndicator"] = `C64cMW_react-spectrum-ListViewItem-parentIndicator`;
module.exports["react-spectrum-ListViewItem-parentIndicator--hasChildItems"] = `C64cMW_react-spectrum-ListViewItem-parentIndicator--hasChildItems`;
module.exports["react-spectrum-ListViewItem-thumbnail"] = `C64cMW_react-spectrum-ListViewItem-thumbnail`;
module.exports["round-bottoms"] = `C64cMW_round-bottoms`;
module.exports["round-tops"] = `C64cMW_round-tops`;
module.exports["thumbnail"] = `C64cMW_thumbnail`;

},{}],"2Y46l":[function(require,module,exports) {
const _temp0 = require("707a7640c73ce162");
const _temp1 = require("16f4cfac7709b376");
const _temp2 = require("5cd5d3a8da2d4c6b");
const _temp3 = require("49e7dddd44e6ddb7");
const _temp4 = require("9c8d49e2fb47f6c1");
const _temp5 = require("587d00557d9c0ab6");
const _temp6 = require("dab2aff554e8874e");
const _temp7 = require("f1676e256770b328");
const _temp8 = require("c43d365ce440d63f");
const _temp9 = require("c032ff6cc204aee5");
const _temp10 = require("430267b865858797");
const _temp11 = require("33caadda5c37a4e8");
const _temp12 = require("dfa3d1782ba92acc");
const _temp13 = require("730e9311a86a8f7f");
const _temp14 = require("d36516b49ec827fe");
const _temp15 = require("1fa9577e8ef8e15");
const _temp16 = require("82926e48f1d48883");
const _temp17 = require("af434fd433b53630");
const _temp18 = require("b2d66a377213fa90");
const _temp19 = require("b662412cf279575");
const _temp20 = require("596f9f16ebebbc72");
const _temp21 = require("37db4dd4467b8f93");
const _temp22 = require("f1af4615ffcaba0");
const _temp23 = require("9b6d37db0d252ff");
const _temp24 = require("58bd923744e83308");
const _temp25 = require("466b70346c556fb1");
const _temp26 = require("9f45d12db85133c8");
const _temp27 = require("a06f345f3b9921c7");
const _temp28 = require("869c51316403f826");
const _temp29 = require("c2ef940e78c5d32f");
const _temp30 = require("5f0d972fce35037a");
const _temp31 = require("e94e30d07444ae1");
const _temp32 = require("884d7e920224970");
const _temp33 = require("93329369a76db1bc");
module.exports = {
    "ar-AE": _temp0,
    "bg-BG": _temp1,
    "cs-CZ": _temp2,
    "da-DK": _temp3,
    "de-DE": _temp4,
    "el-GR": _temp5,
    "en-US": _temp6,
    "es-ES": _temp7,
    "et-EE": _temp8,
    "fi-FI": _temp9,
    "fr-FR": _temp10,
    "he-IL": _temp11,
    "hr-HR": _temp12,
    "hu-HU": _temp13,
    "it-IT": _temp14,
    "ja-JP": _temp15,
    "ko-KR": _temp16,
    "lt-LT": _temp17,
    "lv-LV": _temp18,
    "nb-NO": _temp19,
    "nl-NL": _temp20,
    "pl-PL": _temp21,
    "pt-BR": _temp22,
    "pt-PT": _temp23,
    "ro-RO": _temp24,
    "ru-RU": _temp25,
    "sk-SK": _temp26,
    "sl-SI": _temp27,
    "sr-SP": _temp28,
    "sv-SE": _temp29,
    "tr-TR": _temp30,
    "uk-UA": _temp31,
    "zh-CN": _temp32,
    "zh-TW": _temp33
};

},{"707a7640c73ce162":"dX52Y","16f4cfac7709b376":"acgYh","5cd5d3a8da2d4c6b":"6IK95","49e7dddd44e6ddb7":"gbbTT","9c8d49e2fb47f6c1":"glZkR","587d00557d9c0ab6":"a7wrA","dab2aff554e8874e":"4pgJk","f1676e256770b328":"iiWM9","c43d365ce440d63f":"1SBhj","c032ff6cc204aee5":"iePAW","430267b865858797":"5jt5t","33caadda5c37a4e8":"eYXRd","dfa3d1782ba92acc":"dfKUT","730e9311a86a8f7f":"gawcU","d36516b49ec827fe":"9pukM","1fa9577e8ef8e15":"58iiL","82926e48f1d48883":"klTpU","af434fd433b53630":"7CDPP","b2d66a377213fa90":"dY65r","b662412cf279575":"rfVXo","596f9f16ebebbc72":"2TWAk","37db4dd4467b8f93":"buFUk","f1af4615ffcaba0":"89DRH","9b6d37db0d252ff":"9sPeC","58bd923744e83308":"hf77L","466b70346c556fb1":"c53Hn","9f45d12db85133c8":"eRUaz","a06f345f3b9921c7":"e5BWP","869c51316403f826":"lbIYb","c2ef940e78c5d32f":"il67O","5f0d972fce35037a":"igESr","e94e30d07444ae1":"clAYy","884d7e920224970":"31w9Y","93329369a76db1bc":"PTBny"}],"dX52Y":[function(require,module,exports) {
module.exports = {
    "loading": `\u{62C}\u{627}\u{631}\u{64D} \u{627}\u{644}\u{62A}\u{62D}\u{645}\u{64A}\u{644}...`,
    "loadingMore": `\u{62C}\u{627}\u{631}\u{64D} \u{62A}\u{62D}\u{645}\u{64A}\u{644} \u{627}\u{644}\u{645}\u{632}\u{64A}\u{62F}...`
};

},{}],"acgYh":[function(require,module,exports) {
module.exports = {
    "loading": `\u{417}\u{430}\u{440}\u{435}\u{436}\u{434}\u{430}\u{43D}\u{435}...`,
    "loadingMore": `\u{417}\u{430}\u{440}\u{435}\u{436}\u{434}\u{430}\u{43D}\u{435} \u{43D}\u{430} \u{43E}\u{449}\u{435}...`
};

},{}],"6IK95":[function(require,module,exports) {
module.exports = {
    "loading": `Na\u{10D}\xedt\xe1n\xed...`,
    "loadingMore": `Na\u{10D}\xedt\xe1n\xed dal\u{161}\xedch...`
};

},{}],"gbbTT":[function(require,module,exports) {
module.exports = {
    "loading": `Indl\xe6ser...`,
    "loadingMore": `Indl\xe6ser flere...`
};

},{}],"glZkR":[function(require,module,exports) {
module.exports = {
    "loading": `Laden...`,
    "loadingMore": `Mehr laden ...`
};

},{}],"a7wrA":[function(require,module,exports) {
module.exports = {
    "loading": `\u{3A6}\u{3CC}\u{3C1}\u{3C4}\u{3C9}\u{3C3}\u{3B7}...`,
    "loadingMore": `\u{3A6}\u{3CC}\u{3C1}\u{3C4}\u{3C9}\u{3C3}\u{3B7} \u{3C0}\u{3B5}\u{3C1}\u{3B9}\u{3C3}\u{3C3}\u{3CC}\u{3C4}\u{3B5}\u{3C1}\u{3C9}\u{3BD}...`
};

},{}],"4pgJk":[function(require,module,exports) {
module.exports = {
    "loading": `Loading\u{2026}`,
    "loadingMore": `Loading more\u{2026}`
};

},{}],"iiWM9":[function(require,module,exports) {
module.exports = {
    "loading": `Cargando\u{2026}`,
    "loadingMore": `Cargando m\xe1s\u{2026}`
};

},{}],"1SBhj":[function(require,module,exports) {
module.exports = {
    "loading": `Laadimine...`,
    "loadingMore": `Laadi rohkem...`
};

},{}],"iePAW":[function(require,module,exports) {
module.exports = {
    "loading": `Ladataan\u{2026}`,
    "loadingMore": `Ladataan lis\xe4\xe4\u{2026}`
};

},{}],"5jt5t":[function(require,module,exports) {
module.exports = {
    "loading": `Chargement...`,
    "loadingMore": `Chargement suppl\xe9mentaire...`
};

},{}],"eYXRd":[function(require,module,exports) {
module.exports = {
    "loading": `\u{5D8}\u{5D5}\u{5E2}\u{5DF}...`,
    "loadingMore": `\u{5D8}\u{5D5}\u{5E2}\u{5DF} \u{5E2}\u{5D5}\u{5D3}...`
};

},{}],"dfKUT":[function(require,module,exports) {
module.exports = {
    "loading": `U\u{10D}itavam...`,
    "loadingMore": `U\u{10D}itavam jo\u{161}...`
};

},{}],"gawcU":[function(require,module,exports) {
module.exports = {
    "loading": `Bet\xf6lt\xe9s folyamatban\u{2026}`,
    "loadingMore": `Tov\xe1bbiak bet\xf6lt\xe9se folyamatban\u{2026}`
};

},{}],"9pukM":[function(require,module,exports) {
module.exports = {
    "loading": `Caricamento...`,
    "loadingMore": `Caricamento altri...`
};

},{}],"58iiL":[function(require,module,exports) {
module.exports = {
    "loading": `\u{8AAD}\u{307F}\u{8FBC}\u{307F}\u{4E2D}...`,
    "loadingMore": `\u{3055}\u{3089}\u{306B}\u{8AAD}\u{307F}\u{8FBC}\u{307F}\u{4E2D}...`
};

},{}],"klTpU":[function(require,module,exports) {
module.exports = {
    "loading": `\u{B85C}\u{B4DC} \u{C911}\u{2026}`,
    "loadingMore": `\u{CD94}\u{AC00} \u{B85C}\u{B4DC} \u{C911}\u{2026}`
};

},{}],"7CDPP":[function(require,module,exports) {
module.exports = {
    "loading": `\u{12E}keliama...`,
    "loadingMore": `\u{12E}keliama daugiau...`
};

},{}],"dY65r":[function(require,module,exports) {
module.exports = {
    "loading": `Notiek iel\u{101}de...`,
    "loadingMore": `Tiek iel\u{101}d\u{113}ts v\u{113}l...`
};

},{}],"rfVXo":[function(require,module,exports) {
module.exports = {
    "loading": `Laster inn ...`,
    "loadingMore": `Laster inn flere ...`
};

},{}],"2TWAk":[function(require,module,exports) {
module.exports = {
    "loading": `Laden...`,
    "loadingMore": `Meer laden...`
};

},{}],"buFUk":[function(require,module,exports) {
module.exports = {
    "loading": `\u{141}adowanie...`,
    "loadingMore": `Wczytywanie wi\u{119}kszej liczby...`
};

},{}],"89DRH":[function(require,module,exports) {
module.exports = {
    "loading": `Carregando...`,
    "loadingMore": `Carregando mais...`
};

},{}],"9sPeC":[function(require,module,exports) {
module.exports = {
    "loading": `A carregar...`,
    "loadingMore": `A carregar mais...`
};

},{}],"hf77L":[function(require,module,exports) {
module.exports = {
    "loading": `Se \xeencarc\u{103}...`,
    "loadingMore": `Se \xeencarc\u{103} mai multe...`
};

},{}],"c53Hn":[function(require,module,exports) {
module.exports = {
    "loading": `\u{417}\u{430}\u{433}\u{440}\u{443}\u{437}\u{43A}\u{430}...`,
    "loadingMore": `\u{414}\u{43E}\u{43F}\u{43E}\u{43B}\u{43D}\u{438}\u{442}\u{435}\u{43B}\u{44C}\u{43D}\u{430}\u{44F} \u{437}\u{430}\u{433}\u{440}\u{443}\u{437}\u{43A}\u{430}...`
};

},{}],"eRUaz":[function(require,module,exports) {
module.exports = {
    "loading": `Na\u{10D}\xedtava sa...`,
    "loadingMore": `Na\u{10D}\xedtava sa viac...`
};

},{}],"e5BWP":[function(require,module,exports) {
module.exports = {
    "loading": `Nalaganje ...`,
    "loadingMore": `Nalaganje ve\u{10D} vsebine ...`
};

},{}],"lbIYb":[function(require,module,exports) {
module.exports = {
    "loading": `U\u{10D}itavam...`,
    "loadingMore": `U\u{10D}itavam jo\u{161}...`
};

},{}],"il67O":[function(require,module,exports) {
module.exports = {
    "loading": `L\xe4ser in...`,
    "loadingMore": `L\xe4ser in mer...`
};

},{}],"igESr":[function(require,module,exports) {
module.exports = {
    "loading": `Y\xfckleniyor...`,
    "loadingMore": `Daha fazla y\xfckleniyor...`
};

},{}],"clAYy":[function(require,module,exports) {
module.exports = {
    "loading": `\u{417}\u{430}\u{432}\u{430}\u{43D}\u{442}\u{430}\u{436}\u{435}\u{43D}\u{43D}\u{44F}\u{2026}`,
    "loadingMore": `\u{417}\u{430}\u{432}\u{430}\u{43D}\u{442}\u{430}\u{436}\u{435}\u{43D}\u{43D}\u{44F} \u{456}\u{43D}\u{448}\u{438}\u{445} \u{43E}\u{431}\u{2019}\u{454}\u{43A}\u{442}\u{456}\u{432}...`
};

},{}],"31w9Y":[function(require,module,exports) {
module.exports = {
    "loading": `\u{6B63}\u{5728}\u{52A0}\u{8F7D}...`,
    "loadingMore": `\u{6B63}\u{5728}\u{52A0}\u{8F7D}\u{66F4}\u{591A}...`
};

},{}],"PTBny":[function(require,module,exports) {
module.exports = {
    "loading": `\u{8F09}\u{5165}\u{4E2D}\u{2026}`,
    "loadingMore": `\u{6B63}\u{5728}\u{8F09}\u{5165}\u{66F4}\u{591A}\u{2026}`
};

},{}],"kI18T":[function(require,module,exports) {
/*
 * Copyright 2021 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ListViewItem", ()=>ListViewItem);
var _checkbox = require("@react-spectrum/checkbox");
var _chevronLeftMedium = require("@spectrum-icons/ui/ChevronLeftMedium");
var _chevronLeftMediumDefault = parcelHelpers.interopDefault(_chevronLeftMedium);
var _chevronRightMedium = require("@spectrum-icons/ui/ChevronRightMedium");
var _chevronRightMediumDefault = parcelHelpers.interopDefault(_chevronRightMedium);
var _utils = require("@react-spectrum/utils");
var _reactTransitionGroup = require("react-transition-group");
var _focus = require("@react-aria/focus");
var _layout = require("@react-spectrum/layout");
var _interactions = require("@react-aria/interactions");
var _listGripper = require("@spectrum-icons/ui/ListGripper");
var _listGripperDefault = parcelHelpers.interopDefault(_listGripper);
var _stylesCss = require("./styles.css");
var _stylesCssDefault = parcelHelpers.interopDefault(_stylesCss);
var _listView = require("./ListView");
var _utils1 = require("@react-aria/utils");
var _provider = require("@react-spectrum/provider");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _text = require("@react-spectrum/text");
var _button = require("@react-aria/button");
var _gridlist = require("@react-aria/gridlist");
var _i18N = require("@react-aria/i18n");
var _visuallyHidden = require("@react-aria/visually-hidden");
function ListViewItem(props) {
    var _layout_getContentSize, _layout_virtualizer;
    let { item, isEmphasized } = props;
    let { state, dragState, dropState, isListDraggable, isListDroppable, layout, dragAndDropHooks, loadingState } = (0, _react.useContext)((0, _listView.ListViewContext));
    let { direction } = (0, _i18N.useLocale)();
    let rowRef = (0, _react.useRef)();
    let checkboxWrapperRef = (0, _react.useRef)();
    let { isFocusVisible: isFocusVisibleWithin, focusProps: focusWithinProps } = (0, _focus.useFocusRing)({
        within: true
    });
    let { isFocusVisible, focusProps } = (0, _focus.useFocusRing)();
    let { rowProps, gridCellProps, isPressed, descriptionProps, isSelected, isDisabled, allowsSelection, hasAction } = (0, _gridlist.useGridListItem)({
        node: item,
        isVirtualized: true,
        shouldSelectOnPressUp: isListDraggable
    }, state, rowRef);
    let isDroppable = isListDroppable && !isDisabled;
    let { hoverProps, isHovered } = (0, _interactions.useHover)({
        isDisabled: !allowsSelection && !hasAction
    });
    let { checkboxProps } = (0, _gridlist.useGridListSelectionCheckbox)({
        key: item.key
    }, state);
    let hasDescription = (0, _utils.useHasChild)(`.${(0, _stylesCssDefault.default)["react-spectrum-ListViewItem-description"]}`, rowRef);
    let draggableItem;
    if (isListDraggable) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        draggableItem = dragAndDropHooks.useDraggableItem({
            key: item.key,
            hasDragButton: true
        }, dragState);
        if (isDisabled) draggableItem = null;
    }
    let droppableItem;
    let isDropTarget;
    let dropIndicator;
    let dropIndicatorRef = (0, _react.useRef)();
    if (isListDroppable) {
        let target = {
            type: "item",
            key: item.key,
            dropPosition: "on"
        };
        isDropTarget = dropState.isDropTarget(target);
        // eslint-disable-next-line react-hooks/rules-of-hooks
        dropIndicator = dragAndDropHooks.useDropIndicator({
            target
        }, dropState, dropIndicatorRef);
    }
    let dragButtonRef = (0, _reactDefault.default).useRef();
    let { buttonProps } = (0, _button.useButton)({
        ...draggableItem === null || draggableItem === void 0 ? void 0 : draggableItem.dragButtonProps,
        elementType: "div"
    }, dragButtonRef);
    let chevron = direction === "ltr" ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _chevronRightMediumDefault.default), {
        "aria-hidden": "true",
        UNSAFE_className: (0, _utils.classNames)((0, _stylesCssDefault.default), "react-spectrum-ListViewItem-parentIndicator", {
            "react-spectrum-ListViewItem-parentIndicator--hasChildItems": item.props.hasChildItems,
            "is-disabled": !hasAction
        })
    }) : /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _chevronLeftMediumDefault.default), {
        "aria-hidden": "true",
        UNSAFE_className: (0, _utils.classNames)((0, _stylesCssDefault.default), "react-spectrum-ListViewItem-parentIndicator", {
            "react-spectrum-ListViewItem-parentIndicator--hasChildItems": item.props.hasChildItems,
            "is-disabled": !hasAction
        })
    });
    let showCheckbox = state.selectionManager.selectionMode !== "none" && state.selectionManager.selectionBehavior === "toggle";
    let { visuallyHiddenProps } = (0, _visuallyHidden.useVisuallyHidden)();
    let dropProps = isDroppable ? droppableItem === null || droppableItem === void 0 ? void 0 : droppableItem.dropProps : {
        "aria-hidden": droppableItem === null || droppableItem === void 0 ? void 0 : droppableItem.dropProps["aria-hidden"]
    };
    const mergedProps = (0, _utils1.mergeProps)(rowProps, draggableItem === null || draggableItem === void 0 ? void 0 : draggableItem.dragProps, dropProps, hoverProps, focusWithinProps, focusProps, // Remove tab index from list row if performing a screenreader drag. This prevents TalkBack from focusing the row,
    // allowing for single swipe navigation between row drop indicator
    (dragAndDropHooks === null || dragAndDropHooks === void 0 ? void 0 : dragAndDropHooks.isVirtualDragging()) && {
        tabIndex: null
    });
    let isFirstRow = item.prevKey == null;
    let isLastRow = item.nextKey == null;
    // Figure out if the ListView content is equal or greater in height to the container. If so, we'll need to round the bottom
    // border corners of the last row when selected and we can get rid of the bottom border if it isn't selected to avoid border overlap
    // with bottom border
    let isFlushWithContainerBottom = false;
    if (isLastRow && loadingState !== "loadingMore") {
        if (((_layout_getContentSize = layout.getContentSize()) === null || _layout_getContentSize === void 0 ? void 0 : _layout_getContentSize.height) >= ((_layout_virtualizer = layout.virtualizer) === null || _layout_virtualizer === void 0 ? void 0 : _layout_virtualizer.getVisibleRect().height)) isFlushWithContainerBottom = true;
    }
    // previous item isn't selected
    // and the previous item isn't focused or, if it is focused, then if focus globally isn't visible or just focus isn't in the listview
    let roundTops = !state.selectionManager.isSelected(item.prevKey) && (state.selectionManager.focusedKey !== item.prevKey || !((0, _interactions.isFocusVisible)() && state.selectionManager.isFocused));
    let roundBottoms = !state.selectionManager.isSelected(item.nextKey) && (state.selectionManager.focusedKey !== item.nextKey || !((0, _interactions.isFocusVisible)() && state.selectionManager.isFocused));
    let content = typeof item.rendered === "string" ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, item.rendered) : item.rendered;
    if (isDisabled) content = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _provider.Provider), {
        isDisabled: true
    }, content);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...mergedProps,
        className: (0, _utils.classNames)((0, _stylesCssDefault.default), "react-spectrum-ListView-row", {
            "focus-ring": isFocusVisible,
            "round-tops": roundTops || isHovered && !isSelected && state.selectionManager.focusedKey !== item.key,
            "round-bottoms": roundBottoms || isHovered && !isSelected && state.selectionManager.focusedKey !== item.key
        }),
        ref: rowRef
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        // TODO: refactor the css here now that we are focusing the row?
        className: (0, _utils.classNames)((0, _stylesCssDefault.default), "react-spectrum-ListViewItem", {
            "is-active": isPressed,
            "is-focused": isFocusVisibleWithin,
            "focus-ring": isFocusVisible,
            "is-hovered": isHovered,
            "is-selected": isSelected,
            "is-disabled": isDisabled,
            "is-prev-selected": state.selectionManager.isSelected(item.prevKey),
            "is-next-selected": state.selectionManager.isSelected(item.nextKey),
            "react-spectrum-ListViewItem--highlightSelection": state.selectionManager.selectionBehavior === "replace" && (isSelected || state.selectionManager.isSelected(item.nextKey)),
            "react-spectrum-ListViewItem--dropTarget": !!isDropTarget,
            "react-spectrum-ListViewItem--firstRow": isFirstRow,
            "react-spectrum-ListViewItem--lastRow": isLastRow,
            "react-spectrum-ListViewItem--isFlushBottom": isFlushWithContainerBottom,
            "react-spectrum-ListViewItem--hasDescription": hasDescription
        }),
        ...gridCellProps
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Grid), {
        UNSAFE_className: (0, _stylesCssDefault.default)["react-spectrum-ListViewItem-grid"]
    }, isListDraggable && /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _stylesCssDefault.default)["react-spectrum-ListViewItem-draghandle-container"]
    }, !isDisabled && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _focus.FocusRing), {
        focusRingClass: (0, _utils.classNames)((0, _stylesCssDefault.default), "focus-ring")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...buttonProps,
        className: (0, _utils.classNames)((0, _stylesCssDefault.default), "react-spectrum-ListViewItem-draghandle-button"),
        style: !isFocusVisibleWithin ? {
            ...visuallyHiddenProps.style
        } : {},
        ref: dragButtonRef,
        draggable: "true"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _listGripperDefault.default), null)))), isListDroppable && !(dropIndicator === null || dropIndicator === void 0 ? void 0 : dropIndicator.isHidden) && /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        role: "button",
        ...visuallyHiddenProps,
        ...dropIndicator === null || dropIndicator === void 0 ? void 0 : dropIndicator.dropIndicatorProps,
        ref: dropIndicatorRef
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactTransitionGroup.CSSTransition), {
        in: showCheckbox,
        unmountOnExit: true,
        classNames: {
            enter: (0, _stylesCssDefault.default)["react-spectrum-ListViewItem-checkbox--enter"],
            enterActive: (0, _stylesCssDefault.default)["react-spectrum-ListViewItem-checkbox--enterActive"],
            exit: (0, _stylesCssDefault.default)["react-spectrum-ListViewItem-checkbox--exit"],
            exitActive: (0, _stylesCssDefault.default)["react-spectrum-ListViewItem-checkbox--exitActive"]
        },
        timeout: 160,
        nodeRef: checkboxWrapperRef
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ref: checkboxWrapperRef,
        className: (0, _stylesCssDefault.default)["react-spectrum-ListViewItem-checkboxWrapper"]
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _checkbox.Checkbox), {
        ...checkboxProps,
        UNSAFE_className: (0, _stylesCssDefault.default)["react-spectrum-ListViewItem-checkbox"],
        isEmphasized: isEmphasized
    }))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.SlotProvider), {
        slots: {
            text: {
                UNSAFE_className: (0, _stylesCssDefault.default)["react-spectrum-ListViewItem-content"]
            },
            description: {
                UNSAFE_className: (0, _stylesCssDefault.default)["react-spectrum-ListViewItem-description"],
                ...descriptionProps
            },
            illustration: {
                UNSAFE_className: (0, _stylesCssDefault.default)["react-spectrum-ListViewItem-thumbnail"]
            },
            image: {
                UNSAFE_className: (0, _stylesCssDefault.default)["react-spectrum-ListViewItem-thumbnail"]
            },
            actionButton: {
                UNSAFE_className: (0, _stylesCssDefault.default)["react-spectrum-ListViewItem-actions"],
                isQuiet: true
            },
            actionGroup: {
                UNSAFE_className: (0, _stylesCssDefault.default)["react-spectrum-ListViewItem-actions"],
                isQuiet: true,
                density: "compact"
            },
            actionMenu: {
                UNSAFE_className: (0, _stylesCssDefault.default)["react-spectrum-ListViewItem-actionmenu"],
                isQuiet: true
            }
        }
    }, content, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.ClearSlots), null, chevron)))));
}

},{"@react-spectrum/checkbox":"1r19j","@spectrum-icons/ui/ChevronLeftMedium":"eZUPs","@spectrum-icons/ui/ChevronRightMedium":"6amCu","@react-spectrum/utils":"cMIJ6","react-transition-group":"fvo4w","@react-aria/focus":"42mbF","@react-spectrum/layout":"hzaUY","@react-aria/interactions":"ky3G8","@spectrum-icons/ui/ListGripper":"6Lck0","./styles.css":"dovNV","./ListView":"9X3vR","@react-aria/utils":"9cLk5","@react-spectrum/provider":"5bCdp","react":"9yzVZ","@react-spectrum/text":"etCGI","@react-aria/button":"fsdLZ","@react-aria/gridlist":"g9vQF","@react-aria/i18n":"411rg","@react-aria/visually-hidden":"4jwxT","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"9LZrS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>RootDropIndicator);
var _listView = require("./ListView");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _visuallyHidden = require("@react-aria/visually-hidden");
function RootDropIndicator() {
    let { dropState, dragAndDropHooks } = (0, _react.useContext)((0, _listView.ListViewContext));
    let ref = (0, _react.useRef)();
    let { dropIndicatorProps } = dragAndDropHooks.useDropIndicator({
        target: {
            type: "root"
        }
    }, dropState, ref);
    let isDropTarget = dropState.isDropTarget({
        type: "root"
    });
    let { visuallyHiddenProps } = (0, _visuallyHidden.useVisuallyHidden)();
    if (!isDropTarget && dropIndicatorProps["aria-hidden"]) return null;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        role: "row",
        "aria-hidden": dropIndicatorProps["aria-hidden"]
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        role: "gridcell",
        "aria-selected": "false"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        role: "button",
        ...visuallyHiddenProps,
        ...dropIndicatorProps,
        ref: ref
    })));
}

},{"./ListView":"9X3vR","react":"9yzVZ","@react-aria/visually-hidden":"4jwxT","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"1BVOK":[function(require,module,exports) {
/*
 * Copyright 2021 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DragPreview", ()=>DragPreview);
var _utils = require("@react-spectrum/utils");
var _layout = require("@react-spectrum/layout");
var _stylesCss = require("./styles.css");
var _stylesCssDefault = parcelHelpers.interopDefault(_stylesCss);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _text = require("@react-spectrum/text");
function DragPreview(props) {
    let { item, itemCount, itemHeight, density } = props;
    let isDraggingMultiple = itemCount > 1;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        style: {
            height: itemHeight
        },
        className: (0, _utils.classNames)((0, _stylesCssDefault.default), "react-spectrum-ListViewItem", "react-spectrum-ListViewItem-dragPreview", {
            "react-spectrum-ListViewItem-dragPreview--multiple": isDraggingMultiple
        }, `react-spectrum-ListViewItem-dragPreview--${density}`)
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Grid), {
        UNSAFE_className: (0, _stylesCssDefault.default)["react-spectrum-ListViewItem-grid"]
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.SlotProvider), {
        slots: {
            text: {
                UNSAFE_className: (0, _stylesCssDefault.default)["react-spectrum-ListViewItem-content"]
            },
            description: {
                UNSAFE_className: (0, _stylesCssDefault.default)["react-spectrum-ListViewItem-description"]
            },
            illustration: {
                UNSAFE_className: (0, _stylesCssDefault.default)["react-spectrum-ListViewItem-thumbnail"]
            },
            image: {
                UNSAFE_className: (0, _stylesCssDefault.default)["react-spectrum-ListViewItem-thumbnail"]
            },
            actionButton: {
                UNSAFE_className: (0, _stylesCssDefault.default)["react-spectrum-ListViewItem-actions"],
                isQuiet: true
            },
            actionGroup: {
                UNSAFE_className: (0, _stylesCssDefault.default)["react-spectrum-ListViewItem-actions"],
                isQuiet: true,
                density: "compact"
            },
            actionMenu: {
                UNSAFE_className: (0, _stylesCssDefault.default)["react-spectrum-ListViewItem-actionmenu"],
                isQuiet: true
            }
        }
    }, typeof item.rendered === "string" ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, item.rendered) : item.rendered, isDraggingMultiple && /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _utils.classNames)((0, _stylesCssDefault.default), "react-spectrum-ListViewItem-badge")
    }, itemCount))));
}

},{"@react-spectrum/utils":"cMIJ6","@react-spectrum/layout":"hzaUY","./styles.css":"dovNV","react":"9yzVZ","@react-spectrum/text":"etCGI","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"dDZDm":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /// <reference types="css-module-types" />
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Meter", ()=>(0, _meter.Meter));
var _meter = require("./Meter");

},{"./Meter":"14Dak","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"14Dak":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Meter", ()=>_Meter);
var _utils = require("@react-spectrum/utils");
var _progress = require("@react-spectrum/progress");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _varsCss = require("@adobe/spectrum-css-temp/components/barloader/vars.css");
var _varsCssDefault = parcelHelpers.interopDefault(_varsCss);
var _meter = require("@react-aria/meter");
function Meter(props, ref) {
    let { variant, ...otherProps } = props;
    const { meterProps, labelProps } = (0, _meter.useMeter)(props);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _progress.ProgressBarBase), {
        ...otherProps,
        ref: ref,
        barProps: meterProps,
        labelProps: labelProps,
        barClassName: (0, _utils.classNames)((0, _varsCssDefault.default), {
            "is-positive": variant === "positive",
            "is-warning": variant === "warning",
            "is-critical": variant === "critical"
        })
    });
}
/**
 * Meters are visual representations of a quantity or an achievement.
 * Their progress is determined by user actions, rather than system actions.
 */ let _Meter = /*#__PURE__*/ (0, _reactDefault.default).forwardRef(Meter);

},{"@react-spectrum/utils":"cMIJ6","@react-spectrum/progress":"4kHa7","react":"9yzVZ","@adobe/spectrum-css-temp/components/barloader/vars.css":"k8y65","@react-aria/meter":"9oBtl","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"cMsXx":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /// <reference types="css-module-types" />
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NumberField", ()=>(0, _numberField.NumberField));
var _numberField = require("./NumberField");

},{"./NumberField":"eZ1IQ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"eZ1IQ":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NumberField", ()=>_NumberField);
var _utils = require("@react-spectrum/utils");
var _label = require("@react-spectrum/label");
var _focus = require("@react-aria/focus");
var _utils1 = require("@react-aria/utils");
var _numberfield = require("@react-stately/numberfield");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _stepButton = require("./StepButton");
var _varsCss = require("@adobe/spectrum-css-temp/components/stepper/vars.css");
var _varsCssDefault = parcelHelpers.interopDefault(_varsCss);
var _textfield = require("@react-spectrum/textfield");
var _form = require("@react-spectrum/form");
var _interactions = require("@react-aria/interactions");
var _i18N = require("@react-aria/i18n");
var _numberfield1 = require("@react-aria/numberfield");
var _provider = require("@react-spectrum/provider");
function NumberField(props, ref) {
    props = (0, _provider.useProviderProps)(props);
    props = (0, _form.useFormProps)(props);
    let provider = (0, _provider.useProvider)();
    let { isQuiet, isReadOnly, isDisabled, hideStepper } = props;
    let { styleProps: style } = (0, _utils.useStyleProps)(props);
    let { locale } = (0, _i18N.useLocale)();
    let state = (0, _numberfield.useNumberFieldState)({
        ...props,
        locale
    });
    let inputRef = (0, _react.useRef)(null);
    let domRef = (0, _utils.useFocusableRef)(ref, inputRef);
    let { groupProps, labelProps, inputProps, incrementButtonProps, decrementButtonProps, descriptionProps, errorMessageProps, isInvalid, validationErrors, validationDetails } = (0, _numberfield1.useNumberField)(props, state, inputRef);
    let isMobile = provider.scale === "large";
    let showStepper = !hideStepper;
    let { isHovered, hoverProps } = (0, _interactions.useHover)({
        isDisabled
    });
    let validationState = props.validationState || (isInvalid ? "invalid" : undefined);
    let className = (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Stepper", // because FocusRing won't pass along the className from Field, we have to handle that ourselves
    !props.label && style.className ? style.className : "", {
        "spectrum-Stepper--isQuiet": isQuiet,
        "is-disabled": isDisabled,
        "spectrum-Stepper--readonly": isReadOnly,
        "is-invalid": validationState === "invalid" && !isDisabled,
        "spectrum-Stepper--showStepper": showStepper,
        "spectrum-Stepper--isMobile": isMobile,
        "is-hovered": isHovered
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _label.Field), {
        ...props,
        descriptionProps: descriptionProps,
        errorMessageProps: errorMessageProps,
        isInvalid: isInvalid,
        validationErrors: validationErrors,
        validationDetails: validationDetails,
        labelProps: labelProps,
        ref: domRef,
        wrapperClassName: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Stepper-container", {
            "spectrum-Stepper-container--isMobile": isMobile
        })
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(NumberFieldInput, {
        ...props,
        groupProps: (0, _utils1.mergeProps)(groupProps, hoverProps),
        inputProps: inputProps,
        inputRef: inputRef,
        incrementProps: incrementButtonProps,
        decrementProps: decrementButtonProps,
        className: className,
        style: style,
        state: state,
        validationState: validationState
    }));
}
const NumberFieldInput = /*#__PURE__*/ (0, _reactDefault.default).forwardRef(function NumberFieldInput(props, ref) {
    let { groupProps, inputProps, inputRef, incrementProps, decrementProps, className, style, autoFocus, isQuiet, isDisabled, hideStepper, validationState, name, state } = props;
    let showStepper = !hideStepper;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _focus.FocusRing), {
        within: true,
        isTextInput: true,
        focusClass: (0, _utils.classNames)((0, _varsCssDefault.default), "is-focused"),
        focusRingClass: (0, _utils.classNames)((0, _varsCssDefault.default), "focus-ring"),
        autoFocus: autoFocus
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...groupProps,
        ref: ref,
        style: style,
        className: className
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textfield.TextFieldBase), {
        UNSAFE_className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Stepper-field"),
        inputClassName: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Stepper-input"),
        validationIconClassName: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Stepper-icon"),
        isQuiet: isQuiet,
        inputRef: inputRef,
        validationState: validationState,
        inputProps: inputProps,
        isDisabled: isDisabled,
        disableFocusRing: true
    }), showStepper && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _stepButton.StepButton), {
        direction: "up",
        isQuiet: isQuiet,
        ...incrementProps
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _stepButton.StepButton), {
        direction: "down",
        isQuiet: isQuiet,
        ...decrementProps
    })), name && /*#__PURE__*/ (0, _reactDefault.default).createElement("input", {
        type: "hidden",
        name: name,
        value: isNaN(state.numberValue) ? "" : state.numberValue
    })));
});
/**
 * NumberFields allow users to enter a number, and increment or decrement the value using stepper buttons.
 */ let _NumberField = /*#__PURE__*/ (0, _reactDefault.default).forwardRef(NumberField);

},{"@react-spectrum/utils":"cMIJ6","@react-spectrum/label":"6qv6N","@react-aria/focus":"42mbF","@react-aria/utils":"9cLk5","@react-stately/numberfield":"l3Rr3","react":"9yzVZ","./StepButton":"p8wjF","@adobe/spectrum-css-temp/components/stepper/vars.css":"kOXY0","@react-spectrum/textfield":"hOmtq","@react-spectrum/form":"bGDqA","@react-aria/interactions":"ky3G8","@react-aria/i18n":"411rg","@react-aria/numberfield":"13aeo","@react-spectrum/provider":"5bCdp","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"p8wjF":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StepButton", ()=>_StepButton);
var _add = require("@spectrum-icons/workflow/Add");
var _addDefault = parcelHelpers.interopDefault(_add);
var _chevronDownSmall = require("@spectrum-icons/ui/ChevronDownSmall");
var _chevronDownSmallDefault = parcelHelpers.interopDefault(_chevronDownSmall);
var _chevronUpSmall = require("@spectrum-icons/ui/ChevronUpSmall");
var _chevronUpSmallDefault = parcelHelpers.interopDefault(_chevronUpSmall);
var _utils = require("@react-spectrum/utils");
var _focus = require("@react-aria/focus");
var _utils1 = require("@react-aria/utils");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _remove = require("@spectrum-icons/workflow/Remove");
var _removeDefault = parcelHelpers.interopDefault(_remove);
var _varsCss = require("@adobe/spectrum-css-temp/components/stepper/vars.css");
var _varsCssDefault = parcelHelpers.interopDefault(_varsCss);
var _button = require("@react-aria/button");
var _interactions = require("@react-aria/interactions");
var _provider = require("@react-spectrum/provider");
function StepButton(props, ref) {
    props = (0, _provider.useProviderProps)(props);
    let { scale } = (0, _provider.useProvider)();
    let { direction, isDisabled, isQuiet } = props;
    let domRef = (0, _utils.useFocusableRef)(ref);
    /**
   * Must use div for now because Safari pointer event bugs on disabled form elements.
   * Link https://bugs.webkit.org/show_bug.cgi?id=219188.
   */ let { buttonProps, isPressed } = (0, _button.useButton)({
        ...props,
        elementType: "div"
    }, domRef);
    let { hoverProps, isHovered } = (0, _interactions.useHover)(props);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _focus.FocusRing), {
        focusRingClass: (0, _utils.classNames)((0, _varsCssDefault.default), "focus-ring")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Stepper-button", {
            "spectrum-Stepper-button--stepUp": direction === "up",
            "spectrum-Stepper-button--stepDown": direction === "down",
            "spectrum-Stepper-button--isQuiet": isQuiet,
            "is-hovered": isHovered,
            "is-active": isPressed,
            "is-disabled": isDisabled
        }),
        ...(0, _utils1.mergeProps)(hoverProps, buttonProps),
        ref: domRef
    }, direction === "up" && scale === "large" && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _addDefault.default), {
        UNSAFE_className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Stepper-button-icon", "spectrum-Stepper-stepUpIcon"),
        size: "S"
    }), direction === "up" && scale === "medium" && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _chevronUpSmallDefault.default), {
        UNSAFE_className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Stepper-button-icon", "spectrum-Stepper-stepUpIcon")
    }), direction === "down" && scale === "large" && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _removeDefault.default), {
        UNSAFE_className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Stepper-button-icon", "spectrum-Stepper-stepDownIcon"),
        size: "S"
    }), direction === "down" && scale === "medium" && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _chevronDownSmallDefault.default), {
        UNSAFE_className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Stepper-button-icon", "spectrum-Stepper-stepDownIcon")
    })));
}
/**
 * Buttons for NumberField.
 */ let _StepButton = /*#__PURE__*/ (0, _reactDefault.default).forwardRef(StepButton);

},{"@spectrum-icons/workflow/Add":"evYih","@spectrum-icons/ui/ChevronDownSmall":"e8FOu","@spectrum-icons/ui/ChevronUpSmall":"bXpYe","@react-spectrum/utils":"cMIJ6","@react-aria/focus":"42mbF","@react-aria/utils":"9cLk5","react":"9yzVZ","@spectrum-icons/workflow/Remove":"1LCxt","@adobe/spectrum-css-temp/components/stepper/vars.css":"kOXY0","@react-aria/button":"fsdLZ","@react-aria/interactions":"ky3G8","@react-spectrum/provider":"5bCdp","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"e8FOu":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("50b885ca978af89");
exports.__esModule = true;
exports.default = ChevronDownSmall;
var _ChevronDownSmall = require("ba49129b33b57120");
var _icon = require("b6bf4bd2ad4b2f79");
var _react = _interopRequireDefault(require("97a43e97273f1d5b"));
function ChevronDownSmall(props) {
    return /*#__PURE__*/ _react.default.createElement(_icon.UIIcon, props, /*#__PURE__*/ _react.default.createElement(_ChevronDownSmall.ChevronDownSmall, null));
}

},{"50b885ca978af89":"iHubQ","ba49129b33b57120":"5Y0Wc","b6bf4bd2ad4b2f79":"k7wem","97a43e97273f1d5b":"9yzVZ"}],"5Y0Wc":[function(require,module,exports) {
/**
* @adobe/react-spectrum-ui (c) by Adobe
* 
* @adobe/react-spectrum-ui is licensed under a
* Creative Commons Attribution-NoDerivatives 4.0 International License.
* 
* You should have received a copy of the license along with this
* work. If not, see <http://creativecommons.org/licenses/by-nd/4.0/>.
**/ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ChevronDownSmall = ChevronDownSmall;
var _react = _interopRequireDefault(require("189b05de4f7aaf42"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function ChevronDownSmall(_ref) {
    var _ref$scale = _ref.scale, scale = _ref$scale === void 0 ? "M" : _ref$scale, props = _objectWithoutProperties(_ref, [
        "scale"
    ]);
    return _react["default"].createElement("svg", _extends({}, props, props), scale === "L" && _react["default"].createElement("path", {
        d: "M5 7a.747.747 0 0 0 .53-.22l4.24-4.24a.75.75 0 1 0-1.06-1.06L5 5.19 1.29 1.48A.75.75 0 1 0 .23 2.54l4.24 4.24A.747.747 0 0 0 5 7z"
    }), scale === "M" && _react["default"].createElement("path", {
        d: "M4 5.5a.747.747 0 0 0 .53-.22c.607-.577 1.97-2.038 3.24-3.24A.75.75 0 1 0 6.71.98L4 3.69 1.29.98A.75.75 0 1 0 .23 2.04l3.24 3.24A.747.747 0 0 0 4 5.5z"
    }));
}
ChevronDownSmall.displayName = "ChevronDownSmall";

},{"189b05de4f7aaf42":"9yzVZ"}],"bXpYe":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("49c249b5f63b09ec");
exports.__esModule = true;
exports.default = ChevronUpSmall;
var _ChevronUpSmall = require("465fd05802d90303");
var _icon = require("db500146ac778f47");
var _react = _interopRequireDefault(require("ff22b63a354f70ac"));
function ChevronUpSmall(props) {
    return /*#__PURE__*/ _react.default.createElement(_icon.UIIcon, props, /*#__PURE__*/ _react.default.createElement(_ChevronUpSmall.ChevronUpSmall, null));
}

},{"49c249b5f63b09ec":"iHubQ","465fd05802d90303":"e6NZh","db500146ac778f47":"k7wem","ff22b63a354f70ac":"9yzVZ"}],"e6NZh":[function(require,module,exports) {
/**
* @adobe/react-spectrum-ui (c) by Adobe
* 
* @adobe/react-spectrum-ui is licensed under a
* Creative Commons Attribution-NoDerivatives 4.0 International License.
* 
* You should have received a copy of the license along with this
* work. If not, see <http://creativecommons.org/licenses/by-nd/4.0/>.
**/ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ChevronUpSmall = ChevronUpSmall;
var _react = _interopRequireDefault(require("7c33de7de0e5dcb9"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function ChevronUpSmall(_ref) {
    var _ref$scale = _ref.scale, scale = _ref$scale === void 0 ? "M" : _ref$scale, props = _objectWithoutProperties(_ref, [
        "scale"
    ]);
    return _react["default"].createElement("svg", _extends({}, props, props), scale === "L" && _react["default"].createElement("path", {
        d: "M5 1a.747.747 0 0 0-.53.22L.23 5.46a.75.75 0 1 0 1.06 1.06L5 2.81l3.71 3.71a.75.75 0 1 0 1.06-1.06L5.53 1.22A.747.747 0 0 0 5 1z"
    }), scale === "M" && _react["default"].createElement("path", {
        d: "M4 .5a.747.747 0 0 0-.53.22C2.862 1.297 1.5 2.758.23 3.96a.75.75 0 1 0 1.06 1.06L4 2.31l2.71 2.71a.75.75 0 1 0 1.06-1.06L4.53.72A.747.747 0 0 0 4 .5z"
    }));
}
ChevronUpSmall.displayName = "ChevronUpSmall";

},{"7c33de7de0e5dcb9":"9yzVZ"}],"1LCxt":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("28ee6d3d393489c8");
exports.__esModule = true;
exports.default = Remove;
var _Remove = require("2e217326d5332744");
var _icon = require("88d32e40dad9fff2");
var _react = _interopRequireDefault(require("4beda93a0a5ac987"));
function Remove(props) {
    return /*#__PURE__*/ _react.default.createElement(_icon.Icon, props, /*#__PURE__*/ _react.default.createElement(_Remove.A4uRemove, null));
}

},{"28ee6d3d393489c8":"iHubQ","2e217326d5332744":"4wo2E","88d32e40dad9fff2":"k7wem","4beda93a0a5ac987":"9yzVZ"}],"4wo2E":[function(require,module,exports) {
/**
* @adobe/react-spectrum-workflow (c) by Adobe
* 
* @adobe/react-spectrum-workflow is licensed under a
* Creative Commons Attribution-NoDerivatives 4.0 International License.
* 
* You should have received a copy of the license along with this
* work. If not, see <http://creativecommons.org/licenses/by-nd/4.0/>.
**/ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.A4uRemove = A4uRemove;
var _react = _interopRequireDefault(require("51497fb51325c04e"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function A4uRemove(_ref) {
    var props = _extends({}, _ref);
    return /*#__PURE__*/ _react["default"].createElement("svg", _extends({
        viewBox: "0 0 36 36"
    }, props, props), /*#__PURE__*/ _react["default"].createElement("rect", {
        fillRule: "evenodd",
        height: "4",
        rx: "1",
        ry: "1",
        width: "24",
        x: "6",
        y: "16"
    }));
}

},{"51497fb51325c04e":"9yzVZ"}],"kOXY0":[function(require,module,exports) {
module.exports["decrement"] = `Ug6T-W_decrement`;
module.exports["field"] = `Ug6T-W_field`;
module.exports["focus-ring"] = `Ug6T-W_focus-ring`;
module.exports["i18nFontFamily"] = `Ug6T-W_i18nFontFamily`;
module.exports["increment"] = `Ug6T-W_increment`;
module.exports["is-active"] = `Ug6T-W_is-active`;
module.exports["is-disabled"] = `Ug6T-W_is-disabled`;
module.exports["is-focused"] = `Ug6T-W_is-focused`;
module.exports["is-hovered"] = `Ug6T-W_is-hovered`;
module.exports["is-invalid"] = `Ug6T-W_is-invalid`;
module.exports["is-open"] = `Ug6T-W_is-open`;
module.exports["spectrum-BaseButton"] = `Ug6T-W_spectrum-BaseButton ${module.exports["i18nFontFamily"]}`;
module.exports["spectrum-FocusRing-ring"] = `Ug6T-W_spectrum-FocusRing-ring`;
module.exports["spectrum-FocusRing"] = `Ug6T-W_spectrum-FocusRing ${module.exports["spectrum-FocusRing-ring"]}`;
module.exports["spectrum-ActionButton"] = `Ug6T-W_spectrum-ActionButton ${module.exports["spectrum-BaseButton"]} ${module.exports["spectrum-FocusRing"]}`;
module.exports["spectrum-ActionButton--quiet"] = `Ug6T-W_spectrum-ActionButton--quiet`;
module.exports["spectrum-ActionButton-hold"] = `Ug6T-W_spectrum-ActionButton-hold`;
module.exports["spectrum-ActionButton-label"] = `Ug6T-W_spectrum-ActionButton-label`;
module.exports["spectrum-Button"] = `Ug6T-W_spectrum-Button ${module.exports["spectrum-BaseButton"]} ${module.exports["spectrum-FocusRing"]}`;
module.exports["spectrum-Button--iconOnly"] = `Ug6T-W_spectrum-Button--iconOnly`;
module.exports["spectrum-Button--pending"] = `Ug6T-W_spectrum-Button--pending`;
module.exports["spectrum-Button-circleLoader"] = `Ug6T-W_spectrum-Button-circleLoader`;
module.exports["spectrum-Button-label"] = `Ug6T-W_spectrum-Button-label`;
module.exports["spectrum-ClearButton"] = `Ug6T-W_spectrum-ClearButton ${module.exports["spectrum-BaseButton"]} ${module.exports["spectrum-FocusRing"]}`;
module.exports["spectrum-ClearButton--small"] = `Ug6T-W_spectrum-ClearButton--small`;
module.exports["spectrum-FieldButton"] = `Ug6T-W_spectrum-FieldButton ${module.exports["spectrum-BaseButton"]} ${module.exports["spectrum-FocusRing"]}`;
module.exports["spectrum-FocusRing--quiet"] = `Ug6T-W_spectrum-FocusRing--quiet`;
module.exports["spectrum-FieldButton--quiet"] = `Ug6T-W_spectrum-FieldButton--quiet ${module.exports["spectrum-FocusRing--quiet"]}`;
module.exports["spectrum-Icon"] = `Ug6T-W_spectrum-Icon`;
module.exports["spectrum-LogicButton"] = `Ug6T-W_spectrum-LogicButton ${module.exports["spectrum-BaseButton"]} ${module.exports["spectrum-FocusRing"]}`;
module.exports["spectrum-Stepper"] = `Ug6T-W_spectrum-Stepper ${module.exports["spectrum-FocusRing"]}`;
module.exports["spectrum-Stepper--isMobile"] = `Ug6T-W_spectrum-Stepper--isMobile`;
module.exports["spectrum-Stepper--isQuiet"] = `Ug6T-W_spectrum-Stepper--isQuiet ${module.exports["spectrum-FocusRing--quiet"]}`;
module.exports["spectrum-Stepper--readonly"] = `Ug6T-W_spectrum-Stepper--readonly`;
module.exports["spectrum-Stepper--showStepper"] = `Ug6T-W_spectrum-Stepper--showStepper`;
module.exports["spectrum-Stepper-button"] = `Ug6T-W_spectrum-Stepper-button ${module.exports["spectrum-BaseButton"]}`;
module.exports["spectrum-Stepper-button--stepDown"] = `Ug6T-W_spectrum-Stepper-button--stepDown`;
module.exports["spectrum-Stepper-button--stepUp"] = `Ug6T-W_spectrum-Stepper-button--stepUp`;
module.exports["spectrum-Stepper-button-icon"] = `Ug6T-W_spectrum-Stepper-button-icon`;
module.exports["spectrum-Stepper-container"] = `Ug6T-W_spectrum-Stepper-container`;
module.exports["spectrum-Stepper-container--isMobile"] = `Ug6T-W_spectrum-Stepper-container--isMobile`;
module.exports["spectrum-Stepper-field"] = `Ug6T-W_spectrum-Stepper-field`;
module.exports["spectrum-Stepper-icon"] = `Ug6T-W_spectrum-Stepper-icon`;
module.exports["spectrum-Stepper-input"] = `Ug6T-W_spectrum-Stepper-input`;

},{}],"kL1Uy":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /// <reference types="css-module-types" />
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Picker", ()=>(0, _picker.Picker));
parcelHelpers.export(exports, "Item", ()=>(0, _collections.Item));
parcelHelpers.export(exports, "Section", ()=>(0, _collections.Section));
var _picker = require("./Picker");
var _collections = require("@react-stately/collections");

},{"./Picker":"7wXq8","@react-stately/collections":"loANi","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"7wXq8":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Picker", ()=>_Picker);
var _alertMedium = require("@spectrum-icons/ui/AlertMedium");
var _alertMediumDefault = parcelHelpers.interopDefault(_alertMedium);
var _chevronDownMedium = require("@spectrum-icons/ui/ChevronDownMedium");
var _chevronDownMediumDefault = parcelHelpers.interopDefault(_chevronDownMedium);
var _utils = require("@react-spectrum/utils");
var _label = require("@react-spectrum/label");
var _button = require("@react-spectrum/button");
var _select = require("@react-aria/select");
// @ts-ignore
var _json = require("../intl/*.json");
var _jsonDefault = parcelHelpers.interopDefault(_json);
var _listbox = require("@react-spectrum/listbox");
var _utils1 = require("@react-aria/utils");
var _overlays = require("@react-spectrum/overlays");
var _interactions = require("@react-aria/interactions");
var _progress = require("@react-spectrum/progress");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _varsCss = require("@adobe/spectrum-css-temp/components/dropdown/vars.css");
var _varsCssDefault = parcelHelpers.interopDefault(_varsCss);
var _text = require("@react-spectrum/text");
var _form = require("@react-spectrum/form");
var _i18N = require("@react-aria/i18n");
var _provider = require("@react-spectrum/provider");
var _select1 = require("@react-stately/select");
function Picker(props, ref) {
    props = (0, _utils.useSlotProps)(props, "picker");
    props = (0, _provider.useProviderProps)(props);
    props = (0, _form.useFormProps)(props);
    let stringFormatter = (0, _i18N.useLocalizedStringFormatter)((0, _jsonDefault.default), "@react-spectrum/picker");
    let { autoComplete, isDisabled, direction = "bottom", align = "start", shouldFlip = true, placeholder = stringFormatter.format("placeholder"), isQuiet, label, labelPosition = "top", menuWidth, name, autoFocus } = props;
    let state = (0, _select1.useSelectState)(props);
    let domRef = (0, _utils.useDOMRef)(ref);
    let popoverRef = (0, _react.useRef)();
    let triggerRef = (0, _react.useRef)();
    let unwrappedTriggerRef = (0, _utils.useUnwrapDOMRef)(triggerRef);
    let listboxRef = (0, _react.useRef)();
    let isLoadingInitial = props.isLoading && state.collection.size === 0;
    let isLoadingMore = props.isLoading && state.collection.size > 0;
    let progressCircleId = (0, _utils1.useId)();
    // We create the listbox layout in Picker and pass it to ListBoxBase below
    // so that the layout information can be cached even while the listbox is not mounted.
    // We also use the layout as the keyboard delegate for type to select.
    let layout = (0, _listbox.useListBoxLayout)(state, isLoadingMore);
    let { labelProps, triggerProps, valueProps, menuProps, descriptionProps, errorMessageProps, isInvalid, validationErrors, validationDetails } = (0, _select.useSelect)({
        ...props,
        "aria-describedby": isLoadingInitial ? progressCircleId : undefined,
        keyboardDelegate: layout
    }, state, unwrappedTriggerRef);
    let isMobile = (0, _utils.useIsMobileDevice)();
    let { hoverProps, isHovered } = (0, _interactions.useHover)({
        isDisabled
    });
    // On small screen devices, the listbox is rendered in a tray, otherwise a popover.
    let listbox = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _listbox.ListBoxBase), {
        ...menuProps,
        ref: listboxRef,
        disallowEmptySelection: true,
        autoFocus: state.focusStrategy || true,
        shouldSelectOnPressUp: true,
        focusOnPointerEnter: true,
        layout: layout,
        state: state,
        width: isMobile ? "100%" : undefined,
        // Set max height: inherit so Tray scrolling works
        UNSAFE_style: {
            maxHeight: "inherit"
        },
        isLoading: props.isLoading,
        onLoadMore: props.onLoadMore
    });
    // Measure the width of the button to inform the width of the menu (below).
    let [buttonWidth, setButtonWidth] = (0, _react.useState)(null);
    let { scale } = (0, _provider.useProvider)();
    let onResize = (0, _react.useCallback)(()=>{
        if (!isMobile && unwrappedTriggerRef.current) {
            let width = unwrappedTriggerRef.current.offsetWidth;
            setButtonWidth(width);
        }
    }, [
        unwrappedTriggerRef,
        setButtonWidth,
        isMobile
    ]);
    (0, _utils1.useResizeObserver)({
        ref: unwrappedTriggerRef,
        onResize: onResize
    });
    (0, _utils1.useLayoutEffect)(onResize, [
        scale,
        state.selectedKey,
        onResize
    ]);
    let overlay;
    if (isMobile) overlay = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _overlays.Tray), {
        state: state
    }, listbox);
    else {
        // If quiet, use the default width, otherwise match the width of the button. This can be overridden by the menuWidth prop.
        // Always have a minimum width of the button width. When quiet, there is an extra offset to add.
        // Not using style props for this because they don't support `calc`.
        let width = isQuiet ? null : buttonWidth;
        let style = {
            width: menuWidth ? (0, _utils.dimensionValue)(menuWidth) : width,
            minWidth: isQuiet ? `calc(${buttonWidth}px + calc(2 * var(--spectrum-dropdown-quiet-offset)))` : buttonWidth
        };
        overlay = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _overlays.Popover), {
            UNSAFE_style: style,
            UNSAFE_className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Dropdown-popover", {
                "spectrum-Dropdown-popover--quiet": isQuiet
            }),
            ref: popoverRef,
            placement: `${direction} ${align}`,
            shouldFlip: shouldFlip,
            hideArrow: true,
            state: state,
            triggerRef: unwrappedTriggerRef,
            scrollRef: listboxRef
        }, listbox);
    }
    let contents = state.selectedItem ? state.selectedItem.rendered : placeholder;
    if (typeof contents === "string") contents = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, contents);
    let picker = /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Dropdown", {
            "is-invalid": isInvalid && !isDisabled,
            "is-disabled": isDisabled,
            "spectrum-Dropdown--quiet": isQuiet
        })
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _select.HiddenSelect), {
        autoComplete: autoComplete,
        isDisabled: isDisabled,
        state: state,
        triggerRef: unwrappedTriggerRef,
        label: label,
        name: name
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _interactions.PressResponder), (0, _utils1.mergeProps)(hoverProps, triggerProps), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.FieldButton), {
        ref: triggerRef,
        isActive: state.isOpen,
        isQuiet: isQuiet,
        isDisabled: isDisabled,
        isInvalid: isInvalid,
        autoFocus: autoFocus,
        UNSAFE_className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Dropdown-trigger", {
            "is-hovered": isHovered
        })
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.SlotProvider), {
        slots: {
            icon: {
                UNSAFE_className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Icon"),
                size: "S"
            },
            avatar: {
                UNSAFE_className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Dropdown-avatar"),
                size: "avatar-size-100"
            },
            text: {
                ...valueProps,
                UNSAFE_className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Dropdown-label", {
                    "is-placeholder": !state.selectedItem
                })
            },
            description: {
                isHidden: true
            }
        }
    }, contents), isLoadingInitial && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _progress.ProgressCircle), {
        id: progressCircleId,
        isIndeterminate: true,
        size: "S",
        "aria-label": stringFormatter.format("loading"),
        UNSAFE_className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Dropdown-progressCircle")
    }), isInvalid && !isLoadingInitial && !isDisabled && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _alertMediumDefault.default), {
        UNSAFE_className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Dropdown-invalidIcon")
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _chevronDownMediumDefault.default), {
        UNSAFE_className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Dropdown-chevron")
    }))), state.collection.size === 0 ? null : overlay);
    let wrapperClassName = (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Field", {
        "spectrum-Dropdown-fieldWrapper--quiet": isQuiet,
        "spectrum-Dropdown-fieldWrapper--positionSide": labelPosition === "side"
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _label.Field), {
        ...props,
        ref: domRef,
        wrapperClassName: wrapperClassName,
        labelProps: labelProps,
        descriptionProps: descriptionProps,
        errorMessageProps: errorMessageProps,
        isInvalid: isInvalid,
        validationErrors: validationErrors,
        validationDetails: validationDetails,
        showErrorIcon: false,
        includeNecessityIndicatorInAccessibilityName: true,
        elementType: "span"
    }, picker);
}
/**
 * Pickers allow users to choose a single option from a collapsible list of options when space is limited.
 */ // forwardRef doesn't support generic parameters, so cast the result to the correct type
// https://stackoverflow.com/questions/58469229/react-with-typescript-generics-while-using-react-forwardref
const _Picker = /*#__PURE__*/ (0, _reactDefault.default).forwardRef(Picker);

},{"@spectrum-icons/ui/AlertMedium":"2v5QX","@spectrum-icons/ui/ChevronDownMedium":"bWUHC","@react-spectrum/utils":"cMIJ6","@react-spectrum/label":"6qv6N","@react-spectrum/button":"jZWyP","@react-aria/select":"l1sFE","../intl/*.json":"bwwbW","@react-spectrum/listbox":"kF7kO","@react-aria/utils":"9cLk5","@react-spectrum/overlays":"3nwGn","@react-aria/interactions":"ky3G8","@react-spectrum/progress":"4kHa7","react":"9yzVZ","@adobe/spectrum-css-temp/components/dropdown/vars.css":"hAeyH","@react-spectrum/text":"etCGI","@react-spectrum/form":"bGDqA","@react-aria/i18n":"411rg","@react-spectrum/provider":"5bCdp","@react-stately/select":"4LWw9","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"bwwbW":[function(require,module,exports) {
const _temp0 = require("1dca920796bf63c4");
const _temp1 = require("41bbce685f5a8d46");
const _temp2 = require("849d275d40cd7b2d");
const _temp3 = require("cc96906ba853325c");
const _temp4 = require("fe6991d5eb574c29");
const _temp5 = require("456557122c0055e3");
const _temp6 = require("77db0a925d2a4294");
const _temp7 = require("ee87d092265a91ca");
const _temp8 = require("718b1c7713d76dae");
const _temp9 = require("1eaa0991875ea5fe");
const _temp10 = require("bd93dde90b2c0869");
const _temp11 = require("a5b23df35caf61ec");
const _temp12 = require("3d8119ed6d47a94e");
const _temp13 = require("40ed09f50411e33d");
const _temp14 = require("e2478af2ce7e8278");
const _temp15 = require("9820c1bae33fc391");
const _temp16 = require("5a581cae354e40ad");
const _temp17 = require("43fd79b9a301c10");
const _temp18 = require("cd61bfcf4f577c45");
const _temp19 = require("d59a6ce25a788f6e");
const _temp20 = require("c473919f505b4a0b");
const _temp21 = require("9148250fb321bdbb");
const _temp22 = require("c0b03f6db07aa3bb");
const _temp23 = require("ace9a513870e5de");
const _temp24 = require("4ecb720406d1c1de");
const _temp25 = require("b5b6a13903168c3f");
const _temp26 = require("2d7fdf039c0ccd49");
const _temp27 = require("353017d26c3bb990");
const _temp28 = require("2f917dcb202f3f72");
const _temp29 = require("c00de4e83efcec0b");
const _temp30 = require("64ded31cb33a0e31");
const _temp31 = require("a62af1a073068cdc");
const _temp32 = require("578bfc78920a66d5");
const _temp33 = require("d7341ec69c2ed386");
module.exports = {
    "ar-AE": _temp0,
    "bg-BG": _temp1,
    "cs-CZ": _temp2,
    "da-DK": _temp3,
    "de-DE": _temp4,
    "el-GR": _temp5,
    "en-US": _temp6,
    "es-ES": _temp7,
    "et-EE": _temp8,
    "fi-FI": _temp9,
    "fr-FR": _temp10,
    "he-IL": _temp11,
    "hr-HR": _temp12,
    "hu-HU": _temp13,
    "it-IT": _temp14,
    "ja-JP": _temp15,
    "ko-KR": _temp16,
    "lt-LT": _temp17,
    "lv-LV": _temp18,
    "nb-NO": _temp19,
    "nl-NL": _temp20,
    "pl-PL": _temp21,
    "pt-BR": _temp22,
    "pt-PT": _temp23,
    "ro-RO": _temp24,
    "ru-RU": _temp25,
    "sk-SK": _temp26,
    "sl-SI": _temp27,
    "sr-SP": _temp28,
    "sv-SE": _temp29,
    "tr-TR": _temp30,
    "uk-UA": _temp31,
    "zh-CN": _temp32,
    "zh-TW": _temp33
};

},{"1dca920796bf63c4":"5wOdS","41bbce685f5a8d46":"gF056","849d275d40cd7b2d":"hQ6BS","cc96906ba853325c":"fGMqD","fe6991d5eb574c29":"h75ey","456557122c0055e3":"lJKFG","77db0a925d2a4294":"g5ze6","ee87d092265a91ca":"hBNF8","718b1c7713d76dae":"ccKK7","1eaa0991875ea5fe":"lDTPe","bd93dde90b2c0869":"jQHKE","a5b23df35caf61ec":"9ELqm","3d8119ed6d47a94e":"eLuxH","40ed09f50411e33d":"9rU83","e2478af2ce7e8278":"fNWiv","9820c1bae33fc391":"cHh1G","5a581cae354e40ad":"jwAY3","43fd79b9a301c10":"2Esuf","cd61bfcf4f577c45":"jMUgF","d59a6ce25a788f6e":"1QFp7","c473919f505b4a0b":"dqOI6","9148250fb321bdbb":"7ZoGt","c0b03f6db07aa3bb":"kchpV","ace9a513870e5de":"iqLKy","4ecb720406d1c1de":"5tw0u","b5b6a13903168c3f":"5qDNA","2d7fdf039c0ccd49":"4F9ai","353017d26c3bb990":"gO0Yw","2f917dcb202f3f72":"b99Z8","c00de4e83efcec0b":"caihs","64ded31cb33a0e31":"4zhVg","a62af1a073068cdc":"4pC48","578bfc78920a66d5":"9KrQd","d7341ec69c2ed386":"iqha8"}],"5wOdS":[function(require,module,exports) {
module.exports = {
    "loading": `\u{62C}\u{627}\u{631}\u{64D} \u{627}\u{644}\u{62A}\u{62D}\u{645}\u{64A}\u{644}...`,
    "placeholder": `\u{62D}\u{62F}\u{62F} \u{62E}\u{64A}\u{627}\u{631}\u{64B}\u{627}...`
};

},{}],"gF056":[function(require,module,exports) {
module.exports = {
    "loading": `\u{417}\u{430}\u{440}\u{435}\u{436}\u{434}\u{430}\u{43D}\u{435}...`,
    "placeholder": `\u{418}\u{437}\u{431}\u{435}\u{440}\u{435}\u{442}\u{435} \u{43E}\u{43F}\u{446}\u{438}\u{44F}`
};

},{}],"hQ6BS":[function(require,module,exports) {
module.exports = {
    "loading": `Na\u{10D}\xedt\xe1n\xed...`,
    "placeholder": `Vyberte vhodnou mo\u{17E}nost...`
};

},{}],"fGMqD":[function(require,module,exports) {
module.exports = {
    "loading": `Indl\xe6ser ...`,
    "placeholder": `V\xe6lg en mulighed ...`
};

},{}],"h75ey":[function(require,module,exports) {
module.exports = {
    "loading": `Laden...`,
    "placeholder": `Option ausw\xe4hlen...`
};

},{}],"lJKFG":[function(require,module,exports) {
module.exports = {
    "loading": `\u{3A6}\u{3CC}\u{3C1}\u{3C4}\u{3C9}\u{3C3}\u{3B7}...`,
    "placeholder": `\u{395}\u{3C0}\u{3B9}\u{3BB}\u{3AD}\u{3BE}\u{3C4}\u{3B5}\u{2026}`
};

},{}],"g5ze6":[function(require,module,exports) {
module.exports = {
    "placeholder": `Select an option\u{2026}`,
    "loading": `Loading\u{2026}`
};

},{}],"hBNF8":[function(require,module,exports) {
module.exports = {
    "loading": `Cargando\u{2026}`,
    "placeholder": `Seleccione una opci\xf3n\u{2026}`
};

},{}],"ccKK7":[function(require,module,exports) {
module.exports = {
    "loading": `Laadimine...`,
    "placeholder": `Valige valikuline...`
};

},{}],"lDTPe":[function(require,module,exports) {
module.exports = {
    "loading": `Ladataan\u{2026}`,
    "placeholder": `Valitse vaihtoehto...`
};

},{}],"jQHKE":[function(require,module,exports) {
module.exports = {
    "loading": `Chargement...`,
    "placeholder": `S\xe9lectionnez une option...`
};

},{}],"9ELqm":[function(require,module,exports) {
module.exports = {
    "loading": `\u{5D8}\u{5D5}\u{5E2}\u{5DF}...`,
    "placeholder": `\u{5D1}\u{5D7}\u{5E8} \u{5D0}\u{5E4}\u{5E9}\u{5E8}\u{5D5}\u{5EA}...`
};

},{}],"eLuxH":[function(require,module,exports) {
module.exports = {
    "loading": `U\u{10D}itavam...`,
    "placeholder": `Odaberite opciju`
};

},{}],"9rU83":[function(require,module,exports) {
module.exports = {
    "loading": `Bet\xf6lt\xe9s folyamatban\u{2026}`,
    "placeholder": `V\xe1lasszon egy opci\xf3t\u{2026}`
};

},{}],"fNWiv":[function(require,module,exports) {
module.exports = {
    "loading": `Caricamento...`,
    "placeholder": `Seleziona un\u{2019}opzione...`
};

},{}],"cHh1G":[function(require,module,exports) {
module.exports = {
    "loading": `\u{8AAD}\u{307F}\u{8FBC}\u{307F}\u{4E2D}...`,
    "placeholder": `\u{30AA}\u{30D7}\u{30B7}\u{30E7}\u{30F3}\u{3092}\u{9078}\u{629E}...`
};

},{}],"jwAY3":[function(require,module,exports) {
module.exports = {
    "loading": `\u{B85C}\u{B4DC} \u{C911}`,
    "placeholder": `\u{C120}\u{D0DD} \u{C0AC}\u{D56D} \u{C120}\u{D0DD}`
};

},{}],"2Esuf":[function(require,module,exports) {
module.exports = {
    "loading": `\u{12E}keliama...`,
    "placeholder": `Pasirinkite parinkt\u{12F}...`
};

},{}],"jMUgF":[function(require,module,exports) {
module.exports = {
    "loading": `Notiek iel\u{101}de...`,
    "placeholder": `Atlasiet opciju...`
};

},{}],"1QFp7":[function(require,module,exports) {
module.exports = {
    "loading": `Laster inn ...`,
    "placeholder": `Velg et alternativ...`
};

},{}],"dqOI6":[function(require,module,exports) {
module.exports = {
    "loading": `Laden...`,
    "placeholder": `Optie selecteren...`
};

},{}],"7ZoGt":[function(require,module,exports) {
module.exports = {
    "loading": `\u{141}adowanie...`,
    "placeholder": `Wybierz opcj\u{119}...`
};

},{}],"kchpV":[function(require,module,exports) {
module.exports = {
    "loading": `Carregando...`,
    "placeholder": `Selecione uma op\xe7\xe3o...`
};

},{}],"iqLKy":[function(require,module,exports) {
module.exports = {
    "loading": `A carregar...`,
    "placeholder": `Selecionar uma op\xe7\xe3o...`
};

},{}],"5tw0u":[function(require,module,exports) {
module.exports = {
    "loading": `Se \xeencarc\u{103}...`,
    "placeholder": `Selecta\u{21B}i o op\u{21B}iune`
};

},{}],"5qDNA":[function(require,module,exports) {
module.exports = {
    "loading": `\u{417}\u{430}\u{433}\u{440}\u{443}\u{437}\u{43A}\u{430}...`,
    "placeholder": `\u{412}\u{44B}\u{431}\u{440}\u{430}\u{442}\u{44C} \u{43F}\u{430}\u{440}\u{430}\u{43C}\u{435}\u{442}\u{440}...`
};

},{}],"4F9ai":[function(require,module,exports) {
module.exports = {
    "loading": `Na\u{10D}\xedtava sa...`,
    "placeholder": `Vyberte mo\u{17E}nos\u{165}...`
};

},{}],"gO0Yw":[function(require,module,exports) {
module.exports = {
    "loading": `Nalaganje...`,
    "placeholder": `Izberite mo\u{17E}nost`
};

},{}],"b99Z8":[function(require,module,exports) {
module.exports = {
    "loading": `U\u{10D}itavam...`,
    "placeholder": `Izaberite opciju`
};

},{}],"caihs":[function(require,module,exports) {
module.exports = {
    "loading": `L\xe4ser in...`,
    "placeholder": `V\xe4lj ett alternativ...`
};

},{}],"4zhVg":[function(require,module,exports) {
module.exports = {
    "loading": `Y\xfckleniyor...`,
    "placeholder": `Bir se\xe7im yap\u{131}n\u{2026}`
};

},{}],"4pC48":[function(require,module,exports) {
module.exports = {
    "loading": `\u{417}\u{430}\u{432}\u{430}\u{43D}\u{442}\u{430}\u{436}\u{435}\u{43D}\u{43D}\u{44F}\u{2026}`,
    "placeholder": `\u{412}\u{438}\u{431}\u{435}\u{440}\u{456}\u{442}\u{44C} \u{43E}\u{43F}\u{446}\u{456}\u{44E}...`
};

},{}],"9KrQd":[function(require,module,exports) {
module.exports = {
    "loading": `\u{6B63}\u{5728}\u{52A0}\u{8F7D}...`,
    "placeholder": `\u{9009}\u{62E9}\u{4E00}\u{4E2A}\u{9009}\u{9879}...`
};

},{}],"iqha8":[function(require,module,exports) {
module.exports = {
    "loading": `\u{6B63}\u{5728}\u{8F09}\u{5165}`,
    "placeholder": `\u{9078}\u{53D6}\u{4E00}\u{500B}\u{9078}\u{9805}`
};

},{}],"hAeyH":[function(require,module,exports) {
module.exports["focus-ring"] = `PBsjDW_focus-ring`;
module.exports["i18nFontFamily"] = `PBsjDW_i18nFontFamily`;
module.exports["is-disabled"] = `PBsjDW_is-disabled`;
module.exports["is-hovered"] = `PBsjDW_is-hovered`;
module.exports["is-invalid"] = `PBsjDW_is-invalid`;
module.exports["is-placeholder"] = `PBsjDW_is-placeholder`;
module.exports["is-selected"] = `PBsjDW_is-selected`;
module.exports["spectrum-Dropdown"] = `PBsjDW_spectrum-Dropdown`;
module.exports["spectrum-Dropdown--quiet"] = `PBsjDW_spectrum-Dropdown--quiet`;
module.exports["spectrum-Dropdown-avatar"] = `PBsjDW_spectrum-Dropdown-avatar`;
module.exports["spectrum-Dropdown-chevron"] = `PBsjDW_spectrum-Dropdown-chevron`;
module.exports["spectrum-Dropdown-fieldWrapper--positionSide"] = `PBsjDW_spectrum-Dropdown-fieldWrapper--positionSide`;
module.exports["spectrum-Dropdown-fieldWrapper--quiet"] = `PBsjDW_spectrum-Dropdown-fieldWrapper--quiet`;
module.exports["spectrum-Dropdown-invalidIcon"] = `PBsjDW_spectrum-Dropdown-invalidIcon`;
module.exports["spectrum-Dropdown-label"] = `PBsjDW_spectrum-Dropdown-label`;
module.exports["spectrum-Dropdown-popover--quiet"] = `PBsjDW_spectrum-Dropdown-popover--quiet`;
module.exports["spectrum-Dropdown-progressCircle"] = `PBsjDW_spectrum-Dropdown-progressCircle`;
module.exports["spectrum-Dropdown-trigger"] = `PBsjDW_spectrum-Dropdown-trigger`;
module.exports["spectrum-Field"] = `PBsjDW_spectrum-Field`;
module.exports["spectrum-FocusRing-ring"] = `PBsjDW_spectrum-FocusRing-ring`;
module.exports["spectrum-FocusRing"] = `PBsjDW_spectrum-FocusRing ${module.exports["spectrum-FocusRing-ring"]}`;
module.exports["spectrum-FocusRing--quiet"] = `PBsjDW_spectrum-FocusRing--quiet`;
module.exports["spectrum-Icon"] = `PBsjDW_spectrum-Icon`;

},{}],"gbtGh":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /// <reference types="css-module-types" />
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Radio", ()=>(0, _radio.Radio));
parcelHelpers.export(exports, "RadioGroup", ()=>(0, _radioGroup.RadioGroup));
var _radio = require("./Radio");
var _radioGroup = require("./RadioGroup");

},{"./Radio":"7br50","./RadioGroup":"fdfNX","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"7br50":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Radio", ()=>_Radio);
var _utils = require("@react-spectrum/utils");
var _focus = require("@react-aria/focus");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _varsCss = require("@adobe/spectrum-css-temp/components/radio/vars.css");
var _varsCssDefault = parcelHelpers.interopDefault(_varsCss);
var _interactions = require("@react-aria/interactions");
var _radio = require("@react-aria/radio");
var _context = require("./context");
function Radio(props, ref) {
    let { isDisabled, children, autoFocus, ...otherProps } = props;
    let { styleProps } = (0, _utils.useStyleProps)(otherProps);
    let { hoverProps, isHovered } = (0, _interactions.useHover)({
        isDisabled
    });
    let inputRef = (0, _react.useRef)(null);
    let domRef = (0, _utils.useFocusableRef)(ref, inputRef);
    let radioGroupProps = (0, _context.useRadioProvider)();
    let { isEmphasized, state } = radioGroupProps;
    let { inputProps } = (0, _radio.useRadio)({
        ...props,
        ...radioGroupProps,
        isDisabled
    }, state, inputRef);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("label", {
        ...styleProps,
        ...hoverProps,
        ref: domRef,
        className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Radio", {
            // Removing. Pending design feedback.
            // 'spectrum-Radio--labelBelow': labelPosition === 'bottom',
            "spectrum-Radio--quiet": !isEmphasized,
            "is-disabled": isDisabled,
            "is-invalid": state.isInvalid,
            "is-hovered": isHovered
        }, styleProps.className)
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _focus.FocusRing), {
        focusRingClass: (0, _utils.classNames)((0, _varsCssDefault.default), "focus-ring"),
        autoFocus: autoFocus
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("input", {
        ...inputProps,
        ref: inputRef,
        className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Radio-input")
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Radio-button")
    }), children && /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Radio-label")
    }, children));
}
/**
 * Radio buttons allow users to select a single option from a list of mutually exclusive options.
 * All possible options are exposed up front for users to compare.
 */ const _Radio = /*#__PURE__*/ (0, _react.forwardRef)(Radio);

},{"@react-spectrum/utils":"cMIJ6","@react-aria/focus":"42mbF","react":"9yzVZ","@adobe/spectrum-css-temp/components/radio/vars.css":"c0kDa","@react-aria/interactions":"ky3G8","@react-aria/radio":"25mgs","./context":"d7Slw","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"c0kDa":[function(require,module,exports) {
module.exports["focus-ring"] = `V2HKpq_focus-ring`;
module.exports["i18nFontFamily"] = `V2HKpq_i18nFontFamily`;
module.exports["is-hovered"] = `V2HKpq_is-hovered`;
module.exports["is-invalid"] = `V2HKpq_is-invalid`;
module.exports["spectrum-FocusRing-ring"] = `V2HKpq_spectrum-FocusRing-ring`;
module.exports["spectrum-FocusRing"] = `V2HKpq_spectrum-FocusRing ${module.exports["spectrum-FocusRing-ring"]}`;
module.exports["spectrum-FocusRing--quiet"] = `V2HKpq_spectrum-FocusRing--quiet`;
module.exports["spectrum-Radio"] = `V2HKpq_spectrum-Radio`;
module.exports["spectrum-Radio--labelBelow"] = `V2HKpq_spectrum-Radio--labelBelow`;
module.exports["spectrum-Radio--quiet"] = `V2HKpq_spectrum-Radio--quiet`;
module.exports["spectrum-Radio-button"] = `V2HKpq_spectrum-Radio-button`;
module.exports["spectrum-Radio-input"] = `V2HKpq_spectrum-Radio-input`;
module.exports["spectrum-Radio-label"] = `V2HKpq_spectrum-Radio-label`;

},{}],"d7Slw":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RadioContext", ()=>RadioContext);
parcelHelpers.export(exports, "useRadioProvider", ()=>useRadioProvider);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const RadioContext = (0, _reactDefault.default).createContext(null);
function useRadioProvider() {
    return (0, _react.useContext)(RadioContext) || {};
}

},{"react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"fdfNX":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RadioGroup", ()=>_RadioGroup);
var _utils = require("@react-spectrum/utils");
var _label = require("@react-spectrum/label");
var _context = require("./context");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _varsCss = require("@adobe/spectrum-css-temp/components/fieldgroup/vars.css");
var _varsCssDefault = parcelHelpers.interopDefault(_varsCss);
var _form = require("@react-spectrum/form");
var _provider = require("@react-spectrum/provider");
var _radio = require("@react-aria/radio");
var _radio1 = require("@react-stately/radio");
function RadioGroup(props, ref) {
    props = (0, _provider.useProviderProps)(props);
    props = (0, _form.useFormProps)(props);
    let { isEmphasized, children, orientation = "vertical" } = props;
    let domRef = (0, _utils.useDOMRef)(ref);
    let state = (0, _radio1.useRadioGroupState)(props);
    let { radioGroupProps, ...otherProps } = (0, _radio.useRadioGroup)(props, state);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _label.Field), {
        ...props,
        ...otherProps,
        ref: domRef,
        wrapperClassName: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-FieldGroup"),
        elementType: "span"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...radioGroupProps,
        className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-FieldGroup-group", {
            "spectrum-FieldGroup-group--horizontal": orientation === "horizontal"
        })
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _context.RadioContext).Provider, {
        value: {
            isEmphasized,
            state
        }
    }, children)));
}
/**
 * Radio groups allow users to select a single option from a list of mutually exclusive options.
 * All possible options are exposed up front for users to compare.
 */ const _RadioGroup = /*#__PURE__*/ (0, _reactDefault.default).forwardRef(RadioGroup);

},{"@react-spectrum/utils":"cMIJ6","@react-spectrum/label":"6qv6N","./context":"d7Slw","react":"9yzVZ","@adobe/spectrum-css-temp/components/fieldgroup/vars.css":"ly32V","@react-spectrum/form":"bGDqA","@react-spectrum/provider":"5bCdp","@react-aria/radio":"25mgs","@react-stately/radio":"qkKdG","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"if52z":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /// <reference types="css-module-types" />
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Slider", ()=>(0, _slider.Slider));
parcelHelpers.export(exports, "RangeSlider", ()=>(0, _rangeSlider.RangeSlider));
var _slider = require("./Slider");
var _rangeSlider = require("./RangeSlider");

},{"./Slider":"5kTKy","./RangeSlider":"bmrXd","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"5kTKy":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Slider", ()=>_Slider);
var _utils = require("@react-aria/utils");
var _utils1 = require("@react-spectrum/utils");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _sliderBase = require("./SliderBase");
var _sliderThumb = require("./SliderThumb");
var _varsCss = require("@adobe/spectrum-css-temp/components/slider/vars.css");
var _varsCssDefault = parcelHelpers.interopDefault(_varsCss);
var _i18N = require("@react-aria/i18n");
function Slider(props, ref) {
    let { onChange, onChangeEnd, value, defaultValue, isFilled, fillOffset, trackGradient, getValueLabel, ...otherProps } = props;
    let baseProps = {
        ...otherProps,
        // Normalize `value: number[]` to `value: number`
        value: value != null ? [
            value
        ] : undefined,
        defaultValue: defaultValue != null ? [
            defaultValue
        ] : undefined,
        onChange: (v)=>{
            onChange === null || onChange === void 0 ? void 0 : onChange(v[0]);
        },
        onChangeEnd: (v)=>{
            onChangeEnd === null || onChangeEnd === void 0 ? void 0 : onChangeEnd(v[0]);
        },
        getValueLabel: getValueLabel ? ([v])=>getValueLabel(v) : undefined
    };
    let { direction } = (0, _i18N.useLocale)();
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _sliderBase.SliderBase), {
        ...baseProps,
        ref: ref,
        classes: {
            "spectrum-Slider--filled": isFilled && fillOffset == null
        },
        style: // @ts-ignore
        {
            "--spectrum-slider-track-gradient": trackGradient && `linear-gradient(to ${direction === "ltr" ? "right" : "left"}, ${trackGradient.join(", ")})`
        }
    }, ({ trackRef, inputRef, state })=>{
        fillOffset = fillOffset != null ? (0, _utils.clamp)(fillOffset, state.getThumbMinValue(0), state.getThumbMaxValue(0)) : fillOffset;
        let cssDirection = direction === "rtl" ? "right" : "left";
        let lowerTrack = /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
            className: (0, _utils1.classNames)((0, _varsCssDefault.default), "spectrum-Slider-track"),
            style: {
                width: `${state.getThumbPercent(0) * 100}%`,
                // TODO not sure if it has advantages, but this could also be implemented as CSS calc():
                // .track::before {
                //    background-size: calc((1/ (var(--width)/100)) * 100%);
                //    width: calc(var(--width) * 1%)M
                // }
                // @ts-ignore
                "--spectrum-track-background-size": `${1 / state.getThumbPercent(0) * 100}%`,
                "--spectrum-track-background-position": direction === "ltr" ? "0" : "100%"
            }
        });
        let upperTrack = /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
            className: (0, _utils1.classNames)((0, _varsCssDefault.default), "spectrum-Slider-track"),
            style: {
                width: `${(1 - state.getThumbPercent(0)) * 100}%`,
                // @ts-ignore
                "--spectrum-track-background-size": `${1 / (1 - state.getThumbPercent(0)) * 100}%`,
                "--spectrum-track-background-position": direction === "ltr" ? "100%" : "0"
            }
        });
        let filledTrack = null;
        if (isFilled && fillOffset != null) {
            let width = state.getThumbPercent(0) - state.getValuePercent(fillOffset);
            let isRightOfOffset = width > 0;
            let offset = isRightOfOffset ? state.getValuePercent(fillOffset) : state.getThumbPercent(0);
            filledTrack = /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
                className: (0, _utils1.classNames)((0, _varsCssDefault.default), "spectrum-Slider-fill", {
                    "spectrum-Slider-fill--right": isRightOfOffset
                }),
                style: {
                    [cssDirection]: `${offset * 100}%`,
                    width: `${Math.abs(width) * 100}%`
                }
            });
        }
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, lowerTrack, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _sliderThumb.SliderThumb), {
            index: 0,
            isDisabled: props.isDisabled,
            trackRef: trackRef,
            inputRef: inputRef,
            state: state,
            name: props.name
        }), filledTrack, upperTrack);
    });
}
/**
 * Sliders allow users to quickly select a value within a range. They should be used when the upper and lower bounds to the range are invariable.
 */ const _Slider = /*#__PURE__*/ (0, _reactDefault.default).forwardRef(Slider);

},{"@react-aria/utils":"9cLk5","@react-spectrum/utils":"cMIJ6","react":"9yzVZ","./SliderBase":"loTCI","./SliderThumb":"hbe6c","@adobe/spectrum-css-temp/components/slider/vars.css":"fbqrC","@react-aria/i18n":"411rg","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"loTCI":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SliderBase", ()=>_SliderBase);
var _utils = require("@react-spectrum/utils");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _slider = require("@react-stately/slider");
var _varsCss = require("@adobe/spectrum-css-temp/components/slider/vars.css");
var _varsCssDefault = parcelHelpers.interopDefault(_varsCss);
var _i18N = require("@react-aria/i18n");
var _provider = require("@react-spectrum/provider");
var _slider1 = require("@react-aria/slider");
function SliderBase(props, ref) {
    props = (0, _provider.useProviderProps)(props);
    let { isDisabled, children, classes, style, labelPosition = "top", getValueLabel, showValueLabel = !!props.label, formatOptions, minValue = 0, maxValue = 100, ...otherProps } = props;
    let { styleProps } = (0, _utils.useStyleProps)(otherProps);
    // `Math.abs(Math.sign(a) - Math.sign(b)) === 2` is true if the values have a different sign.
    let alwaysDisplaySign = Math.abs(Math.sign(minValue) - Math.sign(maxValue)) === 2;
    if (alwaysDisplaySign) {
        if (formatOptions != null) {
            if (!("signDisplay" in formatOptions)) formatOptions = {
                ...formatOptions,
                // @ts-ignore
                signDisplay: "exceptZero"
            };
        } else // @ts-ignore
        formatOptions = {
            signDisplay: "exceptZero"
        };
    }
    const formatter = (0, _i18N.useNumberFormatter)(formatOptions);
    const state = (0, _slider.useSliderState)({
        ...props,
        numberFormatter: formatter,
        minValue,
        maxValue
    });
    let trackRef = (0, _react.useRef)();
    let { groupProps, trackProps, labelProps, outputProps } = (0, _slider1.useSlider)(props, state, trackRef);
    let inputRef = (0, _react.useRef)();
    let domRef = (0, _utils.useFocusableRef)(ref, inputRef);
    let displayValue = "";
    let maxLabelLength = undefined;
    if (typeof getValueLabel === "function") {
        displayValue = getValueLabel(state.values);
        switch(state.values.length){
            case 1:
                maxLabelLength = Math.max(getValueLabel([
                    minValue
                ]).length, getValueLabel([
                    maxValue
                ]).length);
                break;
            case 2:
                // Try all possible combinations of min and max values.
                maxLabelLength = Math.max(getValueLabel([
                    minValue,
                    minValue
                ]).length, getValueLabel([
                    minValue,
                    maxValue
                ]).length, getValueLabel([
                    maxValue,
                    minValue
                ]).length, getValueLabel([
                    maxValue,
                    maxValue
                ]).length);
                break;
            default:
                throw new Error("Only sliders with 1 or 2 handles are supported!");
        }
    } else {
        maxLabelLength = Math.max([
            ...formatter.format(minValue)
        ].length, [
            ...formatter.format(maxValue)
        ].length);
        switch(state.values.length){
            case 1:
                displayValue = state.getThumbValueLabel(0);
                break;
            case 2:
                // This should really use the NumberFormat#formatRange proposal...
                // https://github.com/tc39/ecma402/issues/393
                // https://github.com/tc39/proposal-intl-numberformat-v3#formatrange-ecma-402-393
                displayValue = `${state.getThumbValueLabel(0)} \u{2013} ${state.getThumbValueLabel(1)}`;
                maxLabelLength = 3 + 2 * Math.max(maxLabelLength, [
                    ...formatter.format(minValue)
                ].length, [
                    ...formatter.format(maxValue)
                ].length);
                break;
            default:
                throw new Error("Only sliders with 1 or 2 handles are supported!");
        }
    }
    let labelNode = /*#__PURE__*/ (0, _reactDefault.default).createElement("label", {
        className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Slider-label"),
        ...labelProps
    }, props.label);
    let valueNode = /*#__PURE__*/ (0, _reactDefault.default).createElement("output", {
        ...outputProps,
        className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Slider-value"),
        style: maxLabelLength && {
            width: `${maxLabelLength}ch`,
            minWidth: `${maxLabelLength}ch`
        }
    }, displayValue);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ref: domRef,
        className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Slider", {
            "spectrum-Slider--positionTop": labelPosition === "top",
            "spectrum-Slider--positionSide": labelPosition === "side",
            "is-disabled": isDisabled
        }, classes, styleProps.className),
        style: {
            ...style,
            ...styleProps.style
        },
        ...groupProps
    }, props.label && /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Slider-labelContainer"),
        role: "presentation"
    }, props.label && labelNode, props.contextualHelp && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.SlotProvider), {
        slots: {
            actionButton: {
                UNSAFE_className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Slider-contextualHelp")
            }
        }
    }, props.contextualHelp), labelPosition === "top" && showValueLabel && valueNode), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Slider-controls"),
        ref: trackRef,
        ...trackProps,
        role: "presentation"
    }, children({
        trackRef,
        inputRef,
        state
    })), labelPosition === "side" && /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Slider-valueLabelContainer"),
        role: "presentation"
    }, showValueLabel && valueNode));
}
const _SliderBase = /*#__PURE__*/ (0, _reactDefault.default).forwardRef(SliderBase);

},{"@react-spectrum/utils":"cMIJ6","react":"9yzVZ","@react-stately/slider":"82Whk","@adobe/spectrum-css-temp/components/slider/vars.css":"fbqrC","@react-aria/i18n":"411rg","@react-spectrum/provider":"5bCdp","@react-aria/slider":"eOsko","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"fbqrC":[function(require,module,exports) {
module.exports["contextualHelp"] = `BTW8mG_contextualHelp`;
module.exports["focus-ring"] = `BTW8mG_focus-ring`;
module.exports["i18nFontFamily"] = `BTW8mG_i18nFontFamily`;
module.exports["is-disabled"] = `BTW8mG_is-disabled`;
module.exports["is-dragged"] = `BTW8mG_is-dragged`;
module.exports["is-focused"] = `BTW8mG_is-focused`;
module.exports["is-hovered"] = `BTW8mG_is-hovered`;
module.exports["is-tophandle"] = `BTW8mG_is-tophandle`;
module.exports["label"] = `BTW8mG_label`;
module.exports["spectrum-Slider"] = `BTW8mG_spectrum-Slider`;
module.exports["spectrum-Dial"] = `BTW8mG_spectrum-Dial ${module.exports["spectrum-Slider"]}`;
module.exports["spectrum-Dial--small"] = `BTW8mG_spectrum-Dial--small`;
module.exports["spectrum-Slider-controls"] = `BTW8mG_spectrum-Slider-controls`;
module.exports["spectrum-Dial-controls"] = `BTW8mG_spectrum-Dial-controls ${module.exports["spectrum-Slider-controls"]}`;
module.exports["spectrum-Slider-handle"] = `BTW8mG_spectrum-Slider-handle`;
module.exports["spectrum-Dial-handle"] = `BTW8mG_spectrum-Dial-handle ${module.exports["spectrum-Slider-handle"]}`;
module.exports["spectrum-Slider-input"] = `BTW8mG_spectrum-Slider-input`;
module.exports["spectrum-Dial-input"] = `BTW8mG_spectrum-Dial-input ${module.exports["spectrum-Slider-input"]}`;
module.exports["spectrum-Dial-label"] = `BTW8mG_spectrum-Dial-label`;
module.exports["spectrum-Slider-labelContainer"] = `BTW8mG_spectrum-Slider-labelContainer`;
module.exports["spectrum-Dial-labelContainer"] = `BTW8mG_spectrum-Dial-labelContainer ${module.exports["spectrum-Slider-labelContainer"]}`;
module.exports["spectrum-Dial-value"] = `BTW8mG_spectrum-Dial-value`;
module.exports["spectrum-FocusRing-ring"] = `BTW8mG_spectrum-FocusRing-ring`;
module.exports["spectrum-FocusRing"] = `BTW8mG_spectrum-FocusRing ${module.exports["spectrum-FocusRing-ring"]}`;
module.exports["spectrum-FocusRing--quiet"] = `BTW8mG_spectrum-FocusRing--quiet`;
module.exports["spectrum-Slider--color"] = `BTW8mG_spectrum-Slider--color`;
module.exports["spectrum-Slider--filled"] = `BTW8mG_spectrum-Slider--filled`;
module.exports["spectrum-Slider--label-side"] = `BTW8mG_spectrum-Slider--label-side`;
module.exports["spectrum-Slider--positionSide"] = `BTW8mG_spectrum-Slider--positionSide`;
module.exports["spectrum-Slider--positionTop"] = `BTW8mG_spectrum-Slider--positionTop`;
module.exports["spectrum-Slider--ramp"] = `BTW8mG_spectrum-Slider--ramp`;
module.exports["spectrum-Slider--range"] = `BTW8mG_spectrum-Slider--range`;
module.exports["spectrum-Slider-buffer"] = `BTW8mG_spectrum-Slider-buffer`;
module.exports["spectrum-Slider-contextualHelp"] = `BTW8mG_spectrum-Slider-contextualHelp`;
module.exports["spectrum-Slider-fill"] = `BTW8mG_spectrum-Slider-fill`;
module.exports["spectrum-Slider-fill--right"] = `BTW8mG_spectrum-Slider-fill--right`;
module.exports["spectrum-Slider-label"] = `BTW8mG_spectrum-Slider-label`;
module.exports["spectrum-Slider-ramp"] = `BTW8mG_spectrum-Slider-ramp`;
module.exports["spectrum-Slider-tick"] = `BTW8mG_spectrum-Slider-tick`;
module.exports["spectrum-Slider-tickLabel"] = `BTW8mG_spectrum-Slider-tickLabel`;
module.exports["spectrum-Slider-ticks"] = `BTW8mG_spectrum-Slider-ticks`;
module.exports["spectrum-Slider-track"] = `BTW8mG_spectrum-Slider-track`;
module.exports["spectrum-Slider-value"] = `BTW8mG_spectrum-Slider-value`;
module.exports["spectrum-Slider-valueLabelContainer"] = `BTW8mG_spectrum-Slider-valueLabelContainer`;
module.exports["u-isGrabbing"] = `BTW8mG_u-isGrabbing`;
module.exports["value"] = `BTW8mG_value`;

},{}],"hbe6c":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SliderThumb", ()=>SliderThumb);
var _utils = require("@react-spectrum/utils");
var _focus = require("@react-aria/focus");
var _utils1 = require("@react-aria/utils");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _varsCss = require("@adobe/spectrum-css-temp/components/slider/vars.css");
var _varsCssDefault = parcelHelpers.interopDefault(_varsCss);
var _interactions = require("@react-aria/interactions");
var _slider = require("@react-aria/slider");
var _visuallyHidden = require("@react-aria/visually-hidden");
function SliderThumb(props) {
    let { inputRef, state } = props;
    let backupRef = (0, _react.useRef)();
    inputRef = inputRef || backupRef;
    let { thumbProps, inputProps, isDragging, isFocused } = (0, _slider.useSliderThumb)({
        ...props,
        inputRef
    }, state);
    let { hoverProps, isHovered } = (0, _interactions.useHover)({});
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _focus.FocusRing), {
        within: true,
        focusRingClass: (0, _utils.classNames)((0, _varsCssDefault.default), "is-focused")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Slider-handle", {
            "is-hovered": isHovered,
            "is-dragged": isDragging,
            "is-tophandle": isFocused
        }),
        ...(0, _utils1.mergeProps)(thumbProps, hoverProps),
        role: "presentation"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _visuallyHidden.VisuallyHidden), null, /*#__PURE__*/ (0, _reactDefault.default).createElement("input", {
        className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Slider-input"),
        ref: inputRef,
        ...inputProps
    }))));
}

},{"@react-spectrum/utils":"cMIJ6","@react-aria/focus":"42mbF","@react-aria/utils":"9cLk5","react":"9yzVZ","@adobe/spectrum-css-temp/components/slider/vars.css":"fbqrC","@react-aria/interactions":"ky3G8","@react-aria/slider":"eOsko","@react-aria/visually-hidden":"4jwxT","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"bmrXd":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RangeSlider", ()=>_RangeSlider);
var _utils = require("@react-spectrum/utils");
// @ts-ignore
var _json = require("../intl/*.json");
var _jsonDefault = parcelHelpers.interopDefault(_json);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _sliderBase = require("./SliderBase");
var _sliderThumb = require("./SliderThumb");
var _varsCss = require("@adobe/spectrum-css-temp/components/slider/vars.css");
var _varsCssDefault = parcelHelpers.interopDefault(_varsCss);
var _i18N = require("@react-aria/i18n");
function RangeSlider(props, ref) {
    let { onChange, onChangeEnd, value, defaultValue, getValueLabel, ...otherProps } = props;
    var _props_minValue, _props_maxValue;
    let baseProps = {
        ...otherProps,
        value: value != null ? [
            value.start,
            value.end
        ] : undefined,
        defaultValue: defaultValue != null ? [
            defaultValue.start,
            defaultValue.end
        ] : [
            (_props_minValue = props.minValue) !== null && _props_minValue !== void 0 ? _props_minValue : 0,
            (_props_maxValue = props.maxValue) !== null && _props_maxValue !== void 0 ? _props_maxValue : 100
        ],
        onChange (v) {
            onChange === null || onChange === void 0 ? void 0 : onChange({
                start: v[0],
                end: v[1]
            });
        },
        onChangeEnd (v) {
            onChangeEnd === null || onChangeEnd === void 0 ? void 0 : onChangeEnd({
                start: v[0],
                end: v[1]
            });
        },
        getValueLabel: getValueLabel ? ([start, end])=>getValueLabel({
                start,
                end
            }) : undefined
    };
    let stringFormatter = (0, _i18N.useLocalizedStringFormatter)((0, _jsonDefault.default), "@react-spectrum/slider");
    let { direction } = (0, _i18N.useLocale)();
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _sliderBase.SliderBase), {
        ...baseProps,
        classes: "spectrum-Slider--range",
        ref: ref
    }, ({ trackRef, inputRef, state })=>{
        let cssDirection = direction === "rtl" ? "right" : "left";
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
            className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Slider-track"),
            style: {
                width: `${state.getThumbPercent(0) * 100}%`
            }
        }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _sliderThumb.SliderThumb), {
            index: 0,
            "aria-label": stringFormatter.format("minimum"),
            isDisabled: props.isDisabled,
            trackRef: trackRef,
            inputRef: inputRef,
            state: state,
            name: props.startName
        }), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
            className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Slider-track"),
            style: {
                [cssDirection]: `${state.getThumbPercent(0) * 100}%`,
                width: `${Math.abs(state.getThumbPercent(0) - state.getThumbPercent(1)) * 100}%`
            }
        }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _sliderThumb.SliderThumb), {
            index: 1,
            "aria-label": stringFormatter.format("maximum"),
            isDisabled: props.isDisabled,
            trackRef: trackRef,
            state: state,
            name: props.endName
        }), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
            className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Slider-track"),
            style: {
                width: `${(1 - state.getThumbPercent(1)) * 100}%`
            }
        }));
    });
}
/**
 * RangeSliders allow users to quickly select a subset range. They should be used when the upper and lower bounds to the range are invariable.
 */ const _RangeSlider = /*#__PURE__*/ (0, _reactDefault.default).forwardRef(RangeSlider);

},{"@react-spectrum/utils":"cMIJ6","../intl/*.json":"cM4Pk","react":"9yzVZ","./SliderBase":"loTCI","./SliderThumb":"hbe6c","@adobe/spectrum-css-temp/components/slider/vars.css":"fbqrC","@react-aria/i18n":"411rg","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"cM4Pk":[function(require,module,exports) {
const _temp0 = require("794ddebb67ab6c0a");
const _temp1 = require("13a9b1ff3de0d469");
const _temp2 = require("e711037ac6407e48");
const _temp3 = require("61ba0e192b98378c");
const _temp4 = require("aa28299d6036e239");
const _temp5 = require("3cc57ec27d3618a8");
const _temp6 = require("b69beacd2a5f85ec");
const _temp7 = require("79cf4e2f2477e9fc");
const _temp8 = require("9531a9d5ab473d94");
const _temp9 = require("902c3d568cec6900");
const _temp10 = require("407e93272cb8e5cf");
const _temp11 = require("6dc201f78991a668");
const _temp12 = require("84ed852463d95b78");
const _temp13 = require("7a8655a73f36e7dd");
const _temp14 = require("93e67949929b125b");
const _temp15 = require("97ebaef17020fc21");
const _temp16 = require("4f215306e6fd52e7");
const _temp17 = require("dba3de23fad066b");
const _temp18 = require("3bc398bba76cf601");
const _temp19 = require("9f3d7cb76a4f7590");
const _temp20 = require("cd6b403242430457");
const _temp21 = require("623ce0358378c8ca");
const _temp22 = require("e415e44ab8defc14");
const _temp23 = require("bed1406ce0d8a05d");
const _temp24 = require("db9e57fe47d2ae97");
const _temp25 = require("d0ec06ab7329264d");
const _temp26 = require("7fa8a482ebd2d1b4");
const _temp27 = require("30ebcc72d554f523");
const _temp28 = require("156ee680cf53c48e");
const _temp29 = require("418c2931bce8d89");
const _temp30 = require("fd1fafe4a4b84ad0");
const _temp31 = require("f6519facdbab9118");
const _temp32 = require("bebae5740b622ce2");
const _temp33 = require("c7653e421c3428a2");
module.exports = {
    "ar-AE": _temp0,
    "bg-BG": _temp1,
    "cs-CZ": _temp2,
    "da-DK": _temp3,
    "de-DE": _temp4,
    "el-GR": _temp5,
    "en-US": _temp6,
    "es-ES": _temp7,
    "et-EE": _temp8,
    "fi-FI": _temp9,
    "fr-FR": _temp10,
    "he-IL": _temp11,
    "hr-HR": _temp12,
    "hu-HU": _temp13,
    "it-IT": _temp14,
    "ja-JP": _temp15,
    "ko-KR": _temp16,
    "lt-LT": _temp17,
    "lv-LV": _temp18,
    "nb-NO": _temp19,
    "nl-NL": _temp20,
    "pl-PL": _temp21,
    "pt-BR": _temp22,
    "pt-PT": _temp23,
    "ro-RO": _temp24,
    "ru-RU": _temp25,
    "sk-SK": _temp26,
    "sl-SI": _temp27,
    "sr-SP": _temp28,
    "sv-SE": _temp29,
    "tr-TR": _temp30,
    "uk-UA": _temp31,
    "zh-CN": _temp32,
    "zh-TW": _temp33
};

},{"794ddebb67ab6c0a":"9rEh3","13a9b1ff3de0d469":"68dKQ","e711037ac6407e48":"gPKvT","61ba0e192b98378c":"89nHq","aa28299d6036e239":"ijA10","3cc57ec27d3618a8":"daDEN","b69beacd2a5f85ec":"gY9SA","79cf4e2f2477e9fc":"a4QaC","9531a9d5ab473d94":"i9YZY","902c3d568cec6900":"7Vd67","407e93272cb8e5cf":"9R8Jf","6dc201f78991a668":"Rh5gA","84ed852463d95b78":"gPcyV","7a8655a73f36e7dd":"6ipCS","93e67949929b125b":"3wkeu","97ebaef17020fc21":"2rO5e","4f215306e6fd52e7":"be9w4","dba3de23fad066b":"42hdN","3bc398bba76cf601":"aXhLi","9f3d7cb76a4f7590":"ivtoT","cd6b403242430457":"jET5g","623ce0358378c8ca":"i4LeH","e415e44ab8defc14":"jxZxy","bed1406ce0d8a05d":"ih5Om","db9e57fe47d2ae97":"JneiY","d0ec06ab7329264d":"4cy2W","7fa8a482ebd2d1b4":"eXB5p","30ebcc72d554f523":"afuaT","156ee680cf53c48e":"33dZR","418c2931bce8d89":"3RJrK","fd1fafe4a4b84ad0":"h6MN0","f6519facdbab9118":"lWEfb","bebae5740b622ce2":"ibnOP","c7653e421c3428a2":"5Dnwo"}],"9rEh3":[function(require,module,exports) {
module.exports = {
    "maximum": `\u{623}\u{642}\u{635}\u{649}`,
    "minimum": `\u{623}\u{62F}\u{646}\u{649}`
};

},{}],"68dKQ":[function(require,module,exports) {
module.exports = {
    "maximum": `\u{41C}\u{430}\u{43A}\u{441}\u{438}\u{43C}\u{443}\u{43C}`,
    "minimum": `\u{41C}\u{438}\u{43D}\u{438}\u{43C}\u{443}\u{43C}`
};

},{}],"gPKvT":[function(require,module,exports) {
module.exports = {
    "maximum": `Maximum`,
    "minimum": `Minimum`
};

},{}],"89nHq":[function(require,module,exports) {
module.exports = {
    "maximum": `Maksimum`,
    "minimum": `Minimum`
};

},{}],"ijA10":[function(require,module,exports) {
module.exports = {
    "maximum": `Maximum`,
    "minimum": `Minimum`
};

},{}],"daDEN":[function(require,module,exports) {
module.exports = {
    "maximum": `\u{39C}\u{3AD}\u{3B3}\u{3B9}\u{3C3}\u{3C4}\u{3BF}`,
    "minimum": `\u{395}\u{3BB}\u{3AC}\u{3C7}\u{3B9}\u{3C3}\u{3C4}\u{3BF}`
};

},{}],"gY9SA":[function(require,module,exports) {
module.exports = {
    "minimum": `Minimum`,
    "maximum": `Maximum`
};

},{}],"a4QaC":[function(require,module,exports) {
module.exports = {
    "maximum": `M\xe1ximo`,
    "minimum": `M\xednimo`
};

},{}],"i9YZY":[function(require,module,exports) {
module.exports = {
    "maximum": `Maksimaalne`,
    "minimum": `Minimaalne`
};

},{}],"7Vd67":[function(require,module,exports) {
module.exports = {
    "maximum": `Maksimi`,
    "minimum": `Minimi`
};

},{}],"9R8Jf":[function(require,module,exports) {
module.exports = {
    "maximum": `Maximum`,
    "minimum": `Minimum`
};

},{}],"Rh5gA":[function(require,module,exports) {
module.exports = {
    "maximum": `\u{5DE}\u{5E7}\u{5E1}\u{5D9}\u{5DE}\u{5D5}\u{5DD}`,
    "minimum": `\u{5DE}\u{5D9}\u{5E0}\u{5D9}\u{5DE}\u{5D5}\u{5DD}`
};

},{}],"gPcyV":[function(require,module,exports) {
module.exports = {
    "maximum": `Najvi\u{161}e`,
    "minimum": `Najmanje`
};

},{}],"6ipCS":[function(require,module,exports) {
module.exports = {
    "maximum": `Maximum`,
    "minimum": `Minimum`
};

},{}],"3wkeu":[function(require,module,exports) {
module.exports = {
    "maximum": `Massimo`,
    "minimum": `Minimo`
};

},{}],"2rO5e":[function(require,module,exports) {
module.exports = {
    "maximum": `\u{6700}\u{5927}`,
    "minimum": `\u{6700}\u{5C0F}`
};

},{}],"be9w4":[function(require,module,exports) {
module.exports = {
    "maximum": `\u{CD5C}\u{B300}`,
    "minimum": `\u{CD5C}\u{C18C}`
};

},{}],"42hdN":[function(require,module,exports) {
module.exports = {
    "maximum": `Daugiausia`,
    "minimum": `Ma\u{17E}iausia`
};

},{}],"aXhLi":[function(require,module,exports) {
module.exports = {
    "maximum": `Maksim\u{101}l\u{101} v\u{113}rt\u{12B}ba`,
    "minimum": `Minim\u{101}l\u{101} v\u{113}rt\u{12B}ba`
};

},{}],"ivtoT":[function(require,module,exports) {
module.exports = {
    "maximum": `Maksimum`,
    "minimum": `Minimum`
};

},{}],"jET5g":[function(require,module,exports) {
module.exports = {
    "maximum": `Maximum`,
    "minimum": `Minimum`
};

},{}],"i4LeH":[function(require,module,exports) {
module.exports = {
    "maximum": `Maksimum`,
    "minimum": `Minimum`
};

},{}],"jxZxy":[function(require,module,exports) {
module.exports = {
    "maximum": `M\xe1ximo`,
    "minimum": `M\xednimo`
};

},{}],"ih5Om":[function(require,module,exports) {
module.exports = {
    "maximum": `M\xe1ximo`,
    "minimum": `M\xednimo`
};

},{}],"JneiY":[function(require,module,exports) {
module.exports = {
    "maximum": `Maximum`,
    "minimum": `Minimum`
};

},{}],"4cy2W":[function(require,module,exports) {
module.exports = {
    "maximum": `\u{41C}\u{430}\u{43A}\u{441}\u{438}\u{43C}\u{443}\u{43C}`,
    "minimum": `\u{41C}\u{438}\u{43D}\u{438}\u{43C}\u{443}\u{43C}`
};

},{}],"eXB5p":[function(require,module,exports) {
module.exports = {
    "maximum": `Maximum`,
    "minimum": `Minimum`
};

},{}],"afuaT":[function(require,module,exports) {
module.exports = {
    "maximum": `Najve\u{10D}ji`,
    "minimum": `Najmanj`
};

},{}],"33dZR":[function(require,module,exports) {
module.exports = {
    "maximum": `Najvi\u{161}e`,
    "minimum": `Najmanje`
};

},{}],"3RJrK":[function(require,module,exports) {
module.exports = {
    "maximum": `Maximum`,
    "minimum": `Minimum`
};

},{}],"h6MN0":[function(require,module,exports) {
module.exports = {
    "maximum": `Maksimum`,
    "minimum": `Minimum`
};

},{}],"lWEfb":[function(require,module,exports) {
module.exports = {
    "maximum": `\u{41C}\u{430}\u{43A}\u{441}\u{438}\u{43C}\u{443}\u{43C}`,
    "minimum": `\u{41C}\u{456}\u{43D}\u{456}\u{43C}\u{443}\u{43C}`
};

},{}],"ibnOP":[function(require,module,exports) {
module.exports = {
    "maximum": `\u{6700}\u{5927}`,
    "minimum": `\u{6700}\u{5C0F}`
};

},{}],"5Dnwo":[function(require,module,exports) {
module.exports = {
    "maximum": `\u{6700}\u{5927}\u{503C}`,
    "minimum": `\u{6700}\u{5C0F}\u{503C}`
};

},{}],"12nOK":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /// <reference types="css-module-types" />
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StatusLight", ()=>(0, _statusLight.StatusLight));
var _statusLight = require("./StatusLight");

},{"./StatusLight":"gvAxb","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"gvAxb":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StatusLight", ()=>_StatusLight);
var _utils = require("@react-spectrum/utils");
var _utils1 = require("@react-aria/utils");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _varsCss = require("@adobe/spectrum-css-temp/components/statuslight/vars.css");
var _varsCssDefault = parcelHelpers.interopDefault(_varsCss);
var _provider = require("@react-spectrum/provider");
function StatusLight(props, ref) {
    let { variant, children, isDisabled, role, ...otherProps } = (0, _provider.useProviderProps)(props);
    let domRef = (0, _utils.useDOMRef)(ref);
    let { styleProps } = (0, _utils.useStyleProps)(otherProps);
    if (!children && !props["aria-label"]) console.warn("If no children are provided, an aria-label must be specified");
    if (!role && (props["aria-label"] || props["aria-labelledby"])) console.warn("A labelled StatusLight must have a role.");
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...(0, _utils1.filterDOMProps)(otherProps, {
            labelable: !!role
        }),
        ...styleProps,
        role: role,
        className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-StatusLight", `spectrum-StatusLight--${variant}`, {
            "is-disabled": isDisabled
        }, styleProps.className),
        ref: domRef
    }, children);
}
/**
 * Status lights are used to color code categories and labels commonly found in data visualization.
 * When status lights have a semantic meaning, they should use semantic variant colors.
 */ let _StatusLight = /*#__PURE__*/ (0, _react.forwardRef)(StatusLight);

},{"@react-spectrum/utils":"cMIJ6","@react-aria/utils":"9cLk5","react":"9yzVZ","@adobe/spectrum-css-temp/components/statuslight/vars.css":"lGs8V","@react-spectrum/provider":"5bCdp","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"lGs8V":[function(require,module,exports) {
module.exports["focus-ring"] = `j59EQa_focus-ring`;
module.exports["i18nFontFamily"] = `j59EQa_i18nFontFamily`;
module.exports["is-disabled"] = `j59EQa_is-disabled`;
module.exports["spectrum-FocusRing-ring"] = `j59EQa_spectrum-FocusRing-ring`;
module.exports["spectrum-FocusRing"] = `j59EQa_spectrum-FocusRing ${module.exports["spectrum-FocusRing-ring"]}`;
module.exports["spectrum-FocusRing--quiet"] = `j59EQa_spectrum-FocusRing--quiet`;
module.exports["spectrum-StatusLight"] = `j59EQa_spectrum-StatusLight`;
module.exports["spectrum-StatusLight--active"] = `j59EQa_spectrum-StatusLight--active`;
module.exports["spectrum-StatusLight--celery"] = `j59EQa_spectrum-StatusLight--celery`;
module.exports["spectrum-StatusLight--chartreuse"] = `j59EQa_spectrum-StatusLight--chartreuse`;
module.exports["spectrum-StatusLight--fuchsia"] = `j59EQa_spectrum-StatusLight--fuchsia`;
module.exports["spectrum-StatusLight--indigo"] = `j59EQa_spectrum-StatusLight--indigo`;
module.exports["spectrum-StatusLight--info"] = `j59EQa_spectrum-StatusLight--info`;
module.exports["spectrum-StatusLight--magenta"] = `j59EQa_spectrum-StatusLight--magenta`;
module.exports["spectrum-StatusLight--negative"] = `j59EQa_spectrum-StatusLight--negative`;
module.exports["spectrum-StatusLight--neutral"] = `j59EQa_spectrum-StatusLight--neutral`;
module.exports["spectrum-StatusLight--notice"] = `j59EQa_spectrum-StatusLight--notice`;
module.exports["spectrum-StatusLight--positive"] = `j59EQa_spectrum-StatusLight--positive`;
module.exports["spectrum-StatusLight--purple"] = `j59EQa_spectrum-StatusLight--purple`;
module.exports["spectrum-StatusLight--seafoam"] = `j59EQa_spectrum-StatusLight--seafoam`;
module.exports["spectrum-StatusLight--yellow"] = `j59EQa_spectrum-StatusLight--yellow`;

},{}],"87IGq":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /// <reference types="css-module-types" />
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TabList", ()=>(0, _tabs.TabList));
parcelHelpers.export(exports, "TabPanels", ()=>(0, _tabs.TabPanels));
parcelHelpers.export(exports, "Tabs", ()=>(0, _tabs.Tabs));
parcelHelpers.export(exports, "Item", ()=>(0, _collections.Item));
var _tabs = require("./Tabs");
var _collections = require("@react-stately/collections");

},{"./Tabs":"bmSHs","@react-stately/collections":"loANi","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"bmSHs":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * A TabList is used within Tabs to group tabs that a user can switch between.
 * The keys of the items within the <TabList> must match up with a corresponding item inside the <TabPanels>.
 */ parcelHelpers.export(exports, "TabList", ()=>TabList);
/**
 * TabPanels is used within Tabs as a container for the content of each tab.
 * The keys of the items within the <TabPanels> must match up with a corresponding item inside the <TabList>.
 */ parcelHelpers.export(exports, "TabPanels", ()=>TabPanels);
parcelHelpers.export(exports, "Tabs", ()=>_Tabs);
var _utils = require("@react-spectrum/utils");
var _utils1 = require("@react-aria/utils");
var _focus = require("@react-aria/focus");
var _picker = require("@react-spectrum/picker");
var _list = require("@react-stately/list");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _varsCss = require("@adobe/spectrum-css-temp/components/tabs/vars.css");
var _varsCssDefault = parcelHelpers.interopDefault(_varsCss);
var _tabs = require("@react-stately/tabs");
var _text = require("@react-spectrum/text");
var _collections = require("@react-stately/collections");
var _interactions = require("@react-aria/interactions");
var _i18N = require("@react-aria/i18n");
var _provider = require("@react-spectrum/provider");
var _tabs1 = require("@react-aria/tabs");
const TabContext = /*#__PURE__*/ (0, _reactDefault.default).createContext(null);
function Tabs(props, ref) {
    props = (0, _provider.useProviderProps)(props);
    let { orientation = "horizontal", density = "regular", children, ...otherProps } = props;
    let domRef = (0, _utils.useDOMRef)(ref);
    let tablistRef = (0, _react.useRef)();
    let wrapperRef = (0, _react.useRef)();
    let { direction } = (0, _i18N.useLocale)();
    let { styleProps } = (0, _utils.useStyleProps)(otherProps);
    let [collapsed, setCollapsed] = (0, _react.useState)(false);
    let [selectedTab, setSelectedTab] = (0, _react.useState)();
    const [tabListState, setTabListState] = (0, _react.useState)(null);
    let [tabPositions, setTabPositions] = (0, _react.useState)([]);
    let prevTabPositions = (0, _react.useRef)(tabPositions);
    (0, _react.useEffect)(()=>{
        if (tablistRef.current) {
            var _tabListState_selectedKey;
            let selectedTab = tablistRef.current.querySelector(`[data-key="${CSS.escape(tabListState === null || tabListState === void 0 ? void 0 : (_tabListState_selectedKey = tabListState.selectedKey) === null || _tabListState_selectedKey === void 0 ? void 0 : _tabListState_selectedKey.toString())}"]`);
            if (selectedTab != null) setSelectedTab(selectedTab);
        }
    // collapse is in the dep array so selectedTab can be updated for TabLine positioning
    }, [
        children,
        tabListState === null || tabListState === void 0 ? void 0 : tabListState.selectedKey,
        collapsed,
        tablistRef
    ]);
    let checkShouldCollapse = (0, _react.useCallback)(()=>{
        if (wrapperRef.current && orientation !== "vertical") {
            let tabsComponent = wrapperRef.current;
            let tabs = tablistRef.current.querySelectorAll('[role="tab"]');
            let tabDimensions = [
                ...tabs
            ].map((tab)=>tab.getBoundingClientRect());
            let end = direction === "rtl" ? "left" : "right";
            let farEdgeTabList = tabsComponent.getBoundingClientRect()[end];
            let farEdgeLastTab = tabDimensions[tabDimensions.length - 1][end];
            let shouldCollapse = direction === "rtl" ? farEdgeLastTab < farEdgeTabList : farEdgeTabList < farEdgeLastTab;
            setCollapsed(shouldCollapse);
            if (tabDimensions.length !== prevTabPositions.current.length || tabDimensions.some((box, index)=>{
                var _prevTabPositions_current_index, _prevTabPositions_current_index1;
                return (box === null || box === void 0 ? void 0 : box.left) !== ((_prevTabPositions_current_index = prevTabPositions.current[index]) === null || _prevTabPositions_current_index === void 0 ? void 0 : _prevTabPositions_current_index.left) || (box === null || box === void 0 ? void 0 : box.right) !== ((_prevTabPositions_current_index1 = prevTabPositions.current[index]) === null || _prevTabPositions_current_index1 === void 0 ? void 0 : _prevTabPositions_current_index1.right);
            })) {
                setTabPositions(tabDimensions);
                prevTabPositions.current = tabDimensions;
            }
        }
    }, [
        tablistRef,
        wrapperRef,
        direction,
        orientation,
        setCollapsed,
        prevTabPositions,
        setTabPositions
    ]);
    (0, _react.useEffect)(()=>{
        checkShouldCollapse();
    }, [
        children,
        checkShouldCollapse
    ]);
    (0, _utils1.useResizeObserver)({
        ref: wrapperRef,
        onResize: checkShouldCollapse
    });
    let tabPanelProps = {
        "aria-labelledby": undefined
    };
    // When the tabs are collapsed, the tabPanel should be labelled by the Picker button element.
    let collapsibleTabListId = (0, _utils1.useId)();
    if (collapsed && orientation !== "vertical") tabPanelProps["aria-labelledby"] = collapsibleTabListId;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(TabContext.Provider, {
        value: {
            tabProps: {
                ...props,
                orientation,
                density
            },
            tabState: {
                tabListState,
                setTabListState,
                selectedTab,
                collapsed
            },
            refs: {
                tablistRef,
                wrapperRef
            },
            tabPanelProps,
            tabLineState: tabPositions
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...(0, _utils1.filterDOMProps)(otherProps),
        ...styleProps,
        ref: domRef,
        className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-TabsPanel", `spectrum-TabsPanel--${orientation}`, styleProps.className)
    }, props.children));
}
// @private
function Tab(props) {
    let { item, state } = props;
    let { key, rendered } = item;
    let ref = (0, _react.useRef)();
    let { tabProps, isSelected, isDisabled } = (0, _tabs1.useTab)({
        key
    }, state, ref);
    let { hoverProps, isHovered } = (0, _interactions.useHover)({
        ...props
    });
    let ElementType = item.props.href ? "a" : "div";
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _focus.FocusRing), {
        focusRingClass: (0, _utils.classNames)((0, _varsCssDefault.default), "focus-ring")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(ElementType, {
        ...(0, _utils1.mergeProps)(tabProps, hoverProps),
        ref: ref,
        className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Tabs-item", {
            "is-selected": isSelected,
            "is-disabled": isDisabled,
            "is-hovered": isHovered
        })
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.SlotProvider), {
        slots: {
            icon: {
                size: "S",
                UNSAFE_className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Icon")
            },
            text: {
                UNSAFE_className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Tabs-itemLabel")
            }
        }
    }, typeof rendered === "string" ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, rendered) : rendered)));
}
// @private
function TabLine(props) {
    let { orientation, // Is either the tab node (non-collapsed) or the picker node (collapsed)
    selectedTab, // selectedKey is provided so that the TabLine styles are updated when the TabPicker's width updates from a selection change
    selectedKey } = props;
    let { direction } = (0, _i18N.useLocale)();
    let { scale } = (0, _provider.useProvider)();
    let { tabLineState } = (0, _react.useContext)(TabContext);
    let [style, setStyle] = (0, _react.useState)({
        width: undefined,
        height: undefined
    });
    let onResize = (0, _react.useCallback)(()=>{
        if (selectedTab) {
            var _selectedTab_offsetParent;
            let styleObj = {
                transform: undefined,
                width: undefined,
                height: undefined
            };
            // In RTL, calculate the transform from the right edge of the tablist so that resizing the window doesn't break the Tabline position due to offsetLeft changes
            let offset = direction === "rtl" ? -1 * (((_selectedTab_offsetParent = selectedTab.offsetParent) === null || _selectedTab_offsetParent === void 0 ? void 0 : _selectedTab_offsetParent.offsetWidth) - selectedTab.offsetWidth - selectedTab.offsetLeft) : selectedTab.offsetLeft;
            styleObj.transform = orientation === "vertical" ? `translateY(${selectedTab.offsetTop}px)` : `translateX(${offset}px)`;
            if (orientation === "horizontal") styleObj.width = `${selectedTab.offsetWidth}px`;
            else styleObj.height = `${selectedTab.offsetHeight}px`;
            setStyle(styleObj);
        }
    }, [
        direction,
        setStyle,
        selectedTab,
        orientation
    ]);
    (0, _utils1.useLayoutEffect)(()=>{
        onResize();
    }, [
        onResize,
        scale,
        selectedKey,
        tabLineState
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Tabs-selectionIndicator"),
        role: "presentation",
        style: style
    });
}
function TabList(props) {
    const tabContext = (0, _react.useContext)(TabContext);
    const { refs, tabState, tabProps, tabPanelProps } = tabContext;
    const { isQuiet, density, isEmphasized, orientation } = tabProps;
    const { selectedTab, collapsed, setTabListState } = tabState;
    const { tablistRef, wrapperRef } = refs;
    // Pass original Tab props but override children to create the collection.
    const state = (0, _tabs.useTabListState)({
        ...tabProps,
        children: props.children
    });
    let { styleProps } = (0, _utils.useStyleProps)(props);
    const { tabListProps } = (0, _tabs1.useTabList)({
        ...tabProps,
        ...props
    }, state, tablistRef);
    (0, _react.useEffect)(()=>{
        // Passing back to root as useTabPanel needs the TabListState
        setTabListState(state);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        state.disabledKeys,
        state.selectedItem,
        state.selectedKey,
        props.children
    ]);
    let collapseStyle = collapsed && orientation !== "vertical" ? {
        maxWidth: "calc(100% + 1px)",
        overflow: "hidden",
        visibility: "hidden",
        position: "absolute"
    } : {
        maxWidth: "calc(100% + 1px)"
    };
    let stylePropsFinal = orientation === "vertical" ? styleProps : {
        style: collapseStyle
    };
    if (collapsed && orientation !== "vertical") tabListProps["aria-hidden"] = true;
    let tabListclassName = (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-TabsPanel-tabs");
    const tabContent = /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...stylePropsFinal,
        ...tabListProps,
        ref: tablistRef,
        className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Tabs", `spectrum-Tabs--${orientation}`, tabListclassName, {
            "spectrum-Tabs--quiet": isQuiet,
            "spectrum-Tabs--emphasized": isEmphasized,
            ["spectrum-Tabs--compact"]: density === "compact"
        }, orientation === "vertical" && styleProps.className)
    }, [
        ...state.collection
    ].map((item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(Tab, {
            key: item.key,
            item: item,
            state: state,
            orientation: orientation
        })), /*#__PURE__*/ (0, _reactDefault.default).createElement(TabLine, {
        orientation: orientation,
        selectedTab: selectedTab
    }));
    if (orientation === "vertical") return tabContent;
    else return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...styleProps,
        ref: wrapperRef,
        className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-TabsPanel-collapseWrapper", styleProps.className)
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(TabPicker, {
        ...props,
        ...tabProps,
        visible: collapsed,
        id: tabPanelProps["aria-labelledby"],
        state: state,
        className: tabListclassName
    }), tabContent);
}
function TabPanels(props) {
    const { tabState, tabProps } = (0, _react.useContext)(TabContext);
    const { tabListState } = tabState;
    const factory = (0, _react.useCallback)((nodes)=>new (0, _list.ListCollection)(nodes), []);
    const collection = (0, _collections.useCollection)({
        items: tabProps.items,
        ...props
    }, factory, {
        suppressTextValueWarning: true
    });
    const selectedItem = tabListState ? collection.getItem(tabListState.selectedKey) : null;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(TabPanel, {
        ...props,
        key: tabListState === null || tabListState === void 0 ? void 0 : tabListState.selectedKey
    }, selectedItem && selectedItem.props.children);
}
// @private
function TabPanel(props) {
    const { tabState, tabPanelProps: ctxTabPanelProps } = (0, _react.useContext)(TabContext);
    const { tabListState } = tabState;
    let ref = (0, _react.useRef)();
    const { tabPanelProps } = (0, _tabs1.useTabPanel)(props, tabListState, ref);
    let { styleProps } = (0, _utils.useStyleProps)(props);
    if (ctxTabPanelProps["aria-labelledby"]) tabPanelProps["aria-labelledby"] = ctxTabPanelProps["aria-labelledby"];
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _focus.FocusRing), {
        focusRingClass: (0, _utils.classNames)((0, _varsCssDefault.default), "focus-ring")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...styleProps,
        ...tabPanelProps,
        ref: ref,
        className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-TabsPanel-tabpanel", styleProps.className)
    }, props.children));
}
function TabPicker(props) {
    let { isDisabled, isEmphasized, isQuiet, state, "aria-labelledby": ariaLabeledBy, "aria-label": ariaLabel, density, className, id, visible } = props;
    let ref = (0, _react.useRef)();
    let [pickerNode, setPickerNode] = (0, _react.useState)(null);
    (0, _react.useEffect)(()=>{
        let node = (0, _utils.unwrapDOMRef)(ref);
        setPickerNode(node.current);
    }, [
        ref
    ]);
    let items = [
        ...state.collection
    ];
    let pickerProps = {
        "aria-labelledby": ariaLabeledBy,
        "aria-label": ariaLabel
    };
    const style = visible ? {} : {
        visibility: "hidden",
        position: "absolute"
    };
    // TODO: Figure out if tabListProps should go onto the div here, v2 doesn't do it
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Tabs", "spectrum-Tabs--horizontal", "spectrum-Tabs--isCollapsed", {
            "spectrum-Tabs--quiet": isQuiet,
            ["spectrum-Tabs--compact"]: density === "compact",
            "spectrum-Tabs--emphasized": isEmphasized
        }, className),
        style: style,
        "aria-hidden": visible ? undefined : true
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.SlotProvider), {
        slots: {
            icon: {
                size: "S",
                UNSAFE_className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Icon")
            },
            button: {
                focusRingClass: (0, _utils.classNames)((0, _varsCssDefault.default), "focus-ring")
            }
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _picker.Picker), {
        ...pickerProps,
        id: id,
        items: items,
        ref: ref,
        isQuiet: true,
        isDisabled: !visible || isDisabled,
        selectedKey: state.selectedKey,
        disabledKeys: state.disabledKeys,
        onSelectionChange: state.setSelectedKey,
        UNSAFE_className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Tabs-picker")
    }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _picker.Item), item.props, item.rendered)), pickerNode && /*#__PURE__*/ (0, _reactDefault.default).createElement(TabLine, {
        orientation: "horizontal",
        selectedTab: pickerNode,
        selectedKey: state.selectedKey
    })));
}
/**
 * Tabs organize content into multiple sections and allow users to navigate between them. The content under the set of tabs should be related and form a coherent unit.
 */ // forwardRef doesn't support generic parameters, so cast the result to the correct type
// https://stackoverflow.com/questions/58469229/react-with-typescript-generics-while-using-react-forwardref
const _Tabs = /*#__PURE__*/ (0, _reactDefault.default).forwardRef(Tabs);

},{"@react-spectrum/utils":"cMIJ6","@react-aria/utils":"9cLk5","@react-aria/focus":"42mbF","@react-spectrum/picker":"kL1Uy","@react-stately/list":"Cp0zP","react":"9yzVZ","@adobe/spectrum-css-temp/components/tabs/vars.css":"fPF90","@react-stately/tabs":"47SYn","@react-spectrum/text":"etCGI","@react-stately/collections":"loANi","@react-aria/interactions":"ky3G8","@react-aria/i18n":"411rg","@react-spectrum/provider":"5bCdp","@react-aria/tabs":"9tXWP","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"fPF90":[function(require,module,exports) {
module.exports["focus-ring"] = `FzVSrW_focus-ring`;
module.exports["i18nFontFamily"] = `FzVSrW_i18nFontFamily`;
module.exports["is-disabled"] = `FzVSrW_is-disabled`;
module.exports["is-hovered"] = `FzVSrW_is-hovered`;
module.exports["is-selected"] = `FzVSrW_is-selected`;
module.exports["spectrum-FocusRing-ring"] = `FzVSrW_spectrum-FocusRing-ring`;
module.exports["spectrum-FocusRing"] = `FzVSrW_spectrum-FocusRing ${module.exports["spectrum-FocusRing-ring"]}`;
module.exports["spectrum-FocusRing--quiet"] = `FzVSrW_spectrum-FocusRing--quiet`;
module.exports["spectrum-Icon"] = `FzVSrW_spectrum-Icon`;
module.exports["spectrum-Tabs"] = `FzVSrW_spectrum-Tabs`;
module.exports["spectrum-Tabs--compact"] = `FzVSrW_spectrum-Tabs--compact`;
module.exports["spectrum-Tabs--emphasized"] = `FzVSrW_spectrum-Tabs--emphasized`;
module.exports["spectrum-Tabs--horizontal"] = `FzVSrW_spectrum-Tabs--horizontal`;
module.exports["spectrum-Tabs--isCollapsed"] = `FzVSrW_spectrum-Tabs--isCollapsed`;
module.exports["spectrum-Tabs--quiet"] = `FzVSrW_spectrum-Tabs--quiet`;
module.exports["spectrum-Tabs--vertical"] = `FzVSrW_spectrum-Tabs--vertical`;
module.exports["spectrum-Tabs-item"] = `FzVSrW_spectrum-Tabs-item`;
module.exports["spectrum-Tabs-itemLabel"] = `FzVSrW_spectrum-Tabs-itemLabel`;
module.exports["spectrum-Tabs-picker"] = `FzVSrW_spectrum-Tabs-picker`;
module.exports["spectrum-Tabs-selectionIndicator"] = `FzVSrW_spectrum-Tabs-selectionIndicator`;
module.exports["spectrum-TabsPanel"] = `FzVSrW_spectrum-TabsPanel`;
module.exports["spectrum-TabsPanel--horizontal"] = `FzVSrW_spectrum-TabsPanel--horizontal`;
module.exports["spectrum-TabsPanel--vertical"] = `FzVSrW_spectrum-TabsPanel--vertical`;
module.exports["spectrum-TabsPanel-collapseWrapper"] = `FzVSrW_spectrum-TabsPanel-collapseWrapper`;
module.exports["spectrum-TabsPanel-tabpanel"] = `FzVSrW_spectrum-TabsPanel-tabpanel`;
module.exports["spectrum-TabsPanel-tabs"] = `FzVSrW_spectrum-TabsPanel-tabs`;

},{}],"dM36P":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TagGroup", ()=>(0, _tagGroup.TagGroup));
parcelHelpers.export(exports, "Item", ()=>(0, _collections.Item));
var _tagGroup = require("./TagGroup");
var _collections = require("@react-stately/collections");

},{"./TagGroup":"iVSCD","@react-stately/collections":"loANi","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"iVSCD":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TagGroup", ()=>_TagGroup);
var _button = require("@react-spectrum/button");
var _tag = require("@react-aria/tag");
var _utils = require("@react-spectrum/utils");
var _label = require("@react-spectrum/label");
var _focus = require("@react-aria/focus");
// @ts-ignore
var _json = require("../intl/*.json");
var _jsonDefault = parcelHelpers.interopDefault(_json);
var _list = require("@react-stately/list");
var _selection = require("@react-aria/selection");
var _provider = require("@react-spectrum/provider");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _varsCss = require("@adobe/spectrum-css-temp/components/tags/vars.css");
var _varsCssDefault = parcelHelpers.interopDefault(_varsCss);
var _tag1 = require("./Tag");
var _form = require("@react-spectrum/form");
var _utils1 = require("@react-aria/utils");
var _i18N = require("@react-aria/i18n");
const TAG_STYLES = {
    medium: {
        height: 24,
        margin: 4
    },
    large: {
        height: 30,
        margin: 5
    }
};
function TagGroup(props, ref) {
    props = (0, _provider.useProviderProps)(props);
    props = (0, _form.useFormProps)(props);
    let { maxRows, children, actionLabel, onAction, labelPosition, renderEmptyState = ()=>stringFormatter.format("noTags") } = props;
    let domRef = (0, _utils.useDOMRef)(ref);
    let containerRef = (0, _react.useRef)(null);
    let tagsRef = (0, _react.useRef)(null);
    let { direction } = (0, _i18N.useLocale)();
    let { scale } = (0, _provider.useProvider)();
    let stringFormatter = (0, _i18N.useLocalizedStringFormatter)((0, _jsonDefault.default), "@react-spectrum/tag");
    let [isCollapsed, setIsCollapsed] = (0, _react.useState)(maxRows != null);
    let state = (0, _list.useListState)(props);
    let [tagState, setTagState] = (0, _utils1.useValueEffect)({
        visibleTagCount: state.collection.size,
        showCollapseButton: false
    });
    let keyboardDelegate = (0, _react.useMemo)(()=>{
        let collection = isCollapsed ? new (0, _list.ListCollection)([
            ...state.collection
        ].slice(0, tagState.visibleTagCount)) : new (0, _list.ListCollection)([
            ...state.collection
        ]);
        return new (0, _selection.ListKeyboardDelegate)({
            collection,
            ref: domRef,
            direction,
            orientation: "horizontal"
        });
    }, [
        direction,
        isCollapsed,
        state.collection,
        tagState.visibleTagCount,
        domRef
    ]);
    // Remove onAction from props so it doesn't make it into useGridList.
    delete props.onAction;
    let { gridProps, labelProps, descriptionProps, errorMessageProps } = (0, _tag.useTagGroup)({
        ...props,
        keyboardDelegate
    }, state, tagsRef);
    let actionsId = (0, _utils1.useId)();
    let actionsRef = (0, _react.useRef)(null);
    let updateVisibleTagCount = (0, _react.useCallback)(()=>{
        if (maxRows && maxRows > 0) {
            let computeVisibleTagCount = ()=>{
                // Refs can be null at runtime.
                let currContainerRef = containerRef.current;
                let currTagsRef = tagsRef.current;
                let currActionsRef = actionsRef.current;
                if (!currContainerRef || !currTagsRef || !currActionsRef || state.collection.size === 0) return {
                    visibleTagCount: 0,
                    showCollapseButton: false
                };
                // Count rows and show tags until we hit the maxRows.
                let tags = [
                    ...currTagsRef.children
                ];
                let currY = -Infinity;
                let rowCount = 0;
                let index = 0;
                let tagWidths = [];
                for (let tag of tags){
                    let { width, y } = tag.getBoundingClientRect();
                    if (y !== currY) {
                        currY = y;
                        rowCount++;
                    }
                    if (maxRows && rowCount > maxRows) break;
                    tagWidths.push(width);
                    index++;
                }
                // Remove tags until there is space for the collapse button and action button (if present) on the last row.
                let buttons = [
                    ...currActionsRef.children
                ];
                if (maxRows && buttons.length > 0 && rowCount >= maxRows) {
                    var _tags_;
                    let buttonsWidth = buttons.reduce((acc, curr)=>acc += curr.getBoundingClientRect().width, 0);
                    buttonsWidth += TAG_STYLES[scale].margin * 2 * buttons.length;
                    let end = direction === "ltr" ? "right" : "left";
                    let containerEnd = currContainerRef.parentElement.getBoundingClientRect()[end];
                    let lastTagEnd = (_tags_ = tags[index - 1]) === null || _tags_ === void 0 ? void 0 : _tags_.getBoundingClientRect()[end];
                    lastTagEnd += TAG_STYLES[scale].margin;
                    let availableWidth = containerEnd - lastTagEnd;
                    while(availableWidth < buttonsWidth && index > 0){
                        availableWidth += tagWidths.pop();
                        index--;
                    }
                }
                return {
                    visibleTagCount: Math.max(index, 1),
                    showCollapseButton: index < state.collection.size
                };
            };
            setTagState(function*() {
                // Update to show all items.
                yield {
                    visibleTagCount: state.collection.size,
                    showCollapseButton: true
                };
                // Measure, and update to show the items until maxRows is reached.
                yield computeVisibleTagCount();
            });
        }
    }, [
        maxRows,
        setTagState,
        direction,
        scale,
        state.collection.size
    ]);
    (0, _utils1.useResizeObserver)({
        ref: containerRef,
        onResize: updateVisibleTagCount
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, _utils1.useLayoutEffect)(updateVisibleTagCount, [
        children
    ]);
    (0, _react.useEffect)(()=>{
        var // Recalculate visible tags when fonts are loaded.
        _document_fonts;
        (_document_fonts = document.fonts) === null || _document_fonts === void 0 ? void 0 : _document_fonts.ready.then(()=>updateVisibleTagCount());
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let visibleTags = (0, _react.useMemo)(()=>[
            ...state.collection
        ].slice(0, isCollapsed ? tagState.visibleTagCount : state.collection.size), [
        isCollapsed,
        state.collection,
        tagState.visibleTagCount
    ]);
    let handlePressCollapse = ()=>{
        // Prevents button from losing focus if focusedKey got collapsed.
        state.selectionManager.setFocusedKey(null);
        setIsCollapsed((prevCollapsed)=>!prevCollapsed);
    };
    let showActions = tagState.showCollapseButton || actionLabel && onAction;
    let isEmpty = state.collection.size === 0;
    let containerStyle = (0, _react.useMemo)(()=>{
        if (maxRows == null || !isCollapsed || isEmpty) return undefined;
        let maxHeight = (TAG_STYLES[scale].height + TAG_STYLES[scale].margin * 2) * maxRows;
        return {
            maxHeight,
            overflow: "hidden"
        };
    }, [
        isCollapsed,
        maxRows,
        isEmpty,
        scale
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _focus.FocusScope), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _label.Field), {
        ...props,
        labelProps: labelProps,
        descriptionProps: descriptionProps,
        errorMessageProps: errorMessageProps,
        showErrorIcon: true,
        ref: domRef,
        elementType: "span",
        wrapperClassName: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Tags-fieldWrapper", {
            "spectrum-Tags-fieldWrapper--positionSide": labelPosition === "side"
        })
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ref: containerRef,
        style: containerStyle,
        className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Tags-container", {
            "spectrum-Tags-container--empty": isEmpty
        })
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _focus.FocusRing), {
        focusRingClass: (0, _utils.classNames)((0, _varsCssDefault.default), "focus-ring")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ref: tagsRef,
        ...gridProps,
        className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Tags")
    }, visibleTags.map((item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _tag1.Tag), {
            ...item.props,
            key: item.key,
            item: item,
            state: state
        }, item.rendered)), isEmpty && /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Tags-empty-state")
    }, renderEmptyState()))), showActions && !isEmpty && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _provider.Provider), {
        isDisabled: false
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        role: "group",
        ref: actionsRef,
        id: actionsId,
        "aria-label": stringFormatter.format("actions"),
        "aria-labelledby": `${gridProps.id} ${actionsId}`,
        className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Tags-actions")
    }, tagState.showCollapseButton && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), {
        isQuiet: true,
        onPress: handlePressCollapse,
        UNSAFE_className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Tags-actionButton")
    }, isCollapsed ? stringFormatter.format("showAllButtonLabel", {
        tagCount: state.collection.size
    }) : stringFormatter.format("hideButtonLabel")), actionLabel && onAction && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), {
        isQuiet: true,
        onPress: ()=>onAction === null || onAction === void 0 ? void 0 : onAction(),
        UNSAFE_className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Tags-actionButton")
    }, actionLabel))))));
}
/** Tags allow users to categorize content. They can represent keywords or people, and are grouped to describe an item or a search request. */ const _TagGroup = /*#__PURE__*/ (0, _reactDefault.default).forwardRef(TagGroup);

},{"@react-spectrum/button":"jZWyP","@react-aria/tag":"bGZEL","@react-spectrum/utils":"cMIJ6","@react-spectrum/label":"6qv6N","@react-aria/focus":"42mbF","../intl/*.json":"6NThA","@react-stately/list":"Cp0zP","@react-aria/selection":"6Fly5","@react-spectrum/provider":"5bCdp","react":"9yzVZ","@adobe/spectrum-css-temp/components/tags/vars.css":"b2NwJ","./Tag":"6zUwy","@react-spectrum/form":"bGDqA","@react-aria/utils":"9cLk5","@react-aria/i18n":"411rg","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"6NThA":[function(require,module,exports) {
const _temp0 = require("4559aff809fca450");
const _temp1 = require("abb10a665310e73f");
const _temp2 = require("a04554dc9ba9720f");
const _temp3 = require("758a604d40af6951");
const _temp4 = require("13021e8b484a4019");
const _temp5 = require("42276e691f187435");
const _temp6 = require("10c3d4db7a8cff9d");
const _temp7 = require("feeff427f6772753");
const _temp8 = require("85b1d62fccc9da1e");
const _temp9 = require("ef1aa7c7e41e99c");
const _temp10 = require("925dcf7ffa47fc79");
const _temp11 = require("8844a8164514601d");
const _temp12 = require("2f6b222788e60010");
const _temp13 = require("878b82c911239a8a");
const _temp14 = require("aee7f7765b421a34");
const _temp15 = require("f54f4891e33420e6");
const _temp16 = require("5fbfdc89fd2433ed");
const _temp17 = require("4d1885b3c83c2d9c");
const _temp18 = require("9b8d4dfcc08744f2");
const _temp19 = require("ad7b5cc30d971c23");
const _temp20 = require("699103c1e25d4356");
const _temp21 = require("4a442a735e73a339");
const _temp22 = require("7716e523f08828e0");
const _temp23 = require("124347e8c15c73ec");
const _temp24 = require("c99226e58735e9af");
const _temp25 = require("fe99732d6951bf0e");
const _temp26 = require("a21d047d80d64e34");
const _temp27 = require("7873a97d65da0f0a");
const _temp28 = require("b23a5591bcf9385c");
const _temp29 = require("254e1050ad0751fb");
const _temp30 = require("a5989e16b8d4ab86");
const _temp31 = require("64fd1587755e3084");
const _temp32 = require("ebe1d5e74241a094");
const _temp33 = require("82cf374e1cae46e3");
module.exports = {
    "ar-AE": _temp0,
    "bg-BG": _temp1,
    "cs-CZ": _temp2,
    "da-DK": _temp3,
    "de-DE": _temp4,
    "el-GR": _temp5,
    "en-US": _temp6,
    "es-ES": _temp7,
    "et-EE": _temp8,
    "fi-FI": _temp9,
    "fr-FR": _temp10,
    "he-IL": _temp11,
    "hr-HR": _temp12,
    "hu-HU": _temp13,
    "it-IT": _temp14,
    "ja-JP": _temp15,
    "ko-KR": _temp16,
    "lt-LT": _temp17,
    "lv-LV": _temp18,
    "nb-NO": _temp19,
    "nl-NL": _temp20,
    "pl-PL": _temp21,
    "pt-BR": _temp22,
    "pt-PT": _temp23,
    "ro-RO": _temp24,
    "ru-RU": _temp25,
    "sk-SK": _temp26,
    "sl-SI": _temp27,
    "sr-SP": _temp28,
    "sv-SE": _temp29,
    "tr-TR": _temp30,
    "uk-UA": _temp31,
    "zh-CN": _temp32,
    "zh-TW": _temp33
};

},{"4559aff809fca450":"6sNqc","abb10a665310e73f":"ktWjM","a04554dc9ba9720f":"bebbg","758a604d40af6951":"lEaV8","13021e8b484a4019":"koq3g","42276e691f187435":"esVIx","10c3d4db7a8cff9d":"57a6u","feeff427f6772753":"1OqFj","85b1d62fccc9da1e":"80wVF","ef1aa7c7e41e99c":"78lyC","925dcf7ffa47fc79":"hTy8W","8844a8164514601d":"iOamq","2f6b222788e60010":"9clX1","878b82c911239a8a":"cq5R8","aee7f7765b421a34":"c8zwm","f54f4891e33420e6":"aDHws","5fbfdc89fd2433ed":"iBEXp","4d1885b3c83c2d9c":"41Yxk","9b8d4dfcc08744f2":"auwqn","ad7b5cc30d971c23":"5UrkI","699103c1e25d4356":"3aRQQ","4a442a735e73a339":"8n14t","7716e523f08828e0":"femRG","124347e8c15c73ec":"6s4ec","c99226e58735e9af":"64LWo","fe99732d6951bf0e":"dA9YW","a21d047d80d64e34":"5wI0m","7873a97d65da0f0a":"jI6fS","b23a5591bcf9385c":"5fnV7","254e1050ad0751fb":"lInRp","a5989e16b8d4ab86":"2gPml","64fd1587755e3084":"4FgF9","ebe1d5e74241a094":"27HVV","82cf374e1cae46e3":"dR349"}],"6sNqc":[function(require,module,exports) {
module.exports = {
    "actions": `\u{627}\u{644}\u{625}\u{62C}\u{631}\u{627}\u{621}\u{627}\u{62A}`,
    "hideButtonLabel": `\u{625}\u{638}\u{647}\u{627}\u{631} \u{623}\u{642}\u{644}`,
    "noTags": `\u{628}\u{62F}\u{648}\u{646}`,
    "showAllButtonLabel": (args, formatter)=>`\u{639}\u{631}\u{636} \u{627}\u{644}\u{643}\u{644} (${formatter.number(args.tagCount)})`
};

},{}],"ktWjM":[function(require,module,exports) {
module.exports = {
    "actions": `\u{414}\u{435}\u{439}\u{441}\u{442}\u{432}\u{438}\u{44F}`,
    "hideButtonLabel": `\u{41F}\u{43E}\u{43A}\u{430}\u{437}\u{432}\u{430}\u{43D}\u{435} \u{43D}\u{430} \u{43F}\u{43E}-\u{43C}\u{430}\u{43B}\u{43A}\u{43E}`,
    "noTags": `\u{41D}\u{438}\u{442}\u{43E} \u{435}\u{434}\u{438}\u{43D}`,
    "showAllButtonLabel": (args, formatter)=>`\u{41F}\u{43E}\u{43A}\u{430}\u{437}\u{432}\u{430}\u{43D}\u{435} \u{43D}\u{430} \u{432}\u{441}\u{438}\u{447}\u{43A}\u{438} (${formatter.number(args.tagCount)})`
};

},{}],"bebbg":[function(require,module,exports) {
module.exports = {
    "actions": `Akce`,
    "hideButtonLabel": `Zobrazit m\xe9n\u{11B}`,
    "noTags": `\u{17D}\xe1dn\xfd`,
    "showAllButtonLabel": (args, formatter)=>`Zobrazit v\u{161}e (${formatter.number(args.tagCount)})`
};

},{}],"lEaV8":[function(require,module,exports) {
module.exports = {
    "actions": `Handlinger`,
    "hideButtonLabel": `Vis mindre`,
    "noTags": `Ingen`,
    "showAllButtonLabel": (args, formatter)=>`Vis alle (${formatter.number(args.tagCount)})`
};

},{}],"koq3g":[function(require,module,exports) {
module.exports = {
    "actions": `Aktionen`,
    "hideButtonLabel": `Weniger zeigen`,
    "noTags": `Keine`,
    "showAllButtonLabel": (args, formatter)=>`Alle anzeigen (${formatter.number(args.tagCount)})`
};

},{}],"esVIx":[function(require,module,exports) {
module.exports = {
    "actions": `\u{395}\u{3BD}\u{3AD}\u{3C1}\u{3B3}\u{3B5}\u{3B9}\u{3B5}\u{3C2}`,
    "hideButtonLabel": `\u{395}\u{3BC}\u{3C6}\u{3AC}\u{3BD}\u{3B9}\u{3C3}\u{3B7} \u{3BB}\u{3B9}\u{3B3}\u{3CC}\u{3C4}\u{3B5}\u{3C1}\u{3C9}\u{3BD}`,
    "noTags": `\u{39A}\u{3B1}\u{3BD}\u{3AD}\u{3BD}\u{3B1}`,
    "showAllButtonLabel": (args, formatter)=>`\u{395}\u{3BC}\u{3C6}\u{3AC}\u{3BD}\u{3B9}\u{3C3}\u{3B7} \u{3CC}\u{3BB}\u{3C9}\u{3BD} (${formatter.number(args.tagCount)})`
};

},{}],"57a6u":[function(require,module,exports) {
module.exports = {
    "showAllButtonLabel": (args, formatter)=>`Show all (${formatter.number(args.tagCount)})`,
    "hideButtonLabel": `Show less`,
    "actions": `Actions`,
    "noTags": `None`
};

},{}],"1OqFj":[function(require,module,exports) {
module.exports = {
    "actions": `Acciones`,
    "hideButtonLabel": `Mostrar menos`,
    "noTags": `Ninguno`,
    "showAllButtonLabel": (args, formatter)=>`Mostrar todo (${formatter.number(args.tagCount)})`
};

},{}],"80wVF":[function(require,module,exports) {
module.exports = {
    "actions": `Toimingud`,
    "hideButtonLabel": `Kuva v\xe4hem`,
    "noTags": `Puudub`,
    "showAllButtonLabel": (args, formatter)=>`Kuva k\xf5ik (${formatter.number(args.tagCount)})`
};

},{}],"78lyC":[function(require,module,exports) {
module.exports = {
    "actions": `Toiminnot`,
    "hideButtonLabel": `N\xe4yt\xe4 v\xe4hemm\xe4n`,
    "noTags": `Ei mit\xe4\xe4n`,
    "showAllButtonLabel": (args, formatter)=>`N\xe4yt\xe4 kaikki (${formatter.number(args.tagCount)})`
};

},{}],"hTy8W":[function(require,module,exports) {
module.exports = {
    "actions": `Actions`,
    "hideButtonLabel": `Afficher moins`,
    "noTags": `Aucun`,
    "showAllButtonLabel": (args, formatter)=>`Tout afficher (${formatter.number(args.tagCount)})`
};

},{}],"iOamq":[function(require,module,exports) {
module.exports = {
    "actions": `\u{5E4}\u{5E2}\u{5D5}\u{5DC}\u{5D5}\u{5EA}`,
    "hideButtonLabel": `\u{5D4}\u{5E6}\u{5D2} \u{5E4}\u{5D7}\u{5D5}\u{5EA}`,
    "noTags": `\u{5DC}\u{5DC}\u{5D0}`,
    "showAllButtonLabel": (args, formatter)=>`\u{5D4}\u{5E6}\u{5D2} \u{5D4}\u{5DB}\u{5DC} (${formatter.number(args.tagCount)})`
};

},{}],"9clX1":[function(require,module,exports) {
module.exports = {
    "actions": `Radnje`,
    "hideButtonLabel": `Prika\u{17E}i manje`,
    "noTags": `Nema`,
    "showAllButtonLabel": (args, formatter)=>`Prika\u{17E}i sve (${formatter.number(args.tagCount)})`
};

},{}],"cq5R8":[function(require,module,exports) {
module.exports = {
    "actions": `M\u{171}veletek`,
    "hideButtonLabel": `Mutass kevesebbet`,
    "noTags": `Egyik sem`,
    "showAllButtonLabel": (args, formatter)=>`Az \xf6sszes megjelen\xedt\xe9se (${formatter.number(args.tagCount)})`
};

},{}],"c8zwm":[function(require,module,exports) {
module.exports = {
    "actions": `Azioni`,
    "hideButtonLabel": `Mostra meno`,
    "noTags": `Nessuno`,
    "showAllButtonLabel": (args, formatter)=>`Mostra tutto (${formatter.number(args.tagCount)})`
};

},{}],"aDHws":[function(require,module,exports) {
module.exports = {
    "actions": `\u{30A2}\u{30AF}\u{30B7}\u{30E7}\u{30F3}`,
    "hideButtonLabel": `\u{8868}\u{793A}\u{3092}\u{6E1B}\u{3089}\u{3059}`,
    "noTags": `\u{306A}\u{3057}`,
    "showAllButtonLabel": (args, formatter)=>`\u{3059}\u{3079}\u{3066}\u{306E} (${formatter.number(args.tagCount)}) \u{3092}\u{8868}\u{793A}`
};

},{}],"iBEXp":[function(require,module,exports) {
module.exports = {
    "actions": `\u{C561}\u{C158}`,
    "hideButtonLabel": `\u{AC04}\u{B2E8}\u{D788} \u{D45C}\u{C2DC}`,
    "noTags": `\u{C5C6}\u{C74C}`,
    "showAllButtonLabel": (args, formatter)=>`\u{BAA8}\u{B450} \u{D45C}\u{C2DC} (${formatter.number(args.tagCount)})`
};

},{}],"41Yxk":[function(require,module,exports) {
module.exports = {
    "actions": `Veiksmai`,
    "hideButtonLabel": `Rodyti ma\u{17E}iau`,
    "noTags": `N\u{117}ra`,
    "showAllButtonLabel": (args, formatter)=>`Rodyti visk\u{105} (${formatter.number(args.tagCount)})`
};

},{}],"auwqn":[function(require,module,exports) {
module.exports = {
    "actions": `Darb\u{12B}bas`,
    "hideButtonLabel": `R\u{101}d\u{12B}t maz\u{101}k`,
    "noTags": `Nav`,
    "showAllButtonLabel": (args, formatter)=>`R\u{101}d\u{12B}t visu (${formatter.number(args.tagCount)})`
};

},{}],"5UrkI":[function(require,module,exports) {
module.exports = {
    "actions": `Handlinger`,
    "hideButtonLabel": `Vis mindre`,
    "noTags": `Ingen`,
    "showAllButtonLabel": (args, formatter)=>`Vis alle (${formatter.number(args.tagCount)})`
};

},{}],"3aRQQ":[function(require,module,exports) {
module.exports = {
    "actions": `Acties`,
    "hideButtonLabel": `Minder weergeven`,
    "noTags": `Geen`,
    "showAllButtonLabel": (args, formatter)=>`Alles tonen (${formatter.number(args.tagCount)})`
};

},{}],"8n14t":[function(require,module,exports) {
module.exports = {
    "actions": `Dzia\u{142}ania`,
    "hideButtonLabel": `Wy\u{15B}wietl mniej`,
    "noTags": `Brak`,
    "showAllButtonLabel": (args, formatter)=>`Poka\u{17C} wszystko (${formatter.number(args.tagCount)})`
};

},{}],"femRG":[function(require,module,exports) {
module.exports = {
    "actions": `A\xe7\xf5es`,
    "hideButtonLabel": `Mostrar menos`,
    "noTags": `Nenhum`,
    "showAllButtonLabel": (args, formatter)=>`Mostrar tudo (${formatter.number(args.tagCount)})`
};

},{}],"6s4ec":[function(require,module,exports) {
module.exports = {
    "actions": `A\xe7\xf5es`,
    "hideButtonLabel": `Mostrar menos`,
    "noTags": `Nenhum`,
    "showAllButtonLabel": (args, formatter)=>`Mostrar tudo (${formatter.number(args.tagCount)})`
};

},{}],"64LWo":[function(require,module,exports) {
module.exports = {
    "actions": `Ac\u{21B}iuni`,
    "hideButtonLabel": `Se afi\u{219}eaz\u{103} mai pu\u{21B}in`,
    "noTags": `Niciuna`,
    "showAllButtonLabel": (args, formatter)=>`Se afi\u{219}eaz\u{103} tot (${formatter.number(args.tagCount)})`
};

},{}],"dA9YW":[function(require,module,exports) {
module.exports = {
    "actions": `\u{414}\u{435}\u{439}\u{441}\u{442}\u{432}\u{438}\u{44F}`,
    "hideButtonLabel": `\u{41F}\u{43E}\u{43A}\u{430}\u{437}\u{430}\u{442}\u{44C} \u{43C}\u{435}\u{43D}\u{44C}\u{448}\u{435}`,
    "noTags": `\u{41D}\u{435}\u{442}`,
    "showAllButtonLabel": (args, formatter)=>`\u{41F}\u{43E}\u{43A}\u{430}\u{437}\u{430}\u{442}\u{44C} \u{432}\u{441}\u{435} (${formatter.number(args.tagCount)})`
};

},{}],"5wI0m":[function(require,module,exports) {
module.exports = {
    "actions": `Akcie`,
    "hideButtonLabel": `Zobrazi\u{165} menej`,
    "noTags": `\u{17D}iadne`,
    "showAllButtonLabel": (args, formatter)=>`Zobrazi\u{165} v\u{161}etko (${formatter.number(args.tagCount)})`
};

},{}],"jI6fS":[function(require,module,exports) {
module.exports = {
    "actions": `Dejanja`,
    "hideButtonLabel": `Prika\u{17E}i manj`,
    "noTags": `Ni\u{10D}`,
    "showAllButtonLabel": (args, formatter)=>`Prika\u{17E} vse (${formatter.number(args.tagCount)})`
};

},{}],"5fnV7":[function(require,module,exports) {
module.exports = {
    "actions": `Radnje`,
    "hideButtonLabel": `Prika\u{17E}i manje`,
    "noTags": `Ne postoji`,
    "showAllButtonLabel": (args, formatter)=>`Prika\u{17E}i sve (${formatter.number(args.tagCount)})`
};

},{}],"lInRp":[function(require,module,exports) {
module.exports = {
    "actions": `\xc5tg\xe4rder`,
    "hideButtonLabel": `Visa mindre`,
    "noTags": `Ingen`,
    "showAllButtonLabel": (args, formatter)=>`Visa alla (${formatter.number(args.tagCount)})`
};

},{}],"2gPml":[function(require,module,exports) {
module.exports = {
    "actions": `Eylemler`,
    "hideButtonLabel": `Daha az g\xf6ster`,
    "noTags": `Hi\xe7biri`,
    "showAllButtonLabel": (args, formatter)=>`T\xfcm\xfcn\xfc g\xf6ster (${formatter.number(args.tagCount)})`
};

},{}],"4FgF9":[function(require,module,exports) {
module.exports = {
    "actions": `\u{414}\u{456}\u{457}`,
    "hideButtonLabel": `\u{41F}\u{43E}\u{43A}\u{430}\u{437}\u{443}\u{432}\u{430}\u{442}\u{438} \u{43C}\u{435}\u{43D}\u{448}\u{435}`,
    "noTags": `\u{41D}\u{435}\u{43C}\u{430}\u{454}`,
    "showAllButtonLabel": (args, formatter)=>`\u{41F}\u{43E}\u{43A}\u{430}\u{437}\u{430}\u{442}\u{438} \u{432}\u{441}\u{456} (${formatter.number(args.tagCount)})`
};

},{}],"27HVV":[function(require,module,exports) {
module.exports = {
    "actions": `\u{64CD}\u{4F5C}`,
    "hideButtonLabel": `\u{663E}\u{793A}\u{66F4}\u{5C11}`,
    "noTags": `\u{65E0}`,
    "showAllButtonLabel": (args, formatter)=>`\u{5168}\u{90E8}\u{663E}\u{793A} (${formatter.number(args.tagCount)})`
};

},{}],"dR349":[function(require,module,exports) {
module.exports = {
    "actions": `\u{52D5}\u{4F5C}`,
    "hideButtonLabel": `\u{986F}\u{793A}\u{8F03}\u{5C11}`,
    "noTags": `\u{7121}`,
    "showAllButtonLabel": (args, formatter)=>`\u{986F}\u{793A}\u{5168}\u{90E8} (${formatter.number(args.tagCount)})`
};

},{}],"b2NwJ":[function(require,module,exports) {
module.exports["action"] = `fx8d1q_action`;
module.exports["content"] = `fx8d1q_content`;
module.exports["decoration"] = `fx8d1q_decoration`;
module.exports["focus-ring"] = `fx8d1q_focus-ring`;
module.exports["i18nFontFamily"] = `fx8d1q_i18nFontFamily`;
module.exports["is-disabled"] = `fx8d1q_is-disabled`;
module.exports["is-focused"] = `fx8d1q_is-focused`;
module.exports["is-hovered"] = `fx8d1q_is-hovered`;
module.exports["spectrum-FocusRing-ring"] = `fx8d1q_spectrum-FocusRing-ring`;
module.exports["spectrum-FocusRing"] = `fx8d1q_spectrum-FocusRing ${module.exports["spectrum-FocusRing-ring"]}`;
module.exports["spectrum-FocusRing--quiet"] = `fx8d1q_spectrum-FocusRing--quiet`;
module.exports["spectrum-Tag"] = `fx8d1q_spectrum-Tag ${module.exports["spectrum-FocusRing"]}`;
module.exports["spectrum-Tag--removable"] = `fx8d1q_spectrum-Tag--removable`;
module.exports["spectrum-Tag-avatar"] = `fx8d1q_spectrum-Tag-avatar`;
module.exports["spectrum-Tag-cell"] = `fx8d1q_spectrum-Tag-cell`;
module.exports["spectrum-Tag-content"] = `fx8d1q_spectrum-Tag-content`;
module.exports["spectrum-Tag-icon"] = `fx8d1q_spectrum-Tag-icon`;
module.exports["spectrum-Tag-removeButton"] = `fx8d1q_spectrum-Tag-removeButton`;
module.exports["spectrum-Tags"] = `fx8d1q_spectrum-Tags`;
module.exports["spectrum-Tags-actionButton"] = `fx8d1q_spectrum-Tags-actionButton`;
module.exports["spectrum-Tags-actions"] = `fx8d1q_spectrum-Tags-actions`;
module.exports["spectrum-Tags-container"] = `fx8d1q_spectrum-Tags-container`;
module.exports["spectrum-Tags-container--empty"] = `fx8d1q_spectrum-Tags-container--empty`;
module.exports["spectrum-Tags-empty-state"] = `fx8d1q_spectrum-Tags-empty-state`;
module.exports["spectrum-Tags-fieldWrapper"] = `fx8d1q_spectrum-Tags-fieldWrapper`;
module.exports["spectrum-Tags-fieldWrapper--positionSide"] = `fx8d1q_spectrum-Tags-fieldWrapper--positionSide`;

},{}],"6zUwy":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Tag", ()=>Tag);
var _tag = require("@react-aria/tag");
var _utils = require("@react-spectrum/utils");
var _button = require("@react-spectrum/button");
var _utils1 = require("@react-aria/utils");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _varsCss = require("@adobe/spectrum-css-temp/components/tags/vars.css");
var _varsCssDefault = parcelHelpers.interopDefault(_varsCss);
var _text = require("@react-spectrum/text");
var _focus = require("@react-aria/focus");
var _interactions = require("@react-aria/interactions");
function Tag(props) {
    const { item, state, ...otherProps } = props;
    // @ts-ignore
    let { styleProps } = (0, _utils.useStyleProps)(otherProps);
    let { hoverProps, isHovered } = (0, _interactions.useHover)({});
    let { isFocused, isFocusVisible, focusProps } = (0, _focus.useFocusRing)({
        within: true
    });
    let ref = (0, _react.useRef)(null);
    let { removeButtonProps, gridCellProps, rowProps, allowsRemoving } = (0, _tag.useTag)({
        ...props,
        item
    }, state, ref);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...(0, _utils1.mergeProps)(rowProps, hoverProps, focusProps),
        className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Tag", {
            "focus-ring": isFocusVisible,
            "is-focused": isFocused,
            "is-hovered": isHovered,
            "spectrum-Tag--removable": allowsRemoving
        }, styleProps.className),
        ref: ref
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Tag-cell"),
        ...gridCellProps
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.SlotProvider), {
        slots: {
            icon: {
                UNSAFE_className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Tag-icon"),
                size: "XS"
            },
            text: {
                UNSAFE_className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Tag-content")
            },
            avatar: {
                UNSAFE_className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Tag-avatar"),
                size: "avatar-size-50"
            }
        }
    }, typeof item.rendered === "string" ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, item.rendered) : item.rendered, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.ClearSlots), null, allowsRemoving && /*#__PURE__*/ (0, _reactDefault.default).createElement(TagRemoveButton, {
        item: item,
        ...removeButtonProps,
        UNSAFE_className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Tag-removeButton")
    })))));
}
function TagRemoveButton(props) {
    let { styleProps } = (0, _utils.useStyleProps)(props);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("span", styleProps, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ClearButton), props));
}

},{"@react-aria/tag":"bGZEL","@react-spectrum/utils":"cMIJ6","@react-spectrum/button":"jZWyP","@react-aria/utils":"9cLk5","react":"9yzVZ","@adobe/spectrum-css-temp/components/tags/vars.css":"b2NwJ","@react-spectrum/text":"etCGI","@react-aria/focus":"42mbF","@react-aria/interactions":"ky3G8","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"hvP5p":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /// <reference types="css-module-types" />
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "theme", ()=>theme);
var _spectrumDarkestCss = require("@adobe/spectrum-css-temp/vars/spectrum-darkest.css");
var _spectrumDarkestCssDefault = parcelHelpers.interopDefault(_spectrumDarkestCss);
var _spectrumGlobalCss = require("@adobe/spectrum-css-temp/vars/spectrum-global.css");
var _spectrumGlobalCssDefault = parcelHelpers.interopDefault(_spectrumGlobalCss);
var _spectrumLargeCss = require("@adobe/spectrum-css-temp/vars/spectrum-large.css");
var _spectrumLargeCssDefault = parcelHelpers.interopDefault(_spectrumLargeCss);
var _spectrumLightCss = require("@adobe/spectrum-css-temp/vars/spectrum-light.css");
var _spectrumLightCssDefault = parcelHelpers.interopDefault(_spectrumLightCss);
var _spectrumMediumCss = require("@adobe/spectrum-css-temp/vars/spectrum-medium.css");
var _spectrumMediumCssDefault = parcelHelpers.interopDefault(_spectrumMediumCss);
let theme = {
    global: (0, _spectrumGlobalCssDefault.default),
    light: (0, _spectrumLightCssDefault.default),
    dark: (0, _spectrumDarkestCssDefault.default),
    medium: (0, _spectrumMediumCssDefault.default),
    large: (0, _spectrumLargeCssDefault.default)
};

},{"@adobe/spectrum-css-temp/vars/spectrum-darkest.css":"gniV6","@adobe/spectrum-css-temp/vars/spectrum-global.css":"3JKS4","@adobe/spectrum-css-temp/vars/spectrum-large.css":"1BNjr","@adobe/spectrum-css-temp/vars/spectrum-light.css":"lgx8Y","@adobe/spectrum-css-temp/vars/spectrum-medium.css":"8swdG","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"gniV6":[function(require,module,exports) {
module.exports["spectrum--darkest"] = `gP7gvq_spectrum--darkest`;

},{}],"3JKS4":[function(require,module,exports) {
module.exports["spectrum"] = `zA6MfG_spectrum`;
module.exports["spectrum--dark"] = `zA6MfG_spectrum--dark`;
module.exports["spectrum--darkest"] = `zA6MfG_spectrum--darkest`;
module.exports["spectrum--large"] = `zA6MfG_spectrum--large`;
module.exports["spectrum--light"] = `zA6MfG_spectrum--light`;
module.exports["spectrum--lightest"] = `zA6MfG_spectrum--lightest`;
module.exports["spectrum--medium"] = `zA6MfG_spectrum--medium`;

},{}],"1BNjr":[function(require,module,exports) {
module.exports["spectrum--large"] = `HAZavG_spectrum--large`;

},{}],"lgx8Y":[function(require,module,exports) {
module.exports["spectrum--light"] = `PFjRbG_spectrum--light`;

},{}],"8swdG":[function(require,module,exports) {
module.exports["spectrum--medium"] = `xSyFOq_spectrum--medium`;

},{}],"dRB1Q":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /// <reference types="css-module-types" />
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Well", ()=>(0, _well.Well));
var _well = require("./Well");

},{"./Well":"852qZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"852qZ":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Well", ()=>_Well);
var _utils = require("@react-spectrum/utils");
var _utils1 = require("@react-aria/utils");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _varsCss = require("@adobe/spectrum-css-temp/components/well/vars.css");
var _varsCssDefault = parcelHelpers.interopDefault(_varsCss);
function Well(props, ref) {
    let { children, role, ...otherProps } = props;
    let domRef = (0, _utils.useDOMRef)(ref);
    let { styleProps } = (0, _utils.useStyleProps)(otherProps);
    if (!role && (props["aria-label"] || props["aria-labelledby"])) console.warn("A labelled Well must have a role.");
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...(0, _utils1.filterDOMProps)(otherProps, {
            labelable: !!role
        }),
        ...styleProps,
        role: role,
        ref: domRef,
        className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Well", styleProps.className)
    }, children);
}
/**
 * A Well is a content container that displays non-editable content separate from other content on the screen.
 * Often this is used to display preformatted text, such as code/markup examples on a documentation page.
 */ const _Well = /*#__PURE__*/ (0, _react.forwardRef)(Well);

},{"@react-spectrum/utils":"cMIJ6","@react-aria/utils":"9cLk5","react":"9yzVZ","@adobe/spectrum-css-temp/components/well/vars.css":"lVl6k","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"lVl6k":[function(require,module,exports) {
module.exports["focus-ring"] = `SWvLfG_focus-ring`;
module.exports["i18nFontFamily"] = `SWvLfG_i18nFontFamily`;
module.exports["spectrum-FocusRing-ring"] = `SWvLfG_spectrum-FocusRing-ring`;
module.exports["spectrum-FocusRing"] = `SWvLfG_spectrum-FocusRing ${module.exports["spectrum-FocusRing-ring"]}`;
module.exports["spectrum-FocusRing--quiet"] = `SWvLfG_spectrum-FocusRing--quiet`;
module.exports["spectrum-Well"] = `SWvLfG_spectrum-Well`;

},{}],"cHWGH":[function(require,module,exports) {
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /// <reference types="css-module-types" />
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useDragAndDrop", ()=>(0, _useDragAndDrop.useDragAndDrop));
parcelHelpers.export(exports, "DIRECTORY_DRAG_TYPE", ()=>(0, _dnd.DIRECTORY_DRAG_TYPE));
var _useDragAndDrop = require("./useDragAndDrop");
var _dnd = require("@react-aria/dnd");

},{"./useDragAndDrop":"eB7Bf","@react-aria/dnd":"hi3Sh","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"eB7Bf":[function(require,module,exports) {
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides the hooks required to enable drag and drop behavior for a drag and drop compatible React Spectrum component.
 */ parcelHelpers.export(exports, "useDragAndDrop", ()=>useDragAndDrop);
var _dnd = require("@react-aria/dnd");
var _dnd1 = require("@react-stately/dnd");
var _react = require("react");
function useDragAndDrop(options) {
    let dragAndDropHooks = (0, _react.useMemo)(()=>{
        let { onDrop, onInsert, onItemDrop, onReorder, onRootDrop, getItems, renderPreview } = options;
        let isDraggable = !!getItems;
        let isDroppable = !!(onDrop || onInsert || onItemDrop || onReorder || onRootDrop);
        let hooks = {};
        if (isDraggable) {
            hooks.useDraggableCollectionState = function useDraggableCollectionStateOverride(props) {
                return (0, _dnd1.useDraggableCollectionState)({
                    ...props,
                    ...options
                });
            };
            hooks.useDraggableCollection = (0, _dnd.useDraggableCollection);
            hooks.useDraggableItem = (0, _dnd.useDraggableItem);
            hooks.DragPreview = (0, _dnd.DragPreview);
            hooks.renderPreview = renderPreview;
        }
        if (isDroppable) {
            hooks.useDroppableCollectionState = function useDroppableCollectionStateOverride(props) {
                return (0, _dnd1.useDroppableCollectionState)({
                    ...props,
                    ...options
                });
            };
            hooks.useDroppableItem = (0, _dnd.useDroppableItem);
            hooks.useDroppableCollection = function useDroppableCollectionOverride(props, state, ref) {
                return (0, _dnd.useDroppableCollection)({
                    ...props,
                    ...options
                }, state, ref);
            };
            hooks.useDropIndicator = (0, _dnd.useDropIndicator);
        }
        if (isDraggable || isDroppable) hooks.isVirtualDragging = (0, _dnd.isVirtualDragging);
        return hooks;
    }, [
        options
    ]);
    return {
        dragAndDropHooks: dragAndDropHooks
    };
}

},{"@react-aria/dnd":"hi3Sh","@react-stately/dnd":"bUQOi","react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"kygiG":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Default", ()=>Default);
parcelHelpers.export(exports, "ConstantContainer", ()=>ConstantContainer);
var _addonActions = require("@storybook/addon-actions");
var _bell = require("@spectrum-icons/workflow/Bell");
var _bellDefault = parcelHelpers.interopDefault(_bell);
var _button = require("@react-spectrum/button");
var _ = require("../");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _text = require("@react-spectrum/text");
exports.default = {
    title: "ButtonGroup",
    component: (0, _.ButtonGroup),
    argTypes: {
        isDisabled: {
            control: "boolean"
        },
        orientation: {
            control: "select",
            options: [
                "horizontal",
                "vertical"
            ]
        },
        align: {
            control: "select",
            options: [
                "start",
                "end",
                "center"
            ]
        }
    }
};
const Default = {
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
            style: {
                minWidth: "100px",
                padding: "10px",
                resize: "horizontal",
                overflow: "auto",
                backgroundColor: "var(--spectrum-global-color-gray-50)"
            }
        }, render(args))
};
const ConstantContainer = {
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(ExpandingSibling, args),
    name: "constant container, changing siblings"
};
function render(props) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Component, props);
}
let ExpandingSibling = (props = {})=>{
    let [isExpanded, setIsExpanded] = (0, _react.useState)(false);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        style: {
            display: "flex",
            flexWrap: "nowrap",
            width: "800px",
            overflow: "hidden",
            padding: "10px",
            backgroundColor: "var(--spectrum-global-color-gray-50)"
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        style: {
            paddingRight: isExpanded ? "200px" : "10px"
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.Button), {
        variant: "secondary",
        onPress: ()=>setIsExpanded((prev)=>!prev)
    }, isExpanded ? "Shrink" : "Expand")), render(props));
};
let Component = (props)=>{
    let [show, setShow] = (0, _react.useState)(false);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ButtonGroup), {
        maxWidth: "100vw",
        ...props
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.Button), {
        variant: "primary",
        onPress: (0, _addonActions.action)("press")
    }, "Button 1"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.Button), {
        variant: "negative",
        onPress: (0, _addonActions.action)("press")
    }, "Button long long long name"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.Button), {
        variant: "primary",
        isDisabled: true,
        onPress: (0, _addonActions.action)("press")
    }, "Disabled button"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.Button), {
        variant: "secondary",
        onPress: ()=>setShow((show)=>!show)
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _bellDefault.default), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, "Click me to make Button larger"), show && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, "to test overflow resizing :D")));
};

},{"@storybook/addon-actions":"coXbW","@spectrum-icons/workflow/Bell":"5FeJ6","@react-spectrum/button":"jZWyP","../":"82Les","react":"9yzVZ","@react-spectrum/text":"etCGI","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"82Les":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _src = require("./src");
parcelHelpers.exportAll(_src, exports);

},{"./src":"anP11","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"7F9uU":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Default", ()=>Default);
parcelHelpers.export(exports, "DefaultValue", ()=>DefaultValue);
parcelHelpers.export(exports, "ControlledValue", ()=>ControlledValue);
parcelHelpers.export(exports, "WithTime", ()=>WithTime);
parcelHelpers.export(exports, "ZonedTime", ()=>ZonedTime);
parcelHelpers.export(exports, "OneWeek", ()=>OneWeek);
parcelHelpers.export(exports, "DefaultMinMax", ()=>DefaultMinMax);
parcelHelpers.export(exports, "DateUnavailable", ()=>DateUnavailable);
parcelHelpers.export(exports, "MinValue", ()=>MinValue);
parcelHelpers.export(exports, "MinValueDefaultVal", ()=>MinValueDefaultVal);
parcelHelpers.export(exports, "DefaultFocusedValue", ()=>DefaultFocusedValue);
parcelHelpers.export(exports, "FocusedValue", ()=>FocusedValue);
var _addonActions = require("@storybook/addon-actions");
var _button = require("@react-spectrum/button");
var _ = require("../");
var _date = require("@internationalized/date");
var _layout = require("@react-spectrum/layout");
var _picker = require("@react-spectrum/picker");
var _provider = require("@react-spectrum/provider");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _datepicker = require("@react-spectrum/datepicker");
var _i18N = require("@react-aria/i18n");
var _view = require("@react-spectrum/view");
exports.default = {
    title: "Date and Time/Calendar",
    component: (0, _.Calendar),
    args: {
        onChange: (0, _addonActions.action)("onChange")
    },
    argTypes: {
        onChange: {
            table: {
                disable: true
            }
        },
        defaultValue: {
            table: {
                disable: true
            }
        },
        minValue: {
            table: {
                disable: true
            }
        },
        value: {
            table: {
                disable: true
            }
        },
        maxValue: {
            table: {
                disable: true
            }
        },
        defaultFocusedValue: {
            table: {
                disable: true
            }
        },
        isDisabled: {
            control: "boolean"
        },
        isReadOnly: {
            control: "boolean"
        },
        autoFocus: {
            control: "boolean"
        },
        visibleMonths: {
            control: "number"
        },
        pageBehavior: {
            control: "select",
            options: [
                null,
                "single",
                "visible"
            ]
        },
        isInvalid: {
            control: "boolean"
        },
        "aria-label": {
            control: "text"
        },
        errorMessage: {
            control: "text"
        }
    }
};
const Default = {
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(Example, args)
};
const DefaultValue = {
    ...Default,
    args: {
        defaultValue: new (0, _date.CalendarDate)(2019, 6, 5)
    }
};
const ControlledValue = {
    ...Default,
    args: {
        value: new (0, _date.CalendarDate)(2019, 5, 5)
    }
};
const WithTime = {
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(CalendarWithTime, args)
};
const ZonedTime = {
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(CalendarWithZonedTime, args),
    name: "with zoned time"
};
const OneWeek = {
    ...Default,
    args: {
        minValue: (0, _date.today)((0, _date.getLocalTimeZone)()),
        maxValue: (0, _date.today)((0, _date.getLocalTimeZone)()).add({
            weeks: 1
        })
    },
    name: "minValue: today, maxValue: 1 week from now"
};
const DefaultMinMax = {
    ...Default,
    args: {
        defaultValue: new (0, _date.CalendarDate)(2019, 6, 10),
        minValue: new (0, _date.CalendarDate)(2019, 6, 5),
        maxValue: new (0, _date.CalendarDate)(2019, 6, 20)
    },
    name: "defaultValue + minValue + maxValue"
};
const DateUnavailable = {
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(Example, {
            ...args,
            defaultValue: (0, _date.today)((0, _date.getLocalTimeZone)()).add({
                days: 1
            }),
            isDateUnavailable: (date)=>{
                const disabledIntervals = [
                    [
                        (0, _date.today)((0, _date.getLocalTimeZone)()),
                        (0, _date.today)((0, _date.getLocalTimeZone)()).add({
                            weeks: 1
                        })
                    ],
                    [
                        (0, _date.today)((0, _date.getLocalTimeZone)()).add({
                            weeks: 2
                        }),
                        (0, _date.today)((0, _date.getLocalTimeZone)()).add({
                            weeks: 3
                        })
                    ]
                ];
                return disabledIntervals.some((interval)=>date.compare(interval[0]) > 0 && date.compare(interval[1]) < 0);
            }
        }),
    name: "isDateUnavailable"
};
const MinValue = {
    ...Default,
    args: {
        minValue: (0, _date.today)((0, _date.getLocalTimeZone)())
    },
    name: "minValue: today"
};
const MinValueDefaultVal = {
    ...Default,
    args: {
        minValue: (0, _date.today)((0, _date.getLocalTimeZone)()),
        defaultValue: new (0, _date.CalendarDate)(2019, 6, 5)
    },
    name: "minValue: today, defaultValue"
};
const DefaultFocusedValue = {
    ...Default,
    args: {
        defaultFocusedValue: new (0, _date.CalendarDate)(2019, 6, 5)
    },
    name: "defaultFocusedValue"
};
const FocusedValue = {
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(ControlledFocus, args),
    name: "focusedValue"
};
// https://github.com/unicode-org/cldr/blob/22af90ae3bb04263f651323ce3d9a71747a75ffb/common/supplemental/supplementalData.xml#L4649-L4664
const preferences = [
    {
        locale: "",
        label: "Default",
        ordering: "gregory"
    },
    {
        label: "Arabic (Algeria)",
        locale: "ar-DZ",
        territories: "DJ DZ EH ER IQ JO KM LB LY MA MR OM PS SD SY TD TN YE",
        ordering: "gregory islamic islamic-civil islamic-tbla"
    },
    {
        label: "Arabic (United Arab Emirates)",
        locale: "ar-AE",
        territories: "AE BH KW QA",
        ordering: "gregory islamic-umalqura islamic islamic-civil islamic-tbla"
    },
    {
        label: "Arabic (Egypt)",
        locale: "AR-EG",
        territories: "EG",
        ordering: "gregory coptic islamic islamic-civil islamic-tbla"
    },
    {
        label: "Arabic (Saudi Arabia)",
        locale: "ar-SA",
        territories: "SA",
        ordering: "islamic-umalqura gregory islamic islamic-rgsa"
    },
    {
        label: "Farsi (Afghanistan)",
        locale: "fa-AF",
        territories: "AF IR",
        ordering: "persian gregory islamic islamic-civil islamic-tbla"
    },
    // {territories: 'CN CX HK MO SG', ordering: 'gregory chinese'},
    {
        label: "Amharic (Ethiopia)",
        locale: "am-ET",
        territories: "ET",
        ordering: "gregory ethiopic ethioaa"
    },
    {
        label: "Hebrew (Israel)",
        locale: "he-IL",
        territories: "IL",
        ordering: "gregory hebrew islamic islamic-civil islamic-tbla"
    },
    {
        label: "Hindi (India)",
        locale: "hi-IN",
        territories: "IN",
        ordering: "gregory indian"
    },
    {
        label: "Japanese (Japan)",
        locale: "ja-JP",
        territories: "JP",
        ordering: "gregory japanese"
    },
    // {territories: 'KR', ordering: 'gregory dangi'},
    {
        label: "Thai (Thailand)",
        locale: "th-TH",
        territories: "TH",
        ordering: "buddhist gregory"
    },
    {
        label: "Chinese (Taiwan)",
        locale: "zh-TW",
        territories: "TW",
        ordering: "gregory roc chinese"
    }
];
const calendars = [
    {
        key: "gregory",
        name: "Gregorian"
    },
    {
        key: "japanese",
        name: "Japanese"
    },
    {
        key: "buddhist",
        name: "Buddhist"
    },
    {
        key: "roc",
        name: "Taiwan"
    },
    {
        key: "persian",
        name: "Persian"
    },
    {
        key: "indian",
        name: "Indian"
    },
    {
        key: "islamic-umalqura",
        name: "Islamic (Umm al-Qura)"
    },
    {
        key: "islamic-civil",
        name: "Islamic Civil"
    },
    {
        key: "islamic-tbla",
        name: "Islamic Tabular"
    },
    {
        key: "hebrew",
        name: "Hebrew"
    },
    {
        key: "coptic",
        name: "Coptic"
    },
    {
        key: "ethiopic",
        name: "Ethiopic"
    },
    {
        key: "ethioaa",
        name: "Ethiopic (Amete Alem)"
    }
];
function Example(props) {
    let [locale, setLocale] = (0, _reactDefault.default).useState("");
    let [calendar, setCalendar] = (0, _reactDefault.default).useState(calendars[0].key);
    let { locale: defaultLocale } = (0, _i18N.useLocale)();
    let pref = preferences.find((p)=>p.locale === locale);
    let preferredCalendars = (0, _reactDefault.default).useMemo(()=>pref ? pref.ordering.split(" ").map((p)=>calendars.find((c)=>c.key === p)).filter(Boolean) : [
            calendars[0]
        ], [
        pref
    ]);
    let otherCalendars = (0, _reactDefault.default).useMemo(()=>calendars.filter((c)=>!preferredCalendars.some((p)=>p.key === c.key)), [
        preferredCalendars
    ]);
    let updateLocale = (locale)=>{
        setLocale(locale);
        let pref = preferences.find((p)=>p.locale === locale);
        setCalendar(pref.ordering.split(" ")[0]);
    };
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
        direction: "column",
        gap: "size-600",
        alignItems: "center"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
        direction: "column",
        gap: "size-150",
        wrap: true
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _picker.Picker), {
        label: "Locale",
        items: preferences,
        selectedKey: locale,
        onSelectionChange: updateLocale
    }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _picker.Item), {
            key: item.locale
        }, item.label)), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _picker.Picker), {
        label: "Calendar",
        selectedKey: calendar,
        onSelectionChange: setCalendar
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _picker.Section), {
        title: "Preferred",
        items: preferredCalendars
    }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _picker.Item), null, item.name)), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _picker.Section), {
        title: "Other",
        items: otherCalendars
    }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _picker.Item), null, item.name)))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _provider.Provider), {
        locale: (locale || defaultLocale) + (calendar && calendar !== preferredCalendars[0].key ? "-u-ca-" + calendar : "")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.View), {
        maxWidth: "100vw",
        padding: "size-10",
        overflow: "auto"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Calendar), props))));
}
function CalendarWithTime(props) {
    let [value, setValue] = (0, _react.useState)(new (0, _date.CalendarDateTime)(2019, 6, 5, 8));
    let onChange = (v)=>{
        var _props_onChange;
        setValue(v);
        props === null || props === void 0 ? void 0 : (_props_onChange = props.onChange) === null || _props_onChange === void 0 ? void 0 : _props_onChange.call(props, v);
    };
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
        direction: "column"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Calendar), {
        ...props,
        value: value,
        onChange: onChange
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _datepicker.TimeField), {
        label: "Time",
        value: value,
        onChange: onChange
    }));
}
function CalendarWithZonedTime(props) {
    let [value, setValue] = (0, _react.useState)((0, _date.parseZonedDateTime)("2021-03-14T00:45-08:00[America/Los_Angeles]"));
    let onChange = (v)=>{
        var _props_onChange;
        setValue(v);
        props === null || props === void 0 ? void 0 : (_props_onChange = props.onChange) === null || _props_onChange === void 0 ? void 0 : _props_onChange.call(props, v);
    };
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
        direction: "column"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Calendar), {
        ...props,
        value: value,
        onChange: onChange
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _datepicker.TimeField), {
        label: "Time",
        value: value,
        onChange: onChange
    }));
}
function ControlledFocus(props) {
    let [focusedDate, setFocusedDate] = (0, _react.useState)(new (0, _date.CalendarDate)(2019, 6, 5));
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
        direction: "column",
        alignItems: "start",
        gap: "size-200"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), {
        onPress: ()=>setFocusedDate(new (0, _date.CalendarDate)(2019, 6, 5))
    }, "Reset focused date"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Calendar), {
        ...props,
        focusedValue: focusedDate,
        onFocusChange: setFocusedDate
    }));
}

},{"@storybook/addon-actions":"coXbW","@react-spectrum/button":"jZWyP","../":"aHuOk","@internationalized/date":"hesBk","@react-spectrum/layout":"hzaUY","@react-spectrum/picker":"kL1Uy","@react-spectrum/provider":"5bCdp","react":"9yzVZ","@react-spectrum/datepicker":"2xkLK","@react-aria/i18n":"411rg","@react-spectrum/view":"dnRjt","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"aHuOk":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _src = require("./src");
parcelHelpers.exportAll(_src, exports);

},{"./src":"9d2lg","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"fSmea":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Default", ()=>Default);
parcelHelpers.export(exports, "DefaultValue", ()=>DefaultValue);
parcelHelpers.export(exports, "ControlledValue", ()=>ControlledValue);
parcelHelpers.export(exports, "WithTime", ()=>WithTime);
parcelHelpers.export(exports, "ZonedTime", ()=>ZonedTime);
parcelHelpers.export(exports, "OneWeek", ()=>OneWeek);
parcelHelpers.export(exports, "DefaultMinMax", ()=>DefaultMinMax);
parcelHelpers.export(exports, "DateUnavailable", ()=>DateUnavailable);
parcelHelpers.export(exports, "MinValue", ()=>MinValue);
parcelHelpers.export(exports, "DefaultValVisibleMonths", ()=>DefaultValVisibleMonths);
parcelHelpers.export(exports, "DateUnavailableInvalid", ()=>DateUnavailableInvalid);
var _addonActions = require("@storybook/addon-actions");
var _date = require("@internationalized/date");
var _layout = require("@react-spectrum/layout");
var _ = require("../");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _datepicker = require("@react-spectrum/datepicker");
var _i18N = require("@react-aria/i18n");
var _view = require("@react-spectrum/view");
exports.default = {
    title: "Date and Time/RangeCalendar",
    component: (0, _.RangeCalendar),
    args: {
        onChange: (0, _addonActions.action)("onChange")
    },
    argTypes: {
        onChange: {
            table: {
                disable: true
            }
        },
        defaultValue: {
            table: {
                disable: true
            }
        },
        minValue: {
            table: {
                disable: true
            }
        },
        value: {
            table: {
                disable: true
            }
        },
        maxValue: {
            table: {
                disable: true
            }
        },
        isDisabled: {
            control: "boolean"
        },
        isReadOnly: {
            control: "boolean"
        },
        allowsNonContiguousRanges: {
            control: "boolean"
        },
        autoFocus: {
            control: "boolean"
        },
        visibleMonths: {
            control: "number"
        },
        pageBehavior: {
            control: "select",
            options: [
                null,
                "single",
                "visible"
            ]
        },
        isInvalid: {
            control: "boolean"
        },
        errorMessage: {
            control: "text"
        }
    }
};
const Default = {
    render: (args)=>render(args)
};
const DefaultValue = {
    ...Default,
    args: {
        defaultValue: {
            start: new (0, _date.CalendarDate)(2019, 6, 5),
            end: new (0, _date.CalendarDate)(2019, 6, 10)
        }
    }
};
const ControlledValue = {
    ...Default,
    args: {
        value: {
            start: new (0, _date.CalendarDate)(2019, 6, 5),
            end: new (0, _date.CalendarDate)(2019, 6, 10)
        }
    }
};
const WithTime = {
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(RangeCalendarWithTime, args)
};
const ZonedTime = {
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(RangeCalendarWithZonedTime, args),
    name: "with zoned time"
};
const OneWeek = {
    ...Default,
    args: {
        minValue: (0, _date.today)((0, _date.getLocalTimeZone)()),
        maxValue: (0, _date.today)((0, _date.getLocalTimeZone)()).add({
            weeks: 1
        })
    },
    name: "minValue: today, maxValue: 1 week from now"
};
const DefaultMinMax = {
    ...Default,
    args: {
        defaultValue: {
            start: new (0, _date.CalendarDate)(2019, 6, 10),
            end: new (0, _date.CalendarDate)(2019, 6, 12)
        },
        minValue: new (0, _date.CalendarDate)(2019, 6, 5),
        maxValue: new (0, _date.CalendarDate)(2019, 6, 20)
    },
    name: "defaultValue + minValue + maxValue"
};
const DateUnavailable = {
    ...Default,
    args: {
        isDateUnavailable: (date)=>{
            const disabledIntervals = [
                [
                    (0, _date.today)((0, _date.getLocalTimeZone)()),
                    (0, _date.today)((0, _date.getLocalTimeZone)()).add({
                        weeks: 1
                    })
                ],
                [
                    (0, _date.today)((0, _date.getLocalTimeZone)()).add({
                        weeks: 2
                    }),
                    (0, _date.today)((0, _date.getLocalTimeZone)()).add({
                        weeks: 3
                    })
                ]
            ];
            return disabledIntervals.some((interval)=>date.compare(interval[0]) > 0 && date.compare(interval[1]) < 0);
        }
    },
    name: "isDateUnavailable"
};
const MinValue = {
    ...Default,
    args: {
        minValue: (0, _date.today)((0, _date.getLocalTimeZone)())
    },
    name: "minValue: today"
};
const DefaultValVisibleMonths = {
    ...Default,
    args: {
        visibleMonths: 3,
        defaultValue: {
            start: new (0, _date.CalendarDate)(2021, 10, 5),
            end: new (0, _date.CalendarDate)(2021, 12, 10)
        }
    },
    name: "defaultValue, visibleMonths: 3"
};
const DateUnavailableInvalid = {
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(DateUnavailableAndInvalid, args),
    name: "isDateUnavailable, invalid"
};
function render(props) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.View), {
        maxWidth: "100vw",
        overflow: "auto"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.RangeCalendar), props));
}
function RangeCalendarWithTime(props) {
    let [value, setValue] = (0, _react.useState)({
        start: new (0, _date.CalendarDateTime)(2019, 6, 5, 8),
        end: new (0, _date.CalendarDateTime)(2019, 6, 10, 12)
    });
    let onChange = (v)=>{
        var _props_onChange;
        setValue(v);
        props === null || props === void 0 ? void 0 : (_props_onChange = props.onChange) === null || _props_onChange === void 0 ? void 0 : _props_onChange.call(props, v);
    };
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
        direction: "column"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.RangeCalendar), {
        ...props,
        value: value,
        onChange: onChange
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
        gap: "size-100"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _datepicker.TimeField), {
        label: "Start time",
        value: value.start,
        onChange: (v)=>onChange({
                ...value,
                start: v
            })
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _datepicker.TimeField), {
        label: "End time",
        value: value.end,
        onChange: (v)=>onChange({
                ...value,
                end: v
            })
    })));
}
function RangeCalendarWithZonedTime(props) {
    let [value, setValue] = (0, _react.useState)({
        start: (0, _date.parseZonedDateTime)("2021-03-10T00:45-05:00[America/New_York]"),
        end: (0, _date.parseZonedDateTime)("2021-03-26T18:05-07:00[America/Los_Angeles]")
    });
    let onChange = (v)=>{
        var _props_onChange;
        setValue(v);
        props === null || props === void 0 ? void 0 : (_props_onChange = props.onChange) === null || _props_onChange === void 0 ? void 0 : _props_onChange.call(props, v);
    };
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
        direction: "column"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.RangeCalendar), {
        ...props,
        value: value,
        onChange: onChange
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
        gap: "size-100"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _datepicker.TimeField), {
        label: "Start time",
        value: value.start,
        onChange: (v)=>onChange({
                ...value,
                start: v
            })
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _datepicker.TimeField), {
        label: "End time",
        value: value.end,
        onChange: (v)=>onChange({
                ...value,
                end: v
            })
    })));
}
function DateUnavailableAndInvalid(props) {
    let { locale } = (0, _i18N.useLocale)();
    return render({
        ...props,
        isDateUnavailable: (date)=>(0, _date.isWeekend)(date, locale),
        allowsNonContiguousRanges: true,
        defaultValue: {
            start: new (0, _date.CalendarDate)(2021, 10, 3),
            end: new (0, _date.CalendarDate)(2021, 10, 16)
        }
    });
}

},{"@storybook/addon-actions":"coXbW","@internationalized/date":"hesBk","@react-spectrum/layout":"hzaUY","../":"aHuOk","react":"9yzVZ","@react-spectrum/datepicker":"2xkLK","@react-aria/i18n":"411rg","@react-spectrum/view":"dnRjt","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"jBc4q":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Default", ()=>Default);
var _utils = require("@react-spectrum/utils");
var _storyUtils = require("@react-spectrum/story-utils");
var _layout = require("@react-spectrum/layout");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _varsCss = require("@adobe/spectrum-css-temp/components/calendar/vars.css");
var _varsCssDefault = parcelHelpers.interopDefault(_varsCss);
let states = [
    {
        isToday: true
    },
    {
        isSelected: true
    },
    {
        isFocused: true
    },
    {
        isHovered: true
    },
    {
        isPressed: true
    },
    {
        isDisabled: true
    },
    {
        isRangeSelection: true
    },
    {
        isRangeStart: true
    },
    {
        isRangeEnd: true
    },
    {
        isSelectionStart: true
    },
    {
        isSelectionEnd: true
    }
];
exports.default = {
    title: "Date and Time/RangeCalendar/cell"
};
// Fake cell for testing css
function Cell({ isToday, isSelected, isFocused, isHovered, isPressed, isDisabled, isRangeStart, isRangeEnd, isRangeSelection, isSelectionStart, isSelectionEnd }) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Calendar-date", {
            "is-today": isToday,
            "is-selected": isSelected,
            "is-focused": isFocused,
            "is-disabled": isDisabled,
            "is-range-start": isRangeStart,
            "is-range-end": isRangeEnd,
            "is-range-selection": isRangeSelection,
            "is-selection-start": isSelectionStart,
            "is-selection-end": isSelectionEnd,
            "is-hovered": isHovered,
            "is-pressed": isPressed
        })
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Calendar-dateText")
    }, "12"));
}
const Default = {
    render: ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Grid), {
            columns: (0, _layout.repeat)(10, 100)
        }, (0, _storyUtils.generatePowerset)(states, (merged)=>merged.isDisabled && (merged.isFocused || merged.isHovered || merged.isPressed) || !merged.isSelected && (merged.isRangeSelection || merged.isSelectionStart || merged.isSelectionEnd || merged.isRangeStart || merged.isRangeEnd) || (merged.isRangeStart || merged.isRangeEnd) && !merged.isRangeSelection || merged.isRangeStart && merged.isRangeEnd || merged.isSelectionStart && !merged.isRangeStart || merged.isSelectionEnd && !merged.isRangeEnd).map((props)=>/*#__PURE__*/ (0, _reactDefault.default).createElement("div", null, Object.keys(props).join(" "), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
                style: {
                    position: "relative",
                    width: 40,
                    height: 40,
                    textAlign: "center"
                }
            }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Cell, props)))))
};

},{"@react-spectrum/utils":"cMIJ6","@react-spectrum/story-utils":"gPtIF","@react-spectrum/layout":"hzaUY","react":"9yzVZ","@adobe/spectrum-css-temp/components/calendar/vars.css":"cpOyi","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"6Z2Qc":[function(require,module,exports) {
/*
 * Copyright 2021 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Default", ()=>Default);
parcelHelpers.export(exports, "CardGrid", ()=>CardGrid);
parcelHelpers.export(exports, "CardWaterfall", ()=>CardWaterfall);
parcelHelpers.export(exports, "CardFloat", ()=>CardFloat);
parcelHelpers.export(exports, "CardGridMessyText", ()=>CardGridMessyText);
parcelHelpers.export(exports, "CardWaterfallMessyText", ()=>CardWaterfallMessyText);
parcelHelpers.export(exports, "CardGridNoPreview", ()=>CardGridNoPreview);
parcelHelpers.export(exports, "CardWaterfallNoPreview", ()=>CardWaterfallNoPreview);
parcelHelpers.export(exports, "Selected", ()=>Selected);
var _avatar = require("@react-spectrum/avatar");
var _ = require("..");
var _cardBase = require("../src/CardBase");
var _cardViewContext = require("../src/CardViewContext");
var _view = require("@react-spectrum/view");
var _utils = require("./utils");
var _text = require("@react-spectrum/text");
var _image = require("@react-spectrum/image");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _interactions = require("@react-aria/interactions");
var _provider = require("@react-spectrum/provider");
exports.default = {
    title: "Card/default",
    component: (0, _.Card),
    argTypes: {
        layout: {
            table: {
                disable: true
            }
        },
        children: {
            table: {
                disable: true
            }
        }
    }
};
const Default = {
    args: {
        children: /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _image.Image), {
            src: "https://i.imgur.com/Z7AzH2c.jpg"
        }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _avatar.Avatar), {
            src: "https://mir-s3-cdn-cf.behance.net/project_modules/disp/690bc6105945313.5f84bfc9de488.png"
        }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Heading), null, "Title"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), {
            slot: "detail"
        }, "PNG"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Content), null, "Description"))
    },
    decorators: [
        (Story)=>/*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
                style: {
                    width: "208px"
                }
            }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Story, null))
    ]
};
const CardGrid = {
    render: (args, context)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Card), {
            ...args,
            ...context,
            id: null
        }),
    args: {
        layout: "grid"
    },
    decorators: [
        (Story, context)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(CardGridDecorator, {
                Story: Story,
                context: context
            })
    ]
};
let CardGridDecorator = (props)=>{
    let { Story, context } = props;
    let { args } = context;
    let { scale } = (0, _provider.useProvider)();
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        style: {
            width: "100%",
            margin: "50px",
            display: "grid",
            gap: "20px",
            gridTemplateColumns: "repeat(auto-fit, 208px)",
            gridAutoRows: "auto",
            justifyContent: "center",
            justifyItems: "center",
            alignItems: "start"
        }
    }, new Array(15).fill(0).map((_, index)=>{
        let url = (0, _utils.getImage)(index);
        return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
            style: scale === "medium" ? {
                width: "208px",
                height: "293px"
            } : {
                width: "208px",
                height: "355px"
            },
            key: `${index}${url}`
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Story, args, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _image.Image), {
            src: url
        }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Heading), null, "Title ", index), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), {
            slot: "detail"
        }, "PNG"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Content), null, "Description")));
    }));
};
const CardWaterfall = {
    render: (args, context)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Card), {
            ...args,
            ...context,
            id: null
        }),
    args: {
        layout: "waterfall"
    },
    decorators: [
        (Story, context)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(CardWaterfallDecorator, {
                Story: Story,
                context: context
            })
    ]
};
let CardWaterfallDecorator = (props)=>{
    let { Story, context } = props;
    let { args } = context;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        style: {
            width: "100%",
            height: "150vh",
            margin: "50px",
            display: "flex",
            flexDirection: "column",
            flexWrap: "wrap",
            alignItems: "start"
        }
    }, new Array(15).fill(0).map((_, index)=>{
        let url = (0, _utils.getImage)(index);
        return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
            style: {
                width: "208px",
                margin: "10px"
            },
            key: `${index}${url}`
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Story, args, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _image.Image), {
            src: url
        }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Heading), null, "Title ", index), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), {
            slot: "detail"
        }, "PNG"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Content), null, (0, _utils.getDescription)(index))));
    }));
};
const CardFloat = {
    render: (args, context)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Card), {
            ...args,
            ...context,
            id: null
        }),
    decorators: [
        (Story, context)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(CardFloatDecorator, {
                Story: Story,
                context: context
            })
    ]
};
let CardFloatDecorator = (props)=>{
    let { Story, context } = props;
    let { args } = context;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        style: {
            width: "100%",
            margin: "50px"
        }
    }, new Array(15).fill(0).map((_, index)=>{
        let url = (0, _utils.getImage)(index);
        return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
            style: {
                float: "left",
                margin: "10px"
            },
            key: `${index}${url}`
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Story, args, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _image.Image), {
            src: url
        }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Heading), null, "Title ", index), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), {
            slot: "detail"
        }, "PNG"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Content), null, "Description")));
    }));
};
const CardGridMessyText = {
    render: (args, context)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Card), {
            ...args,
            ...context,
            id: null
        }),
    args: {
        ...Default.args,
        layout: "grid"
    },
    decorators: [
        (Story, context)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(CardGridMessyTextDecorator, {
                Story: Story,
                context: context
            })
    ]
};
let CardGridMessyTextDecorator = (props)=>{
    let { Story, context } = props;
    let { args } = context;
    let { scale } = (0, _provider.useProvider)();
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        style: {
            width: "100%",
            margin: "50px",
            display: "grid",
            gap: "20px",
            gridTemplateColumns: "repeat(auto-fit, 208px)",
            gridAutoRows: "auto",
            justifyContent: "center",
            justifyItems: "center",
            alignItems: "start"
        }
    }, new Array(15).fill(0).map((_, index)=>{
        let url = (0, _utils.getImage)(index);
        return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
            style: scale === "medium" ? {
                width: "208px",
                height: "293px"
            } : {
                width: "208px",
                height: "355px"
            },
            key: `${index}${url}`
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Story, args, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _image.Image), {
            src: url
        }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Heading), null, index, " Rechtsschutzversicherungsgesellschaften Nahrungsmittelunvertr\xe4glichkeit Unabh\xe4ngigkeitserkl\xe4rungen Freundschaftsbeziehungen"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), {
            slot: "detail"
        }, "Rechtsschutzversicherungsgesellschaften Nahrungsmittelunvertr\xe4glichkeit Unabh\xe4ngigkeitserkl\xe4rungen Freundschaftsbeziehungen"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Content), null, "Rechtsschutzversicherungsgesellschaften Nahrungsmittelunvertr\xe4glichkeit Unabh\xe4ngigkeitserkl\xe4rungen Freundschaftsbeziehungen")));
    }));
};
const CardWaterfallMessyText = {
    render: (args, context)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Card), {
            ...args,
            ...context,
            id: null
        }),
    args: {
        ...Default.args,
        layout: "waterfall"
    },
    decorators: [
        (Story, context)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(CardWaterfallMessyTextDecorator, {
                Story: Story,
                context: context
            })
    ]
};
let CardWaterfallMessyTextDecorator = (props)=>{
    let { Story, context } = props;
    let { args } = context;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        style: {
            width: "100%",
            height: "150vh",
            margin: "50px",
            display: "flex",
            flexDirection: "column",
            flexWrap: "wrap",
            alignItems: "start"
        }
    }, new Array(15).fill(0).map((_, index)=>{
        let url = (0, _utils.getImage)(index);
        return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
            style: {
                width: "208px",
                margin: "10px"
            },
            key: `${index}${url}`
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Story, args, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _image.Image), {
            src: url
        }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Heading), null, index, " Rechtsschutzversicherungsgesellschaften Nahrungsmittelunvertr\xe4glichkeit Unabh\xe4ngigkeitserkl\xe4rungen Freundschaftsbeziehungen"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), {
            slot: "detail"
        }, "Rechtsschutzversicherungsgesellschaften Nahrungsmittelunvertr\xe4glichkeit Unabh\xe4ngigkeitserkl\xe4rungen Freundschaftsbeziehungen"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Content), null, "Rechtsschutzversicherungsgesellschaften Nahrungsmittelunvertr\xe4glichkeit Unabh\xe4ngigkeitserkl\xe4rungen Freundschaftsbeziehungen")));
    }));
};
const CardGridNoPreview = {
    render: (args, context)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Card), {
            ...args,
            ...context,
            id: null
        }),
    args: {
        ...Default.args,
        layout: "grid"
    },
    decorators: [
        (Story, context)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(CardGridNoPreviewDecorator, {
                Story: Story,
                context: context
            })
    ]
};
let CardGridNoPreviewDecorator = (props)=>{
    let { Story, context } = props;
    let { args } = context;
    let { scale } = (0, _provider.useProvider)();
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        style: {
            width: "100%",
            margin: "50px",
            display: "grid",
            gap: "20px",
            gridTemplateColumns: "repeat(auto-fit, 208px)",
            gridAutoRows: "auto",
            justifyContent: "center",
            justifyItems: "center",
            alignItems: "start"
        }
    }, new Array(15).fill(0).map((_, index)=>{
        let url = (0, _utils.getImage)(index);
        return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
            style: scale === "medium" ? {
                width: "208px",
                height: "160px"
            } : {
                width: "208px",
                height: "200px"
            },
            key: `${index}${url}`
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Story, args, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Heading), null, "Title ", index), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), {
            slot: "detail"
        }, "PNG"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Content), null, "Description")));
    }));
};
const CardWaterfallNoPreview = {
    render: (args, context)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Card), {
            ...args,
            ...context,
            id: null
        }),
    args: {
        layout: "waterfall"
    },
    decorators: [
        (Story, context)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(CardWaterfallNoPreviewDecorator, {
                Story: Story,
                context: context
            })
    ]
};
let CardWaterfallNoPreviewDecorator = (props)=>{
    let { Story, context } = props;
    let { args } = context;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        style: {
            width: "100%",
            height: "150vh",
            margin: "50px",
            display: "flex",
            flexDirection: "column",
            flexWrap: "wrap",
            alignItems: "start"
        }
    }, new Array(15).fill(0).map((_, index)=>{
        let url = (0, _utils.getImage)(index);
        return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
            style: {
                width: "208px",
                margin: "10px"
            },
            key: `${index}${url}`
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Story, args, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Heading), null, "Title ", index), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), {
            slot: "detail"
        }, "PNG"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Content), null, (0, _utils.getDescription)(index))));
    }));
};
let SelectableCard = (props)=>{
    let [state, setState] = (0, _react.useState)({
        disabledKeys: new Set(),
        selectionManager: {
            isSelected: ()=>true,
            select: ()=>setState((prev)=>({
                        ...prev,
                        selectionManager: {
                            ...prev.selectionManager,
                            isSelected: ()=>!prev.selectionManager.isSelected()
                        }
                    }))
        }
    });
    let { pressProps } = (0, _interactions.usePress)({
        onPress: ()=>setState((prev)=>({
                    ...prev,
                    selectionManager: {
                        ...prev.selectionManager,
                        isSelected: ()=>!prev.selectionManager.isSelected()
                    }
                }))
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        style: {
            width: "208px"
        },
        ...pressProps
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _cardViewContext.CardViewContext).Provider, {
        value: {
            state
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _cardBase.CardBase), props)));
};
const Selected = {
    args: {
        ...Default.args
    },
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(SelectableCard, {
            ...args,
            id: null
        })
};

},{"@react-spectrum/avatar":"kHDr1","..":"4GreE","../src/CardBase":"aem24","../src/CardViewContext":"kisA8","@react-spectrum/view":"dnRjt","./utils":"aSOMD","@react-spectrum/text":"etCGI","@react-spectrum/image":"2GFZF","react":"9yzVZ","@react-aria/interactions":"ky3G8","@react-spectrum/provider":"5bCdp","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"4GreE":[function(require,module,exports) {
/*
 * Copyright 2021 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _src = require("./src");
parcelHelpers.exportAll(_src, exports);

},{"./src":"9M3dH","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"9M3dH":[function(require,module,exports) {
/*
 * Copyright 2021 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /// <reference types="css-module-types" />
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CardView", ()=>(0, _cardView.CardView));
parcelHelpers.export(exports, "GalleryLayout", ()=>(0, _galleryLayout.GalleryLayout));
parcelHelpers.export(exports, "GridLayout", ()=>(0, _gridLayout.GridLayout));
parcelHelpers.export(exports, "WaterfallLayout", ()=>(0, _waterfallLayout.WaterfallLayout));
parcelHelpers.export(exports, "Card", ()=>(0, _card.Card));
var _cardView = require("./CardView");
var _galleryLayout = require("./GalleryLayout");
var _gridLayout = require("./GridLayout");
var _waterfallLayout = require("./WaterfallLayout");
var _card = require("./Card");

},{"./CardView":"6MLBG","./GalleryLayout":"iyUVy","./GridLayout":"9Lzhj","./WaterfallLayout":"3vtFb","./Card":"kQXTr","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"6MLBG":[function(require,module,exports) {
/*
 * Copyright 2021 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CardView", ()=>_CardView);
var _cardBase = require("./CardBase");
var _cardViewContext = require("./CardViewContext");
var _utils = require("@react-spectrum/utils");
var _grid = require("@react-stately/grid");
// @ts-ignore
var _json = require("../intl/*.json");
var _jsonDefault = parcelHelpers.interopDefault(_json);
var _utils1 = require("@react-aria/utils");
var _progress = require("@react-spectrum/progress");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _varsCss = require("@adobe/spectrum-css-temp/components/card/vars.css");
var _varsCssDefault = parcelHelpers.interopDefault(_varsCss);
var _i18N = require("@react-aria/i18n");
var _grid1 = require("@react-aria/grid");
var _list = require("@react-stately/list");
var _provider = require("@react-spectrum/provider");
var _virtualizer = require("@react-aria/virtualizer");
function CardView(props, ref) {
    let { scale } = (0, _provider.useProvider)();
    let { styleProps } = (0, _utils.useStyleProps)(props);
    let domRef = (0, _utils.useDOMRef)(ref);
    let { isQuiet, renderEmptyState, layout, loadingState, onLoadMore, cardOrientation = "vertical" } = props;
    let collator = (0, _i18N.useCollator)({
        usage: "search",
        sensitivity: "base"
    });
    let isLoading = loadingState === "loading" || loadingState === "loadingMore";
    let cardViewLayout = (0, _react.useMemo)(()=>typeof layout === "function" ? new layout({
            collator,
            cardOrientation,
            scale
        }) : layout, [
        layout,
        collator,
        cardOrientation,
        scale
    ]);
    let layoutType = cardViewLayout.layoutType;
    let stringFormatter = (0, _i18N.useLocalizedStringFormatter)((0, _jsonDefault.default), "@react-spectrum/card");
    let { direction } = (0, _i18N.useLocale)();
    let { collection } = (0, _list.useListState)(props);
    let gridCollection = (0, _react.useMemo)(()=>new (0, _grid.GridCollection)({
            columnCount: 1,
            items: [
                ...collection
            ].map((item)=>({
                    // Makes the Grid row use the keys the user provides to the cards so that selection change via interactions returns the card keys
                    ...item,
                    hasChildNodes: true,
                    childNodes: [
                        {
                            key: `cell-${item.key}`,
                            type: "cell",
                            value: null,
                            level: 0,
                            rendered: null,
                            textValue: item.textValue,
                            hasChildNodes: false,
                            childNodes: []
                        }
                    ]
                }))
        }), [
        collection
    ]);
    let state = (0, _grid.useGridState)({
        ...props,
        selectionMode: cardOrientation === "horizontal" && layoutType === "grid" ? "none" : props.selectionMode,
        collection: gridCollection,
        focusMode: "cell"
    });
    cardViewLayout.collection = gridCollection;
    cardViewLayout.disabledKeys = state.disabledKeys;
    cardViewLayout.isLoading = isLoading;
    cardViewLayout.direction = direction;
    let { gridProps } = (0, _grid1.useGrid)({
        ...props,
        isVirtualized: true,
        keyboardDelegate: cardViewLayout
    }, state, domRef);
    let renderWrapper = (parent, reusableView)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _virtualizer.VirtualizerItem), {
            key: reusableView.key,
            layoutInfo: reusableView.layoutInfo,
            virtualizer: reusableView.virtualizer,
            parent: parent === null || parent === void 0 ? void 0 : parent.layoutInfo
        }, reusableView.rendered);
    let focusedKey = state.selectionManager.focusedKey;
    let focusedItem = gridCollection.getItem(state.selectionManager.focusedKey);
    if ((focusedItem === null || focusedItem === void 0 ? void 0 : focusedItem.parentKey) != null) focusedKey = focusedItem.parentKey;
    let margin = cardViewLayout.margin || 0;
    let virtualizer = cardViewLayout.virtualizer;
    let scrollToItem = (0, _react.useCallback)((key)=>{
        virtualizer && virtualizer.scrollToItem(key, {
            duration: 0,
            offsetY: margin
        });
    }, [
        margin,
        virtualizer
    ]);
    // TODO: does aria-row count and aria-col count need to be modified? Perhaps aria-col count needs to be omitted
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _cardViewContext.CardViewContext).Provider, {
        value: {
            state,
            isQuiet,
            layout: cardViewLayout,
            cardOrientation
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _virtualizer.Virtualizer), {
        ...gridProps,
        ...styleProps,
        className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-CardView"),
        ref: domRef,
        focusedKey: focusedKey,
        scrollDirection: "vertical",
        layout: cardViewLayout,
        collection: gridCollection,
        isLoading: isLoading,
        onLoadMore: onLoadMore,
        renderWrapper: renderWrapper,
        transitionDuration: isLoading ? 160 : 220,
        scrollToItem: scrollToItem
    }, (type, item)=>{
        if (type === "item") return /*#__PURE__*/ (0, _reactDefault.default).createElement(InternalCard, {
            item: item
        });
        else if (type === "loader") return /*#__PURE__*/ (0, _reactDefault.default).createElement(CenteredWrapper, null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _progress.ProgressCircle), {
            isIndeterminate: true,
            "aria-label": state.collection.size > 0 ? stringFormatter.format("loadingMore") : stringFormatter.format("loading")
        }));
        else if (type === "placeholder") {
            let emptyState = renderEmptyState ? renderEmptyState() : null;
            if (emptyState == null) return null;
            return /*#__PURE__*/ (0, _reactDefault.default).createElement(CenteredWrapper, null, emptyState);
        }
    }));
}
function CenteredWrapper({ children }) {
    let { state } = (0, _cardViewContext.useCardViewContext)();
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        role: "row",
        "aria-rowindex": state.collection.size + 1,
        className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-CardView-centeredWrapper")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        role: "gridcell"
    }, children));
}
function InternalCard(props) {
    let { item } = props;
    let cellNode = [
        ...item.childNodes
    ][0];
    let { state, cardOrientation, isQuiet, layout } = (0, _cardViewContext.useCardViewContext)();
    let layoutType = layout.layoutType;
    let rowRef = (0, _react.useRef)();
    let cellRef = (0, _react.useRef)();
    let unwrappedRef = (0, _utils.useUnwrapDOMRef)(cellRef);
    let { rowProps: gridRowProps } = (0, _grid1.useGridRow)({
        node: item,
        isVirtualized: true
    }, state, rowRef);
    let { gridCellProps } = (0, _grid1.useGridCell)({
        node: cellNode,
        focusMode: "cell"
    }, state, unwrappedRef);
    // Prevent space key from scrolling the CardView if triggered on a disabled item or on a Card in a selectionMode="none" CardView.
    let allowsInteraction = state.selectionManager.selectionMode !== "none";
    let isDisabled = !allowsInteraction || state.disabledKeys.has(item.key);
    let onKeyDown = (e)=>{
        if (e.key === " " && isDisabled) e.preventDefault();
    };
    let rowProps = (0, _utils1.mergeProps)(gridRowProps, {
        onKeyDown
    });
    if (layoutType === "grid" || layoutType === "gallery") isQuiet = true;
    if (layoutType !== "grid") cardOrientation = "vertical";
    // We don't want to focus the checkbox (or any other focusable elements) within the Card
    // when pressing the arrow keys so we delete the key down handler here. Arrow key navigation between
    // the cards in the CardView is handled by useGrid => useSelectableCollection instead.
    delete gridCellProps.onKeyDownCapture;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...rowProps,
        ref: rowRef,
        className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-CardView-row")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _cardBase.CardBase), {
        ref: cellRef,
        articleProps: gridCellProps,
        isQuiet: isQuiet,
        orientation: cardOrientation,
        item: item,
        layout: layoutType
    }, item.rendered));
}
/**
 * TODO: Add description of component here.
 */ const _CardView = /*#__PURE__*/ (0, _reactDefault.default).forwardRef(CardView);

},{"./CardBase":"aem24","./CardViewContext":"kisA8","@react-spectrum/utils":"cMIJ6","@react-stately/grid":"ehdYF","../intl/*.json":"2Cefb","@react-aria/utils":"9cLk5","@react-spectrum/progress":"4kHa7","react":"9yzVZ","@adobe/spectrum-css-temp/components/card/vars.css":"ibpeR","@react-aria/i18n":"411rg","@react-aria/grid":"6tGaN","@react-stately/list":"Cp0zP","@react-spectrum/provider":"5bCdp","@react-aria/virtualizer":"gAPsK","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"aem24":[function(require,module,exports) {
/*
 * Copyright 2021 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CardBase", ()=>_CardBase);
var _checkbox = require("@react-spectrum/checkbox");
var _utils = require("@react-spectrum/utils");
var _utils1 = require("@react-aria/utils");
var _focus = require("@react-aria/focus");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _varsCss = require("@adobe/spectrum-css-temp/components/card/vars.css");
var _varsCssDefault = parcelHelpers.interopDefault(_varsCss);
var _cardViewContext = require("./CardViewContext");
var _interactions = require("@react-aria/interactions");
var _provider = require("@react-spectrum/provider");
function CardBase(props, ref) {
    props = (0, _provider.useProviderProps)(props);
    let context = (0, _cardViewContext.useCardViewContext)() || {}; // we can call again here, won't change from Card.tsx
    let { state } = context;
    let manager = state === null || state === void 0 ? void 0 : state.selectionManager;
    let { isQuiet, orientation = "vertical", articleProps = {}, item, layout, children } = props;
    let key = item === null || item === void 0 ? void 0 : item.key;
    let isSelected = manager === null || manager === void 0 ? void 0 : manager.isSelected(key);
    let isDisabled = state === null || state === void 0 ? void 0 : state.disabledKeys.has(key);
    let onChange = ()=>manager === null || manager === void 0 ? void 0 : manager.select(key);
    let { styleProps } = (0, _utils.useStyleProps)(props);
    let { cardProps, titleProps, contentProps } = useCard(props);
    let domRef = (0, _utils.useDOMRef)(ref);
    let gridRef = (0, _react.useRef)();
    let checkboxRef = (0, _react.useRef)(null);
    // cards are only interactive if there is a selection manager and it allows selection
    let { hoverProps, isHovered } = (0, _interactions.useHover)({
        isDisabled: manager === undefined || (manager === null || manager === void 0 ? void 0 : manager.selectionMode) === "none" || isDisabled
    });
    let [isFocused, setIsFocused] = (0, _react.useState)(false);
    let { focusWithinProps } = (0, _interactions.useFocusWithin)({
        onFocusWithinChange: setIsFocused,
        isDisabled
    });
    // ToDo: see css for comment about avatar under selector .spectrum-Card--noLayout.spectrum-Card--default
    let hasPreviewImage = (0, _utils.useHasChild)(`.${(0, _varsCssDefault.default)["spectrum-Card-image"]}`, gridRef);
    let hasPreviewIllustration = (0, _utils.useHasChild)(`.${(0, _varsCssDefault.default)["spectrum-Card-illustration"]}`, gridRef);
    let hasPreview = hasPreviewImage || hasPreviewIllustration;
    // this is for horizontal cards
    let [height, setHeight] = (0, _react.useState)(NaN);
    let updateHeight = (0, _react.useCallback)(()=>{
        if (orientation !== "horizontal") return;
        let cardHeight = gridRef.current.getBoundingClientRect().height;
        setHeight(cardHeight);
    }, [
        orientation,
        gridRef,
        setHeight
    ]);
    (0, _utils1.useResizeObserver)({
        ref: gridRef,
        onResize: updateHeight
    });
    let aspectRatioEnforce = undefined;
    if (orientation === "horizontal" && !isNaN(height)) aspectRatioEnforce = {
        height: `${height}px`,
        width: `${height}px`
    };
    let slots = (0, _react.useMemo)(()=>({
            image: {
                UNSAFE_className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Card-image"),
                objectFit: orientation === "horizontal" ? "cover" : "contain",
                alt: "",
                ...aspectRatioEnforce
            },
            illustration: {
                UNSAFE_className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Card-illustration"),
                ...aspectRatioEnforce
            },
            avatar: {
                UNSAFE_className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Card-avatar"),
                size: "avatar-size-400"
            },
            heading: {
                UNSAFE_className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Card-heading"),
                ...titleProps
            },
            content: {
                UNSAFE_className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Card-content"),
                ...contentProps
            },
            detail: {
                UNSAFE_className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Card-detail")
            }
        }), [
        titleProps,
        contentProps,
        height,
        isQuiet,
        orientation
    ]);
    (0, _utils1.useLayoutEffect)(()=>{
        if (gridRef === null || gridRef === void 0 ? void 0 : gridRef.current) {
            let walker = (0, _focus.getFocusableTreeWalker)(gridRef.current);
            let nextNode = walker.nextNode();
            while(nextNode != null){
                if (checkboxRef.current && !checkboxRef.current.UNSAFE_getDOMNode().contains(nextNode)) {
                    console.warn("Card does not support focusable elements, please contact the team regarding your use case.");
                    break;
                }
                nextNode = walker.nextNode();
            }
        }
    }, [
        children
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _focus.FocusRing), {
        focusRingClass: (0, _utils.classNames)((0, _varsCssDefault.default), "focus-ring")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("article", {
        ...styleProps,
        ...(0, _utils1.mergeProps)(cardProps, focusWithinProps, hoverProps, (0, _utils1.filterDOMProps)(props), articleProps),
        ref: domRef,
        className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Card", {
            "spectrum-Card--default": !isQuiet && orientation !== "horizontal",
            "spectrum-Card--isQuiet": isQuiet && orientation !== "horizontal",
            "spectrum-Card--horizontal": orientation === "horizontal",
            "spectrum-Card--noPreview": !hasPreview,
            "is-hovered": isHovered,
            "is-focused": isFocused,
            "is-selected": isSelected,
            "spectrum-Card--waterfall": layout === "waterfall",
            "spectrum-Card--gallery": layout === "gallery",
            "spectrum-Card--grid": layout === "grid",
            "spectrum-Card--noLayout": layout !== "waterfall" && layout !== "gallery" && layout !== "grid"
        }, styleProps.className)
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ref: gridRef,
        className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Card-grid")
    }, manager && manager.selectionMode !== "none" && /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Card-checkboxWrapper")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _checkbox.Checkbox), {
        ref: checkboxRef,
        isDisabled: isDisabled,
        excludeFromTabOrder: true,
        isSelected: isSelected,
        onChange: onChange,
        UNSAFE_className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Card-checkbox"),
        isEmphasized: true,
        "aria-label": "select"
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.SlotProvider), {
        slots: slots
    }, children), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Card-decoration")
    }))));
}
function useCard(props) {
    let titleId = (0, _utils1.useSlotId)();
    let descriptionId = (0, _utils1.useSlotId)();
    let titleProps = (0, _react.useMemo)(()=>({
            id: titleId
        }), [
        titleId
    ]);
    let contentProps = (0, _react.useMemo)(()=>({
            id: descriptionId
        }), [
        descriptionId
    ]);
    return {
        cardProps: {
            ...(0, _utils1.filterDOMProps)(props),
            "aria-labelledby": titleId,
            "aria-describedby": descriptionId,
            tabIndex: 0
        },
        titleProps,
        contentProps
    };
}
/**
 * TODO: Add description of component here.
 */ const _CardBase = /*#__PURE__*/ (0, _reactDefault.default).forwardRef(CardBase);

},{"@react-spectrum/checkbox":"1r19j","@react-spectrum/utils":"cMIJ6","@react-aria/utils":"9cLk5","@react-aria/focus":"42mbF","react":"9yzVZ","@adobe/spectrum-css-temp/components/card/vars.css":"ibpeR","./CardViewContext":"kisA8","@react-aria/interactions":"ky3G8","@react-spectrum/provider":"5bCdp","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"ibpeR":[function(require,module,exports) {
module.exports["avatar"] = `dqWSla_avatar`;
module.exports["content"] = `dqWSla_content`;
module.exports["detail"] = `dqWSla_detail`;
module.exports["focus-ring"] = `dqWSla_focus-ring`;
module.exports["i18nFontFamily"] = `dqWSla_i18nFontFamily`;
module.exports["is-drop-target"] = `dqWSla_is-drop-target`;
module.exports["is-focused"] = `dqWSla_is-focused`;
module.exports["is-hovered"] = `dqWSla_is-hovered`;
module.exports["is-selected"] = `dqWSla_is-selected`;
module.exports["preview"] = `dqWSla_preview`;
module.exports["spectrum-Card"] = `dqWSla_spectrum-Card`;
module.exports["spectrum-Card--default"] = `dqWSla_spectrum-Card--default`;
module.exports["spectrum-Card--gallery"] = `dqWSla_spectrum-Card--gallery`;
module.exports["spectrum-Card--grid"] = `dqWSla_spectrum-Card--grid`;
module.exports["spectrum-Card--horizontal"] = `dqWSla_spectrum-Card--horizontal`;
module.exports["spectrum-Card--isQuiet"] = `dqWSla_spectrum-Card--isQuiet`;
module.exports["spectrum-Card--noLayout"] = `dqWSla_spectrum-Card--noLayout`;
module.exports["spectrum-Card--noPreview"] = `dqWSla_spectrum-Card--noPreview`;
module.exports["spectrum-Card--waterfall"] = `dqWSla_spectrum-Card--waterfall`;
module.exports["spectrum-Card-avatar"] = `dqWSla_spectrum-Card-avatar`;
module.exports["spectrum-Card-checkbox"] = `dqWSla_spectrum-Card-checkbox`;
module.exports["spectrum-Card-checkboxWrapper"] = `dqWSla_spectrum-Card-checkboxWrapper`;
module.exports["spectrum-Card-content"] = `dqWSla_spectrum-Card-content`;
module.exports["spectrum-Card-decoration"] = `dqWSla_spectrum-Card-decoration`;
module.exports["spectrum-Card-detail"] = `dqWSla_spectrum-Card-detail`;
module.exports["spectrum-Card-grid"] = `dqWSla_spectrum-Card-grid`;
module.exports["spectrum-Card-heading"] = `dqWSla_spectrum-Card-heading`;
module.exports["spectrum-Card-illustration"] = `dqWSla_spectrum-Card-illustration`;
module.exports["spectrum-Card-image"] = `dqWSla_spectrum-Card-image`;
module.exports["spectrum-CardView"] = `dqWSla_spectrum-CardView`;
module.exports["spectrum-CardView-centeredWrapper"] = `dqWSla_spectrum-CardView-centeredWrapper`;
module.exports["spectrum-CardView-row"] = `dqWSla_spectrum-CardView-row`;
module.exports["spectrum-FocusRing-ring"] = `dqWSla_spectrum-FocusRing-ring`;
module.exports["spectrum-FocusRing"] = `dqWSla_spectrum-FocusRing ${module.exports["spectrum-FocusRing-ring"]}`;
module.exports["spectrum-FocusRing--quiet"] = `dqWSla_spectrum-FocusRing--quiet`;
module.exports["title"] = `dqWSla_title`;

},{}],"kisA8":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CardViewContext", ()=>CardViewContext);
parcelHelpers.export(exports, "useCardViewContext", ()=>useCardViewContext);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const CardViewContext = /*#__PURE__*/ (0, _reactDefault.default).createContext(null);
function useCardViewContext() {
    return (0, _react.useContext)(CardViewContext);
}

},{"react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"2Cefb":[function(require,module,exports) {
const _temp0 = require("b381b258135a0021");
const _temp1 = require("d0b5771e9dbde83a");
const _temp2 = require("95b43ccf2351ff84");
const _temp3 = require("51fc9798a4d07dbe");
const _temp4 = require("178146e219381a45");
const _temp5 = require("84bc3094bde87f7e");
const _temp6 = require("6d235aa94a228536");
const _temp7 = require("424db50354f5a4e5");
const _temp8 = require("9c735b1f4e45bd49");
const _temp9 = require("6744347778595f98");
const _temp10 = require("e18f8205e0f08573");
const _temp11 = require("75b3897169ef78c2");
const _temp12 = require("589cfeb9f24edb15");
const _temp13 = require("40792b6499ffc0e0");
const _temp14 = require("4390eb92858752d0");
const _temp15 = require("b1903d5758cbcb14");
const _temp16 = require("d2c8aa22a0b6e58");
const _temp17 = require("3d025026279e3050");
const _temp18 = require("9dd9741329505610");
const _temp19 = require("1bbc238624344b57");
const _temp20 = require("f441a397ddee55eb");
const _temp21 = require("ae6cfc7d5d0003c6");
const _temp22 = require("7e7e8020c50e7ee");
const _temp23 = require("f372962c60412012");
const _temp24 = require("2150818bf787653e");
const _temp25 = require("cbae239abe7b832b");
const _temp26 = require("41f660fddbc88514");
const _temp27 = require("302894f9ab04357d");
const _temp28 = require("5e687a5f2e3258be");
const _temp29 = require("3c62ff7c8b6c1b4f");
const _temp30 = require("1658195c64a309f1");
const _temp31 = require("45d62316ad371abf");
const _temp32 = require("b391718b4ed1ee07");
const _temp33 = require("59ddbdbf3a766e7e");
module.exports = {
    "ar-AE": _temp0,
    "bg-BG": _temp1,
    "cs-CZ": _temp2,
    "da-DK": _temp3,
    "de-DE": _temp4,
    "el-GR": _temp5,
    "en-US": _temp6,
    "es-ES": _temp7,
    "et-EE": _temp8,
    "fi-FI": _temp9,
    "fr-FR": _temp10,
    "he-IL": _temp11,
    "hr-HR": _temp12,
    "hu-HU": _temp13,
    "it-IT": _temp14,
    "ja-JP": _temp15,
    "ko-KR": _temp16,
    "lt-LT": _temp17,
    "lv-LV": _temp18,
    "nb-NO": _temp19,
    "nl-NL": _temp20,
    "pl-PL": _temp21,
    "pt-BR": _temp22,
    "pt-PT": _temp23,
    "ro-RO": _temp24,
    "ru-RU": _temp25,
    "sk-SK": _temp26,
    "sl-SI": _temp27,
    "sr-SP": _temp28,
    "sv-SE": _temp29,
    "tr-TR": _temp30,
    "uk-UA": _temp31,
    "zh-CN": _temp32,
    "zh-TW": _temp33
};

},{"b381b258135a0021":"4rJ84","d0b5771e9dbde83a":"au2Ch","95b43ccf2351ff84":"iiLVq","51fc9798a4d07dbe":"7nuc2","178146e219381a45":"8LIkd","84bc3094bde87f7e":"h7Ebq","6d235aa94a228536":"3Tkzu","424db50354f5a4e5":"csRiZ","9c735b1f4e45bd49":"l0I13","6744347778595f98":"aSXqi","e18f8205e0f08573":"d599y","75b3897169ef78c2":"i68RE","589cfeb9f24edb15":"xc827","40792b6499ffc0e0":"kI7ui","4390eb92858752d0":"5X9N5","b1903d5758cbcb14":"7eSzW","d2c8aa22a0b6e58":"VDFNf","3d025026279e3050":"95NvH","9dd9741329505610":"l1s2F","1bbc238624344b57":"1cMRV","f441a397ddee55eb":"Dh9w3","ae6cfc7d5d0003c6":"gtKWY","7e7e8020c50e7ee":"isK9t","f372962c60412012":"eVUo2","2150818bf787653e":"iglA0","cbae239abe7b832b":"ff0Ne","41f660fddbc88514":"hIh8g","302894f9ab04357d":"90dmG","5e687a5f2e3258be":"2ORvx","3c62ff7c8b6c1b4f":"9FlYn","1658195c64a309f1":"b7nMX","45d62316ad371abf":"f5C6Q","b391718b4ed1ee07":"i8kEP","59ddbdbf3a766e7e":"lhZKR"}],"4rJ84":[function(require,module,exports) {
module.exports = {
    "loading": `\u{62C}\u{627}\u{631}\u{64D} \u{627}\u{644}\u{62A}\u{62D}\u{645}\u{64A}\u{644}...`,
    "loadingMore": `\u{62C}\u{627}\u{631}\u{64D} \u{62A}\u{62D}\u{645}\u{64A}\u{644} \u{627}\u{644}\u{645}\u{632}\u{64A}\u{62F}...`
};

},{}],"au2Ch":[function(require,module,exports) {
module.exports = {
    "loading": `\u{417}\u{430}\u{440}\u{435}\u{436}\u{434}\u{430}\u{43D}\u{435}...`,
    "loadingMore": `\u{417}\u{430}\u{440}\u{435}\u{436}\u{434}\u{430}\u{43D}\u{435} \u{43D}\u{430} \u{43E}\u{449}\u{435}...`
};

},{}],"iiLVq":[function(require,module,exports) {
module.exports = {
    "loading": `Na\u{10D}\xedt\xe1n\xed...`,
    "loadingMore": `Na\u{10D}\xedt\xe1n\xed dal\u{161}\xedch...`
};

},{}],"7nuc2":[function(require,module,exports) {
module.exports = {
    "loading": `Indl\xe6ser...`,
    "loadingMore": `Indl\xe6ser flere...`
};

},{}],"8LIkd":[function(require,module,exports) {
module.exports = {
    "loading": `Wird geladen...`,
    "loadingMore": `Noch mehr wird geladen...`
};

},{}],"h7Ebq":[function(require,module,exports) {
module.exports = {
    "loading": `\u{3A6}\u{3CC}\u{3C1}\u{3C4}\u{3C9}\u{3C3}\u{3B7}...`,
    "loadingMore": `\u{3A6}\u{3CC}\u{3C1}\u{3C4}\u{3C9}\u{3C3}\u{3B7} \u{3C0}\u{3B5}\u{3C1}\u{3B9}\u{3C3}\u{3C3}\u{3CC}\u{3C4}\u{3B5}\u{3C1}\u{3C9}\u{3BD}...`
};

},{}],"3Tkzu":[function(require,module,exports) {
module.exports = {
    "loading": `Loading\u{2026}`,
    "loadingMore": `Loading more\u{2026}`
};

},{}],"csRiZ":[function(require,module,exports) {
module.exports = {
    "loading": `Cargando\u{2026}`,
    "loadingMore": `Cargando m\xe1s\u{2026}`
};

},{}],"l0I13":[function(require,module,exports) {
module.exports = {
    "loading": `Laadimine...`,
    "loadingMore": `Laadi rohkem...`
};

},{}],"aSXqi":[function(require,module,exports) {
module.exports = {
    "loading": `Ladataan\u{2026}`,
    "loadingMore": `Ladataan lis\xe4\xe4\u{2026}`
};

},{}],"d599y":[function(require,module,exports) {
module.exports = {
    "loading": `Chargement en cours\u{2026}`,
    "loadingMore": `Chargement d\u{2019}autres d\u{2019}\xe9l\xe9ments\u{2026}`
};

},{}],"i68RE":[function(require,module,exports) {
module.exports = {
    "loading": `\u{5D8}\u{5D5}\u{5E2}\u{5DF}...`,
    "loadingMore": `\u{5D8}\u{5D5}\u{5E2}\u{5DF} \u{5E2}\u{5D5}\u{5D3}...`
};

},{}],"xc827":[function(require,module,exports) {
module.exports = {
    "loading": `U\u{10D}itavam...`,
    "loadingMore": `U\u{10D}itavam jo\u{161}...`
};

},{}],"kI7ui":[function(require,module,exports) {
module.exports = {
    "loading": `Bet\xf6lt\xe9s folyamatban\u{2026}`,
    "loadingMore": `Tov\xe1bbiak bet\xf6lt\xe9se folyamatban\u{2026}`
};

},{}],"5X9N5":[function(require,module,exports) {
module.exports = {
    "loading": `Caricamento...`,
    "loadingMore": `Caricamento altri...`
};

},{}],"7eSzW":[function(require,module,exports) {
module.exports = {
    "loading": `\u{8AAD}\u{307F}\u{8FBC}\u{307F}\u{4E2D}...`,
    "loadingMore": `\u{3055}\u{3089}\u{306B}\u{8AAD}\u{307F}\u{8FBC}\u{307F}\u{4E2D}...`
};

},{}],"VDFNf":[function(require,module,exports) {
module.exports = {
    "loading": `\u{B85C}\u{B4DC} \u{C911}\u{2026}`,
    "loadingMore": `\u{CD94}\u{AC00} \u{B85C}\u{B4DC} \u{C911}\u{2026}`
};

},{}],"95NvH":[function(require,module,exports) {
module.exports = {
    "loading": `\u{12E}keliama\u{2026}`,
    "loadingMore": `\u{12E}keliama daugiau\u{2026}`
};

},{}],"l1s2F":[function(require,module,exports) {
module.exports = {
    "loading": `Notiek iel\u{101}de\u{2026}`,
    "loadingMore": `Tiek iel\u{101}d\u{113}ts v\u{113}l...`
};

},{}],"1cMRV":[function(require,module,exports) {
module.exports = {
    "loading": `Laster inn...`,
    "loadingMore": `Laster inn flere...`
};

},{}],"Dh9w3":[function(require,module,exports) {
module.exports = {
    "loading": `Laden...`,
    "loadingMore": `Meer laden...`
};

},{}],"gtKWY":[function(require,module,exports) {
module.exports = {
    "loading": `Wczytywanie...`,
    "loadingMore": `Wczytywanie wi\u{119}kszej liczby...`
};

},{}],"isK9t":[function(require,module,exports) {
module.exports = {
    "loading": `Carregando...`,
    "loadingMore": `Carregando mais...`
};

},{}],"eVUo2":[function(require,module,exports) {
module.exports = {
    "loading": `A carregar...`,
    "loadingMore": `A carregar mais...`
};

},{}],"iglA0":[function(require,module,exports) {
module.exports = {
    "loading": `Se \xeencarc\u{103}...`,
    "loadingMore": `Se \xeencarc\u{103} mai multe...`
};

},{}],"ff0Ne":[function(require,module,exports) {
module.exports = {
    "loading": `\u{417}\u{430}\u{433}\u{440}\u{443}\u{437}\u{43A}\u{430}...`,
    "loadingMore": `\u{414}\u{43E}\u{43F}\u{43E}\u{43B}\u{43D}\u{438}\u{442}\u{435}\u{43B}\u{44C}\u{43D}\u{430}\u{44F} \u{437}\u{430}\u{433}\u{440}\u{443}\u{437}\u{43A}\u{430}...`
};

},{}],"hIh8g":[function(require,module,exports) {
module.exports = {
    "loading": `Na\u{10D}\xedtava sa...`,
    "loadingMore": `Na\u{10D}\xedtava sa viac...`
};

},{}],"90dmG":[function(require,module,exports) {
module.exports = {
    "loading": `Nalaganje...`,
    "loadingMore": `Nalaganje dodatne vsebine...`
};

},{}],"2ORvx":[function(require,module,exports) {
module.exports = {
    "loading": `U\u{10D}itavam...`,
    "loadingMore": `U\u{10D}itavam jo\u{161}...`
};

},{}],"9FlYn":[function(require,module,exports) {
module.exports = {
    "loading": `L\xe4ser in...`,
    "loadingMore": `L\xe4ser in mer...`
};

},{}],"b7nMX":[function(require,module,exports) {
module.exports = {
    "loading": `Y\xfckleniyor...`,
    "loadingMore": `Daha fazla y\xfckleniyor...`
};

},{}],"f5C6Q":[function(require,module,exports) {
module.exports = {
    "loading": `\u{417}\u{430}\u{432}\u{430}\u{43D}\u{442}\u{430}\u{436}\u{435}\u{43D}\u{43D}\u{44F}\u{2026}`,
    "loadingMore": `\u{417}\u{430}\u{432}\u{430}\u{43D}\u{442}\u{430}\u{436}\u{435}\u{43D}\u{43D}\u{44F} \u{456}\u{43D}\u{448}\u{438}\u{445} \u{43E}\u{431}\u{2019}\u{454}\u{43A}\u{442}\u{456}\u{432}...`
};

},{}],"i8kEP":[function(require,module,exports) {
module.exports = {
    "loading": `\u{6B63}\u{5728}\u{52A0}\u{8F7D}...`,
    "loadingMore": `\u{6B63}\u{5728}\u{52A0}\u{8F7D}\u{66F4}\u{591A}...`
};

},{}],"lhZKR":[function(require,module,exports) {
module.exports = {
    "loading": `\u{6B63}\u{5728}\u{8F09}\u{5165}\u{2026}`,
    "loadingMore": `\u{6B63}\u{5728}\u{8F09}\u{5165}\u{66F4}\u{591A}\u{2026}`
};

},{}],"iyUVy":[function(require,module,exports) {
/*
 * Copyright 2021 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GalleryLayout", ()=>GalleryLayout);
var _baseLayout = require("./BaseLayout");
var _virtualizer = require("@react-stately/virtualizer");
const DEFAULT_OPTIONS = {
    S: {
        idealRowHeight: 112,
        minItemSize: new (0, _virtualizer.Size)(96, 96),
        itemSpacing: new (0, _virtualizer.Size)(8, 16),
        itemPadding: 24,
        dropSpacing: 50,
        margin: 8
    },
    L: {
        idealRowHeight: 208,
        minItemSize: new (0, _virtualizer.Size)(136, 136),
        itemSpacing: new (0, _virtualizer.Size)(18, 18),
        itemPadding: {
            "medium": 78,
            "large": 99
        },
        dropSpacing: 100,
        margin: 24
    }
};
class GalleryLayout extends (0, _baseLayout.BaseLayout) {
    get layoutType() {
        return "gallery";
    }
    /**
   * Takes a row of widths and if there are any widths smaller than the min-width, leech width starting from
   * the widest in the row until it can't give anymore, then move to the second widest and so forth.
   * Do this until all assets meet the min-width.
   * */ _distributeWidths(widths) {
        // create a copy of the widths array and sort it largest to smallest
        let sortedWidths = widths.concat().sort((a, b)=>a[1] > b[1] ? -1 : 1);
        for (let width of widths)// for each width, if it's smaller than the min width
        if (width[1] < this.minItemSize.width) {
            // then figure out how much smaller
            let delta = this.minItemSize.width - width[1];
            for (let item of sortedWidths)// go from the largest width in the row to the smallest
            // if the width is greater than the min width
            if (widths[item[0]][1] > this.minItemSize.width) {
                // subtract the delta from the width, if it's still greater than the min width
                // then we have finished, subtract the delta permanently from that width
                // eslint-disable-next-line max-depth
                if (widths[item[0]][1] - delta > this.minItemSize.width) {
                    widths[item[0]][1] -= delta;
                    delta = 0;
                    break;
                } else {
                    // otherwise, we take as much as we can from the current width and then move on to
                    // the next largest and take some width from it
                    let maxChange = widths[item[0]][1] - this.minItemSize.width;
                    delta -= maxChange;
                    widths[item[0]][1] -= maxChange;
                }
            }
            if (delta > 0) return false;
            // force the width to be the min width that we just rebalanced for
            width[1] = this.minItemSize.width;
        }
        return true;
    }
    buildCollection() {
        let visibleWidth = this.virtualizer.visibleRect.width;
        let visibleHeight = this.virtualizer.visibleRect.height;
        let y = this.margin;
        let availableWidth = visibleWidth - this.margin * 2;
        // If avaliable width is not greater than 0, skip node layout calculations
        if (availableWidth > 0) {
            // Compute aspect ratios for all of the items, and the total width if all items were on in a single row.
            let ratios = [];
            let totalWidth = 0;
            let minRatio = this.minItemSize.width / this.minItemSize.height;
            let maxRatio = availableWidth / this.minItemSize.height;
            for (let node of this.collection){
                let ratio = node.props.width / node.props.height;
                if (ratio < minRatio) ratio = minRatio;
                else if (ratio > maxRatio && ratio !== minRatio) ratio = maxRatio;
                let itemWidth = ratio * this.minItemSize.height;
                ratios.push(ratio);
                totalWidth += itemWidth;
            }
            totalWidth += this.itemSpacing.width * (this.collection.size - 1);
            // Determine how many rows we'll need, and partition the items into rows
            // using the aspect ratios as weights.
            let rows = Math.max(1, Math.ceil(totalWidth / availableWidth));
            // if the available width can't hold two items, then every item will get its own row
            // this leads to a faster run through linear partition and more dependable output for small row widths
            if (availableWidth <= this.minItemSize.width * 2 + this.itemPadding * 2) rows = this.collection.size;
            let weightedRatios = ratios.map((ratio)=>ratio < this.threshold ? ratio + 0.5 * (1 / ratio) : ratio);
            let partition = linearPartition(weightedRatios, rows);
            let index = 0;
            for (let row of partition){
                // Compute the total weight for this row
                let totalWeight = 0;
                for(let j = index; j < index + row.length; j++)totalWeight += ratios[j];
                // Determine the row height based on the total available width and weight of this row.
                let bestRowHeight = (availableWidth - (row.length - 1) * this.itemSpacing.width) / totalWeight;
                // if this is the last row and the row height is >2x the ideal row height, then cap to the ideal height
                // probably doing this because if the last row has one extremely tall image, then the row becomes huge
                // though that can happen anywhere if a row has lots of tall images... so i'm not sure why this one matters
                if (row === partition[partition.length - 1] && bestRowHeight > this.idealRowHeight * 2) bestRowHeight = this.idealRowHeight;
                let itemHeight = Math.round(bestRowHeight) + this.itemPadding;
                let x = this.margin;
                // if any items are going to end up too small, add a bit of width to them and subtract it from wider objects
                let widths = [];
                for(let j = index; j < index + row.length; j++){
                    let width = Math.round(bestRowHeight * ratios[j]);
                    widths.push([
                        j - index,
                        width
                    ]);
                }
                this._distributeWidths(widths);
                // Create items for this row.
                for(let j = index; j < index + row.length; j++){
                    let node = this.collection.rows[j];
                    let itemWidth = Math.max(widths[j - index][1], this.minItemSize.width);
                    let rect = new (0, _virtualizer.Rect)(x, y, itemWidth, itemHeight);
                    let layoutInfo = new (0, _virtualizer.LayoutInfo)(node.type, node.key, rect);
                    layoutInfo.allowOverflow = true;
                    this.layoutInfos.set(node.key, layoutInfo);
                    x += itemWidth + this.itemSpacing.width;
                }
                y += itemHeight + this.itemSpacing.height;
                index += row.length;
            }
            if (this.isLoading) {
                let loaderY = y;
                let loaderHeight = 60;
                // If there aren't any items, make loader take all avaliable room and remove margin from y calculation
                // so it doesn't scroll
                if (this.collection.size === 0) {
                    loaderY = 0;
                    loaderHeight = visibleHeight || 60;
                }
                let rect = new (0, _virtualizer.Rect)(0, loaderY, visibleWidth, loaderHeight);
                let loader = new (0, _virtualizer.LayoutInfo)("loader", "loader", rect);
                this.layoutInfos.set("loader", loader);
                y = loader.rect.maxY;
            }
            if (this.collection.size === 0 && !this.isLoading) {
                let rect = new (0, _virtualizer.Rect)(0, 0, visibleWidth, visibleHeight);
                let placeholder = new (0, _virtualizer.LayoutInfo)("placeholder", "placeholder", rect);
                this.layoutInfos.set("placeholder", placeholder);
                y = placeholder.rect.maxY;
            }
        }
        this.contentSize = new (0, _virtualizer.Size)(visibleWidth, y);
    }
    constructor(options = {}){
        super(options);
        let cardSize = "L";
        this.idealRowHeight = options.idealRowHeight || DEFAULT_OPTIONS[cardSize].idealRowHeight;
        this.itemSpacing = options.itemSpacing || DEFAULT_OPTIONS[cardSize].itemSpacing;
        this.itemPadding = options.itemPadding != null ? options.itemPadding : DEFAULT_OPTIONS[cardSize].itemPadding[this.scale];
        this.minItemSize = options.minItemSize || DEFAULT_OPTIONS[cardSize].minItemSize;
        this.threshold = options.threshold || 1;
        this.margin = options.margin != null ? options.margin : DEFAULT_OPTIONS[cardSize].margin;
    }
}
// https://www8.cs.umu.se/kurser/TDBA77/VT06/algorithms/BOOK/BOOK2/NODE45.HTM
function linearPartition(seq, k) {
    let n = seq.length;
    if (k <= 0) return [];
    if (k >= n) return seq.map((x)=>[
            x
        ]);
    if (n === 1) return [
        seq
    ];
    let table = Array(n).fill(0).map(()=>Array(k).fill(0));
    let solution = Array(n - 1).fill(0).map(()=>Array(k - 1).fill(0));
    for(let i = 0; i < n; i++)table[i][0] = seq[i] + (i > 0 ? table[i - 1][0] : 0);
    for(let i = 0; i < k; i++)table[0][i] = seq[0];
    for(let i = 1; i < n; i++)for(let j = 1; j < k; j++){
        let currentMin = 0;
        let minX = Infinity;
        for(let x = 0; x < i; x++){
            let c1 = table[x][j - 1];
            let c2 = table[i][0] - table[x][0];
            let cost = Math.max(c1, c2);
            if (!x || cost < currentMin) {
                currentMin = cost;
                minX = x;
            }
        }
        table[i][j] = currentMin;
        solution[i - 1][j - 1] = minX;
    }
    n = n - 1;
    k = k - 2;
    let result = [];
    while(k >= 0){
        if (n >= 1) {
            let row = [];
            for(let i = solution[n - 1][k] + 1; i < n + 1; i++)row.push(seq[i]);
            result.unshift(row);
            n = solution[n - 1][k];
        }
        k--;
    }
    let row = [];
    for(let i = 0; i < n + 1; i++)row.push(seq[i]);
    result.unshift(row);
    return result;
}

},{"./BaseLayout":"39Kn0","@react-stately/virtualizer":"lVS5O","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"39Kn0":[function(require,module,exports) {
/*
 * Copyright 2021 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BaseLayout", ()=>BaseLayout);
var _collections = require("@react-stately/collections");
var _virtualizer = require("@react-stately/virtualizer");
class BaseLayout extends (0, _virtualizer.Layout) {
    validate(invalidationContext) {
        this.collection = this.virtualizer.collection;
        this.buildCollection(invalidationContext);
        // Remove layout info that doesn't exist in new collection
        if (this.lastCollection) {
            for (let key of this.lastCollection.getKeys())if (!this.collection.getItem(key)) this.layoutInfos.delete(key);
            if (!this.isLoading) this.layoutInfos.delete("loader");
            if (this.collection.size > 0) this.layoutInfos.delete("placeholder");
        }
        this.lastCollection = this.collection;
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    buildCollection(invalidationContext) {}
    getContentSize() {
        return this.contentSize;
    }
    getLayoutInfo(key) {
        return this.layoutInfos.get(key);
    }
    getVisibleLayoutInfos(rect) {
        let res = [];
        for (let layoutInfo of this.layoutInfos.values())if (this.isVisible(layoutInfo, rect)) res.push(layoutInfo);
        return res;
    }
    isVisible(layoutInfo, rect) {
        return layoutInfo.rect.intersects(rect);
    }
    getInitialLayoutInfo(layoutInfo) {
        layoutInfo.opacity = 0;
        layoutInfo.transform = "scale3d(0.8, 0.8, 0.8)";
        return layoutInfo;
    }
    getFinalLayoutInfo(layoutInfo) {
        layoutInfo.opacity = 0;
        layoutInfo.transform = "scale3d(0.8, 0.8, 0.8)";
        return layoutInfo;
    }
    _findClosestLayoutInfo(target, rect) {
        let layoutInfos = this.getVisibleLayoutInfos(rect);
        let best = null;
        let bestDistance = Infinity;
        // Calculates distance as the distance between the center of 2 rects.
        for (let cur of layoutInfos)if (cur.type === "item") {
            let curRect = cur.rect;
            let targetMidX = (target.x + target.maxX) / 2;
            let targetMidY = (target.y + target.maxY) / 2;
            let curMidX = (curRect.x + curRect.maxX) / 2;
            let curMidY = (curRect.y + curRect.maxY) / 2;
            let dist = Math.pow(targetMidX - curMidX, 2) + Math.pow(targetMidY - curMidY, 2);
            if (dist < bestDistance) {
                best = cur;
                bestDistance = dist;
            }
        }
        return best;
    }
    _findClosest(target, rect) {
        let best = this._findClosestLayoutInfo(target, rect);
        return best || null;
    }
    getKeyBelow(key) {
        var _this__findClosest, _getFirstItem;
        // Expected key is the currently focused cell so we need the parent row key
        let parentRowKey = this.collection.getItem(key).parentKey;
        let layoutInfo = this.getLayoutInfo(parentRowKey);
        let rect = new (0, _virtualizer.Rect)(layoutInfo.rect.x, layoutInfo.rect.maxY + 1, layoutInfo.rect.width, this.virtualizer.visibleRect.height);
        let closestRow = this.collection.getItem((_this__findClosest = this._findClosest(layoutInfo.rect, rect)) === null || _this__findClosest === void 0 ? void 0 : _this__findClosest.key);
        return (_getFirstItem = (0, _collections.getFirstItem)((0, _collections.getChildNodes)(closestRow, this.collection))) === null || _getFirstItem === void 0 ? void 0 : _getFirstItem.key;
    }
    getKeyAbove(key) {
        var _this__findClosest, _getFirstItem;
        // Expected key is the currently focused cell so we need the parent row key
        let parentRowKey = this.collection.getItem(key).parentKey;
        let layoutInfo = this.getLayoutInfo(parentRowKey);
        let rect = new (0, _virtualizer.Rect)(layoutInfo.rect.x, 0, layoutInfo.rect.width, layoutInfo.rect.y - 1);
        let closestRow = this.collection.getItem((_this__findClosest = this._findClosest(layoutInfo.rect, rect)) === null || _this__findClosest === void 0 ? void 0 : _this__findClosest.key);
        return (_getFirstItem = (0, _collections.getFirstItem)((0, _collections.getChildNodes)(closestRow, this.collection))) === null || _getFirstItem === void 0 ? void 0 : _getFirstItem.key;
    }
    getKeyRightOf(key) {
        // Expected key is the currently focused cell so we need the parent row key
        let parentRowKey = this.collection.getItem(key).parentKey;
        key = this.direction === "rtl" ? this.collection.getKeyBefore(parentRowKey) : this.collection.getKeyAfter(parentRowKey);
        while(key != null){
            var _getFirstItem;
            let item = this.collection.getItem(key);
            // Don't check if item is disabled because we want to be able to focus disabled items in a grid (double check this)
            if (item.type === "item") return (_getFirstItem = (0, _collections.getFirstItem)((0, _collections.getChildNodes)(item, this.collection))) === null || _getFirstItem === void 0 ? void 0 : _getFirstItem.key;
            key = this.direction === "rtl" ? this.collection.getKeyBefore(key) : this.collection.getKeyAfter(key);
        }
    }
    getKeyLeftOf(key) {
        // Expected key is the currently focused cell so we need the parent row key
        let parentRowKey = this.collection.getItem(key).parentKey;
        key = this.direction === "rtl" ? this.collection.getKeyAfter(parentRowKey) : this.collection.getKeyBefore(parentRowKey);
        while(key != null){
            var _getFirstItem;
            let item = this.collection.getItem(key);
            // Don't check if item is disabled because we want to be able to focus disabled items in a grid (double check this)
            if (item.type === "item") return (_getFirstItem = (0, _collections.getFirstItem)((0, _collections.getChildNodes)(item, this.collection))) === null || _getFirstItem === void 0 ? void 0 : _getFirstItem.key;
            key = this.direction === "rtl" ? this.collection.getKeyAfter(key) : this.collection.getKeyBefore(key);
        }
    }
    getFirstKey() {
        var _getFirstItem;
        let firstRow = this.collection.getItem(this.collection.getFirstKey());
        return (_getFirstItem = (0, _collections.getFirstItem)((0, _collections.getChildNodes)(firstRow, this.collection))) === null || _getFirstItem === void 0 ? void 0 : _getFirstItem.key;
    }
    getLastKey() {
        var _getFirstItem;
        let lastRow = this.collection.getItem(this.collection.getLastKey());
        return (_getFirstItem = (0, _collections.getFirstItem)((0, _collections.getChildNodes)(lastRow, this.collection))) === null || _getFirstItem === void 0 ? void 0 : _getFirstItem.key;
    }
    // TODO: pretty unwieldy because it needs to bounce back and forth between the parent key and the child key
    // Perhaps have layoutInfo store childKey as well so we don't need to do this? Or maybe make the layoutInfos be the cells instead of the rows?
    getKeyPageAbove(key) {
        // Expected key is the currently focused cell so we need the parent row key
        let parentRowKey = this.collection.getItem(key).parentKey;
        let layoutInfo = this.getLayoutInfo(parentRowKey);
        if (layoutInfo) {
            var _this_collection_getItem;
            let pageY = Math.max(0, layoutInfo.rect.y + layoutInfo.rect.height - this.virtualizer.visibleRect.height);
            // If the node is so large that it spans multiple page heights, return the key of the item immediately above
            // Otherwise keep going up until we exceed a single page height worth of nodes
            let keyAbove = (_this_collection_getItem = this.collection.getItem(this.getKeyAbove(key))) === null || _this_collection_getItem === void 0 ? void 0 : _this_collection_getItem.parentKey;
            layoutInfo = this.getLayoutInfo(keyAbove);
            if (layoutInfo && layoutInfo.rect.y > pageY) while(layoutInfo && layoutInfo.rect.y > pageY){
                var _getFirstItem, _this_collection_getItem1;
                let childKey = (_getFirstItem = (0, _collections.getFirstItem)((0, _collections.getChildNodes)(this.collection.getItem(layoutInfo.key), this.collection))) === null || _getFirstItem === void 0 ? void 0 : _getFirstItem.key;
                let keyAbove = (_this_collection_getItem1 = this.collection.getItem(this.getKeyAbove(childKey))) === null || _this_collection_getItem1 === void 0 ? void 0 : _this_collection_getItem1.parentKey;
                layoutInfo = this.getLayoutInfo(keyAbove);
            }
            if (layoutInfo) {
                var _getFirstItem1;
                let childKey = (_getFirstItem1 = (0, _collections.getFirstItem)((0, _collections.getChildNodes)(this.collection.getItem(layoutInfo.key), this.collection))) === null || _getFirstItem1 === void 0 ? void 0 : _getFirstItem1.key;
                return childKey;
            }
        }
        return this.getFirstKey();
    }
    // TODO: pretty unwieldy because it needs to bounce back and forth between the parent key and the child key
    // Perhaps have layoutInfo store childKey as well so we don't need to do this?
    getKeyPageBelow(key) {
        // Expected key is the currently focused cell so we need the parent row key
        let parentRowKey = this.collection.getItem(key).parentKey;
        let layoutInfo = this.getLayoutInfo(parentRowKey);
        if (layoutInfo) {
            var _this_collection_getItem;
            let pageY = Math.min(this.virtualizer.contentSize.height, layoutInfo.rect.y - layoutInfo.rect.height + this.virtualizer.visibleRect.height);
            // If the node is so large that it spans multiple page heights, return the key of the item immediately below
            // Otherwise keep going up until we exceed a single page height worth of nodes
            let keyBelow = (_this_collection_getItem = this.collection.getItem(this.getKeyBelow(key))) === null || _this_collection_getItem === void 0 ? void 0 : _this_collection_getItem.parentKey;
            layoutInfo = this.getLayoutInfo(keyBelow);
            if (layoutInfo && layoutInfo.rect.y < pageY) while(layoutInfo && layoutInfo.rect.y < pageY){
                var _getFirstItem, _this_collection_getItem1;
                let childKey = (_getFirstItem = (0, _collections.getFirstItem)((0, _collections.getChildNodes)(this.collection.getItem(layoutInfo.key), this.collection))) === null || _getFirstItem === void 0 ? void 0 : _getFirstItem.key;
                let keyBelow = (_this_collection_getItem1 = this.collection.getItem(this.getKeyBelow(childKey))) === null || _this_collection_getItem1 === void 0 ? void 0 : _this_collection_getItem1.parentKey;
                layoutInfo = this.getLayoutInfo(keyBelow);
            }
            if (layoutInfo) {
                var _getFirstItem1;
                let childKey = (_getFirstItem1 = (0, _collections.getFirstItem)((0, _collections.getChildNodes)(this.collection.getItem(layoutInfo.key), this.collection))) === null || _getFirstItem1 === void 0 ? void 0 : _getFirstItem1.key;
                return childKey;
            }
        }
        return this.getLastKey();
    }
    getKeyForSearch(search, fromKey) {
        if (!this.collator) return null;
        let collection = this.collection;
        let key = fromKey !== null && fromKey !== void 0 ? fromKey : this.getFirstKey();
        let startItem = collection.getItem(key);
        key = startItem.parentKey;
        while(key != null){
            let item = collection.getItem(key);
            if (item.textValue) {
                var _getFirstItem;
                let substring = item.textValue.slice(0, search.length);
                if (this.collator.compare(substring, search) === 0) return (_getFirstItem = (0, _collections.getFirstItem)((0, _collections.getChildNodes)(item, this.collection))) === null || _getFirstItem === void 0 ? void 0 : _getFirstItem.key;
            }
            key = this.collection.getKeyAfter(key);
        }
        return null;
    }
    constructor(options = {}){
        super();
        this.disabledKeys = new Set();
        this.layoutInfos = new Map();
        this.collator = options.collator;
        this.lastCollection = null;
        this.scale = options.scale || "medium";
        this.margin = options.margin || 24;
    }
}

},{"@react-stately/collections":"loANi","@react-stately/virtualizer":"lVS5O","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"9Lzhj":[function(require,module,exports) {
/*
 * Copyright 2021 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GridLayout", ()=>GridLayout);
var _baseLayout = require("./BaseLayout");
var _collections = require("@react-stately/collections");
var _virtualizer = require("@react-stately/virtualizer");
const DEFAULT_OPTIONS = {
    S: {
        itemPadding: 20,
        minItemSize: {
            "vertical": new (0, _virtualizer.Size)(96, 96)
        },
        maxItemSize: new (0, _virtualizer.Size)(Infinity, Infinity),
        margin: 8,
        minSpace: new (0, _virtualizer.Size)(6, 6),
        maxColumns: Infinity,
        dropSpacing: 50
    },
    L: {
        itemPadding: {
            "vertical": {
                "medium": 78,
                "large": 98
            },
            "horizontal": {
                "medium": 150,
                "large": 170
            }
        },
        minItemSize: {
            "vertical": new (0, _virtualizer.Size)(208, 208),
            "horizontal": new (0, _virtualizer.Size)(102, 102)
        },
        maxItemSize: new (0, _virtualizer.Size)(Infinity, Infinity),
        margin: 24,
        minSpace: new (0, _virtualizer.Size)(18, 18),
        maxColumns: Infinity,
        dropSpacing: 100
    }
};
class GridLayout extends (0, _baseLayout.BaseLayout) {
    get layoutType() {
        return "grid";
    }
    getIndexAtPoint(x, y, allowInsertingAtEnd = false) {
        let itemHeight = this.itemSize.height + this.minSpace.height;
        let itemWidth = this.itemSize.width + this.horizontalSpacing;
        return Math.max(0, Math.min(this.collection.size - (allowInsertingAtEnd ? 0 : 1), Math.floor(y / itemHeight) * this.numColumns + Math.floor((x - this.horizontalSpacing) / itemWidth)));
    }
    getVisibleLayoutInfos(rect) {
        let res = [];
        let numItems = this.collection.size;
        if (numItems <= 0 || !this.itemSize) // If there aren't any items in the collection, we are in a loader/placeholder state. Return those layoutInfos as
        // the currently visible items
        {
            if (this.layoutInfos.size > 0) {
                for (let layoutInfo of this.layoutInfos.values())if (this.isVisible(layoutInfo, rect)) res.push(layoutInfo);
            }
        } else {
            // The approach from v2 uses indexes where other v3 layouts iterate through every node/root node. This feels more efficient
            let firstVisibleItem = this.getIndexAtPoint(rect.x, rect.y);
            let lastVisibleItem = this.getIndexAtPoint(rect.maxX, rect.maxY);
            for(let index = firstVisibleItem; index <= lastVisibleItem; index++){
                let keyFromIndex = this.collection.rows[index].key;
                let layoutInfo = this.layoutInfos.get(keyFromIndex);
                if (layoutInfo && this.isVisible(layoutInfo, rect)) res.push(layoutInfo);
            }
            // Check if loader is in view and add to res if so
            let loader = this.layoutInfos.get("loader");
            if (loader && this.isVisible(loader, rect)) res.push(loader);
        }
        return res;
    }
    buildCollection() {
        let visibleWidth = this.virtualizer.visibleRect.width;
        let visibleHeight = this.virtualizer.visibleRect.height;
        let horizontalItemPadding = this.cardOrientation === "horizontal" ? this.itemPadding : 0;
        let verticalItemPadding = this.cardOrientation === "vertical" ? this.itemPadding : 0;
        let minCardWidth = this.minItemSize.width + horizontalItemPadding;
        // Compute the number of rows and columns needed to display the content
        let availableWidth = visibleWidth - this.margin * 2;
        let columns = Math.floor((availableWidth + this.minSpace.width) / (minCardWidth + this.minSpace.width));
        this.numColumns = Math.max(1, Math.min(this.maxColumns, columns));
        this.numRows = Math.ceil(this.collection.size / this.numColumns);
        // Compute the available width (minus the space between items)
        let width = availableWidth - this.minSpace.width * Math.max(0, this.numColumns - 1);
        // Compute the item width based on the space available
        let itemWidth = Math.floor(width / this.numColumns);
        itemWidth = Math.max(minCardWidth, Math.min(this.maxItemSize.width, itemWidth));
        // Compute the item height, which is proportional to the item width
        let t = (itemWidth - minCardWidth) / minCardWidth;
        let itemHeight = Math.floor(this.minItemSize.height + this.minItemSize.height * t);
        itemHeight = Math.max(this.minItemSize.height, Math.min(this.maxItemSize.height, itemHeight)) + verticalItemPadding;
        this.itemSize = new (0, _virtualizer.Size)(itemWidth, itemHeight);
        // Compute the horizontal spacing and content height
        this.horizontalSpacing = this.numColumns < 2 ? 0 : Math.floor((availableWidth - this.numColumns * this.itemSize.width) / (this.numColumns - 1));
        let y = this.margin;
        let index = 0;
        for (let node of this.collection){
            let layoutInfo = this.buildChild(node, y, index);
            y = layoutInfo.rect.maxY;
            index++;
        }
        if (this.isLoading) {
            let loaderY = y;
            let loaderHeight = 60;
            // If there aren't any items, make loader take all avaliable room and remove margin from y calculation
            // so it doesn't scroll
            if (this.collection.size === 0) {
                loaderY = 0;
                loaderHeight = visibleHeight || 60;
            }
            let rect = new (0, _virtualizer.Rect)(0, loaderY, visibleWidth, loaderHeight);
            let loader = new (0, _virtualizer.LayoutInfo)("loader", "loader", rect);
            this.layoutInfos.set("loader", loader);
            y = loader.rect.maxY;
        }
        if (this.collection.size === 0 && !this.isLoading) {
            let rect = new (0, _virtualizer.Rect)(0, 0, visibleWidth, visibleHeight);
            let placeholder = new (0, _virtualizer.LayoutInfo)("placeholder", "placeholder", rect);
            this.layoutInfos.set("placeholder", placeholder);
            y = placeholder.rect.maxY;
        }
        this.contentSize = new (0, _virtualizer.Size)(visibleWidth, y);
    }
    buildChild(node, y, index) {
        let row = Math.floor(index / this.numColumns);
        let column = index % this.numColumns;
        let x = this.margin + column * (this.itemSize.width + this.horizontalSpacing);
        y = this.margin + row * (this.itemSize.height + this.minSpace.height);
        let rect = new (0, _virtualizer.Rect)(x, y, this.itemSize.width, this.itemSize.height);
        // TODO: Perhaps have it so that the child key for each row is stored with the layoutInfo?
        let layoutInfo = new (0, _virtualizer.LayoutInfo)(node.type, node.key, rect);
        layoutInfo.allowOverflow = true;
        this.layoutInfos.set(node.key, layoutInfo);
        return layoutInfo;
    }
    // Since the collection doesn't represent the visual layout, need to calculate what row and column the current key is in,
    // then return the key that occupies the row + column below. This can be done by figuring out how many cards exist per column then dividing the
    // collection contents by that number (which will give us the row distribution)
    getKeyBelow(key) {
        var _getFirstItem;
        // Expected key is the currently focused cell so we need the parent row key
        let parentRowKey = this.collection.getItem(key).parentKey;
        let indexRowBelow;
        let index = this.collection.rows.findIndex((card)=>card.key === parentRowKey);
        if (index !== -1) indexRowBelow = index + this.numColumns;
        else return null;
        let row = this.collection.rows[indexRowBelow];
        return row ? (_getFirstItem = (0, _collections.getFirstItem)((0, _collections.getChildNodes)(row, this.collection))) === null || _getFirstItem === void 0 ? void 0 : _getFirstItem.key : null;
    }
    getKeyAbove(key) {
        var _getFirstItem;
        // Expected key is the currently focused cell so we need the parent row key
        let parentRowKey = this.collection.getItem(key).parentKey;
        let indexRowAbove;
        let index = this.collection.rows.findIndex((card)=>card.key === parentRowKey);
        if (index !== -1) indexRowAbove = index - this.numColumns;
        else return null;
        let row = this.collection.rows[indexRowAbove];
        return row ? (_getFirstItem = (0, _collections.getFirstItem)((0, _collections.getChildNodes)(row, this.collection))) === null || _getFirstItem === void 0 ? void 0 : _getFirstItem.key : null;
    }
    constructor(options = {}){
        super(options);
        let cardSize = "L";
        this.cardOrientation = options.cardOrientation || "vertical";
        this.minItemSize = options.minItemSize || DEFAULT_OPTIONS[cardSize].minItemSize[this.cardOrientation];
        this.maxItemSize = options.maxItemSize || DEFAULT_OPTIONS[cardSize].maxItemSize;
        this.margin = options.margin != null ? options.margin : DEFAULT_OPTIONS[cardSize].margin;
        this.minSpace = options.minSpace || DEFAULT_OPTIONS[cardSize].minSpace;
        this.maxColumns = options.maxColumns || DEFAULT_OPTIONS[cardSize].maxColumns;
        this.itemPadding = options.itemPadding != null ? options.itemPadding : DEFAULT_OPTIONS[cardSize].itemPadding[this.cardOrientation][this.scale];
        this.itemSize = null;
        this.numColumns = 0;
        this.numRows = 0;
        this.horizontalSpacing = 0;
    }
}

},{"./BaseLayout":"39Kn0","@react-stately/collections":"loANi","@react-stately/virtualizer":"lVS5O","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"3vtFb":[function(require,module,exports) {
/*
 * Copyright 2021 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// TODO: this didn't have any options that varied with card size, should it have?
parcelHelpers.export(exports, "WaterfallLayout", ()=>WaterfallLayout);
var _baseLayout = require("./BaseLayout");
var _collections = require("@react-stately/collections");
var _virtualizer = require("@react-stately/virtualizer");
class WaterfallLayout extends (0, _baseLayout.BaseLayout) {
    get layoutType() {
        return "waterfall";
    }
    buildCollection(invalidationContext) {
        // Compute the number of columns needed to display the content
        let visibleWidth = this.virtualizer.visibleRect.width;
        let availableWidth = visibleWidth - this.margin * 2;
        let columns = Math.floor((availableWidth + this.minSpace.width) / (this.minItemSize.width + this.minSpace.width));
        this.numColumns = Math.max(1, Math.min(this.maxColumns, columns));
        // Compute the available width (minus the space between items)
        let width = availableWidth - this.minSpace.width * (this.numColumns - 1);
        // Compute the item width based on the space available
        let itemWidth = Math.round(width / this.numColumns);
        itemWidth = Math.max(this.minItemSize.width, Math.min(this.maxItemSize.width, itemWidth));
        this.itemWidth = itemWidth;
        // Compute the horizontal spacing
        // if only one column, we cannot divide by zero, so set it to 1
        let horizontalSpacing = Math.round((availableWidth - this.numColumns * itemWidth) / Math.max(1, this.numColumns - 1));
        this.horizontalSpacing = horizontalSpacing;
        // Setup an array of column heights
        let columnHeights = Array(this.numColumns).fill(this.margin);
        for (let node of this.collection){
            let key = node.key;
            // Compute the height of the item. Use the existing height if available,
            // otherwise call the delegate to estimate the size.
            let oldLayoutInfo = this.layoutInfos.get(key);
            let height;
            let estimatedSize = true;
            if (oldLayoutInfo) {
                height = oldLayoutInfo.rect.height;
                estimatedSize = invalidationContext.sizeChanged || oldLayoutInfo.estimatedSize;
            } else if (node.props.width && node.props.height) {
                let nodeWidth = node.props.width;
                let nodeHeight = node.props.height;
                let scaledHeight = Math.round(nodeHeight * (itemWidth / nodeWidth));
                height = Math.max(this.minItemSize.height, Math.min(this.maxItemSize.height, scaledHeight));
            } else height = itemWidth;
            // Figure out which column to place the item in, and compute its position.
            let column = this.getNextColumnIndex(columnHeights);
            let x = this.margin + column * (itemWidth + horizontalSpacing);
            let y = columnHeights[column];
            let rect = new (0, _virtualizer.Rect)(x, y, itemWidth, height);
            let layoutInfo = new (0, _virtualizer.LayoutInfo)(node.type, key, rect);
            layoutInfo.estimatedSize = estimatedSize;
            layoutInfo.allowOverflow = true;
            this.layoutInfos.set(key, layoutInfo);
            // TODO: From v2 figure out this bit, when does this get called and what to replace this.collectionView._transaction with?
            // Removing it from v2 doesn't seem to do anything?
            // if (layoutInfo.estimatedSize && !invalidationContext.contentChanged && !this.collectionView._transaction) {
            //   this.updateItemSize(new IndexPath(section, i));
            // }
            columnHeights[column] += layoutInfo.rect.height + this.minSpace.height;
        }
        // Reset all columns to the maximum for the next section
        let maxHeight = Math.max.apply(Math, columnHeights) - this.minSpace.height + this.margin;
        columnHeights.fill(maxHeight);
        let y = columnHeights[0];
        if (this.isLoading) {
            let loaderY = y;
            let loaderHeight = 60;
            // If there aren't any items, make loader take all avaliable room and remove margin from y calculation
            // so it doesn't scroll
            if (this.collection.size === 0) {
                loaderY = 0;
                loaderHeight = this.virtualizer.visibleRect.height || 60;
            }
            let rect = new (0, _virtualizer.Rect)(0, loaderY, this.virtualizer.visibleRect.width, loaderHeight);
            let loader = new (0, _virtualizer.LayoutInfo)("loader", "loader", rect);
            this.layoutInfos.set("loader", loader);
            y = loader.rect.maxY;
        }
        if (this.collection.size === 0 && !this.isLoading) {
            let rect = new (0, _virtualizer.Rect)(0, 0, this.virtualizer.visibleRect.width, this.virtualizer.visibleRect.height);
            let placeholder = new (0, _virtualizer.LayoutInfo)("placeholder", "placeholder", rect);
            this.layoutInfos.set("placeholder", placeholder);
            y = placeholder.rect.maxY;
        }
        this.contentSize = new (0, _virtualizer.Size)(this.virtualizer.visibleRect.width, y);
    }
    updateItemSize(key, size) {
        let layoutInfo = this.layoutInfos.get(key);
        if (!size || !layoutInfo) return false;
        if (size.height !== layoutInfo.rect.height) {
            // TODO: also not sure about copying layout info vs mutating it. Listlayout does the below
            // but I feel that is because it actually maintained a layoutNode map cache which this doesn't have
            let newLayoutInfo = layoutInfo.copy();
            newLayoutInfo.rect.height = size.height < 600 ? size.height : 600;
            newLayoutInfo.estimatedSize = false;
            this.layoutInfos.set(key, newLayoutInfo);
            return true;
        }
        return false;
    }
    getNextColumnIndex(columnHeights) {
        let minIndex = 0;
        for(let i = 0; i < columnHeights.length; i++)if (columnHeights[i] < columnHeights[minIndex]) minIndex = i;
        return minIndex;
    }
    getClosestRight(key) {
        var _this__findClosest, _getFirstItem;
        let layoutInfo = this.getLayoutInfo(key);
        // Refactored from v2. Current strategy is to find the closest card in the adjacent column.
        // This prevent the issue where it was possible that the closest layoutInfo would be two columns over due to the middle card being exceptionally tall
        // and thus the top corner to top corner distance was massive.
        // First look for a card to the immediate right of the current card. If we can't find any, look for the nearest card in the entire column to the right of the card
        let rect = new (0, _virtualizer.Rect)(layoutInfo.rect.maxX + 1, layoutInfo.rect.y, layoutInfo.rect.width + this.horizontalSpacing, layoutInfo.rect.height);
        key = (_this__findClosest = this._findClosest(layoutInfo.rect, rect)) === null || _this__findClosest === void 0 ? void 0 : _this__findClosest.key;
        if (!key) {
            var _this__findClosest1;
            rect = new (0, _virtualizer.Rect)(layoutInfo.rect.maxX + 1, 0, layoutInfo.rect.width + this.horizontalSpacing, this.virtualizer.contentSize.height);
            key = (_this__findClosest1 = this._findClosest(layoutInfo.rect, rect)) === null || _this__findClosest1 === void 0 ? void 0 : _this__findClosest1.key;
        }
        let item = this.collection.getItem(key);
        return (_getFirstItem = (0, _collections.getFirstItem)((0, _collections.getChildNodes)(item, this.collection))) === null || _getFirstItem === void 0 ? void 0 : _getFirstItem.key;
    }
    getClosestLeft(key) {
        var _this__findClosest, _getFirstItem;
        let layoutInfo = this.getLayoutInfo(key);
        // First look for a card to the immediate left of the current card. If we can't find any, look for the nearest card in the entire column to the left of the card
        let rect = new (0, _virtualizer.Rect)(layoutInfo.rect.x - layoutInfo.rect.width - this.horizontalSpacing - 1, layoutInfo.rect.y, layoutInfo.rect.width + this.horizontalSpacing, layoutInfo.rect.height);
        key = (_this__findClosest = this._findClosest(layoutInfo.rect, rect)) === null || _this__findClosest === void 0 ? void 0 : _this__findClosest.key;
        if (!key) {
            var _this__findClosest1;
            rect = new (0, _virtualizer.Rect)(layoutInfo.rect.x - layoutInfo.rect.width - this.horizontalSpacing - 1, 0, layoutInfo.rect.width + this.horizontalSpacing, this.virtualizer.contentSize.height);
            key = (_this__findClosest1 = this._findClosest(layoutInfo.rect, rect)) === null || _this__findClosest1 === void 0 ? void 0 : _this__findClosest1.key;
        }
        let item = this.collection.getItem(key);
        return (_getFirstItem = (0, _collections.getFirstItem)((0, _collections.getChildNodes)(item, this.collection))) === null || _getFirstItem === void 0 ? void 0 : _getFirstItem.key;
    }
    getKeyRightOf(key) {
        // Expected key is the currently focused cell so we need the parent row key
        let parentRowKey = this.collection.getItem(key).parentKey;
        return this.direction === "rtl" ? this.getClosestLeft(parentRowKey) : this.getClosestRight(parentRowKey);
    }
    getKeyLeftOf(key) {
        // Expected key is the currently focused cell so we need the parent row key
        let parentRowKey = this.collection.getItem(key).parentKey;
        return this.direction === "rtl" ? this.getClosestRight(parentRowKey) : this.getClosestLeft(parentRowKey);
    }
    constructor(options = {}){
        // TODO: WaterfallLayout doesn't use card size in v2, but perhaps it should support it? Perhaps it would modify
        // minItemSize defaults or other things
        super(options);
        this.minItemSize = options.minItemSize || new (0, _virtualizer.Size)(240, 136);
        this.maxItemSize = options.maxItemSize || new (0, _virtualizer.Size)(Infinity, Infinity);
        this.margin = options.margin != null ? options.margin : 24;
        this.minSpace = options.minSpace || new (0, _virtualizer.Size)(18, 18);
        this.maxColumns = options.maxColumns || Infinity;
        this.itemWidth = 0;
        this.numColumns = 0;
        this.lastCollection = null;
        this.collator = options.collator;
    }
}

},{"./BaseLayout":"39Kn0","@react-stately/collections":"loANi","@react-stately/virtualizer":"lVS5O","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"kQXTr":[function(require,module,exports) {
/*
 * Copyright 2021 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Card", ()=>_Card);
var _cardBase = require("./CardBase");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _cardViewContext = require("./CardViewContext");
let Card = /*#__PURE__*/ (0, _react.forwardRef)((props, ref)=>{
    let context = (0, _cardViewContext.useCardViewContext)();
    if (context !== null) return null;
    else return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _cardBase.CardBase), {
        ...props,
        ref: ref
    });
});
// @ts-ignore
Card.getCollectionNode = function* getCollectionNode(props) {
    let { children, textValue } = props;
    yield {
        type: "item",
        props: props,
        rendered: children,
        "aria-label": props["aria-label"],
        hasChildNodes: false,
        textValue
    };
};
let _Card = Card;

},{"./CardBase":"aem24","react":"9yzVZ","./CardViewContext":"kisA8","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"aSOMD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getImage", ()=>getImage);
parcelHelpers.export(exports, "getImageFullData", ()=>getImageFullData);
parcelHelpers.export(exports, "getDescription", ()=>getDescription);
let images = [
    {
        width: 1001,
        height: 381,
        src: "https://i.imgur.com/Z7AzH2c.jpg"
    },
    {
        width: 640,
        height: 640,
        src: "https://i.imgur.com/DhygPot.jpg"
    },
    {
        width: 182,
        height: 1009,
        src: "https://i.imgur.com/L7RTlvI.png"
    },
    {
        width: 1516,
        height: 1009,
        src: "https://i.imgur.com/1nScMIH.jpg"
    },
    {
        width: 1215,
        height: 121,
        src: "https://i.imgur.com/zzwWogn.jpg"
    }
];
// descriptions separate from images so that the same image might have multiple different descriptions
let descriptions = [
    "Description",
    "Description that is a medium length",
    "This is the description that never ends, it goes on and on my friends. Someone started typing without knowing what it was",
    "Rechtsschutzversicherungsgesellschaften Nahrungsmittelunvertr\xe4glichkeit Unabh\xe4ngigkeitserkl\xe4rungen Freundschaftsbeziehungen"
];
function getImage(index) {
    return images[index % images.length].src;
}
function getImageFullData(index) {
    return images[index % images.length];
}
function getDescription(index) {
    return descriptions[index % descriptions.length];
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"cKQBm":[function(require,module,exports) {
/*
 * Copyright 2021 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DefaultGalleryStatic", ()=>DefaultGalleryStatic);
parcelHelpers.export(exports, "FalsyIdGallery", ()=>FalsyIdGallery);
parcelHelpers.export(exports, "DefaultGalleryNoThinImages", ()=>DefaultGalleryNoThinImages);
parcelHelpers.export(exports, "DefaultGalleryLowVariance", ()=>DefaultGalleryLowVariance);
parcelHelpers.export(exports, "DefaultGallery", ()=>DefaultGallery);
parcelHelpers.export(exports, "DisabledKeysGallery", ()=>DisabledKeysGallery);
parcelHelpers.export(exports, "SelectedKeys", ()=>SelectedKeys);
parcelHelpers.export(exports, "IsLoadingNoHeightGallery", ()=>IsLoadingNoHeightGallery);
parcelHelpers.export(exports, "IsLoadingHeightGallery", ()=>IsLoadingHeightGallery);
parcelHelpers.export(exports, "LoadingMoreGallery", ()=>LoadingMoreGallery);
parcelHelpers.export(exports, "FilteringGallery", ()=>FilteringGallery);
parcelHelpers.export(exports, "EmptyWithHeightGallery", ()=>EmptyWithHeightGallery);
parcelHelpers.export(exports, "AsyncLoadingGallery", ()=>AsyncLoadingGallery);
parcelHelpers.export(exports, "CustomLayoutOptions", ()=>CustomLayoutOptions);
var _gridCardViewStories = require("./GridCardView.stories");
var _ = require("../");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _virtualizer = require("@react-stately/virtualizer");
var _i18N = require("@react-aria/i18n");
let itemsLowVariance = [
    {
        width: 1001,
        height: 381,
        src: "https://i.imgur.com/Z7AzH2c.jpg",
        id: 1,
        title: "Bob 1"
    },
    {
        width: 640,
        height: 640,
        src: "https://i.imgur.com/DhygPot.jpg",
        id: 2,
        title: "Joe 1 really really really really long"
    },
    {
        width: 314,
        height: 1009,
        src: "https://i.imgur.com/3lzeoK7.jpg",
        id: 3,
        title: "Jane 1"
    },
    {
        width: 1516,
        height: 1009,
        src: "https://i.imgur.com/1nScMIH.jpg",
        id: 4,
        title: "Bob 2"
    },
    {
        width: 640,
        height: 640,
        src: "https://i.imgur.com/DhygPot.jpg",
        id: 5,
        title: "Joe 2"
    },
    {
        width: 1516,
        height: 1009,
        src: "https://i.imgur.com/1nScMIH.jpg",
        id: 6,
        title: "Jane 2"
    },
    {
        width: 1001,
        height: 381,
        src: "https://i.imgur.com/Z7AzH2c.jpg",
        id: 7,
        title: "Bob 3"
    },
    {
        width: 314,
        height: 1009,
        src: "https://i.imgur.com/3lzeoK7.jpg",
        id: 8,
        title: "Joe 3"
    },
    {
        width: 314,
        height: 1009,
        src: "https://i.imgur.com/3lzeoK7.jpg",
        id: 9,
        title: "Jane 3"
    },
    {
        width: 1516,
        height: 1009,
        src: "https://i.imgur.com/1nScMIH.jpg",
        id: 10,
        title: "Bob 4"
    },
    {
        width: 314,
        height: 1009,
        src: "https://i.imgur.com/3lzeoK7.jpg",
        id: 11,
        title: "Joe 4"
    },
    {
        width: 1001,
        height: 381,
        src: "https://i.imgur.com/Z7AzH2c.jpg",
        id: 12,
        title: "Jane 4"
    },
    {
        width: 314,
        height: 1009,
        src: "https://i.imgur.com/3lzeoK7.jpg",
        id: 13,
        title: "Bob 5"
    },
    {
        width: 1516,
        height: 1009,
        src: "https://i.imgur.com/1nScMIH.jpg",
        id: 14,
        title: "Joe 5"
    },
    {
        width: 314,
        height: 1009,
        src: "https://i.imgur.com/3lzeoK7.jpg",
        id: 15,
        title: "Jane 5"
    },
    {
        width: 1516,
        height: 1009,
        src: "https://i.imgur.com/1nScMIH.jpg",
        id: 16,
        title: "Bob 6"
    },
    {
        width: 314,
        height: 1009,
        src: "https://i.imgur.com/3lzeoK7.jpg",
        id: 17,
        title: "Joe 6"
    },
    {
        width: 640,
        height: 640,
        src: "https://i.imgur.com/DhygPot.jpg",
        id: 18,
        title: "Jane 6"
    },
    {
        width: 314,
        height: 1009,
        src: "https://i.imgur.com/3lzeoK7.jpg",
        id: 19,
        title: "Bob 7"
    },
    {
        width: 1001,
        height: 381,
        src: "https://i.imgur.com/Z7AzH2c.jpg",
        id: 20,
        title: "Joe 7"
    },
    {
        width: 1516,
        height: 1009,
        src: "https://i.imgur.com/1nScMIH.jpg",
        id: 21,
        title: "Jane 7"
    },
    {
        width: 314,
        height: 1009,
        src: "https://i.imgur.com/3lzeoK7.jpg",
        id: 22,
        title: "Bob 8"
    }
];
let itemsNoThinImages = [
    {
        width: 1001,
        height: 381,
        src: "https://i.imgur.com/Z7AzH2c.jpg",
        id: 1,
        title: "Bob 1"
    },
    {
        width: 640,
        height: 640,
        src: "https://i.imgur.com/DhygPot.jpg",
        id: 2,
        title: "Joe 1 really really really really long"
    },
    {
        width: 1516,
        height: 1009,
        src: "https://i.imgur.com/1nScMIH.jpg",
        id: 4,
        title: "Jane 1"
    },
    {
        width: 640,
        height: 640,
        src: "https://i.imgur.com/DhygPot.jpg",
        id: 5,
        title: "Bob 2"
    },
    {
        width: 1516,
        height: 1009,
        src: "https://i.imgur.com/1nScMIH.jpg",
        id: 6,
        title: "Joe 2"
    },
    {
        width: 1001,
        height: 381,
        src: "https://i.imgur.com/Z7AzH2c.jpg",
        id: 7,
        title: "Jane 2"
    },
    {
        width: 1516,
        height: 1009,
        src: "https://i.imgur.com/1nScMIH.jpg",
        id: 10,
        title: "Bob 3"
    },
    {
        width: 1001,
        height: 381,
        src: "https://i.imgur.com/Z7AzH2c.jpg",
        id: 12,
        title: "Joe 3"
    },
    {
        width: 1516,
        height: 1009,
        src: "https://i.imgur.com/1nScMIH.jpg",
        id: 14,
        title: "Jane 3"
    },
    {
        width: 1516,
        height: 1009,
        src: "https://i.imgur.com/1nScMIH.jpg",
        id: 16,
        title: "Bob 4"
    },
    {
        width: 640,
        height: 640,
        src: "https://i.imgur.com/DhygPot.jpg",
        id: 18,
        title: "Joe 4"
    },
    {
        width: 1001,
        height: 381,
        src: "https://i.imgur.com/Z7AzH2c.jpg",
        id: 20,
        title: "Jane 4"
    },
    {
        width: 1516,
        height: 1009,
        src: "https://i.imgur.com/1nScMIH.jpg",
        id: 21,
        title: "Bob 5"
    }
];
// TODO: accessibility failures regarding article element with role="gridcell", will need to double check when we pick CardView back up
exports.default = {
    title: "CardView/Gallery layout",
    component: (0, _.CardView),
    args: {
        "aria-label": "Test CardView"
    },
    argTypes: {
        layout: {
            table: {
                disable: true
            }
        },
        selectionMode: {
            control: "radio",
            defaultValue: "multiple",
            options: [
                "none",
                "single",
                "multiple"
            ]
        }
    }
};
const DefaultGalleryStatic = {
    ...(0, _gridCardViewStories.StaticCards),
    args: {
        ...(0, _gridCardViewStories.StaticCards).args,
        layout: (0, _.GalleryLayout)
    }
};
const FalsyIdGallery = {
    ...(0, _gridCardViewStories.FalsyIds),
    args: {
        ...(0, _gridCardViewStories.FalsyIds).args,
        layout: (0, _.GalleryLayout)
    }
};
const DefaultGalleryNoThinImages = {
    ...(0, _gridCardViewStories.DynamicCards),
    args: {
        ...(0, _gridCardViewStories.DynamicCards).args,
        layout: (0, _.GalleryLayout),
        items: itemsNoThinImages
    },
    name: "dynamic cards, no thin images"
};
const DefaultGalleryLowVariance = {
    ...(0, _gridCardViewStories.DynamicCards),
    args: {
        ...(0, _gridCardViewStories.DynamicCards).args,
        layout: (0, _.GalleryLayout),
        items: itemsLowVariance
    },
    name: "dynamic cards, low variance in aspect ratios"
};
const DefaultGallery = {
    ...(0, _gridCardViewStories.DynamicCards),
    args: {
        ...(0, _gridCardViewStories.DynamicCards).args,
        layout: (0, _.GalleryLayout)
    },
    name: "dynamic cards, high variance in aspect ratios"
};
const DisabledKeysGallery = {
    ...(0, _gridCardViewStories.DisabledKeys),
    args: {
        ...(0, _gridCardViewStories.DisabledKeys).args,
        layout: (0, _.GalleryLayout),
        items: itemsLowVariance
    }
};
const SelectedKeys = {
    ...(0, _gridCardViewStories.ControlledCards),
    args: {
        ...(0, _gridCardViewStories.ControlledCards).args,
        layout: (0, _.GalleryLayout),
        items: itemsLowVariance
    }
};
const IsLoadingNoHeightGallery = {
    ...(0, _gridCardViewStories.IsLoadingNoHeightGrid),
    args: {
        ...(0, _gridCardViewStories.IsLoadingNoHeightGrid).args,
        layout: (0, _.GalleryLayout)
    }
};
const IsLoadingHeightGallery = {
    ...(0, _gridCardViewStories.IsLoadingHeightGrid),
    args: {
        ...(0, _gridCardViewStories.IsLoadingHeightGrid).args,
        layout: (0, _.GalleryLayout)
    }
};
const LoadingMoreGallery = {
    ...(0, _gridCardViewStories.LoadingMoreGrid),
    args: {
        ...(0, _gridCardViewStories.LoadingMoreGrid).args,
        layout: (0, _.GalleryLayout)
    }
};
const FilteringGallery = {
    ...(0, _gridCardViewStories.FilteringGrid),
    args: {
        ...(0, _gridCardViewStories.FilteringGrid).args,
        layout: (0, _.GalleryLayout)
    }
};
const EmptyWithHeightGallery = {
    ...(0, _gridCardViewStories.EmptyWithHeightGrid),
    args: {
        ...(0, _gridCardViewStories.EmptyWithHeightGrid).args,
        layout: (0, _.GalleryLayout)
    }
};
const AsyncLoadingGallery = {
    ...(0, _gridCardViewStories.AsyncLoading),
    args: {
        ...(0, _gridCardViewStories.AsyncLoading).args,
        layout: (0, _.GalleryLayout)
    }
};
const CustomLayoutOptions = {
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(CustomGalleryLayout, args),
    args: {
        selectionMode: "multiple",
        items: itemsLowVariance,
        layoutOptions: {
            idealRowHeight: 400,
            itemSpacing: new (0, _virtualizer.Size)(10, 10),
            itemPadding: 78,
            minItemSize: new (0, _virtualizer.Size)(150, 400)
        }
    },
    name: "Custom layout options"
};
function CustomGalleryLayout(props) {
    let { layoutOptions, ...otherProps } = props;
    let collator = (0, _i18N.useCollator)({
        usage: "search",
        sensitivity: "base"
    });
    let galleryLayout = (0, _react.useMemo)(()=>new (0, _.GalleryLayout)({
            collator,
            ...layoutOptions
        }), [
        collator,
        layoutOptions
    ]);
    return (0, _gridCardViewStories.CustomLayout)({
        ...otherProps,
        layout: galleryLayout
    });
}

},{"./GridCardView.stories":"kI5xv","../":"4GreE","react":"9yzVZ","@react-stately/virtualizer":"lVS5O","@react-aria/i18n":"411rg","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"kI5xv":[function(require,module,exports) {
/*
 * Copyright 2021 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "falsyItems", ()=>falsyItems);
parcelHelpers.export(exports, "DynamicCards", ()=>DynamicCards);
parcelHelpers.export(exports, "StaticCards", ()=>StaticCards);
parcelHelpers.export(exports, "DefaultGridConstructor", ()=>DefaultGridConstructor);
parcelHelpers.export(exports, "HorizontalGrid", ()=>HorizontalGrid);
parcelHelpers.export(exports, "HorizontalGridConstructor", ()=>HorizontalGridConstructor);
parcelHelpers.export(exports, "FalsyIds", ()=>FalsyIds);
parcelHelpers.export(exports, "DisabledKeys", ()=>DisabledKeys);
parcelHelpers.export(exports, "ControlledCards", ()=>ControlledCards);
parcelHelpers.export(exports, "NoCards", ()=>NoCards);
parcelHelpers.export(exports, "IsLoadingNoHeightGrid", ()=>IsLoadingNoHeightGrid);
parcelHelpers.export(exports, "IsLoadingHeightGrid", ()=>IsLoadingHeightGrid);
parcelHelpers.export(exports, "LoadingMoreGrid", ()=>LoadingMoreGrid);
parcelHelpers.export(exports, "FilteringGrid", ()=>FilteringGrid);
parcelHelpers.export(exports, "EmptyWithHeightGrid", ()=>EmptyWithHeightGrid);
parcelHelpers.export(exports, "AsyncLoading", ()=>AsyncLoading);
parcelHelpers.export(exports, "CustomLayoutOptions", ()=>CustomLayoutOptions);
parcelHelpers.export(exports, "CustomLayout", ()=>CustomLayout);
var _addonActions = require("@storybook/addon-actions");
var _button = require("@react-spectrum/button");
var _ = require("../");
var _view = require("@react-spectrum/view");
var _layout = require("@react-spectrum/layout");
var _utils = require("./utils");
var _text = require("@react-spectrum/text");
var _illustratedmessage = require("@react-spectrum/illustratedmessage");
var _image = require("@react-spectrum/image");
var _link = require("@react-spectrum/link");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _virtualizer = require("@react-stately/virtualizer");
var _textfield = require("@react-spectrum/textfield");
var _data = require("@react-stately/data");
var _i18N = require("@react-aria/i18n");
var _provider = require("@react-spectrum/provider");
let items = [
    {
        width: 1001,
        height: 381,
        src: "https://i.imgur.com/Z7AzH2c.jpg",
        title: "Bob 1"
    },
    {
        width: 640,
        height: 640,
        src: "https://i.imgur.com/DhygPot.jpg",
        title: "Joe 1 really really really really really really really really really really really really long"
    },
    {
        width: 182,
        height: 1009,
        src: "https://i.imgur.com/L7RTlvI.png",
        title: "Jane 1"
    },
    {
        width: 1516,
        height: 1009,
        src: "https://i.imgur.com/1nScMIH.jpg",
        title: "Bob 2"
    },
    {
        width: 640,
        height: 640,
        src: "https://i.imgur.com/DhygPot.jpg",
        title: "Joe 2"
    },
    {
        width: 1516,
        height: 1009,
        src: "https://i.imgur.com/1nScMIH.jpg",
        title: "Jane 2"
    },
    {
        width: 1001,
        height: 381,
        src: "https://i.imgur.com/Z7AzH2c.jpg",
        title: "Bob 3"
    },
    {
        width: 182,
        height: 1009,
        src: "https://i.imgur.com/L7RTlvI.png",
        title: "Joe 3"
    },
    {
        width: 1215,
        height: 121,
        src: "https://i.imgur.com/zzwWogn.jpg",
        title: "Jane 3"
    },
    {
        width: 1516,
        height: 1009,
        src: "https://i.imgur.com/1nScMIH.jpg",
        title: "Bob 4"
    },
    {
        width: 182,
        height: 1009,
        src: "https://i.imgur.com/L7RTlvI.png",
        title: "Joe 4"
    },
    {
        width: 1001,
        height: 381,
        src: "https://i.imgur.com/Z7AzH2c.jpg",
        title: "Jane 4"
    },
    {
        width: 182,
        height: 1009,
        src: "https://i.imgur.com/L7RTlvI.png",
        title: "Bob 5"
    },
    {
        width: 1516,
        height: 1009,
        src: "https://i.imgur.com/1nScMIH.jpg",
        title: "Joe 5"
    },
    {
        width: 182,
        height: 1009,
        src: "https://i.imgur.com/L7RTlvI.png",
        title: "Jane 5"
    },
    {
        width: 1516,
        height: 1009,
        src: "https://i.imgur.com/1nScMIH.jpg",
        title: "Bob 6"
    },
    {
        width: 1215,
        height: 121,
        src: "https://i.imgur.com/zzwWogn.jpg",
        title: "Joe 6"
    },
    {
        width: 640,
        height: 640,
        src: "https://i.imgur.com/DhygPot.jpg",
        title: "Jane 6"
    },
    {
        width: 182,
        height: 1009,
        src: "https://i.imgur.com/L7RTlvI.png",
        title: "Bob 7"
    },
    {
        width: 1001,
        height: 381,
        src: "https://i.imgur.com/Z7AzH2c.jpg",
        title: "Joe 7"
    },
    {
        width: 1516,
        height: 1009,
        src: "https://i.imgur.com/1nScMIH.jpg",
        title: "Jane 7"
    },
    {
        width: 1215,
        height: 121,
        src: "https://i.imgur.com/zzwWogn.jpg",
        title: "Bob 8"
    }
];
let falsyItems = [
    {
        id: 0,
        width: 1001,
        height: 381,
        src: "https://i.imgur.com/Z7AzH2c.jpg",
        title: "Bob 1"
    },
    {
        id: 1,
        width: 640,
        height: 640,
        src: "https://i.imgur.com/DhygPot.jpg",
        title: "Joe 1 really really really really really really really really really really really really long"
    },
    {
        id: 2,
        width: 182,
        height: 1009,
        src: "https://i.imgur.com/L7RTlvI.png",
        title: "Jane 1"
    }
];
function renderEmptyState() {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _illustratedmessage.IllustratedMessage), null, /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        width: "150",
        height: "103",
        viewBox: "0 0 150 103"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M133.7,8.5h-118c-1.9,0-3.5,1.6-3.5,3.5v27c0,0.8,0.7,1.5,1.5,1.5s1.5-0.7,1.5-1.5V23.5h119V92c0,0.3-0.2,0.5-0.5,0.5h-118c-0.3,0-0.5-0.2-0.5-0.5V69c0-0.8-0.7-1.5-1.5-1.5s-1.5,0.7-1.5,1.5v23c0,1.9,1.6,3.5,3.5,3.5h118c1.9,0,3.5-1.6,3.5-3.5V12C137.2,10.1,135.6,8.5,133.7,8.5z M15.2,21.5V12c0-0.3,0.2-0.5,0.5-0.5h118c0.3,0,0.5,0.2,0.5,0.5v9.5H15.2z M32.6,16.5c0,0.6-0.4,1-1,1h-10c-0.6,0-1-0.4-1-1s0.4-1,1-1h10C32.2,15.5,32.6,15.9,32.6,16.5z M13.6,56.1l-8.6,8.5C4.8,65,4.4,65.1,4,65.1c-0.4,0-0.8-0.1-1.1-0.4c-0.6-0.6-0.6-1.5,0-2.1l8.6-8.5l-8.6-8.5c-0.6-0.6-0.6-1.5,0-2.1c0.6-0.6,1.5-0.6,2.1,0l8.6,8.5l8.6-8.5c0.6-0.6,1.5-0.6,2.1,0c0.6,0.6,0.6,1.5,0,2.1L15.8,54l8.6,8.5c0.6,0.6,0.6,1.5,0,2.1c-0.3,0.3-0.7,0.4-1.1,0.4c-0.4,0-0.8-0.1-1.1-0.4L13.6,56.1z"
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Heading), null, "No results"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Content), null, "No results found, press ", /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _link.Link), {
        onPress: (0, _addonActions.action)("linkPress")
    }, "here"), " for more info."));
}
// TODO: accessibility failures regarding article element with role="gridcell", will need to double check when we pick CardView back up
exports.default = {
    title: "CardView/Grid layout",
    component: (0, _.CardView),
    excludeStories: [
        "NoCards",
        "CustomLayout",
        "falsyItems"
    ],
    args: {
        "aria-label": "Test CardView"
    },
    argTypes: {
        layout: {
            table: {
                disable: true
            }
        },
        selectionMode: {
            control: "radio",
            defaultValue: "multiple",
            options: [
                "none",
                "single",
                "multiple"
            ]
        }
    }
};
let onSelectionChange = (0, _addonActions.action)("onSelectionChange");
let actions = {
    onSelectionChange: (s)=>onSelectionChange([
            ...s
        ])
};
const DynamicCards = {
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(DynamicCardView, args),
    args: {
        items: items
    },
    name: "default Grid layout with initialized layout"
};
const StaticCards = {
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(StaticCardView, args),
    name: "static card"
};
const DefaultGridConstructor = {
    ...DynamicCards,
    args: {
        ...DynamicCards.args,
        layout: (0, _.GridLayout)
    },
    name: "default Grid layout w/ layout constructor"
};
const HorizontalGrid = {
    ...DynamicCards,
    args: {
        ...DynamicCards.args,
        cardOrientation: "horizontal"
    },
    name: "Grid layout with horizontal cards, initialized layout"
};
const HorizontalGridConstructor = {
    ...DynamicCards,
    args: {
        ...DynamicCards.args,
        cardOrientation: "horizontal",
        layout: (0, _.GridLayout)
    },
    name: "Grid layout with horizontal cards, layout constructor"
};
const FalsyIds = {
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(CardViewIdKeys, args),
    args: {
        items: falsyItems
    },
    name: "falsy ids"
};
const DisabledKeys = {
    ...DynamicCards,
    args: {
        ...DynamicCards.args,
        disabledKeys: [
            "Joe 2",
            "Bob 4"
        ]
    },
    name: "disabled keys, Joe2, Bob 4"
};
const ControlledCards = {
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(ControlledCardView, args),
    args: {
        items: items
    },
    name: "selected keys, controlled"
};
const NoCards = {
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(NoItemCardView, args)
};
const IsLoadingNoHeightGrid = {
    ...NoCards,
    args: {
        ...NoCards.args,
        width: "800px",
        loadingState: "loading"
    },
    name: "loadingState = loading, no height"
};
const IsLoadingHeightGrid = {
    ...NoCards,
    args: {
        ...NoCards.args,
        width: "800px",
        height: "800px",
        loadingState: "loading"
    },
    name: "loadingState = loading, set height"
};
const LoadingMoreGrid = {
    ...DynamicCards,
    args: {
        ...DynamicCards.args,
        loadingState: "loadingMore"
    },
    name: "loadingState = loadingMore"
};
const FilteringGrid = {
    ...DynamicCards,
    args: {
        ...DynamicCards.args,
        loadingState: "filtering"
    },
    name: "loadingState = filtering"
};
const EmptyWithHeightGrid = {
    ...NoCards,
    args: {
        ...NoCards.args,
        width: "800px",
        height: "800px",
        renderEmptyState
    },
    name: "empty, set height"
};
const AsyncLoading = {
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(AsyncLoadingCardView, args),
    args: {
        items: items
    },
    name: "Async loading"
};
const CustomLayoutOptions = {
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(CustomLayout, args),
    args: {
        items: items,
        layoutOptions: {
            maxColumns: 2,
            margin: 150,
            minSpace: new (0, _virtualizer.Size)(10, 10),
            itemPadding: 400
        }
    },
    name: "Custom layout options"
};
function CardViewIdKeys(props) {
    let { scale } = (0, _provider.useProvider)();
    let collator = (0, _i18N.useCollator)({
        usage: "search",
        sensitivity: "base"
    });
    let cardOrientation = props.cardOrientation || "vertical";
    let gridLayout = (0, _react.useMemo)(()=>new (0, _.GridLayout)({
            scale,
            collator,
            cardOrientation
        }), [
        collator,
        scale,
        cardOrientation
    ]);
    let { layout = gridLayout, items, ...otherProps } = props;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        style: {
            width: "800px",
            resize: "both",
            height: "90vh",
            overflow: "auto"
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.CardView), {
        ...actions,
        ...otherProps,
        items: items,
        layout: layout,
        width: "100%",
        height: "100%"
    }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Card), {
            textValue: item.title,
            width: item.width,
            height: item.height
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _image.Image), {
            src: item.src
        }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Heading), null, item.title), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), {
            slot: "detail"
        }, "PNG"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Content), null, "Very very very very very very very very very very very very very long description"))));
}
function DynamicCardView(props) {
    let { scale } = (0, _provider.useProvider)();
    let collator = (0, _i18N.useCollator)({
        usage: "search",
        sensitivity: "base"
    });
    let cardOrientation = props.cardOrientation || "vertical";
    let gridLayout = (0, _react.useMemo)(()=>new (0, _.GridLayout)({
            scale,
            collator,
            cardOrientation
        }), [
        collator,
        scale,
        cardOrientation
    ]);
    let { layout = gridLayout, ...otherProps } = props;
    let [value, setValue] = (0, _react.useState)("");
    let [items, setItems] = (0, _react.useState)(props.items);
    let removeItem = ()=>{
        let val = parseInt(value, 10);
        let newItems = items.slice(0, val).concat(items.slice(val + 1, items.length));
        setItems(newItems);
    };
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        style: {
            width: "800px",
            resize: "both",
            height: "90vh",
            overflow: "auto"
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
        direction: "column",
        height: "100%",
        width: "100%"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
        direction: "row",
        maxWidth: "500px",
        alignItems: "end"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textfield.TextField), {
        value: value,
        onChange: setValue,
        label: "Nth item to remove"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), {
        onPress: removeItem
    }, "Remove")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.CardView), {
        ...actions,
        ...otherProps,
        items: items,
        layout: layout,
        width: "100%",
        height: "100%"
    }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Card), {
            key: item.title,
            textValue: item.title,
            width: item.width,
            height: item.height
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _image.Image), {
            src: item.src
        }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Heading), null, item.title), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), {
            slot: "detail"
        }, "PNG"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Content), null, "Very very very very very very very very very very very very very long description")))));
}
function ControlledCardView(props) {
    let { scale } = (0, _provider.useProvider)();
    let collator = (0, _i18N.useCollator)({
        usage: "search",
        sensitivity: "base"
    });
    let cardOrientation = props.cardOrientation || "vertical";
    let gridLayout = (0, _react.useMemo)(()=>new (0, _.GridLayout)({
            scale,
            collator,
            cardOrientation
        }), [
        collator,
        scale,
        cardOrientation
    ]);
    let { layout = gridLayout, ...otherProps } = props;
    let [value, setValue] = (0, _react.useState)("");
    let [items, setItems] = (0, _react.useState)(props.items);
    let [selectedKeys, setSelectedKeys] = (0, _react.useState)("all");
    let removeItem = ()=>{
        let val = parseInt(value, 10);
        let newItems = items.slice(0, val).concat(items.slice(val + 1, items.length));
        setItems(newItems);
    };
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        style: {
            width: "800px",
            resize: "both",
            height: "90vh",
            overflow: "auto"
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
        direction: "column",
        width: "100%",
        height: "100%"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
        direction: "row",
        maxWidth: "500px",
        alignItems: "end"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textfield.TextField), {
        value: value,
        onChange: setValue,
        label: "Nth item to remove"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), {
        onPress: removeItem
    }, "Remove")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.CardView), {
        ...actions,
        ...otherProps,
        selectedKeys: selectedKeys,
        onSelectionChange: setSelectedKeys,
        items: items,
        layout: layout,
        width: "100%",
        height: "100%"
    }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Card), {
            key: item.title,
            textValue: item.title,
            width: item.width,
            height: item.height
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _image.Image), {
            src: item.src
        }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Heading), null, item.title), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), {
            slot: "detail"
        }, "PNG"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Content), null, "Very very very very very very very very very very very very very long description")))));
}
function NoItemCardView(props) {
    let { scale } = (0, _provider.useProvider)();
    let collator = (0, _i18N.useCollator)({
        usage: "search",
        sensitivity: "base"
    });
    let cardOrientation = props.cardOrientation || "vertical";
    let gridLayout = (0, _react.useMemo)(()=>new (0, _.GridLayout)({
            scale,
            collator,
            cardOrientation
        }), [
        collator,
        scale,
        cardOrientation
    ]);
    let { layout = gridLayout } = props;
    let [show, setShow] = (0, _react.useState)(false);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), {
        onPress: ()=>setShow((show)=>!show)
    }, "Toggle items"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.CardView), {
        ...props,
        items: show ? items : [],
        layout: layout,
        UNSAFE_style: {
            background: "var(--spectrum-global-color-gray-300)"
        }
    }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Card), {
            key: item.title,
            textValue: item.title,
            width: item.width,
            height: item.height
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _image.Image), {
            src: item.src
        }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Heading), null, item.title), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), {
            slot: "detail"
        }, "PNG"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Content), null, "Very very very very very very very very very very very very very long description"))));
}
function StaticCardView(props) {
    let { scale } = (0, _provider.useProvider)();
    let collator = (0, _i18N.useCollator)({
        usage: "search",
        sensitivity: "base"
    });
    let cardOrientation = props.cardOrientation || "vertical";
    let gridLayout = (0, _react.useMemo)(()=>new (0, _.GridLayout)({
            scale,
            collator,
            cardOrientation
        }), [
        collator,
        scale,
        cardOrientation
    ]);
    let { layout = gridLayout } = props;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        style: {
            width: "800px",
            resize: "both",
            height: "90vh",
            overflow: "auto"
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.CardView), {
        ...actions,
        ...props,
        height: "100%",
        width: "100%",
        items: [
            {}
        ],
        layout: layout
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Card), {
        key: "Bob 1",
        width: 1001,
        height: 381,
        textValue: "Bob 1"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _image.Image), {
        src: "https://i.imgur.com/Z7AzH2c.jpg"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Heading), null, "Bob 1"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), {
        slot: "detail"
    }, "PNG"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Content), null, "Very very very very very very very very very very very very very long description")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Card), {
        key: "Joe 1",
        width: 640,
        height: 640,
        textValue: "Joe 1"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _image.Image), {
        src: "https://i.imgur.com/DhygPot.jpg"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Heading), null, "Joe 1"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), {
        slot: "detail"
    }, "PNG")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Card), {
        key: "Jane 1",
        width: 182,
        height: 1009,
        textValue: "Jane 1"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _image.Image), {
        src: "https://i.imgur.com/L7RTlvI.png"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Heading), null, "Jane 1"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), {
        slot: "detail"
    }, "PNG"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Content), null, "Description")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Card), {
        key: "Bob 2",
        width: 1516,
        height: 1009,
        textValue: "Bob 2"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _image.Image), {
        src: "https://i.imgur.com/1nScMIH.jpg"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Heading), null, "Bob 2"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), {
        slot: "detail"
    }, "PNG"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Content), null, "Very very very very very very very very very very very very very long description")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Card), {
        key: "Joe 2",
        width: 640,
        height: 640,
        textValue: "Joe 2"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _image.Image), {
        src: "https://i.imgur.com/DhygPot.jpg"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Heading), null, "Joe 2"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), {
        slot: "detail"
    }, "PNG"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Content), null, "Description"))));
}
function AsyncLoadingCardView(props) {
    let { scale } = (0, _provider.useProvider)();
    let collator = (0, _i18N.useCollator)({
        usage: "search",
        sensitivity: "base"
    });
    let cardOrientation = props.cardOrientation || "vertical";
    let gridLayout = (0, _react.useMemo)(()=>new (0, _.GridLayout)({
            scale,
            collator,
            cardOrientation
        }), [
        collator,
        scale,
        cardOrientation
    ]);
    let { layout = gridLayout } = props;
    let list = (0, _data.useAsyncList)({
        async load ({ signal, cursor }) {
            if (cursor) cursor = cursor.replace(/^http:\/\//i, "https://");
            let items = [];
            await new Promise((resolve)=>setTimeout(resolve, 1500));
            let res = await fetch(cursor || "https://swapi.py4e.com/api/people/?search", {
                signal
            });
            let json = await res.json();
            items = json.results.map((element, index)=>({
                    ...(0, _utils.getImageFullData)(index),
                    title: element.name
                }));
            return {
                items: items,
                cursor: json.next
            };
        }
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        style: {
            width: "800px",
            resize: "both",
            height: "90vh",
            overflow: "auto"
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.CardView), {
        ...actions,
        ...props,
        height: "100%",
        width: "100%",
        items: list.items,
        onLoadMore: list.loadMore,
        loadingState: list.loadingState,
        layout: layout
    }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Card), {
            key: item.title,
            textValue: item.title,
            width: item.width,
            height: item.height
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _image.Image), {
            src: item.src
        }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Heading), null, item.title), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), {
            slot: "detail"
        }, "PNG"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Content), null, "Very very very very very very very very very very very very very long description"))));
}
function CustomLayout(props) {
    let { scale } = (0, _provider.useProvider)();
    let collator = (0, _i18N.useCollator)({
        usage: "search",
        sensitivity: "base"
    });
    let layoutOptions = props.layoutOptions;
    let cardOrientation = props.cardOrientation || "vertical";
    let gridLayout = (0, _react.useMemo)(()=>new (0, _.GridLayout)({
            scale,
            collator,
            cardOrientation,
            ...layoutOptions
        }), [
        collator,
        scale,
        layoutOptions,
        cardOrientation
    ]);
    let { layout = gridLayout, ...otherProps } = props;
    let [value, setValue] = (0, _react.useState)("");
    let [items, setItems] = (0, _react.useState)(props.items);
    let removeItem = ()=>{
        let val = parseInt(value, 10);
        let newItems = items.slice(0, val).concat(items.slice(val + 1, items.length));
        setItems(newItems);
    };
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        style: {
            width: "800px",
            resize: "both",
            height: "90vh",
            overflow: "auto"
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
        direction: "column",
        width: "100%",
        height: "100%"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
        direction: "row",
        maxWidth: "500px",
        alignItems: "end"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textfield.TextField), {
        value: value,
        onChange: setValue,
        label: "Nth item to remove"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), {
        onPress: removeItem
    }, "Remove")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.CardView), {
        ...actions,
        ...otherProps,
        items: items,
        layout: layout,
        width: "100%",
        height: "100%"
    }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Card), {
            key: item.title,
            textValue: item.title,
            width: item.width,
            height: item.height
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _image.Image), {
            src: item.src
        }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Heading), null, item.title), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), {
            slot: "detail"
        }, "PNG"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Content), null, "Very very very very very very very very very very very very very long description")))));
}

},{"@storybook/addon-actions":"coXbW","@react-spectrum/button":"jZWyP","../":"4GreE","@react-spectrum/view":"dnRjt","@react-spectrum/layout":"hzaUY","./utils":"aSOMD","@react-spectrum/text":"etCGI","@react-spectrum/illustratedmessage":"cV05z","@react-spectrum/image":"2GFZF","@react-spectrum/link":"lNoiB","react":"9yzVZ","@react-stately/virtualizer":"lVS5O","@react-spectrum/textfield":"hOmtq","@react-stately/data":"gEgJM","@react-aria/i18n":"411rg","@react-spectrum/provider":"5bCdp","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"jUJAW":[function(require,module,exports) {
/*
 * Copyright 2021 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CardGrid", ()=>CardGrid);
parcelHelpers.export(exports, "CardFloat", ()=>CardFloat);
parcelHelpers.export(exports, "CardGridTall", ()=>CardGridTall);
var _index = require("../index");
var _view = require("@react-spectrum/view");
var _utils = require("../stories/utils");
var _text = require("@react-spectrum/text");
var _horizontalCardChromatic = require("../chromatic/HorizontalCard.chromatic");
var _image = require("@react-spectrum/image");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
exports.default = {
    title: "Card/horizontal",
    component: (0, _index.Card),
    args: {
        orientation: "horizontal"
    },
    argTypes: {
        layout: {
            table: {
                disable: true
            }
        },
        children: {
            table: {
                disable: true
            }
        }
    }
};
const CardGrid = {
    render: (args, context)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index.Card), {
            ...args,
            ...context,
            id: null
        }),
    args: {
        ...(0, _horizontalCardChromatic.Horizontal).args,
        layout: "grid"
    },
    decorators: [
        (Story, context)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(CardGridDecorator, {
                Story: Story,
                context: context
            })
    ]
};
const CardGridDecorator = (props)=>{
    let { Story, context } = props;
    let { args } = context;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        style: {
            width: "100%",
            margin: "50px",
            display: "grid",
            gap: "20px",
            gridTemplateColumns: "repeat(auto-fit, 360px)",
            gridAutoRows: "104px"
        }
    }, new Array(15).fill(0).map((_, index)=>{
        let url = (0, _utils.getImage)(index);
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(Story, {
            ...args,
            key: `${index}${url}`
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _image.Image), {
            src: url
        }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Heading), null, "Title ", index), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), {
            slot: "detail"
        }, "PNG"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Content), null, "Description"));
    }));
};
const CardFloat = {
    render: (args, context)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index.Card), {
            ...args,
            ...context,
            id: null
        }),
    args: {
        ...(0, _horizontalCardChromatic.Horizontal).args
    },
    decorators: [
        (Story, context)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(CardFloatDecorator, {
                Story: Story,
                context: context
            })
    ]
};
const CardFloatDecorator = (props)=>{
    let { Story, context } = props;
    let { args } = context;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        style: {
            width: "100%",
            margin: "50px"
        }
    }, new Array(15).fill(0).map((_, index)=>{
        let url = (0, _utils.getImage)(index);
        return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
            style: {
                float: "left",
                margin: "10px"
            },
            key: `${index}${url}`
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Story, args, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _image.Image), {
            src: url
        }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Heading), null, "Title ", index), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), {
            slot: "detail"
        }, "PNG"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Content), null, "Description")));
    }));
};
const CardGridTall = {
    render: (args, context)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index.Card), {
            ...args,
            ...context,
            id: null
        }),
    args: {
        ...(0, _horizontalCardChromatic.Horizontal).args,
        layout: "grid"
    },
    decorators: [
        (Story, context)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(CardGridTallDecorator, {
                Story: Story,
                context: context
            })
    ]
};
const CardGridTallDecorator = (props)=>{
    let { Story, context } = props;
    let { args } = context;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        style: {
            width: "100%",
            margin: "50px",
            display: "grid",
            gap: "20px",
            gridTemplateColumns: "repeat(auto-fit, 360px)",
            gridAutoRows: "150px"
        }
    }, new Array(15).fill(0).map((_, index)=>{
        let url = (0, _utils.getImage)(index);
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(Story, {
            ...args,
            key: `${index}${url}`
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _image.Image), {
            src: url
        }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Heading), null, "Title ", index), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), {
            slot: "detail"
        }, "PNG"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Content), null, "Description"));
    }));
};

},{"../index":"4GreE","@react-spectrum/view":"dnRjt","../stories/utils":"aSOMD","@react-spectrum/text":"etCGI","../chromatic/HorizontalCard.chromatic":"kf382","@react-spectrum/image":"2GFZF","react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"kf382":[function(require,module,exports) {
/*
 * Copyright 2021 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Horizontal", ()=>Horizontal);
parcelHelpers.export(exports, "HorizontalSquare", ()=>HorizontalSquare);
parcelHelpers.export(exports, "HorizontalTall", ()=>HorizontalTall);
parcelHelpers.export(exports, "HorizontalNoDescription", ()=>HorizontalNoDescription);
parcelHelpers.export(exports, "HorizontalNoDescriptionSquare", ()=>HorizontalNoDescriptionSquare);
parcelHelpers.export(exports, "HorizontalWithIllustration", ()=>HorizontalWithIllustration);
parcelHelpers.export(exports, "HorizontalLongTitle", ()=>HorizontalLongTitle);
parcelHelpers.export(exports, "HorizontalLongDescription", ()=>HorizontalLongDescription);
parcelHelpers.export(exports, "HorizontalLongDetail", ()=>HorizontalLongDetail);
var _index = require("../index");
var _cardChromatic = require("./Card.chromatic");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
exports.default = {
    title: "Card/horizontal",
    component: (0, _index.Card),
    args: {
        orientation: "horizontal"
    }
};
const Horizontal = {
    ...(0, _cardChromatic.Default),
    decorators: [
        (Story)=>/*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
                style: {
                    height: "90px"
                }
            }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Story, null))
    ]
};
const HorizontalSquare = {
    ...(0, _cardChromatic.DefaultSquare),
    ...Horizontal,
    args: {
        ...(0, _cardChromatic.DefaultSquare).args
    }
};
const HorizontalTall = {
    ...(0, _cardChromatic.DefaultTall),
    ...Horizontal,
    args: {
        ...(0, _cardChromatic.DefaultTall).args
    }
};
const HorizontalNoDescription = {
    ...(0, _cardChromatic.NoDescription),
    ...Horizontal,
    args: {
        ...(0, _cardChromatic.NoDescription).args
    }
};
const HorizontalNoDescriptionSquare = {
    ...(0, _cardChromatic.NoDescriptionSquare),
    ...Horizontal,
    args: {
        ...(0, _cardChromatic.NoDescriptionSquare).args
    }
};
const HorizontalWithIllustration = {
    ...(0, _cardChromatic.WithIllustration),
    ...Horizontal,
    args: {
        ...(0, _cardChromatic.WithIllustration).args
    }
};
const HorizontalLongTitle = {
    ...(0, _cardChromatic.LongTitle),
    ...Horizontal,
    args: {
        ...(0, _cardChromatic.LongTitle).args
    }
};
const HorizontalLongDescription = {
    ...(0, _cardChromatic.LongContent),
    ...Horizontal,
    args: {
        ...(0, _cardChromatic.LongContent).args
    }
};
const HorizontalLongDetail = {
    ...(0, _cardChromatic.LongDetail),
    ...Horizontal,
    args: {
        ...(0, _cardChromatic.LongDetail).args
    }
};

},{"../index":"4GreE","./Card.chromatic":"3yxBm","react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"3yxBm":[function(require,module,exports) {
/*
 * Copyright 2021 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Default", ()=>Default);
parcelHelpers.export(exports, "DefaultSquare", ()=>DefaultSquare);
parcelHelpers.export(exports, "DefaultTall", ()=>DefaultTall);
parcelHelpers.export(exports, "DefaultPreviewAlt", ()=>DefaultPreviewAlt);
parcelHelpers.export(exports, "LongContent", ()=>LongContent);
parcelHelpers.export(exports, "LongContentSquare", ()=>LongContentSquare);
parcelHelpers.export(exports, "LongContentPoorWordSize", ()=>LongContentPoorWordSize);
parcelHelpers.export(exports, "NoDescription", ()=>NoDescription);
parcelHelpers.export(exports, "NoDescriptionSquare", ()=>NoDescriptionSquare);
parcelHelpers.export(exports, "NoImage", ()=>NoImage);
parcelHelpers.export(exports, "WithIllustration", ()=>WithIllustration);
parcelHelpers.export(exports, "WithColorfulIllustration", ()=>WithColorfulIllustration);
parcelHelpers.export(exports, "WithColorfulIllustratedMessage", ()=>WithColorfulIllustratedMessage);
parcelHelpers.export(exports, "LongTitle", ()=>LongTitle);
parcelHelpers.export(exports, "LongDescription", ()=>LongDescription);
parcelHelpers.export(exports, "LongDetail", ()=>LongDetail);
parcelHelpers.export(exports, "LongEverything", ()=>LongEverything);
parcelHelpers.export(exports, "Selected", ()=>Selected);
// actually use Illustration???
// where to get the three asset svgs to use with Illustration
parcelHelpers.export(exports, "File", ()=>File);
var _varsCss = require("@adobe/spectrum-css-temp/components/asset/vars.css");
var _varsCssDefault = parcelHelpers.interopDefault(_varsCss);
var _ = require("..");
var _utils = require("@react-spectrum/utils");
var _view = require("@react-spectrum/view");
var _cardStories = require("../stories/Card.stories");
var _text = require("@react-spectrum/text");
var _illustratedmessage = require("@react-spectrum/illustratedmessage");
var _image = require("@react-spectrum/image");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
exports.default = {
    title: "Card/default",
    component: (0, _.Card),
    excludeStories: [
        "WithColorfulIllustratedMessage"
    ]
};
const Default = (0, _cardStories.Default);
const DefaultSquare = {
    ...Default,
    args: {
        children: /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _image.Image), {
            src: "https://i.imgur.com/DhygPot.jpg"
        }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Heading), null, "Title"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), {
            slot: "detail"
        }, "PNG"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Content), null, "Description"))
    }
};
const DefaultTall = {
    ...Default,
    args: {
        children: /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _image.Image), {
            src: "https://i.imgur.com/3lzeoK7.jpg"
        }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Heading), null, "Title"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), {
            slot: "detail"
        }, "PNG"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Content), null, "Description"))
    }
};
const DefaultPreviewAlt = {
    ...Default,
    args: {
        children: /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _image.Image), {
            alt: "preview",
            src: "https://i.imgur.com/Z7AzH2c.jpg"
        }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Heading), null, "Title"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), {
            slot: "detail"
        }, "PNG"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Content), null, "Description"))
    }
};
const LongContent = {
    ...Default,
    args: {
        children: /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _image.Image), {
            src: "https://i.imgur.com/Z7AzH2c.png"
        }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Heading), null, "Title"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), {
            slot: "detail"
        }, "PNG"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Content), null, "This is the description that never ends, it goes on and on my friends. Someone started typing without knowing what it was."))
    }
};
const LongContentSquare = {
    ...Default,
    args: {
        children: /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _image.Image), {
            src: "https://i.imgur.com/DhygPot.png"
        }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Heading), null, "Title"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), {
            slot: "detail"
        }, "PNG"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Content), null, "This is the description that never ends, it goes on and on my friends. Someone started typing without knowing what it was."))
    }
};
const LongContentPoorWordSize = {
    ...Default,
    args: {
        children: /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _image.Image), {
            src: "https://i.imgur.com/Z7AzH2c.png"
        }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Heading), null, "Title"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), {
            slot: "detail"
        }, "PNG"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Content), null, "Rechtsschutzversicherungsgesellschaften Nahrungsmittelunvertr\xe4glichkeit Unabh\xe4ngigkeitserkl\xe4rungen Freundschaftsbeziehungen"))
    }
};
const NoDescription = {
    ...Default,
    args: {
        children: /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _image.Image), {
            src: "https://i.imgur.com/Z7AzH2c.png"
        }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Heading), null, "Title"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), {
            slot: "detail"
        }, "PNG"))
    }
};
const NoDescriptionSquare = {
    ...Default,
    args: {
        children: /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _image.Image), {
            src: "https://i.imgur.com/DhygPot.jpg"
        }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Heading), null, "Title"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), {
            slot: "detail"
        }, "PNG"))
    }
};
const NoImage = {
    ...Default,
    args: {
        children: /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Heading), null, "Title"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), {
            slot: "detail"
        }, "PNG"))
    }
};
const WithIllustration = {
    ...Default,
    args: {
        children: /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement(File, {
            alt: "file",
            slot: "illustration",
            width: 50,
            height: 50
        }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Heading), null, "Title"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), {
            slot: "detail"
        }, "PNG"))
    }
};
const WithColorfulIllustration = {
    ...Default,
    args: {
        children: /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement(IllustrationContainer, null, /*#__PURE__*/ (0, _reactDefault.default).createElement(ColorfulIllustration, null)), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Heading), null, "Title"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), {
            slot: "detail"
        }, "PNG"))
    },
    parameters: {
        description: {
            data: "ignore the no white background, the svg just has a transparent background"
        }
    }
};
const WithColorfulIllustratedMessage = {
    ...Default,
    args: {
        children: /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _illustratedmessage.IllustratedMessage), null, /*#__PURE__*/ (0, _reactDefault.default).createElement(ColorfulIllustration, null)), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Heading), null, "Title"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), {
            slot: "detail"
        }, "PNG"))
    },
    parameters: {
        description: {
            data: "does not work right now, Illustrated Message messes with the styles and has some other interference. We may not even want to support it this way."
        }
    }
};
const LongTitle = {
    ...Default,
    args: {
        children: /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _image.Image), {
            src: "https://i.imgur.com/Z7AzH2c.jpg"
        }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Heading), null, "This is a long title about how dinosaurs used to rule the earth before a meteor came and wiped them all out"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), {
            slot: "detail"
        }, "PNG"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Content), null, "Description"))
    }
};
const LongDescription = {
    ...Default,
    args: {
        children: /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _image.Image), {
            src: "https://i.imgur.com/Z7AzH2c.jpg"
        }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Heading), null, "Title"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), {
            slot: "detail"
        }, "PNG"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Content), null, "This is a long description about the Pterodactyl, a pterosaur of the late Jurassic period, with a long slender head and neck and a very short tail."))
    }
};
const LongDetail = {
    ...Default,
    args: {
        children: /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _image.Image), {
            src: "https://i.imgur.com/Z7AzH2c.jpg"
        }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Heading), null, "Title"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), {
            slot: "detail"
        }, "Stats: Genus: Pterodactylus; Rafinesque, 1815 Order: Pterosauria Kingdom: Animalia Phylum: Chordata"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Content), null, "Description"))
    }
};
const LongEverything = {
    ...Default,
    args: {
        children: /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _image.Image), {
            src: "https://i.imgur.com/Z7AzH2c.jpg"
        }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Heading), null, "Rechtsschutzversicherungsgesellschaften Nahrungsmittelunvertr\xe4glichkeit Unabh\xe4ngigkeitserkl\xe4rungen Freundschaftsbeziehungen"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), {
            slot: "detail"
        }, "Rechtsschutzversicherungsgesellschaften Nahrungsmittelunvertr\xe4glichkeit Unabh\xe4ngigkeitserkl\xe4rungen Freundschaftsbeziehungen"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Content), null, "Rechtsschutzversicherungsgesellschaften Nahrungsmittelunvertr\xe4glichkeit Unabh\xe4ngigkeitserkl\xe4rungen Freundschaftsbeziehungen"))
    }
};
const Selected = (0, _cardStories.Selected);
function File(props) {
    props = (0, _utils.useSlotProps)(props, "asset");
    let { styleProps } = (0, _utils.useStyleProps)(props);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _utils.classNames)((0, _varsCssDefault.default), styleProps.className)
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        viewBox: "0 0 128 128",
        ...styleProps,
        className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Asset-file"),
        "aria-label": props.alt,
        "aria-hidden": props.decorative || null,
        role: "img"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Asset-fileBackground"),
        d: "M24,126c-5.5,0-10-4.5-10-10V12c0-5.5,4.5-10,10-10h61.5c2.1,0,4.1,0.8,5.6,2.3l20.5,20.4c1.5,1.5,2.4,3.5,2.4,5.7V116c0,5.5-4.5,10-10,10H24z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("g", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Asset-fileOutline"),
        d: "M113.1,23.3L92.6,2.9C90.7,1,88.2,0,85.5,0H24c-6.6,0-12,5.4-12,12v104c0,6.6,5.4,12,12,12h80c6.6,0,12-5.4,12-12V30.4C116,27.8,114.9,25.2,113.1,23.3z M90,6l20.1,20H92c-1.1,0-2-0.9-2-2V6z M112,116c0,4.4-3.6,8-8,8H24c-4.4,0-8-3.6-8-8V12c0-4.4,3.6-8,8-8h61.5c0.2,0,0.3,0,0.5,0v20c0,3.3,2.7,6,6,6h20c0,0.1,0,0.3,0,0.4V116z"
    })))));
}
function IllustrationContainer(props) {
    props = (0, _utils.useSlotProps)(props, "illustration");
    let { styleProps } = (0, _utils.useStyleProps)(props);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", styleProps, props.children);
}
// disable the rest, it's for show
/* eslint-disable */ function ColorfulIllustration(props) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        viewBox: "0 0 612 792"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("style", {
        dangerouslySetInnerHTML: {
            __html: `
        .st0{display:none;}
        .st1{display:inline;}
        .st2{display:inline;fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;}
        .st3{display:inline;fill:none;stroke:#000000;stroke-width:2;stroke-miterlimit:10;}
        .st4{display:inline;fill:none;stroke:#000000;stroke-miterlimit:10;}
        .st5{display:inline;fill:none;}
        .st6{fill:#2D2D2D;}
        .st7{fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;}
        .st8{fill:#3F3F3F;}
        .st9{fill:#FFFFFF;}
        .st10{fill:#43A547;}
        .st11{fill:#43A548;}
        .st12{fill:none;}
        .st13{fill:none;stroke:#000000;stroke-width:2;stroke-miterlimit:10;}
        .st14{fill:none;stroke:#000000;stroke-miterlimit:10;}
      `
        }
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        id: "Trace",
        className: "st0"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        className: "st2",
        d: "M284,279c-62.23,0-113.75,45.84-122.64,105.59l18.01-3.33c0,0,17.1-40.07,71.34-42.02 c54.23-1.95,70.85,44.71,61.56,55.21c9.28-1.47,10.26,20.52,6.35,27.85c17.59,5.37,15.15,56.19,6.84,75.73 c2.55,4.15,6.77,12.67,9.39,18.09C377.98,496.71,408,453.36,408,403C408,334.52,352.48,279,284,279z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        className: "st1"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M254.12,428.65c1.9-4.77,3.97-9.47,6.15-14.13c1.09-2.33,2.21-4.65,3.39-6.94c1.16-2.31,2.59-4.47,4.02-6.65 c0.74-1.08,1.51-2.14,2.39-3.16c0.45-0.51,0.92-1.01,1.5-1.47c0.29-0.23,0.61-0.46,1.02-0.64c0.2-0.09,0.44-0.17,0.7-0.22 c0.29-0.05,0.56-0.03,0.8,0.01c0.88,0.18,1.48,0.5,2.09,0.82c0.6,0.33,1.16,0.68,1.72,1.04c1.1,0.73,2.15,1.5,3.18,2.29 c4.1,3.18,7.93,6.61,11.7,10.13c3.75,3.52,7.41,7.14,10.95,10.89c1.77,1.88,3.5,3.78,5.18,5.75c1.68,1.97,3.32,3.97,4.78,6.17 c1.46,2.28,2.53,4.61,3.54,7.03c0.99,2.41,1.84,4.87,2.55,7.37c0.71,2.5,1.28,5.05,1.67,7.63c0.19,1.29,0.33,2.6,0.38,3.93 c0.04,1.33,0.04,2.67-0.29,4.1l-0.25,1.06l-1.01-0.34c-2.95-1-5.63-2.15-8.42-3.25l-8.28-3.37c-5.51-2.25-11.03-4.48-16.56-6.66 c-2.77-1.08-5.53-2.17-8.33-3.18c-2.79-0.98-5.52-2.23-8.3-3.05c-0.34-0.1-0.69-0.19-1.02-0.26c-0.37-0.07-0.5-0.09-0.89-0.02 c-0.67,0.09-1.38,0.29-2.08,0.5c-1.4,0.43-2.78,0.96-4.16,1.51c-2.74,1.13-5.47,2.34-8.15,3.63c2.56-1.53,5.15-3.01,7.83-4.34 c1.34-0.67,2.69-1.31,4.11-1.87c0.71-0.27,1.42-0.54,2.22-0.71c0.21-0.04,0.35-0.1,0.66-0.11c0.25-0.01,0.46,0.01,0.67,0.03 c0.41,0.05,0.79,0.12,1.17,0.2c1.5,0.32,2.94,0.74,4.38,1.17c1.44,0.43,2.87,0.87,4.26,1.42l8.35,3.22 c5.55,2.18,11.07,4.42,16.58,6.67l8.27,3.36c2.74,1.09,5.55,2.28,8.24,3.19l-1.26,0.72c0.25-1.07,0.28-2.32,0.24-3.54 c-0.05-1.23-0.18-2.48-0.36-3.72c-0.37-2.48-0.93-4.95-1.61-7.38c-0.69-2.43-1.51-4.82-2.47-7.15c-0.97-2.31-2.05-4.66-3.37-6.69 c-2.81-4.13-6.29-7.93-9.75-11.65c-3.5-3.71-7.13-7.31-10.86-10.8c-3.73-3.48-7.55-6.89-11.55-10c-1-0.77-2.02-1.52-3.06-2.21 c-0.52-0.34-1.04-0.67-1.57-0.96c-0.51-0.28-1.08-0.54-1.46-0.61c-0.08-0.01-0.13-0.01-0.15-0.01c-0.05,0.01-0.12,0.03-0.21,0.07 c-0.18,0.08-0.39,0.21-0.6,0.39c-0.42,0.34-0.84,0.77-1.24,1.22c-0.8,0.92-1.53,1.93-2.24,2.97c-1.44,2.07-2.63,4.32-4,6.47 c-1.34,2.17-2.63,4.37-3.9,6.6C258.93,419.59,256.51,424.11,254.12,428.65z"
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        className: "st1"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M273.67,476.54l9.84,3.73l-0.24,0.08c1.86-3.18,3.91-6.25,6.27-9.11c1.19-1.42,2.46-2.79,3.95-3.96 c0.74-0.6,1.58-1.09,2.47-1.48c0.88-0.36,1.77-0.67,2.67-0.91c3.59-1.02,7.24-1.61,10.88-2.18c3.65-0.54,7.3-0.98,10.98-1.34 l0.15,1.99c-3.64,0.22-7.29,0.53-10.92,0.93c-3.62,0.43-7.27,0.88-10.78,1.75c-1.77,0.44-3.45,0.95-4.86,2.03 c-1.44,1.04-2.73,2.34-3.95,3.68c-2.42,2.72-4.57,5.7-6.54,8.79l-0.09,0.14l-0.15-0.06L273.67,476.54z"
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        className: "st1"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M195.49,410.09c1.67-2.31,3.44-4.53,5.24-6.74c2.02-1.98,4.03-3.97,6.12-5.9c1.06-0.97,2.08-1.92,3.3-2.83 c0.15-0.11,0.33-0.23,0.51-0.34c0.1-0.06,0.23-0.13,0.35-0.18c0.11-0.06,0.51-0.17,0.72-0.13c0.59,0.1,0.62,0.2,0.87,0.29 l0.51,0.27c0.64,0.37,1.25,0.75,1.85,1.13c2.4,1.54,4.73,3.12,7.08,4.68c4.69,3.12,9.36,6.31,14.19,9.08 c0.6,0.34,1.21,0.67,1.82,0.96c0.59,0.29,1.26,0.58,1.69,0.66c0.09-0.02-0.02,0.04,0.16-0.01c0.12-0.04,0.23-0.06,0.36-0.11 c0.27-0.12,0.54-0.23,0.83-0.4c0.58-0.28,1.09-0.73,1.67-1.08c2.39-1.36,4.68-3.05,6.97-4.73c-1.74,2.26-3.63,4.39-5.8,6.35 c-0.28,0.24-0.58,0.45-0.91,0.63c-0.32,0.19-0.63,0.4-0.97,0.58c-0.32,0.19-0.71,0.35-1.08,0.51c-0.2,0.08-0.43,0.13-0.65,0.19 c-0.15,0.07-0.63,0.07-0.89,0.03c-0.95-0.19-1.57-0.52-2.25-0.84c-0.67-0.32-1.3-0.67-1.92-1.02c-4.96-2.85-9.62-6.04-14.32-9.16 c-2.35-1.57-4.68-3.15-7.04-4.66c-0.59-0.37-1.18-0.74-1.76-1.08l-0.42-0.23c-0.07-0.05-0.35-0.13-0.11-0.09 c0.02-0.01,0.09,0.01,0.14,0c0.04,0,0.12-0.05,0.08-0.02l-0.12,0.06c-0.12,0.08-0.23,0.15-0.37,0.25 c-1.04,0.78-2.09,1.74-3.12,2.68c-2.05,1.9-4.07,3.87-6.05,5.86C199.95,406.56,197.76,408.35,195.49,410.09z"
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        className: "st1"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M285.71,397.72l5.31,4.57c1.77,1.52,3.51,3.08,5.27,4.62l-0.71-0.15c1.48-0.63,2.84-1.66,4.12-2.78 c1.28-1.12,2.45-2.38,3.71-3.56c1.26-1.19,2.56-2.36,3.95-3.46c0.7-0.54,1.42-1.08,2.2-1.54c0.39-0.24,0.8-0.44,1.23-0.61 c0.43-0.16,0.91-0.29,1.39-0.22v0.2c-0.79,0.23-1.39,0.86-2,1.44c-0.6,0.6-1.18,1.23-1.76,1.87c-1.16,1.28-2.32,2.58-3.57,3.81 c-1.25,1.23-2.63,2.36-4.06,3.42c-1.44,1.06-2.95,2.08-4.74,2.7l-0.42,0.15l-0.29-0.29c-1.64-1.66-3.29-3.31-4.91-4.99l-4.87-5.04 L285.71,397.72z"
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        className: "st3",
        d: "M201.84,403.73c0,0-1.95,18.57,18.57,22.48c14.68,2.8,19.54-14.17,19.54-14.17"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        className: "st1",
        d: "M227.06,405.91c-3.52-2.29-7.22-4.8-10.25-6.82c-0.63,2.35-0.88,5.33-0.62,8.56 c0.58,7.23,3.51,12.89,6.54,12.64c3.03-0.24,5.01-6.3,4.42-13.53C227.13,406.48,227.09,406.2,227.06,405.91z M222.87,413.08 c-1.06,0.18-2.26-1.61-2.67-4c-0.41-2.39,0.12-4.48,1.18-4.66c1.06-0.18,2.26,1.61,2.67,4 C224.46,410.8,223.93,412.89,222.87,413.08z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        className: "st1",
        d: "M308.48,396.98c-2.86,2.56-6.55,6.66-10.05,9.01c0.49,5.42,3.37,9.59,6.66,9.44c3.45-0.16,6.03-4.99,5.77-10.8 C310.72,401.57,309.81,398.85,308.48,396.98z M304.81,410.66c-1.06,0-1.92-1.32-1.92-2.96c0-1.63,0.86-2.96,1.92-2.96 c1.06,0,1.92,1.32,1.92,2.96C306.73,409.33,305.87,410.66,304.81,410.66z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        className: "st1"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M295.13,493.16c-0.09-1.59-0.04-2.97,0.03-4.43c0.08-1.44,0.23-2.87,0.41-4.29c0.37-2.84,0.93-5.65,1.67-8.41 c1.47-5.52,3.6-10.84,6.29-15.85c2.73-4.99,5.99-9.68,9.7-13.95c3.72-4.27,7.89-8.12,12.34-11.58c4.45-3.46,9.21-6.49,14.15-9.15 c1.25-0.67,2.42-1.36,3.59-2.06l1.76-1.04l1.66-1.19l1.66-1.19c0.55-0.4,1.05-0.88,1.57-1.31c1.04-0.88,2.09-1.76,3.03-2.76 c3.92-3.82,7.24-8.25,10.11-12.95c0.75-1.16,1.37-2.39,2.06-3.59c0.62-1.23,1.28-2.45,1.84-3.71c1.16-2.5,2.22-5.07,3.06-7.68 l0.7,0.19c-0.71,2.73-1.64,5.37-2.74,7.95c-0.52,1.3-1.14,2.56-1.73,3.83c-0.66,1.24-1.23,2.52-1.96,3.73 c-2.74,4.9-6.1,9.48-10.05,13.52c-0.95,1.05-2.02,1.97-3.08,2.91c-0.54,0.46-1.04,0.96-1.61,1.39l-1.7,1.27l-1.71,1.27l-1.82,1.11 c-1.21,0.75-2.43,1.49-3.61,2.16c-4.79,2.72-9.38,5.79-13.64,9.26c-4.26,3.46-8.21,7.29-11.71,11.48 c-3.49,4.21-6.51,8.77-9.01,13.6c-2.46,4.85-4.38,9.96-5.65,15.23c-0.64,2.63-1.11,5.3-1.4,7.98c-0.14,1.34-0.25,2.68-0.29,4.02 c-0.04,1.31-0.05,2.72,0.05,3.9L295.13,493.16z"
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        className: "st1"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M254.06,449.02c2.54-1.57,5.12-3.07,7.79-4.43c1.34-0.68,2.69-1.34,4.1-1.91c0.72-0.28,1.42-0.56,2.23-0.74 c0.22-0.04,0.35-0.11,0.68-0.12c0.27-0.01,0.48,0.01,0.69,0.03c0.42,0.05,0.81,0.11,1.19,0.19c1.52,0.3,2.96,0.73,4.37,1.25 l4.22,1.52c2.8,1.04,5.58,2.11,8.36,3.2c5.55,2.18,11.07,4.42,16.58,6.67l8.27,3.36c2.74,1.09,5.55,2.28,8.24,3.19l-1.26,0.72 c0.25-1.07,0.28-2.32,0.24-3.54c-0.05-1.23-0.18-2.48-0.36-3.72c-0.37-2.48-0.93-4.95-1.61-7.38c-0.69-2.43-1.51-4.82-2.47-7.15 c-0.97-2.31-2.05-4.66-3.37-6.69c-2.81-4.13-6.29-7.93-9.75-11.65c-3.5-3.71-7.13-7.31-10.86-10.8 c-3.72-3.49-7.56-6.87-11.54-10.01c-0.97-0.81-1.96-1.6-2.98-2.33c-0.51-0.37-1.02-0.72-1.54-1.03c-0.51-0.31-1.07-0.6-1.53-0.71 c-0.3-0.11-0.76,0.13-1.23,0.49c-0.46,0.35-0.89,0.79-1.31,1.24c-0.83,0.92-1.59,1.94-2.32,2.97c-2.9,4.17-5.41,8.66-7.85,13.16 c-2.43,4.51-4.77,9.07-7,13.69c2.05-4.7,4.2-9.36,6.47-13.96c2.3-4.59,4.65-9.16,7.46-13.5c0.71-1.08,1.46-2.15,2.31-3.16 c0.43-0.5,0.88-1,1.43-1.45c0.27-0.23,0.57-0.44,0.94-0.61c0.18-0.09,0.39-0.16,0.62-0.2c0.25-0.04,0.48-0.03,0.7-0.01 c0.81,0.14,1.41,0.43,2.03,0.72c0.6,0.3,1.18,0.63,1.74,0.97c1.12,0.68,2.2,1.42,3.26,2.17c4.12,3.15,7.93,6.61,11.71,10.11 c3.75,3.52,7.41,7.14,10.95,10.89c1.77,1.88,3.5,3.78,5.18,5.75c1.68,1.97,3.32,3.97,4.78,6.17c1.46,2.28,2.53,4.61,3.54,7.03 c0.99,2.41,1.84,4.87,2.55,7.37c0.71,2.5,1.28,5.05,1.67,7.63c0.19,1.29,0.33,2.6,0.38,3.93c0.04,1.33,0.04,2.67-0.29,4.1 l-0.25,1.06l-1.01-0.34c-2.95-1-5.63-2.15-8.42-3.25l-8.28-3.37c-5.51-2.25-11.03-4.48-16.56-6.66 c-5.51-2.18-11.13-4.3-16.67-6.06c-0.34-0.11-0.68-0.2-1-0.27c-0.37-0.07-0.45-0.09-0.84-0.03c-0.66,0.08-1.37,0.27-2.06,0.47 c-1.39,0.41-2.78,0.93-4.16,1.47C259.5,446.58,256.77,447.77,254.06,449.02z"
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        className: "st1"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M339.52,425.68c0.11-0.16,0.15-0.18,0.21-0.24c0.06-0.06,0.11-0.09,0.16-0.13c0.1-0.08,0.2-0.15,0.29-0.19 c0.2-0.12,0.37-0.18,0.56-0.25c0.36-0.12,0.71-0.18,1.05-0.22c0.67-0.07,1.31-0.04,1.93,0.03c1.24,0.14,2.4,0.45,3.54,0.8 c1.14,0.36,2.25,0.77,3.33,1.24c1.09,0.45,2.15,0.96,3.21,1.45c-1.12-0.34-2.24-0.7-3.37-0.98c-1.13-0.3-2.27-0.55-3.4-0.74 c-1.13-0.18-2.28-0.32-3.38-0.28c-0.55,0.01-1.09,0.07-1.57,0.19c-0.24,0.06-0.46,0.14-0.64,0.23c-0.08,0.05-0.18,0.1-0.22,0.15 c-0.03,0.02-0.06,0.05-0.06,0.06c-0.01,0.01-0.02,0.02-0.01,0.01c0.01-0.01-0.01,0.02,0.06-0.08L339.52,425.68z"
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        className: "st1"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M341.94,424.24c0.21-0.3,0.45-0.79,0.63-1.23c0.2-0.45,0.36-0.93,0.51-1.42c0.29-0.97,0.49-1.99,0.63-3.01 c0.14-1.03,0.19-2.08,0.21-3.13c0.01-1.05-0.05-2.11-0.14-3.17c0.25,1.03,0.48,2.07,0.64,3.13c0.15,1.06,0.27,2.13,0.29,3.21 c0.02,1.08-0.02,2.18-0.16,3.28c-0.08,0.55-0.17,1.1-0.31,1.65c-0.14,0.57-0.28,1.06-0.57,1.7L341.94,424.24z"
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        className: "st1"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M359.23,408.73c0.16-0.32,0.32-0.87,0.41-1.35c0.11-0.5,0.16-1.02,0.2-1.54c0.07-1.05-0.01-2.12-0.16-3.19 c-0.15-1.07-0.43-2.13-0.75-3.18c-0.17-0.52-0.37-1.03-0.55-1.56l-0.66-1.52l0.88,1.42c0.26,0.49,0.55,0.97,0.79,1.48 c0.48,1.01,0.94,2.05,1.27,3.14c0.33,1.09,0.58,2.22,0.69,3.39c0.05,0.58,0.07,1.17,0.04,1.77c-0.04,0.62-0.08,1.16-0.3,1.89 L359.23,408.73z"
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        className: "st1"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M362.94,403.96c1.01,0.16,2.12,0.25,3.2,0.28c1.09,0.03,2.18-0.01,3.27-0.1c1.09-0.09,2.17-0.28,3.24-0.54 c1.07-0.25,2.11-0.64,3.14-1.09c-0.94,0.6-1.93,1.14-2.98,1.56c-1.05,0.42-2.13,0.79-3.23,1.05c-1.1,0.27-2.23,0.48-3.36,0.62 c-1.15,0.14-2.26,0.22-3.47,0.21L362.94,403.96z"
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        className: "st4",
        d: "M344.03,417.9c-3.42,0.24-5.05-8.94-7.08-19.54c-1.22-6.35-2.44-13.44-1.47-21.01 c1.47-0.49,10.02,15.64,10.99,20.03C347.45,401.78,347.45,417.66,344.03,417.9z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        className: "st4",
        d: "M359.42,400.56c-6.35-1.47-13.19-32.25-10.99-35.91C352.82,366.11,365.77,395.92,359.42,400.56z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        className: "st4",
        d: "M367.72,404.22c0,0,8.79-13.19,31.76-10.26C398.26,399.83,371.39,414.48,367.72,404.22z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        className: "st4",
        d: "M347.2,425.72c0,0,4.15,9.53,16.12,9.28c11.97-0.24,26.63-7.82,26.87-11.24c-1.71-1.22-15.64,4.4-24.92,2.2 c-4.57-1.08-16.12-1.22-16.12-1.22L347.2,425.72z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        className: "st4",
        d: "M386.29,355.12c-3.66,2.2-16.86,18.32-18.32,26.14c-1.47,7.82,5.08,8.73,8.79,4.4 C379.7,382.24,387.02,360.25,386.29,355.12z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        className: "st1"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M292.79,408.06c3.51,2.95,7,5.94,10.38,9.06c1.69,1.56,3.36,3.14,5.02,4.75c1.64,1.64,3.33,3.2,4.69,5.24l-1.01-0.44 c0.72-0.11,1.45-0.4,2.11-0.89c0.67-0.48,1.29-1.1,1.85-1.79c1.12-1.38,2.09-2.99,2.94-4.67l0.19,0.06 c-0.12,0.96-0.39,1.88-0.68,2.8c-0.32,0.92-0.72,1.81-1.22,2.67c-0.52,0.85-1.12,1.68-1.93,2.37c-0.79,0.7-1.8,1.27-2.94,1.47 l-0.6,0.11l-0.41-0.55c-1.28-1.7-2.74-3.49-4.23-5.2c-1.51-1.71-3.08-3.37-4.66-5.02c-3.19-3.28-6.36-6.59-9.62-9.82 L292.79,408.06z"
    }))), /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        id: "Brushes",
        className: "st0"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        className: "st4",
        d: "M165.41,383.22c5.62,2.5,12.37,0.01,16.97-4.07c4.61-4.08,7.72-9.53,11.52-14.36 c8.7-11.06,21.17-18.92,34.66-22.9c13.5-3.98,27.97-4.19,41.79-1.54c10.69,2.05,21.27,5.92,29.63,12.9 c8.36,6.98,14.25,17.39,14.08,28.28c-0.17,10.89-7.26,21.8-17.72,24.82"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        className: "st4",
        d: "M286.33,398.45c4.61,1.89,8.66,5.11,11.54,9.18"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        className: "st4",
        d: "M314.12,384.58c-0.82,4.43,1.18,8.88,3.54,12.71c2.37,3.83,5.19,7.51,6.31,11.87c0.51,1.99,0.57,4.07,0.26,6.1 c-0.36,2.34-2.11,4.43-2.45,6.59c-0.43,2.82,4.76,7.64,6.2,10.48c4,7.89,5.37,17,4.84,25.77c-0.79,12.98-5.34,25.4-9.84,37.61"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        className: "st4",
        d: "M320.18,492.81c6.13,6.38,10.78,14.17,13.49,22.6"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        className: "st4",
        d: "M256.3,448.41c3.07-3.17,7.78-4.31,12.18-4.01c4.4,0.3,8.61,1.86,12.74,3.4c12.48,4.66,25.71,9.38,38.19,14.04 c1.34-13.05-4.07-26.07-12.08-36.46s-18.48-18.56-28.84-26.62c-1.26-0.98-2.66-2.01-4.26-1.95c-2.43,0.08-3.99,2.53-5.11,4.68 c-4.62,8.88-9.23,17.76-13.85,26.65"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        className: "st4",
        d: "M274.39,475.98c2.35,1.38,5,2.8,7.66,2.22c2.87-0.64,4.69-3.36,6.56-5.63c5.89-7.14,15.13-11.38,24.38-11.18"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        className: "st4",
        d: "M297.62,492.94c-0.68-15.73,4.81-31.66,15.04-43.63c6.24-7.3,14.05-13.06,21.86-18.67 c7.8-5.6,15.73-11.16,22.31-18.16s11.8-15.65,13.01-25.18"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        className: "st4",
        d: "M342.23,405.49c3.07,5.7,3.61,12.71,1.43,18.81"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        className: "st4",
        d: "M365.32,434.23c-7.04-5.2-15.71-8.15-24.46-8.31"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        className: "st4",
        d: "M380.64,400.87c-5.62,1-11.23,1.99-16.85,2.99"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        className: "st4",
        d: "M355.69,386.92c4.3,6,6.23,13.65,5.29,20.98"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        className: "st4",
        d: "M337.11,390.92c2.9,4.01,5.81,8.03,8.71,12.04c1.15,1.59,2.31,3.2,3.02,5.03c0.71,1.83,0.91,3.93,0.14,5.74 c-3.43,7.95-8.79-1.72-10.21-5.23c-1.13-2.81-1.85-5.78-2.13-8.8C336.51,398.22,337.73,391.77,337.11,390.92z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        className: "st4",
        d: "M351.13,434.48c1.95,1.64,4.54,2.35,7.09,2.54c7.09,0.54,14.36-2.83,18.53-8.59 c-4.64,0.65-9.26-0.97-13.82-2.04c-3.9-0.91-8.45-1.47-12.19,0.37C347.25,428.48,348.42,432.2,351.13,434.48z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        className: "st4",
        d: "M349.95,374.81c2.51,3.7,5.86,6.77,8.34,10.49c1.87,2.81,3.62,6.71,2.88,10.17c-0.65,3.02-3.35,5.6-5.92,2.78 c-2.32-2.54-3.11-7.67-3.84-10.91C350.49,383.23,349.99,379.02,349.95,374.81z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        className: "st4",
        d: "M391.44,395.99c-0.44,0.02-3.68,5.01-4.33,5.64c-1.8,1.78-3.88,3.3-6.13,4.47c-3.03,1.57-8.29,3.38-9.46-1.17 C368.76,394.27,385.91,396.24,391.44,395.99z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        className: "st4",
        d: "M365.56,376.89c1.6-1.94,4.19-2.67,6.49-3.69c4.9-2.18,8.97-6.17,11.25-11.02c1.16,5.68,1.56,11.51,1.18,17.29 c-0.19,2.9-0.66,5.98-2.6,8.14C376.04,394.12,359.15,384.67,365.56,376.89z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        className: "st4",
        d: "M249.08,405.11c-2.35,3.54-6.23,6.3-10.48,6.31c-3.85,0.01-7.37-2.19-10.28-4.72s-5.46-5.5-8.71-7.58 c-3.24-2.08-7.49-3.16-10.97-1.5c-1.15,0.55-2.14,1.36-3.13,2.16c-3.65,2.98-7.31,5.95-10.96,8.93"
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        id: "Trace_copy",
        className: "st0"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        className: "st2",
        d: "M284,279c-62.23,0-113.75,45.84-122.64,105.59l18.01-3.33c0,0,17.1-40.07,71.34-42.02 c54.23-1.95,68.57,43.49,61.56,55.21c6.84,2.12,10.26,20.52,6.35,27.85c17.59,5.37,15.15,56.19,6.84,75.73 c2.55,4.15,6.77,12.67,9.39,18.09C377.98,496.71,408,453.36,408,403C408,334.52,352.48,279,284,279z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        className: "st1",
        d: "M254.12,428.65c1.9-4.77,3.97-9.47,6.15-14.13c1.09-2.33,2.21-4.65,3.39-6.94c1.16-2.31,2.59-4.47,4.02-6.65 c0.74-1.08,1.51-2.14,2.39-3.16c0.45-0.51,0.92-1.01,1.5-1.47c0.29-0.23,0.61-0.46,1.02-0.64c0.2-0.09,0.44-0.17,0.7-0.22 c0.29-0.05,0.56-0.03,0.8,0.01c0.88,0.18,1.48,0.5,2.09,0.82c0.6,0.33,1.16,0.68,1.72,1.04c1.1,0.73,2.15,1.5,3.18,2.29 c4.1,3.18,7.93,6.61,11.7,10.13c3.75,3.52,7.41,7.14,10.95,10.89c1.77,1.88,3.5,3.78,5.18,5.75c1.68,1.97,3.32,3.97,4.78,6.17 c1.46,2.28,2.53,4.61,3.54,7.03c0.99,2.41,1.84,4.87,2.55,7.37c0.71,2.5,1.28,5.05,1.67,7.63c0.19,1.29,0.33,2.6,0.38,3.93 c0.04,1.33,0.04,2.67-0.29,4.1l-0.25,1.06l-1.01-0.34c-2.95-1-5.63-2.15-8.42-3.25l-8.28-3.37c-5.51-2.25-11.03-4.48-16.56-6.66 c-2.77-1.08-5.53-2.17-8.33-3.18c-2.79-0.98-5.52-2.23-8.3-3.05c-0.34-0.1-0.69-0.19-1.02-0.26c-0.37-0.07-0.5-0.09-0.89-0.02 c-0.67,0.09-1.38,0.29-2.08,0.5c-1.4,0.43-2.78,0.96-4.16,1.51c-2.74,1.13-5.47,2.34-8.15,3.63c2.56-1.53,5.15-3.01,7.83-4.34 c1.34-0.67,2.69-1.31,4.11-1.87c0.71-0.27,1.42-0.54,2.22-0.71c0.21-0.04,0.35-0.1,0.66-0.11c0.25-0.01,0.46,0.01,0.67,0.03 c0.41,0.05,0.79,0.12,1.17,0.2c1.5,0.32,2.94,0.74,4.38,1.17c1.44,0.43,2.87,0.87,4.26,1.42l8.35,3.22 c5.55,2.18,11.07,4.42,16.58,6.67l8.27,3.36c2.74,1.09,5.55,2.28,8.24,3.19l-1.26,0.72c0.25-1.07,0.28-2.32,0.24-3.54 c-0.05-1.23-0.18-2.48-0.36-3.72c-0.37-2.48-0.93-4.95-1.61-7.38c-0.69-2.43-1.51-4.82-2.47-7.15c-0.97-2.31-2.05-4.66-3.37-6.69 c-2.81-4.13-6.29-7.93-9.75-11.65c-3.5-3.71-7.13-7.31-10.86-10.8c-3.73-3.48-7.55-6.89-11.55-10c-1-0.77-2.02-1.52-3.06-2.21 c-0.52-0.34-1.04-0.67-1.57-0.96c-0.51-0.28-1.08-0.54-1.46-0.61c-0.08-0.01-0.13-0.01-0.15-0.01c-0.05,0.01-0.12,0.03-0.21,0.07 c-0.18,0.08-0.39,0.21-0.6,0.39c-0.42,0.34-0.84,0.77-1.24,1.22c-0.8,0.92-1.53,1.93-2.24,2.97c-1.44,2.07-2.63,4.32-4,6.47 c-1.34,2.17-2.63,4.37-3.9,6.6C258.93,419.59,256.51,424.11,254.12,428.65z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        className: "st1",
        d: "M273.67,476.54l9.84,3.73l-0.24,0.08c1.86-3.18,3.91-6.25,6.27-9.11c1.19-1.42,2.46-2.79,3.95-3.96 c0.74-0.6,1.58-1.09,2.47-1.48c0.88-0.36,1.77-0.67,2.67-0.91c3.59-1.02,7.06-1.87,10.7-2.44c3.65-0.54,5.11-1.11,8.79-1.47 l1.3,1.63c-3.64,0.22-6.14,0.98-9.77,1.38c-3.62,0.43-7.21,1.18-10.72,2.05c-1.77,0.44-3.45,0.95-4.86,2.03 c-1.44,1.04-2.73,2.34-3.95,3.68c-2.42,2.72-4.57,5.7-6.54,8.79l-0.09,0.14l-0.15-0.06L273.67,476.54z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        className: "st1",
        d: "M195.49,410.09c1.67-2.31,3.44-4.53,5.24-6.74c2.02-1.98,4.03-3.97,6.12-5.9c1.06-0.97,2.08-1.92,3.3-2.83 c0.15-0.11,0.33-0.23,0.51-0.34c0.1-0.06,0.23-0.13,0.35-0.18c0.11-0.06,0.51-0.17,0.72-0.13c0.59,0.1,0.62,0.2,0.87,0.29 l0.51,0.27c0.64,0.37,1.25,0.75,1.85,1.13c2.4,1.54,4.73,3.12,7.08,4.68c4.69,3.12,9.36,6.31,14.19,9.08 c0.6,0.34,1.21,0.67,1.82,0.96c0.59,0.29,1.26,0.58,1.69,0.66c0.09-0.02-0.02,0.04,0.16-0.01c0.12-0.04,0.23-0.06,0.36-0.11 c0.27-0.12,0.54-0.23,0.83-0.4c0.58-0.28,1.09-0.73,1.67-1.08c2.39-1.36,4.68-3.05,6.97-4.73c-1.74,2.26-3.63,4.39-5.8,6.35 c-0.28,0.24-0.58,0.45-0.91,0.63c-0.32,0.19-0.63,0.4-0.97,0.58c-0.32,0.19-0.71,0.35-1.08,0.51c-0.2,0.08-0.43,0.13-0.65,0.19 c-0.15,0.07-0.63,0.07-0.89,0.03c-0.95-0.19-1.57-0.52-2.25-0.84c-0.67-0.32-1.3-0.67-1.92-1.02c-4.96-2.85-9.62-6.04-14.32-9.16 c-2.35-1.57-4.68-3.15-7.04-4.66c-0.59-0.37-1.18-0.74-1.76-1.08l-0.42-0.23c-0.07-0.05-0.35-0.13-0.11-0.09 c0.02-0.01,0.09,0.01,0.14,0c0.04,0,0.12-0.05,0.08-0.02l-0.12,0.06c-0.12,0.08-0.23,0.15-0.37,0.25 c-1.04,0.78-2.09,1.74-3.12,2.68c-2.05,1.9-4.07,3.87-6.05,5.86C199.95,406.56,197.76,408.35,195.49,410.09z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        className: "st1",
        d: "M285.71,397.72l5.31,4.57c1.77,1.52,3.51,3.08,5.27,4.62l-0.71-0.15c1.48-0.63,2.84-1.66,4.12-2.78 c1.28-1.12,2.45-2.38,3.71-3.56c1.26-1.19,2.91-3.08,3.48-3.77c0.58-0.68,1.29-1.49,2.08-1.95c0.39-0.24,1.4,0.29,1.83,0.12 c0.43-0.16,0.91-0.29,1.39-0.22v0.2c-0.79,0.23-1.39,0.86-2,1.44c-0.6,0.6-1.18,1.23-1.76,1.87c-1.16,1.28-2.32,2.58-3.57,3.81 c-1.25,1.23-2.63,2.36-4.06,3.42c-1.44,1.06-2.95,2.08-4.74,2.7l-0.42,0.15l-0.29-0.29c-1.64-1.66-3.29-3.31-4.91-4.99l-4.87-5.04 L285.71,397.72z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        className: "st3",
        d: "M201.84,403.73c0,0-1.95,18.57,18.57,22.48c14.68,2.8,19.54-14.17,19.54-14.17"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        className: "st1",
        d: "M308.48,396.98c-2.86,2.56-6.55,6.66-10.05,9.01c0.49,5.42,3.37,9.59,6.66,9.44c3.45-0.16,6.03-4.99,5.77-10.8 C310.72,401.57,309.81,398.85,308.48,396.98z M303.5,410.48c-1.06,0-1.92-1.32-1.92-2.96c0-1.63,0.86-2.96,1.92-2.96 c1.06,0,1.92,1.32,1.92,2.96C305.43,409.15,304.57,410.48,303.5,410.48z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        className: "st1",
        d: "M254.06,449.02c2.54-1.57,5.12-3.07,7.79-4.43c1.34-0.68,2.69-1.34,4.1-1.91c0.72-0.28,1.42-0.56,2.23-0.74 c0.22-0.04,0.35-0.11,0.68-0.12c0.27-0.01,0.48,0.01,0.69,0.03c0.42,0.05,0.81,0.11,1.19,0.19c1.52,0.3,2.96,0.73,4.37,1.25 l4.22,1.52c2.8,1.04,5.58,2.11,8.36,3.2c5.55,2.18,11.07,4.42,16.58,6.67l8.27,3.36c2.74,1.09,5.55,2.28,8.24,3.19l-1.26,0.72 c0.25-1.07,0.28-2.32,0.24-3.54c-0.05-1.23-0.18-2.48-0.36-3.72c-0.37-2.48-0.93-4.95-1.61-7.38c-0.69-2.43-1.51-4.82-2.47-7.15 c-0.97-2.31-2.05-4.66-3.37-6.69c-2.81-4.13-6.29-7.93-9.75-11.65c-3.5-3.71-7.13-7.31-10.86-10.8 c-3.72-3.49-7.56-6.87-11.54-10.01c-0.97-0.81-1.96-1.6-2.98-2.33c-0.51-0.37-1.02-0.72-1.54-1.03c-0.51-0.31-1.07-0.6-1.53-0.71 c-0.3-0.11-0.76,0.13-1.23,0.49c-0.46,0.35-0.89,0.79-1.31,1.24c-0.83,0.92-1.59,1.94-2.32,2.97c-2.9,4.17-5.41,8.66-7.85,13.16 c-2.43,4.51-4.77,9.07-7,13.69c2.05-4.7,4.2-9.36,6.47-13.96c2.3-4.59,4.65-9.16,7.46-13.5c0.71-1.08,1.46-2.15,2.31-3.16 c0.43-0.5,0.88-1,1.43-1.45c0.27-0.23,0.57-0.44,0.94-0.61c0.18-0.09,0.39-0.16,0.62-0.2c0.25-0.04,0.48-0.03,0.7-0.01 c0.81,0.14,1.41,0.43,2.03,0.72c0.6,0.3,1.18,0.63,1.74,0.97c1.12,0.68,2.2,1.42,3.26,2.17c4.12,3.15,7.93,6.61,11.71,10.11 c3.75,3.52,7.41,7.14,10.95,10.89c1.77,1.88,3.5,3.78,5.18,5.75c1.68,1.97,3.32,3.97,4.78,6.17c1.46,2.28,2.53,4.61,3.54,7.03 c0.99,2.41,1.84,4.87,2.55,7.37c0.71,2.5,1.28,5.05,1.67,7.63c0.19,1.29,0.33,2.6,0.38,3.93c0.04,1.33,0.04,2.67-0.29,4.1 l-0.25,1.06l-1.01-0.34c-2.95-1-5.63-2.15-8.42-3.25l-8.28-3.37c-5.51-2.25-11.03-4.48-16.56-6.66c-5.51-2.18-11.13-4.3-16.67-6.06 c-0.34-0.11-0.68-0.2-1-0.27c-0.37-0.07-0.45-0.09-0.84-0.03c-0.66,0.08-1.37,0.27-2.06,0.47c-1.39,0.41-2.78,0.93-4.16,1.47 C259.5,446.58,256.77,447.77,254.06,449.02z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        className: "st1",
        d: "M339.52,425.68c0.11-0.16,0.15-0.18,0.21-0.24c0.06-0.06,0.11-0.09,0.16-0.13c0.1-0.08,0.2-0.15,0.29-0.19 c0.2-0.12,0.37-0.18,0.56-0.25c0.36-0.12,0.71-0.18,1.05-0.22c0.67-0.07,1.31-0.04,1.93,0.03c1.24,0.14,2.4,0.45,3.54,0.8 c1.14,0.36,2.25,0.77,3.33,1.24c1.09,0.45,2.15,0.96,3.21,1.45c-1.12-0.34-2.24-0.7-3.37-0.98c-1.13-0.3-2.27-0.55-3.4-0.74 c-1.13-0.18-2.28-0.32-3.38-0.28c-0.55,0.01-1.09,0.07-1.57,0.19c-0.24,0.06-0.46,0.14-0.64,0.23c-0.08,0.05-0.18,0.1-0.22,0.15 c-0.03,0.02-0.06,0.05-0.06,0.06c-0.01,0.01-0.02,0.02-0.01,0.01c0.01-0.01-0.01,0.02,0.06-0.08L339.52,425.68z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        className: "st1",
        d: "M341.94,424.24c0.21-0.3,0.45-0.79,0.63-1.23c0.2-0.45,0.36-0.93,0.51-1.42c0.29-0.97,0.49-1.99,0.63-3.01 c0.14-1.03,0.19-2.08,0.21-3.13c0.01-1.05-0.05-2.11-0.14-3.17c0.25,1.03,0.48,2.07,0.64,3.13c0.15,1.06,0.27,2.13,0.29,3.21 c0.02,1.08-0.02,2.18-0.16,3.28c-0.08,0.55-0.17,1.1-0.31,1.65c-0.14,0.57-0.28,1.06-0.57,1.7L341.94,424.24z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        className: "st1",
        d: "M359.23,408.73c0.16-0.32,0.32-0.87,0.41-1.35c0.11-0.5,0.16-1.02,0.2-1.54c0.07-1.05-0.01-2.12-0.16-3.19 c-0.15-1.07-0.43-2.13-0.75-3.18c-0.17-0.52-0.37-1.03-0.55-1.56l-0.66-1.52l0.88,1.42c0.26,0.49,0.55,0.97,0.79,1.48 c0.48,1.01,0.94,2.05,1.27,3.14c0.33,1.09,0.58,2.22,0.69,3.39c0.05,0.58,0.07,1.17,0.04,1.77c-0.04,0.62-0.6,1.03-0.81,1.76 L359.23,408.73z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        className: "st1",
        d: "M362.94,403.96c1.01,0.16,2.12,0.25,3.2,0.28c1.09,0.03,2.18-0.01,3.27-0.1c1.09-0.09,2.17-0.28,3.24-0.54 c1.07-0.25,2.11-0.64,3.14-1.09c-0.94,0.6-1.93,1.14-2.98,1.56c-1.05,0.42-2.13,0.79-3.23,1.05c-1.1,0.27-2.23,0.48-3.36,0.62 c-1.15,0.14-2.26,0.22-3.47,0.21L362.94,403.96z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        className: "st4",
        d: "M344.03,417.9c-3.42,0.24-5.05-8.94-7.08-19.54c-1.22-6.35-2.44-13.44-1.47-21.01 c1.47-0.49,10.02,15.64,10.99,20.03C347.45,401.78,347.45,417.66,344.03,417.9z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        className: "st4",
        d: "M359.42,400.56c-6.35-1.47-13.19-32.25-10.99-35.91C352.82,366.11,365.77,395.92,359.42,400.56z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        className: "st4",
        d: "M367.72,404.22c0,0,8.79-13.19,31.76-10.26C398.26,399.83,371.39,414.48,367.72,404.22z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        className: "st4",
        d: "M347.2,425.72c0,0,4.15,9.53,16.12,9.28c11.97-0.24,26.63-7.82,26.87-11.24c-1.71-1.22-15.6,4.23-24.92,2.2 C355.92,423.93,347.2,425.72,347.2,425.72z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        className: "st1",
        d: "M292.79,408.06c3.51,2.95,7,5.94,10.38,9.06c1.69,1.56,3.36,3.14,5.02,4.75c1.64,1.64,3.33,3.2,4.69,5.24 l-1.01-0.44c0.72-0.11,1.45-0.4,2.11-0.89c0.67-0.48,1.29-1.1,1.85-1.79c1.12-1.38,2.09-2.99,2.94-4.67l0.19,0.06 c-0.12,0.96-0.39,1.88-0.68,2.8c-0.32,0.92-0.72,1.81-1.22,2.67c-0.52,0.85-1.12,1.68-1.93,2.37c-0.79,0.7-1.8,1.27-2.94,1.47 l-0.6,0.11l-0.41-0.55c-1.28-1.7-2.74-3.49-4.23-5.2c-1.51-1.71-3.08-3.37-4.66-5.02c-3.19-3.28-6.36-6.59-9.62-9.82L292.79,408.06 z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        className: "st1"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M305.69,456.45c-0.75,1.22-1.48,2.46-2.16,3.71c-2.69,5.01-4.82,10.33-6.29,15.85c-0.73,2.76-1.3,5.57-1.67,8.41 c-0.18,1.42-0.33,2.85-0.41,4.29c-0.07,1.46-0.13,2.84-0.03,4.43l3.98-0.35c-0.1-1.18-0.09-2.59-0.05-3.9 c0.05-1.34,0.15-2.68,0.29-4.02c0.29-2.68,0.76-5.35,1.4-7.98c1.27-5.27,3.19-10.38,5.65-15.23c0.71-1.37,1.47-2.71,2.26-4.03 L305.69,456.45z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M370.06,388.01c-0.84,2.61-1.91,5.18-3.06,7.68c-0.56,1.26-1.22,2.48-1.84,3.71c-0.69,1.19-1.3,2.43-2.06,3.59 c-2.87,4.7-6.19,9.13-10.11,12.95c-0.94,1-1.99,1.87-3.03,2.76c-0.53,0.44-1.02,0.91-1.57,1.31l-1.66,1.19l-1.66,1.19l-1.76,1.03 c-1.17,0.69-2.34,1.38-3.59,2.06c-4.94,2.66-9.7,5.69-14.15,9.15c-2.98,2.31-5.81,4.82-8.49,7.49c0.4,0.97,0.78,1.98,1.07,2.85 c2.78-3,5.79-5.79,8.98-8.38c4.25-3.47,8.85-6.53,13.64-9.26c1.18-0.67,2.4-1.42,3.61-2.16l1.82-1.11l1.71-1.27l1.7-1.27 c0.56-0.43,1.07-0.93,1.61-1.39c1.06-0.94,2.13-1.86,3.08-2.91c3.95-4.04,7.31-8.62,10.05-13.52c0.72-1.2,1.3-2.49,1.96-3.73 c0.58-1.28,1.21-2.53,1.73-3.83c1.1-2.58,2.03-5.22,2.74-7.95L370.06,388.01z"
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        className: "st1",
        d: "M228.47,407.89c-0.01-0.29,0.03-0.94,0-1.22c-3.52-2.29-8.63-5.55-11.66-7.57c-0.63,2.35-1.02,5.35-0.62,8.56 c0.68,5.36,3.39,9.64,6.42,9.88C227.13,417.9,228.7,413.52,228.47,407.89z M221.96,411.66c-1.06,0-1.92-1.32-1.92-2.96 c0-1.63,0.86-2.96,1.92-2.96c1.06,0,1.92,1.32,1.92,2.96C223.88,410.33,223.02,411.66,221.96,411.66z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        id: "SVGID_x5F_1_x5F_",
        className: "st5",
        d: "M284,519.85c64.43,0,116.85-52.42,116.85-116.85c0-64.43-52.42-116.85-116.85-116.85 c-64.43,0-116.85,52.42-116.85,116.85C167.15,467.43,219.57,519.85,284,519.85z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("text", {
        className: "st1"
    }, " ", /*#__PURE__*/ (0, _reactDefault.default).createElement("textPath", {
        startOffset: "1165.844%"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("tspan", {
        style: {
            fontFamily: "MyriadPro-Regular",
            fontSize: "16.6923px",
            letterSpacing: "262px"
        }
    }, "DON\u2019T  @HERE  ME"), " "))), /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        id: "Colors"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        className: "st6",
        d: "M333.93,516.09c0.72-0.32,1.44-0.63,2.15-0.97l-2.63-1.23c-1.86-5.77-8.31-15.7-8.31-15.7 s17.92-61.24-5.86-74.92c1.95-3.58,1.95-26.71-7.49-28.34c5.86-8.47-0.98-55.37-57.33-55.05s-74.27,41.04-74.27,41.04l-17.73,3.67 l-1.29-1.41c-0.99,6.31-1.51,12.78-1.51,19.36c0,68.54,55.57,124.11,124.11,124.11c17.82,0,34.76-3.77,50.08-10.54 c0.03-0.01,0.05-0.01,0.08-0.02C333.93,516.11,333.93,516.1,333.93,516.09z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("circle", {
        className: "st7",
        cx: "283.83",
        cy: "403.33",
        r: "124.33"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        className: "st8",
        d: "M254.12,428.82c2.44-6.76,15.71-31.95,18.89-32.25c3.18-0.3,34.85,25.73,39.09,36.48 c4.23,10.75,9.77,14.33,8.79,29.97c-4.56-3.91-51.96-20.88-51.96-20.88l-14.49,6.88C254.45,449.01,251.6,435.8,254.12,428.82z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        className: "st8",
        d: "M315.04,462.69c0,0-12.38,0.98-18.57,3.26c-6.19,2.28-13.1,14.67-13.1,14.67s-6.93-3.03-9.7-4.25 c-2.56-1.13-19.22-27.36-19.22-27.36l14.49-6.88l46.1,18.6V462.69z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        className: "st9",
        d: "M211.78,394.94l-10.42,9.45c0,0,0.63,20.78,21.5,22.48c12.05,0.98,16.29-14.33,16.29-14.33L211.78,394.94z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        className: "st9",
        d: "M312.43,428.16c0,0,11.15-5.23,6.84-22.48c-3.26-13.03-7.49-10.75-7.49-10.75l-15.64,13.03l-1.63,1.95 L312.43,428.16z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        className: "st10",
        d: "M335.72,378.08c0,0-0.86,5.5-0.73,7.7c0.12,2.2,4.52,24.8,4.52,24.8s2.32,6.6,3.18,7.08 c0.86,0.49,2.2-0.12,2.2-0.12l1.71-4.89c0,0,0.86-12.09,0.12-14.17C345.98,396.41,339.51,379.79,335.72,378.08z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("polygon", {
        className: "st10",
        points: "347.94,426.7 350.62,430.49 357.22,434.27 364.67,435 373.59,433.42 383.6,429.39 389.47,425.6 390.08,423.89 387.76,423.64 377.99,425.6 368.7,426.58 360.03,425.11 350.38,424.99  "
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("polygon", {
        className: "st10",
        points: "367.72,404.34 372.86,399.09 381.04,395.18 387.02,394.08 396.43,393.72 399.48,394.08 397.65,397.02 392.89,400.68 384.34,405.32 378.6,407.15 372.61,407.89 368.82,406.06  "
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("polygon", {
        className: "st10",
        points: "359.42,400.56 357.22,399.09 354.04,393.72 349.4,378.33 348.06,367.33 348.55,364.65 352.09,368.55 357.22,378.94 361.13,392.62 361.13,397.87  "
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        className: "st11",
        d: "M384.42,360.74c-4.4,7.82-18.08,14.01-20.68,18.73s7.03,8.72,7.03,8.72s7.94,3.47,9.75,1.05 C386.05,381.82,383.12,373.74,384.42,360.74z M377.09,382.6l-5.21-2.97l6.93-5.27L377.09,382.6z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        id: "SVGID_x5F_00000080910466905454608670000016559596414473353368_x5F_",
        className: "st12",
        d: "M284,519.85 c64.43,0,116.85-52.42,116.85-116.85c0-64.43-52.42-116.85-116.85-116.85c-64.43,0-116.85,52.42-116.85,116.85 C167.15,467.43,219.57,519.85,284,519.85z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("text", null, " ", /*#__PURE__*/ (0, _reactDefault.default).createElement("textPath", {
        startOffset: "1165.844%"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("tspan", {
        className: "st9",
        style: {
            fontFamily: "MyriadPro-Regular",
            fontSize: "16.6923px",
            letterSpacing: "262px"
        }
    }, "DON\u2019T  @HERE  ME"), " "))), /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        id: "Trace_w_x2F_shading"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        className: "st7",
        d: "M284,279c-62.23,0-113.75,45.84-122.64,105.59l18.01-3.33c0,0,17.1-40.07,71.34-42.02 c54.23-1.95,68.57,43.49,61.56,55.21c6.84,2.12,10.26,20.52,6.35,27.85c17.59,5.37,15.15,56.19,6.84,75.73 c2.55,4.15,6.77,12.67,9.39,18.09C377.98,496.71,408,453.36,408,403C408,334.52,352.48,279,284,279z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M254.12,428.65c1.9-4.77,3.97-9.47,6.15-14.13c1.09-2.33,2.21-4.65,3.39-6.94c1.16-2.31,2.59-4.47,4.02-6.65 c0.74-1.08,1.51-2.14,2.39-3.16c0.45-0.51,0.92-1.01,1.5-1.47c0.29-0.23,0.61-0.46,1.02-0.64c0.2-0.09,0.44-0.17,0.7-0.22 c0.29-0.05,0.56-0.03,0.8,0.01c0.88,0.18,1.48,0.5,2.09,0.82c0.6,0.33,1.16,0.68,1.72,1.04c1.1,0.73,2.15,1.5,3.18,2.29 c4.1,3.18,7.93,6.61,11.7,10.13c3.75,3.52,7.41,7.14,10.95,10.89c1.77,1.88,3.5,3.78,5.18,5.75c1.68,1.97,3.32,3.97,4.78,6.17 c1.46,2.28,2.53,4.61,3.54,7.03c0.99,2.41,1.84,4.87,2.55,7.37c0.71,2.5,1.28,5.05,1.67,7.63c0.19,1.29,0.33,2.6,0.38,3.93 c0.04,1.33,0.04,2.67-0.29,4.1l-0.25,1.06l-1.01-0.34c-2.95-1-5.63-2.15-8.42-3.25l-8.28-3.37c-5.51-2.25-11.03-4.48-16.56-6.66 c-2.77-1.08-5.53-2.17-8.33-3.18c-2.79-0.98-5.52-2.23-8.3-3.05c-0.34-0.1-0.69-0.19-1.02-0.26c-0.37-0.07-0.5-0.09-0.89-0.02 c-0.67,0.09-1.38,0.29-2.08,0.5c-1.4,0.43-2.78,0.96-4.16,1.51c-2.74,1.13-5.47,2.34-8.15,3.63c2.56-1.53,5.15-3.01,7.83-4.34 c1.34-0.67,2.69-1.31,4.11-1.87c0.71-0.27,1.42-0.54,2.22-0.71c0.21-0.04,0.35-0.1,0.66-0.11c0.25-0.01,0.46,0.01,0.67,0.03 c0.41,0.05,0.79,0.12,1.17,0.2c1.5,0.32,2.94,0.74,4.38,1.17c1.44,0.43,2.87,0.87,4.26,1.42l8.35,3.22 c5.55,2.18,11.07,4.42,16.58,6.67l8.27,3.36c2.74,1.09,5.55,2.28,8.24,3.19l-1.26,0.72c0.25-1.07,0.28-2.32,0.24-3.54 c-0.05-1.23-0.18-2.48-0.36-3.72c-0.37-2.48-0.93-4.95-1.61-7.38c-0.69-2.43-1.51-4.82-2.47-7.15c-0.97-2.31-2.05-4.66-3.37-6.69 c-2.81-4.13-6.29-7.93-9.75-11.65c-3.5-3.71-7.13-7.31-10.86-10.8c-3.73-3.48-7.55-6.89-11.55-10c-1-0.77-2.02-1.52-3.06-2.21 c-0.52-0.34-1.04-0.67-1.57-0.96c-0.51-0.28-1.08-0.54-1.46-0.61c-0.08-0.01-0.13-0.01-0.15-0.01c-0.05,0.01-0.12,0.03-0.21,0.07 c-0.18,0.08-0.39,0.21-0.6,0.39c-0.42,0.34-0.84,0.77-1.24,1.22c-0.8,0.92-1.53,1.93-2.24,2.97c-1.44,2.07-2.63,4.32-4,6.47 c-1.34,2.17-2.63,4.37-3.9,6.6C258.93,419.59,256.51,424.11,254.12,428.65z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M273.67,476.54l9.84,3.73l-0.24,0.08c1.86-3.18,3.91-6.25,6.27-9.11c1.19-1.42,2.46-2.79,3.95-3.96 c0.74-0.6,1.58-1.09,2.47-1.48c0.88-0.36,1.77-0.67,2.67-0.91c3.59-1.02,7.06-1.87,10.7-2.44c3.65-0.54,5.11-1.11,8.79-1.47 l1.3,1.63c-3.64,0.22-6.14,0.98-9.77,1.38c-3.62,0.43-7.21,1.18-10.72,2.05c-1.77,0.44-3.45,0.95-4.86,2.03 c-1.44,1.04-2.73,2.34-3.95,3.68c-2.42,2.72-4.57,5.7-6.54,8.79l-0.09,0.14l-0.15-0.06L273.67,476.54z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M195.49,410.09c1.67-2.31,3.44-4.53,5.24-6.74c2.02-1.98,4.03-3.97,6.12-5.9c1.06-0.97,2.08-1.92,3.3-2.83 c0.15-0.11,0.33-0.23,0.51-0.34c0.1-0.06,0.23-0.13,0.35-0.18c0.11-0.06,0.51-0.17,0.72-0.13c0.59,0.1,0.62,0.2,0.87,0.29 l0.51,0.27c0.64,0.37,1.25,0.75,1.85,1.13c2.4,1.54,4.73,3.12,7.08,4.68c4.69,3.12,9.36,6.31,14.19,9.08 c0.6,0.34,1.21,0.67,1.82,0.96c0.59,0.29,1.26,0.58,1.69,0.66c0.09-0.02-0.02,0.04,0.16-0.01c0.12-0.04,0.23-0.06,0.36-0.11 c0.27-0.12,0.54-0.23,0.83-0.4c0.58-0.28,1.09-0.73,1.67-1.08c2.39-1.36,4.68-3.05,6.97-4.73c-1.74,2.26-3.63,4.39-5.8,6.35 c-0.28,0.24-0.58,0.45-0.91,0.63c-0.32,0.19-0.63,0.4-0.97,0.58c-0.32,0.19-0.71,0.35-1.08,0.51c-0.2,0.08-0.43,0.13-0.65,0.19 c-0.15,0.07-0.63,0.07-0.89,0.03c-0.95-0.19-1.57-0.52-2.25-0.84c-0.67-0.32-1.3-0.67-1.92-1.02c-4.96-2.85-9.62-6.04-14.32-9.16 c-2.35-1.57-4.68-3.15-7.04-4.66c-0.59-0.37-1.18-0.74-1.76-1.08l-0.42-0.23c-0.07-0.05-0.35-0.13-0.11-0.09 c0.02-0.01,0.09,0.01,0.14,0c0.04,0,0.12-0.05,0.08-0.02l-0.12,0.06c-0.12,0.08-0.23,0.15-0.37,0.25 c-1.04,0.78-2.09,1.74-3.12,2.68c-2.05,1.9-4.07,3.87-6.05,5.86C199.95,406.56,197.76,408.35,195.49,410.09z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M285.71,397.72l5.31,4.57c1.77,1.52,3.51,3.08,5.27,4.62l-0.71-0.15c1.48-0.63,2.84-1.66,4.12-2.78 c1.28-1.12,2.45-2.38,3.71-3.56c1.26-1.19,2.91-3.08,3.48-3.77c0.58-0.68,1.29-1.49,2.08-1.95c0.39-0.24,1.4,0.29,1.83,0.12 c0.43-0.16,0.91-0.29,1.39-0.22v0.2c-0.79,0.23-1.39,0.86-2,1.44c-0.6,0.6-1.18,1.23-1.76,1.87c-1.16,1.28-2.32,2.58-3.57,3.81 c-1.25,1.23-2.63,2.36-4.06,3.42c-1.44,1.06-2.95,2.08-4.74,2.7l-0.42,0.15l-0.29-0.29c-1.64-1.66-3.29-3.31-4.91-4.99l-4.87-5.04 L285.71,397.72z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        className: "st13",
        d: "M201.84,403.73c0,0-1.95,18.57,18.57,22.48c14.68,2.8,19.54-14.17,19.54-14.17"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M308.48,396.98c-2.86,2.56-6.55,6.66-10.05,9.01c0.49,5.42,3.37,9.59,6.66,9.44c3.45-0.16,6.03-4.99,5.77-10.8 C310.72,401.57,309.81,398.85,308.48,396.98z M303.5,410.48c-1.06,0-1.92-1.32-1.92-2.96c0-1.63,0.86-2.96,1.92-2.96 c1.06,0,1.92,1.32,1.92,2.96C305.43,409.15,304.57,410.48,303.5,410.48z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M254.06,449.02c2.54-1.57,5.12-3.07,7.79-4.43c1.34-0.68,2.69-1.34,4.1-1.91c0.72-0.28,1.42-0.56,2.23-0.74 c0.22-0.04,0.35-0.11,0.68-0.12c0.27-0.01,0.48,0.01,0.69,0.03c0.42,0.05,0.81,0.11,1.19,0.19c1.52,0.3,2.96,0.73,4.37,1.25 l4.22,1.52c2.8,1.04,5.58,2.11,8.36,3.2c5.55,2.18,11.07,4.42,16.58,6.67l8.27,3.36c2.74,1.09,5.55,2.28,8.24,3.19l-1.26,0.72 c0.25-1.07,0.28-2.32,0.24-3.54c-0.05-1.23-0.18-2.48-0.36-3.72c-0.37-2.48-0.93-4.95-1.61-7.38c-0.69-2.43-1.51-4.82-2.47-7.15 c-0.97-2.31-2.05-4.66-3.37-6.69c-2.81-4.13-6.29-7.93-9.75-11.65c-3.5-3.71-7.13-7.31-10.86-10.8 c-3.72-3.49-7.56-6.87-11.54-10.01c-0.97-0.81-1.96-1.6-2.98-2.33c-0.51-0.37-1.02-0.72-1.54-1.03c-0.51-0.31-1.07-0.6-1.53-0.71 c-0.3-0.11-0.76,0.13-1.23,0.49c-0.46,0.35-0.89,0.79-1.31,1.24c-0.83,0.92-1.59,1.94-2.32,2.97c-2.9,4.17-5.41,8.66-7.85,13.16 c-2.43,4.51-4.77,9.07-7,13.69c2.05-4.7,4.2-9.36,6.47-13.96c2.3-4.59,4.65-9.16,7.46-13.5c0.71-1.08,1.46-2.15,2.31-3.16 c0.43-0.5,0.88-1,1.43-1.45c0.27-0.23,0.57-0.44,0.94-0.61c0.18-0.09,0.39-0.16,0.62-0.2c0.25-0.04,0.48-0.03,0.7-0.01 c0.81,0.14,1.41,0.43,2.03,0.72c0.6,0.3,1.18,0.63,1.74,0.97c1.12,0.68,2.2,1.42,3.26,2.17c4.12,3.15,7.93,6.61,11.71,10.11 c3.75,3.52,7.41,7.14,10.95,10.89c1.77,1.88,3.5,3.78,5.18,5.75c1.68,1.97,3.32,3.97,4.78,6.17c1.46,2.28,2.53,4.61,3.54,7.03 c0.99,2.41,1.84,4.87,2.55,7.37c0.71,2.5,1.28,5.05,1.67,7.63c0.19,1.29,0.33,2.6,0.38,3.93c0.04,1.33,0.04,2.67-0.29,4.1 l-0.25,1.06l-1.01-0.34c-2.95-1-5.63-2.15-8.42-3.25l-8.28-3.37c-5.51-2.25-11.03-4.48-16.56-6.66c-5.51-2.18-11.13-4.3-16.67-6.06 c-0.34-0.11-0.68-0.2-1-0.27c-0.37-0.07-0.45-0.09-0.84-0.03c-0.66,0.08-1.37,0.27-2.06,0.47c-1.39,0.41-2.78,0.93-4.16,1.47 C259.5,446.58,256.77,447.77,254.06,449.02z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M339.52,425.68c0.11-0.16,0.15-0.18,0.21-0.24c0.06-0.06,0.11-0.09,0.16-0.13c0.1-0.08,0.2-0.15,0.29-0.19 c0.2-0.12,0.37-0.18,0.56-0.25c0.36-0.12,0.71-0.18,1.05-0.22c0.67-0.07,1.31-0.04,1.93,0.03c1.24,0.14,2.4,0.45,3.54,0.8 c1.14,0.36,2.25,0.77,3.33,1.24c1.09,0.45,2.15,0.96,3.21,1.45c-1.12-0.34-2.24-0.7-3.37-0.98c-1.13-0.3-2.27-0.55-3.4-0.74 c-1.13-0.18-2.28-0.32-3.38-0.28c-0.55,0.01-1.09,0.07-1.57,0.19c-0.24,0.06-0.46,0.14-0.64,0.23c-0.08,0.05-0.18,0.1-0.22,0.15 c-0.03,0.02-0.06,0.05-0.06,0.06c-0.01,0.01-0.02,0.02-0.01,0.01c0.01-0.01-0.01,0.02,0.06-0.08L339.52,425.68z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M341.94,424.24c0.21-0.3,0.45-0.79,0.63-1.23c0.2-0.45,0.36-0.93,0.51-1.42c0.29-0.97,0.49-1.99,0.63-3.01 c0.14-1.03,0.19-2.08,0.21-3.13c0.01-1.05-0.05-2.11-0.14-3.17c0.25,1.03,0.48,2.07,0.64,3.13c0.15,1.06,0.27,2.13,0.29,3.21 c0.02,1.08-0.02,2.18-0.16,3.28c-0.08,0.55-0.17,1.1-0.31,1.65c-0.14,0.57-0.28,1.06-0.57,1.7L341.94,424.24z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M359.23,408.73c0.16-0.32,0.32-0.87,0.41-1.35c0.11-0.5,0.16-1.02,0.2-1.54c0.07-1.05-0.01-2.12-0.16-3.19 c-0.15-1.07-0.43-2.13-0.75-3.18c-0.17-0.52-0.37-1.03-0.55-1.56l-0.66-1.52l0.88,1.42c0.26,0.49,0.55,0.97,0.79,1.48 c0.48,1.01,0.94,2.05,1.27,3.14c0.33,1.09,0.58,2.22,0.69,3.39c0.05,0.58,0.07,1.17,0.04,1.77c-0.04,0.62-0.6,1.03-0.81,1.76 L359.23,408.73z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M362.94,403.96c1.01,0.16,2.12,0.25,3.2,0.28c1.09,0.03,2.18-0.01,3.27-0.1c1.09-0.09,2.17-0.28,3.24-0.54 c1.07-0.25,2.11-0.64,3.14-1.09c-0.94,0.6-1.93,1.14-2.98,1.56c-1.05,0.42-2.13,0.79-3.23,1.05c-1.1,0.27-2.23,0.48-3.36,0.62 c-1.15,0.14-2.26,0.22-3.47,0.21L362.94,403.96z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        className: "st14",
        d: "M344.03,417.9c-3.42,0.24-5.05-8.94-7.08-19.54c-1.22-6.35-2.44-13.44-1.47-21.01 c1.47-0.49,10.02,15.64,10.99,20.03C347.45,401.78,347.45,417.66,344.03,417.9z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        className: "st14",
        d: "M359.42,400.56c-6.35-1.47-13.19-32.25-10.99-35.91C352.82,366.11,365.77,395.92,359.42,400.56z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        className: "st14",
        d: "M367.72,404.22c0,0,8.79-13.19,31.76-10.26C398.26,399.83,371.39,414.48,367.72,404.22z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        className: "st14",
        d: "M347.2,425.72c0,0,4.15,9.53,16.12,9.28c11.97-0.24,26.63-7.82,26.87-11.24c-1.71-1.22-15.6,4.23-24.92,2.2 C355.92,423.93,347.2,425.72,347.2,425.72z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M292.79,408.06c3.51,2.95,7,5.94,10.38,9.06c1.69,1.56,3.36,3.14,5.02,4.75c1.64,1.64,3.33,3.2,4.69,5.24l-1.01-0.44 c0.72-0.11,1.45-0.4,2.11-0.89c0.67-0.48,1.29-1.1,1.85-1.79c1.12-1.38,2.09-2.99,2.94-4.67l0.19,0.06 c-0.12,0.96-0.39,1.88-0.68,2.8c-0.32,0.92-0.72,1.81-1.22,2.67c-0.52,0.85-1.12,1.68-1.93,2.37c-0.79,0.7-1.8,1.27-2.94,1.47 l-0.6,0.11l-0.41-0.55c-1.28-1.7-2.74-3.49-4.23-5.2c-1.51-1.71-3.08-3.37-4.66-5.02c-3.19-3.28-6.36-6.59-9.62-9.82L292.79,408.06 z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("g", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M305.69,456.45c-0.75,1.22-1.48,2.46-2.16,3.71c-2.69,5.01-4.82,10.33-6.29,15.85c-0.73,2.76-1.3,5.57-1.67,8.41 c-0.18,1.42-0.33,2.85-0.41,4.29c-0.07,1.46-0.13,2.84-0.03,4.43l3.98-0.35c-0.1-1.18-0.09-2.59-0.05-3.9 c0.05-1.34,0.15-2.68,0.29-4.02c0.29-2.68,0.76-5.35,1.4-7.98c1.27-5.27,3.19-10.38,5.65-15.23c0.71-1.37,1.47-2.71,2.26-4.03 L305.69,456.45z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M370.06,388.01c-0.84,2.61-1.91,5.18-3.06,7.68c-0.56,1.26-1.22,2.48-1.84,3.71c-0.69,1.19-1.3,2.43-2.06,3.59 c-2.87,4.7-6.19,9.13-10.11,12.95c-0.94,1-1.99,1.87-3.03,2.76c-0.53,0.44-1.02,0.91-1.57,1.31l-1.66,1.19l-1.66,1.19l-1.76,1.03 c-1.17,0.69-2.34,1.38-3.59,2.06c-4.94,2.66-9.7,5.69-14.15,9.15c-2.98,2.31-5.81,4.82-8.49,7.49c0.4,0.97,0.78,1.98,1.07,2.85 c2.78-3,5.79-5.79,8.98-8.38c4.25-3.47,8.85-6.53,13.64-9.26c1.18-0.67,2.4-1.42,3.61-2.16l1.82-1.11l1.71-1.27l1.7-1.27 c0.56-0.43,1.07-0.93,1.61-1.39c1.06-0.94,2.13-1.86,3.08-2.91c3.95-4.04,7.31-8.62,10.05-13.52c0.72-1.2,1.3-2.49,1.96-3.73 c0.58-1.28,1.21-2.53,1.73-3.83c1.1-2.58,2.03-5.22,2.74-7.95L370.06,388.01z"
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M228.47,407.89c-0.01-0.29,0.03-0.94,0-1.22c-3.52-2.29-8.63-5.55-11.66-7.57c-0.63,2.35-1.02,5.35-0.62,8.56 c0.68,5.36,3.39,9.64,6.42,9.88C227.13,417.9,228.7,413.52,228.47,407.89z M221.96,411.66c-1.06,0-1.92-1.32-1.92-2.96 c0-1.63,0.86-2.96,1.92-2.96c1.06,0,1.92,1.32,1.92,2.96C223.88,410.33,223.02,411.66,221.96,411.66z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        className: "st14",
        d: "M384.42,360.74c-4.4,7.82-18.08,14.01-20.68,18.73c-2.61,4.72,7.03,8.72,7.03,8.72s7.94,3.47,9.75,1.05 C386.05,381.82,383.12,373.74,384.42,360.74z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("polygon", {
        className: "st14",
        points: "377.09,382.6 371.88,379.63 378.81,374.36  "
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("polygon", {
        points: "375.3,381.58 375.79,390.1 377.66,382.42  "
    })));
}

},{"@adobe/spectrum-css-temp/components/asset/vars.css":"eyymK","..":"4GreE","@react-spectrum/utils":"cMIJ6","@react-spectrum/view":"dnRjt","../stories/Card.stories":"6Z2Qc","@react-spectrum/text":"etCGI","@react-spectrum/illustratedmessage":"cV05z","@react-spectrum/image":"2GFZF","react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"eyymK":[function(require,module,exports) {
module.exports["focus-ring"] = `QSGf6W_focus-ring`;
module.exports["i18nFontFamily"] = `QSGf6W_i18nFontFamily`;
module.exports["spectrum-Asset"] = `QSGf6W_spectrum-Asset`;
module.exports["spectrum-Asset-file"] = `QSGf6W_spectrum-Asset-file`;
module.exports["spectrum-Asset-fileBackground"] = `QSGf6W_spectrum-Asset-fileBackground`;
module.exports["spectrum-Asset-fileOutline"] = `QSGf6W_spectrum-Asset-fileOutline`;
module.exports["spectrum-Asset-folder"] = `QSGf6W_spectrum-Asset-folder`;
module.exports["spectrum-Asset-folderBackground"] = `QSGf6W_spectrum-Asset-folderBackground`;
module.exports["spectrum-Asset-folderOutline"] = `QSGf6W_spectrum-Asset-folderOutline`;
module.exports["spectrum-Asset-image"] = `QSGf6W_spectrum-Asset-image`;
module.exports["spectrum-FocusRing-ring"] = `QSGf6W_spectrum-FocusRing-ring`;
module.exports["spectrum-FocusRing"] = `QSGf6W_spectrum-FocusRing ${module.exports["spectrum-FocusRing-ring"]}`;
module.exports["spectrum-FocusRing--quiet"] = `QSGf6W_spectrum-FocusRing--quiet`;

},{}],"i9TKx":[function(require,module,exports) {
/*
 * Copyright 2021 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CardGrid", ()=>CardGrid);
parcelHelpers.export(exports, "CardWaterfall", ()=>CardWaterfall);
parcelHelpers.export(exports, "CardGallery", ()=>CardGallery);
parcelHelpers.export(exports, "CardFloat", ()=>CardFloat);
parcelHelpers.export(exports, "CardGridNoDescription", ()=>CardGridNoDescription);
parcelHelpers.export(exports, "CardGridIllustrations", ()=>CardGridIllustrations);
parcelHelpers.export(exports, "CardGridLongTitle", ()=>CardGridLongTitle);
parcelHelpers.export(exports, "CardGridTallRows", ()=>CardGridTallRows);
parcelHelpers.export(exports, "CardGridMessyText", ()=>CardGridMessyText);
parcelHelpers.export(exports, "CardWaterfallMessyText", ()=>CardWaterfallMessyText);
parcelHelpers.export(exports, "CardGalleryMessyText", ()=>CardGalleryMessyText);
var _index = require("../index");
var _utils = require("@react-spectrum/utils");
var _view = require("@react-spectrum/view");
var _cardChromatic = require("../chromatic/Card.chromatic");
var _utils1 = require("../stories/utils");
var _text = require("@react-spectrum/text");
var _image = require("@react-spectrum/image");
var _quietCardChromatic = require("../chromatic/QuietCard.chromatic");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _varsCss = require("@adobe/spectrum-css-temp/components/card/vars.css");
var _varsCssDefault = parcelHelpers.interopDefault(_varsCss);
exports.default = {
    title: "Card/quiet",
    component: (0, _index.Card),
    args: {
        isQuiet: true
    },
    argTypes: {
        layout: {
            table: {
                disable: true
            }
        },
        children: {
            table: {
                disable: true
            }
        },
        isQuiet: {
            table: {
                disable: true
            }
        }
    }
};
const CardGrid = {
    render: (args, context)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index.Card), {
            ...args,
            ...context,
            id: null
        }),
    args: {
        ...(0, _quietCardChromatic.Quiet).args,
        layout: "grid"
    },
    decorators: [
        (Story, context)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(CardGridDecorator, {
                Story: Story,
                context: context
            })
    ]
};
let CardGridDecorator = (props)=>{
    let { Story, context } = props;
    let { args } = context;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        style: {
            width: "100%",
            margin: "50px",
            display: "grid",
            gap: "20px",
            gridTemplateColumns: "repeat(auto-fit, 208px)",
            gridAutoRows: "305px"
        }
    }, new Array(15).fill(0).map((_, index)=>{
        let url = (0, _utils1.getImage)(index);
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(Story, {
            ...args,
            key: `${index}${url}`
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _image.Image), {
            src: url
        }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Heading), null, "Title ", index), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), {
            slot: "detail"
        }, "PNG"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Content), null, "Description"));
    }));
};
const CardWaterfall = {
    render: (args, context)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index.Card), {
            ...args,
            ...context,
            id: null
        }),
    args: {
        ...(0, _quietCardChromatic.Quiet).args,
        layout: "waterfall"
    },
    decorators: [
        (Story, context)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(CardWaterfallDecorator, {
                Story: Story,
                context: context
            })
    ]
};
const CardWaterfallDecorator = (props)=>{
    let { Story, context } = props;
    let { args } = context;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        style: {
            width: "100%",
            height: "150vh",
            margin: "50px",
            display: "flex",
            flexDirection: "column",
            flexWrap: "wrap",
            alignItems: "start"
        }
    }, new Array(15).fill(0).map((_, index)=>{
        let url = (0, _utils1.getImage)(index);
        return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
            style: {
                width: "208px",
                margin: "10px"
            },
            key: `${index}${url}`
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Story, args, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _image.Image), {
            src: url
        }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Heading), null, "Title ", index), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), {
            slot: "detail"
        }, "PNG"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Content), null, (0, _utils1.getDescription)(index))));
    }));
};
const CardGallery = {
    render: (args, context)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index.Card), {
            ...args,
            ...context,
            id: null
        }),
    args: {
        ...(0, _quietCardChromatic.Quiet).args,
        layout: "gallery"
    },
    decorators: [
        (Story, context)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(CardGalleryDecorator, {
                Story: Story,
                context: context
            })
    ]
};
const CardGalleryDecorator = (props)=>{
    let { Story, context } = props;
    let { args } = context;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        style: {
            width: "100%",
            margin: "50px",
            display: "flex",
            flexDirection: "row",
            flexWrap: "wrap"
        }
    }, new Array(15).fill(0).map((_, index)=>{
        let url = (0, _utils1.getImage)(index);
        return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
            style: {
                height: "339px",
                margin: "10px"
            },
            key: `${index}${url}`
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Story, args, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _image.Image), {
            src: url
        }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Heading), null, "Title ", index), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), {
            slot: "detail"
        }, "PNG"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Content), null, "Description")));
    }));
};
const CardFloat = {
    render: (args, context)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index.Card), {
            ...args,
            ...context,
            id: null
        }),
    args: {
        ...(0, _quietCardChromatic.Quiet).args
    },
    decorators: [
        (Story, context)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(CardFloatDecorator, {
                Story: Story,
                context: context
            })
    ]
};
const CardFloatDecorator = (props)=>{
    let { Story, context } = props;
    let { args } = context;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        style: {
            width: "100%",
            margin: "50px"
        }
    }, new Array(15).fill(0).map((_, index)=>{
        let url = (0, _utils1.getImage)(index);
        return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
            style: {
                float: "left",
                margin: "10px"
            },
            key: `${index}${url}`
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Story, args, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _image.Image), {
            src: url
        }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Heading), null, "Title ", index), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), {
            slot: "detail"
        }, "PNG"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Content), null, "Description")));
    }));
};
const CardGridNoDescription = {
    render: (args, context)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index.Card), {
            ...args,
            ...context,
            id: null
        }),
    args: {
        ...(0, _quietCardChromatic.Quiet).args,
        layout: "grid"
    },
    decorators: [
        (Story, context)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(CardGridNoDescriptionDecorator, {
                Story: Story,
                context: context
            })
    ]
};
const CardGridNoDescriptionDecorator = (props)=>{
    let { Story, context } = props;
    let { args } = context;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-CardGrid"),
        style: {
            width: "100%",
            margin: "50px",
            display: "grid",
            gap: "20px",
            gridTemplateColumns: "repeat(auto-fit, 208px)",
            gridAutoRows: "274px"
        }
    }, new Array(15).fill(0).map((_, index)=>{
        let url = (0, _utils1.getImage)(index);
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(Story, {
            ...args,
            key: `${index}${url}`
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _image.Image), {
            src: url
        }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Heading), null, "Title ", index), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), {
            slot: "detail"
        }, "PNG"));
    }));
};
const CardGridIllustrations = {
    render: (args, context)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index.Card), {
            ...args,
            ...context,
            id: null
        }),
    args: {
        ...(0, _quietCardChromatic.Quiet).args,
        layout: "grid"
    },
    decorators: [
        (Story, context)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(CardGridIllustrationsDecorator, {
                Story: Story,
                context: context
            })
    ]
};
const CardGridIllustrationsDecorator = (props)=>{
    let { Story, context } = props;
    let { args } = context;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-CardGrid"),
        style: {
            width: "100%",
            margin: "50px",
            display: "grid",
            gap: "20px",
            gridTemplateColumns: "repeat(auto-fit, 208px)",
            gridAutoRows: "274px"
        }
    }, new Array(15).fill(0).map((_, index)=>{
        let url = (0, _utils1.getImage)(index);
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(Story, {
            ...args,
            key: `${index}${url}`
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _cardChromatic.File), {
            slot: "illustration",
            alt: "test illustration"
        }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Heading), null, "Title ", index), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), {
            slot: "detail"
        }, "PNG"));
    }));
};
const CardGridLongTitle = {
    render: (args, context)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index.Card), {
            ...args,
            ...context,
            id: null
        }),
    args: {
        ...(0, _quietCardChromatic.Quiet).args,
        layout: "grid"
    },
    decorators: [
        (Story, context)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(CardGridLongTitleDecorator, {
                Story: Story,
                context: context
            })
    ]
};
const CardGridLongTitleDecorator = (props)=>{
    let { Story, context } = props;
    let { args } = context;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-CardGrid"),
        style: {
            width: "100%",
            margin: "50px",
            display: "grid",
            gap: "20px",
            gridTemplateColumns: "repeat(auto-fit, 208px)",
            gridAutoRows: "305px"
        }
    }, new Array(15).fill(0).map((_, index)=>{
        let url = (0, _utils1.getImage)(index);
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(Story, {
            ...args,
            key: `${index}${url}`
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _image.Image), {
            src: url
        }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Heading), null, "This is a long title about how dinosaurs used to rule the earth before a meteor came and wiped them all out ", index), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), {
            slot: "detail"
        }, "PNG"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Content), null, "Description"));
    }));
};
const CardGridTallRows = {
    render: (args, context)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index.Card), {
            ...args,
            ...context,
            id: null
        }),
    args: {
        ...(0, _quietCardChromatic.Quiet).args,
        layout: "grid"
    },
    decorators: [
        (Story, context)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(CardGridTallRowsDecorator, {
                Story: Story,
                context: context
            })
    ]
};
const CardGridTallRowsDecorator = (props)=>{
    let { Story, context } = props;
    let { args } = context;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-CardGrid"),
        style: {
            width: "100%",
            margin: "50px",
            display: "grid",
            gap: "20px",
            gridTemplateColumns: "repeat(auto-fit, 208px)",
            gridAutoRows: "400px"
        }
    }, new Array(15).fill(0).map((_, index)=>{
        let url = (0, _utils1.getImage)(index);
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(Story, {
            ...args,
            key: `${index}${url}`
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _image.Image), {
            src: url
        }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Heading), null, "Title ", index), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), {
            slot: "detail"
        }, "PNG"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Content), null, "Description"));
    }));
};
const CardGridMessyText = {
    render: (args, context)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index.Card), {
            ...args,
            ...context,
            id: null
        }),
    args: {
        ...(0, _quietCardChromatic.Quiet).args,
        layout: "grid"
    },
    decorators: [
        (Story, context)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(CardGridMessyTextDecorator, {
                Story: Story,
                context: context
            })
    ]
};
const CardGridMessyTextDecorator = (props)=>{
    let { Story, context } = props;
    let { args } = context;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        style: {
            width: "100%",
            margin: "50px",
            display: "grid",
            gap: "20px",
            gridTemplateColumns: "repeat(auto-fit, 208px)",
            gridAutoRows: "305px"
        }
    }, new Array(15).fill(0).map((_, index)=>{
        let url = (0, _utils1.getImage)(index);
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(Story, {
            ...args,
            key: `${index}${url}`
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _image.Image), {
            src: url
        }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Heading), null, index, " Rechtsschutzversicherungsgesellschaften Nahrungsmittelunvertr\xe4glichkeit Unabh\xe4ngigkeitserkl\xe4rungen Freundschaftsbeziehungen"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), {
            slot: "detail"
        }, "Rechtsschutzversicherungsgesellschaften Nahrungsmittelunvertr\xe4glichkeit Unabh\xe4ngigkeitserkl\xe4rungen Freundschaftsbeziehungen"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Content), null, "Rechtsschutzversicherungsgesellschaften Nahrungsmittelunvertr\xe4glichkeit Unabh\xe4ngigkeitserkl\xe4rungen Freundschaftsbeziehungen"));
    }));
};
const CardWaterfallMessyText = {
    render: (args, context)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index.Card), {
            ...args,
            ...context,
            id: null
        }),
    args: {
        ...(0, _quietCardChromatic.Quiet).args,
        layout: "waterfall"
    },
    decorators: [
        (Story, context)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(CardWaterfallMessyTextDecorator, {
                Story: Story,
                context: context
            })
    ]
};
const CardWaterfallMessyTextDecorator = (props)=>{
    let { Story, context } = props;
    let { args } = context;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        style: {
            width: "100%",
            height: "150vh",
            margin: "50px",
            display: "flex",
            flexDirection: "column",
            flexWrap: "wrap",
            alignItems: "start"
        }
    }, new Array(15).fill(0).map((_, index)=>{
        let url = (0, _utils1.getImage)(index);
        return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
            style: {
                width: "208px",
                margin: "10px"
            },
            key: `${index}${url}`
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Story, args, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _image.Image), {
            src: url
        }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Heading), null, index, " Rechtsschutzversicherungsgesellschaften Nahrungsmittelunvertr\xe4glichkeit Unabh\xe4ngigkeitserkl\xe4rungen Freundschaftsbeziehungen"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), {
            slot: "detail"
        }, "Rechtsschutzversicherungsgesellschaften Nahrungsmittelunvertr\xe4glichkeit Unabh\xe4ngigkeitserkl\xe4rungen Freundschaftsbeziehungen"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Content), null, "Rechtsschutzversicherungsgesellschaften Nahrungsmittelunvertr\xe4glichkeit Unabh\xe4ngigkeitserkl\xe4rungen Freundschaftsbeziehungen")));
    }));
};
const CardGalleryMessyText = {
    render: (args, context)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index.Card), {
            ...args,
            ...context,
            id: null
        }),
    args: {
        ...(0, _quietCardChromatic.Quiet).args,
        layout: "gallery"
    },
    decorators: [
        (Story, context)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(CardGalleryMessyTextDecorator, {
                Story: Story,
                context: context
            })
    ],
    parameters: {
        description: {
            data: "ignore extra horizontal space, it will not do this in a real gallery layout"
        }
    }
};
const CardGalleryMessyTextDecorator = (props)=>{
    let { Story, context } = props;
    let { args } = context;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        style: {
            width: "100%",
            margin: "50px",
            display: "flex",
            flexDirection: "row",
            flexWrap: "wrap"
        }
    }, new Array(15).fill(0).map((_, index)=>{
        let url = (0, _utils1.getImage)(index);
        return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
            style: {
                height: "339px",
                margin: "10px"
            },
            key: `${index}${url}`
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Story, args, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _image.Image), {
            src: url
        }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Heading), null, index, " Rechtsschutzversicherungsgesellschaften Nahrungsmittelunvertr\xe4glichkeit Unabh\xe4ngigkeitserkl\xe4rungen Freundschaftsbeziehungen"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), {
            slot: "detail"
        }, "Rechtsschutzversicherungsgesellschaften Nahrungsmittelunvertr\xe4glichkeit Unabh\xe4ngigkeitserkl\xe4rungen Freundschaftsbeziehungen"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Content), null, "Rechtsschutzversicherungsgesellschaften Nahrungsmittelunvertr\xe4glichkeit Unabh\xe4ngigkeitserkl\xe4rungen Freundschaftsbeziehungen")));
    }));
};

},{"../index":"4GreE","@react-spectrum/utils":"cMIJ6","@react-spectrum/view":"dnRjt","../chromatic/Card.chromatic":"3yxBm","../stories/utils":"aSOMD","@react-spectrum/text":"etCGI","@react-spectrum/image":"2GFZF","../chromatic/QuietCard.chromatic":"lY18b","react":"9yzVZ","@adobe/spectrum-css-temp/components/card/vars.css":"ibpeR","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"lY18b":[function(require,module,exports) {
/*
 * Copyright 2021 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Quiet", ()=>Quiet);
parcelHelpers.export(exports, "QuietSquare", ()=>QuietSquare);
parcelHelpers.export(exports, "QuietTall", ()=>QuietTall);
parcelHelpers.export(exports, "QuietNoDescription", ()=>QuietNoDescription);
parcelHelpers.export(exports, "QuietNoDescriptionSquare", ()=>QuietNoDescriptionSquare);
parcelHelpers.export(exports, "QuietWithIllustration", ()=>QuietWithIllustration);
parcelHelpers.export(exports, "QuietLongTitle", ()=>QuietLongTitle);
parcelHelpers.export(exports, "QuietLongDescription", ()=>QuietLongDescription);
parcelHelpers.export(exports, "QuietLongContentPoorWordSize", ()=>QuietLongContentPoorWordSize);
parcelHelpers.export(exports, "QuietLongDetail", ()=>QuietLongDetail);
parcelHelpers.export(exports, "QuietLongEverything", ()=>QuietLongEverything);
parcelHelpers.export(exports, "QuietSelected", ()=>QuietSelected);
var _index = require("../index");
var _cardChromatic = require("./Card.chromatic");
exports.default = {
    title: "Card/quiet",
    component: (0, _index.Card),
    args: {
        isQuiet: true
    }
};
const Quiet = {
    ...(0, _cardChromatic.Default)
};
const QuietSquare = {
    ...(0, _cardChromatic.DefaultSquare)
};
const QuietTall = {
    ...(0, _cardChromatic.DefaultTall)
};
const QuietNoDescription = {
    ...(0, _cardChromatic.NoDescription)
};
const QuietNoDescriptionSquare = {
    ...(0, _cardChromatic.NoDescriptionSquare)
};
const QuietWithIllustration = {
    ...(0, _cardChromatic.WithIllustration)
};
const QuietLongTitle = {
    ...(0, _cardChromatic.LongTitle)
};
const QuietLongDescription = {
    ...(0, _cardChromatic.LongDescription)
};
const QuietLongContentPoorWordSize = {
    ...(0, _cardChromatic.LongContentPoorWordSize)
};
const QuietLongDetail = {
    ...(0, _cardChromatic.LongDetail)
};
const QuietLongEverything = {
    ...(0, _cardChromatic.LongEverything)
};
const QuietSelected = {
    ...(0, _cardChromatic.Selected),
    name: "Selected"
};

},{"../index":"4GreE","./Card.chromatic":"3yxBm","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"71boN":[function(require,module,exports) {
/*
 * Copyright 2021 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DefaultWaterfallStatic", ()=>DefaultWaterfallStatic);
parcelHelpers.export(exports, "FalsyIdWaterfall", ()=>FalsyIdWaterfall);
parcelHelpers.export(exports, "DefaultWaterfall", ()=>DefaultWaterfall);
parcelHelpers.export(exports, "DefaultWaterfallNoSize", ()=>DefaultWaterfallNoSize);
parcelHelpers.export(exports, "QuietWaterfall", ()=>QuietWaterfall);
parcelHelpers.export(exports, "QuietWaterfallNoSize", ()=>QuietWaterfallNoSize);
parcelHelpers.export(exports, "DisabledKeysWaterfall", ()=>DisabledKeysWaterfall);
parcelHelpers.export(exports, "SelectedKeys", ()=>SelectedKeys);
parcelHelpers.export(exports, "IsLoadingNoHeightWaterfall", ()=>IsLoadingNoHeightWaterfall);
parcelHelpers.export(exports, "IsLoadingHeightWaterfall", ()=>IsLoadingHeightWaterfall);
parcelHelpers.export(exports, "LoadingMoreWaterfall", ()=>LoadingMoreWaterfall);
parcelHelpers.export(exports, "FilteringWaterfall", ()=>FilteringWaterfall);
parcelHelpers.export(exports, "EmptyWithHeightWaterfall", ()=>EmptyWithHeightWaterfall);
parcelHelpers.export(exports, "AsyncLoadingWaterfall", ()=>AsyncLoadingWaterfall);
parcelHelpers.export(exports, "CustomLayoutOptions", ()=>CustomLayoutOptions);
var _gridCardViewStories = require("./GridCardView.stories");
var _ = require("../");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _virtualizer = require("@react-stately/virtualizer");
var _i18N = require("@react-aria/i18n");
let itemsNoSize = [
    {
        src: "https://i.imgur.com/Z7AzH2c.jpg",
        title: "Bob 1"
    },
    {
        src: "https://i.imgur.com/DhygPot.jpg",
        title: "Joe 1 really really really really really really really really really really really really long"
    },
    {
        src: "https://i.imgur.com/L7RTlvI.png",
        title: "Jane 1"
    },
    {
        src: "https://i.imgur.com/1nScMIH.jpg",
        title: "Bob 2"
    },
    {
        src: "https://i.imgur.com/DhygPot.jpg",
        title: "Joe 2"
    },
    {
        src: "https://i.imgur.com/1nScMIH.jpg",
        title: "Jane 2"
    },
    {
        src: "https://i.imgur.com/Z7AzH2c.jpg",
        title: "Bob 3"
    },
    {
        src: "https://i.imgur.com/L7RTlvI.png",
        title: "Joe 3"
    },
    {
        src: "https://i.imgur.com/zzwWogn.jpg",
        title: "Jane 3"
    },
    {
        src: "https://i.imgur.com/1nScMIH.jpg",
        title: "Bob 4"
    },
    {
        src: "https://i.imgur.com/L7RTlvI.png",
        title: "Joe 4"
    },
    {
        src: "https://i.imgur.com/Z7AzH2c.jpg",
        title: "Jane 4"
    },
    {
        src: "https://i.imgur.com/L7RTlvI.png",
        title: "Bob 5"
    },
    {
        src: "https://i.imgur.com/1nScMIH.jpg",
        title: "Joe 5"
    },
    {
        src: "https://i.imgur.com/L7RTlvI.png",
        title: "Jane 5"
    },
    {
        src: "https://i.imgur.com/1nScMIH.jpg",
        title: "Bob 6"
    },
    {
        src: "https://i.imgur.com/zzwWogn.jpg",
        title: "Joe 6"
    },
    {
        src: "https://i.imgur.com/DhygPot.jpg",
        title: "Jane 6"
    },
    {
        src: "https://i.imgur.com/L7RTlvI.png",
        title: "Bob 7"
    },
    {
        src: "https://i.imgur.com/Z7AzH2c.jpg",
        title: "Joe 7"
    },
    {
        src: "https://i.imgur.com/1nScMIH.jpg",
        title: "Jane 7"
    },
    {
        src: "https://i.imgur.com/zzwWogn.jpg",
        title: "Bob 8"
    }
];
// TODO: accessibility failures regarding article element with role="gridcell", will need to double check when we pick CardView back up
exports.default = {
    title: "CardView/Waterfall layout",
    component: (0, _.CardView),
    parameters: {
        chromatic: {
            delay: 300
        }
    },
    args: {
        "aria-label": "Test CardView"
    },
    argTypes: {
        layout: {
            table: {
                disable: true
            }
        },
        selectionMode: {
            control: "radio",
            defaultValue: "multiple",
            options: [
                "none",
                "single",
                "multiple"
            ]
        }
    }
};
const DefaultWaterfallStatic = {
    ...(0, _gridCardViewStories.StaticCards),
    args: {
        ...(0, _gridCardViewStories.StaticCards).args,
        layout: (0, _.WaterfallLayout)
    }
};
const FalsyIdWaterfall = {
    ...(0, _gridCardViewStories.FalsyIds),
    args: {
        ...(0, _gridCardViewStories.FalsyIds).args,
        layout: (0, _.WaterfallLayout)
    }
};
const DefaultWaterfall = {
    ...(0, _gridCardViewStories.DynamicCards),
    args: {
        ...(0, _gridCardViewStories.DynamicCards).args,
        layout: (0, _.WaterfallLayout)
    },
    name: "size provided with items"
};
const DefaultWaterfallNoSize = {
    ...(0, _gridCardViewStories.DynamicCards),
    args: {
        ...(0, _gridCardViewStories.DynamicCards).args,
        layout: (0, _.WaterfallLayout),
        items: itemsNoSize
    },
    name: "no size provided with items"
};
const QuietWaterfall = {
    ...(0, _gridCardViewStories.DynamicCards),
    args: {
        ...(0, _gridCardViewStories.DynamicCards).args,
        layout: (0, _.WaterfallLayout),
        isQuiet: true
    },
    name: "quiet cards"
};
const QuietWaterfallNoSize = {
    ...(0, _gridCardViewStories.DynamicCards),
    args: {
        ...(0, _gridCardViewStories.DynamicCards).args,
        layout: (0, _.WaterfallLayout),
        isQuiet: true,
        items: itemsNoSize
    },
    name: "quiet cards, no size provided with items"
};
const DisabledKeysWaterfall = {
    ...(0, _gridCardViewStories.DisabledKeys),
    args: {
        ...(0, _gridCardViewStories.DisabledKeys).args,
        layout: (0, _.WaterfallLayout)
    }
};
const SelectedKeys = {
    ...(0, _gridCardViewStories.ControlledCards),
    args: {
        ...(0, _gridCardViewStories.ControlledCards).args,
        layout: (0, _.WaterfallLayout)
    }
};
const IsLoadingNoHeightWaterfall = {
    ...(0, _gridCardViewStories.IsLoadingNoHeightGrid),
    args: {
        ...(0, _gridCardViewStories.IsLoadingNoHeightGrid).args,
        layout: (0, _.WaterfallLayout)
    }
};
const IsLoadingHeightWaterfall = {
    ...(0, _gridCardViewStories.IsLoadingHeightGrid),
    args: {
        ...(0, _gridCardViewStories.IsLoadingHeightGrid).args,
        layout: (0, _.WaterfallLayout)
    }
};
const LoadingMoreWaterfall = {
    ...(0, _gridCardViewStories.LoadingMoreGrid),
    args: {
        ...(0, _gridCardViewStories.LoadingMoreGrid).args,
        layout: (0, _.WaterfallLayout)
    }
};
const FilteringWaterfall = {
    ...(0, _gridCardViewStories.FilteringGrid),
    args: {
        ...(0, _gridCardViewStories.FilteringGrid).args,
        layout: (0, _.WaterfallLayout)
    }
};
const EmptyWithHeightWaterfall = {
    ...(0, _gridCardViewStories.EmptyWithHeightGrid),
    args: {
        ...(0, _gridCardViewStories.EmptyWithHeightGrid).args,
        layout: (0, _.WaterfallLayout)
    }
};
const AsyncLoadingWaterfall = {
    ...(0, _gridCardViewStories.AsyncLoading),
    args: {
        ...(0, _gridCardViewStories.AsyncLoading).args,
        layout: (0, _.WaterfallLayout)
    }
};
const CustomLayoutOptions = {
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(CustomWaterfallLayout, args),
    args: {
        selectionMode: "multiple",
        items: itemsNoSize,
        layoutOptions: {
            minSpace: new (0, _virtualizer.Size)(50, 50),
            maxColumns: 2,
            margin: 10
        }
    },
    name: "Custom layout options"
};
function CustomWaterfallLayout(props) {
    let { layoutOptions, ...otherProps } = props;
    let collator = (0, _i18N.useCollator)({
        usage: "search",
        sensitivity: "base"
    });
    let galleryLayout = (0, _react.useMemo)(()=>new (0, _.WaterfallLayout)({
            collator,
            ...layoutOptions
        }), [
        collator,
        layoutOptions
    ]);
    return (0, _gridCardViewStories.CustomLayout)({
        ...otherProps,
        layout: galleryLayout
    });
}

},{"./GridCardView.stories":"kI5xv","../":"4GreE","react":"9yzVZ","@react-stately/virtualizer":"lVS5O","@react-aria/i18n":"411rg","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"achgo":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Default", ()=>Default);
parcelHelpers.export(exports, "CustomLabel", ()=>CustomLabel);
parcelHelpers.export(exports, "LongLabel", ()=>LongLabel);
parcelHelpers.export(exports, "NoLabel", ()=>NoLabel);
parcelHelpers.export(exports, "WHCM", ()=>WHCM);
var _addonActions = require("@storybook/addon-actions");
var _ = require("../");
var _layout = require("@react-spectrum/layout");
var _link = require("@react-spectrum/link");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
exports.default = {
    title: "Checkbox",
    component: (0, _.Checkbox),
    args: {
        onChange: (0, _addonActions.action)("onChange")
    },
    argTypes: {
        onChange: {
            table: {
                disable: true
            }
        },
        defaultSelected: {
            control: "boolean"
        },
        isSelected: {
            control: "boolean"
        },
        isIndeterminate: {
            control: "boolean"
        },
        isEmphasized: {
            control: "boolean"
        },
        isDisabled: {
            control: "boolean"
        },
        isReadOnly: {
            control: "boolean"
        },
        autoFocus: {
            control: "boolean"
        },
        isInvalid: {
            control: "boolean"
        }
    }
};
const Default = {
    render: (args)=>render(args)
};
const CustomLabel = {
    render: (args)=>renderCustomLabel(args)
};
const LongLabel = {
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Checkbox), args, "Super long checkbox label. Sample text. Arma virumque cano, Troiae qui primus ab oris. Italiam, fato profugus, Laviniaque venit.")
};
const NoLabel = {
    render: (args)=>renderNoLabel(args)
};
const WHCM = {
    render: ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
            direction: "column",
            gap: "size-200"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
            gap: "size-200"
        }, "Shows the different states from ", /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _link.Link), null, /*#__PURE__*/ (0, _reactDefault.default).createElement("a", {
            href: "https://spectrum.adobe.com/static/Windows-High-Contrast-Kits/Checkbox-WindowsHighContrast.xd"
        }, "spectrum"))), renderRow(), renderRow({
            isSelected: true,
            isEmphasized: true
        }), renderRow({
            isIndeterminate: true,
            isEmphasized: true
        }), renderRow({
            isSelected: true,
            isEmphasized: false
        }), renderRow({
            isIndeterminate: true,
            isEmphasized: false
        }), renderRow({
            isInvalid: true
        }), renderRow({
            isSelected: true,
            isInvalid: true
        }))
};
function render(props = {}) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Checkbox), props, "Checkbox Label");
}
function renderCustomLabel(props = {}) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Checkbox), props, /*#__PURE__*/ (0, _reactDefault.default).createElement("span", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("i", null, "Italicized"), " Checkbox Label"));
}
function renderNoLabel(props = {}) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Checkbox), {
        "aria-label": "checkbox with no visible label",
        ...props
    });
}
function renderRow(props = {}) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
        gap: "size-200"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Checkbox), props, "Option"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Checkbox), {
        isDisabled: true,
        ...props
    }, "Option"));
}

},{"@storybook/addon-actions":"coXbW","../":"hwzRp","@react-spectrum/layout":"hzaUY","@react-spectrum/link":"lNoiB","react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"hwzRp":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _src = require("./src");
parcelHelpers.exportAll(_src, exports);

},{"./src":"1r19j","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"llbGl":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Default", ()=>Default);
parcelHelpers.export(exports, "DefaultValue", ()=>DefaultValue);
parcelHelpers.export(exports, "ControlledValue", ()=>ControlledValue);
parcelHelpers.export(exports, "OneCheckboxDisabled", ()=>OneCheckboxDisabled);
parcelHelpers.export(exports, "TwoCheckboxDisabled", ()=>TwoCheckboxDisabled);
parcelHelpers.export(exports, "OneInvalidCheckbox", ()=>OneInvalidCheckbox);
parcelHelpers.export(exports, "FixedWidth", ()=>FixedWidth);
parcelHelpers.export(exports, "ContextualHelpStory", ()=>ContextualHelpStory);
parcelHelpers.export(exports, "AutoFocus", ()=>AutoFocus);
parcelHelpers.export(exports, "ControlledGroup", ()=>ControlledGroup);
var _addonActions = require("@storybook/addon-actions");
var _ = require("../");
var _reactSpectrum = require("@adobe/react-spectrum");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
exports.default = {
    title: "CheckboxGroup",
    component: (0, _.CheckboxGroup),
    args: {
        label: "Pets",
        onChange: (0, _addonActions.action)("onChange")
    },
    argTypes: {
        onChange: {
            table: {
                disable: true
            }
        },
        contextualHelp: {
            table: {
                disable: true
            }
        },
        defaultValue: {
            table: {
                disable: true
            }
        },
        value: {
            table: {
                disable: true
            }
        },
        isEmphasized: {
            control: "boolean"
        },
        isDisabled: {
            control: "boolean"
        },
        isReadOnly: {
            control: "boolean"
        },
        isRequired: {
            control: "boolean"
        },
        necessityIndicator: {
            control: "select",
            options: [
                "icon",
                "label"
            ]
        },
        labelPosition: {
            control: "select",
            options: [
                "top",
                "side"
            ]
        },
        labelAlign: {
            control: "select",
            options: [
                "start",
                "end"
            ]
        },
        isInvalid: {
            control: "boolean"
        },
        description: {
            control: "text"
        },
        errorMessage: {
            control: "text"
        },
        showErrorIcon: {
            control: "boolean"
        },
        orientation: {
            control: "select",
            options: [
                "horizontal",
                "vertical"
            ]
        },
        "aria-label": {
            control: "text"
        },
        name: {
            control: "text"
        }
    }
};
const Default = {
    render: (args)=>render(args)
};
const DefaultValue = {
    ...Default,
    args: {
        defaultValue: [
            "dragons"
        ]
    },
    name: "defaultValue: dragons"
};
const ControlledValue = {
    ...Default,
    args: {
        value: [
            "dragons"
        ]
    },
    name: "controlled: dragons"
};
const OneCheckboxDisabled = {
    render: (args)=>render(args, [
            {},
            {
                isDisabled: true
            },
            {}
        ]),
    name: "isDisabled on one checkbox"
};
const TwoCheckboxDisabled = {
    render: (args)=>render({
            ...args,
            defaultValue: [
                "dragons"
            ]
        }, [
            {},
            {
                isDisabled: true
            },
            {
                isDisabled: true
            }
        ]),
    name: "isDisabled two checkboxes and one checked"
};
const OneInvalidCheckbox = {
    render: (args)=>render(args, [
            {},
            {
                isInvalid: true
            },
            {}
        ]),
    name: 'validationState: "invalid" on one checkbox'
};
const FixedWidth = {
    render: (args)=>renderWithDescriptionErrorMessageAndValidation(args),
    name: "with description, error message and validation, fixed width"
};
const ContextualHelpStory = {
    ...Default,
    args: {
        contextualHelp: /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSpectrum.ContextualHelp), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSpectrum.Heading), null, "What is a segment?"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSpectrum.Content), null, "Segments identify who your visitors are, what devices and services they use, where they navigated from, and much more."))
    },
    name: "contextual help"
};
const AutoFocus = {
    render: (args)=>render(args, [
            {},
            {
                autoFocus: true
            },
            {}
        ]),
    name: "autoFocus on one checkbox"
};
const ControlledGroup = {
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(ControlledCheckboxGroup, args),
    name: "controlled"
};
function render(props = {}, checkboxProps = []) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.CheckboxGroup), {
        label: "Pets",
        ...props
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Checkbox), {
        value: "dogs",
        ...checkboxProps[0]
    }, "Dogs"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Checkbox), {
        value: "cats",
        ...checkboxProps[1]
    }, "Cats"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Checkbox), {
        value: "dragons",
        ...checkboxProps[2]
    }, "Dragons"));
}
function ControlledCheckboxGroup(props) {
    let [checked, setChecked] = (0, _react.useState)([]);
    let onChange = (value)=>{
        var _props_onChange;
        setChecked(value);
        props === null || props === void 0 ? void 0 : (_props_onChange = props.onChange) === null || _props_onChange === void 0 ? void 0 : _props_onChange.call(props, value);
    };
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.CheckboxGroup), {
        label: "Pets",
        ...props,
        onChange: onChange,
        value: checked
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Checkbox), {
        value: "dogs"
    }, "Dogs"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Checkbox), {
        value: "cats"
    }, "Cats"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Checkbox), {
        value: "dragons"
    }, "Dragons"));
}
function renderWithDescriptionErrorMessageAndValidation(props) {
    function Example(props) {
        let [checked, setChecked] = (0, _react.useState)([
            "dogs",
            "dragons"
        ]);
        let isValid = checked.length === 2 && checked.includes("dogs") && checked.includes("dragons");
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSpectrum.Flex), {
            width: "480px"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.CheckboxGroup), {
            ...props,
            label: "Pets",
            onChange: setChecked,
            value: checked,
            isInvalid: !isValid,
            description: "Select a pet.",
            errorMessage: checked.includes("cats") ? "No cats allowed." : "Select only dogs and dragons."
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Checkbox), {
            value: "dogs"
        }, "Dogs"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Checkbox), {
            value: "cats"
        }, "Cats"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Checkbox), {
            value: "dragons"
        }, "Dragons")));
    }
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Example, props);
}

},{"@storybook/addon-actions":"coXbW","../":"hwzRp","@adobe/react-spectrum":"cwANo","react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"4HlAn":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "XBlueYGreen", ()=>XBlueYGreen);
parcelHelpers.export(exports, "XGreenYBlue", ()=>XGreenYBlue);
parcelHelpers.export(exports, "XBlueYRed", ()=>XBlueYRed);
parcelHelpers.export(exports, "XRedYBlue", ()=>XRedYBlue);
parcelHelpers.export(exports, "XRedYGreen", ()=>XRedYGreen);
parcelHelpers.export(exports, "XGreenYRed", ()=>XGreenYRed);
parcelHelpers.export(exports, "XBlueYGreenisDisabled", ()=>XBlueYGreenisDisabled);
parcelHelpers.export(exports, "XBlueYGreenAriaLabelled", ()=>XBlueYGreenAriaLabelled);
parcelHelpers.export(exports, "XBlueYGreenSize3000", ()=>XBlueYGreenSize3000);
parcelHelpers.export(exports, "XBlueYGreenSize600", ()=>XBlueYGreenSize600);
parcelHelpers.export(exports, "XSaturationYLightness", ()=>XSaturationYLightness);
parcelHelpers.export(exports, "XLightnessYSaturation", ()=>XLightnessYSaturation);
parcelHelpers.export(exports, "XSaturationYLightnessisDisabled", ()=>XSaturationYLightnessisDisabled);
parcelHelpers.export(exports, "XHueYSaturationHSL", ()=>XHueYSaturationHSL);
parcelHelpers.export(exports, "XSaturationYHueHSL", ()=>XSaturationYHueHSL);
parcelHelpers.export(exports, "XHueYSaturationHSLisDisabled", ()=>XHueYSaturationHSLisDisabled);
parcelHelpers.export(exports, "XHueYLightnessHSL", ()=>XHueYLightnessHSL);
parcelHelpers.export(exports, "XLightnessYHueHSL", ()=>XLightnessYHueHSL);
parcelHelpers.export(exports, "XHueYLightnessHSLisDisabled", ()=>XHueYLightnessHSLisDisabled);
parcelHelpers.export(exports, "XSaturationYBrightness", ()=>XSaturationYBrightness);
parcelHelpers.export(exports, "XBrightnessYSaturation", ()=>XBrightnessYSaturation);
parcelHelpers.export(exports, "XSaturationYBrightnessisDisabled", ()=>XSaturationYBrightnessisDisabled);
parcelHelpers.export(exports, "XHueYSaturationHSB", ()=>XHueYSaturationHSB);
parcelHelpers.export(exports, "XSaturationYHueHS", ()=>XSaturationYHueHS);
parcelHelpers.export(exports, "XHueYSaturationHSBisDisabled", ()=>XHueYSaturationHSBisDisabled);
parcelHelpers.export(exports, "XHueYBrightnessHSB", ()=>XHueYBrightnessHSB);
parcelHelpers.export(exports, "XBrightnessYHueHSB", ()=>XBrightnessYHueHSB);
parcelHelpers.export(exports, "XBrightnessYHueHSBisDisabled", ()=>XBrightnessYHueHSBisDisabled);
var _addonActions = require("@storybook/addon-actions");
var _ = require("../");
var _reactSpectrum = require("@adobe/react-spectrum");
var _color = require("@react-stately/color");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const meta = {
    title: "ColorArea",
    component: (0, _.ColorArea),
    argTypes: {
        xChannel: {
            table: {
                disable: true
            }
        },
        yChannel: {
            table: {
                disable: true
            }
        },
        onChange: {
            table: {
                disable: true
            }
        },
        onChangeEnd: {
            table: {
                disable: true
            }
        }
    }
};
exports.default = meta;
const Template = (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(ColorAreaExample, args);
function ColorAreaExample(props) {
    let { xChannel, yChannel, isDisabled, "aria-label": ariaLabel } = props;
    let defaultValue = typeof props.defaultValue === "string" ? (0, _color.parseColor)(props.defaultValue) : props.defaultValue;
    let [color, setColor] = (0, _react.useState)(defaultValue || (0, _color.parseColor)("#ff00ff"));
    let xyChannels = {
        xChannel,
        yChannel
    };
    let colorSpace = color.getColorSpace();
    let { zChannel } = color.getColorSpaceAxes(xyChannels);
    let isHue = zChannel === "hue";
    function onChange(e) {
        const newColor = (e || color).toFormat(colorSpace);
        if (props.onChange) props.onChange(newColor);
        setColor(newColor);
    }
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        role: "group",
        "aria-label": `${ariaLabel ? `${ariaLabel} ` : ""}${colorSpace.toUpperCase()} Color Picker`
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSpectrum.Flex), {
        gap: "size-500",
        alignItems: "start"
    }, isHue ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSpectrum.Flex), {
        direction: "column",
        gap: 0,
        alignItems: "center"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSpectrum.View), {
        position: "relative",
        width: "size-2400"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSpectrum.Grid), {
        position: "absolute",
        justifyContent: "center",
        alignContent: "center",
        width: "100%",
        height: "100%"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ColorArea), {
        size: "size-1200",
        ...props,
        value: color,
        onChange: onChange,
        onChangeEnd: props.onChangeEnd
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ColorWheel), {
        size: "size-2400",
        value: color,
        onChange: onChange,
        onChangeEnd: props.onChangeEnd,
        isDisabled: isDisabled
    }))) : /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSpectrum.Flex), {
        direction: "column",
        gap: "size-50",
        alignItems: "center"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ColorArea), {
        ...props,
        value: color,
        onChange: onChange,
        onChangeEnd: props.onChangeEnd,
        isDisabled: isDisabled
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ColorSlider), {
        value: color,
        onChange: onChange,
        onChangeEnd: props.onChangeEnd,
        channel: zChannel,
        isDisabled: isDisabled
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSpectrum.Flex), {
        direction: "column",
        alignItems: "center",
        gap: "size-100",
        minWidth: "size-1200"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        role: "img",
        "aria-label": `color swatch: ${color.toString("rgb")}`,
        title: `${color.toString("hex")}`,
        style: {
            width: "96px",
            height: "96px",
            background: color.toString("css")
        }
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ColorField), {
        label: "HEX Color",
        value: color,
        onChange: onChange,
        onKeyDown: (event)=>event.key === "Enter" && onChange(event.target.value),
        isDisabled: isDisabled,
        width: "size-1200"
    }))));
}
const XBlueYGreen = {
    render: Template,
    name: 'RGB xChannel="blue", yChannel="green"',
    args: {
        defaultValue: "#0FF",
        xChannel: "blue",
        yChannel: "green",
        onChange: (0, _addonActions.action)("onChange"),
        onChangeEnd: (0, _addonActions.action)("onChangeEnd")
    }
};
const XGreenYBlue = {
    render: Template,
    name: 'RGB xChannel="green", yChannel="blue"',
    args: {
        ...XBlueYGreen.args,
        xChannel: "green",
        yChannel: "blue"
    }
};
const XBlueYRed = {
    render: Template,
    name: 'RGB xChannel="blue", yChannel="red"',
    args: {
        ...XBlueYGreen.args,
        defaultValue: "#F0F",
        xChannel: "blue",
        yChannel: "red"
    }
};
const XRedYBlue = {
    render: Template,
    name: 'RGB xChannel="red", yChannel="blue"',
    args: {
        ...XBlueYGreen.args,
        defaultValue: "#F0F",
        xChannel: "red",
        yChannel: "blue"
    }
};
const XRedYGreen = {
    render: Template,
    name: 'RGB xChannel="red", yChannel="green"',
    args: {
        ...XBlueYGreen.args,
        defaultValue: "#FF0",
        xChannel: "red",
        yChannel: "green"
    }
};
const XGreenYRed = {
    render: Template,
    name: 'RGB xChannel="green", yChannel="red"',
    args: {
        ...XBlueYGreen.args,
        defaultValue: "#FF0",
        xChannel: "green",
        yChannel: "red"
    }
};
const XBlueYGreenisDisabled = {
    render: Template,
    name: 'RGB xChannel="blue", yChannel="green", isDisabled',
    args: {
        ...XBlueYGreen.args,
        isDisabled: true
    }
};
const XBlueYGreenAriaLabelled = {
    render: Template,
    name: 'RGB xChannel="blue", yChannel="green", aria-label="foo"',
    args: {
        ...XBlueYGreen.args,
        "aria-label": "foo"
    }
};
const XBlueYGreenSize3000 = {
    render: Template,
    name: 'RGB xChannel="blue", yChannel="green", size="size-3000"',
    args: {
        ...XBlueYGreen.args,
        size: "size-3000"
    }
};
const XBlueYGreenSize600 = {
    render: Template,
    name: 'RGB xChannel="blue", yChannel="green", size="size-600"',
    args: {
        ...XBlueYGreen.args,
        size: "size-600"
    }
};
const XSaturationYLightness = {
    render: Template,
    name: 'HSL xChannel="saturation", yChannel="lightness"',
    args: {
        ...XBlueYGreen.args,
        xChannel: "saturation",
        yChannel: "lightness",
        defaultValue: "hsl(0, 100%, 50%)"
    }
};
const XLightnessYSaturation = {
    render: Template,
    name: 'HSL xChannel="lightness", yChannel="saturation"',
    args: {
        ...XBlueYGreen.args,
        xChannel: "lightness",
        yChannel: "saturation",
        defaultValue: "hsl(0, 100%, 50%)"
    }
};
const XSaturationYLightnessisDisabled = {
    render: Template,
    name: 'HSL xChannel="saturation", yChannel="lightness", isDisabled',
    args: {
        ...XSaturationYLightness.args,
        isDisabled: true
    }
};
const XHueYSaturationHSL = {
    render: Template,
    name: 'HSL xChannel="hue", yChannel="saturation"',
    args: {
        ...XSaturationYLightness.args,
        xChannel: "hue",
        yChannel: "saturation",
        defaultValue: "hsl(0, 100%, 50%)"
    }
};
const XSaturationYHueHSL = {
    render: Template,
    name: 'HSL xChannel="saturation", yChannel="hue"',
    args: {
        ...XSaturationYLightness.args,
        xChannel: "saturation",
        yChannel: "hue",
        defaultValue: "hsl(0, 100%, 50%)"
    }
};
const XHueYSaturationHSLisDisabled = {
    render: Template,
    name: 'HSL xChannel="hue", yChannel="saturation", isDisabled',
    args: {
        ...XHueYSaturationHSL.args,
        isDisabled: true
    }
};
const XHueYLightnessHSL = {
    render: Template,
    name: 'HSL xChannel="hue", yChannel="lightness"',
    args: {
        ...XHueYSaturationHSL.args,
        xChannel: "hue",
        yChannel: "lightness",
        defaultValue: "hsl(0, 100%, 50%)"
    }
};
const XLightnessYHueHSL = {
    render: Template,
    name: 'HSL xChannel="lightness", yChannel="hue"',
    args: {
        ...XHueYSaturationHSL.args,
        xChannel: "lightness",
        yChannel: "hue",
        defaultValue: "hsl(0, 100%, 50%)"
    }
};
const XHueYLightnessHSLisDisabled = {
    render: Template,
    name: 'HSL xChannel="hue", yChannel="lightness", isDisabled',
    args: {
        ...XHueYLightnessHSL.args,
        isDisabled: true
    }
};
const XSaturationYBrightness = {
    render: Template,
    name: 'HSB xChannel="saturation", yChannel="brightness"',
    args: {
        ...XHueYSaturationHSL.args,
        xChannel: "saturation",
        yChannel: "brightness",
        defaultValue: "hsb(0, 100%, 100%)"
    }
};
const XBrightnessYSaturation = {
    render: Template,
    name: 'HSB xChannel="brightness", yChannel="saturation"',
    args: {
        ...XHueYSaturationHSL.args,
        xChannel: "brightness",
        yChannel: "saturation",
        defaultValue: "hsb(0, 100%, 100%)"
    }
};
const XSaturationYBrightnessisDisabled = {
    render: Template,
    name: 'HSB xChannel="saturation", yChannel="brightness", isDisabled',
    args: {
        ...XSaturationYBrightness.args,
        isDisabled: true
    }
};
const XHueYSaturationHSB = {
    render: Template,
    name: 'HSB xChannel="hue", yChannel="saturation"',
    args: {
        ...XSaturationYBrightness.args,
        xChannel: "hue",
        yChannel: "saturation",
        defaultValue: "hsb(0, 100%, 100%)"
    }
};
const XSaturationYHueHS = {
    render: Template,
    name: 'HSB xChannel="saturation", yChannel="hue"',
    args: {
        ...XSaturationYBrightness.args,
        xChannel: "saturation",
        yChannel: "hue",
        defaultValue: "hsb(0, 100%, 100%)"
    }
};
const XHueYSaturationHSBisDisabled = {
    render: Template,
    name: 'HSB xChannel="hue", yChannel="saturation", isDisabled',
    args: {
        ...XHueYSaturationHSB.args,
        isDisabled: true
    }
};
const XHueYBrightnessHSB = {
    render: Template,
    name: 'HSB xChannel="hue", yChannel="brightness"',
    args: {
        ...XHueYSaturationHSB.args,
        xChannel: "hue",
        yChannel: "brightness",
        defaultValue: "hsb(0, 100%, 100%)"
    }
};
const XBrightnessYHueHSB = {
    render: Template,
    name: 'HSB xChannel="brightness", yChannel="hue"',
    args: {
        ...XHueYSaturationHSB.args,
        xChannel: "brightness",
        yChannel: "hue",
        defaultValue: "hsb(0, 100%, 100%)"
    }
};
const XBrightnessYHueHSBisDisabled = {
    render: Template,
    name: 'HSB xChannel="brightness", yChannel="hue", isDisabled',
    args: {
        ...XBrightnessYHueHSB.args,
        isDisabled: true
    }
};

},{"@storybook/addon-actions":"coXbW","../":"rC4Qm","@adobe/react-spectrum":"cwANo","@react-stately/color":"1aHGl","react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"rC4Qm":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _src = require("./src");
parcelHelpers.exportAll(_src, exports);

},{"./src":"hkBc2","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"hkBc2":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /// <reference types="css-module-types" />
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ColorArea", ()=>(0, _colorArea.ColorArea));
parcelHelpers.export(exports, "ColorWheel", ()=>(0, _colorWheel.ColorWheel));
parcelHelpers.export(exports, "ColorSlider", ()=>(0, _colorSlider.ColorSlider));
parcelHelpers.export(exports, "ColorField", ()=>(0, _colorField.ColorField));
var _colorArea = require("./ColorArea");
var _colorWheel = require("./ColorWheel");
var _colorSlider = require("./ColorSlider");
var _colorField = require("./ColorField");

},{"./ColorArea":"1zOeG","./ColorWheel":"6Y0Yo","./ColorSlider":"6Ifq1","./ColorField":"lwZwv","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"1zOeG":[function(require,module,exports) {
/*
 * Copyright 2021 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ColorArea", ()=>_ColorArea);
var _utils = require("@react-spectrum/utils");
var _colorThumb = require("./ColorThumb");
var _utils1 = require("@react-aria/utils");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _varsCss = require("@adobe/spectrum-css-temp/components/colorarea/vars.css");
var _varsCssDefault = parcelHelpers.interopDefault(_varsCss);
var _color = require("@react-aria/color");
var _color1 = require("@react-stately/color");
var _focus = require("@react-aria/focus");
var _provider = require("@react-spectrum/provider");
function ColorArea(props, ref) {
    props = (0, _provider.useProviderProps)(props);
    let { isDisabled } = props;
    let size = props.size && (0, _utils.dimensionValue)(props.size);
    let { styleProps } = (0, _utils.useStyleProps)(props);
    let inputXRef = (0, _react.useRef)(null);
    let inputYRef = (0, _react.useRef)(null);
    let containerRef = (0, _utils.useFocusableRef)(ref, inputXRef);
    let state = (0, _color1.useColorAreaState)(props);
    let { colorAreaProps, gradientProps, xInputProps, yInputProps, thumbProps } = (0, _color.useColorArea)({
        ...props,
        inputXRef,
        inputYRef,
        containerRef
    }, state);
    let { focusProps, isFocusVisible } = (0, _focus.useFocusRing)();
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...colorAreaProps,
        className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-ColorArea", {
            "is-disabled": isDisabled
        }, styleProps.className),
        ref: containerRef,
        style: {
            ...colorAreaProps.style,
            ...styleProps.style,
            // Workaround around https://github.com/adobe/spectrum-css/issues/1032
            width: size,
            height: size
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...gradientProps,
        className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-ColorArea-gradient")
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _colorThumb.ColorThumb), {
        value: state.getDisplayColor(),
        isFocused: isFocusVisible,
        isDisabled: isDisabled,
        isDragging: state.isDragging,
        className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-ColorArea-handle"),
        ...thumbProps
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        role: "presentation"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("input", {
        className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-ColorArea-slider"),
        ...(0, _utils1.mergeProps)(xInputProps, focusProps),
        ref: inputXRef
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("input", {
        className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-ColorArea-slider"),
        ...(0, _utils1.mergeProps)(yInputProps, focusProps),
        ref: inputYRef
    }))));
}
/**
 * ColorArea allows users to adjust two channels of an RGB, HSL or HSB color value against a two-dimensional gradient background.
 */ let _ColorArea = /*#__PURE__*/ (0, _reactDefault.default).forwardRef(ColorArea);

},{"@react-spectrum/utils":"cMIJ6","./ColorThumb":"iTbho","@react-aria/utils":"9cLk5","react":"9yzVZ","@adobe/spectrum-css-temp/components/colorarea/vars.css":"2Ekcn","@react-aria/color":"fjtDT","@react-stately/color":"1aHGl","@react-aria/focus":"42mbF","@react-spectrum/provider":"5bCdp","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"iTbho":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ColorThumb", ()=>ColorThumb);
var _utils = require("@react-spectrum/utils");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _varsCss = require("@adobe/spectrum-css-temp/components/colorhandle/vars.css");
var _varsCssDefault = parcelHelpers.interopDefault(_varsCss);
var _varsCss1 = require("@adobe/spectrum-css-temp/components/colorloupe/vars.css");
var _varsCssDefault1 = parcelHelpers.interopDefault(_varsCss1);
var _utils1 = require("@react-aria/utils");
function ColorThumb(props) {
    let { value, isDisabled, isDragging, isFocused, children, className = "", ...otherProps } = props;
    let patternId = (0, _utils1.useId)();
    let valueCSS = value.toString("css");
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-ColorHandle", {
            "is-focused": isFocused,
            "is-disabled": isDisabled
        }) + " " + className,
        ...otherProps
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-ColorHandle-color"),
        style: {
            backgroundColor: valueCSS
        }
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        className: (0, _utils.classNames)((0, _varsCssDefault1.default), "spectrum-ColorLoupe", {
            "is-open": isDragging
        }),
        "aria-hidden": "true"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("pattern", {
        id: patternId,
        x: "0",
        y: "0",
        width: "16",
        height: "16",
        patternUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("rect", {
        className: (0, _utils.classNames)((0, _varsCssDefault1.default), "spectrum-ColorLoupe-inner-background"),
        x: "0",
        y: "0",
        width: "16",
        height: "16"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("rect", {
        className: (0, _utils.classNames)((0, _varsCssDefault1.default), "spectrum-ColorLoupe-inner-checker"),
        x: "0",
        y: "0",
        width: "8",
        height: "8"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("rect", {
        className: (0, _utils.classNames)((0, _varsCssDefault1.default), "spectrum-ColorLoupe-inner-checker"),
        x: "8",
        y: "8",
        width: "8",
        height: "8"
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        className: (0, _utils.classNames)((0, _varsCssDefault1.default), "spectrum-ColorLoupe-inner"),
        d: "M25 1a24 24 0 0124 24c0 16.255-24 40-24 40S1 41.255 1 25A24 24 0 0125 1z",
        fill: `url(#${patternId})`
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        className: (0, _utils.classNames)((0, _varsCssDefault1.default), "spectrum-ColorLoupe-inner"),
        d: "M25 1a24 24 0 0124 24c0 16.255-24 40-24 40S1 41.255 1 25A24 24 0 0125 1z",
        fill: valueCSS
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        className: (0, _utils.classNames)((0, _varsCssDefault1.default), "spectrum-ColorLoupe-outer"),
        d: "M25 3A21.98 21.98 0 003 25c0 6.2 4 14.794 11.568 24.853A144.233 144.233 0 0025 62.132a144.085 144.085 0 0010.4-12.239C42.99 39.816 47 31.209 47 25A21.98 21.98 0 0025 3m0-2a24 24 0 0124 24c0 16.255-24 40-24 40S1 41.255 1 25A24 24 0 0125 1z"
    })), children);
}

},{"@react-spectrum/utils":"cMIJ6","react":"9yzVZ","@adobe/spectrum-css-temp/components/colorhandle/vars.css":"3kxGh","@adobe/spectrum-css-temp/components/colorloupe/vars.css":"bHYl3","@react-aria/utils":"9cLk5","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"3kxGh":[function(require,module,exports) {
module.exports["spectrum-ColorControl-handle--focused"] = `hoc2UW_spectrum-ColorControl-handle--focused`;
module.exports["focus-ring"] = `hoc2UW_focus-ring ${module.exports["spectrum-ColorControl-handle--focused"]}`;
module.exports["is-disabled"] = `hoc2UW_is-disabled`;
module.exports["is-focused"] = `hoc2UW_is-focused ${module.exports["spectrum-ColorControl-handle--focused"]}`;
module.exports["spectrum-ColorHandle"] = `hoc2UW_spectrum-ColorHandle`;
module.exports["spectrum-ColorHandle-color"] = `hoc2UW_spectrum-ColorHandle-color`;

},{}],"bHYl3":[function(require,module,exports) {
module.exports["is-open"] = `HpWpfq_is-open`;
module.exports["spectrum-ColorLoupe"] = `HpWpfq_spectrum-ColorLoupe`;
module.exports["spectrum-ColorLoupe-inner-background"] = `HpWpfq_spectrum-ColorLoupe-inner-background`;
module.exports["spectrum-ColorLoupe-inner-checker"] = `HpWpfq_spectrum-ColorLoupe-inner-checker`;
module.exports["spectrum-ColorLoupe-outer"] = `HpWpfq_spectrum-ColorLoupe-outer`;

},{}],"2Ekcn":[function(require,module,exports) {
module.exports["focus-ring"] = `lm1DSq_focus-ring`;
module.exports["is-disabled"] = `lm1DSq_is-disabled`;
module.exports["is-focused"] = `lm1DSq_is-focused`;
module.exports["spectrum-ColorArea"] = `lm1DSq_spectrum-ColorArea`;
module.exports["spectrum-ColorArea-gradient"] = `lm1DSq_spectrum-ColorArea-gradient`;
module.exports["spectrum-ColorArea-handle"] = `lm1DSq_spectrum-ColorArea-handle`;
module.exports["spectrum-ColorArea-slider"] = `lm1DSq_spectrum-ColorArea-slider`;
module.exports["spectrum-ColorHandle-color"] = `lm1DSq_spectrum-ColorHandle-color`;

},{}],"fjtDT":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useColorArea", ()=>(0, _useColorArea.useColorArea));
parcelHelpers.export(exports, "useColorSlider", ()=>(0, _useColorSlider.useColorSlider));
parcelHelpers.export(exports, "useColorWheel", ()=>(0, _useColorWheel.useColorWheel));
parcelHelpers.export(exports, "useColorField", ()=>(0, _useColorField.useColorField));
var _useColorArea = require("./useColorArea");
var _useColorSlider = require("./useColorSlider");
var _useColorWheel = require("./useColorWheel");
var _useColorField = require("./useColorField");

},{"./useColorArea":"ddmzN","./useColorSlider":"a0NgB","./useColorWheel":"iFCBt","./useColorField":"kRXYM","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"ddmzN":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides the behavior and accessibility implementation for a color area component.
 * Color area allows users to adjust two channels of an RGB, HSL or HSB color value against a two-dimensional gradient background.
 */ parcelHelpers.export(exports, "useColorArea", ()=>useColorArea);
var _utils = require("@react-aria/utils");
// @ts-ignore
var _json = require("../intl/*.json");
var _jsonDefault = parcelHelpers.interopDefault(_json);
var _react = require("react");
var _useColorAreaGradient = require("./useColorAreaGradient");
var _interactions = require("@react-aria/interactions");
var _i18N = require("@react-aria/i18n");
var _visuallyHidden = require("@react-aria/visually-hidden");
function useColorArea(props, state) {
    let { isDisabled, inputXRef, inputYRef, containerRef, "aria-label": ariaLabel, xName, yName } = props;
    let stringFormatter = (0, _i18N.useLocalizedStringFormatter)((0, _jsonDefault.default), "@react-aria/color");
    let { addGlobalListener, removeGlobalListener } = (0, _utils.useGlobalListeners)();
    let { direction, locale } = (0, _i18N.useLocale)();
    let [focusedInput, setFocusedInput] = (0, _react.useState)(null);
    let focusInput = (0, _react.useCallback)((inputRef = inputXRef)=>{
        if (inputRef.current) (0, _utils.focusWithoutScrolling)(inputRef.current);
    }, [
        inputXRef
    ]);
    (0, _utils.useFormReset)(inputXRef, [
        state.xValue,
        state.yValue
    ], ([x, y])=>{
        let newColor = state.value.withChannelValue(state.channels.xChannel, x).withChannelValue(state.channels.yChannel, y);
        state.setValue(newColor);
    });
    let [valueChangedViaKeyboard, setValueChangedViaKeyboard] = (0, _react.useState)(false);
    let { xChannel, yChannel, zChannel } = state.channels;
    let xChannelStep = state.xChannelStep;
    let yChannelStep = state.yChannelStep;
    let currentPosition = (0, _react.useRef)(null);
    let { keyboardProps } = (0, _interactions.useKeyboard)({
        onKeyDown (e) {
            // these are the cases that useMove doesn't handle
            if (!/^(PageUp|PageDown|Home|End)$/.test(e.key)) {
                e.continuePropagation();
                return;
            }
            // same handling as useMove, don't need to stop propagation, useKeyboard will do that for us
            e.preventDefault();
            // remember to set this and unset it so that onChangeEnd is fired
            state.setDragging(true);
            setValueChangedViaKeyboard(true);
            let dir;
            switch(e.key){
                case "PageUp":
                    state.incrementY(state.yChannelPageStep);
                    dir = "y";
                    break;
                case "PageDown":
                    state.decrementY(state.yChannelPageStep);
                    dir = "y";
                    break;
                case "Home":
                    direction === "rtl" ? state.incrementX(state.xChannelPageStep) : state.decrementX(state.xChannelPageStep);
                    dir = "x";
                    break;
                case "End":
                    direction === "rtl" ? state.decrementX(state.xChannelPageStep) : state.incrementX(state.xChannelPageStep);
                    dir = "x";
                    break;
            }
            state.setDragging(false);
            if (dir) {
                let input = dir === "x" ? inputXRef : inputYRef;
                focusInput(input);
                setFocusedInput(dir);
            }
        }
    });
    let moveHandler = {
        onMoveStart () {
            currentPosition.current = null;
            state.setDragging(true);
        },
        onMove ({ deltaX, deltaY, pointerType, shiftKey }) {
            var _containerRef_current;
            let { incrementX, decrementX, incrementY, decrementY, xChannelPageStep, xChannelStep, yChannelPageStep, yChannelStep, getThumbPosition, setColorFromPoint } = state;
            if (currentPosition.current == null) currentPosition.current = getThumbPosition();
            let { width, height } = ((_containerRef_current = containerRef.current) === null || _containerRef_current === void 0 ? void 0 : _containerRef_current.getBoundingClientRect()) || {
                width: 0,
                height: 0
            };
            let valueChanged = deltaX !== 0 || deltaY !== 0;
            if (pointerType === "keyboard") {
                let deltaXValue = shiftKey && xChannelPageStep > xChannelStep ? xChannelPageStep : xChannelStep;
                let deltaYValue = shiftKey && yChannelPageStep > yChannelStep ? yChannelPageStep : yChannelStep;
                if (deltaX > 0 && direction === "ltr" || deltaX < 0 && direction === "rtl") incrementX(deltaXValue);
                else if (deltaX < 0 && direction === "ltr" || deltaX > 0 && direction === "rtl") decrementX(deltaXValue);
                else if (deltaY > 0) decrementY(deltaYValue);
                else if (deltaY < 0) incrementY(deltaYValue);
                setValueChangedViaKeyboard(valueChanged);
                // set the focused input based on which axis has the greater delta
                focusedInput = valueChanged && Math.abs(deltaY) > Math.abs(deltaX) ? "y" : "x";
                setFocusedInput(focusedInput);
            } else {
                currentPosition.current.x += (direction === "rtl" ? -1 : 1) * deltaX / width;
                currentPosition.current.y += deltaY / height;
                setColorFromPoint(currentPosition.current.x, currentPosition.current.y);
            }
        },
        onMoveEnd () {
            isOnColorArea.current = false;
            state.setDragging(false);
            let input = focusedInput === "x" ? inputXRef : inputYRef;
            focusInput(input);
        }
    };
    let { moveProps: movePropsThumb } = (0, _interactions.useMove)(moveHandler);
    let { focusWithinProps } = (0, _interactions.useFocusWithin)({
        onFocusWithinChange: (focusWithin)=>{
            if (!focusWithin) setValueChangedViaKeyboard(false);
        }
    });
    let currentPointer = (0, _react.useRef)(undefined);
    let isOnColorArea = (0, _react.useRef)(false);
    let { moveProps: movePropsContainer } = (0, _interactions.useMove)({
        onMoveStart () {
            if (isOnColorArea.current) moveHandler.onMoveStart();
        },
        onMove (e) {
            if (isOnColorArea.current) moveHandler.onMove(e);
        },
        onMoveEnd () {
            if (isOnColorArea.current) moveHandler.onMoveEnd();
        }
    });
    let onThumbDown = (id)=>{
        if (!state.isDragging) {
            currentPointer.current = id;
            setValueChangedViaKeyboard(false);
            focusInput();
            state.setDragging(true);
            if (typeof PointerEvent !== "undefined") addGlobalListener(window, "pointerup", onThumbUp, false);
            else {
                addGlobalListener(window, "mouseup", onThumbUp, false);
                addGlobalListener(window, "touchend", onThumbUp, false);
            }
        }
    };
    let onThumbUp = (e)=>{
        var _e_changedTouches;
        var _e_pointerId;
        let id = (_e_pointerId = e.pointerId) !== null && _e_pointerId !== void 0 ? _e_pointerId : (_e_changedTouches = e.changedTouches) === null || _e_changedTouches === void 0 ? void 0 : _e_changedTouches[0].identifier;
        if (id === currentPointer.current) {
            setValueChangedViaKeyboard(false);
            focusInput();
            state.setDragging(false);
            currentPointer.current = undefined;
            isOnColorArea.current = false;
            if (typeof PointerEvent !== "undefined") removeGlobalListener(window, "pointerup", onThumbUp, false);
            else {
                removeGlobalListener(window, "mouseup", onThumbUp, false);
                removeGlobalListener(window, "touchend", onThumbUp, false);
            }
        }
    };
    let onColorAreaDown = (colorArea, id, clientX, clientY)=>{
        let rect = colorArea.getBoundingClientRect();
        let { width, height } = rect;
        let x = (clientX - rect.x) / width;
        let y = (clientY - rect.y) / height;
        if (direction === "rtl") x = 1 - x;
        if (x >= 0 && x <= 1 && y >= 0 && y <= 1 && !state.isDragging && currentPointer.current === undefined) {
            isOnColorArea.current = true;
            setValueChangedViaKeyboard(false);
            currentPointer.current = id;
            state.setColorFromPoint(x, y);
            focusInput();
            state.setDragging(true);
            if (typeof PointerEvent !== "undefined") addGlobalListener(window, "pointerup", onColorAreaUp, false);
            else {
                addGlobalListener(window, "mouseup", onColorAreaUp, false);
                addGlobalListener(window, "touchend", onColorAreaUp, false);
            }
        }
    };
    let onColorAreaUp = (e)=>{
        var _e_changedTouches;
        var _e_pointerId;
        let id = (_e_pointerId = e.pointerId) !== null && _e_pointerId !== void 0 ? _e_pointerId : (_e_changedTouches = e.changedTouches) === null || _e_changedTouches === void 0 ? void 0 : _e_changedTouches[0].identifier;
        if (isOnColorArea.current && id === currentPointer.current) {
            isOnColorArea.current = false;
            setValueChangedViaKeyboard(false);
            currentPointer.current = undefined;
            state.setDragging(false);
            focusInput();
            if (typeof PointerEvent !== "undefined") removeGlobalListener(window, "pointerup", onColorAreaUp, false);
            else {
                removeGlobalListener(window, "mouseup", onColorAreaUp, false);
                removeGlobalListener(window, "touchend", onColorAreaUp, false);
            }
        }
    };
    let colorAreaInteractions = isDisabled ? {} : (0, _utils.mergeProps)({
        ...typeof PointerEvent !== "undefined" ? {
            onPointerDown: (e)=>{
                if (e.pointerType === "mouse" && (e.button !== 0 || e.altKey || e.ctrlKey || e.metaKey)) return;
                onColorAreaDown(e.currentTarget, e.pointerId, e.clientX, e.clientY);
            }
        } : {
            onMouseDown: (e)=>{
                if (e.button !== 0 || e.altKey || e.ctrlKey || e.metaKey) return;
                onColorAreaDown(e.currentTarget, undefined, e.clientX, e.clientY);
            },
            onTouchStart: (e)=>{
                onColorAreaDown(e.currentTarget, e.changedTouches[0].identifier, e.changedTouches[0].clientX, e.changedTouches[0].clientY);
            }
        }
    }, movePropsContainer);
    let thumbInteractions = isDisabled ? {} : (0, _utils.mergeProps)({
        ...typeof PointerEvent !== "undefined" ? {
            onPointerDown: (e)=>{
                if (e.pointerType === "mouse" && (e.button !== 0 || e.altKey || e.ctrlKey || e.metaKey)) return;
                onThumbDown(e.pointerId);
            }
        } : {
            onMouseDown: (e)=>{
                if (e.button !== 0 || e.altKey || e.ctrlKey || e.metaKey) return;
                onThumbDown(undefined);
            },
            onTouchStart: (e)=>{
                onThumbDown(e.changedTouches[0].identifier);
            }
        }
    }, focusWithinProps, keyboardProps, movePropsThumb);
    let { focusProps: xInputFocusProps } = (0, _interactions.useFocus)({
        onFocus: ()=>{
            setFocusedInput("x");
        }
    });
    let { focusProps: yInputFocusProps } = (0, _interactions.useFocus)({
        onFocus: ()=>{
            setFocusedInput("y");
        }
    });
    let isMobile = (0, _utils.isIOS)() || (0, _utils.isAndroid)();
    function getAriaValueTextForChannel(channel) {
        return valueChangedViaKeyboard ? stringFormatter.format("colorNameAndValue", {
            name: state.value.getChannelName(channel, locale),
            value: state.value.formatChannelValue(channel, locale)
        }) : [
            stringFormatter.format("colorNameAndValue", {
                name: state.value.getChannelName(channel, locale),
                value: state.value.formatChannelValue(channel, locale)
            }),
            stringFormatter.format("colorNameAndValue", {
                name: state.value.getChannelName(channel === yChannel ? xChannel : yChannel, locale),
                value: state.value.formatChannelValue(channel === yChannel ? xChannel : yChannel, locale)
            })
        ].join(", ");
    }
    let colorPickerLabel = stringFormatter.format("colorPicker");
    let xInputLabellingProps = (0, _utils.useLabels)({
        ...props,
        "aria-label": ariaLabel ? stringFormatter.format("colorInputLabel", {
            label: ariaLabel,
            channelLabel: colorPickerLabel
        }) : colorPickerLabel
    });
    let yInputLabellingProps = (0, _utils.useLabels)({
        ...props,
        "aria-label": ariaLabel ? stringFormatter.format("colorInputLabel", {
            label: ariaLabel,
            channelLabel: colorPickerLabel
        }) : colorPickerLabel
    });
    let colorAreaLabellingProps = (0, _utils.useLabels)({
        ...props,
        "aria-label": ariaLabel ? `${ariaLabel}, ${colorPickerLabel}` : undefined
    }, isMobile ? colorPickerLabel : undefined);
    let ariaRoleDescription = stringFormatter.format("twoDimensionalSlider");
    let { visuallyHiddenProps } = (0, _visuallyHidden.useVisuallyHidden)({
        style: {
            opacity: "0.0001",
            width: "100%",
            height: "100%",
            pointerEvents: "none"
        }
    });
    let { colorAreaStyleProps, gradientStyleProps, thumbStyleProps } = (0, _useColorAreaGradient.useColorAreaGradient)({
        direction,
        state,
        xChannel,
        zChannel,
        isDisabled: props.isDisabled
    });
    return {
        colorAreaProps: {
            ...colorAreaLabellingProps,
            ...colorAreaInteractions,
            ...colorAreaStyleProps,
            role: "group"
        },
        gradientProps: {
            ...gradientStyleProps,
            role: "presentation"
        },
        thumbProps: {
            ...thumbInteractions,
            ...thumbStyleProps,
            role: "presentation"
        },
        xInputProps: {
            ...xInputLabellingProps,
            ...visuallyHiddenProps,
            ...xInputFocusProps,
            type: "range",
            min: state.value.getChannelRange(xChannel).minValue,
            max: state.value.getChannelRange(xChannel).maxValue,
            step: xChannelStep,
            "aria-roledescription": ariaRoleDescription,
            "aria-valuetext": getAriaValueTextForChannel(xChannel),
            disabled: isDisabled,
            value: state.value.getChannelValue(xChannel),
            name: xName,
            tabIndex: isMobile || !focusedInput || focusedInput === "x" ? undefined : -1,
            /*
        So that only a single "2d slider" control shows up when listing form elements for screen readers,
        add aria-hidden="true" to the unfocused control when the value has not changed via the keyboard,
        but remove aria-hidden to reveal the input for each channel when the value has changed with the keyboard.
      */ "aria-hidden": isMobile || !focusedInput || focusedInput === "x" || valueChangedViaKeyboard ? undefined : "true",
            onChange: (e)=>{
                state.setXValue(parseFloat(e.target.value));
            }
        },
        yInputProps: {
            ...yInputLabellingProps,
            ...visuallyHiddenProps,
            ...yInputFocusProps,
            type: "range",
            min: state.value.getChannelRange(yChannel).minValue,
            max: state.value.getChannelRange(yChannel).maxValue,
            step: yChannelStep,
            "aria-roledescription": ariaRoleDescription,
            "aria-valuetext": getAriaValueTextForChannel(yChannel),
            "aria-orientation": "vertical",
            disabled: isDisabled,
            value: state.value.getChannelValue(yChannel),
            name: yName,
            tabIndex: isMobile || focusedInput === "y" ? undefined : -1,
            /*
        So that only a single "2d slider" control shows up when listing form elements for screen readers,
        add aria-hidden="true" to the unfocused input when the value has not changed via the keyboard,
        but remove aria-hidden to reveal the input for each channel when the value has changed with the keyboard.
      */ "aria-hidden": isMobile || focusedInput === "y" || valueChangedViaKeyboard ? undefined : "true",
            onChange: (e)=>{
                state.setYValue(parseFloat(e.target.value));
            }
        }
    };
}

},{"@react-aria/utils":"9cLk5","../intl/*.json":"gyPa0","react":"9yzVZ","./useColorAreaGradient":"10XAE","@react-aria/interactions":"ky3G8","@react-aria/i18n":"411rg","@react-aria/visually-hidden":"4jwxT","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"gyPa0":[function(require,module,exports) {
const _temp0 = require("fd28ab3e583acafd");
const _temp1 = require("720e216cab7b7ba4");
const _temp2 = require("559eade6dcf6b87f");
const _temp3 = require("a64b39c5672cb431");
const _temp4 = require("9627d39939a4f914");
const _temp5 = require("24dbd639d50b4c1e");
const _temp6 = require("fdac0e02a6b5e974");
const _temp7 = require("fda5450887291c48");
const _temp8 = require("5aca092ec289a424");
const _temp9 = require("a349443c27cc24b");
const _temp10 = require("f06b391bb60aabc5");
const _temp11 = require("bd6ecba6fc38678c");
const _temp12 = require("fb55d76cd9577ef3");
const _temp13 = require("537b8d68ca377245");
const _temp14 = require("69634f88892bf7a6");
const _temp15 = require("2476a83dd8e96270");
const _temp16 = require("c15b084353944e05");
const _temp17 = require("45e43b3e4ad04dc5");
const _temp18 = require("f9a7b68bade50467");
const _temp19 = require("e2c45d24bec52af6");
const _temp20 = require("3bf956af919a4704");
const _temp21 = require("52b4b6cbdcb7256e");
const _temp22 = require("c2cf7e258991288e");
const _temp23 = require("f8aadecdd6ea9625");
const _temp24 = require("117e123ddf42950a");
const _temp25 = require("4957a53d28558e32");
const _temp26 = require("97e281451329f6f1");
const _temp27 = require("9abddc99aba1c250");
const _temp28 = require("624350b3d08a89d4");
const _temp29 = require("518283df38737bfd");
const _temp30 = require("63d39172fc4d210");
const _temp31 = require("8e0126357fd569f2");
const _temp32 = require("974d3ec6a91141b4");
const _temp33 = require("6aab64caa5acfbe8");
module.exports = {
    "ar-AE": _temp0,
    "bg-BG": _temp1,
    "cs-CZ": _temp2,
    "da-DK": _temp3,
    "de-DE": _temp4,
    "el-GR": _temp5,
    "en-US": _temp6,
    "es-ES": _temp7,
    "et-EE": _temp8,
    "fi-FI": _temp9,
    "fr-FR": _temp10,
    "he-IL": _temp11,
    "hr-HR": _temp12,
    "hu-HU": _temp13,
    "it-IT": _temp14,
    "ja-JP": _temp15,
    "ko-KR": _temp16,
    "lt-LT": _temp17,
    "lv-LV": _temp18,
    "nb-NO": _temp19,
    "nl-NL": _temp20,
    "pl-PL": _temp21,
    "pt-BR": _temp22,
    "pt-PT": _temp23,
    "ro-RO": _temp24,
    "ru-RU": _temp25,
    "sk-SK": _temp26,
    "sl-SI": _temp27,
    "sr-SP": _temp28,
    "sv-SE": _temp29,
    "tr-TR": _temp30,
    "uk-UA": _temp31,
    "zh-CN": _temp32,
    "zh-TW": _temp33
};

},{"fd28ab3e583acafd":"fITSN","720e216cab7b7ba4":"gxvp2","559eade6dcf6b87f":"8ghKd","a64b39c5672cb431":"4fPLw","9627d39939a4f914":"lr9zy","24dbd639d50b4c1e":"804vi","fdac0e02a6b5e974":"3hMtY","fda5450887291c48":"gjWeX","5aca092ec289a424":"9OyEa","a349443c27cc24b":"dKCjI","f06b391bb60aabc5":"2hpDo","bd6ecba6fc38678c":"469w1","fb55d76cd9577ef3":"cnvn9","537b8d68ca377245":"eZkZk","69634f88892bf7a6":"2Szk1","2476a83dd8e96270":"chFhZ","c15b084353944e05":"TidYg","45e43b3e4ad04dc5":"dEOBO","f9a7b68bade50467":"7MSCX","e2c45d24bec52af6":"8bKOo","3bf956af919a4704":"afLsc","52b4b6cbdcb7256e":"cBhnw","c2cf7e258991288e":"7Ie54","f8aadecdd6ea9625":"4VlQc","117e123ddf42950a":"emEVC","4957a53d28558e32":"dWB0J","97e281451329f6f1":"7nglw","9abddc99aba1c250":"bMMdS","624350b3d08a89d4":"7dagf","518283df38737bfd":"fPpcT","63d39172fc4d210":"8uExj","8e0126357fd569f2":"8U1B6","974d3ec6a91141b4":"7gTHa","6aab64caa5acfbe8":"lwvkw"}],"fITSN":[function(require,module,exports) {
module.exports = {
    "colorInputLabel": (args)=>`${args.label}, ${args.channelLabel}`,
    "colorNameAndValue": (args)=>`${args.name}: ${args.value}`,
    "colorPicker": `\u{623}\u{62F}\u{627}\u{629} \u{627}\u{646}\u{62A}\u{642}\u{627}\u{621} \u{627}\u{644}\u{644}\u{648}\u{646}`,
    "twoDimensionalSlider": `\u{645}\u{64F}\u{646}\u{632}\u{644}\u{642} 2D`
};

},{}],"gxvp2":[function(require,module,exports) {
module.exports = {
    "colorInputLabel": (args)=>`${args.label}, ${args.channelLabel}`,
    "colorNameAndValue": (args)=>`${args.name}: ${args.value}`,
    "colorPicker": `\u{421}\u{440}\u{435}\u{434}\u{441}\u{442}\u{432}\u{43E} \u{437}\u{430} \u{438}\u{437}\u{431}\u{438}\u{440}\u{430}\u{43D}\u{435} \u{43D}\u{430} \u{446}\u{432}\u{44F}\u{442}`,
    "twoDimensionalSlider": `2D \u{43F}\u{43B}\u{44A}\u{437}\u{433}\u{430}\u{447}`
};

},{}],"8ghKd":[function(require,module,exports) {
module.exports = {
    "colorInputLabel": (args)=>`${args.label}, ${args.channelLabel}`,
    "colorNameAndValue": (args)=>`${args.name}: ${args.value}`,
    "colorPicker": `V\xfdb\u{11B}r barvy`,
    "twoDimensionalSlider": `2D posuvn\xedk`
};

},{}],"4fPLw":[function(require,module,exports) {
module.exports = {
    "colorInputLabel": (args)=>`${args.label}, ${args.channelLabel}`,
    "colorNameAndValue": (args)=>`${args.name}: ${args.value}`,
    "colorPicker": `Farvev\xe6lger`,
    "twoDimensionalSlider": `2D-skyder`
};

},{}],"lr9zy":[function(require,module,exports) {
module.exports = {
    "colorInputLabel": (args)=>`${args.label}, ${args.channelLabel}`,
    "colorNameAndValue": (args)=>`${args.name}: ${args.value}`,
    "colorPicker": `Farbw\xe4hler`,
    "twoDimensionalSlider": `2D-Schieberegler`
};

},{}],"804vi":[function(require,module,exports) {
module.exports = {
    "colorInputLabel": (args)=>`${args.label}, ${args.channelLabel}`,
    "colorNameAndValue": (args)=>`${args.name}: ${args.value}`,
    "colorPicker": `\u{395}\u{3C0}\u{3B9}\u{3BB}\u{3BF}\u{3B3}\u{3AD}\u{3B1}\u{3C2} \u{3C7}\u{3C1}\u{3C9}\u{3BC}\u{3AC}\u{3C4}\u{3C9}\u{3BD}`,
    "twoDimensionalSlider": `\u{3A1}\u{3C5}\u{3B8}\u{3BC}\u{3B9}\u{3C3}\u{3C4}\u{3B9}\u{3BA}\u{3CC} 2D`
};

},{}],"3hMtY":[function(require,module,exports) {
module.exports = {
    "colorPicker": `Color picker`,
    "twoDimensionalSlider": `2D slider`,
    "colorNameAndValue": (args)=>`${args.name}: ${args.value}`,
    "colorInputLabel": (args)=>`${args.label}, ${args.channelLabel}`
};

},{}],"gjWeX":[function(require,module,exports) {
module.exports = {
    "colorInputLabel": (args)=>`${args.label}, ${args.channelLabel}`,
    "colorNameAndValue": (args)=>`${args.name}: ${args.value}`,
    "colorPicker": `Selector de color`,
    "twoDimensionalSlider": `Regulador 2D`
};

},{}],"9OyEa":[function(require,module,exports) {
module.exports = {
    "colorInputLabel": (args)=>`${args.label}, ${args.channelLabel}`,
    "colorNameAndValue": (args)=>`${args.name}: ${args.value}`,
    "colorPicker": `V\xe4rvivalija`,
    "twoDimensionalSlider": `2D-liugur`
};

},{}],"dKCjI":[function(require,module,exports) {
module.exports = {
    "colorInputLabel": (args)=>`${args.label}, ${args.channelLabel}`,
    "colorNameAndValue": (args)=>`${args.name}: ${args.value}`,
    "colorPicker": `V\xe4rimuokkain`,
    "twoDimensionalSlider": `2D-liukus\xe4\xe4din`
};

},{}],"2hpDo":[function(require,module,exports) {
module.exports = {
    "colorInputLabel": (args)=>`${args.label}, ${args.channelLabel}`,
    "colorNameAndValue": (args)=>`${args.name}\xa0: ${args.value}`,
    "colorPicker": `S\xe9lecteur de couleurs`,
    "twoDimensionalSlider": `Curseur\xa02D`
};

},{}],"469w1":[function(require,module,exports) {
module.exports = {
    "colorInputLabel": (args)=>`${args.label}, ${args.channelLabel}`,
    "colorNameAndValue": (args)=>`${args.name}: ${args.value}`,
    "colorPicker": `\u{5D1}\u{5D5}\u{5D7}\u{5E8} \u{5D4}\u{5E6}\u{5D1}\u{5E2}\u{5D9}\u{5DD}`,
    "twoDimensionalSlider": `\u{5DE}\u{5D7}\u{5D5}\u{5D5}\u{5DF} \u{5D3}\u{5D5} \u{5DE}\u{5D9}\u{5DE}\u{5D3}\u{5D9}`
};

},{}],"cnvn9":[function(require,module,exports) {
module.exports = {
    "colorInputLabel": (args)=>`${args.label}, ${args.channelLabel}`,
    "colorNameAndValue": (args)=>`${args.name}: ${args.value}`,
    "colorPicker": `Odabir boje`,
    "twoDimensionalSlider": `2D kliza\u{10D}`
};

},{}],"eZkZk":[function(require,module,exports) {
module.exports = {
    "colorInputLabel": (args)=>`${args.label}, ${args.channelLabel}`,
    "colorNameAndValue": (args)=>`${args.name}: ${args.value}`,
    "colorPicker": `Sz\xednv\xe1laszt\xf3`,
    "twoDimensionalSlider": `2D-cs\xfaszka`
};

},{}],"2Szk1":[function(require,module,exports) {
module.exports = {
    "colorInputLabel": (args)=>`${args.label}, ${args.channelLabel}`,
    "colorNameAndValue": (args)=>`${args.name}: ${args.value}`,
    "colorPicker": `Selettore colore`,
    "twoDimensionalSlider": `Cursore 2D`
};

},{}],"chFhZ":[function(require,module,exports) {
module.exports = {
    "colorInputLabel": (args)=>`${args.label}\u{3001}${args.channelLabel}`,
    "colorNameAndValue": (args)=>`${args.name} : ${args.value}`,
    "colorPicker": `\u{30AB}\u{30E9}\u{30FC}\u{30D4}\u{30C3}\u{30AB}\u{30FC}`,
    "twoDimensionalSlider": `2D \u{30B9}\u{30E9}\u{30A4}\u{30C0}\u{30FC}`
};

},{}],"TidYg":[function(require,module,exports) {
module.exports = {
    "colorInputLabel": (args)=>`${args.label}, ${args.channelLabel}`,
    "colorNameAndValue": (args)=>`${args.name}: ${args.value}`,
    "colorPicker": `\u{C0C9}\u{C0C1} \u{D53C}\u{CEE4}`,
    "twoDimensionalSlider": `2D \u{C2AC}\u{B77C}\u{C774}\u{B354}`
};

},{}],"dEOBO":[function(require,module,exports) {
module.exports = {
    "colorInputLabel": (args)=>`${args.label}, ${args.channelLabel}`,
    "colorNameAndValue": (args)=>`${args.name}: ${args.value}`,
    "colorPicker": `Spalv\u{173} parinkiklis`,
    "twoDimensionalSlider": `2D slankiklis`
};

},{}],"7MSCX":[function(require,module,exports) {
module.exports = {
    "colorInputLabel": (args)=>`${args.label}, ${args.channelLabel}`,
    "colorNameAndValue": (args)=>`${args.name}: ${args.value}`,
    "colorPicker": `Kr\u{101}su atlas\u{12B}t\u{101}js`,
    "twoDimensionalSlider": `2D sl\u{12B}dnis`
};

},{}],"8bKOo":[function(require,module,exports) {
module.exports = {
    "colorInputLabel": (args)=>`${args.label}, ${args.channelLabel}`,
    "colorNameAndValue": (args)=>`${args.name}: ${args.value}`,
    "colorPicker": `Fargevelger`,
    "twoDimensionalSlider": `2D-glidebryter`
};

},{}],"afLsc":[function(require,module,exports) {
module.exports = {
    "colorInputLabel": (args)=>`${args.label}, ${args.channelLabel}`,
    "colorNameAndValue": (args)=>`${args.name}: ${args.value}`,
    "colorPicker": `Kleurkiezer`,
    "twoDimensionalSlider": `2D-schuifregelaar`
};

},{}],"cBhnw":[function(require,module,exports) {
module.exports = {
    "colorInputLabel": (args)=>`${args.label}, ${args.channelLabel}`,
    "colorNameAndValue": (args)=>`${args.name}: ${args.value}`,
    "colorPicker": `Pr\xf3bnik kolor\xf3w`,
    "twoDimensionalSlider": `Suwak 2D`
};

},{}],"7Ie54":[function(require,module,exports) {
module.exports = {
    "colorInputLabel": (args)=>`${args.label}, ${args.channelLabel}`,
    "colorNameAndValue": (args)=>`${args.name}: ${args.value}`,
    "colorPicker": `Seletor de cores`,
    "twoDimensionalSlider": `Controle deslizante 2D`
};

},{}],"4VlQc":[function(require,module,exports) {
module.exports = {
    "colorInputLabel": (args)=>`${args.label}, ${args.channelLabel}`,
    "colorNameAndValue": (args)=>`${args.name}: ${args.value}`,
    "colorPicker": `Seletor de cores`,
    "twoDimensionalSlider": `Controle deslizante 2D`
};

},{}],"emEVC":[function(require,module,exports) {
module.exports = {
    "colorInputLabel": (args)=>`${args.label}, ${args.channelLabel}`,
    "colorNameAndValue": (args)=>`${args.name}: ${args.value}`,
    "colorPicker": `Selector de culori`,
    "twoDimensionalSlider": `Glisor 2D`
};

},{}],"dWB0J":[function(require,module,exports) {
module.exports = {
    "colorInputLabel": (args)=>`${args.label}, ${args.channelLabel}`,
    "colorNameAndValue": (args)=>`${args.name}: ${args.value}`,
    "colorPicker": `\u{41F}\u{430}\u{43B}\u{438}\u{442}\u{440}\u{430} \u{446}\u{432}\u{435}\u{442}\u{43E}\u{432}`,
    "twoDimensionalSlider": `\u{41F}\u{43E}\u{43B}\u{437}\u{443}\u{43D}\u{43E}\u{43A} 2D`
};

},{}],"7nglw":[function(require,module,exports) {
module.exports = {
    "colorInputLabel": (args)=>`${args.label}, ${args.channelLabel}`,
    "colorNameAndValue": (args)=>`${args.name}: ${args.value}`,
    "colorPicker": `V\xfdber farieb`,
    "twoDimensionalSlider": `2D jazdec`
};

},{}],"bMMdS":[function(require,module,exports) {
module.exports = {
    "colorInputLabel": (args)=>`${args.label}, ${args.channelLabel}`,
    "colorNameAndValue": (args)=>`${args.name}: ${args.value}`,
    "colorPicker": `Izbirnik barv`,
    "twoDimensionalSlider": `2D drsnik`
};

},{}],"7dagf":[function(require,module,exports) {
module.exports = {
    "colorInputLabel": (args)=>`${args.label}, ${args.channelLabel}`,
    "colorNameAndValue": (args)=>`${args.name}: ${args.value}`,
    "colorPicker": `Bira\u{10D} boja`,
    "twoDimensionalSlider": `2D kliza\u{10D}`
};

},{}],"fPpcT":[function(require,module,exports) {
module.exports = {
    "colorInputLabel": (args)=>`${args.label}, ${args.channelLabel}`,
    "colorNameAndValue": (args)=>`${args.name}: ${args.value}`,
    "colorPicker": `F\xe4rgv\xe4ljaren`,
    "twoDimensionalSlider": `2D-reglage`
};

},{}],"8uExj":[function(require,module,exports) {
module.exports = {
    "colorInputLabel": (args)=>`${args.label}, ${args.channelLabel}`,
    "colorNameAndValue": (args)=>`${args.name}: ${args.value}`,
    "colorPicker": `Renk Se\xe7ici`,
    "twoDimensionalSlider": `2D s\xfcrg\xfc`
};

},{}],"8U1B6":[function(require,module,exports) {
module.exports = {
    "colorInputLabel": (args)=>`${args.label}, ${args.channelLabel}`,
    "colorNameAndValue": (args)=>`${args.name}: ${args.value}`,
    "colorPicker": `\u{41F}\u{430}\u{43B}\u{456}\u{442}\u{440}\u{430} \u{43A}\u{43E}\u{43B}\u{44C}\u{43E}\u{440}\u{456}\u{432}`,
    "twoDimensionalSlider": `\u{41F}\u{43E}\u{432}\u{437}\u{443}\u{43D}\u{43E}\u{43A} 2D`
};

},{}],"7gTHa":[function(require,module,exports) {
module.exports = {
    "colorInputLabel": (args)=>`${args.label}\u{3001}${args.channelLabel}`,
    "colorNameAndValue": (args)=>`${args.name}\u{FF1A}${args.value}`,
    "colorPicker": `\u{62FE}\u{8272}\u{5668}`,
    "twoDimensionalSlider": `2D \u{6ED1}\u{5757}`
};

},{}],"lwvkw":[function(require,module,exports) {
module.exports = {
    "colorInputLabel": (args)=>`${args.label}\u{FF0C}${args.channelLabel}`,
    "colorNameAndValue": (args)=>`${args.name}\u{FF1A}${args.value}`,
    "colorPicker": `\u{6AA2}\u{8272}\u{5668}`,
    "twoDimensionalSlider": `2D \u{6ED1}\u{687F}`
};

},{}],"10XAE":[function(require,module,exports) {
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useColorAreaGradient", ()=>useColorAreaGradient);
var _react = require("react");
const generateRGB_R = (orientation, dir, zValue)=>{
    let maskImage = `linear-gradient(to ${orientation[Number(!dir)]}, transparent, #000)`;
    let result = {
        colorAreaStyles: {
            backgroundImage: `linear-gradient(to ${orientation[Number(dir)]},rgb(${zValue},0,0),rgb(${zValue},255,0))`
        },
        gradientStyles: {
            backgroundImage: `linear-gradient(to ${orientation[Number(dir)]},rgb(${zValue},0,255),rgb(${zValue},255,255))`,
            "WebkitMaskImage": maskImage,
            maskImage
        }
    };
    return result;
};
const generateRGB_G = (orientation, dir, zValue)=>{
    let maskImage = `linear-gradient(to ${orientation[Number(!dir)]}, transparent, #000)`;
    let result = {
        colorAreaStyles: {
            backgroundImage: `linear-gradient(to ${orientation[Number(dir)]},rgb(0,${zValue},0),rgb(255,${zValue},0))`
        },
        gradientStyles: {
            backgroundImage: `linear-gradient(to ${orientation[Number(dir)]},rgb(0,${zValue},255),rgb(255,${zValue},255))`,
            "WebkitMaskImage": maskImage,
            maskImage
        }
    };
    return result;
};
const generateRGB_B = (orientation, dir, zValue)=>{
    let maskImage = `linear-gradient(to ${orientation[Number(!dir)]}, transparent, #000)`;
    let result = {
        colorAreaStyles: {
            backgroundImage: `linear-gradient(to ${orientation[Number(dir)]},rgb(0,0,${zValue}),rgb(255,0,${zValue}))`
        },
        gradientStyles: {
            backgroundImage: `linear-gradient(to ${orientation[Number(dir)]},rgb(0,255,${zValue}),rgb(255,255,${zValue}))`,
            "WebkitMaskImage": maskImage,
            maskImage
        }
    };
    return result;
};
const generateHSL_H = (orientation, dir, zValue)=>{
    let result = {
        colorAreaStyles: {},
        gradientStyles: {
            background: [
                `linear-gradient(to ${orientation[Number(dir)]}, hsla(0,0%,0%,1) 0%, hsla(0,0%,0%,0) 50%, hsla(0,0%,100%,0) 50%, hsla(0,0%,100%,1) 100%)`,
                `linear-gradient(to ${orientation[Number(!dir)]},hsl(0,0%,50%),hsla(0,0%,50%,0))`,
                `hsl(${zValue}, 100%, 50%)`
            ].join(",")
        }
    };
    return result;
};
const generateHSL_S = (orientation, dir, alphaValue)=>{
    let result = {
        colorAreaStyles: {},
        gradientStyles: {
            background: [
                `linear-gradient(to ${orientation[Number(!dir)]}, hsla(0,0%,0%,${alphaValue}) 0%, hsla(0,0%,0%,0) 50%, hsla(0,0%,100%,0) 50%, hsla(0,0%,100%,${alphaValue}) 100%)`,
                `linear-gradient(to ${orientation[Number(dir)]},hsla(0,100%,50%,${alphaValue}),hsla(60,100%,50%,${alphaValue}),hsla(120,100%,50%,${alphaValue}),hsla(180,100%,50%,${alphaValue}),hsla(240,100%,50%,${alphaValue}),hsla(300,100%,50%,${alphaValue}),hsla(359,100%,50%,${alphaValue}))`,
                "hsl(0, 0%, 50%)"
            ].join(",")
        }
    };
    return result;
};
const generateHSL_L = (orientation, dir, zValue)=>{
    let result = {
        colorAreaStyles: {},
        gradientStyles: {
            backgroundImage: [
                `linear-gradient(to ${orientation[Number(!dir)]},hsl(0,0%,${zValue}%),hsla(0,0%,${zValue}%,0))`,
                `linear-gradient(to ${orientation[Number(dir)]},hsl(0,100%,${zValue}%),hsl(60,100%,${zValue}%),hsl(120,100%,${zValue}%),hsl(180,100%,${zValue}%),hsl(240,100%,${zValue}%),hsl(300,100%,${zValue}%),hsl(360,100%,${zValue}%))`
            ].join(",")
        }
    };
    return result;
};
const generateHSB_H = (orientation, dir, zValue)=>{
    let result = {
        colorAreaStyles: {},
        gradientStyles: {
            background: [
                `linear-gradient(to ${orientation[Number(dir)]},hsl(0,0%,0%),hsla(0,0%,0%,0))`,
                `linear-gradient(to ${orientation[Number(!dir)]},hsl(0,0%,100%),hsla(0,0%,100%,0))`,
                `hsl(${zValue}, 100%, 50%)`
            ].join(",")
        }
    };
    return result;
};
const generateHSB_S = (orientation, dir, alphaValue)=>{
    let result = {
        colorAreaStyles: {},
        gradientStyles: {
            background: [
                `linear-gradient(to ${orientation[Number(!dir)]},hsla(0,0%,0%,${alphaValue}),hsla(0,0%,0%,0))`,
                `linear-gradient(to ${orientation[Number(dir)]},hsla(0,100%,50%,${alphaValue}),hsla(60,100%,50%,${alphaValue}),hsla(120,100%,50%,${alphaValue}),hsla(180,100%,50%,${alphaValue}),hsla(240,100%,50%,${alphaValue}),hsla(300,100%,50%,${alphaValue}),hsla(359,100%,50%,${alphaValue}))`,
                `linear-gradient(to ${orientation[Number(!dir)]},hsl(0,0%,0%),hsl(0,0%,100%))`
            ].join(",")
        }
    };
    return result;
};
const generateHSB_B = (orientation, dir, alphaValue)=>{
    let result = {
        colorAreaStyles: {},
        gradientStyles: {
            background: [
                `linear-gradient(to ${orientation[Number(!dir)]},hsla(0,0%,100%,${alphaValue}),hsla(0,0%,100%,0))`,
                `linear-gradient(to ${orientation[Number(dir)]},hsla(0,100%,50%,${alphaValue}),hsla(60,100%,50%,${alphaValue}),hsla(120,100%,50%,${alphaValue}),hsla(180,100%,50%,${alphaValue}),hsla(240,100%,50%,${alphaValue}),hsla(300,100%,50%,${alphaValue}),hsla(359,100%,50%,${alphaValue}))`,
                "#000"
            ].join(",")
        }
    };
    return result;
};
function useColorAreaGradient({ direction, state, zChannel, xChannel, isDisabled }) {
    let returnVal = (0, _react.useMemo)(()=>{
        let orientation = [
            "top",
            direction === "rtl" ? "left" : "right"
        ];
        let dir = false;
        let background = {
            colorAreaStyles: {},
            gradientStyles: {}
        };
        let zValue = state.value.getChannelValue(zChannel);
        let { minValue: zMin, maxValue: zMax } = state.value.getChannelRange(zChannel);
        let alphaValue = (zValue - zMin) / (zMax - zMin);
        let isHSL = state.value.getColorSpace() === "hsl";
        if (!isDisabled) switch(zChannel){
            case "red":
                dir = xChannel === "green";
                background = generateRGB_R(orientation, dir, zValue);
                break;
            case "green":
                dir = xChannel === "red";
                background = generateRGB_G(orientation, dir, zValue);
                break;
            case "blue":
                dir = xChannel === "red";
                background = generateRGB_B(orientation, dir, zValue);
                break;
            case "hue":
                dir = xChannel !== "saturation";
                if (isHSL) background = generateHSL_H(orientation, dir, zValue);
                else background = generateHSB_H(orientation, dir, zValue);
                break;
            case "saturation":
                dir = xChannel === "hue";
                if (isHSL) background = generateHSL_S(orientation, dir, alphaValue);
                else background = generateHSB_S(orientation, dir, alphaValue);
                break;
            case "brightness":
                dir = xChannel === "hue";
                background = generateHSB_B(orientation, dir, alphaValue);
                break;
            case "lightness":
                dir = xChannel === "hue";
                background = generateHSL_L(orientation, dir, zValue);
                break;
        }
        let { x, y } = state.getThumbPosition();
        if (direction === "rtl") x = 1 - x;
        let forcedColorAdjustNoneStyle = {
            forcedColorAdjust: "none"
        };
        return {
            colorAreaStyleProps: {
                style: {
                    position: "relative",
                    touchAction: "none",
                    ...forcedColorAdjustNoneStyle,
                    ...background.colorAreaStyles
                }
            },
            gradientStyleProps: {
                style: {
                    touchAction: "none",
                    ...forcedColorAdjustNoneStyle,
                    ...background.gradientStyles
                }
            },
            thumbStyleProps: {
                style: {
                    position: "absolute",
                    left: `${x * 100}%`,
                    top: `${y * 100}%`,
                    transform: "translate(0%, 0%)",
                    touchAction: "none",
                    ...forcedColorAdjustNoneStyle
                }
            }
        };
    }, [
        direction,
        state,
        zChannel,
        xChannel,
        isDisabled
    ]);
    return returnVal;
}

},{"react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"a0NgB":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides the behavior and accessibility implementation for a color slider component.
 * Color sliders allow users to adjust an individual channel of a color value.
 */ parcelHelpers.export(exports, "useColorSlider", ()=>useColorSlider);
var _utils = require("@react-aria/utils");
var _i18N = require("@react-aria/i18n");
var _slider = require("@react-aria/slider");
function useColorSlider(props, state) {
    let { trackRef, inputRef, orientation, channel, "aria-label": ariaLabel, name } = props;
    let { locale, direction } = (0, _i18N.useLocale)();
    // Provide a default aria-label if there is no other label provided.
    if (!props.label && !ariaLabel && !props["aria-labelledby"]) ariaLabel = state.value.getChannelName(channel, locale);
    // @ts-ignore - ignore unused incompatible props
    let { groupProps, trackProps, labelProps, outputProps } = (0, _slider.useSlider)({
        ...props,
        "aria-label": ariaLabel
    }, state, trackRef);
    let { inputProps, thumbProps } = (0, _slider.useSliderThumb)({
        index: 0,
        orientation,
        isDisabled: props.isDisabled,
        name,
        trackRef,
        inputRef
    }, state);
    let generateBackground = ()=>{
        let value = state.getDisplayColor();
        let to;
        if (orientation === "vertical") to = "top";
        else if (direction === "ltr") to = "right";
        else to = "left";
        switch(channel){
            case "hue":
                return `linear-gradient(to ${to}, rgb(255, 0, 0) 0%, rgb(255, 255, 0) 17%, rgb(0, 255, 0) 33%, rgb(0, 255, 255) 50%, rgb(0, 0, 255) 67%, rgb(255, 0, 255) 83%, rgb(255, 0, 0) 100%)`;
            case "lightness":
                {
                    // We have to add an extra color stop in the middle so that the hue shows up at all.
                    // Otherwise it will always just be black to white.
                    let min = state.getThumbMinValue(0);
                    let max = state.getThumbMaxValue(0);
                    let start = value.withChannelValue(channel, min).toString("css");
                    let middle = value.withChannelValue(channel, (max - min) / 2).toString("css");
                    let end = value.withChannelValue(channel, max).toString("css");
                    return `linear-gradient(to ${to}, ${start}, ${middle}, ${end})`;
                }
            case "saturation":
            case "brightness":
            case "red":
            case "green":
            case "blue":
            case "alpha":
                {
                    let start = value.withChannelValue(channel, state.getThumbMinValue(0)).toString("css");
                    let end = value.withChannelValue(channel, state.getThumbMaxValue(0)).toString("css");
                    return `linear-gradient(to ${to}, ${start}, ${end})`;
                }
            default:
                throw new Error("Unknown color channel: " + channel);
        }
    };
    let forcedColorAdjustNoneStyle = {
        forcedColorAdjust: "none"
    };
    return {
        trackProps: {
            ...(0, _utils.mergeProps)(groupProps, trackProps),
            style: {
                ...trackProps.style,
                ...forcedColorAdjustNoneStyle,
                background: generateBackground()
            }
        },
        inputProps,
        thumbProps: {
            ...thumbProps,
            style: {
                ...thumbProps.style,
                ...forcedColorAdjustNoneStyle
            }
        },
        labelProps,
        outputProps
    };
}

},{"@react-aria/utils":"9cLk5","@react-aria/i18n":"411rg","@react-aria/slider":"eOsko","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"iFCBt":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides the behavior and accessibility implementation for a color wheel component.
 * Color wheels allow users to adjust the hue of an HSL or HSB color value on a circular track.
 */ parcelHelpers.export(exports, "useColorWheel", ()=>useColorWheel);
var _utils = require("@react-aria/utils");
var _react = require("react");
var _interactions = require("@react-aria/interactions");
var _i18N = require("@react-aria/i18n");
function useColorWheel(props, state, inputRef) {
    let { isDisabled, innerRadius, outerRadius, "aria-label": ariaLabel, name } = props;
    let { addGlobalListener, removeGlobalListener } = (0, _utils.useGlobalListeners)();
    let thumbRadius = (innerRadius + outerRadius) / 2;
    let focusInput = (0, _react.useCallback)(()=>{
        if (inputRef.current) (0, _utils.focusWithoutScrolling)(inputRef.current);
    }, [
        inputRef
    ]);
    (0, _utils.useFormReset)(inputRef, state.hue, state.setHue);
    let currentPosition = (0, _react.useRef)(null);
    let { keyboardProps } = (0, _interactions.useKeyboard)({
        onKeyDown (e) {
            // these are the cases that useMove doesn't handle
            if (!/^(PageUp|PageDown)$/.test(e.key)) {
                e.continuePropagation();
                return;
            }
            // same handling as useMove, don't need to stop propagation, useKeyboard will do that for us
            e.preventDefault();
            // remember to set this and unset it so that onChangeEnd is fired
            state.setDragging(true);
            switch(e.key){
                case "PageUp":
                    e.preventDefault();
                    state.increment(state.pageStep);
                    break;
                case "PageDown":
                    e.preventDefault();
                    state.decrement(state.pageStep);
                    break;
            }
            state.setDragging(false);
        }
    });
    let moveHandler = {
        onMoveStart () {
            currentPosition.current = null;
            state.setDragging(true);
        },
        onMove ({ deltaX, deltaY, pointerType, shiftKey }) {
            if (currentPosition.current == null) currentPosition.current = state.getThumbPosition(thumbRadius);
            currentPosition.current.x += deltaX;
            currentPosition.current.y += deltaY;
            if (pointerType === "keyboard") {
                if (deltaX > 0 || deltaY < 0) state.increment(shiftKey ? state.pageStep : state.step);
                else if (deltaX < 0 || deltaY > 0) state.decrement(shiftKey ? state.pageStep : state.step);
            } else state.setHueFromPoint(currentPosition.current.x, currentPosition.current.y, thumbRadius);
        },
        onMoveEnd () {
            isOnTrack.current = false;
            state.setDragging(false);
            focusInput();
        }
    };
    let { moveProps: movePropsThumb } = (0, _interactions.useMove)(moveHandler);
    let currentPointer = (0, _react.useRef)(undefined);
    let isOnTrack = (0, _react.useRef)(false);
    let { moveProps: movePropsContainer } = (0, _interactions.useMove)({
        onMoveStart () {
            if (isOnTrack.current) moveHandler.onMoveStart();
        },
        onMove (e) {
            if (isOnTrack.current) moveHandler.onMove(e);
        },
        onMoveEnd () {
            if (isOnTrack.current) moveHandler.onMoveEnd();
        }
    });
    let onThumbDown = (id)=>{
        if (!state.isDragging) {
            currentPointer.current = id;
            focusInput();
            state.setDragging(true);
            if (typeof PointerEvent !== "undefined") addGlobalListener(window, "pointerup", onThumbUp, false);
            else {
                addGlobalListener(window, "mouseup", onThumbUp, false);
                addGlobalListener(window, "touchend", onThumbUp, false);
            }
        }
    };
    let onThumbUp = (e)=>{
        var _e_changedTouches;
        var _e_pointerId;
        let id = (_e_pointerId = e.pointerId) !== null && _e_pointerId !== void 0 ? _e_pointerId : (_e_changedTouches = e.changedTouches) === null || _e_changedTouches === void 0 ? void 0 : _e_changedTouches[0].identifier;
        if (id === currentPointer.current) {
            focusInput();
            state.setDragging(false);
            currentPointer.current = undefined;
            isOnTrack.current = false;
            if (typeof PointerEvent !== "undefined") removeGlobalListener(window, "pointerup", onThumbUp, false);
            else {
                removeGlobalListener(window, "mouseup", onThumbUp, false);
                removeGlobalListener(window, "touchend", onThumbUp, false);
            }
        }
    };
    let onTrackDown = (track, id, pageX, pageY)=>{
        let rect = track.getBoundingClientRect();
        let x = pageX - rect.x - rect.width / 2;
        let y = pageY - rect.y - rect.height / 2;
        let radius = Math.sqrt(x * x + y * y);
        if (innerRadius < radius && radius < outerRadius && !state.isDragging && currentPointer.current === undefined) {
            isOnTrack.current = true;
            currentPointer.current = id;
            state.setHueFromPoint(x, y, radius);
            focusInput();
            state.setDragging(true);
            if (typeof PointerEvent !== "undefined") addGlobalListener(window, "pointerup", onTrackUp, false);
            else {
                addGlobalListener(window, "mouseup", onTrackUp, false);
                addGlobalListener(window, "touchend", onTrackUp, false);
            }
        }
    };
    let onTrackUp = (e)=>{
        var _e_changedTouches;
        var _e_pointerId;
        let id = (_e_pointerId = e.pointerId) !== null && _e_pointerId !== void 0 ? _e_pointerId : (_e_changedTouches = e.changedTouches) === null || _e_changedTouches === void 0 ? void 0 : _e_changedTouches[0].identifier;
        if (isOnTrack.current && id === currentPointer.current) {
            isOnTrack.current = false;
            currentPointer.current = undefined;
            state.setDragging(false);
            focusInput();
            if (typeof PointerEvent !== "undefined") removeGlobalListener(window, "pointerup", onTrackUp, false);
            else {
                removeGlobalListener(window, "mouseup", onTrackUp, false);
                removeGlobalListener(window, "touchend", onTrackUp, false);
            }
        }
    };
    let trackInteractions = isDisabled ? {} : (0, _utils.mergeProps)({
        ...typeof PointerEvent !== "undefined" ? {
            onPointerDown: (e)=>{
                if (e.pointerType === "mouse" && (e.button !== 0 || e.altKey || e.ctrlKey || e.metaKey)) return;
                onTrackDown(e.currentTarget, e.pointerId, e.clientX, e.clientY);
            }
        } : {
            onMouseDown: (e)=>{
                if (e.button !== 0 || e.altKey || e.ctrlKey || e.metaKey) return;
                onTrackDown(e.currentTarget, undefined, e.clientX, e.clientY);
            },
            onTouchStart: (e)=>{
                onTrackDown(e.currentTarget, e.changedTouches[0].identifier, e.changedTouches[0].clientX, e.changedTouches[0].clientY);
            }
        }
    }, movePropsContainer);
    let thumbInteractions = isDisabled ? {} : (0, _utils.mergeProps)({
        onMouseDown: (e)=>{
            if (e.button !== 0 || e.altKey || e.ctrlKey || e.metaKey) return;
            onThumbDown(undefined);
        },
        onPointerDown: (e)=>{
            if (e.pointerType === "mouse" && (e.button !== 0 || e.altKey || e.ctrlKey || e.metaKey)) return;
            onThumbDown(e.pointerId);
        },
        onTouchStart: (e)=>{
            onThumbDown(e.changedTouches[0].identifier);
        }
    }, keyboardProps, movePropsThumb);
    let { x, y } = state.getThumbPosition(thumbRadius);
    // Provide a default aria-label if none is given
    let { locale } = (0, _i18N.useLocale)();
    if (ariaLabel == null && props["aria-labelledby"] == null) ariaLabel = state.value.getChannelName("hue", locale);
    let inputLabellingProps = (0, _utils.useLabels)({
        ...props,
        "aria-label": ariaLabel
    });
    let { minValue, maxValue, step } = state.value.getChannelRange("hue");
    let forcedColorAdjustNoneStyle = {
        forcedColorAdjust: "none"
    };
    return {
        trackProps: {
            ...trackInteractions,
            style: {
                position: "relative",
                touchAction: "none",
                width: outerRadius * 2,
                height: outerRadius * 2,
                background: `
          conic-gradient(
            from 90deg,
            hsl(0, 100%, 50%),
            hsl(30, 100%, 50%),
            hsl(60, 100%, 50%),
            hsl(90, 100%, 50%),
            hsl(120, 100%, 50%),
            hsl(150, 100%, 50%),
            hsl(180, 100%, 50%),
            hsl(210, 100%, 50%),
            hsl(240, 100%, 50%),
            hsl(270, 100%, 50%),
            hsl(300, 100%, 50%),
            hsl(330, 100%, 50%),
            hsl(360, 100%, 50%)
          )
        `,
                clipPath: `path(evenodd, "${circlePath(outerRadius, outerRadius, outerRadius)} ${circlePath(outerRadius, outerRadius, innerRadius)}")`,
                ...forcedColorAdjustNoneStyle
            }
        },
        thumbProps: {
            ...thumbInteractions,
            style: {
                position: "absolute",
                left: "50%",
                top: "50%",
                transform: `translate(calc(${x}px - 50%), calc(${y}px - 50%))`,
                touchAction: "none",
                ...forcedColorAdjustNoneStyle
            }
        },
        inputProps: (0, _utils.mergeProps)(inputLabellingProps, {
            type: "range",
            min: String(minValue),
            max: String(maxValue),
            step: String(step),
            "aria-valuetext": state.value.formatChannelValue("hue", locale),
            disabled: isDisabled,
            value: `${state.value.getChannelValue("hue")}`,
            name,
            onChange: (e)=>{
                state.setHue(parseFloat(e.target.value));
            }
        })
    };
}
// Creates an SVG path string for a circle.
function circlePath(cx, cy, r) {
    return `M ${cx}, ${cy} m ${-r}, 0 a ${r}, ${r}, 0, 1, 0, ${r * 2}, 0 a ${r}, ${r}, 0, 1, 0 ${-r * 2}, 0`;
}

},{"@react-aria/utils":"9cLk5","react":"9yzVZ","@react-aria/interactions":"ky3G8","@react-aria/i18n":"411rg","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"kRXYM":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides the behavior and accessibility implementation for a color field component.
 * Color fields allow users to enter and adjust a hex color value.
 */ parcelHelpers.export(exports, "useColorField", ()=>useColorField);
var _react = require("react");
var _utils = require("@react-aria/utils");
var _form = require("@react-stately/form");
var _interactions = require("@react-aria/interactions");
var _textfield = require("@react-aria/textfield");
var _spinbutton = require("@react-aria/spinbutton");
function useColorField(props, state, ref) {
    let { isDisabled, isReadOnly, isRequired, isWheelDisabled, validationBehavior = "aria" } = props;
    let { colorValue, inputValue, increment, decrement, incrementToMax, decrementToMin, commit } = state;
    let inputId = (0, _utils.useId)();
    let { spinButtonProps } = (0, _spinbutton.useSpinButton)({
        isDisabled,
        isReadOnly,
        isRequired,
        maxValue: 0xFFFFFF,
        minValue: 0,
        onIncrement: increment,
        onIncrementToMax: incrementToMax,
        onDecrement: decrement,
        onDecrementToMin: decrementToMin,
        value: colorValue ? colorValue.toHexInt() : undefined,
        textValue: colorValue ? colorValue.toString("hex") : undefined
    });
    let [focusWithin, setFocusWithin] = (0, _react.useState)(false);
    let { focusWithinProps } = (0, _interactions.useFocusWithin)({
        isDisabled,
        onFocusWithinChange: setFocusWithin
    });
    let onWheel = (0, _react.useCallback)((e)=>{
        if (Math.abs(e.deltaY) <= Math.abs(e.deltaX)) return;
        if (e.deltaY > 0) increment();
        else if (e.deltaY < 0) decrement();
    }, [
        decrement,
        increment
    ]);
    // If the input isn't supposed to receive input, disable scrolling.
    let scrollingDisabled = isWheelDisabled || isDisabled || isReadOnly || !focusWithin;
    (0, _interactions.useScrollWheel)({
        onScroll: onWheel,
        isDisabled: scrollingDisabled
    }, ref);
    let onChange = (value)=>{
        if (state.validate(value)) state.setInputValue(value);
    };
    let { inputProps, ...otherProps } = (0, _textfield.useFormattedTextField)((0, _utils.mergeProps)(props, {
        id: inputId,
        value: inputValue,
        defaultValue: undefined,
        validate: undefined,
        [(0, _form.privateValidationStateProp)]: state,
        type: "text",
        autoComplete: "off",
        onChange
    }), state, ref);
    inputProps = (0, _utils.mergeProps)(inputProps, spinButtonProps, focusWithinProps, {
        role: "textbox",
        "aria-valuemax": null,
        "aria-valuemin": null,
        "aria-valuenow": null,
        "aria-valuetext": null,
        autoCorrect: "off",
        spellCheck: "false",
        onBlur: commit
    });
    if (validationBehavior === "native") inputProps["aria-required"] = undefined;
    return {
        inputProps,
        ...otherProps
    };
}

},{"react":"9yzVZ","@react-aria/utils":"9cLk5","@react-stately/form":"9yZqm","@react-aria/interactions":"ky3G8","@react-aria/textfield":"6dEv6","@react-aria/spinbutton":"3vYfp","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"1aHGl":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parseColor", ()=>(0, _color.parseColor));
parcelHelpers.export(exports, "useColorAreaState", ()=>(0, _useColorAreaState.useColorAreaState));
parcelHelpers.export(exports, "useColorSliderState", ()=>(0, _useColorSliderState.useColorSliderState));
parcelHelpers.export(exports, "useColorWheelState", ()=>(0, _useColorWheelState.useColorWheelState));
parcelHelpers.export(exports, "useColorFieldState", ()=>(0, _useColorFieldState.useColorFieldState));
var _color = require("./Color");
var _useColorAreaState = require("./useColorAreaState");
var _useColorSliderState = require("./useColorSliderState");
var _useColorWheelState = require("./useColorWheelState");
var _useColorFieldState = require("./useColorFieldState");

},{"./Color":"4MncF","./useColorAreaState":"2KaCW","./useColorSliderState":"6bEoE","./useColorWheelState":"4fVyE","./useColorFieldState":"d50ac","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"4MncF":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/** Parses a color from a string value. Throws an error if the string could not be parsed. */ parcelHelpers.export(exports, "parseColor", ()=>parseColor);
parcelHelpers.export(exports, "normalizeColor", ()=>normalizeColor);
var _utils = require("@react-stately/utils");
// @ts-ignore
var _json = require("../intl/*.json");
var _jsonDefault = parcelHelpers.interopDefault(_json);
var _string = require("@internationalized/string");
var _number = require("@internationalized/number");
let dictionary = new (0, _string.LocalizedStringDictionary)((0, _jsonDefault.default));
function parseColor(value) {
    let res = RGBColor.parse(value) || HSBColor.parse(value) || HSLColor.parse(value);
    if (res) return res;
    throw new Error("Invalid color value: " + value);
}
function normalizeColor(v) {
    if (typeof v === "string") return parseColor(v);
    else return v;
}
class Color {
    toHexInt() {
        return this.toFormat("rgb").toHexInt();
    }
    getChannelValue(channel) {
        if (channel in this) return this[channel];
        throw new Error("Unsupported color channel: " + channel);
    }
    withChannelValue(channel, value) {
        if (channel in this) {
            let x = this.clone();
            x[channel] = value;
            return x;
        }
        throw new Error("Unsupported color channel: " + channel);
    }
    getChannelName(channel, locale) {
        let strings = (0, _string.LocalizedStringDictionary).getGlobalDictionaryForPackage("@react-stately/color") || dictionary;
        return strings.getStringForLocale(channel, locale);
    }
    getColorSpaceAxes(xyChannels) {
        let { xChannel, yChannel } = xyChannels;
        let xCh = xChannel || this.getColorChannels().find((c)=>c !== yChannel);
        let yCh = yChannel || this.getColorChannels().find((c)=>c !== xCh);
        let zCh = this.getColorChannels().find((c)=>c !== xCh && c !== yCh);
        return {
            xChannel: xCh,
            yChannel: yCh,
            zChannel: zCh
        };
    }
}
class RGBColor extends Color {
    static parse(value) {
        let colors = [];
        // matching #rgb, #rgba, #rrggbb, #rrggbbaa
        if (/^#[\da-f]+$/i.test(value) && [
            4,
            5,
            7,
            9
        ].includes(value.length)) {
            const values = (value.length < 6 ? value.replace(/[^#]/gi, "$&$&") : value).slice(1).split("");
            while(values.length > 0)colors.push(parseInt(values.splice(0, 2).join(""), 16));
            colors[3] = colors[3] !== undefined ? colors[3] / 255 : undefined;
        }
        // matching rgb(rrr, ggg, bbb), rgba(rrr, ggg, bbb, 0.a)
        const match = value.match(/^rgba?\((.*)\)$/);
        if (match === null || match === void 0 ? void 0 : match[1]) {
            colors = match[1].split(",").map((value)=>Number(value.trim()));
            colors = colors.map((num, i)=>(0, _utils.clamp)(num, 0, i < 3 ? 255 : 1));
        }
        var _colors_;
        return colors.length < 3 ? undefined : new RGBColor(colors[0], colors[1], colors[2], (_colors_ = colors[3]) !== null && _colors_ !== void 0 ? _colors_ : 1);
    }
    toString(format) {
        switch(format){
            case "hex":
                return "#" + (this.red.toString(16).padStart(2, "0") + this.green.toString(16).padStart(2, "0") + this.blue.toString(16).padStart(2, "0")).toUpperCase();
            case "hexa":
                return "#" + (this.red.toString(16).padStart(2, "0") + this.green.toString(16).padStart(2, "0") + this.blue.toString(16).padStart(2, "0") + Math.round(this.alpha * 255).toString(16).padStart(2, "0")).toUpperCase();
            case "rgb":
                return `rgb(${this.red}, ${this.green}, ${this.blue})`;
            case "css":
            case "rgba":
                return `rgba(${this.red}, ${this.green}, ${this.blue}, ${this.alpha})`;
            default:
                return this.toFormat(format).toString(format);
        }
    }
    toFormat(format) {
        switch(format){
            case "hex":
            case "hexa":
            case "rgb":
            case "rgba":
                return this;
            case "hsb":
            case "hsba":
                return this.toHSB();
            case "hsl":
            case "hsla":
                return this.toHSL();
            default:
                throw new Error("Unsupported color conversion: rgb -> " + format);
        }
    }
    toHexInt() {
        return this.red << 16 | this.green << 8 | this.blue;
    }
    /**
   * Converts an RGB color value to HSB.
   * Conversion formula adapted from https://en.wikipedia.org/wiki/HSL_and_HSV#From_RGB.
   * @returns An HSBColor object.
   */ toHSB() {
        const red = this.red / 255;
        const green = this.green / 255;
        const blue = this.blue / 255;
        const min = Math.min(red, green, blue);
        const brightness = Math.max(red, green, blue);
        const chroma = brightness - min;
        const saturation = brightness === 0 ? 0 : chroma / brightness;
        let hue = 0; // achromatic
        if (chroma !== 0) {
            switch(brightness){
                case red:
                    hue = (green - blue) / chroma + (green < blue ? 6 : 0);
                    break;
                case green:
                    hue = (blue - red) / chroma + 2;
                    break;
                case blue:
                    hue = (red - green) / chroma + 4;
                    break;
            }
            hue /= 6;
        }
        return new HSBColor((0, _utils.toFixedNumber)(hue * 360, 2), (0, _utils.toFixedNumber)(saturation * 100, 2), (0, _utils.toFixedNumber)(brightness * 100, 2), this.alpha);
    }
    /**
   * Converts an RGB color value to HSL.
   * Conversion formula adapted from https://en.wikipedia.org/wiki/HSL_and_HSV#From_RGB.
   * @returns An HSLColor object.
   */ toHSL() {
        const red = this.red / 255;
        const green = this.green / 255;
        const blue = this.blue / 255;
        const min = Math.min(red, green, blue);
        const max = Math.max(red, green, blue);
        const lightness = (max + min) / 2;
        const chroma = max - min;
        let hue;
        let saturation;
        if (chroma === 0) hue = saturation = 0; // achromatic
        else {
            saturation = chroma / (lightness < .5 ? max + min : 2 - max - min);
            switch(max){
                case red:
                    hue = (green - blue) / chroma + (green < blue ? 6 : 0);
                    break;
                case green:
                    hue = (blue - red) / chroma + 2;
                    break;
                case blue:
                    hue = (red - green) / chroma + 4;
                    break;
            }
            hue /= 6;
        }
        return new HSLColor((0, _utils.toFixedNumber)(hue * 360, 2), (0, _utils.toFixedNumber)(saturation * 100, 2), (0, _utils.toFixedNumber)(lightness * 100, 2), this.alpha);
    }
    clone() {
        return new RGBColor(this.red, this.green, this.blue, this.alpha);
    }
    getChannelRange(channel) {
        switch(channel){
            case "red":
            case "green":
            case "blue":
                return {
                    minValue: 0x0,
                    maxValue: 0xFF,
                    step: 0x1,
                    pageSize: 0x11
                };
            case "alpha":
                return {
                    minValue: 0,
                    maxValue: 1,
                    step: 0.01,
                    pageSize: 0.1
                };
            default:
                throw new Error("Unknown color channel: " + channel);
        }
    }
    formatChannelValue(channel, locale) {
        let options;
        let value = this.getChannelValue(channel);
        switch(channel){
            case "red":
            case "green":
            case "blue":
                options = {
                    style: "decimal"
                };
                break;
            case "alpha":
                options = {
                    style: "percent"
                };
                break;
            default:
                throw new Error("Unknown color channel: " + channel);
        }
        return new (0, _number.NumberFormatter)(locale, options).format(value);
    }
    getColorSpace() {
        return "rgb";
    }
    getColorChannels() {
        return RGBColor.colorChannels;
    }
    constructor(red, green, blue, alpha){
        super();
        this.red = red;
        this.green = green;
        this.blue = blue;
        this.alpha = alpha;
    }
}
RGBColor.colorChannels = [
    "red",
    "green",
    "blue"
];
// X = <negative/positive number with/without decimal places>
// before/after a comma, 0 or more whitespaces are allowed
// - hsb(X, X%, X%)
// - hsba(X, X%, X%, X)
const HSB_REGEX = /hsb\(([-+]?\d+(?:.\d+)?\s*,\s*[-+]?\d+(?:.\d+)?%\s*,\s*[-+]?\d+(?:.\d+)?%)\)|hsba\(([-+]?\d+(?:.\d+)?\s*,\s*[-+]?\d+(?:.\d+)?%\s*,\s*[-+]?\d+(?:.\d+)?%\s*,\s*[-+]?\d(.\d+)?)\)/;
class HSBColor extends Color {
    static parse(value) {
        let m;
        if (m = value.match(HSB_REGEX)) {
            var _m_;
            const [h, s, b, a] = ((_m_ = m[1]) !== null && _m_ !== void 0 ? _m_ : m[2]).split(",").map((n)=>Number(n.trim().replace("%", "")));
            return new HSBColor(mod(h, 360), (0, _utils.clamp)(s, 0, 100), (0, _utils.clamp)(b, 0, 100), (0, _utils.clamp)(a !== null && a !== void 0 ? a : 1, 0, 1));
        }
    }
    toString(format) {
        switch(format){
            case "css":
                return this.toHSL().toString("css");
            case "hex":
                return this.toRGB().toString("hex");
            case "hexa":
                return this.toRGB().toString("hexa");
            case "hsb":
                return `hsb(${this.hue}, ${(0, _utils.toFixedNumber)(this.saturation, 2)}%, ${(0, _utils.toFixedNumber)(this.brightness, 2)}%)`;
            case "hsba":
                return `hsba(${this.hue}, ${(0, _utils.toFixedNumber)(this.saturation, 2)}%, ${(0, _utils.toFixedNumber)(this.brightness, 2)}%, ${this.alpha})`;
            default:
                return this.toFormat(format).toString(format);
        }
    }
    toFormat(format) {
        switch(format){
            case "hsb":
            case "hsba":
                return this;
            case "hsl":
            case "hsla":
                return this.toHSL();
            case "rgb":
            case "rgba":
                return this.toRGB();
            default:
                throw new Error("Unsupported color conversion: hsb -> " + format);
        }
    }
    /**
   * Converts a HSB color to HSL.
   * Conversion formula adapted from https://en.wikipedia.org/wiki/HSL_and_HSV#HSV_to_HSL.
   * @returns An HSLColor object.
   */ toHSL() {
        let saturation = this.saturation / 100;
        let brightness = this.brightness / 100;
        let lightness = brightness * (1 - saturation / 2);
        saturation = lightness === 0 || lightness === 1 ? 0 : (brightness - lightness) / Math.min(lightness, 1 - lightness);
        return new HSLColor((0, _utils.toFixedNumber)(this.hue, 2), (0, _utils.toFixedNumber)(saturation * 100, 2), (0, _utils.toFixedNumber)(lightness * 100, 2), this.alpha);
    }
    /**
   * Converts a HSV color value to RGB.
   * Conversion formula adapted from https://en.wikipedia.org/wiki/HSL_and_HSV#HSV_to_RGB_alternative.
   * @returns An RGBColor object.
   */ toRGB() {
        let hue = this.hue;
        let saturation = this.saturation / 100;
        let brightness = this.brightness / 100;
        let fn = (n, k = (n + hue / 60) % 6)=>brightness - saturation * brightness * Math.max(Math.min(k, 4 - k, 1), 0);
        return new RGBColor(Math.round(fn(5) * 255), Math.round(fn(3) * 255), Math.round(fn(1) * 255), this.alpha);
    }
    clone() {
        return new HSBColor(this.hue, this.saturation, this.brightness, this.alpha);
    }
    getChannelRange(channel) {
        switch(channel){
            case "hue":
                return {
                    minValue: 0,
                    maxValue: 360,
                    step: 1,
                    pageSize: 15
                };
            case "saturation":
            case "brightness":
                return {
                    minValue: 0,
                    maxValue: 100,
                    step: 1,
                    pageSize: 10
                };
            case "alpha":
                return {
                    minValue: 0,
                    maxValue: 1,
                    step: 0.01,
                    pageSize: 0.1
                };
            default:
                throw new Error("Unknown color channel: " + channel);
        }
    }
    formatChannelValue(channel, locale) {
        let options;
        let value = this.getChannelValue(channel);
        switch(channel){
            case "hue":
                options = {
                    style: "unit",
                    unit: "degree",
                    unitDisplay: "narrow"
                };
                break;
            case "saturation":
            case "brightness":
                options = {
                    style: "percent"
                };
                value /= 100;
                break;
            case "alpha":
                options = {
                    style: "percent"
                };
                break;
            default:
                throw new Error("Unknown color channel: " + channel);
        }
        return new (0, _number.NumberFormatter)(locale, options).format(value);
    }
    getColorSpace() {
        return "hsb";
    }
    getColorChannels() {
        return HSBColor.colorChannels;
    }
    constructor(hue, saturation, brightness, alpha){
        super();
        this.hue = hue;
        this.saturation = saturation;
        this.brightness = brightness;
        this.alpha = alpha;
    }
}
HSBColor.colorChannels = [
    "hue",
    "saturation",
    "brightness"
];
// X = <negative/positive number with/without decimal places>
// before/after a comma, 0 or more whitespaces are allowed
// - hsl(X, X%, X%)
// - hsla(X, X%, X%, X)
const HSL_REGEX = /hsl\(([-+]?\d+(?:.\d+)?\s*,\s*[-+]?\d+(?:.\d+)?%\s*,\s*[-+]?\d+(?:.\d+)?%)\)|hsla\(([-+]?\d+(?:.\d+)?\s*,\s*[-+]?\d+(?:.\d+)?%\s*,\s*[-+]?\d+(?:.\d+)?%\s*,\s*[-+]?\d(.\d+)?)\)/;
function mod(n, m) {
    return (n % m + m) % m;
}
class HSLColor extends Color {
    static parse(value) {
        let m;
        if (m = value.match(HSL_REGEX)) {
            var _m_;
            const [h, s, l, a] = ((_m_ = m[1]) !== null && _m_ !== void 0 ? _m_ : m[2]).split(",").map((n)=>Number(n.trim().replace("%", "")));
            return new HSLColor(mod(h, 360), (0, _utils.clamp)(s, 0, 100), (0, _utils.clamp)(l, 0, 100), (0, _utils.clamp)(a !== null && a !== void 0 ? a : 1, 0, 1));
        }
    }
    toString(format) {
        switch(format){
            case "hex":
                return this.toRGB().toString("hex");
            case "hexa":
                return this.toRGB().toString("hexa");
            case "hsl":
                return `hsl(${this.hue}, ${(0, _utils.toFixedNumber)(this.saturation, 2)}%, ${(0, _utils.toFixedNumber)(this.lightness, 2)}%)`;
            case "css":
            case "hsla":
                return `hsla(${this.hue}, ${(0, _utils.toFixedNumber)(this.saturation, 2)}%, ${(0, _utils.toFixedNumber)(this.lightness, 2)}%, ${this.alpha})`;
            default:
                return this.toFormat(format).toString(format);
        }
    }
    toFormat(format) {
        switch(format){
            case "hsl":
            case "hsla":
                return this;
            case "hsb":
            case "hsba":
                return this.toHSB();
            case "rgb":
            case "rgba":
                return this.toRGB();
            default:
                throw new Error("Unsupported color conversion: hsl -> " + format);
        }
    }
    /**
   * Converts a HSL color to HSB.
   * Conversion formula adapted from https://en.wikipedia.org/wiki/HSL_and_HSV#HSL_to_HSV.
   * @returns An HSBColor object.
   */ toHSB() {
        let saturation = this.saturation / 100;
        let lightness = this.lightness / 100;
        let brightness = lightness + saturation * Math.min(lightness, 1 - lightness);
        saturation = brightness === 0 ? 0 : 2 * (1 - lightness / brightness);
        return new HSBColor((0, _utils.toFixedNumber)(this.hue, 2), (0, _utils.toFixedNumber)(saturation * 100, 2), (0, _utils.toFixedNumber)(brightness * 100, 2), this.alpha);
    }
    /**
   * Converts a HSL color to RGB.
   * Conversion formula adapted from https://en.wikipedia.org/wiki/HSL_and_HSV#HSL_to_RGB_alternative.
   * @returns An RGBColor object.
   */ toRGB() {
        let hue = this.hue;
        let saturation = this.saturation / 100;
        let lightness = this.lightness / 100;
        let a = saturation * Math.min(lightness, 1 - lightness);
        let fn = (n, k = (n + hue / 30) % 12)=>lightness - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
        return new RGBColor(Math.round(fn(0) * 255), Math.round(fn(8) * 255), Math.round(fn(4) * 255), this.alpha);
    }
    clone() {
        return new HSLColor(this.hue, this.saturation, this.lightness, this.alpha);
    }
    getChannelRange(channel) {
        switch(channel){
            case "hue":
                return {
                    minValue: 0,
                    maxValue: 360,
                    step: 1,
                    pageSize: 15
                };
            case "saturation":
            case "lightness":
                return {
                    minValue: 0,
                    maxValue: 100,
                    step: 1,
                    pageSize: 10
                };
            case "alpha":
                return {
                    minValue: 0,
                    maxValue: 1,
                    step: 0.01,
                    pageSize: 0.1
                };
            default:
                throw new Error("Unknown color channel: " + channel);
        }
    }
    formatChannelValue(channel, locale) {
        let options;
        let value = this.getChannelValue(channel);
        switch(channel){
            case "hue":
                options = {
                    style: "unit",
                    unit: "degree",
                    unitDisplay: "narrow"
                };
                break;
            case "saturation":
            case "lightness":
                options = {
                    style: "percent"
                };
                value /= 100;
                break;
            case "alpha":
                options = {
                    style: "percent"
                };
                break;
            default:
                throw new Error("Unknown color channel: " + channel);
        }
        return new (0, _number.NumberFormatter)(locale, options).format(value);
    }
    getColorSpace() {
        return "hsl";
    }
    getColorChannels() {
        return HSLColor.colorChannels;
    }
    constructor(hue, saturation, lightness, alpha){
        super();
        this.hue = hue;
        this.saturation = saturation;
        this.lightness = lightness;
        this.alpha = alpha;
    }
}
HSLColor.colorChannels = [
    "hue",
    "saturation",
    "lightness"
];

},{"@react-stately/utils":"cpDPf","../intl/*.json":"2WYPV","@internationalized/string":"3QbrG","@internationalized/number":"h1VQt","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"2WYPV":[function(require,module,exports) {
const _temp0 = require("8261da12f2d796a0");
const _temp1 = require("e7f3cc295bd56c43");
const _temp2 = require("928b156311df314a");
const _temp3 = require("da11529b8a7c7264");
const _temp4 = require("2bd4fec20301a6e1");
const _temp5 = require("cb9e00ee1797bf96");
const _temp6 = require("df40c9f1e99342bc");
const _temp7 = require("2b741161a64c7f86");
const _temp8 = require("a0ab208d0c4d9bbc");
const _temp9 = require("6df59a33f8752594");
const _temp10 = require("95e83656be88a0b9");
const _temp11 = require("7b43c4f28c496178");
const _temp12 = require("ca7ab27d3dbdd701");
const _temp13 = require("9f280952ec6332d");
const _temp14 = require("a16fa84e8bec6f6d");
const _temp15 = require("87fa3c86dcff8488");
const _temp16 = require("7643407c7cc55124");
const _temp17 = require("8473098240aaa140");
const _temp18 = require("5a1160f9f8fea50a");
const _temp19 = require("2e5cb06bca7c3095");
const _temp20 = require("7888108d023a7b7f");
const _temp21 = require("61ff268bb8d1d4ac");
const _temp22 = require("3df506a2b962a66c");
const _temp23 = require("3c242200fe67447");
const _temp24 = require("50e3a59c589af3e6");
const _temp25 = require("d2499b131531a58f");
const _temp26 = require("e7105632fe9719e");
const _temp27 = require("1ab0cac6d4283cba");
const _temp28 = require("d0c6a9c4b1c1a945");
const _temp29 = require("9f55ffca6e1e6aee");
const _temp30 = require("ad7f8d39c3c9bbf1");
const _temp31 = require("9e2a03a6e3891821");
const _temp32 = require("84e9a5375c4b8dcf");
const _temp33 = require("3165da1482829949");
module.exports = {
    "ar-AE": _temp0,
    "bg-BG": _temp1,
    "cs-CZ": _temp2,
    "da-DK": _temp3,
    "de-DE": _temp4,
    "el-GR": _temp5,
    "en-US": _temp6,
    "es-ES": _temp7,
    "et-EE": _temp8,
    "fi-FI": _temp9,
    "fr-FR": _temp10,
    "he-IL": _temp11,
    "hr-HR": _temp12,
    "hu-HU": _temp13,
    "it-IT": _temp14,
    "ja-JP": _temp15,
    "ko-KR": _temp16,
    "lt-LT": _temp17,
    "lv-LV": _temp18,
    "nb-NO": _temp19,
    "nl-NL": _temp20,
    "pl-PL": _temp21,
    "pt-BR": _temp22,
    "pt-PT": _temp23,
    "ro-RO": _temp24,
    "ru-RU": _temp25,
    "sk-SK": _temp26,
    "sl-SI": _temp27,
    "sr-SP": _temp28,
    "sv-SE": _temp29,
    "tr-TR": _temp30,
    "uk-UA": _temp31,
    "zh-CN": _temp32,
    "zh-TW": _temp33
};

},{"8261da12f2d796a0":"ij4FO","e7f3cc295bd56c43":"6wGXv","928b156311df314a":"ePOx7","da11529b8a7c7264":"9R3oE","2bd4fec20301a6e1":"kO7iL","cb9e00ee1797bf96":"aZbQO","df40c9f1e99342bc":"eaF4n","2b741161a64c7f86":"gkXWh","a0ab208d0c4d9bbc":"5cgme","6df59a33f8752594":"bsEyM","95e83656be88a0b9":"btTL3","7b43c4f28c496178":"7M6RP","ca7ab27d3dbdd701":"4N49p","9f280952ec6332d":"byZnS","a16fa84e8bec6f6d":"lqlIb","87fa3c86dcff8488":"k5Upk","7643407c7cc55124":"bDc9x","8473098240aaa140":"1D1iO","5a1160f9f8fea50a":"5JYZf","2e5cb06bca7c3095":"idZ7l","7888108d023a7b7f":"7IRf3","61ff268bb8d1d4ac":"aSlu1","3df506a2b962a66c":"4xa6g","3c242200fe67447":"ayWjY","50e3a59c589af3e6":"fCg0c","d2499b131531a58f":"cg7m5","e7105632fe9719e":"ctUUu","1ab0cac6d4283cba":"4Mrdp","d0c6a9c4b1c1a945":"77caw","9f55ffca6e1e6aee":"k0yVG","ad7f8d39c3c9bbf1":"4ujd7","9e2a03a6e3891821":"c38xv","84e9a5375c4b8dcf":"kDrou","3165da1482829949":"3NiUS"}],"ij4FO":[function(require,module,exports) {
module.exports = {
    "alpha": `\u{623}\u{644}\u{641}\u{627}`,
    "blue": `\u{623}\u{632}\u{631}\u{642}`,
    "brightness": `\u{627}\u{644}\u{633}\u{637}\u{648}\u{639}`,
    "green": `\u{623}\u{62E}\u{636}\u{631}`,
    "hue": `\u{62F}\u{631}\u{62C}\u{629} \u{627}\u{644}\u{644}\u{648}\u{646}`,
    "lightness": `\u{627}\u{644}\u{625}\u{636}\u{627}\u{621}\u{629}`,
    "red": `\u{623}\u{62D}\u{645}\u{631}`,
    "saturation": `\u{627}\u{644}\u{62A}\u{634}\u{628}\u{639}`
};

},{}],"6wGXv":[function(require,module,exports) {
module.exports = {
    "alpha": `\u{410}\u{43B}\u{444}\u{430}`,
    "blue": `\u{421}\u{438}\u{43D}\u{44C}\u{43E}`,
    "brightness": `\u{42F}\u{440}\u{43A}\u{43E}\u{441}\u{442}`,
    "green": `\u{417}\u{435}\u{43B}\u{435}\u{43D}\u{43E}`,
    "hue": `\u{41E}\u{442}\u{442}\u{435}\u{43D}\u{44A}\u{43A}`,
    "lightness": `\u{41B}\u{435}\u{43A}\u{43E}\u{442}\u{430}`,
    "red": `\u{427}\u{435}\u{440}\u{432}\u{435}\u{43D}\u{43E}`,
    "saturation": `\u{41D}\u{430}\u{441}\u{438}\u{442}\u{435}\u{43D}\u{43E}\u{441}\u{442}`
};

},{}],"ePOx7":[function(require,module,exports) {
module.exports = {
    "alpha": `Alfa`,
    "blue": `Modr\xe1`,
    "brightness": `Jas`,
    "green": `Zelen\xe1`,
    "hue": `Odst\xedn`,
    "lightness": `Sv\u{11B}tlost`,
    "red": `\u{10C}erven\xe1`,
    "saturation": `Sytost`
};

},{}],"9R3oE":[function(require,module,exports) {
module.exports = {
    "alpha": `Alfa`,
    "blue": `Bl\xe5`,
    "brightness": `Lysstyrke`,
    "green": `Gr\xf8n`,
    "hue": `Tone`,
    "lightness": `Lyshed`,
    "red": `R\xf8d`,
    "saturation": `Farvem\xe6tning`
};

},{}],"kO7iL":[function(require,module,exports) {
module.exports = {
    "alpha": `Alpha`,
    "blue": `Blau`,
    "brightness": `Helligkeit`,
    "green": `Gr\xfcn`,
    "hue": `Farbton`,
    "lightness": `Leuchtkraft`,
    "red": `Rot`,
    "saturation": `S\xe4ttigung`
};

},{}],"aZbQO":[function(require,module,exports) {
module.exports = {
    "alpha": `\u{386}\u{3BB}\u{3C6}\u{3B1}`,
    "blue": `\u{39C}\u{3C0}\u{3BB}\u{3B5}`,
    "brightness": `\u{3A6}\u{3C9}\u{3C4}\u{3B5}\u{3B9}\u{3BD}\u{3CC}\u{3C4}\u{3B7}\u{3C4}\u{3B1}`,
    "green": `\u{3A0}\u{3C1}\u{3AC}\u{3C3}\u{3B9}\u{3BD}\u{3BF}`,
    "hue": `\u{3A4}\u{3CC}\u{3BD}\u{3BF}\u{3C2}`,
    "lightness": `\u{3A6}\u{3C9}\u{3C4}\u{3B5}\u{3B9}\u{3BD}\u{3CC}\u{3C4}\u{3B7}\u{3C4}\u{3B1}`,
    "red": `\u{39A}\u{3CC}\u{3BA}\u{3BA}\u{3B9}\u{3BD}\u{3BF}`,
    "saturation": `\u{39A}\u{3BF}\u{3C1}\u{3B5}\u{3C3}\u{3BC}\u{3CC}\u{3C2}`
};

},{}],"eaF4n":[function(require,module,exports) {
module.exports = {
    "hue": `Hue`,
    "saturation": `Saturation`,
    "lightness": `Lightness`,
    "brightness": `Brightness`,
    "red": `Red`,
    "green": `Green`,
    "blue": `Blue`,
    "alpha": `Alpha`
};

},{}],"gkXWh":[function(require,module,exports) {
module.exports = {
    "alpha": `Alpha`,
    "blue": `Azul`,
    "brightness": `Brillo`,
    "green": `Verde`,
    "hue": `Tono`,
    "lightness": `Luminosidad`,
    "red": `Rojo`,
    "saturation": `Saturaci\xf3n`
};

},{}],"5cgme":[function(require,module,exports) {
module.exports = {
    "alpha": `Alfa`,
    "blue": `Sinine`,
    "brightness": `Heledus`,
    "green": `Roheline`,
    "hue": `V\xe4rv`,
    "lightness": `Valgus`,
    "red": `Punane`,
    "saturation": `K\xfcllastus`
};

},{}],"bsEyM":[function(require,module,exports) {
module.exports = {
    "alpha": `Alpha`,
    "blue": `Sininen`,
    "brightness": `Kirkkaus`,
    "green": `Vihre\xe4`,
    "hue": `S\xe4vy`,
    "lightness": `Valom\xe4\xe4r\xe4`,
    "red": `Punainen`,
    "saturation": `V\xe4rikyll\xe4isyys`
};

},{}],"btTL3":[function(require,module,exports) {
module.exports = {
    "alpha": `Alpha`,
    "blue": `Bleu`,
    "brightness": `Luminosit\xe9`,
    "green": `Vert`,
    "hue": `Teinte`,
    "lightness": `Luminosit\xe9`,
    "red": `Rouge`,
    "saturation": `Saturation`
};

},{}],"7M6RP":[function(require,module,exports) {
module.exports = {
    "alpha": `\u{5D0}\u{5DC}\u{5E4}\u{5D0}`,
    "blue": `\u{5DB}\u{5D7}\u{5D5}\u{5DC}`,
    "brightness": `\u{5D1}\u{5D4}\u{5D9}\u{5E8}\u{5D5}\u{5EA}`,
    "green": `\u{5D9}\u{5E8}\u{5D5}\u{5E7}`,
    "hue": `\u{5D2}\u{5D5}\u{5D5}\u{5DF}`,
    "lightness": `\u{5DB}\u{5DE}\u{5D5}\u{5EA} \u{5D0}\u{5D5}\u{5E8}`,
    "red": `\u{5D0}\u{5D3}\u{5D5}\u{5DD}`,
    "saturation": `\u{5E8}\u{5D5}\u{5D5}\u{5D9}\u{5D4}`
};

},{}],"4N49p":[function(require,module,exports) {
module.exports = {
    "alpha": `Alfa`,
    "blue": `Plava`,
    "brightness": `Svjetlina`,
    "green": `Zelena`,
    "hue": `Nijansa`,
    "lightness": `Osvijetljenost`,
    "red": `Crvena`,
    "saturation": `Zasi\u{107}enost`
};

},{}],"byZnS":[function(require,module,exports) {
module.exports = {
    "alpha": `Alfa`,
    "blue": `K\xe9k`,
    "brightness": `F\xe9nyess\xe9g`,
    "green": `Z\xf6ld`,
    "hue": `Sz\xedn\xe1rnyalat`,
    "lightness": `Vil\xe1goss\xe1g`,
    "red": `Piros`,
    "saturation": `Tel\xedtetts\xe9g`
};

},{}],"lqlIb":[function(require,module,exports) {
module.exports = {
    "alpha": `Alfa`,
    "blue": `Blu`,
    "brightness": `Luminosit\xe0`,
    "green": `Verde`,
    "hue": `Tonalit\xe0`,
    "lightness": `Luminosit\xe0`,
    "red": `Rosso`,
    "saturation": `Saturazione`
};

},{}],"k5Upk":[function(require,module,exports) {
module.exports = {
    "alpha": `\u{30A2}\u{30EB}\u{30D5}\u{30A1}`,
    "blue": `\u{9752}`,
    "brightness": `\u{660E}\u{308B}\u{3055}`,
    "green": `\u{7DD1}`,
    "hue": `\u{8272}\u{76F8}`,
    "lightness": `\u{660E}\u{5EA6}`,
    "red": `\u{8D64}`,
    "saturation": `\u{5F69}\u{5EA6}`
};

},{}],"bDc9x":[function(require,module,exports) {
module.exports = {
    "alpha": `\u{C54C}\u{D30C}`,
    "blue": `\u{D30C}\u{B791}`,
    "brightness": `\u{BA85}\u{B3C4}`,
    "green": `\u{CD08}\u{B85D}`,
    "hue": `\u{C0C9}\u{C870}`,
    "lightness": `\u{BC1D}\u{AE30}`,
    "red": `\u{BE68}\u{AC15}`,
    "saturation": `\u{CC44}\u{B3C4}`
};

},{}],"1D1iO":[function(require,module,exports) {
module.exports = {
    "alpha": `Alfa`,
    "blue": `M\u{117}lyna`,
    "brightness": `Ry\u{161}kumas`,
    "green": `\u{17D}alia`,
    "hue": `Atspalvis`,
    "lightness": `\u{160}viesumas`,
    "red": `Raudona`,
    "saturation": `\u{12E}sotinimas`
};

},{}],"5JYZf":[function(require,module,exports) {
module.exports = {
    "alpha": `Alfa`,
    "blue": `Zila`,
    "brightness": `Spilgtums`,
    "green": `Za\u{13C}a`,
    "hue": `Nokr\u{101}sa`,
    "lightness": `Gai\u{161}ums`,
    "red": `Sarkana`,
    "saturation": `Pies\u{101}tin\u{101}jums`
};

},{}],"idZ7l":[function(require,module,exports) {
module.exports = {
    "alpha": `Alfa`,
    "blue": `Bl\xe5`,
    "brightness": `Lysstyrke`,
    "green": `Gr\xf8nn`,
    "hue": `Fargetone`,
    "lightness": `Lyshet`,
    "red": `R\xf8d`,
    "saturation": `Metning`
};

},{}],"7IRf3":[function(require,module,exports) {
module.exports = {
    "alpha": `Alfa`,
    "blue": `Blauw`,
    "brightness": `Helderheid`,
    "green": `Groen`,
    "hue": `Kleurtoon`,
    "lightness": `Lichtsterkte`,
    "red": `Rood`,
    "saturation": `Verzadiging`
};

},{}],"aSlu1":[function(require,module,exports) {
module.exports = {
    "alpha": `Alfa`,
    "blue": `Niebieski`,
    "brightness": `Jasno\u{15B}\u{107}`,
    "green": `Zielony`,
    "hue": `Odcie\u{144}`,
    "lightness": `Jaskrawo\u{15B}\u{107}`,
    "red": `Czerwony`,
    "saturation": `Nasycenie`
};

},{}],"4xa6g":[function(require,module,exports) {
module.exports = {
    "alpha": `Alfa`,
    "blue": `Azul`,
    "brightness": `Brilho`,
    "green": `Verde`,
    "hue": `Matiz`,
    "lightness": `Luminosidade`,
    "red": `Vermelho`,
    "saturation": `Satura\xe7\xe3o`
};

},{}],"ayWjY":[function(require,module,exports) {
module.exports = {
    "alpha": `Alfa`,
    "blue": `Azul`,
    "brightness": `Luminosidade`,
    "green": `Verde`,
    "hue": `Tonalidade`,
    "lightness": `Claridade`,
    "red": `Vermelho`,
    "saturation": `Satura\xe7\xe3o`
};

},{}],"fCg0c":[function(require,module,exports) {
module.exports = {
    "alpha": `Alfa`,
    "blue": `Albastru`,
    "brightness": `Luminozitate`,
    "green": `Verde`,
    "hue": `Nuan\u{21B}\u{103}`,
    "lightness": `Luminozitate`,
    "red": `Ro\u{219}u`,
    "saturation": `Satura\u{21B}ie`
};

},{}],"cg7m5":[function(require,module,exports) {
module.exports = {
    "alpha": `\u{410}\u{43B}\u{44C}\u{444}\u{430}`,
    "blue": `\u{421}\u{438}\u{43D}\u{438}\u{439}`,
    "brightness": `\u{42F}\u{440}\u{43A}\u{43E}\u{441}\u{442}\u{44C}`,
    "green": `\u{417}\u{435}\u{43B}\u{435}\u{43D}\u{44B}\u{439}`,
    "hue": `\u{41E}\u{442}\u{442}\u{435}\u{43D}\u{43E}\u{43A}`,
    "lightness": `\u{41E}\u{441}\u{432}\u{435}\u{449}\u{435}\u{43D}\u{43D}\u{43E}\u{441}\u{442}\u{44C}`,
    "red": `\u{41A}\u{440}\u{430}\u{441}\u{43D}\u{44B}\u{439}`,
    "saturation": `\u{41D}\u{430}\u{441}\u{44B}\u{449}\u{435}\u{43D}\u{43D}\u{43E}\u{441}\u{442}\u{44C}`
};

},{}],"ctUUu":[function(require,module,exports) {
module.exports = {
    "alpha": `Alfa`,
    "blue": `Modr\xe1`,
    "brightness": `Jas`,
    "green": `Zelen\xe1`,
    "hue": `Odtie\u{148}`,
    "lightness": `Svetlos\u{165}`,
    "red": `\u{10C}erven\xe1`,
    "saturation": `S\xfdtos\u{165}`
};

},{}],"4Mrdp":[function(require,module,exports) {
module.exports = {
    "alpha": `Alfa`,
    "blue": `Modra`,
    "brightness": `Svetlost`,
    "green": `Zelena`,
    "hue": `Barva`,
    "lightness": `Lahkost`,
    "red": `Rde\u{10D}a`,
    "saturation": `Nasi\u{10D}enost`
};

},{}],"77caw":[function(require,module,exports) {
module.exports = {
    "alpha": `Alfa`,
    "blue": `Plava`,
    "brightness": `Osvetljenost`,
    "green": `Zelena`,
    "hue": `Nijansa`,
    "lightness": `Osvetljenje`,
    "red": `Crvena`,
    "saturation": `Zasi\u{107}enje`
};

},{}],"k0yVG":[function(require,module,exports) {
module.exports = {
    "alpha": `Alfa`,
    "blue": `Bl\xe5tt`,
    "brightness": `Ljusstyrka`,
    "green": `Gr\xf6nt`,
    "hue": `Nyans`,
    "lightness": `Ljushet`,
    "red": `R\xf6tt`,
    "saturation": `M\xe4ttnad`
};

},{}],"4ujd7":[function(require,module,exports) {
module.exports = {
    "alpha": `Alfa`,
    "blue": `Mavi`,
    "brightness": `Parlakl\u{131}k`,
    "green": `Ye\u{15F}il`,
    "hue": `Ton`,
    "lightness": `Canl\u{131}l\u{131}k`,
    "red": `K\u{131}rm\u{131}z\u{131}`,
    "saturation": `Doygunluk`
};

},{}],"c38xv":[function(require,module,exports) {
module.exports = {
    "alpha": `\u{410}\u{43B}\u{44C}\u{444}\u{430}`,
    "blue": `\u{421}\u{438}\u{43D}\u{456}\u{439}`,
    "brightness": `\u{42F}\u{441}\u{43A}\u{440}\u{430}\u{432}\u{456}\u{441}\u{442}\u{44C}`,
    "green": `\u{417}\u{435}\u{43B}\u{435}\u{43D}\u{438}\u{439}`,
    "hue": `\u{422}\u{43E}\u{43D}`,
    "lightness": `\u{41E}\u{441}\u{432}\u{456}\u{442}\u{43B}\u{435}\u{43D}\u{456}\u{441}\u{442}\u{44C}`,
    "red": `\u{427}\u{435}\u{440}\u{432}\u{43E}\u{43D}\u{438}\u{439}`,
    "saturation": `\u{41D}\u{430}\u{441}\u{438}\u{447}\u{435}\u{43D}\u{456}\u{441}\u{442}\u{44C}`
};

},{}],"kDrou":[function(require,module,exports) {
module.exports = {
    "alpha": `Alpha`,
    "blue": `\u{84DD}\u{8272}`,
    "brightness": `\u{4EAE}\u{5EA6}`,
    "green": `\u{7EFF}\u{8272}`,
    "hue": `\u{8272}\u{76F8}`,
    "lightness": `\u{660E}\u{4EAE}\u{5EA6}`,
    "red": `\u{7EA2}\u{8272}`,
    "saturation": `\u{9971}\u{548C}\u{5EA6}`
};

},{}],"3NiUS":[function(require,module,exports) {
module.exports = {
    "alpha": `Alpha`,
    "blue": `\u{85CD}\u{8272}`,
    "brightness": `\u{4EAE}\u{5EA6}`,
    "green": `\u{7DA0}\u{8272}`,
    "hue": `\u{8272}\u{76F8}`,
    "lightness": `\u{660E}\u{4EAE}`,
    "red": `\u{7D05}\u{8272}`,
    "saturation": `\u{98FD}\u{548C}\u{5EA6}`
};

},{}],"2KaCW":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides state management for a color area component.
 * Color area allows users to adjust two channels of an HSL, HSB or RGB color value against a two-dimensional gradient background.
 */ parcelHelpers.export(exports, "useColorAreaState", ()=>useColorAreaState);
var _utils = require("@react-stately/utils");
var _color = require("./Color");
var _react = require("react");
const DEFAULT_COLOR = (0, _color.parseColor)("#ffffff");
function useColorAreaState(props) {
    let { value, defaultValue, xChannel, yChannel, onChange, onChangeEnd } = props;
    if (!value && !defaultValue) defaultValue = DEFAULT_COLOR;
    let [color, setColorState] = (0, _utils.useControlledState)(value && (0, _color.normalizeColor)(value), defaultValue && (0, _color.normalizeColor)(defaultValue), onChange);
    let valueRef = (0, _react.useRef)(color);
    let setColor = (color)=>{
        valueRef.current = color;
        setColorState(color);
    };
    let channels = (0, _react.useMemo)(()=>color.getColorSpaceAxes({
            xChannel,
            yChannel
        }), [
        color,
        xChannel,
        yChannel
    ]);
    let xChannelRange = color.getChannelRange(channels.xChannel);
    let yChannelRange = color.getChannelRange(channels.yChannel);
    let { minValue: minValueX, maxValue: maxValueX, step: stepX, pageSize: pageSizeX } = xChannelRange;
    let { minValue: minValueY, maxValue: maxValueY, step: stepY, pageSize: pageSizeY } = yChannelRange;
    let [isDragging, setDragging] = (0, _react.useState)(false);
    let isDraggingRef = (0, _react.useRef)(false);
    let xValue = color.getChannelValue(channels.xChannel);
    let yValue = color.getChannelValue(channels.yChannel);
    let setXValue = (v)=>{
        if (v === xValue) return;
        let newColor = color.withChannelValue(channels.xChannel, v);
        setColor(newColor);
    };
    let setYValue = (v)=>{
        if (v === yValue) return;
        let newColor = color.withChannelValue(channels.yChannel, v);
        setColor(newColor);
    };
    return {
        channels,
        xChannelStep: stepX,
        yChannelStep: stepY,
        xChannelPageStep: pageSizeX,
        yChannelPageStep: pageSizeY,
        value: color,
        setValue (value) {
            setColor((0, _color.normalizeColor)(value));
        },
        xValue,
        setXValue,
        yValue,
        setYValue,
        setColorFromPoint (x, y) {
            let newXValue = minValueX + (0, _utils.clamp)(x, 0, 1) * (maxValueX - minValueX);
            let newYValue = minValueY + (1 - (0, _utils.clamp)(y, 0, 1)) * (maxValueY - minValueY);
            let newColor;
            if (newXValue !== xValue) {
                // Round new value to multiple of step, clamp value between min and max
                newXValue = (0, _utils.snapValueToStep)(newXValue, minValueX, maxValueX, stepX);
                newColor = color.withChannelValue(channels.xChannel, newXValue);
            }
            if (newYValue !== yValue) {
                // Round new value to multiple of step, clamp value between min and max
                newYValue = (0, _utils.snapValueToStep)(newYValue, minValueY, maxValueY, stepY);
                newColor = (newColor || color).withChannelValue(channels.yChannel, newYValue);
            }
            if (newColor) setColor(newColor);
        },
        getThumbPosition () {
            let x = (xValue - minValueX) / (maxValueX - minValueX);
            let y = 1 - (yValue - minValueY) / (maxValueY - minValueY);
            return {
                x,
                y
            };
        },
        incrementX (stepSize) {
            setXValue(xValue + stepSize > maxValueX ? maxValueX : (0, _utils.snapValueToStep)(xValue + stepSize, minValueX, maxValueX, stepX));
        },
        incrementY (stepSize) {
            setYValue(yValue + stepSize > maxValueY ? maxValueY : (0, _utils.snapValueToStep)(yValue + stepSize, minValueY, maxValueY, stepY));
        },
        decrementX (stepSize) {
            setXValue((0, _utils.snapValueToStep)(xValue - stepSize, minValueX, maxValueX, stepX));
        },
        decrementY (stepSize) {
            setYValue((0, _utils.snapValueToStep)(yValue - stepSize, minValueY, maxValueY, stepY));
        },
        setDragging (isDragging) {
            let wasDragging = isDraggingRef.current;
            isDraggingRef.current = isDragging;
            if (onChangeEnd && !isDragging && wasDragging) onChangeEnd(valueRef.current);
            setDragging(isDragging);
        },
        isDragging,
        getDisplayColor () {
            return color.withChannelValue("alpha", 1);
        }
    };
}

},{"@react-stately/utils":"cpDPf","./Color":"4MncF","react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"6bEoE":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides state management for a color slider component.
 * Color sliders allow users to adjust an individual channel of a color value.
 */ parcelHelpers.export(exports, "useColorSliderState", ()=>useColorSliderState);
var _color = require("./Color");
var _slider = require("@react-stately/slider");
var _utils = require("@react-stately/utils");
function useColorSliderState(props) {
    let { channel, value, defaultValue, onChange, locale, ...otherProps } = props;
    if (value == null && defaultValue == null) throw new Error("useColorSliderState requires a value or defaultValue");
    let [color, setColor] = (0, _utils.useControlledState)(value && (0, _color.normalizeColor)(value), defaultValue && (0, _color.normalizeColor)(defaultValue), onChange);
    let sliderState = (0, _slider.useSliderState)({
        ...color.getChannelRange(channel),
        ...otherProps,
        // Unused except in getThumbValueLabel, which is overridden below. null to appease TypeScript.
        numberFormatter: null,
        value: color.getChannelValue(channel),
        onChange (v) {
            setColor(color.withChannelValue(channel, v));
        },
        onChangeEnd (v) {
            // onChange will have already been called with the right value, this is just to trigger onChangeEnd
            if (props.onChangeEnd) props.onChangeEnd(color.withChannelValue(channel, v));
        }
    });
    let { step, pageSize } = color.getChannelRange(channel);
    return {
        ...sliderState,
        value: color,
        setValue (value) {
            setColor((0, _color.normalizeColor)(value));
        },
        getDisplayColor () {
            switch(channel){
                case "hue":
                    return (0, _color.parseColor)(`hsl(${color.getChannelValue("hue")}, 100%, 50%)`);
                case "lightness":
                case "brightness":
                case "saturation":
                case "red":
                case "green":
                case "blue":
                    return color.withChannelValue("alpha", 1);
                case "alpha":
                    return color;
                default:
                    throw new Error("Unknown color channel: " + channel);
            }
        },
        getThumbValueLabel () {
            return color.formatChannelValue(channel, locale);
        },
        step,
        pageSize
    };
}

},{"./Color":"4MncF","@react-stately/slider":"82Whk","@react-stately/utils":"cpDPf","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"4fVyE":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides state management for a color wheel component.
 * Color wheels allow users to adjust the hue of an HSL or HSB color value on a circular track.
 */ parcelHelpers.export(exports, "useColorWheelState", ()=>useColorWheelState);
var _color = require("./Color");
var _utils = require("@react-stately/utils");
var _react = require("react");
const DEFAULT_COLOR = (0, _color.parseColor)("hsl(0, 100%, 50%)");
function roundToStep(value, step) {
    return Math.round(value / step) * step;
}
function mod(n, m) {
    return (n % m + m) % m;
}
function roundDown(v) {
    let r = Math.floor(v);
    if (r === v) return v - 1;
    else return r;
}
function degToRad(deg) {
    return deg * Math.PI / 180;
}
function radToDeg(rad) {
    return rad * 180 / Math.PI;
}
// 0deg = 3 o'clock. increases clockwise
function angleToCartesian(angle, radius) {
    let rad = degToRad(360 - angle + 90);
    let x = Math.sin(rad) * radius;
    let y = Math.cos(rad) * radius;
    return {
        x,
        y
    };
}
function cartesianToAngle(x, y, radius) {
    let deg = radToDeg(Math.atan2(y / radius, x / radius));
    return (deg + 360) % 360;
}
function useColorWheelState(props) {
    let { defaultValue, onChange, onChangeEnd } = props;
    if (!props.value && !defaultValue) defaultValue = DEFAULT_COLOR;
    let [value, setValueState] = (0, _utils.useControlledState)((0, _color.normalizeColor)(props.value), (0, _color.normalizeColor)(defaultValue), onChange);
    let valueRef = (0, _react.useRef)(value);
    let setValue = (value)=>{
        valueRef.current = value;
        setValueState(value);
    };
    let channelRange = value.getChannelRange("hue");
    let { minValue: minValueX, maxValue: maxValueX, step: step, pageSize: pageStep } = channelRange;
    let [isDragging, setDragging] = (0, _react.useState)(false);
    let isDraggingRef = (0, _react.useRef)(false);
    let hue = value.getChannelValue("hue");
    function setHue(v) {
        if (v > 360) // Make sure you can always get back to 0.
        v = 0;
        v = roundToStep(mod(v, 360), step);
        if (hue !== v) {
            let color = value.withChannelValue("hue", v);
            setValue(color);
        }
    }
    return {
        value,
        step,
        pageStep,
        setValue (v) {
            let color = (0, _color.normalizeColor)(v);
            setValue(color);
        },
        hue,
        setHue,
        setHueFromPoint (x, y, radius) {
            setHue(cartesianToAngle(x, y, radius));
        },
        getThumbPosition (radius) {
            return angleToCartesian(value.getChannelValue("hue"), radius);
        },
        increment (stepSize = 1) {
            let s = Math.max(stepSize, step);
            let newValue = hue + s;
            if (newValue >= maxValueX) // Make sure you can always get back to 0.
            newValue = minValueX;
            setHue(roundToStep(mod(newValue, 360), s));
        },
        decrement (stepSize = 1) {
            let s = Math.max(stepSize, step);
            if (hue === 0) // We can't just subtract step because this might be the case:
            // |(previous step) - 0| < step size
            setHue(roundDown(360 / s) * s);
            else setHue(roundToStep(mod(hue - s, 360), s));
        },
        setDragging (isDragging) {
            let wasDragging = isDraggingRef.current;
            isDraggingRef.current = isDragging;
            if (onChangeEnd && !isDragging && wasDragging) onChangeEnd(valueRef.current);
            setDragging(isDragging);
        },
        isDragging,
        getDisplayColor () {
            return value.toFormat("hsl").withChannelValue("saturation", 100).withChannelValue("lightness", 50).withChannelValue("alpha", 1);
        }
    };
}

},{"./Color":"4MncF","@react-stately/utils":"cpDPf","react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"d50ac":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides state management for a color field component. Color fields allow
 * users to enter and adjust a hex color value.
 */ parcelHelpers.export(exports, "useColorFieldState", ()=>useColorFieldState);
var _form = require("@react-stately/form");
var _color = require("./Color");
var _useColor = require("./useColor");
var _utils = require("@react-stately/utils");
var _react = require("react");
const MIN_COLOR = (0, _color.parseColor)("#000000");
const MAX_COLOR = (0, _color.parseColor)("#FFFFFF");
const MIN_COLOR_INT = MIN_COLOR.toHexInt();
const MAX_COLOR_INT = MAX_COLOR.toHexInt();
function useColorFieldState(props) {
    let { value, defaultValue, onChange } = props;
    let { step } = MIN_COLOR.getChannelRange("red");
    let initialValue = (0, _useColor.useColor)(value);
    let initialDefaultValue = (0, _useColor.useColor)(defaultValue);
    let [colorValue, setColorValue] = (0, _utils.useControlledState)(initialValue, initialDefaultValue, onChange);
    let [inputValue, setInputValue] = (0, _react.useState)(()=>(value || defaultValue) && colorValue ? colorValue.toString("hex") : "");
    let validation = (0, _form.useFormValidationState)({
        ...props,
        value: colorValue
    });
    let safelySetColorValue = (newColor)=>{
        if (!colorValue || !newColor) {
            setColorValue(newColor);
            return;
        }
        if (newColor.toHexInt() !== colorValue.toHexInt()) {
            setColorValue(newColor);
            return;
        }
    };
    let [prevValue, setPrevValue] = (0, _react.useState)(colorValue);
    if (prevValue !== colorValue) {
        setInputValue(colorValue ? colorValue.toString("hex") : "");
        setPrevValue(colorValue);
    }
    let parsedValue = (0, _react.useMemo)(()=>{
        let color;
        try {
            color = (0, _color.parseColor)(inputValue.startsWith("#") ? inputValue : `#${inputValue}`);
        } catch (err) {
            color = null;
        }
        return color;
    }, [
        inputValue
    ]);
    let commit = ()=>{
        // Set to empty state if input value is empty
        if (!inputValue.length) {
            safelySetColorValue(null);
            setInputValue(value === undefined ? "" : colorValue.toString("hex"));
            return;
        }
        // if it failed to parse, then reset input to formatted version of current number
        if (parsedValue == null) {
            setInputValue(colorValue ? colorValue.toString("hex") : "");
            return;
        }
        safelySetColorValue(parsedValue);
        // in a controlled state, the numberValue won't change, so we won't go back to our old input without help
        let newColorValue = "";
        if (colorValue) newColorValue = colorValue.toString("hex");
        setInputValue(newColorValue);
    };
    let increment = ()=>{
        let newValue = addColorValue(parsedValue, step);
        // if we've arrived at the same value that was previously in the state, the
        // input value should be updated to match
        // ex type 4, press increment, highlight the number in the input, type 4 again, press increment
        // you'd be at 5, then incrementing to 5 again, so no re-render would happen and 4 would be left in the input
        if (newValue === colorValue) setInputValue(newValue.toString("hex"));
        safelySetColorValue(newValue);
        validation.commitValidation();
    };
    let decrement = ()=>{
        let newValue = addColorValue(parsedValue, -step);
        // if we've arrived at the same value that was previously in the state, the
        // input value should be updated to match
        // ex type 4, press increment, highlight the number in the input, type 4 again, press increment
        // you'd be at 5, then incrementing to 5 again, so no re-render would happen and 4 would be left in the input
        if (newValue === colorValue) setInputValue(newValue.toString("hex"));
        safelySetColorValue(newValue);
        validation.commitValidation();
    };
    let incrementToMax = ()=>safelySetColorValue(MAX_COLOR);
    let decrementToMin = ()=>safelySetColorValue(MIN_COLOR);
    let validate = (value)=>{
        var _value_match;
        return value === "" || !!((_value_match = value.match(/^#?[0-9a-f]{0,6}$/i)) === null || _value_match === void 0 ? void 0 : _value_match[0]);
    };
    return {
        ...validation,
        validate,
        colorValue,
        inputValue,
        setInputValue,
        commit,
        increment,
        incrementToMax,
        decrement,
        decrementToMin
    };
}
function addColorValue(color, step) {
    let newColor = color ? color : MIN_COLOR;
    let colorInt = newColor.toHexInt();
    let clampInt = Math.min(Math.max(colorInt + step, MIN_COLOR_INT), MAX_COLOR_INT);
    if (clampInt !== colorInt) {
        let newColorString = `#${clampInt.toString(16).padStart(6, "0").toUpperCase()}`;
        newColor = (0, _color.parseColor)(newColorString);
    }
    return newColor;
}

},{"@react-stately/form":"9yZqm","./Color":"4MncF","./useColor":"1sEY0","@react-stately/utils":"cpDPf","react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"1sEY0":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useColor", ()=>useColor);
var _color = require("./Color");
var _react = require("react");
function useColor(value) {
    return (0, _react.useMemo)(()=>{
        if (typeof value === "string") try {
            return (0, _color.parseColor)(value);
        } catch (err) {
            return undefined;
        }
        return value;
    }, [
        value
    ]);
}

},{"./Color":"4MncF","react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"6Y0Yo":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ColorWheel", ()=>_ColorWheel);
var _utils = require("@react-spectrum/utils");
var _colorThumb = require("./ColorThumb");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _varsCss = require("@adobe/spectrum-css-temp/components/colorwheel/vars.css");
var _varsCssDefault = parcelHelpers.interopDefault(_varsCss);
var _color = require("@react-aria/color");
var _color1 = require("@react-stately/color");
var _focus = require("@react-aria/focus");
var _provider = require("@react-spectrum/provider");
var _utils1 = require("@react-aria/utils");
const WHEEL_THICKNESS = 24;
function ColorWheel(props, ref) {
    props = (0, _provider.useProviderProps)(props);
    let { isDisabled } = props;
    let size = props.size && (0, _utils.dimensionValue)(props.size);
    let { styleProps } = (0, _utils.useStyleProps)(props);
    let inputRef = (0, _react.useRef)(null);
    let containerRef = (0, _utils.useFocusableRef)(ref, inputRef);
    let [wheelRadius, setWheelRadius] = (0, _react.useState)(0);
    let [wheelThickness, setWheelThickness] = (0, _react.useState)(WHEEL_THICKNESS);
    let resizeHandler = (0, _react.useCallback)(()=>{
        if (containerRef.current) {
            setWheelRadius(containerRef.current.offsetWidth / 2);
            let thickness = window.getComputedStyle(containerRef.current).getPropertyValue("--spectrum-colorwheel-track-thickness");
            if (thickness) setWheelThickness(parseInt(thickness, 10));
        }
    }, [
        containerRef,
        setWheelRadius,
        setWheelThickness
    ]);
    (0, _react.useEffect)(()=>{
        // the size observer's fallback to the window resize event doesn't fire on mount
        if (wheelRadius === 0) resizeHandler();
    }, [
        wheelRadius,
        resizeHandler
    ]);
    (0, _utils1.useResizeObserver)({
        ref: containerRef,
        onResize: resizeHandler
    });
    let state = (0, _color1.useColorWheelState)(props);
    let { trackProps, inputProps, thumbProps } = (0, _color.useColorWheel)({
        ...props,
        innerRadius: wheelRadius - wheelThickness,
        outerRadius: wheelRadius
    }, state, inputRef);
    let { focusProps, isFocusVisible } = (0, _focus.useFocusRing)();
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-ColorWheel", {
            "is-disabled": isDisabled
        }, styleProps.className),
        ref: containerRef,
        style: {
            ...styleProps.style,
            // Workaround around https://github.com/adobe/spectrum-css/issues/1032
            // @ts-ignore
            "width": size,
            "height": size
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...trackProps,
        className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-ColorWheel-gradient")
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _colorThumb.ColorThumb), {
        value: state.getDisplayColor(),
        isFocused: isFocusVisible,
        isDisabled: isDisabled,
        isDragging: state.isDragging,
        className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-ColorWheel-handle"),
        ...thumbProps
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("input", {
        ...focusProps,
        className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-ColorWheel-slider"),
        ...inputProps,
        ref: inputRef
    })));
}
/**
 * ColorWheels allow users to adjust the hue of an HSL or HSB color value on a circular track.
 */ let _ColorWheel = /*#__PURE__*/ (0, _reactDefault.default).forwardRef(ColorWheel);

},{"@react-spectrum/utils":"cMIJ6","./ColorThumb":"iTbho","react":"9yzVZ","@adobe/spectrum-css-temp/components/colorwheel/vars.css":"k3z1u","@react-aria/color":"fjtDT","@react-stately/color":"1aHGl","@react-aria/focus":"42mbF","@react-spectrum/provider":"5bCdp","@react-aria/utils":"9cLk5","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"k3z1u":[function(require,module,exports) {
module.exports["is-disabled"] = `qPIMxa_is-disabled`;
module.exports["is-dragged"] = `qPIMxa_is-dragged`;
module.exports["is-focused"] = `qPIMxa_is-focused`;
module.exports["spectrum-ColorControl-hiddenField"] = `qPIMxa_spectrum-ColorControl-hiddenField`;
module.exports["spectrum-ColorWheel"] = `qPIMxa_spectrum-ColorWheel`;
module.exports["spectrum-ColorWheel-gradient"] = `qPIMxa_spectrum-ColorWheel-gradient`;
module.exports["spectrum-ColorWheel-handle"] = `qPIMxa_spectrum-ColorWheel-handle`;
module.exports["spectrum-ColorWheel-segment"] = `qPIMxa_spectrum-ColorWheel-segment`;
module.exports["spectrum-ColorWheel-slider"] = `qPIMxa_spectrum-ColorWheel-slider ${module.exports["spectrum-ColorControl-hiddenField"]}`;

},{}],"6Ifq1":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ColorSlider", ()=>_ColorSlider);
var _utils = require("@react-spectrum/utils");
var _colorThumb = require("./ColorThumb");
var _label = require("@react-spectrum/label");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _varsCss = require("@adobe/spectrum-css-temp/components/colorslider/vars.css");
var _varsCssDefault = parcelHelpers.interopDefault(_varsCss);
var _color = require("@react-aria/color");
var _color1 = require("@react-stately/color");
var _interactions = require("@react-aria/interactions");
var _i18N = require("@react-aria/i18n");
var _provider = require("@react-spectrum/provider");
function ColorSlider(props, ref) {
    props = (0, _provider.useProviderProps)(props);
    let { isDisabled, channel, orientation, label, showValueLabel, "aria-label": ariaLabel } = props;
    let vertical = orientation === "vertical";
    let { styleProps } = (0, _utils.useStyleProps)(props);
    let { locale } = (0, _i18N.useLocale)();
    let inputRef = (0, _react.useRef)(null);
    let trackRef = (0, _react.useRef)(null);
    let domRef = (0, _utils.useFocusableRef)(ref, inputRef);
    let state = (0, _color1.useColorSliderState)({
        ...props,
        locale
    });
    // If vertical and a label is provided, use it as an aria-label instead.
    if (vertical && label) {
        ariaLabel = ariaLabel || (typeof label === "string" ? label : undefined);
        label = null;
    }
    // If no external label, aria-label or aria-labelledby is provided,
    // default to displaying the localized channel value.
    // Specifically check if label is undefined. If label is `null` then display no visible label.
    // A default aria-label is provided by useColorSlider in that case.
    if (label === undefined && !ariaLabel && !props["aria-labelledby"] && !vertical) label = state.value.getChannelName(channel, locale);
    // Show the value label by default if there is a visible label
    if (showValueLabel == null) showValueLabel = !!label;
    let { inputProps, thumbProps, trackProps, labelProps, outputProps } = (0, _color.useColorSlider)({
        ...props,
        label,
        "aria-label": ariaLabel,
        trackRef,
        inputRef
    }, state);
    let { isFocusVisible } = (0, _interactions.useFocusVisible)();
    let [isFocused, setIsFocused] = (0, _react.useState)(false);
    let { focusProps } = (0, _interactions.useFocus)({
        isDisabled,
        onFocusChange: setIsFocused
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ref: domRef,
        ...styleProps,
        className: (0, _utils.classNames)((0, _varsCssDefault.default), {
            "spectrum-ColorSlider-container--horizontal": !vertical,
            "spectrum-ColorSlider-container--vertical": vertical
        })
    }, label && /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-ColorSlider-labelContainer")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _label.Label), labelProps, label), props.contextualHelp && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.SlotProvider), {
        slots: {
            actionButton: {
                UNSAFE_className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-ColorSlider-contextualHelp")
            }
        }
    }, props.contextualHelp), showValueLabel && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _label.Label), {
        elementType: "span",
        UNSAFE_className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-ColorSlider-valueLabel")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("output", outputProps, state.value.formatChannelValue(channel, locale)))), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...trackProps,
        ref: trackRef,
        className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-ColorSlider", {
            "is-disabled": isDisabled,
            "spectrum-ColorSlider--vertical": vertical
        })
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _colorThumb.ColorThumb), {
        value: state.getDisplayColor(),
        isFocused: isFocused && isFocusVisible,
        isDisabled: isDisabled,
        isDragging: state.isThumbDragging(0),
        className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-ColorSlider-handle"),
        ...thumbProps
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("input", {
        ...inputProps,
        ...focusProps,
        ref: inputRef,
        className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-ColorSlider-slider")
    }))));
}
/**
 * ColorSliders allow users to adjust an individual channel of a color value.
 */ let _ColorSlider = /*#__PURE__*/ (0, _reactDefault.default).forwardRef(ColorSlider);

},{"@react-spectrum/utils":"cMIJ6","./ColorThumb":"iTbho","@react-spectrum/label":"6qv6N","react":"9yzVZ","@adobe/spectrum-css-temp/components/colorslider/vars.css":"6diAJ","@react-aria/color":"fjtDT","@react-stately/color":"1aHGl","@react-aria/interactions":"ky3G8","@react-aria/i18n":"411rg","@react-spectrum/provider":"5bCdp","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"6diAJ":[function(require,module,exports) {
module.exports["contextualHelp"] = `WJOmgG_contextualHelp`;
module.exports["is-disabled"] = `WJOmgG_is-disabled`;
module.exports["is-focused"] = `WJOmgG_is-focused`;
module.exports["label"] = `WJOmgG_label`;
module.exports["spectrum-ColorControl-hiddenField"] = `WJOmgG_spectrum-ColorControl-hiddenField`;
module.exports["spectrum-ColorSlider"] = `WJOmgG_spectrum-ColorSlider`;
module.exports["spectrum-ColorSlider--vertical"] = `WJOmgG_spectrum-ColorSlider--vertical`;
module.exports["spectrum-ColorSlider-container--horizontal"] = `WJOmgG_spectrum-ColorSlider-container--horizontal`;
module.exports["spectrum-ColorSlider-container--vertical"] = `WJOmgG_spectrum-ColorSlider-container--vertical`;
module.exports["spectrum-ColorSlider-contextualHelp"] = `WJOmgG_spectrum-ColorSlider-contextualHelp`;
module.exports["spectrum-ColorSlider-handle"] = `WJOmgG_spectrum-ColorSlider-handle`;
module.exports["spectrum-ColorSlider-labelContainer"] = `WJOmgG_spectrum-ColorSlider-labelContainer`;
module.exports["spectrum-ColorSlider-slider"] = `WJOmgG_spectrum-ColorSlider-slider ${module.exports["spectrum-ColorControl-hiddenField"]}`;
module.exports["spectrum-ColorSlider-valueLabel"] = `WJOmgG_spectrum-ColorSlider-valueLabel`;
module.exports["value"] = `WJOmgG_value`;

},{}],"lwZwv":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ColorField", ()=>_ColorField);
var _utils = require("@react-spectrum/utils");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _colorfieldCss = require("./colorfield.css");
var _colorfieldCssDefault = parcelHelpers.interopDefault(_colorfieldCss);
var _textfield = require("@react-spectrum/textfield");
var _color = require("@react-aria/color");
var _color1 = require("@react-stately/color");
var _form = require("@react-spectrum/form");
var _provider = require("@react-spectrum/provider");
function ColorField(props, ref) {
    props = (0, _provider.useProviderProps)(props);
    props = (0, _form.useFormProps)(props);
    let { // These disabled props are handled by the state hook
    value, defaultValue, onChange, ...otherProps } = props;
    let state = (0, _color1.useColorFieldState)(props);
    let inputRef = (0, _react.useRef)(null);
    let result = (0, _color.useColorField)(otherProps, state, inputRef);
    if (props.placeholder) console.warn("Placeholders are deprecated due to accessibility issues. Please use help text instead. See the docs for details: https://react-spectrum.adobe.com/react-spectrum/ColorField.html#help-text");
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textfield.TextFieldBase), {
        ...otherProps,
        ref: ref,
        inputRef: inputRef,
        ...result,
        inputClassName: (0, _utils.classNames)((0, _colorfieldCssDefault.default), "react-spectrum-ColorField-input")
    });
}
/**
 * ColorFields allow users to enter a color in #rrggbb hexadecimal format.
 */ const _ColorField = /*#__PURE__*/ (0, _reactDefault.default).forwardRef(ColorField);

},{"@react-spectrum/utils":"cMIJ6","react":"9yzVZ","./colorfield.css":"aGkDS","@react-spectrum/textfield":"hOmtq","@react-aria/color":"fjtDT","@react-stately/color":"1aHGl","@react-spectrum/form":"bGDqA","@react-spectrum/provider":"5bCdp","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"aGkDS":[function(require,module,exports) {
module.exports["react-spectrum-ColorField-input"] = `UccskW_react-spectrum-ColorField-input`;

},{}],"1F7cM":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Default", ()=>Default);
parcelHelpers.export(exports, "DefaultValue", ()=>DefaultValue);
parcelHelpers.export(exports, "ControlledValue", ()=>ControlledValue);
parcelHelpers.export(exports, "AriaLabelledBy", ()=>AriaLabelledBy);
parcelHelpers.export(exports, "MinWidth", ()=>MinWidth);
parcelHelpers.export(exports, "ContextualHelpStory", ()=>ContextualHelpStory);
var _addonActions = require("@storybook/addon-actions");
var _ = require("../");
var _view = require("@react-spectrum/view");
var _contextualhelp = require("@react-spectrum/contextualhelp");
var _layout = require("@react-spectrum/layout");
var _text = require("@react-spectrum/text");
var _color = require("@react-stately/color");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _utils = require("@react-aria/utils");
var _visuallyHidden = require("@react-aria/visually-hidden");
exports.default = {
    title: "ColorField",
    component: (0, _.ColorField),
    args: {
        onChange: (0, _addonActions.action)("onChange"),
        label: "Primary Color"
    },
    argTypes: {
        onChange: {
            table: {
                disable: true
            }
        },
        contextualHelp: {
            table: {
                disable: true
            }
        },
        label: {
            control: "text"
        },
        "aria-label": {
            control: "text"
        },
        isQuiet: {
            control: "boolean"
        },
        isReadOnly: {
            control: "boolean"
        },
        isDisabled: {
            control: "boolean"
        },
        autoFocus: {
            control: "boolean"
        },
        isRequired: {
            control: "boolean"
        },
        necessityIndicator: {
            control: "select",
            options: [
                "icon",
                "label"
            ]
        },
        labelAlign: {
            control: "select",
            options: [
                "end",
                "start"
            ]
        },
        labelPosition: {
            control: "select",
            options: [
                "top",
                "side"
            ]
        },
        isInvalid: {
            control: "boolean"
        },
        isWheelDisabled: {
            control: "boolean"
        },
        description: {
            control: "text"
        },
        errorMessage: {
            control: "text"
        },
        width: {
            control: "text"
        }
    }
};
const Default = {
    render: (args)=>render(args)
};
const DefaultValue = {
    ...Default,
    args: {
        defaultValue: "#abcdef"
    }
};
const ControlledValue = {
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(ControlledColorField, {
            ...args,
            value: (0, _color.parseColor)("#FF00AA")
        })
};
const AriaLabelledBy = {
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement("label", {
            htmlFor: "colorfield",
            id: "label"
        }, "Primary Color"), render({
            ...args,
            id: "colorfield",
            "aria-labelledby": "label"
        })),
    name: "aria-labelledy"
};
const MinWidth = {
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
            direction: "column",
            gap: "size-100"
        }, render({
            ...args,
            width: "10px"
        }), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
            style: {
                width: "10px"
            }
        }, render(args))),
    name: "custom width, 10px for min-width"
};
const ContextualHelpStory = {
    ...Default,
    args: {
        contextualHelp: /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _contextualhelp.ContextualHelp), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Heading), null, "What is a segment?"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Content), null, "Segments identify who your visitors are, what devices and services they use, where they navigated from, and much more."))
    },
    name: "contextual help"
};
function ControlledColorField(props) {
    let [color, setColor] = (0, _react.useState)(props.value);
    let onChange = (color)=>{
        setColor(color);
        if (props.onChange) props.onChange(color);
    };
    let style = color ? {
        backgroundColor: color.toString("rgb")
    } : {};
    let id = (0, _utils.useId)();
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
        direction: "row",
        gap: "size-100",
        alignItems: "end"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ColorField), {
        id: id,
        label: "Primary Color",
        onChange: onChange,
        value: color
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.View), {
        width: "size-400",
        height: "size-400",
        UNSAFE_style: style
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _visuallyHidden.VisuallyHidden), null, /*#__PURE__*/ (0, _reactDefault.default).createElement("output", {
        htmlFor: id,
        "aria-live": "off"
    }, color ? color.toString("hex") : ""))));
}
function render(props = {}) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ColorField), props);
}

},{"@storybook/addon-actions":"coXbW","../":"rC4Qm","@react-spectrum/view":"dnRjt","@react-spectrum/contextualhelp":"jA6za","@react-spectrum/layout":"hzaUY","@react-spectrum/text":"etCGI","@react-stately/color":"1aHGl","react":"9yzVZ","@react-aria/utils":"9cLk5","@react-aria/visually-hidden":"4jwxT","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"ktXAm":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Default", ()=>Default);
parcelHelpers.export(exports, "Controlled", ()=>Controlled);
parcelHelpers.export(exports, "ContextualHelpStory", ()=>ContextualHelpStory);
parcelHelpers.export(exports, "RGBA", ()=>RGBA);
parcelHelpers.export(exports, "HSLA", ()=>HSLA);
parcelHelpers.export(exports, "HSBA", ()=>HSBA);
var _addonActions = require("@storybook/addon-actions");
var _ = require("../");
var _view = require("@react-spectrum/view");
var _contextualhelp = require("@react-spectrum/contextualhelp");
var _layout = require("@react-spectrum/layout");
var _text = require("@react-spectrum/text");
var _color = require("@react-stately/color");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
exports.default = {
    title: "ColorSlider",
    component: (0, _.ColorSlider),
    args: {
        onChange: (0, _addonActions.action)("onChange"),
        onChangeEnd: (0, _addonActions.action)("onChangeEnd")
    },
    argTypes: {
        onChange: {
            table: {
                disable: true
            }
        },
        onChangeEnd: {
            table: {
                disable: true
            }
        },
        contextualHelp: {
            table: {
                disable: true
            }
        },
        channel: {
            table: {
                disable: true
            }
        },
        label: {
            control: "text"
        },
        "aria-label": {
            control: "text"
        },
        isDisabled: {
            control: "boolean"
        },
        showValueLabel: {
            control: "boolean"
        },
        orientation: {
            control: "select",
            options: [
                "horizontal",
                "vertical"
            ]
        },
        width: {
            control: "text"
        },
        height: {
            control: "text"
        }
    }
};
const Default = {
    args: {
        defaultValue: "#800000",
        channel: "red"
    },
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ColorSlider), args)
};
const Controlled = {
    ...Default,
    args: {
        value: "#800000",
        channel: "red"
    }
};
const ContextualHelpStory = {
    ...Default,
    args: {
        defaultValue: "hsb(0, 100%, 50%)",
        channel: "hue",
        contextualHelp: /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _contextualhelp.ContextualHelp), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Heading), null, "What is a segment?"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Content), null, "Segments identify who your visitors are, what devices and services they use, where they navigated from, and much more."))
    },
    name: "contextual help"
};
const RGBA = {
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(RGBASlider, args)
};
const HSLA = {
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(HSLASlider, args)
};
const HSBA = {
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(HSBASlider, args)
};
function RGBASlider(props) {
    let [color, setColor] = (0, _react.useState)((0, _color.parseColor)("#ff00ff"));
    let onChange = (v)=>{
        var _props_onChange;
        setColor(v);
        props === null || props === void 0 ? void 0 : (_props_onChange = props.onChange) === null || _props_onChange === void 0 ? void 0 : _props_onChange.call(props, v);
    };
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        role: "group",
        "aria-label": "RGBA Color Picker"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
        gap: "size-500",
        alignItems: "center"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
        direction: "column"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ColorSlider), {
        ...props,
        value: color,
        onChange: onChange,
        channel: "red"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ColorSlider), {
        ...props,
        value: color,
        onChange: onChange,
        channel: "green"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ColorSlider), {
        ...props,
        value: color,
        onChange: onChange,
        channel: "blue"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ColorSlider), {
        ...props,
        value: color,
        onChange: onChange,
        channel: "alpha"
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
        direction: "column",
        alignItems: "center",
        gap: "size-100"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        style: {
            width: "100px",
            height: "100px",
            background: color.toString("css")
        }
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, color.toString("hexa")))));
}
function HSLASlider(props) {
    let [color, setColor] = (0, _react.useState)((0, _color.parseColor)("hsla(0, 100%, 50%, 0.5)"));
    let onChange = (v)=>{
        var _props_onChange;
        setColor(v);
        props === null || props === void 0 ? void 0 : (_props_onChange = props.onChange) === null || _props_onChange === void 0 ? void 0 : _props_onChange.call(props, v);
    };
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        role: "group",
        "aria-label": "HSLA Color Picker"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
        gap: "size-500",
        alignItems: "center"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
        direction: "column"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ColorSlider), {
        ...props,
        value: color,
        onChange: onChange,
        channel: "hue"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ColorSlider), {
        ...props,
        value: color,
        onChange: onChange,
        channel: "saturation"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ColorSlider), {
        ...props,
        value: color,
        onChange: onChange,
        channel: "lightness"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ColorSlider), {
        ...props,
        value: color,
        onChange: onChange,
        channel: "alpha"
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
        direction: "column",
        alignItems: "center",
        gap: "size-100"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        style: {
            width: "100px",
            height: "100px",
            background: color.toString("css")
        }
    }))));
}
function HSBASlider(props) {
    let [color, setColor] = (0, _react.useState)((0, _color.parseColor)("hsba(0, 100%, 50%, 0.5)"));
    let onChange = (v)=>{
        var _props_onChange;
        setColor(v);
        props === null || props === void 0 ? void 0 : (_props_onChange = props.onChange) === null || _props_onChange === void 0 ? void 0 : _props_onChange.call(props, v);
    };
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        role: "group",
        "aria-label": "HSBA Color Picker"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
        gap: "size-500",
        alignItems: "center"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
        direction: "column"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ColorSlider), {
        ...props,
        value: color,
        onChange: onChange,
        channel: "hue"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ColorSlider), {
        ...props,
        value: color,
        onChange: onChange,
        channel: "saturation"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ColorSlider), {
        ...props,
        value: color,
        onChange: onChange,
        channel: "brightness"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ColorSlider), {
        ...props,
        value: color,
        onChange: onChange,
        channel: "alpha"
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
        direction: "column",
        alignItems: "center",
        gap: "size-100"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        style: {
            width: "100px",
            height: "100px",
            background: color.toString("css")
        }
    }))));
}

},{"@storybook/addon-actions":"coXbW","../":"rC4Qm","@react-spectrum/view":"dnRjt","@react-spectrum/contextualhelp":"jA6za","@react-spectrum/layout":"hzaUY","@react-spectrum/text":"etCGI","@react-stately/color":"1aHGl","react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"d3bsU":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Default", ()=>Default);
parcelHelpers.export(exports, "Alpha", ()=>Alpha);
var _colorThumb = require("../src/ColorThumb");
var _color = require("@react-stately/color");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
exports.default = {
    title: "ColorThumb",
    component: (0, _colorThumb.ColorThumb),
    argTypes: {
        value: {
            table: {
                disable: true
            }
        },
        isFocused: {
            control: "boolean"
        },
        isDragging: {
            control: "boolean"
        },
        isDisabled: {
            control: "boolean"
        }
    }
};
const Default = {
    args: {
        value: (0, _color.parseColor)("#f00")
    },
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _colorThumb.ColorThumb), args)
};
const Alpha = {
    ...Default,
    args: {
        value: (0, _color.parseColor)("hsla(0, 100%, 100%, 0)")
    }
};

},{"../src/ColorThumb":"iTbho","@react-stately/color":"1aHGl","react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"iZF8g":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Default", ()=>Default);
parcelHelpers.export(exports, "Controlled", ()=>Controlled);
parcelHelpers.export(exports, "ControlledHSL", ()=>ControlledHSL);
var _addonActions = require("@storybook/addon-actions");
var _ = require("../");
var _reactSpectrum = require("@adobe/react-spectrum");
var _color = require("@react-stately/color");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
exports.default = {
    title: "ColorWheel",
    component: (0, _.ColorWheel),
    excludeStories: [
        "ControlledHSL"
    ],
    args: {
        onChange: (0, _addonActions.action)("onChange"),
        onChangeEnd: (0, _addonActions.action)("onChangeEnd")
    },
    argTypes: {
        onChange: {
            table: {
                disable: true
            }
        },
        onChangeEnd: {
            table: {
                disable: true
            }
        },
        isDisabled: {
            control: "boolean"
        },
        size: {
            control: "text"
        }
    }
};
const Default = {
    args: {
        defaultValue: "hsl(0, 100%, 50%)"
    },
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ColorWheel), args)
};
const Controlled = {
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSpectrum.Flex), {
            gap: "size-500",
            direction: "row",
            alignItems: "center"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement(ControlledHSL, args))
};
function ControlledHSL(props) {
    let [color, setColor] = (0, _react.useState)(props.defaultValue || (0, _color.parseColor)("hsl(0, 100%, 50%)"));
    let colorCSS = color.toString("css");
    let onChangeEnd = (color)=>{
        props.onChangeEnd && props.onChangeEnd(color);
        setColor(color);
    };
    let onChange = (color)=>{
        props.onChange && props.onChange(color);
        setColor(color);
    };
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ColorWheel), {
        onChange: onChange,
        onChangeEnd: onChangeEnd,
        value: color.toString("hsl")
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        style: {
            width: "50px",
            height: "50px",
            backgroundColor: colorCSS,
            border: "1px solid black"
        }
    }));
}

},{"@storybook/addon-actions":"coXbW","../":"rC4Qm","@adobe/react-spectrum":"cwANo","@react-stately/color":"1aHGl","react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"KOzmH":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Default", ()=>Default);
parcelHelpers.export(exports, "Dynamic", ()=>Dynamic);
parcelHelpers.export(exports, "NoItems", ()=>NoItems);
parcelHelpers.export(exports, "MappedItems", ()=>MappedItems);
parcelHelpers.export(exports, "Sections", ()=>Sections);
parcelHelpers.export(exports, "ManySections", ()=>ManySections);
parcelHelpers.export(exports, "ComplexItems", ()=>ComplexItems);
parcelHelpers.export(exports, "WithAvatars", ()=>WithAvatars);
parcelHelpers.export(exports, "UserProvidedLabel", ()=>UserProvidedLabel);
parcelHelpers.export(exports, "DisabledKeys", ()=>DisabledKeys);
parcelHelpers.export(exports, "ContextualHelpStory", ()=>ContextualHelpStory);
parcelHelpers.export(exports, "Resize", ()=>Resize);
parcelHelpers.export(exports, "SmallDiv", ()=>SmallDiv);
parcelHelpers.export(exports, "ControlledInputValueStory", ()=>ControlledInputValueStory);
parcelHelpers.export(exports, "DefaultInputValue", ()=>DefaultInputValue);
parcelHelpers.export(exports, "ControlledSelectedKey", ()=>ControlledSelectedKey);
parcelHelpers.export(exports, "DefaultSelectedKey", ()=>DefaultSelectedKey);
parcelHelpers.export(exports, "AllControlled", ()=>AllControlled);
parcelHelpers.export(exports, "DefaultInputAndKey", ()=>DefaultInputAndKey);
parcelHelpers.export(exports, "ControlledInputDefaultKey", ()=>ControlledInputDefaultKey);
parcelHelpers.export(exports, "ControlledInputValue", ()=>ControlledInputValue);
parcelHelpers.export(exports, "CustomFilter", ()=>CustomFilter);
parcelHelpers.export(exports, "LoadingState", ()=>LoadingState);
parcelHelpers.export(exports, "FilteringListData", ()=>FilteringListData);
parcelHelpers.export(exports, "SeverSideFiltering", ()=>SeverSideFiltering);
parcelHelpers.export(exports, "SeverSideFilteringControlled", ()=>SeverSideFilteringControlled);
parcelHelpers.export(exports, "SeverSideFilteringControlledReset", ()=>SeverSideFilteringControlledReset);
parcelHelpers.export(exports, "InDialog", ()=>InDialog);
parcelHelpers.export(exports, "WHCM", ()=>WHCM);
parcelHelpers.export(exports, "Links", ()=>Links);
var _addonActions = require("@storybook/addon-actions");
var _button = require("@react-spectrum/button");
var _add = require("@spectrum-icons/workflow/Add");
var _addDefault = parcelHelpers.interopDefault(_add);
var _alert = require("@spectrum-icons/workflow/Alert");
var _alertDefault = parcelHelpers.interopDefault(_alert);
var _avatar = require("@react-spectrum/avatar");
var _bell = require("@spectrum-icons/workflow/Bell");
var _bellDefault = parcelHelpers.interopDefault(_bell);
var _buttongroup = require("@react-spectrum/buttongroup");
var _utils = require("@react-aria/utils");
var _ = require("../");
var _view = require("@react-spectrum/view");
var _contextualhelp = require("@react-spectrum/contextualhelp");
var _copy = require("@spectrum-icons/workflow/Copy");
var _copyDefault = parcelHelpers.interopDefault(_copy);
var _dialog = require("@react-spectrum/dialog");
var _draw = require("@spectrum-icons/workflow/Draw");
var _drawDefault = parcelHelpers.interopDefault(_draw);
var _layout = require("@react-spectrum/layout");
var _text = require("@react-spectrum/text");
var _link = require("@react-spectrum/link");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _data = require("@react-stately/data");
var _i18N = require("@react-aria/i18n");
let items = [
    {
        name: "Aardvark",
        id: "1"
    },
    {
        name: "Kangaroo",
        id: "2"
    },
    {
        name: "Snake",
        id: "3"
    }
];
let withSection = [
    {
        name: "Animals",
        id: "s1",
        children: [
            {
                name: "Aardvark",
                id: "1"
            },
            {
                name: "Kangaroo",
                id: "2"
            },
            {
                name: "Snake",
                id: "3"
            }
        ]
    },
    {
        name: "People",
        id: "s2",
        children: [
            {
                name: "Danni",
                id: "4"
            },
            {
                name: "Devon",
                id: "5"
            },
            {
                name: "Ross",
                id: "6"
            }
        ]
    }
];
let lotsOfSections = [];
for(let i = 0; i < 50; i++){
    let children = [];
    for(let j = 0; j < 50; j++)children.push({
        name: `Section ${i}, Item ${j}`
    });
    lotsOfSections.push({
        name: "Section " + i,
        children
    });
}
exports.default = {
    title: "ComboBox",
    component: (0, _.ComboBox),
    args: {
        label: "Combobox",
        onOpenChange: (0, _addonActions.action)("onOpenChange"),
        onInputChange: (0, _addonActions.action)("onInputChange"),
        onSelectionChange: (0, _addonActions.action)("onSelectionChange"),
        onBlur: (0, _addonActions.action)("onBlur"),
        onFocus: (0, _addonActions.action)("onFocus")
    },
    argTypes: {
        defaultItems: {
            table: {
                disable: true
            }
        },
        contextualHelp: {
            table: {
                disable: true
            }
        },
        onOpenChange: {
            table: {
                disable: true
            }
        },
        disabledKeys: {
            table: {
                disable: true
            }
        },
        inputValue: {
            table: {
                disable: true
            }
        },
        defaultInputValue: {
            table: {
                disable: true
            }
        },
        defaultSelectedKey: {
            table: {
                disable: true
            }
        },
        selectedKey: {
            table: {
                disable: true
            }
        },
        onInputChange: {
            table: {
                disable: true
            }
        },
        onSelectionChange: {
            table: {
                disable: true
            }
        },
        onBlur: {
            table: {
                disable: true
            }
        },
        onFocus: {
            table: {
                disable: true
            }
        },
        label: {
            control: "text"
        },
        "aria-label": {
            control: "text"
        },
        isDisabled: {
            control: "boolean"
        },
        isQuiet: {
            control: "boolean"
        },
        isReadOnly: {
            control: "boolean"
        },
        autoFocus: {
            control: "boolean"
        },
        isRequired: {
            control: "boolean"
        },
        necessityIndicator: {
            control: "select",
            options: [
                "icon",
                "label"
            ]
        },
        labelAlign: {
            control: "select",
            options: [
                "end",
                "start"
            ]
        },
        labelPosition: {
            control: "select",
            options: [
                "top",
                "side"
            ]
        },
        validationState: {
            control: "select",
            options: [
                null,
                "valid",
                "invalid"
            ]
        },
        description: {
            control: "text"
        },
        errorMessage: {
            control: "text"
        },
        menuTrigger: {
            control: "select",
            options: [
                "focus",
                "manual"
            ]
        },
        direction: {
            control: "radio",
            options: [
                "top",
                "bottom"
            ]
        },
        align: {
            control: "radio",
            options: [
                "start",
                "end"
            ]
        },
        allowsCustomValue: {
            control: "boolean"
        },
        width: {
            control: {
                type: "radio",
                options: [
                    null,
                    "100px",
                    "480px",
                    "size-4600"
                ]
            }
        },
        menuWidth: {
            control: {
                type: "radio",
                options: [
                    null,
                    "100px",
                    "480px",
                    "size-4600"
                ]
            }
        }
    }
};
const Default = {
    render: (args)=>render(args),
    name: "static items"
};
const Dynamic = {
    args: {
        defaultItems: items
    },
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ComboBox), args, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), null, item.name)),
    name: "dynamic items"
};
const NoItems = {
    ...Dynamic,
    args: {
        defaultItems: []
    },
    name: "no items"
};
const MappedItems = {
    args: {
        defaultSelectedKey: "2"
    },
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(ComboBoxWithMap, args),
    name: "with mapped items (defaultItem and items undef)"
};
const Sections = {
    args: {
        defaultItems: withSection
    },
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ComboBox), args, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Section), {
                key: item.name,
                items: item.children,
                title: item.name
            }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
                    key: item.name
                }, item.name))),
    name: "with sections"
};
const ManySections = {
    ...Sections,
    args: {
        defaultItems: lotsOfSections
    },
    name: "with many sections"
};
const ComplexItems = {
    args: {
        label: "Select action"
    },
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ComboBox), args, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            textValue: "Add to queue"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _addDefault.default), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, "Add to queue"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), {
            slot: "description"
        }, "Add to current watch queue.")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            textValue: "Add review"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _drawDefault.default), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, "Add review"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), {
            slot: "description"
        }, "Post a review for the episode.")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            textValue: "Subscribe to series"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _bellDefault.default), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, "Subscribe to series"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), {
            slot: "description"
        }, "Add series to your subscription list and be notified when a new episode airs.")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            textValue: "Report"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _alertDefault.default), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, "Report"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), {
            slot: "description"
        }, "Report an issue/violation.")))
};
const WithAvatars = {
    args: {
        label: "Select a user"
    },
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ComboBox), args, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            textValue: "User 1"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _avatar.Avatar), {
            src: "https://i.imgur.com/kJOwAdv.png"
        }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, "User 1")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            textValue: "User 2"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _avatar.Avatar), {
            src: "https://i.imgur.com/kJOwAdv.png"
        }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, "User 2")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            textValue: "User 3"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _avatar.Avatar), {
            src: "https://i.imgur.com/kJOwAdv.png"
        }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, "User 3")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            textValue: "User 4"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _avatar.Avatar), {
            src: "https://i.imgur.com/kJOwAdv.png"
        }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, "User 4")))
};
const UserProvidedLabel = {
    args: {
        label: "Select action"
    },
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
            direction: "column",
            width: "size-3000"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement("label", {
            id: "test-label",
            htmlFor: "test-id"
        }, "Combobox"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ComboBox), {
            ...args,
            id: "test-id",
            "aria-labelledby": "test-label"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            key: "one"
        }, "Item One"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            key: "two",
            textValue: "Item Two"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _copyDefault.default), {
            size: "S"
        }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, "Item Two")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            key: "three"
        }, "Item Three")))
};
const DisabledKeys = {
    args: {
        defaultItems: withSection,
        label: "Combobox",
        disabledKeys: [
            "Snake",
            "Ross"
        ]
    },
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ComboBox), args, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Section), {
                key: item.name,
                items: item.children,
                title: item.name
            }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
                    key: item.name
                }, item.name)))
};
const ContextualHelpStory = {
    ...Default,
    args: {
        ...Default.args,
        contextualHelp: /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _contextualhelp.ContextualHelp), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Heading), null, "What is a segment?"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Content), null, "Segments identify who your visitors are, what devices and services they use, where they navigated from, and much more."))
    },
    name: "contextual help"
};
const Resize = {
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(ResizeCombobox, args)
};
const SmallDiv = {
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
            width: "size-500"
        }, render(args)),
    name: "in small div"
};
const ControlledInputValueStory = {
    args: {
        inputValue: "Snake",
        disabledKeys: [
            "2",
            "6"
        ]
    },
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(ControlledValueComboBox, args),
    name: "inputValue (controlled)"
};
const DefaultInputValue = {
    ...Default,
    args: {
        defaultInputValue: "Item Three",
        disabledKeys: [
            "two"
        ]
    },
    name: "defaultInputValue (uncontrolled)"
};
const ControlledSelectedKey = {
    args: {
        selectedKey: "4",
        disabledKeys: [
            "2",
            "6"
        ]
    },
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(ControlledKeyComboBox, args),
    name: "selectedKey (controlled)"
};
const DefaultSelectedKey = {
    ...Default,
    args: {
        defaultSelectedKey: "two",
        disabledKeys: [
            "one"
        ]
    },
    name: "defaultSelectedKey (uncontrolled)"
};
const AllControlled = {
    args: {
        selectedKey: "2",
        inputValue: "Kangaroo",
        disabledKeys: [
            "2",
            "6"
        ]
    },
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(AllControlledComboBox, args),
    name: "inputValue and selectedKey (controlled)"
};
const DefaultInputAndKey = {
    ...Default,
    args: {
        defaultInputValue: "Item Two",
        defaultSelectedKey: "two",
        disabledKeys: [
            "two"
        ]
    },
    name: "defaultInputValue and defaultSelectedKey (uncontrolled)"
};
const ControlledInputDefaultKey = {
    ...ControlledInputValueStory,
    args: {
        inputValue: "K",
        defaultSelectedKey: "two",
        disabledKeys: [
            "2",
            "6"
        ]
    },
    name: "inputValue and defaultSelectedKey (controlled by inputvalue)"
};
const ControlledInputValue = {
    ...ControlledSelectedKey,
    args: {
        defaultInputValue: "Blah",
        selectedKey: "2",
        disabledKeys: [
            "2",
            "6"
        ]
    },
    name: "defaultInputValue and selectedKey (controlled by selectedKey)"
};
const CustomFilter = {
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(CustomFilterComboBox, args)
};
const LoadingState = {
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(LoadingExamples, args)
};
const FilteringListData = {
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(ListDataExample, args),
    name: "filtering with useListData"
};
const SeverSideFiltering = {
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(AsyncLoadingExample, args),
    name: "server side filtering with useAsyncList"
};
const SeverSideFilteringControlled = {
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(AsyncLoadingExampleControlledKey, args),
    name: "server side filtering with useAsyncList (controlled key)"
};
const SeverSideFilteringControlledReset = {
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(AsyncLoadingExampleControlledKeyWithReset, args),
    name: "server side filtering with controlled key and inputValue reset if not focused"
};
const InDialog = {
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(ComboBoxWithinDialog, args),
    name: "within a dialog"
};
const WHCM = {
    render: ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
            direction: "column",
            gap: "size-200"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
            gap: "size-200"
        }, "Shows the different states from ", /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _link.Link), null, /*#__PURE__*/ (0, _reactDefault.default).createElement("a", {
            href: "https://spectrum.adobe.com/static/Windows-High-Contrast-Kits/Combobox-WindowsHighContrast.xd"
        }, "spectrum"))), renderRow({
            placeholder: "Type here..."
        }), renderRow(), renderRow({
            labelPosition: "side"
        }), renderRow({
            isQuiet: true,
            placeholder: "Type here..."
        }), renderRow({
            isQuiet: true
        }), renderRow({
            isRequired: true
        }), renderRow({
            isRequired: true,
            isQuiet: true
        }), renderRow({
            validationState: "invalid"
        }), renderRow({
            validationState: "invalid",
            isQuiet: true
        }))
};
const Links = {
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ComboBox), args, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            key: "foo"
        }, "Foo"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            key: "bar"
        }, "Bar"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            href: "https://google.com"
        }, "Google"))
};
function LoadingExamples(props) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
        gap: "size-300",
        direction: "column"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ComboBox), {
        ...props,
        label: "Combobox (loading)",
        loadingState: "loading",
        defaultItems: items
    }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), null, item.name)), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ComboBox), {
        ...props,
        label: "Combobox (filtering)",
        loadingState: "filtering",
        defaultItems: items
    }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), null, item.name)), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ComboBox), {
        ...props,
        label: "Combobox (loading + menuTrigger manual)",
        loadingState: "loading",
        menuTrigger: "manual",
        defaultItems: items
    }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), null, item.name)), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ComboBox), {
        ...props,
        label: "Combobox (loading more)",
        loadingState: "loadingMore",
        defaultItems: items
    }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), null, item.name)));
}
function ListDataExample(props) {
    let { contains } = (0, _i18N.useFilter)({
        sensitivity: "base"
    });
    let list = (0, _data.useListData)({
        initialItems: items,
        initialFilterText: "Snake",
        filter (item, text) {
            return contains(item.name, text);
        }
    });
    let [showAll, setShowAll] = (0, _react.useState)(false);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
        gap: "size-300",
        direction: "column"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ComboBox), {
        ...props,
        onOpenChange: (open, reason)=>{
            if (reason === "manual" && open) setShowAll(true);
        },
        label: "ComboBox (show all on open)",
        items: showAll ? items : list.items,
        inputValue: list.filterText,
        onInputChange: (value)=>{
            setShowAll(false);
            list.setFilterText(value);
        }
    }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), null, item.name)), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ComboBox), {
        ...props,
        label: "ComboBox (default controlled items behavior)",
        items: list.items,
        inputValue: list.filterText,
        onInputChange: list.setFilterText
    }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), null, item.name)));
}
function AsyncLoadingExample(props) {
    let list = (0, _data.useAsyncList)({
        async load ({ signal, cursor, filterText }) {
            if (cursor) cursor = cursor.replace(/^http:\/\//i, "https://");
            // Slow down load so progress circle can appear
            await new Promise((resolve)=>setTimeout(resolve, 1500));
            let res = await fetch(cursor || `https://swapi.py4e.com/api/people/?search=${filterText}`, {
                signal
            });
            let json = await res.json();
            return {
                items: json.results,
                cursor: json.next
            };
        }
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ComboBox), {
        label: "Star Wars Character Lookup",
        ...props,
        items: list.items,
        inputValue: list.filterText,
        onInputChange: list.setFilterText,
        loadingState: list.loadingState,
        onLoadMore: (0, _utils.chain)(props === null || props === void 0 ? void 0 : props.onLoadMore, list.loadMore)
    }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            key: item.name
        }, item.name));
}
function AsyncLoadingExampleControlledKey(props) {
    let list = (0, _data.useAsyncList)({
        async load ({ signal, cursor, filterText }) {
            if (cursor) cursor = cursor.replace(/^http:\/\//i, "https://");
            // Slow down load so progress circle can appear
            await new Promise((resolve)=>setTimeout(resolve, 1500));
            let res = await fetch(cursor || `https://swapi.py4e.com/api/people/?search=${filterText}`, {
                signal
            });
            let json = await res.json();
            return {
                items: json.results,
                cursor: json.next
            };
        },
        initialSelectedKeys: [
            "Luke Skywalker"
        ],
        getKey: (item)=>item.name
    });
    let onSelectionChange = (key)=>{
        var _list_getItem;
        let itemText = (_list_getItem = list.getItem(key)) === null || _list_getItem === void 0 ? void 0 : _list_getItem.name;
        list.setSelectedKeys(new Set([
            key
        ]));
        list.setFilterText(itemText);
    };
    let onInputChange = (value)=>{
        if (value === "") list.setSelectedKeys(new Set([
            null
        ]));
        list.setFilterText(value);
    };
    let selectedKey = list.selectedKeys.values().next().value;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ComboBox), {
        label: "Star Wars Character Lookup",
        ...props,
        selectedKey: selectedKey,
        onSelectionChange: onSelectionChange,
        items: list.items,
        inputValue: list.filterText,
        onInputChange: onInputChange,
        loadingState: list.loadingState,
        onLoadMore: list.loadMore
    }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            key: item.name
        }, item.name));
}
function AsyncLoadingExampleControlledKeyWithReset(props) {
    let isFocused = (0, _react.useRef)(false);
    let list = (0, _data.useAsyncList)({
        async load ({ signal, cursor, filterText, selectedKeys }) {
            if (cursor) cursor = cursor.replace(/^http:\/\//i, "https://");
            // Slow down load so progress circle can appear
            await new Promise((resolve)=>setTimeout(resolve, 1500));
            let res = await fetch(cursor || `https://swapi.py4e.com/api/people/?search=${filterText}`, {
                signal
            });
            let json = await res.json();
            let selectedText;
            let selectedKey = selectedKeys.values().next().value;
            // If selectedKey exists and combobox is performing intial load, update the input value with the selected key text
            if (!isFocused.current && selectedKey) {
                var _json_results_find;
                let selectedItemName = (_json_results_find = json.results.find((item)=>item.name === selectedKey)) === null || _json_results_find === void 0 ? void 0 : _json_results_find.name;
                if (selectedItemName != null && selectedItemName !== filterText) selectedText = selectedItemName;
            }
            return {
                items: json.results,
                cursor: json.next,
                filterText: selectedText !== null && selectedText !== void 0 ? selectedText : filterText
            };
        },
        initialSelectedKeys: [
            "Luke Skywalker"
        ],
        getKey: (item)=>item.name
    });
    let onSelectionChange = (key)=>{
        var _list_getItem;
        let itemText = (_list_getItem = list.getItem(key)) === null || _list_getItem === void 0 ? void 0 : _list_getItem.name;
        list.setSelectedKeys(new Set([
            key
        ]));
        list.setFilterText(itemText);
    };
    let onInputChange = (value)=>{
        if (value === "") list.setSelectedKeys(new Set([
            null
        ]));
        list.setFilterText(value);
    };
    let selectedKey = list.selectedKeys.values().next().value;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ComboBox), {
        label: "Star Wars Character Lookup",
        ...props,
        onFocusChange: (focus)=>isFocused.current = focus,
        selectedKey: selectedKey,
        onSelectionChange: onSelectionChange,
        items: list.items,
        inputValue: list.filterText,
        onInputChange: onInputChange,
        loadingState: list.loadingState,
        onLoadMore: list.loadMore
    }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            key: item.name
        }, item.name));
}
let customFilterItems = [
    {
        name: "The first item",
        id: "1"
    },
    {
        name: "The second item",
        id: "2"
    },
    {
        name: "The third item",
        id: "3"
    }
];
let CustomFilterComboBox = (props)=>{
    let { startsWith } = (0, _i18N.useFilter)({
        sensitivity: "base"
    });
    let [filterValue, setFilterValue] = (0, _reactDefault.default).useState("");
    // eslint-disable-next-line react-hooks/exhaustive-deps
    let filteredItems = (0, _reactDefault.default).useMemo(()=>customFilterItems.filter((item)=>startsWith(item.name, filterValue)), [
        props.items,
        filterValue,
        startsWith
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ComboBox), {
        label: "Combobox",
        ...props,
        items: filteredItems,
        inputValue: filterValue,
        onInputChange: setFilterValue
    }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), null, item.name));
};
function AllControlledComboBox(props) {
    let [fieldState, setFieldState] = (0, _reactDefault.default).useState({
        selectedKey: props.selectedKey,
        inputValue: props.inputValue
    });
    let list = (0, _data.useTreeData)({
        initialItems: withSection
    });
    let onSelectionChange = (key)=>{
        setFieldState((prevState)=>{
            var _list_getItem;
            var _list_getItem_value_name;
            return {
                inputValue: (_list_getItem_value_name = (_list_getItem = list.getItem(key)) === null || _list_getItem === void 0 ? void 0 : _list_getItem.value.name) !== null && _list_getItem_value_name !== void 0 ? _list_getItem_value_name : props.allowsCustomValue ? prevState.inputValue : "",
                selectedKey: key
            };
        });
    };
    let onInputChange = (value)=>{
        setFieldState((prevState)=>({
                inputValue: value,
                selectedKey: value === "" ? null : prevState.selectedKey
            }));
    };
    let setSnake = ()=>{
        setFieldState({
            inputValue: "Snake",
            selectedKey: "3"
        });
    };
    let setRoss = ()=>{
        setFieldState({
            inputValue: "Ross",
            selectedKey: "6"
        });
    };
    let clearAll = ()=>{
        setFieldState({
            inputValue: "",
            selectedKey: null
        });
    };
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", null, "Current selectedKey: ", fieldState.selectedKey), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", null, "Current input value: ", fieldState.inputValue), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _buttongroup.ButtonGroup), {
        marginEnd: "30px"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.Button), {
        variant: "secondary",
        onPress: setSnake
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, "Snake")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.Button), {
        variant: "secondary",
        onPress: setRoss
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, "Ross")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.Button), {
        variant: "secondary",
        onPress: clearAll
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, "Clear key"))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ComboBox), {
        label: "Combobox",
        ...props,
        selectedKey: fieldState.selectedKey,
        inputValue: fieldState.inputValue,
        defaultItems: list.items,
        onInputChange: onInputChange,
        onSelectionChange: onSelectionChange
    }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Section), {
            items: item.children,
            title: item.value.name
        }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), null, item.value.name))));
}
let ControlledKeyComboBox = (props)=>{
    let [selectedKey, setSelectedKey] = (0, _reactDefault.default).useState(props.selectedKey);
    let onSelectionChange = (key)=>{
        setSelectedKey(key);
    };
    let setSnake = ()=>{
        setSelectedKey("3");
    };
    let setRoss = ()=>{
        setSelectedKey("6");
    };
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", null, "Current selectedKey: ", selectedKey), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _buttongroup.ButtonGroup), {
        marginEnd: "30px"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.Button), {
        variant: "secondary",
        onPress: setSnake
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, "Snake")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.Button), {
        variant: "secondary",
        onPress: setRoss
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, "Ross")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.Button), {
        variant: "secondary",
        onPress: ()=>setSelectedKey(null)
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, "Clear key"))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ComboBox), {
        label: "Combobox",
        ...props,
        selectedKey: selectedKey,
        defaultItems: withSection,
        onSelectionChange: onSelectionChange
    }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Section), {
            items: item.children,
            title: item.name
        }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), null, item.name))));
};
let ControlledValueComboBox = (props)=>{
    let [value, setValue] = (0, _reactDefault.default).useState(props.inputValue);
    let onValueChange = (value)=>{
        setValue(value);
    };
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", null, "Current input value: ", value), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _buttongroup.ButtonGroup), {
        marginEnd: "30px",
        UNSAFE_style: {
            verticalAlign: "bottom"
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.Button), {
        variant: "secondary",
        onPress: ()=>setValue("Blah")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, "Blah")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.Button), {
        variant: "secondary",
        onPress: ()=>setValue("Kangaroo")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, "Kangaroo")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.Button), {
        variant: "secondary",
        onPress: ()=>setValue("")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, "Clear field"))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ComboBox), {
        label: "Combobox",
        ...props,
        inputValue: value,
        defaultItems: withSection,
        onInputChange: onValueChange
    }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Section), {
            items: item.children,
            title: item.name
        }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), null, item.name))));
};
function ResizeCombobox(props) {
    let [size, setSize] = (0, _react.useState)(true);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
        direction: "column",
        gap: "size-200",
        alignItems: "start"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        style: {
            width: size ? "200px" : "300px"
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ComboBox), {
        label: "Combobox",
        ...props,
        width: "100%"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
        key: "one"
    }, "Item One"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
        key: "two",
        textValue: "Item Two"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _copyDefault.default), {
        size: "S"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, "Item Two")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
        key: "three"
    }, "Item Three"))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), {
        onPress: ()=>setSize((prev)=>!prev)
    }, "Toggle size"));
}
function render(props = {}) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ComboBox), {
        label: "Combobox",
        ...props
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
        key: "one"
    }, "Item One"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
        key: "two",
        textValue: "Item Two"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _copyDefault.default), {
        size: "S"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, "Item Two")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
        key: "three"
    }, "Item Three"));
}
function renderRow(props = {}) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
        gap: "size-200"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ComboBox), {
        label: "Label",
        ...props
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
        key: "one"
    }, "Option 1"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
        key: "two",
        textValue: "Item Two"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _copyDefault.default), {
        size: "S"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, "Option 2")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
        key: "three"
    }, "Option 3")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ComboBox), {
        isDisabled: true,
        label: "Label",
        ...props
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
        key: "one"
    }, "Option 1"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
        key: "two",
        textValue: "Item Two"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _copyDefault.default), {
        size: "S"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, "Option 2")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
        key: "three"
    }, "Option 3")));
}
function ComboBoxWithMap(props) {
    let [items, setItems] = (0, _reactDefault.default).useState([
        {
            name: "The first item",
            id: "one"
        },
        {
            name: "The second item",
            id: "two"
        },
        {
            name: "The third item",
            id: "three"
        }
    ]);
    let onClick = ()=>{
        setItems([
            {
                name: "The first item new text",
                id: "one"
            },
            {
                name: "The second item new text",
                id: "two"
            },
            {
                name: "The third item new text",
                id: "three"
            }
        ]);
    };
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
        direction: "column"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("button", {
        onClick: onClick
    }, "Press to change items"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ComboBox), {
        label: "Combobox",
        ...props
    }, items.map((item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            key: item.id
        }, item.name))));
}
function ComboBoxWithinDialog(props) {
    let { allowsCustomValue } = props;
    let items = [
        {
            name: "Animals",
            id: "s1",
            children: [
                {
                    name: "Aardvark",
                    id: "1"
                },
                {
                    name: "Kangaroo",
                    id: "2"
                },
                {
                    name: "Snake",
                    id: "3"
                }
            ]
        },
        {
            name: "People",
            id: "s2",
            children: [
                {
                    name: "Danni",
                    id: "4"
                },
                {
                    name: "Devon",
                    id: "5"
                },
                {
                    name: "Ross",
                    id: "6"
                }
            ]
        }
    ];
    let [selectedKey, setSelectedKey] = (0, _react.useState)(null);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _dialog.DialogTrigger), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), null, "Show ComboBox"), (close)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _dialog.Dialog), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Content), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ComboBox), {
            label: "Combo Box",
            ...props,
            defaultItems: items,
            placeholder: "choose wisely",
            width: "size-3000",
            allowsCustomValue: allowsCustomValue,
            selectedKey: selectedKey,
            onSelectionChange: setSelectedKey,
            onKeyDown: (e)=>{
                if (e.key === "Escape" && (selectedKey !== null || e.target.value === "" || allowsCustomValue)) e.continuePropagation();
            }
        }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Section), {
                key: item.name,
                items: item.children,
                title: item.name
            }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
                    key: item.name
                }, item.name)))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _buttongroup.ButtonGroup), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.Button), {
            onPress: close,
            variant: "secondary"
        }, "Cancel"))));
}

},{"@storybook/addon-actions":"coXbW","@react-spectrum/button":"jZWyP","@spectrum-icons/workflow/Add":"evYih","@spectrum-icons/workflow/Alert":"lNgQc","@react-spectrum/avatar":"kHDr1","@spectrum-icons/workflow/Bell":"5FeJ6","@react-spectrum/buttongroup":"anP11","@react-aria/utils":"9cLk5","../":"chANl","@react-spectrum/view":"dnRjt","@react-spectrum/contextualhelp":"jA6za","@spectrum-icons/workflow/Copy":"jpSBZ","@react-spectrum/dialog":"3G0HV","@spectrum-icons/workflow/Draw":"gXEyB","@react-spectrum/layout":"hzaUY","@react-spectrum/text":"etCGI","@react-spectrum/link":"lNoiB","react":"9yzVZ","@react-stately/data":"gEgJM","@react-aria/i18n":"411rg","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"lNgQc":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("a755f01bfa088fd5");
exports.__esModule = true;
exports.default = Alert;
var _Alert = require("328f86a64c54d74d");
var _icon = require("67bdfa25f91c9fea");
var _react = _interopRequireDefault(require("77e17e166a4e9016"));
function Alert(props) {
    return /*#__PURE__*/ _react.default.createElement(_icon.Icon, props, /*#__PURE__*/ _react.default.createElement(_Alert.A4uAlert, null));
}

},{"a755f01bfa088fd5":"iHubQ","328f86a64c54d74d":"dFiHm","67bdfa25f91c9fea":"k7wem","77e17e166a4e9016":"9yzVZ"}],"dFiHm":[function(require,module,exports) {
/**
* @adobe/react-spectrum-workflow (c) by Adobe
* 
* @adobe/react-spectrum-workflow is licensed under a
* Creative Commons Attribution-NoDerivatives 4.0 International License.
* 
* You should have received a copy of the license along with this
* work. If not, see <http://creativecommons.org/licenses/by-nd/4.0/>.
**/ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.A4uAlert = A4uAlert;
var _react = _interopRequireDefault(require("459d3d6ead43c81"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function A4uAlert(_ref) {
    var props = _extends({}, _ref);
    return /*#__PURE__*/ _react["default"].createElement("svg", _extends({
        viewBox: "0 0 36 36"
    }, props, props), /*#__PURE__*/ _react["default"].createElement("path", {
        fillRule: "evenodd",
        d: "M17.127,2.579.4,32.512A1,1,0,0,0,1.272,34H34.728a1,1,0,0,0,.872-1.488L18.873,2.579A1,1,0,0,0,17.127,2.579ZM20,29.5a.5.5,0,0,1-.5.5h-3a.5.5,0,0,1-.5-.5v-3a.5.5,0,0,1,.5-.5h3a.5.5,0,0,1,.5.5Zm0-6a.5.5,0,0,1-.5.5h-3a.5.5,0,0,1-.5-.5v-12a.5.5,0,0,1,.5-.5h3a.5.5,0,0,1,.5.5Z"
    }));
}

},{"459d3d6ead43c81":"9yzVZ"}],"chANl":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 * 
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _src = require("./src");
parcelHelpers.exportAll(_src, exports);

},{"./src":"bO8KM","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"hytoP":[function(require,module,exports) {
/*
 * Copyright 2021 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Default", ()=>Default);
parcelHelpers.export(exports, "WithLink", ()=>WithLink);
parcelHelpers.export(exports, "WithButton", ()=>WithButton);
parcelHelpers.export(exports, "AriaLabelledyBy", ()=>AriaLabelledyBy);
var _reactSpectrum = require("@adobe/react-spectrum");
var _src = require("../src");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
exports.default = {
    title: "ContextualHelp",
    component: (0, _src.ContextualHelp),
    argTypes: {
        onOpenChange: {
            action: "openChange",
            table: {
                disable: true
            }
        },
        placement: {
            control: "select",
            options: [
                "bottom",
                "bottom left",
                "bottom right",
                "bottom start",
                "bottom end",
                "top",
                "top left",
                "top right",
                "top start",
                "top end",
                "left",
                "left top",
                "left bottom",
                "start",
                "start top",
                "start bottom",
                "right",
                "right top",
                "right bottom",
                "end",
                "end top",
                "end bottom"
            ]
        },
        variant: {
            control: "select",
            defaultValue: "help",
            options: [
                "help",
                "info"
            ]
        },
        offset: {
            control: "number",
            min: -500,
            max: 500
        },
        crossOffset: {
            control: "number",
            min: -500,
            max: 500
        },
        containerPadding: {
            control: "number",
            min: -500,
            max: 500
        },
        shouldFlip: {
            control: "boolean"
        },
        children: {
            table: {
                disable: true
            }
        }
    }
};
const helpText = ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSpectrum.Text), null, "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin sit amet tristique risus. In sit amet suscipit lorem.");
const Default = {
    args: {
        children: /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSpectrum.Heading), null, "Help title"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSpectrum.Content), null, helpText()))
    }
};
const WithLink = {
    args: {
        children: /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSpectrum.Heading), null, "Help title"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSpectrum.Content), null, helpText()), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSpectrum.Footer), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSpectrum.Link), null, "Learn more")))
    },
    name: "with link"
};
const WithButton = {
    args: {
        marginStart: "size-100"
    },
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSpectrum.Flex), {
            alignItems: "center"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSpectrum.Button), {
            variant: "primary",
            isDisabled: true
        }, "Create"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _src.ContextualHelp), {
            ...args,
            UNSAFE_className: "foo"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSpectrum.Heading), null, "Help title"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSpectrum.Content), null, helpText()))),
    name: "with button",
    parameters: {
        description: {
            data: "Custom classname foo is on the contextual help button."
        }
    }
};
const AriaLabelledyBy = {
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSpectrum.Flex), {
            alignItems: "center"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
            id: "foo"
        }, "I label the contextual help button"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _src.ContextualHelp), {
            ...args,
            "aria-labelledby": "foo"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSpectrum.Heading), null, "Help title"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSpectrum.Content), null, helpText()))),
    name: "aria-labelledyby"
};

},{"@adobe/react-spectrum":"cwANo","../src":"jA6za","react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"bc8PO":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Default", ()=>Default);
parcelHelpers.export(exports, "DefaultValue", ()=>DefaultValue);
parcelHelpers.export(exports, "ControlledValue", ()=>ControlledValue);
parcelHelpers.export(exports, "DefaultValueZoned", ()=>DefaultValueZoned);
parcelHelpers.export(exports, "DateTimeValue", ()=>DateTimeValue);
parcelHelpers.export(exports, "DateTimeValueZoned", ()=>DateTimeValueZoned);
parcelHelpers.export(exports, "DateTimeValueAbsolute", ()=>DateTimeValueAbsolute);
parcelHelpers.export(exports, "DateTimeValueAbsoluteZoned", ()=>DateTimeValueAbsoluteZoned);
parcelHelpers.export(exports, "MinMaxValue", ()=>MinMaxValue);
parcelHelpers.export(exports, "IsDateUnavailable", ()=>IsDateUnavailable);
parcelHelpers.export(exports, "PlaceholderVal", ()=>PlaceholderVal);
parcelHelpers.export(exports, "PlaceholderValTime", ()=>PlaceholderValTime);
parcelHelpers.export(exports, "PlaceholderValTimeZoned", ()=>PlaceholderValTimeZoned);
parcelHelpers.export(exports, "AllEvents", ()=>AllEvents);
parcelHelpers.export(exports, "ContextualHelpStory", ()=>ContextualHelpStory);
var _addonActions = require("@storybook/addon-actions");
var _date = require("@internationalized/date");
var _view = require("@react-spectrum/view");
var _contextualhelp = require("@react-spectrum/contextualhelp");
var _ = require("../");
var _layout = require("@react-spectrum/layout");
var _text = require("@react-spectrum/text");
var _picker = require("@react-spectrum/picker");
var _provider = require("@react-spectrum/provider");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _i18N = require("@react-aria/i18n");
const BlockDecorator = (storyFn)=>/*#__PURE__*/ (0, _reactDefault.default).createElement("div", null, storyFn());
exports.default = {
    title: "Date and Time/DateField",
    component: (0, _.DateField),
    decorators: [
        (storyFn)=>BlockDecorator(storyFn)
    ],
    args: {
        onChange: (0, _addonActions.action)("onChange")
    },
    argTypes: {
        onChange: {
            table: {
                disable: true
            }
        },
        defaultValue: {
            table: {
                disable: true
            }
        },
        value: {
            table: {
                disable: true
            }
        },
        minValue: {
            table: {
                disable: true
            }
        },
        maxValue: {
            table: {
                disable: true
            }
        },
        placeholderValue: {
            table: {
                disable: true
            }
        },
        onBlur: {
            table: {
                disable: true
            }
        },
        onFocus: {
            table: {
                disable: true
            }
        },
        onFocusChange: {
            table: {
                disable: true
            }
        },
        onKeyDown: {
            table: {
                disable: true
            }
        },
        onKeyUp: {
            table: {
                disable: true
            }
        },
        contextualHelp: {
            table: {
                disable: true
            }
        },
        label: {
            control: "text"
        },
        granularity: {
            control: "select",
            options: [
                "day",
                "hour",
                "minute",
                "second"
            ]
        },
        hourCycle: {
            control: "select",
            options: [
                12,
                24
            ]
        },
        hideTimeZone: {
            control: "boolean"
        },
        shouldForceLeadingZeros: {
            control: "boolean"
        },
        isDisabled: {
            control: "boolean"
        },
        isQuiet: {
            control: "boolean"
        },
        isReadOnly: {
            control: "boolean"
        },
        isRequired: {
            control: "boolean"
        },
        necessityIndicator: {
            control: "select",
            options: [
                "icon",
                "label"
            ]
        },
        validationState: {
            control: "select",
            options: [
                null,
                "valid",
                "invalid"
            ]
        },
        description: {
            control: "text"
        },
        errorMessage: {
            control: "text"
        },
        labelAlign: {
            control: "select",
            options: [
                "end",
                "start"
            ]
        },
        labelPosition: {
            control: "select",
            options: [
                "top",
                "side"
            ]
        },
        autoFocus: {
            control: "boolean"
        },
        showFormatHelpText: {
            control: "boolean"
        },
        "aria-label": {
            control: "text"
        },
        width: {
            control: "text"
        }
    }
};
const Default = {
    render: (args)=>render(args)
};
const DefaultValue = {
    ...Default,
    args: {
        defaultValue: (0, _date.parseDate)("2020-02-03")
    }
};
const ControlledValue = {
    ...Default,
    args: {
        value: new (0, _date.CalendarDate)(2020, 2, 3)
    }
};
const DefaultValueZoned = {
    ...Default,
    args: {
        defaultValue: (0, _date.toZoned)((0, _date.parseDate)("2020-02-03"), "America/Los_Angeles")
    },
    name: "defaultValue date, zoned"
};
const DateTimeValue = {
    ...Default,
    args: {
        defaultValue: (0, _date.parseDateTime)("2021-03-14T08:45")
    }
};
const DateTimeValueZoned = {
    ...Default,
    args: {
        defaultValue: (0, _date.parseZonedDateTime)("2021-11-07T00:45-07:00[America/Los_Angeles]")
    }
};
const DateTimeValueAbsolute = {
    ...Default,
    args: {
        defaultValue: (0, _date.parseAbsoluteToLocal)("2021-11-07T07:45:00Z")
    }
};
const DateTimeValueAbsoluteZoned = {
    ...Default,
    args: {
        defaultValue: (0, _date.parseAbsolute)("2021-11-07T07:45:00Z", "America/New_York")
    }
};
const MinMaxValue = {
    ...Default,
    args: {
        minValue: new (0, _date.CalendarDate)(2010, 0, 1),
        maxValue: new (0, _date.CalendarDate)(2020, 0, 1)
    },
    name: "minValue: 2010/1/1, maxValue: 2020/1/1"
};
const IsDateUnavailable = {
    ...Default,
    args: {
        isDateUnavailable: (date)=>{
            return date.compare(new (0, _date.CalendarDate)(1980, 1, 1)) >= 0 && date.compare(new (0, _date.CalendarDate)(1980, 1, 8)) <= 0;
        },
        errorMessage: "Date unavailable.",
        contextualHelp: /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _contextualhelp.ContextualHelp), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Heading), null, "Which dates are unavailable?"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Content), null, "Any date between 1/1/1980 and 1/8/1980 are unavailable."))
    },
    parameters: {
        description: {
            data: 'Any date between 1/1/1980 and 1/8/1980 are unavailable and will display a "Date unavailable" error to the user'
        }
    }
};
const PlaceholderVal = {
    ...Default,
    args: {
        placeholderValue: new (0, _date.CalendarDate)(1980, 1, 1)
    },
    name: "placeholder value: 1980/1/1"
};
const PlaceholderValTime = {
    ...Default,
    args: {
        placeholderValue: new (0, _date.CalendarDateTime)(1980, 1, 1, 8)
    },
    name: "placeholder value: 1980/1/1 8AM"
};
const PlaceholderValTimeZoned = {
    ...Default,
    args: {
        placeholderValue: (0, _date.toZoned)(new (0, _date.CalendarDate)(1980, 1, 1), "America/Los_Angeles")
    },
    name: "placeholder value: 1980/1/1 zoned"
};
const AllEvents = {
    ...Default,
    args: {
        onBlur: (0, _addonActions.action)("onBlur"),
        onFocus: (0, _addonActions.action)("onFocus"),
        onFocusChange: (0, _addonActions.action)("onFocusChange"),
        onKeyDown: (0, _addonActions.action)("onKeyDown"),
        onKeyUp: (0, _addonActions.action)("onKeyUp")
    },
    name: "all the events"
};
const ContextualHelpStory = {
    ...Default,
    args: {
        contextualHelp: /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _contextualhelp.ContextualHelp), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Heading), null, "What is a segment?"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Content), null, "Segments identify who your visitors are, what devices and services they use, where they navigated from, and much more."))
    },
    name: "contextual help"
};
function render(props = {}) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Example, {
        label: "Date",
        maxWidth: "calc(100vw - 40px)",
        ...props
    });
}
// https://github.com/unicode-org/cldr/blob/22af90ae3bb04263f651323ce3d9a71747a75ffb/common/supplemental/supplementalData.xml#L4649-L4664
const preferences = [
    {
        locale: "",
        label: "Default",
        ordering: "gregory"
    },
    {
        label: "Arabic (Algeria)",
        locale: "ar-DZ",
        territories: "DJ DZ EH ER IQ JO KM LB LY MA MR OM PS SD SY TD TN YE",
        ordering: "gregory islamic islamic-civil islamic-tbla"
    },
    {
        label: "Arabic (United Arab Emirates)",
        locale: "ar-AE",
        territories: "AE BH KW QA",
        ordering: "gregory islamic-umalqura islamic islamic-civil islamic-tbla"
    },
    {
        label: "Arabic (Egypt)",
        locale: "AR-EG",
        territories: "EG",
        ordering: "gregory coptic islamic islamic-civil islamic-tbla"
    },
    {
        label: "Arabic (Saudi Arabia)",
        locale: "ar-SA",
        territories: "SA",
        ordering: "islamic-umalqura gregory islamic islamic-rgsa"
    },
    {
        label: "Farsi (Afghanistan)",
        locale: "fa-AF",
        territories: "AF IR",
        ordering: "persian gregory islamic islamic-civil islamic-tbla"
    },
    // {territories: 'CN CX HK MO SG', ordering: 'gregory chinese'},
    {
        label: "Amharic (Ethiopia)",
        locale: "am-ET",
        territories: "ET",
        ordering: "gregory ethiopic ethioaa"
    },
    {
        label: "Hebrew (Israel)",
        locale: "he-IL",
        territories: "IL",
        ordering: "gregory hebrew islamic islamic-civil islamic-tbla"
    },
    {
        label: "Hindi (India)",
        locale: "hi-IN",
        territories: "IN",
        ordering: "gregory indian"
    },
    // {label: 'Marathi (India)', locale: 'mr-IN', territories: 'IN', ordering: 'gregory indian'},
    {
        label: "Bengali (India)",
        locale: "bn-IN",
        territories: "IN",
        ordering: "gregory indian"
    },
    {
        label: "Japanese (Japan)",
        locale: "ja-JP",
        territories: "JP",
        ordering: "gregory japanese"
    },
    // {territories: 'KR', ordering: 'gregory dangi'},
    {
        label: "Thai (Thailand)",
        locale: "th-TH",
        territories: "TH",
        ordering: "buddhist gregory"
    },
    {
        label: "Chinese (Taiwan)",
        locale: "zh-TW",
        territories: "TW",
        ordering: "gregory roc chinese"
    }
];
const calendars = [
    {
        key: "gregory",
        name: "Gregorian"
    },
    {
        key: "japanese",
        name: "Japanese"
    },
    {
        key: "buddhist",
        name: "Buddhist"
    },
    {
        key: "roc",
        name: "Taiwan"
    },
    {
        key: "persian",
        name: "Persian"
    },
    {
        key: "indian",
        name: "Indian"
    },
    {
        key: "islamic-umalqura",
        name: "Islamic (Umm al-Qura)"
    },
    {
        key: "islamic-civil",
        name: "Islamic Civil"
    },
    {
        key: "islamic-tbla",
        name: "Islamic Tabular"
    },
    {
        key: "hebrew",
        name: "Hebrew"
    },
    {
        key: "coptic",
        name: "Coptic"
    },
    {
        key: "ethiopic",
        name: "Ethiopic"
    },
    {
        key: "ethioaa",
        name: "Ethiopic (Amete Alem)"
    }
];
function Example(props) {
    let [locale, setLocale] = (0, _reactDefault.default).useState("");
    let [calendar, setCalendar] = (0, _reactDefault.default).useState(calendars[0].key);
    let { locale: defaultLocale } = (0, _i18N.useLocale)();
    let pref = preferences.find((p)=>p.locale === locale);
    let preferredCalendars = (0, _reactDefault.default).useMemo(()=>pref ? pref.ordering.split(" ").map((p)=>calendars.find((c)=>c.key === p)).filter(Boolean) : [
            calendars[0]
        ], [
        pref
    ]);
    let otherCalendars = (0, _reactDefault.default).useMemo(()=>calendars.filter((c)=>!preferredCalendars.some((p)=>p.key === c.key)), [
        preferredCalendars
    ]);
    let updateLocale = (locale)=>{
        setLocale(locale);
        let pref = preferences.find((p)=>p.locale === locale);
        setCalendar(pref.ordering.split(" ")[0]);
    };
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
        direction: "column",
        gap: "size-600",
        alignItems: "center"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
        direction: "row",
        gap: "size-150",
        wrap: true,
        justifyContent: "center"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _picker.Picker), {
        label: "Locale",
        items: preferences,
        selectedKey: locale,
        onSelectionChange: updateLocale
    }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _picker.Item), {
            key: item.locale
        }, item.label)), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _picker.Picker), {
        label: "Calendar",
        selectedKey: calendar,
        onSelectionChange: setCalendar
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _picker.Section), {
        title: "Preferred",
        items: preferredCalendars
    }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _picker.Item), null, item.name)), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _picker.Section), {
        title: "Other",
        items: otherCalendars
    }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _picker.Item), null, item.name)))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _provider.Provider), {
        locale: (locale || defaultLocale) + (calendar && calendar !== preferredCalendars[0].key ? "-u-ca-" + calendar : "")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.DateField), props)));
}

},{"@storybook/addon-actions":"coXbW","@internationalized/date":"hesBk","@react-spectrum/view":"dnRjt","@react-spectrum/contextualhelp":"jA6za","../":"dzZCj","@react-spectrum/layout":"hzaUY","@react-spectrum/text":"etCGI","@react-spectrum/picker":"kL1Uy","@react-spectrum/provider":"5bCdp","react":"9yzVZ","@react-aria/i18n":"411rg","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"dzZCj":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _src = require("./src");
parcelHelpers.exportAll(_src, exports);

},{"./src":"2xkLK","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"jRHGd":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Default", ()=>Default);
parcelHelpers.export(exports, "DefaultValue", ()=>DefaultValue);
parcelHelpers.export(exports, "ControlledValue", ()=>ControlledValue);
parcelHelpers.export(exports, "DefaultValueZoned", ()=>DefaultValueZoned);
parcelHelpers.export(exports, "DateTimeValue", ()=>DateTimeValue);
parcelHelpers.export(exports, "DateTimeValueZoned", ()=>DateTimeValueZoned);
parcelHelpers.export(exports, "DateTimeValueAbsolute", ()=>DateTimeValueAbsolute);
parcelHelpers.export(exports, "DateTimeValueAbsoluteZoned", ()=>DateTimeValueAbsoluteZoned);
parcelHelpers.export(exports, "MinMaxValue", ()=>MinMaxValue);
parcelHelpers.export(exports, "PlaceholderVal", ()=>PlaceholderVal);
parcelHelpers.export(exports, "PlaceholderValTime", ()=>PlaceholderValTime);
parcelHelpers.export(exports, "PlaceholderValTimeZoned", ()=>PlaceholderValTimeZoned);
parcelHelpers.export(exports, "DateUnavailable", ()=>DateUnavailable);
parcelHelpers.export(exports, "AllEvents", ()=>AllEvents);
parcelHelpers.export(exports, "ContextualHelpStory", ()=>ContextualHelpStory);
var _addonActions = require("@storybook/addon-actions");
var _button = require("@react-spectrum/button");
var _date = require("@internationalized/date");
var _utils = require("@react-aria/utils");
var _view = require("@react-spectrum/view");
var _contextualhelp = require("@react-spectrum/contextualhelp");
var _ = require("../");
var _layout = require("@react-spectrum/layout");
var _text = require("@react-spectrum/text");
var _picker = require("@react-spectrum/picker");
var _provider = require("@react-spectrum/provider");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _i18N = require("@react-aria/i18n");
const BlockDecorator = (storyFn)=>/*#__PURE__*/ (0, _reactDefault.default).createElement("div", null, storyFn());
exports.default = {
    title: "Date and Time/DatePicker",
    component: (0, _.DatePicker),
    decorators: [
        (storyFn)=>BlockDecorator(storyFn)
    ],
    args: {
        onChange: (0, _addonActions.action)("onChange")
    },
    argTypes: {
        onChange: {
            table: {
                disable: true
            }
        },
        defaultValue: {
            table: {
                disable: true
            }
        },
        value: {
            table: {
                disable: true
            }
        },
        minValue: {
            table: {
                disable: true
            }
        },
        maxValue: {
            table: {
                disable: true
            }
        },
        placeholderValue: {
            table: {
                disable: true
            }
        },
        onBlur: {
            table: {
                disable: true
            }
        },
        onFocus: {
            table: {
                disable: true
            }
        },
        onFocusChange: {
            table: {
                disable: true
            }
        },
        onKeyDown: {
            table: {
                disable: true
            }
        },
        onKeyUp: {
            table: {
                disable: true
            }
        },
        onOpenChange: {
            table: {
                disable: true
            }
        },
        contextualHelp: {
            table: {
                disable: true
            }
        },
        isDateUnavailable: {
            table: {
                disable: true
            }
        },
        label: {
            control: "text"
        },
        granularity: {
            control: "select",
            options: [
                "day",
                "hour",
                "minute",
                "second"
            ]
        },
        hourCycle: {
            control: "select",
            options: [
                12,
                24
            ]
        },
        hideTimeZone: {
            control: "boolean"
        },
        shouldForceLeadingZeros: {
            control: "boolean"
        },
        isDisabled: {
            control: "boolean"
        },
        isQuiet: {
            control: "boolean"
        },
        isReadOnly: {
            control: "boolean"
        },
        isRequired: {
            control: "boolean"
        },
        necessityIndicator: {
            control: "select",
            options: [
                "icon",
                "label"
            ]
        },
        validationState: {
            control: "select",
            options: [
                null,
                "valid",
                "invalid"
            ]
        },
        description: {
            control: "text"
        },
        errorMessage: {
            control: "text"
        },
        labelAlign: {
            control: "select",
            options: [
                "end",
                "start"
            ]
        },
        labelPosition: {
            control: "select",
            options: [
                "top",
                "side"
            ]
        },
        autoFocus: {
            control: "boolean"
        },
        showFormatHelpText: {
            control: "boolean"
        },
        "aria-label": {
            control: "text"
        },
        width: {
            control: "text"
        },
        maxVisibleMonths: {
            control: "number"
        },
        shouldFlip: {
            control: "boolean"
        },
        defaultOpen: {
            control: "boolean"
        },
        isOpen: {
            control: "boolean"
        }
    }
};
const Default = {
    render: (args)=>render(args)
};
const DefaultValue = {
    ...Default,
    args: {
        defaultValue: (0, _date.parseDate)("2020-02-03")
    }
};
const ControlledValue = {
    args: {
        value: new (0, _date.CalendarDate)(2020, 2, 3)
    },
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(ControlledExample, args)
};
const DefaultValueZoned = {
    ...Default,
    args: {
        defaultValue: (0, _date.toZoned)((0, _date.parseDate)("2020-02-03"), "America/Los_Angeles")
    },
    name: "defaultValue date, zoned"
};
const DateTimeValue = {
    ...Default,
    args: {
        defaultValue: (0, _date.parseDateTime)("2021-03-14T08:45")
    }
};
const DateTimeValueZoned = {
    ...Default,
    args: {
        defaultValue: (0, _date.parseZonedDateTime)("2021-11-07T00:45-07:00[America/Los_Angeles]")
    }
};
const DateTimeValueAbsolute = {
    ...Default,
    args: {
        defaultValue: (0, _date.parseAbsoluteToLocal)("2021-11-07T07:45:00Z")
    }
};
const DateTimeValueAbsoluteZoned = {
    ...Default,
    args: {
        defaultValue: (0, _date.parseAbsolute)("2021-11-07T07:45:00Z", "America/New_York")
    }
};
const MinMaxValue = {
    ...Default,
    args: {
        minValue: new (0, _date.CalendarDate)(2010, 0, 1),
        maxValue: new (0, _date.CalendarDate)(2020, 0, 1)
    },
    name: "minValue: 2010/1/1, maxValue: 2020/1/1"
};
const PlaceholderVal = {
    ...Default,
    args: {
        placeholderValue: new (0, _date.CalendarDate)(1980, 1, 1)
    },
    name: "placeholder value: 1980/1/1"
};
const PlaceholderValTime = {
    ...Default,
    args: {
        placeholderValue: new (0, _date.CalendarDateTime)(1980, 1, 1, 8)
    },
    name: "placeholder value: 1980/1/1 8AM"
};
const PlaceholderValTimeZoned = {
    ...Default,
    args: {
        placeholderValue: (0, _date.toZoned)(new (0, _date.CalendarDate)(1980, 1, 1), "America/Los_Angeles")
    },
    name: "placeholder value: 1980/1/1 zoned"
};
const DateUnavailable = {
    ...Default,
    args: {
        isDateUnavailable: (date)=>{
            const disabledIntervals = [
                [
                    (0, _date.today)((0, _date.getLocalTimeZone)()),
                    (0, _date.today)((0, _date.getLocalTimeZone)()).add({
                        weeks: 1
                    })
                ],
                [
                    (0, _date.today)((0, _date.getLocalTimeZone)()).add({
                        weeks: 2
                    }),
                    (0, _date.today)((0, _date.getLocalTimeZone)()).add({
                        weeks: 3
                    })
                ]
            ];
            return disabledIntervals.some((interval)=>date.compare(interval[0]) > 0 && date.compare(interval[1]) < 0);
        }
    },
    name: "isDateUnavailable"
};
const AllEvents = {
    ...Default,
    args: {
        onBlur: (0, _addonActions.action)("onBlur"),
        onFocus: (0, _addonActions.action)("onFocus"),
        onFocusChange: (0, _addonActions.action)("onFocusChange"),
        onKeyDown: (0, _addonActions.action)("onKeyDown"),
        onKeyUp: (0, _addonActions.action)("onKeyUp"),
        onOpenChange: (0, _addonActions.action)("onOpenChange")
    },
    name: "all the events"
};
const ContextualHelpStory = {
    ...Default,
    args: {
        contextualHelp: /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _contextualhelp.ContextualHelp), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Heading), null, "What is a segment?"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Content), null, "Segments identify who your visitors are, what devices and services they use, where they navigated from, and much more."))
    },
    name: "contextual help"
};
function render(props = {}) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Example, {
        label: "Date",
        maxWidth: "calc(100vw - 40px)",
        ...props
    });
}
// https://github.com/unicode-org/cldr/blob/22af90ae3bb04263f651323ce3d9a71747a75ffb/common/supplemental/supplementalData.xml#L4649-L4664
const preferences = [
    {
        locale: "",
        label: "Default",
        ordering: "gregory"
    },
    {
        label: "Arabic (Algeria)",
        locale: "ar-DZ",
        territories: "DJ DZ EH ER IQ JO KM LB LY MA MR OM PS SD SY TD TN YE",
        ordering: "gregory islamic islamic-civil islamic-tbla"
    },
    {
        label: "Arabic (United Arab Emirates)",
        locale: "ar-AE",
        territories: "AE BH KW QA",
        ordering: "gregory islamic-umalqura islamic islamic-civil islamic-tbla"
    },
    {
        label: "Arabic (Egypt)",
        locale: "AR-EG",
        territories: "EG",
        ordering: "gregory coptic islamic islamic-civil islamic-tbla"
    },
    {
        label: "Arabic (Saudi Arabia)",
        locale: "ar-SA",
        territories: "SA",
        ordering: "islamic-umalqura gregory islamic islamic-rgsa"
    },
    {
        label: "Farsi (Afghanistan)",
        locale: "fa-AF",
        territories: "AF IR",
        ordering: "persian gregory islamic islamic-civil islamic-tbla"
    },
    // {territories: 'CN CX HK MO SG', ordering: 'gregory chinese'},
    {
        label: "Amharic (Ethiopia)",
        locale: "am-ET",
        territories: "ET",
        ordering: "gregory ethiopic ethioaa"
    },
    {
        label: "Hebrew (Israel)",
        locale: "he-IL",
        territories: "IL",
        ordering: "gregory hebrew islamic islamic-civil islamic-tbla"
    },
    {
        label: "Hindi (India)",
        locale: "hi-IN",
        territories: "IN",
        ordering: "gregory indian"
    },
    // {label: 'Marathi (India)', locale: 'mr-IN', territories: 'IN', ordering: 'gregory indian'},
    {
        label: "Bengali (India)",
        locale: "bn-IN",
        territories: "IN",
        ordering: "gregory indian"
    },
    {
        label: "Japanese (Japan)",
        locale: "ja-JP",
        territories: "JP",
        ordering: "gregory japanese"
    },
    // {territories: 'KR', ordering: 'gregory dangi'},
    {
        label: "Thai (Thailand)",
        locale: "th-TH",
        territories: "TH",
        ordering: "buddhist gregory"
    },
    {
        label: "Chinese (Taiwan)",
        locale: "zh-TW",
        territories: "TW",
        ordering: "gregory roc chinese"
    }
];
const calendars = [
    {
        key: "gregory",
        name: "Gregorian"
    },
    {
        key: "japanese",
        name: "Japanese"
    },
    {
        key: "buddhist",
        name: "Buddhist"
    },
    {
        key: "roc",
        name: "Taiwan"
    },
    {
        key: "persian",
        name: "Persian"
    },
    {
        key: "indian",
        name: "Indian"
    },
    {
        key: "islamic-umalqura",
        name: "Islamic (Umm al-Qura)"
    },
    {
        key: "islamic-civil",
        name: "Islamic Civil"
    },
    {
        key: "islamic-tbla",
        name: "Islamic Tabular"
    },
    {
        key: "hebrew",
        name: "Hebrew"
    },
    {
        key: "coptic",
        name: "Coptic"
    },
    {
        key: "ethiopic",
        name: "Ethiopic"
    },
    {
        key: "ethioaa",
        name: "Ethiopic (Amete Alem)"
    }
];
function Example(props) {
    let [locale, setLocale] = (0, _reactDefault.default).useState("");
    let [calendar, setCalendar] = (0, _reactDefault.default).useState(calendars[0].key);
    let { locale: defaultLocale } = (0, _i18N.useLocale)();
    let pref = preferences.find((p)=>p.locale === locale);
    let preferredCalendars = (0, _reactDefault.default).useMemo(()=>pref ? pref.ordering.split(" ").map((p)=>calendars.find((c)=>c.key === p)).filter(Boolean) : [
            calendars[0]
        ], [
        pref
    ]);
    let otherCalendars = (0, _reactDefault.default).useMemo(()=>calendars.filter((c)=>!preferredCalendars.some((p)=>p.key === c.key)), [
        preferredCalendars
    ]);
    let updateLocale = (locale)=>{
        setLocale(locale);
        let pref = preferences.find((p)=>p.locale === locale);
        setCalendar(pref.ordering.split(" ")[0]);
    };
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
        direction: "column",
        gap: "size-600",
        alignItems: "center"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
        direction: "row",
        gap: "size-150",
        wrap: true,
        justifyContent: "center"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _picker.Picker), {
        label: "Locale",
        items: preferences,
        selectedKey: locale,
        onSelectionChange: updateLocale
    }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _picker.Item), {
            key: item.locale
        }, item.label)), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _picker.Picker), {
        label: "Calendar",
        selectedKey: calendar,
        onSelectionChange: setCalendar
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _picker.Section), {
        title: "Preferred",
        items: preferredCalendars
    }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _picker.Item), null, item.name)), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _picker.Section), {
        title: "Other",
        items: otherCalendars
    }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _picker.Item), null, item.name)))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _provider.Provider), {
        locale: (locale || defaultLocale) + (calendar && calendar !== preferredCalendars[0].key ? "-u-ca-" + calendar : "")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.DatePicker), props)));
}
function ControlledExample(props) {
    let [value, setValue] = (0, _reactDefault.default).useState(props.value);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
        direction: "column",
        alignItems: "center",
        gap: "size-150"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Example, {
        label: "Controlled",
        ...props,
        value: value,
        onChange: (0, _utils.chain)(setValue, props === null || props === void 0 ? void 0 : props.onChange)
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), {
        onPress: ()=>setValue(new (0, _date.CalendarDate)(2020, 2, 3))
    }, "Change value"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), {
        onPress: ()=>setValue(null)
    }, "Clear"));
}

},{"@storybook/addon-actions":"coXbW","@react-spectrum/button":"jZWyP","@internationalized/date":"hesBk","@react-aria/utils":"9cLk5","@react-spectrum/view":"dnRjt","@react-spectrum/contextualhelp":"jA6za","../":"dzZCj","@react-spectrum/layout":"hzaUY","@react-spectrum/text":"etCGI","@react-spectrum/picker":"kL1Uy","@react-spectrum/provider":"5bCdp","react":"9yzVZ","@react-aria/i18n":"411rg","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"nIrhl":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Default", ()=>Default);
parcelHelpers.export(exports, "DefaultValue", ()=>DefaultValue);
parcelHelpers.export(exports, "ControlledValue", ()=>ControlledValue);
parcelHelpers.export(exports, "DefaultValueZoned", ()=>DefaultValueZoned);
parcelHelpers.export(exports, "GranularityMinute", ()=>GranularityMinute);
parcelHelpers.export(exports, "GranularitySecond", ()=>GranularitySecond);
parcelHelpers.export(exports, "HourCycle12", ()=>HourCycle12);
parcelHelpers.export(exports, "HourCycle24", ()=>HourCycle24);
parcelHelpers.export(exports, "ForceLeadingZeros", ()=>ForceLeadingZeros);
parcelHelpers.export(exports, "IsDisabled", ()=>IsDisabled);
parcelHelpers.export(exports, "IsQuietIsDisabled", ()=>IsQuietIsDisabled);
parcelHelpers.export(exports, "IsReadOnly", ()=>IsReadOnly);
parcelHelpers.export(exports, "AutoFocus", ()=>AutoFocus);
parcelHelpers.export(exports, "ValidationStateInvalid", ()=>ValidationStateInvalid);
parcelHelpers.export(exports, "ValidationStateValid", ()=>ValidationStateValid);
parcelHelpers.export(exports, "MinDate201011MaxDate202011", ()=>MinDate201011MaxDate202011);
parcelHelpers.export(exports, "IsDateUnavailable", ()=>IsDateUnavailable);
parcelHelpers.export(exports, "IsDateAvailableAllowsNonContiguousRanges", ()=>IsDateAvailableAllowsNonContiguousRanges);
parcelHelpers.export(exports, "PlaceholderValue198011", ()=>PlaceholderValue198011);
parcelHelpers.export(exports, "MaxVisibleMonths2", ()=>MaxVisibleMonths2);
parcelHelpers.export(exports, "MaxVisibleMonths3", ()=>MaxVisibleMonths3);
parcelHelpers.export(exports, "ShowFormatHelpText", ()=>ShowFormatHelpText);
parcelHelpers.export(exports, "AllTheEvents", ()=>AllTheEvents);
parcelHelpers.export(exports, "render", ()=>render);
var _addonActions = require("@storybook/addon-actions");
var _button = require("@react-spectrum/button");
var _date = require("@internationalized/date");
var _utils = require("@react-aria/utils");
var _ = require("../");
var _layout = require("@react-spectrum/layout");
var _picker = require("@react-spectrum/picker");
var _reactSpectrum = require("@adobe/react-spectrum");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _i18N = require("@react-aria/i18n");
const BlockDecorator = (storyFn)=>/*#__PURE__*/ (0, _reactDefault.default).createElement("div", null, storyFn());
exports.default = {
    title: "Date and Time/DateRangePicker",
    decorators: [
        BlockDecorator
    ],
    excludeStories: [
        "render"
    ]
};
const Default = ()=>render();
Default.story = {
    name: "default"
};
const DefaultValue = ()=>render({
        defaultValue: {
            start: new (0, _date.CalendarDate)(2020, 2, 3),
            end: new (0, _date.CalendarDate)(2020, 5, 4)
        }
    });
DefaultValue.story = {
    name: "defaultValue"
};
const ControlledValue = ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement(ControlledExample, null);
ControlledValue.story = {
    name: "controlled value"
};
const DefaultValueZoned = ()=>render({
        defaultValue: {
            start: (0, _date.toZoned)((0, _date.parseDate)("2020-02-03"), "America/New_York"),
            end: (0, _date.toZoned)((0, _date.parseDate)("2020-02-05"), "America/Los_Angeles")
        }
    });
DefaultValueZoned.story = {
    name: "defaultValue, zoned"
};
const GranularityMinute = ()=>render({
        granularity: "minute"
    });
GranularityMinute.story = {
    name: "granularity: minute"
};
const GranularitySecond = ()=>render({
        granularity: "second"
    });
GranularitySecond.story = {
    name: "granularity: second"
};
const HourCycle12 = ()=>render({
        granularity: "minute",
        hourCycle: 12
    });
HourCycle12.story = {
    name: "hourCycle: 12"
};
const HourCycle24 = ()=>render({
        granularity: "minute",
        hourCycle: 24
    });
HourCycle24.story = {
    name: "hourCycle: 24"
};
const ForceLeadingZeros = ()=>render({
        defaultValue: {
            start: new (0, _date.CalendarDate)(2020, 2, 3),
            end: new (0, _date.CalendarDate)(2020, 5, 4)
        },
        shouldForceLeadingZeros: true
    });
ForceLeadingZeros.story = {
    name: "shouldForceLeadingZeros"
};
const IsDisabled = ()=>render({
        isDisabled: true,
        value: {
            start: new (0, _date.CalendarDate)(2020, 2, 3),
            end: new (0, _date.CalendarDate)(2020, 5, 4)
        }
    });
IsDisabled.story = {
    name: "isDisabled"
};
const IsQuietIsDisabled = ()=>render({
        isQuiet: true,
        isDisabled: true,
        value: {
            start: new (0, _date.CalendarDate)(2020, 2, 3),
            end: new (0, _date.CalendarDate)(2020, 5, 4)
        }
    });
IsQuietIsDisabled.story = {
    name: "isQuiet, isDisabled"
};
const IsReadOnly = ()=>render({
        isReadOnly: true,
        value: {
            start: new (0, _date.CalendarDate)(2020, 2, 3),
            end: new (0, _date.CalendarDate)(2020, 5, 4)
        }
    });
IsReadOnly.story = {
    name: "isReadOnly"
};
const AutoFocus = ()=>render({
        autoFocus: true
    });
AutoFocus.story = {
    name: "autoFocus"
};
const ValidationStateInvalid = ()=>render({
        validationState: "invalid",
        value: {
            start: new (0, _date.CalendarDate)(2020, 2, 3),
            end: new (0, _date.CalendarDate)(2020, 5, 4)
        }
    });
ValidationStateInvalid.story = {
    name: "validationState: invalid"
};
const ValidationStateValid = ()=>render({
        validationState: "valid",
        value: {
            start: new (0, _date.CalendarDate)(2020, 2, 3),
            end: new (0, _date.CalendarDate)(2020, 5, 4)
        }
    });
ValidationStateValid.story = {
    name: "validationState: valid"
};
const MinDate201011MaxDate202011 = ()=>render({
        minValue: new (0, _date.CalendarDate)(2010, 1, 1),
        maxValue: new (0, _date.CalendarDate)(2020, 1, 1)
    });
MinDate201011MaxDate202011.story = {
    name: "minDate: 2010/1/1, maxDate: 2020/1/1"
};
const IsDateUnavailable = ()=>{
    const disabledRanges = [
        [
            (0, _date.today)((0, _date.getLocalTimeZone)()),
            (0, _date.today)((0, _date.getLocalTimeZone)()).add({
                weeks: 1
            })
        ],
        [
            (0, _date.today)((0, _date.getLocalTimeZone)()).add({
                weeks: 2
            }),
            (0, _date.today)((0, _date.getLocalTimeZone)()).add({
                weeks: 3
            })
        ]
    ];
    let [value, setValue] = (0, _reactDefault.default).useState(null);
    let isInvalid = value && disabledRanges.some((interval)=>value.end.compare(interval[0]) >= 0 && value.start.compare(interval[1]) <= 0);
    let isDateUnavailable = (date)=>disabledRanges.some((interval)=>date.compare(interval[0]) >= 0 && date.compare(interval[1]) <= 0);
    return render({
        value,
        onChange: setValue,
        validationState: isInvalid ? "invalid" : null,
        isDateUnavailable,
        errorMessage: "Selected ranges may not include unavailable dates."
    });
};
IsDateUnavailable.story = {
    name: "isDateUnavailable"
};
const IsDateAvailableAllowsNonContiguousRanges = ()=>{
    let { locale } = (0, _i18N.useLocale)();
    return render({
        isDateUnavailable: (date)=>(0, _date.isWeekend)(date, locale),
        allowsNonContiguousRanges: true
    });
};
IsDateAvailableAllowsNonContiguousRanges.story = {
    name: "isDateAvailable, allowsNonContiguousRanges"
};
const PlaceholderValue198011 = ()=>render({
        placeholderValue: new (0, _date.CalendarDate)(1980, 1, 1)
    });
PlaceholderValue198011.story = {
    name: "placeholderValue: 1980/1/1"
};
const MaxVisibleMonths2 = ()=>render({
        maxVisibleMonths: 2,
        granularity: "minute"
    });
MaxVisibleMonths2.story = {
    name: "maxVisibleMonths: 2"
};
const MaxVisibleMonths3 = ()=>render({
        maxVisibleMonths: 3,
        granularity: "minute"
    });
MaxVisibleMonths3.story = {
    name: "maxVisibleMonths: 3"
};
const ShowFormatHelpText = ()=>render({
        showFormatHelpText: true
    });
ShowFormatHelpText.story = {
    name: "showFormatHelpText"
};
const AllTheEvents = ()=>render({
        onBlur: (0, _addonActions.action)("onBlur"),
        onFocus: (0, _addonActions.action)("onFocus"),
        onFocusChange: (0, _addonActions.action)("onFocusChange"),
        onKeyDown: (0, _addonActions.action)("onKeyDown"),
        onKeyUp: (0, _addonActions.action)("onKeyUp"),
        onOpenChange: (0, _addonActions.action)("onOpenChange")
    });
AllTheEvents.story = {
    name: "all the events"
};
function render(props = {}) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", null, /*#__PURE__*/ (0, _reactDefault.default).createElement(Example, {
        label: "Date range",
        onChange: (0, _addonActions.action)("change"),
        maxWidth: "calc(100vw - 40px)",
        ...props
    }));
}
// https://github.com/unicode-org/cldr/blob/22af90ae3bb04263f651323ce3d9a71747a75ffb/common/supplemental/supplementalData.xml#L4649-L4664
const preferences = [
    {
        locale: "",
        label: "Default",
        ordering: "gregory"
    },
    {
        label: "Arabic (Algeria)",
        locale: "ar-DZ",
        territories: "DJ DZ EH ER IQ JO KM LB LY MA MR OM PS SD SY TD TN YE",
        ordering: "gregory islamic islamic-civil islamic-tbla"
    },
    {
        label: "Arabic (United Arab Emirates)",
        locale: "ar-AE",
        territories: "AE BH KW QA",
        ordering: "gregory islamic-umalqura islamic islamic-civil islamic-tbla"
    },
    {
        label: "Arabic (Egypt)",
        locale: "AR-EG",
        territories: "EG",
        ordering: "gregory coptic islamic islamic-civil islamic-tbla"
    },
    {
        label: "Arabic (Saudi Arabia)",
        locale: "ar-SA",
        territories: "SA",
        ordering: "islamic-umalqura gregory islamic islamic-rgsa"
    },
    {
        label: "Farsi (Afghanistan)",
        locale: "fa-AF",
        territories: "AF IR",
        ordering: "persian gregory islamic islamic-civil islamic-tbla"
    },
    // {territories: 'CN CX HK MO SG', ordering: 'gregory chinese'},
    {
        label: "Amharic (Ethiopia)",
        locale: "am-ET",
        territories: "ET",
        ordering: "gregory ethiopic ethioaa"
    },
    {
        label: "Hebrew (Israel)",
        locale: "he-IL",
        territories: "IL",
        ordering: "gregory hebrew islamic islamic-civil islamic-tbla"
    },
    {
        label: "Hindi (India)",
        locale: "hi-IN",
        territories: "IN",
        ordering: "gregory indian"
    },
    // {label: 'Marathi (India)', locale: 'mr-IN', territories: 'IN', ordering: 'gregory indian'},
    {
        label: "Bengali (India)",
        locale: "bn-IN",
        territories: "IN",
        ordering: "gregory indian"
    },
    {
        label: "Japanese (Japan)",
        locale: "ja-JP",
        territories: "JP",
        ordering: "gregory japanese"
    },
    // {territories: 'KR', ordering: 'gregory dangi'},
    {
        label: "Thai (Thailand)",
        locale: "th-TH",
        territories: "TH",
        ordering: "buddhist gregory"
    },
    {
        label: "Chinese (Taiwan)",
        locale: "zh-TW",
        territories: "TW",
        ordering: "gregory roc chinese"
    }
];
const calendars = [
    {
        key: "gregory",
        name: "Gregorian"
    },
    {
        key: "japanese",
        name: "Japanese"
    },
    {
        key: "buddhist",
        name: "Buddhist"
    },
    {
        key: "roc",
        name: "Taiwan"
    },
    {
        key: "persian",
        name: "Persian"
    },
    {
        key: "indian",
        name: "Indian"
    },
    {
        key: "islamic-umalqura",
        name: "Islamic (Umm al-Qura)"
    },
    {
        key: "islamic-civil",
        name: "Islamic Civil"
    },
    {
        key: "islamic-tbla",
        name: "Islamic Tabular"
    },
    {
        key: "hebrew",
        name: "Hebrew"
    },
    {
        key: "coptic",
        name: "Coptic"
    },
    {
        key: "ethiopic",
        name: "Ethiopic"
    },
    {
        key: "ethioaa",
        name: "Ethiopic (Amete Alem)"
    }
];
function Example(props) {
    let [locale, setLocale] = (0, _reactDefault.default).useState("");
    let [calendar, setCalendar] = (0, _reactDefault.default).useState(calendars[0].key);
    let { locale: defaultLocale } = (0, _i18N.useLocale)();
    let pref = preferences.find((p)=>p.locale === locale);
    let preferredCalendars = (0, _reactDefault.default).useMemo(()=>pref ? pref.ordering.split(" ").map((p)=>calendars.find((c)=>c.key === p)).filter(Boolean) : [
            calendars[0]
        ], [
        pref
    ]);
    let otherCalendars = (0, _reactDefault.default).useMemo(()=>calendars.filter((c)=>!preferredCalendars.some((p)=>p.key === c.key)), [
        preferredCalendars
    ]);
    let updateLocale = (locale)=>{
        setLocale(locale);
        let pref = preferences.find((p)=>p.locale === locale);
        setCalendar(pref.ordering.split(" ")[0]);
    };
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
        direction: "column",
        gap: "size-600",
        alignItems: "center"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
        direction: "row",
        gap: "size-150",
        wrap: true,
        justifyContent: "center"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _picker.Picker), {
        label: "Locale",
        items: preferences,
        selectedKey: locale,
        onSelectionChange: updateLocale
    }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _picker.Item), {
            key: item.locale
        }, item.label)), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _picker.Picker), {
        label: "Calendar",
        selectedKey: calendar,
        onSelectionChange: setCalendar
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _picker.Section), {
        title: "Preferred",
        items: preferredCalendars
    }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _picker.Item), null, item.name)), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _picker.Section), {
        title: "Other",
        items: otherCalendars
    }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _picker.Item), null, item.name)))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSpectrum.Provider), {
        locale: (locale || defaultLocale) + (calendar && calendar !== preferredCalendars[0].key ? "-u-ca-" + calendar : "")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.DateRangePicker), props)));
}
function ControlledExample(props) {
    let [value, setValue] = (0, _reactDefault.default).useState(null);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
        direction: "column",
        alignItems: "center",
        gap: "size-150"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.DateRangePicker), {
        label: "Controlled",
        ...props,
        granularity: "minute",
        value: value,
        onChange: (0, _utils.chain)(setValue, (0, _addonActions.action)("onChange"))
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), {
        onPress: ()=>setValue({
                start: new (0, _date.CalendarDate)(2020, 2, 3),
                end: new (0, _date.CalendarDate)(2020, 5, 4)
            })
    }, "Change value"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), {
        onPress: ()=>setValue(null)
    }, "Clear"));
}

},{"@storybook/addon-actions":"coXbW","@react-spectrum/button":"jZWyP","@internationalized/date":"hesBk","@react-aria/utils":"9cLk5","../":"dzZCj","@react-spectrum/layout":"hzaUY","@react-spectrum/picker":"kL1Uy","@adobe/react-spectrum":"cwANo","react":"9yzVZ","@react-aria/i18n":"411rg","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"kcJfy":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IsQuiet", ()=>IsQuiet);
parcelHelpers.export(exports, "LabelPositionSide", ()=>LabelPositionSide);
parcelHelpers.export(exports, "LabelAlignEnd", ()=>LabelAlignEnd);
parcelHelpers.export(exports, "Required", ()=>Required);
parcelHelpers.export(exports, "RequiredWithLabel", ()=>RequiredWithLabel);
parcelHelpers.export(exports, "Optional", ()=>Optional);
parcelHelpers.export(exports, "NoVisibleLabel", ()=>NoVisibleLabel);
parcelHelpers.export(exports, "QuietNoVisibleLabel", ()=>QuietNoVisibleLabel);
parcelHelpers.export(exports, "CustomWidth", ()=>CustomWidth);
parcelHelpers.export(exports, "QuietCustomWidth", ()=>QuietCustomWidth);
parcelHelpers.export(exports, "CustomWidthNoVisibleLabel", ()=>CustomWidthNoVisibleLabel);
parcelHelpers.export(exports, "CustomWidthLabelPositionSide", ()=>CustomWidthLabelPositionSide);
parcelHelpers.export(exports, "Description", ()=>Description);
parcelHelpers.export(exports, "ErrorMessage", ()=>ErrorMessage);
parcelHelpers.export(exports, "InvalidWithTime", ()=>InvalidWithTime);
parcelHelpers.export(exports, "_ContextualHelp", ()=>_ContextualHelp);
parcelHelpers.export(exports, "InScrollableContainer", ()=>InScrollableContainer);
parcelHelpers.export(exports, "ShouldFlipFalse", ()=>ShouldFlipFalse);
var _view = require("@react-spectrum/view");
var _contextualhelp = require("@react-spectrum/contextualhelp");
var _text = require("@react-spectrum/text");
var _date = require("@internationalized/date");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _dateRangePickerStories = require("./DateRangePicker.stories");
const BlockDecorator = (storyFn)=>/*#__PURE__*/ (0, _reactDefault.default).createElement("div", null, storyFn());
exports.default = {
    title: "Date and Time/DateRangePicker/styling",
    decorators: [
        BlockDecorator
    ]
};
const IsQuiet = ()=>(0, _dateRangePickerStories.render)({
        isQuiet: true
    });
IsQuiet.story = {
    name: "isQuiet"
};
const LabelPositionSide = ()=>(0, _dateRangePickerStories.render)({
        labelPosition: "side"
    });
LabelPositionSide.story = {
    name: "labelPosition: side"
};
const LabelAlignEnd = ()=>(0, _dateRangePickerStories.render)({
        labelPosition: "top",
        labelAlign: "end"
    });
LabelAlignEnd.story = {
    name: "labelAlign: end"
};
const Required = ()=>(0, _dateRangePickerStories.render)({
        isRequired: true
    });
Required.story = {
    name: "required"
};
const RequiredWithLabel = ()=>(0, _dateRangePickerStories.render)({
        isRequired: true,
        necessityIndicator: "label"
    });
RequiredWithLabel.story = {
    name: "required with label"
};
const Optional = ()=>(0, _dateRangePickerStories.render)({
        necessityIndicator: "label"
    });
Optional.story = {
    name: "optional"
};
const NoVisibleLabel = ()=>(0, _dateRangePickerStories.render)({
        "aria-label": "Date range",
        label: null
    });
NoVisibleLabel.story = {
    name: "no visible label"
};
const QuietNoVisibleLabel = ()=>(0, _dateRangePickerStories.render)({
        isQuiet: true,
        "aria-label": "Date range",
        label: null
    });
QuietNoVisibleLabel.story = {
    name: "quiet no visible label"
};
const CustomWidth = ()=>(0, _dateRangePickerStories.render)({
        width: "size-4600"
    });
CustomWidth.story = {
    name: "custom width"
};
const QuietCustomWidth = ()=>(0, _dateRangePickerStories.render)({
        isQuiet: true,
        width: "size-4600"
    });
QuietCustomWidth.story = {
    name: "quiet custom width"
};
const CustomWidthNoVisibleLabel = ()=>(0, _dateRangePickerStories.render)({
        width: "size-4600",
        label: null,
        "aria-label": "Date range"
    });
CustomWidthNoVisibleLabel.story = {
    name: "custom width no visible label"
};
const CustomWidthLabelPositionSide = ()=>(0, _dateRangePickerStories.render)({
        width: "size-4600",
        labelPosition: "side"
    });
CustomWidthLabelPositionSide.story = {
    name: "custom width, labelPosition=side"
};
const Description = ()=>(0, _dateRangePickerStories.render)({
        description: "Help text"
    });
Description.story = {
    name: "description"
};
const ErrorMessage = ()=>(0, _dateRangePickerStories.render)({
        errorMessage: "Dates must be after today",
        validationState: "invalid"
    });
ErrorMessage.story = {
    name: "errorMessage"
};
const InvalidWithTime = ()=>(0, _dateRangePickerStories.render)({
        validationState: "invalid",
        granularity: "minute",
        defaultValue: {
            start: (0, _date.toZoned)((0, _date.parseDate)("2020-02-03"), "America/New_York"),
            end: (0, _date.toZoned)((0, _date.parseDate)("2020-02-12"), "America/Los_Angeles")
        }
    });
InvalidWithTime.story = {
    name: "invalid with time"
};
const _ContextualHelp = ()=>(0, _dateRangePickerStories.render)({
        contextualHelp: /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _contextualhelp.ContextualHelp), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Heading), null, "What is a segment?"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Content), null, "Segments identify who your visitors are, what devices and services they use, where they navigated from, and much more."))
    });
_ContextualHelp.story = {
    name: "contextual help"
};
const InScrollableContainer = ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        style: {
            height: "200vh"
        }
    }, (0, _dateRangePickerStories.render)({
        granularity: "second"
    }));
InScrollableContainer.story = {
    name: "in scrollable container"
};
const ShouldFlipFalse = ()=>(0, _dateRangePickerStories.render)({
        shouldFlip: false
    });
ShouldFlipFalse.story = {
    name: "shouldFlip: false"
};

},{"@react-spectrum/view":"dnRjt","@react-spectrum/contextualhelp":"jA6za","@react-spectrum/text":"etCGI","@internationalized/date":"hesBk","react":"9yzVZ","./DateRangePicker.stories":"nIrhl","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"dDIjw":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Default", ()=>Default);
parcelHelpers.export(exports, "DefaultValue", ()=>DefaultValue);
parcelHelpers.export(exports, "ControlledValue", ()=>ControlledValue);
parcelHelpers.export(exports, "GranularitySecond", ()=>GranularitySecond);
parcelHelpers.export(exports, "HourCycle12", ()=>HourCycle12);
parcelHelpers.export(exports, "HourCycle24", ()=>HourCycle24);
parcelHelpers.export(exports, "HourCycle12GranularityHour", ()=>HourCycle12GranularityHour);
parcelHelpers.export(exports, "HourCycle24GranularityHour", ()=>HourCycle24GranularityHour);
parcelHelpers.export(exports, "Zoned", ()=>Zoned);
parcelHelpers.export(exports, "HideTimeZone", ()=>HideTimeZone);
parcelHelpers.export(exports, "ForceLeadingZeros", ()=>ForceLeadingZeros);
parcelHelpers.export(exports, "IsDisabled", ()=>IsDisabled);
parcelHelpers.export(exports, "IsQuietIsDisabled", ()=>IsQuietIsDisabled);
parcelHelpers.export(exports, "IsReadOnly", ()=>IsReadOnly);
parcelHelpers.export(exports, "AutoFocus", ()=>AutoFocus);
parcelHelpers.export(exports, "ValidationStateInvalid", ()=>ValidationStateInvalid);
parcelHelpers.export(exports, "ValidationStateValid", ()=>ValidationStateValid);
parcelHelpers.export(exports, "PlaceholderValue8Am", ()=>PlaceholderValue8Am);
parcelHelpers.export(exports, "PlaceholderValue1980118AmZoned", ()=>PlaceholderValue1980118AmZoned);
parcelHelpers.export(exports, "MinValue8Am", ()=>MinValue8Am);
parcelHelpers.export(exports, "MaxValue8Pm", ()=>MaxValue8Pm);
parcelHelpers.export(exports, "MinValue8AmMaxValue8Pm", ()=>MinValue8AmMaxValue8Pm);
parcelHelpers.export(exports, "AllTheEvents", ()=>AllTheEvents);
parcelHelpers.export(exports, "render", ()=>render);
var _addonActions = require("@storybook/addon-actions");
var _date = require("@internationalized/date");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _ = require("../");
const BlockDecorator = (storyFn)=>/*#__PURE__*/ (0, _reactDefault.default).createElement("div", null, storyFn());
exports.default = {
    title: "Date and Time/TimeField",
    decorators: [
        BlockDecorator
    ],
    excludeStories: [
        "render"
    ]
};
const Default = ()=>render();
Default.story = {
    name: "default"
};
const DefaultValue = ()=>render({
        defaultValue: (0, _date.parseTime)("20:24")
    });
DefaultValue.story = {
    name: "defaultValue"
};
const ControlledValue = ()=>render({
        value: new (0, _date.Time)(2, 35)
    });
ControlledValue.story = {
    name: "controlled value"
};
const GranularitySecond = ()=>render({
        granularity: "second"
    });
GranularitySecond.story = {
    name: "granularity: second"
};
const HourCycle12 = ()=>render({
        hourCycle: 12,
        defaultValue: (0, _date.parseTime)("00:00")
    });
HourCycle12.story = {
    name: "hourCycle: 12"
};
const HourCycle24 = ()=>render({
        hourCycle: 24,
        defaultValue: (0, _date.parseTime)("00:00")
    });
HourCycle24.story = {
    name: "hourCycle: 24"
};
const HourCycle12GranularityHour = ()=>render({
        hourCycle: 12,
        granularity: "hour"
    });
HourCycle12GranularityHour.story = {
    name: "hourCycle: 12, granularity: hour"
};
const HourCycle24GranularityHour = ()=>render({
        hourCycle: 24,
        granularity: "hour"
    });
HourCycle24GranularityHour.story = {
    name: "hourCycle: 24, granularity: hour"
};
const Zoned = ()=>render({
        defaultValue: (0, _date.parseZonedDateTime)("2021-11-07T00:45-07:00[America/Los_Angeles]")
    });
Zoned.story = {
    name: "zoned"
};
const HideTimeZone = ()=>render({
        defaultValue: (0, _date.parseZonedDateTime)("2021-11-07T00:45-07:00[America/Los_Angeles]"),
        hideTimeZone: true
    });
HideTimeZone.story = {
    name: "hideTimeZone"
};
const ForceLeadingZeros = ()=>render({
        defaultValue: (0, _date.parseTime)("08:00"),
        shouldForceLeadingZeros: true
    });
ForceLeadingZeros.story = {
    name: "shouldForceLeadingZeros"
};
const IsDisabled = ()=>render({
        isDisabled: true,
        value: new (0, _date.Time)(2, 35)
    });
IsDisabled.story = {
    name: "isDisabled"
};
const IsQuietIsDisabled = ()=>render({
        isQuiet: true,
        isDisabled: true,
        value: new (0, _date.Time)(2, 35)
    });
IsQuietIsDisabled.story = {
    name: "isQuiet, isDisabled"
};
const IsReadOnly = ()=>render({
        isReadOnly: true,
        value: new (0, _date.Time)(2, 35)
    });
IsReadOnly.story = {
    name: "isReadOnly"
};
const AutoFocus = ()=>render({
        autoFocus: true
    });
AutoFocus.story = {
    name: "autoFocus"
};
const ValidationStateInvalid = ()=>render({
        validationState: "invalid",
        value: new (0, _date.Time)(2, 35)
    });
ValidationStateInvalid.story = {
    name: "validationState: invalid"
};
const ValidationStateValid = ()=>render({
        validationState: "valid",
        value: new (0, _date.Time)(2, 35)
    });
ValidationStateValid.story = {
    name: "validationState: valid"
};
const PlaceholderValue8Am = ()=>render({
        placeholderValue: new (0, _date.Time)(8)
    });
PlaceholderValue8Am.story = {
    name: "placeholderValue: 8 AM"
};
const PlaceholderValue1980118AmZoned = ()=>render({
        placeholderValue: (0, _date.toZoned)(new (0, _date.CalendarDateTime)(1980, 1, 1, 8), "America/Los_Angeles")
    });
PlaceholderValue1980118AmZoned.story = {
    name: "placeholderValue: 1980/1/1 8AM, zoned"
};
const MinValue8Am = ()=>render({
        minValue: new (0, _date.Time)(8)
    });
MinValue8Am.story = {
    name: "minValue: 8 AM"
};
const MaxValue8Pm = ()=>render({
        maxValue: new (0, _date.Time)(20)
    });
MaxValue8Pm.story = {
    name: "maxValue: 8 PM"
};
const MinValue8AmMaxValue8Pm = ()=>render({
        minValue: new (0, _date.Time)(8),
        maxValue: new (0, _date.Time)(20)
    });
MinValue8AmMaxValue8Pm.story = {
    name: "minValue: 8 AM, maxValue: 8 PM"
};
const AllTheEvents = ()=>render({
        onBlur: (0, _addonActions.action)("onBlur"),
        onFocus: (0, _addonActions.action)("onFocus"),
        onFocusChange: (0, _addonActions.action)("onFocusChange"),
        onKeyDown: (0, _addonActions.action)("onKeyDown"),
        onKeyUp: (0, _addonActions.action)("onKeyUp"),
        onOpenChange: (0, _addonActions.action)("onOpenChange")
    });
AllTheEvents.story = {
    name: "all the events"
};
function render(props = {}) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TimeField), {
        label: "Time",
        onChange: (0, _addonActions.action)("change"),
        maxWidth: "calc(100vw - 40px)",
        ...props
    });
}

},{"@storybook/addon-actions":"coXbW","@internationalized/date":"hesBk","react":"9yzVZ","../":"dzZCj","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"6tToD":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IsQuiet", ()=>IsQuiet);
parcelHelpers.export(exports, "LabelPositionSide", ()=>LabelPositionSide);
parcelHelpers.export(exports, "LabelAlignEnd", ()=>LabelAlignEnd);
parcelHelpers.export(exports, "Required", ()=>Required);
parcelHelpers.export(exports, "RequiredWithLabel", ()=>RequiredWithLabel);
parcelHelpers.export(exports, "Optional", ()=>Optional);
parcelHelpers.export(exports, "NoVisibleLabel", ()=>NoVisibleLabel);
parcelHelpers.export(exports, "QuietNoVisibleLabel", ()=>QuietNoVisibleLabel);
parcelHelpers.export(exports, "CustomWidth", ()=>CustomWidth);
parcelHelpers.export(exports, "QuietCustomWidth", ()=>QuietCustomWidth);
parcelHelpers.export(exports, "CustomWidthNoVisibleLabel", ()=>CustomWidthNoVisibleLabel);
parcelHelpers.export(exports, "CustomWidthLabelPositionSide", ()=>CustomWidthLabelPositionSide);
parcelHelpers.export(exports, "Description", ()=>Description);
parcelHelpers.export(exports, "ErrorMessage", ()=>ErrorMessage);
parcelHelpers.export(exports, "_ContextualHelp", ()=>_ContextualHelp);
var _view = require("@react-spectrum/view");
var _contextualhelp = require("@react-spectrum/contextualhelp");
var _text = require("@react-spectrum/text");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _timeFieldStories = require("./TimeField.stories");
const BlockDecorator = (storyFn)=>/*#__PURE__*/ (0, _reactDefault.default).createElement("div", null, storyFn());
exports.default = {
    title: "Date and Time/TimeField/styling",
    decorators: [
        BlockDecorator
    ]
};
const IsQuiet = ()=>(0, _timeFieldStories.render)({
        isQuiet: true
    });
IsQuiet.story = {
    name: "isQuiet"
};
const LabelPositionSide = ()=>(0, _timeFieldStories.render)({
        labelPosition: "side"
    });
LabelPositionSide.story = {
    name: "labelPosition: side"
};
const LabelAlignEnd = ()=>(0, _timeFieldStories.render)({
        labelPosition: "top",
        labelAlign: "end"
    });
LabelAlignEnd.story = {
    name: "labelAlign: end"
};
const Required = ()=>(0, _timeFieldStories.render)({
        isRequired: true
    });
Required.story = {
    name: "required"
};
const RequiredWithLabel = ()=>(0, _timeFieldStories.render)({
        isRequired: true,
        necessityIndicator: "label"
    });
RequiredWithLabel.story = {
    name: "required with label"
};
const Optional = ()=>(0, _timeFieldStories.render)({
        necessityIndicator: "label"
    });
Optional.story = {
    name: "optional"
};
const NoVisibleLabel = ()=>(0, _timeFieldStories.render)({
        "aria-label": "Time",
        label: null
    });
NoVisibleLabel.story = {
    name: "no visible label"
};
const QuietNoVisibleLabel = ()=>(0, _timeFieldStories.render)({
        isQuiet: true,
        "aria-label": "Time",
        label: null
    });
QuietNoVisibleLabel.story = {
    name: "quiet no visible label"
};
const CustomWidth = ()=>(0, _timeFieldStories.render)({
        width: "size-3000"
    });
CustomWidth.story = {
    name: "custom width"
};
const QuietCustomWidth = ()=>(0, _timeFieldStories.render)({
        isQuiet: true,
        width: "size-3000"
    });
QuietCustomWidth.story = {
    name: "quiet custom width"
};
const CustomWidthNoVisibleLabel = ()=>(0, _timeFieldStories.render)({
        width: "size-3000",
        label: null,
        "aria-label": "Time"
    });
CustomWidthNoVisibleLabel.story = {
    name: "custom width no visible label"
};
const CustomWidthLabelPositionSide = ()=>(0, _timeFieldStories.render)({
        width: "size-3000",
        labelPosition: "side"
    });
CustomWidthLabelPositionSide.story = {
    name: "custom width, labelPosition=side"
};
const Description = ()=>(0, _timeFieldStories.render)({
        description: "Help text"
    });
Description.story = {
    name: "description"
};
const ErrorMessage = ()=>(0, _timeFieldStories.render)({
        errorMessage: "Time must be between 9 AM and 5 PM",
        validationState: "invalid"
    });
ErrorMessage.story = {
    name: "errorMessage"
};
const _ContextualHelp = ()=>(0, _timeFieldStories.render)({
        contextualHelp: /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _contextualhelp.ContextualHelp), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Heading), null, "What is a segment?"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Content), null, "Segments identify who your visitors are, what devices and services they use, where they navigated from, and much more."))
    });
_ContextualHelp.story = {
    name: "contextual help"
};

},{"@react-spectrum/view":"dnRjt","@react-spectrum/contextualhelp":"jA6za","@react-spectrum/text":"etCGI","react":"9yzVZ","./TimeField.stories":"dDIjw","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"gH7Kq":[function(require,module,exports) {
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Destructive", ()=>Destructive);
parcelHelpers.export(exports, "Confirmation", ()=>Confirmation);
parcelHelpers.export(exports, "Information", ()=>Information);
parcelHelpers.export(exports, "Error", ()=>Error);
parcelHelpers.export(exports, "Warning", ()=>Warning);
parcelHelpers.export(exports, "PrimaryDisabled", ()=>PrimaryDisabled);
parcelHelpers.export(exports, "AutoFocusPrimary", ()=>AutoFocusPrimary);
parcelHelpers.export(exports, "SecondaryDisabled", ()=>SecondaryDisabled);
parcelHelpers.export(exports, "AutoFocusSecondary", ()=>AutoFocusSecondary);
parcelHelpers.export(exports, "AutoFocusCancel", ()=>AutoFocusCancel);
var _addonActions = require("@storybook/addon-actions");
var _button = require("@react-spectrum/button");
var _ = require("../");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _dialogStories = require("./Dialog.stories");
exports.default = {
    title: "Dialog/Alert"
};
const Destructive = ()=>renderAlert({
        variant: "destructive",
        title: "Warning Destructive",
        children: (0, _dialogStories.singleParagraph)(),
        primaryActionLabel: "Accept",
        cancelLabel: "Cancel",
        onPrimaryAction: (0, _addonActions.action)("primary"),
        onSecondaryAction: (0, _addonActions.action)("secondary"),
        onCancel: (0, _addonActions.action)("cancel")
    });
Destructive.story = {
    name: "destructive"
};
const Confirmation = ()=>renderAlert({
        variant: "confirmation",
        title: "Confirmation Required",
        children: (0, _dialogStories.singleParagraph)(),
        primaryActionLabel: "Accept",
        cancelLabel: "Cancel",
        onPrimaryAction: (0, _addonActions.action)("primary"),
        onSecondaryAction: (0, _addonActions.action)("secondary"),
        onCancel: (0, _addonActions.action)("cancel")
    });
Confirmation.story = {
    name: "confirmation"
};
const Information = ()=>renderAlert({
        variant: "information",
        title: "Informative Alert",
        children: (0, _dialogStories.singleParagraph)(),
        primaryActionLabel: "Accept",
        cancelLabel: "Cancel",
        onPrimaryAction: (0, _addonActions.action)("primary"),
        onSecondaryAction: (0, _addonActions.action)("secondary"),
        onCancel: (0, _addonActions.action)("cancel")
    });
Information.story = {
    name: "information"
};
const Error = ()=>renderAlert({
        variant: "error",
        title: "Error: Danger Will Robinson",
        children: (0, _dialogStories.singleParagraph)(),
        primaryActionLabel: "Accept",
        cancelLabel: "Cancel",
        onPrimaryAction: (0, _addonActions.action)("primary"),
        onSecondaryAction: (0, _addonActions.action)("secondary"),
        onCancel: (0, _addonActions.action)("cancel")
    });
Error.story = {
    name: "error"
};
const Warning = ()=>renderAlert({
        variant: "warning",
        title: "This is a warning",
        children: (0, _dialogStories.singleParagraph)(),
        primaryActionLabel: "Accept",
        cancelLabel: "Cancel",
        onPrimaryAction: (0, _addonActions.action)("primary"),
        onSecondaryAction: (0, _addonActions.action)("secondary"),
        onCancel: (0, _addonActions.action)("cancel")
    });
Warning.story = {
    name: "warning"
};
const PrimaryDisabled = ()=>renderAlert({
        variant: "error",
        title: "Error: Danger Will Robinson",
        children: (0, _dialogStories.singleParagraph)(),
        primaryActionLabel: "Accept",
        cancelLabel: "Cancel",
        onPrimaryAction: (0, _addonActions.action)("primary"),
        onSecondaryAction: (0, _addonActions.action)("secondary"),
        onCancel: (0, _addonActions.action)("cancel"),
        isPrimaryActionDisabled: true
    });
PrimaryDisabled.story = {
    name: "primary disabled"
};
const AutoFocusPrimary = ()=>renderAlert({
        variant: "error",
        title: "Error: Danger Will Robinson",
        children: (0, _dialogStories.singleParagraph)(),
        primaryActionLabel: "Accept",
        cancelLabel: "Cancel",
        secondaryActionLabel: "Secondary button",
        onPrimaryAction: (0, _addonActions.action)("primary"),
        onSecondaryAction: (0, _addonActions.action)("secondary"),
        onCancel: (0, _addonActions.action)("cancel"),
        autoFocusButton: "primary"
    });
AutoFocusPrimary.story = {
    name: "autoFocus primary"
};
const SecondaryDisabled = ()=>renderAlert({
        variant: "error",
        title: "Error: Danger Will Robinson",
        children: (0, _dialogStories.singleParagraph)(),
        primaryActionLabel: "Accept",
        secondaryActionLabel: "Secondary button",
        cancelLabel: "Cancel",
        onPrimaryAction: (0, _addonActions.action)("primary"),
        onSecondaryAction: (0, _addonActions.action)("secondary"),
        onCancel: (0, _addonActions.action)("cancel"),
        isSecondaryActionDisabled: true
    });
SecondaryDisabled.story = {
    name: "secondary disabled"
};
const AutoFocusSecondary = ()=>renderAlert({
        variant: "error",
        title: "Error: Danger Will Robinson",
        children: (0, _dialogStories.singleParagraph)(),
        primaryActionLabel: "Accept",
        cancelLabel: "Cancel",
        secondaryActionLabel: "Secondary button",
        onPrimaryAction: (0, _addonActions.action)("primary"),
        onSecondaryAction: (0, _addonActions.action)("secondary"),
        onCancel: (0, _addonActions.action)("cancel"),
        autoFocusButton: "secondary"
    });
AutoFocusSecondary.story = {
    name: "autoFocus secondary"
};
const AutoFocusCancel = ()=>renderAlert({
        variant: "error",
        title: "Error: Danger Will Robinson",
        children: (0, _dialogStories.singleParagraph)(),
        primaryActionLabel: "Accept",
        cancelLabel: "Cancel",
        secondaryActionLabel: "Secondary button",
        onPrimaryAction: (0, _addonActions.action)("primary"),
        onSecondaryAction: (0, _addonActions.action)("secondary"),
        onCancel: (0, _addonActions.action)("cancel"),
        autoFocusButton: "cancel"
    });
AutoFocusCancel.story = {
    name: "autoFocus cancel"
};
function renderAlert({ ...props }) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        style: {
            display: "flex",
            width: "auto",
            margin: "100px 0"
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.DialogTrigger), {
        defaultOpen: true
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), null, "Trigger"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.AlertDialog), {
        ...props,
        onPrimaryAction: (0, _addonActions.action)("primary"),
        onSecondaryAction: (0, _addonActions.action)("secondary"),
        onCancel: props.onCancel
    })));
}

},{"@storybook/addon-actions":"coXbW","@react-spectrum/button":"jZWyP","../":"5Zpr7","react":"9yzVZ","./Dialog.stories":"gtUDv","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"5Zpr7":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _src = require("./src");
parcelHelpers.exportAll(_src, exports);

},{"./src":"3G0HV","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"gtUDv":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Default", ()=>Default);
parcelHelpers.export(exports, "IsDismissable", ()=>IsDismissable);
parcelHelpers.export(exports, "LongContent", ()=>LongContent);
parcelHelpers.export(exports, "WithHero", ()=>WithHero);
parcelHelpers.export(exports, "WithHeroIsDimissable", ()=>WithHeroIsDimissable);
parcelHelpers.export(exports, "WithFooter", ()=>WithFooter);
parcelHelpers.export(exports, "Small", ()=>Small);
parcelHelpers.export(exports, "Medium", ()=>Medium);
parcelHelpers.export(exports, "Large", ()=>Large);
parcelHelpers.export(exports, "_Form", ()=>_Form);
parcelHelpers.export(exports, "FullscreenTakeoverForm", ()=>FullscreenTakeoverForm);
parcelHelpers.export(exports, "ThreeButtons", ()=>ThreeButtons);
parcelHelpers.export(exports, "ThreeButtonsVerticalOrientation", ()=>ThreeButtonsVerticalOrientation);
parcelHelpers.export(exports, "ThreeButtonsFooter", ()=>ThreeButtonsFooter);
parcelHelpers.export(exports, "ClearedContent", ()=>ClearedContent);
parcelHelpers.export(exports, "WithIframe", ()=>WithIframe);
parcelHelpers.export(exports, "HorizontalScrolling", ()=>HorizontalScrolling);
parcelHelpers.export(exports, "singleParagraph", ()=>singleParagraph);
var _button = require("@react-spectrum/button");
var _buttongroup = require("@react-spectrum/buttongroup");
var _checkbox = require("@react-spectrum/checkbox");
var _view = require("@react-spectrum/view");
var _ = require("../");
var _divider = require("@react-spectrum/divider");
var _layout = require("@react-spectrum/layout");
var _form = require("@react-spectrum/form");
var _text = require("@react-spectrum/text");
var _image = require("@react-spectrum/image");
var _picker = require("@react-spectrum/picker");
var _radio = require("@react-spectrum/radio");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _textfield = require("@react-spectrum/textfield");
exports.default = {
    title: "Dialog",
    providerSwitcher: {
        status: "notice"
    },
    excludeStories: [
        "singleParagraph"
    ]
};
const Default = ()=>render({});
Default.story = {
    name: "default"
};
const IsDismissable = ()=>render({
        isDismissable: true
    });
IsDismissable.story = {
    name: "isDismissable"
};
const LongContent = ()=>renderLongContent({});
LongContent.story = {
    name: "long content"
};
const WithHero = ()=>renderHero({});
WithHero.story = {
    name: "with hero"
};
const WithHeroIsDimissable = ()=>renderHero({
        isDismissable: true
    });
WithHeroIsDimissable.story = {
    name: "with hero, isDimissable"
};
const WithFooter = ()=>renderFooter({});
WithFooter.story = {
    name: "with footer"
};
const Small = ()=>render({
        size: "S"
    });
Small.story = {
    name: "small"
};
const Medium = ()=>render({
        size: "M"
    });
Medium.story = {
    name: "medium"
};
const Large = ()=>render({
        size: "L"
    });
Large.story = {
    name: "large"
};
const _Form = ()=>renderWithForm({});
_Form.story = {
    name: "form"
};
const FullscreenTakeoverForm = ()=>renderWithForm({
        type: "fullscreenTakeover"
    });
FullscreenTakeoverForm.story = {
    name: "fullscreenTakeover form"
};
const ThreeButtons = ()=>renderWithThreeButtons({});
ThreeButtons.story = {
    name: "three buttons"
};
const ThreeButtonsVerticalOrientation = ()=>renderWithThreeButtonsVertical({});
ThreeButtonsVerticalOrientation.story = {
    name: "three buttons, vertical orientation"
};
const ThreeButtonsFooter = ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement(RenderWithThreeButtonsAndFooter, null);
ThreeButtonsFooter.story = {
    name: "three buttons, footer"
};
const ClearedContent = ()=>renderWithDividerInContent({});
ClearedContent.story = {
    name: "cleared content"
};
const WithIframe = ()=>renderIframe({});
WithIframe.story = {
    name: "with iframe"
};
const HorizontalScrolling = ()=>renderHorizontalScrolling({});
function render(props) {
    let { width = "auto", isDismissable, ...otherProps } = props;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        style: {
            display: "flex",
            width,
            margin: "100px 0"
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.DialogTrigger), {
        isDismissable: isDismissable,
        defaultOpen: true
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), null, "Trigger"), (close)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Dialog), otherProps, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Heading), null, "The Heading"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Header), null, "The Header"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _divider.Divider), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Content), null, singleParagraph()), !isDismissable && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _buttongroup.ButtonGroup), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.Button), {
            variant: "secondary",
            onPress: close
        }, "Cancel"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.Button), {
            variant: "cta",
            onPress: close
        }, "Confirm")))));
}
function renderIframe({ width = "auto", isDismissable, ...props }) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        style: {
            display: "flex",
            width,
            margin: "100px 0"
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.DialogTrigger), {
        isDismissable: isDismissable,
        defaultOpen: true
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), null, "Trigger"), (close)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Dialog), props, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Heading), null, "The Heading"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Header), null, "The Header"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _divider.Divider), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Content), null, /*#__PURE__*/ (0, _reactDefault.default).createElement("iframe", {
            width: "100%",
            title: "wikipedia",
            src: "https://wikipedia.org/wiki/Main_Page"
        })), !isDismissable && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _buttongroup.ButtonGroup), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.Button), {
            variant: "secondary",
            onPress: close
        }, "Cancel"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.Button), {
            variant: "cta",
            onPress: close
        }, "Confirm")))));
}
function renderHero(props) {
    let { width = "auto", isDismissable, ...otherProps } = props;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        style: {
            display: "flex",
            width,
            margin: "100px 0"
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.DialogTrigger), {
        isDismissable: isDismissable,
        defaultOpen: true
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), null, "Trigger"), (close)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Dialog), otherProps, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _image.Image), {
            slot: "hero",
            alt: "",
            src: "https://i.imgur.com/Z7AzH2c.png",
            objectFit: "cover"
        }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Heading), null, "The Heading"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Header), null, "The Header"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _divider.Divider), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Content), null, singleParagraph()), !isDismissable && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _buttongroup.ButtonGroup), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.Button), {
            variant: "secondary",
            onPress: close
        }, "Cancel"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.Button), {
            variant: "cta",
            onPress: close
        }, "Confirm")))));
}
function renderFooter({ width = "auto", isDismissable, ...props }) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        style: {
            display: "flex",
            width,
            margin: "100px 0"
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.DialogTrigger), {
        isDismissable: isDismissable,
        defaultOpen: true
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), null, "Trigger"), (close)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Dialog), props, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Heading), null, "The Heading"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Header), null, "The Header"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _divider.Divider), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Content), null, singleParagraph()), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Footer), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _checkbox.Checkbox), null, "I accept")), !isDismissable && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _buttongroup.ButtonGroup), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.Button), {
            variant: "secondary",
            onPress: close
        }, "Cancel"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.Button), {
            variant: "cta",
            onPress: close
        }, "Confirm")))));
}
function renderWithForm({ width = "auto", ...props }) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        style: {
            display: "flex",
            width,
            margin: "100px 0"
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.DialogTrigger), {
        defaultOpen: true,
        type: props.type
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), null, "Trigger"), (close)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Dialog), props, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Heading), null, "The Heading"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Header), null, "The Header"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _divider.Divider), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Content), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _form.Form), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textfield.TextField), {
            label: "Last Words",
            autoFocus: true
        }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _checkbox.Checkbox), null, "Acknowledge robot overlords"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _picker.Picker), {
            isDisabled: true
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _picker.Item), {
            key: "Aardvark"
        }, "Aardvark"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _picker.Item), {
            key: "Kangaroo"
        }, "Kangaroo"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _picker.Item), {
            key: "Snake"
        }, "Snake")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.Button), {
            UNSAFE_style: {
                display: "none"
            },
            variant: "primary"
        }, "Hidden"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.Button), {
            UNSAFE_style: {
                visibility: "hidden",
                position: "absolute"
            },
            variant: "primary"
        }, "Hidden"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _radio.RadioGroup), {
            label: "Preferred Job",
            name: "jobs"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _radio.Radio), {
            value: "battery"
        }, "Battery"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _radio.Radio), {
            value: "storage"
        }, "Information Storage"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _radio.Radio), {
            value: "processor"
        }, "Processor"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _radio.Radio), {
            value: "zoo"
        }, "Zoo stock"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _radio.Radio), {
            value: "translator"
        }, "Emotional Translator"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _radio.Radio), {
            value: "hunter"
        }, "Bounty Hunter"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _radio.Radio), {
            value: "actor"
        }, "Actor"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _radio.Radio), {
            value: "tester"
        }, "Waterslide Tester"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _radio.Radio), {
            value: "psychiatrist"
        }, "Psychiatrist")))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _buttongroup.ButtonGroup), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.Button), {
            variant: "secondary",
            onPress: close
        }, "Cancel"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.Button), {
            variant: "cta",
            onPress: close
        }, "Confirm")))));
}
let singleParagraph = ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin sit amet tristique risus. In sit amet suscipit lorem. Orci varius natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. In condimentum imperdiet metus non condimentum. Duis eu velit et quam accumsan tempus at id velit. Duis elementum elementum purus, id tempus mauris posuere a. Nunc vestibulum sapien pellentesque lectus commodo ornare.");
let fiveParagraphs = ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement("p", null, "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Mi proin sed libero enim. Mattis ullamcorper velit sed ullamcorper morbi tincidunt. Sed enim ut sem viverra aliquet eget sit amet tellus. Diam quis enim lobortis scelerisque fermentum dui faucibus in ornare. Diam quam nulla porttitor massa id. Eleifend mi in nulla posuere sollicitudin. Turpis nunc eget lorem dolor sed viverra ipsum nunc. Faucibus in ornare quam viverra. Risus commodo viverra maecenas accumsan lacus vel facilisis volutpat est. Nam libero justo laoreet sit amet cursus sit. Netus et malesuada fames ac. Dictum fusce ut placerat orci nulla pellentesque dignissim enim sit. Eros donec ac odio tempor orci. Ut etiam sit amet nisl purus in mollis nunc. Nisl rhoncus mattis rhoncus urna neque viverra. Convallis aenean et tortor at risus. Diam phasellus vestibulum lorem sed risus ultricies."), /*#__PURE__*/ (0, _reactDefault.default).createElement("p", null, "Eleifend quam adipiscing vitae proin sagittis nisl. Diam donec adipiscing tristique risus. In fermentum posuere urna nec tincidunt praesent semper. Suspendisse in est ante in. Egestas diam in arcu cursus euismod quis viverra nibh cras. Aliquam sem fringilla ut morbi tincidunt augue interdum. Lacus sed turpis tincidunt id aliquet risus feugiat. Praesent semper feugiat nibh sed pulvinar proin. In massa tempor nec feugiat nisl pretium fusce id velit. Non nisi est sit amet facilisis. Mi in nulla posuere sollicitudin aliquam ultrices. Morbi leo urna molestie at elementum. Laoreet non curabitur gravida arcu ac tortor dignissim convallis. Risus quis varius quam quisque id. Platea dictumst quisque sagittis purus. Etiam non quam lacus suspendisse faucibus interdum posuere. Semper feugiat nibh sed pulvinar proin gravida hendrerit lectus."), /*#__PURE__*/ (0, _reactDefault.default).createElement("p", null, "Risus ultricies tristique nulla aliquet enim tortor at. Ac placerat vestibulum lectus mauris. Sed viverra tellus in hac habitasse platea dictumst vestibulum rhoncus. Suspendisse ultrices gravida dictum fusce ut placerat orci nulla pellentesque. Sit amet nulla facilisi morbi tempus iaculis urna. Ut etiam sit amet nisl purus in. Risus at ultrices mi tempus imperdiet. Magna fermentum iaculis eu non diam phasellus. Orci sagittis eu volutpat odio. Volutpat blandit aliquam etiam erat velit scelerisque in dictum non. Amet nulla facilisi morbi tempus iaculis urna id. Iaculis eu non diam phasellus. Eu lobortis elementum nibh tellus molestie nunc. At tempor commodo ullamcorper a lacus vestibulum sed. Mi sit amet mauris commodo quis. Tellus elementum sagittis vitae et leo duis. Vel risus commodo viverra maecenas accumsan lacus."), /*#__PURE__*/ (0, _reactDefault.default).createElement("p", null, "Ut porttitor leo a diam sollicitudin tempor id eu nisl. Tristique senectus et netus et malesuada fames ac turpis egestas. Tellus in hac habitasse platea dictumst vestibulum rhoncus est. Integer feugiat scelerisque varius morbi enim nunc faucibus a. Tempus quam pellentesque nec nam aliquam sem et. Quam viverra orci sagittis eu volutpat odio facilisis mauris. Nunc lobortis mattis aliquam faucibus purus in massa tempor. Tincidunt dui ut ornare lectus sit amet est. Magna fermentum iaculis eu non. Posuere sollicitudin aliquam ultrices sagittis orci a scelerisque. Vitae aliquet nec ullamcorper sit amet risus nullam eget felis. Vitae proin sagittis nisl rhoncus mattis rhoncus. Nunc vel risus commodo viverra maecenas. Diam in arcu cursus euismod. Dolor morbi non arcu risus quis varius quam. Amet nisl suscipit adipiscing bibendum. Nulla pellentesque dignissim enim sit amet venenatis. Nunc congue nisi vitae suscipit tellus mauris a diam maecenas. In hac habitasse platea dictumst vestibulum rhoncus est pellentesque elit"), /*#__PURE__*/ (0, _reactDefault.default).createElement("p", null, "Cras semper auctor neque vitae tempus quam pellentesque nec. Maecenas ultricies mi eget mauris pharetra et ultrices neque ornare. Vulputate enim nulla aliquet porttitor lacus luctus accumsan tortor posuere. Pellentesque habitant morbi tristique senectus et. Ipsum dolor sit amet consectetur adipiscing elit pellentesque. Sem et tortor consequat id porta nibh venenatis. Viverra nibh cras pulvinar mattis nunc sed blandit. Urna porttitor rhoncus dolor purus. Vivamus arcu felis bibendum ut. Cras sed felis eget velit aliquet. Sed tempus urna et pharetra pharetra. Viverra adipiscing at in tellus integer feugiat scelerisque varius morbi. Ac tortor vitae purus faucibus ornare suspendisse sed nisi lacus. Ultrices neque ornare aenean euismod elementum nisi quis eleifend quam. Vel turpis nunc eget lorem. Quisque egestas diam in arcu cursus euismod quis viverra. At tempor commodo ullamcorper a lacus vestibulum sed. Id aliquet lectus proin nibh nisl condimentum id venenatis. Quis viverra nibh cras pulvinar. Purus in mollis nunc sed."));
function renderLongContent({ width = "auto", ...props }) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        style: {
            display: "flex",
            flexDirection: "column",
            alignItems: "start",
            width,
            padding: "0 20px"
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("p", null, "Test instructions on mobile:", /*#__PURE__*/ (0, _reactDefault.default).createElement("ol", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("li", null, "Scroll down and open dialog."), /*#__PURE__*/ (0, _reactDefault.default).createElement("li", null, "Tap on the top input. Dialog should resize when the keyboard comes up and remain at the top of the screen. The rest of the page should not scroll (the first time you do this it may scroll slightly due to the bottom toolbar showing)."), /*#__PURE__*/ (0, _reactDefault.default).createElement("li", null, "Close the software keyboard."), /*#__PURE__*/ (0, _reactDefault.default).createElement("li", null, "Scroll down and tap on the bottom input. Dialog should resize as before, and focused input should scroll into view."), /*#__PURE__*/ (0, _reactDefault.default).createElement("li", null, "Tap the previous button in the software keyboard. Focus should move to the first input in the dialog. Dialog should not move and page should not scroll."), /*#__PURE__*/ (0, _reactDefault.default).createElement("li", null, "Tap the previous button again. Focus should stay on the first input in the dialog and not move out to the textfield outside the dialog. The page may jump slightly, and come back but there is nothing we can do about this.")), "Note: all this only works outside the storybook iframe due to VisualViewport limitations."), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textfield.TextField), {
        label: "Outer textfield"
    }), fiveParagraphs(), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.DialogTrigger), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), null, "Trigger"), (close)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Dialog), props, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Heading), null, "The Heading is also very long and demonstrates what happens if there is no Header"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _divider.Divider), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Content), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textfield.TextField), {
            label: "Top textfield"
        }), fiveParagraphs(), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textfield.TextField), {
            label: "Bottom textfield"
        })), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _buttongroup.ButtonGroup), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.Button), {
            variant: "secondary",
            onPress: close
        }, "Cancel"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.Button), {
            variant: "cta",
            onPress: close,
            autoFocus: true
        }, "Confirm")))), fiveParagraphs());
}
function renderWithThreeButtons({ width = "auto", ...props }) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        style: {
            display: "flex",
            width,
            margin: "100px 0"
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.DialogTrigger), {
        defaultOpen: true
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), null, "Trigger"), (close)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Dialog), props, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Heading), null, "The Heading"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Header), null, "The Header"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _divider.Divider), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Content), null, singleParagraph()), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _buttongroup.ButtonGroup), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.Button), {
            variant: "secondary",
            onPress: close
        }, "Secondary"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.Button), {
            variant: "primary",
            onPress: close
        }, "Primary"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.Button), {
            variant: "cta",
            onPress: close,
            autoFocus: true
        }, "CTA")))));
}
function renderWithThreeButtonsVertical({ width = "auto", ...props }) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        style: {
            display: "flex",
            width,
            margin: "100px 0"
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.DialogTrigger), {
        defaultOpen: true
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), null, "Trigger"), (close)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Dialog), props, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Heading), null, "The Heading"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _divider.Divider), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Content), null, singleParagraph()), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _buttongroup.ButtonGroup), {
            orientation: "vertical"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.Button), {
            variant: "secondary",
            onPress: close
        }, "Secondary"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.Button), {
            variant: "primary",
            onPress: close
        }, "Primary"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.Button), {
            variant: "cta",
            onPress: close,
            autoFocus: true
        }, "CTA")))));
}
function RenderWithThreeButtonsAndFooter({ width = "auto", ...props }) {
    let labels = [
        {
            heading: "The Heading",
            checkboxLabel: "I have read and accept",
            secondaryButtonLabel: "Secondary",
            primaryButtonLabel: "Primary"
        },
        {
            heading: "Terms of Service",
            checkboxLabel: "I have read and accept the terms of use and privacy policy",
            secondaryButtonLabel: "Secondary and best button",
            primaryButtonLabel: "Primary and worst"
        }
    ];
    let [whichLabels, setWhichLabels] = (0, _react.useState)(0);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        style: {
            display: "flex",
            width,
            margin: "100px 0"
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.Button), {
        variant: "primary",
        onPress: ()=>{
            whichLabels ? setWhichLabels(0) : setWhichLabels(1);
        }
    }, "Toggle labels"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.DialogTrigger), {
        defaultOpen: true
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), null, "Trigger"), (close)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Dialog), props, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Heading), null, labels[whichLabels].heading), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Header), null, "The Header"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _divider.Divider), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Content), null, singleParagraph()), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Footer), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _checkbox.Checkbox), null, labels[whichLabels].checkboxLabel)), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _buttongroup.ButtonGroup), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.Button), {
            variant: "secondary",
            onPress: close
        }, labels[whichLabels].secondaryButtonLabel), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.Button), {
            variant: "primary",
            onPress: close
        }, labels[whichLabels].primaryButtonLabel), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.Button), {
            variant: "cta",
            onPress: close,
            autoFocus: true
        }, "CTA")))));
}
function renderWithDividerInContent({ width = "auto", ...props }) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        style: {
            display: "flex",
            width,
            margin: "100px 0"
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.DialogTrigger), {
        defaultOpen: true
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), null, "Trigger"), (close)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Dialog), props, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Heading), null, "The Heading"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Header), null, "The Header"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _divider.Divider), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Content), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
            UNSAFE_style: {
                padding: "10px"
            }
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), {
            flexGrow: 1,
            flexBasis: 0
        }, "Column number one. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _divider.Divider), {
            flexShrink: 0,
            marginStart: 10,
            marginEnd: 10,
            orientation: "vertical",
            size: "S"
        }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), {
            flexGrow: 1,
            flexBasis: 0
        }, "Column number two. Eleifend quam adipiscing vitae proin sagittis nisl. Diam donec adipiscing tristique risus."))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _buttongroup.ButtonGroup), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.Button), {
            variant: "primary",
            onPress: close
        }, "Primary"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.Button), {
            variant: "cta",
            onPress: close,
            autoFocus: true
        }, "CTA")))));
}
function renderHorizontalScrolling({ width = "auto", ...props }) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        style: {
            display: "flex",
            flexDirection: "column",
            alignItems: "start",
            width
        }
    }, fiveParagraphs(), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.DialogTrigger), {
        defaultOpen: true
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), null, "Trigger"), (close)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Dialog), props, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Heading), null, "The Heading"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Header), null, "The Header"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _divider.Divider), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Content), {
            UNSAFE_style: {
                overflow: "auto",
                touchAction: "pan-x"
            }
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textfield.TextField), {
            label: "Top textfield",
            minWidth: "100vw"
        }), /*#__PURE__*/ (0, _reactDefault.default).createElement("p", null, "scroll this content horizontally")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _buttongroup.ButtonGroup), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.Button), {
            variant: "secondary",
            onPress: close
        }, "Cancel"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.Button), {
            variant: "cta",
            onPress: close,
            autoFocus: true
        }, "Confirm")))), fiveParagraphs());
}

},{"@react-spectrum/button":"jZWyP","@react-spectrum/buttongroup":"anP11","@react-spectrum/checkbox":"1r19j","@react-spectrum/view":"dnRjt","../":"5Zpr7","@react-spectrum/divider":"dxmqN","@react-spectrum/layout":"hzaUY","@react-spectrum/form":"bGDqA","@react-spectrum/text":"etCGI","@react-spectrum/image":"2GFZF","@react-spectrum/picker":"kL1Uy","@react-spectrum/radio":"gbtGh","react":"9yzVZ","@react-spectrum/textfield":"hOmtq","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"iEdyP":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Default", ()=>Default);
parcelHelpers.export(exports, "InAMenu", ()=>InAMenu);
parcelHelpers.export(exports, "TypeFullscreen", ()=>TypeFullscreen);
parcelHelpers.export(exports, "TypeFullscreenTakeover", ()=>TypeFullscreenTakeover);
parcelHelpers.export(exports, "IsDismissable", ()=>IsDismissable);
parcelHelpers.export(exports, "IsKeyboardDismissDisabled", ()=>IsKeyboardDismissDisabled);
parcelHelpers.export(exports, "NestedDialogContainers", ()=>NestedDialogContainers);
var _dialogContainerExamples = require("./DialogContainerExamples");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
exports.default = {
    title: "DialogContainer",
    providerSwitcher: {
        status: "notice"
    }
};
const Default = ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _dialogContainerExamples.DialogContainerExample), null);
Default.story = {
    name: "default"
};
const InAMenu = ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _dialogContainerExamples.MenuExample), null);
InAMenu.story = {
    name: "in a menu"
};
const TypeFullscreen = ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _dialogContainerExamples.MenuExample), {
        type: "fullscreen"
    });
TypeFullscreen.story = {
    name: "type: fullscreen"
};
const TypeFullscreenTakeover = ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _dialogContainerExamples.MenuExample), {
        type: "fullscreenTakeover"
    });
TypeFullscreenTakeover.story = {
    name: "type: fullscreenTakeover"
};
const IsDismissable = ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _dialogContainerExamples.MenuExample), {
        isDismissable: true
    });
IsDismissable.story = {
    name: "isDismissable"
};
const IsKeyboardDismissDisabled = ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _dialogContainerExamples.MenuExample), {
        isKeyboardDismissDisabled: true
    });
IsKeyboardDismissDisabled.story = {
    name: "isKeyboardDismissDisabled"
};
const NestedDialogContainers = ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _dialogContainerExamples.NestedDialogContainerExample), null);

},{"./DialogContainerExamples":"j9VMX","react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"j9VMX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DialogContainerExample", ()=>DialogContainerExample);
parcelHelpers.export(exports, "MenuExample", ()=>MenuExample);
parcelHelpers.export(exports, "NestedDialogContainerExample", ()=>NestedDialogContainerExample);
var _button = require("@react-spectrum/button");
var _buttongroup = require("@react-spectrum/buttongroup");
var _view = require("@react-spectrum/view");
var _ = require("../");
var _divider = require("@react-spectrum/divider");
var _text = require("@react-spectrum/text");
var _menu = require("@react-spectrum/menu");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
function DialogContainerExample(props) {
    let [isOpen, setOpen] = (0, _reactDefault.default).useState(false);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), {
        onPress: ()=>setOpen(true)
    }, "Open dialog"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.DialogContainer), {
        onDismiss: ()=>setOpen(false),
        ...props
    }, isOpen && /*#__PURE__*/ (0, _reactDefault.default).createElement(ExampleDialog, props)));
}
function MenuExample(props) {
    let [isOpen, setOpen] = (0, _reactDefault.default).useState(false);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _menu.MenuTrigger), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), null, "Open menu"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _menu.Menu), {
        onAction: ()=>setOpen(true)
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _menu.Item), null, "Open dialog..."))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.DialogContainer), {
        ...props,
        onDismiss: ()=>setOpen(false)
    }, isOpen && /*#__PURE__*/ (0, _reactDefault.default).createElement(ExampleDialog, props)));
}
function ExampleDialog(props) {
    let container = (0, _.useDialogContainer)();
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Dialog), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Heading), null, "The Heading"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Header), null, "The Header"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _divider.Divider), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Content), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin sit amet tristique risus. In sit amet suscipit lorem. Orci varius natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. In condimentum imperdiet metus non condimentum. Duis eu velit et quam accumsan tempus at id velit. Duis elementum elementum purus, id tempus mauris posuere a. Nunc vestibulum sapien pellentesque lectus commodo ornare.")), !props.isDismissable && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _buttongroup.ButtonGroup), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.Button), {
        variant: "secondary",
        onPress: container.dismiss
    }, "Cancel"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.Button), {
        variant: "cta",
        onPress: container.dismiss
    }, "Confirm")));
}
function NestedDialogContainerExample() {
    let [dialog, setDialog] = (0, _reactDefault.default).useState(null);
    let dismiss = ()=>setDialog(null);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _menu.MenuTrigger), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), {
        "aria-label": "Actions"
    }, "Open menu"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _menu.Menu), {
        onAction: setDialog
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _menu.Item), {
        key: "doThis"
    }, "Do this\u2026"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _menu.Item), {
        key: "doThat"
    }, "Do that\u2026"))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.DialogContainer), {
        onDismiss: dismiss
    }, dialog !== null && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Dialog), {
        onDismiss: dismiss,
        isDismissable: true
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Heading), null, dialog === "doThis" ? "This" : "That"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _divider.Divider), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Content), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), {
        onPress: ()=>setDialog(dialog === "doThis" ? "doThat" : "doThis"),
        autoFocus: true
    }, dialog === "doThis" ? "Do that" : "Do this")))));
}

},{"@react-spectrum/button":"jZWyP","@react-spectrum/buttongroup":"anP11","@react-spectrum/view":"dnRjt","../":"5Zpr7","@react-spectrum/divider":"dxmqN","@react-spectrum/text":"etCGI","@react-spectrum/menu":"asqy4","react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"ljImx":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Default", ()=>Default);
parcelHelpers.export(exports, "TypePopover", ()=>TypePopover);
parcelHelpers.export(exports, "TypeModal", ()=>TypeModal);
parcelHelpers.export(exports, "TypeModalIsDismissable", ()=>TypeModalIsDismissable);
parcelHelpers.export(exports, "TypeFullscreen", ()=>TypeFullscreen);
parcelHelpers.export(exports, "TypeFullscreenTakeover", ()=>TypeFullscreenTakeover);
parcelHelpers.export(exports, "TypeTray", ()=>TypeTray);
parcelHelpers.export(exports, "MobileTypeFullscreen", ()=>MobileTypeFullscreen);
parcelHelpers.export(exports, "MobileTypeFullscreenTakeover", ()=>MobileTypeFullscreenTakeover);
parcelHelpers.export(exports, "PopoverWithMobileTypeModal", ()=>PopoverWithMobileTypeModal);
parcelHelpers.export(exports, "PopoverWithMobileTypeTray", ()=>PopoverWithMobileTypeTray);
parcelHelpers.export(exports, "NestedModals", ()=>NestedModals);
parcelHelpers.export(exports, "NestedModalsFullscreentakeover", ()=>NestedModalsFullscreentakeover);
parcelHelpers.export(exports, "WithMenuTrigger", ()=>WithMenuTrigger);
parcelHelpers.export(exports, "NestedPopovers", ()=>NestedPopovers);
parcelHelpers.export(exports, "PopoverInsideScrollView", ()=>PopoverInsideScrollView);
parcelHelpers.export(exports, "ShouldFlipWithWidth", ()=>ShouldFlipWithWidth);
parcelHelpers.export(exports, "CloseFunctionWithButtonPopover", ()=>CloseFunctionWithButtonPopover);
parcelHelpers.export(exports, "TargetRef", ()=>TargetRef);
parcelHelpers.export(exports, "_AlertDialog", ()=>_AlertDialog);
parcelHelpers.export(exports, "CrossoffsetExamples", ()=>CrossoffsetExamples);
parcelHelpers.export(exports, "TriggerVisibleThroughUnderlay", ()=>TriggerVisibleThroughUnderlay);
parcelHelpers.export(exports, "_2Popovers", ()=>_2Popovers);
parcelHelpers.export(exports, "_AdjustableDialog", ()=>_AdjustableDialog);
parcelHelpers.export(exports, "WithTooltip", ()=>WithTooltip);
parcelHelpers.export(exports, "WithTooltipTrigger", ()=>WithTooltipTrigger);
parcelHelpers.export(exports, "WithTranslations", ()=>WithTranslations);
parcelHelpers.export(exports, "TriggersOnEdges", ()=>TriggersOnEdges);
var _addonActions = require("@storybook/addon-actions");
var _button = require("@react-spectrum/button");
var _ = require("../");
var _alertMedium = require("@spectrum-icons/ui/AlertMedium");
var _alertMediumDefault = parcelHelpers.interopDefault(_alertMedium);
var _buttongroup = require("@react-spectrum/buttongroup");
var _utils = require("@react-aria/utils");
var _checkbox = require("@react-spectrum/checkbox");
var _view = require("@react-spectrum/view");
var _divider = require("@react-spectrum/divider");
var _layout = require("@react-spectrum/layout");
var _text = require("@react-spectrum/text");
var _image = require("@react-spectrum/image");
var _menu = require("@react-spectrum/menu");
var _provider = require("@react-spectrum/provider");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _tooltip = require("@react-spectrum/tooltip");
var _dialogLanguagesChromatic = require("./../chromatic/DialogLanguages.chromatic");
exports.default = {
    title: "DialogTrigger",
    providerSwitcher: {
        status: "notice"
    },
    argTypes: {
        crossOffset: {
            control: {
                type: "number"
            }
        },
        offset: {
            control: {
                type: "number"
            }
        },
        placement: {
            type: "select",
            defaultValue: "top",
            options: [
                "bottom",
                "bottom left",
                "bottom right",
                "bottom start",
                "bottom end",
                "top",
                "top left",
                "top right",
                "top start",
                "top end",
                "left",
                "left top",
                "left bottom",
                "start",
                "start top",
                "start bottom",
                "right",
                "right top",
                "right bottom",
                "end",
                "end top",
                "end bottom"
            ]
        },
        buttonHeight: {
            control: {
                type: "number"
            }
        },
        buttonWidth: {
            control: {
                type: "number"
            }
        },
        shouldFlip: {
            control: {
                type: "boolean"
            }
        },
        isKeyboardDismissDisabled: {
            control: {
                type: "boolean"
            }
        },
        containerPadding: {
            control: {
                type: "number"
            }
        }
    }
};
const Default = (args)=>render(args);
Default.story = {
    name: "default"
};
const TypePopover = (args)=>renderPopover({
        type: "popover",
        ...args
    });
TypePopover.story = {
    name: "type: popover"
};
const TypeModal = (args)=>render({
        type: "modal",
        ...args
    });
TypeModal.story = {
    name: "type: modal"
};
const TypeModalIsDismissable = (args)=>render({
        type: "modal",
        isDismissable: true,
        ...args
    });
TypeModalIsDismissable.story = {
    name: "type: modal isDismissable"
};
const TypeFullscreen = (args)=>render({
        type: "fullscreen",
        ...args
    });
TypeFullscreen.story = {
    name: "type: fullscreen"
};
const TypeFullscreenTakeover = (args)=>render({
        type: "fullscreenTakeover",
        ...args
    });
TypeFullscreenTakeover.story = {
    name: "type: fullscreenTakeover"
};
const TypeTray = (args)=>renderPopover({
        type: "tray",
        ...args
    });
TypeTray.story = {
    name: "type: tray"
};
const MobileTypeFullscreen = (args)=>render({
        type: "modal",
        mobileType: "fullscreen",
        ...args
    });
MobileTypeFullscreen.story = {
    name: "mobileType: fullscreen"
};
const MobileTypeFullscreenTakeover = (args)=>render({
        type: "modal",
        mobileType: "fullscreenTakeover",
        ...args
    });
MobileTypeFullscreenTakeover.story = {
    name: "mobileType: fullscreenTakeover"
};
const PopoverWithMobileTypeModal = (args)=>renderPopover({
        type: "popover",
        mobileType: "modal",
        ...args
    });
PopoverWithMobileTypeModal.story = {
    name: "popover with mobileType: modal"
};
const PopoverWithMobileTypeTray = (args)=>renderPopover({
        type: "popover",
        mobileType: "tray",
        ...args
    });
PopoverWithMobileTypeTray.story = {
    name: "popover with mobileType: tray"
};
const NestedModals = ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        style: {
            paddingTop: 100
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("input", {
        "aria-label": "test input"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _provider.Provider), {
        colorScheme: "dark",
        UNSAFE_style: {
            padding: 40,
            marginTop: 10
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.DialogTrigger), {
        isDismissable: true
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), null, "Trigger"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Dialog), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Content), null, /*#__PURE__*/ (0, _reactDefault.default).createElement("input", null), /*#__PURE__*/ (0, _reactDefault.default).createElement("input", null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.DialogTrigger), {
        isDismissable: true
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), null, "Trigger"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Dialog), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Content), null, /*#__PURE__*/ (0, _reactDefault.default).createElement("input", null), /*#__PURE__*/ (0, _reactDefault.default).createElement("input", null)))))))));
NestedModals.story = {
    name: "nested modals"
};
const NestedModalsFullscreentakeover = ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.DialogTrigger), {
        type: "fullscreenTakeover"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), null, "Trigger"), (close)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Dialog), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Heading), null, "The Heading"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Header), null, "The Header"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _divider.Divider), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Content), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.DialogTrigger), {
            isDismissable: true
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), null, "Trigger"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Dialog), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Content), null, /*#__PURE__*/ (0, _reactDefault.default).createElement("input", null), /*#__PURE__*/ (0, _reactDefault.default).createElement("input", null))))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _buttongroup.ButtonGroup), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.Button), {
            variant: "secondary",
            onPress: (0, _utils.chain)(close, (0, _addonActions.action)("cancel"))
        }, "Cancel"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.Button), {
            variant: "cta",
            onPress: (0, _utils.chain)(close, (0, _addonActions.action)("confirm"))
        }, "Confirm"))));
NestedModalsFullscreentakeover.story = {
    name: "nested modals, fullscreentakeover"
};
const WithMenuTrigger = ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.DialogTrigger), {
        type: "popover"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), null, "Trigger"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Dialog), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Heading), null, "The Heading"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Content), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _menu.MenuTrigger), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), null, "Test"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _menu.Menu), {
        autoFocus: "first"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _menu.Item), null, "Item 1"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _menu.Item), null, "Item 2"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _menu.Item), null, "Item 3"))))));
WithMenuTrigger.story = {
    name: "with menu trigger"
};
const NestedPopovers = ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        style: {
            paddingTop: 100
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.DialogTrigger), {
        type: "popover"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), null, "Trigger"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Dialog), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Content), null, /*#__PURE__*/ (0, _reactDefault.default).createElement("input", null), /*#__PURE__*/ (0, _reactDefault.default).createElement("input", null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.DialogTrigger), {
        type: "popover"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), null, "Trigger"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Dialog), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Content), null, "Hi!")))))));
NestedPopovers.story = {
    name: "nested popovers"
};
const PopoverInsideScrollView = ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        style: {
            height: 100,
            display: "flex"
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        style: {
            paddingTop: 100,
            height: 100,
            overflow: "auto"
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        style: {
            height: 200
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.DialogTrigger), {
        type: "popover"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), null, "Trigger"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Dialog), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Content), null, /*#__PURE__*/ (0, _reactDefault.default).createElement("input", null), /*#__PURE__*/ (0, _reactDefault.default).createElement("input", null)))))), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        style: {
            paddingTop: 100,
            height: 100,
            overflow: "auto",
            flex: 1
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        style: {
            height: 200
        }
    }, "other")));
PopoverInsideScrollView.story = {
    name: "popover inside scroll view",
    parameters: {
        a11y: {
            config: {
                rules: [
                    {
                        id: "scrollable-region-focusable",
                        enabled: false
                    }
                ]
            }
        }
    }
};
const ShouldFlipWithWidth = (args)=>renderPopover({
        type: "popover",
        width: "calc(100vh - 100px)",
        ...args
    });
ShouldFlipWithWidth.story = {
    name: "shouldFlip with width"
};
const CloseFunctionWithButtonPopover = ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        style: {
            display: "flex",
            margin: "100px 0"
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.DialogTrigger), {
        type: "popover",
        onOpenChange: (0, _addonActions.action)("open change")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), null, "Trigger"), (close)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Dialog), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Heading), null, "The Heading"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Header), null, "The Header"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _divider.Divider), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Content), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin sit amet tristique risus. In sit amet suscipit lorem. Orci varius natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. In condimentum imperdiet metus non condimentum. Duis eu velit et quam accumsan tempus at id velit. Duis elementum elementum purus, id tempus mauris posuere a. Nunc vestibulum sapien pellentesque lectus commodo ornare.")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _buttongroup.ButtonGroup), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.Button), {
            variant: "secondary",
            onPress: (0, _utils.chain)(close, (0, _addonActions.action)("cancel"))
        }, "Cancel")))));
CloseFunctionWithButtonPopover.story = {
    name: "Close function with button: popover"
};
const TargetRef = (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(TriggerWithRef, {
        type: "popover",
        ...args
    });
TargetRef.story = {
    name: "targetRef"
};
const _AlertDialog = (args)=>renderAlert(args);
_AlertDialog.story = {
    name: "alert dialog"
};
const CrossoffsetExamples = ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
        gap: "size-200",
        alignSelf: "center"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
        gap: "size-200",
        direction: "column",
        alignItems: "start"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("span", null, "Left Top"), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("span", null, "-50"), renderPopover({
        type: "popover",
        placement: "left top",
        crossOffset: -50
    }, false)), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("span", null, "0"), renderPopover({
        type: "popover",
        placement: "left top"
    }, false)), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("span", null, "50"), renderPopover({
        type: "popover",
        placement: "left top",
        crossOffset: 50
    }, false))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
        gap: "size-200",
        direction: "column",
        alignItems: "start"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("span", null, "Left"), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("span", null, "-50"), renderPopover({
        type: "popover",
        placement: "left",
        crossOffset: -50
    }, false)), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("span", null, "0"), renderPopover({
        type: "popover",
        placement: "left"
    }, false)), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("span", null, "50"), renderPopover({
        type: "popover",
        placement: "left",
        crossOffset: 50
    }, false))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
        gap: "size-200",
        direction: "column",
        alignItems: "start"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("span", null, "Left Bottom"), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("span", null, "-50"), renderPopover({
        type: "popover",
        placement: "left bottom",
        crossOffset: -50
    }, false)), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("span", null, "0"), renderPopover({
        type: "popover",
        placement: "left bottom"
    }, false)), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("span", null, "50"), renderPopover({
        type: "popover",
        placement: "left bottom",
        crossOffset: 50
    }, false))));
CrossoffsetExamples.story = {
    name: "crossoffset examples"
};
const TriggerVisibleThroughUnderlay = (args)=>renderTriggerNotCentered(args);
TriggerVisibleThroughUnderlay.story = {
    name: "trigger visible through underlay"
};
const _2Popovers = ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
        gap: "size-200"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.DialogTrigger), {
        type: "popover"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), null, "Trigger"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Dialog), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Content), null, /*#__PURE__*/ (0, _reactDefault.default).createElement("input", null), /*#__PURE__*/ (0, _reactDefault.default).createElement("input", null)))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.DialogTrigger), {
        type: "popover"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), null, "Trigger"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Dialog), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Content), null, "Hi!"))));
_2Popovers.story = {
    name: "2 popovers"
};
const _AdjustableDialog = ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement(AdjustableDialog, null);
_AdjustableDialog.story = {
    name: "adjustable dialog"
};
const WithTooltip = ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        style: {
            display: "flex",
            width: "auto",
            margin: "100px 0"
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.DialogTrigger), {
        isDismissable: true
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), null, "Trigger"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Dialog), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Heading), null, "Has tooltip"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _divider.Divider), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Content), null, /*#__PURE__*/ (0, _reactDefault.default).createElement("p", null, "Pressing escape when Tooltip is open closes Tooltip and not Dialog too."), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _tooltip.TooltipTrigger), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.Button), {
        variant: "cta"
    }, "Has tooltip"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _tooltip.Tooltip), null, "Press escape"))))));
WithTooltip.story = {
    name: "with tooltip inside"
};
const WithTooltipTrigger = ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
        direction: "row",
        gap: 10
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.DialogTrigger), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), null, "DialogTrigger only"), (close)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(CustomDialog, {
            close: close
        })), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _tooltip.TooltipTrigger), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), null, "TooltipTrigger only"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _tooltip.Tooltip), null, "This is a tooltip")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _tooltip.TooltipTrigger), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), {
        isDisabled: true
    }, "TooltipTrigger only"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _tooltip.Tooltip), null, "This is a tooltip")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.DialogTrigger), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _tooltip.TooltipTrigger), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), null, "DialogTrigger + TooltipTrigger"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _tooltip.Tooltip), null, "This is a tooltip")), (close)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(CustomDialog, {
            close: close
        })), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.DialogTrigger), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _tooltip.TooltipTrigger), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), {
        isDisabled: true
    }, "DialogTrigger + TooltipTrigger"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _tooltip.Tooltip), null, "This is a tooltip")), (close)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(CustomDialog, {
            close: close
        })));
WithTooltipTrigger.story = {
    name: "with tooltip wrapper"
};
function CustomDialog({ close }) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Dialog), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Content), null, "Dialog content"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _buttongroup.ButtonGroup), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.Button), {
        variant: "cta",
        onPress: close
    }, "Close")));
}
const WithTranslations = ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _dialogLanguagesChromatic.TranslateDialog), null);
WithTranslations.story = {
    name: "with translations",
    parameters: {
        description: {
            data: "Translations included for: Arabic, English, Hebrew, Japanese, Korean, Simplified Chinese, and Traditional Chinese."
        }
    }
};
const TriggersOnEdges = ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.View), {
        width: "100%",
        overflow: "auto"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Grid), {
        areas: [
            "top    top",
            "start  end",
            "bottom bottom"
        ],
        columns: [
            "auto",
            "auto"
        ],
        rows: [
            "size-450",
            "auto",
            "size-450"
        ],
        height: "1600px",
        width: "calc(100vw + 100px)",
        marginTop: "20px",
        marginBottom: "20px",
        gap: "size-100"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.View), {
        gridArea: "top",
        justifySelf: "center"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.DialogTrigger), {
        type: "popover",
        placement: "end",
        shouldFlip: false
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), null, "Trigger"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Dialog), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Content), null, "Placement Start"))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.DialogTrigger), {
        type: "popover",
        placement: "end top",
        shouldFlip: false
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), null, "Trigger"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Dialog), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Content), null, "Placement End Top"))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.DialogTrigger), {
        type: "popover",
        placement: "end bottom",
        shouldFlip: false
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), null, "Trigger"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Dialog), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Content), null, "Placement End Bottom"))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.DialogTrigger), {
        type: "popover",
        placement: "start",
        shouldFlip: false
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), null, "Trigger"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Dialog), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Content), null, "Placement End"))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.DialogTrigger), {
        type: "popover",
        placement: "start top",
        shouldFlip: false
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), null, "Trigger"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Dialog), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Content), null, "Placement Start Top"))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.DialogTrigger), {
        type: "popover",
        placement: "start bottom",
        shouldFlip: false
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), null, "Trigger"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Dialog), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Content), null, "Placement Start Bottom"))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.DialogTrigger), {
        type: "popover",
        placement: "bottom",
        shouldFlip: false
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), null, "Trigger"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Dialog), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Content), null, "Placement Bottom"))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.DialogTrigger), {
        type: "popover",
        shouldFlip: false
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), null, "Trigger"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Dialog), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Content), null, "No Placement (default is bottom)")))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.View), {
        gridArea: "start",
        justifySelf: "start",
        alignSelf: "center",
        paddingStart: "20px"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.DialogTrigger), {
        type: "popover",
        placement: "top",
        shouldFlip: false
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), null, "T"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Dialog), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Content), null, "Placement Top"))), /*#__PURE__*/ (0, _reactDefault.default).createElement("br", null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.DialogTrigger), {
        type: "popover",
        placement: "top start",
        shouldFlip: false
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), null, "T"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Dialog), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Content), null, "Placement Top Start"))), /*#__PURE__*/ (0, _reactDefault.default).createElement("br", null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.DialogTrigger), {
        type: "popover",
        placement: "top end",
        shouldFlip: false
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), null, "T"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Dialog), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Content), null, "Placement Top End"))), /*#__PURE__*/ (0, _reactDefault.default).createElement("br", null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.DialogTrigger), {
        type: "popover",
        placement: "bottom",
        shouldFlip: false
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), null, "T"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Dialog), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Content), null, "Placement Bottom"))), /*#__PURE__*/ (0, _reactDefault.default).createElement("br", null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.DialogTrigger), {
        type: "popover",
        placement: "bottom start",
        shouldFlip: false
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), null, "T"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Dialog), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Content), null, "Placement Bottom Start"))), /*#__PURE__*/ (0, _reactDefault.default).createElement("br", null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.DialogTrigger), {
        type: "popover",
        placement: "bottom end",
        shouldFlip: false
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), null, "T"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Dialog), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Content), null, "Placement Bottom End"))), /*#__PURE__*/ (0, _reactDefault.default).createElement("br", null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.DialogTrigger), {
        type: "popover",
        placement: "end",
        shouldFlip: false
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), null, "T"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Dialog), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Content), null, "Placement End"))), /*#__PURE__*/ (0, _reactDefault.default).createElement("br", null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.DialogTrigger), {
        type: "popover",
        shouldFlip: false
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), null, "Trigger"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Dialog), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Content), null, "No Placement (default is bottom)")))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.View), {
        gridArea: "end",
        justifySelf: "end",
        alignSelf: "center",
        paddingEnd: "20px"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.DialogTrigger), {
        type: "popover",
        placement: "top",
        shouldFlip: false
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), null, "T"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Dialog), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Content), null, "Placement Top"))), /*#__PURE__*/ (0, _reactDefault.default).createElement("br", null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.DialogTrigger), {
        type: "popover",
        placement: "top end",
        shouldFlip: false
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), null, "T"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Dialog), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Content), null, "Placement Top End"))), /*#__PURE__*/ (0, _reactDefault.default).createElement("br", null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.DialogTrigger), {
        type: "popover",
        placement: "top start",
        shouldFlip: false
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), null, "T"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Dialog), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Content), null, "Placement Top Start"))), /*#__PURE__*/ (0, _reactDefault.default).createElement("br", null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.DialogTrigger), {
        type: "popover",
        placement: "bottom",
        shouldFlip: false
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), null, "T"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Dialog), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Content), null, "Placement Bottom"))), /*#__PURE__*/ (0, _reactDefault.default).createElement("br", null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.DialogTrigger), {
        type: "popover",
        placement: "bottom end",
        shouldFlip: false
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), null, "T"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Dialog), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Content), null, "Placement Bottom End"))), /*#__PURE__*/ (0, _reactDefault.default).createElement("br", null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.DialogTrigger), {
        type: "popover",
        placement: "bottom start",
        shouldFlip: false
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), null, "T"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Dialog), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Content), null, "Placement Bottom Start"))), /*#__PURE__*/ (0, _reactDefault.default).createElement("br", null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.DialogTrigger), {
        type: "popover",
        placement: "start",
        shouldFlip: false
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), null, "T"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Dialog), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Content), null, "Placement Start"))), /*#__PURE__*/ (0, _reactDefault.default).createElement("br", null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.DialogTrigger), {
        type: "popover",
        shouldFlip: false
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), null, "Trigger"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Dialog), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Content), null, "No Placement (default is bottom)")))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.View), {
        gridArea: "bottom",
        justifySelf: "center"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.DialogTrigger), {
        type: "popover",
        placement: "end",
        shouldFlip: false
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), null, "Trigger"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Dialog), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Content), null, "Placement End"))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.DialogTrigger), {
        type: "popover",
        placement: "end bottom",
        shouldFlip: false
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), null, "Trigger"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Dialog), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Content), null, "Placement End Bottom"))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.DialogTrigger), {
        type: "popover",
        placement: "end top",
        shouldFlip: false
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), null, "Trigger"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Dialog), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Content), null, "Placement End Top"))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.DialogTrigger), {
        type: "popover",
        placement: "start",
        shouldFlip: false
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), null, "Trigger"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Dialog), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Content), null, "Placement Start"))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.DialogTrigger), {
        type: "popover",
        placement: "start bottom",
        shouldFlip: false
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), null, "Trigger"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Dialog), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Content), null, "Placement Start Bottom"))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.DialogTrigger), {
        type: "popover",
        placement: "start top",
        shouldFlip: false
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), null, "Trigger"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Dialog), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Content), null, "Placement Start top"))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.DialogTrigger), {
        type: "popover",
        placement: "top",
        shouldFlip: false
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), null, "Trigger"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Dialog), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Content), null, "Placement top"))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.DialogTrigger), {
        type: "popover",
        shouldFlip: false
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), null, "Trigger"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Dialog), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Content), null, "No Placement (default is bottom)"))))));
TriggersOnEdges.story = {
    name: "popover triggers on edges"
};
function render(props) {
    let { width = "auto", ...otherProps } = props;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        style: {
            display: "flex",
            width,
            margin: "100px 0"
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.DialogTrigger), {
        ...otherProps,
        onOpenChange: (0, _addonActions.action)("open change")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), null, "Trigger"), (close)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Dialog), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Heading), {
            id: "foo"
        }, "The Heading"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Header), null, "The Header"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _divider.Divider), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Content), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin sit amet tristique risus. In sit amet suscipit lorem. Orci varius natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. In condimentum imperdiet metus non condimentum. Duis eu velit et quam accumsan tempus at id velit. Duis elementum elementum purus, id tempus mauris posuere a. Nunc vestibulum sapien pellentesque lectus commodo ornare.")), !props.isDismissable && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _buttongroup.ButtonGroup), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.Button), {
            variant: "secondary",
            onPress: (0, _utils.chain)(close, (0, _addonActions.action)("cancel"))
        }, "Cancel"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.Button), {
            variant: "cta",
            onPress: (0, _utils.chain)(close, (0, _addonActions.action)("confirm"))
        }, "Confirm")))));
}
function renderTriggerNotCentered(props) {
    let { buttonHeight, buttonWidth, ...otherProps } = props;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        style: {
            position: "absolute",
            top: "100px",
            left: "100px"
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", null, "action button shouldn't get any events if the underlay is up and you try to click it through the underlay"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.DialogTrigger), {
        ...otherProps,
        isDismissable: true,
        onOpenChange: (0, _addonActions.action)("open change")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), {
        height: buttonHeight,
        width: buttonWidth,
        onPressStart: (0, _addonActions.action)("onPressStart"),
        onPress: (0, _addonActions.action)("onPress"),
        onPressEnd: (0, _addonActions.action)("onPressEnd")
    }, "Trigger"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Dialog), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Heading), null, "The Heading"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Header), null, "The Header"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _divider.Divider), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Content), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin sit amet tristique risus. In sit amet suscipit lorem. Orci varius natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. In condimentum imperdiet metus non condimentum. Duis eu velit et quam accumsan tempus at id velit. Duis elementum elementum purus, id tempus mauris posuere a. Nunc vestibulum sapien pellentesque lectus commodo ornare.")))));
}
function renderPopover(props, withMargin = true) {
    let { width = "auto", buttonHeight, buttonWidth, ...otherProps } = props;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        style: {
            display: "flex",
            width,
            margin: withMargin ? "100px 0" : undefined
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.DialogTrigger), {
        ...otherProps,
        onOpenChange: (0, _addonActions.action)("open change")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), {
        height: buttonHeight,
        width: buttonWidth
    }, "Trigger"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Dialog), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Heading), null, "The Heading"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Header), null, "The Header"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _divider.Divider), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Content), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin sit amet tristique risus. In sit amet suscipit lorem. Orci varius natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. In condimentum imperdiet metus non condimentum. Duis eu velit et quam accumsan tempus at id velit. Duis elementum elementum purus, id tempus mauris posuere a. Nunc vestibulum sapien pellentesque lectus commodo ornare.")))));
}
let TriggerWithRef = (props)=>{
    let { buttonHeight, buttonWidth, ...otherProps } = props;
    let ref = (0, _reactDefault.default).useRef(null);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        style: {
            display: "flex"
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.DialogTrigger), {
        ...otherProps,
        targetRef: ref,
        onOpenChange: (0, _addonActions.action)("open change")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), {
        height: buttonHeight,
        width: buttonWidth
    }, "Trigger"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Dialog), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Heading), null, "The Heading"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Header), null, "The Header"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _divider.Divider), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Content), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin sit amet tristique risus. In sit amet suscipit lorem. Orci varius natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. In condimentum imperdiet metus non condimentum. Duis eu velit et quam accumsan tempus at id velit. Duis elementum elementum purus, id tempus mauris posuere a. Nunc vestibulum sapien pellentesque lectus commodo ornare.")))), /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        ref: ref,
        style: {
            marginInlineStart: "200px"
        }
    }, "Popover appears over here"));
};
function renderAlert(props) {
    let { buttonHeight, buttonWidth, width = "auto", ...otherProps } = props;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        style: {
            display: "flex",
            width,
            margin: "100px 0"
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.DialogTrigger), {
        ...otherProps,
        onOpenChange: (0, _addonActions.action)("open change")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), {
        height: buttonHeight,
        width: buttonWidth
    }, "Trigger"), (close)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.AlertDialog), {
            title: "Alert! Danger!",
            variant: "error",
            primaryActionLabel: "Accept",
            secondaryActionLabel: "Whoa",
            cancelLabel: "Cancel",
            onCancel: (0, _utils.chain)(close, (0, _addonActions.action)("cancel")),
            onPrimaryAction: (0, _utils.chain)(close, (0, _addonActions.action)("primary")),
            onSecondaryAction: (0, _utils.chain)(close, (0, _addonActions.action)("secondary"))
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, "Fine! No, absolutely fine. It's not like I don't have, you know, ten thousand other test subjects begging me to help them escape. You know, it's not like this place is about to EXPLODE."))));
}
function AdjustableDialog() {
    let headingStrings = [
        "The Heading",
        "The Heading of Maximum Truth That is Really Long to Go On and On a a a a a Again and Wraps"
    ];
    let [showHero, setShowHero] = (0, _react.useState)(false);
    let [heading, setHeading] = (0, _react.useState)(headingStrings[0]);
    let [showHeader, setShowHeader] = (0, _react.useState)(false);
    let [showTypeIcon, setShowTypeIcon] = (0, _react.useState)(false);
    let [isDismissable, setIsDismissable] = (0, _react.useState)(false);
    let [showFooter, setShowFooter] = (0, _react.useState)(false);
    let [longButtonLabels, setLongButtonLabels] = (0, _react.useState)(false);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
        gap: "size-200"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
        direction: "column",
        width: "size-2000",
        gap: "size-100"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _checkbox.Checkbox), {
        onChange: setShowHero
    }, "Show Hero"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _checkbox.Checkbox), {
        onChange: (isChecked)=>{
            isChecked ? setHeading(headingStrings[1]) : setHeading(headingStrings[0]);
        }
    }, "Toggle Heading Values"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _checkbox.Checkbox), {
        onChange: setShowHeader
    }, "Show Header"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _checkbox.Checkbox), {
        onChange: setShowTypeIcon
    }, "Show TypeIcon"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _checkbox.Checkbox), {
        onChange: setIsDismissable
    }, "Show Dismissable"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _checkbox.Checkbox), {
        onChange: setShowFooter
    }, "Show Footer"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _checkbox.Checkbox), {
        onChange: setLongButtonLabels
    }, "Show Long Button Labels")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.DialogTrigger), {
        isDismissable: isDismissable
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), null, "Trigger"), (close)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Dialog), null, showHero && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _image.Image), {
            slot: "hero",
            alt: "",
            src: "https://i.imgur.com/Z7AzH2c.png",
            objectFit: "cover"
        }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Heading), null, heading), showHeader && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Header), null, "This is a long header"), showTypeIcon && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _alertMediumDefault.default), {
            slot: "typeIcon",
            "aria-label": "Alert"
        }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _divider.Divider), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Content), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin sit amet tristique risus. In sit amet suscipit lorem. Orci varius natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. In condimentum imperdiet metus non condimentum. Duis eu velit et quam accumsan tempus at id velit. Duis elementum elementum purus, id tempus mauris posuere a. Nunc vestibulum sapien pellentesque lectus commodo ornare.")), showFooter && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Footer), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _checkbox.Checkbox), null, "I have read and accept the terms of use and privacy policy")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _buttongroup.ButtonGroup), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.Button), {
            variant: "secondary",
            onPress: (0, _utils.chain)(close, (0, _addonActions.action)("cancel"))
        }, "Cancel ", longButtonLabels && "and close this dialog"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.Button), {
            variant: "cta",
            onPress: (0, _utils.chain)(close, (0, _addonActions.action)("confirm"))
        }, "Confirm ", longButtonLabels && "and close this dialog")))));
}

},{"@storybook/addon-actions":"coXbW","@react-spectrum/button":"jZWyP","../":"5Zpr7","@spectrum-icons/ui/AlertMedium":"2v5QX","@react-spectrum/buttongroup":"anP11","@react-aria/utils":"9cLk5","@react-spectrum/checkbox":"1r19j","@react-spectrum/view":"dnRjt","@react-spectrum/divider":"dxmqN","@react-spectrum/layout":"hzaUY","@react-spectrum/text":"etCGI","@react-spectrum/image":"2GFZF","@react-spectrum/menu":"asqy4","@react-spectrum/provider":"5bCdp","react":"9yzVZ","@react-spectrum/tooltip":"f9wa6","./../chromatic/DialogLanguages.chromatic":"dxgSP","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"dxgSP":[function(require,module,exports) {
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TranslateDialog", ()=>TranslateDialog);
parcelHelpers.export(exports, "ArabicComplex", ()=>ArabicComplex);
parcelHelpers.export(exports, "HebrewComplex", ()=>HebrewComplex);
parcelHelpers.export(exports, "JapaneseComplex", ()=>JapaneseComplex);
parcelHelpers.export(exports, "KoreanComplex", ()=>KoreanComplex);
parcelHelpers.export(exports, "ChineseSimplfiedComplex", ()=>ChineseSimplfiedComplex);
parcelHelpers.export(exports, "ChineseTraditionalComplex", ()=>ChineseTraditionalComplex);
var _button = require("@react-spectrum/button");
var _buttongroup = require("@react-spectrum/buttongroup");
var _table = require("@react-spectrum/table");
var _view = require("@react-spectrum/view");
var _ = require("../");
var _divider = require("@react-spectrum/divider");
var _text = require("@react-spectrum/text");
// @ts-ignore
var _intlMessagesJson = require("./intlMessages.json");
var _intlMessagesJsonDefault = parcelHelpers.interopDefault(_intlMessagesJson);
var _tag = require("@react-spectrum/tag");
var _provider = require("@react-spectrum/provider");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _i18N = require("@react-aria/i18n");
exports.default = {
    title: "Languages/Dialog",
    parameters: {
        chromaticProvider: {
            colorSchemes: [
                "darkest"
            ],
            express: false,
            locales: [
                "en-US"
            ],
            scales: [
                "medium"
            ]
        }
    },
    excludeStories: [
        "TranslateDialog"
    ]
};
let TranslateDialog = (dialogProps)=>{
    let strings = (0, _i18N.useLocalizedStringFormatter)((0, _intlMessagesJsonDefault.default));
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.DialogTrigger), dialogProps, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), null, strings.format("koji")), (close)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Dialog), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Heading), null, strings.format("kojiFoods")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Header), null, strings.format("foodsMakeWithKoji")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _divider.Divider), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Content), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _tag.TagGroup), {
            "aria-label": strings.format("kojiColors")
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _tag.Item), null, strings.format("white")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _tag.Item), null, strings.format("yellow")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _tag.Item), null, strings.format("black"))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _table.TableView), {
            "aria-label": strings.format("foodsMakeWithKoji"),
            selectionMode: "multiple"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _table.TableHeader), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _table.Column), null, strings.format("name")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _table.Column), null, strings.format("description"))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _table.TableBody), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _table.Row), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _table.Cell), null, strings.format("soySauce")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _table.Cell), null, strings.format("soySauceDescription"))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _table.Row), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _table.Cell), null, strings.format("miso")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _table.Cell), null, strings.format("misoDescription"))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _table.Row), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _table.Cell), null, strings.format("amazake")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _table.Cell), null, strings.format("amazakeDescription"))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _table.Row), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _table.Cell), null, strings.format("sake")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _table.Cell), null, strings.format("sakeDescription"))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _table.Row), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _table.Cell), null, strings.format("mirin")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _table.Cell), null, strings.format("mirinDescription"))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _table.Row), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _table.Cell), null, strings.format("riceWineVinegar")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _table.Cell), null, strings.format("riceWineVinegarDescription")))))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _buttongroup.ButtonGroup), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.Button), {
            variant: "secondary",
            onPress: close
        }, strings.format("cancel")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.Button), {
            variant: "cta",
            onPress: close
        }, strings.format("confirm")))));
};
const ArabicComplex = ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _provider.Provider), {
        locale: "ar-AE"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(TranslateDialog, {
        defaultOpen: true
    }));
const HebrewComplex = ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _provider.Provider), {
        locale: "he-IL"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(TranslateDialog, {
        defaultOpen: true
    }));
const JapaneseComplex = ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _provider.Provider), {
        locale: "ja-JP"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(TranslateDialog, {
        defaultOpen: true
    }));
const KoreanComplex = ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _provider.Provider), {
        locale: "ko-KR"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(TranslateDialog, {
        defaultOpen: true
    }));
const ChineseSimplfiedComplex = ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _provider.Provider), {
        locale: "zh-CN"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(TranslateDialog, {
        defaultOpen: true
    }));
const ChineseTraditionalComplex = ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _provider.Provider), {
        locale: "zh-TW"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(TranslateDialog, {
        defaultOpen: true
    }));

},{"@react-spectrum/button":"jZWyP","@react-spectrum/buttongroup":"anP11","@react-spectrum/table":"gptJH","@react-spectrum/view":"dnRjt","../":"5Zpr7","@react-spectrum/divider":"dxmqN","@react-spectrum/text":"etCGI","./intlMessages.json":"3jhXu","@react-spectrum/tag":"dM36P","@react-spectrum/provider":"5bCdp","react":"9yzVZ","@react-aria/i18n":"411rg","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"3jhXu":[function(require,module,exports) {
module.exports = JSON.parse('{"ar-AR":{"koji":"\u0643\u0648\u062C\u064A","kojiFoods":"\u0627\u0644\u0623\u0637\u0639\u0645\u0629 \u0643\u0648\u062C\u064A","foodsMakeWithKoji":"\u0627\u0644\u0623\u0637\u0639\u0645\u0629 \u0627\u0644\u064A\u0627\u0628\u0627\u0646\u064A\u0629 \u0648\u0627\u0644\u062A\u0648\u0627\u0628\u0644 \u0648\u0627\u0644\u0645\u0634\u0631\u0648\u0628\u0627\u062A \u0627\u0644\u0645\u0635\u0646\u0648\u0639\u0629 \u0645\u0646 \u0627\u0644\u0643\u0648\u062C\u064A","kojiColors":"\u0623\u0644\u0648\u0627\u0646 \u0643\u0648\u062C\u064A","white":"\u0623\u0628\u064A\u0636 (\u0623\u062E\u0636\u0631)","yellow":"\u0623\u0635\u0641\u0631","black":"\u0623\u0633\u0648\u062F","name":"\u0627\u0633\u0645","description":"\u0648\u0635\u0641","soySauce":"\u0634\u0648\u064A\u0648","soySauceDescription":"\u0628\u0647\u0627\u0631 \u0633\u0627\u0626\u0644 \u0645\u0635\u0646\u0648\u0639 \u0645\u0646 \u0641\u0648\u0644 \u0627\u0644\u0635\u0648\u064A\u0627 \u0648\u0643\u0648\u062C\u064A \u0648\u0627\u0644\u0642\u0645\u062D.","miso":"\u0645\u064A\u0633\u0648","misoDescription":"\u062A\u0648\u0627\u0628\u0644 \u064A\u0627\u0628\u0627\u0646\u064A\u0629 \u062A\u0642\u0644\u064A\u062F\u064A\u0629.","amazake":"\u0623\u0645\u0627\u0632\u0627\u0643\u064A","amazakeDescription":"\u0645\u0634\u0631\u0648\u0628 \u0623\u0631\u0632 \u062D\u0644\u0648.","sake":"\u0645\u0646 \u0623\u062C\u0644","sakeDescription":"\u0646\u0628\u064A\u0630 \u0627\u0644\u0623\u0631\u0632.","mirin":"\u0645\u064A\u0631\u064A\u0646","mirinDescription":"\u0646\u0628\u064A\u0630 \u0623\u0631\u0632 \u062D\u0644\u0648.","riceWineVinegar":"\u062E\u0644 \u0646\u0628\u064A\u0630 \u0627\u0644\u0623\u0631\u0632","riceWineVinegarDescription":"\u062E\u0644 \u0645\u0635\u0646\u0648\u0639 \u0645\u0646 \u0646\u0628\u064A\u0630 \u0627\u0644\u0623\u0631\u0632.","cancel":"\u064A\u0644\u063A\u064A","confirm":"\u064A\u062A\u0623\u0643\u062F"},"en-US":{"koji":"Koji","kojiFoods":"Koji foods","foodsMakeWithKoji":"Japanese foods, condiments, and beverages made with koji","kojiColors":"Colors of koji","white":"white (green)","yellow":"yellow","black":"black","name":"Name","description":"Description","soySauce":"Shoyu","soySauceDescription":"A liquid condiment made from soybeans, koji, and wheat.","miso":"Miso","misoDescription":"A traditional Japanese seasoning.","amazake":"Amazake","amazakeDescription":"A sweet rice drink.","sake":"Sake","sakeDescription":"Rice wine.","mirin":"Mirin","mirinDescription":"Sweet rice wine.","riceWineVinegar":"Rice wine vinegar","riceWineVinegarDescription":"Vinegar made from rice wine.","cancel":"Cancel","confirm":"Confirm"},"he-IL":{"koji":"\u05E7\u05D5\u05D2\'\u05D9","kojiFoods":"\u05DE\u05D6\u05D5\u05E0\u05D5\u05EA \u05E7\u05D5\u05D2\'\u05D9","foodsMakeWithKoji":"\u05D0\u05D5\u05DB\u05DC \u05D9\u05E4\u05E0\u05D9, \u05EA\u05D1\u05DC\u05D9\u05E0\u05D9\u05DD \u05D5\u05DE\u05E9\u05E7\u05D0\u05D5\u05EA \u05E2\u05E9\u05D5\u05D9\u05D9\u05DD \u05E2\u05DD \u05E7\u05D5\u05D2\'\u05D9","kojiColors":"\u05E6\u05D1\u05E2\u05D9\u05DD \u05E9\u05DC \u05E7\u05D5\u05D2\'\u05D9","white":"\u05DC\u05D1\u05DF (\u05D9\u05E8\u05D5\u05E7)","yellow":"\u05E6\u05D4\u05D5\u05D1","black":"\u05E9\u05C1\u05B8\u05D7\u05D5\u05B9\u05E8","name":"\u05E9\u05C1\u05B5\u05DD","description":"\u05EA\u05D9\u05D0\u05D5\u05E8","soySauce":"\u05E9\u05D5\u05D9\u05D5","soySauceDescription":"\u05EA\u05D1\u05DC\u05D9\u05DF \u05E0\u05D5\u05D6\u05DC\u05D9 \u05D4\u05E2\u05E9\u05D5\u05D9 \u05DE\u05E4\u05D5\u05DC\u05D9 \u05E1\u05D5\u05D9\u05D4, \u05E7\u05D5\u05D2\'\u05D9 \u05D5\u05D7\u05D9\u05D8\u05D4.","miso":"\u05DE\u05D9\u05E1\u05D5","misoDescription":"\u05EA\u05D9\u05D1\u05D5\u05DC \u05D9\u05E4\u05E0\u05D9 \u05DE\u05E1\u05D5\u05E8\u05EA\u05D9.","amazake":"\u05D0\u05DE\u05D6\u05D0\u05E7\u05D4","amazakeDescription":"\u05DE\u05E9\u05E7\u05D4 \u05D0\u05D5\u05E8\u05D6 \u05DE\u05EA\u05D5\u05E7.","sake":"\u05E1\u05D0\u05E7\u05D4","sakeDescription":"\u05D9\u05D9\u05DF \u05D0\u05D5\u05E8\u05D6.","mirin":"\u05DE\u05D9\u05E8\u05D9\u05DF","mirinDescription":"\u05D9\u05D9\u05DF \u05D0\u05D5\u05E8\u05D6 \u05DE\u05EA\u05D5\u05E7.","riceWineVinegar":"\u05D7\u05D5\u05DE\u05E5 \u05D9\u05D9\u05DF \u05D0\u05D5\u05E8\u05D6","riceWineVinegarDescription":"\u05D7\u05D5\u05DE\u05E5 \u05E2\u05E9\u05D5\u05D9 \u05DE\u05D9\u05D9\u05DF \u05D0\u05D5\u05E8\u05D6.","cancel":"\u05DC\u05B0\u05D1\u05B7\u05D8\u05B5\u05DC","confirm":"\u05DC\u05B0\u05D0\u05B7\u05E9\u05C1\u05B5\u05E8"},"ja-JP":{"koji":"\u9EB9","kojiFoods":"\u9EB9\u98DF\u54C1","foodsMakeWithKoji":"\u9EB9\u3092\u4F7F\u3063\u305F\u548C\u98DF\u30FB\u8ABF\u5473\u6599\u30FB\u98F2\u6599","kojiColors":"\u9EB9\u306E\u8272","white":"\u767D\uFF08\u7DD1","yellow":"\u9EC4\u8272","black":"\u9ED2","name":"\u540D\u524D","description":"\u8AAC\u660E","soySauce":"\u91A4\u6CB9","soySauceDescription":"\u5927\u8C46\u3001\u9EB9\u3001\u5C0F\u9EA6\u304B\u3089\u4F5C\u3089\u308C\u305F\u6DB2\u4F53\u8ABF\u5473\u6599\u3067\u3059\u3002","miso":"\u5473\u564C","misoDescription":"\u65E5\u672C\u306E\u4F1D\u7D71\u7684\u306A\u8ABF\u5473\u6599\u3002","amazake":"\u7518\u9152","amazakeDescription":"\u7518\u3044\u304A\u7C73\u306E\u30C9\u30EA\u30F3\u30AF\u3002","sake":"\u9152","sakeDescription":"\u304A\u9152\u3002","mirin":"\u307F\u308A\u3093","mirinDescription":"\u5473\u9182\u3002","riceWineVinegar":"\u7C73\u9162","riceWineVinegarDescription":"\u7C73\u9152\u304B\u3089\u4F5C\u3089\u308C\u305F\u304A\u9162\u3002","cancel":"\u30AD\u30E3\u30F3\u30BB\u30EB","confirm":"\u78BA\u8A8D"},"ko-KR":{"koji":"\uCF54\uC9C0","kojiFoods":"\uB204\uB8E9 \uC2DD\uD488","foodsMakeWithKoji":"\uB204\uB8E9\uC73C\uB85C \uB9CC\uB4E0 \uC77C\uBCF8 \uC74C\uC2DD, \uC870\uBBF8\uB8CC \uBC0F \uC74C\uB8CC","kojiColors":"\uB204\uB8E9\uC758 \uC0C9","white":"\uD770\uC0C9(\uB179\uC0C9)","yellow":"\uB178\uB780\uC0C9","black":"\uAC80\uC740\uC0C9","name":"\uC774\uB984","description":"\uC124\uBA85","soySauce":"\uC1FC\uC720","soySauceDescription":"\uCF69, \uB204\uB8E9, \uBC00\uB85C \uB9CC\uB4E0 \uC561\uCCB4 \uC870\uBBF8\uB8CC.","miso":"\uB41C\uC7A5","misoDescription":"\uC77C\uBCF8\uC758 \uC804\uD1B5 \uC870\uBBF8\uB8CC.","amazake":"\uAC10\uC8FC","amazakeDescription":"\uB2EC\uCF64\uD55C \uC300 \uC74C\uB8CC.","sake":"\uB3D9\uAE30","sakeDescription":"\uB9C9\uAC78\uB9AC.","mirin":"\uBBF8\uB9B0","mirinDescription":"\uB2EC\uCF64\uD55C \uB9C9\uAC78\uB9AC.","riceWineVinegar":"\uB9C9\uAC78\uB9AC\uC2DD\uCD08","riceWineVinegarDescription":"\uB9C9\uAC78\uB9AC\uB85C \uB9CC\uB4E0 \uC2DD\uCD08.","cancel":"\uCDE8\uC18C","confirm":"\uD655\uC778\uD558\uB2E4"},"zh-CN":{"koji":"\u5C0F\u53F8","kojiFoods":"\u9152\u66F2\u98DF\u54C1","foodsMakeWithKoji":"\u7528\u66F2\u5236\u6210\u7684\u65E5\u672C\u98DF\u54C1\u3001\u8C03\u5473\u54C1\u548C\u996E\u6599","kojiColors":"\u9152\u66F2\u7684\u989C\u8272","white":"\u767D\uFF08\u7EFF\uFF09","yellow":"\u9EC4\u8272\u7684","black":"\u9ED1\u8272\u7684","name":"\u59D3\u540D","description":"\u63CF\u8FF0","soySauce":"\u9171\u6CB9","soySauceDescription":"\u4E00\u79CD\u7531\u5927\u8C46\u3001\u66F2\u548C\u5C0F\u9EA6\u5236\u6210\u7684\u6DB2\u4F53\u8C03\u5473\u54C1\u3002","miso":"\u5473\u564C","misoDescription":"\u65E5\u672C\u4F20\u7EDF\u8C03\u5473\u6599","amazake":"\u7518\u9152","amazakeDescription":"\u4E00\u79CD\u751C\u7C73\u996E\u6599\u3002","sake":"\u6E05\u9152","sakeDescription":"\u7C73\u9152\u3002","mirin":"\u6599\u9152","mirinDescription":"\u751C\u7C73\u9152\u3002","riceWineVinegar":"\u7C73\u9152\u918B","riceWineVinegarDescription":"\u7528\u7C73\u9152\u5236\u6210\u7684\u918B\u3002","cancel":"\u53D6\u6D88","confirm":"\u786E\u8BA4"},"zh-TW":{"koji":"\u5C0F\u53F8","kojiFoods":"\u9152\u9EAF\u98DF\u54C1","foodsMakeWithKoji":"\u7528\u66F2\u88FD\u6210\u7684\u65E5\u672C\u98DF\u54C1\u3001\u8ABF\u5473\u54C1\u548C\u98F2\u6599","kojiColors":"\u9152\u9EAF\u7684\u984F\u8272","white":"\u767D\uFF08\u7DA0\uFF09","yellow":"\u9EC3\u8272\u7684","black":"\u9ED1\u8272\u7684","name":"\u59D3\u540D","description":"\u63CF\u8FF0","soySauce":"\u91AC\u6CB9","soySauceDescription":"\u4E00\u7A2E\u7531\u5927\u8C46\u3001\u66F2\u548C\u5C0F\u9EA5\u88FD\u6210\u7684\u6DB2\u9AD4\u8ABF\u5473\u54C1\u3002","miso":"\u5473\u564C","misoDescription":"\u65E5\u672C\u50B3\u7D71\u8ABF\u5473\u6599\u3002","amazake":"\u7518\u9152","amazakeDescription":"\u4E00\u7A2E\u751C\u7C73\u98F2\u6599\u3002","sake":"\u6E05\u9152","sakeDescription":"\u7C73\u9152\u3002","mirin":"\u6599\u9152","mirinDescription":"\u751C\u7C73\u9152\u3002","riceWineVinegar":"\u7C73\u9152\u918B","riceWineVinegarDescription":"\u7528\u7C73\u9152\u88FD\u6210\u7684\u918B\u3002","cancel":"\u53D6\u6D88","confirm":"\u78BA\u8A8D"}}');

},{}],"en2uX":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LargeDefault", ()=>LargeDefault);
parcelHelpers.export(exports, "Medium", ()=>Medium);
parcelHelpers.export(exports, "Small", ()=>Small);
parcelHelpers.export(exports, "VerticalLargeDefault", ()=>VerticalLargeDefault);
parcelHelpers.export(exports, "VerticalMedium", ()=>VerticalMedium);
parcelHelpers.export(exports, "VerticalSmall", ()=>VerticalSmall);
var _button = require("@react-spectrum/button");
var _ = require("../");
var _properties = require("@spectrum-icons/workflow/Properties");
var _propertiesDefault = parcelHelpers.interopDefault(_properties);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _select = require("@spectrum-icons/workflow/Select");
var _selectDefault = parcelHelpers.interopDefault(_select);
exports.default = {
    title: "Divider",
    providerSwitcher: {
        status: "positive"
    }
};
const LargeDefault = ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement("section", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("h1", null, "Large"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Divider), null), /*#__PURE__*/ (0, _reactDefault.default).createElement("p", null, "Page or Section Titles."));
LargeDefault.story = {
    name: "Large (Default)"
};
const Medium = ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement("section", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("h1", null, "Medium"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Divider), {
        size: "M"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("p", null, "Divide subsections, or divide different groups of elements (between panels, rails, etc.)"));
const Small = ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement("section", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("h1", null, "Small"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Divider), {
        size: "S"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("p", null, "Divide like-elements (tables, tool groups, elements within a panel, etc.)"));
const VerticalLargeDefault = ()=>renderVertical();
VerticalLargeDefault.story = {
    name: "Vertical, Large (Default)"
};
const VerticalMedium = ()=>renderVertical({
        size: "M"
    });
VerticalMedium.story = {
    name: "Vertical, Medium"
};
const VerticalSmall = ()=>renderVertical({
        size: "S"
    });
VerticalSmall.story = {
    name: "Vertical, Small"
};
function renderVertical(props = {}) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("section", {
        style: {
            display: "flex"
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), {
        "aria-label": "Properties",
        isQuiet: true
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _propertiesDefault.default), null)), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Divider), {
        orientation: "vertical",
        ...props
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), {
        "aria-label": "Select",
        isQuiet: true
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _selectDefault.default), null)));
}

},{"@react-spectrum/button":"jZWyP","../":"dLuYl","@spectrum-icons/workflow/Properties":"9QEfS","react":"9yzVZ","@spectrum-icons/workflow/Select":"cF4is","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"dLuYl":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _src = require("./src");
parcelHelpers.exportAll(_src, exports);

},{"./src":"dxmqN","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"aR8GX":[function(require,module,exports) {
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "withDraggable", ()=>withDraggable);
parcelHelpers.export(exports, "customAriaLabel", ()=>customAriaLabel);
parcelHelpers.export(exports, "withButton", ()=>withButton);
parcelHelpers.export(exports, "customBannerMessage", ()=>customBannerMessage);
parcelHelpers.export(exports, "acceptsMultiple", ()=>acceptsMultiple);
parcelHelpers.export(exports, "filledDropzone", ()=>filledDropzone);
var _addonActions = require("@storybook/addon-actions");
var _button = require("@react-spectrum/button");
var _table = require("@react-spectrum/table");
var _utils = require("@react-spectrum/utils");
var _view = require("@react-spectrum/view");
var _dndStories = require("@react-aria/dnd/stories/dnd.stories");
var _reactAria = require("react-aria");
var _ = require("../");
var _file = require("@spectrum-icons/illustrations/File");
var _fileDefault = parcelHelpers.interopDefault(_file);
var _reactAriaComponents = require("react-aria-components");
var _text = require("@react-spectrum/text");
var _illustratedmessage = require("@react-spectrum/illustratedmessage");
var _notFound = require("@spectrum-icons/illustrations/NotFound");
var _notFoundDefault = parcelHelpers.interopDefault(_notFound);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _stylesCss = require("./styles.css");
var _stylesCssDefault = parcelHelpers.interopDefault(_stylesCss);
var _upload = require("@spectrum-icons/illustrations/Upload");
var _uploadDefault = parcelHelpers.interopDefault(_upload);
const meta = {
    title: "DropZone",
    component: (0, _.DropZone)
};
exports.default = meta;
const withDraggable = {
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(DropZoneWithDraggable, args)
};
const customAriaLabel = {
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(DropZoneWithDraggable, {
            ...args,
            "aria-label": "custom label"
        })
};
const withButton = {
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(DropZoneWithButton, args)
};
const customBannerMessage = {
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(Example, {
            ...args,
            replaceMessage: "This is a custom message"
        })
};
const acceptsMultiple = {
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(Example, args)
};
const filledDropzone = {
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(DropZoneFilled, args)
};
function renderEmptyState() {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _illustratedmessage.IllustratedMessage), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _notFoundDefault.default), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Heading), null, "No files"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Content), null, "No files selected"));
}
function Example(props) {
    let columns = [
        {
            name: "Name",
            uid: "name"
        },
        {
            name: "Type",
            uid: "type"
        }
    ];
    let [isFilled, setIsFilled] = (0, _react.useState)(false);
    let [filledSrc, setFilledSrc] = (0, _react.useState)(undefined);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.DropZone), {
        ...props,
        width: "size-3000",
        height: "size-3000",
        isFilled: isFilled,
        onDrop: async (e)=>{
            let items = e.items.filter((item)=>item.kind === "file");
            if (items.length > 0) {
                const rows = items.map((item, index)=>({
                        name: item.name,
                        type: item.type,
                        id: index
                    }));
                setFilledSrc(rows);
                setIsFilled(true);
            }
        },
        onDropEnter: (0, _addonActions.action)("onDropEnter"),
        onDropExit: (0, _addonActions.action)("onDropExit"),
        onPaste: (0, _addonActions.action)("onPaste")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _illustratedmessage.IllustratedMessage), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _uploadDefault.default), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Heading), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Text), {
        slot: "label"
    }, "Drag a file here")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Content), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.FileTrigger), {
        allowsMultiple: true,
        onSelect: (e)=>{
            let files = Array.from(e || []);
            let rows = files.map((file, index)=>({
                    name: file.name,
                    type: file.type,
                    id: index
                }));
            setFilledSrc(rows);
            setIsFilled(true);
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.Button), {
        variant: "primary"
    }, "Select a file"))))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _table.TableView), {
        renderEmptyState: renderEmptyState,
        height: "size-3000",
        minWidth: "size-3000"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _table.TableHeader), {
        columns: columns
    }, (column)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _table.Column), {
            key: column.uid
        }, column.name)), isFilled ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _table.TableBody), {
        items: filledSrc
    }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _table.Row), null, (columnKey)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _table.Cell), null, item[columnKey]))) : /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _table.TableBody), null, [])));
}
function DropZoneWithDraggable(props) {
    let [isFilled, setIsFilled] = (0, _react.useState)(false);
    let [filledSrc, setFilledSrc] = (0, _react.useState)(null);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _dndStories.Draggable), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.DropZone), {
        ...props,
        isFilled: isFilled,
        onDrop: async (e)=>{
            let items = await Promise.all(e.items.filter((item)=>item.kind === "text" && item.types.has("text/plain")).map((item)=>item.getText("text/plain")));
            if (items.length > 0) {
                setIsFilled(true);
                setFilledSrc(items.join("\n"));
            }
        },
        onDropEnter: (0, _addonActions.action)("onDropEnter"),
        onDropExit: (0, _addonActions.action)("onDropExit"),
        onPaste: (0, _addonActions.action)("onPaste")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _illustratedmessage.IllustratedMessage), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _uploadDefault.default), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Heading), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Text), {
        slot: "label"
    }, "Drag and Drop here"))), filledSrc));
}
function DropZoneWithButton(props) {
    let [isFilled, setIsFilled] = (0, _react.useState)(false);
    let [filledSrc, setFilledSrc] = (0, _react.useState)(null);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.DropZone), {
        ...props,
        width: "size-3000",
        height: "size-3000",
        isFilled: isFilled,
        UNSAFE_className: (0, _utils.classNames)((0, _stylesCssDefault.default), isFilled && "is-filled"),
        onDrop: async (e)=>{
            let item = e.items.find((item)=>item.kind === "file");
            if (item) {
                setFilledSrc({
                    src: URL.createObjectURL(await item.getFile()),
                    type: item.type,
                    name: item.name
                });
                setIsFilled(true);
            }
        },
        onDropEnter: (0, _addonActions.action)("onDropEnter"),
        onDropExit: (0, _addonActions.action)("onDropExit"),
        onPaste: (0, _addonActions.action)("onPaste")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _illustratedmessage.IllustratedMessage), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _uploadDefault.default), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Heading), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.Text), {
        slot: "label"
    }, "Drag and Drop here")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Content), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.FileTrigger), {
        onSelect: (e)=>{
            let files = Array.from(e || []);
            let src = files.map((file)=>URL.createObjectURL(file));
            let type = files.map((file)=>file.type);
            let name = files.map((file)=>file.name);
            setFilledSrc({
                src: src[0],
                type: type[0],
                name: name[0]
            });
            setIsFilled(true);
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.Button), {
        variant: "primary"
    }, "Select a file"))))), isFilled && /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _stylesCssDefault.default).files
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _fileDefault.default), null), filledSrc === null || filledSrc === void 0 ? void 0 : filledSrc.name));
}
function DropZoneFilled(props) {
    let [isFilled, setIsFilled] = (0, _react.useState)(true);
    let [filledSrc, setFilledSrc] = (0, _react.useState)("https://i.imgur.com/DhygPot.jpg");
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement(DraggableImage, null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.DropZone), {
        ...props,
        isFilled: isFilled,
        UNSAFE_className: (0, _utils.classNames)((0, _stylesCssDefault.default), "is-filled"),
        width: "size-3000",
        height: "size-2400",
        getDropOperation: (types)=>types.has("image/png") || types.has("image/jpeg") ? "copy" : "cancel",
        onDrop: async (e)=>{
            e.items.find(async (item)=>{
                if (item.kind === "file") {
                    if (item.type === "image/jpeg" || item.type === "image/png") {
                        setFilledSrc(URL.createObjectURL(await item.getFile()));
                        setIsFilled(true);
                    }
                } else if (item.kind === "text") {
                    setFilledSrc(await item.getText("image/jpeg"));
                    setIsFilled(true);
                }
            });
        },
        onDropEnter: (0, _addonActions.action)("onDropEnter"),
        onDropExit: (0, _addonActions.action)("onDropExit"),
        onPaste: (0, _addonActions.action)("onPaste")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("img", {
        className: (0, _stylesCssDefault.default).images,
        alt: "a starry sky",
        src: filledSrc
    })));
}
function DraggableImage() {
    let { dragProps, isDragging } = (0, _reactAria.useDrag)({
        getItems () {
            return [
                {
                    "image/jpeg": "https://i.imgur.com/Z7AzH2c.jpg"
                }
            ];
        }
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...dragProps,
        role: "button",
        tabIndex: 0,
        style: {
            margin: "20px"
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("img", {
        width: "150px",
        height: "100px",
        alt: "traditional roof",
        src: "https://i.imgur.com/Z7AzH2c.jpg",
        className: `draggable ${isDragging ? "dragging" : ""}`
    }));
}

},{"@storybook/addon-actions":"coXbW","@react-spectrum/button":"jZWyP","@react-spectrum/table":"gptJH","@react-spectrum/utils":"cMIJ6","@react-spectrum/view":"dnRjt","@react-aria/dnd/stories/dnd.stories":"6aNDQ","react-aria":"e7jhe","../":"31tMK","@spectrum-icons/illustrations/File":"fy2lO","react-aria-components":"lFSUH","@react-spectrum/text":"etCGI","@react-spectrum/illustratedmessage":"cV05z","@spectrum-icons/illustrations/NotFound":"ev5ep","react":"9yzVZ","./styles.css":"23Uc5","@spectrum-icons/illustrations/Upload":"543AJ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"31tMK":[function(require,module,exports) {
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _src = require("./src");
parcelHelpers.exportAll(_src, exports);

},{"./src":"NhhCG","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"NhhCG":[function(require,module,exports) {
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /// <reference types="css-module-types" />
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DropZone", ()=>(0, _dropZone.DropZone));
var _dropZone = require("./DropZone");

},{"./DropZone":"dUQfp","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"dUQfp":[function(require,module,exports) {
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DropZone", ()=>_DropZone);
var _utils = require("@react-spectrum/utils");
var _reactAriaComponents = require("react-aria-components");
// @ts-ignore
var _json = require("../intl/*.json");
var _jsonDefault = parcelHelpers.interopDefault(_json);
var _utils1 = require("@react-aria/utils");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _varsCss = require("@adobe/spectrum-css-temp/components/dropzone/vars.css");
var _varsCssDefault = parcelHelpers.interopDefault(_varsCss);
var _i18N = require("@react-aria/i18n");
// Filter out props used by RAC DropZone that we don't want in RSP DropZone for now.
let filterProps = (props)=>{
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    let { onHoverStart, onHoverChange, onHoverEnd, ...otherProps } = props;
    return otherProps;
};
function DropZone(props, ref) {
    let { children, isFilled, replaceMessage, ...otherProps } = props;
    let { styleProps } = (0, _utils.useStyleProps)(props);
    let domRef = (0, _utils.useDOMRef)(ref);
    let messageId = (0, _utils1.useId)();
    let stringFormatter = (0, _i18N.useLocalizedStringFormatter)((0, _jsonDefault.default), "@react-spectrum/dropzone");
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.DropZone), {
        ...(0, _utils1.mergeProps)(filterProps(otherProps)),
        ...styleProps,
        "aria-labelledby": isFilled && messageId,
        className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Dropzone", styleProps.className, {
            "spectrum-Dropzone--filled": isFilled
        }),
        ref: domRef
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.SlotProvider), {
        slots: {
            illustration: {
                UNSAFE_className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Dropzone-illustratedMessage")
            }
        }
    }, children), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Dropzone-backdrop")
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        id: messageId,
        className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Dropzone-banner", styleProps.className)
    }, replaceMessage ? replaceMessage : stringFormatter.format("replaceMessage")));
}
/**
 * A drop zone is an area into which one or multiple objects can be dragged and dropped.
 */ let _DropZone = /*#__PURE__*/ (0, _reactDefault.default).forwardRef(DropZone);

},{"@react-spectrum/utils":"cMIJ6","react-aria-components":"lFSUH","../intl/*.json":"4WVxX","@react-aria/utils":"9cLk5","react":"9yzVZ","@adobe/spectrum-css-temp/components/dropzone/vars.css":"lnziS","@react-aria/i18n":"411rg","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"4WVxX":[function(require,module,exports) {
const _temp0 = require("b737f99ed11e28e1");
const _temp1 = require("85f419dea6455770");
const _temp2 = require("6442656f95d81c3c");
const _temp3 = require("75b555260672b8d5");
const _temp4 = require("3e71e70b6eeb7b15");
const _temp5 = require("4c83b503f61d574");
const _temp6 = require("a282f2332797e1d1");
const _temp7 = require("bada4b154f1f1db1");
const _temp8 = require("ee8d71aa1ea53df");
const _temp9 = require("fa415fa05eb7587f");
const _temp10 = require("293b3cb68ec22d81");
const _temp11 = require("68d8f1d7708feda5");
const _temp12 = require("c741d53b1202a22f");
const _temp13 = require("5b32412ea7ab1b86");
const _temp14 = require("74707b76fb5b0751");
const _temp15 = require("e013b88a9132c47");
const _temp16 = require("9e33e3106ac81103");
const _temp17 = require("386a85d5d76ce388");
const _temp18 = require("b7c65361f3189318");
const _temp19 = require("9af4845f9b1cdf32");
const _temp20 = require("459f4c3d0e95e6e7");
const _temp21 = require("5e43dffd19a1c2db");
const _temp22 = require("a0cb242410428b35");
const _temp23 = require("8e420d66cf232813");
const _temp24 = require("cc1b8c826765bd2a");
const _temp25 = require("5b515faa14750f06");
const _temp26 = require("c77694c0328a991a");
const _temp27 = require("667d46aef255fac8");
const _temp28 = require("1f2a9c13511c493d");
const _temp29 = require("3ff78a56f7070a5f");
const _temp30 = require("9318ef1ab8703ba0");
const _temp31 = require("d29e4c3cf85db4c2");
const _temp32 = require("34e5a2e114ab567b");
const _temp33 = require("40ddea017da2049f");
module.exports = {
    "ar-AE": _temp0,
    "bg-BG": _temp1,
    "cs-CZ": _temp2,
    "da-DK": _temp3,
    "de-DE": _temp4,
    "el-GR": _temp5,
    "en-US": _temp6,
    "es-ES": _temp7,
    "et-EE": _temp8,
    "fi-FI": _temp9,
    "fr-FR": _temp10,
    "he-IL": _temp11,
    "hr-HR": _temp12,
    "hu-HU": _temp13,
    "it-IT": _temp14,
    "ja-JP": _temp15,
    "ko-KR": _temp16,
    "lt-LT": _temp17,
    "lv-LV": _temp18,
    "nb-NO": _temp19,
    "nl-NL": _temp20,
    "pl-PL": _temp21,
    "pt-BR": _temp22,
    "pt-PT": _temp23,
    "ro-RO": _temp24,
    "ru-RU": _temp25,
    "sk-SK": _temp26,
    "sl-SI": _temp27,
    "sr-SP": _temp28,
    "sv-SE": _temp29,
    "tr-TR": _temp30,
    "uk-UA": _temp31,
    "zh-CN": _temp32,
    "zh-TW": _temp33
};

},{"b737f99ed11e28e1":"fgLOh","85f419dea6455770":"dSBTF","6442656f95d81c3c":"izRjA","75b555260672b8d5":"1d9mh","3e71e70b6eeb7b15":"lpEIh","4c83b503f61d574":"1GsGF","a282f2332797e1d1":"76eqb","bada4b154f1f1db1":"8AE3B","ee8d71aa1ea53df":"ceg5R","fa415fa05eb7587f":"dEMfd","293b3cb68ec22d81":"3UZDc","68d8f1d7708feda5":"9emwy","c741d53b1202a22f":"6DRi9","5b32412ea7ab1b86":"fYgpL","74707b76fb5b0751":"g3vDX","e013b88a9132c47":"gBagx","9e33e3106ac81103":"6Chel","386a85d5d76ce388":"7j0fE","b7c65361f3189318":"9L9bT","9af4845f9b1cdf32":"gUlK6","459f4c3d0e95e6e7":"2x0jV","5e43dffd19a1c2db":"51r9B","a0cb242410428b35":"41361","8e420d66cf232813":"caEZH","cc1b8c826765bd2a":"03UTe","5b515faa14750f06":"cCyo5","c77694c0328a991a":"dCK7P","667d46aef255fac8":"04c5P","1f2a9c13511c493d":"isTFh","3ff78a56f7070a5f":"7TePR","9318ef1ab8703ba0":"e2HRc","d29e4c3cf85db4c2":"8LGSh","34e5a2e114ab567b":"1LWey","40ddea017da2049f":"jqbDI"}],"fgLOh":[function(require,module,exports) {
module.exports = {
    "replaceMessage": `\u{644}\u{644}\u{627}\u{633}\u{62A}\u{628}\u{62F}\u{627}\u{644}\u{60C} \u{642}\u{645} \u{628}\u{625}\u{641}\u{644}\u{627}\u{62A} \u{627}\u{644}\u{645}\u{644}\u{641}`
};

},{}],"dSBTF":[function(require,module,exports) {
module.exports = {
    "replaceMessage": `\u{41F}\u{443}\u{441}\u{43D}\u{435}\u{442}\u{435} \u{444}\u{430}\u{439}\u{43B} \u{437}\u{430} \u{437}\u{430}\u{43C}\u{44F}\u{43D}\u{430}`
};

},{}],"izRjA":[function(require,module,exports) {
module.exports = {
    "replaceMessage": `P\u{159}et\xe1hn\u{11B}te soubor k nahrazen\xed`
};

},{}],"1d9mh":[function(require,module,exports) {
module.exports = {
    "replaceMessage": `Drop fil for at erstatte`
};

},{}],"lpEIh":[function(require,module,exports) {
module.exports = {
    "replaceMessage": `Datei zum Ersetzen ablegen`
};

},{}],"1GsGF":[function(require,module,exports) {
module.exports = {
    "replaceMessage": `\u{391}\u{3C0}\u{3CC}\u{3B8}\u{3B5}\u{3C3}\u{3B7} \u{3B1}\u{3C1}\u{3C7}\u{3B5}\u{3AF}\u{3BF}\u{3C5} \u{3B3}\u{3B9}\u{3B1} \u{3B1}\u{3BD}\u{3C4}\u{3B9}\u{3BA}\u{3B1}\u{3C4}\u{3AC}\u{3C3}\u{3C4}\u{3B1}\u{3C3}\u{3B7}`
};

},{}],"76eqb":[function(require,module,exports) {
module.exports = {
    "replaceMessage": `Drop file to replace`
};

},{}],"8AE3B":[function(require,module,exports) {
module.exports = {
    "replaceMessage": `Suelte el archivo para reemplazar`
};

},{}],"ceg5R":[function(require,module,exports) {
module.exports = {
    "replaceMessage": `Kukuta fail asendamiseks`
};

},{}],"dEMfd":[function(require,module,exports) {
module.exports = {
    "replaceMessage": `Pudota korvaava tiedosto`
};

},{}],"3UZDc":[function(require,module,exports) {
module.exports = {
    "replaceMessage": `D\xe9poser le fichier \xe0 remplacer`
};

},{}],"9emwy":[function(require,module,exports) {
module.exports = {
    "replaceMessage": `\u{5E9}\u{5D7}\u{5E8}\u{5E8} \u{5D0}\u{5EA} \u{5D4}\u{5E7}\u{5D5}\u{5D1}\u{5E5} \u{5DC}\u{5D4}\u{5D7}\u{5DC}\u{5E4}\u{5D4}`
};

},{}],"6DRi9":[function(require,module,exports) {
module.exports = {
    "replaceMessage": `Ispustite datoteku za zamjenu`
};

},{}],"fYgpL":[function(require,module,exports) {
module.exports = {
    "replaceMessage": `Ejtse le a f\xe1jlt a cser\xe9hez`
};

},{}],"g3vDX":[function(require,module,exports) {
module.exports = {
    "replaceMessage": `Rilascia il file da sostituire`
};

},{}],"gBagx":[function(require,module,exports) {
module.exports = {
    "replaceMessage": `\u{30D5}\u{30A1}\u{30A4}\u{30EB}\u{3092}\u{30C9}\u{30ED}\u{30C3}\u{30D7}\u{3057}\u{3066}\u{7F6E}\u{63DB}`
};

},{}],"6Chel":[function(require,module,exports) {
module.exports = {
    "replaceMessage": `\u{D30C}\u{C77C}\u{C744} \u{B4DC}\u{B86D}\u{D558}\u{C5EC} \u{BC14}\u{AFB8}\u{AE30}`
};

},{}],"7j0fE":[function(require,module,exports) {
module.exports = {
    "replaceMessage": `Pa\u{161}alinkite fail\u{105}, kad pakeistum\u{117}te`
};

},{}],"9L9bT":[function(require,module,exports) {
module.exports = {
    "replaceMessage": `Lai aizst\u{101}tu, nometiet failu`
};

},{}],"gUlK6":[function(require,module,exports) {
module.exports = {
    "replaceMessage": `Slipp filen for \xe5 erstatte`
};

},{}],"2x0jV":[function(require,module,exports) {
module.exports = {
    "replaceMessage": `Bestand neerzetten om te vervangen`
};

},{}],"51r9B":[function(require,module,exports) {
module.exports = {
    "replaceMessage": `Upu\u{15B}\u{107} plik, aby zast\u{105}pi\u{107}`
};

},{}],"41361":[function(require,module,exports) {
module.exports = {
    "replaceMessage": `Solte o arquivo para substituir`
};

},{}],"caEZH":[function(require,module,exports) {
module.exports = {
    "replaceMessage": `Largar ficheiro para substituir`
};

},{}],"03UTe":[function(require,module,exports) {
module.exports = {
    "replaceMessage": `Plasa\u{21B}i fi\u{219}ierul pentru a \xeenlocui`
};

},{}],"cCyo5":[function(require,module,exports) {
module.exports = {
    "replaceMessage": `\u{41F}\u{435}\u{440}\u{435}\u{442}\u{430}\u{449}\u{438}\u{442}\u{435} \u{444}\u{430}\u{439}\u{43B} \u{434}\u{43B}\u{44F} \u{437}\u{430}\u{43C}\u{435}\u{43D}\u{44B}`
};

},{}],"dCK7P":[function(require,module,exports) {
module.exports = {
    "replaceMessage": `Presu\u{148}te s\xfabor, ktor\xfd chcete nahradi\u{165}`
};

},{}],"04c5P":[function(require,module,exports) {
module.exports = {
    "replaceMessage": `Spustite datoteko za zamenjavo`
};

},{}],"isTFh":[function(require,module,exports) {
module.exports = {
    "replaceMessage": `Otpustite datoteku radi zamene`
};

},{}],"7TePR":[function(require,module,exports) {
module.exports = {
    "replaceMessage": `Sl\xe4pp filen f\xf6r att ers\xe4tta`
};

},{}],"e2HRc":[function(require,module,exports) {
module.exports = {
    "replaceMessage": `De\u{11F}i\u{15F}tirmek i\xe7in dosyay\u{131} b\u{131}rak\u{131}n`
};

},{}],"8LGSh":[function(require,module,exports) {
module.exports = {
    "replaceMessage": `\u{41F}\u{435}\u{440}\u{435}\u{442}\u{44F}\u{433}\u{43D}\u{456}\u{442}\u{44C} \u{444}\u{430}\u{439}\u{43B} \u{434}\u{43B}\u{44F} \u{437}\u{430}\u{43C}\u{456}\u{43D}\u{438}`
};

},{}],"1LWey":[function(require,module,exports) {
module.exports = {
    "replaceMessage": `\u{5220}\u{9664}\u{8981}\u{66FF}\u{6362}\u{7684}\u{6587}\u{4EF6}`
};

},{}],"jqbDI":[function(require,module,exports) {
module.exports = {
    "replaceMessage": `\u{653E}\u{7F6E}\u{8981}\u{53D6}\u{4EE3}\u{7684}\u{6A94}\u{6848}`
};

},{}],"lnziS":[function(require,module,exports) {
module.exports["focus-ring"] = `b5Gu6W_focus-ring`;
module.exports["i18nFontFamily"] = `b5Gu6W_i18nFontFamily`;
module.exports["spectrum-Dropzone"] = `b5Gu6W_spectrum-Dropzone`;
module.exports["spectrum-Dropzone--filled"] = `b5Gu6W_spectrum-Dropzone--filled`;
module.exports["spectrum-Dropzone-backdrop"] = `b5Gu6W_spectrum-Dropzone-backdrop`;
module.exports["spectrum-Dropzone-banner"] = `b5Gu6W_spectrum-Dropzone-banner`;
module.exports["spectrum-Dropzone-illustratedMessage"] = `b5Gu6W_spectrum-Dropzone-illustratedMessage`;
module.exports["spectrum-FocusRing-ring"] = `b5Gu6W_spectrum-FocusRing-ring`;
module.exports["spectrum-FocusRing"] = `b5Gu6W_spectrum-FocusRing ${module.exports["spectrum-FocusRing-ring"]}`;
module.exports["spectrum-FocusRing--quiet"] = `b5Gu6W_spectrum-FocusRing--quiet`;

},{}],"fy2lO":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("da043a8c083d59ff");
exports.__esModule = true;
exports.default = File;
var _icon = require("a2e9cf98e9631625");
var _react = _interopRequireDefault(require("6c5b361b38ed1883"));
function File(props) {
    return /*#__PURE__*/ _react.default.createElement(_icon.Illustration, props, /*#__PURE__*/ _react.default.createElement("svg", {
        viewBox: "0 0 32 32",
        height: "32",
        width: "32"
    }, /*#__PURE__*/ _react.default.createElement("path", {
        fill: "var(--spectrum-global-color-gray-50)",
        d: "M6 31.503a2.503 2.503 0 01-2.5-2.5v-26A2.503 2.503 0 016 .502h15.38a1.988 1.988 0 011.411.582l5.12 5.103a2.015 2.015 0 01.589 1.416v21.399a2.502 2.502 0 01-2.5 2.5z"
    }), /*#__PURE__*/ _react.default.createElement("path", {
        fill: "var(--spectrum-global-color-gray-500)",
        d: "M28.26 5.83L23.14.73A2.465 2.465 0 0021.38 0H6a3.009 3.009 0 00-3 3v26a3.002 3.002 0 003 3h20a3.002 3.002 0 003-3V7.6a2.515 2.515 0 00-.74-1.77zM22.5 1.5l5.02 5H23a.501.501 0 01-.5-.5zM28 29a2 2 0 01-2 2H6a2 2 0 01-2-2V3a2.006 2.006 0 012-2h15.38a.486.486 0 01.12.01V6A1.504 1.504 0 0023 7.5h4.99a.34.34 0 01.01.1z"
    })));
}

},{"da043a8c083d59ff":"iHubQ","a2e9cf98e9631625":"k7wem","6c5b361b38ed1883":"9yzVZ"}],"ev5ep":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("b4f919bd6e04fe8c");
exports.__esModule = true;
exports.default = Error404;
var _icon = require("f31bd03b18051507");
var _react = _interopRequireDefault(require("6e1ca7406b107a6e"));
function Error404(props) {
    return /*#__PURE__*/ _react.default.createElement(_icon.Illustration, props, /*#__PURE__*/ _react.default.createElement("svg", {
        width: "135.321",
        height: "87"
    }, /*#__PURE__*/ _react.default.createElement("g", {
        fill: "none",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeMiterlimit: "10"
    }, /*#__PURE__*/ _react.default.createElement("path", {
        d: "M11.821 60.5v23a2.006 2.006 0 002 2h118a2.006 2.006 0 002-2v-80a2.006 2.006 0 00-2-2h-118a2.006 2.006 0 00-2 2v27",
        strokeWidth: "3"
    }), /*#__PURE__*/ _react.default.createElement("path", {
        strokeWidth: "2",
        d: "M133.721 14h-122M29.721 8h-10"
    }), /*#__PURE__*/ _react.default.createElement("path", {
        strokeWidth: "3",
        d: "M2.121 55.1l19.3-19.2M21.421 55.1l-19.3-19.2"
    }))));
}

},{"b4f919bd6e04fe8c":"iHubQ","f31bd03b18051507":"k7wem","6e1ca7406b107a6e":"9yzVZ"}],"23Uc5":[function(require,module,exports) {
module.exports["files"] = `dPqerq_files`;
module.exports["images"] = `dPqerq_images`;
module.exports["is-filled"] = `dPqerq_is-filled`;

},{}],"543AJ":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("583105f008fe1974");
exports.__esModule = true;
exports.default = Error504;
var _icon = require("a44bf534bba3dbc7");
var _react = _interopRequireDefault(require("e81f9afe674f273e"));
function Error504(props) {
    return /*#__PURE__*/ _react.default.createElement(_icon.Illustration, props, /*#__PURE__*/ _react.default.createElement("svg", {
        width: "191.2",
        height: "97.9"
    }, /*#__PURE__*/ _react.default.createElement("path", {
        d: "M51.5 33h-48A3.543 3.543 0 000 36.5v35A3.543 3.543 0 003.5 75h48a3.543 3.543 0 003.5-3.5v-35a3.543 3.543 0 00-3.5-3.5zm-48 3h48a.472.472 0 01.5.5v30.6L40.5 55.4a2.94 2.94 0 00-2.2-.9 3.1 3.1 0 00-2.2.9l-4.7 5-11.8-12a2.94 2.94 0 00-2.2-.9 3.1 3.1 0 00-2.2.9L3 60.8V36.5a.472.472 0 01.5-.5zM3 71.5v-7.8l13.7-13.8a1.08 1.08 0 01.7-.3.908.908 0 01.7.3L40.2 72H3.5a.472.472 0 01-.5-.5zm48.5.5h-8.6c0-.1-.1-.1-.1-.2l-9.9-10 4.7-5a.908.908 0 01.7-.3.779.779 0 01.7.3L52 70v1.5a.472.472 0 01-.5.5z",
        stroke: "none"
    }), /*#__PURE__*/ _react.default.createElement("path", {
        d: "M41.8 51.3a5.664 5.664 0 004.1-1.7 5.835 5.835 0 001.7-4.1 5.957 5.957 0 00-5.8-5.9 5.85 5.85 0 000 11.7zm-2.7-8.5a3.864 3.864 0 012.7-1.1 3.8 3.8 0 013.8 3.8 3.756 3.756 0 01-3.8 3.8 3.8 3.8 0 01-3.8-3.8 3.864 3.864 0 011.1-2.7zM187.3 35h-27.2l-7.5-6.8a4.713 4.713 0 00-3-1.2h-15.3a3.159 3.159 0 00-3.2 3.2v40.1a3.691 3.691 0 003.7 3.7h52.7a3.691 3.691 0 003.7-3.7V38.7a3.933 3.933 0 00-3.9-3.7zm-53.1-5h15.3a1.284 1.284 0 011 .4l5.1 4.6H134v-4.8a.215.215 0 01.2-.2zM188 70.3a.684.684 0 01-.7.7h-52.7a.684.684 0 01-.7-.7V38h53.3a.684.684 0 01.7.7v31.6zM100.4 86L93 93.4V55.7a1.5 1.5 0 00-3 0v37.7L82.6 86a1.449 1.449 0 00-2.1 0 1.541 1.541 0 000 2.1l8.9 8.9a2.878 2.878 0 002.1.9 2.723 2.723 0 002.1-.9l8.9-8.9a1.485 1.485 0 00-2.1-2.1z",
        stroke: "none"
    }), /*#__PURE__*/ _react.default.createElement("path", {
        d: "M119.5 26a1.538 1.538 0 00-1.5 1.5v43.7a.86.86 0 01-.8.8H97.5a1.5 1.5 0 000 3h19.7a3.8 3.8 0 003.8-3.8V27.5a1.538 1.538 0 00-1.5-1.5zM121 21.4a.749.749 0 00-.1-.5c-.1-.2-.2-.3-.3-.5l-21-20a2.186 2.186 0 00-.5-.3 1.486 1.486 0 00-.6-.1H67.8A3.8 3.8 0 0064 3.8v67.4a3.8 3.8 0 003.8 3.8h17.7a1.5 1.5 0 000-3H67.8a.86.86 0 01-.8-.8V3.8a.86.86 0 01.8-.8H97v16.2a3.8 3.8 0 003.8 3.8h19c.1 0 .2 0 .2-.1h.1c.1 0 .2-.1.3-.1l.1-.1c.1 0 .1-.1.2-.1a2.186 2.186 0 00.3-.5v-.7zm-21-2.2V5l15.7 15h-15a.858.858 0 01-.7-.8z",
        stroke: "none"
    })));
}

},{"583105f008fe1974":"iHubQ","a44bf534bba3dbc7":"k7wem","e81f9afe674f273e":"9yzVZ"}],"khMhk":[function(require,module,exports) {
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DefaultWithButton", ()=>DefaultWithButton);
parcelHelpers.export(exports, "DefaultWithLink", ()=>DefaultWithLink);
var _button = require("@react-spectrum/button");
var _reactAriaComponents = require("react-aria-components");
var _link = require("@react-spectrum/link");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const meta = {
    title: "FileTrigger",
    component: (0, _reactAriaComponents.FileTrigger)
};
exports.default = meta;
const DefaultWithButton = {
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.FileTrigger), args, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.Button), {
            variant: "accent"
        }, "Upload"))
};
const DefaultWithLink = {
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAriaComponents.FileTrigger), args, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _link.Link), null, "Upload"))
};

},{"@react-spectrum/button":"jZWyP","react-aria-components":"lFSUH","@react-spectrum/link":"lNoiB","react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"9C8rZ":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Default", ()=>Default);
parcelHelpers.export(exports, "LabelPositionSide", ()=>LabelPositionSide);
parcelHelpers.export(exports, "CustomWidth", ()=>CustomWidth);
parcelHelpers.export(exports, "CustomWidthLabelPositionSide", ()=>CustomWidthLabelPositionSide);
parcelHelpers.export(exports, "LabelAlignEnd", ()=>LabelAlignEnd);
parcelHelpers.export(exports, "LabelPositionSideLabelAlignEnd", ()=>LabelPositionSideLabelAlignEnd);
parcelHelpers.export(exports, "FieldsNextToEachOther", ()=>FieldsNextToEachOther);
parcelHelpers.export(exports, "FieldsWithAutoCompleteProperty", ()=>FieldsWithAutoCompleteProperty);
parcelHelpers.export(exports, "IsRequiredTrue", ()=>IsRequiredTrue);
parcelHelpers.export(exports, "IsRequiredTrueNecessityIndicatorLabel", ()=>IsRequiredTrueNecessityIndicatorLabel);
parcelHelpers.export(exports, "IsRequiredFalseNecessityIndicatorLabel", ()=>IsRequiredFalseNecessityIndicatorLabel);
parcelHelpers.export(exports, "IsDisabled", ()=>IsDisabled);
parcelHelpers.export(exports, "IsQuiet", ()=>IsQuiet);
parcelHelpers.export(exports, "IsQuietLabelPositionSide", ()=>IsQuietLabelPositionSide);
parcelHelpers.export(exports, "IsEmphasized", ()=>IsEmphasized);
parcelHelpers.export(exports, "ValidationStateInvalid", ()=>ValidationStateInvalid);
parcelHelpers.export(exports, "ValidationStateValid", ()=>ValidationStateValid);
parcelHelpers.export(exports, "ValidationStateInvalidIsQuietTrue", ()=>ValidationStateInvalidIsQuietTrue);
parcelHelpers.export(exports, "ValidationStateValidIsQuietTrue", ()=>ValidationStateValidIsQuietTrue);
parcelHelpers.export(exports, "FormWithReset", ()=>FormWithReset);
parcelHelpers.export(exports, "_FormWithSubmit", ()=>_FormWithSubmit);
parcelHelpers.export(exports, "FormWithNumberfieldAndLocaleArAe", ()=>FormWithNumberfieldAndLocaleArAe);
parcelHelpers.export(exports, "WithTranslations", ()=>WithTranslations);
parcelHelpers.export(exports, "NativeValidation", ()=>NativeValidation);
parcelHelpers.export(exports, "ServerValidation", ()=>ServerValidation);
var _addonActions = require("@storybook/addon-actions");
var _button = require("@react-spectrum/button");
var _buttongroup = require("@react-spectrum/buttongroup");
var _date = require("@internationalized/date");
var _utils = require("@react-aria/utils");
var _checkbox = require("@react-spectrum/checkbox");
var _color = require("@react-spectrum/color");
var _combobox = require("@react-spectrum/combobox");
var _view = require("@react-spectrum/view");
var _contextualhelp = require("@react-spectrum/contextualhelp");
var _data = require("./data");
var _datepicker = require("@react-spectrum/datepicker");
var _layout = require("@react-spectrum/layout");
var _ = require("../");
var _formLanguagesChromatic = require("./../chromatic/FormLanguages.chromatic");
var _text = require("@react-spectrum/text");
var _inlinealert = require("@react-spectrum/inlinealert");
var _picker = require("@react-spectrum/picker");
var _numberfield = require("@react-spectrum/numberfield");
var _radio = require("@react-spectrum/radio");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _autocomplete = require("@react-spectrum/autocomplete");
var _searchfield = require("@react-spectrum/searchfield");
var _slider = require("@react-spectrum/slider");
var _statuslight = require("@react-spectrum/statuslight");
var _switch = require("@react-spectrum/switch");
var _tag = require("@react-spectrum/tag");
var _textfield = require("@react-spectrum/textfield");
var _varsCss = require("@adobe/spectrum-css-temp/components/typography/vars.css");
var _varsCssDefault = parcelHelpers.interopDefault(_varsCss);
var _well = require("@react-spectrum/well");
exports.default = {
    title: "Form",
    providerSwitcher: {
        status: "positive"
    }
};
const Default = ()=>render({});
const LabelPositionSide = ()=>render({
        labelPosition: "side"
    });
LabelPositionSide.story = {
    name: "labelPosition: side"
};
const CustomWidth = ()=>render({
        width: 400
    });
CustomWidth.story = {
    name: "custom width"
};
const CustomWidthLabelPositionSide = ()=>render({
        width: 400,
        labelPosition: "side"
    });
CustomWidthLabelPositionSide.story = {
    name: "custom width, labelPosition: side"
};
const LabelAlignEnd = ()=>render({
        width: 400,
        labelAlign: "end"
    });
LabelAlignEnd.story = {
    name: "labelAlign: end"
};
const LabelPositionSideLabelAlignEnd = ()=>render({
        width: 400,
        labelPosition: "side",
        labelAlign: "end"
    });
LabelPositionSideLabelAlignEnd.story = {
    name: "labelPosition: side, labelAlign: end"
};
const FieldsNextToEachOther = ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Form), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textfield.TextField), {
        label: "First Name",
        marginEnd: "size-100",
        flex: 1,
        description: "Please enter your first name."
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textfield.TextField), {
        label: "Last Name",
        flex: 1,
        description: "Please enter your last name."
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textfield.TextField), {
        label: "Street Address",
        description: "Please include apartment or suite number."
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textfield.TextField), {
        label: "City",
        marginEnd: "size-100",
        flex: 1,
        description: "Please enter the city you live in."
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _picker.Picker), {
        label: "State",
        items: (0, _data.states),
        marginEnd: "size-100",
        flex: 1
    }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _picker.Item), {
            key: item.abbr
        }, item.name)), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textfield.TextField), {
        label: "Zip code",
        flex: 1,
        description: "Please enter a five-digit zip code."
    })));
FieldsNextToEachOther.story = {
    name: "fields next to each other"
};
const FieldsWithAutoCompleteProperty = ()=>{
    const [checked, setChecked] = (0, _react.useState)(true);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Form), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _well.Well), {
        role: "group",
        "aria-labelledby": "billing-legend"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("h2", {
        id: "billing-legend",
        className: (0, _varsCssDefault.default)["spectrum-Heading4"]
    }, "Billing address"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textfield.TextField), {
        autoComplete: "billing given-name",
        name: "firstName",
        isRequired: true,
        label: "First Name",
        marginEnd: "size-100",
        flex: 1
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textfield.TextField), {
        autoComplete: "billing family-name",
        name: "lastName",
        isRequired: true,
        label: "Last Name",
        flex: 1
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textfield.TextArea), {
        autoComplete: "billing street-address",
        name: "streetAddress",
        isRequired: true,
        label: "Street Address",
        flex: 1
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textfield.TextField), {
        autoComplete: "billing address-level2",
        name: "city",
        isRequired: true,
        label: "City",
        marginEnd: "size-100",
        flex: 1
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _picker.Picker), {
        autoComplete: "billing address-level1",
        name: "state",
        isRequired: true,
        label: "State",
        items: (0, _data.states),
        marginEnd: "size-100",
        flex: 1
    }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _picker.Item), {
            key: item.abbr
        }, item.name)), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textfield.TextField), {
        autoComplete: "billing postal-code",
        name: "zip",
        isRequired: true,
        label: "Zip code",
        flex: 1
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _picker.Picker), {
        autoComplete: "billing country",
        name: "country",
        isRequired: true,
        label: "Country",
        items: (0, _data.countries),
        marginEnd: "size-100",
        flex: 1
    }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _picker.Item), {
            key: item.code
        }, item.name))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textfield.TextField), {
        autoComplete: "billing tel",
        type: "tel",
        name: "phone",
        label: "Phone number",
        marginEnd: "size-100",
        flex: 1
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textfield.TextField), {
        autoComplete: "billing email",
        type: "email",
        name: "email",
        isRequired: true,
        label: "Email address",
        marginEnd: "size-100",
        flex: 1
    }))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _well.Well), {
        role: "group",
        "aria-labelledby": "shipping-legend"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("h2", {
        id: "shipping-legend",
        className: (0, _varsCssDefault.default)["spectrum-Heading4"]
    }, "Shipping address"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _checkbox.Checkbox), {
        isSelected: checked,
        onChange: setChecked
    }, "Same as billing address"), !checked && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textfield.TextField), {
        autoComplete: "shipping given-name",
        name: "shippingFirstName",
        isRequired: true,
        label: "First Name",
        marginEnd: "size-100",
        flex: 1
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textfield.TextField), {
        autoComplete: "shipping family-name",
        name: "shippingLastName",
        isRequired: true,
        label: "Last Name",
        flex: 1
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textfield.TextArea), {
        autoComplete: "shipping street-address",
        name: "shippingStreetAddress",
        isRequired: true,
        label: "Street Address",
        flex: 1
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textfield.TextField), {
        autoComplete: "shipping address-level2",
        name: "shippingCity",
        isRequired: true,
        label: "City",
        marginEnd: "size-100",
        flex: 1
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _picker.Picker), {
        autoComplete: "shipping address-level1",
        name: "shippingState",
        isRequired: true,
        label: "State",
        items: (0, _data.states),
        marginEnd: "size-100",
        flex: 1
    }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _picker.Item), {
            key: item.abbr
        }, item.name)), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textfield.TextField), {
        autoComplete: "shipping postal-code",
        name: "shippingZip",
        isRequired: true,
        label: "Zip code",
        flex: 1
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _picker.Picker), {
        autoComplete: "shipping country",
        name: "shippingCountry",
        isRequired: true,
        label: "Country",
        items: (0, _data.countries),
        marginEnd: "size-100",
        flex: 1
    }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _picker.Item), {
            key: item.code
        }, item.name))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textfield.TextField), {
        autoComplete: "shipping tel",
        type: "tel",
        name: "shippingPhone",
        label: "Phone number",
        marginEnd: "size-100",
        flex: 1
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textfield.TextField), {
        autoComplete: "shipping email",
        type: "email",
        name: "shippingEmail",
        isRequired: true,
        label: "Email address",
        marginEnd: "size-100",
        flex: 1
    })))));
};
FieldsWithAutoCompleteProperty.story = {
    name: "fields with autoComplete property"
};
const IsRequiredTrue = ()=>render({
        isRequired: true
    });
IsRequiredTrue.story = {
    name: "isRequired: true"
};
const IsRequiredTrueNecessityIndicatorLabel = ()=>render({
        isRequired: true,
        necessityIndicator: "label"
    });
IsRequiredTrueNecessityIndicatorLabel.story = {
    name: "isRequired: true, necessityIndicator: label"
};
const IsRequiredFalseNecessityIndicatorLabel = ()=>render({
        isRequired: false,
        necessityIndicator: "label"
    });
IsRequiredFalseNecessityIndicatorLabel.story = {
    name: "isRequired: false, necessityIndicator: label"
};
const IsDisabled = ()=>render({
        isDisabled: true
    });
IsDisabled.story = {
    name: "isDisabled"
};
const IsQuiet = ()=>render({
        isQuiet: true
    });
IsQuiet.story = {
    name: "isQuiet"
};
const IsQuietLabelPositionSide = ()=>render({
        isQuiet: true,
        labelPosition: "side"
    });
IsQuietLabelPositionSide.story = {
    name: "isQuiet, labelPosition: side"
};
const IsEmphasized = ()=>render({
        isEmphasized: true
    });
IsEmphasized.story = {
    name: "isEmphasized"
};
const ValidationStateInvalid = ()=>render({
        validationState: "invalid"
    });
ValidationStateInvalid.story = {
    name: "validationState: invalid"
};
const ValidationStateValid = ()=>render({
        validationState: "valid"
    });
ValidationStateValid.story = {
    name: "validationState: valid"
};
const ValidationStateInvalidIsQuietTrue = ()=>render({
        validationState: "invalid",
        isQuiet: true
    });
ValidationStateInvalidIsQuietTrue.story = {
    name: "validationState: invalid, isQuiet: true"
};
const ValidationStateValidIsQuietTrue = ()=>render({
        validationState: "valid",
        isQuiet: true
    });
ValidationStateValidIsQuietTrue.story = {
    name: "validationState: valid, isQuiet: true"
};
const FormWithReset = ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement(FormWithControls, null);
FormWithReset.story = {
    name: "form with reset"
};
const _FormWithSubmit = ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement(FormWithSubmit, null);
_FormWithSubmit.story = {
    name: "form with submit"
};
const FormWithNumberfieldAndLocaleArAe = ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
        gap: "size-100"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _numberfield.NumberField), {
        label: "Outside form",
        description: "Hello"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Form), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _numberfield.NumberField), {
        label: "Inside form"
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Form), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textfield.TextField), {
        label: "First Name"
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Form), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textfield.TextField), {
        label: "First Name"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _numberfield.NumberField), {
        label: "Inside form"
    })));
FormWithNumberfieldAndLocaleArAe.story = {
    name: "form with numberfield and locale=ar-AE"
};
const WithTranslations = ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _formLanguagesChromatic.FormTranslatedText), null);
WithTranslations.story = {
    name: "with translations",
    parameters: {
        description: {
            data: "Translations included for: Arabic, English, Hebrew, Japanese, Korean, Simplified Chinese, and Traditional Chinese."
        }
    }
};
function render(props = {}) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Form), props, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _checkbox.CheckboxGroup), {
        label: "Pets",
        name: "pets",
        validate: (v)=>v.includes("dogs") ? "No dogs" : null
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _checkbox.Checkbox), {
        value: "dogs"
    }, "Dogs"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _checkbox.Checkbox), {
        value: "cats"
    }, "Cats"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _checkbox.Checkbox), {
        value: "dragons"
    }, "Dragons")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _combobox.ComboBox), {
        label: "More Animals",
        name: "combobox"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _picker.Item), {
        key: "red panda"
    }, "Red Panda"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _picker.Item), {
        key: "aardvark"
    }, "Aardvark"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _picker.Item), {
        key: "kangaroo"
    }, "Kangaroo"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _picker.Item), {
        key: "snake"
    }, "Snake")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _autocomplete.SearchAutocomplete), {
        label: "Search Animals",
        name: "searchAutocomplete"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _picker.Item), {
        key: "red panda"
    }, "Red Panda"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _picker.Item), {
        key: "aardvark"
    }, "Aardvark"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _picker.Item), {
        key: "kangaroo"
    }, "Kangaroo"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _picker.Item), {
        key: "snake"
    }, "Snake")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _numberfield.NumberField), {
        label: "Years lived there",
        name: "years"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _picker.Picker), {
        label: "State",
        items: (0, _data.states),
        name: "state"
    }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _picker.Item), {
            key: item.abbr
        }, item.name)), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _picker.Picker), {
        label: "Country",
        items: (0, _data.countries),
        name: "country"
    }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _picker.Item), {
            key: item.name
        }, item.name)), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _picker.Picker), {
        label: "Favorite color",
        name: "color",
        description: "Select any color you like.",
        errorMessage: "Please select a nicer color."
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _picker.Item), null, "Red"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _picker.Item), null, "Orange"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _picker.Item), null, "Yellow"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _picker.Item), null, "Green"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _picker.Item), null, "Blue"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _picker.Item), null, "Purple")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _radio.RadioGroup), {
        label: "Favorite pet",
        name: "favorite-pet-group"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _radio.Radio), {
        value: "dogs"
    }, "Dogs"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _radio.Radio), {
        value: "cats"
    }, "Cats"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _radio.Radio), {
        value: "dragons"
    }, "Dragons")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _searchfield.SearchField), {
        label: "Search",
        name: "search"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _switch.Switch), {
        name: "switch"
    }, "Low power mode"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textfield.TextArea), {
        name: "comments",
        label: "Comments",
        description: "Express yourself!",
        errorMessage: "No wrong answers, except for this one."
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textfield.TextField), {
        label: "City",
        name: "city",
        contextualHelp: /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _contextualhelp.ContextualHelp), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Heading), null, "What is a segment?"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Content), null, "Segments identify who your visitors are, what devices and services they use, where they navigated from, and much more."))
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textfield.TextField), {
        label: "Zip code",
        description: "Please enter a five-digit zip code.",
        pattern: "[0-9]{5}",
        name: "zip"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _tag.TagGroup), {
        label: "Favorite tags",
        description: "Select your favorite tags.",
        errorMessage: "Incorrect combination of tags."
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _picker.Item), {
        key: "1"
    }, "Cool Tag 1"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _picker.Item), {
        key: "2"
    }, "Cool Tag 2"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _picker.Item), {
        key: "3"
    }, "Cool Tag 3"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _picker.Item), {
        key: "4"
    }, "Cool Tag 4"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _picker.Item), {
        key: "5"
    }, "Cool Tag 5"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _picker.Item), {
        key: "6"
    }, "Cool Tag 6")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _color.ColorField), {
        label: "Color",
        name: "color"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _datepicker.DateField), {
        label: "Date",
        granularity: "minute",
        name: "date"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _datepicker.TimeField), {
        label: "Time",
        name: "time"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _datepicker.DatePicker), {
        label: "Date picker",
        name: "datePicker"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _datepicker.DateRangePicker), {
        label: "Date range",
        startName: "startDate",
        endName: "endDate"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textfield.TextField), {
        type: "email",
        label: "Email",
        name: "email"
    }), props.showSubmit && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _buttongroup.ButtonGroup), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.Button), {
        variant: "primary",
        type: "submit"
    }, "Submit"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.Button), {
        variant: "secondary",
        type: "reset"
    }, "Reset")));
}
function FormWithControls(props = {}) {
    let [firstName, setFirstName] = (0, _react.useState)("hello");
    let [isHunter, setIsHunter] = (0, _react.useState)(true);
    let [favoritePet, setFavoritePet] = (0, _react.useState)("cats");
    let [favoriteColor, setFavoriteColor] = (0, _react.useState)("green");
    let [howIFeel, setHowIFeel] = (0, _react.useState)("I feel good, o I feel so good!");
    let [birthday, setBirthday] = (0, _react.useState)(new (0, _date.CalendarDate)(1732, 2, 22));
    let [money, setMoney] = (0, _react.useState)(50);
    let [superSpeed, setSuperSpeed] = (0, _react.useState)(true);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Form), {
        onSubmit: (e)=>{
            (0, _addonActions.action)("onSubmit")(Object.fromEntries(new FormData(e.target).entries()));
            e.preventDefault();
        },
        ...props
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textfield.TextField), {
        name: "first-name",
        label: "First Name (controlled)",
        value: firstName,
        onChange: setFirstName
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textfield.TextField), {
        name: "last-name",
        label: "Last Name (uncontrolled)",
        defaultValue: "world"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textfield.TextField), {
        name: "street-address",
        label: "Street Address (uncontrolled)"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _picker.Picker), {
        name: "country",
        label: "Country (uncontrolled)",
        items: (0, _data.countries)
    }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _picker.Item), {
            key: item.name
        }, item.name)), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _numberfield.NumberField), {
        name: "age",
        label: "Age (uncontrolled)"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _numberfield.NumberField), {
        name: "money",
        label: "Money (controlled)",
        formatOptions: {
            style: "currency",
            currency: "USD"
        },
        value: money,
        onChange: setMoney
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _picker.Picker), {
        name: "favorite-color",
        label: "Favorite color (controlled)",
        selectedKey: favoriteColor,
        onSelectionChange: setFavoriteColor
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _picker.Item), {
        key: "red"
    }, "Red"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _picker.Item), {
        key: "orange"
    }, "Orange"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _picker.Item), {
        key: "yellow"
    }, "Yellow"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _picker.Item), {
        key: "green"
    }, "Green"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _picker.Item), {
        key: "blue"
    }, "Blue"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _picker.Item), {
        key: "purple"
    }, "Purple")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _checkbox.Checkbox), {
        name: "is-hunter",
        isSelected: isHunter,
        onChange: setIsHunter
    }, "I am a hunter! (controlled)"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _checkbox.Checkbox), {
        name: "is-wizard",
        defaultSelected: true
    }, "I am a wizard! (uncontrolled)"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _switch.Switch), {
        name: "airplane-mode"
    }, "Airplane mode (uncontrolled)"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _switch.Switch), {
        name: "super-speed",
        isSelected: superSpeed,
        onChange: setSuperSpeed
    }, "Super speed (controlled)"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _radio.RadioGroup), {
        label: "Favorite pet (controlled)",
        name: "favorite-pet-group",
        value: favoritePet,
        onChange: setFavoritePet
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _radio.Radio), {
        value: "dogs"
    }, "Dogs"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _radio.Radio), {
        value: "cats"
    }, "Cats"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _radio.Radio), {
        value: "dragons"
    }, "Dragons")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _radio.RadioGroup), {
        label: "Favorite pet (uncontrolled)",
        name: "favorite-pet-group2",
        defaultValue: "cats"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _radio.Radio), {
        value: "dogs"
    }, "Dogs"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _radio.Radio), {
        value: "cats"
    }, "Cats"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _radio.Radio), {
        value: "dragons"
    }, "Dragons")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textfield.TextArea), {
        name: "comments-controlled",
        label: "Comments (controlled)",
        value: howIFeel,
        onChange: setHowIFeel
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textfield.TextArea), {
        name: "comments-uncontrolled",
        label: "Comments (uncontrolled)",
        defaultValue: "hello"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _combobox.ComboBox), {
        label: "Favorite Animal (uncontrolled)",
        name: "favorite-animal",
        formValue: "key"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _picker.Item), {
        key: "red panda"
    }, "Red Panda"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _picker.Item), {
        key: "aardvark"
    }, "Aardvark"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _picker.Item), {
        key: "kangaroo"
    }, "Kangaroo"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _picker.Item), {
        key: "snake"
    }, "Snake")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _datepicker.DateField), {
        name: "date-uncontrolled",
        label: "Birth date (uncontrolled)"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _datepicker.DateField), {
        name: "date-controlled",
        label: "Birth date (controlled)",
        value: birthday,
        onChange: setBirthday
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _datepicker.DateRangePicker), {
        startName: "trip-start",
        endName: "trip-end",
        label: "Trip dates (uncontrolled)"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _slider.Slider), {
        name: "cookies",
        label: "Cookies (uncontrolled)",
        defaultValue: 50
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _buttongroup.ButtonGroup), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.Button), {
        variant: "primary",
        type: "submit"
    }, "Submit"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.Button), {
        variant: "secondary",
        type: "reset"
    }, "Reset")));
}
function FormWithSubmit() {
    let [policies, setPolicies] = (0, _react.useState)([]);
    let [policiesDirty, setPoliciesDirty] = (0, _react.useState)(false);
    let [pet, setPet] = (0, _react.useState)("");
    let [petDirty, setPetDirty] = (0, _react.useState)(false);
    let [truth, setTruth] = (0, _react.useState)(false);
    let [truthDirty, setTruthDirty] = (0, _react.useState)(false);
    let [email, setEmail] = (0, _react.useState)("");
    let [emailDirty, setEmailDirty] = (0, _react.useState)(false);
    let [formStatus, setFormStatus] = (0, _react.useState)("progress");
    let [isSubmitted, setSubmitted] = (0, _react.useState)(false); // TODO: really should be isSectionInvalid / 'fixing' for each form field. once form is submitted with mistakes, unchecking an unrelated, previously valid field should not make it look invalid.
    let getValidationState = (isValid)=>[
            "invalid",
            "fixing"
        ].includes(formStatus) && !isValid ? "invalid" : undefined;
    (0, _react.useEffect)(()=>{
        let validate = ()=>policies.length === 3 && !!pet && truth && email.includes("@");
        let formDirty = policiesDirty || petDirty || truthDirty || emailDirty;
        if (isSubmitted) {
            if (formDirty) setFormStatus("fixing");
            else setFormStatus(validate() ? "valid" : "invalid");
        } else setFormStatus("progress");
    }, [
        policies,
        policiesDirty,
        pet,
        petDirty,
        truth,
        truthDirty,
        email,
        emailDirty,
        isSubmitted
    ]);
    let Status = ({ formStatus })=>{
        let [variant, setVariant] = (0, _react.useState)("info");
        (0, _react.useEffect)(()=>{
            switch(formStatus){
                case "invalid":
                    return setVariant("negative");
                case "valid":
                    return setVariant("positive");
                case "fixing":
                    return setVariant("notice");
                default:
                    return setVariant("info");
            }
        }, [
            formStatus
        ]);
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _statuslight.StatusLight), {
            variant: variant
        }, formStatus === "progress" && "In progress", formStatus === "valid" && "Submitted successfully", formStatus === "invalid" && "Error", formStatus === "fixing" && "Fixing mistakes");
    };
    let handleSubmit = (e)=>{
        e.preventDefault();
        setPoliciesDirty(false);
        setTruthDirty(false);
        setPetDirty(false);
        setEmailDirty(false);
        setSubmitted(true);
        (0, _addonActions.action)("onSubmit")(e);
    };
    let reset = ()=>{
        setSubmitted(false);
        setPolicies([]);
        setPet("");
        setTruth(false);
        setPoliciesDirty(false);
        setPetDirty(false);
        setTruthDirty(false);
        setEmail("");
        setEmailDirty(false);
        setFormStatus("progress");
    };
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Form), {
        onSubmit: handleSubmit,
        isReadOnly: formStatus === "valid"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (formStatus === "invalid" || formStatus === "valid") && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _inlinealert.InlineAlert), {
        variant: formStatus === "invalid" ? "negative" : "positive"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Header), null, formStatus === "invalid" ? "Error" : "Success"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Content), null, formStatus === "invalid" ? "There was an error with the form." : "Form was successfully completed."))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textfield.TextField), {
        label: "Email address",
        type: "email",
        value: email,
        onChange: (0, _utils.chain)(()=>setEmailDirty(true), setEmail),
        validationState: getValidationState(email.includes("@")),
        errorMessage: "Email address must contain @"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _checkbox.CheckboxGroup), {
        label: "Agree to the following",
        isRequired: true,
        value: policies,
        onChange: (0, _utils.chain)(()=>setPoliciesDirty(true), setPolicies)
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _checkbox.Checkbox), {
        value: "terms",
        isRequired: true,
        isInvalid: getValidationState(policies.includes("terms")) === "invalid"
    }, "Terms and conditions"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _checkbox.Checkbox), {
        value: "privacy",
        isRequired: true,
        isInvalid: getValidationState(policies.includes("privacy")) === "invalid"
    }, "Privacy policy"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _checkbox.Checkbox), {
        value: "cookies",
        isRequired: true,
        isInvalid: getValidationState(policies.includes("cookies")) === "invalid"
    }, "Cookie policy")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _checkbox.Checkbox), {
        isRequired: true,
        value: "truth",
        isSelected: truth,
        onChange: (0, _utils.chain)(()=>setTruthDirty(true), setTruth),
        isInvalid: getValidationState(truth) === "invalid"
    }, "I am telling the truth"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _radio.RadioGroup), {
        label: "Favorite pet",
        isRequired: true,
        value: pet,
        onChange: (0, _utils.chain)(()=>setPetDirty(true), setPet),
        isInvalid: getValidationState(Boolean(pet)) === "invalid"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _radio.Radio), {
        value: "dogs"
    }, "Dogs"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _radio.Radio), {
        value: "cats"
    }, "Cats"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _radio.Radio), {
        value: "dragons"
    }, "Dragons")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _tag.TagGroup), {
        label: "Favorite tags"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _picker.Item), {
        key: "1"
    }, "Cool Tag 1"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _picker.Item), {
        key: "2"
    }, "Cool Tag 2"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _picker.Item), {
        key: "3"
    }, "Cool Tag 3"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _picker.Item), {
        key: "4"
    }, "Cool Tag 4"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _picker.Item), {
        key: "5"
    }, "Cool Tag 5"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _picker.Item), {
        key: "6"
    }, "Cool Tag 6")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.Button), {
        variant: "cta",
        type: "submit",
        isDisabled: formStatus === "valid"
    }, "Submit"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.Button), {
        variant: "secondary",
        type: "reset",
        onPress: reset
    }, "Reset"), /*#__PURE__*/ (0, _reactDefault.default).createElement(Status, {
        formStatus: formStatus
    }));
}
const NativeValidation = ()=>render({
        isRequired: true,
        validationBehavior: "native",
        showSubmit: true,
        onSubmit: (e)=>{
            e.preventDefault();
            (0, _addonActions.action)("onSubmit")(Object.fromEntries(new FormData(e.target).entries()));
        }
    });
NativeValidation.story = {
    parameters: {
        description: {
            data: "This story is to test that client validation occurs on form submit and updates when the user commits changes to a field value (e.g. on blur)."
        }
    }
};
function ServerValidation() {
    let [serverErrors, setServerErrors] = (0, _react.useState)({});
    let onSubmit = async (e)=>{
        e.preventDefault();
        let errors = {};
        for (let el of e.target.elements)errors[el.name] = `Invalid value for "${el.name}".`;
        setServerErrors(errors);
    };
    return render({
        validationBehavior: "native",
        onSubmit,
        validationErrors: serverErrors,
        showSubmit: true
    });
}
ServerValidation.story = {
    parameters: {
        description: {
            data: "This story is to test that server errors appear after submission, and are cleared when a field is modified."
        }
    }
};

},{"@storybook/addon-actions":"coXbW","@react-spectrum/button":"jZWyP","@react-spectrum/buttongroup":"anP11","@internationalized/date":"hesBk","@react-aria/utils":"9cLk5","@react-spectrum/checkbox":"1r19j","@react-spectrum/color":"hkBc2","@react-spectrum/combobox":"bO8KM","@react-spectrum/view":"dnRjt","@react-spectrum/contextualhelp":"jA6za","./data":"dHx7M","@react-spectrum/datepicker":"2xkLK","@react-spectrum/layout":"hzaUY","../":"47EMa","./../chromatic/FormLanguages.chromatic":"4Go1r","@react-spectrum/text":"etCGI","@react-spectrum/inlinealert":"5XTuR","@react-spectrum/picker":"kL1Uy","@react-spectrum/numberfield":"cMsXx","@react-spectrum/radio":"gbtGh","react":"9yzVZ","@react-spectrum/autocomplete":"9Ircl","@react-spectrum/searchfield":"2pivm","@react-spectrum/slider":"if52z","@react-spectrum/statuslight":"12nOK","@react-spectrum/switch":"fzqJX","@react-spectrum/tag":"dM36P","@react-spectrum/textfield":"hOmtq","@adobe/spectrum-css-temp/components/typography/vars.css":"cPEjS","@react-spectrum/well":"dRB1Q","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"dHx7M":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "states", ()=>states);
parcelHelpers.export(exports, "countries", ()=>countries);
const states = [
    {
        name: "Alabama",
        abbr: "AL"
    },
    {
        name: "Alaska",
        abbr: "AK"
    },
    {
        name: "American Samoa",
        abbr: "AS"
    },
    {
        name: "Arizona",
        abbr: "AZ"
    },
    {
        name: "Arkansas",
        abbr: "AR"
    },
    {
        name: "California",
        abbr: "CA"
    },
    {
        name: "Colorado",
        abbr: "CO"
    },
    {
        name: "Connecticut",
        abbr: "CT"
    },
    {
        name: "Delaware",
        abbr: "DE"
    },
    {
        name: "District Of Columbia",
        abbr: "DC"
    },
    {
        name: "Federated States Of Micronesia",
        abbr: "FM"
    },
    {
        name: "Florida",
        abbr: "FL"
    },
    {
        name: "Georgia",
        abbr: "GA"
    },
    {
        name: "Guam",
        abbr: "GU"
    },
    {
        name: "Hawaii",
        abbr: "HI"
    },
    {
        name: "Idaho",
        abbr: "ID"
    },
    {
        name: "Illinois",
        abbr: "IL"
    },
    {
        name: "Indiana",
        abbr: "IN"
    },
    {
        name: "Iowa",
        abbr: "IA"
    },
    {
        name: "Kansas",
        abbr: "KS"
    },
    {
        name: "Kentucky",
        abbr: "KY"
    },
    {
        name: "Louisiana",
        abbr: "LA"
    },
    {
        name: "Maine",
        abbr: "ME"
    },
    {
        name: "Marshall Islands",
        abbr: "MH"
    },
    {
        name: "Maryland",
        abbr: "MD"
    },
    {
        name: "Massachusetts",
        abbr: "MA"
    },
    {
        name: "Michigan",
        abbr: "MI"
    },
    {
        name: "Minnesota",
        abbr: "MN"
    },
    {
        name: "Mississippi",
        abbr: "MS"
    },
    {
        name: "Missouri",
        abbr: "MO"
    },
    {
        name: "Montana",
        abbr: "MT"
    },
    {
        name: "Nebraska",
        abbr: "NE"
    },
    {
        name: "Nevada",
        abbr: "NV"
    },
    {
        name: "New Hampshire",
        abbr: "NH"
    },
    {
        name: "New Jersey",
        abbr: "NJ"
    },
    {
        name: "New Mexico",
        abbr: "NM"
    },
    {
        name: "New York",
        abbr: "NY"
    },
    {
        name: "North Carolina",
        abbr: "NC"
    },
    {
        name: "North Dakota",
        abbr: "ND"
    },
    {
        name: "Northern Mariana Islands",
        abbr: "MP"
    },
    {
        name: "Ohio",
        abbr: "OH"
    },
    {
        name: "Oklahoma",
        abbr: "OK"
    },
    {
        name: "Oregon",
        abbr: "OR"
    },
    {
        name: "Palau",
        abbr: "PW"
    },
    {
        name: "Pennsylvania",
        abbr: "PA"
    },
    {
        name: "Puerto Rico",
        abbr: "PR"
    },
    {
        name: "Rhode Island",
        abbr: "RI"
    },
    {
        name: "South Carolina",
        abbr: "SC"
    },
    {
        name: "South Dakota",
        abbr: "SD"
    },
    {
        name: "Tennessee",
        abbr: "TN"
    },
    {
        name: "Texas",
        abbr: "TX"
    },
    {
        name: "Utah",
        abbr: "UT"
    },
    {
        name: "Vermont",
        abbr: "VT"
    },
    {
        name: "Virgin Islands",
        abbr: "VI"
    },
    {
        name: "Virginia",
        abbr: "VA"
    },
    {
        name: "Washington",
        abbr: "WA"
    },
    {
        name: "West Virginia",
        abbr: "WV"
    },
    {
        name: "Wisconsin",
        abbr: "WI"
    },
    {
        name: "Wyoming",
        abbr: "WY"
    }
];
const countries = [
    {
        name: "Afghanistan",
        code: "AF"
    },
    {
        name: "\xc5land Islands",
        code: "AX"
    },
    {
        name: "Albania",
        code: "AL"
    },
    {
        name: "Algeria",
        code: "DZ"
    },
    {
        name: "American Samoa",
        code: "AS"
    },
    {
        name: "AndorrA",
        code: "AD"
    },
    {
        name: "Angola",
        code: "AO"
    },
    {
        name: "Anguilla",
        code: "AI"
    },
    {
        name: "Antarctica",
        code: "AQ"
    },
    {
        name: "Antigua and Barbuda",
        code: "AG"
    },
    {
        name: "Argentina",
        code: "AR"
    },
    {
        name: "Armenia",
        code: "AM"
    },
    {
        name: "Aruba",
        code: "AW"
    },
    {
        name: "Australia",
        code: "AU"
    },
    {
        name: "Austria",
        code: "AT"
    },
    {
        name: "Azerbaijan",
        code: "AZ"
    },
    {
        name: "Bahamas",
        code: "BS"
    },
    {
        name: "Bahrain",
        code: "BH"
    },
    {
        name: "Bangladesh",
        code: "BD"
    },
    {
        name: "Barbados",
        code: "BB"
    },
    {
        name: "Belarus",
        code: "BY"
    },
    {
        name: "Belgium",
        code: "BE"
    },
    {
        name: "Belize",
        code: "BZ"
    },
    {
        name: "Benin",
        code: "BJ"
    },
    {
        name: "Bermuda",
        code: "BM"
    },
    {
        name: "Bhutan",
        code: "BT"
    },
    {
        name: "Bolivia",
        code: "BO"
    },
    {
        name: "Bosnia and Herzegovina",
        code: "BA"
    },
    {
        name: "Botswana",
        code: "BW"
    },
    {
        name: "Bouvet Island",
        code: "BV"
    },
    {
        name: "Brazil",
        code: "BR"
    },
    {
        name: "British Indian Ocean Territory",
        code: "IO"
    },
    {
        name: "Brunei Darussalam",
        code: "BN"
    },
    {
        name: "Bulgaria",
        code: "BG"
    },
    {
        name: "Burkina Faso",
        code: "BF"
    },
    {
        name: "Burundi",
        code: "BI"
    },
    {
        name: "Cambodia",
        code: "KH"
    },
    {
        name: "Cameroon",
        code: "CM"
    },
    {
        name: "Canada",
        code: "CA"
    },
    {
        name: "Cape Verde",
        code: "CV"
    },
    {
        name: "Cayman Islands",
        code: "KY"
    },
    {
        name: "Central African Republic",
        code: "CF"
    },
    {
        name: "Chad",
        code: "TD"
    },
    {
        name: "Chile",
        code: "CL"
    },
    {
        name: "China",
        code: "CN"
    },
    {
        name: "Christmas Island",
        code: "CX"
    },
    {
        name: "Cocos (Keeling) Islands",
        code: "CC"
    },
    {
        name: "Colombia",
        code: "CO"
    },
    {
        name: "Comoros",
        code: "KM"
    },
    {
        name: "Congo",
        code: "CG"
    },
    {
        name: "Congo, The Democratic Republic of the",
        code: "CD"
    },
    {
        name: "Cook Islands",
        code: "CK"
    },
    {
        name: "Costa Rica",
        code: "CR"
    },
    {
        name: "Cote D'Ivoire",
        code: "CI"
    },
    {
        name: "Croatia",
        code: "HR"
    },
    {
        name: "Cuba",
        code: "CU"
    },
    {
        name: "Cyprus",
        code: "CY"
    },
    {
        name: "Czech Republic",
        code: "CZ"
    },
    {
        name: "Denmark",
        code: "DK"
    },
    {
        name: "Djibouti",
        code: "DJ"
    },
    {
        name: "Dominica",
        code: "DM"
    },
    {
        name: "Dominican Republic",
        code: "DO"
    },
    {
        name: "Ecuador",
        code: "EC"
    },
    {
        name: "Egypt",
        code: "EG"
    },
    {
        name: "El Salvador",
        code: "SV"
    },
    {
        name: "Equatorial Guinea",
        code: "GQ"
    },
    {
        name: "Eritrea",
        code: "ER"
    },
    {
        name: "Estonia",
        code: "EE"
    },
    {
        name: "Ethiopia",
        code: "ET"
    },
    {
        name: "Falkland Islands (Malvinas)",
        code: "FK"
    },
    {
        name: "Faroe Islands",
        code: "FO"
    },
    {
        name: "Fiji",
        code: "FJ"
    },
    {
        name: "Finland",
        code: "FI"
    },
    {
        name: "France",
        code: "FR"
    },
    {
        name: "French Guiana",
        code: "GF"
    },
    {
        name: "French Polynesia",
        code: "PF"
    },
    {
        name: "French Southern Territories",
        code: "TF"
    },
    {
        name: "Gabon",
        code: "GA"
    },
    {
        name: "Gambia",
        code: "GM"
    },
    {
        name: "Georgia",
        code: "GE"
    },
    {
        name: "Germany",
        code: "DE"
    },
    {
        name: "Ghana",
        code: "GH"
    },
    {
        name: "Gibraltar",
        code: "GI"
    },
    {
        name: "Greece",
        code: "GR"
    },
    {
        name: "Greenland",
        code: "GL"
    },
    {
        name: "Grenada",
        code: "GD"
    },
    {
        name: "Guadeloupe",
        code: "GP"
    },
    {
        name: "Guam",
        code: "GU"
    },
    {
        name: "Guatemala",
        code: "GT"
    },
    {
        name: "Guernsey",
        code: "GG"
    },
    {
        name: "Guinea",
        code: "GN"
    },
    {
        name: "Guinea-Bissau",
        code: "GW"
    },
    {
        name: "Guyana",
        code: "GY"
    },
    {
        name: "Haiti",
        code: "HT"
    },
    {
        name: "Heard Island and Mcdonald Islands",
        code: "HM"
    },
    {
        name: "Holy See (Vatican City State)",
        code: "VA"
    },
    {
        name: "Honduras",
        code: "HN"
    },
    {
        name: "Hong Kong",
        code: "HK"
    },
    {
        name: "Hungary",
        code: "HU"
    },
    {
        name: "Iceland",
        code: "IS"
    },
    {
        name: "India",
        code: "IN"
    },
    {
        name: "Indonesia",
        code: "ID"
    },
    {
        name: "Iran, Islamic Republic Of",
        code: "IR"
    },
    {
        name: "Iraq",
        code: "IQ"
    },
    {
        name: "Ireland",
        code: "IE"
    },
    {
        name: "Isle of Man",
        code: "IM"
    },
    {
        name: "Israel",
        code: "IL"
    },
    {
        name: "Italy",
        code: "IT"
    },
    {
        name: "Jamaica",
        code: "JM"
    },
    {
        name: "Japan",
        code: "JP"
    },
    {
        name: "Jersey",
        code: "JE"
    },
    {
        name: "Jordan",
        code: "JO"
    },
    {
        name: "Kazakhstan",
        code: "KZ"
    },
    {
        name: "Kenya",
        code: "KE"
    },
    {
        name: "Kiribati",
        code: "KI"
    },
    {
        name: "Korea, Democratic People'S Republic of",
        code: "KP"
    },
    {
        name: "Korea, Republic of",
        code: "KR"
    },
    {
        name: "Kuwait",
        code: "KW"
    },
    {
        name: "Kyrgyzstan",
        code: "KG"
    },
    {
        name: "Lao People'S Democratic Republic",
        code: "LA"
    },
    {
        name: "Latvia",
        code: "LV"
    },
    {
        name: "Lebanon",
        code: "LB"
    },
    {
        name: "Lesotho",
        code: "LS"
    },
    {
        name: "Liberia",
        code: "LR"
    },
    {
        name: "Libyan Arab Jamahiriya",
        code: "LY"
    },
    {
        name: "Liechtenstein",
        code: "LI"
    },
    {
        name: "Lithuania",
        code: "LT"
    },
    {
        name: "Luxembourg",
        code: "LU"
    },
    {
        name: "Macao",
        code: "MO"
    },
    {
        name: "Macedonia, The Former Yugoslav Republic of",
        code: "MK"
    },
    {
        name: "Madagascar",
        code: "MG"
    },
    {
        name: "Malawi",
        code: "MW"
    },
    {
        name: "Malaysia",
        code: "MY"
    },
    {
        name: "Maldives",
        code: "MV"
    },
    {
        name: "Mali",
        code: "ML"
    },
    {
        name: "Malta",
        code: "MT"
    },
    {
        name: "Marshall Islands",
        code: "MH"
    },
    {
        name: "Martinique",
        code: "MQ"
    },
    {
        name: "Mauritania",
        code: "MR"
    },
    {
        name: "Mauritius",
        code: "MU"
    },
    {
        name: "Mayotte",
        code: "YT"
    },
    {
        name: "Mexico",
        code: "MX"
    },
    {
        name: "Micronesia, Federated States of",
        code: "FM"
    },
    {
        name: "Moldova, Republic of",
        code: "MD"
    },
    {
        name: "Monaco",
        code: "MC"
    },
    {
        name: "Mongolia",
        code: "MN"
    },
    {
        name: "Montserrat",
        code: "MS"
    },
    {
        name: "Morocco",
        code: "MA"
    },
    {
        name: "Mozambique",
        code: "MZ"
    },
    {
        name: "Myanmar",
        code: "MM"
    },
    {
        name: "Namibia",
        code: "NA"
    },
    {
        name: "Nauru",
        code: "NR"
    },
    {
        name: "Nepal",
        code: "NP"
    },
    {
        name: "Netherlands",
        code: "NL"
    },
    {
        name: "Netherlands Antilles",
        code: "AN"
    },
    {
        name: "New Caledonia",
        code: "NC"
    },
    {
        name: "New Zealand",
        code: "NZ"
    },
    {
        name: "Nicaragua",
        code: "NI"
    },
    {
        name: "Niger",
        code: "NE"
    },
    {
        name: "Nigeria",
        code: "NG"
    },
    {
        name: "Niue",
        code: "NU"
    },
    {
        name: "Norfolk Island",
        code: "NF"
    },
    {
        name: "Northern Mariana Islands",
        code: "MP"
    },
    {
        name: "Norway",
        code: "NO"
    },
    {
        name: "Oman",
        code: "OM"
    },
    {
        name: "Pakistan",
        code: "PK"
    },
    {
        name: "Palau",
        code: "PW"
    },
    {
        name: "Palestinian Territory, Occupied",
        code: "PS"
    },
    {
        name: "Panama",
        code: "PA"
    },
    {
        name: "Papua New Guinea",
        code: "PG"
    },
    {
        name: "Paraguay",
        code: "PY"
    },
    {
        name: "Peru",
        code: "PE"
    },
    {
        name: "Philippines",
        code: "PH"
    },
    {
        name: "Pitcairn",
        code: "PN"
    },
    {
        name: "Poland",
        code: "PL"
    },
    {
        name: "Portugal",
        code: "PT"
    },
    {
        name: "Puerto Rico",
        code: "PR"
    },
    {
        name: "Qatar",
        code: "QA"
    },
    {
        name: "Reunion",
        code: "RE"
    },
    {
        name: "Romania",
        code: "RO"
    },
    {
        name: "Russian Federation",
        code: "RU"
    },
    {
        name: "RWANDA",
        code: "RW"
    },
    {
        name: "Saint Helena",
        code: "SH"
    },
    {
        name: "Saint Kitts and Nevis",
        code: "KN"
    },
    {
        name: "Saint Lucia",
        code: "LC"
    },
    {
        name: "Saint Pierre and Miquelon",
        code: "PM"
    },
    {
        name: "Saint Vincent and the Grenadines",
        code: "VC"
    },
    {
        name: "Samoa",
        code: "WS"
    },
    {
        name: "San Marino",
        code: "SM"
    },
    {
        name: "Sao Tome and Principe",
        code: "ST"
    },
    {
        name: "Saudi Arabia",
        code: "SA"
    },
    {
        name: "Senegal",
        code: "SN"
    },
    {
        name: "Serbia and Montenegro",
        code: "CS"
    },
    {
        name: "Seychelles",
        code: "SC"
    },
    {
        name: "Sierra Leone",
        code: "SL"
    },
    {
        name: "Singapore",
        code: "SG"
    },
    {
        name: "Slovakia",
        code: "SK"
    },
    {
        name: "Slovenia",
        code: "SI"
    },
    {
        name: "Solomon Islands",
        code: "SB"
    },
    {
        name: "Somalia",
        code: "SO"
    },
    {
        name: "South Africa",
        code: "ZA"
    },
    {
        name: "South Georgia and the South Sandwich Islands",
        code: "GS"
    },
    {
        name: "Spain",
        code: "ES"
    },
    {
        name: "Sri Lanka",
        code: "LK"
    },
    {
        name: "Sudan",
        code: "SD"
    },
    {
        name: "Suriname",
        code: "SR"
    },
    {
        name: "Svalbard and Jan Mayen",
        code: "SJ"
    },
    {
        name: "Swaziland",
        code: "SZ"
    },
    {
        name: "Sweden",
        code: "SE"
    },
    {
        name: "Switzerland",
        code: "CH"
    },
    {
        name: "Syrian Arab Republic",
        code: "SY"
    },
    {
        name: "Taiwan, Province of China",
        code: "TW"
    },
    {
        name: "Tajikistan",
        code: "TJ"
    },
    {
        name: "Tanzania, United Republic of",
        code: "TZ"
    },
    {
        name: "Thailand",
        code: "TH"
    },
    {
        name: "Timor-Leste",
        code: "TL"
    },
    {
        name: "Togo",
        code: "TG"
    },
    {
        name: "Tokelau",
        code: "TK"
    },
    {
        name: "Tonga",
        code: "TO"
    },
    {
        name: "Trinidad and Tobago",
        code: "TT"
    },
    {
        name: "Tunisia",
        code: "TN"
    },
    {
        name: "Turkey",
        code: "TR"
    },
    {
        name: "Turkmenistan",
        code: "TM"
    },
    {
        name: "Turks and Caicos Islands",
        code: "TC"
    },
    {
        name: "Tuvalu",
        code: "TV"
    },
    {
        name: "Uganda",
        code: "UG"
    },
    {
        name: "Ukraine",
        code: "UA"
    },
    {
        name: "United Arab Emirates",
        code: "AE"
    },
    {
        name: "United Kingdom",
        code: "GB"
    },
    {
        name: "United States",
        code: "US"
    },
    {
        name: "United States Minor Outlying Islands",
        code: "UM"
    },
    {
        name: "Uruguay",
        code: "UY"
    },
    {
        name: "Uzbekistan",
        code: "UZ"
    },
    {
        name: "Vanuatu",
        code: "VU"
    },
    {
        name: "Venezuela",
        code: "VE"
    },
    {
        name: "Viet Nam",
        code: "VN"
    },
    {
        name: "Virgin Islands, British",
        code: "VG"
    },
    {
        name: "Virgin Islands, U.S.",
        code: "VI"
    },
    {
        name: "Wallis and Futuna",
        code: "WF"
    },
    {
        name: "Western Sahara",
        code: "EH"
    },
    {
        name: "Yemen",
        code: "YE"
    },
    {
        name: "Zambia",
        code: "ZM"
    },
    {
        name: "Zimbabwe",
        code: "ZW"
    }
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"47EMa":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _src = require("./src");
parcelHelpers.exportAll(_src, exports);

},{"./src":"bGDqA","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"4Go1r":[function(require,module,exports) {
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FormTranslatedText", ()=>FormTranslatedText);
parcelHelpers.export(exports, "FormTranslatedTextSideLabel", ()=>FormTranslatedTextSideLabel);
var _checkbox = require("@react-spectrum/checkbox");
var _color = require("@react-spectrum/color");
var _combobox = require("@react-spectrum/combobox");
var _view = require("@react-spectrum/view");
var _contextualhelp = require("@react-spectrum/contextualhelp");
var _form = require("@react-spectrum/form");
var _text = require("@react-spectrum/text");
// @ts-ignore
var _intlMessagesJson = require("./intlMessages.json");
var _intlMessagesJsonDefault = parcelHelpers.interopDefault(_intlMessagesJson);
var _picker = require("@react-spectrum/picker");
var _numberfield = require("@react-spectrum/numberfield");
var _radio = require("@react-spectrum/radio");
var _slider = require("@react-spectrum/slider");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _searchfield = require("@react-spectrum/searchfield");
var _switch = require("@react-spectrum/switch");
var _textfield = require("@react-spectrum/textfield");
var _i18N = require("@react-aria/i18n");
exports.default = {
    title: "Languages/Form",
    parameters: {
        chromaticProvider: {
            colorSchemes: [
                "light"
            ],
            express: false,
            locales: [
                "ar-AE",
                "he-IL",
                "zh-CN",
                "zh-TW",
                "ja-JP",
                "ko-KR"
            ],
            scales: [
                "large",
                "medium"
            ]
        }
    }
};
let TranslateForm = (props)=>{
    let strings = (0, _i18N.useLocalizedStringFormatter)((0, _intlMessagesJsonDefault.default));
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _form.Form), props, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _checkbox.CheckboxGroup), {
        defaultValue: [
            "cow",
            "goat"
        ],
        label: strings.format("ruminants"),
        description: strings.format("areRuminats"),
        contextualHelp: /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _contextualhelp.ContextualHelp), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Heading), null, strings.format("whatIsARuminat")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Content), null, strings.format("ruminatDefinition")))
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _checkbox.Checkbox), {
        value: "cow"
    }, strings.format("cow")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _checkbox.Checkbox), {
        value: "goat"
    }, strings.format("goat")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _checkbox.Checkbox), {
        value: "chicken"
    }, strings.format("chicken"))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _color.ColorField), {
        label: strings.format("color"),
        defaultValue: "#119911",
        validationState: "invalid",
        errorMessage: strings.format("colorError")
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _combobox.ComboBox), {
        label: strings.format("ruminants"),
        defaultInputValue: strings.format("cow"),
        validationState: "valid",
        description: strings.format("areRuminats"),
        contextualHelp: /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _contextualhelp.ContextualHelp), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Heading), null, strings.format("whatIsARuminat")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Content), null, strings.format("ruminatDefinition")))
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _picker.Item), {
        key: "cow"
    }, strings.format("cow")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _picker.Item), {
        key: "goat"
    }, strings.format("goat")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _picker.Item), {
        key: "chicken"
    }, strings.format("chicken")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _picker.Item), {
        key: "sheep"
    }, strings.format("sheep"))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _numberfield.NumberField), {
        label: strings.format("farmAnimalCount"),
        validationState: "invalid",
        errorMessage: strings.format("farmCountError")
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _picker.Picker), {
        label: strings.format("ruminants"),
        defaultSelectedKey: strings.format("chicken"),
        isInvalid: true,
        errorMessage: strings.format("notRuminatError"),
        contextualHelp: /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _contextualhelp.ContextualHelp), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Heading), null, strings.format("whatIsARuminat")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Content), null, strings.format("ruminatDefinition")))
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _picker.Item), {
        key: "cow"
    }, strings.format("cow")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _picker.Item), {
        key: "goat"
    }, strings.format("goat")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _picker.Item), {
        key: strings.format("chicken")
    }, strings.format("chicken")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _picker.Item), {
        key: strings.format("sheep")
    }, strings.format("sheep"))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _radio.RadioGroup), {
        label: strings.format("ruminants"),
        defaultValue: strings.format("sheep"),
        description: strings.format("areRuminats"),
        contextualHelp: /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _contextualhelp.ContextualHelp), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Heading), null, strings.format("whatIsARuminat")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Content), null, strings.format("ruminatDefinition")))
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _radio.Radio), {
        value: "cow"
    }, strings.format("cow")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _radio.Radio), {
        value: "goat"
    }, strings.format("goat")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _radio.Radio), {
        value: "chicken"
    }, strings.format("chicken")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _radio.Radio), {
        value: strings.format("sheep")
    }, strings.format("sheep"))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _slider.RangeSlider), {
        label: strings.format("ageRange"),
        defaultValue: {
            start: 12,
            end: 36
        }
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _searchfield.SearchField), {
        label: strings.format("cheeseSearch"),
        validationState: "valid",
        description: strings.format("findCheese")
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _slider.Slider), {
        label: strings.format("farmScore"),
        defaultValue: 25
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _switch.Switch), null, strings.format("amHappy")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textfield.TextArea), {
        label: strings.format("clients"),
        validationState: "invalid",
        errorMessage: strings.format("clientsError"),
        contextualHelp: /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _contextualhelp.ContextualHelp), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Heading), null, strings.format("clientHeading")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Content), null, strings.format("clientContent")))
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textfield.TextField), {
        label: strings.format("farmName"),
        value: strings.format("brownFenceFarm"),
        validationState: "valid",
        description: strings.format("farmDescription"),
        contextualHelp: /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _contextualhelp.ContextualHelp), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Heading), null, strings.format("farmTitle")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Content), null, strings.format("farmLegal")))
    }));
};
const FormTranslatedText = (props)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(TranslateForm, props);
const FormTranslatedTextSideLabel = ()=>{
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(FormTranslatedText, {
        labelPosition: "side",
        labelAlign: "start",
        width: "500px"
    });
};

},{"@react-spectrum/checkbox":"1r19j","@react-spectrum/color":"hkBc2","@react-spectrum/combobox":"bO8KM","@react-spectrum/view":"dnRjt","@react-spectrum/contextualhelp":"jA6za","@react-spectrum/form":"bGDqA","@react-spectrum/text":"etCGI","./intlMessages.json":"6MS2q","@react-spectrum/picker":"kL1Uy","@react-spectrum/numberfield":"cMsXx","@react-spectrum/radio":"gbtGh","@react-spectrum/slider":"if52z","react":"9yzVZ","@react-spectrum/searchfield":"2pivm","@react-spectrum/switch":"fzqJX","@react-spectrum/textfield":"hOmtq","@react-aria/i18n":"411rg","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"6MS2q":[function(require,module,exports) {
module.exports = JSON.parse('{"ar-AR":{"ruminants":"\u0627\u0644\u0645\u062C\u062A\u0631\u0627\u062A","areRuminats":"\u0647\u0630\u0647 \u0645\u062C\u062A\u0631\u0627\u062A.","whatIsARuminat":"\u0645\u0627 \u0647\u0648 \u0627\u0644\u0645\u062C\u062A\u0631\u061F","ruminatDefinition":"\u0627\u0644\u0645\u062C\u062A\u0631\u0627\u062A \u0647\u064A \u062D\u064A\u0648\u0627\u0646\u0627\u062A \u0631\u0639\u064A \u062D\u0648\u0627\u0641\u0631 \u0623\u0648 \u062B\u062F\u064A\u064A\u0627\u062A \u0642\u0627\u062F\u0631\u0629 \u0639\u0644\u0649 \u0627\u0644\u062D\u0635\u0648\u0644 \u0639\u0644\u0649 \u0627\u0644\u0645\u063A\u0630\u064A\u0627\u062A \u0645\u0646 \u0627\u0644\u0623\u0637\u0639\u0645\u0629 \u0627\u0644\u0646\u0628\u0627\u062A\u064A\u0629 \u0639\u0646 \u0637\u0631\u064A\u0642 \u062A\u062E\u0645\u064A\u0631\u0647\u0627 \u0641\u064A \u0645\u0639\u062F\u0629 \u0645\u062A\u062E\u0635\u0635\u0629 \u0642\u0628\u0644 \u0627\u0644\u0647\u0636\u0645 \u060C \u0628\u0634\u0643\u0644 \u0623\u0633\u0627\u0633\u064A \u0645\u0646 \u062E\u0644\u0627\u0644 \u0627\u0644\u0625\u062C\u0631\u0627\u0621\u0627\u062A \u0627\u0644\u0645\u064A\u0643\u0631\u0648\u0628\u064A\u0629.","cow":"\u0628\u0642\u0631\u0629","goat":"\u0645\u0639\u0632\u0629","chicken":"\u0641\u0631\u062E\u0629","sheep":"\u063A\u0646\u0645","color":"Adobe \u0644\u0648\u0646","colorError":"\u0644\u064A\u0633 \u0644\u0648\u0646 Adobe \u0635\u0627\u0644\u062D\u064B\u0627","farmAnimalCount":"\u0639\u062F\u062F \u062D\u064A\u0648\u0627\u0646\u0627\u062A \u0627\u0644\u0645\u0632\u0631\u0639\u0629","farmCountError":"\u0627\u062E\u062A\u0631 \u0631\u0642\u0645\u064B\u0627 \u0635\u0627\u0644\u062D\u064B\u0627","notRuminatError":"\u0647\u0630\u0627 \u0627\u0644\u062D\u064A\u0648\u0627\u0646 \u0644\u064A\u0633 \u0645\u062C\u062A\u0631\u064B\u0627.","ageRange":"\u0627\u0644\u0641\u0626\u0629 \u0627\u0644\u0639\u0645\u0631\u064A\u0629","cheeseSearch":"\u0627\u0644\u0628\u062D\u062B \u0639\u0646 \u0627\u0644\u062C\u0628\u0646","findCheese":"\u0623\u062F\u062E\u0644 \u062C\u0628\u0646\u064B\u0627 \u0635\u0627\u0644\u062D\u064B\u0627 \u0644\u0644\u0639\u062B\u0648\u0631 \u0639\u0644\u0649 \u0627\u0644\u0623\u0635\u0644 \u0648\u0627\u0644\u062A\u0627\u0631\u064A\u062E \u0648\u0627\u0644\u0648\u0635\u0641\u0629.","farmScore":"\u0646\u062A\u064A\u062C\u0629 \u0627\u0644\u0645\u0632\u0631\u0639\u0629","amHappy":"\u0647\u0644 \u0623\u0646\u062A \u0633\u0639\u064A\u062F\u061F","clients":"\u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0639\u0645\u0644\u0627\u0621","clientsError":"\u0623\u062F\u062E\u0644 \u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0639\u0645\u0644\u0627\u0621.","clientHeading":"\u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0639\u0645\u0644\u0627\u0621","clientContent":"\u0642\u0627\u0626\u0645\u0629 \u0645\u0641\u0635\u0648\u0644\u0629 \u0628\u0641\u0648\u0627\u0635\u0644 \u0644\u062C\u0645\u064A\u0639 \u0627\u0644\u0639\u0645\u0644\u0627\u0621.","farmName":"\u0627\u0633\u0645 \u0627\u0644\u0645\u0632\u0631\u0639\u0629","brownFenceFarm":"\u0645\u0632\u0631\u0639\u0629 \u0627\u0644\u0633\u0648\u0631 \u0627\u0644\u0628\u0646\u064A","farmDescription":"\u0623\u062F\u062E\u0644 \u0627\u0633\u0645 \u0645\u0632\u0631\u0639\u062A\u0643.","farmTitle":"\u0627\u0644\u0627\u0633\u0645 \u0627\u0644\u0642\u0627\u0646\u0648\u0646\u064A \u0644\u0644\u0645\u0632\u0631\u0639\u0629","farmLegal":"\u064A\u062C\u0628 \u0623\u0646 \u064A\u0643\u0648\u0646 \u0647\u0630\u0627 \u0627\u0644\u0627\u0633\u0645 \u0627\u0644\u0642\u0627\u0646\u0648\u0646\u064A \u0644\u0644\u0645\u0632\u0631\u0639\u0629 \u0648\u0644\u064A\u0633 \u0627\u0633\u0645\u064B\u0627 \u0645\u0633\u062A\u0639\u0627\u0631\u064B\u0627 \u0623\u0648 \u0627\u0633\u0645 \u062A\u0633\u0648\u064A\u0642."},"en-US":{"ruminants":"Ruminants","areRuminats":"These are ruminants.","whatIsARuminat":"What is a ruminat?","ruminatDefinition":"Ruminants are hoofed herbivorous grazing or browsing mammals that are able to acquire nutrients from plant-based food by fermenting it in a specialized stomach prior to digestion, principally through microbial actions.","cow":"Cow","goat":"Goat","chicken":"Chicken","sheep":"Sheep","color":"Adobe color","colorError":"Not a valid Adobe color","farmAnimalCount":"Farm animal count","farmCountError":"Choose a valid number","notRuminatError":"This animal is not a ruminant.","ageRange":"Age range","cheeseSearch":"Cheese search","findCheese":"Enter a valid cheese to find origin, history, and recipe.","farmScore":"Farm score","amHappy":"Are you happy?","clients":"List of clients","clientsError":"Enter client list.","clientHeading":"Client list","clientContent":"Comma seperated list of all clients.","farmName":"Farm name","brownFenceFarm":"Brown Fence Farm","farmDescription":"Enter the name of your farm.","farmTitle":"Legal name of farm","farmLegal":"This should be the legal name of the farm and not an alias or marketing name."},"he-IL":{"ruminants":"\u05DE\u05E2\u05DC\u05D9 \u05D2\u05D9\u05E8\u05D4","areRuminats":"\u05D0\u05DC\u05D4 \u05D1\u05E2\u05DC\u05D9 \u05D2\u05D9\u05E8\u05D4.","whatIsARuminat":"\u05DE\u05D4 \u05D6\u05D4 \u05D2\u05D9\u05E8\u05D4?","ruminatDefinition":"\u05D2\u05D9\u05E8\u05D4 \u05D4\u05DD \u05D9\u05D5\u05E0\u05E7\u05D9\u05DD \u05D0\u05D5\u05DB\u05DC\u05D9 \u05E2\u05E9\u05D1 \u05E4\u05E8\u05E1\u05D5\u05EA \u05E9\u05E8\u05D5\u05E2\u05D5\u05EA \u05D0\u05D5 \u05D2\u05D5\u05DC\u05E9\u05D9\u05DD \u05D4\u05DE\u05E1\u05D5\u05D2\u05DC\u05D9\u05DD \u05DC\u05E8\u05DB\u05D5\u05E9 \u05D7\u05D5\u05DE\u05E8\u05D9\u05DD \u05DE\u05D6\u05D9\u05E0\u05D9\u05DD \u05DE\u05DE\u05D6\u05D5\u05DF \u05E6\u05DE\u05D7\u05D9 \u05E2\u05DC \u05D9\u05D3\u05D9 \u05EA\u05E1\u05D9\u05E1\u05EA\u05D5 \u05D1\u05E7\u05D9\u05D1\u05D4 \u05DE\u05D9\u05D5\u05D7\u05D3\u05EA \u05DC\u05E4\u05E0\u05D9 \u05D4\u05E2\u05D9\u05DB\u05D5\u05DC, \u05D1\u05E2\u05D9\u05E7\u05E8 \u05D1\u05D0\u05DE\u05E6\u05E2\u05D5\u05EA \u05E4\u05E2\u05D5\u05DC\u05D5\u05EA \u05DE\u05D9\u05E7\u05E8\u05D5\u05D1\u05D9\u05D0\u05DC\u05D9\u05D5\u05EA.","cow":"\u05E4\u05BC\u05B8\u05E8\u05B8\u05D4","goat":"\u05E2\u05B5\u05D6","chicken":"\u05E2\u05D5\u05E3","sheep":"\u05DB\u05D1\u05E9\u05D9\u05DD","color":"Adobe \u05E6\u05B6\u05D1\u05B7\u05E2","colorError":"\u05DC\u05D0 \u05E6\u05D1\u05E2 Adobe \u05D7\u05D5\u05E7\u05D9","farmAnimalCount":"\u05E1\u05E4\u05D9\u05E8\u05EA \u05D7\u05D9\u05D5\u05EA \u05DE\u05E9\u05E7","farmCountError":"\u05D1\u05D7\u05E8 \u05DE\u05E1\u05E4\u05E8 \u05D7\u05D5\u05E7\u05D9","notRuminatError":"\u05D1\u05E2\u05DC \u05D7\u05D9\u05D9\u05DD \u05D6\u05D4 \u05D0\u05D9\u05E0\u05D5 \u05DE\u05E2\u05DC\u05D4 \u05D2\u05D9\u05E8\u05D4.","ageRange":"\u05D8\u05D5\u05D5\u05D7 \u05D2\u05D9\u05DC\u05D0\u05D9\u05DD","cheeseSearch":"\u05D7\u05D9\u05E4\u05D5\u05E9 \u05D2\u05D1\u05D9\u05E0\u05D4","findCheese":"\u05D4\u05D6\u05DF \u05D2\u05D1\u05D9\u05E0\u05D4 \u05D7\u05D5\u05E7\u05D9\u05EA \u05DB\u05D3\u05D9 \u05DC\u05DE\u05E6\u05D5\u05D0 \u05DE\u05E7\u05D5\u05E8, \u05D4\u05D9\u05E1\u05D8\u05D5\u05E8\u05D9\u05D4 \u05D5\u05DE\u05EA\u05DB\u05D5\u05DF.","farmScore":"\u05E6\u05D9\u05D5\u05DF \u05D4\u05D7\u05D5\u05D5\u05D4","amHappy":"\u05D4\u05D0\u05DD \u05D0\u05EA\u05D4 \u05E9\u05DE\u05D7?","clients":"\u05E8\u05E9\u05D9\u05DE\u05EA \u05DC\u05E7\u05D5\u05D7\u05D5\u05EA","clientsError":"\u05D4\u05D9\u05DB\u05E0\u05E1 \u05DC\u05E8\u05E9\u05D9\u05DE\u05EA \u05DC\u05E7\u05D5\u05D7\u05D5\u05EA.","clientHeading":"\u05E8\u05E9\u05D9\u05DE\u05EA \u05DC\u05E7\u05D5\u05D7\u05D5\u05EA","clientContent":"\u05E8\u05E9\u05D9\u05DE\u05D4 \u05DE\u05D5\u05E4\u05E8\u05D3\u05EA \u05D1\u05E4\u05E1\u05D9\u05E7 \u05E9\u05DC \u05DB\u05DC \u05D4\u05DC\u05E7\u05D5\u05D7\u05D5\u05EA.","farmName":"\u05E9\u05DD \u05D4\u05D7\u05D5\u05D5\u05D4","brownFenceFarm":"\u05D7\u05D5\u05D5\u05EA \u05D2\u05D3\u05E8 \u05D7\u05D5\u05DE\u05D4","farmDescription":"\u05D4\u05D6\u05DF \u05D0\u05EA \u05E9\u05DD \u05D4\u05D7\u05D5\u05D5\u05D4 \u05E9\u05DC\u05DA.","farmTitle":"\u05D4\u05E9\u05DD \u05D4\u05D7\u05D5\u05E7\u05D9 \u05E9\u05DC \u05D4\u05D7\u05D5\u05D5\u05D4","farmLegal":"\u05D6\u05D4 \u05E6\u05E8\u05D9\u05DA \u05DC\u05D4\u05D9\u05D5\u05EA \u05D4\u05E9\u05DD \u05D4\u05D7\u05D5\u05E7\u05D9 \u05E9\u05DC \u05D4\u05D7\u05D5\u05D5\u05D4 \u05D5\u05DC\u05D0 \u05DB\u05D9\u05E0\u05D5\u05D9 \u05D0\u05D5 \u05E9\u05DD \u05E9\u05D9\u05D5\u05D5\u05E7\u05D9."},"ja-JP":{"ruminants":"\u53CD\u82BB\u52D5\u7269","areRuminats":"\u3053\u308C\u3089\u306F\u53CD\u82BB\u52D5\u7269\u3067\u3059\u3002","whatIsARuminat":"\u53CD\u82BB\u52D5\u7269\u3068\u306F\uFF1F","ruminatDefinition":"\u53CD\u82BB\u52D5\u7269\u306F\u3001\u4E3B\u306B\u5FAE\u751F\u7269\u306E\u4F5C\u7528\u3092\u901A\u3058\u3066\u3001\u6D88\u5316\u524D\u306B\u7279\u6B8A\u306A\u80C3\u3067\u767A\u9175\u3055\u305B\u308B\u3053\u3068\u306B\u3088\u308A\u3001\u690D\u7269\u30D9\u30FC\u30B9\u306E\u98DF\u7269\u304B\u3089\u6804\u990A\u7D20\u3092\u53D6\u5F97\u3067\u304D\u308B\u8349\u98DF\u6027\u306E\u8349\u98DF\u307E\u305F\u306F\u95B2\u89A7\u3059\u308B\u6709\u8E44\u52D5\u7269\u3067\u3059\u3002","cow":"\u725B","goat":"\u30E4\u30AE","chicken":"\u9D8F","sheep":"\u7F8A","color":"Adobe \u8272","colorError":"\u6709\u52B9\u306A Adob\u200B\u200Be \u30AB\u30E9\u30FC\u3067\u306F\u3042\u308A\u307E\u305B\u3093","farmAnimalCount":"\u5BB6\u755C\u6570","farmCountError":"\u6709\u52B9\u306A\u756A\u53F7\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044","notRuminatError":"\u3053\u306E\u52D5\u7269\u306F\u53CD\u82BB\u52D5\u7269\u3067\u306F\u3042\u308A\u307E\u305B\u3093","ageRange":"\u5E74\u9F62\u5C64","cheeseSearch":"\u30C1\u30FC\u30BA\u691C\u7D22","findCheese":"\u6709\u52B9\u306A\u30C1\u30FC\u30BA\u3092\u5165\u529B\u3057\u3066\u3001\u8D77\u6E90\u3001\u6B74\u53F2\u3001\u30EC\u30B7\u30D4\u3092\u691C\u7D22\u3057\u3066\u304F\u3060\u3055\u3044\u3002","farmScore":"\u8FB2\u5834\u30B9\u30B3\u30A2","amHappy":"\u5E78\u305B\u3067\u3059\u304B\uFF1F","clients":"\u30AF\u30E9\u30A4\u30A2\u30F3\u30C8\u4E00\u89A7","clientsError":"\u9867\u5BA2\u30EA\u30B9\u30C8\u3092\u5165\u529B\u3057\u307E\u3059\u3002","clientHeading":"\u30AF\u30E9\u30A4\u30A2\u30F3\u30C8\u30EA\u30B9\u30C8","clientContent":"\u3059\u3079\u3066\u306E\u30AF\u30E9\u30A4\u30A2\u30F3\u30C8\u306E\u30AB\u30F3\u30DE\u533A\u5207\u308A\u30EA\u30B9\u30C8\u3002","farmName":"\u8FB2\u5834\u540D","brownFenceFarm":"\u30D6\u30E9\u30A6\u30F3 \u30D5\u30A7\u30F3\u30B9 \u30D5\u30A1\u30FC\u30E0","farmDescription":"\u8FB2\u5834\u306E\u540D\u524D\u3092\u5165\u529B\u3057\u307E\u3059\u3002","farmTitle":"\u8FB2\u5834\u306E\u6B63\u5F0F\u540D\u79F0","farmLegal":"\u3053\u308C\u306F\u8FB2\u5834\u306E\u6B63\u5F0F\u306A\u540D\u524D\u3067\u3042\u308A\u3001\u30A8\u30A4\u30EA\u30A2\u30B9\u3084\u30DE\u30FC\u30B1\u30C6\u30A3\u30F3\u30B0\u540D\u3067\u306F\u3042\u308A\u307E\u305B\u3093\u3002"},"ko-KR":{"ruminants":"\uBC18\uCD94 \uB3D9\uBB3C","areRuminats":"\uC774\uB4E4\uC740 \uBC18\uCD94 \uB3D9\uBB3C\uC785\uB2C8\uB2E4.","whatIsARuminat":"\uBC18\uCD94\uB3D9\uBB3C\uC774\uB780?","ruminatDefinition":"\uBC18\uCD94\uB3D9\uBB3C\uC740 \uBC1C\uAD7D\uC774 \uC788\uB294 \uCD08\uC2DD\uC131 \uBC29\uBAA9 \uB610\uB294 \uBE0C\uB77C\uC6B0\uC9D5 \uD3EC\uC720\uB958\uB85C, \uC8FC\uB85C \uBBF8\uC0DD\uBB3C \uC791\uC6A9\uC744 \uD1B5\uD574 \uC18C\uD654\uD558\uAE30 \uC804\uC5D0 \uD2B9\uC218 \uC704\uC7A5\uC5D0\uC11C \uC2DD\uBB3C\uC131 \uC2DD\uD488\uC744 \uBC1C\uD6A8\uC2DC\uCF1C \uC601\uC591\uBD84\uC744 \uC5BB\uC744 \uC218 \uC788\uC2B5\uB2C8\uB2E4.","cow":"\uC554\uC18C","goat":"\uC5FC\uC18C","chicken":"\uB2ED","sheep":"\uC591","color":"Adobe \uC0C9\uC0C1","colorError":"\uC720\uD6A8\uD55C Adobe \uC0C9\uC0C1\uC774 \uC544\uB2D9\uB2C8\uB2E4.","farmAnimalCount":"\uB18D\uC7A5 \uB3D9\uBB3C \uC218","farmCountError":"\uC720\uD6A8\uD55C \uBC88\uD638\uB97C \uC120\uD0DD\uD558\uC138\uC694","notRuminatError":"\uC774 \uB3D9\uBB3C\uC740 \uBC18\uCD94 \uB3D9\uBB3C\uC774 \uC544\uB2D9\uB2C8\uB2E4.","ageRange":"\uC5F0\uB839\uB300","cheeseSearch":"\uCE58\uC988 \uAC80\uC0C9","findCheese":"\uC6D0\uC0B0\uC9C0, \uC5ED\uC0AC \uBC0F \uC870\uB9AC\uBC95\uC744 \uCC3E\uC73C\uB824\uBA74 \uC720\uD6A8\uD55C \uCE58\uC988\uB97C \uC785\uB825\uD558\uC2ED\uC2DC\uC624.","farmScore":"\uB18D\uC7A5 \uC810\uC218","amHappy":"\uD589\uBCF5\uD558\uB2C8?","clients":"\uD074\uB77C\uC774\uC5B8\uD2B8 \uBAA9\uB85D","clientsError":"\uD074\uB77C\uC774\uC5B8\uD2B8 \uBAA9\uB85D\uC744 \uC785\uB825\uD558\uC2ED\uC2DC\uC624.","clientHeading":"\uD074\uB77C\uC774\uC5B8\uD2B8 \uBAA9\uB85D","clientContent":"\uBAA8\uB4E0 \uD074\uB77C\uC774\uC5B8\uD2B8\uC758 \uC27C\uD45C\uB85C \uAD6C\uBD84\uB41C \uBAA9\uB85D\uC785\uB2C8\uB2E4.","farmName":"\uB18D\uC7A5 \uC774\uB984","brownFenceFarm":"\uAC08\uC0C9 \uC6B8\uD0C0\uB9AC \uB18D\uC7A5","farmDescription":"\uB18D\uC7A5 \uC774\uB984\uC744 \uC785\uB825\uD558\uC138\uC694.","farmTitle":"\uB18D\uC7A5\uC758 \uBC95\uC801 \uC774\uB984","farmLegal":"\uBCC4\uCE6D\uC774\uB098 \uB9C8\uCF00\uD305 \uC774\uB984\uC774 \uC544\uB2C8\uB77C \uD31C\uC758 \uBC95\uC801 \uC774\uB984\uC774\uC5B4\uC57C \uD569\uB2C8\uB2E4."},"zh-CN":{"ruminants":"\u53CD\u520D\u52A8\u7269","areRuminats":"\u8FD9\u4E9B\u662F\u53CD\u520D\u52A8\u7269\u3002","whatIsARuminat":"\u4EC0\u4E48\u662F\u53CD\u520D\u52A8\u7269\uFF1F","ruminatDefinition":"\u53CD\u520D\u52A8\u7269\u662F\u6709\u8E44\u7684\u8349\u98DF\u6027\u98DF\u8349\u6216\u6D4F\u89C8\u54FA\u4E73\u52A8\u7269\uFF0C\u5B83\u4EEC\u80FD\u591F\u901A\u8FC7\u5728\u6D88\u5316\u524D\u5728\u4E13\u95E8\u7684\u80C3\u4E2D\u53D1\u9175\u6765\u4ECE\u690D\u7269\u6027\u98DF\u7269\u4E2D\u83B7\u53D6\u8425\u517B\uFF0C\u4E3B\u8981\u662F\u901A\u8FC7\u5FAE\u751F\u7269\u4F5C\u7528\u3002","cow":"\u5976\u725B","goat":"\u5C71\u7F8A","chicken":"\u9E21","sheep":"\u7F8A","color":"Adobe \u989C\u8272","colorError":"\u4E0D\u662F\u6709\u6548\u7684 Adob\u200B\u200Be \u989C\u8272","farmAnimalCount":"\u519C\u573A\u52A8\u7269\u6570\u91CF","farmCountError":"\u9009\u62E9\u4E00\u4E2A\u6709\u6548\u7684\u53F7\u7801","notRuminatError":"\u8FD9\u79CD\u52A8\u7269\u4E0D\u662F\u53CD\u520D\u52A8\u7269\u3002","ageRange":"\u5E74\u9F84\u8303\u56F4","cheeseSearch":"\u5976\u916A\u641C\u7D22","findCheese":"\u8F93\u5165\u6709\u6548\u7684\u5976\u916A\u4EE5\u67E5\u627E\u4EA7\u5730\u3001\u5386\u53F2\u548C\u914D\u65B9\u3002","farmScore":"\u519C\u573A\u5206\u6570","amHappy":"\u4F60\u5FEB\u4E50\u5417\uFF1F","clients":"\u5BA2\u6237\u540D\u5355","clientsError":"\u8F93\u5165\u5BA2\u6237\u540D\u5355\u3002","clientHeading":"\u5BA2\u6237\u540D\u5355","clientContent":"\u6240\u6709\u5BA2\u6237\u7AEF\u7684\u9017\u53F7\u5206\u9694\u5217\u8868\u3002","farmName":"\u519C\u573A\u540D\u79F0","brownFenceFarm":"\u5E03\u6717\u6805\u680F\u519C\u573A","farmDescription":"\u8F93\u5165\u60A8\u519C\u573A\u7684\u540D\u79F0\u3002","farmTitle":"\u519C\u573A\u7684\u6CD5\u5B9A\u540D\u79F0","farmLegal":"\u8FD9\u5E94\u8BE5\u662F\u519C\u573A\u7684\u6CD5\u5B9A\u540D\u79F0\uFF0C\u800C\u4E0D\u662F\u522B\u540D\u6216\u8425\u9500\u540D\u79F0\u3002"},"zh-TW":{"ruminants":"\u53CD\u82BB\u52D5\u7269","areRuminats":"\u9019\u4E9B\u662F\u53CD\u82BB\u52D5\u7269\u3002","whatIsARuminat":"\u4EC0\u9EBC\u662F\u53CD\u82BB\u52D5\u7269\uFF1F","ruminatDefinition":"\u53CD\u82BB\u52D5\u7269\u662F\u6709\u8E44\u7684\u8349\u98DF\u6027\u98DF\u8349\u6216\u700F\u89BD\u54FA\u4E73\u52D5\u7269\uFF0C\u5B83\u5011\u80FD\u5920\u901A\u904E\u5728\u6D88\u5316\u524D\u5728\u5C08\u9580\u7684\u80C3\u4E2D\u767C\u9175\u4F86\u5F9E\u690D\u7269\u6027\u98DF\u7269\u4E2D\u7372\u53D6\u71DF\u990A\uFF0C\u4E3B\u8981\u662F\u901A\u904E\u5FAE\u751F\u7269\u4F5C\u7528\u3002","cow":"\u5976\u725B","goat":"\u5C71\u7F8A","chicken":"\u96DE","sheep":"\u7F8A","color":"Adobe \u984F\u8272","colorError":"\u4E0D\u662F\u6709\u6548\u7684 Adob\u200B\u200Be \u984F\u8272","farmAnimalCount":"\u8FB2\u5834\u52D5\u7269\u6578\u91CF","farmCountError":"\u9078\u64C7\u4E00\u500B\u6709\u6548\u7684\u865F\u78BC","notRuminatError":"\u9019\u7A2E\u52D5\u7269\u4E0D\u662F\u53CD\u82BB\u52D5\u7269\u3002","ageRange":"\u5E74\u9F61\u7BC4\u570D","cheeseSearch":"\u5976\u916A\u641C\u7D22","findCheese":"\u8F38\u5165\u6709\u6548\u7684\u5976\u916A\u4EE5\u67E5\u627E\u7522\u5730\u3001\u6B77\u53F2\u548C\u914D\u65B9\u3002","farmScore":"\u8FB2\u5834\u5206\u6578","amHappy":"\u4F60\u5FEB\u6A02\u55CE\uFF1F","clients":"\u5BA2\u6236\u540D\u55AE","clientsError":"\u8F38\u5165\u5BA2\u6236\u540D\u55AE\u3002","clientHeading":"\u5BA2\u6236\u540D\u55AE","clientContent":"\u6240\u6709\u5BA2\u6236\u7AEF\u7684\u9017\u865F\u5206\u9694\u5217\u8868\u3002","farmName":"\u8FB2\u5834\u540D\u7A31","brownFenceFarm":"\u5E03\u6717\u67F5\u6B04\u8FB2\u5834","farmDescription":"\u8F38\u5165\u60A8\u8FB2\u5834\u7684\u540D\u7A31\u3002","farmTitle":"\u8FB2\u5834\u7684\u6CD5\u5B9A\u540D\u7A31","farmLegal":"\u9019\u61C9\u8A72\u662F\u8FB2\u5834\u7684\u6CD5\u5B9A\u540D\u7A31\uFF0C\u800C\u4E0D\u662F\u5225\u540D\u6216\u71DF\u92B7\u540D\u7A31\u3002"}}');

},{}],"cPEjS":[function(require,module,exports) {
module.exports["spectrum"] = `_5cHwvW_spectrum`;
module.exports["spectrum-Article"] = `_5cHwvW_spectrum-Article`;
module.exports["spectrum-Body"] = `_5cHwvW_spectrum-Body`;
module.exports["spectrum-Body--italic"] = `_5cHwvW_spectrum-Body--italic`;
module.exports["spectrum-Body--large"] = `_5cHwvW_spectrum-Body--large`;
module.exports["spectrum-Body--secondary"] = `_5cHwvW_spectrum-Body--secondary`;
module.exports["spectrum-Body--small"] = `_5cHwvW_spectrum-Body--small`;
module.exports["spectrum-Body1"] = `_5cHwvW_spectrum-Body1`;
module.exports["spectrum-Body2"] = `_5cHwvW_spectrum-Body2`;
module.exports["spectrum-Body3"] = `_5cHwvW_spectrum-Body3`;
module.exports["spectrum-Body4"] = `_5cHwvW_spectrum-Body4`;
module.exports["spectrum-Body5"] = `_5cHwvW_spectrum-Body5`;
module.exports["spectrum-Code1"] = `_5cHwvW_spectrum-Code1`;
module.exports["spectrum-Code2"] = `_5cHwvW_spectrum-Code2`;
module.exports["spectrum-Code3"] = `_5cHwvW_spectrum-Code3`;
module.exports["spectrum-Code4"] = `_5cHwvW_spectrum-Code4`;
module.exports["spectrum-Code5"] = `_5cHwvW_spectrum-Code5`;
module.exports["spectrum-Detail"] = `_5cHwvW_spectrum-Detail`;
module.exports["spectrum-Heading--display"] = `_5cHwvW_spectrum-Heading--display`;
module.exports["spectrum-Heading--pageTitle"] = `_5cHwvW_spectrum-Heading--pageTitle`;
module.exports["spectrum-Heading--subtitle1"] = `_5cHwvW_spectrum-Heading--subtitle1`;
module.exports["spectrum-Heading--subtitle2"] = `_5cHwvW_spectrum-Heading--subtitle2`;
module.exports["spectrum-Heading--subtitle3"] = `_5cHwvW_spectrum-Heading--subtitle3`;
module.exports["spectrum-Heading1"] = `_5cHwvW_spectrum-Heading1`;
module.exports["spectrum-Heading1--display"] = `_5cHwvW_spectrum-Heading1--display`;
module.exports["spectrum-Heading1--quiet"] = `_5cHwvW_spectrum-Heading1--quiet`;
module.exports["spectrum-Heading1--strong"] = `_5cHwvW_spectrum-Heading1--strong`;
module.exports["spectrum-Heading2"] = `_5cHwvW_spectrum-Heading2`;
module.exports["spectrum-Heading2--display"] = `_5cHwvW_spectrum-Heading2--display`;
module.exports["spectrum-Heading2--quiet"] = `_5cHwvW_spectrum-Heading2--quiet`;
module.exports["spectrum-Heading2--strong"] = `_5cHwvW_spectrum-Heading2--strong`;
module.exports["spectrum-Heading3"] = `_5cHwvW_spectrum-Heading3`;
module.exports["spectrum-Heading4"] = `_5cHwvW_spectrum-Heading4`;
module.exports["spectrum-Heading5"] = `_5cHwvW_spectrum-Heading5`;
module.exports["spectrum-Heading6"] = `_5cHwvW_spectrum-Heading6`;
module.exports["spectrum-Subheading"] = `_5cHwvW_spectrum-Subheading`;
module.exports["spectrum-Typography"] = `_5cHwvW_spectrum-Typography`;

},{}],"5yi5z":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ExcitingSquare", ()=>ExcitingSquare);
var _ = require("../");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
exports.default = {
    title: "Icons/Custom",
    providerSwitcher: {
        status: "positive"
    }
};
const ExcitingSquare = ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Icon), null, /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        viewBox: "0 0 25 25"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("rect", {
        x: "0",
        y: "0",
        width: "25",
        height: "25"
    })));
ExcitingSquare.story = {
    name: "exciting square"
};

},{"../":"5mO6x","react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"5mO6x":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _src = require("./src");
parcelHelpers.exportAll(_src, exports);

},{"./src":"k7wem","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"6RGZn":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_NotFound", ()=>_NotFound);
parcelHelpers.export(exports, "NoHeadingOrDescription", ()=>NoHeadingOrDescription);
var _view = require("@react-spectrum/view");
var _text = require("@react-spectrum/text");
var _ = require("../");
var _notFound = require("@spectrum-icons/illustrations/NotFound");
var _notFoundDefault = parcelHelpers.interopDefault(_notFound);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
let meta = {
    title: "IllustratedMessage",
    component: (0, _.IllustratedMessage)
};
exports.default = meta;
const _NotFound = {
    args: {
        children: /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _notFoundDefault.default), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Heading), null, "Error 404: Page not found"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Content), null, "This page isn\u2019t available. Try checking the URL or visit a different page."))
    },
    name: "Not Found"
};
const NoHeadingOrDescription = {
    args: {
        children: /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _notFoundDefault.default), {
            "aria-label": "No Results"
        })
    }
};

},{"@react-spectrum/view":"dnRjt","@react-spectrum/text":"etCGI","../":"euZBS","@spectrum-icons/illustrations/NotFound":"ev5ep","react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"euZBS":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _src = require("./src");
parcelHelpers.exportAll(_src, exports);

},{"./src":"cV05z","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"9v27c":[function(require,module,exports) {
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Default", ()=>Default);
parcelHelpers.export(exports, "Dynamic", ()=>Dynamic);
var _button = require("@react-spectrum/button");
var _view = require("@react-spectrum/view");
var _text = require("@react-spectrum/text");
var _ = require("../");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const meta = {
    title: "InlineAlert",
    component: (0, _.InlineAlert),
    args: {
        title: "Title",
        content: "Content"
    },
    argTypes: {
        variant: {
            control: "select",
            options: [
                "neutral",
                "info",
                "positive",
                "notice",
                "negative"
            ]
        },
        title: {
            control: "text"
        },
        content: {
            control: "text"
        }
    }
};
exports.default = meta;
const Default = {
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.InlineAlert), args, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Heading), null, args.title), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Content), null, args.content))
};
const Dynamic = {
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(DynamicExample, args)
};
function DynamicExample(args) {
    let [shown, setShown] = (0, _react.useState)(false);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.Button), {
        variant: "primary",
        onPress: ()=>setShown(!shown)
    }, shown ? "Hide Alert" : "Show Alert"), shown && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.InlineAlert), {
        ...args,
        autoFocus: true
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Heading), null, args.title), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Content), null, args.content)));
}

},{"@react-spectrum/button":"jZWyP","@react-spectrum/view":"dnRjt","@react-spectrum/text":"etCGI","../":"ew9vI","react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"ew9vI":[function(require,module,exports) {
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _src = require("./src");
parcelHelpers.exportAll(_src, exports);

},{"./src":"5XTuR","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"foTZt":[function(require,module,exports) {
/*
 * Copyright 2021 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Default", ()=>Default);
parcelHelpers.export(exports, "WithState", ()=>WithState);
parcelHelpers.export(exports, "AriaLabel", ()=>AriaLabel);
parcelHelpers.export(exports, "DescriptionAndCustomDescription", ()=>DescriptionAndCustomDescription);
parcelHelpers.export(exports, "AriaLabelWithDynamicHelpText", ()=>AriaLabelWithDynamicHelpText);
var _layout = require("@react-spectrum/layout");
var _radio = require("@react-spectrum/radio");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _textfield = require("@react-spectrum/textfield");
const argTypes = {
    label: {
        control: "text"
    },
    description: {
        control: "text"
    },
    errorMessage: {
        control: "text"
    },
    validationState: {
        control: "radio",
        options: [
            "invalid",
            "valid"
        ]
    },
    isDisabled: {
        control: "boolean"
    },
    labelAlign: {
        control: "radio",
        options: [
            "end",
            "start"
        ]
    },
    labelPosition: {
        control: "radio",
        options: [
            "side",
            "top"
        ]
    },
    width: {
        control: "radio",
        options: [
            "100px",
            "440px",
            "var(--spectrum-global-dimension-top, var(--spectrum-alias-top))"
        ]
    }
};
exports.default = {
    title: "HelpText",
    component: (0, _textfield.TextField),
    args: {
        label: "Password",
        description: "Password must be at least 8 characters."
    },
    argTypes: argTypes
};
let Default = {};
let WithState = {
    args: {
        label: "Empty field",
        description: "This input is only valid when it's empty.",
        errorMessage: "Remove input."
    },
    argTypes: {
        validationState: {
            control: {
                disable: true
            }
        }
    },
    render: (props)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(TextFieldWithValidationState, props)
};
let AriaLabel = {
    args: {
        label: null,
        "aria-label": "Password"
    },
    argTypes: {
        label: {
            control: {
                disable: true
            }
        },
        "aria-label": {
            control: "text"
        }
    }
};
const DescriptionAndCustomDescription = {
    args: {
        customDescription: "Custom description.",
        "aria-describedby": "custom-description"
    },
    argTypes: {
        customDescription: {
            control: "text"
        },
        "aria-describedby": {
            control: {
                disable: true
            }
        }
    },
    decorators: [
        (Story, Context)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
                direction: "column",
                gap: "size-125"
            }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Story, null), /*#__PURE__*/ (0, _reactDefault.default).createElement("p", {
                id: Context.args["aria-describedby"]
            }, Context.args.customDescription))
    ]
};
let AriaLabelWithDynamicHelpText = {
    args: {
        label: null,
        "aria-label": "Password",
        description: undefined
    },
    render: (props)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(TextFieldWithAriaLabelAndDynamicHelpText, props),
    parameters: {
        description: {
            data: "For the case when there is no label and help text is added or removed dynamically. Focus should remain in the text field as the user types and the help text gets added or removed."
        }
    }
};
function TextFieldWithValidationState(props) {
    let [value, setValue] = (0, _react.useState)("");
    let [valid, setValid] = (0, _react.useState)(undefined);
    let validState;
    if (value.length) validState = "invalid";
    else if (valid === "valid") validState = "valid";
    else validState = undefined;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
        direction: "column",
        gap: "size-200"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textfield.TextField), {
        ...props,
        value: value,
        onChange: setValue,
        validationState: validState
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _radio.RadioGroup), {
        label: "Valid State",
        value: valid ? valid : "",
        onChange: setValid
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _radio.Radio), {
        value: "valid"
    }, "Valid"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _radio.Radio), {
        value: ""
    }, "undefined")));
}
function TextFieldWithAriaLabelAndDynamicHelpText(props) {
    let [value, setValue] = (0, _react.useState)("");
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textfield.TextField), {
        ...props,
        value: value,
        onChange: setValue,
        validationState: value.length ? "invalid" : undefined,
        errorMessage: "Invalid length."
    });
}

},{"@react-spectrum/layout":"hzaUY","@react-spectrum/radio":"gbtGh","react":"9yzVZ","@react-spectrum/textfield":"hOmtq","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"eAZ1D":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Default", ()=>Default);
parcelHelpers.export(exports, "WidthForLabelAlignSide", ()=>WidthForLabelAlignSide);
var _ = require("../");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _textfield = require("@react-spectrum/textfield");
const argTypes = {
    labelAlign: {
        control: "radio",
        options: [
            "end",
            "start"
        ]
    },
    labelPosition: {
        control: "radio",
        options: [
            "side",
            "top"
        ]
    },
    necessityIndicator: {
        control: "radio",
        options: [
            "icon",
            "label"
        ]
    },
    isRequired: {
        control: "boolean"
    },
    htmlFor: {
        control: {
            disable: true
        }
    }
};
exports.default = {
    title: "Label",
    component: (0, _.Label),
    args: {
        width: "100%",
        htmlFor: "test",
        children: "Test"
    },
    argTypes: argTypes,
    decorators: [
        (Story, Context)=>/*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
                style: {
                    whiteSpace: "nowrap"
                }
            }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Story, null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textfield.TextField), {
                id: Context.args.htmlFor,
                isRequired: Context.args.isRequired
            }))
    ]
};
let Default = {};
let WidthForLabelAlignSide = {
    args: {
        width: "80px",
        labelPosition: "side"
    },
    argTypes: {
        labelPosition: {
            control: {
                disable: true
            }
        }
    }
};

},{"../":"5A7mA","react":"9yzVZ","@react-spectrum/textfield":"hOmtq","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"5A7mA":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _src = require("./src");
parcelHelpers.exportAll(_src, exports);

},{"./src":"6qv6N","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"6AFCA":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Default", ()=>Default);
parcelHelpers.export(exports, "StringArray", ()=>StringArray);
parcelHelpers.export(exports, "CalendarDateType", ()=>CalendarDateType);
parcelHelpers.export(exports, "CalendarDateTimeType", ()=>CalendarDateTimeType);
parcelHelpers.export(exports, "CalendarDateTimeTypeFormatOptions", ()=>CalendarDateTimeTypeFormatOptions);
parcelHelpers.export(exports, "ZonedDateTimeType", ()=>ZonedDateTimeType);
parcelHelpers.export(exports, "DateType", ()=>DateType);
parcelHelpers.export(exports, "TimeType", ()=>TimeType);
parcelHelpers.export(exports, "CalendarDateRange", ()=>CalendarDateRange);
parcelHelpers.export(exports, "CalendarDateTimeRange", ()=>CalendarDateTimeRange);
parcelHelpers.export(exports, "ZonedDateTimeRange", ()=>ZonedDateTimeRange);
parcelHelpers.export(exports, "DateRange", ()=>DateRange);
parcelHelpers.export(exports, "TimeRange", ()=>TimeRange);
parcelHelpers.export(exports, "Number", ()=>Number);
parcelHelpers.export(exports, "NumberRange", ()=>NumberRange);
parcelHelpers.export(exports, "WithContextualHelp", ()=>WithContextualHelp);
var _date = require("@internationalized/date");
var _view = require("@react-spectrum/view");
var _contextualhelp = require("@react-spectrum/contextualhelp");
var _text = require("@react-spectrum/text");
var _ = require("..");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
exports.default = {
    title: "LabeledValue",
    component: (0, _.LabeledValue),
    argTypes: {
        labelPosition: {
            control: {
                type: "radio",
                options: [
                    null,
                    "top",
                    "side"
                ]
            }
        },
        labelAlign: {
            control: {
                type: "radio",
                options: [
                    "start",
                    "end"
                ]
            }
        },
        width: {
            control: {
                type: "radio",
                options: [
                    null,
                    "300px",
                    "600px"
                ]
            }
        }
    }
};
let Default = {
    args: {
        label: "Test",
        value: "foo ".repeat(20)
    },
    name: "String"
};
let StringArray = {
    args: {
        label: "Test",
        value: [
            "wow",
            "cool",
            "awesome"
        ]
    },
    name: "String array"
};
let CalendarDateType = {
    args: {
        label: "Test",
        value: new (0, _date.CalendarDate)(2019, 6, 5)
    },
    name: "CalendarDate"
};
let CalendarDateTimeType = {
    args: {
        label: "Test",
        value: new (0, _date.CalendarDateTime)(2020, 2, 3, 12, 23, 24, 120)
    },
    name: "CalendarDateTime"
};
let CalendarDateTimeTypeFormatOptions = {
    args: {
        label: "Test",
        value: new (0, _date.CalendarDateTime)(2020, 2, 3, 12, 23, 24, 120),
        formatOptions: {
            dateStyle: "short",
            timeStyle: "short"
        }
    },
    name: "CalendarDateTime with formatOptions"
};
let ZonedDateTimeType = {
    args: {
        label: "Test",
        value: new (0, _date.ZonedDateTime)(2020, 2, 3, "America/Los_Angeles", -28800000)
    },
    name: "ZonedDateTime"
};
let DateType = {
    args: {
        label: "Test",
        value: new Date(2000, 5, 5)
    },
    name: "Date"
};
let TimeType = {
    args: {
        label: "Test",
        value: new (0, _date.Time)(9, 45)
    },
    name: "Time"
};
let CalendarDateRange = {
    args: {
        label: "Test",
        value: {
            start: new (0, _date.CalendarDate)(2019, 6, 5),
            end: new (0, _date.CalendarDate)(2019, 7, 5)
        }
    },
    name: "RangeValue<CalendarDate>"
};
let CalendarDateTimeRange = {
    args: {
        label: "Test",
        value: {
            start: new (0, _date.CalendarDateTime)(2020, 2, 3, 12, 23, 24, 120),
            end: new (0, _date.CalendarDateTime)(2020, 3, 3, 12, 23, 24, 120)
        }
    },
    name: "RangeValue<CalendarDateTime>"
};
let ZonedDateTimeRange = {
    args: {
        label: "Test",
        value: {
            start: new (0, _date.ZonedDateTime)(2020, 2, 3, "America/Los_Angeles", -28800000),
            end: new (0, _date.ZonedDateTime)(2020, 3, 3, "America/Los_Angeles", -28800000)
        }
    },
    name: "RangeValue<ZonedDateTime>"
};
let DateRange = {
    args: {
        label: "Test",
        value: {
            start: new Date(2019, 6, 5),
            end: new Date(2019, 6, 10)
        }
    },
    name: "RangeValue<Date>"
};
let TimeRange = {
    args: {
        label: "Test",
        value: {
            start: new (0, _date.Time)(9, 45),
            end: new (0, _date.Time)(10, 50)
        }
    },
    name: "RangeValue<Time>"
};
let Number = {
    args: {
        label: "Test",
        value: 10
    },
    name: "Number"
};
let NumberRange = {
    args: {
        label: "Test",
        value: {
            start: 10,
            end: 20
        }
    },
    name: "RangeValue<Number>"
};
let WithContextualHelp = {
    args: {
        label: "Test",
        value: 25,
        contextualHelp: /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _contextualhelp.ContextualHelp), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Heading), null, "What is a segment?"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Content), null, "Segments identify who your visitors are, what devices and services they use, where they navigated from, and much more."))
    },
    name: "contextual help"
};

},{"@internationalized/date":"hesBk","@react-spectrum/view":"dnRjt","@react-spectrum/contextualhelp":"jA6za","@react-spectrum/text":"etCGI","..":"bBv9l","react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"bBv9l":[function(require,module,exports) {
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _src = require("./src");
parcelHelpers.exportAll(_src, exports);

},{"./src":"cPWzw","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"lVcgH":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "VerticalStackWithGap", ()=>VerticalStackWithGap);
parcelHelpers.export(exports, "HorizontalStackWithGap", ()=>HorizontalStackWithGap);
parcelHelpers.export(exports, "WrappingWithGap", ()=>WrappingWithGap);
parcelHelpers.export(exports, "NestedFlexWithGap", ()=>NestedFlexWithGap);
parcelHelpers.export(exports, "AlignCenter", ()=>AlignCenter);
parcelHelpers.export(exports, "AlignEnd", ()=>AlignEnd);
parcelHelpers.export(exports, "JustifyStart", ()=>JustifyStart);
parcelHelpers.export(exports, "JustifyCenter", ()=>JustifyCenter);
parcelHelpers.export(exports, "JustifyEnd", ()=>JustifyEnd);
parcelHelpers.export(exports, "JustifySpaceAround", ()=>JustifySpaceAround);
parcelHelpers.export(exports, "JustifySpaceBetween", ()=>JustifySpaceBetween);
parcelHelpers.export(exports, "JustifySpaceEvenly", ()=>JustifySpaceEvenly);
parcelHelpers.export(exports, "Ordered", ()=>Ordered);
parcelHelpers.export(exports, "Responsive", ()=>Responsive);
var _layout = require("@react-spectrum/layout");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _view = require("@react-spectrum/view");
let baseColors = [
    "celery",
    "chartreuse",
    "yellow",
    "magenta",
    "fuchsia",
    "purple",
    "indigo",
    "seafoam",
    "red",
    "orange",
    "green",
    "blue"
];
let colors = [];
for (let color of baseColors)for(let i = 4; i <= 7; i++)colors.push(`${color}-${i}00`);
exports.default = {
    title: "Flex"
};
const VerticalStackWithGap = ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
        direction: "column",
        width: "size-2000",
        gap: "size-100"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.View), {
        backgroundColor: "celery-600",
        height: "size-800"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.View), {
        backgroundColor: "blue-600",
        height: "size-800"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.View), {
        backgroundColor: "magenta-600",
        height: "size-800"
    }));
VerticalStackWithGap.story = {
    name: "Vertical stack with gap"
};
const HorizontalStackWithGap = ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
        direction: "row",
        height: "size-800",
        gap: "size-100"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.View), {
        backgroundColor: "celery-600",
        width: "size-800"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.View), {
        backgroundColor: "blue-600",
        width: "size-800"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.View), {
        backgroundColor: "magenta-600",
        width: "size-800"
    }));
HorizontalStackWithGap.story = {
    name: "Horizontal stack with gap"
};
const WrappingWithGap = ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.View), {
        maxWidth: "80%",
        borderWidth: "thin",
        borderColor: "dark"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
        direction: "row",
        gap: "size-100",
        wrap: true
    }, colors.map((color)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.View), {
            key: color,
            backgroundColor: color,
            width: "size-800",
            height: "size-800"
        }))));
WrappingWithGap.story = {
    name: "Wrapping with gap"
};
const NestedFlexWithGap = ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
        direction: "column",
        gap: "size-150"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.View), {
        backgroundColor: "celery-600",
        height: "size-800"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
        direction: "row",
        height: "size-800",
        gap: "size-100"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.View), {
        backgroundColor: "indigo-600",
        width: "size-800"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.View), {
        backgroundColor: "seafoam-600",
        width: "size-800"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.View), {
        backgroundColor: "blue-600",
        width: "size-800"
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.View), {
        backgroundColor: "magenta-600",
        height: "size-800"
    }));
NestedFlexWithGap.story = {
    name: "Nested flex with gap"
};
const AlignCenter = ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
        direction: "row",
        gap: "size-100",
        alignItems: "center"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.View), {
        backgroundColor: "celery-600",
        width: "size-800",
        height: "size-800"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.View), {
        backgroundColor: "blue-600",
        width: "size-800",
        height: "size-2000"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.View), {
        backgroundColor: "magenta-600",
        width: "size-800",
        height: "size-800"
    }));
AlignCenter.story = {
    name: "Align center"
};
const AlignEnd = ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
        direction: "row",
        gap: "size-100",
        alignItems: "end"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.View), {
        backgroundColor: "celery-600",
        width: "size-800",
        height: "size-800"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.View), {
        backgroundColor: "blue-600",
        width: "size-800",
        height: "size-2000"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.View), {
        backgroundColor: "magenta-600",
        width: "size-800",
        height: "size-800"
    }));
AlignEnd.story = {
    name: "Align end"
};
const JustifyStart = ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
        direction: "row",
        gap: "size-100",
        justifyContent: "start",
        width: "80%"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.View), {
        backgroundColor: "celery-600",
        width: "size-800",
        height: "size-800"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.View), {
        backgroundColor: "blue-600",
        width: "size-800",
        height: "size-800"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.View), {
        backgroundColor: "magenta-600",
        width: "size-800",
        height: "size-800"
    }));
JustifyStart.story = {
    name: "Justify start"
};
const JustifyCenter = ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
        direction: "row",
        gap: "size-100",
        justifyContent: "center",
        width: "80%"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.View), {
        backgroundColor: "celery-600",
        width: "size-800",
        height: "size-800"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.View), {
        backgroundColor: "blue-600",
        width: "size-800",
        height: "size-800"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.View), {
        backgroundColor: "magenta-600",
        width: "size-800",
        height: "size-800"
    }));
JustifyCenter.story = {
    name: "Justify center"
};
const JustifyEnd = ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
        direction: "row",
        gap: "size-100",
        justifyContent: "end",
        width: "80%"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.View), {
        backgroundColor: "celery-600",
        width: "size-800",
        height: "size-800"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.View), {
        backgroundColor: "blue-600",
        width: "size-800",
        height: "size-800"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.View), {
        backgroundColor: "magenta-600",
        width: "size-800",
        height: "size-800"
    }));
JustifyEnd.story = {
    name: "Justify end"
};
const JustifySpaceAround = ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
        direction: "row",
        gap: "size-100",
        justifyContent: "space-around",
        width: "80%"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.View), {
        backgroundColor: "celery-600",
        width: "size-800",
        height: "size-800"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.View), {
        backgroundColor: "blue-600",
        width: "size-800",
        height: "size-800"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.View), {
        backgroundColor: "magenta-600",
        width: "size-800",
        height: "size-800"
    }));
JustifySpaceAround.story = {
    name: "Justify space-around"
};
const JustifySpaceBetween = ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
        direction: "row",
        gap: "size-100",
        justifyContent: "space-between",
        width: "80%"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.View), {
        backgroundColor: "celery-600",
        width: "size-800",
        height: "size-800"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.View), {
        backgroundColor: "blue-600",
        width: "size-800",
        height: "size-800"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.View), {
        backgroundColor: "magenta-600",
        width: "size-800",
        height: "size-800"
    }));
JustifySpaceBetween.story = {
    name: "Justify space-between"
};
const JustifySpaceEvenly = ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
        direction: "row",
        gap: "size-100",
        justifyContent: "space-evenly",
        width: "80%"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.View), {
        backgroundColor: "celery-600",
        width: "size-800",
        height: "size-800"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.View), {
        backgroundColor: "blue-600",
        width: "size-800",
        height: "size-800"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.View), {
        backgroundColor: "magenta-600",
        width: "size-800",
        height: "size-800"
    }));
JustifySpaceEvenly.story = {
    name: "Justify space-evenly"
};
const Ordered = ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
        direction: "row",
        gap: "size-100",
        justifyContent: "space-evenly",
        width: "80%"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.View), {
        backgroundColor: "celery-600",
        order: 2,
        width: "size-800",
        height: "size-800"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.View), {
        backgroundColor: "blue-600",
        width: "size-800",
        height: "size-800"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.View), {
        backgroundColor: "magenta-600",
        order: 1,
        width: "size-800",
        height: "size-800"
    }));
Ordered.story = {
    name: "ordered"
};
const Responsive = ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
        direction: {
            base: "column",
            L: "row"
        },
        gap: {
            base: "size-100",
            M: "size-250",
            L: "size-350"
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.View), {
        backgroundColor: "celery-600",
        width: "size-800",
        height: "size-800"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.View), {
        backgroundColor: "blue-600",
        width: "size-800",
        height: "size-800"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.View), {
        backgroundColor: "magenta-600",
        width: "size-800",
        height: "size-800"
    }));
Responsive.story = {
    name: "responsive"
};

},{"@react-spectrum/layout":"hzaUY","react":"9yzVZ","@react-spectrum/view":"dnRjt","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"6kZ47":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ExplicitGrid", ()=>ExplicitGrid);
parcelHelpers.export(exports, "ImplicitGrid", ()=>ImplicitGrid);
parcelHelpers.export(exports, "Responsive", ()=>Responsive);
var _layout = require("@react-spectrum/layout");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _view = require("@react-spectrum/view");
let baseColors = [
    "celery",
    "chartreuse",
    "yellow",
    "magenta",
    "fuchsia",
    "purple",
    "indigo",
    "seafoam",
    "red",
    "orange",
    "green",
    "blue"
];
let colors = [];
for (let color of baseColors)for(let i = 4; i <= 7; i++)colors.push(`${color}-${i}00`);
exports.default = {
    title: "Grid"
};
const ExplicitGrid = ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Grid), {
        areas: [
            "header  header",
            "sidebar content",
            "footer  footer"
        ],
        columns: [
            "size-3000",
            "auto"
        ],
        rows: [
            "size-1000",
            "auto",
            "size-1000"
        ],
        height: "size-6000",
        width: "80%",
        gap: "size-100"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.View), {
        backgroundColor: "celery-600",
        gridArea: "header",
        padding: "size-100"
    }, "Header"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.View), {
        backgroundColor: "blue-600",
        gridArea: "sidebar",
        padding: "size-100"
    }, "Sidebar"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.View), {
        backgroundColor: "purple-600",
        gridArea: "content",
        padding: "size-100"
    }, "Content"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.View), {
        backgroundColor: "magenta-600",
        gridArea: "footer",
        padding: "size-100"
    }, "Footer"));
ExplicitGrid.story = {
    name: "Explicit grid"
};
const ImplicitGrid = ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Grid), {
        columns: (0, _layout.repeat)("auto-fit", "size-800"),
        autoRows: "size-800",
        justifyContent: "center",
        width: "80%",
        gap: "size-100"
    }, colors.map((color)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.View), {
            key: color,
            backgroundColor: color
        })));
ImplicitGrid.story = {
    name: "Implicit grid"
};
const Responsive = ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Grid), {
        columns: {
            base: (0, _layout.repeat)("auto-fit", "size-800"),
            M: (0, _layout.repeat)("auto-fit", "size-1200"),
            L: (0, _layout.repeat)("auto-fit", "size-2000")
        },
        autoRows: {
            base: "size-800",
            M: "size-1200",
            L: "size-2000"
        },
        justifyContent: "center",
        width: "80%",
        gap: {
            base: "size-100",
            M: "size-250",
            L: "size-350"
        }
    }, colors.map((color)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.View), {
            key: color,
            backgroundColor: color
        })));
Responsive.story = {
    name: "responsive"
};

},{"@react-spectrum/layout":"hzaUY","react":"9yzVZ","@react-spectrum/view":"dnRjt","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"67sw9":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Default", ()=>Default);
parcelHelpers.export(exports, "Secondary", ()=>Secondary);
parcelHelpers.export(exports, "OverBackground", ()=>OverBackground);
parcelHelpers.export(exports, "IsQuiet", ()=>IsQuiet);
parcelHelpers.export(exports, "IsQuietSecondary", ()=>IsQuietSecondary);
parcelHelpers.export(exports, "WithHref", ()=>WithHref);
parcelHelpers.export(exports, "WithChildren", ()=>WithChildren);
parcelHelpers.export(exports, "BlockNavigation", ()=>BlockNavigation);
parcelHelpers.export(exports, "OnClick", ()=>OnClick);
var _ = require("../");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
exports.default = {
    title: "Link",
    component: (0, _.Link),
    argTypes: {
        onPress: {
            action: "press"
        },
        onPressStart: {
            action: "pressstart"
        },
        onPressEnd: {
            action: "pressend"
        }
    }
};
let Default = {
    args: {
        children: "This is a React Spectrum Link"
    }
};
let Secondary = {
    ...Default,
    args: {
        ...Default.args,
        variant: "secondary"
    },
    name: "variant: secondary"
};
let OverBackground = {
    ...Default,
    args: {
        ...Default.args,
        variant: "overBackground"
    },
    decorators: [
        (Story)=>/*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
                style: {
                    backgroundColor: "rgb(15, 121, 125)",
                    color: "rgb(15, 121, 125)",
                    padding: "15px 20px",
                    display: "inline-block"
                }
            }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Story, null))
    ],
    name: "variant: overBackground"
};
let IsQuiet = {
    ...Default,
    args: {
        ...Default.args,
        isQuiet: true
    },
    name: "isQuiet: true"
};
let IsQuietSecondary = {
    ...Default,
    args: {
        ...IsQuiet.args,
        ...Secondary.args
    },
    name: "isQuiet: true, variant: secondary"
};
let WithHref = {
    ...Default,
    args: {
        ...Default.args,
        href: "//example.com"
    },
    name: "href"
};
let WithChildren = {
    ...Default,
    args: {
        children: /*#__PURE__*/ (0, _reactDefault.default).createElement("a", {
            href: "//example.com",
            target: "_self"
        }, "This is a React Spectrum Link")
    },
    name: "children: a"
};
let BlockNavigation = {
    args: {
        children: /*#__PURE__*/ (0, _reactDefault.default).createElement("a", {
            href: "//example.com",
            target: "_self",
            onClick: (e)=>e.preventDefault()
        }, "This is a React Spectrum Link")
    }
};
let OnClick = {
    ...Default,
    args: {
        ...Default.args
    },
    argTypes: {
        onClick: {
            action: "deprecatedOnClick"
        }
    },
    name: "onClick"
};

},{"../":"4X4az","react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"4X4az":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _src = require("./src");
parcelHelpers.exportAll(_src, exports);

},{"./src":"lNoiB","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"7ktXC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "items", ()=>items);
parcelHelpers.export(exports, "renderEmptyState", ()=>renderEmptyState);
parcelHelpers.export(exports, "Default", ()=>Default);
parcelHelpers.export(exports, "DynamicItems", ()=>DynamicItems);
parcelHelpers.export(exports, "DynamicItemsSmallView", ()=>DynamicItemsSmallView);
parcelHelpers.export(exports, "Falsy", ()=>Falsy);
parcelHelpers.export(exports, "EmptyList", ()=>EmptyList);
parcelHelpers.export(exports, "Loading", ()=>Loading);
parcelHelpers.export(exports, "LoadingMore", ()=>LoadingMore);
parcelHelpers.export(exports, "AsyncLoading", ()=>AsyncLoading);
parcelHelpers.export(exports, "AsyncLoadingAction", ()=>AsyncLoadingAction);
parcelHelpers.export(exports, "EmptyDynamic", ()=>EmptyDynamic);
parcelHelpers.export(exports, "WithActionBar", ()=>WithActionBar);
parcelHelpers.export(exports, "WithActionBarEmphasized", ()=>WithActionBarEmphasized);
parcelHelpers.export(exports, "Thumbnails", ()=>Thumbnails);
parcelHelpers.export(exports, "LongText", ()=>LongText);
parcelHelpers.export(exports, "RemoveListItems", ()=>RemoveListItems);
var _addonActions = require("@storybook/addon-actions");
var _actionbar = require("@react-spectrum/actionbar");
var _button = require("@react-spectrum/button");
var _actiongroup = require("@react-spectrum/actiongroup");
var _view = require("@react-spectrum/view");
var _copy = require("@spectrum-icons/workflow/Copy");
var _copyDefault = parcelHelpers.interopDefault(_copy);
var _delete = require("@spectrum-icons/workflow/Delete");
var _deleteDefault = parcelHelpers.interopDefault(_delete);
var _dialog = require("@react-spectrum/dialog");
var _divider = require("@react-spectrum/divider");
var _edit = require("@spectrum-icons/workflow/Edit");
var _editDefault = parcelHelpers.interopDefault(_edit);
var _file = require("@spectrum-icons/illustrations/File");
var _fileDefault = parcelHelpers.interopDefault(_file);
var _layout = require("@react-spectrum/layout");
var _focus = require("@react-aria/focus");
var _folder = require("@spectrum-icons/illustrations/Folder");
var _folderDefault = parcelHelpers.interopDefault(_folder);
var _text = require("@react-spectrum/text");
var _illustratedmessage = require("@react-spectrum/illustratedmessage");
var _image = require("@react-spectrum/image");
var _ = require("../");
var _link = require("@react-spectrum/link");
var _noSearchResults = require("@spectrum-icons/illustrations/NoSearchResults");
var _noSearchResultsDefault = parcelHelpers.interopDefault(_noSearchResults);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _data = require("@react-stately/data");
const items = [
    {
        key: "a",
        name: "Adobe Photoshop",
        type: "file"
    },
    {
        key: "b",
        name: "Adobe XD",
        type: "file"
    },
    {
        key: "c",
        name: "Documents",
        type: "folder",
        children: [
            {
                key: 1,
                name: "Sales Pitch"
            },
            {
                key: 2,
                name: "Demo"
            },
            {
                key: 3,
                name: "Taxes"
            }
        ]
    },
    {
        key: "d",
        name: "Adobe InDesign",
        type: "file"
    },
    {
        key: "e",
        name: "Utilities",
        type: "folder",
        children: [
            {
                key: 1,
                name: "Activity Monitor"
            }
        ]
    },
    {
        key: "f",
        name: "Adobe AfterEffects",
        type: "file"
    },
    {
        key: "g",
        name: "Adobe Illustrator",
        type: "file"
    },
    {
        key: "h",
        name: "Adobe Lightroom",
        type: "file"
    },
    {
        key: "i",
        name: "Adobe Premiere Pro",
        type: "file"
    },
    {
        key: "j",
        name: "Adobe Fresco",
        type: "file"
    },
    {
        key: "k",
        name: "Adobe Dreamweaver",
        type: "file"
    },
    {
        key: "l",
        name: "Adobe Connect",
        type: "file"
    },
    {
        key: "m",
        name: "Pictures",
        type: "folder",
        children: [
            {
                key: 1,
                name: "Yosemite"
            },
            {
                key: 2,
                name: "Jackson Hole"
            },
            {
                key: 3,
                name: "Crater Lake"
            }
        ]
    },
    {
        key: "n",
        name: "Adobe Acrobat",
        type: "file"
    }
];
// taken from https://random.dog/
const itemsWithThumbs = [
    {
        key: "0",
        title: "folder of good bois",
        illustration: /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _folderDefault.default), null)
    },
    {
        key: "1",
        title: "swimmer",
        url: "https://random.dog/b2fe2172-cf11-43f4-9c7f-29bd19601712.jpg"
    },
    {
        key: "2",
        title: "chocolate",
        url: "https://random.dog/2032518a-eec8-4102-9d48-3dca5a26eb23.png"
    },
    {
        key: "3",
        title: "good boi",
        url: "https://random.dog/191091b2-7d69-47af-9f52-6605063f1a47.jpg"
    },
    {
        key: "4",
        title: "polar bear",
        url: "https://random.dog/c22c077e-a009-486f-834c-a19edcc36a17.jpg"
    },
    {
        key: "5",
        title: "cold boi",
        url: "https://random.dog/093a41da-e2c0-4535-a366-9ef3f2013f73.jpg"
    },
    {
        key: "6",
        title: "pilot",
        url: "https://random.dog/09f8ecf4-c22b-49f4-af24-29fb5c8dbb2d.jpg"
    },
    {
        key: "7",
        title: "nerd",
        url: "https://random.dog/1a0535a6-ca89-4059-9b3a-04a554c0587b.jpg"
    },
    {
        key: "8",
        title: "audiophile",
        url: "https://random.dog/32367-2062-4347.jpg"
    },
    {
        key: "9",
        title: "file of great boi",
        illustration: /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _fileDefault.default), null)
    }
];
function renderEmptyState() {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _illustratedmessage.IllustratedMessage), null, /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        width: "150",
        height: "103",
        viewBox: "0 0 150 103"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M133.7,8.5h-118c-1.9,0-3.5,1.6-3.5,3.5v27c0,0.8,0.7,1.5,1.5,1.5s1.5-0.7,1.5-1.5V23.5h119V92c0,0.3-0.2,0.5-0.5,0.5h-118c-0.3,0-0.5-0.2-0.5-0.5V69c0-0.8-0.7-1.5-1.5-1.5s-1.5,0.7-1.5,1.5v23c0,1.9,1.6,3.5,3.5,3.5h118c1.9,0,3.5-1.6,3.5-3.5V12C137.2,10.1,135.6,8.5,133.7,8.5z M15.2,21.5V12c0-0.3,0.2-0.5,0.5-0.5h118c0.3,0,0.5,0.2,0.5,0.5v9.5H15.2z M32.6,16.5c0,0.6-0.4,1-1,1h-10c-0.6,0-1-0.4-1-1s0.4-1,1-1h10C32.2,15.5,32.6,15.9,32.6,16.5z M13.6,56.1l-8.6,8.5C4.8,65,4.4,65.1,4,65.1c-0.4,0-0.8-0.1-1.1-0.4c-0.6-0.6-0.6-1.5,0-2.1l8.6-8.5l-8.6-8.5c-0.6-0.6-0.6-1.5,0-2.1c0.6-0.6,1.5-0.6,2.1,0l8.6,8.5l8.6-8.5c0.6-0.6,1.5-0.6,2.1,0c0.6,0.6,0.6,1.5,0,2.1L15.8,54l8.6,8.5c0.6,0.6,0.6,1.5,0,2.1c-0.3,0.3-0.7,0.4-1.1,0.4c-0.4,0-0.8-0.1-1.1-0.4L13.6,56.1z"
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Heading), null, "No results"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Content), null, "No results found, press ", /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _link.Link), {
        onPress: (0, _addonActions.action)("linkPress")
    }, "here"), " for more info."));
}
let decorator = (storyFn, context)=>{
    let omittedStories = [
        "draggable rows",
        "dynamic items + renderEmptyState"
    ];
    return window.screen.width <= 700 || omittedStories.some((omittedName)=>context.name.includes(omittedName)) ? storyFn() : /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        style: {
            paddingInline: "10px"
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("label", {
        htmlFor: "focus-before"
    }, "Focus before"), /*#__PURE__*/ (0, _reactDefault.default).createElement("input", {
        id: "focus-before"
    })), storyFn(), /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        style: {
            paddingInline: "10px"
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("label", {
        htmlFor: "focus-after"
    }, "Focus after"), /*#__PURE__*/ (0, _reactDefault.default).createElement("input", {
        id: "focus-after"
    })));
};
exports.default = {
    title: "ListView",
    component: (0, _.ListView),
    decorators: [
        (story, context)=>decorator(story, context)
    ],
    excludeStories: [
        "renderEmptyState",
        "items"
    ],
    args: {
        isQuiet: false,
        density: "regular",
        selectionMode: "multiple",
        selectionStyle: "checkbox",
        overflowMode: "truncate",
        disabledBehavior: "selection"
    },
    argTypes: {
        selectionMode: {
            control: {
                type: "radio",
                options: [
                    "none",
                    "single",
                    "multiple"
                ]
            }
        },
        selectionStyle: {
            control: {
                type: "radio",
                options: [
                    "checkbox",
                    "highlight"
                ]
            }
        },
        isQuiet: {
            control: {
                type: "boolean"
            }
        },
        density: {
            control: {
                type: "select",
                options: [
                    "compact",
                    "regular",
                    "spacious"
                ]
            }
        },
        overflowMode: {
            control: {
                type: "radio",
                options: [
                    "truncate",
                    "wrap"
                ]
            }
        },
        disabledBehavior: {
            control: {
                type: "radio",
                options: [
                    "selection",
                    "all"
                ]
            }
        }
    }
};
const Default = {
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ListView), {
            width: "250px",
            "aria-label": "default ListView",
            ...args
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            textValue: "Adobe Photoshop"
        }, "Adobe Photoshop"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            textValue: "Adobe Illustrator"
        }, "Adobe Illustrator"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            textValue: "Adobe XD"
        }, "Adobe XD")),
    name: "default"
};
const DynamicItems = {
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ListView), {
            "aria-label": "Dynamic items",
            items: items,
            width: "300px",
            height: "250px",
            ...args
        }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
                key: item.key,
                textValue: item.name
            }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, item.name), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _actiongroup.ActionGroup), {
                buttonLabelBehavior: "hide"
            }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
                key: "edit"
            }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _editDefault.default), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, "Edit")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
                key: "delete"
            }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _deleteDefault.default), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, "Delete"))))),
    name: "dynamic items"
};
const DynamicItemsSmallView = {
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ListView), {
            "aria-label": "small view port listview",
            items: items,
            width: "100px",
            height: "250px",
            ...args
        }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
                key: item.key,
                textValue: item.name
            }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, item.name), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _actiongroup.ActionGroup), {
                buttonLabelBehavior: "hide"
            }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
                key: "edit"
            }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _editDefault.default), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, "Edit")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
                key: "delete"
            }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _deleteDefault.default), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, "Delete"))))),
    name: "dynamic items - small viewport"
};
const Falsy = {
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(FalsyIds, args),
    name: "falsy ids as keys"
};
const EmptyList = {
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ListView), {
            "aria-label": "empty ListView",
            width: "300px",
            height: "300px",
            renderEmptyState: renderEmptyState,
            ...args
        }, []),
    name: "empty list"
};
const Loading = {
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ListView), {
            "aria-label": "loading ListView",
            width: "300px",
            height: "300px",
            loadingState: "loading",
            ...args
        }, []),
    name: "loading"
};
const LoadingMore = {
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ListView), {
            "aria-label": "loading more ListView",
            width: "300px",
            height: "300px",
            loadingState: "loadingMore",
            ...args
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            textValue: "Adobe Photoshop"
        }, "Adobe Photoshop"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            textValue: "Adobe Illustrator"
        }, "Adobe Illustrator"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            textValue: "Adobe XD"
        }, "Adobe XD")),
    name: "loadingMore"
};
const AsyncLoading = {
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(AsyncList, args),
    name: "async listview loading"
};
const AsyncLoadingAction = {
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(AsyncList, {
            withActions: true,
            ...args
        }),
    name: "async listview loading with actions"
};
const EmptyDynamic = {
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(EmptyTest, args),
    name: "dynamic items + renderEmptyState"
};
const WithActionBar = {
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(ActionBarExample, args),
    name: "with ActionBar"
};
const WithActionBarEmphasized = {
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(ActionBarExample, {
            isEmphasized: true,
            ...args
        }),
    name: "with emphasized ActionBar"
};
const Thumbnails = {
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ListView), {
            width: "250px",
            items: itemsWithThumbs,
            "aria-label": "ListView with thumbnails",
            ...args
        }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
                textValue: item.title
            }, item.url && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _image.Image), {
                src: item.url,
                alt: ""
            }), item.illustration, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, item.title), item.url && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), {
                slot: "description"
            }, "JPG"))),
    name: "thumbnails"
};
const LongText = {
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ListView), {
            width: "250px",
            ...args
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            textValue: "Homeward Bound: The Incredible Journey"
        }, "Homeward Bound: The Incredible Journey"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            textValue: "Monsters University"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, "Monsters University"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), {
            slot: "description"
        }, "As a first grader, Mike Wazowski begins to dream of becoming a Scarer"))),
    name: "long text"
};
function AsyncList(props) {
    let list = (0, _data.useAsyncList)({
        async load ({ signal, cursor }) {
            if (cursor) cursor = cursor.replace(/^http:\/\//i, "https://");
            // Slow down load so progress circle can appear
            await new Promise((resolve)=>setTimeout(resolve, 1500));
            let res = await fetch(cursor || "https://swapi.py4e.com/api/people/?search=", {
                signal
            });
            let json = await res.json();
            return {
                items: json.results,
                cursor: json.next
            };
        }
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ListView), {
        selectionMode: "multiple",
        "aria-label": "example async loading list",
        width: "size-6000",
        height: "size-3000",
        items: list.items,
        loadingState: list.loadingState,
        onLoadMore: list.loadMore,
        ...props
    }, (item)=>{
        if (props.withActions) return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            key: item.name,
            textValue: item.name
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, item.name), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), null, "Edit"));
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            key: item.name,
            textValue: item.name
        }, item.name);
    });
}
function FalsyIds(props) {
    let items = [
        {
            id: 1,
            name: "key=1"
        },
        {
            id: 0,
            name: "key=0"
        }
    ];
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ListView), {
        "aria-label": "falsy id ListView",
        width: "250px",
        height: 400,
        selectionMode: "multiple",
        onSelectionChange: (0, _addonActions.action)("onSelectionChange"),
        items: items,
        onAction: (0, _addonActions.action)("onAction"),
        ...props
    }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), null, item.name));
}
function ActionBarExample(props) {
    let list = (0, _data.useListData)({
        initialItems: [
            {
                key: 0,
                name: "Adobe Photoshop"
            },
            {
                key: 1,
                name: "Adobe Illustrator"
            },
            {
                key: 2,
                name: "Adobe XD"
            }
        ],
        initialSelectedKeys: [
            0
        ]
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _actionbar.ActionBarContainer), {
        height: 300
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ListView), {
        ...props,
        selectedKeys: list.selectedKeys,
        onSelectionChange: list.setSelectedKeys,
        items: list.items,
        width: "250px",
        "aria-label": "Action Bar ListView"
    }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), null, item.name)), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _actionbar.ActionBar), {
        selectedItemCount: list.selectedKeys === "all" ? list.items.length : list.selectedKeys.size,
        onAction: (0, _addonActions.action)("onAction"),
        onClearSelection: ()=>list.setSelectedKeys(new Set([])),
        ...props
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
        key: "edit"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _editDefault.default), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, "Edit")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
        key: "copy"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _copyDefault.default), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, "Copy")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
        key: "delete"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _deleteDefault.default), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, "Delete"))));
}
let i = 0;
function EmptyTest() {
    const [items, setItems] = (0, _react.useState)([]);
    const [divProps, setDivProps] = (0, _react.useState)({});
    (0, _react.useEffect)(()=>{
        let newItems = [];
        for(i = 0; i < 20; i++)newItems.push({
            key: i,
            name: `Item ${i}`
        });
        setItems(newItems);
    }, []);
    const renderEmpty = ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _illustratedmessage.IllustratedMessage), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _noSearchResultsDefault.default), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Heading), null, "No items"));
    let hasDivProps = Object.keys(divProps).length > 0;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
        direction: "row"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", divProps, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ListView), {
        "aria-label": "render empty state ListView",
        items: items,
        width: "250px",
        height: hasDivProps ? null : "500px",
        renderEmptyState: renderEmpty
    }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            key: item.key
        }, item.name))), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        style: {
            paddingLeft: "10px"
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), {
        isDisabled: hasDivProps,
        onPress: ()=>setDivProps({
                style: {
                    display: "flex",
                    flexGrow: 1,
                    minWidth: "200px",
                    maxHeight: "500px"
                }
            })
    }, "Use flex div wrapper (no set height)"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
        gap: 10,
        marginTop: 10
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), {
        onPress: ()=>setItems([])
    }, "Clear All"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), {
        onPress: ()=>{
            let newArr = [
                ...items
            ];
            newArr.push({
                key: i++,
                name: `Item ${i}`
            });
            setItems(newArr);
        }
    }, "Add 1"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), {
        onPress: ()=>{
            let newItems = [
                ...items
            ];
            setItems(newItems.slice(0, 4));
        }
    }, "Slice (0, 4)")))));
}
const RemoveListItems = {
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(Demo, args)
};
function Demo(props) {
    let [items, setItems] = (0, _react.useState)([
        {
            key: 1,
            label: "utilities"
        }
    ]);
    let onDelete = (key)=>{
        setItems((prevItems)=>prevItems.filter((item)=>item.key !== key));
    };
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ListView), {
        selectionMode: "multiple",
        maxWidth: "size-6000",
        items: items,
        height: "300px",
        width: "250px",
        "aria-label": "ListView example with complex items",
        ...props
    }, (item)=>{
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            key: item.key,
            textValue: item.label
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, item.label), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _dialog.DialogTrigger), {
            type: "popover"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), null, "Delete"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _dialog.Dialog), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Heading), null, "Warning, cannot undo"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _divider.Divider), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Content), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, "Are you sure?"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _focus.FocusScope), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.Button), {
            variant: "accent",
            onPressStart: ()=>onDelete(item.key)
        }, "Delete"))))));
    });
}

},{"@storybook/addon-actions":"coXbW","@react-spectrum/actionbar":"3NgxP","@react-spectrum/button":"jZWyP","@react-spectrum/actiongroup":"hkqBV","@react-spectrum/view":"dnRjt","@spectrum-icons/workflow/Copy":"jpSBZ","@spectrum-icons/workflow/Delete":"foJ71","@react-spectrum/dialog":"3G0HV","@react-spectrum/divider":"dxmqN","@spectrum-icons/workflow/Edit":"ijmhW","@spectrum-icons/illustrations/File":"fy2lO","@react-spectrum/layout":"hzaUY","@react-aria/focus":"42mbF","@spectrum-icons/illustrations/Folder":"8w4Jp","@react-spectrum/text":"etCGI","@react-spectrum/illustratedmessage":"cV05z","@react-spectrum/image":"2GFZF","../":"bkKyS","@react-spectrum/link":"lNoiB","@spectrum-icons/illustrations/NoSearchResults":"2nDIV","react":"9yzVZ","@react-stately/data":"gEgJM","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"8w4Jp":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("2eeee375e0e18cd9");
exports.__esModule = true;
exports.default = File;
var _icon = require("6f9c119574afbe1b");
var _react = _interopRequireDefault(require("dafd401eb6e2870a"));
function File(props) {
    return /*#__PURE__*/ _react.default.createElement(_icon.Illustration, props, /*#__PURE__*/ _react.default.createElement("svg", {
        viewBox: "0 0 32 32",
        height: "32",
        width: "32"
    }, /*#__PURE__*/ _react.default.createElement("path", {
        fill: "var(--spectrum-global-color-gray-300)",
        d: "M3 29.5C1.6 29.5.5 28.4.5 27V5C.5 3.6 1.6 2.5 3 2.5h10.1c.5 0 1 .2 1.4.6l3.1 3.1c.2.2.4.3.7.3H29c1.4 0 2.5 1.1 2.5 2.5v18c0 1.4-1.1 2.5-2.5 2.5H3z"
    }), /*#__PURE__*/ _react.default.createElement("path", {
        fill: "var(--spectrum-global-color-gray-500)",
        d: "M29 6H18.3c-.1 0-.2 0-.4-.2l-3.1-3.1c-.4-.4-1-.7-1.7-.7H3C1.3 2 0 3.3 0 5v22c0 1.6 1.3 3 3 3h26c1.7 0 3-1.4 3-3V9c0-1.7-1.3-3-3-3zm2 21c0 1.1-.9 2-2 2H3c-1.1 0-2-.9-2-2V7h28c1.1 0 2 .9 2 2v18z"
    })));
}

},{"2eeee375e0e18cd9":"iHubQ","6f9c119574afbe1b":"k7wem","dafd401eb6e2870a":"9yzVZ"}],"bkKyS":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _src = require("./src");
parcelHelpers.exportAll(_src, exports);

},{"./src":"h7MYZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"2nDIV":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("ecd1cef216ad4a29");
exports.__esModule = true;
exports.default = NoSearchResults;
var _icon = require("9d032fc6ff91f56b");
var _react = _interopRequireDefault(require("5ec4ba68e122d7cd"));
function NoSearchResults(props) {
    return /*#__PURE__*/ _react.default.createElement(_icon.Illustration, props, /*#__PURE__*/ _react.default.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "99.039",
        height: "94.342"
    }, /*#__PURE__*/ _react.default.createElement("g", {
        fill: "none",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, /*#__PURE__*/ _react.default.createElement("path", {
        d: "M93.113 88.415a5.38 5.38 0 0 1-7.61 0L58.862 61.773a1.018 1.018 0 0 1 0-1.44l6.17-6.169a1.018 1.018 0 0 1 1.439 0l26.643 26.643a5.38 5.38 0 0 1 0 7.608z",
        strokeWidth: "2.99955"
    }), /*#__PURE__*/ _react.default.createElement("path", {
        strokeWidth: "2",
        d: "M59.969 59.838l-3.246-3.246M61.381 51.934l3.246 3.246M64.609 61.619l13.327 13.327"
    }), /*#__PURE__*/ _react.default.createElement("path", {
        strokeWidth: "3",
        d: "M13.311 47.447A28.87 28.87 0 1 0 36.589 1.5c-10.318 0-20.141 5.083-24.7 13.46M2.121 38.734l15.536-15.536M17.657 38.734L2.121 23.198"
    }))));
}

},{"ecd1cef216ad4a29":"iHubQ","9d032fc6ff91f56b":"k7wem","5ec4ba68e122d7cd":"9yzVZ"}],"2mSZi":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ActionButtons", ()=>ActionButtons);
parcelHelpers.export(exports, "ActionGroups", ()=>ActionGroups);
parcelHelpers.export(exports, "ActionMenus", ()=>ActionMenus);
parcelHelpers.export(exports, "ActionMenusGroup", ()=>ActionMenusGroup);
parcelHelpers.export(exports, "Focus", ()=>Focus);
parcelHelpers.export(exports, "FocusExample", ()=>FocusExample);
var _addonActions = require("@storybook/addon-actions");
var _button = require("@react-spectrum/button");
var _actiongroup = require("@react-spectrum/actiongroup");
var _menu = require("@react-spectrum/menu");
var _add = require("@spectrum-icons/workflow/Add");
var _addDefault = parcelHelpers.interopDefault(_add);
var _copy = require("@spectrum-icons/workflow/Copy");
var _copyDefault = parcelHelpers.interopDefault(_copy);
var _delete = require("@spectrum-icons/workflow/Delete");
var _deleteDefault = parcelHelpers.interopDefault(_delete);
var _folder = require("@spectrum-icons/illustrations/Folder");
var _folderDefault = parcelHelpers.interopDefault(_folder);
var _info = require("@spectrum-icons/workflow/Info");
var _infoDefault = parcelHelpers.interopDefault(_info);
var _ = require("../");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _removeCircle = require("@spectrum-icons/workflow/RemoveCircle");
var _removeCircleDefault = parcelHelpers.interopDefault(_removeCircle);
var _text = require("@react-spectrum/text");
var _data = require("@react-stately/data");
exports.default = {
    title: "ListView/Actions",
    component: (0, _.ListView),
    excludeStories: [
        "FocusExample"
    ],
    args: {
        isQuiet: false,
        density: "regular",
        selectionMode: "multiple",
        selectionStyle: "checkbox",
        overflowMode: "truncate",
        disabledBehavior: "selection"
    },
    argTypes: {
        selectionMode: {
            control: {
                type: "radio",
                options: [
                    "none",
                    "single",
                    "multiple"
                ]
            }
        },
        selectionStyle: {
            control: {
                type: "radio",
                options: [
                    "checkbox",
                    "highlight"
                ]
            }
        },
        isQuiet: {
            control: {
                type: "boolean"
            }
        },
        density: {
            control: {
                type: "select",
                options: [
                    "compact",
                    "regular",
                    "spacious"
                ]
            }
        },
        overflowMode: {
            control: {
                type: "radio",
                options: [
                    "truncate",
                    "wrap"
                ]
            }
        },
        disabledBehavior: {
            control: {
                type: "radio",
                options: [
                    "selection",
                    "all"
                ]
            }
        }
    }
};
const ActionButtons = {
    render: (args)=>renderActionsExample((props)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), {
                ...props,
                "aria-label": "copy"
            }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _copyDefault.default), null)), args),
    name: "ActionButton"
};
const ActionGroups = {
    render: (args)=>renderActionsExample(()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _actiongroup.ActionGroup), {
                buttonLabelBehavior: "hide",
                onAction: (0, _addonActions.action)("actionGroupAction")
            }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
                key: "add"
            }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _addDefault.default), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, "Add")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
                key: "delete"
            }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _deleteDefault.default), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, "Delete"))), args),
    name: "ActionGroup"
};
const ActionMenus = {
    render: (args)=>renderActionsExample(()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _menu.ActionMenu), {
                onAction: (0, _addonActions.action)("actionMenuAction")
            }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
                key: "add"
            }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _addDefault.default), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, "Add")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
                key: "delete"
            }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _deleteDefault.default), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, "Delete"))), args),
    name: "ActionMenu"
};
const ActionMenusGroup = {
    render: (args)=>renderActionsExample(()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _actiongroup.ActionGroup), {
                buttonLabelBehavior: "hide",
                onAction: (0, _addonActions.action)("actionGroupAction")
            }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
                key: "info"
            }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _infoDefault.default), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, "Info"))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _menu.ActionMenu), {
                onAction: (0, _addonActions.action)("actionMenuACtion")
            }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
                key: "add"
            }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _addDefault.default), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, "Add")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
                key: "delete"
            }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _deleteDefault.default), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, "Delete")))), args),
    name: "ActionGroup + ActionMenu"
};
const Focus = {
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(FocusExample, args),
    name: 'Restore focus after item removal (disabledBehavior: "selection")'
};
function renderActionsExample(renderActions, props) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ListView), {
        width: "300px",
        selectionMode: "single",
        ...props,
        onAction: (0, _addonActions.action)("onAction"),
        onSelectionChange: (0, _addonActions.action)("onSelectionChange"),
        "aria-label": "render actions ListView"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
        key: "a",
        textValue: "Utilities",
        hasChildItems: true
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _folderDefault.default), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, "Utilities"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), {
        slot: "description"
    }, "16 items"), renderActions({
        onPress: (0, _addonActions.action)("actionPress")
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
        key: "b",
        textValue: "Adobe Photoshop"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, "Adobe Photoshop"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), {
        slot: "description"
    }, "Application"), renderActions({
        onPress: (0, _addonActions.action)("actionPress")
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
        key: "c",
        textValue: "Adobe Illustrator"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, "Adobe Illustrator"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), {
        slot: "description"
    }, "Application"), renderActions({
        onPress: (0, _addonActions.action)("actionPress")
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
        key: "d",
        textValue: "Adobe XD"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, "Adobe XD"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), {
        slot: "description"
    }, "Application"), renderActions({
        onPress: (0, _addonActions.action)("actionPress")
    })));
}
const FocusExample = (args)=>{
    const items = [
        {
            id: 1,
            name: "Adobe Photoshop"
        },
        {
            id: 2,
            name: "Adobe XD"
        },
        {
            id: 3,
            name: "Adobe InDesign"
        },
        {
            id: 4,
            name: "Adobe AfterEffects"
        },
        {
            id: 5,
            name: "Adobe Flash",
            isDisabled: true
        },
        {
            id: 6,
            name: "Adobe Illustrator"
        },
        {
            id: 7,
            name: "Adobe Lightroom"
        },
        {
            id: 8,
            name: "Adobe Premiere Pro"
        },
        {
            id: 9,
            name: "Adobe Fresco"
        },
        {
            id: 10,
            name: "Adobe Dreamweaver"
        }
    ];
    const list = (0, _data.useListData)({
        initialItems: items,
        initialSelectedKeys: []
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ListView), {
        "aria-label": "listview with removable items",
        width: "250px",
        items: list.items,
        disabledKeys: [
            "5"
        ],
        ...args
    }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            key: item.id,
            textValue: item.name
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, item.name), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), {
            "aria-label": `Remove ${item.name}`,
            isQuiet: true,
            onPress: ()=>list.remove(item.id),
            isDisabled: item.isDisabled
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _removeCircleDefault.default), null))));
};

},{"@storybook/addon-actions":"coXbW","@react-spectrum/button":"jZWyP","@react-spectrum/actiongroup":"hkqBV","@react-spectrum/menu":"asqy4","@spectrum-icons/workflow/Add":"evYih","@spectrum-icons/workflow/Copy":"jpSBZ","@spectrum-icons/workflow/Delete":"foJ71","@spectrum-icons/illustrations/Folder":"8w4Jp","@spectrum-icons/workflow/Info":"dNHFs","../":"bkKyS","react":"9yzVZ","@spectrum-icons/workflow/RemoveCircle":"6kKEe","@react-spectrum/text":"etCGI","@react-stately/data":"gEgJM","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"6kKEe":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("73ef5a66cb1b6a6f");
exports.__esModule = true;
exports.default = RemoveCircle;
var _RemoveCircle = require("ba4a8995106480a3");
var _icon = require("a2ad894cfbd2db35");
var _react = _interopRequireDefault(require("a7bc54814a9fec97"));
function RemoveCircle(props) {
    return /*#__PURE__*/ _react.default.createElement(_icon.Icon, props, /*#__PURE__*/ _react.default.createElement(_RemoveCircle.A4uRemoveCircle, null));
}

},{"73ef5a66cb1b6a6f":"iHubQ","ba4a8995106480a3":"3fRvr","a2ad894cfbd2db35":"k7wem","a7bc54814a9fec97":"9yzVZ"}],"3fRvr":[function(require,module,exports) {
/**
* @adobe/react-spectrum-workflow (c) by Adobe
* 
* @adobe/react-spectrum-workflow is licensed under a
* Creative Commons Attribution-NoDerivatives 4.0 International License.
* 
* You should have received a copy of the license along with this
* work. If not, see <http://creativecommons.org/licenses/by-nd/4.0/>.
**/ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.A4uRemoveCircle = A4uRemoveCircle;
var _react = _interopRequireDefault(require("a35ac08b7bd8a757"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function A4uRemoveCircle(_ref) {
    var props = _extends({}, _ref);
    return /*#__PURE__*/ _react["default"].createElement("svg", _extends({
        viewBox: "0 0 36 36"
    }, props, props), /*#__PURE__*/ _react["default"].createElement("path", {
        fillRule: "evenodd",
        d: "M18,2A16,16,0,1,0,34,18,16,16,0,0,0,18,2ZM28,19a1,1,0,0,1-1,1H9a1,1,0,0,1-1-1V17a1,1,0,0,1,1-1H27a1,1,0,0,1,1,1Z"
    }));
}

},{"a35ac08b7bd8a757":"9yzVZ"}],"Afqjm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DragOut", ()=>DragOut);
parcelHelpers.export(exports, "CustomDragPreview", ()=>CustomDragPreview);
parcelHelpers.export(exports, "DragWithin", ()=>DragWithin);
parcelHelpers.export(exports, "DragWithinScroll", ()=>DragWithinScroll);
parcelHelpers.export(exports, "DragIntoFolder", ()=>DragIntoFolder);
parcelHelpers.export(exports, "DragBetween", ()=>DragBetween);
parcelHelpers.export(exports, "DragBetweenRootOnly", ()=>DragBetweenRootOnly);
parcelHelpers.export(exports, "DraggableOnAction", ()=>DraggableOnAction);
parcelHelpers.export(exports, "DraggableCopyLink", ()=>DraggableCopyLink);
var _addonActions = require("@storybook/addon-actions");
var _listViewDnDExamples = require("./ListViewDnDExamples");
var _dndStories = require("@react-aria/dnd/stories/dnd.stories");
var _layout = require("@react-spectrum/layout");
var _ = require("../");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _view = require("@react-spectrum/view");
exports.default = {
    title: "ListView/Drag and Drop",
    component: (0, _.ListView),
    args: {
        isQuiet: false,
        density: "regular",
        selectionMode: "multiple",
        selectionStyle: "checkbox",
        overflowMode: "truncate",
        disabledBehavior: "selection"
    },
    argTypes: {
        selectionMode: {
            control: {
                type: "radio",
                options: [
                    "none",
                    "single",
                    "multiple"
                ]
            }
        },
        selectionStyle: {
            control: {
                type: "radio",
                options: [
                    "checkbox",
                    "highlight"
                ]
            }
        },
        isQuiet: {
            control: {
                type: "boolean"
            }
        },
        density: {
            control: {
                type: "select",
                options: [
                    "compact",
                    "regular",
                    "spacious"
                ]
            }
        },
        overflowMode: {
            control: {
                type: "radio",
                options: [
                    "truncate",
                    "wrap"
                ]
            }
        },
        disabledBehavior: {
            control: {
                type: "radio",
                options: [
                    "selection",
                    "all"
                ]
            }
        }
    }
};
let getAllowedDropOperationsAction = (0, _addonActions.action)("getAllowedDropOperationsAction");
const DragOut = {
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
            direction: "row",
            wrap: true,
            alignItems: "center"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement("input", {
            "aria-label": "input before"
        }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _dndStories.Droppable), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _listViewDnDExamples.DragExample), {
            dragHookOptions: {
                onDragStart: (0, _addonActions.action)("dragStart"),
                onDragEnd: (0, _addonActions.action)("dragEnd")
            },
            listViewProps: args
        })),
    name: "Drag out of list"
};
const CustomDragPreview = {
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
            direction: "row",
            wrap: true,
            alignItems: "center"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement("input", {
            "aria-label": "input before"
        }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _dndStories.Droppable), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _listViewDnDExamples.DragExample), {
            dragHookOptions: {
                onDragStart: (0, _addonActions.action)("dragStart"),
                onDragEnd: (0, _addonActions.action)("dragEnd"),
                renderPreview: (keys, draggedKey)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.View), {
                        backgroundColor: "gray-50",
                        padding: "size-100",
                        borderRadius: "medium",
                        borderWidth: "thin",
                        borderColor: "blue-500"
                    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("strong", null, "Custom Preview"), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", null, "Keys: [", [
                        ...keys
                    ].join(", "), "]"), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", null, "Dragged: ", draggedKey))
            },
            listViewProps: args
        })),
    name: "Custom drag preview"
};
const DragWithin = {
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
            direction: "row",
            wrap: true,
            alignItems: "center"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _listViewDnDExamples.ReorderExample), {
            ...args,
            getAllowedDropOperationsAction: getAllowedDropOperationsAction,
            disabledKeys: [
                "1"
            ],
            onDrop: (0, _addonActions.action)("drop"),
            onDragStart: (0, _addonActions.action)("dragStart"),
            onDragEnd: (0, _addonActions.action)("dragEnd")
        })),
    name: "Drag within list (Reorder}"
};
const DragWithinScroll = {
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
            direction: "row",
            wrap: true,
            alignItems: "center",
            height: 100
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _listViewDnDExamples.ReorderExample), {
            ...args,
            getAllowedDropOperationsAction: getAllowedDropOperationsAction,
            disabledKeys: [
                "1"
            ],
            onDrop: (0, _addonActions.action)("drop"),
            onDragStart: (0, _addonActions.action)("dragStart"),
            onDragEnd: (0, _addonActions.action)("dragEnd")
        })),
    name: "Drag within list scrolling (Reorder)"
};
const DragIntoFolder = {
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
            direction: "row",
            wrap: true,
            alignItems: "center"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _listViewDnDExamples.DragIntoItemExample), {
            getAllowedDropOperationsAction: getAllowedDropOperationsAction,
            listViewProps: args
        })),
    name: "Drag into folder"
};
const DragBetween = {
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
            direction: "row",
            wrap: true,
            alignItems: "center"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _listViewDnDExamples.DragBetweenListsExample), {
            ...args,
            getAllowedDropOperationsAction: getAllowedDropOperationsAction
        })),
    name: "Drag between lists"
};
const DragBetweenRootOnly = {
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
            direction: "row",
            wrap: true,
            alignItems: "center"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _listViewDnDExamples.DragBetweenListsRootOnlyExample), {
            listViewProps: args,
            getAllowedDropOperationsAction: getAllowedDropOperationsAction
        })),
    name: "Drag between lists (Root only)",
    parameters: {
        description: {
            data: "Folders are non-draggable."
        }
    }
};
const DraggableOnAction = {
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
            direction: "row",
            wrap: true,
            alignItems: "center"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement("input", {
            "aria-label": "input before"
        }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _dndStories.Droppable), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _listViewDnDExamples.DragExample), {
            listViewProps: {
                onAction: (0, _addonActions.action)("onAction"),
                ...args
            },
            dragHookOptions: {
                onDragStart: (0, _addonActions.action)("dragStart"),
                onDragEnd: (0, _addonActions.action)("dragEnd")
            }
        })),
    name: "draggable rows, onAction",
    parameters: {
        description: {
            data: "Folders are non-draggable."
        }
    }
};
const DraggableCopyLink = {
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
            direction: "row",
            wrap: true,
            alignItems: "center"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement("input", {
            "aria-label": "input before"
        }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _dndStories.Droppable), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _listViewDnDExamples.DragExample), {
            listViewProps: {
                onAction: (0, _addonActions.action)("onAction"),
                ...args
            },
            dragHookOptions: {
                onDragStart: (0, _addonActions.action)("dragStart"),
                onDragEnd: (0, _addonActions.action)("dragEnd"),
                getAllowedDropOperations: ()=>{
                    getAllowedDropOperationsAction();
                    return [
                        "copy",
                        "link",
                        "cancel"
                    ];
                }
            }
        })),
    name: "draggable rows, allow copy and link",
    parameters: {
        description: {
            data: "Allows copy, link, and cancel operations. Copy should be the default operation, and link should be the operation when the CTRL key is held while dragging."
        }
    }
};

},{"@storybook/addon-actions":"coXbW","./ListViewDnDExamples":"89vpO","@react-aria/dnd/stories/dnd.stories":"6aNDQ","@react-spectrum/layout":"hzaUY","../":"bkKyS","react":"9yzVZ","@react-spectrum/view":"dnRjt","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"89vpO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DragExample", ()=>DragExample);
parcelHelpers.export(exports, "ReorderExample", ()=>ReorderExample);
parcelHelpers.export(exports, "DragIntoItemExample", ()=>DragIntoItemExample);
parcelHelpers.export(exports, "DragBetweenListsExample", ()=>DragBetweenListsExample);
parcelHelpers.export(exports, "DragBetweenListsRootOnlyExample", ()=>DragBetweenListsRootOnlyExample);
var _addonActions = require("@storybook/addon-actions");
var _menu = require("@react-spectrum/menu");
var _utils = require("@react-aria/utils");
var _delete = require("@spectrum-icons/workflow/Delete");
var _deleteDefault = parcelHelpers.interopDefault(_delete);
var _edit = require("@spectrum-icons/workflow/Edit");
var _editDefault = parcelHelpers.interopDefault(_edit);
var _file = require("@spectrum-icons/illustrations/File");
var _fileDefault = parcelHelpers.interopDefault(_file);
var _layout = require("@react-spectrum/layout");
var _folder = require("@spectrum-icons/illustrations/Folder");
var _folderDefault = parcelHelpers.interopDefault(_folder);
var _ = require("../");
var _listViewStories = require("./ListView.stories");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _text = require("@react-spectrum/text");
var _dnd = require("@react-spectrum/dnd");
var _data = require("@react-stately/data");
function DragExample(props) {
    let { listViewProps, dragHookOptions } = props;
    let getItems = (keys)=>[
            ...keys
        ].map((key)=>{
            let item = (0, _listViewStories.items).find((item)=>item.key === key);
            return {
                "text/plain": item.name
            };
        });
    let { dragAndDropHooks } = (0, _dnd.useDragAndDrop)({
        getItems,
        getAllowedDropOperations () {
            var _props_getAllowedDropOperationsAction;
            (_props_getAllowedDropOperationsAction = props.getAllowedDropOperationsAction) === null || _props_getAllowedDropOperationsAction === void 0 ? void 0 : _props_getAllowedDropOperationsAction.call(props);
            return [
                "move",
                "cancel"
            ];
        },
        ...dragHookOptions
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ListView), {
        "aria-label": "draggable list view",
        width: "300px",
        selectionMode: "multiple",
        items: (0, _listViewStories.items),
        disabledKeys: [
            "f"
        ],
        dragAndDropHooks: dragAndDropHooks,
        ...listViewProps
    }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            key: item.key,
            textValue: item.name,
            hasChildItems: item.type === "folder"
        }, item.type === "folder" && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _folderDefault.default), null), item.key === "a" && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _fileDefault.default), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, item.name), item.key === "b" && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), {
            slot: "description"
        }, "Beta"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _menu.ActionMenu), {
            onAction: (0, _addonActions.action)("onAction")
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            key: "edit",
            textValue: "Edit"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _editDefault.default), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, "Edit")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            key: "delete",
            textValue: "Delete"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _deleteDefault.default), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, "Delete")))));
}
let itemList1 = [
    {
        id: "1",
        type: "item",
        textValue: "Item One"
    },
    {
        id: "2",
        type: "item",
        textValue: "Item Two"
    },
    {
        id: "3",
        type: "item",
        textValue: "Item Three"
    },
    {
        id: "4",
        type: "item",
        textValue: "Item Four"
    },
    {
        id: "5",
        type: "item",
        textValue: "Item Five"
    },
    {
        id: "6",
        type: "item",
        textValue: "Item Six"
    }
];
let itemList2 = [
    {
        id: "7",
        type: "item",
        textValue: "Item Seven"
    },
    {
        id: "8",
        type: "item",
        textValue: "Item Eight"
    },
    {
        id: "9",
        type: "item",
        textValue: "Item Nine"
    },
    {
        id: "10",
        type: "item",
        textValue: "Item Ten"
    },
    {
        id: "11",
        type: "item",
        textValue: "Item Eleven"
    },
    {
        id: "12",
        type: "item",
        textValue: "Item Twelve"
    }
];
function ReorderExample(props) {
    let { onDrop, onDragStart, onDragEnd, disabledKeys = [
        "2"
    ], ...otherprops } = props;
    let list = (0, _data.useListData)({
        initialItems: props.items || itemList1
    });
    // Use a random drag type so the items can only be reordered within this list and not dragged elsewhere.
    let dragType = (0, _reactDefault.default).useMemo(()=>`keys-${Math.random().toString(36).slice(2)}`, []);
    let onMove = (keys, target)=>{
        if (target.dropPosition === "before") list.moveBefore(target.key, keys);
        else list.moveAfter(target.key, keys);
    };
    let { dragAndDropHooks } = (0, _dnd.useDragAndDrop)({
        getItems (keys) {
            return [
                ...keys
            ].map((key)=>{
                key = JSON.stringify(key);
                return {
                    [dragType]: key,
                    "text/plain": key
                };
            });
        },
        getAllowedDropOperations () {
            var _props_getAllowedDropOperationsAction;
            (_props_getAllowedDropOperationsAction = props.getAllowedDropOperationsAction) === null || _props_getAllowedDropOperationsAction === void 0 ? void 0 : _props_getAllowedDropOperationsAction.call(props);
            return [
                "move",
                "cancel"
            ];
        },
        onDragStart: onDragStart,
        onDragEnd: onDragEnd,
        async onDrop (e) {
            onDrop(e);
            if (e.target.type !== "root" && e.target.dropPosition !== "on") {
                let keys = [];
                for (let item of e.items)if (item.kind === "text") {
                    let key;
                    if (item.types.has(dragType)) {
                        key = JSON.parse(await item.getText(dragType));
                        keys.push(key);
                    } else if (item.types.has("text/plain")) {
                        // Fallback for Chrome Android case: https://bugs.chromium.org/p/chromium/issues/detail?id=1293803
                        // Multiple drag items are contained in a single string so we need to split them out
                        key = await item.getText("text/plain");
                        keys = key.split("\n").map((val)=>val.replaceAll('"', ""));
                    }
                }
                onMove(keys, e.target);
            }
        },
        getDropOperation (target) {
            if (target.type === "root" || target.dropPosition === "on") return "cancel";
            return "move";
        }
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ListView), {
        "aria-label": "reorderable list view",
        selectionMode: "multiple",
        width: "300px",
        height: "100%",
        items: list.items,
        disabledKeys: disabledKeys,
        dragAndDropHooks: dragAndDropHooks,
        ...otherprops
    }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), null, item.textValue));
}
function DragIntoItemExample(props) {
    let { listViewProps = {}, dragHookOptions = {}, dropHookOptions = {} } = props;
    let { onDragStart, onDragEnd } = dragHookOptions;
    let { onDrop } = dropHookOptions;
    let onDropAction = (0, _utils.chain)((0, _addonActions.action)("onDrop"), onDrop);
    let getAllowedDropOperationsAction = (0, _addonActions.action)("getAllowedDropOperations");
    let list = (0, _data.useListData)({
        initialItems: [
            {
                id: "0",
                type: "folder",
                textValue: "Folder 1",
                childNodes: []
            },
            {
                id: "1",
                type: "item",
                textValue: "One"
            },
            {
                id: "2",
                type: "item",
                textValue: "Two"
            },
            {
                id: "3",
                type: "item",
                textValue: "Three"
            },
            {
                id: "4",
                type: "item",
                textValue: "Four"
            },
            {
                id: "5",
                type: "item",
                textValue: "Five"
            },
            {
                id: "6",
                type: "item",
                textValue: "Six"
            },
            {
                id: "7",
                type: "folder",
                textValue: "Folder disabled",
                childNodes: []
            },
            {
                id: "8",
                type: "folder",
                textValue: "Folder 2",
                childNodes: []
            }
        ]
    });
    let disabledKeys = [
        "2",
        "7"
    ];
    // Use a random drag type so the items can only be reordered within this list and not dragged elsewhere.
    let dragType = (0, _reactDefault.default).useMemo(()=>`keys-${Math.random().toString(36).slice(2)}`, []);
    let onMove = (keys, target)=>{
        let folderItem = list.getItem(target.key);
        let draggedItems = keys.map((key)=>list.getItem(key));
        list.update(target.key, {
            ...folderItem,
            childNodes: [
                ...folderItem.childNodes,
                ...draggedItems
            ]
        });
        list.remove(...keys);
    };
    let { dragAndDropHooks } = (0, _dnd.useDragAndDrop)({
        getItems (keys) {
            return [
                ...keys
            ].map((key)=>{
                key = JSON.stringify(key);
                return {
                    [dragType]: key,
                    "text/plain": key
                };
            });
        },
        getAllowedDropOperations () {
            getAllowedDropOperationsAction();
            return [
                "move",
                "cancel"
            ];
        },
        onDragStart: (0, _utils.chain)((0, _addonActions.action)("dragStart"), onDragStart),
        onDragEnd: (0, _utils.chain)((0, _addonActions.action)("dragEnd"), onDragEnd),
        onDrop: async (e)=>{
            onDropAction(e);
            if (e.target.type !== "root" && e.target.dropPosition === "on") {
                let keys = [];
                for (let item of e.items)if (item.kind === "text") {
                    let key;
                    if (item.types.has(dragType)) {
                        key = JSON.parse(await item.getText(dragType));
                        keys.push(key);
                    } else if (item.types.has("text/plain")) {
                        // Fallback for Chrome Android case: https://bugs.chromium.org/p/chromium/issues/detail?id=1293803
                        // Multiple drag items are contained in a single string so we need to split them out
                        key = await item.getText("text/plain");
                        keys = key.split("\n").map((val)=>val.replaceAll('"', ""));
                    }
                }
                if (!keys.includes(e.target.key)) onMove(keys, e.target);
            }
        },
        getDropOperation (target) {
            if (target.type === "root" || target.dropPosition !== "on" || !list.getItem(target.key).childNodes || disabledKeys.includes(target.key)) return "cancel";
            return "move";
        }
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ListView), {
        "aria-label": "Drop into list view item example",
        selectionMode: "multiple",
        width: "300px",
        items: list.items,
        disabledKeys: disabledKeys,
        dragAndDropHooks: dragAndDropHooks,
        ...listViewProps
    }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            textValue: item.textValue,
            hasChildItems: item.type === "folder"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, item.type === "folder" ? `${item.textValue} (Drop items here)` : `Item ${item.textValue}`), item.type === "folder" && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _folderDefault.default), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), {
            slot: "description"
        }, `contains ${item.childNodes.length} dropped item(s)`))));
}
function DragBetweenListsExample(props) {
    let { onDragStart, onDragEnd, onDrop } = props;
    let onDropAction = (0, _utils.chain)((0, _addonActions.action)("onDrop"), onDrop);
    onDragStart = (0, _utils.chain)((0, _addonActions.action)("dragStart"), onDragStart);
    onDragEnd = (0, _utils.chain)((0, _addonActions.action)("dragEnd"), onDragEnd);
    let list1 = (0, _data.useListData)({
        initialItems: props.items1 || itemList1
    });
    let list2 = (0, _data.useListData)({
        initialItems: props.items2 || itemList2
    });
    let onMove = (keys, target)=>{
        let sourceList = list1.getItem(keys[0]) ? list1 : list2;
        let destinationList = list1.getItem(target.key) ? list1 : list2;
        if (sourceList === destinationList) {
            // Handle dragging within same list
            if (target.dropPosition === "before") sourceList.moveBefore(target.key, keys);
            else sourceList.moveAfter(target.key, keys);
        } else {
            // Handle dragging between lists
            if (target.dropPosition === "before") destinationList.insertBefore(target.key, ...keys.map((key)=>sourceList.getItem(key)));
            else destinationList.insertAfter(target.key, ...keys.map((key)=>sourceList.getItem(key)));
            sourceList.remove(...keys);
        }
    };
    // Use a random drag type so the items can only be reordered within the two lists and not dragged elsewhere.
    let dragType = (0, _reactDefault.default).useMemo(()=>`keys-${Math.random().toString(36).slice(2)}`, []);
    let { dragAndDropHooks } = (0, _dnd.useDragAndDrop)({
        getItems (keys) {
            return [
                ...keys
            ].map((key)=>{
                key = JSON.stringify(key);
                return {
                    [dragType]: key,
                    "text/plain": key
                };
            });
        },
        getAllowedDropOperations () {
            var _props_getAllowedDropOperationsAction;
            (_props_getAllowedDropOperationsAction = props.getAllowedDropOperationsAction) === null || _props_getAllowedDropOperationsAction === void 0 ? void 0 : _props_getAllowedDropOperationsAction.call(props);
            return [
                "move",
                "cancel"
            ];
        },
        onDragStart,
        onDragEnd,
        onDrop: async (e)=>{
            onDropAction(e);
            if (e.target.type !== "root" && e.target.dropPosition !== "on") {
                let keys = [];
                for (let item of e.items)if (item.kind === "text") {
                    let key;
                    if (item.types.has(dragType)) {
                        key = JSON.parse(await item.getText(dragType));
                        keys.push(key);
                    } else if (item.types.has("text/plain")) {
                        // Fallback for Chrome Android case: https://bugs.chromium.org/p/chromium/issues/detail?id=1293803
                        // Multiple drag items are contained in a single string so we need to split them out
                        key = await item.getText("text/plain");
                        keys = key.split("\n").map((val)=>val.replaceAll('"', ""));
                    }
                }
                onMove(keys, e.target);
            }
        },
        getDropOperation (target) {
            if (target.type === "root" || target.dropPosition === "on") return "cancel";
            return "move";
        }
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
        direction: "column",
        margin: "size-100"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), {
        alignSelf: "center"
    }, "List 1"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ListView), {
        "aria-label": "First list view",
        selectionMode: "multiple",
        width: "300px",
        items: list1.items,
        disabledKeys: [
            "2"
        ],
        dragAndDropHooks: dragAndDropHooks,
        ...props
    }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), null, item.textValue))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
        direction: "column",
        margin: "size-100"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), {
        alignSelf: "center"
    }, "List 2"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ListView), {
        "aria-label": "Second list view",
        selectionMode: "multiple",
        width: "300px",
        items: list2.items,
        disabledKeys: [
            "2"
        ],
        dragAndDropHooks: dragAndDropHooks,
        ...props
    }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), null, item.textValue))));
}
function DragBetweenListsRootOnlyExample(props) {
    let { listViewProps = {}, dragHookOptions = {}, dropHookOptions = {} } = props;
    let { onDragStart, onDragEnd } = dragHookOptions;
    let { onDrop } = dropHookOptions;
    let onDropAction = (0, _utils.chain)((0, _addonActions.action)("onDrop"), onDrop);
    let list1 = (0, _data.useListData)({
        initialItems: props.items1 || itemList1
    });
    let list2 = (0, _data.useListData)({
        initialItems: props.items2 || itemList2
    });
    let onMove = (keys, destinationList)=>{
        let sourceList = list1.getItem(keys[0]) ? list1 : list2;
        let items = keys.map((key)=>sourceList.getItem(key));
        sourceList.remove(...keys);
        destinationList.append(...items);
    };
    let { dragAndDropHooks: dragAndDropHooksFirst } = (0, _dnd.useDragAndDrop)({
        getItems (keys) {
            return [
                ...keys
            ].map((key)=>{
                key = JSON.stringify(key);
                return {
                    "list1": key,
                    "text/plain": key
                };
            });
        },
        getAllowedDropOperations () {
            var _props_getAllowedDropOperationsAction;
            (_props_getAllowedDropOperationsAction = props.getAllowedDropOperationsAction) === null || _props_getAllowedDropOperationsAction === void 0 ? void 0 : _props_getAllowedDropOperationsAction.call(props);
            return [
                "move",
                "cancel"
            ];
        },
        onDragStart: (0, _utils.chain)((0, _addonActions.action)("dragStart"), onDragStart),
        onDragEnd: (0, _utils.chain)((0, _addonActions.action)("dragEnd"), onDragEnd),
        onDrop: async (e)=>{
            onDropAction(e);
            if (e.target.type === "root") {
                let keys = [];
                for (let item of e.items)if (item.kind === "text") {
                    let key;
                    if (item.types.has("list2")) {
                        key = JSON.parse(await item.getText("list2"));
                        keys.push(key);
                    } else if (item.types.has("text/plain")) {
                        // Fallback for Chrome Android case: https://bugs.chromium.org/p/chromium/issues/detail?id=1293803
                        // Multiple drag items are contained in a single string so we need to split them out
                        key = await item.getText("text/plain");
                        keys = key.split("\n").map((val)=>val.replaceAll('"', ""));
                    }
                }
                onMove(keys, list1);
            }
        },
        getDropOperation (target, types) {
            if (target.type === "root" && (types.has("list2") || types.has("text/plain"))) return "move";
            return "cancel";
        }
    });
    let { dragAndDropHooks: dragAndDropHooksSecond } = (0, _dnd.useDragAndDrop)({
        getItems (keys) {
            return [
                ...keys
            ].map((key)=>{
                key = JSON.stringify(key);
                return {
                    "list2": key,
                    "text/plain": key
                };
            });
        },
        getAllowedDropOperations () {
            var _props_getAllowedDropOperationsAction;
            (_props_getAllowedDropOperationsAction = props.getAllowedDropOperationsAction) === null || _props_getAllowedDropOperationsAction === void 0 ? void 0 : _props_getAllowedDropOperationsAction.call(props);
            return [
                "move",
                "cancel"
            ];
        },
        onDragStart: (0, _utils.chain)((0, _addonActions.action)("dragStart"), onDragStart),
        onDragEnd: (0, _utils.chain)((0, _addonActions.action)("dragEnd"), onDragEnd),
        onDrop: async (e)=>{
            onDropAction(e);
            if (e.target.type === "root") {
                let keys = [];
                for (let item of e.items)if (item.kind === "text") {
                    let key;
                    if (item.types.has("list1")) {
                        key = JSON.parse(await item.getText("list1"));
                        keys.push(key);
                    } else if (item.types.has("text/plain")) {
                        // Fallback for Chrome Android case: https://bugs.chromium.org/p/chromium/issues/detail?id=1293803
                        // Multiple drag items are contained in a single string so we need to split them out
                        key = await item.getText("text/plain");
                        keys = key.split("\n").map((val)=>val.replaceAll('"', ""));
                    }
                }
                onMove(keys, list2);
            }
        },
        getDropOperation (target, types) {
            if (target.type === "root" && (types.has("list1") || types.has("text/plain"))) return "move";
            return "cancel";
        }
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
        direction: "column",
        margin: "size-100"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), {
        alignSelf: "center"
    }, "List 1"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ListView), {
        "aria-label": "First list view",
        selectionMode: "multiple",
        width: "300px",
        items: list1.items,
        disabledKeys: [
            "2"
        ],
        dragAndDropHooks: dragAndDropHooksFirst,
        ...listViewProps
    }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), null, item.textValue))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
        direction: "column",
        margin: "size-100"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), {
        alignSelf: "center"
    }, "List 2"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ListView), {
        "aria-label": "Second list view",
        selectionMode: "multiple",
        width: "300px",
        items: list2.items,
        disabledKeys: [
            "2"
        ],
        dragAndDropHooks: dragAndDropHooksSecond,
        ...listViewProps
    }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), null, item.textValue))));
}

},{"@storybook/addon-actions":"coXbW","@react-spectrum/menu":"asqy4","@react-aria/utils":"9cLk5","@spectrum-icons/workflow/Delete":"foJ71","@spectrum-icons/workflow/Edit":"ijmhW","@spectrum-icons/illustrations/File":"fy2lO","@react-spectrum/layout":"hzaUY","@spectrum-icons/illustrations/Folder":"8w4Jp","../":"bkKyS","./ListView.stories":"7ktXC","react":"9yzVZ","@react-spectrum/text":"etCGI","@react-spectrum/dnd":"cHWGH","@react-stately/data":"gEgJM","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"HsCSB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DragOut", ()=>DragOut);
parcelHelpers.export(exports, "DragWithin", ()=>DragWithin);
parcelHelpers.export(exports, "DropOntoItem", ()=>DropOntoItem);
parcelHelpers.export(exports, "DropOntoRoot", ()=>DropOntoRoot);
parcelHelpers.export(exports, "DropBetween", ()=>DropBetween);
parcelHelpers.export(exports, "DirectoryFileDrop", ()=>DirectoryFileDrop);
parcelHelpers.export(exports, "Complex", ()=>Complex);
parcelHelpers.export(exports, "GetDropOperationDefault", ()=>GetDropOperationDefault);
parcelHelpers.export(exports, "UtilOverride", ()=>UtilOverride);
var _addonActions = require("@storybook/addon-actions");
var _listViewDnDUtilExamples = require("./ListViewDnDUtilExamples");
var _dndStories = require("@react-aria/dnd/stories/dnd.stories");
var _layout = require("@react-spectrum/layout");
var _ = require("../");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
exports.default = {
    title: "ListView/Drag and Drop/Util Handlers",
    component: (0, _.ListView),
    args: {
        isQuiet: false,
        density: "regular",
        selectionMode: "multiple",
        selectionStyle: "checkbox",
        overflowMode: "truncate",
        disabledBehavior: "selection"
    },
    argTypes: {
        selectionMode: {
            control: {
                type: "radio",
                options: [
                    "none",
                    "single",
                    "multiple"
                ]
            }
        },
        selectionStyle: {
            control: {
                type: "radio",
                options: [
                    "checkbox",
                    "highlight"
                ]
            }
        },
        isQuiet: {
            control: {
                type: "boolean"
            }
        },
        density: {
            control: {
                type: "select",
                options: [
                    "compact",
                    "regular",
                    "spacious"
                ]
            }
        },
        overflowMode: {
            control: {
                type: "radio",
                options: [
                    "truncate",
                    "wrap"
                ]
            }
        },
        disabledBehavior: {
            control: {
                type: "radio",
                options: [
                    "selection",
                    "all"
                ]
            }
        }
    }
};
const DragOut = {
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
            direction: "row",
            wrap: true,
            alignItems: "center"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement("input", {
            "aria-label": "input before"
        }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _dndStories.Droppable), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _listViewDnDUtilExamples.DragExampleUtilHandlers), {
            listViewProps: args,
            dndOptions: {
                onDragStart: (0, _addonActions.action)("dragStart"),
                onDragEnd: (0, _addonActions.action)("dragEnd")
            }
        })),
    name: "Drag out of list"
};
const DragWithin = {
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _listViewDnDUtilExamples.ReorderExampleUtilHandlers), {
            listViewProps: args,
            dndOptions: {
                onDragStart: (0, _addonActions.action)("dragStart"),
                onDragEnd: (0, _addonActions.action)("dragEnd")
            }
        }),
    name: "Drag within list (Reorder}"
};
const DropOntoItem = {
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _listViewDnDUtilExamples.ItemDropExampleUtilHandlers), {
            listViewProps: args,
            dndOptions: {
                onDragStart: (0, _addonActions.action)("dragStart"),
                onDragEnd: (0, _addonActions.action)("dragEnd")
            }
        }),
    name: "drop onto item/folder",
    parameters: {
        description: {
            data: "Allows dropping on items and folders. Dropping on a item is a no op (action fires still). Dropping external items is also a no op"
        }
    }
};
const DropOntoRoot = {
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _listViewDnDUtilExamples.RootDropExampleUtilHandlers), {
            listViewProps: args,
            firstListDnDOptions: {
                onDragStart: (0, _addonActions.action)("dragStart")
            }
        }),
    name: "drop onto root",
    parameters: {
        description: {
            data: "Allows one way dragging from first list to root of second list. Copy and link operations shouldnt remove items from the first list"
        }
    }
};
const DropBetween = {
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _listViewDnDUtilExamples.InsertExampleUtilHandlers), {
            listViewProps: args,
            firstListDnDOptions: {
                onDragStart: (0, _addonActions.action)("dragStart")
            }
        }),
    name: "drop between items",
    parameters: {
        description: {
            data: "Allows one way dragging from first list to between items of second list. Copy and link operations shouldnt remove items from the first list"
        }
    }
};
const DirectoryFileDrop = {
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _listViewDnDUtilExamples.FinderDropUtilHandlers), {
            listViewProps: args
        }),
    name: "allows directories and files from finder",
    parameters: {
        description: {
            data: "The first list should allow only directory drops (e.g. folders from finder). The second list should allow all drag type drops (directory/files from finder, any drag items)."
        }
    }
};
const Complex = {
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _listViewDnDUtilExamples.DragBetweenListsComplex), {
            listViewProps: args,
            firstListDnDOptions: {
                onDragStart: (0, _addonActions.action)("dragStartList1")
            },
            secondListDnDOptions: {
                onDragStart: (0, _addonActions.action)("dragStartList2")
            }
        }),
    name: "complex drag between lists",
    parameters: {
        description: {
            data: "The first list should allow dragging and drops into its folder, but disallow reorder operations. External root drops should be placed at the end of the list. The second list should allow all operations and root drops should be placed at the top of the list. Move and copy operations are allowed. The invalid drag item should be able to be dropped in either list if accompanied by other valid drag items."
        }
    }
};
const GetDropOperationDefault = {
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _listViewDnDUtilExamples.DragBetweenListsComplex), {
            listViewProps: args,
            firstListDnDOptions: {
                onDragStart: (0, _addonActions.action)("dragStartList1"),
                getDropOperation: (_, __, allowedOperations)=>allowedOperations.filter((op)=>op !== "move")[0],
                getAllowedDropOperations: ()=>[
                        "link"
                    ]
            },
            secondListDnDOptions: {
                onDragStart: (0, _addonActions.action)("dragStartList2"),
                getDropOperation: (_, __, allowedOperations)=>allowedOperations.filter((op)=>op !== "move")[0],
                getAllowedDropOperations: ()=>[
                        "move",
                        "copy",
                        "link"
                    ]
            }
        }),
    name: "using getDropOperations to determine default drop operation",
    parameters: {
        description: {
            data: "Dragging from the first to the second list should automatically set a link operation and all other drop operations should be disabled. Dragging from the second to first list should support copy and link operations, with copy being the default."
        }
    }
};
const UtilOverride = {
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _listViewDnDUtilExamples.DragBetweenListsOverride), args),
    name: "util handlers overridden by onDrop and getDropOperations",
    parameters: {
        description: {
            data: "The first list should be draggable, the second list should only be root droppable. No actions for onRootDrop, onReorder, onItemDrop, or onInsert should appear in the storybook actions panel."
        }
    }
};

},{"@storybook/addon-actions":"coXbW","./ListViewDnDUtilExamples":"awBR9","@react-aria/dnd/stories/dnd.stories":"6aNDQ","@react-spectrum/layout":"hzaUY","../":"bkKyS","react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"awBR9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DragExampleUtilHandlers", ()=>DragExampleUtilHandlers);
parcelHelpers.export(exports, "ReorderExampleUtilHandlers", ()=>ReorderExampleUtilHandlers);
parcelHelpers.export(exports, "ItemDropExampleUtilHandlers", ()=>ItemDropExampleUtilHandlers);
parcelHelpers.export(exports, "RootDropExampleUtilHandlers", ()=>RootDropExampleUtilHandlers);
parcelHelpers.export(exports, "InsertExampleUtilHandlers", ()=>InsertExampleUtilHandlers);
parcelHelpers.export(exports, "FinderDropUtilHandlers", ()=>FinderDropUtilHandlers);
parcelHelpers.export(exports, "DragBetweenListsComplex", ()=>DragBetweenListsComplex);
parcelHelpers.export(exports, "DragBetweenListsOverride", ()=>DragBetweenListsOverride);
var _addonActions = require("@storybook/addon-actions");
var _dnd = require("@react-aria/dnd");
var _layout = require("@react-spectrum/layout");
var _folder = require("@spectrum-icons/illustrations/Folder");
var _folderDefault = parcelHelpers.interopDefault(_folder);
var _ = require("../");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _text = require("@react-spectrum/text");
var _dnd1 = require("@react-spectrum/dnd");
var _data = require("@react-stately/data");
let itemProcessor = async (items, acceptedDragTypes)=>{
    let processedItems = [];
    let text;
    for (let item of items)for (let type of acceptedDragTypes){
        if (item.kind === "text" && item.types.has(type)) {
            text = await item.getText(type);
            processedItems.push(JSON.parse(text));
            break;
        } else if (item.types.size === 1 && item.types.has("text/plain")) {
            // Fallback for Chrome Android case: https://bugs.chromium.org/p/chromium/issues/detail?id=1293803
            // Multiple drag items are contained in a single string so we need to split them out
            text = await item.getText("text/plain");
            processedItems = text.split("\n").map((val)=>JSON.parse(val));
            break;
        }
    }
    return processedItems;
};
let folderList1 = [
    {
        identifier: "1",
        type: "file",
        name: "Adobe Photoshop"
    },
    {
        identifier: "2",
        type: "file",
        name: "Adobe XD"
    },
    {
        identifier: "3",
        type: "folder",
        name: "Documents",
        childNodes: []
    },
    {
        identifier: "4",
        type: "file",
        name: "Adobe InDesign"
    },
    {
        identifier: "5",
        type: "folder",
        name: "Utilities",
        childNodes: []
    },
    {
        identifier: "6",
        type: "file",
        name: "Adobe AfterEffects"
    }
];
let folderList2 = [
    {
        identifier: "7",
        type: "folder",
        name: "Pictures",
        childNodes: []
    },
    {
        identifier: "8",
        type: "file",
        name: "Adobe Fresco"
    },
    {
        identifier: "9",
        type: "folder",
        name: "Apps",
        childNodes: []
    },
    {
        identifier: "10",
        type: "file",
        name: "Adobe Illustrator"
    },
    {
        identifier: "11",
        type: "file",
        name: "Adobe Lightroom"
    },
    {
        identifier: "12",
        type: "file",
        name: "Adobe Dreamweaver"
    },
    {
        identifier: "13",
        type: "unique_type",
        name: "invalid drag item"
    }
];
function DragExampleUtilHandlers(props) {
    let { listViewProps, dndOptions } = props;
    let list = (0, _data.useListData)({
        initialItems: folderList1,
        getKey: (item)=>item.identifier
    });
    let acceptedDragTypes = [
        "file",
        "folder",
        "text/plain"
    ];
    let { dragAndDropHooks } = (0, _dnd1.useDragAndDrop)({
        getItems: (keys)=>[
                ...keys
            ].map((key)=>{
                let item = list.getItem(key);
                return {
                    [`${item.type}`]: JSON.stringify(item),
                    "text/plain": JSON.stringify(item)
                };
            }),
        acceptedDragTypes,
        ...dndOptions
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ListView), {
        "aria-label": "Draggable ListView with dnd hook util handlers",
        selectionMode: "multiple",
        width: "size-3600",
        height: "size-3600",
        items: list.items,
        ...listViewProps,
        dragAndDropHooks: dragAndDropHooks
    }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            textValue: item.name,
            key: item.identifier
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, item.name), item.type === "folder" && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _folderDefault.default), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), {
            slot: "description"
        }, `contains ${item.childNodes.length} dropped item(s)`))));
}
function ReorderExampleUtilHandlers(props) {
    let { listViewProps, dndOptions } = props;
    let list = (0, _data.useListData)({
        initialItems: folderList1,
        getKey: (item)=>item.identifier
    });
    let acceptedDragTypes = [
        "file",
        "folder",
        "text/plain"
    ];
    let { dragAndDropHooks } = (0, _dnd1.useDragAndDrop)({
        getItems: (keys)=>[
                ...keys
            ].map((key)=>{
                let item = list.getItem(key);
                return {
                    [`${item.type}`]: JSON.stringify(item),
                    "text/plain": JSON.stringify(item)
                };
            }),
        onReorder: async (e)=>{
            let { keys, target, dropOperation } = e;
            (0, _addonActions.action)("onReorder")(e);
            let itemsToCopy = [];
            if (dropOperation === "copy") for (let key of keys){
                let item = {
                    ...list.getItem(key)
                };
                item.identifier = Math.random().toString(36).slice(2);
                itemsToCopy.push(item);
            }
            if (target.dropPosition === "before") {
                if (dropOperation === "move") list.moveBefore(target.key, [
                    ...keys
                ]);
                else if (dropOperation === "copy") list.insertBefore(target.key, ...itemsToCopy);
            } else if (target.dropPosition === "after") {
                if (dropOperation === "move") list.moveAfter(target.key, [
                    ...keys
                ]);
                else if (dropOperation === "copy") list.insertAfter(target.key, ...itemsToCopy);
            }
        },
        acceptedDragTypes,
        ...dndOptions
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ListView), {
        "aria-label": "Reorderable ListView from util handlers",
        selectionMode: "multiple",
        width: "size-3600",
        height: "size-3600",
        items: list.items,
        ...listViewProps,
        dragAndDropHooks: dragAndDropHooks
    }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            textValue: item.name,
            key: item.identifier
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, item.name), item.type === "folder" && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _folderDefault.default), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), {
            slot: "description"
        }, `contains ${item.childNodes.length} dropped item(s)`))));
}
function ItemDropExampleUtilHandlers(props) {
    let { listViewProps, dndOptions } = props;
    let list = (0, _data.useListData)({
        initialItems: folderList1,
        getKey: (item)=>item.identifier
    });
    let acceptedDragTypes = [
        "file",
        "folder",
        "text/plain"
    ];
    let { dragAndDropHooks } = (0, _dnd1.useDragAndDrop)({
        getItems: (keys)=>[
                ...keys
            ].map((key)=>{
                let item = list.getItem(key);
                return {
                    [`${item.type}`]: JSON.stringify(item),
                    "text/plain": JSON.stringify(item)
                };
            }),
        onItemDrop: async (e)=>{
            let { items, target, isInternal, dropOperation } = e;
            (0, _addonActions.action)("onItemDrop")(e);
            if (isInternal) {
                let processedItems = await itemProcessor(items, acceptedDragTypes);
                let targetItem = list.getItem(target.key);
                if ((targetItem === null || targetItem === void 0 ? void 0 : targetItem.childNodes) != null) {
                    list.update(target.key, {
                        ...targetItem,
                        childNodes: [
                            ...targetItem.childNodes,
                            ...processedItems
                        ]
                    });
                    if (isInternal && dropOperation === "move") {
                        let keysToRemove = processedItems.map((item)=>item.identifier);
                        list.remove(...keysToRemove);
                    }
                }
            }
        },
        acceptedDragTypes,
        ...dndOptions
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ListView), {
        "aria-label": "Item and folder droppable ListView from dnd hook util handlers",
        selectionMode: "multiple",
        width: "size-3600",
        height: "size-3600",
        items: list.items,
        ...listViewProps,
        dragAndDropHooks: dragAndDropHooks
    }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            textValue: item.name,
            key: item.identifier
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, item.name), item.type === "folder" && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _folderDefault.default), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), {
            slot: "description"
        }, `contains ${item.childNodes.length} dropped item(s)`))));
}
function RootDropExampleUtilHandlers(props) {
    let { listViewProps, firstListDnDOptions, secondListDnDOptions } = props;
    let list1 = (0, _data.useListData)({
        initialItems: folderList1,
        getKey: (item)=>item.identifier
    });
    let list2 = (0, _data.useListData)({
        initialItems: folderList2,
        getKey: (item)=>item.identifier
    });
    let acceptedDragTypes = [
        "file",
        "folder",
        "text/plain"
    ];
    let { dragAndDropHooks: list1Hooks } = (0, _dnd1.useDragAndDrop)({
        getItems: (keys)=>[
                ...keys
            ].map((key)=>{
                let item = list1.getItem(key);
                return {
                    [`${item.type}`]: JSON.stringify(item),
                    "text/plain": JSON.stringify(item)
                };
            }),
        onDragEnd: (e)=>{
            let { dropOperation, isInternal, keys } = e;
            (0, _addonActions.action)("onDragEnd")(e);
            if (dropOperation === "move" && !isInternal) list1.remove(...keys);
        },
        acceptedDragTypes,
        ...firstListDnDOptions
    });
    let { dragAndDropHooks: list2Hooks } = (0, _dnd1.useDragAndDrop)({
        onRootDrop: async (e)=>{
            (0, _addonActions.action)("onRootDropList1")(e);
            let processedItems = await itemProcessor(e.items, acceptedDragTypes);
            list2.append(...processedItems);
        },
        acceptedDragTypes,
        ...secondListDnDOptions
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
        wrap: true,
        gap: "size-300"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ListView), {
        "aria-label": "Draggable ListView",
        selectionMode: "multiple",
        width: "size-3600",
        height: "size-3600",
        items: list1.items,
        ...listViewProps,
        dragAndDropHooks: list1Hooks
    }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            textValue: item.name,
            key: item.identifier
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, item.name), item.type === "folder" && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _folderDefault.default), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), {
            slot: "description"
        }, `contains ${item.childNodes.length} dropped item(s)`)))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ListView), {
        "aria-label": "Root droppable ListView from dnd hook util handlers",
        selectionMode: "multiple",
        width: "size-3600",
        height: "size-3600",
        items: list2.items,
        ...listViewProps,
        dragAndDropHooks: list2Hooks
    }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            textValue: item.name,
            key: item.identifier
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, item.name), item.type === "folder" && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _folderDefault.default), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), {
            slot: "description"
        }, `contains ${item.childNodes.length} dropped item(s)`)))));
}
function InsertExampleUtilHandlers(props) {
    let { listViewProps, firstListDnDOptions, secondListDnDOptions } = props;
    let list1 = (0, _data.useListData)({
        initialItems: folderList1,
        getKey: (item)=>item.identifier
    });
    let list2 = (0, _data.useListData)({
        initialItems: folderList2,
        getKey: (item)=>item.identifier
    });
    let acceptedDragTypes = [
        "file",
        "folder",
        "text/plain"
    ];
    let { dragAndDropHooks: list1Hooks } = (0, _dnd1.useDragAndDrop)({
        getItems: (keys)=>[
                ...keys
            ].map((key)=>{
                let item = list1.getItem(key);
                return {
                    [`${item.type}`]: JSON.stringify(item),
                    "text/plain": JSON.stringify(item)
                };
            }),
        onDragEnd: (e)=>{
            let { dropOperation, isInternal, keys } = e;
            (0, _addonActions.action)("onDragEnd")(e);
            if (dropOperation === "move" && !isInternal) list1.remove(...keys);
        },
        acceptedDragTypes,
        ...firstListDnDOptions
    });
    let { dragAndDropHooks: list2Hooks } = (0, _dnd1.useDragAndDrop)({
        onInsert: async (e)=>{
            let { items, target } = e;
            (0, _addonActions.action)("onInsertList2")(e);
            let processedItems = await itemProcessor(items, acceptedDragTypes);
            if (target.dropPosition === "before") list2.insertBefore(target.key, ...processedItems);
            else if (target.dropPosition === "after") list2.insertAfter(target.key, ...processedItems);
        },
        acceptedDragTypes,
        ...secondListDnDOptions
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
        wrap: true,
        gap: "size-300"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ListView), {
        "aria-label": "Draggable ListView",
        selectionMode: "multiple",
        width: "size-3600",
        height: "size-3600",
        items: list1.items,
        ...listViewProps,
        dragAndDropHooks: list1Hooks
    }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            textValue: item.name,
            key: item.identifier
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, item.name), item.type === "folder" && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _folderDefault.default), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), {
            slot: "description"
        }, `contains ${item.childNodes.length} dropped item(s)`)))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ListView), {
        "aria-label": "Insert droppable ListView from dnd hook util handlers",
        selectionMode: "multiple",
        width: "size-3600",
        height: "size-3600",
        items: list2.items,
        ...listViewProps,
        dragAndDropHooks: list2Hooks
    }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            textValue: item.name,
            key: item.identifier
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, item.name), item.type === "folder" && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _folderDefault.default), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), {
            slot: "description"
        }, `contains ${item.childNodes.length} dropped item(s)`)))));
}
function FinderDropUtilHandlers(props) {
    let { listViewProps, firstListDnDOptions, secondListDnDOptions } = props;
    let list1 = (0, _data.useListData)({
        initialItems: folderList1,
        getKey: (item)=>item.identifier
    });
    let list2 = (0, _data.useListData)({
        initialItems: folderList2,
        getKey: (item)=>item.identifier
    });
    let { dragAndDropHooks: list1Hooks } = (0, _dnd1.useDragAndDrop)({
        acceptedDragTypes: [
            (0, _dnd.DIRECTORY_DRAG_TYPE)
        ],
        onInsert: async (e)=>{
            (0, _addonActions.action)("onInsertList1")(e);
        },
        onItemDrop: async (e)=>{
            (0, _addonActions.action)("onItemDropList1")(e);
        },
        ...firstListDnDOptions
    });
    let { dragAndDropHooks: list2Hooks } = (0, _dnd1.useDragAndDrop)({
        onInsert: async (e)=>{
            (0, _addonActions.action)("onInsertList2")(e);
        },
        onItemDrop: async (e)=>{
            (0, _addonActions.action)("onItemDropList2")(e);
        },
        acceptedDragTypes: "all",
        ...secondListDnDOptions
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
        wrap: true,
        gap: "size-300"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ListView), {
        "aria-label": "ListView that accepts directory drops only",
        selectionMode: "multiple",
        width: "size-3600",
        height: "size-3600",
        items: list1.items,
        ...listViewProps,
        dragAndDropHooks: list1Hooks
    }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            textValue: item.name,
            key: item.identifier
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, item.name), item.type === "folder" && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _folderDefault.default), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), {
            slot: "description"
        }, `contains ${item.childNodes.length} dropped item(s)`)))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ListView), {
        "aria-label": "ListView that accepts all drag types",
        selectionMode: "multiple",
        width: "size-3600",
        height: "size-3600",
        items: list2.items,
        ...listViewProps,
        dragAndDropHooks: list2Hooks
    }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            textValue: item.name,
            key: item.identifier
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, item.name), item.type === "folder" && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _folderDefault.default), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), {
            slot: "description"
        }, `contains ${item.childNodes.length} dropped item(s)`)))));
}
function DragBetweenListsComplex(props) {
    let { listViewProps, firstListDnDOptions, secondListDnDOptions } = props;
    let list1 = (0, _data.useListData)({
        initialItems: folderList1,
        getKey: (item)=>item.identifier
    });
    let list2 = (0, _data.useListData)({
        initialItems: folderList2,
        getKey: (item)=>item.identifier
    });
    let acceptedDragTypes = [
        "file",
        "folder",
        "text/plain"
    ];
    // List 1 should allow on item drops and external drops, but disallow reordering/internal drops
    let { dragAndDropHooks: dragAndDropHooksList1 } = (0, _dnd1.useDragAndDrop)({
        getItems: (keys)=>[
                ...keys
            ].map((key)=>{
                let item = list1.getItem(key);
                return {
                    [`${item.type}`]: JSON.stringify(item),
                    "text/plain": JSON.stringify(item)
                };
            }),
        onInsert: async (e)=>{
            let { items, target } = e;
            (0, _addonActions.action)("onInsertList1")(e);
            let processedItems = await itemProcessor(items, acceptedDragTypes);
            if (target.dropPosition === "before") list1.insertBefore(target.key, ...processedItems);
            else if (target.dropPosition === "after") list1.insertAfter(target.key, ...processedItems);
        },
        onRootDrop: async (e)=>{
            (0, _addonActions.action)("onRootDropList1")(e);
            let processedItems = await itemProcessor(e.items, acceptedDragTypes);
            list1.append(...processedItems);
        },
        onItemDrop: async (e)=>{
            let { items, target, isInternal, dropOperation } = e;
            (0, _addonActions.action)("onItemDropList1")(e);
            let processedItems = await itemProcessor(items, acceptedDragTypes);
            let targetItem = list1.getItem(target.key);
            list1.update(target.key, {
                ...targetItem,
                childNodes: [
                    ...targetItem.childNodes,
                    ...processedItems
                ]
            });
            if (isInternal && dropOperation === "move") {
                // TODO test this, perhaps it would be easier to also pass the draggedKeys to onItemDrop instead?
                // TODO: dig into other libraries to see how they handle this
                let keysToRemove = processedItems.map((item)=>item.identifier);
                list1.remove(...keysToRemove);
            }
        },
        acceptedDragTypes,
        onDragEnd: (e)=>{
            let { dropOperation, isInternal, keys } = e;
            (0, _addonActions.action)("onDragEndList1")(e);
            if (dropOperation === "move" && !isInternal) list1.remove(...keys);
        },
        getAllowedDropOperations: ()=>[
                "move",
                "copy"
            ],
        shouldAcceptItemDrop: (target)=>!!list1.getItem(target.key).childNodes,
        ...firstListDnDOptions
    });
    // List 2 should allow reordering, on folder drops, and on root drops
    let { dragAndDropHooks: dragAndDropHooksList2 } = (0, _dnd1.useDragAndDrop)({
        getItems: (keys)=>[
                ...keys
            ].map((key)=>{
                let item = list2.getItem(key);
                let dragItem = {};
                let itemString = JSON.stringify(item);
                dragItem[`${item.type}`] = itemString;
                if (item.type !== "unique_type") dragItem["text/plain"] = itemString;
                return dragItem;
            }),
        onInsert: async (e)=>{
            let { items, target } = e;
            (0, _addonActions.action)("onInsertList2")(e);
            let processedItems = await itemProcessor(items, acceptedDragTypes);
            if (target.dropPosition === "before") list2.insertBefore(target.key, ...processedItems);
            else if (target.dropPosition === "after") list2.insertAfter(target.key, ...processedItems);
        },
        onReorder: async (e)=>{
            let { keys, target, dropOperation } = e;
            (0, _addonActions.action)("onReorderList2")(e);
            let itemsToCopy = [];
            if (dropOperation === "copy") for (let key of keys){
                let item = {
                    ...list2.getItem(key)
                };
                item.identifier = Math.random().toString(36).slice(2);
                itemsToCopy.push(item);
            }
            if (target.dropPosition === "before") {
                if (dropOperation === "move") list2.moveBefore(target.key, [
                    ...keys
                ]);
                else if (dropOperation === "copy") list2.insertBefore(target.key, ...itemsToCopy);
            } else if (target.dropPosition === "after") {
                if (dropOperation === "move") list2.moveAfter(target.key, [
                    ...keys
                ]);
                else if (dropOperation === "copy") list2.insertAfter(target.key, ...itemsToCopy);
            }
        },
        onRootDrop: async (e)=>{
            (0, _addonActions.action)("onRootDropList2")(e);
            let processedItems = await itemProcessor(e.items, acceptedDragTypes);
            list2.prepend(...processedItems);
        },
        onItemDrop: async (e)=>{
            let { items, target, isInternal, dropOperation } = e;
            (0, _addonActions.action)("onItemDropList2")(e);
            let processedItems = await itemProcessor(items, acceptedDragTypes);
            let targetItem = list2.getItem(target.key);
            list2.update(target.key, {
                ...targetItem,
                childNodes: [
                    ...targetItem.childNodes,
                    ...processedItems
                ]
            });
            if (isInternal && dropOperation === "move") {
                let keysToRemove = processedItems.map((item)=>item.identifier);
                list2.remove(...keysToRemove);
            }
        },
        acceptedDragTypes,
        onDragEnd: (e)=>{
            let { dropOperation, isInternal, keys } = e;
            (0, _addonActions.action)("onDragEndList2")(e);
            if (dropOperation === "move" && !isInternal) {
                let keysToRemove = [
                    ...keys
                ].filter((key)=>list2.getItem(key).type !== "unique_type");
                list2.remove(...keysToRemove);
            }
        },
        getAllowedDropOperations: ()=>[
                "move",
                "copy"
            ],
        shouldAcceptItemDrop: (target)=>!!list2.getItem(target.key).childNodes,
        ...secondListDnDOptions
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
        wrap: true,
        gap: "size-300"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ListView), {
        "aria-label": "First ListView in drag between list example",
        selectionMode: "multiple",
        width: "size-3600",
        height: "size-3600",
        items: list1.items,
        ...listViewProps,
        dragAndDropHooks: dragAndDropHooksList1
    }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            textValue: item.name,
            key: item.identifier
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, item.name), item.type === "folder" && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _folderDefault.default), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), {
            slot: "description"
        }, `contains ${item.childNodes.length} dropped item(s)`)))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ListView), {
        "aria-label": "Second ListView in drag between list example",
        selectionMode: "multiple",
        width: "size-3600",
        height: "size-3600",
        items: list2.items,
        ...listViewProps,
        dragAndDropHooks: dragAndDropHooksList2,
        ...props
    }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            textValue: item.name,
            key: item.identifier
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, item.name), item.type === "folder" && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _folderDefault.default), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), {
            slot: "description"
        }, `contains ${item.childNodes.length} dropped item(s)`)))));
}
function DragBetweenListsOverride(props) {
    let list1 = (0, _data.useListData)({
        initialItems: [
            {
                identifier: "1",
                type: "file",
                name: "Adobe Photoshop"
            },
            {
                identifier: "2",
                type: "file",
                name: "Adobe XD"
            },
            {
                identifier: "3",
                type: "file",
                name: "Adobe InDesign"
            },
            {
                identifier: "4",
                type: "file",
                name: "Adobe AfterEffects"
            }
        ],
        getKey: (item)=>item.identifier
    });
    let list2 = (0, _data.useListData)({
        initialItems: [
            {
                identifier: "7",
                type: "folder",
                name: "Pictures",
                childNodes: []
            },
            {
                identifier: "8",
                type: "file",
                name: "Adobe Fresco"
            },
            {
                identifier: "9",
                type: "folder",
                name: "Apps",
                childNodes: []
            },
            {
                identifier: "10",
                type: "file",
                name: "Adobe Illustrator"
            },
            {
                identifier: "11",
                type: "file",
                name: "Adobe Lightroom"
            },
            {
                identifier: "12",
                type: "file",
                name: "Adobe Dreamweaver"
            }
        ],
        getKey: (item)=>item.identifier
    });
    let { dragAndDropHooks: dragAndDropHooksList1 } = (0, _dnd1.useDragAndDrop)({
        getItems: (keys)=>[
                ...keys
            ].map((key)=>{
                let item = list1.getItem(key);
                let dragType = `list-1-adobe-${item.type}`;
                return {
                    [`${dragType}`]: JSON.stringify(item),
                    "text/plain": JSON.stringify(item)
                };
            }),
        onDragEnd: (e)=>{
            (0, _addonActions.action)("onDragEnd")(e);
            if (e.dropOperation === "move") list1.remove(...e.keys);
        }
    });
    let { dragAndDropHooks: dragAndDropHooksList2 } = (0, _dnd1.useDragAndDrop)({
        getDropOperation: (target, types)=>{
            if (target.type !== "root" || !(types.has("list-1-adobe-file") || types.has("text/plain"))) return "cancel";
            return "move";
        },
        onDrop: async (e)=>{
            (0, _addonActions.action)("onDrop")(e);
            let { items } = e;
            let itemsToAdd = [];
            let text;
            for (let item of items)if (item.kind === "text") {
                if (item.types.size === 1 && item.types.has("text/plain")) {
                    text = await item.getText("text/plain");
                    itemsToAdd = text.split("\n").map((val)=>JSON.parse(val));
                } else {
                    text = await item.getText("list-1-adobe-file");
                    itemsToAdd.push(JSON.parse(text));
                }
            }
            list2.append(...itemsToAdd);
        },
        // the below utility handlers shouldn't be called because onDrop is defined
        // shouldAcceptItemDrop and acceptedDragTypes shouldn't affect the behavior either
        onInsert: ()=>(0, _addonActions.action)("onInsert"),
        onReorder: ()=>(0, _addonActions.action)("onReorder"),
        onRootDrop: ()=>(0, _addonActions.action)("onRootDrop"),
        onItemDrop: ()=>(0, _addonActions.action)("onItemDrop"),
        shouldAcceptItemDrop: (target)=>!!list2.getItem(target.key).childNodes,
        acceptedDragTypes: "all"
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
        wrap: true,
        gap: "size-300"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ListView), {
        "aria-label": "Draggable listview",
        selectionMode: "multiple",
        width: "size-3600",
        height: "size-3600",
        items: list1.items,
        dragAndDropHooks: dragAndDropHooksList1,
        ...props
    }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            textValue: item.name,
            key: item.identifier
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, item.name), item.type === "folder" && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _folderDefault.default), null))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ListView), {
        "aria-label": "droppable listview",
        selectionMode: "multiple",
        width: "size-3600",
        height: "size-3600",
        items: list2.items,
        dragAndDropHooks: dragAndDropHooksList2,
        ...props
    }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            textValue: item.name,
            key: item.identifier
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, item.name), item.type === "folder" && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _folderDefault.default), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), {
            slot: "description"
        }, `contains ${item.childNodes.length} dropped item(s)`)))));
}

},{"@storybook/addon-actions":"coXbW","@react-aria/dnd":"hi3Sh","@react-spectrum/layout":"hzaUY","@spectrum-icons/illustrations/Folder":"8w4Jp","../":"bkKyS","react":"9yzVZ","@react-spectrum/text":"etCGI","@react-spectrum/dnd":"cHWGH","@react-stately/data":"gEgJM","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"43BAm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Default", ()=>Default);
parcelHelpers.export(exports, "DisableFolders", ()=>DisableFolders);
parcelHelpers.export(exports, "DisableFolderSelection", ()=>DisableFolderSelection);
parcelHelpers.export(exports, "Links", ()=>Links);
parcelHelpers.export(exports, "OnAction", ()=>OnAction);
parcelHelpers.export(exports, "OnActionDisableFolders", ()=>OnActionDisableFolders);
parcelHelpers.export(exports, "onActionDisableFoldersRowActions", ()=>onActionDisableFoldersRowActions);
parcelHelpers.export(exports, "onActionDisableFiles", ()=>onActionDisableFiles);
parcelHelpers.export(exports, "onActionDisableFilesRowActions", ()=>onActionDisableFilesRowActions);
var _addonActions = require("@storybook/addon-actions");
var _menu = require("@react-spectrum/menu");
var _add = require("@spectrum-icons/workflow/Add");
var _addDefault = parcelHelpers.interopDefault(_add);
var _breadcrumbs = require("@react-spectrum/breadcrumbs");
var _utils = require("@react-aria/utils");
var _delete = require("@spectrum-icons/workflow/Delete");
var _deleteDefault = parcelHelpers.interopDefault(_delete);
var _folder = require("@spectrum-icons/illustrations/Folder");
var _folderDefault = parcelHelpers.interopDefault(_folder);
var _ = require("../");
var _listViewStories = require("./ListView.stories");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _text = require("@react-spectrum/text");
exports.default = {
    title: "ListView/Selection",
    component: (0, _.ListView),
    excludeStories: [],
    args: {
        isQuiet: false,
        density: "regular",
        selectionMode: "multiple",
        selectionStyle: "checkbox",
        overflowMode: "truncate",
        disabledBehavior: "selection"
    },
    argTypes: {
        selectionMode: {
            control: {
                type: "radio",
                options: [
                    "none",
                    "single",
                    "multiple"
                ]
            }
        },
        selectionStyle: {
            control: {
                type: "radio",
                options: [
                    "checkbox",
                    "highlight"
                ]
            }
        },
        isQuiet: {
            control: {
                type: "boolean"
            }
        },
        density: {
            control: {
                type: "select",
                options: [
                    "compact",
                    "regular",
                    "spacious"
                ]
            }
        },
        overflowMode: {
            control: {
                type: "radio",
                options: [
                    "truncate",
                    "wrap"
                ]
            }
        },
        disabledBehavior: {
            control: {
                type: "radio",
                options: [
                    "selection",
                    "all"
                ]
            }
        }
    }
};
const Default = {
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ListView), {
            "aria-label": "default selection ListView",
            width: "250px",
            height: 400,
            onSelectionChange: (0, _addonActions.action)("onSelectionChange"),
            items: (0, _listViewStories.items),
            ...args
        }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
                textValue: item.name
            }, item.type === "folder" ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _folderDefault.default), null) : null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, item.name))),
    name: "default"
};
const DisableFolders = {
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ListView), {
            "aria-label": "disabled folders ListView",
            width: "250px",
            height: 400,
            onSelectionChange: (0, _addonActions.action)("onSelectionChange"),
            items: (0, _listViewStories.items),
            disabledKeys: [
                "c",
                "e",
                "m"
            ],
            ...args
        }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
                textValue: item.name
            }, item.type === "folder" ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _folderDefault.default), null) : null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, item.name))),
    name: "disable folders"
};
const DisableFolderSelection = {
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ListView), {
            "aria-label": "disabled folder selection ListView",
            width: "250px",
            height: 400,
            onSelectionChange: (0, _addonActions.action)("onSelectionChange"),
            items: (0, _listViewStories.items),
            disabledKeys: [
                "c",
                "e",
                "m"
            ],
            disabledBehavior: "selection",
            ...args
        }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
                textValue: item.name
            }, item.type === "folder" ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _folderDefault.default), null) : null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, item.name), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _menu.ActionMenu), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
                key: "add"
            }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _addDefault.default), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, "Add")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
                key: "delete"
            }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _deleteDefault.default), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, "Delete"))))),
    name: "disable folders selection"
};
const Links = (args)=>{
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ListView), {
        "aria-label": "ListView with links",
        width: "250px",
        height: 400,
        onSelectionChange: (0, _addonActions.action)("onSelectionChange"),
        ...args
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
        key: "https://adobe.com/",
        href: "https://adobe.com/"
    }, "Adobe"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
        key: "https://google.com/",
        href: "https://google.com/"
    }, "Google"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
        key: "https://apple.com/",
        href: "https://apple.com/"
    }, "Apple"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
        key: "https://nytimes.com/",
        href: "https://nytimes.com/"
    }, "New York Times"));
};
const OnAction = {
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(NavigationExample, args),
    name: "onAction"
};
const OnActionDisableFolders = {
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(NavigationExample, {
            disabledType: "folder",
            disabledBehavior: "selection",
            ...args
        }),
    name: "onAction, disable folder selection"
};
const onActionDisableFoldersRowActions = {
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(NavigationExample, {
            disabledType: "folder",
            disabledBehavior: "selection",
            showActions: true,
            ...args
        }),
    name: "onAction, disable folder selection, with row action"
};
const onActionDisableFiles = {
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(NavigationExample, {
            disabledType: "file",
            ...args
        }),
    name: "onAction, disable files"
};
const onActionDisableFilesRowActions = {
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(NavigationExample, {
            disabledType: "file",
            showActions: true,
            ...args
        }),
    name: "onAction, disable files, with row actions"
};
function NavigationExample(props) {
    let [selectedKeys, setSelectedKeys] = (0, _react.useState)(new Set());
    let [breadcrumbs, setBreadcrumbs] = (0, _react.useState)([
        {
            key: "root",
            name: "Root",
            type: "folder",
            children: (0, _listViewStories.items)
        }
    ]);
    let { name, children } = breadcrumbs[breadcrumbs.length - 1];
    let onAction = (key)=>{
        let item = children.find((item)=>item.key === key);
        if (item.type === "folder") {
            setBreadcrumbs([
                ...breadcrumbs,
                item
            ]);
            setSelectedKeys(new Set());
        }
    };
    let onBreadcrumbAction = (key)=>{
        let index = breadcrumbs.findIndex((item)=>item.key === key);
        setBreadcrumbs(breadcrumbs.slice(0, index + 1));
        setSelectedKeys(new Set());
    };
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _breadcrumbs.Breadcrumbs), {
        onAction: onBreadcrumbAction
    }, breadcrumbs.map((item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            key: item.key
        }, item.name))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ListView), {
        "aria-label": name,
        width: "250px",
        height: 400,
        onSelectionChange: (0, _utils.chain)(setSelectedKeys, (0, _addonActions.action)("onSelectionChange")),
        selectionMode: "multiple",
        selectionStyle: "checkbox",
        selectedKeys: selectedKeys,
        items: children,
        disabledKeys: props.disabledType ? children.filter((item)=>item.type === props.disabledType).map((item)=>item.key) : null,
        onAction: (0, _utils.chain)(onAction, (0, _addonActions.action)("onAction")),
        ...props
    }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            hasChildItems: item.type === "folder",
            textValue: item.name
        }, item.type === "folder" ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _folderDefault.default), null) : null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, item.name), props.showActions && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _menu.ActionMenu), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            key: "add"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _addDefault.default), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, "Add")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            key: "delete"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _deleteDefault.default), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, "Delete"))))));
}

},{"@storybook/addon-actions":"coXbW","@react-spectrum/menu":"asqy4","@spectrum-icons/workflow/Add":"evYih","@react-spectrum/breadcrumbs":"2lBZC","@react-aria/utils":"9cLk5","@spectrum-icons/workflow/Delete":"foJ71","@spectrum-icons/illustrations/Folder":"8w4Jp","../":"bkKyS","./ListView.stories":"7ktXC","react":"9yzVZ","@react-spectrum/text":"etCGI","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"54byp":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DefaultListBox", ()=>DefaultListBox);
parcelHelpers.export(exports, "ListBoxWSections", ()=>ListBoxWSections);
parcelHelpers.export(exports, "ListBoxWManySectionsAndSelection", ()=>ListBoxWManySectionsAndSelection);
parcelHelpers.export(exports, "ListBoxWSectionsAndFalsyIds", ()=>ListBoxWSectionsAndFalsyIds);
parcelHelpers.export(exports, "ListBoxWSectionsAndNoTitle", ()=>ListBoxWSectionsAndNoTitle);
parcelHelpers.export(exports, "Static", ()=>Static);
parcelHelpers.export(exports, "StaticWithSectionsAndSelection", ()=>StaticWithSectionsAndSelection);
parcelHelpers.export(exports, "StaticWithSectionsAndNoTitle", ()=>StaticWithSectionsAndNoTitle);
parcelHelpers.export(exports, "WithDefaultSelectedOption", ()=>WithDefaultSelectedOption);
parcelHelpers.export(exports, "SingleSelectionWithDefaultSelectedOption", ()=>SingleSelectionWithDefaultSelectedOption);
parcelHelpers.export(exports, "StaticWithDefaultSelectedOptions", ()=>StaticWithDefaultSelectedOptions);
parcelHelpers.export(exports, "WithSelectedOptionsControlled", ()=>WithSelectedOptionsControlled);
parcelHelpers.export(exports, "StaticWithSelectedOptionsControlled", ()=>StaticWithSelectedOptionsControlled);
parcelHelpers.export(exports, "WithDisabledOptions", ()=>WithDisabledOptions);
parcelHelpers.export(exports, "StaticWithDisabledOptions", ()=>StaticWithDisabledOptions);
parcelHelpers.export(exports, "MultipleSelection", ()=>MultipleSelection);
parcelHelpers.export(exports, "MultipleSelectionStatic", ()=>MultipleSelectionStatic);
parcelHelpers.export(exports, "NoSelectionAllowed", ()=>NoSelectionAllowed);
parcelHelpers.export(exports, "NoSelectionAllowedStatic", ()=>NoSelectionAllowedStatic);
parcelHelpers.export(exports, "ListBoxWithAutoFocusTrue", ()=>ListBoxWithAutoFocusTrue);
parcelHelpers.export(exports, "ListBoxWithAutoFocusComplex", ()=>ListBoxWithAutoFocusComplex);
parcelHelpers.export(exports, "ListBoxWithAutoFocusFirst", ()=>ListBoxWithAutoFocusFirst);
parcelHelpers.export(exports, "ListBoxWithAutoFocusLast", ()=>ListBoxWithAutoFocusLast);
parcelHelpers.export(exports, "ListBoxWithKeyboardSelectionWrapping", ()=>ListBoxWithKeyboardSelectionWrapping);
parcelHelpers.export(exports, "WithSemanticElementsStatic", ()=>WithSemanticElementsStatic);
parcelHelpers.export(exports, "WithSemanticElementsGenerativeMultipleSelection", ()=>WithSemanticElementsGenerativeMultipleSelection);
parcelHelpers.export(exports, "IsLoading", ()=>IsLoading);
parcelHelpers.export(exports, "IsLoadingMore", ()=>IsLoadingMore);
parcelHelpers.export(exports, "AsyncLoading", ()=>AsyncLoading);
parcelHelpers.export(exports, "AsyncLoadingResizable", ()=>AsyncLoadingResizable);
parcelHelpers.export(exports, "ListboxContainers", ()=>ListboxContainers);
parcelHelpers.export(exports, "RestoreFocusExample", ()=>RestoreFocusExample);
parcelHelpers.export(exports, "WithTranslations", ()=>WithTranslations);
parcelHelpers.export(exports, "FocusExample", ()=>FocusExample);
parcelHelpers.export(exports, "Links", ()=>Links);
parcelHelpers.export(exports, "WithAvatars", ()=>WithAvatars);
var _addonActions = require("@storybook/addon-actions");
var _reactSpectrum = require("@adobe/react-spectrum");
var _alignCenter = require("@spectrum-icons/workflow/AlignCenter");
var _alignCenterDefault = parcelHelpers.interopDefault(_alignCenter);
var _alignLeft = require("@spectrum-icons/workflow/AlignLeft");
var _alignLeftDefault = parcelHelpers.interopDefault(_alignLeft);
var _alignRight = require("@spectrum-icons/workflow/AlignRight");
var _alignRightDefault = parcelHelpers.interopDefault(_alignRight);
var _blower = require("@spectrum-icons/workflow/Blower");
var _blowerDefault = parcelHelpers.interopDefault(_blower);
var _book = require("@spectrum-icons/workflow/Book");
var _bookDefault = parcelHelpers.interopDefault(_book);
var _copy = require("@spectrum-icons/workflow/Copy");
var _copyDefault = parcelHelpers.interopDefault(_copy);
var _cut = require("@spectrum-icons/workflow/Cut");
var _cutDefault = parcelHelpers.interopDefault(_cut);
var _delete = require("@spectrum-icons/workflow/Delete");
var _deleteDefault = parcelHelpers.interopDefault(_delete);
var _focus = require("@react-aria/focus");
var _ = require("../");
var _label = require("@react-spectrum/label");
var _paste = require("@spectrum-icons/workflow/Paste");
var _pasteDefault = parcelHelpers.interopDefault(_paste);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _listBoxLanguagesChromatic = require("./../chromatic/ListBoxLanguages.chromatic");
var _data = require("@react-stately/data");
let iconMap = {
    AlignCenter: (0, _alignCenterDefault.default),
    AlignLeft: (0, _alignLeftDefault.default),
    AlignRight: (0, _alignRightDefault.default),
    Blower: (0, _blowerDefault.default),
    Book: (0, _bookDefault.default),
    Copy: (0, _copyDefault.default),
    Cut: (0, _cutDefault.default),
    Paste: (0, _pasteDefault.default)
};
let hardModeProgrammatic = [
    {
        name: "Section 1",
        children: [
            {
                name: "Copy",
                icon: "Copy"
            },
            {
                name: "Cut",
                icon: "Cut"
            },
            {
                name: "Paste",
                icon: "Paste"
            }
        ]
    },
    {
        name: "Section 2",
        children: [
            {
                name: "Puppy",
                icon: "AlignLeft"
            },
            {
                name: "Doggo",
                icon: "AlignCenter"
            },
            {
                name: "Floof",
                icon: "AlignRight"
            }
        ]
    }
];
let flatOptions = [
    {
        name: "Aardvark"
    },
    {
        name: "Kangaroo"
    },
    {
        name: "Snake"
    },
    {
        name: "Danni"
    },
    {
        name: "Devon"
    },
    {
        name: "Ross"
    },
    {
        name: "Puppy"
    },
    {
        name: "Doggo"
    },
    {
        name: "Floof"
    }
];
let withSection = [
    {
        name: "Animals",
        children: [
            {
                name: "Aardvark"
            },
            {
                name: "Kangaroo"
            },
            {
                name: "Snake"
            }
        ]
    },
    {
        name: "People",
        children: [
            {
                name: "Danni"
            },
            {
                name: "Devon"
            },
            {
                name: "Ross"
            }
        ]
    }
];
let itemsWithFalsyId = [
    {
        id: 0,
        name: "key=0",
        children: [
            {
                id: 1,
                name: "Aardvark"
            },
            {
                id: 2,
                name: "Kangaroo"
            },
            {
                id: 3,
                name: "Snake"
            }
        ]
    },
    {
        id: "",
        name: 'key=""',
        children: [
            {
                id: 4,
                name: "Danni"
            },
            {
                id: 5,
                name: "Devon"
            },
            {
                id: 6,
                name: "Ross"
            }
        ]
    }
];
let lotsOfSections = [];
for(let i = 0; i < 50; i++){
    let children = [];
    for(let j = 0; j < 50; j++)children.push({
        name: `Section ${i}, Item ${j}`
    });
    lotsOfSections.push({
        name: "Section " + i,
        children
    });
}
exports.default = {
    title: "ListBox",
    excludeStories: [
        "FocusExample"
    ]
};
function StoryDecorator(props) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        style: {
            display: "flex",
            flexDirection: "column"
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _label.Label), {
        id: "label"
    }, "Choose an item"), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        style: {
            display: "flex",
            minWidth: "200px",
            background: "var(--spectrum-global-color-gray-50)",
            border: "1px solid lightgray",
            maxHeight: 300
        }
    }, props.children));
}
const DefaultListBox = {
    render: ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ListBox), {
            flexGrow: 1,
            "aria-labelledby": "label",
            items: flatOptions
        }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
                key: item.name
            }, item.name)),
    decorators: [
        (Story)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(StoryDecorator, null, /*#__PURE__*/ (0, _reactDefault.default).createElement(Story, null))
    ],
    name: "Default ListBox"
};
const ListBoxWSections = {
    render: ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ListBox), {
            flexGrow: 1,
            "aria-labelledby": "label",
            items: withSection
        }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Section), {
                key: item.name,
                items: item.children,
                title: item.name
            }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
                    key: item.name
                }, item.name))),
    decorators: [
        (Story)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(StoryDecorator, null, /*#__PURE__*/ (0, _reactDefault.default).createElement(Story, null))
    ],
    name: "ListBox w/ sections"
};
const ListBoxWManySectionsAndSelection = {
    render: ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ListBox), {
            flexGrow: 1,
            "aria-labelledby": "label",
            selectionMode: "multiple",
            items: lotsOfSections,
            onSelectionChange: (0, _addonActions.action)("onSelectionChange")
        }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Section), {
                key: item.name,
                items: item.children,
                title: item.name
            }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
                    key: item.name
                }, item.name))),
    decorators: [
        (Story)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(StoryDecorator, null, /*#__PURE__*/ (0, _reactDefault.default).createElement(Story, null))
    ],
    name: "ListBox w/ many sections and selection"
};
const ListBoxWSectionsAndFalsyIds = {
    render: ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ListBox), {
            flexGrow: 1,
            "aria-labelledby": "label",
            items: itemsWithFalsyId,
            selectionMode: "multiple",
            onSelectionChange: (0, _addonActions.action)("onSelectionChange")
        }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Section), {
                items: item.children,
                title: item.name
            }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), null, item.name))),
    decorators: [
        (Story)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(StoryDecorator, null, /*#__PURE__*/ (0, _reactDefault.default).createElement(Story, null))
    ],
    name: "ListBox w/ sections and falsy ids"
};
const ListBoxWSectionsAndNoTitle = {
    render: ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ListBox), {
            flexGrow: 1,
            "aria-labelledby": "label",
            items: withSection
        }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Section), {
                key: item.name,
                items: item.children,
                "aria-label": item.name
            }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
                    key: item.name
                }, item.name))),
    decorators: [
        (Story)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(StoryDecorator, null, /*#__PURE__*/ (0, _reactDefault.default).createElement(Story, null))
    ],
    name: "ListBox w/ sections and no title"
};
const Static = {
    render: ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ListBox), {
            flexGrow: 1,
            "aria-labelledby": "label"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), null, "One"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), null, "Two"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), null, "Three")),
    decorators: [
        (Story)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(StoryDecorator, null, /*#__PURE__*/ (0, _reactDefault.default).createElement(Story, null))
    ]
};
const StaticWithSectionsAndSelection = {
    render: ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ListBox), {
            flexGrow: 1,
            "aria-labelledby": "label",
            selectionMode: "multiple"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Section), {
            title: "Section 1"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), null, "One"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), null, "Two"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), null, "Three")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Section), {
            title: "Section 2"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), null, "One"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), null, "Two"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), null, "Three"))),
    decorators: [
        (Story)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(StoryDecorator, null, /*#__PURE__*/ (0, _reactDefault.default).createElement(Story, null))
    ],
    name: "Static with sections and selection"
};
const StaticWithSectionsAndNoTitle = {
    render: ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ListBox), {
            flexGrow: 1,
            "aria-labelledby": "label"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Section), {
            "aria-label": "Section 1"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), null, "One"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), null, "Two"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), null, "Three")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Section), {
            "aria-label": "Section 2"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), null, "One"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), null, "Two"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), null, "Three"))),
    decorators: [
        (Story)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(StoryDecorator, null, /*#__PURE__*/ (0, _reactDefault.default).createElement(Story, null))
    ],
    name: "Static with sections and no title"
};
const WithDefaultSelectedOption = {
    render: ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ListBox), {
            flexGrow: 1,
            "aria-labelledby": "label",
            selectionMode: "multiple",
            onSelectionChange: (0, _addonActions.action)("onSelectionChange"),
            items: withSection,
            defaultSelectedKeys: [
                "Kangaroo"
            ]
        }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Section), {
                key: item.name,
                items: item.children,
                title: item.name
            }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
                    key: item.name
                }, item.name))),
    decorators: [
        (Story)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(StoryDecorator, null, /*#__PURE__*/ (0, _reactDefault.default).createElement(Story, null))
    ],
    name: "with default selected option"
};
const SingleSelectionWithDefaultSelectedOption = {
    render: ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ListBox), {
            flexGrow: 1,
            selectionMode: "single",
            onSelectionChange: (0, _addonActions.action)("onSelectionChange"),
            "aria-labelledby": "label",
            items: flatOptions,
            defaultSelectedKeys: [
                "Kangaroo"
            ]
        }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
                key: item.name
            }, item.name)),
    decorators: [
        (Story)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(StoryDecorator, null, /*#__PURE__*/ (0, _reactDefault.default).createElement(Story, null))
    ],
    name: "single selection with default selected option"
};
const StaticWithDefaultSelectedOptions = {
    render: ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ListBox), {
            flexGrow: 1,
            "aria-labelledby": "label",
            selectionMode: "multiple",
            onSelectionChange: (0, _addonActions.action)("onSelectionChange"),
            defaultSelectedKeys: [
                "2",
                "3"
            ]
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Section), {
            title: "Section 1"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            key: "1"
        }, "One"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            key: "2"
        }, "Two"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            key: "3"
        }, "Three")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Section), {
            title: "Section 2"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            key: "4"
        }, "Four"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            key: "5"
        }, "Five"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            key: "6"
        }, "Six"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            key: "7"
        }, "Seven"))),
    decorators: [
        (Story)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(StoryDecorator, null, /*#__PURE__*/ (0, _reactDefault.default).createElement(Story, null))
    ],
    name: "static with default selected options"
};
const WithSelectedOptionsControlled = {
    render: ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ListBox), {
            flexGrow: 1,
            "aria-labelledby": "label",
            selectionMode: "multiple",
            onSelectionChange: (0, _addonActions.action)("onSelectionChange"),
            items: withSection,
            selectedKeys: [
                "Kangaroo"
            ]
        }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Section), {
                key: item.name,
                items: item.children,
                title: item.name
            }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
                    key: item.name
                }, item.name))),
    decorators: [
        (Story)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(StoryDecorator, null, /*#__PURE__*/ (0, _reactDefault.default).createElement(Story, null))
    ],
    name: "with selected options (controlled)"
};
const StaticWithSelectedOptionsControlled = {
    render: ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ListBox), {
            flexGrow: 1,
            "aria-labelledby": "label",
            selectionMode: "multiple",
            onSelectionChange: (0, _addonActions.action)("onSelectionChange"),
            selectedKeys: [
                "2"
            ]
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Section), {
            title: "Section 1"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            key: "1"
        }, "One"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            key: "2"
        }, "Two"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            key: "3"
        }, "Three")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Section), {
            title: "Section 2"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            key: "4"
        }, "Four"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            key: "5"
        }, "Five"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            key: "6"
        }, "Six"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            key: "7"
        }, "Seven"))),
    decorators: [
        (Story)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(StoryDecorator, null, /*#__PURE__*/ (0, _reactDefault.default).createElement(Story, null))
    ],
    name: "static with selected options (controlled)"
};
const WithDisabledOptions = {
    render: ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ListBox), {
            flexGrow: 1,
            "aria-labelledby": "label",
            items: withSection,
            disabledKeys: [
                "Kangaroo",
                "Ross"
            ]
        }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Section), {
                key: item.name,
                items: item.children,
                title: item.name
            }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
                    key: item.name
                }, item.name))),
    decorators: [
        (Story)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(StoryDecorator, null, /*#__PURE__*/ (0, _reactDefault.default).createElement(Story, null))
    ],
    name: "with disabled options"
};
const StaticWithDisabledOptions = {
    render: ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ListBox), {
            flexGrow: 1,
            "aria-labelledby": "label",
            disabledKeys: [
                "3",
                "5"
            ]
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Section), {
            title: "Section 1"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            key: "1"
        }, "One"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            key: "2"
        }, "Two"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            key: "3"
        }, "Three")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Section), {
            title: "Section 2"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            key: "4"
        }, "Four"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            key: "5"
        }, "Five"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            key: "6"
        }, "Six"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            key: "7"
        }, "Seven"))),
    decorators: [
        (Story)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(StoryDecorator, null, /*#__PURE__*/ (0, _reactDefault.default).createElement(Story, null))
    ],
    name: "static with disabled options"
};
const MultipleSelection = {
    render: ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ListBox), {
            flexGrow: 1,
            "aria-labelledby": "label",
            items: withSection,
            onSelectionChange: (0, _addonActions.action)("onSelectionChange"),
            selectionMode: "multiple",
            defaultSelectedKeys: [
                "Aardvark",
                "Snake"
            ],
            disabledKeys: [
                "Kangaroo",
                "Ross"
            ]
        }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Section), {
                key: item.name,
                items: item.children,
                title: item.name
            }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
                    key: item.name
                }, item.name))),
    decorators: [
        (Story)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(StoryDecorator, null, /*#__PURE__*/ (0, _reactDefault.default).createElement(Story, null))
    ],
    name: "Multiple selection"
};
const MultipleSelectionStatic = {
    render: ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ListBox), {
            flexGrow: 1,
            "aria-labelledby": "label",
            onSelectionChange: (0, _addonActions.action)("onSelectionChange"),
            selectionMode: "multiple",
            defaultSelectedKeys: [
                "2",
                "5"
            ],
            disabledKeys: [
                "1",
                "3"
            ]
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Section), {
            title: "Section 1"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            key: "1"
        }, "One"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            key: "2"
        }, "Two"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            key: "3"
        }, "Three")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Section), {
            title: "Section 2"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            key: "4"
        }, "Four"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            key: "5"
        }, "Five"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            key: "6"
        }, "Six"))),
    decorators: [
        (Story)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(StoryDecorator, null, /*#__PURE__*/ (0, _reactDefault.default).createElement(Story, null))
    ],
    name: "Multiple selection, static"
};
const NoSelectionAllowed = {
    render: ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ListBox), {
            flexGrow: 1,
            "aria-labelledby": "label",
            items: withSection
        }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Section), {
                key: item.name,
                items: item.children,
                title: item.name
            }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
                    key: item.name
                }, item.name))),
    decorators: [
        (Story)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(StoryDecorator, null, /*#__PURE__*/ (0, _reactDefault.default).createElement(Story, null))
    ],
    name: "No selection allowed"
};
const NoSelectionAllowedStatic = {
    render: ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ListBox), {
            flexGrow: 1,
            "aria-labelledby": "label"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Section), {
            title: "Section 1"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), null, "One"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), null, "Two"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), null, "Three")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Section), {
            title: "Section 2"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), null, "Four"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), null, "Five"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), null, "Six"))),
    decorators: [
        (Story)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(StoryDecorator, null, /*#__PURE__*/ (0, _reactDefault.default).createElement(Story, null))
    ],
    name: "No selection allowed, static"
};
const ListBoxWithAutoFocusTrue = {
    render: ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ListBox), {
            flexGrow: 1,
            "aria-labelledby": "label",
            items: withSection,
            autoFocus: true
        }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Section), {
                key: item.name,
                items: item.children,
                title: item.name
            }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
                    key: item.name
                }, item.name))),
    decorators: [
        (Story)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(StoryDecorator, null, /*#__PURE__*/ (0, _reactDefault.default).createElement(Story, null))
    ],
    name: "ListBox with autoFocus=true"
};
const ListBoxWithAutoFocusComplex = {
    render: ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ListBox), {
            flexGrow: 1,
            "aria-labelledby": "label",
            items: withSection,
            autoFocus: true,
            defaultSelectedKeys: [
                "Snake"
            ],
            selectionMode: "single"
        }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Section), {
                key: item.name,
                items: item.children,
                title: item.name
            }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
                    key: item.name
                }, item.name))),
    decorators: [
        (Story)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(StoryDecorator, null, /*#__PURE__*/ (0, _reactDefault.default).createElement(Story, null))
    ],
    name: "ListBox with autoFocus=true, selectionMode=single, default selected key (uncontrolled)"
};
const ListBoxWithAutoFocusFirst = {
    render: ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ListBox), {
            flexGrow: 1,
            "aria-labelledby": "label",
            items: withSection,
            selectionMode: "multiple",
            onSelectionChange: (0, _addonActions.action)("onSelectionChange"),
            autoFocus: "first"
        }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Section), {
                key: item.name,
                items: item.children,
                title: item.name
            }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
                    key: item.name
                }, item.name))),
    decorators: [
        (Story)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(StoryDecorator, null, /*#__PURE__*/ (0, _reactDefault.default).createElement(Story, null))
    ],
    name: 'ListBox with autoFocus="first"'
};
const ListBoxWithAutoFocusLast = {
    render: ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ListBox), {
            flexGrow: 1,
            "aria-labelledby": "label",
            items: withSection,
            selectionMode: "multiple",
            onSelectionChange: (0, _addonActions.action)("onSelectionChange"),
            autoFocus: "last"
        }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Section), {
                key: item.name,
                items: item.children,
                title: item.name
            }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
                    key: item.name
                }, item.name))),
    decorators: [
        (Story)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(StoryDecorator, null, /*#__PURE__*/ (0, _reactDefault.default).createElement(Story, null))
    ],
    name: 'ListBox with autoFocus="last"'
};
const ListBoxWithKeyboardSelectionWrapping = {
    render: ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ListBox), {
            flexGrow: 1,
            "aria-labelledby": "label",
            items: withSection,
            selectionMode: "multiple",
            onSelectionChange: (0, _addonActions.action)("onSelectionChange"),
            shouldFocusWrap: true
        }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Section), {
                key: item.name,
                items: item.children,
                title: item.name
            }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
                    key: item.name
                }, item.name))),
    decorators: [
        (Story)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(StoryDecorator, null, /*#__PURE__*/ (0, _reactDefault.default).createElement(Story, null))
    ],
    name: "ListBox with keyboard selection wrapping"
};
const WithSemanticElementsStatic = {
    render: ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ListBox), {
            flexGrow: 1,
            "aria-labelledby": "label",
            selectionMode: "multiple",
            disabledKeys: [
                "paste",
                "floof"
            ],
            onSelectionChange: (0, _addonActions.action)("onSelectionChange")
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Section), {
            title: "Section 1"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            key: "copy",
            textValue: "Copy"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _copyDefault.default), {
            size: "S"
        }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSpectrum.Text), null, "Copy")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            key: "cut",
            textValue: "Cut"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _cutDefault.default), {
            size: "S"
        }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSpectrum.Text), null, "Cut")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            key: "paste",
            textValue: "Paste"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _pasteDefault.default), {
            size: "S"
        }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSpectrum.Text), null, "Paste"))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Section), {
            title: "Section 2"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            key: "puppy",
            textValue: "Puppy"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _alignLeftDefault.default), {
            size: "S"
        }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSpectrum.Text), null, "Puppy"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSpectrum.Text), {
            slot: "description"
        }, "Puppy description super long as well geez")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            key: "floof",
            textValue: "Floof"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _alignRightDefault.default), {
            size: "S"
        }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSpectrum.Text), null, "Floof"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSpectrum.Text), {
            slot: "description"
        }, "Floof medium description")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            key: "doggo",
            textValue: "Doggo with really really really long long long text"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _alignCenterDefault.default), {
            size: "S"
        }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSpectrum.Text), null, "Doggo with really really really long long long text")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            key: "basic"
        }, "Basic Item"))),
    decorators: [
        (Story)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(StoryDecorator, null, /*#__PURE__*/ (0, _reactDefault.default).createElement(Story, null))
    ],
    name: "with semantic elements (static)"
};
const WithSemanticElementsGenerativeMultipleSelection = {
    render: ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ListBox), {
            flexGrow: 1,
            "aria-labelledby": "label",
            items: hardModeProgrammatic,
            onSelectionChange: (0, _addonActions.action)("onSelectionChange"),
            selectionMode: "multiple"
        }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Section), {
                key: item.name,
                items: item.children,
                title: item.name
            }, (item)=>customOption(item))),
    decorators: [
        (Story)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(StoryDecorator, null, /*#__PURE__*/ (0, _reactDefault.default).createElement(Story, null))
    ],
    name: "with semantic elements (generative), multiple selection"
};
const IsLoading = {
    render: ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ListBox), {
            flexGrow: 1,
            "aria-labelledby": "label",
            items: [],
            isLoading: true
        }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), null, item.name)),
    decorators: [
        (Story)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(StoryDecorator, null, /*#__PURE__*/ (0, _reactDefault.default).createElement(Story, null))
    ],
    name: "isLoading"
};
const IsLoadingMore = {
    render: ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ListBox), {
            flexGrow: 1,
            "aria-labelledby": "label",
            items: flatOptions,
            isLoading: true
        }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
                key: item.name
            }, item.name)),
    decorators: [
        (Story)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(StoryDecorator, null, /*#__PURE__*/ (0, _reactDefault.default).createElement(Story, null))
    ],
    name: "isLoading more"
};
const AsyncLoading = {
    render: ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement(AsyncLoadingExample, null),
    decorators: [
        (Story)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(StoryDecorator, null, /*#__PURE__*/ (0, _reactDefault.default).createElement(Story, null))
    ],
    name: "async loading"
};
const AsyncLoadingResizable = {
    render: ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
            style: {
                display: "flex",
                height: "200px",
                flexGrow: 1,
                minWidth: "200px",
                padding: "10px",
                resize: "both",
                overflow: "auto"
            }
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement(AsyncLoadingExample, null)),
    decorators: [
        (Story)=>/*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
                style: {
                    display: "flex",
                    flexDirection: "column"
                }
            }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _label.Label), {
                id: "label"
            }, "Choose an item"), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
                style: {
                    display: "flex",
                    minWidth: "200px",
                    background: "var(--spectrum-global-color-gray-50)",
                    border: "1px solid lightgray"
                }
            }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Story, null)))
    ],
    name: "async loading, resizable"
};
const ListboxContainers = {
    render: ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement(App, null),
    decorators: null,
    name: "listbox containers"
};
const RestoreFocusExample = {
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(FocusExample, args),
    decorators: null,
    name: "restore focus after deleting selected items"
};
const WithTranslations = {
    render: ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _listBoxLanguagesChromatic.TranslateListBox), null),
    decorators: null,
    name: "with translations",
    parameters: {
        description: {
            data: "Translations included for: Arabic, English, Hebrew, Japanese, Korean, Simplified Chinese, and Traditional Chinese."
        }
    }
};
let customOption = (item)=>{
    let Icon = iconMap[item.icon];
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
        textValue: item.name,
        key: item.name
    }, item.icon && /*#__PURE__*/ (0, _reactDefault.default).createElement(Icon, {
        size: "S"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSpectrum.Text), null, item.name));
};
function AsyncLoadingExample() {
    let list = (0, _data.useAsyncList)({
        async load ({ signal, cursor }) {
            let res = await fetch(cursor || "https://pokeapi.co/api/v2/pokemon", {
                signal
            });
            let json = await res.json();
            return {
                items: json.results,
                cursor: json.next
            };
        }
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ListBox), {
        flexGrow: 1,
        "aria-labelledby": "label",
        items: list.items,
        isLoading: list.isLoading,
        onLoadMore: list.loadMore
    }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            key: item.name
        }, item.name));
}
let itemsForDemo = Array.from(new Array(100)).map((val, index)=>({
        val,
        index
    }));
function App() {
    let [size, setSize] = (0, _react.useState)("700px");
    const toggleSize = ()=>{
        if (size === "700px") setSize("300px");
        else setSize("700px");
    };
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSpectrum.Button), {
        variant: "primary",
        onPress: toggleSize
    }, " Toggle Size"), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        style: {
            display: "flex",
            height: size,
            overflow: "hidden"
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSpectrum.Flex), {
        maxHeight: "300px"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSpectrum.Text), {
        id: "label1"
    }, "Max-Height: 300px"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ListBox), {
        width: "150px",
        items: itemsForDemo,
        "aria-labelledby": "label1"
    }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            textValue: String(item.index),
            key: item.index
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSpectrum.Text), null, "IDX: ", item.index)))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSpectrum.Flex), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSpectrum.Text), {
        id: "label2"
    }, "None"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ListBox), {
        width: "150px",
        items: itemsForDemo,
        "aria-labelledby": "label2"
    }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            textValue: String(item.index),
            key: item.index
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSpectrum.Text), null, "IDX: ", item.index)))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSpectrum.Flex), {
        maxHeight: "700px"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSpectrum.Text), {
        id: "label3"
    }, "Max-Height: 700px"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ListBox), {
        width: "150px",
        items: itemsForDemo,
        "aria-labelledby": "label3"
    }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            textValue: String(item.index),
            key: item.index
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSpectrum.Text), null, "IDX: ", item.index)))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSpectrum.Flex), {
        maxHeight: "100%"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSpectrum.Text), {
        id: "label4"
    }, "MaxHeight: 100%"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ListBox), {
        width: "150px",
        items: itemsForDemo,
        "aria-labelledby": "label4"
    }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            textValue: String(item.index),
            key: item.index
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSpectrum.Text), null, "IDX: ", item.index)))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSpectrum.Flex), {
        maxHeight: "50%"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSpectrum.Text), {
        id: "label5"
    }, "MaxHeight: 50%"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ListBox), {
        width: "150px",
        items: itemsForDemo,
        "aria-labelledby": "label5"
    }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            textValue: String(item.index),
            key: item.index
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSpectrum.Text), null, "IDX: ", item.index)))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSpectrum.Flex), {
        height: "700px"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSpectrum.Text), {
        id: "label6"
    }, "Height: 700px"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ListBox), {
        width: "150px",
        items: itemsForDemo,
        "aria-labelledby": "label6"
    }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            textValue: String(item.index),
            key: item.index
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSpectrum.Text), null, "IDX: ", item.index)))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSpectrum.Flex), {
        height: "100%"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSpectrum.Text), {
        id: "label7"
    }, "Height: 100%"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ListBox), {
        width: "150px",
        items: itemsForDemo,
        "aria-labelledby": "label7"
    }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            textValue: String(item.index),
            key: item.index
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSpectrum.Text), null, "IDX: ", item.index))))));
}
function FocusExample(args = {}) {
    let tree = (0, _data.useTreeData)({
        initialItems: withSection,
        getKey: (item)=>item.name,
        getChildren: (item)=>item.children
    });
    let [dialog, setDialog] = (0, _react.useState)(null);
    let ref = (0, _react.useRef)(null);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _focus.FocusScope), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSpectrum.Flex), {
        direction: "column"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSpectrum.ActionGroup), {
        marginBottom: 8,
        onAction: (action)=>setDialog({
                action
            })
    }, tree.selectedKeys.size > 0 && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
        key: "bulk-delete",
        "aria-label": "Delete selected items"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _deleteDefault.default), null))), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        style: {
            display: "flex",
            flexDirection: "column"
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _label.Label), {
        id: "label"
    }, "Choose items"), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        style: {
            display: "flex",
            minWidth: "200px",
            background: "var(--spectrum-global-color-gray-50)",
            border: "1px solid lightgray",
            maxHeight: 300
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ListBox), {
        ref: ref,
        flexGrow: 1,
        "aria-labelledby": "label",
        items: tree.items,
        selectedKeys: tree.selectedKeys,
        onSelectionChange: tree.setSelectedKeys,
        selectionMode: "multiple",
        ...args
    }, (item)=>item.children.length && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Section), {
            key: item.value.name,
            items: item.children,
            title: item.value.name
        }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
                key: item.value.name
            }, item.value.name))))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSpectrum.DialogContainer), {
        onDismiss: ()=>setDialog(null)
    }, (dialog === null || dialog === void 0 ? void 0 : dialog.action) === "bulk-delete" && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSpectrum.AlertDialog), {
        title: "Delete",
        variant: "destructive",
        primaryActionLabel: "Delete",
        onPrimaryAction: ()=>tree.removeSelectedItems()
    }, "Are you sure you want to delete ", tree.selectedKeys.size === 1 ? "1 item" : `${tree.selectedKeys.size} items`, "?"))));
}
const Links = (args)=>{
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ListBox), {
        "aria-label": "ListBox with links",
        width: "250px",
        height: 400,
        onSelectionChange: (0, _addonActions.action)("onSelectionChange"),
        ...args
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
        key: "https://adobe.com/",
        href: "https://adobe.com/"
    }, "Adobe"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
        key: "https://google.com/",
        href: "https://google.com/"
    }, "Google"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
        key: "https://apple.com/",
        href: "https://apple.com/"
    }, "Apple"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
        key: "https://nytimes.com/",
        href: "https://nytimes.com/"
    }, "New York Times"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), null, "Non link"));
};
Links.story = {
    decorators: [
        (Story)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(StoryDecorator, null, /*#__PURE__*/ (0, _reactDefault.default).createElement(Story, null))
    ],
    args: {
        selectionMode: "none"
    },
    argTypes: {
        selectionMode: {
            control: {
                type: "radio",
                options: [
                    "none",
                    "single",
                    "multiple"
                ]
            }
        }
    }
};
const WithAvatars = {
    render: ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ListBox), {
            "aria-label": "Listbox with avatars",
            width: "350px"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            textValue: "Person 1"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSpectrum.Text), null, "Person 1"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSpectrum.Avatar), {
            src: "https://i.imgur.com/kJOwAdv.png",
            alt: "default Adobe avatar"
        })), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            textValue: "Person 1"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSpectrum.Text), null, "Person 2"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSpectrum.Avatar), {
            src: "https://i.imgur.com/kJOwAdv.png",
            alt: "default Adobe avatar"
        })), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            textValue: "Person 1"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSpectrum.Text), null, "Person 3"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSpectrum.Avatar), {
            src: "https://i.imgur.com/kJOwAdv.png",
            alt: "default Adobe avatar"
        }))),
    decorators: [
        (Story)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(StoryDecorator, null, /*#__PURE__*/ (0, _reactDefault.default).createElement(Story, null))
    ]
};

},{"@storybook/addon-actions":"coXbW","@adobe/react-spectrum":"cwANo","@spectrum-icons/workflow/AlignCenter":"2Chkz","@spectrum-icons/workflow/AlignLeft":"65eDL","@spectrum-icons/workflow/AlignRight":"3qK4F","@spectrum-icons/workflow/Blower":"8N8wp","@spectrum-icons/workflow/Book":"e9BS5","@spectrum-icons/workflow/Copy":"jpSBZ","@spectrum-icons/workflow/Cut":"4SMrV","@spectrum-icons/workflow/Delete":"foJ71","@react-aria/focus":"42mbF","../":"2jN2R","@react-spectrum/label":"6qv6N","@spectrum-icons/workflow/Paste":"jKZ2V","react":"9yzVZ","./../chromatic/ListBoxLanguages.chromatic":"avvgZ","@react-stately/data":"gEgJM","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"2Chkz":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("579ae8802ff0057f");
exports.__esModule = true;
exports.default = AlignCenter;
var _AlignCenter = require("6142aa9c15adb4c8");
var _icon = require("307a79a76a7b7ab1");
var _react = _interopRequireDefault(require("3c768f11b35c63a6"));
function AlignCenter(props) {
    return /*#__PURE__*/ _react.default.createElement(_icon.Icon, props, /*#__PURE__*/ _react.default.createElement(_AlignCenter.A4uAlignCenter, null));
}

},{"579ae8802ff0057f":"iHubQ","6142aa9c15adb4c8":"jZ4ws","307a79a76a7b7ab1":"k7wem","3c768f11b35c63a6":"9yzVZ"}],"jZ4ws":[function(require,module,exports) {
/**
* @adobe/react-spectrum-workflow (c) by Adobe
* 
* @adobe/react-spectrum-workflow is licensed under a
* Creative Commons Attribution-NoDerivatives 4.0 International License.
* 
* You should have received a copy of the license along with this
* work. If not, see <http://creativecommons.org/licenses/by-nd/4.0/>.
**/ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.A4uAlignCenter = A4uAlignCenter;
var _react = _interopRequireDefault(require("37eb05c68e628bc4"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function A4uAlignCenter(_ref) {
    var props = _extends({}, _ref);
    return /*#__PURE__*/ _react["default"].createElement("svg", _extends({
        viewBox: "0 0 36 36"
    }, props, props), /*#__PURE__*/ _react["default"].createElement("path", {
        fillRule: "evenodd",
        d: "M29,20H18V16h7a1,1,0,0,0,1-1V7a1,1,0,0,0-1-1H18V.5a.5.5,0,0,0-.5-.5h-1a.5.5,0,0,0-.5.5V6H9A1,1,0,0,0,8,7v8a1,1,0,0,0,1,1h7v4H5a1,1,0,0,0-1,1v8a1,1,0,0,0,1,1H16v5.5a.5.5,0,0,0,.5.5h1a.5.5,0,0,0,.5-.5V30H29a1,1,0,0,0,1-1V21A1,1,0,0,0,29,20Z"
    }));
}

},{"37eb05c68e628bc4":"9yzVZ"}],"65eDL":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("a78b03a4249e5c36");
exports.__esModule = true;
exports.default = AlignLeft;
var _AlignLeft = require("d9654394080b86c3");
var _icon = require("a9083cadb765c2f7");
var _react = _interopRequireDefault(require("40cc916d707dff63"));
function AlignLeft(props) {
    return /*#__PURE__*/ _react.default.createElement(_icon.Icon, props, /*#__PURE__*/ _react.default.createElement(_AlignLeft.A4uAlignLeft, null));
}

},{"a78b03a4249e5c36":"iHubQ","d9654394080b86c3":"7GbJz","a9083cadb765c2f7":"k7wem","40cc916d707dff63":"9yzVZ"}],"7GbJz":[function(require,module,exports) {
/**
* @adobe/react-spectrum-workflow (c) by Adobe
* 
* @adobe/react-spectrum-workflow is licensed under a
* Creative Commons Attribution-NoDerivatives 4.0 International License.
* 
* You should have received a copy of the license along with this
* work. If not, see <http://creativecommons.org/licenses/by-nd/4.0/>.
**/ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.A4uAlignLeft = A4uAlignLeft;
var _react = _interopRequireDefault(require("4765d3e264f54099"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function A4uAlignLeft(_ref) {
    var props = _extends({}, _ref);
    return /*#__PURE__*/ _react["default"].createElement("svg", _extends({
        viewBox: "0 0 36 36"
    }, props, props), /*#__PURE__*/ _react["default"].createElement("rect", {
        fillRule: "evenodd",
        height: "36",
        rx: "0.5",
        ry: "0.5",
        width: "2",
        x: "2"
    }), /*#__PURE__*/ _react["default"].createElement("rect", {
        fillRule: "evenodd",
        height: "10",
        rx: "1",
        ry: "1",
        width: "26",
        x: "6",
        y: "20"
    }), /*#__PURE__*/ _react["default"].createElement("rect", {
        fillRule: "evenodd",
        height: "10",
        rx: "1",
        ry: "1",
        width: "16",
        x: "6",
        y: "6"
    }));
}

},{"4765d3e264f54099":"9yzVZ"}],"3qK4F":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("5fb8da3116b69774");
exports.__esModule = true;
exports.default = AlignRight;
var _AlignRight = require("c0f5d78569c23ea8");
var _icon = require("ffdb65433e812224");
var _react = _interopRequireDefault(require("d5156bdc5f53a62f"));
function AlignRight(props) {
    return /*#__PURE__*/ _react.default.createElement(_icon.Icon, props, /*#__PURE__*/ _react.default.createElement(_AlignRight.A4uAlignRight, null));
}

},{"5fb8da3116b69774":"iHubQ","c0f5d78569c23ea8":"e04VA","ffdb65433e812224":"k7wem","d5156bdc5f53a62f":"9yzVZ"}],"e04VA":[function(require,module,exports) {
/**
* @adobe/react-spectrum-workflow (c) by Adobe
* 
* @adobe/react-spectrum-workflow is licensed under a
* Creative Commons Attribution-NoDerivatives 4.0 International License.
* 
* You should have received a copy of the license along with this
* work. If not, see <http://creativecommons.org/licenses/by-nd/4.0/>.
**/ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.A4uAlignRight = A4uAlignRight;
var _react = _interopRequireDefault(require("3201abb52de0176b"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function A4uAlignRight(_ref) {
    var props = _extends({}, _ref);
    return /*#__PURE__*/ _react["default"].createElement("svg", _extends({
        viewBox: "0 0 36 36"
    }, props, props), /*#__PURE__*/ _react["default"].createElement("rect", {
        fillRule: "evenodd",
        height: "36",
        rx: "0.5",
        ry: "0.5",
        width: "2",
        x: "32"
    }), /*#__PURE__*/ _react["default"].createElement("rect", {
        fillRule: "evenodd",
        height: "10",
        rx: "1",
        ry: "1",
        width: "26",
        x: "4",
        y: "20"
    }), /*#__PURE__*/ _react["default"].createElement("rect", {
        fillRule: "evenodd",
        height: "10",
        rx: "1",
        ry: "1",
        width: "16",
        x: "14",
        y: "6"
    }));
}

},{"3201abb52de0176b":"9yzVZ"}],"8N8wp":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("7279bdf54c98e1ad");
exports.__esModule = true;
exports.default = Blower;
var _Blower = require("fe750a9a1bc39454");
var _icon = require("a3fa2ccf61a1b3ad");
var _react = _interopRequireDefault(require("54c83e8b9961e3a9"));
function Blower(props) {
    return /*#__PURE__*/ _react.default.createElement(_icon.Icon, props, /*#__PURE__*/ _react.default.createElement(_Blower.A4uBlower, null));
}

},{"7279bdf54c98e1ad":"iHubQ","fe750a9a1bc39454":"juBOF","a3fa2ccf61a1b3ad":"k7wem","54c83e8b9961e3a9":"9yzVZ"}],"juBOF":[function(require,module,exports) {
/**
* @adobe/react-spectrum-workflow (c) by Adobe
* 
* @adobe/react-spectrum-workflow is licensed under a
* Creative Commons Attribution-NoDerivatives 4.0 International License.
* 
* You should have received a copy of the license along with this
* work. If not, see <http://creativecommons.org/licenses/by-nd/4.0/>.
**/ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.A4uBlower = A4uBlower;
var _react = _interopRequireDefault(require("ed2d8d22ccfbc9aa"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function A4uBlower(_ref) {
    var props = _extends({}, _ref);
    return /*#__PURE__*/ _react["default"].createElement("svg", _extends({
        viewBox: "0 0 36 36"
    }, props, props), /*#__PURE__*/ _react["default"].createElement("path", {
        fillRule: "evenodd",
        d: "M30.828,7.341a6.329,6.329,0,0,0-6.4-1.957c-2.4.569-5.88,4.132-7.275,6.814-.053,0-.1-.016-.156-.016a5.754,5.754,0,0,0-2.629.655c1-3.959,3.853-7.267-.2-10.1C10.931.465,6.342,4.172,6.342,4.172a6.328,6.328,0,0,0-1.958,6.4c.569,2.4,4.132,5.88,6.814,7.275,0,.054-.016.1-.016.157a5.754,5.754,0,0,0,.655,2.629c-3.959-1-7.267-3.852-10.1.2-2.27,3.244,1.436,7.832,1.436,7.832a6.328,6.328,0,0,0,6.4,1.958c2.4-.569,5.88-4.132,7.275-6.814.053,0,.1.016.156.016a5.754,5.754,0,0,0,2.629-.655c-1,3.959-3.852,7.266.2,10.1,3.244,2.271,7.833-1.436,7.833-1.436a6.328,6.328,0,0,0,1.958-6.4c-.569-2.4-4.132-5.88-6.814-7.275,0-.054.016-.1.016-.157a5.754,5.754,0,0,0-.655-2.629c3.959,1,7.267,3.852,10.1-.2C34.534,11.93,30.828,7.341,30.828,7.341ZM17,21a3,3,0,1,1,3-3A3,3,0,0,1,17,21Z"
    }));
}

},{"ed2d8d22ccfbc9aa":"9yzVZ"}],"2jN2R":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 * 
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _src = require("./src");
parcelHelpers.exportAll(_src, exports);

},{"./src":"kF7kO","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"avvgZ":[function(require,module,exports) {
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TranslateListBox", ()=>TranslateListBox);
parcelHelpers.export(exports, "ArabicComplex", ()=>ArabicComplex);
parcelHelpers.export(exports, "HebrewComplex", ()=>HebrewComplex);
parcelHelpers.export(exports, "JapaneseComplex", ()=>JapaneseComplex);
parcelHelpers.export(exports, "KoreanComplex", ()=>KoreanComplex);
parcelHelpers.export(exports, "ChineseSimplfiedComplex", ()=>ChineseSimplfiedComplex);
parcelHelpers.export(exports, "ChineseTraditionalComplex", ()=>ChineseTraditionalComplex);
var _add = require("@spectrum-icons/workflow/Add");
var _addDefault = parcelHelpers.interopDefault(_add);
var _alert = require("@spectrum-icons/workflow/Alert");
var _alertDefault = parcelHelpers.interopDefault(_alert);
var _bell = require("@spectrum-icons/workflow/Bell");
var _bellDefault = parcelHelpers.interopDefault(_bell);
var _draw = require("@spectrum-icons/workflow/Draw");
var _drawDefault = parcelHelpers.interopDefault(_draw);
// @ts-ignore
var _intlMessagesJson = require("./intlMessages.json");
var _intlMessagesJsonDefault = parcelHelpers.interopDefault(_intlMessagesJson);
var _ = require("..");
var _label = require("@react-spectrum/label");
var _provider = require("@react-spectrum/provider");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _text = require("@react-spectrum/text");
var _i18N = require("@react-aria/i18n");
exports.default = {
    title: "Languages/ListBox",
    parameters: {
        chromaticProvider: {
            colorSchemes: [
                "light"
            ],
            express: false,
            locales: [
                "en-US"
            ],
            scales: [
                "large"
            ]
        }
    },
    excludeStories: [
        "TranslateListBox"
    ]
};
let TranslateListBox = ()=>{
    let strings = (0, _i18N.useLocalizedStringFormatter)((0, _intlMessagesJsonDefault.default));
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        style: {
            display: "flex",
            flexDirection: "column"
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _label.Label), {
        id: "label"
    }, strings.format("selectAction")), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        style: {
            display: "flex",
            minWidth: "200px",
            background: "var(--spectrum-global-color-gray-50)",
            border: "1px solid lightgray",
            maxHeight: "100%"
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ListBox), {
        "aria-labelledby": "label",
        flexGrow: 1,
        autoFocus: true,
        selectionMode: "multiple",
        defaultSelectedKeys: [
            "queue",
            "subscribe"
        ],
        disabledKeys: [
            "report"
        ]
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Section), {
        title: strings.format("actions")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
        key: "queue",
        textValue: strings.format("addToQueue")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _addDefault.default), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, strings.format("addToQueue")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), {
        slot: "description"
    }, strings.format("addToCurrentWatchQueue"))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
        key: "review",
        textValue: strings.format("addReview")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _drawDefault.default), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, strings.format("addReview")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), {
        slot: "description"
    }, strings.format("postAReviewForTheEpisode"))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
        key: "subscribe",
        textValue: strings.format("subscribeToSeries")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _bellDefault.default), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, strings.format("subscribeToSeries")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), {
        slot: "description"
    }, strings.format("addSeriesToSubscription"))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
        key: "report",
        textValue: strings.format("report")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _alertDefault.default), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, strings.format("report")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), {
        slot: "description"
    }, strings.format("reportAnIssue")))))));
};
const ArabicComplex = ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _provider.Provider), {
        locale: "ar-AE"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(TranslateListBox, null));
const HebrewComplex = ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _provider.Provider), {
        locale: "he-IL"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(TranslateListBox, null));
const JapaneseComplex = ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _provider.Provider), {
        locale: "ja-JP"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(TranslateListBox, null));
const KoreanComplex = ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _provider.Provider), {
        locale: "ko-KR"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(TranslateListBox, null));
const ChineseSimplfiedComplex = ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _provider.Provider), {
        locale: "zh-CN"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(TranslateListBox, null));
const ChineseTraditionalComplex = ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _provider.Provider), {
        locale: "zh-TW"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(TranslateListBox, null));

},{"@spectrum-icons/workflow/Add":"evYih","@spectrum-icons/workflow/Alert":"lNgQc","@spectrum-icons/workflow/Bell":"5FeJ6","@spectrum-icons/workflow/Draw":"gXEyB","./intlMessages.json":"iusw8","..":"2jN2R","@react-spectrum/label":"6qv6N","@react-spectrum/provider":"5bCdp","react":"9yzVZ","@react-spectrum/text":"etCGI","@react-aria/i18n":"411rg","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"iusw8":[function(require,module,exports) {
module.exports = JSON.parse('{"ar-AR":{"actions":"\u0623\u062C\u0631\u0627\u0621\u0627\u062A","selectAction":"\u0627\u062E\u062A\u0631 \u0641\u0639\u0644\u0627","addToQueue":"\u0625\u0636\u0627\u0641\u0629 \u0625\u0644\u0649 \u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0627\u0646\u062A\u0638\u0627\u0631","addToCurrentWatchQueue":"\u0623\u0636\u0641 \u0625\u0644\u0649 \u0642\u0627\u0626\u0645\u0629 \u0627\u0646\u062A\u0638\u0627\u0631 \u0627\u0644\u0645\u0634\u0627\u0647\u062F\u0629 \u0627\u0644\u062D\u0627\u0644\u064A\u0629.","addReview":"\u0625\u0636\u0627\u0641\u0629 \u0645\u0631\u0627\u062C\u0639\u0629","postAReviewForTheEpisode":"\u0623\u0636\u0641 \u0645\u0631\u0627\u062C\u0639\u0629 \u0644\u0644\u062D\u0644\u0642\u0629.","subscribeToSeries":"\u0627\u0634\u062A\u0631\u0643 \u0641\u064A \u0627\u0644\u0645\u0633\u0644\u0633\u0644","addSeriesToSubscription":"\u0623\u0636\u0641 \u0633\u0644\u0633\u0644\u0629 \u0625\u0644\u0649 \u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0627\u0634\u062A\u0631\u0627\u0643 \u0627\u0644\u062E\u0627\u0635\u0629 \u0628\u0643 \u0648\u0633\u064A\u062A\u0645 \u0625\u0639\u0644\u0627\u0645\u0643 \u0639\u0646\u062F \u0628\u062B \u062D\u0644\u0642\u0629 \u062C\u062F\u064A\u062F\u0629.","report":"\u062A\u0642\u0631\u064A\u0631","reportAnIssue":"\u0627\u0644\u0625\u0628\u0644\u0627\u063A \u0639\u0646 \u0645\u0634\u0643\u0644\u0629 / \u0627\u0646\u062A\u0647\u0627\u0643."},"en-US":{"actions":"Actions","selectAction":"Select action","addToQueue":"Add to queue","addToCurrentWatchQueue":"Add to current watch queue.","addReview":"Add review","postAReviewForTheEpisode":"Post a review for the episode.","subscribeToSeries":"Subscribe to series","addSeriesToSubscription":"Add series to your subscription list and be notified when a new episode airs.","report":"Report","reportAnIssue":"Report an issue/violation."},"he-IL":{"actions":"\u05E4\u05E2\u05D5\u05DC\u05D5\u05EA","selectAction":"\u05D1\u05D7\u05E8 \u05E4\u05E2\u05D5\u05DC\u05D4","addToQueue":"\u05D4\u05D5\u05E1\u05E3 \u05DC\u05EA\u05D5\u05E8","addToCurrentWatchQueue":"\u05D4\u05D5\u05E1\u05E3 \u05DC\u05EA\u05D5\u05E8 \u05D4\u05E6\u05E4\u05D9\u05D9\u05D4 \u05D4\u05E0\u05D5\u05DB\u05D7\u05D9.","addReview":"\u05D4\u05D5\u05E1\u05E3 \u05D1\u05D9\u05E7\u05D5\u05E8\u05EA","postAReviewForTheEpisode":"\u05E4\u05E8\u05E1\u05DD \u05D1\u05D9\u05E7\u05D5\u05E8\u05EA \u05E2\u05DC \u05D4\u05E4\u05E8\u05E7.","subscribeToSeries":"\u05D4\u05D9\u05E8\u05E9\u05DE\u05D5 \u05DC\u05E1\u05D3\u05E8\u05D5\u05EA","addSeriesToSubscription":"\u05D4\u05D5\u05E1\u05E3 \u05E1\u05D3\u05E8\u05D5\u05EA \u05DC\u05E8\u05E9\u05D9\u05DE\u05EA \u05D4\u05DE\u05E0\u05D5\u05D9\u05D9\u05DD \u05E9\u05DC\u05DA \u05D5\u05E7\u05D1\u05DC \u05D4\u05D5\u05D3\u05E2\u05D4 \u05DB\u05E9\u05E4\u05E8\u05E7 \u05D7\u05D3\u05E9 \u05D9\u05E9\u05D5\u05D3\u05E8.","report":"\u05DC\u05D4\u05D2\u05D9\u05E9 \u05EA\u05DC\u05D5\u05E0\u05D4","reportAnIssue":"\u05D3\u05D5\u05D5\u05D7 \u05E2\u05DC \u05D1\u05E2\u05D9\u05D4/\u05D4\u05E4\u05E8\u05D4."},"ja-JP":{"actions":"\u884C\u52D5","selectAction":"\u30A2\u30AF\u30B7\u30E7\u30F3\u306E\u9078\u629E","addToQueue":"\u30AD\u30E5\u30FC\u306B\u8FFD\u52A0\u3059\u308B","addToCurrentWatchQueue":"\u73FE\u5728\u306E\u76E3\u8996\u30AD\u30E5\u30FC\u306B\u8FFD\u52A0\u3057\u307E\u3059\u3002","addReview":"\u30EC\u30D3\u30E5\u30FC\u3092\u8FFD\u52A0","postAReviewForTheEpisode":"\u30A8\u30D4\u30BD\u30FC\u30C9\u306E\u30EC\u30D3\u30E5\u30FC\u3092\u6295\u7A3F\u3057\u307E\u3059\u3002","subscribeToSeries":"\u30B7\u30EA\u30FC\u30BA\u3092\u8CFC\u8AAD\u3059\u308B","addSeriesToSubscription":"\u30B7\u30EA\u30FC\u30BA\u3092\u8CFC\u8AAD\u30EA\u30B9\u30C8\u306B\u8FFD\u52A0\u3059\u308B\u3068\u3001\u65B0\u3057\u3044\u30A8\u30D4\u30BD\u30FC\u30C9\u304C\u653E\u9001\u3055\u308C\u305F\u3068\u304D\u306B\u901A\u77E5\u304C\u5C4A\u304D\u307E\u3059\u3002","report":"\u5831\u544A","reportAnIssue":"\u554F\u984C/\u9055\u53CD\u3092\u5831\u544A\u3057\u307E\u3059\u3002"},"ko-KR":{"actions":"\uD589\uC704","selectAction":"\uC791\uC5C5 \uC120\uD0DD","addToQueue":"\uBAA9\uB85D\uC5D0 \uCD94\uAC00\uD574","addToCurrentWatchQueue":"\uD604\uC7AC \uC2DC\uCCAD \uB300\uAE30\uC5F4\uC5D0 \uCD94\uAC00\uD569\uB2C8\uB2E4.","addReview":"\uB9AC\uBDF0 \uCD94\uAC00","postAReviewForTheEpisode":"\uC5D0\uD53C\uC18C\uB4DC\uC5D0 \uB300\uD55C \uB9AC\uBDF0\uB97C \uAC8C\uC2DC\uD569\uB2C8\uB2E4.","subscribeToSeries":"\uC2DC\uB9AC\uC988 \uAD6C\uB3C5","addSeriesToSubscription":"\uAD6C\uB3C5 \uBAA9\uB85D\uC5D0 \uC2DC\uB9AC\uC988\uB97C \uCD94\uAC00\uD558\uACE0 \uC0C8 \uC5D0\uD53C\uC18C\uB4DC\uAC00 \uBC29\uC1A1\uB420 \uB54C \uC54C\uB9BC\uC744 \uBC1B\uC73C\uC138\uC694.","report":"\uBCF4\uACE0\uC11C","reportAnIssue":"\uBB38\uC81C/\uC704\uBC18\uC744 \uBCF4\uACE0\uD569\uB2C8\uB2E4."},"zh-CN":{"actions":"\u52A8\u4F5C","selectAction":"\u9009\u62E9\u52A8\u4F5C","addToQueue":"\u6DFB\u52A0\u5230\u961F\u5217","addToCurrentWatchQueue":"\u6DFB\u52A0\u5230\u5F53\u524D\u89C2\u770B\u961F\u5217\u3002","addReview":"\u6DFB\u52A0\u8BC4\u8BBA","postAReviewForTheEpisode":"\u53D1\u8868\u5BF9\u5267\u96C6\u7684\u8BC4\u8BBA\u3002","subscribeToSeries":"\u8BA2\u9605\u7CFB\u5217","addSeriesToSubscription":"\u5C06\u7CFB\u5217\u6DFB\u52A0\u5230\u60A8\u7684\u8BA2\u9605\u5217\u8868\uFF0C\u5E76\u5728\u65B0\u5267\u96C6\u64AD\u51FA\u65F6\u6536\u5230\u901A\u77E5\u3002","report":"\u62A5\u544A","reportAnIssue":"\u62A5\u544A\u95EE\u9898/\u8FDD\u89C4\u884C\u4E3A\u3002"},"zh-TW":{"actions":"\u52D5\u4F5C","selectAction":"\u9078\u64C7\u52D5\u4F5C","addToQueue":"\u6DFB\u52A0\u5230\u968A\u5217","addToCurrentWatchQueue":"\u6DFB\u52A0\u5230\u7576\u524D\u89C0\u770B\u968A\u5217\u3002","addReview":"\u6DFB\u52A0\u8A55\u8AD6","postAReviewForTheEpisode":"\u767C\u8868\u5C0D\u5287\u96C6\u7684\u8A55\u8AD6\u3002","subscribeToSeries":"\u8A02\u95B1\u7CFB\u5217","addSeriesToSubscription":"\u5C07\u7CFB\u5217\u6DFB\u52A0\u5230\u60A8\u7684\u8A02\u95B1\u5217\u8868\uFF0C\u4E26\u5728\u65B0\u5287\u96C6\u64AD\u51FA\u6642\u6536\u5230\u901A\u77E5\u3002","report":"\u5831\u544A","reportAnIssue":"\u5831\u544A\u554F\u984C/\u9055\u898F\u884C\u70BA\u3002"}}');

},{}],"4a41n":[function(require,module,exports) {
/*
 * Copyright 2021 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Default", ()=>Default);
parcelHelpers.export(exports, "AriaLabel", ()=>AriaLabel);
parcelHelpers.export(exports, "DOMId", ()=>DOMId);
parcelHelpers.export(exports, "Quiet", ()=>Quiet);
parcelHelpers.export(exports, "Disabled", ()=>Disabled);
parcelHelpers.export(exports, "DisabledKeys", ()=>DisabledKeys);
parcelHelpers.export(exports, "AutoFocus", ()=>AutoFocus);
parcelHelpers.export(exports, "DefaultOpen", ()=>DefaultOpen);
parcelHelpers.export(exports, "ControlledOpen", ()=>ControlledOpen);
parcelHelpers.export(exports, "DirectionAlignFlip", ()=>DirectionAlignFlip);
parcelHelpers.export(exports, "WithTooltip", ()=>WithTooltip);
parcelHelpers.export(exports, "Dynamic", ()=>Dynamic);
var _addonActions = require("@storybook/addon-actions");
var _ = require("..");
var _checkbox = require("@react-spectrum/checkbox");
var _layout = require("@react-spectrum/layout");
var _1 = require("../");
var _picker = require("@react-spectrum/picker");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _tooltip = require("@react-spectrum/tooltip");
const meta = {
    title: "ActionMenu",
    component: (0, _.ActionMenu)
};
exports.default = meta;
const Template = (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ActionMenu), {
        onAction: (0, _addonActions.action)("action"),
        ...args
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _1.Item), {
        key: "one"
    }, "One"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _1.Item), {
        key: "two"
    }, "Two"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _1.Item), {
        key: "three"
    }, "Three"));
const directionItems = [
    {
        key: "bottom",
        label: "Bottom"
    },
    {
        key: "top",
        label: "Top"
    },
    {
        key: "left",
        label: "Left"
    },
    {
        key: "right",
        label: "Right"
    },
    {
        key: "start",
        label: "Start"
    },
    {
        key: "end",
        label: "End"
    }
];
const alignItems = [
    {
        key: "start",
        label: "Start"
    },
    {
        key: "end",
        label: "End"
    }
];
function isOfDirection(key) {
    return directionItems.map((e)=>e.key).includes(key);
}
function isOfAlignment(key) {
    return alignItems.map((e)=>e.key).includes(key);
}
function DirectionAlignment() {
    const [align, setAlignment] = (0, _react.useState)("start");
    const [direction, setDirection] = (0, _react.useState)("bottom");
    const [shouldFlip, setShouldFlip] = (0, _react.useState)(true);
    const handleAlignChange = (key)=>{
        if (isOfAlignment(key)) setAlignment(key);
    };
    const handleDirectionChange = (key)=>{
        if (isOfDirection(key)) setDirection(key);
    };
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
        alignItems: "end",
        gap: 10,
        wrap: true
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _picker.Picker), {
        label: "Align",
        items: alignItems,
        selectedKey: align,
        onSelectionChange: handleAlignChange
    }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _1.Item), {
            key: item.key
        }, item.label)), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _picker.Picker), {
        label: "Direction",
        items: directionItems,
        selectedKey: direction,
        onSelectionChange: handleDirectionChange
    }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _1.Item), {
            key: item.key
        }, item.label)), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _checkbox.Checkbox), {
        isSelected: shouldFlip,
        onChange: setShouldFlip
    }, "Should Flip"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ActionMenu), {
        onAction: (0, _addonActions.action)("action"),
        align: align,
        direction: direction,
        shouldFlip: shouldFlip
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _1.Item), {
        key: "one"
    }, "One"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _1.Item), {
        key: "two"
    }, "Two"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _1.Item), {
        key: "three"
    }, "Three")));
}
const Default = {
    render: Template,
    args: {}
};
const AriaLabel = {
    render: Template,
    args: {
        "aria-label": "Some more actions"
    }
};
const DOMId = {
    render: Template,
    args: {
        id: "my-action-menu"
    }
};
const Quiet = {
    render: Template,
    args: {
        isQuiet: true
    }
};
const Disabled = {
    render: Template,
    args: {
        isDisabled: true
    }
};
const DisabledKeys = {
    render: Template,
    args: {
        disabledKeys: [
            "two"
        ]
    }
};
const AutoFocus = {
    render: Template,
    args: {
        autoFocus: true
    }
};
const DefaultOpen = {
    render: Template,
    args: {
        onOpenChange: (0, _addonActions.action)("openChange"),
        defaultOpen: true
    }
};
const ControlledOpen = ()=>{
    let [open, setOpen] = (0, _reactDefault.default).useState(false);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ActionMenu), {
        isOpen: open,
        onOpenChange: setOpen,
        onAction: (0, _addonActions.action)("action")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _1.Item), {
        key: "cut"
    }, "Cut"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _1.Item), {
        key: "copy"
    }, "Copy"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _1.Item), {
        key: "paste"
    }, "Paste"));
};
const DirectionAlignFlip = ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement(DirectionAlignment, null);
const WithTooltip = ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _tooltip.TooltipTrigger), {
        delay: 0
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ActionMenu), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _1.Item), {
        key: "cut"
    }, "Cut"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _1.Item), {
        key: "copy"
    }, "Copy"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _1.Item), {
        key: "paste"
    }, "Paste")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _tooltip.Tooltip), null, "Actions"));
const Dynamic = ()=>{
    const items = [
        {
            key: "cut",
            label: "Cut"
        },
        {
            key: "copy",
            label: "Copy"
        },
        {
            key: "paste",
            label: "Paste"
        }
    ];
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ActionMenu), {
        items: items
    }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _1.Item), {
            key: item.key
        }, item.label));
};

},{"@storybook/addon-actions":"coXbW","..":"8myJq","@react-spectrum/checkbox":"1r19j","@react-spectrum/layout":"hzaUY","../":"8myJq","@react-spectrum/picker":"kL1Uy","react":"9yzVZ","@react-spectrum/tooltip":"f9wa6","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"8myJq":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _src = require("./src");
parcelHelpers.exportAll(_src, exports);

},{"./src":"asqy4","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"iKKSY":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DefaultMenuStatic", ()=>DefaultMenuStatic);
parcelHelpers.export(exports, "DefaultMenuGenerative", ()=>DefaultMenuGenerative);
parcelHelpers.export(exports, "DefaultMenuWSectionStatic", ()=>DefaultMenuWSectionStatic);
parcelHelpers.export(exports, "DefaultMenuWSectionGenerative", ()=>DefaultMenuWSectionGenerative);
parcelHelpers.export(exports, "DefaultMenuWTitlelessSectionsStatic", ()=>DefaultMenuWTitlelessSectionsStatic);
parcelHelpers.export(exports, "DefaultMenuWTitlelessSectionsGenerative", ()=>DefaultMenuWTitlelessSectionsGenerative);
parcelHelpers.export(exports, "WithFalsyItemKeys", ()=>WithFalsyItemKeys);
parcelHelpers.export(exports, "SingleSelectedKeyControlledStatic", ()=>SingleSelectedKeyControlledStatic);
parcelHelpers.export(exports, "SingleSelectedKeyControlledGenerative", ()=>SingleSelectedKeyControlledGenerative);
parcelHelpers.export(exports, "SingleDefaultSelectedKeyUncontrolledStatic", ()=>SingleDefaultSelectedKeyUncontrolledStatic);
parcelHelpers.export(exports, "SingleDefaultSelectedKeyUncontrolledGenerative", ()=>SingleDefaultSelectedKeyUncontrolledGenerative);
parcelHelpers.export(exports, "MultipleDefaultSelectedKeyControlledStatic", ()=>MultipleDefaultSelectedKeyControlledStatic);
parcelHelpers.export(exports, "MultipleSelectedKeyControlledGenerative", ()=>MultipleSelectedKeyControlledGenerative);
parcelHelpers.export(exports, "MultipleDefaultSelectedKeyUncontrolledStatic", ()=>MultipleDefaultSelectedKeyUncontrolledStatic);
parcelHelpers.export(exports, "MultipleDefaultSelectedKeyUncontrolledGenerative", ()=>MultipleDefaultSelectedKeyUncontrolledGenerative);
parcelHelpers.export(exports, "MenuWithAutoFocusTrue", ()=>MenuWithAutoFocusTrue);
parcelHelpers.export(exports, "MenuWithAutoFocusFalse", ()=>MenuWithAutoFocusFalse);
parcelHelpers.export(exports, "MenuWithAutoFocusTrueDefaultSelectedKeyUncontrolledSelectionModeSingle", ()=>MenuWithAutoFocusTrueDefaultSelectedKeyUncontrolledSelectionModeSingle);
parcelHelpers.export(exports, "MenuWithAutoFocusFirst", ()=>MenuWithAutoFocusFirst);
parcelHelpers.export(exports, "MenuWithAutoFocusLast", ()=>MenuWithAutoFocusLast);
parcelHelpers.export(exports, "MenuWithKeyboardSelectionWrappingFalse", ()=>MenuWithKeyboardSelectionWrappingFalse);
parcelHelpers.export(exports, "AlignEnd", ()=>AlignEnd);
parcelHelpers.export(exports, "DirectionTop", ()=>DirectionTop);
parcelHelpers.export(exports, "DirectionBottom", ()=>DirectionBottom);
parcelHelpers.export(exports, "DirectionStart", ()=>DirectionStart);
parcelHelpers.export(exports, "DirectionStartAlignEnd", ()=>DirectionStartAlignEnd);
parcelHelpers.export(exports, "DirectionEnd", ()=>DirectionEnd);
parcelHelpers.export(exports, "DirectionEndAlignEnd", ()=>DirectionEndAlignEnd);
parcelHelpers.export(exports, "DirectionLeft", ()=>DirectionLeft);
parcelHelpers.export(exports, "DirectionLeftAlignEnd", ()=>DirectionLeftAlignEnd);
parcelHelpers.export(exports, "DirectionRight", ()=>DirectionRight);
parcelHelpers.export(exports, "DirectionRightAlignEnd", ()=>DirectionRightAlignEnd);
parcelHelpers.export(exports, "ShouldFlip", ()=>ShouldFlip);
parcelHelpers.export(exports, "IsOpen", ()=>IsOpen);
parcelHelpers.export(exports, "DefaultOpen", ()=>DefaultOpen);
parcelHelpers.export(exports, "DisabledButton", ()=>DisabledButton);
parcelHelpers.export(exports, "MultiselectMenu", ()=>MultiselectMenu);
parcelHelpers.export(exports, "NoSelectionAllowedMenu", ()=>NoSelectionAllowedMenu);
parcelHelpers.export(exports, "CloseOnSelectFalse", ()=>CloseOnSelectFalse);
parcelHelpers.export(exports, "CloseOnSelectTrueMultiselectMenu", ()=>CloseOnSelectTrueMultiselectMenu);
parcelHelpers.export(exports, "MenuWithSemanticElementsStatic", ()=>MenuWithSemanticElementsStatic);
parcelHelpers.export(exports, "MenuWithSemanticElementsGenerative", ()=>MenuWithSemanticElementsGenerative);
parcelHelpers.export(exports, "MenuShouldPreventScrolling", ()=>MenuShouldPreventScrolling);
parcelHelpers.export(exports, "MenuClosesOnBlur", ()=>MenuClosesOnBlur);
parcelHelpers.export(exports, "WithFalsyKey", ()=>WithFalsyKey);
parcelHelpers.export(exports, "MenuTriggerWithTriggerLongPress", ()=>MenuTriggerWithTriggerLongPress);
parcelHelpers.export(exports, "ControlledIsOpen", ()=>ControlledIsOpen);
parcelHelpers.export(exports, "WithTranslations", ()=>WithTranslations);
parcelHelpers.export(exports, "render", ()=>render);
parcelHelpers.export(exports, "MenuItemUnavailable", ()=>MenuItemUnavailable);
parcelHelpers.export(exports, "MenuItemUnavailableDynamic", ()=>MenuItemUnavailableDynamic);
parcelHelpers.export(exports, "MenuItemUnavailableToggling", ()=>MenuItemUnavailableToggling);
parcelHelpers.export(exports, "MenuWithLinks", ()=>MenuWithLinks);
var _addonActions = require("@storybook/addon-actions");
var _button = require("@react-spectrum/button");
var _alignCenter = require("@spectrum-icons/workflow/AlignCenter");
var _alignCenterDefault = parcelHelpers.interopDefault(_alignCenter);
var _alignLeft = require("@spectrum-icons/workflow/AlignLeft");
var _alignLeftDefault = parcelHelpers.interopDefault(_alignLeft);
var _alignRight = require("@spectrum-icons/workflow/AlignRight");
var _alignRightDefault = parcelHelpers.interopDefault(_alignRight);
var _blower = require("@spectrum-icons/workflow/Blower");
var _blowerDefault = parcelHelpers.interopDefault(_blower);
var _book = require("@spectrum-icons/workflow/Book");
var _bookDefault = parcelHelpers.interopDefault(_book);
var _view = require("@react-spectrum/view");
var _ = require("../");
var _copy = require("@spectrum-icons/workflow/Copy");
var _copyDefault = parcelHelpers.interopDefault(_copy);
var _cut = require("@spectrum-icons/workflow/Cut");
var _cutDefault = parcelHelpers.interopDefault(_cut);
var _dialog = require("@react-spectrum/dialog");
var _text = require("@react-spectrum/text");
var _link = require("@react-spectrum/link");
var _paste = require("@spectrum-icons/workflow/Paste");
var _pasteDefault = parcelHelpers.interopDefault(_paste);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactSpectrum = require("@adobe/react-spectrum");
var _menuTriggerLanguagesChromatic = require("./../chromatic/MenuTriggerLanguages.chromatic");
let iconMap = {
    AlignCenter: (0, _alignCenterDefault.default),
    AlignLeft: (0, _alignLeftDefault.default),
    AlignRight: (0, _alignRightDefault.default),
    Blower: (0, _blowerDefault.default),
    Book: (0, _bookDefault.default),
    Copy: (0, _copyDefault.default),
    Cut: (0, _cutDefault.default),
    Paste: (0, _pasteDefault.default)
};
let hardModeProgrammatic = [
    {
        name: "Section 1",
        children: [
            {
                name: "Copy",
                icon: "Copy",
                shortcut: "\u2318C"
            },
            {
                name: "Cut",
                icon: "Cut",
                shortcut: "\u2318X"
            },
            {
                name: "Paste",
                icon: "Paste",
                shortcut: "\u2318V"
            }
        ]
    },
    {
        name: "Section 2",
        children: [
            {
                name: "Puppy",
                icon: "AlignLeft",
                shortcut: "\u2318P"
            },
            {
                name: "Doggo",
                icon: "AlignCenter",
                shortcut: "\u2318D"
            },
            {
                name: "Floof",
                icon: "AlignRight",
                shortcut: "\u2318F"
            },
            {
                name: "hasChildren",
                children: [
                    {
                        name: "Thailand",
                        icon: "Blower",
                        shortcut: "\u2318T"
                    },
                    {
                        name: "Germany",
                        icon: "Book",
                        shortcut: "\u2318G"
                    }
                ]
            }
        ]
    }
];
let flatMenu = [
    {
        name: "Aardvark"
    },
    {
        name: "Kangaroo"
    },
    {
        name: "Snake"
    },
    {
        name: "Danni"
    },
    {
        name: "Devon"
    },
    {
        name: "Ross"
    },
    {
        name: "Puppy"
    },
    {
        name: "Doggo"
    },
    {
        name: "Floof"
    }
];
let withSection = [
    {
        name: "Animals",
        children: [
            {
                name: "Aardvark"
            },
            {
                name: "Kangaroo"
            },
            {
                name: "Snake"
            }
        ]
    },
    {
        name: "People",
        children: [
            {
                name: "Danni"
            },
            {
                name: "Devon"
            },
            {
                name: "Ross",
                children: [
                    {
                        name: "Tests",
                        children: [
                            {
                                name: "blah"
                            }
                        ]
                    }
                ]
            }
        ]
    }
];
let itemsWithFalsyId = [
    {
        id: 1,
        name: "Animals",
        children: [
            {
                id: 0,
                name: "id=0"
            },
            {
                id: 2,
                name: "Snake"
            }
        ]
    },
    {
        id: 3,
        name: "People",
        children: [
            {
                id: 4,
                name: "Danni"
            },
            {
                id: 5,
                name: "Devon"
            },
            {
                id: 6,
                name: "Ross",
                children: [
                    {
                        id: 7,
                        name: "Tests",
                        children: [
                            {
                                id: 8,
                                name: "blah"
                            }
                        ]
                    }
                ]
            }
        ]
    }
];
exports.default = {
    title: "MenuTrigger",
    excludeStories: [
        "render"
    ]
};
const DefaultMenuStatic = ()=>render(/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Menu), {
        onAction: (0, _addonActions.action)("onAction")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), null, "One"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), null, "Two"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), null, "Three")));
DefaultMenuStatic.story = {
    name: "default menu (static)"
};
const DefaultMenuGenerative = ()=>render(/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Menu), {
        items: flatMenu,
        onAction: (0, _addonActions.action)("onAction")
    }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            key: item.name
        }, item.name)));
DefaultMenuGenerative.story = {
    name: "default menu (generative)"
};
const DefaultMenuWSectionStatic = ()=>render(/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Menu), {
        onAction: (0, _addonActions.action)("onAction")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Section), {
        title: "Section 1"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), null, "One"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), null, "Two"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), null, "Three")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Section), {
        title: "Section 2"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), null, "One"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), null, "Two"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), null, "Three"))));
DefaultMenuWSectionStatic.story = {
    name: "default menu w/ section (static)"
};
const DefaultMenuWSectionGenerative = ()=>render(defaultMenu);
DefaultMenuWSectionGenerative.story = {
    name: "default menu w/ section (generative)"
};
const DefaultMenuWTitlelessSectionsStatic = ()=>render(/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Menu), {
        onAction: (0, _addonActions.action)("onAction")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Section), {
        "aria-label": "Section 1"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), null, "One"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), null, "Two"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), null, "Three")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Section), {
        "aria-label": "Section 2"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), null, "One"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), null, "Two"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), null, "Three"))));
DefaultMenuWTitlelessSectionsStatic.story = {
    name: "default menu w/ titleless sections (static)"
};
const DefaultMenuWTitlelessSectionsGenerative = ()=>render(/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Menu), {
        items: withSection,
        onAction: (0, _addonActions.action)("onAction")
    }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Section), {
            key: item.name,
            items: item.children,
            "aria-label": item.name
        }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
                key: item.name
            }, item.name))));
DefaultMenuWTitlelessSectionsGenerative.story = {
    name: "default menu w/ titleless sections (generative)"
};
const WithFalsyItemKeys = ()=>render(/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Menu), {
        items: itemsWithFalsyId,
        onAction: (0, _addonActions.action)("onAction")
    }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Section), {
            items: item.children,
            title: item.name
        }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), null, item.name))));
WithFalsyItemKeys.story = {
    name: "with falsy item keys"
};
const SingleSelectedKeyControlledStatic = ()=>render(/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Menu), {
        selectionMode: "single",
        onAction: (0, _addonActions.action)("onAction"),
        selectedKeys: [
            "2"
        ]
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Section), {
        title: "Section 1"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
        key: "1"
    }, "One"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
        key: "2"
    }, "Two"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
        key: "3"
    }, "Three")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Section), {
        title: "Section 2"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
        key: "4"
    }, "Four"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
        key: "5"
    }, "Five"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
        key: "6"
    }, "Six"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
        key: "7"
    }, "Seven"))));
SingleSelectedKeyControlledStatic.story = {
    name: "single selected key (controlled, static)"
};
const SingleSelectedKeyControlledGenerative = ()=>render(defaultMenu, {}, {
        selectedKeys: [
            "Kangaroo"
        ],
        selectionMode: "single"
    });
SingleSelectedKeyControlledGenerative.story = {
    name: "single selected key (controlled, generative)"
};
const SingleDefaultSelectedKeyUncontrolledStatic = ()=>render(/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Menu), {
        selectionMode: "single",
        onAction: (0, _addonActions.action)("onAction"),
        defaultSelectedKeys: [
            "2"
        ]
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Section), {
        title: "Section 1"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
        key: "1"
    }, "One"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
        key: "2"
    }, "Two"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
        key: "3"
    }, "Three")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Section), {
        title: "Section 2"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
        key: "4"
    }, "Four"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
        key: "5"
    }, "Five"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
        key: "6"
    }, "Six"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
        key: "7"
    }, "Seven"))));
SingleDefaultSelectedKeyUncontrolledStatic.story = {
    name: "single default selected key (uncontrolled, static)"
};
const SingleDefaultSelectedKeyUncontrolledGenerative = ()=>render(defaultMenu, {}, {
        defaultSelectedKeys: [
            "Kangaroo"
        ],
        selectionMode: "single"
    });
SingleDefaultSelectedKeyUncontrolledGenerative.story = {
    name: "single default selected key (uncontrolled, generative)"
};
const MultipleDefaultSelectedKeyControlledStatic = ()=>render(/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Menu), {
        onAction: (0, _addonActions.action)("onAction"),
        selectionMode: "multiple",
        selectedKeys: [
            "2",
            "5"
        ],
        disabledKeys: [
            "1",
            "3"
        ]
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Section), {
        title: "Section 1"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
        key: "1"
    }, "One"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
        key: "2"
    }, "Two"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
        key: "3"
    }, "Three")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Section), {
        title: "Section 2"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
        key: "4"
    }, "Four"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
        key: "5"
    }, "Five"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
        key: "6"
    }, "Six"))));
MultipleDefaultSelectedKeyControlledStatic.story = {
    name: "multiple default selected key (controlled, static)"
};
const MultipleSelectedKeyControlledGenerative = ()=>render(defaultMenu, {}, {
        selectedKeys: [
            "Kangaroo",
            "Devon"
        ],
        selectionMode: "multiple"
    });
MultipleSelectedKeyControlledGenerative.story = {
    name: "multiple selected key (controlled, generative)"
};
const MultipleDefaultSelectedKeyUncontrolledStatic = ()=>render(/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Menu), {
        onAction: (0, _addonActions.action)("onAction"),
        selectionMode: "multiple",
        defaultSelectedKeys: [
            "2",
            "5"
        ],
        disabledKeys: [
            "1",
            "3"
        ]
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Section), {
        title: "Section 1"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
        key: "1"
    }, "One"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
        key: "2"
    }, "Two"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
        key: "3"
    }, "Three")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Section), {
        title: "Section 2"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
        key: "4"
    }, "Four"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
        key: "5"
    }, "Five"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
        key: "6"
    }, "Six"))));
MultipleDefaultSelectedKeyUncontrolledStatic.story = {
    name: "multiple default selected key (uncontrolled, static)"
};
const MultipleDefaultSelectedKeyUncontrolledGenerative = ()=>render(defaultMenu, {}, {
        defaultSelectedKeys: [
            "Kangaroo",
            "Devon"
        ],
        selectionMode: "multiple"
    });
MultipleDefaultSelectedKeyUncontrolledGenerative.story = {
    name: "multiple default selected key (uncontrolled, generative)"
};
const MenuWithAutoFocusTrue = ()=>render(defaultMenu, {}, {
        autoFocus: true
    });
MenuWithAutoFocusTrue.story = {
    name: "Menu with autoFocus=true"
};
const MenuWithAutoFocusFalse = ()=>render(defaultMenu, {}, {
        autoFocus: false
    });
MenuWithAutoFocusFalse.story = {
    name: "Menu with autoFocus=false"
};
const MenuWithAutoFocusTrueDefaultSelectedKeyUncontrolledSelectionModeSingle = ()=>render(defaultMenu, {}, {
        autoFocus: true,
        selectionMode: "single",
        defaultSelectedKeys: [
            "Kangaroo"
        ]
    });
MenuWithAutoFocusTrueDefaultSelectedKeyUncontrolledSelectionModeSingle.story = {
    name: "Menu with autoFocus=true, default selected key (uncontrolled), selectionMode single"
};
const MenuWithAutoFocusFirst = ()=>render(defaultMenu, {}, {
        autoFocus: "first"
    });
MenuWithAutoFocusFirst.story = {
    name: 'Menu with autoFocus="first"'
};
const MenuWithAutoFocusLast = ()=>render(defaultMenu, {}, {
        autoFocus: "last"
    });
MenuWithAutoFocusLast.story = {
    name: 'Menu with autoFocus="last"'
};
const MenuWithKeyboardSelectionWrappingFalse = ()=>render(defaultMenu, {}, {
        shouldFocusWrap: false
    });
MenuWithKeyboardSelectionWrappingFalse.story = {
    name: "Menu with keyboard selection wrapping false"
};
const AlignEnd = ()=>render(/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Menu), {
        onAction: (0, _addonActions.action)("onAction")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), null, "One"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), null, "Two"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), null, "Three")), {
        align: "end"
    });
AlignEnd.story = {
    name: 'align="end"'
};
const DirectionTop = ()=>render(defaultMenu, {
        direction: "top"
    });
DirectionTop.story = {
    name: 'direction="top"'
};
const DirectionBottom = ()=>render(defaultMenu, {
        direction: "bottom"
    });
DirectionBottom.story = {
    name: 'direction="bottom"'
};
const DirectionStart = ()=>render(defaultMenu, {
        direction: "start"
    });
DirectionStart.story = {
    name: 'direction="start"'
};
const DirectionStartAlignEnd = ()=>render(defaultMenu, {
        direction: "start",
        align: "end"
    });
DirectionStartAlignEnd.story = {
    name: 'direction="start", align="end"'
};
const DirectionEnd = ()=>render(defaultMenu, {
        direction: "end"
    });
DirectionEnd.story = {
    name: 'direction="end"'
};
const DirectionEndAlignEnd = ()=>render(defaultMenu, {
        direction: "end",
        align: "end"
    });
DirectionEndAlignEnd.story = {
    name: 'direction="end", align="end"'
};
const DirectionLeft = ()=>render(defaultMenu, {
        direction: "left"
    });
DirectionLeft.story = {
    name: 'direction="left"'
};
const DirectionLeftAlignEnd = ()=>render(defaultMenu, {
        direction: "left",
        align: "end"
    });
DirectionLeftAlignEnd.story = {
    name: 'direction="left", align="end"'
};
const DirectionRight = ()=>render(defaultMenu, {
        direction: "right"
    });
DirectionRight.story = {
    name: 'direction="right"'
};
const DirectionRightAlignEnd = ()=>render(defaultMenu, {
        direction: "right",
        align: "end"
    });
DirectionRightAlignEnd.story = {
    name: 'direction="right", align="end"'
};
const ShouldFlip = ()=>render(defaultMenu, {
        shouldFlip: true
    });
ShouldFlip.story = {
    name: "shouldFlip"
};
const IsOpen = ()=>render(defaultMenu, {
        isOpen: true
    });
IsOpen.story = {
    name: "isOpen"
};
const DefaultOpen = ()=>render(defaultMenu, {
        defaultOpen: true
    });
DefaultOpen.story = {
    name: "defaultOpen"
};
const DisabledButton = ()=>render(defaultMenu, {
        isDisabled: true
    });
DisabledButton.story = {
    name: "disabled button"
};
const MultiselectMenu = ()=>render(defaultMenu, {}, {
        selectionMode: "multiple"
    });
MultiselectMenu.story = {
    name: "multiselect menu"
};
const NoSelectionAllowedMenu = ()=>render(defaultMenu, {}, {
        selectionMode: "none"
    });
NoSelectionAllowedMenu.story = {
    name: "no selection allowed menu"
};
const CloseOnSelectFalse = ()=>render(defaultMenu, {
        closeOnSelect: false
    }, {});
CloseOnSelectFalse.story = {
    name: "closeOnSelect=false"
};
const CloseOnSelectTrueMultiselectMenu = ()=>render(defaultMenu, {
        closeOnSelect: true
    }, {
        selectionMode: "multiple"
    });
CloseOnSelectTrueMultiselectMenu.story = {
    name: "closeOnSelect=true, multiselect menu"
};
const MenuWithSemanticElementsStatic = ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        style: {
            display: "flex",
            width: "auto",
            margin: "250px 0"
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.MenuTrigger), {
        onOpenChange: (0, _addonActions.action)("onOpenChange")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), {
        onPress: (0, _addonActions.action)("press"),
        onPressStart: (0, _addonActions.action)("pressstart"),
        onPressEnd: (0, _addonActions.action)("pressend")
    }, "Menu Button"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Menu), {
        onAction: (0, _addonActions.action)("action")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Section), {
        title: "Section 1"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
        textValue: "Copy"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _copyDefault.default), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, "Copy"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Keyboard), null, "\u2318C")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
        textValue: "Cut"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _cutDefault.default), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, "Cut"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Keyboard), null, "\u2318X")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
        textValue: "Paste"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _pasteDefault.default), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, "Paste"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Keyboard), null, "\u2318V"))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Section), {
        title: "Section 2"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
        textValue: "Puppy"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _alignLeftDefault.default), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, "Puppy"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), {
        slot: "description"
    }, "Puppy description super long as well geez")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
        textValue: "Doggo with really really really long long long text"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _alignCenterDefault.default), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, "Doggo with really really really long long long text"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), {
        slot: "end"
    }, "Value")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
        textValue: "Floof"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _alignRightDefault.default), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, "Floof")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), null, "Basic Item")))));
MenuWithSemanticElementsStatic.story = {
    name: "menu with semantic elements (static)"
};
const MenuWithSemanticElementsGenerative = ()=>render(/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Menu), {
        items: hardModeProgrammatic,
        onAction: (0, _addonActions.action)("onAction")
    }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Section), {
            key: item.name,
            items: item.children,
            title: item.name
        }, (item)=>customMenuItem(item))));
MenuWithSemanticElementsGenerative.story = {
    name: "menu with semantic elements (generative)"
};
const MenuShouldPreventScrolling = ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        style: {
            height: 100,
            display: "flex"
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        style: {
            paddingTop: 100,
            height: 100,
            overflow: "auto",
            background: "antiquewhite"
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        style: {
            height: 200
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", null, "Shouldn't be able to scroll here while Menu is open."), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.MenuTrigger), {
        onOpenChange: (0, _addonActions.action)("onOpenChange"),
        defaultOpen: true
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), {
        onPress: (0, _addonActions.action)("press"),
        onPressStart: (0, _addonActions.action)("pressstart"),
        onPressEnd: (0, _addonActions.action)("pressend")
    }, "Menu Button"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Menu), {
        items: withSection,
        onAction: (0, _addonActions.action)("action")
    }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Section), {
            key: item.name,
            items: item.children,
            title: item.name
        }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
                key: item.name,
                childItems: item.children
            }, item.name)))))), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        style: {
            paddingTop: 100,
            height: 100,
            overflow: "auto",
            flex: 1,
            background: "grey"
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        style: {
            height: 200
        }
    }, "Also shouldn't be able to scroll here while Menu is open.")));
MenuShouldPreventScrolling.story = {
    name: "menu should prevent scrolling"
};
const MenuClosesOnBlur = ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        style: {
            display: "flex",
            width: "auto",
            margin: "250px 0"
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("label", {
        htmlFor: "focus-before"
    }, "Focus before"), /*#__PURE__*/ (0, _reactDefault.default).createElement("input", {
        id: "focus-before"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.MenuTrigger), {
        onOpenChange: (0, _addonActions.action)("onOpenChange")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), {
        onPress: (0, _addonActions.action)("press"),
        onPressStart: (0, _addonActions.action)("pressstart"),
        onPressEnd: (0, _addonActions.action)("pressend")
    }, "Menu Button"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Menu), {
        items: withSection,
        onAction: (0, _addonActions.action)("action"),
        disabledKeys: [
            "Snake",
            "Ross"
        ]
    }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Section), {
            key: item.name,
            items: item.children,
            title: item.name
        }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
                key: item.name,
                childItems: item.children
            }, item.name)))), /*#__PURE__*/ (0, _reactDefault.default).createElement("label", {
        htmlFor: "focus-after"
    }, "Focus after"), /*#__PURE__*/ (0, _reactDefault.default).createElement("input", {
        id: "focus-after"
    })));
MenuClosesOnBlur.story = {
    name: "menu closes on blur"
};
const WithFalsyKey = ()=>render(/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Menu), {
        onAction: (0, _addonActions.action)("onAction")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
        key: "1"
    }, "One"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
        key: ""
    }, "Two"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
        key: "3"
    }, "Three")));
WithFalsyKey.story = {
    name: "with falsy key"
};
const MenuTriggerWithTriggerLongPress = ()=>render(defaultMenu, {
        trigger: "longPress"
    });
MenuTriggerWithTriggerLongPress.story = {
    name: 'MenuTrigger with trigger="longPress"'
};
const ControlledIsOpen = ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement(ControlledOpeningMenuTrigger, null);
ControlledIsOpen.story = {
    name: "controlled isOpen"
};
const WithTranslations = ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _menuTriggerLanguagesChromatic.TranslateMenu), null);
WithTranslations.story = {
    name: "with translations",
    parameters: {
        description: {
            data: "Translations included for: Arabic, English, Hebrew, Japanese, Korean, Simplified Chinese, and Traditional Chinese."
        }
    }
};
let customMenuItem = (item)=>{
    let Icon = iconMap[item.icon];
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
        childItems: item.children,
        textValue: item.name,
        key: item.name
    }, item.icon && /*#__PURE__*/ (0, _reactDefault.default).createElement(Icon, null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, item.name), item.shortcut && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Keyboard), null, item.shortcut));
};
function render(menu, { isDisabled, ...props } = {}, menuProps = {}) {
    let menuRender = /*#__PURE__*/ (0, _reactDefault.default).cloneElement(menu, menuProps);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        style: {
            display: "flex",
            width: "auto",
            margin: "250px 0"
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.MenuTrigger), {
        onOpenChange: (0, _addonActions.action)("onOpenChange"),
        ...props
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), {
        isDisabled: isDisabled,
        onPress: (0, _addonActions.action)("press"),
        onPressStart: (0, _addonActions.action)("pressstart"),
        onPressEnd: (0, _addonActions.action)("pressend")
    }, "Menu Button"), menuRender));
}
let defaultMenu = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Menu), {
    items: withSection,
    onAction: (0, _addonActions.action)("action"),
    disabledKeys: [
        "Snake",
        "Ross"
    ]
}, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Section), {
        key: item.name,
        items: item.children,
        title: item.name
    }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            key: item.name,
            childItems: item.children
        }, item.name)));
function ControlledOpeningMenuTrigger() {
    let [isOpen, setIsOpen] = (0, _react.useState)(false);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        style: {
            display: "flex",
            width: "auto",
            margin: "250px 0"
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.MenuTrigger), {
        onOpenChange: setIsOpen,
        isOpen: isOpen
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), {
        onPress: (0, _addonActions.action)("press"),
        onPressStart: (0, _addonActions.action)("pressstart"),
        onPressEnd: (0, _addonActions.action)("pressend")
    }, "Menu Button"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Menu), {
        onAction: (0, _addonActions.action)("onAction")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
        key: "1"
    }, "One"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
        key: ""
    }, "Two"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
        key: "3"
    }, "Three"))));
}
let MenuItemUnavailable = {
    render: ()=>render(/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Menu), {
            onAction: (0, _addonActions.action)("onAction")
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            key: "1"
        }, "One"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ContextualHelpTrigger), {
            isUnavailable: true
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            key: "foo"
        }, "Two"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _dialog.Dialog), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Heading), null, "hello"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Content), null, "Is it me you're looking for?"))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ContextualHelpTrigger), {
            isUnavailable: true
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            key: "baz"
        }, "Two point five"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _dialog.Dialog), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Heading), null, "hello"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Content), null, "Is it me you're looking for?"))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            key: "3"
        }, "Three"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ContextualHelpTrigger), {
            isUnavailable: true
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            key: "bar",
            textValue: "Four"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, "Four"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), {
            slot: "description"
        }, "Shut the door")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _dialog.Dialog), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Heading), null, "hello"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Content), null, "Is it me you're looking for?"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Footer), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _link.Link), null, "Learn more")))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            key: "5"
        }, "Five")))
};
let MenuItemUnavailableDynamic = {
    render: ()=>render(/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Menu), {
            items: flatMenu,
            onAction: (0, _addonActions.action)("onAction")
        }, (item)=>{
            if (item.name === "Kangaroo") return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ContextualHelpTrigger), {
                isUnavailable: true
            }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
                key: item.name
            }, item.name), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _dialog.Dialog), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Heading), null, "hello"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Content), null, "Is it me you're looking for?")));
            return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
                key: item.name
            }, item.name);
        }))
};
let MenuItemUnavailableToggling = {
    render: ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement(MenuWithUnavailableSometimes, null)
};
function MenuWithUnavailableSometimes(props) {
    let [isUnavailable, setIsUnavailable] = (0, _react.useState)(false);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSpectrum.ToggleButton), {
        isSelected: isUnavailable,
        onChange: setIsUnavailable
    }, "Toggle item 2"), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        style: {
            display: "flex",
            width: "auto",
            margin: "250px 0"
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.MenuTrigger), {
        onOpenChange: (0, _addonActions.action)("onOpenChange"),
        ...props
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), null, "Menu Button"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Menu), {
        onAction: (0, _addonActions.action)("onAction")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
        key: "1"
    }, "One"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ContextualHelpTrigger), {
        isUnavailable: isUnavailable
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
        key: "foo"
    }, "Two"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _dialog.Dialog), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Heading), null, "hello"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Content), null, "Is it me you're looking for?"))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ContextualHelpTrigger), {
        isUnavailable: true
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
        key: "baz"
    }, "Two point five"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _dialog.Dialog), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Heading), null, "hello"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Content), null, "Is it me you're looking for?"))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
        key: "3"
    }, "Three"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ContextualHelpTrigger), {
        isUnavailable: true
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
        key: "bar",
        textValue: "Four"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, "Four"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), {
        slot: "description"
    }, "Shut the door")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _dialog.Dialog), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Heading), null, "hello"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Content), null, "Is it me you're looking for?"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Footer), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _link.Link), null, "Learn more")))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
        key: "5"
    }, "Five")))), /*#__PURE__*/ (0, _reactDefault.default).createElement("input", null));
}
const MenuWithLinks = (props)=>render(/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Menu), {
        ...props,
        onAction: (0, _addonActions.action)("onAction")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
        href: "https://adobe.com"
    }, "Adobe"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
        href: "https://google.com"
    }, "Google"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
        href: "https://apple.com"
    }, "Apple")));
MenuWithLinks.story = {
    args: {
        selectionMode: "none"
    },
    argTypes: {
        selectionMode: {
            control: {
                type: "inline-radio",
                options: [
                    "none",
                    "single",
                    "multiple"
                ]
            }
        }
    }
};

},{"@storybook/addon-actions":"coXbW","@react-spectrum/button":"jZWyP","@spectrum-icons/workflow/AlignCenter":"2Chkz","@spectrum-icons/workflow/AlignLeft":"65eDL","@spectrum-icons/workflow/AlignRight":"3qK4F","@spectrum-icons/workflow/Blower":"8N8wp","@spectrum-icons/workflow/Book":"e9BS5","@react-spectrum/view":"dnRjt","../":"8myJq","@spectrum-icons/workflow/Copy":"jpSBZ","@spectrum-icons/workflow/Cut":"4SMrV","@react-spectrum/dialog":"3G0HV","@react-spectrum/text":"etCGI","@react-spectrum/link":"lNoiB","@spectrum-icons/workflow/Paste":"jKZ2V","react":"9yzVZ","@adobe/react-spectrum":"cwANo","./../chromatic/MenuTriggerLanguages.chromatic":"1OwiN","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"1OwiN":[function(require,module,exports) {
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TranslateMenu", ()=>TranslateMenu);
parcelHelpers.export(exports, "ArabicComplex", ()=>ArabicComplex);
parcelHelpers.export(exports, "HebrewComplex", ()=>HebrewComplex);
parcelHelpers.export(exports, "JapaneseComplex", ()=>JapaneseComplex);
parcelHelpers.export(exports, "KoreanComplex", ()=>KoreanComplex);
parcelHelpers.export(exports, "ChineseSimplfiedComplex", ()=>ChineseSimplfiedComplex);
parcelHelpers.export(exports, "ChineseTraditionalComplex", ()=>ChineseTraditionalComplex);
var _button = require("@react-spectrum/button");
var _copy = require("@spectrum-icons/workflow/Copy");
var _copyDefault = parcelHelpers.interopDefault(_copy);
var _cut = require("@spectrum-icons/workflow/Cut");
var _cutDefault = parcelHelpers.interopDefault(_cut);
// @ts-ignore
var _intlMessagesJson = require("./intlMessages.json");
var _intlMessagesJsonDefault = parcelHelpers.interopDefault(_intlMessagesJson);
var _ = require("../");
var _text = require("@react-spectrum/text");
var _paste = require("@spectrum-icons/workflow/Paste");
var _pasteDefault = parcelHelpers.interopDefault(_paste);
var _provider = require("@react-spectrum/provider");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _i18N = require("@react-aria/i18n");
exports.default = {
    title: "Languages/MenuTrigger",
    parameters: {
        chromaticProvider: {
            colorSchemes: [
                "light"
            ],
            express: false,
            locales: [
                "en-US"
            ],
            scales: [
                "large"
            ]
        }
    },
    excludeStories: [
        "TranslateMenu"
    ]
};
let iconMap = {
    Copy: (0, _copyDefault.default),
    Cut: (0, _cutDefault.default),
    Paste: (0, _pasteDefault.default)
};
let menuItems = [
    {
        name: "copy",
        icon: "Copy",
        shortcut: "\u2318C"
    },
    {
        name: "cut",
        icon: "Cut",
        shortcut: "\u2318X"
    },
    {
        name: "paste",
        icon: "Paste",
        shortcut: "\u2318V"
    }
];
const customMenuItem = (item, strings)=>{
    let Icon = iconMap[item.icon];
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
        textValue: item.name,
        key: item.name
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Icon, {
        size: "S"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, strings.format(item.name)), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Keyboard), null, item.shortcut));
};
let TranslateMenu = (props)=>{
    let strings = (0, _i18N.useLocalizedStringFormatter)((0, _intlMessagesJsonDefault.default));
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.MenuTrigger), props, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), null, strings.format("button")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Menu), {
        items: menuItems
    }, (item)=>customMenuItem(item, strings)));
};
const ArabicComplex = ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _provider.Provider), {
        locale: "ar-AE"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(TranslateMenu, {
        isOpen: true
    }));
const HebrewComplex = ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _provider.Provider), {
        locale: "he-IL"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(TranslateMenu, {
        isOpen: true
    }));
const JapaneseComplex = ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _provider.Provider), {
        locale: "ja-JP"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(TranslateMenu, {
        isOpen: true
    }));
const KoreanComplex = ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _provider.Provider), {
        locale: "ko-KR"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(TranslateMenu, {
        isOpen: true
    }));
const ChineseSimplfiedComplex = ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _provider.Provider), {
        locale: "zh-CN"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(TranslateMenu, {
        isOpen: true
    }));
const ChineseTraditionalComplex = ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _provider.Provider), {
        locale: "zh-TW"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(TranslateMenu, {
        isOpen: true
    }));

},{"@react-spectrum/button":"jZWyP","@spectrum-icons/workflow/Copy":"jpSBZ","@spectrum-icons/workflow/Cut":"4SMrV","./intlMessages.json":"24ie3","../":"8myJq","@react-spectrum/text":"etCGI","@spectrum-icons/workflow/Paste":"jKZ2V","@react-spectrum/provider":"5bCdp","react":"9yzVZ","@react-aria/i18n":"411rg","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"24ie3":[function(require,module,exports) {
module.exports = JSON.parse('{"ar-AR":{"button":"\u064A\u062D\u0631\u0631","copy":"\u064A\u0646\u0633\u062E","cut":"\u064A\u0642\u0637\u0639","paste":"\u0645\u0639\u062C\u0648\u0646"},"en-US":{"button":"Edit","copy":"Copy","cut":"Cut","paste":"Paste"},"he-IL":{"button":"\u05DC\u05B7\u05E2\u05B2\u05E8\u05D5\u05B9\u05DA","copy":"\u05E2\u05D5\u05EA\u05E7","cut":"\u05D2\u05D6\u05D9\u05E8\u05D4","paste":"\u05DC\u05B0\u05D4\u05B7\u05D3\u05D1\u05BC\u05B4\u05D9\u05E7"},"ja-JP":{"button":"\u7DE8\u96C6","copy":"\u30B3\u30D4\u30FC","cut":"\u5207\u308B","paste":"\u30DA\u30FC\u30B9\u30C8"},"ko-KR":{"button":"\uD3B8\uC9D1\uD558\uB2E4","copy":"\uBCF5\uC0AC","cut":"\uC790\uB974\uB2E4","paste":"\uBC18\uC8FD"},"zh-CN":{"button":"\u7F16\u8F91","copy":"\u590D\u5236","cut":"\u5207","paste":"\u7C98\u8D34"},"zh-TW":{"button":"\u7DE8\u8F2F","copy":"\u8907\u88FD","cut":"\u5207","paste":"\u7C98\u8CBC"}}');

},{}],"5dFCD":[function(require,module,exports) {
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SubmenuStatic", ()=>SubmenuStatic);
parcelHelpers.export(exports, "SubmenuDynamic", ()=>SubmenuDynamic);
parcelHelpers.export(exports, "SubmenuManyItems", ()=>SubmenuManyItems);
parcelHelpers.export(exports, "SubmenuStaticSections", ()=>SubmenuStaticSections);
parcelHelpers.export(exports, "SubmenuDynamicSections", ()=>SubmenuDynamicSections);
parcelHelpers.export(exports, "MainSectionsSubNoSections", ()=>MainSectionsSubNoSections);
parcelHelpers.export(exports, "MainNoSectionsSubSections", ()=>MainNoSectionsSubSections);
parcelHelpers.export(exports, "MixedSections", ()=>MixedSections);
parcelHelpers.export(exports, "Complex", ()=>Complex);
parcelHelpers.export(exports, "SubmenuActions", ()=>SubmenuActions);
parcelHelpers.export(exports, "SubmenuSelection", ()=>SubmenuSelection);
parcelHelpers.export(exports, "DisabledSubmenuTrigger", ()=>DisabledSubmenuTrigger);
parcelHelpers.export(exports, "NoKeysProvided", ()=>NoKeysProvided);
parcelHelpers.export(exports, "ConditionalSubmenu", ()=>ConditionalSubmenu);
parcelHelpers.export(exports, "UnavailableWithSubmenu", ()=>UnavailableWithSubmenu);
parcelHelpers.export(exports, "TabBehaviorStory", ()=>TabBehaviorStory);
var _addonActions = require("@storybook/addon-actions");
var _button = require("@react-spectrum/button");
var _alignCenter = require("@spectrum-icons/workflow/AlignCenter");
var _alignCenterDefault = parcelHelpers.interopDefault(_alignCenter);
var _alignLeft = require("@spectrum-icons/workflow/AlignLeft");
var _alignLeftDefault = parcelHelpers.interopDefault(_alignLeft);
var _alignRight = require("@spectrum-icons/workflow/AlignRight");
var _alignRightDefault = parcelHelpers.interopDefault(_alignRight);
var _annotatePen = require("@spectrum-icons/workflow/AnnotatePen");
var _annotatePenDefault = parcelHelpers.interopDefault(_annotatePen);
var _view = require("@react-spectrum/view");
var _ = require("../");
var _menuTriggerStories = require("./MenuTrigger.stories");
var _menuTriggerStoriesDefault = parcelHelpers.interopDefault(_menuTriggerStories);
var _dialog = require("@react-spectrum/dialog");
var _text = require("@react-spectrum/text");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _textIndentIncrease = require("@spectrum-icons/workflow/TextIndentIncrease");
var _textIndentIncreaseDefault = parcelHelpers.interopDefault(_textIndentIncrease);
var _textItalic = require("@spectrum-icons/workflow/TextItalic");
var _textItalicDefault = parcelHelpers.interopDefault(_textItalic);
var _reactSpectrum = require("@adobe/react-spectrum");
exports.default = {
    ...(0, _menuTriggerStoriesDefault.default),
    title: "MenuTrigger/Submenu"
};
const SubmenuStatic = {
    render: (args)=>(0, _menuTriggerStories.render)(/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Menu), {
            onAction: (0, _addonActions.action)("lvl 1 menu onAction"),
            ...args
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            key: "Lvl 1 Item 1"
        }, "Lvl 1 Item 1"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.SubmenuTrigger), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            key: "Lvl 1 Item 2"
        }, "Lvl 1 Item 2"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Menu), {
            onAction: (0, _addonActions.action)("lvl 2 menu onAction"),
            ...args.submenu1Props
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            key: "Lvl 2 Item 1"
        }, "Lvl 2 Item 1"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            key: "Lvl 2 Item 2"
        }, "Lvl 2 Item 2"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.SubmenuTrigger), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            key: "Lvl 2 Item 3"
        }, "Lvl 2 Item 3"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Menu), {
            onAction: (0, _addonActions.action)("lvl 3 menu onAction"),
            ...args.submenu2Props
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            key: "Lvl 3 Item 1"
        }, "Lvl 3 Item 1"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            key: "Lvl 3 Item 2"
        }, "Lvl 3 Item 2"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            key: "Lvl 3 Item 3"
        }, "Lvl 3 Item 3"))))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            key: "Lvl 1 Item 3"
        }, "Lvl 1 Item 3")), args.menuTriggerProps),
    name: "static submenu items"
};
let dynamicSubmenu = [
    {
        name: "Lvl 1 Item 1"
    },
    {
        name: "Lvl 1 Item 2",
        children: [
            {
                name: "Lvl 2 Item 1"
            },
            {
                name: "Lvl 2 Item 2"
            },
            {
                name: "Lvl 2 Item 3",
                children: [
                    {
                        name: "Lvl 3 Item 1"
                    },
                    {
                        name: "Lvl 3 Item 2"
                    },
                    {
                        name: "Lvl 3 Item 3"
                    }
                ]
            }
        ]
    },
    {
        name: "Lvl 1 Item 3"
    }
];
let manyItemsSubmenu = [
    {
        name: "Lvl 1 Item 1"
    },
    {
        name: "Lvl 1 Item 2",
        children: [
            ...[
                ...Array(30)
            ].map((_, i)=>({
                    name: `Lvl 2 Item ${i + 1}`
                })),
            {
                name: "Lvl 2 Item 31",
                children: [
                    {
                        name: "Lvl 3 Item 1"
                    },
                    {
                        name: "Lvl 3 Item 2"
                    },
                    {
                        name: "Lvl 3 Item 3"
                    }
                ]
            }
        ]
    },
    ...[
        ...Array(30)
    ].map((_, i)=>({
            name: `Lvl 1 Item ${i + 3}`
        }))
];
// TODO: is this really the only way to define the dynamic render func? Kinda annoying that we have
// to define this func separately and recursively call it, but I don't think we can do the same approach as
// collapsible rows tableview since Menu isn't a collection component nor are we making the parent Menu tree collection
// track the full "tree" of menu items (we aren't making Item take other items/sections as children and are relying on each submenu having its own
// tree state + collection tracking its own level of items).
let dynamicRenderFunc = (item)=>{
    if (item.children) return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.SubmenuTrigger), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
        key: item.name
    }, item.name), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Menu), {
        items: item.children,
        onAction: (0, _addonActions.action)(`${item.name} onAction`)
    }, (item)=>dynamicRenderFunc(item)));
    else return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
        key: item.name
    }, item.name);
};
const SubmenuDynamic = {
    render: (args)=>(0, _menuTriggerStories.render)(/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Menu), {
            items: dynamicSubmenu,
            onAction: (0, _addonActions.action)("onAction"),
            ...args
        }, (item)=>dynamicRenderFunc(item))),
    name: "dynamic submenu items"
};
const SubmenuManyItems = {
    render: (args)=>(0, _menuTriggerStories.render)(/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Menu), {
            items: manyItemsSubmenu,
            onAction: (0, _addonActions.action)("onAction"),
            ...args
        }, (item)=>dynamicRenderFunc(item))),
    name: "dynamic submenu with many items"
};
const SubmenuStaticSections = {
    render: ()=>(0, _menuTriggerStories.render)(/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Menu), {
            onAction: (0, _addonActions.action)("onAction")
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Section), {
            title: "Section 1"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            key: "Sec 1 Lvl 1 Item 1"
        }, "Sec 1 Lvl 1 Item 1"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.SubmenuTrigger), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            key: "Sec 1 Lvl 1 Item 2"
        }, "Sec 1 Lvl 1 Item 2"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Menu), {
            onAction: (0, _addonActions.action)("Sec 1 Lvl 2 menu onAction")
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Section), {
            title: "Sub Section 1"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            key: "Sec 1 SubSec 1 Lvl 2 Item 1"
        }, "Sec 1 SubSec 1 Lvl 2 Item 1"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            key: "Sec 1 SubSec 1 Lvl 2 Item 2"
        }, "Sec 1 SubSec 1 Lvl 2 Item 2"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            key: "Sec 1 SubSec 1 Lvl 2 Item 3"
        }, "Sec 1 SubSec 1 Lvl 2 Item 3")))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            key: "Sec 1 Lvl 1 Item 3"
        }, "Sec 1 Lvl 1 Item 3")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Section), {
            title: "Section 2"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            key: "Sec 2 Lvl 1 Item 1"
        }, "Sec 2 Lvl 1 Item 1"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.SubmenuTrigger), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            key: "Sec 2 Lvl 1 Item 2"
        }, "Sec 2 Lvl 1 Item 2"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Menu), {
            onAction: (0, _addonActions.action)("Sec 2 Lvl 2 menu onAction")
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Section), {
            title: "Sub Section 1"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            key: "Sec 2 SubSec 1 Lvl 2 Item 1"
        }, "Sec 2 SubSec 1 Lvl 2 Item 1"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            key: "Sec 2 SubSec 1 Lvl 2 Item 2"
        }, "Sec 2 SubSec 1 Lvl 2 Item 2"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            key: "Sec 2 SubSec 1 Lvl 2 Item 3"
        }, "Sec 2 SubSec 1 Lvl 2 Item 3")))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            key: "Sec 2 Lvl 1 Item 3"
        }, "Sec 2 Lvl 1 Item 3")))),
    name: "static submenu items with sections"
};
let dynamicSubmenuSections = [
    {
        name: "Section 1",
        isSection: true,
        children: [
            {
                name: "Sec 1 Lvl 1 Item 1"
            },
            {
                name: "Sec 1 Lvl 1 Item 2",
                children: [
                    {
                        name: "Sub Section 1",
                        isSection: true,
                        children: [
                            {
                                name: "Sec 1 SubSec 1 Lvl 2 Item 1"
                            },
                            {
                                name: "Sec 1 SubSec 1 Lvl 2 Item 2"
                            },
                            {
                                name: "Sec 1 SubSec 1 Lvl 2 Item 3",
                                children: [
                                    {
                                        name: "Sub Section 1.1",
                                        isSection: true,
                                        children: [
                                            {
                                                name: "Sec 1 SubSec 1.1 Lvl 3 Item 1"
                                            },
                                            {
                                                name: "Sec 1 SubSec 1.1 Lvl 3 Item 2"
                                            },
                                            {
                                                name: "Sec 1 SubSec 1.1 Lvl 3 Item 3"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                name: "Sec 1 Lvl 1 Item 3"
            }
        ]
    },
    {
        name: "Section 2",
        isSection: true,
        children: [
            {
                name: "Sec 2 Lvl 1 Item 1"
            },
            {
                name: "Sec 2 Lvl 1 Item 2",
                children: [
                    {
                        name: "Sub Section 1",
                        isSection: true,
                        children: [
                            {
                                name: "Sec 2 SubSec 1 Lvl 2 Item 1"
                            },
                            {
                                name: "Sec 2 SubSec 1 Lvl 2 Item 2"
                            },
                            {
                                name: "Sec 2 SubSec 1 Lvl 2 Item 3"
                            }
                        ]
                    }
                ]
            },
            {
                name: "Sec 2 Lvl 1 Item 3"
            }
        ]
    }
];
let iconMap = {
    AlignCenter: (0, _alignCenterDefault.default),
    AlignLeft: (0, _alignLeftDefault.default),
    AlignRight: (0, _alignRightDefault.default),
    AnnotatePen: (0, _annotatePenDefault.default),
    TextIndentIncrease: (0, _textIndentIncreaseDefault.default),
    TextItalics: (0, _textItalicDefault.default)
};
let dynamicRenderTrigger = (item, Icon)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.SubmenuTrigger), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
        key: item.name,
        textValue: item.name
    }, item.icon && /*#__PURE__*/ (0, _reactDefault.default).createElement(Icon, {
        size: "S"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, item.name)), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Menu), {
        items: item.children,
        onAction: (0, _addonActions.action)(`${item.name} onAction`)
    }, (item)=>dynamicRenderFuncSections(item)));
let dynamicRenderItem = (item, Icon)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
        key: item.name,
        textValue: item.name
    }, item.icon && /*#__PURE__*/ (0, _reactDefault.default).createElement(Icon, {
        size: "S"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, item.name), item.shortcut && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Keyboard), null, item.shortcut));
let dynamicRenderFuncSections = (item)=>{
    let Icon = iconMap[item.icon];
    if (item.children) {
        if (item.isSection) {
            var _item_name;
            let key = (_item_name = item.name) !== null && _item_name !== void 0 ? _item_name : item.textValue;
            return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Section), {
                key: key,
                title: item === null || item === void 0 ? void 0 : item.name,
                "aria-label": item === null || item === void 0 ? void 0 : item.textValue,
                items: item.children
            }, (item)=>{
                if (item.children) return dynamicRenderTrigger(item, Icon);
                else return dynamicRenderItem(item, Icon);
            });
        } else return dynamicRenderTrigger(item, Icon);
    } else return dynamicRenderItem(item, Icon);
};
const SubmenuDynamicSections = {
    render: ()=>(0, _menuTriggerStories.render)(/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Menu), {
            items: dynamicSubmenuSections,
            onAction: (0, _addonActions.action)("onAction")
        }, (item)=>dynamicRenderFuncSections(item))),
    name: "dynamic submenu items with sections"
};
let submenuNoSection = [
    {
        name: "Section 1",
        isSection: true,
        children: [
            {
                name: "Sec 1 Lvl 1 Item 1",
                children: [
                    {
                        name: "Sec 1 Lvl 2.1 Item 1"
                    },
                    {
                        name: "Sec 1 Lvl 2.1 Item 2"
                    },
                    {
                        name: "Sec 1 Lvl 2.1 Item 3"
                    }
                ]
            },
            {
                name: "Sec 1 Lvl 1 Item 2",
                children: [
                    {
                        name: "Sec 1 Lvl 2.2 Item 1"
                    },
                    {
                        name: "Sec 1 Lvl 2.2 Item 2"
                    },
                    {
                        name: "Sec 1 Lvl 2.2 Item 3",
                        children: [
                            {
                                name: "Sec 1 Lvl 3.2 Item 1"
                            },
                            {
                                name: "Sec 1 Lvl 3.2 Item 2"
                            },
                            {
                                name: "Sec 1 Lvl 3.2 Item 3"
                            }
                        ]
                    }
                ]
            },
            {
                name: "Sec 1 Lvl 1 Item 3"
            }
        ]
    }
];
const MainSectionsSubNoSections = {
    render: ()=>(0, _menuTriggerStories.render)(/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Menu), {
            items: submenuNoSection,
            onAction: (0, _addonActions.action)("onAction")
        }, (item)=>dynamicRenderFuncSections(item))),
    name: "dynamic, main menu w/ sections, sub menu no sections"
};
let submenuSections = [
    {
        name: "Lvl 1 Item 1",
        children: [
            {
                name: "Section 1",
                isSection: true,
                children: [
                    {
                        name: "Sec 1 Lvl 2.1 Item 1"
                    },
                    {
                        name: "Sec 1 Lvl 2.1 Item 2"
                    },
                    {
                        name: "Sec 1 Lvl 2.1 Item 3"
                    }
                ]
            }
        ]
    },
    {
        name: "Lvl 1 Item 2",
        children: [
            {
                name: "Section 1",
                isSection: true,
                children: [
                    {
                        name: "Sec 1 Lvl 2 Item 1"
                    },
                    {
                        name: "Sec 1 Lvl 2 Item 2"
                    },
                    {
                        name: "Sec 1 Lvl 2 Item 3",
                        children: [
                            {
                                name: "Section 1.1",
                                isSection: true,
                                children: [
                                    {
                                        name: "Sec 1.1 Lvl 3 Item 1"
                                    },
                                    {
                                        name: "Sec 1.1 Lvl 3 Item 2"
                                    },
                                    {
                                        name: "Sec 1.1 Lvl 3 Item 3"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    },
    {
        name: "Lvl 1 Item 3"
    }
];
const MainNoSectionsSubSections = {
    render: ()=>(0, _menuTriggerStories.render)(/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Menu), {
            items: submenuSections,
            onAction: (0, _addonActions.action)("onAction")
        }, (item)=>dynamicRenderFuncSections(item))),
    name: "dynamic, main menu no sections, sub menu w/ sections"
};
let mixedSectionsAndNonSections = [
    {
        name: "Lvl 1 Item 1"
    },
    {
        name: "Lvl 1 Item 2",
        children: [
            {
                name: "Section 1",
                isSection: true,
                children: [
                    {
                        name: "Sec 1 Lvl 2 Item 1"
                    },
                    {
                        name: "Sec 1 Lvl 2 Item 2"
                    },
                    {
                        name: "Sec 1 Lvl 2 Item 3",
                        children: [
                            {
                                name: "Sec 1 Lvl 3 Item 1",
                                children: [
                                    {
                                        name: "Section 1.1",
                                        isSection: true,
                                        children: [
                                            {
                                                name: "Sec 1.1 Lvl 4 Item 1"
                                            },
                                            {
                                                name: "Sec 1.1 Lvl 4 Item 2"
                                            },
                                            {
                                                name: "Sec 1.1 Lvl 4 Item 3"
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                name: "Sec 1 Lvl 3 Item 2"
                            },
                            {
                                name: "Sec 1 Lvl 3 Item 3"
                            }
                        ]
                    }
                ]
            }
        ]
    },
    {
        name: "Lvl 1 Item 3"
    }
];
const MixedSections = {
    render: ()=>(0, _menuTriggerStories.render)(/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Menu), {
            items: mixedSectionsAndNonSections,
            onAction: (0, _addonActions.action)("onAction")
        }, (item)=>dynamicRenderFuncSections(item))),
    name: "dynamic, mix of menus w/ sections and w/o sections"
};
let complex = [
    {
        name: "Font",
        icon: "AnnotatePen",
        children: [
            {
                textValue: "Font styles",
                isSection: true,
                children: [
                    {
                        name: "Show Fonts",
                        shortcut: "\u2318T"
                    },
                    {
                        name: "Bold",
                        shortcut: "\u2318B"
                    },
                    {
                        name: "Italics",
                        shortcut: "\u2318I"
                    },
                    {
                        name: "Underline",
                        shortcut: "\u2318U"
                    },
                    {
                        name: "Strikethrough"
                    }
                ]
            },
            {
                textValue: "Font size",
                isSection: true,
                children: [
                    {
                        name: "Bigger",
                        shortcut: "\u2318+"
                    },
                    {
                        name: "Smaller",
                        shortcut: "\u2318-"
                    }
                ]
            },
            {
                textValue: "Baseline section",
                isSection: true,
                children: [
                    {
                        name: "Baseline",
                        children: [
                            {
                                name: "Use default"
                            },
                            {
                                name: "Superscript"
                            },
                            {
                                name: "Subscript"
                            }
                        ]
                    }
                ]
            }
        ]
    },
    {
        name: "Text",
        icon: "TextItalics",
        children: [
            {
                name: "Align Left",
                icon: "AlignLeft",
                shortcut: "\u2318{"
            },
            {
                name: "Center",
                icon: "AlignCenter",
                shortcut: "\u2318|"
            },
            {
                name: "Justify"
            },
            {
                name: "Align Right",
                icon: "AlignRight",
                shortcut: "\u2318}"
            }
        ]
    },
    {
        name: "Indentation",
        icon: "TextIndentIncrease",
        children: [
            {
                name: "Increase",
                shortcut: "\u2318]"
            },
            {
                name: "Decrease",
                shortcut: "\u2318["
            }
        ]
    }
];
const Complex = {
    render: ()=>(0, _menuTriggerStories.render)(/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Menu), {
            items: complex,
            onAction: (0, _addonActions.action)("onAction")
        }, (item)=>dynamicRenderFuncSections(item))),
    name: "complex"
};
const SubmenuActions = {
    render: (args)=>(0, _menuTriggerStories.render)(/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Menu), {
            onAction: (0, _addonActions.action)("onAction lvl 1 menu"),
            onClose: (0, _addonActions.action)("onClose lvl 1 menu"),
            ...args
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            key: "Lvl 1 Item 1"
        }, "Lvl 1 Item 1"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.SubmenuTrigger), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            key: "Lvl 1 Item 2"
        }, "Lvl 1 Item 2"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Menu), {
            onAction: (0, _addonActions.action)("onAction lvl 2 menu"),
            onClose: (0, _addonActions.action)("onClose menu 2")
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            key: "Lvl 2 Item 1"
        }, "Lvl 2 Item 1"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            key: "Lvl 2 Item 2"
        }, "Lvl 2 Item 2"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.SubmenuTrigger), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            key: "Lvl 2 Item 3"
        }, "Lvl 2 Item 3"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Menu), {
            onAction: (0, _addonActions.action)("onAction lvl 3 menu"),
            onClose: (0, _addonActions.action)("onClose menu 3")
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            key: "Lvl 3 Item 1"
        }, "Lvl 3 Item 1"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            key: "Lvl 3 Item 2"
        }, "Lvl 3 Item 2"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            key: "Lvl 3 Item 3"
        }, "Lvl 3 Item 3"))))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            key: "Lvl 1 Item 3"
        }, "Lvl 1 Item 3"))),
    name: "submenu onAction and onClose",
    parameters: {
        description: {
            data: "Each menu has its own onAction and onClose that are triggered only if its direct menu option was acted upon."
        }
    }
};
const SubmenuSelection = {
    render: (args)=>(0, _menuTriggerStories.render)(/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Menu), {
            onSelectionChange: (0, _addonActions.action)("onSelectionChange lvl 1 menu"),
            selectionMode: "multiple",
            defaultSelectedKeys: "all",
            ...args
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            key: "Lvl 1 Item 1"
        }, "Lvl 1 Item 1"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.SubmenuTrigger), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            key: "Lvl 1 Item 2"
        }, "Lvl 1 Item 2"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Menu), {
            onSelectionChange: (0, _addonActions.action)("onSelectionChange lvl 2 menu"),
            selectionMode: "single",
            defaultSelectedKeys: [
                "Lvl 2 Item 3"
            ]
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            key: "Lvl 2 Item 1"
        }, "Lvl 2 Item 1"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            key: "Lvl 2 Item 2"
        }, "Lvl 2 Item 2"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.SubmenuTrigger), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            key: "Lvl 2 Item 3"
        }, "Lvl 2 Item 3"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Menu), {
            onSelectionChange: (0, _addonActions.action)("onSelectionChange lvl 3 menu"),
            selectionMode: "multiple"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            key: "Lvl 3 Item 1"
        }, "Lvl 3 Item 1"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            key: "Lvl 3 Item 2"
        }, "Lvl 3 Item 2"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            key: "Lvl 3 Item 3"
        }, "Lvl 3 Item 3"))))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            key: "Lvl 1 Item 3"
        }, "Lvl 1 Item 3"))),
    name: "submenu selectionMode and onSelectionChange",
    parameters: {
        description: {
            data: "Lvl 1 and Lvl 3 menus have multiple selection, Lvl 2 menu has single selection"
        }
    }
};
const DisabledSubmenuTrigger = {
    render: (args)=>(0, _menuTriggerStories.render)(/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Menu), {
            onSelectionChange: (0, _addonActions.action)("onSelectionChange lvl 1 menu"),
            selectionMode: "multiple",
            ...args
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            key: "Lvl 1 Item 1"
        }, "Lvl 1 Item 1"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.SubmenuTrigger), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            key: "Lvl 1 Item 2"
        }, "Lvl 1 Item 2"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Menu), {
            onSelectionChange: (0, _addonActions.action)("onSelectionChange lvl 2 menu"),
            selectionMode: "single",
            disabledKeys: [
                "Lvl 2 Item 3"
            ]
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            key: "Lvl 2 Item 1"
        }, "Lvl 2 Item 1"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            key: "Lvl 1 Item 2"
        }, "Lvl 2 Item 2"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.SubmenuTrigger), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            key: "Lvl 2 Item 3"
        }, "Lvl 2 Item 3"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Menu), {
            onSelectionChange: (0, _addonActions.action)("onSelectionChange lvl 3 menu"),
            selectionMode: "multiple"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            key: "Lvl 3 Item 1"
        }, "Lvl 3 Item 1"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            key: "Lvl 3 Item 2"
        }, "Lvl 3 Item 2"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            key: "Lvl 3 Item 3"
        }, "Lvl 3 Item 3"))))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            key: "Lvl 1 Item 3"
        }, "Lvl 1 Item 3"))),
    name: "disabled submenu trigger",
    parameters: {
        description: {
            data: "Lvl 2 submenu trigger is disabled"
        }
    }
};
const NoKeysProvided = {
    render: (args)=>(0, _menuTriggerStories.render)(/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Menu), {
            onAction: (0, _addonActions.action)("lvl 1 menu onAction"),
            ...args
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), null, "Lvl 1 Item 1"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.SubmenuTrigger), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), null, "Lvl 1 Item 2"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Menu), {
            onAction: (0, _addonActions.action)("lvl 2 menu onAction"),
            ...args.submenu1Props
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), null, "Lvl 2 Item 1"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), null, "Lvl 2 Item 2"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.SubmenuTrigger), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), null, "Lvl 2 Item 3"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Menu), {
            onAction: (0, _addonActions.action)("lvl 3 menu onAction"),
            ...args.submenu2Props
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), null, "Lvl 3 Item 1"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), null, "Lvl 3 Item 2"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), null, "Lvl 3 Item 3"))))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), null, "Lvl 1 Item 3")), args.menuTriggerProps),
    name: "no keys provided",
    parameters: {
        description: {
            data: "No keys are provided so they should be autogenerated. It should allow for duplicated menu item keys across each submenu level, reflected in onAction"
        }
    }
};
const ConditionalSubmenu = {
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(ConditionalSubmenuExample, args),
    name: "conditional submenu"
};
function ConditionalSubmenuExample(props) {
    let [disabled, setDisabled] = (0, _reactDefault.default).useState(false);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSpectrum.ToggleButton), {
        isSelected: disabled,
        onChange: setDisabled
    }, "Toggle item 2 unavailable"), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        style: {
            display: "flex",
            width: "auto",
            margin: "250px 0"
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.MenuTrigger), {
        onOpenChange: (0, _addonActions.action)("onOpenChange"),
        ...props
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), null, "Menu Button"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Menu), {
        onAction: (0, _addonActions.action)("onAction")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
        key: "Lvl 1 Item 1"
    }, "Lvl 1 Item 1"), disabled ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ContextualHelpTrigger), {
        isUnavailable: true
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
        key: "Lvl 1 Item 2"
    }, "Lvl 1 Item 2"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _dialog.Dialog), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Heading), null, "SubmenuTrigger disabled"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Content), null, "You don't have permissions for this submenu"))) : /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.SubmenuTrigger), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
        key: "Lvl 1 Item 2"
    }, "Lvl 1 Item 2"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Menu), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
        key: "Lvl 2 Item 1"
    }, "Lvl 2 Item 1"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
        key: "Lvl 2 Item 2"
    }, "Lvl 2 Item 2"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
        key: "Lvl 2 Item 3"
    }, "Lvl 2 Item 3"))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
        key: "Lvl 1 Item 3"
    }, "Lvl 1 Item 3")))));
}
const UnavailableWithSubmenu = {
    render: (args)=>(0, _menuTriggerStories.render)(/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Menu), {
            onAction: (0, _addonActions.action)("lvl 1 menu onAction"),
            ...args
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            key: "Lvl 1 Item 1"
        }, "Lvl 1 Item 1"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.SubmenuTrigger), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            key: "Lvl 1 Item 2"
        }, "Lvl 1 Item 2"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Menu), {
            onAction: (0, _addonActions.action)("lvl 2.2 menu onAction"),
            ...args.submenu1Props
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ContextualHelpTrigger), {
            isUnavailable: true
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            key: "Lvl 2 Item 1"
        }, "Lvl 2.2 Item 1"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _dialog.Dialog), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Heading), null, "another one"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Content), null, "try hovering on other items"))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            key: "Lvl 2 Item 2"
        }, "Lvl 2.2 Item 2"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.SubmenuTrigger), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            key: "Lvl 2 Item 3"
        }, "Lvl 2.2 Item 3"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Menu), {
            onAction: (0, _addonActions.action)("lvl 3 menu onAction"),
            ...args.submenu2Props
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            key: "Lvl 3 Item 1"
        }, "Lvl 3 Item 1"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            key: "Lvl 3 Item 2"
        }, "Lvl 3 Item 2"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            key: "Lvl 3 Item 3"
        }, "Lvl 3 Item 3"))))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ContextualHelpTrigger), {
            isUnavailable: true
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            key: "Lvl 1 Item 3"
        }, "Lvl 1 Item 3"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _dialog.Dialog), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Heading), null, "hello"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Content), null, "Is it me you're looking for?"))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.SubmenuTrigger), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            key: "Lvl 1 Item 4"
        }, "Lvl 1 Item 4"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Menu), {
            onAction: (0, _addonActions.action)("lvl 2.4 menu onAction"),
            ...args.submenu1Props
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            key: "Lvl 2.4 Item 1"
        }, "Lvl 2.4 Item 1"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            key: "Lvl 2.4 Item 2"
        }, "Lvl 2.4 Item 2"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            key: "Lvl 2.4 Item 3"
        }, "Lvl 2.4 Item 3"))))),
    name: "with unavailable menu item"
};
const TabBehaviorStory = {
    render: ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement("input", {
            "data-testid": "inputleft"
        }), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
            style: {
                display: "flex",
                width: "auto",
                margin: "250px 0"
            }
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.MenuTrigger), {
            onOpenChange: (0, _addonActions.action)("onOpenChange")
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), null, "Menu Button"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Menu), {
            items: dynamicSubmenu,
            onAction: (0, _addonActions.action)("onAction")
        }, (item)=>dynamicRenderFunc(item)))), /*#__PURE__*/ (0, _reactDefault.default).createElement("input", {
            "data-testid": "inputright"
        })),
    name: "tab behavior",
    parameters: {
        description: {
            data: "Test tabbing and shift tabbing from within a submenu"
        }
    }
};

},{"@storybook/addon-actions":"coXbW","@react-spectrum/button":"jZWyP","@spectrum-icons/workflow/AlignCenter":"2Chkz","@spectrum-icons/workflow/AlignLeft":"65eDL","@spectrum-icons/workflow/AlignRight":"3qK4F","@spectrum-icons/workflow/AnnotatePen":"goKf4","@react-spectrum/view":"dnRjt","../":"8myJq","./MenuTrigger.stories":"iKKSY","@react-spectrum/dialog":"3G0HV","@react-spectrum/text":"etCGI","react":"9yzVZ","@spectrum-icons/workflow/TextIndentIncrease":"es0zc","@spectrum-icons/workflow/TextItalic":"dV69R","@adobe/react-spectrum":"cwANo","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"goKf4":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("69f7ab19b5eaa09d");
exports.__esModule = true;
exports.default = AnnotatePen;
var _AnnotatePen = require("f0063f9738553849");
var _icon = require("3218ec149059aadc");
var _react = _interopRequireDefault(require("1733b58d7540d439"));
function AnnotatePen(props) {
    return /*#__PURE__*/ _react.default.createElement(_icon.Icon, props, /*#__PURE__*/ _react.default.createElement(_AnnotatePen.A4uAnnotatePen, null));
}

},{"69f7ab19b5eaa09d":"iHubQ","f0063f9738553849":"dUqMQ","3218ec149059aadc":"k7wem","1733b58d7540d439":"9yzVZ"}],"dUqMQ":[function(require,module,exports) {
/**
* @adobe/react-spectrum-workflow (c) by Adobe
* 
* @adobe/react-spectrum-workflow is licensed under a
* Creative Commons Attribution-NoDerivatives 4.0 International License.
* 
* You should have received a copy of the license along with this
* work. If not, see <http://creativecommons.org/licenses/by-nd/4.0/>.
**/ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.A4uAnnotatePen = A4uAnnotatePen;
var _react = _interopRequireDefault(require("27655b323d3e798e"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function A4uAnnotatePen(_ref) {
    var props = _extends({}, _ref);
    return /*#__PURE__*/ _react["default"].createElement("svg", _extends({
        viewBox: "0 0 36 36"
    }, props, props), /*#__PURE__*/ _react["default"].createElement("path", {
        fillRule: "evenodd",
        d: "M28.023,4.36A.967.967,0,0,0,27.98,3a.963.963,0,0,0-1.362-.044A1.561,1.561,0,0,0,26.5,3.1l-.011-.014-8.74,8.736.012.016a.721.721,0,0,0-.145.119.993.993,0,1,0,1.524,1.258l.013.013,8.739-8.737-.015-.014A.813.813,0,0,0,28.023,4.36Z"
    }), /*#__PURE__*/ _react["default"].createElement("path", {
        fillRule: "evenodd",
        d: "M29.8,5.883c-.72.721-9.537,9.645-9.588,9.7a2.214,2.214,0,0,1-2.362.029l-.767-.725L6.286,25.474a1.5,1.5,0,0,0-.327.48L4.088,32.36a.375.375,0,0,0,.5.491L11.016,30.9a1.5,1.5,0,0,0,.46-.313L33.06,9.079Z"
    }), /*#__PURE__*/ _react["default"].createElement("path", {
        fillRule: "evenodd",
        d: "M30.814,4.172,33.92,7.128A2.78,2.78,0,0,0,33.113,3.9a3.3,3.3,0,0,0-3.22-1.06c-.179.064.065.3.138.375S30.766,4.076,30.814,4.172Z"
    }), /*#__PURE__*/ _react["default"].createElement("path", {
        fillRule: "evenodd",
        d: "M3.723,27.486c-3.053-9.059.3-16.932,8.726-21.509,1.269-.69.268-2.706-1.01-2.012C2.19,8.992-1.077,17.405,2.286,27.5,3.723,31.814,3.723,27.486,3.723,27.486Z"
    }));
}

},{"27655b323d3e798e":"9yzVZ"}],"es0zc":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("a4045f6b6aae4c77");
exports.__esModule = true;
exports.default = TextIndentIncrease;
var _TextIndentIncrease = require("5b7257c6c0dc1cd4");
var _icon = require("a06c3de613e69f89");
var _react = _interopRequireDefault(require("e0bf9a1cc28d1741"));
function TextIndentIncrease(props) {
    return /*#__PURE__*/ _react.default.createElement(_icon.Icon, props, /*#__PURE__*/ _react.default.createElement(_TextIndentIncrease.A4uTextIndentIncrease, null));
}

},{"a4045f6b6aae4c77":"iHubQ","5b7257c6c0dc1cd4":"6bcBv","a06c3de613e69f89":"k7wem","e0bf9a1cc28d1741":"9yzVZ"}],"6bcBv":[function(require,module,exports) {
/**
* @adobe/react-spectrum-workflow (c) by Adobe
* 
* @adobe/react-spectrum-workflow is licensed under a
* Creative Commons Attribution-NoDerivatives 4.0 International License.
* 
* You should have received a copy of the license along with this
* work. If not, see <http://creativecommons.org/licenses/by-nd/4.0/>.
**/ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.A4uTextIndentIncrease = A4uTextIndentIncrease;
var _react = _interopRequireDefault(require("b236bacd49d6bc0"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function A4uTextIndentIncrease(_ref) {
    var props = _extends({}, _ref);
    return /*#__PURE__*/ _react["default"].createElement("svg", _extends({
        viewBox: "0 0 36 36"
    }, props, props), /*#__PURE__*/ _react["default"].createElement("rect", {
        fillRule: "evenodd",
        height: "4",
        rx: "1",
        ry: "1",
        width: "24",
        x: "8",
        y: "28"
    }), /*#__PURE__*/ _react["default"].createElement("rect", {
        fillRule: "evenodd",
        height: "4",
        rx: "1",
        ry: "1",
        width: "12",
        x: "20",
        y: "20"
    }), /*#__PURE__*/ _react["default"].createElement("rect", {
        fillRule: "evenodd",
        height: "4",
        rx: "1",
        ry: "1",
        width: "12",
        x: "20",
        y: "12"
    }), /*#__PURE__*/ _react["default"].createElement("rect", {
        fillRule: "evenodd",
        height: "4",
        rx: "1",
        ry: "1",
        width: "24",
        x: "8",
        y: "4"
    }), /*#__PURE__*/ _react["default"].createElement("path", {
        fillRule: "evenodd",
        d: "M8,14V10.672a.5.5,0,0,1,.866-.341L16,18,8.866,25.669A.5.5,0,0,1,8,25.328V22H1a1,1,0,0,1-1-1V15a1,1,0,0,1,1-1Z"
    }));
}

},{"b236bacd49d6bc0":"9yzVZ"}],"dV69R":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("134da7a3474fcc44");
exports.__esModule = true;
exports.default = TextItalic;
var _TextItalic = require("147d27c97e77033e");
var _icon = require("e7a98153043475e1");
var _react = _interopRequireDefault(require("397d50d50f1d62de"));
function TextItalic(props) {
    return /*#__PURE__*/ _react.default.createElement(_icon.Icon, props, /*#__PURE__*/ _react.default.createElement(_TextItalic.A4uTextItalic, null));
}

},{"134da7a3474fcc44":"iHubQ","147d27c97e77033e":"hUv0d","e7a98153043475e1":"k7wem","397d50d50f1d62de":"9yzVZ"}],"hUv0d":[function(require,module,exports) {
/**
* @adobe/react-spectrum-workflow (c) by Adobe
* 
* @adobe/react-spectrum-workflow is licensed under a
* Creative Commons Attribution-NoDerivatives 4.0 International License.
* 
* You should have received a copy of the license along with this
* work. If not, see <http://creativecommons.org/licenses/by-nd/4.0/>.
**/ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.A4uTextItalic = A4uTextItalic;
var _react = _interopRequireDefault(require("63a5f12fb963d036"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function A4uTextItalic(_ref) {
    var props = _extends({}, _ref);
    return /*#__PURE__*/ _react["default"].createElement("svg", _extends({
        viewBox: "0 0 36 36"
    }, props, props), /*#__PURE__*/ _react["default"].createElement("path", {
        fillRule: "evenodd",
        d: "M7.919,4A1.561,1.561,0,0,0,6.568,5L4.459,11a.685.685,0,0,0,.649,1h2a1.557,1.557,0,0,0,1.351-1L9.514,8h8L10.486,28h-3a1.557,1.557,0,0,0-1.351,1l-.7,2a.685.685,0,0,0,.649,1h10a1.557,1.557,0,0,0,1.351-1l.7-2a.684.684,0,0,0-.649-1h-3L21.514,8h8l-1.055,3a.685.685,0,0,0,.649,1h2a1.557,1.557,0,0,0,1.351-1l2.109-6a.686.686,0,0,0-.649-1Z"
    }));
}

},{"63a5f12fb963d036":"9yzVZ"}],"eQU5F":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Default", ()=>Default);
parcelHelpers.export(exports, "ValueLabel1Of4", ()=>ValueLabel1Of4);
parcelHelpers.export(exports, "UsingNumberFormatOptionsWithCurrencyStyle", ()=>UsingNumberFormatOptionsWithCurrencyStyle);
parcelHelpers.export(exports, "NoVisibleLabel", ()=>NoVisibleLabel);
parcelHelpers.export(exports, "ParentWidth100", ()=>ParentWidth100);
parcelHelpers.export(exports, "ParentWidth100Px", ()=>ParentWidth100Px);
parcelHelpers.export(exports, "Width300Px", ()=>Width300Px);
parcelHelpers.export(exports, "Width30Px", ()=>Width30Px);
parcelHelpers.export(exports, "UsingRawValuesForMinValueMaxValueAndValue", ()=>UsingRawValuesForMinValueMaxValueAndValue);
parcelHelpers.export(exports, "UsingRawValuesWithNumberFormatter", ()=>UsingRawValuesWithNumberFormatter);
var _ = require("../");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const formatOptions = {
    style: "currency",
    currency: "JPY"
};
exports.default = {
    title: "Meter",
    component: (0, _.Meter),
    args: {
        variant: "positive"
    },
    argTypes: {
        value: {
            control: {
                type: "range",
                min: 0,
                max: 100
            }
        },
        variant: {
            control: {
                type: "radio",
                options: [
                    "positive",
                    "warning",
                    "critical"
                ]
            }
        },
        size: {
            control: {
                type: "radio",
                options: [
                    "S",
                    "L"
                ]
            }
        },
        showValueLabel: {
            control: "boolean"
        },
        labelPosition: {
            control: "radio",
            options: [
                "top",
                "side"
            ]
        }
    }
};
const Default = {
    args: {
        label: "Meter",
        value: 50
    },
    name: "value: 50",
    parameters: {
        a11y: {
            config: {
                // Erroring attributes work for meter and/or progressbar, but combined role confuses aXe
                rules: [
                    {
                        id: "aria-allowed-attr",
                        selector: '*:not([role="meter progressbar"])'
                    }
                ]
            }
        }
    }
};
const ValueLabel1Of4 = {
    ...Default,
    args: {
        ...Default.args,
        value: 25,
        valueLabel: "1 of 4"
    },
    name: "valueLabel: 1 of 4"
};
const UsingNumberFormatOptionsWithCurrencyStyle = {
    ...Default,
    args: {
        ...Default.args,
        showValueLabel: true,
        formatOptions
    },
    name: "Using number formatOptions with currency style"
};
const NoVisibleLabel = {
    ...Default,
    args: {
        ...Default.args,
        label: null,
        "aria-label": "Meter"
    },
    name: "no visible label"
};
const ParentWidth100 = {
    ...Default,
    args: {
        ...Default.args,
        value: 32
    },
    decorators: [
        (Story)=>/*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
                style: {
                    width: "100%"
                }
            }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Story, null))
    ],
    name: "parent width 100%"
};
const ParentWidth100Px = {
    ...Default,
    args: {
        ...Default.args,
        value: 32
    },
    decorators: [
        (Story)=>/*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
                style: {
                    width: "100px"
                }
            }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Story, null))
    ],
    name: "parent width 100px"
};
const Width300Px = {
    ...Default,
    args: {
        ...Default.args,
        value: 32,
        width: "300px"
    },
    name: "width: 300px"
};
const Width30Px = {
    ...Default,
    args: {
        ...Default.args,
        value: 32,
        width: "30px"
    },
    name: "width: 30px"
};
const UsingRawValuesForMinValueMaxValueAndValue = {
    ...Default,
    args: {
        ...Default.args,
        showValueLabel: true,
        labelPosition: "top",
        maxValue: 2147483648,
        value: 715827883
    },
    name: "Using raw values for minValue, maxValue, and value"
};
const UsingRawValuesWithNumberFormatter = {
    ...Default,
    args: {
        ...Default.args,
        showValueLabel: true,
        labelPosition: "top",
        maxValue: 2147483648,
        value: 715827883,
        formatOptions
    },
    name: "Using raw values with number formatter"
};

},{"../":"6xade","react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"6xade":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _src = require("./src");
parcelHelpers.exportAll(_src, exports);

},{"./src":"dDZDm","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"czANX":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Default", ()=>Default);
parcelHelpers.export(exports, "DefaultValue10", ()=>DefaultValue10);
parcelHelpers.export(exports, "Value10", ()=>Value10);
parcelHelpers.export(exports, "MaximumFractionDigits0", ()=>MaximumFractionDigits0);
parcelHelpers.export(exports, "Currency", ()=>Currency);
parcelHelpers.export(exports, "Percent", ()=>Percent);
parcelHelpers.export(exports, "PercentMaxFractionDigits2NoMinFractionDigits", ()=>PercentMaxFractionDigits2NoMinFractionDigits);
parcelHelpers.export(exports, "PercentMin2Max2FractionDigits", ()=>PercentMin2Max2FractionDigits);
parcelHelpers.export(exports, "PercentMin2Max3FractionDigits", ()=>PercentMin2Max3FractionDigits);
parcelHelpers.export(exports, "MinValue00FractionDigits", ()=>MinValue00FractionDigits);
parcelHelpers.export(exports, "PercentUsingSign", ()=>PercentUsingSign);
parcelHelpers.export(exports, "Disabled", ()=>Disabled);
parcelHelpers.export(exports, "Readonly", ()=>Readonly);
parcelHelpers.export(exports, "IsQuiet", ()=>IsQuiet);
parcelHelpers.export(exports, "QuietDisabled", ()=>QuietDisabled);
parcelHelpers.export(exports, "QuietReadonly", ()=>QuietReadonly);
parcelHelpers.export(exports, "ValidationStateInvalid", ()=>ValidationStateInvalid);
parcelHelpers.export(exports, "ValidationStateValid", ()=>ValidationStateValid);
parcelHelpers.export(exports, "ValidationStateInvalidIsQuiet", ()=>ValidationStateInvalidIsQuiet);
parcelHelpers.export(exports, "ValidationStateValidIsQuiet", ()=>ValidationStateValidIsQuiet);
parcelHelpers.export(exports, "MinValue0MaxValue20", ()=>MinValue0MaxValue20);
parcelHelpers.export(exports, "MinValue0MaxValue20Quiet", ()=>MinValue0MaxValue20Quiet);
parcelHelpers.export(exports, "MinValue50MaxValue20", ()=>MinValue50MaxValue20);
parcelHelpers.export(exports, "MinValue20MaxValue50", ()=>MinValue20MaxValue50);
parcelHelpers.export(exports, "MinValue0DefaultValue0", ()=>MinValue0DefaultValue0);
parcelHelpers.export(exports, "Step5", ()=>Step5);
parcelHelpers.export(exports, "Step3WithMin2Max21", ()=>Step3WithMin2Max21);
parcelHelpers.export(exports, "AutoFocus", ()=>AutoFocus);
parcelHelpers.export(exports, "HideStepper", ()=>HideStepper);
parcelHelpers.export(exports, "IsQuietHideStepper", ()=>IsQuietHideStepper);
parcelHelpers.export(exports, "Required", ()=>Required);
parcelHelpers.export(exports, "Optional", ()=>Optional);
parcelHelpers.export(exports, "RequiredWithLabel", ()=>RequiredWithLabel);
parcelHelpers.export(exports, "LabelTopEnd", ()=>LabelTopEnd);
parcelHelpers.export(exports, "LabelSide", ()=>LabelSide);
parcelHelpers.export(exports, "NoVisibleLabel", ()=>NoVisibleLabel);
parcelHelpers.export(exports, "QuietNoVisibleLabel", ()=>QuietNoVisibleLabel);
parcelHelpers.export(exports, "QuietNoVisibleLabelHidestepper", ()=>QuietNoVisibleLabelHidestepper);
parcelHelpers.export(exports, "AriaLabelledby", ()=>AriaLabelledby);
parcelHelpers.export(exports, "WithDescriptionNoVisibleLabel", ()=>WithDescriptionNoVisibleLabel);
parcelHelpers.export(exports, "WithErrorMessageLabelPositionSide", ()=>WithErrorMessageLabelPositionSide);
parcelHelpers.export(exports, "_ContextualHelp", ()=>_ContextualHelp);
parcelHelpers.export(exports, "CustomWidth", ()=>CustomWidth);
parcelHelpers.export(exports, "QuietCustomWidth", ()=>QuietCustomWidth);
parcelHelpers.export(exports, "CustomWidthNoVisibleLabel", ()=>CustomWidthNoVisibleLabel);
parcelHelpers.export(exports, "CustomWidthLabelPositionSide", ()=>CustomWidthLabelPositionSide);
parcelHelpers.export(exports, "Controlled", ()=>Controlled);
parcelHelpers.export(exports, "CurrencySwitcher", ()=>CurrencySwitcher);
parcelHelpers.export(exports, "Flexed", ()=>Flexed);
parcelHelpers.export(exports, "MinWidth", ()=>MinWidth);
parcelHelpers.export(exports, "FocusEvents", ()=>FocusEvents);
parcelHelpers.export(exports, "InputDomEvents", ()=>InputDomEvents);
parcelHelpers.export(exports, "ResetControlledStateToBlankWithNull", ()=>ResetControlledStateToBlankWithNull);
var _addonActions = require("@storybook/addon-actions");
var _button = require("@react-spectrum/button");
var _utils = require("@react-aria/utils");
var _view = require("@react-spectrum/view");
var _contextualhelp = require("@react-spectrum/contextualhelp");
var _layout = require("@react-spectrum/layout");
var _form = require("@react-spectrum/form");
var _text = require("@react-spectrum/text");
var _picker = require("@react-spectrum/picker");
var _src = require("../src");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
exports.default = {
    title: "NumberField",
    decorators: [
        (story)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(ErrorBoundary, null, story())
    ],
    providerSwitcher: {
        status: "notice"
    }
};
const Default = ()=>render({});
Default.story = {
    name: "default"
};
const DefaultValue10 = ()=>render({
        defaultValue: 10
    });
DefaultValue10.story = {
    name: "defaultValue: 10"
};
const Value10 = ()=>render({
        value: 10
    });
Value10.story = {
    name: "value: 10"
};
const MaximumFractionDigits0 = ()=>render({
        formatOptions: {
            maximumFractionDigits: 0
        }
    });
MaximumFractionDigits0.story = {
    name: "maximumFractionDigits = 0"
};
const Currency = ()=>render({
        formatOptions: {
            style: "currency",
            currency: "EUR"
        },
        label: "Price"
    });
Currency.story = {
    name: "currency"
};
const Percent = ()=>render({
        formatOptions: {
            style: "percent"
        },
        label: "Tax"
    });
Percent.story = {
    name: "percent"
};
const PercentMaxFractionDigits2NoMinFractionDigits = ()=>render({
        formatOptions: {
            style: "percent",
            maximumFractionDigits: 2
        },
        label: "Tax"
    });
PercentMaxFractionDigits2NoMinFractionDigits.story = {
    name: "percent, max fraction digits: 2, no min fraction digits"
};
const PercentMin2Max2FractionDigits = ()=>render({
        formatOptions: {
            style: "percent",
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        },
        label: "Tax"
    });
PercentMin2Max2FractionDigits.story = {
    name: "percent min = 2 max = 2 fraction digits"
};
const PercentMin2Max3FractionDigits = ()=>render({
        formatOptions: {
            style: "percent",
            minimumFractionDigits: 2,
            maximumFractionDigits: 3
        },
        label: "Tax"
    });
PercentMin2Max3FractionDigits.story = {
    name: "percent min = 2 max = 3 fraction digits"
};
const MinValue00FractionDigits = ()=>render({
        minValue: 0,
        formatOptions: {
            maximumFractionDigits: 0
        }
    });
MinValue00FractionDigits.story = {
    name: "minValue = 0, 0 fraction digits"
};
const PercentUsingSign = ()=>render({
        formatOptions: {
            style: "percent",
            signDisplay: "always"
        },
        label: "Tax"
    });
PercentUsingSign.story = {
    name: "percent using sign"
};
const Disabled = ()=>render({
        isDisabled: true
    });
Disabled.story = {
    name: "disabled"
};
const Readonly = ()=>render({
        defaultValue: 10,
        isReadOnly: true
    });
Readonly.story = {
    name: "readonly"
};
const IsQuiet = ()=>render({
        isQuiet: true
    });
IsQuiet.story = {
    name: "isQuiet"
};
const QuietDisabled = ()=>render({
        isQuiet: true,
        isDisabled: true,
        defaultValue: 10
    });
QuietDisabled.story = {
    name: "quiet disabled"
};
const QuietReadonly = ()=>render({
        isQuiet: true,
        isReadOnly: true,
        defaultValue: 10
    });
QuietReadonly.story = {
    name: "quiet readonly"
};
const ValidationStateInvalid = ()=>render({
        validationState: "invalid"
    });
ValidationStateInvalid.story = {
    name: "validationState: invalid"
};
const ValidationStateValid = ()=>render({
        validationState: "valid"
    });
ValidationStateValid.story = {
    name: "validationState: valid"
};
const ValidationStateInvalidIsQuiet = ()=>render({
        validationState: "invalid",
        isQuiet: true
    });
ValidationStateInvalidIsQuiet.story = {
    name: "validationState: invalid, isQuiet"
};
const ValidationStateValidIsQuiet = ()=>render({
        validationState: "valid",
        isQuiet: true
    });
ValidationStateValidIsQuiet.story = {
    name: "validationState: valid, isQuiet"
};
const MinValue0MaxValue20 = ()=>render({
        minValue: 0,
        maxValue: 20
    });
MinValue0MaxValue20.story = {
    name: "minValue = 0, maxValue = 20"
};
const MinValue0MaxValue20Quiet = ()=>render({
        isQuiet: true,
        minValue: 0,
        maxValue: 20
    });
MinValue0MaxValue20Quiet.story = {
    name: "minValue = 0, maxValue = 20, quiet"
};
const MinValue50MaxValue20 = ()=>render({
        minValue: -50,
        maxValue: -20
    });
MinValue50MaxValue20.story = {
    name: "minValue = -50, maxValue = -20"
};
const MinValue20MaxValue50 = ()=>render({
        minValue: 20,
        maxValue: 50
    });
MinValue20MaxValue50.story = {
    name: "minValue = 20, maxValue = 50"
};
const MinValue0DefaultValue0 = ()=>render({
        minValue: 0,
        defaultValue: 0
    });
MinValue0DefaultValue0.story = {
    name: "minValue = 0, defaultValue = 0"
};
const Step5 = ()=>render({
        step: 5
    });
Step5.story = {
    name: "step = 5"
};
const Step3WithMin2Max21 = ()=>render({
        step: 3,
        minValue: 2,
        maxValue: 21
    });
Step3WithMin2Max21.story = {
    name: "step = 3 with min = 2, max = 21"
};
const AutoFocus = ()=>render({
        autoFocus: true
    });
AutoFocus.story = {
    name: "autoFocus"
};
const HideStepper = ()=>render({
        hideStepper: true
    });
HideStepper.story = {
    name: "hideStepper"
};
const IsQuietHideStepper = ()=>render({
        isQuiet: true,
        hideStepper: true
    });
IsQuietHideStepper.story = {
    name: "isQuiet, hideStepper"
};
const Required = ()=>render({
        isRequired: true
    });
Required.story = {
    name: "required"
};
const Optional = ()=>render({
        necessityIndicator: "label"
    });
Optional.story = {
    name: "optional"
};
const RequiredWithLabel = ()=>render({
        isRequired: true,
        necessityIndicator: "label"
    });
RequiredWithLabel.story = {
    name: "required with label"
};
const LabelTopEnd = ()=>render({
        isRequired: true,
        labelPosition: "top",
        labelAlign: "end"
    });
LabelTopEnd.story = {
    name: "label top end"
};
const LabelSide = ()=>render({
        isRequired: true,
        labelPosition: "side"
    });
LabelSide.story = {
    name: "label side"
};
const NoVisibleLabel = ()=>renderNoLabel({
        isRequired: true,
        "aria-label": "Width"
    });
NoVisibleLabel.story = {
    name: "no visible label"
};
const QuietNoVisibleLabel = ()=>renderNoLabel({
        isQuiet: true,
        isRequired: true,
        "aria-label": "Width"
    });
QuietNoVisibleLabel.story = {
    name: "quiet no visible label"
};
const QuietNoVisibleLabelHidestepper = ()=>renderNoLabel({
        hideStepper: true,
        isQuiet: true,
        isRequired: true,
        "aria-label": "Width"
    });
QuietNoVisibleLabelHidestepper.story = {
    name: "quiet no visible label hidestepper"
};
const AriaLabelledby = ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement("label", {
        htmlFor: "numberfield",
        id: "label"
    }, "Width"), renderNoLabel({
        isRequired: true,
        id: "numberfield",
        "aria-labelledby": "label"
    }));
AriaLabelledby.story = {
    name: "aria-labelledby"
};
const WithDescriptionNoVisibleLabel = ()=>renderNoLabel({
        "aria-label": "Age",
        description: "Please select your age."
    });
WithDescriptionNoVisibleLabel.story = {
    name: "with description, no visible label"
};
const WithErrorMessageLabelPositionSide = ()=>render({
        labelPosition: "side",
        errorMessage: "Please enter a positive number.",
        validationState: "invalid"
    });
WithErrorMessageLabelPositionSide.story = {
    name: "with error message, labelPosition: side"
};
const _ContextualHelp = ()=>render({
        contextualHelp: /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _contextualhelp.ContextualHelp), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Heading), null, "What is a segment?"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Content), null, "Segments identify who your visitors are, what devices and services they use, where they navigated from, and much more."))
    });
_ContextualHelp.story = {
    name: "contextual help"
};
const CustomWidth = ()=>render({
        width: "size-3000"
    });
CustomWidth.story = {
    name: "custom width"
};
const QuietCustomWidth = ()=>render({
        isQuiet: true,
        width: "size-3000"
    });
QuietCustomWidth.story = {
    name: "quiet custom width"
};
const CustomWidthNoVisibleLabel = ()=>renderNoLabel({
        width: "size-3000",
        isRequired: true,
        "aria-label": "Width"
    });
CustomWidthNoVisibleLabel.story = {
    name: "custom width no visible label"
};
const CustomWidthLabelPositionSide = ()=>render({
        width: "size-3000",
        labelPosition: "side"
    });
CustomWidthLabelPositionSide.story = {
    name: "custom width, labelPosition=side"
};
const Controlled = ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement(NumberFieldControlled, null);
Controlled.story = {
    name: "controlled"
};
const CurrencySwitcher = ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement(NumberFieldWithCurrencySelect, null);
CurrencySwitcher.story = {
    name: "currency switcher"
};
const Flexed = ()=>renderSet();
Flexed.story = {
    name: "flexed"
};
const MinWidth = ()=>render({
        width: 0
    });
MinWidth.story = {
    name: "min width"
};
const FocusEvents = ()=>render({
        onBlur: (0, _addonActions.action)("onBlur"),
        onFocus: (0, _addonActions.action)("onFocus"),
        onFocusChange: (0, _addonActions.action)("onFocusChange"),
        onKeyDown: (0, _addonActions.action)("onKeyDown"),
        onKeyUp: (0, _addonActions.action)("onKeyUp")
    });
FocusEvents.story = {
    name: "focus events"
};
const InputDomEvents = ()=>render({
        onCopy: (0, _addonActions.action)("onCopy"),
        onCut: (0, _addonActions.action)("onCut"),
        onPaste: (0, _addonActions.action)("onPaste"),
        onCompositionStart: (0, _addonActions.action)("onCompositionStart"),
        onCompositionEnd: (0, _addonActions.action)("onCompositionEnd"),
        onCompositionUpdate: (0, _addonActions.action)("onCompositionUpdate"),
        onSelect: (0, _addonActions.action)("onSelect"),
        onBeforeInput: (0, _addonActions.action)("onBeforeInput"),
        onInput: (0, _addonActions.action)("onInput")
    });
InputDomEvents.story = {
    name: "input dom events"
};
const ResetControlledStateToBlankWithNull = ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement(NumberFieldControlledStateReset, null);
ResetControlledStateToBlankWithNull.story = {
    name: "reset controlled state to blank with null"
};
function render(props = {}) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _src.NumberField), {
        onChange: (0, _addonActions.action)("onChange"),
        UNSAFE_className: "custom_classname",
        label: "Width",
        ...props
    });
}
function renderNoLabel(props = {}) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _src.NumberField), {
        ...props,
        onChange: (0, _addonActions.action)("onChange"),
        UNSAFE_className: "custom_classname"
    });
}
function renderSet() {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
        width: "100%",
        gap: "size-200",
        alignItems: "end"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _src.NumberField), {
        label: "Grows",
        flexGrow: 1
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _src.NumberField), {
        label: "Static"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _src.NumberField), {
        "aria-label": "Grows",
        flexGrow: 1
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _src.NumberField), {
        "aria-label": "Static"
    }));
}
function NumberFieldControlled(props) {
    let [value, setValue] = (0, _react.useState)(10);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _src.NumberField), {
        ...props,
        formatOptions: {
            style: "currency",
            currency: "EUR"
        },
        value: value,
        onChange: (0, _utils.chain)(setValue, (0, _addonActions.action)("onChange")),
        label: "Price"
    });
}
function NumberFieldWithCurrencySelect(props) {
    let [value, setValue] = (0, _react.useState)(10);
    let [currency, setCurrency] = (0, _react.useState)("EUR");
    let [currencySign, setCurrencySign] = (0, _react.useState)("standard");
    let [currencyDisplay, setCurrencyDisplay] = (0, _react.useState)("symbol");
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _form.Form), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _src.NumberField), {
        label: "Price",
        ...props,
        formatOptions: {
            style: "currency",
            currency,
            currencySign,
            currencyDisplay
        },
        value: value,
        onChange: (0, _utils.chain)(setValue, (0, _addonActions.action)("onChange"))
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _picker.Picker), {
        onSelectionChange: (item)=>setCurrency(String(item)),
        label: "Choose Currency",
        selectedKey: currency,
        items: [
            {
                label: "Euro",
                value: "EUR"
            },
            {
                label: "US Dollar",
                value: "USD"
            },
            {
                label: "Japanese Yen",
                value: "JPY"
            },
            {
                label: "Saudi Riyal",
                value: "SAR"
            }
        ]
    }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _picker.Item), {
            key: item.value
        }, item.label)), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _picker.Picker), {
        onSelectionChange: (item)=>setCurrencySign(String(item)),
        label: "Currency Sign",
        selectedKey: currencySign,
        items: [
            {
                label: "Standard",
                value: "standard"
            },
            {
                label: "Accounting",
                value: "accounting"
            }
        ]
    }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _picker.Item), {
            key: item.value
        }, item.label)), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _picker.Picker), {
        onSelectionChange: (item)=>setCurrencyDisplay(String(item)),
        label: "Currency Display",
        selectedKey: currencyDisplay,
        items: [
            {
                label: "Symbol",
                value: "symbol"
            },
            {
                label: "Narrow Symbol",
                value: "narrowSymbol"
            },
            {
                label: "Code",
                value: "code"
            },
            {
                label: "Name",
                value: "name"
            }
        ]
    }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _picker.Item), {
            key: item.value
        }, item.label)));
}
function NumberFieldControlledStateReset() {
    const [controlledValue, setControlledValue] = (0, _react.useState)(12);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _src.NumberField), {
        "aria-label": "numberfield to reset",
        value: controlledValue,
        onChange: (value)=>setControlledValue(value)
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.Button), {
        variant: "primary",
        onPress: ()=>setControlledValue(NaN)
    }, "Reset"));
}
class ErrorBoundary extends (0, _reactDefault.default).Component {
    static getDerivedStateFromError() {
        // Update state so the next render will show the fallback UI.
        return {
            hasError: true
        };
    }
    render() {
        if (this.state.hasError) // You can render any custom fallback UI
        return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", null, "Your browser may not support this set of Intl.Format options.");
        return this.props.children;
    }
    constructor(props){
        super(props);
        this.state = {
            hasError: false
        };
    }
}

},{"@storybook/addon-actions":"coXbW","@react-spectrum/button":"jZWyP","@react-aria/utils":"9cLk5","@react-spectrum/view":"dnRjt","@react-spectrum/contextualhelp":"jA6za","@react-spectrum/layout":"hzaUY","@react-spectrum/form":"bGDqA","@react-spectrum/text":"etCGI","@react-spectrum/picker":"kL1Uy","../src":"cMsXx","react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"gnIco":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Default", ()=>Default);
parcelHelpers.export(exports, "_UnmountingTrigger", ()=>_UnmountingTrigger);
var _button = require("@react-spectrum/button");
var _buttongroup = require("@react-spectrum/buttongroup");
var _view = require("@react-spectrum/view");
var _dialog = require("@react-spectrum/dialog");
var _divider = require("@react-spectrum/divider");
var _layout = require("@react-spectrum/layout");
var _text = require("@react-spectrum/text");
var _ = require("../");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _overlays = require("@react-stately/overlays");
exports.default = {
    title: "Modal",
    parameters: {
        providerSwitcher: {
            status: "notice"
        }
    }
};
const Default = ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement(ModalExample, null);
Default.story = {
    name: "default"
};
const _UnmountingTrigger = ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement(UnmountingTrigger, null);
_UnmountingTrigger.story = {
    name: "unmounting trigger"
};
function ModalExample() {
    let state = (0, _overlays.useOverlayTriggerState)({});
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _react.Fragment), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), {
        onPress: state.open
    }, "Open modal"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Modal), {
        state: state
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _dialog.Dialog), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Heading), null, "Title"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _divider.Divider), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Content), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, "I am a dialog")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _buttongroup.ButtonGroup), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.Button), {
        variant: "cta",
        onPress: state.close
    }, "Close")))));
}
function UnmountingTrigger() {
    let popoverState = (0, _overlays.useOverlayTriggerState)({});
    let modalState = (0, _overlays.useOverlayTriggerState)({});
    let openModal = ()=>{
        popoverState.close();
        modalState.open();
    };
    // Ideally this would be a menu, but we don't have those implemented yet...
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _react.Fragment), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _dialog.DialogTrigger), {
        type: "popover",
        isOpen: popoverState.isOpen,
        onOpenChange: popoverState.setOpen
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), null, "Open popover"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _dialog.Dialog), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Heading), null, "Title"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _divider.Divider), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Content), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
        direction: "column",
        gap: "size-100"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, "I am a dialog"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), {
        onPress: openModal
    }, "Open modal"))))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Modal), {
        state: modalState
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _dialog.Dialog), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Heading), null, "Title"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _divider.Divider), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Content), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, "I am a dialog")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _buttongroup.ButtonGroup), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.Button), {
        variant: "cta",
        onPress: modalState.close
    }, "Close")))));
}

},{"@react-spectrum/button":"jZWyP","@react-spectrum/buttongroup":"anP11","@react-spectrum/view":"dnRjt","@react-spectrum/dialog":"3G0HV","@react-spectrum/divider":"dxmqN","@react-spectrum/layout":"hzaUY","@react-spectrum/text":"etCGI","../":"jVZQL","react":"9yzVZ","@react-stately/overlays":"5uxM4","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"jVZQL":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _src = require("./src");
parcelHelpers.exportAll(_src, exports);

},{"./src":"3nwGn","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"dD9Be":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Default", ()=>Default);
parcelHelpers.export(exports, "Controlled", ()=>Controlled);
var _addonActions = require("@storybook/addon-actions");
var _ = require("../");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
exports.default = {
    title: "PaginationInput"
};
const Default = ()=>render({
        maxValue: "10",
        onChange: (0, _addonActions.action)("onChange")
    });
const Controlled = ()=>render({
        maxValue: "50",
        value: "2",
        onChange: (0, _addonActions.action)("onChange")
    });
Controlled.story = {
    name: "controlled"
};
function render(props = {}) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.PaginationInput), {
        ...props,
        onPrevious: (0, _addonActions.action)("onPrevious"),
        onNext: (0, _addonActions.action)("onNext")
    });
}

},{"@storybook/addon-actions":"coXbW","../":"axr8W","react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"axr8W":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _src = require("./src");
parcelHelpers.exportAll(_src, exports);

},{"./src":"2GUDS","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"2GUDS":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /// <reference types="css-module-types" />
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PaginationInput", ()=>(0, _pagination.PaginationInput));
var _pagination = require("./Pagination");

},{"./Pagination":"5767L","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"5767L":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PaginationInput", ()=>PaginationInput);
var _button = require("@react-spectrum/button");
var _chevronLeftMedium = require("@spectrum-icons/ui/ChevronLeftMedium");
var _chevronLeftMediumDefault = parcelHelpers.interopDefault(_chevronLeftMedium);
var _chevronRightMedium = require("@spectrum-icons/ui/ChevronRightMedium");
var _chevronRightMediumDefault = parcelHelpers.interopDefault(_chevronRightMedium);
var _utils = require("@react-spectrum/utils");
// @ts-ignore
var _json = require("../intl/*.json");
var _jsonDefault = parcelHelpers.interopDefault(_json);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _varsCss = require("@adobe/spectrum-css-temp/components/pagination/vars.css");
var _varsCssDefault = parcelHelpers.interopDefault(_varsCss);
var _textfield = require("@react-spectrum/textfield");
var _varsCss1 = require("@adobe/spectrum-css-temp/components/typography/vars.css");
var _varsCssDefault1 = parcelHelpers.interopDefault(_varsCss1);
var _i18N = require("@react-aria/i18n");
var _pagination = require("@react-aria/pagination");
var _pagination1 = require("@react-stately/pagination");
var _provider = require("@react-spectrum/provider");
function PaginationInput(props) {
    props = Object.assign({}, {
        defaultValue: 1
    }, props);
    props = (0, _provider.useProviderProps)(props);
    let state = (0, _pagination1.usePaginationState)(props);
    let { prevButtonProps, nextButtonProps, textProps } = (0, _pagination.usePagination)(props, state);
    let stringFormatter = (0, _i18N.useLocalizedStringFormatter)((0, _jsonDefault.default), "@react-spectrum/pagination");
    let { direction } = (0, _i18N.useLocale)();
    const { maxValue } = props;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("nav", {
        className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Pagination", "spectrum-Pagination--explicit")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), {
        ...prevButtonProps,
        isQuiet: true
    }, direction === "rtl" ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _chevronRightMediumDefault.default), null) : /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _chevronLeftMediumDefault.default), null)), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textfield.TextField), {
        ...textProps,
        // This is a filler for now to fix accessibility tests, will revisit when we pick Pagination back up
        "aria-label": "pagination input",
        value: state.value,
        onChange: state.onChange,
        UNSAFE_className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Pagination-input")
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        className: (0, _utils.classNames)((0, _varsCssDefault1.default), "spectrum-Body--secondary", (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Pagination-counter"))
    }, stringFormatter.format("page_count", {
        n: maxValue
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), {
        ...nextButtonProps,
        isQuiet: true
    }, direction === "rtl" ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _chevronLeftMediumDefault.default), null) : /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _chevronRightMediumDefault.default), null)));
}

},{"@react-spectrum/button":"jZWyP","@spectrum-icons/ui/ChevronLeftMedium":"eZUPs","@spectrum-icons/ui/ChevronRightMedium":"6amCu","@react-spectrum/utils":"cMIJ6","../intl/*.json":"aIBc3","react":"9yzVZ","@adobe/spectrum-css-temp/components/pagination/vars.css":"jMVcT","@react-spectrum/textfield":"hOmtq","@adobe/spectrum-css-temp/components/typography/vars.css":"cPEjS","@react-aria/i18n":"411rg","@react-aria/pagination":"1pbNf","@react-stately/pagination":"k5Rh1","@react-spectrum/provider":"5bCdp","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"aIBc3":[function(require,module,exports) {
const _temp0 = require("6c45bb47fb74e645");
const _temp1 = require("112c8706be982c58");
const _temp2 = require("6fdb13c38842ca97");
const _temp3 = require("d9b55069e26d88b7");
const _temp4 = require("e689a7b44c1e439c");
const _temp5 = require("3d3db3a18de688d1");
const _temp6 = require("1c63d6fe5269f87d");
const _temp7 = require("eed51675935ea1b3");
const _temp8 = require("e58b5b53fe6cf451");
const _temp9 = require("2ecf1770cefde1f0");
const _temp10 = require("96182bfcf4bc4cec");
const _temp11 = require("c55c107c7d7e9696");
const _temp12 = require("9235b0493456e8aa");
const _temp13 = require("3074e237afaf3d23");
const _temp14 = require("b5e4c1774f09c344");
const _temp15 = require("168cac5c1cb13c4d");
const _temp16 = require("87bab9ff03cc3f14");
const _temp17 = require("61207fc805b051cb");
const _temp18 = require("e45c5d7ef048c0bc");
const _temp19 = require("f79d08166a1cc19a");
const _temp20 = require("a803bf448afe4caa");
const _temp21 = require("d9370b237558ea2f");
const _temp22 = require("eaf232dfc2af3205");
const _temp23 = require("d77ad3cf40829c9e");
const _temp24 = require("aab3dd24a66faf05");
const _temp25 = require("9696fd78ca4733fb");
const _temp26 = require("a64a30c2aba987d2");
const _temp27 = require("d96749cdd146c97f");
const _temp28 = require("235fc8391c2a3429");
const _temp29 = require("235bfdc21ceaf9ac");
const _temp30 = require("b196eaa52a5b45c4");
const _temp31 = require("3d504497c7171e9a");
const _temp32 = require("263336616145ebe");
const _temp33 = require("2a328e3607c4d2cc");
module.exports = {
    "ar-AE": _temp0,
    "bg-BG": _temp1,
    "cs-CZ": _temp2,
    "da-DK": _temp3,
    "de-DE": _temp4,
    "el-GR": _temp5,
    "en-US": _temp6,
    "es-ES": _temp7,
    "et-EE": _temp8,
    "fi-FI": _temp9,
    "fr-FR": _temp10,
    "he-IL": _temp11,
    "hr-HR": _temp12,
    "hu-HU": _temp13,
    "it-IT": _temp14,
    "ja-JP": _temp15,
    "ko-KR": _temp16,
    "lt-LT": _temp17,
    "lv-LV": _temp18,
    "nb-NO": _temp19,
    "nl-NL": _temp20,
    "pl-PL": _temp21,
    "pt-BR": _temp22,
    "pt-PT": _temp23,
    "ro-RO": _temp24,
    "ru-RU": _temp25,
    "sk-SK": _temp26,
    "sl-SI": _temp27,
    "sr-SP": _temp28,
    "sv-SE": _temp29,
    "tr-TR": _temp30,
    "uk-UA": _temp31,
    "zh-CN": _temp32,
    "zh-TW": _temp33
};

},{"6c45bb47fb74e645":"cgG7i","112c8706be982c58":"bwb3y","6fdb13c38842ca97":"h0Boj","d9b55069e26d88b7":"jlJZ1","e689a7b44c1e439c":"bol7a","3d3db3a18de688d1":"93MJT","1c63d6fe5269f87d":"kI1kI","eed51675935ea1b3":"5dC9T","e58b5b53fe6cf451":"a7W1l","2ecf1770cefde1f0":"jdFDj","96182bfcf4bc4cec":"7JSNL","c55c107c7d7e9696":"bLnpw","9235b0493456e8aa":"1On88","3074e237afaf3d23":"cvePn","b5e4c1774f09c344":"3mpuT","168cac5c1cb13c4d":"fHwby","87bab9ff03cc3f14":"dOMDn","61207fc805b051cb":"9gIbD","e45c5d7ef048c0bc":"54vzh","f79d08166a1cc19a":"kCHoM","a803bf448afe4caa":"lLm1C","d9370b237558ea2f":"ixLbN","eaf232dfc2af3205":"18Fng","d77ad3cf40829c9e":"4nJwF","aab3dd24a66faf05":"gYL5p","9696fd78ca4733fb":"dwNuL","a64a30c2aba987d2":"4K7SG","d96749cdd146c97f":"jzVEX","235fc8391c2a3429":"dZzms","235bfdc21ceaf9ac":"eCBtD","b196eaa52a5b45c4":"f4cd4","3d504497c7171e9a":"gZU0a","263336616145ebe":"anIUo","2a328e3607c4d2cc":"bwpuc"}],"cgG7i":[function(require,module,exports) {
module.exports = {
    "page_count": (args, formatter)=>`\u{645}\u{646} ${formatter.plural(args.n, {
            one: ()=>`${formatter.number(args.n)} \u{635}\u{641}\u{62D}\u{629}`,
            other: ()=>`${formatter.number(args.n)} \u{645}\u{646} \u{627}\u{644}\u{635}\u{641}\u{62D}\u{627}\u{62A}`
        })}`
};

},{}],"bwb3y":[function(require,module,exports) {
module.exports = {
    "page_count": (args, formatter)=>`\u{43D}\u{430} ${formatter.plural(args.n, {
            one: ()=>`${formatter.number(args.n)} \u{441}\u{442}\u{440}\u{430}\u{43D}\u{438}\u{446}\u{430}`,
            other: ()=>`${formatter.number(args.n)} \u{441}\u{442}\u{440}\u{430}\u{43D}\u{438}\u{446}\u{438}`
        })}`
};

},{}],"h0Boj":[function(require,module,exports) {
module.exports = {
    "page_count": (args, formatter)=>`z ${formatter.plural(args.n, {
            one: ()=>`${formatter.number(args.n)} str\xe1nky`,
            other: ()=>`${formatter.number(args.n)} str\xe1nek`
        })}`
};

},{}],"jlJZ1":[function(require,module,exports) {
module.exports = {
    "page_count": (args, formatter)=>`af ${formatter.plural(args.n, {
            one: ()=>`${formatter.number(args.n)} side`,
            other: ()=>`${formatter.number(args.n)} sider`
        })}`
};

},{}],"bol7a":[function(require,module,exports) {
module.exports = {
    "page_count": (args, formatter)=>`von ${formatter.plural(args.n, {
            one: ()=>`${formatter.number(args.n)} Seite`,
            other: ()=>`${formatter.number(args.n)} Seiten`
        })}`
};

},{}],"93MJT":[function(require,module,exports) {
module.exports = {
    "page_count": (args, formatter)=>`\u{3B1}\u{3C0}\u{3CC} ${formatter.plural(args.n, {
            one: ()=>`${formatter.number(args.n)} \u{3C3}\u{3B5}\u{3BB}\u{3AF}\u{3B4}\u{3B1}`,
            other: ()=>`${formatter.number(args.n)} \u{3C3}\u{3B5}\u{3BB}\u{3AF}\u{3B4}\u{3B5}\u{3C2}`
        })}`
};

},{}],"kI1kI":[function(require,module,exports) {
module.exports = {
    "page_count": (args, formatter)=>`of ${formatter.plural(args.n, {
            one: ()=>`${formatter.number(args.n)} page`,
            other: ()=>`${formatter.number(args.n)} pages`
        })}`
};

},{}],"5dC9T":[function(require,module,exports) {
module.exports = {
    "page_count": (args, formatter)=>`de ${formatter.plural(args.n, {
            one: ()=>`${formatter.number(args.n)} p\xe1gina`,
            other: ()=>`${formatter.number(args.n)} p\xe1ginas`
        })}`
};

},{}],"a7W1l":[function(require,module,exports) {
module.exports = {
    "page_count": (args, formatter)=>`/ ${formatter.plural(args.n, {
            one: ()=>`${formatter.number(args.n)} lk`,
            other: ()=>`${formatter.number(args.n)} lk`
        })}`
};

},{}],"jdFDj":[function(require,module,exports) {
module.exports = {
    "page_count": (args, formatter)=>`/ ${formatter.plural(args.n, {
            one: ()=>`${formatter.number(args.n)} sivu`,
            other: ()=>`${formatter.number(args.n)} sivua`
        })}`
};

},{}],"7JSNL":[function(require,module,exports) {
module.exports = {
    "page_count": (args, formatter)=>`sur ${formatter.plural(args.n, {
            one: ()=>`${formatter.number(args.n)} page`,
            other: ()=>`${formatter.number(args.n)} pages`
        })}`
};

},{}],"bLnpw":[function(require,module,exports) {
module.exports = {
    "page_count": (args, formatter)=>`\u{5DE}\u{5EA}\u{5D5}\u{5DA} ${formatter.plural(args.n, {
            one: ()=>`${formatter.number(args.n)} \u{5D3}\u{5E3}`,
            other: ()=>`${formatter.number(args.n)} \u{5D3}\u{5E4}\u{5D9}\u{5DD}`
        })}`
};

},{}],"1On88":[function(require,module,exports) {
module.exports = {
    "page_count": (args, formatter)=>`od ${formatter.plural(args.n, {
            one: ()=>`${formatter.number(args.n)} stranice`,
            other: ()=>`${formatter.number(args.n)} stranica`
        })}`
};

},{}],"cvePn":[function(require,module,exports) {
module.exports = {
    "page_count": (args, formatter)=>`/ ${formatter.plural(args.n, {
            one: ()=>`${formatter.number(args.n)} oldal`,
            other: ()=>`${formatter.number(args.n)} oldalak`
        })}`
};

},{}],"3mpuT":[function(require,module,exports) {
module.exports = {
    "page_count": (args, formatter)=>`di ${formatter.plural(args.n, {
            one: ()=>`${formatter.number(args.n)} pagina`,
            other: ()=>`${formatter.number(args.n)} pagine`
        })}`
};

},{}],"fHwby":[function(require,module,exports) {
module.exports = {
    "page_count": (args, formatter)=>`\u{FF0F} ${formatter.plural(args.n, {
            one: ()=>`${formatter.number(args.n)} \u{30DA}\u{30FC}\u{30B8}`,
            other: ()=>`${formatter.number(args.n)} \u{30DA}\u{30FC}\u{30B8}`
        })}`
};

},{}],"dOMDn":[function(require,module,exports) {
module.exports = {
    "page_count": (args, formatter)=>`/ ${formatter.plural(args.n, {
            one: ()=>`${formatter.number(args.n)} \u{D398}\u{C774}\u{C9C0}`,
            other: ()=>`${formatter.number(args.n)} \u{D398}\u{C774}\u{C9C0}`
        })}`
};

},{}],"9gIbD":[function(require,module,exports) {
module.exports = {
    "page_count": (args, formatter)=>`i\u{161} ${formatter.plural(args.n, {
            one: ()=>`${formatter.number(args.n)} psl.`,
            other: ()=>`${formatter.number(args.n)} psl.`
        })}`
};

},{}],"54vzh":[function(require,module,exports) {
module.exports = {
    "page_count": (args, formatter)=>`no ${formatter.plural(args.n, {
            one: ()=>`${formatter.number(args.n)}\xa0lpp.`,
            other: ()=>`${formatter.number(args.n)}\xa0lpp.`
        })}`
};

},{}],"kCHoM":[function(require,module,exports) {
module.exports = {
    "page_count": (args, formatter)=>`av ${formatter.plural(args.n, {
            one: ()=>`${formatter.number(args.n)} side`,
            other: ()=>`${formatter.number(args.n)} sider`
        })}`
};

},{}],"lLm1C":[function(require,module,exports) {
module.exports = {
    "page_count": (args, formatter)=>`van ${formatter.plural(args.n, {
            one: ()=>`${formatter.number(args.n)} pagina`,
            other: ()=>`${formatter.number(args.n)} pagina's`
        })}`
};

},{}],"ixLbN":[function(require,module,exports) {
module.exports = {
    "page_count": (args, formatter)=>`z ${formatter.plural(args.n, {
            one: ()=>`${formatter.number(args.n)} strony`,
            other: ()=>`${formatter.number(args.n)} stron`
        })}`
};

},{}],"18Fng":[function(require,module,exports) {
module.exports = {
    "page_count": (args, formatter)=>`de ${formatter.plural(args.n, {
            one: ()=>`${formatter.number(args.n)} p\xe1gina`,
            other: ()=>`${formatter.number(args.n)} p\xe1ginas`
        })}`
};

},{}],"4nJwF":[function(require,module,exports) {
module.exports = {
    "page_count": (args, formatter)=>`de ${formatter.plural(args.n, {
            one: ()=>`${formatter.number(args.n)} p\xe1gina`,
            other: ()=>`${formatter.number(args.n)} p\xe1ginas`
        })}`
};

},{}],"gYL5p":[function(require,module,exports) {
module.exports = {
    "page_count": (args, formatter)=>`din ${formatter.plural(args.n, {
            one: ()=>`${formatter.number(args.n)} pagin\u{103}`,
            other: ()=>`${formatter.number(args.n)} pagini`
        })}`
};

},{}],"dwNuL":[function(require,module,exports) {
module.exports = {
    "page_count": (args, formatter)=>`\u{438}\u{437} ${formatter.plural(args.n, {
            one: ()=>`${formatter.number(args.n)} \u{441}\u{442}\u{440}.`,
            other: ()=>`${formatter.number(args.n)} \u{441}\u{442}\u{440}.`
        })}`
};

},{}],"4K7SG":[function(require,module,exports) {
module.exports = {
    "page_count": (args, formatter)=>`z ${formatter.plural(args.n, {
            one: ()=>`${formatter.number(args.n)} strany`,
            other: ()=>`${formatter.number(args.n)} str\xe1n`
        })}`
};

},{}],"jzVEX":[function(require,module,exports) {
module.exports = {
    "page_count": (args, formatter)=>`od ${formatter.plural(args.n, {
            one: ()=>`${formatter.number(args.n)} stran`,
            other: ()=>`${formatter.number(args.n)} strani`
        })}`
};

},{}],"dZzms":[function(require,module,exports) {
module.exports = {
    "page_count": (args, formatter)=>`od ${formatter.plural(args.n, {
            one: ()=>`${formatter.number(args.n)} strana`,
            other: ()=>`${formatter.number(args.n)} strana`
        })}`
};

},{}],"eCBtD":[function(require,module,exports) {
module.exports = {
    "page_count": (args, formatter)=>`av ${formatter.plural(args.n, {
            one: ()=>`${formatter.number(args.n)} sida`,
            other: ()=>`${formatter.number(args.n)} sidor`
        })}`
};

},{}],"f4cd4":[function(require,module,exports) {
module.exports = {
    "page_count": (args, formatter)=>`/ ${formatter.plural(args.n, {
            one: ()=>`${formatter.number(args.n)} sayfa`,
            other: ()=>`${formatter.number(args.n)} sayfa`
        })}`
};

},{}],"gZU0a":[function(require,module,exports) {
module.exports = {
    "page_count": (args, formatter)=>`\u{456}\u{437} ${formatter.plural(args.n, {
            one: ()=>`${formatter.number(args.n)} \u{441}\u{442}\u{43E}\u{440}\u{456}\u{43D}\u{43A}\u{438}`,
            other: ()=>`${formatter.number(args.n)} \u{441}\u{442}\u{43E}\u{440}.`
        })}`
};

},{}],"anIUo":[function(require,module,exports) {
module.exports = {
    "page_count": (args, formatter)=>`\u{5171} ${formatter.plural(args.n, {
            one: ()=>`${formatter.number(args.n)} \u{9875}`,
            other: ()=>`${formatter.number(args.n)} \u{9875}`
        })}`
};

},{}],"bwpuc":[function(require,module,exports) {
module.exports = {
    "page_count": (args, formatter)=>`\u{5171} ${formatter.plural(args.n, {
            one: ()=>`${formatter.number(args.n)} \u{9801}`,
            other: ()=>`${formatter.number(args.n)} \u{9801}`
        })}`
};

},{}],"jMVcT":[function(require,module,exports) {
module.exports["focus-ring"] = `t7ozgq_focus-ring`;
module.exports["i18nFontFamily"] = `t7ozgq_i18nFontFamily`;
module.exports["is-hovered"] = `t7ozgq_is-hovered`;
module.exports["is-selected"] = `t7ozgq_is-selected`;
module.exports["spectrum-FocusRing-ring"] = `t7ozgq_spectrum-FocusRing-ring`;
module.exports["spectrum-FocusRing"] = `t7ozgq_spectrum-FocusRing ${module.exports["spectrum-FocusRing-ring"]}`;
module.exports["spectrum-FocusRing--quiet"] = `t7ozgq_spectrum-FocusRing--quiet`;
module.exports["spectrum-Pagination--explicit"] = `t7ozgq_spectrum-Pagination--explicit`;
module.exports["spectrum-Pagination--listing"] = `t7ozgq_spectrum-Pagination--listing`;
module.exports["spectrum-Pagination-counter"] = `t7ozgq_spectrum-Pagination-counter`;
module.exports["spectrum-Pagination-input"] = `t7ozgq_spectrum-Pagination-input`;
module.exports["spectrum-Pagination-nextButton"] = `t7ozgq_spectrum-Pagination-nextButton`;
module.exports["spectrum-Pagination-pageButton"] = `t7ozgq_spectrum-Pagination-pageButton`;
module.exports["spectrum-Pagination-prevButton"] = `t7ozgq_spectrum-Pagination-prevButton`;

},{}],"1pbNf":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "usePagination", ()=>(0, _usePagination.usePagination));
var _usePagination = require("./usePagination");

},{"./usePagination":"b1hqv","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"b1hqv":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "usePagination", ()=>usePagination);
var _intl = require("../intl");
var _intlDefault = parcelHelpers.interopDefault(_intl);
var _i18N = require("@react-aria/i18n");
function usePagination(props, state) {
    let stringFormatter = (0, _i18N.useLocalizedStringFormatter)((0, _intlDefault.default), "@react-aria/pagination");
    let onPrevious = ()=>{
        state.onDecrement();
        if (props.onPrevious) props.onPrevious(state.ref.current);
    };
    let onNext = ()=>{
        state.onIncrement();
        if (props.onNext) props.onNext(state.ref.current);
    };
    let onKeyDown = (e)=>{
        switch(e.key){
            case "ArrowUp":
            case "Up":
                state.onIncrement();
                break;
            case "ArrowDown":
            case "Down":
                state.onDecrement();
                break;
            case "Enter":
            case " ":
                break;
            default:
        }
    };
    return {
        prevButtonProps: {
            ...props,
            "aria-label": stringFormatter.format("previous"),
            onPress: onPrevious
        },
        nextButtonProps: {
            ...props,
            "aria-label": stringFormatter.format("next"),
            onPress: onNext
        },
        textProps: {
            ...props,
            onKeyDown: onKeyDown
        }
    };
}

},{"../intl":"3x8hz","@react-aria/i18n":"411rg","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"3x8hz":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _csCZJson = require("./cs-CZ.json");
var _csCZJsonDefault = parcelHelpers.interopDefault(_csCZJson);
var _daDKJson = require("./da-DK.json");
var _daDKJsonDefault = parcelHelpers.interopDefault(_daDKJson);
var _deDEJson = require("./de-DE.json");
var _deDEJsonDefault = parcelHelpers.interopDefault(_deDEJson);
var _enUSJson = require("./en-US.json");
var _enUSJsonDefault = parcelHelpers.interopDefault(_enUSJson);
var _esESJson = require("./es-ES.json");
var _esESJsonDefault = parcelHelpers.interopDefault(_esESJson);
var _fiFIJson = require("./fi-FI.json");
var _fiFIJsonDefault = parcelHelpers.interopDefault(_fiFIJson);
var _frFRJson = require("./fr-FR.json");
var _frFRJsonDefault = parcelHelpers.interopDefault(_frFRJson);
var _itITJson = require("./it-IT.json");
var _itITJsonDefault = parcelHelpers.interopDefault(_itITJson);
var _jaJPJson = require("./ja-JP.json");
var _jaJPJsonDefault = parcelHelpers.interopDefault(_jaJPJson);
var _koKRJson = require("./ko-KR.json");
var _koKRJsonDefault = parcelHelpers.interopDefault(_koKRJson);
var _nbNOJson = require("./nb-NO.json");
var _nbNOJsonDefault = parcelHelpers.interopDefault(_nbNOJson);
var _nlNLJson = require("./nl-NL.json");
var _nlNLJsonDefault = parcelHelpers.interopDefault(_nlNLJson);
var _plPLJson = require("./pl-PL.json");
var _plPLJsonDefault = parcelHelpers.interopDefault(_plPLJson);
var _ptBRJson = require("./pt-BR.json");
var _ptBRJsonDefault = parcelHelpers.interopDefault(_ptBRJson);
var _ruRUJson = require("./ru-RU.json");
var _ruRUJsonDefault = parcelHelpers.interopDefault(_ruRUJson);
var _svSEJson = require("./sv-SE.json");
var _svSEJsonDefault = parcelHelpers.interopDefault(_svSEJson);
var _trTRJson = require("./tr-TR.json");
var _trTRJsonDefault = parcelHelpers.interopDefault(_trTRJson);
var _zhCNJson = require("./zh-CN.json");
var _zhCNJsonDefault = parcelHelpers.interopDefault(_zhCNJson);
var _zhTWJson = require("./zh-TW.json");
var _zhTWJsonDefault = parcelHelpers.interopDefault(_zhTWJson);
exports.default = {
    "cs-CZ": (0, _csCZJsonDefault.default),
    "da-DK": (0, _daDKJsonDefault.default),
    "de-DE": (0, _deDEJsonDefault.default),
    "en-US": (0, _enUSJsonDefault.default),
    "es-ES": (0, _esESJsonDefault.default),
    "fi-FI": (0, _fiFIJsonDefault.default),
    "fr-FR": (0, _frFRJsonDefault.default),
    "it-IT": (0, _itITJsonDefault.default),
    "ja-JP": (0, _jaJPJsonDefault.default),
    "ko-KR": (0, _koKRJsonDefault.default),
    "nb-NO": (0, _nbNOJsonDefault.default),
    "nl-NL": (0, _nlNLJsonDefault.default),
    "pl-PL": (0, _plPLJsonDefault.default),
    "pt-BR": (0, _ptBRJsonDefault.default),
    "ru-RU": (0, _ruRUJsonDefault.default),
    "sv-SE": (0, _svSEJsonDefault.default),
    "tr-TR": (0, _trTRJsonDefault.default),
    "zh-CN": (0, _zhCNJsonDefault.default),
    "zh-TW": (0, _zhTWJsonDefault.default)
};

},{"./cs-CZ.json":"fuGDE","./da-DK.json":"4Xjyt","./de-DE.json":"3iXSV","./en-US.json":"7Dur3","./es-ES.json":"9gCS4","./fi-FI.json":"cW3GP","./fr-FR.json":"8FMfB","./it-IT.json":"2zknR","./ja-JP.json":"eRmgI","./ko-KR.json":"96Lut","./nb-NO.json":"7Gny9","./nl-NL.json":"5cZgl","./pl-PL.json":"famNx","./pt-BR.json":"9i3mt","./ru-RU.json":"QBC7D","./sv-SE.json":"8hfSJ","./tr-TR.json":"i5XtZ","./zh-CN.json":"d1Nwj","./zh-TW.json":"2PMoU","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"fuGDE":[function(require,module,exports) {
module.exports = {
    "next": `Dal\u{161}\xed`,
    "previous": `P\u{159}edchoz\xed`
};

},{}],"4Xjyt":[function(require,module,exports) {
module.exports = {
    "next": `N\xe6ste`,
    "previous": `Forrige`
};

},{}],"3iXSV":[function(require,module,exports) {
module.exports = {
    "next": `Weiter`,
    "previous": `Zur\xfcck`
};

},{}],"7Dur3":[function(require,module,exports) {
module.exports = {
    "previous": `Previous`,
    "next": `Next`
};

},{}],"9gCS4":[function(require,module,exports) {
module.exports = {
    "next": `Siguiente`,
    "previous": `Anterior`
};

},{}],"cW3GP":[function(require,module,exports) {
module.exports = {
    "next": `Seuraava`,
    "previous": `Edellinen`
};

},{}],"8FMfB":[function(require,module,exports) {
module.exports = {
    "next": `Suivant`,
    "previous": `Pr\xe9c\xe9dent`
};

},{}],"2zknR":[function(require,module,exports) {
module.exports = {
    "next": `Successivo`,
    "previous": `Precedente`
};

},{}],"eRmgI":[function(require,module,exports) {
module.exports = {
    "next": `\u{6B21}\u{3078}`,
    "previous": `\u{524D}\u{3078}`
};

},{}],"96Lut":[function(require,module,exports) {
module.exports = {
    "next": `\u{B2E4}\u{C74C}`,
    "previous": `\u{C774}\u{C804}`
};

},{}],"7Gny9":[function(require,module,exports) {
module.exports = {
    "next": `Neste`,
    "previous": `Forrige`
};

},{}],"5cZgl":[function(require,module,exports) {
module.exports = {
    "next": `Volgende`,
    "previous": `Vorige`
};

},{}],"famNx":[function(require,module,exports) {
module.exports = {
    "next": `Dalej`,
    "previous": `Wstecz`
};

},{}],"9i3mt":[function(require,module,exports) {
module.exports = {
    "next": `Pr\xf3ximo`,
    "previous": `Anterior`
};

},{}],"QBC7D":[function(require,module,exports) {
module.exports = {
    "next": `\u{414}\u{430}\u{43B}\u{435}\u{435}`,
    "previous": `\u{41D}\u{430}\u{437}\u{430}\u{434}`
};

},{}],"8hfSJ":[function(require,module,exports) {
module.exports = {
    "next": `N\xe4sta`,
    "previous": `F\xf6reg\xe5ende`
};

},{}],"i5XtZ":[function(require,module,exports) {
module.exports = {
    "next": `Sonraki`,
    "previous": `\xd6nceki`
};

},{}],"d1Nwj":[function(require,module,exports) {
module.exports = {
    "next": `\u{4E0B}\u{4E00}\u{9875}`,
    "previous": `\u{4E0A}\u{4E00}\u{9875}`
};

},{}],"2PMoU":[function(require,module,exports) {
module.exports = {
    "next": `\u{4E0B}\u{4E00}\u{9801}`,
    "previous": `\u{4E0A}\u{4E00}\u{9801}`
};

},{}],"k5Rh1":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "usePaginationState", ()=>(0, _usePaginationState.usePaginationState));
var _usePaginationState = require("./usePaginationState");

},{"./usePaginationState":"kybnQ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"kybnQ":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "usePaginationState", ()=>usePaginationState);
var _utils = require("@react-stately/utils");
var _react = require("react");
function usePaginationState(props) {
    const [value, setValue] = (0, _utils.useControlledState)(props.value, props.defaultValue, props.onChange);
    let ref = (0, _react.useRef)(value);
    const onPageInputChange = (value)=>{
        if (value === "" || isValidPage(props.maxValue, value)) {
            value = value !== "" ? parseInt(value, 10) : value;
            setValue(value);
            ref.current = value;
        }
    };
    const onIncrement = ()=>{
        let val = value === "" ? 1 : parseInt(value, 10) + 1;
        if (isValidPage(props.maxValue, val)) {
            ref.current = val;
            setValue(val);
        }
    };
    const onDecrement = ()=>{
        let val = value === "" ? 1 : parseInt(value, 10) - 1;
        if (isValidPage(props.maxValue, val)) {
            ref.current = val;
            setValue(val);
        }
    };
    return {
        onChange: onPageInputChange,
        onDecrement,
        onIncrement,
        ref,
        value
    };
}
function isValidPage(totalPages, page) {
    page = parseInt(page, 10);
    totalPages = parseInt(totalPages, 10);
    return !isNaN(page) && page >= 1 && totalPages && page <= totalPages;
}

},{"@react-stately/utils":"cpDPf","react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"lRoA0":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Default", ()=>Default);
parcelHelpers.export(exports, "Disabled", ()=>Disabled);
parcelHelpers.export(exports, "Sections", ()=>Sections);
parcelHelpers.export(exports, "Dynamic", ()=>Dynamic);
parcelHelpers.export(exports, "DynamicSections", ()=>DynamicSections);
parcelHelpers.export(exports, "ComplexItems", ()=>ComplexItems);
parcelHelpers.export(exports, "WithAvatars", ()=>WithAvatars);
parcelHelpers.export(exports, "LongItemText", ()=>LongItemText);
parcelHelpers.export(exports, "FalsyKey", ()=>FalsyKey);
parcelHelpers.export(exports, "LabelledBy", ()=>LabelledBy);
parcelHelpers.export(exports, "ContextualHelpPicker", ()=>ContextualHelpPicker);
parcelHelpers.export(exports, "SelectedKey", ()=>SelectedKey);
parcelHelpers.export(exports, "DefaultSelectedKey", ()=>DefaultSelectedKey);
parcelHelpers.export(exports, "Loading", ()=>Loading);
parcelHelpers.export(exports, "AsyncLoading", ()=>AsyncLoading);
parcelHelpers.export(exports, "Focus", ()=>Focus);
parcelHelpers.export(exports, "Resize", ()=>Resize);
parcelHelpers.export(exports, "Scrolling", ()=>Scrolling);
parcelHelpers.export(exports, "Links", ()=>Links);
parcelHelpers.export(exports, "Quiet", ()=>Quiet);
var _addonActions = require("@storybook/addon-actions");
var _button = require("@react-spectrum/button");
var _alignCenter = require("@spectrum-icons/workflow/AlignCenter");
var _alignCenterDefault = parcelHelpers.interopDefault(_alignCenter);
var _alignLeft = require("@spectrum-icons/workflow/AlignLeft");
var _alignLeftDefault = parcelHelpers.interopDefault(_alignLeft);
var _alignRight = require("@spectrum-icons/workflow/AlignRight");
var _alignRightDefault = parcelHelpers.interopDefault(_alignRight);
var _avatar = require("@react-spectrum/avatar");
var _view = require("@react-spectrum/view");
var _contextualhelp = require("@react-spectrum/contextualhelp");
var _copy = require("@spectrum-icons/workflow/Copy");
var _copyDefault = parcelHelpers.interopDefault(_copy);
var _cut = require("@spectrum-icons/workflow/Cut");
var _cutDefault = parcelHelpers.interopDefault(_cut);
var _layout = require("@react-spectrum/layout");
var _text = require("@react-spectrum/text");
var _ = require("../");
var _paste = require("@spectrum-icons/workflow/Paste");
var _pasteDefault = parcelHelpers.interopDefault(_paste);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _data = require("@react-stately/data");
var _testingLibrary = require("@storybook/testing-library");
let flatOptions = [
    {
        id: 1,
        name: "Aardvark"
    },
    {
        id: 2,
        name: "Kangaroo"
    },
    {
        id: 3,
        name: "Snake"
    },
    {
        id: 4,
        name: "Danni"
    },
    {
        id: 5,
        name: "Devon"
    },
    {
        id: 6,
        name: "Ross"
    },
    {
        id: 7,
        name: "Puppy"
    },
    {
        id: 8,
        name: "Doggo"
    },
    {
        id: 9,
        name: "Floof"
    }
];
let longItemText = [
    {
        id: "short",
        name: "One"
    },
    {
        id: "long",
        name: "your text here long long long long"
    },
    {
        id: "underscores",
        name: "your_text_here_long_long_long_long"
    },
    {
        id: "hypens",
        name: "your-text-here-long-long-long-long"
    },
    {
        id: "singleWord",
        name: "supercalifragilisticexpialidocious"
    },
    {
        id: "always",
        name: "This item is very long and word wraps poorly"
    }
];
let falsyKey = [
    {
        id: "",
        name: "None"
    },
    {
        id: "One",
        name: "One"
    },
    {
        id: "Two",
        name: "Two"
    },
    {
        id: "Three",
        name: "Three"
    }
];
let withSection = [
    {
        name: "Animals",
        children: [
            {
                name: "Aardvark"
            },
            {
                name: "Kangaroo"
            },
            {
                name: "Snake"
            }
        ]
    },
    {
        name: "People",
        children: [
            {
                name: "Danni"
            },
            {
                name: "Devon"
            },
            {
                name: "Ross"
            }
        ]
    }
];
exports.default = {
    title: "Picker",
    component: (0, _.Picker),
    excludeStories: [],
    args: {
        "label": "Test",
        onSelectionChange: (0, _addonActions.action)("onSelectionChange"),
        onOpenChange: (0, _addonActions.action)("onOpenChange")
    },
    argTypes: {
        layout: {
            table: {
                disable: true
            }
        },
        children: {
            table: {
                disable: true
            }
        },
        onSelectionChange: {
            table: {
                disable: true
            }
        },
        onOpenChange: {
            table: {
                disable: true
            }
        },
        label: {
            control: "text"
        },
        description: {
            control: "text"
        },
        errorMessage: {
            control: "text"
        },
        isDisabled: {
            control: "boolean"
        },
        labelAlign: {
            control: "radio",
            options: [
                "end",
                "start"
            ]
        },
        labelPosition: {
            control: "radio",
            options: [
                "side",
                "top"
            ]
        },
        necessityIndicator: {
            control: "radio",
            options: [
                "icon",
                "label"
            ]
        },
        isRequired: {
            control: "boolean"
        },
        isInvalid: {
            control: "boolean"
        },
        isQuiet: {
            control: "boolean"
        },
        direction: {
            control: "radio",
            options: [
                "top",
                "bottom"
            ]
        },
        align: {
            control: "radio",
            options: [
                "start",
                "end"
            ]
        },
        width: {
            control: {
                type: "radio",
                options: [
                    null,
                    "100px",
                    "480px",
                    "size-4600"
                ]
            }
        },
        menuWidth: {
            control: {
                type: "radio",
                options: [
                    null,
                    "100px",
                    "480px",
                    "size-4600"
                ]
            }
        },
        isLoading: {
            control: "boolean"
        },
        autoFocus: {
            control: "boolean"
        },
        isOpen: {
            control: "boolean"
        },
        defaultOpen: {
            control: "boolean"
        }
    }
};
const Default = {
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(DefaultPicker, args)
};
// Need to interact with picker for the aXe plugin to catch the 'aria-hidden-focus' false positive
Default.play = async ({ canvasElement })=>{
    let canvas = (0, _testingLibrary.within)(canvasElement);
    let button = await canvas.findByRole("button");
    await (0, _testingLibrary.userEvent).click(button);
    let body = canvasElement.ownerDocument.body;
    await (0, _testingLibrary.within)(body).findByRole("listbox");
};
const Disabled = {
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(DefaultPicker, {
            ...args,
            disabledKeys: [
                "Short"
            ]
        }),
    name: "disabled keys"
};
const Sections = {
    args: {
        children: /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Section), {
            title: "Animals"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            key: "Aardvark"
        }, "Aardvark"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            key: "Kangaroo"
        }, "Kangaroo"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            key: "Snake"
        }, "Snake"))
    }
};
const Dynamic = {
    args: {
        children: (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), null, item.name),
        items: flatOptions
    },
    name: "dynamic"
};
const DynamicSections = {
    args: {
        children: (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Section), {
                key: item.name,
                items: item.children,
                title: item.name
            }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
                    key: item.name
                }, item.name)),
        items: withSection
    },
    name: "dynamic with sections"
};
const ComplexItems = {
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(ComplexItemsPicker, args),
    name: "complex items"
};
const WithAvatars = {
    args: {
        label: "Select a user"
    },
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Picker), args, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            textValue: "User 1"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _avatar.Avatar), {
            src: "https://i.imgur.com/kJOwAdv.png"
        }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, "User 1")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            textValue: "User 2"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _avatar.Avatar), {
            src: "https://i.imgur.com/kJOwAdv.png"
        }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, "User 2")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            textValue: "User 3"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _avatar.Avatar), {
            src: "https://i.imgur.com/kJOwAdv.png"
        }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, "User 3")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            textValue: "User 4"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _avatar.Avatar), {
            src: "https://i.imgur.com/kJOwAdv.png"
        }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, "User 4")))
};
const LongItemText = {
    args: {
        children: (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
                key: item.key
            }, item.name),
        items: longItemText
    },
    name: "long item text"
};
const FalsyKey = {
    args: {
        children: (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
                key: item.key
            }, item.name),
        items: falsyKey
    },
    name: "falsy item key"
};
const LabelledBy = {
    args: {
        "aria-label": null,
        "aria-labelledby": true,
        label: null
    },
    argTypes: {
        "aria-label": {
            control: "text"
        },
        "aria-labelledby": {
            control: "boolean"
        }
    },
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
            id: "test"
        }, "Test label"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Picker), {
            ...args,
            "aria-labelledby": args["aria-labelledby"] ? "test" : null,
            items: flatOptions
        }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), null, item.name))),
    name: "no visible label combination story",
    parameters: {
        description: {
            data: "Use controls to add/remove a visible label, aria-label, and toggle the aria-labelledby on/off"
        }
    }
};
const ContextualHelpPicker = {
    args: {
        children: (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), null, item.name),
        items: flatOptions,
        contextualHelp: /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _contextualhelp.ContextualHelp), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Heading), null, "What is a segment?"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Content), null, "Segments identify who your visitors are, what devices and services they use, where they navigated from, and much more."))
    },
    name: "contextual help"
};
const SelectedKey = {
    args: {
        children: (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), null, item.name),
        items: flatOptions,
        selectedKey: 7
    },
    name: "selectedKey"
};
const DefaultSelectedKey = {
    args: {
        children: (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), null, item.name),
        items: flatOptions,
        defaultSelectedKey: 7
    },
    name: "defaultSelectedKey (uncontrolled)"
};
const Loading = {
    args: {
        children: (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), null, item.name),
        items: [],
        isLoading: true
    },
    name: "isLoading, no items"
};
const AsyncLoading = {
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(AsyncLoadingExample, args),
    name: "async loading"
};
const Focus = {
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
            style: {
                display: "flex",
                width: "auto",
                margin: "250px 0"
            }
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement("label", {
            htmlFor: "focus-before"
        }, "Focus before"), /*#__PURE__*/ (0, _reactDefault.default).createElement("input", {
            id: "focus-before",
            "data-testid": "before"
        }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Picker), {
            ...args,
            label: "Focus-Test",
            items: flatOptions,
            onFocus: (0, _addonActions.action)("focus"),
            onBlur: (0, _addonActions.action)("blur"),
            onKeyDown: (0, _addonActions.action)("keydown"),
            onKeyUp: (0, _addonActions.action)("keyup")
        }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), null, item.name)), /*#__PURE__*/ (0, _reactDefault.default).createElement("label", {
            htmlFor: "focus-after"
        }, "Focus after"), /*#__PURE__*/ (0, _reactDefault.default).createElement("input", {
            id: "focus-after",
            "data-testid": "after"
        })),
    name: "keyboard tab focus"
};
const Resize = {
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(ResizePicker, args),
    name: "resize"
};
const Scrolling = {
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.View), {
            width: "300px",
            height: "size-500",
            overflow: "auto"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.View), {
            width: "500px"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Picker), {
            ...args,
            label: "Test"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            key: "One"
        }, "One"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            key: "Two"
        }, "Two"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            key: "Three"
        }, "Three")))),
    name: "scrolling container"
};
const Links = {
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Picker), args, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            key: "foo"
        }, "Foo"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            key: "bar"
        }, "Bar"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            href: "https://google.com"
        }, "Google"))
};
const Quiet = {
    render: ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.View), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.View), null, /*#__PURE__*/ (0, _reactDefault.default).createElement("h4", null, "Quiet picker with label"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Picker), {
            label: "Choose frequency",
            isQuiet: true
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            key: "rarely"
        }, "Rarely"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            key: "sometimes"
        }, "Sometimes"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            key: "always"
        }, "Always"))), /*#__PURE__*/ (0, _reactDefault.default).createElement("hr", null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.View), null, /*#__PURE__*/ (0, _reactDefault.default).createElement("h4", null, "Quiet picker without label"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Picker), {
            "aria-label": "Choose frequency",
            isQuiet: true
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            key: "rarely"
        }, "Rarely"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            key: "sometimes"
        }, "Sometimes"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            key: "always"
        }, "Always"))), /*#__PURE__*/ (0, _reactDefault.default).createElement("hr", null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.View), {
            width: 200
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement("h4", null, "Quiet picker with label and fixed width (200px)"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Picker), {
            isQuiet: true,
            label: "Choose frequency",
            defaultSelectedKey: "sometimes"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            key: "rarely"
        }, "Rarely"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            key: "sometimes"
        }, "This text is very long and will overflow the container"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            key: "always"
        }, "Always"))), /*#__PURE__*/ (0, _reactDefault.default).createElement("hr", null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.View), {
            width: 600
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement("h4", null, "Quiet picker with label and fixed width (600px)"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Picker), {
            isQuiet: true,
            label: "Choose frequency",
            defaultSelectedKey: "sometimes"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            key: "rarely"
        }, "Rarely"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            key: "sometimes"
        }, "This text is very long the picker should expand to fit"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            key: "always"
        }, "Always"))))
};
function DefaultPicker(props) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Picker), props, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
        key: "Short"
    }, "Short"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
        key: "Normal"
    }, "Normal"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
        key: "This item is very long and word wraps poorly"
    }, "This item is very long and word wraps poorly"));
}
function ComplexItemsPicker(props) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Picker), props, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Section), {
        title: "Section 1"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
        textValue: "Copy"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _copyDefault.default), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, "Copy")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
        textValue: "Cut"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _cutDefault.default), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, "Cut")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
        textValue: "Paste"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _pasteDefault.default), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, "Paste"))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Section), {
        title: "Section 2"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
        textValue: "Puppy"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _alignLeftDefault.default), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, "Puppy"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), {
        slot: "description"
    }, "Puppy description super long as well geez")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
        textValue: "Doggo with really really really long long long text"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _alignCenterDefault.default), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, "Doggo with really really really long long long text")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
        textValue: "Floof"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _alignRightDefault.default), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, "Floof"))));
}
function AsyncLoadingExample(props) {
    let list = (0, _data.useAsyncList)({
        async load ({ signal, cursor }) {
            let res = await fetch(cursor || "https://pokeapi.co/api/v2/pokemon", {
                signal
            });
            let json = await res.json();
            // The API is too fast sometimes, so make it take longer so we can see the spinner
            await new Promise((resolve)=>setTimeout(resolve, cursor ? 500 : 1000));
            return {
                items: json.results,
                cursor: json.next
            };
        }
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Picker), {
        ...props,
        label: "Pick a Pokemon",
        items: list.items,
        isLoading: list.isLoading,
        onLoadMore: list.loadMore
    }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            key: item.name
        }, item.name));
}
function ResizePicker(props) {
    const [state, setState] = (0, _react.useState)(true);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
        direction: "column",
        gap: "size-200",
        alignItems: "start"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        style: {
            width: state ? "200px" : "300px"
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Picker), {
        ...props,
        label: "Choose A",
        width: "100%"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
        key: "A1"
    }, "A1"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
        key: "A2"
    }, "A2"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
        key: "A3"
    }, "A3"))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), {
        onPress: ()=>setState(!state)
    }, "Toggle size"));
}

},{"@storybook/addon-actions":"coXbW","@react-spectrum/button":"jZWyP","@spectrum-icons/workflow/AlignCenter":"2Chkz","@spectrum-icons/workflow/AlignLeft":"65eDL","@spectrum-icons/workflow/AlignRight":"3qK4F","@react-spectrum/avatar":"kHDr1","@react-spectrum/view":"dnRjt","@react-spectrum/contextualhelp":"jA6za","@spectrum-icons/workflow/Copy":"jpSBZ","@spectrum-icons/workflow/Cut":"4SMrV","@react-spectrum/layout":"hzaUY","@react-spectrum/text":"etCGI","../":"hJnFk","@spectrum-icons/workflow/Paste":"jKZ2V","react":"9yzVZ","@react-stately/data":"gEgJM","@storybook/testing-library":"egwuA","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"hJnFk":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 * 
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _src = require("./src");
parcelHelpers.exportAll(_src, exports);

},{"./src":"kL1Uy","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"egwuA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "buildQueries", ()=>buildQueries);
parcelHelpers.export(exports, "configure", ()=>configure);
parcelHelpers.export(exports, "createEvent", ()=>createEvent);
parcelHelpers.export(exports, "findAllByAltText", ()=>findAllByAltText);
parcelHelpers.export(exports, "findAllByDisplayValue", ()=>findAllByDisplayValue);
parcelHelpers.export(exports, "findAllByLabelText", ()=>findAllByLabelText);
parcelHelpers.export(exports, "findAllByPlaceholderText", ()=>findAllByPlaceholderText);
parcelHelpers.export(exports, "findAllByRole", ()=>findAllByRole);
parcelHelpers.export(exports, "findAllByTestId", ()=>findAllByTestId);
parcelHelpers.export(exports, "findAllByText", ()=>findAllByText);
parcelHelpers.export(exports, "findAllByTitle", ()=>findAllByTitle);
parcelHelpers.export(exports, "findByAltText", ()=>findByAltText);
parcelHelpers.export(exports, "findByDisplayValue", ()=>findByDisplayValue);
parcelHelpers.export(exports, "findByLabelText", ()=>findByLabelText);
parcelHelpers.export(exports, "findByPlaceholderText", ()=>findByPlaceholderText);
parcelHelpers.export(exports, "findByRole", ()=>findByRole);
parcelHelpers.export(exports, "findByTestId", ()=>findByTestId);
parcelHelpers.export(exports, "findByText", ()=>findByText);
parcelHelpers.export(exports, "findByTitle", ()=>findByTitle);
parcelHelpers.export(exports, "fireEvent", ()=>fireEvent);
parcelHelpers.export(exports, "getAllByAltText", ()=>getAllByAltText);
parcelHelpers.export(exports, "getAllByDisplayValue", ()=>getAllByDisplayValue);
parcelHelpers.export(exports, "getAllByLabelText", ()=>getAllByLabelText);
parcelHelpers.export(exports, "getAllByPlaceholderText", ()=>getAllByPlaceholderText);
parcelHelpers.export(exports, "getAllByRole", ()=>getAllByRole);
parcelHelpers.export(exports, "getAllByTestId", ()=>getAllByTestId);
parcelHelpers.export(exports, "getAllByText", ()=>getAllByText);
parcelHelpers.export(exports, "getAllByTitle", ()=>getAllByTitle);
parcelHelpers.export(exports, "getByAltText", ()=>getByAltText);
parcelHelpers.export(exports, "getByDisplayValue", ()=>getByDisplayValue);
parcelHelpers.export(exports, "getByLabelText", ()=>getByLabelText);
parcelHelpers.export(exports, "getByPlaceholderText", ()=>getByPlaceholderText);
parcelHelpers.export(exports, "getByRole", ()=>getByRole);
parcelHelpers.export(exports, "getByTestId", ()=>getByTestId);
parcelHelpers.export(exports, "getByText", ()=>getByText);
parcelHelpers.export(exports, "getByTitle", ()=>getByTitle);
parcelHelpers.export(exports, "getConfig", ()=>getConfig);
parcelHelpers.export(exports, "getDefaultNormalizer", ()=>getDefaultNormalizer);
parcelHelpers.export(exports, "getElementError", ()=>getElementError);
parcelHelpers.export(exports, "getNodeText", ()=>getNodeText);
parcelHelpers.export(exports, "getQueriesForElement", ()=>getQueriesForElement);
parcelHelpers.export(exports, "getRoles", ()=>getRoles);
parcelHelpers.export(exports, "getSuggestedQuery", ()=>getSuggestedQuery);
parcelHelpers.export(exports, "isInaccessible", ()=>isInaccessible);
parcelHelpers.export(exports, "logDOM", ()=>logDOM);
parcelHelpers.export(exports, "logRoles", ()=>logRoles);
parcelHelpers.export(exports, "prettyDOM", ()=>prettyDOM);
parcelHelpers.export(exports, "queries", ()=>queries);
parcelHelpers.export(exports, "queryAllByAltText", ()=>queryAllByAltText);
parcelHelpers.export(exports, "queryAllByAttribute", ()=>queryAllByAttribute);
parcelHelpers.export(exports, "queryAllByDisplayValue", ()=>queryAllByDisplayValue);
parcelHelpers.export(exports, "queryAllByLabelText", ()=>queryAllByLabelText);
parcelHelpers.export(exports, "queryAllByPlaceholderText", ()=>queryAllByPlaceholderText);
parcelHelpers.export(exports, "queryAllByRole", ()=>queryAllByRole);
parcelHelpers.export(exports, "queryAllByTestId", ()=>queryAllByTestId);
parcelHelpers.export(exports, "queryAllByText", ()=>queryAllByText);
parcelHelpers.export(exports, "queryAllByTitle", ()=>queryAllByTitle);
parcelHelpers.export(exports, "queryByAltText", ()=>queryByAltText);
parcelHelpers.export(exports, "queryByAttribute", ()=>queryByAttribute);
parcelHelpers.export(exports, "queryByDisplayValue", ()=>queryByDisplayValue);
parcelHelpers.export(exports, "queryByLabelText", ()=>queryByLabelText);
parcelHelpers.export(exports, "queryByPlaceholderText", ()=>queryByPlaceholderText);
parcelHelpers.export(exports, "queryByRole", ()=>queryByRole);
parcelHelpers.export(exports, "queryByTestId", ()=>queryByTestId);
parcelHelpers.export(exports, "queryByText", ()=>queryByText);
parcelHelpers.export(exports, "queryByTitle", ()=>queryByTitle);
parcelHelpers.export(exports, "queryHelpers", ()=>queryHelpers);
parcelHelpers.export(exports, "screen", ()=>screen);
parcelHelpers.export(exports, "waitFor", ()=>waitFor);
parcelHelpers.export(exports, "waitForElementToBeRemoved", ()=>waitForElementToBeRemoved);
parcelHelpers.export(exports, "within", ()=>within);
parcelHelpers.export(exports, "prettyFormat", ()=>prettyFormat);
parcelHelpers.export(exports, "userEvent", ()=>userEvent);
var _clientLogger = require("@storybook/client-logger");
var _instrumenter = require("@storybook/instrumenter");
var _dom = require("@testing-library/dom");
var _userEvent = require("@testing-library/user-event");
var _userEventDefault = parcelHelpers.interopDefault(_userEvent);
var _tsDedent = require("ts-dedent");
var _tsDedentDefault = parcelHelpers.interopDefault(_tsDedent);
var __makeTemplateObject = undefined && undefined.__makeTemplateObject || function(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
};
var __assign = undefined && undefined.__assign || function() {
    __assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var debugOptions = {
    timeout: 2147483647,
    interval: 2147483647
};
var testingLibrary = (0, _instrumenter.instrument)(__assign({}, _dom), {
    intercept: function(method, path) {
        return path[0] === "fireEvent" || method.startsWith("findBy");
    },
    getArgs: function(call, state) {
        if (!state.isDebugging) return call.args;
        if (call.method.startsWith("findBy")) {
            var _a = call.args, value = _a[0], queryOptions = _a[1], waitForOptions = _a[2];
            return [
                value,
                queryOptions,
                __assign(__assign({}, waitForOptions), debugOptions)
            ];
        }
        if (call.method.startsWith("waitFor")) {
            var _b = call.args, callback = _b[0], options = _b[1];
            return [
                callback,
                __assign(__assign({}, options), debugOptions)
            ];
        }
        return call.args;
    }
});
testingLibrary.screen = Object.entries(testingLibrary.screen).reduce(function(acc, _a) {
    var key = _a[0], val = _a[1];
    return Object.defineProperty(acc, key, {
        get: function() {
            (0, _clientLogger.once).warn((0, _tsDedentDefault.default)(templateObject_1 || (templateObject_1 = __makeTemplateObject([
                "\n          You are using Testing Library's `screen` object. Use `within(canvasElement)` instead.\n          More info: https://storybook.js.org/docs/react/essentials/interactions\n        "
            ], [
                "\n          You are using Testing Library's \\`screen\\` object. Use \\`within(canvasElement)\\` instead.\n          More info: https://storybook.js.org/docs/react/essentials/interactions\n        "
            ]))));
            return val;
        }
    });
}, __assign({}, testingLibrary.screen));
var buildQueries = testingLibrary.buildQueries, configure = testingLibrary.configure, createEvent = testingLibrary.createEvent, findAllByAltText = testingLibrary.findAllByAltText, findAllByDisplayValue = testingLibrary.findAllByDisplayValue, findAllByLabelText = testingLibrary.findAllByLabelText, findAllByPlaceholderText = testingLibrary.findAllByPlaceholderText, findAllByRole = testingLibrary.findAllByRole, findAllByTestId = testingLibrary.findAllByTestId, findAllByText = testingLibrary.findAllByText, findAllByTitle = testingLibrary.findAllByTitle, findByAltText = testingLibrary.findByAltText, findByDisplayValue = testingLibrary.findByDisplayValue, findByLabelText = testingLibrary.findByLabelText, findByPlaceholderText = testingLibrary.findByPlaceholderText, findByRole = testingLibrary.findByRole, findByTestId = testingLibrary.findByTestId, findByText = testingLibrary.findByText, findByTitle = testingLibrary.findByTitle, fireEvent = testingLibrary.fireEvent, getAllByAltText = testingLibrary.getAllByAltText, getAllByDisplayValue = testingLibrary.getAllByDisplayValue, getAllByLabelText = testingLibrary.getAllByLabelText, getAllByPlaceholderText = testingLibrary.getAllByPlaceholderText, getAllByRole = testingLibrary.getAllByRole, getAllByTestId = testingLibrary.getAllByTestId, getAllByText = testingLibrary.getAllByText, getAllByTitle = testingLibrary.getAllByTitle, getByAltText = testingLibrary.getByAltText, getByDisplayValue = testingLibrary.getByDisplayValue, getByLabelText = testingLibrary.getByLabelText, getByPlaceholderText = testingLibrary.getByPlaceholderText, getByRole = testingLibrary.getByRole, getByTestId = testingLibrary.getByTestId, getByText = testingLibrary.getByText, getByTitle = testingLibrary.getByTitle, getConfig = testingLibrary.getConfig, getDefaultNormalizer = testingLibrary.getDefaultNormalizer, getElementError = testingLibrary.getElementError, getNodeText = testingLibrary.getNodeText, getQueriesForElement = testingLibrary.getQueriesForElement, getRoles = testingLibrary.getRoles, getSuggestedQuery = testingLibrary.getSuggestedQuery, isInaccessible = testingLibrary.isInaccessible, logDOM = testingLibrary.logDOM, logRoles = testingLibrary.logRoles, prettyDOM = testingLibrary.prettyDOM, queries = testingLibrary.queries, queryAllByAltText = testingLibrary.queryAllByAltText, queryAllByAttribute = testingLibrary.queryAllByAttribute, queryAllByDisplayValue = testingLibrary.queryAllByDisplayValue, queryAllByLabelText = testingLibrary.queryAllByLabelText, queryAllByPlaceholderText = testingLibrary.queryAllByPlaceholderText, queryAllByRole = testingLibrary.queryAllByRole, queryAllByTestId = testingLibrary.queryAllByTestId, queryAllByText = testingLibrary.queryAllByText, queryAllByTitle = testingLibrary.queryAllByTitle, queryByAltText = testingLibrary.queryByAltText, queryByAttribute = testingLibrary.queryByAttribute, queryByDisplayValue = testingLibrary.queryByDisplayValue, queryByLabelText = testingLibrary.queryByLabelText, queryByPlaceholderText = testingLibrary.queryByPlaceholderText, queryByRole = testingLibrary.queryByRole, queryByTestId = testingLibrary.queryByTestId, queryByText = testingLibrary.queryByText, queryByTitle = testingLibrary.queryByTitle, queryHelpers = testingLibrary.queryHelpers, screen = testingLibrary.screen, waitFor = testingLibrary.waitFor, waitForElementToBeRemoved = testingLibrary.waitForElementToBeRemoved, within = testingLibrary.within, prettyFormat = testingLibrary.prettyFormat;
var userEvent = (0, _instrumenter.instrument)({
    userEvent: (0, _userEventDefault.default)
}, {
    intercept: true
}).userEvent;
var templateObject_1;

},{"@storybook/client-logger":"f6HH7","@storybook/instrumenter":"lOl6R","@testing-library/dom":"f2A46","@testing-library/user-event":"9GFmI","ts-dedent":"b3KVD","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"f6HH7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "logger", ()=>logger);
parcelHelpers.export(exports, "once", ()=>once);
parcelHelpers.export(exports, "pretty", ()=>pretty);
var _esArrayConcatJs = require("core-js/modules/es.array.concat.js");
var _esArrayIteratorJs = require("core-js/modules/es.array.iterator.js");
var _esObjectToStringJs = require("core-js/modules/es.object.to-string.js");
var _esSetJs = require("core-js/modules/es.set.js");
var _esStringIteratorJs = require("core-js/modules/es.string.iterator.js");
var _webDomCollectionsIteratorJs = require("core-js/modules/web.dom-collections.iterator.js");
var _esRegexpExecJs = require("core-js/modules/es.regexp.exec.js");
var _esStringReplaceJs = require("core-js/modules/es.string.replace.js");
var _global = require("global");
var _globalDefault = parcelHelpers.interopDefault(_global);
var LOGLEVEL = (0, _globalDefault.default).LOGLEVEL, console = (0, _globalDefault.default).console;
var levels = {
    trace: 1,
    debug: 2,
    info: 3,
    warn: 4,
    error: 5,
    silent: 10
};
var currentLogLevelString = LOGLEVEL;
var currentLogLevelNumber = levels[currentLogLevelString] || levels.info;
var logger = {
    trace: function trace(message) {
        for(var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)rest[_key - 1] = arguments[_key];
        return currentLogLevelNumber <= levels.trace && console.trace.apply(console, [
            message
        ].concat(rest));
    },
    debug: function debug(message) {
        for(var _len2 = arguments.length, rest = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)rest[_key2 - 1] = arguments[_key2];
        return currentLogLevelNumber <= levels.debug && console.debug.apply(console, [
            message
        ].concat(rest));
    },
    info: function info(message) {
        for(var _len3 = arguments.length, rest = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)rest[_key3 - 1] = arguments[_key3];
        return currentLogLevelNumber <= levels.info && console.info.apply(console, [
            message
        ].concat(rest));
    },
    warn: function warn(message) {
        for(var _len4 = arguments.length, rest = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++)rest[_key4 - 1] = arguments[_key4];
        return currentLogLevelNumber <= levels.warn && console.warn.apply(console, [
            message
        ].concat(rest));
    },
    error: function error(message) {
        for(var _len5 = arguments.length, rest = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++)rest[_key5 - 1] = arguments[_key5];
        return currentLogLevelNumber <= levels.error && console.error.apply(console, [
            message
        ].concat(rest));
    },
    log: function log(message) {
        for(var _len6 = arguments.length, rest = new Array(_len6 > 1 ? _len6 - 1 : 0), _key6 = 1; _key6 < _len6; _key6++)rest[_key6 - 1] = arguments[_key6];
        return currentLogLevelNumber < levels.silent && console.log.apply(console, [
            message
        ].concat(rest));
    }
};
var logged = new Set();
var once = function once(type) {
    return function(message) {
        if (logged.has(message)) return undefined;
        logged.add(message);
        for(var _len7 = arguments.length, rest = new Array(_len7 > 1 ? _len7 - 1 : 0), _key7 = 1; _key7 < _len7; _key7++)rest[_key7 - 1] = arguments[_key7];
        return logger[type].apply(logger, [
            message
        ].concat(rest));
    };
};
once.clear = function() {
    return logged.clear();
};
once.trace = once("trace");
once.debug = once("debug");
once.info = once("info");
once.warn = once("warn");
once.error = once("error");
once.log = once("log");
var pretty = function pretty(type) {
    return function() {
        var argArray = [];
        for(var _len8 = arguments.length, args = new Array(_len8), _key8 = 0; _key8 < _len8; _key8++)args[_key8] = arguments[_key8];
        if (args.length) {
            var startTagRe = /<span\s+style=(['"])([^'"]*)\1\s*>/gi;
            var endTagRe = /<\/span>/gi;
            var reResultArray;
            argArray.push(args[0].replace(startTagRe, "%c").replace(endTagRe, "%c")); // eslint-disable-next-line no-cond-assign
            while(reResultArray = startTagRe.exec(args[0])){
                argArray.push(reResultArray[2]);
                argArray.push("");
            } // pass through subsequent args since chrome dev tools does not (yet) support console.log styling of the following form: console.log('%cBlue!', 'color: blue;', '%cRed!', 'color: red;');
            // eslint-disable-next-line no-plusplus
            for(var j = 1; j < args.length; j++)argArray.push(args[j]);
        } // eslint-disable-next-line prefer-spread
        logger[type].apply(logger, argArray);
    };
};
pretty.trace = pretty("trace");
pretty.debug = pretty("debug");
pretty.info = pretty("info");
pretty.warn = pretty("warn");
pretty.error = pretty("error");

},{"core-js/modules/es.array.concat.js":"g1t7q","core-js/modules/es.array.iterator.js":"ieU20","core-js/modules/es.object.to-string.js":"lsA9p","core-js/modules/es.set.js":"6FW6g","core-js/modules/es.string.iterator.js":"74a8v","core-js/modules/web.dom-collections.iterator.js":"aXR96","core-js/modules/es.regexp.exec.js":"5q56v","core-js/modules/es.string.replace.js":"bFiJG","global":"5PzlO","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"lOl6R":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EVENTS", ()=>(0, _instrumenter.EVENTS));
parcelHelpers.export(exports, "instrument", ()=>(0, _instrumenter.instrument));
var _instrumenter = require("./instrumenter");
var _types = require("./types");
parcelHelpers.exportAll(_types, exports);

},{"./instrumenter":"dgC9F","./types":false,"@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"dgC9F":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EVENTS", ()=>EVENTS);
parcelHelpers.export(exports, "Instrumenter", ()=>Instrumenter);
/**
 * Instruments an object or module by traversing its properties, patching any functions (methods)
 * to enable debugging. Patched functions will emit a `call` event when invoked.
 * When intercept = true, patched functions will return a Promise when the debugger stops before
 * this function. As such, "interceptable" functions will have to be `await`-ed.
 */ parcelHelpers.export(exports, "instrument", ()=>instrument);
var _esSymbolJs = require("core-js/modules/es.symbol.js");
var _esSymbolDescriptionJs = require("core-js/modules/es.symbol.description.js");
var _esSymbolIteratorJs = require("core-js/modules/es.symbol.iterator.js");
var _esSymbolToPrimitiveJs = require("core-js/modules/es.symbol.to-primitive.js");
var _esDateToPrimitiveJs = require("core-js/modules/es.date.to-primitive.js");
var _esNumberConstructorJs = require("core-js/modules/es.number.constructor.js");
var _esObjectToStringJs = require("core-js/modules/es.object.to-string.js");
var _esArrayIteratorJs = require("core-js/modules/es.array.iterator.js");
var _esMapJs = require("core-js/modules/es.map.js");
var _esStringIteratorJs = require("core-js/modules/es.string.iterator.js");
var _webDomCollectionsIteratorJs = require("core-js/modules/web.dom-collections.iterator.js");
var _esSetJs = require("core-js/modules/es.set.js");
var _esArrayFilterJs = require("core-js/modules/es.array.filter.js");
var _esArrayFromJs = require("core-js/modules/es.array.from.js");
var _esObjectAssignJs = require("core-js/modules/es.object.assign.js");
var _esArrayMapJs = require("core-js/modules/es.array.map.js");
var _esArrayFindIndexJs = require("core-js/modules/es.array.find-index.js");
var _esArraySliceJs = require("core-js/modules/es.array.slice.js");
var _esArrayFindJs = require("core-js/modules/es.array.find.js");
var _esObjectValuesJs = require("core-js/modules/es.object.values.js");
var _webDomCollectionsForEachJs = require("core-js/modules/web.dom-collections.for-each.js");
var _esObjectEntriesJs = require("core-js/modules/es.object.entries.js");
var _esObjectKeysJs = require("core-js/modules/es.object.keys.js");
var _esArrayConcatJs = require("core-js/modules/es.array.concat.js");
var _esPromiseJs = require("core-js/modules/es.promise.js");
var _esFunctionNameJs = require("core-js/modules/es.function.name.js");
var _esArrayIncludesJs = require("core-js/modules/es.array.includes.js");
var _esArraySortJs = require("core-js/modules/es.array.sort.js");
var _esStringIncludesJs = require("core-js/modules/es.string.includes.js");
var _esRegexpExecJs = require("core-js/modules/es.regexp.exec.js");
var _esStringSearchJs = require("core-js/modules/es.string.search.js");
/* eslint-disable no-underscore-dangle */ var _addons = require("@storybook/addons");
var _clientLogger = require("@storybook/client-logger");
var _coreEvents = require("@storybook/core-events");
var _global = require("global");
var _globalDefault = parcelHelpers.interopDefault(_global);
var _types = require("./types");
var _global$FEATURES;
function _typeof(obj) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var EVENTS = {
    CALL: "instrumenter/call",
    SYNC: "instrumenter/sync",
    START: "instrumenter/start",
    BACK: "instrumenter/back",
    GOTO: "instrumenter/goto",
    NEXT: "instrumenter/next",
    END: "instrumenter/end"
};
var debuggerDisabled = ((_global$FEATURES = (0, _globalDefault.default).FEATURES) === null || _global$FEATURES === void 0 ? void 0 : _global$FEATURES.interactionsDebugger) !== true;
var controlsDisabled = {
    debugger: !debuggerDisabled,
    start: false,
    back: false,
    goto: false,
    next: false,
    end: false
};
var alreadyCompletedException = new Error("This function ran after the play function completed. Did you forget to `await` it?");
var isObject = function isObject(o) {
    return Object.prototype.toString.call(o) === "[object Object]";
};
var isModule = function isModule(o) {
    return Object.prototype.toString.call(o) === "[object Module]";
};
var isInstrumentable = function isInstrumentable(o) {
    if (!isObject(o) && !isModule(o)) return false;
    if (o.constructor === undefined) return true;
    var proto = o.constructor.prototype;
    if (!isObject(proto)) return false;
    if (Object.prototype.hasOwnProperty.call(proto, "isPrototypeOf") === false) return false;
    return true;
};
var construct = function construct(obj) {
    try {
        return new obj.constructor();
    } catch (e) {
        return {};
    }
};
var getInitialState = function getInitialState() {
    return {
        renderPhase: undefined,
        isDebugging: false,
        isPlaying: false,
        isLocked: false,
        cursor: 0,
        calls: [],
        shadowCalls: [],
        callRefsByResult: new Map(),
        chainedCallIds: new Set(),
        parentId: undefined,
        playUntil: undefined,
        resolvers: {},
        syncTimeout: undefined,
        forwardedException: undefined
    };
};
var getRetainedState = function getRetainedState(state) {
    var isDebugging = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var calls = (isDebugging ? state.shadowCalls : state.calls).filter(function(call) {
        return call.retain;
    });
    if (!calls.length) return undefined;
    var callRefsByResult = new Map(Array.from(state.callRefsByResult.entries()).filter(function(_ref) {
        var _ref2 = _slicedToArray(_ref, 2), ref = _ref2[1];
        return ref.retain;
    }));
    return {
        cursor: calls.length,
        calls: calls,
        callRefsByResult: callRefsByResult
    };
};
var Instrumenter = /*#__PURE__*/ function() {
    // State is tracked per story to deal with multiple stories on the same canvas (i.e. docs mode)
    function Instrumenter() {
        var _this = this;
        _classCallCheck(this, Instrumenter);
        this.channel = void 0;
        this.initialized = false;
        this.state = void 0;
        this.channel = (0, _addons.addons).getChannel(); // Restore state from the parent window in case the iframe was reloaded.
        this.state = (0, _globalDefault.default).window.parent.__STORYBOOK_ADDON_INTERACTIONS_INSTRUMENTER_STATE__ || {}; // When called from `start`, isDebugging will be true
        var resetState = function resetState(_ref3) {
            var storyId = _ref3.storyId, _ref3$isPlaying = _ref3.isPlaying, isPlaying = _ref3$isPlaying === void 0 ? true : _ref3$isPlaying, _ref3$isDebugging = _ref3.isDebugging, isDebugging = _ref3$isDebugging === void 0 ? false : _ref3$isDebugging;
            var state = _this.getState(storyId);
            _this.setState(storyId, Object.assign({}, getInitialState(), getRetainedState(state, isDebugging), {
                shadowCalls: isDebugging ? state.shadowCalls : [],
                chainedCallIds: isDebugging ? state.chainedCallIds : new Set(),
                playUntil: isDebugging ? state.playUntil : undefined,
                isPlaying: isPlaying,
                isDebugging: isDebugging
            })); // Don't sync while debugging, as it'll cause flicker.
            if (!isDebugging) _this.sync(storyId);
        }; // A forceRemount might be triggered for debugging (on `start`), or elsewhere in Storybook.
        this.channel.on((0, _coreEvents.FORCE_REMOUNT), resetState); // Start with a clean slate before playing after a remount, and stop debugging when done.
        this.channel.on((0, _coreEvents.STORY_RENDER_PHASE_CHANGED), function(_ref4) {
            var storyId = _ref4.storyId, newPhase = _ref4.newPhase;
            var _this$getState = _this.getState(storyId), isDebugging = _this$getState.isDebugging, forwardedException = _this$getState.forwardedException;
            _this.setState(storyId, {
                renderPhase: newPhase
            });
            if (newPhase === "playing") resetState({
                storyId: storyId,
                isDebugging: isDebugging
            });
            if (newPhase === "played") {
                _this.setState(storyId, {
                    isLocked: false,
                    isPlaying: false,
                    isDebugging: false,
                    forwardedException: undefined
                }); // Rethrow any unhandled forwarded exception so it doesn't go unnoticed.
                if (forwardedException) throw forwardedException;
            }
        }); // Trash non-retained state and clear the log when switching stories, but not on initial boot.
        this.channel.on((0, _coreEvents.SET_CURRENT_STORY), function() {
            if (_this.initialized) _this.cleanup();
            else _this.initialized = true;
        });
        var start = function start(_ref5) {
            var storyId = _ref5.storyId, playUntil = _ref5.playUntil;
            if (!_this.getState(storyId).isDebugging) _this.setState(storyId, function(_ref6) {
                var calls = _ref6.calls;
                return {
                    calls: [],
                    shadowCalls: calls.map(function(call) {
                        return Object.assign({}, call, {
                            status: (0, _types.CallStates).WAITING
                        });
                    }),
                    isDebugging: true
                };
            });
            var log = _this.getLog(storyId);
            _this.setState(storyId, function(_ref7) {
                var _shadowCalls$slice$fi;
                var shadowCalls = _ref7.shadowCalls;
                var firstRowIndex = shadowCalls.findIndex(function(call) {
                    return call.id === log[0].callId;
                });
                return {
                    playUntil: playUntil || ((_shadowCalls$slice$fi = shadowCalls.slice(0, firstRowIndex).filter(function(call) {
                        return call.interceptable;
                    }).slice(-1)[0]) === null || _shadowCalls$slice$fi === void 0 ? void 0 : _shadowCalls$slice$fi.id)
                };
            }); // Force remount may trigger a page reload if the play function can't be aborted.
            _this.channel.emit((0, _coreEvents.FORCE_REMOUNT), {
                storyId: storyId,
                isDebugging: true
            });
        };
        var back = function back(_ref8) {
            var _log;
            var storyId = _ref8.storyId;
            var _this$getState2 = _this.getState(storyId), isDebugging = _this$getState2.isDebugging;
            var log = _this.getLog(storyId);
            var next = isDebugging ? log.findIndex(function(_ref9) {
                var status = _ref9.status;
                return status === (0, _types.CallStates).WAITING;
            }) : log.length;
            start({
                storyId: storyId,
                playUntil: (_log = log[next - 2]) === null || _log === void 0 ? void 0 : _log.callId
            });
        };
        var goto = function goto(_ref10) {
            var storyId = _ref10.storyId, callId = _ref10.callId;
            var _this$getState3 = _this.getState(storyId), calls = _this$getState3.calls, shadowCalls = _this$getState3.shadowCalls, resolvers = _this$getState3.resolvers;
            var call = calls.find(function(_ref11) {
                var id = _ref11.id;
                return id === callId;
            });
            var shadowCall = shadowCalls.find(function(_ref12) {
                var id = _ref12.id;
                return id === callId;
            });
            if (!call && shadowCall && Object.values(resolvers).length > 0) {
                var _this$getLog$find;
                var nextId = (_this$getLog$find = _this.getLog(storyId).find(function(c) {
                    return c.status === (0, _types.CallStates).WAITING;
                })) === null || _this$getLog$find === void 0 ? void 0 : _this$getLog$find.callId;
                if (shadowCall.id !== nextId) _this.setState(storyId, {
                    playUntil: shadowCall.id
                });
                Object.values(resolvers).forEach(function(resolve) {
                    return resolve();
                });
            } else start({
                storyId: storyId,
                playUntil: callId
            });
        };
        var next = function next(_ref13) {
            var storyId = _ref13.storyId;
            var _this$getState4 = _this.getState(storyId), resolvers = _this$getState4.resolvers;
            if (Object.values(resolvers).length > 0) Object.values(resolvers).forEach(function(resolve) {
                return resolve();
            });
            else {
                var _this$getLog$find2;
                var nextId = (_this$getLog$find2 = _this.getLog(storyId).find(function(c) {
                    return c.status === (0, _types.CallStates).WAITING;
                })) === null || _this$getLog$find2 === void 0 ? void 0 : _this$getLog$find2.callId;
                if (nextId) start({
                    storyId: storyId,
                    playUntil: nextId
                });
                else end({
                    storyId: storyId
                });
            }
        };
        var end = function end(_ref14) {
            var storyId = _ref14.storyId;
            _this.setState(storyId, {
                playUntil: undefined,
                isDebugging: false
            });
            Object.values(_this.getState(storyId).resolvers).forEach(function(resolve) {
                return resolve();
            });
        };
        this.channel.on(EVENTS.START, start);
        this.channel.on(EVENTS.BACK, back);
        this.channel.on(EVENTS.GOTO, goto);
        this.channel.on(EVENTS.NEXT, next);
        this.channel.on(EVENTS.END, end);
    }
    _createClass(Instrumenter, [
        {
            key: "getState",
            value: function getState(storyId) {
                return this.state[storyId] || getInitialState();
            }
        },
        {
            key: "setState",
            value: function setState(storyId, update) {
                var state = this.getState(storyId);
                var patch = typeof update === "function" ? update(state) : update;
                this.state = Object.assign({}, this.state, _defineProperty({}, storyId, Object.assign({}, state, patch))); // Track state on the parent window so we can reload the iframe without losing state.
                (0, _globalDefault.default).window.parent.__STORYBOOK_ADDON_INTERACTIONS_INSTRUMENTER_STATE__ = this.state;
            }
        },
        {
            key: "cleanup",
            value: function cleanup() {
                // Reset stories with retained state to their initial state, and drop the rest.
                this.state = Object.entries(this.state).reduce(function(acc, _ref15) {
                    var _ref16 = _slicedToArray(_ref15, 2), storyId = _ref16[0], state = _ref16[1];
                    var retainedState = getRetainedState(state);
                    if (!retainedState) return acc;
                    acc[storyId] = Object.assign(getInitialState(), retainedState);
                    return acc;
                }, {});
                this.channel.emit(EVENTS.SYNC, {
                    controlStates: controlsDisabled,
                    logItems: []
                });
                (0, _globalDefault.default).window.parent.__STORYBOOK_ADDON_INTERACTIONS_INSTRUMENTER_STATE__ = this.state;
            }
        },
        {
            key: "getLog",
            value: function getLog(storyId) {
                var _this$getState5 = this.getState(storyId), calls = _this$getState5.calls, shadowCalls = _this$getState5.shadowCalls;
                var merged = _toConsumableArray(shadowCalls);
                calls.forEach(function(call, index) {
                    merged[index] = call;
                });
                var seen = new Set();
                return merged.reduceRight(function(acc, call) {
                    call.args.forEach(function(arg) {
                        if (arg !== null && arg !== void 0 && arg.__callId__) seen.add(arg.__callId__);
                    });
                    call.path.forEach(function(node) {
                        if (node.__callId__) seen.add(node.__callId__);
                    });
                    if (call.interceptable && !seen.has(call.id)) {
                        acc.unshift({
                            callId: call.id,
                            status: call.status
                        });
                        seen.add(call.id);
                    }
                    return acc;
                }, []);
            } // Traverses the object structure to recursively patch all function properties.
        },
        {
            key: "instrument",
            value: function instrument(obj, options) {
                var _this2 = this;
                if (!isInstrumentable(obj)) return obj;
                var _options$mutate = options.mutate, mutate = _options$mutate === void 0 ? false : _options$mutate, _options$path = options.path, path = _options$path === void 0 ? [] : _options$path;
                return Object.keys(obj).reduce(function(acc, key) {
                    var value = obj[key]; // Nothing to patch, but might be instrumentable, so we recurse
                    if (typeof value !== "function") {
                        acc[key] = _this2.instrument(value, Object.assign({}, options, {
                            path: path.concat(key)
                        }));
                        return acc;
                    } // Already patched, so we pass through unchanged
                    if (typeof value.__originalFn__ === "function") {
                        acc[key] = value;
                        return acc;
                    } // Patch the function and mark it "patched" by adding a reference to the original function
                    acc[key] = function() {
                        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                        return _this2.track(key, value, args, options);
                    };
                    acc[key].__originalFn__ = value; // Reuse the original name as the patched function's name
                    Object.defineProperty(acc[key], "name", {
                        value: key,
                        writable: false
                    }); // Deal with functions that also act like an object
                    if (Object.keys(value).length > 0) Object.assign(acc[key], _this2.instrument(Object.assign({}, value), Object.assign({}, options, {
                        path: path.concat(key)
                    })));
                    return acc;
                }, mutate ? obj : construct(obj));
            } // Monkey patch an object method to record calls.
        },
        {
            key: "track",
            value: function track(method, fn, args, options) {
                var _args$, _global$window$__STOR, _global$window$__STOR2, _global$window$__STOR3;
                var storyId = (args === null || args === void 0 ? void 0 : (_args$ = args[0]) === null || _args$ === void 0 ? void 0 : _args$.__storyId__) || ((_global$window$__STOR = (0, _globalDefault.default).window.__STORYBOOK_PREVIEW__) === null || _global$window$__STOR === void 0 ? void 0 : (_global$window$__STOR2 = _global$window$__STOR.urlStore) === null || _global$window$__STOR2 === void 0 ? void 0 : (_global$window$__STOR3 = _global$window$__STOR2.selection) === null || _global$window$__STOR3 === void 0 ? void 0 : _global$window$__STOR3.storyId);
                var _this$getState6 = this.getState(storyId), cursor = _this$getState6.cursor, parentId = _this$getState6.parentId;
                this.setState(storyId, {
                    cursor: cursor + 1
                });
                var id = "".concat(parentId || storyId, " [").concat(cursor, "] ").concat(method);
                var _options$path2 = options.path, path = _options$path2 === void 0 ? [] : _options$path2, _options$intercept = options.intercept, intercept = _options$intercept === void 0 ? false : _options$intercept, _options$retain = options.retain, retain = _options$retain === void 0 ? false : _options$retain;
                var interceptable = typeof intercept === "function" ? intercept(method, path) : intercept;
                var call = {
                    id: id,
                    parentId: parentId,
                    storyId: storyId,
                    cursor: cursor,
                    path: path,
                    method: method,
                    args: args,
                    interceptable: interceptable,
                    retain: retain
                };
                var result = (interceptable ? this.intercept : this.invoke).call(this, fn, call, options);
                return this.instrument(result, Object.assign({}, options, {
                    mutate: true,
                    path: [
                        {
                            __callId__: call.id
                        }
                    ]
                }));
            }
        },
        {
            key: "intercept",
            value: function intercept(fn, call, options) {
                var _this3 = this;
                var _this$getState7 = this.getState(call.storyId), chainedCallIds = _this$getState7.chainedCallIds, isDebugging = _this$getState7.isDebugging, playUntil = _this$getState7.playUntil; // For a "jump to step" action, continue playing until we hit a call by that ID.
                // For chained calls, we can only return a Promise for the last call in the chain.
                var isChainedUpon = chainedCallIds.has(call.id);
                if (!isDebugging || isChainedUpon || playUntil) {
                    if (playUntil === call.id) this.setState(call.storyId, {
                        playUntil: undefined
                    });
                    return this.invoke(fn, call, options);
                } // Instead of invoking the function, defer the function call until we continue playing.
                return new Promise(function(resolve) {
                    _this3.setState(call.storyId, function(_ref17) {
                        var resolvers = _ref17.resolvers;
                        return {
                            isLocked: false,
                            resolvers: Object.assign({}, resolvers, _defineProperty({}, call.id, resolve))
                        };
                    });
                }).then(function() {
                    _this3.setState(call.storyId, function(state) {
                        var _state$resolvers = state.resolvers, _call$id = call.id, _ = _state$resolvers[_call$id], resolvers = _objectWithoutProperties(_state$resolvers, [
                            _call$id
                        ].map(_toPropertyKey));
                        return {
                            isLocked: true,
                            resolvers: resolvers
                        };
                    });
                    return _this3.invoke(fn, call, options);
                });
            }
        },
        {
            key: "invoke",
            value: function invoke(fn, call, options) {
                var _this4 = this;
                // TODO this doesnt work because the abortSignal we have here is the newly created one
                // const { abortSignal } = global.window.__STORYBOOK_PREVIEW__ || {};
                // if (abortSignal && abortSignal.aborted) throw IGNORED_EXCEPTION;
                var _this$getState8 = this.getState(call.storyId), callRefsByResult = _this$getState8.callRefsByResult, forwardedException = _this$getState8.forwardedException, renderPhase = _this$getState8.renderPhase;
                var info = Object.assign({}, call, {
                    // Map args that originate from a tracked function call to a call reference to enable nesting.
                    // These values are often not fully serializable anyway (e.g. HTML elements).
                    args: call.args.map(function(arg) {
                        if (callRefsByResult.has(arg)) return callRefsByResult.get(arg);
                        if (arg instanceof (0, _globalDefault.default).window.HTMLElement) {
                            var prefix = arg.prefix, localName = arg.localName, id = arg.id, classList = arg.classList, innerText = arg.innerText;
                            var classNames = Array.from(classList);
                            return {
                                __element__: {
                                    prefix: prefix,
                                    localName: localName,
                                    id: id,
                                    classNames: classNames,
                                    innerText: innerText
                                }
                            };
                        }
                        return arg;
                    })
                }); // Mark any ancestor calls as "chained upon" so we won't attempt to defer it later.
                call.path.forEach(function(ref) {
                    if (ref !== null && ref !== void 0 && ref.__callId__) _this4.setState(call.storyId, function(_ref18) {
                        var chainedCallIds = _ref18.chainedCallIds;
                        return {
                            chainedCallIds: new Set(Array.from(chainedCallIds).concat(ref.__callId__))
                        };
                    });
                });
                var handleException = function handleException(e) {
                    if (e instanceof Error) {
                        var name = e.name, message = e.message, stack = e.stack;
                        var exception = {
                            name: name,
                            message: message,
                            stack: stack
                        };
                        _this4.update(Object.assign({}, info, {
                            status: (0, _types.CallStates).ERROR,
                            exception: exception
                        })); // Always track errors to their originating call.
                        _this4.setState(call.storyId, function(state) {
                            return {
                                callRefsByResult: new Map([].concat(_toConsumableArray(Array.from(state.callRefsByResult.entries())), [
                                    [
                                        e,
                                        {
                                            __callId__: call.id,
                                            retain: call.retain
                                        }
                                    ]
                                ]))
                            };
                        }); // We need to throw to break out of the play function, but we don't want to trigger a redbox
                        // so we throw an ignoredException, which is caught and silently ignored by Storybook.
                        if (call.interceptable && e !== alreadyCompletedException) throw 0, _coreEvents.IGNORED_EXCEPTION;
                         // Non-interceptable calls need their exceptions forwarded to the next interceptable call.
                        // In case no interceptable call picks it up, it'll get rethrown in the "completed" phase.
                        _this4.setState(call.storyId, {
                            forwardedException: e
                        });
                        return e;
                    }
                    throw e;
                };
                try {
                    // An earlier, non-interceptable call might have forwarded an exception.
                    if (forwardedException) {
                        this.setState(call.storyId, {
                            forwardedException: undefined
                        });
                        throw forwardedException;
                    }
                    if (renderPhase === "played" && !call.retain) throw alreadyCompletedException;
                    var finalArgs = options.getArgs ? options.getArgs(call, this.getState(call.storyId)) : call.args;
                    var result = fn.apply(void 0, _toConsumableArray(finalArgs.map(function(arg) {
                        if (typeof arg !== "function" || Object.keys(arg).length) return arg;
                        return function() {
                            var _this4$getState = _this4.getState(call.storyId), cursor = _this4$getState.cursor, parentId = _this4$getState.parentId;
                            _this4.setState(call.storyId, {
                                cursor: 0,
                                parentId: call.id
                            });
                            var restore = function restore() {
                                return _this4.setState(call.storyId, {
                                    cursor: cursor,
                                    parentId: parentId
                                });
                            };
                            var res = arg.apply(void 0, arguments);
                            if (res instanceof Promise) res.then(restore, restore);
                            else restore();
                            return res;
                        };
                    }))); // Track the result so we can trace later uses of it back to the originating call.
                    // Primitive results (undefined, null, boolean, string, number, BigInt) are ignored.
                    if (result && [
                        "object",
                        "function",
                        "symbol"
                    ].includes(_typeof(result))) this.setState(call.storyId, function(state) {
                        return {
                            callRefsByResult: new Map([].concat(_toConsumableArray(Array.from(state.callRefsByResult.entries())), [
                                [
                                    result,
                                    {
                                        __callId__: call.id,
                                        retain: call.retain
                                    }
                                ]
                            ]))
                        };
                    });
                    this.update(Object.assign({}, info, {
                        status: result instanceof Promise ? (0, _types.CallStates).ACTIVE : (0, _types.CallStates).DONE
                    }));
                    if (result instanceof Promise) return result.then(function(value) {
                        _this4.update(Object.assign({}, info, {
                            status: (0, _types.CallStates).DONE
                        }));
                        return value;
                    }, handleException);
                    return result;
                } catch (e) {
                    return handleException(e);
                }
            } // Sends the call info and log to the manager.
        },
        {
            key: "update",
            value: function update(call) {
                var _this5 = this;
                clearTimeout(this.getState(call.storyId).syncTimeout);
                this.channel.emit(EVENTS.CALL, call);
                this.setState(call.storyId, function(_ref19) {
                    var calls = _ref19.calls;
                    // Omit earlier calls for the same ID, which may have been superceded by a later invocation.
                    // This typically happens when calls are part of a callback which runs multiple times.
                    var callsById = calls.concat(call).reduce(function(a, c) {
                        return Object.assign(a, _defineProperty({}, c.id, c));
                    }, {});
                    return {
                        // Calls are sorted to ensure parent calls always come before calls in their callback.
                        calls: Object.values(callsById).sort(function(a, b) {
                            return a.id.localeCompare(b.id, undefined, {
                                numeric: true
                            });
                        }),
                        syncTimeout: setTimeout(function() {
                            return _this5.sync(call.storyId);
                        }, 0)
                    };
                });
            }
        },
        {
            key: "sync",
            value: function sync(storyId) {
                var _this$getState9 = this.getState(storyId), isLocked = _this$getState9.isLocked, isPlaying = _this$getState9.isPlaying;
                var logItems = this.getLog(storyId);
                var hasActive = logItems.some(function(item) {
                    return item.status === (0, _types.CallStates).ACTIVE;
                });
                if (debuggerDisabled || isLocked || hasActive || logItems.length === 0) {
                    this.channel.emit(EVENTS.SYNC, {
                        controlStates: controlsDisabled,
                        logItems: logItems
                    });
                    return;
                }
                var hasPrevious = logItems.some(function(item) {
                    return [
                        (0, _types.CallStates).DONE,
                        (0, _types.CallStates).ERROR
                    ].includes(item.status);
                });
                var controlStates = {
                    debugger: true,
                    start: hasPrevious,
                    back: hasPrevious,
                    goto: true,
                    next: isPlaying,
                    end: isPlaying
                };
                this.channel.emit(EVENTS.SYNC, {
                    controlStates: controlStates,
                    logItems: logItems
                });
            }
        }
    ]);
    return Instrumenter;
}();
function instrument(obj) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    try {
        var _global$window$locati, _global$window$locati2, _global$window$locati3, _global$window$locati4;
        var forceInstrument = false;
        var skipInstrument = false;
        if (((_global$window$locati = (0, _globalDefault.default).window.location) === null || _global$window$locati === void 0 ? void 0 : (_global$window$locati2 = _global$window$locati.search) === null || _global$window$locati2 === void 0 ? void 0 : _global$window$locati2.indexOf("instrument=true")) !== -1) forceInstrument = true;
        else if (((_global$window$locati3 = (0, _globalDefault.default).window.location) === null || _global$window$locati3 === void 0 ? void 0 : (_global$window$locati4 = _global$window$locati3.search) === null || _global$window$locati4 === void 0 ? void 0 : _global$window$locati4.indexOf("instrument=false")) !== -1) skipInstrument = true;
         // Don't do any instrumentation if not loaded in an iframe unless it's forced - instrumentation can also be skipped.
        if ((0, _globalDefault.default).window.parent === (0, _globalDefault.default).window && !forceInstrument || skipInstrument) return obj;
         // Only create an instance if we don't have one (singleton) yet.
        if (!(0, _globalDefault.default).window.__STORYBOOK_ADDON_INTERACTIONS_INSTRUMENTER__) (0, _globalDefault.default).window.__STORYBOOK_ADDON_INTERACTIONS_INSTRUMENTER__ = new Instrumenter();
        var instrumenter = (0, _globalDefault.default).window.__STORYBOOK_ADDON_INTERACTIONS_INSTRUMENTER__;
        return instrumenter.instrument(obj, options);
    } catch (e) {
        // Access to the parent window might fail due to CORS restrictions.
        (0, _clientLogger.once).warn(e);
        return obj;
    }
}

},{"core-js/modules/es.symbol.js":"ajw2f","core-js/modules/es.symbol.description.js":"wrlLc","core-js/modules/es.symbol.iterator.js":"fhNIb","core-js/modules/es.symbol.to-primitive.js":"2DRNy","core-js/modules/es.date.to-primitive.js":"4mzZp","core-js/modules/es.number.constructor.js":"hVD7l","core-js/modules/es.object.to-string.js":"lsA9p","core-js/modules/es.array.iterator.js":"ieU20","core-js/modules/es.map.js":"bbbTA","core-js/modules/es.string.iterator.js":"74a8v","core-js/modules/web.dom-collections.iterator.js":"aXR96","core-js/modules/es.set.js":"6FW6g","core-js/modules/es.array.filter.js":"fD2da","core-js/modules/es.array.from.js":"9UCQw","core-js/modules/es.object.assign.js":"8FU8M","core-js/modules/es.array.map.js":"jTP7e","core-js/modules/es.array.find-index.js":"SckaK","core-js/modules/es.array.slice.js":"8RRh9","core-js/modules/es.array.find.js":"hWBPu","core-js/modules/es.object.values.js":"bB8XB","core-js/modules/web.dom-collections.for-each.js":"iYT1M","core-js/modules/es.object.entries.js":"7Wf79","core-js/modules/es.object.keys.js":"5Q2AT","core-js/modules/es.array.concat.js":"g1t7q","core-js/modules/es.promise.js":"2jax7","core-js/modules/es.function.name.js":"4LiLL","core-js/modules/es.array.includes.js":"dbUjS","core-js/modules/es.array.sort.js":"eO5d0","core-js/modules/es.string.includes.js":"cx9ET","core-js/modules/es.regexp.exec.js":"5q56v","core-js/modules/es.string.search.js":"l1Pph","@storybook/addons":"eHH6R","@storybook/client-logger":"6rq9J","@storybook/core-events":"gacRk","global":"5PzlO","./types":"nvqZ9","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"2DRNy":[function(require,module,exports) {
var defineWellKnownSymbol = require("b60c854ffe7b0afe");
// `Symbol.toPrimitive` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.toprimitive
defineWellKnownSymbol("toPrimitive");

},{"b60c854ffe7b0afe":"jltxQ"}],"4mzZp":[function(require,module,exports) {
var hasOwn = require("af14b1f4d994a127");
var redefine = require("b87cbaec2564f431");
var dateToPrimitive = require("5ca81c5eeb540a34");
var wellKnownSymbol = require("5e5f3eb0bfd879e9");
var TO_PRIMITIVE = wellKnownSymbol("toPrimitive");
var DatePrototype = Date.prototype;
// `Date.prototype[@@toPrimitive]` method
// https://tc39.es/ecma262/#sec-date.prototype-@@toprimitive
if (!hasOwn(DatePrototype, TO_PRIMITIVE)) redefine(DatePrototype, TO_PRIMITIVE, dateToPrimitive);

},{"af14b1f4d994a127":"4SzRl","b87cbaec2564f431":"3ncOy","5ca81c5eeb540a34":"j6aFV","5e5f3eb0bfd879e9":"kbsMI"}],"j6aFV":[function(require,module,exports) {
"use strict";
var global = require("4ec82d8b97d3c1e6");
var anObject = require("38c74c72615b5acf");
var ordinaryToPrimitive = require("474ad3f08d0bd65b");
var TypeError = global.TypeError;
// `Date.prototype[@@toPrimitive](hint)` method implementation
// https://tc39.es/ecma262/#sec-date.prototype-@@toprimitive
module.exports = function(hint) {
    anObject(this);
    if (hint === "string" || hint === "default") hint = "string";
    else if (hint !== "number") throw TypeError("Incorrect hint");
    return ordinaryToPrimitive(this, hint);
};

},{"4ec82d8b97d3c1e6":"1GZc4","38c74c72615b5acf":"39qAm","474ad3f08d0bd65b":"bLKgc"}],"eHH6R":[function(require,module,exports) {
// There can only be 1 default export per entry point and it has to be directly from public_api
// Exporting this twice in order to to be able to import it like { addons } instead of 'addons'
// prefer import { addons } from '@storybook/addons' over import addons from '@storybook/addons'
//
// See index.ts
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _index = require("./index");
var _makeDecorator = require("./make-decorator");
parcelHelpers.exportAll(_makeDecorator, exports);
parcelHelpers.exportAll(_index, exports);
var _types = require("./types");
parcelHelpers.exportAll(_types, exports);
var _storybookChannelMock = require("./storybook-channel-mock");
parcelHelpers.exportAll(_storybookChannelMock, exports);
var _hooks = require("./hooks");
parcelHelpers.exportAll(_hooks, exports);
exports.default = (0, _index.addons);

},{"./index":"jIrtU","./make-decorator":"2z3NN","./types":"kY0SI","./storybook-channel-mock":"9FcrO","./hooks":"2VgtV","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"jIrtU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Channel", ()=>(0, _channels.Channel));
parcelHelpers.export(exports, "AddonStore", ()=>AddonStore);
parcelHelpers.export(exports, "addons", ()=>addons);
var _esObjectAssignJs = require("core-js/modules/es.object.assign.js");
var _esObjectToStringJs = require("core-js/modules/es.object.to-string.js");
var _webDomCollectionsForEachJs = require("core-js/modules/web.dom-collections.for-each.js");
var _esObjectValuesJs = require("core-js/modules/es.object.values.js");
var _esPromiseJs = require("core-js/modules/es.promise.js");
var _global = require("global");
var _globalDefault = parcelHelpers.interopDefault(_global);
var _channels = require("@storybook/channels");
var _clientLogger = require("@storybook/client-logger");
var _storybookChannelMock = require("./storybook-channel-mock");
var _types = require("./types");
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
var AddonStore = /*#__PURE__*/ _createClass(function AddonStore() {
    var _this = this;
    _classCallCheck(this, AddonStore);
    this.loaders = {};
    this.elements = {};
    this.config = {};
    this.channel = void 0;
    this.serverChannel = void 0;
    this.promise = void 0;
    this.resolve = void 0;
    this.getChannel = function() {
        // this.channel should get overwritten by setChannel. If it wasn't called (e.g. in non-browser environment), set a mock instead.
        if (!_this.channel) _this.setChannel((0, _storybookChannelMock.mockChannel)());
        return _this.channel;
    };
    this.getServerChannel = function() {
        if (!_this.serverChannel) throw new Error("Accessing non-existent serverChannel");
        return _this.serverChannel;
    };
    this.ready = function() {
        return _this.promise;
    };
    this.hasChannel = function() {
        return !!_this.channel;
    };
    this.hasServerChannel = function() {
        return !!_this.serverChannel;
    };
    this.setChannel = function(channel) {
        _this.channel = channel;
        _this.resolve();
    };
    this.setServerChannel = function(channel) {
        _this.serverChannel = channel;
    };
    this.getElements = function(type) {
        if (!_this.elements[type]) _this.elements[type] = {};
        return _this.elements[type];
    };
    this.addPanel = function(name, options) {
        _this.add(name, Object.assign({
            type: (0, _types.types).PANEL
        }, options));
    };
    this.add = function(name, addon) {
        var type = addon.type;
        var collection = _this.getElements(type);
        collection[name] = Object.assign({
            id: name
        }, addon);
    };
    this.setConfig = function(value) {
        Object.assign(_this.config, value);
    };
    this.getConfig = function() {
        return _this.config;
    };
    this.register = function(name, registerCallback) {
        if (_this.loaders[name]) (0, _clientLogger.logger).warn("".concat(name, " was loaded twice, this could have bad side-effects"));
        _this.loaders[name] = registerCallback;
    };
    this.loadAddons = function(api) {
        Object.values(_this.loaders).forEach(function(value) {
            return value(api);
        });
    };
    this.promise = new Promise(function(res) {
        _this.resolve = function() {
            return res(_this.getChannel());
        };
    });
}); // Enforce addons store to be a singleton
var KEY = "__STORYBOOK_ADDONS";
function getAddonsStore() {
    if (!(0, _globalDefault.default)[KEY]) (0, _globalDefault.default)[KEY] = new AddonStore();
    return (0, _globalDefault.default)[KEY];
} // Exporting this twice in order to to be able to import it like { addons } instead of 'addons'
var addons = getAddonsStore();

},{"core-js/modules/es.object.assign.js":"8FU8M","core-js/modules/es.object.to-string.js":"lsA9p","core-js/modules/web.dom-collections.for-each.js":"iYT1M","core-js/modules/es.object.values.js":"bB8XB","core-js/modules/es.promise.js":"2jax7","global":"5PzlO","@storybook/channels":"jwxa4","@storybook/client-logger":"6rq9J","./storybook-channel-mock":"9FcrO","./types":"kY0SI","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"jwxa4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Channel", ()=>Channel);
var _esObjectFreezeJs = require("core-js/modules/es.object.freeze.js");
var _esArraySliceJs = require("core-js/modules/es.array.slice.js");
var _esObjectToStringJs = require("core-js/modules/es.object.to-string.js");
var _esRegexpToStringJs = require("core-js/modules/es.regexp.to-string.js");
var _webImmediateJs = require("core-js/modules/web.immediate.js");
var _esObjectKeysJs = require("core-js/modules/es.object.keys.js");
var _esArrayFilterJs = require("core-js/modules/es.array.filter.js");
var _webDomCollectionsForEachJs = require("core-js/modules/web.dom-collections.for-each.js");
var _utilDeprecate = require("util-deprecate");
var _utilDeprecateDefault = parcelHelpers.interopDefault(_utilDeprecate);
var _tsDedent = require("ts-dedent");
var _tsDedentDefault = parcelHelpers.interopDefault(_tsDedent);
var _templateObject;
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) raw = strings.slice(0);
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
var generateRandomId = function generateRandomId() {
    // generates a random 13 character string
    return Math.random().toString(16).slice(2);
};
var Channel = /*#__PURE__*/ function() {
    function Channel() {
        var _this = this;
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, transport = _ref.transport, _ref$async = _ref.async, async = _ref$async === void 0 ? false : _ref$async;
        _classCallCheck(this, Channel);
        this.isAsync = void 0;
        this.sender = generateRandomId();
        this.events = {};
        this.data = {};
        this.transport = undefined;
        this.addPeerListener = (0, _utilDeprecateDefault.default)(function(eventName, listener) {
            _this.addListener(eventName, listener);
        }, (0, _tsDedentDefault.default)(_templateObject || (_templateObject = _taggedTemplateLiteral([
            "\n      channel.addPeerListener is deprecated\n    "
        ]))));
        this.isAsync = async;
        if (transport) {
            this.transport = transport;
            this.transport.setHandler(function(event) {
                return _this.handleEvent(event);
            });
        }
    }
    _createClass(Channel, [
        {
            key: "hasTransport",
            get: function get() {
                return !!this.transport;
            }
        },
        {
            key: "addListener",
            value: function addListener(eventName, listener) {
                this.events[eventName] = this.events[eventName] || [];
                this.events[eventName].push(listener);
            }
        },
        {
            key: "emit",
            value: function emit(eventName) {
                var _this2 = this;
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
                var event = {
                    type: eventName,
                    args: args,
                    from: this.sender
                };
                var options = {};
                if (args.length >= 1 && args[0] && args[0].options) options = args[0].options;
                var handler = function handler() {
                    if (_this2.transport) _this2.transport.send(event, options);
                    _this2.handleEvent(event);
                };
                if (this.isAsync) // todo I'm not sure how to test this
                setImmediate(handler);
                else handler();
            }
        },
        {
            key: "last",
            value: function last(eventName) {
                return this.data[eventName];
            }
        },
        {
            key: "eventNames",
            value: function eventNames() {
                return Object.keys(this.events);
            }
        },
        {
            key: "listenerCount",
            value: function listenerCount(eventName) {
                var listeners = this.listeners(eventName);
                return listeners ? listeners.length : 0;
            }
        },
        {
            key: "listeners",
            value: function listeners(eventName) {
                var listeners = this.events[eventName];
                return listeners || undefined;
            }
        },
        {
            key: "once",
            value: function once(eventName, listener) {
                var onceListener = this.onceListener(eventName, listener);
                this.addListener(eventName, onceListener);
            }
        },
        {
            key: "removeAllListeners",
            value: function removeAllListeners(eventName) {
                if (!eventName) this.events = {};
                else if (this.events[eventName]) delete this.events[eventName];
            }
        },
        {
            key: "removeListener",
            value: function removeListener(eventName, listener) {
                var listeners = this.listeners(eventName);
                if (listeners) this.events[eventName] = listeners.filter(function(l) {
                    return l !== listener;
                });
            }
        },
        {
            key: "on",
            value: function on(eventName, listener) {
                this.addListener(eventName, listener);
            }
        },
        {
            key: "off",
            value: function off(eventName, listener) {
                this.removeListener(eventName, listener);
            }
        },
        {
            key: "handleEvent",
            value: function handleEvent(event) {
                var listeners = this.listeners(event.type);
                if (listeners && listeners.length) listeners.forEach(function(fn) {
                    fn.apply(event, event.args);
                });
                this.data[event.type] = event.args;
            }
        },
        {
            key: "onceListener",
            value: function onceListener(eventName, listener) {
                var _this3 = this;
                var onceListener = function onceListener() {
                    _this3.removeListener(eventName, onceListener);
                    return listener.apply(void 0, arguments);
                };
                return onceListener;
            }
        }
    ]);
    return Channel;
}();
exports.default = Channel;

},{"core-js/modules/es.object.freeze.js":"9LVYO","core-js/modules/es.array.slice.js":"8RRh9","core-js/modules/es.object.to-string.js":"lsA9p","core-js/modules/es.regexp.to-string.js":"bGzly","core-js/modules/web.immediate.js":"9PmDy","core-js/modules/es.object.keys.js":"5Q2AT","core-js/modules/es.array.filter.js":"fD2da","core-js/modules/web.dom-collections.for-each.js":"iYT1M","util-deprecate":"lYmRJ","ts-dedent":"9RvVa","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"6rq9J":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "logger", ()=>logger);
parcelHelpers.export(exports, "once", ()=>once);
parcelHelpers.export(exports, "pretty", ()=>pretty);
var _esArrayConcatJs = require("core-js/modules/es.array.concat.js");
var _esArrayIteratorJs = require("core-js/modules/es.array.iterator.js");
var _esObjectToStringJs = require("core-js/modules/es.object.to-string.js");
var _esSetJs = require("core-js/modules/es.set.js");
var _esStringIteratorJs = require("core-js/modules/es.string.iterator.js");
var _webDomCollectionsIteratorJs = require("core-js/modules/web.dom-collections.iterator.js");
var _esRegexpExecJs = require("core-js/modules/es.regexp.exec.js");
var _esStringReplaceJs = require("core-js/modules/es.string.replace.js");
var _global = require("global");
var _globalDefault = parcelHelpers.interopDefault(_global);
var LOGLEVEL = (0, _globalDefault.default).LOGLEVEL, console = (0, _globalDefault.default).console;
var levels = {
    trace: 1,
    debug: 2,
    info: 3,
    warn: 4,
    error: 5,
    silent: 10
};
var currentLogLevelString = LOGLEVEL;
var currentLogLevelNumber = levels[currentLogLevelString] || levels.info;
var logger = {
    trace: function trace(message) {
        for(var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)rest[_key - 1] = arguments[_key];
        return currentLogLevelNumber <= levels.trace && console.trace.apply(console, [
            message
        ].concat(rest));
    },
    debug: function debug(message) {
        for(var _len2 = arguments.length, rest = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)rest[_key2 - 1] = arguments[_key2];
        return currentLogLevelNumber <= levels.debug && console.debug.apply(console, [
            message
        ].concat(rest));
    },
    info: function info(message) {
        for(var _len3 = arguments.length, rest = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)rest[_key3 - 1] = arguments[_key3];
        return currentLogLevelNumber <= levels.info && console.info.apply(console, [
            message
        ].concat(rest));
    },
    warn: function warn(message) {
        for(var _len4 = arguments.length, rest = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++)rest[_key4 - 1] = arguments[_key4];
        return currentLogLevelNumber <= levels.warn && console.warn.apply(console, [
            message
        ].concat(rest));
    },
    error: function error(message) {
        for(var _len5 = arguments.length, rest = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++)rest[_key5 - 1] = arguments[_key5];
        return currentLogLevelNumber <= levels.error && console.error.apply(console, [
            message
        ].concat(rest));
    },
    log: function log(message) {
        for(var _len6 = arguments.length, rest = new Array(_len6 > 1 ? _len6 - 1 : 0), _key6 = 1; _key6 < _len6; _key6++)rest[_key6 - 1] = arguments[_key6];
        return currentLogLevelNumber < levels.silent && console.log.apply(console, [
            message
        ].concat(rest));
    }
};
var logged = new Set();
var once = function once(type) {
    return function(message) {
        if (logged.has(message)) return undefined;
        logged.add(message);
        for(var _len7 = arguments.length, rest = new Array(_len7 > 1 ? _len7 - 1 : 0), _key7 = 1; _key7 < _len7; _key7++)rest[_key7 - 1] = arguments[_key7];
        return logger[type].apply(logger, [
            message
        ].concat(rest));
    };
};
once.clear = function() {
    return logged.clear();
};
once.trace = once("trace");
once.debug = once("debug");
once.info = once("info");
once.warn = once("warn");
once.error = once("error");
once.log = once("log");
var pretty = function pretty(type) {
    return function() {
        var argArray = [];
        for(var _len8 = arguments.length, args = new Array(_len8), _key8 = 0; _key8 < _len8; _key8++)args[_key8] = arguments[_key8];
        if (args.length) {
            var startTagRe = /<span\s+style=(['"])([^'"]*)\1\s*>/gi;
            var endTagRe = /<\/span>/gi;
            var reResultArray;
            argArray.push(args[0].replace(startTagRe, "%c").replace(endTagRe, "%c")); // eslint-disable-next-line no-cond-assign
            while(reResultArray = startTagRe.exec(args[0])){
                argArray.push(reResultArray[2]);
                argArray.push("");
            } // pass through subsequent args since chrome dev tools does not (yet) support console.log styling of the following form: console.log('%cBlue!', 'color: blue;', '%cRed!', 'color: red;');
            // eslint-disable-next-line no-plusplus
            for(var j = 1; j < args.length; j++)argArray.push(args[j]);
        } // eslint-disable-next-line prefer-spread
        logger[type].apply(logger, argArray);
    };
};
pretty.trace = pretty("trace");
pretty.debug = pretty("debug");
pretty.info = pretty("info");
pretty.warn = pretty("warn");
pretty.error = pretty("error");

},{"core-js/modules/es.array.concat.js":"g1t7q","core-js/modules/es.array.iterator.js":"ieU20","core-js/modules/es.object.to-string.js":"lsA9p","core-js/modules/es.set.js":"6FW6g","core-js/modules/es.string.iterator.js":"74a8v","core-js/modules/web.dom-collections.iterator.js":"aXR96","core-js/modules/es.regexp.exec.js":"5q56v","core-js/modules/es.string.replace.js":"bFiJG","global":"5PzlO","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"9FcrO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mockChannel", ()=>mockChannel);
var _channels = require("@storybook/channels");
var _channelsDefault = parcelHelpers.interopDefault(_channels);
function mockChannel() {
    var transport = {
        setHandler: function setHandler() {},
        send: function send() {}
    };
    return new (0, _channelsDefault.default)({
        transport: transport
    });
}

},{"@storybook/channels":"jwxa4","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"kY0SI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "types", ()=>types);
parcelHelpers.export(exports, "isSupportedType", ()=>isSupportedType);
var _esArrayFindJs = require("core-js/modules/es.array.find.js");
var _esObjectToStringJs = require("core-js/modules/es.object.to-string.js");
var _esObjectValuesJs = require("core-js/modules/es.object.values.js");
var types;
(function(types) {
    types["TAB"] = "tab";
    types["PANEL"] = "panel";
    types["TOOL"] = "tool";
    types["TOOLEXTRA"] = "toolextra";
    types["PREVIEW"] = "preview";
    types["NOTES_ELEMENT"] = "notes-element";
})(types || (types = {}));
function isSupportedType(type) {
    return !!Object.values(types).find(function(typeVal) {
        return typeVal === type;
    });
}

},{"core-js/modules/es.array.find.js":"hWBPu","core-js/modules/es.object.to-string.js":"lsA9p","core-js/modules/es.object.values.js":"bB8XB","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"2z3NN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "makeDecorator", ()=>makeDecorator);
var _esFunctionNameJs = require("core-js/modules/es.function.name.js");
var _esArrayConcatJs = require("core-js/modules/es.array.concat.js");
var makeDecorator = function makeDecorator(_ref) {
    var name = _ref.name, parameterName = _ref.parameterName, wrapper = _ref.wrapper, _ref$skipIfNoParamete = _ref.skipIfNoParametersOrOptions, skipIfNoParametersOrOptions = _ref$skipIfNoParamete === void 0 ? false : _ref$skipIfNoParamete;
    var decorator = function decorator(options) {
        return function(storyFn, context) {
            var parameters = context.parameters && context.parameters[parameterName];
            if (parameters && parameters.disable) return storyFn(context);
            if (skipIfNoParametersOrOptions && !options && !parameters) return storyFn(context);
            return wrapper(storyFn, context, {
                options: options,
                parameters: parameters
            });
        };
    };
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        // Used without options as .addDecorator(decorator)
        if (typeof args[0] === "function") return decorator().apply(void 0, args);
        return function() {
            // Used as [.]addDecorator(decorator(options))
            if (arguments.length > 1) {
                // Used as [.]addDecorator(decorator(option1, option2))
                if (args.length > 1) return decorator(args).apply(void 0, arguments);
                return decorator.apply(void 0, args).apply(void 0, arguments);
            }
            throw new Error("Passing stories directly into ".concat(name, "() is not allowed,\n        instead use addDecorator(").concat(name, ") and pass options with the '").concat(parameterName, "' parameter"));
        };
    };
};

},{"core-js/modules/es.function.name.js":"4LiLL","core-js/modules/es.array.concat.js":"g1t7q","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"2VgtV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HooksContext", ()=>HooksContext);
parcelHelpers.export(exports, "applyHooks", ()=>applyHooks);
/* Returns a memoized value, see https://reactjs.org/docs/hooks-reference.html#usememo */ parcelHelpers.export(exports, "useMemo", ()=>useMemo);
/* Returns a memoized callback, see https://reactjs.org/docs/hooks-reference.html#usecallback */ parcelHelpers.export(exports, "useCallback", ()=>useCallback);
/* Returns a mutable ref object, see https://reactjs.org/docs/hooks-reference.html#useref */ parcelHelpers.export(exports, "useRef", ()=>useRef);
/* Returns a stateful value, and a function to update it, see https://reactjs.org/docs/hooks-reference.html#usestate */ parcelHelpers.export(exports, "useState", ()=>useState);
/* A redux-like alternative to useState, see https://reactjs.org/docs/hooks-reference.html#usereducer */ parcelHelpers.export(exports, "useReducer", ()=>useReducer);
/*
  Triggers a side effect, see https://reactjs.org/docs/hooks-reference.html#usestate
  Effects are triggered synchronously after rendering the story
*/ parcelHelpers.export(exports, "useEffect", ()=>useEffect);
/* Accepts a map of Storybook channel event listeners, returns an emit function */ parcelHelpers.export(exports, "useChannel", ()=>useChannel);
/* Returns current story context */ parcelHelpers.export(exports, "useStoryContext", ()=>useStoryContext);
/* Returns current value of a story parameter */ parcelHelpers.export(exports, "useParameter", ()=>useParameter);
/* Returns current value of story args */ parcelHelpers.export(exports, "useArgs", ()=>useArgs);
/* Returns current value of global args */ parcelHelpers.export(exports, "useGlobals", ()=>useGlobals);
var _esArrayIteratorJs = require("core-js/modules/es.array.iterator.js");
var _esObjectToStringJs = require("core-js/modules/es.object.to-string.js");
var _esStringIteratorJs = require("core-js/modules/es.string.iterator.js");
var _esWeakMapJs = require("core-js/modules/es.weak-map.js");
var _webDomCollectionsIteratorJs = require("core-js/modules/web.dom-collections.iterator.js");
var _esSetJs = require("core-js/modules/es.set.js");
var _webDomCollectionsForEachJs = require("core-js/modules/web.dom-collections.for-each.js");
var _esArrayIncludesJs = require("core-js/modules/es.array.includes.js");
var _esStringIncludesJs = require("core-js/modules/es.string.includes.js");
var _esFunctionNameJs = require("core-js/modules/es.function.name.js");
var _esArrayMapJs = require("core-js/modules/es.array.map.js");
var _esArrayConcatJs = require("core-js/modules/es.array.concat.js");
var _esObjectEntriesJs = require("core-js/modules/es.object.entries.js");
var _esObjectKeysJs = require("core-js/modules/es.object.keys.js");
var _esSymbolJs = require("core-js/modules/es.symbol.js");
var _esSymbolDescriptionJs = require("core-js/modules/es.symbol.description.js");
var _esSymbolIteratorJs = require("core-js/modules/es.symbol.iterator.js");
var _esArrayFromJs = require("core-js/modules/es.array.from.js");
var _esArraySliceJs = require("core-js/modules/es.array.slice.js");
var _esRegexpExecJs = require("core-js/modules/es.regexp.exec.js");
var _global = require("global");
var _globalDefault = parcelHelpers.interopDefault(_global);
var _clientLogger = require("@storybook/client-logger");
var _coreEvents = require("@storybook/core-events");
var _index = require("./index");
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
var globalWindow = (0, _globalDefault.default).window;
var HooksContext = /*#__PURE__*/ function() {
    function HooksContext() {
        var _this = this;
        _classCallCheck(this, HooksContext);
        this.hookListsMap = void 0;
        this.mountedDecorators = void 0;
        this.prevMountedDecorators = void 0;
        this.currentHooks = void 0;
        this.nextHookIndex = void 0;
        this.currentPhase = void 0;
        this.currentEffects = void 0;
        this.prevEffects = void 0;
        this.currentDecoratorName = void 0;
        this.hasUpdates = void 0;
        this.currentContext = void 0;
        this.renderListener = function(storyId) {
            if (storyId !== _this.currentContext.id) return;
            _this.triggerEffects();
            _this.currentContext = null;
            _this.removeRenderListeners();
        };
        this.init();
    }
    _createClass(HooksContext, [
        {
            key: "init",
            value: function init() {
                this.hookListsMap = new WeakMap();
                this.mountedDecorators = new Set();
                this.prevMountedDecorators = this.mountedDecorators;
                this.currentHooks = [];
                this.nextHookIndex = 0;
                this.currentPhase = "NONE";
                this.currentEffects = [];
                this.prevEffects = [];
                this.currentDecoratorName = null;
                this.hasUpdates = false;
                this.currentContext = null;
            }
        },
        {
            key: "clean",
            value: function clean() {
                this.prevEffects.forEach(function(effect) {
                    if (effect.destroy) effect.destroy();
                });
                this.init();
                this.removeRenderListeners();
            }
        },
        {
            key: "getNextHook",
            value: function getNextHook() {
                var hook = this.currentHooks[this.nextHookIndex];
                this.nextHookIndex += 1;
                return hook;
            }
        },
        {
            key: "triggerEffects",
            value: function triggerEffects() {
                var _this2 = this;
                // destroy removed effects
                this.prevEffects.forEach(function(effect) {
                    if (!_this2.currentEffects.includes(effect) && effect.destroy) effect.destroy();
                }); // trigger added effects
                this.currentEffects.forEach(function(effect) {
                    if (!_this2.prevEffects.includes(effect)) // eslint-disable-next-line no-param-reassign
                    effect.destroy = effect.create();
                });
                this.prevEffects = this.currentEffects;
                this.currentEffects = [];
            }
        },
        {
            key: "addRenderListeners",
            value: function addRenderListeners() {
                this.removeRenderListeners();
                var channel = (0, _index.addons).getChannel();
                channel.on((0, _coreEvents.STORY_RENDERED), this.renderListener);
            }
        },
        {
            key: "removeRenderListeners",
            value: function removeRenderListeners() {
                var channel = (0, _index.addons).getChannel();
                channel.removeListener((0, _coreEvents.STORY_RENDERED), this.renderListener);
            }
        }
    ]);
    return HooksContext;
}();
function hookify(fn) {
    return function() {
        var _ref = typeof (arguments.length <= 0 ? undefined : arguments[0]) === "function" ? arguments.length <= 1 ? undefined : arguments[1] : arguments.length <= 0 ? undefined : arguments[0], hooks = _ref.hooks;
        var prevPhase = hooks.currentPhase;
        var prevHooks = hooks.currentHooks;
        var prevNextHookIndex = hooks.nextHookIndex;
        var prevDecoratorName = hooks.currentDecoratorName;
        hooks.currentDecoratorName = fn.name;
        if (hooks.prevMountedDecorators.has(fn)) {
            hooks.currentPhase = "UPDATE";
            hooks.currentHooks = hooks.hookListsMap.get(fn) || [];
        } else {
            hooks.currentPhase = "MOUNT";
            hooks.currentHooks = [];
            hooks.hookListsMap.set(fn, hooks.currentHooks);
            hooks.prevMountedDecorators.add(fn);
        }
        hooks.nextHookIndex = 0;
        var prevContext = globalWindow.STORYBOOK_HOOKS_CONTEXT;
        globalWindow.STORYBOOK_HOOKS_CONTEXT = hooks;
        var result = fn.apply(void 0, arguments);
        globalWindow.STORYBOOK_HOOKS_CONTEXT = prevContext;
        if (hooks.currentPhase === "UPDATE" && hooks.getNextHook() != null) throw new Error("Rendered fewer hooks than expected. This may be caused by an accidental early return statement.");
        hooks.currentPhase = prevPhase;
        hooks.currentHooks = prevHooks;
        hooks.nextHookIndex = prevNextHookIndex;
        hooks.currentDecoratorName = prevDecoratorName;
        return result;
    };
} // Counter to prevent infinite loops.
var numberOfRenders = 0;
var RENDER_LIMIT = 25;
var applyHooks = function applyHooks(applyDecorators) {
    return function(storyFn, decorators) {
        var decorated = applyDecorators(hookify(storyFn), decorators.map(function(decorator) {
            return hookify(decorator);
        }));
        return function(context) {
            var _ref2 = context, hooks = _ref2.hooks;
            hooks.prevMountedDecorators = hooks.mountedDecorators;
            hooks.mountedDecorators = new Set([
                storyFn
            ].concat(_toConsumableArray(decorators)));
            hooks.currentContext = context;
            hooks.hasUpdates = false;
            var result = decorated(context);
            numberOfRenders = 1;
            while(hooks.hasUpdates){
                hooks.hasUpdates = false;
                hooks.currentEffects = [];
                result = decorated(context);
                numberOfRenders += 1;
                if (numberOfRenders > RENDER_LIMIT) throw new Error("Too many re-renders. Storybook limits the number of renders to prevent an infinite loop.");
            }
            hooks.addRenderListeners();
            return result;
        };
    };
};
var areDepsEqual = function areDepsEqual(deps, nextDeps) {
    return deps.length === nextDeps.length && deps.every(function(dep, i) {
        return dep === nextDeps[i];
    });
};
var invalidHooksError = function invalidHooksError() {
    return new Error("Storybook preview hooks can only be called inside decorators and story functions.");
};
function getHooksContextOrNull() {
    return globalWindow.STORYBOOK_HOOKS_CONTEXT || null;
}
function getHooksContextOrThrow() {
    var hooks = getHooksContextOrNull();
    if (hooks == null) throw invalidHooksError();
    return hooks;
}
function useHook(name, callback, deps) {
    var hooks = getHooksContextOrThrow();
    if (hooks.currentPhase === "MOUNT") {
        if (deps != null && !Array.isArray(deps)) (0, _clientLogger.logger).warn("".concat(name, " received a final argument that is not an array (instead, received ").concat(deps, "). When specified, the final argument must be an array."));
        var _hook = {
            name: name,
            deps: deps
        };
        hooks.currentHooks.push(_hook);
        callback(_hook);
        return _hook;
    }
    if (hooks.currentPhase === "UPDATE") {
        var _hook2 = hooks.getNextHook();
        if (_hook2 == null) throw new Error("Rendered more hooks than during the previous render.");
        if (_hook2.name !== name) (0, _clientLogger.logger).warn("Storybook has detected a change in the order of Hooks".concat(hooks.currentDecoratorName ? " called by ".concat(hooks.currentDecoratorName) : "", ". This will lead to bugs and errors if not fixed."));
        if (deps != null && _hook2.deps == null) (0, _clientLogger.logger).warn("".concat(name, " received a final argument during this render, but not during the previous render. Even though the final argument is optional, its type cannot change between renders."));
        if (deps != null && _hook2.deps != null && deps.length !== _hook2.deps.length) (0, _clientLogger.logger).warn("The final argument passed to ".concat(name, " changed size between renders. The order and size of this array must remain constant.\nPrevious: ").concat(_hook2.deps, "\nIncoming: ").concat(deps));
        if (deps == null || _hook2.deps == null || !areDepsEqual(deps, _hook2.deps)) {
            callback(_hook2);
            _hook2.deps = deps;
        }
        return _hook2;
    }
    throw invalidHooksError();
}
function useMemoLike(name, nextCreate, deps) {
    var _useHook = useHook(name, function(hook) {
        // eslint-disable-next-line no-param-reassign
        hook.memoizedState = nextCreate();
    }, deps), memoizedState = _useHook.memoizedState;
    return memoizedState;
}
function useMemo(nextCreate, deps) {
    return useMemoLike("useMemo", nextCreate, deps);
}
function useCallback(callback, deps) {
    return useMemoLike("useCallback", function() {
        return callback;
    }, deps);
}
function useRefLike(name, initialValue) {
    return useMemoLike(name, function() {
        return {
            current: initialValue
        };
    }, []);
}
function useRef(initialValue) {
    return useRefLike("useRef", initialValue);
}
function triggerUpdate() {
    var hooks = getHooksContextOrNull(); // Rerun storyFn if updates were triggered synchronously, force rerender otherwise
    if (hooks != null && hooks.currentPhase !== "NONE") hooks.hasUpdates = true;
    else try {
        (0, _index.addons).getChannel().emit((0, _coreEvents.FORCE_RE_RENDER));
    } catch (e) {
        (0, _clientLogger.logger).warn("State updates of Storybook preview hooks work only in browser");
    }
}
function useStateLike(name, initialState) {
    var stateRef = useRefLike(name, typeof initialState === "function" ? initialState() : initialState);
    var setState = function setState(update) {
        // @ts-ignore S type should never be function, but there's no way to tell that to TypeScript
        stateRef.current = typeof update === "function" ? update(stateRef.current) : update;
        triggerUpdate();
    };
    return [
        stateRef.current,
        setState
    ];
}
function useState(initialState) {
    return useStateLike("useState", initialState);
}
function useReducer(reducer, initialArg, init) {
    var initialState = init != null ? function() {
        return init(initialArg);
    } : initialArg;
    var _useStateLike = useStateLike("useReducer", initialState), _useStateLike2 = _slicedToArray(_useStateLike, 2), state = _useStateLike2[0], setState = _useStateLike2[1];
    var dispatch = function dispatch(action) {
        return setState(function(prevState) {
            return reducer(prevState, action);
        });
    };
    return [
        state,
        dispatch
    ];
}
function useEffect(create, deps) {
    var hooks = getHooksContextOrThrow();
    var effect = useMemoLike("useEffect", function() {
        return {
            create: create
        };
    }, deps);
    if (!hooks.currentEffects.includes(effect)) hooks.currentEffects.push(effect);
}
function useChannel(eventMap) {
    var deps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var channel = (0, _index.addons).getChannel();
    useEffect(function() {
        Object.entries(eventMap).forEach(function(_ref3) {
            var _ref4 = _slicedToArray(_ref3, 2), type = _ref4[0], listener = _ref4[1];
            return channel.on(type, listener);
        });
        return function() {
            Object.entries(eventMap).forEach(function(_ref5) {
                var _ref6 = _slicedToArray(_ref5, 2), type = _ref6[0], listener = _ref6[1];
                return channel.removeListener(type, listener);
            });
        };
    }, [].concat(_toConsumableArray(Object.keys(eventMap)), _toConsumableArray(deps)));
    return useCallback(channel.emit.bind(channel), [
        channel
    ]);
}
function useStoryContext() {
    var _getHooksContextOrThr = getHooksContextOrThrow(), currentContext = _getHooksContextOrThr.currentContext;
    if (currentContext == null) throw invalidHooksError();
    return currentContext;
}
function useParameter(parameterKey, defaultValue) {
    var _useStoryContext = useStoryContext(), parameters = _useStoryContext.parameters;
    if (parameterKey) {
        var _parameters$parameter;
        return (_parameters$parameter = parameters[parameterKey]) !== null && _parameters$parameter !== void 0 ? _parameters$parameter : defaultValue;
    }
    return undefined;
}
function useArgs() {
    var channel = (0, _index.addons).getChannel();
    var _useStoryContext2 = useStoryContext(), storyId = _useStoryContext2.id, args = _useStoryContext2.args;
    var updateArgs = useCallback(function(updatedArgs) {
        return channel.emit((0, _coreEvents.UPDATE_STORY_ARGS), {
            storyId: storyId,
            updatedArgs: updatedArgs
        });
    }, [
        channel,
        storyId
    ]);
    var resetArgs = useCallback(function(argNames) {
        return channel.emit((0, _coreEvents.RESET_STORY_ARGS), {
            storyId: storyId,
            argNames: argNames
        });
    }, [
        channel,
        storyId
    ]);
    return [
        args,
        updateArgs,
        resetArgs
    ];
}
function useGlobals() {
    var channel = (0, _index.addons).getChannel();
    var _useStoryContext3 = useStoryContext(), globals = _useStoryContext3.globals;
    var updateGlobals = useCallback(function(newGlobals) {
        return channel.emit((0, _coreEvents.UPDATE_GLOBALS), {
            globals: newGlobals
        });
    }, [
        channel
    ]);
    return [
        globals,
        updateGlobals
    ];
}

},{"core-js/modules/es.array.iterator.js":"ieU20","core-js/modules/es.object.to-string.js":"lsA9p","core-js/modules/es.string.iterator.js":"74a8v","core-js/modules/es.weak-map.js":"36z2S","core-js/modules/web.dom-collections.iterator.js":"aXR96","core-js/modules/es.set.js":"6FW6g","core-js/modules/web.dom-collections.for-each.js":"iYT1M","core-js/modules/es.array.includes.js":"dbUjS","core-js/modules/es.string.includes.js":"cx9ET","core-js/modules/es.function.name.js":"4LiLL","core-js/modules/es.array.map.js":"jTP7e","core-js/modules/es.array.concat.js":"g1t7q","core-js/modules/es.object.entries.js":"7Wf79","core-js/modules/es.object.keys.js":"5Q2AT","core-js/modules/es.symbol.js":"ajw2f","core-js/modules/es.symbol.description.js":"wrlLc","core-js/modules/es.symbol.iterator.js":"fhNIb","core-js/modules/es.array.from.js":"9UCQw","core-js/modules/es.array.slice.js":"8RRh9","core-js/modules/es.regexp.exec.js":"5q56v","global":"5PzlO","@storybook/client-logger":"6rq9J","@storybook/core-events":"gacRk","./index":"jIrtU","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"gacRk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CHANNEL_CREATED", ()=>CHANNEL_CREATED);
parcelHelpers.export(exports, "CONFIG_ERROR", ()=>CONFIG_ERROR);
parcelHelpers.export(exports, "STORY_INDEX_INVALIDATED", ()=>STORY_INDEX_INVALIDATED);
parcelHelpers.export(exports, "STORY_SPECIFIED", ()=>STORY_SPECIFIED);
parcelHelpers.export(exports, "SET_STORIES", ()=>SET_STORIES);
parcelHelpers.export(exports, "SET_CURRENT_STORY", ()=>SET_CURRENT_STORY);
parcelHelpers.export(exports, "CURRENT_STORY_WAS_SET", ()=>CURRENT_STORY_WAS_SET);
parcelHelpers.export(exports, "FORCE_RE_RENDER", ()=>FORCE_RE_RENDER);
parcelHelpers.export(exports, "FORCE_REMOUNT", ()=>FORCE_REMOUNT);
parcelHelpers.export(exports, "STORY_PREPARED", ()=>STORY_PREPARED);
parcelHelpers.export(exports, "STORY_CHANGED", ()=>STORY_CHANGED);
parcelHelpers.export(exports, "STORY_UNCHANGED", ()=>STORY_UNCHANGED);
parcelHelpers.export(exports, "PRELOAD_STORIES", ()=>PRELOAD_STORIES);
parcelHelpers.export(exports, "STORY_RENDERED", ()=>STORY_RENDERED);
parcelHelpers.export(exports, "STORY_MISSING", ()=>STORY_MISSING);
parcelHelpers.export(exports, "STORY_ERRORED", ()=>STORY_ERRORED);
parcelHelpers.export(exports, "STORY_THREW_EXCEPTION", ()=>STORY_THREW_EXCEPTION);
parcelHelpers.export(exports, "STORY_RENDER_PHASE_CHANGED", ()=>STORY_RENDER_PHASE_CHANGED);
parcelHelpers.export(exports, "UPDATE_STORY_ARGS", ()=>UPDATE_STORY_ARGS);
parcelHelpers.export(exports, "STORY_ARGS_UPDATED", ()=>STORY_ARGS_UPDATED);
parcelHelpers.export(exports, "RESET_STORY_ARGS", ()=>RESET_STORY_ARGS);
parcelHelpers.export(exports, "SET_GLOBALS", ()=>SET_GLOBALS);
parcelHelpers.export(exports, "UPDATE_GLOBALS", ()=>UPDATE_GLOBALS);
parcelHelpers.export(exports, "GLOBALS_UPDATED", ()=>GLOBALS_UPDATED);
parcelHelpers.export(exports, "REGISTER_SUBSCRIPTION", ()=>REGISTER_SUBSCRIPTION);
parcelHelpers.export(exports, "PREVIEW_KEYDOWN", ()=>PREVIEW_KEYDOWN);
parcelHelpers.export(exports, "SELECT_STORY", ()=>SELECT_STORY);
parcelHelpers.export(exports, "STORIES_COLLAPSE_ALL", ()=>STORIES_COLLAPSE_ALL);
parcelHelpers.export(exports, "STORIES_EXPAND_ALL", ()=>STORIES_EXPAND_ALL);
parcelHelpers.export(exports, "DOCS_RENDERED", ()=>DOCS_RENDERED);
parcelHelpers.export(exports, "SHARED_STATE_CHANGED", ()=>SHARED_STATE_CHANGED);
parcelHelpers.export(exports, "SHARED_STATE_SET", ()=>SHARED_STATE_SET);
parcelHelpers.export(exports, "NAVIGATE_URL", ()=>NAVIGATE_URL);
parcelHelpers.export(exports, "UPDATE_QUERY_PARAMS", ()=>UPDATE_QUERY_PARAMS);
parcelHelpers.export(exports, "IGNORED_EXCEPTION", ()=>IGNORED_EXCEPTION);
var events; // Enables: `import Events from ...`
(function(events) {
    events["CHANNEL_CREATED"] = "channelCreated";
    events["CONFIG_ERROR"] = "configError";
    events["STORY_INDEX_INVALIDATED"] = "storyIndexInvalidated";
    events["STORY_SPECIFIED"] = "storySpecified";
    events["SET_STORIES"] = "setStories";
    events["SET_CURRENT_STORY"] = "setCurrentStory";
    events["CURRENT_STORY_WAS_SET"] = "currentStoryWasSet";
    events["FORCE_RE_RENDER"] = "forceReRender";
    events["FORCE_REMOUNT"] = "forceRemount";
    events["PRELOAD_STORIES"] = "preloadStories";
    events["STORY_PREPARED"] = "storyPrepared";
    events["STORY_CHANGED"] = "storyChanged";
    events["STORY_UNCHANGED"] = "storyUnchanged";
    events["STORY_RENDERED"] = "storyRendered";
    events["STORY_MISSING"] = "storyMissing";
    events["STORY_ERRORED"] = "storyErrored";
    events["STORY_THREW_EXCEPTION"] = "storyThrewException";
    events["STORY_RENDER_PHASE_CHANGED"] = "storyRenderPhaseChanged";
    events["UPDATE_STORY_ARGS"] = "updateStoryArgs";
    events["STORY_ARGS_UPDATED"] = "storyArgsUpdated";
    events["RESET_STORY_ARGS"] = "resetStoryArgs";
    events["SET_GLOBALS"] = "setGlobals";
    events["UPDATE_GLOBALS"] = "updateGlobals";
    events["GLOBALS_UPDATED"] = "globalsUpdated";
    events["REGISTER_SUBSCRIPTION"] = "registerSubscription";
    events["PREVIEW_KEYDOWN"] = "previewKeydown";
    events["SELECT_STORY"] = "selectStory";
    events["STORIES_COLLAPSE_ALL"] = "storiesCollapseAll";
    events["STORIES_EXPAND_ALL"] = "storiesExpandAll";
    events["DOCS_RENDERED"] = "docsRendered";
    events["SHARED_STATE_CHANGED"] = "sharedStateChanged";
    events["SHARED_STATE_SET"] = "sharedStateSet";
    events["NAVIGATE_URL"] = "navigateUrl";
    events["UPDATE_QUERY_PARAMS"] = "updateQueryParams";
})(events || (events = {}));
exports.default = events; // Enables: `import * as Events from ...` or `import { CHANNEL_CREATED } as Events from ...`
// This is the preferred method
var CHANNEL_CREATED = events.CHANNEL_CREATED, CONFIG_ERROR = events.CONFIG_ERROR, STORY_INDEX_INVALIDATED = events.STORY_INDEX_INVALIDATED, STORY_SPECIFIED = events.STORY_SPECIFIED, SET_STORIES = events.SET_STORIES, SET_CURRENT_STORY = events.SET_CURRENT_STORY, CURRENT_STORY_WAS_SET = events.CURRENT_STORY_WAS_SET, FORCE_RE_RENDER = events.FORCE_RE_RENDER, FORCE_REMOUNT = events.FORCE_REMOUNT, STORY_PREPARED = events.STORY_PREPARED, STORY_CHANGED = events.STORY_CHANGED, STORY_UNCHANGED = events.STORY_UNCHANGED, PRELOAD_STORIES = events.PRELOAD_STORIES, STORY_RENDERED = events.STORY_RENDERED, STORY_MISSING = events.STORY_MISSING, STORY_ERRORED = events.STORY_ERRORED, STORY_THREW_EXCEPTION = events.STORY_THREW_EXCEPTION, STORY_RENDER_PHASE_CHANGED = events.STORY_RENDER_PHASE_CHANGED, UPDATE_STORY_ARGS = events.UPDATE_STORY_ARGS, STORY_ARGS_UPDATED = events.STORY_ARGS_UPDATED, RESET_STORY_ARGS = events.RESET_STORY_ARGS, SET_GLOBALS = events.SET_GLOBALS, UPDATE_GLOBALS = events.UPDATE_GLOBALS, GLOBALS_UPDATED = events.GLOBALS_UPDATED, REGISTER_SUBSCRIPTION = events.REGISTER_SUBSCRIPTION, PREVIEW_KEYDOWN = events.PREVIEW_KEYDOWN, SELECT_STORY = events.SELECT_STORY, STORIES_COLLAPSE_ALL = events.STORIES_COLLAPSE_ALL, STORIES_EXPAND_ALL = events.STORIES_EXPAND_ALL, DOCS_RENDERED = events.DOCS_RENDERED, SHARED_STATE_CHANGED = events.SHARED_STATE_CHANGED, SHARED_STATE_SET = events.SHARED_STATE_SET, NAVIGATE_URL = events.NAVIGATE_URL, UPDATE_QUERY_PARAMS = events.UPDATE_QUERY_PARAMS; // Used to break out of the current render without showing a redbox
var IGNORED_EXCEPTION = new Error("ignoredException");

},{"@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"nvqZ9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CallStates", ()=>CallStates);
var CallStates;
(function(CallStates) {
    CallStates["DONE"] = "done";
    CallStates["ERROR"] = "error";
    CallStates["ACTIVE"] = "active";
    CallStates["WAITING"] = "waiting";
})(CallStates || (CallStates = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"f2A46":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "prettyFormat", ()=>_prettyFormat);
parcelHelpers.export(exports, "buildQueries", ()=>buildQueries);
parcelHelpers.export(exports, "configure", ()=>configure);
parcelHelpers.export(exports, "createEvent", ()=>createEvent);
parcelHelpers.export(exports, "findAllByAltText", ()=>findAllByAltText);
parcelHelpers.export(exports, "findAllByDisplayValue", ()=>findAllByDisplayValue);
parcelHelpers.export(exports, "findAllByLabelText", ()=>findAllByLabelText);
parcelHelpers.export(exports, "findAllByPlaceholderText", ()=>findAllByPlaceholderText);
parcelHelpers.export(exports, "findAllByRole", ()=>findAllByRole);
parcelHelpers.export(exports, "findAllByTestId", ()=>findAllByTestId);
parcelHelpers.export(exports, "findAllByText", ()=>findAllByText);
parcelHelpers.export(exports, "findAllByTitle", ()=>findAllByTitle);
parcelHelpers.export(exports, "findByAltText", ()=>findByAltText);
parcelHelpers.export(exports, "findByDisplayValue", ()=>findByDisplayValue);
parcelHelpers.export(exports, "findByLabelText", ()=>findByLabelText);
parcelHelpers.export(exports, "findByPlaceholderText", ()=>findByPlaceholderText);
parcelHelpers.export(exports, "findByRole", ()=>findByRole);
parcelHelpers.export(exports, "findByTestId", ()=>findByTestId);
parcelHelpers.export(exports, "findByText", ()=>findByText);
parcelHelpers.export(exports, "findByTitle", ()=>findByTitle);
parcelHelpers.export(exports, "fireEvent", ()=>fireEvent);
parcelHelpers.export(exports, "getAllByAltText", ()=>getAllByAltText);
parcelHelpers.export(exports, "getAllByDisplayValue", ()=>getAllByDisplayValue);
parcelHelpers.export(exports, "getAllByLabelText", ()=>getAllByLabelTextWithSuggestions);
parcelHelpers.export(exports, "getAllByPlaceholderText", ()=>getAllByPlaceholderText);
parcelHelpers.export(exports, "getAllByRole", ()=>getAllByRole);
parcelHelpers.export(exports, "getAllByTestId", ()=>getAllByTestId);
parcelHelpers.export(exports, "getAllByText", ()=>getAllByText);
parcelHelpers.export(exports, "getAllByTitle", ()=>getAllByTitle);
parcelHelpers.export(exports, "getByAltText", ()=>getByAltText);
parcelHelpers.export(exports, "getByDisplayValue", ()=>getByDisplayValue);
parcelHelpers.export(exports, "getByLabelText", ()=>getByLabelTextWithSuggestions);
parcelHelpers.export(exports, "getByPlaceholderText", ()=>getByPlaceholderText);
parcelHelpers.export(exports, "getByRole", ()=>getByRole);
parcelHelpers.export(exports, "getByTestId", ()=>getByTestId);
parcelHelpers.export(exports, "getByText", ()=>getByText);
parcelHelpers.export(exports, "getByTitle", ()=>getByTitle);
parcelHelpers.export(exports, "getConfig", ()=>getConfig);
parcelHelpers.export(exports, "getDefaultNormalizer", ()=>getDefaultNormalizer);
parcelHelpers.export(exports, "getElementError", ()=>getElementError);
parcelHelpers.export(exports, "getMultipleElementsFoundError", ()=>getMultipleElementsFoundError);
parcelHelpers.export(exports, "getNodeText", ()=>getNodeText);
parcelHelpers.export(exports, "getQueriesForElement", ()=>getQueriesForElement);
parcelHelpers.export(exports, "getRoles", ()=>getRoles);
parcelHelpers.export(exports, "getSuggestedQuery", ()=>getSuggestedQuery);
parcelHelpers.export(exports, "isInaccessible", ()=>isInaccessible);
parcelHelpers.export(exports, "logDOM", ()=>logDOM);
parcelHelpers.export(exports, "logRoles", ()=>logRoles);
parcelHelpers.export(exports, "makeFindQuery", ()=>makeFindQuery);
parcelHelpers.export(exports, "makeGetAllQuery", ()=>makeGetAllQuery);
parcelHelpers.export(exports, "makeSingleQuery", ()=>makeSingleQuery);
parcelHelpers.export(exports, "prettyDOM", ()=>prettyDOM);
parcelHelpers.export(exports, "queries", ()=>queries);
parcelHelpers.export(exports, "queryAllByAltText", ()=>queryAllByAltTextWithSuggestions);
parcelHelpers.export(exports, "queryAllByAttribute", ()=>queryAllByAttribute);
parcelHelpers.export(exports, "queryAllByDisplayValue", ()=>queryAllByDisplayValueWithSuggestions);
parcelHelpers.export(exports, "queryAllByLabelText", ()=>queryAllByLabelTextWithSuggestions);
parcelHelpers.export(exports, "queryAllByPlaceholderText", ()=>queryAllByPlaceholderTextWithSuggestions);
parcelHelpers.export(exports, "queryAllByRole", ()=>queryAllByRoleWithSuggestions);
parcelHelpers.export(exports, "queryAllByTestId", ()=>queryAllByTestIdWithSuggestions);
parcelHelpers.export(exports, "queryAllByText", ()=>queryAllByTextWithSuggestions);
parcelHelpers.export(exports, "queryAllByTitle", ()=>queryAllByTitleWithSuggestions);
parcelHelpers.export(exports, "queryByAltText", ()=>queryByAltText);
parcelHelpers.export(exports, "queryByAttribute", ()=>queryByAttribute);
parcelHelpers.export(exports, "queryByDisplayValue", ()=>queryByDisplayValue);
parcelHelpers.export(exports, "queryByLabelText", ()=>queryByLabelText);
parcelHelpers.export(exports, "queryByPlaceholderText", ()=>queryByPlaceholderText);
parcelHelpers.export(exports, "queryByRole", ()=>queryByRole);
parcelHelpers.export(exports, "queryByTestId", ()=>queryByTestId);
parcelHelpers.export(exports, "queryByText", ()=>queryByText);
parcelHelpers.export(exports, "queryByTitle", ()=>queryByTitle);
parcelHelpers.export(exports, "queryHelpers", ()=>queryHelpers);
parcelHelpers.export(exports, "screen", ()=>screen);
parcelHelpers.export(exports, "waitFor", ()=>waitForWrapper);
parcelHelpers.export(exports, "waitForElementToBeRemoved", ()=>waitForElementToBeRemoved);
parcelHelpers.export(exports, "within", ()=>getQueriesForElement);
parcelHelpers.export(exports, "wrapAllByQueryWithSuggestion", ()=>wrapAllByQueryWithSuggestion);
parcelHelpers.export(exports, "wrapSingleQueryWithSuggestion", ()=>wrapSingleQueryWithSuggestion);
var _prettyFormat = require("pretty-format");
var _domAccessibilityApi = require("dom-accessibility-api");
var _ariaQuery = require("aria-query");
var _lzString = require("lz-string");
var _lzStringDefault = parcelHelpers.interopDefault(_lzString);
var process = require("48ce5fb41d2886e6");
/**
 * Source: https://github.com/facebook/jest/blob/e7bb6a1e26ffab90611b2593912df15b69315611/packages/pretty-format/src/plugins/DOMElement.ts
 */ /* eslint-disable -- trying to stay as close to the original as possible */ /* istanbul ignore file */ function escapeHTML(str) {
    return str.replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
// Return empty string if keys is empty.
const printProps = (keys, props, config, indentation, depth, refs, printer)=>{
    const indentationNext = indentation + config.indent;
    const colors = config.colors;
    return keys.map((key)=>{
        const value = props[key];
        let printed = printer(value, config, indentationNext, depth, refs);
        if (typeof value !== "string") {
            if (printed.indexOf("\n") !== -1) printed = config.spacingOuter + indentationNext + printed + config.spacingOuter + indentation;
            printed = "{" + printed + "}";
        }
        return config.spacingInner + indentation + colors.prop.open + key + colors.prop.close + "=" + colors.value.open + printed + colors.value.close;
    }).join("");
};
// https://developer.mozilla.org/en-US/docs/Web/API/Node/nodeType#node_type_constants
const NodeTypeTextNode = 3;
// Return empty string if children is empty.
const printChildren = (children, config, indentation, depth, refs, printer)=>children.map((child)=>{
        const printedChild = typeof child === "string" ? printText(child, config) : printer(child, config, indentation, depth, refs);
        if (printedChild === "" && typeof child === "object" && child !== null && child.nodeType !== NodeTypeTextNode) // A plugin serialized this Node to '' meaning we should ignore it.
        return "";
        return config.spacingOuter + indentation + printedChild;
    }).join("");
const printText = (text, config)=>{
    const contentColor = config.colors.content;
    return contentColor.open + escapeHTML(text) + contentColor.close;
};
const printComment = (comment, config)=>{
    const commentColor = config.colors.comment;
    return commentColor.open + "<!--" + escapeHTML(comment) + "-->" + commentColor.close;
};
// Separate the functions to format props, children, and element,
// so a plugin could override a particular function, if needed.
// Too bad, so sad: the traditional (but unnecessary) space
// in a self-closing tagColor requires a second test of printedProps.
const printElement = (type, printedProps, printedChildren, config, indentation)=>{
    const tagColor = config.colors.tag;
    return tagColor.open + "<" + type + (printedProps && tagColor.close + printedProps + config.spacingOuter + indentation + tagColor.open) + (printedChildren ? ">" + tagColor.close + printedChildren + config.spacingOuter + indentation + tagColor.open + "</" + type : (printedProps && !config.min ? "" : " ") + "/") + ">" + tagColor.close;
};
const printElementAsLeaf = (type, config)=>{
    const tagColor = config.colors.tag;
    return tagColor.open + "<" + type + tagColor.close + " \u2026" + tagColor.open + " />" + tagColor.close;
};
const ELEMENT_NODE$1 = 1;
const TEXT_NODE$1 = 3;
const COMMENT_NODE$1 = 8;
const FRAGMENT_NODE = 11;
const ELEMENT_REGEXP = /^((HTML|SVG)\w*)?Element$/;
const testNode = (val)=>{
    const constructorName = val.constructor.name;
    const { nodeType, tagName } = val;
    const isCustomElement = typeof tagName === "string" && tagName.includes("-") || typeof val.hasAttribute === "function" && val.hasAttribute("is");
    return nodeType === ELEMENT_NODE$1 && (ELEMENT_REGEXP.test(constructorName) || isCustomElement) || nodeType === TEXT_NODE$1 && constructorName === "Text" || nodeType === COMMENT_NODE$1 && constructorName === "Comment" || nodeType === FRAGMENT_NODE && constructorName === "DocumentFragment";
};
function nodeIsText(node) {
    return node.nodeType === TEXT_NODE$1;
}
function nodeIsComment(node) {
    return node.nodeType === COMMENT_NODE$1;
}
function nodeIsFragment(node) {
    return node.nodeType === FRAGMENT_NODE;
}
function createDOMElementFilter(filterNode) {
    return {
        test: (val)=>{
            var _val$constructor2;
            return (val == null ? void 0 : (_val$constructor2 = val.constructor) == null ? void 0 : _val$constructor2.name) && testNode(val);
        },
        serialize: (node, config, indentation, depth, refs, printer)=>{
            if (nodeIsText(node)) return printText(node.data, config);
            if (nodeIsComment(node)) return printComment(node.data, config);
            const type = nodeIsFragment(node) ? "DocumentFragment" : node.tagName.toLowerCase();
            if (++depth > config.maxDepth) return printElementAsLeaf(type, config);
            return printElement(type, printProps(nodeIsFragment(node) ? [] : Array.from(node.attributes).map((attr)=>attr.name).sort(), nodeIsFragment(node) ? {} : Array.from(node.attributes).reduce((props, attribute)=>{
                props[attribute.name] = attribute.value;
                return props;
            }, {}), config, indentation + config.indent, depth, refs, printer), printChildren(Array.prototype.slice.call(node.childNodes || node.children).filter(filterNode), config, indentation + config.indent, depth, refs, printer), config, indentation);
        }
    };
}
// We try to load node dependencies
let chalk = null;
let readFileSync = null;
let codeFrameColumns = null;
try {
    const nodeRequire = module && module.require;
    readFileSync = nodeRequire.call(module, "fs").readFileSync;
    codeFrameColumns = nodeRequire.call(module, "@babel/code-frame").codeFrameColumns;
    chalk = nodeRequire.call(module, "chalk");
} catch  {
// We're in a browser environment
}
// frame has the form "at myMethod (location/to/my/file.js:10:2)"
function getCodeFrame(frame) {
    const locationStart = frame.indexOf("(") + 1;
    const locationEnd = frame.indexOf(")");
    const frameLocation = frame.slice(locationStart, locationEnd);
    const frameLocationElements = frameLocation.split(":");
    const [filename, line, column] = [
        frameLocationElements[0],
        parseInt(frameLocationElements[1], 10),
        parseInt(frameLocationElements[2], 10)
    ];
    let rawFileContents = "";
    try {
        rawFileContents = readFileSync(filename, "utf-8");
    } catch  {
        return "";
    }
    const codeFrame = codeFrameColumns(rawFileContents, {
        start: {
            line,
            column
        }
    }, {
        highlightCode: true,
        linesBelow: 0
    });
    return chalk.dim(frameLocation) + "\n" + codeFrame + "\n";
}
function getUserCodeFrame() {
    // If we couldn't load dependencies, we can't generate the user trace
    /* istanbul ignore next */ if (!readFileSync || !codeFrameColumns) return "";
    const err = new Error();
    const firstClientCodeFrame = err.stack.split("\n").slice(1) // Remove first line which has the form "Error: TypeError"
    .find((frame)=>!frame.includes("node_modules/")); // Ignore frames from 3rd party libraries
    return getCodeFrame(firstClientCodeFrame);
}
// Constant node.nodeType for text nodes, see:
// https://developer.mozilla.org/en-US/docs/Web/API/Node/nodeType#Node_type_constants
const TEXT_NODE = 3;
function jestFakeTimersAreEnabled() {
    /* istanbul ignore else */ // eslint-disable-next-line
    if (typeof jest !== "undefined" && jest !== null) return(// legacy timers
    setTimeout._isMockFunction === true || // modern timers
    Object.prototype.hasOwnProperty.call(setTimeout, "clock"));
    // istanbul ignore next
    return false;
}
function getDocument() {
    /* istanbul ignore if */ if (typeof window === "undefined") throw new Error("Could not find default container");
    return window.document;
}
function getWindowFromNode(node) {
    if (node.defaultView) // node is document
    return node.defaultView;
    else if (node.ownerDocument && node.ownerDocument.defaultView) // node is a DOM node
    return node.ownerDocument.defaultView;
    else if (node.window) // node is window
    return node.window;
    else if (node.ownerDocument && node.ownerDocument.defaultView === null) throw new Error("It looks like the window object is not available for the provided node.");
    else if (node.then instanceof Function) throw new Error("It looks like you passed a Promise object instead of a DOM node. Did you do something like `fireEvent.click(screen.findBy...` when you meant to use a `getBy` query `fireEvent.click(screen.getBy...`, or await the findBy query `fireEvent.click(await screen.findBy...`?");
    else if (Array.isArray(node)) throw new Error("It looks like you passed an Array instead of a DOM node. Did you do something like `fireEvent.click(screen.getAllBy...` when you meant to use a `getBy` query `fireEvent.click(screen.getBy...`?");
    else if (typeof node.debug === "function" && typeof node.logTestingPlaygroundURL === "function") throw new Error("It looks like you passed a `screen` object. Did you do something like `fireEvent.click(screen, ...` when you meant to use a query, e.g. `fireEvent.click(screen.getBy..., `?");
    else // The user passed something unusual to a calling function
    throw new Error("The given node is not an Element, the node type is: " + typeof node + ".");
}
function checkContainerType(container) {
    if (!container || !(typeof container.querySelector === "function") || !(typeof container.querySelectorAll === "function")) throw new TypeError("Expected container to be an Element, a Document or a DocumentFragment but got " + getTypeName(container) + ".");
    function getTypeName(object) {
        if (typeof object === "object") return object === null ? "null" : object.constructor.name;
        return typeof object;
    }
}
const shouldHighlight = ()=>{
    let colors;
    try {
        var _process, _process$env;
        colors = JSON.parse((_process = process) == null ? void 0 : (_process$env = _process.env) == null ? void 0 : _process$env.COLORS);
    } catch (e) {
    // If this throws, process?.env?.COLORS wasn't parsable. Since we only
    // care about `true` or `false`, we can safely ignore the error.
    }
    if (typeof colors === "boolean") // If `colors` is set explicitly (both `true` and `false`), use that value.
    return colors;
    else // If `colors` is not set, colorize if we're in node.
    return typeof process !== "undefined" && process.versions !== undefined && process.versions.node !== undefined;
};
const { DOMCollection } = _prettyFormat.plugins;
// https://developer.mozilla.org/en-US/docs/Web/API/Node/nodeType#node_type_constants
const ELEMENT_NODE = 1;
const COMMENT_NODE = 8;
// https://github.com/facebook/jest/blob/615084195ae1ae61ddd56162c62bbdda17587569/packages/pretty-format/src/plugins/DOMElement.ts#L50
function filterCommentsAndDefaultIgnoreTagsTags(value) {
    return value.nodeType !== COMMENT_NODE && (value.nodeType !== ELEMENT_NODE || !value.matches(getConfig().defaultIgnore));
}
function prettyDOM(dom, maxLength, options) {
    if (options === void 0) options = {};
    if (!dom) dom = getDocument().body;
    if (typeof maxLength !== "number") maxLength = (typeof process !== "undefined" && undefined, 7000);
    if (maxLength === 0) return "";
    if (dom.documentElement) dom = dom.documentElement;
    let domTypeName = typeof dom;
    if (domTypeName === "object") domTypeName = dom.constructor.name;
    else // To don't fall with `in` operator
    dom = {};
    if (!("outerHTML" in dom)) throw new TypeError("Expected an element or document but got " + domTypeName);
    const { filterNode = filterCommentsAndDefaultIgnoreTagsTags, ...prettyFormatOptions } = options;
    const debugContent = _prettyFormat.format(dom, {
        plugins: [
            createDOMElementFilter(filterNode),
            DOMCollection
        ],
        printFunctionName: false,
        highlight: shouldHighlight(),
        ...prettyFormatOptions
    });
    return maxLength !== undefined && dom.outerHTML.length > maxLength ? debugContent.slice(0, maxLength) + "..." : debugContent;
}
const logDOM = function() {
    const userCodeFrame = getUserCodeFrame();
    if (userCodeFrame) console.log(prettyDOM(...arguments) + "\n\n" + userCodeFrame);
    else console.log(prettyDOM(...arguments));
};
// It would be cleaner for this to live inside './queries', but
// other parts of the code assume that all exports from
// './queries' are query functions.
let config = {
    testIdAttribute: "data-testid",
    asyncUtilTimeout: 1000,
    // asyncWrapper and advanceTimersWrapper is to support React's async `act` function.
    // forcing react-testing-library to wrap all async functions would've been
    // a total nightmare (consider wrapping every findBy* query and then also
    // updating `within` so those would be wrapped too. Total nightmare).
    // so we have this config option that's really only intended for
    // react-testing-library to use. For that reason, this feature will remain
    // undocumented.
    asyncWrapper: (cb)=>cb(),
    unstable_advanceTimersWrapper: (cb)=>cb(),
    eventWrapper: (cb)=>cb(),
    // default value for the `hidden` option in `ByRole` queries
    defaultHidden: false,
    // default value for the `ignore` option in `ByText` queries
    defaultIgnore: "script, style",
    // showOriginalStackTrace flag to show the full error stack traces for async errors
    showOriginalStackTrace: false,
    // throw errors w/ suggestions for better queries. Opt in so off by default.
    throwSuggestions: false,
    // called when getBy* queries fail. (message, container) => Error
    getElementError (message, container) {
        const prettifiedDOM = prettyDOM(container);
        const error = new Error([
            message,
            "Ignored nodes: comments, " + config.defaultIgnore + "\n" + prettifiedDOM
        ].filter(Boolean).join("\n\n"));
        error.name = "TestingLibraryElementError";
        return error;
    },
    _disableExpensiveErrorDiagnostics: false,
    computedStyleSupportsPseudoElements: false
};
function runWithExpensiveErrorDiagnosticsDisabled(callback) {
    try {
        config._disableExpensiveErrorDiagnostics = true;
        return callback();
    } finally{
        config._disableExpensiveErrorDiagnostics = false;
    }
}
function configure(newConfig) {
    if (typeof newConfig === "function") // Pass the existing config out to the provided function
    // and accept a delta in return
    newConfig = newConfig(config);
    // Merge the incoming config delta
    config = {
        ...config,
        ...newConfig
    };
}
function getConfig() {
    return config;
}
const labelledNodeNames = [
    "button",
    "meter",
    "output",
    "progress",
    "select",
    "textarea",
    "input"
];
function getTextContent(node) {
    if (labelledNodeNames.includes(node.nodeName.toLowerCase())) return "";
    if (node.nodeType === TEXT_NODE) return node.textContent;
    return Array.from(node.childNodes).map((childNode)=>getTextContent(childNode)).join("");
}
function getLabelContent(element) {
    let textContent;
    if (element.tagName.toLowerCase() === "label") textContent = getTextContent(element);
    else textContent = element.value || element.textContent;
    return textContent;
}
// Based on https://github.com/eps1lon/dom-accessibility-api/pull/352
function getRealLabels(element) {
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- types are not aware of older browsers that don't implement `labels`
    if (element.labels !== undefined) {
        var _labels;
        return (_labels = element.labels) != null ? _labels : [];
    }
    if (!isLabelable(element)) return [];
    const labels = element.ownerDocument.querySelectorAll("label");
    return Array.from(labels).filter((label)=>label.control === element);
}
function isLabelable(element) {
    return /BUTTON|METER|OUTPUT|PROGRESS|SELECT|TEXTAREA/.test(element.tagName) || element.tagName === "INPUT" && element.getAttribute("type") !== "hidden";
}
function getLabels(container, element, _temp) {
    let { selector = "*" } = _temp === void 0 ? {} : _temp;
    const ariaLabelledBy = element.getAttribute("aria-labelledby");
    const labelsId = ariaLabelledBy ? ariaLabelledBy.split(" ") : [];
    return labelsId.length ? labelsId.map((labelId)=>{
        const labellingElement = container.querySelector('[id="' + labelId + '"]');
        return labellingElement ? {
            content: getLabelContent(labellingElement),
            formControl: null
        } : {
            content: "",
            formControl: null
        };
    }) : Array.from(getRealLabels(element)).map((label)=>{
        const textToMatch = getLabelContent(label);
        const formControlSelector = "button, input, meter, output, progress, select, textarea";
        const labelledFormControl = Array.from(label.querySelectorAll(formControlSelector)).filter((formControlElement)=>formControlElement.matches(selector))[0];
        return {
            content: textToMatch,
            formControl: labelledFormControl
        };
    });
}
function assertNotNullOrUndefined(matcher) {
    if (matcher === null || matcher === undefined) throw new Error("It looks like " + matcher + " was passed instead of a matcher. Did you do something like getByText(" + matcher + ")?");
}
function fuzzyMatches(textToMatch, node, matcher, normalizer) {
    if (typeof textToMatch !== "string") return false;
    assertNotNullOrUndefined(matcher);
    const normalizedText = normalizer(textToMatch);
    if (typeof matcher === "string" || typeof matcher === "number") return normalizedText.toLowerCase().includes(matcher.toString().toLowerCase());
    else if (typeof matcher === "function") return matcher(normalizedText, node);
    else return matchRegExp(matcher, normalizedText);
}
function matches(textToMatch, node, matcher, normalizer) {
    if (typeof textToMatch !== "string") return false;
    assertNotNullOrUndefined(matcher);
    const normalizedText = normalizer(textToMatch);
    if (matcher instanceof Function) return matcher(normalizedText, node);
    else if (matcher instanceof RegExp) return matchRegExp(matcher, normalizedText);
    else return normalizedText === String(matcher);
}
function getDefaultNormalizer(_temp) {
    let { trim = true, collapseWhitespace = true } = _temp === void 0 ? {} : _temp;
    return (text)=>{
        let normalizedText = text;
        normalizedText = trim ? normalizedText.trim() : normalizedText;
        normalizedText = collapseWhitespace ? normalizedText.replace(/\s+/g, " ") : normalizedText;
        return normalizedText;
    };
}
/**
 * Constructs a normalizer to pass to functions in matches.js
 * @param {boolean|undefined} trim The user-specified value for `trim`, without
 * any defaulting having been applied
 * @param {boolean|undefined} collapseWhitespace The user-specified value for
 * `collapseWhitespace`, without any defaulting having been applied
 * @param {Function|undefined} normalizer The user-specified normalizer
 * @returns {Function} A normalizer
 */ function makeNormalizer(_ref) {
    let { trim, collapseWhitespace, normalizer } = _ref;
    if (!normalizer) // No custom normalizer specified. Just use default.
    return getDefaultNormalizer({
        trim,
        collapseWhitespace
    });
    if (typeof trim !== "undefined" || typeof collapseWhitespace !== "undefined") // They've also specified a value for trim or collapseWhitespace
    throw new Error('trim and collapseWhitespace are not supported with a normalizer. If you want to use the default trim and collapseWhitespace logic in your normalizer, use "getDefaultNormalizer({trim, collapseWhitespace})" and compose that into your normalizer');
    return normalizer;
}
function matchRegExp(matcher, text) {
    const match = matcher.test(text);
    if (matcher.global && matcher.lastIndex !== 0) {
        console.warn("To match all elements we had to reset the lastIndex of the RegExp because the global flag is enabled. We encourage to remove the global flag from the RegExp.");
        matcher.lastIndex = 0;
    }
    return match;
}
function getNodeText(node) {
    if (node.matches("input[type=submit], input[type=button], input[type=reset]")) return node.value;
    return Array.from(node.childNodes).filter((child)=>child.nodeType === TEXT_NODE && Boolean(child.textContent)).map((c)=>c.textContent).join("");
}
const elementRoleList = buildElementRoleList((0, _ariaQuery.elementRoles));
/**
 * @param {Element} element -
 * @returns {boolean} - `true` if `element` and its subtree are inaccessible
 */ function isSubtreeInaccessible(element) {
    if (element.hidden === true) return true;
    if (element.getAttribute("aria-hidden") === "true") return true;
    const window1 = element.ownerDocument.defaultView;
    if (window1.getComputedStyle(element).display === "none") return true;
    return false;
}
/**
 * Partial implementation https://www.w3.org/TR/wai-aria-1.2/#tree_exclusion
 * which should only be used for elements with a non-presentational role i.e.
 * `role="none"` and `role="presentation"` will not be excluded.
 *
 * Implements aria-hidden semantics (i.e. parent overrides child)
 * Ignores "Child Presentational: True" characteristics
 *
 * @param {Element} element -
 * @param {object} [options] -
 * @param {function (element: Element): boolean} options.isSubtreeInaccessible -
 * can be used to return cached results from previous isSubtreeInaccessible calls
 * @returns {boolean} true if excluded, otherwise false
 */ function isInaccessible(element, options) {
    if (options === void 0) options = {};
    const { isSubtreeInaccessible: isSubtreeInaccessibleImpl = isSubtreeInaccessible } = options;
    const window1 = element.ownerDocument.defaultView;
    // since visibility is inherited we can exit early
    if (window1.getComputedStyle(element).visibility === "hidden") return true;
    let currentElement = element;
    while(currentElement){
        if (isSubtreeInaccessibleImpl(currentElement)) return true;
        currentElement = currentElement.parentElement;
    }
    return false;
}
function getImplicitAriaRoles(currentNode) {
    // eslint bug here:
    // eslint-disable-next-line no-unused-vars
    for (const { match, roles } of elementRoleList){
        if (match(currentNode)) return [
            ...roles
        ];
    }
    return [];
}
function buildElementRoleList(elementRolesMap) {
    function makeElementSelector(_ref) {
        let { name, attributes } = _ref;
        return "" + name + attributes.map((_ref2)=>{
            let { name: attributeName, value, constraints = [] } = _ref2;
            const shouldNotExist = constraints.indexOf("undefined") !== -1;
            if (shouldNotExist) return ":not([" + attributeName + "])";
            else if (value) return "[" + attributeName + '="' + value + '"]';
            else return "[" + attributeName + "]";
        }).join("");
    }
    function getSelectorSpecificity(_ref3) {
        let { attributes = [] } = _ref3;
        return attributes.length;
    }
    function bySelectorSpecificity(_ref4, _ref5) {
        let { specificity: leftSpecificity } = _ref4;
        let { specificity: rightSpecificity } = _ref5;
        return rightSpecificity - leftSpecificity;
    }
    function match(element) {
        let { attributes = [] } = element;
        // https://github.com/testing-library/dom-testing-library/issues/814
        const typeTextIndex = attributes.findIndex((attribute)=>attribute.value && attribute.name === "type" && attribute.value === "text");
        if (typeTextIndex >= 0) // not using splice to not mutate the attributes array
        attributes = [
            ...attributes.slice(0, typeTextIndex),
            ...attributes.slice(typeTextIndex + 1)
        ];
        const selector = makeElementSelector({
            ...element,
            attributes
        });
        return (node)=>{
            if (typeTextIndex >= 0 && node.type !== "text") return false;
            return node.matches(selector);
        };
    }
    let result = [];
    // eslint bug here:
    // eslint-disable-next-line no-unused-vars
    for (const [element, roles] of elementRolesMap.entries())result = [
        ...result,
        {
            match: match(element),
            roles: Array.from(roles),
            specificity: getSelectorSpecificity(element)
        }
    ];
    return result.sort(bySelectorSpecificity);
}
function getRoles(container, _temp) {
    let { hidden = false } = _temp === void 0 ? {} : _temp;
    function flattenDOM(node) {
        return [
            node,
            ...Array.from(node.children).reduce((acc, child)=>[
                    ...acc,
                    ...flattenDOM(child)
                ], [])
        ];
    }
    return flattenDOM(container).filter((element)=>{
        return hidden === false ? isInaccessible(element) === false : true;
    }).reduce((acc, node)=>{
        let roles = [];
        // TODO: This violates html-aria which does not allow any role on every element
        if (node.hasAttribute("role")) roles = node.getAttribute("role").split(" ").slice(0, 1);
        else roles = getImplicitAriaRoles(node);
        return roles.reduce((rolesAcc, role)=>Array.isArray(rolesAcc[role]) ? {
                ...rolesAcc,
                [role]: [
                    ...rolesAcc[role],
                    node
                ]
            } : {
                ...rolesAcc,
                [role]: [
                    node
                ]
            }, acc);
    }, {});
}
function prettyRoles(dom, _ref6) {
    let { hidden, includeDescription } = _ref6;
    const roles = getRoles(dom, {
        hidden
    });
    // We prefer to skip generic role, we don't recommend it
    return Object.entries(roles).filter((_ref7)=>{
        let [role] = _ref7;
        return role !== "generic";
    }).map((_ref8)=>{
        let [role, elements] = _ref8;
        const delimiterBar = "-".repeat(50);
        const elementsString = elements.map((el)=>{
            const nameString = 'Name "' + (0, _domAccessibilityApi.computeAccessibleName)(el, {
                computedStyleSupportsPseudoElements: getConfig().computedStyleSupportsPseudoElements
            }) + '":\n';
            const domString = prettyDOM(el.cloneNode(false));
            if (includeDescription) {
                const descriptionString = 'Description "' + (0, _domAccessibilityApi.computeAccessibleDescription)(el, {
                    computedStyleSupportsPseudoElements: getConfig().computedStyleSupportsPseudoElements
                }) + '":\n';
                return "" + nameString + descriptionString + domString;
            }
            return "" + nameString + domString;
        }).join("\n\n");
        return role + ":\n\n" + elementsString + "\n\n" + delimiterBar;
    }).join("\n");
}
const logRoles = function(dom, _temp2) {
    let { hidden = false } = _temp2 === void 0 ? {} : _temp2;
    return console.log(prettyRoles(dom, {
        hidden
    }));
};
/**
 * @param {Element} element -
 * @returns {boolean | undefined} - false/true if (not)selected, undefined if not selectable
 */ function computeAriaSelected(element) {
    // implicit value from html-aam mappings: https://www.w3.org/TR/html-aam-1.0/#html-attribute-state-and-property-mappings
    // https://www.w3.org/TR/html-aam-1.0/#details-id-97
    if (element.tagName === "OPTION") return element.selected;
    // explicit value
    return checkBooleanAttribute(element, "aria-selected");
}
/**
 * @param {Element} element -
 * @returns {boolean | undefined} - false/true if (not)checked, undefined if not checked-able
 */ function computeAriaChecked(element) {
    // implicit value from html-aam mappings: https://www.w3.org/TR/html-aam-1.0/#html-attribute-state-and-property-mappings
    // https://www.w3.org/TR/html-aam-1.0/#details-id-56
    // https://www.w3.org/TR/html-aam-1.0/#details-id-67
    if ("indeterminate" in element && element.indeterminate) return undefined;
    if ("checked" in element) return element.checked;
    // explicit value
    return checkBooleanAttribute(element, "aria-checked");
}
/**
 * @param {Element} element -
 * @returns {boolean | undefined} - false/true if (not)pressed, undefined if not press-able
 */ function computeAriaPressed(element) {
    // https://www.w3.org/TR/wai-aria-1.1/#aria-pressed
    return checkBooleanAttribute(element, "aria-pressed");
}
/**
 * @param {Element} element -
 * @returns {boolean | string | null} -
 */ function computeAriaCurrent(element) {
    var _ref9, _checkBooleanAttribut;
    // https://www.w3.org/TR/wai-aria-1.1/#aria-current
    return (_ref9 = (_checkBooleanAttribut = checkBooleanAttribute(element, "aria-current")) != null ? _checkBooleanAttribut : element.getAttribute("aria-current")) != null ? _ref9 : false;
}
/**
 * @param {Element} element -
 * @returns {boolean | undefined} - false/true if (not)expanded, undefined if not expand-able
 */ function computeAriaExpanded(element) {
    // https://www.w3.org/TR/wai-aria-1.1/#aria-expanded
    return checkBooleanAttribute(element, "aria-expanded");
}
function checkBooleanAttribute(element, attribute) {
    const attributeValue = element.getAttribute(attribute);
    if (attributeValue === "true") return true;
    if (attributeValue === "false") return false;
    return undefined;
}
/**
 * @param {Element} element -
 * @returns {number | undefined} - number if implicit heading or aria-level present, otherwise undefined
 */ function computeHeadingLevel(element) {
    // https://w3c.github.io/html-aam/#el-h1-h6
    // https://w3c.github.io/html-aam/#el-h1-h6
    const implicitHeadingLevels = {
        H1: 1,
        H2: 2,
        H3: 3,
        H4: 4,
        H5: 5,
        H6: 6
    };
    // explicit aria-level value
    // https://www.w3.org/TR/wai-aria-1.2/#aria-level
    const ariaLevelAttribute = element.getAttribute("aria-level") && Number(element.getAttribute("aria-level"));
    return ariaLevelAttribute || implicitHeadingLevels[element.tagName];
}
const normalize = getDefaultNormalizer();
function escapeRegExp(string) {
    return string.replace(/[.*+\-?^${}()|[\]\\]/g, "\\$&"); // $& means the whole matched string
}
function getRegExpMatcher(string) {
    return new RegExp(escapeRegExp(string.toLowerCase()), "i");
}
function makeSuggestion(queryName, element, content, _ref) {
    let { variant, name } = _ref;
    let warning = "";
    const queryOptions = {};
    const queryArgs = [
        [
            "Role",
            "TestId"
        ].includes(queryName) ? content : getRegExpMatcher(content)
    ];
    if (name) queryOptions.name = getRegExpMatcher(name);
    if (queryName === "Role" && isInaccessible(element)) {
        queryOptions.hidden = true;
        warning = "Element is inaccessible. This means that the element and all its children are invisible to screen readers.\n    If you are using the aria-hidden prop, make sure this is the right choice for your case.\n    ";
    }
    if (Object.keys(queryOptions).length > 0) queryArgs.push(queryOptions);
    const queryMethod = variant + "By" + queryName;
    return {
        queryName,
        queryMethod,
        queryArgs,
        variant,
        warning,
        toString () {
            if (warning) console.warn(warning);
            let [text, options] = queryArgs;
            text = typeof text === "string" ? "'" + text + "'" : text;
            options = options ? ", { " + Object.entries(options).map((_ref2)=>{
                let [k, v] = _ref2;
                return k + ": " + v;
            }).join(", ") + " }" : "";
            return queryMethod + "(" + text + options + ")";
        }
    };
}
function canSuggest(currentMethod, requestedMethod, data) {
    return data && (!requestedMethod || requestedMethod.toLowerCase() === currentMethod.toLowerCase());
}
function getSuggestedQuery(element, variant, method) {
    var _element$getAttribute, _getImplicitAriaRoles;
    if (variant === void 0) variant = "get";
    // don't create suggestions for script and style elements
    if (element.matches(getConfig().defaultIgnore)) return undefined;
    //We prefer to suggest something else if the role is generic
    const role = (_element$getAttribute = element.getAttribute("role")) != null ? _element$getAttribute : (_getImplicitAriaRoles = getImplicitAriaRoles(element)) == null ? void 0 : _getImplicitAriaRoles[0];
    if (role !== "generic" && canSuggest("Role", method, role)) return makeSuggestion("Role", element, role, {
        variant,
        name: (0, _domAccessibilityApi.computeAccessibleName)(element, {
            computedStyleSupportsPseudoElements: getConfig().computedStyleSupportsPseudoElements
        })
    });
    const labelText = getLabels(document, element).map((label)=>label.content).join(" ");
    if (canSuggest("LabelText", method, labelText)) return makeSuggestion("LabelText", element, labelText, {
        variant
    });
    const placeholderText = element.getAttribute("placeholder");
    if (canSuggest("PlaceholderText", method, placeholderText)) return makeSuggestion("PlaceholderText", element, placeholderText, {
        variant
    });
    const textContent = normalize(getNodeText(element));
    if (canSuggest("Text", method, textContent)) return makeSuggestion("Text", element, textContent, {
        variant
    });
    if (canSuggest("DisplayValue", method, element.value)) return makeSuggestion("DisplayValue", element, normalize(element.value), {
        variant
    });
    const alt = element.getAttribute("alt");
    if (canSuggest("AltText", method, alt)) return makeSuggestion("AltText", element, alt, {
        variant
    });
    const title = element.getAttribute("title");
    if (canSuggest("Title", method, title)) return makeSuggestion("Title", element, title, {
        variant
    });
    const testId = element.getAttribute(getConfig().testIdAttribute);
    if (canSuggest("TestId", method, testId)) return makeSuggestion("TestId", element, testId, {
        variant
    });
    return undefined;
}
// This is so the stack trace the developer sees is one that's
// closer to their code (because async stack traces are hard to follow).
function copyStackTrace(target, source) {
    target.stack = source.stack.replace(source.message, target.message);
}
function waitFor(callback, _ref) {
    let { container = getDocument(), timeout = getConfig().asyncUtilTimeout, showOriginalStackTrace = getConfig().showOriginalStackTrace, stackTraceError, interval = 50, onTimeout = (error)=>{
        error.message = getConfig().getElementError(error.message, container).message;
        return error;
    }, mutationObserverOptions = {
        subtree: true,
        childList: true,
        attributes: true,
        characterData: true
    } } = _ref;
    if (typeof callback !== "function") throw new TypeError("Received `callback` arg must be a function");
    return new Promise(async (resolve, reject)=>{
        let lastError, intervalId, observer;
        let finished = false;
        let promiseStatus = "idle";
        const overallTimeoutTimer = setTimeout(handleTimeout, timeout);
        const usingJestFakeTimers = jestFakeTimersAreEnabled();
        if (usingJestFakeTimers) {
            const { unstable_advanceTimersWrapper: advanceTimersWrapper } = getConfig();
            checkCallback();
            // this is a dangerous rule to disable because it could lead to an
            // infinite loop. However, eslint isn't smart enough to know that we're
            // setting finished inside `onDone` which will be called when we're done
            // waiting or when we've timed out.
            // eslint-disable-next-line no-unmodified-loop-condition
            while(!finished){
                if (!jestFakeTimersAreEnabled()) {
                    const error = new Error("Changed from using fake timers to real timers while using waitFor. This is not allowed and will result in very strange behavior. Please ensure you're awaiting all async things your test is doing before changing to real timers. For more info, please go to https://github.com/testing-library/dom-testing-library/issues/830");
                    if (!showOriginalStackTrace) copyStackTrace(error, stackTraceError);
                    reject(error);
                    return;
                }
                // we *could* (maybe should?) use `advanceTimersToNextTimer` but it's
                // possible that could make this loop go on forever if someone is using
                // third party code that's setting up recursive timers so rapidly that
                // the user's timer's don't get a chance to resolve. So we'll advance
                // by an interval instead. (We have a test for this case).
                advanceTimersWrapper(()=>{
                    jest.advanceTimersByTime(interval);
                });
                // It's really important that checkCallback is run *before* we flush
                // in-flight promises. To be honest, I'm not sure why, and I can't quite
                // think of a way to reproduce the problem in a test, but I spent
                // an entire day banging my head against a wall on this.
                checkCallback();
                if (finished) break;
                // In this rare case, we *need* to wait for in-flight promises
                // to resolve before continuing. We don't need to take advantage
                // of parallelization so we're fine.
                // https://stackoverflow.com/a/59243586/971592
                // eslint-disable-next-line no-await-in-loop
                await advanceTimersWrapper(async ()=>{
                    await new Promise((r)=>{
                        setTimeout(r, 0);
                        jest.advanceTimersByTime(0);
                    });
                });
            }
        } else {
            try {
                checkContainerType(container);
            } catch (e) {
                reject(e);
                return;
            }
            intervalId = setInterval(checkRealTimersCallback, interval);
            const { MutationObserver } = getWindowFromNode(container);
            observer = new MutationObserver(checkRealTimersCallback);
            observer.observe(container, mutationObserverOptions);
            checkCallback();
        }
        function onDone(error, result) {
            finished = true;
            clearTimeout(overallTimeoutTimer);
            if (!usingJestFakeTimers) {
                clearInterval(intervalId);
                observer.disconnect();
            }
            if (error) reject(error);
            else resolve(result);
        }
        function checkRealTimersCallback() {
            if (jestFakeTimersAreEnabled()) {
                const error = new Error("Changed from using real timers to fake timers while using waitFor. This is not allowed and will result in very strange behavior. Please ensure you're awaiting all async things your test is doing before changing to fake timers. For more info, please go to https://github.com/testing-library/dom-testing-library/issues/830");
                if (!showOriginalStackTrace) copyStackTrace(error, stackTraceError);
                return reject(error);
            } else return checkCallback();
        }
        function checkCallback() {
            if (promiseStatus === "pending") return;
            try {
                const result = runWithExpensiveErrorDiagnosticsDisabled(callback);
                if (typeof (result == null ? void 0 : result.then) === "function") {
                    promiseStatus = "pending";
                    result.then((resolvedValue)=>{
                        promiseStatus = "resolved";
                        onDone(null, resolvedValue);
                    }, (rejectedValue)=>{
                        promiseStatus = "rejected";
                        lastError = rejectedValue;
                    });
                } else onDone(null, result);
            // If `callback` throws, wait for the next mutation, interval, or timeout.
            } catch (error) {
                // Save the most recent callback error to reject the promise with it in the event of a timeout
                lastError = error;
            }
        }
        function handleTimeout() {
            let error;
            if (lastError) {
                error = lastError;
                if (!showOriginalStackTrace && error.name === "TestingLibraryElementError") copyStackTrace(error, stackTraceError);
            } else {
                error = new Error("Timed out in waitFor.");
                if (!showOriginalStackTrace) copyStackTrace(error, stackTraceError);
            }
            onDone(onTimeout(error), null);
        }
    });
}
function waitForWrapper(callback, options) {
    // create the error here so its stack trace is as close to the
    // calling code as possible
    const stackTraceError = new Error("STACK_TRACE_MESSAGE");
    return getConfig().asyncWrapper(()=>waitFor(callback, {
            stackTraceError,
            ...options
        }));
}
/*
eslint
  max-lines-per-function: ["error", {"max": 200}],
*/ function getElementError(message, container) {
    return getConfig().getElementError(message, container);
}
function getMultipleElementsFoundError(message, container) {
    return getElementError(message + "\n\n(If this is intentional, then use the `*AllBy*` variant of the query (like `queryAllByText`, `getAllByText`, or `findAllByText`)).", container);
}
function queryAllByAttribute(attribute, container, text, _temp) {
    let { exact = true, collapseWhitespace, trim, normalizer } = _temp === void 0 ? {} : _temp;
    const matcher = exact ? matches : fuzzyMatches;
    const matchNormalizer = makeNormalizer({
        collapseWhitespace,
        trim,
        normalizer
    });
    return Array.from(container.querySelectorAll("[" + attribute + "]")).filter((node)=>matcher(node.getAttribute(attribute), node, text, matchNormalizer));
}
function queryByAttribute(attribute, container, text, options) {
    const els = queryAllByAttribute(attribute, container, text, options);
    if (els.length > 1) throw getMultipleElementsFoundError("Found multiple elements by [" + attribute + "=" + text + "]", container);
    return els[0] || null;
}
// this accepts a query function and returns a function which throws an error
// if more than one elements is returned, otherwise it returns the first
// element or null
function makeSingleQuery(allQuery, getMultipleError) {
    return function(container) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        const els = allQuery(container, ...args);
        if (els.length > 1) {
            const elementStrings = els.map((element)=>getElementError(null, element).message).join("\n\n");
            throw getMultipleElementsFoundError(getMultipleError(container, ...args) + "\n\nHere are the matching elements:\n\n" + elementStrings, container);
        }
        return els[0] || null;
    };
}
function getSuggestionError(suggestion, container) {
    return getConfig().getElementError("A better query is available, try this:\n" + suggestion.toString() + "\n", container);
}
// this accepts a query function and returns a function which throws an error
// if an empty list of elements is returned
function makeGetAllQuery(allQuery, getMissingError) {
    return function(container) {
        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
        const els = allQuery(container, ...args);
        if (!els.length) throw getConfig().getElementError(getMissingError(container, ...args), container);
        return els;
    };
}
// this accepts a getter query function and returns a function which calls
// waitFor and passing a function which invokes the getter.
function makeFindQuery(getter) {
    return (container, text, options, waitForOptions)=>{
        return waitForWrapper(()=>{
            return getter(container, text, options);
        }, {
            container,
            ...waitForOptions
        });
    };
}
const wrapSingleQueryWithSuggestion = (query, queryAllByName, variant)=>function(container) {
        for(var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)args[_key3 - 1] = arguments[_key3];
        const element = query(container, ...args);
        const [{ suggest = getConfig().throwSuggestions } = {}] = args.slice(-1);
        if (element && suggest) {
            const suggestion = getSuggestedQuery(element, variant);
            if (suggestion && !queryAllByName.endsWith(suggestion.queryName)) throw getSuggestionError(suggestion.toString(), container);
        }
        return element;
    };
const wrapAllByQueryWithSuggestion = (query, queryAllByName, variant)=>function(container) {
        for(var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++)args[_key4 - 1] = arguments[_key4];
        const els = query(container, ...args);
        const [{ suggest = getConfig().throwSuggestions } = {}] = args.slice(-1);
        if (els.length && suggest) {
            // get a unique list of all suggestion messages.  We are only going to make a suggestion if
            // all the suggestions are the same
            const uniqueSuggestionMessages = [
                ...new Set(els.map((element)=>{
                    var _getSuggestedQuery;
                    return (_getSuggestedQuery = getSuggestedQuery(element, variant)) == null ? void 0 : _getSuggestedQuery.toString();
                }))
            ];
            if (// only want to suggest if all the els have the same suggestion.
            uniqueSuggestionMessages.length === 1 && !queryAllByName.endsWith(// eslint-disable-next-line @typescript-eslint/no-non-null-assertion -- TODO: Can this be null at runtime?
            getSuggestedQuery(els[0], variant).queryName)) throw getSuggestionError(uniqueSuggestionMessages[0], container);
        }
        return els;
    };
// TODO: This deviates from the published declarations
// However, the implementation always required a dyadic (after `container`) not variadic `queryAllBy` considering the implementation of `makeFindQuery`
// This is at least statically true and can be verified by accepting `QueryMethod<Arguments, HTMLElement[]>`
function buildQueries(queryAllBy, getMultipleError, getMissingError) {
    const queryBy = wrapSingleQueryWithSuggestion(makeSingleQuery(queryAllBy, getMultipleError), queryAllBy.name, "query");
    const getAllBy = makeGetAllQuery(queryAllBy, getMissingError);
    const getBy = makeSingleQuery(getAllBy, getMultipleError);
    const getByWithSuggestions = wrapSingleQueryWithSuggestion(getBy, queryAllBy.name, "get");
    const getAllWithSuggestions = wrapAllByQueryWithSuggestion(getAllBy, queryAllBy.name.replace("query", "get"), "getAll");
    const findAllBy = makeFindQuery(wrapAllByQueryWithSuggestion(getAllBy, queryAllBy.name, "findAll"));
    const findBy = makeFindQuery(wrapSingleQueryWithSuggestion(getBy, queryAllBy.name, "find"));
    return [
        queryBy,
        getAllWithSuggestions,
        getByWithSuggestions,
        findAllBy,
        findBy
    ];
}
var queryHelpers = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    getElementError: getElementError,
    wrapAllByQueryWithSuggestion: wrapAllByQueryWithSuggestion,
    wrapSingleQueryWithSuggestion: wrapSingleQueryWithSuggestion,
    getMultipleElementsFoundError: getMultipleElementsFoundError,
    queryAllByAttribute: queryAllByAttribute,
    queryByAttribute: queryByAttribute,
    makeSingleQuery: makeSingleQuery,
    makeGetAllQuery: makeGetAllQuery,
    makeFindQuery: makeFindQuery,
    buildQueries: buildQueries
});
function queryAllLabels(container) {
    return Array.from(container.querySelectorAll("label,input")).map((node)=>{
        return {
            node,
            textToMatch: getLabelContent(node)
        };
    }).filter((_ref)=>{
        let { textToMatch } = _ref;
        return textToMatch !== null;
    });
}
const queryAllLabelsByText = function(container, text, _temp) {
    let { exact = true, trim, collapseWhitespace, normalizer } = _temp === void 0 ? {} : _temp;
    const matcher = exact ? matches : fuzzyMatches;
    const matchNormalizer = makeNormalizer({
        collapseWhitespace,
        trim,
        normalizer
    });
    const textToMatchByLabels = queryAllLabels(container);
    return textToMatchByLabels.filter((_ref2)=>{
        let { node, textToMatch } = _ref2;
        return matcher(textToMatch, node, text, matchNormalizer);
    }).map((_ref3)=>{
        let { node } = _ref3;
        return node;
    });
};
const queryAllByLabelText = function(container, text, _temp2) {
    let { selector = "*", exact = true, collapseWhitespace, trim, normalizer } = _temp2 === void 0 ? {} : _temp2;
    checkContainerType(container);
    const matcher = exact ? matches : fuzzyMatches;
    const matchNormalizer = makeNormalizer({
        collapseWhitespace,
        trim,
        normalizer
    });
    const matchingLabelledElements = Array.from(container.querySelectorAll("*")).filter((element)=>{
        return getRealLabels(element).length || element.hasAttribute("aria-labelledby");
    }).reduce((labelledElements, labelledElement)=>{
        const labelList = getLabels(container, labelledElement, {
            selector
        });
        labelList.filter((label)=>Boolean(label.formControl)).forEach((label)=>{
            if (matcher(label.content, label.formControl, text, matchNormalizer) && label.formControl) labelledElements.push(label.formControl);
        });
        const labelsValue = labelList.filter((label)=>Boolean(label.content)).map((label)=>label.content);
        if (matcher(labelsValue.join(" "), labelledElement, text, matchNormalizer)) labelledElements.push(labelledElement);
        if (labelsValue.length > 1) labelsValue.forEach((labelValue, index)=>{
            if (matcher(labelValue, labelledElement, text, matchNormalizer)) labelledElements.push(labelledElement);
            const labelsFiltered = [
                ...labelsValue
            ];
            labelsFiltered.splice(index, 1);
            if (labelsFiltered.length > 1) {
                if (matcher(labelsFiltered.join(" "), labelledElement, text, matchNormalizer)) labelledElements.push(labelledElement);
            }
        });
        return labelledElements;
    }, []).concat(queryAllByAttribute("aria-label", container, text, {
        exact,
        normalizer: matchNormalizer
    }));
    return Array.from(new Set(matchingLabelledElements)).filter((element)=>element.matches(selector));
};
// the getAll* query would normally look like this:
// const getAllByLabelText = makeGetAllQuery(
//   queryAllByLabelText,
//   (c, text) => `Unable to find a label with the text of: ${text}`,
// )
// however, we can give a more helpful error message than the generic one,
// so we're writing this one out by hand.
const getAllByLabelText = function(container, text) {
    for(var _len = arguments.length, rest = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)rest[_key - 2] = arguments[_key];
    const els = queryAllByLabelText(container, text, ...rest);
    if (!els.length) {
        const labels = queryAllLabelsByText(container, text, ...rest);
        if (labels.length) {
            const tagNames = labels.map((label)=>getTagNameOfElementAssociatedWithLabelViaFor(container, label)).filter((tagName)=>!!tagName);
            if (tagNames.length) throw getConfig().getElementError(tagNames.map((tagName)=>"Found a label with the text of: " + text + ", however the element associated with this label (<" + tagName + " />) is non-labellable [https://html.spec.whatwg.org/multipage/forms.html#category-label]. If you really need to label a <" + tagName + " />, you can use aria-label or aria-labelledby instead.").join("\n\n"), container);
            else throw getConfig().getElementError("Found a label with the text of: " + text + ', however no form control was found associated to that label. Make sure you\'re using the "for" attribute or "aria-labelledby" attribute correctly.', container);
        } else throw getConfig().getElementError("Unable to find a label with the text of: " + text, container);
    }
    return els;
};
function getTagNameOfElementAssociatedWithLabelViaFor(container, label) {
    const htmlFor = label.getAttribute("for");
    if (!htmlFor) return null;
    const element = container.querySelector('[id="' + htmlFor + '"]');
    return element ? element.tagName.toLowerCase() : null;
}
// the reason mentioned above is the same reason we're not using buildQueries
const getMultipleError$7 = (c, text)=>"Found multiple elements with the text of: " + text;
const queryByLabelText = wrapSingleQueryWithSuggestion(makeSingleQuery(queryAllByLabelText, getMultipleError$7), queryAllByLabelText.name, "query");
const getByLabelText = makeSingleQuery(getAllByLabelText, getMultipleError$7);
const findAllByLabelText = makeFindQuery(wrapAllByQueryWithSuggestion(getAllByLabelText, getAllByLabelText.name, "findAll"));
const findByLabelText = makeFindQuery(wrapSingleQueryWithSuggestion(getByLabelText, getAllByLabelText.name, "find"));
const getAllByLabelTextWithSuggestions = wrapAllByQueryWithSuggestion(getAllByLabelText, getAllByLabelText.name, "getAll");
const getByLabelTextWithSuggestions = wrapSingleQueryWithSuggestion(getByLabelText, getAllByLabelText.name, "get");
const queryAllByLabelTextWithSuggestions = wrapAllByQueryWithSuggestion(queryAllByLabelText, queryAllByLabelText.name, "queryAll");
const queryAllByPlaceholderText = function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    checkContainerType(args[0]);
    return queryAllByAttribute("placeholder", ...args);
};
const getMultipleError$6 = (c, text)=>"Found multiple elements with the placeholder text of: " + text;
const getMissingError$6 = (c, text)=>"Unable to find an element with the placeholder text of: " + text;
const queryAllByPlaceholderTextWithSuggestions = wrapAllByQueryWithSuggestion(queryAllByPlaceholderText, queryAllByPlaceholderText.name, "queryAll");
const [queryByPlaceholderText, getAllByPlaceholderText, getByPlaceholderText, findAllByPlaceholderText, findByPlaceholderText] = buildQueries(queryAllByPlaceholderText, getMultipleError$6, getMissingError$6);
const queryAllByText = function(container, text, _temp) {
    let { selector = "*", exact = true, collapseWhitespace, trim, ignore = getConfig().defaultIgnore, normalizer } = _temp === void 0 ? {} : _temp;
    checkContainerType(container);
    const matcher = exact ? matches : fuzzyMatches;
    const matchNormalizer = makeNormalizer({
        collapseWhitespace,
        trim,
        normalizer
    });
    let baseArray = [];
    if (typeof container.matches === "function" && container.matches(selector)) baseArray = [
        container
    ];
    return [
        ...baseArray,
        ...Array.from(container.querySelectorAll(selector))
    ]// TODO: `matches` according lib.dom.d.ts can get only `string` but according our code it can handle also boolean :)
    .filter((node)=>!ignore || !node.matches(ignore)).filter((node)=>matcher(getNodeText(node), node, text, matchNormalizer));
};
const getMultipleError$5 = (c, text)=>"Found multiple elements with the text: " + text;
const getMissingError$5 = function(c, text, options) {
    if (options === void 0) options = {};
    const { collapseWhitespace, trim, normalizer, selector } = options;
    const matchNormalizer = makeNormalizer({
        collapseWhitespace,
        trim,
        normalizer
    });
    const normalizedText = matchNormalizer(text.toString());
    const isNormalizedDifferent = normalizedText !== text.toString();
    const isCustomSelector = (selector != null ? selector : "*") !== "*";
    return "Unable to find an element with the text: " + (isNormalizedDifferent ? normalizedText + " (normalized from '" + text + "')" : text) + (isCustomSelector ? ", which matches selector '" + selector + "'" : "") + ". This could be because the text is broken up by multiple elements. In this case, you can provide a function for your text matcher to make your matcher more flexible.";
};
const queryAllByTextWithSuggestions = wrapAllByQueryWithSuggestion(queryAllByText, queryAllByText.name, "queryAll");
const [queryByText, getAllByText, getByText, findAllByText, findByText] = buildQueries(queryAllByText, getMultipleError$5, getMissingError$5);
const queryAllByDisplayValue = function(container, value, _temp) {
    let { exact = true, collapseWhitespace, trim, normalizer } = _temp === void 0 ? {} : _temp;
    checkContainerType(container);
    const matcher = exact ? matches : fuzzyMatches;
    const matchNormalizer = makeNormalizer({
        collapseWhitespace,
        trim,
        normalizer
    });
    return Array.from(container.querySelectorAll("input,textarea,select")).filter((node)=>{
        if (node.tagName === "SELECT") {
            const selectedOptions = Array.from(node.options).filter((option)=>option.selected);
            return selectedOptions.some((optionNode)=>matcher(getNodeText(optionNode), optionNode, value, matchNormalizer));
        } else return matcher(node.value, node, value, matchNormalizer);
    });
};
const getMultipleError$4 = (c, value)=>"Found multiple elements with the display value: " + value + ".";
const getMissingError$4 = (c, value)=>"Unable to find an element with the display value: " + value + ".";
const queryAllByDisplayValueWithSuggestions = wrapAllByQueryWithSuggestion(queryAllByDisplayValue, queryAllByDisplayValue.name, "queryAll");
const [queryByDisplayValue, getAllByDisplayValue, getByDisplayValue, findAllByDisplayValue, findByDisplayValue] = buildQueries(queryAllByDisplayValue, getMultipleError$4, getMissingError$4);
// Valid tags are img, input, area and custom elements
const VALID_TAG_REGEXP = /^(img|input|area|.+-.+)$/i;
const queryAllByAltText = function(container, alt, options) {
    if (options === void 0) options = {};
    checkContainerType(container);
    return queryAllByAttribute("alt", container, alt, options).filter((node)=>VALID_TAG_REGEXP.test(node.tagName));
};
const getMultipleError$3 = (c, alt)=>"Found multiple elements with the alt text: " + alt;
const getMissingError$3 = (c, alt)=>"Unable to find an element with the alt text: " + alt;
const queryAllByAltTextWithSuggestions = wrapAllByQueryWithSuggestion(queryAllByAltText, queryAllByAltText.name, "queryAll");
const [queryByAltText, getAllByAltText, getByAltText, findAllByAltText, findByAltText] = buildQueries(queryAllByAltText, getMultipleError$3, getMissingError$3);
const isSvgTitle = (node)=>{
    var _node$parentElement;
    return node.tagName.toLowerCase() === "title" && ((_node$parentElement = node.parentElement) == null ? void 0 : _node$parentElement.tagName.toLowerCase()) === "svg";
};
const queryAllByTitle = function(container, text, _temp) {
    let { exact = true, collapseWhitespace, trim, normalizer } = _temp === void 0 ? {} : _temp;
    checkContainerType(container);
    const matcher = exact ? matches : fuzzyMatches;
    const matchNormalizer = makeNormalizer({
        collapseWhitespace,
        trim,
        normalizer
    });
    return Array.from(container.querySelectorAll("[title], svg > title")).filter((node)=>matcher(node.getAttribute("title"), node, text, matchNormalizer) || isSvgTitle(node) && matcher(getNodeText(node), node, text, matchNormalizer));
};
const getMultipleError$2 = (c, title)=>"Found multiple elements with the title: " + title + ".";
const getMissingError$2 = (c, title)=>"Unable to find an element with the title: " + title + ".";
const queryAllByTitleWithSuggestions = wrapAllByQueryWithSuggestion(queryAllByTitle, queryAllByTitle.name, "queryAll");
const [queryByTitle, getAllByTitle, getByTitle, findAllByTitle, findByTitle] = buildQueries(queryAllByTitle, getMultipleError$2, getMissingError$2);
function queryAllByRole(container, role, _temp) {
    let { exact = true, collapseWhitespace, hidden = getConfig().defaultHidden, name, description, trim, normalizer, queryFallbacks = false, selected, checked, pressed, current, level, expanded } = _temp === void 0 ? {} : _temp;
    checkContainerType(container);
    const matcher = exact ? matches : fuzzyMatches;
    const matchNormalizer = makeNormalizer({
        collapseWhitespace,
        trim,
        normalizer
    });
    if (selected !== undefined) {
        var _allRoles$get;
        // guard against unknown roles
        if (((_allRoles$get = (0, _ariaQuery.roles).get(role)) == null ? void 0 : _allRoles$get.props["aria-selected"]) === undefined) throw new Error('"aria-selected" is not supported on role "' + role + '".');
    }
    if (checked !== undefined) {
        var _allRoles$get2;
        // guard against unknown roles
        if (((_allRoles$get2 = (0, _ariaQuery.roles).get(role)) == null ? void 0 : _allRoles$get2.props["aria-checked"]) === undefined) throw new Error('"aria-checked" is not supported on role "' + role + '".');
    }
    if (pressed !== undefined) {
        var _allRoles$get3;
        // guard against unknown roles
        if (((_allRoles$get3 = (0, _ariaQuery.roles).get(role)) == null ? void 0 : _allRoles$get3.props["aria-pressed"]) === undefined) throw new Error('"aria-pressed" is not supported on role "' + role + '".');
    }
    if (current !== undefined) {
        var _allRoles$get4;
        /* istanbul ignore next */ // guard against unknown roles
        // All currently released ARIA versions support `aria-current` on all roles.
        // Leaving this for symetry and forward compatibility
        if (((_allRoles$get4 = (0, _ariaQuery.roles).get(role)) == null ? void 0 : _allRoles$get4.props["aria-current"]) === undefined) throw new Error('"aria-current" is not supported on role "' + role + '".');
    }
    if (level !== undefined) {
        // guard against using `level` option with any role other than `heading`
        if (role !== "heading") throw new Error('Role "' + role + '" cannot have "level" property.');
    }
    if (expanded !== undefined) {
        var _allRoles$get5;
        // guard against unknown roles
        if (((_allRoles$get5 = (0, _ariaQuery.roles).get(role)) == null ? void 0 : _allRoles$get5.props["aria-expanded"]) === undefined) throw new Error('"aria-expanded" is not supported on role "' + role + '".');
    }
    const subtreeIsInaccessibleCache = new WeakMap();
    function cachedIsSubtreeInaccessible(element) {
        if (!subtreeIsInaccessibleCache.has(element)) subtreeIsInaccessibleCache.set(element, isSubtreeInaccessible(element));
        return subtreeIsInaccessibleCache.get(element);
    }
    return Array.from(container.querySelectorAll(// Only query elements that can be matched by the following filters
    makeRoleSelector(role, exact, normalizer ? matchNormalizer : undefined))).filter((node)=>{
        const isRoleSpecifiedExplicitly = node.hasAttribute("role");
        if (isRoleSpecifiedExplicitly) {
            const roleValue = node.getAttribute("role");
            if (queryFallbacks) return roleValue.split(" ").filter(Boolean).some((text)=>matcher(text, node, role, matchNormalizer));
            // if a custom normalizer is passed then let normalizer handle the role value
            if (normalizer) return matcher(roleValue, node, role, matchNormalizer);
            // other wise only send the first word to match
            const [firstWord] = roleValue.split(" ");
            return matcher(firstWord, node, role, matchNormalizer);
        }
        const implicitRoles = getImplicitAriaRoles(node);
        return implicitRoles.some((implicitRole)=>matcher(implicitRole, node, role, matchNormalizer));
    }).filter((element)=>{
        if (selected !== undefined) return selected === computeAriaSelected(element);
        if (checked !== undefined) return checked === computeAriaChecked(element);
        if (pressed !== undefined) return pressed === computeAriaPressed(element);
        if (current !== undefined) return current === computeAriaCurrent(element);
        if (expanded !== undefined) return expanded === computeAriaExpanded(element);
        if (level !== undefined) return level === computeHeadingLevel(element);
        // don't care if aria attributes are unspecified
        return true;
    }).filter((element)=>{
        if (name === undefined) // Don't care
        return true;
        return matches((0, _domAccessibilityApi.computeAccessibleName)(element, {
            computedStyleSupportsPseudoElements: getConfig().computedStyleSupportsPseudoElements
        }), element, name, (text)=>text);
    }).filter((element)=>{
        if (description === undefined) // Don't care
        return true;
        return matches((0, _domAccessibilityApi.computeAccessibleDescription)(element, {
            computedStyleSupportsPseudoElements: getConfig().computedStyleSupportsPseudoElements
        }), element, description, (text)=>text);
    }).filter((element)=>{
        return hidden === false ? isInaccessible(element, {
            isSubtreeInaccessible: cachedIsSubtreeInaccessible
        }) === false : true;
    });
}
function makeRoleSelector(role, exact, customNormalizer) {
    var _roleElements$get;
    if (typeof role !== "string") // For non-string role parameters we can not determine the implicitRoleSelectors.
    return "*";
    const explicitRoleSelector = exact && !customNormalizer ? '*[role~="' + role + '"]' : "*[role]";
    const roleRelations = (_roleElements$get = (0, _ariaQuery.roleElements).get(role)) != null ? _roleElements$get : new Set();
    const implicitRoleSelectors = new Set(Array.from(roleRelations).map((_ref)=>{
        let { name } = _ref;
        return name;
    }));
    // Current transpilation config sometimes assumes `...` is always applied to arrays.
    // `...` is equivalent to `Array.prototype.concat` for arrays.
    // If you replace this code with `[explicitRoleSelector, ...implicitRoleSelectors]`, make sure every transpilation target retains the `...` in favor of `Array.prototype.concat`.
    return [
        explicitRoleSelector
    ].concat(Array.from(implicitRoleSelectors)).join(",");
}
const getNameHint = (name)=>{
    let nameHint = "";
    if (name === undefined) nameHint = "";
    else if (typeof name === "string") nameHint = ' and name "' + name + '"';
    else nameHint = " and name `" + name + "`";
    return nameHint;
};
const getMultipleError$1 = function(c, role, _temp2) {
    let { name } = _temp2 === void 0 ? {} : _temp2;
    return 'Found multiple elements with the role "' + role + '"' + getNameHint(name);
};
const getMissingError$1 = function(container, role, _temp3) {
    let { hidden = getConfig().defaultHidden, name, description } = _temp3 === void 0 ? {} : _temp3;
    if (getConfig()._disableExpensiveErrorDiagnostics) return 'Unable to find role="' + role + '"' + getNameHint(name);
    let roles = "";
    Array.from(container.children).forEach((childElement)=>{
        roles += prettyRoles(childElement, {
            hidden,
            includeDescription: description !== undefined
        });
    });
    let roleMessage;
    if (roles.length === 0) {
        if (hidden === false) roleMessage = "There are no accessible roles. But there might be some inaccessible roles. If you wish to access them, then set the `hidden` option to `true`. Learn more about this here: https://testing-library.com/docs/dom-testing-library/api-queries#byrole";
        else roleMessage = "There are no available roles.";
    } else roleMessage = ("\nHere are the " + (hidden === false ? "accessible" : "available") + " roles:\n\n  " + roles.replace(/\n/g, "\n  ").replace(/\n\s\s\n/g, "\n\n") + "\n").trim();
    let nameHint = "";
    if (name === undefined) nameHint = "";
    else if (typeof name === "string") nameHint = ' and name "' + name + '"';
    else nameHint = " and name `" + name + "`";
    let descriptionHint = "";
    if (description === undefined) descriptionHint = "";
    else if (typeof description === "string") descriptionHint = ' and description "' + description + '"';
    else descriptionHint = " and description `" + description + "`";
    return ("\nUnable to find an " + (hidden === false ? "accessible " : "") + 'element with the role "' + role + '"' + nameHint + descriptionHint + "\n\n" + roleMessage).trim();
};
const queryAllByRoleWithSuggestions = wrapAllByQueryWithSuggestion(queryAllByRole, queryAllByRole.name, "queryAll");
const [queryByRole, getAllByRole, getByRole, findAllByRole, findByRole] = buildQueries(queryAllByRole, getMultipleError$1, getMissingError$1);
const getTestIdAttribute = ()=>getConfig().testIdAttribute;
const queryAllByTestId = function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    checkContainerType(args[0]);
    return queryAllByAttribute(getTestIdAttribute(), ...args);
};
const getMultipleError = (c, id)=>"Found multiple elements by: [" + getTestIdAttribute() + '="' + id + '"]';
const getMissingError = (c, id)=>"Unable to find an element by: [" + getTestIdAttribute() + '="' + id + '"]';
const queryAllByTestIdWithSuggestions = wrapAllByQueryWithSuggestion(queryAllByTestId, queryAllByTestId.name, "queryAll");
const [queryByTestId, getAllByTestId, getByTestId, findAllByTestId, findByTestId] = buildQueries(queryAllByTestId, getMultipleError, getMissingError);
var queries = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    queryAllByLabelText: queryAllByLabelTextWithSuggestions,
    queryByLabelText: queryByLabelText,
    getAllByLabelText: getAllByLabelTextWithSuggestions,
    getByLabelText: getByLabelTextWithSuggestions,
    findAllByLabelText: findAllByLabelText,
    findByLabelText: findByLabelText,
    queryByPlaceholderText: queryByPlaceholderText,
    queryAllByPlaceholderText: queryAllByPlaceholderTextWithSuggestions,
    getByPlaceholderText: getByPlaceholderText,
    getAllByPlaceholderText: getAllByPlaceholderText,
    findAllByPlaceholderText: findAllByPlaceholderText,
    findByPlaceholderText: findByPlaceholderText,
    queryByText: queryByText,
    queryAllByText: queryAllByTextWithSuggestions,
    getByText: getByText,
    getAllByText: getAllByText,
    findAllByText: findAllByText,
    findByText: findByText,
    queryByDisplayValue: queryByDisplayValue,
    queryAllByDisplayValue: queryAllByDisplayValueWithSuggestions,
    getByDisplayValue: getByDisplayValue,
    getAllByDisplayValue: getAllByDisplayValue,
    findAllByDisplayValue: findAllByDisplayValue,
    findByDisplayValue: findByDisplayValue,
    queryByAltText: queryByAltText,
    queryAllByAltText: queryAllByAltTextWithSuggestions,
    getByAltText: getByAltText,
    getAllByAltText: getAllByAltText,
    findAllByAltText: findAllByAltText,
    findByAltText: findByAltText,
    queryByTitle: queryByTitle,
    queryAllByTitle: queryAllByTitleWithSuggestions,
    getByTitle: getByTitle,
    getAllByTitle: getAllByTitle,
    findAllByTitle: findAllByTitle,
    findByTitle: findByTitle,
    queryByRole: queryByRole,
    queryAllByRole: queryAllByRoleWithSuggestions,
    getAllByRole: getAllByRole,
    getByRole: getByRole,
    findAllByRole: findAllByRole,
    findByRole: findByRole,
    queryByTestId: queryByTestId,
    queryAllByTestId: queryAllByTestIdWithSuggestions,
    getByTestId: getByTestId,
    getAllByTestId: getAllByTestId,
    findAllByTestId: findAllByTestId,
    findByTestId: findByTestId
});
/**
 * @typedef {{[key: string]: Function}} FuncMap
 */ /**
 * @param {HTMLElement} element container
 * @param {FuncMap} queries object of functions
 * @param {Object} initialValue for reducer
 * @returns {FuncMap} returns object of functions bound to container
 */ function getQueriesForElement(element, queries$1, initialValue) {
    if (queries$1 === void 0) queries$1 = queries;
    if (initialValue === void 0) initialValue = {};
    return Object.keys(queries$1).reduce((helpers, key)=>{
        const fn = queries$1[key];
        helpers[key] = fn.bind(null, element);
        return helpers;
    }, initialValue);
}
const isRemoved = (result)=>!result || Array.isArray(result) && !result.length;
// Check if the element is not present.
// As the name implies, waitForElementToBeRemoved should check `present` --> `removed`
function initialCheck(elements) {
    if (isRemoved(elements)) throw new Error("The element(s) given to waitForElementToBeRemoved are already removed. waitForElementToBeRemoved requires that the element(s) exist(s) before waiting for removal.");
}
async function waitForElementToBeRemoved(callback, options) {
    // created here so we get a nice stacktrace
    const timeoutError = new Error("Timed out in waitForElementToBeRemoved.");
    if (typeof callback !== "function") {
        initialCheck(callback);
        const elements = Array.isArray(callback) ? callback : [
            callback
        ];
        const getRemainingElements = elements.map((element)=>{
            let parent = element.parentElement;
            if (parent === null) return ()=>null;
            while(parent.parentElement)parent = parent.parentElement;
            return ()=>parent.contains(element) ? element : null;
        });
        callback = ()=>getRemainingElements.map((c)=>c()).filter(Boolean);
    }
    initialCheck(callback());
    return waitForWrapper(()=>{
        let result;
        try {
            result = callback();
        } catch (error) {
            if (error.name === "TestingLibraryElementError") return undefined;
            throw error;
        }
        if (!isRemoved(result)) throw timeoutError;
        return undefined;
    }, options);
}
/*
eslint
  require-await: "off"
*/ const eventMap = {
    // Clipboard Events
    copy: {
        EventType: "ClipboardEvent",
        defaultInit: {
            bubbles: true,
            cancelable: true,
            composed: true
        }
    },
    cut: {
        EventType: "ClipboardEvent",
        defaultInit: {
            bubbles: true,
            cancelable: true,
            composed: true
        }
    },
    paste: {
        EventType: "ClipboardEvent",
        defaultInit: {
            bubbles: true,
            cancelable: true,
            composed: true
        }
    },
    // Composition Events
    compositionEnd: {
        EventType: "CompositionEvent",
        defaultInit: {
            bubbles: true,
            cancelable: true,
            composed: true
        }
    },
    compositionStart: {
        EventType: "CompositionEvent",
        defaultInit: {
            bubbles: true,
            cancelable: true,
            composed: true
        }
    },
    compositionUpdate: {
        EventType: "CompositionEvent",
        defaultInit: {
            bubbles: true,
            cancelable: true,
            composed: true
        }
    },
    // Keyboard Events
    keyDown: {
        EventType: "KeyboardEvent",
        defaultInit: {
            bubbles: true,
            cancelable: true,
            charCode: 0,
            composed: true
        }
    },
    keyPress: {
        EventType: "KeyboardEvent",
        defaultInit: {
            bubbles: true,
            cancelable: true,
            charCode: 0,
            composed: true
        }
    },
    keyUp: {
        EventType: "KeyboardEvent",
        defaultInit: {
            bubbles: true,
            cancelable: true,
            charCode: 0,
            composed: true
        }
    },
    // Focus Events
    focus: {
        EventType: "FocusEvent",
        defaultInit: {
            bubbles: false,
            cancelable: false,
            composed: true
        }
    },
    blur: {
        EventType: "FocusEvent",
        defaultInit: {
            bubbles: false,
            cancelable: false,
            composed: true
        }
    },
    focusIn: {
        EventType: "FocusEvent",
        defaultInit: {
            bubbles: true,
            cancelable: false,
            composed: true
        }
    },
    focusOut: {
        EventType: "FocusEvent",
        defaultInit: {
            bubbles: true,
            cancelable: false,
            composed: true
        }
    },
    // Form Events
    change: {
        EventType: "Event",
        defaultInit: {
            bubbles: true,
            cancelable: false
        }
    },
    input: {
        EventType: "InputEvent",
        defaultInit: {
            bubbles: true,
            cancelable: false,
            composed: true
        }
    },
    invalid: {
        EventType: "Event",
        defaultInit: {
            bubbles: false,
            cancelable: true
        }
    },
    submit: {
        EventType: "Event",
        defaultInit: {
            bubbles: true,
            cancelable: true
        }
    },
    reset: {
        EventType: "Event",
        defaultInit: {
            bubbles: true,
            cancelable: true
        }
    },
    // Mouse Events
    click: {
        EventType: "MouseEvent",
        defaultInit: {
            bubbles: true,
            cancelable: true,
            button: 0,
            composed: true
        }
    },
    contextMenu: {
        EventType: "MouseEvent",
        defaultInit: {
            bubbles: true,
            cancelable: true,
            composed: true
        }
    },
    dblClick: {
        EventType: "MouseEvent",
        defaultInit: {
            bubbles: true,
            cancelable: true,
            composed: true
        }
    },
    drag: {
        EventType: "DragEvent",
        defaultInit: {
            bubbles: true,
            cancelable: true,
            composed: true
        }
    },
    dragEnd: {
        EventType: "DragEvent",
        defaultInit: {
            bubbles: true,
            cancelable: false,
            composed: true
        }
    },
    dragEnter: {
        EventType: "DragEvent",
        defaultInit: {
            bubbles: true,
            cancelable: true,
            composed: true
        }
    },
    dragExit: {
        EventType: "DragEvent",
        defaultInit: {
            bubbles: true,
            cancelable: false,
            composed: true
        }
    },
    dragLeave: {
        EventType: "DragEvent",
        defaultInit: {
            bubbles: true,
            cancelable: false,
            composed: true
        }
    },
    dragOver: {
        EventType: "DragEvent",
        defaultInit: {
            bubbles: true,
            cancelable: true,
            composed: true
        }
    },
    dragStart: {
        EventType: "DragEvent",
        defaultInit: {
            bubbles: true,
            cancelable: true,
            composed: true
        }
    },
    drop: {
        EventType: "DragEvent",
        defaultInit: {
            bubbles: true,
            cancelable: true,
            composed: true
        }
    },
    mouseDown: {
        EventType: "MouseEvent",
        defaultInit: {
            bubbles: true,
            cancelable: true,
            composed: true
        }
    },
    mouseEnter: {
        EventType: "MouseEvent",
        defaultInit: {
            bubbles: false,
            cancelable: false,
            composed: true
        }
    },
    mouseLeave: {
        EventType: "MouseEvent",
        defaultInit: {
            bubbles: false,
            cancelable: false,
            composed: true
        }
    },
    mouseMove: {
        EventType: "MouseEvent",
        defaultInit: {
            bubbles: true,
            cancelable: true,
            composed: true
        }
    },
    mouseOut: {
        EventType: "MouseEvent",
        defaultInit: {
            bubbles: true,
            cancelable: true,
            composed: true
        }
    },
    mouseOver: {
        EventType: "MouseEvent",
        defaultInit: {
            bubbles: true,
            cancelable: true,
            composed: true
        }
    },
    mouseUp: {
        EventType: "MouseEvent",
        defaultInit: {
            bubbles: true,
            cancelable: true,
            composed: true
        }
    },
    // Selection Events
    select: {
        EventType: "Event",
        defaultInit: {
            bubbles: true,
            cancelable: false
        }
    },
    // Touch Events
    touchCancel: {
        EventType: "TouchEvent",
        defaultInit: {
            bubbles: true,
            cancelable: false,
            composed: true
        }
    },
    touchEnd: {
        EventType: "TouchEvent",
        defaultInit: {
            bubbles: true,
            cancelable: true,
            composed: true
        }
    },
    touchMove: {
        EventType: "TouchEvent",
        defaultInit: {
            bubbles: true,
            cancelable: true,
            composed: true
        }
    },
    touchStart: {
        EventType: "TouchEvent",
        defaultInit: {
            bubbles: true,
            cancelable: true,
            composed: true
        }
    },
    // UI Events
    resize: {
        EventType: "UIEvent",
        defaultInit: {
            bubbles: false,
            cancelable: false
        }
    },
    scroll: {
        EventType: "UIEvent",
        defaultInit: {
            bubbles: false,
            cancelable: false
        }
    },
    // Wheel Events
    wheel: {
        EventType: "WheelEvent",
        defaultInit: {
            bubbles: true,
            cancelable: true,
            composed: true
        }
    },
    // Media Events
    abort: {
        EventType: "Event",
        defaultInit: {
            bubbles: false,
            cancelable: false
        }
    },
    canPlay: {
        EventType: "Event",
        defaultInit: {
            bubbles: false,
            cancelable: false
        }
    },
    canPlayThrough: {
        EventType: "Event",
        defaultInit: {
            bubbles: false,
            cancelable: false
        }
    },
    durationChange: {
        EventType: "Event",
        defaultInit: {
            bubbles: false,
            cancelable: false
        }
    },
    emptied: {
        EventType: "Event",
        defaultInit: {
            bubbles: false,
            cancelable: false
        }
    },
    encrypted: {
        EventType: "Event",
        defaultInit: {
            bubbles: false,
            cancelable: false
        }
    },
    ended: {
        EventType: "Event",
        defaultInit: {
            bubbles: false,
            cancelable: false
        }
    },
    loadedData: {
        EventType: "Event",
        defaultInit: {
            bubbles: false,
            cancelable: false
        }
    },
    loadedMetadata: {
        EventType: "Event",
        defaultInit: {
            bubbles: false,
            cancelable: false
        }
    },
    loadStart: {
        EventType: "ProgressEvent",
        defaultInit: {
            bubbles: false,
            cancelable: false
        }
    },
    pause: {
        EventType: "Event",
        defaultInit: {
            bubbles: false,
            cancelable: false
        }
    },
    play: {
        EventType: "Event",
        defaultInit: {
            bubbles: false,
            cancelable: false
        }
    },
    playing: {
        EventType: "Event",
        defaultInit: {
            bubbles: false,
            cancelable: false
        }
    },
    progress: {
        EventType: "ProgressEvent",
        defaultInit: {
            bubbles: false,
            cancelable: false
        }
    },
    rateChange: {
        EventType: "Event",
        defaultInit: {
            bubbles: false,
            cancelable: false
        }
    },
    seeked: {
        EventType: "Event",
        defaultInit: {
            bubbles: false,
            cancelable: false
        }
    },
    seeking: {
        EventType: "Event",
        defaultInit: {
            bubbles: false,
            cancelable: false
        }
    },
    stalled: {
        EventType: "Event",
        defaultInit: {
            bubbles: false,
            cancelable: false
        }
    },
    suspend: {
        EventType: "Event",
        defaultInit: {
            bubbles: false,
            cancelable: false
        }
    },
    timeUpdate: {
        EventType: "Event",
        defaultInit: {
            bubbles: false,
            cancelable: false
        }
    },
    volumeChange: {
        EventType: "Event",
        defaultInit: {
            bubbles: false,
            cancelable: false
        }
    },
    waiting: {
        EventType: "Event",
        defaultInit: {
            bubbles: false,
            cancelable: false
        }
    },
    // Events
    load: {
        // TODO: load events can be UIEvent or Event depending on what generated them
        // This is where this abstraction breaks down.
        // But the common targets are <img />, <script /> and window.
        // Neither of these targets receive a UIEvent
        EventType: "Event",
        defaultInit: {
            bubbles: false,
            cancelable: false
        }
    },
    error: {
        EventType: "Event",
        defaultInit: {
            bubbles: false,
            cancelable: false
        }
    },
    // Animation Events
    animationStart: {
        EventType: "AnimationEvent",
        defaultInit: {
            bubbles: true,
            cancelable: false
        }
    },
    animationEnd: {
        EventType: "AnimationEvent",
        defaultInit: {
            bubbles: true,
            cancelable: false
        }
    },
    animationIteration: {
        EventType: "AnimationEvent",
        defaultInit: {
            bubbles: true,
            cancelable: false
        }
    },
    // Transition Events
    transitionCancel: {
        EventType: "TransitionEvent",
        defaultInit: {
            bubbles: true,
            cancelable: false
        }
    },
    transitionEnd: {
        EventType: "TransitionEvent",
        defaultInit: {
            bubbles: true,
            cancelable: true
        }
    },
    transitionRun: {
        EventType: "TransitionEvent",
        defaultInit: {
            bubbles: true,
            cancelable: false
        }
    },
    transitionStart: {
        EventType: "TransitionEvent",
        defaultInit: {
            bubbles: true,
            cancelable: false
        }
    },
    // pointer events
    pointerOver: {
        EventType: "PointerEvent",
        defaultInit: {
            bubbles: true,
            cancelable: true,
            composed: true
        }
    },
    pointerEnter: {
        EventType: "PointerEvent",
        defaultInit: {
            bubbles: false,
            cancelable: false
        }
    },
    pointerDown: {
        EventType: "PointerEvent",
        defaultInit: {
            bubbles: true,
            cancelable: true,
            composed: true
        }
    },
    pointerMove: {
        EventType: "PointerEvent",
        defaultInit: {
            bubbles: true,
            cancelable: true,
            composed: true
        }
    },
    pointerUp: {
        EventType: "PointerEvent",
        defaultInit: {
            bubbles: true,
            cancelable: true,
            composed: true
        }
    },
    pointerCancel: {
        EventType: "PointerEvent",
        defaultInit: {
            bubbles: true,
            cancelable: false,
            composed: true
        }
    },
    pointerOut: {
        EventType: "PointerEvent",
        defaultInit: {
            bubbles: true,
            cancelable: true,
            composed: true
        }
    },
    pointerLeave: {
        EventType: "PointerEvent",
        defaultInit: {
            bubbles: false,
            cancelable: false
        }
    },
    gotPointerCapture: {
        EventType: "PointerEvent",
        defaultInit: {
            bubbles: true,
            cancelable: false,
            composed: true
        }
    },
    lostPointerCapture: {
        EventType: "PointerEvent",
        defaultInit: {
            bubbles: true,
            cancelable: false,
            composed: true
        }
    },
    // history events
    popState: {
        EventType: "PopStateEvent",
        defaultInit: {
            bubbles: true,
            cancelable: false
        }
    },
    // window events
    offline: {
        EventType: "Event",
        defaultInit: {
            bubbles: false,
            cancelable: false
        }
    },
    online: {
        EventType: "Event",
        defaultInit: {
            bubbles: false,
            cancelable: false
        }
    }
};
const eventAliasMap = {
    doubleClick: "dblClick"
};
function fireEvent(element, event) {
    return getConfig().eventWrapper(()=>{
        if (!event) throw new Error("Unable to fire an event - please provide an event object.");
        if (!element) throw new Error('Unable to fire a "' + event.type + '" event - please provide a DOM element.');
        return element.dispatchEvent(event);
    });
}
function createEvent(eventName, node, init, _temp) {
    let { EventType = "Event", defaultInit = {} } = _temp === void 0 ? {} : _temp;
    if (!node) throw new Error('Unable to fire a "' + eventName + '" event - please provide a DOM element.');
    const eventInit = {
        ...defaultInit,
        ...init
    };
    const { target: { value, files, ...targetProperties } = {} } = eventInit;
    if (value !== undefined) setNativeValue(node, value);
    if (files !== undefined) // input.files is a read-only property so this is not allowed:
    // input.files = [file]
    // so we have to use this workaround to set the property
    Object.defineProperty(node, "files", {
        configurable: true,
        enumerable: true,
        writable: true,
        value: files
    });
    Object.assign(node, targetProperties);
    const window1 = getWindowFromNode(node);
    const EventConstructor = window1[EventType] || window1.Event;
    let event;
    /* istanbul ignore else  */ if (typeof EventConstructor === "function") event = new EventConstructor(eventName, eventInit);
    else {
        // IE11 polyfill from https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent/CustomEvent#Polyfill
        event = window1.document.createEvent(EventType);
        const { bubbles, cancelable, detail, ...otherInit } = eventInit;
        event.initEvent(eventName, bubbles, cancelable, detail);
        Object.keys(otherInit).forEach((eventKey)=>{
            event[eventKey] = otherInit[eventKey];
        });
    }
    // DataTransfer is not supported in jsdom: https://github.com/jsdom/jsdom/issues/1568
    const dataTransferProperties = [
        "dataTransfer",
        "clipboardData"
    ];
    dataTransferProperties.forEach((dataTransferKey)=>{
        const dataTransferValue = eventInit[dataTransferKey];
        if (typeof dataTransferValue === "object") {
            /* istanbul ignore if  */ if (typeof window1.DataTransfer === "function") Object.defineProperty(event, dataTransferKey, {
                value: Object.getOwnPropertyNames(dataTransferValue).reduce((acc, propName)=>{
                    Object.defineProperty(acc, propName, {
                        value: dataTransferValue[propName]
                    });
                    return acc;
                }, new window1.DataTransfer())
            });
            else Object.defineProperty(event, dataTransferKey, {
                value: dataTransferValue
            });
        }
    });
    return event;
}
Object.keys(eventMap).forEach((key)=>{
    const { EventType, defaultInit } = eventMap[key];
    const eventName = key.toLowerCase();
    createEvent[key] = (node, init)=>createEvent(eventName, node, init, {
            EventType,
            defaultInit
        });
    fireEvent[key] = (node, init)=>fireEvent(node, createEvent[key](node, init));
});
// function written after some investigation here:
// https://github.com/facebook/react/issues/10135#issuecomment-401496776
function setNativeValue(element, value) {
    const { set: valueSetter } = Object.getOwnPropertyDescriptor(element, "value") || {};
    const prototype = Object.getPrototypeOf(element);
    const { set: prototypeValueSetter } = Object.getOwnPropertyDescriptor(prototype, "value") || {};
    if (prototypeValueSetter && valueSetter !== prototypeValueSetter) prototypeValueSetter.call(element, value);
    else {
        /* istanbul ignore if */ // eslint-disable-next-line no-lonely-if -- Can't be ignored by istanbul otherwise
        if (valueSetter) valueSetter.call(element, value);
        else throw new Error("The given element does not have a value setter");
    }
}
Object.keys(eventAliasMap).forEach((aliasKey)=>{
    const key = eventAliasMap[aliasKey];
    fireEvent[aliasKey] = function() {
        return fireEvent[key](...arguments);
    };
});
/* eslint complexity:["error", 9] */ // WARNING: `lz-string` only has a default export but statically we assume named exports are allowd
function unindent(string) {
    // remove white spaces first, to save a few bytes.
    // testing-playground will reformat on load any ways.
    return string.replace(/[ \t]*[\n][ \t]*/g, "\n");
}
function encode(value) {
    return (0, _lzStringDefault.default).compressToEncodedURIComponent(unindent(value));
}
function getPlaygroundUrl(markup) {
    return "https://testing-playground.com/#markup=" + encode(markup);
}
const debug = (element, maxLength, options)=>Array.isArray(element) ? element.forEach((el)=>logDOM(el, maxLength, options)) : logDOM(element, maxLength, options);
const logTestingPlaygroundURL = function(element) {
    if (element === void 0) element = getDocument().body;
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    if (!element || !("innerHTML" in element)) {
        console.log("The element you're providing isn't a valid DOM element.");
        return;
    }
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    if (!element.innerHTML) {
        console.log("The provided element doesn't have any children.");
        return;
    }
    const playgroundUrl = getPlaygroundUrl(element.innerHTML);
    console.log("Open this URL in your browser\n\n" + playgroundUrl);
    return playgroundUrl;
};
const initialValue = {
    debug,
    logTestingPlaygroundURL
};
const screen = typeof document !== "undefined" && document.body // eslint-disable-line @typescript-eslint/no-unnecessary-condition
 ? getQueriesForElement(document.body, queries, initialValue) : Object.keys(queries).reduce((helpers, key)=>{
    // `key` is for all intents and purposes the type of keyof `helpers`, which itself is the type of `initialValue` plus incoming properties from `queries`
    // if `Object.keys(something)` returned Array<keyof typeof something> this explicit type assertion would not be necessary
    // see https://stackoverflow.com/questions/55012174/why-doesnt-object-keys-return-a-keyof-type-in-typescript
    helpers[key] = ()=>{
        throw new TypeError("For queries bound to document.body a global document has to be available... Learn more: https://testing-library.com/s/screen-global-error");
    };
    return helpers;
}, initialValue);

},{"48ce5fb41d2886e6":"6WEZ3","pretty-format":"5NRwb","dom-accessibility-api":"lPB7U","aria-query":"6RWmf","lz-string":"ahc0m","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"6WEZ3":[function(require,module,exports) {
// shim for using process in browser
var process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var cachedSetTimeout;
var cachedClearTimeout;
function defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") cachedSetTimeout = setTimeout;
        else cachedSetTimeout = defaultSetTimout;
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") cachedClearTimeout = clearTimeout;
        else cachedClearTimeout = defaultClearTimeout;
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
})();
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }
}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;
function cleanUpNextTick() {
    if (!draining || !currentQueue) return;
    draining = false;
    if (currentQueue.length) queue = currentQueue.concat(queue);
    else queueIndex = -1;
    if (queue.length) drainQueue();
}
function drainQueue() {
    if (draining) return;
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;
    var len = queue.length;
    while(len){
        currentQueue = queue;
        queue = [];
        while(++queueIndex < len)if (currentQueue) currentQueue[queueIndex].run();
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}
process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) runTimeout(drainQueue);
};
// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
process.title = "browser";
process.browser = true;
process.env = {};
process.argv = [];
process.version = ""; // empty string to avoid regexp issues
process.versions = {};
function noop() {}
process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;
process.listeners = function(name) {
    return [];
};
process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
process.cwd = function() {
    return "/";
};
process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
process.umask = function() {
    return 0;
};

},{}],"5NRwb":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.format = format;
exports.default = exports.plugins = exports.DEFAULT_OPTIONS = void 0;
var _ansiStyles = _interopRequireDefault(require("473836ef7885ce15"));
var _collections = require("dc22616279a58f26");
var _AsymmetricMatcher = _interopRequireDefault(require("9aae8eceb0a83bdd"));
var _ConvertAnsi = _interopRequireDefault(require("ff8cd73688e93d8e"));
var _DOMCollection = _interopRequireDefault(require("84c4c7c4f9fba03"));
var _DOMElement = _interopRequireDefault(require("b93f07fca8ea29e"));
var _Immutable = _interopRequireDefault(require("79c97ddc37f1992e"));
var _ReactElement = _interopRequireDefault(require("12a86e384b4e78b"));
var _ReactTestComponent = _interopRequireDefault(require("683a13335c5b0382"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * Copyright (c) Facebook, Inc. and its affiliates. All Rights Reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /* eslint-disable local/ban-types-eventually */ const toString = Object.prototype.toString;
const toISOString = Date.prototype.toISOString;
const errorToString = Error.prototype.toString;
const regExpToString = RegExp.prototype.toString;
/**
 * Explicitly comparing typeof constructor to function avoids undefined as name
 * when mock identity-obj-proxy returns the key as the value for any key.
 */ const getConstructorName = (val)=>typeof val.constructor === "function" && val.constructor.name || "Object";
/* global window */ /** Is val is equal to global window object? Works even if it does not exist :) */ const isWindow = (val)=>typeof window !== "undefined" && val === window;
const SYMBOL_REGEXP = /^Symbol\((.*)\)(.*)$/;
const NEWLINE_REGEXP = /\n/gi;
class PrettyFormatPluginError extends Error {
    constructor(message, stack){
        super(message);
        this.stack = stack;
        this.name = this.constructor.name;
    }
}
function isToStringedArrayType(toStringed) {
    return toStringed === "[object Array]" || toStringed === "[object ArrayBuffer]" || toStringed === "[object DataView]" || toStringed === "[object Float32Array]" || toStringed === "[object Float64Array]" || toStringed === "[object Int8Array]" || toStringed === "[object Int16Array]" || toStringed === "[object Int32Array]" || toStringed === "[object Uint8Array]" || toStringed === "[object Uint8ClampedArray]" || toStringed === "[object Uint16Array]" || toStringed === "[object Uint32Array]";
}
function printNumber(val) {
    return Object.is(val, -0) ? "-0" : String(val);
}
function printBigInt(val) {
    return String(`${val}n`);
}
function printFunction(val, printFunctionName) {
    if (!printFunctionName) return "[Function]";
    return "[Function " + (val.name || "anonymous") + "]";
}
function printSymbol(val) {
    return String(val).replace(SYMBOL_REGEXP, "Symbol($1)");
}
function printError(val) {
    return "[" + errorToString.call(val) + "]";
}
/**
 * The first port of call for printing an object, handles most of the
 * data-types in JS.
 */ function printBasicValue(val, printFunctionName, escapeRegex, escapeString) {
    if (val === true || val === false) return "" + val;
    if (val === undefined) return "undefined";
    if (val === null) return "null";
    const typeOf = typeof val;
    if (typeOf === "number") return printNumber(val);
    if (typeOf === "bigint") return printBigInt(val);
    if (typeOf === "string") {
        if (escapeString) return '"' + val.replace(/"|\\/g, "\\$&") + '"';
        return '"' + val + '"';
    }
    if (typeOf === "function") return printFunction(val, printFunctionName);
    if (typeOf === "symbol") return printSymbol(val);
    const toStringed = toString.call(val);
    if (toStringed === "[object WeakMap]") return "WeakMap {}";
    if (toStringed === "[object WeakSet]") return "WeakSet {}";
    if (toStringed === "[object Function]" || toStringed === "[object GeneratorFunction]") return printFunction(val, printFunctionName);
    if (toStringed === "[object Symbol]") return printSymbol(val);
    if (toStringed === "[object Date]") return isNaN(+val) ? "Date { NaN }" : toISOString.call(val);
    if (toStringed === "[object Error]") return printError(val);
    if (toStringed === "[object RegExp]") {
        if (escapeRegex) // https://github.com/benjamingr/RegExp.escape/blob/main/polyfill.js
        return regExpToString.call(val).replace(/[\\^$*+?.()|[\]{}]/g, "\\$&");
        return regExpToString.call(val);
    }
    if (val instanceof Error) return printError(val);
    return null;
}
/**
 * Handles more complex objects ( such as objects with circular references.
 * maps and sets etc )
 */ function printComplexValue(val, config, indentation, depth, refs, hasCalledToJSON) {
    if (refs.indexOf(val) !== -1) return "[Circular]";
    refs = refs.slice();
    refs.push(val);
    const hitMaxDepth = ++depth > config.maxDepth;
    const min = config.min;
    if (config.callToJSON && !hitMaxDepth && val.toJSON && typeof val.toJSON === "function" && !hasCalledToJSON) return printer(val.toJSON(), config, indentation, depth, refs, true);
    const toStringed = toString.call(val);
    if (toStringed === "[object Arguments]") return hitMaxDepth ? "[Arguments]" : (min ? "" : "Arguments ") + "[" + (0, _collections.printListItems)(val, config, indentation, depth, refs, printer) + "]";
    if (isToStringedArrayType(toStringed)) return hitMaxDepth ? "[" + val.constructor.name + "]" : (min ? "" : !config.printBasicPrototype && val.constructor.name === "Array" ? "" : val.constructor.name + " ") + "[" + (0, _collections.printListItems)(val, config, indentation, depth, refs, printer) + "]";
    if (toStringed === "[object Map]") return hitMaxDepth ? "[Map]" : "Map {" + (0, _collections.printIteratorEntries)(val.entries(), config, indentation, depth, refs, printer, " => ") + "}";
    if (toStringed === "[object Set]") return hitMaxDepth ? "[Set]" : "Set {" + (0, _collections.printIteratorValues)(val.values(), config, indentation, depth, refs, printer) + "}";
     // Avoid failure to serialize global window object in jsdom test environment.
    // For example, not even relevant if window is prop of React element.
    return hitMaxDepth || isWindow(val) ? "[" + getConstructorName(val) + "]" : (min ? "" : !config.printBasicPrototype && getConstructorName(val) === "Object" ? "" : getConstructorName(val) + " ") + "{" + (0, _collections.printObjectProperties)(val, config, indentation, depth, refs, printer) + "}";
}
function isNewPlugin(plugin) {
    return plugin.serialize != null;
}
function printPlugin(plugin, val, config, indentation, depth, refs) {
    let printed;
    try {
        printed = isNewPlugin(plugin) ? plugin.serialize(val, config, indentation, depth, refs, printer) : plugin.print(val, (valChild)=>printer(valChild, config, indentation, depth, refs), (str)=>{
            const indentationNext = indentation + config.indent;
            return indentationNext + str.replace(NEWLINE_REGEXP, "\n" + indentationNext);
        }, {
            edgeSpacing: config.spacingOuter,
            min: config.min,
            spacing: config.spacingInner
        }, config.colors);
    } catch (error) {
        throw new PrettyFormatPluginError(error.message, error.stack);
    }
    if (typeof printed !== "string") throw new Error(`pretty-format: Plugin must return type "string" but instead returned "${typeof printed}".`);
    return printed;
}
function findPlugin(plugins, val) {
    for(let p = 0; p < plugins.length; p++)try {
        if (plugins[p].test(val)) return plugins[p];
    } catch (error) {
        throw new PrettyFormatPluginError(error.message, error.stack);
    }
    return null;
}
function printer(val, config, indentation, depth, refs, hasCalledToJSON) {
    const plugin = findPlugin(config.plugins, val);
    if (plugin !== null) return printPlugin(plugin, val, config, indentation, depth, refs);
    const basicResult = printBasicValue(val, config.printFunctionName, config.escapeRegex, config.escapeString);
    if (basicResult !== null) return basicResult;
    return printComplexValue(val, config, indentation, depth, refs, hasCalledToJSON);
}
const DEFAULT_THEME = {
    comment: "gray",
    content: "reset",
    prop: "yellow",
    tag: "cyan",
    value: "green"
};
const DEFAULT_THEME_KEYS = Object.keys(DEFAULT_THEME);
const DEFAULT_OPTIONS = {
    callToJSON: true,
    compareKeys: undefined,
    escapeRegex: false,
    escapeString: true,
    highlight: false,
    indent: 2,
    maxDepth: Infinity,
    min: false,
    plugins: [],
    printBasicPrototype: true,
    printFunctionName: true,
    theme: DEFAULT_THEME
};
exports.DEFAULT_OPTIONS = DEFAULT_OPTIONS;
function validateOptions(options) {
    Object.keys(options).forEach((key)=>{
        if (!DEFAULT_OPTIONS.hasOwnProperty(key)) throw new Error(`pretty-format: Unknown option "${key}".`);
    });
    if (options.min && options.indent !== undefined && options.indent !== 0) throw new Error('pretty-format: Options "min" and "indent" cannot be used together.');
    if (options.theme !== undefined) {
        if (options.theme === null) throw new Error(`pretty-format: Option "theme" must not be null.`);
        if (typeof options.theme !== "object") throw new Error(`pretty-format: Option "theme" must be of type "object" but instead received "${typeof options.theme}".`);
    }
}
const getColorsHighlight = (options)=>DEFAULT_THEME_KEYS.reduce((colors, key)=>{
        const value = options.theme && options.theme[key] !== undefined ? options.theme[key] : DEFAULT_THEME[key];
        const color = value && _ansiStyles.default[value];
        if (color && typeof color.close === "string" && typeof color.open === "string") colors[key] = color;
        else throw new Error(`pretty-format: Option "theme" has a key "${key}" whose value "${value}" is undefined in ansi-styles.`);
        return colors;
    }, Object.create(null));
const getColorsEmpty = ()=>DEFAULT_THEME_KEYS.reduce((colors, key)=>{
        colors[key] = {
            close: "",
            open: ""
        };
        return colors;
    }, Object.create(null));
const getPrintFunctionName = (options)=>options && options.printFunctionName !== undefined ? options.printFunctionName : DEFAULT_OPTIONS.printFunctionName;
const getEscapeRegex = (options)=>options && options.escapeRegex !== undefined ? options.escapeRegex : DEFAULT_OPTIONS.escapeRegex;
const getEscapeString = (options)=>options && options.escapeString !== undefined ? options.escapeString : DEFAULT_OPTIONS.escapeString;
const getConfig = (options)=>{
    var _options$printBasicPr;
    return {
        callToJSON: options && options.callToJSON !== undefined ? options.callToJSON : DEFAULT_OPTIONS.callToJSON,
        colors: options && options.highlight ? getColorsHighlight(options) : getColorsEmpty(),
        compareKeys: options && typeof options.compareKeys === "function" ? options.compareKeys : DEFAULT_OPTIONS.compareKeys,
        escapeRegex: getEscapeRegex(options),
        escapeString: getEscapeString(options),
        indent: options && options.min ? "" : createIndent(options && options.indent !== undefined ? options.indent : DEFAULT_OPTIONS.indent),
        maxDepth: options && options.maxDepth !== undefined ? options.maxDepth : DEFAULT_OPTIONS.maxDepth,
        min: options && options.min !== undefined ? options.min : DEFAULT_OPTIONS.min,
        plugins: options && options.plugins !== undefined ? options.plugins : DEFAULT_OPTIONS.plugins,
        printBasicPrototype: (_options$printBasicPr = options === null || options === void 0 ? void 0 : options.printBasicPrototype) !== null && _options$printBasicPr !== void 0 ? _options$printBasicPr : true,
        printFunctionName: getPrintFunctionName(options),
        spacingInner: options && options.min ? " " : "\n",
        spacingOuter: options && options.min ? "" : "\n"
    };
};
function createIndent(indent) {
    return new Array(indent + 1).join(" ");
}
/**
 * Returns a presentation string of your `val` object
 * @param val any potential JavaScript object
 * @param options Custom settings
 */ function format(val, options) {
    if (options) {
        validateOptions(options);
        if (options.plugins) {
            const plugin = findPlugin(options.plugins, val);
            if (plugin !== null) return printPlugin(plugin, val, getConfig(options), "", 0, []);
        }
    }
    const basicResult = printBasicValue(val, getPrintFunctionName(options), getEscapeRegex(options), getEscapeString(options));
    if (basicResult !== null) return basicResult;
    return printComplexValue(val, getConfig(options), "", 0, []);
}
const plugins = {
    AsymmetricMatcher: _AsymmetricMatcher.default,
    ConvertAnsi: _ConvertAnsi.default,
    DOMCollection: _DOMCollection.default,
    DOMElement: _DOMElement.default,
    Immutable: _Immutable.default,
    ReactElement: _ReactElement.default,
    ReactTestComponent: _ReactTestComponent.default
};
exports.plugins = plugins;
var _default = format;
exports.default = _default;

},{"473836ef7885ce15":"gVV1p","dc22616279a58f26":"8bd63","9aae8eceb0a83bdd":"jMVUc","ff8cd73688e93d8e":"A1rfb","84c4c7c4f9fba03":"2spkE","b93f07fca8ea29e":"ksIXJ","79c97ddc37f1992e":"lUstD","12a86e384b4e78b":"lbo6x","683a13335c5b0382":"csTcU"}],"gVV1p":[function(require,module,exports) {
"use strict";
const ANSI_BACKGROUND_OFFSET = 10;
const wrapAnsi256 = (offset = 0)=>(code)=>`\u001B[${38 + offset};5;${code}m`;
const wrapAnsi16m = (offset = 0)=>(red, green, blue)=>`\u001B[${38 + offset};2;${red};${green};${blue}m`;
function assembleStyles() {
    const codes = new Map();
    const styles = {
        modifier: {
            reset: [
                0,
                0
            ],
            // 21 isn't widely supported and 22 does the same thing
            bold: [
                1,
                22
            ],
            dim: [
                2,
                22
            ],
            italic: [
                3,
                23
            ],
            underline: [
                4,
                24
            ],
            overline: [
                53,
                55
            ],
            inverse: [
                7,
                27
            ],
            hidden: [
                8,
                28
            ],
            strikethrough: [
                9,
                29
            ]
        },
        color: {
            black: [
                30,
                39
            ],
            red: [
                31,
                39
            ],
            green: [
                32,
                39
            ],
            yellow: [
                33,
                39
            ],
            blue: [
                34,
                39
            ],
            magenta: [
                35,
                39
            ],
            cyan: [
                36,
                39
            ],
            white: [
                37,
                39
            ],
            // Bright color
            blackBright: [
                90,
                39
            ],
            redBright: [
                91,
                39
            ],
            greenBright: [
                92,
                39
            ],
            yellowBright: [
                93,
                39
            ],
            blueBright: [
                94,
                39
            ],
            magentaBright: [
                95,
                39
            ],
            cyanBright: [
                96,
                39
            ],
            whiteBright: [
                97,
                39
            ]
        },
        bgColor: {
            bgBlack: [
                40,
                49
            ],
            bgRed: [
                41,
                49
            ],
            bgGreen: [
                42,
                49
            ],
            bgYellow: [
                43,
                49
            ],
            bgBlue: [
                44,
                49
            ],
            bgMagenta: [
                45,
                49
            ],
            bgCyan: [
                46,
                49
            ],
            bgWhite: [
                47,
                49
            ],
            // Bright color
            bgBlackBright: [
                100,
                49
            ],
            bgRedBright: [
                101,
                49
            ],
            bgGreenBright: [
                102,
                49
            ],
            bgYellowBright: [
                103,
                49
            ],
            bgBlueBright: [
                104,
                49
            ],
            bgMagentaBright: [
                105,
                49
            ],
            bgCyanBright: [
                106,
                49
            ],
            bgWhiteBright: [
                107,
                49
            ]
        }
    };
    // Alias bright black as gray (and grey)
    styles.color.gray = styles.color.blackBright;
    styles.bgColor.bgGray = styles.bgColor.bgBlackBright;
    styles.color.grey = styles.color.blackBright;
    styles.bgColor.bgGrey = styles.bgColor.bgBlackBright;
    for (const [groupName, group] of Object.entries(styles)){
        for (const [styleName, style] of Object.entries(group)){
            styles[styleName] = {
                open: `\u001B[${style[0]}m`,
                close: `\u001B[${style[1]}m`
            };
            group[styleName] = styles[styleName];
            codes.set(style[0], style[1]);
        }
        Object.defineProperty(styles, groupName, {
            value: group,
            enumerable: false
        });
    }
    Object.defineProperty(styles, "codes", {
        value: codes,
        enumerable: false
    });
    styles.color.close = "\x1b[39m";
    styles.bgColor.close = "\x1b[49m";
    styles.color.ansi256 = wrapAnsi256();
    styles.color.ansi16m = wrapAnsi16m();
    styles.bgColor.ansi256 = wrapAnsi256(ANSI_BACKGROUND_OFFSET);
    styles.bgColor.ansi16m = wrapAnsi16m(ANSI_BACKGROUND_OFFSET);
    // From https://github.com/Qix-/color-convert/blob/3f0e0d4e92e235796ccb17f6e85c72094a651f49/conversions.js
    Object.defineProperties(styles, {
        rgbToAnsi256: {
            value: (red, green, blue)=>{
                // We use the extended greyscale palette here, with the exception of
                // black and white. normal palette only has 4 greyscale shades.
                if (red === green && green === blue) {
                    if (red < 8) return 16;
                    if (red > 248) return 231;
                    return Math.round((red - 8) / 247 * 24) + 232;
                }
                return 16 + 36 * Math.round(red / 255 * 5) + 6 * Math.round(green / 255 * 5) + Math.round(blue / 255 * 5);
            },
            enumerable: false
        },
        hexToRgb: {
            value: (hex)=>{
                const matches = /(?<colorString>[a-f\d]{6}|[a-f\d]{3})/i.exec(hex.toString(16));
                if (!matches) return [
                    0,
                    0,
                    0
                ];
                let { colorString } = matches.groups;
                if (colorString.length === 3) colorString = colorString.split("").map((character)=>character + character).join("");
                const integer = Number.parseInt(colorString, 16);
                return [
                    integer >> 16 & 0xFF,
                    integer >> 8 & 0xFF,
                    integer & 0xFF
                ];
            },
            enumerable: false
        },
        hexToAnsi256: {
            value: (hex)=>styles.rgbToAnsi256(...styles.hexToRgb(hex)),
            enumerable: false
        }
    });
    return styles;
}
// Make the export immutable
Object.defineProperty(module, "exports", {
    enumerable: true,
    get: assembleStyles
});

},{}],"8bd63":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.printIteratorEntries = printIteratorEntries;
exports.printIteratorValues = printIteratorValues;
exports.printListItems = printListItems;
exports.printObjectProperties = printObjectProperties;
/**
 * Copyright (c) Facebook, Inc. and its affiliates. All Rights Reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ const getKeysOfEnumerableProperties = (object, compareKeys)=>{
    const keys = Object.keys(object).sort(compareKeys);
    if (Object.getOwnPropertySymbols) Object.getOwnPropertySymbols(object).forEach((symbol)=>{
        if (Object.getOwnPropertyDescriptor(object, symbol).enumerable) keys.push(symbol);
    });
    return keys;
};
/**
 * Return entries (for example, of a map)
 * with spacing, indentation, and comma
 * without surrounding punctuation (for example, braces)
 */ function printIteratorEntries(iterator, config, indentation, depth, refs, printer, // What a distracting diff if you change a data structure to/from
// ECMAScript Object or Immutable.Map/OrderedMap which use the default.
separator = ": ") {
    let result = "";
    let current = iterator.next();
    if (!current.done) {
        result += config.spacingOuter;
        const indentationNext = indentation + config.indent;
        while(!current.done){
            const name = printer(current.value[0], config, indentationNext, depth, refs);
            const value = printer(current.value[1], config, indentationNext, depth, refs);
            result += indentationNext + name + separator + value;
            current = iterator.next();
            if (!current.done) result += "," + config.spacingInner;
            else if (!config.min) result += ",";
        }
        result += config.spacingOuter + indentation;
    }
    return result;
}
/**
 * Return values (for example, of a set)
 * with spacing, indentation, and comma
 * without surrounding punctuation (braces or brackets)
 */ function printIteratorValues(iterator, config, indentation, depth, refs, printer) {
    let result = "";
    let current = iterator.next();
    if (!current.done) {
        result += config.spacingOuter;
        const indentationNext = indentation + config.indent;
        while(!current.done){
            result += indentationNext + printer(current.value, config, indentationNext, depth, refs);
            current = iterator.next();
            if (!current.done) result += "," + config.spacingInner;
            else if (!config.min) result += ",";
        }
        result += config.spacingOuter + indentation;
    }
    return result;
}
/**
 * Return items (for example, of an array)
 * with spacing, indentation, and comma
 * without surrounding punctuation (for example, brackets)
 **/ function printListItems(list, config, indentation, depth, refs, printer) {
    let result = "";
    if (list.length) {
        result += config.spacingOuter;
        const indentationNext = indentation + config.indent;
        for(let i = 0; i < list.length; i++){
            result += indentationNext;
            if (i in list) result += printer(list[i], config, indentationNext, depth, refs);
            if (i < list.length - 1) result += "," + config.spacingInner;
            else if (!config.min) result += ",";
        }
        result += config.spacingOuter + indentation;
    }
    return result;
}
/**
 * Return properties of an object
 * with spacing, indentation, and comma
 * without surrounding punctuation (for example, braces)
 */ function printObjectProperties(val, config, indentation, depth, refs, printer) {
    let result = "";
    const keys = getKeysOfEnumerableProperties(val, config.compareKeys);
    if (keys.length) {
        result += config.spacingOuter;
        const indentationNext = indentation + config.indent;
        for(let i = 0; i < keys.length; i++){
            const key = keys[i];
            const name = printer(key, config, indentationNext, depth, refs);
            const value = printer(val[key], config, indentationNext, depth, refs);
            result += indentationNext + name + ": " + value;
            if (i < keys.length - 1) result += "," + config.spacingInner;
            else if (!config.min) result += ",";
        }
        result += config.spacingOuter + indentation;
    }
    return result;
}

},{}],"jMVUc":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = exports.test = exports.serialize = void 0;
var _collections = require("13e31cf233f96c2b");
var global = function() {
    if (typeof globalThis !== "undefined") return globalThis;
    else if (typeof global !== "undefined") return global;
    else if (typeof self !== "undefined") return self;
    else if (typeof window !== "undefined") return window;
    else return Function("return this")();
}();
var Symbol = global["jest-symbol-do-not-touch"] || global.Symbol;
const asymmetricMatcher = typeof Symbol === "function" && Symbol.for ? Symbol.for("jest.asymmetricMatcher") : 0x1357a5;
const SPACE = " ";
const serialize = (val, config, indentation, depth, refs, printer)=>{
    const stringedValue = val.toString();
    if (stringedValue === "ArrayContaining" || stringedValue === "ArrayNotContaining") {
        if (++depth > config.maxDepth) return "[" + stringedValue + "]";
        return stringedValue + SPACE + "[" + (0, _collections.printListItems)(val.sample, config, indentation, depth, refs, printer) + "]";
    }
    if (stringedValue === "ObjectContaining" || stringedValue === "ObjectNotContaining") {
        if (++depth > config.maxDepth) return "[" + stringedValue + "]";
        return stringedValue + SPACE + "{" + (0, _collections.printObjectProperties)(val.sample, config, indentation, depth, refs, printer) + "}";
    }
    if (stringedValue === "StringMatching" || stringedValue === "StringNotMatching") return stringedValue + SPACE + printer(val.sample, config, indentation, depth, refs);
    if (stringedValue === "StringContaining" || stringedValue === "StringNotContaining") return stringedValue + SPACE + printer(val.sample, config, indentation, depth, refs);
    return val.toAsymmetricMatcher();
};
exports.serialize = serialize;
const test = (val)=>val && val.$$typeof === asymmetricMatcher;
exports.test = test;
const plugin = {
    serialize,
    test
};
var _default = plugin;
exports.default = _default;

},{"13e31cf233f96c2b":"8bd63"}],"A1rfb":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = exports.serialize = exports.test = void 0;
var _ansiRegex = _interopRequireDefault(require("c3ea58fcb869e8bf"));
var _ansiStyles = _interopRequireDefault(require("5e2f0fe9df27bfe"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * Copyright (c) Facebook, Inc. and its affiliates. All Rights Reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ const toHumanReadableAnsi = (text)=>text.replace((0, _ansiRegex.default)(), (match)=>{
        switch(match){
            case _ansiStyles.default.red.close:
            case _ansiStyles.default.green.close:
            case _ansiStyles.default.cyan.close:
            case _ansiStyles.default.gray.close:
            case _ansiStyles.default.white.close:
            case _ansiStyles.default.yellow.close:
            case _ansiStyles.default.bgRed.close:
            case _ansiStyles.default.bgGreen.close:
            case _ansiStyles.default.bgYellow.close:
            case _ansiStyles.default.inverse.close:
            case _ansiStyles.default.dim.close:
            case _ansiStyles.default.bold.close:
            case _ansiStyles.default.reset.open:
            case _ansiStyles.default.reset.close:
                return "</>";
            case _ansiStyles.default.red.open:
                return "<red>";
            case _ansiStyles.default.green.open:
                return "<green>";
            case _ansiStyles.default.cyan.open:
                return "<cyan>";
            case _ansiStyles.default.gray.open:
                return "<gray>";
            case _ansiStyles.default.white.open:
                return "<white>";
            case _ansiStyles.default.yellow.open:
                return "<yellow>";
            case _ansiStyles.default.bgRed.open:
                return "<bgRed>";
            case _ansiStyles.default.bgGreen.open:
                return "<bgGreen>";
            case _ansiStyles.default.bgYellow.open:
                return "<bgYellow>";
            case _ansiStyles.default.inverse.open:
                return "<inverse>";
            case _ansiStyles.default.dim.open:
                return "<dim>";
            case _ansiStyles.default.bold.open:
                return "<bold>";
            default:
                return "";
        }
    });
const test = (val)=>typeof val === "string" && !!val.match((0, _ansiRegex.default)());
exports.test = test;
const serialize = (val, config, indentation, depth, refs, printer)=>printer(toHumanReadableAnsi(val), config, indentation, depth, refs);
exports.serialize = serialize;
const plugin = {
    serialize,
    test
};
var _default = plugin;
exports.default = _default;

},{"c3ea58fcb869e8bf":"sTZeO","5e2f0fe9df27bfe":"gVV1p"}],"sTZeO":[function(require,module,exports) {
"use strict";
module.exports = ({ onlyFirst = false } = {})=>{
    const pattern = [
        "[\\u001B\\u009B][[\\]()#;?]*(?:(?:(?:(?:;[-a-zA-Z\\d\\/#&.:=?%@~_]+)*|[a-zA-Z\\d]+(?:;[-a-zA-Z\\d\\/#&.:=?%@~_]*)*)?\\u0007)",
        "(?:(?:\\d{1,4}(?:;\\d{0,4})*)?[\\dA-PR-TZcf-ntqry=><~]))"
    ].join("|");
    return new RegExp(pattern, onlyFirst ? undefined : "g");
};

},{}],"2spkE":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = exports.serialize = exports.test = void 0;
var _collections = require("3ec87dc1c71d6a80");
/**
 * Copyright (c) Facebook, Inc. and its affiliates. All Rights Reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /* eslint-disable local/ban-types-eventually */ const SPACE = " ";
const OBJECT_NAMES = [
    "DOMStringMap",
    "NamedNodeMap"
];
const ARRAY_REGEXP = /^(HTML\w*Collection|NodeList)$/;
const testName = (name)=>OBJECT_NAMES.indexOf(name) !== -1 || ARRAY_REGEXP.test(name);
const test = (val)=>val && val.constructor && !!val.constructor.name && testName(val.constructor.name);
exports.test = test;
const isNamedNodeMap = (collection)=>collection.constructor.name === "NamedNodeMap";
const serialize = (collection, config, indentation, depth, refs, printer)=>{
    const name = collection.constructor.name;
    if (++depth > config.maxDepth) return "[" + name + "]";
    return (config.min ? "" : name + SPACE) + (OBJECT_NAMES.indexOf(name) !== -1 ? "{" + (0, _collections.printObjectProperties)(isNamedNodeMap(collection) ? Array.from(collection).reduce((props, attribute)=>{
        props[attribute.name] = attribute.value;
        return props;
    }, {}) : {
        ...collection
    }, config, indentation, depth, refs, printer) + "}" : "[" + (0, _collections.printListItems)(Array.from(collection), config, indentation, depth, refs, printer) + "]");
};
exports.serialize = serialize;
const plugin = {
    serialize,
    test
};
var _default = plugin;
exports.default = _default;

},{"3ec87dc1c71d6a80":"8bd63"}],"ksIXJ":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = exports.serialize = exports.test = void 0;
var _markup = require("2e9682d876f3bc6f");
/**
 * Copyright (c) Facebook, Inc. and its affiliates. All Rights Reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ const ELEMENT_NODE = 1;
const TEXT_NODE = 3;
const COMMENT_NODE = 8;
const FRAGMENT_NODE = 11;
const ELEMENT_REGEXP = /^((HTML|SVG)\w*)?Element$/;
const testHasAttribute = (val)=>{
    try {
        return typeof val.hasAttribute === "function" && val.hasAttribute("is");
    } catch  {
        return false;
    }
};
const testNode = (val)=>{
    const constructorName = val.constructor.name;
    const { nodeType, tagName } = val;
    const isCustomElement = typeof tagName === "string" && tagName.includes("-") || testHasAttribute(val);
    return nodeType === ELEMENT_NODE && (ELEMENT_REGEXP.test(constructorName) || isCustomElement) || nodeType === TEXT_NODE && constructorName === "Text" || nodeType === COMMENT_NODE && constructorName === "Comment" || nodeType === FRAGMENT_NODE && constructorName === "DocumentFragment";
};
const test = (val)=>{
    var _val$constructor;
    return (val === null || val === void 0 ? void 0 : (_val$constructor = val.constructor) === null || _val$constructor === void 0 ? void 0 : _val$constructor.name) && testNode(val);
};
exports.test = test;
function nodeIsText(node) {
    return node.nodeType === TEXT_NODE;
}
function nodeIsComment(node) {
    return node.nodeType === COMMENT_NODE;
}
function nodeIsFragment(node) {
    return node.nodeType === FRAGMENT_NODE;
}
const serialize = (node, config, indentation, depth, refs, printer)=>{
    if (nodeIsText(node)) return (0, _markup.printText)(node.data, config);
    if (nodeIsComment(node)) return (0, _markup.printComment)(node.data, config);
    const type = nodeIsFragment(node) ? `DocumentFragment` : node.tagName.toLowerCase();
    if (++depth > config.maxDepth) return (0, _markup.printElementAsLeaf)(type, config);
    return (0, _markup.printElement)(type, (0, _markup.printProps)(nodeIsFragment(node) ? [] : Array.from(node.attributes).map((attr)=>attr.name).sort(), nodeIsFragment(node) ? {} : Array.from(node.attributes).reduce((props, attribute)=>{
        props[attribute.name] = attribute.value;
        return props;
    }, {}), config, indentation + config.indent, depth, refs, printer), (0, _markup.printChildren)(Array.prototype.slice.call(node.childNodes || node.children), config, indentation + config.indent, depth, refs, printer), config, indentation);
};
exports.serialize = serialize;
const plugin = {
    serialize,
    test
};
var _default = plugin;
exports.default = _default;

},{"2e9682d876f3bc6f":"aNNIr"}],"aNNIr":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.printElementAsLeaf = exports.printElement = exports.printComment = exports.printText = exports.printChildren = exports.printProps = void 0;
var _escapeHTML = _interopRequireDefault(require("9b7396d5f8d90259"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * Copyright (c) Facebook, Inc. and its affiliates. All Rights Reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ // Return empty string if keys is empty.
const printProps = (keys, props, config, indentation, depth, refs, printer)=>{
    const indentationNext = indentation + config.indent;
    const colors = config.colors;
    return keys.map((key)=>{
        const value = props[key];
        let printed = printer(value, config, indentationNext, depth, refs);
        if (typeof value !== "string") {
            if (printed.indexOf("\n") !== -1) printed = config.spacingOuter + indentationNext + printed + config.spacingOuter + indentation;
            printed = "{" + printed + "}";
        }
        return config.spacingInner + indentation + colors.prop.open + key + colors.prop.close + "=" + colors.value.open + printed + colors.value.close;
    }).join("");
}; // Return empty string if children is empty.
exports.printProps = printProps;
const printChildren = (children, config, indentation, depth, refs, printer)=>children.map((child)=>config.spacingOuter + indentation + (typeof child === "string" ? printText(child, config) : printer(child, config, indentation, depth, refs))).join("");
exports.printChildren = printChildren;
const printText = (text, config)=>{
    const contentColor = config.colors.content;
    return contentColor.open + (0, _escapeHTML.default)(text) + contentColor.close;
};
exports.printText = printText;
const printComment = (comment, config)=>{
    const commentColor = config.colors.comment;
    return commentColor.open + "<!--" + (0, _escapeHTML.default)(comment) + "-->" + commentColor.close;
}; // Separate the functions to format props, children, and element,
// so a plugin could override a particular function, if needed.
// Too bad, so sad: the traditional (but unnecessary) space
// in a self-closing tagColor requires a second test of printedProps.
exports.printComment = printComment;
const printElement = (type, printedProps, printedChildren, config, indentation)=>{
    const tagColor = config.colors.tag;
    return tagColor.open + "<" + type + (printedProps && tagColor.close + printedProps + config.spacingOuter + indentation + tagColor.open) + (printedChildren ? ">" + tagColor.close + printedChildren + config.spacingOuter + indentation + tagColor.open + "</" + type : (printedProps && !config.min ? "" : " ") + "/") + ">" + tagColor.close;
};
exports.printElement = printElement;
const printElementAsLeaf = (type, config)=>{
    const tagColor = config.colors.tag;
    return tagColor.open + "<" + type + tagColor.close + " \u2026" + tagColor.open + " />" + tagColor.close;
};
exports.printElementAsLeaf = printElementAsLeaf;

},{"9b7396d5f8d90259":"14t54"}],"14t54":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = escapeHTML;
/**
 * Copyright (c) Facebook, Inc. and its affiliates. All Rights Reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ function escapeHTML(str) {
    return str.replace(/</g, "&lt;").replace(/>/g, "&gt;");
}

},{}],"lUstD":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = exports.test = exports.serialize = void 0;
var _collections = require("fd0043a38e038eeb");
/**
 * Copyright (c) Facebook, Inc. and its affiliates. All Rights Reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ // SENTINEL constants are from https://github.com/facebook/immutable-js
const IS_ITERABLE_SENTINEL = "@@__IMMUTABLE_ITERABLE__@@";
const IS_LIST_SENTINEL = "@@__IMMUTABLE_LIST__@@";
const IS_KEYED_SENTINEL = "@@__IMMUTABLE_KEYED__@@";
const IS_MAP_SENTINEL = "@@__IMMUTABLE_MAP__@@";
const IS_ORDERED_SENTINEL = "@@__IMMUTABLE_ORDERED__@@";
const IS_RECORD_SENTINEL = "@@__IMMUTABLE_RECORD__@@"; // immutable v4
const IS_SEQ_SENTINEL = "@@__IMMUTABLE_SEQ__@@";
const IS_SET_SENTINEL = "@@__IMMUTABLE_SET__@@";
const IS_STACK_SENTINEL = "@@__IMMUTABLE_STACK__@@";
const getImmutableName = (name)=>"Immutable." + name;
const printAsLeaf = (name)=>"[" + name + "]";
const SPACE = " ";
const LAZY = "\u2026"; // Seq is lazy if it calls a method like filter
const printImmutableEntries = (val, config, indentation, depth, refs, printer, type)=>++depth > config.maxDepth ? printAsLeaf(getImmutableName(type)) : getImmutableName(type) + SPACE + "{" + (0, _collections.printIteratorEntries)(val.entries(), config, indentation, depth, refs, printer) + "}"; // Record has an entries method because it is a collection in immutable v3.
// Return an iterator for Immutable Record from version v3 or v4.
function getRecordEntries(val) {
    let i = 0;
    return {
        next () {
            if (i < val._keys.length) {
                const key = val._keys[i++];
                return {
                    done: false,
                    value: [
                        key,
                        val.get(key)
                    ]
                };
            }
            return {
                done: true,
                value: undefined
            };
        }
    };
}
const printImmutableRecord = (val, config, indentation, depth, refs, printer)=>{
    // _name property is defined only for an Immutable Record instance
    // which was constructed with a second optional descriptive name arg
    const name = getImmutableName(val._name || "Record");
    return ++depth > config.maxDepth ? printAsLeaf(name) : name + SPACE + "{" + (0, _collections.printIteratorEntries)(getRecordEntries(val), config, indentation, depth, refs, printer) + "}";
};
const printImmutableSeq = (val, config, indentation, depth, refs, printer)=>{
    const name = getImmutableName("Seq");
    if (++depth > config.maxDepth) return printAsLeaf(name);
    if (val[IS_KEYED_SENTINEL]) return name + SPACE + "{" + (val._iter || val._object ? (0, _collections.printIteratorEntries)(val.entries(), config, indentation, depth, refs, printer) : LAZY) + "}";
    return name + SPACE + "[" + (val._iter || // from Immutable collection of values
    val._array || // from ECMAScript array
    val._collection || // from ECMAScript collection in immutable v4
    val._iterable // from ECMAScript collection in immutable v3
     ? (0, _collections.printIteratorValues)(val.values(), config, indentation, depth, refs, printer) : LAZY) + "]";
};
const printImmutableValues = (val, config, indentation, depth, refs, printer, type)=>++depth > config.maxDepth ? printAsLeaf(getImmutableName(type)) : getImmutableName(type) + SPACE + "[" + (0, _collections.printIteratorValues)(val.values(), config, indentation, depth, refs, printer) + "]";
const serialize = (val, config, indentation, depth, refs, printer)=>{
    if (val[IS_MAP_SENTINEL]) return printImmutableEntries(val, config, indentation, depth, refs, printer, val[IS_ORDERED_SENTINEL] ? "OrderedMap" : "Map");
    if (val[IS_LIST_SENTINEL]) return printImmutableValues(val, config, indentation, depth, refs, printer, "List");
    if (val[IS_SET_SENTINEL]) return printImmutableValues(val, config, indentation, depth, refs, printer, val[IS_ORDERED_SENTINEL] ? "OrderedSet" : "Set");
    if (val[IS_STACK_SENTINEL]) return printImmutableValues(val, config, indentation, depth, refs, printer, "Stack");
    if (val[IS_SEQ_SENTINEL]) return printImmutableSeq(val, config, indentation, depth, refs, printer);
     // For compatibility with immutable v3 and v4, let record be the default.
    return printImmutableRecord(val, config, indentation, depth, refs, printer);
}; // Explicitly comparing sentinel properties to true avoids false positive
// when mock identity-obj-proxy returns the key as the value for any key.
exports.serialize = serialize;
const test = (val)=>val && (val[IS_ITERABLE_SENTINEL] === true || val[IS_RECORD_SENTINEL] === true);
exports.test = test;
const plugin = {
    serialize,
    test
};
var _default = plugin;
exports.default = _default;

},{"fd0043a38e038eeb":"8bd63"}],"lbo6x":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = exports.test = exports.serialize = void 0;
var ReactIs = _interopRequireWildcard(require("a93bbd839bfe075c"));
var _markup = require("5bea4381922ec67");
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
/**
 * Copyright (c) Facebook, Inc. and its affiliates. All Rights Reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ // Given element.props.children, or subtree during recursive traversal,
// return flattened array of children.
const getChildren = (arg, children = [])=>{
    if (Array.isArray(arg)) arg.forEach((item)=>{
        getChildren(item, children);
    });
    else if (arg != null && arg !== false) children.push(arg);
    return children;
};
const getType = (element)=>{
    const type = element.type;
    if (typeof type === "string") return type;
    if (typeof type === "function") return type.displayName || type.name || "Unknown";
    if (ReactIs.isFragment(element)) return "React.Fragment";
    if (ReactIs.isSuspense(element)) return "React.Suspense";
    if (typeof type === "object" && type !== null) {
        if (ReactIs.isContextProvider(element)) return "Context.Provider";
        if (ReactIs.isContextConsumer(element)) return "Context.Consumer";
        if (ReactIs.isForwardRef(element)) {
            if (type.displayName) return type.displayName;
            const functionName = type.render.displayName || type.render.name || "";
            return functionName !== "" ? "ForwardRef(" + functionName + ")" : "ForwardRef";
        }
        if (ReactIs.isMemo(element)) {
            const functionName = type.displayName || type.type.displayName || type.type.name || "";
            return functionName !== "" ? "Memo(" + functionName + ")" : "Memo";
        }
    }
    return "UNDEFINED";
};
const getPropKeys = (element)=>{
    const { props } = element;
    return Object.keys(props).filter((key)=>key !== "children" && props[key] !== undefined).sort();
};
const serialize = (element, config, indentation, depth, refs, printer)=>++depth > config.maxDepth ? (0, _markup.printElementAsLeaf)(getType(element), config) : (0, _markup.printElement)(getType(element), (0, _markup.printProps)(getPropKeys(element), element.props, config, indentation + config.indent, depth, refs, printer), (0, _markup.printChildren)(getChildren(element.props.children), config, indentation + config.indent, depth, refs, printer), config, indentation);
exports.serialize = serialize;
const test = (val)=>val != null && ReactIs.isElement(val);
exports.test = test;
const plugin = {
    serialize,
    test
};
var _default = plugin;
exports.default = _default;

},{"a93bbd839bfe075c":"61avk","5bea4381922ec67":"aNNIr"}],"61avk":[function(require,module,exports) {
"use strict";
module.exports = require("d16c6ba6214b47c3");

},{"d16c6ba6214b47c3":"2CiXh"}],"2CiXh":[function(require,module,exports) {
/** @license React v17.0.2
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var b = 60103, c = 60106, d = 60107, e = 60108, f = 60114, g = 60109, h = 60110, k = 60112, l = 60113, m = 60120, n = 60115, p = 60116, q = 60121, r = 60122, u = 60117, v = 60129, w = 60131;
if ("function" === typeof Symbol && Symbol.for) {
    var x = Symbol.for;
    b = x("react.element");
    c = x("react.portal");
    d = x("react.fragment");
    e = x("react.strict_mode");
    f = x("react.profiler");
    g = x("react.provider");
    h = x("react.context");
    k = x("react.forward_ref");
    l = x("react.suspense");
    m = x("react.suspense_list");
    n = x("react.memo");
    p = x("react.lazy");
    q = x("react.block");
    r = x("react.server.block");
    u = x("react.fundamental");
    v = x("react.debug_trace_mode");
    w = x("react.legacy_hidden");
}
function y(a) {
    if ("object" === typeof a && null !== a) {
        var t = a.$$typeof;
        switch(t){
            case b:
                switch(a = a.type, a){
                    case d:
                    case f:
                    case e:
                    case l:
                    case m:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case h:
                            case k:
                            case p:
                            case n:
                            case g:
                                return a;
                            default:
                                return t;
                        }
                }
            case c:
                return t;
        }
    }
}
var z = g, A = b, B = k, C = d, D = p, E = n, F = c, G = f, H = e, I = l;
exports.ContextConsumer = h;
exports.ContextProvider = z;
exports.Element = A;
exports.ForwardRef = B;
exports.Fragment = C;
exports.Lazy = D;
exports.Memo = E;
exports.Portal = F;
exports.Profiler = G;
exports.StrictMode = H;
exports.Suspense = I;
exports.isAsyncMode = function() {
    return !1;
};
exports.isConcurrentMode = function() {
    return !1;
};
exports.isContextConsumer = function(a) {
    return y(a) === h;
};
exports.isContextProvider = function(a) {
    return y(a) === g;
};
exports.isElement = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === b;
};
exports.isForwardRef = function(a) {
    return y(a) === k;
};
exports.isFragment = function(a) {
    return y(a) === d;
};
exports.isLazy = function(a) {
    return y(a) === p;
};
exports.isMemo = function(a) {
    return y(a) === n;
};
exports.isPortal = function(a) {
    return y(a) === c;
};
exports.isProfiler = function(a) {
    return y(a) === f;
};
exports.isStrictMode = function(a) {
    return y(a) === e;
};
exports.isSuspense = function(a) {
    return y(a) === l;
};
exports.isValidElementType = function(a) {
    return "string" === typeof a || "function" === typeof a || a === d || a === f || a === v || a === e || a === l || a === m || a === w || "object" === typeof a && null !== a && (a.$$typeof === p || a.$$typeof === n || a.$$typeof === g || a.$$typeof === h || a.$$typeof === k || a.$$typeof === u || a.$$typeof === q || a[0] === r) ? !0 : !1;
};
exports.typeOf = y;

},{}],"csTcU":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = exports.test = exports.serialize = void 0;
var _markup = require("2b0589fda4e35598");
var global = function() {
    if (typeof globalThis !== "undefined") return globalThis;
    else if (typeof global !== "undefined") return global;
    else if (typeof self !== "undefined") return self;
    else if (typeof window !== "undefined") return window;
    else return Function("return this")();
}();
var Symbol = global["jest-symbol-do-not-touch"] || global.Symbol;
const testSymbol = typeof Symbol === "function" && Symbol.for ? Symbol.for("react.test.json") : 0xea71357;
const getPropKeys = (object)=>{
    const { props } = object;
    return props ? Object.keys(props).filter((key)=>props[key] !== undefined).sort() : [];
};
const serialize = (object, config, indentation, depth, refs, printer)=>++depth > config.maxDepth ? (0, _markup.printElementAsLeaf)(object.type, config) : (0, _markup.printElement)(object.type, object.props ? (0, _markup.printProps)(getPropKeys(object), object.props, config, indentation + config.indent, depth, refs, printer) : "", object.children ? (0, _markup.printChildren)(object.children, config, indentation + config.indent, depth, refs, printer) : "", config, indentation);
exports.serialize = serialize;
const test = (val)=>val && val.$$typeof === testSymbol;
exports.test = test;
const plugin = {
    serialize,
    test
};
var _default = plugin;
exports.default = _default;

},{"2b0589fda4e35598":"aNNIr"}],"lPB7U":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "computeAccessibleDescription", ()=>(0, _accessibleDescriptionMjs.computeAccessibleDescription));
parcelHelpers.export(exports, "computeAccessibleName", ()=>(0, _accessibleNameMjs.computeAccessibleName));
parcelHelpers.export(exports, "getRole", ()=>(0, _getRoleMjsDefault.default));
var _accessibleDescriptionMjs = require("./accessible-description.mjs");
var _accessibleNameMjs = require("./accessible-name.mjs");
var _getRoleMjs = require("./getRole.mjs");
var _getRoleMjsDefault = parcelHelpers.interopDefault(_getRoleMjs);
var _isInaccessibleMjs = require("./is-inaccessible.mjs");
parcelHelpers.exportAll(_isInaccessibleMjs, exports);

},{"./accessible-description.mjs":"f37w4","./accessible-name.mjs":"fvBJl","./getRole.mjs":"daIBu","./is-inaccessible.mjs":"1VBsJ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"f37w4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @param root
 * @param options
 * @returns
 */ parcelHelpers.export(exports, "computeAccessibleDescription", ()=>computeAccessibleDescription);
var _accessibleNameAndDescriptionMjs = require("./accessible-name-and-description.mjs");
var _utilMjs = require("./util.mjs");
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function computeAccessibleDescription(root) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var description = (0, _utilMjs.queryIdRefs)(root, "aria-describedby").map(function(element) {
        return (0, _accessibleNameAndDescriptionMjs.computeTextAlternative)(element, _objectSpread(_objectSpread({}, options), {}, {
            compute: "description"
        }));
    }).join(" "); // TODO: Technically we need to make sure that node wasn't used for the accessible name
    //       This causes `description_1.0_combobox-focusable-manual` to fail
    //
    // https://www.w3.org/TR/html-aam-1.0/#accessible-name-and-description-computation
    // says for so many elements to use the `title` that we assume all elements are considered
    if (description === "") {
        var title = root.getAttribute("title");
        description = title === null ? "" : title;
    }
    return description;
}

},{"./accessible-name-and-description.mjs":"30QqR","./util.mjs":"j7scl","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"30QqR":[function(require,module,exports) {
/**
 * implements https://w3c.github.io/accname/
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * implements https://w3c.github.io/accname/#mapping_additional_nd_te
 * @param root
 * @param options
 * @returns
 */ parcelHelpers.export(exports, "computeTextAlternative", ()=>computeTextAlternative);
var _arrayFromMjs = require("./polyfills/array.from.mjs");
var _arrayFromMjsDefault = parcelHelpers.interopDefault(_arrayFromMjs);
var _setLikeMjs = require("./polyfills/SetLike.mjs");
var _setLikeMjsDefault = parcelHelpers.interopDefault(_setLikeMjs);
var _utilMjs = require("./util.mjs");
/**
 *  A string of characters where all carriage returns, newlines, tabs, and form-feeds are replaced with a single space, and multiple spaces are reduced to a single space. The string contains only character data; it does not contain any markup.
 */ /**
 *
 * @param {string} string -
 * @returns {FlatString} -
 */ function asFlatString(s) {
    return s.trim().replace(/\s\s+/g, " ");
}
/**
 *
 * @param node -
 * @param options - These are not optional to prevent accidentally calling it without options in `computeAccessibleName`
 * @returns {boolean} -
 */ function isHidden(node, getComputedStyleImplementation) {
    if (!(0, _utilMjs.isElement)(node)) return false;
    if (node.hasAttribute("hidden") || node.getAttribute("aria-hidden") === "true") return true;
    var style = getComputedStyleImplementation(node);
    return style.getPropertyValue("display") === "none" || style.getPropertyValue("visibility") === "hidden";
}
/**
 * @param {Node} node -
 * @returns {boolean} - As defined in step 2E of https://w3c.github.io/accname/#mapping_additional_nd_te
 */ function isControl(node) {
    return (0, _utilMjs.hasAnyConcreteRoles)(node, [
        "button",
        "combobox",
        "listbox",
        "textbox"
    ]) || hasAbstractRole(node, "range");
}
function hasAbstractRole(node, role) {
    if (!(0, _utilMjs.isElement)(node)) return false;
    switch(role){
        case "range":
            return (0, _utilMjs.hasAnyConcreteRoles)(node, [
                "meter",
                "progressbar",
                "scrollbar",
                "slider",
                "spinbutton"
            ]);
        default:
            throw new TypeError("No knowledge about abstract role '".concat(role, "'. This is likely a bug :("));
    }
}
/**
 * element.querySelectorAll but also considers owned tree
 * @param element
 * @param selectors
 */ function querySelectorAllSubtree(element, selectors) {
    var elements = (0, _arrayFromMjsDefault.default)(element.querySelectorAll(selectors));
    (0, _utilMjs.queryIdRefs)(element, "aria-owns").forEach(function(root) {
        // babel transpiles this assuming an iterator
        elements.push.apply(elements, (0, _arrayFromMjsDefault.default)(root.querySelectorAll(selectors)));
    });
    return elements;
}
function querySelectedOptions(listbox) {
    if ((0, _utilMjs.isHTMLSelectElement)(listbox)) // IE11 polyfill
    return listbox.selectedOptions || querySelectorAllSubtree(listbox, "[selected]");
    return querySelectorAllSubtree(listbox, '[aria-selected="true"]');
}
function isMarkedPresentational(node) {
    return (0, _utilMjs.hasAnyConcreteRoles)(node, [
        "none",
        "presentation"
    ]);
}
/**
 * Elements specifically listed in html-aam
 *
 * We don't need this for `label` or `legend` elements.
 * Their implicit roles already allow "naming from content".
 *
 * sources:
 *
 * - https://w3c.github.io/html-aam/#table-element
 */ function isNativeHostLanguageTextAlternativeElement(node) {
    return (0, _utilMjs.isHTMLTableCaptionElement)(node);
}
/**
 * https://w3c.github.io/aria/#namefromcontent
 */ function allowsNameFromContent(node) {
    return (0, _utilMjs.hasAnyConcreteRoles)(node, [
        "button",
        "cell",
        "checkbox",
        "columnheader",
        "gridcell",
        "heading",
        "label",
        "legend",
        "link",
        "menuitem",
        "menuitemcheckbox",
        "menuitemradio",
        "option",
        "radio",
        "row",
        "rowheader",
        "switch",
        "tab",
        "tooltip",
        "treeitem"
    ]);
}
/**
 * TODO https://github.com/eps1lon/dom-accessibility-api/issues/100
 */ function isDescendantOfNativeHostLanguageTextAlternativeElement(node) {
    return false;
}
/**
 * TODO https://github.com/eps1lon/dom-accessibility-api/issues/101
 */ // eslint-disable-next-line @typescript-eslint/no-unused-vars -- not implemented yet
function computeTooltipAttributeValue(node) {
    return null;
}
function getValueOfTextbox(element) {
    if ((0, _utilMjs.isHTMLInputElement)(element) || (0, _utilMjs.isHTMLTextAreaElement)(element)) return element.value;
     // https://github.com/eps1lon/dom-accessibility-api/issues/4
    return element.textContent || "";
}
function getTextualContent(declaration) {
    var content = declaration.getPropertyValue("content");
    if (/^["'].*["']$/.test(content)) return content.slice(1, -1);
    return "";
}
/**
 * https://html.spec.whatwg.org/multipage/forms.html#category-label
 * TODO: form-associated custom elements
 * @param element
 */ function isLabelableElement(element) {
    var localName = (0, _utilMjs.getLocalName)(element);
    return localName === "button" || localName === "input" && element.getAttribute("type") !== "hidden" || localName === "meter" || localName === "output" || localName === "progress" || localName === "select" || localName === "textarea";
}
/**
 * > [...], then the first such descendant in tree order is the label element's labeled control.
 * -- https://html.spec.whatwg.org/multipage/forms.html#labeled-control
 * @param element
 */ function findLabelableElement(element) {
    if (isLabelableElement(element)) return element;
    var labelableElement = null;
    element.childNodes.forEach(function(childNode) {
        if (labelableElement === null && (0, _utilMjs.isElement)(childNode)) {
            var descendantLabelableElement = findLabelableElement(childNode);
            if (descendantLabelableElement !== null) labelableElement = descendantLabelableElement;
        }
    });
    return labelableElement;
}
/**
 * Polyfill of HTMLLabelElement.control
 * https://html.spec.whatwg.org/multipage/forms.html#labeled-control
 * @param label
 */ function getControlOfLabel(label) {
    if (label.control !== undefined) return label.control;
    var htmlFor = label.getAttribute("for");
    if (htmlFor !== null) return label.ownerDocument.getElementById(htmlFor);
    return findLabelableElement(label);
}
/**
 * Polyfill of HTMLInputElement.labels
 * https://developer.mozilla.org/en-US/docs/Web/API/HTMLInputElement/labels
 * @param element
 */ function getLabels(element) {
    var labelsProperty = element.labels;
    if (labelsProperty === null) return labelsProperty;
    if (labelsProperty !== undefined) return (0, _arrayFromMjsDefault.default)(labelsProperty);
     // polyfill
    if (!isLabelableElement(element)) return null;
    var document = element.ownerDocument;
    return (0, _arrayFromMjsDefault.default)(document.querySelectorAll("label")).filter(function(label) {
        return getControlOfLabel(label) === element;
    });
}
/**
 * Gets the contents of a slot used for computing the accname
 * @param slot
 */ function getSlotContents(slot) {
    // Computing the accessible name for elements containing slots is not
    // currently defined in the spec. This implementation reflects the
    // behavior of NVDA 2020.2/Firefox 81 and iOS VoiceOver/Safari 13.6.
    var assignedNodes = slot.assignedNodes();
    if (assignedNodes.length === 0) // if no nodes are assigned to the slot, it displays the default content
    return (0, _arrayFromMjsDefault.default)(slot.childNodes);
    return assignedNodes;
}
function computeTextAlternative(root) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var consultedNodes = new (0, _setLikeMjsDefault.default)();
    var window = (0, _utilMjs.safeWindow)(root);
    var _options$compute = options.compute, compute = _options$compute === void 0 ? "name" : _options$compute, _options$computedStyl = options.computedStyleSupportsPseudoElements, computedStyleSupportsPseudoElements = _options$computedStyl === void 0 ? options.getComputedStyle !== undefined : _options$computedStyl, _options$getComputedS = options.getComputedStyle, getComputedStyle = _options$getComputedS === void 0 ? window.getComputedStyle.bind(window) : _options$getComputedS, _options$hidden = options.hidden, hidden = _options$hidden === void 0 ? false : _options$hidden; // 2F.i
    function computeMiscTextAlternative(node, context) {
        var accumulatedText = "";
        if ((0, _utilMjs.isElement)(node) && computedStyleSupportsPseudoElements) {
            var pseudoBefore = getComputedStyle(node, "::before");
            var beforeContent = getTextualContent(pseudoBefore);
            accumulatedText = "".concat(beforeContent, " ").concat(accumulatedText);
        } // FIXME: Including aria-owns is not defined in the spec
        // But it is required in the web-platform-test
        var childNodes = (0, _utilMjs.isHTMLSlotElement)(node) ? getSlotContents(node) : (0, _arrayFromMjsDefault.default)(node.childNodes).concat((0, _utilMjs.queryIdRefs)(node, "aria-owns"));
        childNodes.forEach(function(child) {
            var result = computeTextAlternative(child, {
                isEmbeddedInLabel: context.isEmbeddedInLabel,
                isReferenced: false,
                recursion: true
            }); // TODO: Unclear why display affects delimiter
            // see https://github.com/w3c/accname/issues/3
            var display = (0, _utilMjs.isElement)(child) ? getComputedStyle(child).getPropertyValue("display") : "inline";
            var separator = display !== "inline" ? " " : ""; // trailing separator for wpt tests
            accumulatedText += "".concat(separator).concat(result).concat(separator);
        });
        if ((0, _utilMjs.isElement)(node) && computedStyleSupportsPseudoElements) {
            var pseudoAfter = getComputedStyle(node, "::after");
            var afterContent = getTextualContent(pseudoAfter);
            accumulatedText = "".concat(accumulatedText, " ").concat(afterContent);
        }
        return accumulatedText;
    }
    function computeElementTextAlternative(node) {
        if (!(0, _utilMjs.isElement)(node)) return null;
        /**
     *
     * @param element
     * @param attributeName
     * @returns A string non-empty string or `null`
     */ function useAttribute(element, attributeName) {
            var attribute = element.getAttributeNode(attributeName);
            if (attribute !== null && !consultedNodes.has(attribute) && attribute.value.trim() !== "") {
                consultedNodes.add(attribute);
                return attribute.value;
            }
            return null;
        } // https://w3c.github.io/html-aam/#fieldset-and-legend-elements
        if ((0, _utilMjs.isHTMLFieldSetElement)(node)) {
            consultedNodes.add(node);
            var children = (0, _arrayFromMjsDefault.default)(node.childNodes);
            for(var i = 0; i < children.length; i += 1){
                var child = children[i];
                if ((0, _utilMjs.isHTMLLegendElement)(child)) return computeTextAlternative(child, {
                    isEmbeddedInLabel: false,
                    isReferenced: false,
                    recursion: false
                });
            }
        } else if ((0, _utilMjs.isHTMLTableElement)(node)) {
            // https://w3c.github.io/html-aam/#table-element
            consultedNodes.add(node);
            var _children = (0, _arrayFromMjsDefault.default)(node.childNodes);
            for(var _i = 0; _i < _children.length; _i += 1){
                var _child = _children[_i];
                if ((0, _utilMjs.isHTMLTableCaptionElement)(_child)) return computeTextAlternative(_child, {
                    isEmbeddedInLabel: false,
                    isReferenced: false,
                    recursion: false
                });
            }
        } else if ((0, _utilMjs.isSVGSVGElement)(node)) {
            // https://www.w3.org/TR/svg-aam-1.0/
            consultedNodes.add(node);
            var _children2 = (0, _arrayFromMjsDefault.default)(node.childNodes);
            for(var _i2 = 0; _i2 < _children2.length; _i2 += 1){
                var _child2 = _children2[_i2];
                if ((0, _utilMjs.isSVGTitleElement)(_child2)) return _child2.textContent;
            }
            return null;
        } else if ((0, _utilMjs.getLocalName)(node) === "img" || (0, _utilMjs.getLocalName)(node) === "area") {
            // https://w3c.github.io/html-aam/#area-element
            // https://w3c.github.io/html-aam/#img-element
            var nameFromAlt = useAttribute(node, "alt");
            if (nameFromAlt !== null) return nameFromAlt;
        } else if ((0, _utilMjs.isHTMLOptGroupElement)(node)) {
            var nameFromLabel = useAttribute(node, "label");
            if (nameFromLabel !== null) return nameFromLabel;
        }
        if ((0, _utilMjs.isHTMLInputElement)(node) && (node.type === "button" || node.type === "submit" || node.type === "reset")) {
            // https://w3c.github.io/html-aam/#input-type-text-input-type-password-input-type-search-input-type-tel-input-type-email-input-type-url-and-textarea-element-accessible-description-computation
            var nameFromValue = useAttribute(node, "value");
            if (nameFromValue !== null) return nameFromValue;
             // TODO: l10n
            if (node.type === "submit") return "Submit";
             // TODO: l10n
            if (node.type === "reset") return "Reset";
        }
        var labels = getLabels(node);
        if (labels !== null && labels.length !== 0) {
            consultedNodes.add(node);
            return (0, _arrayFromMjsDefault.default)(labels).map(function(element) {
                return computeTextAlternative(element, {
                    isEmbeddedInLabel: true,
                    isReferenced: false,
                    recursion: true
                });
            }).filter(function(label) {
                return label.length > 0;
            }).join(" ");
        } // https://w3c.github.io/html-aam/#input-type-image-accessible-name-computation
        // TODO: wpt test consider label elements but html-aam does not mention them
        // We follow existing implementations over spec
        if ((0, _utilMjs.isHTMLInputElement)(node) && node.type === "image") {
            var _nameFromAlt = useAttribute(node, "alt");
            if (_nameFromAlt !== null) return _nameFromAlt;
            var nameFromTitle = useAttribute(node, "title");
            if (nameFromTitle !== null) return nameFromTitle;
             // TODO: l10n
            return "Submit Query";
        }
        return useAttribute(node, "title");
    }
    function computeTextAlternative(current, context) {
        if (consultedNodes.has(current)) return "";
         // 2A
        if (!hidden && isHidden(current, getComputedStyle) && !context.isReferenced) {
            consultedNodes.add(current);
            return "";
        } // 2B
        var labelElements = (0, _utilMjs.queryIdRefs)(current, "aria-labelledby");
        if (compute === "name" && !context.isReferenced && labelElements.length > 0) return labelElements.map(function(element) {
            return computeTextAlternative(element, {
                isEmbeddedInLabel: context.isEmbeddedInLabel,
                isReferenced: true,
                // thais isn't recursion as specified, otherwise we would skip
                // `aria-label` in
                // <input id="myself" aria-label="foo" aria-labelledby="myself"
                recursion: false
            });
        }).join(" ");
         // 2C
        // Changed from the spec in anticipation of https://github.com/w3c/accname/issues/64
        // spec says we should only consider skipping if we have a non-empty label
        var skipToStep2E = context.recursion && isControl(current) && compute === "name";
        if (!skipToStep2E) {
            var ariaLabel = ((0, _utilMjs.isElement)(current) && current.getAttribute("aria-label") || "").trim();
            if (ariaLabel !== "" && compute === "name") {
                consultedNodes.add(current);
                return ariaLabel;
            } // 2D
            if (!isMarkedPresentational(current)) {
                var elementTextAlternative = computeElementTextAlternative(current);
                if (elementTextAlternative !== null) {
                    consultedNodes.add(current);
                    return elementTextAlternative;
                }
            }
        } // special casing, cheating to make tests pass
        // https://github.com/w3c/accname/issues/67
        if ((0, _utilMjs.hasAnyConcreteRoles)(current, [
            "menu"
        ])) {
            consultedNodes.add(current);
            return "";
        } // 2E
        if (skipToStep2E || context.isEmbeddedInLabel || context.isReferenced) {
            if ((0, _utilMjs.hasAnyConcreteRoles)(current, [
                "combobox",
                "listbox"
            ])) {
                consultedNodes.add(current);
                var selectedOptions = querySelectedOptions(current);
                if (selectedOptions.length === 0) // defined per test `name_heading_combobox`
                return (0, _utilMjs.isHTMLInputElement)(current) ? current.value : "";
                return (0, _arrayFromMjsDefault.default)(selectedOptions).map(function(selectedOption) {
                    return computeTextAlternative(selectedOption, {
                        isEmbeddedInLabel: context.isEmbeddedInLabel,
                        isReferenced: false,
                        recursion: true
                    });
                }).join(" ");
            }
            if (hasAbstractRole(current, "range")) {
                consultedNodes.add(current);
                if (current.hasAttribute("aria-valuetext")) // eslint-disable-next-line @typescript-eslint/no-non-null-assertion -- safe due to hasAttribute guard
                return current.getAttribute("aria-valuetext");
                if (current.hasAttribute("aria-valuenow")) // eslint-disable-next-line @typescript-eslint/no-non-null-assertion -- safe due to hasAttribute guard
                return current.getAttribute("aria-valuenow");
                 // Otherwise, use the value as specified by a host language attribute.
                return current.getAttribute("value") || "";
            }
            if ((0, _utilMjs.hasAnyConcreteRoles)(current, [
                "textbox"
            ])) {
                consultedNodes.add(current);
                return getValueOfTextbox(current);
            }
        } // 2F: https://w3c.github.io/accname/#step2F
        if (allowsNameFromContent(current) || (0, _utilMjs.isElement)(current) && context.isReferenced || isNativeHostLanguageTextAlternativeElement(current) || isDescendantOfNativeHostLanguageTextAlternativeElement(current)) {
            consultedNodes.add(current);
            return computeMiscTextAlternative(current, {
                isEmbeddedInLabel: context.isEmbeddedInLabel,
                isReferenced: false
            });
        }
        if (current.nodeType === current.TEXT_NODE) {
            consultedNodes.add(current);
            return current.textContent || "";
        }
        if (context.recursion) {
            consultedNodes.add(current);
            return computeMiscTextAlternative(current, {
                isEmbeddedInLabel: context.isEmbeddedInLabel,
                isReferenced: false
            });
        }
        var tooltipAttributeValue = computeTooltipAttributeValue(current);
        if (tooltipAttributeValue !== null) {
            consultedNodes.add(current);
            return tooltipAttributeValue;
        } // TODO should this be reachable?
        consultedNodes.add(current);
        return "";
    }
    return asFlatString(computeTextAlternative(root, {
        isEmbeddedInLabel: false,
        // by spec computeAccessibleDescription starts with the referenced elements as roots
        isReferenced: compute === "description",
        recursion: false
    }));
}

},{"./polyfills/array.from.mjs":"35Eqq","./polyfills/SetLike.mjs":"j8Bpi","./util.mjs":"j7scl","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"35Eqq":[function(require,module,exports) {
/**
 * @source {https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/from#Polyfill}
 * but without thisArg (too hard to type, no need to `this`)
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>arrayFrom);
var toStr = Object.prototype.toString;
function isCallable(fn) {
    return typeof fn === "function" || toStr.call(fn) === "[object Function]";
}
function toInteger(value) {
    var number = Number(value);
    if (isNaN(number)) return 0;
    if (number === 0 || !isFinite(number)) return number;
    return (number > 0 ? 1 : -1) * Math.floor(Math.abs(number));
}
var maxSafeInteger = Math.pow(2, 53) - 1;
function toLength(value) {
    var len = toInteger(value);
    return Math.min(Math.max(len, 0), maxSafeInteger);
}
function arrayFrom(arrayLike, mapFn) {
    // 1. Let C be the this value.
    // edit(@eps1lon): we're not calling it as Array.from
    var C = Array; // 2. Let items be ToObject(arrayLike).
    var items = Object(arrayLike); // 3. ReturnIfAbrupt(items).
    if (arrayLike == null) throw new TypeError("Array.from requires an array-like object - not null or undefined");
     // 4. If mapfn is undefined, then let mapping be false.
    // const mapFn = arguments.length > 1 ? arguments[1] : void undefined;
    if (typeof mapFn !== "undefined") {
        // 5. else
        // 5. a If IsCallable(mapfn) is false, throw a TypeError exception.
        if (!isCallable(mapFn)) throw new TypeError("Array.from: when provided, the second argument must be a function");
    } // 10. Let lenValue be Get(items, "length").
    // 11. Let len be ToLength(lenValue).
    var len = toLength(items.length); // 13. If IsConstructor(C) is true, then
    // 13. a. Let A be the result of calling the [[Construct]] internal method
    // of C with an argument list containing the single item len.
    // 14. a. Else, Let A be ArrayCreate(len).
    var A = isCallable(C) ? Object(new C(len)) : new Array(len); // 16. Let k be 0.
    var k = 0; // 17. Repeat, while k < len… (also steps a - h)
    var kValue;
    while(k < len){
        kValue = items[k];
        if (mapFn) A[k] = mapFn(kValue, k);
        else A[k] = kValue;
        k += 1;
    } // 18. Let putStatus be Put(A, "length", len, true).
    A.length = len; // 20. Return A.
    return A;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"j8Bpi":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
// for environments without Set we fallback to arrays with unique members
var SetLike = /*#__PURE__*/ function() {
    function SetLike() {
        var items = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        _classCallCheck(this, SetLike);
        _defineProperty(this, "items", void 0);
        this.items = items;
    }
    _createClass(SetLike, [
        {
            key: "add",
            value: function add(value) {
                if (this.has(value) === false) this.items.push(value);
                return this;
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.items = [];
            }
        },
        {
            key: "delete",
            value: function _delete(value) {
                var previousLength = this.items.length;
                this.items = this.items.filter(function(item) {
                    return item !== value;
                });
                return previousLength !== this.items.length;
            }
        },
        {
            key: "forEach",
            value: function forEach(callbackfn) {
                var _this = this;
                this.items.forEach(function(item) {
                    callbackfn(item, item, _this);
                });
            }
        },
        {
            key: "has",
            value: function has(value) {
                return this.items.indexOf(value) !== -1;
            }
        },
        {
            key: "size",
            get: function get() {
                return this.items.length;
            }
        }
    ]);
    return SetLike;
}();
exports.default = typeof Set === "undefined" ? Set : SetLike;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"j7scl":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Safe Element.localName for all supported environments
 * @param element
 */ parcelHelpers.export(exports, "getLocalName", ()=>getLocalName);
parcelHelpers.export(exports, "isElement", ()=>isElement);
parcelHelpers.export(exports, "isHTMLTableCaptionElement", ()=>isHTMLTableCaptionElement);
parcelHelpers.export(exports, "isHTMLInputElement", ()=>isHTMLInputElement);
parcelHelpers.export(exports, "isHTMLOptGroupElement", ()=>isHTMLOptGroupElement);
parcelHelpers.export(exports, "isHTMLSelectElement", ()=>isHTMLSelectElement);
parcelHelpers.export(exports, "isHTMLTableElement", ()=>isHTMLTableElement);
parcelHelpers.export(exports, "isHTMLTextAreaElement", ()=>isHTMLTextAreaElement);
parcelHelpers.export(exports, "safeWindow", ()=>safeWindow);
parcelHelpers.export(exports, "isHTMLFieldSetElement", ()=>isHTMLFieldSetElement);
parcelHelpers.export(exports, "isHTMLLegendElement", ()=>isHTMLLegendElement);
parcelHelpers.export(exports, "isHTMLSlotElement", ()=>isHTMLSlotElement);
parcelHelpers.export(exports, "isSVGElement", ()=>isSVGElement);
parcelHelpers.export(exports, "isSVGSVGElement", ()=>isSVGSVGElement);
parcelHelpers.export(exports, "isSVGTitleElement", ()=>isSVGTitleElement);
/**
 *
 * @param {Node} node -
 * @param {string} attributeName -
 * @returns {Element[]} -
 */ parcelHelpers.export(exports, "queryIdRefs", ()=>queryIdRefs);
parcelHelpers.export(exports, "hasAnyConcreteRoles", ()=>hasAnyConcreteRoles);
var _getRoleMjs = require("./getRole.mjs");
var _getRoleMjsDefault = parcelHelpers.interopDefault(_getRoleMjs);
function getLocalName(element) {
    var _element$localName;
    return (_element$localName = element.localName) !== null && _element$localName !== void 0 ? _element$localName : element.tagName.toLowerCase();
}
function isElement(node) {
    return node !== null && node.nodeType === node.ELEMENT_NODE;
}
function isHTMLTableCaptionElement(node) {
    return isElement(node) && getLocalName(node) === "caption";
}
function isHTMLInputElement(node) {
    return isElement(node) && getLocalName(node) === "input";
}
function isHTMLOptGroupElement(node) {
    return isElement(node) && getLocalName(node) === "optgroup";
}
function isHTMLSelectElement(node) {
    return isElement(node) && getLocalName(node) === "select";
}
function isHTMLTableElement(node) {
    return isElement(node) && getLocalName(node) === "table";
}
function isHTMLTextAreaElement(node) {
    return isElement(node) && getLocalName(node) === "textarea";
}
function safeWindow(node) {
    var _ref = node.ownerDocument === null ? node : node.ownerDocument, defaultView = _ref.defaultView;
    if (defaultView === null) throw new TypeError("no window available");
    return defaultView;
}
function isHTMLFieldSetElement(node) {
    return isElement(node) && getLocalName(node) === "fieldset";
}
function isHTMLLegendElement(node) {
    return isElement(node) && getLocalName(node) === "legend";
}
function isHTMLSlotElement(node) {
    return isElement(node) && getLocalName(node) === "slot";
}
function isSVGElement(node) {
    return isElement(node) && node.ownerSVGElement !== undefined;
}
function isSVGSVGElement(node) {
    return isElement(node) && getLocalName(node) === "svg";
}
function isSVGTitleElement(node) {
    return isSVGElement(node) && getLocalName(node) === "title";
}
function queryIdRefs(node, attributeName) {
    if (isElement(node) && node.hasAttribute(attributeName)) {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion -- safe due to hasAttribute check
        var ids = node.getAttribute(attributeName).split(" ");
        return ids.map(function(id) {
            return node.ownerDocument.getElementById(id);
        }).filter(function(element) {
            return element !== null;
        } // TODO: why does this not narrow?
        );
    }
    return [];
}
function hasAnyConcreteRoles(node, roles) {
    if (isElement(node)) return roles.indexOf((0, _getRoleMjsDefault.default)(node)) !== -1;
    return false;
}

},{"./getRole.mjs":"daIBu","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"daIBu":[function(require,module,exports) {
// https://w3c.github.io/html-aria/#document-conformance-requirements-for-use-of-aria-attributes-in-html
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getRole);
var _utilMjs = require("./util.mjs");
var localNameToRoleMappings = {
    article: "article",
    aside: "complementary",
    button: "button",
    datalist: "listbox",
    dd: "definition",
    details: "group",
    dialog: "dialog",
    dt: "term",
    fieldset: "group",
    figure: "figure",
    // WARNING: Only with an accessible name
    form: "form",
    footer: "contentinfo",
    h1: "heading",
    h2: "heading",
    h3: "heading",
    h4: "heading",
    h5: "heading",
    h6: "heading",
    header: "banner",
    hr: "separator",
    html: "document",
    legend: "legend",
    li: "listitem",
    math: "math",
    main: "main",
    menu: "list",
    nav: "navigation",
    ol: "list",
    optgroup: "group",
    // WARNING: Only in certain context
    option: "option",
    output: "status",
    progress: "progressbar",
    // WARNING: Only with an accessible name
    section: "region",
    summary: "button",
    table: "table",
    tbody: "rowgroup",
    textarea: "textbox",
    tfoot: "rowgroup",
    // WARNING: Only in certain context
    td: "cell",
    th: "columnheader",
    thead: "rowgroup",
    tr: "row",
    ul: "list"
};
var prohibitedAttributes = {
    caption: new Set([
        "aria-label",
        "aria-labelledby"
    ]),
    code: new Set([
        "aria-label",
        "aria-labelledby"
    ]),
    deletion: new Set([
        "aria-label",
        "aria-labelledby"
    ]),
    emphasis: new Set([
        "aria-label",
        "aria-labelledby"
    ]),
    generic: new Set([
        "aria-label",
        "aria-labelledby",
        "aria-roledescription"
    ]),
    insertion: new Set([
        "aria-label",
        "aria-labelledby"
    ]),
    paragraph: new Set([
        "aria-label",
        "aria-labelledby"
    ]),
    presentation: new Set([
        "aria-label",
        "aria-labelledby"
    ]),
    strong: new Set([
        "aria-label",
        "aria-labelledby"
    ]),
    subscript: new Set([
        "aria-label",
        "aria-labelledby"
    ]),
    superscript: new Set([
        "aria-label",
        "aria-labelledby"
    ])
};
/**
 *
 * @param element
 * @param role The role used for this element. This is specified to control whether you want to use the implicit or explicit role.
 */ function hasGlobalAriaAttributes(element, role) {
    // https://rawgit.com/w3c/aria/stable/#global_states
    // commented attributes are deprecated
    return [
        "aria-atomic",
        "aria-busy",
        "aria-controls",
        "aria-current",
        "aria-describedby",
        "aria-details",
        "aria-dropeffect",
        "aria-flowto",
        "aria-grabbed",
        "aria-hidden",
        "aria-keyshortcuts",
        "aria-label",
        "aria-labelledby",
        "aria-live",
        "aria-owns",
        "aria-relevant",
        "aria-roledescription"
    ].some(function(attributeName) {
        var _prohibitedAttributes;
        return element.hasAttribute(attributeName) && !((_prohibitedAttributes = prohibitedAttributes[role]) !== null && _prohibitedAttributes !== void 0 && _prohibitedAttributes.has(attributeName));
    });
}
function ignorePresentationalRole(element, implicitRole) {
    // https://rawgit.com/w3c/aria/stable/#conflict_resolution_presentation_none
    return hasGlobalAriaAttributes(element, implicitRole);
}
function getRole(element) {
    var explicitRole = getExplicitRole(element);
    if (explicitRole === null || explicitRole === "presentation") {
        var implicitRole = getImplicitRole(element);
        if (explicitRole !== "presentation" || ignorePresentationalRole(element, implicitRole || "")) return implicitRole;
    }
    return explicitRole;
}
function getImplicitRole(element) {
    var mappedByTag = localNameToRoleMappings[(0, _utilMjs.getLocalName)(element)];
    if (mappedByTag !== undefined) return mappedByTag;
    switch((0, _utilMjs.getLocalName)(element)){
        case "a":
        case "area":
        case "link":
            if (element.hasAttribute("href")) return "link";
            break;
        case "img":
            if (element.getAttribute("alt") === "" && !ignorePresentationalRole(element, "img")) return "presentation";
            return "img";
        case "input":
            var _ref = element, type = _ref.type;
            switch(type){
                case "button":
                case "image":
                case "reset":
                case "submit":
                    return "button";
                case "checkbox":
                case "radio":
                    return type;
                case "range":
                    return "slider";
                case "email":
                case "tel":
                case "text":
                case "url":
                    if (element.hasAttribute("list")) return "combobox";
                    return "textbox";
                case "search":
                    if (element.hasAttribute("list")) return "combobox";
                    return "searchbox";
                default:
                    return null;
            }
        case "select":
            if (element.hasAttribute("multiple") || element.size > 1) return "listbox";
            return "combobox";
    }
    return null;
}
function getExplicitRole(element) {
    var role = element.getAttribute("role");
    if (role !== null) {
        var explicitRole = role.trim().split(" ")[0]; // String.prototype.split(sep, limit) will always return an array with at least one member
        // as long as limit is either undefined or > 0
        if (explicitRole.length > 0) return explicitRole;
    }
    return null;
}

},{"./util.mjs":"j7scl","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"fvBJl":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * implements https://w3c.github.io/accname/#mapping_additional_nd_name
 * @param root
 * @param options
 * @returns
 */ parcelHelpers.export(exports, "computeAccessibleName", ()=>computeAccessibleName);
var _accessibleNameAndDescriptionMjs = require("./accessible-name-and-description.mjs");
var _utilMjs = require("./util.mjs");
/**
 * https://w3c.github.io/aria/#namefromprohibited
 */ function prohibitsNaming(node) {
    return (0, _utilMjs.hasAnyConcreteRoles)(node, [
        "caption",
        "code",
        "deletion",
        "emphasis",
        "generic",
        "insertion",
        "paragraph",
        "presentation",
        "strong",
        "subscript",
        "superscript"
    ]);
}
function computeAccessibleName(root) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (prohibitsNaming(root)) return "";
    return (0, _accessibleNameAndDescriptionMjs.computeTextAlternative)(root, options);
}

},{"./accessible-name-and-description.mjs":"30QqR","./util.mjs":"j7scl","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"1VBsJ":[function(require,module,exports) {
/**
 * Partial implementation https://www.w3.org/TR/wai-aria-1.2/#tree_exclusion
 * which should only be used for elements with a non-presentational role i.e.
 * `role="none"` and `role="presentation"` will not be excluded.
 *
 * Implements aria-hidden semantics (i.e. parent overrides child)
 * Ignores "Child Presentational: True" characteristics
 *
 * @param element
 * @param options
 * @returns {boolean} true if excluded, otherwise false
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isInaccessible", ()=>isInaccessible);
/**
 *
 * @param element
 * @param options
 * @returns {boolean} - `true` if every child of the element is inaccessible
 */ parcelHelpers.export(exports, "isSubtreeInaccessible", ()=>isSubtreeInaccessible);
function isInaccessible(element) {
    var _element$ownerDocumen;
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _options$getComputedS = options.getComputedStyle, getComputedStyle = _options$getComputedS === void 0 ? (_element$ownerDocumen = element.ownerDocument.defaultView) === null || _element$ownerDocumen === void 0 ? void 0 : _element$ownerDocumen.getComputedStyle : _options$getComputedS, _options$isSubtreeIna = options.isSubtreeInaccessible, isSubtreeInaccessibleImpl = _options$isSubtreeIna === void 0 ? isSubtreeInaccessible : _options$isSubtreeIna;
    if (typeof getComputedStyle !== "function") throw new TypeError("Owner document of the element needs to have an associated window.");
     // since visibility is inherited we can exit early
    if (getComputedStyle(element).visibility === "hidden") return true;
    var currentElement = element;
    while(currentElement){
        if (isSubtreeInaccessibleImpl(currentElement, {
            getComputedStyle: getComputedStyle
        })) return true;
        currentElement = currentElement.parentElement;
    }
    return false;
}
function isSubtreeInaccessible(element) {
    var _element$ownerDocumen2;
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _options$getComputedS2 = options.getComputedStyle, getComputedStyle = _options$getComputedS2 === void 0 ? (_element$ownerDocumen2 = element.ownerDocument.defaultView) === null || _element$ownerDocumen2 === void 0 ? void 0 : _element$ownerDocumen2.getComputedStyle : _options$getComputedS2;
    if (typeof getComputedStyle !== "function") throw new TypeError("Owner document of the element needs to have an associated window.");
    if (element.hidden === true) return true;
    if (element.getAttribute("aria-hidden") === "true") return true;
    if (getComputedStyle(element).display === "none") return true;
    return false;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"6RWmf":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.roles = exports.roleElements = exports.elementRoles = exports.dom = exports.aria = void 0;
var _ariaPropsMap = _interopRequireDefault(require("1c504d5471f66b20"));
var _domMap = _interopRequireDefault(require("72e92b03a66e862f"));
var _rolesMap = _interopRequireDefault(require("14b9260f0c5396d1"));
var _elementRoleMap = _interopRequireDefault(require("610e7fe3905bd928"));
var _roleElementMap = _interopRequireDefault(require("2cd5f5ef6d31358a"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var aria = _ariaPropsMap.default;
exports.aria = aria;
var dom = _domMap.default;
exports.dom = dom;
var roles = _rolesMap.default;
exports.roles = roles;
var elementRoles = _elementRoleMap.default;
exports.elementRoles = elementRoles;
var roleElements = _roleElementMap.default;
exports.roleElements = roleElements;

},{"1c504d5471f66b20":"71GPa","72e92b03a66e862f":"SVFeo","14b9260f0c5396d1":"4vhJn","610e7fe3905bd928":"cXXFm","2cd5f5ef6d31358a":"6pWDi"}],"71GPa":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _iterationDecorator = _interopRequireDefault(require("331af7edb1dbe93a"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (!it) {
        if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e2) {
                    throw _e2;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = it.call(o);
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e3) {
            didErr = true;
            err = _e3;
        },
        f: function f() {
            try {
                if (!normalCompletion && it.return != null) it.return();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var properties = [
    [
        "aria-activedescendant",
        {
            "type": "id"
        }
    ],
    [
        "aria-atomic",
        {
            "type": "boolean"
        }
    ],
    [
        "aria-autocomplete",
        {
            "type": "token",
            "values": [
                "inline",
                "list",
                "both",
                "none"
            ]
        }
    ],
    [
        "aria-busy",
        {
            "type": "boolean"
        }
    ],
    [
        "aria-checked",
        {
            "type": "tristate"
        }
    ],
    [
        "aria-colcount",
        {
            type: "integer"
        }
    ],
    [
        "aria-colindex",
        {
            type: "integer"
        }
    ],
    [
        "aria-colspan",
        {
            type: "integer"
        }
    ],
    [
        "aria-controls",
        {
            "type": "idlist"
        }
    ],
    [
        "aria-current",
        {
            type: "token",
            values: [
                "page",
                "step",
                "location",
                "date",
                "time",
                true,
                false
            ]
        }
    ],
    [
        "aria-describedby",
        {
            "type": "idlist"
        }
    ],
    [
        "aria-details",
        {
            "type": "id"
        }
    ],
    [
        "aria-disabled",
        {
            "type": "boolean"
        }
    ],
    [
        "aria-dropeffect",
        {
            "type": "tokenlist",
            "values": [
                "copy",
                "execute",
                "link",
                "move",
                "none",
                "popup"
            ]
        }
    ],
    [
        "aria-errormessage",
        {
            "type": "id"
        }
    ],
    [
        "aria-expanded",
        {
            "type": "boolean",
            "allowundefined": true
        }
    ],
    [
        "aria-flowto",
        {
            "type": "idlist"
        }
    ],
    [
        "aria-grabbed",
        {
            "type": "boolean",
            "allowundefined": true
        }
    ],
    [
        "aria-haspopup",
        {
            "type": "token",
            "values": [
                false,
                true,
                "menu",
                "listbox",
                "tree",
                "grid",
                "dialog"
            ]
        }
    ],
    [
        "aria-hidden",
        {
            "type": "boolean",
            "allowundefined": true
        }
    ],
    [
        "aria-invalid",
        {
            "type": "token",
            "values": [
                "grammar",
                false,
                "spelling",
                true
            ]
        }
    ],
    [
        "aria-keyshortcuts",
        {
            type: "string"
        }
    ],
    [
        "aria-label",
        {
            "type": "string"
        }
    ],
    [
        "aria-labelledby",
        {
            "type": "idlist"
        }
    ],
    [
        "aria-level",
        {
            "type": "integer"
        }
    ],
    [
        "aria-live",
        {
            "type": "token",
            "values": [
                "assertive",
                "off",
                "polite"
            ]
        }
    ],
    [
        "aria-modal",
        {
            type: "boolean"
        }
    ],
    [
        "aria-multiline",
        {
            "type": "boolean"
        }
    ],
    [
        "aria-multiselectable",
        {
            "type": "boolean"
        }
    ],
    [
        "aria-orientation",
        {
            "type": "token",
            "values": [
                "vertical",
                "undefined",
                "horizontal"
            ]
        }
    ],
    [
        "aria-owns",
        {
            "type": "idlist"
        }
    ],
    [
        "aria-placeholder",
        {
            type: "string"
        }
    ],
    [
        "aria-posinset",
        {
            "type": "integer"
        }
    ],
    [
        "aria-pressed",
        {
            "type": "tristate"
        }
    ],
    [
        "aria-readonly",
        {
            "type": "boolean"
        }
    ],
    [
        "aria-relevant",
        {
            "type": "tokenlist",
            "values": [
                "additions",
                "all",
                "removals",
                "text"
            ]
        }
    ],
    [
        "aria-required",
        {
            "type": "boolean"
        }
    ],
    [
        "aria-roledescription",
        {
            type: "string"
        }
    ],
    [
        "aria-rowcount",
        {
            type: "integer"
        }
    ],
    [
        "aria-rowindex",
        {
            type: "integer"
        }
    ],
    [
        "aria-rowspan",
        {
            type: "integer"
        }
    ],
    [
        "aria-selected",
        {
            "type": "boolean",
            "allowundefined": true
        }
    ],
    [
        "aria-setsize",
        {
            "type": "integer"
        }
    ],
    [
        "aria-sort",
        {
            "type": "token",
            "values": [
                "ascending",
                "descending",
                "none",
                "other"
            ]
        }
    ],
    [
        "aria-valuemax",
        {
            "type": "number"
        }
    ],
    [
        "aria-valuemin",
        {
            "type": "number"
        }
    ],
    [
        "aria-valuenow",
        {
            "type": "number"
        }
    ],
    [
        "aria-valuetext",
        {
            "type": "string"
        }
    ]
];
var ariaPropsMap = {
    entries: function entries() {
        return properties;
    },
    forEach: function forEach(fn) {
        var thisArg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        var _iterator = _createForOfIteratorHelper(properties), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var _step$value = _slicedToArray(_step.value, 2), key = _step$value[0], values = _step$value[1];
                fn.call(thisArg, values, key, properties);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
    },
    get: function get(key) {
        var item = properties.find(function(tuple) {
            return tuple[0] === key ? true : false;
        });
        return item && item[1];
    },
    has: function has(key) {
        return !!ariaPropsMap.get(key);
    },
    keys: function keys() {
        return properties.map(function(_ref) {
            var _ref2 = _slicedToArray(_ref, 1), key = _ref2[0];
            return key;
        });
    },
    values: function values() {
        return properties.map(function(_ref3) {
            var _ref4 = _slicedToArray(_ref3, 2), values = _ref4[1];
            return values;
        });
    }
};
var _default = (0, _iterationDecorator.default)(ariaPropsMap, ariaPropsMap.entries());
exports.default = _default;

},{"331af7edb1dbe93a":"doGnk"}],"doGnk":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = iterationDecorator;
var _iteratorProxy = _interopRequireDefault(require("c7bfd8dc07e38057"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _typeof(obj) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
}
function iterationDecorator(collection, entries) {
    if (typeof Symbol === "function" && _typeof(Symbol.iterator) === "symbol") Object.defineProperty(collection, Symbol.iterator, {
        value: _iteratorProxy.default.bind(entries)
    });
    return collection;
}

},{"c7bfd8dc07e38057":"8S6mq"}],"8S6mq":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
// eslint-disable-next-line no-unused-vars
function iteratorProxy() {
    var values = this;
    var index = 0;
    var iter = {
        "@@iterator": function iterator() {
            return iter;
        },
        next: function next() {
            if (index < values.length) {
                var value = values[index];
                index = index + 1;
                return {
                    done: false,
                    value: value
                };
            } else return {
                done: true
            };
        }
    };
    return iter;
}
var _default = iteratorProxy;
exports.default = _default;

},{}],"SVFeo":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _iterationDecorator = _interopRequireDefault(require("e60812fdb4c36259"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (!it) {
        if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e2) {
                    throw _e2;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = it.call(o);
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e3) {
            didErr = true;
            err = _e3;
        },
        f: function f() {
            try {
                if (!normalCompletion && it.return != null) it.return();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var dom = [
    [
        "a",
        {
            reserved: false
        }
    ],
    [
        "abbr",
        {
            reserved: false
        }
    ],
    [
        "acronym",
        {
            reserved: false
        }
    ],
    [
        "address",
        {
            reserved: false
        }
    ],
    [
        "applet",
        {
            reserved: false
        }
    ],
    [
        "area",
        {
            reserved: false
        }
    ],
    [
        "article",
        {
            reserved: false
        }
    ],
    [
        "aside",
        {
            reserved: false
        }
    ],
    [
        "audio",
        {
            reserved: false
        }
    ],
    [
        "b",
        {
            reserved: false
        }
    ],
    [
        "base",
        {
            reserved: true
        }
    ],
    [
        "bdi",
        {
            reserved: false
        }
    ],
    [
        "bdo",
        {
            reserved: false
        }
    ],
    [
        "big",
        {
            reserved: false
        }
    ],
    [
        "blink",
        {
            reserved: false
        }
    ],
    [
        "blockquote",
        {
            reserved: false
        }
    ],
    [
        "body",
        {
            reserved: false
        }
    ],
    [
        "br",
        {
            reserved: false
        }
    ],
    [
        "button",
        {
            reserved: false
        }
    ],
    [
        "canvas",
        {
            reserved: false
        }
    ],
    [
        "caption",
        {
            reserved: false
        }
    ],
    [
        "center",
        {
            reserved: false
        }
    ],
    [
        "cite",
        {
            reserved: false
        }
    ],
    [
        "code",
        {
            reserved: false
        }
    ],
    [
        "col",
        {
            reserved: true
        }
    ],
    [
        "colgroup",
        {
            reserved: true
        }
    ],
    [
        "content",
        {
            reserved: false
        }
    ],
    [
        "data",
        {
            reserved: false
        }
    ],
    [
        "datalist",
        {
            reserved: false
        }
    ],
    [
        "dd",
        {
            reserved: false
        }
    ],
    [
        "del",
        {
            reserved: false
        }
    ],
    [
        "details",
        {
            reserved: false
        }
    ],
    [
        "dfn",
        {
            reserved: false
        }
    ],
    [
        "dialog",
        {
            reserved: false
        }
    ],
    [
        "dir",
        {
            reserved: false
        }
    ],
    [
        "div",
        {
            reserved: false
        }
    ],
    [
        "dl",
        {
            reserved: false
        }
    ],
    [
        "dt",
        {
            reserved: false
        }
    ],
    [
        "em",
        {
            reserved: false
        }
    ],
    [
        "embed",
        {
            reserved: false
        }
    ],
    [
        "fieldset",
        {
            reserved: false
        }
    ],
    [
        "figcaption",
        {
            reserved: false
        }
    ],
    [
        "figure",
        {
            reserved: false
        }
    ],
    [
        "font",
        {
            reserved: false
        }
    ],
    [
        "footer",
        {
            reserved: false
        }
    ],
    [
        "form",
        {
            reserved: false
        }
    ],
    [
        "frame",
        {
            reserved: false
        }
    ],
    [
        "frameset",
        {
            reserved: false
        }
    ],
    [
        "h1",
        {
            reserved: false
        }
    ],
    [
        "h2",
        {
            reserved: false
        }
    ],
    [
        "h3",
        {
            reserved: false
        }
    ],
    [
        "h4",
        {
            reserved: false
        }
    ],
    [
        "h5",
        {
            reserved: false
        }
    ],
    [
        "h6",
        {
            reserved: false
        }
    ],
    [
        "head",
        {
            reserved: true
        }
    ],
    [
        "header",
        {
            reserved: false
        }
    ],
    [
        "hgroup",
        {
            reserved: false
        }
    ],
    [
        "hr",
        {
            reserved: false
        }
    ],
    [
        "html",
        {
            reserved: true
        }
    ],
    [
        "i",
        {
            reserved: false
        }
    ],
    [
        "iframe",
        {
            reserved: false
        }
    ],
    [
        "img",
        {
            reserved: false
        }
    ],
    [
        "input",
        {
            reserved: false
        }
    ],
    [
        "ins",
        {
            reserved: false
        }
    ],
    [
        "kbd",
        {
            reserved: false
        }
    ],
    [
        "keygen",
        {
            reserved: false
        }
    ],
    [
        "label",
        {
            reserved: false
        }
    ],
    [
        "legend",
        {
            reserved: false
        }
    ],
    [
        "li",
        {
            reserved: false
        }
    ],
    [
        "link",
        {
            reserved: true
        }
    ],
    [
        "main",
        {
            reserved: false
        }
    ],
    [
        "map",
        {
            reserved: false
        }
    ],
    [
        "mark",
        {
            reserved: false
        }
    ],
    [
        "marquee",
        {
            reserved: false
        }
    ],
    [
        "menu",
        {
            reserved: false
        }
    ],
    [
        "menuitem",
        {
            reserved: false
        }
    ],
    [
        "meta",
        {
            reserved: true
        }
    ],
    [
        "meter",
        {
            reserved: false
        }
    ],
    [
        "nav",
        {
            reserved: false
        }
    ],
    [
        "noembed",
        {
            reserved: true
        }
    ],
    [
        "noscript",
        {
            reserved: true
        }
    ],
    [
        "object",
        {
            reserved: false
        }
    ],
    [
        "ol",
        {
            reserved: false
        }
    ],
    [
        "optgroup",
        {
            reserved: false
        }
    ],
    [
        "option",
        {
            reserved: false
        }
    ],
    [
        "output",
        {
            reserved: false
        }
    ],
    [
        "p",
        {
            reserved: false
        }
    ],
    [
        "param",
        {
            reserved: true
        }
    ],
    [
        "picture",
        {
            reserved: true
        }
    ],
    [
        "pre",
        {
            reserved: false
        }
    ],
    [
        "progress",
        {
            reserved: false
        }
    ],
    [
        "q",
        {
            reserved: false
        }
    ],
    [
        "rp",
        {
            reserved: false
        }
    ],
    [
        "rt",
        {
            reserved: false
        }
    ],
    [
        "rtc",
        {
            reserved: false
        }
    ],
    [
        "ruby",
        {
            reserved: false
        }
    ],
    [
        "s",
        {
            reserved: false
        }
    ],
    [
        "samp",
        {
            reserved: false
        }
    ],
    [
        "script",
        {
            reserved: true
        }
    ],
    [
        "section",
        {
            reserved: false
        }
    ],
    [
        "select",
        {
            reserved: false
        }
    ],
    [
        "small",
        {
            reserved: false
        }
    ],
    [
        "source",
        {
            reserved: true
        }
    ],
    [
        "spacer",
        {
            reserved: false
        }
    ],
    [
        "span",
        {
            reserved: false
        }
    ],
    [
        "strike",
        {
            reserved: false
        }
    ],
    [
        "strong",
        {
            reserved: false
        }
    ],
    [
        "style",
        {
            reserved: true
        }
    ],
    [
        "sub",
        {
            reserved: false
        }
    ],
    [
        "summary",
        {
            reserved: false
        }
    ],
    [
        "sup",
        {
            reserved: false
        }
    ],
    [
        "table",
        {
            reserved: false
        }
    ],
    [
        "tbody",
        {
            reserved: false
        }
    ],
    [
        "td",
        {
            reserved: false
        }
    ],
    [
        "textarea",
        {
            reserved: false
        }
    ],
    [
        "tfoot",
        {
            reserved: false
        }
    ],
    [
        "th",
        {
            reserved: false
        }
    ],
    [
        "thead",
        {
            reserved: false
        }
    ],
    [
        "time",
        {
            reserved: false
        }
    ],
    [
        "title",
        {
            reserved: true
        }
    ],
    [
        "tr",
        {
            reserved: false
        }
    ],
    [
        "track",
        {
            reserved: true
        }
    ],
    [
        "tt",
        {
            reserved: false
        }
    ],
    [
        "u",
        {
            reserved: false
        }
    ],
    [
        "ul",
        {
            reserved: false
        }
    ],
    [
        "var",
        {
            reserved: false
        }
    ],
    [
        "video",
        {
            reserved: false
        }
    ],
    [
        "wbr",
        {
            reserved: false
        }
    ],
    [
        "xmp",
        {
            reserved: false
        }
    ]
];
var domMap = {
    entries: function entries() {
        return dom;
    },
    forEach: function forEach(fn) {
        var thisArg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        var _iterator = _createForOfIteratorHelper(dom), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var _step$value = _slicedToArray(_step.value, 2), key = _step$value[0], values = _step$value[1];
                fn.call(thisArg, values, key, dom);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
    },
    get: function get(key) {
        var item = dom.find(function(tuple) {
            return tuple[0] === key ? true : false;
        });
        return item && item[1];
    },
    has: function has(key) {
        return !!domMap.get(key);
    },
    keys: function keys() {
        return dom.map(function(_ref) {
            var _ref2 = _slicedToArray(_ref, 1), key = _ref2[0];
            return key;
        });
    },
    values: function values() {
        return dom.map(function(_ref3) {
            var _ref4 = _slicedToArray(_ref3, 2), values = _ref4[1];
            return values;
        });
    }
};
var _default = (0, _iterationDecorator.default)(domMap, domMap.entries());
exports.default = _default;

},{"e60812fdb4c36259":"doGnk"}],"4vhJn":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _ariaAbstractRoles = _interopRequireDefault(require("a7e4b3d5d909d292"));
var _ariaLiteralRoles = _interopRequireDefault(require("2d4b6cc4140eb0e3"));
var _ariaDpubRoles = _interopRequireDefault(require("28c055f39564915d"));
var _ariaGraphicsRoles = _interopRequireDefault(require("78372d6c14825aba"));
var _iterationDecorator = _interopRequireDefault(require("5346a32fefaccbaf"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (!it) {
        if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e2) {
                    throw _e2;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = it.call(o);
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e3) {
            didErr = true;
            err = _e3;
        },
        f: function f() {
            try {
                if (!normalCompletion && it.return != null) it.return();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var roles = [].concat(_ariaAbstractRoles.default, _ariaLiteralRoles.default, _ariaDpubRoles.default, _ariaGraphicsRoles.default);
roles.forEach(function(_ref) {
    var _ref2 = _slicedToArray(_ref, 2), roleDefinition = _ref2[1];
    // Conglomerate the properties
    var _iterator = _createForOfIteratorHelper(roleDefinition.superClass), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var superClassIter = _step.value;
            var _iterator2 = _createForOfIteratorHelper(superClassIter), _step2;
            try {
                var _loop = function _loop() {
                    var superClassName = _step2.value;
                    var superClassRoleTuple = roles.find(function(_ref3) {
                        var _ref4 = _slicedToArray(_ref3, 1), name = _ref4[0];
                        return name === superClassName;
                    });
                    if (superClassRoleTuple) {
                        var superClassDefinition = superClassRoleTuple[1];
                        for(var _i2 = 0, _Object$keys = Object.keys(superClassDefinition.props); _i2 < _Object$keys.length; _i2++){
                            var prop = _Object$keys[_i2];
                            if (// $FlowIssue Accessing the hasOwnProperty on the Object prototype is fine.
                            !Object.prototype.hasOwnProperty.call(roleDefinition.props, prop)) Object.assign(roleDefinition.props, _defineProperty({}, prop, superClassDefinition.props[prop]));
                        }
                    }
                };
                for(_iterator2.s(); !(_step2 = _iterator2.n()).done;)_loop();
            } catch (err) {
                _iterator2.e(err);
            } finally{
                _iterator2.f();
            }
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
});
var rolesMap = {
    entries: function entries() {
        return roles;
    },
    forEach: function forEach(fn) {
        var thisArg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        var _iterator3 = _createForOfIteratorHelper(roles), _step3;
        try {
            for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                var _step3$value = _slicedToArray(_step3.value, 2), key = _step3$value[0], values = _step3$value[1];
                fn.call(thisArg, values, key, roles);
            }
        } catch (err) {
            _iterator3.e(err);
        } finally{
            _iterator3.f();
        }
    },
    get: function get(key) {
        var item = roles.find(function(tuple) {
            return tuple[0] === key ? true : false;
        });
        return item && item[1];
    },
    has: function has(key) {
        return !!rolesMap.get(key);
    },
    keys: function keys() {
        return roles.map(function(_ref5) {
            var _ref6 = _slicedToArray(_ref5, 1), key = _ref6[0];
            return key;
        });
    },
    values: function values() {
        return roles.map(function(_ref7) {
            var _ref8 = _slicedToArray(_ref7, 2), values = _ref8[1];
            return values;
        });
    }
};
var _default = (0, _iterationDecorator.default)(rolesMap, rolesMap.entries());
exports.default = _default;

},{"a7e4b3d5d909d292":"cEuLa","2d4b6cc4140eb0e3":"6Kg2v","28c055f39564915d":"MrFbL","78372d6c14825aba":"b5uJJ","5346a32fefaccbaf":"doGnk"}],"cEuLa":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _commandRole = _interopRequireDefault(require("3414071ea4617acf"));
var _compositeRole = _interopRequireDefault(require("1df9d43d7ec8b919"));
var _inputRole = _interopRequireDefault(require("26125df474aece43"));
var _landmarkRole = _interopRequireDefault(require("b9813c3e64b0c4d1"));
var _rangeRole = _interopRequireDefault(require("458b04e31090ed4f"));
var _roletypeRole = _interopRequireDefault(require("4e2802ba51cb8063"));
var _sectionRole = _interopRequireDefault(require("9d8167b79b826bfa"));
var _sectionheadRole = _interopRequireDefault(require("935256e9a52b4d48"));
var _selectRole = _interopRequireDefault(require("78d5b2720362fad2"));
var _structureRole = _interopRequireDefault(require("f773014c2d4fabc0"));
var _widgetRole = _interopRequireDefault(require("31b5d37538dbeb4c"));
var _windowRole = _interopRequireDefault(require("e38291d505f07701"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var ariaAbstractRoles = [
    [
        "command",
        _commandRole.default
    ],
    [
        "composite",
        _compositeRole.default
    ],
    [
        "input",
        _inputRole.default
    ],
    [
        "landmark",
        _landmarkRole.default
    ],
    [
        "range",
        _rangeRole.default
    ],
    [
        "roletype",
        _roletypeRole.default
    ],
    [
        "section",
        _sectionRole.default
    ],
    [
        "sectionhead",
        _sectionheadRole.default
    ],
    [
        "select",
        _selectRole.default
    ],
    [
        "structure",
        _structureRole.default
    ],
    [
        "widget",
        _widgetRole.default
    ],
    [
        "window",
        _windowRole.default
    ]
];
var _default = ariaAbstractRoles;
exports.default = _default;

},{"3414071ea4617acf":"d55PA","1df9d43d7ec8b919":"keETv","26125df474aece43":"kGane","b9813c3e64b0c4d1":"hjAvC","458b04e31090ed4f":"1QuyZ","4e2802ba51cb8063":"i2966","9d8167b79b826bfa":"dKsa3","935256e9a52b4d48":"bHiGH","78d5b2720362fad2":"kioMx","f773014c2d4fabc0":"b8qtN","31b5d37538dbeb4c":"5jmo1","e38291d505f07701":"8ZM6x"}],"d55PA":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var commandRole = {
    abstract: true,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        "author"
    ],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [
        {
            concept: {
                name: "menuitem"
            },
            module: "HTML"
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            "roletype",
            "widget"
        ]
    ]
};
var _default = commandRole;
exports.default = _default;

},{}],"keETv":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var compositeRole = {
    abstract: true,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        "author"
    ],
    prohibitedProps: [],
    props: {
        "aria-activedescendant": null,
        "aria-disabled": null
    },
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            "roletype",
            "widget"
        ]
    ]
};
var _default = compositeRole;
exports.default = _default;

},{}],"kGane":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var inputRole = {
    abstract: true,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        "author"
    ],
    prohibitedProps: [],
    props: {
        "aria-disabled": null
    },
    relatedConcepts: [
        {
            concept: {
                name: "input"
            },
            module: "XForms"
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            "roletype",
            "widget"
        ]
    ]
};
var _default = inputRole;
exports.default = _default;

},{}],"hjAvC":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var landmarkRole = {
    abstract: true,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        "author"
    ],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            "roletype",
            "structure",
            "section"
        ]
    ]
};
var _default = landmarkRole;
exports.default = _default;

},{}],"1QuyZ":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var rangeRole = {
    abstract: true,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        "author"
    ],
    prohibitedProps: [],
    props: {
        "aria-valuemax": null,
        "aria-valuemin": null,
        "aria-valuenow": null
    },
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            "roletype",
            "structure"
        ]
    ]
};
var _default = rangeRole;
exports.default = _default;

},{}],"i2966":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var roletypeRole = {
    abstract: true,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [],
    prohibitedProps: [],
    props: {
        "aria-atomic": null,
        "aria-busy": null,
        "aria-controls": null,
        "aria-current": null,
        "aria-describedby": null,
        "aria-details": null,
        "aria-dropeffect": null,
        "aria-flowto": null,
        "aria-grabbed": null,
        "aria-hidden": null,
        "aria-keyshortcuts": null,
        "aria-label": null,
        "aria-labelledby": null,
        "aria-live": null,
        "aria-owns": null,
        "aria-relevant": null,
        "aria-roledescription": null
    },
    relatedConcepts: [
        {
            concept: {
                name: "rel"
            },
            module: "HTML"
        },
        {
            concept: {
                name: "role"
            },
            module: "XHTML"
        },
        {
            concept: {
                name: "type"
            },
            module: "Dublin Core"
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: []
};
var _default = roletypeRole;
exports.default = _default;

},{}],"dKsa3":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var sectionRole = {
    abstract: true,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [
        {
            concept: {
                name: "frontmatter"
            },
            module: "DTB"
        },
        {
            concept: {
                name: "level"
            },
            module: "DTB"
        },
        {
            concept: {
                name: "level"
            },
            module: "SMIL"
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            "roletype",
            "structure"
        ]
    ]
};
var _default = sectionRole;
exports.default = _default;

},{}],"bHiGH":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var sectionheadRole = {
    abstract: true,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        "author",
        "contents"
    ],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            "roletype",
            "structure"
        ]
    ]
};
var _default = sectionheadRole;
exports.default = _default;

},{}],"kioMx":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var selectRole = {
    abstract: true,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        "author"
    ],
    prohibitedProps: [],
    props: {
        "aria-orientation": null
    },
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            "roletype",
            "widget",
            "composite"
        ],
        [
            "roletype",
            "structure",
            "section",
            "group"
        ]
    ]
};
var _default = selectRole;
exports.default = _default;

},{}],"b8qtN":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var structureRole = {
    abstract: true,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            "roletype"
        ]
    ]
};
var _default = structureRole;
exports.default = _default;

},{}],"5jmo1":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var widgetRole = {
    abstract: true,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            "roletype"
        ]
    ]
};
var _default = widgetRole;
exports.default = _default;

},{}],"8ZM6x":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var windowRole = {
    abstract: true,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        "author"
    ],
    prohibitedProps: [],
    props: {
        "aria-modal": null
    },
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            "roletype"
        ]
    ]
};
var _default = windowRole;
exports.default = _default;

},{}],"6Kg2v":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _alertRole = _interopRequireDefault(require("ca4f79a6da511d74"));
var _alertdialogRole = _interopRequireDefault(require("88756a4aef1a53fb"));
var _applicationRole = _interopRequireDefault(require("8dfd3f9dbac29404"));
var _articleRole = _interopRequireDefault(require("c9d743ca720d9995"));
var _bannerRole = _interopRequireDefault(require("859bc75d7b6061a5"));
var _blockquoteRole = _interopRequireDefault(require("2f377392a6dbdcd3"));
var _buttonRole = _interopRequireDefault(require("5904ea1d104e701d"));
var _captionRole = _interopRequireDefault(require("af0386be738965d6"));
var _cellRole = _interopRequireDefault(require("d38227432666308"));
var _checkboxRole = _interopRequireDefault(require("5b546b45bd551e37"));
var _codeRole = _interopRequireDefault(require("db6f2bd1644b78b1"));
var _columnheaderRole = _interopRequireDefault(require("ede765aac0f8eef4"));
var _comboboxRole = _interopRequireDefault(require("b48549cab85a21cd"));
var _complementaryRole = _interopRequireDefault(require("bf74ac8164958064"));
var _contentinfoRole = _interopRequireDefault(require("d6f9e36e5f2406cf"));
var _definitionRole = _interopRequireDefault(require("7b46c36d49303327"));
var _deletionRole = _interopRequireDefault(require("1e18a54708dea656"));
var _dialogRole = _interopRequireDefault(require("e54204cb97fd1580"));
var _directoryRole = _interopRequireDefault(require("95d1567a259fd686"));
var _documentRole = _interopRequireDefault(require("6f7425ebb943a59b"));
var _emphasisRole = _interopRequireDefault(require("c22119240be4bae4"));
var _feedRole = _interopRequireDefault(require("506fbeb8740e16a9"));
var _figureRole = _interopRequireDefault(require("7daa32b381d1f249"));
var _formRole = _interopRequireDefault(require("925d572ddba5bff1"));
var _genericRole = _interopRequireDefault(require("32f3c0fa7c8be0f4"));
var _gridRole = _interopRequireDefault(require("ab6746119b6c6737"));
var _gridcellRole = _interopRequireDefault(require("3c0c29bd050bd2ad"));
var _groupRole = _interopRequireDefault(require("42dd751513c9a5e"));
var _headingRole = _interopRequireDefault(require("c92c6debbec3292e"));
var _imgRole = _interopRequireDefault(require("28f9d073ca7016d"));
var _insertionRole = _interopRequireDefault(require("ae18b0157fc7b51c"));
var _linkRole = _interopRequireDefault(require("44164ba2ceda4369"));
var _listRole = _interopRequireDefault(require("3d24b2910fd69b4"));
var _listboxRole = _interopRequireDefault(require("32ad902d952edbb3"));
var _listitemRole = _interopRequireDefault(require("4e32dde39355fcc0"));
var _logRole = _interopRequireDefault(require("b94c231c224d1d02"));
var _mainRole = _interopRequireDefault(require("e90d1af4ae1f3b9d"));
var _marqueeRole = _interopRequireDefault(require("ad916f6819da2507"));
var _mathRole = _interopRequireDefault(require("e98c1b3622b1edcb"));
var _menuRole = _interopRequireDefault(require("242e89e9fd3ac7ef"));
var _menubarRole = _interopRequireDefault(require("d262f683e8a7ce0d"));
var _menuitemRole = _interopRequireDefault(require("375fb1da63ddef10"));
var _menuitemcheckboxRole = _interopRequireDefault(require("de6d2f9094d46a7a"));
var _menuitemradioRole = _interopRequireDefault(require("1aeb5efe06bbf248"));
var _meterRole = _interopRequireDefault(require("4cc67ded0c74b254"));
var _navigationRole = _interopRequireDefault(require("c5709ca763485c51"));
var _noneRole = _interopRequireDefault(require("f877ed36bb9a5c43"));
var _noteRole = _interopRequireDefault(require("d80ef4e30e8366f"));
var _optionRole = _interopRequireDefault(require("90fa346e6bcc829"));
var _paragraphRole = _interopRequireDefault(require("c529d6c872621cde"));
var _presentationRole = _interopRequireDefault(require("c68e08197f387527"));
var _progressbarRole = _interopRequireDefault(require("67cbc5331f564eb3"));
var _radioRole = _interopRequireDefault(require("afb0e37e33305801"));
var _radiogroupRole = _interopRequireDefault(require("1e988aab4c6859e5"));
var _regionRole = _interopRequireDefault(require("4ff108b8b59feee"));
var _rowRole = _interopRequireDefault(require("d9f5f554bef16c27"));
var _rowgroupRole = _interopRequireDefault(require("d2f6c88543c61a52"));
var _rowheaderRole = _interopRequireDefault(require("7abcf58884f892d6"));
var _scrollbarRole = _interopRequireDefault(require("d981754770436284"));
var _searchRole = _interopRequireDefault(require("571b9c4850a18550"));
var _searchboxRole = _interopRequireDefault(require("dd8c1a1fbf72f0d9"));
var _separatorRole = _interopRequireDefault(require("ac3e5d493c298ac"));
var _sliderRole = _interopRequireDefault(require("8de18adfe835d3b0"));
var _spinbuttonRole = _interopRequireDefault(require("ff3e90acfb596527"));
var _statusRole = _interopRequireDefault(require("bb39a930257b743"));
var _strongRole = _interopRequireDefault(require("4a1ba6b2f2bb51b"));
var _subscriptRole = _interopRequireDefault(require("2b52124ff8def222"));
var _superscriptRole = _interopRequireDefault(require("139b6f1ef6b6de66"));
var _switchRole = _interopRequireDefault(require("9e4f9e84fd48fab7"));
var _tabRole = _interopRequireDefault(require("94cbdb92b8c803d3"));
var _tableRole = _interopRequireDefault(require("5c98b9343ac52258"));
var _tablistRole = _interopRequireDefault(require("ae7171786fedb320"));
var _tabpanelRole = _interopRequireDefault(require("fd80bc459df12d86"));
var _termRole = _interopRequireDefault(require("e8aa48fec46146d1"));
var _textboxRole = _interopRequireDefault(require("636c3044b167df5"));
var _timeRole = _interopRequireDefault(require("464f92cdc7959453"));
var _timerRole = _interopRequireDefault(require("e7cc3ce215e58a49"));
var _toolbarRole = _interopRequireDefault(require("f8f28a8c79259637"));
var _tooltipRole = _interopRequireDefault(require("7bb61743a58f0ed4"));
var _treeRole = _interopRequireDefault(require("c63b7baa6d4cd69"));
var _treegridRole = _interopRequireDefault(require("eb702a9fae743c05"));
var _treeitemRole = _interopRequireDefault(require("afe45fa9d63ddf8e"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var ariaLiteralRoles = [
    [
        "alert",
        _alertRole.default
    ],
    [
        "alertdialog",
        _alertdialogRole.default
    ],
    [
        "application",
        _applicationRole.default
    ],
    [
        "article",
        _articleRole.default
    ],
    [
        "banner",
        _bannerRole.default
    ],
    [
        "blockquote",
        _blockquoteRole.default
    ],
    [
        "button",
        _buttonRole.default
    ],
    [
        "caption",
        _captionRole.default
    ],
    [
        "cell",
        _cellRole.default
    ],
    [
        "checkbox",
        _checkboxRole.default
    ],
    [
        "code",
        _codeRole.default
    ],
    [
        "columnheader",
        _columnheaderRole.default
    ],
    [
        "combobox",
        _comboboxRole.default
    ],
    [
        "complementary",
        _complementaryRole.default
    ],
    [
        "contentinfo",
        _contentinfoRole.default
    ],
    [
        "definition",
        _definitionRole.default
    ],
    [
        "deletion",
        _deletionRole.default
    ],
    [
        "dialog",
        _dialogRole.default
    ],
    [
        "directory",
        _directoryRole.default
    ],
    [
        "document",
        _documentRole.default
    ],
    [
        "emphasis",
        _emphasisRole.default
    ],
    [
        "feed",
        _feedRole.default
    ],
    [
        "figure",
        _figureRole.default
    ],
    [
        "form",
        _formRole.default
    ],
    [
        "generic",
        _genericRole.default
    ],
    [
        "grid",
        _gridRole.default
    ],
    [
        "gridcell",
        _gridcellRole.default
    ],
    [
        "group",
        _groupRole.default
    ],
    [
        "heading",
        _headingRole.default
    ],
    [
        "img",
        _imgRole.default
    ],
    [
        "insertion",
        _insertionRole.default
    ],
    [
        "link",
        _linkRole.default
    ],
    [
        "list",
        _listRole.default
    ],
    [
        "listbox",
        _listboxRole.default
    ],
    [
        "listitem",
        _listitemRole.default
    ],
    [
        "log",
        _logRole.default
    ],
    [
        "main",
        _mainRole.default
    ],
    [
        "marquee",
        _marqueeRole.default
    ],
    [
        "math",
        _mathRole.default
    ],
    [
        "menu",
        _menuRole.default
    ],
    [
        "menubar",
        _menubarRole.default
    ],
    [
        "menuitem",
        _menuitemRole.default
    ],
    [
        "menuitemcheckbox",
        _menuitemcheckboxRole.default
    ],
    [
        "menuitemradio",
        _menuitemradioRole.default
    ],
    [
        "meter",
        _meterRole.default
    ],
    [
        "navigation",
        _navigationRole.default
    ],
    [
        "none",
        _noneRole.default
    ],
    [
        "note",
        _noteRole.default
    ],
    [
        "option",
        _optionRole.default
    ],
    [
        "paragraph",
        _paragraphRole.default
    ],
    [
        "presentation",
        _presentationRole.default
    ],
    [
        "progressbar",
        _progressbarRole.default
    ],
    [
        "radio",
        _radioRole.default
    ],
    [
        "radiogroup",
        _radiogroupRole.default
    ],
    [
        "region",
        _regionRole.default
    ],
    [
        "row",
        _rowRole.default
    ],
    [
        "rowgroup",
        _rowgroupRole.default
    ],
    [
        "rowheader",
        _rowheaderRole.default
    ],
    [
        "scrollbar",
        _scrollbarRole.default
    ],
    [
        "search",
        _searchRole.default
    ],
    [
        "searchbox",
        _searchboxRole.default
    ],
    [
        "separator",
        _separatorRole.default
    ],
    [
        "slider",
        _sliderRole.default
    ],
    [
        "spinbutton",
        _spinbuttonRole.default
    ],
    [
        "status",
        _statusRole.default
    ],
    [
        "strong",
        _strongRole.default
    ],
    [
        "subscript",
        _subscriptRole.default
    ],
    [
        "superscript",
        _superscriptRole.default
    ],
    [
        "switch",
        _switchRole.default
    ],
    [
        "tab",
        _tabRole.default
    ],
    [
        "table",
        _tableRole.default
    ],
    [
        "tablist",
        _tablistRole.default
    ],
    [
        "tabpanel",
        _tabpanelRole.default
    ],
    [
        "term",
        _termRole.default
    ],
    [
        "textbox",
        _textboxRole.default
    ],
    [
        "time",
        _timeRole.default
    ],
    [
        "timer",
        _timerRole.default
    ],
    [
        "toolbar",
        _toolbarRole.default
    ],
    [
        "tooltip",
        _tooltipRole.default
    ],
    [
        "tree",
        _treeRole.default
    ],
    [
        "treegrid",
        _treegridRole.default
    ],
    [
        "treeitem",
        _treeitemRole.default
    ]
];
var _default = ariaLiteralRoles;
exports.default = _default;

},{"ca4f79a6da511d74":"kKg9Q","88756a4aef1a53fb":"3Z7UN","8dfd3f9dbac29404":"lASC5","c9d743ca720d9995":"lAiWh","859bc75d7b6061a5":"7ShCK","2f377392a6dbdcd3":"aPAJH","5904ea1d104e701d":"eON7M","af0386be738965d6":"gxsdg","d38227432666308":"ie6Oo","5b546b45bd551e37":"6UZpT","db6f2bd1644b78b1":"9s8z5","ede765aac0f8eef4":"8pJ1k","b48549cab85a21cd":"13M9t","bf74ac8164958064":"pFJBt","d6f9e36e5f2406cf":"eRgap","7b46c36d49303327":"4juBL","1e18a54708dea656":"aQPD1","e54204cb97fd1580":"7qfLi","95d1567a259fd686":"7YZUJ","6f7425ebb943a59b":"3XSO6","c22119240be4bae4":"ljGI0","506fbeb8740e16a9":"1H6OA","7daa32b381d1f249":"7LI5C","925d572ddba5bff1":"3XaJ3","32f3c0fa7c8be0f4":"emBat","ab6746119b6c6737":"7dzJr","3c0c29bd050bd2ad":"ah541","42dd751513c9a5e":"hKIbg","c92c6debbec3292e":"aAzA8","28f9d073ca7016d":"8Idl1","ae18b0157fc7b51c":"5FOdn","44164ba2ceda4369":"6Z7vK","3d24b2910fd69b4":"1aiX3","32ad902d952edbb3":"1S99m","4e32dde39355fcc0":"gt5bM","b94c231c224d1d02":"44hCl","e90d1af4ae1f3b9d":"e3QeZ","ad916f6819da2507":"IediM","e98c1b3622b1edcb":"5xhB0","242e89e9fd3ac7ef":"6HNL0","d262f683e8a7ce0d":"eVQdI","375fb1da63ddef10":"9nG5t","de6d2f9094d46a7a":"1gIqn","1aeb5efe06bbf248":"cAWw9","4cc67ded0c74b254":"fRIkD","c5709ca763485c51":"ln3G3","f877ed36bb9a5c43":"5GE2Y","d80ef4e30e8366f":"19ums","90fa346e6bcc829":"2TRsH","c529d6c872621cde":"i5qWm","c68e08197f387527":"dcQpN","67cbc5331f564eb3":"gbowZ","afb0e37e33305801":"4QEEs","1e988aab4c6859e5":"kFbJ5","4ff108b8b59feee":"4AZOY","d9f5f554bef16c27":"g5yN8","d2f6c88543c61a52":"hHQSp","7abcf58884f892d6":"bCnlU","d981754770436284":"dr05U","571b9c4850a18550":"5gkcs","dd8c1a1fbf72f0d9":"kEYv6","ac3e5d493c298ac":"66Lbn","8de18adfe835d3b0":"3o8a7","ff3e90acfb596527":"aSaMM","bb39a930257b743":"5dzMT","4a1ba6b2f2bb51b":"1kyWY","2b52124ff8def222":"6qPSY","139b6f1ef6b6de66":"3IiDp","9e4f9e84fd48fab7":"fKzKu","94cbdb92b8c803d3":"8QllK","5c98b9343ac52258":"76Ar9","ae7171786fedb320":"eUwW2","fd80bc459df12d86":"iGJdp","e8aa48fec46146d1":"4AXci","636c3044b167df5":"b7CIX","464f92cdc7959453":"5Ni8U","e7cc3ce215e58a49":"6scrO","f8f28a8c79259637":"f3vxe","7bb61743a58f0ed4":"eDre0","c63b7baa6d4cd69":"74TlZ","eb702a9fae743c05":"aa6wx","afe45fa9d63ddf8e":"ixE38"}],"kKg9Q":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var alertRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        "author"
    ],
    prohibitedProps: [],
    props: {
        "aria-atomic": "true",
        "aria-live": "assertive"
    },
    relatedConcepts: [
        {
            concept: {
                name: "alert"
            },
            module: "XForms"
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            "roletype",
            "structure",
            "section"
        ]
    ]
};
var _default = alertRole;
exports.default = _default;

},{}],"3Z7UN":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var alertdialogRole = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        "author"
    ],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [
        {
            concept: {
                name: "alert"
            },
            module: "XForms"
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            "roletype",
            "structure",
            "section",
            "alert"
        ],
        [
            "roletype",
            "window",
            "dialog"
        ]
    ]
};
var _default = alertdialogRole;
exports.default = _default;

},{}],"lASC5":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var applicationRole = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        "author"
    ],
    prohibitedProps: [],
    props: {
        "aria-activedescendant": null,
        "aria-disabled": null,
        "aria-errormessage": null,
        "aria-expanded": null,
        "aria-haspopup": null,
        "aria-invalid": null
    },
    relatedConcepts: [
        {
            concept: {
                name: "Device Independence Delivery Unit"
            }
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            "roletype",
            "structure"
        ]
    ]
};
var _default = applicationRole;
exports.default = _default;

},{}],"lAiWh":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var articleRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        "author"
    ],
    prohibitedProps: [],
    props: {
        "aria-posinset": null,
        "aria-setsize": null
    },
    relatedConcepts: [
        {
            concept: {
                name: "article"
            },
            module: "HTML"
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            "roletype",
            "structure",
            "document"
        ]
    ]
};
var _default = articleRole;
exports.default = _default;

},{}],"7ShCK":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var bannerRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        "author"
    ],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [
        {
            concept: {
                constraints: [
                    "direct descendant of document"
                ],
                name: "header"
            },
            module: "HTML"
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            "roletype",
            "structure",
            "section",
            "landmark"
        ]
    ]
};
var _default = bannerRole;
exports.default = _default;

},{}],"aPAJH":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var blockquoteRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        "author"
    ],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            "roletype",
            "structure",
            "section"
        ]
    ]
};
var _default = blockquoteRole;
exports.default = _default;

},{}],"eON7M":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var buttonRole = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: true,
    nameFrom: [
        "author",
        "contents"
    ],
    prohibitedProps: [],
    props: {
        "aria-disabled": null,
        "aria-expanded": null,
        "aria-haspopup": null,
        "aria-pressed": null
    },
    relatedConcepts: [
        {
            concept: {
                attributes: [
                    {
                        constraints: [
                            "set"
                        ],
                        name: "aria-pressed"
                    },
                    {
                        name: "type",
                        value: "checkbox"
                    }
                ],
                name: "input"
            },
            module: "HTML"
        },
        {
            concept: {
                attributes: [
                    {
                        name: "aria-expanded",
                        value: "false"
                    }
                ],
                name: "summary"
            },
            module: "HTML"
        },
        {
            concept: {
                attributes: [
                    {
                        name: "aria-expanded",
                        value: "true"
                    }
                ],
                constraints: [
                    "direct descendant of details element with the open attribute defined"
                ],
                name: "summary"
            },
            module: "HTML"
        },
        {
            concept: {
                attributes: [
                    {
                        name: "type",
                        value: "button"
                    }
                ],
                name: "input"
            },
            module: "HTML"
        },
        {
            concept: {
                attributes: [
                    {
                        name: "type",
                        value: "image"
                    }
                ],
                name: "input"
            },
            module: "HTML"
        },
        {
            concept: {
                attributes: [
                    {
                        name: "type",
                        value: "reset"
                    }
                ],
                name: "input"
            },
            module: "HTML"
        },
        {
            concept: {
                attributes: [
                    {
                        name: "type",
                        value: "submit"
                    }
                ],
                name: "input"
            },
            module: "HTML"
        },
        {
            concept: {
                name: "button"
            },
            module: "HTML"
        },
        {
            concept: {
                name: "trigger"
            },
            module: "XForms"
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            "roletype",
            "widget",
            "command"
        ]
    ]
};
var _default = buttonRole;
exports.default = _default;

},{}],"gxsdg":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var captionRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        "prohibited"
    ],
    prohibitedProps: [
        "aria-label",
        "aria-labelledby"
    ],
    props: {},
    relatedConcepts: [],
    requireContextRole: [
        "figure",
        "grid",
        "table"
    ],
    requiredContextRole: [
        "figure",
        "grid",
        "table"
    ],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            "roletype",
            "structure",
            "section"
        ]
    ]
};
var _default = captionRole;
exports.default = _default;

},{}],"ie6Oo":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var cellRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        "author",
        "contents"
    ],
    prohibitedProps: [],
    props: {
        "aria-colindex": null,
        "aria-colspan": null,
        "aria-rowindex": null,
        "aria-rowspan": null
    },
    relatedConcepts: [
        {
            concept: {
                constraints: [
                    "descendant of table"
                ],
                name: "td"
            },
            module: "HTML"
        }
    ],
    requireContextRole: [
        "row"
    ],
    requiredContextRole: [
        "row"
    ],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            "roletype",
            "structure",
            "section"
        ]
    ]
};
var _default = cellRole;
exports.default = _default;

},{}],"6UZpT":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var checkboxRole = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: true,
    nameFrom: [
        "author",
        "contents"
    ],
    prohibitedProps: [],
    props: {
        "aria-checked": null,
        "aria-errormessage": null,
        "aria-expanded": null,
        "aria-invalid": null,
        "aria-readonly": null,
        "aria-required": null
    },
    relatedConcepts: [
        {
            concept: {
                attributes: [
                    {
                        name: "type",
                        value: "checkbox"
                    }
                ],
                name: "input"
            },
            module: "HTML"
        },
        {
            concept: {
                name: "option"
            },
            module: "ARIA"
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {
        "aria-checked": null
    },
    superClass: [
        [
            "roletype",
            "widget",
            "input"
        ]
    ]
};
var _default = checkboxRole;
exports.default = _default;

},{}],"9s8z5":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var codeRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        "prohibited"
    ],
    prohibitedProps: [
        "aria-label",
        "aria-labelledby"
    ],
    props: {},
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            "roletype",
            "structure",
            "section"
        ]
    ]
};
var _default = codeRole;
exports.default = _default;

},{}],"8pJ1k":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var columnheaderRole = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        "author",
        "contents"
    ],
    prohibitedProps: [],
    props: {
        "aria-sort": null
    },
    relatedConcepts: [
        {
            attributes: [
                {
                    name: "scope",
                    value: "col"
                }
            ],
            concept: {
                name: "th"
            },
            module: "HTML"
        }
    ],
    requireContextRole: [
        "row"
    ],
    requiredContextRole: [
        "row"
    ],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            "roletype",
            "structure",
            "section",
            "cell"
        ],
        [
            "roletype",
            "structure",
            "section",
            "cell",
            "gridcell"
        ],
        [
            "roletype",
            "widget",
            "gridcell"
        ],
        [
            "roletype",
            "structure",
            "sectionhead"
        ]
    ]
};
var _default = columnheaderRole;
exports.default = _default;

},{}],"13M9t":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var comboboxRole = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        "author"
    ],
    prohibitedProps: [],
    props: {
        "aria-activedescendant": null,
        "aria-autocomplete": null,
        "aria-errormessage": null,
        "aria-invalid": null,
        "aria-readonly": null,
        "aria-required": null,
        "aria-expanded": "false",
        "aria-haspopup": "listbox"
    },
    relatedConcepts: [
        {
            concept: {
                attributes: [
                    {
                        constraints: [
                            "set"
                        ],
                        name: "list"
                    },
                    {
                        name: "type",
                        value: "email"
                    }
                ],
                name: "input"
            },
            module: "HTML"
        },
        {
            concept: {
                attributes: [
                    {
                        constraints: [
                            "set"
                        ],
                        name: "list"
                    },
                    {
                        name: "type",
                        value: "search"
                    }
                ],
                name: "input"
            },
            module: "HTML"
        },
        {
            concept: {
                attributes: [
                    {
                        constraints: [
                            "set"
                        ],
                        name: "list"
                    },
                    {
                        name: "type",
                        value: "tel"
                    }
                ],
                name: "input"
            },
            module: "HTML"
        },
        {
            concept: {
                attributes: [
                    {
                        constraints: [
                            "set"
                        ],
                        name: "list"
                    },
                    {
                        name: "type",
                        value: "text"
                    }
                ],
                name: "input"
            },
            module: "HTML"
        },
        {
            concept: {
                attributes: [
                    {
                        constraints: [
                            "set"
                        ],
                        name: "list"
                    },
                    {
                        name: "type",
                        value: "url"
                    }
                ],
                name: "input"
            },
            module: "HTML"
        },
        {
            concept: {
                attributes: [
                    {
                        constraints: [
                            "set"
                        ],
                        name: "list"
                    },
                    {
                        name: "type",
                        value: "url"
                    }
                ],
                name: "input"
            },
            module: "HTML"
        },
        {
            concept: {
                attributes: [
                    {
                        constraints: [
                            "undefined"
                        ],
                        name: "multiple"
                    },
                    {
                        constraints: [
                            "undefined"
                        ],
                        name: "size"
                    }
                ],
                name: "select"
            },
            module: "HTML"
        },
        {
            concept: {
                attributes: [
                    {
                        constraints: [
                            "undefined"
                        ],
                        name: "multiple"
                    },
                    {
                        name: "size",
                        value: 1
                    }
                ],
                name: "select"
            },
            module: "HTML"
        },
        {
            concept: {
                name: "select"
            },
            module: "XForms"
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {
        "aria-controls": null,
        "aria-expanded": "false"
    },
    superClass: [
        [
            "roletype",
            "widget",
            "input"
        ]
    ]
};
var _default = comboboxRole;
exports.default = _default;

},{}],"pFJBt":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var complementaryRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        "author"
    ],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [
        {
            concept: {
                name: "aside"
            },
            module: "HTML"
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            "roletype",
            "structure",
            "section",
            "landmark"
        ]
    ]
};
var _default = complementaryRole;
exports.default = _default;

},{}],"eRgap":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var contentinfoRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        "author"
    ],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [
        {
            concept: {
                constraints: [
                    "direct descendant of document"
                ],
                name: "footer"
            },
            module: "HTML"
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            "roletype",
            "structure",
            "section",
            "landmark"
        ]
    ]
};
var _default = contentinfoRole;
exports.default = _default;

},{}],"4juBL":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var definitionRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        "author"
    ],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [
        {
            concept: {
                name: "dd"
            },
            module: "HTML"
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            "roletype",
            "structure",
            "section"
        ]
    ]
};
var _default = definitionRole;
exports.default = _default;

},{}],"aQPD1":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var deletionRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        "prohibited"
    ],
    prohibitedProps: [
        "aria-label",
        "aria-labelledby"
    ],
    props: {},
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            "roletype",
            "structure",
            "section"
        ]
    ]
};
var _default = deletionRole;
exports.default = _default;

},{}],"7qfLi":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var dialogRole = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        "author"
    ],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [
        {
            concept: {
                name: "dialog"
            },
            module: "HTML"
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            "roletype",
            "window"
        ]
    ]
};
var _default = dialogRole;
exports.default = _default;

},{}],"7YZUJ":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var directoryRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        "author"
    ],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [
        {
            module: "DAISY Guide"
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            "roletype",
            "structure",
            "section",
            "list"
        ]
    ]
};
var _default = directoryRole;
exports.default = _default;

},{}],"3XSO6":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var documentRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        "author"
    ],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [
        {
            concept: {
                name: "Device Independence Delivery Unit"
            }
        },
        {
            concept: {
                name: "body"
            },
            module: "HTML"
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            "roletype",
            "structure"
        ]
    ]
};
var _default = documentRole;
exports.default = _default;

},{}],"ljGI0":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var emphasisRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        "prohibited"
    ],
    prohibitedProps: [
        "aria-label",
        "aria-labelledby"
    ],
    props: {},
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            "roletype",
            "structure",
            "section"
        ]
    ]
};
var _default = emphasisRole;
exports.default = _default;

},{}],"1H6OA":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var feedRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        "author"
    ],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [
        [
            "article"
        ]
    ],
    requiredProps: {},
    superClass: [
        [
            "roletype",
            "structure",
            "section",
            "list"
        ]
    ]
};
var _default = feedRole;
exports.default = _default;

},{}],"7LI5C":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var figureRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        "author"
    ],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [
        {
            concept: {
                name: "figure"
            },
            module: "HTML"
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            "roletype",
            "structure",
            "section"
        ]
    ]
};
var _default = figureRole;
exports.default = _default;

},{}],"3XaJ3":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var formRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        "author"
    ],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [
        {
            concept: {
                attributes: [
                    {
                        constraints: [
                            "set"
                        ],
                        name: "aria-label"
                    }
                ],
                name: "form"
            },
            module: "HTML"
        },
        {
            concept: {
                attributes: [
                    {
                        constraints: [
                            "set"
                        ],
                        name: "aria-labelledby"
                    }
                ],
                name: "form"
            },
            module: "HTML"
        },
        {
            concept: {
                attributes: [
                    {
                        constraints: [
                            "set"
                        ],
                        name: "name"
                    }
                ],
                name: "form"
            },
            module: "HTML"
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            "roletype",
            "structure",
            "section",
            "landmark"
        ]
    ]
};
var _default = formRole;
exports.default = _default;

},{}],"emBat":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var genericRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        "prohibited"
    ],
    prohibitedProps: [
        "aria-label",
        "aria-labelledby"
    ],
    props: {},
    relatedConcepts: [
        {
            concept: {
                name: "span"
            },
            module: "HTML"
        },
        {
            concept: {
                name: "div"
            },
            module: "HTML"
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            "roletype",
            "structure"
        ]
    ]
};
var _default = genericRole;
exports.default = _default;

},{}],"7dzJr":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var gridRole = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        "author"
    ],
    prohibitedProps: [],
    props: {
        "aria-multiselectable": null,
        "aria-readonly": null
    },
    relatedConcepts: [
        {
            concept: {
                attributes: [
                    {
                        name: "role",
                        value: "grid"
                    }
                ],
                name: "table"
            },
            module: "HTML"
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [
        [
            "row"
        ],
        [
            "row",
            "rowgroup"
        ]
    ],
    requiredProps: {},
    superClass: [
        [
            "roletype",
            "widget",
            "composite"
        ],
        [
            "roletype",
            "structure",
            "section",
            "table"
        ]
    ]
};
var _default = gridRole;
exports.default = _default;

},{}],"ah541":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var gridcellRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        "author",
        "contents"
    ],
    prohibitedProps: [],
    props: {
        "aria-disabled": null,
        "aria-errormessage": null,
        "aria-expanded": null,
        "aria-haspopup": null,
        "aria-invalid": null,
        "aria-readonly": null,
        "aria-required": null,
        "aria-selected": null
    },
    relatedConcepts: [
        {
            concept: {
                attributes: [
                    {
                        name: "role",
                        value: "gridcell"
                    }
                ],
                name: "td"
            },
            module: "HTML"
        }
    ],
    requireContextRole: [
        "row"
    ],
    requiredContextRole: [
        "row"
    ],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            "roletype",
            "structure",
            "section",
            "cell"
        ],
        [
            "roletype",
            "widget"
        ]
    ]
};
var _default = gridcellRole;
exports.default = _default;

},{}],"hKIbg":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var groupRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        "author"
    ],
    prohibitedProps: [],
    props: {
        "aria-activedescendant": null,
        "aria-disabled": null
    },
    relatedConcepts: [
        {
            concept: {
                name: "details"
            },
            module: "HTML"
        },
        {
            concept: {
                name: "fieldset"
            },
            module: "HTML"
        },
        {
            concept: {
                name: "optgroup"
            },
            module: "HTML"
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            "roletype",
            "structure",
            "section"
        ]
    ]
};
var _default = groupRole;
exports.default = _default;

},{}],"aAzA8":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var headingRole = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        "author",
        "contents"
    ],
    prohibitedProps: [],
    props: {
        "aria-level": "2"
    },
    relatedConcepts: [
        {
            concept: {
                name: "h1"
            },
            module: "HTML"
        },
        {
            concept: {
                name: "h2"
            },
            module: "HTML"
        },
        {
            concept: {
                name: "h3"
            },
            module: "HTML"
        },
        {
            concept: {
                name: "h4"
            },
            module: "HTML"
        },
        {
            concept: {
                name: "h5"
            },
            module: "HTML"
        },
        {
            concept: {
                name: "h6"
            },
            module: "HTML"
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {
        "aria-level": "2"
    },
    superClass: [
        [
            "roletype",
            "structure",
            "sectionhead"
        ]
    ]
};
var _default = headingRole;
exports.default = _default;

},{}],"8Idl1":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var imgRole = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: true,
    nameFrom: [
        "author"
    ],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [
        {
            concept: {
                attributes: [
                    {
                        constraints: [
                            "set"
                        ],
                        name: "alt"
                    }
                ],
                name: "img"
            },
            module: "HTML"
        },
        {
            concept: {
                attributes: [
                    {
                        constraints: [
                            "undefined"
                        ],
                        name: "alt"
                    }
                ],
                name: "img"
            },
            module: "HTML"
        },
        {
            concept: {
                name: "imggroup"
            },
            module: "DTB"
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            "roletype",
            "structure",
            "section"
        ]
    ]
};
var _default = imgRole;
exports.default = _default;

},{}],"5FOdn":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var insertionRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        "prohibited"
    ],
    prohibitedProps: [
        "aria-label",
        "aria-labelledby"
    ],
    props: {},
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            "roletype",
            "structure",
            "section"
        ]
    ]
};
var _default = insertionRole;
exports.default = _default;

},{}],"6Z7vK":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var linkRole = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        "author",
        "contents"
    ],
    prohibitedProps: [],
    props: {
        "aria-disabled": null,
        "aria-expanded": null,
        "aria-haspopup": null
    },
    relatedConcepts: [
        {
            concept: {
                attributes: [
                    {
                        name: "href"
                    }
                ],
                name: "a"
            },
            module: "HTML"
        },
        {
            concept: {
                attributes: [
                    {
                        name: "href"
                    }
                ],
                name: "area"
            },
            module: "HTML"
        },
        {
            concept: {
                attributes: [
                    {
                        name: "href"
                    }
                ],
                name: "link"
            },
            module: "HTML"
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            "roletype",
            "widget",
            "command"
        ]
    ]
};
var _default = linkRole;
exports.default = _default;

},{}],"1aiX3":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var listRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        "author"
    ],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [
        {
            concept: {
                name: "menu"
            },
            module: "HTML"
        },
        {
            concept: {
                name: "ol"
            },
            module: "HTML"
        },
        {
            concept: {
                name: "ul"
            },
            module: "HTML"
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [
        [
            "listitem"
        ]
    ],
    requiredProps: {},
    superClass: [
        [
            "roletype",
            "structure",
            "section"
        ]
    ]
};
var _default = listRole;
exports.default = _default;

},{}],"1S99m":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var listboxRole = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        "author"
    ],
    prohibitedProps: [],
    props: {
        "aria-errormessage": null,
        "aria-expanded": null,
        "aria-invalid": null,
        "aria-multiselectable": null,
        "aria-readonly": null,
        "aria-required": null,
        "aria-orientation": "vertical"
    },
    relatedConcepts: [
        {
            concept: {
                attributes: [
                    {
                        constraints: [
                            ">1"
                        ],
                        name: "size"
                    },
                    {
                        name: "multiple"
                    }
                ],
                name: "select"
            },
            module: "HTML"
        },
        {
            concept: {
                attributes: [
                    {
                        constraints: [
                            ">1"
                        ],
                        name: "size"
                    }
                ],
                name: "select"
            },
            module: "HTML"
        },
        {
            concept: {
                attributes: [
                    {
                        name: "multiple"
                    }
                ],
                name: "select"
            },
            module: "HTML"
        },
        {
            concept: {
                name: "datalist"
            },
            module: "HTML"
        },
        {
            concept: {
                name: "list"
            },
            module: "ARIA"
        },
        {
            concept: {
                name: "select"
            },
            module: "XForms"
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [
        [
            "option",
            "group"
        ],
        [
            "option"
        ]
    ],
    requiredProps: {},
    superClass: [
        [
            "roletype",
            "widget",
            "composite",
            "select"
        ],
        [
            "roletype",
            "structure",
            "section",
            "group",
            "select"
        ]
    ]
};
var _default = listboxRole;
exports.default = _default;

},{}],"gt5bM":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var listitemRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        "author"
    ],
    prohibitedProps: [],
    props: {
        "aria-level": null,
        "aria-posinset": null,
        "aria-setsize": null
    },
    relatedConcepts: [
        {
            concept: {
                constraints: [
                    "direct descendant of ol, ul or menu"
                ],
                name: "li"
            },
            module: "HTML"
        },
        {
            concept: {
                name: "item"
            },
            module: "XForms"
        }
    ],
    requireContextRole: [
        "directory",
        "list"
    ],
    requiredContextRole: [
        "directory",
        "list"
    ],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            "roletype",
            "structure",
            "section"
        ]
    ]
};
var _default = listitemRole;
exports.default = _default;

},{}],"44hCl":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var logRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        "author"
    ],
    prohibitedProps: [],
    props: {
        "aria-live": "polite"
    },
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            "roletype",
            "structure",
            "section"
        ]
    ]
};
var _default = logRole;
exports.default = _default;

},{}],"e3QeZ":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var mainRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        "author"
    ],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [
        {
            concept: {
                name: "main"
            },
            module: "HTML"
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            "roletype",
            "structure",
            "section",
            "landmark"
        ]
    ]
};
var _default = mainRole;
exports.default = _default;

},{}],"IediM":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var marqueeRole = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        "author"
    ],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            "roletype",
            "structure",
            "section"
        ]
    ]
};
var _default = marqueeRole;
exports.default = _default;

},{}],"5xhB0":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var mathRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        "author"
    ],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [
        {
            concept: {
                name: "math"
            },
            module: "HTML"
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            "roletype",
            "structure",
            "section"
        ]
    ]
};
var _default = mathRole;
exports.default = _default;

},{}],"6HNL0":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var menuRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        "author"
    ],
    prohibitedProps: [],
    props: {
        "aria-orientation": "vertical"
    },
    relatedConcepts: [
        {
            concept: {
                name: "MENU"
            },
            module: "JAPI"
        },
        {
            concept: {
                name: "list"
            },
            module: "ARIA"
        },
        {
            concept: {
                name: "select"
            },
            module: "XForms"
        },
        {
            concept: {
                name: "sidebar"
            },
            module: "DTB"
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [
        [
            "menuitem",
            "group"
        ],
        [
            "menuitemradio",
            "group"
        ],
        [
            "menuitemcheckbox",
            "group"
        ],
        [
            "menuitem"
        ],
        [
            "menuitemcheckbox"
        ],
        [
            "menuitemradio"
        ]
    ],
    requiredProps: {},
    superClass: [
        [
            "roletype",
            "widget",
            "composite",
            "select"
        ],
        [
            "roletype",
            "structure",
            "section",
            "group",
            "select"
        ]
    ]
};
var _default = menuRole;
exports.default = _default;

},{}],"eVQdI":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var menubarRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        "author"
    ],
    prohibitedProps: [],
    props: {
        "aria-orientation": "horizontal"
    },
    relatedConcepts: [
        {
            concept: {
                name: "toolbar"
            },
            module: "ARIA"
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [
        [
            "menuitem",
            "group"
        ],
        [
            "menuitemradio",
            "group"
        ],
        [
            "menuitemcheckbox",
            "group"
        ],
        [
            "menuitem"
        ],
        [
            "menuitemcheckbox"
        ],
        [
            "menuitemradio"
        ]
    ],
    requiredProps: {},
    superClass: [
        [
            "roletype",
            "widget",
            "composite",
            "select",
            "menu"
        ],
        [
            "roletype",
            "structure",
            "section",
            "group",
            "select",
            "menu"
        ]
    ]
};
var _default = menubarRole;
exports.default = _default;

},{}],"9nG5t":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var menuitemRole = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        "author",
        "contents"
    ],
    prohibitedProps: [],
    props: {
        "aria-disabled": null,
        "aria-expanded": null,
        "aria-haspopup": null,
        "aria-posinset": null,
        "aria-setsize": null
    },
    relatedConcepts: [
        {
            concept: {
                name: "MENU_ITEM"
            },
            module: "JAPI"
        },
        {
            concept: {
                name: "listitem"
            },
            module: "ARIA"
        },
        {
            concept: {
                name: "menuitem"
            },
            module: "HTML"
        },
        {
            concept: {
                name: "option"
            },
            module: "ARIA"
        }
    ],
    requireContextRole: [
        "group",
        "menu",
        "menubar"
    ],
    requiredContextRole: [
        "group",
        "menu",
        "menubar"
    ],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            "roletype",
            "widget",
            "command"
        ]
    ]
};
var _default = menuitemRole;
exports.default = _default;

},{}],"1gIqn":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var menuitemcheckboxRole = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: true,
    nameFrom: [
        "author",
        "contents"
    ],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [
        {
            concept: {
                name: "menuitem"
            },
            module: "ARIA"
        }
    ],
    requireContextRole: [
        "group",
        "menu",
        "menubar"
    ],
    requiredContextRole: [
        "group",
        "menu",
        "menubar"
    ],
    requiredOwnedElements: [],
    requiredProps: {
        "aria-checked": null
    },
    superClass: [
        [
            "roletype",
            "widget",
            "input",
            "checkbox"
        ],
        [
            "roletype",
            "widget",
            "command",
            "menuitem"
        ]
    ]
};
var _default = menuitemcheckboxRole;
exports.default = _default;

},{}],"cAWw9":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var menuitemradioRole = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: true,
    nameFrom: [
        "author",
        "contents"
    ],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [
        {
            concept: {
                name: "menuitem"
            },
            module: "ARIA"
        }
    ],
    requireContextRole: [
        "group",
        "menu",
        "menubar"
    ],
    requiredContextRole: [
        "group",
        "menu",
        "menubar"
    ],
    requiredOwnedElements: [],
    requiredProps: {
        "aria-checked": null
    },
    superClass: [
        [
            "roletype",
            "widget",
            "input",
            "checkbox",
            "menuitemcheckbox"
        ],
        [
            "roletype",
            "widget",
            "command",
            "menuitem",
            "menuitemcheckbox"
        ],
        [
            "roletype",
            "widget",
            "input",
            "radio"
        ]
    ]
};
var _default = menuitemradioRole;
exports.default = _default;

},{}],"fRIkD":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var meterRole = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: true,
    nameFrom: [
        "author"
    ],
    prohibitedProps: [],
    props: {
        "aria-valuetext": null,
        "aria-valuemax": "100",
        "aria-valuemin": "0"
    },
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {
        "aria-valuenow": null
    },
    superClass: [
        [
            "roletype",
            "structure",
            "range"
        ]
    ]
};
var _default = meterRole;
exports.default = _default;

},{}],"ln3G3":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var navigationRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        "author"
    ],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [
        {
            concept: {
                name: "nav"
            },
            module: "HTML"
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            "roletype",
            "structure",
            "section",
            "landmark"
        ]
    ]
};
var _default = navigationRole;
exports.default = _default;

},{}],"5GE2Y":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var noneRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: []
};
var _default = noneRole;
exports.default = _default;

},{}],"19ums":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var noteRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        "author"
    ],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            "roletype",
            "structure",
            "section"
        ]
    ]
};
var _default = noteRole;
exports.default = _default;

},{}],"2TRsH":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var optionRole = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: true,
    nameFrom: [
        "author",
        "contents"
    ],
    prohibitedProps: [],
    props: {
        "aria-checked": null,
        "aria-posinset": null,
        "aria-setsize": null,
        "aria-selected": "false"
    },
    relatedConcepts: [
        {
            concept: {
                name: "item"
            },
            module: "XForms"
        },
        {
            concept: {
                name: "listitem"
            },
            module: "ARIA"
        },
        {
            concept: {
                name: "option"
            },
            module: "HTML"
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {
        "aria-selected": "false"
    },
    superClass: [
        [
            "roletype",
            "widget",
            "input"
        ]
    ]
};
var _default = optionRole;
exports.default = _default;

},{}],"i5qWm":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var paragraphRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        "prohibited"
    ],
    prohibitedProps: [
        "aria-label",
        "aria-labelledby"
    ],
    props: {},
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            "roletype",
            "structure",
            "section"
        ]
    ]
};
var _default = paragraphRole;
exports.default = _default;

},{}],"dcQpN":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var presentationRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        "prohibited"
    ],
    prohibitedProps: [
        "aria-label",
        "aria-labelledby"
    ],
    props: {},
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            "roletype",
            "structure"
        ]
    ]
};
var _default = presentationRole;
exports.default = _default;

},{}],"gbowZ":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var progressbarRole = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: true,
    nameFrom: [
        "author"
    ],
    prohibitedProps: [],
    props: {
        "aria-valuetext": null
    },
    relatedConcepts: [
        {
            concept: {
                name: "progress"
            },
            module: "HTML"
        },
        {
            concept: {
                name: "status"
            },
            module: "ARIA"
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            "roletype",
            "structure",
            "range"
        ],
        [
            "roletype",
            "widget"
        ]
    ]
};
var _default = progressbarRole;
exports.default = _default;

},{}],"4QEEs":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var radioRole = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: true,
    nameFrom: [
        "author",
        "contents"
    ],
    prohibitedProps: [],
    props: {
        "aria-checked": null,
        "aria-posinset": null,
        "aria-setsize": null
    },
    relatedConcepts: [
        {
            concept: {
                attributes: [
                    {
                        name: "type",
                        value: "radio"
                    }
                ],
                name: "input"
            },
            module: "HTML"
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {
        "aria-checked": null
    },
    superClass: [
        [
            "roletype",
            "widget",
            "input"
        ]
    ]
};
var _default = radioRole;
exports.default = _default;

},{}],"kFbJ5":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var radiogroupRole = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        "author"
    ],
    prohibitedProps: [],
    props: {
        "aria-errormessage": null,
        "aria-invalid": null,
        "aria-readonly": null,
        "aria-required": null
    },
    relatedConcepts: [
        {
            concept: {
                name: "list"
            },
            module: "ARIA"
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [
        [
            "radio"
        ]
    ],
    requiredProps: {},
    superClass: [
        [
            "roletype",
            "widget",
            "composite",
            "select"
        ],
        [
            "roletype",
            "structure",
            "section",
            "group",
            "select"
        ]
    ]
};
var _default = radiogroupRole;
exports.default = _default;

},{}],"4AZOY":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var regionRole = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        "author"
    ],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [
        {
            concept: {
                attributes: [
                    {
                        constraints: [
                            "set"
                        ],
                        name: "aria-label"
                    }
                ],
                name: "section"
            },
            module: "HTML"
        },
        {
            concept: {
                attributes: [
                    {
                        constraints: [
                            "set"
                        ],
                        name: "aria-labelledby"
                    }
                ],
                name: "section"
            },
            module: "HTML"
        },
        {
            concept: {
                name: "Device Independence Glossart perceivable unit"
            }
        },
        {
            concept: {
                name: "frame"
            },
            module: "HTML"
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            "roletype",
            "structure",
            "section",
            "landmark"
        ]
    ]
};
var _default = regionRole;
exports.default = _default;

},{}],"g5yN8":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var rowRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        "author",
        "contents"
    ],
    prohibitedProps: [],
    props: {
        "aria-colindex": null,
        "aria-expanded": null,
        "aria-level": null,
        "aria-posinset": null,
        "aria-rowindex": null,
        "aria-selected": null,
        "aria-setsize": null
    },
    relatedConcepts: [
        {
            concept: {
                name: "tr"
            },
            module: "HTML"
        }
    ],
    requireContextRole: [
        "grid",
        "rowgroup",
        "table",
        "treegrid"
    ],
    requiredContextRole: [
        "grid",
        "rowgroup",
        "table",
        "treegrid"
    ],
    requiredOwnedElements: [
        [
            "cell"
        ],
        [
            "columnheader"
        ],
        [
            "gridcell"
        ],
        [
            "rowheader"
        ]
    ],
    requiredProps: {},
    superClass: [
        [
            "roletype",
            "structure",
            "section",
            "group"
        ],
        [
            "roletype",
            "widget"
        ]
    ]
};
var _default = rowRole;
exports.default = _default;

},{}],"hHQSp":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var rowgroupRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        "author",
        "contents"
    ],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [
        {
            concept: {
                name: "tbody"
            },
            module: "HTML"
        },
        {
            concept: {
                name: "tfoot"
            },
            module: "HTML"
        },
        {
            concept: {
                name: "thead"
            },
            module: "HTML"
        }
    ],
    requireContextRole: [
        "grid",
        "table",
        "treegrid"
    ],
    requiredContextRole: [
        "grid",
        "table",
        "treegrid"
    ],
    requiredOwnedElements: [
        [
            "row"
        ]
    ],
    requiredProps: {},
    superClass: [
        [
            "roletype",
            "structure"
        ]
    ]
};
var _default = rowgroupRole;
exports.default = _default;

},{}],"bCnlU":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var rowheaderRole = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        "author",
        "contents"
    ],
    prohibitedProps: [],
    props: {
        "aria-sort": null
    },
    relatedConcepts: [
        {
            concept: {
                attributes: [
                    {
                        name: "scope",
                        value: "row"
                    }
                ],
                name: "th"
            },
            module: "HTML"
        },
        {
            concept: {
                attributes: [
                    {
                        name: "scope",
                        value: "rowgroup"
                    }
                ],
                name: "th"
            },
            module: "HTML"
        }
    ],
    requireContextRole: [
        "row",
        "rowgroup"
    ],
    requiredContextRole: [
        "row",
        "rowgroup"
    ],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            "roletype",
            "structure",
            "section",
            "cell"
        ],
        [
            "roletype",
            "structure",
            "section",
            "cell",
            "gridcell"
        ],
        [
            "roletype",
            "widget",
            "gridcell"
        ],
        [
            "roletype",
            "structure",
            "sectionhead"
        ]
    ]
};
var _default = rowheaderRole;
exports.default = _default;

},{}],"dr05U":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var scrollbarRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: true,
    nameFrom: [
        "author"
    ],
    prohibitedProps: [],
    props: {
        "aria-disabled": null,
        "aria-valuetext": null,
        "aria-orientation": "vertical",
        "aria-valuemax": "100",
        "aria-valuemin": "0"
    },
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {
        "aria-controls": null,
        "aria-valuenow": null
    },
    superClass: [
        [
            "roletype",
            "structure",
            "range"
        ],
        [
            "roletype",
            "widget"
        ]
    ]
};
var _default = scrollbarRole;
exports.default = _default;

},{}],"5gkcs":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var searchRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        "author"
    ],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            "roletype",
            "structure",
            "section",
            "landmark"
        ]
    ]
};
var _default = searchRole;
exports.default = _default;

},{}],"kEYv6":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var searchboxRole = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        "author"
    ],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [
        {
            concept: {
                attributes: [
                    {
                        constraints: [
                            "undefined"
                        ],
                        name: "list"
                    },
                    {
                        name: "type",
                        value: "search"
                    }
                ],
                name: "input"
            },
            module: "HTML"
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            "roletype",
            "widget",
            "input",
            "textbox"
        ]
    ]
};
var _default = searchboxRole;
exports.default = _default;

},{}],"66Lbn":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var separatorRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: true,
    nameFrom: [
        "author"
    ],
    prohibitedProps: [],
    props: {
        "aria-disabled": null,
        "aria-orientation": "horizontal",
        "aria-valuemax": "100",
        "aria-valuemin": "0",
        "aria-valuenow": null,
        "aria-valuetext": null
    },
    relatedConcepts: [
        {
            concept: {
                name: "hr"
            },
            module: "HTML"
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            "roletype",
            "structure"
        ]
    ]
};
var _default = separatorRole;
exports.default = _default;

},{}],"3o8a7":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var sliderRole = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: true,
    nameFrom: [
        "author"
    ],
    prohibitedProps: [],
    props: {
        "aria-errormessage": null,
        "aria-haspopup": null,
        "aria-invalid": null,
        "aria-readonly": null,
        "aria-valuetext": null,
        "aria-orientation": "horizontal",
        "aria-valuemax": "100",
        "aria-valuemin": "0"
    },
    relatedConcepts: [
        {
            concept: {
                attributes: [
                    {
                        name: "type",
                        value: "range"
                    }
                ],
                name: "input"
            },
            module: "HTML"
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {
        "aria-valuenow": null
    },
    superClass: [
        [
            "roletype",
            "widget",
            "input"
        ],
        [
            "roletype",
            "structure",
            "range"
        ]
    ]
};
var _default = sliderRole;
exports.default = _default;

},{}],"aSaMM":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var spinbuttonRole = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        "author"
    ],
    prohibitedProps: [],
    props: {
        "aria-errormessage": null,
        "aria-invalid": null,
        "aria-readonly": null,
        "aria-required": null,
        "aria-valuetext": null,
        "aria-valuenow": "0"
    },
    relatedConcepts: [
        {
            concept: {
                attributes: [
                    {
                        name: "type",
                        value: "number"
                    }
                ],
                name: "input"
            },
            module: "HTML"
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            "roletype",
            "widget",
            "composite"
        ],
        [
            "roletype",
            "widget",
            "input"
        ],
        [
            "roletype",
            "structure",
            "range"
        ]
    ]
};
var _default = spinbuttonRole;
exports.default = _default;

},{}],"5dzMT":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var statusRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        "author"
    ],
    prohibitedProps: [],
    props: {
        "aria-atomic": "true",
        "aria-live": "polite"
    },
    relatedConcepts: [
        {
            concept: {
                name: "output"
            },
            module: "HTML"
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            "roletype",
            "structure",
            "section"
        ]
    ]
};
var _default = statusRole;
exports.default = _default;

},{}],"1kyWY":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var strongRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        "prohibited"
    ],
    prohibitedProps: [
        "aria-label",
        "aria-labelledby"
    ],
    props: {},
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            "roletype",
            "structure",
            "section"
        ]
    ]
};
var _default = strongRole;
exports.default = _default;

},{}],"6qPSY":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var subscriptRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        "prohibited"
    ],
    prohibitedProps: [
        "aria-label",
        "aria-labelledby"
    ],
    props: {},
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            "roletype",
            "structure",
            "section"
        ]
    ]
};
var _default = subscriptRole;
exports.default = _default;

},{}],"3IiDp":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var superscriptRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        "prohibited"
    ],
    prohibitedProps: [
        "aria-label",
        "aria-labelledby"
    ],
    props: {},
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            "roletype",
            "structure",
            "section"
        ]
    ]
};
var _default = superscriptRole;
exports.default = _default;

},{}],"fKzKu":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var switchRole = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: true,
    nameFrom: [
        "author",
        "contents"
    ],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [
        {
            concept: {
                name: "button"
            },
            module: "ARIA"
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {
        "aria-checked": null
    },
    superClass: [
        [
            "roletype",
            "widget",
            "input",
            "checkbox"
        ]
    ]
};
var _default = switchRole;
exports.default = _default;

},{}],"8QllK":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var tabRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: true,
    nameFrom: [
        "author",
        "contents"
    ],
    prohibitedProps: [],
    props: {
        "aria-disabled": null,
        "aria-expanded": null,
        "aria-haspopup": null,
        "aria-posinset": null,
        "aria-setsize": null,
        "aria-selected": "false"
    },
    relatedConcepts: [],
    requireContextRole: [
        "tablist"
    ],
    requiredContextRole: [
        "tablist"
    ],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            "roletype",
            "structure",
            "sectionhead"
        ],
        [
            "roletype",
            "widget"
        ]
    ]
};
var _default = tabRole;
exports.default = _default;

},{}],"76Ar9":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var tableRole = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        "author"
    ],
    prohibitedProps: [],
    props: {
        "aria-colcount": null,
        "aria-rowcount": null
    },
    relatedConcepts: [
        {
            concept: {
                name: "table"
            },
            module: "HTML"
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [
        [
            "row"
        ],
        [
            "row",
            "rowgroup"
        ]
    ],
    requiredProps: {},
    superClass: [
        [
            "roletype",
            "structure",
            "section"
        ]
    ]
};
var _default = tableRole;
exports.default = _default;

},{}],"eUwW2":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var tablistRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        "author"
    ],
    prohibitedProps: [],
    props: {
        "aria-level": null,
        "aria-multiselectable": null,
        "aria-orientation": "horizontal"
    },
    relatedConcepts: [
        {
            module: "DAISY",
            concept: {
                name: "guide"
            }
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [
        [
            "tab"
        ]
    ],
    requiredProps: {},
    superClass: [
        [
            "roletype",
            "widget",
            "composite"
        ]
    ]
};
var _default = tablistRole;
exports.default = _default;

},{}],"iGJdp":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var tabpanelRole = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        "author"
    ],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            "roletype",
            "structure",
            "section"
        ]
    ]
};
var _default = tabpanelRole;
exports.default = _default;

},{}],"4AXci":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var termRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        "author"
    ],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [
        {
            concept: {
                name: "dfn"
            },
            module: "HTML"
        },
        {
            concept: {
                name: "dt"
            },
            module: "HTML"
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            "roletype",
            "structure",
            "section"
        ]
    ]
};
var _default = termRole;
exports.default = _default;

},{}],"b7CIX":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var textboxRole = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        "author"
    ],
    prohibitedProps: [],
    props: {
        "aria-activedescendant": null,
        "aria-autocomplete": null,
        "aria-errormessage": null,
        "aria-haspopup": null,
        "aria-invalid": null,
        "aria-multiline": null,
        "aria-placeholder": null,
        "aria-readonly": null,
        "aria-required": null
    },
    relatedConcepts: [
        {
            concept: {
                attributes: [
                    {
                        constraints: [
                            "undefined"
                        ],
                        name: "type"
                    },
                    {
                        constraints: [
                            "undefined"
                        ],
                        name: "list"
                    }
                ],
                name: "input"
            },
            module: "HTML"
        },
        {
            concept: {
                attributes: [
                    {
                        constraints: [
                            "undefined"
                        ],
                        name: "list"
                    },
                    {
                        name: "type",
                        value: "email"
                    }
                ],
                name: "input"
            },
            module: "HTML"
        },
        {
            concept: {
                attributes: [
                    {
                        constraints: [
                            "undefined"
                        ],
                        name: "list"
                    },
                    {
                        name: "type",
                        value: "tel"
                    }
                ],
                name: "input"
            },
            module: "HTML"
        },
        {
            concept: {
                attributes: [
                    {
                        constraints: [
                            "undefined"
                        ],
                        name: "list"
                    },
                    {
                        name: "type",
                        value: "text"
                    }
                ],
                name: "input"
            },
            module: "HTML"
        },
        {
            concept: {
                attributes: [
                    {
                        constraints: [
                            "undefined"
                        ],
                        name: "list"
                    },
                    {
                        name: "type",
                        value: "url"
                    }
                ],
                name: "input"
            },
            module: "HTML"
        },
        {
            concept: {
                name: "input"
            },
            module: "XForms"
        },
        {
            concept: {
                name: "textarea"
            },
            module: "HTML"
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            "roletype",
            "widget",
            "input"
        ]
    ]
};
var _default = textboxRole;
exports.default = _default;

},{}],"5Ni8U":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var timeRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        "author"
    ],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            "roletype",
            "structure",
            "section"
        ]
    ]
};
var _default = timeRole;
exports.default = _default;

},{}],"6scrO":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var timerRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        "author"
    ],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            "roletype",
            "structure",
            "section",
            "status"
        ]
    ]
};
var _default = timerRole;
exports.default = _default;

},{}],"f3vxe":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var toolbarRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        "author"
    ],
    prohibitedProps: [],
    props: {
        "aria-orientation": "horizontal"
    },
    relatedConcepts: [
        {
            concept: {
                name: "menubar"
            },
            module: "ARIA"
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            "roletype",
            "structure",
            "section",
            "group"
        ]
    ]
};
var _default = toolbarRole;
exports.default = _default;

},{}],"eDre0":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var tooltipRole = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        "author",
        "contents"
    ],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            "roletype",
            "structure",
            "section"
        ]
    ]
};
var _default = tooltipRole;
exports.default = _default;

},{}],"74TlZ":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var treeRole = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        "author"
    ],
    prohibitedProps: [],
    props: {
        "aria-errormessage": null,
        "aria-invalid": null,
        "aria-multiselectable": null,
        "aria-required": null,
        "aria-orientation": "vertical"
    },
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [
        [
            "treeitem",
            "group"
        ],
        [
            "treeitem"
        ]
    ],
    requiredProps: {},
    superClass: [
        [
            "roletype",
            "widget",
            "composite",
            "select"
        ],
        [
            "roletype",
            "structure",
            "section",
            "group",
            "select"
        ]
    ]
};
var _default = treeRole;
exports.default = _default;

},{}],"aa6wx":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var treegridRole = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        "author"
    ],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [
        [
            "row"
        ],
        [
            "row",
            "rowgroup"
        ]
    ],
    requiredProps: {},
    superClass: [
        [
            "roletype",
            "widget",
            "composite",
            "grid"
        ],
        [
            "roletype",
            "structure",
            "section",
            "table",
            "grid"
        ],
        [
            "roletype",
            "widget",
            "composite",
            "select",
            "tree"
        ],
        [
            "roletype",
            "structure",
            "section",
            "group",
            "select",
            "tree"
        ]
    ]
};
var _default = treegridRole;
exports.default = _default;

},{}],"ixE38":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var treeitemRole = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        "author",
        "contents"
    ],
    prohibitedProps: [],
    props: {
        "aria-expanded": null,
        "aria-haspopup": null
    },
    relatedConcepts: [],
    requireContextRole: [
        "group",
        "tree"
    ],
    requiredContextRole: [
        "group",
        "tree"
    ],
    requiredOwnedElements: [],
    requiredProps: {
        "aria-selected": null
    },
    superClass: [
        [
            "roletype",
            "structure",
            "section",
            "listitem"
        ],
        [
            "roletype",
            "widget",
            "input",
            "option"
        ]
    ]
};
var _default = treeitemRole;
exports.default = _default;

},{}],"MrFbL":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _docAbstractRole = _interopRequireDefault(require("b1ef890f2e828847"));
var _docAcknowledgmentsRole = _interopRequireDefault(require("b46f0dcb4f92e4e5"));
var _docAfterwordRole = _interopRequireDefault(require("48c8658a59613a71"));
var _docAppendixRole = _interopRequireDefault(require("b059ab3f59613b64"));
var _docBacklinkRole = _interopRequireDefault(require("f049381cd55d4b99"));
var _docBiblioentryRole = _interopRequireDefault(require("bc6924a09248f26f"));
var _docBibliographyRole = _interopRequireDefault(require("7ae50021bd2706ee"));
var _docBibliorefRole = _interopRequireDefault(require("8e8d6eda59459b61"));
var _docChapterRole = _interopRequireDefault(require("cad161f0882d8aa7"));
var _docColophonRole = _interopRequireDefault(require("864af280bbe837c"));
var _docConclusionRole = _interopRequireDefault(require("5453f2706baf8131"));
var _docCoverRole = _interopRequireDefault(require("b87405d5f5fbcd1c"));
var _docCreditRole = _interopRequireDefault(require("2f47e0f1fc88caac"));
var _docCreditsRole = _interopRequireDefault(require("481974391446722f"));
var _docDedicationRole = _interopRequireDefault(require("9eab6f42a834c8fa"));
var _docEndnoteRole = _interopRequireDefault(require("8035e49efaa21dda"));
var _docEndnotesRole = _interopRequireDefault(require("7d83748fc979c62f"));
var _docEpigraphRole = _interopRequireDefault(require("632865120e5643d0"));
var _docEpilogueRole = _interopRequireDefault(require("c59c18b164d945b3"));
var _docErrataRole = _interopRequireDefault(require("bd60a3bbabc764ff"));
var _docExampleRole = _interopRequireDefault(require("6af0a7d7a8af3e32"));
var _docFootnoteRole = _interopRequireDefault(require("c3c28d959ffcfd58"));
var _docForewordRole = _interopRequireDefault(require("ea7179dd7a268ff1"));
var _docGlossaryRole = _interopRequireDefault(require("df229add31fbbc31"));
var _docGlossrefRole = _interopRequireDefault(require("230e041a72d1773f"));
var _docIndexRole = _interopRequireDefault(require("8df329eed0ecd40c"));
var _docIntroductionRole = _interopRequireDefault(require("c8a4a2f1d0f7ab59"));
var _docNoterefRole = _interopRequireDefault(require("7ff5e10d3a44ac3d"));
var _docNoticeRole = _interopRequireDefault(require("24cdc984648632ed"));
var _docPagebreakRole = _interopRequireDefault(require("d94b281b7d8f15cb"));
var _docPagelistRole = _interopRequireDefault(require("f0be7ea45078e443"));
var _docPartRole = _interopRequireDefault(require("ada3a872ffe66130"));
var _docPrefaceRole = _interopRequireDefault(require("2ac35acd7620af9b"));
var _docPrologueRole = _interopRequireDefault(require("56d9e540c2bb74e6"));
var _docPullquoteRole = _interopRequireDefault(require("afc79b343b1231f4"));
var _docQnaRole = _interopRequireDefault(require("f8d601af472f3831"));
var _docSubtitleRole = _interopRequireDefault(require("a523cd357d05d673"));
var _docTipRole = _interopRequireDefault(require("95e1853932806a2c"));
var _docTocRole = _interopRequireDefault(require("f86962a3ff5d1ef6"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var ariaDpubRoles = [
    [
        "doc-abstract",
        _docAbstractRole.default
    ],
    [
        "doc-acknowledgments",
        _docAcknowledgmentsRole.default
    ],
    [
        "doc-afterword",
        _docAfterwordRole.default
    ],
    [
        "doc-appendix",
        _docAppendixRole.default
    ],
    [
        "doc-backlink",
        _docBacklinkRole.default
    ],
    [
        "doc-biblioentry",
        _docBiblioentryRole.default
    ],
    [
        "doc-bibliography",
        _docBibliographyRole.default
    ],
    [
        "doc-biblioref",
        _docBibliorefRole.default
    ],
    [
        "doc-chapter",
        _docChapterRole.default
    ],
    [
        "doc-colophon",
        _docColophonRole.default
    ],
    [
        "doc-conclusion",
        _docConclusionRole.default
    ],
    [
        "doc-cover",
        _docCoverRole.default
    ],
    [
        "doc-credit",
        _docCreditRole.default
    ],
    [
        "doc-credits",
        _docCreditsRole.default
    ],
    [
        "doc-dedication",
        _docDedicationRole.default
    ],
    [
        "doc-endnote",
        _docEndnoteRole.default
    ],
    [
        "doc-endnotes",
        _docEndnotesRole.default
    ],
    [
        "doc-epigraph",
        _docEpigraphRole.default
    ],
    [
        "doc-epilogue",
        _docEpilogueRole.default
    ],
    [
        "doc-errata",
        _docErrataRole.default
    ],
    [
        "doc-example",
        _docExampleRole.default
    ],
    [
        "doc-footnote",
        _docFootnoteRole.default
    ],
    [
        "doc-foreword",
        _docForewordRole.default
    ],
    [
        "doc-glossary",
        _docGlossaryRole.default
    ],
    [
        "doc-glossref",
        _docGlossrefRole.default
    ],
    [
        "doc-index",
        _docIndexRole.default
    ],
    [
        "doc-introduction",
        _docIntroductionRole.default
    ],
    [
        "doc-noteref",
        _docNoterefRole.default
    ],
    [
        "doc-notice",
        _docNoticeRole.default
    ],
    [
        "doc-pagebreak",
        _docPagebreakRole.default
    ],
    [
        "doc-pagelist",
        _docPagelistRole.default
    ],
    [
        "doc-part",
        _docPartRole.default
    ],
    [
        "doc-preface",
        _docPrefaceRole.default
    ],
    [
        "doc-prologue",
        _docPrologueRole.default
    ],
    [
        "doc-pullquote",
        _docPullquoteRole.default
    ],
    [
        "doc-qna",
        _docQnaRole.default
    ],
    [
        "doc-subtitle",
        _docSubtitleRole.default
    ],
    [
        "doc-tip",
        _docTipRole.default
    ],
    [
        "doc-toc",
        _docTocRole.default
    ]
];
var _default = ariaDpubRoles;
exports.default = _default;

},{"b1ef890f2e828847":"kvkJ6","b46f0dcb4f92e4e5":"4shJl","48c8658a59613a71":"2vyL1","b059ab3f59613b64":"lK0zB","f049381cd55d4b99":"7d98H","bc6924a09248f26f":"8qTkH","7ae50021bd2706ee":"6daY5","8e8d6eda59459b61":"dxGTE","cad161f0882d8aa7":"3T9Zb","864af280bbe837c":"l6K6D","5453f2706baf8131":"4oYQq","b87405d5f5fbcd1c":"l3DMy","2f47e0f1fc88caac":"hnwK9","481974391446722f":"lgh5S","9eab6f42a834c8fa":"3iTjz","8035e49efaa21dda":"gZbhJ","7d83748fc979c62f":"6GUJz","632865120e5643d0":"dSi65","c59c18b164d945b3":"1Unxr","bd60a3bbabc764ff":"1QYws","6af0a7d7a8af3e32":"50Vnt","c3c28d959ffcfd58":"7hO4l","ea7179dd7a268ff1":"lOucx","df229add31fbbc31":"1t3Fc","230e041a72d1773f":"kVWQT","8df329eed0ecd40c":"9J2JF","c8a4a2f1d0f7ab59":"g3GhK","7ff5e10d3a44ac3d":"3Jlq2","24cdc984648632ed":"27mEX","d94b281b7d8f15cb":"aN9hl","f0be7ea45078e443":"94P1G","ada3a872ffe66130":"91lRr","2ac35acd7620af9b":"hug2D","56d9e540c2bb74e6":"8t3je","afc79b343b1231f4":"fNvEQ","f8d601af472f3831":"jHmnA","a523cd357d05d673":"704GY","95e1853932806a2c":"12Xpy","f86962a3ff5d1ef6":"dS4Sn"}],"kvkJ6":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var docAbstractRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        "author"
    ],
    prohibitedProps: [],
    props: {
        "aria-disabled": null,
        "aria-errormessage": null,
        "aria-expanded": null,
        "aria-haspopup": null,
        "aria-invalid": null
    },
    relatedConcepts: [
        {
            concept: {
                name: "abstract [EPUB-SSV]"
            },
            module: "EPUB"
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            "roletype",
            "structure",
            "section"
        ]
    ]
};
var _default = docAbstractRole;
exports.default = _default;

},{}],"4shJl":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var docAcknowledgmentsRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        "author"
    ],
    prohibitedProps: [],
    props: {
        "aria-disabled": null,
        "aria-errormessage": null,
        "aria-expanded": null,
        "aria-haspopup": null,
        "aria-invalid": null
    },
    relatedConcepts: [
        {
            concept: {
                name: "acknowledgments [EPUB-SSV]"
            },
            module: "EPUB"
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            "roletype",
            "structure",
            "section",
            "landmark"
        ]
    ]
};
var _default = docAcknowledgmentsRole;
exports.default = _default;

},{}],"2vyL1":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var docAfterwordRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        "author"
    ],
    prohibitedProps: [],
    props: {
        "aria-disabled": null,
        "aria-errormessage": null,
        "aria-expanded": null,
        "aria-haspopup": null,
        "aria-invalid": null
    },
    relatedConcepts: [
        {
            concept: {
                name: "afterword [EPUB-SSV]"
            },
            module: "EPUB"
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            "roletype",
            "structure",
            "section",
            "landmark"
        ]
    ]
};
var _default = docAfterwordRole;
exports.default = _default;

},{}],"lK0zB":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var docAppendixRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        "author"
    ],
    prohibitedProps: [],
    props: {
        "aria-disabled": null,
        "aria-errormessage": null,
        "aria-expanded": null,
        "aria-haspopup": null,
        "aria-invalid": null
    },
    relatedConcepts: [
        {
            concept: {
                name: "appendix [EPUB-SSV]"
            },
            module: "EPUB"
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            "roletype",
            "structure",
            "section",
            "landmark"
        ]
    ]
};
var _default = docAppendixRole;
exports.default = _default;

},{}],"7d98H":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var docBacklinkRole = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        "author",
        "content"
    ],
    prohibitedProps: [],
    props: {
        "aria-errormessage": null,
        "aria-invalid": null
    },
    relatedConcepts: [
        {
            concept: {
                name: "referrer [EPUB-SSV]"
            },
            module: "EPUB"
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            "roletype",
            "widget",
            "command",
            "link"
        ]
    ]
};
var _default = docBacklinkRole;
exports.default = _default;

},{}],"8qTkH":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var docBiblioentryRole = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        "author"
    ],
    prohibitedProps: [],
    props: {
        "aria-disabled": null,
        "aria-errormessage": null,
        "aria-expanded": null,
        "aria-haspopup": null,
        "aria-invalid": null
    },
    relatedConcepts: [
        {
            concept: {
                name: "EPUB biblioentry [EPUB-SSV]"
            },
            module: "EPUB"
        }
    ],
    requireContextRole: [
        "doc-bibliography"
    ],
    requiredContextRole: [
        "doc-bibliography"
    ],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            "roletype",
            "structure",
            "section",
            "listitem"
        ]
    ]
};
var _default = docBiblioentryRole;
exports.default = _default;

},{}],"6daY5":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var docBibliographyRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        "author"
    ],
    prohibitedProps: [],
    props: {
        "aria-disabled": null,
        "aria-errormessage": null,
        "aria-expanded": null,
        "aria-haspopup": null,
        "aria-invalid": null
    },
    relatedConcepts: [
        {
            concept: {
                name: "bibliography [EPUB-SSV]"
            },
            module: "EPUB"
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [
        [
            "doc-biblioentry"
        ]
    ],
    requiredProps: {},
    superClass: [
        [
            "roletype",
            "structure",
            "section",
            "landmark"
        ]
    ]
};
var _default = docBibliographyRole;
exports.default = _default;

},{}],"dxGTE":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var docBibliorefRole = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        "author",
        "contents"
    ],
    prohibitedProps: [],
    props: {
        "aria-errormessage": null,
        "aria-invalid": null
    },
    relatedConcepts: [
        {
            concept: {
                name: "biblioref [EPUB-SSV]"
            },
            module: "EPUB"
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            "roletype",
            "widget",
            "command",
            "link"
        ]
    ]
};
var _default = docBibliorefRole;
exports.default = _default;

},{}],"3T9Zb":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var docChapterRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        "author"
    ],
    prohibitedProps: [],
    props: {
        "aria-disabled": null,
        "aria-errormessage": null,
        "aria-expanded": null,
        "aria-haspopup": null,
        "aria-invalid": null
    },
    relatedConcepts: [
        {
            concept: {
                name: "chapter [EPUB-SSV]"
            },
            module: "EPUB"
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            "roletype",
            "structure",
            "section",
            "landmark"
        ]
    ]
};
var _default = docChapterRole;
exports.default = _default;

},{}],"l6K6D":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var docColophonRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        "author"
    ],
    prohibitedProps: [],
    props: {
        "aria-disabled": null,
        "aria-errormessage": null,
        "aria-expanded": null,
        "aria-haspopup": null,
        "aria-invalid": null
    },
    relatedConcepts: [
        {
            concept: {
                name: "colophon [EPUB-SSV]"
            },
            module: "EPUB"
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            "roletype",
            "structure",
            "section"
        ]
    ]
};
var _default = docColophonRole;
exports.default = _default;

},{}],"4oYQq":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var docConclusionRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        "author"
    ],
    prohibitedProps: [],
    props: {
        "aria-disabled": null,
        "aria-errormessage": null,
        "aria-expanded": null,
        "aria-haspopup": null,
        "aria-invalid": null
    },
    relatedConcepts: [
        {
            concept: {
                name: "conclusion [EPUB-SSV]"
            },
            module: "EPUB"
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            "roletype",
            "structure",
            "section",
            "landmark"
        ]
    ]
};
var _default = docConclusionRole;
exports.default = _default;

},{}],"l3DMy":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var docCoverRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        "author"
    ],
    prohibitedProps: [],
    props: {
        "aria-disabled": null,
        "aria-errormessage": null,
        "aria-expanded": null,
        "aria-haspopup": null,
        "aria-invalid": null
    },
    relatedConcepts: [
        {
            concept: {
                name: "cover [EPUB-SSV]"
            },
            module: "EPUB"
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            "roletype",
            "structure",
            "section",
            "img"
        ]
    ]
};
var _default = docCoverRole;
exports.default = _default;

},{}],"hnwK9":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var docCreditRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        "author"
    ],
    prohibitedProps: [],
    props: {
        "aria-disabled": null,
        "aria-errormessage": null,
        "aria-expanded": null,
        "aria-haspopup": null,
        "aria-invalid": null
    },
    relatedConcepts: [
        {
            concept: {
                name: "credit [EPUB-SSV]"
            },
            module: "EPUB"
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            "roletype",
            "structure",
            "section"
        ]
    ]
};
var _default = docCreditRole;
exports.default = _default;

},{}],"lgh5S":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var docCreditsRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        "author"
    ],
    prohibitedProps: [],
    props: {
        "aria-disabled": null,
        "aria-errormessage": null,
        "aria-expanded": null,
        "aria-haspopup": null,
        "aria-invalid": null
    },
    relatedConcepts: [
        {
            concept: {
                name: "credits [EPUB-SSV]"
            },
            module: "EPUB"
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            "roletype",
            "structure",
            "section",
            "landmark"
        ]
    ]
};
var _default = docCreditsRole;
exports.default = _default;

},{}],"3iTjz":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var docDedicationRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        "author"
    ],
    prohibitedProps: [],
    props: {
        "aria-disabled": null,
        "aria-errormessage": null,
        "aria-expanded": null,
        "aria-haspopup": null,
        "aria-invalid": null
    },
    relatedConcepts: [
        {
            concept: {
                name: "dedication [EPUB-SSV]"
            },
            module: "EPUB"
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            "roletype",
            "structure",
            "section"
        ]
    ]
};
var _default = docDedicationRole;
exports.default = _default;

},{}],"gZbhJ":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var docEndnoteRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        "author"
    ],
    prohibitedProps: [],
    props: {
        "aria-disabled": null,
        "aria-errormessage": null,
        "aria-expanded": null,
        "aria-haspopup": null,
        "aria-invalid": null
    },
    relatedConcepts: [
        {
            concept: {
                name: "rearnote [EPUB-SSV]"
            },
            module: "EPUB"
        }
    ],
    requireContextRole: [
        "doc-endnotes"
    ],
    requiredContextRole: [
        "doc-endnotes"
    ],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            "roletype",
            "structure",
            "section",
            "listitem"
        ]
    ]
};
var _default = docEndnoteRole;
exports.default = _default;

},{}],"6GUJz":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var docEndnotesRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        "author"
    ],
    prohibitedProps: [],
    props: {
        "aria-disabled": null,
        "aria-errormessage": null,
        "aria-expanded": null,
        "aria-haspopup": null,
        "aria-invalid": null
    },
    relatedConcepts: [
        {
            concept: {
                name: "rearnotes [EPUB-SSV]"
            },
            module: "EPUB"
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [
        [
            "doc-endnote"
        ]
    ],
    requiredProps: {},
    superClass: [
        [
            "roletype",
            "structure",
            "section",
            "landmark"
        ]
    ]
};
var _default = docEndnotesRole;
exports.default = _default;

},{}],"dSi65":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var docEpigraphRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        "author"
    ],
    prohibitedProps: [],
    props: {
        "aria-disabled": null,
        "aria-errormessage": null,
        "aria-expanded": null,
        "aria-haspopup": null,
        "aria-invalid": null
    },
    relatedConcepts: [
        {
            concept: {
                name: "epigraph [EPUB-SSV]"
            },
            module: "EPUB"
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            "roletype",
            "structure",
            "section"
        ]
    ]
};
var _default = docEpigraphRole;
exports.default = _default;

},{}],"1Unxr":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var docEpilogueRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        "author"
    ],
    prohibitedProps: [],
    props: {
        "aria-disabled": null,
        "aria-errormessage": null,
        "aria-expanded": null,
        "aria-haspopup": null,
        "aria-invalid": null
    },
    relatedConcepts: [
        {
            concept: {
                name: "epilogue [EPUB-SSV]"
            },
            module: "EPUB"
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            "roletype",
            "structure",
            "section",
            "landmark"
        ]
    ]
};
var _default = docEpilogueRole;
exports.default = _default;

},{}],"1QYws":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var docErrataRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        "author"
    ],
    prohibitedProps: [],
    props: {
        "aria-disabled": null,
        "aria-errormessage": null,
        "aria-expanded": null,
        "aria-haspopup": null,
        "aria-invalid": null
    },
    relatedConcepts: [
        {
            concept: {
                name: "errata [EPUB-SSV]"
            },
            module: "EPUB"
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            "roletype",
            "structure",
            "section",
            "landmark"
        ]
    ]
};
var _default = docErrataRole;
exports.default = _default;

},{}],"50Vnt":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var docExampleRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        "author"
    ],
    prohibitedProps: [],
    props: {
        "aria-disabled": null,
        "aria-errormessage": null,
        "aria-expanded": null,
        "aria-haspopup": null,
        "aria-invalid": null
    },
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            "roletype",
            "structure",
            "section"
        ]
    ]
};
var _default = docExampleRole;
exports.default = _default;

},{}],"7hO4l":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var docFootnoteRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        "author"
    ],
    prohibitedProps: [],
    props: {
        "aria-disabled": null,
        "aria-errormessage": null,
        "aria-expanded": null,
        "aria-haspopup": null,
        "aria-invalid": null
    },
    relatedConcepts: [
        {
            concept: {
                name: "footnote [EPUB-SSV]"
            },
            module: "EPUB"
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            "roletype",
            "structure",
            "section"
        ]
    ]
};
var _default = docFootnoteRole;
exports.default = _default;

},{}],"lOucx":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var docForewordRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        "author"
    ],
    prohibitedProps: [],
    props: {
        "aria-disabled": null,
        "aria-errormessage": null,
        "aria-expanded": null,
        "aria-haspopup": null,
        "aria-invalid": null
    },
    relatedConcepts: [
        {
            concept: {
                name: "foreword [EPUB-SSV]"
            },
            module: "EPUB"
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            "roletype",
            "structure",
            "section",
            "landmark"
        ]
    ]
};
var _default = docForewordRole;
exports.default = _default;

},{}],"1t3Fc":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var docGlossaryRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        "author"
    ],
    prohibitedProps: [],
    props: {
        "aria-disabled": null,
        "aria-errormessage": null,
        "aria-expanded": null,
        "aria-haspopup": null,
        "aria-invalid": null
    },
    relatedConcepts: [
        {
            concept: {
                name: "glossary [EPUB-SSV]"
            },
            module: "EPUB"
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [
        [
            "definition"
        ],
        [
            "term"
        ]
    ],
    requiredProps: {},
    superClass: [
        [
            "roletype",
            "structure",
            "section",
            "landmark"
        ]
    ]
};
var _default = docGlossaryRole;
exports.default = _default;

},{}],"kVWQT":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var docGlossrefRole = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        "author",
        "contents"
    ],
    prohibitedProps: [],
    props: {
        "aria-errormessage": null,
        "aria-invalid": null
    },
    relatedConcepts: [
        {
            concept: {
                name: "glossref [EPUB-SSV]"
            },
            module: "EPUB"
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            "roletype",
            "widget",
            "command",
            "link"
        ]
    ]
};
var _default = docGlossrefRole;
exports.default = _default;

},{}],"9J2JF":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var docIndexRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        "author"
    ],
    prohibitedProps: [],
    props: {
        "aria-disabled": null,
        "aria-errormessage": null,
        "aria-expanded": null,
        "aria-haspopup": null,
        "aria-invalid": null
    },
    relatedConcepts: [
        {
            concept: {
                name: "index [EPUB-SSV]"
            },
            module: "EPUB"
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            "roletype",
            "structure",
            "section",
            "landmark",
            "navigation"
        ]
    ]
};
var _default = docIndexRole;
exports.default = _default;

},{}],"g3GhK":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var docIntroductionRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        "author"
    ],
    prohibitedProps: [],
    props: {
        "aria-disabled": null,
        "aria-errormessage": null,
        "aria-expanded": null,
        "aria-haspopup": null,
        "aria-invalid": null
    },
    relatedConcepts: [
        {
            concept: {
                name: "introduction [EPUB-SSV]"
            },
            module: "EPUB"
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            "roletype",
            "structure",
            "section",
            "landmark"
        ]
    ]
};
var _default = docIntroductionRole;
exports.default = _default;

},{}],"3Jlq2":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var docNoterefRole = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        "author",
        "contents"
    ],
    prohibitedProps: [],
    props: {
        "aria-errormessage": null,
        "aria-invalid": null
    },
    relatedConcepts: [
        {
            concept: {
                name: "noteref [EPUB-SSV]"
            },
            module: "EPUB"
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            "roletype",
            "widget",
            "command",
            "link"
        ]
    ]
};
var _default = docNoterefRole;
exports.default = _default;

},{}],"27mEX":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var docNoticeRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        "author"
    ],
    prohibitedProps: [],
    props: {
        "aria-disabled": null,
        "aria-errormessage": null,
        "aria-expanded": null,
        "aria-haspopup": null,
        "aria-invalid": null
    },
    relatedConcepts: [
        {
            concept: {
                name: "notice [EPUB-SSV]"
            },
            module: "EPUB"
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            "roletype",
            "structure",
            "section",
            "note"
        ]
    ]
};
var _default = docNoticeRole;
exports.default = _default;

},{}],"aN9hl":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var docPagebreakRole = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: true,
    nameFrom: [
        "author"
    ],
    prohibitedProps: [],
    props: {
        "aria-errormessage": null,
        "aria-expanded": null,
        "aria-haspopup": null,
        "aria-invalid": null
    },
    relatedConcepts: [
        {
            concept: {
                name: "pagebreak [EPUB-SSV]"
            },
            module: "EPUB"
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            "roletype",
            "structure",
            "separator"
        ]
    ]
};
var _default = docPagebreakRole;
exports.default = _default;

},{}],"94P1G":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var docPagelistRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        "author"
    ],
    prohibitedProps: [],
    props: {
        "aria-disabled": null,
        "aria-errormessage": null,
        "aria-expanded": null,
        "aria-haspopup": null,
        "aria-invalid": null
    },
    relatedConcepts: [
        {
            concept: {
                name: "page-list [EPUB-SSV]"
            },
            module: "EPUB"
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            "roletype",
            "structure",
            "section",
            "landmark",
            "navigation"
        ]
    ]
};
var _default = docPagelistRole;
exports.default = _default;

},{}],"91lRr":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var docPartRole = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        "author"
    ],
    prohibitedProps: [],
    props: {
        "aria-disabled": null,
        "aria-errormessage": null,
        "aria-expanded": null,
        "aria-haspopup": null,
        "aria-invalid": null
    },
    relatedConcepts: [
        {
            concept: {
                name: "part [EPUB-SSV]"
            },
            module: "EPUB"
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            "roletype",
            "structure",
            "section",
            "landmark"
        ]
    ]
};
var _default = docPartRole;
exports.default = _default;

},{}],"hug2D":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var docPrefaceRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        "author"
    ],
    prohibitedProps: [],
    props: {
        "aria-disabled": null,
        "aria-errormessage": null,
        "aria-expanded": null,
        "aria-haspopup": null,
        "aria-invalid": null
    },
    relatedConcepts: [
        {
            concept: {
                name: "preface [EPUB-SSV]"
            },
            module: "EPUB"
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            "roletype",
            "structure",
            "section",
            "landmark"
        ]
    ]
};
var _default = docPrefaceRole;
exports.default = _default;

},{}],"8t3je":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var docPrologueRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        "author"
    ],
    prohibitedProps: [],
    props: {
        "aria-disabled": null,
        "aria-errormessage": null,
        "aria-expanded": null,
        "aria-haspopup": null,
        "aria-invalid": null
    },
    relatedConcepts: [
        {
            concept: {
                name: "prologue [EPUB-SSV]"
            },
            module: "EPUB"
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            "roletype",
            "structure",
            "section",
            "landmark"
        ]
    ]
};
var _default = docPrologueRole;
exports.default = _default;

},{}],"fNvEQ":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var docPullquoteRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        "author"
    ],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [
        {
            concept: {
                name: "pullquote [EPUB-SSV]"
            },
            module: "EPUB"
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            "none"
        ]
    ]
};
var _default = docPullquoteRole;
exports.default = _default;

},{}],"jHmnA":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var docQnaRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        "author"
    ],
    prohibitedProps: [],
    props: {
        "aria-disabled": null,
        "aria-errormessage": null,
        "aria-expanded": null,
        "aria-haspopup": null,
        "aria-invalid": null
    },
    relatedConcepts: [
        {
            concept: {
                name: "qna [EPUB-SSV]"
            },
            module: "EPUB"
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            "roletype",
            "structure",
            "section"
        ]
    ]
};
var _default = docQnaRole;
exports.default = _default;

},{}],"704GY":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var docSubtitleRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        "author"
    ],
    prohibitedProps: [],
    props: {
        "aria-disabled": null,
        "aria-errormessage": null,
        "aria-expanded": null,
        "aria-haspopup": null,
        "aria-invalid": null
    },
    relatedConcepts: [
        {
            concept: {
                name: "subtitle [EPUB-SSV]"
            },
            module: "EPUB"
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            "roletype",
            "structure",
            "sectionhead"
        ]
    ]
};
var _default = docSubtitleRole;
exports.default = _default;

},{}],"12Xpy":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var docTipRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        "author"
    ],
    prohibitedProps: [],
    props: {
        "aria-disabled": null,
        "aria-errormessage": null,
        "aria-expanded": null,
        "aria-haspopup": null,
        "aria-invalid": null
    },
    relatedConcepts: [
        {
            concept: {
                name: "help [EPUB-SSV]"
            },
            module: "EPUB"
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            "roletype",
            "structure",
            "section",
            "note"
        ]
    ]
};
var _default = docTipRole;
exports.default = _default;

},{}],"dS4Sn":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var docTocRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        "author"
    ],
    prohibitedProps: [],
    props: {
        "aria-disabled": null,
        "aria-errormessage": null,
        "aria-expanded": null,
        "aria-haspopup": null,
        "aria-invalid": null
    },
    relatedConcepts: [
        {
            concept: {
                name: "toc [EPUB-SSV]"
            },
            module: "EPUB"
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            "roletype",
            "structure",
            "section",
            "landmark",
            "navigation"
        ]
    ]
};
var _default = docTocRole;
exports.default = _default;

},{}],"b5uJJ":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _graphicsDocumentRole = _interopRequireDefault(require("99112730cf9db2db"));
var _graphicsObjectRole = _interopRequireDefault(require("4c17dd14f3c033c"));
var _graphicsSymbolRole = _interopRequireDefault(require("5c479b21fecf143c"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var ariaGraphicsRoles = [
    [
        "graphics-document",
        _graphicsDocumentRole.default
    ],
    [
        "graphics-object",
        _graphicsObjectRole.default
    ],
    [
        "graphics-symbol",
        _graphicsSymbolRole.default
    ]
];
var _default = ariaGraphicsRoles;
exports.default = _default;

},{"99112730cf9db2db":"1TgU3","4c17dd14f3c033c":"9E5ZZ","5c479b21fecf143c":"8qs72"}],"1TgU3":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var graphicsDocumentRole = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        "author"
    ],
    prohibitedProps: [],
    props: {
        "aria-disabled": null,
        "aria-errormessage": null,
        "aria-expanded": null,
        "aria-haspopup": null,
        "aria-invalid": null
    },
    relatedConcepts: [
        {
            module: "GRAPHICS",
            concept: {
                name: "graphics-object"
            }
        },
        {
            module: "ARIA",
            concept: {
                name: "img"
            }
        },
        {
            module: "ARIA",
            concept: {
                name: "article"
            }
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            "roletype",
            "structure",
            "document"
        ]
    ]
};
var _default = graphicsDocumentRole;
exports.default = _default;

},{}],"9E5ZZ":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var graphicsObjectRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        "author",
        "contents"
    ],
    prohibitedProps: [],
    props: {
        "aria-errormessage": null,
        "aria-expanded": null,
        "aria-haspopup": null,
        "aria-invalid": null
    },
    relatedConcepts: [
        {
            module: "GRAPHICS",
            concept: {
                name: "graphics-document"
            }
        },
        {
            module: "ARIA",
            concept: {
                name: "group"
            }
        },
        {
            module: "ARIA",
            concept: {
                name: "img"
            }
        },
        {
            module: "GRAPHICS",
            concept: {
                name: "graphics-symbol"
            }
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            "roletype",
            "structure",
            "section",
            "group"
        ]
    ]
};
var _default = graphicsObjectRole;
exports.default = _default;

},{}],"8qs72":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var graphicsSymbolRole = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: true,
    nameFrom: [
        "author"
    ],
    prohibitedProps: [],
    props: {
        "aria-disabled": null,
        "aria-errormessage": null,
        "aria-expanded": null,
        "aria-haspopup": null,
        "aria-invalid": null
    },
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            "roletype",
            "structure",
            "section",
            "img"
        ]
    ]
};
var _default = graphicsSymbolRole;
exports.default = _default;

},{}],"cXXFm":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _deepEqual = _interopRequireDefault(require("4b0412299e5d1701"));
var _iterationDecorator = _interopRequireDefault(require("daae0b62aaf42d62"));
var _rolesMap = _interopRequireDefault(require("a5d89eeba7a0cc2c"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (!it) {
        if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e2) {
                    throw _e2;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = it.call(o);
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e3) {
            didErr = true;
            err = _e3;
        },
        f: function f() {
            try {
                if (!normalCompletion && it.return != null) it.return();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var elementRoles = [];
var keys = _rolesMap.default.keys();
for(var i = 0; i < keys.length; i++){
    var key = keys[i];
    var role = _rolesMap.default.get(key);
    if (role) {
        var concepts = [].concat(role.baseConcepts, role.relatedConcepts);
        for(var k = 0; k < concepts.length; k++){
            var relation = concepts[k];
            if (relation.module === "HTML") {
                var concept = relation.concept;
                if (concept) (function() {
                    var conceptStr = JSON.stringify(concept);
                    var elementRoleRelation = elementRoles.find(function(relation) {
                        return JSON.stringify(relation[0]) === conceptStr;
                    });
                    var roles = void 0;
                    if (elementRoleRelation) roles = elementRoleRelation[1];
                    else roles = [];
                    var isUnique = true;
                    for(var _i = 0; _i < roles.length; _i++)if (roles[_i] === key) {
                        isUnique = false;
                        break;
                    }
                    if (isUnique) roles.push(key);
                    elementRoles.push([
                        concept,
                        roles
                    ]);
                })();
            }
        }
    }
}
var elementRoleMap = {
    entries: function entries() {
        return elementRoles;
    },
    forEach: function forEach(fn) {
        var thisArg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        var _iterator = _createForOfIteratorHelper(elementRoles), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var _step$value = _slicedToArray(_step.value, 2), _key = _step$value[0], values = _step$value[1];
                fn.call(thisArg, values, _key, elementRoles);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
    },
    get: function get(key) {
        var item = elementRoles.find(function(tuple) {
            return (0, _deepEqual.default)(key, tuple[0]);
        });
        return item && item[1];
    },
    has: function has(key) {
        return !!elementRoleMap.get(key);
    },
    keys: function keys() {
        return elementRoles.map(function(_ref) {
            var _ref2 = _slicedToArray(_ref, 1), key = _ref2[0];
            return key;
        });
    },
    values: function values() {
        return elementRoles.map(function(_ref3) {
            var _ref4 = _slicedToArray(_ref3, 2), values = _ref4[1];
            return values;
        });
    }
};
var _default = (0, _iterationDecorator.default)(elementRoleMap, elementRoleMap.entries());
exports.default = _default;

},{"4b0412299e5d1701":"5EWpv","daae0b62aaf42d62":"doGnk","a5d89eeba7a0cc2c":"4vhJn"}],"5EWpv":[function(require,module,exports) {
"use strict";
var assign = require("66d7c2a795c02b5");
var callBound = require("2175dac8ae9ce911");
var flags = require("f60a9f85e965c8db");
var GetIntrinsic = require("f00f9b3fafe92103");
var getIterator = require("b463b0c7f7d7cf72");
var getSideChannel = require("1f5ab288d9f4acc3");
var is = require("4507ab82af52838e");
var isArguments = require("35e168c0757d86dc");
var isArray = require("a8ef0ae6409c8be7");
var isArrayBuffer = require("d4406e33036431eb");
var isDate = require("51869b400334d972");
var isRegex = require("e39d986f72f520d7");
var isSharedArrayBuffer = require("73e5c64ba4b1a19a");
var objectKeys = require("69b25d5c5741b949");
var whichBoxedPrimitive = require("d518d261984adf0e");
var whichCollection = require("72d15e59e8c459c4");
var whichTypedArray = require("e39d85a76a9fff43");
var byteLength = require("75f7ec9931b5a132");
var sabByteLength = callBound("SharedArrayBuffer.prototype.byteLength", true);
var $getTime = callBound("Date.prototype.getTime");
var gPO = Object.getPrototypeOf;
var $objToString = callBound("Object.prototype.toString");
var $Set = GetIntrinsic("%Set%", true);
var $mapHas = callBound("Map.prototype.has", true);
var $mapGet = callBound("Map.prototype.get", true);
var $mapSize = callBound("Map.prototype.size", true);
var $setAdd = callBound("Set.prototype.add", true);
var $setDelete = callBound("Set.prototype.delete", true);
var $setHas = callBound("Set.prototype.has", true);
var $setSize = callBound("Set.prototype.size", true);
// taken from https://github.com/browserify/commonjs-assert/blob/bba838e9ba9e28edf3127ce6974624208502f6bc/internal/util/comparisons.js#L401-L414
function setHasEqualElement(set, val1, opts, channel) {
    var i = getIterator(set);
    var result;
    while((result = i.next()) && !result.done)if (internalDeepEqual(val1, result.value, opts, channel)) {
        // Remove the matching element to make sure we do not check that again.
        $setDelete(set, result.value);
        return true;
    }
    return false;
}
// taken from https://github.com/browserify/commonjs-assert/blob/bba838e9ba9e28edf3127ce6974624208502f6bc/internal/util/comparisons.js#L416-L439
function findLooseMatchingPrimitives(prim) {
    if (typeof prim === "undefined") return null;
    if (typeof prim === "object") return void 0;
    if (typeof prim === "symbol") return false;
    if (typeof prim === "string" || typeof prim === "number") // Loose equal entries exist only if the string is possible to convert to a regular number and not NaN.
    return +prim === +prim; // eslint-disable-line no-implicit-coercion
    return true;
}
// taken from https://github.com/browserify/commonjs-assert/blob/bba838e9ba9e28edf3127ce6974624208502f6bc/internal/util/comparisons.js#L449-L460
function mapMightHaveLoosePrim(a, b, prim, item, opts, channel) {
    var altValue = findLooseMatchingPrimitives(prim);
    if (altValue != null) return altValue;
    var curB = $mapGet(b, altValue);
    var looseOpts = assign({}, opts, {
        strict: false
    });
    if (typeof curB === "undefined" && !$mapHas(b, altValue) || !internalDeepEqual(item, curB, looseOpts, channel)) return false;
    // eslint-disable-next-line no-use-before-define
    return !$mapHas(a, altValue) && internalDeepEqual(item, curB, looseOpts, channel);
}
// taken from https://github.com/browserify/commonjs-assert/blob/bba838e9ba9e28edf3127ce6974624208502f6bc/internal/util/comparisons.js#L441-L447
function setMightHaveLoosePrim(a, b, prim) {
    var altValue = findLooseMatchingPrimitives(prim);
    if (altValue != null) return altValue;
    return $setHas(b, altValue) && !$setHas(a, altValue);
}
// taken from https://github.com/browserify/commonjs-assert/blob/bba838e9ba9e28edf3127ce6974624208502f6bc/internal/util/comparisons.js#L518-L533
function mapHasEqualEntry(set, map, key1, item1, opts, channel) {
    var i = getIterator(set);
    var result;
    var key2;
    while((result = i.next()) && !result.done){
        key2 = result.value;
        if (// eslint-disable-next-line no-use-before-define
        internalDeepEqual(key1, key2, opts, channel) && internalDeepEqual(item1, $mapGet(map, key2), opts, channel)) {
            $setDelete(set, key2);
            return true;
        }
    }
    return false;
}
function internalDeepEqual(actual, expected, options, channel) {
    var opts = options || {};
    // 7.1. All identical values are equivalent, as determined by ===.
    if (opts.strict ? is(actual, expected) : actual === expected) return true;
    var actualBoxed = whichBoxedPrimitive(actual);
    var expectedBoxed = whichBoxedPrimitive(expected);
    if (actualBoxed !== expectedBoxed) return false;
    // 7.3. Other pairs that do not both pass typeof value == 'object', equivalence is determined by ==.
    if (!actual || !expected || typeof actual !== "object" && typeof expected !== "object") return opts.strict ? is(actual, expected) : actual == expected; // eslint-disable-line eqeqeq
    /*
   * 7.4. For all other Object pairs, including Array objects, equivalence is
   * determined by having the same number of owned properties (as verified
   * with Object.prototype.hasOwnProperty.call), the same set of keys
   * (although not necessarily the same order), equivalent values for every
   * corresponding key, and an identical 'prototype' property. Note: this
   * accounts for both named and indexed properties on Arrays.
   */ // see https://github.com/nodejs/node/commit/d3aafd02efd3a403d646a3044adcf14e63a88d32 for memos/channel inspiration
    var hasActual = channel.has(actual);
    var hasExpected = channel.has(expected);
    var sentinel;
    if (hasActual && hasExpected) {
        if (channel.get(actual) === channel.get(expected)) return true;
    } else sentinel = {};
    if (!hasActual) channel.set(actual, sentinel);
    if (!hasExpected) channel.set(expected, sentinel);
    // eslint-disable-next-line no-use-before-define
    return objEquiv(actual, expected, opts, channel);
}
function isBuffer(x) {
    if (!x || typeof x !== "object" || typeof x.length !== "number") return false;
    if (typeof x.copy !== "function" || typeof x.slice !== "function") return false;
    if (x.length > 0 && typeof x[0] !== "number") return false;
    return !!(x.constructor && x.constructor.isBuffer && x.constructor.isBuffer(x));
}
function setEquiv(a, b, opts, channel) {
    if ($setSize(a) !== $setSize(b)) return false;
    var iA = getIterator(a);
    var iB = getIterator(b);
    var resultA;
    var resultB;
    var set;
    while((resultA = iA.next()) && !resultA.done){
        if (resultA.value && typeof resultA.value === "object") {
            if (!set) set = new $Set();
            $setAdd(set, resultA.value);
        } else if (!$setHas(b, resultA.value)) {
            if (opts.strict) return false;
            if (!setMightHaveLoosePrim(a, b, resultA.value)) return false;
            if (!set) set = new $Set();
            $setAdd(set, resultA.value);
        }
    }
    if (set) {
        while((resultB = iB.next()) && !resultB.done){
            // We have to check if a primitive value is already matching and only if it's not, go hunting for it.
            if (resultB.value && typeof resultB.value === "object") {
                if (!setHasEqualElement(set, resultB.value, opts.strict, channel)) return false;
            } else if (!opts.strict && !$setHas(a, resultB.value) && !setHasEqualElement(set, resultB.value, opts.strict, channel)) return false;
        }
        return $setSize(set) === 0;
    }
    return true;
}
function mapEquiv(a, b, opts, channel) {
    if ($mapSize(a) !== $mapSize(b)) return false;
    var iA = getIterator(a);
    var iB = getIterator(b);
    var resultA;
    var resultB;
    var set;
    var key;
    var item1;
    var item2;
    while((resultA = iA.next()) && !resultA.done){
        key = resultA.value[0];
        item1 = resultA.value[1];
        if (key && typeof key === "object") {
            if (!set) set = new $Set();
            $setAdd(set, key);
        } else {
            item2 = $mapGet(b, key);
            if (typeof item2 === "undefined" && !$mapHas(b, key) || !internalDeepEqual(item1, item2, opts, channel)) {
                if (opts.strict) return false;
                if (!mapMightHaveLoosePrim(a, b, key, item1, opts, channel)) return false;
                if (!set) set = new $Set();
                $setAdd(set, key);
            }
        }
    }
    if (set) {
        while((resultB = iB.next()) && !resultB.done){
            key = resultB.value[0];
            item2 = resultB.value[1];
            if (key && typeof key === "object") {
                if (!mapHasEqualEntry(set, a, key, item2, opts, channel)) return false;
            } else if (!opts.strict && (!a.has(key) || !internalDeepEqual($mapGet(a, key), item2, opts, channel)) && !mapHasEqualEntry(set, a, key, item2, assign({}, opts, {
                strict: false
            }), channel)) return false;
        }
        return $setSize(set) === 0;
    }
    return true;
}
function objEquiv(a, b, opts, channel) {
    /* eslint max-statements: [2, 100], max-lines-per-function: [2, 120], max-depth: [2, 5], max-lines: [2, 400] */ var i, key;
    if (typeof a !== typeof b) return false;
    if (a == null || b == null) return false;
    if ($objToString(a) !== $objToString(b)) return false;
    if (isArguments(a) !== isArguments(b)) return false;
    var aIsArray = isArray(a);
    var bIsArray = isArray(b);
    if (aIsArray !== bIsArray) return false;
    // TODO: replace when a cross-realm brand check is available
    var aIsError = a instanceof Error;
    var bIsError = b instanceof Error;
    if (aIsError !== bIsError) return false;
    if (aIsError || bIsError) {
        if (a.name !== b.name || a.message !== b.message) return false;
    }
    var aIsRegex = isRegex(a);
    var bIsRegex = isRegex(b);
    if (aIsRegex !== bIsRegex) return false;
    if ((aIsRegex || bIsRegex) && (a.source !== b.source || flags(a) !== flags(b))) return false;
    var aIsDate = isDate(a);
    var bIsDate = isDate(b);
    if (aIsDate !== bIsDate) return false;
    if (aIsDate || bIsDate) {
        if ($getTime(a) !== $getTime(b)) return false;
    }
    if (opts.strict && gPO && gPO(a) !== gPO(b)) return false;
    var aWhich = whichTypedArray(a);
    var bWhich = whichTypedArray(b);
    if ((aWhich || bWhich) && aWhich !== bWhich) return false;
    var aIsBuffer = isBuffer(a);
    var bIsBuffer = isBuffer(b);
    if (aIsBuffer !== bIsBuffer) return false;
    if (aIsBuffer || bIsBuffer) {
        if (a.length !== b.length) return false;
        for(i = 0; i < a.length; i++){
            if (a[i] !== b[i]) return false;
        }
        return true;
    }
    var aIsArrayBuffer = isArrayBuffer(a);
    var bIsArrayBuffer = isArrayBuffer(b);
    if (aIsArrayBuffer !== bIsArrayBuffer) return false;
    if (aIsArrayBuffer || bIsArrayBuffer) {
        if (byteLength(a) !== byteLength(b)) return false;
        return typeof Uint8Array === "function" && internalDeepEqual(new Uint8Array(a), new Uint8Array(b), opts, channel);
    }
    var aIsSAB = isSharedArrayBuffer(a);
    var bIsSAB = isSharedArrayBuffer(b);
    if (aIsSAB !== bIsSAB) return false;
    if (aIsSAB || bIsSAB) {
        if (sabByteLength(a) !== sabByteLength(b)) return false;
        return typeof Uint8Array === "function" && internalDeepEqual(new Uint8Array(a), new Uint8Array(b), opts, channel);
    }
    if (typeof a !== typeof b) return false;
    var ka = objectKeys(a);
    var kb = objectKeys(b);
    // having the same number of owned properties (keys incorporates hasOwnProperty)
    if (ka.length !== kb.length) return false;
    // the same set of keys (although not necessarily the same order),
    ka.sort();
    kb.sort();
    // ~~~cheap key test
    for(i = ka.length - 1; i >= 0; i--){
        if (ka[i] != kb[i]) return false;
         // eslint-disable-line eqeqeq
    }
    // equivalent values for every corresponding key, and ~~~possibly expensive deep test
    for(i = ka.length - 1; i >= 0; i--){
        key = ka[i];
        if (!internalDeepEqual(a[key], b[key], opts, channel)) return false;
    }
    var aCollection = whichCollection(a);
    var bCollection = whichCollection(b);
    if (aCollection !== bCollection) return false;
    if (aCollection === "Set" || bCollection === "Set") return setEquiv(a, b, opts, channel);
    if (aCollection === "Map") return mapEquiv(a, b, opts, channel);
    return true;
}
module.exports = function deepEqual(a, b, opts) {
    return internalDeepEqual(a, b, opts, getSideChannel());
};

},{"66d7c2a795c02b5":"gDZ8E","2175dac8ae9ce911":"kSjLP","f60a9f85e965c8db":"eOw7z","f00f9b3fafe92103":"lUbTP","b463b0c7f7d7cf72":"jP84s","1f5ab288d9f4acc3":"l3w67","4507ab82af52838e":"jwM6R","35e168c0757d86dc":"3ssGk","a8ef0ae6409c8be7":"bnrni","d4406e33036431eb":"8G92T","51869b400334d972":"3KJ9j","e39d986f72f520d7":"34grm","73e5c64ba4b1a19a":"ftIEQ","69b25d5c5741b949":"9FqgX","d518d261984adf0e":"eU8hw","72d15e59e8c459c4":"jKiEg","e39d85a76a9fff43":"8TYZK","75f7ec9931b5a132":"gSHJL"}],"gDZ8E":[function(require,module,exports) {
"use strict";
var defineProperties = require("31006c3cfe40af17");
var callBind = require("4bd644f8ee56850a");
var implementation = require("7eb15e28e3121047");
var getPolyfill = require("741d58b7433c3ec2");
var shim = require("b106e2c495003b2a");
var polyfill = callBind.apply(getPolyfill());
// eslint-disable-next-line no-unused-vars
var bound = function assign(target, source1) {
    return polyfill(Object, arguments);
};
defineProperties(bound, {
    getPolyfill: getPolyfill,
    implementation: implementation,
    shim: shim
});
module.exports = bound;

},{"31006c3cfe40af17":"lmPVn","4bd644f8ee56850a":"1LGPW","7eb15e28e3121047":"dH3bg","741d58b7433c3ec2":"S2JpI","b106e2c495003b2a":"13FFC"}],"lmPVn":[function(require,module,exports) {
"use strict";
var keys = require("7ff177585d1618f0");
var hasSymbols = typeof Symbol === "function" && typeof Symbol("foo") === "symbol";
var toStr = Object.prototype.toString;
var concat = Array.prototype.concat;
var origDefineProperty = Object.defineProperty;
var isFunction = function(fn) {
    return typeof fn === "function" && toStr.call(fn) === "[object Function]";
};
var hasPropertyDescriptors = require("c52d62086511583f")();
var supportsDescriptors = origDefineProperty && hasPropertyDescriptors;
var defineProperty = function(object, name, value, predicate) {
    if (name in object && (!isFunction(predicate) || !predicate())) return;
    if (supportsDescriptors) origDefineProperty(object, name, {
        configurable: true,
        enumerable: false,
        value: value,
        writable: true
    });
    else object[name] = value; // eslint-disable-line no-param-reassign
};
var defineProperties = function(object, map) {
    var predicates = arguments.length > 2 ? arguments[2] : {};
    var props = keys(map);
    if (hasSymbols) props = concat.call(props, Object.getOwnPropertySymbols(map));
    for(var i = 0; i < props.length; i += 1)defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
};
defineProperties.supportsDescriptors = !!supportsDescriptors;
module.exports = defineProperties;

},{"7ff177585d1618f0":"9FqgX","c52d62086511583f":"lvtdS"}],"9FqgX":[function(require,module,exports) {
"use strict";
var slice = Array.prototype.slice;
var isArgs = require("93e8460f624c96f4");
var origKeys = Object.keys;
var keysShim = origKeys ? function keys(o) {
    return origKeys(o);
} : require("344bb0d7b2568e03");
var originalKeys = Object.keys;
keysShim.shim = function shimObjectKeys() {
    if (Object.keys) {
        var keysWorksWithArguments = function() {
            // Safari 5.0 bug
            var args = Object.keys(arguments);
            return args && args.length === arguments.length;
        }(1, 2);
        if (!keysWorksWithArguments) Object.keys = function keys(object) {
            if (isArgs(object)) return originalKeys(slice.call(object));
            return originalKeys(object);
        };
    } else Object.keys = keysShim;
    return Object.keys || keysShim;
};
module.exports = keysShim;

},{"93e8460f624c96f4":"2jDBt","344bb0d7b2568e03":"053ud"}],"2jDBt":[function(require,module,exports) {
"use strict";
var toStr = Object.prototype.toString;
module.exports = function isArguments(value) {
    var str = toStr.call(value);
    var isArgs = str === "[object Arguments]";
    if (!isArgs) isArgs = str !== "[object Array]" && value !== null && typeof value === "object" && typeof value.length === "number" && value.length >= 0 && toStr.call(value.callee) === "[object Function]";
    return isArgs;
};

},{}],"053ud":[function(require,module,exports) {
"use strict";
var keysShim;
if (!Object.keys) {
    // modified from https://github.com/es-shims/es5-shim
    var has = Object.prototype.hasOwnProperty;
    var toStr = Object.prototype.toString;
    var isArgs = require("b0d8c8b84be91ffd"); // eslint-disable-line global-require
    var isEnumerable = Object.prototype.propertyIsEnumerable;
    var hasDontEnumBug = !isEnumerable.call({
        toString: null
    }, "toString");
    var hasProtoEnumBug = isEnumerable.call(function() {}, "prototype");
    var dontEnums = [
        "toString",
        "toLocaleString",
        "valueOf",
        "hasOwnProperty",
        "isPrototypeOf",
        "propertyIsEnumerable",
        "constructor"
    ];
    var equalsConstructorPrototype = function(o) {
        var ctor = o.constructor;
        return ctor && ctor.prototype === o;
    };
    var excludedKeys = {
        $applicationCache: true,
        $console: true,
        $external: true,
        $frame: true,
        $frameElement: true,
        $frames: true,
        $innerHeight: true,
        $innerWidth: true,
        $onmozfullscreenchange: true,
        $onmozfullscreenerror: true,
        $outerHeight: true,
        $outerWidth: true,
        $pageXOffset: true,
        $pageYOffset: true,
        $parent: true,
        $scrollLeft: true,
        $scrollTop: true,
        $scrollX: true,
        $scrollY: true,
        $self: true,
        $webkitIndexedDB: true,
        $webkitStorageInfo: true,
        $window: true
    };
    var hasAutomationEqualityBug = function() {
        /* global window */ if (typeof window === "undefined") return false;
        for(var k in window)try {
            if (!excludedKeys["$" + k] && has.call(window, k) && window[k] !== null && typeof window[k] === "object") try {
                equalsConstructorPrototype(window[k]);
            } catch (e) {
                return true;
            }
        } catch (e) {
            return true;
        }
        return false;
    }();
    var equalsConstructorPrototypeIfNotBuggy = function(o) {
        /* global window */ if (typeof window === "undefined" || !hasAutomationEqualityBug) return equalsConstructorPrototype(o);
        try {
            return equalsConstructorPrototype(o);
        } catch (e) {
            return false;
        }
    };
    keysShim = function keys(object) {
        var isObject = object !== null && typeof object === "object";
        var isFunction = toStr.call(object) === "[object Function]";
        var isArguments = isArgs(object);
        var isString = isObject && toStr.call(object) === "[object String]";
        var theKeys = [];
        if (!isObject && !isFunction && !isArguments) throw new TypeError("Object.keys called on a non-object");
        var skipProto = hasProtoEnumBug && isFunction;
        if (isString && object.length > 0 && !has.call(object, 0)) for(var i = 0; i < object.length; ++i)theKeys.push(String(i));
        if (isArguments && object.length > 0) for(var j = 0; j < object.length; ++j)theKeys.push(String(j));
        else {
            for(var name in object)if (!(skipProto && name === "prototype") && has.call(object, name)) theKeys.push(String(name));
        }
        if (hasDontEnumBug) {
            var skipConstructor = equalsConstructorPrototypeIfNotBuggy(object);
            for(var k = 0; k < dontEnums.length; ++k)if (!(skipConstructor && dontEnums[k] === "constructor") && has.call(object, dontEnums[k])) theKeys.push(dontEnums[k]);
        }
        return theKeys;
    };
}
module.exports = keysShim;

},{"b0d8c8b84be91ffd":"2jDBt"}],"lvtdS":[function(require,module,exports) {
"use strict";
var GetIntrinsic = require("b0bf8b8435d3abc");
var $defineProperty = GetIntrinsic("%Object.defineProperty%", true);
var hasPropertyDescriptors = function hasPropertyDescriptors() {
    if ($defineProperty) try {
        $defineProperty({}, "a", {
            value: 1
        });
        return true;
    } catch (e) {
        // IE 8 has a broken defineProperty
        return false;
    }
    return false;
};
hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
    // node v0.6 has a bug where array lengths can be Set but not Defined
    if (!hasPropertyDescriptors()) return null;
    try {
        return $defineProperty([], "length", {
            value: 1
        }).length !== 1;
    } catch (e) {
        // In Firefox 4-22, defining length on an array throws an exception.
        return true;
    }
};
module.exports = hasPropertyDescriptors;

},{"b0bf8b8435d3abc":"fTq9o"}],"dH3bg":[function(require,module,exports) {
"use strict";
// modified from https://github.com/es-shims/es6-shim
var objectKeys = require("334c0bea01e613e6");
var hasSymbols = require("1964e25feb5e87a1")();
var callBound = require("6fb85b5b56dcab21");
var toObject = Object;
var $push = callBound("Array.prototype.push");
var $propIsEnumerable = callBound("Object.prototype.propertyIsEnumerable");
var originalGetSymbols = hasSymbols ? Object.getOwnPropertySymbols : null;
// eslint-disable-next-line no-unused-vars
module.exports = function assign(target, source1) {
    if (target == null) throw new TypeError("target must be an object");
    var to = toObject(target); // step 1
    if (arguments.length === 1) return to; // step 2
    for(var s = 1; s < arguments.length; ++s){
        var from = toObject(arguments[s]); // step 3.a.i
        // step 3.a.ii:
        var keys = objectKeys(from);
        var getSymbols = hasSymbols && (Object.getOwnPropertySymbols || originalGetSymbols);
        if (getSymbols) {
            var syms = getSymbols(from);
            for(var j = 0; j < syms.length; ++j){
                var key = syms[j];
                if ($propIsEnumerable(from, key)) $push(keys, key);
            }
        }
        // step 3.a.iii:
        for(var i = 0; i < keys.length; ++i){
            var nextKey = keys[i];
            if ($propIsEnumerable(from, nextKey)) {
                var propValue = from[nextKey]; // step 3.a.iii.2.a
                to[nextKey] = propValue; // step 3.a.iii.2.b
            }
        }
    }
    return to; // step 4
};

},{"334c0bea01e613e6":"9FqgX","1964e25feb5e87a1":"ldFxD","6fb85b5b56dcab21":"kSjLP"}],"S2JpI":[function(require,module,exports) {
"use strict";
var implementation = require("b7e83063a8ec29e5");
var lacksProperEnumerationOrder = function() {
    if (!Object.assign) return false;
    /*
	 * v8, specifically in node 4.x, has a bug with incorrect property enumeration order
	 * note: this does not detect the bug unless there's 20 characters
	 */ var str = "abcdefghijklmnopqrst";
    var letters = str.split("");
    var map = {};
    for(var i = 0; i < letters.length; ++i)map[letters[i]] = letters[i];
    var obj = Object.assign({}, map);
    var actual = "";
    for(var k in obj)actual += k;
    return str !== actual;
};
var assignHasPendingExceptions = function() {
    if (!Object.assign || !Object.preventExtensions) return false;
    /*
	 * Firefox 37 still has "pending exception" logic in its Object.assign implementation,
	 * which is 72% slower than our shim, and Firefox 40's native implementation.
	 */ var thrower = Object.preventExtensions({
        1: 2
    });
    try {
        Object.assign(thrower, "xy");
    } catch (e) {
        return thrower[1] === "y";
    }
    return false;
};
module.exports = function getPolyfill() {
    if (!Object.assign) return implementation;
    if (lacksProperEnumerationOrder()) return implementation;
    if (assignHasPendingExceptions()) return implementation;
    return Object.assign;
};

},{"b7e83063a8ec29e5":"dH3bg"}],"13FFC":[function(require,module,exports) {
"use strict";
var define = require("6217b44f86f6933f");
var getPolyfill = require("1bf116323cb538f2");
module.exports = function shimAssign() {
    var polyfill = getPolyfill();
    define(Object, {
        assign: polyfill
    }, {
        assign: function() {
            return Object.assign !== polyfill;
        }
    });
    return polyfill;
};

},{"6217b44f86f6933f":"lmPVn","1bf116323cb538f2":"S2JpI"}],"eOw7z":[function(require,module,exports) {
"use strict";
var define = require("2a606ca4bac32b9");
var callBind = require("e31d43c509ae6451");
var implementation = require("5174dccdc8e82737");
var getPolyfill = require("a23d1338d3c9fa38");
var shim = require("47a21389f9e2199c");
var flagsBound = callBind(getPolyfill());
define(flagsBound, {
    getPolyfill: getPolyfill,
    implementation: implementation,
    shim: shim
});
module.exports = flagsBound;

},{"2a606ca4bac32b9":"c3IWl","e31d43c509ae6451":"1LGPW","5174dccdc8e82737":"aBjCg","a23d1338d3c9fa38":"fWYrI","47a21389f9e2199c":"7eQsJ"}],"c3IWl":[function(require,module,exports) {
"use strict";
var keys = require("3ebb97fdf1130f64");
var hasSymbols = typeof Symbol === "function" && typeof Symbol("foo") === "symbol";
var toStr = Object.prototype.toString;
var concat = Array.prototype.concat;
var origDefineProperty = Object.defineProperty;
var isFunction = function(fn) {
    return typeof fn === "function" && toStr.call(fn) === "[object Function]";
};
var hasPropertyDescriptors = require("eb175bf345715af7")();
var supportsDescriptors = origDefineProperty && hasPropertyDescriptors;
var defineProperty = function(object, name, value, predicate) {
    if (name in object) {
        if (predicate === true) {
            if (object[name] === value) return;
        } else if (!isFunction(predicate) || !predicate()) return;
    }
    if (supportsDescriptors) origDefineProperty(object, name, {
        configurable: true,
        enumerable: false,
        value: value,
        writable: true
    });
    else object[name] = value; // eslint-disable-line no-param-reassign
};
var defineProperties = function(object, map) {
    var predicates = arguments.length > 2 ? arguments[2] : {};
    var props = keys(map);
    if (hasSymbols) props = concat.call(props, Object.getOwnPropertySymbols(map));
    for(var i = 0; i < props.length; i += 1)defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
};
defineProperties.supportsDescriptors = !!supportsDescriptors;
module.exports = defineProperties;

},{"3ebb97fdf1130f64":"9FqgX","eb175bf345715af7":"lvtdS"}],"aBjCg":[function(require,module,exports) {
"use strict";
var functionsHaveConfigurableNames = require("2075dc3971218507").functionsHaveConfigurableNames();
var $Object = Object;
var $TypeError = TypeError;
module.exports = function flags() {
    if (this != null && this !== $Object(this)) throw new $TypeError("RegExp.prototype.flags getter called on non-object");
    var result = "";
    if (this.hasIndices) result += "d";
    if (this.global) result += "g";
    if (this.ignoreCase) result += "i";
    if (this.multiline) result += "m";
    if (this.dotAll) result += "s";
    if (this.unicode) result += "u";
    if (this.unicodeSets) result += "v";
    if (this.sticky) result += "y";
    return result;
};
if (functionsHaveConfigurableNames && Object.defineProperty) Object.defineProperty(module.exports, "name", {
    value: "get flags"
});

},{"2075dc3971218507":"6joTI"}],"6joTI":[function(require,module,exports) {
"use strict";
var functionsHaveNames = function functionsHaveNames() {
    return typeof (function f() {}).name === "string";
};
var gOPD = Object.getOwnPropertyDescriptor;
if (gOPD) try {
    gOPD([], "length");
} catch (e) {
    // IE 8 has a broken gOPD
    gOPD = null;
}
functionsHaveNames.functionsHaveConfigurableNames = function functionsHaveConfigurableNames() {
    if (!functionsHaveNames() || !gOPD) return false;
    var desc = gOPD(function() {}, "name");
    return !!desc && !!desc.configurable;
};
var $bind = Function.prototype.bind;
functionsHaveNames.boundFunctionsHaveNames = function boundFunctionsHaveNames() {
    return functionsHaveNames() && typeof $bind === "function" && (function f() {}).bind().name !== "";
};
module.exports = functionsHaveNames;

},{}],"fWYrI":[function(require,module,exports) {
"use strict";
var implementation = require("167d1a9082276947");
var supportsDescriptors = require("3fc9bfa176d35633").supportsDescriptors;
var $gOPD = Object.getOwnPropertyDescriptor;
module.exports = function getPolyfill() {
    if (supportsDescriptors && /a/mig.flags === "gim") {
        var descriptor = $gOPD(RegExp.prototype, "flags");
        if (descriptor && typeof descriptor.get === "function" && typeof RegExp.prototype.dotAll === "boolean" && typeof RegExp.prototype.hasIndices === "boolean") {
            /* eslint getter-return: 0 */ var calls = "";
            var o = {};
            Object.defineProperty(o, "hasIndices", {
                get: function() {
                    calls += "d";
                }
            });
            Object.defineProperty(o, "sticky", {
                get: function() {
                    calls += "y";
                }
            });
            if (calls === "dy") return descriptor.get;
        }
    }
    return implementation;
};

},{"167d1a9082276947":"aBjCg","3fc9bfa176d35633":"c3IWl"}],"7eQsJ":[function(require,module,exports) {
"use strict";
var supportsDescriptors = require("309f51212ddfcc72").supportsDescriptors;
var getPolyfill = require("741ca07541f77b4b");
var gOPD = Object.getOwnPropertyDescriptor;
var defineProperty = Object.defineProperty;
var TypeErr = TypeError;
var getProto = Object.getPrototypeOf;
var regex = /a/;
module.exports = function shimFlags() {
    if (!supportsDescriptors || !getProto) throw new TypeErr("RegExp.prototype.flags requires a true ES5 environment that supports property descriptors");
    var polyfill = getPolyfill();
    var proto = getProto(regex);
    var descriptor = gOPD(proto, "flags");
    if (!descriptor || descriptor.get !== polyfill) defineProperty(proto, "flags", {
        configurable: true,
        enumerable: false,
        get: polyfill
    });
    return polyfill;
};

},{"309f51212ddfcc72":"c3IWl","741ca07541f77b4b":"fWYrI"}],"lUbTP":[function(require,module,exports) {
"use strict";
var undefined1;
var $SyntaxError = SyntaxError;
var $Function = Function;
var $TypeError = TypeError;
// eslint-disable-next-line consistent-return
var getEvalledConstructor = function(expressionSyntax) {
    try {
        return $Function('"use strict"; return (' + expressionSyntax + ").constructor;")();
    } catch (e) {}
};
var $gOPD = Object.getOwnPropertyDescriptor;
if ($gOPD) try {
    $gOPD({}, "");
} catch (e) {
    $gOPD = null; // this is IE 8, which has a broken gOPD
}
var throwTypeError = function() {
    throw new $TypeError();
};
var ThrowTypeError = $gOPD ? function() {
    try {
        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
        arguments.callee; // IE 8 does not throw here
        return throwTypeError;
    } catch (calleeThrows) {
        try {
            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
            return $gOPD(arguments, "callee").get;
        } catch (gOPDthrows) {
            return throwTypeError;
        }
    }
}() : throwTypeError;
var hasSymbols = require("f25ef1fbbdad314e")();
var getProto = Object.getPrototypeOf || function(x) {
    return x.__proto__;
}; // eslint-disable-line no-proto
var needsEval = {};
var TypedArray = typeof Uint8Array === "undefined" ? undefined : getProto(Uint8Array);
var INTRINSICS = {
    "%AggregateError%": typeof AggregateError === "undefined" ? undefined : AggregateError,
    "%Array%": Array,
    "%ArrayBuffer%": typeof ArrayBuffer === "undefined" ? undefined : ArrayBuffer,
    "%ArrayIteratorPrototype%": hasSymbols ? getProto([][Symbol.iterator]()) : undefined,
    "%AsyncFromSyncIteratorPrototype%": undefined,
    "%AsyncFunction%": needsEval,
    "%AsyncGenerator%": needsEval,
    "%AsyncGeneratorFunction%": needsEval,
    "%AsyncIteratorPrototype%": needsEval,
    "%Atomics%": typeof Atomics === "undefined" ? undefined : Atomics,
    "%BigInt%": typeof BigInt === "undefined" ? undefined : BigInt,
    "%BigInt64Array%": typeof BigInt64Array === "undefined" ? undefined : BigInt64Array,
    "%BigUint64Array%": typeof BigUint64Array === "undefined" ? undefined : BigUint64Array,
    "%Boolean%": Boolean,
    "%DataView%": typeof DataView === "undefined" ? undefined : DataView,
    "%Date%": Date,
    "%decodeURI%": decodeURI,
    "%decodeURIComponent%": decodeURIComponent,
    "%encodeURI%": encodeURI,
    "%encodeURIComponent%": encodeURIComponent,
    "%Error%": Error,
    "%eval%": eval,
    "%EvalError%": EvalError,
    "%Float32Array%": typeof Float32Array === "undefined" ? undefined : Float32Array,
    "%Float64Array%": typeof Float64Array === "undefined" ? undefined : Float64Array,
    "%FinalizationRegistry%": typeof FinalizationRegistry === "undefined" ? undefined : FinalizationRegistry,
    "%Function%": $Function,
    "%GeneratorFunction%": needsEval,
    "%Int8Array%": typeof Int8Array === "undefined" ? undefined : Int8Array,
    "%Int16Array%": typeof Int16Array === "undefined" ? undefined : Int16Array,
    "%Int32Array%": typeof Int32Array === "undefined" ? undefined : Int32Array,
    "%isFinite%": isFinite,
    "%isNaN%": isNaN,
    "%IteratorPrototype%": hasSymbols ? getProto(getProto([][Symbol.iterator]())) : undefined,
    "%JSON%": typeof JSON === "object" ? JSON : undefined,
    "%Map%": typeof Map === "undefined" ? undefined : Map,
    "%MapIteratorPrototype%": typeof Map === "undefined" || !hasSymbols ? undefined : getProto(new Map()[Symbol.iterator]()),
    "%Math%": Math,
    "%Number%": Number,
    "%Object%": Object,
    "%parseFloat%": parseFloat,
    "%parseInt%": parseInt,
    "%Promise%": typeof Promise === "undefined" ? undefined : Promise,
    "%Proxy%": typeof Proxy === "undefined" ? undefined : Proxy,
    "%RangeError%": RangeError,
    "%ReferenceError%": ReferenceError,
    "%Reflect%": typeof Reflect === "undefined" ? undefined : Reflect,
    "%RegExp%": RegExp,
    "%Set%": typeof Set === "undefined" ? undefined : Set,
    "%SetIteratorPrototype%": typeof Set === "undefined" || !hasSymbols ? undefined : getProto(new Set()[Symbol.iterator]()),
    "%SharedArrayBuffer%": typeof SharedArrayBuffer === "undefined" ? undefined : SharedArrayBuffer,
    "%String%": String,
    "%StringIteratorPrototype%": hasSymbols ? getProto(""[Symbol.iterator]()) : undefined,
    "%Symbol%": hasSymbols ? Symbol : undefined,
    "%SyntaxError%": $SyntaxError,
    "%ThrowTypeError%": ThrowTypeError,
    "%TypedArray%": TypedArray,
    "%TypeError%": $TypeError,
    "%Uint8Array%": typeof Uint8Array === "undefined" ? undefined : Uint8Array,
    "%Uint8ClampedArray%": typeof Uint8ClampedArray === "undefined" ? undefined : Uint8ClampedArray,
    "%Uint16Array%": typeof Uint16Array === "undefined" ? undefined : Uint16Array,
    "%Uint32Array%": typeof Uint32Array === "undefined" ? undefined : Uint32Array,
    "%URIError%": URIError,
    "%WeakMap%": typeof WeakMap === "undefined" ? undefined : WeakMap,
    "%WeakRef%": typeof WeakRef === "undefined" ? undefined : WeakRef,
    "%WeakSet%": typeof WeakSet === "undefined" ? undefined : WeakSet
};
try {
    null.error; // eslint-disable-line no-unused-expressions
} catch (e) {
    // https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
    var errorProto = getProto(getProto(e));
    INTRINSICS["%Error.prototype%"] = errorProto;
}
var doEval = function doEval(name) {
    var value;
    if (name === "%AsyncFunction%") value = getEvalledConstructor("async function () {}");
    else if (name === "%GeneratorFunction%") value = getEvalledConstructor("function* () {}");
    else if (name === "%AsyncGeneratorFunction%") value = getEvalledConstructor("async function* () {}");
    else if (name === "%AsyncGenerator%") {
        var fn = doEval("%AsyncGeneratorFunction%");
        if (fn) value = fn.prototype;
    } else if (name === "%AsyncIteratorPrototype%") {
        var gen = doEval("%AsyncGenerator%");
        if (gen) value = getProto(gen.prototype);
    }
    INTRINSICS[name] = value;
    return value;
};
var LEGACY_ALIASES = {
    "%ArrayBufferPrototype%": [
        "ArrayBuffer",
        "prototype"
    ],
    "%ArrayPrototype%": [
        "Array",
        "prototype"
    ],
    "%ArrayProto_entries%": [
        "Array",
        "prototype",
        "entries"
    ],
    "%ArrayProto_forEach%": [
        "Array",
        "prototype",
        "forEach"
    ],
    "%ArrayProto_keys%": [
        "Array",
        "prototype",
        "keys"
    ],
    "%ArrayProto_values%": [
        "Array",
        "prototype",
        "values"
    ],
    "%AsyncFunctionPrototype%": [
        "AsyncFunction",
        "prototype"
    ],
    "%AsyncGenerator%": [
        "AsyncGeneratorFunction",
        "prototype"
    ],
    "%AsyncGeneratorPrototype%": [
        "AsyncGeneratorFunction",
        "prototype",
        "prototype"
    ],
    "%BooleanPrototype%": [
        "Boolean",
        "prototype"
    ],
    "%DataViewPrototype%": [
        "DataView",
        "prototype"
    ],
    "%DatePrototype%": [
        "Date",
        "prototype"
    ],
    "%ErrorPrototype%": [
        "Error",
        "prototype"
    ],
    "%EvalErrorPrototype%": [
        "EvalError",
        "prototype"
    ],
    "%Float32ArrayPrototype%": [
        "Float32Array",
        "prototype"
    ],
    "%Float64ArrayPrototype%": [
        "Float64Array",
        "prototype"
    ],
    "%FunctionPrototype%": [
        "Function",
        "prototype"
    ],
    "%Generator%": [
        "GeneratorFunction",
        "prototype"
    ],
    "%GeneratorPrototype%": [
        "GeneratorFunction",
        "prototype",
        "prototype"
    ],
    "%Int8ArrayPrototype%": [
        "Int8Array",
        "prototype"
    ],
    "%Int16ArrayPrototype%": [
        "Int16Array",
        "prototype"
    ],
    "%Int32ArrayPrototype%": [
        "Int32Array",
        "prototype"
    ],
    "%JSONParse%": [
        "JSON",
        "parse"
    ],
    "%JSONStringify%": [
        "JSON",
        "stringify"
    ],
    "%MapPrototype%": [
        "Map",
        "prototype"
    ],
    "%NumberPrototype%": [
        "Number",
        "prototype"
    ],
    "%ObjectPrototype%": [
        "Object",
        "prototype"
    ],
    "%ObjProto_toString%": [
        "Object",
        "prototype",
        "toString"
    ],
    "%ObjProto_valueOf%": [
        "Object",
        "prototype",
        "valueOf"
    ],
    "%PromisePrototype%": [
        "Promise",
        "prototype"
    ],
    "%PromiseProto_then%": [
        "Promise",
        "prototype",
        "then"
    ],
    "%Promise_all%": [
        "Promise",
        "all"
    ],
    "%Promise_reject%": [
        "Promise",
        "reject"
    ],
    "%Promise_resolve%": [
        "Promise",
        "resolve"
    ],
    "%RangeErrorPrototype%": [
        "RangeError",
        "prototype"
    ],
    "%ReferenceErrorPrototype%": [
        "ReferenceError",
        "prototype"
    ],
    "%RegExpPrototype%": [
        "RegExp",
        "prototype"
    ],
    "%SetPrototype%": [
        "Set",
        "prototype"
    ],
    "%SharedArrayBufferPrototype%": [
        "SharedArrayBuffer",
        "prototype"
    ],
    "%StringPrototype%": [
        "String",
        "prototype"
    ],
    "%SymbolPrototype%": [
        "Symbol",
        "prototype"
    ],
    "%SyntaxErrorPrototype%": [
        "SyntaxError",
        "prototype"
    ],
    "%TypedArrayPrototype%": [
        "TypedArray",
        "prototype"
    ],
    "%TypeErrorPrototype%": [
        "TypeError",
        "prototype"
    ],
    "%Uint8ArrayPrototype%": [
        "Uint8Array",
        "prototype"
    ],
    "%Uint8ClampedArrayPrototype%": [
        "Uint8ClampedArray",
        "prototype"
    ],
    "%Uint16ArrayPrototype%": [
        "Uint16Array",
        "prototype"
    ],
    "%Uint32ArrayPrototype%": [
        "Uint32Array",
        "prototype"
    ],
    "%URIErrorPrototype%": [
        "URIError",
        "prototype"
    ],
    "%WeakMapPrototype%": [
        "WeakMap",
        "prototype"
    ],
    "%WeakSetPrototype%": [
        "WeakSet",
        "prototype"
    ]
};
var bind = require("67fcc5c5f9c345b0");
var hasOwn = require("a2d7ee5f25b25d37");
var $concat = bind.call(Function.call, Array.prototype.concat);
var $spliceApply = bind.call(Function.apply, Array.prototype.splice);
var $replace = bind.call(Function.call, String.prototype.replace);
var $strSlice = bind.call(Function.call, String.prototype.slice);
var $exec = bind.call(Function.call, RegExp.prototype.exec);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */ 
var stringToPath = function stringToPath(string) {
    var first = $strSlice(string, 0, 1);
    var last = $strSlice(string, -1);
    if (first === "%" && last !== "%") throw new $SyntaxError("invalid intrinsic syntax, expected closing `%`");
    else if (last === "%" && first !== "%") throw new $SyntaxError("invalid intrinsic syntax, expected opening `%`");
    var result = [];
    $replace(string, rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $replace(subString, reEscapeChar, "$1") : number || match;
    });
    return result;
};
/* end adaptation */ var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    var intrinsicName = name;
    var alias;
    if (hasOwn(LEGACY_ALIASES, intrinsicName)) {
        alias = LEGACY_ALIASES[intrinsicName];
        intrinsicName = "%" + alias[0] + "%";
    }
    if (hasOwn(INTRINSICS, intrinsicName)) {
        var value = INTRINSICS[intrinsicName];
        if (value === needsEval) value = doEval(intrinsicName);
        if (typeof value === "undefined" && !allowMissing) throw new $TypeError("intrinsic " + name + " exists, but is not available. Please file an issue!");
        return {
            alias: alias,
            name: intrinsicName,
            value: value
        };
    }
    throw new $SyntaxError("intrinsic " + name + " does not exist!");
};
module.exports = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== "string" || name.length === 0) throw new $TypeError("intrinsic name must be a non-empty string");
    if (arguments.length > 1 && typeof allowMissing !== "boolean") throw new $TypeError('"allowMissing" argument must be a boolean');
    if ($exec(/^%?[^%]*%?$/, name) === null) throw new $SyntaxError("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
    var parts = stringToPath(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : "";
    var intrinsic = getBaseIntrinsic("%" + intrinsicBaseName + "%", allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
        intrinsicBaseName = alias[0];
        $spliceApply(parts, $concat([
            0,
            1
        ], alias));
    }
    for(var i = 1, isOwn = true; i < parts.length; i += 1){
        var part = parts[i];
        var first = $strSlice(part, 0, 1);
        var last = $strSlice(part, -1);
        if ((first === '"' || first === "'" || first === "`" || last === '"' || last === "'" || last === "`") && first !== last) throw new $SyntaxError("property names with quotes must have matching quotes");
        if (part === "constructor" || !isOwn) skipFurtherCaching = true;
        intrinsicBaseName += "." + part;
        intrinsicRealName = "%" + intrinsicBaseName + "%";
        if (hasOwn(INTRINSICS, intrinsicRealName)) value = INTRINSICS[intrinsicRealName];
        else if (value != null) {
            if (!(part in value)) {
                if (!allowMissing) throw new $TypeError("base intrinsic for " + name + " exists, but the property is not available.");
                return void 0;
            }
            if ($gOPD && i + 1 >= parts.length) {
                var desc = $gOPD(value, part);
                isOwn = !!desc;
                // By convention, when a data property is converted to an accessor
                // property to emulate a data property that does not suffer from
                // the override mistake, that accessor's getter is marked with
                // an `originalValue` property. Here, when we detect this, we
                // uphold the illusion by pretending to see that original data
                // property, i.e., returning the value rather than the getter
                // itself.
                if (isOwn && "get" in desc && !("originalValue" in desc.get)) value = desc.get;
                else value = value[part];
            } else {
                isOwn = hasOwn(value, part);
                value = value[part];
            }
            if (isOwn && !skipFurtherCaching) INTRINSICS[intrinsicRealName] = value;
        }
    }
    return value;
};

},{"f25ef1fbbdad314e":"Hzs91","67fcc5c5f9c345b0":"jVVtB","a2d7ee5f25b25d37":"3bVv3"}],"jP84s":[function(require,module,exports) {
var process = require("fae62858926d8104");
"use strict";
/* eslint global-require: 0 */ // the code is structured this way so that bundlers can
// alias out `has-symbols` to `() => true` or `() => false` if your target
// environments' Symbol capabilities are known, and then use
// dead code elimination on the rest of this module.
//
// Similarly, `isarray` can be aliased to `Array.isArray` if
// available in all target environments.
var isArguments = require("6852acab7aecf9d6");
var getStopIterationIterator = require("91e22879998534c6");
if (require("b6127dd0618ca580")() || require("4cedb8cfde480f45")()) {
    var $iterator = Symbol.iterator;
    // Symbol is available natively or shammed
    // natively:
    //  - Chrome >= 38
    //  - Edge 12-14?, Edge >= 15 for sure
    //  - FF >= 36
    //  - Safari >= 9
    //  - node >= 0.12
    module.exports = function getIterator(iterable) {
        // alternatively, `iterable[$iterator]?.()`
        if (iterable != null && typeof iterable[$iterator] !== "undefined") return iterable[$iterator]();
        if (isArguments(iterable)) // arguments objects lack Symbol.iterator
        // - node 0.12
        return Array.prototype[$iterator].call(iterable);
    };
} else {
    // Symbol is not available, native or shammed
    var isArray = require("9e40df185bc98ad2");
    var isString = require("4408d389fb64535");
    var GetIntrinsic = require("1dadc710d71d74ba");
    var $Map = GetIntrinsic("%Map%", true);
    var $Set = GetIntrinsic("%Set%", true);
    var callBound = require("99235f8f305089d6");
    var $arrayPush = callBound("Array.prototype.push");
    var $charCodeAt = callBound("String.prototype.charCodeAt");
    var $stringSlice = callBound("String.prototype.slice");
    var advanceStringIndex = function advanceStringIndex(S, index) {
        var length = S.length;
        if (index + 1 >= length) return index + 1;
        var first = $charCodeAt(S, index);
        if (first < 0xD800 || first > 0xDBFF) return index + 1;
        var second = $charCodeAt(S, index + 1);
        if (second < 0xDC00 || second > 0xDFFF) return index + 1;
        return index + 2;
    };
    var getArrayIterator = function getArrayIterator(arraylike) {
        var i = 0;
        return {
            next: function next() {
                var done = i >= arraylike.length;
                var value;
                if (!done) {
                    value = arraylike[i];
                    i += 1;
                }
                return {
                    done: done,
                    value: value
                };
            }
        };
    };
    var getNonCollectionIterator = function getNonCollectionIterator(iterable, noPrimordialCollections) {
        if (isArray(iterable) || isArguments(iterable)) return getArrayIterator(iterable);
        if (isString(iterable)) {
            var i = 0;
            return {
                next: function next() {
                    var nextIndex = advanceStringIndex(iterable, i);
                    var value = $stringSlice(iterable, i, nextIndex);
                    i = nextIndex;
                    return {
                        done: nextIndex > iterable.length,
                        value: value
                    };
                }
            };
        }
        // es6-shim and es-shims' es-map use a string "_es6-shim iterator_" property on different iterables, such as MapIterator.
        if (noPrimordialCollections && typeof iterable["_es6-shim iterator_"] !== "undefined") return iterable["_es6-shim iterator_"]();
    };
    if (!$Map && !$Set) // the only language iterables are Array, String, arguments
    // - Safari <= 6.0
    // - Chrome < 38
    // - node < 0.12
    // - FF < 13
    // - IE < 11
    // - Edge < 11
    module.exports = function getIterator(iterable) {
        if (iterable != null) return getNonCollectionIterator(iterable, true);
    };
    else {
        // either Map or Set are available, but Symbol is not
        // - es6-shim on an ES5 browser
        // - Safari 6.2 (maybe 6.1?)
        // - FF v[13, 36)
        // - IE 11
        // - Edge 11
        // - Safari v[6, 9)
        var isMap = require("281327d695979bc1");
        var isSet = require("87d16ceb511608");
        // Firefox >= 27, IE 11, Safari 6.2 - 9, Edge 11, es6-shim in older envs, all have forEach
        var $mapForEach = callBound("Map.prototype.forEach", true);
        var $setForEach = callBound("Set.prototype.forEach", true);
        if (typeof process === "undefined" || !process.versions || !process.versions.node) {
            // Firefox 17 - 26 has `.iterator()`, whose iterator `.next()` either
            // returns a value, or throws a StopIteration object. These browsers
            // do not have any other mechanism for iteration.
            var $mapIterator = callBound("Map.prototype.iterator", true);
            var $setIterator = callBound("Set.prototype.iterator", true);
        }
        // Firefox 27-35, and some older es6-shim versions, use a string "@@iterator" property
        // this returns a proper iterator object, so we should use it instead of forEach.
        // newer es6-shim versions use a string "_es6-shim iterator_" property.
        var $mapAtAtIterator = callBound("Map.prototype.@@iterator", true) || callBound("Map.prototype._es6-shim iterator_", true);
        var $setAtAtIterator = callBound("Set.prototype.@@iterator", true) || callBound("Set.prototype._es6-shim iterator_", true);
        var getCollectionIterator = function getCollectionIterator(iterable) {
            if (isMap(iterable)) {
                if ($mapIterator) return getStopIterationIterator($mapIterator(iterable));
                if ($mapAtAtIterator) return $mapAtAtIterator(iterable);
                if ($mapForEach) {
                    var entries = [];
                    $mapForEach(iterable, function(v, k) {
                        $arrayPush(entries, [
                            k,
                            v
                        ]);
                    });
                    return getArrayIterator(entries);
                }
            }
            if (isSet(iterable)) {
                if ($setIterator) return getStopIterationIterator($setIterator(iterable));
                if ($setAtAtIterator) return $setAtAtIterator(iterable);
                if ($setForEach) {
                    var values = [];
                    $setForEach(iterable, function(v) {
                        $arrayPush(values, v);
                    });
                    return getArrayIterator(values);
                }
            }
        };
        module.exports = function getIterator(iterable) {
            return getCollectionIterator(iterable) || getNonCollectionIterator(iterable);
        };
    }
}

},{"fae62858926d8104":"6WEZ3","6852acab7aecf9d6":"3ssGk","91e22879998534c6":"1tZ0v","b6127dd0618ca580":"Hzs91","4cedb8cfde480f45":"ldFxD","9e40df185bc98ad2":"fv2st","4408d389fb64535":"46YIA","1dadc710d71d74ba":"fTq9o","99235f8f305089d6":"kSjLP","281327d695979bc1":"vHjDp","87d16ceb511608":"aTQw8"}],"3ssGk":[function(require,module,exports) {
"use strict";
var hasToStringTag = require("e2b01ce809f132fb")();
var callBound = require("649cbf9949986a39");
var $toString = callBound("Object.prototype.toString");
var isStandardArguments = function isArguments(value) {
    if (hasToStringTag && value && typeof value === "object" && Symbol.toStringTag in value) return false;
    return $toString(value) === "[object Arguments]";
};
var isLegacyArguments = function isArguments(value) {
    if (isStandardArguments(value)) return true;
    return value !== null && typeof value === "object" && typeof value.length === "number" && value.length >= 0 && $toString(value) !== "[object Array]" && $toString(value.callee) === "[object Function]";
};
var supportsStandardArguments = function() {
    return isStandardArguments(arguments);
}();
isStandardArguments.isLegacyArguments = isLegacyArguments; // for tests
module.exports = supportsStandardArguments ? isStandardArguments : isLegacyArguments;

},{"e2b01ce809f132fb":"3BxV8","649cbf9949986a39":"kSjLP"}],"1tZ0v":[function(require,module,exports) {
"use strict";
var SLOT = require("86c99d501e630e");
var $SyntaxError = SyntaxError;
var $StopIteration = typeof StopIteration === "object" ? StopIteration : null;
module.exports = function getStopIterationIterator(origIterator) {
    if (!$StopIteration) throw new $SyntaxError("this environment lacks StopIteration");
    SLOT.set(origIterator, "[[Done]]", false);
    var siIterator = {
        next: function next() {
            var iterator = SLOT.get(this, "[[Iterator]]");
            var done = SLOT.get(iterator, "[[Done]]");
            try {
                return {
                    done: done,
                    value: done ? void 0 : iterator.next()
                };
            } catch (e) {
                SLOT.set(iterator, "[[Done]]", true);
                if (e !== $StopIteration) throw e;
                return {
                    done: true,
                    value: void 0
                };
            }
        }
    };
    SLOT.set(siIterator, "[[Iterator]]", origIterator);
    return siIterator;
};

},{"86c99d501e630e":"6AxG6"}],"6AxG6":[function(require,module,exports) {
"use strict";
var GetIntrinsic = require("e43bfb04602a23d7");
var has = require("e8f7a152d700f4a4");
var channel = require("96cbd2dfeb8696d8")();
var $TypeError = GetIntrinsic("%TypeError%");
var SLOT = {
    assert: function(O, slot) {
        if (!O || typeof O !== "object" && typeof O !== "function") throw new $TypeError("`O` is not an object");
        if (typeof slot !== "string") throw new $TypeError("`slot` must be a string");
        channel.assert(O);
        if (!SLOT.has(O, slot)) throw new $TypeError("`" + slot + "` is not present on `O`");
    },
    get: function(O, slot) {
        if (!O || typeof O !== "object" && typeof O !== "function") throw new $TypeError("`O` is not an object");
        if (typeof slot !== "string") throw new $TypeError("`slot` must be a string");
        var slots = channel.get(O);
        return slots && slots["$" + slot];
    },
    has: function(O, slot) {
        if (!O || typeof O !== "object" && typeof O !== "function") throw new $TypeError("`O` is not an object");
        if (typeof slot !== "string") throw new $TypeError("`slot` must be a string");
        var slots = channel.get(O);
        return !!slots && has(slots, "$" + slot);
    },
    set: function(O, slot, V) {
        if (!O || typeof O !== "object" && typeof O !== "function") throw new $TypeError("`O` is not an object");
        if (typeof slot !== "string") throw new $TypeError("`slot` must be a string");
        var slots = channel.get(O);
        if (!slots) {
            slots = {};
            channel.set(O, slots);
        }
        slots["$" + slot] = V;
    }
};
if (Object.freeze) Object.freeze(SLOT);
module.exports = SLOT;

},{"e43bfb04602a23d7":"aCfP4","e8f7a152d700f4a4":"3bVv3","96cbd2dfeb8696d8":"l3w67"}],"aCfP4":[function(require,module,exports) {
"use strict";
var undefined1;
var $SyntaxError = SyntaxError;
var $Function = Function;
var $TypeError = TypeError;
// eslint-disable-next-line consistent-return
var getEvalledConstructor = function(expressionSyntax) {
    try {
        return $Function('"use strict"; return (' + expressionSyntax + ").constructor;")();
    } catch (e) {}
};
var $gOPD = Object.getOwnPropertyDescriptor;
if ($gOPD) try {
    $gOPD({}, "");
} catch (e) {
    $gOPD = null; // this is IE 8, which has a broken gOPD
}
var throwTypeError = function() {
    throw new $TypeError();
};
var ThrowTypeError = $gOPD ? function() {
    try {
        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
        arguments.callee; // IE 8 does not throw here
        return throwTypeError;
    } catch (calleeThrows) {
        try {
            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
            return $gOPD(arguments, "callee").get;
        } catch (gOPDthrows) {
            return throwTypeError;
        }
    }
}() : throwTypeError;
var hasSymbols = require("587561d2f28c61de")();
var getProto = Object.getPrototypeOf || function(x) {
    return x.__proto__;
}; // eslint-disable-line no-proto
var needsEval = {};
var TypedArray = typeof Uint8Array === "undefined" ? undefined : getProto(Uint8Array);
var INTRINSICS = {
    "%AggregateError%": typeof AggregateError === "undefined" ? undefined : AggregateError,
    "%Array%": Array,
    "%ArrayBuffer%": typeof ArrayBuffer === "undefined" ? undefined : ArrayBuffer,
    "%ArrayIteratorPrototype%": hasSymbols ? getProto([][Symbol.iterator]()) : undefined,
    "%AsyncFromSyncIteratorPrototype%": undefined,
    "%AsyncFunction%": needsEval,
    "%AsyncGenerator%": needsEval,
    "%AsyncGeneratorFunction%": needsEval,
    "%AsyncIteratorPrototype%": needsEval,
    "%Atomics%": typeof Atomics === "undefined" ? undefined : Atomics,
    "%BigInt%": typeof BigInt === "undefined" ? undefined : BigInt,
    "%BigInt64Array%": typeof BigInt64Array === "undefined" ? undefined : BigInt64Array,
    "%BigUint64Array%": typeof BigUint64Array === "undefined" ? undefined : BigUint64Array,
    "%Boolean%": Boolean,
    "%DataView%": typeof DataView === "undefined" ? undefined : DataView,
    "%Date%": Date,
    "%decodeURI%": decodeURI,
    "%decodeURIComponent%": decodeURIComponent,
    "%encodeURI%": encodeURI,
    "%encodeURIComponent%": encodeURIComponent,
    "%Error%": Error,
    "%eval%": eval,
    "%EvalError%": EvalError,
    "%Float32Array%": typeof Float32Array === "undefined" ? undefined : Float32Array,
    "%Float64Array%": typeof Float64Array === "undefined" ? undefined : Float64Array,
    "%FinalizationRegistry%": typeof FinalizationRegistry === "undefined" ? undefined : FinalizationRegistry,
    "%Function%": $Function,
    "%GeneratorFunction%": needsEval,
    "%Int8Array%": typeof Int8Array === "undefined" ? undefined : Int8Array,
    "%Int16Array%": typeof Int16Array === "undefined" ? undefined : Int16Array,
    "%Int32Array%": typeof Int32Array === "undefined" ? undefined : Int32Array,
    "%isFinite%": isFinite,
    "%isNaN%": isNaN,
    "%IteratorPrototype%": hasSymbols ? getProto(getProto([][Symbol.iterator]())) : undefined,
    "%JSON%": typeof JSON === "object" ? JSON : undefined,
    "%Map%": typeof Map === "undefined" ? undefined : Map,
    "%MapIteratorPrototype%": typeof Map === "undefined" || !hasSymbols ? undefined : getProto(new Map()[Symbol.iterator]()),
    "%Math%": Math,
    "%Number%": Number,
    "%Object%": Object,
    "%parseFloat%": parseFloat,
    "%parseInt%": parseInt,
    "%Promise%": typeof Promise === "undefined" ? undefined : Promise,
    "%Proxy%": typeof Proxy === "undefined" ? undefined : Proxy,
    "%RangeError%": RangeError,
    "%ReferenceError%": ReferenceError,
    "%Reflect%": typeof Reflect === "undefined" ? undefined : Reflect,
    "%RegExp%": RegExp,
    "%Set%": typeof Set === "undefined" ? undefined : Set,
    "%SetIteratorPrototype%": typeof Set === "undefined" || !hasSymbols ? undefined : getProto(new Set()[Symbol.iterator]()),
    "%SharedArrayBuffer%": typeof SharedArrayBuffer === "undefined" ? undefined : SharedArrayBuffer,
    "%String%": String,
    "%StringIteratorPrototype%": hasSymbols ? getProto(""[Symbol.iterator]()) : undefined,
    "%Symbol%": hasSymbols ? Symbol : undefined,
    "%SyntaxError%": $SyntaxError,
    "%ThrowTypeError%": ThrowTypeError,
    "%TypedArray%": TypedArray,
    "%TypeError%": $TypeError,
    "%Uint8Array%": typeof Uint8Array === "undefined" ? undefined : Uint8Array,
    "%Uint8ClampedArray%": typeof Uint8ClampedArray === "undefined" ? undefined : Uint8ClampedArray,
    "%Uint16Array%": typeof Uint16Array === "undefined" ? undefined : Uint16Array,
    "%Uint32Array%": typeof Uint32Array === "undefined" ? undefined : Uint32Array,
    "%URIError%": URIError,
    "%WeakMap%": typeof WeakMap === "undefined" ? undefined : WeakMap,
    "%WeakRef%": typeof WeakRef === "undefined" ? undefined : WeakRef,
    "%WeakSet%": typeof WeakSet === "undefined" ? undefined : WeakSet
};
try {
    null.error; // eslint-disable-line no-unused-expressions
} catch (e) {
    // https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
    var errorProto = getProto(getProto(e));
    INTRINSICS["%Error.prototype%"] = errorProto;
}
var doEval = function doEval(name) {
    var value;
    if (name === "%AsyncFunction%") value = getEvalledConstructor("async function () {}");
    else if (name === "%GeneratorFunction%") value = getEvalledConstructor("function* () {}");
    else if (name === "%AsyncGeneratorFunction%") value = getEvalledConstructor("async function* () {}");
    else if (name === "%AsyncGenerator%") {
        var fn = doEval("%AsyncGeneratorFunction%");
        if (fn) value = fn.prototype;
    } else if (name === "%AsyncIteratorPrototype%") {
        var gen = doEval("%AsyncGenerator%");
        if (gen) value = getProto(gen.prototype);
    }
    INTRINSICS[name] = value;
    return value;
};
var LEGACY_ALIASES = {
    "%ArrayBufferPrototype%": [
        "ArrayBuffer",
        "prototype"
    ],
    "%ArrayPrototype%": [
        "Array",
        "prototype"
    ],
    "%ArrayProto_entries%": [
        "Array",
        "prototype",
        "entries"
    ],
    "%ArrayProto_forEach%": [
        "Array",
        "prototype",
        "forEach"
    ],
    "%ArrayProto_keys%": [
        "Array",
        "prototype",
        "keys"
    ],
    "%ArrayProto_values%": [
        "Array",
        "prototype",
        "values"
    ],
    "%AsyncFunctionPrototype%": [
        "AsyncFunction",
        "prototype"
    ],
    "%AsyncGenerator%": [
        "AsyncGeneratorFunction",
        "prototype"
    ],
    "%AsyncGeneratorPrototype%": [
        "AsyncGeneratorFunction",
        "prototype",
        "prototype"
    ],
    "%BooleanPrototype%": [
        "Boolean",
        "prototype"
    ],
    "%DataViewPrototype%": [
        "DataView",
        "prototype"
    ],
    "%DatePrototype%": [
        "Date",
        "prototype"
    ],
    "%ErrorPrototype%": [
        "Error",
        "prototype"
    ],
    "%EvalErrorPrototype%": [
        "EvalError",
        "prototype"
    ],
    "%Float32ArrayPrototype%": [
        "Float32Array",
        "prototype"
    ],
    "%Float64ArrayPrototype%": [
        "Float64Array",
        "prototype"
    ],
    "%FunctionPrototype%": [
        "Function",
        "prototype"
    ],
    "%Generator%": [
        "GeneratorFunction",
        "prototype"
    ],
    "%GeneratorPrototype%": [
        "GeneratorFunction",
        "prototype",
        "prototype"
    ],
    "%Int8ArrayPrototype%": [
        "Int8Array",
        "prototype"
    ],
    "%Int16ArrayPrototype%": [
        "Int16Array",
        "prototype"
    ],
    "%Int32ArrayPrototype%": [
        "Int32Array",
        "prototype"
    ],
    "%JSONParse%": [
        "JSON",
        "parse"
    ],
    "%JSONStringify%": [
        "JSON",
        "stringify"
    ],
    "%MapPrototype%": [
        "Map",
        "prototype"
    ],
    "%NumberPrototype%": [
        "Number",
        "prototype"
    ],
    "%ObjectPrototype%": [
        "Object",
        "prototype"
    ],
    "%ObjProto_toString%": [
        "Object",
        "prototype",
        "toString"
    ],
    "%ObjProto_valueOf%": [
        "Object",
        "prototype",
        "valueOf"
    ],
    "%PromisePrototype%": [
        "Promise",
        "prototype"
    ],
    "%PromiseProto_then%": [
        "Promise",
        "prototype",
        "then"
    ],
    "%Promise_all%": [
        "Promise",
        "all"
    ],
    "%Promise_reject%": [
        "Promise",
        "reject"
    ],
    "%Promise_resolve%": [
        "Promise",
        "resolve"
    ],
    "%RangeErrorPrototype%": [
        "RangeError",
        "prototype"
    ],
    "%ReferenceErrorPrototype%": [
        "ReferenceError",
        "prototype"
    ],
    "%RegExpPrototype%": [
        "RegExp",
        "prototype"
    ],
    "%SetPrototype%": [
        "Set",
        "prototype"
    ],
    "%SharedArrayBufferPrototype%": [
        "SharedArrayBuffer",
        "prototype"
    ],
    "%StringPrototype%": [
        "String",
        "prototype"
    ],
    "%SymbolPrototype%": [
        "Symbol",
        "prototype"
    ],
    "%SyntaxErrorPrototype%": [
        "SyntaxError",
        "prototype"
    ],
    "%TypedArrayPrototype%": [
        "TypedArray",
        "prototype"
    ],
    "%TypeErrorPrototype%": [
        "TypeError",
        "prototype"
    ],
    "%Uint8ArrayPrototype%": [
        "Uint8Array",
        "prototype"
    ],
    "%Uint8ClampedArrayPrototype%": [
        "Uint8ClampedArray",
        "prototype"
    ],
    "%Uint16ArrayPrototype%": [
        "Uint16Array",
        "prototype"
    ],
    "%Uint32ArrayPrototype%": [
        "Uint32Array",
        "prototype"
    ],
    "%URIErrorPrototype%": [
        "URIError",
        "prototype"
    ],
    "%WeakMapPrototype%": [
        "WeakMap",
        "prototype"
    ],
    "%WeakSetPrototype%": [
        "WeakSet",
        "prototype"
    ]
};
var bind = require("5f2ff0f1757b9e6d");
var hasOwn = require("c4e4a251dfae39a2");
var $concat = bind.call(Function.call, Array.prototype.concat);
var $spliceApply = bind.call(Function.apply, Array.prototype.splice);
var $replace = bind.call(Function.call, String.prototype.replace);
var $strSlice = bind.call(Function.call, String.prototype.slice);
var $exec = bind.call(Function.call, RegExp.prototype.exec);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */ 
var stringToPath = function stringToPath(string) {
    var first = $strSlice(string, 0, 1);
    var last = $strSlice(string, -1);
    if (first === "%" && last !== "%") throw new $SyntaxError("invalid intrinsic syntax, expected closing `%`");
    else if (last === "%" && first !== "%") throw new $SyntaxError("invalid intrinsic syntax, expected opening `%`");
    var result = [];
    $replace(string, rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $replace(subString, reEscapeChar, "$1") : number || match;
    });
    return result;
};
/* end adaptation */ var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    var intrinsicName = name;
    var alias;
    if (hasOwn(LEGACY_ALIASES, intrinsicName)) {
        alias = LEGACY_ALIASES[intrinsicName];
        intrinsicName = "%" + alias[0] + "%";
    }
    if (hasOwn(INTRINSICS, intrinsicName)) {
        var value = INTRINSICS[intrinsicName];
        if (value === needsEval) value = doEval(intrinsicName);
        if (typeof value === "undefined" && !allowMissing) throw new $TypeError("intrinsic " + name + " exists, but is not available. Please file an issue!");
        return {
            alias: alias,
            name: intrinsicName,
            value: value
        };
    }
    throw new $SyntaxError("intrinsic " + name + " does not exist!");
};
module.exports = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== "string" || name.length === 0) throw new $TypeError("intrinsic name must be a non-empty string");
    if (arguments.length > 1 && typeof allowMissing !== "boolean") throw new $TypeError('"allowMissing" argument must be a boolean');
    if ($exec(/^%?[^%]*%?$/, name) === null) throw new $SyntaxError("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
    var parts = stringToPath(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : "";
    var intrinsic = getBaseIntrinsic("%" + intrinsicBaseName + "%", allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
        intrinsicBaseName = alias[0];
        $spliceApply(parts, $concat([
            0,
            1
        ], alias));
    }
    for(var i = 1, isOwn = true; i < parts.length; i += 1){
        var part = parts[i];
        var first = $strSlice(part, 0, 1);
        var last = $strSlice(part, -1);
        if ((first === '"' || first === "'" || first === "`" || last === '"' || last === "'" || last === "`") && first !== last) throw new $SyntaxError("property names with quotes must have matching quotes");
        if (part === "constructor" || !isOwn) skipFurtherCaching = true;
        intrinsicBaseName += "." + part;
        intrinsicRealName = "%" + intrinsicBaseName + "%";
        if (hasOwn(INTRINSICS, intrinsicRealName)) value = INTRINSICS[intrinsicRealName];
        else if (value != null) {
            if (!(part in value)) {
                if (!allowMissing) throw new $TypeError("base intrinsic for " + name + " exists, but the property is not available.");
                return void 0;
            }
            if ($gOPD && i + 1 >= parts.length) {
                var desc = $gOPD(value, part);
                isOwn = !!desc;
                // By convention, when a data property is converted to an accessor
                // property to emulate a data property that does not suffer from
                // the override mistake, that accessor's getter is marked with
                // an `originalValue` property. Here, when we detect this, we
                // uphold the illusion by pretending to see that original data
                // property, i.e., returning the value rather than the getter
                // itself.
                if (isOwn && "get" in desc && !("originalValue" in desc.get)) value = desc.get;
                else value = value[part];
            } else {
                isOwn = hasOwn(value, part);
                value = value[part];
            }
            if (isOwn && !skipFurtherCaching) INTRINSICS[intrinsicRealName] = value;
        }
    }
    return value;
};

},{"587561d2f28c61de":"Hzs91","5f2ff0f1757b9e6d":"jVVtB","c4e4a251dfae39a2":"3bVv3"}],"fv2st":[function(require,module,exports) {
var toString = {}.toString;
module.exports = Array.isArray || function(arr) {
    return toString.call(arr) == "[object Array]";
};

},{}],"46YIA":[function(require,module,exports) {
"use strict";
var strValue = String.prototype.valueOf;
var tryStringObject = function tryStringObject(value) {
    try {
        strValue.call(value);
        return true;
    } catch (e) {
        return false;
    }
};
var toStr = Object.prototype.toString;
var strClass = "[object String]";
var hasToStringTag = require("dc253d94c90af370")();
module.exports = function isString(value) {
    if (typeof value === "string") return true;
    if (typeof value !== "object") return false;
    return hasToStringTag ? tryStringObject(value) : toStr.call(value) === strClass;
};

},{"dc253d94c90af370":"3BxV8"}],"vHjDp":[function(require,module,exports) {
"use strict";
var $Map = typeof Map === "function" && Map.prototype ? Map : null;
var $Set = typeof Set === "function" && Set.prototype ? Set : null;
var exported;
if (!$Map) // eslint-disable-next-line no-unused-vars
exported = function isMap(x) {
    // `Map` is not present in this environment.
    return false;
};
var $mapHas = $Map ? Map.prototype.has : null;
var $setHas = $Set ? Set.prototype.has : null;
if (!exported && !$mapHas) // eslint-disable-next-line no-unused-vars
exported = function isMap(x) {
    // `Map` does not have a `has` method
    return false;
};
module.exports = exported || function isMap(x) {
    if (!x || typeof x !== "object") return false;
    try {
        $mapHas.call(x);
        if ($setHas) try {
            $setHas.call(x);
        } catch (e) {
            return true;
        }
        return x instanceof $Map; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
};

},{}],"aTQw8":[function(require,module,exports) {
"use strict";
var $Map = typeof Map === "function" && Map.prototype ? Map : null;
var $Set = typeof Set === "function" && Set.prototype ? Set : null;
var exported;
if (!$Set) // eslint-disable-next-line no-unused-vars
exported = function isSet(x) {
    // `Set` is not present in this environment.
    return false;
};
var $mapHas = $Map ? Map.prototype.has : null;
var $setHas = $Set ? Set.prototype.has : null;
if (!exported && !$setHas) // eslint-disable-next-line no-unused-vars
exported = function isSet(x) {
    // `Set` does not have a `has` method
    return false;
};
module.exports = exported || function isSet(x) {
    if (!x || typeof x !== "object") return false;
    try {
        $setHas.call(x);
        if ($mapHas) try {
            $mapHas.call(x);
        } catch (e) {
            return true;
        }
        return x instanceof $Set; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
};

},{}],"jwM6R":[function(require,module,exports) {
"use strict";
var define = require("7a0bb7df335a6af");
var callBind = require("794ce1103c4a65ba");
var implementation = require("f52a71fcf365d3bd");
var getPolyfill = require("59addbaef079e040");
var shim = require("c0e8b0f7342ba484");
var polyfill = callBind(getPolyfill(), Object);
define(polyfill, {
    getPolyfill: getPolyfill,
    implementation: implementation,
    shim: shim
});
module.exports = polyfill;

},{"7a0bb7df335a6af":"lmPVn","794ce1103c4a65ba":"1LGPW","f52a71fcf365d3bd":"79eTN","59addbaef079e040":"4mctC","c0e8b0f7342ba484":"9jyNk"}],"79eTN":[function(require,module,exports) {
"use strict";
var numberIsNaN = function(value) {
    return value !== value;
};
module.exports = function is(a, b) {
    if (a === 0 && b === 0) return 1 / a === 1 / b;
    if (a === b) return true;
    if (numberIsNaN(a) && numberIsNaN(b)) return true;
    return false;
};

},{}],"4mctC":[function(require,module,exports) {
"use strict";
var implementation = require("ff80ab827617d6fd");
module.exports = function getPolyfill() {
    return typeof Object.is === "function" ? Object.is : implementation;
};

},{"ff80ab827617d6fd":"79eTN"}],"9jyNk":[function(require,module,exports) {
"use strict";
var getPolyfill = require("f188d636391a5061");
var define = require("155865cffc557cd");
module.exports = function shimObjectIs() {
    var polyfill = getPolyfill();
    define(Object, {
        is: polyfill
    }, {
        is: function testObjectIs() {
            return Object.is !== polyfill;
        }
    });
    return polyfill;
};

},{"f188d636391a5061":"4mctC","155865cffc557cd":"lmPVn"}],"bnrni":[function(require,module,exports) {
var toString = {}.toString;
module.exports = Array.isArray || function(arr) {
    return toString.call(arr) == "[object Array]";
};

},{}],"8G92T":[function(require,module,exports) {
"use strict";
var callBind = require("a30b9eee5dc55b4b");
var callBound = require("74346874006db20b");
var GetIntrinsic = require("2e6ed2d884c5409");
var isTypedArray = require("557c12dd5f95be9e");
var $ArrayBuffer = GetIntrinsic("ArrayBuffer", true);
var $Float32Array = GetIntrinsic("Float32Array", true);
var $byteLength = callBound("ArrayBuffer.prototype.byteLength", true);
// in node 0.10, ArrayBuffers have no prototype methods, but have an own slot-checking `slice` method
var abSlice = $ArrayBuffer && !$byteLength && new $ArrayBuffer().slice;
var $abSlice = abSlice && callBind(abSlice);
module.exports = $byteLength || $abSlice ? function isArrayBuffer(obj) {
    if (!obj || typeof obj !== "object") return false;
    try {
        if ($byteLength) $byteLength(obj);
        else $abSlice(obj, 0);
        return true;
    } catch (e) {
        return false;
    }
} : $Float32Array ? function IsArrayBuffer(obj) {
    try {
        return new $Float32Array(obj).buffer === obj && !isTypedArray(obj);
    } catch (e) {
        return typeof obj === "object" && e.name === "RangeError";
    }
} : function isArrayBuffer(obj) {
    return false;
};

},{"a30b9eee5dc55b4b":"1LGPW","74346874006db20b":"kSjLP","2e6ed2d884c5409":"21Wj0","557c12dd5f95be9e":"b0Kwd"}],"21Wj0":[function(require,module,exports) {
"use strict";
var undefined1;
var $SyntaxError = SyntaxError;
var $Function = Function;
var $TypeError = TypeError;
// eslint-disable-next-line consistent-return
var getEvalledConstructor = function(expressionSyntax) {
    try {
        return $Function('"use strict"; return (' + expressionSyntax + ").constructor;")();
    } catch (e) {}
};
var $gOPD = Object.getOwnPropertyDescriptor;
if ($gOPD) try {
    $gOPD({}, "");
} catch (e) {
    $gOPD = null; // this is IE 8, which has a broken gOPD
}
var throwTypeError = function() {
    throw new $TypeError();
};
var ThrowTypeError = $gOPD ? function() {
    try {
        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
        arguments.callee; // IE 8 does not throw here
        return throwTypeError;
    } catch (calleeThrows) {
        try {
            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
            return $gOPD(arguments, "callee").get;
        } catch (gOPDthrows) {
            return throwTypeError;
        }
    }
}() : throwTypeError;
var hasSymbols = require("91901063b4b0ea7e")();
var getProto = Object.getPrototypeOf || function(x) {
    return x.__proto__;
}; // eslint-disable-line no-proto
var needsEval = {};
var TypedArray = typeof Uint8Array === "undefined" ? undefined : getProto(Uint8Array);
var INTRINSICS = {
    "%AggregateError%": typeof AggregateError === "undefined" ? undefined : AggregateError,
    "%Array%": Array,
    "%ArrayBuffer%": typeof ArrayBuffer === "undefined" ? undefined : ArrayBuffer,
    "%ArrayIteratorPrototype%": hasSymbols ? getProto([][Symbol.iterator]()) : undefined,
    "%AsyncFromSyncIteratorPrototype%": undefined,
    "%AsyncFunction%": needsEval,
    "%AsyncGenerator%": needsEval,
    "%AsyncGeneratorFunction%": needsEval,
    "%AsyncIteratorPrototype%": needsEval,
    "%Atomics%": typeof Atomics === "undefined" ? undefined : Atomics,
    "%BigInt%": typeof BigInt === "undefined" ? undefined : BigInt,
    "%BigInt64Array%": typeof BigInt64Array === "undefined" ? undefined : BigInt64Array,
    "%BigUint64Array%": typeof BigUint64Array === "undefined" ? undefined : BigUint64Array,
    "%Boolean%": Boolean,
    "%DataView%": typeof DataView === "undefined" ? undefined : DataView,
    "%Date%": Date,
    "%decodeURI%": decodeURI,
    "%decodeURIComponent%": decodeURIComponent,
    "%encodeURI%": encodeURI,
    "%encodeURIComponent%": encodeURIComponent,
    "%Error%": Error,
    "%eval%": eval,
    "%EvalError%": EvalError,
    "%Float32Array%": typeof Float32Array === "undefined" ? undefined : Float32Array,
    "%Float64Array%": typeof Float64Array === "undefined" ? undefined : Float64Array,
    "%FinalizationRegistry%": typeof FinalizationRegistry === "undefined" ? undefined : FinalizationRegistry,
    "%Function%": $Function,
    "%GeneratorFunction%": needsEval,
    "%Int8Array%": typeof Int8Array === "undefined" ? undefined : Int8Array,
    "%Int16Array%": typeof Int16Array === "undefined" ? undefined : Int16Array,
    "%Int32Array%": typeof Int32Array === "undefined" ? undefined : Int32Array,
    "%isFinite%": isFinite,
    "%isNaN%": isNaN,
    "%IteratorPrototype%": hasSymbols ? getProto(getProto([][Symbol.iterator]())) : undefined,
    "%JSON%": typeof JSON === "object" ? JSON : undefined,
    "%Map%": typeof Map === "undefined" ? undefined : Map,
    "%MapIteratorPrototype%": typeof Map === "undefined" || !hasSymbols ? undefined : getProto(new Map()[Symbol.iterator]()),
    "%Math%": Math,
    "%Number%": Number,
    "%Object%": Object,
    "%parseFloat%": parseFloat,
    "%parseInt%": parseInt,
    "%Promise%": typeof Promise === "undefined" ? undefined : Promise,
    "%Proxy%": typeof Proxy === "undefined" ? undefined : Proxy,
    "%RangeError%": RangeError,
    "%ReferenceError%": ReferenceError,
    "%Reflect%": typeof Reflect === "undefined" ? undefined : Reflect,
    "%RegExp%": RegExp,
    "%Set%": typeof Set === "undefined" ? undefined : Set,
    "%SetIteratorPrototype%": typeof Set === "undefined" || !hasSymbols ? undefined : getProto(new Set()[Symbol.iterator]()),
    "%SharedArrayBuffer%": typeof SharedArrayBuffer === "undefined" ? undefined : SharedArrayBuffer,
    "%String%": String,
    "%StringIteratorPrototype%": hasSymbols ? getProto(""[Symbol.iterator]()) : undefined,
    "%Symbol%": hasSymbols ? Symbol : undefined,
    "%SyntaxError%": $SyntaxError,
    "%ThrowTypeError%": ThrowTypeError,
    "%TypedArray%": TypedArray,
    "%TypeError%": $TypeError,
    "%Uint8Array%": typeof Uint8Array === "undefined" ? undefined : Uint8Array,
    "%Uint8ClampedArray%": typeof Uint8ClampedArray === "undefined" ? undefined : Uint8ClampedArray,
    "%Uint16Array%": typeof Uint16Array === "undefined" ? undefined : Uint16Array,
    "%Uint32Array%": typeof Uint32Array === "undefined" ? undefined : Uint32Array,
    "%URIError%": URIError,
    "%WeakMap%": typeof WeakMap === "undefined" ? undefined : WeakMap,
    "%WeakRef%": typeof WeakRef === "undefined" ? undefined : WeakRef,
    "%WeakSet%": typeof WeakSet === "undefined" ? undefined : WeakSet
};
try {
    null.error; // eslint-disable-line no-unused-expressions
} catch (e) {
    // https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
    var errorProto = getProto(getProto(e));
    INTRINSICS["%Error.prototype%"] = errorProto;
}
var doEval = function doEval(name) {
    var value;
    if (name === "%AsyncFunction%") value = getEvalledConstructor("async function () {}");
    else if (name === "%GeneratorFunction%") value = getEvalledConstructor("function* () {}");
    else if (name === "%AsyncGeneratorFunction%") value = getEvalledConstructor("async function* () {}");
    else if (name === "%AsyncGenerator%") {
        var fn = doEval("%AsyncGeneratorFunction%");
        if (fn) value = fn.prototype;
    } else if (name === "%AsyncIteratorPrototype%") {
        var gen = doEval("%AsyncGenerator%");
        if (gen) value = getProto(gen.prototype);
    }
    INTRINSICS[name] = value;
    return value;
};
var LEGACY_ALIASES = {
    "%ArrayBufferPrototype%": [
        "ArrayBuffer",
        "prototype"
    ],
    "%ArrayPrototype%": [
        "Array",
        "prototype"
    ],
    "%ArrayProto_entries%": [
        "Array",
        "prototype",
        "entries"
    ],
    "%ArrayProto_forEach%": [
        "Array",
        "prototype",
        "forEach"
    ],
    "%ArrayProto_keys%": [
        "Array",
        "prototype",
        "keys"
    ],
    "%ArrayProto_values%": [
        "Array",
        "prototype",
        "values"
    ],
    "%AsyncFunctionPrototype%": [
        "AsyncFunction",
        "prototype"
    ],
    "%AsyncGenerator%": [
        "AsyncGeneratorFunction",
        "prototype"
    ],
    "%AsyncGeneratorPrototype%": [
        "AsyncGeneratorFunction",
        "prototype",
        "prototype"
    ],
    "%BooleanPrototype%": [
        "Boolean",
        "prototype"
    ],
    "%DataViewPrototype%": [
        "DataView",
        "prototype"
    ],
    "%DatePrototype%": [
        "Date",
        "prototype"
    ],
    "%ErrorPrototype%": [
        "Error",
        "prototype"
    ],
    "%EvalErrorPrototype%": [
        "EvalError",
        "prototype"
    ],
    "%Float32ArrayPrototype%": [
        "Float32Array",
        "prototype"
    ],
    "%Float64ArrayPrototype%": [
        "Float64Array",
        "prototype"
    ],
    "%FunctionPrototype%": [
        "Function",
        "prototype"
    ],
    "%Generator%": [
        "GeneratorFunction",
        "prototype"
    ],
    "%GeneratorPrototype%": [
        "GeneratorFunction",
        "prototype",
        "prototype"
    ],
    "%Int8ArrayPrototype%": [
        "Int8Array",
        "prototype"
    ],
    "%Int16ArrayPrototype%": [
        "Int16Array",
        "prototype"
    ],
    "%Int32ArrayPrototype%": [
        "Int32Array",
        "prototype"
    ],
    "%JSONParse%": [
        "JSON",
        "parse"
    ],
    "%JSONStringify%": [
        "JSON",
        "stringify"
    ],
    "%MapPrototype%": [
        "Map",
        "prototype"
    ],
    "%NumberPrototype%": [
        "Number",
        "prototype"
    ],
    "%ObjectPrototype%": [
        "Object",
        "prototype"
    ],
    "%ObjProto_toString%": [
        "Object",
        "prototype",
        "toString"
    ],
    "%ObjProto_valueOf%": [
        "Object",
        "prototype",
        "valueOf"
    ],
    "%PromisePrototype%": [
        "Promise",
        "prototype"
    ],
    "%PromiseProto_then%": [
        "Promise",
        "prototype",
        "then"
    ],
    "%Promise_all%": [
        "Promise",
        "all"
    ],
    "%Promise_reject%": [
        "Promise",
        "reject"
    ],
    "%Promise_resolve%": [
        "Promise",
        "resolve"
    ],
    "%RangeErrorPrototype%": [
        "RangeError",
        "prototype"
    ],
    "%ReferenceErrorPrototype%": [
        "ReferenceError",
        "prototype"
    ],
    "%RegExpPrototype%": [
        "RegExp",
        "prototype"
    ],
    "%SetPrototype%": [
        "Set",
        "prototype"
    ],
    "%SharedArrayBufferPrototype%": [
        "SharedArrayBuffer",
        "prototype"
    ],
    "%StringPrototype%": [
        "String",
        "prototype"
    ],
    "%SymbolPrototype%": [
        "Symbol",
        "prototype"
    ],
    "%SyntaxErrorPrototype%": [
        "SyntaxError",
        "prototype"
    ],
    "%TypedArrayPrototype%": [
        "TypedArray",
        "prototype"
    ],
    "%TypeErrorPrototype%": [
        "TypeError",
        "prototype"
    ],
    "%Uint8ArrayPrototype%": [
        "Uint8Array",
        "prototype"
    ],
    "%Uint8ClampedArrayPrototype%": [
        "Uint8ClampedArray",
        "prototype"
    ],
    "%Uint16ArrayPrototype%": [
        "Uint16Array",
        "prototype"
    ],
    "%Uint32ArrayPrototype%": [
        "Uint32Array",
        "prototype"
    ],
    "%URIErrorPrototype%": [
        "URIError",
        "prototype"
    ],
    "%WeakMapPrototype%": [
        "WeakMap",
        "prototype"
    ],
    "%WeakSetPrototype%": [
        "WeakSet",
        "prototype"
    ]
};
var bind = require("82cad20b6bdf47d0");
var hasOwn = require("5e48577c8473a5d1");
var $concat = bind.call(Function.call, Array.prototype.concat);
var $spliceApply = bind.call(Function.apply, Array.prototype.splice);
var $replace = bind.call(Function.call, String.prototype.replace);
var $strSlice = bind.call(Function.call, String.prototype.slice);
var $exec = bind.call(Function.call, RegExp.prototype.exec);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */ 
var stringToPath = function stringToPath(string) {
    var first = $strSlice(string, 0, 1);
    var last = $strSlice(string, -1);
    if (first === "%" && last !== "%") throw new $SyntaxError("invalid intrinsic syntax, expected closing `%`");
    else if (last === "%" && first !== "%") throw new $SyntaxError("invalid intrinsic syntax, expected opening `%`");
    var result = [];
    $replace(string, rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $replace(subString, reEscapeChar, "$1") : number || match;
    });
    return result;
};
/* end adaptation */ var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    var intrinsicName = name;
    var alias;
    if (hasOwn(LEGACY_ALIASES, intrinsicName)) {
        alias = LEGACY_ALIASES[intrinsicName];
        intrinsicName = "%" + alias[0] + "%";
    }
    if (hasOwn(INTRINSICS, intrinsicName)) {
        var value = INTRINSICS[intrinsicName];
        if (value === needsEval) value = doEval(intrinsicName);
        if (typeof value === "undefined" && !allowMissing) throw new $TypeError("intrinsic " + name + " exists, but is not available. Please file an issue!");
        return {
            alias: alias,
            name: intrinsicName,
            value: value
        };
    }
    throw new $SyntaxError("intrinsic " + name + " does not exist!");
};
module.exports = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== "string" || name.length === 0) throw new $TypeError("intrinsic name must be a non-empty string");
    if (arguments.length > 1 && typeof allowMissing !== "boolean") throw new $TypeError('"allowMissing" argument must be a boolean');
    if ($exec(/^%?[^%]*%?$/, name) === null) throw new $SyntaxError("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
    var parts = stringToPath(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : "";
    var intrinsic = getBaseIntrinsic("%" + intrinsicBaseName + "%", allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
        intrinsicBaseName = alias[0];
        $spliceApply(parts, $concat([
            0,
            1
        ], alias));
    }
    for(var i = 1, isOwn = true; i < parts.length; i += 1){
        var part = parts[i];
        var first = $strSlice(part, 0, 1);
        var last = $strSlice(part, -1);
        if ((first === '"' || first === "'" || first === "`" || last === '"' || last === "'" || last === "`") && first !== last) throw new $SyntaxError("property names with quotes must have matching quotes");
        if (part === "constructor" || !isOwn) skipFurtherCaching = true;
        intrinsicBaseName += "." + part;
        intrinsicRealName = "%" + intrinsicBaseName + "%";
        if (hasOwn(INTRINSICS, intrinsicRealName)) value = INTRINSICS[intrinsicRealName];
        else if (value != null) {
            if (!(part in value)) {
                if (!allowMissing) throw new $TypeError("base intrinsic for " + name + " exists, but the property is not available.");
                return void 0;
            }
            if ($gOPD && i + 1 >= parts.length) {
                var desc = $gOPD(value, part);
                isOwn = !!desc;
                // By convention, when a data property is converted to an accessor
                // property to emulate a data property that does not suffer from
                // the override mistake, that accessor's getter is marked with
                // an `originalValue` property. Here, when we detect this, we
                // uphold the illusion by pretending to see that original data
                // property, i.e., returning the value rather than the getter
                // itself.
                if (isOwn && "get" in desc && !("originalValue" in desc.get)) value = desc.get;
                else value = value[part];
            } else {
                isOwn = hasOwn(value, part);
                value = value[part];
            }
            if (isOwn && !skipFurtherCaching) INTRINSICS[intrinsicRealName] = value;
        }
    }
    return value;
};

},{"91901063b4b0ea7e":"Hzs91","82cad20b6bdf47d0":"jVVtB","5e48577c8473a5d1":"3bVv3"}],"b0Kwd":[function(require,module,exports) {
var global = arguments[3];
"use strict";
var forEach = require("68abe9b54a20c572");
var availableTypedArrays = require("aafd98fda33bbd57");
var callBound = require("a32527df8bf8b924");
var $toString = callBound("Object.prototype.toString");
var hasToStringTag = require("b3f7dbb937db3363")();
var gOPD = require("af60b1967ea134c8");
var g = typeof globalThis === "undefined" ? global : globalThis;
var typedArrays = availableTypedArrays();
var $indexOf = callBound("Array.prototype.indexOf", true) || function indexOf(array, value) {
    for(var i = 0; i < array.length; i += 1){
        if (array[i] === value) return i;
    }
    return -1;
};
var $slice = callBound("String.prototype.slice");
var toStrTags = {};
var getPrototypeOf = Object.getPrototypeOf; // require('getprototypeof');
if (hasToStringTag && gOPD && getPrototypeOf) forEach(typedArrays, function(typedArray) {
    var arr = new g[typedArray]();
    if (Symbol.toStringTag in arr) {
        var proto = getPrototypeOf(arr);
        var descriptor = gOPD(proto, Symbol.toStringTag);
        if (!descriptor) {
            var superProto = getPrototypeOf(proto);
            descriptor = gOPD(superProto, Symbol.toStringTag);
        }
        toStrTags[typedArray] = descriptor.get;
    }
});
var tryTypedArrays = function tryAllTypedArrays(value) {
    var anyTrue = false;
    forEach(toStrTags, function(getter, typedArray) {
        if (!anyTrue) try {
            anyTrue = getter.call(value) === typedArray;
        } catch (e) {}
    });
    return anyTrue;
};
module.exports = function isTypedArray(value) {
    if (!value || typeof value !== "object") return false;
    if (!hasToStringTag || !(Symbol.toStringTag in value)) {
        var tag = $slice($toString(value), 8, -1);
        return $indexOf(typedArrays, tag) > -1;
    }
    if (!gOPD) return false;
    return tryTypedArrays(value);
};

},{"68abe9b54a20c572":"cL9Ij","aafd98fda33bbd57":"28rP5","a32527df8bf8b924":"kSjLP","b3f7dbb937db3363":"3BxV8","af60b1967ea134c8":"6z83T"}],"cL9Ij":[function(require,module,exports) {
"use strict";
var isCallable = require("e50ebc24bbb25feb");
var toStr = Object.prototype.toString;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var forEachArray = function forEachArray(array, iterator, receiver) {
    for(var i = 0, len = array.length; i < len; i++)if (hasOwnProperty.call(array, i)) {
        if (receiver == null) iterator(array[i], i, array);
        else iterator.call(receiver, array[i], i, array);
    }
};
var forEachString = function forEachString(string, iterator, receiver) {
    for(var i = 0, len = string.length; i < len; i++)// no such thing as a sparse string.
    if (receiver == null) iterator(string.charAt(i), i, string);
    else iterator.call(receiver, string.charAt(i), i, string);
};
var forEachObject = function forEachObject(object, iterator, receiver) {
    for(var k in object)if (hasOwnProperty.call(object, k)) {
        if (receiver == null) iterator(object[k], k, object);
        else iterator.call(receiver, object[k], k, object);
    }
};
var forEach = function forEach(list, iterator, thisArg) {
    if (!isCallable(iterator)) throw new TypeError("iterator must be a function");
    var receiver;
    if (arguments.length >= 3) receiver = thisArg;
    if (toStr.call(list) === "[object Array]") forEachArray(list, iterator, receiver);
    else if (typeof list === "string") forEachString(list, iterator, receiver);
    else forEachObject(list, iterator, receiver);
};
module.exports = forEach;

},{"e50ebc24bbb25feb":"aXmHc"}],"aXmHc":[function(require,module,exports) {
"use strict";
var fnToStr = Function.prototype.toString;
var reflectApply = typeof Reflect === "object" && Reflect !== null && Reflect.apply;
var badArrayLike;
var isCallableMarker;
if (typeof reflectApply === "function" && typeof Object.defineProperty === "function") try {
    badArrayLike = Object.defineProperty({}, "length", {
        get: function() {
            throw isCallableMarker;
        }
    });
    isCallableMarker = {};
    // eslint-disable-next-line no-throw-literal
    reflectApply(function() {
        throw 42;
    }, null, badArrayLike);
} catch (_) {
    if (_ !== isCallableMarker) reflectApply = null;
}
else reflectApply = null;
var constructorRegex = /^\s*class\b/;
var isES6ClassFn = function isES6ClassFunction(value) {
    try {
        var fnStr = fnToStr.call(value);
        return constructorRegex.test(fnStr);
    } catch (e) {
        return false; // not a function
    }
};
var tryFunctionObject = function tryFunctionToStr(value) {
    try {
        if (isES6ClassFn(value)) return false;
        fnToStr.call(value);
        return true;
    } catch (e) {
        return false;
    }
};
var toStr = Object.prototype.toString;
var objectClass = "[object Object]";
var fnClass = "[object Function]";
var genClass = "[object GeneratorFunction]";
var ddaClass = "[object HTMLAllCollection]"; // IE 11
var ddaClass2 = "[object HTML document.all class]";
var ddaClass3 = "[object HTMLCollection]"; // IE 9-10
var hasToStringTag = typeof Symbol === "function" && !!Symbol.toStringTag; // better: use `has-tostringtag`
var isIE68 = !(0 in [
    , 
]); // eslint-disable-line no-sparse-arrays, comma-spacing
var isDDA = function isDocumentDotAll() {
    return false;
};
if (typeof document === "object") {
    // Firefox 3 canonicalizes DDA to undefined when it's not accessed directly
    var all = document.all;
    if (toStr.call(all) === toStr.call(document.all)) isDDA = function isDocumentDotAll(value) {
        /* globals document: false */ // in IE 6-8, typeof document.all is "object" and it's truthy
        if ((isIE68 || !value) && (typeof value === "undefined" || typeof value === "object")) try {
            var str = toStr.call(value);
            return (str === ddaClass || str === ddaClass2 || str === ddaClass3 // opera 12.16
             || str === objectClass // IE 6-8
            ) && value("") == null; // eslint-disable-line eqeqeq
        } catch (e) {}
        return false;
    };
}
module.exports = reflectApply ? function isCallable(value) {
    if (isDDA(value)) return true;
    if (!value) return false;
    if (typeof value !== "function" && typeof value !== "object") return false;
    try {
        reflectApply(value, null, badArrayLike);
    } catch (e) {
        if (e !== isCallableMarker) return false;
    }
    return !isES6ClassFn(value) && tryFunctionObject(value);
} : function isCallable(value) {
    if (isDDA(value)) return true;
    if (!value) return false;
    if (typeof value !== "function" && typeof value !== "object") return false;
    if (hasToStringTag) return tryFunctionObject(value);
    if (isES6ClassFn(value)) return false;
    var strClass = toStr.call(value);
    if (strClass !== fnClass && strClass !== genClass && !/^\[object HTML/.test(strClass)) return false;
    return tryFunctionObject(value);
};

},{}],"28rP5":[function(require,module,exports) {
var global = arguments[3];
"use strict";
var possibleNames = [
    "BigInt64Array",
    "BigUint64Array",
    "Float32Array",
    "Float64Array",
    "Int16Array",
    "Int32Array",
    "Int8Array",
    "Uint16Array",
    "Uint32Array",
    "Uint8Array",
    "Uint8ClampedArray"
];
var g = typeof globalThis === "undefined" ? global : globalThis;
module.exports = function availableTypedArrays() {
    var out = [];
    for(var i = 0; i < possibleNames.length; i++)if (typeof g[possibleNames[i]] === "function") out[out.length] = possibleNames[i];
    return out;
};

},{}],"6z83T":[function(require,module,exports) {
"use strict";
var GetIntrinsic = require("693e651525841e04");
var $gOPD = GetIntrinsic("%Object.getOwnPropertyDescriptor%", true);
if ($gOPD) try {
    $gOPD([], "length");
} catch (e) {
    // IE 8 has a broken gOPD
    $gOPD = null;
}
module.exports = $gOPD;

},{"693e651525841e04":"fTq9o"}],"3KJ9j":[function(require,module,exports) {
"use strict";
var getDay = Date.prototype.getDay;
var tryDateObject = function tryDateGetDayCall(value) {
    try {
        getDay.call(value);
        return true;
    } catch (e) {
        return false;
    }
};
var toStr = Object.prototype.toString;
var dateClass = "[object Date]";
var hasToStringTag = require("8af699f0ba606fc1")();
module.exports = function isDateObject(value) {
    if (typeof value !== "object" || value === null) return false;
    return hasToStringTag ? tryDateObject(value) : toStr.call(value) === dateClass;
};

},{"8af699f0ba606fc1":"3BxV8"}],"ftIEQ":[function(require,module,exports) {
"use strict";
var callBound = require("31d6400741845ec");
var $byteLength = callBound("SharedArrayBuffer.prototype.byteLength", true);
module.exports = $byteLength ? function isSharedArrayBuffer(obj) {
    if (!obj || typeof obj !== "object") return false;
    try {
        $byteLength(obj);
        return true;
    } catch (e) {
        return false;
    }
} : function isSharedArrayBuffer(obj) {
    return false;
};

},{"31d6400741845ec":"kSjLP"}],"eU8hw":[function(require,module,exports) {
"use strict";
var isString = require("11d3feda75cd5852");
var isNumber = require("a2d99dd0b4e7e2f");
var isBoolean = require("276e2da6a047a0b8");
var isSymbol = require("d5677c34fc7072a0");
var isBigInt = require("56526aa18a4172fb");
// eslint-disable-next-line consistent-return
module.exports = function whichBoxedPrimitive(value) {
    // eslint-disable-next-line eqeqeq
    if (value == null || typeof value !== "object" && typeof value !== "function") return null;
    if (isString(value)) return "String";
    if (isNumber(value)) return "Number";
    if (isBoolean(value)) return "Boolean";
    if (isSymbol(value)) return "Symbol";
    if (isBigInt(value)) return "BigInt";
};

},{"11d3feda75cd5852":"46YIA","a2d99dd0b4e7e2f":"jfXmW","276e2da6a047a0b8":"akNy6","d5677c34fc7072a0":"lWRY6","56526aa18a4172fb":"aizHH"}],"jfXmW":[function(require,module,exports) {
"use strict";
var numToStr = Number.prototype.toString;
var tryNumberObject = function tryNumberObject(value) {
    try {
        numToStr.call(value);
        return true;
    } catch (e) {
        return false;
    }
};
var toStr = Object.prototype.toString;
var numClass = "[object Number]";
var hasToStringTag = require("6c3ebb022928d133")();
module.exports = function isNumberObject(value) {
    if (typeof value === "number") return true;
    if (typeof value !== "object") return false;
    return hasToStringTag ? tryNumberObject(value) : toStr.call(value) === numClass;
};

},{"6c3ebb022928d133":"3BxV8"}],"akNy6":[function(require,module,exports) {
"use strict";
var callBound = require("84f959c52b4cc86");
var $boolToStr = callBound("Boolean.prototype.toString");
var $toString = callBound("Object.prototype.toString");
var tryBooleanObject = function booleanBrandCheck(value) {
    try {
        $boolToStr(value);
        return true;
    } catch (e) {
        return false;
    }
};
var boolClass = "[object Boolean]";
var hasToStringTag = require("c7e31dd187752fb0")();
module.exports = function isBoolean(value) {
    if (typeof value === "boolean") return true;
    if (value === null || typeof value !== "object") return false;
    return hasToStringTag && Symbol.toStringTag in value ? tryBooleanObject(value) : $toString(value) === boolClass;
};

},{"84f959c52b4cc86":"kSjLP","c7e31dd187752fb0":"3BxV8"}],"aizHH":[function(require,module,exports) {
"use strict";
var hasBigInts = require("5d154ac48fe82ab8")();
if (hasBigInts) {
    var bigIntValueOf = BigInt.prototype.valueOf;
    var tryBigInt = function tryBigIntObject(value) {
        try {
            bigIntValueOf.call(value);
            return true;
        } catch (e) {}
        return false;
    };
    module.exports = function isBigInt(value) {
        if (value === null || typeof value === "undefined" || typeof value === "boolean" || typeof value === "string" || typeof value === "number" || typeof value === "symbol" || typeof value === "function") return false;
        if (typeof value === "bigint") return true;
        return tryBigInt(value);
    };
} else module.exports = function isBigInt(value) {
    return false;
};

},{"5d154ac48fe82ab8":"a8WQy"}],"a8WQy":[function(require,module,exports) {
"use strict";
var $BigInt = typeof BigInt !== "undefined" && BigInt;
module.exports = function hasNativeBigInts() {
    return typeof $BigInt === "function" && typeof BigInt === "function" && typeof $BigInt(42) === "bigint" // eslint-disable-line no-magic-numbers
     && typeof BigInt(42) === "bigint"; // eslint-disable-line no-magic-numbers
};

},{}],"jKiEg":[function(require,module,exports) {
"use strict";
var isMap = require("d4cc45a59360005a");
var isSet = require("4af25f4aa4b77a83");
var isWeakMap = require("d0ab6821281ca1fa");
var isWeakSet = require("d25c2dcce56d3a64");
module.exports = function whichCollection(value) {
    if (value && typeof value === "object") {
        if (isMap(value)) return "Map";
        if (isSet(value)) return "Set";
        if (isWeakMap(value)) return "WeakMap";
        if (isWeakSet(value)) return "WeakSet";
    }
    return false;
};

},{"d4cc45a59360005a":"fW0xt","4af25f4aa4b77a83":"lzH19","d0ab6821281ca1fa":"d0Ddi","d25c2dcce56d3a64":"j9D81"}],"fW0xt":[function(require,module,exports) {
"use strict";
var $Map = typeof Map === "function" && Map.prototype ? Map : null;
var $Set = typeof Set === "function" && Set.prototype ? Set : null;
var exported;
if (!$Map) // eslint-disable-next-line no-unused-vars
exported = function isMap(x) {
    // `Map` is not present in this environment.
    return false;
};
var $mapHas = $Map ? Map.prototype.has : null;
var $setHas = $Set ? Set.prototype.has : null;
if (!exported && !$mapHas) // eslint-disable-next-line no-unused-vars
exported = function isMap(x) {
    // `Map` does not have a `has` method
    return false;
};
module.exports = exported || function isMap(x) {
    if (!x || typeof x !== "object") return false;
    try {
        $mapHas.call(x);
        if ($setHas) try {
            $setHas.call(x);
        } catch (e) {
            return true;
        }
        return x instanceof $Map; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
};

},{}],"lzH19":[function(require,module,exports) {
"use strict";
var $Map = typeof Map === "function" && Map.prototype ? Map : null;
var $Set = typeof Set === "function" && Set.prototype ? Set : null;
var exported;
if (!$Set) // eslint-disable-next-line no-unused-vars
exported = function isSet(x) {
    // `Set` is not present in this environment.
    return false;
};
var $mapHas = $Map ? Map.prototype.has : null;
var $setHas = $Set ? Set.prototype.has : null;
if (!exported && !$setHas) // eslint-disable-next-line no-unused-vars
exported = function isSet(x) {
    // `Set` does not have a `has` method
    return false;
};
module.exports = exported || function isSet(x) {
    if (!x || typeof x !== "object") return false;
    try {
        $setHas.call(x);
        if ($mapHas) try {
            $mapHas.call(x);
        } catch (e) {
            return true;
        }
        return x instanceof $Set; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
};

},{}],"d0Ddi":[function(require,module,exports) {
"use strict";
var $WeakMap = typeof WeakMap === "function" && WeakMap.prototype ? WeakMap : null;
var $WeakSet = typeof WeakSet === "function" && WeakSet.prototype ? WeakSet : null;
var exported;
if (!$WeakMap) // eslint-disable-next-line no-unused-vars
exported = function isWeakMap(x) {
    // `WeakMap` is not present in this environment.
    return false;
};
var $mapHas = $WeakMap ? $WeakMap.prototype.has : null;
var $setHas = $WeakSet ? $WeakSet.prototype.has : null;
if (!exported && !$mapHas) // eslint-disable-next-line no-unused-vars
exported = function isWeakMap(x) {
    // `WeakMap` does not have a `has` method
    return false;
};
module.exports = exported || function isWeakMap(x) {
    if (!x || typeof x !== "object") return false;
    try {
        $mapHas.call(x, $mapHas);
        if ($setHas) try {
            $setHas.call(x, $setHas);
        } catch (e) {
            return true;
        }
        return x instanceof $WeakMap; // core-js workaround, pre-v3
    } catch (e) {}
    return false;
};

},{}],"j9D81":[function(require,module,exports) {
"use strict";
var GetIntrinsic = require("5468f65dce743940");
var callBound = require("14572863a8d182c1");
var $WeakSet = GetIntrinsic("%WeakSet%", true);
var $setHas = callBound("WeakSet.prototype.has", true);
if ($setHas) {
    var $mapHas = callBound("WeakMap.prototype.has", true);
    module.exports = function isWeakSet(x) {
        if (!x || typeof x !== "object") return false;
        try {
            $setHas(x, $setHas);
            if ($mapHas) try {
                $mapHas(x, $mapHas);
            } catch (e) {
                return true;
            }
            return x instanceof $WeakSet; // core-js workaround, pre-v3
        } catch (e) {}
        return false;
    };
} else // eslint-disable-next-line no-unused-vars
module.exports = function isWeakSet(x) {
    // `WeakSet` does not exist, or does not have a `has` method
    return false;
};

},{"5468f65dce743940":"fTq9o","14572863a8d182c1":"kSjLP"}],"8TYZK":[function(require,module,exports) {
var global = arguments[3];
"use strict";
var forEach = require("2941d48f36957e3c");
var availableTypedArrays = require("beaf5502a5823cce");
var callBound = require("83f633f9b335db8f");
var gOPD = require("ce6b45c571ba4e3e");
var $toString = callBound("Object.prototype.toString");
var hasToStringTag = require("9e7ef6c88184c56")();
var g = typeof globalThis === "undefined" ? global : globalThis;
var typedArrays = availableTypedArrays();
var $slice = callBound("String.prototype.slice");
var toStrTags = {};
var getPrototypeOf = Object.getPrototypeOf; // require('getprototypeof');
if (hasToStringTag && gOPD && getPrototypeOf) forEach(typedArrays, function(typedArray) {
    if (typeof g[typedArray] === "function") {
        var arr = new g[typedArray]();
        if (Symbol.toStringTag in arr) {
            var proto = getPrototypeOf(arr);
            var descriptor = gOPD(proto, Symbol.toStringTag);
            if (!descriptor) {
                var superProto = getPrototypeOf(proto);
                descriptor = gOPD(superProto, Symbol.toStringTag);
            }
            toStrTags[typedArray] = descriptor.get;
        }
    }
});
var tryTypedArrays = function tryAllTypedArrays(value) {
    var foundName = false;
    forEach(toStrTags, function(getter, typedArray) {
        if (!foundName) try {
            var name = getter.call(value);
            if (name === typedArray) foundName = name;
        } catch (e) {}
    });
    return foundName;
};
var isTypedArray = require("41b5d056a91a2f13");
module.exports = function whichTypedArray(value) {
    if (!isTypedArray(value)) return false;
    if (!hasToStringTag || !(Symbol.toStringTag in value)) return $slice($toString(value), 8, -1);
    return tryTypedArrays(value);
};

},{"2941d48f36957e3c":"cL9Ij","beaf5502a5823cce":"28rP5","83f633f9b335db8f":"kSjLP","ce6b45c571ba4e3e":"6z83T","9e7ef6c88184c56":"3BxV8","41b5d056a91a2f13":"b0Kwd"}],"gSHJL":[function(require,module,exports) {
"use strict";
var callBound = require("b1b8e13ecd9287a7");
var $byteLength = callBound("ArrayBuffer.prototype.byteLength", true);
var isArrayBuffer = require("6382a20b4706fa1a");
module.exports = function byteLength(ab) {
    if (!isArrayBuffer(ab)) return NaN;
    return $byteLength ? $byteLength(ab) : ab.byteLength;
}; // in node < 0.11, byteLength is an own nonconfigurable property

},{"b1b8e13ecd9287a7":"kSjLP","6382a20b4706fa1a":"8G92T"}],"6pWDi":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _iterationDecorator = _interopRequireDefault(require("87b12bfba4713bc4"));
var _rolesMap = _interopRequireDefault(require("97dfeab47ccc381d"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (!it) {
        if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e2) {
                    throw _e2;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = it.call(o);
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e3) {
            didErr = true;
            err = _e3;
        },
        f: function f() {
            try {
                if (!normalCompletion && it.return != null) it.return();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var roleElement = [];
var keys = _rolesMap.default.keys();
var _loop = function _loop(i) {
    var key = keys[i];
    var role = _rolesMap.default.get(key);
    if (role) {
        var concepts = [].concat(role.baseConcepts, role.relatedConcepts);
        for(var k = 0; k < concepts.length; k++){
            var relation = concepts[k];
            if (relation.module === "HTML") {
                var concept = relation.concept;
                if (concept) {
                    var roleElementRelation = roleElement.find(function(item) {
                        return item[0] === key;
                    });
                    var relationConcepts = void 0;
                    if (roleElementRelation) relationConcepts = roleElementRelation[1];
                    else relationConcepts = [];
                    relationConcepts.push(concept);
                    roleElement.push([
                        key,
                        relationConcepts
                    ]);
                }
            }
        }
    }
};
for(var i = 0; i < keys.length; i++)_loop(i);
var roleElementMap = {
    entries: function entries() {
        return roleElement;
    },
    forEach: function forEach(fn) {
        var thisArg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        var _iterator = _createForOfIteratorHelper(roleElement), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var _step$value = _slicedToArray(_step.value, 2), key = _step$value[0], values = _step$value[1];
                fn.call(thisArg, values, key, roleElement);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
    },
    get: function get(key) {
        var item = roleElement.find(function(tuple) {
            return tuple[0] === key ? true : false;
        });
        return item && item[1];
    },
    has: function has(key) {
        return !!roleElementMap.get(key);
    },
    keys: function keys() {
        return roleElement.map(function(_ref) {
            var _ref2 = _slicedToArray(_ref, 1), key = _ref2[0];
            return key;
        });
    },
    values: function values() {
        return roleElement.map(function(_ref3) {
            var _ref4 = _slicedToArray(_ref3, 2), values = _ref4[1];
            return values;
        });
    }
};
var _default = (0, _iterationDecorator.default)(roleElementMap, roleElementMap.entries());
exports.default = _default;

},{"87b12bfba4713bc4":"doGnk","97dfeab47ccc381d":"4vhJn"}],"ahc0m":[function(require,module,exports) {
// Copyright (c) 2013 Pieroxy <pieroxy@pieroxy.net>
// This work is free. You can redistribute it and/or modify it
// under the terms of the WTFPL, Version 2
// For more information see LICENSE.txt or http://www.wtfpl.net/
//
// For more information, the home page:
// http://pieroxy.net/blog/pages/lz-string/testing.html
//
// LZ-based compression algorithm, version 1.4.5
var LZString = function() {
    // private property
    var f = String.fromCharCode;
    var keyStrBase64 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
    var keyStrUriSafe = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+-$";
    var baseReverseDic = {};
    function getBaseValue(alphabet, character) {
        if (!baseReverseDic[alphabet]) {
            baseReverseDic[alphabet] = {};
            for(var i = 0; i < alphabet.length; i++)baseReverseDic[alphabet][alphabet.charAt(i)] = i;
        }
        return baseReverseDic[alphabet][character];
    }
    var LZString = {
        compressToBase64: function(input) {
            if (input == null) return "";
            var res = LZString._compress(input, 6, function(a) {
                return keyStrBase64.charAt(a);
            });
            switch(res.length % 4){
                default:
                case 0:
                    return res;
                case 1:
                    return res + "===";
                case 2:
                    return res + "==";
                case 3:
                    return res + "=";
            }
        },
        decompressFromBase64: function(input) {
            if (input == null) return "";
            if (input == "") return null;
            return LZString._decompress(input.length, 32, function(index) {
                return getBaseValue(keyStrBase64, input.charAt(index));
            });
        },
        compressToUTF16: function(input) {
            if (input == null) return "";
            return LZString._compress(input, 15, function(a) {
                return f(a + 32);
            }) + " ";
        },
        decompressFromUTF16: function(compressed) {
            if (compressed == null) return "";
            if (compressed == "") return null;
            return LZString._decompress(compressed.length, 16384, function(index) {
                return compressed.charCodeAt(index) - 32;
            });
        },
        //compress into uint8array (UCS-2 big endian format)
        compressToUint8Array: function(uncompressed) {
            var compressed = LZString.compress(uncompressed);
            var buf = new Uint8Array(compressed.length * 2); // 2 bytes per character
            for(var i = 0, TotalLen = compressed.length; i < TotalLen; i++){
                var current_value = compressed.charCodeAt(i);
                buf[i * 2] = current_value >>> 8;
                buf[i * 2 + 1] = current_value % 256;
            }
            return buf;
        },
        //decompress from uint8array (UCS-2 big endian format)
        decompressFromUint8Array: function(compressed) {
            if (compressed === null || compressed === undefined) return LZString.decompress(compressed);
            else {
                var buf = new Array(compressed.length / 2); // 2 bytes per character
                for(var i = 0, TotalLen = buf.length; i < TotalLen; i++)buf[i] = compressed[i * 2] * 256 + compressed[i * 2 + 1];
                var result = [];
                buf.forEach(function(c) {
                    result.push(f(c));
                });
                return LZString.decompress(result.join(""));
            }
        },
        //compress into a string that is already URI encoded
        compressToEncodedURIComponent: function(input) {
            if (input == null) return "";
            return LZString._compress(input, 6, function(a) {
                return keyStrUriSafe.charAt(a);
            });
        },
        //decompress from an output of compressToEncodedURIComponent
        decompressFromEncodedURIComponent: function(input) {
            if (input == null) return "";
            if (input == "") return null;
            input = input.replace(/ /g, "+");
            return LZString._decompress(input.length, 32, function(index) {
                return getBaseValue(keyStrUriSafe, input.charAt(index));
            });
        },
        compress: function(uncompressed) {
            return LZString._compress(uncompressed, 16, function(a) {
                return f(a);
            });
        },
        _compress: function(uncompressed, bitsPerChar, getCharFromInt) {
            if (uncompressed == null) return "";
            var i, value, context_dictionary = {}, context_dictionaryToCreate = {}, context_c = "", context_wc = "", context_w = "", context_enlargeIn = 2, context_dictSize = 3, context_numBits = 2, context_data = [], context_data_val = 0, context_data_position = 0, ii;
            for(ii = 0; ii < uncompressed.length; ii += 1){
                context_c = uncompressed.charAt(ii);
                if (!Object.prototype.hasOwnProperty.call(context_dictionary, context_c)) {
                    context_dictionary[context_c] = context_dictSize++;
                    context_dictionaryToCreate[context_c] = true;
                }
                context_wc = context_w + context_c;
                if (Object.prototype.hasOwnProperty.call(context_dictionary, context_wc)) context_w = context_wc;
                else {
                    if (Object.prototype.hasOwnProperty.call(context_dictionaryToCreate, context_w)) {
                        if (context_w.charCodeAt(0) < 256) {
                            for(i = 0; i < context_numBits; i++){
                                context_data_val = context_data_val << 1;
                                if (context_data_position == bitsPerChar - 1) {
                                    context_data_position = 0;
                                    context_data.push(getCharFromInt(context_data_val));
                                    context_data_val = 0;
                                } else context_data_position++;
                            }
                            value = context_w.charCodeAt(0);
                            for(i = 0; i < 8; i++){
                                context_data_val = context_data_val << 1 | value & 1;
                                if (context_data_position == bitsPerChar - 1) {
                                    context_data_position = 0;
                                    context_data.push(getCharFromInt(context_data_val));
                                    context_data_val = 0;
                                } else context_data_position++;
                                value = value >> 1;
                            }
                        } else {
                            value = 1;
                            for(i = 0; i < context_numBits; i++){
                                context_data_val = context_data_val << 1 | value;
                                if (context_data_position == bitsPerChar - 1) {
                                    context_data_position = 0;
                                    context_data.push(getCharFromInt(context_data_val));
                                    context_data_val = 0;
                                } else context_data_position++;
                                value = 0;
                            }
                            value = context_w.charCodeAt(0);
                            for(i = 0; i < 16; i++){
                                context_data_val = context_data_val << 1 | value & 1;
                                if (context_data_position == bitsPerChar - 1) {
                                    context_data_position = 0;
                                    context_data.push(getCharFromInt(context_data_val));
                                    context_data_val = 0;
                                } else context_data_position++;
                                value = value >> 1;
                            }
                        }
                        context_enlargeIn--;
                        if (context_enlargeIn == 0) {
                            context_enlargeIn = Math.pow(2, context_numBits);
                            context_numBits++;
                        }
                        delete context_dictionaryToCreate[context_w];
                    } else {
                        value = context_dictionary[context_w];
                        for(i = 0; i < context_numBits; i++){
                            context_data_val = context_data_val << 1 | value & 1;
                            if (context_data_position == bitsPerChar - 1) {
                                context_data_position = 0;
                                context_data.push(getCharFromInt(context_data_val));
                                context_data_val = 0;
                            } else context_data_position++;
                            value = value >> 1;
                        }
                    }
                    context_enlargeIn--;
                    if (context_enlargeIn == 0) {
                        context_enlargeIn = Math.pow(2, context_numBits);
                        context_numBits++;
                    }
                    // Add wc to the dictionary.
                    context_dictionary[context_wc] = context_dictSize++;
                    context_w = String(context_c);
                }
            }
            // Output the code for w.
            if (context_w !== "") {
                if (Object.prototype.hasOwnProperty.call(context_dictionaryToCreate, context_w)) {
                    if (context_w.charCodeAt(0) < 256) {
                        for(i = 0; i < context_numBits; i++){
                            context_data_val = context_data_val << 1;
                            if (context_data_position == bitsPerChar - 1) {
                                context_data_position = 0;
                                context_data.push(getCharFromInt(context_data_val));
                                context_data_val = 0;
                            } else context_data_position++;
                        }
                        value = context_w.charCodeAt(0);
                        for(i = 0; i < 8; i++){
                            context_data_val = context_data_val << 1 | value & 1;
                            if (context_data_position == bitsPerChar - 1) {
                                context_data_position = 0;
                                context_data.push(getCharFromInt(context_data_val));
                                context_data_val = 0;
                            } else context_data_position++;
                            value = value >> 1;
                        }
                    } else {
                        value = 1;
                        for(i = 0; i < context_numBits; i++){
                            context_data_val = context_data_val << 1 | value;
                            if (context_data_position == bitsPerChar - 1) {
                                context_data_position = 0;
                                context_data.push(getCharFromInt(context_data_val));
                                context_data_val = 0;
                            } else context_data_position++;
                            value = 0;
                        }
                        value = context_w.charCodeAt(0);
                        for(i = 0; i < 16; i++){
                            context_data_val = context_data_val << 1 | value & 1;
                            if (context_data_position == bitsPerChar - 1) {
                                context_data_position = 0;
                                context_data.push(getCharFromInt(context_data_val));
                                context_data_val = 0;
                            } else context_data_position++;
                            value = value >> 1;
                        }
                    }
                    context_enlargeIn--;
                    if (context_enlargeIn == 0) {
                        context_enlargeIn = Math.pow(2, context_numBits);
                        context_numBits++;
                    }
                    delete context_dictionaryToCreate[context_w];
                } else {
                    value = context_dictionary[context_w];
                    for(i = 0; i < context_numBits; i++){
                        context_data_val = context_data_val << 1 | value & 1;
                        if (context_data_position == bitsPerChar - 1) {
                            context_data_position = 0;
                            context_data.push(getCharFromInt(context_data_val));
                            context_data_val = 0;
                        } else context_data_position++;
                        value = value >> 1;
                    }
                }
                context_enlargeIn--;
                if (context_enlargeIn == 0) {
                    context_enlargeIn = Math.pow(2, context_numBits);
                    context_numBits++;
                }
            }
            // Mark the end of the stream
            value = 2;
            for(i = 0; i < context_numBits; i++){
                context_data_val = context_data_val << 1 | value & 1;
                if (context_data_position == bitsPerChar - 1) {
                    context_data_position = 0;
                    context_data.push(getCharFromInt(context_data_val));
                    context_data_val = 0;
                } else context_data_position++;
                value = value >> 1;
            }
            // Flush the last char
            while(true){
                context_data_val = context_data_val << 1;
                if (context_data_position == bitsPerChar - 1) {
                    context_data.push(getCharFromInt(context_data_val));
                    break;
                } else context_data_position++;
            }
            return context_data.join("");
        },
        decompress: function(compressed) {
            if (compressed == null) return "";
            if (compressed == "") return null;
            return LZString._decompress(compressed.length, 32768, function(index) {
                return compressed.charCodeAt(index);
            });
        },
        _decompress: function(length, resetValue, getNextValue) {
            var dictionary = [], next, enlargeIn = 4, dictSize = 4, numBits = 3, entry = "", result = [], i, w, bits, resb, maxpower, power, c, data = {
                val: getNextValue(0),
                position: resetValue,
                index: 1
            };
            for(i = 0; i < 3; i += 1)dictionary[i] = i;
            bits = 0;
            maxpower = Math.pow(2, 2);
            power = 1;
            while(power != maxpower){
                resb = data.val & data.position;
                data.position >>= 1;
                if (data.position == 0) {
                    data.position = resetValue;
                    data.val = getNextValue(data.index++);
                }
                bits |= (resb > 0 ? 1 : 0) * power;
                power <<= 1;
            }
            switch(next = bits){
                case 0:
                    bits = 0;
                    maxpower = Math.pow(2, 8);
                    power = 1;
                    while(power != maxpower){
                        resb = data.val & data.position;
                        data.position >>= 1;
                        if (data.position == 0) {
                            data.position = resetValue;
                            data.val = getNextValue(data.index++);
                        }
                        bits |= (resb > 0 ? 1 : 0) * power;
                        power <<= 1;
                    }
                    c = f(bits);
                    break;
                case 1:
                    bits = 0;
                    maxpower = Math.pow(2, 16);
                    power = 1;
                    while(power != maxpower){
                        resb = data.val & data.position;
                        data.position >>= 1;
                        if (data.position == 0) {
                            data.position = resetValue;
                            data.val = getNextValue(data.index++);
                        }
                        bits |= (resb > 0 ? 1 : 0) * power;
                        power <<= 1;
                    }
                    c = f(bits);
                    break;
                case 2:
                    return "";
            }
            dictionary[3] = c;
            w = c;
            result.push(c);
            while(true){
                if (data.index > length) return "";
                bits = 0;
                maxpower = Math.pow(2, numBits);
                power = 1;
                while(power != maxpower){
                    resb = data.val & data.position;
                    data.position >>= 1;
                    if (data.position == 0) {
                        data.position = resetValue;
                        data.val = getNextValue(data.index++);
                    }
                    bits |= (resb > 0 ? 1 : 0) * power;
                    power <<= 1;
                }
                switch(c = bits){
                    case 0:
                        bits = 0;
                        maxpower = Math.pow(2, 8);
                        power = 1;
                        while(power != maxpower){
                            resb = data.val & data.position;
                            data.position >>= 1;
                            if (data.position == 0) {
                                data.position = resetValue;
                                data.val = getNextValue(data.index++);
                            }
                            bits |= (resb > 0 ? 1 : 0) * power;
                            power <<= 1;
                        }
                        dictionary[dictSize++] = f(bits);
                        c = dictSize - 1;
                        enlargeIn--;
                        break;
                    case 1:
                        bits = 0;
                        maxpower = Math.pow(2, 16);
                        power = 1;
                        while(power != maxpower){
                            resb = data.val & data.position;
                            data.position >>= 1;
                            if (data.position == 0) {
                                data.position = resetValue;
                                data.val = getNextValue(data.index++);
                            }
                            bits |= (resb > 0 ? 1 : 0) * power;
                            power <<= 1;
                        }
                        dictionary[dictSize++] = f(bits);
                        c = dictSize - 1;
                        enlargeIn--;
                        break;
                    case 2:
                        return result.join("");
                }
                if (enlargeIn == 0) {
                    enlargeIn = Math.pow(2, numBits);
                    numBits++;
                }
                if (dictionary[c]) entry = dictionary[c];
                else {
                    if (c === dictSize) entry = w + w.charAt(0);
                    else return null;
                }
                result.push(entry);
                // Add w+entry[0] to the dictionary.
                dictionary[dictSize++] = w + entry.charAt(0);
                enlargeIn--;
                w = entry;
                if (enlargeIn == 0) {
                    enlargeIn = Math.pow(2, numBits);
                    numBits++;
                }
            }
        }
    };
    return LZString;
}();
if (typeof define === "function" && define.amd) define(function() {
    return LZString;
});
else if (module != null) module.exports = LZString;
else if (typeof angular !== "undefined" && angular != null) angular.module("LZString", []).factory("LZString", function() {
    return LZString;
});

},{}],"9GFmI":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
Object.defineProperty(exports, "specialChars", {
    enumerable: true,
    get: function() {
        return _keyboard.specialCharMap;
    }
});
var _click = require("25d421f2cf729c39");
var _type = require("137d0eb956e8d715");
var _clear = require("dfc2f5c70e939bb4");
var _tab = require("1dc10e3eae176e51");
var _hover = require("aae7b291f92bd541");
var _upload = require("4300c611a74baf08");
var _selectOptions = require("90fa8a7cc6bcb8ef");
var _paste = require("c96dcbcc487a325e");
var _keyboard = require("d2f27504dfbdb8");
const userEvent = {
    click: _click.click,
    dblClick: _click.dblClick,
    type: _type.type,
    clear: _clear.clear,
    tab: _tab.tab,
    hover: _hover.hover,
    unhover: _hover.unhover,
    upload: _upload.upload,
    selectOptions: _selectOptions.selectOptions,
    deselectOptions: _selectOptions.deselectOptions,
    paste: _paste.paste,
    keyboard: _keyboard.keyboard
};
var _default = userEvent;
exports.default = _default;

},{"25d421f2cf729c39":"4GzGH","137d0eb956e8d715":"8ZIJq","dfc2f5c70e939bb4":"dtwrw","1dc10e3eae176e51":"2Nb9g","aae7b291f92bd541":"cclLK","4300c611a74baf08":"eGNuj","90fa8a7cc6bcb8ef":"75wWf","c96dcbcc487a325e":"kJzkn","d2f27504dfbdb8":"30x4a"}],"4GzGH":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.click = click;
exports.dblClick = dblClick;
var _dom = require("365a10f506cc634a");
var _utils = require("54446ba1746d0d7d");
var _hover = require("18029cdab822d571");
var _blur = require("4251ab77ddef47f8");
var _focus = require("6a3dc6684ec6b0ee");
function getPreviouslyFocusedElement(element) {
    const focusedElement = element.ownerDocument.activeElement;
    const wasAnotherElementFocused = focusedElement && focusedElement !== element.ownerDocument.body && focusedElement !== element;
    return wasAnotherElementFocused ? focusedElement : null;
}
function clickLabel(label, init, { clickCount }) {
    if ((0, _utils.isLabelWithInternallyDisabledControl)(label)) return;
    _dom.fireEvent.pointerDown(label, init);
    _dom.fireEvent.mouseDown(label, (0, _utils.getMouseEventOptions)("mousedown", init, clickCount));
    _dom.fireEvent.pointerUp(label, init);
    _dom.fireEvent.mouseUp(label, (0, _utils.getMouseEventOptions)("mouseup", init, clickCount));
    fireClick(label, (0, _utils.getMouseEventOptions)("click", init, clickCount)); // clicking the label will trigger a click of the label.control
    // however, it will not focus the label.control so we have to do it
    // ourselves.
    if (label.control) (0, _focus.focus)(label.control);
}
function clickBooleanElement(element, init, { clickCount }) {
    _dom.fireEvent.pointerDown(element, init);
    if (!element.disabled) _dom.fireEvent.mouseDown(element, (0, _utils.getMouseEventOptions)("mousedown", init, clickCount));
    (0, _focus.focus)(element);
    _dom.fireEvent.pointerUp(element, init);
    if (!element.disabled) {
        _dom.fireEvent.mouseUp(element, (0, _utils.getMouseEventOptions)("mouseup", init, clickCount));
        fireClick(element, (0, _utils.getMouseEventOptions)("click", init, clickCount));
    }
}
function clickElement(element, init, { clickCount }) {
    const previousElement = getPreviouslyFocusedElement(element);
    _dom.fireEvent.pointerDown(element, init);
    if (!(0, _utils.isDisabled)(element)) {
        const continueDefaultHandling = _dom.fireEvent.mouseDown(element, (0, _utils.getMouseEventOptions)("mousedown", init, clickCount));
        if (continueDefaultHandling) {
            const closestFocusable = findClosest(element, _utils.isFocusable);
            if (previousElement && !closestFocusable) (0, _blur.blur)(previousElement);
            else if (closestFocusable) (0, _focus.focus)(closestFocusable);
        }
    }
    _dom.fireEvent.pointerUp(element, init);
    if (!(0, _utils.isDisabled)(element)) {
        _dom.fireEvent.mouseUp(element, (0, _utils.getMouseEventOptions)("mouseup", init, clickCount));
        fireClick(element, (0, _utils.getMouseEventOptions)("click", init, clickCount));
        const parentLabel = element.closest("label");
        if (parentLabel != null && parentLabel.control) (0, _focus.focus)(parentLabel.control);
    }
}
function findClosest(element, callback) {
    let el = element;
    do {
        if (callback(el)) return el;
        el = el.parentElement;
    }while (el && el !== element.ownerDocument.body);
    return undefined;
}
function click(element, init, { skipHover = false, clickCount = 0, skipPointerEventsCheck = false } = {}) {
    if (!skipPointerEventsCheck && !(0, _utils.hasPointerEvents)(element)) throw new Error('unable to click element as it has or inherits pointer-events set to "none".');
     // We just checked for `pointerEvents`. We can always skip this one in `hover`.
    if (!skipHover) (0, _hover.hover)(element, init, {
        skipPointerEventsCheck: true
    });
    if ((0, _utils.isElementType)(element, "label")) clickLabel(element, init, {
        clickCount
    });
    else if ((0, _utils.isElementType)(element, "input")) {
        if (element.type === "checkbox" || element.type === "radio") clickBooleanElement(element, init, {
            clickCount
        });
        else clickElement(element, init, {
            clickCount
        });
    } else clickElement(element, init, {
        clickCount
    });
}
function fireClick(element, mouseEventOptions) {
    if (mouseEventOptions.button === 2) _dom.fireEvent.contextMenu(element, mouseEventOptions);
    else _dom.fireEvent.click(element, mouseEventOptions);
}
function dblClick(element, init, { skipPointerEventsCheck = false } = {}) {
    if (!skipPointerEventsCheck && !(0, _utils.hasPointerEvents)(element)) throw new Error('unable to double-click element as it has or inherits pointer-events set to "none".');
    (0, _hover.hover)(element, init, {
        skipPointerEventsCheck
    });
    click(element, init, {
        skipHover: true,
        clickCount: 0,
        skipPointerEventsCheck
    });
    click(element, init, {
        skipHover: true,
        clickCount: 1,
        skipPointerEventsCheck
    });
    _dom.fireEvent.dblClick(element, (0, _utils.getMouseEventOptions)("dblclick", init, 2));
}

},{"365a10f506cc634a":"f2A46","54446ba1746d0d7d":"44kvM","18029cdab822d571":"cclLK","4251ab77ddef47f8":"fYyoU","6a3dc6684ec6b0ee":"3KAtg"}],"44kvM":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _getMouseEventOptions = require("326e5f8e5110572c");
Object.keys(_getMouseEventOptions).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _getMouseEventOptions[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _getMouseEventOptions[key];
        }
    });
});
var _isClickableInput = require("b4dd1938e0fc2794");
Object.keys(_isClickableInput).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _isClickableInput[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _isClickableInput[key];
        }
    });
});
var _buildTimeValue = require("a7dd8c020cfbace2");
Object.keys(_buildTimeValue).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _buildTimeValue[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _buildTimeValue[key];
        }
    });
});
var _calculateNewValue = require("c19443cf03f8ca65");
Object.keys(_calculateNewValue).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _calculateNewValue[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _calculateNewValue[key];
        }
    });
});
var _cursorPosition = require("a9fd506bcddc9eac");
Object.keys(_cursorPosition).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _cursorPosition[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _cursorPosition[key];
        }
    });
});
var _getValue = require("352cdad1238562c7");
Object.keys(_getValue).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _getValue[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _getValue[key];
        }
    });
});
var _hasUnreliableEmptyValue = require("8e562e337b647be8");
Object.keys(_hasUnreliableEmptyValue).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _hasUnreliableEmptyValue[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _hasUnreliableEmptyValue[key];
        }
    });
});
var _isContentEditable = require("1c94ec79e2b70548");
Object.keys(_isContentEditable).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _isContentEditable[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _isContentEditable[key];
        }
    });
});
var _isEditable = require("7189f2c18a770c8a");
Object.keys(_isEditable).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _isEditable[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _isEditable[key];
        }
    });
});
var _isValidDateValue = require("604e825f2d2c1942");
Object.keys(_isValidDateValue).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _isValidDateValue[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _isValidDateValue[key];
        }
    });
});
var _isValidInputTimeValue = require("91455e18715c0951");
Object.keys(_isValidInputTimeValue).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _isValidInputTimeValue[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _isValidInputTimeValue[key];
        }
    });
});
var _maxLength = require("58f292d7252e2819");
Object.keys(_maxLength).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _maxLength[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _maxLength[key];
        }
    });
});
var _selectionRange = require("c806b5cf3e65433e");
Object.keys(_selectionRange).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _selectionRange[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _selectionRange[key];
        }
    });
});
var _getActiveElement = require("342833d292d47ba9");
Object.keys(_getActiveElement).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _getActiveElement[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _getActiveElement[key];
        }
    });
});
var _isFocusable = require("c8a57f9571b764f7");
Object.keys(_isFocusable).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _isFocusable[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _isFocusable[key];
        }
    });
});
var _selector = require("209e4b449cd3a4f3");
Object.keys(_selector).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _selector[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _selector[key];
        }
    });
});
var _eventWrapper = require("f671e49c185fbc73");
Object.keys(_eventWrapper).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _eventWrapper[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _eventWrapper[key];
        }
    });
});
var _isElementType = require("687c90b46707d75b");
Object.keys(_isElementType).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _isElementType[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _isElementType[key];
        }
    });
});
var _isLabelWithInternallyDisabledControl = require("324f339c2bb0719d");
Object.keys(_isLabelWithInternallyDisabledControl).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _isLabelWithInternallyDisabledControl[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _isLabelWithInternallyDisabledControl[key];
        }
    });
});
var _isVisible = require("ff1b9426b84d45b9");
Object.keys(_isVisible).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _isVisible[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _isVisible[key];
        }
    });
});
var _isDisabled = require("5e4a1afe2ee505e9");
Object.keys(_isDisabled).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _isDisabled[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _isDisabled[key];
        }
    });
});
var _isDocument = require("55dc5b9bd25402b4");
Object.keys(_isDocument).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _isDocument[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _isDocument[key];
        }
    });
});
var _wait = require("c621c87eaf195021");
Object.keys(_wait).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _wait[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _wait[key];
        }
    });
});
var _hasPointerEvents = require("e8522aa89b58a1db");
Object.keys(_hasPointerEvents).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _hasPointerEvents[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _hasPointerEvents[key];
        }
    });
});
var _hasFormSubmit = require("2758102f5f2fd48c");
Object.keys(_hasFormSubmit).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _hasFormSubmit[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _hasFormSubmit[key];
        }
    });
});

},{"326e5f8e5110572c":"ea4Mx","b4dd1938e0fc2794":"fELld","a7dd8c020cfbace2":"1bdxv","c19443cf03f8ca65":"1Aa0S","a9fd506bcddc9eac":"4RiyU","352cdad1238562c7":"aHVwm","8e562e337b647be8":"6HRjl","1c94ec79e2b70548":"1S8ca","7189f2c18a770c8a":"azKB8","604e825f2d2c1942":"lExIb","91455e18715c0951":"1uywD","58f292d7252e2819":"b4n5r","c806b5cf3e65433e":"eyzEs","342833d292d47ba9":"7l1Px","c8a57f9571b764f7":"e6TbA","209e4b449cd3a4f3":"ku1Pv","f671e49c185fbc73":"kFSMe","687c90b46707d75b":"lr17d","324f339c2bb0719d":"hdye4","ff1b9426b84d45b9":"d5Q2c","5e4a1afe2ee505e9":"loBhy","55dc5b9bd25402b4":"1eeVO","c621c87eaf195021":"66Z5a","e8522aa89b58a1db":"jfeND","2758102f5f2fd48c":"fONGP"}],"ea4Mx":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getMouseEventOptions = getMouseEventOptions;
function isMousePressEvent(event) {
    return event === "mousedown" || event === "mouseup" || event === "click" || event === "dblclick";
} // https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/buttons
const BUTTONS_NAMES = {
    none: 0,
    primary: 1,
    secondary: 2,
    auxiliary: 4
}; // https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/button
const BUTTON_NAMES = {
    primary: 0,
    auxiliary: 1,
    secondary: 2
};
function translateButtonNumber(value, from) {
    var _Object$entries$find;
    const [mapIn, mapOut] = from === "button" ? [
        BUTTON_NAMES,
        BUTTONS_NAMES
    ] : [
        BUTTONS_NAMES,
        BUTTON_NAMES
    ];
    const name = (_Object$entries$find = Object.entries(mapIn).find(([, i])=>i === value)) == null ? void 0 : _Object$entries$find[0]; // istanbul ignore next
    return name && Object.prototype.hasOwnProperty.call(mapOut, name) ? mapOut[name] : 0;
}
function convertMouseButtons(event, init, property) {
    if (!isMousePressEvent(event)) return 0;
    if (typeof init[property] === "number") return init[property];
    else if (property === "button" && typeof init.buttons === "number") return translateButtonNumber(init.buttons, "buttons");
    else if (property === "buttons" && typeof init.button === "number") return translateButtonNumber(init.button, "button");
    return property != "button" && isMousePressEvent(event) ? 1 : 0;
}
function getMouseEventOptions(event, init, clickCount = 0) {
    var _init;
    init = (_init = init) != null ? _init : {};
    return {
        ...init,
        // https://developer.mozilla.org/en-US/docs/Web/API/UIEvent/detail
        detail: event === "mousedown" || event === "mouseup" || event === "click" ? 1 + clickCount : clickCount,
        buttons: convertMouseButtons(event, init, "buttons"),
        button: convertMouseButtons(event, init, "button")
    };
}

},{}],"fELld":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isClickableInput = isClickableInput;
var _isElementType = require("6f07a7350d1da828");
const CLICKABLE_INPUT_TYPES = [
    "button",
    "color",
    "file",
    "image",
    "reset",
    "submit",
    "checkbox",
    "radio"
];
function isClickableInput(element) {
    return (0, _isElementType.isElementType)(element, "button") || (0, _isElementType.isElementType)(element, "input") && CLICKABLE_INPUT_TYPES.includes(element.type);
}

},{"6f07a7350d1da828":"lr17d"}],"lr17d":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isElementType = isElementType;
function isElementType(element, tag, props) {
    if (element.namespaceURI && element.namespaceURI !== "http://www.w3.org/1999/xhtml") return false;
    tag = Array.isArray(tag) ? tag : [
        tag
    ]; // tagName is uppercase in HTMLDocument and lowercase in XMLDocument
    if (!tag.includes(element.tagName.toLowerCase())) return false;
    if (props) return Object.entries(props).every(([k, v])=>element[k] === v);
    return true;
}

},{}],"1bdxv":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.buildTimeValue = buildTimeValue;
function buildTimeValue(value) {
    const onlyDigitsValue = value.replace(/\D/g, "");
    if (onlyDigitsValue.length < 2) return value;
    const firstDigit = parseInt(onlyDigitsValue[0], 10);
    const secondDigit = parseInt(onlyDigitsValue[1], 10);
    if (firstDigit >= 3 || firstDigit === 2 && secondDigit >= 4) {
        let index;
        if (firstDigit >= 3) index = 1;
        else index = 2;
        return build(onlyDigitsValue, index);
    }
    if (value.length === 2) return value;
    return build(onlyDigitsValue, 2);
}
function build(onlyDigitsValue, index) {
    const hours = onlyDigitsValue.slice(0, index);
    const validHours = Math.min(parseInt(hours, 10), 23);
    const minuteCharacters = onlyDigitsValue.slice(index);
    const parsedMinutes = parseInt(minuteCharacters, 10);
    const validMinutes = Math.min(parsedMinutes, 59);
    return `${validHours.toString().padStart(2, "0")}:${validMinutes.toString().padStart(2, "0")}`;
}

},{}],"1Aa0S":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.calculateNewValue = calculateNewValue;
var _selectionRange = require("f098adb43ab4baf6");
var _getValue2 = require("b970d9f61bf628c3");
var _isValidDateValue = require("9d9872a716fa770");
var _isValidInputTimeValue = require("93cba8b826c06eef");
function calculateNewValue(newEntry, element, value = (()=>{
    var _getValue;
    return (_getValue = (0, _getValue2.getValue)(element)) != null ? _getValue : /* istanbul ignore next */ "";
})(), selectionRange = (0, _selectionRange.getSelectionRange)(element), deleteContent) {
    const selectionStart = selectionRange.selectionStart === null ? value.length : selectionRange.selectionStart;
    const selectionEnd = selectionRange.selectionEnd === null ? value.length : selectionRange.selectionEnd;
    const prologEnd = Math.max(0, selectionStart === selectionEnd && deleteContent === "backward" ? selectionStart - 1 : selectionStart);
    const prolog = value.substring(0, prologEnd);
    const epilogStart = Math.min(value.length, selectionStart === selectionEnd && deleteContent === "forward" ? selectionEnd + 1 : selectionEnd);
    const epilog = value.substring(epilogStart, value.length);
    let newValue = `${prolog}${newEntry}${epilog}`;
    const newSelectionStart = prologEnd + newEntry.length;
    if (element.type === "date" && !(0, _isValidDateValue.isValidDateValue)(element, newValue)) newValue = value;
    if (element.type === "time" && !(0, _isValidInputTimeValue.isValidInputTimeValue)(element, newValue)) {
        if ((0, _isValidInputTimeValue.isValidInputTimeValue)(element, newEntry)) newValue = newEntry;
        else newValue = value;
    }
    return {
        newValue,
        newSelectionStart
    };
}

},{"f098adb43ab4baf6":"eyzEs","b970d9f61bf628c3":"aHVwm","9d9872a716fa770":"lExIb","93cba8b826c06eef":"1uywD"}],"eyzEs":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getSelectionRange = getSelectionRange;
exports.hasSelectionSupport = hasSelectionSupport;
exports.setSelectionRange = setSelectionRange;
var _isElementType = require("eff1172552ad9218");
// https://github.com/jsdom/jsdom/blob/c2fb8ff94917a4d45e2398543f5dd2a8fed0bdab/lib/jsdom/living/nodes/HTMLInputElement-impl.js#L45
var selectionSupportType;
(function(selectionSupportType) {
    selectionSupportType["text"] = "text";
    selectionSupportType["search"] = "search";
    selectionSupportType["url"] = "url";
    selectionSupportType["tel"] = "tel";
    selectionSupportType["password"] = "password";
})(selectionSupportType || (selectionSupportType = {}));
const InputSelection = Symbol("inputSelection");
function hasSelectionSupport(element) {
    return (0, _isElementType.isElementType)(element, "textarea") || (0, _isElementType.isElementType)(element, "input") && Boolean(selectionSupportType[element.type]);
}
function getSelectionRange(element) {
    if (hasSelectionSupport(element)) return {
        selectionStart: element.selectionStart,
        selectionEnd: element.selectionEnd
    };
    if ((0, _isElementType.isElementType)(element, "input")) {
        var _InputSelection;
        return (_InputSelection = element[InputSelection]) != null ? _InputSelection : {
            selectionStart: null,
            selectionEnd: null
        };
    }
    const selection = element.ownerDocument.getSelection(); // there should be no editing if the focusNode is outside of element
    // TODO: properly handle selection ranges
    if (selection != null && selection.rangeCount && element.contains(selection.focusNode)) {
        const range = selection.getRangeAt(0);
        return {
            selectionStart: range.startOffset,
            selectionEnd: range.endOffset
        };
    } else return {
        selectionStart: null,
        selectionEnd: null
    };
}
function setSelectionRange(element, newSelectionStart, newSelectionEnd) {
    const { selectionStart, selectionEnd } = getSelectionRange(element);
    if (selectionStart === newSelectionStart && selectionEnd === newSelectionEnd) return;
    if (hasSelectionSupport(element)) element.setSelectionRange(newSelectionStart, newSelectionEnd);
    if ((0, _isElementType.isElementType)(element, "input")) element[InputSelection] = {
        selectionStart: newSelectionStart,
        selectionEnd: newSelectionEnd
    };
     // Moving the selection inside <input> or <textarea> does not alter the document Selection.
    if ((0, _isElementType.isElementType)(element, "input") || (0, _isElementType.isElementType)(element, "textarea")) return;
    const range = element.ownerDocument.createRange();
    range.selectNodeContents(element); // istanbul ignore else
    if (element.firstChild) {
        range.setStart(element.firstChild, newSelectionStart);
        range.setEnd(element.firstChild, newSelectionEnd);
    }
    const selection = element.ownerDocument.getSelection(); // istanbul ignore else
    if (selection) {
        selection.removeAllRanges();
        selection.addRange(range);
    }
}

},{"eff1172552ad9218":"lr17d"}],"aHVwm":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getValue = getValue;
var _isContentEditable = require("211863752884712f");
function getValue(element) {
    // istanbul ignore if
    if (!element) return null;
    if ((0, _isContentEditable.isContentEditable)(element)) return element.textContent;
    return element.value;
}

},{"211863752884712f":"1S8ca"}],"1S8ca":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isContentEditable = isContentEditable;
//jsdom is not supporting isContentEditable
function isContentEditable(element) {
    return element.hasAttribute("contenteditable") && (element.getAttribute("contenteditable") == "true" || element.getAttribute("contenteditable") == "");
}

},{}],"lExIb":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isValidDateValue = isValidDateValue;
function isValidDateValue(element, value) {
    const clone = element.cloneNode();
    clone.value = value;
    return clone.value === value;
}

},{}],"1uywD":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isValidInputTimeValue = isValidInputTimeValue;
function isValidInputTimeValue(element, timeValue) {
    const clone = element.cloneNode();
    clone.value = timeValue;
    return clone.value === timeValue;
}

},{}],"4RiyU":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isCursorAtEnd = isCursorAtEnd;
exports.isCursorAtStart = isCursorAtStart;
var _selectionRange = require("9e82db946bdbbf43");
var _getValue2 = require("bfa4ad130714c6cb");
function isCursorAtEnd(element) {
    var _getValue;
    const { selectionStart, selectionEnd } = (0, _selectionRange.getSelectionRange)(element);
    return selectionStart === selectionEnd && (selectionStart != null ? selectionStart : /* istanbul ignore next */ 0) === ((_getValue = (0, _getValue2.getValue)(element)) != null ? _getValue : /* istanbul ignore next */ "").length;
}
function isCursorAtStart(element) {
    const { selectionStart, selectionEnd } = (0, _selectionRange.getSelectionRange)(element);
    return selectionStart === selectionEnd && (selectionStart != null ? selectionStart : /* istanbul ignore next */ 0) === 0;
}

},{"9e82db946bdbbf43":"eyzEs","bfa4ad130714c6cb":"aHVwm"}],"6HRjl":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.hasUnreliableEmptyValue = hasUnreliableEmptyValue;
var _isElementType = require("b32b7e9671392020");
var unreliableValueInputTypes;
/**
 * Check if an empty IDL value on the element could mean a derivation of displayed value and IDL value
 */ (function(unreliableValueInputTypes) {
    unreliableValueInputTypes["number"] = "number";
})(unreliableValueInputTypes || (unreliableValueInputTypes = {}));
function hasUnreliableEmptyValue(element) {
    return (0, _isElementType.isElementType)(element, "input") && Boolean(unreliableValueInputTypes[element.type]);
}

},{"b32b7e9671392020":"lr17d"}],"azKB8":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.editableInputTypes = void 0;
exports.isEditable = isEditable;
exports.isEditableInput = isEditableInput;
var _isElementType = require("fe1f43c7dddb42d6");
var _isContentEditable = require("166341d7a495df19");
function isEditable(element) {
    return isEditableInput(element) || (0, _isElementType.isElementType)(element, "textarea", {
        readOnly: false
    }) || (0, _isContentEditable.isContentEditable)(element);
}
let editableInputTypes;
exports.editableInputTypes = editableInputTypes;
(function(editableInputTypes) {
    editableInputTypes["text"] = "text";
    editableInputTypes["date"] = "date";
    editableInputTypes["datetime-local"] = "datetime-local";
    editableInputTypes["email"] = "email";
    editableInputTypes["month"] = "month";
    editableInputTypes["number"] = "number";
    editableInputTypes["password"] = "password";
    editableInputTypes["search"] = "search";
    editableInputTypes["tel"] = "tel";
    editableInputTypes["time"] = "time";
    editableInputTypes["url"] = "url";
    editableInputTypes["week"] = "week";
})(editableInputTypes || (exports.editableInputTypes = editableInputTypes = {}));
function isEditableInput(element) {
    return (0, _isElementType.isElementType)(element, "input", {
        readOnly: false
    }) && Boolean(editableInputTypes[element.type]);
}

},{"fe1f43c7dddb42d6":"lr17d","166341d7a495df19":"1S8ca"}],"b4n5r":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getSpaceUntilMaxLength = getSpaceUntilMaxLength;
var _isElementType = require("4c8e50c660ca92c7");
var _getValue = require("4b85eb7fae7cd632");
var maxLengthSupportedTypes;
(function(maxLengthSupportedTypes) {
    maxLengthSupportedTypes["email"] = "email";
    maxLengthSupportedTypes["password"] = "password";
    maxLengthSupportedTypes["search"] = "search";
    maxLengthSupportedTypes["telephone"] = "telephone";
    maxLengthSupportedTypes["text"] = "text";
    maxLengthSupportedTypes["url"] = "url";
})(maxLengthSupportedTypes || (maxLengthSupportedTypes = {}));
function getSpaceUntilMaxLength(element) {
    const value = (0, _getValue.getValue)(element);
    /* istanbul ignore if */ if (value === null) return undefined;
    const maxLength = getSanitizedMaxLength(element);
    return maxLength ? maxLength - value.length : undefined;
} // can't use .maxLength property because of a jsdom bug:
// https://github.com/jsdom/jsdom/issues/2927
function getSanitizedMaxLength(element) {
    var _element$getAttribute;
    if (!supportsMaxLength(element)) return undefined;
    const attr = (_element$getAttribute = element.getAttribute("maxlength")) != null ? _element$getAttribute : "";
    return /^\d+$/.test(attr) && Number(attr) >= 0 ? Number(attr) : undefined;
}
function supportsMaxLength(element) {
    return (0, _isElementType.isElementType)(element, "textarea") || (0, _isElementType.isElementType)(element, "input") && Boolean(maxLengthSupportedTypes[element.type]);
}

},{"4c8e50c660ca92c7":"lr17d","4b85eb7fae7cd632":"aHVwm"}],"7l1Px":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getActiveElement = getActiveElement;
var _isDisabled = require("6a3c3620e6b857f4");
function getActiveElement(document) {
    const activeElement = document.activeElement;
    if (activeElement != null && activeElement.shadowRoot) return getActiveElement(activeElement.shadowRoot);
    else {
        // Browser does not yield disabled elements as document.activeElement - jsdom does
        if ((0, _isDisabled.isDisabled)(activeElement)) return document.ownerDocument ? /* istanbul ignore next */ document.ownerDocument.body : document.body;
        return activeElement;
    }
}

},{"6a3c3620e6b857f4":"loBhy"}],"loBhy":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isDisabled = isDisabled;
// This should probably be extended with checking the element type
// https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/disabled
function isDisabled(element) {
    return Boolean(element && element.disabled);
}

},{}],"e6TbA":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isFocusable = isFocusable;
var _isLabelWithInternallyDisabledControl = require("8ca99e06200055c6");
var _selector = require("a8f19c860bec7a7f");
function isFocusable(element) {
    return !(0, _isLabelWithInternallyDisabledControl.isLabelWithInternallyDisabledControl)(element) && element.matches(_selector.FOCUSABLE_SELECTOR);
}

},{"8ca99e06200055c6":"hdye4","a8f19c860bec7a7f":"ku1Pv"}],"hdye4":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isLabelWithInternallyDisabledControl = isLabelWithInternallyDisabledControl;
var _isDisabled = require("dc43589e0759007c");
var _isElementType = require("b2fe5296e8a3da46");
// Absolutely NO events fire on label elements that contain their control
// if that control is disabled. NUTS!
// no joke. There are NO events for: <label><input disabled /><label>
function isLabelWithInternallyDisabledControl(element) {
    if (!(0, _isElementType.isElementType)(element, "label")) return false;
    const control = element.control;
    return Boolean(control && element.contains(control) && (0, _isDisabled.isDisabled)(control));
}

},{"dc43589e0759007c":"loBhy","b2fe5296e8a3da46":"lr17d"}],"ku1Pv":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.FOCUSABLE_SELECTOR = void 0;
const FOCUSABLE_SELECTOR = [
    "input:not([type=hidden]):not([disabled])",
    "button:not([disabled])",
    "select:not([disabled])",
    "textarea:not([disabled])",
    '[contenteditable=""]',
    '[contenteditable="true"]',
    "a[href]",
    "[tabindex]:not([disabled])"
].join(", ");
exports.FOCUSABLE_SELECTOR = FOCUSABLE_SELECTOR;

},{}],"kFSMe":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.eventWrapper = eventWrapper;
var _dom = require("56338467208e96c9");
function eventWrapper(cb) {
    let result;
    (0, _dom.getConfig)().eventWrapper(()=>{
        result = cb();
    });
    return result;
}

},{"56338467208e96c9":"f2A46"}],"d5Q2c":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isVisible = isVisible;
var _helpers = require("bac46124c6f2712d");
function isVisible(element) {
    const window = (0, _helpers.getWindowFromNode)(element);
    for(let el = element; (_el = el) != null && _el.ownerDocument; el = el.parentElement){
        var _el;
        const display = window.getComputedStyle(el).display;
        if (display === "none") return false;
    }
    return true;
}

},{"bac46124c6f2712d":"b0MvW"}],"b0MvW":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.TEXT_NODE = void 0;
exports.checkContainerType = checkContainerType;
exports.getDocument = getDocument;
exports.getWindowFromNode = getWindowFromNode;
exports.jestFakeTimersAreEnabled = jestFakeTimersAreEnabled;
// Constant node.nodeType for text nodes, see:
// https://developer.mozilla.org/en-US/docs/Web/API/Node/nodeType#Node_type_constants
const TEXT_NODE = 3;
exports.TEXT_NODE = TEXT_NODE;
function jestFakeTimersAreEnabled() {
    /* istanbul ignore else */ // eslint-disable-next-line
    if (typeof jest !== "undefined" && jest !== null) return(// legacy timers
    setTimeout._isMockFunction === true || // modern timers
    Object.prototype.hasOwnProperty.call(setTimeout, "clock"));
    // istanbul ignore next
    return false;
}
function getDocument() {
    /* istanbul ignore if */ if (typeof window === "undefined") throw new Error("Could not find default container");
    return window.document;
}
function getWindowFromNode(node) {
    if (node.defaultView) // node is document
    return node.defaultView;
    else if (node.ownerDocument && node.ownerDocument.defaultView) // node is a DOM node
    return node.ownerDocument.defaultView;
    else if (node.window) // node is window
    return node.window;
    else if (node.ownerDocument && node.ownerDocument.defaultView === null) throw new Error(`It looks like the window object is not available for the provided node.`);
    else if (node.then instanceof Function) throw new Error(`It looks like you passed a Promise object instead of a DOM node. Did you do something like \`fireEvent.click(screen.findBy...\` when you meant to use a \`getBy\` query \`fireEvent.click(screen.getBy...\`, or await the findBy query \`fireEvent.click(await screen.findBy...\`?`);
    else if (Array.isArray(node)) throw new Error(`It looks like you passed an Array instead of a DOM node. Did you do something like \`fireEvent.click(screen.getAllBy...\` when you meant to use a \`getBy\` query \`fireEvent.click(screen.getBy...\`?`);
    else if (typeof node.debug === "function" && typeof node.logTestingPlaygroundURL === "function") throw new Error(`It looks like you passed a \`screen\` object. Did you do something like \`fireEvent.click(screen, ...\` when you meant to use a query, e.g. \`fireEvent.click(screen.getBy..., \`?`);
    else // The user passed something unusual to a calling function
    throw new Error(`The given node is not an Element, the node type is: ${typeof node}.`);
}
function checkContainerType(container) {
    if (!container || !(typeof container.querySelector === "function") || !(typeof container.querySelectorAll === "function")) throw new TypeError(`Expected container to be an Element, a Document or a DocumentFragment but got ${getTypeName(container)}.`);
    function getTypeName(object) {
        if (typeof object === "object") return object === null ? "null" : object.constructor.name;
        return typeof object;
    }
}

},{}],"1eeVO":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isDocument = isDocument;
function isDocument(el) {
    return el.nodeType === el.DOCUMENT_NODE;
}

},{}],"66Z5a":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.wait = wait;
function wait(time) {
    return new Promise((resolve)=>setTimeout(()=>resolve(), time));
}

},{}],"jfeND":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.hasPointerEvents = hasPointerEvents;
var _helpers = require("b590006f907d54dc");
function hasPointerEvents(element) {
    const window = (0, _helpers.getWindowFromNode)(element);
    for(let el = element; (_el = el) != null && _el.ownerDocument; el = el.parentElement){
        var _el;
        const pointerEvents = window.getComputedStyle(el).pointerEvents;
        if (pointerEvents && ![
            "inherit",
            "unset"
        ].includes(pointerEvents)) return pointerEvents !== "none";
    }
    return true;
}

},{"b590006f907d54dc":"b0MvW"}],"fONGP":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.hasFormSubmit = void 0;
const hasFormSubmit = (form)=>!!(form && (form.querySelector('input[type="submit"]') || form.querySelector('button[type="submit"]')));
exports.hasFormSubmit = hasFormSubmit;

},{}],"cclLK":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.hover = hover;
exports.unhover = unhover;
var _dom = require("e2fbfd6997c259d9");
var _utils = require("8d3dcd9652b392bc");
// includes `element`
function getParentElements(element) {
    const parentElements = [
        element
    ];
    let currentElement = element;
    while((currentElement = currentElement.parentElement) != null)parentElements.push(currentElement);
    return parentElements;
}
function hover(element, init, { skipPointerEventsCheck = false } = {}) {
    if (!skipPointerEventsCheck && !(0, _utils.hasPointerEvents)(element)) throw new Error('unable to hover element as it has or inherits pointer-events set to "none".');
    if ((0, _utils.isLabelWithInternallyDisabledControl)(element)) return;
    const parentElements = getParentElements(element).reverse();
    _dom.fireEvent.pointerOver(element, init);
    for (const el of parentElements)_dom.fireEvent.pointerEnter(el, init);
    if (!(0, _utils.isDisabled)(element)) {
        _dom.fireEvent.mouseOver(element, (0, _utils.getMouseEventOptions)("mouseover", init));
        for (const el of parentElements)_dom.fireEvent.mouseEnter(el, (0, _utils.getMouseEventOptions)("mouseenter", init));
    }
    _dom.fireEvent.pointerMove(element, init);
    if (!(0, _utils.isDisabled)(element)) _dom.fireEvent.mouseMove(element, (0, _utils.getMouseEventOptions)("mousemove", init));
}
function unhover(element, init, { skipPointerEventsCheck = false } = {}) {
    if (!skipPointerEventsCheck && !(0, _utils.hasPointerEvents)(element)) throw new Error('unable to unhover element as it has or inherits pointer-events set to "none".');
    if ((0, _utils.isLabelWithInternallyDisabledControl)(element)) return;
    const parentElements = getParentElements(element);
    _dom.fireEvent.pointerMove(element, init);
    if (!(0, _utils.isDisabled)(element)) _dom.fireEvent.mouseMove(element, (0, _utils.getMouseEventOptions)("mousemove", init));
    _dom.fireEvent.pointerOut(element, init);
    for (const el of parentElements)_dom.fireEvent.pointerLeave(el, init);
    if (!(0, _utils.isDisabled)(element)) {
        _dom.fireEvent.mouseOut(element, (0, _utils.getMouseEventOptions)("mouseout", init));
        for (const el of parentElements)_dom.fireEvent.mouseLeave(el, (0, _utils.getMouseEventOptions)("mouseleave", init));
    }
}

},{"e2fbfd6997c259d9":"f2A46","8d3dcd9652b392bc":"44kvM"}],"fYyoU":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.blur = blur;
var _utils = require("698e2e27b0498023");
function blur(element) {
    if (!(0, _utils.isFocusable)(element)) return;
    const wasActive = (0, _utils.getActiveElement)(element.ownerDocument) === element;
    if (!wasActive) return;
    (0, _utils.eventWrapper)(()=>element.blur());
}

},{"698e2e27b0498023":"44kvM"}],"3KAtg":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.focus = focus;
var _utils = require("c207a193faa10f56");
function focus(element) {
    if (!(0, _utils.isFocusable)(element)) return;
    const isAlreadyActive = (0, _utils.getActiveElement)(element.ownerDocument) === element;
    if (isAlreadyActive) return;
    (0, _utils.eventWrapper)(()=>element.focus());
}

},{"c207a193faa10f56":"44kvM"}],"8ZIJq":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.type = type;
var _dom = require("b0deb4383e51fdc7");
var _typeImplementation = require("7dd601ad09c62873");
// this needs to be wrapped in the event/asyncWrapper for React's act and angular's change detection
// depending on whether it will be async.
function type(element, text, { delay = 0, ...options } = {}) {
    // we do not want to wrap in the asyncWrapper if we're not
    // going to actually be doing anything async, so we only wrap
    // if the delay is greater than 0
    if (delay > 0) return (0, _dom.getConfig)().asyncWrapper(()=>(0, _typeImplementation.typeImplementation)(element, text, {
            delay,
            ...options
        }));
    else return void (0, _typeImplementation.typeImplementation)(element, text, {
        delay,
        ...options
    }) // prevents users from dealing with UnhandledPromiseRejectionWarning
    .catch(console.error);
}

},{"b0deb4383e51fdc7":"f2A46","7dd601ad09c62873":"5MRSD"}],"5MRSD":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.typeImplementation = typeImplementation;
var _utils = require("5ac3fa506342b7f3");
var _click = require("d2a4d3b0216083be");
var _keyboard = require("3a72f2451f939dda");
async function typeImplementation(element, text, { delay, skipClick = false, skipAutoClose = false, initialSelectionStart, initialSelectionEnd }) {
    // TODO: properly type guard
    // we use this workaround for now to prevent changing behavior
    if (element.disabled) return;
    if (!skipClick) (0, _click.click)(element); // The focused element could change between each event, so get the currently active element each time
    const currentElement = ()=>(0, _utils.getActiveElement)(element.ownerDocument); // by default, a new element has its selection start and end at 0
    // but most of the time when people call "type", they expect it to type
    // at the end of the current input value. So, if the selection start
    // and end are both the default of 0, then we'll go ahead and change
    // them to the length of the current value.
    // the only time it would make sense to pass the initialSelectionStart or
    // initialSelectionEnd is if you have an input with a value and want to
    // explicitly start typing with the cursor at 0. Not super common.
    const value = (0, _utils.getValue)(currentElement());
    const { selectionStart, selectionEnd } = (0, _utils.getSelectionRange)(element);
    if (value != null && (selectionStart === null || selectionStart === 0) && (selectionEnd === null || selectionEnd === 0)) (0, _utils.setSelectionRange)(currentElement(), initialSelectionStart != null ? initialSelectionStart : value.length, initialSelectionEnd != null ? initialSelectionEnd : value.length);
    const { promise, releaseAllKeys } = (0, _keyboard.keyboardImplementationWrapper)(text, {
        delay,
        document: element.ownerDocument
    });
    if (delay > 0) await promise;
    if (!skipAutoClose) releaseAllKeys();
     // eslint-disable-next-line consistent-return -- we need to return the internal Promise so that it is catchable if we don't await
    return promise;
}

},{"5ac3fa506342b7f3":"44kvM","d2a4d3b0216083be":"4GzGH","3a72f2451f939dda":"30x4a"}],"30x4a":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.keyboard = keyboard;
exports.keyboardImplementationWrapper = keyboardImplementationWrapper;
Object.defineProperty(exports, "specialCharMap", {
    enumerable: true,
    get: function() {
        return _specialCharMap.specialCharMap;
    }
});
var _dom = require("40aa57eee0e59b8b");
var _keyboardImplementation = require("86104760d1aaa150");
var _keyMap = require("8dd4660df21e53ba");
var _specialCharMap = require("2325c588e7d953f");
function keyboard(text, options) {
    var _options$delay;
    const { promise, state } = keyboardImplementationWrapper(text, options);
    if (((_options$delay = options == null ? void 0 : options.delay) != null ? _options$delay : 0) > 0) return (0, _dom.getConfig)().asyncWrapper(()=>promise.then(()=>state));
    else {
        // prevent users from dealing with UnhandledPromiseRejectionWarning in sync call
        promise.catch(console.error);
        return state;
    }
}
function keyboardImplementationWrapper(text, config = {}) {
    const { keyboardState: state = createKeyboardState(), delay = 0, document: doc = document, autoModify = false, keyboardMap = _keyMap.defaultKeyMap } = config;
    const options = {
        delay,
        document: doc,
        autoModify,
        keyboardMap
    };
    return {
        promise: (0, _keyboardImplementation.keyboardImplementation)(text, options, state),
        state,
        releaseAllKeys: ()=>(0, _keyboardImplementation.releaseAllKeys)(options, state)
    };
}
function createKeyboardState() {
    return {
        activeElement: null,
        pressed: [],
        carryChar: "",
        modifiers: {
            alt: false,
            caps: false,
            ctrl: false,
            meta: false,
            shift: false
        }
    };
}

},{"40aa57eee0e59b8b":"f2A46","86104760d1aaa150":"hOwR1","8dd4660df21e53ba":"eQTSV","2325c588e7d953f":"bWbhQ"}],"hOwR1":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.keyboardImplementation = keyboardImplementation;
exports.releaseAllKeys = releaseAllKeys;
var _dom = require("1e484da7dde10ab5");
var _utils = require("8a0d81f5ad25760d");
var _getNextKeyDef = require("df6dd5f9116b4aee");
var plugins = _interopRequireWildcard(require("e950b3245089c21d"));
var _getEventProps = require("209f563570b1cb87");
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
async function keyboardImplementation(text, options, state) {
    var _state$repeatKey;
    const { document } = options;
    const getCurrentElement = ()=>getActive(document);
    const { keyDef, consumedLength, releasePrevious, releaseSelf, repeat } = (_state$repeatKey = state.repeatKey) != null ? _state$repeatKey : (0, _getNextKeyDef.getNextKeyDef)(text, options);
    const replace = applyPlugins(plugins.replaceBehavior, keyDef, getCurrentElement(), options, state);
    if (!replace) {
        const pressed = state.pressed.find((p)=>p.keyDef === keyDef); // Release the key automatically if it was pressed before.
        // Do not release the key on iterations on `state.repeatKey`.
        if (pressed && !state.repeatKey) keyup(keyDef, getCurrentElement, options, state, pressed.unpreventedDefault);
        if (!releasePrevious) {
            const unpreventedDefault = keydown(keyDef, getCurrentElement, options, state);
            if (unpreventedDefault && hasKeyPress(keyDef, state)) keypress(keyDef, getCurrentElement, options, state);
             // Release the key only on the last iteration on `state.repeatKey`.
            if (releaseSelf && repeat <= 1) keyup(keyDef, getCurrentElement, options, state, unpreventedDefault);
        }
    }
    if (repeat > 1) state.repeatKey = {
        // don't consume again on the next iteration
        consumedLength: 0,
        keyDef,
        releasePrevious,
        releaseSelf,
        repeat: repeat - 1
    };
    else delete state.repeatKey;
    if (text.length > consumedLength || repeat > 1) {
        if (options.delay > 0) await (0, _utils.wait)(options.delay);
        return keyboardImplementation(text.slice(consumedLength), options, state);
    }
    return void 0;
}
function getActive(document) {
    var _getActiveElement;
    return (_getActiveElement = (0, _utils.getActiveElement)(document)) != null ? _getActiveElement : /* istanbul ignore next */ document.body;
}
function releaseAllKeys(options, state) {
    const getCurrentElement = ()=>getActive(options.document);
    for (const k of state.pressed)keyup(k.keyDef, getCurrentElement, options, state, k.unpreventedDefault);
}
function keydown(keyDef, getCurrentElement, options, state) {
    const element = getCurrentElement(); // clear carried characters when focus is moved
    if (element !== state.activeElement) {
        state.carryValue = undefined;
        state.carryChar = "";
    }
    state.activeElement = element;
    applyPlugins(plugins.preKeydownBehavior, keyDef, element, options, state);
    const unpreventedDefault = _dom.fireEvent.keyDown(element, (0, _getEventProps.getKeyEventProps)(keyDef, state));
    state.pressed.push({
        keyDef,
        unpreventedDefault
    });
    if (unpreventedDefault) // all default behavior like keypress/submit etc is applied to the currentElement
    applyPlugins(plugins.keydownBehavior, keyDef, getCurrentElement(), options, state);
    return unpreventedDefault;
}
function keypress(keyDef, getCurrentElement, options, state) {
    const element = getCurrentElement();
    const unpreventedDefault = _dom.fireEvent.keyPress(element, (0, _getEventProps.getKeyEventProps)(keyDef, state));
    if (unpreventedDefault) applyPlugins(plugins.keypressBehavior, keyDef, getCurrentElement(), options, state);
}
function keyup(keyDef, getCurrentElement, options, state, unprevented) {
    const element = getCurrentElement();
    applyPlugins(plugins.preKeyupBehavior, keyDef, element, options, state);
    const unpreventedDefault = _dom.fireEvent.keyUp(element, (0, _getEventProps.getKeyEventProps)(keyDef, state));
    if (unprevented && unpreventedDefault) applyPlugins(plugins.keyupBehavior, keyDef, getCurrentElement(), options, state);
    state.pressed = state.pressed.filter((k)=>k.keyDef !== keyDef);
    applyPlugins(plugins.postKeyupBehavior, keyDef, element, options, state);
}
function applyPlugins(pluginCollection, keyDef, element, options, state) {
    const plugin = pluginCollection.find((p)=>p.matches(keyDef, element, options, state));
    if (plugin) plugin.handle(keyDef, element, options, state);
    return !!plugin;
}
function hasKeyPress(keyDef, state) {
    var _keyDef$key;
    return (((_keyDef$key = keyDef.key) == null ? void 0 : _keyDef$key.length) === 1 || keyDef.key === "Enter") && !state.modifiers.ctrl && !state.modifiers.alt;
}

},{"1e484da7dde10ab5":"f2A46","8a0d81f5ad25760d":"44kvM","df6dd5f9116b4aee":"cuWMw","e950b3245089c21d":"i69vy","209f563570b1cb87":"pyGUn"}],"cuWMw":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getNextKeyDef = getNextKeyDef;
var bracketDict;
(function(bracketDict) {
    bracketDict["{"] = "}";
    bracketDict["["] = "]";
})(bracketDict || (bracketDict = {}));
var legacyModifiers;
(function(legacyModifiers) {
    legacyModifiers["alt"] = "alt";
    legacyModifiers["ctrl"] = "ctrl";
    legacyModifiers["meta"] = "meta";
    legacyModifiers["shift"] = "shift";
})(legacyModifiers || (legacyModifiers = {}));
var legacyKeyMap;
/**
 * Get the next key from keyMap
 *
 * Keys can be referenced by `{key}` or `{special}` as well as physical locations per `[code]`.
 * Everything else will be interpreted as a typed character - e.g. `a`.
 * Brackets `{` and `[` can be escaped by doubling - e.g. `foo[[bar` translates to `foo[bar`.
 * Keeping the key pressed can be written as `{key>}`.
 * When keeping the key pressed you can choose how long (how many keydown and keypress) the key is pressed `{key>3}`.
 * You can then release the key per `{key>3/}` or keep it pressed and continue with the next key.
 * Modifiers like `{shift}` imply being kept pressed. This can be turned of per `{shift/}`.
 */ (function(legacyKeyMap) {
    legacyKeyMap["ctrl"] = "Control";
    legacyKeyMap["del"] = "Delete";
    legacyKeyMap["esc"] = "Escape";
    legacyKeyMap["space"] = " ";
})(legacyKeyMap || (legacyKeyMap = {}));
function getNextKeyDef(text, options) {
    var _options$keyboardMap$;
    const { type, descriptor, consumedLength, releasePrevious, releaseSelf, repeat } = readNextDescriptor(text);
    const keyDef = (_options$keyboardMap$ = options.keyboardMap.find((def)=>{
        if (type === "[") {
            var _def$code;
            return ((_def$code = def.code) == null ? void 0 : _def$code.toLowerCase()) === descriptor.toLowerCase();
        } else if (type === "{") {
            var _def$key;
            const key = mapLegacyKey(descriptor);
            return ((_def$key = def.key) == null ? void 0 : _def$key.toLowerCase()) === key.toLowerCase();
        }
        return def.key === descriptor;
    })) != null ? _options$keyboardMap$ : {
        key: "Unknown",
        code: "Unknown",
        [type === "[" ? "code" : "key"]: descriptor
    };
    return {
        keyDef,
        consumedLength,
        releasePrevious,
        releaseSelf,
        repeat
    };
}
function readNextDescriptor(text) {
    let pos = 0;
    const startBracket = text[pos] in bracketDict ? text[pos] : "";
    pos += startBracket.length; // `foo{{bar` is an escaped char at position 3,
    // but `foo{{{>5}bar` should be treated as `{` pressed down for 5 keydowns.
    const startBracketRepeated = startBracket ? text.match(new RegExp(`^\\${startBracket}+`))[0].length : 0;
    const isEscapedChar = startBracketRepeated === 2 || startBracket === "{" && startBracketRepeated > 3;
    const type = isEscapedChar ? "" : startBracket;
    return {
        type,
        ...type === "" ? readPrintableChar(text, pos) : readTag(text, pos, type)
    };
}
function readPrintableChar(text, pos) {
    const descriptor = text[pos];
    assertDescriptor(descriptor, text, pos);
    pos += descriptor.length;
    return {
        consumedLength: pos,
        descriptor,
        releasePrevious: false,
        releaseSelf: true,
        repeat: 1
    };
}
function readTag(text, pos, startBracket) {
    var _text$slice$match, _text$slice$match$, _text$slice$match2;
    const releasePreviousModifier = text[pos] === "/" ? "/" : "";
    pos += releasePreviousModifier.length;
    const descriptor = (_text$slice$match = text.slice(pos).match(/^\w+/)) == null ? void 0 : _text$slice$match[0];
    assertDescriptor(descriptor, text, pos);
    pos += descriptor.length;
    const repeatModifier = (_text$slice$match$ = (_text$slice$match2 = text.slice(pos).match(/^>\d+/)) == null ? void 0 : _text$slice$match2[0]) != null ? _text$slice$match$ : "";
    pos += repeatModifier.length;
    const releaseSelfModifier = text[pos] === "/" || !repeatModifier && text[pos] === ">" ? text[pos] : "";
    pos += releaseSelfModifier.length;
    const expectedEndBracket = bracketDict[startBracket];
    const endBracket = text[pos] === expectedEndBracket ? expectedEndBracket : "";
    if (!endBracket) throw new Error(getErrorMessage([
        !repeatModifier && "repeat modifier",
        !releaseSelfModifier && "release modifier",
        `"${expectedEndBracket}"`
    ].filter(Boolean).join(" or "), text[pos], text));
    pos += endBracket.length;
    return {
        consumedLength: pos,
        descriptor,
        releasePrevious: !!releasePreviousModifier,
        repeat: repeatModifier ? Math.max(Number(repeatModifier.substr(1)), 1) : 1,
        releaseSelf: hasReleaseSelf(startBracket, descriptor, releaseSelfModifier, repeatModifier)
    };
}
function assertDescriptor(descriptor, text, pos) {
    if (!descriptor) throw new Error(getErrorMessage("key descriptor", text[pos], text));
}
function getEnumValue(f, key) {
    return f[key];
}
function hasReleaseSelf(startBracket, descriptor, releaseSelfModifier, repeatModifier) {
    if (releaseSelfModifier) return releaseSelfModifier === "/";
    if (repeatModifier) return false;
    if (startBracket === "{" && getEnumValue(legacyModifiers, descriptor.toLowerCase())) return false;
    return true;
}
function mapLegacyKey(descriptor) {
    var _getEnumValue;
    return (_getEnumValue = getEnumValue(legacyKeyMap, descriptor)) != null ? _getEnumValue : descriptor;
}
function getErrorMessage(expected, found, text) {
    return `Expected ${expected} but found "${found != null ? found : ""}" in "${text}"
    See https://github.com/testing-library/user-event/blob/main/README.md#keyboardtext-options
    for more information about how userEvent parses your input.`;
}

},{}],"i69vy":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.replaceBehavior = exports.preKeyupBehavior = exports.preKeydownBehavior = exports.postKeyupBehavior = exports.keyupBehavior = exports.keypressBehavior = exports.keydownBehavior = void 0;
var _utils = require("746cef131795622f");
var arrowKeys = _interopRequireWildcard(require("270d34a8f1349c03"));
var controlKeys = _interopRequireWildcard(require("3b1cab6a17306f63"));
var characterKeys = _interopRequireWildcard(require("5c91601719e829fe"));
var functionalKeys = _interopRequireWildcard(require("82dceb0a94cd8985"));
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
const replaceBehavior = [
    {
        matches: (keyDef, element)=>keyDef.key === "selectall" && (0, _utils.isElementType)(element, [
                "input",
                "textarea"
            ]),
        handle: (keyDef, element, options, state)=>{
            var _state$carryValue;
            (0, _utils.setSelectionRange)(element, 0, ((_state$carryValue = state.carryValue) != null ? _state$carryValue : element.value).length);
        }
    }
];
exports.replaceBehavior = replaceBehavior;
const preKeydownBehavior = [
    ...functionalKeys.preKeydownBehavior
];
exports.preKeydownBehavior = preKeydownBehavior;
const keydownBehavior = [
    ...arrowKeys.keydownBehavior,
    ...controlKeys.keydownBehavior,
    ...functionalKeys.keydownBehavior
];
exports.keydownBehavior = keydownBehavior;
const keypressBehavior = [
    ...functionalKeys.keypressBehavior,
    ...characterKeys.keypressBehavior
];
exports.keypressBehavior = keypressBehavior;
const preKeyupBehavior = [
    ...functionalKeys.preKeyupBehavior
];
exports.preKeyupBehavior = preKeyupBehavior;
const keyupBehavior = [
    ...functionalKeys.keyupBehavior
];
exports.keyupBehavior = keyupBehavior;
const postKeyupBehavior = [
    ...functionalKeys.postKeyupBehavior
];
exports.postKeyupBehavior = postKeyupBehavior;

},{"746cef131795622f":"44kvM","270d34a8f1349c03":"l2fvm","3b1cab6a17306f63":"c5VC8","5c91601719e829fe":"c3eXz","82dceb0a94cd8985":"7RbQl"}],"l2fvm":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.keydownBehavior = void 0;
var _utils = require("19ec8b85b0ed19b0");
/**
 * This file should contain behavior for arrow keys as described here:
 * https://w3c.github.io/uievents-code/#key-arrowpad-section
 */ const keydownBehavior = [
    {
        // TODO: implement for contentEditable
        matches: (keyDef, element)=>(keyDef.key === "ArrowLeft" || keyDef.key === "ArrowRight") && (0, _utils.isElementType)(element, [
                "input",
                "textarea"
            ]),
        handle: (keyDef, element)=>{
            var _ref;
            const { selectionStart, selectionEnd } = (0, _utils.getSelectionRange)(element);
            const direction = keyDef.key === "ArrowLeft" ? -1 : 1;
            const newPos = (_ref = selectionStart === selectionEnd ? (selectionStart != null ? selectionStart : /* istanbul ignore next */ 0) + direction : direction < 0 ? selectionStart : selectionEnd) != null ? _ref : /* istanbul ignore next */ 0;
            (0, _utils.setSelectionRange)(element, newPos, newPos);
        }
    }
];
exports.keydownBehavior = keydownBehavior;

},{"19ec8b85b0ed19b0":"44kvM"}],"c5VC8":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.keydownBehavior = void 0;
var _utils = require("9dd99f8379c9c15b");
var _shared = require("d01f1a5e008ba5be");
/**
 * This file should contain behavior for arrow keys as described here:
 * https://w3c.github.io/uievents-code/#key-controlpad-section
 */ const keydownBehavior = [
    {
        matches: (keyDef, element)=>(keyDef.key === "Home" || keyDef.key === "End") && ((0, _utils.isElementType)(element, [
                "input",
                "textarea"
            ]) || (0, _utils.isContentEditable)(element)),
        handle: (keyDef, element)=>{
            // This could probably been improved by collapsing a selection range
            if (keyDef.key === "Home") (0, _utils.setSelectionRange)(element, 0, 0);
            else {
                var _getValue$length, _getValue;
                const newPos = (_getValue$length = (_getValue = (0, _utils.getValue)(element)) == null ? void 0 : _getValue.length) != null ? _getValue$length : /* istanbul ignore next */ 0;
                (0, _utils.setSelectionRange)(element, newPos, newPos);
            }
        }
    },
    {
        matches: (keyDef, element)=>(keyDef.key === "PageUp" || keyDef.key === "PageDown") && (0, _utils.isElementType)(element, [
                "input"
            ]),
        handle: (keyDef, element)=>{
            // This could probably been improved by collapsing a selection range
            if (keyDef.key === "PageUp") (0, _utils.setSelectionRange)(element, 0, 0);
            else {
                var _getValue$length2, _getValue2;
                const newPos = (_getValue$length2 = (_getValue2 = (0, _utils.getValue)(element)) == null ? void 0 : _getValue2.length) != null ? _getValue$length2 : /* istanbul ignore next */ 0;
                (0, _utils.setSelectionRange)(element, newPos, newPos);
            }
        }
    },
    {
        matches: (keyDef, element)=>keyDef.key === "Delete" && (0, _utils.isEditable)(element) && !(0, _utils.isCursorAtEnd)(element),
        handle: (keDef, element, options, state)=>{
            const { newValue, newSelectionStart } = (0, _utils.calculateNewValue)("", element, state.carryValue, undefined, "forward");
            (0, _shared.fireInputEvent)(element, {
                newValue,
                newSelectionStart,
                eventOverrides: {
                    inputType: "deleteContentForward"
                }
            });
            (0, _shared.carryValue)(element, state, newValue);
        }
    }
];
exports.keydownBehavior = keydownBehavior;

},{"9dd99f8379c9c15b":"44kvM","d01f1a5e008ba5be":"hlrMC"}],"hlrMC":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _carryValue = require("732b64c07faf20be");
Object.keys(_carryValue).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _carryValue[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _carryValue[key];
        }
    });
});
var _fireChangeForInputTimeIfValid = require("10d6db824abede4f");
Object.keys(_fireChangeForInputTimeIfValid).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _fireChangeForInputTimeIfValid[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _fireChangeForInputTimeIfValid[key];
        }
    });
});
var _fireInputEvent = require("cb9b1accb6070f56");
Object.keys(_fireInputEvent).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _fireInputEvent[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _fireInputEvent[key];
        }
    });
});

},{"732b64c07faf20be":"e0vod","10d6db824abede4f":"iMDC8","cb9b1accb6070f56":"fKq4B"}],"e0vod":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.carryValue = carryValue;
var _utils = require("be587710bfcc5178");
function carryValue(element, state, newValue) {
    const value = (0, _utils.getValue)(element);
    state.carryValue = value !== newValue && value === "" && (0, _utils.hasUnreliableEmptyValue)(element) ? newValue : undefined;
}

},{"be587710bfcc5178":"44kvM"}],"iMDC8":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.fireChangeForInputTimeIfValid = fireChangeForInputTimeIfValid;
var _dom = require("311e1ae03c4d7084");
var _utils = require("867245146c24043d");
function fireChangeForInputTimeIfValid(el, prevValue, timeNewEntry) {
    if ((0, _utils.isValidInputTimeValue)(el, timeNewEntry) && prevValue !== timeNewEntry) _dom.fireEvent.change(el, {
        target: {
            value: timeNewEntry
        }
    });
}

},{"311e1ae03c4d7084":"f2A46","867245146c24043d":"44kvM"}],"fKq4B":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.fireInputEvent = fireInputEvent;
var _dom = require("2fa83f096321a51b");
var _utils = require("314f7375f55bdd51");
function fireInputEvent(element, { newValue, newSelectionStart, eventOverrides }) {
    // apply the changes before firing the input event, so that input handlers can access the altered dom and selection
    if ((0, _utils.isContentEditable)(element)) applyNative(element, "textContent", newValue);
    else /* istanbul ignore else */ if ((0, _utils.isElementType)(element, [
        "input",
        "textarea"
    ])) applyNative(element, "value", newValue);
    else // TODO: properly type guard
    throw new Error("Invalid Element");
    setSelectionRangeAfterInput(element, newSelectionStart);
    _dom.fireEvent.input(element, {
        ...eventOverrides
    });
    setSelectionRangeAfterInputHandler(element, newValue, newSelectionStart);
}
function setSelectionRangeAfterInput(element, newSelectionStart) {
    (0, _utils.setSelectionRange)(element, newSelectionStart, newSelectionStart);
}
function setSelectionRangeAfterInputHandler(element, newValue, newSelectionStart) {
    const value = (0, _utils.getValue)(element); // don't apply this workaround on elements that don't necessarily report the visible value - e.g. number
    // TODO: this could probably be only applied when there is keyboardState.carryValue
    const isUnreliableValue = value === "" && (0, _utils.hasUnreliableEmptyValue)(element);
    if (!isUnreliableValue && value === newValue) {
        const { selectionStart } = (0, _utils.getSelectionRange)(element);
        if (selectionStart === value.length) // The value was changed as expected, but the cursor was moved to the end
        // TODO: this could probably be only applied when we work around a framework setter on the element in applyNative
        (0, _utils.setSelectionRange)(element, newSelectionStart, newSelectionStart);
    }
}
const initial = Symbol("initial input value/textContent");
const onBlur = Symbol("onBlur");
/**
 * React tracks the changes on element properties.
 * This workaround tries to alter the DOM element without React noticing,
 * so that it later picks up the change.
 *
 * @see https://github.com/facebook/react/blob/148f8e497c7d37a3c7ab99f01dec2692427272b1/packages/react-dom/src/client/inputValueTracking.js#L51-L104
 */ function applyNative(element, propName, propValue) {
    const descriptor = Object.getOwnPropertyDescriptor(element, propName);
    const nativeDescriptor = Object.getOwnPropertyDescriptor(element.constructor.prototype, propName);
    if (descriptor && nativeDescriptor) Object.defineProperty(element, propName, nativeDescriptor);
     // Keep track of the initial value to determine if a change event should be dispatched.
    // CONSTRAINT: We can not determine what happened between focus event and our first API call.
    if (element[initial] === undefined) element[initial] = String(element[propName]);
    element[propName] = propValue; // Add an event listener for the blur event to the capture phase on the window.
    // CONSTRAINT: Currently there is no cross-platform solution to unshift the event handler stack.
    // Our change event might occur after other event handlers on the blur event have been processed.
    if (!element[onBlur]) {
        var _element$ownerDocumen;
        (_element$ownerDocumen = element.ownerDocument.defaultView) == null || _element$ownerDocumen.addEventListener("blur", element[onBlur] = ()=>{
            const initV = element[initial]; // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete element[onBlur]; // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete element[initial];
            if (String(element[propName]) !== initV) _dom.fireEvent.change(element);
        }, {
            capture: true,
            once: true
        });
    }
    if (descriptor) Object.defineProperty(element, propName, descriptor);
}

},{"2fa83f096321a51b":"f2A46","314f7375f55bdd51":"44kvM"}],"c3eXz":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.keypressBehavior = void 0;
var _dom = require("77c3e1c02bcb502c");
var _shared = require("f63be530ee0fffc9");
var _utils = require("1738c3ec94afdbfa");
/**
 * This file should cover the behavior for keys that produce character input
 */ const keypressBehavior = [
    {
        matches: (keyDef, element)=>{
            var _keyDef$key;
            return ((_keyDef$key = keyDef.key) == null ? void 0 : _keyDef$key.length) === 1 && (0, _utils.isElementType)(element, "input", {
                type: "time",
                readOnly: false
            });
        },
        handle: (keyDef, element, options, state)=>{
            var _state$carryValue;
            let newEntry = keyDef.key;
            const textToBeTyped = ((_state$carryValue = state.carryValue) != null ? _state$carryValue : "") + newEntry;
            const timeNewEntry = (0, _utils.buildTimeValue)(textToBeTyped);
            if ((0, _utils.isValidInputTimeValue)(element, timeNewEntry)) newEntry = timeNewEntry;
            const { newValue, newSelectionStart } = (0, _utils.calculateNewValue)(newEntry, element);
            const prevValue = (0, _utils.getValue)(element); // this check was provided by fireInputEventIfNeeded
            // TODO: verify if it is even needed by this handler
            if (prevValue !== newValue) (0, _shared.fireInputEvent)(element, {
                newValue,
                newSelectionStart,
                eventOverrides: {
                    data: keyDef.key,
                    inputType: "insertText"
                }
            });
            (0, _shared.fireChangeForInputTimeIfValid)(element, prevValue, timeNewEntry);
            state.carryValue = textToBeTyped;
        }
    },
    {
        matches: (keyDef, element)=>{
            var _keyDef$key2;
            return ((_keyDef$key2 = keyDef.key) == null ? void 0 : _keyDef$key2.length) === 1 && (0, _utils.isElementType)(element, "input", {
                type: "date",
                readOnly: false
            });
        },
        handle: (keyDef, element, options, state)=>{
            var _state$carryValue2;
            let newEntry = keyDef.key;
            const textToBeTyped = ((_state$carryValue2 = state.carryValue) != null ? _state$carryValue2 : "") + newEntry;
            const isValidToBeTyped = (0, _utils.isValidDateValue)(element, textToBeTyped);
            if (isValidToBeTyped) newEntry = textToBeTyped;
            const { newValue, newSelectionStart } = (0, _utils.calculateNewValue)(newEntry, element);
            const prevValue = (0, _utils.getValue)(element); // this check was provided by fireInputEventIfNeeded
            // TODO: verify if it is even needed by this handler
            if (prevValue !== newValue) (0, _shared.fireInputEvent)(element, {
                newValue,
                newSelectionStart,
                eventOverrides: {
                    data: keyDef.key,
                    inputType: "insertText"
                }
            });
            if (isValidToBeTyped) _dom.fireEvent.change(element, {
                target: {
                    value: textToBeTyped
                }
            });
            state.carryValue = textToBeTyped;
        }
    },
    {
        matches: (keyDef, element)=>{
            var _keyDef$key3;
            return ((_keyDef$key3 = keyDef.key) == null ? void 0 : _keyDef$key3.length) === 1 && (0, _utils.isElementType)(element, "input", {
                type: "number",
                readOnly: false
            });
        },
        handle: (keyDef, element, options, state)=>{
            var _ref, _state$carryValue3, _newValue$match, _newValue$match2;
            if (!/[\d.\-e]/.test(keyDef.key)) return;
            const oldValue = (_ref = (_state$carryValue3 = state.carryValue) != null ? _state$carryValue3 : (0, _utils.getValue)(element)) != null ? _ref : /* istanbul ignore next */ "";
            const { newValue, newSelectionStart } = (0, _utils.calculateNewValue)(keyDef.key, element, oldValue); // the browser allows some invalid input but not others
            // it allows up to two '-' at any place before any 'e' or one directly following 'e'
            // it allows one '.' at any place before e
            const valueParts = newValue.split("e", 2);
            if (Number((_newValue$match = newValue.match(/-/g)) == null ? void 0 : _newValue$match.length) > 2 || Number((_newValue$match2 = newValue.match(/\./g)) == null ? void 0 : _newValue$match2.length) > 1 || valueParts[1] && !/^-?\d*$/.test(valueParts[1])) return;
            (0, _shared.fireInputEvent)(element, {
                newValue,
                newSelectionStart,
                eventOverrides: {
                    data: keyDef.key,
                    inputType: "insertText"
                }
            });
            const appliedValue = (0, _utils.getValue)(element);
            if (appliedValue === newValue) state.carryValue = undefined;
            else state.carryValue = newValue;
        }
    },
    {
        matches: (keyDef, element)=>{
            var _keyDef$key4;
            return ((_keyDef$key4 = keyDef.key) == null ? void 0 : _keyDef$key4.length) === 1 && ((0, _utils.isElementType)(element, [
                "input",
                "textarea"
            ], {
                readOnly: false
            }) && !(0, _utils.isClickableInput)(element) || (0, _utils.isContentEditable)(element)) && (0, _utils.getSpaceUntilMaxLength)(element) !== 0;
        },
        handle: (keyDef, element)=>{
            const { newValue, newSelectionStart } = (0, _utils.calculateNewValue)(keyDef.key, element);
            (0, _shared.fireInputEvent)(element, {
                newValue,
                newSelectionStart,
                eventOverrides: {
                    data: keyDef.key,
                    inputType: "insertText"
                }
            });
        }
    },
    {
        matches: (keyDef, element)=>keyDef.key === "Enter" && ((0, _utils.isElementType)(element, "textarea", {
                readOnly: false
            }) || (0, _utils.isContentEditable)(element)) && (0, _utils.getSpaceUntilMaxLength)(element) !== 0,
        handle: (keyDef, element, options, state)=>{
            const { newValue, newSelectionStart } = (0, _utils.calculateNewValue)("\n", element);
            const inputType = (0, _utils.isContentEditable)(element) && !state.modifiers.shift ? "insertParagraph" : "insertLineBreak";
            (0, _shared.fireInputEvent)(element, {
                newValue,
                newSelectionStart,
                eventOverrides: {
                    inputType
                }
            });
        }
    }
];
exports.keypressBehavior = keypressBehavior;

},{"77c3e1c02bcb502c":"f2A46","f63be530ee0fffc9":"hlrMC","1738c3ec94afdbfa":"44kvM"}],"7RbQl":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.preKeyupBehavior = exports.preKeydownBehavior = exports.postKeyupBehavior = exports.keyupBehavior = exports.keypressBehavior = exports.keydownBehavior = void 0;
var _dom = require("66e7c2e58fa1845c");
var _utils = require("f0e50b878b593bc2");
var _getEventProps = require("acf48b4707cfd12c");
var _shared = require("b8a3ca0e15a027ef");
/**
 * This file should contain behavior for functional keys as described here:
 * https://w3c.github.io/uievents-code/#key-alphanumeric-functional
 */ const modifierKeys = {
    Alt: "alt",
    Control: "ctrl",
    Shift: "shift",
    Meta: "meta"
};
const preKeydownBehavior = [
    ...Object.entries(modifierKeys).map(([key, modKey])=>({
            matches: (keyDef)=>keyDef.key === key,
            handle: (keyDef, element, options, state)=>{
                state.modifiers[modKey] = true;
            }
        })),
    // The modifier does not change
    {
        matches: (keyDef)=>keyDef.key === "AltGraph",
        handle: (keyDef, element, options, state)=>{
            var _options$keyboardMap$;
            const ctrlKeyDef = (_options$keyboardMap$ = options.keyboardMap.find((k)=>k.key === "Control")) != null ? _options$keyboardMap$ : /* istanbul ignore next */ {
                key: "Control",
                code: "Control"
            };
            _dom.fireEvent.keyDown(element, (0, _getEventProps.getKeyEventProps)(ctrlKeyDef, state));
        }
    }
];
exports.preKeydownBehavior = preKeydownBehavior;
const keydownBehavior = [
    {
        matches: (keyDef)=>keyDef.key === "CapsLock",
        handle: (keyDef, element, options, state)=>{
            state.modifiers.caps = !state.modifiers.caps;
        }
    },
    {
        matches: (keyDef, element)=>keyDef.key === "Backspace" && (0, _utils.isEditable)(element) && !(0, _utils.isCursorAtStart)(element),
        handle: (keyDef, element, options, state)=>{
            const { newValue, newSelectionStart } = (0, _utils.calculateNewValue)("", element, state.carryValue, undefined, "backward");
            (0, _shared.fireInputEvent)(element, {
                newValue,
                newSelectionStart,
                eventOverrides: {
                    inputType: "deleteContentBackward"
                }
            });
            (0, _shared.carryValue)(element, state, newValue);
        }
    }
];
exports.keydownBehavior = keydownBehavior;
const keypressBehavior = [
    {
        matches: (keyDef, element)=>keyDef.key === "Enter" && (0, _utils.isElementType)(element, "input") && [
                "checkbox",
                "radio"
            ].includes(element.type),
        handle: (keyDef, element)=>{
            const form = element.form;
            if ((0, _utils.hasFormSubmit)(form)) _dom.fireEvent.submit(form);
        }
    },
    {
        matches: (keyDef, element)=>keyDef.key === "Enter" && ((0, _utils.isClickableInput)(element) || // Links with href defined should handle Enter the same as a click
            (0, _utils.isElementType)(element, "a") && Boolean(element.href)),
        handle: (keyDef, element, options, state)=>{
            _dom.fireEvent.click(element, (0, _getEventProps.getMouseEventProps)(state));
        }
    },
    {
        matches: (keyDef, element)=>keyDef.key === "Enter" && (0, _utils.isElementType)(element, "input"),
        handle: (keyDef, element)=>{
            const form = element.form;
            if (form && (form.querySelectorAll("input").length === 1 || (0, _utils.hasFormSubmit)(form))) _dom.fireEvent.submit(form);
        }
    }
];
exports.keypressBehavior = keypressBehavior;
const preKeyupBehavior = [
    ...Object.entries(modifierKeys).map(([key, modKey])=>({
            matches: (keyDef)=>keyDef.key === key,
            handle: (keyDef, element, options, state)=>{
                state.modifiers[modKey] = false;
            }
        }))
];
exports.preKeyupBehavior = preKeyupBehavior;
const keyupBehavior = [
    {
        matches: (keyDef, element)=>keyDef.key === " " && (0, _utils.isClickableInput)(element),
        handle: (keyDef, element, options, state)=>{
            _dom.fireEvent.click(element, (0, _getEventProps.getMouseEventProps)(state));
        }
    }
];
exports.keyupBehavior = keyupBehavior;
const postKeyupBehavior = [
    // The modifier does not change
    {
        matches: (keyDef)=>keyDef.key === "AltGraph",
        handle: (keyDef, element, options, state)=>{
            var _options$keyboardMap$2;
            const ctrlKeyDef = (_options$keyboardMap$2 = options.keyboardMap.find((k)=>k.key === "Control")) != null ? _options$keyboardMap$2 : /* istanbul ignore next */ {
                key: "Control",
                code: "Control"
            };
            _dom.fireEvent.keyUp(element, (0, _getEventProps.getKeyEventProps)(ctrlKeyDef, state));
        }
    }
];
exports.postKeyupBehavior = postKeyupBehavior;

},{"66e7c2e58fa1845c":"f2A46","f0e50b878b593bc2":"44kvM","acf48b4707cfd12c":"pyGUn","b8a3ca0e15a027ef":"hlrMC"}],"pyGUn":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getKeyEventProps = getKeyEventProps;
exports.getMouseEventProps = getMouseEventProps;
function getKeyEventProps(keyDef, state) {
    var _keyDef$keyCode, _keyDef$key;
    return {
        key: keyDef.key,
        code: keyDef.code,
        altKey: state.modifiers.alt,
        ctrlKey: state.modifiers.ctrl,
        metaKey: state.modifiers.meta,
        shiftKey: state.modifiers.shift,
        /** @deprecated use code instead */ keyCode: (_keyDef$keyCode = keyDef.keyCode) != null ? _keyDef$keyCode : ((_keyDef$key = keyDef.key) == null ? void 0 : _keyDef$key.length) === 1 ? keyDef.key.charCodeAt(0) : undefined
    };
}
function getMouseEventProps(state) {
    return {
        altKey: state.modifiers.alt,
        ctrlKey: state.modifiers.ctrl,
        metaKey: state.modifiers.meta,
        shiftKey: state.modifiers.shift
    };
}

},{}],"eQTSV":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.defaultKeyMap = void 0;
var _types = require("bc097a736256f539");
/**
 * Mapping for a default US-104-QWERTY keyboard
 */ const defaultKeyMap = [
    ..."0123456789".split("").map((c)=>({
            code: `Digit${c}`,
            key: c
        })),
    ...")!@#$%^&*(".split("").map((c, i)=>({
            code: `Digit${i}`,
            key: c,
            shiftKey: true
        })),
    ..."abcdefghijklmnopqrstuvwxyz".split("").map((c)=>({
            code: `Key${c.toUpperCase()}`,
            key: c
        })),
    ..."ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("").map((c)=>({
            code: `Key${c}`,
            key: c,
            shiftKey: true
        })),
    {
        code: "Space",
        key: " "
    },
    {
        code: "AltLeft",
        key: "Alt",
        location: _types.DOM_KEY_LOCATION.LEFT,
        keyCode: 18
    },
    {
        code: "AltRight",
        key: "Alt",
        location: _types.DOM_KEY_LOCATION.RIGHT,
        keyCode: 18
    },
    {
        code: "ShiftLeft",
        key: "Shift",
        location: _types.DOM_KEY_LOCATION.LEFT,
        keyCode: 16
    },
    {
        code: "ShiftRight",
        key: "Shift",
        location: _types.DOM_KEY_LOCATION.RIGHT,
        keyCode: 16
    },
    {
        code: "ControlLeft",
        key: "Control",
        location: _types.DOM_KEY_LOCATION.LEFT,
        keyCode: 17
    },
    {
        code: "ControlRight",
        key: "Control",
        location: _types.DOM_KEY_LOCATION.RIGHT,
        keyCode: 17
    },
    {
        code: "MetaLeft",
        key: "Meta",
        location: _types.DOM_KEY_LOCATION.LEFT,
        keyCode: 93
    },
    {
        code: "MetaRight",
        key: "Meta",
        location: _types.DOM_KEY_LOCATION.RIGHT,
        keyCode: 93
    },
    {
        code: "OSLeft",
        key: "OS",
        location: _types.DOM_KEY_LOCATION.LEFT,
        keyCode: 91
    },
    {
        code: "OSRight",
        key: "OS",
        location: _types.DOM_KEY_LOCATION.RIGHT,
        keyCode: 91
    },
    {
        code: "CapsLock",
        key: "CapsLock",
        keyCode: 20
    },
    {
        code: "Backspace",
        key: "Backspace",
        keyCode: 8
    },
    {
        code: "Enter",
        key: "Enter",
        keyCode: 13
    },
    {
        code: "Escape",
        key: "Escape",
        keyCode: 27
    },
    {
        code: "ArrowUp",
        key: "ArrowUp",
        keyCode: 38
    },
    {
        code: "ArrowDown",
        key: "ArrowDown",
        keyCode: 40
    },
    {
        code: "ArrowLeft",
        key: "ArrowLeft",
        keyCode: 37
    },
    {
        code: "ArrowRight",
        key: "ArrowRight",
        keyCode: 39
    },
    {
        code: "Home",
        key: "Home",
        keyCode: 36
    },
    {
        code: "End",
        key: "End",
        keyCode: 35
    },
    {
        code: "Delete",
        key: "Delete",
        keyCode: 46
    },
    {
        code: "PageUp",
        key: "PageUp",
        keyCode: 33
    },
    {
        code: "PageDown",
        key: "PageDown",
        keyCode: 34
    } // TODO: add mappings
];
exports.defaultKeyMap = defaultKeyMap;

},{"bc097a736256f539":"8dDsp"}],"8dDsp":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DOM_KEY_LOCATION = void 0;
/**
 * @internal Do not create/alter this by yourself as this type might be subject to changes.
 */ let DOM_KEY_LOCATION;
exports.DOM_KEY_LOCATION = DOM_KEY_LOCATION;
(function(DOM_KEY_LOCATION) {
    DOM_KEY_LOCATION[DOM_KEY_LOCATION["STANDARD"] = 0] = "STANDARD";
    DOM_KEY_LOCATION[DOM_KEY_LOCATION["LEFT"] = 1] = "LEFT";
    DOM_KEY_LOCATION[DOM_KEY_LOCATION["RIGHT"] = 2] = "RIGHT";
    DOM_KEY_LOCATION[DOM_KEY_LOCATION["NUMPAD"] = 3] = "NUMPAD";
})(DOM_KEY_LOCATION || (exports.DOM_KEY_LOCATION = DOM_KEY_LOCATION = {}));

},{}],"bWbhQ":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.specialCharMap = void 0;
/**
 * @deprecated This list of strings with special meaning is no longer necessary
 * as we've introduced a standardized way to describe any keystroke for `userEvent`.
 * @see https://testing-library.com/docs/ecosystem-user-event#keyboardtext-options
 */ const specialCharMap = {
    arrowLeft: "{arrowleft}",
    arrowRight: "{arrowright}",
    arrowDown: "{arrowdown}",
    arrowUp: "{arrowup}",
    enter: "{enter}",
    escape: "{esc}",
    delete: "{del}",
    backspace: "{backspace}",
    home: "{home}",
    end: "{end}",
    selectAll: "{selectall}",
    space: "{space}",
    whitespace: " ",
    pageUp: "{pageUp}",
    pageDown: "{pageDown}"
};
exports.specialCharMap = specialCharMap;

},{}],"dtwrw":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.clear = clear;
var _utils = require("4d47d4a146263ec2");
var _type = require("b824bf90eb120d14");
function clear(element) {
    var _element$selectionSta, _element$selectionEnd;
    if (!(0, _utils.isElementType)(element, [
        "input",
        "textarea"
    ])) // TODO: support contenteditable
    throw new Error("clear currently only supports input and textarea elements.");
    if ((0, _utils.isDisabled)(element)) return;
     // TODO: track the selection range ourselves so we don't have to do this input "type" trickery
    // just like cypress does: https://github.com/cypress-io/cypress/blob/8d7f1a0bedc3c45a2ebf1ff50324b34129fdc683/packages/driver/src/dom/selection.ts#L16-L37
    const elementType = element.type;
    if (elementType !== "textarea") element.type = "text";
    (0, _type.type)(element, "{selectall}{del}", {
        delay: 0,
        initialSelectionStart: (_element$selectionSta = element.selectionStart) != null ? _element$selectionSta : /* istanbul ignore next */ undefined,
        initialSelectionEnd: (_element$selectionEnd = element.selectionEnd) != null ? _element$selectionEnd : /* istanbul ignore next */ undefined
    });
    if (elementType !== "textarea") element.type = elementType;
}

},{"4d47d4a146263ec2":"44kvM","b824bf90eb120d14":"8ZIJq"}],"2Nb9g":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.tab = tab;
var _dom = require("737edfd4224787ee");
var _utils = require("41898db3984a2637");
var _focus = require("3a83ab2dd9c2fd92");
var _blur = require("f5d12122468f22de");
function getNextElement(currentIndex, shift, elements, focusTrap) {
    if ((0, _utils.isDocument)(focusTrap) && (currentIndex === 0 && shift || currentIndex === elements.length - 1 && !shift)) return focusTrap.body;
    const nextIndex = shift ? currentIndex - 1 : currentIndex + 1;
    const defaultIndex = shift ? elements.length - 1 : 0;
    return elements[nextIndex] || elements[defaultIndex];
}
function tab({ shift = false, focusTrap } = {}) {
    var _focusTrap$ownerDocum, _focusTrap;
    const doc = (_focusTrap$ownerDocum = (_focusTrap = focusTrap) == null ? void 0 : _focusTrap.ownerDocument) != null ? _focusTrap$ownerDocum : document;
    const previousElement = (0, _utils.getActiveElement)(doc);
    if (!focusTrap) focusTrap = doc;
    const focusableElements = focusTrap.querySelectorAll(_utils.FOCUSABLE_SELECTOR);
    const enabledElements = Array.from(focusableElements).filter((el)=>el === previousElement || el.getAttribute("tabindex") !== "-1" && !(0, _utils.isDisabled)(el) && // Hidden elements are not tabable
        (0, _utils.isVisible)(el));
    if (enabledElements.length === 0) return;
    const orderedElements = enabledElements.map((el, idx)=>({
            el,
            idx
        })).sort((a, b)=>{
        // tabindex has no effect if the active element has tabindex="-1"
        if (previousElement && previousElement.getAttribute("tabindex") === "-1") return a.idx - b.idx;
        const tabIndexA = Number(a.el.getAttribute("tabindex"));
        const tabIndexB = Number(b.el.getAttribute("tabindex"));
        const diff = tabIndexA - tabIndexB;
        return diff === 0 ? a.idx - b.idx : diff;
    }).map(({ el })=>el); // TODO: verify/remove type casts
    const checkedRadio = {};
    let prunedElements = [];
    orderedElements.forEach((currentElement)=>{
        // For radio groups keep only the active radio
        // If there is no active radio, keep only the checked radio
        // If there is no checked radio, treat like everything else
        const el = currentElement;
        if (el.type === "radio" && el.name) {
            // If the active element is part of the group, add only that
            const prev = previousElement;
            if (prev && prev.type === el.type && prev.name === el.name) {
                if (el === prev) prunedElements.push(el);
                return;
            } // If we stumble upon a checked radio, remove the others
            if (el.checked) {
                prunedElements = prunedElements.filter((e)=>e.type !== el.type || e.name !== el.name);
                prunedElements.push(el);
                checkedRadio[el.name] = el;
                return;
            } // If we already found the checked one, skip
            if (typeof checkedRadio[el.name] !== "undefined") return;
        }
        prunedElements.push(el);
    });
    const index = prunedElements.findIndex((el)=>el === previousElement);
    const nextElement = getNextElement(index, shift, prunedElements, focusTrap);
    const shiftKeyInit = {
        key: "Shift",
        keyCode: 16,
        shiftKey: true
    };
    const tabKeyInit = {
        key: "Tab",
        keyCode: 9,
        shiftKey: shift
    };
    let continueToTab = true; // not sure how to make it so there's no previous element...
    // istanbul ignore else
    if (previousElement) {
        // preventDefault on the shift key makes no difference
        if (shift) _dom.fireEvent.keyDown(previousElement, {
            ...shiftKeyInit
        });
        continueToTab = _dom.fireEvent.keyDown(previousElement, {
            ...tabKeyInit
        });
    }
    const keyUpTarget = !continueToTab && previousElement ? previousElement : nextElement;
    if (continueToTab) {
        if (nextElement === doc.body) /* istanbul ignore else */ {
            if (previousElement) (0, _blur.blur)(previousElement);
        } else (0, _focus.focus)(nextElement);
    }
    _dom.fireEvent.keyUp(keyUpTarget, {
        ...tabKeyInit
    });
    if (shift) _dom.fireEvent.keyUp(keyUpTarget, {
        ...shiftKeyInit,
        shiftKey: false
    });
} /*
eslint
  complexity: "off",
  max-statements: "off",
*/ 

},{"737edfd4224787ee":"f2A46","41898db3984a2637":"44kvM","3a83ab2dd9c2fd92":"3KAtg","f5d12122468f22de":"fYyoU"}],"eGNuj":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.upload = upload;
var _dom = require("38eafd542683f7cc");
var _click = require("f2dd944221615e20");
var _blur = require("bf3fcc9af8c02ea1");
var _focus = require("2a9cb91420c9b044");
var _utils = require("8251bc7d8a67293c");
function upload(element, fileOrFiles, init, { applyAccept = false } = {}) {
    var _input$files;
    const input = (0, _utils.isElementType)(element, "label") ? element.control : element;
    if (!input || !(0, _utils.isElementType)(input, "input", {
        type: "file"
    })) throw new TypeError(`The ${input === element ? "given" : "associated"} ${input == null ? void 0 : input.tagName} element does not accept file uploads`);
    if ((0, _utils.isDisabled)(element)) return;
    (0, _click.click)(element, init == null ? void 0 : init.clickInit);
    const files = (Array.isArray(fileOrFiles) ? fileOrFiles : [
        fileOrFiles
    ]).filter((file)=>!applyAccept || isAcceptableFile(file, input.accept)).slice(0, input.multiple ? undefined : 1); // blur fires when the file selector pops up
    (0, _blur.blur)(element); // focus fires when they make their selection
    (0, _focus.focus)(element); // do not fire an input event if the file selection does not change
    if (files.length === ((_input$files = input.files) == null ? void 0 : _input$files.length) && files.every((f, i)=>{
        var _input$files2;
        return f === ((_input$files2 = input.files) == null ? void 0 : _input$files2.item(i));
    })) return;
     // the event fired in the browser isn't actually an "input" or "change" event
    // but a new Event with a type set to "input" and "change"
    // Kinda odd...
    const inputFiles = {
        ...files,
        length: files.length,
        item: (index)=>files[index],
        [Symbol.iterator] () {
            let i = 0;
            return {
                next: ()=>({
                        done: i >= files.length,
                        value: files[i++]
                    })
            };
        }
    };
    (0, _dom.fireEvent)(input, (0, _dom.createEvent)("input", input, {
        target: {
            files: inputFiles
        },
        bubbles: true,
        cancelable: false,
        composed: true
    }));
    _dom.fireEvent.change(input, {
        target: {
            files: inputFiles
        },
        ...init == null ? void 0 : init.changeInit
    });
}
function isAcceptableFile(file, accept) {
    if (!accept) return true;
    const wildcards = [
        "audio/*",
        "image/*",
        "video/*"
    ];
    return accept.split(",").some((acceptToken)=>{
        if (acceptToken.startsWith(".")) // tokens starting with a dot represent a file extension
        return file.name.endsWith(acceptToken);
        else if (wildcards.includes(acceptToken)) return file.type.startsWith(acceptToken.substr(0, acceptToken.length - 1));
        return file.type === acceptToken;
    });
}

},{"38eafd542683f7cc":"f2A46","f2dd944221615e20":"4GzGH","bf3fcc9af8c02ea1":"fYyoU","2a9cb91420c9b044":"3KAtg","8251bc7d8a67293c":"44kvM"}],"75wWf":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.selectOptions = exports.deselectOptions = void 0;
var _dom = require("688f28ae11a89e5");
var _utils = require("73c7586e5ada8675");
var _click = require("b19a63c94e94166a");
var _focus = require("8be451941b1bad97");
var _hover = require("f9c867df9d83292c");
function selectOptionsBase(newValue, select, values, init, { skipPointerEventsCheck = false } = {}) {
    if (!newValue && !select.multiple) throw (0, _dom.getConfig)().getElementError(`Unable to deselect an option in a non-multiple select. Use selectOptions to change the selection instead.`, select);
    const valArray = Array.isArray(values) ? values : [
        values
    ];
    const allOptions = Array.from(select.querySelectorAll('option, [role="option"]'));
    const selectedOptions = valArray.map((val)=>{
        if (typeof val !== "string" && allOptions.includes(val)) return val;
        else {
            const matchingOption = allOptions.find((o)=>o.value === val || o.innerHTML === val);
            if (matchingOption) return matchingOption;
            else throw (0, _dom.getConfig)().getElementError(`Value "${String(val)}" not found in options`, select);
        }
    }).filter((option)=>!(0, _utils.isDisabled)(option));
    if ((0, _utils.isDisabled)(select) || !selectedOptions.length) return;
    if ((0, _utils.isElementType)(select, "select")) {
        if (select.multiple) for (const option of selectedOptions){
            const withPointerEvents = skipPointerEventsCheck ? true : (0, _utils.hasPointerEvents)(option); // events fired for multiple select are weird. Can't use hover...
            if (withPointerEvents) {
                _dom.fireEvent.pointerOver(option, init);
                _dom.fireEvent.pointerEnter(select, init);
                _dom.fireEvent.mouseOver(option);
                _dom.fireEvent.mouseEnter(select);
                _dom.fireEvent.pointerMove(option, init);
                _dom.fireEvent.mouseMove(option, init);
                _dom.fireEvent.pointerDown(option, init);
                _dom.fireEvent.mouseDown(option, init);
            }
            (0, _focus.focus)(select);
            if (withPointerEvents) {
                _dom.fireEvent.pointerUp(option, init);
                _dom.fireEvent.mouseUp(option, init);
            }
            selectOption(option);
            if (withPointerEvents) _dom.fireEvent.click(option, init);
        }
        else if (selectedOptions.length === 1) {
            const withPointerEvents = skipPointerEventsCheck ? true : (0, _utils.hasPointerEvents)(select); // the click to open the select options
            if (withPointerEvents) (0, _click.click)(select, init, {
                skipPointerEventsCheck
            });
            else (0, _focus.focus)(select);
            selectOption(selectedOptions[0]);
            if (withPointerEvents) {
                // the browser triggers another click event on the select for the click on the option
                // this second click has no 'down' phase
                _dom.fireEvent.pointerOver(select, init);
                _dom.fireEvent.pointerEnter(select, init);
                _dom.fireEvent.mouseOver(select);
                _dom.fireEvent.mouseEnter(select);
                _dom.fireEvent.pointerUp(select, init);
                _dom.fireEvent.mouseUp(select, init);
                _dom.fireEvent.click(select, init);
            }
        } else throw (0, _dom.getConfig)().getElementError(`Cannot select multiple options on a non-multiple select`, select);
    } else if (select.getAttribute("role") === "listbox") selectedOptions.forEach((option)=>{
        (0, _hover.hover)(option, init, {
            skipPointerEventsCheck
        });
        (0, _click.click)(option, init, {
            skipPointerEventsCheck
        });
        (0, _hover.unhover)(option, init, {
            skipPointerEventsCheck
        });
    });
    else throw (0, _dom.getConfig)().getElementError(`Cannot select options on elements that are neither select nor listbox elements`, select);
    function selectOption(option) {
        option.selected = newValue;
        (0, _dom.fireEvent)(select, (0, _dom.createEvent)("input", select, {
            bubbles: true,
            cancelable: false,
            composed: true,
            ...init
        }));
        _dom.fireEvent.change(select, init);
    }
}
const selectOptions = selectOptionsBase.bind(null, true);
exports.selectOptions = selectOptions;
const deselectOptions = selectOptionsBase.bind(null, false);
exports.deselectOptions = deselectOptions;

},{"688f28ae11a89e5":"f2A46","73c7586e5ada8675":"44kvM","b19a63c94e94166a":"4GzGH","8be451941b1bad97":"3KAtg","f9c867df9d83292c":"cclLK"}],"kJzkn":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.paste = paste;
var _dom = require("1478b2001758771e");
var _utils = require("d11098cb08f1fc71");
function isSupportedElement(element) {
    return (0, _utils.isElementType)(element, "input") && Boolean(_utils.editableInputTypes[element.type]) || (0, _utils.isElementType)(element, "textarea");
}
function paste(element, text, init, { initialSelectionStart, initialSelectionEnd } = {}) {
    // TODO: implement for contenteditable
    if (!isSupportedElement(element)) throw new TypeError(`The given ${element.tagName} element is currently unsupported.
      A PR extending this implementation would be very much welcome at https://github.com/testing-library/user-event`);
    if ((0, _utils.isDisabled)(element)) return;
    (0, _utils.eventWrapper)(()=>element.focus()); // by default, a new element has it's selection start and end at 0
    // but most of the time when people call "paste", they expect it to paste
    // at the end of the current input value. So, if the selection start
    // and end are both the default of 0, then we'll go ahead and change
    // them to the length of the current value.
    // the only time it would make sense to pass the initialSelectionStart or
    // initialSelectionEnd is if you have an input with a value and want to
    // explicitely start typing with the cursor at 0. Not super common.
    if (element.selectionStart === 0 && element.selectionEnd === 0) (0, _utils.setSelectionRange)(element, initialSelectionStart != null ? initialSelectionStart : element.value.length, initialSelectionEnd != null ? initialSelectionEnd : element.value.length);
    _dom.fireEvent.paste(element, init);
    if (element.readOnly) return;
    text = text.substr(0, (0, _utils.getSpaceUntilMaxLength)(element));
    const { newValue, newSelectionStart } = (0, _utils.calculateNewValue)(text, element);
    _dom.fireEvent.input(element, {
        inputType: "insertFromPaste",
        target: {
            value: newValue
        }
    });
    (0, _utils.setSelectionRange)(element, {
        newSelectionStart,
        selectionEnd: newSelectionStart
    }, {});
}

},{"1478b2001758771e":"f2A46","d11098cb08f1fc71":"44kvM"}],"b3KVD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "dedent", ()=>dedent);
function dedent(templ) {
    var values = [];
    for(var _i = 1; _i < arguments.length; _i++)values[_i - 1] = arguments[_i];
    var strings = Array.from(typeof templ === "string" ? [
        templ
    ] : templ);
    strings[strings.length - 1] = strings[strings.length - 1].replace(/\r?\n([\t ]*)$/, "");
    var indentLengths = strings.reduce(function(arr, str) {
        var matches = str.match(/\n([\t ]+|(?!\s).)/g);
        if (matches) return arr.concat(matches.map(function(match) {
            var _a, _b;
            return (_b = (_a = match.match(/[\t ]/g)) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0;
        }));
        return arr;
    }, []);
    if (indentLengths.length) {
        var pattern_1 = new RegExp("\n[	 ]{" + Math.min.apply(Math, indentLengths) + "}", "g");
        strings = strings.map(function(str) {
            return str.replace(pattern_1, "\n");
        });
    }
    strings[0] = strings[0].replace(/^\r?\n/, "");
    var string = strings[0];
    values.forEach(function(value, i) {
        var endentations = string.match(/(?:^|\n)( *)$/);
        var endentation = endentations ? endentations[1] : "";
        var indentedValue = value;
        if (typeof value === "string" && value.includes("\n")) indentedValue = String(value).split("\n").map(function(str, i) {
            return i === 0 ? str : "" + endentation + str;
        }).join("\n");
        string += indentedValue + strings[i + 1];
    });
    return string;
}
exports.default = dedent;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"leBCm":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Default", ()=>Default);
parcelHelpers.export(exports, "Value50", ()=>Value50);
parcelHelpers.export(exports, "Value100", ()=>Value100);
parcelHelpers.export(exports, "SizeS", ()=>SizeS);
parcelHelpers.export(exports, "ShowValueLabelTrue", ()=>ShowValueLabelTrue);
parcelHelpers.export(exports, "ShowValueLabelFalse", ()=>ShowValueLabelFalse);
parcelHelpers.export(exports, "ValueLabel1Of4", ()=>ValueLabel1Of4);
parcelHelpers.export(exports, "UsingNumberFormatOptionsWithCurrencyStyle", ()=>UsingNumberFormatOptionsWithCurrencyStyle);
parcelHelpers.export(exports, "NoVisibleLabel", ()=>NoVisibleLabel);
parcelHelpers.export(exports, "LabelPositionSide", ()=>LabelPositionSide);
parcelHelpers.export(exports, "LabelPositionTop", ()=>LabelPositionTop);
parcelHelpers.export(exports, "LongLabel", ()=>LongLabel);
parcelHelpers.export(exports, "LongLabelLabelPositionSide", ()=>LongLabelLabelPositionSide);
parcelHelpers.export(exports, "IsIndeterminateTrue", ()=>IsIndeterminateTrue);
parcelHelpers.export(exports, "IsIndeterminateTrueSizeS", ()=>IsIndeterminateTrueSizeS);
parcelHelpers.export(exports, "VariantOverBackground", ()=>VariantOverBackground);
parcelHelpers.export(exports, "StaticColorWhite", ()=>StaticColorWhite);
parcelHelpers.export(exports, "StaticColorBlack", ()=>StaticColorBlack);
parcelHelpers.export(exports, "ParentWidth100", ()=>ParentWidth100);
parcelHelpers.export(exports, "ParentWidth100Px", ()=>ParentWidth100Px);
parcelHelpers.export(exports, "Width300Px", ()=>Width300Px);
parcelHelpers.export(exports, "Width300PxIsIndeterminateTrue", ()=>Width300PxIsIndeterminateTrue);
parcelHelpers.export(exports, "Width300PxLabelPositionSide", ()=>Width300PxLabelPositionSide);
parcelHelpers.export(exports, "Width300PxLabelPositionSideIsIndeterminateTrue", ()=>Width300PxLabelPositionSideIsIndeterminateTrue);
parcelHelpers.export(exports, "Width30Px", ()=>Width30Px);
parcelHelpers.export(exports, "Width30PxSizeS", ()=>Width30PxSizeS);
parcelHelpers.export(exports, "Width30PxLabelPositionSideLongLabel", ()=>Width30PxLabelPositionSideLongLabel);
parcelHelpers.export(exports, "Width30PxLabelPositionSideIsIndeterminateTrueLongLabelButtonOnRight", ()=>Width30PxLabelPositionSideIsIndeterminateTrueLongLabelButtonOnRight);
parcelHelpers.export(exports, "UsingRawValuesForMinValueMaxValueAndValue", ()=>UsingRawValuesForMinValueMaxValueAndValue);
parcelHelpers.export(exports, "UsingRawValuesWithNumberFormatter", ()=>UsingRawValuesWithNumberFormatter);
var _ = require("../");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const formatOptions = {
    style: "currency",
    currency: "JPY"
};
const grayedBoxStyle = {
    width: "250px",
    height: "60px",
    backgroundColor: "rgba(0,0,0,0.4)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
};
exports.default = {
    title: "Progress/ProgressBar",
    providerSwitcher: {
        status: "positive"
    },
    args: {
        value: 32
    },
    argTypes: {
        value: {
            control: {
                type: "range",
                min: 0,
                max: 100
            }
        }
    }
};
const Default = (args)=>render(args);
const Value50 = ()=>render({
        value: 50
    });
Value50.story = {
    name: "value: 50"
};
const Value100 = ()=>render({
        value: 100
    });
Value100.story = {
    name: "value: 100"
};
const SizeS = (args)=>render({
        size: "S",
        ...args
    });
SizeS.story = {
    name: "size: S"
};
const ShowValueLabelTrue = (args)=>render({
        showValueLabel: true,
        ...args
    });
ShowValueLabelTrue.story = {
    name: "showValueLabel: true"
};
const ShowValueLabelFalse = (args)=>render({
        showValueLabel: false,
        ...args
    });
ShowValueLabelFalse.story = {
    name: "showValueLabel: false"
};
const ValueLabel1Of4 = ()=>render({
        value: 25,
        valueLabel: "1 of 4"
    });
ValueLabel1Of4.story = {
    name: "valueLabel: 1 of 4"
};
const UsingNumberFormatOptionsWithCurrencyStyle = (args)=>render({
        ...args,
        showValueLabel: true,
        formatOptions
    });
UsingNumberFormatOptionsWithCurrencyStyle.story = {
    name: "Using number formatOptions with currency style"
};
const NoVisibleLabel = (args)=>render({
        label: null,
        "aria-label": "Loading\u2026",
        ...args
    });
NoVisibleLabel.story = {
    name: "no visible label"
};
const LabelPositionSide = (args)=>render({
        labelPosition: "side",
        ...args
    });
LabelPositionSide.story = {
    name: "labelPosition: side"
};
const LabelPositionTop = (args)=>render({
        labelPosition: "top",
        ...args
    });
LabelPositionTop.story = {
    name: "labelPosition: top"
};
const LongLabel = (args)=>render({
        label: "Super long progress bar label. Sample label copy. Loading...",
        ...args
    });
LongLabel.story = {
    name: "long label"
};
const LongLabelLabelPositionSide = (args)=>render({
        labelPosition: "side",
        label: "Super long progress bar label. Sample label copy. Loading...",
        ...args
    });
LongLabelLabelPositionSide.story = {
    name: "long label, labelPosition: side"
};
const IsIndeterminateTrue = (args)=>render({
        isIndeterminate: true,
        ...args
    });
IsIndeterminateTrue.story = {
    name: "isIndeterminate: true"
};
const IsIndeterminateTrueSizeS = ()=>render({
        isIndeterminate: true,
        size: "S"
    });
IsIndeterminateTrueSizeS.story = {
    name: "isIndeterminate: true, size: S"
};
const VariantOverBackground = (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        style: grayedBoxStyle
    }, render({
        variant: "overBackground",
        ...args
    }));
VariantOverBackground.story = {
    name: "variant: overBackground"
};
const StaticColorWhite = (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        style: grayedBoxStyle
    }, render({
        staticColor: "white",
        ...args
    }));
StaticColorWhite.story = {
    name: "staticColor: white"
};
const StaticColorBlack = (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        style: {
            ...grayedBoxStyle,
            backgroundColor: "rgb(206, 247, 243)"
        }
    }, render({
        staticColor: "black",
        ...args
    }));
StaticColorBlack.story = {
    name: "staticColor: black"
};
const ParentWidth100 = ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        style: {
            width: "100%"
        }
    }, render());
ParentWidth100.story = {
    name: "parent width 100%"
};
const ParentWidth100Px = ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        style: {
            width: "100px"
        }
    }, render());
ParentWidth100Px.story = {
    name: "parent width 100px"
};
const Width300Px = ()=>render({
        width: "300px",
        value: 100
    });
Width300Px.story = {
    name: "width: 300px"
};
const Width300PxIsIndeterminateTrue = ()=>render({
        width: "300px",
        isIndeterminate: true
    });
Width300PxIsIndeterminateTrue.story = {
    name: "width: 300px, isIndeterminate: true"
};
const Width300PxLabelPositionSide = ()=>render({
        width: "300px",
        labelPosition: "side"
    });
Width300PxLabelPositionSide.story = {
    name: "width: 300px, labelPosition: side"
};
const Width300PxLabelPositionSideIsIndeterminateTrue = ()=>render({
        width: "300px",
        labelPosition: "side",
        isIndeterminate: true
    });
Width300PxLabelPositionSideIsIndeterminateTrue.story = {
    name: "width: 300px, labelPosition: side, isIndeterminate: true"
};
const Width30Px = ()=>render({
        width: "30px"
    });
Width30Px.story = {
    name: "width: 30px"
};
const Width30PxSizeS = ()=>render({
        width: "30px",
        size: "S"
    });
Width30PxSizeS.story = {
    name: "width: 30px, size: S"
};
const Width30PxLabelPositionSideLongLabel = ()=>render({
        width: "30px",
        labelPosition: "side",
        label: "Super long progress bar label. Sample label copy. Loading..."
    });
Width30PxLabelPositionSideLongLabel.story = {
    name: "width: 30px, labelPosition: side, long label"
};
const Width30PxLabelPositionSideIsIndeterminateTrueLongLabelButtonOnRight = ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, render({
        width: "30px",
        labelPosition: "side",
        isIndeterminate: true,
        label: "Super long progress bar label. Sample label copy. Loading..."
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("button", null, "Confirm"));
Width30PxLabelPositionSideIsIndeterminateTrueLongLabelButtonOnRight.story = {
    name: "width: 30px, labelPosition: side, isIndeterminate: true, long label, button on right"
};
const UsingRawValuesForMinValueMaxValueAndValue = ()=>render({
        showValueLabel: true,
        labelPosition: "top",
        maxValue: 2147483648,
        value: 715827883
    });
UsingRawValuesForMinValueMaxValueAndValue.story = {
    name: "Using raw values for minValue, maxValue, and value"
};
const UsingRawValuesWithNumberFormatter = ()=>render({
        showValueLabel: true,
        labelPosition: "top",
        maxValue: 2147483648,
        value: 715827883,
        formatOptions
    });
UsingRawValuesWithNumberFormatter.story = {
    name: "Using raw values with number formatter"
};
function render(props = {}) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ProgressBar), {
        label: "Loading\u2026",
        ...props
    });
}

},{"../":"4W8Gd","react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"4W8Gd":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _src = require("./src");
parcelHelpers.exportAll(_src, exports);

},{"./src":"4kHa7","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"9DP3B":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Default", ()=>Default);
parcelHelpers.export(exports, "Value50", ()=>Value50);
parcelHelpers.export(exports, "Value100", ()=>Value100);
parcelHelpers.export(exports, "SizeS", ()=>SizeS);
parcelHelpers.export(exports, "SizeL", ()=>SizeL);
parcelHelpers.export(exports, "VariantOverBackground", ()=>VariantOverBackground);
parcelHelpers.export(exports, "StaticColorWhite", ()=>StaticColorWhite);
parcelHelpers.export(exports, "StaticColorBlack", ()=>StaticColorBlack);
parcelHelpers.export(exports, "UsingRawValuesForMinValueMaxValueAndValue", ()=>UsingRawValuesForMinValueMaxValueAndValue);
parcelHelpers.export(exports, "IsIndeterminateTrue", ()=>IsIndeterminateTrue);
parcelHelpers.export(exports, "IsIndeterminateTrueSizeS", ()=>IsIndeterminateTrueSizeS);
parcelHelpers.export(exports, "IsIndeterminateTrueSizeL", ()=>IsIndeterminateTrueSizeL);
parcelHelpers.export(exports, "IsIndeterminateTrueVariantOverBackground", ()=>IsIndeterminateTrueVariantOverBackground);
var _ = require("../");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const grayedBoxStyle = {
    width: "100px",
    height: "100px",
    backgroundColor: "rgba(0,0,0,0.4)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
};
exports.default = {
    title: "Progress/ProgressCircle",
    providerSwitcher: {
        status: "positive"
    },
    args: {
        value: 32
    },
    argTypes: {
        value: {
            control: {
                type: "range",
                min: 0,
                max: 100
            }
        }
    }
};
const Default = (args)=>render(args);
const Value50 = ()=>render({
        value: 50
    });
Value50.story = {
    name: "value: 50"
};
const Value100 = ()=>render({
        value: 100
    });
Value100.story = {
    name: "value: 100"
};
const SizeS = (args)=>render({
        ...args,
        size: "S"
    });
SizeS.story = {
    name: "size: S"
};
const SizeL = (args)=>render({
        ...args,
        size: "L"
    });
SizeL.story = {
    name: "size: L"
};
const VariantOverBackground = (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        style: grayedBoxStyle
    }, render({
        ...args,
        variant: "overBackground"
    }));
VariantOverBackground.story = {
    name: "variant: overBackground"
};
const StaticColorWhite = (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        style: {
            ...grayedBoxStyle,
            backgroundColor: "rgb(0, 119, 114)"
        }
    }, render({
        ...args,
        staticColor: "white"
    }));
StaticColorWhite.story = {
    name: "staticColor: white"
};
const StaticColorBlack = (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        style: {
            ...grayedBoxStyle,
            backgroundColor: "rgb(206, 247, 243)"
        }
    }, render({
        ...args,
        staticColor: "black"
    }));
StaticColorBlack.story = {
    name: "staticColor: black"
};
const UsingRawValuesForMinValueMaxValueAndValue = ()=>render({
        labelPosition: "top",
        maxValue: 2147483648,
        value: 715827883
    });
UsingRawValuesForMinValueMaxValueAndValue.story = {
    name: "Using raw values for minValue, maxValue, and value"
};
const IsIndeterminateTrue = ()=>render({
        isIndeterminate: true
    });
IsIndeterminateTrue.story = {
    name: "isIndeterminate: true"
};
const IsIndeterminateTrueSizeS = ()=>render({
        isIndeterminate: true,
        size: "S"
    });
IsIndeterminateTrueSizeS.story = {
    name: "isIndeterminate: true, size: S"
};
const IsIndeterminateTrueSizeL = ()=>render({
        isIndeterminate: true,
        size: "L"
    });
IsIndeterminateTrueSizeL.story = {
    name: "isIndeterminate: true, size: L"
};
const IsIndeterminateTrueVariantOverBackground = ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        style: grayedBoxStyle
    }, render({
        isIndeterminate: true,
        variant: "overBackground"
    }));
IsIndeterminateTrueVariantOverBackground.story = {
    name: "isIndeterminate: true, variant: overBackground"
};
function render(props = {}) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ProgressCircle), {
        "aria-label": "Loading\u2026",
        ...props
    });
}

},{"../":"4W8Gd","react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"jjp8O":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ColorSchemeDark", ()=>ColorSchemeDark);
parcelHelpers.export(exports, "ScaleLarge", ()=>ScaleLarge);
parcelHelpers.export(exports, "NestedColorSchemes", ()=>NestedColorSchemes);
parcelHelpers.export(exports, "NestedProps", ()=>NestedProps);
parcelHelpers.export(exports, "IsQuiet", ()=>IsQuiet);
parcelHelpers.export(exports, "IsEmphasized", ()=>IsEmphasized);
parcelHelpers.export(exports, "IsDisabled", ()=>IsDisabled);
parcelHelpers.export(exports, "IsReadOnly", ()=>IsReadOnly);
parcelHelpers.export(exports, "IsRequired", ()=>IsRequired);
parcelHelpers.export(exports, "CustomTheme", ()=>CustomTheme);
parcelHelpers.export(exports, "ExpressTheme", ()=>ExpressTheme);
parcelHelpers.export(exports, "ResponsiveStyleProps", ()=>ResponsiveStyleProps);
parcelHelpers.export(exports, "CustomResponsiveStyleProps", ()=>CustomResponsiveStyleProps);
parcelHelpers.export(exports, "BreakpointOmitted", ()=>BreakpointOmitted);
parcelHelpers.export(exports, "LocaleZhHant", ()=>LocaleZhHant);
var _button = require("@react-spectrum/button");
var _checkbox = require("@react-spectrum/checkbox");
var _combobox = require("@react-spectrum/combobox");
var _customThemeCss = require("./custom-theme.css");
var _customThemeCssDefault = parcelHelpers.interopDefault(_customThemeCss);
var _themeExpress = require("@react-spectrum/theme-express");
var _layout = require("@react-spectrum/layout");
var _form = require("@react-spectrum/form");
var _numberfield = require("@react-spectrum/numberfield");
var _ = require("../");
var _radio = require("@react-spectrum/radio");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _spectrumLargeCss = require("@adobe/spectrum-css-temp/vars/spectrum-large.css");
var _spectrumLargeCssDefault = parcelHelpers.interopDefault(_spectrumLargeCss);
var _spectrumMediumCss = require("@adobe/spectrum-css-temp/vars/spectrum-medium.css");
var _spectrumMediumCssDefault = parcelHelpers.interopDefault(_spectrumMediumCss);
var _searchfield = require("@react-spectrum/searchfield");
var _switch = require("@react-spectrum/switch");
var _textfield = require("@react-spectrum/textfield");
var _utils = require("@react-spectrum/utils");
const THEME = {
    light: (0, _customThemeCssDefault.default),
    medium: (0, _spectrumMediumCssDefault.default),
    large: (0, _spectrumLargeCssDefault.default)
};
exports.default = {
    title: "Provider",
    parameters: {
        providerSwitcher: {
            status: "positive"
        }
    }
};
const ColorSchemeDark = ()=>render({
        colorScheme: "dark",
        style: {
            padding: 50,
            textAlign: "center",
            width: 500
        }
    });
ColorSchemeDark.story = {
    name: "colorScheme: dark"
};
const ScaleLarge = ()=>render({
        scale: "large"
    });
ScaleLarge.story = {
    name: "scale: large"
};
const NestedColorSchemes = ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Provider), {
        colorScheme: "dark",
        UNSAFE_style: {
            padding: 50,
            textAlign: "center",
            width: 500
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.Button), {
        variant: "primary"
    }, "I am a dark button"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Provider), {
        colorScheme: "light",
        UNSAFE_style: {
            padding: 50,
            margin: 50,
            textAlign: "center"
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.Button), {
        variant: "primary"
    }, "I am a light button")));
NestedColorSchemes.story = {
    name: "nested color schemes"
};
const NestedProps = ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Provider), {
        isDisabled: true
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.Button), {
        variant: "primary"
    }, "I am disabled"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Provider), {
        isQuiet: true
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.Button), {
        variant: "primary"
    }, "I am disabled and quiet")));
NestedProps.story = {
    name: "nested props"
};
const IsQuiet = ()=>render({
        isQuiet: true
    });
IsQuiet.story = {
    name: "isQuiet"
};
const IsEmphasized = ()=>render({
        isEmphasized: true
    });
IsEmphasized.story = {
    name: "isEmphasized"
};
const IsDisabled = ()=>render({
        isDisabled: true
    });
IsDisabled.story = {
    name: "isDisabled"
};
const IsReadOnly = ()=>render({
        isReadOnly: true
    });
IsReadOnly.story = {
    name: "isReadOnly"
};
const IsRequired = ()=>render({
        isRequired: true
    });
IsRequired.story = {
    name: "isRequired"
};
const CustomTheme = ()=>render({
        theme: THEME
    });
CustomTheme.story = {
    name: "custom theme"
};
const ExpressTheme = ()=>render({
        theme: (0, _themeExpress.theme)
    });
ExpressTheme.story = {
    name: "express theme"
};
const ResponsiveStyleProps = ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Provider), {
        UNSAFE_style: {
            padding: 50
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textfield.TextField), {
        label: "A text field",
        width: {
            base: "size-800",
            S: "size-1000",
            M: "size-2000",
            L: "size-3000"
        }
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.Button), {
        isHidden: {
            base: false,
            S: false,
            M: false,
            L: true
        },
        marginTop: {
            base: "size-100",
            M: "size-1000"
        },
        variant: "primary"
    }, "This button is hidden in large display."));
ResponsiveStyleProps.story = {
    name: "responsive styleProps"
};
const CustomResponsiveStyleProps = ()=>{
    let Breakpoint = ()=>{
        let { matchedBreakpoints } = (0, _utils.useBreakpoint)();
        let breakpoint = matchedBreakpoints[0];
        let width = {
            base: "size-1600",
            XS: "size-2000",
            S: "size-2400",
            M: "size-3000",
            L: "size-3400",
            XL: "size-4600",
            XXL: "size-6000"
        };
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.Button), {
            variant: "primary",
            width: width
        }, "Button with ", breakpoint, " breakpoint."), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", null, "width: ", width[breakpoint]));
    };
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Provider), {
        breakpoints: {
            S: 480,
            M: 640,
            L: 1024
        },
        UNSAFE_style: {
            padding: 50
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Breakpoint, null));
};
CustomResponsiveStyleProps.story = {
    name: "custom responsive styleProps"
};
const BreakpointOmitted = ()=>{
    let Breakpoint = ()=>{
        let { matchedBreakpoints } = (0, _utils.useBreakpoint)();
        let breakpoint = matchedBreakpoints[0];
        let width = {
            base: "size-1600",
            S: "size-2400",
            L: "size-3400"
        };
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement("p", null, "button's width will be S: 'size-2400' at M viewport."), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.Button), {
            variant: "primary",
            width: width
        }, "Button with ", breakpoint, " breakpoint."));
    };
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Provider), {
        UNSAFE_style: {
            padding: 50
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Breakpoint, null));
};
BreakpointOmitted.story = {
    name: "breakpoint omitted"
};
const LocaleZhHant = ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement("div", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", null, "Heaven and earth are mysterious and yellow, the universe is prehistoric"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Provider), {
        locale: "zh-Hant"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", null, "\u5929\u5730\u7384\u9EC3\uFF0C\u5B87\u5B99\u6D2A\u8352")));
LocaleZhHant.story = {
    name: "locale: zh-Hant"
};
function render(props = {}) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Provider), {
        ...props,
        UNSAFE_style: {
            padding: 50
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _form.Form), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), null, " ", /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.Button), {
        variant: "primary"
    }, "I am a button")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _checkbox.CheckboxGroup), {
        defaultValue: [
            "dragons"
        ],
        label: "Pets"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _checkbox.Checkbox), {
        value: "dogs"
    }, "Dogs"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _checkbox.Checkbox), {
        value: "cats"
    }, "Cats"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _checkbox.Checkbox), {
        value: "dragons"
    }, "Dragons")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _combobox.ComboBox), {
        label: "More Animals"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _combobox.Item), {
        key: "red panda"
    }, "Red Panda"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _combobox.Item), {
        key: "aardvark"
    }, "Aardvark"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _combobox.Item), {
        key: "kangaroo"
    }, "Kangaroo"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _combobox.Item), {
        key: "snake"
    }, "Snake")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _numberfield.NumberField), {
        label: "Years lived there"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _radio.RadioGroup), {
        label: "A radio group"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _radio.Radio), {
        value: "dogs"
    }, "Dogs"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _radio.Radio), {
        value: "cats"
    }, "Cats"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _radio.Radio), {
        value: "horses"
    }, "Horses")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _searchfield.SearchField), {
        label: "Search"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _switch.Switch), {
        isSelected: true
    }, "Dogs!"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textfield.TextField), {
        label: "A text field",
        marginTop: "size-100",
        necessityIndicator: "label",
        value: "dummy value"
    })));
}

},{"@react-spectrum/button":"jZWyP","@react-spectrum/checkbox":"1r19j","@react-spectrum/combobox":"bO8KM","./custom-theme.css":"gwDjD","@react-spectrum/theme-express":"k09cF","@react-spectrum/layout":"hzaUY","@react-spectrum/form":"bGDqA","@react-spectrum/numberfield":"cMsXx","../":"0iE6e","@react-spectrum/radio":"gbtGh","react":"9yzVZ","@adobe/spectrum-css-temp/vars/spectrum-large.css":"1BNjr","@adobe/spectrum-css-temp/vars/spectrum-medium.css":"8swdG","@react-spectrum/searchfield":"2pivm","@react-spectrum/switch":"fzqJX","@react-spectrum/textfield":"hOmtq","@react-spectrum/utils":"cMIJ6","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"gwDjD":[function(require,module,exports) {
module.exports["theme"] = `KnBWrq_theme`;

},{}],"k09cF":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /// <reference types="css-module-types" />
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "theme", ()=>theme);
var _themeDefault = require("@react-spectrum/theme-default");
var _expressCss = require("@adobe/spectrum-css-temp/vars/express.css");
var _expressCssDefault = parcelHelpers.interopDefault(_expressCss);
let theme = {
    ...(0, _themeDefault.theme),
    global: {
        ...(0, _themeDefault.theme).global,
        express: (0, _expressCssDefault.default).express
    },
    medium: {
        ...(0, _themeDefault.theme).medium,
        express: (0, _expressCssDefault.default).medium
    },
    large: {
        ...(0, _themeDefault.theme).large,
        express: (0, _expressCssDefault.default).large
    }
};

},{"@react-spectrum/theme-default":"hvP5p","@adobe/spectrum-css-temp/vars/express.css":"5WKyD","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"5WKyD":[function(require,module,exports) {
module.exports["express"] = `-9mX2q_express`;
module.exports["large"] = `-9mX2q_large`;
module.exports["medium"] = `-9mX2q_medium`;

},{}],"0iE6e":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _src = require("./src");
parcelHelpers.exportAll(_src, exports);

},{"./src":"5bCdp","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"bBogr":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Default", ()=>Default);
parcelHelpers.export(exports, "DefaultValueDragons", ()=>DefaultValueDragons);
parcelHelpers.export(exports, "ControlledDragons", ()=>ControlledDragons);
parcelHelpers.export(exports, "IsDisabledOnOneRadio", ()=>IsDisabledOnOneRadio);
parcelHelpers.export(exports, "WithDescription", ()=>WithDescription);
parcelHelpers.export(exports, "WithErrorMessage", ()=>WithErrorMessage);
parcelHelpers.export(exports, "WithErrorMessageAndErrorIcon", ()=>WithErrorMessageAndErrorIcon);
parcelHelpers.export(exports, "WithDescriptionErrorMessageAndValidationFixedWidth", ()=>WithDescriptionErrorMessageAndValidationFixedWidth);
parcelHelpers.export(exports, "_ContextualHelp", ()=>_ContextualHelp);
parcelHelpers.export(exports, "NoVisibleLabel", ()=>NoVisibleLabel);
parcelHelpers.export(exports, "LongRadioLabel", ()=>LongRadioLabel);
parcelHelpers.export(exports, "ProviderControlIsDisabled", ()=>ProviderControlIsDisabled);
parcelHelpers.export(exports, "AutoFocusOnOneRadio", ()=>AutoFocusOnOneRadio);
parcelHelpers.export(exports, "ControlledRovingTab", ()=>ControlledRovingTab);
var _addonActions = require("@storybook/addon-actions");
var _reactSpectrum = require("@adobe/react-spectrum");
var _provider = require("@react-spectrum/provider");
var _src = require("../src");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
exports.default = {
    title: "RadioGroup",
    providerSwitcher: {
        status: "positive"
    },
    args: {
        label: "Favorite pet",
        isEmphasized: false,
        isDisabled: false,
        isReadOnly: false,
        isRequired: false,
        necessityIndicator: "icon",
        labelPosition: "top",
        labelAlign: "start",
        isInvalid: false,
        orientation: "vertical"
    },
    argTypes: {
        labelPosition: {
            control: {
                type: "radio",
                options: [
                    "top",
                    "side"
                ]
            }
        },
        necessityIndicator: {
            control: {
                type: "radio",
                options: [
                    "icon",
                    "label"
                ]
            }
        },
        labelAlign: {
            control: {
                type: "radio",
                options: [
                    "start",
                    "end"
                ]
            }
        },
        orientation: {
            control: {
                type: "radio",
                options: [
                    "horizontal",
                    "vertical"
                ]
            }
        }
    }
};
const Default = (args)=>render(args);
Default.story = {
    name: "default"
};
const DefaultValueDragons = (args)=>render({
        ...args,
        defaultValue: "dragons"
    });
DefaultValueDragons.story = {
    name: "defaultValue: dragons"
};
const ControlledDragons = (args)=>render({
        ...args,
        value: "dragons"
    });
ControlledDragons.story = {
    name: "controlled: dragons"
};
const IsDisabledOnOneRadio = (args)=>render(args, [
        {},
        {
            isDisabled: true
        },
        {}
    ]);
IsDisabledOnOneRadio.story = {
    name: "isDisabled on one radio"
};
const WithDescription = (args)=>render({
        ...args,
        description: "Please select a pet."
    });
WithDescription.story = {
    name: "with description"
};
const WithErrorMessage = (args)=>render({
        ...args,
        errorMessage: "Please select a pet.",
        isInvalid: true
    });
WithErrorMessage.story = {
    name: "with error message"
};
const WithErrorMessageAndErrorIcon = (args)=>render({
        ...args,
        errorMessage: "Please select a pet.",
        isInvalid: true,
        showErrorIcon: true
    });
WithErrorMessageAndErrorIcon.story = {
    name: "with error message and error icon"
};
const WithDescriptionErrorMessageAndValidationFixedWidth = (args)=>renderWithDescriptionErrorMessageAndValidation(args);
WithDescriptionErrorMessageAndValidationFixedWidth.story = {
    name: "with description, error message and validation, fixed width"
};
const _ContextualHelp = (args)=>render({
        ...args,
        contextualHelp: /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSpectrum.ContextualHelp), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSpectrum.Heading), null, "What is a segment?"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSpectrum.Content), null, "Segments identify who your visitors are, what devices and services they use, where they navigated from, and much more."))
    });
_ContextualHelp.story = {
    name: "contextual help"
};
const NoVisibleLabel = (args)=>render({
        ...args,
        label: null,
        "aria-label": "Favorite pet"
    });
NoVisibleLabel.story = {
    name: "no visible label"
};
const LongRadioLabel = (args)=>renderLongLabel(args);
LongRadioLabel.story = {
    name: "long radio label"
};
const ProviderControlIsDisabled = ()=>renderFormControl();
ProviderControlIsDisabled.story = {
    name: "provider control: isDisabled"
};
const AutoFocusOnOneRadio = (args)=>render(args, [
        {},
        {
            autoFocus: true
        },
        {}
    ]);
AutoFocusOnOneRadio.story = {
    name: "autoFocus on one radio"
};
function render(props, radioProps = [
    {},
    {},
    {}
]) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _src.RadioGroup), {
        label: "Favorite pet",
        ...props,
        onChange: (0, _addonActions.action)("onChange"),
        name: "favorite-pet-group"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _src.Radio), {
        value: "dogs",
        ...radioProps[0]
    }, "Dogs"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _src.Radio), {
        value: "cats",
        ...radioProps[1]
    }, "Cats"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _src.Radio), {
        value: "dragons",
        ...radioProps[2]
    }, "Dragons"));
}
function renderLongLabel(props, radioProps = [
    {},
    {},
    {}
]) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _src.RadioGroup), {
        "aria-label": "Favorite pet",
        ...props,
        onChange: (0, _addonActions.action)("onChange")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _src.Radio), {
        value: "dogs",
        ...radioProps[0]
    }, "Dogs Dogs Dogs Dogs Dogs Dogs Dogs Dogs Dogs Dogs Dogs Dogs Dogs Dogs Dogs Dogs Dogs Dogs Dogs Dogs Dogs Dogs Dogs"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _src.Radio), {
        value: "cats",
        ...radioProps[1]
    }, "Cats"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _src.Radio), {
        value: "dragons",
        ...radioProps[2]
    }, "Dragons"));
}
function renderFormControl() {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _provider.Provider), {
        isDisabled: true
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _src.RadioGroup), {
        "aria-label": "Favorite pet",
        onChange: (0, _addonActions.action)("onChangePet"),
        name: "favorite-pet-group"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _src.Radio), {
        value: "dogs"
    }, "Dogs"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _src.Radio), {
        value: "cats"
    }, "Cats"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _src.Radio), {
        value: "dragons"
    }, "Dragons")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _src.RadioGroup), {
        "aria-label": "Favorite cereal",
        onChange: (0, _addonActions.action)("onChangeCereal"),
        name: "favorite-cereal-group"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _src.Radio), {
        value: "reeses"
    }, "Reese's Peanut Butter Puffs"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _src.Radio), {
        value: "honeynut"
    }, "HoneyNut Cheerios"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _src.Radio), {
        value: "cinnamon"
    }, "Cinnamon Toast Crunch")));
}
function renderWithDescriptionErrorMessageAndValidation(props) {
    function Example() {
        let [selected, setSelected] = (0, _react.useState)("dogs");
        let isValid = selected === "dogs";
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSpectrum.Flex), {
            width: "480px"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _src.RadioGroup), {
            ...props,
            "aria-label": "Favorite pet",
            onChange: setSelected,
            isInvalid: !isValid,
            description: "Please select a pet.",
            errorMessage: selected === "cats" ? "No cats allowed." : "Please select dogs."
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _src.Radio), {
            value: "dogs"
        }, "Dogs"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _src.Radio), {
            value: "cats"
        }, "Cats"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _src.Radio), {
            value: "dragons"
        }, "Dragons")));
    }
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Example, null);
}
const ControlledRovingTab = ()=>{
    const [selected, setSelected] = (0, _react.useState)("1");
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSpectrum.Flex), {
        direction: "column",
        gap: "16px",
        alignItems: "center",
        margin: "16px"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSpectrum.Button), {
        variant: "primary",
        onPress: ()=>setSelected("2")
    }, 'Make it "Two"'), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _src.RadioGroup), {
        label: "Lucky number? (controlled)",
        value: selected,
        onChange: setSelected
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _src.Radio), {
        value: "1"
    }, "One"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _src.Radio), {
        value: "2"
    }, "Two"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _src.Radio), {
        value: "3"
    }, "Three"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _src.Radio), {
        value: "4"
    }, "Four")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSpectrum.Button), {
        variant: "primary",
        onPress: ()=>setSelected("3")
    }, 'Make it "Three"'));
};
ControlledRovingTab.story = {
    name: "controlled roving tab"
};

},{"@storybook/addon-actions":"coXbW","@adobe/react-spectrum":"cwANo","@react-spectrum/provider":"5bCdp","../src":"gbtGh","react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"cETgv":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Default", ()=>Default);
parcelHelpers.export(exports, "DefaultValueUncontrolled", ()=>DefaultValueUncontrolled);
parcelHelpers.export(exports, "ValueControlled", ()=>ValueControlled);
parcelHelpers.export(exports, "IconRefresh", ()=>IconRefresh);
parcelHelpers.export(exports, "IconNull", ()=>IconNull);
parcelHelpers.export(exports, "OnClear", ()=>OnClear);
parcelHelpers.export(exports, "AutoFocus", ()=>AutoFocus);
parcelHelpers.export(exports, "NoVisibleLabel", ()=>NoVisibleLabel);
parcelHelpers.export(exports, "WithDescription", ()=>WithDescription);
parcelHelpers.export(exports, "WithErrorMessage", ()=>WithErrorMessage);
parcelHelpers.export(exports, "_ContextualHelp", ()=>_ContextualHelp);
parcelHelpers.export(exports, "CustomWidth", ()=>CustomWidth);
parcelHelpers.export(exports, "CustomWidthAndNarrowContainer", ()=>CustomWidthAndNarrowContainer);
parcelHelpers.export(exports, "WithinAPopover", ()=>WithinAPopover);
var _addonActions = require("@storybook/addon-actions");
var _button = require("@react-spectrum/button");
var _view = require("@react-spectrum/view");
var _contextualhelp = require("@react-spectrum/contextualhelp");
var _dialog = require("@react-spectrum/dialog");
var _layout = require("@react-spectrum/layout");
var _text = require("@react-spectrum/text");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _refresh = require("@spectrum-icons/workflow/Refresh");
var _refreshDefault = parcelHelpers.interopDefault(_refresh);
var _ = require("../");
const info = 'A containing element with `role="search"` has been added to define a **search** landmark region.';
exports.default = {
    title: "SearchField",
    providerSwitcher: {
        status: "positive"
    },
    args: {
        label: "Search",
        isQuiet: false,
        isDisabled: false,
        isReadOnly: false,
        isRequired: false,
        necessityIndicator: "icon",
        labelPosition: "top",
        labelAlign: "start",
        validationState: null
    },
    argTypes: {
        labelPosition: {
            control: {
                type: "radio",
                options: [
                    "top",
                    "side"
                ]
            }
        },
        necessityIndicator: {
            control: {
                type: "radio",
                options: [
                    "icon",
                    "label"
                ]
            }
        },
        labelAlign: {
            control: {
                type: "radio",
                options: [
                    "start",
                    "end"
                ]
            }
        },
        validationState: {
            control: {
                type: "radio",
                options: [
                    null,
                    "valid",
                    "invalid"
                ]
            }
        }
    }
};
const Default = (args)=>renderSearchLandmark(render(args));
Default.story = {
    parameters: {
        info
    }
};
const DefaultValueUncontrolled = (args)=>renderSearchLandmark(render({
        ...args,
        defaultValue: "React"
    }));
DefaultValueUncontrolled.story = {
    name: "defaultValue (uncontrolled)",
    parameters: {
        info
    }
};
const ValueControlled = (args)=>renderSearchLandmark(render({
        ...args,
        value: "React"
    }));
ValueControlled.story = {
    name: "value (controlled)",
    parameters: {
        info
    }
};
const IconRefresh = (args)=>renderSearchLandmark(render({
        ...args,
        defaultValue: "React",
        icon: /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _refreshDefault.default), null)
    }));
IconRefresh.story = {
    name: "icon: refresh",
    parameters: {
        info
    }
};
const IconNull = (args)=>renderSearchLandmark(render({
        ...args,
        defaultValue: "React",
        icon: null
    }));
IconNull.story = {
    name: "icon: null",
    parameters: {
        info
    }
};
const OnClear = (args)=>renderSearchLandmark(render({
        ...args,
        onClear: (0, _addonActions.action)("clear")
    }));
OnClear.story = {
    name: "onClear",
    parameters: {
        info
    }
};
const AutoFocus = (args)=>renderSearchLandmark(render({
        ...args,
        autoFocus: true
    }));
AutoFocus.story = {
    name: "autoFocus",
    parameters: {
        info
    }
};
const NoVisibleLabel = (args)=>render({
        ...args,
        label: null,
        "aria-label": "Street address"
    });
NoVisibleLabel.story = {
    name: "no visible label"
};
const WithDescription = (args)=>render({
        ...args,
        description: "Enter a search term."
    });
WithDescription.story = {
    name: "with description"
};
const WithErrorMessage = (args)=>render({
        ...args,
        errorMessage: "Remove special characters.",
        validationState: "invalid"
    });
WithErrorMessage.story = {
    name: "with error message"
};
const _ContextualHelp = (args)=>render({
        ...args,
        contextualHelp: /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _contextualhelp.ContextualHelp), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Heading), null, "What is a segment?"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Content), null, "Segments identify who your visitors are, what devices and services they use, where they navigated from, and much more."))
    });
_ContextualHelp.story = {
    name: "contextual help"
};
const CustomWidth = (args)=>render({
        ...args,
        width: 300
    });
CustomWidth.story = {
    name: "custom width"
};
const CustomWidthAndNarrowContainer = (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
        direction: "column",
        width: "30px"
    }, render({
        ...args,
        defaultValue: "React",
        validationState: "valid"
    }), render({
        ...args,
        defaultValue: "React",
        width: 30
    }), render({
        ...args,
        defaultValue: "React",
        width: 30,
        validationState: "valid"
    }));
CustomWidthAndNarrowContainer.story = {
    name: "custom width and narrow container"
};
const WithinAPopover = (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _dialog.DialogTrigger), {
        type: "popover"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), null, "Trigger"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _dialog.Dialog), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Heading), null, "The Heading"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Content), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.SearchField), {
        label: "Search",
        ...args,
        onChange: (0, _addonActions.action)("change"),
        onSubmit: (0, _addonActions.action)("submit")
    }))));
WithinAPopover.story = {
    name: "within a popover"
};
function renderSearchLandmark(child) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        role: "search"
    }, child);
}
function render(props = {}) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.SearchField), {
        UNSAFE_className: "custom_classname",
        label: "Search",
        ...props,
        onChange: (0, _addonActions.action)("change"),
        onSubmit: (0, _addonActions.action)("submit")
    });
}

},{"@storybook/addon-actions":"coXbW","@react-spectrum/button":"jZWyP","@react-spectrum/view":"dnRjt","@react-spectrum/contextualhelp":"jA6za","@react-spectrum/dialog":"3G0HV","@react-spectrum/layout":"hzaUY","@react-spectrum/text":"etCGI","react":"9yzVZ","@spectrum-icons/workflow/Refresh":"8TK42","../":"6lUxm","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"8TK42":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("4cb52d8d096742c9");
exports.__esModule = true;
exports.default = Refresh;
var _Refresh = require("d3b608cfefe83265");
var _icon = require("66e37e8b125acc6f");
var _react = _interopRequireDefault(require("7ef19e6b903a757"));
function Refresh(props) {
    return /*#__PURE__*/ _react.default.createElement(_icon.Icon, props, /*#__PURE__*/ _react.default.createElement(_Refresh.A4uRefresh, null));
}

},{"4cb52d8d096742c9":"iHubQ","d3b608cfefe83265":"9mB4u","66e37e8b125acc6f":"k7wem","7ef19e6b903a757":"9yzVZ"}],"9mB4u":[function(require,module,exports) {
/**
* @adobe/react-spectrum-workflow (c) by Adobe
* 
* @adobe/react-spectrum-workflow is licensed under a
* Creative Commons Attribution-NoDerivatives 4.0 International License.
* 
* You should have received a copy of the license along with this
* work. If not, see <http://creativecommons.org/licenses/by-nd/4.0/>.
**/ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.A4uRefresh = A4uRefresh;
var _react = _interopRequireDefault(require("a11d80efb5139e6a"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function A4uRefresh(_ref) {
    var props = _extends({}, _ref);
    return /*#__PURE__*/ _react["default"].createElement("svg", _extends({
        viewBox: "0 0 36 36"
    }, props, props), /*#__PURE__*/ _react["default"].createElement("path", {
        fillRule: "evenodd",
        d: "M32.67383,20H30.78027a1.21547,1.21547,0,0,0-1.16259.93774,11.44726,11.44726,0,0,1-19.11573,5.074l-.69238-.69251,3.95508-3.95495A.78548.78548,0,0,0,14,20.80371.80343.80343,0,0,0,13.24561,20H2.49609A.4996.4996,0,0,0,2,20.49585V31.24573A.80293.80293,0,0,0,2.80371,32a.78433.78433,0,0,0,.56055-.2356l3.61719-3.61706.356.3562a16.17057,16.17057,0,0,0,7.28321,4.33179A15.43018,15.43018,0,0,0,33.66455,21.16968.99566.99566,0,0,0,32.67383,20Z"
    }), /*#__PURE__*/ _react["default"].createElement("path", {
        fillRule: "evenodd",
        d: "M33.19629,4a.78383.78383,0,0,0-.56055.2356L29.01855,7.85266l-.35595-.3562a16.17057,16.17057,0,0,0-7.28321-4.33179A15.43018,15.43018,0,0,0,2.33545,14.83032.99571.99571,0,0,0,3.32617,16H5.21973a1.21558,1.21558,0,0,0,1.16259-.93787A11.44729,11.44729,0,0,1,25.49805,9.98828l.69238.69251-3.95508,3.95483A.78568.78568,0,0,0,22,15.19617.80353.80353,0,0,0,22.75439,16H33.50391A.49976.49976,0,0,0,34,15.50415V4.75427A.80293.80293,0,0,0,33.19629,4Z"
    }));
}

},{"a11d80efb5139e6a":"9yzVZ"}],"6lUxm":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _src = require("./src");
parcelHelpers.exportAll(_src, exports);

},{"./src":"2pivm","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"bdvCe":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Default", ()=>Default);
parcelHelpers.export(exports, "ValueControlled", ()=>ValueControlled);
parcelHelpers.export(exports, "isDisabled", ()=>isDisabled);
parcelHelpers.export(exports, "isRequired", ()=>isRequired);
parcelHelpers.export(exports, "isReadOnly", ()=>isReadOnly);
parcelHelpers.export(exports, "searchfieldDefaultValue", ()=>searchfieldDefaultValue);
parcelHelpers.export(exports, "pickerDefaultValue", ()=>pickerDefaultValue);
parcelHelpers.export(exports, "isRequiredNecessityIndicatorLabel", ()=>isRequiredNecessityIndicatorLabel);
parcelHelpers.export(exports, "isRequiredFalse_necessityIndicator", ()=>isRequiredFalse_necessityIndicator);
parcelHelpers.export(exports, "InputValidationSateInvalid", ()=>InputValidationSateInvalid);
parcelHelpers.export(exports, "PickerValidationSateInvalid", ()=>PickerValidationSateInvalid);
parcelHelpers.export(exports, "PickerDisabled", ()=>PickerDisabled);
parcelHelpers.export(exports, "CustomWidth300", ()=>CustomWidth300);
parcelHelpers.export(exports, "CustomWidth30", ()=>CustomWidth30);
parcelHelpers.export(exports, "LabelPositionSide", ()=>LabelPositionSide);
parcelHelpers.export(exports, "NoVisibleLabel", ()=>NoVisibleLabel);
parcelHelpers.export(exports, "NoLabels", ()=>NoLabels);
parcelHelpers.export(exports, "ExternalLabel", ()=>ExternalLabel);
parcelHelpers.export(exports, "AutoFocusSearchField", ()=>AutoFocusSearchField);
parcelHelpers.export(exports, "AutoFocusPicker", ()=>AutoFocusPicker);
parcelHelpers.export(exports, "ReverseChildrenOrder", ()=>ReverseChildrenOrder);
parcelHelpers.export(exports, "ResizeSearchWithin", ()=>ResizeSearchWithin);
parcelHelpers.export(exports, "ResizeSearchWithinNoLabel", ()=>ResizeSearchWithinNoLabel);
parcelHelpers.export(exports, "iconFilter", ()=>iconFilter);
parcelHelpers.export(exports, "iconNull", ()=>iconNull);
var _addonActions = require("@storybook/addon-actions");
var _button = require("@react-spectrum/button");
var _filter = require("@spectrum-icons/workflow/Filter");
var _filterDefault = parcelHelpers.interopDefault(_filter);
var _layout = require("@react-spectrum/layout");
var _picker = require("@react-spectrum/picker");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _searchfield = require("@react-spectrum/searchfield");
var _ = require("../");
exports.default = {
    title: "SearchWithin"
};
function render(props = {}, searchFieldProps = {}, pickerProps = {}) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.SearchWithin), {
        label: "This is label",
        ...props
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _searchfield.SearchField), {
        ...searchFieldProps,
        onChange: (0, _addonActions.action)("change"),
        onSubmit: (0, _addonActions.action)("submit")
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _picker.Picker), {
        defaultSelectedKey: "all",
        ...pickerProps,
        onSelectionChange: (0, _addonActions.action)("selectionChange")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _picker.Item), {
        key: "all"
    }, "All"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _picker.Item), {
        key: "campaigns"
    }, "Campaigns"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _picker.Item), {
        key: "audiences"
    }, "Audiences"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _picker.Item), {
        key: "tags"
    }, "Tags"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _picker.Item), {
        key: "long"
    }, "This item is very long and word wraps poorly")));
}
function renderReverse(props = {}, searchFieldProps = {}, pickerProps = {}) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.SearchWithin), {
        label: "Test label",
        ...props
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _picker.Picker), {
        defaultSelectedKey: "all",
        ...pickerProps,
        onSelectionChange: (0, _addonActions.action)("selectionChange")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _picker.Item), {
        key: "all"
    }, "All"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _picker.Item), {
        key: "campaigns"
    }, "Campaigns"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _picker.Item), {
        key: "audiences"
    }, "Audiences"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _picker.Item), {
        key: "tags"
    }, "Tags"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _picker.Item), {
        key: "long"
    }, "This item is very long and word wraps poorly")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _searchfield.SearchField), {
        ...searchFieldProps,
        onChange: (0, _addonActions.action)("change"),
        onSubmit: (0, _addonActions.action)("submit")
    }));
}
function ResizeSearchWithinApp(props) {
    const [state, setState] = (0, _react.useState)(true);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
        direction: "column",
        gap: "size-200",
        alignItems: "start"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        style: {
            width: state ? "300px" : "400px"
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.SearchWithin), {
        label: "Test label",
        ...props,
        width: "100%"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _searchfield.SearchField), {
        onChange: (0, _addonActions.action)("change"),
        onSubmit: (0, _addonActions.action)("submit")
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _picker.Picker), {
        defaultSelectedKey: "all",
        onSelectionChange: (0, _addonActions.action)("selectionChange")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _picker.Item), {
        key: "all"
    }, "All"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _picker.Item), {
        key: "campaigns"
    }, "Campaigns"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _picker.Item), {
        key: "audiences"
    }, "Audiences"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _picker.Item), {
        key: "tags"
    }, "Tags"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _picker.Item), {
        key: "long"
    }, "This item is very long and word wraps poorly")))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), {
        onPress: ()=>setState(!state)
    }, "Toggle size"));
}
const Default = ()=>render({});
const ValueControlled = ()=>render({}, {
        value: "Controlled"
    });
ValueControlled.name = "value (controlled) ";
const isDisabled = ()=>render({
        isDisabled: true
    });
isDisabled.name = "isDisabled: true";
const isRequired = ()=>render({
        isRequired: true
    });
isRequired.name = "isRequired: true";
const isReadOnly = ()=>render({}, {
        isReadOnly: true,
        value: "Read Only"
    });
isReadOnly.name = "isReadOnly: true";
const searchfieldDefaultValue = ()=>render({}, {
        defaultValue: "Default Value"
    });
searchfieldDefaultValue.name = "Default value for Searchfield";
const pickerDefaultValue = ()=>render({}, {}, {
        defaultSelectedKey: "tags"
    });
pickerDefaultValue.name = "Default value for Picker";
const isRequiredNecessityIndicatorLabel = ()=>render({
        isRequired: true,
        necessityIndicator: "label"
    });
isRequiredNecessityIndicatorLabel.name = 'isRequired: true, necessityIndicator "label"';
const isRequiredFalse_necessityIndicator = ()=>render({
        isRequired: false,
        necessityIndicator: "label"
    });
isRequiredFalse_necessityIndicator.name = 'isRequired: false, necessityIndicator "label"';
const InputValidationSateInvalid = ()=>render({}, {
        validationState: "invalid"
    });
InputValidationSateInvalid.name = "input validationState: invalid";
const PickerValidationSateInvalid = ()=>render({}, {}, {
        isInvalid: true
    });
PickerValidationSateInvalid.name = "picker validationState: invalid";
const PickerDisabled = ()=>render({}, {}, {
        isDisabled: true
    });
const CustomWidth300 = ()=>render({
        width: 300
    });
CustomWidth300.name = "Custom width: 300";
const CustomWidth30 = ()=>render({
        width: 30
    });
CustomWidth30.name = "Custom width: 30";
const LabelPositionSide = ()=>render({
        labelPosition: "side"
    });
LabelPositionSide.name = "labelPosition: side";
const NoVisibleLabel = ()=>render({
        label: undefined,
        "aria-label": "Test aria label"
    });
const NoLabels = ()=>render({
        label: undefined
    });
const ExternalLabel = ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        style: {
            display: "flex",
            flexDirection: "column"
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        id: "foo"
    }, "External label"), render({
        label: undefined,
        "aria-labelledby": "foo"
    }));
const AutoFocusSearchField = ()=>render({}, {
        autoFocus: true
    });
AutoFocusSearchField.name = "autoFocus: true on SearchField";
const AutoFocusPicker = ()=>render({}, {}, {
        autoFocus: true
    });
AutoFocusPicker.name = "autoFocus: true on Picker";
const ReverseChildrenOrder = ()=>renderReverse({});
const ResizeSearchWithin = ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement(ResizeSearchWithinApp, null);
const ResizeSearchWithinNoLabel = ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement(ResizeSearchWithinApp, {
        label: null
    });
const iconFilter = ()=>render({}, {
        icon: /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _filterDefault.default), null)
    });
iconFilter.name = "icon: Filter";
const iconNull = ()=>render({}, {
        icon: null
    });
iconNull.name = "icon: null";

},{"@storybook/addon-actions":"coXbW","@react-spectrum/button":"jZWyP","@spectrum-icons/workflow/Filter":"9GjEj","@react-spectrum/layout":"hzaUY","@react-spectrum/picker":"kL1Uy","react":"9yzVZ","@react-spectrum/searchfield":"2pivm","../":"gnd2Z","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"gnd2Z":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _src = require("./src");
parcelHelpers.exportAll(_src, exports);

},{"./src":"7dzvS","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"7dzvS":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /// <reference types="css-module-types" />
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SearchWithin", ()=>(0, _searchWithin.SearchWithin));
var _searchWithin = require("./SearchWithin");

},{"./SearchWithin":"db7AD","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"db7AD":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SearchWithin", ()=>_SearchWithin);
var _utils = require("@react-spectrum/utils");
var _label = require("@react-spectrum/label");
// @ts-ignore
var _json = require("../intl/*.json");
var _jsonDefault = parcelHelpers.interopDefault(_json);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _varsCss = require("@adobe/spectrum-css-temp/components/searchwithin/vars.css");
var _varsCssDefault = parcelHelpers.interopDefault(_varsCss);
var _form = require("@react-spectrum/form");
var _utils1 = require("@react-aria/utils");
var _label1 = require("@react-aria/label");
var _i18N = require("@react-aria/i18n");
var _provider = require("@react-spectrum/provider");
var _visuallyHidden = require("@react-aria/visually-hidden");
function SearchWithin(props, ref) {
    props = (0, _provider.useProviderProps)(props);
    props = (0, _form.useFormProps)(props);
    let stringFormatter = (0, _i18N.useLocalizedStringFormatter)((0, _jsonDefault.default), "@react-spectrum/searchwithin");
    let { styleProps } = (0, _utils.useStyleProps)(props);
    let { children, isDisabled, isRequired, label } = props;
    let defaultAriaLabel = stringFormatter.format("search");
    if (!label && !props["aria-label"] && !props["aria-labelledby"]) props["aria-label"] = defaultAriaLabel;
    // Get label and group props (aka fieldProps)
    let { labelProps, fieldProps } = (0, _label1.useLabel)(props);
    // Grab aria-labelledby for the search input. Will need the entire concatenated aria-labelledby if it exists since pointing at the group id doesn’t
    // suffice if there is a external label
    let labelledBy = fieldProps["aria-labelledby"] || (fieldProps["aria-label"] !== defaultAriaLabel ? fieldProps.id : "");
    let pickerId = (0, _utils1.useId)();
    let domRef = (0, _utils.useFocusableRef)(ref);
    let groupRef = (0, _react.useRef)(null);
    // Measure the width of the field to inform the width of the menu.
    let [menuWidth, setMenuWidth] = (0, _react.useState)(null);
    let { scale } = (0, _provider.useProvider)();
    let onResize = (0, _react.useCallback)(()=>{
        var _groupRef_current, _domRef_current;
        let shouldUseGroup = !!label;
        let width = shouldUseGroup ? (_groupRef_current = groupRef.current) === null || _groupRef_current === void 0 ? void 0 : _groupRef_current.offsetWidth : (_domRef_current = domRef.current) === null || _domRef_current === void 0 ? void 0 : _domRef_current.offsetWidth;
        if (width && !isNaN(width)) setMenuWidth(width);
    }, [
        groupRef,
        domRef,
        setMenuWidth,
        label
    ]);
    (0, _utils.useResizeObserver)({
        ref: domRef,
        onResize: onResize
    });
    (0, _utils1.useLayoutEffect)(onResize, [
        scale,
        onResize
    ]);
    let defaultSlotValues = {
        isDisabled,
        isRequired,
        label: null,
        isQuiet: false,
        validationState: null,
        description: null,
        errorMessage: null,
        descriptionProps: null,
        errorMessageProps: null,
        "aria-label": null
    };
    let searchFieldClassName = (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-SearchWithin-searchfield");
    let pickerClassName = (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-SearchWithin-picker");
    let visuallyHiddenId = (0, _utils1.useId)();
    let slots = {
        searchfield: {
            ...defaultSlotValues,
            UNSAFE_className: searchFieldClassName,
            // Apply aria-labelledby of group or the group id to searchfield. No need to pass the group id (we want a new one) and aria-label (aria-labelledby will suffice)
            "aria-labelledby": `${labelledBy} ${visuallyHiddenId} ${pickerId}`,
            // When label is provided, input should have id referenced by htmlFor of label, instead of group
            id: label && fieldProps.id
        },
        picker: {
            ...defaultSlotValues,
            id: pickerId,
            UNSAFE_className: pickerClassName,
            menuWidth,
            align: "end",
            "aria-labelledby": `${labelledBy} ${visuallyHiddenId}`
        }
    };
    if (label) // When label is provided, input should have id referenced by htmlFor of label, instead of group
    delete fieldProps.id;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _label.Field), {
        ...props,
        labelProps: labelProps,
        ref: domRef,
        wrapperClassName: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-SearchWithin-container")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...fieldProps,
        role: "group",
        className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-SearchWithin", styleProps.className),
        ref: groupRef
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _visuallyHidden.VisuallyHidden), {
        id: visuallyHiddenId
    }, stringFormatter.format("searchWithin")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.SlotProvider), {
        slots: slots
    }, children)));
}
/**
 * A SearchWithin combines a SearchField and a Picker into a single group. This allows a user to constrain the scope of their search to a particular category, for example.
 */ const _SearchWithin = /*#__PURE__*/ (0, _reactDefault.default).forwardRef(SearchWithin);

},{"@react-spectrum/utils":"cMIJ6","@react-spectrum/label":"6qv6N","../intl/*.json":"6sJOG","react":"9yzVZ","@adobe/spectrum-css-temp/components/searchwithin/vars.css":"9bBue","@react-spectrum/form":"bGDqA","@react-aria/utils":"9cLk5","@react-aria/label":"74Ccz","@react-aria/i18n":"411rg","@react-spectrum/provider":"5bCdp","@react-aria/visually-hidden":"4jwxT","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"6sJOG":[function(require,module,exports) {
const _temp0 = require("3591b06409b9f5d4");
const _temp1 = require("f1aa3566f88095b1");
const _temp2 = require("537132208c230adb");
const _temp3 = require("916aa3b78ea2deb4");
const _temp4 = require("5487fd472f01891f");
const _temp5 = require("385d05fc89fc4585");
const _temp6 = require("5a636061dc2d0304");
const _temp7 = require("89a1f3d25d563e79");
const _temp8 = require("89b7a08b25891bf9");
const _temp9 = require("92f7fa0597d5e662");
const _temp10 = require("153173666fc548b7");
const _temp11 = require("919e37f0e42e1852");
const _temp12 = require("4440e6198c363d76");
const _temp13 = require("bd91c0ac154a7bb4");
const _temp14 = require("8e4aa4b1c757bf12");
const _temp15 = require("ca875a6d53e661fb");
const _temp16 = require("de9b3ead5fab0ed6");
const _temp17 = require("628289dd9787fb0d");
const _temp18 = require("b5169316aa5eda5b");
const _temp19 = require("3a0181f1aab0882d");
const _temp20 = require("e0a1309d351a1c1f");
const _temp21 = require("13e7d6970454894a");
const _temp22 = require("7c91c2c88334a29");
const _temp23 = require("7c4828996f401e9");
const _temp24 = require("6a2413639e0fadda");
const _temp25 = require("89cff66cb9d0dcae");
const _temp26 = require("e9ff1997f20bdd92");
const _temp27 = require("9943c07efa579dcd");
const _temp28 = require("389910aeff35f1db");
const _temp29 = require("6cdbef6db3f083d6");
const _temp30 = require("a3d4924d618acea0");
const _temp31 = require("9398a8286c3cb81");
const _temp32 = require("46135a4545504edc");
const _temp33 = require("b2ca90ea0233be53");
module.exports = {
    "ar-AE": _temp0,
    "bg-BG": _temp1,
    "cs-CZ": _temp2,
    "da-DK": _temp3,
    "de-DE": _temp4,
    "el-GR": _temp5,
    "en-US": _temp6,
    "es-ES": _temp7,
    "et-EE": _temp8,
    "fi-FI": _temp9,
    "fr-FR": _temp10,
    "he-IL": _temp11,
    "hr-HR": _temp12,
    "hu-HU": _temp13,
    "it-IT": _temp14,
    "ja-JP": _temp15,
    "ko-KR": _temp16,
    "lt-LT": _temp17,
    "lv-LV": _temp18,
    "nb-NO": _temp19,
    "nl-NL": _temp20,
    "pl-PL": _temp21,
    "pt-BR": _temp22,
    "pt-PT": _temp23,
    "ro-RO": _temp24,
    "ru-RU": _temp25,
    "sk-SK": _temp26,
    "sl-SI": _temp27,
    "sr-SP": _temp28,
    "sv-SE": _temp29,
    "tr-TR": _temp30,
    "uk-UA": _temp31,
    "zh-CN": _temp32,
    "zh-TW": _temp33
};

},{"3591b06409b9f5d4":"jn2wC","f1aa3566f88095b1":"k6gAM","537132208c230adb":"3GLLV","916aa3b78ea2deb4":"8EAqs","5487fd472f01891f":"4dSL6","385d05fc89fc4585":"dSNe9","5a636061dc2d0304":"dwaH7","89a1f3d25d563e79":"9bKdK","89b7a08b25891bf9":"kk8Ic","92f7fa0597d5e662":"4O6Y7","153173666fc548b7":"5drjH","919e37f0e42e1852":"i8fQo","4440e6198c363d76":"7paRV","bd91c0ac154a7bb4":"fphfT","8e4aa4b1c757bf12":"7FVwg","ca875a6d53e661fb":"koJwx","de9b3ead5fab0ed6":"eIx1Q","628289dd9787fb0d":"9Jjyu","b5169316aa5eda5b":"1pgav","3a0181f1aab0882d":"kvfAo","e0a1309d351a1c1f":"cGI5r","13e7d6970454894a":"hXDPj","7c91c2c88334a29":"9cpZu","7c4828996f401e9":"6Qx48","6a2413639e0fadda":"kDWQh","89cff66cb9d0dcae":"gpBMr","e9ff1997f20bdd92":"5m6Ip","9943c07efa579dcd":"6i4QT","389910aeff35f1db":"kCy1x","6cdbef6db3f083d6":"bQy5H","a3d4924d618acea0":"3P4V4","9398a8286c3cb81":"jYtzM","46135a4545504edc":"hvxa0","b2ca90ea0233be53":"ao6Y7"}],"jn2wC":[function(require,module,exports) {
module.exports = {
    "search": `\u{628}\u{62D}\u{62B}`,
    "searchWithin": `\u{628}\u{62D}\u{62B} \u{641}\u{64A}`
};

},{}],"k6gAM":[function(require,module,exports) {
module.exports = {
    "search": `\u{422}\u{44A}\u{440}\u{441}\u{435}\u{43D}\u{435}`,
    "searchWithin": `\u{422}\u{44A}\u{440}\u{441}\u{435}\u{43D}\u{435} \u{438}\u{437}`
};

},{}],"3GLLV":[function(require,module,exports) {
module.exports = {
    "search": `Hledat`,
    "searchWithin": `Hledat v r\xe1mci`
};

},{}],"8EAqs":[function(require,module,exports) {
module.exports = {
    "search": `S\xf8g`,
    "searchWithin": `S\xf8g i`
};

},{}],"4dSL6":[function(require,module,exports) {
module.exports = {
    "search": `Suchen`,
    "searchWithin": `Suchen in`
};

},{}],"dSNe9":[function(require,module,exports) {
module.exports = {
    "search": `\u{391}\u{3BD}\u{3B1}\u{3B6}\u{3AE}\u{3C4}\u{3B7}\u{3C3}\u{3B7}`,
    "searchWithin": `\u{391}\u{3BD}\u{3B1}\u{3B6}\u{3AE}\u{3C4}\u{3B7}\u{3C3}\u{3B7} \u{3B5}\u{3BD}\u{3C4}\u{3CC}\u{3C2}`
};

},{}],"dwaH7":[function(require,module,exports) {
module.exports = {
    "search": `Search`,
    "searchWithin": `Search within`
};

},{}],"9bKdK":[function(require,module,exports) {
module.exports = {
    "search": `Buscar`,
    "searchWithin": `Buscar en`
};

},{}],"kk8Ic":[function(require,module,exports) {
module.exports = {
    "search": `Otsi`,
    "searchWithin": `Otsi kohast`
};

},{}],"4O6Y7":[function(require,module,exports) {
module.exports = {
    "search": `Hae`,
    "searchWithin": `Hae kohteesta`
};

},{}],"5drjH":[function(require,module,exports) {
module.exports = {
    "search": `Rechercher`,
    "searchWithin": `Rechercher dans`
};

},{}],"i8fQo":[function(require,module,exports) {
module.exports = {
    "search": `\u{5D7}\u{5E4}\u{5E9}`,
    "searchWithin": `\u{5D7}\u{5E4}\u{5E9} \u{5D1}\u{5EA}\u{5D5}\u{5DA}`
};

},{}],"7paRV":[function(require,module,exports) {
module.exports = {
    "search": `Tra\u{17E}i`,
    "searchWithin": `Tra\u{17E}i unutar`
};

},{}],"fphfT":[function(require,module,exports) {
module.exports = {
    "search": `Keres\xe9s`,
    "searchWithin": `Keres\xe9s ezen bel\xfcl:`
};

},{}],"7FVwg":[function(require,module,exports) {
module.exports = {
    "search": `Cerca`,
    "searchWithin": `Cerca in`
};

},{}],"koJwx":[function(require,module,exports) {
module.exports = {
    "search": `\u{691C}\u{7D22}`,
    "searchWithin": `\u{691C}\u{7D22}\u{7BC4}\u{56F2}`
};

},{}],"eIx1Q":[function(require,module,exports) {
module.exports = {
    "search": `\u{AC80}\u{C0C9}`,
    "searchWithin": `\u{B2E4}\u{C74C} \u{BC94}\u{C704} \u{B0B4} \u{AC80}\u{C0C9}:`
};

},{}],"9Jjyu":[function(require,module,exports) {
module.exports = {
    "search": `Ie\u{161}koti`,
    "searchWithin": `Ie\u{161}koti`
};

},{}],"1pgav":[function(require,module,exports) {
module.exports = {
    "search": `Mekl\u{113}t`,
    "searchWithin": `Mekl\u{113}t \u{161}aj\u{101}:`
};

},{}],"kvfAo":[function(require,module,exports) {
module.exports = {
    "search": `S\xf8k`,
    "searchWithin": `S\xf8k i`
};

},{}],"cGI5r":[function(require,module,exports) {
module.exports = {
    "search": `Zoeken`,
    "searchWithin": `Zoeken in`
};

},{}],"hXDPj":[function(require,module,exports) {
module.exports = {
    "search": `Szukaj`,
    "searchWithin": `Szukaj w nast\u{119}puj\u{105}cym zakresie`
};

},{}],"9cpZu":[function(require,module,exports) {
module.exports = {
    "search": `Pesquisar`,
    "searchWithin": `Pesquisar em`
};

},{}],"6Qx48":[function(require,module,exports) {
module.exports = {
    "search": `Procurar`,
    "searchWithin": `Procurar em`
};

},{}],"kDWQh":[function(require,module,exports) {
module.exports = {
    "search": `C\u{103}utare`,
    "searchWithin": `C\u{103}uta\u{21B}i \xeen`
};

},{}],"gpBMr":[function(require,module,exports) {
module.exports = {
    "search": `\u{41F}\u{43E}\u{438}\u{441}\u{43A}`,
    "searchWithin": `\u{41F}\u{43E}\u{438}\u{441}\u{43A} \u{432}`
};

},{}],"5m6Ip":[function(require,module,exports) {
module.exports = {
    "search": `Vyh\u{13E}ad\xe1va\u{165}`,
    "searchWithin": `Vyh\u{13E}ad\xe1va\u{165} v rozsahu`
};

},{}],"6i4QT":[function(require,module,exports) {
module.exports = {
    "search": `Iskanje`,
    "searchWithin": `I\u{161}\u{10D}ite znotraj`
};

},{}],"kCy1x":[function(require,module,exports) {
module.exports = {
    "search": `Pretraga`,
    "searchWithin": `Pretraga u`
};

},{}],"bQy5H":[function(require,module,exports) {
module.exports = {
    "search": `S\xf6k`,
    "searchWithin": `S\xf6k inom`
};

},{}],"3P4V4":[function(require,module,exports) {
module.exports = {
    "search": `Ara`,
    "searchWithin": `\u{15E}urada ara:`
};

},{}],"jYtzM":[function(require,module,exports) {
module.exports = {
    "search": `\u{41F}\u{43E}\u{448}\u{443}\u{43A}`,
    "searchWithin": `\u{41F}\u{43E}\u{448}\u{443}\u{43A} \u{443}`
};

},{}],"hvxa0":[function(require,module,exports) {
module.exports = {
    "search": `\u{641C}\u{7D22}`,
    "searchWithin": `\u{641C}\u{7D22}\u{8303}\u{56F4}`
};

},{}],"ao6Y7":[function(require,module,exports) {
module.exports = {
    "search": `\u{641C}\u{5C0B}`,
    "searchWithin": `\u{641C}\u{5C0B}\u{7BC4}\u{570D}`
};

},{}],"9bBue":[function(require,module,exports) {
module.exports["focus-ring"] = `k29NhW_focus-ring`;
module.exports["i18nFontFamily"] = `k29NhW_i18nFontFamily`;
module.exports["spectrum-FocusRing-ring"] = `k29NhW_spectrum-FocusRing-ring`;
module.exports["spectrum-FocusRing"] = `k29NhW_spectrum-FocusRing ${module.exports["spectrum-FocusRing-ring"]}`;
module.exports["spectrum-FocusRing--quiet"] = `k29NhW_spectrum-FocusRing--quiet`;
module.exports["spectrum-SearchWithin"] = `k29NhW_spectrum-SearchWithin`;
module.exports["spectrum-SearchWithin-container"] = `k29NhW_spectrum-SearchWithin-container`;
module.exports["spectrum-SearchWithin-picker"] = `k29NhW_spectrum-SearchWithin-picker`;
module.exports["spectrum-SearchWithin-searchfield"] = `k29NhW_spectrum-SearchWithin-searchfield`;

},{}],"aEWRO":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Default", ()=>Default);
parcelHelpers.export(exports, "Label", ()=>Label);
parcelHelpers.export(exports, "CustomWidth", ()=>CustomWidth);
parcelHelpers.export(exports, "LabelOverflow", ()=>LabelOverflow);
parcelHelpers.export(exports, "ShowValueLabelFalse", ()=>ShowValueLabelFalse);
parcelHelpers.export(exports, "FormatOptionsPercent", ()=>FormatOptionsPercent);
parcelHelpers.export(exports, "FormatOptionsCentimeter", ()=>FormatOptionsCentimeter);
parcelHelpers.export(exports, "CustomValueLabel", ()=>CustomValueLabel);
parcelHelpers.export(exports, "CustomValueLabelWithLabelOverflow", ()=>CustomValueLabelWithLabelOverflow);
parcelHelpers.export(exports, "MinMax", ()=>MinMax);
parcelHelpers.export(exports, "_ContextualHelp", ()=>_ContextualHelp);
var _addonActions = require("@storybook/addon-actions");
var _view = require("@react-spectrum/view");
var _contextualhelp = require("@react-spectrum/contextualhelp");
var _storyUtils = require("@react-spectrum/story-utils");
var _text = require("@react-spectrum/text");
var _ = require("../");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
let message = "Your browser may not support this set of format options.";
exports.default = {
    title: "Slider/RangeSlider",
    decorators: [
        (story)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _storyUtils.ErrorBoundary), {
                message: message
            }, story())
    ],
    args: {
        label: "Label",
        isDisabled: false,
        labelPosition: "top"
    },
    argTypes: {
        labelPosition: {
            control: {
                type: "radio",
                options: [
                    "top",
                    "side"
                ]
            }
        }
    }
};
const Default = (args)=>render({
        ...args,
        "aria-label": "Label",
        label: undefined
    });
const Label = (args)=>render(args);
Label.story = {
    name: "label"
};
const CustomWidth = (args)=>render({
        ...args,
        width: "300px"
    });
CustomWidth.story = {
    name: "custom width"
};
const LabelOverflow = (args)=>render({
        ...args,
        label: "This is a rather long label for this narrow slider element.",
        maxValue: 1000,
        width: "300px"
    });
LabelOverflow.story = {
    name: "label overflow"
};
const ShowValueLabelFalse = (args)=>render({
        ...args,
        showValueLabel: false
    });
ShowValueLabelFalse.story = {
    name: "showValueLabel: false"
};
const FormatOptionsPercent = (args)=>render({
        ...args,
        minValue: 0,
        maxValue: 1,
        step: 0.01,
        formatOptions: {
            style: "percent"
        }
    });
FormatOptionsPercent.story = {
    name: "formatOptions percent"
};
const FormatOptionsCentimeter = (args)=>render({
        ...args,
        maxValue: 1000,
        formatOptions: {
            style: "unit",
            unit: "centimeter"
        }
    });
FormatOptionsCentimeter.story = {
    name: "formatOptions centimeter"
};
const CustomValueLabel = (args)=>render({
        ...args,
        getValueLabel: (value)=>`${value.start} <-> ${value.end}`
    });
CustomValueLabel.story = {
    name: "custom valueLabel"
};
const CustomValueLabelWithLabelOverflow = (args)=>render({
        ...args,
        label: "This is a rather long label for this narrow slider element.",
        getValueLabel: (value)=>`${value.start} <-> ${value.end}`
    });
CustomValueLabelWithLabelOverflow.story = {
    name: "custom valueLabel with label overflow"
};
const MinMax = (args)=>render({
        ...args,
        minValue: 30,
        maxValue: 70
    });
MinMax.story = {
    name: "min/max"
};
const _ContextualHelp = (args)=>render({
        ...args,
        label: "Label",
        contextualHelp: /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _contextualhelp.ContextualHelp), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Heading), null, "What is a segment?"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Content), null, "Segments identify who your visitors are, what devices and services they use, where they navigated from, and much more."))
    });
_ContextualHelp.story = {
    name: "contextual help"
};
function render(props = {}) {
    if (props.onChange == null) props.onChange = (v)=>{
        (0, _addonActions.action)("change")(v.start, v.end);
    };
    if (props.onChangeEnd == null) props.onChangeEnd = (v)=>{
        (0, _addonActions.action)("changeEnd")(v.start, v.end);
    };
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.RangeSlider), props);
}

},{"@storybook/addon-actions":"coXbW","@react-spectrum/view":"dnRjt","@react-spectrum/contextualhelp":"jA6za","@react-spectrum/story-utils":"gPtIF","@react-spectrum/text":"etCGI","../":"f5XKY","react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"f5XKY":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _src = require("./src");
parcelHelpers.exportAll(_src, exports);

},{"./src":"if52z","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"5139p":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Default", ()=>Default);
parcelHelpers.export(exports, "Label", ()=>Label);
parcelHelpers.export(exports, "Multitouch", ()=>Multitouch);
parcelHelpers.export(exports, "CustomWidth", ()=>CustomWidth);
parcelHelpers.export(exports, "CustomWidthSmall", ()=>CustomWidthSmall);
parcelHelpers.export(exports, "LabelOverflow", ()=>LabelOverflow);
parcelHelpers.export(exports, "ShowValueLabelFalse", ()=>ShowValueLabelFalse);
parcelHelpers.export(exports, "FormatOptionsPercent", ()=>FormatOptionsPercent);
parcelHelpers.export(exports, "FormatOptionsCentimeter", ()=>FormatOptionsCentimeter);
parcelHelpers.export(exports, "CustomValueLabel", ()=>CustomValueLabel);
parcelHelpers.export(exports, "CustomValueLabelWithLabelOverflow", ()=>CustomValueLabelWithLabelOverflow);
parcelHelpers.export(exports, "MinMax", ()=>MinMax);
parcelHelpers.export(exports, "Step", ()=>Step);
parcelHelpers.export(exports, "IsFilledTrue", ()=>IsFilledTrue);
parcelHelpers.export(exports, "FillOffset", ()=>FillOffset);
parcelHelpers.export(exports, "TrackGradient", ()=>TrackGradient);
parcelHelpers.export(exports, "TrackGradientWithFillOffset", ()=>TrackGradientWithFillOffset);
parcelHelpers.export(exports, "_ContextualHelp", ()=>_ContextualHelp);
var _addonActions = require("@storybook/addon-actions");
var _view = require("@react-spectrum/view");
var _contextualhelp = require("@react-spectrum/contextualhelp");
var _storyUtils = require("@react-spectrum/story-utils");
var _layout = require("@react-spectrum/layout");
var _text = require("@react-spectrum/text");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _ = require("../");
let message = "Your browser may not support this set of format options.";
exports.default = {
    title: "Slider",
    decorators: [
        (story)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _storyUtils.ErrorBoundary), {
                message: message
            }, story())
    ],
    args: {
        label: "Label",
        isDisabled: false,
        labelPosition: "top"
    },
    argTypes: {
        labelPosition: {
            control: {
                type: "radio",
                options: [
                    "top",
                    "side"
                ]
            }
        }
    }
};
const Default = (args)=>render({
        ...args,
        label: null,
        "aria-label": "Label"
    });
const Label = (args)=>render(args);
Label.story = {
    name: "label"
};
const Multitouch = (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
        direction: "column",
        gap: "size-1000"
    }, render({
        ...args,
        label: "Label"
    }), render({
        ...args,
        label: "Label"
    }));
Multitouch.story = {
    name: "multitouch"
};
const CustomWidth = (args)=>render({
        ...args,
        width: "300px"
    });
CustomWidth.story = {
    name: "custom width"
};
const CustomWidthSmall = (args)=>render({
        ...args,
        width: "30px"
    });
CustomWidthSmall.story = {
    name: "custom width small"
};
const LabelOverflow = (args)=>render({
        ...args,
        label: "This is a rather long label for this narrow slider element.",
        maxValue: 1000,
        width: "300px"
    });
LabelOverflow.story = {
    name: "label overflow"
};
const ShowValueLabelFalse = (args)=>render({
        ...args,
        showValueLabel: false
    });
ShowValueLabelFalse.story = {
    name: "showValueLabel: false"
};
const FormatOptionsPercent = (args)=>render({
        ...args,
        minValue: 0,
        maxValue: 1,
        step: 0.01,
        formatOptions: {
            style: "percent"
        }
    });
FormatOptionsPercent.story = {
    name: "formatOptions percent"
};
const FormatOptionsCentimeter = (args)=>render({
        ...args,
        maxValue: 1000,
        formatOptions: {
            style: "unit",
            unit: "centimeter"
        }
    });
FormatOptionsCentimeter.story = {
    name: "formatOptions centimeter"
};
const CustomValueLabel = (args)=>render({
        ...args,
        getValueLabel: (state)=>`A ${state} B`
    });
CustomValueLabel.story = {
    name: "custom valueLabel"
};
const CustomValueLabelWithLabelOverflow = (args)=>render({
        ...args,
        label: "This is a rather long label for this narrow slider element.",
        getValueLabel: (state)=>`A ${state} B`
    });
CustomValueLabelWithLabelOverflow.story = {
    name: "custom valueLabel with label overflow"
};
const MinMax = (args)=>render({
        ...args,
        minValue: 30,
        maxValue: 70
    });
MinMax.story = {
    name: "min/max"
};
const Step = (args)=>render({
        ...args,
        minValue: 0,
        maxValue: 100,
        step: 5
    });
Step.story = {
    name: "step"
};
const IsFilledTrue = (args)=>render({
        ...args,
        isFilled: true
    });
IsFilledTrue.story = {
    name: "isFilled: true"
};
const FillOffset = (args)=>render({
        ...args,
        label: "Exposure",
        isFilled: true,
        fillOffset: 0,
        defaultValue: 0,
        minValue: -7,
        maxValue: 5
    });
FillOffset.story = {
    name: "fillOffset"
};
const TrackGradient = (args)=>render({
        ...args,
        trackGradient: [
            "blue",
            "red"
        ]
    });
TrackGradient.story = {
    name: "trackGradient"
};
const TrackGradientWithFillOffset = (args)=>render({
        ...args,
        trackGradient: [
            "blue",
            "red"
        ],
        isFilled: true,
        fillOffset: 50
    });
TrackGradientWithFillOffset.story = {
    name: "trackGradient with fillOffset"
};
const _ContextualHelp = (args)=>render({
        ...args,
        contextualHelp: /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _contextualhelp.ContextualHelp), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Heading), null, "What is a segment?"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Content), null, "Segments identify who your visitors are, what devices and services they use, where they navigated from, and much more."))
    });
_ContextualHelp.story = {
    name: "contextual help"
};
function render(props = {}) {
    if (props.onChange == null) props.onChange = (0, _addonActions.action)("change");
    if (props.onChangeEnd == null) props.onChangeEnd = (0, _addonActions.action)("changeEnd");
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Slider), props);
}

},{"@storybook/addon-actions":"coXbW","@react-spectrum/view":"dnRjt","@react-spectrum/contextualhelp":"jA6za","@react-spectrum/story-utils":"gPtIF","@react-spectrum/layout":"hzaUY","@react-spectrum/text":"etCGI","react":"9yzVZ","../":"f5XKY","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"htgkj":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Default", ()=>Default);
var _ = require("../");
exports.default = {
    title: "StatusLight",
    component: (0, _.StatusLight),
    argTypes: {
        variant: {
            control: {
                type: "select",
                options: [
                    "positive",
                    "negative",
                    "notice",
                    "info",
                    "neutral",
                    "celery",
                    "chartreuse",
                    "yellow",
                    "magenta",
                    "fuchsia",
                    "purple",
                    "indigo",
                    "seafoam"
                ]
            }
        },
        isDisabled: {
            control: "boolean"
        }
    }
};
const Default = {
    args: {
        children: "Status light of love",
        variant: "positive"
    },
    name: "Default"
};

},{"../":"kSzZT","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"kSzZT":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _src = require("./src");
parcelHelpers.exportAll(_src, exports);

},{"./src":"12nOK","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"cEVVO":[function(require,module,exports) {
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Default", ()=>Default);
parcelHelpers.export(exports, "DefaultCompleted", ()=>DefaultCompleted);
parcelHelpers.export(exports, "DisabledAllKeys", ()=>DisabledAllKeys);
parcelHelpers.export(exports, "DisabledKey", ()=>DisabledKey);
parcelHelpers.export(exports, "Disabled", ()=>Disabled);
parcelHelpers.export(exports, "ReadOnly", ()=>ReadOnly);
parcelHelpers.export(exports, "WithButtonsDefault", ()=>WithButtonsDefault);
parcelHelpers.export(exports, "VerticalWithOddLengths", ()=>VerticalWithOddLengths);
parcelHelpers.export(exports, "HorizontalWithOddLengths", ()=>HorizontalWithOddLengths);
parcelHelpers.export(exports, "WithButtonsDefaultCompletedStep", ()=>WithButtonsDefaultCompletedStep);
parcelHelpers.export(exports, "ControlledStory", ()=>ControlledStory);
var _addonActions = require("@storybook/addon-actions");
var _button = require("@react-spectrum/button");
var _buttongroup = require("@react-spectrum/buttongroup");
var _layout = require("@react-spectrum/layout");
var _collections = require("@react-stately/collections");
var _picker = require("@react-spectrum/picker");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _ = require("../");
var _view = require("@react-spectrum/view");
const options = [
    {
        key: "details",
        value: "Details"
    },
    {
        key: "select-offers",
        value: "Select offers"
    },
    {
        key: "fallback-offer",
        value: "Fallback offer"
    },
    {
        key: "summary",
        value: "Summary"
    }
];
exports.default = {
    title: "StepList",
    component: (0, _.StepList),
    args: {
        onSelectionChange: (0, _addonActions.action)("onSelectionChange"),
        onLastCompletedStepChange: (0, _addonActions.action)("onLastCompletedStepChange")
    },
    argTypes: {
        children: {
            table: {
                disable: true
            }
        },
        isEmphasized: {
            control: "boolean"
        },
        isReadOnly: {
            control: "boolean"
        },
        onLastCompletedStepChange: {
            table: {
                disable: true
            }
        },
        onSelectionChange: {
            table: {
                disable: true
            }
        },
        orientation: {
            control: {
                type: "inline-radio",
                options: [
                    "horizontal",
                    "vertical"
                ]
            }
        },
        size: {
            control: {
                type: "inline-radio",
                options: [
                    "S",
                    "M",
                    "L",
                    "XL"
                ]
            }
        }
    }
};
function DefaultStepList(props) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.StepList), props, options.map((o)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _collections.Item), {
            key: o.key
        }, o.value)));
}
const Default = {
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(DefaultStepList, args)
};
const DefaultCompleted = {
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(DefaultStepList, {
            ...args,
            defaultLastCompletedStep: "summary"
        }),
    name: "Default - Completed"
};
const DisabledAllKeys = {
    args: {
        children: options.map((o)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _collections.Item), {
                key: o.key
            }, o.value)),
        defaultSelectedKey: options[1].key,
        defaultLastCompletedStep: options[1].key,
        disabledKeys: options.map((o)=>o.key)
    },
    name: "disabledAllKeys"
};
const DisabledKey = {
    args: {
        children: options.map((o)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _collections.Item), {
                key: o.key
            }, o.value)),
        defaultSelectedKey: options[1].key,
        defaultLastCompletedStep: options[1].key,
        disabledKeys: new Set([
            "select-offers"
        ])
    },
    name: "disabledKeys"
};
const Disabled = {
    args: {
        isDisabled: true,
        children: options.map((o)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _collections.Item), {
                key: o.key
            }, o.value)),
        defaultSelectedKey: options[1].key,
        defaultLastCompletedStep: options[1].key
    },
    name: "disabled"
};
const ReadOnly = {
    args: {
        isReadOnly: true,
        children: options.map((o)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _collections.Item), {
                key: o.key
            }, o.value)),
        defaultSelectedKey: options[1].key,
        defaultLastCompletedStep: options[1].key
    },
    name: "readonly"
};
const WithButtonsDefault = {
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(WithButtons, args),
    name: "Control Selected Key"
};
const VerticalWithOddLengths = {
    args: {
        orientation: "vertical",
        width: 75,
        children: options.map((o)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _collections.Item), {
                key: o.key
            }, `${o.value} ${o.value} ${o.value}`)),
        defaultSelectedKey: options[1].key,
        defaultLastCompletedStep: options[1].key
    },
    name: "Vertical Odd names"
};
const HorizontalWithOddLengths = {
    args: {
        width: 600,
        children: options.map((o)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _collections.Item), {
                key: o.key
            }, `${o.value} ${o.value} ${o.value}`)),
        defaultSelectedKey: options[1].key,
        defaultLastCompletedStep: options[1].key
    },
    name: "Horizontal Odd names"
};
const WithButtonsDefaultCompletedStep = {
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(WithButtons, {
            defaultLastCompletedStep: "select-offers",
            defaultSelectedKey: "fallback-offer",
            ...args
        }),
    name: "Control Selected Key with Default Completed Step"
};
function WithButtons(args) {
    const keys = (0, _react.useMemo)(()=>options.map((o)=>o.key), []);
    let [stepNumber, setStepNumber] = (0, _react.useState)(keys.indexOf(args.selectedKey || args.defaultSelectedKey) + 1);
    const selectedKey = (0, _react.useMemo)(()=>{
        return keys[stepNumber - 1];
    }, [
        keys,
        stepNumber
    ]);
    const handleSelectionChange = (0, _react.useCallback)((key)=>{
        setStepNumber(keys.indexOf(key) + 1);
        args.onSelectionChange(key);
    }, [
        keys,
        args
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.View), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.StepList), {
        ...args,
        onSelectionChange: handleSelectionChange,
        selectedKey: selectedKey
    }, options.map((o)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _collections.Item), {
            key: o.key
        }, o.value))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
        marginTop: "size-300"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _buttongroup.ButtonGroup), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.Button), {
        isDisabled: stepNumber === 1,
        variant: "secondary",
        onPress: ()=>setStepNumber(stepNumber - 1)
    }, "Back"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.Button), {
        isDisabled: stepNumber === keys.length,
        variant: "cta",
        onPress: ()=>setStepNumber(stepNumber + 1)
    }, "Next"))));
}
const ControlledStory = {
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(Controlled, {
            ...args,
            selectedKey: "details"
        }),
    name: "Controlled"
};
function Controlled(args) {
    const [lastCompletedStep, setLastCompletedStep] = (0, _react.useState)(args.lastCompletedStep);
    const [selectedKey, setSelectedKey] = (0, _react.useState)(args.selectedKey);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.View), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.StepList), {
        ...args,
        lastCompletedStep: lastCompletedStep,
        selectedKey: selectedKey
    }, options.map((o)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _collections.Item), {
            key: o.key
        }, o.value))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
        marginTop: "size-300"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _picker.Picker), {
        label: "lastCompletedStep",
        onSelectionChange: setLastCompletedStep,
        selectedKey: lastCompletedStep
    }, options.map((o)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _collections.Item), {
            key: o.key
        }, o.value))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _picker.Picker), {
        label: "selectedKey",
        onSelectionChange: setSelectedKey,
        selectedKey: selectedKey
    }, options.map((o)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _collections.Item), {
            key: o.key
        }, o.value)))));
}

},{"@storybook/addon-actions":"coXbW","@react-spectrum/button":"jZWyP","@react-spectrum/buttongroup":"anP11","@react-spectrum/layout":"hzaUY","@react-stately/collections":"loANi","@react-spectrum/picker":"kL1Uy","react":"9yzVZ","../":"k0Buf","@react-spectrum/view":"dnRjt","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"k0Buf":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _src = require("./src");
parcelHelpers.exportAll(_src, exports);

},{"./src":"835vb","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"835vb":[function(require,module,exports) {
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /// <reference types="css-module-types" />
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StepList", ()=>(0, _stepList.StepList));
parcelHelpers.export(exports, "Item", ()=>(0, _collections.Item));
var _stepList = require("./StepList");
var _collections = require("@react-stately/collections");

},{"./StepList":"4hs5j","@react-stately/collections":false,"@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"4hs5j":[function(require,module,exports) {
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StepList", ()=>_StepList);
var _steplist = require("@react-aria/steplist");
var _utils = require("@react-spectrum/utils");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _stepListContext = require("./StepListContext");
var _stepListItem = require("./StepListItem");
var _varsCss = require("@adobe/spectrum-css-temp/components/steplist/vars.css");
var _varsCssDefault = parcelHelpers.interopDefault(_varsCss);
var _provider = require("@react-spectrum/provider");
var _steplist1 = require("@react-stately/steplist");
function StepList(props, ref) {
    const { size = "M", orientation = "horizontal" } = props;
    props = (0, _provider.useProviderProps)(props);
    const { isDisabled, isEmphasized } = props;
    let { styleProps } = (0, _utils.useStyleProps)(props);
    let domRef = (0, _utils.useDOMRef)(ref);
    let state = (0, _steplist1.useStepListState)(props);
    let { listProps } = (0, _steplist.useStepList)(props, state, domRef);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("ol", {
        ...listProps,
        ...styleProps,
        ref: domRef,
        className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Steplist", styleProps.className, {
            "spectrum-Steplist--small": size === "S",
            "spectrum-Steplist--medium": size === "M",
            "spectrum-Steplist--large": size === "L",
            "spectrum-Steplist--xlarge": size === "XL",
            "spectrum-Steplist--emphasized": isEmphasized,
            "spectrum-Steplist--horizontal": orientation === "horizontal",
            "spectrum-Steplist--vertical": orientation === "vertical"
        })
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _stepListContext.StepListContext).Provider, {
        value: state
    }, [
        ...state.collection
    ].map((item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _stepListItem.StepListItem), {
            key: item.key,
            isDisabled: isDisabled,
            item: item
        }))));
}
const _StepList = /*#__PURE__*/ (0, _reactDefault.default).forwardRef(StepList);

},{"@react-aria/steplist":"iNZaZ","@react-spectrum/utils":"cMIJ6","react":"9yzVZ","./StepListContext":"iZVt6","./StepListItem":"jnmze","@adobe/spectrum-css-temp/components/steplist/vars.css":"hHaxt","@react-spectrum/provider":"5bCdp","@react-stately/steplist":"46wZf","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"iNZaZ":[function(require,module,exports) {
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useStepList", ()=>(0, _useStepList.useStepList));
parcelHelpers.export(exports, "useStepListItem", ()=>(0, _useStepListItem.useStepListItem));
var _useStepList = require("./useStepList");
var _useStepListItem = require("./useStepListItem");

},{"./useStepList":"lXpLM","./useStepListItem":"1YB75","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"lXpLM":[function(require,module,exports) {
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useStepList", ()=>useStepList);
var _utils = require("@react-aria/utils");
// @ts-ignore
var _json = require("../intl/*.json");
var _jsonDefault = parcelHelpers.interopDefault(_json);
var _i18N = require("@react-aria/i18n");
var _selection = require("@react-aria/selection");
function useStepList(props, state, ref) {
    let { "aria-label": ariaLabel } = props;
    let { listProps } = (0, _selection.useSelectableList)({
        ...props,
        ...state,
        allowsTabNavigation: true,
        ref
    });
    const strings = (0, _i18N.useLocalizedStringFormatter)((0, _jsonDefault.default), "@react-aria/steplist");
    const stepListProps = {
        ...(0, _utils.mergeProps)(listProps, (0, _utils.filterDOMProps)(props, {
            labelable: true
        })),
        "aria-label": ariaLabel || strings.format("steplist")
    };
    return {
        listProps: {
            ...stepListProps,
            tabIndex: undefined
        }
    };
}

},{"@react-aria/utils":"9cLk5","../intl/*.json":"gTvAp","@react-aria/i18n":"411rg","@react-aria/selection":"6Fly5","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"gTvAp":[function(require,module,exports) {
const _temp0 = require("26bc4e8a75c8dc6c");
const _temp1 = require("90aa5e398b6ad1c5");
const _temp2 = require("4d4777153694d125");
const _temp3 = require("e842cd871904ccad");
const _temp4 = require("7d77085543a6a11e");
const _temp5 = require("6ad308d14e36ee35");
const _temp6 = require("b09cd618ca107351");
const _temp7 = require("57c1df3a5d807c14");
const _temp8 = require("98b54b74fa5efadc");
const _temp9 = require("6c19b22c0e790d2d");
const _temp10 = require("f2da2070afc0ef0");
const _temp11 = require("897c2d45dd6dcfbd");
const _temp12 = require("90b6e3f6dc450010");
const _temp13 = require("2a230ff3c2b6d5ac");
const _temp14 = require("f7e6370d0da9ec36");
const _temp15 = require("8121ad8c29948587");
const _temp16 = require("c471485843e847ef");
const _temp17 = require("3dd398371b8cd5d7");
const _temp18 = require("1075c0b3d1b1864e");
const _temp19 = require("94d24e81671ecf01");
const _temp20 = require("7801809fe2ad6108");
const _temp21 = require("c1e083b51c3f31d");
const _temp22 = require("125eb6904f0f820e");
const _temp23 = require("879ba8a1356b5e15");
const _temp24 = require("c1dc4497aa410510");
const _temp25 = require("6a3caa20200d6ada");
const _temp26 = require("5898b5145bb8dede");
const _temp27 = require("f0d1d317bca9e248");
const _temp28 = require("50a6dedb26e7186a");
const _temp29 = require("6636b8a71bdf4b0e");
const _temp30 = require("7628c6fc5c9ce296");
const _temp31 = require("a78eb0b1aad1f5ff");
const _temp32 = require("5bec09c1c25f7d07");
const _temp33 = require("182c46b88db08b6c");
module.exports = {
    "ar-AE": _temp0,
    "bg-BG": _temp1,
    "cs-CZ": _temp2,
    "da-DK": _temp3,
    "de-DE": _temp4,
    "el-GR": _temp5,
    "en-US": _temp6,
    "es-ES": _temp7,
    "et-EE": _temp8,
    "fi-FI": _temp9,
    "fr-FR": _temp10,
    "he-IL": _temp11,
    "hr-HR": _temp12,
    "hu-HU": _temp13,
    "it-IT": _temp14,
    "ja-JP": _temp15,
    "ko-KR": _temp16,
    "lt-LT": _temp17,
    "lv-LV": _temp18,
    "nb-NO": _temp19,
    "nl-NL": _temp20,
    "pl-PL": _temp21,
    "pt-BR": _temp22,
    "pt-PT": _temp23,
    "ro-RO": _temp24,
    "ru-RU": _temp25,
    "sk-SK": _temp26,
    "sl-SI": _temp27,
    "sr-SP": _temp28,
    "sv-SE": _temp29,
    "tr-TR": _temp30,
    "uk-UA": _temp31,
    "zh-CN": _temp32,
    "zh-TW": _temp33
};

},{"26bc4e8a75c8dc6c":"jszsD","90aa5e398b6ad1c5":"dj4yl","4d4777153694d125":"c5ML1","e842cd871904ccad":"1NNqH","7d77085543a6a11e":"ef8p3","6ad308d14e36ee35":"lrtGB","b09cd618ca107351":"jAQno","57c1df3a5d807c14":"cXJib","98b54b74fa5efadc":"9drlC","6c19b22c0e790d2d":"36UIP","f2da2070afc0ef0":"8WIsW","897c2d45dd6dcfbd":"eKTVP","90b6e3f6dc450010":"cSLVO","2a230ff3c2b6d5ac":"ebQaB","f7e6370d0da9ec36":"2gh0C","8121ad8c29948587":"8ZyM6","c471485843e847ef":"gv5gZ","3dd398371b8cd5d7":"dJZns","1075c0b3d1b1864e":"3UBXg","94d24e81671ecf01":"1jmDT","7801809fe2ad6108":"iOoqz","c1e083b51c3f31d":"asxH3","125eb6904f0f820e":"6PRE3","879ba8a1356b5e15":"ddtGl","c1dc4497aa410510":"kyNvd","6a3caa20200d6ada":"hV8yn","5898b5145bb8dede":"gQysb","f0d1d317bca9e248":"khyDn","50a6dedb26e7186a":"k6rE0","6636b8a71bdf4b0e":"arYyg","7628c6fc5c9ce296":"h5cdD","a78eb0b1aad1f5ff":"lJYI4","5bec09c1c25f7d07":"1bNd3","182c46b88db08b6c":"1nvwQ"}],"jszsD":[function(require,module,exports) {
module.exports = {
    "steplist": `\u{642}\u{627}\u{626}\u{645}\u{629} \u{627}\u{644}\u{62E}\u{637}\u{648}\u{627}\u{62A}`
};

},{}],"dj4yl":[function(require,module,exports) {
module.exports = {
    "steplist": `\u{421}\u{43F}\u{438}\u{441}\u{44A}\u{43A} \u{441}\u{44A}\u{441} \u{441}\u{442}\u{44A}\u{43F}\u{43A}\u{438}`
};

},{}],"c5ML1":[function(require,module,exports) {
module.exports = {
    "steplist": `Seznam krok\u{16F}`
};

},{}],"1NNqH":[function(require,module,exports) {
module.exports = {
    "steplist": `Trinliste`
};

},{}],"ef8p3":[function(require,module,exports) {
module.exports = {
    "steplist": `Schrittliste`
};

},{}],"lrtGB":[function(require,module,exports) {
module.exports = {
    "steplist": `\u{39B}\u{3AF}\u{3C3}\u{3C4}\u{3B1} \u{3B2}\u{3B7}\u{3BC}\u{3AC}\u{3C4}\u{3C9}\u{3BD}`
};

},{}],"jAQno":[function(require,module,exports) {
module.exports = {
    "steplist": `Step List`
};

},{}],"cXJib":[function(require,module,exports) {
module.exports = {
    "steplist": `Lista de pasos`
};

},{}],"9drlC":[function(require,module,exports) {
module.exports = {
    "steplist": `Sammude loend`
};

},{}],"36UIP":[function(require,module,exports) {
module.exports = {
    "steplist": `Vaiheluettelo`
};

},{}],"8WIsW":[function(require,module,exports) {
module.exports = {
    "steplist": `Liste des \xe9tapes`
};

},{}],"eKTVP":[function(require,module,exports) {
module.exports = {
    "steplist": `\u{5E8}\u{5E9}\u{5D9}\u{5DE}\u{5EA} \u{5E6}\u{5E2}\u{5D3}\u{5D9}\u{5DD}`
};

},{}],"cSLVO":[function(require,module,exports) {
module.exports = {
    "steplist": `Lista koraka`
};

},{}],"ebQaB":[function(require,module,exports) {
module.exports = {
    "steplist": `L\xe9p\xe9sek list\xe1ja`
};

},{}],"2gh0C":[function(require,module,exports) {
module.exports = {
    "steplist": `Elenco dei passaggi`
};

},{}],"8ZyM6":[function(require,module,exports) {
module.exports = {
    "steplist": `\u{624B}\u{9806}\u{30EA}\u{30B9}\u{30C8}`
};

},{}],"gv5gZ":[function(require,module,exports) {
module.exports = {
    "steplist": `\u{B2E8}\u{ACC4} \u{BAA9}\u{B85D}`
};

},{}],"dJZns":[function(require,module,exports) {
module.exports = {
    "steplist": `\u{17D}ingsni\u{173} s\u{105}ra\u{161}as`
};

},{}],"3UBXg":[function(require,module,exports) {
module.exports = {
    "steplist": `Darb\u{12B}bu saraksts`
};

},{}],"1jmDT":[function(require,module,exports) {
module.exports = {
    "steplist": `Trinnliste`
};

},{}],"iOoqz":[function(require,module,exports) {
module.exports = {
    "steplist": `Stappenlijst`
};

},{}],"asxH3":[function(require,module,exports) {
module.exports = {
    "steplist": `Lista krok\xf3w`
};

},{}],"6PRE3":[function(require,module,exports) {
module.exports = {
    "steplist": `Lista de etapas`
};

},{}],"ddtGl":[function(require,module,exports) {
module.exports = {
    "steplist": `Lista de passos`
};

},{}],"kyNvd":[function(require,module,exports) {
module.exports = {
    "steplist": `Lista de pa\u{219}i`
};

},{}],"hV8yn":[function(require,module,exports) {
module.exports = {
    "steplist": `\u{421}\u{43F}\u{438}\u{441}\u{43E}\u{43A} \u{448}\u{430}\u{433}\u{43E}\u{432}`
};

},{}],"gQysb":[function(require,module,exports) {
module.exports = {
    "steplist": `Zoznam krokov`
};

},{}],"khyDn":[function(require,module,exports) {
module.exports = {
    "steplist": `Seznam korakov`
};

},{}],"k6rE0":[function(require,module,exports) {
module.exports = {
    "steplist": `Lista koraka`
};

},{}],"arYyg":[function(require,module,exports) {
module.exports = {
    "steplist": `Steglista`
};

},{}],"h5cdD":[function(require,module,exports) {
module.exports = {
    "steplist": `Ad\u{131}m Listesi`
};

},{}],"lJYI4":[function(require,module,exports) {
module.exports = {
    "steplist": `\u{421}\u{43F}\u{438}\u{441}\u{43E}\u{43A} \u{43A}\u{440}\u{43E}\u{43A}\u{456}\u{432}`
};

},{}],"1bNd3":[function(require,module,exports) {
module.exports = {
    "steplist": `\u{6B65}\u{9AA4}\u{5217}\u{8868}`
};

},{}],"1nvwQ":[function(require,module,exports) {
module.exports = {
    "steplist": `\u{6B65}\u{9A5F}\u{6E05}\u{55AE}`
};

},{}],"1YB75":[function(require,module,exports) {
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useStepListItem", ()=>useStepListItem);
var _selection = require("@react-aria/selection");
function useStepListItem(props, state, ref) {
    const { key } = props;
    let { selectionManager: manager, selectedKey } = state;
    let isDisabled = !state.isSelectable(key);
    let { itemProps } = (0, _selection.useSelectableItem)({
        isDisabled,
        key,
        ref,
        selectionManager: manager
    });
    const isSelected = selectedKey === key;
    let onKeyDown = (event)=>{
        var _itemProps_onKeyDown;
        const { key: eventKey } = event;
        if (eventKey === "ArrowDown" || eventKey === "ArrowUp") {
            event.preventDefault();
            event.stopPropagation();
        }
        (_itemProps_onKeyDown = itemProps.onKeyDown) === null || _itemProps_onKeyDown === void 0 ? void 0 : _itemProps_onKeyDown.call(itemProps, event);
    };
    return {
        stepProps: {
            ...itemProps,
            onKeyDown,
            role: "link",
            "aria-current": isSelected ? "step" : undefined,
            "aria-disabled": isDisabled ? true : undefined,
            tabIndex: !isDisabled ? 0 : undefined
        }
    };
}

},{"@react-aria/selection":"6Fly5","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"iZVt6":[function(require,module,exports) {
/*
 * Copyright 202 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StepListContext", ()=>StepListContext);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const StepListContext = (0, _reactDefault.default).createContext(null);

},{"react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"jnmze":[function(require,module,exports) {
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StepListItem", ()=>StepListItem);
var _chevronRightMedium = require("@spectrum-icons/ui/ChevronRightMedium");
var _chevronRightMediumDefault = parcelHelpers.interopDefault(_chevronRightMedium);
var _utils = require("@react-spectrum/utils");
var _focus = require("@react-aria/focus");
var _intl = require("../intl");
var _intlDefault = parcelHelpers.interopDefault(_intl);
var _utils1 = require("@react-aria/utils");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _stepListContext = require("./StepListContext");
var _varsCss = require("@adobe/spectrum-css-temp/components/steplist/vars.css");
var _varsCssDefault = parcelHelpers.interopDefault(_varsCss);
var _interactions = require("@react-aria/interactions");
var _i18N = require("@react-aria/i18n");
var _steplist = require("@react-aria/steplist");
var _visuallyHidden = require("@react-aria/visually-hidden");
function StepListItem(props) {
    let { isDisabled, item } = props;
    let { key } = item;
    let ref = (0, _react.useRef)(null);
    let { direction } = (0, _i18N.useLocale)();
    let state = (0, _react.useContext)((0, _stepListContext.StepListContext));
    const isSelected = state.selectedKey === key;
    const isCompleted = state.isCompleted(key);
    const isItemDisabled = isDisabled || state.disabledKeys.has(key);
    let { stepProps, stepStateProps } = (0, _steplist.useStepListItem)({
        ...props,
        key
    }, state, ref);
    let { hoverProps, isHovered } = (0, _interactions.useHover)({
        ...props,
        isDisabled: isItemDisabled || isSelected || props.isReadOnly
    });
    let stepStateText = "";
    const stringFormatter = (0, _i18N.useLocalizedStringFormatter)((0, _intlDefault.default), "@react-spectrum/steplist");
    const numberFormatter = (0, _i18N.useNumberFormatter)();
    if (isSelected) stepStateText = stringFormatter.format("current");
    else if (isCompleted) stepStateText = stringFormatter.format("completed");
    else stepStateText = stringFormatter.format("notCompleted");
    let markerId = (0, _utils1.useId)();
    let labelId = (0, _utils1.useId)();
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("li", {
        className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Steplist-item")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _focus.FocusRing), {
        within: true,
        focusRingClass: (0, _utils.classNames)((0, _varsCssDefault.default), "focus-ring")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("a", {
        ...(0, _utils1.mergeProps)(hoverProps, stepProps),
        "aria-labelledby": `${markerId} ${labelId}`,
        ref: ref,
        className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Steplist-link", {
            "is-selected": isSelected && !isItemDisabled,
            "is-disabled": isItemDisabled,
            "is-hovered": isHovered,
            "is-completed": isCompleted,
            "is-selectable": state.isSelectable(key) && !isSelected
        })
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _visuallyHidden.VisuallyHidden), stepStateProps, stepStateText), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        id: labelId,
        "aria-hidden": "true",
        className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Steplist-label")
    }, item.rendered), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Steplist-segment", {
            "is-completed": isCompleted
        })
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Steplist-segmentLine"),
        xmlns: "http://www.w3.org/2000/svg",
        height: "100%",
        viewBox: "0 0 2 8",
        preserveAspectRatio: "none"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("line", {
        x1: "1",
        y1: "0",
        x2: "1",
        y2: "8",
        vectorEffect: "non-scaling-stroke"
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _chevronRightMediumDefault.default), {
        UNSAFE_className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Steplist-chevron", {
            "is-reversed": direction === "rtl"
        })
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        "aria-hidden": "true",
        className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Steplist-markerWrapper")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        id: markerId,
        className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Steplist-marker")
    }, numberFormatter.format((item.index || 0) + 1))))));
}

},{"@spectrum-icons/ui/ChevronRightMedium":"6amCu","@react-spectrum/utils":"cMIJ6","@react-aria/focus":"42mbF","../intl":"kiVMr","@react-aria/utils":"9cLk5","react":"9yzVZ","./StepListContext":"iZVt6","@adobe/spectrum-css-temp/components/steplist/vars.css":"hHaxt","@react-aria/interactions":"ky3G8","@react-aria/i18n":"411rg","@react-aria/steplist":"iNZaZ","@react-aria/visually-hidden":"4jwxT","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"kiVMr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _enUSJson = require("./en-US.json");
var _enUSJsonDefault = parcelHelpers.interopDefault(_enUSJson);
exports.default = {
    "en-US": (0, _enUSJsonDefault.default)
};

},{"./en-US.json":"dlj2C","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"dlj2C":[function(require,module,exports) {
module.exports = {
    "completed": `Completed: `,
    "notCompleted": `Not completed: `,
    "current": `Current: `,
    "steplist": `Step List`
};

},{}],"hHaxt":[function(require,module,exports) {
module.exports["focus-ring"] = `Y9ExmG_focus-ring`;
module.exports["i18nFontFamily"] = `Y9ExmG_i18nFontFamily`;
module.exports["is-completed"] = `Y9ExmG_is-completed`;
module.exports["is-disabled"] = `Y9ExmG_is-disabled`;
module.exports["is-hovered"] = `Y9ExmG_is-hovered`;
module.exports["is-reversed"] = `Y9ExmG_is-reversed`;
module.exports["is-selected"] = `Y9ExmG_is-selected`;
module.exports["label"] = `Y9ExmG_label`;
module.exports["line"] = `Y9ExmG_line`;
module.exports["marker"] = `Y9ExmG_marker`;
module.exports["spectrum-FocusRing-ring"] = `Y9ExmG_spectrum-FocusRing-ring`;
module.exports["spectrum-FocusRing"] = `Y9ExmG_spectrum-FocusRing ${module.exports["spectrum-FocusRing-ring"]}`;
module.exports["spectrum-FocusRing--quiet"] = `Y9ExmG_spectrum-FocusRing--quiet`;
module.exports["spectrum-Steplist"] = `Y9ExmG_spectrum-Steplist`;
module.exports["spectrum-Steplist--emphasized"] = `Y9ExmG_spectrum-Steplist--emphasized`;
module.exports["spectrum-Steplist--horizontal"] = `Y9ExmG_spectrum-Steplist--horizontal`;
module.exports["spectrum-Steplist--large"] = `Y9ExmG_spectrum-Steplist--large`;
module.exports["spectrum-Steplist--medium"] = `Y9ExmG_spectrum-Steplist--medium`;
module.exports["spectrum-Steplist--small"] = `Y9ExmG_spectrum-Steplist--small`;
module.exports["spectrum-Steplist--vertical"] = `Y9ExmG_spectrum-Steplist--vertical`;
module.exports["spectrum-Steplist--xlarge"] = `Y9ExmG_spectrum-Steplist--xlarge`;
module.exports["spectrum-Steplist-chevron"] = `Y9ExmG_spectrum-Steplist-chevron`;
module.exports["spectrum-Steplist-item"] = `Y9ExmG_spectrum-Steplist-item`;
module.exports["spectrum-Steplist-label"] = `Y9ExmG_spectrum-Steplist-label`;
module.exports["spectrum-Steplist-link"] = `Y9ExmG_spectrum-Steplist-link`;
module.exports["spectrum-Steplist-marker"] = `Y9ExmG_spectrum-Steplist-marker`;
module.exports["spectrum-Steplist-markerWrapper"] = `Y9ExmG_spectrum-Steplist-markerWrapper`;
module.exports["spectrum-Steplist-segment"] = `Y9ExmG_spectrum-Steplist-segment`;
module.exports["spectrum-Steplist-segmentLine"] = `Y9ExmG_spectrum-Steplist-segmentLine`;

},{}],"46wZf":[function(require,module,exports) {
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useStepListState", ()=>(0, _useStepListState.useStepListState));
var _useStepListState = require("./useStepListState");

},{"./useStepListState":"a7Qac","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"a7Qac":[function(require,module,exports) {
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useStepListState", ()=>useStepListState);
var _list = require("@react-stately/list");
var _react = require("react");
var _utils = require("@react-stately/utils");
function useStepListState(props) {
    let state = (0, _list.useSingleSelectListState)(props);
    var _props_defaultLastCompletedStep;
    let [lastCompletedStep, setLastCompletedStep] = (0, _utils.useControlledState)(props.lastCompletedStep, (_props_defaultLastCompletedStep = props.defaultLastCompletedStep) !== null && _props_defaultLastCompletedStep !== void 0 ? _props_defaultLastCompletedStep : null, props.onLastCompletedStepChange);
    const { setSelectedKey: realSetSelectedKey, selectedKey, collection } = state;
    const { indexMap, keysLinkedList } = (0, _react.useMemo)(()=>buildKeysMaps(collection), [
        collection
    ]);
    const selectedIdx = indexMap.get(selectedKey);
    const isCompleted = (0, _react.useCallback)((step)=>{
        if (step === undefined) return false;
        return step !== null && lastCompletedStep !== null && indexMap.has(step) && indexMap.has(lastCompletedStep) && indexMap.get(step) <= indexMap.get(lastCompletedStep);
    }, [
        indexMap,
        lastCompletedStep
    ]);
    const findDefaultSelectedKey = (0, _react.useCallback)((collection, disabledKeys)=>{
        let selectedKey = null;
        if (collection && collection.size > 0) {
            selectedKey = collection.getFirstKey();
            // loop over keys until we find one that isn't completed or disabled and select that
            while(selectedKey !== collection.getLastKey() && selectedKey && (disabledKeys.has(selectedKey) || isCompleted(selectedKey)))selectedKey = collection.getKeyAfter(selectedKey);
        }
        return selectedKey;
    }, [
        isCompleted
    ]);
    (0, _react.useEffect)(()=>{
        // Ensure a step is always selected (in case no selected key was specified or if selected item was deleted from collection)
        let selectedKey = state.selectedKey;
        if (state.selectionManager.isEmpty || !state.collection.getItem(selectedKey)) {
            selectedKey = findDefaultSelectedKey(state.collection, state.disabledKeys);
            if (selectedKey !== null) state.selectionManager.replaceSelection(selectedKey);
        }
        if (state.selectionManager.focusedKey == null) state.selectionManager.setFocusedKey(selectedKey);
        var _ref;
        let lcs = (_ref = lastCompletedStep !== null ? indexMap.get(lastCompletedStep) : -1) !== null && _ref !== void 0 ? _ref : -1;
        if (selectedIdx !== undefined && selectedIdx > 0 && selectedIdx > lcs + 1 && selectedKey !== null && keysLinkedList.has(selectedKey)) setLastCompletedStep(keysLinkedList.get(selectedKey));
    });
    function isSelectable(step) {
        if (props.isDisabled || state.disabledKeys.has(step) || props.isReadOnly) return false;
        if (isCompleted(step)) return true;
        const prevStep = keysLinkedList.get(step);
        return isCompleted(prevStep) || step === state.collection.getFirstKey();
    }
    function setSelectedKey(key) {
        const prevKey = keysLinkedList.get(key);
        if (prevKey && !isCompleted(prevKey)) setLastCompletedStep(prevKey);
        realSetSelectedKey(key);
    }
    return {
        ...state,
        setSelectedKey,
        setLastCompletedStep,
        isCompleted,
        isSelectable
    };
}
function buildKeysMaps(coll) {
    const indexMap = new Map();
    const keysLinkedList = new Map();
    let i = 0;
    let prev = undefined;
    for (const item of coll){
        indexMap.set(item.key, i);
        keysLinkedList.set(item.key, prev === null || prev === void 0 ? void 0 : prev.key);
        prev = item;
        i++;
    }
    return {
        indexMap,
        keysLinkedList
    };
}

},{"@react-stately/list":"Cp0zP","react":"9yzVZ","@react-stately/utils":"cpDPf","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"6Ukh5":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Default", ()=>Default);
parcelHelpers.export(exports, "DefaultSelectedTrue", ()=>DefaultSelectedTrue);
parcelHelpers.export(exports, "IsSelectedTrue", ()=>IsSelectedTrue);
parcelHelpers.export(exports, "IsSelectedFalse", ()=>IsSelectedFalse);
parcelHelpers.export(exports, "IsDisabledTrue", ()=>IsDisabledTrue);
parcelHelpers.export(exports, "IsReadOnlyTrueIsSelectedTrue", ()=>IsReadOnlyTrueIsSelectedTrue);
parcelHelpers.export(exports, "AutoFocus", ()=>AutoFocus);
parcelHelpers.export(exports, "CustomLabel", ()=>CustomLabel);
parcelHelpers.export(exports, "LongLabel", ()=>LongLabel);
parcelHelpers.export(exports, "NoLabel", ()=>NoLabel);
parcelHelpers.export(exports, "ControlledImplementation", ()=>ControlledImplementation);
parcelHelpers.export(exports, "WHCMTest", ()=>WHCMTest);
var _utils = require("@react-aria/utils");
var _layout = require("@react-spectrum/layout");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _ = require("../");
exports.default = {
    title: "Switch",
    component: (0, _.Switch),
    args: {
        isEmphasized: false
    },
    argTypes: {
        onChange: {
            action: "change"
        },
        onFocus: {
            action: "focus"
        },
        onBlur: {
            action: "blur"
        }
    }
};
const Default = {
    args: {
        children: /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, "Switch Label")
    }
};
const DefaultSelectedTrue = {
    ...Default,
    args: {
        ...Default.args,
        defaultSelected: true
    },
    name: "defaultSelected: true"
};
const IsSelectedTrue = {
    ...Default,
    args: {
        ...Default.args,
        isSelected: true
    },
    name: "isSelected: true"
};
const IsSelectedFalse = {
    ...Default,
    args: {
        ...Default.args,
        isSelected: false
    },
    name: "isSelected: false"
};
const IsDisabledTrue = {
    ...Default,
    args: {
        ...Default.args,
        isDisabled: true
    },
    name: "isDisabled: true"
};
const IsReadOnlyTrueIsSelectedTrue = {
    ...Default,
    args: {
        ...Default.args,
        isReadOnly: true,
        isSelected: true
    },
    name: "isReadOnly: true, isSelected: true"
};
const AutoFocus = {
    ...Default,
    args: {
        ...Default.args,
        autoFocus: true
    },
    name: "autoFocus"
};
const CustomLabel = {
    ...Default,
    args: {
        children: /*#__PURE__*/ (0, _reactDefault.default).createElement("span", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("i", null, "Italicized"), " Switch Label")
    },
    name: "custom label"
};
const LongLabel = {
    ...Default,
    args: {
        children: /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, "Super long checkbox label. Sample text. Arma virumque cano, Troiae qui primus ab oris. Italiam, fato profugus, Laviniaque venit.")
    },
    name: "long label"
};
const NoLabel = {
    ...Default,
    args: {
        "aria-label": "This switch has no visible label"
    },
    name: "no label",
    parameters: {
        description: {
            data: "Try me with a screen reader."
        }
    }
};
const ControlledImplementation = {
    ...Default,
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(ControlledSwitch, args)
};
function ControlledSwitch(props) {
    let [checked, setChecked] = (0, _react.useState)(false);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Switch), {
        ...props,
        onChange: (0, _utils.chain)(setChecked, props.onChange),
        isSelected: checked
    });
}
const WHCMTest = {
    render: ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
            direction: "column",
            gap: "size-200"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
            gap: "size-200"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Switch), null, "Option"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Switch), {
            isDisabled: true
        }, "Option")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
            gap: "size-200"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Switch), {
            isSelected: true,
            isEmphasized: true
        }, "Option"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Switch), {
            isSelected: true,
            isEmphasized: true,
            isDisabled: true
        }, "Option")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
            gap: "size-200"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Switch), {
            isSelected: true
        }, "Option"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Switch), {
            isSelected: true,
            isDisabled: true
        }, "Option"))),
    name: "WHCM test"
};

},{"@react-aria/utils":"9cLk5","@react-spectrum/layout":"hzaUY","react":"9yzVZ","../":"80WMg","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"80WMg":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _src = require("./src");
parcelHelpers.exportAll(_src, exports);

},{"./src":"fzqJX","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"70C9Q":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Static", ()=>Static);
parcelHelpers.export(exports, "columns", ()=>columns);
parcelHelpers.export(exports, "Dynamic", ()=>Dynamic);
parcelHelpers.export(exports, "DynamicFalsyRowKeys", ()=>DynamicFalsyRowKeys);
parcelHelpers.export(exports, "HorizontalScrollingOnly", ()=>HorizontalScrollingOnly);
parcelHelpers.export(exports, "HorizontalScrollingOnlyFlushBottom", ()=>HorizontalScrollingOnlyFlushBottom);
parcelHelpers.export(exports, "DynamicWithDisabledKeys", ()=>DynamicWithDisabledKeys);
parcelHelpers.export(exports, "DynamicShowDividers", ()=>DynamicShowDividers);
parcelHelpers.export(exports, "DynamicSelectedKeys", ()=>DynamicSelectedKeys);
parcelHelpers.export(exports, "StaticNestedColumns", ()=>StaticNestedColumns);
parcelHelpers.export(exports, "DynamicNestedColumns", ()=>DynamicNestedColumns);
parcelHelpers.export(exports, "DynamicNestedColumnsWithResizing", ()=>DynamicNestedColumnsWithResizing);
parcelHelpers.export(exports, "FocusableCells", ()=>FocusableCells);
parcelHelpers.export(exports, "ManyColumnsAndRows", ()=>ManyColumnsAndRows);
parcelHelpers.export(exports, "ShouldFillCellWidth", ()=>ShouldFillCellWidth);
parcelHelpers.export(exports, "ColumnWidthsAndDividers", ()=>ColumnWidthsAndDividers);
parcelHelpers.export(exports, "CellWithLongContent", ()=>CellWithLongContent);
parcelHelpers.export(exports, "CustomRowHeaderLabeling", ()=>CustomRowHeaderLabeling);
parcelHelpers.export(exports, "CRUD", ()=>CRUD);
parcelHelpers.export(exports, "InlineDeleteButtons", ()=>InlineDeleteButtons);
parcelHelpers.export(exports, "HidingColumnsExample", ()=>HidingColumnsExample);
parcelHelpers.export(exports, "IsLoading", ()=>IsLoading);
parcelHelpers.export(exports, "IsLoadingMore", ()=>IsLoadingMore);
parcelHelpers.export(exports, "Filtering", ()=>Filtering);
parcelHelpers.export(exports, "EmptyStateTable", ()=>EmptyStateTable);
parcelHelpers.export(exports, "EmptyStateStory", ()=>EmptyStateStory);
parcelHelpers.export(exports, "AsyncLoading", ()=>AsyncLoading);
parcelHelpers.export(exports, "AsyncLoadingQuarryTest", ()=>AsyncLoadingQuarryTest);
parcelHelpers.export(exports, "HideHeader", ()=>HideHeader);
parcelHelpers.export(exports, "AsyncLoadingClientFiltering", ()=>AsyncLoadingClientFiltering);
parcelHelpers.export(exports, "AsyncLoadingServerFiltering", ()=>AsyncLoadingServerFiltering);
parcelHelpers.export(exports, "AsyncLoadingServerFilteringLoadMore", ()=>AsyncLoadingServerFilteringLoadMore);
parcelHelpers.export(exports, "WithDialogTrigger", ()=>WithDialogTrigger);
parcelHelpers.export(exports, "WithBreadcrumbNavigation", ()=>WithBreadcrumbNavigation);
parcelHelpers.export(exports, "ResizingUncontrolledDynamicWidths", ()=>ResizingUncontrolledDynamicWidths);
parcelHelpers.export(exports, "ResizingUncontrolledStaticWidths", ()=>ResizingUncontrolledStaticWidths);
parcelHelpers.export(exports, "ResizingUncontrolledColumnDivider", ()=>ResizingUncontrolledColumnDivider);
parcelHelpers.export(exports, "ResizingUncontrolledMinMax", ()=>ResizingUncontrolledMinMax);
parcelHelpers.export(exports, "ResizingUncontrolledSomeNotAllowed", ()=>ResizingUncontrolledSomeNotAllowed);
parcelHelpers.export(exports, "ResizingUncontrolledNoHeightWidth", ()=>ResizingUncontrolledNoHeightWidth);
parcelHelpers.export(exports, "ResizingUncontrolledSortableColumns", ()=>ResizingUncontrolledSortableColumns);
parcelHelpers.export(exports, "ResizingManyColumnsRows", ()=>ResizingManyColumnsRows);
parcelHelpers.export(exports, "ResizingHidingColumns", ()=>ResizingHidingColumns);
parcelHelpers.export(exports, "ResizingZoom", ()=>ResizingZoom);
parcelHelpers.export(exports, "ResizingControlledNoInitialWidths", ()=>ResizingControlledNoInitialWidths);
parcelHelpers.export(exports, "ResizingControlledSomeInitialWidths", ()=>ResizingControlledSomeInitialWidths);
parcelHelpers.export(exports, "ResizingControlledAllInitialWidths", ()=>ResizingControlledAllInitialWidths);
parcelHelpers.export(exports, "ResizingControlledHideHeader", ()=>ResizingControlledHideHeader);
parcelHelpers.export(exports, "TypeaheadWithDialog", ()=>TypeaheadWithDialog);
parcelHelpers.export(exports, "Links", ()=>Links);
parcelHelpers.export(exports, "ColumnHeaderFocusRingTable", ()=>ColumnHeaderFocusRingTable);
var _addonActions = require("@storybook/addon-actions");
var _button = require("@react-spectrum/button");
var _add = require("@spectrum-icons/workflow/Add");
var _addDefault = parcelHelpers.interopDefault(_add);
var _breadcrumbs = require("@react-spectrum/breadcrumbs");
var _buttongroup = require("@react-spectrum/buttongroup");
var _ = require("../");
var _view = require("@react-spectrum/view");
var _controllingResize = require("./ControllingResize");
var _crudexample = require("./CRUDExample");
var _delete = require("@spectrum-icons/workflow/Delete");
var _deleteDefault = parcelHelpers.interopDefault(_delete);
var _dialog = require("@react-spectrum/dialog");
var _divider = require("@react-spectrum/divider");
var _layout = require("@react-spectrum/layout");
var _text = require("@react-spectrum/text");
var _hidingColumns = require("./HidingColumns");
var _hidingColumnsAllowsResizing = require("./HidingColumnsAllowsResizing");
var _illustratedmessage = require("@react-spectrum/illustratedmessage");
var _link = require("@react-spectrum/link");
var _noSearchResults = require("@spectrum-icons/illustrations/NoSearchResults");
var _noSearchResultsDefault = parcelHelpers.interopDefault(_noSearchResults);
var _radio = require("@react-spectrum/radio");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _searchfield = require("@react-spectrum/searchfield");
var _switch = require("@react-spectrum/switch");
var _textfield = require("@react-spectrum/textfield");
var _data = require("@react-stately/data");
var _i18N = require("@react-aria/i18n");
exports.default = {
    title: "TableView",
    excludeStories: [
        "columns",
        "renderEmptyState",
        "EmptyStateTable"
    ],
    component: (0, _.TableView),
    args: {
        onAction: (0, _addonActions.action)("onAction"),
        onResizeStart: (0, _addonActions.action)("onResizeStart"),
        onResize: (0, _addonActions.action)("onResize"),
        onResizeEnd: (0, _addonActions.action)("onResizeEnd"),
        onSelectionChange: (0, _addonActions.action)("onSelectionChange"),
        onSortChange: (0, _addonActions.action)("onSortChange")
    },
    argTypes: {
        // intentionally added so that we can unset the default value
        // there is no argType for function
        // use the controls reset button to undo it
        // https://storybook.js.org/docs/react/essentials/controls#annotation
        onAction: {
            control: "select",
            options: [
                undefined
            ]
        },
        onResizeStart: {
            table: {
                disable: true
            }
        },
        onResize: {
            table: {
                disable: true
            }
        },
        onResizeEnd: {
            table: {
                disable: true
            }
        },
        onSelectionChange: {
            table: {
                disable: true
            }
        },
        onSortChange: {
            table: {
                disable: true
            }
        },
        disabledKeys: {
            table: {
                disable: true
            }
        },
        selectedKeys: {
            table: {
                disable: true
            }
        },
        density: {
            control: "select",
            options: [
                "compact",
                "regular",
                "spacious"
            ]
        },
        overflowMode: {
            control: "select",
            options: [
                "wrap",
                "truncate"
            ]
        },
        isQuiet: {
            control: "boolean"
        },
        selectionMode: {
            control: "select",
            options: [
                "none",
                "single",
                "multiple"
            ]
        },
        selectionStyle: {
            control: "select",
            options: [
                "checkbox",
                "highlight"
            ]
        },
        disallowEmptySelection: {
            control: "boolean"
        }
    }
};
const Static = {
    args: {
        "aria-label": "TableView with static contents",
        width: 300,
        height: 200
    },
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableView), args, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableHeader), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Column), {
            key: "foo"
        }, "Foo"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Column), {
            key: "bar"
        }, "Bar"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Column), {
            key: "baz"
        }, "Baz")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableBody), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Row), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, "One"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, "Two"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, "Three")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Row), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, "One"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, "Two"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, "Three")))),
    name: "static"
};
let columns = [
    {
        name: "Foo",
        key: "foo"
    },
    {
        name: "Bar",
        key: "bar"
    },
    {
        name: "Baz",
        key: "baz"
    }
];
let items = [
    {
        test: "Test 1",
        foo: "Foo 1",
        bar: "Bar 1",
        yay: "Yay 1",
        baz: "Baz 1"
    },
    {
        test: "Test 2",
        foo: "Foo 2",
        bar: "Bar 2",
        yay: "Yay 2",
        baz: "Baz 2"
    },
    {
        test: "Test 1",
        foo: "Foo 3",
        bar: "Bar 1",
        yay: "Yay 1",
        baz: "Baz 1"
    },
    {
        test: "Test 2",
        foo: "Foo 4",
        bar: "Bar 2",
        yay: "Yay 2",
        baz: "Baz 2"
    },
    {
        test: "Test 1",
        foo: "Foo 5",
        bar: "Bar 1",
        yay: "Yay 1",
        baz: "Baz 1"
    },
    {
        test: "Test 2",
        foo: "Foo 6",
        bar: "Bar 2",
        yay: "Yay 2",
        baz: "Baz 2"
    },
    {
        test: "Test 1",
        foo: "Foo 7",
        bar: "Bar 1",
        yay: "Yay 1",
        baz: "Baz 1"
    },
    {
        test: "Test 2",
        foo: "Foo 8",
        bar: "Bar 2",
        yay: "Yay 2",
        baz: "Baz 2"
    }
];
const Dynamic = {
    args: {
        "aria-label": "TableView with static contents",
        width: 300,
        height: 200
    },
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableView), args, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableHeader), {
            columns: columns
        }, (column)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Column), null, column.name)), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableBody), {
            items: items
        }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Row), {
                key: item.foo
            }, (key)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, item[key])))),
    name: "dynamic"
};
let itemsWithFalsyId = [
    {
        test: "Test 1",
        foo: "Foo 1",
        bar: "Bar 1",
        yay: "Yay 1",
        baz: "Baz 1",
        id: 0
    },
    {
        test: "Test 1",
        foo: "Foo 2",
        bar: "Bar 1",
        yay: "Yay 1",
        baz: "Baz 1",
        id: 1
    }
];
const DynamicFalsyRowKeys = {
    args: {
        "aria-label": "TableView with dynamic contents",
        width: 300,
        height: 200
    },
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableView), args, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableHeader), {
            columns: columns
        }, (column)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Column), null, column.name)), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableBody), {
            items: itemsWithFalsyId
        }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Row), null, (key)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, item[key])))),
    name: "dynamic, falsy row keys"
};
const HorizontalScrollingOnly = {
    args: {
        "aria-label": "TableView with dynamic contents",
        width: 200,
        height: 220
    },
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableView), args, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableHeader), {
            columns: columns
        }, (column)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Column), null, column.name)), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableBody), {
            items: items.slice(0, 3)
        }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Row), {
                key: item.foo
            }, (key)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, item[key])))),
    name: "horizontal scrolling only"
};
const HorizontalScrollingOnlyFlushBottom = {
    args: {
        "aria-label": "TableView with dynamic contents",
        width: 200,
        height: 174
    },
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableView), args, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableHeader), {
            columns: columns
        }, (column)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Column), null, column.name)), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableBody), {
            items: items.slice(0, 3)
        }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Row), {
                key: item.foo
            }, (key)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, item[key])))),
    name: "horizontal scrolling only flush bottom"
};
const DynamicWithDisabledKeys = {
    ...Dynamic,
    args: {
        ...Dynamic.args,
        disabledKeys: new Set([
            "Foo 1",
            "Foo 3"
        ])
    },
    name: "dynamic with disabled keys"
};
const DynamicShowDividers = {
    args: {
        "aria-label": "TableView with static contents",
        width: 300,
        height: 200
    },
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableView), args, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableHeader), {
            columns: columns
        }, (column)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Column), {
                showDivider: true
            }, column.name)), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableBody), {
            items: items
        }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Row), {
                key: item.foo
            }, (key)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, item[key])))),
    name: "dynamic showDividers"
};
const DynamicSelectedKeys = {
    ...Dynamic,
    args: {
        ...Dynamic.args,
        selectedKeys: new Set([
            "Foo 1",
            "Foo 3"
        ]),
        selectionMode: "multiple"
    },
    name: "selectedKeys",
    parameters: {
        controls: {
            exclude: /selectionMode/
        }
    }
};
const StaticNestedColumns = {
    args: {
        "aria-label": "TableView with nested columns",
        width: 500,
        height: 200
    },
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableView), args, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableHeader), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Column), {
            key: "test"
        }, "Test"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Column), {
            title: "Blah"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Column), {
            title: "Group 1"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Column), {
            key: "foo"
        }, "Foo"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Column), {
            key: "bar"
        }, "Bar")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Column), {
            title: "Group 2"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Column), {
            key: "baz"
        }, "Baz")))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableBody), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Row), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, "Test1"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, "One"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, "Two"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, "Three")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Row), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, "Test2"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, "One"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, "Two"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, "Three")))),
    name: "static with nested columns"
};
let nestedColumns = [
    {
        name: "Test",
        key: "test"
    },
    {
        name: "Tiered One Header",
        key: "tier1",
        children: [
            {
                name: "Tier Two Header A",
                key: "tier2a",
                children: [
                    {
                        name: "Foo",
                        key: "foo"
                    },
                    {
                        name: "Bar",
                        key: "bar"
                    }
                ]
            },
            {
                name: "Yay",
                key: "yay"
            },
            {
                name: "Tier Two Header B",
                key: "tier2b",
                children: [
                    {
                        name: "Baz",
                        key: "baz"
                    }
                ]
            }
        ]
    }
];
const DynamicNestedColumns = {
    args: {
        "aria-label": "TableView with nested columns",
        width: 700,
        height: 300
    },
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableView), args, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableHeader), {
            columns: nestedColumns
        }, (column)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Column), {
                childColumns: column.children,
                textValue: column.name
            }, column.name)), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableBody), {
            items: items
        }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Row), {
                key: item.foo
            }, (key)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, item[key])))),
    name: "dynamic with nested columns"
};
const DynamicNestedColumnsWithResizing = {
    args: {
        "aria-label": "TableView with nested columns",
        width: 700,
        height: 300
    },
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableView), args, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableHeader), {
            columns: nestedColumns
        }, (column)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Column), {
                allowsResizing: true,
                childColumns: column.children
            }, column.name)), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableBody), {
            items: items
        }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Row), {
                key: item.foo
            }, (key)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, item[key])))),
    name: "dynamic with nested columns with resizing"
};
const FocusableCells = {
    args: {
        "aria-label": "TableView with focusable cells",
        width: 450,
        height: 200
    },
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
            direction: "column"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement("label", {
            htmlFor: "focus-before"
        }, "Focus before"), /*#__PURE__*/ (0, _reactDefault.default).createElement("input", {
            id: "focus-before"
        }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableView), args, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableHeader), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Column), {
            key: "foo"
        }, "Foo"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Column), {
            key: "bar"
        }, "Bar"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Column), {
            key: "baz"
        }, "baz")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableBody), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Row), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _switch.Switch), {
            "aria-label": "Foo"
        })), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _link.Link), null, /*#__PURE__*/ (0, _reactDefault.default).createElement("a", {
            href: "https://yahoo.com",
            target: "_blank"
        }, "Yahoo"))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, "Three")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Row), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _switch.Switch), {
            "aria-label": "Foo"
        }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _switch.Switch), {
            "aria-label": "Bar"
        })), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _link.Link), null, /*#__PURE__*/ (0, _reactDefault.default).createElement("a", {
            href: "https://google.com",
            target: "_blank"
        }, "Google"))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, "Three")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Row), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _switch.Switch), {
            "aria-label": "Foo"
        })), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _link.Link), null, /*#__PURE__*/ (0, _reactDefault.default).createElement("a", {
            href: "https://yahoo.com",
            target: "_blank"
        }, "Yahoo"))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, "Three")))), /*#__PURE__*/ (0, _reactDefault.default).createElement("label", {
            htmlFor: "focus-after"
        }, "Focus after"), /*#__PURE__*/ (0, _reactDefault.default).createElement("input", {
            id: "focus-after"
        })),
    name: "focusable cells"
};
let manyColunns = [];
for(let i = 0; i < 100; i++)manyColunns.push({
    name: "Column " + i,
    key: "C" + i
});
let manyRows = [];
for(let i = 0; i < 1000; i++){
    let row = {
        key: "R" + i
    };
    for(let j = 0; j < 100; j++)row["C" + j] = `${i}, ${j}`;
    manyRows.push(row);
}
const ManyColumnsAndRows = {
    args: {
        "aria-label": "TableView with many columns and rows",
        width: 700,
        height: 500
    },
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement("label", {
            htmlFor: "focus-before"
        }, "Focus before"), /*#__PURE__*/ (0, _reactDefault.default).createElement("input", {
            id: "focus-before"
        }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableView), args, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableHeader), {
            columns: manyColunns
        }, (column)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Column), {
                minWidth: 100
            }, column.name)), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableBody), {
            items: manyRows
        }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Row), {
                key: item.foo
            }, (key)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, item[key])))), /*#__PURE__*/ (0, _reactDefault.default).createElement("label", {
            htmlFor: "focus-after"
        }, "Focus after"), /*#__PURE__*/ (0, _reactDefault.default).createElement("input", {
            id: "focus-after"
        })),
    name: "many columns and rows"
};
const TableViewFilledCellWidths = (props)=>{
    let { allowsResizing, ...otherProps } = props;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableView), otherProps, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableHeader), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Column), {
        allowsResizing: allowsResizing
    }, "File Name"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Column), {
        allowsResizing: allowsResizing,
        align: "center"
    }, "Type"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Column), {
        allowsResizing: allowsResizing,
        align: "end"
    }, "Size"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Column), {
        allowsResizing: allowsResizing
    }, "Description")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableBody), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Row), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, "2018 Proposal"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, "PDF"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, "214 KB"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, "very very very very very very long long long long long description")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Row), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.View), {
        width: "100%",
        backgroundColor: "gray-200"
    }, "100%")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.View), {
        UNSAFE_style: {
            margin: "auto",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap"
        },
        width: "100%",
        backgroundColor: "gray-200"
    }, "100%")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.View), {
        UNSAFE_style: {
            marginInlineStart: "auto",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap"
        },
        width: "100%",
        backgroundColor: "gray-200"
    }, "100%")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.View), {
        UNSAFE_style: {
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap"
        },
        width: "100%",
        backgroundColor: "gray-200"
    }, "very very very very very very long long long long long description"))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Row), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.View), {
        UNSAFE_style: {
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap"
        },
        width: "50%",
        backgroundColor: "gray-200"
    }, "50% div")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.View), {
        UNSAFE_style: {
            margin: "auto",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap"
        },
        width: "70%",
        backgroundColor: "gray-200"
    }, "70% div")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.View), {
        UNSAFE_style: {
            float: "right",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap"
        },
        width: "70%",
        backgroundColor: "gray-200"
    }, "70% div")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.View), {
        UNSAFE_style: {
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap"
        },
        width: "70%",
        backgroundColor: "gray-200"
    }, "very very very very very very long long long long long description"))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Row), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        style: {
            backgroundColor: "var(--spectrum-global-color-gray-200"
        }
    }, "span child")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        style: {
            backgroundColor: "var(--spectrum-global-color-gray-200"
        }
    }, "span child")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        style: {
            backgroundColor: "var(--spectrum-global-color-gray-200"
        }
    }, "span child")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        style: {
            backgroundColor: "var(--spectrum-global-color-gray-200"
        }
    }, "very very very very very very long long long long long description")))));
};
const ShouldFillCellWidth = {
    args: {
        "aria-label": "TableView with filled cells",
        width: 500,
        height: 200
    },
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(TableViewFilledCellWidths, args),
    name: "should fill cell width",
    argTypes: {
        allowsResizing: {
            type: "boolean"
        }
    }
};
const ColumnWidthsAndDividers = {
    args: {
        "aria-label": "TableView with column widths and dividers",
        width: 500,
        height: 200
    },
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableView), args, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableHeader), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Column), {
            width: 250,
            showDivider: true
        }, "File Name"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Column), null, "Type"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Column), {
            align: "end"
        }, "Size")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableBody), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Row), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, "2018 Proposal"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, "PDF"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, "214 KB")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Row), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, "Budget"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, "XLS"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, "120 KB")))),
    name: "column widths and dividers"
};
const CellWithLongContent = {
    args: {
        "aria-label": "TableView with column widths and dividers",
        width: 500,
        height: 300
    },
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableView), args, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableHeader), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Column), {
            width: 250,
            showDivider: true
        }, "File Name"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Column), null, "Type"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Column), {
            align: "end"
        }, "Size")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableBody), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Row), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, "2018 Proposal with very very very very very very long long long long long filename"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, "PDF"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, "214 KB")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Row), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, "Budget"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, "XLS"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, "120 KB")))),
    name: "cell with long content",
    parameters: {
        description: {
            data: "After changing overflowMode, refresh page to see the change."
        }
    }
};
const CustomRowHeaderLabeling = {
    args: {
        "aria-label": "TableView with custom row header labeling",
        width: 500,
        height: 200
    },
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableView), args, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableHeader), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Column), {
            isRowHeader: true
        }, "First Name"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Column), {
            isRowHeader: true
        }, "Last Name"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Column), null, "Birthday")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableBody), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Row), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, "Sam"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, "Smith"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, "May 3")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Row), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, "Julia"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, "Jones"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, "February 10")))),
    name: "custom isRowHeader labeling",
    parameters: {
        description: {
            content: "Changes how the screen reader labels rows."
        }
    }
};
const CRUD = {
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _crudexample.CRUDExample), args),
    name: "CRUD"
};
function DeletableRowsTable(props) {
    let list = (0, _data.useListData)({
        initialItems: [
            {
                id: 1,
                firstName: "Sam",
                lastName: "Smith",
                birthday: "May 3"
            },
            {
                id: 2,
                firstName: "Julia",
                lastName: "Jones",
                birthday: "February 10"
            }
        ]
    });
    let onSelectionChange = (0, _react.useCallback)((keys)=>{
        props.onSelectionChange(keys);
        list.setSelectedKeys(keys);
    }, [
        props,
        list
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableView), {
        ...props,
        selectedKeys: list.selectedKeys,
        onSelectionChange: onSelectionChange,
        renderEmptyState: list.items.length === 0 ? ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement(EmptyState, null) : undefined
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableHeader), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Column), {
        isRowHeader: true,
        key: "firstName"
    }, "First Name"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Column), {
        isRowHeader: true,
        key: "lastName"
    }, "Last Name"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Column), {
        key: "birthday"
    }, "Birthday"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Column), {
        key: "actions",
        align: "end"
    }, "Actions")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableBody), {
        items: list.items
    }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Row), null, (column)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, column === "actions" ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), {
                onPress: ()=>list.remove(item.id)
            }, "Delete") : item[column]))));
}
const InlineDeleteButtons = {
    args: {
        "aria-label": "People",
        width: 500,
        height: 300
    },
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(DeletableRowsTable, args),
    name: "Inline delete buttons"
};
const HidingColumnsExample = {
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _hidingColumns.HidingColumns), args),
    name: "hiding columns"
};
const IsLoading = {
    args: {
        "aria-label": "TableView loading",
        width: 700,
        height: 200
    },
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableView), args, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableHeader), {
            columns: manyColunns
        }, (column)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Column), {
                minWidth: 100
            }, column.name)), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableBody), {
            items: [],
            loadingState: "loading"
        }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Row), {
                key: item.foo
            }, (key)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, item[key])))),
    name: "isLoading"
};
const IsLoadingMore = {
    args: {
        "aria-label": "TableView loading more",
        width: 700,
        height: 200
    },
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableView), args, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableHeader), {
            columns: manyColunns
        }, (column)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Column), {
                minWidth: 100
            }, column.name)), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableBody), {
            items: [],
            loadingState: "loadingMore"
        }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Row), {
                key: item.foo
            }, (key)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, item[key])))),
    name: "isLoading more"
};
const Filtering = {
    args: {
        "aria-label": "TableView filtering",
        width: 700,
        height: 200
    },
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableView), args, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableHeader), {
            columns: columns
        }, (column)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Column), {
                minWidth: 100
            }, column.name)), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableBody), {
            items: items,
            loadingState: "filtering"
        }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Row), {
                key: item.foo
            }, (key)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, item[key])))),
    name: "filtering"
};
function renderEmptyState() {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _illustratedmessage.IllustratedMessage), null, /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        width: "150",
        height: "103",
        viewBox: "0 0 150 103"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M133.7,8.5h-118c-1.9,0-3.5,1.6-3.5,3.5v27c0,0.8,0.7,1.5,1.5,1.5s1.5-0.7,1.5-1.5V23.5h119V92c0,0.3-0.2,0.5-0.5,0.5h-118c-0.3,0-0.5-0.2-0.5-0.5V69c0-0.8-0.7-1.5-1.5-1.5s-1.5,0.7-1.5,1.5v23c0,1.9,1.6,3.5,3.5,3.5h118c1.9,0,3.5-1.6,3.5-3.5V12C137.2,10.1,135.6,8.5,133.7,8.5z M15.2,21.5V12c0-0.3,0.2-0.5,0.5-0.5h118c0.3,0,0.5,0.2,0.5,0.5v9.5H15.2z M32.6,16.5c0,0.6-0.4,1-1,1h-10c-0.6,0-1-0.4-1-1s0.4-1,1-1h10C32.2,15.5,32.6,15.9,32.6,16.5z M13.6,56.1l-8.6,8.5C4.8,65,4.4,65.1,4,65.1c-0.4,0-0.8-0.1-1.1-0.4c-0.6-0.6-0.6-1.5,0-2.1l8.6-8.5l-8.6-8.5c-0.6-0.6-0.6-1.5,0-2.1c0.6-0.6,1.5-0.6,2.1,0l8.6,8.5l8.6-8.5c0.6-0.6,1.5-0.6,2.1,0c0.6,0.6,0.6,1.5,0,2.1L15.8,54l8.6,8.5c0.6,0.6,0.6,1.5,0,2.1c-0.3,0.3-0.7,0.4-1.1,0.4c-0.4,0-0.8-0.1-1.1-0.4L13.6,56.1z"
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Heading), null, "No results"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Content), null, "No results found, press ", /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _link.Link), {
        onPress: (0, _addonActions.action)("linkPress")
    }, "here"), " for more info."));
}
function EmptyStateTable(props) {
    let { items, columns, allowsSorting, ...otherProps } = props;
    let [show, setShow] = (0, _react.useState)(false);
    let [sortDescriptor, setSortDescriptor] = (0, _react.useState)({});
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
        direction: "column"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), {
        width: "100px",
        onPress: ()=>setShow((show)=>!show)
    }, "Toggle items"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableView), {
        "aria-label": "TableView with empty state",
        width: 700,
        height: 400,
        renderEmptyState: renderEmptyState,
        selectionMode: "multiple",
        sortDescriptor: sortDescriptor,
        onSortChange: setSortDescriptor,
        ...otherProps
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableHeader), {
        columns: columns !== null && columns !== void 0 ? columns : manyColunns
    }, (column)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Column), {
            allowsResizing: true,
            allowsSorting: allowsSorting,
            minWidth: 100
        }, column.name)), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableBody), {
        items: show ? items !== null && items !== void 0 ? items : manyRows : []
    }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Row), {
            key: item.foo,
            UNSTABLE_childItems: item.childRows
        }, (key)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, item[key])))));
}
const EmptyStateStory = {
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(EmptyStateTable, args),
    name: "renderEmptyState"
};
function AsyncLoadingExample(props) {
    const { isResizable } = props;
    let list = (0, _data.useAsyncList)({
        getKey: (item)=>item.data.id,
        async load ({ signal, cursor }) {
            let url = new URL("https://www.reddit.com/r/upliftingnews.json");
            if (cursor) url.searchParams.append("after", cursor);
            let res = await fetch(url.toString(), {
                signal
            });
            let json = await res.json();
            return {
                items: json.data.children,
                cursor: json.data.after
            };
        },
        sort ({ items, sortDescriptor }) {
            return {
                items: items.slice().sort((a, b)=>{
                    let cmp = a.data[sortDescriptor.column] < b.data[sortDescriptor.column] ? -1 : 1;
                    if (sortDescriptor.direction === "descending") cmp *= -1;
                    return cmp;
                })
            };
        }
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), {
        marginBottom: 10,
        onPress: ()=>list.remove(list.items[0].data.id)
    }, "Remove first item"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableView), {
        ...props,
        sortDescriptor: list.sortDescriptor,
        onSortChange: list.sort,
        selectedKeys: list.selectedKeys,
        onSelectionChange: list.setSelectedKeys
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableHeader), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Column), {
        key: "score",
        defaultWidth: 100,
        allowsResizing: isResizable,
        allowsSorting: true
    }, "Score"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Column), {
        key: "title",
        isRowHeader: true,
        allowsResizing: isResizable,
        allowsSorting: true
    }, "Title"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Column), {
        key: "author",
        defaultWidth: 200,
        allowsResizing: isResizable,
        allowsSorting: true
    }, "Author"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Column), {
        key: "num_comments",
        defaultWidth: 100,
        allowsResizing: isResizable,
        allowsSorting: true
    }, "Comments")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableBody), {
        items: list.items,
        loadingState: list.loadingState,
        onLoadMore: list.loadMore
    }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Row), {
            key: item.data.id
        }, (key)=>key === "title" ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), {
                textValue: item.data.title
            }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _link.Link), {
                isQuiet: true
            }, /*#__PURE__*/ (0, _reactDefault.default).createElement("a", {
                href: item.data.url,
                target: "_blank"
            }, item.data.title))) : /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, item.data[key])))));
}
const AsyncLoading = {
    args: {
        "aria-label": "Top news from Reddit",
        selectionMode: "multiple",
        width: 1000,
        height: 400
    },
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(AsyncLoadingExample, args),
    name: "async loading"
};
async function fakeFetch() {
    return new Promise((resolve)=>{
        setTimeout(()=>resolve({
                json: async function() {
                    return {
                        data: {
                            children: [
                                {
                                    data: {
                                        id: "foo",
                                        thumbnail: "https://i.imgur.com/Z7AzH2c.jpg",
                                        ups: "7",
                                        title: "cats",
                                        created: Date.now()
                                    }
                                },
                                {
                                    data: {
                                        id: "fooo",
                                        thumbnail: "https://i.imgur.com/Z7AzH2c.jpg",
                                        ups: "7",
                                        title: "cats",
                                        created: Date.now()
                                    }
                                },
                                {
                                    data: {
                                        id: "foooo",
                                        thumbnail: "https://i.imgur.com/Z7AzH2c.jpg",
                                        ups: "7",
                                        title: "cats",
                                        created: Date.now()
                                    }
                                },
                                {
                                    data: {
                                        id: "fooooo",
                                        thumbnail: "https://i.imgur.com/Z7AzH2c.jpg",
                                        ups: "7",
                                        title: "cats",
                                        created: Date.now()
                                    }
                                },
                                {
                                    data: {
                                        id: "foooooo",
                                        thumbnail: "https://i.imgur.com/Z7AzH2c.jpg",
                                        ups: "7",
                                        title: "cats",
                                        created: Date.now()
                                    }
                                },
                                {
                                    data: {
                                        id: "doo",
                                        thumbnail: "https://i.imgur.com/Z7AzH2c.jpg",
                                        ups: "7",
                                        title: "cats",
                                        created: Date.now()
                                    }
                                },
                                {
                                    data: {
                                        id: "1",
                                        thumbnail: "https://i.imgur.com/Z7AzH2c.jpg",
                                        ups: "7",
                                        title: "cats",
                                        created: Date.now()
                                    }
                                },
                                {
                                    data: {
                                        id: "2",
                                        thumbnail: "https://i.imgur.com/Z7AzH2c.jpg",
                                        ups: "7",
                                        title: "cats",
                                        created: Date.now()
                                    }
                                },
                                {
                                    data: {
                                        id: "3",
                                        thumbnail: "https://i.imgur.com/Z7AzH2c.jpg",
                                        ups: "7",
                                        title: "cats",
                                        created: Date.now()
                                    }
                                },
                                {
                                    data: {
                                        id: "4",
                                        thumbnail: "https://i.imgur.com/Z7AzH2c.jpg",
                                        ups: "7",
                                        title: "cats",
                                        created: Date.now()
                                    }
                                },
                                {
                                    data: {
                                        id: "5",
                                        thumbnail: "https://i.imgur.com/Z7AzH2c.jpg",
                                        ups: "7",
                                        title: "cats",
                                        created: Date.now()
                                    }
                                },
                                {
                                    data: {
                                        id: "6",
                                        thumbnail: "https://i.imgur.com/Z7AzH2c.jpg",
                                        ups: "7",
                                        title: "cats",
                                        created: Date.now()
                                    }
                                }
                            ]
                        }
                    };
                }
            }), 1000);
    });
}
const AsyncLoadingQuarryTest = {
    args: {
        "aria-label": "Top news from Reddit",
        selectionMode: "multiple",
        height: 400,
        width: "100%"
    },
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(AsyncLoadingExampleQuarryTest, args),
    name: "async reload on sort"
};
function AsyncLoadingExampleQuarryTest(props) {
    let [filters, setFilters] = (0, _reactDefault.default).useState({});
    const rColumns = [
        {
            key: "title",
            label: "Title"
        },
        {
            key: "ups",
            label: "Upvotes",
            width: 200
        },
        {
            key: "created",
            label: "Created",
            width: 350
        }
    ];
    let list = (0, _data.useAsyncList)({
        getKey: (item)=>item.id,
        async load ({ cursor }) {
            const url = new URL("https://www.reddit.com/r/aww.json");
            if (cursor) url.searchParams.append("after", cursor);
            const res = await fakeFetch();
            // @ts-ignore
            const json = await res.json();
            const items = json.data.children.map((item)=>{
                return {
                    id: item.data.id,
                    preview: item.data.thumbnail,
                    ups: item.data.ups,
                    title: item.data.title,
                    created: new Date(item.data.created * 1000).toISOString()
                };
            });
            return {
                items,
                cursor: json.data.after,
                total: 987
            };
        },
        async sort ({ items, sortDescriptor }) {
            return {
                items: items.slice().sort((a, b)=>{
                    let cmp = a[sortDescriptor.column] < b[sortDescriptor.column] ? -1 : 1;
                    if (sortDescriptor.direction === "descending") cmp *= -1;
                    return cmp;
                })
            };
        }
    });
    let reloadDeps = [
        filters
    ];
    useMountEffect(()=>{
        list.reload();
    }, reloadDeps);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableView), {
        ...props,
        width: "90vw",
        sortDescriptor: list.sortDescriptor,
        selectedKeys: list.selectedKeys,
        onSelectionChange: list.setSelectedKeys,
        onSortChange: setFilters
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableHeader), {
        columns: rColumns
    }, (column)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Column), {
            key: column.key,
            allowsSorting: true
        }, column.label)), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableBody), {
        items: list.items,
        loadingState: list.loadingState,
        onLoadMore: list.loadMore
    }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Row), {
            key: item.id
        }, (key)=>key === "title" ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), {
                textValue: item.title
            }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _link.Link), {
                isQuiet: true
            }, /*#__PURE__*/ (0, _reactDefault.default).createElement("a", {
                href: item.url,
                target: "_blank"
            }, item.title))) : /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, item[key]))));
}
function useMountEffect(fn, deps) {
    const mounted = (0, _reactDefault.default).useRef(false);
    (0, _reactDefault.default).useEffect(()=>{
        if (mounted.current) fn();
        else mounted.current = true;
    }, deps);
}
const HideHeader = {
    args: {
        "aria-label": "TableView with static contents",
        width: 350,
        height: 200
    },
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableView), args, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableHeader), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Column), {
            key: "foo"
        }, "Foo"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Column), {
            key: "addAction",
            hideHeader: true
        }, "Add Info"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Column), {
            key: "deleteAction",
            hideHeader: true,
            showDivider: true
        }, "Delete Item"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Column), {
            key: "bar"
        }, "Bar"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Column), {
            key: "baz"
        }, "Baz")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableBody), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Row), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, "One"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), {
            isQuiet: true,
            "aria-label": "Add Info"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _addDefault.default), null))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), {
            isQuiet: true,
            "aria-label": "Delete"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _deleteDefault.default), null))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, "Two"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, "Three")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Row), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, "One"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), {
            isQuiet: true,
            "aria-label": "Add Info"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _addDefault.default), null))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), {
            isQuiet: true,
            "aria-label": "Delete"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _deleteDefault.default), null))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, "Two"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, "Three")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Row), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, "One"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), {
            isQuiet: true,
            "aria-label": "Add Info"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _addDefault.default), null))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), {
            isQuiet: true,
            "aria-label": "Delete"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _deleteDefault.default), null))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, "Two"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, "Three")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Row), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, "One"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), {
            isQuiet: true,
            "aria-label": "Add Info"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _addDefault.default), null))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), {
            isQuiet: true,
            "aria-label": "Delete"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _deleteDefault.default), null))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, "Two"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, "Three")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Row), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, "One"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), {
            isQuiet: true,
            "aria-label": "Add Info"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _addDefault.default), null))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), {
            isQuiet: true,
            "aria-label": "Delete"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _deleteDefault.default), null))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, "Two"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, "Three")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Row), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, "One"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), {
            isQuiet: true,
            "aria-label": "Add Info"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _addDefault.default), null))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), {
            isQuiet: true,
            "aria-label": "Delete"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _deleteDefault.default), null))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, "Two"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, "Three")))),
    name: "hideHeader"
};
let COLUMNS = [
    {
        name: "Name",
        key: "name",
        minWidth: 200
    },
    {
        name: "Owner",
        key: "ownerName"
    }
];
async function getCollectionItems() {
    const result = [
        {
            id: "xx",
            name: "abc",
            ownerName: "xx"
        },
        {
            id: "aa",
            name: "efg",
            ownerName: "aa"
        },
        {
            id: "yy",
            name: "abcd",
            ownerName: "yy"
        },
        {
            id: "bb",
            name: "efgh",
            ownerName: "bb"
        },
        {
            id: "zz",
            name: "abce",
            ownerName: "zz"
        },
        {
            id: "cc",
            name: "efgi",
            ownerName: "cc"
        }
    ];
    return new Promise((resolve)=>{
        setTimeout(()=>{
            resolve(result);
        }, 5);
    });
}
function ProjectListTable(props) {
    let { contains } = (0, _i18N.useFilter)({
        sensitivity: "base"
    });
    let [filterText, setFilterText] = (0, _reactDefault.default).useState("");
    let list = (0, _data.useAsyncList)({
        async load () {
            let projects = await getCollectionItems();
            return {
                items: projects
            };
        }
    });
    let filteredItems = (0, _reactDefault.default).useMemo(()=>list.items.filter((item)=>contains(item.name, filterText)), [
        list.items,
        filterText,
        contains
    ]);
    const onChange = (value)=>{
        setFilterText(value);
    };
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _searchfield.SearchField), {
        marginStart: "size-200",
        marginBottom: "size-200",
        marginTop: "size-200",
        width: "size-3600",
        "aria-label": "Search by name",
        value: filterText,
        onChange: onChange
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.View), {
        flexGrow: 1,
        height: 700,
        overflow: "hidden"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableView), {
        "aria-label": "Project list",
        ...props,
        height: "100%",
        sortDescriptor: list.sortDescriptor,
        onSortChange: list.sort
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableHeader), {
        columns: COLUMNS
    }, (column)=>{
        const { name, ...columnProps } = column;
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Column), columnProps, name);
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableBody), {
        items: filteredItems,
        loadingState: list.loadingState
    }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Row), {
            key: item.id
        }, (key)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, item[key]))))));
}
const AsyncLoadingClientFiltering = {
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(ProjectListTable, args),
    name: "async client side filter loading"
};
function AsyncServerFilterTable(props) {
    let columns = [
        {
            name: "Name",
            key: "name",
            minWidth: 200
        },
        {
            name: "Height",
            key: "height"
        },
        {
            name: "Mass",
            key: "mass"
        }
    ];
    let list = (0, _data.useAsyncList)({
        getKey: (item)=>item.name,
        async load ({ signal, cursor, filterText }) {
            if (cursor) cursor = cursor.replace(/^http:\/\//i, "https://");
            let res = await fetch(cursor || `https://swapi.py4e.com/api/people/?search=${filterText}`, {
                signal
            });
            let json = await res.json();
            return {
                items: json.results,
                cursor: json.next
            };
        }
    });
    const onChange = (value)=>{
        list.setFilterText(value);
    };
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _searchfield.SearchField), {
        marginStart: "size-200",
        marginBottom: "size-200",
        marginTop: "size-200",
        width: "size-3600",
        "aria-label": "Search by name",
        defaultValue: list.filterText,
        onChange: onChange
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableView), {
        "aria-label": "Star Wars Characters",
        height: 200,
        width: 600,
        ...props,
        sortDescriptor: list.sortDescriptor,
        onSortChange: list.sort
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableHeader), {
        columns: columns
    }, (column)=>{
        const { name, ...columnProps } = column;
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Column), columnProps, name);
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableBody), {
        items: list.items,
        loadingState: list.loadingState,
        onLoadMore: list.loadMore
    }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Row), {
            key: item.name
        }, (key)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, item[key])))));
}
const AsyncLoadingServerFiltering = {
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(AsyncServerFilterTable, args),
    name: "async server side filter loading"
};
const AsyncLoadingServerFilteringLoadMore = {
    args: {
        height: 500
    },
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(AsyncServerFilterTable, args),
    name: "loads more on scroll when contentSize.height < rect.height * 2"
};
const WithDialogTrigger = {
    args: {
        "aria-label": "TableView with static contents",
        width: 300,
        height: 200
    },
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableView), args, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableHeader), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Column), {
            key: "foo"
        }, "Foo"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Column), {
            key: "bar"
        }, "Bar"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Column), {
            key: "baz"
        }, "Baz")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableBody), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Row), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, "One"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, "Two"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _dialog.DialogTrigger), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), {
            "aria-label": "Add"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _addDefault.default), null)), (close)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _dialog.Dialog), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Heading), null, "The Heading"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _divider.Divider), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Content), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textfield.TextField), {
                label: "Last Words"
            })), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _buttongroup.ButtonGroup), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.Button), {
                variant: "secondary",
                onPress: close
            }, "Cancel"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.Button), {
                variant: "cta",
                onPress: close
            }, "Confirm")))))))),
    name: "with dialog trigger"
};
function TableWithBreadcrumbs(props) {
    const fs = [
        {
            key: "a",
            name: "Folder A",
            type: "folder"
        },
        {
            key: "b",
            name: "File B",
            value: "10 MB"
        },
        {
            key: "c",
            name: "File C",
            value: "10 MB",
            parent: "a"
        },
        {
            key: "d",
            name: "File D",
            value: "10 MB",
            parent: "a"
        }
    ];
    const [loadingState, setLoadingState] = (0, _react.useState)("idle");
    const [selection, setSelection] = (0, _react.useState)(new Set([]));
    const [items, setItems] = (0, _react.useState)(()=>fs.filter((item)=>!item.parent));
    const changeFolder = (folder)=>{
        setItems([]);
        setLoadingState("loading");
        // mimic loading behavior
        setTimeout(()=>{
            setLoadingState("idle");
            setItems(fs.filter((item)=>folder ? item.parent === folder : !item.parent));
        }, 700);
        setSelection(new Set([]));
    };
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
        direction: "column",
        width: "400px"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", null, "The TableView should not error if row selection changes due to items changes from external navigation (breadcrumbs)."), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _breadcrumbs.Breadcrumbs), {
        onAction: (item)=>{
            if (item === "root") changeFolder("");
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _breadcrumbs.Item), {
        key: "root"
    }, "root"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _breadcrumbs.Item), null, "a")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableView), {
        width: "400px",
        "aria-label": "table",
        ...props,
        selectedKeys: selection,
        onSelectionChange: (sel)=>setSelection(sel)
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableHeader), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Column), {
        key: "name",
        isRowHeader: true
    }, "Name"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Column), {
        key: "value"
    }, "Value")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableBody), {
        items: items,
        loadingState: loadingState
    }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Row), {
            key: item.key
        }, (column)=>{
            if (item.type === "folder" && column === "name") return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), {
                textValue: item[column]
            }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _link.Link), {
                onPress: ()=>changeFolder(item.key)
            }, item[column]));
            return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, item[column]);
        }))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), {
        onPress: ()=>setSelection(items.some((item)=>item.key === "d") ? new Set([
                "d"
            ]) : new Set([]))
    }, "Select D"));
}
const WithBreadcrumbNavigation = {
    args: {
        // onAction is attached to everything by default now, but that changes the behavior of TableView
        // our tests using this component expect the non-onAction behavior
        onAction: undefined
    },
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(TableWithBreadcrumbs, args),
    name: "table with breadcrumb navigation"
};
const ResizingUncontrolledDynamicWidths = {
    args: {
        "aria-label": "TableView with resizable columns",
        width: 800,
        height: 200
    },
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement("label", {
            htmlFor: "focusable-before"
        }, "Focusable before"), /*#__PURE__*/ (0, _reactDefault.default).createElement("input", {
            id: "focusable-before"
        }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableView), args, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableHeader), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Column), {
            allowsResizing: true,
            defaultWidth: "1fr"
        }, "File Name"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Column), {
            allowsResizing: true,
            defaultWidth: "2fr"
        }, "Type"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Column), {
            allowsResizing: true,
            defaultWidth: "2fr"
        }, "Size"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Column), {
            allowsResizing: true,
            defaultWidth: "1fr"
        }, "Weight")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableBody), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Row), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, "2018 Proposal"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, "PDF"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, "214 KB"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, "1 LB")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Row), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, "Budget"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, "XLS"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, "120 KB"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, "20 LB")))), /*#__PURE__*/ (0, _reactDefault.default).createElement("label", {
            htmlFor: "focusable-after"
        }, "Focusable after"), /*#__PURE__*/ (0, _reactDefault.default).createElement("input", {
            id: "focusable-after"
        })),
    name: "allowsResizing, uncontrolled, dynamic widths"
};
const ResizingUncontrolledStaticWidths = {
    args: {
        "aria-label": "TableView with resizable columns",
        width: 800,
        height: 200
    },
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableView), args, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableHeader), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Column), {
            allowsResizing: true,
            defaultWidth: "50%"
        }, "File Name"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Column), {
            allowsResizing: true,
            defaultWidth: "20%"
        }, "Type"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Column), {
            allowsResizing: true,
            defaultWidth: 239
        }, "Size")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableBody), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Row), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, "2018 Proposal"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, "PDF"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, "214 KB")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Row), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, "Budget"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, "XLS"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, "120 KB")))),
    name: "allowsResizing, uncontrolled, static widths"
};
const ResizingUncontrolledColumnDivider = {
    args: {
        "aria-label": "TableView with resizable columns and divider",
        width: 800,
        height: 200
    },
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableView), args, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableHeader), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Column), {
            allowsResizing: true,
            showDivider: true
        }, "File Name"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Column), {
            allowsResizing: true,
            defaultWidth: "3fr"
        }, "Type"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Column), {
            allowsResizing: true
        }, "Size")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableBody), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Row), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, "2018 Proposal"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, "PDF"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, "214 KB")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Row), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, "Budget"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, "XLS"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, "120 KB")))),
    name: "allowsResizing, uncontrolled, column divider"
};
const ResizingUncontrolledMinMax = {
    args: {
        "aria-label": "TableView with resizable columns",
        width: 800,
        height: 200
    },
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableView), args, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableHeader), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Column), {
            allowsResizing: true,
            defaultWidth: 200,
            minWidth: 175,
            maxWidth: 300
        }, "File Name"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Column), {
            allowsResizing: true,
            defaultWidth: "1fr",
            minWidth: 175,
            maxWidth: 500
        }, "Size"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Column), {
            allowsResizing: true,
            defaultWidth: 200,
            minWidth: 175,
            maxWidth: 300
        }, "Type")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableBody), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Row), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, "2018 Proposal"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, "PDF"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, "214 KB")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Row), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, "Budget"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, "XLS"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, "120 KB")))),
    name: "allowsResizing, uncontrolled, min/max widths"
};
const ResizingUncontrolledSomeNotAllowed = {
    args: {
        "aria-label": "TableView with resizable columns",
        width: 800,
        height: 200
    },
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableView), args, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableHeader), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Column), {
            allowsResizing: true
        }, "File Name"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Column), {
            defaultWidth: "1fr"
        }, "Type"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Column), {
            defaultWidth: "2fr"
        }, "Size"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Column), {
            allowsResizing: true,
            defaultWidth: "2fr"
        }, "Weight")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableBody), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Row), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, "2018 Proposal"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, "PDF"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, "214 KB"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, "1 LB")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Row), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, "Budget"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, "XLS"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, "120 KB"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, "20 LB")))),
    name: "allowsResizing, uncontrolled, some columns not allowed resizing"
};
const ResizingUncontrolledNoHeightWidth = {
    args: {
        "aria-label": "TableView with resizable columns and no width or height set"
    },
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableView), args, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableHeader), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Column), {
            allowsResizing: true,
            defaultWidth: 150
        }, "File Name"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Column), {
            allowsResizing: true,
            defaultWidth: 100
        }, "Type"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Column), {
            allowsResizing: true,
            defaultWidth: 100
        }, "Size"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Column), {
            allowsResizing: true,
            defaultWidth: 100
        }, "Weight")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableBody), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Row), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, "2018 Proposal"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, "PDF"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, "214 KB"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, "1 LB")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Row), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, "Budget"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, "XLS"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, "120 KB"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, "20 LB")))),
    name: "allowsResizing, uncontrolled, undefined table width and height"
};
const ResizingUncontrolledSortableColumns = {
    args: {
        width: 1000,
        height: 400
    },
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(AsyncLoadingExample, {
            isResizable: true,
            ...args
        }),
    name: "allowsResizing, uncontrolled, sortable columns"
};
const ResizingManyColumnsRows = {
    args: {
        "aria-label": "TableView with many columns and rows",
        width: 700,
        height: 500
    },
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement("label", {
            htmlFor: "focusable-before"
        }, "Focusable before"), /*#__PURE__*/ (0, _reactDefault.default).createElement("input", {
            id: "focusable-before"
        }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableView), args, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableHeader), {
            columns: manyColunns
        }, (column)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Column), {
                allowsResizing: true,
                minWidth: 100
            }, column.name)), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableBody), {
            items: manyRows
        }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Row), {
                key: item.foo
            }, (key)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, item[key])))), /*#__PURE__*/ (0, _reactDefault.default).createElement("label", {
            htmlFor: "focusable-after"
        }, "Focusable after"), /*#__PURE__*/ (0, _reactDefault.default).createElement("input", {
            id: "focusable-after"
        })),
    name: "allowsResizing, many columns and rows"
};
const ResizingHidingColumns = {
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _hidingColumnsAllowsResizing.HidingColumnsAllowsResizing), args),
    name: "allowsResizing, hiding columns"
};
function EmptyState() {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _illustratedmessage.IllustratedMessage), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _noSearchResultsDefault.default), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Heading), null, "No results"));
}
function ZoomResizing(props) {
    const [child, setChild] = (0, _react.useState)("loader");
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: "App",
        style: {
            height: "100vh"
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _radio.RadioGroup), {
        label: "Child type",
        orientation: "horizontal",
        value: child,
        onChange: setChild
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _radio.Radio), {
        value: "loader"
    }, "Loading state"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _radio.Radio), {
        value: "empty"
    }, "Empty state")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
        height: "100%"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableView), {
        height: "100%",
        width: "100%",
        ...props,
        renderEmptyState: child === "empty" ? ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement(EmptyState, null) : undefined
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableHeader), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Column), null, "column")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableBody), {
        items: [],
        loadingState: child === "loader" ? "loading" : undefined
    }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Row), null, (column)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, item[column]))))));
}
const ResizingZoom = {
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
            style: {
                position: "absolute",
                height: "calc(100vh-32px)",
                width: "calc(100vw - 32px)"
            }
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement(ZoomResizing, args)),
    name: "zoom resizing table",
    parameters: {
        description: {
            data: 'Using browser zoom should not trigger an infinite resizing loop. CMD+"+" to zoom in and CMD+"-" to zoom out.'
        }
    }
};
let uncontrolledColumns = [
    {
        name: "Name",
        uid: "name"
    },
    {
        name: "Type",
        uid: "type"
    },
    {
        name: "Height",
        uid: "height"
    },
    {
        name: "Weight",
        uid: "weight"
    },
    {
        name: "Level",
        uid: "level"
    }
];
const ResizingControlledNoInitialWidths = {
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _controllingResize.ControllingResize), {
            ...args,
            width: 900,
            columns: uncontrolledColumns
        }),
    name: "allowsResizing, controlled, no widths",
    parameters: {
        description: {
            data: `
    You can use the buttons to save and restore the column widths. When restoring,
    you will notice that the entire table reverts, this is because no columns are controlled.
  `
        }
    }
};
let columnsSomeFR = [
    {
        name: "Name",
        uid: "name",
        width: "1fr"
    },
    {
        name: "Type",
        uid: "type",
        width: "1fr"
    },
    {
        name: "Height",
        uid: "height"
    },
    {
        name: "Weight",
        uid: "weight"
    },
    {
        name: "Level",
        uid: "level",
        width: "4fr"
    }
];
const ResizingControlledSomeInitialWidths = {
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _controllingResize.ControllingResize), {
            ...args,
            width: 900,
            columns: columnsSomeFR
        }),
    name: "allowsResizing, controlled, some widths",
    parameters: {
        description: {
            data: `
    You can use the buttons to save and restore the column widths. When restoring,
    you will see a quick flash because the entire table is re-rendered. This
    mimics what would happen if an app reloaded the whole page and restored a saved
    column width state. This is a "some widths" controlled story. It cannot restore
    the widths of the columns that it does not manage. Height and weight are uncontrolled.
  `
        }
    }
};
let columnsFR = [
    {
        name: "Name",
        uid: "name",
        width: "1fr"
    },
    {
        name: "Type",
        uid: "type",
        width: "1fr"
    },
    {
        name: "Level",
        uid: "level",
        width: "4fr"
    }
];
const ResizingControlledAllInitialWidths = {
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _controllingResize.ControllingResize), {
            ...args,
            width: 900,
            columns: columnsFR
        }),
    name: "allowsResizing, controlled, all widths",
    parameters: {
        description: {
            data: `
    You can use the buttons to save and restore the column widths. When restoring,
    you will see a quick flash because the entire table is re-rendered. This
    mimics what would happen if an app reloaded the whole page and restored a saved
    column width state.
  `
        }
    }
};
let columnsFRHideHeaders = [
    {
        name: "Name",
        uid: "name",
        hideHeader: true
    },
    {
        name: "Type",
        uid: "type",
        width: 300,
        hideHeader: true
    },
    {
        name: "Level",
        uid: "level",
        width: "4fr"
    }
];
const ResizingControlledHideHeader = {
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _controllingResize.ControllingResize), {
            ...args,
            width: 900,
            columns: columnsFRHideHeaders
        }),
    name: "allowsResizing, controlled, hideHeader",
    parameters: {
        description: {
            data: `
    Hide headers columns should not be resizable.
  `
        }
    }
};
let typeAheadColumns = [
    {
        name: "First Name",
        id: "firstname",
        isRowHeader: true
    },
    {
        name: "Last Name",
        id: "lastname",
        isRowHeader: true
    },
    {
        name: "Birthday",
        id: "birthday"
    },
    {
        name: "Edit",
        id: "edit"
    }
];
let typeAheadRows = [
    ...Array.from({
        length: 100
    }, (v, i)=>({
            id: i,
            firstname: "Aubrey",
            lastname: "Sheppard",
            birthday: "May 7"
        })),
    {
        id: 101,
        firstname: "John",
        lastname: "Doe",
        birthday: "May 7"
    }
];
const TypeaheadWithDialog = {
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
            style: {
                height: "90vh"
            }
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableView), {
            "aria-label": "Table",
            selectionMode: "none",
            height: "100%",
            ...args
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableHeader), {
            columns: typeAheadColumns
        }, (col)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Column), {
                key: col.id,
                isRowHeader: col.isRowHeader
            }, col.name)), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableBody), {
            items: typeAheadRows
        }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Row), {
                key: item.id
            }, (key)=>key === "edit" ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _dialog.DialogTrigger), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), {
                    "aria-label": "Add Info"
                }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _addDefault.default), null)), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _dialog.Dialog), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Heading), null, "Add Info"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _divider.Divider), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Content), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textfield.TextField), {
                    label: "Enter a J"
                }))))) : /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, item[key])))))
};
const Links = (args)=>{
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableView), {
        ...args,
        "aria-label": "Bookmarks table",
        onSelectionChange: (0, _addonActions.action)("onSelectionChange")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableHeader), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Column), null, "Name"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Column), null, "URL"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Column), null, "Date added")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableBody), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Row), {
        key: "https://adobe.com/",
        href: "https://adobe.com/"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, "Adobe"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, "https://adobe.com/"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, "January 28, 2023")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Row), {
        key: "https://google.com/",
        href: "https://google.com/"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, "Google"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, "https://google.com/"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, "April 5, 2023")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Row), {
        key: "https://apple.com/",
        href: "https://apple.com/"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, "Apple"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, "https://apple.com/"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, "June 5, 2023")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Row), {
        key: "https://nytimes.com/",
        href: "https://nytimes.com/"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, "New York Times"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, "https://nytimes.com/"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, "July 12, 2023"))));
};
const ColumnHeaderFocusRingTable = {
    render: ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement(LoadingTable, null),
    storyName: "column header focus after loading",
    parameters: {
        description: {
            data: "Column header should remain focused even if the table collections empties/loading state changes to loading"
        }
    }
};
const allItems = [
    {
        key: "sam",
        name: "Sam",
        height: 66,
        birthday: "May 3"
    },
    {
        key: "julia",
        name: "Julia",
        height: 70,
        birthday: "February 10"
    }
];
function LoadingTable() {
    const [items, setItems] = (0, _react.useState)(allItems);
    const [loadingState, setLoadingState] = (0, _react.useState)(undefined);
    const onSortChange = ()=>{
        setItems([]);
        setLoadingState("loading");
        setTimeout(()=>{
            setItems(items.length > 1 ? [
                ...items.slice(0, 1)
            ] : []);
            setLoadingState(undefined);
        }, 1000);
    };
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableView), {
        "aria-label": "Table",
        selectionMode: "multiple",
        onSortChange: onSortChange,
        height: 300
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableHeader), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Column), {
        key: "name"
    }, "Name"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Column), {
        key: "height",
        allowsSorting: true
    }, "Height"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Column), {
        key: "birthday"
    }, "Birthday")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableBody), {
        items: items,
        loadingState: loadingState
    }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Row), {
            key: item.key
        }, (column)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, item[column]))));
}

},{"@storybook/addon-actions":"coXbW","@react-spectrum/button":"jZWyP","@spectrum-icons/workflow/Add":"evYih","@react-spectrum/breadcrumbs":"2lBZC","@react-spectrum/buttongroup":"anP11","../":"kHBRW","@react-spectrum/view":"dnRjt","./ControllingResize":"7g0Wd","./CRUDExample":"18I2f","@spectrum-icons/workflow/Delete":"foJ71","@react-spectrum/dialog":"3G0HV","@react-spectrum/divider":"dxmqN","@react-spectrum/layout":"hzaUY","@react-spectrum/text":"etCGI","./HidingColumns":"iuXbw","./HidingColumnsAllowsResizing":"cJPii","@react-spectrum/illustratedmessage":"cV05z","@react-spectrum/link":"lNoiB","@spectrum-icons/illustrations/NoSearchResults":"2nDIV","@react-spectrum/radio":"gbtGh","react":"9yzVZ","@react-spectrum/searchfield":"2pivm","@react-spectrum/switch":"fzqJX","@react-spectrum/textfield":"hOmtq","@react-stately/data":"gEgJM","@react-aria/i18n":"411rg","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"kHBRW":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 * 
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _src = require("./src");
parcelHelpers.exportAll(_src, exports);

},{"./src":"gptJH","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"7g0Wd":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ControllingResize", ()=>ControllingResize);
var _button = require("@react-spectrum/button");
var _ = require("../");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
let defaultColumns = [
    {
        name: "Name",
        uid: "name",
        width: "1fr"
    },
    {
        name: "Type",
        uid: "type",
        width: "1fr"
    },
    {
        name: "Height",
        uid: "height"
    },
    {
        name: "Weight",
        uid: "weight"
    },
    {
        name: "Level",
        uid: "level",
        width: "5fr"
    }
];
let defaultRows = [
    {
        id: 1,
        name: "Charizard",
        type: "Fire, Flying",
        level: "67",
        weight: "200lbs",
        height: "5'7\""
    },
    {
        id: 2,
        name: "Blastoise",
        type: "Water",
        level: "56",
        weight: "188lbs",
        height: "5'3\""
    },
    {
        id: 3,
        name: "Venusaur",
        type: "Grass, Poison",
        level: "83",
        weight: "220lbs",
        height: "6'7\""
    },
    {
        id: 4,
        name: "Pikachu",
        type: "Electric",
        level: "100",
        weight: "13lbs",
        height: "1'4\""
    },
    {
        id: 5,
        name: "Charizard",
        type: "Fire, Flying",
        level: "67",
        weight: "200lbs",
        height: "5'7\""
    },
    {
        id: 6,
        name: "Blastoise",
        type: "Water",
        level: "56",
        weight: "188lbs",
        height: "5'3\""
    },
    {
        id: 7,
        name: "Venusaur",
        type: "Grass, Poison",
        level: "83",
        weight: "220lbs",
        height: "6'7\""
    },
    {
        id: 8,
        name: "Pikachu",
        type: "Electric",
        level: "100",
        weight: "13lbs",
        height: "1'4\""
    },
    {
        id: 9,
        name: "Charizard",
        type: "Fire, Flying",
        level: "67",
        weight: "200lbs",
        height: "5'7\""
    },
    {
        id: 10,
        name: "Blastoise",
        type: "Water",
        level: "56",
        weight: "188lbs",
        height: "5'3\""
    },
    {
        id: 11,
        name: "Venusaur",
        type: "Grass, Poison",
        level: "83",
        weight: "220lbs",
        height: "6'7\""
    },
    {
        id: 12,
        name: "Pikachu",
        type: "Electric",
        level: "100",
        weight: "13lbs",
        height: "1'4\""
    }
];
function ControllingResize(props) {
    let { columns = defaultColumns, rows = defaultRows, onResize, ...otherProps } = props;
    let [widths, _setWidths] = (0, _react.useState)(()=>new Map(columns.filter((col)=>col.width).map((col)=>[
                col.uid,
                col.width
            ])));
    let setWidths = (0, _react.useCallback)((vals)=>{
        let controlledKeys = new Set(columns.filter((col)=>col.width).map((col)=>col.uid));
        let newVals = new Map(Array.from(vals).filter(([key])=>controlledKeys.has(key)));
        _setWidths(newVals);
        onResize === null || onResize === void 0 ? void 0 : onResize(vals);
    }, [
        onResize,
        columns,
        _setWidths
    ]);
    let [savedCols, setSavedCols] = (0, _react.useState)(widths);
    let [renderKey, setRenderKey] = (0, _react.useState)(()=>Math.random());
    // eslint-disable-next-line react-hooks/exhaustive-deps
    let cols = (0, _react.useMemo)(()=>columns.map((col)=>({
                ...col
            })), [
        columns,
        widths
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.Button), {
        variant: "accent",
        onPress: ()=>setSavedCols(widths)
    }, "Save Cols"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.Button), {
        variant: "accent",
        onPress: ()=>{
            _setWidths(savedCols);
            setRenderKey(Math.random());
        }
    }, "Restore Cols"), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", null, "Current saved column state: ", "{", Array.from(savedCols).map(([key, entry])=>`${key} => ${entry}`).join(","), "}"), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        key: renderKey
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableView), {
        "aria-label": "Table with resizable columns",
        onResize: setWidths,
        ...otherProps
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableHeader), {
        columns: cols
    }, (column)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Column), {
            ...column,
            key: column.uid,
            width: widths.get(column.uid),
            allowsResizing: true
        }, column.name)), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableBody), {
        items: rows
    }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Row), null, (key)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, item[key]))))));
}

},{"@react-spectrum/button":"jZWyP","../":"kHBRW","react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"18I2f":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CRUDExample", ()=>CRUDExample);
var _button = require("@react-spectrum/button");
var _actiongroup = require("@react-spectrum/actiongroup");
var _add = require("@spectrum-icons/workflow/Add");
var _addDefault = parcelHelpers.interopDefault(_add);
var _dialog = require("@react-spectrum/dialog");
var _buttongroup = require("@react-spectrum/buttongroup");
var _ = require("../");
var _view = require("@react-spectrum/view");
var _delete = require("@spectrum-icons/workflow/Delete");
var _deleteDefault = parcelHelpers.interopDefault(_delete);
var _divider = require("@react-spectrum/divider");
var _layout = require("@react-spectrum/layout");
var _form = require("@react-spectrum/form");
var _text = require("@react-spectrum/text");
var _illustratedmessage = require("@react-spectrum/illustratedmessage");
var _menu = require("@react-spectrum/menu");
var _more = require("@spectrum-icons/workflow/More");
var _moreDefault = parcelHelpers.interopDefault(_more);
var _noSearchResults = require("@spectrum-icons/illustrations/NoSearchResults");
var _noSearchResultsDefault = parcelHelpers.interopDefault(_noSearchResults);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _textfield = require("@react-spectrum/textfield");
var _data = require("@react-stately/data");
function CRUDExample(props) {
    let list = (0, _data.useListData)({
        initialItems: [
            {
                id: 1,
                firstName: "Sam",
                lastName: "Smith",
                birthday: "May 3"
            },
            {
                id: 2,
                firstName: "Julia",
                lastName: "Jones",
                birthday: "February 10"
            }
        ]
    });
    let [dialog, setDialog] = (0, _react.useState)(null);
    let createItem = (item)=>{
        list.prepend({
            ...item,
            id: Date.now()
        });
    };
    let selectedCount = list.selectedKeys === "all" ? list.items.length : list.selectedKeys.size;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
        direction: "column"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _actiongroup.ActionGroup), {
        marginBottom: 8,
        onAction: (action)=>setDialog({
                action
            })
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _menu.Item), {
        key: "add",
        "aria-label": "Add item"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _addDefault.default), null)), selectedCount > 0 && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _menu.Item), {
        key: "bulk-delete",
        "aria-label": "Delete selected items"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _deleteDefault.default), null))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableView), {
        "aria-label": "People",
        width: 500,
        height: 300,
        selectionMode: "multiple",
        ...props,
        selectedKeys: list.selectedKeys,
        onSelectionChange: list.setSelectedKeys,
        renderEmptyState: list.items.length === 0 ? ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement(EmptyState, null) : undefined
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableHeader), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Column), {
        isRowHeader: true,
        key: "firstName"
    }, "First Name"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Column), {
        isRowHeader: true,
        key: "lastName"
    }, "Last Name"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Column), {
        key: "birthday"
    }, "Birthday"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Column), {
        key: "actions",
        align: "end"
    }, "Actions")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableBody), {
        items: list.items
    }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Row), null, (column)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, column === "actions" ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _menu.MenuTrigger), {
                align: "end"
            }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), {
                isQuiet: true,
                "aria-label": "Actions"
            }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _moreDefault.default), null)), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _menu.Menu), {
                onAction: (action)=>setDialog({
                        action,
                        item
                    })
            }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _menu.Item), {
                key: "edit"
            }, "Edit..."), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _menu.Item), {
                key: "delete"
            }, "Delete..."))) : item[column])))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _dialog.DialogContainer), {
        onDismiss: ()=>setDialog(null)
    }, (dialog === null || dialog === void 0 ? void 0 : dialog.action) === "add" && /*#__PURE__*/ (0, _reactDefault.default).createElement(EditDialog, {
        item: null,
        onConfirm: createItem
    }), (dialog === null || dialog === void 0 ? void 0 : dialog.action) === "edit" && /*#__PURE__*/ (0, _reactDefault.default).createElement(EditDialog, {
        item: dialog.item,
        onConfirm: (item)=>list.update(dialog.item.id, item)
    }), (dialog === null || dialog === void 0 ? void 0 : dialog.action) === "delete" && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _dialog.AlertDialog), {
        title: "Delete",
        variant: "destructive",
        primaryActionLabel: "Delete",
        onPrimaryAction: ()=>{
            // Add delay so that dialog closes and restores focus
            // to the TableView before removing the row.
            setTimeout(()=>list.remove(dialog.item.id), list.items.length === 1 ? 0 : 60);
        }
    }, "Are you sure you want to delete ", dialog.item.firstName, " ", dialog.item.lastName, "?"), (dialog === null || dialog === void 0 ? void 0 : dialog.action) === "bulk-delete" && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _dialog.AlertDialog), {
        title: "Delete",
        variant: "destructive",
        primaryActionLabel: "Delete",
        onPrimaryAction: ()=>list.removeSelectedItems()
    }, "Are you sure you want to delete ", selectedCount === 1 ? "1 item" : `${selectedCount} items`, "?")));
}
function EditDialog({ item, onConfirm }) {
    let dialog = (0, _dialog.useDialogContainer)();
    let [state, setState] = (0, _react.useState)({
        firstName: "",
        lastName: "",
        birthday: "",
        ...item
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _dialog.Dialog), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Heading), null, !item ? "Create item" : "Edit item"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _divider.Divider), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Content), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _form.Form), {
        labelPosition: "side",
        width: "100%"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textfield.TextField), {
        autoFocus: true,
        label: "First Name",
        value: state.firstName,
        onChange: (firstName)=>setState({
                ...state,
                firstName
            })
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textfield.TextField), {
        label: "Last Name",
        value: state.lastName,
        onChange: (lastName)=>setState({
                ...state,
                lastName
            })
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textfield.TextField), {
        label: "Birthday",
        value: state.birthday,
        onChange: (birthday)=>setState({
                ...state,
                birthday
            })
    }))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _buttongroup.ButtonGroup), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.Button), {
        variant: "secondary",
        onPress: dialog.dismiss
    }, "Cancel"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.Button), {
        variant: "cta",
        onPress: ()=>{
            dialog.dismiss();
            onConfirm(state);
        }
    }, !item ? "Create" : "Save")));
}
function EmptyState() {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _illustratedmessage.IllustratedMessage), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _noSearchResultsDefault.default), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Heading), null, "No results"));
}

},{"@react-spectrum/button":"jZWyP","@react-spectrum/actiongroup":"hkqBV","@spectrum-icons/workflow/Add":"evYih","@react-spectrum/dialog":"3G0HV","@react-spectrum/buttongroup":"anP11","../":"kHBRW","@react-spectrum/view":"dnRjt","@spectrum-icons/workflow/Delete":"foJ71","@react-spectrum/divider":"dxmqN","@react-spectrum/layout":"hzaUY","@react-spectrum/form":"bGDqA","@react-spectrum/text":"etCGI","@react-spectrum/illustratedmessage":"cV05z","@react-spectrum/menu":"asqy4","@spectrum-icons/workflow/More":"khbPp","@spectrum-icons/illustrations/NoSearchResults":"2nDIV","react":"9yzVZ","@react-spectrum/textfield":"hOmtq","@react-stately/data":"gEgJM","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"iuXbw":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HidingColumns", ()=>HidingColumns);
var _ = require("../");
var _checkbox = require("@react-spectrum/checkbox");
var _layout = require("@react-spectrum/layout");
var _form = require("@react-spectrum/form");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
let columns = [
    {
        key: "planName",
        title: "Plan Name"
    },
    {
        key: "audienceType",
        title: "Audience Type"
    },
    {
        key: "netBudget",
        title: "Net Budget"
    },
    {
        key: "targetOTP",
        title: "Target OTP"
    },
    {
        key: "reach",
        title: "Reach"
    }
];
let data = [
    {
        id: 1,
        planName: "Plan 1: $300k, digital",
        audienceType: "Strategic",
        netBudget: "$300,000",
        targetOTP: "7.4%",
        reach: "11.52%"
    },
    {
        id: 2,
        planName: "Plan 2: $500k, digital",
        audienceType: "Strategic",
        netBudget: "$500,000",
        targetOTP: "22.5%",
        reach: "11.5%"
    },
    {
        id: 3,
        planName: "Plan 3: $800k, digital",
        audienceType: "Strategic",
        netBudget: "$800,000",
        targetOTP: "22.5%",
        reach: "11.5%"
    },
    {
        id: 4,
        planName: "Plan 4: $300k, MRI",
        audienceType: "Demo+strategic",
        netBudget: "$300,000",
        targetOTP: "22.5%",
        reach: "11.5%"
    },
    {
        id: 5,
        planName: "Plan 5: $500k, MRI",
        audienceType: "Demo+strategic",
        netBudget: "$500,000",
        targetOTP: "22.5%",
        reach: "11.5%"
    },
    {
        id: 6,
        planName: "Plan 6: $800k, MRI",
        audienceType: "Demo+strategic",
        netBudget: "$800,000",
        targetOTP: "22.5%",
        reach: "11.5%"
    }
];
function HidingColumns(props) {
    let [visibleColumns, setVisibleColumns] = (0, _reactDefault.default).useState(new Set(columns.map((c)=>c.key)));
    let toggleColumn = (key)=>{
        let columns = new Set(visibleColumns);
        if (columns.has(key)) columns.delete(key);
        else columns.add(key);
        setVisibleColumns(columns);
    };
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _form.Form), null, columns.slice(1).map((c)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _checkbox.Checkbox), {
            key: c.key,
            isSelected: visibleColumns.has(c.key),
            onChange: ()=>toggleColumn(c.key)
        }, c.title))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableView), {
        "aria-label": "Table with hideable columns",
        width: 900,
        height: 500,
        selectionMode: "single",
        ...props
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableHeader), {
        columns: columns.filter((c)=>visibleColumns.has(c.key))
    }, (column)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Column), null, column.title)), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableBody), {
        items: data
    }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Row), null, (key)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, item[key])))));
}

},{"../":"kHBRW","@react-spectrum/checkbox":"1r19j","@react-spectrum/layout":"hzaUY","@react-spectrum/form":"bGDqA","react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"cJPii":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HidingColumnsAllowsResizing", ()=>HidingColumnsAllowsResizing);
var _ = require("../");
var _checkbox = require("@react-spectrum/checkbox");
var _layout = require("@react-spectrum/layout");
var _form = require("@react-spectrum/form");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
let columns = [
    {
        key: "planName",
        title: "Plan Name"
    },
    {
        key: "audienceType",
        title: "Audience Type",
        allowsResizing: true
    },
    {
        key: "netBudget",
        title: "Net Budget",
        allowsResizing: true
    },
    {
        key: "targetOTP",
        title: "Target OTP"
    },
    {
        key: "reach",
        title: "Reach"
    }
];
let data = [
    {
        id: 1,
        planName: "Plan 1: $300k, digital",
        audienceType: "Strategic",
        netBudget: "$300,000",
        targetOTP: "7.4%",
        reach: "11.52%"
    },
    {
        id: 2,
        planName: "Plan 2: $500k, digital",
        audienceType: "Strategic",
        netBudget: "$500,000",
        targetOTP: "22.5%",
        reach: "11.5%"
    },
    {
        id: 3,
        planName: "Plan 3: $800k, digital",
        audienceType: "Strategic",
        netBudget: "$800,000",
        targetOTP: "22.5%",
        reach: "11.5%"
    },
    {
        id: 4,
        planName: "Plan 4: $300k, MRI",
        audienceType: "Demo+strategic",
        netBudget: "$300,000",
        targetOTP: "22.5%",
        reach: "11.5%"
    },
    {
        id: 5,
        planName: "Plan 5: $500k, MRI",
        audienceType: "Demo+strategic",
        netBudget: "$500,000",
        targetOTP: "22.5%",
        reach: "11.5%"
    },
    {
        id: 6,
        planName: "Plan 6: $800k, MRI",
        audienceType: "Demo+strategic",
        netBudget: "$800,000",
        targetOTP: "22.5%",
        reach: "11.5%"
    }
];
function HidingColumnsAllowsResizing(props) {
    let [visibleColumns, setVisibleColumns] = (0, _reactDefault.default).useState(new Set(columns.map((c)=>c.key)));
    let toggleColumn = (key)=>{
        let columns = new Set(visibleColumns);
        if (columns.has(key)) columns.delete(key);
        else columns.add(key);
        setVisibleColumns(columns);
    };
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _form.Form), null, columns.slice(1).map((c)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _checkbox.Checkbox), {
            key: c.key,
            isSelected: visibleColumns.has(c.key),
            onChange: ()=>toggleColumn(c.key)
        }, c.title))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableView), {
        "aria-label": "Table with hideable columns",
        width: 900,
        height: 500,
        ...props
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableHeader), {
        columns: columns.filter((c)=>visibleColumns.has(c.key))
    }, (column)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Column), {
            allowsResizing: column.allowsResizing
        }, column.title)), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableBody), {
        items: data
    }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Row), null, (key)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, item[key])))));
}

},{"../":"kHBRW","@react-spectrum/checkbox":"1r19j","@react-spectrum/layout":"hzaUY","@react-spectrum/form":"bGDqA","react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"7aGpT":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DragOutOfTable", ()=>DragOutOfTable);
parcelHelpers.export(exports, "DragOutOfTableWithoutTableHeader", ()=>DragOutOfTableWithoutTableHeader);
parcelHelpers.export(exports, "CustomDragPreview", ()=>CustomDragPreview);
parcelHelpers.export(exports, "DragWithinTable", ()=>DragWithinTable);
parcelHelpers.export(exports, "DragOntoRow", ()=>DragOntoRow);
parcelHelpers.export(exports, "DragBetweenTables", ()=>DragBetweenTables);
parcelHelpers.export(exports, "DragBetweenTablesRootOnly", ()=>DragBetweenTablesRootOnly);
parcelHelpers.export(exports, "DraggableRowsCopyLink", ()=>DraggableRowsCopyLink);
var _addonActions = require("@storybook/addon-actions");
var _tableStories = require("./Table.stories");
var _tableStoriesDefault = parcelHelpers.interopDefault(_tableStories);
var _divider = require("@react-spectrum/divider");
var _tableDnDExamples = require("./TableDnDExamples");
var _dndStories = require("../../../@react-aria/dnd/stories/dnd.stories");
var _layout = require("@react-spectrum/layout");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _view = require("@react-spectrum/view");
exports.default = {
    ...(0, _tableStoriesDefault.default),
    title: "TableView/Drag and Drop"
};
const DragOutOfTable = {
    args: {
        disabledKeys: [
            "Foo 2"
        ]
    },
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
            direction: "row",
            wrap: true,
            alignItems: "center",
            gap: "size-200"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _dndStories.Droppable), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _tableDnDExamples.DragExample), {
            dragHookOptions: {
                onDragStart: (0, _addonActions.action)("dragStart"),
                onDragEnd: (0, _addonActions.action)("dragEnd")
            },
            tableViewProps: args
        })),
    name: "Drag out of table"
};
const DragOutOfTableWithoutTableHeader = {
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
            direction: "row",
            wrap: true,
            alignItems: "center",
            gap: "size-200"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _dndStories.Droppable), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _tableDnDExamples.DragWithoutRowHeaderExample), {
            dragHookOptions: {
                onDragStart: (0, _addonActions.action)("dragStart"),
                onDragEnd: (0, _addonActions.action)("dragEnd")
            },
            tableViewProps: args
        })),
    name: "Drag out of table without table header"
};
const CustomDragPreview = {
    args: {
        disabledKeys: [
            "Foo 2"
        ]
    },
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
            direction: "row",
            wrap: true,
            alignItems: "center",
            gap: "size-200"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _dndStories.Droppable), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _tableDnDExamples.DragExample), {
            dragHookOptions: {
                onDragStart: (0, _addonActions.action)("dragStart"),
                onDragEnd: (0, _addonActions.action)("dragEnd"),
                renderPreview: (keys, draggedKey)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.View), {
                        backgroundColor: "gray-50",
                        padding: "size-100",
                        borderRadius: "medium",
                        borderWidth: "thin",
                        borderColor: "blue-500"
                    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("strong", null, "Custom Preview"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _divider.Divider), {
                        size: "S"
                    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", null, "Keys: [", [
                        ...keys
                    ].join(", "), "]"), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", null, "Dragged: ", draggedKey))
            },
            tableViewProps: args
        })),
    storyName: "Custom drag preview"
};
const DragWithinTable = {
    args: {
        disabledKeys: [
            "Foo 2"
        ]
    },
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
            direction: "row",
            wrap: true,
            alignItems: "center"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _tableDnDExamples.ReorderExample), {
            tableViewProps: args,
            onDrop: (0, _addonActions.action)("drop"),
            onDragStart: (0, _addonActions.action)("dragStart"),
            onDragEnd: (0, _addonActions.action)("dragEnd")
        })),
    name: "Drag within table (Reorder)"
};
const DragOntoRow = {
    args: {
        disabledKeys: [
            "1"
        ]
    },
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
            direction: "row",
            wrap: true,
            alignItems: "center"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _tableDnDExamples.DragOntoRowExample), {
            tableViewProps: args
        })),
    name: "Drag onto row",
    parameters: {
        description: {
            data: "Drag item types onto folder types."
        }
    }
};
const DragBetweenTables = {
    args: {
        disabledKeys: [
            "2",
            "8"
        ]
    },
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
            direction: "row",
            wrap: true,
            alignItems: "center"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _tableDnDExamples.DragBetweenTablesExample), args)),
    name: "Drag between tables"
};
const DragBetweenTablesRootOnly = {
    args: {
        disabledKeys: [
            "2",
            "8"
        ]
    },
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
            direction: "row",
            wrap: true,
            alignItems: "center"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _tableDnDExamples.DragBetweenTablesRootOnlyExample), {
            tableViewProps: args
        })),
    name: "Drag between tables (Root only)"
};
const DraggableRowsCopyLink = {
    args: {
        disabledKeys: [
            "Foo 2"
        ]
    },
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
            direction: "row",
            wrap: true,
            alignItems: "center"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _dndStories.Droppable), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _tableDnDExamples.DragExample), {
            tableViewProps: {
                onAction: (0, _addonActions.action)("onAction"),
                ...args
            },
            dragHookOptions: {
                onDragStart: (0, _addonActions.action)("dragStart"),
                onDragEnd: (0, _addonActions.action)("dragEnd"),
                getAllowedDropOperations: ()=>{
                    getAllowedDropOperationsAction();
                    return [
                        "copy",
                        "link",
                        "cancel"
                    ];
                }
            }
        })),
    name: "draggable rows, allow copy and link",
    parameters: {
        description: {
            data: "Allows copy, link, and cancel operations. Copy should be the default operation, and link should be the operation when the CTRL key is held while dragging."
        }
    }
};
let getAllowedDropOperationsAction = (0, _addonActions.action)("getAllowedDropOperationsAction");

},{"@storybook/addon-actions":"coXbW","./Table.stories":"70C9Q","@react-spectrum/divider":"dxmqN","./TableDnDExamples":"l7v3X","../../../@react-aria/dnd/stories/dnd.stories":"6aNDQ","@react-spectrum/layout":"hzaUY","react":"9yzVZ","@react-spectrum/view":"dnRjt","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"l7v3X":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DragExample", ()=>DragExample);
parcelHelpers.export(exports, "DragWithoutRowHeaderExample", ()=>DragWithoutRowHeaderExample);
parcelHelpers.export(exports, "ReorderExample", ()=>ReorderExample);
parcelHelpers.export(exports, "DragOntoRowExample", ()=>DragOntoRowExample);
parcelHelpers.export(exports, "DragBetweenTablesExample", ()=>DragBetweenTablesExample);
parcelHelpers.export(exports, "DragBetweenTablesRootOnlyExample", ()=>DragBetweenTablesRootOnlyExample);
var _addonActions = require("@storybook/addon-actions");
var _ = require("../");
var _utils = require("@react-aria/utils");
var _layout = require("@react-spectrum/layout");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _text = require("@react-spectrum/text");
var _dnd = require("@react-spectrum/dnd");
var _data = require("@react-stately/data");
let onSelectionChange = (0, _addonActions.action)("onSelectionChange");
let columns = [
    {
        name: "First name",
        key: "first_name",
        isRowHeader: true
    },
    {
        name: "Last name",
        key: "last_name",
        isRowHeader: true
    },
    {
        name: "Email",
        key: "email"
    },
    {
        name: "Department",
        key: "department"
    },
    {
        name: "Job Title",
        key: "job_title"
    },
    {
        name: "IP Address",
        key: "ip_address"
    }
];
let columnsWithOutRowHeader = [
    {
        name: "First name",
        key: "first_name"
    },
    {
        name: "Last name",
        key: "last_name"
    },
    {
        name: "Email",
        key: "email"
    },
    {
        name: "Department",
        key: "department"
    },
    {
        name: "Job Title",
        key: "job_title"
    },
    {
        name: "IP Address",
        key: "ip_address"
    }
];
let items = [
    {
        id: "a",
        first_name: "Vin",
        last_name: "Charlet",
        email: "vcharlet0@123-reg.co.uk",
        ip_address: "18.45.175.130",
        department: "Services",
        job_title: "Analog Circuit Design manager"
    },
    {
        id: "b",
        first_name: "Lexy",
        last_name: "Maddison",
        email: "lmaddison1@xinhuanet.com",
        ip_address: "238.210.151.48",
        department: "Research and Development",
        job_title: "Analog Circuit Design manager"
    },
    {
        id: "c",
        first_name: "Robbi",
        last_name: "Persence",
        email: "rpersence2@hud.gov",
        ip_address: "130.2.120.99",
        department: "Business Development",
        job_title: "Analog Circuit Design manager"
    },
    {
        id: "d",
        first_name: "Dodie",
        last_name: "Hurworth",
        email: "dhurworth3@webs.com",
        ip_address: "235.183.154.184",
        department: "Training",
        job_title: "Account Coordinator"
    },
    {
        id: "e",
        first_name: "Audrye",
        last_name: "Hember",
        email: "ahember4@blogtalkradio.com",
        ip_address: "136.25.192.37",
        department: "Legal",
        job_title: "Operator"
    },
    {
        id: "f",
        first_name: "Beau",
        last_name: "Oller",
        email: "boller5@nytimes.com",
        ip_address: "93.111.22.12",
        department: "Business Development",
        job_title: "Speech Pathologist"
    },
    {
        id: "g",
        first_name: "Roarke",
        last_name: "Gration",
        email: "rgration6@purevolume.com",
        ip_address: "234.221.23.241",
        department: "Product Management",
        job_title: "Electrical Engineer"
    },
    {
        id: "h",
        first_name: "Cathy",
        last_name: "Lishman",
        email: "clishman7@constantcontact.com",
        ip_address: "181.158.213.202",
        department: "Research and Development",
        job_title: "Assistant Professor"
    },
    {
        id: "i",
        first_name: "Enrika",
        last_name: "Soitoux",
        email: "esoitoux8@google.com.hk",
        ip_address: "51.244.20.173",
        department: "Support",
        job_title: "Teacher"
    },
    {
        id: "j",
        first_name: "Aloise",
        last_name: "Tuxsell",
        email: "atuxsell9@jigsy.com",
        ip_address: "253.46.84.168",
        department: "Training",
        job_title: "Financial Advisor"
    }
];
let getAllowedDropOperationsAction = (0, _addonActions.action)("getAllowedDropOperationsAction");
function DragExample(props) {
    let { tableViewProps, dragHookOptions } = props;
    let getItems = (keys)=>[
            ...keys
        ].map((key)=>{
            let item = items.find((item)=>item.id === key);
            return {
                "text/plain": `${item.first_name} ${item.last_name}`
            };
        });
    let { dragAndDropHooks } = (0, _dnd.useDragAndDrop)({
        getItems,
        getAllowedDropOperations () {
            getAllowedDropOperationsAction();
            return [
                "move",
                "cancel"
            ];
        },
        ...dragHookOptions
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableView), {
        "aria-label": "TableView with dragging enabled",
        selectionMode: "multiple",
        width: 400,
        height: 300,
        onSelectionChange: (s)=>onSelectionChange([
                ...s
            ]),
        dragAndDropHooks: dragAndDropHooks,
        ...tableViewProps
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableHeader), {
        columns: columns
    }, (column)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Column), {
            minWidth: 100,
            isRowHeader: column.isRowHeader
        }, column.name)), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableBody), {
        items: items
    }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Row), null, (key)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, item[key]))));
}
function DragWithoutRowHeaderExample(props) {
    let { tableViewProps, dragHookOptions } = props;
    let getItems = (keys)=>[
            ...keys
        ].map((key)=>{
            let item = items.find((item)=>item.id === key);
            return {
                "text/plain": `${item.first_name} ${item.last_name}`
            };
        });
    let { dragAndDropHooks } = (0, _dnd.useDragAndDrop)({
        getItems,
        getAllowedDropOperations () {
            getAllowedDropOperationsAction();
            return [
                "move",
                "cancel"
            ];
        },
        ...dragHookOptions
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableView), {
        "aria-label": "TableView with dragging enabled",
        selectionMode: "multiple",
        width: 400,
        height: 300,
        onSelectionChange: (s)=>onSelectionChange([
                ...s
            ]),
        dragAndDropHooks: dragAndDropHooks,
        ...tableViewProps
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableHeader), {
        columns: columnsWithOutRowHeader
    }, (column)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Column), {
            minWidth: 100
        }, column.name)), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableBody), {
        items: items
    }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Row), null, (key)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, item[key]))));
}
function ReorderExample(props) {
    let { onDrop, onDragStart, onDragEnd, tableViewProps } = props;
    let list = (0, _data.useListData)({
        initialItems: items,
        getKey: (item)=>item.id
    });
    // Use a random drag type so the items can only be reordered within this table and not dragged elsewhere.
    let dragType = (0, _reactDefault.default).useMemo(()=>`keys-${Math.random().toString(36).slice(2)}`, []);
    let onMove = (keys, target)=>{
        if (target.dropPosition === "before") list.moveBefore(target.key, keys);
        else list.moveAfter(target.key, keys);
    };
    let { dragAndDropHooks } = (0, _dnd.useDragAndDrop)({
        getItems (keys) {
            return [
                ...keys
            ].map((key)=>{
                key = JSON.stringify(key);
                return {
                    [dragType]: key,
                    "text/plain": key
                };
            });
        },
        getAllowedDropOperations () {
            getAllowedDropOperationsAction();
            return [
                "move",
                "cancel"
            ];
        },
        onDragStart: onDragStart,
        onDragEnd: onDragEnd,
        async onDrop (e) {
            onDrop(e);
            if (e.target.type !== "root" && e.target.dropPosition !== "on") {
                let keys = [];
                for (let item of e.items)if (item.kind === "text") {
                    let key;
                    if (item.types.has(dragType)) {
                        key = JSON.parse(await item.getText(dragType));
                        keys.push(key);
                    } else if (item.types.has("text/plain")) {
                        // Fallback for Chrome Android case: https://bugs.chromium.org/p/chromium/issues/detail?id=1293803
                        // Multiple drag items are contained in a single string so we need to split them out
                        key = await item.getText("text/plain");
                        keys = key.split("\n").map((val)=>val.replaceAll('"', ""));
                    }
                }
                onMove(keys, e.target);
            }
        },
        getDropOperation (target) {
            if (target.type === "root" || target.dropPosition === "on") return "cancel";
            return "move";
        }
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableView), {
        "aria-label": "Reorderable TableView",
        selectionMode: "multiple",
        width: 400,
        height: 300,
        dragAndDropHooks: dragAndDropHooks,
        ...tableViewProps
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableHeader), {
        columns: columns
    }, (column)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Column), {
            minWidth: 100,
            isRowHeader: column.isRowHeader
        }, column.name)), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableBody), {
        items: list.items
    }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Row), null, (key)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, item[key]))));
}
function DragOntoRowExample(props) {
    let { tableViewProps = {}, dragHookOptions = {}, dropHookOptions = {} } = props;
    let { onDragStart, onDragEnd } = dragHookOptions;
    let { onDrop } = dropHookOptions;
    let onDropAction = (0, _utils.chain)((0, _addonActions.action)("onDrop"), onDrop);
    let getAllowedDropOperationsAction = (0, _addonActions.action)("getAllowedDropOperations");
    let columns = [
        {
            name: "ID",
            key: "id",
            width: 50
        },
        {
            name: "Type",
            key: "type",
            width: 100
        },
        {
            name: "Name",
            key: "name",
            width: 200
        },
        {
            name: "Child Items",
            key: "childNodes",
            width: 250
        }
    ];
    let list = (0, _data.useListData)({
        initialItems: [
            {
                id: "0",
                type: "folder",
                name: "Folder 1",
                childNodes: []
            },
            {
                id: "1",
                type: "item",
                name: "One"
            },
            {
                id: "2",
                type: "item",
                name: "Two"
            },
            {
                id: "3",
                type: "item",
                name: "Three"
            },
            {
                id: "4",
                type: "item",
                name: "Four"
            },
            {
                id: "5",
                type: "item",
                name: "Five"
            },
            {
                id: "6",
                type: "item",
                name: "Six"
            },
            {
                id: "7",
                type: "folder",
                name: "Folder (disabled)",
                childNodes: []
            },
            {
                id: "8",
                type: "folder",
                name: "Folder 2",
                childNodes: []
            }
        ]
    });
    let disabledKeys = [
        "2",
        "7"
    ];
    // Use a random drag type so the items can only be reordered within this list and not dragged elsewhere.
    let dragType = (0, _reactDefault.default).useMemo(()=>`keys-${Math.random().toString(36).slice(2)}`, []);
    let onMove = (keys, target)=>{
        let folderItem = list.getItem(target.key);
        let draggedItems = keys.map((key)=>list.getItem(key));
        list.update(target.key, {
            ...folderItem,
            childNodes: [
                ...folderItem.childNodes,
                ...draggedItems
            ]
        });
        list.remove(...keys);
    };
    let { dragAndDropHooks } = (0, _dnd.useDragAndDrop)({
        getItems (keys) {
            return [
                ...keys
            ].map((key)=>{
                key = JSON.stringify(key);
                return {
                    [dragType]: key,
                    "text/plain": key
                };
            });
        },
        getAllowedDropOperations () {
            getAllowedDropOperationsAction();
            return [
                "move",
                "cancel"
            ];
        },
        onDragStart: (0, _utils.chain)((0, _addonActions.action)("dragStart"), onDragStart),
        onDragEnd: (0, _utils.chain)((0, _addonActions.action)("dragEnd"), onDragEnd),
        onDrop: async (e)=>{
            onDropAction(e);
            if (e.target.type !== "root" && e.target.dropPosition === "on") {
                let keys = [];
                for (let item of e.items)if (item.kind === "text") {
                    let key;
                    if (item.types.has(dragType)) {
                        key = JSON.parse(await item.getText(dragType));
                        keys.push(key);
                    } else if (item.types.has("text/plain")) {
                        // Fallback for Chrome Android case: https://bugs.chromium.org/p/chromium/issues/detail?id=1293803
                        // Multiple drag items are contained in a single string so we need to split them out
                        key = await item.getText("text/plain");
                        keys = key.split("\n").map((val)=>val.replaceAll('"', ""));
                    }
                }
                if (!keys.includes(e.target.key)) onMove(keys, e.target);
            }
        },
        getDropOperation (target) {
            var _list_getItem;
            if (target.type === "root" || target.dropPosition !== "on" || !((_list_getItem = list.getItem(target.key)) === null || _list_getItem === void 0 ? void 0 : _list_getItem.childNodes) || disabledKeys.includes(target.key)) return "cancel";
            return "move";
        }
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableView), {
        "aria-label": "Drag onto table row example",
        selectionMode: "multiple",
        disabledKeys: disabledKeys,
        dragAndDropHooks: dragAndDropHooks,
        ...tableViewProps
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableHeader), {
        columns: columns
    }, (column)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Column), {
            minWidth: column.width,
            isRowHeader: column.key === "name"
        }, column.name)), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableBody), {
        items: list.items
    }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Row), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, item.id), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, item.type), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, item.name), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, item.type === "folder" ? `${item.childNodes.length} dropped items` : "-"))));
}
let itemList1 = [
    {
        id: "1",
        type: "item",
        name: "Item One"
    },
    {
        id: "2",
        type: "item",
        name: "Item Two"
    },
    {
        id: "3",
        type: "item",
        name: "Item Three"
    },
    {
        id: "4",
        type: "item",
        name: "Item Four"
    },
    {
        id: "5",
        type: "item",
        name: "Item Five"
    },
    {
        id: "6",
        type: "item",
        name: "Item Six"
    }
];
let itemList2 = [
    {
        id: "7",
        type: "item",
        name: "Item Seven"
    },
    {
        id: "8",
        type: "item",
        name: "Item Eight"
    },
    {
        id: "9",
        type: "item",
        name: "Item Nine"
    },
    {
        id: "10",
        type: "item",
        name: "Item Ten"
    },
    {
        id: "11",
        type: "item",
        name: "Item Eleven"
    },
    {
        id: "12",
        type: "item",
        name: "Item Twelve"
    }
];
let itemColumns = [
    {
        name: "ID",
        key: "id"
    },
    {
        name: "Type",
        key: "type"
    },
    {
        name: "Name",
        key: "name"
    }
];
function DragBetweenTablesExample(props) {
    let { onDragStart, onDragEnd, onDrop } = props;
    let onDropAction = (0, _utils.chain)((0, _addonActions.action)("onDrop"), onDrop);
    onDragStart = (0, _utils.chain)((0, _addonActions.action)("dragStart"), onDragStart);
    onDragEnd = (0, _utils.chain)((0, _addonActions.action)("dragEnd"), onDragEnd);
    let list1 = (0, _data.useListData)({
        initialItems: props.items1 || itemList1
    });
    let list2 = (0, _data.useListData)({
        initialItems: props.items2 || itemList2
    });
    let onMove = (keys, target)=>{
        let sourceList = list1.getItem(keys[0]) ? list1 : list2;
        let destinationList = list1.getItem(target.key) ? list1 : list2;
        if (sourceList === destinationList) {
            // Handle dragging within same list
            if (target.dropPosition === "before") sourceList.moveBefore(target.key, keys);
            else sourceList.moveAfter(target.key, keys);
        } else {
            // Handle dragging between lists
            if (target.dropPosition === "before") destinationList.insertBefore(target.key, ...keys.map((key)=>sourceList.getItem(key)));
            else destinationList.insertAfter(target.key, ...keys.map((key)=>sourceList.getItem(key)));
            sourceList.remove(...keys);
        }
    };
    // Use a random drag type so the items can only be reordered within the two lists and not dragged elsewhere.
    let dragType = (0, _reactDefault.default).useMemo(()=>`keys-${Math.random().toString(36).slice(2)}`, []);
    let { dragAndDropHooks } = (0, _dnd.useDragAndDrop)({
        getItems (keys) {
            return [
                ...keys
            ].map((key)=>{
                key = JSON.stringify(key);
                return {
                    [dragType]: key,
                    "text/plain": key
                };
            });
        },
        getAllowedDropOperations () {
            getAllowedDropOperationsAction();
            return [
                "move",
                "cancel"
            ];
        },
        onDragStart,
        onDragEnd,
        onDrop: async (e)=>{
            onDropAction(e);
            if (e.target.type !== "root" && e.target.dropPosition !== "on") {
                let keys = [];
                for (let item of e.items)if (item.kind === "text") {
                    let key;
                    if (item.types.has(dragType)) {
                        key = JSON.parse(await item.getText(dragType));
                        keys.push(key);
                    } else if (item.types.has("text/plain")) {
                        // Fallback for Chrome Android case: https://bugs.chromium.org/p/chromium/issues/detail?id=1293803
                        // Multiple drag items are contained in a single string so we need to split them out
                        key = await item.getText("text/plain");
                        keys = key.split("\n").map((val)=>val.replaceAll('"', ""));
                    }
                }
                onMove(keys, e.target);
            }
        },
        getDropOperation (target) {
            if (target.type === "root" || target.dropPosition === "on") return "cancel";
            return "move";
        }
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
        direction: "column",
        margin: "size-100"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), {
        alignSelf: "center"
    }, "Table 1"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableView), {
        "aria-label": "First TableView",
        selectionMode: "multiple",
        width: 400,
        dragAndDropHooks: dragAndDropHooks,
        ...props
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableHeader), {
        columns: itemColumns
    }, (column)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Column), {
            minWidth: 100,
            isRowHeader: column.key === "name"
        }, column.name)), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableBody), {
        items: list1.items
    }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Row), null, (key)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, item[key]))))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
        direction: "column",
        margin: "size-100"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), {
        alignSelf: "center"
    }, "Table 2"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableView), {
        "aria-label": "Second TableView",
        selectionMode: "multiple",
        width: 400,
        dragAndDropHooks: dragAndDropHooks,
        ...props
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableHeader), {
        columns: itemColumns
    }, (column)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Column), {
            minWidth: 100,
            isRowHeader: column.key === "name"
        }, column.name)), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableBody), {
        items: list2.items
    }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Row), null, (key)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, item[key]))))));
}
function DragBetweenTablesRootOnlyExample(props) {
    let { tableViewProps = {}, dragHookOptions = {}, dropHookOptions = {} } = props;
    let { onDragStart, onDragEnd } = dragHookOptions;
    let { onDrop } = dropHookOptions;
    let onDropAction = (0, _utils.chain)((0, _addonActions.action)("onDrop"), onDrop);
    let list1 = (0, _data.useListData)({
        initialItems: props.items1 || itemList1
    });
    let list2 = (0, _data.useListData)({
        initialItems: props.items2 || itemList2
    });
    let onMove = (keys, destinationList)=>{
        let sourceList = list1.getItem(keys[0]) ? list1 : list2;
        let items = keys.map((key)=>sourceList.getItem(key));
        sourceList.remove(...keys);
        destinationList.append(...items);
    };
    let { dragAndDropHooks: dragAndDropHooksFirst } = (0, _dnd.useDragAndDrop)({
        getItems (keys) {
            return [
                ...keys
            ].map((key)=>{
                key = JSON.stringify(key);
                return {
                    "list1": key,
                    "text/plain": key
                };
            });
        },
        getAllowedDropOperations () {
            getAllowedDropOperationsAction();
            return [
                "move",
                "cancel"
            ];
        },
        onDragStart: (0, _utils.chain)((0, _addonActions.action)("dragStart"), onDragStart),
        onDragEnd: (0, _utils.chain)((0, _addonActions.action)("dragEnd"), onDragEnd),
        onDrop: async (e)=>{
            onDropAction(e);
            if (e.target.type === "root") {
                let keys = [];
                for (let item of e.items)if (item.kind === "text") {
                    let key;
                    if (item.types.has("list2")) {
                        key = JSON.parse(await item.getText("list2"));
                        keys.push(key);
                    } else if (item.types.has("text/plain")) {
                        // Fallback for Chrome Android case: https://bugs.chromium.org/p/chromium/issues/detail?id=1293803
                        // Multiple drag items are contained in a single string so we need to split them out
                        key = await item.getText("text/plain");
                        keys = key.split("\n").map((val)=>val.replaceAll('"', ""));
                    }
                }
                onMove(keys, list1);
            }
        },
        getDropOperation (target, types) {
            if (target.type === "root" && (types.has("list2") || types.has("text/plain"))) return "move";
            return "cancel";
        }
    });
    let { dragAndDropHooks: dragAndDropHooksSecond } = (0, _dnd.useDragAndDrop)({
        getItems (keys) {
            return [
                ...keys
            ].map((key)=>{
                key = JSON.stringify(key);
                return {
                    "list2": key,
                    "text/plain": key
                };
            });
        },
        getAllowedDropOperations () {
            getAllowedDropOperationsAction();
            return [
                "move",
                "cancel"
            ];
        },
        onDragStart: (0, _utils.chain)((0, _addonActions.action)("dragStart"), onDragStart),
        onDragEnd: (0, _utils.chain)((0, _addonActions.action)("dragEnd"), onDragEnd),
        onDrop: async (e)=>{
            onDropAction(e);
            if (e.target.type === "root") {
                let keys = [];
                for (let item of e.items)if (item.kind === "text") {
                    let key;
                    if (item.types.has("list1")) {
                        key = JSON.parse(await item.getText("list1"));
                        keys.push(key);
                    } else if (item.types.has("text/plain")) {
                        // Fallback for Chrome Android case: https://bugs.chromium.org/p/chromium/issues/detail?id=1293803
                        // Multiple drag items are contained in a single string so we need to split them out
                        key = await item.getText("text/plain");
                        keys = key.split("\n").map((val)=>val.replaceAll('"', ""));
                    }
                }
                onMove(keys, list2);
            }
        },
        getDropOperation (target, types) {
            if (target.type === "root" && (types.has("list1") || types.has("text/plain"))) return "move";
            return "cancel";
        }
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
        direction: "column",
        margin: "size-100"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), {
        alignSelf: "center"
    }, "Table 1"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableView), {
        "aria-label": "First TableView",
        selectionMode: "multiple",
        width: 400,
        dragAndDropHooks: dragAndDropHooksFirst,
        ...tableViewProps
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableHeader), {
        columns: itemColumns
    }, (column)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Column), {
            minWidth: 100,
            isRowHeader: column.key === "name"
        }, column.name)), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableBody), {
        items: list1.items
    }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Row), null, (key)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, item[key]))))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
        direction: "column",
        margin: "size-100"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), {
        alignSelf: "center"
    }, "Table 2"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableView), {
        "aria-label": "Second TableView",
        selectionMode: "multiple",
        width: 400,
        dragAndDropHooks: dragAndDropHooksSecond,
        ...tableViewProps
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableHeader), {
        columns: itemColumns
    }, (column)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Column), {
            minWidth: 100,
            isRowHeader: column.key === "name"
        }, column.name)), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableBody), {
        items: list2.items
    }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Row), null, (key)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, item[key]))))));
}

},{"@storybook/addon-actions":"coXbW","../":"kHBRW","@react-aria/utils":"9cLk5","@react-spectrum/layout":"hzaUY","react":"9yzVZ","@react-spectrum/text":"etCGI","@react-spectrum/dnd":"cHWGH","@react-stately/data":"gEgJM","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"du7S9":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DragOutOfTable", ()=>DragOutOfTable);
parcelHelpers.export(exports, "DragWithinTable", ()=>DragWithinTable);
parcelHelpers.export(exports, "DragOntoRow", ()=>DragOntoRow);
parcelHelpers.export(exports, "DropOntoRoot", ()=>DropOntoRoot);
parcelHelpers.export(exports, "DropBetweenRows", ()=>DropBetweenRows);
parcelHelpers.export(exports, "AllowsDirectoriesAndFilesFromFinder", ()=>AllowsDirectoriesAndFilesFromFinder);
parcelHelpers.export(exports, "ComplexDragBetweenTables", ()=>ComplexDragBetweenTables);
parcelHelpers.export(exports, "UsingGetDropOperations", ()=>UsingGetDropOperations);
parcelHelpers.export(exports, "OverrideUtilHandlers", ()=>OverrideUtilHandlers);
var _addonActions = require("@storybook/addon-actions");
var _tableStories = require("./Table.stories");
var _tableStoriesDefault = parcelHelpers.interopDefault(_tableStories);
var _tableDnDUtilExamples = require("./TableDnDUtilExamples");
var _dndStories = require("../../../@react-aria/dnd/stories/dnd.stories");
var _layout = require("@react-spectrum/layout");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
exports.default = {
    ...(0, _tableStoriesDefault.default),
    title: "TableView/Drag and Drop/Util Handlers"
};
const DragOutOfTable = {
    args: {
        disabledKeys: [
            "2"
        ]
    },
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
            direction: "row",
            wrap: true,
            alignItems: "center"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _dndStories.Droppable), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _tableDnDUtilExamples.DragExampleUtilHandlers), {
            tableViewProps: args,
            dndOptions: {
                onDragStart: (0, _addonActions.action)("dragStart"),
                onDragEnd: (0, _addonActions.action)("dragEnd")
            }
        })),
    name: "drag out of table"
};
const DragWithinTable = {
    args: {
        disabledKeys: [
            "2"
        ]
    },
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _tableDnDUtilExamples.ReorderExampleUtilHandlers), {
            tableViewProps: args,
            dndOptions: {
                onDragStart: (0, _addonActions.action)("dragStart"),
                onDragEnd: (0, _addonActions.action)("dragEnd")
            }
        }),
    name: "drag within table (reorder)"
};
const DragOntoRow = {
    args: {
        disabledKeys: [
            "2"
        ]
    },
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _tableDnDUtilExamples.ItemDropExampleUtilHandlers), {
            tableViewProps: args,
            dndOptions: {
                onDragStart: (0, _addonActions.action)("dragStart"),
                onDragEnd: (0, _addonActions.action)("dragEnd")
            }
        }),
    name: "drop onto row/folder",
    parameters: {
        description: {
            data: "Allows dropping on items and folders. Dropping on a item is a no op (action fires still). Dropping external items is also a no op"
        }
    }
};
const DropOntoRoot = {
    args: {
        disabledKeys: [
            "2",
            "8"
        ]
    },
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
            direction: "row",
            wrap: true,
            alignItems: "center"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _tableDnDUtilExamples.RootDropExampleUtilHandlers), {
            tableViewProps: args,
            firstTableDnDOptions: {
                onDragStart: (0, _addonActions.action)("dragStart")
            }
        })),
    name: "drop onto root",
    parameters: {
        description: {
            data: "Allows one way dragging from first table to root of second table. Copy and link operations shouldnt remove items from the first table"
        }
    }
};
const DropBetweenRows = {
    args: {
        disabledKeys: [
            "2",
            "8"
        ]
    },
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _tableDnDUtilExamples.InsertExampleUtilHandlers), {
            tableViewProps: args,
            firstTableDnDOptions: {
                onDragStart: (0, _addonActions.action)("dragStart")
            }
        }),
    name: "drop between rows",
    parameters: {
        description: {
            data: "Allows one way dragging from first table to between items of second table. Copy and link operations shouldnt remove items from the first table"
        }
    }
};
const AllowsDirectoriesAndFilesFromFinder = {
    args: {
        disabledKeys: [
            "2",
            "8"
        ]
    },
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
            direction: "row",
            wrap: true,
            alignItems: "center"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _tableDnDUtilExamples.FinderDropUtilHandlers), {
            tableViewProps: args
        })),
    name: "allows directories and files from finder",
    parameters: {
        description: {
            data: "The first table should allow only directory drops (e.g. folders from finder). The second table should allow all drag type drops (directory/files from finder, any drag items)."
        }
    }
};
const ComplexDragBetweenTables = {
    args: {
        disabledKeys: [
            "2",
            "8"
        ]
    },
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _tableDnDUtilExamples.DragBetweenTablesComplex), {
            tableViewProps: args,
            firstTableDnDOptions: {
                onDragStart: (0, _addonActions.action)("dragStartTable1")
            },
            secondTableDnDOptions: {
                onDragStart: (0, _addonActions.action)("dragStartTable2")
            }
        }),
    name: "complex drag between tables",
    parameters: {
        description: {
            data: "The first table should allow dragging and drops into its folder, but disallow reorder operations. External root drops should be placed at the end of the list. The second table should allow all operations and root drops should be placed at the top of the table. Move and copy operations are allowed. The invalid drag item should be able to be dropped in either table if accompanied by other valid drag items."
        }
    }
};
const UsingGetDropOperations = {
    args: {
        disabledKeys: [
            "2",
            "8"
        ]
    },
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _tableDnDUtilExamples.DragBetweenTablesComplex), {
            tableViewProps: args,
            firstTableDnDOptions: {
                onDragStart: (0, _addonActions.action)("dragStartTable1"),
                getDropOperation: (_, __, allowedOperations)=>allowedOperations.filter((op)=>op !== "move")[0],
                getAllowedDropOperations: ()=>[
                        "link"
                    ]
            },
            secondTableDnDOptions: {
                onDragStart: (0, _addonActions.action)("dragStartTable2"),
                getDropOperation: (_, __, allowedOperations)=>allowedOperations.filter((op)=>op !== "move")[0],
                getAllowedDropOperations: ()=>[
                        "move",
                        "copy",
                        "link"
                    ]
            }
        }),
    name: "using getDropOperations to determine default drop operation",
    parameters: {
        description: {
            data: "Dragging from the first to the second table should automatically set a link operation and all other drop operations should be disabled. Dragging from the second to first table should support copy and link operations, with copy being the default."
        }
    }
};
const OverrideUtilHandlers = {
    args: {
        disabledKeys: [
            "2",
            "8"
        ]
    },
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _tableDnDUtilExamples.DragBetweenTablesOverride), args),
    name: "util handlers overridden by onDrop and getDropOperations",
    parameters: {
        description: {
            data: "The first table should be draggable, the second table should only be root droppable. No actions for onRootDrop, onReorder, onItemDrop, or onInsert should appear in the storybook actions panel."
        }
    }
};

},{"@storybook/addon-actions":"coXbW","./Table.stories":"70C9Q","./TableDnDUtilExamples":"ayFa2","../../../@react-aria/dnd/stories/dnd.stories":"6aNDQ","@react-spectrum/layout":"hzaUY","react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"ayFa2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DragExampleUtilHandlers", ()=>DragExampleUtilHandlers);
parcelHelpers.export(exports, "ReorderExampleUtilHandlers", ()=>ReorderExampleUtilHandlers);
parcelHelpers.export(exports, "ItemDropExampleUtilHandlers", ()=>ItemDropExampleUtilHandlers);
parcelHelpers.export(exports, "RootDropExampleUtilHandlers", ()=>RootDropExampleUtilHandlers);
parcelHelpers.export(exports, "InsertExampleUtilHandlers", ()=>InsertExampleUtilHandlers);
parcelHelpers.export(exports, "FinderDropUtilHandlers", ()=>FinderDropUtilHandlers);
parcelHelpers.export(exports, "DragBetweenTablesComplex", ()=>DragBetweenTablesComplex);
parcelHelpers.export(exports, "DragBetweenTablesOverride", ()=>DragBetweenTablesOverride);
var _addonActions = require("@storybook/addon-actions");
var _ = require("..");
var _dnd = require("@react-spectrum/dnd");
var _layout = require("@react-spectrum/layout");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _text = require("@react-spectrum/text");
var _data = require("@react-stately/data");
let onSelectionChange = (0, _addonActions.action)("onSelectionChange");
let itemProcessor = async (items, acceptedDragTypes)=>{
    let processedItems = [];
    let text;
    for (let item of items)for (let type of acceptedDragTypes){
        if (item.kind === "text" && item.types.has(type)) {
            text = await item.getText(type);
            processedItems.push(JSON.parse(text));
            break;
        } else if (item.types.size === 1 && item.types.has("text/plain")) {
            // Fallback for Chrome Android case: https://bugs.chromium.org/p/chromium/issues/detail?id=1293803
            // Multiple drag items are contained in a single string so we need to split them out
            text = await item.getText("text/plain");
            processedItems = text.split("\n").map((val)=>JSON.parse(val));
            break;
        }
    }
    return processedItems;
};
let folderList1 = [
    {
        identifier: "1",
        type: "file",
        name: "Adobe Photoshop"
    },
    {
        identifier: "2",
        type: "file",
        name: "Adobe XD"
    },
    {
        identifier: "3",
        type: "folder",
        name: "Documents",
        childNodes: []
    },
    {
        identifier: "4",
        type: "file",
        name: "Adobe InDesign"
    },
    {
        identifier: "5",
        type: "folder",
        name: "Utilities",
        childNodes: []
    },
    {
        identifier: "6",
        type: "file",
        name: "Adobe AfterEffects"
    }
];
let folderList2 = [
    {
        identifier: "7",
        type: "folder",
        name: "Pictures",
        childNodes: []
    },
    {
        identifier: "8",
        type: "file",
        name: "Adobe Fresco"
    },
    {
        identifier: "9",
        type: "folder",
        name: "Apps",
        childNodes: []
    },
    {
        identifier: "10",
        type: "file",
        name: "Adobe Illustrator"
    },
    {
        identifier: "11",
        type: "file",
        name: "Adobe Lightroom"
    },
    {
        identifier: "12",
        type: "file",
        name: "Adobe Dreamweaver"
    },
    {
        identifier: "13",
        type: "unique_type",
        name: "invalid drag item"
    }
];
let columns = [
    {
        name: "ID",
        key: "identifier"
    },
    {
        name: "Name",
        key: "name"
    },
    {
        name: "Type",
        key: "type"
    }
];
function DragExampleUtilHandlers(props) {
    let { tableViewProps, dndOptions } = props;
    let list = (0, _data.useListData)({
        initialItems: folderList1,
        getKey: (item)=>item.identifier
    });
    let acceptedDragTypes = [
        "file",
        "folder",
        "text/plain"
    ];
    let { dragAndDropHooks } = (0, _dnd.useDragAndDrop)({
        getItems: (keys)=>[
                ...keys
            ].map((key)=>{
                let item = list.getItem(key);
                return {
                    [`${item.type}`]: JSON.stringify(item),
                    "text/plain": JSON.stringify(item)
                };
            }),
        acceptedDragTypes,
        ...dndOptions
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableView), {
        "aria-label": "TableView with dnd util handlers",
        selectionMode: "multiple",
        width: 400,
        height: 200,
        onSelectionChange: (s)=>onSelectionChange([
                ...s
            ]),
        dragAndDropHooks: dragAndDropHooks,
        ...tableViewProps
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableHeader), {
        columns: columns
    }, (column)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Column), {
            isRowHeader: column.key === "name"
        }, column.name)), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableBody), {
        items: list.items
    }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Row), {
            key: item.identifier
        }, (key)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, item[key]))));
}
function ReorderExampleUtilHandlers(props) {
    let { tableViewProps, dndOptions } = props;
    let list = (0, _data.useListData)({
        initialItems: folderList1,
        getKey: (item)=>item.identifier
    });
    let acceptedDragTypes = [
        "file",
        "folder",
        "text/plain"
    ];
    let { dragAndDropHooks } = (0, _dnd.useDragAndDrop)({
        getItems: (keys)=>[
                ...keys
            ].map((key)=>{
                let item = list.getItem(key);
                return {
                    [`${item.type}`]: JSON.stringify(item),
                    "text/plain": JSON.stringify(item)
                };
            }),
        onReorder: async (e)=>{
            let { keys, target, dropOperation } = e;
            (0, _addonActions.action)("onReorder")(e);
            let itemsToCopy = [];
            if (dropOperation === "copy") for (let key of keys){
                let item = {
                    ...list.getItem(key)
                };
                item.identifier = Math.random().toString(36).slice(2);
                itemsToCopy.push(item);
            }
            if (target.dropPosition === "before") {
                if (dropOperation === "move") list.moveBefore(target.key, [
                    ...keys
                ]);
                else if (dropOperation === "copy") list.insertBefore(target.key, ...itemsToCopy);
            } else if (target.dropPosition === "after") {
                if (dropOperation === "move") list.moveAfter(target.key, [
                    ...keys
                ]);
                else if (dropOperation === "copy") list.insertAfter(target.key, ...itemsToCopy);
            }
        },
        acceptedDragTypes,
        ...dndOptions
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableView), {
        "aria-label": "Reorderable TableView with util handlers",
        selectionMode: "multiple",
        width: 400,
        height: 200,
        onSelectionChange: (s)=>onSelectionChange([
                ...s
            ]),
        dragAndDropHooks: dragAndDropHooks,
        ...tableViewProps
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableHeader), {
        columns: columns
    }, (column)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Column), {
            isRowHeader: column.key === "name"
        }, column.name)), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableBody), {
        items: list.items
    }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Row), {
            key: item.identifier
        }, (key)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, item[key]))));
}
function ItemDropExampleUtilHandlers(props) {
    let { tableViewProps, dndOptions } = props;
    let list = (0, _data.useListData)({
        initialItems: folderList1,
        getKey: (item)=>item.identifier
    });
    let acceptedDragTypes = [
        "file",
        "folder",
        "text/plain"
    ];
    let { dragAndDropHooks } = (0, _dnd.useDragAndDrop)({
        getItems: (keys)=>[
                ...keys
            ].map((key)=>{
                let item = list.getItem(key);
                return {
                    [`${item.type}`]: JSON.stringify(item),
                    "text/plain": JSON.stringify(item)
                };
            }),
        onItemDrop: async (e)=>{
            let { items, target, isInternal, dropOperation } = e;
            (0, _addonActions.action)("onItemDrop")(e);
            if (isInternal) {
                let processedItems = await itemProcessor(items, acceptedDragTypes);
                let targetItem = list.getItem(target.key);
                if ((targetItem === null || targetItem === void 0 ? void 0 : targetItem.childNodes) != null) {
                    list.update(target.key, {
                        ...targetItem,
                        childNodes: [
                            ...targetItem.childNodes,
                            ...processedItems
                        ]
                    });
                    if (isInternal && dropOperation === "move") {
                        let keysToRemove = processedItems.map((item)=>item.identifier);
                        list.remove(...keysToRemove);
                    }
                }
            }
        },
        acceptedDragTypes,
        ...dndOptions
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableView), {
        "aria-label": "Row droppable TableView from dnd hook util handlers",
        selectionMode: "multiple",
        width: 400,
        height: 200,
        onSelectionChange: (s)=>onSelectionChange([
                ...s
            ]),
        dragAndDropHooks: dragAndDropHooks,
        ...tableViewProps
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableHeader), {
        columns: columns
    }, (column)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Column), {
            isRowHeader: column.key === "name"
        }, column.name)), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableBody), {
        items: list.items
    }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Row), {
            key: item.identifier
        }, (key)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, item[key]))));
}
function RootDropExampleUtilHandlers(props) {
    let { tableViewProps, firstTableDnDOptions, secondTableDnDOptions } = props;
    let list1 = (0, _data.useListData)({
        initialItems: folderList1,
        getKey: (item)=>item.identifier
    });
    let list2 = (0, _data.useListData)({
        initialItems: folderList2,
        getKey: (item)=>item.identifier
    });
    let acceptedDragTypes = [
        "file",
        "folder",
        "text/plain"
    ];
    let { dragAndDropHooks: table1Hooks } = (0, _dnd.useDragAndDrop)({
        getItems: (keys)=>[
                ...keys
            ].map((key)=>{
                let item = list1.getItem(key);
                return {
                    [`${item.type}`]: JSON.stringify(item),
                    "text/plain": JSON.stringify(item)
                };
            }),
        onDragEnd: (e)=>{
            let { dropOperation, isInternal, keys } = e;
            (0, _addonActions.action)("onDragEnd")(e);
            if (dropOperation === "move" && !isInternal) list1.remove(...keys);
        },
        acceptedDragTypes,
        ...firstTableDnDOptions
    });
    let { dragAndDropHooks: table2Hooks } = (0, _dnd.useDragAndDrop)({
        onRootDrop: async (e)=>{
            (0, _addonActions.action)("onRootDropTable1")(e);
            let processedItems = await itemProcessor(e.items, acceptedDragTypes);
            list2.append(...processedItems);
        },
        acceptedDragTypes,
        ...secondTableDnDOptions
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
        direction: "column",
        margin: "size-100"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), {
        alignSelf: "center"
    }, "Table 1"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableView), {
        "aria-label": "First TableView",
        selectionMode: "multiple",
        width: 300,
        dragAndDropHooks: table1Hooks,
        ...tableViewProps
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableHeader), {
        columns: columns
    }, (column)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Column), {
            isRowHeader: column.key === "name"
        }, column.name)), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableBody), {
        items: list1.items
    }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Row), {
            key: item.identifier
        }, (key)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, item[key]))))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
        direction: "column",
        margin: "size-100"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), {
        alignSelf: "center"
    }, "Table 2"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableView), {
        "aria-label": "Second TableView",
        selectionMode: "multiple",
        width: 300,
        dragAndDropHooks: table2Hooks,
        ...tableViewProps
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableHeader), {
        columns: columns
    }, (column)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Column), {
            isRowHeader: column.key === "name"
        }, column.name)), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableBody), {
        items: list2.items
    }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Row), {
            key: item.identifier
        }, (key)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, item[key]))))));
}
function InsertExampleUtilHandlers(props) {
    let { tableViewProps, firstTableDnDOptions, secondTableDnDOptions } = props;
    let list1 = (0, _data.useListData)({
        initialItems: folderList1,
        getKey: (item)=>item.identifier
    });
    let list2 = (0, _data.useListData)({
        initialItems: folderList2,
        getKey: (item)=>item.identifier
    });
    let acceptedDragTypes = [
        "file",
        "folder",
        "text/plain"
    ];
    let { dragAndDropHooks: table1Hooks } = (0, _dnd.useDragAndDrop)({
        getItems: (keys)=>[
                ...keys
            ].map((key)=>{
                let item = list1.getItem(key);
                return {
                    [`${item.type}`]: JSON.stringify(item),
                    "text/plain": JSON.stringify(item)
                };
            }),
        onDragEnd: (e)=>{
            let { dropOperation, isInternal, keys } = e;
            (0, _addonActions.action)("onDragEnd")(e);
            if (dropOperation === "move" && !isInternal) list1.remove(...keys);
        },
        acceptedDragTypes,
        ...firstTableDnDOptions
    });
    let { dragAndDropHooks: table2Hooks } = (0, _dnd.useDragAndDrop)({
        onInsert: async (e)=>{
            let { items, target } = e;
            (0, _addonActions.action)("onInsertTable2")(e);
            let processedItems = await itemProcessor(items, acceptedDragTypes);
            if (target.dropPosition === "before") list2.insertBefore(target.key, ...processedItems);
            else if (target.dropPosition === "after") list2.insertAfter(target.key, ...processedItems);
        },
        acceptedDragTypes,
        ...secondTableDnDOptions
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
        direction: "column",
        margin: "size-100"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), {
        alignSelf: "center"
    }, "Table 1"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableView), {
        "aria-label": "First TableView",
        selectionMode: "multiple",
        width: 300,
        dragAndDropHooks: table1Hooks,
        ...tableViewProps
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableHeader), {
        columns: columns
    }, (column)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Column), {
            isRowHeader: column.key === "name"
        }, column.name)), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableBody), {
        items: list1.items
    }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Row), {
            key: item.identifier
        }, (key)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, item[key]))))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
        direction: "column",
        margin: "size-100"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), {
        alignSelf: "center"
    }, "Table 2"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableView), {
        "aria-label": "Second TableView",
        selectionMode: "multiple",
        width: 300,
        dragAndDropHooks: table2Hooks,
        ...tableViewProps
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableHeader), {
        columns: columns
    }, (column)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Column), {
            isRowHeader: column.key === "name"
        }, column.name)), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableBody), {
        items: list2.items
    }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Row), {
            key: item.identifier
        }, (key)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, item[key]))))));
}
function FinderDropUtilHandlers(props) {
    let { tableViewProps, firstTableDnDOptions, secondTableDnDOptions } = props;
    let list1 = (0, _data.useListData)({
        initialItems: folderList1,
        getKey: (item)=>item.identifier
    });
    let list2 = (0, _data.useListData)({
        initialItems: folderList2,
        getKey: (item)=>item.identifier
    });
    let { dragAndDropHooks: table1Hooks } = (0, _dnd.useDragAndDrop)({
        acceptedDragTypes: [
            (0, _dnd.DIRECTORY_DRAG_TYPE)
        ],
        onInsert: async (e)=>{
            (0, _addonActions.action)("onInsertTable1")(e);
        },
        onItemDrop: async (e)=>{
            (0, _addonActions.action)("onItemDropTable1")(e);
        },
        ...firstTableDnDOptions
    });
    let { dragAndDropHooks: table2Hooks } = (0, _dnd.useDragAndDrop)({
        onInsert: async (e)=>{
            (0, _addonActions.action)("onInsertTable2")(e);
        },
        onItemDrop: async (e)=>{
            (0, _addonActions.action)("onItemDropTable2")(e);
        },
        acceptedDragTypes: "all",
        ...secondTableDnDOptions
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
        direction: "column",
        margin: "size-100"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), {
        alignSelf: "center"
    }, "Table 1"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableView), {
        "aria-label": "TableView that accepts directory drops only",
        selectionMode: "multiple",
        width: 300,
        dragAndDropHooks: table1Hooks,
        ...tableViewProps
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableHeader), {
        columns: columns
    }, (column)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Column), {
            isRowHeader: column.key === "name"
        }, column.name)), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableBody), {
        items: list1.items
    }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Row), {
            key: item.identifier
        }, (key)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, item[key]))))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
        direction: "column",
        margin: "size-100"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), {
        alignSelf: "center"
    }, "Table 2"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableView), {
        "aria-label": "TableView that accepts all drag types",
        selectionMode: "multiple",
        width: 300,
        dragAndDropHooks: table2Hooks,
        ...tableViewProps
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableHeader), {
        columns: columns
    }, (column)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Column), {
            isRowHeader: column.key === "name"
        }, column.name)), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableBody), {
        items: list2.items
    }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Row), {
            key: item.identifier
        }, (key)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, item[key]))))));
}
function DragBetweenTablesComplex(props) {
    let { tableViewProps, firstTableDnDOptions, secondTableDnDOptions } = props;
    let list1 = (0, _data.useListData)({
        initialItems: folderList1,
        getKey: (item)=>item.identifier
    });
    let list2 = (0, _data.useListData)({
        initialItems: folderList2,
        getKey: (item)=>item.identifier
    });
    let acceptedDragTypes = [
        "file",
        "folder",
        "text/plain"
    ];
    // table 1 should allow on item drops and external drops, but disallow reordering/internal drops
    let { dragAndDropHooks: dragAndDropHooksTable1 } = (0, _dnd.useDragAndDrop)({
        getItems: (keys)=>[
                ...keys
            ].map((key)=>{
                let item = list1.getItem(key);
                return {
                    [`${item.type}`]: JSON.stringify(item),
                    "text/plain": JSON.stringify(item)
                };
            }),
        onInsert: async (e)=>{
            let { items, target } = e;
            (0, _addonActions.action)("onInsertTable1")(e);
            let processedItems = await itemProcessor(items, acceptedDragTypes);
            if (target.dropPosition === "before") list1.insertBefore(target.key, ...processedItems);
            else if (target.dropPosition === "after") list1.insertAfter(target.key, ...processedItems);
        },
        onRootDrop: async (e)=>{
            (0, _addonActions.action)("onRootDropTable1")(e);
            let processedItems = await itemProcessor(e.items, acceptedDragTypes);
            list1.append(...processedItems);
        },
        onItemDrop: async (e)=>{
            let { items, target, isInternal, dropOperation } = e;
            (0, _addonActions.action)("onItemDropTable1")(e);
            let processedItems = await itemProcessor(items, acceptedDragTypes);
            let targetItem = list1.getItem(target.key);
            list1.update(target.key, {
                ...targetItem,
                childNodes: [
                    ...targetItem.childNodes,
                    ...processedItems
                ]
            });
            if (isInternal && dropOperation === "move") {
                // TODO test this, perhaps it would be easier to also pass the draggedKeys to onItemDrop instead?
                // TODO: dig into other libraries to see how they handle this
                let keysToRemove = processedItems.map((item)=>item.identifier);
                list1.remove(...keysToRemove);
            }
        },
        acceptedDragTypes,
        onDragEnd: (e)=>{
            let { dropOperation, isInternal, keys } = e;
            (0, _addonActions.action)("onDragEndTable1")(e);
            if (dropOperation === "move" && !isInternal) list1.remove(...keys);
        },
        getAllowedDropOperations: ()=>[
                "move",
                "copy"
            ],
        shouldAcceptItemDrop: (target)=>{
            var _list1_getItem;
            return !!((_list1_getItem = list1.getItem(target.key)) === null || _list1_getItem === void 0 ? void 0 : _list1_getItem.childNodes);
        },
        ...firstTableDnDOptions
    });
    // table 2 should allow reordering, on folder drops, and on root drops
    let { dragAndDropHooks: dragAndDropHooksTable2 } = (0, _dnd.useDragAndDrop)({
        getItems: (keys)=>[
                ...keys
            ].map((key)=>{
                let item = list2.getItem(key);
                let dragItem = {};
                let itemString = JSON.stringify(item);
                dragItem[`${item.type}`] = itemString;
                if (item.type !== "unique_type") dragItem["text/plain"] = itemString;
                return dragItem;
            }),
        onInsert: async (e)=>{
            let { items, target } = e;
            (0, _addonActions.action)("onInsertTable2")(e);
            let processedItems = await itemProcessor(items, acceptedDragTypes);
            if (target.dropPosition === "before") list2.insertBefore(target.key, ...processedItems);
            else if (target.dropPosition === "after") list2.insertAfter(target.key, ...processedItems);
        },
        onReorder: async (e)=>{
            let { keys, target, dropOperation } = e;
            (0, _addonActions.action)("onReorderTable2")(e);
            let itemsToCopy = [];
            if (dropOperation === "copy") for (let key of keys){
                let item = {
                    ...list2.getItem(key)
                };
                item.identifier = Math.random().toString(36).slice(2);
                itemsToCopy.push(item);
            }
            if (target.dropPosition === "before") {
                if (dropOperation === "move") list2.moveBefore(target.key, [
                    ...keys
                ]);
                else if (dropOperation === "copy") list2.insertBefore(target.key, ...itemsToCopy);
            } else if (target.dropPosition === "after") {
                if (dropOperation === "move") list2.moveAfter(target.key, [
                    ...keys
                ]);
                else if (dropOperation === "copy") list2.insertAfter(target.key, ...itemsToCopy);
            }
        },
        onRootDrop: async (e)=>{
            (0, _addonActions.action)("onRootDropTable2")(e);
            let processedItems = await itemProcessor(e.items, acceptedDragTypes);
            list2.prepend(...processedItems);
        },
        onItemDrop: async (e)=>{
            let { items, target, isInternal, dropOperation } = e;
            (0, _addonActions.action)("onItemDropTable2")(e);
            let processedItems = await itemProcessor(items, acceptedDragTypes);
            let targetItem = list2.getItem(target.key);
            list2.update(target.key, {
                ...targetItem,
                childNodes: [
                    ...targetItem.childNodes,
                    ...processedItems
                ]
            });
            if (isInternal && dropOperation === "move") {
                let keysToRemove = processedItems.map((item)=>item.identifier);
                list2.remove(...keysToRemove);
            }
        },
        acceptedDragTypes,
        onDragEnd: (e)=>{
            let { dropOperation, isInternal, keys } = e;
            (0, _addonActions.action)("onDragEndTable2")(e);
            if (dropOperation === "move" && !isInternal) {
                let keysToRemove = [
                    ...keys
                ].filter((key)=>list2.getItem(key).type !== "unique_type");
                list2.remove(...keysToRemove);
            }
        },
        getAllowedDropOperations: ()=>[
                "move",
                "copy"
            ],
        shouldAcceptItemDrop: (target)=>{
            var _list2_getItem;
            return !!((_list2_getItem = list2.getItem(target.key)) === null || _list2_getItem === void 0 ? void 0 : _list2_getItem.childNodes);
        },
        ...secondTableDnDOptions
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
        direction: "column",
        margin: "size-100"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), {
        alignSelf: "center"
    }, "Table 1"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableView), {
        "aria-label": "First TableView in drag between table example",
        selectionMode: "multiple",
        width: 300,
        dragAndDropHooks: dragAndDropHooksTable1,
        ...tableViewProps
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableHeader), {
        columns: columns
    }, (column)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Column), {
            isRowHeader: column.key === "name"
        }, column.name)), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableBody), {
        items: list1.items
    }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Row), {
            key: item.identifier
        }, (key)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, item[key]))))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
        direction: "column",
        margin: "size-100"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), {
        alignSelf: "center"
    }, "Table 2"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableView), {
        "aria-label": "Second TableView in drag between table example",
        selectionMode: "multiple",
        width: 300,
        dragAndDropHooks: dragAndDropHooksTable2,
        ...tableViewProps
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableHeader), {
        columns: columns
    }, (column)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Column), {
            isRowHeader: column.key === "name"
        }, column.name)), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableBody), {
        items: list2.items
    }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Row), {
            key: item.identifier
        }, (key)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, item[key]))))));
}
function DragBetweenTablesOverride(props) {
    let list1 = (0, _data.useListData)({
        initialItems: [
            {
                identifier: "1",
                type: "file",
                name: "Adobe Photoshop"
            },
            {
                identifier: "2",
                type: "file",
                name: "Adobe XD"
            },
            {
                identifier: "3",
                type: "file",
                name: "Adobe InDesign"
            },
            {
                identifier: "4",
                type: "file",
                name: "Adobe AfterEffects"
            }
        ],
        getKey: (item)=>item.identifier
    });
    let list2 = (0, _data.useListData)({
        initialItems: [
            {
                identifier: "7",
                type: "folder",
                name: "Pictures",
                childNodes: []
            },
            {
                identifier: "8",
                type: "file",
                name: "Adobe Fresco"
            },
            {
                identifier: "9",
                type: "folder",
                name: "Apps",
                childNodes: []
            },
            {
                identifier: "10",
                type: "file",
                name: "Adobe Illustrator"
            },
            {
                identifier: "11",
                type: "file",
                name: "Adobe Lightroom"
            },
            {
                identifier: "12",
                type: "file",
                name: "Adobe Dreamweaver"
            }
        ],
        getKey: (item)=>item.identifier
    });
    let { dragAndDropHooks: dragAndDropHooksTable1 } = (0, _dnd.useDragAndDrop)({
        getItems: (keys)=>[
                ...keys
            ].map((key)=>{
                let item = list1.getItem(key);
                let dragType = `table-1-adobe-${item.type}`;
                return {
                    [`${dragType}`]: JSON.stringify(item),
                    "text/plain": JSON.stringify(item)
                };
            }),
        onDragEnd: (e)=>{
            (0, _addonActions.action)("onDragEnd")(e);
            if (e.dropOperation === "move") list1.remove(...e.keys);
        }
    });
    let { dragAndDropHooks: dragAndDropHooksTable2 } = (0, _dnd.useDragAndDrop)({
        getDropOperation: (target, types)=>{
            if (target.type !== "root" || !(types.has("table-1-adobe-file") || types.has("text/plain"))) return "cancel";
            return "move";
        },
        onDrop: async (e)=>{
            (0, _addonActions.action)("onDrop")(e);
            let { items } = e;
            let itemsToAdd = [];
            let text;
            for (let item of items)if (item.kind === "text") {
                if (item.types.size === 1 && item.types.has("text/plain")) {
                    text = await item.getText("text/plain");
                    itemsToAdd = text.split("\n").map((val)=>JSON.parse(val));
                } else {
                    text = await item.getText("table-1-adobe-file");
                    itemsToAdd.push(JSON.parse(text));
                }
            }
            list2.append(...itemsToAdd);
        },
        // the below utility handlers shouldn't be called because onDrop is defined
        // shouldAcceptItemDrop and acceptedDragTypes shouldn't affect the behavior either
        onInsert: ()=>(0, _addonActions.action)("onInsert"),
        onReorder: ()=>(0, _addonActions.action)("onReorder"),
        onRootDrop: ()=>(0, _addonActions.action)("onRootDrop"),
        onItemDrop: ()=>(0, _addonActions.action)("onItemDrop"),
        shouldAcceptItemDrop: (target)=>{
            var _list2_getItem;
            return !!((_list2_getItem = list2.getItem(target.key)) === null || _list2_getItem === void 0 ? void 0 : _list2_getItem.childNodes);
        },
        acceptedDragTypes: "all"
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
        direction: "column",
        margin: "size-100"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), {
        alignSelf: "center"
    }, "Table 1"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableView), {
        "aria-label": "TableView that accepts directory drops only",
        selectionMode: "multiple",
        width: 300,
        dragAndDropHooks: dragAndDropHooksTable1,
        ...props
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableHeader), {
        columns: columns
    }, (column)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Column), {
            isRowHeader: column.key === "name"
        }, column.name)), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableBody), {
        items: list1.items
    }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Row), {
            key: item.identifier
        }, (key)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, item[key]))))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
        direction: "column",
        margin: "size-100"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), {
        alignSelf: "center"
    }, "Table 2"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableView), {
        "aria-label": "TableView that accepts all drag types",
        selectionMode: "multiple",
        width: 300,
        dragAndDropHooks: dragAndDropHooksTable2,
        ...props
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableHeader), {
        columns: columns
    }, (column)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Column), {
            isRowHeader: column.key === "name"
        }, column.name)), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableBody), {
        items: list2.items
    }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Row), {
            key: item.identifier
        }, (key)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, item[key]))))));
}

},{"@storybook/addon-actions":"coXbW","..":"kHBRW","@react-spectrum/dnd":"cHWGH","@react-spectrum/layout":"hzaUY","react":"9yzVZ","@react-spectrum/text":"etCGI","@react-stately/data":"gEgJM","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"b56Ug":[function(require,module,exports) {
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StaticExpandableRows", ()=>StaticExpandableRows);
parcelHelpers.export(exports, "DynamicExpandableRowsStory", ()=>DynamicExpandableRowsStory);
parcelHelpers.export(exports, "UserSetRowHeader", ()=>UserSetRowHeader);
parcelHelpers.export(exports, "ManyExpandableRowsStory", ()=>ManyExpandableRowsStory);
parcelHelpers.export(exports, "EmptyTreeGridStory", ()=>EmptyTreeGridStory);
parcelHelpers.export(exports, "LoadingTreeGridStory", ()=>LoadingTreeGridStory);
parcelHelpers.export(exports, "NestedColumnsStory", ()=>NestedColumnsStory);
parcelHelpers.export(exports, "ResizableColumnsStory", ()=>ResizableColumnsStory);
var _addonActions = require("@storybook/addon-actions");
var _button = require("@react-spectrum/button");
var _ = require("../");
var _utils = require("@react-aria/utils");
var _tableStories = require("./Table.stories");
var _tableStoriesDefault = parcelHelpers.interopDefault(_tableStories);
var _flags = require("@react-stately/flags");
var _layout = require("@react-spectrum/layout");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
(0, _flags.enableTableNestedRows)();
exports.default = {
    ...(0, _tableStoriesDefault.default),
    title: "TableView/Expandable rows"
};
const StaticExpandableRows = {
    args: {
        "aria-label": "TableView with static expandable rows",
        width: 500,
        height: 200
    },
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableView), {
            UNSTABLE_defaultExpandedKeys: [
                "row 1"
            ],
            UNSTABLE_allowsExpandableRows: true,
            UNSTABLE_onExpandedChange: (0, _addonActions.action)("onExpandedChange"),
            ...args
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableHeader), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Column), {
            key: "foo"
        }, "Foo"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Column), {
            key: "bar"
        }, "Bar"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Column), {
            key: "baz"
        }, "Baz")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableBody), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Row), {
            key: "row 1"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, "Lvl 1 Foo 1"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, "Lvl 1 Bar 1"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, " Lvl 1 Baz 1"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Row), {
            key: "child row 1 level 2"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, "Lvl 2 Foo 1"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, "Lvl 2 Bar 1"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, "Lvl 2 Baz 1"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Row), {
            key: "child row 1 level 3"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, "Lvl 3 Foo 1"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, "Lvl 3 Bar 1"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, "Lvl 3 Baz 1"))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Row), {
            key: "child row 2 level 2"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, "Lvl 2 Foo 2"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, "Lvl 2 Bar 2"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, "Lvl 2 Baz 2"))))),
    name: "static with expandable rows"
};
let nestedItems = [
    {
        foo: "Lvl 1 Foo 1",
        bar: "Lvl 1 Bar 1",
        baz: "Lvl 1 Baz 1",
        childRows: [
            {
                foo: "Lvl 2 Foo 1",
                bar: "Lvl 2 Bar 1",
                baz: "Lvl 2 Baz 1",
                childRows: [
                    {
                        foo: "Lvl 3 Foo 1",
                        bar: "Lvl 3 Bar 1",
                        baz: "Lvl 3 Baz 1"
                    }
                ]
            },
            {
                foo: "Lvl 2 Foo 2",
                bar: "Lvl 2 Bar 2",
                baz: "Lvl 2 Baz 2"
            }
        ]
    }
];
function DynamicExpandableRows(props) {
    let [expandedKeys, setExpandedKeys] = (0, _react.useState)("all");
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
        direction: "column"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), {
        onPress: ()=>setExpandedKeys("all")
    }, "Expand all"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), {
        onPress: ()=>setExpandedKeys(new Set([]))
    }, "Collapse all"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), {
        onPress: ()=>setExpandedKeys(new Set([
                "Lvl 1 Foo 1"
            ]))
    }, "Set expanded to Lvl 1 Foo 1"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableView), {
        UNSTABLE_expandedKeys: expandedKeys,
        UNSTABLE_onExpandedChange: (0, _utils.chain)(setExpandedKeys, (0, _addonActions.action)("onExpandedChange")),
        UNSTABLE_allowsExpandableRows: true,
        ...props
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableHeader), {
        columns: (0, _tableStories.columns)
    }, (column)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Column), null, column.name)), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableBody), {
        items: nestedItems
    }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Row), {
            key: item.foo,
            UNSTABLE_childItems: item.childRows
        }, (key)=>{
            // Note: The "item" here will reflect the child Row's values from nestedItems
            return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, item[key]);
        }))));
}
const DynamicExpandableRowsStory = {
    args: {
        "aria-label": "TableView with dynamic expandable rows",
        width: 500,
        height: 400
    },
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(DynamicExpandableRows, args),
    name: "dynamic with expandable rows"
};
const UserSetRowHeader = {
    args: {
        "aria-label": "TableView with expandable rows and multiple row headers",
        width: 500,
        height: 400
    },
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableView), {
            UNSTABLE_allowsExpandableRows: true,
            UNSTABLE_onExpandedChange: (0, _addonActions.action)("onExpandedChange"),
            ...args
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableHeader), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Column), {
            key: "foo",
            allowsResizing: true
        }, "Foo"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Column), {
            isRowHeader: true,
            allowsResizing: true,
            key: "bar"
        }, "Bar"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Column), {
            isRowHeader: true,
            key: "baz",
            allowsResizing: true
        }, "Baz")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableBody), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Row), {
            key: "test"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, "Lvl 1 Foo 1"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, "Lvl 1 Bar 1"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, "Lvl 1 Baz 1"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Row), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, "Lvl 2 Foo 1"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, "Lvl 2 Bar 1"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, "Lvl 2 Baz 1"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Row), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, "Lvl 3 Foo 1"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, "Lvl 3 Bar 1"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, "Lvl 3 Baz 1"))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Row), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, "Lvl 2 Foo 2"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, "Lvl 2 Bar 2"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, "Lvl 2 Baz 2"))))),
    name: "multiple user set row headers",
    parameters: {
        description: {
            data: "Row headers are Bar and Baz column cells, chevron"
        }
    }
};
let manyRows = [];
function generateRow(lvlIndex, lvlLimit, rowIndex) {
    let row = {
        key: `Row ${rowIndex} Lvl ${lvlIndex}`
    };
    for (let col of (0, _tableStories.columns))row[col.key] = `Row ${rowIndex}, Lvl ${lvlIndex}, ${col.name}`;
    if (lvlIndex < lvlLimit) row["childRows"] = [
        generateRow(++lvlIndex, lvlLimit, rowIndex)
    ];
    return row;
}
for(let i = 1; i < 20; i++){
    let row = generateRow(1, 3, i);
    manyRows.push(row);
}
function ManyExpandableRows(props) {
    let { allowsResizing, showDivider, ...otherProps } = props;
    let [expandedKeys, setExpandedKeys] = (0, _react.useState)("all");
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
        direction: "column"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), {
        onPress: ()=>setExpandedKeys("all")
    }, "Expand all"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), {
        onPress: ()=>setExpandedKeys(new Set([]))
    }, "Collapse all"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableView), {
        UNSTABLE_expandedKeys: expandedKeys,
        UNSTABLE_onExpandedChange: (0, _utils.chain)(setExpandedKeys, (0, _addonActions.action)("onExpandedChange")),
        UNSTABLE_allowsExpandableRows: true,
        disabledKeys: [
            "Row 1 Lvl 2"
        ],
        ...otherProps
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableHeader), {
        columns: (0, _tableStories.columns)
    }, (column)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Column), {
            showDivider: showDivider,
            allowsResizing: allowsResizing
        }, column.name)), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableBody), {
        items: manyRows
    }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Row), {
            key: item.key,
            UNSTABLE_childItems: item.childRows
        }, (key)=>{
            return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, item[key]);
        }))));
}
const ManyExpandableRowsStory = {
    args: {
        "aria-label": "TableView with many dynamic expandable rows",
        width: 500,
        height: 400
    },
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(ManyExpandableRows, args),
    name: "many expandable rows"
};
const EmptyTreeGridStory = {
    args: {
        "aria-label": "TableView with empty state",
        width: 500,
        height: 400
    },
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _tableStories.EmptyStateTable), {
            UNSTABLE_allowsExpandableRows: true,
            selectionMode: "none",
            columns: (0, _tableStories.columns),
            items: manyRows,
            allowsSorting: false,
            onSortChange: null,
            sortDescriptor: null,
            ...args
        }),
    name: "empty state"
};
function LoadingStateTable(props) {
    let [show, setShow] = (0, _react.useState)(false);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
        direction: "column"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), {
        width: "100px",
        onPress: ()=>setShow((show)=>!show)
    }, "Toggle items"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableView), {
        UNSTABLE_allowsExpandableRows: true,
        "aria-label": "TableView with empty state",
        ...props
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableHeader), {
        columns: (0, _tableStories.columns)
    }, (column)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Column), null, column.name)), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableBody), {
        items: show ? manyRows : [],
        loadingState: "loadingMore"
    }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Row), {
            key: item.key,
            UNSTABLE_childItems: item.childRows
        }, (key)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, item[key])))));
}
const LoadingTreeGridStory = {
    args: {
        "aria-label": "TableView with loading",
        width: 500,
        height: 400
    },
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(LoadingStateTable, args),
    name: "isLoading"
};
const NestedColumnsStory = {
    args: {
        "aria-label": "TableView with nested columns",
        width: 500,
        height: 400
    },
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableView), {
            UNSTABLE_allowsExpandableRows: true,
            ...args
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableHeader), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Column), {
            title: "Blah"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Column), {
            title: "Group 1"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Column), {
            key: "foo"
        }, "Foo"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Column), {
            key: "bar"
        }, "Bar")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Column), {
            title: "Group 2"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Column), {
            key: "baz"
        }, "Baz")))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TableBody), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Row), {
            key: "row 1"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, "Lvl 1 Foo 1"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, "Lvl 1 Bar 1"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, " Lvl 1 Baz 1"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Row), {
            key: "child row 1 level 2"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, "Lvl 2 Foo 1"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, "Lvl 2 Bar 1"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, "Lvl 2 Baz 1"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Row), {
            key: "child row 1 level 3"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, "Lvl 3 Foo 1"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, "Lvl 3 Bar 1"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, "Lvl 3 Baz 1"))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Row), {
            key: "child row 2 level 2"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, "Lvl 2 Foo 2"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, "Lvl 2 Bar 2"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Cell), null, "Lvl 2 Baz 2"))))),
    name: "with nested columns"
};
const ResizableColumnsStory = {
    args: {
        "aria-label": "TableView with many dynamic expandable rows and resizable columns",
        width: 500,
        height: 400
    },
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(ManyExpandableRows, {
            allowsResizing: true,
            showDivider: true,
            ...args
        }),
    name: "resizable columns"
};

},{"@storybook/addon-actions":"coXbW","@react-spectrum/button":"jZWyP","../":"kHBRW","@react-aria/utils":"9cLk5","./Table.stories":"70C9Q","@react-stately/flags":"aEc5X","@react-spectrum/layout":"hzaUY","react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"cQXcQ":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Default", ()=>Default);
parcelHelpers.export(exports, "WithFalsyItemKey", ()=>WithFalsyItemKey);
parcelHelpers.export(exports, "DefaultSelectedKeyVal2", ()=>DefaultSelectedKeyVal2);
parcelHelpers.export(exports, "ControlledSelectedKeyVal3", ()=>ControlledSelectedKeyVal3);
parcelHelpers.export(exports, "OrientationVertical", ()=>OrientationVertical);
parcelHelpers.export(exports, "DensityCompact", ()=>DensityCompact);
parcelHelpers.export(exports, "IsQuiet", ()=>IsQuiet);
parcelHelpers.export(exports, "IsQuietDensityCompact", ()=>IsQuietDensityCompact);
parcelHelpers.export(exports, "DensityCompactOrientationVertical", ()=>DensityCompactOrientationVertical);
parcelHelpers.export(exports, "Icons", ()=>Icons);
parcelHelpers.export(exports, "IconsDensityCompact", ()=>IconsDensityCompact);
parcelHelpers.export(exports, "IconsOrientationVertical", ()=>IconsOrientationVertical);
parcelHelpers.export(exports, "IconsDensityCompactOrientationVertical", ()=>IconsDensityCompactOrientationVertical);
parcelHelpers.export(exports, "IsEmphasizedTrue", ()=>IsEmphasizedTrue);
parcelHelpers.export(exports, "IsEmphasizedTrueIconsIsQuietTrue", ()=>IsEmphasizedTrueIconsIsQuietTrue);
parcelHelpers.export(exports, "IsEmphasizedTrueOrientationVertical", ()=>IsEmphasizedTrueOrientationVertical);
parcelHelpers.export(exports, "DisableAllTabs", ()=>DisableAllTabs);
parcelHelpers.export(exports, "KeyboardActivationManual", ()=>KeyboardActivationManual);
parcelHelpers.export(exports, "MiddleDisabled", ()=>MiddleDisabled);
parcelHelpers.export(exports, "AllDisabled", ()=>AllDisabled);
parcelHelpers.export(exports, "Resizeable", ()=>Resizeable);
parcelHelpers.export(exports, "CollapseBehavior", ()=>CollapseBehavior);
parcelHelpers.export(exports, "CollapseBehaviorIsQuiet", ()=>CollapseBehaviorIsQuiet);
parcelHelpers.export(exports, "CollapseBehaviorDensityCompact", ()=>CollapseBehaviorDensityCompact);
parcelHelpers.export(exports, "CollapseBehaviorDensityCompactIsQuiet", ()=>CollapseBehaviorDensityCompactIsQuiet);
parcelHelpers.export(exports, "CollapseBehaviorIsEmphasizedTrue", ()=>CollapseBehaviorIsEmphasizedTrue);
parcelHelpers.export(exports, "_OrientationFlip", ()=>_OrientationFlip);
parcelHelpers.export(exports, "TestingTabsInFlex", ()=>TestingTabsInFlex);
parcelHelpers.export(exports, "TransitionBetweenTabSizes", ()=>TransitionBetweenTabSizes);
parcelHelpers.export(exports, "TabWithFlexContainerInBetween", ()=>TabWithFlexContainerInBetween);
parcelHelpers.export(exports, "TabsAtTheBottom", ()=>TabsAtTheBottom);
parcelHelpers.export(exports, "TabsOnTheRight", ()=>TabsOnTheRight);
parcelHelpers.export(exports, "FocusableElementInTabPanel", ()=>FocusableElementInTabPanel);
parcelHelpers.export(exports, "Tab1ControlledChild", ()=>Tab1ControlledChild);
parcelHelpers.export(exports, "ChangingTabTitles", ()=>ChangingTabTitles);
parcelHelpers.export(exports, "ChangingSelectionProgramatically", ()=>ChangingSelectionProgramatically);
parcelHelpers.export(exports, "Links", ()=>Links);
var _addonActions = require("@storybook/addon-actions");
var _reactSpectrum = require("@adobe/react-spectrum");
var _bookmark = require("@spectrum-icons/workflow/Bookmark");
var _bookmarkDefault = parcelHelpers.interopDefault(_bookmark);
var _button = require("@react-spectrum/button");
var _buttongroup = require("@react-spectrum/buttongroup");
var _calendar = require("@spectrum-icons/workflow/Calendar");
var _calendarDefault = parcelHelpers.interopDefault(_calendar);
var _dashboard = require("@spectrum-icons/workflow/Dashboard");
var _dashboardDefault = parcelHelpers.interopDefault(_dashboard);
var _ = require("..");
var _picker = require("@react-spectrum/picker");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _utils = require("@react-aria/utils");
var _textfield = require("@react-spectrum/textfield");
exports.default = {
    title: "Tabs"
};
const Default = ()=>render();
const WithFalsyItemKey = ()=>renderWithFalsyKey();
WithFalsyItemKey.story = {
    name: "with falsy item key"
};
const DefaultSelectedKeyVal2 = ()=>render({
        defaultSelectedKey: "val2"
    });
DefaultSelectedKeyVal2.story = {
    name: "defaultSelectedKey: val2"
};
const ControlledSelectedKeyVal3 = ()=>render({
        selectedKey: "val3"
    });
ControlledSelectedKeyVal3.story = {
    name: "controlled: selectedKey: val3"
};
const OrientationVertical = ()=>render({
        orientation: "vertical"
    });
OrientationVertical.story = {
    name: "orientation: vertical"
};
const DensityCompact = ()=>render({
        density: "compact"
    });
DensityCompact.story = {
    name: "density: compact"
};
const IsQuiet = ()=>render({
        isQuiet: true
    });
IsQuiet.story = {
    name: "isQuiet"
};
const IsQuietDensityCompact = ()=>render({
        isQuiet: true,
        density: "compact"
    });
IsQuietDensityCompact.story = {
    name: "isQuiet, density: compact"
};
const DensityCompactOrientationVertical = ()=>render({
        density: "compact",
        orientation: "vertical"
    });
DensityCompactOrientationVertical.story = {
    name: "density: compact, orientation: vertical"
};
const Icons = ()=>renderWithIcons();
Icons.story = {
    name: "icons"
};
const IconsDensityCompact = ()=>renderWithIcons({
        density: "compact"
    });
IconsDensityCompact.story = {
    name: "icons, density: compact"
};
const IconsOrientationVertical = ()=>renderWithIcons({
        orientation: "vertical"
    });
IconsOrientationVertical.story = {
    name: "icons, orientation: vertical"
};
const IconsDensityCompactOrientationVertical = ()=>renderWithIcons({
        orientation: "vertical",
        density: "compact"
    });
IconsDensityCompactOrientationVertical.story = {
    name: "icons, density: compact, orientation: vertical"
};
const IsEmphasizedTrue = ()=>render({
        isEmphasized: true
    });
IsEmphasizedTrue.story = {
    name: "isEmphasized: true"
};
const IsEmphasizedTrueIconsIsQuietTrue = ()=>renderWithIcons({
        isEmphasized: true,
        isQuiet: true
    });
IsEmphasizedTrueIconsIsQuietTrue.story = {
    name: "isEmphasized: true, icons, isQuiet: true"
};
const IsEmphasizedTrueOrientationVertical = ()=>render({
        isEmphasized: true,
        orientation: "vertical"
    });
IsEmphasizedTrueOrientationVertical.story = {
    name: "isEmphasized: true, orientation: vertical"
};
const DisableAllTabs = ()=>render({
        isDisabled: true
    });
DisableAllTabs.story = {
    name: "disable all tabs"
};
const KeyboardActivationManual = ()=>render({
        keyboardActivation: "manual"
    });
KeyboardActivationManual.story = {
    name: "keyboardActivation: manual"
};
const MiddleDisabled = ()=>render({
        disabledKeys: [
            "val2"
        ]
    });
MiddleDisabled.story = {
    name: "middle disabled"
};
const AllDisabled = ()=>render({
        disabledKeys: [
            "val1",
            "val2",
            "val3",
            "val4",
            "val5"
        ]
    });
AllDisabled.story = {
    name: "all disabled"
};
const Resizeable = ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        style: {
            minWidth: "100px",
            width: "300px",
            height: "400px",
            padding: "10px",
            resize: "horizontal",
            overflow: "auto",
            backgroundColor: "var(--spectrum-global-color-gray-50)"
        }
    }, render());
Resizeable.story = {
    name: "resizeable"
};
const CollapseBehavior = ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement(DynamicTabs, null);
CollapseBehavior.story = {
    name: "collapse behavior"
};
const CollapseBehaviorIsQuiet = ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement(DynamicTabs, {
        isQuiet: true
    });
CollapseBehaviorIsQuiet.story = {
    name: "collapse behavior, isQuiet"
};
const CollapseBehaviorDensityCompact = ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement(DynamicTabs, {
        density: "compact"
    });
CollapseBehaviorDensityCompact.story = {
    name: "collapse behavior, density: compact"
};
const CollapseBehaviorDensityCompactIsQuiet = ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement(DynamicTabs, {
        isQuiet: true,
        density: "compact"
    });
CollapseBehaviorDensityCompactIsQuiet.story = {
    name: "collapse behavior, density: compact, isQuiet"
};
const CollapseBehaviorIsEmphasizedTrue = ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement(DynamicTabs, {
        isEmphasized: true
    });
CollapseBehaviorIsEmphasizedTrue.story = {
    name: "collapse behavior, isEmphasized: true"
};
const _OrientationFlip = ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement(OrientationFlip, null);
_OrientationFlip.story = {
    name: "orientation flip"
};
const TestingTabsInFlex = ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSpectrum.Flex), {
        minHeight: 400,
        minWidth: 400,
        UNSAFE_style: {
            borderWidth: 1,
            borderStyle: "solid",
            borderColor: "var(--spectrum-global-color-gray-800)",
            padding: "10px"
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Tabs), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TabList), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), null, "Tab 1"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), null, "Tab 2")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TabPanels), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), null, "Hello World"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), null, "Goodbye World"))));
TestingTabsInFlex.story = {
    name: "testing: tabs in flex"
};
const TransitionBetweenTabSizes = ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Tabs), {
        maxWidth: 500
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TabList), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSpectrum.Text), null, "Tab 1 long long long name")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSpectrum.Text), null, "Tab 2"))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TabPanels), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), null, "Text"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), null, "Text 2")));
TransitionBetweenTabSizes.story = {
    name: "transition between tab sizes"
};
const TabWithFlexContainerInBetween = ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement(DynamicTabsWithDecoration, null);
TabWithFlexContainerInBetween.story = {
    name: "Tab with flex container in between"
};
const TabsAtTheBottom = ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Tabs), {
        maxWidth: 500
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TabPanels), {
        height: "size-1000"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), null, "Text 1"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), null, "Text 2")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TabList), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), null, "Tab 1"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), null, "Tab 2")));
TabsAtTheBottom.story = {
    name: "tabs at the bottom"
};
const TabsOnTheRight = ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Tabs), {
        maxWidth: 500,
        orientation: "vertical"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TabPanels), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), null, "Text 1"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), null, "Text 2")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TabList), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), null, "Tab 1"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), null, "Tab 2")));
TabsOnTheRight.story = {
    name: "tabs on the right"
};
const FocusableElementInTabPanel = ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Tabs), {
        maxWidth: 500
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TabList), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), null, "Tab 1"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), null, "Tab 2")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TabPanels), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textfield.TextField), {
        label: "Tab 1"
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textfield.TextField), {
        label: "Tab 2",
        isDisabled: true
    }))));
FocusableElementInTabPanel.story = {
    name: "focusable element in tab panel"
};
const Tab1ControlledChild = ()=>{
    let [tab1Text, setTab1Text] = (0, _react.useState)("");
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Tabs), {
        maxWidth: 500
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TabList), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), null, "Tab 1"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), null, "Tab 2")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TabPanels), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textfield.TextField), {
        label: "Tab 1",
        value: tab1Text,
        onChange: setTab1Text
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textfield.TextField), {
        label: "Tab 2"
    }))));
};
Tab1ControlledChild.story = {
    name: "Tab 1 controlled child"
};
const ChangingTabTitles = ()=>{
    let [tab1Text, setTab1Text] = (0, _react.useState)("Tab 1");
    let [tab2Text, setTab2Text] = (0, _react.useState)("Tab 2");
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSpectrum.Flex), {
        minHeight: 400,
        minWidth: 400,
        direction: "column"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textfield.TextField), {
        label: "Tab1 Title",
        value: tab1Text,
        onChange: setTab1Text
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textfield.TextField), {
        label: "Tab2 Title",
        value: tab2Text,
        onChange: setTab2Text
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Tabs), {
        maxWidth: 500
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TabList), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), null, tab1Text), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), null, tab2Text)), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TabPanels), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), null, "Tab 1 Content"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), null, "Tab 2 Content"))));
};
ChangingTabTitles.story = {
    name: "changing tab titles"
};
const ChangingSelectionProgramatically = ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement(ControlledSelection, null);
ChangingSelectionProgramatically.story = {
    name: "changing selection programatically"
};
const Links = (args)=>{
    let [url, setUrl] = (0, _react.useState)("/one");
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.RouterProvider), {
        navigate: setUrl
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Tabs), {
        selectedKey: url,
        "aria-label": "Some tabs",
        width: args.collapsed ? 200 : 300
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TabList), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
        key: "/one",
        href: "/one"
    }, "Tab 1"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
        key: "/two",
        href: "/two"
    }, "Tab 2"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
        key: "/three",
        href: "/three"
    }, "Tab 3"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
        key: "/four",
        href: "/four"
    }, "Tab 4"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
        key: "/five",
        href: "/five"
    }, "Tab 5")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TabPanels), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
        key: "/one"
    }, "Foo"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
        key: "/two"
    }, "Bar"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
        key: "/three"
    }, "Tab 3"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
        key: "/four"
    }, "Tab 4"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
        key: "/five"
    }, "Tab 5"))));
};
Links.story = {
    args: {
        collapsed: false
    }
};
function render(props = {}) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Tabs), {
        ...props,
        "aria-label": "Tab example",
        maxWidth: 500,
        onSelectionChange: (0, _addonActions.action)("onSelectionChange")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TabList), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
        key: "val1"
    }, "Tab 1"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
        key: "val2"
    }, "Tab 2"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
        key: "val3"
    }, "Tab 3"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
        key: "val4"
    }, "Tab 4"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
        key: "val5"
    }, "Tab 5")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TabPanels), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
        key: "val1"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSpectrum.Heading), null, "Tab Body 1"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSpectrum.Text), null, "Dolore ex esse laboris elit magna esse sunt. Pariatur in veniam Lorem est occaecat do magna nisi mollit ipsum sit adipisicing fugiat ex. Pariatur ullamco exercitation ea qui adipisicing. Id cupidatat aute id ut excepteur exercitation magna pariatur. Mollit irure irure reprehenderit pariatur eiusmod proident Lorem deserunt duis cillum mollit. Do reprehenderit sit cupidatat quis laborum in do culpa nisi ipsum. Velit aliquip commodo ea ipsum incididunt culpa nostrud deserunt incididunt exercitation. In quis proident sit ad dolore tempor. Eiusmod pariatur quis commodo labore cupidatat cillum enim eiusmod voluptate laborum culpa. Laborum cupidatat incididunt velit voluptate incididunt occaecat quis do. Consequat adipisicing irure Lorem commodo officia sint id. Velit sit magna aliquip eiusmod non id deserunt. Magna veniam ad consequat dolor cupidatat esse enim Lorem ullamco. Anim excepteur consectetur id in. Mollit laboris duis labore enim duis esse reprehenderit.")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
        key: "val2"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSpectrum.Heading), null, "Tab Body 2"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSpectrum.Text), null, "Dolore ex esse laboris elit magna esse sunt. Pariatur in veniam Lorem est occaecat do magna nisi mollit ipsum sit adipisicing fugiat ex. Pariatur ullamco exercitation ea qui adipisicing. Id cupidatat aute id ut excepteur exercitation magna pariatur. Mollit irure irure reprehenderit pariatur eiusmod proident Lorem deserunt duis cillum mollit. Do reprehenderit sit cupidatat quis laborum in do culpa nisi ipsum. Velit aliquip commodo ea ipsum incididunt culpa nostrud deserunt incididunt exercitation. In quis proident sit ad dolore tempor. Eiusmod pariatur quis commodo labore cupidatat cillum enim eiusmod voluptate laborum culpa. Laborum cupidatat incididunt velit voluptate incididunt occaecat quis do. Consequat adipisicing irure Lorem commodo officia sint id. Velit sit magna aliquip eiusmod non id deserunt. Magna veniam ad consequat dolor cupidatat esse enim Lorem ullamco. Anim excepteur consectetur id in. Mollit laboris duis labore enim duis esse reprehenderit.")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
        key: "val3"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSpectrum.Heading), null, "Tab Body 3"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSpectrum.Text), null, "Dolore ex esse laboris elit magna esse sunt. Pariatur in veniam Lorem est occaecat do magna nisi mollit ipsum sit adipisicing fugiat ex. Pariatur ullamco exercitation ea qui adipisicing. Id cupidatat aute id ut excepteur exercitation magna pariatur. Mollit irure irure reprehenderit pariatur eiusmod proident Lorem deserunt duis cillum mollit. Do reprehenderit sit cupidatat quis laborum in do culpa nisi ipsum. Velit aliquip commodo ea ipsum incididunt culpa nostrud deserunt incididunt exercitation. In quis proident sit ad dolore tempor. Eiusmod pariatur quis commodo labore cupidatat cillum enim eiusmod voluptate laborum culpa. Laborum cupidatat incididunt velit voluptate incididunt occaecat quis do. Consequat adipisicing irure Lorem commodo officia sint id. Velit sit magna aliquip eiusmod non id deserunt. Magna veniam ad consequat dolor cupidatat esse enim Lorem ullamco. Anim excepteur consectetur id in. Mollit laboris duis labore enim duis esse reprehenderit.")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
        key: "val4"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSpectrum.Heading), null, "Tab Body 4"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSpectrum.Text), null, "Dolore ex esse laboris elit magna esse sunt. Pariatur in veniam Lorem est occaecat do magna nisi mollit ipsum sit adipisicing fugiat ex. Pariatur ullamco exercitation ea qui adipisicing. Id cupidatat aute id ut excepteur exercitation magna pariatur. Mollit irure irure reprehenderit pariatur eiusmod proident Lorem deserunt duis cillum mollit. Do reprehenderit sit cupidatat quis laborum in do culpa nisi ipsum. Velit aliquip commodo ea ipsum incididunt culpa nostrud deserunt incididunt exercitation. In quis proident sit ad dolore tempor. Eiusmod pariatur quis commodo labore cupidatat cillum enim eiusmod voluptate laborum culpa. Laborum cupidatat incididunt velit voluptate incididunt occaecat quis do. Consequat adipisicing irure Lorem commodo officia sint id. Velit sit magna aliquip eiusmod non id deserunt. Magna veniam ad consequat dolor cupidatat esse enim Lorem ullamco. Anim excepteur consectetur id in. Mollit laboris duis labore enim duis esse reprehenderit.")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
        key: "val5"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSpectrum.Heading), null, "Tab Body 5"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSpectrum.Text), null, "Dolore ex esse laboris elit magna esse sunt. Pariatur in veniam Lorem est occaecat do magna nisi mollit ipsum sit adipisicing fugiat ex. Pariatur ullamco exercitation ea qui adipisicing. Id cupidatat aute id ut excepteur exercitation magna pariatur. Mollit irure irure reprehenderit pariatur eiusmod proident Lorem deserunt duis cillum mollit. Do reprehenderit sit cupidatat quis laborum in do culpa nisi ipsum. Velit aliquip commodo ea ipsum incididunt culpa nostrud deserunt incididunt exercitation. In quis proident sit ad dolore tempor. Eiusmod pariatur quis commodo labore cupidatat cillum enim eiusmod voluptate laborum culpa. Laborum cupidatat incididunt velit voluptate incididunt occaecat quis do. Consequat adipisicing irure Lorem commodo officia sint id. Velit sit magna aliquip eiusmod non id deserunt. Magna veniam ad consequat dolor cupidatat esse enim Lorem ullamco. Anim excepteur consectetur id in. Mollit laboris duis labore enim duis esse reprehenderit."))));
}
function renderWithIcons(props = {}) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Tabs), {
        ...props,
        "aria-label": "Tab example",
        maxWidth: 500,
        onSelectionChange: (0, _addonActions.action)("onSelectionChange")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TabList), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
        key: "dashboard"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _dashboardDefault.default), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSpectrum.Text), null, "Dashboard")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
        key: "calendar"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _calendarDefault.default), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSpectrum.Text), null, "Calendar")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
        key: "bookmark"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _bookmarkDefault.default), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSpectrum.Text), null, "Bookmark"))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TabPanels), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
        key: "dashboard"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSpectrum.Heading), null, "Dashboard"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSpectrum.Text), null, "Dolore ex esse laboris elit magna esse sunt. Pariatur in veniam Lorem est occaecat do magna nisi mollit ipsum sit adipisicing fugiat ex. Pariatur ullamco exercitation ea qui adipisicing. Id cupidatat aute id ut excepteur exercitation magna pariatur. Mollit irure irure reprehenderit pariatur eiusmod proident Lorem deserunt duis cillum mollit. Do reprehenderit sit cupidatat quis laborum in do culpa nisi ipsum. Velit aliquip commodo ea ipsum incididunt culpa nostrud deserunt incididunt exercitation. In quis proident sit ad dolore tempor. Eiusmod pariatur quis commodo labore cupidatat cillum enim eiusmod voluptate laborum culpa. Laborum cupidatat incididunt velit voluptate incididunt occaecat quis do. Consequat adipisicing irure Lorem commodo officia sint id. Velit sit magna aliquip eiusmod non id deserunt. Magna veniam ad consequat dolor cupidatat esse enim Lorem ullamco. Anim excepteur consectetur id in. Mollit laboris duis labore enim duis esse reprehenderit.")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
        key: "calendar"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSpectrum.Heading), null, "Calendar"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSpectrum.Text), null, "Dolore ex esse laboris elit magna esse sunt. Pariatur in veniam Lorem est occaecat do magna nisi mollit ipsum sit adipisicing fugiat ex. Pariatur ullamco exercitation ea qui adipisicing. Id cupidatat aute id ut excepteur exercitation magna pariatur. Mollit irure irure reprehenderit pariatur eiusmod proident Lorem deserunt duis cillum mollit. Do reprehenderit sit cupidatat quis laborum in do culpa nisi ipsum. Velit aliquip commodo ea ipsum incididunt culpa nostrud deserunt incididunt exercitation. In quis proident sit ad dolore tempor. Eiusmod pariatur quis commodo labore cupidatat cillum enim eiusmod voluptate laborum culpa. Laborum cupidatat incididunt velit voluptate incididunt occaecat quis do. Consequat adipisicing irure Lorem commodo officia sint id. Velit sit magna aliquip eiusmod non id deserunt. Magna veniam ad consequat dolor cupidatat esse enim Lorem ullamco. Anim excepteur consectetur id in. Mollit laboris duis labore enim duis esse reprehenderit.")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
        key: "bookmark"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSpectrum.Heading), null, "Bookmark"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSpectrum.Text), null, "Dolore ex esse laboris elit magna esse sunt. Pariatur in veniam Lorem est occaecat do magna nisi mollit ipsum sit adipisicing fugiat ex. Pariatur ullamco exercitation ea qui adipisicing. Id cupidatat aute id ut excepteur exercitation magna pariatur. Mollit irure irure reprehenderit pariatur eiusmod proident Lorem deserunt duis cillum mollit. Do reprehenderit sit cupidatat quis laborum in do culpa nisi ipsum. Velit aliquip commodo ea ipsum incididunt culpa nostrud deserunt incididunt exercitation. In quis proident sit ad dolore tempor. Eiusmod pariatur quis commodo labore cupidatat cillum enim eiusmod voluptate laborum culpa. Laborum cupidatat incididunt velit voluptate incididunt occaecat quis do. Consequat adipisicing irure Lorem commodo officia sint id. Velit sit magna aliquip eiusmod non id deserunt. Magna veniam ad consequat dolor cupidatat esse enim Lorem ullamco. Anim excepteur consectetur id in. Mollit laboris duis labore enim duis esse reprehenderit."))));
}
function renderWithFalsyKey(props = {}) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Tabs), {
        ...props,
        "aria-label": "Tab example",
        maxWidth: 500,
        onSelectionChange: (0, _addonActions.action)("onSelectionChange")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TabList), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
        key: ""
    }, "Tab 1"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
        key: "val2"
    }, "Tab 2"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
        key: "val3"
    }, "Tab 3"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
        key: "val4"
    }, "Tab 4"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
        key: "val5"
    }, "Tab 5")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TabPanels), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
        key: ""
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSpectrum.Heading), null, "Tab Body 1"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSpectrum.Text), null, "Dolore ex esse laboris elit magna esse sunt. Pariatur in veniam Lorem est occaecat do magna nisi mollit ipsum sit adipisicing fugiat ex. Pariatur ullamco exercitation ea qui adipisicing. Id cupidatat aute id ut excepteur exercitation magna pariatur. Mollit irure irure reprehenderit pariatur eiusmod proident Lorem deserunt duis cillum mollit. Do reprehenderit sit cupidatat quis laborum in do culpa nisi ipsum. Velit aliquip commodo ea ipsum incididunt culpa nostrud deserunt incididunt exercitation. In quis proident sit ad dolore tempor. Eiusmod pariatur quis commodo labore cupidatat cillum enim eiusmod voluptate laborum culpa. Laborum cupidatat incididunt velit voluptate incididunt occaecat quis do. Consequat adipisicing irure Lorem commodo officia sint id. Velit sit magna aliquip eiusmod non id deserunt. Magna veniam ad consequat dolor cupidatat esse enim Lorem ullamco. Anim excepteur consectetur id in. Mollit laboris duis labore enim duis esse reprehenderit.")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
        key: "val2"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSpectrum.Heading), null, "Tab Body 2"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSpectrum.Text), null, "Dolore ex esse laboris elit magna esse sunt. Pariatur in veniam Lorem est occaecat do magna nisi mollit ipsum sit adipisicing fugiat ex. Pariatur ullamco exercitation ea qui adipisicing. Id cupidatat aute id ut excepteur exercitation magna pariatur. Mollit irure irure reprehenderit pariatur eiusmod proident Lorem deserunt duis cillum mollit. Do reprehenderit sit cupidatat quis laborum in do culpa nisi ipsum. Velit aliquip commodo ea ipsum incididunt culpa nostrud deserunt incididunt exercitation. In quis proident sit ad dolore tempor. Eiusmod pariatur quis commodo labore cupidatat cillum enim eiusmod voluptate laborum culpa. Laborum cupidatat incididunt velit voluptate incididunt occaecat quis do. Consequat adipisicing irure Lorem commodo officia sint id. Velit sit magna aliquip eiusmod non id deserunt. Magna veniam ad consequat dolor cupidatat esse enim Lorem ullamco. Anim excepteur consectetur id in. Mollit laboris duis labore enim duis esse reprehenderit.")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
        key: "val3"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSpectrum.Heading), null, "Tab Body 3"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSpectrum.Text), null, "Dolore ex esse laboris elit magna esse sunt. Pariatur in veniam Lorem est occaecat do magna nisi mollit ipsum sit adipisicing fugiat ex. Pariatur ullamco exercitation ea qui adipisicing. Id cupidatat aute id ut excepteur exercitation magna pariatur. Mollit irure irure reprehenderit pariatur eiusmod proident Lorem deserunt duis cillum mollit. Do reprehenderit sit cupidatat quis laborum in do culpa nisi ipsum. Velit aliquip commodo ea ipsum incididunt culpa nostrud deserunt incididunt exercitation. In quis proident sit ad dolore tempor. Eiusmod pariatur quis commodo labore cupidatat cillum enim eiusmod voluptate laborum culpa. Laborum cupidatat incididunt velit voluptate incididunt occaecat quis do. Consequat adipisicing irure Lorem commodo officia sint id. Velit sit magna aliquip eiusmod non id deserunt. Magna veniam ad consequat dolor cupidatat esse enim Lorem ullamco. Anim excepteur consectetur id in. Mollit laboris duis labore enim duis esse reprehenderit.")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
        key: "val4"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSpectrum.Heading), null, "Tab Body 4"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSpectrum.Text), null, "Dolore ex esse laboris elit magna esse sunt. Pariatur in veniam Lorem est occaecat do magna nisi mollit ipsum sit adipisicing fugiat ex. Pariatur ullamco exercitation ea qui adipisicing. Id cupidatat aute id ut excepteur exercitation magna pariatur. Mollit irure irure reprehenderit pariatur eiusmod proident Lorem deserunt duis cillum mollit. Do reprehenderit sit cupidatat quis laborum in do culpa nisi ipsum. Velit aliquip commodo ea ipsum incididunt culpa nostrud deserunt incididunt exercitation. In quis proident sit ad dolore tempor. Eiusmod pariatur quis commodo labore cupidatat cillum enim eiusmod voluptate laborum culpa. Laborum cupidatat incididunt velit voluptate incididunt occaecat quis do. Consequat adipisicing irure Lorem commodo officia sint id. Velit sit magna aliquip eiusmod non id deserunt. Magna veniam ad consequat dolor cupidatat esse enim Lorem ullamco. Anim excepteur consectetur id in. Mollit laboris duis labore enim duis esse reprehenderit.")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
        key: "val5"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSpectrum.Heading), null, "Tab Body 5"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSpectrum.Text), null, "Dolore ex esse laboris elit magna esse sunt. Pariatur in veniam Lorem est occaecat do magna nisi mollit ipsum sit adipisicing fugiat ex. Pariatur ullamco exercitation ea qui adipisicing. Id cupidatat aute id ut excepteur exercitation magna pariatur. Mollit irure irure reprehenderit pariatur eiusmod proident Lorem deserunt duis cillum mollit. Do reprehenderit sit cupidatat quis laborum in do culpa nisi ipsum. Velit aliquip commodo ea ipsum incididunt culpa nostrud deserunt incididunt exercitation. In quis proident sit ad dolore tempor. Eiusmod pariatur quis commodo labore cupidatat cillum enim eiusmod voluptate laborum culpa. Laborum cupidatat incididunt velit voluptate incididunt occaecat quis do. Consequat adipisicing irure Lorem commodo officia sint id. Velit sit magna aliquip eiusmod non id deserunt. Magna veniam ad consequat dolor cupidatat esse enim Lorem ullamco. Anim excepteur consectetur id in. Mollit laboris duis labore enim duis esse reprehenderit."))));
}
let items = [
    {
        name: "Tab 1",
        children: "Tab Body 1",
        icon: /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _dashboardDefault.default), null)
    },
    {
        name: "Tab 2",
        children: "Tab Body 2",
        icon: /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _calendarDefault.default), null)
    },
    {
        name: "Tab 3",
        children: "Tab Body 3",
        icon: /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _bookmarkDefault.default), null)
    },
    {
        name: "Tab 4",
        children: "Tab Body 4",
        icon: /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _dashboardDefault.default), null)
    },
    {
        name: "Tab 5",
        children: "Tab Body 5",
        icon: /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _calendarDefault.default), null)
    },
    {
        name: "Tab 6",
        children: "Tab Body 6",
        icon: /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _bookmarkDefault.default), null)
    }
];
let DynamicTabs = (props)=>{
    let [tabs, setTabs] = (0, _reactDefault.default).useState(items);
    let addTab = ()=>{
        let newTabs = [
            ...tabs
        ];
        newTabs.push({
            name: `Tab ${tabs.length + 1}`,
            children: `Tab Body ${tabs.length + 1}`
        });
        setTabs(newTabs);
    };
    let removeTab = ()=>{
        if (tabs.length > 1) {
            let newTabs = [
                ...tabs
            ];
            newTabs.pop();
            setTabs(newTabs);
        }
    };
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        style: {
            width: "80%"
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Tabs), {
        ...props,
        "aria-label": "Tab example",
        items: tabs,
        onSelectionChange: (0, _addonActions.action)("onSelectionChange")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TabList), null, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            key: item.name
        }, item.icon, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSpectrum.Text), null, item.name))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TabPanels), null, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            key: item.name
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSpectrum.Heading), null, item.children), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSpectrum.Text), null, "Dolore ex esse laboris elit magna esse sunt. Pariatur in veniam Lorem est occaecat do magna nisi mollit ipsum sit adipisicing fugiat ex. Pariatur ullamco exercitation ea qui adipisicing. Id cupidatat aute id ut excepteur exercitation magna pariatur. Mollit irure irure reprehenderit pariatur eiusmod proident Lorem deserunt duis cillum mollit. Do reprehenderit sit cupidatat quis laborum in do culpa nisi ipsum. Velit aliquip commodo ea ipsum incididunt culpa nostrud deserunt incididunt exercitation. In quis proident sit ad dolore tempor. Eiusmod pariatur quis commodo labore cupidatat cillum enim eiusmod voluptate laborum culpa. Laborum cupidatat incididunt velit voluptate incididunt occaecat quis do. Consequat adipisicing irure Lorem commodo officia sint id. Velit sit magna aliquip eiusmod non id deserunt. Magna veniam ad consequat dolor cupidatat esse enim Lorem ullamco. Anim excepteur consectetur id in. Mollit laboris duis labore enim duis esse reprehenderit.")))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _buttongroup.ButtonGroup), {
        marginEnd: "30px"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.Button), {
        variant: "secondary",
        onPress: ()=>addTab()
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSpectrum.Text), null, "Add Tab")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.Button), {
        variant: "secondary",
        onPress: ()=>removeTab()
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSpectrum.Text), null, "Remove Tab"))));
};
let OrientationFlip = (props = {})=>{
    let [flipOrientation, setFlipOrientation] = (0, _reactDefault.default).useState(true);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        style: {
            width: "80%"
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Tabs), {
        ...props,
        "aria-label": "Tab example",
        items: items,
        onSelectionChange: (0, _addonActions.action)("onSelectionChange"),
        orientation: flipOrientation ? "horizontal" : "vertical"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TabList), null, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            key: item.name
        }, item.icon, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSpectrum.Text), null, item.name))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TabPanels), null, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            key: item.name
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSpectrum.Heading), null, item.children), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSpectrum.Text), null, "Dolore ex esse laboris elit magna esse sunt. Pariatur in veniam Lorem est occaecat do magna nisi mollit ipsum sit adipisicing fugiat ex. Pariatur ullamco exercitation ea qui adipisicing. Id cupidatat aute id ut excepteur exercitation magna pariatur. Mollit irure irure reprehenderit pariatur eiusmod proident Lorem deserunt duis cillum mollit. Do reprehenderit sit cupidatat quis laborum in do culpa nisi ipsum. Velit aliquip commodo ea ipsum incididunt culpa nostrud deserunt incididunt exercitation. In quis proident sit ad dolore tempor. Eiusmod pariatur quis commodo labore cupidatat cillum enim eiusmod voluptate laborum culpa. Laborum cupidatat incididunt velit voluptate incididunt occaecat quis do. Consequat adipisicing irure Lorem commodo officia sint id. Velit sit magna aliquip eiusmod non id deserunt. Magna veniam ad consequat dolor cupidatat esse enim Lorem ullamco. Anim excepteur consectetur id in. Mollit laboris duis labore enim duis esse reprehenderit.")))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.Button), {
        variant: "secondary",
        onPress: ()=>setFlipOrientation((state)=>!state)
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSpectrum.Text), null, "Flip Orientation")));
};
let DynamicTabsWithDecoration = (props = {})=>{
    let [tabs, setTabs] = (0, _reactDefault.default).useState(items);
    let addTab = ()=>{
        let newTabs = [
            ...tabs
        ];
        newTabs.push({
            name: `Tab ${tabs.length + 1}`,
            children: `Tab Body ${tabs.length + 1}`
        });
        setTabs(newTabs);
    };
    let removeTab = ()=>{
        if (tabs.length > 1) {
            let newTabs = [
                ...tabs
            ];
            newTabs.pop();
            setTabs(newTabs);
        }
    };
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        style: {
            width: "80%"
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Tabs), {
        ...props,
        "aria-label": "Tab example",
        items: tabs,
        onSelectionChange: (0, _addonActions.action)("onSelectionChange")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSpectrum.Flex), {
        direction: "row",
        alignItems: "center"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TabList), {
        flex: "1 1 auto",
        UNSAFE_style: {
            overflow: "hidden"
        }
    }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            key: item.name
        }, item.icon, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSpectrum.Text), null, item.name))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSpectrum.Flex), {
        alignItems: "center",
        justifyContent: "end",
        flex: "0 0 auto",
        alignSelf: "stretch",
        UNSAFE_style: {
            borderBottom: "var(--spectrum-alias-border-size-thick) solid var(--spectrum-global-color-gray-300)"
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSpectrum.ActionGroup), {
        marginEnd: "30px",
        disabledKeys: tabs.length === 1 ? [
            "remove"
        ] : undefined,
        onAction: (val)=>val === "add" ? addTab() : removeTab()
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
        key: "add"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSpectrum.Text), null, "Add Tab")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
        key: "remove"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSpectrum.Text), null, "Remove Tab"))))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TabPanels), null, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            key: item.name
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSpectrum.Heading), null, item.children), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSpectrum.Text), null, "Dolore ex esse laboris elit magna esse sunt. Pariatur in veniam Lorem est occaecat do magna nisi mollit ipsum sit adipisicing fugiat ex. Pariatur ullamco exercitation ea qui adipisicing. Id cupidatat aute id ut excepteur exercitation magna pariatur. Mollit irure irure reprehenderit pariatur eiusmod proident Lorem deserunt duis cillum mollit. Do reprehenderit sit cupidatat quis laborum in do culpa nisi ipsum. Velit aliquip commodo ea ipsum incididunt culpa nostrud deserunt incididunt exercitation. In quis proident sit ad dolore tempor. Eiusmod pariatur quis commodo labore cupidatat cillum enim eiusmod voluptate laborum culpa. Laborum cupidatat incididunt velit voluptate incididunt occaecat quis do. Consequat adipisicing irure Lorem commodo officia sint id. Velit sit magna aliquip eiusmod non id deserunt. Magna veniam ad consequat dolor cupidatat esse enim Lorem ullamco. Anim excepteur consectetur id in. Mollit laboris duis labore enim duis esse reprehenderit.")))));
};
let ControlledSelection = ()=>{
    let [selectedKey, setSelectedKey] = (0, _react.useState)("Tab 1");
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        style: {
            width: "80%"
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _picker.Picker), {
        label: "Set selected tab",
        selectedKey: selectedKey,
        onSelectionChange: setSelectedKey,
        items: items
    }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            key: item.name
        }, item.name)), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Tabs), {
        "aria-label": "Tab example",
        items: items,
        selectedKey: selectedKey,
        onSelectionChange: setSelectedKey
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TabList), null, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            key: item.name
        }, item.icon, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSpectrum.Text), null, item.name))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TabPanels), null, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.Item), {
            key: item.name
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSpectrum.Heading), null, item.children), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSpectrum.Text), null, "Dolore ex esse laboris elit magna esse sunt. Pariatur in veniam Lorem est occaecat do magna nisi mollit ipsum sit adipisicing fugiat ex. Pariatur ullamco exercitation ea qui adipisicing. Id cupidatat aute id ut excepteur exercitation magna pariatur. Mollit irure irure reprehenderit pariatur eiusmod proident Lorem deserunt duis cillum mollit. Do reprehenderit sit cupidatat quis laborum in do culpa nisi ipsum. Velit aliquip commodo ea ipsum incididunt culpa nostrud deserunt incididunt exercitation. In quis proident sit ad dolore tempor. Eiusmod pariatur quis commodo labore cupidatat cillum enim eiusmod voluptate laborum culpa. Laborum cupidatat incididunt velit voluptate incididunt occaecat quis do. Consequat adipisicing irure Lorem commodo officia sint id. Velit sit magna aliquip eiusmod non id deserunt. Magna veniam ad consequat dolor cupidatat esse enim Lorem ullamco. Anim excepteur consectetur id in. Mollit laboris duis labore enim duis esse reprehenderit.")))));
};

},{"@storybook/addon-actions":"coXbW","@adobe/react-spectrum":"cwANo","@spectrum-icons/workflow/Bookmark":"lfemW","@react-spectrum/button":"jZWyP","@react-spectrum/buttongroup":"anP11","@spectrum-icons/workflow/Calendar":"bJMhf","@spectrum-icons/workflow/Dashboard":"doDHV","..":"8NyDL","@react-spectrum/picker":"kL1Uy","react":"9yzVZ","@react-aria/utils":"9cLk5","@react-spectrum/textfield":"hOmtq","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"lfemW":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("70d70aa39eb85cd5");
exports.__esModule = true;
exports.default = Bookmark;
var _Bookmark = require("2304ebf3c815c49");
var _icon = require("acaa278a69bb33ca");
var _react = _interopRequireDefault(require("3113da37d7659775"));
function Bookmark(props) {
    return /*#__PURE__*/ _react.default.createElement(_icon.Icon, props, /*#__PURE__*/ _react.default.createElement(_Bookmark.A4uBookmark, null));
}

},{"70d70aa39eb85cd5":"iHubQ","2304ebf3c815c49":"ddeDO","acaa278a69bb33ca":"k7wem","3113da37d7659775":"9yzVZ"}],"ddeDO":[function(require,module,exports) {
/**
* @adobe/react-spectrum-workflow (c) by Adobe
* 
* @adobe/react-spectrum-workflow is licensed under a
* Creative Commons Attribution-NoDerivatives 4.0 International License.
* 
* You should have received a copy of the license along with this
* work. If not, see <http://creativecommons.org/licenses/by-nd/4.0/>.
**/ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.A4uBookmark = A4uBookmark;
var _react = _interopRequireDefault(require("1820d83e388d7508"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function A4uBookmark(_ref) {
    var props = _extends({}, _ref);
    return /*#__PURE__*/ _react["default"].createElement("svg", _extends({
        viewBox: "0 0 36 36"
    }, props, props), /*#__PURE__*/ _react["default"].createElement("path", {
        fillRule: "evenodd",
        d: "M15.071,34.724,13,31.373l-2.071,3.351A.5.5,0,0,1,10,34.467V24h6V34.467A.5.5,0,0,1,15.071,34.724Z"
    }), /*#__PURE__*/ _react["default"].createElement("path", {
        fillRule: "evenodd",
        d: "M8,27.443A3.987,3.987,0,0,1,9.995,20H20.518a1,1,0,0,0,.8-.4l11.1-14.8a.5.5,0,0,0-.4-.8H16.025a1,1,0,0,0-.8.4L3.522,19.328H3.53A7.942,7.942,0,0,0,8,31.716Z"
    }), /*#__PURE__*/ _react["default"].createElement("path", {
        fillRule: "evenodd",
        d: "M32.018,16H28.782l-9,12H18v4h2.518a1,1,0,0,0,.8-.4l11.1-14.8A.5.5,0,0,0,32.018,16Z"
    }));
}

},{"1820d83e388d7508":"9yzVZ"}],"doDHV":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("9bbf9b86784afbad");
exports.__esModule = true;
exports.default = Dashboard;
var _Dashboard = require("5193fec2326a0274");
var _icon = require("cf35566acaebafe4");
var _react = _interopRequireDefault(require("937bab5de62e4747"));
function Dashboard(props) {
    return /*#__PURE__*/ _react.default.createElement(_icon.Icon, props, /*#__PURE__*/ _react.default.createElement(_Dashboard.A4uDashboard, null));
}

},{"9bbf9b86784afbad":"iHubQ","5193fec2326a0274":"1ORRe","cf35566acaebafe4":"k7wem","937bab5de62e4747":"9yzVZ"}],"1ORRe":[function(require,module,exports) {
/**
* @adobe/react-spectrum-workflow (c) by Adobe
* 
* @adobe/react-spectrum-workflow is licensed under a
* Creative Commons Attribution-NoDerivatives 4.0 International License.
* 
* You should have received a copy of the license along with this
* work. If not, see <http://creativecommons.org/licenses/by-nd/4.0/>.
**/ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.A4uDashboard = A4uDashboard;
var _react = _interopRequireDefault(require("a336bc8d1e6913f8"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function A4uDashboard(_ref) {
    var props = _extends({}, _ref);
    return /*#__PURE__*/ _react["default"].createElement("svg", _extends({
        viewBox: "0 0 36 36"
    }, props, props), /*#__PURE__*/ _react["default"].createElement("path", {
        fillRule: "evenodd",
        d: "M7.324,28.053a13.27,13.27,0,0,1-2.656-7.794A13.483,13.483,0,0,1,17.612,6.741,13.331,13.331,0,0,1,28.676,28.053a.725.725,0,0,0,.1,1l.931.775a.733.733,0,0,0,1.048-.107,16,16,0,1,0-25.515,0,.729.729,0,0,0,1.045.107l.932-.776A.724.724,0,0,0,7.324,28.053Z"
    }), /*#__PURE__*/ _react["default"].createElement("path", {
        fillRule: "evenodd",
        d: "M20.839,23.526a2.909,2.909,0,1,1-3.474-2.2c.748-.167,5.534-6.2,6.146-5.845C24.184,15.871,20.656,22.706,20.839,23.526Z"
    }), /*#__PURE__*/ _react["default"].createElement("circle", {
        fillRule: "evenodd",
        cx: "7.818",
        cy: "20.069",
        r: "1.6"
    }), /*#__PURE__*/ _react["default"].createElement("circle", {
        fillRule: "evenodd",
        cx: "10.727",
        cy: "12.796",
        r: "1.6"
    }), /*#__PURE__*/ _react["default"].createElement("circle", {
        fillRule: "evenodd",
        cx: "25.273",
        cy: "12.796",
        r: "1.455"
    }), /*#__PURE__*/ _react["default"].createElement("circle", {
        fillRule: "evenodd",
        cx: "18",
        cy: "9.887",
        r: "1.455"
    }), /*#__PURE__*/ _react["default"].createElement("circle", {
        fillRule: "evenodd",
        cx: "28.182",
        cy: "20.069",
        r: "1.455"
    }));
}

},{"a336bc8d1e6913f8":"9yzVZ"}],"8NyDL":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _src = require("./src");
parcelHelpers.exportAll(_src, exports);

},{"./src":"87IGq","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"jvJcZ":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Default", ()=>Default);
parcelHelpers.export(exports, "WithIcons", ()=>WithIcons);
parcelHelpers.export(exports, "OnRemove", ()=>OnRemove);
parcelHelpers.export(exports, "Wrapping", ()=>Wrapping);
parcelHelpers.export(exports, "LabelTruncation", ()=>LabelTruncation);
parcelHelpers.export(exports, "MaxRows", ()=>MaxRows);
parcelHelpers.export(exports, "MaxRowsManyTags", ()=>MaxRowsManyTags);
parcelHelpers.export(exports, "MaxRowsOnRemove", ()=>MaxRowsOnRemove);
parcelHelpers.export(exports, "WithAvatar", ()=>WithAvatar);
parcelHelpers.export(exports, "WithAvatarOnRemove", ()=>WithAvatarOnRemove);
parcelHelpers.export(exports, "WithAction", ()=>WithAction);
parcelHelpers.export(exports, "WithActionAndMaxRows", ()=>WithActionAndMaxRows);
parcelHelpers.export(exports, "WithLabelDescriptionContextualHelp", ()=>WithLabelDescriptionContextualHelp);
parcelHelpers.export(exports, "WithLabelDescriptionContextualHelpAndAction", ()=>WithLabelDescriptionContextualHelpAndAction);
parcelHelpers.export(exports, "EmptyState", ()=>EmptyState);
parcelHelpers.export(exports, "CustomEmptyState", ()=>CustomEmptyState);
parcelHelpers.export(exports, "Links", ()=>Links);
var _addonActions = require("@storybook/addon-actions");
var _audio = require("@spectrum-icons/workflow/Audio");
var _audioDefault = parcelHelpers.interopDefault(_audio);
var _avatar = require("@react-spectrum/avatar");
var _view = require("@react-spectrum/view");
var _contextualhelp = require("@react-spectrum/contextualhelp");
var _text = require("@react-spectrum/text");
var _src = require("../src");
var _link = require("@react-spectrum/link");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
let manyItems = [];
for(let i = 0; i < 50; i++){
    let item = {
        key: i
    };
    manyItems.push(item);
}
function ResizableContainer({ children }) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        style: {
            width: "200px",
            height: "200px",
            padding: "10px",
            resize: "horizontal",
            overflow: "auto",
            backgroundColor: "var(--spectrum-global-color-gray-50)"
        }
    }, children, /*#__PURE__*/ (0, _reactDefault.default).createElement("p", null, "Use the resize handle to resize the container."));
}
function render(props) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _src.TagGroup), {
        ...props,
        "aria-label": "Tag group"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _src.Item), {
        key: "1"
    }, "Cool Tag 1"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _src.Item), {
        key: "2"
    }, "Cool Tag 2"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _src.Item), {
        key: "3"
    }, "Cool Tag 3"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _src.Item), {
        key: "4"
    }, "Cool Tag 4"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _src.Item), {
        key: "5"
    }, "Cool Tag 5"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _src.Item), {
        key: "6"
    }, "Cool Tag 6"));
}
exports.default = {
    title: "TagGroup",
    component: (0, _src.TagGroup),
    argTypes: {
        onRemove: {
            table: {
                disable: true
            }
        },
        onAction: {
            table: {
                disable: true
            }
        },
        items: {
            table: {
                disable: true
            }
        },
        maxRows: {
            type: "number"
        },
        contextualHelp: {
            table: {
                disable: true
            }
        },
        isRequired: {
            control: "boolean"
        },
        necessityIndicator: {
            control: "select",
            options: [
                "icon",
                "label"
            ]
        },
        labelPosition: {
            control: "select",
            options: [
                "top",
                "side"
            ]
        },
        labelAlign: {
            control: "select",
            options: [
                "start",
                "end"
            ]
        },
        isInvalid: {
            control: "boolean"
        },
        description: {
            control: "text"
        },
        errorMessage: {
            control: "text"
        }
    },
    render: (args)=>render(args)
};
const Default = {};
const WithIcons = {
    args: {
        items: [
            {
                key: "1",
                label: "Cool Tag 1"
            },
            {
                key: "2",
                label: "Cool Tag 2"
            }
        ]
    },
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _src.TagGroup), {
            "aria-label": "Tag group with icons",
            ...args
        }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _src.Item), {
                key: item.key,
                textValue: item.label
            }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _audioDefault.default), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, item.label)))
};
const OnRemove = {
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(OnRemoveExample, args),
    name: "onRemove"
};
const Wrapping = {
    decorators: [
        (Story)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(ResizableContainer, null, /*#__PURE__*/ (0, _reactDefault.default).createElement(Story, null))
    ]
};
const LabelTruncation = {
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
            style: {
                width: "100px"
            }
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _src.TagGroup), {
            "aria-label": "Tag group with label truncation",
            ...args
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _src.Item), {
            key: "1"
        }, "Cool Tag 1 with a really long label"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _src.Item), {
            key: "2"
        }, "Another long cool tag label"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _src.Item), {
            key: "3"
        }, "This tag")))
};
const MaxRows = {
    args: {
        maxRows: 2
    },
    decorators: [
        (Story)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(ResizableContainer, null, /*#__PURE__*/ (0, _reactDefault.default).createElement(Story, null))
    ],
    name: "maxRows"
};
const MaxRowsManyTags = {
    args: {
        maxRows: 2
    },
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _src.TagGroup), {
            "aria-label": "Tag group with 50 tags",
            items: manyItems,
            ...args
        }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _src.Item), {
                key: item.key
            }, `Tag ${item.key}`)),
    decorators: [
        (Story)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(ResizableContainer, null, /*#__PURE__*/ (0, _reactDefault.default).createElement(Story, null))
    ],
    name: "maxRows with many tags"
};
const MaxRowsOnRemove = {
    args: {
        maxRows: 2
    },
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(OnRemoveExample, args),
    decorators: [
        (Story)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(ResizableContainer, null, /*#__PURE__*/ (0, _reactDefault.default).createElement(Story, null))
    ],
    name: "maxRows + onRemove"
};
const WithAvatar = {
    args: {
        items: [
            {
                key: "1",
                label: "Cool Person 1"
            },
            {
                key: "2",
                label: "Cool Person 2"
            }
        ]
    },
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _src.TagGroup), {
            "aria-label": "Tag group with avatars",
            ...args
        }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _src.Item), {
                key: item.key,
                textValue: item.label
            }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _avatar.Avatar), {
                src: "https://i.imgur.com/kJOwAdv.png",
                alt: "default Adobe avatar"
            }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, item.label))),
    name: "with avatar"
};
const WithAvatarOnRemove = {
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(OnRemoveExample, {
            withAvatar: true,
            ...args
        }),
    name: "with avatar + onRemove"
};
const WithAction = {
    args: {
        onAction: (0, _addonActions.action)("clear"),
        actionLabel: "Clear"
    },
    name: "with action"
};
const WithActionAndMaxRows = {
    args: {
        maxRows: 2,
        onAction: (0, _addonActions.action)("clear"),
        actionLabel: "Clear"
    },
    decorators: [
        (Story)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(ResizableContainer, null, /*#__PURE__*/ (0, _reactDefault.default).createElement(Story, null))
    ],
    name: "with action and maxRows"
};
const WithLabelDescriptionContextualHelp = {
    args: {
        label: "Some sample tags",
        description: "Here is a description about the tag group.",
        contextualHelp: /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _contextualhelp.ContextualHelp), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Heading), null, "What are these tags?"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Content), null, "Here is more information about the tag group."))
    },
    decorators: [
        (Story)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(ResizableContainer, null, /*#__PURE__*/ (0, _reactDefault.default).createElement(Story, null))
    ],
    name: "with label, description, contextual help"
};
const WithLabelDescriptionContextualHelpAndAction = {
    args: {
        onAction: (0, _addonActions.action)("clear"),
        actionLabel: "Clear",
        label: "Some sample tags",
        description: "Here is a description about the tag group.",
        contextualHelp: /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _contextualhelp.ContextualHelp), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Heading), null, "What are these tags?"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Content), null, "Here is more information about the tag group."))
    },
    decorators: [
        (Story)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(ResizableContainer, null, /*#__PURE__*/ (0, _reactDefault.default).createElement(Story, null))
    ],
    name: "with label, description, contextual help + action"
};
const EmptyState = {
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _src.TagGroup), {
            label: "Tag group with empty state",
            ...args
        }, []),
    storyName: "Empty state"
};
const CustomEmptyState = {
    ...EmptyState,
    args: {
        renderEmptyState: ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement("span", null, "No tags. ", /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _link.Link), null, /*#__PURE__*/ (0, _reactDefault.default).createElement("a", {
                href: "//react-spectrum.com"
            }, "Click here")), " to add some.")
    },
    storyName: "Custom empty state"
};
function OnRemoveExample(props) {
    let { withAvatar, ...otherProps } = props;
    let [items, setItems] = (0, _react.useState)([
        {
            id: 1,
            label: "Cool Tag 1"
        },
        {
            id: 2,
            label: "Another cool tag"
        },
        {
            id: 3,
            label: "This tag"
        },
        {
            id: 4,
            label: "What tag?"
        },
        {
            id: 5,
            label: "This tag is cool too"
        },
        {
            id: 6,
            label: "Shy tag"
        }
    ]);
    let onRemove = (keys)=>{
        setItems((prevItems)=>prevItems.filter((item)=>!keys.has(item.id)));
        (0, _addonActions.action)("onRemove")(keys);
    };
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _src.TagGroup), {
        "aria-label": "Tag group with removable tags",
        items: items,
        onRemove: (key)=>onRemove(key),
        ...otherProps
    }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _src.Item), {
            key: item.key,
            textValue: item.label
        }, withAvatar && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _avatar.Avatar), {
            src: "https://i.imgur.com/kJOwAdv.png",
            alt: "default Adobe avatar"
        }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), null, item.label)));
}
const Links = {
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _src.TagGroup), {
            "aria-label": "Tag group with links",
            ...args
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _src.Item), {
            href: "https://adobe.com"
        }, "Adobe"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _src.Item), {
            href: "https://google.com"
        }, "Google"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _src.Item), {
            href: "https://apple.com"
        }, "Apple"))
};

},{"@storybook/addon-actions":"coXbW","@spectrum-icons/workflow/Audio":"CBHH4","@react-spectrum/avatar":"kHDr1","@react-spectrum/view":"dnRjt","@react-spectrum/contextualhelp":"jA6za","@react-spectrum/text":"etCGI","../src":"dM36P","@react-spectrum/link":"lNoiB","react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"CBHH4":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("e50f99a362204002");
exports.__esModule = true;
exports.default = Audio;
var _Audio = require("b2e215d24057840c");
var _icon = require("bfe5abcf4b4a1b9");
var _react = _interopRequireDefault(require("fa5f93c0bdc3aa93"));
function Audio(props) {
    return /*#__PURE__*/ _react.default.createElement(_icon.Icon, props, /*#__PURE__*/ _react.default.createElement(_Audio.A4uAudio, null));
}

},{"e50f99a362204002":"iHubQ","b2e215d24057840c":"5R5VX","bfe5abcf4b4a1b9":"k7wem","fa5f93c0bdc3aa93":"9yzVZ"}],"5R5VX":[function(require,module,exports) {
/**
* @adobe/react-spectrum-workflow (c) by Adobe
* 
* @adobe/react-spectrum-workflow is licensed under a
* Creative Commons Attribution-NoDerivatives 4.0 International License.
* 
* You should have received a copy of the license along with this
* work. If not, see <http://creativecommons.org/licenses/by-nd/4.0/>.
**/ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.A4uAudio = A4uAudio;
var _react = _interopRequireDefault(require("e8d0f358023c34f"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function A4uAudio(_ref) {
    var props = _extends({}, _ref);
    return /*#__PURE__*/ _react["default"].createElement("svg", _extends({
        viewBox: "0 0 36 36"
    }, props, props), /*#__PURE__*/ _react["default"].createElement("path", {
        fillRule: "evenodd",
        d: "M30,3.417a1,1,0,0,0-1.268-.965l-16,4.447A1,1,0,0,0,12,7.863v16.55a6.628,6.628,0,0,0-6.144.057c-3.113,1.515-4.687,4.7-3.515,7.1S6.987,34.706,10.1,33.19A6.434,6.434,0,0,0,14,27.857c0-.167,0-15.033,0-15.033l14-4V20.413a6.628,6.628,0,0,0-6.144.057c-3.113,1.515-4.687,4.7-3.515,7.1s4.646,3.132,7.759,1.616A6.427,6.427,0,0,0,30,23.833C30,23.767,30,3.417,30,3.417Z"
    }));
}

},{"e8d0f358023c34f":"9yzVZ"}],"3I358":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Default", ()=>Default);
parcelHelpers.export(exports, "ValueTestControlled", ()=>ValueTestControlled);
parcelHelpers.export(exports, "DefaultValueTestUncontrolled", ()=>DefaultValueTestUncontrolled);
parcelHelpers.export(exports, "AutoFocusTrue", ()=>AutoFocusTrue);
parcelHelpers.export(exports, "IconInfo", ()=>IconInfo);
parcelHelpers.export(exports, "NoVisibleLabel", ()=>NoVisibleLabel);
parcelHelpers.export(exports, "WithDescription", ()=>WithDescription);
parcelHelpers.export(exports, "WithErrorMessage", ()=>WithErrorMessage);
parcelHelpers.export(exports, "WithContextualHelp", ()=>WithContextualHelp);
parcelHelpers.export(exports, "CustomWidth", ()=>CustomWidth);
parcelHelpers.export(exports, "CustomWidthSmall", ()=>CustomWidthSmall);
parcelHelpers.export(exports, "CustomHeightWithLabel", ()=>CustomHeightWithLabel);
parcelHelpers.export(exports, "ChangeableHelptext", ()=>ChangeableHelptext);
parcelHelpers.export(exports, "ChangeableHelptextCustomHeight", ()=>ChangeableHelptextCustomHeight);
parcelHelpers.export(exports, "ControlledInteractive", ()=>ControlledInteractive);
parcelHelpers.export(exports, "InFlex", ()=>InFlex);
parcelHelpers.export(exports, "InFlexValidationState", ()=>InFlexValidationState);
parcelHelpers.export(exports, "WithDifferentLocaleText", ()=>WithDifferentLocaleText);
var _addonActions = require("@storybook/addon-actions");
var _button = require("@react-spectrum/button");
var _reactSpectrum = require("@adobe/react-spectrum");
var _layout = require("@react-spectrum/layout");
var _form = require("@react-spectrum/form");
var _info = require("@spectrum-icons/workflow/Info");
var _infoDefault = parcelHelpers.interopDefault(_info);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _ = require("../");
exports.default = {
    title: "TextArea",
    providerSwitcher: {
        status: "positive"
    },
    args: {
        label: "Comments",
        isQuiet: false,
        isDisabled: false,
        isReadOnly: false,
        isRequired: false,
        necessityIndicator: "icon",
        labelPosition: "top",
        labelAlign: "start",
        validationState: null
    },
    argTypes: {
        labelPosition: {
            control: {
                type: "radio",
                options: [
                    "top",
                    "side"
                ]
            }
        },
        necessityIndicator: {
            control: {
                type: "radio",
                options: [
                    "icon",
                    "label"
                ]
            }
        },
        labelAlign: {
            control: {
                type: "radio",
                options: [
                    "start",
                    "end"
                ]
            }
        },
        validationState: {
            control: {
                type: "radio",
                options: [
                    null,
                    "valid",
                    "invalid"
                ]
            }
        }
    }
};
const Default = (args)=>render(args);
const ValueTestControlled = (args)=>render({
        ...args,
        value: "Test"
    });
ValueTestControlled.story = {
    name: "value: Test (controlled)"
};
const DefaultValueTestUncontrolled = (args)=>render({
        ...args,
        defaultValue: "Test"
    });
DefaultValueTestUncontrolled.story = {
    name: "defaultValue: Test (uncontrolled)"
};
const AutoFocusTrue = (args)=>render({
        ...args,
        autoFocus: true
    });
AutoFocusTrue.story = {
    name: "autoFocus: true"
};
const IconInfo = (args)=>render({
        ...args,
        icon: /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _infoDefault.default), null)
    });
IconInfo.story = {
    name: "icon: Info"
};
const NoVisibleLabel = (args)=>render({
        ...args,
        label: null,
        "aria-label": "Street address"
    });
NoVisibleLabel.story = {
    name: "no visible label"
};
const WithDescription = (args)=>render({
        ...args,
        description: "Enter product feedback."
    });
WithDescription.story = {
    name: "with description"
};
const WithErrorMessage = (args)=>render({
        ...args,
        errorMessage: "Enter at least 250 characters.",
        validationState: "invalid"
    });
WithErrorMessage.story = {
    name: "with error message"
};
const WithContextualHelp = (args)=>render({
        ...args,
        contextualHelp: /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSpectrum.ContextualHelp), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSpectrum.Heading), null, "What is a segment?"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSpectrum.Content), null, "Segments identify who your visitors are, what devices and services they use, where they navigated from, and much more."))
    });
WithContextualHelp.story = {
    name: "with contextual help"
};
const CustomWidth = (args)=>render({
        ...args,
        icon: /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _infoDefault.default), null),
        validationState: "invalid",
        width: "300px"
    });
CustomWidth.story = {
    name: "custom width"
};
const CustomWidthSmall = (args)=>render({
        ...args,
        icon: /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _infoDefault.default), null),
        validationState: "invalid",
        width: "30px"
    });
CustomWidthSmall.story = {
    name: "custom width small"
};
const CustomHeightWithLabel = (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _form.Form), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TextArea), {
        ...args,
        label: "Custom height",
        description: "height: size-2000",
        height: "size-2000"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TextArea), {
        ...args,
        label: "Custom height",
        description: "height: size-2000",
        height: "size-2000",
        isQuiet: true
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TextArea), {
        ...args,
        labelPosition: "side",
        label: "Custom height",
        description: "height: size-2000",
        height: "size-2000"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TextArea), {
        ...args,
        labelPosition: "side",
        label: "Custom height",
        description: "height: size-2000",
        height: "size-2000",
        isQuiet: true
    }));
CustomHeightWithLabel.story = {
    name: "custom height with label"
};
const ChangeableHelptext = (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(ValidationExample, args);
ChangeableHelptext.story = {
    name: "changeable helptext",
    parameters: {
        description: {
            data: 'Verify that the changing size of the error message does not interfere with the height. To test, delete the input, then type the character "a". Height should update to match.'
        }
    }
};
const ChangeableHelptextCustomHeight = (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(ValidationExample, {
        ...args,
        height: "175px",
        minHeight: "100px",
        maxHeight: "50vh"
    });
ChangeableHelptextCustomHeight.story = {
    name: "changeable helptext custom height",
    parameters: {
        description: {
            data: 'Verify that the changing size of the error message does not interfere with the height. To test, delete the input, then type the character "a". Height should update to match.'
        }
    }
};
const ControlledInteractive = (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(ControlledTextArea, args);
ControlledInteractive.story = {
    name: "controlled interactive"
};
const InFlex = (args)=>renderInFlexRowAndBlock(args);
InFlex.story = {
    name: "in flex"
};
const InFlexValidationState = (args)=>renderInFlexRowAndBlock({
        ...args,
        validationState: "invalid"
    });
InFlexValidationState.story = {
    name: "in flex validation state"
};
function render(props = {}) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TextArea), {
        label: "Comments",
        onChange: (0, _addonActions.action)("change"),
        onFocus: (0, _addonActions.action)("focus"),
        onBlur: (0, _addonActions.action)("blur"),
        UNSAFE_className: "custom_classname",
        ...props
    });
}
function ControlledTextArea(props) {
    let [value, setValue] = (0, _react.useState)("");
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TextArea), {
        label: "megatron",
        value: value,
        onChange: setValue,
        ...props,
        isQuiet: true
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.Button), {
        variant: "primary",
        onPress: ()=>setValue("decepticons are evil transformers and should be kicked out of earth")
    }, "Set Text"));
}
function renderInFlexRowAndBlock(props = {}) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
        direction: "column",
        gap: "size-300"
    }, "Align stretch", /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
        gap: "size-100"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TextArea), {
        label: "Default",
        ...props
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TextArea), {
        label: "Quiet",
        isQuiet: true,
        ...props
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TextArea), {
        label: "Quiet",
        isQuiet: true,
        ...props
    })), "Align end", /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
        gap: "size-100",
        alignItems: "end"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TextArea), {
        label: "Default",
        ...props
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TextArea), {
        label: "Quiet",
        isQuiet: true,
        ...props
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TextArea), {
        label: "Quiet",
        isQuiet: true,
        ...props
    })), "Display block", /*#__PURE__*/ (0, _reactDefault.default).createElement("div", null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TextArea), {
        label: "Default",
        ...props
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TextArea), {
        label: "Quiet",
        isQuiet: true,
        ...props
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TextArea), {
        label: "Quiet",
        isQuiet: true,
        ...props
    })));
}
function ValidationExample(props) {
    let [value, setValue] = (0, _reactDefault.default).useState("0");
    let isValid = (0, _reactDefault.default).useMemo(()=>/^\d$/.test(value), [
        value
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TextArea), {
        ...props,
        validationState: isValid ? "valid" : "invalid",
        value: value,
        onChange: setValue,
        label: "Favorite number",
        maxLength: 1,
        description: "Enter a single digit number.",
        errorMessage: value === "" ? "Empty input not allowed." : "Single digit numbers are 0-9. Lorem ipsum dolor."
    });
}
// strings with diacritic marks
let localeStrings = {
    "ar-AE": "\u0639\u0650\u0631\u0650\u0641\u0650\u062A\u0640\u0640\u0640\u0627\u0646\u064D \u062E\u0627\u0646\u064D\u0650",
    "bg-BG": "\u0410\u0437\u0431\u0443\u0447\u0435\u043D \u0440\u0435\u0434",
    "cs-CZ": "Abecedn\xed \u0159\xe1dek",
    "da-DK": "Afbryder",
    "de-DE": "Abbruch",
    "el-GR": "\u0391\u03BB\u03C6\u03B1\u03B2\u03B7\u03C4\u03B9\u03BA\u03AE \u03B3\u03C1\u03B1\u03BC\u03BC\u03AE",
    "en-US": "123 Main St.",
    "es-ES": "L\xednea alfab\xe9tica",
    "et-EE": "T\xe4hestikuline rida",
    "fi-FI": "Aakkosellinen rivi",
    "fr-FR": "Ligne alphab\xe9tique",
    "he-IL": "\u05E9\u05D5\u05E8\u05EA \u05D0\u05DC\u05E4\u05D1\u05D9\u05EA",
    "hr-HR": "Abecedni redak",
    "hu-HU": "\xc1b\xe9c\xe9sor",
    "it-IT": "Riga alfabetica",
    "ja-JP": "\u30A2\u30EB\u30D5\u30A1\u30D9\u30C3\u30C8\u9806",
    "ko-KR": "\uC54C\uD30C\uBCB3 \uC21C\uC11C",
    "lt-LT": "Ab\u0117c\u0117lin\u0117 eilut\u0117",
    "lv-LV": "Alfab\u0113tisk\u0101 rinda",
    "nb-NO": "Alfabetisk rekkef\xf8lge",
    "nl-NL": "Alfabetische volgorde",
    "pl-PL": "Alfabetyczny wiersz",
    "pt-BR": "Linha alfab\xe9tica",
    "ro-RO": "R\xe2nd alfabetic",
    "ru-RU": "\u0410\u043B\u0444\u0430\u0432\u0438\u0442\u043D\u044B\u0439 \u043F\u043E\u0440\u044F\u0434\u043E\u043A",
    "sk-SK": "Abecedn\xfd riadok",
    "sl-SI": "Abecedni red",
    "sr-SP": "\u0410\u0431\u0435\u0446\u0435\u0434\u043D\u0438 \u0440\u0435\u0434",
    "sv-SE": "Alfabetisk ordning",
    "tr-TR": "Alfabetik s\u0131ra",
    "uk-UA": "\u0410\u043B\u0444\u0430\u0432\u0456\u0442\u043D\u0438\u0439 \u043F\u043E\u0440\u044F\u0434\u043E\u043A",
    "zh-CN": "\u5B57\u6BCD\u987A\u5E8F",
    "zh-TW": "\u5B57\u6BCD\u9806\u5E8F"
};
// https://lingojam.com/ZalgoText
let zalgoString = "i\u0336\u030A\u0341\u0303\u031A\u0312\u035D\u0304\u0346\u0356t\u0336\u0300\u0300\u0352\u0342\u0350\u0310\u0304\u0307\u0341\u0352\u0305\u0306\u0341\u033A\u0322\u033B\u0318\u0322\u0316\u0317\u0327\u0349\u031F\u031E\u032D'\u0336\u0311\u035D\u0351\u035B\u0350\u035D\u034B\u0344\u0306\u0307\u0343\u032F\u0333s\u0335\u0309\u0344\u0310\u030C\u030C\u0303\u0343\u035D\u0359\u0347\u0349\u032A \u0334\u030F\u035D\u030D\u030C\u0340\u0315\u0319\u0318\u0319m\u0336\u0304\u0352\u0303\u030A\u0341\u034B\u030E\u0301\u0346\u030D\u0343\u0351\u0305\u0330\u0325\u0347\u035Ce\u0335\u031B\u0346\u033E\u031A\u0301\u0360\u0341\u030E\u030A\u034C\u0315\u0312\u0341\u0357\u032A\u031C\u032F\u0353\u0345\u0327\u0348\u0330\u0330\u0331\u0320,\u0337\u034A\u0309\u035D\u0312\u030E\u034A\u032B\u0331\u0356\u0316 \u0335\u0344\u033E\u0303\u030B\u0352\u0303\u0307\u0314\u031B\u0300\u031D\u0333\u0345\u0326\u0359\u0321\u035A\u0323\u0327\u0329\u035C\u031C\u0359i\u0335\u0310\u0345\u032F\u0330\u0330\u0349\u033A\u034E\u0316'\u0337\u030A\u0350\u031A\u0351\u0357\u0341\u0315\u0352\u034C\u035D\u0341\u035B\u035Am\u0334\u0315\u033D\u0358\u0346\u0360\u0357\u030C\u0308\u0307\u034B\u030D\u032F\u0328\u031E\u0347\u0324\u034E\u0325\u032B\u0327\u0329\u0354\u0356\u032E\u0316\u0332 \u0338\u0311\u030C\u030D\u034B\u0303\u035A\u031E\u0320\u0326t\u0337\u0343\u035B\u0309\u0318\u031D\u0318\u0323\u032E\u0353\u0320\u032E\u0324\u034D\u0355h\u0336\u0343\u031B\u0346\u0310\u035D\u0360\u033D\u0312\u0344\u0354\u0333\u031F\u0329\u0326\u034D\u0324\u0325\u0325\u0326\u0317\u034D\u0356e\u0337\u0304\u0306\u0342\u031B\u0307\u035D\u033F\u030B\u0307\u0313\u0302\u030B\u0352\u0302\u0342\u0353\u032B\u031C\u0355\u0348\u0359\u032E\u0355\u031D\u0359 \u0338\u0313\u0308\u0311\u0301\u0358\u035D\u0307\u0308\u0300\u0350\u034C\u0342\u035B\u034C\u0305\u0348\u0345\u0320\u031F\u0324\u0347\u031F\u0317\u033C\u0328\u0332\u032F\u032D\u035Cp\u0334\u030E\u031B\u0305\u0341\u030F\u031B\u0302\u0301\u0310\u033E\u035D\u0343\u0343\u034C\u0327\u033A\u0329\u0327\u0329\u0318\u0332\u031C\u0330\u0329\u035A\u033B\u032C\u0320r\u0337\u0312\u030A\u0312\u035B\u0314\u031C\u0331o\u0337\u0313\u0344\u033D\u0308\u030D\u0308\u030C\u0302\u031B\u031A\u035D\u035D\u0340\u033C\u031D\u0325\u033A\u034E\u035A\u035A\u0347\u031D\u032Bb\u0335\u030D\u0357\u035D\u0350\u0331\u0320\u033C\u0354\u0359\u0326\u031D\u0320\u0333\u0324l\u0337\u031B\u030B\u035B\u0330\u0332\u033A\u032B\u032D\u0333\u0339\u032C\u0333\u0324\u0331\u034Ee\u0337\u0352\u0327m\u0335\u030E\u0310\u0313\u030F\u0312\u0357\u0333\u031F\u0349\u032A\u031E,\u0336\u0313\u034B\u0315\u0304\u030B\u035B\u0341\u0304\u035D\u034D\u0325\u0317\u033A\u0328\u032E\u0330\u032C\u034D \u0337\u034C\u0308\u0303\u035D\u035D\u0303\u0344\u0303\u030D\u030A\u0327\u032B\u0345\u032F\u0318\u0323\u0320\u032E\u0355\u032A\u0348\u0323\u0321\u0339\u0327i\u0338\u0357\u033D\u030B\u034A\u030D\u035B\u0342\u030A\u0343\u0311\u0305\u034B\u033F\u0332\u0320\u0324\u0333\u0328t\u0336\u034A\u031B\u030B\u0350\u0310\u0315\u034C\u0352\u030A\u033F\u0358\u0332\u0348\u0347\u0347'\u0338\u033F\u034C\u034D\u0320\u0332\u0324\u0327\u0320\u031D\u0329\u031Fs\u0337\u0301\u0305\u0307\u035B\u035B\u0344\u0305\u0311\u0307\u0314\u030C\u035D\u0346\u0333\u0347 \u0335\u0352\u0307\u0314\u0357\u0358\u031B\u0331\u0345\u033A\u0319\u032Am\u0336\u0309\u030F\u035D\u0351\u0315\u0324\u031F\u0359\u0349\u0322\u0320\u0323\u033A\u0325\u032B\u0359\u0339\u0349\u0327\u032Ce\u0334\u0315\u0352\u0301\u0311\u0303\u032A\u0325\u032A\u0320\u031C\u033B\u032A\u034E\u034E\u0331\u0331\u032F\u031C";
function DefaultLocaleStrings(props) {
    let locale = (0, _reactSpectrum.useLocale)();
    let [isZalgo, setValue] = (0, _reactDefault.default).useState(false);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TextArea), {
        label: "Sampling of diacritics",
        value: isZalgo ? zalgoString : localeStrings[locale.locale],
        UNSAFE_className: "custom_classname",
        ...props
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), {
        onPress: ()=>setValue((prev)=>!prev)
    }, "Toggle Zalgo"));
}
const WithDifferentLocaleText = {
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(DefaultLocaleStrings, args)
};

},{"@storybook/addon-actions":"coXbW","@react-spectrum/button":"jZWyP","@adobe/react-spectrum":"cwANo","@react-spectrum/layout":"hzaUY","@react-spectrum/form":"bGDqA","@spectrum-icons/workflow/Info":"dNHFs","react":"9yzVZ","../":"cjlRh","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"cjlRh":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _src = require("./src");
parcelHelpers.exportAll(_src, exports);

},{"./src":"hOmtq","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"a4Pip":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Default", ()=>Default);
parcelHelpers.export(exports, "ValueTestControlled", ()=>ValueTestControlled);
parcelHelpers.export(exports, "DefaultValueTestUncontrolled", ()=>DefaultValueTestUncontrolled);
parcelHelpers.export(exports, "TypeEmail", ()=>TypeEmail);
parcelHelpers.export(exports, "Pattern09", ()=>Pattern09);
parcelHelpers.export(exports, "AutoFocusTrue", ()=>AutoFocusTrue);
parcelHelpers.export(exports, "IconInfo", ()=>IconInfo);
parcelHelpers.export(exports, "NoVisibleLabel", ()=>NoVisibleLabel);
parcelHelpers.export(exports, "WithDescription", ()=>WithDescription);
parcelHelpers.export(exports, "WithErrorMessage", ()=>WithErrorMessage);
parcelHelpers.export(exports, "WithDescriptionErrorMessageAndValidation", ()=>WithDescriptionErrorMessageAndValidation);
parcelHelpers.export(exports, "WithContextualHelp", ()=>WithContextualHelp);
parcelHelpers.export(exports, "CustomWidth", ()=>CustomWidth);
parcelHelpers.export(exports, "CustomWidthSmall", ()=>CustomWidthSmall);
parcelHelpers.export(exports, "WithDifferentLocaleText", ()=>WithDifferentLocaleText);
var _addonActions = require("@storybook/addon-actions");
var _reactSpectrum = require("@adobe/react-spectrum");
var _info = require("@spectrum-icons/workflow/Info");
var _infoDefault = parcelHelpers.interopDefault(_info);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _ = require("../");
exports.default = {
    title: "TextField",
    component: (0, _.TextField),
    providerSwitcher: {
        status: "positive"
    },
    args: {
        label: "Street address",
        isQuiet: false,
        isDisabled: false,
        isReadOnly: false,
        isRequired: false,
        necessityIndicator: "icon",
        labelPosition: "top",
        labelAlign: "start",
        validationState: null
    },
    argTypes: {
        labelPosition: {
            control: {
                type: "radio",
                options: [
                    "top",
                    "side"
                ]
            }
        },
        necessityIndicator: {
            control: {
                type: "radio",
                options: [
                    "icon",
                    "label"
                ]
            }
        },
        labelAlign: {
            control: {
                type: "radio",
                options: [
                    "start",
                    "end"
                ]
            }
        },
        validationState: {
            control: {
                type: "radio",
                options: [
                    null,
                    "valid",
                    "invalid"
                ]
            }
        }
    }
};
const Default = {
    render: (args)=>render(args)
};
const ValueTestControlled = {
    render: (args)=>render({
            ...args,
            value: "Test"
        }),
    name: "value: Test (controlled)"
};
const DefaultValueTestUncontrolled = {
    render: (args)=>render({
            ...args,
            defaultValue: "Test"
        }),
    name: "defaultValue: Test (uncontrolled)"
};
const TypeEmail = {
    render: (args)=>render({
            ...args,
            type: "email"
        }),
    name: "type: email"
};
const Pattern09 = {
    render: (args)=>render({
            ...args,
            pattern: "[0-9]+"
        }),
    name: "pattern: [0-9]+"
};
const AutoFocusTrue = {
    render: (args)=>render({
            ...args,
            autoFocus: true
        }),
    name: "autoFocus: true"
};
const IconInfo = {
    render: (args)=>render({
            ...args,
            icon: /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _infoDefault.default), null)
        }),
    name: "icon: Info"
};
const NoVisibleLabel = {
    render: (args)=>render({
            ...args,
            label: null,
            "aria-label": "Street address"
        }),
    name: "no visible label"
};
const WithDescription = {
    render: (args)=>render({
            ...args,
            description: "Please enter your street address."
        }),
    name: "with description"
};
const WithErrorMessage = {
    render: (args)=>render({
            ...args,
            errorMessage: "Please enter a valid street address.",
            validationState: "invalid"
        }),
    name: "with error message"
};
const WithDescriptionErrorMessageAndValidation = {
    render: (args)=>renderWithDescriptionErrorMessageAndValidation(args),
    name: "with description, error message and validation"
};
const WithContextualHelp = {
    render: (args)=>render({
            ...args,
            contextualHelp: /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSpectrum.ContextualHelp), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSpectrum.Heading), null, "What is a segment?"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSpectrum.Content), null, "Segments identify who your visitors are, what devices and services they use, where they navigated from, and much more."))
        }),
    name: "with contextual help"
};
const CustomWidth = {
    render: (args)=>render({
            ...args,
            icon: /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _infoDefault.default), null),
            validationState: "invalid",
            width: "300px"
        }),
    name: "custom width"
};
const CustomWidthSmall = {
    render: (args)=>render({
            ...args,
            icon: /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _infoDefault.default), null),
            validationState: "invalid",
            width: "30px"
        }),
    name: "custom width small"
};
// strings with diacritic marks
let localeStrings = {
    "ar-AE": "\u0639\u0650\u0631\u0650\u0641\u0650\u062A\u0640\u0640\u0640\u0627\u0646\u064D \u062E\u0627\u0646\u064D\u0650",
    "bg-BG": "\u0410\u0437\u0431\u0443\u0447\u0435\u043D \u0440\u0435\u0434",
    "cs-CZ": "Abecedn\xed \u0159\xe1dek",
    "da-DK": "Afbryder",
    "de-DE": "Abbruch",
    "el-GR": "\u0391\u03BB\u03C6\u03B1\u03B2\u03B7\u03C4\u03B9\u03BA\u03AE \u03B3\u03C1\u03B1\u03BC\u03BC\u03AE",
    "en-US": "123 Main St.",
    "es-ES": "L\xednea alfab\xe9tica",
    "et-EE": "T\xe4hestikuline rida",
    "fi-FI": "Aakkosellinen rivi",
    "fr-FR": "Ligne alphab\xe9tique",
    "he-IL": "\u05E9\u05D5\u05E8\u05EA \u05D0\u05DC\u05E4\u05D1\u05D9\u05EA",
    "hr-HR": "Abecedni redak",
    "hu-HU": "\xc1b\xe9c\xe9sor",
    "it-IT": "Riga alfabetica",
    "ja-JP": "\u30A2\u30EB\u30D5\u30A1\u30D9\u30C3\u30C8\u9806",
    "ko-KR": "\uC54C\uD30C\uBCB3 \uC21C\uC11C",
    "lt-LT": "Ab\u0117c\u0117lin\u0117 eilut\u0117",
    "lv-LV": "Alfab\u0113tisk\u0101 rinda",
    "nb-NO": "Alfabetisk rekkef\xf8lge",
    "nl-NL": "Alfabetische volgorde",
    "pl-PL": "Alfabetyczny wiersz",
    "pt-BR": "Linha alfab\xe9tica",
    "ro-RO": "R\xe2nd alfabetic",
    "ru-RU": "\u0410\u043B\u0444\u0430\u0432\u0438\u0442\u043D\u044B\u0439 \u043F\u043E\u0440\u044F\u0434\u043E\u043A",
    "sk-SK": "Abecedn\xfd riadok",
    "sl-SI": "Abecedni red",
    "sr-SP": "\u0410\u0431\u0435\u0446\u0435\u0434\u043D\u0438 \u0440\u0435\u0434",
    "sv-SE": "Alfabetisk ordning",
    "tr-TR": "Alfabetik s\u0131ra",
    "uk-UA": "\u0410\u043B\u0444\u0430\u0432\u0456\u0442\u043D\u0438\u0439 \u043F\u043E\u0440\u044F\u0434\u043E\u043A",
    "zh-CN": "\u5B57\u6BCD\u987A\u5E8F",
    "zh-TW": "\u5B57\u6BCD\u9806\u5E8F"
};
// https://lingojam.com/ZalgoText
let zalgoString = "i\u0336\u030A\u0341\u0303\u031A\u0312\u035D\u0304\u0346\u0356t\u0336\u0300\u0300\u0352\u0342\u0350\u0310\u0304\u0307\u0341\u0352\u0305\u0306\u0341\u033A\u0322\u033B\u0318\u0322\u0316\u0317\u0327\u0349\u031F\u031E\u032D'\u0336\u0311\u035D\u0351\u035B\u0350\u035D\u034B\u0344\u0306\u0307\u0343\u032F\u0333s\u0335\u0309\u0344\u0310\u030C\u030C\u0303\u0343\u035D\u0359\u0347\u0349\u032A \u0334\u030F\u035D\u030D\u030C\u0340\u0315\u0319\u0318\u0319m\u0336\u0304\u0352\u0303\u030A\u0341\u034B\u030E\u0301\u0346\u030D\u0343\u0351\u0305\u0330\u0325\u0347\u035Ce\u0335\u031B\u0346\u033E\u031A\u0301\u0360\u0341\u030E\u030A\u034C\u0315\u0312\u0341\u0357\u032A\u031C\u032F\u0353\u0345\u0327\u0348\u0330\u0330\u0331\u0320,\u0337\u034A\u0309\u035D\u0312\u030E\u034A\u032B\u0331\u0356\u0316 \u0335\u0344\u033E\u0303\u030B\u0352\u0303\u0307\u0314\u031B\u0300\u031D\u0333\u0345\u0326\u0359\u0321\u035A\u0323\u0327\u0329\u035C\u031C\u0359i\u0335\u0310\u0345\u032F\u0330\u0330\u0349\u033A\u034E\u0316'\u0337\u030A\u0350\u031A\u0351\u0357\u0341\u0315\u0352\u034C\u035D\u0341\u035B\u035Am\u0334\u0315\u033D\u0358\u0346\u0360\u0357\u030C\u0308\u0307\u034B\u030D\u032F\u0328\u031E\u0347\u0324\u034E\u0325\u032B\u0327\u0329\u0354\u0356\u032E\u0316\u0332 \u0338\u0311\u030C\u030D\u034B\u0303\u035A\u031E\u0320\u0326t\u0337\u0343\u035B\u0309\u0318\u031D\u0318\u0323\u032E\u0353\u0320\u032E\u0324\u034D\u0355h\u0336\u0343\u031B\u0346\u0310\u035D\u0360\u033D\u0312\u0344\u0354\u0333\u031F\u0329\u0326\u034D\u0324\u0325\u0325\u0326\u0317\u034D\u0356e\u0337\u0304\u0306\u0342\u031B\u0307\u035D\u033F\u030B\u0307\u0313\u0302\u030B\u0352\u0302\u0342\u0353\u032B\u031C\u0355\u0348\u0359\u032E\u0355\u031D\u0359 \u0338\u0313\u0308\u0311\u0301\u0358\u035D\u0307\u0308\u0300\u0350\u034C\u0342\u035B\u034C\u0305\u0348\u0345\u0320\u031F\u0324\u0347\u031F\u0317\u033C\u0328\u0332\u032F\u032D\u035Cp\u0334\u030E\u031B\u0305\u0341\u030F\u031B\u0302\u0301\u0310\u033E\u035D\u0343\u0343\u034C\u0327\u033A\u0329\u0327\u0329\u0318\u0332\u031C\u0330\u0329\u035A\u033B\u032C\u0320r\u0337\u0312\u030A\u0312\u035B\u0314\u031C\u0331o\u0337\u0313\u0344\u033D\u0308\u030D\u0308\u030C\u0302\u031B\u031A\u035D\u035D\u0340\u033C\u031D\u0325\u033A\u034E\u035A\u035A\u0347\u031D\u032Bb\u0335\u030D\u0357\u035D\u0350\u0331\u0320\u033C\u0354\u0359\u0326\u031D\u0320\u0333\u0324l\u0337\u031B\u030B\u035B\u0330\u0332\u033A\u032B\u032D\u0333\u0339\u032C\u0333\u0324\u0331\u034Ee\u0337\u0352\u0327m\u0335\u030E\u0310\u0313\u030F\u0312\u0357\u0333\u031F\u0349\u032A\u031E,\u0336\u0313\u034B\u0315\u0304\u030B\u035B\u0341\u0304\u035D\u034D\u0325\u0317\u033A\u0328\u032E\u0330\u032C\u034D \u0337\u034C\u0308\u0303\u035D\u035D\u0303\u0344\u0303\u030D\u030A\u0327\u032B\u0345\u032F\u0318\u0323\u0320\u032E\u0355\u032A\u0348\u0323\u0321\u0339\u0327i\u0338\u0357\u033D\u030B\u034A\u030D\u035B\u0342\u030A\u0343\u0311\u0305\u034B\u033F\u0332\u0320\u0324\u0333\u0328t\u0336\u034A\u031B\u030B\u0350\u0310\u0315\u034C\u0352\u030A\u033F\u0358\u0332\u0348\u0347\u0347'\u0338\u033F\u034C\u034D\u0320\u0332\u0324\u0327\u0320\u031D\u0329\u031Fs\u0337\u0301\u0305\u0307\u035B\u035B\u0344\u0305\u0311\u0307\u0314\u030C\u035D\u0346\u0333\u0347 \u0335\u0352\u0307\u0314\u0357\u0358\u031B\u0331\u0345\u033A\u0319\u032Am\u0336\u0309\u030F\u035D\u0351\u0315\u0324\u031F\u0359\u0349\u0322\u0320\u0323\u033A\u0325\u032B\u0359\u0339\u0349\u0327\u032Ce\u0334\u0315\u0352\u0301\u0311\u0303\u032A\u0325\u032A\u0320\u031C\u033B\u032A\u034E\u034E\u0331\u0331\u032F\u031C";
function DefaultLocaleStrings(props) {
    let locale = (0, _reactSpectrum.useLocale)();
    let [isZalgo, setValue] = (0, _reactDefault.default).useState(false);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TextField), {
        label: "Sampling of diacritics",
        value: isZalgo ? zalgoString : localeStrings[locale.locale],
        UNSAFE_className: "custom_classname",
        ...props
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSpectrum.ActionButton), {
        onPress: ()=>setValue((prev)=>!prev)
    }, "Toggle Zalgo"));
}
const WithDifferentLocaleText = {
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(DefaultLocaleStrings, args)
};
function render(props = {}) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TextField), {
        label: "Street address",
        onChange: (0, _addonActions.action)("change"),
        onFocus: (0, _addonActions.action)("focus"),
        onBlur: (0, _addonActions.action)("blur"),
        UNSAFE_className: "custom_classname",
        ...props
    });
}
function renderWithDescriptionErrorMessageAndValidation(props) {
    function Example() {
        let [value, setValue] = (0, _reactDefault.default).useState("0");
        let isValid = (0, _reactDefault.default).useMemo(()=>/^\d$/.test(value), [
            value
        ]);
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.TextField), {
            ...props,
            validationState: isValid ? "valid" : "invalid",
            value: value,
            onChange: setValue,
            label: "Favorite number",
            maxLength: 1,
            description: "Enter a single digit number.",
            errorMessage: value === "" ? "Empty input not allowed." : "Single digit numbers are 0-9."
        });
    }
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Example, null);
}

},{"@storybook/addon-actions":"coXbW","@adobe/react-spectrum":"cwANo","@spectrum-icons/workflow/Info":"dNHFs","react":"9yzVZ","../":"cjlRh","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"bAwHT":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Default", ()=>Default);
parcelHelpers.export(exports, "WithAction", ()=>WithAction);
parcelHelpers.export(exports, "WithDialog", ()=>WithDialog);
parcelHelpers.export(exports, "MultipleToastContainers", ()=>MultipleToastContainers);
parcelHelpers.export(exports, "ProgrammaticallyClosing", ()=>ProgrammaticallyClosing);
parcelHelpers.export(exports, "WithIframe", ()=>WithIframe);
var _addonActions = require("@storybook/addon-actions");
var _button = require("@react-spectrum/button");
var _buttongroup = require("@react-spectrum/buttongroup");
var _checkbox = require("@react-spectrum/checkbox");
var _view = require("@react-spectrum/view");
var _landmark = require("@react-aria/landmark");
var _dialog = require("@react-spectrum/dialog");
var _layout = require("@react-spectrum/layout");
var _text = require("@react-spectrum/text");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _ = require("../");
exports.default = {
    title: "Toast",
    decorators: [
        (story, { parameters })=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, !parameters.disableToastContainer && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ToastContainer), null), /*#__PURE__*/ (0, _reactDefault.default).createElement(MainLandmark, null, story()))
    ],
    args: {
        shouldCloseOnAction: false,
        timeout: null
    },
    argTypes: {
        timeout: {
            control: {
                type: "radio",
                options: [
                    null,
                    5000
                ]
            }
        }
    }
};
const Default = (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(RenderProvider, args);
Default.story = {
    parameters: {
        a11y: {
            config: {
                rules: [
                    // Ignore landmark accessibility failures since the extra main is just for testing purposes
                    // and not a explicit part of the Toast component
                    {
                        id: "landmark-main-is-top-level",
                        enabled: false
                    },
                    {
                        id: "landmark-no-duplicate-main",
                        enabled: false
                    },
                    {
                        id: "landmark-unique",
                        enabled: false
                    }
                ]
            }
        }
    }
};
const WithAction = (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(RenderProvider, {
        ...args,
        actionLabel: "Action",
        onAction: (0, _addonActions.action)("onAction")
    });
WithAction.story = {
    name: "With action",
    parameters: {
        a11y: {
            config: {
                rules: [
                    {
                        id: "landmark-main-is-top-level",
                        enabled: false
                    },
                    {
                        id: "landmark-no-duplicate-main",
                        enabled: false
                    },
                    {
                        id: "landmark-unique",
                        enabled: false
                    }
                ]
            }
        }
    }
};
const WithDialog = (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _dialog.DialogTrigger), {
        isDismissable: true
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.Button), {
        variant: "accent"
    }, "Open dialog"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _dialog.Dialog), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Heading), null, "Toasty"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _view.Content), null, /*#__PURE__*/ (0, _reactDefault.default).createElement(RenderProvider, args))));
WithDialog.story = {
    name: "With dialog",
    parameters: {
        a11y: {
            config: {
                rules: [
                    {
                        id: "landmark-main-is-top-level",
                        enabled: false
                    },
                    {
                        id: "landmark-no-duplicate-main",
                        enabled: false
                    },
                    {
                        id: "landmark-unique",
                        enabled: false
                    }
                ]
            }
        }
    }
};
const MultipleToastContainers = (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(Multiple, args);
MultipleToastContainers.story = {
    name: "multiple ToastContainers",
    parameters: {
        disableToastContainer: true,
        a11y: {
            config: {
                rules: [
                    {
                        id: "landmark-main-is-top-level",
                        enabled: false
                    },
                    {
                        id: "landmark-no-duplicate-main",
                        enabled: false
                    },
                    {
                        id: "landmark-unique",
                        enabled: false
                    }
                ]
            }
        }
    }
};
const ProgrammaticallyClosing = (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(ToastToggle, args);
ProgrammaticallyClosing.story = {
    name: "programmatically closing",
    parameters: {
        a11y: {
            config: {
                rules: [
                    {
                        id: "landmark-main-is-top-level",
                        enabled: false
                    },
                    {
                        id: "landmark-no-duplicate-main",
                        enabled: false
                    },
                    {
                        id: "landmark-unique",
                        enabled: false
                    }
                ]
            }
        }
    }
};
const WithIframe = ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement(IframeExample, null);
WithIframe.story = {
    name: "with iframe",
    parameters: {
        a11y: {
            config: {
                rules: [
                    {
                        id: "aria-allowed-role",
                        selector: '*:not(iframe[role="main"])'
                    },
                    {
                        id: "landmark-main-is-top-level",
                        enabled: false
                    },
                    {
                        id: "landmark-no-duplicate-main",
                        enabled: false
                    },
                    {
                        id: "landmark-unique",
                        enabled: false
                    }
                ]
            }
        }
    }
};
function RenderProvider(options) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _buttongroup.ButtonGroup), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.Button), {
        onPress: ()=>(0, _.ToastQueue).neutral("Toast available", {
                ...options,
                onClose: (0, _addonActions.action)("onClose")
            }),
        variant: "secondary"
    }, "Show Neutral Toast"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.Button), {
        onPress: ()=>(0, _.ToastQueue).positive("Toast is done!", {
                ...options,
                onClose: (0, _addonActions.action)("onClose")
            }),
        variant: "primary"
    }, "Show Positive Toast"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.Button), {
        onPress: ()=>(0, _.ToastQueue).negative("Toast is burned!", {
                ...options,
                onClose: (0, _addonActions.action)("onClose")
            }),
        variant: "negative"
    }, "Show Negative Toast"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.Button), {
        onPress: ()=>(0, _.ToastQueue).info("Toasting\u2026", {
                ...options,
                onClose: (0, _addonActions.action)("onClose")
            }),
        variant: "accent",
        style: "outline"
    }, "Show Info Toast"));
}
function ToastToggle(options) {
    let [close, setClose] = (0, _react.useState)(null);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.Button), {
        onPress: ()=>{
            if (!close) {
                let close = (0, _.ToastQueue).negative("Unable to save", {
                    ...options,
                    onClose: ()=>setClose(null)
                });
                setClose(()=>close);
            } else close();
        },
        variant: "primary"
    }, close ? "Hide" : "Show", " Toast");
}
function Multiple(options) {
    let [isMounted1, setMounted1] = (0, _react.useState)(true);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
        direction: "column"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _checkbox.Checkbox), {
        isSelected: isMounted1,
        onChange: setMounted1
    }, "First mounted"), isMounted1 && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ToastContainer), null), /*#__PURE__*/ (0, _reactDefault.default).createElement(MultipleInner, null), /*#__PURE__*/ (0, _reactDefault.default).createElement(RenderProvider, options));
}
function MultipleInner() {
    let [isMounted2, setMounted2] = (0, _react.useState)(true);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _checkbox.Checkbox), {
        isSelected: isMounted2,
        onChange: setMounted2
    }, "Second mounted"), isMounted2 && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.ToastContainer), null));
}
function IframeExample() {
    let controller = (0, _react.useMemo)(()=>(0, _landmark.createLandmarkController)(), []);
    (0, _react.useEffect)(()=>()=>controller.dispose(), [
        controller
    ]);
    let onLoad = (e)=>{
        let iframe = e.target;
        let window1 = iframe.contentWindow;
        let document = window1.document;
        // Catch toasts inside the iframe and redirect them outside.
        window1.addEventListener("react-spectrum-toast", (e)=>{
            e.preventDefault();
            (0, _.ToastQueue)[e.detail.variant](e.detail.children, e.detail.options);
        });
        let prevFocusedElement = null;
        window1.addEventListener("react-aria-landmark-navigation", (e)=>{
            e.preventDefault();
            let el = document.activeElement;
            if (el !== document.body) prevFocusedElement = el;
            // Prevent focus scope from stealing focus back when we move focus to the iframe.
            document.body.setAttribute("data-react-aria-top-layer", "true");
            window1.parent.postMessage({
                type: "landmark-navigation",
                direction: e.detail.direction
            });
            setTimeout(()=>{
                document.body.removeAttribute("data-react-aria-top-layer");
            }, 100);
        });
        // When the iframe is re-focused, restore focus back inside where it was before.
        window1.addEventListener("focus", ()=>{
            if (prevFocusedElement) {
                prevFocusedElement.focus();
                prevFocusedElement = null;
            }
        });
        // Move focus to first or last landmark when we receive a message from the parent page.
        window1.addEventListener("message", (e)=>{
            if (e.data.type === "landmark-navigation") // (Can't use LandmarkController in this example because we need the controller instance inside the iframe)
            document.body.dispatchEvent(new KeyboardEvent("keydown", {
                key: "F6",
                shiftKey: e.data.direction === "backward",
                bubbles: true
            }));
        });
    };
    (0, _react.useEffect)(()=>{
        let onMessage = (e)=>{
            let iframe = ref.current;
            if (e.data.type === "landmark-navigation") {
                // Move focus to the iframe so that when focus is restored there, and we can redirect it back inside (below).
                iframe.focus();
                // Now re-dispatch the keyboard event so landmark navigation outside the iframe picks it up.
                controller.navigate(e.data.direction);
            }
        };
        window.addEventListener("message", onMessage);
        return ()=>window.removeEventListener("message", onMessage);
    }, [
        controller
    ]);
    let ref = (0, _react.useRef)(null);
    let { landmarkProps } = (0, _landmark.useLandmark)({
        role: "main",
        focus (direction) {
            // when iframe landmark receives focus via landmark navigation, go to first/last landmark inside iframe.
            ref.current.contentWindow.postMessage({
                type: "landmark-navigation",
                direction
            });
        }
    }, ref);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("iframe", {
        ref: ref,
        ...landmarkProps,
        title: "iframe",
        width: "500",
        height: "500",
        src: "iframe.html?providerSwitcher-express=false&providerSwitcher-toastPosition=bottom&viewMode=story&id=toast--with-dialog",
        onLoad: onLoad,
        tabIndex: -1
    });
}
function MainLandmark(props) {
    let ref = (0, _react.useRef)();
    let { landmarkProps } = (0, _landmark.useLandmark)({
        ...props,
        role: "main"
    }, ref);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("main", {
        "aria-label": "Danni's unicorn corral",
        ref: ref,
        ...props,
        ...landmarkProps,
        style: {
            padding: 40,
            background: "white"
        }
    }, props.children);
}

},{"@storybook/addon-actions":"coXbW","@react-spectrum/button":"jZWyP","@react-spectrum/buttongroup":"anP11","@react-spectrum/checkbox":"1r19j","@react-spectrum/view":"dnRjt","@react-aria/landmark":"8X64T","@react-spectrum/dialog":"3G0HV","@react-spectrum/layout":"hzaUY","@react-spectrum/text":"etCGI","react":"9yzVZ","../":"if2cM","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"if2cM":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _src = require("./src");
parcelHelpers.exportAll(_src, exports);

},{"./src":"hiksm","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"hiksm":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /// <reference types="css-module-types" />
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ToastContainer", ()=>(0, _toastContainer.ToastContainer));
parcelHelpers.export(exports, "ToastQueue", ()=>(0, _toastContainer.ToastQueue));
var _toastContainer = require("./ToastContainer");

},{"./ToastContainer":"gE2vH","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"gE2vH":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// For testing. Not exported from the package index.
parcelHelpers.export(exports, "clearToastQueue", ()=>clearToastQueue);
/**
 * A ToastContainer renders the queued toasts in an application. It should be placed
 * at the root of the app.
 */ parcelHelpers.export(exports, "ToastContainer", ()=>ToastContainer);
parcelHelpers.export(exports, "ToastQueue", ()=>SpectrumToastQueue);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _toast = require("./Toast");
var _toaster = require("./Toaster");
var _toast1 = require("@react-stately/toast");
var _indexJs = require("use-sync-external-store/shim/index.js");
// There is a single global toast queue instance for the whole app, initialized lazily.
let globalToastQueue = null;
function getGlobalToastQueue() {
    if (!globalToastQueue) globalToastQueue = new (0, _toast1.ToastQueue)({
        maxVisibleToasts: 1,
        hasExitAnimation: true
    });
    return globalToastQueue;
}
function clearToastQueue() {
    globalToastQueue = null;
}
let toastProviders = new Set();
let subscriptions = new Set();
function subscribe(fn) {
    subscriptions.add(fn);
    return ()=>subscriptions.delete(fn);
}
function triggerSubscriptions() {
    for (let fn of subscriptions)fn();
}
function getActiveToastContainer() {
    return toastProviders.values().next().value;
}
function useActiveToastContainer() {
    return (0, _indexJs.useSyncExternalStore)(subscribe, getActiveToastContainer, getActiveToastContainer);
}
function ToastContainer(props) {
    // Track all toast provider instances in a set.
    // Only the first one will actually render.
    // We use a ref to do this, since it will have a stable identity
    // over the lifetime of the component.
    let ref = (0, _react.useRef)();
    // eslint-disable-next-line arrow-body-style
    (0, _react.useEffect)(()=>{
        toastProviders.add(ref);
        triggerSubscriptions();
        return ()=>{
            // When this toast provider unmounts, reset all animations so that
            // when the new toast provider renders, it is seamless.
            for (let toast of getGlobalToastQueue().visibleToasts)toast.animation = null;
            // Remove this toast provider, and call subscriptions.
            // This will cause all other instances to re-render,
            // and the first one to become the new active toast provider.
            toastProviders.delete(ref);
            triggerSubscriptions();
        };
    }, []);
    // Only render if this is the active toast provider instance, and there are visible toasts.
    let activeToastContainer = useActiveToastContainer();
    let state = (0, _toast1.useToastQueue)(getGlobalToastQueue());
    if (ref === activeToastContainer && state.visibleToasts.length > 0) return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _toaster.Toaster), {
        state: state,
        ...props
    }, state.visibleToasts.map((toast)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _toast.Toast), {
            key: toast.key,
            toast: toast,
            state: state
        })));
    return null;
}
function addToast(children, variant, options = {}) {
    // Dispatch a custom event so that toasts can be intercepted and re-targeted, e.g. when inside an iframe.
    if (typeof CustomEvent !== "undefined" && typeof window !== "undefined") {
        let event = new CustomEvent("react-spectrum-toast", {
            cancelable: true,
            bubbles: true,
            detail: {
                children,
                variant,
                options
            }
        });
        let shouldContinue = window.dispatchEvent(event);
        if (!shouldContinue) return;
    }
    let value = {
        children,
        variant,
        actionLabel: options.actionLabel,
        onAction: options.onAction,
        shouldCloseOnAction: options.shouldCloseOnAction
    };
    // Minimum time of 5s from https://spectrum.adobe.com/page/toast/#Auto-dismissible
    // Actionable toasts cannot be auto dismissed. That would fail WCAG SC 2.2.1.
    // It is debatable whether non-actionable toasts would also fail.
    let timeout = options.timeout && !options.onAction ? Math.max(options.timeout, 5000) : null;
    let queue = getGlobalToastQueue();
    let key = queue.add(value, {
        priority: getPriority(variant, options),
        timeout,
        onClose: options.onClose
    });
    return ()=>queue.close(key);
}
const SpectrumToastQueue = {
    /** Queues a neutral toast. */ neutral (children, options = {}) {
        return addToast(children, "neutral", options);
    },
    /** Queues a positive toast. */ positive (children, options = {}) {
        return addToast(children, "positive", options);
    },
    /** Queues a negative toast. */ negative (children, options = {}) {
        return addToast(children, "negative", options);
    },
    /** Queues an informational toast. */ info (children, options = {}) {
        return addToast(children, "info", options);
    }
};
// https://spectrum.adobe.com/page/toast/#Priority-queue
// TODO: if a lower priority toast comes in, no way to know until you dismiss the higher priority one.
const VARIANT_PRIORITY = {
    negative: 10,
    positive: 3,
    info: 2,
    neutral: 1
};
function getPriority(variant, options) {
    let priority = VARIANT_PRIORITY[variant] || 1;
    if (options.onAction) priority += 4;
    return priority;
}

},{"react":"9yzVZ","./Toast":"ipNc1","./Toaster":"8VfjV","@react-stately/toast":"3XbaS","use-sync-external-store/shim/index.js":"41GFF","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"ipNc1":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ICONS", ()=>ICONS);
parcelHelpers.export(exports, "Toast", ()=>_Toast);
var _alertMedium = require("@spectrum-icons/ui/AlertMedium");
var _alertMediumDefault = parcelHelpers.interopDefault(_alertMedium);
var _button = require("@react-spectrum/button");
var _utils = require("@react-spectrum/utils");
var _crossMedium = require("@spectrum-icons/ui/CrossMedium");
var _crossMediumDefault = parcelHelpers.interopDefault(_crossMedium);
var _infoMedium = require("@spectrum-icons/ui/InfoMedium");
var _infoMediumDefault = parcelHelpers.interopDefault(_infoMedium);
// @ts-ignore
var _json = require("../intl/*.json");
var _jsonDefault = parcelHelpers.interopDefault(_json);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _varsCss = require("@adobe/spectrum-css-temp/components/toast/vars.css");
var _varsCssDefault = parcelHelpers.interopDefault(_varsCss);
var _successMedium = require("@spectrum-icons/ui/SuccessMedium");
var _successMediumDefault = parcelHelpers.interopDefault(_successMedium);
var _toastContainerCss = require("./toastContainer.css");
var _toastContainerCssDefault = parcelHelpers.interopDefault(_toastContainerCss);
var _toaster = require("./Toaster");
var _i18N = require("@react-aria/i18n");
var _toast = require("@react-aria/toast");
const ICONS = {
    info: (0, _infoMediumDefault.default),
    negative: (0, _alertMediumDefault.default),
    positive: (0, _successMediumDefault.default)
};
function Toast(props, ref) {
    var _state_visibleToasts_;
    let { toast: { key, animation, content: { children, variant, actionLabel, onAction, shouldCloseOnAction } }, state, ...otherProps } = props;
    let domRef = (0, _utils.useDOMRef)(ref);
    let { closeButtonProps, titleProps, toastProps } = (0, _toast.useToast)(props, state, domRef);
    let { styleProps } = (0, _utils.useStyleProps)(otherProps);
    let stringFormatter = (0, _i18N.useLocalizedStringFormatter)((0, _jsonDefault.default), "@react-spectrum/toast");
    let iconLabel = variant && variant !== "neutral" ? stringFormatter.format(variant) : null;
    let Icon = ICONS[variant];
    let isFocusVisible = (0, _react.useContext)((0, _toaster.ToasterContext));
    const handleAction = ()=>{
        if (onAction) onAction();
        if (shouldCloseOnAction) state.close(key);
    };
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...styleProps,
        ...toastProps,
        ref: domRef,
        className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Toast", {
            ["spectrum-Toast--" + variant]: variant
        }, styleProps.className, (0, _utils.classNames)((0, _toastContainerCssDefault.default), "spectrum-Toast", {
            "focus-ring": props.toast.key === ((_state_visibleToasts_ = state.visibleToasts[0]) === null || _state_visibleToasts_ === void 0 ? void 0 : _state_visibleToasts_.key) && isFocusVisible
        })),
        style: {
            ...styleProps.style,
            zIndex: props.toast.priority
        },
        "data-animation": animation,
        onAnimationEnd: ()=>{
            if (animation === "exiting") state.remove(key);
        }
    }, Icon && /*#__PURE__*/ (0, _reactDefault.default).createElement(Icon, {
        "aria-label": iconLabel,
        UNSAFE_className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Toast-typeIcon")
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Toast-body")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Toast-content"),
        ...titleProps
    }, children), actionLabel && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.Button), {
        onPress: handleAction,
        UNSAFE_className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Button"),
        variant: "secondary",
        staticColor: "white"
    }, actionLabel)), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-Toast-buttons")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ClearButton), {
        ...closeButtonProps,
        variant: "overBackground"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _crossMediumDefault.default), null))));
}
let _Toast = /*#__PURE__*/ (0, _reactDefault.default).forwardRef(Toast);

},{"@spectrum-icons/ui/AlertMedium":"2v5QX","@react-spectrum/button":"jZWyP","@react-spectrum/utils":"cMIJ6","@spectrum-icons/ui/CrossMedium":"8utHt","@spectrum-icons/ui/InfoMedium":"kEEGF","../intl/*.json":"cTLVc","react":"9yzVZ","@adobe/spectrum-css-temp/components/toast/vars.css":"1GLbt","@spectrum-icons/ui/SuccessMedium":"7xKnN","./toastContainer.css":"6CdoP","./Toaster":"8VfjV","@react-aria/i18n":"411rg","@react-aria/toast":"l9hgR","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"8utHt":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("bcee19f69579a772");
exports.__esModule = true;
exports.default = CrossMedium;
var _CrossMedium = require("84efa6faa7d8cf0");
var _icon = require("102766c35bcd28a4");
var _react = _interopRequireDefault(require("bc751b02585f8677"));
function CrossMedium(props) {
    return /*#__PURE__*/ _react.default.createElement(_icon.UIIcon, props, /*#__PURE__*/ _react.default.createElement(_CrossMedium.CrossMedium, null));
}

},{"bcee19f69579a772":"iHubQ","84efa6faa7d8cf0":"hVBVQ","102766c35bcd28a4":"k7wem","bc751b02585f8677":"9yzVZ"}],"hVBVQ":[function(require,module,exports) {
/**
* @adobe/react-spectrum-ui (c) by Adobe
* 
* @adobe/react-spectrum-ui is licensed under a
* Creative Commons Attribution-NoDerivatives 4.0 International License.
* 
* You should have received a copy of the license along with this
* work. If not, see <http://creativecommons.org/licenses/by-nd/4.0/>.
**/ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CrossMedium = CrossMedium;
var _react = _interopRequireDefault(require("d3db5ac712cba8e0"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function CrossMedium(_ref) {
    var _ref$scale = _ref.scale, scale = _ref$scale === void 0 ? "M" : _ref$scale, props = _objectWithoutProperties(_ref, [
        "scale"
    ]);
    return _react["default"].createElement("svg", _extends({}, props, props), scale === "L" && _react["default"].createElement("path", {
        d: "M9.77 8.71L6.06 5l3.71-3.71A.75.75 0 1 0 8.71.23L5 3.94 1.29.23A.75.75 0 1 0 .23 1.29L3.94 5 .23 8.71a.75.75 0 1 0 1.06 1.06L5 6.06l3.71 3.71a.75.75 0 1 0 1.06-1.06z"
    }), scale === "M" && _react["default"].createElement("path", {
        d: "M7.77 6.71L5.06 4l2.71-2.71A.75.75 0 1 0 6.71.23L4 2.94 1.29.23A.75.75 0 1 0 .23 1.29L2.94 4 .23 6.71a.75.75 0 1 0 1.06 1.06L4 5.06l2.71 2.71a.75.75 0 1 0 1.06-1.06z"
    }));
}
CrossMedium.displayName = "CrossMedium";

},{"d3db5ac712cba8e0":"9yzVZ"}],"cTLVc":[function(require,module,exports) {
const _temp0 = require("5b366e4bfd035a51");
const _temp1 = require("a4452539ee6d7049");
const _temp2 = require("94125499ea620ff2");
const _temp3 = require("3cf45549b1f2cd43");
const _temp4 = require("cb0b08c8165b0e9e");
const _temp5 = require("e3bcd2d7b46abfe6");
const _temp6 = require("6a0c710c544558f");
const _temp7 = require("883f970255e086e4");
const _temp8 = require("1303035c8b5a0047");
const _temp9 = require("599f1a48226b5653");
const _temp10 = require("2c40e0bef3964a69");
const _temp11 = require("6e50954f9b38dc8a");
const _temp12 = require("130cdc83d1e7928a");
const _temp13 = require("f7093044dcca761b");
const _temp14 = require("c15f902d8af34b36");
const _temp15 = require("2c01188514516772");
const _temp16 = require("6545cd24840db1c6");
const _temp17 = require("531dbdaaef8cabb1");
const _temp18 = require("36fb268de3f0fb0b");
const _temp19 = require("9f3e0f0cfd6c5a02");
const _temp20 = require("7111ef00b4396da3");
const _temp21 = require("7fcd601fd9c021af");
const _temp22 = require("8623ff0e5dc248ac");
const _temp23 = require("cd09df72582c2d8c");
const _temp24 = require("de83cc68ef008893");
const _temp25 = require("854aca81f0264234");
const _temp26 = require("6f2c6dc14376a887");
const _temp27 = require("b27560b7410ce3a8");
const _temp28 = require("4b932dfe821665c5");
const _temp29 = require("8350c531fa1a8b65");
const _temp30 = require("cb363e02bb3b21b4");
const _temp31 = require("df96b6dd4d4ce5fd");
const _temp32 = require("186f35febe64cc80");
const _temp33 = require("ea69e512a7cc3423");
module.exports = {
    "ar-AE": _temp0,
    "bg-BG": _temp1,
    "cs-CZ": _temp2,
    "da-DK": _temp3,
    "de-DE": _temp4,
    "el-GR": _temp5,
    "en-US": _temp6,
    "es-ES": _temp7,
    "et-EE": _temp8,
    "fi-FI": _temp9,
    "fr-FR": _temp10,
    "he-IL": _temp11,
    "hr-HR": _temp12,
    "hu-HU": _temp13,
    "it-IT": _temp14,
    "ja-JP": _temp15,
    "ko-KR": _temp16,
    "lt-LT": _temp17,
    "lv-LV": _temp18,
    "nb-NO": _temp19,
    "nl-NL": _temp20,
    "pl-PL": _temp21,
    "pt-BR": _temp22,
    "pt-PT": _temp23,
    "ro-RO": _temp24,
    "ru-RU": _temp25,
    "sk-SK": _temp26,
    "sl-SI": _temp27,
    "sr-SP": _temp28,
    "sv-SE": _temp29,
    "tr-TR": _temp30,
    "uk-UA": _temp31,
    "zh-CN": _temp32,
    "zh-TW": _temp33
};

},{"5b366e4bfd035a51":"6O01z","a4452539ee6d7049":"agbEC","94125499ea620ff2":"bMWpe","3cf45549b1f2cd43":"dmqGJ","cb0b08c8165b0e9e":"5rW3N","e3bcd2d7b46abfe6":"iZK9f","6a0c710c544558f":"4WW3b","883f970255e086e4":"b4yNc","1303035c8b5a0047":"5oxDa","599f1a48226b5653":"i3L75","2c40e0bef3964a69":"bHwNn","6e50954f9b38dc8a":"b5SEu","130cdc83d1e7928a":"7yIhO","f7093044dcca761b":"018Xs","c15f902d8af34b36":"f5Aik","2c01188514516772":"iCdFW","6545cd24840db1c6":"8L8df","531dbdaaef8cabb1":"gKNR5","36fb268de3f0fb0b":"MSYEc","9f3e0f0cfd6c5a02":"8nQsM","7111ef00b4396da3":"jTQx2","7fcd601fd9c021af":"aCVEI","8623ff0e5dc248ac":"jBmol","cd09df72582c2d8c":"6IVY7","de83cc68ef008893":"1tPsI","854aca81f0264234":"7KqS4","6f2c6dc14376a887":"97jvb","b27560b7410ce3a8":"aEWxs","4b932dfe821665c5":"l5pKV","8350c531fa1a8b65":"fGl7f","cb363e02bb3b21b4":"l4JYp","df96b6dd4d4ce5fd":"6UjrI","186f35febe64cc80":"dD98B","ea69e512a7cc3423":"bq2Jf"}],"6O01z":[function(require,module,exports) {
module.exports = {
    "info": `\u{645}\u{639}\u{644}\u{648}\u{645}\u{627}\u{62A}`,
    "negative": `\u{62E}\u{637}\u{623}`,
    "positive": `\u{62A}\u{645} \u{628}\u{646}\u{62C}\u{627}\u{62D}`
};

},{}],"agbEC":[function(require,module,exports) {
module.exports = {
    "info": `\u{418}\u{43D}\u{444}\u{43E}\u{440}\u{43C}\u{430}\u{446}\u{438}\u{44F}`,
    "negative": `\u{413}\u{440}\u{435}\u{448}\u{43A}\u{430}`,
    "positive": `\u{423}\u{441}\u{43F}\u{435}\u{448}\u{43D}\u{43E}`
};

},{}],"bMWpe":[function(require,module,exports) {
module.exports = {
    "info": `Informace`,
    "negative": `Chyba`,
    "positive": `\xdasp\u{11B}ch`
};

},{}],"dmqGJ":[function(require,module,exports) {
module.exports = {
    "info": `Info`,
    "negative": `Fejl`,
    "positive": `Fuldf\xf8rt`
};

},{}],"5rW3N":[function(require,module,exports) {
module.exports = {
    "info": `Informationen`,
    "negative": `Fehler`,
    "positive": `Erfolg`
};

},{}],"iZK9f":[function(require,module,exports) {
module.exports = {
    "info": `\u{3A0}\u{3BB}\u{3B7}\u{3C1}\u{3BF}\u{3C6}\u{3BF}\u{3C1}\u{3AF}\u{3B5}\u{3C2}`,
    "negative": `\u{3A3}\u{3C6}\u{3AC}\u{3BB}\u{3BC}\u{3B1}`,
    "positive": `\u{395}\u{3C0}\u{3B9}\u{3C4}\u{3C5}\u{3C7}\u{3AF}\u{3B1}`
};

},{}],"4WW3b":[function(require,module,exports) {
module.exports = {
    "info": `Info`,
    "negative": `Error`,
    "positive": `Success`
};

},{}],"b4yNc":[function(require,module,exports) {
module.exports = {
    "info": `Informaci\xf3n`,
    "negative": `Error`,
    "positive": `\xc9xito`
};

},{}],"5oxDa":[function(require,module,exports) {
module.exports = {
    "info": `Teave`,
    "negative": `Viga`,
    "positive": `Valmis`
};

},{}],"i3L75":[function(require,module,exports) {
module.exports = {
    "info": `Tiedot`,
    "negative": `Virhe`,
    "positive": `Onnistui`
};

},{}],"bHwNn":[function(require,module,exports) {
module.exports = {
    "info": `Infos`,
    "negative": `Erreur`,
    "positive": `Succ\xe8s`
};

},{}],"b5SEu":[function(require,module,exports) {
module.exports = {
    "info": `\u{5DE}\u{5D9}\u{5D3}\u{5E2}`,
    "negative": `\u{5E9}\u{5D2}\u{5D9}\u{5D0}\u{5D4}`,
    "positive": `\u{5D4}\u{5E6}\u{5DC}\u{5D7}\u{5D4}`
};

},{}],"7yIhO":[function(require,module,exports) {
module.exports = {
    "info": `Informacije`,
    "negative": `Pogre\u{161}ka`,
    "positive": `Uspje\u{161}no`
};

},{}],"018Xs":[function(require,module,exports) {
module.exports = {
    "info": `Inform\xe1ci\xf3`,
    "negative": `Hiba`,
    "positive": `Siker`
};

},{}],"f5Aik":[function(require,module,exports) {
module.exports = {
    "info": `Informazioni`,
    "negative": `Errore`,
    "positive": `Operazione riuscita`
};

},{}],"iCdFW":[function(require,module,exports) {
module.exports = {
    "info": `\u{60C5}\u{5831}`,
    "negative": `\u{30A8}\u{30E9}\u{30FC}`,
    "positive": `\u{6210}\u{529F}`
};

},{}],"8L8df":[function(require,module,exports) {
module.exports = {
    "info": `\u{C815}\u{BCF4}`,
    "negative": `\u{C624}\u{B958}`,
    "positive": `\u{C131}\u{ACF5}`
};

},{}],"gKNR5":[function(require,module,exports) {
module.exports = {
    "info": `Informacija`,
    "negative": `Klaida`,
    "positive": `S\u{117}kmingai`
};

},{}],"MSYEc":[function(require,module,exports) {
module.exports = {
    "info": `Inform\u{101}cija`,
    "negative": `K\u{13C}\u{16B}da`,
    "positive": `Izdev\u{101}s`
};

},{}],"8nQsM":[function(require,module,exports) {
module.exports = {
    "info": `Info`,
    "negative": `Feil`,
    "positive": `Vellykket`
};

},{}],"jTQx2":[function(require,module,exports) {
module.exports = {
    "info": `Info`,
    "negative": `Fout`,
    "positive": `Geslaagd`
};

},{}],"aCVEI":[function(require,module,exports) {
module.exports = {
    "info": `Informacje`,
    "negative": `B\u{142}\u{105}d`,
    "positive": `Powodzenie`
};

},{}],"jBmol":[function(require,module,exports) {
module.exports = {
    "info": `Informa\xe7\xf5es`,
    "negative": `Erro`,
    "positive": `Sucesso`
};

},{}],"6IVY7":[function(require,module,exports) {
module.exports = {
    "info": `Informa\xe7\xe3o`,
    "negative": `Erro`,
    "positive": `Sucesso`
};

},{}],"1tPsI":[function(require,module,exports) {
module.exports = {
    "info": `Informa\u{21B}ii`,
    "negative": `Eroare`,
    "positive": `Succes`
};

},{}],"7KqS4":[function(require,module,exports) {
module.exports = {
    "info": `\u{418}\u{43D}\u{444}\u{43E}\u{440}\u{43C}\u{430}\u{446}\u{438}\u{44F}`,
    "negative": `\u{41E}\u{448}\u{438}\u{431}\u{43A}\u{430}`,
    "positive": `\u{423}\u{441}\u{43F}\u{435}\u{448}\u{43D}\u{43E}`
};

},{}],"97jvb":[function(require,module,exports) {
module.exports = {
    "info": `Inform\xe1cie`,
    "negative": `Chyba`,
    "positive": `\xdaspech`
};

},{}],"aEWxs":[function(require,module,exports) {
module.exports = {
    "info": `Informacije`,
    "negative": `Napaka`,
    "positive": `Uspe\u{161}no`
};

},{}],"l5pKV":[function(require,module,exports) {
module.exports = {
    "info": `Informacije`,
    "negative": `Gre\u{161}ka`,
    "positive": `Uspe\u{161}no`
};

},{}],"fGl7f":[function(require,module,exports) {
module.exports = {
    "info": `Info`,
    "negative": `Fel`,
    "positive": `Lyckades`
};

},{}],"l4JYp":[function(require,module,exports) {
module.exports = {
    "info": `Bilgiler`,
    "negative": `Hata`,
    "positive": `Ba\u{15F}ar\u{131}l\u{131}`
};

},{}],"6UjrI":[function(require,module,exports) {
module.exports = {
    "info": `\u{406}\u{43D}\u{444}\u{43E}\u{440}\u{43C}\u{430}\u{446}\u{456}\u{44F}`,
    "negative": `\u{41F}\u{43E}\u{43C}\u{438}\u{43B}\u{43A}\u{430}`,
    "positive": `\u{423}\u{441}\u{43F}\u{456}\u{448}\u{43D}\u{43E}`
};

},{}],"dD98B":[function(require,module,exports) {
module.exports = {
    "info": `\u{4FE1}\u{606F}`,
    "negative": `\u{9519}\u{8BEF}`,
    "positive": `\u{6210}\u{529F}`
};

},{}],"bq2Jf":[function(require,module,exports) {
module.exports = {
    "info": `\u{8CC7}\u{8A0A}`,
    "negative": `\u{932F}\u{8AA4}`,
    "positive": `\u{6210}\u{529F}`
};

},{}],"1GLbt":[function(require,module,exports) {
module.exports["spectrum-Button"] = `O7O3BG_spectrum-Button`;
module.exports["spectrum-ClearButton"] = `O7O3BG_spectrum-ClearButton`;
module.exports["spectrum-Toast"] = `O7O3BG_spectrum-Toast`;
module.exports["spectrum-Toast--info"] = `O7O3BG_spectrum-Toast--info`;
module.exports["spectrum-Toast--negative"] = `O7O3BG_spectrum-Toast--negative`;
module.exports["spectrum-Toast--positive"] = `O7O3BG_spectrum-Toast--positive`;
module.exports["spectrum-Toast-body"] = `O7O3BG_spectrum-Toast-body`;
module.exports["spectrum-Toast-buttons"] = `O7O3BG_spectrum-Toast-buttons`;
module.exports["spectrum-Toast-content"] = `O7O3BG_spectrum-Toast-content`;
module.exports["spectrum-Toast-typeIcon"] = `O7O3BG_spectrum-Toast-typeIcon`;

},{}],"6CdoP":[function(require,module,exports) {
module.exports["fade-out"] = `xynrca_fade-out`;
module.exports["fade-out"];
module.exports["focus-ring"] = `xynrca_focus-ring`;
module.exports["react-spectrum-ToastContainer"] = `xynrca_react-spectrum-ToastContainer`;
module.exports["slide-in"] = `xynrca_slide-in`;
module.exports["slide-in"];
module.exports["spectrum-FocusRing-ring"] = `xynrca_spectrum-FocusRing-ring`;
module.exports["spectrum-FocusRing"] = `xynrca_spectrum-FocusRing ${module.exports["spectrum-FocusRing-ring"]}`;
module.exports["spectrum-FocusRing--quiet"] = `xynrca_spectrum-FocusRing--quiet`;
module.exports["spectrum-Toast"] = `xynrca_spectrum-Toast ${module.exports["spectrum-FocusRing"]}`;

},{}],"8VfjV":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ToasterContext", ()=>ToasterContext);
parcelHelpers.export(exports, "Toaster", ()=>Toaster);
var _toast = require("@react-aria/toast");
var _utils = require("@react-spectrum/utils");
var _utils1 = require("@react-aria/utils");
var _provider = require("@react-spectrum/provider");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactDom = require("react-dom");
var _reactDomDefault = parcelHelpers.interopDefault(_reactDom);
var _toastContainerCss = require("./toastContainer.css");
var _toastContainerCssDefault = parcelHelpers.interopDefault(_toastContainerCss);
var _focus = require("@react-aria/focus");
const ToasterContext = /*#__PURE__*/ (0, _react.createContext)(false);
function Toaster(props) {
    let { children, state } = props;
    let ref = (0, _react.useRef)();
    let { regionProps } = (0, _toast.useToastRegion)(props, state, ref);
    let { focusProps, isFocusVisible } = (0, _focus.useFocusRing)();
    let contents = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _provider.Provider), {
        UNSAFE_style: {
            background: "transparent"
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(ToasterContext.Provider, {
        value: isFocusVisible
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...(0, _utils1.mergeProps)(regionProps, focusProps),
        ref: ref,
        "data-position": "bottom",
        "data-placement": "center",
        className: (0, _utils.classNames)((0, _toastContainerCssDefault.default), "react-spectrum-ToastContainer")
    }, children)));
    return /*#__PURE__*/ (0, _reactDomDefault.default).createPortal(contents, document.body);
}

},{"@react-aria/toast":"l9hgR","@react-spectrum/utils":"cMIJ6","@react-aria/utils":"9cLk5","@react-spectrum/provider":"5bCdp","react":"9yzVZ","react-dom":"cEvV3","./toastContainer.css":"6CdoP","@react-aria/focus":"42mbF","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"brOGJ":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Default", ()=>Default);
parcelHelpers.export(exports, "LongContent", ()=>LongContent);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _src = require("../src");
const argTypes = {
    placement: {
        control: "radio",
        options: [
            "top",
            "bottom",
            "left",
            "right"
        ]
    },
    variant: {
        control: "radio",
        options: [
            undefined,
            "neutral",
            "info",
            "positive",
            "negative"
        ]
    },
    showIcon: {
        control: "boolean"
    },
    isOpen: {
        control: {
            disable: true
        }
    }
};
exports.default = {
    title: "Tooltip",
    component: (0, _src.Tooltip),
    args: {
        isOpen: true,
        children: "This is a tooltip"
    },
    argTypes: argTypes
};
const Default = {};
const LongContent = {
    args: {
        children: /*#__PURE__*/ (0, _reactDefault.default).createElement("div", null, "Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Vestibulum tortor quam, feugiat vitae, ultricies eget, tempor sit amet, ante. Donec eu libero sit amet quam egestas semper. Aenean ultricies mi vitae est. Mauris placerat eleifend leo. Quisque sit amet est et sapien ullamcorper pharetra. Vestibulum erat wisi, condimentum sed, commodo vitae, ornare sit amet, wisi. Aenean fermentum, elit eget tincidunt condimentum, eros ipsum rutrum orci, sagittis tempus lacus enim ac dui.")
    }
};

},{"react":"9yzVZ","../src":"f9wa6","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"dVFHv":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Default", ()=>Default);
parcelHelpers.export(exports, "DefaultOpen", ()=>DefaultOpen);
parcelHelpers.export(exports, "IsOpen", ()=>IsOpen);
parcelHelpers.export(exports, "TriggerDisabled", ()=>TriggerDisabled);
parcelHelpers.export(exports, "TooltipOnLink", ()=>TooltipOnLink);
parcelHelpers.export(exports, "TooltripTriggerInsideActionGroup", ()=>TooltripTriggerInsideActionGroup);
parcelHelpers.export(exports, "ArrowPositioningAtEdge", ()=>ArrowPositioningAtEdge);
parcelHelpers.export(exports, "TooltipWithOtherHoverables", ()=>TooltipWithOtherHoverables);
parcelHelpers.export(exports, "MultipleTooltips", ()=>MultipleTooltips);
parcelHelpers.export(exports, "ControlledMultipleTooltips", ()=>ControlledMultipleTooltips);
parcelHelpers.export(exports, "CrossoffsetExamples", ()=>CrossoffsetExamples);
var _addonActions = require("@storybook/addon-actions");
var _button = require("@react-spectrum/button");
var _actiongroup = require("@react-spectrum/actiongroup");
var _delete = require("@spectrum-icons/workflow/Delete");
var _deleteDefault = parcelHelpers.interopDefault(_delete);
var _edit = require("@spectrum-icons/workflow/Edit");
var _editDefault = parcelHelpers.interopDefault(_edit);
var _layout = require("@react-spectrum/layout");
var _link = require("@react-spectrum/link");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _saveTo = require("@spectrum-icons/workflow/SaveTo");
var _saveToDefault = parcelHelpers.interopDefault(_saveTo);
var _src = require("../src");
const argTypes = {
    placement: {
        control: "select",
        options: [
            "bottom",
            "bottom left",
            "bottom right",
            "bottom start",
            "bottom end",
            "top",
            "top left",
            "top right",
            "top start",
            "top end",
            "left",
            "left top",
            "left bottom",
            "start",
            "start top",
            "start bottom",
            "right",
            "right top",
            "right bottom",
            "end",
            "end top",
            "end bottom"
        ]
    },
    delay: {
        control: "number",
        min: 0,
        max: 50000,
        step: 500
    },
    offset: {
        control: "number",
        min: -500,
        max: 500
    },
    crossOffset: {
        control: "number",
        min: -500,
        max: 500
    },
    containerPadding: {
        control: "number",
        min: -500,
        max: 500
    },
    isDisabled: {
        control: "boolean"
    },
    shouldFlip: {
        control: "boolean"
    },
    trigger: {
        control: "radio",
        options: [
            undefined,
            "focus"
        ]
    },
    children: {
        control: {
            disable: true
        }
    }
};
const disabledArgTypes = {
    placement: {
        control: {
            disable: true
        }
    },
    delay: {
        control: {
            disable: true
        }
    },
    offset: {
        control: {
            disable: true
        }
    },
    crossOffset: {
        control: {
            disable: true
        }
    },
    containerPadding: {
        control: {
            disable: true
        }
    },
    isDisabled: {
        control: {
            disable: true
        }
    },
    shouldFlip: {
        control: {
            disable: true
        }
    },
    trigger: {
        control: {
            disable: true
        }
    },
    children: {
        control: {
            disable: true
        }
    }
};
exports.default = {
    title: "TooltipTrigger",
    component: (0, _src.TooltipTrigger),
    args: {
        children: [
            /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), {
                "aria-label": "Edit Name"
            }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _editDefault.default), null)),
            /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _src.Tooltip), null, "Change Name")
        ],
        onOpenChange: (0, _addonActions.action)("openChange")
    },
    argTypes: argTypes
};
const Default = {};
const DefaultOpen = {
    args: {
        defaultOpen: true
    },
    name: "defaultOpen: true"
};
const IsOpen = {
    args: {
        isOpen: true
    },
    name: "isOpen: true"
};
const TriggerDisabled = {
    args: {
        children: [
            /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), {
                "aria-label": "Edit Name",
                isDisabled: true
            }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _editDefault.default), null)),
            /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _src.Tooltip), null, "Change Name")
        ]
    },
    argTypes: disabledArgTypes
};
const TooltipOnLink = {
    args: {
        children: [
            /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _link.Link), null, /*#__PURE__*/ (0, _reactDefault.default).createElement("a", {
                href: "https://react-spectrum.adobe.com/",
                target: "_blank",
                rel: "noreferrer"
            }, "Why did dinosaurs have feathers?")),
            /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _src.Tooltip), null, "Dinosaurs had feathers, find out more.")
        ]
    }
};
const TooltripTriggerInsideActionGroup = {
    args: {
        delay: 0
    },
    render: (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _actiongroup.ActionGroup), {
            selectionMode: "single",
            disallowEmptySelection: true,
            onSelectionChange: (0, _addonActions.action)("onSelectionChange")
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _src.TooltipTrigger), args, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _actiongroup.Item), {
            key: "editKey",
            "aria-label": "Edit"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _editDefault.default), null)), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _src.Tooltip), null, "Edit")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _src.TooltipTrigger), args, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _actiongroup.Item), {
            key: "saveKey",
            "aria-label": "Save"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _saveToDefault.default), null)), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _src.Tooltip), null, "Save")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _src.TooltipTrigger), args, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _actiongroup.Item), {
            key: "deleteKey",
            "aria-label": "Delete"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _deleteDefault.default), null)), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _src.Tooltip), null, "Delete")))
};
const ArrowPositioningAtEdge = {
    args: {
        children: [
            /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), null, "Trigger Tooltip"),
            /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _src.Tooltip), null, "Long tooltip message that just goes on and on.")
        ]
    },
    decorators: [
        (Story)=>/*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
                style: {
                    width: "100%"
                }
            }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Story, null))
    ]
};
const TooltipWithOtherHoverables = {
    args: {
        children: [
            /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), null, "Trigger Tooltip"),
            /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _src.Tooltip), null, "Long tooltip message that just goes on and on.")
        ]
    },
    decorators: [
        (Story)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
                gap: "size-100"
            }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Story, null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.Button), {
                variant: "secondary"
            }, "No Tooltip"))
    ]
};
const MultipleTooltips = {
    args: {
        placement: "start"
    },
    render: (props)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(MultipleTriggers, props)
};
const ControlledMultipleTooltips = {
    args: {
        placement: "start"
    },
    render: (props)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(MultipleTriggers, {
            ...props,
            isControlled: true
        })
};
let MultipleTriggers = (props)=>{
    let [one, setOne] = (0, _react.useState)(false);
    let [two, setTwo] = (0, _react.useState)(false);
    let [three, setThree] = (0, _react.useState)(false);
    let [four, setFour] = (0, _react.useState)(false);
    let items = [
        {
            variant: "neutral",
            isOpen: one,
            onOpenChange: setOne
        },
        {
            variant: "positive",
            isOpen: two,
            onOpenChange: setTwo
        },
        {
            variant: "negative",
            isOpen: three,
            onOpenChange: setThree
        },
        {
            variant: "info",
            isOpen: four,
            onOpenChange: setFour
        }
    ];
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
        gap: "size-100",
        direction: "column"
    }, items.map((item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _src.TooltipTrigger), {
            ...props,
            key: item.variant,
            isOpen: props.isControlled ? item.isOpen : undefined,
            onOpenChange: props.isControlled ? item.onOpenChange : (0, _addonActions.action)("onOpenChange")
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), null, item.variant, " Tooltip"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _src.Tooltip), {
            variant: item.variant,
            showIcon: true
        }, item.variant, " message."))));
};
const CrossoffsetExamples = {
    render: ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
            gap: "size-200"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
            gap: "size-200",
            direction: "column",
            alignItems: "start"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement("span", null, "Left Top"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _src.TooltipTrigger), {
            delay: 0,
            placement: "left top",
            crossOffset: 10
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), null, "Tooltip Trigger 10"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _src.Tooltip), null, "Tooltip message.")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _src.TooltipTrigger), {
            delay: 0,
            placement: "left top"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), null, "Tooltip Trigger 0"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _src.Tooltip), null, "Tooltip message.")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _src.TooltipTrigger), {
            delay: 0,
            placement: "left top",
            crossOffset: -10
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), null, "Tooltip Trigger -10"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _src.Tooltip), null, "Tooltip message."))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
            gap: "size-200",
            direction: "column",
            alignItems: "start"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement("span", null, "Left"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _src.TooltipTrigger), {
            delay: 0,
            placement: "left",
            crossOffset: 10
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), null, "Tooltip Trigger 10"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _src.Tooltip), null, "Tooltip message.")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _src.TooltipTrigger), {
            delay: 0,
            placement: "left"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), null, "Tooltip Trigger 0 "), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _src.Tooltip), null, "Tooltip message.")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _src.TooltipTrigger), {
            delay: 0,
            placement: "left",
            crossOffset: -10
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), null, "Tooltip Trigger -10"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _src.Tooltip), null, "Tooltip message."))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Flex), {
            gap: "size-200",
            direction: "column",
            alignItems: "start"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement("span", null, "Left Bottom"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _src.TooltipTrigger), {
            delay: 0,
            placement: "left bottom",
            crossOffset: 10
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), null, "Tooltip Trigger 10"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _src.Tooltip), null, "Tooltip message.")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _src.TooltipTrigger), {
            delay: 0,
            placement: "left bottom"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), null, "Tooltip Trigger 0"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _src.Tooltip), null, "Tooltip message.")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _src.TooltipTrigger), {
            delay: 0,
            placement: "left bottom",
            crossOffset: -10
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.ActionButton), null, "Tooltip Trigger -10"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _src.Tooltip), null, "Tooltip message."))))
};

},{"@storybook/addon-actions":"coXbW","@react-spectrum/button":"jZWyP","@react-spectrum/actiongroup":"hkqBV","@spectrum-icons/workflow/Delete":"foJ71","@spectrum-icons/workflow/Edit":"ijmhW","@react-spectrum/layout":"hzaUY","@react-spectrum/link":"lNoiB","react":"9yzVZ","@spectrum-icons/workflow/SaveTo":"9aQDk","../src":"f9wa6","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"9aQDk":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("7ebcee52210fbb94");
exports.__esModule = true;
exports.default = SaveTo;
var _SaveTo = require("d01b7fc2eee8f006");
var _icon = require("329fa646a7288619");
var _react = _interopRequireDefault(require("cc0a0fa4a6837b1d"));
function SaveTo(props) {
    return /*#__PURE__*/ _react.default.createElement(_icon.Icon, props, /*#__PURE__*/ _react.default.createElement(_SaveTo.A4uSaveTo, null));
}

},{"7ebcee52210fbb94":"iHubQ","d01b7fc2eee8f006":"apFBl","329fa646a7288619":"k7wem","cc0a0fa4a6837b1d":"9yzVZ"}],"apFBl":[function(require,module,exports) {
/**
* @adobe/react-spectrum-workflow (c) by Adobe
* 
* @adobe/react-spectrum-workflow is licensed under a
* Creative Commons Attribution-NoDerivatives 4.0 International License.
* 
* You should have received a copy of the license along with this
* work. If not, see <http://creativecommons.org/licenses/by-nd/4.0/>.
**/ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.A4uSaveTo = A4uSaveTo;
var _react = _interopRequireDefault(require("14db5545aa9c4b0b"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function A4uSaveTo(_ref) {
    var props = _extends({}, _ref);
    return /*#__PURE__*/ _react["default"].createElement("svg", _extends({
        viewBox: "0 0 36 36"
    }, props, props), /*#__PURE__*/ _react["default"].createElement("path", {
        fillRule: "evenodd",
        d: "M33,10H27a1,1,0,0,0-1,1v2a1,1,0,0,0,1,1h3V30H6V14H9a1,1,0,0,0,1-1V11a1,1,0,0,0-1-1H3a1,1,0,0,0-1,1V33a1,1,0,0,0,1,1H33a1,1,0,0,0,1-1V11A1,1,0,0,0,33,10Z"
    }), /*#__PURE__*/ _react["default"].createElement("path", {
        fillRule: "evenodd",
        d: "M10.2,17.331l7.445,7.525a.5.5,0,0,0,.7,0L25.8,17.331a.782.782,0,0,0,.2-.526.8.8,0,0,0-.8-.8H20V3a1,1,0,0,0-1-1H17a1,1,0,0,0-1,1V16H10.8a.8.8,0,0,0-.8.8A.782.782,0,0,0,10.2,17.331Z"
    }));
}

},{"14db5545aa9c4b0b":"9yzVZ"}],"apjq2":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Default", ()=>Default);
parcelHelpers.export(exports, "Sections", ()=>Sections);
parcelHelpers.export(exports, "Static", ()=>Static);
parcelHelpers.export(exports, "StaticSections", ()=>StaticSections);
parcelHelpers.export(exports, "LongList", ()=>LongList);
var _src = require("../src");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
let items = [
    {
        name: "Animals",
        children: [
            {
                name: "Aardvark"
            },
            {
                name: "Kangaroo"
            },
            {
                name: "Snake"
            }
        ]
    },
    {
        name: "People",
        children: [
            {
                name: "Danni"
            },
            {
                name: "Devon"
            },
            {
                name: "Ross",
                children: [
                    {
                        name: "Tests"
                    }
                ]
            }
        ]
    }
];
let longList = [];
for(let i = 0; i < 1000; i++)longList.push({
    name: "Item " + i
});
exports.default = {
    title: "Tree"
};
const Default = ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _src.Tree), {
        items: items,
        onSelectionChange: (keys)=>console.log(keys)
    }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _src.Item), {
            key: item.name,
            childItems: item.children
        }, item.name));
const Sections = ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _src.Tree), {
        items: items
    }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _src.Section), {
            key: item.name,
            items: item.children,
            title: item.name
        }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _src.Item), {
                key: item.name,
                childItems: item.children
            }, item.name)));
const Static = ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _src.Tree), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _src.Item), null, "One"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _src.Item), null, "Two"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _src.Item), {
        title: "Three"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _src.Item), null, "Four"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _src.Item), {
        title: "Five"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _src.Item), null, "Six"))));
const StaticSections = ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _src.Tree), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _src.Section), {
        title: "Section 1"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _src.Item), null, "One"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _src.Item), null, "Two"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _src.Item), null, "Three")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _src.Section), {
        title: "Section 2"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _src.Item), null, "One"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _src.Item), null, "Two"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _src.Item), null, "Three")));
StaticSections.story = {
    name: "Static sections"
};
const LongList = ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement("div", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("input", {
        "aria-label": "input before"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _src.Tree), {
        items: longList
    }, (item)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _src.Item), {
            key: item.name
        }, item.name)), /*#__PURE__*/ (0, _reactDefault.default).createElement("input", {
        "aria-label": "input after"
    }));
LongList.story = {
    name: "Long list"
};

},{"../src":"j5Za4","react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"j5Za4":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /// <reference types="css-module-types" />
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Item", ()=>(0, _tree.Item));
parcelHelpers.export(exports, "Section", ()=>(0, _tree.Section));
parcelHelpers.export(exports, "Tree", ()=>(0, _tree.Tree));
var _tree = require("./Tree");

},{"./Tree":"hH1HO","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"hH1HO":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Item", ()=>(0, _collections.Item));
parcelHelpers.export(exports, "Section", ()=>(0, _collections.Section));
parcelHelpers.export(exports, "Tree", ()=>Tree);
var _chevronRightMedium = require("@spectrum-icons/ui/ChevronRightMedium");
var _chevronRightMediumDefault = parcelHelpers.interopDefault(_chevronRightMedium);
var _utils = require("@react-spectrum/utils");
var _focus = require("@react-aria/focus");
var _collections = require("@react-stately/collections");
var _layout = require("@react-stately/layout");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _varsCss = require("@adobe/spectrum-css-temp/components/treeview/vars.css");
var _varsCssDefault = parcelHelpers.interopDefault(_varsCss);
var _tree = require("@react-stately/tree");
var _selection = require("@react-aria/selection");
var _virtualizer = require("@react-aria/virtualizer");
function Tree(props) {
    let state = (0, _tree.useTreeState)(props);
    let layout = (0, _react.useMemo)(()=>new (0, _layout.ListLayout)({
            rowHeight: 44,
            indentationForItem (tree, key) {
                let level = tree.getItem(key).level;
                return 28 * level;
            }
        }), []);
    let ref = (0, _react.useRef)();
    let { collectionProps } = (0, _selection.useSelectableCollection)({
        ref,
        selectionManager: state.selectionManager,
        keyboardDelegate: layout
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _virtualizer.Virtualizer), {
        ...collectionProps,
        ref: ref,
        focusedKey: state.selectionManager.focusedKey,
        className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-TreeView"),
        layout: layout,
        collection: state.collection
    }, (type, item)=>{
        if (type === "section") return /*#__PURE__*/ (0, _reactDefault.default).createElement(TreeHeading, {
            item: item
        });
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(TreeItem, {
            item: item,
            state: state
        });
    });
}
function TreeItem(props) {
    let { item, state } = props;
    let { key, rendered, hasChildNodes } = item;
    let isExpanded = state.expandedKeys.has(key);
    let isSelected = state.selectionManager.isSelected(key);
    let itemClassName = (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-TreeView-item", {
        "is-open": isExpanded
    });
    let linkClassName = (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-TreeView-itemLink", {
        "is-selected": isSelected
    });
    let ref = (0, _react.useRef)();
    let { itemProps } = (0, _selection.useSelectableItem)({
        selectionManager: state.selectionManager,
        key: item.key,
        ref
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: itemClassName,
        role: "presentation"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _focus.FocusRing), {
        focusRingClass: (0, _utils.classNames)((0, _varsCssDefault.default), "focus-ring")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...itemProps,
        ref: ref,
        className: linkClassName
    }, hasChildNodes && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _chevronRightMediumDefault.default), {
        UNSAFE_className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-TreeView-indicator")
    }), rendered)));
}
function TreeHeading({ item }) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _utils.classNames)((0, _varsCssDefault.default), "spectrum-TreeView-heading")
    }, item.rendered);
}

},{"@spectrum-icons/ui/ChevronRightMedium":"6amCu","@react-spectrum/utils":"cMIJ6","@react-aria/focus":"42mbF","@react-stately/collections":"loANi","@react-stately/layout":"6Mwz5","react":"9yzVZ","@adobe/spectrum-css-temp/components/treeview/vars.css":"2LGsf","@react-stately/tree":"f1QlQ","@react-aria/selection":"6Fly5","@react-aria/virtualizer":"gAPsK","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"2LGsf":[function(require,module,exports) {
module.exports["focus-ring"] = `K8IPeW_focus-ring`;
module.exports["i18nFontFamily"] = `K8IPeW_i18nFontFamily`;
module.exports["is-disabled"] = `K8IPeW_is-disabled`;
module.exports["is-drop-target"] = `K8IPeW_is-drop-target`;
module.exports["is-hovered"] = `K8IPeW_is-hovered`;
module.exports["is-open"] = `K8IPeW_is-open`;
module.exports["is-selected"] = `K8IPeW_is-selected`;
module.exports["spectrum-FocusRing-ring"] = `K8IPeW_spectrum-FocusRing-ring`;
module.exports["spectrum-FocusRing"] = `K8IPeW_spectrum-FocusRing ${module.exports["spectrum-FocusRing-ring"]}`;
module.exports["spectrum-FocusRing--quiet"] = `K8IPeW_spectrum-FocusRing--quiet`;
module.exports["spectrum-Icon"] = `K8IPeW_spectrum-Icon`;
module.exports["spectrum-TreeView"] = `K8IPeW_spectrum-TreeView`;
module.exports["spectrum-TreeView-heading"] = `K8IPeW_spectrum-TreeView-heading`;
module.exports["spectrum-TreeView-indicator"] = `K8IPeW_spectrum-TreeView-indicator`;
module.exports["spectrum-TreeView-item"] = `K8IPeW_spectrum-TreeView-item`;
module.exports["spectrum-TreeView-item--indent1"] = `K8IPeW_spectrum-TreeView-item--indent1`;
module.exports["spectrum-TreeView-item--indent10"] = `K8IPeW_spectrum-TreeView-item--indent10`;
module.exports["spectrum-TreeView-item--indent2"] = `K8IPeW_spectrum-TreeView-item--indent2`;
module.exports["spectrum-TreeView-item--indent3"] = `K8IPeW_spectrum-TreeView-item--indent3`;
module.exports["spectrum-TreeView-item--indent4"] = `K8IPeW_spectrum-TreeView-item--indent4`;
module.exports["spectrum-TreeView-item--indent5"] = `K8IPeW_spectrum-TreeView-item--indent5`;
module.exports["spectrum-TreeView-item--indent6"] = `K8IPeW_spectrum-TreeView-item--indent6`;
module.exports["spectrum-TreeView-item--indent7"] = `K8IPeW_spectrum-TreeView-item--indent7`;
module.exports["spectrum-TreeView-item--indent8"] = `K8IPeW_spectrum-TreeView-item--indent8`;
module.exports["spectrum-TreeView-item--indent9"] = `K8IPeW_spectrum-TreeView-item--indent9`;
module.exports["spectrum-TreeView-itemLink"] = `K8IPeW_spectrum-TreeView-itemLink`;

},{}],"3lZgj":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Default", ()=>Default);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _ = require("../");
let meta = {
    title: "View",
    component: (0, _.View),
    args: {
        colorVersion: 5,
        backgroundColor: "blue-400"
    }
};
exports.default = meta;
const Default = (args)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _.View), {
        ...args,
        width: "single-line-width",
        height: "size-500",
        elementType: "span"
    });

},{"react":"9yzVZ","../":"b2NDc","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"b2NDc":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _src = require("./src");
parcelHelpers.exportAll(_src, exports);

},{"./src":"dnRjt","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"aZidy":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Default", ()=>Default);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _ = require("../");
let meta = {
    title: "Well",
    component: (0, _.Well)
};
exports.default = meta;
let Default = {
    args: {
        children: /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, "This is a React Spectrum Well")
    }
};

},{"react":"9yzVZ","../":"hzV5F","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"hzV5F":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _src = require("./src");
parcelHelpers.exportAll(_src, exports);

},{"./src":"dRB1Q","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"izdhi":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ColorIconWithSizes", ()=>ColorIconWithSizes);
var _calendarCheckColor = require("../CalendarCheckColor");
var _calendarCheckColorDefault = parcelHelpers.interopDefault(_calendarCheckColor);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
exports.default = {
    title: "Icons/Color"
};
const ColorIconWithSizes = ()=>renderIconSizes((0, _calendarCheckColorDefault.default), {
        "aria-label": "Adobe Analytics Color"
    });
ColorIconWithSizes.story = {
    name: "Color icon with sizes"
};
function renderIconSizes(Component, props) {
    let sizes = [
        "XXS",
        "XS",
        "S",
        "M",
        "L",
        "XL",
        "XXL"
    ];
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", null, sizes.map((size)=>{
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(Component, {
            size: size,
            margin: "15px",
            ...props
        });
    }));
}

},{"../CalendarCheckColor":"iExyW","react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"iExyW":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("c946ca3a056800a");
exports.__esModule = true;
exports.default = CalendarCheckColor;
var _CalendarCheckColor = require("3cfec90566961e5b");
var _icon = require("ea2a705c95494e3f");
var _react = _interopRequireDefault(require("8cdd794c7299e636"));
function CalendarCheckColor(props) {
    return /*#__PURE__*/ _react.default.createElement(_icon.Icon, props, /*#__PURE__*/ _react.default.createElement(_CalendarCheckColor.A4uCalendarCheckColor, null));
}

},{"c946ca3a056800a":"iHubQ","3cfec90566961e5b":"hSQ88","ea2a705c95494e3f":"k7wem","8cdd794c7299e636":"9yzVZ"}],"hSQ88":[function(require,module,exports) {
/**
* @adobe/react-spectrum-workflow-color (c) by Adobe
* 
* @adobe/react-spectrum-workflow-color is licensed under a
* Creative Commons Attribution-NoDerivatives 4.0 International License.
* 
* You should have received a copy of the license along with this
* work. If not, see <http://creativecommons.org/licenses/by-nd/4.0/>.
**/ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.A4uCalendarCheckColor = A4uCalendarCheckColor;
var _react = _interopRequireDefault(require("1255d61503a8e90"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function A4uCalendarCheckColor(_ref) {
    var _ref$scale = _ref.scale, scale = _ref$scale === void 0 ? "M" : _ref$scale, _ref$color = _ref.color, color = _ref$color === void 0 ? "LIGHT" : _ref$color, props = _objectWithoutProperties(_ref, [
        "scale",
        "color"
    ]);
    return _react["default"].createElement("svg", _extends({
        viewBox: "0 0 1152 1152"
    }, props, props), _react["default"].createElement("path", {
        opacity: 0.65,
        d: "M144 0h144v144H144zM768 0h144v144H768z"
    }), _react["default"].createElement("path", {
        fill: "#82AA46",
        d: "M864 576c-159.028 0-288 128.912-288 288 0 159.107 128.972 288 288 288s288-128.893 288-288c0-159.088-128.972-288-288-288zm-72 444L660 888l60-60 72 72 204-204 60 60-264 264z"
    }), _react["default"].createElement("path", {
        opacity: 0.65,
        d: "M1008 96h-48v96H720V96H336v96H96V96H48C0 96 0 144 0 144v864s0 48 48 48h483.368a384.425 384.425 0 0 1-21.146-42.477C496.423 980.904 487.309 946.91 482.963 912H336V768h144v48h2.963c4.345-34.906 13.46-68.897 27.258-101.516 16.217-38.337 38.309-73.369 65.778-104.457V528h101.998a385.03 385.03 0 0 1 36.519-17.79C761.916 490.164 812.21 480 864 480s102.084 10.164 149.483 30.21A384.534 384.534 0 0 1 1056 531.376V144s0-48-48-48zM240 912H96V768h144v144zm0-240H96V528h144v144zm0-240H96V288h144v144zm240 240H336V528h144v144zm0-240H336V288h144v144zm240 0H576V288h144v144zm240 0H816V288h144v144z"
    }));
}

},{"1255d61503a8e90":"9yzVZ"}],"3x3nV":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IconAddWithSizes", ()=>IconAddWithSizes);
parcelHelpers.export(exports, "IconBellWithSizes", ()=>IconBellWithSizes);
parcelHelpers.export(exports, "IconAlertNegative", ()=>IconAlertNegative);
parcelHelpers.export(exports, "IconAlertInformative", ()=>IconAlertInformative);
parcelHelpers.export(exports, "IconAlertPositive", ()=>IconAlertPositive);
parcelHelpers.export(exports, "IconAlertNotice", ()=>IconAlertNotice);
var _add = require("../Add");
var _addDefault = parcelHelpers.interopDefault(_add);
var _alert = require("../Alert");
var _alertDefault = parcelHelpers.interopDefault(_alert);
var _bell = require("../Bell");
var _bellDefault = parcelHelpers.interopDefault(_bell);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
exports.default = {
    title: "Icons/Express"
};
const IconAddWithSizes = ()=>renderIconSizes((0, _addDefault.default), {
        "aria-label": "Add"
    });
IconAddWithSizes.story = {
    name: "icon: Add with sizes"
};
const IconBellWithSizes = ()=>renderIconSizes((0, _bellDefault.default), {
        "aria-label": "Bell"
    });
IconBellWithSizes.story = {
    name: "icon: Bell with sizes"
};
const IconAlertNegative = ()=>renderIconSizes((0, _alertDefault.default), {
        "aria-label": "Alert",
        color: "negative"
    });
IconAlertNegative.story = {
    name: "icon: Alert negative"
};
const IconAlertInformative = ()=>renderIconSizes((0, _alertDefault.default), {
        "aria-label": "Alert",
        color: "informative"
    });
IconAlertInformative.story = {
    name: "icon: Alert informative"
};
const IconAlertPositive = ()=>renderIconSizes((0, _alertDefault.default), {
        "aria-label": "Alert",
        color: "positive"
    });
IconAlertPositive.story = {
    name: "icon: Alert positive"
};
const IconAlertNotice = ()=>renderIconSizes((0, _alertDefault.default), {
        "aria-label": "Alert",
        color: "notice"
    });
IconAlertNotice.story = {
    name: "icon: Alert notice"
};
function renderIconSizes(Component, props) {
    let sizes = [
        "XXS",
        "XS",
        "S",
        "M",
        "L",
        "XL",
        "XXL"
    ];
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", null, sizes.map((size)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(Component, {
            margin: "15px",
            size: size,
            ...props
        })));
}

},{"../Add":"1W7CG","../Alert":"6Xu45","../Bell":"kSb55","react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"1W7CG":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("b83f6c973a7b85cd");
exports.__esModule = true;
exports.default = Add;
var _extends2 = _interopRequireDefault(require("21f0f14086d1a3a7"));
var _icon = require("c518fd4b822b694a");
var _react = _interopRequireDefault(require("a0dd924793a9c87d"));
const IconComponent = (props)=>/*#__PURE__*/ _react.default.createElement("svg", (0, _extends2.default)({
        viewBox: "0 0 18 18"
    }, props), /*#__PURE__*/ _react.default.createElement("path", {
        d: "M4 10h4v4a1 1 0 1 0 2 0v-4h4a1 1 0 1 0 0-2h-4V4a1 1 0 1 0-2 0v4H4a1 1 0 1 0 0 2Z"
    }));
function Add(props) {
    return /*#__PURE__*/ _react.default.createElement(_icon.Icon, props, /*#__PURE__*/ _react.default.createElement(IconComponent, null));
}

},{"b83f6c973a7b85cd":"iHubQ","21f0f14086d1a3a7":"l4mXf","c518fd4b822b694a":"k7wem","a0dd924793a9c87d":"9yzVZ"}],"6Xu45":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("48295a9a513afc9e");
exports.__esModule = true;
exports.default = Alert;
var _extends2 = _interopRequireDefault(require("e2ce756f8d271925"));
var _icon = require("efd57e8b3a853f93");
var _react = _interopRequireDefault(require("1efbf5bcb10c9329"));
const IconComponent = (props)=>/*#__PURE__*/ _react.default.createElement("svg", (0, _extends2.default)({
        viewBox: "0 0 18 18"
    }, props), /*#__PURE__*/ _react.default.createElement("path", {
        d: "M9 10.5a1 1 0 0 1-1-1V5a1 1 0 1 1 2 0v4.5a1 1 0 0 1-1 1Zm0 1.25a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5Zm8.497 3.589a3.49 3.49 0 0 0 .079-3.474L12 1.815C11.394.68 10.273 0 9 0 7.732 0 6.613.676 6.007 1.808L.416 11.88a3.485 3.485 0 0 0 .089 3.459A3.375 3.375 0 0 0 3.416 17h11.169a3.375 3.375 0 0 0 2.912-1.661ZM10.244 2.77l5.575 10.05a1.5 1.5 0 0 1-.037 1.489c-.264.438-.7.69-1.197.69H3.416c-.498 0-.933-.252-1.197-.69a1.493 1.493 0 0 1-.046-1.474l5.593-10.08C8.018 2.284 8.48 2 9.001 2s.982.283 1.243.771Z"
    }));
function Alert(props) {
    return /*#__PURE__*/ _react.default.createElement(_icon.Icon, props, /*#__PURE__*/ _react.default.createElement(IconComponent, null));
}

},{"48295a9a513afc9e":"iHubQ","e2ce756f8d271925":"l4mXf","efd57e8b3a853f93":"k7wem","1efbf5bcb10c9329":"9yzVZ"}],"kSb55":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("9eb71aba3b05b340");
exports.__esModule = true;
exports.default = Bell;
var _extends2 = _interopRequireDefault(require("ac2e00cc4ef72847"));
var _icon = require("7e7fab451b925af");
var _react = _interopRequireDefault(require("b54e70dde9650196"));
const IconComponent = (props)=>/*#__PURE__*/ _react.default.createElement("svg", (0, _extends2.default)({
        viewBox: "0 0 18 18"
    }, props), /*#__PURE__*/ _react.default.createElement("path", {
        d: "M16.504 10.11C15.573 8.98 15.1 7.95 15.1 7.047c0-2.566-1.164-4.321-3.466-5.22C11.187.725 10.154 0 9 0 7.845 0 6.812.726 6.368 1.827c-2.3.898-3.466 2.653-3.466 5.22 0 .903-.474 1.933-1.406 3.061a2.95 2.95 0 0 0-.395 3.163A2.981 2.981 0 0 0 3.821 15H6v.4C6 16.834 7.346 18 9 18s3-1.166 3-2.6V15h2.179a2.982 2.982 0 0 0 2.72-1.728 2.95 2.95 0 0 0-.395-3.163ZM10 15.4c0 .284-.428.6-1 .6s-1-.316-1-.6V15h2v.4Zm5.09-2.98a.996.996 0 0 1-.911.58H3.82a.995.995 0 0 1-.91-.581.948.948 0 0 1 .127-1.036C4.29 9.865 4.9 8.447 4.902 7.048 4.902 4.8 6.06 4.07 7.19 3.653c.474-.173.86-.558 1.005-1.007C8.301 2.326 8.59 2 9 2s.7.326.808.652c.147.446.532.83 1 1 1.133.418 2.292 1.15 2.292 3.396 0 1.4.61 2.82 1.863 4.335a.95.95 0 0 1 .126 1.037Z"
    }));
function Bell(props) {
    return /*#__PURE__*/ _react.default.createElement(_icon.Icon, props, /*#__PURE__*/ _react.default.createElement(IconComponent, null));
}

},{"9eb71aba3b05b340":"iHubQ","ac2e00cc4ef72847":"l4mXf","7e7fab451b925af":"k7wem","b54e70dde9650196":"9yzVZ"}],"fZXXy":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IconAddWithSizes", ()=>IconAddWithSizes);
parcelHelpers.export(exports, "IconBellWithSizes", ()=>IconBellWithSizes);
parcelHelpers.export(exports, "Icon3DMaterialsWithSizes", ()=>Icon3DMaterialsWithSizes);
parcelHelpers.export(exports, "IconAlertNegative", ()=>IconAlertNegative);
parcelHelpers.export(exports, "IconAlertInformative", ()=>IconAlertInformative);
parcelHelpers.export(exports, "IconAlertPositive", ()=>IconAlertPositive);
parcelHelpers.export(exports, "IconAlertNotice", ()=>IconAlertNotice);
var _3Dmaterials = require("../3DMaterials");
var _3DmaterialsDefault = parcelHelpers.interopDefault(_3Dmaterials);
var _add = require("../Add");
var _addDefault = parcelHelpers.interopDefault(_add);
var _alert = require("../Alert");
var _alertDefault = parcelHelpers.interopDefault(_alert);
var _bell = require("../Bell");
var _bellDefault = parcelHelpers.interopDefault(_bell);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
exports.default = {
    title: "Icons/Workflow"
};
const IconAddWithSizes = ()=>renderIconSizes((0, _addDefault.default), {
        "aria-label": "Add"
    });
IconAddWithSizes.story = {
    name: "icon: Add with sizes"
};
const IconBellWithSizes = ()=>renderIconSizes((0, _bellDefault.default), {
        "aria-label": "Bell"
    });
IconBellWithSizes.story = {
    name: "icon: Bell with sizes"
};
const Icon3DMaterialsWithSizes = ()=>renderIconSizes((0, _3DmaterialsDefault.default), {
        "aria-label": "3D Materials"
    });
Icon3DMaterialsWithSizes.story = {
    name: "icon: _3DMaterials with sizes"
};
const IconAlertNegative = ()=>renderIconSizes((0, _alertDefault.default), {
        "aria-label": "Alert",
        color: "negative"
    });
IconAlertNegative.story = {
    name: "icon: Alert negative"
};
const IconAlertInformative = ()=>renderIconSizes((0, _alertDefault.default), {
        "aria-label": "Alert",
        color: "informative"
    });
IconAlertInformative.story = {
    name: "icon: Alert informative"
};
const IconAlertPositive = ()=>renderIconSizes((0, _alertDefault.default), {
        "aria-label": "Alert",
        color: "positive"
    });
IconAlertPositive.story = {
    name: "icon: Alert positive"
};
const IconAlertNotice = ()=>renderIconSizes((0, _alertDefault.default), {
        "aria-label": "Alert",
        color: "notice"
    });
IconAlertNotice.story = {
    name: "icon: Alert notice"
};
function renderIconSizes(Component, props) {
    let sizes = [
        "XXS",
        "XS",
        "S",
        "M",
        "L",
        "XL",
        "XXL"
    ];
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", null, sizes.map((size)=>{
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(Component, {
            margin: "15px",
            size: size,
            ...props
        });
    }));
}

},{"../3DMaterials":"f7DUU","../Add":"evYih","../Alert":"lNgQc","../Bell":"5FeJ6","react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"f7DUU":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("4a513e75bedc7d37");
exports.__esModule = true;
exports.default = _3DMaterials;
var _DMaterials = require("70f00d0eb0dc1dda");
var _icon = require("6220560254859b48");
var _react = _interopRequireDefault(require("eb23107094d590a7"));
function _3DMaterials(props) {
    return /*#__PURE__*/ _react.default.createElement(_icon.Icon, props, /*#__PURE__*/ _react.default.createElement(_DMaterials.A4u3DMaterials, null));
}

},{"4a513e75bedc7d37":"iHubQ","70f00d0eb0dc1dda":"bhsRy","6220560254859b48":"k7wem","eb23107094d590a7":"9yzVZ"}],"bhsRy":[function(require,module,exports) {
/**
* @adobe/react-spectrum-workflow (c) by Adobe
* 
* @adobe/react-spectrum-workflow is licensed under a
* Creative Commons Attribution-NoDerivatives 4.0 International License.
* 
* You should have received a copy of the license along with this
* work. If not, see <http://creativecommons.org/licenses/by-nd/4.0/>.
**/ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.A4u3DMaterials = A4u3DMaterials;
var _react = _interopRequireDefault(require("590e374bfa87c15f"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function A4u3DMaterials(_ref) {
    var props = _extends({}, _ref);
    return /*#__PURE__*/ _react["default"].createElement("svg", _extends({
        viewBox: "0 0 36 36"
    }, props, props), /*#__PURE__*/ _react["default"].createElement("path", {
        fillRule: "evenodd",
        d: "M11.493,27.963a.216.216,0,0,0-.283-.268c-.734.287-1.852.613-2.335.131C7.351,26.3,10.362,20.064,15.366,15.06S26.666,7.244,28.124,8.7a1.089,1.089,0,0,1,.253,1.011.219.219,0,0,0,.281.249,9.057,9.057,0,0,1,1.495-.326.421.421,0,0,0,.367-.379,2.248,2.248,0,0,0-.5-1.895L30,7.347,30,7.341A15.952,15.952,0,1,0,7.156,29.58a.784.784,0,0,0,.125.1l.01.012a2.087,2.087,0,0,0,1.532.529,6.5,6.5,0,0,0,2.014-.4.456.456,0,0,0,.3-.361A11.427,11.427,0,0,1,11.493,27.963Z"
    }), /*#__PURE__*/ _react["default"].createElement("path", {
        fillRule: "evenodd",
        d: "M33.5,14.729c-.293-1.771-.939-2.959-2.509-2.959-2.69,0-7.007,2.719-11,6.927-4.736,5-7.466,10.4-6.638,13.144a2.742,2.742,0,0,0,2.458,1.887,14.425,14.425,0,0,0,2.217.172,14.944,14.944,0,0,0,11-4.744A15.958,15.958,0,0,0,33.5,14.729Z"
    }));
}

},{"590e374bfa87c15f":"9yzVZ"}],"38Lce":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parameters", ()=>parameters);
parcelHelpers.export(exports, "decorators", ()=>decorators);
parcelHelpers.export(exports, "argTypesEnhancers", ()=>argTypesEnhancers);
var _docsTools = require("@storybook/docs-tools");
var _extractArgTypes = require("./extractArgTypes");
var _jsxDecorator = require("./jsxDecorator");
var parameters = {
    docs: {
        inlineStories: true,
        // NOTE: that the result is a react element. Hooks support is provided by the outer code.
        prepareForInline: function prepareForInline(storyFn) {
            return storyFn();
        },
        extractArgTypes: (0, _extractArgTypes.extractArgTypes),
        extractComponentDescription: (0, _docsTools.extractComponentDescription)
    }
};
var decorators = [
    (0, _jsxDecorator.jsxDecorator)
];
var argTypesEnhancers = [
    (0, _docsTools.enhanceArgTypes)
];

},{"@storybook/docs-tools":"c0Wnz","./extractArgTypes":"dtHip","./jsxDecorator":"4wgBZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"c0Wnz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _argTypes = require("./argTypes");
parcelHelpers.exportAll(_argTypes, exports);
var _shared = require("./shared");
parcelHelpers.exportAll(_shared, exports);
var _hasDocsOrControls = require("./hasDocsOrControls");
parcelHelpers.exportAll(_hasDocsOrControls, exports);

},{"./argTypes":"eZl9x","./shared":"c8f3q","./hasDocsOrControls":false,"@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"eZl9x":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _convert = require("./convert");
parcelHelpers.exportAll(_convert, exports);
var _docgen = require("./docgen");
parcelHelpers.exportAll(_docgen, exports);
var _jsdocParser = require("./jsdocParser");
parcelHelpers.exportAll(_jsdocParser, exports);
var _types = require("./types");
parcelHelpers.exportAll(_types, exports);
var _utils = require("./utils");
parcelHelpers.exportAll(_utils, exports);
var _enhanceArgTypes = require("./enhanceArgTypes");
parcelHelpers.exportAll(_enhanceArgTypes, exports);

},{"./convert":false,"./docgen":"86lm1","./jsdocParser":false,"./types":"hYfqC","./utils":"fKvkw","./enhanceArgTypes":"6SQWf","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"eGTxe":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "convert", ()=>convert);
var _typescript = require("./typescript");
var _flow = require("./flow");
var _proptypes = require("./proptypes");
var convert = function convert(docgenInfo) {
    var type = docgenInfo.type, tsType = docgenInfo.tsType, flowType = docgenInfo.flowType;
    if (type != null) return (0, _proptypes.convert)(type);
    if (tsType != null) return (0, _typescript.convert)(tsType);
    if (flowType != null) return (0, _flow.convert)(flowType);
    return null;
};

},{"./typescript":"lyiRs","./flow":"4qkuD","./proptypes":"amxAE","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"lyiRs":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _convert = require("./convert");
parcelHelpers.exportAll(_convert, exports);
var _types = require("./types");
parcelHelpers.exportAll(_types, exports);

},{"./convert":"aa274","./types":"fPwtg","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"aa274":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "convert", ()=>convert);
var _esObjectToStringJs = require("core-js/modules/es.object.to-string.js");
var _webDomCollectionsForEachJs = require("core-js/modules/web.dom-collections.for-each.js");
var _esFunctionNameJs = require("core-js/modules/es.function.name.js");
var _esObjectAssignJs = require("core-js/modules/es.object.assign.js");
var _esArrayMapJs = require("core-js/modules/es.array.map.js");
/* eslint-disable no-case-declarations */ var convertSig = function convertSig(type) {
    switch(type.type){
        case "function":
            return {
                name: "function"
            };
        case "object":
            var values = {};
            type.signature.properties.forEach(function(prop) {
                values[prop.key] = convert(prop.value);
            });
            return {
                name: "object",
                value: values
            };
        default:
            throw new Error("Unknown: ".concat(type));
    }
};
var convert = function convert(type) {
    var name = type.name, raw = type.raw;
    var base = {};
    if (typeof raw !== "undefined") base.raw = raw;
    switch(type.name){
        case "string":
        case "number":
        case "symbol":
        case "boolean":
            return Object.assign({}, base, {
                name: name
            });
        case "Array":
            return Object.assign({}, base, {
                name: "array",
                value: type.elements.map(convert)
            });
        case "signature":
            return Object.assign({}, base, convertSig(type));
        case "union":
        case "intersection":
            return Object.assign({}, base, {
                name: name,
                value: type.elements.map(convert)
            });
        default:
            return Object.assign({}, base, {
                name: "other",
                value: name
            });
    }
};

},{"core-js/modules/es.object.to-string.js":"lsA9p","core-js/modules/web.dom-collections.for-each.js":"iYT1M","core-js/modules/es.function.name.js":"4LiLL","core-js/modules/es.object.assign.js":"8FU8M","core-js/modules/es.array.map.js":"jTP7e","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"fPwtg":[function(require,module,exports) {

},{}],"4qkuD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _convert = require("./convert");
parcelHelpers.exportAll(_convert, exports);
var _types = require("./types");
parcelHelpers.exportAll(_types, exports);

},{"./convert":"4MfXR","./types":"7JJci","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"4MfXR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "convert", ()=>convert);
var _esFunctionNameJs = require("core-js/modules/es.function.name.js");
var _esRegexpExecJs = require("core-js/modules/es.regexp.exec.js");
var _esStringReplaceJs = require("core-js/modules/es.string.replace.js");
var _esObjectToStringJs = require("core-js/modules/es.object.to-string.js");
var _webDomCollectionsForEachJs = require("core-js/modules/web.dom-collections.for-each.js");
var _esObjectAssignJs = require("core-js/modules/es.object.assign.js");
var _esArrayMapJs = require("core-js/modules/es.array.map.js");
/* eslint-disable no-case-declarations */ var isLiteral = function isLiteral(type) {
    return type.name === "literal";
};
var toEnumOption = function toEnumOption(element) {
    return element.value.replace(/['|"]/g, "");
};
var convertSig = function convertSig(type) {
    switch(type.type){
        case "function":
            return {
                name: "function"
            };
        case "object":
            var values = {};
            type.signature.properties.forEach(function(prop) {
                values[prop.key] = convert(prop.value);
            });
            return {
                name: "object",
                value: values
            };
        default:
            throw new Error("Unknown: ".concat(type));
    }
};
var convert = function convert(type) {
    var name = type.name, raw = type.raw;
    var base = {};
    if (typeof raw !== "undefined") base.raw = raw;
    switch(type.name){
        case "literal":
            return Object.assign({}, base, {
                name: "other",
                value: type.value
            });
        case "string":
        case "number":
        case "symbol":
        case "boolean":
            return Object.assign({}, base, {
                name: name
            });
        case "Array":
            return Object.assign({}, base, {
                name: "array",
                value: type.elements.map(convert)
            });
        case "signature":
            return Object.assign({}, base, convertSig(type));
        case "union":
            if (type.elements.every(isLiteral)) return Object.assign({}, base, {
                name: "enum",
                value: type.elements.map(toEnumOption)
            });
            return Object.assign({}, base, {
                name: name,
                value: type.elements.map(convert)
            });
        case "intersection":
            return Object.assign({}, base, {
                name: name,
                value: type.elements.map(convert)
            });
        default:
            return Object.assign({}, base, {
                name: "other",
                value: name
            });
    }
};

},{"core-js/modules/es.function.name.js":"4LiLL","core-js/modules/es.regexp.exec.js":"5q56v","core-js/modules/es.string.replace.js":"bFiJG","core-js/modules/es.object.to-string.js":"lsA9p","core-js/modules/web.dom-collections.for-each.js":"iYT1M","core-js/modules/es.object.assign.js":"8FU8M","core-js/modules/es.array.map.js":"jTP7e","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"7JJci":[function(require,module,exports) {

},{}],"amxAE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _convert = require("./convert");
parcelHelpers.exportAll(_convert, exports);
var _types = require("./types");
parcelHelpers.exportAll(_types, exports);

},{"./convert":"iet9A","./types":"g58ik","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"iet9A":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "convert", ()=>convert);
var _esFunctionNameJs = require("core-js/modules/es.function.name.js");
var _esArrayMapJs = require("core-js/modules/es.array.map.js");
var _esNumberIsNanJs = require("core-js/modules/es.number.is-nan.js");
var _esNumberConstructorJs = require("core-js/modules/es.number.constructor.js");
var _esObjectAssignJs = require("core-js/modules/es.object.assign.js");
var _esRegexpExecJs = require("core-js/modules/es.regexp.exec.js");
var _esStringSplitJs = require("core-js/modules/es.string.split.js");
var _esArrayConcatJs = require("core-js/modules/es.array.concat.js");
/* eslint-disable no-case-declarations */ var _mapValues = require("lodash/mapValues");
var _mapValuesDefault = parcelHelpers.interopDefault(_mapValues);
var _utils = require("../utils");
var SIGNATURE_REGEXP = /^\(.*\) => /;
var convert = function convert(type) {
    var name = type.name, raw = type.raw, computed = type.computed, value = type.value;
    var base = {};
    if (typeof raw !== "undefined") base.raw = raw;
    switch(name){
        case "enum":
            var _values = computed ? value : value.map(function(v) {
                var trimmedValue = (0, _utils.trimQuotes)(v.value);
                return (0, _utils.includesQuotes)(v.value) || Number.isNaN(Number(trimmedValue)) ? trimmedValue : Number(trimmedValue);
            });
            return Object.assign({}, base, {
                name: name,
                value: _values
            });
        case "string":
        case "number":
        case "symbol":
            return Object.assign({}, base, {
                name: name
            });
        case "func":
            return Object.assign({}, base, {
                name: "function"
            });
        case "bool":
        case "boolean":
            return Object.assign({}, base, {
                name: "boolean"
            });
        case "arrayOf":
        case "array":
            return Object.assign({}, base, {
                name: "array",
                value: value && convert(value)
            });
        case "object":
            return Object.assign({}, base, {
                name: name
            });
        case "objectOf":
            return Object.assign({}, base, {
                name: name,
                value: convert(value)
            });
        case "shape":
        case "exact":
            var values = (0, _mapValuesDefault.default)(value, function(field) {
                return convert(field);
            });
            return Object.assign({}, base, {
                name: "object",
                value: values
            });
        case "union":
            return Object.assign({}, base, {
                name: "union",
                value: value.map(function(v) {
                    return convert(v);
                })
            });
        case "instanceOf":
        case "element":
        case "elementType":
        default:
            if ((name === null || name === void 0 ? void 0 : name.indexOf("|")) > 0) // react-docgen-typescript-plugin doesn't always produce enum-like unions
            // (like if a user has turned off shouldExtractValuesFromUnion) so here we
            // try to recover and construct one.
            try {
                var literalValues = name.split("|").map(function(v) {
                    return JSON.parse(v);
                });
                return Object.assign({}, base, {
                    name: "enum",
                    value: literalValues
                });
            } catch (err) {}
            var otherVal = value ? "".concat(name, "(").concat(value, ")") : name;
            var otherName = SIGNATURE_REGEXP.test(name) ? "function" : "other";
            return Object.assign({}, base, {
                name: otherName,
                value: otherVal
            });
    }
};

},{"core-js/modules/es.function.name.js":"4LiLL","core-js/modules/es.array.map.js":"jTP7e","core-js/modules/es.number.is-nan.js":"hge9g","core-js/modules/es.number.constructor.js":"hVD7l","core-js/modules/es.object.assign.js":"8FU8M","core-js/modules/es.regexp.exec.js":"5q56v","core-js/modules/es.string.split.js":"12go2","core-js/modules/es.array.concat.js":"g1t7q","lodash/mapValues":"fBbhh","../utils":"4qcyR","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"hge9g":[function(require,module,exports) {
var $ = require("677c53d72f4dc4b5");
// `Number.isNaN` method
// https://tc39.es/ecma262/#sec-number.isnan
$({
    target: "Number",
    stat: true
}, {
    isNaN: function isNaN(number) {
        // eslint-disable-next-line no-self-compare -- NaN check
        return number != number;
    }
});

},{"677c53d72f4dc4b5":"1OO62"}],"4qcyR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "trimQuotes", ()=>trimQuotes);
parcelHelpers.export(exports, "includesQuotes", ()=>includesQuotes);
var _esRegexpExecJs = require("core-js/modules/es.regexp.exec.js");
var _esStringReplaceJs = require("core-js/modules/es.string.replace.js");
var QUOTE_REGEX = /^['"]|['"]$/g;
var trimQuotes = function trimQuotes(str) {
    return str.replace(QUOTE_REGEX, "");
};
var includesQuotes = function includesQuotes(str) {
    return QUOTE_REGEX.test(str);
};

},{"core-js/modules/es.regexp.exec.js":"5q56v","core-js/modules/es.string.replace.js":"bFiJG","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"g58ik":[function(require,module,exports) {

},{}],"86lm1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _types = require("./types");
parcelHelpers.exportAll(_types, exports);
var _utils = require("./utils");
parcelHelpers.exportAll(_utils, exports);
var _extractDocgenProps = require("./extractDocgenProps");
parcelHelpers.exportAll(_extractDocgenProps, exports);
var _propDef = require("./PropDef");
parcelHelpers.exportAll(_propDef, exports);

},{"./types":"aopd1","./utils":"il0eA","./extractDocgenProps":"erNst","./PropDef":"4SHI7","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"aopd1":[function(require,module,exports) {
// eslint-disable-next-line @typescript-eslint/no-empty-interface
// export type DocgenType = DocgenPropType | DocgenFlowType | DocgenTypeScriptType;
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TypeSystem", ()=>TypeSystem);
var TypeSystem;
(function(TypeSystem) {
    TypeSystem["JAVASCRIPT"] = "JavaScript";
    TypeSystem["FLOW"] = "Flow";
    TypeSystem["TYPESCRIPT"] = "TypeScript";
    TypeSystem["UNKNOWN"] = "Unknown";
})(TypeSystem || (TypeSystem = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"il0eA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defaultValue = require("./defaultValue");
parcelHelpers.exportAll(_defaultValue, exports);
var _string = require("./string");
parcelHelpers.exportAll(_string, exports);
var _docgenInfo = require("./docgenInfo");
parcelHelpers.exportAll(_docgenInfo, exports);

},{"./defaultValue":false,"./string":false,"./docgenInfo":"fMZcC","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"8IgOj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isDefaultValueBlacklisted", ()=>isDefaultValueBlacklisted);
var _esObjectToStringJs = require("core-js/modules/es.object.to-string.js");
var BLACKLIST = [
    "null",
    "undefined"
];
function isDefaultValueBlacklisted(value) {
    return BLACKLIST.some(function(x) {
        return x === value;
    });
}

},{"core-js/modules/es.object.to-string.js":"lsA9p","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"1Nqlj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "str", ()=>str);
var str = function str(obj) {
    if (!obj) return "";
    if (typeof obj === "string") return obj;
    throw new Error("Description: expected string, got: ".concat(JSON.stringify(obj)));
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"fMZcC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hasDocgen", ()=>hasDocgen);
parcelHelpers.export(exports, "isValidDocgenSection", ()=>isValidDocgenSection);
parcelHelpers.export(exports, "getDocgenSection", ()=>getDocgenSection);
parcelHelpers.export(exports, "getDocgenDescription", ()=>getDocgenDescription);
var _esObjectKeysJs = require("core-js/modules/es.object.keys.js");
var _esSymbolJs = require("core-js/modules/es.symbol.js");
var _esSymbolDescriptionJs = require("core-js/modules/es.symbol.description.js");
/* eslint-disable no-underscore-dangle */ var _string = require("./string");
function hasDocgen(component) {
    return !!component.__docgenInfo;
}
function isValidDocgenSection(docgenSection) {
    return docgenSection != null && Object.keys(docgenSection).length > 0;
}
function getDocgenSection(component, section) {
    return hasDocgen(component) ? component.__docgenInfo[section] : null;
}
function getDocgenDescription(component) {
    return hasDocgen(component) && (0, _string.str)(component.__docgenInfo.description);
}

},{"core-js/modules/es.object.keys.js":"5Q2AT","core-js/modules/es.symbol.js":"ajw2f","core-js/modules/es.symbol.description.js":"wrlLc","./string":"1Nqlj","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"erNst":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "extractComponentSectionArray", ()=>extractComponentSectionArray);
parcelHelpers.export(exports, "extractComponentSectionObject", ()=>extractComponentSectionObject);
parcelHelpers.export(exports, "extractComponentProps", ()=>extractComponentProps);
parcelHelpers.export(exports, "extractComponentDescription", ()=>extractComponentDescription);
var _esArrayMapJs = require("core-js/modules/es.array.map.js");
var _esObjectAssignJs = require("core-js/modules/es.object.assign.js");
var _esFunctionNameJs = require("core-js/modules/es.function.name.js");
var _esObjectKeysJs = require("core-js/modules/es.object.keys.js");
var _esArrayFilterJs = require("core-js/modules/es.array.filter.js");
var _esObjectToStringJs = require("core-js/modules/es.object.to-string.js");
var _esSymbolJs = require("core-js/modules/es.symbol.js");
var _esSymbolDescriptionJs = require("core-js/modules/es.symbol.description.js");
var _jsdocParser = require("../jsdocParser");
var _types = require("./types");
var _utils = require("./utils");
var _createPropDef = require("./createPropDef");
var getTypeSystem = function getTypeSystem(docgenInfo) {
    if (docgenInfo.type != null) return (0, _types.TypeSystem).JAVASCRIPT;
    if (docgenInfo.flowType != null) return (0, _types.TypeSystem).FLOW;
    if (docgenInfo.tsType != null) return (0, _types.TypeSystem).TYPESCRIPT;
    return (0, _types.TypeSystem).UNKNOWN;
};
var extractComponentSectionArray = function extractComponentSectionArray(docgenSection) {
    var typeSystem = getTypeSystem(docgenSection[0]);
    var createPropDef = (0, _createPropDef.getPropDefFactory)(typeSystem);
    return docgenSection.map(function(item) {
        var _item$type;
        var sanitizedItem = item;
        if ((_item$type = item.type) !== null && _item$type !== void 0 && _item$type.elements) sanitizedItem = Object.assign({}, item, {
            type: Object.assign({}, item.type, {
                value: item.type.elements
            })
        });
        return extractProp(sanitizedItem.name, sanitizedItem, typeSystem, createPropDef);
    });
};
var extractComponentSectionObject = function extractComponentSectionObject(docgenSection) {
    var docgenPropsKeys = Object.keys(docgenSection);
    var typeSystem = getTypeSystem(docgenSection[docgenPropsKeys[0]]);
    var createPropDef = (0, _createPropDef.getPropDefFactory)(typeSystem);
    return docgenPropsKeys.map(function(propName) {
        var docgenInfo = docgenSection[propName];
        return docgenInfo != null ? extractProp(propName, docgenInfo, typeSystem, createPropDef) : null;
    }).filter(Boolean);
};
var extractComponentProps = function extractComponentProps(component, section) {
    var docgenSection = (0, _utils.getDocgenSection)(component, section);
    if (!(0, _utils.isValidDocgenSection)(docgenSection)) return [];
     // vue-docgen-api has diverged from react-docgen and returns an array
    return Array.isArray(docgenSection) ? extractComponentSectionArray(docgenSection) : extractComponentSectionObject(docgenSection);
};
function extractProp(propName, docgenInfo, typeSystem, createPropDef) {
    var jsDocParsingResult = (0, _jsdocParser.parseJsDoc)(docgenInfo.description);
    var isIgnored = jsDocParsingResult.includesJsDoc && jsDocParsingResult.ignore;
    if (!isIgnored) {
        var propDef = createPropDef(propName, docgenInfo, jsDocParsingResult);
        return {
            propDef: propDef,
            jsDocTags: jsDocParsingResult.extractedTags,
            docgenInfo: docgenInfo,
            typeSystem: typeSystem
        };
    }
    return null;
}
function extractComponentDescription(component) {
    return component != null && (0, _utils.getDocgenDescription)(component);
}

},{"core-js/modules/es.array.map.js":"jTP7e","core-js/modules/es.object.assign.js":"8FU8M","core-js/modules/es.function.name.js":"4LiLL","core-js/modules/es.object.keys.js":"5Q2AT","core-js/modules/es.array.filter.js":"fD2da","core-js/modules/es.object.to-string.js":"lsA9p","core-js/modules/es.symbol.js":"ajw2f","core-js/modules/es.symbol.description.js":"wrlLc","../jsdocParser":"lnYSY","./types":"aopd1","./utils":"il0eA","./createPropDef":"ekP6O","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"lnYSY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parseJsDoc", ()=>parseJsDoc);
var _esArrayIncludesJs = require("core-js/modules/es.array.includes.js");
var _esStringIncludesJs = require("core-js/modules/es.string.includes.js");
var _esSymbolJs = require("core-js/modules/es.symbol.js");
var _esSymbolDescriptionJs = require("core-js/modules/es.symbol.description.js");
var _esFunctionNameJs = require("core-js/modules/es.function.name.js");
var _esRegexpExecJs = require("core-js/modules/es.regexp.exec.js");
var _esStringReplaceJs = require("core-js/modules/es.string.replace.js");
var _esArrayMapJs = require("core-js/modules/es.array.map.js");
var _esArrayConcatJs = require("core-js/modules/es.array.concat.js");
var _esArrayJoinJs = require("core-js/modules/es.array.join.js");
var _doctrine = require("doctrine");
var _doctrineDefault = parcelHelpers.interopDefault(_doctrine);
function containsJsDoc(value) {
    return value != null && value.includes("@");
}
function parse(content, tags) {
    var ast;
    try {
        ast = (0, _doctrineDefault.default).parse(content, {
            tags: tags,
            sloppy: true
        });
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
        throw new Error("Cannot parse JSDoc tags.");
    }
    return ast;
}
var DEFAULT_OPTIONS = {
    tags: [
        "param",
        "arg",
        "argument",
        "returns",
        "ignore"
    ]
};
var parseJsDoc = function parseJsDoc(value) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_OPTIONS;
    if (!containsJsDoc(value)) return {
        includesJsDoc: false,
        ignore: false
    };
    var jsDocAst = parse(value, options.tags);
    var extractedTags = extractJsDocTags(jsDocAst);
    if (extractedTags.ignore) // There is no point in doing other stuff since this prop will not be rendered.
    return {
        includesJsDoc: true,
        ignore: true
    };
    return {
        includesJsDoc: true,
        ignore: false,
        // Always use the parsed description to ensure JSDoc is removed from the description.
        description: jsDocAst.description,
        extractedTags: extractedTags
    };
};
function extractJsDocTags(ast) {
    var extractedTags = {
        params: null,
        returns: null,
        ignore: false
    };
    for(var i = 0; i < ast.tags.length; i += 1){
        var tag = ast.tags[i];
        if (tag.title === "ignore") {
            extractedTags.ignore = true; // Once we reach an @ignore tag, there is no point in parsing the other tags since we will not render the prop.
            break;
        } else switch(tag.title){
            // arg & argument are aliases for param.
            case "param":
            case "arg":
            case "argument":
                var paramTag = extractParam(tag);
                if (paramTag != null) {
                    if (extractedTags.params == null) extractedTags.params = [];
                    extractedTags.params.push(paramTag);
                }
                break;
            case "returns":
                var returnsTag = extractReturns(tag);
                if (returnsTag != null) extractedTags.returns = returnsTag;
                break;
            default:
                break;
        }
    }
    return extractedTags;
}
function extractParam(tag) {
    var paramName = tag.name; // When the @param doesn't have a name but have a type and a description, "null-null" is returned.
    if (paramName != null && paramName !== "null-null") return {
        name: tag.name,
        type: tag.type,
        description: tag.description,
        getPrettyName: function getPrettyName() {
            if (paramName.includes("null")) // There is a few cases in which the returned param name contains "null".
            // - @param {SyntheticEvent} event- Original SyntheticEvent
            // - @param {SyntheticEvent} event.\n@returns {string}
            return paramName.replace("-null", "").replace(".null", "");
            return tag.name;
        },
        getTypeName: function getTypeName() {
            return tag.type != null ? extractTypeName(tag.type) : null;
        }
    };
    return null;
}
function extractReturns(tag) {
    if (tag.type != null) return {
        type: tag.type,
        description: tag.description,
        getTypeName: function getTypeName() {
            return extractTypeName(tag.type);
        }
    };
    return null;
}
function extractTypeName(type) {
    if (type.type === "NameExpression") return type.name;
    if (type.type === "RecordType") {
        var recordFields = type.fields.map(function(field) {
            if (field.value != null) {
                var valueTypeName = extractTypeName(field.value);
                return "".concat(field.key, ": ").concat(valueTypeName);
            }
            return field.key;
        });
        return "({".concat(recordFields.join(", "), "})");
    }
    if (type.type === "UnionType") {
        var unionElements = type.elements.map(extractTypeName);
        return "(".concat(unionElements.join("|"), ")");
    } // Only support untyped array: []. Might add more support later if required.
    if (type.type === "ArrayType") return "[]";
    if (type.type === "TypeApplication") {
        if (type.expression != null) {
            if (type.expression.name === "Array") {
                var arrayType = extractTypeName(type.applications[0]);
                return "".concat(arrayType, "[]");
            }
        }
    }
    if (type.type === "NullableType" || type.type === "NonNullableType" || type.type === "OptionalType") return extractTypeName(type.expression);
    if (type.type === "AllLiteral") return "any";
    return null;
}

},{"core-js/modules/es.array.includes.js":"dbUjS","core-js/modules/es.string.includes.js":"cx9ET","core-js/modules/es.symbol.js":"ajw2f","core-js/modules/es.symbol.description.js":"wrlLc","core-js/modules/es.function.name.js":"4LiLL","core-js/modules/es.regexp.exec.js":"5q56v","core-js/modules/es.string.replace.js":"bFiJG","core-js/modules/es.array.map.js":"jTP7e","core-js/modules/es.array.concat.js":"g1t7q","core-js/modules/es.array.join.js":"1w71h","doctrine":"an2s2","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"an2s2":[function(require,module,exports) {
/*
 * @fileoverview Main Doctrine object
 * @author Yusuke Suzuki <utatane.tea@gmail.com>
 * @author Dan Tao <daniel.tao@gmail.com>
 * @author Andrew Eisenberg <andrew@eisenberg.as>
 */ (function() {
    "use strict";
    var typed, utility, jsdoc, esutils, hasOwnProperty;
    esutils = require("38b45b045fff4a79");
    typed = require("6c0e771aae2f60f0");
    utility = require("30c3a19c63d2b475");
    function sliceSource(source, index, last) {
        return source.slice(index, last);
    }
    hasOwnProperty = function() {
        var func = Object.prototype.hasOwnProperty;
        return function hasOwnProperty(obj, name) {
            return func.call(obj, name);
        };
    }();
    function shallowCopy(obj) {
        var ret = {}, key;
        for(key in obj)if (obj.hasOwnProperty(key)) ret[key] = obj[key];
        return ret;
    }
    function isASCIIAlphanumeric(ch) {
        return ch >= 0x61 /* 'a' */  && ch <= 0x7A /* 'z' */  || ch >= 0x41 /* 'A' */  && ch <= 0x5A /* 'Z' */  || ch >= 0x30 /* '0' */  && ch <= 0x39 /* '9' */ ;
    }
    function isParamTitle(title) {
        return title === "param" || title === "argument" || title === "arg";
    }
    function isReturnTitle(title) {
        return title === "return" || title === "returns";
    }
    function isProperty(title) {
        return title === "property" || title === "prop";
    }
    function isNameParameterRequired(title) {
        return isParamTitle(title) || isProperty(title) || title === "alias" || title === "this" || title === "mixes" || title === "requires";
    }
    function isAllowedName(title) {
        return isNameParameterRequired(title) || title === "const" || title === "constant";
    }
    function isAllowedNested(title) {
        return isProperty(title) || isParamTitle(title);
    }
    function isAllowedOptional(title) {
        return isProperty(title) || isParamTitle(title);
    }
    function isTypeParameterRequired(title) {
        return isParamTitle(title) || isReturnTitle(title) || title === "define" || title === "enum" || title === "implements" || title === "this" || title === "type" || title === "typedef" || isProperty(title);
    }
    // Consider deprecation instead using 'isTypeParameterRequired' and 'Rules' declaration to pick when a type is optional/required
    // This would require changes to 'parseType'
    function isAllowedType(title) {
        return isTypeParameterRequired(title) || title === "throws" || title === "const" || title === "constant" || title === "namespace" || title === "member" || title === "var" || title === "module" || title === "constructor" || title === "class" || title === "extends" || title === "augments" || title === "public" || title === "private" || title === "protected";
    }
    // A regex character class that contains all whitespace except linebreak characters (\r, \n, \u2028, \u2029)
    var WHITESPACE = "[ \\f\\t\\v\\u00a0\\u1680\\u180e\\u2000-\\u200a\\u202f\\u205f\\u3000\\ufeff]";
    var STAR_MATCHER = "(" + WHITESPACE + "*(?:\\*" + WHITESPACE + "?)?)(.+|[\r\n\u2028\u2029])";
    function unwrapComment(doc) {
        // JSDoc comment is following form
        //   /**
        //    * .......
        //    */
        return doc.// remove /**
        replace(/^\/\*\*?/, "").// remove */
        replace(/\*\/$/, "").// remove ' * ' at the beginning of a line
        replace(new RegExp(STAR_MATCHER, "g"), "$2").// remove trailing whitespace
        replace(/\s*$/, "");
    }
    /**
     * Converts an index in an "unwrapped" JSDoc comment to the corresponding index in the original "wrapped" version
     * @param {string} originalSource The original wrapped comment
     * @param {number} unwrappedIndex The index of a character in the unwrapped string
     * @returns {number} The index of the corresponding character in the original wrapped string
     */ function convertUnwrappedCommentIndex(originalSource, unwrappedIndex) {
        var replacedSource = originalSource.replace(/^\/\*\*?/, "");
        var numSkippedChars = 0;
        var matcher = new RegExp(STAR_MATCHER, "g");
        var match;
        while(match = matcher.exec(replacedSource)){
            numSkippedChars += match[1].length;
            if (match.index + match[0].length > unwrappedIndex + numSkippedChars) return unwrappedIndex + numSkippedChars + originalSource.length - replacedSource.length;
        }
        return originalSource.replace(/\*\/$/, "").replace(/\s*$/, "").length;
    }
    // JSDoc Tag Parser
    (function(exports1) {
        var Rules, index, lineNumber, length, source, originalSource, recoverable, sloppy, strict;
        function advance() {
            var ch = source.charCodeAt(index);
            index += 1;
            if (esutils.code.isLineTerminator(ch) && !(ch === 0x0D /* '\r' */  && source.charCodeAt(index) === 0x0A /* '\n' */ )) lineNumber += 1;
            return String.fromCharCode(ch);
        }
        function scanTitle() {
            var title = "";
            // waste '@'
            advance();
            while(index < length && isASCIIAlphanumeric(source.charCodeAt(index)))title += advance();
            return title;
        }
        function seekContent() {
            var ch, waiting, last = index;
            waiting = false;
            while(last < length){
                ch = source.charCodeAt(last);
                if (esutils.code.isLineTerminator(ch) && !(ch === 0x0D /* '\r' */  && source.charCodeAt(last + 1) === 0x0A /* '\n' */ )) waiting = true;
                else if (waiting) {
                    if (ch === 0x40 /* '@' */ ) break;
                    if (!esutils.code.isWhiteSpace(ch)) waiting = false;
                }
                last += 1;
            }
            return last;
        }
        // type expression may have nest brace, such as,
        // { { ok: string } }
        //
        // therefore, scanning type expression with balancing braces.
        function parseType(title, last, addRange) {
            var ch, brace, type, startIndex, direct = false;
            // search '{'
            while(index < last){
                ch = source.charCodeAt(index);
                if (esutils.code.isWhiteSpace(ch)) advance();
                else if (ch === 0x7B /* '{' */ ) {
                    advance();
                    break;
                } else {
                    // this is direct pattern
                    direct = true;
                    break;
                }
            }
            if (direct) return null;
            // type expression { is found
            brace = 1;
            type = "";
            while(index < last){
                ch = source.charCodeAt(index);
                if (esutils.code.isLineTerminator(ch)) advance();
                else {
                    if (ch === 0x7D /* '}' */ ) {
                        brace -= 1;
                        if (brace === 0) {
                            advance();
                            break;
                        }
                    } else if (ch === 0x7B /* '{' */ ) brace += 1;
                    if (type === "") startIndex = index;
                    type += advance();
                }
            }
            if (brace !== 0) // braces is not balanced
            return utility.throwError("Braces are not balanced");
            if (isAllowedOptional(title)) return typed.parseParamType(type, {
                startIndex: convertIndex(startIndex),
                range: addRange
            });
            return typed.parseType(type, {
                startIndex: convertIndex(startIndex),
                range: addRange
            });
        }
        function scanIdentifier(last) {
            var identifier;
            if (!esutils.code.isIdentifierStartES5(source.charCodeAt(index)) && !source[index].match(/[0-9]/)) return null;
            identifier = advance();
            while(index < last && esutils.code.isIdentifierPartES5(source.charCodeAt(index)))identifier += advance();
            return identifier;
        }
        function skipWhiteSpace(last) {
            while(index < last && (esutils.code.isWhiteSpace(source.charCodeAt(index)) || esutils.code.isLineTerminator(source.charCodeAt(index))))advance();
        }
        function parseName(last, allowBrackets, allowNestedParams) {
            var name = "", useBrackets, insideString;
            skipWhiteSpace(last);
            if (index >= last) return null;
            if (source.charCodeAt(index) === 0x5B /* '[' */ ) {
                if (allowBrackets) {
                    useBrackets = true;
                    name = advance();
                } else return null;
            }
            name += scanIdentifier(last);
            if (allowNestedParams) {
                if (source.charCodeAt(index) === 0x3A /* ':' */  && (name === "module" || name === "external" || name === "event")) {
                    name += advance();
                    name += scanIdentifier(last);
                }
                if (source.charCodeAt(index) === 0x5B /* '[' */  && source.charCodeAt(index + 1) === 0x5D /* ']' */ ) {
                    name += advance();
                    name += advance();
                }
                while(source.charCodeAt(index) === 0x2E /* '.' */  || source.charCodeAt(index) === 0x2F /* '/' */  || source.charCodeAt(index) === 0x23 /* '#' */  || source.charCodeAt(index) === 0x2D /* '-' */  || source.charCodeAt(index) === 0x7E /* '~' */ ){
                    name += advance();
                    name += scanIdentifier(last);
                }
            }
            if (useBrackets) {
                skipWhiteSpace(last);
                // do we have a default value for this?
                if (source.charCodeAt(index) === 0x3D /* '=' */ ) {
                    // consume the '='' symbol
                    name += advance();
                    skipWhiteSpace(last);
                    var ch;
                    var bracketDepth = 1;
                    // scan in the default value
                    while(index < last){
                        ch = source.charCodeAt(index);
                        if (esutils.code.isWhiteSpace(ch)) {
                            if (!insideString) {
                                skipWhiteSpace(last);
                                ch = source.charCodeAt(index);
                            }
                        }
                        if (ch === 0x27 /* ''' */ ) {
                            if (!insideString) insideString = "'";
                            else if (insideString === "'") insideString = "";
                        }
                        if (ch === 0x22 /* '"' */ ) {
                            if (!insideString) insideString = '"';
                            else if (insideString === '"') insideString = "";
                        }
                        if (ch === 0x5B /* '[' */ ) bracketDepth++;
                        else if (ch === 0x5D /* ']' */  && --bracketDepth === 0) break;
                        name += advance();
                    }
                }
                skipWhiteSpace(last);
                if (index >= last || source.charCodeAt(index) !== 0x5D /* ']' */ ) // we never found a closing ']'
                return null;
                // collect the last ']'
                name += advance();
            }
            return name;
        }
        function skipToTag() {
            while(index < length && source.charCodeAt(index) !== 0x40 /* '@' */ )advance();
            if (index >= length) return false;
            utility.assert(source.charCodeAt(index) === 0x40 /* '@' */ );
            return true;
        }
        function convertIndex(rangeIndex) {
            if (source === originalSource) return rangeIndex;
            return convertUnwrappedCommentIndex(originalSource, rangeIndex);
        }
        function TagParser(options, title) {
            this._options = options;
            this._title = title.toLowerCase();
            this._tag = {
                title: title,
                description: null
            };
            if (this._options.lineNumbers) this._tag.lineNumber = lineNumber;
            this._first = index - title.length - 1;
            this._last = 0;
            // space to save special information for title parsers.
            this._extra = {};
        }
        // addError(err, ...)
        TagParser.prototype.addError = function addError(errorText) {
            var args = Array.prototype.slice.call(arguments, 1), msg = errorText.replace(/%(\d)/g, function(whole, index) {
                utility.assert(index < args.length, "Message reference must be in range");
                return args[index];
            });
            if (!this._tag.errors) this._tag.errors = [];
            if (strict) utility.throwError(msg);
            this._tag.errors.push(msg);
            return recoverable;
        };
        TagParser.prototype.parseType = function() {
            // type required titles
            if (isTypeParameterRequired(this._title)) try {
                this._tag.type = parseType(this._title, this._last, this._options.range);
                if (!this._tag.type) {
                    if (!isParamTitle(this._title) && !isReturnTitle(this._title)) {
                        if (!this.addError("Missing or invalid tag type")) return false;
                    }
                }
            } catch (error) {
                this._tag.type = null;
                if (!this.addError(error.message)) return false;
            }
            else if (isAllowedType(this._title)) // optional types
            try {
                this._tag.type = parseType(this._title, this._last, this._options.range);
            } catch (e) {
            //For optional types, lets drop the thrown error when we hit the end of the file
            }
            return true;
        };
        TagParser.prototype._parseNamePath = function(optional) {
            var name;
            name = parseName(this._last, sloppy && isAllowedOptional(this._title), true);
            if (!name) {
                if (!optional) {
                    if (!this.addError("Missing or invalid tag name")) return false;
                }
            }
            this._tag.name = name;
            return true;
        };
        TagParser.prototype.parseNamePath = function() {
            return this._parseNamePath(false);
        };
        TagParser.prototype.parseNamePathOptional = function() {
            return this._parseNamePath(true);
        };
        TagParser.prototype.parseName = function() {
            var assign, name;
            // param, property requires name
            if (isAllowedName(this._title)) {
                this._tag.name = parseName(this._last, sloppy && isAllowedOptional(this._title), isAllowedNested(this._title));
                if (!this._tag.name) {
                    if (!isNameParameterRequired(this._title)) return true;
                    // it's possible the name has already been parsed but interpreted as a type
                    // it's also possible this is a sloppy declaration, in which case it will be
                    // fixed at the end
                    if (isParamTitle(this._title) && this._tag.type && this._tag.type.name) {
                        this._extra.name = this._tag.type;
                        this._tag.name = this._tag.type.name;
                        this._tag.type = null;
                    } else {
                        if (!this.addError("Missing or invalid tag name")) return false;
                    }
                } else {
                    name = this._tag.name;
                    if (name.charAt(0) === "[" && name.charAt(name.length - 1) === "]") {
                        // extract the default value if there is one
                        // example: @param {string} [somebody=John Doe] description
                        assign = name.substring(1, name.length - 1).split("=");
                        if (assign.length > 1) this._tag["default"] = assign.slice(1).join("=");
                        this._tag.name = assign[0];
                        // convert to an optional type
                        if (this._tag.type && this._tag.type.type !== "OptionalType") this._tag.type = {
                            type: "OptionalType",
                            expression: this._tag.type
                        };
                    }
                }
            }
            return true;
        };
        TagParser.prototype.parseDescription = function parseDescription() {
            var description = sliceSource(source, index, this._last).trim();
            if (description) {
                if (/^-\s+/.test(description)) description = description.substring(2);
                this._tag.description = description;
            }
            return true;
        };
        TagParser.prototype.parseCaption = function parseDescription() {
            var description = sliceSource(source, index, this._last).trim();
            var captionStartTag = "<caption>";
            var captionEndTag = "</caption>";
            var captionStart = description.indexOf(captionStartTag);
            var captionEnd = description.indexOf(captionEndTag);
            if (captionStart >= 0 && captionEnd >= 0) {
                this._tag.caption = description.substring(captionStart + captionStartTag.length, captionEnd).trim();
                this._tag.description = description.substring(captionEnd + captionEndTag.length).trim();
            } else this._tag.description = description;
            return true;
        };
        TagParser.prototype.parseKind = function parseKind() {
            var kind, kinds;
            kinds = {
                "class": true,
                "constant": true,
                "event": true,
                "external": true,
                "file": true,
                "function": true,
                "member": true,
                "mixin": true,
                "module": true,
                "namespace": true,
                "typedef": true
            };
            kind = sliceSource(source, index, this._last).trim();
            this._tag.kind = kind;
            if (!hasOwnProperty(kinds, kind)) {
                if (!this.addError("Invalid kind name '%0'", kind)) return false;
            }
            return true;
        };
        TagParser.prototype.parseAccess = function parseAccess() {
            var access;
            access = sliceSource(source, index, this._last).trim();
            this._tag.access = access;
            if (access !== "private" && access !== "protected" && access !== "public") {
                if (!this.addError("Invalid access name '%0'", access)) return false;
            }
            return true;
        };
        TagParser.prototype.parseThis = function parseThis() {
            // this name may be a name expression (e.g. {foo.bar}),
            // an union (e.g. {foo.bar|foo.baz}) or a name path (e.g. foo.bar)
            var value = sliceSource(source, index, this._last).trim();
            if (value && value.charAt(0) === "{") {
                var gotType = this.parseType();
                if (gotType && this._tag.type.type === "NameExpression" || this._tag.type.type === "UnionType") {
                    this._tag.name = this._tag.type.name;
                    return true;
                } else return this.addError("Invalid name for this");
            } else return this.parseNamePath();
        };
        TagParser.prototype.parseVariation = function parseVariation() {
            var variation, text;
            text = sliceSource(source, index, this._last).trim();
            variation = parseFloat(text, 10);
            this._tag.variation = variation;
            if (isNaN(variation)) {
                if (!this.addError("Invalid variation '%0'", text)) return false;
            }
            return true;
        };
        TagParser.prototype.ensureEnd = function() {
            var shouldBeEmpty = sliceSource(source, index, this._last).trim();
            if (shouldBeEmpty) {
                if (!this.addError("Unknown content '%0'", shouldBeEmpty)) return false;
            }
            return true;
        };
        TagParser.prototype.epilogue = function epilogue() {
            var description;
            description = this._tag.description;
            // un-fix potentially sloppy declaration
            if (isAllowedOptional(this._title) && !this._tag.type && description && description.charAt(0) === "[") {
                this._tag.type = this._extra.name;
                if (!this._tag.name) this._tag.name = undefined;
                if (!sloppy) {
                    if (!this.addError("Missing or invalid tag name")) return false;
                }
            }
            return true;
        };
        Rules = {
            // http://usejsdoc.org/tags-access.html
            "access": [
                "parseAccess"
            ],
            // http://usejsdoc.org/tags-alias.html
            "alias": [
                "parseNamePath",
                "ensureEnd"
            ],
            // http://usejsdoc.org/tags-augments.html
            "augments": [
                "parseType",
                "parseNamePathOptional",
                "ensureEnd"
            ],
            // http://usejsdoc.org/tags-constructor.html
            "constructor": [
                "parseType",
                "parseNamePathOptional",
                "ensureEnd"
            ],
            // Synonym: http://usejsdoc.org/tags-constructor.html
            "class": [
                "parseType",
                "parseNamePathOptional",
                "ensureEnd"
            ],
            // Synonym: http://usejsdoc.org/tags-extends.html
            "extends": [
                "parseType",
                "parseNamePathOptional",
                "ensureEnd"
            ],
            // http://usejsdoc.org/tags-example.html
            "example": [
                "parseCaption"
            ],
            // http://usejsdoc.org/tags-deprecated.html
            "deprecated": [
                "parseDescription"
            ],
            // http://usejsdoc.org/tags-global.html
            "global": [
                "ensureEnd"
            ],
            // http://usejsdoc.org/tags-inner.html
            "inner": [
                "ensureEnd"
            ],
            // http://usejsdoc.org/tags-instance.html
            "instance": [
                "ensureEnd"
            ],
            // http://usejsdoc.org/tags-kind.html
            "kind": [
                "parseKind"
            ],
            // http://usejsdoc.org/tags-mixes.html
            "mixes": [
                "parseNamePath",
                "ensureEnd"
            ],
            // http://usejsdoc.org/tags-mixin.html
            "mixin": [
                "parseNamePathOptional",
                "ensureEnd"
            ],
            // http://usejsdoc.org/tags-member.html
            "member": [
                "parseType",
                "parseNamePathOptional",
                "ensureEnd"
            ],
            // http://usejsdoc.org/tags-method.html
            "method": [
                "parseNamePathOptional",
                "ensureEnd"
            ],
            // http://usejsdoc.org/tags-module.html
            "module": [
                "parseType",
                "parseNamePathOptional",
                "ensureEnd"
            ],
            // Synonym: http://usejsdoc.org/tags-method.html
            "func": [
                "parseNamePathOptional",
                "ensureEnd"
            ],
            // Synonym: http://usejsdoc.org/tags-method.html
            "function": [
                "parseNamePathOptional",
                "ensureEnd"
            ],
            // Synonym: http://usejsdoc.org/tags-member.html
            "var": [
                "parseType",
                "parseNamePathOptional",
                "ensureEnd"
            ],
            // http://usejsdoc.org/tags-name.html
            "name": [
                "parseNamePath",
                "ensureEnd"
            ],
            // http://usejsdoc.org/tags-namespace.html
            "namespace": [
                "parseType",
                "parseNamePathOptional",
                "ensureEnd"
            ],
            // http://usejsdoc.org/tags-private.html
            "private": [
                "parseType",
                "parseDescription"
            ],
            // http://usejsdoc.org/tags-protected.html
            "protected": [
                "parseType",
                "parseDescription"
            ],
            // http://usejsdoc.org/tags-public.html
            "public": [
                "parseType",
                "parseDescription"
            ],
            // http://usejsdoc.org/tags-readonly.html
            "readonly": [
                "ensureEnd"
            ],
            // http://usejsdoc.org/tags-requires.html
            "requires": [
                "parseNamePath",
                "ensureEnd"
            ],
            // http://usejsdoc.org/tags-since.html
            "since": [
                "parseDescription"
            ],
            // http://usejsdoc.org/tags-static.html
            "static": [
                "ensureEnd"
            ],
            // http://usejsdoc.org/tags-summary.html
            "summary": [
                "parseDescription"
            ],
            // http://usejsdoc.org/tags-this.html
            "this": [
                "parseThis",
                "ensureEnd"
            ],
            // http://usejsdoc.org/tags-todo.html
            "todo": [
                "parseDescription"
            ],
            // http://usejsdoc.org/tags-typedef.html
            "typedef": [
                "parseType",
                "parseNamePathOptional"
            ],
            // http://usejsdoc.org/tags-variation.html
            "variation": [
                "parseVariation"
            ],
            // http://usejsdoc.org/tags-version.html
            "version": [
                "parseDescription"
            ]
        };
        TagParser.prototype.parse = function parse() {
            var i, iz, sequences, method;
            // empty title
            if (!this._title) {
                if (!this.addError("Missing or invalid title")) return null;
            }
            // Seek to content last index.
            this._last = seekContent(this._title);
            if (this._options.range) this._tag.range = [
                this._first,
                source.slice(0, this._last).replace(/\s*$/, "").length
            ].map(convertIndex);
            if (hasOwnProperty(Rules, this._title)) sequences = Rules[this._title];
            else // default sequences
            sequences = [
                "parseType",
                "parseName",
                "parseDescription",
                "epilogue"
            ];
            for(i = 0, iz = sequences.length; i < iz; ++i){
                method = sequences[i];
                if (!this[method]()) return null;
            }
            return this._tag;
        };
        function parseTag(options) {
            var title, parser, tag;
            // skip to tag
            if (!skipToTag()) return null;
            // scan title
            title = scanTitle();
            // construct tag parser
            parser = new TagParser(options, title);
            tag = parser.parse();
            // Seek global index to end of this tag.
            while(index < parser._last)advance();
            return tag;
        }
        //
        // Parse JSDoc
        //
        function scanJSDocDescription(preserveWhitespace) {
            var description = "", ch, atAllowed;
            atAllowed = true;
            while(index < length){
                ch = source.charCodeAt(index);
                if (atAllowed && ch === 0x40 /* '@' */ ) break;
                if (esutils.code.isLineTerminator(ch)) atAllowed = true;
                else if (atAllowed && !esutils.code.isWhiteSpace(ch)) atAllowed = false;
                description += advance();
            }
            return preserveWhitespace ? description : description.trim();
        }
        function parse(comment, options) {
            var tags = [], tag, description, interestingTags, i, iz;
            if (options === undefined) options = {};
            if (typeof options.unwrap === "boolean" && options.unwrap) source = unwrapComment(comment);
            else source = comment;
            originalSource = comment;
            // array of relevant tags
            if (options.tags) {
                if (Array.isArray(options.tags)) {
                    interestingTags = {};
                    for(i = 0, iz = options.tags.length; i < iz; i++)if (typeof options.tags[i] === "string") interestingTags[options.tags[i]] = true;
                    else utility.throwError('Invalid "tags" parameter: ' + options.tags);
                } else utility.throwError('Invalid "tags" parameter: ' + options.tags);
            }
            length = source.length;
            index = 0;
            lineNumber = 0;
            recoverable = options.recoverable;
            sloppy = options.sloppy;
            strict = options.strict;
            description = scanJSDocDescription(options.preserveWhitespace);
            while(true){
                tag = parseTag(options);
                if (!tag) break;
                if (!interestingTags || interestingTags.hasOwnProperty(tag.title)) tags.push(tag);
            }
            return {
                description: description,
                tags: tags
            };
        }
        exports1.parse = parse;
    })(jsdoc = {});
    exports.version = utility.VERSION;
    exports.parse = jsdoc.parse;
    exports.parseType = typed.parseType;
    exports.parseParamType = typed.parseParamType;
    exports.unwrapComment = unwrapComment;
    exports.Syntax = shallowCopy(typed.Syntax);
    exports.Error = utility.DoctrineError;
    exports.type = {
        Syntax: exports.Syntax,
        parseType: typed.parseType,
        parseParamType: typed.parseParamType,
        stringify: typed.stringify
    };
})(); /* vim: set sw=4 ts=4 et tw=80 : */ 

},{"38b45b045fff4a79":"d3HGx","6c0e771aae2f60f0":"40bpJ","30c3a19c63d2b475":"iCvRf"}],"d3HGx":[function(require,module,exports) {
/*
  Copyright (C) 2013 Yusuke Suzuki <utatane.tea@gmail.com>

  Redistribution and use in source and binary forms, with or without
  modification, are permitted provided that the following conditions are met:

    * Redistributions of source code must retain the above copyright
      notice, this list of conditions and the following disclaimer.
    * Redistributions in binary form must reproduce the above copyright
      notice, this list of conditions and the following disclaimer in the
      documentation and/or other materials provided with the distribution.

  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
  AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
  IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
  ARE DISCLAIMED. IN NO EVENT SHALL <COPYRIGHT HOLDER> BE LIABLE FOR ANY
  DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
  (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
  LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
  ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
  (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF
  THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/ (function() {
    "use strict";
    exports.ast = require("635e464a0faa52f6");
    exports.code = require("ab412758b0cb3565");
    exports.keyword = require("c0f7d4d834ba5d0c");
})(); /* vim: set sw=4 ts=4 et tw=80 : */ 

},{"635e464a0faa52f6":"4Gitz","ab412758b0cb3565":"jwnLN","c0f7d4d834ba5d0c":"epyNb"}],"4Gitz":[function(require,module,exports) {
/*
  Copyright (C) 2013 Yusuke Suzuki <utatane.tea@gmail.com>

  Redistribution and use in source and binary forms, with or without
  modification, are permitted provided that the following conditions are met:

    * Redistributions of source code must retain the above copyright
      notice, this list of conditions and the following disclaimer.
    * Redistributions in binary form must reproduce the above copyright
      notice, this list of conditions and the following disclaimer in the
      documentation and/or other materials provided with the distribution.

  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS 'AS IS'
  AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
  IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
  ARE DISCLAIMED. IN NO EVENT SHALL <COPYRIGHT HOLDER> BE LIABLE FOR ANY
  DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
  (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
  LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
  ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
  (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF
  THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/ (function() {
    "use strict";
    function isExpression(node) {
        if (node == null) return false;
        switch(node.type){
            case "ArrayExpression":
            case "AssignmentExpression":
            case "BinaryExpression":
            case "CallExpression":
            case "ConditionalExpression":
            case "FunctionExpression":
            case "Identifier":
            case "Literal":
            case "LogicalExpression":
            case "MemberExpression":
            case "NewExpression":
            case "ObjectExpression":
            case "SequenceExpression":
            case "ThisExpression":
            case "UnaryExpression":
            case "UpdateExpression":
                return true;
        }
        return false;
    }
    function isIterationStatement(node) {
        if (node == null) return false;
        switch(node.type){
            case "DoWhileStatement":
            case "ForInStatement":
            case "ForStatement":
            case "WhileStatement":
                return true;
        }
        return false;
    }
    function isStatement(node) {
        if (node == null) return false;
        switch(node.type){
            case "BlockStatement":
            case "BreakStatement":
            case "ContinueStatement":
            case "DebuggerStatement":
            case "DoWhileStatement":
            case "EmptyStatement":
            case "ExpressionStatement":
            case "ForInStatement":
            case "ForStatement":
            case "IfStatement":
            case "LabeledStatement":
            case "ReturnStatement":
            case "SwitchStatement":
            case "ThrowStatement":
            case "TryStatement":
            case "VariableDeclaration":
            case "WhileStatement":
            case "WithStatement":
                return true;
        }
        return false;
    }
    function isSourceElement(node) {
        return isStatement(node) || node != null && node.type === "FunctionDeclaration";
    }
    function trailingStatement(node) {
        switch(node.type){
            case "IfStatement":
                if (node.alternate != null) return node.alternate;
                return node.consequent;
            case "LabeledStatement":
            case "ForStatement":
            case "ForInStatement":
            case "WhileStatement":
            case "WithStatement":
                return node.body;
        }
        return null;
    }
    function isProblematicIfStatement(node) {
        var current;
        if (node.type !== "IfStatement") return false;
        if (node.alternate == null) return false;
        current = node.consequent;
        do {
            if (current.type === "IfStatement") {
                if (current.alternate == null) return true;
            }
            current = trailingStatement(current);
        }while (current);
        return false;
    }
    module.exports = {
        isExpression: isExpression,
        isStatement: isStatement,
        isIterationStatement: isIterationStatement,
        isSourceElement: isSourceElement,
        isProblematicIfStatement: isProblematicIfStatement,
        trailingStatement: trailingStatement
    };
})(); /* vim: set sw=4 ts=4 et tw=80 : */ 

},{}],"jwnLN":[function(require,module,exports) {
/*
  Copyright (C) 2013-2014 Yusuke Suzuki <utatane.tea@gmail.com>
  Copyright (C) 2014 Ivan Nikulin <ifaaan@gmail.com>

  Redistribution and use in source and binary forms, with or without
  modification, are permitted provided that the following conditions are met:

    * Redistributions of source code must retain the above copyright
      notice, this list of conditions and the following disclaimer.
    * Redistributions in binary form must reproduce the above copyright
      notice, this list of conditions and the following disclaimer in the
      documentation and/or other materials provided with the distribution.

  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
  AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
  IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
  ARE DISCLAIMED. IN NO EVENT SHALL <COPYRIGHT HOLDER> BE LIABLE FOR ANY
  DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
  (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
  LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
  ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
  (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF
  THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/ (function() {
    "use strict";
    var ES6Regex, ES5Regex, NON_ASCII_WHITESPACES, IDENTIFIER_START, IDENTIFIER_PART, ch;
    // See `tools/generate-identifier-regex.js`.
    ES5Regex = {
        // ECMAScript 5.1/Unicode v9.0.0 NonAsciiIdentifierStart:
        NonAsciiIdentifierStart: /[\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0-\u08B4\u08B6-\u08BD\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C88\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005-\u3007\u3021-\u3029\u3031-\u3035\u3038-\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FD5\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6EF\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AE\uA7B0-\uA7B7\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]/,
        // ECMAScript 5.1/Unicode v9.0.0 NonAsciiIdentifierPart:
        NonAsciiIdentifierPart: /[\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0300-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u0483-\u0487\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u05D0-\u05EA\u05F0-\u05F2\u0610-\u061A\u0620-\u0669\u066E-\u06D3\u06D5-\u06DC\u06DF-\u06E8\u06EA-\u06FC\u06FF\u0710-\u074A\u074D-\u07B1\u07C0-\u07F5\u07FA\u0800-\u082D\u0840-\u085B\u08A0-\u08B4\u08B6-\u08BD\u08D4-\u08E1\u08E3-\u0963\u0966-\u096F\u0971-\u0983\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BC-\u09C4\u09C7\u09C8\u09CB-\u09CE\u09D7\u09DC\u09DD\u09DF-\u09E3\u09E6-\u09F1\u0A01-\u0A03\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A3C\u0A3E-\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A59-\u0A5C\u0A5E\u0A66-\u0A75\u0A81-\u0A83\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABC-\u0AC5\u0AC7-\u0AC9\u0ACB-\u0ACD\u0AD0\u0AE0-\u0AE3\u0AE6-\u0AEF\u0AF9\u0B01-\u0B03\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3C-\u0B44\u0B47\u0B48\u0B4B-\u0B4D\u0B56\u0B57\u0B5C\u0B5D\u0B5F-\u0B63\u0B66-\u0B6F\u0B71\u0B82\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BBE-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCD\u0BD0\u0BD7\u0BE6-\u0BEF\u0C00-\u0C03\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D-\u0C44\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C58-\u0C5A\u0C60-\u0C63\u0C66-\u0C6F\u0C80-\u0C83\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBC-\u0CC4\u0CC6-\u0CC8\u0CCA-\u0CCD\u0CD5\u0CD6\u0CDE\u0CE0-\u0CE3\u0CE6-\u0CEF\u0CF1\u0CF2\u0D01-\u0D03\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D-\u0D44\u0D46-\u0D48\u0D4A-\u0D4E\u0D54-\u0D57\u0D5F-\u0D63\u0D66-\u0D6F\u0D7A-\u0D7F\u0D82\u0D83\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0DCA\u0DCF-\u0DD4\u0DD6\u0DD8-\u0DDF\u0DE6-\u0DEF\u0DF2\u0DF3\u0E01-\u0E3A\u0E40-\u0E4E\u0E50-\u0E59\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB9\u0EBB-\u0EBD\u0EC0-\u0EC4\u0EC6\u0EC8-\u0ECD\u0ED0-\u0ED9\u0EDC-\u0EDF\u0F00\u0F18\u0F19\u0F20-\u0F29\u0F35\u0F37\u0F39\u0F3E-\u0F47\u0F49-\u0F6C\u0F71-\u0F84\u0F86-\u0F97\u0F99-\u0FBC\u0FC6\u1000-\u1049\u1050-\u109D\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u135D-\u135F\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u170C\u170E-\u1714\u1720-\u1734\u1740-\u1753\u1760-\u176C\u176E-\u1770\u1772\u1773\u1780-\u17D3\u17D7\u17DC\u17DD\u17E0-\u17E9\u180B-\u180D\u1810-\u1819\u1820-\u1877\u1880-\u18AA\u18B0-\u18F5\u1900-\u191E\u1920-\u192B\u1930-\u193B\u1946-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u19D0-\u19D9\u1A00-\u1A1B\u1A20-\u1A5E\u1A60-\u1A7C\u1A7F-\u1A89\u1A90-\u1A99\u1AA7\u1AB0-\u1ABD\u1B00-\u1B4B\u1B50-\u1B59\u1B6B-\u1B73\u1B80-\u1BF3\u1C00-\u1C37\u1C40-\u1C49\u1C4D-\u1C7D\u1C80-\u1C88\u1CD0-\u1CD2\u1CD4-\u1CF6\u1CF8\u1CF9\u1D00-\u1DF5\u1DFB-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u200C\u200D\u203F\u2040\u2054\u2071\u207F\u2090-\u209C\u20D0-\u20DC\u20E1\u20E5-\u20F0\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D7F-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2DE0-\u2DFF\u2E2F\u3005-\u3007\u3021-\u302F\u3031-\u3035\u3038-\u303C\u3041-\u3096\u3099\u309A\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FD5\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA62B\uA640-\uA66F\uA674-\uA67D\uA67F-\uA6F1\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AE\uA7B0-\uA7B7\uA7F7-\uA827\uA840-\uA873\uA880-\uA8C5\uA8D0-\uA8D9\uA8E0-\uA8F7\uA8FB\uA8FD\uA900-\uA92D\uA930-\uA953\uA960-\uA97C\uA980-\uA9C0\uA9CF-\uA9D9\uA9E0-\uA9FE\uAA00-\uAA36\uAA40-\uAA4D\uAA50-\uAA59\uAA60-\uAA76\uAA7A-\uAAC2\uAADB-\uAADD\uAAE0-\uAAEF\uAAF2-\uAAF6\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABEA\uABEC\uABED\uABF0-\uABF9\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE00-\uFE0F\uFE20-\uFE2F\uFE33\uFE34\uFE4D-\uFE4F\uFE70-\uFE74\uFE76-\uFEFC\uFF10-\uFF19\uFF21-\uFF3A\uFF3F\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]/
    };
    ES6Regex = {
        // ECMAScript 6/Unicode v9.0.0 NonAsciiIdentifierStart:
        NonAsciiIdentifierStart: /[\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0-\u08B4\u08B6-\u08BD\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C88\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2118-\u211D\u2124\u2126\u2128\u212A-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u3005-\u3007\u3021-\u3029\u3031-\u3035\u3038-\u303C\u3041-\u3096\u309B-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FD5\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6EF\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AE\uA7B0-\uA7B7\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDD40-\uDD74\uDE80-\uDE9C\uDEA0-\uDED0\uDF00-\uDF1F\uDF30-\uDF4A\uDF50-\uDF75\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF\uDFD1-\uDFD5]|\uD801[\uDC00-\uDC9D\uDCB0-\uDCD3\uDCD8-\uDCFB\uDD00-\uDD27\uDD30-\uDD63\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00\uDE10-\uDE13\uDE15-\uDE17\uDE19-\uDE33\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE4\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2]|\uD804[\uDC03-\uDC37\uDC83-\uDCAF\uDCD0-\uDCE8\uDD03-\uDD26\uDD50-\uDD72\uDD76\uDD83-\uDDB2\uDDC1-\uDDC4\uDDDA\uDDDC\uDE00-\uDE11\uDE13-\uDE2B\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEDE\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3D\uDF50\uDF5D-\uDF61]|\uD805[\uDC00-\uDC34\uDC47-\uDC4A\uDC80-\uDCAF\uDCC4\uDCC5\uDCC7\uDD80-\uDDAE\uDDD8-\uDDDB\uDE00-\uDE2F\uDE44\uDE80-\uDEAA\uDF00-\uDF19]|\uD806[\uDCA0-\uDCDF\uDCFF\uDEC0-\uDEF8]|\uD807[\uDC00-\uDC08\uDC0A-\uDC2E\uDC40\uDC72-\uDC8F]|\uD808[\uDC00-\uDF99]|\uD809[\uDC00-\uDC6E\uDC80-\uDD43]|[\uD80C\uD81C-\uD820\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2E]|\uD811[\uDC00-\uDE46]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDED0-\uDEED\uDF00-\uDF2F\uDF40-\uDF43\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDF00-\uDF44\uDF50\uDF93-\uDF9F\uDFE0]|\uD821[\uDC00-\uDFEC]|\uD822[\uDC00-\uDEF2]|\uD82C[\uDC00\uDC01]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB]|\uD83A[\uDC00-\uDCC4\uDD00-\uDD43]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD869[\uDC00-\uDED6\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF34\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1]|\uD87E[\uDC00-\uDE1D]/,
        // ECMAScript 6/Unicode v9.0.0 NonAsciiIdentifierPart:
        NonAsciiIdentifierPart: /[\xAA\xB5\xB7\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0300-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u0483-\u0487\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u05D0-\u05EA\u05F0-\u05F2\u0610-\u061A\u0620-\u0669\u066E-\u06D3\u06D5-\u06DC\u06DF-\u06E8\u06EA-\u06FC\u06FF\u0710-\u074A\u074D-\u07B1\u07C0-\u07F5\u07FA\u0800-\u082D\u0840-\u085B\u08A0-\u08B4\u08B6-\u08BD\u08D4-\u08E1\u08E3-\u0963\u0966-\u096F\u0971-\u0983\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BC-\u09C4\u09C7\u09C8\u09CB-\u09CE\u09D7\u09DC\u09DD\u09DF-\u09E3\u09E6-\u09F1\u0A01-\u0A03\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A3C\u0A3E-\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A59-\u0A5C\u0A5E\u0A66-\u0A75\u0A81-\u0A83\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABC-\u0AC5\u0AC7-\u0AC9\u0ACB-\u0ACD\u0AD0\u0AE0-\u0AE3\u0AE6-\u0AEF\u0AF9\u0B01-\u0B03\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3C-\u0B44\u0B47\u0B48\u0B4B-\u0B4D\u0B56\u0B57\u0B5C\u0B5D\u0B5F-\u0B63\u0B66-\u0B6F\u0B71\u0B82\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BBE-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCD\u0BD0\u0BD7\u0BE6-\u0BEF\u0C00-\u0C03\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D-\u0C44\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C58-\u0C5A\u0C60-\u0C63\u0C66-\u0C6F\u0C80-\u0C83\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBC-\u0CC4\u0CC6-\u0CC8\u0CCA-\u0CCD\u0CD5\u0CD6\u0CDE\u0CE0-\u0CE3\u0CE6-\u0CEF\u0CF1\u0CF2\u0D01-\u0D03\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D-\u0D44\u0D46-\u0D48\u0D4A-\u0D4E\u0D54-\u0D57\u0D5F-\u0D63\u0D66-\u0D6F\u0D7A-\u0D7F\u0D82\u0D83\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0DCA\u0DCF-\u0DD4\u0DD6\u0DD8-\u0DDF\u0DE6-\u0DEF\u0DF2\u0DF3\u0E01-\u0E3A\u0E40-\u0E4E\u0E50-\u0E59\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB9\u0EBB-\u0EBD\u0EC0-\u0EC4\u0EC6\u0EC8-\u0ECD\u0ED0-\u0ED9\u0EDC-\u0EDF\u0F00\u0F18\u0F19\u0F20-\u0F29\u0F35\u0F37\u0F39\u0F3E-\u0F47\u0F49-\u0F6C\u0F71-\u0F84\u0F86-\u0F97\u0F99-\u0FBC\u0FC6\u1000-\u1049\u1050-\u109D\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u135D-\u135F\u1369-\u1371\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u170C\u170E-\u1714\u1720-\u1734\u1740-\u1753\u1760-\u176C\u176E-\u1770\u1772\u1773\u1780-\u17D3\u17D7\u17DC\u17DD\u17E0-\u17E9\u180B-\u180D\u1810-\u1819\u1820-\u1877\u1880-\u18AA\u18B0-\u18F5\u1900-\u191E\u1920-\u192B\u1930-\u193B\u1946-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u19D0-\u19DA\u1A00-\u1A1B\u1A20-\u1A5E\u1A60-\u1A7C\u1A7F-\u1A89\u1A90-\u1A99\u1AA7\u1AB0-\u1ABD\u1B00-\u1B4B\u1B50-\u1B59\u1B6B-\u1B73\u1B80-\u1BF3\u1C00-\u1C37\u1C40-\u1C49\u1C4D-\u1C7D\u1C80-\u1C88\u1CD0-\u1CD2\u1CD4-\u1CF6\u1CF8\u1CF9\u1D00-\u1DF5\u1DFB-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u200C\u200D\u203F\u2040\u2054\u2071\u207F\u2090-\u209C\u20D0-\u20DC\u20E1\u20E5-\u20F0\u2102\u2107\u210A-\u2113\u2115\u2118-\u211D\u2124\u2126\u2128\u212A-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D7F-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2DE0-\u2DFF\u3005-\u3007\u3021-\u302F\u3031-\u3035\u3038-\u303C\u3041-\u3096\u3099-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FD5\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA62B\uA640-\uA66F\uA674-\uA67D\uA67F-\uA6F1\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AE\uA7B0-\uA7B7\uA7F7-\uA827\uA840-\uA873\uA880-\uA8C5\uA8D0-\uA8D9\uA8E0-\uA8F7\uA8FB\uA8FD\uA900-\uA92D\uA930-\uA953\uA960-\uA97C\uA980-\uA9C0\uA9CF-\uA9D9\uA9E0-\uA9FE\uAA00-\uAA36\uAA40-\uAA4D\uAA50-\uAA59\uAA60-\uAA76\uAA7A-\uAAC2\uAADB-\uAADD\uAAE0-\uAAEF\uAAF2-\uAAF6\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABEA\uABEC\uABED\uABF0-\uABF9\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE00-\uFE0F\uFE20-\uFE2F\uFE33\uFE34\uFE4D-\uFE4F\uFE70-\uFE74\uFE76-\uFEFC\uFF10-\uFF19\uFF21-\uFF3A\uFF3F\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDD40-\uDD74\uDDFD\uDE80-\uDE9C\uDEA0-\uDED0\uDEE0\uDF00-\uDF1F\uDF30-\uDF4A\uDF50-\uDF7A\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF\uDFD1-\uDFD5]|\uD801[\uDC00-\uDC9D\uDCA0-\uDCA9\uDCB0-\uDCD3\uDCD8-\uDCFB\uDD00-\uDD27\uDD30-\uDD63\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00-\uDE03\uDE05\uDE06\uDE0C-\uDE13\uDE15-\uDE17\uDE19-\uDE33\uDE38-\uDE3A\uDE3F\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE6\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2]|\uD804[\uDC00-\uDC46\uDC66-\uDC6F\uDC7F-\uDCBA\uDCD0-\uDCE8\uDCF0-\uDCF9\uDD00-\uDD34\uDD36-\uDD3F\uDD50-\uDD73\uDD76\uDD80-\uDDC4\uDDCA-\uDDCC\uDDD0-\uDDDA\uDDDC\uDE00-\uDE11\uDE13-\uDE37\uDE3E\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEEA\uDEF0-\uDEF9\uDF00-\uDF03\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3C-\uDF44\uDF47\uDF48\uDF4B-\uDF4D\uDF50\uDF57\uDF5D-\uDF63\uDF66-\uDF6C\uDF70-\uDF74]|\uD805[\uDC00-\uDC4A\uDC50-\uDC59\uDC80-\uDCC5\uDCC7\uDCD0-\uDCD9\uDD80-\uDDB5\uDDB8-\uDDC0\uDDD8-\uDDDD\uDE00-\uDE40\uDE44\uDE50-\uDE59\uDE80-\uDEB7\uDEC0-\uDEC9\uDF00-\uDF19\uDF1D-\uDF2B\uDF30-\uDF39]|\uD806[\uDCA0-\uDCE9\uDCFF\uDEC0-\uDEF8]|\uD807[\uDC00-\uDC08\uDC0A-\uDC36\uDC38-\uDC40\uDC50-\uDC59\uDC72-\uDC8F\uDC92-\uDCA7\uDCA9-\uDCB6]|\uD808[\uDC00-\uDF99]|\uD809[\uDC00-\uDC6E\uDC80-\uDD43]|[\uD80C\uD81C-\uD820\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2E]|\uD811[\uDC00-\uDE46]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDE60-\uDE69\uDED0-\uDEED\uDEF0-\uDEF4\uDF00-\uDF36\uDF40-\uDF43\uDF50-\uDF59\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDF00-\uDF44\uDF50-\uDF7E\uDF8F-\uDF9F\uDFE0]|\uD821[\uDC00-\uDFEC]|\uD822[\uDC00-\uDEF2]|\uD82C[\uDC00\uDC01]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99\uDC9D\uDC9E]|\uD834[\uDD65-\uDD69\uDD6D-\uDD72\uDD7B-\uDD82\uDD85-\uDD8B\uDDAA-\uDDAD\uDE42-\uDE44]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB\uDFCE-\uDFFF]|\uD836[\uDE00-\uDE36\uDE3B-\uDE6C\uDE75\uDE84\uDE9B-\uDE9F\uDEA1-\uDEAF]|\uD838[\uDC00-\uDC06\uDC08-\uDC18\uDC1B-\uDC21\uDC23\uDC24\uDC26-\uDC2A]|\uD83A[\uDC00-\uDCC4\uDCD0-\uDCD6\uDD00-\uDD4A\uDD50-\uDD59]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD869[\uDC00-\uDED6\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF34\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1]|\uD87E[\uDC00-\uDE1D]|\uDB40[\uDD00-\uDDEF]/
    };
    function isDecimalDigit(ch) {
        return 0x30 <= ch && ch <= 0x39; // 0..9
    }
    function isHexDigit(ch) {
        return 0x30 <= ch && ch <= 0x39 || // 0..9
        0x61 <= ch && ch <= 0x66 || // a..f
        0x41 <= ch && ch <= 0x46; // A..F
    }
    function isOctalDigit(ch) {
        return ch >= 0x30 && ch <= 0x37; // 0..7
    }
    // 7.2 White Space
    NON_ASCII_WHITESPACES = [
        0x1680,
        0x2000,
        0x2001,
        0x2002,
        0x2003,
        0x2004,
        0x2005,
        0x2006,
        0x2007,
        0x2008,
        0x2009,
        0x200A,
        0x202F,
        0x205F,
        0x3000,
        0xFEFF
    ];
    function isWhiteSpace(ch) {
        return ch === 0x20 || ch === 0x09 || ch === 0x0B || ch === 0x0C || ch === 0xA0 || ch >= 0x1680 && NON_ASCII_WHITESPACES.indexOf(ch) >= 0;
    }
    // 7.3 Line Terminators
    function isLineTerminator(ch) {
        return ch === 0x0A || ch === 0x0D || ch === 0x2028 || ch === 0x2029;
    }
    // 7.6 Identifier Names and Identifiers
    function fromCodePoint(cp) {
        if (cp <= 0xFFFF) return String.fromCharCode(cp);
        var cu1 = String.fromCharCode(Math.floor((cp - 0x10000) / 0x400) + 0xD800);
        var cu2 = String.fromCharCode((cp - 0x10000) % 0x400 + 0xDC00);
        return cu1 + cu2;
    }
    IDENTIFIER_START = new Array(0x80);
    for(ch = 0; ch < 0x80; ++ch)IDENTIFIER_START[ch] = ch >= 0x61 && ch <= 0x7A || // a..z
    ch >= 0x41 && ch <= 0x5A || // A..Z
    ch === 0x24 || ch === 0x5F; // $ (dollar) and _ (underscore)
    IDENTIFIER_PART = new Array(0x80);
    for(ch = 0; ch < 0x80; ++ch)IDENTIFIER_PART[ch] = ch >= 0x61 && ch <= 0x7A || // a..z
    ch >= 0x41 && ch <= 0x5A || // A..Z
    ch >= 0x30 && ch <= 0x39 || // 0..9
    ch === 0x24 || ch === 0x5F; // $ (dollar) and _ (underscore)
    function isIdentifierStartES5(ch) {
        return ch < 0x80 ? IDENTIFIER_START[ch] : ES5Regex.NonAsciiIdentifierStart.test(fromCodePoint(ch));
    }
    function isIdentifierPartES5(ch) {
        return ch < 0x80 ? IDENTIFIER_PART[ch] : ES5Regex.NonAsciiIdentifierPart.test(fromCodePoint(ch));
    }
    function isIdentifierStartES6(ch) {
        return ch < 0x80 ? IDENTIFIER_START[ch] : ES6Regex.NonAsciiIdentifierStart.test(fromCodePoint(ch));
    }
    function isIdentifierPartES6(ch) {
        return ch < 0x80 ? IDENTIFIER_PART[ch] : ES6Regex.NonAsciiIdentifierPart.test(fromCodePoint(ch));
    }
    module.exports = {
        isDecimalDigit: isDecimalDigit,
        isHexDigit: isHexDigit,
        isOctalDigit: isOctalDigit,
        isWhiteSpace: isWhiteSpace,
        isLineTerminator: isLineTerminator,
        isIdentifierStartES5: isIdentifierStartES5,
        isIdentifierPartES5: isIdentifierPartES5,
        isIdentifierStartES6: isIdentifierStartES6,
        isIdentifierPartES6: isIdentifierPartES6
    };
})(); /* vim: set sw=4 ts=4 et tw=80 : */ 

},{}],"epyNb":[function(require,module,exports) {
/*
  Copyright (C) 2013 Yusuke Suzuki <utatane.tea@gmail.com>

  Redistribution and use in source and binary forms, with or without
  modification, are permitted provided that the following conditions are met:

    * Redistributions of source code must retain the above copyright
      notice, this list of conditions and the following disclaimer.
    * Redistributions in binary form must reproduce the above copyright
      notice, this list of conditions and the following disclaimer in the
      documentation and/or other materials provided with the distribution.

  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
  AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
  IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
  ARE DISCLAIMED. IN NO EVENT SHALL <COPYRIGHT HOLDER> BE LIABLE FOR ANY
  DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
  (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
  LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
  ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
  (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF
  THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/ (function() {
    "use strict";
    var code = require("b9157deceabd4e7");
    function isStrictModeReservedWordES6(id) {
        switch(id){
            case "implements":
            case "interface":
            case "package":
            case "private":
            case "protected":
            case "public":
            case "static":
            case "let":
                return true;
            default:
                return false;
        }
    }
    function isKeywordES5(id, strict) {
        // yield should not be treated as keyword under non-strict mode.
        if (!strict && id === "yield") return false;
        return isKeywordES6(id, strict);
    }
    function isKeywordES6(id, strict) {
        if (strict && isStrictModeReservedWordES6(id)) return true;
        switch(id.length){
            case 2:
                return id === "if" || id === "in" || id === "do";
            case 3:
                return id === "var" || id === "for" || id === "new" || id === "try";
            case 4:
                return id === "this" || id === "else" || id === "case" || id === "void" || id === "with" || id === "enum";
            case 5:
                return id === "while" || id === "break" || id === "catch" || id === "throw" || id === "const" || id === "yield" || id === "class" || id === "super";
            case 6:
                return id === "return" || id === "typeof" || id === "delete" || id === "switch" || id === "export" || id === "import";
            case 7:
                return id === "default" || id === "finally" || id === "extends";
            case 8:
                return id === "function" || id === "continue" || id === "debugger";
            case 10:
                return id === "instanceof";
            default:
                return false;
        }
    }
    function isReservedWordES5(id, strict) {
        return id === "null" || id === "true" || id === "false" || isKeywordES5(id, strict);
    }
    function isReservedWordES6(id, strict) {
        return id === "null" || id === "true" || id === "false" || isKeywordES6(id, strict);
    }
    function isRestrictedWord(id) {
        return id === "eval" || id === "arguments";
    }
    function isIdentifierNameES5(id) {
        var i, iz, ch;
        if (id.length === 0) return false;
        ch = id.charCodeAt(0);
        if (!code.isIdentifierStartES5(ch)) return false;
        for(i = 1, iz = id.length; i < iz; ++i){
            ch = id.charCodeAt(i);
            if (!code.isIdentifierPartES5(ch)) return false;
        }
        return true;
    }
    function decodeUtf16(lead, trail) {
        return (lead - 0xD800) * 0x400 + (trail - 0xDC00) + 0x10000;
    }
    function isIdentifierNameES6(id) {
        var i, iz, ch, lowCh, check;
        if (id.length === 0) return false;
        check = code.isIdentifierStartES6;
        for(i = 0, iz = id.length; i < iz; ++i){
            ch = id.charCodeAt(i);
            if (0xD800 <= ch && ch <= 0xDBFF) {
                ++i;
                if (i >= iz) return false;
                lowCh = id.charCodeAt(i);
                if (!(0xDC00 <= lowCh && lowCh <= 0xDFFF)) return false;
                ch = decodeUtf16(ch, lowCh);
            }
            if (!check(ch)) return false;
            check = code.isIdentifierPartES6;
        }
        return true;
    }
    function isIdentifierES5(id, strict) {
        return isIdentifierNameES5(id) && !isReservedWordES5(id, strict);
    }
    function isIdentifierES6(id, strict) {
        return isIdentifierNameES6(id) && !isReservedWordES6(id, strict);
    }
    module.exports = {
        isKeywordES5: isKeywordES5,
        isKeywordES6: isKeywordES6,
        isReservedWordES5: isReservedWordES5,
        isReservedWordES6: isReservedWordES6,
        isRestrictedWord: isRestrictedWord,
        isIdentifierNameES5: isIdentifierNameES5,
        isIdentifierNameES6: isIdentifierNameES6,
        isIdentifierES5: isIdentifierES5,
        isIdentifierES6: isIdentifierES6
    };
})(); /* vim: set sw=4 ts=4 et tw=80 : */ 

},{"b9157deceabd4e7":"jwnLN"}],"40bpJ":[function(require,module,exports) {
/*
 * @fileoverview Type expression parser.
 * @author Yusuke Suzuki <utatane.tea@gmail.com>
 * @author Dan Tao <daniel.tao@gmail.com>
 * @author Andrew Eisenberg <andrew@eisenberg.as>
 */ // "typed", the Type Expression Parser for doctrine.
(function() {
    "use strict";
    var Syntax, Token, source, length, index, previous, token, value, esutils, utility, rangeOffset, addRange;
    esutils = require("c04884917b8d1fb9");
    utility = require("84fdd378a161f8fd");
    Syntax = {
        NullableLiteral: "NullableLiteral",
        AllLiteral: "AllLiteral",
        NullLiteral: "NullLiteral",
        UndefinedLiteral: "UndefinedLiteral",
        VoidLiteral: "VoidLiteral",
        UnionType: "UnionType",
        ArrayType: "ArrayType",
        RecordType: "RecordType",
        FieldType: "FieldType",
        FunctionType: "FunctionType",
        ParameterType: "ParameterType",
        RestType: "RestType",
        NonNullableType: "NonNullableType",
        OptionalType: "OptionalType",
        NullableType: "NullableType",
        NameExpression: "NameExpression",
        TypeApplication: "TypeApplication",
        StringLiteralType: "StringLiteralType",
        NumericLiteralType: "NumericLiteralType",
        BooleanLiteralType: "BooleanLiteralType"
    };
    Token = {
        ILLEGAL: 0,
        DOT_LT: 1,
        REST: 2,
        LT: 3,
        GT: 4,
        LPAREN: 5,
        RPAREN: 6,
        LBRACE: 7,
        RBRACE: 8,
        LBRACK: 9,
        RBRACK: 10,
        COMMA: 11,
        COLON: 12,
        STAR: 13,
        PIPE: 14,
        QUESTION: 15,
        BANG: 16,
        EQUAL: 17,
        NAME: 18,
        STRING: 19,
        NUMBER: 20,
        EOF: 21
    };
    function isTypeName(ch) {
        return "><(){}[],:*|?!=".indexOf(String.fromCharCode(ch)) === -1 && !esutils.code.isWhiteSpace(ch) && !esutils.code.isLineTerminator(ch);
    }
    function Context(previous, index, token, value) {
        this._previous = previous;
        this._index = index;
        this._token = token;
        this._value = value;
    }
    Context.prototype.restore = function() {
        previous = this._previous;
        index = this._index;
        token = this._token;
        value = this._value;
    };
    Context.save = function() {
        return new Context(previous, index, token, value);
    };
    function maybeAddRange(node, range) {
        if (addRange) node.range = [
            range[0] + rangeOffset,
            range[1] + rangeOffset
        ];
        return node;
    }
    function advance() {
        var ch = source.charAt(index);
        index += 1;
        return ch;
    }
    function scanHexEscape(prefix) {
        var i, len, ch, code = 0;
        len = prefix === "u" ? 4 : 2;
        for(i = 0; i < len; ++i){
            if (index < length && esutils.code.isHexDigit(source.charCodeAt(index))) {
                ch = advance();
                code = code * 16 + "0123456789abcdef".indexOf(ch.toLowerCase());
            } else return "";
        }
        return String.fromCharCode(code);
    }
    function scanString() {
        var str = "", quote, ch, code, unescaped, restore; //TODO review removal octal = false
        quote = source.charAt(index);
        ++index;
        while(index < length){
            ch = advance();
            if (ch === quote) {
                quote = "";
                break;
            } else if (ch === "\\") {
                ch = advance();
                if (!esutils.code.isLineTerminator(ch.charCodeAt(0))) switch(ch){
                    case "n":
                        str += "\n";
                        break;
                    case "r":
                        str += "\r";
                        break;
                    case "t":
                        str += "	";
                        break;
                    case "u":
                    case "x":
                        restore = index;
                        unescaped = scanHexEscape(ch);
                        if (unescaped) str += unescaped;
                        else {
                            index = restore;
                            str += ch;
                        }
                        break;
                    case "b":
                        str += "\b";
                        break;
                    case "f":
                        str += "\f";
                        break;
                    case "v":
                        str += "\v";
                        break;
                    default:
                        if (esutils.code.isOctalDigit(ch.charCodeAt(0))) {
                            code = "01234567".indexOf(ch);
                            // \0 is not octal escape sequence
                            // Deprecating unused code. TODO review removal
                            //if (code !== 0) {
                            //    octal = true;
                            //}
                            if (index < length && esutils.code.isOctalDigit(source.charCodeAt(index))) {
                                //TODO Review Removal octal = true;
                                code = code * 8 + "01234567".indexOf(advance());
                                // 3 digits are only allowed when string starts
                                // with 0, 1, 2, 3
                                if ("0123".indexOf(ch) >= 0 && index < length && esutils.code.isOctalDigit(source.charCodeAt(index))) code = code * 8 + "01234567".indexOf(advance());
                            }
                            str += String.fromCharCode(code);
                        } else str += ch;
                        break;
                }
                else if (ch === "\r" && source.charCodeAt(index) === 0x0A /* '\n' */ ) ++index;
            } else if (esutils.code.isLineTerminator(ch.charCodeAt(0))) break;
            else str += ch;
        }
        if (quote !== "") utility.throwError("unexpected quote");
        value = str;
        return Token.STRING;
    }
    function scanNumber() {
        var number, ch;
        number = "";
        ch = source.charCodeAt(index);
        if (ch !== 0x2E /* '.' */ ) {
            number = advance();
            ch = source.charCodeAt(index);
            if (number === "0") {
                if (ch === 0x78 /* 'x' */  || ch === 0x58 /* 'X' */ ) {
                    number += advance();
                    while(index < length){
                        ch = source.charCodeAt(index);
                        if (!esutils.code.isHexDigit(ch)) break;
                        number += advance();
                    }
                    if (number.length <= 2) // only 0x
                    utility.throwError("unexpected token");
                    if (index < length) {
                        ch = source.charCodeAt(index);
                        if (esutils.code.isIdentifierStartES5(ch)) utility.throwError("unexpected token");
                    }
                    value = parseInt(number, 16);
                    return Token.NUMBER;
                }
                if (esutils.code.isOctalDigit(ch)) {
                    number += advance();
                    while(index < length){
                        ch = source.charCodeAt(index);
                        if (!esutils.code.isOctalDigit(ch)) break;
                        number += advance();
                    }
                    if (index < length) {
                        ch = source.charCodeAt(index);
                        if (esutils.code.isIdentifierStartES5(ch) || esutils.code.isDecimalDigit(ch)) utility.throwError("unexpected token");
                    }
                    value = parseInt(number, 8);
                    return Token.NUMBER;
                }
                if (esutils.code.isDecimalDigit(ch)) utility.throwError("unexpected token");
            }
            while(index < length){
                ch = source.charCodeAt(index);
                if (!esutils.code.isDecimalDigit(ch)) break;
                number += advance();
            }
        }
        if (ch === 0x2E /* '.' */ ) {
            number += advance();
            while(index < length){
                ch = source.charCodeAt(index);
                if (!esutils.code.isDecimalDigit(ch)) break;
                number += advance();
            }
        }
        if (ch === 0x65 /* 'e' */  || ch === 0x45 /* 'E' */ ) {
            number += advance();
            ch = source.charCodeAt(index);
            if (ch === 0x2B /* '+' */  || ch === 0x2D /* '-' */ ) number += advance();
            ch = source.charCodeAt(index);
            if (esutils.code.isDecimalDigit(ch)) {
                number += advance();
                while(index < length){
                    ch = source.charCodeAt(index);
                    if (!esutils.code.isDecimalDigit(ch)) break;
                    number += advance();
                }
            } else utility.throwError("unexpected token");
        }
        if (index < length) {
            ch = source.charCodeAt(index);
            if (esutils.code.isIdentifierStartES5(ch)) utility.throwError("unexpected token");
        }
        value = parseFloat(number);
        return Token.NUMBER;
    }
    function scanTypeName() {
        var ch, ch2;
        value = advance();
        while(index < length && isTypeName(source.charCodeAt(index))){
            ch = source.charCodeAt(index);
            if (ch === 0x2E /* '.' */ ) {
                if (index + 1 >= length) return Token.ILLEGAL;
                ch2 = source.charCodeAt(index + 1);
                if (ch2 === 0x3C /* '<' */ ) break;
            }
            value += advance();
        }
        return Token.NAME;
    }
    function next() {
        var ch;
        previous = index;
        while(index < length && esutils.code.isWhiteSpace(source.charCodeAt(index)))advance();
        if (index >= length) {
            token = Token.EOF;
            return token;
        }
        ch = source.charCodeAt(index);
        switch(ch){
            case 0x27:
            /* ''' */ case 0x22:
                /* '"' */ token = scanString();
                return token;
            case 0x3A:
                /* ':' */ advance();
                token = Token.COLON;
                return token;
            case 0x2C:
                /* ',' */ advance();
                token = Token.COMMA;
                return token;
            case 0x28:
                /* '(' */ advance();
                token = Token.LPAREN;
                return token;
            case 0x29:
                /* ')' */ advance();
                token = Token.RPAREN;
                return token;
            case 0x5B:
                /* '[' */ advance();
                token = Token.LBRACK;
                return token;
            case 0x5D:
                /* ']' */ advance();
                token = Token.RBRACK;
                return token;
            case 0x7B:
                /* '{' */ advance();
                token = Token.LBRACE;
                return token;
            case 0x7D:
                /* '}' */ advance();
                token = Token.RBRACE;
                return token;
            case 0x2E:
                /* '.' */ if (index + 1 < length) {
                    ch = source.charCodeAt(index + 1);
                    if (ch === 0x3C /* '<' */ ) {
                        advance(); // '.'
                        advance(); // '<'
                        token = Token.DOT_LT;
                        return token;
                    }
                    if (ch === 0x2E /* '.' */  && index + 2 < length && source.charCodeAt(index + 2) === 0x2E /* '.' */ ) {
                        advance(); // '.'
                        advance(); // '.'
                        advance(); // '.'
                        token = Token.REST;
                        return token;
                    }
                    if (esutils.code.isDecimalDigit(ch)) {
                        token = scanNumber();
                        return token;
                    }
                }
                token = Token.ILLEGAL;
                return token;
            case 0x3C:
                /* '<' */ advance();
                token = Token.LT;
                return token;
            case 0x3E:
                /* '>' */ advance();
                token = Token.GT;
                return token;
            case 0x2A:
                /* '*' */ advance();
                token = Token.STAR;
                return token;
            case 0x7C:
                /* '|' */ advance();
                token = Token.PIPE;
                return token;
            case 0x3F:
                /* '?' */ advance();
                token = Token.QUESTION;
                return token;
            case 0x21:
                /* '!' */ advance();
                token = Token.BANG;
                return token;
            case 0x3D:
                /* '=' */ advance();
                token = Token.EQUAL;
                return token;
            case 0x2D:
                /* '-' */ token = scanNumber();
                return token;
            default:
                if (esutils.code.isDecimalDigit(ch)) {
                    token = scanNumber();
                    return token;
                }
                // type string permits following case,
                //
                // namespace.module.MyClass
                //
                // this reduced 1 token TK_NAME
                utility.assert(isTypeName(ch));
                token = scanTypeName();
                return token;
        }
    }
    function consume(target, text) {
        utility.assert(token === target, text || "consumed token not matched");
        next();
    }
    function expect(target, message) {
        if (token !== target) utility.throwError(message || "unexpected token");
        next();
    }
    // UnionType := '(' TypeUnionList ')'
    //
    // TypeUnionList :=
    //     <<empty>>
    //   | NonemptyTypeUnionList
    //
    // NonemptyTypeUnionList :=
    //     TypeExpression
    //   | TypeExpression '|' NonemptyTypeUnionList
    function parseUnionType() {
        var elements, startIndex = index - 1;
        consume(Token.LPAREN, "UnionType should start with (");
        elements = [];
        if (token !== Token.RPAREN) while(true){
            elements.push(parseTypeExpression());
            if (token === Token.RPAREN) break;
            expect(Token.PIPE);
        }
        consume(Token.RPAREN, "UnionType should end with )");
        return maybeAddRange({
            type: Syntax.UnionType,
            elements: elements
        }, [
            startIndex,
            previous
        ]);
    }
    // ArrayType := '[' ElementTypeList ']'
    //
    // ElementTypeList :=
    //     <<empty>>
    //  | TypeExpression
    //  | '...' TypeExpression
    //  | TypeExpression ',' ElementTypeList
    function parseArrayType() {
        var elements, startIndex = index - 1, restStartIndex;
        consume(Token.LBRACK, "ArrayType should start with [");
        elements = [];
        while(token !== Token.RBRACK){
            if (token === Token.REST) {
                restStartIndex = index - 3;
                consume(Token.REST);
                elements.push(maybeAddRange({
                    type: Syntax.RestType,
                    expression: parseTypeExpression()
                }, [
                    restStartIndex,
                    previous
                ]));
                break;
            } else elements.push(parseTypeExpression());
            if (token !== Token.RBRACK) expect(Token.COMMA);
        }
        expect(Token.RBRACK);
        return maybeAddRange({
            type: Syntax.ArrayType,
            elements: elements
        }, [
            startIndex,
            previous
        ]);
    }
    function parseFieldName() {
        var v = value;
        if (token === Token.NAME || token === Token.STRING) {
            next();
            return v;
        }
        if (token === Token.NUMBER) {
            consume(Token.NUMBER);
            return String(v);
        }
        utility.throwError("unexpected token");
    }
    // FieldType :=
    //     FieldName
    //   | FieldName ':' TypeExpression
    //
    // FieldName :=
    //     NameExpression
    //   | StringLiteral
    //   | NumberLiteral
    //   | ReservedIdentifier
    function parseFieldType() {
        var key, rangeStart = previous;
        key = parseFieldName();
        if (token === Token.COLON) {
            consume(Token.COLON);
            return maybeAddRange({
                type: Syntax.FieldType,
                key: key,
                value: parseTypeExpression()
            }, [
                rangeStart,
                previous
            ]);
        }
        return maybeAddRange({
            type: Syntax.FieldType,
            key: key,
            value: null
        }, [
            rangeStart,
            previous
        ]);
    }
    // RecordType := '{' FieldTypeList '}'
    //
    // FieldTypeList :=
    //     <<empty>>
    //   | FieldType
    //   | FieldType ',' FieldTypeList
    function parseRecordType() {
        var fields, rangeStart = index - 1, rangeEnd;
        consume(Token.LBRACE, "RecordType should start with {");
        fields = [];
        if (token === Token.COMMA) consume(Token.COMMA);
        else while(token !== Token.RBRACE){
            fields.push(parseFieldType());
            if (token !== Token.RBRACE) expect(Token.COMMA);
        }
        rangeEnd = index;
        expect(Token.RBRACE);
        return maybeAddRange({
            type: Syntax.RecordType,
            fields: fields
        }, [
            rangeStart,
            rangeEnd
        ]);
    }
    // NameExpression :=
    //    Identifier
    //  | TagIdentifier ':' Identifier
    //
    // Tag identifier is one of "module", "external" or "event"
    // Identifier is the same as Token.NAME, including any dots, something like
    // namespace.module.MyClass
    function parseNameExpression() {
        var name = value, rangeStart = index - name.length;
        expect(Token.NAME);
        if (token === Token.COLON && (name === "module" || name === "external" || name === "event")) {
            consume(Token.COLON);
            name += ":" + value;
            expect(Token.NAME);
        }
        return maybeAddRange({
            type: Syntax.NameExpression,
            name: name
        }, [
            rangeStart,
            previous
        ]);
    }
    // TypeExpressionList :=
    //     TopLevelTypeExpression
    //   | TopLevelTypeExpression ',' TypeExpressionList
    function parseTypeExpressionList() {
        var elements = [];
        elements.push(parseTop());
        while(token === Token.COMMA){
            consume(Token.COMMA);
            elements.push(parseTop());
        }
        return elements;
    }
    // TypeName :=
    //     NameExpression
    //   | NameExpression TypeApplication
    //
    // TypeApplication :=
    //     '.<' TypeExpressionList '>'
    //   | '<' TypeExpressionList '>'   // this is extension of doctrine
    function parseTypeName() {
        var expr, applications, startIndex = index - value.length;
        expr = parseNameExpression();
        if (token === Token.DOT_LT || token === Token.LT) {
            next();
            applications = parseTypeExpressionList();
            expect(Token.GT);
            return maybeAddRange({
                type: Syntax.TypeApplication,
                expression: expr,
                applications: applications
            }, [
                startIndex,
                previous
            ]);
        }
        return expr;
    }
    // ResultType :=
    //     <<empty>>
    //   | ':' void
    //   | ':' TypeExpression
    //
    // BNF is above
    // but, we remove <<empty>> pattern, so token is always TypeToken::COLON
    function parseResultType() {
        consume(Token.COLON, "ResultType should start with :");
        if (token === Token.NAME && value === "void") {
            consume(Token.NAME);
            return {
                type: Syntax.VoidLiteral
            };
        }
        return parseTypeExpression();
    }
    // ParametersType :=
    //     RestParameterType
    //   | NonRestParametersType
    //   | NonRestParametersType ',' RestParameterType
    //
    // RestParameterType :=
    //     '...'
    //     '...' Identifier
    //
    // NonRestParametersType :=
    //     ParameterType ',' NonRestParametersType
    //   | ParameterType
    //   | OptionalParametersType
    //
    // OptionalParametersType :=
    //     OptionalParameterType
    //   | OptionalParameterType, OptionalParametersType
    //
    // OptionalParameterType := ParameterType=
    //
    // ParameterType := TypeExpression | Identifier ':' TypeExpression
    //
    // Identifier is "new" or "this"
    function parseParametersType() {
        var params = [], optionalSequence = false, expr, rest = false, startIndex, restStartIndex = index - 3, nameStartIndex;
        while(token !== Token.RPAREN){
            if (token === Token.REST) {
                // RestParameterType
                consume(Token.REST);
                rest = true;
            }
            startIndex = previous;
            expr = parseTypeExpression();
            if (expr.type === Syntax.NameExpression && token === Token.COLON) {
                nameStartIndex = previous - expr.name.length;
                // Identifier ':' TypeExpression
                consume(Token.COLON);
                expr = maybeAddRange({
                    type: Syntax.ParameterType,
                    name: expr.name,
                    expression: parseTypeExpression()
                }, [
                    nameStartIndex,
                    previous
                ]);
            }
            if (token === Token.EQUAL) {
                consume(Token.EQUAL);
                expr = maybeAddRange({
                    type: Syntax.OptionalType,
                    expression: expr
                }, [
                    startIndex,
                    previous
                ]);
                optionalSequence = true;
            } else if (optionalSequence) utility.throwError("unexpected token");
            if (rest) expr = maybeAddRange({
                type: Syntax.RestType,
                expression: expr
            }, [
                restStartIndex,
                previous
            ]);
            params.push(expr);
            if (token !== Token.RPAREN) expect(Token.COMMA);
        }
        return params;
    }
    // FunctionType := 'function' FunctionSignatureType
    //
    // FunctionSignatureType :=
    //   | TypeParameters '(' ')' ResultType
    //   | TypeParameters '(' ParametersType ')' ResultType
    //   | TypeParameters '(' 'this' ':' TypeName ')' ResultType
    //   | TypeParameters '(' 'this' ':' TypeName ',' ParametersType ')' ResultType
    function parseFunctionType() {
        var isNew, thisBinding, params, result, fnType, startIndex = index - value.length;
        utility.assert(token === Token.NAME && value === "function", "FunctionType should start with 'function'");
        consume(Token.NAME);
        // Google Closure Compiler is not implementing TypeParameters.
        // So we do not. if we don't get '(', we see it as error.
        expect(Token.LPAREN);
        isNew = false;
        params = [];
        thisBinding = null;
        if (token !== Token.RPAREN) {
            // ParametersType or 'this'
            if (token === Token.NAME && (value === "this" || value === "new")) {
                // 'this' or 'new'
                // 'new' is Closure Compiler extension
                isNew = value === "new";
                consume(Token.NAME);
                expect(Token.COLON);
                thisBinding = parseTypeName();
                if (token === Token.COMMA) {
                    consume(Token.COMMA);
                    params = parseParametersType();
                }
            } else params = parseParametersType();
        }
        expect(Token.RPAREN);
        result = null;
        if (token === Token.COLON) result = parseResultType();
        fnType = maybeAddRange({
            type: Syntax.FunctionType,
            params: params,
            result: result
        }, [
            startIndex,
            previous
        ]);
        if (thisBinding) {
            // avoid adding null 'new' and 'this' properties
            fnType["this"] = thisBinding;
            if (isNew) fnType["new"] = true;
        }
        return fnType;
    }
    // BasicTypeExpression :=
    //     '*'
    //   | 'null'
    //   | 'undefined'
    //   | TypeName
    //   | FunctionType
    //   | UnionType
    //   | RecordType
    //   | ArrayType
    function parseBasicTypeExpression() {
        var context, startIndex;
        switch(token){
            case Token.STAR:
                consume(Token.STAR);
                return maybeAddRange({
                    type: Syntax.AllLiteral
                }, [
                    previous - 1,
                    previous
                ]);
            case Token.LPAREN:
                return parseUnionType();
            case Token.LBRACK:
                return parseArrayType();
            case Token.LBRACE:
                return parseRecordType();
            case Token.NAME:
                startIndex = index - value.length;
                if (value === "null") {
                    consume(Token.NAME);
                    return maybeAddRange({
                        type: Syntax.NullLiteral
                    }, [
                        startIndex,
                        previous
                    ]);
                }
                if (value === "undefined") {
                    consume(Token.NAME);
                    return maybeAddRange({
                        type: Syntax.UndefinedLiteral
                    }, [
                        startIndex,
                        previous
                    ]);
                }
                if (value === "true" || value === "false") {
                    consume(Token.NAME);
                    return maybeAddRange({
                        type: Syntax.BooleanLiteralType,
                        value: value === "true"
                    }, [
                        startIndex,
                        previous
                    ]);
                }
                context = Context.save();
                if (value === "function") try {
                    return parseFunctionType();
                } catch (e) {
                    context.restore();
                }
                return parseTypeName();
            case Token.STRING:
                next();
                return maybeAddRange({
                    type: Syntax.StringLiteralType,
                    value: value
                }, [
                    previous - value.length - 2,
                    previous
                ]);
            case Token.NUMBER:
                next();
                return maybeAddRange({
                    type: Syntax.NumericLiteralType,
                    value: value
                }, [
                    previous - String(value).length,
                    previous
                ]);
            default:
                utility.throwError("unexpected token");
        }
    }
    // TypeExpression :=
    //     BasicTypeExpression
    //   | '?' BasicTypeExpression
    //   | '!' BasicTypeExpression
    //   | BasicTypeExpression '?'
    //   | BasicTypeExpression '!'
    //   | '?'
    //   | BasicTypeExpression '[]'
    function parseTypeExpression() {
        var expr, rangeStart;
        if (token === Token.QUESTION) {
            rangeStart = index - 1;
            consume(Token.QUESTION);
            if (token === Token.COMMA || token === Token.EQUAL || token === Token.RBRACE || token === Token.RPAREN || token === Token.PIPE || token === Token.EOF || token === Token.RBRACK || token === Token.GT) return maybeAddRange({
                type: Syntax.NullableLiteral
            }, [
                rangeStart,
                previous
            ]);
            return maybeAddRange({
                type: Syntax.NullableType,
                expression: parseBasicTypeExpression(),
                prefix: true
            }, [
                rangeStart,
                previous
            ]);
        } else if (token === Token.BANG) {
            rangeStart = index - 1;
            consume(Token.BANG);
            return maybeAddRange({
                type: Syntax.NonNullableType,
                expression: parseBasicTypeExpression(),
                prefix: true
            }, [
                rangeStart,
                previous
            ]);
        } else rangeStart = previous;
        expr = parseBasicTypeExpression();
        if (token === Token.BANG) {
            consume(Token.BANG);
            return maybeAddRange({
                type: Syntax.NonNullableType,
                expression: expr,
                prefix: false
            }, [
                rangeStart,
                previous
            ]);
        }
        if (token === Token.QUESTION) {
            consume(Token.QUESTION);
            return maybeAddRange({
                type: Syntax.NullableType,
                expression: expr,
                prefix: false
            }, [
                rangeStart,
                previous
            ]);
        }
        if (token === Token.LBRACK) {
            consume(Token.LBRACK);
            expect(Token.RBRACK, "expected an array-style type declaration (" + value + "[])");
            return maybeAddRange({
                type: Syntax.TypeApplication,
                expression: maybeAddRange({
                    type: Syntax.NameExpression,
                    name: "Array"
                }, [
                    rangeStart,
                    previous
                ]),
                applications: [
                    expr
                ]
            }, [
                rangeStart,
                previous
            ]);
        }
        return expr;
    }
    // TopLevelTypeExpression :=
    //      TypeExpression
    //    | TypeUnionList
    //
    // This rule is Google Closure Compiler extension, not ES4
    // like,
    //   { number | string }
    // If strict to ES4, we should write it as
    //   { (number|string) }
    function parseTop() {
        var expr, elements;
        expr = parseTypeExpression();
        if (token !== Token.PIPE) return expr;
        elements = [
            expr
        ];
        consume(Token.PIPE);
        while(true){
            elements.push(parseTypeExpression());
            if (token !== Token.PIPE) break;
            consume(Token.PIPE);
        }
        return maybeAddRange({
            type: Syntax.UnionType,
            elements: elements
        }, [
            0,
            index
        ]);
    }
    function parseTopParamType() {
        var expr;
        if (token === Token.REST) {
            consume(Token.REST);
            return maybeAddRange({
                type: Syntax.RestType,
                expression: parseTop()
            }, [
                0,
                index
            ]);
        }
        expr = parseTop();
        if (token === Token.EQUAL) {
            consume(Token.EQUAL);
            return maybeAddRange({
                type: Syntax.OptionalType,
                expression: expr
            }, [
                0,
                index
            ]);
        }
        return expr;
    }
    function parseType(src, opt) {
        var expr;
        source = src;
        length = source.length;
        index = 0;
        previous = 0;
        addRange = opt && opt.range;
        rangeOffset = opt && opt.startIndex || 0;
        next();
        expr = parseTop();
        if (opt && opt.midstream) return {
            expression: expr,
            index: previous
        };
        if (token !== Token.EOF) utility.throwError("not reach to EOF");
        return expr;
    }
    function parseParamType(src, opt) {
        var expr;
        source = src;
        length = source.length;
        index = 0;
        previous = 0;
        addRange = opt && opt.range;
        rangeOffset = opt && opt.startIndex || 0;
        next();
        expr = parseTopParamType();
        if (opt && opt.midstream) return {
            expression: expr,
            index: previous
        };
        if (token !== Token.EOF) utility.throwError("not reach to EOF");
        return expr;
    }
    function stringifyImpl(node, compact, topLevel) {
        var result, i, iz;
        switch(node.type){
            case Syntax.NullableLiteral:
                result = "?";
                break;
            case Syntax.AllLiteral:
                result = "*";
                break;
            case Syntax.NullLiteral:
                result = "null";
                break;
            case Syntax.UndefinedLiteral:
                result = "undefined";
                break;
            case Syntax.VoidLiteral:
                result = "void";
                break;
            case Syntax.UnionType:
                if (!topLevel) result = "(";
                else result = "";
                for(i = 0, iz = node.elements.length; i < iz; ++i){
                    result += stringifyImpl(node.elements[i], compact);
                    if (i + 1 !== iz) result += compact ? "|" : " | ";
                }
                if (!topLevel) result += ")";
                break;
            case Syntax.ArrayType:
                result = "[";
                for(i = 0, iz = node.elements.length; i < iz; ++i){
                    result += stringifyImpl(node.elements[i], compact);
                    if (i + 1 !== iz) result += compact ? "," : ", ";
                }
                result += "]";
                break;
            case Syntax.RecordType:
                result = "{";
                for(i = 0, iz = node.fields.length; i < iz; ++i){
                    result += stringifyImpl(node.fields[i], compact);
                    if (i + 1 !== iz) result += compact ? "," : ", ";
                }
                result += "}";
                break;
            case Syntax.FieldType:
                if (node.value) result = node.key + (compact ? ":" : ": ") + stringifyImpl(node.value, compact);
                else result = node.key;
                break;
            case Syntax.FunctionType:
                result = compact ? "function(" : "function (";
                if (node["this"]) {
                    if (node["new"]) result += compact ? "new:" : "new: ";
                    else result += compact ? "this:" : "this: ";
                    result += stringifyImpl(node["this"], compact);
                    if (node.params.length !== 0) result += compact ? "," : ", ";
                }
                for(i = 0, iz = node.params.length; i < iz; ++i){
                    result += stringifyImpl(node.params[i], compact);
                    if (i + 1 !== iz) result += compact ? "," : ", ";
                }
                result += ")";
                if (node.result) result += (compact ? ":" : ": ") + stringifyImpl(node.result, compact);
                break;
            case Syntax.ParameterType:
                result = node.name + (compact ? ":" : ": ") + stringifyImpl(node.expression, compact);
                break;
            case Syntax.RestType:
                result = "...";
                if (node.expression) result += stringifyImpl(node.expression, compact);
                break;
            case Syntax.NonNullableType:
                if (node.prefix) result = "!" + stringifyImpl(node.expression, compact);
                else result = stringifyImpl(node.expression, compact) + "!";
                break;
            case Syntax.OptionalType:
                result = stringifyImpl(node.expression, compact) + "=";
                break;
            case Syntax.NullableType:
                if (node.prefix) result = "?" + stringifyImpl(node.expression, compact);
                else result = stringifyImpl(node.expression, compact) + "?";
                break;
            case Syntax.NameExpression:
                result = node.name;
                break;
            case Syntax.TypeApplication:
                result = stringifyImpl(node.expression, compact) + ".<";
                for(i = 0, iz = node.applications.length; i < iz; ++i){
                    result += stringifyImpl(node.applications[i], compact);
                    if (i + 1 !== iz) result += compact ? "," : ", ";
                }
                result += ">";
                break;
            case Syntax.StringLiteralType:
                result = '"' + node.value + '"';
                break;
            case Syntax.NumericLiteralType:
                result = String(node.value);
                break;
            case Syntax.BooleanLiteralType:
                result = String(node.value);
                break;
            default:
                utility.throwError("Unknown type " + node.type);
        }
        return result;
    }
    function stringify(node, options) {
        if (options == null) options = {};
        return stringifyImpl(node, options.compact, options.topLevel);
    }
    exports.parseType = parseType;
    exports.parseParamType = parseParamType;
    exports.stringify = stringify;
    exports.Syntax = Syntax;
})(); /* vim: set sw=4 ts=4 et tw=80 : */ 

},{"c04884917b8d1fb9":"d3HGx","84fdd378a161f8fd":"iCvRf"}],"iCvRf":[function(require,module,exports) {
/*
 * @fileoverview Utilities for Doctrine
 * @author Yusuke Suzuki <utatane.tea@gmail.com>
 */ (function() {
    "use strict";
    var VERSION;
    VERSION = require("c2100f4e6f9b0e49").version;
    exports.VERSION = VERSION;
    function DoctrineError(message) {
        this.name = "DoctrineError";
        this.message = message;
    }
    DoctrineError.prototype = function() {
        var Middle = function() {};
        Middle.prototype = Error.prototype;
        return new Middle();
    }();
    DoctrineError.prototype.constructor = DoctrineError;
    exports.DoctrineError = DoctrineError;
    function throwError(message) {
        throw new DoctrineError(message);
    }
    exports.throwError = throwError;
    exports.assert = require("5c2817f022d918be");
})(); /* vim: set sw=4 ts=4 et tw=80 : */ 

},{"c2100f4e6f9b0e49":"64hAC","5c2817f022d918be":"1AlMO"}],"64hAC":[function(require,module,exports) {
module.exports = JSON.parse('{"name":"doctrine","description":"JSDoc parser","homepage":"https://github.com/eslint/doctrine","main":"lib/doctrine.js","version":"3.0.0","engines":{"node":">=6.0.0"},"directories":{"lib":"./lib"},"files":["lib"],"maintainers":[{"name":"Nicholas C. Zakas","email":"nicholas+npm@nczconsulting.com","web":"https://www.nczonline.net"},{"name":"Yusuke Suzuki","email":"utatane.tea@gmail.com","web":"https://github.com/Constellation"}],"repository":"eslint/doctrine","devDependencies":{"coveralls":"^3.0.1","dateformat":"^1.0.11","eslint":"^1.10.3","eslint-release":"^1.0.0","linefix":"^0.1.1","mocha":"^3.4.2","npm-license":"^0.3.1","nyc":"^10.3.2","semver":"^5.0.3","shelljs":"^0.5.3","shelljs-nodecli":"^0.1.1","should":"^5.0.1"},"license":"Apache-2.0","scripts":{"pretest":"npm run lint","test":"nyc mocha","coveralls":"nyc report --reporter=text-lcov | coveralls","lint":"eslint lib/","generate-release":"eslint-generate-release","generate-alpharelease":"eslint-generate-prerelease alpha","generate-betarelease":"eslint-generate-prerelease beta","generate-rcrelease":"eslint-generate-prerelease rc","publish-release":"eslint-publish-release"},"dependencies":{"esutils":"^2.0.2"}}');

},{}],"1AlMO":[function(require,module,exports) {
var global = arguments[3];
"use strict";
var objectAssign = require("9feaf718e44760c");
// compare and isBuffer taken from https://github.com/feross/buffer/blob/680e9e5e488f22aac27599a57dc844a6315928dd/index.js
// original notice:
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */ function compare(a, b) {
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
}
function isBuffer(b) {
    if (global.Buffer && typeof global.Buffer.isBuffer === "function") return global.Buffer.isBuffer(b);
    return !!(b != null && b._isBuffer);
}
// based on node assert, original notice:
// NB: The URL to the CommonJS spec is kept just for tradition.
//     node-assert has evolved a lot since then, both in API and behavior.
// http://wiki.commonjs.org/wiki/Unit_Testing/1.0
//
// THIS IS NOT TESTED NOR LIKELY TO WORK OUTSIDE V8!
//
// Originally from narwhal.js (http://narwhaljs.org)
// Copyright (c) 2009 Thomas Robinson <280north.com>
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the 'Software'), to
// deal in the Software without restriction, including without limitation the
// rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
// sell copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
// ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
// WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
var util = require("4737a90df280f1b6");
var hasOwn = Object.prototype.hasOwnProperty;
var pSlice = Array.prototype.slice;
var functionsHaveNames = function() {
    return (function foo() {}).name === "foo";
}();
function pToString(obj) {
    return Object.prototype.toString.call(obj);
}
function isView(arrbuf) {
    if (isBuffer(arrbuf)) return false;
    if (typeof global.ArrayBuffer !== "function") return false;
    if (typeof ArrayBuffer.isView === "function") return ArrayBuffer.isView(arrbuf);
    if (!arrbuf) return false;
    if (arrbuf instanceof DataView) return true;
    if (arrbuf.buffer && arrbuf.buffer instanceof ArrayBuffer) return true;
    return false;
}
// 1. The assert module provides functions that throw
// AssertionError's when particular conditions are not met. The
// assert module must conform to the following interface.
var assert = module.exports = ok;
// 2. The AssertionError is defined in assert.
// new assert.AssertionError({ message: message,
//                             actual: actual,
//                             expected: expected })
var regex = /\s*function\s+([^\(\s]*)\s*/;
// based on https://github.com/ljharb/function.prototype.name/blob/adeeeec8bfcc6068b187d7d9fb3d5bb1d3a30899/implementation.js
function getName(func) {
    if (!util.isFunction(func)) return;
    if (functionsHaveNames) return func.name;
    var str = func.toString();
    var match = str.match(regex);
    return match && match[1];
}
assert.AssertionError = function AssertionError(options) {
    this.name = "AssertionError";
    this.actual = options.actual;
    this.expected = options.expected;
    this.operator = options.operator;
    if (options.message) {
        this.message = options.message;
        this.generatedMessage = false;
    } else {
        this.message = getMessage(this);
        this.generatedMessage = true;
    }
    var stackStartFunction = options.stackStartFunction || fail;
    if (Error.captureStackTrace) Error.captureStackTrace(this, stackStartFunction);
    else {
        // non v8 browsers so we can have a stacktrace
        var err = new Error();
        if (err.stack) {
            var out = err.stack;
            // try to strip useless frames
            var fn_name = getName(stackStartFunction);
            var idx = out.indexOf("\n" + fn_name);
            if (idx >= 0) {
                // once we have located the function frame
                // we need to strip out everything before it (and its line)
                var next_line = out.indexOf("\n", idx + 1);
                out = out.substring(next_line + 1);
            }
            this.stack = out;
        }
    }
};
// assert.AssertionError instanceof Error
util.inherits(assert.AssertionError, Error);
function truncate(s, n) {
    if (typeof s === "string") return s.length < n ? s : s.slice(0, n);
    else return s;
}
function inspect(something) {
    if (functionsHaveNames || !util.isFunction(something)) return util.inspect(something);
    var rawname = getName(something);
    var name = rawname ? ": " + rawname : "";
    return "[Function" + name + "]";
}
function getMessage(self) {
    return truncate(inspect(self.actual), 128) + " " + self.operator + " " + truncate(inspect(self.expected), 128);
}
// At present only the three keys mentioned above are used and
// understood by the spec. Implementations or sub modules can pass
// other keys to the AssertionError's constructor - they will be
// ignored.
// 3. All of the following functions must throw an AssertionError
// when a corresponding condition is not met, with a message that
// may be undefined if not provided.  All assertion methods provide
// both the actual and expected values to the assertion error for
// display purposes.
function fail(actual, expected, message, operator, stackStartFunction) {
    throw new assert.AssertionError({
        message: message,
        actual: actual,
        expected: expected,
        operator: operator,
        stackStartFunction: stackStartFunction
    });
}
// EXTENSION! allows for well behaved errors defined elsewhere.
assert.fail = fail;
// 4. Pure assertion tests whether a value is truthy, as determined
// by !!guard.
// assert.ok(guard, message_opt);
// This statement is equivalent to assert.equal(true, !!guard,
// message_opt);. To test strictly for the value true, use
// assert.strictEqual(true, guard, message_opt);.
function ok(value, message) {
    if (!value) fail(value, true, message, "==", assert.ok);
}
assert.ok = ok;
// 5. The equality assertion tests shallow, coercive equality with
// ==.
// assert.equal(actual, expected, message_opt);
assert.equal = function equal(actual, expected, message) {
    if (actual != expected) fail(actual, expected, message, "==", assert.equal);
};
// 6. The non-equality assertion tests for whether two objects are not equal
// with != assert.notEqual(actual, expected, message_opt);
assert.notEqual = function notEqual(actual, expected, message) {
    if (actual == expected) fail(actual, expected, message, "!=", assert.notEqual);
};
// 7. The equivalence assertion tests a deep equality relation.
// assert.deepEqual(actual, expected, message_opt);
assert.deepEqual = function deepEqual(actual, expected, message) {
    if (!_deepEqual(actual, expected, false)) fail(actual, expected, message, "deepEqual", assert.deepEqual);
};
assert.deepStrictEqual = function deepStrictEqual(actual, expected, message) {
    if (!_deepEqual(actual, expected, true)) fail(actual, expected, message, "deepStrictEqual", assert.deepStrictEqual);
};
function _deepEqual(actual, expected, strict, memos) {
    // 7.1. All identical values are equivalent, as determined by ===.
    if (actual === expected) return true;
    else if (isBuffer(actual) && isBuffer(expected)) return compare(actual, expected) === 0;
    else if (util.isDate(actual) && util.isDate(expected)) return actual.getTime() === expected.getTime();
    else if (util.isRegExp(actual) && util.isRegExp(expected)) return actual.source === expected.source && actual.global === expected.global && actual.multiline === expected.multiline && actual.lastIndex === expected.lastIndex && actual.ignoreCase === expected.ignoreCase;
    else if ((actual === null || typeof actual !== "object") && (expected === null || typeof expected !== "object")) return strict ? actual === expected : actual == expected;
    else if (isView(actual) && isView(expected) && pToString(actual) === pToString(expected) && !(actual instanceof Float32Array || actual instanceof Float64Array)) return compare(new Uint8Array(actual.buffer), new Uint8Array(expected.buffer)) === 0;
    else if (isBuffer(actual) !== isBuffer(expected)) return false;
    else {
        memos = memos || {
            actual: [],
            expected: []
        };
        var actualIndex = memos.actual.indexOf(actual);
        if (actualIndex !== -1) {
            if (actualIndex === memos.expected.indexOf(expected)) return true;
        }
        memos.actual.push(actual);
        memos.expected.push(expected);
        return objEquiv(actual, expected, strict, memos);
    }
}
function isArguments(object) {
    return Object.prototype.toString.call(object) == "[object Arguments]";
}
function objEquiv(a, b, strict, actualVisitedObjects) {
    if (a === null || a === undefined || b === null || b === undefined) return false;
    // if one is a primitive, the other must be same
    if (util.isPrimitive(a) || util.isPrimitive(b)) return a === b;
    if (strict && Object.getPrototypeOf(a) !== Object.getPrototypeOf(b)) return false;
    var aIsArgs = isArguments(a);
    var bIsArgs = isArguments(b);
    if (aIsArgs && !bIsArgs || !aIsArgs && bIsArgs) return false;
    if (aIsArgs) {
        a = pSlice.call(a);
        b = pSlice.call(b);
        return _deepEqual(a, b, strict);
    }
    var ka = objectKeys(a);
    var kb = objectKeys(b);
    var key, i;
    // having the same number of owned properties (keys incorporates
    // hasOwnProperty)
    if (ka.length !== kb.length) return false;
    //the same set of keys (although not necessarily the same order),
    ka.sort();
    kb.sort();
    //~~~cheap key test
    for(i = ka.length - 1; i >= 0; i--){
        if (ka[i] !== kb[i]) return false;
    }
    //equivalent values for every corresponding key, and
    //~~~possibly expensive deep test
    for(i = ka.length - 1; i >= 0; i--){
        key = ka[i];
        if (!_deepEqual(a[key], b[key], strict, actualVisitedObjects)) return false;
    }
    return true;
}
// 8. The non-equivalence assertion tests for any deep inequality.
// assert.notDeepEqual(actual, expected, message_opt);
assert.notDeepEqual = function notDeepEqual(actual, expected, message) {
    if (_deepEqual(actual, expected, false)) fail(actual, expected, message, "notDeepEqual", assert.notDeepEqual);
};
assert.notDeepStrictEqual = notDeepStrictEqual;
function notDeepStrictEqual(actual, expected, message) {
    if (_deepEqual(actual, expected, true)) fail(actual, expected, message, "notDeepStrictEqual", notDeepStrictEqual);
}
// 9. The strict equality assertion tests strict equality, as determined by ===.
// assert.strictEqual(actual, expected, message_opt);
assert.strictEqual = function strictEqual(actual, expected, message) {
    if (actual !== expected) fail(actual, expected, message, "===", assert.strictEqual);
};
// 10. The strict non-equality assertion tests for strict inequality, as
// determined by !==.  assert.notStrictEqual(actual, expected, message_opt);
assert.notStrictEqual = function notStrictEqual(actual, expected, message) {
    if (actual === expected) fail(actual, expected, message, "!==", assert.notStrictEqual);
};
function expectedException(actual, expected) {
    if (!actual || !expected) return false;
    if (Object.prototype.toString.call(expected) == "[object RegExp]") return expected.test(actual);
    try {
        if (actual instanceof expected) return true;
    } catch (e) {
    // Ignore.  The instanceof check doesn't work for arrow functions.
    }
    if (Error.isPrototypeOf(expected)) return false;
    return expected.call({}, actual) === true;
}
function _tryBlock(block) {
    var error;
    try {
        block();
    } catch (e) {
        error = e;
    }
    return error;
}
function _throws(shouldThrow, block, expected, message) {
    var actual;
    if (typeof block !== "function") throw new TypeError('"block" argument must be a function');
    if (typeof expected === "string") {
        message = expected;
        expected = null;
    }
    actual = _tryBlock(block);
    message = (expected && expected.name ? " (" + expected.name + ")." : ".") + (message ? " " + message : ".");
    if (shouldThrow && !actual) fail(actual, expected, "Missing expected exception" + message);
    var userProvidedMessage = typeof message === "string";
    var isUnwantedException = !shouldThrow && util.isError(actual);
    var isUnexpectedException = !shouldThrow && actual && !expected;
    if (isUnwantedException && userProvidedMessage && expectedException(actual, expected) || isUnexpectedException) fail(actual, expected, "Got unwanted exception" + message);
    if (shouldThrow && actual && expected && !expectedException(actual, expected) || !shouldThrow && actual) throw actual;
}
// 11. Expected to throw an error:
// assert.throws(block, Error_opt, message_opt);
assert.throws = function(block, /*optional*/ error, /*optional*/ message) {
    _throws(true, block, error, message);
};
// EXTENSION! This is annoying to write outside this module.
assert.doesNotThrow = function(block, /*optional*/ error, /*optional*/ message) {
    _throws(false, block, error, message);
};
assert.ifError = function(err) {
    if (err) throw err;
};
// Expose a strict only variant of assert
function strict(value, message) {
    if (!value) fail(value, true, message, "==", strict);
}
assert.strict = objectAssign(strict, assert, {
    equal: assert.strictEqual,
    deepEqual: assert.deepStrictEqual,
    notEqual: assert.notStrictEqual,
    notDeepEqual: assert.notDeepStrictEqual
});
assert.strict.strict = assert.strict;
var objectKeys = Object.keys || function(obj) {
    var keys = [];
    for(var key in obj)if (hasOwn.call(obj, key)) keys.push(key);
    return keys;
};

},{"9feaf718e44760c":"jemQB","4737a90df280f1b6":"1J3rC"}],"jemQB":[function(require,module,exports) {
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ "use strict";
/* eslint-disable no-unused-vars */ var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;
function toObject(val) {
    if (val === null || val === undefined) throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(val);
}
function shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String("abc"); // eslint-disable-line no-new-wrappers
        test1[5] = "de";
        if (Object.getOwnPropertyNames(test1)[0] === "5") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2["_" + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join("") !== "0123456789") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        "abcdefghijklmnopqrst".split("").forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
module.exports = shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if (hasOwnProperty.call(from, key)) to[key] = from[key];
        if (getOwnPropertySymbols) {
            symbols = getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if (propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};

},{}],"1J3rC":[function(require,module,exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
var global = arguments[3];
var process = require("4210e9299133e064");
var formatRegExp = /%[sdj%]/g;
exports.format = function(f) {
    if (!isString(f)) {
        var objects = [];
        for(var i = 0; i < arguments.length; i++)objects.push(inspect(arguments[i]));
        return objects.join(" ");
    }
    var i = 1;
    var args = arguments;
    var len = args.length;
    var str = String(f).replace(formatRegExp, function(x) {
        if (x === "%%") return "%";
        if (i >= len) return x;
        switch(x){
            case "%s":
                return String(args[i++]);
            case "%d":
                return Number(args[i++]);
            case "%j":
                try {
                    return JSON.stringify(args[i++]);
                } catch (_) {
                    return "[Circular]";
                }
            default:
                return x;
        }
    });
    for(var x = args[i]; i < len; x = args[++i])if (isNull(x) || !isObject(x)) str += " " + x;
    else str += " " + inspect(x);
    return str;
};
// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
exports.deprecate = function(fn, msg) {
    // Allow for deprecating things in the process of starting up.
    if (isUndefined(global.process)) return function() {
        return exports.deprecate(fn, msg).apply(this, arguments);
    };
    if (process.noDeprecation === true) return fn;
    var warned = false;
    function deprecated() {
        if (!warned) {
            if (process.throwDeprecation) throw new Error(msg);
            else if (process.traceDeprecation) console.trace(msg);
            else console.error(msg);
            warned = true;
        }
        return fn.apply(this, arguments);
    }
    return deprecated;
};
var debugs = {};
var debugEnviron;
exports.debuglog = function(set) {
    if (isUndefined(debugEnviron)) debugEnviron = "";
    set = set.toUpperCase();
    if (!debugs[set]) {
        if (new RegExp("\\b" + set + "\\b", "i").test(debugEnviron)) {
            var pid = process.pid;
            debugs[set] = function() {
                var msg = exports.format.apply(exports, arguments);
                console.error("%s %d: %s", set, pid, msg);
            };
        } else debugs[set] = function() {};
    }
    return debugs[set];
};
/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */ /* legacy: obj, showHidden, depth, colors*/ function inspect(obj, opts) {
    // default options
    var ctx = {
        seen: [],
        stylize: stylizeNoColor
    };
    // legacy...
    if (arguments.length >= 3) ctx.depth = arguments[2];
    if (arguments.length >= 4) ctx.colors = arguments[3];
    if (isBoolean(opts)) // legacy...
    ctx.showHidden = opts;
    else if (opts) // got an "options" object
    exports._extend(ctx, opts);
    // set default options
    if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
    if (isUndefined(ctx.depth)) ctx.depth = 2;
    if (isUndefined(ctx.colors)) ctx.colors = false;
    if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
    if (ctx.colors) ctx.stylize = stylizeWithColor;
    return formatValue(ctx, obj, ctx.depth);
}
exports.inspect = inspect;
// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
inspect.colors = {
    "bold": [
        1,
        22
    ],
    "italic": [
        3,
        23
    ],
    "underline": [
        4,
        24
    ],
    "inverse": [
        7,
        27
    ],
    "white": [
        37,
        39
    ],
    "grey": [
        90,
        39
    ],
    "black": [
        30,
        39
    ],
    "blue": [
        34,
        39
    ],
    "cyan": [
        36,
        39
    ],
    "green": [
        32,
        39
    ],
    "magenta": [
        35,
        39
    ],
    "red": [
        31,
        39
    ],
    "yellow": [
        33,
        39
    ]
};
// Don't use 'blue' not visible on cmd.exe
inspect.styles = {
    "special": "cyan",
    "number": "yellow",
    "boolean": "yellow",
    "undefined": "grey",
    "null": "bold",
    "string": "green",
    "date": "magenta",
    // "name": intentionally not styling
    "regexp": "red"
};
function stylizeWithColor(str, styleType) {
    var style = inspect.styles[styleType];
    if (style) return "\x1b[" + inspect.colors[style][0] + "m" + str + "\x1b[" + inspect.colors[style][1] + "m";
    else return str;
}
function stylizeNoColor(str, styleType) {
    return str;
}
function arrayToHash(array) {
    var hash = {};
    array.forEach(function(val, idx) {
        hash[val] = true;
    });
    return hash;
}
function formatValue(ctx, value, recurseTimes) {
    // Provide a hook for user-specified inspect functions.
    // Check that value is an object with an inspect function on it
    if (ctx.customInspect && value && isFunction(value.inspect) && // Filter out the util module, it's inspect function is special
    value.inspect !== exports.inspect && // Also filter out any prototype objects using the circular check.
    !(value.constructor && value.constructor.prototype === value)) {
        var ret = value.inspect(recurseTimes, ctx);
        if (!isString(ret)) ret = formatValue(ctx, ret, recurseTimes);
        return ret;
    }
    // Primitive types cannot have properties
    var primitive = formatPrimitive(ctx, value);
    if (primitive) return primitive;
    // Look up the keys of the object.
    var keys = Object.keys(value);
    var visibleKeys = arrayToHash(keys);
    if (ctx.showHidden) keys = Object.getOwnPropertyNames(value);
    // IE doesn't make error fields non-enumerable
    // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
    if (isError(value) && (keys.indexOf("message") >= 0 || keys.indexOf("description") >= 0)) return formatError(value);
    // Some type of object without properties can be shortcutted.
    if (keys.length === 0) {
        if (isFunction(value)) {
            var name = value.name ? ": " + value.name : "";
            return ctx.stylize("[Function" + name + "]", "special");
        }
        if (isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), "regexp");
        if (isDate(value)) return ctx.stylize(Date.prototype.toString.call(value), "date");
        if (isError(value)) return formatError(value);
    }
    var base = "", array = false, braces = [
        "{",
        "}"
    ];
    // Make Array say that they are Array
    if (isArray(value)) {
        array = true;
        braces = [
            "[",
            "]"
        ];
    }
    // Make functions say that they are functions
    if (isFunction(value)) {
        var n = value.name ? ": " + value.name : "";
        base = " [Function" + n + "]";
    }
    // Make RegExps say that they are RegExps
    if (isRegExp(value)) base = " " + RegExp.prototype.toString.call(value);
    // Make dates with properties first say the date
    if (isDate(value)) base = " " + Date.prototype.toUTCString.call(value);
    // Make error with message first say the error
    if (isError(value)) base = " " + formatError(value);
    if (keys.length === 0 && (!array || value.length == 0)) return braces[0] + base + braces[1];
    if (recurseTimes < 0) {
        if (isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), "regexp");
        else return ctx.stylize("[Object]", "special");
    }
    ctx.seen.push(value);
    var output;
    if (array) output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
    else output = keys.map(function(key) {
        return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
    ctx.seen.pop();
    return reduceToSingleString(output, base, braces);
}
function formatPrimitive(ctx, value) {
    if (isUndefined(value)) return ctx.stylize("undefined", "undefined");
    if (isString(value)) {
        var simple = "'" + JSON.stringify(value).replace(/^"|"$/g, "").replace(/'/g, "\\'").replace(/\\"/g, '"') + "'";
        return ctx.stylize(simple, "string");
    }
    if (isNumber(value)) return ctx.stylize("" + value, "number");
    if (isBoolean(value)) return ctx.stylize("" + value, "boolean");
    // For some reason typeof null is "object", so special case here.
    if (isNull(value)) return ctx.stylize("null", "null");
}
function formatError(value) {
    return "[" + Error.prototype.toString.call(value) + "]";
}
function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
    var output = [];
    for(var i = 0, l = value.length; i < l; ++i)if (hasOwnProperty(value, String(i))) output.push(formatProperty(ctx, value, recurseTimes, visibleKeys, String(i), true));
    else output.push("");
    keys.forEach(function(key) {
        if (!key.match(/^\d+$/)) output.push(formatProperty(ctx, value, recurseTimes, visibleKeys, key, true));
    });
    return output;
}
function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
    var name, str, desc;
    desc = Object.getOwnPropertyDescriptor(value, key) || {
        value: value[key]
    };
    if (desc.get) {
        if (desc.set) str = ctx.stylize("[Getter/Setter]", "special");
        else str = ctx.stylize("[Getter]", "special");
    } else if (desc.set) str = ctx.stylize("[Setter]", "special");
    if (!hasOwnProperty(visibleKeys, key)) name = "[" + key + "]";
    if (!str) {
        if (ctx.seen.indexOf(desc.value) < 0) {
            if (isNull(recurseTimes)) str = formatValue(ctx, desc.value, null);
            else str = formatValue(ctx, desc.value, recurseTimes - 1);
            if (str.indexOf("\n") > -1) {
                if (array) str = str.split("\n").map(function(line) {
                    return "  " + line;
                }).join("\n").substr(2);
                else str = "\n" + str.split("\n").map(function(line) {
                    return "   " + line;
                }).join("\n");
            }
        } else str = ctx.stylize("[Circular]", "special");
    }
    if (isUndefined(name)) {
        if (array && key.match(/^\d+$/)) return str;
        name = JSON.stringify("" + key);
        if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
            name = name.substr(1, name.length - 2);
            name = ctx.stylize(name, "name");
        } else {
            name = name.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'");
            name = ctx.stylize(name, "string");
        }
    }
    return name + ": " + str;
}
function reduceToSingleString(output, base, braces) {
    var numLinesEst = 0;
    var length = output.reduce(function(prev, cur) {
        numLinesEst++;
        if (cur.indexOf("\n") >= 0) numLinesEst++;
        return prev + cur.replace(/\u001b\[\d\d?m/g, "").length + 1;
    }, 0);
    if (length > 60) return braces[0] + (base === "" ? "" : base + "\n ") + " " + output.join(",\n  ") + " " + braces[1];
    return braces[0] + base + " " + output.join(", ") + " " + braces[1];
}
// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
function isArray(ar) {
    return Array.isArray(ar);
}
exports.isArray = isArray;
function isBoolean(arg) {
    return typeof arg === "boolean";
}
exports.isBoolean = isBoolean;
function isNull(arg) {
    return arg === null;
}
exports.isNull = isNull;
function isNullOrUndefined(arg) {
    return arg == null;
}
exports.isNullOrUndefined = isNullOrUndefined;
function isNumber(arg) {
    return typeof arg === "number";
}
exports.isNumber = isNumber;
function isString(arg) {
    return typeof arg === "string";
}
exports.isString = isString;
function isSymbol(arg) {
    return typeof arg === "symbol";
}
exports.isSymbol = isSymbol;
function isUndefined(arg) {
    return arg === void 0;
}
exports.isUndefined = isUndefined;
function isRegExp(re) {
    return isObject(re) && objectToString(re) === "[object RegExp]";
}
exports.isRegExp = isRegExp;
function isObject(arg) {
    return typeof arg === "object" && arg !== null;
}
exports.isObject = isObject;
function isDate(d) {
    return isObject(d) && objectToString(d) === "[object Date]";
}
exports.isDate = isDate;
function isError(e) {
    return isObject(e) && (objectToString(e) === "[object Error]" || e instanceof Error);
}
exports.isError = isError;
function isFunction(arg) {
    return typeof arg === "function";
}
exports.isFunction = isFunction;
function isPrimitive(arg) {
    return arg === null || typeof arg === "boolean" || typeof arg === "number" || typeof arg === "string" || typeof arg === "symbol" || // ES6 symbol
    typeof arg === "undefined";
}
exports.isPrimitive = isPrimitive;
exports.isBuffer = require("7511459e38845b49");
function objectToString(o) {
    return Object.prototype.toString.call(o);
}
function pad(n) {
    return n < 10 ? "0" + n.toString(10) : n.toString(10);
}
var months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
];
// 26 Feb 16:19:34
function timestamp() {
    var d = new Date();
    var time = [
        pad(d.getHours()),
        pad(d.getMinutes()),
        pad(d.getSeconds())
    ].join(":");
    return [
        d.getDate(),
        months[d.getMonth()],
        time
    ].join(" ");
}
// log is just a thin wrapper to console.log that prepends a timestamp
exports.log = function() {
    console.log("%s - %s", timestamp(), exports.format.apply(exports, arguments));
};
/**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */ exports.inherits = require("f82a12e11e8cc727");
exports._extend = function(origin, add) {
    // Don't do anything if add isn't an object
    if (!add || !isObject(add)) return origin;
    var keys = Object.keys(add);
    var i = keys.length;
    while(i--)origin[keys[i]] = add[keys[i]];
    return origin;
};
function hasOwnProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}

},{"4210e9299133e064":"6WEZ3","7511459e38845b49":"lt6SY","f82a12e11e8cc727":"eCuFk"}],"lt6SY":[function(require,module,exports) {
module.exports = function isBuffer(arg) {
    return arg && typeof arg === "object" && typeof arg.copy === "function" && typeof arg.fill === "function" && typeof arg.readUInt8 === "function";
};

},{}],"eCuFk":[function(require,module,exports) {
if (typeof Object.create === "function") // implementation from standard node.js 'util' module
module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor;
    ctor.prototype = Object.create(superCtor.prototype, {
        constructor: {
            value: ctor,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
};
else // old school shim for old browsers
module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor;
    var TempCtor = function() {};
    TempCtor.prototype = superCtor.prototype;
    ctor.prototype = new TempCtor();
    ctor.prototype.constructor = ctor;
};

},{}],"ekP6O":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "javaScriptFactory", ()=>javaScriptFactory);
parcelHelpers.export(exports, "tsFactory", ()=>tsFactory);
parcelHelpers.export(exports, "flowFactory", ()=>flowFactory);
parcelHelpers.export(exports, "unknownFactory", ()=>unknownFactory);
parcelHelpers.export(exports, "getPropDefFactory", ()=>getPropDefFactory);
var _esFunctionNameJs = require("core-js/modules/es.function.name.js");
var _esObjectToStringJs = require("core-js/modules/es.object.to-string.js");
var _esSymbolJs = require("core-js/modules/es.symbol.js");
var _esSymbolDescriptionJs = require("core-js/modules/es.symbol.description.js");
var _esArrayMapJs = require("core-js/modules/es.array.map.js");
var _types = require("./types");
var _utils = require("../utils");
var _createPropDef = require("./flow/createPropDef");
var _defaultValue = require("./utils/defaultValue");
var _createPropDef1 = require("./typeScript/createPropDef");
var _convert = require("../convert");
function createType(type) {
    // A type could be null if a defaultProp has been provided without a type definition.
    return type != null ? (0, _utils.createSummaryValue)(type.name) : null;
} // A heuristic to tell if a defaultValue comes from RDT
function isReactDocgenTypescript(defaultValue) {
    var computed = defaultValue.computed, func = defaultValue.func;
    return typeof computed === "undefined" && typeof func === "undefined";
}
function isStringValued(type) {
    if (!type) return false;
    if (type.name === "string") return true;
    if (type.name === "enum") return Array.isArray(type.value) && type.value.every(function(_ref) {
        var tv = _ref.value;
        return typeof tv === "string" && tv[0] === '"' && tv[tv.length - 1] === '"';
    });
    return false;
}
function createDefaultValue(defaultValue, type) {
    if (defaultValue != null) {
        var value = defaultValue.value;
        if (!(0, _defaultValue.isDefaultValueBlacklisted)(value)) {
            // Work around a bug in `react-docgen-typescript-loader`, which returns 'string' for a string
            // default, instead of "'string'" -- which is incorrect
            if (isReactDocgenTypescript(defaultValue) && isStringValued(type)) return (0, _utils.createSummaryValue)(JSON.stringify(value));
            return (0, _utils.createSummaryValue)(value);
        }
    }
    return null;
}
function createBasicPropDef(name, type, docgenInfo) {
    var description = docgenInfo.description, required = docgenInfo.required, defaultValue = docgenInfo.defaultValue;
    return {
        name: name,
        type: createType(type),
        required: required,
        description: description,
        defaultValue: createDefaultValue(defaultValue, type)
    };
}
function applyJsDocResult(propDef, jsDocParsingResult) {
    if (jsDocParsingResult.includesJsDoc) {
        var description = jsDocParsingResult.description, extractedTags = jsDocParsingResult.extractedTags;
        if (description != null) // eslint-disable-next-line no-param-reassign
        propDef.description = jsDocParsingResult.description;
        var hasParams = extractedTags.params != null;
        var hasReturns = extractedTags.returns != null && extractedTags.returns.type != null;
        if (hasParams || hasReturns) // eslint-disable-next-line no-param-reassign
        propDef.jsDocTags = {
            params: hasParams && extractedTags.params.map(function(x) {
                return {
                    name: x.getPrettyName(),
                    description: x.description
                };
            }),
            returns: hasReturns && {
                description: extractedTags.returns.description
            }
        };
    }
    return propDef;
}
var javaScriptFactory = function javaScriptFactory(propName, docgenInfo, jsDocParsingResult) {
    var propDef = createBasicPropDef(propName, docgenInfo.type, docgenInfo);
    propDef.sbType = (0, _convert.convert)(docgenInfo);
    return applyJsDocResult(propDef, jsDocParsingResult);
};
var tsFactory = function tsFactory(propName, docgenInfo, jsDocParsingResult) {
    var propDef = (0, _createPropDef1.createTsPropDef)(propName, docgenInfo);
    propDef.sbType = (0, _convert.convert)(docgenInfo);
    return applyJsDocResult(propDef, jsDocParsingResult);
};
var flowFactory = function flowFactory(propName, docgenInfo, jsDocParsingResult) {
    var propDef = (0, _createPropDef.createFlowPropDef)(propName, docgenInfo);
    propDef.sbType = (0, _convert.convert)(docgenInfo);
    return applyJsDocResult(propDef, jsDocParsingResult);
};
var unknownFactory = function unknownFactory(propName, docgenInfo, jsDocParsingResult) {
    var propDef = createBasicPropDef(propName, {
        name: "unknown"
    }, docgenInfo);
    return applyJsDocResult(propDef, jsDocParsingResult);
};
var getPropDefFactory = function getPropDefFactory(typeSystem) {
    switch(typeSystem){
        case (0, _types.TypeSystem).JAVASCRIPT:
            return javaScriptFactory;
        case (0, _types.TypeSystem).TYPESCRIPT:
            return tsFactory;
        case (0, _types.TypeSystem).FLOW:
            return flowFactory;
        default:
            return unknownFactory;
    }
};

},{"core-js/modules/es.function.name.js":"4LiLL","core-js/modules/es.object.to-string.js":"lsA9p","core-js/modules/es.symbol.js":"ajw2f","core-js/modules/es.symbol.description.js":"wrlLc","core-js/modules/es.array.map.js":"jTP7e","./types":"aopd1","../utils":"fKvkw","./flow/createPropDef":"ikonQ","./utils/defaultValue":"8IgOj","./typeScript/createPropDef":"dtMYk","../convert":"eGTxe","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"fKvkw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MAX_TYPE_SUMMARY_LENGTH", ()=>MAX_TYPE_SUMMARY_LENGTH);
parcelHelpers.export(exports, "MAX_DEFAULT_VALUE_SUMMARY_LENGTH", ()=>MAX_DEFAULT_VALUE_SUMMARY_LENGTH);
parcelHelpers.export(exports, "isTooLongForTypeSummary", ()=>isTooLongForTypeSummary);
parcelHelpers.export(exports, "isTooLongForDefaultValueSummary", ()=>isTooLongForDefaultValueSummary);
parcelHelpers.export(exports, "createSummaryValue", ()=>createSummaryValue);
parcelHelpers.export(exports, "normalizeNewlines", ()=>normalizeNewlines);
var _esRegexpExecJs = require("core-js/modules/es.regexp.exec.js");
var _esStringReplaceJs = require("core-js/modules/es.string.replace.js");
var MAX_TYPE_SUMMARY_LENGTH = 90;
var MAX_DEFAULT_VALUE_SUMMARY_LENGTH = 50;
function isTooLongForTypeSummary(value) {
    return value.length > MAX_TYPE_SUMMARY_LENGTH;
}
function isTooLongForDefaultValueSummary(value) {
    return value.length > MAX_DEFAULT_VALUE_SUMMARY_LENGTH;
}
function createSummaryValue(summary, detail) {
    if (summary === detail) return {
        summary: summary
    };
    return {
        summary: summary,
        detail: detail
    };
}
var normalizeNewlines = function normalizeNewlines(string) {
    return string.replace(/\\r\\n/g, "\\n");
};

},{"core-js/modules/es.regexp.exec.js":"5q56v","core-js/modules/es.string.replace.js":"bFiJG","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"ikonQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createFlowPropDef", ()=>createFlowPropDef);
var _esSymbolJs = require("core-js/modules/es.symbol.js");
var _esSymbolDescriptionJs = require("core-js/modules/es.symbol.description.js");
var _createType = require("./createType");
var _createDefaultValue = require("./createDefaultValue");
var createFlowPropDef = function createFlowPropDef(propName, docgenInfo) {
    var flowType = docgenInfo.flowType, description = docgenInfo.description, required = docgenInfo.required, defaultValue = docgenInfo.defaultValue;
    return {
        name: propName,
        type: (0, _createType.createType)(flowType),
        required: required,
        description: description,
        defaultValue: (0, _createDefaultValue.createDefaultValue)(defaultValue, flowType)
    };
};

},{"core-js/modules/es.symbol.js":"ajw2f","core-js/modules/es.symbol.description.js":"wrlLc","./createType":"1vXZw","./createDefaultValue":"hAcAP","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"1vXZw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createType", ()=>createType);
var _esFunctionNameJs = require("core-js/modules/es.function.name.js");
var _esArrayJoinJs = require("core-js/modules/es.array.join.js");
var _esArrayMapJs = require("core-js/modules/es.array.map.js");
var _esRegexpExecJs = require("core-js/modules/es.regexp.exec.js");
var _esStringReplaceJs = require("core-js/modules/es.string.replace.js");
var _utils = require("../../utils");
var FlowTypesType;
(function(FlowTypesType) {
    FlowTypesType["UNION"] = "union";
    FlowTypesType["SIGNATURE"] = "signature";
})(FlowTypesType || (FlowTypesType = {}));
function generateUnionElement(_ref) {
    var name = _ref.name, value = _ref.value, elements = _ref.elements, raw = _ref.raw;
    if (value != null) return value;
    if (elements != null) return elements.map(generateUnionElement).join(" | ");
    if (raw != null) return raw;
    return name;
}
function generateUnion(_ref2) {
    var name = _ref2.name, raw = _ref2.raw, elements = _ref2.elements;
    if (elements != null) return (0, _utils.createSummaryValue)(elements.map(generateUnionElement).join(" | "));
    if (raw != null) // Flow Unions can be defined with or without a leading `|` character, so try to remove it.
    return (0, _utils.createSummaryValue)(raw.replace(/^\|\s*/, ""));
    return (0, _utils.createSummaryValue)(name);
}
function generateFuncSignature(_ref3) {
    var type = _ref3.type, raw = _ref3.raw;
    if (raw != null) return (0, _utils.createSummaryValue)(raw);
    return (0, _utils.createSummaryValue)(type);
}
function generateObjectSignature(_ref4) {
    var type = _ref4.type, raw = _ref4.raw;
    if (raw != null) return !(0, _utils.isTooLongForTypeSummary)(raw) ? (0, _utils.createSummaryValue)(raw) : (0, _utils.createSummaryValue)(type, raw);
    return (0, _utils.createSummaryValue)(type);
}
function generateSignature(flowType) {
    var type = flowType.type;
    return type === "object" ? generateObjectSignature(flowType) : generateFuncSignature(flowType);
}
function generateDefault(_ref5) {
    var name = _ref5.name, raw = _ref5.raw;
    if (raw != null) return !(0, _utils.isTooLongForTypeSummary)(raw) ? (0, _utils.createSummaryValue)(raw) : (0, _utils.createSummaryValue)(name, raw);
    return (0, _utils.createSummaryValue)(name);
}
function createType(type) {
    // A type could be null if a defaultProp has been provided without a type definition.
    if (type == null) return null;
    switch(type.name){
        case FlowTypesType.UNION:
            return generateUnion(type);
        case FlowTypesType.SIGNATURE:
            return generateSignature(type);
        default:
            return generateDefault(type);
    }
}

},{"core-js/modules/es.function.name.js":"4LiLL","core-js/modules/es.array.join.js":"1w71h","core-js/modules/es.array.map.js":"jTP7e","core-js/modules/es.regexp.exec.js":"5q56v","core-js/modules/es.string.replace.js":"bFiJG","../../utils":"fKvkw","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"hAcAP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createDefaultValue", ()=>createDefaultValue);
var _esFunctionNameJs = require("core-js/modules/es.function.name.js");
var _utils = require("../../utils");
var _defaultValue = require("../utils/defaultValue");
function createDefaultValue(defaultValue, type) {
    if (defaultValue != null) {
        var value = defaultValue.value;
        if (!(0, _defaultValue.isDefaultValueBlacklisted)(value)) return !(0, _utils.isTooLongForDefaultValueSummary)(value) ? (0, _utils.createSummaryValue)(value) : (0, _utils.createSummaryValue)(type.name, value);
    }
    return null;
}

},{"core-js/modules/es.function.name.js":"4LiLL","../../utils":"fKvkw","../utils/defaultValue":"8IgOj","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"dtMYk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createTsPropDef", ()=>createTsPropDef);
var _esSymbolJs = require("core-js/modules/es.symbol.js");
var _esSymbolDescriptionJs = require("core-js/modules/es.symbol.description.js");
var _createType = require("./createType");
var _createDefaultValue = require("./createDefaultValue");
var createTsPropDef = function createTsPropDef(propName, docgenInfo) {
    var description = docgenInfo.description, required = docgenInfo.required;
    return {
        name: propName,
        type: (0, _createType.createType)(docgenInfo),
        required: required,
        description: description,
        defaultValue: (0, _createDefaultValue.createDefaultValue)(docgenInfo)
    };
};

},{"core-js/modules/es.symbol.js":"ajw2f","core-js/modules/es.symbol.description.js":"wrlLc","./createType":"8MVLV","./createDefaultValue":"8ytOh","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"8MVLV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createType", ()=>createType);
var _esRegexpExecJs = require("core-js/modules/es.regexp.exec.js");
var _esStringReplaceJs = require("core-js/modules/es.string.replace.js");
var _esFunctionNameJs = require("core-js/modules/es.function.name.js");
var _utils = require("../../utils");
function createType(_ref) {
    var tsType = _ref.tsType, required = _ref.required;
    // A type could be null if a defaultProp has been provided without a type definition.
    if (tsType == null) return null;
    if (!required) return (0, _utils.createSummaryValue)(tsType.name.replace(" | undefined", ""));
    return (0, _utils.createSummaryValue)(tsType.name);
}

},{"core-js/modules/es.regexp.exec.js":"5q56v","core-js/modules/es.string.replace.js":"bFiJG","core-js/modules/es.function.name.js":"4LiLL","../../utils":"fKvkw","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"8ytOh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createDefaultValue", ()=>createDefaultValue);
var _utils = require("../../utils");
var _defaultValue = require("../utils/defaultValue");
function createDefaultValue(_ref) {
    var defaultValue = _ref.defaultValue;
    if (defaultValue != null) {
        var value = defaultValue.value;
        if (!(0, _defaultValue.isDefaultValueBlacklisted)(value)) return (0, _utils.createSummaryValue)(value);
    }
    return null;
}

},{"../../utils":"fKvkw","../utils/defaultValue":"8IgOj","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"4SHI7":[function(require,module,exports) {

},{}],"hYfqC":[function(require,module,exports) {

},{}],"6SQWf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "enhanceArgTypes", ()=>enhanceArgTypes);
var _store = require("@storybook/store");
var enhanceArgTypes = function enhanceArgTypes(context) {
    var component = context.component, userArgTypes = context.argTypes, _context$parameters$d = context.parameters.docs, docs = _context$parameters$d === void 0 ? {} : _context$parameters$d;
    var extractArgTypes = docs.extractArgTypes;
    var extractedArgTypes = extractArgTypes && component ? extractArgTypes(component) : {};
    var withExtractedTypes = extractedArgTypes ? (0, _store.combineParameters)(extractedArgTypes, userArgTypes) : userArgTypes;
    return withExtractedTypes;
};

},{"@storybook/store":"26Xer","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"c8f3q":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ADDON_ID", ()=>ADDON_ID);
parcelHelpers.export(exports, "PANEL_ID", ()=>PANEL_ID);
parcelHelpers.export(exports, "PARAM_KEY", ()=>PARAM_KEY);
parcelHelpers.export(exports, "SNIPPET_RENDERED", ()=>SNIPPET_RENDERED);
parcelHelpers.export(exports, "SourceType", ()=>SourceType);
var ADDON_ID = "storybook/docs";
var PANEL_ID = "".concat(ADDON_ID, "/panel");
var PARAM_KEY = "docs";
var SNIPPET_RENDERED = "".concat(ADDON_ID, "/snippet-rendered");
var SourceType;
(function(SourceType) {
    SourceType["AUTO"] = "auto";
    SourceType["CODE"] = "code";
    SourceType["DYNAMIC"] = "dynamic";
})(SourceType || (SourceType = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"dtHip":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "extractArgTypes", ()=>extractArgTypes);
var _esObjectToStringJs = require("core-js/modules/es.object.to-string.js");
var _esFunctionNameJs = require("core-js/modules/es.function.name.js");
var _esSymbolJs = require("core-js/modules/es.symbol.js");
var _esSymbolDescriptionJs = require("core-js/modules/es.symbol.description.js");
var _esObjectAssignJs = require("core-js/modules/es.object.assign.js");
var _extractProps = require("./extractProps");
var extractArgTypes = function extractArgTypes(component) {
    if (component) {
        var _extractProps1 = (0, _extractProps.extractProps)(component), rows = _extractProps1.rows;
        if (rows) return rows.reduce(function(acc, row) {
            var name = row.name, description = row.description, type = row.type, sbType = row.sbType, defaultSummary = row.defaultValue, jsDocTags = row.jsDocTags, required = row.required;
            acc[name] = {
                name: name,
                description: description,
                type: Object.assign({
                    required: required
                }, sbType),
                table: {
                    type: type,
                    jsDocTags: jsDocTags,
                    defaultValue: defaultSummary
                }
            };
            return acc;
        }, {});
    }
    return null;
};

},{"core-js/modules/es.object.to-string.js":"lsA9p","core-js/modules/es.function.name.js":"4LiLL","core-js/modules/es.symbol.js":"ajw2f","core-js/modules/es.symbol.description.js":"wrlLc","core-js/modules/es.object.assign.js":"8FU8M","./extractProps":"gjZzR","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"gjZzR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "extractProps", ()=>extractProps);
var _esArrayIteratorJs = require("core-js/modules/es.array.iterator.js");
var _esMapJs = require("core-js/modules/es.map.js");
var _esObjectToStringJs = require("core-js/modules/es.object.to-string.js");
var _esStringIteratorJs = require("core-js/modules/es.string.iterator.js");
var _webDomCollectionsIteratorJs = require("core-js/modules/web.dom-collections.iterator.js");
var _webDomCollectionsForEachJs = require("core-js/modules/web.dom-collections.for-each.js");
var _esObjectKeysJs = require("core-js/modules/es.object.keys.js");
var _esArrayMapJs = require("core-js/modules/es.array.map.js");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _docsTools = require("@storybook/docs-tools");
var _handleProp = require("./propTypes/handleProp");
var _handleProp1 = require("./typeScript/handleProp");
var _lib = require("./lib"); // FIXME
var propTypesMap = new Map();
Object.keys((0, _propTypesDefault.default)).forEach(function(typeName) {
    // @ts-ignore
    var type = (0, _propTypesDefault.default)[typeName];
    propTypesMap.set(type, typeName);
    propTypesMap.set(type.isRequired, typeName);
});
function getPropDefs(component, section) {
    var processedComponent = component; // eslint-disable-next-line react/forbid-foreign-prop-types
    if (!(0, _docsTools.hasDocgen)(component) && !component.propTypes && (0, _lib.isMemo)(component)) processedComponent = component.type;
    var extractedProps = (0, _docsTools.extractComponentProps)(processedComponent, section);
    if (extractedProps.length === 0) return [];
    switch(extractedProps[0].typeSystem){
        case (0, _docsTools.TypeSystem).JAVASCRIPT:
            return (0, _handleProp.enhancePropTypesProps)(extractedProps, component);
        case (0, _docsTools.TypeSystem).TYPESCRIPT:
            return (0, _handleProp1.enhanceTypeScriptProps)(extractedProps);
        default:
            return extractedProps.map(function(x) {
                return x.propDef;
            });
    }
}
var extractProps = function extractProps(component) {
    return {
        rows: getPropDefs(component, "props")
    };
};

},{"core-js/modules/es.array.iterator.js":"ieU20","core-js/modules/es.map.js":"bbbTA","core-js/modules/es.object.to-string.js":"lsA9p","core-js/modules/es.string.iterator.js":"74a8v","core-js/modules/web.dom-collections.iterator.js":"aXR96","core-js/modules/web.dom-collections.for-each.js":"iYT1M","core-js/modules/es.object.keys.js":"5Q2AT","core-js/modules/es.array.map.js":"jTP7e","prop-types":"kQxDz","@storybook/docs-tools":"c0Wnz","./propTypes/handleProp":"gAAM0","./typeScript/handleProp":"j7O5n","./lib":"1EkZw","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"gAAM0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "enhancePropTypesProp", ()=>enhancePropTypesProp);
parcelHelpers.export(exports, "enhancePropTypesProps", ()=>enhancePropTypesProps);
var _esArrayMapJs = require("core-js/modules/es.array.map.js");
var _esFunctionNameJs = require("core-js/modules/es.function.name.js");
var _createType = require("./createType");
var _defaultValues = require("../lib/defaultValues");
var _sortProps = require("./sortProps");
var _rawDefaultPropResolvers = require("./rawDefaultPropResolvers");
function enhancePropTypesProp(extractedProp, rawDefaultProp) {
    var propDef = extractedProp.propDef;
    var newtype = (0, _createType.createType)(extractedProp);
    if (newtype != null) propDef.type = newtype;
    var defaultValue = extractedProp.docgenInfo.defaultValue;
    if (defaultValue != null && defaultValue.value != null) {
        var newDefaultValue = (0, _defaultValues.createDefaultValue)(defaultValue.value);
        if (newDefaultValue != null) propDef.defaultValue = newDefaultValue;
    } else if (rawDefaultProp != null) {
        var _newDefaultValue = (0, _defaultValues.createDefaultValueFromRawDefaultProp)(rawDefaultProp, propDef, (0, _rawDefaultPropResolvers.rawDefaultPropTypeResolvers));
        if (_newDefaultValue != null) propDef.defaultValue = _newDefaultValue;
    }
    return propDef;
}
function enhancePropTypesProps(extractedProps, component) {
    var rawDefaultProps = component.defaultProps != null ? component.defaultProps : {};
    var enhancedProps = extractedProps.map(function(x) {
        return enhancePropTypesProp(x, rawDefaultProps[x.propDef.name]);
    });
    return (0, _sortProps.keepOriginalDefinitionOrder)(enhancedProps, component);
}

},{"core-js/modules/es.array.map.js":"jTP7e","core-js/modules/es.function.name.js":"4LiLL","./createType":"iYjFw","../lib/defaultValues":"kXKoJ","./sortProps":"iRLZl","./rawDefaultPropResolvers":"g5Ptv","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"iYjFw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createType", ()=>createType);
var _esFunctionNameJs = require("core-js/modules/es.function.name.js");
var _esRegexpExecJs = require("core-js/modules/es.regexp.exec.js");
var _esStringReplaceJs = require("core-js/modules/es.string.replace.js");
var _esStringSplitJs = require("core-js/modules/es.string.split.js");
var _esArrayJoinJs = require("core-js/modules/es.array.join.js");
var _esArrayMapJs = require("core-js/modules/es.array.map.js");
var _esObjectKeysJs = require("core-js/modules/es.object.keys.js");
var _esArrayConcatJs = require("core-js/modules/es.array.concat.js");
var _esObjectToStringJs = require("core-js/modules/es.object.to-string.js");
var _docsTools = require("@storybook/docs-tools");
var _generateFuncSignature = require("./generateFuncSignature");
var _lib = require("../lib");
var _inspection = require("../lib/inspection");
var MAX_FUNC_LENGTH = 150;
var PropTypesType;
(function(PropTypesType) {
    PropTypesType["CUSTOM"] = "custom";
    PropTypesType["ANY"] = "any";
    PropTypesType["FUNC"] = "func";
    PropTypesType["SHAPE"] = "shape";
    PropTypesType["OBJECT"] = "object";
    PropTypesType["INSTANCEOF"] = "instanceOf";
    PropTypesType["OBJECTOF"] = "objectOf";
    PropTypesType["UNION"] = "union";
    PropTypesType["ENUM"] = "enum";
    PropTypesType["ARRAYOF"] = "arrayOf";
    PropTypesType["ELEMENT"] = "element";
    PropTypesType["ELEMENTTYPE"] = "elementType";
    PropTypesType["NODE"] = "node";
})(PropTypesType || (PropTypesType = {}));
function createTypeDef(_ref) {
    var name = _ref.name, short = _ref.short, compact = _ref.compact, full = _ref.full, inferredType = _ref.inferredType;
    return {
        name: name,
        short: short,
        compact: compact,
        full: full != null ? full : short,
        inferredType: inferredType
    };
}
function cleanPropTypes(value) {
    return value.replace(/PropTypes./g, "").replace(/.isRequired/g, "");
}
function splitIntoLines(value) {
    return value.split(/\r?\n/);
}
function prettyObject(ast) {
    var compact = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    return cleanPropTypes((0, _lib.generateObjectCode)(ast, compact));
}
function prettyArray(ast) {
    var compact = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    return cleanPropTypes((0, _lib.generateCode)(ast, compact));
}
function getCaptionForInspectionType(type) {
    switch(type){
        case (0, _inspection.InspectionType).OBJECT:
            return 0, _lib.OBJECT_CAPTION;
        case (0, _inspection.InspectionType).ARRAY:
            return 0, _lib.ARRAY_CAPTION;
        case (0, _inspection.InspectionType).CLASS:
            return 0, _lib.CLASS_CAPTION;
        case (0, _inspection.InspectionType).FUNCTION:
            return 0, _lib.FUNCTION_CAPTION;
        case (0, _inspection.InspectionType).ELEMENT:
            return 0, _lib.ELEMENT_CAPTION;
        default:
            return 0, _lib.CUSTOM_CAPTION;
    }
}
function generateTypeFromString(value, originalTypeName) {
    var _inspectValue = (0, _inspection.inspectValue)(value), inferredType = _inspectValue.inferredType, ast = _inspectValue.ast;
    var type = inferredType.type;
    var short;
    var compact;
    var full;
    switch(type){
        case (0, _inspection.InspectionType).IDENTIFIER:
        case (0, _inspection.InspectionType).LITERAL:
            short = value;
            compact = value;
            break;
        case (0, _inspection.InspectionType).OBJECT:
            var _ref2 = inferredType, depth = _ref2.depth;
            short = (0, _lib.OBJECT_CAPTION);
            compact = depth === 1 ? prettyObject(ast, true) : null;
            full = prettyObject(ast);
            break;
        case (0, _inspection.InspectionType).ELEMENT:
            var _ref3 = inferredType, identifier = _ref3.identifier;
            short = identifier != null && !(0, _lib.isHtmlTag)(identifier) ? identifier : (0, _lib.ELEMENT_CAPTION);
            compact = splitIntoLines(value).length === 1 ? value : null;
            full = value;
            break;
        case (0, _inspection.InspectionType).ARRAY:
            var _ref4 = inferredType, _depth = _ref4.depth;
            short = (0, _lib.ARRAY_CAPTION);
            compact = _depth <= 2 ? prettyArray(ast, true) : null;
            full = prettyArray(ast);
            break;
        default:
            short = getCaptionForInspectionType(type);
            compact = splitIntoLines(value).length === 1 ? value : null;
            full = value;
            break;
    }
    return createTypeDef({
        name: originalTypeName,
        short: short,
        compact: compact,
        full: full,
        inferredType: type
    });
}
function generateCustom(_ref5) {
    var raw = _ref5.raw;
    if (raw != null) return generateTypeFromString(raw, PropTypesType.CUSTOM);
    return createTypeDef({
        name: PropTypesType.CUSTOM,
        short: (0, _lib.CUSTOM_CAPTION),
        compact: (0, _lib.CUSTOM_CAPTION)
    });
}
function generateFunc(extractedProp) {
    var jsDocTags = extractedProp.jsDocTags;
    if (jsDocTags != null) {
        if (jsDocTags.params != null || jsDocTags.returns != null) return createTypeDef({
            name: PropTypesType.FUNC,
            short: (0, _generateFuncSignature.generateShortFuncSignature)(jsDocTags.params, jsDocTags.returns),
            compact: null,
            full: (0, _generateFuncSignature.generateFuncSignature)(jsDocTags.params, jsDocTags.returns)
        });
    }
    return createTypeDef({
        name: PropTypesType.FUNC,
        short: (0, _lib.FUNCTION_CAPTION),
        compact: (0, _lib.FUNCTION_CAPTION)
    });
}
function generateShape(type, extractedProp) {
    var fields = Object.keys(type.value).map(function(key) {
        return "".concat(key, ": ").concat(generateType(type.value[key], extractedProp).full);
    }).join(", ");
    var _inspectValue2 = (0, _inspection.inspectValue)("{ ".concat(fields, " }")), inferredType = _inspectValue2.inferredType, ast = _inspectValue2.ast;
    var _ref6 = inferredType, depth = _ref6.depth;
    return createTypeDef({
        name: PropTypesType.SHAPE,
        short: (0, _lib.OBJECT_CAPTION),
        compact: depth === 1 && ast ? prettyObject(ast, true) : null,
        full: ast ? prettyObject(ast) : null
    });
}
function objectOf(of) {
    return "objectOf(".concat(of, ")");
}
function generateObjectOf(type, extractedProp) {
    var _generateType = generateType(type.value, extractedProp), short = _generateType.short, compact = _generateType.compact, full = _generateType.full;
    return createTypeDef({
        name: PropTypesType.OBJECTOF,
        short: objectOf(short),
        compact: compact != null ? objectOf(compact) : null,
        full: objectOf(full)
    });
}
function generateUnion(type, extractedProp) {
    if (Array.isArray(type.value)) {
        var values = type.value.reduce(function(acc, v) {
            var _generateType2 = generateType(v, extractedProp), short = _generateType2.short, compact = _generateType2.compact, full = _generateType2.full;
            acc.short.push(short);
            acc.compact.push(compact);
            acc.full.push(full);
            return acc;
        }, {
            short: [],
            compact: [],
            full: []
        });
        return createTypeDef({
            name: PropTypesType.UNION,
            short: values.short.join(" | "),
            compact: values.compact.every(function(x) {
                return x != null;
            }) ? values.compact.join(" | ") : null,
            full: values.full.join(" | ")
        });
    }
    return createTypeDef({
        name: PropTypesType.UNION,
        short: type.value,
        compact: null
    });
}
function generateEnumValue(_ref7) {
    var value = _ref7.value, computed = _ref7.computed;
    return computed ? generateTypeFromString(value, "enumvalue") : createTypeDef({
        name: "enumvalue",
        short: value,
        compact: value
    });
}
function generateEnum(type) {
    if (Array.isArray(type.value)) {
        var values = type.value.reduce(function(acc, v) {
            var _generateEnumValue = generateEnumValue(v), short = _generateEnumValue.short, compact = _generateEnumValue.compact, full = _generateEnumValue.full;
            acc.short.push(short);
            acc.compact.push(compact);
            acc.full.push(full);
            return acc;
        }, {
            short: [],
            compact: [],
            full: []
        });
        return createTypeDef({
            name: PropTypesType.ENUM,
            short: values.short.join(" | "),
            compact: values.compact.every(function(x) {
                return x != null;
            }) ? values.compact.join(" | ") : null,
            full: values.full.join(" | ")
        });
    }
    return createTypeDef({
        name: PropTypesType.ENUM,
        short: type.value,
        compact: type.value
    });
}
function braceAfter(of) {
    return "".concat(of, "[]");
}
function braceAround(of) {
    return "[".concat(of, "]");
}
function createArrayOfObjectTypeDef(short, compact, full) {
    return createTypeDef({
        name: PropTypesType.ARRAYOF,
        short: braceAfter(short),
        compact: compact != null ? braceAround(compact) : null,
        full: braceAround(full)
    });
}
function generateArray(type, extractedProp) {
    var _generateType3 = generateType(type.value, extractedProp), name = _generateType3.name, short = _generateType3.short, compact = _generateType3.compact, full = _generateType3.full, inferredType = _generateType3.inferredType;
    if (name === PropTypesType.CUSTOM) {
        if (inferredType === (0, _inspection.InspectionType).OBJECT) return createArrayOfObjectTypeDef(short, compact, full);
    } else if (name === PropTypesType.SHAPE) return createArrayOfObjectTypeDef(short, compact, full);
    return createTypeDef({
        name: PropTypesType.ARRAYOF,
        short: braceAfter(short),
        compact: braceAfter(short)
    });
}
function generateType(type, extractedProp) {
    try {
        switch(type.name){
            case PropTypesType.CUSTOM:
                return generateCustom(type);
            case PropTypesType.FUNC:
                return generateFunc(extractedProp);
            case PropTypesType.SHAPE:
                return generateShape(type, extractedProp);
            case PropTypesType.INSTANCEOF:
                return createTypeDef({
                    name: PropTypesType.INSTANCEOF,
                    short: type.value,
                    compact: type.value
                });
            case PropTypesType.OBJECTOF:
                return generateObjectOf(type, extractedProp);
            case PropTypesType.UNION:
                return generateUnion(type, extractedProp);
            case PropTypesType.ENUM:
                return generateEnum(type);
            case PropTypesType.ARRAYOF:
                return generateArray(type, extractedProp);
            default:
                return createTypeDef({
                    name: type.name,
                    short: type.name,
                    compact: type.name
                });
        }
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
    }
    return createTypeDef({
        name: "unknown",
        short: "unknown",
        compact: "unknown"
    });
}
function createType(extractedProp) {
    var type = extractedProp.docgenInfo.type; // A type could be null if a defaultProp has been provided without a type definition.
    if (type == null) return null;
    try {
        switch(type.name){
            case PropTypesType.CUSTOM:
            case PropTypesType.SHAPE:
            case PropTypesType.INSTANCEOF:
            case PropTypesType.OBJECTOF:
            case PropTypesType.UNION:
            case PropTypesType.ENUM:
            case PropTypesType.ARRAYOF:
                var _generateType4 = generateType(type, extractedProp), short = _generateType4.short, compact = _generateType4.compact, full = _generateType4.full;
                if (compact != null) {
                    if (!(0, _docsTools.isTooLongForTypeSummary)(compact)) return (0, _docsTools.createSummaryValue)(compact);
                }
                return (0, _docsTools.createSummaryValue)(short, full);
            case PropTypesType.FUNC:
                var _generateType5 = generateType(type, extractedProp), _short = _generateType5.short, _full = _generateType5.full;
                var summary = _short;
                var detail;
                if (_full.length < MAX_FUNC_LENGTH) summary = _full;
                else detail = (0, _generateFuncSignature.toMultilineSignature)(_full);
                return (0, _docsTools.createSummaryValue)(summary, detail);
            default:
                return null;
        }
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
    }
    return null;
}

},{"core-js/modules/es.function.name.js":"4LiLL","core-js/modules/es.regexp.exec.js":"5q56v","core-js/modules/es.string.replace.js":"bFiJG","core-js/modules/es.string.split.js":"12go2","core-js/modules/es.array.join.js":"1w71h","core-js/modules/es.array.map.js":"jTP7e","core-js/modules/es.object.keys.js":"5Q2AT","core-js/modules/es.array.concat.js":"g1t7q","core-js/modules/es.object.to-string.js":"lsA9p","@storybook/docs-tools":"c0Wnz","./generateFuncSignature":"e0JY1","../lib":"1EkZw","../lib/inspection":"g7DSz","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"e0JY1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "generateFuncSignature", ()=>generateFuncSignature);
parcelHelpers.export(exports, "generateShortFuncSignature", ()=>generateShortFuncSignature);
parcelHelpers.export(exports, "toMultilineSignature", ()=>toMultilineSignature);
var _esArrayMapJs = require("core-js/modules/es.array.map.js");
var _esArrayConcatJs = require("core-js/modules/es.array.concat.js");
var _esArrayJoinJs = require("core-js/modules/es.array.join.js");
var _esRegexpExecJs = require("core-js/modules/es.regexp.exec.js");
var _esStringReplaceJs = require("core-js/modules/es.string.replace.js");
function generateFuncSignature(params, returns) {
    var hasParams = params != null;
    var hasReturns = returns != null;
    if (!hasParams && !hasReturns) return "";
    var funcParts = [];
    if (hasParams) {
        var funcParams = params.map(function(x) {
            var prettyName = x.getPrettyName();
            var typeName = x.getTypeName();
            if (typeName != null) return "".concat(prettyName, ": ").concat(typeName);
            return prettyName;
        });
        funcParts.push("(".concat(funcParams.join(", "), ")"));
    } else funcParts.push("()");
    if (hasReturns) funcParts.push("=> ".concat(returns.getTypeName()));
    return funcParts.join(" ");
}
function generateShortFuncSignature(params, returns) {
    var hasParams = params != null;
    var hasReturns = returns != null;
    if (!hasParams && !hasReturns) return "";
    var funcParts = [];
    if (hasParams) funcParts.push("( ... )");
    else funcParts.push("()");
    if (hasReturns) funcParts.push("=> ".concat(returns.getTypeName()));
    return funcParts.join(" ");
}
function toMultilineSignature(signature) {
    return signature.replace(/,/g, ",\r\n");
}

},{"core-js/modules/es.array.map.js":"jTP7e","core-js/modules/es.array.concat.js":"g1t7q","core-js/modules/es.array.join.js":"1w71h","core-js/modules/es.regexp.exec.js":"5q56v","core-js/modules/es.string.replace.js":"bFiJG","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"1EkZw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _captions = require("./captions");
parcelHelpers.exportAll(_captions, exports);
var _isHtmlTag = require("./isHtmlTag");
parcelHelpers.exportAll(_isHtmlTag, exports);
var _generateCode = require("./generateCode");
parcelHelpers.exportAll(_generateCode, exports);
var _componentTypes = require("./componentTypes");
parcelHelpers.exportAll(_componentTypes, exports);

},{"./captions":"2JqpQ","./isHtmlTag":"52X8w","./generateCode":"jxt4Z","./componentTypes":"6nTsv","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"2JqpQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CUSTOM_CAPTION", ()=>CUSTOM_CAPTION);
parcelHelpers.export(exports, "OBJECT_CAPTION", ()=>OBJECT_CAPTION);
parcelHelpers.export(exports, "ARRAY_CAPTION", ()=>ARRAY_CAPTION);
parcelHelpers.export(exports, "CLASS_CAPTION", ()=>CLASS_CAPTION);
parcelHelpers.export(exports, "FUNCTION_CAPTION", ()=>FUNCTION_CAPTION);
parcelHelpers.export(exports, "ELEMENT_CAPTION", ()=>ELEMENT_CAPTION);
var CUSTOM_CAPTION = "custom";
var OBJECT_CAPTION = "object";
var ARRAY_CAPTION = "array";
var CLASS_CAPTION = "class";
var FUNCTION_CAPTION = "func";
var ELEMENT_CAPTION = "element";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"52X8w":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isHtmlTag", ()=>isHtmlTag);
var _esArrayIncludesJs = require("core-js/modules/es.array.includes.js");
var _esStringIncludesJs = require("core-js/modules/es.string.includes.js");
var _htmlTags = require("html-tags");
var _htmlTagsDefault = parcelHelpers.interopDefault(_htmlTags);
function isHtmlTag(tagName) {
    return (0, _htmlTagsDefault.default).includes(tagName.toLowerCase());
}

},{"core-js/modules/es.array.includes.js":"dbUjS","core-js/modules/es.string.includes.js":"cx9ET","html-tags":"8he8M","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"8he8M":[function(require,module,exports) {
"use strict";
module.exports = require("6c9bf1ded7f8a5a1");

},{"6c9bf1ded7f8a5a1":"4WPJC"}],"4WPJC":[function(require,module,exports) {
module.exports = JSON.parse('["a","abbr","address","area","article","aside","audio","b","base","bdi","bdo","blockquote","body","br","button","canvas","caption","cite","code","col","colgroup","data","datalist","dd","del","details","dfn","dialog","div","dl","dt","em","embed","fieldset","figcaption","figure","footer","form","h1","h2","h3","h4","h5","h6","head","header","hgroup","hr","html","i","iframe","img","input","ins","kbd","label","legend","li","link","main","map","mark","math","menu","menuitem","meta","meter","nav","noscript","object","ol","optgroup","option","output","p","param","picture","pre","progress","q","rb","rp","rt","rtc","ruby","s","samp","script","section","select","slot","small","source","span","strong","style","sub","summary","sup","svg","table","tbody","td","template","textarea","tfoot","th","thead","time","title","tr","track","u","ul","var","video","wbr"]');

},{}],"jxt4Z":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "generateCode", ()=>generateCode);
parcelHelpers.export(exports, "generateObjectCode", ()=>generateObjectCode);
parcelHelpers.export(exports, "generateArrayCode", ()=>generateArrayCode);
var _esObjectAssignJs = require("core-js/modules/es.object.assign.js");
var _esStringEndsWithJs = require("core-js/modules/es.string.ends-with.js");
var _esArraySliceJs = require("core-js/modules/es.array.slice.js");
var _esStringStartsWithJs = require("core-js/modules/es.string.starts-with.js");
var _esRegexpExecJs = require("core-js/modules/es.regexp.exec.js");
var _esStringReplaceJs = require("core-js/modules/es.string.replace.js");
var _escodegen = require("escodegen");
var _tsDedent = require("ts-dedent");
var _tsDedentDefault = parcelHelpers.interopDefault(_tsDedent);
var BASIC_OPTIONS = {
    format: {
        indent: {
            style: "  "
        },
        semicolons: false
    }
};
var COMPACT_OPTIONS = Object.assign({}, BASIC_OPTIONS, {
    format: {
        newline: ""
    }
});
var PRETTY_OPTIONS = Object.assign({}, BASIC_OPTIONS);
function generateCode(ast) {
    var compact = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    return (0, _escodegen.generate)(ast, compact ? COMPACT_OPTIONS : PRETTY_OPTIONS);
}
function generateObjectCode(ast) {
    var compact = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    return !compact ? generateCode(ast) : generateCompactObjectCode(ast);
}
function generateCompactObjectCode(ast) {
    var result = generateCode(ast, true); // Cannot get escodegen to add a space before the last } with the compact mode settings.
    // Fix it until a better solution is found.
    if (!result.endsWith(" }")) result = "".concat(result.slice(0, -1), " }");
    return result;
}
function generateArrayCode(ast) {
    var compact = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    return !compact ? generateMultilineArrayCode(ast) : generateCompactArrayCode(ast);
}
function generateMultilineArrayCode(ast) {
    var result = generateCode(ast); // escodegen add extra spacing before the closing bracket of a multiple line array with a nested object.
    // Fix it until a better solution is found.
    if (result.endsWith("  }]")) result = (0, _tsDedentDefault.default)(result);
    return result;
}
function generateCompactArrayCode(ast) {
    var result = generateCode(ast, true); // escodegen add extra an extra before the opening bracket of a compact array that contains primitive values.
    // Fix it until a better solution is found.
    if (result.startsWith("[    ")) result = result.replace("[    ", "[");
    return result;
}

},{"core-js/modules/es.object.assign.js":"8FU8M","core-js/modules/es.string.ends-with.js":"6TCKi","core-js/modules/es.array.slice.js":"8RRh9","core-js/modules/es.string.starts-with.js":"90lFR","core-js/modules/es.regexp.exec.js":"5q56v","core-js/modules/es.string.replace.js":"bFiJG","escodegen":"cF75R","ts-dedent":"9RvVa","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"cF75R":[function(require,module,exports) {
var global = arguments[3];
/*
  Copyright (C) 2012-2014 Yusuke Suzuki <utatane.tea@gmail.com>
  Copyright (C) 2015 Ingvar Stepanyan <me@rreverser.com>
  Copyright (C) 2014 Ivan Nikulin <ifaaan@gmail.com>
  Copyright (C) 2012-2013 Michael Ficarra <escodegen.copyright@michael.ficarra.me>
  Copyright (C) 2012-2013 Mathias Bynens <mathias@qiwi.be>
  Copyright (C) 2013 Irakli Gozalishvili <rfobic@gmail.com>
  Copyright (C) 2012 Robert Gust-Bardon <donate@robert.gust-bardon.org>
  Copyright (C) 2012 John Freeman <jfreeman08@gmail.com>
  Copyright (C) 2011-2012 Ariya Hidayat <ariya.hidayat@gmail.com>
  Copyright (C) 2012 Joost-Wim Boekesteijn <joost-wim@boekesteijn.nl>
  Copyright (C) 2012 Kris Kowal <kris.kowal@cixar.com>
  Copyright (C) 2012 Arpad Borsos <arpad.borsos@googlemail.com>

  Redistribution and use in source and binary forms, with or without
  modification, are permitted provided that the following conditions are met:

    * Redistributions of source code must retain the above copyright
      notice, this list of conditions and the following disclaimer.
    * Redistributions in binary form must reproduce the above copyright
      notice, this list of conditions and the following disclaimer in the
      documentation and/or other materials provided with the distribution.

  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
  AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
  IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
  ARE DISCLAIMED. IN NO EVENT SHALL <COPYRIGHT HOLDER> BE LIABLE FOR ANY
  DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
  (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
  LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
  ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
  (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF
  THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/ /*global exports:true, require:true, global:true*/ (function() {
    "use strict";
    var Syntax, Precedence, BinaryPrecedence, SourceNode, estraverse, esutils, base, indent, json, renumber, hexadecimal, quotes, escapeless, newline, space, parentheses, semicolons, safeConcatenation, directive, extra, parse, sourceMap, sourceCode, preserveBlankLines, FORMAT_MINIFY, FORMAT_DEFAULTS;
    estraverse = require("799f69c44c76494b");
    esutils = require("860044db75801fad");
    Syntax = estraverse.Syntax;
    // Generation is done by generateExpression.
    function isExpression(node) {
        return CodeGenerator.Expression.hasOwnProperty(node.type);
    }
    // Generation is done by generateStatement.
    function isStatement(node) {
        return CodeGenerator.Statement.hasOwnProperty(node.type);
    }
    Precedence = {
        Sequence: 0,
        Yield: 1,
        Assignment: 1,
        Conditional: 2,
        ArrowFunction: 2,
        LogicalOR: 3,
        LogicalAND: 4,
        BitwiseOR: 5,
        BitwiseXOR: 6,
        BitwiseAND: 7,
        Equality: 8,
        Relational: 9,
        BitwiseSHIFT: 10,
        Additive: 11,
        Multiplicative: 12,
        Exponentiation: 13,
        Await: 14,
        Unary: 14,
        Postfix: 15,
        OptionalChaining: 16,
        Call: 17,
        New: 18,
        TaggedTemplate: 19,
        Member: 20,
        Primary: 21
    };
    BinaryPrecedence = {
        "||": Precedence.LogicalOR,
        "&&": Precedence.LogicalAND,
        "|": Precedence.BitwiseOR,
        "^": Precedence.BitwiseXOR,
        "&": Precedence.BitwiseAND,
        "==": Precedence.Equality,
        "!=": Precedence.Equality,
        "===": Precedence.Equality,
        "!==": Precedence.Equality,
        "is": Precedence.Equality,
        "isnt": Precedence.Equality,
        "<": Precedence.Relational,
        ">": Precedence.Relational,
        "<=": Precedence.Relational,
        ">=": Precedence.Relational,
        "in": Precedence.Relational,
        "instanceof": Precedence.Relational,
        "<<": Precedence.BitwiseSHIFT,
        ">>": Precedence.BitwiseSHIFT,
        ">>>": Precedence.BitwiseSHIFT,
        "+": Precedence.Additive,
        "-": Precedence.Additive,
        "*": Precedence.Multiplicative,
        "%": Precedence.Multiplicative,
        "/": Precedence.Multiplicative,
        "**": Precedence.Exponentiation
    };
    //Flags
    var F_ALLOW_IN = 1, F_ALLOW_CALL = 2, F_ALLOW_UNPARATH_NEW = 4, F_FUNC_BODY = 8, F_DIRECTIVE_CTX = 16, F_SEMICOLON_OPT = 32;
    //Expression flag sets
    //NOTE: Flag order:
    // F_ALLOW_IN
    // F_ALLOW_CALL
    // F_ALLOW_UNPARATH_NEW
    var E_FTT = F_ALLOW_CALL | F_ALLOW_UNPARATH_NEW, E_TTF = F_ALLOW_IN | F_ALLOW_CALL, E_TTT = F_ALLOW_IN | F_ALLOW_CALL | F_ALLOW_UNPARATH_NEW, E_TFF = F_ALLOW_IN, E_FFT = F_ALLOW_UNPARATH_NEW, E_TFT = F_ALLOW_IN | F_ALLOW_UNPARATH_NEW;
    //Statement flag sets
    //NOTE: Flag order:
    // F_ALLOW_IN
    // F_FUNC_BODY
    // F_DIRECTIVE_CTX
    // F_SEMICOLON_OPT
    var S_TFFF = F_ALLOW_IN, S_TFFT = F_ALLOW_IN | F_SEMICOLON_OPT, S_FFFF = 0x00, S_TFTF = F_ALLOW_IN | F_DIRECTIVE_CTX, S_TTFF = F_ALLOW_IN | F_FUNC_BODY;
    function getDefaultOptions() {
        // default options
        return {
            indent: null,
            base: null,
            parse: null,
            comment: false,
            format: {
                indent: {
                    style: "    ",
                    base: 0,
                    adjustMultilineComment: false
                },
                newline: "\n",
                space: " ",
                json: false,
                renumber: false,
                hexadecimal: false,
                quotes: "single",
                escapeless: false,
                compact: false,
                parentheses: true,
                semicolons: true,
                safeConcatenation: false,
                preserveBlankLines: false
            },
            moz: {
                comprehensionExpressionStartsWithAssignment: false,
                starlessGenerator: false
            },
            sourceMap: null,
            sourceMapRoot: null,
            sourceMapWithCode: false,
            directive: false,
            raw: true,
            verbatim: null,
            sourceCode: null
        };
    }
    function stringRepeat(str, num) {
        var result = "";
        for(num |= 0; num > 0; num >>>= 1, str += str)if (num & 1) result += str;
        return result;
    }
    function hasLineTerminator(str) {
        return /[\r\n]/g.test(str);
    }
    function endsWithLineTerminator(str) {
        var len = str.length;
        return len && esutils.code.isLineTerminator(str.charCodeAt(len - 1));
    }
    function merge(target, override) {
        var key;
        for(key in override)if (override.hasOwnProperty(key)) target[key] = override[key];
        return target;
    }
    function updateDeeply(target, override) {
        var key, val;
        function isHashObject(target) {
            return typeof target === "object" && target instanceof Object && !(target instanceof RegExp);
        }
        for(key in override)if (override.hasOwnProperty(key)) {
            val = override[key];
            if (isHashObject(val)) {
                if (isHashObject(target[key])) updateDeeply(target[key], val);
                else target[key] = updateDeeply({}, val);
            } else target[key] = val;
        }
        return target;
    }
    function generateNumber(value) {
        var result, point, temp, exponent, pos;
        if (value !== value) throw new Error("Numeric literal whose value is NaN");
        if (value < 0 || value === 0 && 1 / value < 0) throw new Error("Numeric literal whose value is negative");
        if (value === 1 / 0) return json ? "null" : renumber ? "1e400" : "1e+400";
        result = "" + value;
        if (!renumber || result.length < 3) return result;
        point = result.indexOf(".");
        if (!json && result.charCodeAt(0) === 0x30 /* 0 */  && point === 1) {
            point = 0;
            result = result.slice(1);
        }
        temp = result;
        result = result.replace("e+", "e");
        exponent = 0;
        if ((pos = temp.indexOf("e")) > 0) {
            exponent = +temp.slice(pos + 1);
            temp = temp.slice(0, pos);
        }
        if (point >= 0) {
            exponent -= temp.length - point - 1;
            temp = +(temp.slice(0, point) + temp.slice(point + 1)) + "";
        }
        pos = 0;
        while(temp.charCodeAt(temp.length + pos - 1) === 0x30 /* 0 */ )--pos;
        if (pos !== 0) {
            exponent -= pos;
            temp = temp.slice(0, pos);
        }
        if (exponent !== 0) temp += "e" + exponent;
        if ((temp.length < result.length || hexadecimal && value > 1e12 && Math.floor(value) === value && (temp = "0x" + value.toString(16)).length < result.length) && +temp === value) result = temp;
        return result;
    }
    // Generate valid RegExp expression.
    // This function is based on https://github.com/Constellation/iv Engine
    function escapeRegExpCharacter(ch, previousIsBackslash) {
        // not handling '\' and handling \u2028 or \u2029 to unicode escape sequence
        if ((ch & -2) === 0x2028) return (previousIsBackslash ? "u" : "\\u") + (ch === 0x2028 ? "2028" : "2029");
        else if (ch === 10 || ch === 13) return (previousIsBackslash ? "" : "\\") + (ch === 10 ? "n" : "r");
        return String.fromCharCode(ch);
    }
    function generateRegExp(reg) {
        var match, result, flags, i, iz, ch, characterInBrack, previousIsBackslash;
        result = reg.toString();
        if (reg.source) {
            // extract flag from toString result
            match = result.match(/\/([^/]*)$/);
            if (!match) return result;
            flags = match[1];
            result = "";
            characterInBrack = false;
            previousIsBackslash = false;
            for(i = 0, iz = reg.source.length; i < iz; ++i){
                ch = reg.source.charCodeAt(i);
                if (!previousIsBackslash) {
                    if (characterInBrack) {
                        if (ch === 93) characterInBrack = false;
                    } else {
                        if (ch === 47) result += "\\";
                        else if (ch === 91) characterInBrack = true;
                    }
                    result += escapeRegExpCharacter(ch, previousIsBackslash);
                    previousIsBackslash = ch === 92; // \
                } else {
                    // if new RegExp("\\\n') is provided, create /\n/
                    result += escapeRegExpCharacter(ch, previousIsBackslash);
                    // prevent like /\\[/]/
                    previousIsBackslash = false;
                }
            }
            return "/" + result + "/" + flags;
        }
        return result;
    }
    function escapeAllowedCharacter(code, next) {
        var hex;
        if (code === 0x08 /* \b */ ) return "\\b";
        if (code === 0x0C /* \f */ ) return "\\f";
        if (code === 0x09 /* \t */ ) return "\\t";
        hex = code.toString(16).toUpperCase();
        if (json || code > 0xFF) return "\\u" + "0000".slice(hex.length) + hex;
        else if (code === 0x0000 && !esutils.code.isDecimalDigit(next)) return "\\0";
        else if (code === 0x000B /* \v */ ) return "\\x0B";
        else return "\\x" + "00".slice(hex.length) + hex;
    }
    function escapeDisallowedCharacter(code) {
        if (code === 0x5C /* \ */ ) return "\\\\";
        if (code === 0x0A /* \n */ ) return "\\n";
        if (code === 0x0D /* \r */ ) return "\\r";
        if (code === 0x2028) return "\\u2028";
        if (code === 0x2029) return "\\u2029";
        throw new Error("Incorrectly classified character");
    }
    function escapeDirective(str) {
        var i, iz, code, quote;
        quote = quotes === "double" ? '"' : "'";
        for(i = 0, iz = str.length; i < iz; ++i){
            code = str.charCodeAt(i);
            if (code === 0x27 /* ' */ ) {
                quote = '"';
                break;
            } else if (code === 0x22 /* " */ ) {
                quote = "'";
                break;
            } else if (code === 0x5C /* \ */ ) ++i;
        }
        return quote + str + quote;
    }
    function escapeString(str) {
        var result = "", i, len, code, singleQuotes = 0, doubleQuotes = 0, single, quote;
        for(i = 0, len = str.length; i < len; ++i){
            code = str.charCodeAt(i);
            if (code === 0x27 /* ' */ ) ++singleQuotes;
            else if (code === 0x22 /* " */ ) ++doubleQuotes;
            else if (code === 0x2F /* / */  && json) result += "\\";
            else if (esutils.code.isLineTerminator(code) || code === 0x5C /* \ */ ) {
                result += escapeDisallowedCharacter(code);
                continue;
            } else if (!esutils.code.isIdentifierPartES5(code) && (json && code < 0x20 /* SP */  || !json && !escapeless && (code < 0x20 /* SP */  || code > 0x7E /* ~ */ ))) {
                result += escapeAllowedCharacter(code, str.charCodeAt(i + 1));
                continue;
            }
            result += String.fromCharCode(code);
        }
        single = !(quotes === "double" || quotes === "auto" && doubleQuotes < singleQuotes);
        quote = single ? "'" : '"';
        if (!(single ? singleQuotes : doubleQuotes)) return quote + result + quote;
        str = result;
        result = quote;
        for(i = 0, len = str.length; i < len; ++i){
            code = str.charCodeAt(i);
            if (code === 0x27 /* ' */  && single || code === 0x22 /* " */  && !single) result += "\\";
            result += String.fromCharCode(code);
        }
        return result + quote;
    }
    /**
     * flatten an array to a string, where the array can contain
     * either strings or nested arrays
     */ function flattenToString(arr) {
        var i, iz, elem, result = "";
        for(i = 0, iz = arr.length; i < iz; ++i){
            elem = arr[i];
            result += Array.isArray(elem) ? flattenToString(elem) : elem;
        }
        return result;
    }
    /**
     * convert generated to a SourceNode when source maps are enabled.
     */ function toSourceNodeWhenNeeded(generated, node) {
        if (!sourceMap) {
            // with no source maps, generated is either an
            // array or a string.  if an array, flatten it.
            // if a string, just return it
            if (Array.isArray(generated)) return flattenToString(generated);
            else return generated;
        }
        if (node == null) {
            if (generated instanceof SourceNode) return generated;
            else node = {};
        }
        if (node.loc == null) return new SourceNode(null, null, sourceMap, generated, node.name || null);
        return new SourceNode(node.loc.start.line, node.loc.start.column, sourceMap === true ? node.loc.source || null : sourceMap, generated, node.name || null);
    }
    function noEmptySpace() {
        return space ? space : " ";
    }
    function join(left, right) {
        var leftSource, rightSource, leftCharCode, rightCharCode;
        leftSource = toSourceNodeWhenNeeded(left).toString();
        if (leftSource.length === 0) return [
            right
        ];
        rightSource = toSourceNodeWhenNeeded(right).toString();
        if (rightSource.length === 0) return [
            left
        ];
        leftCharCode = leftSource.charCodeAt(leftSource.length - 1);
        rightCharCode = rightSource.charCodeAt(0);
        if ((leftCharCode === 0x2B /* + */  || leftCharCode === 0x2D /* - */ ) && leftCharCode === rightCharCode || esutils.code.isIdentifierPartES5(leftCharCode) && esutils.code.isIdentifierPartES5(rightCharCode) || leftCharCode === 0x2F /* / */  && rightCharCode === 0x69 /* i */ ) return [
            left,
            noEmptySpace(),
            right
        ];
        else if (esutils.code.isWhiteSpace(leftCharCode) || esutils.code.isLineTerminator(leftCharCode) || esutils.code.isWhiteSpace(rightCharCode) || esutils.code.isLineTerminator(rightCharCode)) return [
            left,
            right
        ];
        return [
            left,
            space,
            right
        ];
    }
    function addIndent(stmt) {
        return [
            base,
            stmt
        ];
    }
    function withIndent(fn) {
        var previousBase;
        previousBase = base;
        base += indent;
        fn(base);
        base = previousBase;
    }
    function calculateSpaces(str) {
        var i;
        for(i = str.length - 1; i >= 0; --i){
            if (esutils.code.isLineTerminator(str.charCodeAt(i))) break;
        }
        return str.length - 1 - i;
    }
    function adjustMultilineComment(value, specialBase) {
        var array, i, len, line, j, spaces, previousBase, sn;
        array = value.split(/\r\n|[\r\n]/);
        spaces = Number.MAX_VALUE;
        // first line doesn't have indentation
        for(i = 1, len = array.length; i < len; ++i){
            line = array[i];
            j = 0;
            while(j < line.length && esutils.code.isWhiteSpace(line.charCodeAt(j)))++j;
            if (spaces > j) spaces = j;
        }
        if (typeof specialBase !== "undefined") {
            // pattern like
            // {
            //   var t = 20;  /*
            //                 * this is comment
            //                 */
            // }
            previousBase = base;
            if (array[1][spaces] === "*") specialBase += " ";
            base = specialBase;
        } else {
            if (spaces & 1) // /*
            //  *
            //  */
            // If spaces are odd number, above pattern is considered.
            // We waste 1 space.
            --spaces;
            previousBase = base;
        }
        for(i = 1, len = array.length; i < len; ++i){
            sn = toSourceNodeWhenNeeded(addIndent(array[i].slice(spaces)));
            array[i] = sourceMap ? sn.join("") : sn;
        }
        base = previousBase;
        return array.join("\n");
    }
    function generateComment(comment, specialBase) {
        if (comment.type === "Line") {
            if (endsWithLineTerminator(comment.value)) return "//" + comment.value;
            else {
                // Always use LineTerminator
                var result = "//" + comment.value;
                if (!preserveBlankLines) result += "\n";
                return result;
            }
        }
        if (extra.format.indent.adjustMultilineComment && /[\n\r]/.test(comment.value)) return adjustMultilineComment("/*" + comment.value + "*/", specialBase);
        return "/*" + comment.value + "*/";
    }
    function addComments(stmt, result) {
        var i, len, comment, save, tailingToStatement, specialBase, fragment, extRange, range, prevRange, prefix, infix, suffix, count;
        if (stmt.leadingComments && stmt.leadingComments.length > 0) {
            save = result;
            if (preserveBlankLines) {
                comment = stmt.leadingComments[0];
                result = [];
                extRange = comment.extendedRange;
                range = comment.range;
                prefix = sourceCode.substring(extRange[0], range[0]);
                count = (prefix.match(/\n/g) || []).length;
                if (count > 0) {
                    result.push(stringRepeat("\n", count));
                    result.push(addIndent(generateComment(comment)));
                } else {
                    result.push(prefix);
                    result.push(generateComment(comment));
                }
                prevRange = range;
                for(i = 1, len = stmt.leadingComments.length; i < len; i++){
                    comment = stmt.leadingComments[i];
                    range = comment.range;
                    infix = sourceCode.substring(prevRange[1], range[0]);
                    count = (infix.match(/\n/g) || []).length;
                    result.push(stringRepeat("\n", count));
                    result.push(addIndent(generateComment(comment)));
                    prevRange = range;
                }
                suffix = sourceCode.substring(range[1], extRange[1]);
                count = (suffix.match(/\n/g) || []).length;
                result.push(stringRepeat("\n", count));
            } else {
                comment = stmt.leadingComments[0];
                result = [];
                if (safeConcatenation && stmt.type === Syntax.Program && stmt.body.length === 0) result.push("\n");
                result.push(generateComment(comment));
                if (!endsWithLineTerminator(toSourceNodeWhenNeeded(result).toString())) result.push("\n");
                for(i = 1, len = stmt.leadingComments.length; i < len; ++i){
                    comment = stmt.leadingComments[i];
                    fragment = [
                        generateComment(comment)
                    ];
                    if (!endsWithLineTerminator(toSourceNodeWhenNeeded(fragment).toString())) fragment.push("\n");
                    result.push(addIndent(fragment));
                }
            }
            result.push(addIndent(save));
        }
        if (stmt.trailingComments) {
            if (preserveBlankLines) {
                comment = stmt.trailingComments[0];
                extRange = comment.extendedRange;
                range = comment.range;
                prefix = sourceCode.substring(extRange[0], range[0]);
                count = (prefix.match(/\n/g) || []).length;
                if (count > 0) {
                    result.push(stringRepeat("\n", count));
                    result.push(addIndent(generateComment(comment)));
                } else {
                    result.push(prefix);
                    result.push(generateComment(comment));
                }
            } else {
                tailingToStatement = !endsWithLineTerminator(toSourceNodeWhenNeeded(result).toString());
                specialBase = stringRepeat(" ", calculateSpaces(toSourceNodeWhenNeeded([
                    base,
                    result,
                    indent
                ]).toString()));
                for(i = 0, len = stmt.trailingComments.length; i < len; ++i){
                    comment = stmt.trailingComments[i];
                    if (tailingToStatement) {
                        // We assume target like following script
                        //
                        // var t = 20;  /**
                        //               * This is comment of t
                        //               */
                        if (i === 0) // first case
                        result = [
                            result,
                            indent
                        ];
                        else result = [
                            result,
                            specialBase
                        ];
                        result.push(generateComment(comment, specialBase));
                    } else result = [
                        result,
                        addIndent(generateComment(comment))
                    ];
                    if (i !== len - 1 && !endsWithLineTerminator(toSourceNodeWhenNeeded(result).toString())) result = [
                        result,
                        "\n"
                    ];
                }
            }
        }
        return result;
    }
    function generateBlankLines(start, end, result) {
        var j, newlineCount = 0;
        for(j = start; j < end; j++)if (sourceCode[j] === "\n") newlineCount++;
        for(j = 1; j < newlineCount; j++)result.push(newline);
    }
    function parenthesize(text, current, should) {
        if (current < should) return [
            "(",
            text,
            ")"
        ];
        return text;
    }
    function generateVerbatimString(string) {
        var i, iz, result;
        result = string.split(/\r\n|\n/);
        for(i = 1, iz = result.length; i < iz; i++)result[i] = newline + base + result[i];
        return result;
    }
    function generateVerbatim(expr, precedence) {
        var verbatim, result, prec;
        verbatim = expr[extra.verbatim];
        if (typeof verbatim === "string") result = parenthesize(generateVerbatimString(verbatim), Precedence.Sequence, precedence);
        else {
            // verbatim is object
            result = generateVerbatimString(verbatim.content);
            prec = verbatim.precedence != null ? verbatim.precedence : Precedence.Sequence;
            result = parenthesize(result, prec, precedence);
        }
        return toSourceNodeWhenNeeded(result, expr);
    }
    function CodeGenerator() {}
    // Helpers.
    CodeGenerator.prototype.maybeBlock = function(stmt, flags) {
        var result, noLeadingComment, that = this;
        noLeadingComment = !extra.comment || !stmt.leadingComments;
        if (stmt.type === Syntax.BlockStatement && noLeadingComment) return [
            space,
            this.generateStatement(stmt, flags)
        ];
        if (stmt.type === Syntax.EmptyStatement && noLeadingComment) return ";";
        withIndent(function() {
            result = [
                newline,
                addIndent(that.generateStatement(stmt, flags))
            ];
        });
        return result;
    };
    CodeGenerator.prototype.maybeBlockSuffix = function(stmt, result) {
        var ends = endsWithLineTerminator(toSourceNodeWhenNeeded(result).toString());
        if (stmt.type === Syntax.BlockStatement && (!extra.comment || !stmt.leadingComments) && !ends) return [
            result,
            space
        ];
        if (ends) return [
            result,
            base
        ];
        return [
            result,
            newline,
            base
        ];
    };
    function generateIdentifier(node) {
        return toSourceNodeWhenNeeded(node.name, node);
    }
    function generateAsyncPrefix(node, spaceRequired) {
        return node.async ? "async" + (spaceRequired ? noEmptySpace() : space) : "";
    }
    function generateStarSuffix(node) {
        var isGenerator = node.generator && !extra.moz.starlessGenerator;
        return isGenerator ? "*" + space : "";
    }
    function generateMethodPrefix(prop) {
        var func = prop.value, prefix = "";
        if (func.async) prefix += generateAsyncPrefix(func, !prop.computed);
        if (func.generator) // avoid space before method name
        prefix += generateStarSuffix(func) ? "*" : "";
        return prefix;
    }
    CodeGenerator.prototype.generatePattern = function(node, precedence, flags) {
        if (node.type === Syntax.Identifier) return generateIdentifier(node);
        return this.generateExpression(node, precedence, flags);
    };
    CodeGenerator.prototype.generateFunctionParams = function(node) {
        var i, iz, result, hasDefault;
        hasDefault = false;
        if (node.type === Syntax.ArrowFunctionExpression && !node.rest && (!node.defaults || node.defaults.length === 0) && node.params.length === 1 && node.params[0].type === Syntax.Identifier) // arg => { } case
        result = [
            generateAsyncPrefix(node, true),
            generateIdentifier(node.params[0])
        ];
        else {
            result = node.type === Syntax.ArrowFunctionExpression ? [
                generateAsyncPrefix(node, false)
            ] : [];
            result.push("(");
            if (node.defaults) hasDefault = true;
            for(i = 0, iz = node.params.length; i < iz; ++i){
                if (hasDefault && node.defaults[i]) // Handle default values.
                result.push(this.generateAssignment(node.params[i], node.defaults[i], "=", Precedence.Assignment, E_TTT));
                else result.push(this.generatePattern(node.params[i], Precedence.Assignment, E_TTT));
                if (i + 1 < iz) result.push("," + space);
            }
            if (node.rest) {
                if (node.params.length) result.push("," + space);
                result.push("...");
                result.push(generateIdentifier(node.rest));
            }
            result.push(")");
        }
        return result;
    };
    CodeGenerator.prototype.generateFunctionBody = function(node) {
        var result, expr;
        result = this.generateFunctionParams(node);
        if (node.type === Syntax.ArrowFunctionExpression) {
            result.push(space);
            result.push("=>");
        }
        if (node.expression) {
            result.push(space);
            expr = this.generateExpression(node.body, Precedence.Assignment, E_TTT);
            if (expr.toString().charAt(0) === "{") expr = [
                "(",
                expr,
                ")"
            ];
            result.push(expr);
        } else result.push(this.maybeBlock(node.body, S_TTFF));
        return result;
    };
    CodeGenerator.prototype.generateIterationForStatement = function(operator, stmt, flags) {
        var result = [
            "for" + (stmt.await ? noEmptySpace() + "await" : "") + space + "("
        ], that = this;
        withIndent(function() {
            if (stmt.left.type === Syntax.VariableDeclaration) withIndent(function() {
                result.push(stmt.left.kind + noEmptySpace());
                result.push(that.generateStatement(stmt.left.declarations[0], S_FFFF));
            });
            else result.push(that.generateExpression(stmt.left, Precedence.Call, E_TTT));
            result = join(result, operator);
            result = [
                join(result, that.generateExpression(stmt.right, Precedence.Assignment, E_TTT)),
                ")"
            ];
        });
        result.push(this.maybeBlock(stmt.body, flags));
        return result;
    };
    CodeGenerator.prototype.generatePropertyKey = function(expr, computed) {
        var result = [];
        if (computed) result.push("[");
        result.push(this.generateExpression(expr, Precedence.Assignment, E_TTT));
        if (computed) result.push("]");
        return result;
    };
    CodeGenerator.prototype.generateAssignment = function(left, right, operator, precedence, flags) {
        if (Precedence.Assignment < precedence) flags |= F_ALLOW_IN;
        return parenthesize([
            this.generateExpression(left, Precedence.Call, flags),
            space + operator + space,
            this.generateExpression(right, Precedence.Assignment, flags)
        ], Precedence.Assignment, precedence);
    };
    CodeGenerator.prototype.semicolon = function(flags) {
        if (!semicolons && flags & F_SEMICOLON_OPT) return "";
        return ";";
    };
    // Statements.
    CodeGenerator.Statement = {
        BlockStatement: function(stmt, flags) {
            var range, content, result = [
                "{",
                newline
            ], that = this;
            withIndent(function() {
                // handle functions without any code
                if (stmt.body.length === 0 && preserveBlankLines) {
                    range = stmt.range;
                    if (range[1] - range[0] > 2) {
                        content = sourceCode.substring(range[0] + 1, range[1] - 1);
                        if (content[0] === "\n") result = [
                            "{"
                        ];
                        result.push(content);
                    }
                }
                var i, iz, fragment, bodyFlags;
                bodyFlags = S_TFFF;
                if (flags & F_FUNC_BODY) bodyFlags |= F_DIRECTIVE_CTX;
                for(i = 0, iz = stmt.body.length; i < iz; ++i){
                    if (preserveBlankLines) {
                        // handle spaces before the first line
                        if (i === 0) {
                            if (stmt.body[0].leadingComments) {
                                range = stmt.body[0].leadingComments[0].extendedRange;
                                content = sourceCode.substring(range[0], range[1]);
                                if (content[0] === "\n") result = [
                                    "{"
                                ];
                            }
                            if (!stmt.body[0].leadingComments) generateBlankLines(stmt.range[0], stmt.body[0].range[0], result);
                        }
                        // handle spaces between lines
                        if (i > 0) {
                            if (!stmt.body[i - 1].trailingComments && !stmt.body[i].leadingComments) generateBlankLines(stmt.body[i - 1].range[1], stmt.body[i].range[0], result);
                        }
                    }
                    if (i === iz - 1) bodyFlags |= F_SEMICOLON_OPT;
                    if (stmt.body[i].leadingComments && preserveBlankLines) fragment = that.generateStatement(stmt.body[i], bodyFlags);
                    else fragment = addIndent(that.generateStatement(stmt.body[i], bodyFlags));
                    result.push(fragment);
                    if (!endsWithLineTerminator(toSourceNodeWhenNeeded(fragment).toString())) {
                        if (preserveBlankLines && i < iz - 1) // don't add a new line if there are leading coments
                        // in the next statement
                        {
                            if (!stmt.body[i + 1].leadingComments) result.push(newline);
                        } else result.push(newline);
                    }
                    if (preserveBlankLines) {
                        // handle spaces after the last line
                        if (i === iz - 1) {
                            if (!stmt.body[i].trailingComments) generateBlankLines(stmt.body[i].range[1], stmt.range[1], result);
                        }
                    }
                }
            });
            result.push(addIndent("}"));
            return result;
        },
        BreakStatement: function(stmt, flags) {
            if (stmt.label) return "break " + stmt.label.name + this.semicolon(flags);
            return "break" + this.semicolon(flags);
        },
        ContinueStatement: function(stmt, flags) {
            if (stmt.label) return "continue " + stmt.label.name + this.semicolon(flags);
            return "continue" + this.semicolon(flags);
        },
        ClassBody: function(stmt, flags) {
            var result = [
                "{",
                newline
            ], that = this;
            withIndent(function(indent) {
                var i, iz;
                for(i = 0, iz = stmt.body.length; i < iz; ++i){
                    result.push(indent);
                    result.push(that.generateExpression(stmt.body[i], Precedence.Sequence, E_TTT));
                    if (i + 1 < iz) result.push(newline);
                }
            });
            if (!endsWithLineTerminator(toSourceNodeWhenNeeded(result).toString())) result.push(newline);
            result.push(base);
            result.push("}");
            return result;
        },
        ClassDeclaration: function(stmt, flags) {
            var result, fragment;
            result = [
                "class"
            ];
            if (stmt.id) result = join(result, this.generateExpression(stmt.id, Precedence.Sequence, E_TTT));
            if (stmt.superClass) {
                fragment = join("extends", this.generateExpression(stmt.superClass, Precedence.Unary, E_TTT));
                result = join(result, fragment);
            }
            result.push(space);
            result.push(this.generateStatement(stmt.body, S_TFFT));
            return result;
        },
        DirectiveStatement: function(stmt, flags) {
            if (extra.raw && stmt.raw) return stmt.raw + this.semicolon(flags);
            return escapeDirective(stmt.directive) + this.semicolon(flags);
        },
        DoWhileStatement: function(stmt, flags) {
            // Because `do 42 while (cond)` is Syntax Error. We need semicolon.
            var result = join("do", this.maybeBlock(stmt.body, S_TFFF));
            result = this.maybeBlockSuffix(stmt.body, result);
            return join(result, [
                "while" + space + "(",
                this.generateExpression(stmt.test, Precedence.Sequence, E_TTT),
                ")" + this.semicolon(flags)
            ]);
        },
        CatchClause: function(stmt, flags) {
            var result, that = this;
            withIndent(function() {
                var guard;
                if (stmt.param) {
                    result = [
                        "catch" + space + "(",
                        that.generateExpression(stmt.param, Precedence.Sequence, E_TTT),
                        ")"
                    ];
                    if (stmt.guard) {
                        guard = that.generateExpression(stmt.guard, Precedence.Sequence, E_TTT);
                        result.splice(2, 0, " if ", guard);
                    }
                } else result = [
                    "catch"
                ];
            });
            result.push(this.maybeBlock(stmt.body, S_TFFF));
            return result;
        },
        DebuggerStatement: function(stmt, flags) {
            return "debugger" + this.semicolon(flags);
        },
        EmptyStatement: function(stmt, flags) {
            return ";";
        },
        ExportDefaultDeclaration: function(stmt, flags) {
            var result = [
                "export"
            ], bodyFlags;
            bodyFlags = flags & F_SEMICOLON_OPT ? S_TFFT : S_TFFF;
            // export default HoistableDeclaration[Default]
            // export default AssignmentExpression[In] ;
            result = join(result, "default");
            if (isStatement(stmt.declaration)) result = join(result, this.generateStatement(stmt.declaration, bodyFlags));
            else result = join(result, this.generateExpression(stmt.declaration, Precedence.Assignment, E_TTT) + this.semicolon(flags));
            return result;
        },
        ExportNamedDeclaration: function(stmt, flags) {
            var result = [
                "export"
            ], bodyFlags, that = this;
            bodyFlags = flags & F_SEMICOLON_OPT ? S_TFFT : S_TFFF;
            // export VariableStatement
            // export Declaration[Default]
            if (stmt.declaration) return join(result, this.generateStatement(stmt.declaration, bodyFlags));
            // export ExportClause[NoReference] FromClause ;
            // export ExportClause ;
            if (stmt.specifiers) {
                if (stmt.specifiers.length === 0) result = join(result, "{" + space + "}");
                else if (stmt.specifiers[0].type === Syntax.ExportBatchSpecifier) result = join(result, this.generateExpression(stmt.specifiers[0], Precedence.Sequence, E_TTT));
                else {
                    result = join(result, "{");
                    withIndent(function(indent) {
                        var i, iz;
                        result.push(newline);
                        for(i = 0, iz = stmt.specifiers.length; i < iz; ++i){
                            result.push(indent);
                            result.push(that.generateExpression(stmt.specifiers[i], Precedence.Sequence, E_TTT));
                            if (i + 1 < iz) result.push("," + newline);
                        }
                    });
                    if (!endsWithLineTerminator(toSourceNodeWhenNeeded(result).toString())) result.push(newline);
                    result.push(base + "}");
                }
                if (stmt.source) result = join(result, [
                    "from" + space,
                    // ModuleSpecifier
                    this.generateExpression(stmt.source, Precedence.Sequence, E_TTT),
                    this.semicolon(flags)
                ]);
                else result.push(this.semicolon(flags));
            }
            return result;
        },
        ExportAllDeclaration: function(stmt, flags) {
            // export * FromClause ;
            return [
                "export" + space,
                "*" + space,
                "from" + space,
                // ModuleSpecifier
                this.generateExpression(stmt.source, Precedence.Sequence, E_TTT),
                this.semicolon(flags)
            ];
        },
        ExpressionStatement: function(stmt, flags) {
            var result, fragment;
            function isClassPrefixed(fragment) {
                var code;
                if (fragment.slice(0, 5) !== "class") return false;
                code = fragment.charCodeAt(5);
                return code === 0x7B /* '{' */  || esutils.code.isWhiteSpace(code) || esutils.code.isLineTerminator(code);
            }
            function isFunctionPrefixed(fragment) {
                var code;
                if (fragment.slice(0, 8) !== "function") return false;
                code = fragment.charCodeAt(8);
                return code === 0x28 /* '(' */  || esutils.code.isWhiteSpace(code) || code === 0x2A /* '*' */  || esutils.code.isLineTerminator(code);
            }
            function isAsyncPrefixed(fragment) {
                var code, i, iz;
                if (fragment.slice(0, 5) !== "async") return false;
                if (!esutils.code.isWhiteSpace(fragment.charCodeAt(5))) return false;
                for(i = 6, iz = fragment.length; i < iz; ++i){
                    if (!esutils.code.isWhiteSpace(fragment.charCodeAt(i))) break;
                }
                if (i === iz) return false;
                if (fragment.slice(i, i + 8) !== "function") return false;
                code = fragment.charCodeAt(i + 8);
                return code === 0x28 /* '(' */  || esutils.code.isWhiteSpace(code) || code === 0x2A /* '*' */  || esutils.code.isLineTerminator(code);
            }
            result = [
                this.generateExpression(stmt.expression, Precedence.Sequence, E_TTT)
            ];
            // 12.4 '{', 'function', 'class' is not allowed in this position.
            // wrap expression with parentheses
            fragment = toSourceNodeWhenNeeded(result).toString();
            if (fragment.charCodeAt(0) === 0x7B /* '{' */  || // ObjectExpression
            isClassPrefixed(fragment) || isFunctionPrefixed(fragment) || isAsyncPrefixed(fragment) || directive && flags & F_DIRECTIVE_CTX && stmt.expression.type === Syntax.Literal && typeof stmt.expression.value === "string") result = [
                "(",
                result,
                ")" + this.semicolon(flags)
            ];
            else result.push(this.semicolon(flags));
            return result;
        },
        ImportDeclaration: function(stmt, flags) {
            // ES6: 15.2.1 valid import declarations:
            //     - import ImportClause FromClause ;
            //     - import ModuleSpecifier ;
            var result, cursor, that = this;
            // If no ImportClause is present,
            // this should be `import ModuleSpecifier` so skip `from`
            // ModuleSpecifier is StringLiteral.
            if (stmt.specifiers.length === 0) // import ModuleSpecifier ;
            return [
                "import",
                space,
                // ModuleSpecifier
                this.generateExpression(stmt.source, Precedence.Sequence, E_TTT),
                this.semicolon(flags)
            ];
            // import ImportClause FromClause ;
            result = [
                "import"
            ];
            cursor = 0;
            // ImportedBinding
            if (stmt.specifiers[cursor].type === Syntax.ImportDefaultSpecifier) {
                result = join(result, [
                    this.generateExpression(stmt.specifiers[cursor], Precedence.Sequence, E_TTT)
                ]);
                ++cursor;
            }
            if (stmt.specifiers[cursor]) {
                if (cursor !== 0) result.push(",");
                if (stmt.specifiers[cursor].type === Syntax.ImportNamespaceSpecifier) // NameSpaceImport
                result = join(result, [
                    space,
                    this.generateExpression(stmt.specifiers[cursor], Precedence.Sequence, E_TTT)
                ]);
                else {
                    // NamedImports
                    result.push(space + "{");
                    if (stmt.specifiers.length - cursor === 1) {
                        // import { ... } from "...";
                        result.push(space);
                        result.push(this.generateExpression(stmt.specifiers[cursor], Precedence.Sequence, E_TTT));
                        result.push(space + "}" + space);
                    } else {
                        // import {
                        //    ...,
                        //    ...,
                        // } from "...";
                        withIndent(function(indent) {
                            var i, iz;
                            result.push(newline);
                            for(i = cursor, iz = stmt.specifiers.length; i < iz; ++i){
                                result.push(indent);
                                result.push(that.generateExpression(stmt.specifiers[i], Precedence.Sequence, E_TTT));
                                if (i + 1 < iz) result.push("," + newline);
                            }
                        });
                        if (!endsWithLineTerminator(toSourceNodeWhenNeeded(result).toString())) result.push(newline);
                        result.push(base + "}" + space);
                    }
                }
            }
            result = join(result, [
                "from" + space,
                // ModuleSpecifier
                this.generateExpression(stmt.source, Precedence.Sequence, E_TTT),
                this.semicolon(flags)
            ]);
            return result;
        },
        VariableDeclarator: function(stmt, flags) {
            var itemFlags = flags & F_ALLOW_IN ? E_TTT : E_FTT;
            if (stmt.init) return [
                this.generateExpression(stmt.id, Precedence.Assignment, itemFlags),
                space,
                "=",
                space,
                this.generateExpression(stmt.init, Precedence.Assignment, itemFlags)
            ];
            return this.generatePattern(stmt.id, Precedence.Assignment, itemFlags);
        },
        VariableDeclaration: function(stmt, flags) {
            // VariableDeclarator is typed as Statement,
            // but joined with comma (not LineTerminator).
            // So if comment is attached to target node, we should specialize.
            var result, i, iz, node, bodyFlags, that = this;
            result = [
                stmt.kind
            ];
            bodyFlags = flags & F_ALLOW_IN ? S_TFFF : S_FFFF;
            function block() {
                node = stmt.declarations[0];
                if (extra.comment && node.leadingComments) {
                    result.push("\n");
                    result.push(addIndent(that.generateStatement(node, bodyFlags)));
                } else {
                    result.push(noEmptySpace());
                    result.push(that.generateStatement(node, bodyFlags));
                }
                for(i = 1, iz = stmt.declarations.length; i < iz; ++i){
                    node = stmt.declarations[i];
                    if (extra.comment && node.leadingComments) {
                        result.push("," + newline);
                        result.push(addIndent(that.generateStatement(node, bodyFlags)));
                    } else {
                        result.push("," + space);
                        result.push(that.generateStatement(node, bodyFlags));
                    }
                }
            }
            if (stmt.declarations.length > 1) withIndent(block);
            else block();
            result.push(this.semicolon(flags));
            return result;
        },
        ThrowStatement: function(stmt, flags) {
            return [
                join("throw", this.generateExpression(stmt.argument, Precedence.Sequence, E_TTT)),
                this.semicolon(flags)
            ];
        },
        TryStatement: function(stmt, flags) {
            var result, i, iz, guardedHandlers;
            result = [
                "try",
                this.maybeBlock(stmt.block, S_TFFF)
            ];
            result = this.maybeBlockSuffix(stmt.block, result);
            if (stmt.handlers) // old interface
            for(i = 0, iz = stmt.handlers.length; i < iz; ++i){
                result = join(result, this.generateStatement(stmt.handlers[i], S_TFFF));
                if (stmt.finalizer || i + 1 !== iz) result = this.maybeBlockSuffix(stmt.handlers[i].body, result);
            }
            else {
                guardedHandlers = stmt.guardedHandlers || [];
                for(i = 0, iz = guardedHandlers.length; i < iz; ++i){
                    result = join(result, this.generateStatement(guardedHandlers[i], S_TFFF));
                    if (stmt.finalizer || i + 1 !== iz) result = this.maybeBlockSuffix(guardedHandlers[i].body, result);
                }
                // new interface
                if (stmt.handler) {
                    if (Array.isArray(stmt.handler)) for(i = 0, iz = stmt.handler.length; i < iz; ++i){
                        result = join(result, this.generateStatement(stmt.handler[i], S_TFFF));
                        if (stmt.finalizer || i + 1 !== iz) result = this.maybeBlockSuffix(stmt.handler[i].body, result);
                    }
                    else {
                        result = join(result, this.generateStatement(stmt.handler, S_TFFF));
                        if (stmt.finalizer) result = this.maybeBlockSuffix(stmt.handler.body, result);
                    }
                }
            }
            if (stmt.finalizer) result = join(result, [
                "finally",
                this.maybeBlock(stmt.finalizer, S_TFFF)
            ]);
            return result;
        },
        SwitchStatement: function(stmt, flags) {
            var result, fragment, i, iz, bodyFlags, that = this;
            withIndent(function() {
                result = [
                    "switch" + space + "(",
                    that.generateExpression(stmt.discriminant, Precedence.Sequence, E_TTT),
                    ")" + space + "{" + newline
                ];
            });
            if (stmt.cases) {
                bodyFlags = S_TFFF;
                for(i = 0, iz = stmt.cases.length; i < iz; ++i){
                    if (i === iz - 1) bodyFlags |= F_SEMICOLON_OPT;
                    fragment = addIndent(this.generateStatement(stmt.cases[i], bodyFlags));
                    result.push(fragment);
                    if (!endsWithLineTerminator(toSourceNodeWhenNeeded(fragment).toString())) result.push(newline);
                }
            }
            result.push(addIndent("}"));
            return result;
        },
        SwitchCase: function(stmt, flags) {
            var result, fragment, i, iz, bodyFlags, that = this;
            withIndent(function() {
                if (stmt.test) result = [
                    join("case", that.generateExpression(stmt.test, Precedence.Sequence, E_TTT)),
                    ":"
                ];
                else result = [
                    "default:"
                ];
                i = 0;
                iz = stmt.consequent.length;
                if (iz && stmt.consequent[0].type === Syntax.BlockStatement) {
                    fragment = that.maybeBlock(stmt.consequent[0], S_TFFF);
                    result.push(fragment);
                    i = 1;
                }
                if (i !== iz && !endsWithLineTerminator(toSourceNodeWhenNeeded(result).toString())) result.push(newline);
                bodyFlags = S_TFFF;
                for(; i < iz; ++i){
                    if (i === iz - 1 && flags & F_SEMICOLON_OPT) bodyFlags |= F_SEMICOLON_OPT;
                    fragment = addIndent(that.generateStatement(stmt.consequent[i], bodyFlags));
                    result.push(fragment);
                    if (i + 1 !== iz && !endsWithLineTerminator(toSourceNodeWhenNeeded(fragment).toString())) result.push(newline);
                }
            });
            return result;
        },
        IfStatement: function(stmt, flags) {
            var result, bodyFlags, semicolonOptional, that = this;
            withIndent(function() {
                result = [
                    "if" + space + "(",
                    that.generateExpression(stmt.test, Precedence.Sequence, E_TTT),
                    ")"
                ];
            });
            semicolonOptional = flags & F_SEMICOLON_OPT;
            bodyFlags = S_TFFF;
            if (semicolonOptional) bodyFlags |= F_SEMICOLON_OPT;
            if (stmt.alternate) {
                result.push(this.maybeBlock(stmt.consequent, S_TFFF));
                result = this.maybeBlockSuffix(stmt.consequent, result);
                if (stmt.alternate.type === Syntax.IfStatement) result = join(result, [
                    "else ",
                    this.generateStatement(stmt.alternate, bodyFlags)
                ]);
                else result = join(result, join("else", this.maybeBlock(stmt.alternate, bodyFlags)));
            } else result.push(this.maybeBlock(stmt.consequent, bodyFlags));
            return result;
        },
        ForStatement: function(stmt, flags) {
            var result, that = this;
            withIndent(function() {
                result = [
                    "for" + space + "("
                ];
                if (stmt.init) {
                    if (stmt.init.type === Syntax.VariableDeclaration) result.push(that.generateStatement(stmt.init, S_FFFF));
                    else {
                        // F_ALLOW_IN becomes false.
                        result.push(that.generateExpression(stmt.init, Precedence.Sequence, E_FTT));
                        result.push(";");
                    }
                } else result.push(";");
                if (stmt.test) {
                    result.push(space);
                    result.push(that.generateExpression(stmt.test, Precedence.Sequence, E_TTT));
                    result.push(";");
                } else result.push(";");
                if (stmt.update) {
                    result.push(space);
                    result.push(that.generateExpression(stmt.update, Precedence.Sequence, E_TTT));
                    result.push(")");
                } else result.push(")");
            });
            result.push(this.maybeBlock(stmt.body, flags & F_SEMICOLON_OPT ? S_TFFT : S_TFFF));
            return result;
        },
        ForInStatement: function(stmt, flags) {
            return this.generateIterationForStatement("in", stmt, flags & F_SEMICOLON_OPT ? S_TFFT : S_TFFF);
        },
        ForOfStatement: function(stmt, flags) {
            return this.generateIterationForStatement("of", stmt, flags & F_SEMICOLON_OPT ? S_TFFT : S_TFFF);
        },
        LabeledStatement: function(stmt, flags) {
            return [
                stmt.label.name + ":",
                this.maybeBlock(stmt.body, flags & F_SEMICOLON_OPT ? S_TFFT : S_TFFF)
            ];
        },
        Program: function(stmt, flags) {
            var result, fragment, i, iz, bodyFlags;
            iz = stmt.body.length;
            result = [
                safeConcatenation && iz > 0 ? "\n" : ""
            ];
            bodyFlags = S_TFTF;
            for(i = 0; i < iz; ++i){
                if (!safeConcatenation && i === iz - 1) bodyFlags |= F_SEMICOLON_OPT;
                if (preserveBlankLines) {
                    // handle spaces before the first line
                    if (i === 0) {
                        if (!stmt.body[0].leadingComments) generateBlankLines(stmt.range[0], stmt.body[i].range[0], result);
                    }
                    // handle spaces between lines
                    if (i > 0) {
                        if (!stmt.body[i - 1].trailingComments && !stmt.body[i].leadingComments) generateBlankLines(stmt.body[i - 1].range[1], stmt.body[i].range[0], result);
                    }
                }
                fragment = addIndent(this.generateStatement(stmt.body[i], bodyFlags));
                result.push(fragment);
                if (i + 1 < iz && !endsWithLineTerminator(toSourceNodeWhenNeeded(fragment).toString())) {
                    if (preserveBlankLines) {
                        if (!stmt.body[i + 1].leadingComments) result.push(newline);
                    } else result.push(newline);
                }
                if (preserveBlankLines) {
                    // handle spaces after the last line
                    if (i === iz - 1) {
                        if (!stmt.body[i].trailingComments) generateBlankLines(stmt.body[i].range[1], stmt.range[1], result);
                    }
                }
            }
            return result;
        },
        FunctionDeclaration: function(stmt, flags) {
            return [
                generateAsyncPrefix(stmt, true),
                "function",
                generateStarSuffix(stmt) || noEmptySpace(),
                stmt.id ? generateIdentifier(stmt.id) : "",
                this.generateFunctionBody(stmt)
            ];
        },
        ReturnStatement: function(stmt, flags) {
            if (stmt.argument) return [
                join("return", this.generateExpression(stmt.argument, Precedence.Sequence, E_TTT)),
                this.semicolon(flags)
            ];
            return [
                "return" + this.semicolon(flags)
            ];
        },
        WhileStatement: function(stmt, flags) {
            var result, that = this;
            withIndent(function() {
                result = [
                    "while" + space + "(",
                    that.generateExpression(stmt.test, Precedence.Sequence, E_TTT),
                    ")"
                ];
            });
            result.push(this.maybeBlock(stmt.body, flags & F_SEMICOLON_OPT ? S_TFFT : S_TFFF));
            return result;
        },
        WithStatement: function(stmt, flags) {
            var result, that = this;
            withIndent(function() {
                result = [
                    "with" + space + "(",
                    that.generateExpression(stmt.object, Precedence.Sequence, E_TTT),
                    ")"
                ];
            });
            result.push(this.maybeBlock(stmt.body, flags & F_SEMICOLON_OPT ? S_TFFT : S_TFFF));
            return result;
        }
    };
    merge(CodeGenerator.prototype, CodeGenerator.Statement);
    // Expressions.
    CodeGenerator.Expression = {
        SequenceExpression: function(expr, precedence, flags) {
            var result, i, iz;
            if (Precedence.Sequence < precedence) flags |= F_ALLOW_IN;
            result = [];
            for(i = 0, iz = expr.expressions.length; i < iz; ++i){
                result.push(this.generateExpression(expr.expressions[i], Precedence.Assignment, flags));
                if (i + 1 < iz) result.push("," + space);
            }
            return parenthesize(result, Precedence.Sequence, precedence);
        },
        AssignmentExpression: function(expr, precedence, flags) {
            return this.generateAssignment(expr.left, expr.right, expr.operator, precedence, flags);
        },
        ArrowFunctionExpression: function(expr, precedence, flags) {
            return parenthesize(this.generateFunctionBody(expr), Precedence.ArrowFunction, precedence);
        },
        ConditionalExpression: function(expr, precedence, flags) {
            if (Precedence.Conditional < precedence) flags |= F_ALLOW_IN;
            return parenthesize([
                this.generateExpression(expr.test, Precedence.LogicalOR, flags),
                space + "?" + space,
                this.generateExpression(expr.consequent, Precedence.Assignment, flags),
                space + ":" + space,
                this.generateExpression(expr.alternate, Precedence.Assignment, flags)
            ], Precedence.Conditional, precedence);
        },
        LogicalExpression: function(expr, precedence, flags) {
            return this.BinaryExpression(expr, precedence, flags);
        },
        BinaryExpression: function(expr, precedence, flags) {
            var result, leftPrecedence, rightPrecedence, currentPrecedence, fragment, leftSource;
            currentPrecedence = BinaryPrecedence[expr.operator];
            leftPrecedence = expr.operator === "**" ? Precedence.Postfix : currentPrecedence;
            rightPrecedence = expr.operator === "**" ? currentPrecedence : currentPrecedence + 1;
            if (currentPrecedence < precedence) flags |= F_ALLOW_IN;
            fragment = this.generateExpression(expr.left, leftPrecedence, flags);
            leftSource = fragment.toString();
            if (leftSource.charCodeAt(leftSource.length - 1) === 0x2F /* / */  && esutils.code.isIdentifierPartES5(expr.operator.charCodeAt(0))) result = [
                fragment,
                noEmptySpace(),
                expr.operator
            ];
            else result = join(fragment, expr.operator);
            fragment = this.generateExpression(expr.right, rightPrecedence, flags);
            if (expr.operator === "/" && fragment.toString().charAt(0) === "/" || expr.operator.slice(-1) === "<" && fragment.toString().slice(0, 3) === "!--") {
                // If '/' concats with '/' or `<` concats with `!--`, it is interpreted as comment start
                result.push(noEmptySpace());
                result.push(fragment);
            } else result = join(result, fragment);
            if (expr.operator === "in" && !(flags & F_ALLOW_IN)) return [
                "(",
                result,
                ")"
            ];
            return parenthesize(result, currentPrecedence, precedence);
        },
        CallExpression: function(expr, precedence, flags) {
            var result, i, iz;
            // F_ALLOW_UNPARATH_NEW becomes false.
            result = [
                this.generateExpression(expr.callee, Precedence.Call, E_TTF)
            ];
            if (expr.optional) result.push("?.");
            result.push("(");
            for(i = 0, iz = expr["arguments"].length; i < iz; ++i){
                result.push(this.generateExpression(expr["arguments"][i], Precedence.Assignment, E_TTT));
                if (i + 1 < iz) result.push("," + space);
            }
            result.push(")");
            if (!(flags & F_ALLOW_CALL)) return [
                "(",
                result,
                ")"
            ];
            return parenthesize(result, Precedence.Call, precedence);
        },
        ChainExpression: function(expr, precedence, flags) {
            if (Precedence.OptionalChaining < precedence) flags |= F_ALLOW_CALL;
            var result = this.generateExpression(expr.expression, Precedence.OptionalChaining, flags);
            return parenthesize(result, Precedence.OptionalChaining, precedence);
        },
        NewExpression: function(expr, precedence, flags) {
            var result, length, i, iz, itemFlags;
            length = expr["arguments"].length;
            // F_ALLOW_CALL becomes false.
            // F_ALLOW_UNPARATH_NEW may become false.
            itemFlags = flags & F_ALLOW_UNPARATH_NEW && !parentheses && length === 0 ? E_TFT : E_TFF;
            result = join("new", this.generateExpression(expr.callee, Precedence.New, itemFlags));
            if (!(flags & F_ALLOW_UNPARATH_NEW) || parentheses || length > 0) {
                result.push("(");
                for(i = 0, iz = length; i < iz; ++i){
                    result.push(this.generateExpression(expr["arguments"][i], Precedence.Assignment, E_TTT));
                    if (i + 1 < iz) result.push("," + space);
                }
                result.push(")");
            }
            return parenthesize(result, Precedence.New, precedence);
        },
        MemberExpression: function(expr, precedence, flags) {
            var result, fragment;
            // F_ALLOW_UNPARATH_NEW becomes false.
            result = [
                this.generateExpression(expr.object, Precedence.Call, flags & F_ALLOW_CALL ? E_TTF : E_TFF)
            ];
            if (expr.computed) {
                if (expr.optional) result.push("?.");
                result.push("[");
                result.push(this.generateExpression(expr.property, Precedence.Sequence, flags & F_ALLOW_CALL ? E_TTT : E_TFT));
                result.push("]");
            } else {
                if (!expr.optional && expr.object.type === Syntax.Literal && typeof expr.object.value === "number") {
                    fragment = toSourceNodeWhenNeeded(result).toString();
                    // When the following conditions are all true,
                    //   1. No floating point
                    //   2. Don't have exponents
                    //   3. The last character is a decimal digit
                    //   4. Not hexadecimal OR octal number literal
                    // we should add a floating point.
                    if (fragment.indexOf(".") < 0 && !/[eExX]/.test(fragment) && esutils.code.isDecimalDigit(fragment.charCodeAt(fragment.length - 1)) && !(fragment.length >= 2 && fragment.charCodeAt(0) === 48 // '0'
                    )) result.push(" ");
                }
                result.push(expr.optional ? "?." : ".");
                result.push(generateIdentifier(expr.property));
            }
            return parenthesize(result, Precedence.Member, precedence);
        },
        MetaProperty: function(expr, precedence, flags) {
            var result;
            result = [];
            result.push(typeof expr.meta === "string" ? expr.meta : generateIdentifier(expr.meta));
            result.push(".");
            result.push(typeof expr.property === "string" ? expr.property : generateIdentifier(expr.property));
            return parenthesize(result, Precedence.Member, precedence);
        },
        UnaryExpression: function(expr, precedence, flags) {
            var result, fragment, rightCharCode, leftSource, leftCharCode;
            fragment = this.generateExpression(expr.argument, Precedence.Unary, E_TTT);
            if (space === "") result = join(expr.operator, fragment);
            else {
                result = [
                    expr.operator
                ];
                if (expr.operator.length > 2) // delete, void, typeof
                // get `typeof []`, not `typeof[]`
                result = join(result, fragment);
                else {
                    // Prevent inserting spaces between operator and argument if it is unnecessary
                    // like, `!cond`
                    leftSource = toSourceNodeWhenNeeded(result).toString();
                    leftCharCode = leftSource.charCodeAt(leftSource.length - 1);
                    rightCharCode = fragment.toString().charCodeAt(0);
                    if ((leftCharCode === 0x2B /* + */  || leftCharCode === 0x2D /* - */ ) && leftCharCode === rightCharCode || esutils.code.isIdentifierPartES5(leftCharCode) && esutils.code.isIdentifierPartES5(rightCharCode)) {
                        result.push(noEmptySpace());
                        result.push(fragment);
                    } else result.push(fragment);
                }
            }
            return parenthesize(result, Precedence.Unary, precedence);
        },
        YieldExpression: function(expr, precedence, flags) {
            var result;
            if (expr.delegate) result = "yield*";
            else result = "yield";
            if (expr.argument) result = join(result, this.generateExpression(expr.argument, Precedence.Yield, E_TTT));
            return parenthesize(result, Precedence.Yield, precedence);
        },
        AwaitExpression: function(expr, precedence, flags) {
            var result = join(expr.all ? "await*" : "await", this.generateExpression(expr.argument, Precedence.Await, E_TTT));
            return parenthesize(result, Precedence.Await, precedence);
        },
        UpdateExpression: function(expr, precedence, flags) {
            if (expr.prefix) return parenthesize([
                expr.operator,
                this.generateExpression(expr.argument, Precedence.Unary, E_TTT)
            ], Precedence.Unary, precedence);
            return parenthesize([
                this.generateExpression(expr.argument, Precedence.Postfix, E_TTT),
                expr.operator
            ], Precedence.Postfix, precedence);
        },
        FunctionExpression: function(expr, precedence, flags) {
            var result = [
                generateAsyncPrefix(expr, true),
                "function"
            ];
            if (expr.id) {
                result.push(generateStarSuffix(expr) || noEmptySpace());
                result.push(generateIdentifier(expr.id));
            } else result.push(generateStarSuffix(expr) || space);
            result.push(this.generateFunctionBody(expr));
            return result;
        },
        ArrayPattern: function(expr, precedence, flags) {
            return this.ArrayExpression(expr, precedence, flags, true);
        },
        ArrayExpression: function(expr, precedence, flags, isPattern) {
            var result, multiline, that = this;
            if (!expr.elements.length) return "[]";
            multiline = isPattern ? false : expr.elements.length > 1;
            result = [
                "[",
                multiline ? newline : ""
            ];
            withIndent(function(indent) {
                var i, iz;
                for(i = 0, iz = expr.elements.length; i < iz; ++i){
                    if (!expr.elements[i]) {
                        if (multiline) result.push(indent);
                        if (i + 1 === iz) result.push(",");
                    } else {
                        result.push(multiline ? indent : "");
                        result.push(that.generateExpression(expr.elements[i], Precedence.Assignment, E_TTT));
                    }
                    if (i + 1 < iz) result.push("," + (multiline ? newline : space));
                }
            });
            if (multiline && !endsWithLineTerminator(toSourceNodeWhenNeeded(result).toString())) result.push(newline);
            result.push(multiline ? base : "");
            result.push("]");
            return result;
        },
        RestElement: function(expr, precedence, flags) {
            return "..." + this.generatePattern(expr.argument);
        },
        ClassExpression: function(expr, precedence, flags) {
            var result, fragment;
            result = [
                "class"
            ];
            if (expr.id) result = join(result, this.generateExpression(expr.id, Precedence.Sequence, E_TTT));
            if (expr.superClass) {
                fragment = join("extends", this.generateExpression(expr.superClass, Precedence.Unary, E_TTT));
                result = join(result, fragment);
            }
            result.push(space);
            result.push(this.generateStatement(expr.body, S_TFFT));
            return result;
        },
        MethodDefinition: function(expr, precedence, flags) {
            var result, fragment;
            if (expr["static"]) result = [
                "static" + space
            ];
            else result = [];
            if (expr.kind === "get" || expr.kind === "set") fragment = [
                join(expr.kind, this.generatePropertyKey(expr.key, expr.computed)),
                this.generateFunctionBody(expr.value)
            ];
            else fragment = [
                generateMethodPrefix(expr),
                this.generatePropertyKey(expr.key, expr.computed),
                this.generateFunctionBody(expr.value)
            ];
            return join(result, fragment);
        },
        Property: function(expr, precedence, flags) {
            if (expr.kind === "get" || expr.kind === "set") return [
                expr.kind,
                noEmptySpace(),
                this.generatePropertyKey(expr.key, expr.computed),
                this.generateFunctionBody(expr.value)
            ];
            if (expr.shorthand) {
                if (expr.value.type === "AssignmentPattern") return this.AssignmentPattern(expr.value, Precedence.Sequence, E_TTT);
                return this.generatePropertyKey(expr.key, expr.computed);
            }
            if (expr.method) return [
                generateMethodPrefix(expr),
                this.generatePropertyKey(expr.key, expr.computed),
                this.generateFunctionBody(expr.value)
            ];
            return [
                this.generatePropertyKey(expr.key, expr.computed),
                ":" + space,
                this.generateExpression(expr.value, Precedence.Assignment, E_TTT)
            ];
        },
        ObjectExpression: function(expr, precedence, flags) {
            var multiline, result, fragment, that = this;
            if (!expr.properties.length) return "{}";
            multiline = expr.properties.length > 1;
            withIndent(function() {
                fragment = that.generateExpression(expr.properties[0], Precedence.Sequence, E_TTT);
            });
            if (!multiline) {
                // issues 4
                // Do not transform from
                //   dejavu.Class.declare({
                //       method2: function () {}
                //   });
                // to
                //   dejavu.Class.declare({method2: function () {
                //       }});
                if (!hasLineTerminator(toSourceNodeWhenNeeded(fragment).toString())) return [
                    "{",
                    space,
                    fragment,
                    space,
                    "}"
                ];
            }
            withIndent(function(indent) {
                var i, iz;
                result = [
                    "{",
                    newline,
                    indent,
                    fragment
                ];
                if (multiline) {
                    result.push("," + newline);
                    for(i = 1, iz = expr.properties.length; i < iz; ++i){
                        result.push(indent);
                        result.push(that.generateExpression(expr.properties[i], Precedence.Sequence, E_TTT));
                        if (i + 1 < iz) result.push("," + newline);
                    }
                }
            });
            if (!endsWithLineTerminator(toSourceNodeWhenNeeded(result).toString())) result.push(newline);
            result.push(base);
            result.push("}");
            return result;
        },
        AssignmentPattern: function(expr, precedence, flags) {
            return this.generateAssignment(expr.left, expr.right, "=", precedence, flags);
        },
        ObjectPattern: function(expr, precedence, flags) {
            var result, i, iz, multiline, property, that = this;
            if (!expr.properties.length) return "{}";
            multiline = false;
            if (expr.properties.length === 1) {
                property = expr.properties[0];
                if (property.type === Syntax.Property && property.value.type !== Syntax.Identifier) multiline = true;
            } else for(i = 0, iz = expr.properties.length; i < iz; ++i){
                property = expr.properties[i];
                if (property.type === Syntax.Property && !property.shorthand) {
                    multiline = true;
                    break;
                }
            }
            result = [
                "{",
                multiline ? newline : ""
            ];
            withIndent(function(indent) {
                var i, iz;
                for(i = 0, iz = expr.properties.length; i < iz; ++i){
                    result.push(multiline ? indent : "");
                    result.push(that.generateExpression(expr.properties[i], Precedence.Sequence, E_TTT));
                    if (i + 1 < iz) result.push("," + (multiline ? newline : space));
                }
            });
            if (multiline && !endsWithLineTerminator(toSourceNodeWhenNeeded(result).toString())) result.push(newline);
            result.push(multiline ? base : "");
            result.push("}");
            return result;
        },
        ThisExpression: function(expr, precedence, flags) {
            return "this";
        },
        Super: function(expr, precedence, flags) {
            return "super";
        },
        Identifier: function(expr, precedence, flags) {
            return generateIdentifier(expr);
        },
        ImportDefaultSpecifier: function(expr, precedence, flags) {
            return generateIdentifier(expr.id || expr.local);
        },
        ImportNamespaceSpecifier: function(expr, precedence, flags) {
            var result = [
                "*"
            ];
            var id = expr.id || expr.local;
            if (id) result.push(space + "as" + noEmptySpace() + generateIdentifier(id));
            return result;
        },
        ImportSpecifier: function(expr, precedence, flags) {
            var imported = expr.imported;
            var result = [
                imported.name
            ];
            var local = expr.local;
            if (local && local.name !== imported.name) result.push(noEmptySpace() + "as" + noEmptySpace() + generateIdentifier(local));
            return result;
        },
        ExportSpecifier: function(expr, precedence, flags) {
            var local = expr.local;
            var result = [
                local.name
            ];
            var exported = expr.exported;
            if (exported && exported.name !== local.name) result.push(noEmptySpace() + "as" + noEmptySpace() + generateIdentifier(exported));
            return result;
        },
        Literal: function(expr, precedence, flags) {
            var raw;
            if (expr.hasOwnProperty("raw") && parse && extra.raw) try {
                raw = parse(expr.raw).body[0].expression;
                if (raw.type === Syntax.Literal) {
                    if (raw.value === expr.value) return expr.raw;
                }
            } catch (e) {
            // not use raw property
            }
            if (expr.regex) return "/" + expr.regex.pattern + "/" + expr.regex.flags;
            if (expr.value === null) return "null";
            if (typeof expr.value === "string") return escapeString(expr.value);
            if (typeof expr.value === "number") return generateNumber(expr.value);
            if (typeof expr.value === "boolean") return expr.value ? "true" : "false";
            return generateRegExp(expr.value);
        },
        GeneratorExpression: function(expr, precedence, flags) {
            return this.ComprehensionExpression(expr, precedence, flags);
        },
        ComprehensionExpression: function(expr, precedence, flags) {
            // GeneratorExpression should be parenthesized with (...), ComprehensionExpression with [...]
            // Due to https://bugzilla.mozilla.org/show_bug.cgi?id=883468 position of expr.body can differ in Spidermonkey and ES6
            var result, i, iz, fragment, that = this;
            result = expr.type === Syntax.GeneratorExpression ? [
                "("
            ] : [
                "["
            ];
            if (extra.moz.comprehensionExpressionStartsWithAssignment) {
                fragment = this.generateExpression(expr.body, Precedence.Assignment, E_TTT);
                result.push(fragment);
            }
            if (expr.blocks) withIndent(function() {
                for(i = 0, iz = expr.blocks.length; i < iz; ++i){
                    fragment = that.generateExpression(expr.blocks[i], Precedence.Sequence, E_TTT);
                    if (i > 0 || extra.moz.comprehensionExpressionStartsWithAssignment) result = join(result, fragment);
                    else result.push(fragment);
                }
            });
            if (expr.filter) {
                result = join(result, "if" + space);
                fragment = this.generateExpression(expr.filter, Precedence.Sequence, E_TTT);
                result = join(result, [
                    "(",
                    fragment,
                    ")"
                ]);
            }
            if (!extra.moz.comprehensionExpressionStartsWithAssignment) {
                fragment = this.generateExpression(expr.body, Precedence.Assignment, E_TTT);
                result = join(result, fragment);
            }
            result.push(expr.type === Syntax.GeneratorExpression ? ")" : "]");
            return result;
        },
        ComprehensionBlock: function(expr, precedence, flags) {
            var fragment;
            if (expr.left.type === Syntax.VariableDeclaration) fragment = [
                expr.left.kind,
                noEmptySpace(),
                this.generateStatement(expr.left.declarations[0], S_FFFF)
            ];
            else fragment = this.generateExpression(expr.left, Precedence.Call, E_TTT);
            fragment = join(fragment, expr.of ? "of" : "in");
            fragment = join(fragment, this.generateExpression(expr.right, Precedence.Sequence, E_TTT));
            return [
                "for" + space + "(",
                fragment,
                ")"
            ];
        },
        SpreadElement: function(expr, precedence, flags) {
            return [
                "...",
                this.generateExpression(expr.argument, Precedence.Assignment, E_TTT)
            ];
        },
        TaggedTemplateExpression: function(expr, precedence, flags) {
            var itemFlags = E_TTF;
            if (!(flags & F_ALLOW_CALL)) itemFlags = E_TFF;
            var result = [
                this.generateExpression(expr.tag, Precedence.Call, itemFlags),
                this.generateExpression(expr.quasi, Precedence.Primary, E_FFT)
            ];
            return parenthesize(result, Precedence.TaggedTemplate, precedence);
        },
        TemplateElement: function(expr, precedence, flags) {
            // Don't use "cooked". Since tagged template can use raw template
            // representation. So if we do so, it breaks the script semantics.
            return expr.value.raw;
        },
        TemplateLiteral: function(expr, precedence, flags) {
            var result, i, iz;
            result = [
                "`"
            ];
            for(i = 0, iz = expr.quasis.length; i < iz; ++i){
                result.push(this.generateExpression(expr.quasis[i], Precedence.Primary, E_TTT));
                if (i + 1 < iz) {
                    result.push("${" + space);
                    result.push(this.generateExpression(expr.expressions[i], Precedence.Sequence, E_TTT));
                    result.push(space + "}");
                }
            }
            result.push("`");
            return result;
        },
        ModuleSpecifier: function(expr, precedence, flags) {
            return this.Literal(expr, precedence, flags);
        },
        ImportExpression: function(expr, precedence, flag) {
            return parenthesize([
                "import(",
                this.generateExpression(expr.source, Precedence.Assignment, E_TTT),
                ")"
            ], Precedence.Call, precedence);
        }
    };
    merge(CodeGenerator.prototype, CodeGenerator.Expression);
    CodeGenerator.prototype.generateExpression = function(expr, precedence, flags) {
        var result, type;
        type = expr.type || Syntax.Property;
        if (extra.verbatim && expr.hasOwnProperty(extra.verbatim)) return generateVerbatim(expr, precedence);
        result = this[type](expr, precedence, flags);
        if (extra.comment) result = addComments(expr, result);
        return toSourceNodeWhenNeeded(result, expr);
    };
    CodeGenerator.prototype.generateStatement = function(stmt, flags) {
        var result, fragment;
        result = this[stmt.type](stmt, flags);
        // Attach comments
        if (extra.comment) result = addComments(stmt, result);
        fragment = toSourceNodeWhenNeeded(result).toString();
        if (stmt.type === Syntax.Program && !safeConcatenation && newline === "" && fragment.charAt(fragment.length - 1) === "\n") result = sourceMap ? toSourceNodeWhenNeeded(result).replaceRight(/\s+$/, "") : fragment.replace(/\s+$/, "");
        return toSourceNodeWhenNeeded(result, stmt);
    };
    function generateInternal(node) {
        var codegen;
        codegen = new CodeGenerator();
        if (isStatement(node)) return codegen.generateStatement(node, S_TFFF);
        if (isExpression(node)) return codegen.generateExpression(node, Precedence.Sequence, E_TTT);
        throw new Error("Unknown node type: " + node.type);
    }
    function generate(node, options) {
        var defaultOptions = getDefaultOptions(), result, pair;
        if (options != null) {
            // Obsolete options
            //
            //   `options.indent`
            //   `options.base`
            //
            // Instead of them, we can use `option.format.indent`.
            if (typeof options.indent === "string") defaultOptions.format.indent.style = options.indent;
            if (typeof options.base === "number") defaultOptions.format.indent.base = options.base;
            options = updateDeeply(defaultOptions, options);
            indent = options.format.indent.style;
            if (typeof options.base === "string") base = options.base;
            else base = stringRepeat(indent, options.format.indent.base);
        } else {
            options = defaultOptions;
            indent = options.format.indent.style;
            base = stringRepeat(indent, options.format.indent.base);
        }
        json = options.format.json;
        renumber = options.format.renumber;
        hexadecimal = json ? false : options.format.hexadecimal;
        quotes = json ? "double" : options.format.quotes;
        escapeless = options.format.escapeless;
        newline = options.format.newline;
        space = options.format.space;
        if (options.format.compact) newline = space = indent = base = "";
        parentheses = options.format.parentheses;
        semicolons = options.format.semicolons;
        safeConcatenation = options.format.safeConcatenation;
        directive = options.directive;
        parse = json ? null : options.parse;
        sourceMap = options.sourceMap;
        sourceCode = options.sourceCode;
        preserveBlankLines = options.format.preserveBlankLines && sourceCode !== null;
        extra = options;
        if (sourceMap) {
            if (!exports.browser) // We assume environment is node.js
            // And prevent from including source-map by browserify
            SourceNode = require("c5f9fc72858fa13").SourceNode;
            else SourceNode = global.sourceMap.SourceNode;
        }
        result = generateInternal(node);
        if (!sourceMap) {
            pair = {
                code: result.toString(),
                map: null
            };
            return options.sourceMapWithCode ? pair : pair.code;
        }
        pair = result.toStringWithSourceMap({
            file: options.file,
            sourceRoot: options.sourceMapRoot
        });
        if (options.sourceContent) pair.map.setSourceContent(options.sourceMap, options.sourceContent);
        if (options.sourceMapWithCode) return pair;
        return pair.map.toString();
    }
    FORMAT_MINIFY = {
        indent: {
            style: "",
            base: 0
        },
        renumber: true,
        hexadecimal: true,
        quotes: "auto",
        escapeless: true,
        compact: true,
        parentheses: false,
        semicolons: false
    };
    FORMAT_DEFAULTS = getDefaultOptions().format;
    exports.version = require("5a6225acf72ec9cb").version;
    exports.generate = generate;
    exports.attachComments = estraverse.attachComments;
    exports.Precedence = updateDeeply({}, Precedence);
    exports.browser = false;
    exports.FORMAT_MINIFY = FORMAT_MINIFY;
    exports.FORMAT_DEFAULTS = FORMAT_DEFAULTS;
})(); /* vim: set sw=4 ts=4 et tw=80 : */ 

},{"799f69c44c76494b":"3y8xY","860044db75801fad":"d3HGx","c5f9fc72858fa13":"C92fw","5a6225acf72ec9cb":"a56E7"}],"3y8xY":[function(require,module,exports) {
/*
  Copyright (C) 2012-2013 Yusuke Suzuki <utatane.tea@gmail.com>
  Copyright (C) 2012 Ariya Hidayat <ariya.hidayat@gmail.com>

  Redistribution and use in source and binary forms, with or without
  modification, are permitted provided that the following conditions are met:

    * Redistributions of source code must retain the above copyright
      notice, this list of conditions and the following disclaimer.
    * Redistributions in binary form must reproduce the above copyright
      notice, this list of conditions and the following disclaimer in the
      documentation and/or other materials provided with the distribution.

  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
  AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
  IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
  ARE DISCLAIMED. IN NO EVENT SHALL <COPYRIGHT HOLDER> BE LIABLE FOR ANY
  DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
  (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
  LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
  ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
  (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF
  THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/ /*jslint vars:false, bitwise:true*/ /*jshint indent:4*/ /*global exports:true*/ (function clone(exports1) {
    "use strict";
    var Syntax, VisitorOption, VisitorKeys, BREAK, SKIP, REMOVE;
    function deepCopy(obj) {
        var ret = {}, key, val;
        for(key in obj)if (obj.hasOwnProperty(key)) {
            val = obj[key];
            if (typeof val === "object" && val !== null) ret[key] = deepCopy(val);
            else ret[key] = val;
        }
        return ret;
    }
    // based on LLVM libc++ upper_bound / lower_bound
    // MIT License
    function upperBound(array, func) {
        var diff, len, i, current;
        len = array.length;
        i = 0;
        while(len){
            diff = len >>> 1;
            current = i + diff;
            if (func(array[current])) len = diff;
            else {
                i = current + 1;
                len -= diff + 1;
            }
        }
        return i;
    }
    Syntax = {
        AssignmentExpression: "AssignmentExpression",
        AssignmentPattern: "AssignmentPattern",
        ArrayExpression: "ArrayExpression",
        ArrayPattern: "ArrayPattern",
        ArrowFunctionExpression: "ArrowFunctionExpression",
        AwaitExpression: "AwaitExpression",
        BlockStatement: "BlockStatement",
        BinaryExpression: "BinaryExpression",
        BreakStatement: "BreakStatement",
        CallExpression: "CallExpression",
        CatchClause: "CatchClause",
        ChainExpression: "ChainExpression",
        ClassBody: "ClassBody",
        ClassDeclaration: "ClassDeclaration",
        ClassExpression: "ClassExpression",
        ComprehensionBlock: "ComprehensionBlock",
        ComprehensionExpression: "ComprehensionExpression",
        ConditionalExpression: "ConditionalExpression",
        ContinueStatement: "ContinueStatement",
        DebuggerStatement: "DebuggerStatement",
        DirectiveStatement: "DirectiveStatement",
        DoWhileStatement: "DoWhileStatement",
        EmptyStatement: "EmptyStatement",
        ExportAllDeclaration: "ExportAllDeclaration",
        ExportDefaultDeclaration: "ExportDefaultDeclaration",
        ExportNamedDeclaration: "ExportNamedDeclaration",
        ExportSpecifier: "ExportSpecifier",
        ExpressionStatement: "ExpressionStatement",
        ForStatement: "ForStatement",
        ForInStatement: "ForInStatement",
        ForOfStatement: "ForOfStatement",
        FunctionDeclaration: "FunctionDeclaration",
        FunctionExpression: "FunctionExpression",
        GeneratorExpression: "GeneratorExpression",
        Identifier: "Identifier",
        IfStatement: "IfStatement",
        ImportExpression: "ImportExpression",
        ImportDeclaration: "ImportDeclaration",
        ImportDefaultSpecifier: "ImportDefaultSpecifier",
        ImportNamespaceSpecifier: "ImportNamespaceSpecifier",
        ImportSpecifier: "ImportSpecifier",
        Literal: "Literal",
        LabeledStatement: "LabeledStatement",
        LogicalExpression: "LogicalExpression",
        MemberExpression: "MemberExpression",
        MetaProperty: "MetaProperty",
        MethodDefinition: "MethodDefinition",
        ModuleSpecifier: "ModuleSpecifier",
        NewExpression: "NewExpression",
        ObjectExpression: "ObjectExpression",
        ObjectPattern: "ObjectPattern",
        PrivateIdentifier: "PrivateIdentifier",
        Program: "Program",
        Property: "Property",
        PropertyDefinition: "PropertyDefinition",
        RestElement: "RestElement",
        ReturnStatement: "ReturnStatement",
        SequenceExpression: "SequenceExpression",
        SpreadElement: "SpreadElement",
        Super: "Super",
        SwitchStatement: "SwitchStatement",
        SwitchCase: "SwitchCase",
        TaggedTemplateExpression: "TaggedTemplateExpression",
        TemplateElement: "TemplateElement",
        TemplateLiteral: "TemplateLiteral",
        ThisExpression: "ThisExpression",
        ThrowStatement: "ThrowStatement",
        TryStatement: "TryStatement",
        UnaryExpression: "UnaryExpression",
        UpdateExpression: "UpdateExpression",
        VariableDeclaration: "VariableDeclaration",
        VariableDeclarator: "VariableDeclarator",
        WhileStatement: "WhileStatement",
        WithStatement: "WithStatement",
        YieldExpression: "YieldExpression"
    };
    VisitorKeys = {
        AssignmentExpression: [
            "left",
            "right"
        ],
        AssignmentPattern: [
            "left",
            "right"
        ],
        ArrayExpression: [
            "elements"
        ],
        ArrayPattern: [
            "elements"
        ],
        ArrowFunctionExpression: [
            "params",
            "body"
        ],
        AwaitExpression: [
            "argument"
        ],
        BlockStatement: [
            "body"
        ],
        BinaryExpression: [
            "left",
            "right"
        ],
        BreakStatement: [
            "label"
        ],
        CallExpression: [
            "callee",
            "arguments"
        ],
        CatchClause: [
            "param",
            "body"
        ],
        ChainExpression: [
            "expression"
        ],
        ClassBody: [
            "body"
        ],
        ClassDeclaration: [
            "id",
            "superClass",
            "body"
        ],
        ClassExpression: [
            "id",
            "superClass",
            "body"
        ],
        ComprehensionBlock: [
            "left",
            "right"
        ],
        ComprehensionExpression: [
            "blocks",
            "filter",
            "body"
        ],
        ConditionalExpression: [
            "test",
            "consequent",
            "alternate"
        ],
        ContinueStatement: [
            "label"
        ],
        DebuggerStatement: [],
        DirectiveStatement: [],
        DoWhileStatement: [
            "body",
            "test"
        ],
        EmptyStatement: [],
        ExportAllDeclaration: [
            "source"
        ],
        ExportDefaultDeclaration: [
            "declaration"
        ],
        ExportNamedDeclaration: [
            "declaration",
            "specifiers",
            "source"
        ],
        ExportSpecifier: [
            "exported",
            "local"
        ],
        ExpressionStatement: [
            "expression"
        ],
        ForStatement: [
            "init",
            "test",
            "update",
            "body"
        ],
        ForInStatement: [
            "left",
            "right",
            "body"
        ],
        ForOfStatement: [
            "left",
            "right",
            "body"
        ],
        FunctionDeclaration: [
            "id",
            "params",
            "body"
        ],
        FunctionExpression: [
            "id",
            "params",
            "body"
        ],
        GeneratorExpression: [
            "blocks",
            "filter",
            "body"
        ],
        Identifier: [],
        IfStatement: [
            "test",
            "consequent",
            "alternate"
        ],
        ImportExpression: [
            "source"
        ],
        ImportDeclaration: [
            "specifiers",
            "source"
        ],
        ImportDefaultSpecifier: [
            "local"
        ],
        ImportNamespaceSpecifier: [
            "local"
        ],
        ImportSpecifier: [
            "imported",
            "local"
        ],
        Literal: [],
        LabeledStatement: [
            "label",
            "body"
        ],
        LogicalExpression: [
            "left",
            "right"
        ],
        MemberExpression: [
            "object",
            "property"
        ],
        MetaProperty: [
            "meta",
            "property"
        ],
        MethodDefinition: [
            "key",
            "value"
        ],
        ModuleSpecifier: [],
        NewExpression: [
            "callee",
            "arguments"
        ],
        ObjectExpression: [
            "properties"
        ],
        ObjectPattern: [
            "properties"
        ],
        PrivateIdentifier: [],
        Program: [
            "body"
        ],
        Property: [
            "key",
            "value"
        ],
        PropertyDefinition: [
            "key",
            "value"
        ],
        RestElement: [
            "argument"
        ],
        ReturnStatement: [
            "argument"
        ],
        SequenceExpression: [
            "expressions"
        ],
        SpreadElement: [
            "argument"
        ],
        Super: [],
        SwitchStatement: [
            "discriminant",
            "cases"
        ],
        SwitchCase: [
            "test",
            "consequent"
        ],
        TaggedTemplateExpression: [
            "tag",
            "quasi"
        ],
        TemplateElement: [],
        TemplateLiteral: [
            "quasis",
            "expressions"
        ],
        ThisExpression: [],
        ThrowStatement: [
            "argument"
        ],
        TryStatement: [
            "block",
            "handler",
            "finalizer"
        ],
        UnaryExpression: [
            "argument"
        ],
        UpdateExpression: [
            "argument"
        ],
        VariableDeclaration: [
            "declarations"
        ],
        VariableDeclarator: [
            "id",
            "init"
        ],
        WhileStatement: [
            "test",
            "body"
        ],
        WithStatement: [
            "object",
            "body"
        ],
        YieldExpression: [
            "argument"
        ]
    };
    // unique id
    BREAK = {};
    SKIP = {};
    REMOVE = {};
    VisitorOption = {
        Break: BREAK,
        Skip: SKIP,
        Remove: REMOVE
    };
    function Reference(parent, key) {
        this.parent = parent;
        this.key = key;
    }
    Reference.prototype.replace = function replace(node) {
        this.parent[this.key] = node;
    };
    Reference.prototype.remove = function remove() {
        if (Array.isArray(this.parent)) {
            this.parent.splice(this.key, 1);
            return true;
        } else {
            this.replace(null);
            return false;
        }
    };
    function Element(node, path, wrap, ref) {
        this.node = node;
        this.path = path;
        this.wrap = wrap;
        this.ref = ref;
    }
    function Controller() {}
    // API:
    // return property path array from root to current node
    Controller.prototype.path = function path() {
        var i, iz, j, jz, result, element;
        function addToPath(result, path) {
            if (Array.isArray(path)) for(j = 0, jz = path.length; j < jz; ++j)result.push(path[j]);
            else result.push(path);
        }
        // root node
        if (!this.__current.path) return null;
        // first node is sentinel, second node is root element
        result = [];
        for(i = 2, iz = this.__leavelist.length; i < iz; ++i){
            element = this.__leavelist[i];
            addToPath(result, element.path);
        }
        addToPath(result, this.__current.path);
        return result;
    };
    // API:
    // return type of current node
    Controller.prototype.type = function() {
        var node = this.current();
        return node.type || this.__current.wrap;
    };
    // API:
    // return array of parent elements
    Controller.prototype.parents = function parents() {
        var i, iz, result;
        // first node is sentinel
        result = [];
        for(i = 1, iz = this.__leavelist.length; i < iz; ++i)result.push(this.__leavelist[i].node);
        return result;
    };
    // API:
    // return current node
    Controller.prototype.current = function current() {
        return this.__current.node;
    };
    Controller.prototype.__execute = function __execute(callback, element) {
        var previous, result;
        result = undefined;
        previous = this.__current;
        this.__current = element;
        this.__state = null;
        if (callback) result = callback.call(this, element.node, this.__leavelist[this.__leavelist.length - 1].node);
        this.__current = previous;
        return result;
    };
    // API:
    // notify control skip / break
    Controller.prototype.notify = function notify(flag) {
        this.__state = flag;
    };
    // API:
    // skip child nodes of current node
    Controller.prototype.skip = function() {
        this.notify(SKIP);
    };
    // API:
    // break traversals
    Controller.prototype["break"] = function() {
        this.notify(BREAK);
    };
    // API:
    // remove node
    Controller.prototype.remove = function() {
        this.notify(REMOVE);
    };
    Controller.prototype.__initialize = function(root, visitor) {
        this.visitor = visitor;
        this.root = root;
        this.__worklist = [];
        this.__leavelist = [];
        this.__current = null;
        this.__state = null;
        this.__fallback = null;
        if (visitor.fallback === "iteration") this.__fallback = Object.keys;
        else if (typeof visitor.fallback === "function") this.__fallback = visitor.fallback;
        this.__keys = VisitorKeys;
        if (visitor.keys) this.__keys = Object.assign(Object.create(this.__keys), visitor.keys);
    };
    function isNode(node) {
        if (node == null) return false;
        return typeof node === "object" && typeof node.type === "string";
    }
    function isProperty(nodeType, key) {
        return (nodeType === Syntax.ObjectExpression || nodeType === Syntax.ObjectPattern) && "properties" === key;
    }
    function candidateExistsInLeaveList(leavelist, candidate) {
        for(var i = leavelist.length - 1; i >= 0; --i){
            if (leavelist[i].node === candidate) return true;
        }
        return false;
    }
    Controller.prototype.traverse = function traverse(root, visitor) {
        var worklist, leavelist, element, node, nodeType, ret, key, current, current2, candidates, candidate, sentinel;
        this.__initialize(root, visitor);
        sentinel = {};
        // reference
        worklist = this.__worklist;
        leavelist = this.__leavelist;
        // initialize
        worklist.push(new Element(root, null, null, null));
        leavelist.push(new Element(null, null, null, null));
        while(worklist.length){
            element = worklist.pop();
            if (element === sentinel) {
                element = leavelist.pop();
                ret = this.__execute(visitor.leave, element);
                if (this.__state === BREAK || ret === BREAK) return;
                continue;
            }
            if (element.node) {
                ret = this.__execute(visitor.enter, element);
                if (this.__state === BREAK || ret === BREAK) return;
                worklist.push(sentinel);
                leavelist.push(element);
                if (this.__state === SKIP || ret === SKIP) continue;
                node = element.node;
                nodeType = node.type || element.wrap;
                candidates = this.__keys[nodeType];
                if (!candidates) {
                    if (this.__fallback) candidates = this.__fallback(node);
                    else throw new Error("Unknown node type " + nodeType + ".");
                }
                current = candidates.length;
                while((current -= 1) >= 0){
                    key = candidates[current];
                    candidate = node[key];
                    if (!candidate) continue;
                    if (Array.isArray(candidate)) {
                        current2 = candidate.length;
                        while((current2 -= 1) >= 0){
                            if (!candidate[current2]) continue;
                            if (candidateExistsInLeaveList(leavelist, candidate[current2])) continue;
                            if (isProperty(nodeType, candidates[current])) element = new Element(candidate[current2], [
                                key,
                                current2
                            ], "Property", null);
                            else if (isNode(candidate[current2])) element = new Element(candidate[current2], [
                                key,
                                current2
                            ], null, null);
                            else continue;
                            worklist.push(element);
                        }
                    } else if (isNode(candidate)) {
                        if (candidateExistsInLeaveList(leavelist, candidate)) continue;
                        worklist.push(new Element(candidate, key, null, null));
                    }
                }
            }
        }
    };
    Controller.prototype.replace = function replace(root, visitor) {
        var worklist, leavelist, node, nodeType, target, element, current, current2, candidates, candidate, sentinel, outer, key;
        function removeElem(element) {
            var i, key, nextElem, parent;
            if (element.ref.remove()) {
                // When the reference is an element of an array.
                key = element.ref.key;
                parent = element.ref.parent;
                // If removed from array, then decrease following items' keys.
                i = worklist.length;
                while(i--){
                    nextElem = worklist[i];
                    if (nextElem.ref && nextElem.ref.parent === parent) {
                        if (nextElem.ref.key < key) break;
                        --nextElem.ref.key;
                    }
                }
            }
        }
        this.__initialize(root, visitor);
        sentinel = {};
        // reference
        worklist = this.__worklist;
        leavelist = this.__leavelist;
        // initialize
        outer = {
            root: root
        };
        element = new Element(root, null, null, new Reference(outer, "root"));
        worklist.push(element);
        leavelist.push(element);
        while(worklist.length){
            element = worklist.pop();
            if (element === sentinel) {
                element = leavelist.pop();
                target = this.__execute(visitor.leave, element);
                // node may be replaced with null,
                // so distinguish between undefined and null in this place
                if (target !== undefined && target !== BREAK && target !== SKIP && target !== REMOVE) // replace
                element.ref.replace(target);
                if (this.__state === REMOVE || target === REMOVE) removeElem(element);
                if (this.__state === BREAK || target === BREAK) return outer.root;
                continue;
            }
            target = this.__execute(visitor.enter, element);
            // node may be replaced with null,
            // so distinguish between undefined and null in this place
            if (target !== undefined && target !== BREAK && target !== SKIP && target !== REMOVE) {
                // replace
                element.ref.replace(target);
                element.node = target;
            }
            if (this.__state === REMOVE || target === REMOVE) {
                removeElem(element);
                element.node = null;
            }
            if (this.__state === BREAK || target === BREAK) return outer.root;
            // node may be null
            node = element.node;
            if (!node) continue;
            worklist.push(sentinel);
            leavelist.push(element);
            if (this.__state === SKIP || target === SKIP) continue;
            nodeType = node.type || element.wrap;
            candidates = this.__keys[nodeType];
            if (!candidates) {
                if (this.__fallback) candidates = this.__fallback(node);
                else throw new Error("Unknown node type " + nodeType + ".");
            }
            current = candidates.length;
            while((current -= 1) >= 0){
                key = candidates[current];
                candidate = node[key];
                if (!candidate) continue;
                if (Array.isArray(candidate)) {
                    current2 = candidate.length;
                    while((current2 -= 1) >= 0){
                        if (!candidate[current2]) continue;
                        if (isProperty(nodeType, candidates[current])) element = new Element(candidate[current2], [
                            key,
                            current2
                        ], "Property", new Reference(candidate, current2));
                        else if (isNode(candidate[current2])) element = new Element(candidate[current2], [
                            key,
                            current2
                        ], null, new Reference(candidate, current2));
                        else continue;
                        worklist.push(element);
                    }
                } else if (isNode(candidate)) worklist.push(new Element(candidate, key, null, new Reference(node, key)));
            }
        }
        return outer.root;
    };
    function traverse(root, visitor) {
        var controller = new Controller();
        return controller.traverse(root, visitor);
    }
    function replace(root, visitor) {
        var controller = new Controller();
        return controller.replace(root, visitor);
    }
    function extendCommentRange(comment, tokens) {
        var target;
        target = upperBound(tokens, function search(token) {
            return token.range[0] > comment.range[0];
        });
        comment.extendedRange = [
            comment.range[0],
            comment.range[1]
        ];
        if (target !== tokens.length) comment.extendedRange[1] = tokens[target].range[0];
        target -= 1;
        if (target >= 0) comment.extendedRange[0] = tokens[target].range[1];
        return comment;
    }
    function attachComments(tree, providedComments, tokens) {
        // At first, we should calculate extended comment ranges.
        var comments = [], comment, len, i, cursor;
        if (!tree.range) throw new Error("attachComments needs range information");
        // tokens array is empty, we attach comments to tree as 'leadingComments'
        if (!tokens.length) {
            if (providedComments.length) {
                for(i = 0, len = providedComments.length; i < len; i += 1){
                    comment = deepCopy(providedComments[i]);
                    comment.extendedRange = [
                        0,
                        tree.range[0]
                    ];
                    comments.push(comment);
                }
                tree.leadingComments = comments;
            }
            return tree;
        }
        for(i = 0, len = providedComments.length; i < len; i += 1)comments.push(extendCommentRange(deepCopy(providedComments[i]), tokens));
        // This is based on John Freeman's implementation.
        cursor = 0;
        traverse(tree, {
            enter: function(node) {
                var comment;
                while(cursor < comments.length){
                    comment = comments[cursor];
                    if (comment.extendedRange[1] > node.range[0]) break;
                    if (comment.extendedRange[1] === node.range[0]) {
                        if (!node.leadingComments) node.leadingComments = [];
                        node.leadingComments.push(comment);
                        comments.splice(cursor, 1);
                    } else cursor += 1;
                }
                // already out of owned node
                if (cursor === comments.length) return VisitorOption.Break;
                if (comments[cursor].extendedRange[0] > node.range[1]) return VisitorOption.Skip;
            }
        });
        cursor = 0;
        traverse(tree, {
            leave: function(node) {
                var comment;
                while(cursor < comments.length){
                    comment = comments[cursor];
                    if (node.range[1] < comment.extendedRange[0]) break;
                    if (node.range[1] === comment.extendedRange[0]) {
                        if (!node.trailingComments) node.trailingComments = [];
                        node.trailingComments.push(comment);
                        comments.splice(cursor, 1);
                    } else cursor += 1;
                }
                // already out of owned node
                if (cursor === comments.length) return VisitorOption.Break;
                if (comments[cursor].extendedRange[0] > node.range[1]) return VisitorOption.Skip;
            }
        });
        return tree;
    }
    exports1.Syntax = Syntax;
    exports1.traverse = traverse;
    exports1.replace = replace;
    exports1.attachComments = attachComments;
    exports1.VisitorKeys = VisitorKeys;
    exports1.VisitorOption = VisitorOption;
    exports1.Controller = Controller;
    exports1.cloneEnvironment = function() {
        return clone({});
    };
    return exports1;
})(exports); /* vim: set sw=4 ts=4 et tw=80 : */ 

},{}],"C92fw":[function(require,module,exports) {
/*
 * Copyright 2009-2011 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE.txt or:
 * http://opensource.org/licenses/BSD-3-Clause
 */ exports.SourceMapGenerator = require("4f3489f7a4aa86a").SourceMapGenerator;
exports.SourceMapConsumer = require("74f5da57ddba8e").SourceMapConsumer;
exports.SourceNode = require("24e5bc41542c0363").SourceNode;

},{"4f3489f7a4aa86a":"16QvG","74f5da57ddba8e":"gBAiL","24e5bc41542c0363":"f6lQj"}],"16QvG":[function(require,module,exports) {
/* -*- Mode: js; js-indent-level: 2; -*- */ /*
 * Copyright 2011 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE or:
 * http://opensource.org/licenses/BSD-3-Clause
 */ var base64VLQ = require("c40e1500640cbc22");
var util = require("c65fbfec2259bb0f");
var ArraySet = require("fce2ada3f2269665").ArraySet;
var MappingList = require("2ae94379d5b0c785").MappingList;
/**
 * An instance of the SourceMapGenerator represents a source map which is
 * being built incrementally. You may pass an object with the following
 * properties:
 *
 *   - file: The filename of the generated source.
 *   - sourceRoot: A root for all relative URLs in this source map.
 */ function SourceMapGenerator(aArgs) {
    if (!aArgs) aArgs = {};
    this._file = util.getArg(aArgs, "file", null);
    this._sourceRoot = util.getArg(aArgs, "sourceRoot", null);
    this._skipValidation = util.getArg(aArgs, "skipValidation", false);
    this._sources = new ArraySet();
    this._names = new ArraySet();
    this._mappings = new MappingList();
    this._sourcesContents = null;
}
SourceMapGenerator.prototype._version = 3;
/**
 * Creates a new SourceMapGenerator based on a SourceMapConsumer
 *
 * @param aSourceMapConsumer The SourceMap.
 */ SourceMapGenerator.fromSourceMap = function SourceMapGenerator_fromSourceMap(aSourceMapConsumer) {
    var sourceRoot = aSourceMapConsumer.sourceRoot;
    var generator = new SourceMapGenerator({
        file: aSourceMapConsumer.file,
        sourceRoot: sourceRoot
    });
    aSourceMapConsumer.eachMapping(function(mapping) {
        var newMapping = {
            generated: {
                line: mapping.generatedLine,
                column: mapping.generatedColumn
            }
        };
        if (mapping.source != null) {
            newMapping.source = mapping.source;
            if (sourceRoot != null) newMapping.source = util.relative(sourceRoot, newMapping.source);
            newMapping.original = {
                line: mapping.originalLine,
                column: mapping.originalColumn
            };
            if (mapping.name != null) newMapping.name = mapping.name;
        }
        generator.addMapping(newMapping);
    });
    aSourceMapConsumer.sources.forEach(function(sourceFile) {
        var sourceRelative = sourceFile;
        if (sourceRoot !== null) sourceRelative = util.relative(sourceRoot, sourceFile);
        if (!generator._sources.has(sourceRelative)) generator._sources.add(sourceRelative);
        var content = aSourceMapConsumer.sourceContentFor(sourceFile);
        if (content != null) generator.setSourceContent(sourceFile, content);
    });
    return generator;
};
/**
 * Add a single mapping from original source line and column to the generated
 * source's line and column for this source map being created. The mapping
 * object should have the following properties:
 *
 *   - generated: An object with the generated line and column positions.
 *   - original: An object with the original line and column positions.
 *   - source: The original source file (relative to the sourceRoot).
 *   - name: An optional original token name for this mapping.
 */ SourceMapGenerator.prototype.addMapping = function SourceMapGenerator_addMapping(aArgs) {
    var generated = util.getArg(aArgs, "generated");
    var original = util.getArg(aArgs, "original", null);
    var source = util.getArg(aArgs, "source", null);
    var name = util.getArg(aArgs, "name", null);
    if (!this._skipValidation) this._validateMapping(generated, original, source, name);
    if (source != null) {
        source = String(source);
        if (!this._sources.has(source)) this._sources.add(source);
    }
    if (name != null) {
        name = String(name);
        if (!this._names.has(name)) this._names.add(name);
    }
    this._mappings.add({
        generatedLine: generated.line,
        generatedColumn: generated.column,
        originalLine: original != null && original.line,
        originalColumn: original != null && original.column,
        source: source,
        name: name
    });
};
/**
 * Set the source content for a source file.
 */ SourceMapGenerator.prototype.setSourceContent = function SourceMapGenerator_setSourceContent(aSourceFile, aSourceContent) {
    var source = aSourceFile;
    if (this._sourceRoot != null) source = util.relative(this._sourceRoot, source);
    if (aSourceContent != null) {
        // Add the source content to the _sourcesContents map.
        // Create a new _sourcesContents map if the property is null.
        if (!this._sourcesContents) this._sourcesContents = Object.create(null);
        this._sourcesContents[util.toSetString(source)] = aSourceContent;
    } else if (this._sourcesContents) {
        // Remove the source file from the _sourcesContents map.
        // If the _sourcesContents map is empty, set the property to null.
        delete this._sourcesContents[util.toSetString(source)];
        if (Object.keys(this._sourcesContents).length === 0) this._sourcesContents = null;
    }
};
/**
 * Applies the mappings of a sub-source-map for a specific source file to the
 * source map being generated. Each mapping to the supplied source file is
 * rewritten using the supplied source map. Note: The resolution for the
 * resulting mappings is the minimium of this map and the supplied map.
 *
 * @param aSourceMapConsumer The source map to be applied.
 * @param aSourceFile Optional. The filename of the source file.
 *        If omitted, SourceMapConsumer's file property will be used.
 * @param aSourceMapPath Optional. The dirname of the path to the source map
 *        to be applied. If relative, it is relative to the SourceMapConsumer.
 *        This parameter is needed when the two source maps aren't in the same
 *        directory, and the source map to be applied contains relative source
 *        paths. If so, those relative source paths need to be rewritten
 *        relative to the SourceMapGenerator.
 */ SourceMapGenerator.prototype.applySourceMap = function SourceMapGenerator_applySourceMap(aSourceMapConsumer, aSourceFile, aSourceMapPath) {
    var sourceFile = aSourceFile;
    // If aSourceFile is omitted, we will use the file property of the SourceMap
    if (aSourceFile == null) {
        if (aSourceMapConsumer.file == null) throw new Error('SourceMapGenerator.prototype.applySourceMap requires either an explicit source file, or the source map\'s "file" property. Both were omitted.');
        sourceFile = aSourceMapConsumer.file;
    }
    var sourceRoot = this._sourceRoot;
    // Make "sourceFile" relative if an absolute Url is passed.
    if (sourceRoot != null) sourceFile = util.relative(sourceRoot, sourceFile);
    // Applying the SourceMap can add and remove items from the sources and
    // the names array.
    var newSources = new ArraySet();
    var newNames = new ArraySet();
    // Find mappings for the "sourceFile"
    this._mappings.unsortedForEach(function(mapping) {
        if (mapping.source === sourceFile && mapping.originalLine != null) {
            // Check if it can be mapped by the source map, then update the mapping.
            var original = aSourceMapConsumer.originalPositionFor({
                line: mapping.originalLine,
                column: mapping.originalColumn
            });
            if (original.source != null) {
                // Copy mapping
                mapping.source = original.source;
                if (aSourceMapPath != null) mapping.source = util.join(aSourceMapPath, mapping.source);
                if (sourceRoot != null) mapping.source = util.relative(sourceRoot, mapping.source);
                mapping.originalLine = original.line;
                mapping.originalColumn = original.column;
                if (original.name != null) mapping.name = original.name;
            }
        }
        var source = mapping.source;
        if (source != null && !newSources.has(source)) newSources.add(source);
        var name = mapping.name;
        if (name != null && !newNames.has(name)) newNames.add(name);
    }, this);
    this._sources = newSources;
    this._names = newNames;
    // Copy sourcesContents of applied map.
    aSourceMapConsumer.sources.forEach(function(sourceFile) {
        var content = aSourceMapConsumer.sourceContentFor(sourceFile);
        if (content != null) {
            if (aSourceMapPath != null) sourceFile = util.join(aSourceMapPath, sourceFile);
            if (sourceRoot != null) sourceFile = util.relative(sourceRoot, sourceFile);
            this.setSourceContent(sourceFile, content);
        }
    }, this);
};
/**
 * A mapping can have one of the three levels of data:
 *
 *   1. Just the generated position.
 *   2. The Generated position, original position, and original source.
 *   3. Generated and original position, original source, as well as a name
 *      token.
 *
 * To maintain consistency, we validate that any new mapping being added falls
 * in to one of these categories.
 */ SourceMapGenerator.prototype._validateMapping = function SourceMapGenerator_validateMapping(aGenerated, aOriginal, aSource, aName) {
    // When aOriginal is truthy but has empty values for .line and .column,
    // it is most likely a programmer error. In this case we throw a very
    // specific error message to try to guide them the right way.
    // For example: https://github.com/Polymer/polymer-bundler/pull/519
    if (aOriginal && typeof aOriginal.line !== "number" && typeof aOriginal.column !== "number") throw new Error("original.line and original.column are not numbers -- you probably meant to omit the original mapping entirely and only map the generated position. If so, pass null for the original mapping instead of an object with empty or null values.");
    if (aGenerated && "line" in aGenerated && "column" in aGenerated && aGenerated.line > 0 && aGenerated.column >= 0 && !aOriginal && !aSource && !aName) // Case 1.
    return;
    else if (aGenerated && "line" in aGenerated && "column" in aGenerated && aOriginal && "line" in aOriginal && "column" in aOriginal && aGenerated.line > 0 && aGenerated.column >= 0 && aOriginal.line > 0 && aOriginal.column >= 0 && aSource) // Cases 2 and 3.
    return;
    else throw new Error("Invalid mapping: " + JSON.stringify({
        generated: aGenerated,
        source: aSource,
        original: aOriginal,
        name: aName
    }));
};
/**
 * Serialize the accumulated mappings in to the stream of base 64 VLQs
 * specified by the source map format.
 */ SourceMapGenerator.prototype._serializeMappings = function SourceMapGenerator_serializeMappings() {
    var previousGeneratedColumn = 0;
    var previousGeneratedLine = 1;
    var previousOriginalColumn = 0;
    var previousOriginalLine = 0;
    var previousName = 0;
    var previousSource = 0;
    var result = "";
    var next;
    var mapping;
    var nameIdx;
    var sourceIdx;
    var mappings = this._mappings.toArray();
    for(var i = 0, len = mappings.length; i < len; i++){
        mapping = mappings[i];
        next = "";
        if (mapping.generatedLine !== previousGeneratedLine) {
            previousGeneratedColumn = 0;
            while(mapping.generatedLine !== previousGeneratedLine){
                next += ";";
                previousGeneratedLine++;
            }
        } else if (i > 0) {
            if (!util.compareByGeneratedPositionsInflated(mapping, mappings[i - 1])) continue;
            next += ",";
        }
        next += base64VLQ.encode(mapping.generatedColumn - previousGeneratedColumn);
        previousGeneratedColumn = mapping.generatedColumn;
        if (mapping.source != null) {
            sourceIdx = this._sources.indexOf(mapping.source);
            next += base64VLQ.encode(sourceIdx - previousSource);
            previousSource = sourceIdx;
            // lines are stored 0-based in SourceMap spec version 3
            next += base64VLQ.encode(mapping.originalLine - 1 - previousOriginalLine);
            previousOriginalLine = mapping.originalLine - 1;
            next += base64VLQ.encode(mapping.originalColumn - previousOriginalColumn);
            previousOriginalColumn = mapping.originalColumn;
            if (mapping.name != null) {
                nameIdx = this._names.indexOf(mapping.name);
                next += base64VLQ.encode(nameIdx - previousName);
                previousName = nameIdx;
            }
        }
        result += next;
    }
    return result;
};
SourceMapGenerator.prototype._generateSourcesContent = function SourceMapGenerator_generateSourcesContent(aSources, aSourceRoot) {
    return aSources.map(function(source) {
        if (!this._sourcesContents) return null;
        if (aSourceRoot != null) source = util.relative(aSourceRoot, source);
        var key = util.toSetString(source);
        return Object.prototype.hasOwnProperty.call(this._sourcesContents, key) ? this._sourcesContents[key] : null;
    }, this);
};
/**
 * Externalize the source map.
 */ SourceMapGenerator.prototype.toJSON = function SourceMapGenerator_toJSON() {
    var map = {
        version: this._version,
        sources: this._sources.toArray(),
        names: this._names.toArray(),
        mappings: this._serializeMappings()
    };
    if (this._file != null) map.file = this._file;
    if (this._sourceRoot != null) map.sourceRoot = this._sourceRoot;
    if (this._sourcesContents) map.sourcesContent = this._generateSourcesContent(map.sources, map.sourceRoot);
    return map;
};
/**
 * Render the source map being generated to a string.
 */ SourceMapGenerator.prototype.toString = function SourceMapGenerator_toString() {
    return JSON.stringify(this.toJSON());
};
exports.SourceMapGenerator = SourceMapGenerator;

},{"c40e1500640cbc22":"5jlsn","c65fbfec2259bb0f":"3gsUu","fce2ada3f2269665":"5VumI","2ae94379d5b0c785":"9Bvrn"}],"5jlsn":[function(require,module,exports) {
/* -*- Mode: js; js-indent-level: 2; -*- */ /*
 * Copyright 2011 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE or:
 * http://opensource.org/licenses/BSD-3-Clause
 *
 * Based on the Base 64 VLQ implementation in Closure Compiler:
 * https://code.google.com/p/closure-compiler/source/browse/trunk/src/com/google/debugging/sourcemap/Base64VLQ.java
 *
 * Copyright 2011 The Closure Compiler Authors. All rights reserved.
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are
 * met:
 *
 *  * Redistributions of source code must retain the above copyright
 *    notice, this list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above
 *    copyright notice, this list of conditions and the following
 *    disclaimer in the documentation and/or other materials provided
 *    with the distribution.
 *  * Neither the name of Google Inc. nor the names of its
 *    contributors may be used to endorse or promote products derived
 *    from this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
 * A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT
 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
 * LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE,
 * DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY
 * THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
 * OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */ var base64 = require("9fcf0c64c293678d");
// A single base 64 digit can contain 6 bits of data. For the base 64 variable
// length quantities we use in the source map spec, the first bit is the sign,
// the next four bits are the actual value, and the 6th bit is the
// continuation bit. The continuation bit tells us whether there are more
// digits in this value following this digit.
//
//   Continuation
//   |    Sign
//   |    |
//   V    V
//   101011
var VLQ_BASE_SHIFT = 5;
// binary: 100000
var VLQ_BASE = 1 << VLQ_BASE_SHIFT;
// binary: 011111
var VLQ_BASE_MASK = VLQ_BASE - 1;
// binary: 100000
var VLQ_CONTINUATION_BIT = VLQ_BASE;
/**
 * Converts from a two-complement value to a value where the sign bit is
 * placed in the least significant bit.  For example, as decimals:
 *   1 becomes 2 (10 binary), -1 becomes 3 (11 binary)
 *   2 becomes 4 (100 binary), -2 becomes 5 (101 binary)
 */ function toVLQSigned(aValue) {
    return aValue < 0 ? (-aValue << 1) + 1 : (aValue << 1) + 0;
}
/**
 * Converts to a two-complement value from a value where the sign bit is
 * placed in the least significant bit.  For example, as decimals:
 *   2 (10 binary) becomes 1, 3 (11 binary) becomes -1
 *   4 (100 binary) becomes 2, 5 (101 binary) becomes -2
 */ function fromVLQSigned(aValue) {
    var isNegative = (aValue & 1) === 1;
    var shifted = aValue >> 1;
    return isNegative ? -shifted : shifted;
}
/**
 * Returns the base 64 VLQ encoded value.
 */ exports.encode = function base64VLQ_encode(aValue) {
    var encoded = "";
    var digit;
    var vlq = toVLQSigned(aValue);
    do {
        digit = vlq & VLQ_BASE_MASK;
        vlq >>>= VLQ_BASE_SHIFT;
        if (vlq > 0) // There are still more digits in this value, so we must make sure the
        // continuation bit is marked.
        digit |= VLQ_CONTINUATION_BIT;
        encoded += base64.encode(digit);
    }while (vlq > 0);
    return encoded;
};
/**
 * Decodes the next base 64 VLQ value from the given string and returns the
 * value and the rest of the string via the out parameter.
 */ exports.decode = function base64VLQ_decode(aStr, aIndex, aOutParam) {
    var strLen = aStr.length;
    var result = 0;
    var shift = 0;
    var continuation, digit;
    do {
        if (aIndex >= strLen) throw new Error("Expected more digits in base 64 VLQ value.");
        digit = base64.decode(aStr.charCodeAt(aIndex++));
        if (digit === -1) throw new Error("Invalid base64 digit: " + aStr.charAt(aIndex - 1));
        continuation = !!(digit & VLQ_CONTINUATION_BIT);
        digit &= VLQ_BASE_MASK;
        result = result + (digit << shift);
        shift += VLQ_BASE_SHIFT;
    }while (continuation);
    aOutParam.value = fromVLQSigned(result);
    aOutParam.rest = aIndex;
};

},{"9fcf0c64c293678d":"8yhGH"}],"8yhGH":[function(require,module,exports) {
/* -*- Mode: js; js-indent-level: 2; -*- */ /*
 * Copyright 2011 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE or:
 * http://opensource.org/licenses/BSD-3-Clause
 */ var intToCharMap = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/".split("");
/**
 * Encode an integer in the range of 0 to 63 to a single base 64 digit.
 */ exports.encode = function(number) {
    if (0 <= number && number < intToCharMap.length) return intToCharMap[number];
    throw new TypeError("Must be between 0 and 63: " + number);
};
/**
 * Decode a single base 64 character code digit to an integer. Returns -1 on
 * failure.
 */ exports.decode = function(charCode) {
    var bigA = 65; // 'A'
    var bigZ = 90; // 'Z'
    var littleA = 97; // 'a'
    var littleZ = 122; // 'z'
    var zero = 48; // '0'
    var nine = 57; // '9'
    var plus = 43; // '+'
    var slash = 47; // '/'
    var littleOffset = 26;
    var numberOffset = 52;
    // 0 - 25: ABCDEFGHIJKLMNOPQRSTUVWXYZ
    if (bigA <= charCode && charCode <= bigZ) return charCode - bigA;
    // 26 - 51: abcdefghijklmnopqrstuvwxyz
    if (littleA <= charCode && charCode <= littleZ) return charCode - littleA + littleOffset;
    // 52 - 61: 0123456789
    if (zero <= charCode && charCode <= nine) return charCode - zero + numberOffset;
    // 62: +
    if (charCode == plus) return 62;
    // 63: /
    if (charCode == slash) return 63;
    // Invalid base64 digit.
    return -1;
};

},{}],"3gsUu":[function(require,module,exports) {
/* -*- Mode: js; js-indent-level: 2; -*- */ /*
 * Copyright 2011 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE or:
 * http://opensource.org/licenses/BSD-3-Clause
 */ /**
 * This is a helper function for getting values from parameter/options
 * objects.
 *
 * @param args The object we are extracting values from
 * @param name The name of the property we are getting.
 * @param defaultValue An optional value to return if the property is missing
 * from the object. If this is not specified and the property is missing, an
 * error will be thrown.
 */ function getArg(aArgs, aName, aDefaultValue) {
    if (aName in aArgs) return aArgs[aName];
    else if (arguments.length === 3) return aDefaultValue;
    else throw new Error('"' + aName + '" is a required argument.');
}
exports.getArg = getArg;
var urlRegexp = /^(?:([\w+\-.]+):)?\/\/(?:(\w+:\w+)@)?([\w.-]*)(?::(\d+))?(.*)$/;
var dataUrlRegexp = /^data:.+\,.+$/;
function urlParse(aUrl) {
    var match = aUrl.match(urlRegexp);
    if (!match) return null;
    return {
        scheme: match[1],
        auth: match[2],
        host: match[3],
        port: match[4],
        path: match[5]
    };
}
exports.urlParse = urlParse;
function urlGenerate(aParsedUrl) {
    var url = "";
    if (aParsedUrl.scheme) url += aParsedUrl.scheme + ":";
    url += "//";
    if (aParsedUrl.auth) url += aParsedUrl.auth + "@";
    if (aParsedUrl.host) url += aParsedUrl.host;
    if (aParsedUrl.port) url += ":" + aParsedUrl.port;
    if (aParsedUrl.path) url += aParsedUrl.path;
    return url;
}
exports.urlGenerate = urlGenerate;
/**
 * Normalizes a path, or the path portion of a URL:
 *
 * - Replaces consecutive slashes with one slash.
 * - Removes unnecessary '.' parts.
 * - Removes unnecessary '<dir>/..' parts.
 *
 * Based on code in the Node.js 'path' core module.
 *
 * @param aPath The path or url to normalize.
 */ function normalize(aPath) {
    var path = aPath;
    var url = urlParse(aPath);
    if (url) {
        if (!url.path) return aPath;
        path = url.path;
    }
    var isAbsolute = exports.isAbsolute(path);
    var parts = path.split(/\/+/);
    for(var part, up = 0, i = parts.length - 1; i >= 0; i--){
        part = parts[i];
        if (part === ".") parts.splice(i, 1);
        else if (part === "..") up++;
        else if (up > 0) {
            if (part === "") {
                // The first part is blank if the path is absolute. Trying to go
                // above the root is a no-op. Therefore we can remove all '..' parts
                // directly after the root.
                parts.splice(i + 1, up);
                up = 0;
            } else {
                parts.splice(i, 2);
                up--;
            }
        }
    }
    path = parts.join("/");
    if (path === "") path = isAbsolute ? "/" : ".";
    if (url) {
        url.path = path;
        return urlGenerate(url);
    }
    return path;
}
exports.normalize = normalize;
/**
 * Joins two paths/URLs.
 *
 * @param aRoot The root path or URL.
 * @param aPath The path or URL to be joined with the root.
 *
 * - If aPath is a URL or a data URI, aPath is returned, unless aPath is a
 *   scheme-relative URL: Then the scheme of aRoot, if any, is prepended
 *   first.
 * - Otherwise aPath is a path. If aRoot is a URL, then its path portion
 *   is updated with the result and aRoot is returned. Otherwise the result
 *   is returned.
 *   - If aPath is absolute, the result is aPath.
 *   - Otherwise the two paths are joined with a slash.
 * - Joining for example 'http://' and 'www.example.com' is also supported.
 */ function join(aRoot, aPath) {
    if (aRoot === "") aRoot = ".";
    if (aPath === "") aPath = ".";
    var aPathUrl = urlParse(aPath);
    var aRootUrl = urlParse(aRoot);
    if (aRootUrl) aRoot = aRootUrl.path || "/";
    // `join(foo, '//www.example.org')`
    if (aPathUrl && !aPathUrl.scheme) {
        if (aRootUrl) aPathUrl.scheme = aRootUrl.scheme;
        return urlGenerate(aPathUrl);
    }
    if (aPathUrl || aPath.match(dataUrlRegexp)) return aPath;
    // `join('http://', 'www.example.com')`
    if (aRootUrl && !aRootUrl.host && !aRootUrl.path) {
        aRootUrl.host = aPath;
        return urlGenerate(aRootUrl);
    }
    var joined = aPath.charAt(0) === "/" ? aPath : normalize(aRoot.replace(/\/+$/, "") + "/" + aPath);
    if (aRootUrl) {
        aRootUrl.path = joined;
        return urlGenerate(aRootUrl);
    }
    return joined;
}
exports.join = join;
exports.isAbsolute = function(aPath) {
    return aPath.charAt(0) === "/" || urlRegexp.test(aPath);
};
/**
 * Make a path relative to a URL or another path.
 *
 * @param aRoot The root path or URL.
 * @param aPath The path or URL to be made relative to aRoot.
 */ function relative(aRoot, aPath) {
    if (aRoot === "") aRoot = ".";
    aRoot = aRoot.replace(/\/$/, "");
    // It is possible for the path to be above the root. In this case, simply
    // checking whether the root is a prefix of the path won't work. Instead, we
    // need to remove components from the root one by one, until either we find
    // a prefix that fits, or we run out of components to remove.
    var level = 0;
    while(aPath.indexOf(aRoot + "/") !== 0){
        var index = aRoot.lastIndexOf("/");
        if (index < 0) return aPath;
        // If the only part of the root that is left is the scheme (i.e. http://,
        // file:///, etc.), one or more slashes (/), or simply nothing at all, we
        // have exhausted all components, so the path is not relative to the root.
        aRoot = aRoot.slice(0, index);
        if (aRoot.match(/^([^\/]+:\/)?\/*$/)) return aPath;
        ++level;
    }
    // Make sure we add a "../" for each component we removed from the root.
    return Array(level + 1).join("../") + aPath.substr(aRoot.length + 1);
}
exports.relative = relative;
var supportsNullProto = function() {
    var obj = Object.create(null);
    return !("__proto__" in obj);
}();
function identity(s) {
    return s;
}
/**
 * Because behavior goes wacky when you set `__proto__` on objects, we
 * have to prefix all the strings in our set with an arbitrary character.
 *
 * See https://github.com/mozilla/source-map/pull/31 and
 * https://github.com/mozilla/source-map/issues/30
 *
 * @param String aStr
 */ function toSetString(aStr) {
    if (isProtoString(aStr)) return "$" + aStr;
    return aStr;
}
exports.toSetString = supportsNullProto ? identity : toSetString;
function fromSetString(aStr) {
    if (isProtoString(aStr)) return aStr.slice(1);
    return aStr;
}
exports.fromSetString = supportsNullProto ? identity : fromSetString;
function isProtoString(s) {
    if (!s) return false;
    var length = s.length;
    if (length < 9 /* "__proto__".length */ ) return false;
    if (s.charCodeAt(length - 1) !== 95 /* '_' */  || s.charCodeAt(length - 2) !== 95 /* '_' */  || s.charCodeAt(length - 3) !== 111 /* 'o' */  || s.charCodeAt(length - 4) !== 116 /* 't' */  || s.charCodeAt(length - 5) !== 111 /* 'o' */  || s.charCodeAt(length - 6) !== 114 /* 'r' */  || s.charCodeAt(length - 7) !== 112 /* 'p' */  || s.charCodeAt(length - 8) !== 95 /* '_' */  || s.charCodeAt(length - 9) !== 95 /* '_' */ ) return false;
    for(var i = length - 10; i >= 0; i--){
        if (s.charCodeAt(i) !== 36 /* '$' */ ) return false;
    }
    return true;
}
/**
 * Comparator between two mappings where the original positions are compared.
 *
 * Optionally pass in `true` as `onlyCompareGenerated` to consider two
 * mappings with the same original source/line/column, but different generated
 * line and column the same. Useful when searching for a mapping with a
 * stubbed out mapping.
 */ function compareByOriginalPositions(mappingA, mappingB, onlyCompareOriginal) {
    var cmp = strcmp(mappingA.source, mappingB.source);
    if (cmp !== 0) return cmp;
    cmp = mappingA.originalLine - mappingB.originalLine;
    if (cmp !== 0) return cmp;
    cmp = mappingA.originalColumn - mappingB.originalColumn;
    if (cmp !== 0 || onlyCompareOriginal) return cmp;
    cmp = mappingA.generatedColumn - mappingB.generatedColumn;
    if (cmp !== 0) return cmp;
    cmp = mappingA.generatedLine - mappingB.generatedLine;
    if (cmp !== 0) return cmp;
    return strcmp(mappingA.name, mappingB.name);
}
exports.compareByOriginalPositions = compareByOriginalPositions;
/**
 * Comparator between two mappings with deflated source and name indices where
 * the generated positions are compared.
 *
 * Optionally pass in `true` as `onlyCompareGenerated` to consider two
 * mappings with the same generated line and column, but different
 * source/name/original line and column the same. Useful when searching for a
 * mapping with a stubbed out mapping.
 */ function compareByGeneratedPositionsDeflated(mappingA, mappingB, onlyCompareGenerated) {
    var cmp = mappingA.generatedLine - mappingB.generatedLine;
    if (cmp !== 0) return cmp;
    cmp = mappingA.generatedColumn - mappingB.generatedColumn;
    if (cmp !== 0 || onlyCompareGenerated) return cmp;
    cmp = strcmp(mappingA.source, mappingB.source);
    if (cmp !== 0) return cmp;
    cmp = mappingA.originalLine - mappingB.originalLine;
    if (cmp !== 0) return cmp;
    cmp = mappingA.originalColumn - mappingB.originalColumn;
    if (cmp !== 0) return cmp;
    return strcmp(mappingA.name, mappingB.name);
}
exports.compareByGeneratedPositionsDeflated = compareByGeneratedPositionsDeflated;
function strcmp(aStr1, aStr2) {
    if (aStr1 === aStr2) return 0;
    if (aStr1 === null) return 1; // aStr2 !== null
    if (aStr2 === null) return -1; // aStr1 !== null
    if (aStr1 > aStr2) return 1;
    return -1;
}
/**
 * Comparator between two mappings with inflated source and name strings where
 * the generated positions are compared.
 */ function compareByGeneratedPositionsInflated(mappingA, mappingB) {
    var cmp = mappingA.generatedLine - mappingB.generatedLine;
    if (cmp !== 0) return cmp;
    cmp = mappingA.generatedColumn - mappingB.generatedColumn;
    if (cmp !== 0) return cmp;
    cmp = strcmp(mappingA.source, mappingB.source);
    if (cmp !== 0) return cmp;
    cmp = mappingA.originalLine - mappingB.originalLine;
    if (cmp !== 0) return cmp;
    cmp = mappingA.originalColumn - mappingB.originalColumn;
    if (cmp !== 0) return cmp;
    return strcmp(mappingA.name, mappingB.name);
}
exports.compareByGeneratedPositionsInflated = compareByGeneratedPositionsInflated;
/**
 * Strip any JSON XSSI avoidance prefix from the string (as documented
 * in the source maps specification), and then parse the string as
 * JSON.
 */ function parseSourceMapInput(str) {
    return JSON.parse(str.replace(/^\)]}'[^\n]*\n/, ""));
}
exports.parseSourceMapInput = parseSourceMapInput;
/**
 * Compute the URL of a source given the the source root, the source's
 * URL, and the source map's URL.
 */ function computeSourceURL(sourceRoot, sourceURL, sourceMapURL) {
    sourceURL = sourceURL || "";
    if (sourceRoot) {
        // This follows what Chrome does.
        if (sourceRoot[sourceRoot.length - 1] !== "/" && sourceURL[0] !== "/") sourceRoot += "/";
        // The spec says:
        //   Line 4: An optional source root, useful for relocating source
        //   files on a server or removing repeated values in the
        //   “sources” entry.  This value is prepended to the individual
        //   entries in the “source” field.
        sourceURL = sourceRoot + sourceURL;
    }
    // Historically, SourceMapConsumer did not take the sourceMapURL as
    // a parameter.  This mode is still somewhat supported, which is why
    // this code block is conditional.  However, it's preferable to pass
    // the source map URL to SourceMapConsumer, so that this function
    // can implement the source URL resolution algorithm as outlined in
    // the spec.  This block is basically the equivalent of:
    //    new URL(sourceURL, sourceMapURL).toString()
    // ... except it avoids using URL, which wasn't available in the
    // older releases of node still supported by this library.
    //
    // The spec says:
    //   If the sources are not absolute URLs after prepending of the
    //   “sourceRoot”, the sources are resolved relative to the
    //   SourceMap (like resolving script src in a html document).
    if (sourceMapURL) {
        var parsed = urlParse(sourceMapURL);
        if (!parsed) throw new Error("sourceMapURL could not be parsed");
        if (parsed.path) {
            // Strip the last path component, but keep the "/".
            var index = parsed.path.lastIndexOf("/");
            if (index >= 0) parsed.path = parsed.path.substring(0, index + 1);
        }
        sourceURL = join(urlGenerate(parsed), sourceURL);
    }
    return normalize(sourceURL);
}
exports.computeSourceURL = computeSourceURL;

},{}],"5VumI":[function(require,module,exports) {
/* -*- Mode: js; js-indent-level: 2; -*- */ /*
 * Copyright 2011 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE or:
 * http://opensource.org/licenses/BSD-3-Clause
 */ var util = require("f4001388f67ef757");
var has = Object.prototype.hasOwnProperty;
var hasNativeMap = typeof Map !== "undefined";
/**
 * A data structure which is a combination of an array and a set. Adding a new
 * member is O(1), testing for membership is O(1), and finding the index of an
 * element is O(1). Removing elements from the set is not supported. Only
 * strings are supported for membership.
 */ function ArraySet() {
    this._array = [];
    this._set = hasNativeMap ? new Map() : Object.create(null);
}
/**
 * Static method for creating ArraySet instances from an existing array.
 */ ArraySet.fromArray = function ArraySet_fromArray(aArray, aAllowDuplicates) {
    var set = new ArraySet();
    for(var i = 0, len = aArray.length; i < len; i++)set.add(aArray[i], aAllowDuplicates);
    return set;
};
/**
 * Return how many unique items are in this ArraySet. If duplicates have been
 * added, than those do not count towards the size.
 *
 * @returns Number
 */ ArraySet.prototype.size = function ArraySet_size() {
    return hasNativeMap ? this._set.size : Object.getOwnPropertyNames(this._set).length;
};
/**
 * Add the given string to this set.
 *
 * @param String aStr
 */ ArraySet.prototype.add = function ArraySet_add(aStr, aAllowDuplicates) {
    var sStr = hasNativeMap ? aStr : util.toSetString(aStr);
    var isDuplicate = hasNativeMap ? this.has(aStr) : has.call(this._set, sStr);
    var idx = this._array.length;
    if (!isDuplicate || aAllowDuplicates) this._array.push(aStr);
    if (!isDuplicate) {
        if (hasNativeMap) this._set.set(aStr, idx);
        else this._set[sStr] = idx;
    }
};
/**
 * Is the given string a member of this set?
 *
 * @param String aStr
 */ ArraySet.prototype.has = function ArraySet_has(aStr) {
    if (hasNativeMap) return this._set.has(aStr);
    else {
        var sStr = util.toSetString(aStr);
        return has.call(this._set, sStr);
    }
};
/**
 * What is the index of the given string in the array?
 *
 * @param String aStr
 */ ArraySet.prototype.indexOf = function ArraySet_indexOf(aStr) {
    if (hasNativeMap) {
        var idx = this._set.get(aStr);
        if (idx >= 0) return idx;
    } else {
        var sStr = util.toSetString(aStr);
        if (has.call(this._set, sStr)) return this._set[sStr];
    }
    throw new Error('"' + aStr + '" is not in the set.');
};
/**
 * What is the element at the given index?
 *
 * @param Number aIdx
 */ ArraySet.prototype.at = function ArraySet_at(aIdx) {
    if (aIdx >= 0 && aIdx < this._array.length) return this._array[aIdx];
    throw new Error("No element indexed by " + aIdx);
};
/**
 * Returns the array representation of this set (which has the proper indices
 * indicated by indexOf). Note that this is a copy of the internal array used
 * for storing the members so that no one can mess with internal state.
 */ ArraySet.prototype.toArray = function ArraySet_toArray() {
    return this._array.slice();
};
exports.ArraySet = ArraySet;

},{"f4001388f67ef757":"3gsUu"}],"9Bvrn":[function(require,module,exports) {
/* -*- Mode: js; js-indent-level: 2; -*- */ /*
 * Copyright 2014 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE or:
 * http://opensource.org/licenses/BSD-3-Clause
 */ var util = require("a70191b97ba376d4");
/**
 * Determine whether mappingB is after mappingA with respect to generated
 * position.
 */ function generatedPositionAfter(mappingA, mappingB) {
    // Optimized for most common case
    var lineA = mappingA.generatedLine;
    var lineB = mappingB.generatedLine;
    var columnA = mappingA.generatedColumn;
    var columnB = mappingB.generatedColumn;
    return lineB > lineA || lineB == lineA && columnB >= columnA || util.compareByGeneratedPositionsInflated(mappingA, mappingB) <= 0;
}
/**
 * A data structure to provide a sorted view of accumulated mappings in a
 * performance conscious manner. It trades a neglibable overhead in general
 * case for a large speedup in case of mappings being added in order.
 */ function MappingList() {
    this._array = [];
    this._sorted = true;
    // Serves as infimum
    this._last = {
        generatedLine: -1,
        generatedColumn: 0
    };
}
/**
 * Iterate through internal items. This method takes the same arguments that
 * `Array.prototype.forEach` takes.
 *
 * NOTE: The order of the mappings is NOT guaranteed.
 */ MappingList.prototype.unsortedForEach = function MappingList_forEach(aCallback, aThisArg) {
    this._array.forEach(aCallback, aThisArg);
};
/**
 * Add the given source mapping.
 *
 * @param Object aMapping
 */ MappingList.prototype.add = function MappingList_add(aMapping) {
    if (generatedPositionAfter(this._last, aMapping)) {
        this._last = aMapping;
        this._array.push(aMapping);
    } else {
        this._sorted = false;
        this._array.push(aMapping);
    }
};
/**
 * Returns the flat, sorted array of mappings. The mappings are sorted by
 * generated position.
 *
 * WARNING: This method returns internal data without copying, for
 * performance. The return value must NOT be mutated, and should be treated as
 * an immutable borrow. If you want to take ownership, you must make your own
 * copy.
 */ MappingList.prototype.toArray = function MappingList_toArray() {
    if (!this._sorted) {
        this._array.sort(util.compareByGeneratedPositionsInflated);
        this._sorted = true;
    }
    return this._array;
};
exports.MappingList = MappingList;

},{"a70191b97ba376d4":"3gsUu"}],"gBAiL":[function(require,module,exports) {
/* -*- Mode: js; js-indent-level: 2; -*- */ /*
 * Copyright 2011 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE or:
 * http://opensource.org/licenses/BSD-3-Clause
 */ var util = require("b22324b13f72201b");
var binarySearch = require("129ba2b16e81db9e");
var ArraySet = require("832bf56bf6a231e4").ArraySet;
var base64VLQ = require("95d11d359ee56491");
var quickSort = require("7076e0beb1aa0cfd").quickSort;
function SourceMapConsumer(aSourceMap, aSourceMapURL) {
    var sourceMap = aSourceMap;
    if (typeof aSourceMap === "string") sourceMap = util.parseSourceMapInput(aSourceMap);
    return sourceMap.sections != null ? new IndexedSourceMapConsumer(sourceMap, aSourceMapURL) : new BasicSourceMapConsumer(sourceMap, aSourceMapURL);
}
SourceMapConsumer.fromSourceMap = function(aSourceMap, aSourceMapURL) {
    return BasicSourceMapConsumer.fromSourceMap(aSourceMap, aSourceMapURL);
};
/**
 * The version of the source mapping spec that we are consuming.
 */ SourceMapConsumer.prototype._version = 3;
// `__generatedMappings` and `__originalMappings` are arrays that hold the
// parsed mapping coordinates from the source map's "mappings" attribute. They
// are lazily instantiated, accessed via the `_generatedMappings` and
// `_originalMappings` getters respectively, and we only parse the mappings
// and create these arrays once queried for a source location. We jump through
// these hoops because there can be many thousands of mappings, and parsing
// them is expensive, so we only want to do it if we must.
//
// Each object in the arrays is of the form:
//
//     {
//       generatedLine: The line number in the generated code,
//       generatedColumn: The column number in the generated code,
//       source: The path to the original source file that generated this
//               chunk of code,
//       originalLine: The line number in the original source that
//                     corresponds to this chunk of generated code,
//       originalColumn: The column number in the original source that
//                       corresponds to this chunk of generated code,
//       name: The name of the original symbol which generated this chunk of
//             code.
//     }
//
// All properties except for `generatedLine` and `generatedColumn` can be
// `null`.
//
// `_generatedMappings` is ordered by the generated positions.
//
// `_originalMappings` is ordered by the original positions.
SourceMapConsumer.prototype.__generatedMappings = null;
Object.defineProperty(SourceMapConsumer.prototype, "_generatedMappings", {
    configurable: true,
    enumerable: true,
    get: function() {
        if (!this.__generatedMappings) this._parseMappings(this._mappings, this.sourceRoot);
        return this.__generatedMappings;
    }
});
SourceMapConsumer.prototype.__originalMappings = null;
Object.defineProperty(SourceMapConsumer.prototype, "_originalMappings", {
    configurable: true,
    enumerable: true,
    get: function() {
        if (!this.__originalMappings) this._parseMappings(this._mappings, this.sourceRoot);
        return this.__originalMappings;
    }
});
SourceMapConsumer.prototype._charIsMappingSeparator = function SourceMapConsumer_charIsMappingSeparator(aStr, index) {
    var c = aStr.charAt(index);
    return c === ";" || c === ",";
};
/**
 * Parse the mappings in a string in to a data structure which we can easily
 * query (the ordered arrays in the `this.__generatedMappings` and
 * `this.__originalMappings` properties).
 */ SourceMapConsumer.prototype._parseMappings = function SourceMapConsumer_parseMappings(aStr, aSourceRoot) {
    throw new Error("Subclasses must implement _parseMappings");
};
SourceMapConsumer.GENERATED_ORDER = 1;
SourceMapConsumer.ORIGINAL_ORDER = 2;
SourceMapConsumer.GREATEST_LOWER_BOUND = 1;
SourceMapConsumer.LEAST_UPPER_BOUND = 2;
/**
 * Iterate over each mapping between an original source/line/column and a
 * generated line/column in this source map.
 *
 * @param Function aCallback
 *        The function that is called with each mapping.
 * @param Object aContext
 *        Optional. If specified, this object will be the value of `this` every
 *        time that `aCallback` is called.
 * @param aOrder
 *        Either `SourceMapConsumer.GENERATED_ORDER` or
 *        `SourceMapConsumer.ORIGINAL_ORDER`. Specifies whether you want to
 *        iterate over the mappings sorted by the generated file's line/column
 *        order or the original's source/line/column order, respectively. Defaults to
 *        `SourceMapConsumer.GENERATED_ORDER`.
 */ SourceMapConsumer.prototype.eachMapping = function SourceMapConsumer_eachMapping(aCallback, aContext, aOrder) {
    var context = aContext || null;
    var order = aOrder || SourceMapConsumer.GENERATED_ORDER;
    var mappings;
    switch(order){
        case SourceMapConsumer.GENERATED_ORDER:
            mappings = this._generatedMappings;
            break;
        case SourceMapConsumer.ORIGINAL_ORDER:
            mappings = this._originalMappings;
            break;
        default:
            throw new Error("Unknown order of iteration.");
    }
    var sourceRoot = this.sourceRoot;
    mappings.map(function(mapping) {
        var source = mapping.source === null ? null : this._sources.at(mapping.source);
        source = util.computeSourceURL(sourceRoot, source, this._sourceMapURL);
        return {
            source: source,
            generatedLine: mapping.generatedLine,
            generatedColumn: mapping.generatedColumn,
            originalLine: mapping.originalLine,
            originalColumn: mapping.originalColumn,
            name: mapping.name === null ? null : this._names.at(mapping.name)
        };
    }, this).forEach(aCallback, context);
};
/**
 * Returns all generated line and column information for the original source,
 * line, and column provided. If no column is provided, returns all mappings
 * corresponding to a either the line we are searching for or the next
 * closest line that has any mappings. Otherwise, returns all mappings
 * corresponding to the given line and either the column we are searching for
 * or the next closest column that has any offsets.
 *
 * The only argument is an object with the following properties:
 *
 *   - source: The filename of the original source.
 *   - line: The line number in the original source.  The line number is 1-based.
 *   - column: Optional. the column number in the original source.
 *    The column number is 0-based.
 *
 * and an array of objects is returned, each with the following properties:
 *
 *   - line: The line number in the generated source, or null.  The
 *    line number is 1-based.
 *   - column: The column number in the generated source, or null.
 *    The column number is 0-based.
 */ SourceMapConsumer.prototype.allGeneratedPositionsFor = function SourceMapConsumer_allGeneratedPositionsFor(aArgs) {
    var line = util.getArg(aArgs, "line");
    // When there is no exact match, BasicSourceMapConsumer.prototype._findMapping
    // returns the index of the closest mapping less than the needle. By
    // setting needle.originalColumn to 0, we thus find the last mapping for
    // the given line, provided such a mapping exists.
    var needle = {
        source: util.getArg(aArgs, "source"),
        originalLine: line,
        originalColumn: util.getArg(aArgs, "column", 0)
    };
    needle.source = this._findSourceIndex(needle.source);
    if (needle.source < 0) return [];
    var mappings = [];
    var index = this._findMapping(needle, this._originalMappings, "originalLine", "originalColumn", util.compareByOriginalPositions, binarySearch.LEAST_UPPER_BOUND);
    if (index >= 0) {
        var mapping = this._originalMappings[index];
        if (aArgs.column === undefined) {
            var originalLine = mapping.originalLine;
            // Iterate until either we run out of mappings, or we run into
            // a mapping for a different line than the one we found. Since
            // mappings are sorted, this is guaranteed to find all mappings for
            // the line we found.
            while(mapping && mapping.originalLine === originalLine){
                mappings.push({
                    line: util.getArg(mapping, "generatedLine", null),
                    column: util.getArg(mapping, "generatedColumn", null),
                    lastColumn: util.getArg(mapping, "lastGeneratedColumn", null)
                });
                mapping = this._originalMappings[++index];
            }
        } else {
            var originalColumn = mapping.originalColumn;
            // Iterate until either we run out of mappings, or we run into
            // a mapping for a different line than the one we were searching for.
            // Since mappings are sorted, this is guaranteed to find all mappings for
            // the line we are searching for.
            while(mapping && mapping.originalLine === line && mapping.originalColumn == originalColumn){
                mappings.push({
                    line: util.getArg(mapping, "generatedLine", null),
                    column: util.getArg(mapping, "generatedColumn", null),
                    lastColumn: util.getArg(mapping, "lastGeneratedColumn", null)
                });
                mapping = this._originalMappings[++index];
            }
        }
    }
    return mappings;
};
exports.SourceMapConsumer = SourceMapConsumer;
/**
 * A BasicSourceMapConsumer instance represents a parsed source map which we can
 * query for information about the original file positions by giving it a file
 * position in the generated source.
 *
 * The first parameter is the raw source map (either as a JSON string, or
 * already parsed to an object). According to the spec, source maps have the
 * following attributes:
 *
 *   - version: Which version of the source map spec this map is following.
 *   - sources: An array of URLs to the original source files.
 *   - names: An array of identifiers which can be referrenced by individual mappings.
 *   - sourceRoot: Optional. The URL root from which all sources are relative.
 *   - sourcesContent: Optional. An array of contents of the original source files.
 *   - mappings: A string of base64 VLQs which contain the actual mappings.
 *   - file: Optional. The generated file this source map is associated with.
 *
 * Here is an example source map, taken from the source map spec[0]:
 *
 *     {
 *       version : 3,
 *       file: "out.js",
 *       sourceRoot : "",
 *       sources: ["foo.js", "bar.js"],
 *       names: ["src", "maps", "are", "fun"],
 *       mappings: "AA,AB;;ABCDE;"
 *     }
 *
 * The second parameter, if given, is a string whose value is the URL
 * at which the source map was found.  This URL is used to compute the
 * sources array.
 *
 * [0]: https://docs.google.com/document/d/1U1RGAehQwRypUTovF1KRlpiOFze0b-_2gc6fAH0KY0k/edit?pli=1#
 */ function BasicSourceMapConsumer(aSourceMap, aSourceMapURL) {
    var sourceMap = aSourceMap;
    if (typeof aSourceMap === "string") sourceMap = util.parseSourceMapInput(aSourceMap);
    var version = util.getArg(sourceMap, "version");
    var sources = util.getArg(sourceMap, "sources");
    // Sass 3.3 leaves out the 'names' array, so we deviate from the spec (which
    // requires the array) to play nice here.
    var names = util.getArg(sourceMap, "names", []);
    var sourceRoot = util.getArg(sourceMap, "sourceRoot", null);
    var sourcesContent = util.getArg(sourceMap, "sourcesContent", null);
    var mappings = util.getArg(sourceMap, "mappings");
    var file = util.getArg(sourceMap, "file", null);
    // Once again, Sass deviates from the spec and supplies the version as a
    // string rather than a number, so we use loose equality checking here.
    if (version != this._version) throw new Error("Unsupported version: " + version);
    if (sourceRoot) sourceRoot = util.normalize(sourceRoot);
    sources = sources.map(String)// Some source maps produce relative source paths like "./foo.js" instead of
    // "foo.js".  Normalize these first so that future comparisons will succeed.
    // See bugzil.la/1090768.
    .map(util.normalize)// Always ensure that absolute sources are internally stored relative to
    // the source root, if the source root is absolute. Not doing this would
    // be particularly problematic when the source root is a prefix of the
    // source (valid, but why??). See github issue #199 and bugzil.la/1188982.
    .map(function(source) {
        return sourceRoot && util.isAbsolute(sourceRoot) && util.isAbsolute(source) ? util.relative(sourceRoot, source) : source;
    });
    // Pass `true` below to allow duplicate names and sources. While source maps
    // are intended to be compressed and deduplicated, the TypeScript compiler
    // sometimes generates source maps with duplicates in them. See Github issue
    // #72 and bugzil.la/889492.
    this._names = ArraySet.fromArray(names.map(String), true);
    this._sources = ArraySet.fromArray(sources, true);
    this._absoluteSources = this._sources.toArray().map(function(s) {
        return util.computeSourceURL(sourceRoot, s, aSourceMapURL);
    });
    this.sourceRoot = sourceRoot;
    this.sourcesContent = sourcesContent;
    this._mappings = mappings;
    this._sourceMapURL = aSourceMapURL;
    this.file = file;
}
BasicSourceMapConsumer.prototype = Object.create(SourceMapConsumer.prototype);
BasicSourceMapConsumer.prototype.consumer = SourceMapConsumer;
/**
 * Utility function to find the index of a source.  Returns -1 if not
 * found.
 */ BasicSourceMapConsumer.prototype._findSourceIndex = function(aSource) {
    var relativeSource = aSource;
    if (this.sourceRoot != null) relativeSource = util.relative(this.sourceRoot, relativeSource);
    if (this._sources.has(relativeSource)) return this._sources.indexOf(relativeSource);
    // Maybe aSource is an absolute URL as returned by |sources|.  In
    // this case we can't simply undo the transform.
    var i;
    for(i = 0; i < this._absoluteSources.length; ++i){
        if (this._absoluteSources[i] == aSource) return i;
    }
    return -1;
};
/**
 * Create a BasicSourceMapConsumer from a SourceMapGenerator.
 *
 * @param SourceMapGenerator aSourceMap
 *        The source map that will be consumed.
 * @param String aSourceMapURL
 *        The URL at which the source map can be found (optional)
 * @returns BasicSourceMapConsumer
 */ BasicSourceMapConsumer.fromSourceMap = function SourceMapConsumer_fromSourceMap(aSourceMap, aSourceMapURL) {
    var smc = Object.create(BasicSourceMapConsumer.prototype);
    var names = smc._names = ArraySet.fromArray(aSourceMap._names.toArray(), true);
    var sources = smc._sources = ArraySet.fromArray(aSourceMap._sources.toArray(), true);
    smc.sourceRoot = aSourceMap._sourceRoot;
    smc.sourcesContent = aSourceMap._generateSourcesContent(smc._sources.toArray(), smc.sourceRoot);
    smc.file = aSourceMap._file;
    smc._sourceMapURL = aSourceMapURL;
    smc._absoluteSources = smc._sources.toArray().map(function(s) {
        return util.computeSourceURL(smc.sourceRoot, s, aSourceMapURL);
    });
    // Because we are modifying the entries (by converting string sources and
    // names to indices into the sources and names ArraySets), we have to make
    // a copy of the entry or else bad things happen. Shared mutable state
    // strikes again! See github issue #191.
    var generatedMappings = aSourceMap._mappings.toArray().slice();
    var destGeneratedMappings = smc.__generatedMappings = [];
    var destOriginalMappings = smc.__originalMappings = [];
    for(var i = 0, length = generatedMappings.length; i < length; i++){
        var srcMapping = generatedMappings[i];
        var destMapping = new Mapping;
        destMapping.generatedLine = srcMapping.generatedLine;
        destMapping.generatedColumn = srcMapping.generatedColumn;
        if (srcMapping.source) {
            destMapping.source = sources.indexOf(srcMapping.source);
            destMapping.originalLine = srcMapping.originalLine;
            destMapping.originalColumn = srcMapping.originalColumn;
            if (srcMapping.name) destMapping.name = names.indexOf(srcMapping.name);
            destOriginalMappings.push(destMapping);
        }
        destGeneratedMappings.push(destMapping);
    }
    quickSort(smc.__originalMappings, util.compareByOriginalPositions);
    return smc;
};
/**
 * The version of the source mapping spec that we are consuming.
 */ BasicSourceMapConsumer.prototype._version = 3;
/**
 * The list of original sources.
 */ Object.defineProperty(BasicSourceMapConsumer.prototype, "sources", {
    get: function() {
        return this._absoluteSources.slice();
    }
});
/**
 * Provide the JIT with a nice shape / hidden class.
 */ function Mapping() {
    this.generatedLine = 0;
    this.generatedColumn = 0;
    this.source = null;
    this.originalLine = null;
    this.originalColumn = null;
    this.name = null;
}
/**
 * Parse the mappings in a string in to a data structure which we can easily
 * query (the ordered arrays in the `this.__generatedMappings` and
 * `this.__originalMappings` properties).
 */ BasicSourceMapConsumer.prototype._parseMappings = function SourceMapConsumer_parseMappings(aStr, aSourceRoot) {
    var generatedLine = 1;
    var previousGeneratedColumn = 0;
    var previousOriginalLine = 0;
    var previousOriginalColumn = 0;
    var previousSource = 0;
    var previousName = 0;
    var length = aStr.length;
    var index = 0;
    var cachedSegments = {};
    var temp = {};
    var originalMappings = [];
    var generatedMappings = [];
    var mapping, str, segment, end, value;
    while(index < length){
        if (aStr.charAt(index) === ";") {
            generatedLine++;
            index++;
            previousGeneratedColumn = 0;
        } else if (aStr.charAt(index) === ",") index++;
        else {
            mapping = new Mapping();
            mapping.generatedLine = generatedLine;
            // Because each offset is encoded relative to the previous one,
            // many segments often have the same encoding. We can exploit this
            // fact by caching the parsed variable length fields of each segment,
            // allowing us to avoid a second parse if we encounter the same
            // segment again.
            for(end = index; end < length; end++){
                if (this._charIsMappingSeparator(aStr, end)) break;
            }
            str = aStr.slice(index, end);
            segment = cachedSegments[str];
            if (segment) index += str.length;
            else {
                segment = [];
                while(index < end){
                    base64VLQ.decode(aStr, index, temp);
                    value = temp.value;
                    index = temp.rest;
                    segment.push(value);
                }
                if (segment.length === 2) throw new Error("Found a source, but no line and column");
                if (segment.length === 3) throw new Error("Found a source and line, but no column");
                cachedSegments[str] = segment;
            }
            // Generated column.
            mapping.generatedColumn = previousGeneratedColumn + segment[0];
            previousGeneratedColumn = mapping.generatedColumn;
            if (segment.length > 1) {
                // Original source.
                mapping.source = previousSource + segment[1];
                previousSource += segment[1];
                // Original line.
                mapping.originalLine = previousOriginalLine + segment[2];
                previousOriginalLine = mapping.originalLine;
                // Lines are stored 0-based
                mapping.originalLine += 1;
                // Original column.
                mapping.originalColumn = previousOriginalColumn + segment[3];
                previousOriginalColumn = mapping.originalColumn;
                if (segment.length > 4) {
                    // Original name.
                    mapping.name = previousName + segment[4];
                    previousName += segment[4];
                }
            }
            generatedMappings.push(mapping);
            if (typeof mapping.originalLine === "number") originalMappings.push(mapping);
        }
    }
    quickSort(generatedMappings, util.compareByGeneratedPositionsDeflated);
    this.__generatedMappings = generatedMappings;
    quickSort(originalMappings, util.compareByOriginalPositions);
    this.__originalMappings = originalMappings;
};
/**
 * Find the mapping that best matches the hypothetical "needle" mapping that
 * we are searching for in the given "haystack" of mappings.
 */ BasicSourceMapConsumer.prototype._findMapping = function SourceMapConsumer_findMapping(aNeedle, aMappings, aLineName, aColumnName, aComparator, aBias) {
    // To return the position we are searching for, we must first find the
    // mapping for the given position and then return the opposite position it
    // points to. Because the mappings are sorted, we can use binary search to
    // find the best mapping.
    if (aNeedle[aLineName] <= 0) throw new TypeError("Line must be greater than or equal to 1, got " + aNeedle[aLineName]);
    if (aNeedle[aColumnName] < 0) throw new TypeError("Column must be greater than or equal to 0, got " + aNeedle[aColumnName]);
    return binarySearch.search(aNeedle, aMappings, aComparator, aBias);
};
/**
 * Compute the last column for each generated mapping. The last column is
 * inclusive.
 */ BasicSourceMapConsumer.prototype.computeColumnSpans = function SourceMapConsumer_computeColumnSpans() {
    for(var index = 0; index < this._generatedMappings.length; ++index){
        var mapping = this._generatedMappings[index];
        // Mappings do not contain a field for the last generated columnt. We
        // can come up with an optimistic estimate, however, by assuming that
        // mappings are contiguous (i.e. given two consecutive mappings, the
        // first mapping ends where the second one starts).
        if (index + 1 < this._generatedMappings.length) {
            var nextMapping = this._generatedMappings[index + 1];
            if (mapping.generatedLine === nextMapping.generatedLine) {
                mapping.lastGeneratedColumn = nextMapping.generatedColumn - 1;
                continue;
            }
        }
        // The last mapping for each line spans the entire line.
        mapping.lastGeneratedColumn = Infinity;
    }
};
/**
 * Returns the original source, line, and column information for the generated
 * source's line and column positions provided. The only argument is an object
 * with the following properties:
 *
 *   - line: The line number in the generated source.  The line number
 *     is 1-based.
 *   - column: The column number in the generated source.  The column
 *     number is 0-based.
 *   - bias: Either 'SourceMapConsumer.GREATEST_LOWER_BOUND' or
 *     'SourceMapConsumer.LEAST_UPPER_BOUND'. Specifies whether to return the
 *     closest element that is smaller than or greater than the one we are
 *     searching for, respectively, if the exact element cannot be found.
 *     Defaults to 'SourceMapConsumer.GREATEST_LOWER_BOUND'.
 *
 * and an object is returned with the following properties:
 *
 *   - source: The original source file, or null.
 *   - line: The line number in the original source, or null.  The
 *     line number is 1-based.
 *   - column: The column number in the original source, or null.  The
 *     column number is 0-based.
 *   - name: The original identifier, or null.
 */ BasicSourceMapConsumer.prototype.originalPositionFor = function SourceMapConsumer_originalPositionFor(aArgs) {
    var needle = {
        generatedLine: util.getArg(aArgs, "line"),
        generatedColumn: util.getArg(aArgs, "column")
    };
    var index = this._findMapping(needle, this._generatedMappings, "generatedLine", "generatedColumn", util.compareByGeneratedPositionsDeflated, util.getArg(aArgs, "bias", SourceMapConsumer.GREATEST_LOWER_BOUND));
    if (index >= 0) {
        var mapping = this._generatedMappings[index];
        if (mapping.generatedLine === needle.generatedLine) {
            var source = util.getArg(mapping, "source", null);
            if (source !== null) {
                source = this._sources.at(source);
                source = util.computeSourceURL(this.sourceRoot, source, this._sourceMapURL);
            }
            var name = util.getArg(mapping, "name", null);
            if (name !== null) name = this._names.at(name);
            return {
                source: source,
                line: util.getArg(mapping, "originalLine", null),
                column: util.getArg(mapping, "originalColumn", null),
                name: name
            };
        }
    }
    return {
        source: null,
        line: null,
        column: null,
        name: null
    };
};
/**
 * Return true if we have the source content for every source in the source
 * map, false otherwise.
 */ BasicSourceMapConsumer.prototype.hasContentsOfAllSources = function BasicSourceMapConsumer_hasContentsOfAllSources() {
    if (!this.sourcesContent) return false;
    return this.sourcesContent.length >= this._sources.size() && !this.sourcesContent.some(function(sc) {
        return sc == null;
    });
};
/**
 * Returns the original source content. The only argument is the url of the
 * original source file. Returns null if no original source content is
 * available.
 */ BasicSourceMapConsumer.prototype.sourceContentFor = function SourceMapConsumer_sourceContentFor(aSource, nullOnMissing) {
    if (!this.sourcesContent) return null;
    var index = this._findSourceIndex(aSource);
    if (index >= 0) return this.sourcesContent[index];
    var relativeSource = aSource;
    if (this.sourceRoot != null) relativeSource = util.relative(this.sourceRoot, relativeSource);
    var url;
    if (this.sourceRoot != null && (url = util.urlParse(this.sourceRoot))) {
        // XXX: file:// URIs and absolute paths lead to unexpected behavior for
        // many users. We can help them out when they expect file:// URIs to
        // behave like it would if they were running a local HTTP server. See
        // https://bugzilla.mozilla.org/show_bug.cgi?id=885597.
        var fileUriAbsPath = relativeSource.replace(/^file:\/\//, "");
        if (url.scheme == "file" && this._sources.has(fileUriAbsPath)) return this.sourcesContent[this._sources.indexOf(fileUriAbsPath)];
        if ((!url.path || url.path == "/") && this._sources.has("/" + relativeSource)) return this.sourcesContent[this._sources.indexOf("/" + relativeSource)];
    }
    // This function is used recursively from
    // IndexedSourceMapConsumer.prototype.sourceContentFor. In that case, we
    // don't want to throw if we can't find the source - we just want to
    // return null, so we provide a flag to exit gracefully.
    if (nullOnMissing) return null;
    else throw new Error('"' + relativeSource + '" is not in the SourceMap.');
};
/**
 * Returns the generated line and column information for the original source,
 * line, and column positions provided. The only argument is an object with
 * the following properties:
 *
 *   - source: The filename of the original source.
 *   - line: The line number in the original source.  The line number
 *     is 1-based.
 *   - column: The column number in the original source.  The column
 *     number is 0-based.
 *   - bias: Either 'SourceMapConsumer.GREATEST_LOWER_BOUND' or
 *     'SourceMapConsumer.LEAST_UPPER_BOUND'. Specifies whether to return the
 *     closest element that is smaller than or greater than the one we are
 *     searching for, respectively, if the exact element cannot be found.
 *     Defaults to 'SourceMapConsumer.GREATEST_LOWER_BOUND'.
 *
 * and an object is returned with the following properties:
 *
 *   - line: The line number in the generated source, or null.  The
 *     line number is 1-based.
 *   - column: The column number in the generated source, or null.
 *     The column number is 0-based.
 */ BasicSourceMapConsumer.prototype.generatedPositionFor = function SourceMapConsumer_generatedPositionFor(aArgs) {
    var source = util.getArg(aArgs, "source");
    source = this._findSourceIndex(source);
    if (source < 0) return {
        line: null,
        column: null,
        lastColumn: null
    };
    var needle = {
        source: source,
        originalLine: util.getArg(aArgs, "line"),
        originalColumn: util.getArg(aArgs, "column")
    };
    var index = this._findMapping(needle, this._originalMappings, "originalLine", "originalColumn", util.compareByOriginalPositions, util.getArg(aArgs, "bias", SourceMapConsumer.GREATEST_LOWER_BOUND));
    if (index >= 0) {
        var mapping = this._originalMappings[index];
        if (mapping.source === needle.source) return {
            line: util.getArg(mapping, "generatedLine", null),
            column: util.getArg(mapping, "generatedColumn", null),
            lastColumn: util.getArg(mapping, "lastGeneratedColumn", null)
        };
    }
    return {
        line: null,
        column: null,
        lastColumn: null
    };
};
exports.BasicSourceMapConsumer = BasicSourceMapConsumer;
/**
 * An IndexedSourceMapConsumer instance represents a parsed source map which
 * we can query for information. It differs from BasicSourceMapConsumer in
 * that it takes "indexed" source maps (i.e. ones with a "sections" field) as
 * input.
 *
 * The first parameter is a raw source map (either as a JSON string, or already
 * parsed to an object). According to the spec for indexed source maps, they
 * have the following attributes:
 *
 *   - version: Which version of the source map spec this map is following.
 *   - file: Optional. The generated file this source map is associated with.
 *   - sections: A list of section definitions.
 *
 * Each value under the "sections" field has two fields:
 *   - offset: The offset into the original specified at which this section
 *       begins to apply, defined as an object with a "line" and "column"
 *       field.
 *   - map: A source map definition. This source map could also be indexed,
 *       but doesn't have to be.
 *
 * Instead of the "map" field, it's also possible to have a "url" field
 * specifying a URL to retrieve a source map from, but that's currently
 * unsupported.
 *
 * Here's an example source map, taken from the source map spec[0], but
 * modified to omit a section which uses the "url" field.
 *
 *  {
 *    version : 3,
 *    file: "app.js",
 *    sections: [{
 *      offset: {line:100, column:10},
 *      map: {
 *        version : 3,
 *        file: "section.js",
 *        sources: ["foo.js", "bar.js"],
 *        names: ["src", "maps", "are", "fun"],
 *        mappings: "AAAA,E;;ABCDE;"
 *      }
 *    }],
 *  }
 *
 * The second parameter, if given, is a string whose value is the URL
 * at which the source map was found.  This URL is used to compute the
 * sources array.
 *
 * [0]: https://docs.google.com/document/d/1U1RGAehQwRypUTovF1KRlpiOFze0b-_2gc6fAH0KY0k/edit#heading=h.535es3xeprgt
 */ function IndexedSourceMapConsumer(aSourceMap, aSourceMapURL) {
    var sourceMap = aSourceMap;
    if (typeof aSourceMap === "string") sourceMap = util.parseSourceMapInput(aSourceMap);
    var version = util.getArg(sourceMap, "version");
    var sections = util.getArg(sourceMap, "sections");
    if (version != this._version) throw new Error("Unsupported version: " + version);
    this._sources = new ArraySet();
    this._names = new ArraySet();
    var lastOffset = {
        line: -1,
        column: 0
    };
    this._sections = sections.map(function(s) {
        if (s.url) // The url field will require support for asynchronicity.
        // See https://github.com/mozilla/source-map/issues/16
        throw new Error("Support for url field in sections not implemented.");
        var offset = util.getArg(s, "offset");
        var offsetLine = util.getArg(offset, "line");
        var offsetColumn = util.getArg(offset, "column");
        if (offsetLine < lastOffset.line || offsetLine === lastOffset.line && offsetColumn < lastOffset.column) throw new Error("Section offsets must be ordered and non-overlapping.");
        lastOffset = offset;
        return {
            generatedOffset: {
                // The offset fields are 0-based, but we use 1-based indices when
                // encoding/decoding from VLQ.
                generatedLine: offsetLine + 1,
                generatedColumn: offsetColumn + 1
            },
            consumer: new SourceMapConsumer(util.getArg(s, "map"), aSourceMapURL)
        };
    });
}
IndexedSourceMapConsumer.prototype = Object.create(SourceMapConsumer.prototype);
IndexedSourceMapConsumer.prototype.constructor = SourceMapConsumer;
/**
 * The version of the source mapping spec that we are consuming.
 */ IndexedSourceMapConsumer.prototype._version = 3;
/**
 * The list of original sources.
 */ Object.defineProperty(IndexedSourceMapConsumer.prototype, "sources", {
    get: function() {
        var sources = [];
        for(var i = 0; i < this._sections.length; i++)for(var j = 0; j < this._sections[i].consumer.sources.length; j++)sources.push(this._sections[i].consumer.sources[j]);
        return sources;
    }
});
/**
 * Returns the original source, line, and column information for the generated
 * source's line and column positions provided. The only argument is an object
 * with the following properties:
 *
 *   - line: The line number in the generated source.  The line number
 *     is 1-based.
 *   - column: The column number in the generated source.  The column
 *     number is 0-based.
 *
 * and an object is returned with the following properties:
 *
 *   - source: The original source file, or null.
 *   - line: The line number in the original source, or null.  The
 *     line number is 1-based.
 *   - column: The column number in the original source, or null.  The
 *     column number is 0-based.
 *   - name: The original identifier, or null.
 */ IndexedSourceMapConsumer.prototype.originalPositionFor = function IndexedSourceMapConsumer_originalPositionFor(aArgs) {
    var needle = {
        generatedLine: util.getArg(aArgs, "line"),
        generatedColumn: util.getArg(aArgs, "column")
    };
    // Find the section containing the generated position we're trying to map
    // to an original position.
    var sectionIndex = binarySearch.search(needle, this._sections, function(needle, section) {
        var cmp = needle.generatedLine - section.generatedOffset.generatedLine;
        if (cmp) return cmp;
        return needle.generatedColumn - section.generatedOffset.generatedColumn;
    });
    var section = this._sections[sectionIndex];
    if (!section) return {
        source: null,
        line: null,
        column: null,
        name: null
    };
    return section.consumer.originalPositionFor({
        line: needle.generatedLine - (section.generatedOffset.generatedLine - 1),
        column: needle.generatedColumn - (section.generatedOffset.generatedLine === needle.generatedLine ? section.generatedOffset.generatedColumn - 1 : 0),
        bias: aArgs.bias
    });
};
/**
 * Return true if we have the source content for every source in the source
 * map, false otherwise.
 */ IndexedSourceMapConsumer.prototype.hasContentsOfAllSources = function IndexedSourceMapConsumer_hasContentsOfAllSources() {
    return this._sections.every(function(s) {
        return s.consumer.hasContentsOfAllSources();
    });
};
/**
 * Returns the original source content. The only argument is the url of the
 * original source file. Returns null if no original source content is
 * available.
 */ IndexedSourceMapConsumer.prototype.sourceContentFor = function IndexedSourceMapConsumer_sourceContentFor(aSource, nullOnMissing) {
    for(var i = 0; i < this._sections.length; i++){
        var section = this._sections[i];
        var content = section.consumer.sourceContentFor(aSource, true);
        if (content) return content;
    }
    if (nullOnMissing) return null;
    else throw new Error('"' + aSource + '" is not in the SourceMap.');
};
/**
 * Returns the generated line and column information for the original source,
 * line, and column positions provided. The only argument is an object with
 * the following properties:
 *
 *   - source: The filename of the original source.
 *   - line: The line number in the original source.  The line number
 *     is 1-based.
 *   - column: The column number in the original source.  The column
 *     number is 0-based.
 *
 * and an object is returned with the following properties:
 *
 *   - line: The line number in the generated source, or null.  The
 *     line number is 1-based. 
 *   - column: The column number in the generated source, or null.
 *     The column number is 0-based.
 */ IndexedSourceMapConsumer.prototype.generatedPositionFor = function IndexedSourceMapConsumer_generatedPositionFor(aArgs) {
    for(var i = 0; i < this._sections.length; i++){
        var section = this._sections[i];
        // Only consider this section if the requested source is in the list of
        // sources of the consumer.
        if (section.consumer._findSourceIndex(util.getArg(aArgs, "source")) === -1) continue;
        var generatedPosition = section.consumer.generatedPositionFor(aArgs);
        if (generatedPosition) {
            var ret = {
                line: generatedPosition.line + (section.generatedOffset.generatedLine - 1),
                column: generatedPosition.column + (section.generatedOffset.generatedLine === generatedPosition.line ? section.generatedOffset.generatedColumn - 1 : 0)
            };
            return ret;
        }
    }
    return {
        line: null,
        column: null
    };
};
/**
 * Parse the mappings in a string in to a data structure which we can easily
 * query (the ordered arrays in the `this.__generatedMappings` and
 * `this.__originalMappings` properties).
 */ IndexedSourceMapConsumer.prototype._parseMappings = function IndexedSourceMapConsumer_parseMappings(aStr, aSourceRoot) {
    this.__generatedMappings = [];
    this.__originalMappings = [];
    for(var i = 0; i < this._sections.length; i++){
        var section = this._sections[i];
        var sectionMappings = section.consumer._generatedMappings;
        for(var j = 0; j < sectionMappings.length; j++){
            var mapping = sectionMappings[j];
            var source = section.consumer._sources.at(mapping.source);
            source = util.computeSourceURL(section.consumer.sourceRoot, source, this._sourceMapURL);
            this._sources.add(source);
            source = this._sources.indexOf(source);
            var name = null;
            if (mapping.name) {
                name = section.consumer._names.at(mapping.name);
                this._names.add(name);
                name = this._names.indexOf(name);
            }
            // The mappings coming from the consumer for the section have
            // generated positions relative to the start of the section, so we
            // need to offset them to be relative to the start of the concatenated
            // generated file.
            var adjustedMapping = {
                source: source,
                generatedLine: mapping.generatedLine + (section.generatedOffset.generatedLine - 1),
                generatedColumn: mapping.generatedColumn + (section.generatedOffset.generatedLine === mapping.generatedLine ? section.generatedOffset.generatedColumn - 1 : 0),
                originalLine: mapping.originalLine,
                originalColumn: mapping.originalColumn,
                name: name
            };
            this.__generatedMappings.push(adjustedMapping);
            if (typeof adjustedMapping.originalLine === "number") this.__originalMappings.push(adjustedMapping);
        }
    }
    quickSort(this.__generatedMappings, util.compareByGeneratedPositionsDeflated);
    quickSort(this.__originalMappings, util.compareByOriginalPositions);
};
exports.IndexedSourceMapConsumer = IndexedSourceMapConsumer;

},{"b22324b13f72201b":"3gsUu","129ba2b16e81db9e":"j68Gi","832bf56bf6a231e4":"5VumI","95d11d359ee56491":"5jlsn","7076e0beb1aa0cfd":"e6WSJ"}],"j68Gi":[function(require,module,exports) {
/* -*- Mode: js; js-indent-level: 2; -*- */ /*
 * Copyright 2011 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE or:
 * http://opensource.org/licenses/BSD-3-Clause
 */ exports.GREATEST_LOWER_BOUND = 1;
exports.LEAST_UPPER_BOUND = 2;
/**
 * Recursive implementation of binary search.
 *
 * @param aLow Indices here and lower do not contain the needle.
 * @param aHigh Indices here and higher do not contain the needle.
 * @param aNeedle The element being searched for.
 * @param aHaystack The non-empty array being searched.
 * @param aCompare Function which takes two elements and returns -1, 0, or 1.
 * @param aBias Either 'binarySearch.GREATEST_LOWER_BOUND' or
 *     'binarySearch.LEAST_UPPER_BOUND'. Specifies whether to return the
 *     closest element that is smaller than or greater than the one we are
 *     searching for, respectively, if the exact element cannot be found.
 */ function recursiveSearch(aLow, aHigh, aNeedle, aHaystack, aCompare, aBias) {
    // This function terminates when one of the following is true:
    //
    //   1. We find the exact element we are looking for.
    //
    //   2. We did not find the exact element, but we can return the index of
    //      the next-closest element.
    //
    //   3. We did not find the exact element, and there is no next-closest
    //      element than the one we are searching for, so we return -1.
    var mid = Math.floor((aHigh - aLow) / 2) + aLow;
    var cmp = aCompare(aNeedle, aHaystack[mid], true);
    if (cmp === 0) // Found the element we are looking for.
    return mid;
    else if (cmp > 0) {
        // Our needle is greater than aHaystack[mid].
        if (aHigh - mid > 1) // The element is in the upper half.
        return recursiveSearch(mid, aHigh, aNeedle, aHaystack, aCompare, aBias);
        // The exact needle element was not found in this haystack. Determine if
        // we are in termination case (3) or (2) and return the appropriate thing.
        if (aBias == exports.LEAST_UPPER_BOUND) return aHigh < aHaystack.length ? aHigh : -1;
        else return mid;
    } else {
        // Our needle is less than aHaystack[mid].
        if (mid - aLow > 1) // The element is in the lower half.
        return recursiveSearch(aLow, mid, aNeedle, aHaystack, aCompare, aBias);
        // we are in termination case (3) or (2) and return the appropriate thing.
        if (aBias == exports.LEAST_UPPER_BOUND) return mid;
        else return aLow < 0 ? -1 : aLow;
    }
}
/**
 * This is an implementation of binary search which will always try and return
 * the index of the closest element if there is no exact hit. This is because
 * mappings between original and generated line/col pairs are single points,
 * and there is an implicit region between each of them, so a miss just means
 * that you aren't on the very start of a region.
 *
 * @param aNeedle The element you are looking for.
 * @param aHaystack The array that is being searched.
 * @param aCompare A function which takes the needle and an element in the
 *     array and returns -1, 0, or 1 depending on whether the needle is less
 *     than, equal to, or greater than the element, respectively.
 * @param aBias Either 'binarySearch.GREATEST_LOWER_BOUND' or
 *     'binarySearch.LEAST_UPPER_BOUND'. Specifies whether to return the
 *     closest element that is smaller than or greater than the one we are
 *     searching for, respectively, if the exact element cannot be found.
 *     Defaults to 'binarySearch.GREATEST_LOWER_BOUND'.
 */ exports.search = function search(aNeedle, aHaystack, aCompare, aBias) {
    if (aHaystack.length === 0) return -1;
    var index = recursiveSearch(-1, aHaystack.length, aNeedle, aHaystack, aCompare, aBias || exports.GREATEST_LOWER_BOUND);
    if (index < 0) return -1;
    // We have found either the exact element, or the next-closest element than
    // the one we are searching for. However, there may be more than one such
    // element. Make sure we always return the smallest of these.
    while(index - 1 >= 0){
        if (aCompare(aHaystack[index], aHaystack[index - 1], true) !== 0) break;
        --index;
    }
    return index;
};

},{}],"e6WSJ":[function(require,module,exports) {
/* -*- Mode: js; js-indent-level: 2; -*- */ /*
 * Copyright 2011 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE or:
 * http://opensource.org/licenses/BSD-3-Clause
 */ // It turns out that some (most?) JavaScript engines don't self-host
// `Array.prototype.sort`. This makes sense because C++ will likely remain
// faster than JS when doing raw CPU-intensive sorting. However, when using a
// custom comparator function, calling back and forth between the VM's C++ and
// JIT'd JS is rather slow *and* loses JIT type information, resulting in
// worse generated code for the comparator function than would be optimal. In
// fact, when sorting with a comparator, these costs outweigh the benefits of
// sorting in C++. By using our own JS-implemented Quick Sort (below), we get
// a ~3500ms mean speed-up in `bench/bench.html`.
/**
 * Swap the elements indexed by `x` and `y` in the array `ary`.
 *
 * @param {Array} ary
 *        The array.
 * @param {Number} x
 *        The index of the first item.
 * @param {Number} y
 *        The index of the second item.
 */ function swap(ary, x, y) {
    var temp = ary[x];
    ary[x] = ary[y];
    ary[y] = temp;
}
/**
 * Returns a random integer within the range `low .. high` inclusive.
 *
 * @param {Number} low
 *        The lower bound on the range.
 * @param {Number} high
 *        The upper bound on the range.
 */ function randomIntInRange(low, high) {
    return Math.round(low + Math.random() * (high - low));
}
/**
 * The Quick Sort algorithm.
 *
 * @param {Array} ary
 *        An array to sort.
 * @param {function} comparator
 *        Function to use to compare two items.
 * @param {Number} p
 *        Start index of the array
 * @param {Number} r
 *        End index of the array
 */ function doQuickSort(ary, comparator, p, r) {
    // If our lower bound is less than our upper bound, we (1) partition the
    // array into two pieces and (2) recurse on each half. If it is not, this is
    // the empty array and our base case.
    if (p < r) {
        // (1) Partitioning.
        //
        // The partitioning chooses a pivot between `p` and `r` and moves all
        // elements that are less than or equal to the pivot to the before it, and
        // all the elements that are greater than it after it. The effect is that
        // once partition is done, the pivot is in the exact place it will be when
        // the array is put in sorted order, and it will not need to be moved
        // again. This runs in O(n) time.
        // Always choose a random pivot so that an input array which is reverse
        // sorted does not cause O(n^2) running time.
        var pivotIndex = randomIntInRange(p, r);
        var i = p - 1;
        swap(ary, pivotIndex, r);
        var pivot = ary[r];
        // Immediately after `j` is incremented in this loop, the following hold
        // true:
        //
        //   * Every element in `ary[p .. i]` is less than or equal to the pivot.
        //
        //   * Every element in `ary[i+1 .. j-1]` is greater than the pivot.
        for(var j = p; j < r; j++)if (comparator(ary[j], pivot) <= 0) {
            i += 1;
            swap(ary, i, j);
        }
        swap(ary, i + 1, j);
        var q = i + 1;
        // (2) Recurse on each half.
        doQuickSort(ary, comparator, p, q - 1);
        doQuickSort(ary, comparator, q + 1, r);
    }
}
/**
 * Sort the given array in-place with the given comparator function.
 *
 * @param {Array} ary
 *        An array to sort.
 * @param {function} comparator
 *        Function to use to compare two items.
 */ exports.quickSort = function(ary, comparator) {
    doQuickSort(ary, comparator, 0, ary.length - 1);
};

},{}],"f6lQj":[function(require,module,exports) {
/* -*- Mode: js; js-indent-level: 2; -*- */ /*
 * Copyright 2011 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE or:
 * http://opensource.org/licenses/BSD-3-Clause
 */ var SourceMapGenerator = require("a07d2c2c4b11c39f").SourceMapGenerator;
var util = require("18d5ff036a08fa06");
// Matches a Windows-style `\r\n` newline or a `\n` newline used by all other
// operating systems these days (capturing the result).
var REGEX_NEWLINE = /(\r?\n)/;
// Newline character code for charCodeAt() comparisons
var NEWLINE_CODE = 10;
// Private symbol for identifying `SourceNode`s when multiple versions of
// the source-map library are loaded. This MUST NOT CHANGE across
// versions!
var isSourceNode = "$$$isSourceNode$$$";
/**
 * SourceNodes provide a way to abstract over interpolating/concatenating
 * snippets of generated JavaScript source code while maintaining the line and
 * column information associated with the original source code.
 *
 * @param aLine The original line number.
 * @param aColumn The original column number.
 * @param aSource The original source's filename.
 * @param aChunks Optional. An array of strings which are snippets of
 *        generated JS, or other SourceNodes.
 * @param aName The original identifier.
 */ function SourceNode(aLine, aColumn, aSource, aChunks, aName) {
    this.children = [];
    this.sourceContents = {};
    this.line = aLine == null ? null : aLine;
    this.column = aColumn == null ? null : aColumn;
    this.source = aSource == null ? null : aSource;
    this.name = aName == null ? null : aName;
    this[isSourceNode] = true;
    if (aChunks != null) this.add(aChunks);
}
/**
 * Creates a SourceNode from generated code and a SourceMapConsumer.
 *
 * @param aGeneratedCode The generated code
 * @param aSourceMapConsumer The SourceMap for the generated code
 * @param aRelativePath Optional. The path that relative sources in the
 *        SourceMapConsumer should be relative to.
 */ SourceNode.fromStringWithSourceMap = function SourceNode_fromStringWithSourceMap(aGeneratedCode, aSourceMapConsumer, aRelativePath) {
    // The SourceNode we want to fill with the generated code
    // and the SourceMap
    var node = new SourceNode();
    // All even indices of this array are one line of the generated code,
    // while all odd indices are the newlines between two adjacent lines
    // (since `REGEX_NEWLINE` captures its match).
    // Processed fragments are accessed by calling `shiftNextLine`.
    var remainingLines = aGeneratedCode.split(REGEX_NEWLINE);
    var remainingLinesIndex = 0;
    var shiftNextLine = function() {
        var lineContents = getNextLine();
        // The last line of a file might not have a newline.
        var newLine = getNextLine() || "";
        return lineContents + newLine;
        function getNextLine() {
            return remainingLinesIndex < remainingLines.length ? remainingLines[remainingLinesIndex++] : undefined;
        }
    };
    // We need to remember the position of "remainingLines"
    var lastGeneratedLine = 1, lastGeneratedColumn = 0;
    // The generate SourceNodes we need a code range.
    // To extract it current and last mapping is used.
    // Here we store the last mapping.
    var lastMapping = null;
    aSourceMapConsumer.eachMapping(function(mapping) {
        if (lastMapping !== null) {
            // We add the code from "lastMapping" to "mapping":
            // First check if there is a new line in between.
            if (lastGeneratedLine < mapping.generatedLine) {
                // Associate first line with "lastMapping"
                addMappingWithCode(lastMapping, shiftNextLine());
                lastGeneratedLine++;
                lastGeneratedColumn = 0;
            // The remaining code is added without mapping
            } else {
                // There is no new line in between.
                // Associate the code between "lastGeneratedColumn" and
                // "mapping.generatedColumn" with "lastMapping"
                var nextLine = remainingLines[remainingLinesIndex] || "";
                var code = nextLine.substr(0, mapping.generatedColumn - lastGeneratedColumn);
                remainingLines[remainingLinesIndex] = nextLine.substr(mapping.generatedColumn - lastGeneratedColumn);
                lastGeneratedColumn = mapping.generatedColumn;
                addMappingWithCode(lastMapping, code);
                // No more remaining code, continue
                lastMapping = mapping;
                return;
            }
        }
        // We add the generated code until the first mapping
        // to the SourceNode without any mapping.
        // Each line is added as separate string.
        while(lastGeneratedLine < mapping.generatedLine){
            node.add(shiftNextLine());
            lastGeneratedLine++;
        }
        if (lastGeneratedColumn < mapping.generatedColumn) {
            var nextLine = remainingLines[remainingLinesIndex] || "";
            node.add(nextLine.substr(0, mapping.generatedColumn));
            remainingLines[remainingLinesIndex] = nextLine.substr(mapping.generatedColumn);
            lastGeneratedColumn = mapping.generatedColumn;
        }
        lastMapping = mapping;
    }, this);
    // We have processed all mappings.
    if (remainingLinesIndex < remainingLines.length) {
        if (lastMapping) // Associate the remaining code in the current line with "lastMapping"
        addMappingWithCode(lastMapping, shiftNextLine());
        // and add the remaining lines without any mapping
        node.add(remainingLines.splice(remainingLinesIndex).join(""));
    }
    // Copy sourcesContent into SourceNode
    aSourceMapConsumer.sources.forEach(function(sourceFile) {
        var content = aSourceMapConsumer.sourceContentFor(sourceFile);
        if (content != null) {
            if (aRelativePath != null) sourceFile = util.join(aRelativePath, sourceFile);
            node.setSourceContent(sourceFile, content);
        }
    });
    return node;
    function addMappingWithCode(mapping, code) {
        if (mapping === null || mapping.source === undefined) node.add(code);
        else {
            var source = aRelativePath ? util.join(aRelativePath, mapping.source) : mapping.source;
            node.add(new SourceNode(mapping.originalLine, mapping.originalColumn, source, code, mapping.name));
        }
    }
};
/**
 * Add a chunk of generated JS to this source node.
 *
 * @param aChunk A string snippet of generated JS code, another instance of
 *        SourceNode, or an array where each member is one of those things.
 */ SourceNode.prototype.add = function SourceNode_add(aChunk) {
    if (Array.isArray(aChunk)) aChunk.forEach(function(chunk) {
        this.add(chunk);
    }, this);
    else if (aChunk[isSourceNode] || typeof aChunk === "string") {
        if (aChunk) this.children.push(aChunk);
    } else throw new TypeError("Expected a SourceNode, string, or an array of SourceNodes and strings. Got " + aChunk);
    return this;
};
/**
 * Add a chunk of generated JS to the beginning of this source node.
 *
 * @param aChunk A string snippet of generated JS code, another instance of
 *        SourceNode, or an array where each member is one of those things.
 */ SourceNode.prototype.prepend = function SourceNode_prepend(aChunk) {
    if (Array.isArray(aChunk)) for(var i = aChunk.length - 1; i >= 0; i--)this.prepend(aChunk[i]);
    else if (aChunk[isSourceNode] || typeof aChunk === "string") this.children.unshift(aChunk);
    else throw new TypeError("Expected a SourceNode, string, or an array of SourceNodes and strings. Got " + aChunk);
    return this;
};
/**
 * Walk over the tree of JS snippets in this node and its children. The
 * walking function is called once for each snippet of JS and is passed that
 * snippet and the its original associated source's line/column location.
 *
 * @param aFn The traversal function.
 */ SourceNode.prototype.walk = function SourceNode_walk(aFn) {
    var chunk;
    for(var i = 0, len = this.children.length; i < len; i++){
        chunk = this.children[i];
        if (chunk[isSourceNode]) chunk.walk(aFn);
        else if (chunk !== "") aFn(chunk, {
            source: this.source,
            line: this.line,
            column: this.column,
            name: this.name
        });
    }
};
/**
 * Like `String.prototype.join` except for SourceNodes. Inserts `aStr` between
 * each of `this.children`.
 *
 * @param aSep The separator.
 */ SourceNode.prototype.join = function SourceNode_join(aSep) {
    var newChildren;
    var i;
    var len = this.children.length;
    if (len > 0) {
        newChildren = [];
        for(i = 0; i < len - 1; i++){
            newChildren.push(this.children[i]);
            newChildren.push(aSep);
        }
        newChildren.push(this.children[i]);
        this.children = newChildren;
    }
    return this;
};
/**
 * Call String.prototype.replace on the very right-most source snippet. Useful
 * for trimming whitespace from the end of a source node, etc.
 *
 * @param aPattern The pattern to replace.
 * @param aReplacement The thing to replace the pattern with.
 */ SourceNode.prototype.replaceRight = function SourceNode_replaceRight(aPattern, aReplacement) {
    var lastChild = this.children[this.children.length - 1];
    if (lastChild[isSourceNode]) lastChild.replaceRight(aPattern, aReplacement);
    else if (typeof lastChild === "string") this.children[this.children.length - 1] = lastChild.replace(aPattern, aReplacement);
    else this.children.push("".replace(aPattern, aReplacement));
    return this;
};
/**
 * Set the source content for a source file. This will be added to the SourceMapGenerator
 * in the sourcesContent field.
 *
 * @param aSourceFile The filename of the source file
 * @param aSourceContent The content of the source file
 */ SourceNode.prototype.setSourceContent = function SourceNode_setSourceContent(aSourceFile, aSourceContent) {
    this.sourceContents[util.toSetString(aSourceFile)] = aSourceContent;
};
/**
 * Walk over the tree of SourceNodes. The walking function is called for each
 * source file content and is passed the filename and source content.
 *
 * @param aFn The traversal function.
 */ SourceNode.prototype.walkSourceContents = function SourceNode_walkSourceContents(aFn) {
    for(var i = 0, len = this.children.length; i < len; i++)if (this.children[i][isSourceNode]) this.children[i].walkSourceContents(aFn);
    var sources = Object.keys(this.sourceContents);
    for(var i = 0, len = sources.length; i < len; i++)aFn(util.fromSetString(sources[i]), this.sourceContents[sources[i]]);
};
/**
 * Return the string representation of this source node. Walks over the tree
 * and concatenates all the various snippets together to one string.
 */ SourceNode.prototype.toString = function SourceNode_toString() {
    var str = "";
    this.walk(function(chunk) {
        str += chunk;
    });
    return str;
};
/**
 * Returns the string representation of this source node along with a source
 * map.
 */ SourceNode.prototype.toStringWithSourceMap = function SourceNode_toStringWithSourceMap(aArgs) {
    var generated = {
        code: "",
        line: 1,
        column: 0
    };
    var map = new SourceMapGenerator(aArgs);
    var sourceMappingActive = false;
    var lastOriginalSource = null;
    var lastOriginalLine = null;
    var lastOriginalColumn = null;
    var lastOriginalName = null;
    this.walk(function(chunk, original) {
        generated.code += chunk;
        if (original.source !== null && original.line !== null && original.column !== null) {
            if (lastOriginalSource !== original.source || lastOriginalLine !== original.line || lastOriginalColumn !== original.column || lastOriginalName !== original.name) map.addMapping({
                source: original.source,
                original: {
                    line: original.line,
                    column: original.column
                },
                generated: {
                    line: generated.line,
                    column: generated.column
                },
                name: original.name
            });
            lastOriginalSource = original.source;
            lastOriginalLine = original.line;
            lastOriginalColumn = original.column;
            lastOriginalName = original.name;
            sourceMappingActive = true;
        } else if (sourceMappingActive) {
            map.addMapping({
                generated: {
                    line: generated.line,
                    column: generated.column
                }
            });
            lastOriginalSource = null;
            sourceMappingActive = false;
        }
        for(var idx = 0, length = chunk.length; idx < length; idx++)if (chunk.charCodeAt(idx) === NEWLINE_CODE) {
            generated.line++;
            generated.column = 0;
            // Mappings end at eol
            if (idx + 1 === length) {
                lastOriginalSource = null;
                sourceMappingActive = false;
            } else if (sourceMappingActive) map.addMapping({
                source: original.source,
                original: {
                    line: original.line,
                    column: original.column
                },
                generated: {
                    line: generated.line,
                    column: generated.column
                },
                name: original.name
            });
        } else generated.column++;
    });
    this.walkSourceContents(function(sourceFile, sourceContent) {
        map.setSourceContent(sourceFile, sourceContent);
    });
    return {
        code: generated.code,
        map: map
    };
};
exports.SourceNode = SourceNode;

},{"a07d2c2c4b11c39f":"16QvG","18d5ff036a08fa06":"3gsUu"}],"a56E7":[function(require,module,exports) {
module.exports = JSON.parse('{"name":"escodegen","description":"ECMAScript code generator","homepage":"http://github.com/estools/escodegen","main":"escodegen.js","bin":{"esgenerate":"./bin/esgenerate.js","escodegen":"./bin/escodegen.js"},"files":["LICENSE.BSD","README.md","bin","escodegen.js","package.json"],"version":"2.0.0","engines":{"node":">=6.0"},"maintainers":[{"name":"Yusuke Suzuki","email":"utatane.tea@gmail.com","web":"http://github.com/Constellation"}],"repository":{"type":"git","url":"http://github.com/estools/escodegen.git"},"dependencies":{"estraverse":"^5.2.0","esutils":"^2.0.2","esprima":"^4.0.1","optionator":"^0.8.1"},"optionalDependencies":{"source-map":"~0.6.1"},"devDependencies":{"acorn":"^7.3.1","bluebird":"^3.4.7","bower-registry-client":"^1.0.0","chai":"^4.2.0","chai-exclude":"^2.0.2","commonjs-everywhere":"^0.9.7","gulp":"^3.8.10","gulp-eslint":"^3.0.1","gulp-mocha":"^3.0.1","semver":"^5.1.0"},"license":"BSD-2-Clause","scripts":{"test":"gulp travis","unit-test":"gulp test","lint":"gulp lint","release":"node tools/release.js","build-min":"./node_modules/.bin/cjsify -ma path: tools/entry-point.js > escodegen.browser.min.js","build":"./node_modules/.bin/cjsify -a path: tools/entry-point.js > escodegen.browser.js"}}');

},{}],"6nTsv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isMemo", ()=>isMemo);
parcelHelpers.export(exports, "isForwardRef", ()=>isForwardRef);
var _esSymbolJs = require("core-js/modules/es.symbol.js");
var _esSymbolDescriptionJs = require("core-js/modules/es.symbol.description.js");
var _esObjectToStringJs = require("core-js/modules/es.object.to-string.js");
var isMemo = function isMemo(component) {
    return component.$$typeof === Symbol.for("react.memo");
};
var isForwardRef = function isForwardRef(component) {
    return component.$$typeof === Symbol.for("react.forward_ref");
};

},{"core-js/modules/es.symbol.js":"ajw2f","core-js/modules/es.symbol.description.js":"wrlLc","core-js/modules/es.object.to-string.js":"lsA9p","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"g7DSz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _types = require("./types");
parcelHelpers.exportAll(_types, exports);
var _inspectValue = require("./inspectValue");
parcelHelpers.exportAll(_inspectValue, exports);

},{"./types":"d3pps","./inspectValue":"85dgU","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"d3pps":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InspectionType", ()=>InspectionType);
var InspectionType;
(function(InspectionType) {
    InspectionType["IDENTIFIER"] = "Identifier";
    InspectionType["LITERAL"] = "Literal";
    InspectionType["OBJECT"] = "Object";
    InspectionType["ARRAY"] = "Array";
    InspectionType["FUNCTION"] = "Function";
    InspectionType["CLASS"] = "Class";
    InspectionType["ELEMENT"] = "Element";
    InspectionType["UNKNOWN"] = "Unknown";
})(InspectionType || (InspectionType = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"85dgU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "inspectValue", ()=>inspectValue);
var _esObjectAssignJs = require("core-js/modules/es.object.assign.js");
var _acornParser = require("./acornParser");
var _types = require("./types");
function inspectValue(value) {
    try {
        var parsingResult = (0, _acornParser.parse)(value);
        return Object.assign({}, parsingResult);
    } catch (e) {}
    return {
        inferredType: {
            type: (0, _types.InspectionType).UNKNOWN
        }
    };
}

},{"core-js/modules/es.object.assign.js":"8FU8M","./acornParser":"7tgAY","./types":"d3pps","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"7tgAY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parse", ()=>parse);
var _esObjectAssignJs = require("core-js/modules/es.object.assign.js");
var _esFunctionNameJs = require("core-js/modules/es.function.name.js");
var _esArrayFilterJs = require("core-js/modules/es.array.filter.js");
var _esObjectToStringJs = require("core-js/modules/es.object.to-string.js");
var _acorn = require("acorn");
var _acornJsx = require("acorn-jsx");
var _acornJsxDefault = parcelHelpers.interopDefault(_acornJsx);
var _acornWalk = require("acorn-walk");
var _types = require("./types");
var ACORN_WALK_VISITORS = Object.assign({}, _acornWalk.base, {
    JSXElement: function JSXElement() {}
});
var acornParser = (0, _acorn.Parser).extend((0, _acornJsxDefault.default)()); // Cannot use "estree.Identifier" type because this function also support "JSXIdentifier".
function extractIdentifierName(identifierNode) {
    return identifierNode != null ? identifierNode.name : null;
}
function filterAncestors(ancestors) {
    return ancestors.filter(function(x) {
        return x.type === "ObjectExpression" || x.type === "ArrayExpression";
    });
}
function calculateNodeDepth(node) {
    var depths = [];
    _acornWalk.ancestor(node, {
        ObjectExpression: function ObjectExpression(_, ancestors) {
            depths.push(filterAncestors(ancestors).length);
        },
        ArrayExpression: function ArrayExpression(_, ancestors) {
            depths.push(filterAncestors(ancestors).length);
        }
    }, ACORN_WALK_VISITORS);
    return Math.max.apply(Math, depths);
}
function parseIdentifier(identifierNode) {
    return {
        inferredType: {
            type: (0, _types.InspectionType).IDENTIFIER,
            identifier: extractIdentifierName(identifierNode)
        },
        ast: identifierNode
    };
}
function parseLiteral(literalNode) {
    return {
        inferredType: {
            type: (0, _types.InspectionType).LITERAL
        },
        ast: literalNode
    };
}
function parseFunction(funcNode) {
    var innerJsxElementNode; // If there is at least a JSXElement in the body of the function, then it's a React component.
    _acornWalk.simple(funcNode.body, {
        JSXElement: function JSXElement(node) {
            innerJsxElementNode = node;
        }
    }, ACORN_WALK_VISITORS);
    var isJsx = innerJsxElementNode != null;
    var inferredType = {
        type: isJsx ? (0, _types.InspectionType).ELEMENT : (0, _types.InspectionType).FUNCTION,
        params: funcNode.params,
        hasParams: funcNode.params.length !== 0
    };
    var identifierName = extractIdentifierName(funcNode.id);
    if (identifierName != null) inferredType.identifier = identifierName;
    return {
        inferredType: inferredType,
        ast: funcNode
    };
}
function parseClass(classNode) {
    var innerJsxElementNode; // If there is at least a JSXElement in the body of the class, then it's a React component.
    _acornWalk.simple(classNode.body, {
        JSXElement: function JSXElement(node) {
            innerJsxElementNode = node;
        }
    }, ACORN_WALK_VISITORS);
    var inferredType = {
        type: innerJsxElementNode != null ? (0, _types.InspectionType).ELEMENT : (0, _types.InspectionType).CLASS,
        identifier: extractIdentifierName(classNode.id)
    };
    return {
        inferredType: inferredType,
        ast: classNode
    };
}
function parseJsxElement(jsxElementNode) {
    var inferredType = {
        type: (0, _types.InspectionType).ELEMENT
    };
    var identifierName = extractIdentifierName(jsxElementNode.openingElement.name);
    if (identifierName != null) inferredType.identifier = identifierName;
    return {
        inferredType: inferredType,
        ast: jsxElementNode
    };
}
function parseCall(callNode) {
    var identifierNode = callNode.callee.type === "MemberExpression" ? callNode.callee.property : callNode.callee;
    var identifierName = extractIdentifierName(identifierNode);
    if (identifierName === "shape") return parseObject(callNode.arguments[0]);
    return null;
}
function parseObject(objectNode) {
    return {
        inferredType: {
            type: (0, _types.InspectionType).OBJECT,
            depth: calculateNodeDepth(objectNode)
        },
        ast: objectNode
    };
}
function parseArray(arrayNode) {
    return {
        inferredType: {
            type: (0, _types.InspectionType).ARRAY,
            depth: calculateNodeDepth(arrayNode)
        },
        ast: arrayNode
    };
} // Cannot set "expression" type to "estree.Expression" because the type doesn't include JSX.
function parseExpression(expression) {
    switch(expression.type){
        case "Identifier":
            return parseIdentifier(expression);
        case "Literal":
            return parseLiteral(expression);
        case "FunctionExpression":
        case "ArrowFunctionExpression":
            return parseFunction(expression);
        case "ClassExpression":
            return parseClass(expression);
        case "JSXElement":
            return parseJsxElement(expression);
        case "CallExpression":
            return parseCall(expression);
        case "ObjectExpression":
            return parseObject(expression);
        case "ArrayExpression":
            return parseArray(expression);
        default:
            return null;
    }
}
function parse(value) {
    var ast = acornParser.parse("(".concat(value, ")"));
    var parsingResult = {
        inferredType: {
            type: (0, _types.InspectionType).UNKNOWN
        },
        ast: ast
    };
    if (ast.body[0] != null) {
        var rootNode = ast.body[0];
        switch(rootNode.type){
            case "ExpressionStatement":
                var expressionResult = parseExpression(rootNode.expression);
                if (expressionResult != null) parsingResult = expressionResult;
                break;
            default:
                break;
        }
    }
    return parsingResult;
}

},{"core-js/modules/es.object.assign.js":"8FU8M","core-js/modules/es.function.name.js":"4LiLL","core-js/modules/es.array.filter.js":"fD2da","core-js/modules/es.object.to-string.js":"lsA9p","acorn":"j6GsH","acorn-jsx":"fbU2z","acorn-walk":"3hWFw","./types":"d3pps","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"j6GsH":[function(require,module,exports) {
// Reserved word lists for various dialects of the language
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Node", ()=>Node);
parcelHelpers.export(exports, "Parser", ()=>Parser);
parcelHelpers.export(exports, "Position", ()=>Position);
parcelHelpers.export(exports, "SourceLocation", ()=>SourceLocation);
parcelHelpers.export(exports, "TokContext", ()=>TokContext);
parcelHelpers.export(exports, "Token", ()=>Token);
parcelHelpers.export(exports, "TokenType", ()=>TokenType);
parcelHelpers.export(exports, "defaultOptions", ()=>defaultOptions);
parcelHelpers.export(exports, "getLineInfo", ()=>getLineInfo);
parcelHelpers.export(exports, "isIdentifierChar", ()=>isIdentifierChar);
parcelHelpers.export(exports, "isIdentifierStart", ()=>isIdentifierStart);
parcelHelpers.export(exports, "isNewLine", ()=>isNewLine);
parcelHelpers.export(exports, "keywordTypes", ()=>keywords$1);
parcelHelpers.export(exports, "lineBreak", ()=>lineBreak);
parcelHelpers.export(exports, "lineBreakG", ()=>lineBreakG);
parcelHelpers.export(exports, "nonASCIIwhitespace", ()=>nonASCIIwhitespace);
parcelHelpers.export(exports, "parse", ()=>parse);
parcelHelpers.export(exports, "parseExpressionAt", ()=>parseExpressionAt);
parcelHelpers.export(exports, "tokContexts", ()=>types$1);
parcelHelpers.export(exports, "tokTypes", ()=>types);
parcelHelpers.export(exports, "tokenizer", ()=>tokenizer);
parcelHelpers.export(exports, "version", ()=>version);
var reservedWords = {
    3: "abstract boolean byte char class double enum export extends final float goto implements import int interface long native package private protected public short static super synchronized throws transient volatile",
    5: "class enum extends super const export import",
    6: "enum",
    strict: "implements interface let package private protected public static yield",
    strictBind: "eval arguments"
};
// And the keywords
var ecma5AndLessKeywords = "break case catch continue debugger default do else finally for function if return switch throw try var while with null true false instanceof typeof void delete new in this";
var keywords = {
    5: ecma5AndLessKeywords,
    "5module": ecma5AndLessKeywords + " export import",
    6: ecma5AndLessKeywords + " const class extends export import super"
};
var keywordRelationalOperator = /^in(stanceof)?$/;
// ## Character categories
// Big ugly regular expressions that match characters in the
// whitespace, identifier, and identifier-start categories. These
// are only applied when a character is found to actually have a
// code point above 128.
// Generated by `bin/generate-identifier-regex.js`.
var nonASCIIidentifierStartChars = "\xaa\xb5\xba\xc0-\xd6\xd8-\xf6\xf8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0560-\u0588\u05D0-\u05EA\u05EF-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u0860-\u086A\u08A0-\u08B4\u08B6-\u08C7\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u09FC\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D04-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E86-\u0E8A\u0E8C-\u0EA3\u0EA5\u0EA7-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1878\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C88\u1C90-\u1CBA\u1CBD-\u1CBF\u1CE9-\u1CEC\u1CEE-\u1CF3\u1CF5\u1CF6\u1CFA\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2118-\u211D\u2124\u2126\u2128\u212A-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u3005-\u3007\u3021-\u3029\u3031-\u3035\u3038-\u303C\u3041-\u3096\u309B-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312F\u3131-\u318E\u31A0-\u31BF\u31F0-\u31FF\u3400-\u4DBF\u4E00-\u9FFC\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6EF\uA717-\uA71F\uA722-\uA788\uA78B-\uA7BF\uA7C2-\uA7CA\uA7F5-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA8FE\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB69\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC";
var nonASCIIidentifierChars = "\u200C\u200D\xb7\u0300-\u036F\u0387\u0483-\u0487\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u0610-\u061A\u064B-\u0669\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7\u06E8\u06EA-\u06ED\u06F0-\u06F9\u0711\u0730-\u074A\u07A6-\u07B0\u07C0-\u07C9\u07EB-\u07F3\u07FD\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0859-\u085B\u08D3-\u08E1\u08E3-\u0903\u093A-\u093C\u093E-\u094F\u0951-\u0957\u0962\u0963\u0966-\u096F\u0981-\u0983\u09BC\u09BE-\u09C4\u09C7\u09C8\u09CB-\u09CD\u09D7\u09E2\u09E3\u09E6-\u09EF\u09FE\u0A01-\u0A03\u0A3C\u0A3E-\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A66-\u0A71\u0A75\u0A81-\u0A83\u0ABC\u0ABE-\u0AC5\u0AC7-\u0AC9\u0ACB-\u0ACD\u0AE2\u0AE3\u0AE6-\u0AEF\u0AFA-\u0AFF\u0B01-\u0B03\u0B3C\u0B3E-\u0B44\u0B47\u0B48\u0B4B-\u0B4D\u0B55-\u0B57\u0B62\u0B63\u0B66-\u0B6F\u0B82\u0BBE-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCD\u0BD7\u0BE6-\u0BEF\u0C00-\u0C04\u0C3E-\u0C44\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C62\u0C63\u0C66-\u0C6F\u0C81-\u0C83\u0CBC\u0CBE-\u0CC4\u0CC6-\u0CC8\u0CCA-\u0CCD\u0CD5\u0CD6\u0CE2\u0CE3\u0CE6-\u0CEF\u0D00-\u0D03\u0D3B\u0D3C\u0D3E-\u0D44\u0D46-\u0D48\u0D4A-\u0D4D\u0D57\u0D62\u0D63\u0D66-\u0D6F\u0D81-\u0D83\u0DCA\u0DCF-\u0DD4\u0DD6\u0DD8-\u0DDF\u0DE6-\u0DEF\u0DF2\u0DF3\u0E31\u0E34-\u0E3A\u0E47-\u0E4E\u0E50-\u0E59\u0EB1\u0EB4-\u0EBC\u0EC8-\u0ECD\u0ED0-\u0ED9\u0F18\u0F19\u0F20-\u0F29\u0F35\u0F37\u0F39\u0F3E\u0F3F\u0F71-\u0F84\u0F86\u0F87\u0F8D-\u0F97\u0F99-\u0FBC\u0FC6\u102B-\u103E\u1040-\u1049\u1056-\u1059\u105E-\u1060\u1062-\u1064\u1067-\u106D\u1071-\u1074\u1082-\u108D\u108F-\u109D\u135D-\u135F\u1369-\u1371\u1712-\u1714\u1732-\u1734\u1752\u1753\u1772\u1773\u17B4-\u17D3\u17DD\u17E0-\u17E9\u180B-\u180D\u1810-\u1819\u18A9\u1920-\u192B\u1930-\u193B\u1946-\u194F\u19D0-\u19DA\u1A17-\u1A1B\u1A55-\u1A5E\u1A60-\u1A7C\u1A7F-\u1A89\u1A90-\u1A99\u1AB0-\u1ABD\u1ABF\u1AC0\u1B00-\u1B04\u1B34-\u1B44\u1B50-\u1B59\u1B6B-\u1B73\u1B80-\u1B82\u1BA1-\u1BAD\u1BB0-\u1BB9\u1BE6-\u1BF3\u1C24-\u1C37\u1C40-\u1C49\u1C50-\u1C59\u1CD0-\u1CD2\u1CD4-\u1CE8\u1CED\u1CF4\u1CF7-\u1CF9\u1DC0-\u1DF9\u1DFB-\u1DFF\u203F\u2040\u2054\u20D0-\u20DC\u20E1\u20E5-\u20F0\u2CEF-\u2CF1\u2D7F\u2DE0-\u2DFF\u302A-\u302F\u3099\u309A\uA620-\uA629\uA66F\uA674-\uA67D\uA69E\uA69F\uA6F0\uA6F1\uA802\uA806\uA80B\uA823-\uA827\uA82C\uA880\uA881\uA8B4-\uA8C5\uA8D0-\uA8D9\uA8E0-\uA8F1\uA8FF-\uA909\uA926-\uA92D\uA947-\uA953\uA980-\uA983\uA9B3-\uA9C0\uA9D0-\uA9D9\uA9E5\uA9F0-\uA9F9\uAA29-\uAA36\uAA43\uAA4C\uAA4D\uAA50-\uAA59\uAA7B-\uAA7D\uAAB0\uAAB2-\uAAB4\uAAB7\uAAB8\uAABE\uAABF\uAAC1\uAAEB-\uAAEF\uAAF5\uAAF6\uABE3-\uABEA\uABEC\uABED\uABF0-\uABF9\uFB1E\uFE00-\uFE0F\uFE20-\uFE2F\uFE33\uFE34\uFE4D-\uFE4F\uFF10-\uFF19\uFF3F";
var nonASCIIidentifierStart = new RegExp("[" + nonASCIIidentifierStartChars + "]");
var nonASCIIidentifier = new RegExp("[" + nonASCIIidentifierStartChars + nonASCIIidentifierChars + "]");
nonASCIIidentifierStartChars = nonASCIIidentifierChars = null;
// These are a run-length and offset encoded representation of the
// >0xffff code points that are a valid part of identifiers. The
// offset starts at 0x10000, and each pair of numbers represents an
// offset to the next range, and then a size of the range. They were
// generated by bin/generate-identifier-regex.js
// eslint-disable-next-line comma-spacing
var astralIdentifierStartCodes = [
    0,
    11,
    2,
    25,
    2,
    18,
    2,
    1,
    2,
    14,
    3,
    13,
    35,
    122,
    70,
    52,
    268,
    28,
    4,
    48,
    48,
    31,
    14,
    29,
    6,
    37,
    11,
    29,
    3,
    35,
    5,
    7,
    2,
    4,
    43,
    157,
    19,
    35,
    5,
    35,
    5,
    39,
    9,
    51,
    157,
    310,
    10,
    21,
    11,
    7,
    153,
    5,
    3,
    0,
    2,
    43,
    2,
    1,
    4,
    0,
    3,
    22,
    11,
    22,
    10,
    30,
    66,
    18,
    2,
    1,
    11,
    21,
    11,
    25,
    71,
    55,
    7,
    1,
    65,
    0,
    16,
    3,
    2,
    2,
    2,
    28,
    43,
    28,
    4,
    28,
    36,
    7,
    2,
    27,
    28,
    53,
    11,
    21,
    11,
    18,
    14,
    17,
    111,
    72,
    56,
    50,
    14,
    50,
    14,
    35,
    349,
    41,
    7,
    1,
    79,
    28,
    11,
    0,
    9,
    21,
    107,
    20,
    28,
    22,
    13,
    52,
    76,
    44,
    33,
    24,
    27,
    35,
    30,
    0,
    3,
    0,
    9,
    34,
    4,
    0,
    13,
    47,
    15,
    3,
    22,
    0,
    2,
    0,
    36,
    17,
    2,
    24,
    85,
    6,
    2,
    0,
    2,
    3,
    2,
    14,
    2,
    9,
    8,
    46,
    39,
    7,
    3,
    1,
    3,
    21,
    2,
    6,
    2,
    1,
    2,
    4,
    4,
    0,
    19,
    0,
    13,
    4,
    159,
    52,
    19,
    3,
    21,
    2,
    31,
    47,
    21,
    1,
    2,
    0,
    185,
    46,
    42,
    3,
    37,
    47,
    21,
    0,
    60,
    42,
    14,
    0,
    72,
    26,
    230,
    43,
    117,
    63,
    32,
    7,
    3,
    0,
    3,
    7,
    2,
    1,
    2,
    23,
    16,
    0,
    2,
    0,
    95,
    7,
    3,
    38,
    17,
    0,
    2,
    0,
    29,
    0,
    11,
    39,
    8,
    0,
    22,
    0,
    12,
    45,
    20,
    0,
    35,
    56,
    264,
    8,
    2,
    36,
    18,
    0,
    50,
    29,
    113,
    6,
    2,
    1,
    2,
    37,
    22,
    0,
    26,
    5,
    2,
    1,
    2,
    31,
    15,
    0,
    328,
    18,
    190,
    0,
    80,
    921,
    103,
    110,
    18,
    195,
    2749,
    1070,
    4050,
    582,
    8634,
    568,
    8,
    30,
    114,
    29,
    19,
    47,
    17,
    3,
    32,
    20,
    6,
    18,
    689,
    63,
    129,
    74,
    6,
    0,
    67,
    12,
    65,
    1,
    2,
    0,
    29,
    6135,
    9,
    1237,
    43,
    8,
    8952,
    286,
    50,
    2,
    18,
    3,
    9,
    395,
    2309,
    106,
    6,
    12,
    4,
    8,
    8,
    9,
    5991,
    84,
    2,
    70,
    2,
    1,
    3,
    0,
    3,
    1,
    3,
    3,
    2,
    11,
    2,
    0,
    2,
    6,
    2,
    64,
    2,
    3,
    3,
    7,
    2,
    6,
    2,
    27,
    2,
    3,
    2,
    4,
    2,
    0,
    4,
    6,
    2,
    339,
    3,
    24,
    2,
    24,
    2,
    30,
    2,
    24,
    2,
    30,
    2,
    24,
    2,
    30,
    2,
    24,
    2,
    30,
    2,
    24,
    2,
    7,
    2357,
    44,
    11,
    6,
    17,
    0,
    370,
    43,
    1301,
    196,
    60,
    67,
    8,
    0,
    1205,
    3,
    2,
    26,
    2,
    1,
    2,
    0,
    3,
    0,
    2,
    9,
    2,
    3,
    2,
    0,
    2,
    0,
    7,
    0,
    5,
    0,
    2,
    0,
    2,
    0,
    2,
    2,
    2,
    1,
    2,
    0,
    3,
    0,
    2,
    0,
    2,
    0,
    2,
    0,
    2,
    0,
    2,
    1,
    2,
    0,
    3,
    3,
    2,
    6,
    2,
    3,
    2,
    3,
    2,
    0,
    2,
    9,
    2,
    16,
    6,
    2,
    2,
    4,
    2,
    16,
    4421,
    42717,
    35,
    4148,
    12,
    221,
    3,
    5761,
    15,
    7472,
    3104,
    541,
    1507,
    4938
];
// eslint-disable-next-line comma-spacing
var astralIdentifierCodes = [
    509,
    0,
    227,
    0,
    150,
    4,
    294,
    9,
    1368,
    2,
    2,
    1,
    6,
    3,
    41,
    2,
    5,
    0,
    166,
    1,
    574,
    3,
    9,
    9,
    370,
    1,
    154,
    10,
    176,
    2,
    54,
    14,
    32,
    9,
    16,
    3,
    46,
    10,
    54,
    9,
    7,
    2,
    37,
    13,
    2,
    9,
    6,
    1,
    45,
    0,
    13,
    2,
    49,
    13,
    9,
    3,
    2,
    11,
    83,
    11,
    7,
    0,
    161,
    11,
    6,
    9,
    7,
    3,
    56,
    1,
    2,
    6,
    3,
    1,
    3,
    2,
    10,
    0,
    11,
    1,
    3,
    6,
    4,
    4,
    193,
    17,
    10,
    9,
    5,
    0,
    82,
    19,
    13,
    9,
    214,
    6,
    3,
    8,
    28,
    1,
    83,
    16,
    16,
    9,
    82,
    12,
    9,
    9,
    84,
    14,
    5,
    9,
    243,
    14,
    166,
    9,
    71,
    5,
    2,
    1,
    3,
    3,
    2,
    0,
    2,
    1,
    13,
    9,
    120,
    6,
    3,
    6,
    4,
    0,
    29,
    9,
    41,
    6,
    2,
    3,
    9,
    0,
    10,
    10,
    47,
    15,
    406,
    7,
    2,
    7,
    17,
    9,
    57,
    21,
    2,
    13,
    123,
    5,
    4,
    0,
    2,
    1,
    2,
    6,
    2,
    0,
    9,
    9,
    49,
    4,
    2,
    1,
    2,
    4,
    9,
    9,
    330,
    3,
    19306,
    9,
    135,
    4,
    60,
    6,
    26,
    9,
    1014,
    0,
    2,
    54,
    8,
    3,
    82,
    0,
    12,
    1,
    19628,
    1,
    5319,
    4,
    4,
    5,
    9,
    7,
    3,
    6,
    31,
    3,
    149,
    2,
    1418,
    49,
    513,
    54,
    5,
    49,
    9,
    0,
    15,
    0,
    23,
    4,
    2,
    14,
    1361,
    6,
    2,
    16,
    3,
    6,
    2,
    1,
    2,
    4,
    262,
    6,
    10,
    9,
    419,
    13,
    1495,
    6,
    110,
    6,
    6,
    9,
    4759,
    9,
    787719,
    239
];
// This has a complexity linear to the value of the code. The
// assumption is that looking up astral identifier characters is
// rare.
function isInAstralSet(code, set) {
    var pos = 0x10000;
    for(var i = 0; i < set.length; i += 2){
        pos += set[i];
        if (pos > code) return false;
        pos += set[i + 1];
        if (pos >= code) return true;
    }
}
// Test whether a given character code starts an identifier.
function isIdentifierStart(code, astral) {
    if (code < 65) return code === 36;
    if (code < 91) return true;
    if (code < 97) return code === 95;
    if (code < 123) return true;
    if (code <= 0xffff) return code >= 0xaa && nonASCIIidentifierStart.test(String.fromCharCode(code));
    if (astral === false) return false;
    return isInAstralSet(code, astralIdentifierStartCodes);
}
// Test whether a given character is part of an identifier.
function isIdentifierChar(code, astral) {
    if (code < 48) return code === 36;
    if (code < 58) return true;
    if (code < 65) return false;
    if (code < 91) return true;
    if (code < 97) return code === 95;
    if (code < 123) return true;
    if (code <= 0xffff) return code >= 0xaa && nonASCIIidentifier.test(String.fromCharCode(code));
    if (astral === false) return false;
    return isInAstralSet(code, astralIdentifierStartCodes) || isInAstralSet(code, astralIdentifierCodes);
}
// ## Token types
// The assignment of fine-grained, information-carrying type objects
// allows the tokenizer to store the information it has about a
// token in a way that is very cheap for the parser to look up.
// All token type variables start with an underscore, to make them
// easy to recognize.
// The `beforeExpr` property is used to disambiguate between regular
// expressions and divisions. It is set on all token types that can
// be followed by an expression (thus, a slash after them would be a
// regular expression).
//
// The `startsExpr` property is used to check if the token ends a
// `yield` expression. It is set on all token types that either can
// directly start an expression (like a quotation mark) or can
// continue an expression (like the body of a string).
//
// `isLoop` marks a keyword as starting a loop, which is important
// to know when parsing a label, in order to allow or disallow
// continue jumps to that label.
var TokenType = function TokenType(label, conf) {
    if (conf === void 0) conf = {};
    this.label = label;
    this.keyword = conf.keyword;
    this.beforeExpr = !!conf.beforeExpr;
    this.startsExpr = !!conf.startsExpr;
    this.isLoop = !!conf.isLoop;
    this.isAssign = !!conf.isAssign;
    this.prefix = !!conf.prefix;
    this.postfix = !!conf.postfix;
    this.binop = conf.binop || null;
    this.updateContext = null;
};
function binop(name, prec) {
    return new TokenType(name, {
        beforeExpr: true,
        binop: prec
    });
}
var beforeExpr = {
    beforeExpr: true
}, startsExpr = {
    startsExpr: true
};
// Map keyword names to token types.
var keywords$1 = {};
// Succinct definitions of keyword token types
function kw(name, options) {
    if (options === void 0) options = {};
    options.keyword = name;
    return keywords$1[name] = new TokenType(name, options);
}
var types = {
    num: new TokenType("num", startsExpr),
    regexp: new TokenType("regexp", startsExpr),
    string: new TokenType("string", startsExpr),
    name: new TokenType("name", startsExpr),
    eof: new TokenType("eof"),
    // Punctuation token types.
    bracketL: new TokenType("[", {
        beforeExpr: true,
        startsExpr: true
    }),
    bracketR: new TokenType("]"),
    braceL: new TokenType("{", {
        beforeExpr: true,
        startsExpr: true
    }),
    braceR: new TokenType("}"),
    parenL: new TokenType("(", {
        beforeExpr: true,
        startsExpr: true
    }),
    parenR: new TokenType(")"),
    comma: new TokenType(",", beforeExpr),
    semi: new TokenType(";", beforeExpr),
    colon: new TokenType(":", beforeExpr),
    dot: new TokenType("."),
    question: new TokenType("?", beforeExpr),
    questionDot: new TokenType("?."),
    arrow: new TokenType("=>", beforeExpr),
    template: new TokenType("template"),
    invalidTemplate: new TokenType("invalidTemplate"),
    ellipsis: new TokenType("...", beforeExpr),
    backQuote: new TokenType("`", startsExpr),
    dollarBraceL: new TokenType("${", {
        beforeExpr: true,
        startsExpr: true
    }),
    // Operators. These carry several kinds of properties to help the
    // parser use them properly (the presence of these properties is
    // what categorizes them as operators).
    //
    // `binop`, when present, specifies that this operator is a binary
    // operator, and will refer to its precedence.
    //
    // `prefix` and `postfix` mark the operator as a prefix or postfix
    // unary operator.
    //
    // `isAssign` marks all of `=`, `+=`, `-=` etcetera, which act as
    // binary operators with a very low precedence, that should result
    // in AssignmentExpression nodes.
    eq: new TokenType("=", {
        beforeExpr: true,
        isAssign: true
    }),
    assign: new TokenType("_=", {
        beforeExpr: true,
        isAssign: true
    }),
    incDec: new TokenType("++/--", {
        prefix: true,
        postfix: true,
        startsExpr: true
    }),
    prefix: new TokenType("!/~", {
        beforeExpr: true,
        prefix: true,
        startsExpr: true
    }),
    logicalOR: binop("||", 1),
    logicalAND: binop("&&", 2),
    bitwiseOR: binop("|", 3),
    bitwiseXOR: binop("^", 4),
    bitwiseAND: binop("&", 5),
    equality: binop("==/!=/===/!==", 6),
    relational: binop("</>/<=/>=", 7),
    bitShift: binop("<</>>/>>>", 8),
    plusMin: new TokenType("+/-", {
        beforeExpr: true,
        binop: 9,
        prefix: true,
        startsExpr: true
    }),
    modulo: binop("%", 10),
    star: binop("*", 10),
    slash: binop("/", 10),
    starstar: new TokenType("**", {
        beforeExpr: true
    }),
    coalesce: binop("??", 1),
    // Keyword token types.
    _break: kw("break"),
    _case: kw("case", beforeExpr),
    _catch: kw("catch"),
    _continue: kw("continue"),
    _debugger: kw("debugger"),
    _default: kw("default", beforeExpr),
    _do: kw("do", {
        isLoop: true,
        beforeExpr: true
    }),
    _else: kw("else", beforeExpr),
    _finally: kw("finally"),
    _for: kw("for", {
        isLoop: true
    }),
    _function: kw("function", startsExpr),
    _if: kw("if"),
    _return: kw("return", beforeExpr),
    _switch: kw("switch"),
    _throw: kw("throw", beforeExpr),
    _try: kw("try"),
    _var: kw("var"),
    _const: kw("const"),
    _while: kw("while", {
        isLoop: true
    }),
    _with: kw("with"),
    _new: kw("new", {
        beforeExpr: true,
        startsExpr: true
    }),
    _this: kw("this", startsExpr),
    _super: kw("super", startsExpr),
    _class: kw("class", startsExpr),
    _extends: kw("extends", beforeExpr),
    _export: kw("export"),
    _import: kw("import", startsExpr),
    _null: kw("null", startsExpr),
    _true: kw("true", startsExpr),
    _false: kw("false", startsExpr),
    _in: kw("in", {
        beforeExpr: true,
        binop: 7
    }),
    _instanceof: kw("instanceof", {
        beforeExpr: true,
        binop: 7
    }),
    _typeof: kw("typeof", {
        beforeExpr: true,
        prefix: true,
        startsExpr: true
    }),
    _void: kw("void", {
        beforeExpr: true,
        prefix: true,
        startsExpr: true
    }),
    _delete: kw("delete", {
        beforeExpr: true,
        prefix: true,
        startsExpr: true
    })
};
// Matches a whole line break (where CRLF is considered a single
// line break). Used to count lines.
var lineBreak = /\r\n?|\n|\u2028|\u2029/;
var lineBreakG = new RegExp(lineBreak.source, "g");
function isNewLine(code, ecma2019String) {
    return code === 10 || code === 13 || !ecma2019String && (code === 0x2028 || code === 0x2029);
}
var nonASCIIwhitespace = /[\u1680\u2000-\u200a\u202f\u205f\u3000\ufeff]/;
var skipWhiteSpace = /(?:\s|\/\/.*|\/\*[^]*?\*\/)*/g;
var ref = Object.prototype;
var hasOwnProperty = ref.hasOwnProperty;
var toString = ref.toString;
// Checks if an object has a property.
function has(obj, propName) {
    return hasOwnProperty.call(obj, propName);
}
var isArray = Array.isArray || function(obj) {
    return toString.call(obj) === "[object Array]";
};
function wordsRegexp(words) {
    return new RegExp("^(?:" + words.replace(/ /g, "|") + ")$");
}
// These are used when `options.locations` is on, for the
// `startLoc` and `endLoc` properties.
var Position = function Position(line, col) {
    this.line = line;
    this.column = col;
};
Position.prototype.offset = function offset(n) {
    return new Position(this.line, this.column + n);
};
var SourceLocation = function SourceLocation(p, start, end) {
    this.start = start;
    this.end = end;
    if (p.sourceFile !== null) this.source = p.sourceFile;
};
// The `getLineInfo` function is mostly useful when the
// `locations` option is off (for performance reasons) and you
// want to find the line/column position for a given character
// offset. `input` should be the code string that the offset refers
// into.
function getLineInfo(input, offset) {
    for(var line = 1, cur = 0;;){
        lineBreakG.lastIndex = cur;
        var match = lineBreakG.exec(input);
        if (match && match.index < offset) {
            ++line;
            cur = match.index + match[0].length;
        } else return new Position(line, offset - cur);
    }
}
// A second optional argument can be given to further configure
// the parser process. These options are recognized:
var defaultOptions = {
    // `ecmaVersion` indicates the ECMAScript version to parse. Must be
    // either 3, 5, 6 (2015), 7 (2016), 8 (2017), 9 (2018), or 10
    // (2019). This influences support for strict mode, the set of
    // reserved words, and support for new syntax features. The default
    // is 10.
    ecmaVersion: 10,
    // `sourceType` indicates the mode the code should be parsed in.
    // Can be either `"script"` or `"module"`. This influences global
    // strict mode and parsing of `import` and `export` declarations.
    sourceType: "script",
    // `onInsertedSemicolon` can be a callback that will be called
    // when a semicolon is automatically inserted. It will be passed
    // the position of the comma as an offset, and if `locations` is
    // enabled, it is given the location as a `{line, column}` object
    // as second argument.
    onInsertedSemicolon: null,
    // `onTrailingComma` is similar to `onInsertedSemicolon`, but for
    // trailing commas.
    onTrailingComma: null,
    // By default, reserved words are only enforced if ecmaVersion >= 5.
    // Set `allowReserved` to a boolean value to explicitly turn this on
    // an off. When this option has the value "never", reserved words
    // and keywords can also not be used as property names.
    allowReserved: null,
    // When enabled, a return at the top level is not considered an
    // error.
    allowReturnOutsideFunction: false,
    // When enabled, import/export statements are not constrained to
    // appearing at the top of the program.
    allowImportExportEverywhere: false,
    // When enabled, await identifiers are allowed to appear at the top-level scope,
    // but they are still not allowed in non-async functions.
    allowAwaitOutsideFunction: false,
    // When enabled, hashbang directive in the beginning of file
    // is allowed and treated as a line comment.
    allowHashBang: false,
    // When `locations` is on, `loc` properties holding objects with
    // `start` and `end` properties in `{line, column}` form (with
    // line being 1-based and column 0-based) will be attached to the
    // nodes.
    locations: false,
    // A function can be passed as `onToken` option, which will
    // cause Acorn to call that function with object in the same
    // format as tokens returned from `tokenizer().getToken()`. Note
    // that you are not allowed to call the parser from the
    // callback—that will corrupt its internal state.
    onToken: null,
    // A function can be passed as `onComment` option, which will
    // cause Acorn to call that function with `(block, text, start,
    // end)` parameters whenever a comment is skipped. `block` is a
    // boolean indicating whether this is a block (`/* */`) comment,
    // `text` is the content of the comment, and `start` and `end` are
    // character offsets that denote the start and end of the comment.
    // When the `locations` option is on, two more parameters are
    // passed, the full `{line, column}` locations of the start and
    // end of the comments. Note that you are not allowed to call the
    // parser from the callback—that will corrupt its internal state.
    onComment: null,
    // Nodes have their start and end characters offsets recorded in
    // `start` and `end` properties (directly on the node, rather than
    // the `loc` object, which holds line/column data. To also add a
    // [semi-standardized][range] `range` property holding a `[start,
    // end]` array with the same numbers, set the `ranges` option to
    // `true`.
    //
    // [range]: https://bugzilla.mozilla.org/show_bug.cgi?id=745678
    ranges: false,
    // It is possible to parse multiple files into a single AST by
    // passing the tree produced by parsing the first file as
    // `program` option in subsequent parses. This will add the
    // toplevel forms of the parsed file to the `Program` (top) node
    // of an existing parse tree.
    program: null,
    // When `locations` is on, you can pass this to record the source
    // file in every node's `loc` object.
    sourceFile: null,
    // This value, if given, is stored in every node, whether
    // `locations` is on or off.
    directSourceFile: null,
    // When enabled, parenthesized expressions are represented by
    // (non-standard) ParenthesizedExpression nodes
    preserveParens: false
};
// Interpret and default an options object
function getOptions(opts) {
    var options = {};
    for(var opt in defaultOptions)options[opt] = opts && has(opts, opt) ? opts[opt] : defaultOptions[opt];
    if (options.ecmaVersion >= 2015) options.ecmaVersion -= 2009;
    if (options.allowReserved == null) options.allowReserved = options.ecmaVersion < 5;
    if (isArray(options.onToken)) {
        var tokens = options.onToken;
        options.onToken = function(token) {
            return tokens.push(token);
        };
    }
    if (isArray(options.onComment)) options.onComment = pushComment(options, options.onComment);
    return options;
}
function pushComment(options, array) {
    return function(block, text, start, end, startLoc, endLoc) {
        var comment = {
            type: block ? "Block" : "Line",
            value: text,
            start: start,
            end: end
        };
        if (options.locations) comment.loc = new SourceLocation(this, startLoc, endLoc);
        if (options.ranges) comment.range = [
            start,
            end
        ];
        array.push(comment);
    };
}
// Each scope gets a bitset that may contain these flags
var SCOPE_TOP = 1, SCOPE_FUNCTION = 2, SCOPE_VAR = SCOPE_TOP | SCOPE_FUNCTION, SCOPE_ASYNC = 4, SCOPE_GENERATOR = 8, SCOPE_ARROW = 16, SCOPE_SIMPLE_CATCH = 32, SCOPE_SUPER = 64, SCOPE_DIRECT_SUPER = 128;
function functionFlags(async, generator) {
    return SCOPE_FUNCTION | (async ? SCOPE_ASYNC : 0) | (generator ? SCOPE_GENERATOR : 0);
}
// Used in checkLVal and declareName to determine the type of a binding
var BIND_NONE = 0, BIND_VAR = 1, BIND_LEXICAL = 2, BIND_FUNCTION = 3, BIND_SIMPLE_CATCH = 4, BIND_OUTSIDE = 5; // Special case for function names as bound inside the function
var Parser = function Parser(options, input, startPos) {
    this.options = options = getOptions(options);
    this.sourceFile = options.sourceFile;
    this.keywords = wordsRegexp(keywords[options.ecmaVersion >= 6 ? 6 : options.sourceType === "module" ? "5module" : 5]);
    var reserved = "";
    if (options.allowReserved !== true) {
        for(var v = options.ecmaVersion;; v--){
            if (reserved = reservedWords[v]) break;
        }
        if (options.sourceType === "module") reserved += " await";
    }
    this.reservedWords = wordsRegexp(reserved);
    var reservedStrict = (reserved ? reserved + " " : "") + reservedWords.strict;
    this.reservedWordsStrict = wordsRegexp(reservedStrict);
    this.reservedWordsStrictBind = wordsRegexp(reservedStrict + " " + reservedWords.strictBind);
    this.input = String(input);
    // Used to signal to callers of `readWord1` whether the word
    // contained any escape sequences. This is needed because words with
    // escape sequences must not be interpreted as keywords.
    this.containsEsc = false;
    // Set up token state
    // The current position of the tokenizer in the input.
    if (startPos) {
        this.pos = startPos;
        this.lineStart = this.input.lastIndexOf("\n", startPos - 1) + 1;
        this.curLine = this.input.slice(0, this.lineStart).split(lineBreak).length;
    } else {
        this.pos = this.lineStart = 0;
        this.curLine = 1;
    }
    // Properties of the current token:
    // Its type
    this.type = types.eof;
    // For tokens that include more information than their type, the value
    this.value = null;
    // Its start and end offset
    this.start = this.end = this.pos;
    // And, if locations are used, the {line, column} object
    // corresponding to those offsets
    this.startLoc = this.endLoc = this.curPosition();
    // Position information for the previous token
    this.lastTokEndLoc = this.lastTokStartLoc = null;
    this.lastTokStart = this.lastTokEnd = this.pos;
    // The context stack is used to superficially track syntactic
    // context to predict whether a regular expression is allowed in a
    // given position.
    this.context = this.initialContext();
    this.exprAllowed = true;
    // Figure out if it's a module code.
    this.inModule = options.sourceType === "module";
    this.strict = this.inModule || this.strictDirective(this.pos);
    // Used to signify the start of a potential arrow function
    this.potentialArrowAt = -1;
    // Positions to delayed-check that yield/await does not exist in default parameters.
    this.yieldPos = this.awaitPos = this.awaitIdentPos = 0;
    // Labels in scope.
    this.labels = [];
    // Thus-far undefined exports.
    this.undefinedExports = {};
    // If enabled, skip leading hashbang line.
    if (this.pos === 0 && options.allowHashBang && this.input.slice(0, 2) === "#!") this.skipLineComment(2);
    // Scope tracking for duplicate variable names (see scope.js)
    this.scopeStack = [];
    this.enterScope(SCOPE_TOP);
    // For RegExp validation
    this.regexpState = null;
};
var prototypeAccessors = {
    inFunction: {
        configurable: true
    },
    inGenerator: {
        configurable: true
    },
    inAsync: {
        configurable: true
    },
    allowSuper: {
        configurable: true
    },
    allowDirectSuper: {
        configurable: true
    },
    treatFunctionsAsVar: {
        configurable: true
    }
};
Parser.prototype.parse = function parse() {
    var node = this.options.program || this.startNode();
    this.nextToken();
    return this.parseTopLevel(node);
};
prototypeAccessors.inFunction.get = function() {
    return (this.currentVarScope().flags & SCOPE_FUNCTION) > 0;
};
prototypeAccessors.inGenerator.get = function() {
    return (this.currentVarScope().flags & SCOPE_GENERATOR) > 0;
};
prototypeAccessors.inAsync.get = function() {
    return (this.currentVarScope().flags & SCOPE_ASYNC) > 0;
};
prototypeAccessors.allowSuper.get = function() {
    return (this.currentThisScope().flags & SCOPE_SUPER) > 0;
};
prototypeAccessors.allowDirectSuper.get = function() {
    return (this.currentThisScope().flags & SCOPE_DIRECT_SUPER) > 0;
};
prototypeAccessors.treatFunctionsAsVar.get = function() {
    return this.treatFunctionsAsVarInScope(this.currentScope());
};
// Switch to a getter for 7.0.0.
Parser.prototype.inNonArrowFunction = function inNonArrowFunction() {
    return (this.currentThisScope().flags & SCOPE_FUNCTION) > 0;
};
Parser.extend = function extend() {
    var plugins = [], len = arguments.length;
    while(len--)plugins[len] = arguments[len];
    var cls = this;
    for(var i = 0; i < plugins.length; i++)cls = plugins[i](cls);
    return cls;
};
Parser.parse = function parse(input, options) {
    return new this(options, input).parse();
};
Parser.parseExpressionAt = function parseExpressionAt(input, pos, options) {
    var parser = new this(options, input, pos);
    parser.nextToken();
    return parser.parseExpression();
};
Parser.tokenizer = function tokenizer(input, options) {
    return new this(options, input);
};
Object.defineProperties(Parser.prototype, prototypeAccessors);
var pp = Parser.prototype;
// ## Parser utilities
var literal = /^(?:'((?:\\.|[^'\\])*?)'|"((?:\\.|[^"\\])*?)")/;
pp.strictDirective = function(start) {
    for(;;){
        // Try to find string literal.
        skipWhiteSpace.lastIndex = start;
        start += skipWhiteSpace.exec(this.input)[0].length;
        var match = literal.exec(this.input.slice(start));
        if (!match) return false;
        if ((match[1] || match[2]) === "use strict") {
            skipWhiteSpace.lastIndex = start + match[0].length;
            var spaceAfter = skipWhiteSpace.exec(this.input), end = spaceAfter.index + spaceAfter[0].length;
            var next = this.input.charAt(end);
            return next === ";" || next === "}" || lineBreak.test(spaceAfter[0]) && !(/[(`.[+\-/*%<>=,?^&]/.test(next) || next === "!" && this.input.charAt(end + 1) === "=");
        }
        start += match[0].length;
        // Skip semicolon, if any.
        skipWhiteSpace.lastIndex = start;
        start += skipWhiteSpace.exec(this.input)[0].length;
        if (this.input[start] === ";") start++;
    }
};
// Predicate that tests whether the next token is of the given
// type, and if yes, consumes it as a side effect.
pp.eat = function(type) {
    if (this.type === type) {
        this.next();
        return true;
    } else return false;
};
// Tests whether parsed token is a contextual keyword.
pp.isContextual = function(name) {
    return this.type === types.name && this.value === name && !this.containsEsc;
};
// Consumes contextual keyword if possible.
pp.eatContextual = function(name) {
    if (!this.isContextual(name)) return false;
    this.next();
    return true;
};
// Asserts that following token is given contextual keyword.
pp.expectContextual = function(name) {
    if (!this.eatContextual(name)) this.unexpected();
};
// Test whether a semicolon can be inserted at the current position.
pp.canInsertSemicolon = function() {
    return this.type === types.eof || this.type === types.braceR || lineBreak.test(this.input.slice(this.lastTokEnd, this.start));
};
pp.insertSemicolon = function() {
    if (this.canInsertSemicolon()) {
        if (this.options.onInsertedSemicolon) this.options.onInsertedSemicolon(this.lastTokEnd, this.lastTokEndLoc);
        return true;
    }
};
// Consume a semicolon, or, failing that, see if we are allowed to
// pretend that there is a semicolon at this position.
pp.semicolon = function() {
    if (!this.eat(types.semi) && !this.insertSemicolon()) this.unexpected();
};
pp.afterTrailingComma = function(tokType, notNext) {
    if (this.type === tokType) {
        if (this.options.onTrailingComma) this.options.onTrailingComma(this.lastTokStart, this.lastTokStartLoc);
        if (!notNext) this.next();
        return true;
    }
};
// Expect a token of a given type. If found, consume it, otherwise,
// raise an unexpected token error.
pp.expect = function(type) {
    this.eat(type) || this.unexpected();
};
// Raise an unexpected token error.
pp.unexpected = function(pos) {
    this.raise(pos != null ? pos : this.start, "Unexpected token");
};
function DestructuringErrors() {
    this.shorthandAssign = this.trailingComma = this.parenthesizedAssign = this.parenthesizedBind = this.doubleProto = -1;
}
pp.checkPatternErrors = function(refDestructuringErrors, isAssign) {
    if (!refDestructuringErrors) return;
    if (refDestructuringErrors.trailingComma > -1) this.raiseRecoverable(refDestructuringErrors.trailingComma, "Comma is not permitted after the rest element");
    var parens = isAssign ? refDestructuringErrors.parenthesizedAssign : refDestructuringErrors.parenthesizedBind;
    if (parens > -1) this.raiseRecoverable(parens, "Parenthesized pattern");
};
pp.checkExpressionErrors = function(refDestructuringErrors, andThrow) {
    if (!refDestructuringErrors) return false;
    var shorthandAssign = refDestructuringErrors.shorthandAssign;
    var doubleProto = refDestructuringErrors.doubleProto;
    if (!andThrow) return shorthandAssign >= 0 || doubleProto >= 0;
    if (shorthandAssign >= 0) this.raise(shorthandAssign, "Shorthand property assignments are valid only in destructuring patterns");
    if (doubleProto >= 0) this.raiseRecoverable(doubleProto, "Redefinition of __proto__ property");
};
pp.checkYieldAwaitInDefaultParams = function() {
    if (this.yieldPos && (!this.awaitPos || this.yieldPos < this.awaitPos)) this.raise(this.yieldPos, "Yield expression cannot be a default value");
    if (this.awaitPos) this.raise(this.awaitPos, "Await expression cannot be a default value");
};
pp.isSimpleAssignTarget = function(expr) {
    if (expr.type === "ParenthesizedExpression") return this.isSimpleAssignTarget(expr.expression);
    return expr.type === "Identifier" || expr.type === "MemberExpression";
};
var pp$1 = Parser.prototype;
// ### Statement parsing
// Parse a program. Initializes the parser, reads any number of
// statements, and wraps them in a Program node.  Optionally takes a
// `program` argument.  If present, the statements will be appended
// to its body instead of creating a new node.
pp$1.parseTopLevel = function(node) {
    var exports = {};
    if (!node.body) node.body = [];
    while(this.type !== types.eof){
        var stmt = this.parseStatement(null, true, exports);
        node.body.push(stmt);
    }
    if (this.inModule) for(var i = 0, list = Object.keys(this.undefinedExports); i < list.length; i += 1){
        var name = list[i];
        this.raiseRecoverable(this.undefinedExports[name].start, "Export '" + name + "' is not defined");
    }
    this.adaptDirectivePrologue(node.body);
    this.next();
    node.sourceType = this.options.sourceType;
    return this.finishNode(node, "Program");
};
var loopLabel = {
    kind: "loop"
}, switchLabel = {
    kind: "switch"
};
pp$1.isLet = function(context) {
    if (this.options.ecmaVersion < 6 || !this.isContextual("let")) return false;
    skipWhiteSpace.lastIndex = this.pos;
    var skip = skipWhiteSpace.exec(this.input);
    var next = this.pos + skip[0].length, nextCh = this.input.charCodeAt(next);
    // For ambiguous cases, determine if a LexicalDeclaration (or only a
    // Statement) is allowed here. If context is not empty then only a Statement
    // is allowed. However, `let [` is an explicit negative lookahead for
    // ExpressionStatement, so special-case it first.
    if (nextCh === 91) return true;
     // '['
    if (context) return false;
    if (nextCh === 123) return true;
     // '{'
    if (isIdentifierStart(nextCh, true)) {
        var pos = next + 1;
        while(isIdentifierChar(this.input.charCodeAt(pos), true))++pos;
        var ident = this.input.slice(next, pos);
        if (!keywordRelationalOperator.test(ident)) return true;
    }
    return false;
};
// check 'async [no LineTerminator here] function'
// - 'async /*foo*/ function' is OK.
// - 'async /*\n*/ function' is invalid.
pp$1.isAsyncFunction = function() {
    if (this.options.ecmaVersion < 8 || !this.isContextual("async")) return false;
    skipWhiteSpace.lastIndex = this.pos;
    var skip = skipWhiteSpace.exec(this.input);
    var next = this.pos + skip[0].length;
    return !lineBreak.test(this.input.slice(this.pos, next)) && this.input.slice(next, next + 8) === "function" && (next + 8 === this.input.length || !isIdentifierChar(this.input.charAt(next + 8)));
};
// Parse a single statement.
//
// If expecting a statement and finding a slash operator, parse a
// regular expression literal. This is to handle cases like
// `if (foo) /blah/.exec(foo)`, where looking at the previous token
// does not help.
pp$1.parseStatement = function(context, topLevel, exports) {
    var starttype = this.type, node = this.startNode(), kind;
    if (this.isLet(context)) {
        starttype = types._var;
        kind = "let";
    }
    // Most types of statements are recognized by the keyword they
    // start with. Many are trivial to parse, some require a bit of
    // complexity.
    switch(starttype){
        case types._break:
        case types._continue:
            return this.parseBreakContinueStatement(node, starttype.keyword);
        case types._debugger:
            return this.parseDebuggerStatement(node);
        case types._do:
            return this.parseDoStatement(node);
        case types._for:
            return this.parseForStatement(node);
        case types._function:
            // Function as sole body of either an if statement or a labeled statement
            // works, but not when it is part of a labeled statement that is the sole
            // body of an if statement.
            if (context && (this.strict || context !== "if" && context !== "label") && this.options.ecmaVersion >= 6) this.unexpected();
            return this.parseFunctionStatement(node, false, !context);
        case types._class:
            if (context) this.unexpected();
            return this.parseClass(node, true);
        case types._if:
            return this.parseIfStatement(node);
        case types._return:
            return this.parseReturnStatement(node);
        case types._switch:
            return this.parseSwitchStatement(node);
        case types._throw:
            return this.parseThrowStatement(node);
        case types._try:
            return this.parseTryStatement(node);
        case types._const:
        case types._var:
            kind = kind || this.value;
            if (context && kind !== "var") this.unexpected();
            return this.parseVarStatement(node, kind);
        case types._while:
            return this.parseWhileStatement(node);
        case types._with:
            return this.parseWithStatement(node);
        case types.braceL:
            return this.parseBlock(true, node);
        case types.semi:
            return this.parseEmptyStatement(node);
        case types._export:
        case types._import:
            if (this.options.ecmaVersion > 10 && starttype === types._import) {
                skipWhiteSpace.lastIndex = this.pos;
                var skip = skipWhiteSpace.exec(this.input);
                var next = this.pos + skip[0].length, nextCh = this.input.charCodeAt(next);
                if (nextCh === 40 || nextCh === 46) return this.parseExpressionStatement(node, this.parseExpression());
            }
            if (!this.options.allowImportExportEverywhere) {
                if (!topLevel) this.raise(this.start, "'import' and 'export' may only appear at the top level");
                if (!this.inModule) this.raise(this.start, "'import' and 'export' may appear only with 'sourceType: module'");
            }
            return starttype === types._import ? this.parseImport(node) : this.parseExport(node, exports);
        // If the statement does not start with a statement keyword or a
        // brace, it's an ExpressionStatement or LabeledStatement. We
        // simply start parsing an expression, and afterwards, if the
        // next token is a colon and the expression was a simple
        // Identifier node, we switch to interpreting it as a label.
        default:
            if (this.isAsyncFunction()) {
                if (context) this.unexpected();
                this.next();
                return this.parseFunctionStatement(node, true, !context);
            }
            var maybeName = this.value, expr = this.parseExpression();
            if (starttype === types.name && expr.type === "Identifier" && this.eat(types.colon)) return this.parseLabeledStatement(node, maybeName, expr, context);
            else return this.parseExpressionStatement(node, expr);
    }
};
pp$1.parseBreakContinueStatement = function(node, keyword) {
    var isBreak = keyword === "break";
    this.next();
    if (this.eat(types.semi) || this.insertSemicolon()) node.label = null;
    else if (this.type !== types.name) this.unexpected();
    else {
        node.label = this.parseIdent();
        this.semicolon();
    }
    // Verify that there is an actual destination to break or
    // continue to.
    var i = 0;
    for(; i < this.labels.length; ++i){
        var lab = this.labels[i];
        if (node.label == null || lab.name === node.label.name) {
            if (lab.kind != null && (isBreak || lab.kind === "loop")) break;
            if (node.label && isBreak) break;
        }
    }
    if (i === this.labels.length) this.raise(node.start, "Unsyntactic " + keyword);
    return this.finishNode(node, isBreak ? "BreakStatement" : "ContinueStatement");
};
pp$1.parseDebuggerStatement = function(node) {
    this.next();
    this.semicolon();
    return this.finishNode(node, "DebuggerStatement");
};
pp$1.parseDoStatement = function(node) {
    this.next();
    this.labels.push(loopLabel);
    node.body = this.parseStatement("do");
    this.labels.pop();
    this.expect(types._while);
    node.test = this.parseParenExpression();
    if (this.options.ecmaVersion >= 6) this.eat(types.semi);
    else this.semicolon();
    return this.finishNode(node, "DoWhileStatement");
};
// Disambiguating between a `for` and a `for`/`in` or `for`/`of`
// loop is non-trivial. Basically, we have to parse the init `var`
// statement or expression, disallowing the `in` operator (see
// the second parameter to `parseExpression`), and then check
// whether the next token is `in` or `of`. When there is no init
// part (semicolon immediately after the opening parenthesis), it
// is a regular `for` loop.
pp$1.parseForStatement = function(node) {
    this.next();
    var awaitAt = this.options.ecmaVersion >= 9 && (this.inAsync || !this.inFunction && this.options.allowAwaitOutsideFunction) && this.eatContextual("await") ? this.lastTokStart : -1;
    this.labels.push(loopLabel);
    this.enterScope(0);
    this.expect(types.parenL);
    if (this.type === types.semi) {
        if (awaitAt > -1) this.unexpected(awaitAt);
        return this.parseFor(node, null);
    }
    var isLet = this.isLet();
    if (this.type === types._var || this.type === types._const || isLet) {
        var init$1 = this.startNode(), kind = isLet ? "let" : this.value;
        this.next();
        this.parseVar(init$1, true, kind);
        this.finishNode(init$1, "VariableDeclaration");
        if ((this.type === types._in || this.options.ecmaVersion >= 6 && this.isContextual("of")) && init$1.declarations.length === 1) {
            if (this.options.ecmaVersion >= 9) {
                if (this.type === types._in) {
                    if (awaitAt > -1) this.unexpected(awaitAt);
                } else node.await = awaitAt > -1;
            }
            return this.parseForIn(node, init$1);
        }
        if (awaitAt > -1) this.unexpected(awaitAt);
        return this.parseFor(node, init$1);
    }
    var refDestructuringErrors = new DestructuringErrors;
    var init = this.parseExpression(true, refDestructuringErrors);
    if (this.type === types._in || this.options.ecmaVersion >= 6 && this.isContextual("of")) {
        if (this.options.ecmaVersion >= 9) {
            if (this.type === types._in) {
                if (awaitAt > -1) this.unexpected(awaitAt);
            } else node.await = awaitAt > -1;
        }
        this.toAssignable(init, false, refDestructuringErrors);
        this.checkLVal(init);
        return this.parseForIn(node, init);
    } else this.checkExpressionErrors(refDestructuringErrors, true);
    if (awaitAt > -1) this.unexpected(awaitAt);
    return this.parseFor(node, init);
};
pp$1.parseFunctionStatement = function(node, isAsync, declarationPosition) {
    this.next();
    return this.parseFunction(node, FUNC_STATEMENT | (declarationPosition ? 0 : FUNC_HANGING_STATEMENT), false, isAsync);
};
pp$1.parseIfStatement = function(node) {
    this.next();
    node.test = this.parseParenExpression();
    // allow function declarations in branches, but only in non-strict mode
    node.consequent = this.parseStatement("if");
    node.alternate = this.eat(types._else) ? this.parseStatement("if") : null;
    return this.finishNode(node, "IfStatement");
};
pp$1.parseReturnStatement = function(node) {
    if (!this.inFunction && !this.options.allowReturnOutsideFunction) this.raise(this.start, "'return' outside of function");
    this.next();
    // In `return` (and `break`/`continue`), the keywords with
    // optional arguments, we eagerly look for a semicolon or the
    // possibility to insert one.
    if (this.eat(types.semi) || this.insertSemicolon()) node.argument = null;
    else {
        node.argument = this.parseExpression();
        this.semicolon();
    }
    return this.finishNode(node, "ReturnStatement");
};
pp$1.parseSwitchStatement = function(node) {
    this.next();
    node.discriminant = this.parseParenExpression();
    node.cases = [];
    this.expect(types.braceL);
    this.labels.push(switchLabel);
    this.enterScope(0);
    // Statements under must be grouped (by label) in SwitchCase
    // nodes. `cur` is used to keep the node that we are currently
    // adding statements to.
    var cur;
    for(var sawDefault = false; this.type !== types.braceR;)if (this.type === types._case || this.type === types._default) {
        var isCase = this.type === types._case;
        if (cur) this.finishNode(cur, "SwitchCase");
        node.cases.push(cur = this.startNode());
        cur.consequent = [];
        this.next();
        if (isCase) cur.test = this.parseExpression();
        else {
            if (sawDefault) this.raiseRecoverable(this.lastTokStart, "Multiple default clauses");
            sawDefault = true;
            cur.test = null;
        }
        this.expect(types.colon);
    } else {
        if (!cur) this.unexpected();
        cur.consequent.push(this.parseStatement(null));
    }
    this.exitScope();
    if (cur) this.finishNode(cur, "SwitchCase");
    this.next(); // Closing brace
    this.labels.pop();
    return this.finishNode(node, "SwitchStatement");
};
pp$1.parseThrowStatement = function(node) {
    this.next();
    if (lineBreak.test(this.input.slice(this.lastTokEnd, this.start))) this.raise(this.lastTokEnd, "Illegal newline after throw");
    node.argument = this.parseExpression();
    this.semicolon();
    return this.finishNode(node, "ThrowStatement");
};
// Reused empty array added for node fields that are always empty.
var empty = [];
pp$1.parseTryStatement = function(node) {
    this.next();
    node.block = this.parseBlock();
    node.handler = null;
    if (this.type === types._catch) {
        var clause = this.startNode();
        this.next();
        if (this.eat(types.parenL)) {
            clause.param = this.parseBindingAtom();
            var simple = clause.param.type === "Identifier";
            this.enterScope(simple ? SCOPE_SIMPLE_CATCH : 0);
            this.checkLVal(clause.param, simple ? BIND_SIMPLE_CATCH : BIND_LEXICAL);
            this.expect(types.parenR);
        } else {
            if (this.options.ecmaVersion < 10) this.unexpected();
            clause.param = null;
            this.enterScope(0);
        }
        clause.body = this.parseBlock(false);
        this.exitScope();
        node.handler = this.finishNode(clause, "CatchClause");
    }
    node.finalizer = this.eat(types._finally) ? this.parseBlock() : null;
    if (!node.handler && !node.finalizer) this.raise(node.start, "Missing catch or finally clause");
    return this.finishNode(node, "TryStatement");
};
pp$1.parseVarStatement = function(node, kind) {
    this.next();
    this.parseVar(node, false, kind);
    this.semicolon();
    return this.finishNode(node, "VariableDeclaration");
};
pp$1.parseWhileStatement = function(node) {
    this.next();
    node.test = this.parseParenExpression();
    this.labels.push(loopLabel);
    node.body = this.parseStatement("while");
    this.labels.pop();
    return this.finishNode(node, "WhileStatement");
};
pp$1.parseWithStatement = function(node) {
    if (this.strict) this.raise(this.start, "'with' in strict mode");
    this.next();
    node.object = this.parseParenExpression();
    node.body = this.parseStatement("with");
    return this.finishNode(node, "WithStatement");
};
pp$1.parseEmptyStatement = function(node) {
    this.next();
    return this.finishNode(node, "EmptyStatement");
};
pp$1.parseLabeledStatement = function(node, maybeName, expr, context) {
    for(var i$1 = 0, list = this.labels; i$1 < list.length; i$1 += 1){
        var label = list[i$1];
        if (label.name === maybeName) this.raise(expr.start, "Label '" + maybeName + "' is already declared");
    }
    var kind = this.type.isLoop ? "loop" : this.type === types._switch ? "switch" : null;
    for(var i = this.labels.length - 1; i >= 0; i--){
        var label$1 = this.labels[i];
        if (label$1.statementStart === node.start) {
            // Update information about previous labels on this node
            label$1.statementStart = this.start;
            label$1.kind = kind;
        } else break;
    }
    this.labels.push({
        name: maybeName,
        kind: kind,
        statementStart: this.start
    });
    node.body = this.parseStatement(context ? context.indexOf("label") === -1 ? context + "label" : context : "label");
    this.labels.pop();
    node.label = expr;
    return this.finishNode(node, "LabeledStatement");
};
pp$1.parseExpressionStatement = function(node, expr) {
    node.expression = expr;
    this.semicolon();
    return this.finishNode(node, "ExpressionStatement");
};
// Parse a semicolon-enclosed block of statements, handling `"use
// strict"` declarations when `allowStrict` is true (used for
// function bodies).
pp$1.parseBlock = function(createNewLexicalScope, node, exitStrict) {
    if (createNewLexicalScope === void 0) createNewLexicalScope = true;
    if (node === void 0) node = this.startNode();
    node.body = [];
    this.expect(types.braceL);
    if (createNewLexicalScope) this.enterScope(0);
    while(this.type !== types.braceR){
        var stmt = this.parseStatement(null);
        node.body.push(stmt);
    }
    if (exitStrict) this.strict = false;
    this.next();
    if (createNewLexicalScope) this.exitScope();
    return this.finishNode(node, "BlockStatement");
};
// Parse a regular `for` loop. The disambiguation code in
// `parseStatement` will already have parsed the init statement or
// expression.
pp$1.parseFor = function(node, init) {
    node.init = init;
    this.expect(types.semi);
    node.test = this.type === types.semi ? null : this.parseExpression();
    this.expect(types.semi);
    node.update = this.type === types.parenR ? null : this.parseExpression();
    this.expect(types.parenR);
    node.body = this.parseStatement("for");
    this.exitScope();
    this.labels.pop();
    return this.finishNode(node, "ForStatement");
};
// Parse a `for`/`in` and `for`/`of` loop, which are almost
// same from parser's perspective.
pp$1.parseForIn = function(node, init) {
    var isForIn = this.type === types._in;
    this.next();
    if (init.type === "VariableDeclaration" && init.declarations[0].init != null && (!isForIn || this.options.ecmaVersion < 8 || this.strict || init.kind !== "var" || init.declarations[0].id.type !== "Identifier")) this.raise(init.start, (isForIn ? "for-in" : "for-of") + " loop variable declaration may not have an initializer");
    else if (init.type === "AssignmentPattern") this.raise(init.start, "Invalid left-hand side in for-loop");
    node.left = init;
    node.right = isForIn ? this.parseExpression() : this.parseMaybeAssign();
    this.expect(types.parenR);
    node.body = this.parseStatement("for");
    this.exitScope();
    this.labels.pop();
    return this.finishNode(node, isForIn ? "ForInStatement" : "ForOfStatement");
};
// Parse a list of variable declarations.
pp$1.parseVar = function(node, isFor, kind) {
    node.declarations = [];
    node.kind = kind;
    for(;;){
        var decl = this.startNode();
        this.parseVarId(decl, kind);
        if (this.eat(types.eq)) decl.init = this.parseMaybeAssign(isFor);
        else if (kind === "const" && !(this.type === types._in || this.options.ecmaVersion >= 6 && this.isContextual("of"))) this.unexpected();
        else if (decl.id.type !== "Identifier" && !(isFor && (this.type === types._in || this.isContextual("of")))) this.raise(this.lastTokEnd, "Complex binding patterns require an initialization value");
        else decl.init = null;
        node.declarations.push(this.finishNode(decl, "VariableDeclarator"));
        if (!this.eat(types.comma)) break;
    }
    return node;
};
pp$1.parseVarId = function(decl, kind) {
    decl.id = this.parseBindingAtom();
    this.checkLVal(decl.id, kind === "var" ? BIND_VAR : BIND_LEXICAL, false);
};
var FUNC_STATEMENT = 1, FUNC_HANGING_STATEMENT = 2, FUNC_NULLABLE_ID = 4;
// Parse a function declaration or literal (depending on the
// `statement & FUNC_STATEMENT`).
// Remove `allowExpressionBody` for 7.0.0, as it is only called with false
pp$1.parseFunction = function(node, statement, allowExpressionBody, isAsync) {
    this.initFunction(node);
    if (this.options.ecmaVersion >= 9 || this.options.ecmaVersion >= 6 && !isAsync) {
        if (this.type === types.star && statement & FUNC_HANGING_STATEMENT) this.unexpected();
        node.generator = this.eat(types.star);
    }
    if (this.options.ecmaVersion >= 8) node.async = !!isAsync;
    if (statement & FUNC_STATEMENT) {
        node.id = statement & FUNC_NULLABLE_ID && this.type !== types.name ? null : this.parseIdent();
        if (node.id && !(statement & FUNC_HANGING_STATEMENT)) this.checkLVal(node.id, this.strict || node.generator || node.async ? this.treatFunctionsAsVar ? BIND_VAR : BIND_LEXICAL : BIND_FUNCTION);
    }
    var oldYieldPos = this.yieldPos, oldAwaitPos = this.awaitPos, oldAwaitIdentPos = this.awaitIdentPos;
    this.yieldPos = 0;
    this.awaitPos = 0;
    this.awaitIdentPos = 0;
    this.enterScope(functionFlags(node.async, node.generator));
    if (!(statement & FUNC_STATEMENT)) node.id = this.type === types.name ? this.parseIdent() : null;
    this.parseFunctionParams(node);
    this.parseFunctionBody(node, allowExpressionBody, false);
    this.yieldPos = oldYieldPos;
    this.awaitPos = oldAwaitPos;
    this.awaitIdentPos = oldAwaitIdentPos;
    return this.finishNode(node, statement & FUNC_STATEMENT ? "FunctionDeclaration" : "FunctionExpression");
};
pp$1.parseFunctionParams = function(node) {
    this.expect(types.parenL);
    node.params = this.parseBindingList(types.parenR, false, this.options.ecmaVersion >= 8);
    this.checkYieldAwaitInDefaultParams();
};
// Parse a class declaration or literal (depending on the
// `isStatement` parameter).
pp$1.parseClass = function(node, isStatement) {
    this.next();
    // ecma-262 14.6 Class Definitions
    // A class definition is always strict mode code.
    var oldStrict = this.strict;
    this.strict = true;
    this.parseClassId(node, isStatement);
    this.parseClassSuper(node);
    var classBody = this.startNode();
    var hadConstructor = false;
    classBody.body = [];
    this.expect(types.braceL);
    while(this.type !== types.braceR){
        var element = this.parseClassElement(node.superClass !== null);
        if (element) {
            classBody.body.push(element);
            if (element.type === "MethodDefinition" && element.kind === "constructor") {
                if (hadConstructor) this.raise(element.start, "Duplicate constructor in the same class");
                hadConstructor = true;
            }
        }
    }
    this.strict = oldStrict;
    this.next();
    node.body = this.finishNode(classBody, "ClassBody");
    return this.finishNode(node, isStatement ? "ClassDeclaration" : "ClassExpression");
};
pp$1.parseClassElement = function(constructorAllowsSuper) {
    var this$1 = this;
    if (this.eat(types.semi)) return null;
    var method = this.startNode();
    var tryContextual = function(k, noLineBreak) {
        if (noLineBreak === void 0) noLineBreak = false;
        var start = this$1.start, startLoc = this$1.startLoc;
        if (!this$1.eatContextual(k)) return false;
        if (this$1.type !== types.parenL && (!noLineBreak || !this$1.canInsertSemicolon())) return true;
        if (method.key) this$1.unexpected();
        method.computed = false;
        method.key = this$1.startNodeAt(start, startLoc);
        method.key.name = k;
        this$1.finishNode(method.key, "Identifier");
        return false;
    };
    method.kind = "method";
    method.static = tryContextual("static");
    var isGenerator = this.eat(types.star);
    var isAsync = false;
    if (!isGenerator) {
        if (this.options.ecmaVersion >= 8 && tryContextual("async", true)) {
            isAsync = true;
            isGenerator = this.options.ecmaVersion >= 9 && this.eat(types.star);
        } else if (tryContextual("get")) method.kind = "get";
        else if (tryContextual("set")) method.kind = "set";
    }
    if (!method.key) this.parsePropertyName(method);
    var key = method.key;
    var allowsDirectSuper = false;
    if (!method.computed && !method.static && (key.type === "Identifier" && key.name === "constructor" || key.type === "Literal" && key.value === "constructor")) {
        if (method.kind !== "method") this.raise(key.start, "Constructor can't have get/set modifier");
        if (isGenerator) this.raise(key.start, "Constructor can't be a generator");
        if (isAsync) this.raise(key.start, "Constructor can't be an async method");
        method.kind = "constructor";
        allowsDirectSuper = constructorAllowsSuper;
    } else if (method.static && key.type === "Identifier" && key.name === "prototype") this.raise(key.start, "Classes may not have a static property named prototype");
    this.parseClassMethod(method, isGenerator, isAsync, allowsDirectSuper);
    if (method.kind === "get" && method.value.params.length !== 0) this.raiseRecoverable(method.value.start, "getter should have no params");
    if (method.kind === "set" && method.value.params.length !== 1) this.raiseRecoverable(method.value.start, "setter should have exactly one param");
    if (method.kind === "set" && method.value.params[0].type === "RestElement") this.raiseRecoverable(method.value.params[0].start, "Setter cannot use rest params");
    return method;
};
pp$1.parseClassMethod = function(method, isGenerator, isAsync, allowsDirectSuper) {
    method.value = this.parseMethod(isGenerator, isAsync, allowsDirectSuper);
    return this.finishNode(method, "MethodDefinition");
};
pp$1.parseClassId = function(node, isStatement) {
    if (this.type === types.name) {
        node.id = this.parseIdent();
        if (isStatement) this.checkLVal(node.id, BIND_LEXICAL, false);
    } else {
        if (isStatement === true) this.unexpected();
        node.id = null;
    }
};
pp$1.parseClassSuper = function(node) {
    node.superClass = this.eat(types._extends) ? this.parseExprSubscripts() : null;
};
// Parses module export declaration.
pp$1.parseExport = function(node, exports) {
    this.next();
    // export * from '...'
    if (this.eat(types.star)) {
        if (this.options.ecmaVersion >= 11) {
            if (this.eatContextual("as")) {
                node.exported = this.parseIdent(true);
                this.checkExport(exports, node.exported.name, this.lastTokStart);
            } else node.exported = null;
        }
        this.expectContextual("from");
        if (this.type !== types.string) this.unexpected();
        node.source = this.parseExprAtom();
        this.semicolon();
        return this.finishNode(node, "ExportAllDeclaration");
    }
    if (this.eat(types._default)) {
        this.checkExport(exports, "default", this.lastTokStart);
        var isAsync;
        if (this.type === types._function || (isAsync = this.isAsyncFunction())) {
            var fNode = this.startNode();
            this.next();
            if (isAsync) this.next();
            node.declaration = this.parseFunction(fNode, FUNC_STATEMENT | FUNC_NULLABLE_ID, false, isAsync);
        } else if (this.type === types._class) {
            var cNode = this.startNode();
            node.declaration = this.parseClass(cNode, "nullableID");
        } else {
            node.declaration = this.parseMaybeAssign();
            this.semicolon();
        }
        return this.finishNode(node, "ExportDefaultDeclaration");
    }
    // export var|const|let|function|class ...
    if (this.shouldParseExportStatement()) {
        node.declaration = this.parseStatement(null);
        if (node.declaration.type === "VariableDeclaration") this.checkVariableExport(exports, node.declaration.declarations);
        else this.checkExport(exports, node.declaration.id.name, node.declaration.id.start);
        node.specifiers = [];
        node.source = null;
    } else {
        node.declaration = null;
        node.specifiers = this.parseExportSpecifiers(exports);
        if (this.eatContextual("from")) {
            if (this.type !== types.string) this.unexpected();
            node.source = this.parseExprAtom();
        } else {
            for(var i = 0, list = node.specifiers; i < list.length; i += 1){
                // check for keywords used as local names
                var spec = list[i];
                this.checkUnreserved(spec.local);
                // check if export is defined
                this.checkLocalExport(spec.local);
            }
            node.source = null;
        }
        this.semicolon();
    }
    return this.finishNode(node, "ExportNamedDeclaration");
};
pp$1.checkExport = function(exports, name, pos) {
    if (!exports) return;
    if (has(exports, name)) this.raiseRecoverable(pos, "Duplicate export '" + name + "'");
    exports[name] = true;
};
pp$1.checkPatternExport = function(exports, pat) {
    var type = pat.type;
    if (type === "Identifier") this.checkExport(exports, pat.name, pat.start);
    else if (type === "ObjectPattern") for(var i = 0, list = pat.properties; i < list.length; i += 1){
        var prop = list[i];
        this.checkPatternExport(exports, prop);
    }
    else if (type === "ArrayPattern") for(var i$1 = 0, list$1 = pat.elements; i$1 < list$1.length; i$1 += 1){
        var elt = list$1[i$1];
        if (elt) this.checkPatternExport(exports, elt);
    }
    else if (type === "Property") this.checkPatternExport(exports, pat.value);
    else if (type === "AssignmentPattern") this.checkPatternExport(exports, pat.left);
    else if (type === "RestElement") this.checkPatternExport(exports, pat.argument);
    else if (type === "ParenthesizedExpression") this.checkPatternExport(exports, pat.expression);
};
pp$1.checkVariableExport = function(exports, decls) {
    if (!exports) return;
    for(var i = 0, list = decls; i < list.length; i += 1){
        var decl = list[i];
        this.checkPatternExport(exports, decl.id);
    }
};
pp$1.shouldParseExportStatement = function() {
    return this.type.keyword === "var" || this.type.keyword === "const" || this.type.keyword === "class" || this.type.keyword === "function" || this.isLet() || this.isAsyncFunction();
};
// Parses a comma-separated list of module exports.
pp$1.parseExportSpecifiers = function(exports) {
    var nodes = [], first = true;
    // export { x, y as z } [from '...']
    this.expect(types.braceL);
    while(!this.eat(types.braceR)){
        if (!first) {
            this.expect(types.comma);
            if (this.afterTrailingComma(types.braceR)) break;
        } else first = false;
        var node = this.startNode();
        node.local = this.parseIdent(true);
        node.exported = this.eatContextual("as") ? this.parseIdent(true) : node.local;
        this.checkExport(exports, node.exported.name, node.exported.start);
        nodes.push(this.finishNode(node, "ExportSpecifier"));
    }
    return nodes;
};
// Parses import declaration.
pp$1.parseImport = function(node) {
    this.next();
    // import '...'
    if (this.type === types.string) {
        node.specifiers = empty;
        node.source = this.parseExprAtom();
    } else {
        node.specifiers = this.parseImportSpecifiers();
        this.expectContextual("from");
        node.source = this.type === types.string ? this.parseExprAtom() : this.unexpected();
    }
    this.semicolon();
    return this.finishNode(node, "ImportDeclaration");
};
// Parses a comma-separated list of module imports.
pp$1.parseImportSpecifiers = function() {
    var nodes = [], first = true;
    if (this.type === types.name) {
        // import defaultObj, { x, y as z } from '...'
        var node = this.startNode();
        node.local = this.parseIdent();
        this.checkLVal(node.local, BIND_LEXICAL);
        nodes.push(this.finishNode(node, "ImportDefaultSpecifier"));
        if (!this.eat(types.comma)) return nodes;
    }
    if (this.type === types.star) {
        var node$1 = this.startNode();
        this.next();
        this.expectContextual("as");
        node$1.local = this.parseIdent();
        this.checkLVal(node$1.local, BIND_LEXICAL);
        nodes.push(this.finishNode(node$1, "ImportNamespaceSpecifier"));
        return nodes;
    }
    this.expect(types.braceL);
    while(!this.eat(types.braceR)){
        if (!first) {
            this.expect(types.comma);
            if (this.afterTrailingComma(types.braceR)) break;
        } else first = false;
        var node$2 = this.startNode();
        node$2.imported = this.parseIdent(true);
        if (this.eatContextual("as")) node$2.local = this.parseIdent();
        else {
            this.checkUnreserved(node$2.imported);
            node$2.local = node$2.imported;
        }
        this.checkLVal(node$2.local, BIND_LEXICAL);
        nodes.push(this.finishNode(node$2, "ImportSpecifier"));
    }
    return nodes;
};
// Set `ExpressionStatement#directive` property for directive prologues.
pp$1.adaptDirectivePrologue = function(statements) {
    for(var i = 0; i < statements.length && this.isDirectiveCandidate(statements[i]); ++i)statements[i].directive = statements[i].expression.raw.slice(1, -1);
};
pp$1.isDirectiveCandidate = function(statement) {
    return statement.type === "ExpressionStatement" && statement.expression.type === "Literal" && typeof statement.expression.value === "string" && // Reject parenthesized strings.
    (this.input[statement.start] === '"' || this.input[statement.start] === "'");
};
var pp$2 = Parser.prototype;
// Convert existing expression atom to assignable pattern
// if possible.
pp$2.toAssignable = function(node, isBinding, refDestructuringErrors) {
    if (this.options.ecmaVersion >= 6 && node) switch(node.type){
        case "Identifier":
            if (this.inAsync && node.name === "await") this.raise(node.start, "Cannot use 'await' as identifier inside an async function");
            break;
        case "ObjectPattern":
        case "ArrayPattern":
        case "RestElement":
            break;
        case "ObjectExpression":
            node.type = "ObjectPattern";
            if (refDestructuringErrors) this.checkPatternErrors(refDestructuringErrors, true);
            for(var i = 0, list = node.properties; i < list.length; i += 1){
                var prop = list[i];
                this.toAssignable(prop, isBinding);
                // Early error:
                //   AssignmentRestProperty[Yield, Await] :
                //     `...` DestructuringAssignmentTarget[Yield, Await]
                //
                //   It is a Syntax Error if |DestructuringAssignmentTarget| is an |ArrayLiteral| or an |ObjectLiteral|.
                if (prop.type === "RestElement" && (prop.argument.type === "ArrayPattern" || prop.argument.type === "ObjectPattern")) this.raise(prop.argument.start, "Unexpected token");
            }
            break;
        case "Property":
            // AssignmentProperty has type === "Property"
            if (node.kind !== "init") this.raise(node.key.start, "Object pattern can't contain getter or setter");
            this.toAssignable(node.value, isBinding);
            break;
        case "ArrayExpression":
            node.type = "ArrayPattern";
            if (refDestructuringErrors) this.checkPatternErrors(refDestructuringErrors, true);
            this.toAssignableList(node.elements, isBinding);
            break;
        case "SpreadElement":
            node.type = "RestElement";
            this.toAssignable(node.argument, isBinding);
            if (node.argument.type === "AssignmentPattern") this.raise(node.argument.start, "Rest elements cannot have a default value");
            break;
        case "AssignmentExpression":
            if (node.operator !== "=") this.raise(node.left.end, "Only '=' operator can be used for specifying default value.");
            node.type = "AssignmentPattern";
            delete node.operator;
            this.toAssignable(node.left, isBinding);
        // falls through to AssignmentPattern
        case "AssignmentPattern":
            break;
        case "ParenthesizedExpression":
            this.toAssignable(node.expression, isBinding, refDestructuringErrors);
            break;
        case "ChainExpression":
            this.raiseRecoverable(node.start, "Optional chaining cannot appear in left-hand side");
            break;
        case "MemberExpression":
            if (!isBinding) break;
        default:
            this.raise(node.start, "Assigning to rvalue");
    }
    else if (refDestructuringErrors) this.checkPatternErrors(refDestructuringErrors, true);
    return node;
};
// Convert list of expression atoms to binding list.
pp$2.toAssignableList = function(exprList, isBinding) {
    var end = exprList.length;
    for(var i = 0; i < end; i++){
        var elt = exprList[i];
        if (elt) this.toAssignable(elt, isBinding);
    }
    if (end) {
        var last = exprList[end - 1];
        if (this.options.ecmaVersion === 6 && isBinding && last && last.type === "RestElement" && last.argument.type !== "Identifier") this.unexpected(last.argument.start);
    }
    return exprList;
};
// Parses spread element.
pp$2.parseSpread = function(refDestructuringErrors) {
    var node = this.startNode();
    this.next();
    node.argument = this.parseMaybeAssign(false, refDestructuringErrors);
    return this.finishNode(node, "SpreadElement");
};
pp$2.parseRestBinding = function() {
    var node = this.startNode();
    this.next();
    // RestElement inside of a function parameter must be an identifier
    if (this.options.ecmaVersion === 6 && this.type !== types.name) this.unexpected();
    node.argument = this.parseBindingAtom();
    return this.finishNode(node, "RestElement");
};
// Parses lvalue (assignable) atom.
pp$2.parseBindingAtom = function() {
    if (this.options.ecmaVersion >= 6) switch(this.type){
        case types.bracketL:
            var node = this.startNode();
            this.next();
            node.elements = this.parseBindingList(types.bracketR, true, true);
            return this.finishNode(node, "ArrayPattern");
        case types.braceL:
            return this.parseObj(true);
    }
    return this.parseIdent();
};
pp$2.parseBindingList = function(close, allowEmpty, allowTrailingComma) {
    var elts = [], first = true;
    while(!this.eat(close)){
        if (first) first = false;
        else this.expect(types.comma);
        if (allowEmpty && this.type === types.comma) elts.push(null);
        else if (allowTrailingComma && this.afterTrailingComma(close)) break;
        else if (this.type === types.ellipsis) {
            var rest = this.parseRestBinding();
            this.parseBindingListItem(rest);
            elts.push(rest);
            if (this.type === types.comma) this.raise(this.start, "Comma is not permitted after the rest element");
            this.expect(close);
            break;
        } else {
            var elem = this.parseMaybeDefault(this.start, this.startLoc);
            this.parseBindingListItem(elem);
            elts.push(elem);
        }
    }
    return elts;
};
pp$2.parseBindingListItem = function(param) {
    return param;
};
// Parses assignment pattern around given atom if possible.
pp$2.parseMaybeDefault = function(startPos, startLoc, left) {
    left = left || this.parseBindingAtom();
    if (this.options.ecmaVersion < 6 || !this.eat(types.eq)) return left;
    var node = this.startNodeAt(startPos, startLoc);
    node.left = left;
    node.right = this.parseMaybeAssign();
    return this.finishNode(node, "AssignmentPattern");
};
// Verify that a node is an lval — something that can be assigned
// to.
// bindingType can be either:
// 'var' indicating that the lval creates a 'var' binding
// 'let' indicating that the lval creates a lexical ('let' or 'const') binding
// 'none' indicating that the binding should be checked for illegal identifiers, but not for duplicate references
pp$2.checkLVal = function(expr, bindingType, checkClashes) {
    if (bindingType === void 0) bindingType = BIND_NONE;
    switch(expr.type){
        case "Identifier":
            if (bindingType === BIND_LEXICAL && expr.name === "let") this.raiseRecoverable(expr.start, "let is disallowed as a lexically bound name");
            if (this.strict && this.reservedWordsStrictBind.test(expr.name)) this.raiseRecoverable(expr.start, (bindingType ? "Binding " : "Assigning to ") + expr.name + " in strict mode");
            if (checkClashes) {
                if (has(checkClashes, expr.name)) this.raiseRecoverable(expr.start, "Argument name clash");
                checkClashes[expr.name] = true;
            }
            if (bindingType !== BIND_NONE && bindingType !== BIND_OUTSIDE) this.declareName(expr.name, bindingType, expr.start);
            break;
        case "ChainExpression":
            this.raiseRecoverable(expr.start, "Optional chaining cannot appear in left-hand side");
            break;
        case "MemberExpression":
            if (bindingType) this.raiseRecoverable(expr.start, "Binding member expression");
            break;
        case "ObjectPattern":
            for(var i = 0, list = expr.properties; i < list.length; i += 1){
                var prop = list[i];
                this.checkLVal(prop, bindingType, checkClashes);
            }
            break;
        case "Property":
            // AssignmentProperty has type === "Property"
            this.checkLVal(expr.value, bindingType, checkClashes);
            break;
        case "ArrayPattern":
            for(var i$1 = 0, list$1 = expr.elements; i$1 < list$1.length; i$1 += 1){
                var elem = list$1[i$1];
                if (elem) this.checkLVal(elem, bindingType, checkClashes);
            }
            break;
        case "AssignmentPattern":
            this.checkLVal(expr.left, bindingType, checkClashes);
            break;
        case "RestElement":
            this.checkLVal(expr.argument, bindingType, checkClashes);
            break;
        case "ParenthesizedExpression":
            this.checkLVal(expr.expression, bindingType, checkClashes);
            break;
        default:
            this.raise(expr.start, (bindingType ? "Binding" : "Assigning to") + " rvalue");
    }
};
// A recursive descent parser operates by defining functions for all
var pp$3 = Parser.prototype;
// Check if property name clashes with already added.
// Object/class getters and setters are not allowed to clash —
// either with each other or with an init property — and in
// strict mode, init properties are also not allowed to be repeated.
pp$3.checkPropClash = function(prop, propHash, refDestructuringErrors) {
    if (this.options.ecmaVersion >= 9 && prop.type === "SpreadElement") return;
    if (this.options.ecmaVersion >= 6 && (prop.computed || prop.method || prop.shorthand)) return;
    var key = prop.key;
    var name;
    switch(key.type){
        case "Identifier":
            name = key.name;
            break;
        case "Literal":
            name = String(key.value);
            break;
        default:
            return;
    }
    var kind = prop.kind;
    if (this.options.ecmaVersion >= 6) {
        if (name === "__proto__" && kind === "init") {
            if (propHash.proto) {
                if (refDestructuringErrors) {
                    if (refDestructuringErrors.doubleProto < 0) refDestructuringErrors.doubleProto = key.start;
                } else this.raiseRecoverable(key.start, "Redefinition of __proto__ property");
            }
            propHash.proto = true;
        }
        return;
    }
    name = "$" + name;
    var other = propHash[name];
    if (other) {
        var redefinition;
        if (kind === "init") redefinition = this.strict && other.init || other.get || other.set;
        else redefinition = other.init || other[kind];
        if (redefinition) this.raiseRecoverable(key.start, "Redefinition of property");
    } else other = propHash[name] = {
        init: false,
        get: false,
        set: false
    };
    other[kind] = true;
};
// ### Expression parsing
// These nest, from the most general expression type at the top to
// 'atomic', nondivisible expression types at the bottom. Most of
// the functions will simply let the function(s) below them parse,
// and, *if* the syntactic construct they handle is present, wrap
// the AST node that the inner parser gave them in another node.
// Parse a full expression. The optional arguments are used to
// forbid the `in` operator (in for loops initalization expressions)
// and provide reference for storing '=' operator inside shorthand
// property assignment in contexts where both object expression
// and object pattern might appear (so it's possible to raise
// delayed syntax error at correct position).
pp$3.parseExpression = function(noIn, refDestructuringErrors) {
    var startPos = this.start, startLoc = this.startLoc;
    var expr = this.parseMaybeAssign(noIn, refDestructuringErrors);
    if (this.type === types.comma) {
        var node = this.startNodeAt(startPos, startLoc);
        node.expressions = [
            expr
        ];
        while(this.eat(types.comma))node.expressions.push(this.parseMaybeAssign(noIn, refDestructuringErrors));
        return this.finishNode(node, "SequenceExpression");
    }
    return expr;
};
// Parse an assignment expression. This includes applications of
// operators like `+=`.
pp$3.parseMaybeAssign = function(noIn, refDestructuringErrors, afterLeftParse) {
    if (this.isContextual("yield")) {
        if (this.inGenerator) return this.parseYield(noIn);
        else this.exprAllowed = false;
    }
    var ownDestructuringErrors = false, oldParenAssign = -1, oldTrailingComma = -1;
    if (refDestructuringErrors) {
        oldParenAssign = refDestructuringErrors.parenthesizedAssign;
        oldTrailingComma = refDestructuringErrors.trailingComma;
        refDestructuringErrors.parenthesizedAssign = refDestructuringErrors.trailingComma = -1;
    } else {
        refDestructuringErrors = new DestructuringErrors;
        ownDestructuringErrors = true;
    }
    var startPos = this.start, startLoc = this.startLoc;
    if (this.type === types.parenL || this.type === types.name) this.potentialArrowAt = this.start;
    var left = this.parseMaybeConditional(noIn, refDestructuringErrors);
    if (afterLeftParse) left = afterLeftParse.call(this, left, startPos, startLoc);
    if (this.type.isAssign) {
        var node = this.startNodeAt(startPos, startLoc);
        node.operator = this.value;
        node.left = this.type === types.eq ? this.toAssignable(left, false, refDestructuringErrors) : left;
        if (!ownDestructuringErrors) refDestructuringErrors.parenthesizedAssign = refDestructuringErrors.trailingComma = refDestructuringErrors.doubleProto = -1;
        if (refDestructuringErrors.shorthandAssign >= node.left.start) refDestructuringErrors.shorthandAssign = -1;
         // reset because shorthand default was used correctly
        this.checkLVal(left);
        this.next();
        node.right = this.parseMaybeAssign(noIn);
        return this.finishNode(node, "AssignmentExpression");
    } else if (ownDestructuringErrors) this.checkExpressionErrors(refDestructuringErrors, true);
    if (oldParenAssign > -1) refDestructuringErrors.parenthesizedAssign = oldParenAssign;
    if (oldTrailingComma > -1) refDestructuringErrors.trailingComma = oldTrailingComma;
    return left;
};
// Parse a ternary conditional (`?:`) operator.
pp$3.parseMaybeConditional = function(noIn, refDestructuringErrors) {
    var startPos = this.start, startLoc = this.startLoc;
    var expr = this.parseExprOps(noIn, refDestructuringErrors);
    if (this.checkExpressionErrors(refDestructuringErrors)) return expr;
    if (this.eat(types.question)) {
        var node = this.startNodeAt(startPos, startLoc);
        node.test = expr;
        node.consequent = this.parseMaybeAssign();
        this.expect(types.colon);
        node.alternate = this.parseMaybeAssign(noIn);
        return this.finishNode(node, "ConditionalExpression");
    }
    return expr;
};
// Start the precedence parser.
pp$3.parseExprOps = function(noIn, refDestructuringErrors) {
    var startPos = this.start, startLoc = this.startLoc;
    var expr = this.parseMaybeUnary(refDestructuringErrors, false);
    if (this.checkExpressionErrors(refDestructuringErrors)) return expr;
    return expr.start === startPos && expr.type === "ArrowFunctionExpression" ? expr : this.parseExprOp(expr, startPos, startLoc, -1, noIn);
};
// Parse binary operators with the operator precedence parsing
// algorithm. `left` is the left-hand side of the operator.
// `minPrec` provides context that allows the function to stop and
// defer further parser to one of its callers when it encounters an
// operator that has a lower precedence than the set it is parsing.
pp$3.parseExprOp = function(left, leftStartPos, leftStartLoc, minPrec, noIn) {
    var prec = this.type.binop;
    if (prec != null && (!noIn || this.type !== types._in)) {
        if (prec > minPrec) {
            var logical = this.type === types.logicalOR || this.type === types.logicalAND;
            var coalesce = this.type === types.coalesce;
            if (coalesce) // Handle the precedence of `tt.coalesce` as equal to the range of logical expressions.
            // In other words, `node.right` shouldn't contain logical expressions in order to check the mixed error.
            prec = types.logicalAND.binop;
            var op = this.value;
            this.next();
            var startPos = this.start, startLoc = this.startLoc;
            var right = this.parseExprOp(this.parseMaybeUnary(null, false), startPos, startLoc, prec, noIn);
            var node = this.buildBinary(leftStartPos, leftStartLoc, left, right, op, logical || coalesce);
            if (logical && this.type === types.coalesce || coalesce && (this.type === types.logicalOR || this.type === types.logicalAND)) this.raiseRecoverable(this.start, "Logical expressions and coalesce expressions cannot be mixed. Wrap either by parentheses");
            return this.parseExprOp(node, leftStartPos, leftStartLoc, minPrec, noIn);
        }
    }
    return left;
};
pp$3.buildBinary = function(startPos, startLoc, left, right, op, logical) {
    var node = this.startNodeAt(startPos, startLoc);
    node.left = left;
    node.operator = op;
    node.right = right;
    return this.finishNode(node, logical ? "LogicalExpression" : "BinaryExpression");
};
// Parse unary operators, both prefix and postfix.
pp$3.parseMaybeUnary = function(refDestructuringErrors, sawUnary) {
    var startPos = this.start, startLoc = this.startLoc, expr;
    if (this.isContextual("await") && (this.inAsync || !this.inFunction && this.options.allowAwaitOutsideFunction)) {
        expr = this.parseAwait();
        sawUnary = true;
    } else if (this.type.prefix) {
        var node = this.startNode(), update = this.type === types.incDec;
        node.operator = this.value;
        node.prefix = true;
        this.next();
        node.argument = this.parseMaybeUnary(null, true);
        this.checkExpressionErrors(refDestructuringErrors, true);
        if (update) this.checkLVal(node.argument);
        else if (this.strict && node.operator === "delete" && node.argument.type === "Identifier") this.raiseRecoverable(node.start, "Deleting local variable in strict mode");
        else sawUnary = true;
        expr = this.finishNode(node, update ? "UpdateExpression" : "UnaryExpression");
    } else {
        expr = this.parseExprSubscripts(refDestructuringErrors);
        if (this.checkExpressionErrors(refDestructuringErrors)) return expr;
        while(this.type.postfix && !this.canInsertSemicolon()){
            var node$1 = this.startNodeAt(startPos, startLoc);
            node$1.operator = this.value;
            node$1.prefix = false;
            node$1.argument = expr;
            this.checkLVal(expr);
            this.next();
            expr = this.finishNode(node$1, "UpdateExpression");
        }
    }
    if (!sawUnary && this.eat(types.starstar)) return this.buildBinary(startPos, startLoc, expr, this.parseMaybeUnary(null, false), "**", false);
    else return expr;
};
// Parse call, dot, and `[]`-subscript expressions.
pp$3.parseExprSubscripts = function(refDestructuringErrors) {
    var startPos = this.start, startLoc = this.startLoc;
    var expr = this.parseExprAtom(refDestructuringErrors);
    if (expr.type === "ArrowFunctionExpression" && this.input.slice(this.lastTokStart, this.lastTokEnd) !== ")") return expr;
    var result = this.parseSubscripts(expr, startPos, startLoc);
    if (refDestructuringErrors && result.type === "MemberExpression") {
        if (refDestructuringErrors.parenthesizedAssign >= result.start) refDestructuringErrors.parenthesizedAssign = -1;
        if (refDestructuringErrors.parenthesizedBind >= result.start) refDestructuringErrors.parenthesizedBind = -1;
    }
    return result;
};
pp$3.parseSubscripts = function(base, startPos, startLoc, noCalls) {
    var maybeAsyncArrow = this.options.ecmaVersion >= 8 && base.type === "Identifier" && base.name === "async" && this.lastTokEnd === base.end && !this.canInsertSemicolon() && base.end - base.start === 5 && this.potentialArrowAt === base.start;
    var optionalChained = false;
    while(true){
        var element = this.parseSubscript(base, startPos, startLoc, noCalls, maybeAsyncArrow, optionalChained);
        if (element.optional) optionalChained = true;
        if (element === base || element.type === "ArrowFunctionExpression") {
            if (optionalChained) {
                var chainNode = this.startNodeAt(startPos, startLoc);
                chainNode.expression = element;
                element = this.finishNode(chainNode, "ChainExpression");
            }
            return element;
        }
        base = element;
    }
};
pp$3.parseSubscript = function(base, startPos, startLoc, noCalls, maybeAsyncArrow, optionalChained) {
    var optionalSupported = this.options.ecmaVersion >= 11;
    var optional = optionalSupported && this.eat(types.questionDot);
    if (noCalls && optional) this.raise(this.lastTokStart, "Optional chaining cannot appear in the callee of new expressions");
    var computed = this.eat(types.bracketL);
    if (computed || optional && this.type !== types.parenL && this.type !== types.backQuote || this.eat(types.dot)) {
        var node = this.startNodeAt(startPos, startLoc);
        node.object = base;
        node.property = computed ? this.parseExpression() : this.parseIdent(this.options.allowReserved !== "never");
        node.computed = !!computed;
        if (computed) this.expect(types.bracketR);
        if (optionalSupported) node.optional = optional;
        base = this.finishNode(node, "MemberExpression");
    } else if (!noCalls && this.eat(types.parenL)) {
        var refDestructuringErrors = new DestructuringErrors, oldYieldPos = this.yieldPos, oldAwaitPos = this.awaitPos, oldAwaitIdentPos = this.awaitIdentPos;
        this.yieldPos = 0;
        this.awaitPos = 0;
        this.awaitIdentPos = 0;
        var exprList = this.parseExprList(types.parenR, this.options.ecmaVersion >= 8, false, refDestructuringErrors);
        if (maybeAsyncArrow && !optional && !this.canInsertSemicolon() && this.eat(types.arrow)) {
            this.checkPatternErrors(refDestructuringErrors, false);
            this.checkYieldAwaitInDefaultParams();
            if (this.awaitIdentPos > 0) this.raise(this.awaitIdentPos, "Cannot use 'await' as identifier inside an async function");
            this.yieldPos = oldYieldPos;
            this.awaitPos = oldAwaitPos;
            this.awaitIdentPos = oldAwaitIdentPos;
            return this.parseArrowExpression(this.startNodeAt(startPos, startLoc), exprList, true);
        }
        this.checkExpressionErrors(refDestructuringErrors, true);
        this.yieldPos = oldYieldPos || this.yieldPos;
        this.awaitPos = oldAwaitPos || this.awaitPos;
        this.awaitIdentPos = oldAwaitIdentPos || this.awaitIdentPos;
        var node$1 = this.startNodeAt(startPos, startLoc);
        node$1.callee = base;
        node$1.arguments = exprList;
        if (optionalSupported) node$1.optional = optional;
        base = this.finishNode(node$1, "CallExpression");
    } else if (this.type === types.backQuote) {
        if (optional || optionalChained) this.raise(this.start, "Optional chaining cannot appear in the tag of tagged template expressions");
        var node$2 = this.startNodeAt(startPos, startLoc);
        node$2.tag = base;
        node$2.quasi = this.parseTemplate({
            isTagged: true
        });
        base = this.finishNode(node$2, "TaggedTemplateExpression");
    }
    return base;
};
// Parse an atomic expression — either a single token that is an
// expression, an expression started by a keyword like `function` or
// `new`, or an expression wrapped in punctuation like `()`, `[]`,
// or `{}`.
pp$3.parseExprAtom = function(refDestructuringErrors) {
    // If a division operator appears in an expression position, the
    // tokenizer got confused, and we force it to read a regexp instead.
    if (this.type === types.slash) this.readRegexp();
    var node, canBeArrow = this.potentialArrowAt === this.start;
    switch(this.type){
        case types._super:
            if (!this.allowSuper) this.raise(this.start, "'super' keyword outside a method");
            node = this.startNode();
            this.next();
            if (this.type === types.parenL && !this.allowDirectSuper) this.raise(node.start, "super() call outside constructor of a subclass");
            // The `super` keyword can appear at below:
            // SuperProperty:
            //     super [ Expression ]
            //     super . IdentifierName
            // SuperCall:
            //     super ( Arguments )
            if (this.type !== types.dot && this.type !== types.bracketL && this.type !== types.parenL) this.unexpected();
            return this.finishNode(node, "Super");
        case types._this:
            node = this.startNode();
            this.next();
            return this.finishNode(node, "ThisExpression");
        case types.name:
            var startPos = this.start, startLoc = this.startLoc, containsEsc = this.containsEsc;
            var id = this.parseIdent(false);
            if (this.options.ecmaVersion >= 8 && !containsEsc && id.name === "async" && !this.canInsertSemicolon() && this.eat(types._function)) return this.parseFunction(this.startNodeAt(startPos, startLoc), 0, false, true);
            if (canBeArrow && !this.canInsertSemicolon()) {
                if (this.eat(types.arrow)) return this.parseArrowExpression(this.startNodeAt(startPos, startLoc), [
                    id
                ], false);
                if (this.options.ecmaVersion >= 8 && id.name === "async" && this.type === types.name && !containsEsc) {
                    id = this.parseIdent(false);
                    if (this.canInsertSemicolon() || !this.eat(types.arrow)) this.unexpected();
                    return this.parseArrowExpression(this.startNodeAt(startPos, startLoc), [
                        id
                    ], true);
                }
            }
            return id;
        case types.regexp:
            var value = this.value;
            node = this.parseLiteral(value.value);
            node.regex = {
                pattern: value.pattern,
                flags: value.flags
            };
            return node;
        case types.num:
        case types.string:
            return this.parseLiteral(this.value);
        case types._null:
        case types._true:
        case types._false:
            node = this.startNode();
            node.value = this.type === types._null ? null : this.type === types._true;
            node.raw = this.type.keyword;
            this.next();
            return this.finishNode(node, "Literal");
        case types.parenL:
            var start = this.start, expr = this.parseParenAndDistinguishExpression(canBeArrow);
            if (refDestructuringErrors) {
                if (refDestructuringErrors.parenthesizedAssign < 0 && !this.isSimpleAssignTarget(expr)) refDestructuringErrors.parenthesizedAssign = start;
                if (refDestructuringErrors.parenthesizedBind < 0) refDestructuringErrors.parenthesizedBind = start;
            }
            return expr;
        case types.bracketL:
            node = this.startNode();
            this.next();
            node.elements = this.parseExprList(types.bracketR, true, true, refDestructuringErrors);
            return this.finishNode(node, "ArrayExpression");
        case types.braceL:
            return this.parseObj(false, refDestructuringErrors);
        case types._function:
            node = this.startNode();
            this.next();
            return this.parseFunction(node, 0);
        case types._class:
            return this.parseClass(this.startNode(), false);
        case types._new:
            return this.parseNew();
        case types.backQuote:
            return this.parseTemplate();
        case types._import:
            if (this.options.ecmaVersion >= 11) return this.parseExprImport();
            else return this.unexpected();
        default:
            this.unexpected();
    }
};
pp$3.parseExprImport = function() {
    var node = this.startNode();
    // Consume `import` as an identifier for `import.meta`.
    // Because `this.parseIdent(true)` doesn't check escape sequences, it needs the check of `this.containsEsc`.
    if (this.containsEsc) this.raiseRecoverable(this.start, "Escape sequence in keyword import");
    var meta = this.parseIdent(true);
    switch(this.type){
        case types.parenL:
            return this.parseDynamicImport(node);
        case types.dot:
            node.meta = meta;
            return this.parseImportMeta(node);
        default:
            this.unexpected();
    }
};
pp$3.parseDynamicImport = function(node) {
    this.next(); // skip `(`
    // Parse node.source.
    node.source = this.parseMaybeAssign();
    // Verify ending.
    if (!this.eat(types.parenR)) {
        var errorPos = this.start;
        if (this.eat(types.comma) && this.eat(types.parenR)) this.raiseRecoverable(errorPos, "Trailing comma is not allowed in import()");
        else this.unexpected(errorPos);
    }
    return this.finishNode(node, "ImportExpression");
};
pp$3.parseImportMeta = function(node) {
    this.next(); // skip `.`
    var containsEsc = this.containsEsc;
    node.property = this.parseIdent(true);
    if (node.property.name !== "meta") this.raiseRecoverable(node.property.start, "The only valid meta property for import is 'import.meta'");
    if (containsEsc) this.raiseRecoverable(node.start, "'import.meta' must not contain escaped characters");
    if (this.options.sourceType !== "module") this.raiseRecoverable(node.start, "Cannot use 'import.meta' outside a module");
    return this.finishNode(node, "MetaProperty");
};
pp$3.parseLiteral = function(value) {
    var node = this.startNode();
    node.value = value;
    node.raw = this.input.slice(this.start, this.end);
    if (node.raw.charCodeAt(node.raw.length - 1) === 110) node.bigint = node.raw.slice(0, -1).replace(/_/g, "");
    this.next();
    return this.finishNode(node, "Literal");
};
pp$3.parseParenExpression = function() {
    this.expect(types.parenL);
    var val = this.parseExpression();
    this.expect(types.parenR);
    return val;
};
pp$3.parseParenAndDistinguishExpression = function(canBeArrow) {
    var startPos = this.start, startLoc = this.startLoc, val, allowTrailingComma = this.options.ecmaVersion >= 8;
    if (this.options.ecmaVersion >= 6) {
        this.next();
        var innerStartPos = this.start, innerStartLoc = this.startLoc;
        var exprList = [], first = true, lastIsComma = false;
        var refDestructuringErrors = new DestructuringErrors, oldYieldPos = this.yieldPos, oldAwaitPos = this.awaitPos, spreadStart;
        this.yieldPos = 0;
        this.awaitPos = 0;
        // Do not save awaitIdentPos to allow checking awaits nested in parameters
        while(this.type !== types.parenR){
            first ? first = false : this.expect(types.comma);
            if (allowTrailingComma && this.afterTrailingComma(types.parenR, true)) {
                lastIsComma = true;
                break;
            } else if (this.type === types.ellipsis) {
                spreadStart = this.start;
                exprList.push(this.parseParenItem(this.parseRestBinding()));
                if (this.type === types.comma) this.raise(this.start, "Comma is not permitted after the rest element");
                break;
            } else exprList.push(this.parseMaybeAssign(false, refDestructuringErrors, this.parseParenItem));
        }
        var innerEndPos = this.start, innerEndLoc = this.startLoc;
        this.expect(types.parenR);
        if (canBeArrow && !this.canInsertSemicolon() && this.eat(types.arrow)) {
            this.checkPatternErrors(refDestructuringErrors, false);
            this.checkYieldAwaitInDefaultParams();
            this.yieldPos = oldYieldPos;
            this.awaitPos = oldAwaitPos;
            return this.parseParenArrowList(startPos, startLoc, exprList);
        }
        if (!exprList.length || lastIsComma) this.unexpected(this.lastTokStart);
        if (spreadStart) this.unexpected(spreadStart);
        this.checkExpressionErrors(refDestructuringErrors, true);
        this.yieldPos = oldYieldPos || this.yieldPos;
        this.awaitPos = oldAwaitPos || this.awaitPos;
        if (exprList.length > 1) {
            val = this.startNodeAt(innerStartPos, innerStartLoc);
            val.expressions = exprList;
            this.finishNodeAt(val, "SequenceExpression", innerEndPos, innerEndLoc);
        } else val = exprList[0];
    } else val = this.parseParenExpression();
    if (this.options.preserveParens) {
        var par = this.startNodeAt(startPos, startLoc);
        par.expression = val;
        return this.finishNode(par, "ParenthesizedExpression");
    } else return val;
};
pp$3.parseParenItem = function(item) {
    return item;
};
pp$3.parseParenArrowList = function(startPos, startLoc, exprList) {
    return this.parseArrowExpression(this.startNodeAt(startPos, startLoc), exprList);
};
// New's precedence is slightly tricky. It must allow its argument to
// be a `[]` or dot subscript expression, but not a call — at least,
// not without wrapping it in parentheses. Thus, it uses the noCalls
// argument to parseSubscripts to prevent it from consuming the
// argument list.
var empty$1 = [];
pp$3.parseNew = function() {
    if (this.containsEsc) this.raiseRecoverable(this.start, "Escape sequence in keyword new");
    var node = this.startNode();
    var meta = this.parseIdent(true);
    if (this.options.ecmaVersion >= 6 && this.eat(types.dot)) {
        node.meta = meta;
        var containsEsc = this.containsEsc;
        node.property = this.parseIdent(true);
        if (node.property.name !== "target") this.raiseRecoverable(node.property.start, "The only valid meta property for new is 'new.target'");
        if (containsEsc) this.raiseRecoverable(node.start, "'new.target' must not contain escaped characters");
        if (!this.inNonArrowFunction()) this.raiseRecoverable(node.start, "'new.target' can only be used in functions");
        return this.finishNode(node, "MetaProperty");
    }
    var startPos = this.start, startLoc = this.startLoc, isImport = this.type === types._import;
    node.callee = this.parseSubscripts(this.parseExprAtom(), startPos, startLoc, true);
    if (isImport && node.callee.type === "ImportExpression") this.raise(startPos, "Cannot use new with import()");
    if (this.eat(types.parenL)) node.arguments = this.parseExprList(types.parenR, this.options.ecmaVersion >= 8, false);
    else node.arguments = empty$1;
    return this.finishNode(node, "NewExpression");
};
// Parse template expression.
pp$3.parseTemplateElement = function(ref) {
    var isTagged = ref.isTagged;
    var elem = this.startNode();
    if (this.type === types.invalidTemplate) {
        if (!isTagged) this.raiseRecoverable(this.start, "Bad escape sequence in untagged template literal");
        elem.value = {
            raw: this.value,
            cooked: null
        };
    } else elem.value = {
        raw: this.input.slice(this.start, this.end).replace(/\r\n?/g, "\n"),
        cooked: this.value
    };
    this.next();
    elem.tail = this.type === types.backQuote;
    return this.finishNode(elem, "TemplateElement");
};
pp$3.parseTemplate = function(ref) {
    if (ref === void 0) ref = {};
    var isTagged = ref.isTagged;
    if (isTagged === void 0) isTagged = false;
    var node = this.startNode();
    this.next();
    node.expressions = [];
    var curElt = this.parseTemplateElement({
        isTagged: isTagged
    });
    node.quasis = [
        curElt
    ];
    while(!curElt.tail){
        if (this.type === types.eof) this.raise(this.pos, "Unterminated template literal");
        this.expect(types.dollarBraceL);
        node.expressions.push(this.parseExpression());
        this.expect(types.braceR);
        node.quasis.push(curElt = this.parseTemplateElement({
            isTagged: isTagged
        }));
    }
    this.next();
    return this.finishNode(node, "TemplateLiteral");
};
pp$3.isAsyncProp = function(prop) {
    return !prop.computed && prop.key.type === "Identifier" && prop.key.name === "async" && (this.type === types.name || this.type === types.num || this.type === types.string || this.type === types.bracketL || this.type.keyword || this.options.ecmaVersion >= 9 && this.type === types.star) && !lineBreak.test(this.input.slice(this.lastTokEnd, this.start));
};
// Parse an object literal or binding pattern.
pp$3.parseObj = function(isPattern, refDestructuringErrors) {
    var node = this.startNode(), first = true, propHash = {};
    node.properties = [];
    this.next();
    while(!this.eat(types.braceR)){
        if (!first) {
            this.expect(types.comma);
            if (this.options.ecmaVersion >= 5 && this.afterTrailingComma(types.braceR)) break;
        } else first = false;
        var prop = this.parseProperty(isPattern, refDestructuringErrors);
        if (!isPattern) this.checkPropClash(prop, propHash, refDestructuringErrors);
        node.properties.push(prop);
    }
    return this.finishNode(node, isPattern ? "ObjectPattern" : "ObjectExpression");
};
pp$3.parseProperty = function(isPattern, refDestructuringErrors) {
    var prop = this.startNode(), isGenerator, isAsync, startPos, startLoc;
    if (this.options.ecmaVersion >= 9 && this.eat(types.ellipsis)) {
        if (isPattern) {
            prop.argument = this.parseIdent(false);
            if (this.type === types.comma) this.raise(this.start, "Comma is not permitted after the rest element");
            return this.finishNode(prop, "RestElement");
        }
        // To disallow parenthesized identifier via `this.toAssignable()`.
        if (this.type === types.parenL && refDestructuringErrors) {
            if (refDestructuringErrors.parenthesizedAssign < 0) refDestructuringErrors.parenthesizedAssign = this.start;
            if (refDestructuringErrors.parenthesizedBind < 0) refDestructuringErrors.parenthesizedBind = this.start;
        }
        // Parse argument.
        prop.argument = this.parseMaybeAssign(false, refDestructuringErrors);
        // To disallow trailing comma via `this.toAssignable()`.
        if (this.type === types.comma && refDestructuringErrors && refDestructuringErrors.trailingComma < 0) refDestructuringErrors.trailingComma = this.start;
        // Finish
        return this.finishNode(prop, "SpreadElement");
    }
    if (this.options.ecmaVersion >= 6) {
        prop.method = false;
        prop.shorthand = false;
        if (isPattern || refDestructuringErrors) {
            startPos = this.start;
            startLoc = this.startLoc;
        }
        if (!isPattern) isGenerator = this.eat(types.star);
    }
    var containsEsc = this.containsEsc;
    this.parsePropertyName(prop);
    if (!isPattern && !containsEsc && this.options.ecmaVersion >= 8 && !isGenerator && this.isAsyncProp(prop)) {
        isAsync = true;
        isGenerator = this.options.ecmaVersion >= 9 && this.eat(types.star);
        this.parsePropertyName(prop, refDestructuringErrors);
    } else isAsync = false;
    this.parsePropertyValue(prop, isPattern, isGenerator, isAsync, startPos, startLoc, refDestructuringErrors, containsEsc);
    return this.finishNode(prop, "Property");
};
pp$3.parsePropertyValue = function(prop, isPattern, isGenerator, isAsync, startPos, startLoc, refDestructuringErrors, containsEsc) {
    if ((isGenerator || isAsync) && this.type === types.colon) this.unexpected();
    if (this.eat(types.colon)) {
        prop.value = isPattern ? this.parseMaybeDefault(this.start, this.startLoc) : this.parseMaybeAssign(false, refDestructuringErrors);
        prop.kind = "init";
    } else if (this.options.ecmaVersion >= 6 && this.type === types.parenL) {
        if (isPattern) this.unexpected();
        prop.kind = "init";
        prop.method = true;
        prop.value = this.parseMethod(isGenerator, isAsync);
    } else if (!isPattern && !containsEsc && this.options.ecmaVersion >= 5 && !prop.computed && prop.key.type === "Identifier" && (prop.key.name === "get" || prop.key.name === "set") && this.type !== types.comma && this.type !== types.braceR && this.type !== types.eq) {
        if (isGenerator || isAsync) this.unexpected();
        prop.kind = prop.key.name;
        this.parsePropertyName(prop);
        prop.value = this.parseMethod(false);
        var paramCount = prop.kind === "get" ? 0 : 1;
        if (prop.value.params.length !== paramCount) {
            var start = prop.value.start;
            if (prop.kind === "get") this.raiseRecoverable(start, "getter should have no params");
            else this.raiseRecoverable(start, "setter should have exactly one param");
        } else if (prop.kind === "set" && prop.value.params[0].type === "RestElement") this.raiseRecoverable(prop.value.params[0].start, "Setter cannot use rest params");
    } else if (this.options.ecmaVersion >= 6 && !prop.computed && prop.key.type === "Identifier") {
        if (isGenerator || isAsync) this.unexpected();
        this.checkUnreserved(prop.key);
        if (prop.key.name === "await" && !this.awaitIdentPos) this.awaitIdentPos = startPos;
        prop.kind = "init";
        if (isPattern) prop.value = this.parseMaybeDefault(startPos, startLoc, prop.key);
        else if (this.type === types.eq && refDestructuringErrors) {
            if (refDestructuringErrors.shorthandAssign < 0) refDestructuringErrors.shorthandAssign = this.start;
            prop.value = this.parseMaybeDefault(startPos, startLoc, prop.key);
        } else prop.value = prop.key;
        prop.shorthand = true;
    } else this.unexpected();
};
pp$3.parsePropertyName = function(prop) {
    if (this.options.ecmaVersion >= 6) {
        if (this.eat(types.bracketL)) {
            prop.computed = true;
            prop.key = this.parseMaybeAssign();
            this.expect(types.bracketR);
            return prop.key;
        } else prop.computed = false;
    }
    return prop.key = this.type === types.num || this.type === types.string ? this.parseExprAtom() : this.parseIdent(this.options.allowReserved !== "never");
};
// Initialize empty function node.
pp$3.initFunction = function(node) {
    node.id = null;
    if (this.options.ecmaVersion >= 6) node.generator = node.expression = false;
    if (this.options.ecmaVersion >= 8) node.async = false;
};
// Parse object or class method.
pp$3.parseMethod = function(isGenerator, isAsync, allowDirectSuper) {
    var node = this.startNode(), oldYieldPos = this.yieldPos, oldAwaitPos = this.awaitPos, oldAwaitIdentPos = this.awaitIdentPos;
    this.initFunction(node);
    if (this.options.ecmaVersion >= 6) node.generator = isGenerator;
    if (this.options.ecmaVersion >= 8) node.async = !!isAsync;
    this.yieldPos = 0;
    this.awaitPos = 0;
    this.awaitIdentPos = 0;
    this.enterScope(functionFlags(isAsync, node.generator) | SCOPE_SUPER | (allowDirectSuper ? SCOPE_DIRECT_SUPER : 0));
    this.expect(types.parenL);
    node.params = this.parseBindingList(types.parenR, false, this.options.ecmaVersion >= 8);
    this.checkYieldAwaitInDefaultParams();
    this.parseFunctionBody(node, false, true);
    this.yieldPos = oldYieldPos;
    this.awaitPos = oldAwaitPos;
    this.awaitIdentPos = oldAwaitIdentPos;
    return this.finishNode(node, "FunctionExpression");
};
// Parse arrow function expression with given parameters.
pp$3.parseArrowExpression = function(node, params, isAsync) {
    var oldYieldPos = this.yieldPos, oldAwaitPos = this.awaitPos, oldAwaitIdentPos = this.awaitIdentPos;
    this.enterScope(functionFlags(isAsync, false) | SCOPE_ARROW);
    this.initFunction(node);
    if (this.options.ecmaVersion >= 8) node.async = !!isAsync;
    this.yieldPos = 0;
    this.awaitPos = 0;
    this.awaitIdentPos = 0;
    node.params = this.toAssignableList(params, true);
    this.parseFunctionBody(node, true, false);
    this.yieldPos = oldYieldPos;
    this.awaitPos = oldAwaitPos;
    this.awaitIdentPos = oldAwaitIdentPos;
    return this.finishNode(node, "ArrowFunctionExpression");
};
// Parse function body and check parameters.
pp$3.parseFunctionBody = function(node, isArrowFunction, isMethod) {
    var isExpression = isArrowFunction && this.type !== types.braceL;
    var oldStrict = this.strict, useStrict = false;
    if (isExpression) {
        node.body = this.parseMaybeAssign();
        node.expression = true;
        this.checkParams(node, false);
    } else {
        var nonSimple = this.options.ecmaVersion >= 7 && !this.isSimpleParamList(node.params);
        if (!oldStrict || nonSimple) {
            useStrict = this.strictDirective(this.end);
            // If this is a strict mode function, verify that argument names
            // are not repeated, and it does not try to bind the words `eval`
            // or `arguments`.
            if (useStrict && nonSimple) this.raiseRecoverable(node.start, "Illegal 'use strict' directive in function with non-simple parameter list");
        }
        // Start a new scope with regard to labels and the `inFunction`
        // flag (restore them to their old value afterwards).
        var oldLabels = this.labels;
        this.labels = [];
        if (useStrict) this.strict = true;
        // Add the params to varDeclaredNames to ensure that an error is thrown
        // if a let/const declaration in the function clashes with one of the params.
        this.checkParams(node, !oldStrict && !useStrict && !isArrowFunction && !isMethod && this.isSimpleParamList(node.params));
        // Ensure the function name isn't a forbidden identifier in strict mode, e.g. 'eval'
        if (this.strict && node.id) this.checkLVal(node.id, BIND_OUTSIDE);
        node.body = this.parseBlock(false, undefined, useStrict && !oldStrict);
        node.expression = false;
        this.adaptDirectivePrologue(node.body.body);
        this.labels = oldLabels;
    }
    this.exitScope();
};
pp$3.isSimpleParamList = function(params) {
    for(var i = 0, list = params; i < list.length; i += 1){
        var param = list[i];
        if (param.type !== "Identifier") return false;
    }
    return true;
};
// Checks function params for various disallowed patterns such as using "eval"
// or "arguments" and duplicate parameters.
pp$3.checkParams = function(node, allowDuplicates) {
    var nameHash = {};
    for(var i = 0, list = node.params; i < list.length; i += 1){
        var param = list[i];
        this.checkLVal(param, BIND_VAR, allowDuplicates ? null : nameHash);
    }
};
// Parses a comma-separated list of expressions, and returns them as
// an array. `close` is the token type that ends the list, and
// `allowEmpty` can be turned on to allow subsequent commas with
// nothing in between them to be parsed as `null` (which is needed
// for array literals).
pp$3.parseExprList = function(close, allowTrailingComma, allowEmpty, refDestructuringErrors) {
    var elts = [], first = true;
    while(!this.eat(close)){
        if (!first) {
            this.expect(types.comma);
            if (allowTrailingComma && this.afterTrailingComma(close)) break;
        } else first = false;
        var elt = void 0;
        if (allowEmpty && this.type === types.comma) elt = null;
        else if (this.type === types.ellipsis) {
            elt = this.parseSpread(refDestructuringErrors);
            if (refDestructuringErrors && this.type === types.comma && refDestructuringErrors.trailingComma < 0) refDestructuringErrors.trailingComma = this.start;
        } else elt = this.parseMaybeAssign(false, refDestructuringErrors);
        elts.push(elt);
    }
    return elts;
};
pp$3.checkUnreserved = function(ref) {
    var start = ref.start;
    var end = ref.end;
    var name = ref.name;
    if (this.inGenerator && name === "yield") this.raiseRecoverable(start, "Cannot use 'yield' as identifier inside a generator");
    if (this.inAsync && name === "await") this.raiseRecoverable(start, "Cannot use 'await' as identifier inside an async function");
    if (this.keywords.test(name)) this.raise(start, "Unexpected keyword '" + name + "'");
    if (this.options.ecmaVersion < 6 && this.input.slice(start, end).indexOf("\\") !== -1) return;
    var re = this.strict ? this.reservedWordsStrict : this.reservedWords;
    if (re.test(name)) {
        if (!this.inAsync && name === "await") this.raiseRecoverable(start, "Cannot use keyword 'await' outside an async function");
        this.raiseRecoverable(start, "The keyword '" + name + "' is reserved");
    }
};
// Parse the next token as an identifier. If `liberal` is true (used
// when parsing properties), it will also convert keywords into
// identifiers.
pp$3.parseIdent = function(liberal, isBinding) {
    var node = this.startNode();
    if (this.type === types.name) node.name = this.value;
    else if (this.type.keyword) {
        node.name = this.type.keyword;
        // To fix https://github.com/acornjs/acorn/issues/575
        // `class` and `function` keywords push new context into this.context.
        // But there is no chance to pop the context if the keyword is consumed as an identifier such as a property name.
        // If the previous token is a dot, this does not apply because the context-managing code already ignored the keyword
        if ((node.name === "class" || node.name === "function") && (this.lastTokEnd !== this.lastTokStart + 1 || this.input.charCodeAt(this.lastTokStart) !== 46)) this.context.pop();
    } else this.unexpected();
    this.next(!!liberal);
    this.finishNode(node, "Identifier");
    if (!liberal) {
        this.checkUnreserved(node);
        if (node.name === "await" && !this.awaitIdentPos) this.awaitIdentPos = node.start;
    }
    return node;
};
// Parses yield expression inside generator.
pp$3.parseYield = function(noIn) {
    if (!this.yieldPos) this.yieldPos = this.start;
    var node = this.startNode();
    this.next();
    if (this.type === types.semi || this.canInsertSemicolon() || this.type !== types.star && !this.type.startsExpr) {
        node.delegate = false;
        node.argument = null;
    } else {
        node.delegate = this.eat(types.star);
        node.argument = this.parseMaybeAssign(noIn);
    }
    return this.finishNode(node, "YieldExpression");
};
pp$3.parseAwait = function() {
    if (!this.awaitPos) this.awaitPos = this.start;
    var node = this.startNode();
    this.next();
    node.argument = this.parseMaybeUnary(null, false);
    return this.finishNode(node, "AwaitExpression");
};
var pp$4 = Parser.prototype;
// This function is used to raise exceptions on parse errors. It
// takes an offset integer (into the current `input`) to indicate
// the location of the error, attaches the position to the end
// of the error message, and then raises a `SyntaxError` with that
// message.
pp$4.raise = function(pos, message) {
    var loc = getLineInfo(this.input, pos);
    message += " (" + loc.line + ":" + loc.column + ")";
    var err = new SyntaxError(message);
    err.pos = pos;
    err.loc = loc;
    err.raisedAt = this.pos;
    throw err;
};
pp$4.raiseRecoverable = pp$4.raise;
pp$4.curPosition = function() {
    if (this.options.locations) return new Position(this.curLine, this.pos - this.lineStart);
};
var pp$5 = Parser.prototype;
var Scope = function Scope(flags) {
    this.flags = flags;
    // A list of var-declared names in the current lexical scope
    this.var = [];
    // A list of lexically-declared names in the current lexical scope
    this.lexical = [];
    // A list of lexically-declared FunctionDeclaration names in the current lexical scope
    this.functions = [];
};
// The functions in this module keep track of declared variables in the current scope in order to detect duplicate variable names.
pp$5.enterScope = function(flags) {
    this.scopeStack.push(new Scope(flags));
};
pp$5.exitScope = function() {
    this.scopeStack.pop();
};
// The spec says:
// > At the top level of a function, or script, function declarations are
// > treated like var declarations rather than like lexical declarations.
pp$5.treatFunctionsAsVarInScope = function(scope) {
    return scope.flags & SCOPE_FUNCTION || !this.inModule && scope.flags & SCOPE_TOP;
};
pp$5.declareName = function(name, bindingType, pos) {
    var redeclared = false;
    if (bindingType === BIND_LEXICAL) {
        var scope = this.currentScope();
        redeclared = scope.lexical.indexOf(name) > -1 || scope.functions.indexOf(name) > -1 || scope.var.indexOf(name) > -1;
        scope.lexical.push(name);
        if (this.inModule && scope.flags & SCOPE_TOP) delete this.undefinedExports[name];
    } else if (bindingType === BIND_SIMPLE_CATCH) {
        var scope$1 = this.currentScope();
        scope$1.lexical.push(name);
    } else if (bindingType === BIND_FUNCTION) {
        var scope$2 = this.currentScope();
        if (this.treatFunctionsAsVar) redeclared = scope$2.lexical.indexOf(name) > -1;
        else redeclared = scope$2.lexical.indexOf(name) > -1 || scope$2.var.indexOf(name) > -1;
        scope$2.functions.push(name);
    } else for(var i = this.scopeStack.length - 1; i >= 0; --i){
        var scope$3 = this.scopeStack[i];
        if (scope$3.lexical.indexOf(name) > -1 && !(scope$3.flags & SCOPE_SIMPLE_CATCH && scope$3.lexical[0] === name) || !this.treatFunctionsAsVarInScope(scope$3) && scope$3.functions.indexOf(name) > -1) {
            redeclared = true;
            break;
        }
        scope$3.var.push(name);
        if (this.inModule && scope$3.flags & SCOPE_TOP) delete this.undefinedExports[name];
        if (scope$3.flags & SCOPE_VAR) break;
    }
    if (redeclared) this.raiseRecoverable(pos, "Identifier '" + name + "' has already been declared");
};
pp$5.checkLocalExport = function(id) {
    // scope.functions must be empty as Module code is always strict.
    if (this.scopeStack[0].lexical.indexOf(id.name) === -1 && this.scopeStack[0].var.indexOf(id.name) === -1) this.undefinedExports[id.name] = id;
};
pp$5.currentScope = function() {
    return this.scopeStack[this.scopeStack.length - 1];
};
pp$5.currentVarScope = function() {
    for(var i = this.scopeStack.length - 1;; i--){
        var scope = this.scopeStack[i];
        if (scope.flags & SCOPE_VAR) return scope;
    }
};
// Could be useful for `this`, `new.target`, `super()`, `super.property`, and `super[property]`.
pp$5.currentThisScope = function() {
    for(var i = this.scopeStack.length - 1;; i--){
        var scope = this.scopeStack[i];
        if (scope.flags & SCOPE_VAR && !(scope.flags & SCOPE_ARROW)) return scope;
    }
};
var Node = function Node(parser, pos, loc) {
    this.type = "";
    this.start = pos;
    this.end = 0;
    if (parser.options.locations) this.loc = new SourceLocation(parser, loc);
    if (parser.options.directSourceFile) this.sourceFile = parser.options.directSourceFile;
    if (parser.options.ranges) this.range = [
        pos,
        0
    ];
};
// Start an AST node, attaching a start offset.
var pp$6 = Parser.prototype;
pp$6.startNode = function() {
    return new Node(this, this.start, this.startLoc);
};
pp$6.startNodeAt = function(pos, loc) {
    return new Node(this, pos, loc);
};
// Finish an AST node, adding `type` and `end` properties.
function finishNodeAt(node, type, pos, loc) {
    node.type = type;
    node.end = pos;
    if (this.options.locations) node.loc.end = loc;
    if (this.options.ranges) node.range[1] = pos;
    return node;
}
pp$6.finishNode = function(node, type) {
    return finishNodeAt.call(this, node, type, this.lastTokEnd, this.lastTokEndLoc);
};
// Finish node at given position
pp$6.finishNodeAt = function(node, type, pos, loc) {
    return finishNodeAt.call(this, node, type, pos, loc);
};
// The algorithm used to determine whether a regexp can appear at a
var TokContext = function TokContext(token, isExpr, preserveSpace, override, generator) {
    this.token = token;
    this.isExpr = !!isExpr;
    this.preserveSpace = !!preserveSpace;
    this.override = override;
    this.generator = !!generator;
};
var types$1 = {
    b_stat: new TokContext("{", false),
    b_expr: new TokContext("{", true),
    b_tmpl: new TokContext("${", false),
    p_stat: new TokContext("(", false),
    p_expr: new TokContext("(", true),
    q_tmpl: new TokContext("`", true, true, function(p) {
        return p.tryReadTemplateToken();
    }),
    f_stat: new TokContext("function", false),
    f_expr: new TokContext("function", true),
    f_expr_gen: new TokContext("function", true, false, null, true),
    f_gen: new TokContext("function", false, false, null, true)
};
var pp$7 = Parser.prototype;
pp$7.initialContext = function() {
    return [
        types$1.b_stat
    ];
};
pp$7.braceIsBlock = function(prevType) {
    var parent = this.curContext();
    if (parent === types$1.f_expr || parent === types$1.f_stat) return true;
    if (prevType === types.colon && (parent === types$1.b_stat || parent === types$1.b_expr)) return !parent.isExpr;
    // The check for `tt.name && exprAllowed` detects whether we are
    // after a `yield` or `of` construct. See the `updateContext` for
    // `tt.name`.
    if (prevType === types._return || prevType === types.name && this.exprAllowed) return lineBreak.test(this.input.slice(this.lastTokEnd, this.start));
    if (prevType === types._else || prevType === types.semi || prevType === types.eof || prevType === types.parenR || prevType === types.arrow) return true;
    if (prevType === types.braceL) return parent === types$1.b_stat;
    if (prevType === types._var || prevType === types._const || prevType === types.name) return false;
    return !this.exprAllowed;
};
pp$7.inGeneratorContext = function() {
    for(var i = this.context.length - 1; i >= 1; i--){
        var context = this.context[i];
        if (context.token === "function") return context.generator;
    }
    return false;
};
pp$7.updateContext = function(prevType) {
    var update, type = this.type;
    if (type.keyword && prevType === types.dot) this.exprAllowed = false;
    else if (update = type.updateContext) update.call(this, prevType);
    else this.exprAllowed = type.beforeExpr;
};
// Token-specific context update code
types.parenR.updateContext = types.braceR.updateContext = function() {
    if (this.context.length === 1) {
        this.exprAllowed = true;
        return;
    }
    var out = this.context.pop();
    if (out === types$1.b_stat && this.curContext().token === "function") out = this.context.pop();
    this.exprAllowed = !out.isExpr;
};
types.braceL.updateContext = function(prevType) {
    this.context.push(this.braceIsBlock(prevType) ? types$1.b_stat : types$1.b_expr);
    this.exprAllowed = true;
};
types.dollarBraceL.updateContext = function() {
    this.context.push(types$1.b_tmpl);
    this.exprAllowed = true;
};
types.parenL.updateContext = function(prevType) {
    var statementParens = prevType === types._if || prevType === types._for || prevType === types._with || prevType === types._while;
    this.context.push(statementParens ? types$1.p_stat : types$1.p_expr);
    this.exprAllowed = true;
};
types.incDec.updateContext = function() {
// tokExprAllowed stays unchanged
};
types._function.updateContext = types._class.updateContext = function(prevType) {
    if (prevType.beforeExpr && prevType !== types.semi && prevType !== types._else && !(prevType === types._return && lineBreak.test(this.input.slice(this.lastTokEnd, this.start))) && !((prevType === types.colon || prevType === types.braceL) && this.curContext() === types$1.b_stat)) this.context.push(types$1.f_expr);
    else this.context.push(types$1.f_stat);
    this.exprAllowed = false;
};
types.backQuote.updateContext = function() {
    if (this.curContext() === types$1.q_tmpl) this.context.pop();
    else this.context.push(types$1.q_tmpl);
    this.exprAllowed = false;
};
types.star.updateContext = function(prevType) {
    if (prevType === types._function) {
        var index = this.context.length - 1;
        if (this.context[index] === types$1.f_expr) this.context[index] = types$1.f_expr_gen;
        else this.context[index] = types$1.f_gen;
    }
    this.exprAllowed = true;
};
types.name.updateContext = function(prevType) {
    var allowed = false;
    if (this.options.ecmaVersion >= 6 && prevType !== types.dot) {
        if (this.value === "of" && !this.exprAllowed || this.value === "yield" && this.inGeneratorContext()) allowed = true;
    }
    this.exprAllowed = allowed;
};
// This file contains Unicode properties extracted from the ECMAScript
// specification. The lists are extracted like so:
// $$('#table-binary-unicode-properties > figure > table > tbody > tr > td:nth-child(1) code').map(el => el.innerText)
// #table-binary-unicode-properties
var ecma9BinaryProperties = "ASCII ASCII_Hex_Digit AHex Alphabetic Alpha Any Assigned Bidi_Control Bidi_C Bidi_Mirrored Bidi_M Case_Ignorable CI Cased Changes_When_Casefolded CWCF Changes_When_Casemapped CWCM Changes_When_Lowercased CWL Changes_When_NFKC_Casefolded CWKCF Changes_When_Titlecased CWT Changes_When_Uppercased CWU Dash Default_Ignorable_Code_Point DI Deprecated Dep Diacritic Dia Emoji Emoji_Component Emoji_Modifier Emoji_Modifier_Base Emoji_Presentation Extender Ext Grapheme_Base Gr_Base Grapheme_Extend Gr_Ext Hex_Digit Hex IDS_Binary_Operator IDSB IDS_Trinary_Operator IDST ID_Continue IDC ID_Start IDS Ideographic Ideo Join_Control Join_C Logical_Order_Exception LOE Lowercase Lower Math Noncharacter_Code_Point NChar Pattern_Syntax Pat_Syn Pattern_White_Space Pat_WS Quotation_Mark QMark Radical Regional_Indicator RI Sentence_Terminal STerm Soft_Dotted SD Terminal_Punctuation Term Unified_Ideograph UIdeo Uppercase Upper Variation_Selector VS White_Space space XID_Continue XIDC XID_Start XIDS";
var ecma10BinaryProperties = ecma9BinaryProperties + " Extended_Pictographic";
var ecma11BinaryProperties = ecma10BinaryProperties;
var unicodeBinaryProperties = {
    9: ecma9BinaryProperties,
    10: ecma10BinaryProperties,
    11: ecma11BinaryProperties
};
// #table-unicode-general-category-values
var unicodeGeneralCategoryValues = "Cased_Letter LC Close_Punctuation Pe Connector_Punctuation Pc Control Cc cntrl Currency_Symbol Sc Dash_Punctuation Pd Decimal_Number Nd digit Enclosing_Mark Me Final_Punctuation Pf Format Cf Initial_Punctuation Pi Letter L Letter_Number Nl Line_Separator Zl Lowercase_Letter Ll Mark M Combining_Mark Math_Symbol Sm Modifier_Letter Lm Modifier_Symbol Sk Nonspacing_Mark Mn Number N Open_Punctuation Ps Other C Other_Letter Lo Other_Number No Other_Punctuation Po Other_Symbol So Paragraph_Separator Zp Private_Use Co Punctuation P punct Separator Z Space_Separator Zs Spacing_Mark Mc Surrogate Cs Symbol S Titlecase_Letter Lt Unassigned Cn Uppercase_Letter Lu";
// #table-unicode-script-values
var ecma9ScriptValues = "Adlam Adlm Ahom Ahom Anatolian_Hieroglyphs Hluw Arabic Arab Armenian Armn Avestan Avst Balinese Bali Bamum Bamu Bassa_Vah Bass Batak Batk Bengali Beng Bhaiksuki Bhks Bopomofo Bopo Brahmi Brah Braille Brai Buginese Bugi Buhid Buhd Canadian_Aboriginal Cans Carian Cari Caucasian_Albanian Aghb Chakma Cakm Cham Cham Cherokee Cher Common Zyyy Coptic Copt Qaac Cuneiform Xsux Cypriot Cprt Cyrillic Cyrl Deseret Dsrt Devanagari Deva Duployan Dupl Egyptian_Hieroglyphs Egyp Elbasan Elba Ethiopic Ethi Georgian Geor Glagolitic Glag Gothic Goth Grantha Gran Greek Grek Gujarati Gujr Gurmukhi Guru Han Hani Hangul Hang Hanunoo Hano Hatran Hatr Hebrew Hebr Hiragana Hira Imperial_Aramaic Armi Inherited Zinh Qaai Inscriptional_Pahlavi Phli Inscriptional_Parthian Prti Javanese Java Kaithi Kthi Kannada Knda Katakana Kana Kayah_Li Kali Kharoshthi Khar Khmer Khmr Khojki Khoj Khudawadi Sind Lao Laoo Latin Latn Lepcha Lepc Limbu Limb Linear_A Lina Linear_B Linb Lisu Lisu Lycian Lyci Lydian Lydi Mahajani Mahj Malayalam Mlym Mandaic Mand Manichaean Mani Marchen Marc Masaram_Gondi Gonm Meetei_Mayek Mtei Mende_Kikakui Mend Meroitic_Cursive Merc Meroitic_Hieroglyphs Mero Miao Plrd Modi Modi Mongolian Mong Mro Mroo Multani Mult Myanmar Mymr Nabataean Nbat New_Tai_Lue Talu Newa Newa Nko Nkoo Nushu Nshu Ogham Ogam Ol_Chiki Olck Old_Hungarian Hung Old_Italic Ital Old_North_Arabian Narb Old_Permic Perm Old_Persian Xpeo Old_South_Arabian Sarb Old_Turkic Orkh Oriya Orya Osage Osge Osmanya Osma Pahawh_Hmong Hmng Palmyrene Palm Pau_Cin_Hau Pauc Phags_Pa Phag Phoenician Phnx Psalter_Pahlavi Phlp Rejang Rjng Runic Runr Samaritan Samr Saurashtra Saur Sharada Shrd Shavian Shaw Siddham Sidd SignWriting Sgnw Sinhala Sinh Sora_Sompeng Sora Soyombo Soyo Sundanese Sund Syloti_Nagri Sylo Syriac Syrc Tagalog Tglg Tagbanwa Tagb Tai_Le Tale Tai_Tham Lana Tai_Viet Tavt Takri Takr Tamil Taml Tangut Tang Telugu Telu Thaana Thaa Thai Thai Tibetan Tibt Tifinagh Tfng Tirhuta Tirh Ugaritic Ugar Vai Vaii Warang_Citi Wara Yi Yiii Zanabazar_Square Zanb";
var ecma10ScriptValues = ecma9ScriptValues + " Dogra Dogr Gunjala_Gondi Gong Hanifi_Rohingya Rohg Makasar Maka Medefaidrin Medf Old_Sogdian Sogo Sogdian Sogd";
var ecma11ScriptValues = ecma10ScriptValues + " Elymaic Elym Nandinagari Nand Nyiakeng_Puachue_Hmong Hmnp Wancho Wcho";
var unicodeScriptValues = {
    9: ecma9ScriptValues,
    10: ecma10ScriptValues,
    11: ecma11ScriptValues
};
var data = {};
function buildUnicodeData(ecmaVersion) {
    var d = data[ecmaVersion] = {
        binary: wordsRegexp(unicodeBinaryProperties[ecmaVersion] + " " + unicodeGeneralCategoryValues),
        nonBinary: {
            General_Category: wordsRegexp(unicodeGeneralCategoryValues),
            Script: wordsRegexp(unicodeScriptValues[ecmaVersion])
        }
    };
    d.nonBinary.Script_Extensions = d.nonBinary.Script;
    d.nonBinary.gc = d.nonBinary.General_Category;
    d.nonBinary.sc = d.nonBinary.Script;
    d.nonBinary.scx = d.nonBinary.Script_Extensions;
}
buildUnicodeData(9);
buildUnicodeData(10);
buildUnicodeData(11);
var pp$8 = Parser.prototype;
var RegExpValidationState = function RegExpValidationState(parser) {
    this.parser = parser;
    this.validFlags = "gim" + (parser.options.ecmaVersion >= 6 ? "uy" : "") + (parser.options.ecmaVersion >= 9 ? "s" : "");
    this.unicodeProperties = data[parser.options.ecmaVersion >= 11 ? 11 : parser.options.ecmaVersion];
    this.source = "";
    this.flags = "";
    this.start = 0;
    this.switchU = false;
    this.switchN = false;
    this.pos = 0;
    this.lastIntValue = 0;
    this.lastStringValue = "";
    this.lastAssertionIsQuantifiable = false;
    this.numCapturingParens = 0;
    this.maxBackReference = 0;
    this.groupNames = [];
    this.backReferenceNames = [];
};
RegExpValidationState.prototype.reset = function reset(start, pattern, flags) {
    var unicode = flags.indexOf("u") !== -1;
    this.start = start | 0;
    this.source = pattern + "";
    this.flags = flags;
    this.switchU = unicode && this.parser.options.ecmaVersion >= 6;
    this.switchN = unicode && this.parser.options.ecmaVersion >= 9;
};
RegExpValidationState.prototype.raise = function raise(message) {
    this.parser.raiseRecoverable(this.start, "Invalid regular expression: /" + this.source + "/: " + message);
};
// If u flag is given, this returns the code point at the index (it combines a surrogate pair).
// Otherwise, this returns the code unit of the index (can be a part of a surrogate pair).
RegExpValidationState.prototype.at = function at(i, forceU) {
    if (forceU === void 0) forceU = false;
    var s = this.source;
    var l = s.length;
    if (i >= l) return -1;
    var c = s.charCodeAt(i);
    if (!(forceU || this.switchU) || c <= 0xD7FF || c >= 0xE000 || i + 1 >= l) return c;
    var next = s.charCodeAt(i + 1);
    return next >= 0xDC00 && next <= 0xDFFF ? (c << 10) + next - 0x35FDC00 : c;
};
RegExpValidationState.prototype.nextIndex = function nextIndex(i, forceU) {
    if (forceU === void 0) forceU = false;
    var s = this.source;
    var l = s.length;
    if (i >= l) return l;
    var c = s.charCodeAt(i), next;
    if (!(forceU || this.switchU) || c <= 0xD7FF || c >= 0xE000 || i + 1 >= l || (next = s.charCodeAt(i + 1)) < 0xDC00 || next > 0xDFFF) return i + 1;
    return i + 2;
};
RegExpValidationState.prototype.current = function current(forceU) {
    if (forceU === void 0) forceU = false;
    return this.at(this.pos, forceU);
};
RegExpValidationState.prototype.lookahead = function lookahead(forceU) {
    if (forceU === void 0) forceU = false;
    return this.at(this.nextIndex(this.pos, forceU), forceU);
};
RegExpValidationState.prototype.advance = function advance(forceU) {
    if (forceU === void 0) forceU = false;
    this.pos = this.nextIndex(this.pos, forceU);
};
RegExpValidationState.prototype.eat = function eat(ch, forceU) {
    if (forceU === void 0) forceU = false;
    if (this.current(forceU) === ch) {
        this.advance(forceU);
        return true;
    }
    return false;
};
function codePointToString(ch) {
    if (ch <= 0xFFFF) return String.fromCharCode(ch);
    ch -= 0x10000;
    return String.fromCharCode((ch >> 10) + 0xD800, (ch & 0x03FF) + 0xDC00);
}
/**
 * Validate the flags part of a given RegExpLiteral.
 *
 * @param {RegExpValidationState} state The state to validate RegExp.
 * @returns {void}
 */ pp$8.validateRegExpFlags = function(state) {
    var validFlags = state.validFlags;
    var flags = state.flags;
    for(var i = 0; i < flags.length; i++){
        var flag = flags.charAt(i);
        if (validFlags.indexOf(flag) === -1) this.raise(state.start, "Invalid regular expression flag");
        if (flags.indexOf(flag, i + 1) > -1) this.raise(state.start, "Duplicate regular expression flag");
    }
};
/**
 * Validate the pattern part of a given RegExpLiteral.
 *
 * @param {RegExpValidationState} state The state to validate RegExp.
 * @returns {void}
 */ pp$8.validateRegExpPattern = function(state) {
    this.regexp_pattern(state);
    // The goal symbol for the parse is |Pattern[~U, ~N]|. If the result of
    // parsing contains a |GroupName|, reparse with the goal symbol
    // |Pattern[~U, +N]| and use this result instead. Throw a *SyntaxError*
    // exception if _P_ did not conform to the grammar, if any elements of _P_
    // were not matched by the parse, or if any Early Error conditions exist.
    if (!state.switchN && this.options.ecmaVersion >= 9 && state.groupNames.length > 0) {
        state.switchN = true;
        this.regexp_pattern(state);
    }
};
// https://www.ecma-international.org/ecma-262/8.0/#prod-Pattern
pp$8.regexp_pattern = function(state) {
    state.pos = 0;
    state.lastIntValue = 0;
    state.lastStringValue = "";
    state.lastAssertionIsQuantifiable = false;
    state.numCapturingParens = 0;
    state.maxBackReference = 0;
    state.groupNames.length = 0;
    state.backReferenceNames.length = 0;
    this.regexp_disjunction(state);
    if (state.pos !== state.source.length) {
        // Make the same messages as V8.
        if (state.eat(0x29 /* ) */ )) state.raise("Unmatched ')'");
        if (state.eat(0x5D /* ] */ ) || state.eat(0x7D /* } */ )) state.raise("Lone quantifier brackets");
    }
    if (state.maxBackReference > state.numCapturingParens) state.raise("Invalid escape");
    for(var i = 0, list = state.backReferenceNames; i < list.length; i += 1){
        var name = list[i];
        if (state.groupNames.indexOf(name) === -1) state.raise("Invalid named capture referenced");
    }
};
// https://www.ecma-international.org/ecma-262/8.0/#prod-Disjunction
pp$8.regexp_disjunction = function(state) {
    this.regexp_alternative(state);
    while(state.eat(0x7C /* | */ ))this.regexp_alternative(state);
    // Make the same message as V8.
    if (this.regexp_eatQuantifier(state, true)) state.raise("Nothing to repeat");
    if (state.eat(0x7B /* { */ )) state.raise("Lone quantifier brackets");
};
// https://www.ecma-international.org/ecma-262/8.0/#prod-Alternative
pp$8.regexp_alternative = function(state) {
    while(state.pos < state.source.length && this.regexp_eatTerm(state));
};
// https://www.ecma-international.org/ecma-262/8.0/#prod-annexB-Term
pp$8.regexp_eatTerm = function(state) {
    if (this.regexp_eatAssertion(state)) {
        // Handle `QuantifiableAssertion Quantifier` alternative.
        // `state.lastAssertionIsQuantifiable` is true if the last eaten Assertion
        // is a QuantifiableAssertion.
        if (state.lastAssertionIsQuantifiable && this.regexp_eatQuantifier(state)) // Make the same message as V8.
        {
            if (state.switchU) state.raise("Invalid quantifier");
        }
        return true;
    }
    if (state.switchU ? this.regexp_eatAtom(state) : this.regexp_eatExtendedAtom(state)) {
        this.regexp_eatQuantifier(state);
        return true;
    }
    return false;
};
// https://www.ecma-international.org/ecma-262/8.0/#prod-annexB-Assertion
pp$8.regexp_eatAssertion = function(state) {
    var start = state.pos;
    state.lastAssertionIsQuantifiable = false;
    // ^, $
    if (state.eat(0x5E /* ^ */ ) || state.eat(0x24 /* $ */ )) return true;
    // \b \B
    if (state.eat(0x5C /* \ */ )) {
        if (state.eat(0x42 /* B */ ) || state.eat(0x62 /* b */ )) return true;
        state.pos = start;
    }
    // Lookahead / Lookbehind
    if (state.eat(0x28 /* ( */ ) && state.eat(0x3F /* ? */ )) {
        var lookbehind = false;
        if (this.options.ecmaVersion >= 9) lookbehind = state.eat(0x3C /* < */ );
        if (state.eat(0x3D /* = */ ) || state.eat(0x21 /* ! */ )) {
            this.regexp_disjunction(state);
            if (!state.eat(0x29 /* ) */ )) state.raise("Unterminated group");
            state.lastAssertionIsQuantifiable = !lookbehind;
            return true;
        }
    }
    state.pos = start;
    return false;
};
// https://www.ecma-international.org/ecma-262/8.0/#prod-Quantifier
pp$8.regexp_eatQuantifier = function(state, noError) {
    if (noError === void 0) noError = false;
    if (this.regexp_eatQuantifierPrefix(state, noError)) {
        state.eat(0x3F /* ? */ );
        return true;
    }
    return false;
};
// https://www.ecma-international.org/ecma-262/8.0/#prod-QuantifierPrefix
pp$8.regexp_eatQuantifierPrefix = function(state, noError) {
    return state.eat(0x2A /* * */ ) || state.eat(0x2B /* + */ ) || state.eat(0x3F /* ? */ ) || this.regexp_eatBracedQuantifier(state, noError);
};
pp$8.regexp_eatBracedQuantifier = function(state, noError) {
    var start = state.pos;
    if (state.eat(0x7B /* { */ )) {
        var min = 0, max = -1;
        if (this.regexp_eatDecimalDigits(state)) {
            min = state.lastIntValue;
            if (state.eat(0x2C /* , */ ) && this.regexp_eatDecimalDigits(state)) max = state.lastIntValue;
            if (state.eat(0x7D /* } */ )) {
                // SyntaxError in https://www.ecma-international.org/ecma-262/8.0/#sec-term
                if (max !== -1 && max < min && !noError) state.raise("numbers out of order in {} quantifier");
                return true;
            }
        }
        if (state.switchU && !noError) state.raise("Incomplete quantifier");
        state.pos = start;
    }
    return false;
};
// https://www.ecma-international.org/ecma-262/8.0/#prod-Atom
pp$8.regexp_eatAtom = function(state) {
    return this.regexp_eatPatternCharacters(state) || state.eat(0x2E /* . */ ) || this.regexp_eatReverseSolidusAtomEscape(state) || this.regexp_eatCharacterClass(state) || this.regexp_eatUncapturingGroup(state) || this.regexp_eatCapturingGroup(state);
};
pp$8.regexp_eatReverseSolidusAtomEscape = function(state) {
    var start = state.pos;
    if (state.eat(0x5C /* \ */ )) {
        if (this.regexp_eatAtomEscape(state)) return true;
        state.pos = start;
    }
    return false;
};
pp$8.regexp_eatUncapturingGroup = function(state) {
    var start = state.pos;
    if (state.eat(0x28 /* ( */ )) {
        if (state.eat(0x3F /* ? */ ) && state.eat(0x3A /* : */ )) {
            this.regexp_disjunction(state);
            if (state.eat(0x29 /* ) */ )) return true;
            state.raise("Unterminated group");
        }
        state.pos = start;
    }
    return false;
};
pp$8.regexp_eatCapturingGroup = function(state) {
    if (state.eat(0x28 /* ( */ )) {
        if (this.options.ecmaVersion >= 9) this.regexp_groupSpecifier(state);
        else if (state.current() === 0x3F /* ? */ ) state.raise("Invalid group");
        this.regexp_disjunction(state);
        if (state.eat(0x29 /* ) */ )) {
            state.numCapturingParens += 1;
            return true;
        }
        state.raise("Unterminated group");
    }
    return false;
};
// https://www.ecma-international.org/ecma-262/8.0/#prod-annexB-ExtendedAtom
pp$8.regexp_eatExtendedAtom = function(state) {
    return state.eat(0x2E /* . */ ) || this.regexp_eatReverseSolidusAtomEscape(state) || this.regexp_eatCharacterClass(state) || this.regexp_eatUncapturingGroup(state) || this.regexp_eatCapturingGroup(state) || this.regexp_eatInvalidBracedQuantifier(state) || this.regexp_eatExtendedPatternCharacter(state);
};
// https://www.ecma-international.org/ecma-262/8.0/#prod-annexB-InvalidBracedQuantifier
pp$8.regexp_eatInvalidBracedQuantifier = function(state) {
    if (this.regexp_eatBracedQuantifier(state, true)) state.raise("Nothing to repeat");
    return false;
};
// https://www.ecma-international.org/ecma-262/8.0/#prod-SyntaxCharacter
pp$8.regexp_eatSyntaxCharacter = function(state) {
    var ch = state.current();
    if (isSyntaxCharacter(ch)) {
        state.lastIntValue = ch;
        state.advance();
        return true;
    }
    return false;
};
function isSyntaxCharacter(ch) {
    return ch === 0x24 /* $ */  || ch >= 0x28 /* ( */  && ch <= 0x2B /* + */  || ch === 0x2E /* . */  || ch === 0x3F /* ? */  || ch >= 0x5B /* [ */  && ch <= 0x5E /* ^ */  || ch >= 0x7B /* { */  && ch <= 0x7D /* } */ ;
}
// https://www.ecma-international.org/ecma-262/8.0/#prod-PatternCharacter
// But eat eager.
pp$8.regexp_eatPatternCharacters = function(state) {
    var start = state.pos;
    var ch = 0;
    while((ch = state.current()) !== -1 && !isSyntaxCharacter(ch))state.advance();
    return state.pos !== start;
};
// https://www.ecma-international.org/ecma-262/8.0/#prod-annexB-ExtendedPatternCharacter
pp$8.regexp_eatExtendedPatternCharacter = function(state) {
    var ch = state.current();
    if (ch !== -1 && ch !== 0x24 /* $ */  && !(ch >= 0x28 /* ( */  && ch <= 0x2B /* + */ ) && ch !== 0x2E /* . */  && ch !== 0x3F /* ? */  && ch !== 0x5B /* [ */  && ch !== 0x5E /* ^ */  && ch !== 0x7C /* | */ ) {
        state.advance();
        return true;
    }
    return false;
};
// GroupSpecifier ::
//   [empty]
//   `?` GroupName
pp$8.regexp_groupSpecifier = function(state) {
    if (state.eat(0x3F /* ? */ )) {
        if (this.regexp_eatGroupName(state)) {
            if (state.groupNames.indexOf(state.lastStringValue) !== -1) state.raise("Duplicate capture group name");
            state.groupNames.push(state.lastStringValue);
            return;
        }
        state.raise("Invalid group");
    }
};
// GroupName ::
//   `<` RegExpIdentifierName `>`
// Note: this updates `state.lastStringValue` property with the eaten name.
pp$8.regexp_eatGroupName = function(state) {
    state.lastStringValue = "";
    if (state.eat(0x3C /* < */ )) {
        if (this.regexp_eatRegExpIdentifierName(state) && state.eat(0x3E /* > */ )) return true;
        state.raise("Invalid capture group name");
    }
    return false;
};
// RegExpIdentifierName ::
//   RegExpIdentifierStart
//   RegExpIdentifierName RegExpIdentifierPart
// Note: this updates `state.lastStringValue` property with the eaten name.
pp$8.regexp_eatRegExpIdentifierName = function(state) {
    state.lastStringValue = "";
    if (this.regexp_eatRegExpIdentifierStart(state)) {
        state.lastStringValue += codePointToString(state.lastIntValue);
        while(this.regexp_eatRegExpIdentifierPart(state))state.lastStringValue += codePointToString(state.lastIntValue);
        return true;
    }
    return false;
};
// RegExpIdentifierStart ::
//   UnicodeIDStart
//   `$`
//   `_`
//   `\` RegExpUnicodeEscapeSequence[+U]
pp$8.regexp_eatRegExpIdentifierStart = function(state) {
    var start = state.pos;
    var forceU = this.options.ecmaVersion >= 11;
    var ch = state.current(forceU);
    state.advance(forceU);
    if (ch === 0x5C /* \ */  && this.regexp_eatRegExpUnicodeEscapeSequence(state, forceU)) ch = state.lastIntValue;
    if (isRegExpIdentifierStart(ch)) {
        state.lastIntValue = ch;
        return true;
    }
    state.pos = start;
    return false;
};
function isRegExpIdentifierStart(ch) {
    return isIdentifierStart(ch, true) || ch === 0x24 /* $ */  || ch === 0x5F /* _ */ ;
}
// RegExpIdentifierPart ::
//   UnicodeIDContinue
//   `$`
//   `_`
//   `\` RegExpUnicodeEscapeSequence[+U]
//   <ZWNJ>
//   <ZWJ>
pp$8.regexp_eatRegExpIdentifierPart = function(state) {
    var start = state.pos;
    var forceU = this.options.ecmaVersion >= 11;
    var ch = state.current(forceU);
    state.advance(forceU);
    if (ch === 0x5C /* \ */  && this.regexp_eatRegExpUnicodeEscapeSequence(state, forceU)) ch = state.lastIntValue;
    if (isRegExpIdentifierPart(ch)) {
        state.lastIntValue = ch;
        return true;
    }
    state.pos = start;
    return false;
};
function isRegExpIdentifierPart(ch) {
    return isIdentifierChar(ch, true) || ch === 0x24 /* $ */  || ch === 0x5F /* _ */  || ch === 0x200C /* <ZWNJ> */  || ch === 0x200D /* <ZWJ> */ ;
}
// https://www.ecma-international.org/ecma-262/8.0/#prod-annexB-AtomEscape
pp$8.regexp_eatAtomEscape = function(state) {
    if (this.regexp_eatBackReference(state) || this.regexp_eatCharacterClassEscape(state) || this.regexp_eatCharacterEscape(state) || state.switchN && this.regexp_eatKGroupName(state)) return true;
    if (state.switchU) {
        // Make the same message as V8.
        if (state.current() === 0x63 /* c */ ) state.raise("Invalid unicode escape");
        state.raise("Invalid escape");
    }
    return false;
};
pp$8.regexp_eatBackReference = function(state) {
    var start = state.pos;
    if (this.regexp_eatDecimalEscape(state)) {
        var n = state.lastIntValue;
        if (state.switchU) {
            // For SyntaxError in https://www.ecma-international.org/ecma-262/8.0/#sec-atomescape
            if (n > state.maxBackReference) state.maxBackReference = n;
            return true;
        }
        if (n <= state.numCapturingParens) return true;
        state.pos = start;
    }
    return false;
};
pp$8.regexp_eatKGroupName = function(state) {
    if (state.eat(0x6B /* k */ )) {
        if (this.regexp_eatGroupName(state)) {
            state.backReferenceNames.push(state.lastStringValue);
            return true;
        }
        state.raise("Invalid named reference");
    }
    return false;
};
// https://www.ecma-international.org/ecma-262/8.0/#prod-annexB-CharacterEscape
pp$8.regexp_eatCharacterEscape = function(state) {
    return this.regexp_eatControlEscape(state) || this.regexp_eatCControlLetter(state) || this.regexp_eatZero(state) || this.regexp_eatHexEscapeSequence(state) || this.regexp_eatRegExpUnicodeEscapeSequence(state, false) || !state.switchU && this.regexp_eatLegacyOctalEscapeSequence(state) || this.regexp_eatIdentityEscape(state);
};
pp$8.regexp_eatCControlLetter = function(state) {
    var start = state.pos;
    if (state.eat(0x63 /* c */ )) {
        if (this.regexp_eatControlLetter(state)) return true;
        state.pos = start;
    }
    return false;
};
pp$8.regexp_eatZero = function(state) {
    if (state.current() === 0x30 /* 0 */  && !isDecimalDigit(state.lookahead())) {
        state.lastIntValue = 0;
        state.advance();
        return true;
    }
    return false;
};
// https://www.ecma-international.org/ecma-262/8.0/#prod-ControlEscape
pp$8.regexp_eatControlEscape = function(state) {
    var ch = state.current();
    if (ch === 0x74 /* t */ ) {
        state.lastIntValue = 0x09; /* \t */ 
        state.advance();
        return true;
    }
    if (ch === 0x6E /* n */ ) {
        state.lastIntValue = 0x0A; /* \n */ 
        state.advance();
        return true;
    }
    if (ch === 0x76 /* v */ ) {
        state.lastIntValue = 0x0B; /* \v */ 
        state.advance();
        return true;
    }
    if (ch === 0x66 /* f */ ) {
        state.lastIntValue = 0x0C; /* \f */ 
        state.advance();
        return true;
    }
    if (ch === 0x72 /* r */ ) {
        state.lastIntValue = 0x0D; /* \r */ 
        state.advance();
        return true;
    }
    return false;
};
// https://www.ecma-international.org/ecma-262/8.0/#prod-ControlLetter
pp$8.regexp_eatControlLetter = function(state) {
    var ch = state.current();
    if (isControlLetter(ch)) {
        state.lastIntValue = ch % 0x20;
        state.advance();
        return true;
    }
    return false;
};
function isControlLetter(ch) {
    return ch >= 0x41 /* A */  && ch <= 0x5A /* Z */  || ch >= 0x61 /* a */  && ch <= 0x7A /* z */ ;
}
// https://www.ecma-international.org/ecma-262/8.0/#prod-RegExpUnicodeEscapeSequence
pp$8.regexp_eatRegExpUnicodeEscapeSequence = function(state, forceU) {
    if (forceU === void 0) forceU = false;
    var start = state.pos;
    var switchU = forceU || state.switchU;
    if (state.eat(0x75 /* u */ )) {
        if (this.regexp_eatFixedHexDigits(state, 4)) {
            var lead = state.lastIntValue;
            if (switchU && lead >= 0xD800 && lead <= 0xDBFF) {
                var leadSurrogateEnd = state.pos;
                if (state.eat(0x5C /* \ */ ) && state.eat(0x75 /* u */ ) && this.regexp_eatFixedHexDigits(state, 4)) {
                    var trail = state.lastIntValue;
                    if (trail >= 0xDC00 && trail <= 0xDFFF) {
                        state.lastIntValue = (lead - 0xD800) * 0x400 + (trail - 0xDC00) + 0x10000;
                        return true;
                    }
                }
                state.pos = leadSurrogateEnd;
                state.lastIntValue = lead;
            }
            return true;
        }
        if (switchU && state.eat(0x7B /* { */ ) && this.regexp_eatHexDigits(state) && state.eat(0x7D /* } */ ) && isValidUnicode(state.lastIntValue)) return true;
        if (switchU) state.raise("Invalid unicode escape");
        state.pos = start;
    }
    return false;
};
function isValidUnicode(ch) {
    return ch >= 0 && ch <= 0x10FFFF;
}
// https://www.ecma-international.org/ecma-262/8.0/#prod-annexB-IdentityEscape
pp$8.regexp_eatIdentityEscape = function(state) {
    if (state.switchU) {
        if (this.regexp_eatSyntaxCharacter(state)) return true;
        if (state.eat(0x2F /* / */ )) {
            state.lastIntValue = 0x2F; /* / */ 
            return true;
        }
        return false;
    }
    var ch = state.current();
    if (ch !== 0x63 /* c */  && (!state.switchN || ch !== 0x6B /* k */ )) {
        state.lastIntValue = ch;
        state.advance();
        return true;
    }
    return false;
};
// https://www.ecma-international.org/ecma-262/8.0/#prod-DecimalEscape
pp$8.regexp_eatDecimalEscape = function(state) {
    state.lastIntValue = 0;
    var ch = state.current();
    if (ch >= 0x31 /* 1 */  && ch <= 0x39 /* 9 */ ) {
        do {
            state.lastIntValue = 10 * state.lastIntValue + (ch - 0x30 /* 0 */ );
            state.advance();
        }while ((ch = state.current()) >= 0x30 /* 0 */  && ch <= 0x39 /* 9 */ );
        return true;
    }
    return false;
};
// https://www.ecma-international.org/ecma-262/8.0/#prod-CharacterClassEscape
pp$8.regexp_eatCharacterClassEscape = function(state) {
    var ch = state.current();
    if (isCharacterClassEscape(ch)) {
        state.lastIntValue = -1;
        state.advance();
        return true;
    }
    if (state.switchU && this.options.ecmaVersion >= 9 && (ch === 0x50 /* P */  || ch === 0x70 /* p */ )) {
        state.lastIntValue = -1;
        state.advance();
        if (state.eat(0x7B /* { */ ) && this.regexp_eatUnicodePropertyValueExpression(state) && state.eat(0x7D /* } */ )) return true;
        state.raise("Invalid property name");
    }
    return false;
};
function isCharacterClassEscape(ch) {
    return ch === 0x64 /* d */  || ch === 0x44 /* D */  || ch === 0x73 /* s */  || ch === 0x53 /* S */  || ch === 0x77 /* w */  || ch === 0x57 /* W */ ;
}
// UnicodePropertyValueExpression ::
//   UnicodePropertyName `=` UnicodePropertyValue
//   LoneUnicodePropertyNameOrValue
pp$8.regexp_eatUnicodePropertyValueExpression = function(state) {
    var start = state.pos;
    // UnicodePropertyName `=` UnicodePropertyValue
    if (this.regexp_eatUnicodePropertyName(state) && state.eat(0x3D /* = */ )) {
        var name = state.lastStringValue;
        if (this.regexp_eatUnicodePropertyValue(state)) {
            var value = state.lastStringValue;
            this.regexp_validateUnicodePropertyNameAndValue(state, name, value);
            return true;
        }
    }
    state.pos = start;
    // LoneUnicodePropertyNameOrValue
    if (this.regexp_eatLoneUnicodePropertyNameOrValue(state)) {
        var nameOrValue = state.lastStringValue;
        this.regexp_validateUnicodePropertyNameOrValue(state, nameOrValue);
        return true;
    }
    return false;
};
pp$8.regexp_validateUnicodePropertyNameAndValue = function(state, name, value) {
    if (!has(state.unicodeProperties.nonBinary, name)) state.raise("Invalid property name");
    if (!state.unicodeProperties.nonBinary[name].test(value)) state.raise("Invalid property value");
};
pp$8.regexp_validateUnicodePropertyNameOrValue = function(state, nameOrValue) {
    if (!state.unicodeProperties.binary.test(nameOrValue)) state.raise("Invalid property name");
};
// UnicodePropertyName ::
//   UnicodePropertyNameCharacters
pp$8.regexp_eatUnicodePropertyName = function(state) {
    var ch = 0;
    state.lastStringValue = "";
    while(isUnicodePropertyNameCharacter(ch = state.current())){
        state.lastStringValue += codePointToString(ch);
        state.advance();
    }
    return state.lastStringValue !== "";
};
function isUnicodePropertyNameCharacter(ch) {
    return isControlLetter(ch) || ch === 0x5F /* _ */ ;
}
// UnicodePropertyValue ::
//   UnicodePropertyValueCharacters
pp$8.regexp_eatUnicodePropertyValue = function(state) {
    var ch = 0;
    state.lastStringValue = "";
    while(isUnicodePropertyValueCharacter(ch = state.current())){
        state.lastStringValue += codePointToString(ch);
        state.advance();
    }
    return state.lastStringValue !== "";
};
function isUnicodePropertyValueCharacter(ch) {
    return isUnicodePropertyNameCharacter(ch) || isDecimalDigit(ch);
}
// LoneUnicodePropertyNameOrValue ::
//   UnicodePropertyValueCharacters
pp$8.regexp_eatLoneUnicodePropertyNameOrValue = function(state) {
    return this.regexp_eatUnicodePropertyValue(state);
};
// https://www.ecma-international.org/ecma-262/8.0/#prod-CharacterClass
pp$8.regexp_eatCharacterClass = function(state) {
    if (state.eat(0x5B /* [ */ )) {
        state.eat(0x5E /* ^ */ );
        this.regexp_classRanges(state);
        if (state.eat(0x5D /* ] */ )) return true;
        // Unreachable since it threw "unterminated regular expression" error before.
        state.raise("Unterminated character class");
    }
    return false;
};
// https://www.ecma-international.org/ecma-262/8.0/#prod-ClassRanges
// https://www.ecma-international.org/ecma-262/8.0/#prod-NonemptyClassRanges
// https://www.ecma-international.org/ecma-262/8.0/#prod-NonemptyClassRangesNoDash
pp$8.regexp_classRanges = function(state) {
    while(this.regexp_eatClassAtom(state)){
        var left = state.lastIntValue;
        if (state.eat(0x2D /* - */ ) && this.regexp_eatClassAtom(state)) {
            var right = state.lastIntValue;
            if (state.switchU && (left === -1 || right === -1)) state.raise("Invalid character class");
            if (left !== -1 && right !== -1 && left > right) state.raise("Range out of order in character class");
        }
    }
};
// https://www.ecma-international.org/ecma-262/8.0/#prod-ClassAtom
// https://www.ecma-international.org/ecma-262/8.0/#prod-ClassAtomNoDash
pp$8.regexp_eatClassAtom = function(state) {
    var start = state.pos;
    if (state.eat(0x5C /* \ */ )) {
        if (this.regexp_eatClassEscape(state)) return true;
        if (state.switchU) {
            // Make the same message as V8.
            var ch$1 = state.current();
            if (ch$1 === 0x63 /* c */  || isOctalDigit(ch$1)) state.raise("Invalid class escape");
            state.raise("Invalid escape");
        }
        state.pos = start;
    }
    var ch = state.current();
    if (ch !== 0x5D /* ] */ ) {
        state.lastIntValue = ch;
        state.advance();
        return true;
    }
    return false;
};
// https://www.ecma-international.org/ecma-262/8.0/#prod-annexB-ClassEscape
pp$8.regexp_eatClassEscape = function(state) {
    var start = state.pos;
    if (state.eat(0x62 /* b */ )) {
        state.lastIntValue = 0x08; /* <BS> */ 
        return true;
    }
    if (state.switchU && state.eat(0x2D /* - */ )) {
        state.lastIntValue = 0x2D; /* - */ 
        return true;
    }
    if (!state.switchU && state.eat(0x63 /* c */ )) {
        if (this.regexp_eatClassControlLetter(state)) return true;
        state.pos = start;
    }
    return this.regexp_eatCharacterClassEscape(state) || this.regexp_eatCharacterEscape(state);
};
// https://www.ecma-international.org/ecma-262/8.0/#prod-annexB-ClassControlLetter
pp$8.regexp_eatClassControlLetter = function(state) {
    var ch = state.current();
    if (isDecimalDigit(ch) || ch === 0x5F /* _ */ ) {
        state.lastIntValue = ch % 0x20;
        state.advance();
        return true;
    }
    return false;
};
// https://www.ecma-international.org/ecma-262/8.0/#prod-HexEscapeSequence
pp$8.regexp_eatHexEscapeSequence = function(state) {
    var start = state.pos;
    if (state.eat(0x78 /* x */ )) {
        if (this.regexp_eatFixedHexDigits(state, 2)) return true;
        if (state.switchU) state.raise("Invalid escape");
        state.pos = start;
    }
    return false;
};
// https://www.ecma-international.org/ecma-262/8.0/#prod-DecimalDigits
pp$8.regexp_eatDecimalDigits = function(state) {
    var start = state.pos;
    var ch = 0;
    state.lastIntValue = 0;
    while(isDecimalDigit(ch = state.current())){
        state.lastIntValue = 10 * state.lastIntValue + (ch - 0x30 /* 0 */ );
        state.advance();
    }
    return state.pos !== start;
};
function isDecimalDigit(ch) {
    return ch >= 0x30 /* 0 */  && ch <= 0x39 /* 9 */ ;
}
// https://www.ecma-international.org/ecma-262/8.0/#prod-HexDigits
pp$8.regexp_eatHexDigits = function(state) {
    var start = state.pos;
    var ch = 0;
    state.lastIntValue = 0;
    while(isHexDigit(ch = state.current())){
        state.lastIntValue = 16 * state.lastIntValue + hexToInt(ch);
        state.advance();
    }
    return state.pos !== start;
};
function isHexDigit(ch) {
    return ch >= 0x30 /* 0 */  && ch <= 0x39 /* 9 */  || ch >= 0x41 /* A */  && ch <= 0x46 /* F */  || ch >= 0x61 /* a */  && ch <= 0x66 /* f */ ;
}
function hexToInt(ch) {
    if (ch >= 0x41 /* A */  && ch <= 0x46 /* F */ ) return 10 + (ch - 0x41 /* A */ );
    if (ch >= 0x61 /* a */  && ch <= 0x66 /* f */ ) return 10 + (ch - 0x61 /* a */ );
    return ch - 0x30 /* 0 */ ;
}
// https://www.ecma-international.org/ecma-262/8.0/#prod-annexB-LegacyOctalEscapeSequence
// Allows only 0-377(octal) i.e. 0-255(decimal).
pp$8.regexp_eatLegacyOctalEscapeSequence = function(state) {
    if (this.regexp_eatOctalDigit(state)) {
        var n1 = state.lastIntValue;
        if (this.regexp_eatOctalDigit(state)) {
            var n2 = state.lastIntValue;
            if (n1 <= 3 && this.regexp_eatOctalDigit(state)) state.lastIntValue = n1 * 64 + n2 * 8 + state.lastIntValue;
            else state.lastIntValue = n1 * 8 + n2;
        } else state.lastIntValue = n1;
        return true;
    }
    return false;
};
// https://www.ecma-international.org/ecma-262/8.0/#prod-OctalDigit
pp$8.regexp_eatOctalDigit = function(state) {
    var ch = state.current();
    if (isOctalDigit(ch)) {
        state.lastIntValue = ch - 0x30; /* 0 */ 
        state.advance();
        return true;
    }
    state.lastIntValue = 0;
    return false;
};
function isOctalDigit(ch) {
    return ch >= 0x30 /* 0 */  && ch <= 0x37 /* 7 */ ;
}
// https://www.ecma-international.org/ecma-262/8.0/#prod-Hex4Digits
// https://www.ecma-international.org/ecma-262/8.0/#prod-HexDigit
// And HexDigit HexDigit in https://www.ecma-international.org/ecma-262/8.0/#prod-HexEscapeSequence
pp$8.regexp_eatFixedHexDigits = function(state, length) {
    var start = state.pos;
    state.lastIntValue = 0;
    for(var i = 0; i < length; ++i){
        var ch = state.current();
        if (!isHexDigit(ch)) {
            state.pos = start;
            return false;
        }
        state.lastIntValue = 16 * state.lastIntValue + hexToInt(ch);
        state.advance();
    }
    return true;
};
// Object type used to represent tokens. Note that normally, tokens
// simply exist as properties on the parser object. This is only
// used for the onToken callback and the external tokenizer.
var Token = function Token(p) {
    this.type = p.type;
    this.value = p.value;
    this.start = p.start;
    this.end = p.end;
    if (p.options.locations) this.loc = new SourceLocation(p, p.startLoc, p.endLoc);
    if (p.options.ranges) this.range = [
        p.start,
        p.end
    ];
};
// ## Tokenizer
var pp$9 = Parser.prototype;
// Move to the next token
pp$9.next = function(ignoreEscapeSequenceInKeyword) {
    if (!ignoreEscapeSequenceInKeyword && this.type.keyword && this.containsEsc) this.raiseRecoverable(this.start, "Escape sequence in keyword " + this.type.keyword);
    if (this.options.onToken) this.options.onToken(new Token(this));
    this.lastTokEnd = this.end;
    this.lastTokStart = this.start;
    this.lastTokEndLoc = this.endLoc;
    this.lastTokStartLoc = this.startLoc;
    this.nextToken();
};
pp$9.getToken = function() {
    this.next();
    return new Token(this);
};
// If we're in an ES6 environment, make parsers iterable
if (typeof Symbol !== "undefined") pp$9[Symbol.iterator] = function() {
    var this$1 = this;
    return {
        next: function() {
            var token = this$1.getToken();
            return {
                done: token.type === types.eof,
                value: token
            };
        }
    };
};
// Toggle strict mode. Re-reads the next number or string to please
// pedantic tests (`"use strict"; 010;` should fail).
pp$9.curContext = function() {
    return this.context[this.context.length - 1];
};
// Read a single token, updating the parser object's token-related
// properties.
pp$9.nextToken = function() {
    var curContext = this.curContext();
    if (!curContext || !curContext.preserveSpace) this.skipSpace();
    this.start = this.pos;
    if (this.options.locations) this.startLoc = this.curPosition();
    if (this.pos >= this.input.length) return this.finishToken(types.eof);
    if (curContext.override) return curContext.override(this);
    else this.readToken(this.fullCharCodeAtPos());
};
pp$9.readToken = function(code) {
    // Identifier or keyword. '\uXXXX' sequences are allowed in
    // identifiers, so '\' also dispatches to that.
    if (isIdentifierStart(code, this.options.ecmaVersion >= 6) || code === 92 /* '\' */ ) return this.readWord();
    return this.getTokenFromCode(code);
};
pp$9.fullCharCodeAtPos = function() {
    var code = this.input.charCodeAt(this.pos);
    if (code <= 0xd7ff || code >= 0xe000) return code;
    var next = this.input.charCodeAt(this.pos + 1);
    return (code << 10) + next - 0x35fdc00;
};
pp$9.skipBlockComment = function() {
    var startLoc = this.options.onComment && this.curPosition();
    var start = this.pos, end = this.input.indexOf("*/", this.pos += 2);
    if (end === -1) this.raise(this.pos - 2, "Unterminated comment");
    this.pos = end + 2;
    if (this.options.locations) {
        lineBreakG.lastIndex = start;
        var match;
        while((match = lineBreakG.exec(this.input)) && match.index < this.pos){
            ++this.curLine;
            this.lineStart = match.index + match[0].length;
        }
    }
    if (this.options.onComment) this.options.onComment(true, this.input.slice(start + 2, end), start, this.pos, startLoc, this.curPosition());
};
pp$9.skipLineComment = function(startSkip) {
    var start = this.pos;
    var startLoc = this.options.onComment && this.curPosition();
    var ch = this.input.charCodeAt(this.pos += startSkip);
    while(this.pos < this.input.length && !isNewLine(ch))ch = this.input.charCodeAt(++this.pos);
    if (this.options.onComment) this.options.onComment(false, this.input.slice(start + startSkip, this.pos), start, this.pos, startLoc, this.curPosition());
};
// Called at the start of the parse and after every token. Skips
// whitespace and comments, and.
pp$9.skipSpace = function() {
    loop: while(this.pos < this.input.length){
        var ch = this.input.charCodeAt(this.pos);
        switch(ch){
            case 32:
            case 160:
                ++this.pos;
                break;
            case 13:
                if (this.input.charCodeAt(this.pos + 1) === 10) ++this.pos;
            case 10:
            case 8232:
            case 8233:
                ++this.pos;
                if (this.options.locations) {
                    ++this.curLine;
                    this.lineStart = this.pos;
                }
                break;
            case 47:
                switch(this.input.charCodeAt(this.pos + 1)){
                    case 42:
                        this.skipBlockComment();
                        break;
                    case 47:
                        this.skipLineComment(2);
                        break;
                    default:
                        break loop;
                }
                break;
            default:
                if (ch > 8 && ch < 14 || ch >= 5760 && nonASCIIwhitespace.test(String.fromCharCode(ch))) ++this.pos;
                else break loop;
        }
    }
};
// Called at the end of every token. Sets `end`, `val`, and
// maintains `context` and `exprAllowed`, and skips the space after
// the token, so that the next one's `start` will point at the
// right position.
pp$9.finishToken = function(type, val) {
    this.end = this.pos;
    if (this.options.locations) this.endLoc = this.curPosition();
    var prevType = this.type;
    this.type = type;
    this.value = val;
    this.updateContext(prevType);
};
// ### Token reading
// This is the function that is called to fetch the next token. It
// is somewhat obscure, because it works in character codes rather
// than characters, and because operator parsing has been inlined
// into it.
//
// All in the name of speed.
//
pp$9.readToken_dot = function() {
    var next = this.input.charCodeAt(this.pos + 1);
    if (next >= 48 && next <= 57) return this.readNumber(true);
    var next2 = this.input.charCodeAt(this.pos + 2);
    if (this.options.ecmaVersion >= 6 && next === 46 && next2 === 46) {
        this.pos += 3;
        return this.finishToken(types.ellipsis);
    } else {
        ++this.pos;
        return this.finishToken(types.dot);
    }
};
pp$9.readToken_slash = function() {
    var next = this.input.charCodeAt(this.pos + 1);
    if (this.exprAllowed) {
        ++this.pos;
        return this.readRegexp();
    }
    if (next === 61) return this.finishOp(types.assign, 2);
    return this.finishOp(types.slash, 1);
};
pp$9.readToken_mult_modulo_exp = function(code) {
    var next = this.input.charCodeAt(this.pos + 1);
    var size = 1;
    var tokentype = code === 42 ? types.star : types.modulo;
    // exponentiation operator ** and **=
    if (this.options.ecmaVersion >= 7 && code === 42 && next === 42) {
        ++size;
        tokentype = types.starstar;
        next = this.input.charCodeAt(this.pos + 2);
    }
    if (next === 61) return this.finishOp(types.assign, size + 1);
    return this.finishOp(tokentype, size);
};
pp$9.readToken_pipe_amp = function(code) {
    var next = this.input.charCodeAt(this.pos + 1);
    if (next === code) {
        if (this.options.ecmaVersion >= 12) {
            var next2 = this.input.charCodeAt(this.pos + 2);
            if (next2 === 61) return this.finishOp(types.assign, 3);
        }
        return this.finishOp(code === 124 ? types.logicalOR : types.logicalAND, 2);
    }
    if (next === 61) return this.finishOp(types.assign, 2);
    return this.finishOp(code === 124 ? types.bitwiseOR : types.bitwiseAND, 1);
};
pp$9.readToken_caret = function() {
    var next = this.input.charCodeAt(this.pos + 1);
    if (next === 61) return this.finishOp(types.assign, 2);
    return this.finishOp(types.bitwiseXOR, 1);
};
pp$9.readToken_plus_min = function(code) {
    var next = this.input.charCodeAt(this.pos + 1);
    if (next === code) {
        if (next === 45 && !this.inModule && this.input.charCodeAt(this.pos + 2) === 62 && (this.lastTokEnd === 0 || lineBreak.test(this.input.slice(this.lastTokEnd, this.pos)))) {
            // A `-->` line comment
            this.skipLineComment(3);
            this.skipSpace();
            return this.nextToken();
        }
        return this.finishOp(types.incDec, 2);
    }
    if (next === 61) return this.finishOp(types.assign, 2);
    return this.finishOp(types.plusMin, 1);
};
pp$9.readToken_lt_gt = function(code) {
    var next = this.input.charCodeAt(this.pos + 1);
    var size = 1;
    if (next === code) {
        size = code === 62 && this.input.charCodeAt(this.pos + 2) === 62 ? 3 : 2;
        if (this.input.charCodeAt(this.pos + size) === 61) return this.finishOp(types.assign, size + 1);
        return this.finishOp(types.bitShift, size);
    }
    if (next === 33 && code === 60 && !this.inModule && this.input.charCodeAt(this.pos + 2) === 45 && this.input.charCodeAt(this.pos + 3) === 45) {
        // `<!--`, an XML-style comment that should be interpreted as a line comment
        this.skipLineComment(4);
        this.skipSpace();
        return this.nextToken();
    }
    if (next === 61) size = 2;
    return this.finishOp(types.relational, size);
};
pp$9.readToken_eq_excl = function(code) {
    var next = this.input.charCodeAt(this.pos + 1);
    if (next === 61) return this.finishOp(types.equality, this.input.charCodeAt(this.pos + 2) === 61 ? 3 : 2);
    if (code === 61 && next === 62 && this.options.ecmaVersion >= 6) {
        this.pos += 2;
        return this.finishToken(types.arrow);
    }
    return this.finishOp(code === 61 ? types.eq : types.prefix, 1);
};
pp$9.readToken_question = function() {
    var ecmaVersion = this.options.ecmaVersion;
    if (ecmaVersion >= 11) {
        var next = this.input.charCodeAt(this.pos + 1);
        if (next === 46) {
            var next2 = this.input.charCodeAt(this.pos + 2);
            if (next2 < 48 || next2 > 57) return this.finishOp(types.questionDot, 2);
        }
        if (next === 63) {
            if (ecmaVersion >= 12) {
                var next2$1 = this.input.charCodeAt(this.pos + 2);
                if (next2$1 === 61) return this.finishOp(types.assign, 3);
            }
            return this.finishOp(types.coalesce, 2);
        }
    }
    return this.finishOp(types.question, 1);
};
pp$9.getTokenFromCode = function(code) {
    switch(code){
        // The interpretation of a dot depends on whether it is followed
        // by a digit or another two dots.
        case 46:
            return this.readToken_dot();
        // Punctuation tokens.
        case 40:
            ++this.pos;
            return this.finishToken(types.parenL);
        case 41:
            ++this.pos;
            return this.finishToken(types.parenR);
        case 59:
            ++this.pos;
            return this.finishToken(types.semi);
        case 44:
            ++this.pos;
            return this.finishToken(types.comma);
        case 91:
            ++this.pos;
            return this.finishToken(types.bracketL);
        case 93:
            ++this.pos;
            return this.finishToken(types.bracketR);
        case 123:
            ++this.pos;
            return this.finishToken(types.braceL);
        case 125:
            ++this.pos;
            return this.finishToken(types.braceR);
        case 58:
            ++this.pos;
            return this.finishToken(types.colon);
        case 96:
            if (this.options.ecmaVersion < 6) break;
            ++this.pos;
            return this.finishToken(types.backQuote);
        case 48:
            var next = this.input.charCodeAt(this.pos + 1);
            if (next === 120 || next === 88) return this.readRadixNumber(16);
             // '0x', '0X' - hex number
            if (this.options.ecmaVersion >= 6) {
                if (next === 111 || next === 79) return this.readRadixNumber(8);
                 // '0o', '0O' - octal number
                if (next === 98 || next === 66) return this.readRadixNumber(2);
                 // '0b', '0B' - binary number
            }
        // Anything else beginning with a digit is an integer, octal
        // number, or float.
        case 49:
        case 50:
        case 51:
        case 52:
        case 53:
        case 54:
        case 55:
        case 56:
        case 57:
            return this.readNumber(false);
        // Quotes produce strings.
        case 34:
        case 39:
            return this.readString(code);
        // Operators are parsed inline in tiny state machines. '=' (61) is
        // often referred to. `finishOp` simply skips the amount of
        // characters it is given as second argument, and returns a token
        // of the type given by its first argument.
        case 47:
            return this.readToken_slash();
        case 37:
        case 42:
            return this.readToken_mult_modulo_exp(code);
        case 124:
        case 38:
            return this.readToken_pipe_amp(code);
        case 94:
            return this.readToken_caret();
        case 43:
        case 45:
            return this.readToken_plus_min(code);
        case 60:
        case 62:
            return this.readToken_lt_gt(code);
        case 61:
        case 33:
            return this.readToken_eq_excl(code);
        case 63:
            return this.readToken_question();
        case 126:
            return this.finishOp(types.prefix, 1);
    }
    this.raise(this.pos, "Unexpected character '" + codePointToString$1(code) + "'");
};
pp$9.finishOp = function(type, size) {
    var str = this.input.slice(this.pos, this.pos + size);
    this.pos += size;
    return this.finishToken(type, str);
};
pp$9.readRegexp = function() {
    var escaped, inClass, start = this.pos;
    for(;;){
        if (this.pos >= this.input.length) this.raise(start, "Unterminated regular expression");
        var ch = this.input.charAt(this.pos);
        if (lineBreak.test(ch)) this.raise(start, "Unterminated regular expression");
        if (!escaped) {
            if (ch === "[") inClass = true;
            else if (ch === "]" && inClass) inClass = false;
            else if (ch === "/" && !inClass) break;
            escaped = ch === "\\";
        } else escaped = false;
        ++this.pos;
    }
    var pattern = this.input.slice(start, this.pos);
    ++this.pos;
    var flagsStart = this.pos;
    var flags = this.readWord1();
    if (this.containsEsc) this.unexpected(flagsStart);
    // Validate pattern
    var state = this.regexpState || (this.regexpState = new RegExpValidationState(this));
    state.reset(start, pattern, flags);
    this.validateRegExpFlags(state);
    this.validateRegExpPattern(state);
    // Create Literal#value property value.
    var value = null;
    try {
        value = new RegExp(pattern, flags);
    } catch (e) {
    // ESTree requires null if it failed to instantiate RegExp object.
    // https://github.com/estree/estree/blob/a27003adf4fd7bfad44de9cef372a2eacd527b1c/es5.md#regexpliteral
    }
    return this.finishToken(types.regexp, {
        pattern: pattern,
        flags: flags,
        value: value
    });
};
// Read an integer in the given radix. Return null if zero digits
// were read, the integer value otherwise. When `len` is given, this
// will return `null` unless the integer has exactly `len` digits.
pp$9.readInt = function(radix, len, maybeLegacyOctalNumericLiteral) {
    // `len` is used for character escape sequences. In that case, disallow separators.
    var allowSeparators = this.options.ecmaVersion >= 12 && len === undefined;
    // `maybeLegacyOctalNumericLiteral` is true if it doesn't have prefix (0x,0o,0b)
    // and isn't fraction part nor exponent part. In that case, if the first digit
    // is zero then disallow separators.
    var isLegacyOctalNumericLiteral = maybeLegacyOctalNumericLiteral && this.input.charCodeAt(this.pos) === 48;
    var start = this.pos, total = 0, lastCode = 0;
    for(var i = 0, e = len == null ? Infinity : len; i < e; ++i, ++this.pos){
        var code = this.input.charCodeAt(this.pos), val = void 0;
        if (allowSeparators && code === 95) {
            if (isLegacyOctalNumericLiteral) this.raiseRecoverable(this.pos, "Numeric separator is not allowed in legacy octal numeric literals");
            if (lastCode === 95) this.raiseRecoverable(this.pos, "Numeric separator must be exactly one underscore");
            if (i === 0) this.raiseRecoverable(this.pos, "Numeric separator is not allowed at the first of digits");
            lastCode = code;
            continue;
        }
        if (code >= 97) val = code - 97 + 10;
        else if (code >= 65) val = code - 65 + 10;
        else if (code >= 48 && code <= 57) val = code - 48;
        else val = Infinity;
        if (val >= radix) break;
        lastCode = code;
        total = total * radix + val;
    }
    if (allowSeparators && lastCode === 95) this.raiseRecoverable(this.pos - 1, "Numeric separator is not allowed at the last of digits");
    if (this.pos === start || len != null && this.pos - start !== len) return null;
    return total;
};
function stringToNumber(str, isLegacyOctalNumericLiteral) {
    if (isLegacyOctalNumericLiteral) return parseInt(str, 8);
    // `parseFloat(value)` stops parsing at the first numeric separator then returns a wrong value.
    return parseFloat(str.replace(/_/g, ""));
}
function stringToBigInt(str) {
    if (typeof BigInt !== "function") return null;
    // `BigInt(value)` throws syntax error if the string contains numeric separators.
    return BigInt(str.replace(/_/g, ""));
}
pp$9.readRadixNumber = function(radix) {
    var start = this.pos;
    this.pos += 2; // 0x
    var val = this.readInt(radix);
    if (val == null) this.raise(this.start + 2, "Expected number in radix " + radix);
    if (this.options.ecmaVersion >= 11 && this.input.charCodeAt(this.pos) === 110) {
        val = stringToBigInt(this.input.slice(start, this.pos));
        ++this.pos;
    } else if (isIdentifierStart(this.fullCharCodeAtPos())) this.raise(this.pos, "Identifier directly after number");
    return this.finishToken(types.num, val);
};
// Read an integer, octal integer, or floating-point number.
pp$9.readNumber = function(startsWithDot) {
    var start = this.pos;
    if (!startsWithDot && this.readInt(10, undefined, true) === null) this.raise(start, "Invalid number");
    var octal = this.pos - start >= 2 && this.input.charCodeAt(start) === 48;
    if (octal && this.strict) this.raise(start, "Invalid number");
    var next = this.input.charCodeAt(this.pos);
    if (!octal && !startsWithDot && this.options.ecmaVersion >= 11 && next === 110) {
        var val$1 = stringToBigInt(this.input.slice(start, this.pos));
        ++this.pos;
        if (isIdentifierStart(this.fullCharCodeAtPos())) this.raise(this.pos, "Identifier directly after number");
        return this.finishToken(types.num, val$1);
    }
    if (octal && /[89]/.test(this.input.slice(start, this.pos))) octal = false;
    if (next === 46 && !octal) {
        ++this.pos;
        this.readInt(10);
        next = this.input.charCodeAt(this.pos);
    }
    if ((next === 69 || next === 101) && !octal) {
        next = this.input.charCodeAt(++this.pos);
        if (next === 43 || next === 45) ++this.pos;
         // '+-'
        if (this.readInt(10) === null) this.raise(start, "Invalid number");
    }
    if (isIdentifierStart(this.fullCharCodeAtPos())) this.raise(this.pos, "Identifier directly after number");
    var val = stringToNumber(this.input.slice(start, this.pos), octal);
    return this.finishToken(types.num, val);
};
// Read a string value, interpreting backslash-escapes.
pp$9.readCodePoint = function() {
    var ch = this.input.charCodeAt(this.pos), code;
    if (ch === 123) {
        if (this.options.ecmaVersion < 6) this.unexpected();
        var codePos = ++this.pos;
        code = this.readHexChar(this.input.indexOf("}", this.pos) - this.pos);
        ++this.pos;
        if (code > 0x10FFFF) this.invalidStringToken(codePos, "Code point out of bounds");
    } else code = this.readHexChar(4);
    return code;
};
function codePointToString$1(code) {
    // UTF-16 Decoding
    if (code <= 0xFFFF) return String.fromCharCode(code);
    code -= 0x10000;
    return String.fromCharCode((code >> 10) + 0xD800, (code & 1023) + 0xDC00);
}
pp$9.readString = function(quote) {
    var out = "", chunkStart = ++this.pos;
    for(;;){
        if (this.pos >= this.input.length) this.raise(this.start, "Unterminated string constant");
        var ch = this.input.charCodeAt(this.pos);
        if (ch === quote) break;
        if (ch === 92) {
            out += this.input.slice(chunkStart, this.pos);
            out += this.readEscapedChar(false);
            chunkStart = this.pos;
        } else {
            if (isNewLine(ch, this.options.ecmaVersion >= 10)) this.raise(this.start, "Unterminated string constant");
            ++this.pos;
        }
    }
    out += this.input.slice(chunkStart, this.pos++);
    return this.finishToken(types.string, out);
};
// Reads template string tokens.
var INVALID_TEMPLATE_ESCAPE_ERROR = {};
pp$9.tryReadTemplateToken = function() {
    this.inTemplateElement = true;
    try {
        this.readTmplToken();
    } catch (err) {
        if (err === INVALID_TEMPLATE_ESCAPE_ERROR) this.readInvalidTemplateToken();
        else throw err;
    }
    this.inTemplateElement = false;
};
pp$9.invalidStringToken = function(position, message) {
    if (this.inTemplateElement && this.options.ecmaVersion >= 9) throw INVALID_TEMPLATE_ESCAPE_ERROR;
    else this.raise(position, message);
};
pp$9.readTmplToken = function() {
    var out = "", chunkStart = this.pos;
    for(;;){
        if (this.pos >= this.input.length) this.raise(this.start, "Unterminated template");
        var ch = this.input.charCodeAt(this.pos);
        if (ch === 96 || ch === 36 && this.input.charCodeAt(this.pos + 1) === 123) {
            if (this.pos === this.start && (this.type === types.template || this.type === types.invalidTemplate)) {
                if (ch === 36) {
                    this.pos += 2;
                    return this.finishToken(types.dollarBraceL);
                } else {
                    ++this.pos;
                    return this.finishToken(types.backQuote);
                }
            }
            out += this.input.slice(chunkStart, this.pos);
            return this.finishToken(types.template, out);
        }
        if (ch === 92) {
            out += this.input.slice(chunkStart, this.pos);
            out += this.readEscapedChar(true);
            chunkStart = this.pos;
        } else if (isNewLine(ch)) {
            out += this.input.slice(chunkStart, this.pos);
            ++this.pos;
            switch(ch){
                case 13:
                    if (this.input.charCodeAt(this.pos) === 10) ++this.pos;
                case 10:
                    out += "\n";
                    break;
                default:
                    out += String.fromCharCode(ch);
                    break;
            }
            if (this.options.locations) {
                ++this.curLine;
                this.lineStart = this.pos;
            }
            chunkStart = this.pos;
        } else ++this.pos;
    }
};
// Reads a template token to search for the end, without validating any escape sequences
pp$9.readInvalidTemplateToken = function() {
    for(; this.pos < this.input.length; this.pos++)switch(this.input[this.pos]){
        case "\\":
            ++this.pos;
            break;
        case "$":
            if (this.input[this.pos + 1] !== "{") break;
        // falls through
        case "`":
            return this.finishToken(types.invalidTemplate, this.input.slice(this.start, this.pos));
    }
    this.raise(this.start, "Unterminated template");
};
// Used to read escaped characters
pp$9.readEscapedChar = function(inTemplate) {
    var ch = this.input.charCodeAt(++this.pos);
    ++this.pos;
    switch(ch){
        case 110:
            return "\n" // 'n' -> '\n'
            ;
        case 114:
            return "\r" // 'r' -> '\r'
            ;
        case 120:
            return String.fromCharCode(this.readHexChar(2)) // 'x'
            ;
        case 117:
            return codePointToString$1(this.readCodePoint()) // 'u'
            ;
        case 116:
            return "	" // 't' -> '\t'
            ;
        case 98:
            return "\b" // 'b' -> '\b'
            ;
        case 118:
            return "\v" // 'v' -> '\u000b'
            ;
        case 102:
            return "\f" // 'f' -> '\f'
            ;
        case 13:
            if (this.input.charCodeAt(this.pos) === 10) ++this.pos;
             // '\r\n'
        case 10:
            if (this.options.locations) {
                this.lineStart = this.pos;
                ++this.curLine;
            }
            return "";
        case 56:
        case 57:
            if (inTemplate) {
                var codePos = this.pos - 1;
                this.invalidStringToken(codePos, "Invalid escape sequence in template string");
                return null;
            }
        default:
            if (ch >= 48 && ch <= 55) {
                var octalStr = this.input.substr(this.pos - 1, 3).match(/^[0-7]+/)[0];
                var octal = parseInt(octalStr, 8);
                if (octal > 255) {
                    octalStr = octalStr.slice(0, -1);
                    octal = parseInt(octalStr, 8);
                }
                this.pos += octalStr.length - 1;
                ch = this.input.charCodeAt(this.pos);
                if ((octalStr !== "0" || ch === 56 || ch === 57) && (this.strict || inTemplate)) this.invalidStringToken(this.pos - 1 - octalStr.length, inTemplate ? "Octal literal in template string" : "Octal literal in strict mode");
                return String.fromCharCode(octal);
            }
            if (isNewLine(ch)) // Unicode new line characters after \ get removed from output in both
            // template literals and strings
            return "";
            return String.fromCharCode(ch);
    }
};
// Used to read character escape sequences ('\x', '\u', '\U').
pp$9.readHexChar = function(len) {
    var codePos = this.pos;
    var n = this.readInt(16, len);
    if (n === null) this.invalidStringToken(codePos, "Bad character escape sequence");
    return n;
};
// Read an identifier, and return it as a string. Sets `this.containsEsc`
// to whether the word contained a '\u' escape.
//
// Incrementally adds only escaped chars, adding other chunks as-is
// as a micro-optimization.
pp$9.readWord1 = function() {
    this.containsEsc = false;
    var word = "", first = true, chunkStart = this.pos;
    var astral = this.options.ecmaVersion >= 6;
    while(this.pos < this.input.length){
        var ch = this.fullCharCodeAtPos();
        if (isIdentifierChar(ch, astral)) this.pos += ch <= 0xffff ? 1 : 2;
        else if (ch === 92) {
            this.containsEsc = true;
            word += this.input.slice(chunkStart, this.pos);
            var escStart = this.pos;
            if (this.input.charCodeAt(++this.pos) !== 117) this.invalidStringToken(this.pos, "Expecting Unicode escape sequence \\uXXXX");
            ++this.pos;
            var esc = this.readCodePoint();
            if (!(first ? isIdentifierStart : isIdentifierChar)(esc, astral)) this.invalidStringToken(escStart, "Invalid Unicode escape");
            word += codePointToString$1(esc);
            chunkStart = this.pos;
        } else break;
        first = false;
    }
    return word + this.input.slice(chunkStart, this.pos);
};
// Read an identifier or keyword token. Will check for reserved
// words when necessary.
pp$9.readWord = function() {
    var word = this.readWord1();
    var type = types.name;
    if (this.keywords.test(word)) type = keywords$1[word];
    return this.finishToken(type, word);
};
// Acorn is a tiny, fast JavaScript parser written in JavaScript.
var version = "7.4.1";
Parser.acorn = {
    Parser: Parser,
    version: version,
    defaultOptions: defaultOptions,
    Position: Position,
    SourceLocation: SourceLocation,
    getLineInfo: getLineInfo,
    Node: Node,
    TokenType: TokenType,
    tokTypes: types,
    keywordTypes: keywords$1,
    TokContext: TokContext,
    tokContexts: types$1,
    isIdentifierChar: isIdentifierChar,
    isIdentifierStart: isIdentifierStart,
    Token: Token,
    isNewLine: isNewLine,
    lineBreak: lineBreak,
    lineBreakG: lineBreakG,
    nonASCIIwhitespace: nonASCIIwhitespace
};
// The main exported interface (under `self.acorn` when in the
// browser) is a `parse` function that takes a code string and
// returns an abstract syntax tree as specified by [Mozilla parser
// API][api].
//
// [api]: https://developer.mozilla.org/en-US/docs/SpiderMonkey/Parser_API
function parse(input, options) {
    return Parser.parse(input, options);
}
// This function tries to parse a single expression at a given
// offset in a string. Useful for parsing mixed-language formats
// that embed JavaScript expressions.
function parseExpressionAt(input, pos, options) {
    return Parser.parseExpressionAt(input, pos, options);
}
// Acorn is organized as a tokenizer and a recursive-descent parser.
// The `tokenizer` export provides an interface to the tokenizer.
function tokenizer(input, options) {
    return Parser.tokenizer(input, options);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"fbU2z":[function(require,module,exports) {
"use strict";
const XHTMLEntities = require("b4fe035b49712736");
const hexNumber = /^[\da-fA-F]+$/;
const decimalNumber = /^\d+$/;
// The map to `acorn-jsx` tokens from `acorn` namespace objects.
const acornJsxMap = new WeakMap();
// Get the original tokens for the given `acorn` namespace object.
function getJsxTokens(acorn) {
    acorn = acorn.Parser.acorn || acorn;
    let acornJsx = acornJsxMap.get(acorn);
    if (!acornJsx) {
        const tt = acorn.tokTypes;
        const TokContext = acorn.TokContext;
        const TokenType = acorn.TokenType;
        const tc_oTag = new TokContext("<tag", false);
        const tc_cTag = new TokContext("</tag", false);
        const tc_expr = new TokContext("<tag>...</tag>", true, true);
        const tokContexts = {
            tc_oTag: tc_oTag,
            tc_cTag: tc_cTag,
            tc_expr: tc_expr
        };
        const tokTypes = {
            jsxName: new TokenType("jsxName"),
            jsxText: new TokenType("jsxText", {
                beforeExpr: true
            }),
            jsxTagStart: new TokenType("jsxTagStart", {
                startsExpr: true
            }),
            jsxTagEnd: new TokenType("jsxTagEnd")
        };
        tokTypes.jsxTagStart.updateContext = function() {
            this.context.push(tc_expr); // treat as beginning of JSX expression
            this.context.push(tc_oTag); // start opening tag context
            this.exprAllowed = false;
        };
        tokTypes.jsxTagEnd.updateContext = function(prevType) {
            let out = this.context.pop();
            if (out === tc_oTag && prevType === tt.slash || out === tc_cTag) {
                this.context.pop();
                this.exprAllowed = this.curContext() === tc_expr;
            } else this.exprAllowed = true;
        };
        acornJsx = {
            tokContexts: tokContexts,
            tokTypes: tokTypes
        };
        acornJsxMap.set(acorn, acornJsx);
    }
    return acornJsx;
}
// Transforms JSX element name to string.
function getQualifiedJSXName(object) {
    if (!object) return object;
    if (object.type === "JSXIdentifier") return object.name;
    if (object.type === "JSXNamespacedName") return object.namespace.name + ":" + object.name.name;
    if (object.type === "JSXMemberExpression") return getQualifiedJSXName(object.object) + "." + getQualifiedJSXName(object.property);
}
module.exports = function(options) {
    options = options || {};
    return function(Parser) {
        return plugin({
            allowNamespaces: options.allowNamespaces !== false,
            allowNamespacedObjects: !!options.allowNamespacedObjects
        }, Parser);
    };
};
// This is `tokTypes` of the peer dep.
// This can be different instances from the actual `tokTypes` this plugin uses.
Object.defineProperty(module.exports, "tokTypes", {
    get: function get_tokTypes() {
        return getJsxTokens(require("441cb38ec329228d")).tokTypes;
    },
    configurable: true,
    enumerable: true
});
function plugin(options, Parser) {
    const acorn = Parser.acorn || require("441cb38ec329228d");
    const acornJsx = getJsxTokens(acorn);
    const tt = acorn.tokTypes;
    const tok = acornJsx.tokTypes;
    const tokContexts = acorn.tokContexts;
    const tc_oTag = acornJsx.tokContexts.tc_oTag;
    const tc_cTag = acornJsx.tokContexts.tc_cTag;
    const tc_expr = acornJsx.tokContexts.tc_expr;
    const isNewLine = acorn.isNewLine;
    const isIdentifierStart = acorn.isIdentifierStart;
    const isIdentifierChar = acorn.isIdentifierChar;
    return class extends Parser {
        // Expose actual `tokTypes` and `tokContexts` to other plugins.
        static get acornJsx() {
            return acornJsx;
        }
        // Reads inline JSX contents token.
        jsx_readToken() {
            let out = "", chunkStart = this.pos;
            for(;;){
                if (this.pos >= this.input.length) this.raise(this.start, "Unterminated JSX contents");
                let ch = this.input.charCodeAt(this.pos);
                switch(ch){
                    case 60:
                    case 123:
                        if (this.pos === this.start) {
                            if (ch === 60 && this.exprAllowed) {
                                ++this.pos;
                                return this.finishToken(tok.jsxTagStart);
                            }
                            return this.getTokenFromCode(ch);
                        }
                        out += this.input.slice(chunkStart, this.pos);
                        return this.finishToken(tok.jsxText, out);
                    case 38:
                        out += this.input.slice(chunkStart, this.pos);
                        out += this.jsx_readEntity();
                        chunkStart = this.pos;
                        break;
                    case 62:
                    case 125:
                        this.raise(this.pos, "Unexpected token `" + this.input[this.pos] + "`. Did you mean `" + (ch === 62 ? "&gt;" : "&rbrace;") + "` or " + '`{"' + this.input[this.pos] + '"}' + "`?");
                    default:
                        if (isNewLine(ch)) {
                            out += this.input.slice(chunkStart, this.pos);
                            out += this.jsx_readNewLine(true);
                            chunkStart = this.pos;
                        } else ++this.pos;
                }
            }
        }
        jsx_readNewLine(normalizeCRLF) {
            let ch = this.input.charCodeAt(this.pos);
            let out;
            ++this.pos;
            if (ch === 13 && this.input.charCodeAt(this.pos) === 10) {
                ++this.pos;
                out = normalizeCRLF ? "\n" : "\r\n";
            } else out = String.fromCharCode(ch);
            if (this.options.locations) {
                ++this.curLine;
                this.lineStart = this.pos;
            }
            return out;
        }
        jsx_readString(quote) {
            let out = "", chunkStart = ++this.pos;
            for(;;){
                if (this.pos >= this.input.length) this.raise(this.start, "Unterminated string constant");
                let ch = this.input.charCodeAt(this.pos);
                if (ch === quote) break;
                if (ch === 38) {
                    out += this.input.slice(chunkStart, this.pos);
                    out += this.jsx_readEntity();
                    chunkStart = this.pos;
                } else if (isNewLine(ch)) {
                    out += this.input.slice(chunkStart, this.pos);
                    out += this.jsx_readNewLine(false);
                    chunkStart = this.pos;
                } else ++this.pos;
            }
            out += this.input.slice(chunkStart, this.pos++);
            return this.finishToken(tt.string, out);
        }
        jsx_readEntity() {
            let str = "", count = 0, entity;
            let ch = this.input[this.pos];
            if (ch !== "&") this.raise(this.pos, "Entity must start with an ampersand");
            let startPos = ++this.pos;
            while(this.pos < this.input.length && count++ < 10){
                ch = this.input[this.pos++];
                if (ch === ";") {
                    if (str[0] === "#") {
                        if (str[1] === "x") {
                            str = str.substr(2);
                            if (hexNumber.test(str)) entity = String.fromCharCode(parseInt(str, 16));
                        } else {
                            str = str.substr(1);
                            if (decimalNumber.test(str)) entity = String.fromCharCode(parseInt(str, 10));
                        }
                    } else entity = XHTMLEntities[str];
                    break;
                }
                str += ch;
            }
            if (!entity) {
                this.pos = startPos;
                return "&";
            }
            return entity;
        }
        // Read a JSX identifier (valid tag or attribute name).
        //
        // Optimized version since JSX identifiers can't contain
        // escape characters and so can be read as single slice.
        // Also assumes that first character was already checked
        // by isIdentifierStart in readToken.
        jsx_readWord() {
            let ch, start = this.pos;
            do ch = this.input.charCodeAt(++this.pos);
            while (isIdentifierChar(ch) || ch === 45); // '-'
            return this.finishToken(tok.jsxName, this.input.slice(start, this.pos));
        }
        // Parse next token as JSX identifier
        jsx_parseIdentifier() {
            let node = this.startNode();
            if (this.type === tok.jsxName) node.name = this.value;
            else if (this.type.keyword) node.name = this.type.keyword;
            else this.unexpected();
            this.next();
            return this.finishNode(node, "JSXIdentifier");
        }
        // Parse namespaced identifier.
        jsx_parseNamespacedName() {
            let startPos = this.start, startLoc = this.startLoc;
            let name = this.jsx_parseIdentifier();
            if (!options.allowNamespaces || !this.eat(tt.colon)) return name;
            var node = this.startNodeAt(startPos, startLoc);
            node.namespace = name;
            node.name = this.jsx_parseIdentifier();
            return this.finishNode(node, "JSXNamespacedName");
        }
        // Parses element name in any form - namespaced, member
        // or single identifier.
        jsx_parseElementName() {
            if (this.type === tok.jsxTagEnd) return "";
            let startPos = this.start, startLoc = this.startLoc;
            let node = this.jsx_parseNamespacedName();
            if (this.type === tt.dot && node.type === "JSXNamespacedName" && !options.allowNamespacedObjects) this.unexpected();
            while(this.eat(tt.dot)){
                let newNode = this.startNodeAt(startPos, startLoc);
                newNode.object = node;
                newNode.property = this.jsx_parseIdentifier();
                node = this.finishNode(newNode, "JSXMemberExpression");
            }
            return node;
        }
        // Parses any type of JSX attribute value.
        jsx_parseAttributeValue() {
            switch(this.type){
                case tt.braceL:
                    let node = this.jsx_parseExpressionContainer();
                    if (node.expression.type === "JSXEmptyExpression") this.raise(node.start, "JSX attributes must only be assigned a non-empty expression");
                    return node;
                case tok.jsxTagStart:
                case tt.string:
                    return this.parseExprAtom();
                default:
                    this.raise(this.start, "JSX value should be either an expression or a quoted JSX text");
            }
        }
        // JSXEmptyExpression is unique type since it doesn't actually parse anything,
        // and so it should start at the end of last read token (left brace) and finish
        // at the beginning of the next one (right brace).
        jsx_parseEmptyExpression() {
            let node = this.startNodeAt(this.lastTokEnd, this.lastTokEndLoc);
            return this.finishNodeAt(node, "JSXEmptyExpression", this.start, this.startLoc);
        }
        // Parses JSX expression enclosed into curly brackets.
        jsx_parseExpressionContainer() {
            let node = this.startNode();
            this.next();
            node.expression = this.type === tt.braceR ? this.jsx_parseEmptyExpression() : this.parseExpression();
            this.expect(tt.braceR);
            return this.finishNode(node, "JSXExpressionContainer");
        }
        // Parses following JSX attribute name-value pair.
        jsx_parseAttribute() {
            let node = this.startNode();
            if (this.eat(tt.braceL)) {
                this.expect(tt.ellipsis);
                node.argument = this.parseMaybeAssign();
                this.expect(tt.braceR);
                return this.finishNode(node, "JSXSpreadAttribute");
            }
            node.name = this.jsx_parseNamespacedName();
            node.value = this.eat(tt.eq) ? this.jsx_parseAttributeValue() : null;
            return this.finishNode(node, "JSXAttribute");
        }
        // Parses JSX opening tag starting after '<'.
        jsx_parseOpeningElementAt(startPos, startLoc) {
            let node = this.startNodeAt(startPos, startLoc);
            node.attributes = [];
            let nodeName = this.jsx_parseElementName();
            if (nodeName) node.name = nodeName;
            while(this.type !== tt.slash && this.type !== tok.jsxTagEnd)node.attributes.push(this.jsx_parseAttribute());
            node.selfClosing = this.eat(tt.slash);
            this.expect(tok.jsxTagEnd);
            return this.finishNode(node, nodeName ? "JSXOpeningElement" : "JSXOpeningFragment");
        }
        // Parses JSX closing tag starting after '</'.
        jsx_parseClosingElementAt(startPos, startLoc) {
            let node = this.startNodeAt(startPos, startLoc);
            let nodeName = this.jsx_parseElementName();
            if (nodeName) node.name = nodeName;
            this.expect(tok.jsxTagEnd);
            return this.finishNode(node, nodeName ? "JSXClosingElement" : "JSXClosingFragment");
        }
        // Parses entire JSX element, including it's opening tag
        // (starting after '<'), attributes, contents and closing tag.
        jsx_parseElementAt(startPos, startLoc) {
            let node = this.startNodeAt(startPos, startLoc);
            let children = [];
            let openingElement = this.jsx_parseOpeningElementAt(startPos, startLoc);
            let closingElement = null;
            if (!openingElement.selfClosing) {
                contents: for(;;)switch(this.type){
                    case tok.jsxTagStart:
                        startPos = this.start;
                        startLoc = this.startLoc;
                        this.next();
                        if (this.eat(tt.slash)) {
                            closingElement = this.jsx_parseClosingElementAt(startPos, startLoc);
                            break contents;
                        }
                        children.push(this.jsx_parseElementAt(startPos, startLoc));
                        break;
                    case tok.jsxText:
                        children.push(this.parseExprAtom());
                        break;
                    case tt.braceL:
                        children.push(this.jsx_parseExpressionContainer());
                        break;
                    default:
                        this.unexpected();
                }
                if (getQualifiedJSXName(closingElement.name) !== getQualifiedJSXName(openingElement.name)) this.raise(closingElement.start, "Expected corresponding JSX closing tag for <" + getQualifiedJSXName(openingElement.name) + ">");
            }
            let fragmentOrElement = openingElement.name ? "Element" : "Fragment";
            node["opening" + fragmentOrElement] = openingElement;
            node["closing" + fragmentOrElement] = closingElement;
            node.children = children;
            if (this.type === tt.relational && this.value === "<") this.raise(this.start, "Adjacent JSX elements must be wrapped in an enclosing tag");
            return this.finishNode(node, "JSX" + fragmentOrElement);
        }
        // Parse JSX text
        jsx_parseText() {
            let node = this.parseLiteral(this.value);
            node.type = "JSXText";
            return node;
        }
        // Parses entire JSX element from current position.
        jsx_parseElement() {
            let startPos = this.start, startLoc = this.startLoc;
            this.next();
            return this.jsx_parseElementAt(startPos, startLoc);
        }
        parseExprAtom(refShortHandDefaultPos) {
            if (this.type === tok.jsxText) return this.jsx_parseText();
            else if (this.type === tok.jsxTagStart) return this.jsx_parseElement();
            else return super.parseExprAtom(refShortHandDefaultPos);
        }
        readToken(code) {
            let context = this.curContext();
            if (context === tc_expr) return this.jsx_readToken();
            if (context === tc_oTag || context === tc_cTag) {
                if (isIdentifierStart(code)) return this.jsx_readWord();
                if (code == 62) {
                    ++this.pos;
                    return this.finishToken(tok.jsxTagEnd);
                }
                if ((code === 34 || code === 39) && context == tc_oTag) return this.jsx_readString(code);
            }
            if (code === 60 && this.exprAllowed && this.input.charCodeAt(this.pos + 1) !== 33) {
                ++this.pos;
                return this.finishToken(tok.jsxTagStart);
            }
            return super.readToken(code);
        }
        updateContext(prevType) {
            if (this.type == tt.braceL) {
                var curContext = this.curContext();
                if (curContext == tc_oTag) this.context.push(tokContexts.b_expr);
                else if (curContext == tc_expr) this.context.push(tokContexts.b_tmpl);
                else super.updateContext(prevType);
                this.exprAllowed = true;
            } else if (this.type === tt.slash && prevType === tok.jsxTagStart) {
                this.context.length -= 2; // do not consider JSX expr -> JSX open tag -> ... anymore
                this.context.push(tc_cTag); // reconsider as closing tag context
                this.exprAllowed = false;
            } else return super.updateContext(prevType);
        }
    };
}

},{"b4fe035b49712736":"8l2I9","441cb38ec329228d":"j6GsH"}],"8l2I9":[function(require,module,exports) {
module.exports = {
    quot: '"',
    amp: "&",
    apos: "'",
    lt: "<",
    gt: ">",
    nbsp: "\xa0",
    iexcl: "\xa1",
    cent: "\xa2",
    pound: "\xa3",
    curren: "\xa4",
    yen: "\xa5",
    brvbar: "\xa6",
    sect: "\xa7",
    uml: "\xa8",
    copy: "\xa9",
    ordf: "\xaa",
    laquo: "\xab",
    not: "\xac",
    shy: "\xad",
    reg: "\xae",
    macr: "\xaf",
    deg: "\xb0",
    plusmn: "\xb1",
    sup2: "\xb2",
    sup3: "\xb3",
    acute: "\xb4",
    micro: "\xb5",
    para: "\xb6",
    middot: "\xb7",
    cedil: "\xb8",
    sup1: "\xb9",
    ordm: "\xba",
    raquo: "\xbb",
    frac14: "\xbc",
    frac12: "\xbd",
    frac34: "\xbe",
    iquest: "\xbf",
    Agrave: "\xc0",
    Aacute: "\xc1",
    Acirc: "\xc2",
    Atilde: "\xc3",
    Auml: "\xc4",
    Aring: "\xc5",
    AElig: "\xc6",
    Ccedil: "\xc7",
    Egrave: "\xc8",
    Eacute: "\xc9",
    Ecirc: "\xca",
    Euml: "\xcb",
    Igrave: "\xcc",
    Iacute: "\xcd",
    Icirc: "\xce",
    Iuml: "\xcf",
    ETH: "\xd0",
    Ntilde: "\xd1",
    Ograve: "\xd2",
    Oacute: "\xd3",
    Ocirc: "\xd4",
    Otilde: "\xd5",
    Ouml: "\xd6",
    times: "\xd7",
    Oslash: "\xd8",
    Ugrave: "\xd9",
    Uacute: "\xda",
    Ucirc: "\xdb",
    Uuml: "\xdc",
    Yacute: "\xdd",
    THORN: "\xde",
    szlig: "\xdf",
    agrave: "\xe0",
    aacute: "\xe1",
    acirc: "\xe2",
    atilde: "\xe3",
    auml: "\xe4",
    aring: "\xe5",
    aelig: "\xe6",
    ccedil: "\xe7",
    egrave: "\xe8",
    eacute: "\xe9",
    ecirc: "\xea",
    euml: "\xeb",
    igrave: "\xec",
    iacute: "\xed",
    icirc: "\xee",
    iuml: "\xef",
    eth: "\xf0",
    ntilde: "\xf1",
    ograve: "\xf2",
    oacute: "\xf3",
    ocirc: "\xf4",
    otilde: "\xf5",
    ouml: "\xf6",
    divide: "\xf7",
    oslash: "\xf8",
    ugrave: "\xf9",
    uacute: "\xfa",
    ucirc: "\xfb",
    uuml: "\xfc",
    yacute: "\xfd",
    thorn: "\xfe",
    yuml: "\xff",
    OElig: "\u0152",
    oelig: "\u0153",
    Scaron: "\u0160",
    scaron: "\u0161",
    Yuml: "\u0178",
    fnof: "\u0192",
    circ: "\u02C6",
    tilde: "\u02DC",
    Alpha: "\u0391",
    Beta: "\u0392",
    Gamma: "\u0393",
    Delta: "\u0394",
    Epsilon: "\u0395",
    Zeta: "\u0396",
    Eta: "\u0397",
    Theta: "\u0398",
    Iota: "\u0399",
    Kappa: "\u039A",
    Lambda: "\u039B",
    Mu: "\u039C",
    Nu: "\u039D",
    Xi: "\u039E",
    Omicron: "\u039F",
    Pi: "\u03A0",
    Rho: "\u03A1",
    Sigma: "\u03A3",
    Tau: "\u03A4",
    Upsilon: "\u03A5",
    Phi: "\u03A6",
    Chi: "\u03A7",
    Psi: "\u03A8",
    Omega: "\u03A9",
    alpha: "\u03B1",
    beta: "\u03B2",
    gamma: "\u03B3",
    delta: "\u03B4",
    epsilon: "\u03B5",
    zeta: "\u03B6",
    eta: "\u03B7",
    theta: "\u03B8",
    iota: "\u03B9",
    kappa: "\u03BA",
    lambda: "\u03BB",
    mu: "\u03BC",
    nu: "\u03BD",
    xi: "\u03BE",
    omicron: "\u03BF",
    pi: "\u03C0",
    rho: "\u03C1",
    sigmaf: "\u03C2",
    sigma: "\u03C3",
    tau: "\u03C4",
    upsilon: "\u03C5",
    phi: "\u03C6",
    chi: "\u03C7",
    psi: "\u03C8",
    omega: "\u03C9",
    thetasym: "\u03D1",
    upsih: "\u03D2",
    piv: "\u03D6",
    ensp: "\u2002",
    emsp: "\u2003",
    thinsp: "\u2009",
    zwnj: "\u200C",
    zwj: "\u200D",
    lrm: "\u200E",
    rlm: "\u200F",
    ndash: "\u2013",
    mdash: "\u2014",
    lsquo: "\u2018",
    rsquo: "\u2019",
    sbquo: "\u201A",
    ldquo: "\u201C",
    rdquo: "\u201D",
    bdquo: "\u201E",
    dagger: "\u2020",
    Dagger: "\u2021",
    bull: "\u2022",
    hellip: "\u2026",
    permil: "\u2030",
    prime: "\u2032",
    Prime: "\u2033",
    lsaquo: "\u2039",
    rsaquo: "\u203A",
    oline: "\u203E",
    frasl: "\u2044",
    euro: "\u20AC",
    image: "\u2111",
    weierp: "\u2118",
    real: "\u211C",
    trade: "\u2122",
    alefsym: "\u2135",
    larr: "\u2190",
    uarr: "\u2191",
    rarr: "\u2192",
    darr: "\u2193",
    harr: "\u2194",
    crarr: "\u21B5",
    lArr: "\u21D0",
    uArr: "\u21D1",
    rArr: "\u21D2",
    dArr: "\u21D3",
    hArr: "\u21D4",
    forall: "\u2200",
    part: "\u2202",
    exist: "\u2203",
    empty: "\u2205",
    nabla: "\u2207",
    isin: "\u2208",
    notin: "\u2209",
    ni: "\u220B",
    prod: "\u220F",
    sum: "\u2211",
    minus: "\u2212",
    lowast: "\u2217",
    radic: "\u221A",
    prop: "\u221D",
    infin: "\u221E",
    ang: "\u2220",
    and: "\u2227",
    or: "\u2228",
    cap: "\u2229",
    cup: "\u222A",
    "int": "\u222B",
    there4: "\u2234",
    sim: "\u223C",
    cong: "\u2245",
    asymp: "\u2248",
    ne: "\u2260",
    equiv: "\u2261",
    le: "\u2264",
    ge: "\u2265",
    sub: "\u2282",
    sup: "\u2283",
    nsub: "\u2284",
    sube: "\u2286",
    supe: "\u2287",
    oplus: "\u2295",
    otimes: "\u2297",
    perp: "\u22A5",
    sdot: "\u22C5",
    lceil: "\u2308",
    rceil: "\u2309",
    lfloor: "\u230A",
    rfloor: "\u230B",
    lang: "\u2329",
    rang: "\u232A",
    loz: "\u25CA",
    spades: "\u2660",
    clubs: "\u2663",
    hearts: "\u2665",
    diams: "\u2666"
};

},{}],"3hWFw":[function(require,module,exports) {
// AST walker module for Mozilla Parser API compatible trees
// A simple walk is one where you simply specify callbacks to be
// called on specific nodes. The last two arguments are optional. A
// simple use would be
//
//     walk.simple(myTree, {
//         Expression: function(node) { ... }
//     });
//
// to do something with all expressions. All Parser API node types
// can be used to identify node types, as well as Expression and
// Statement, which denote categories of nodes.
//
// The base argument can be used to pass a custom (recursive)
// walker, and state can be used to give this walked an initial
// state.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ancestor", ()=>ancestor);
parcelHelpers.export(exports, "base", ()=>base);
parcelHelpers.export(exports, "findNodeAfter", ()=>findNodeAfter);
parcelHelpers.export(exports, "findNodeAround", ()=>findNodeAround);
parcelHelpers.export(exports, "findNodeAt", ()=>findNodeAt);
parcelHelpers.export(exports, "findNodeBefore", ()=>findNodeBefore);
parcelHelpers.export(exports, "full", ()=>full);
parcelHelpers.export(exports, "fullAncestor", ()=>fullAncestor);
parcelHelpers.export(exports, "make", ()=>make);
parcelHelpers.export(exports, "recursive", ()=>recursive);
parcelHelpers.export(exports, "simple", ()=>simple);
function simple(node, visitors, baseVisitor, state, override) {
    if (!baseVisitor) baseVisitor = base;
    (function c(node, st, override) {
        var type = override || node.type, found = visitors[type];
        baseVisitor[type](node, st, c);
        if (found) found(node, st);
    })(node, state, override);
}
// An ancestor walk keeps an array of ancestor nodes (including the
// current node) and passes them to the callback as third parameter
// (and also as state parameter when no other state is present).
function ancestor(node, visitors, baseVisitor, state, override) {
    var ancestors = [];
    if (!baseVisitor) baseVisitor = base;
    (function c(node, st, override) {
        var type = override || node.type, found = visitors[type];
        var isNew = node !== ancestors[ancestors.length - 1];
        if (isNew) ancestors.push(node);
        baseVisitor[type](node, st, c);
        if (found) found(node, st || ancestors, ancestors);
        if (isNew) ancestors.pop();
    })(node, state, override);
}
// A recursive walk is one where your functions override the default
// walkers. They can modify and replace the state parameter that's
// threaded through the walk, and can opt how and whether to walk
// their child nodes (by calling their third argument on these
// nodes).
function recursive(node, state, funcs, baseVisitor, override) {
    var visitor = funcs ? make(funcs, baseVisitor || undefined) : baseVisitor;
    (function c(node, st, override) {
        visitor[override || node.type](node, st, c);
    })(node, state, override);
}
function makeTest(test) {
    if (typeof test === "string") return function(type) {
        return type === test;
    };
    else if (!test) return function() {
        return true;
    };
    else return test;
}
var Found = function Found(node, state) {
    this.node = node;
    this.state = state;
};
// A full walk triggers the callback on each node
function full(node, callback, baseVisitor, state, override) {
    if (!baseVisitor) baseVisitor = base;
    (function c(node, st, override) {
        var type = override || node.type;
        baseVisitor[type](node, st, c);
        if (!override) callback(node, st, type);
    })(node, state, override);
}
// An fullAncestor walk is like an ancestor walk, but triggers
// the callback on each node
function fullAncestor(node, callback, baseVisitor, state) {
    if (!baseVisitor) baseVisitor = base;
    var ancestors = [];
    (function c(node, st, override) {
        var type = override || node.type;
        var isNew = node !== ancestors[ancestors.length - 1];
        if (isNew) ancestors.push(node);
        baseVisitor[type](node, st, c);
        if (!override) callback(node, st || ancestors, ancestors, type);
        if (isNew) ancestors.pop();
    })(node, state);
}
// Find a node with a given start, end, and type (all are optional,
// null can be used as wildcard). Returns a {node, state} object, or
// undefined when it doesn't find a matching node.
function findNodeAt(node, start, end, test, baseVisitor, state) {
    if (!baseVisitor) baseVisitor = base;
    test = makeTest(test);
    try {
        (function c(node, st, override) {
            var type = override || node.type;
            if ((start == null || node.start <= start) && (end == null || node.end >= end)) baseVisitor[type](node, st, c);
            if ((start == null || node.start === start) && (end == null || node.end === end) && test(type, node)) throw new Found(node, st);
        })(node, state);
    } catch (e) {
        if (e instanceof Found) return e;
        throw e;
    }
}
// Find the innermost node of a given type that contains the given
// position. Interface similar to findNodeAt.
function findNodeAround(node, pos, test, baseVisitor, state) {
    test = makeTest(test);
    if (!baseVisitor) baseVisitor = base;
    try {
        (function c(node, st, override) {
            var type = override || node.type;
            if (node.start > pos || node.end < pos) return;
            baseVisitor[type](node, st, c);
            if (test(type, node)) throw new Found(node, st);
        })(node, state);
    } catch (e) {
        if (e instanceof Found) return e;
        throw e;
    }
}
// Find the outermost matching node after a given position.
function findNodeAfter(node, pos, test, baseVisitor, state) {
    test = makeTest(test);
    if (!baseVisitor) baseVisitor = base;
    try {
        (function c(node, st, override) {
            if (node.end < pos) return;
            var type = override || node.type;
            if (node.start >= pos && test(type, node)) throw new Found(node, st);
            baseVisitor[type](node, st, c);
        })(node, state);
    } catch (e) {
        if (e instanceof Found) return e;
        throw e;
    }
}
// Find the outermost matching node before a given position.
function findNodeBefore(node, pos, test, baseVisitor, state) {
    test = makeTest(test);
    if (!baseVisitor) baseVisitor = base;
    var max;
    (function c(node, st, override) {
        if (node.start > pos) return;
        var type = override || node.type;
        if (node.end <= pos && (!max || max.node.end < node.end) && test(type, node)) max = new Found(node, st);
        baseVisitor[type](node, st, c);
    })(node, state);
    return max;
}
// Fallback to an Object.create polyfill for older environments.
var create = Object.create || function(proto) {
    function Ctor() {}
    Ctor.prototype = proto;
    return new Ctor;
};
// Used to create a custom walker. Will fill in all missing node
// type properties with the defaults.
function make(funcs, baseVisitor) {
    var visitor = create(baseVisitor || base);
    for(var type in funcs)visitor[type] = funcs[type];
    return visitor;
}
function skipThrough(node, st, c) {
    c(node, st);
}
function ignore(_node, _st, _c) {}
// Node walkers.
var base = {};
base.Program = base.BlockStatement = function(node, st, c) {
    for(var i = 0, list = node.body; i < list.length; i += 1){
        var stmt = list[i];
        c(stmt, st, "Statement");
    }
};
base.Statement = skipThrough;
base.EmptyStatement = ignore;
base.ExpressionStatement = base.ParenthesizedExpression = base.ChainExpression = function(node, st, c) {
    return c(node.expression, st, "Expression");
};
base.IfStatement = function(node, st, c) {
    c(node.test, st, "Expression");
    c(node.consequent, st, "Statement");
    if (node.alternate) c(node.alternate, st, "Statement");
};
base.LabeledStatement = function(node, st, c) {
    return c(node.body, st, "Statement");
};
base.BreakStatement = base.ContinueStatement = ignore;
base.WithStatement = function(node, st, c) {
    c(node.object, st, "Expression");
    c(node.body, st, "Statement");
};
base.SwitchStatement = function(node, st, c) {
    c(node.discriminant, st, "Expression");
    for(var i$1 = 0, list$1 = node.cases; i$1 < list$1.length; i$1 += 1){
        var cs = list$1[i$1];
        if (cs.test) c(cs.test, st, "Expression");
        for(var i = 0, list = cs.consequent; i < list.length; i += 1){
            var cons = list[i];
            c(cons, st, "Statement");
        }
    }
};
base.SwitchCase = function(node, st, c) {
    if (node.test) c(node.test, st, "Expression");
    for(var i = 0, list = node.consequent; i < list.length; i += 1){
        var cons = list[i];
        c(cons, st, "Statement");
    }
};
base.ReturnStatement = base.YieldExpression = base.AwaitExpression = function(node, st, c) {
    if (node.argument) c(node.argument, st, "Expression");
};
base.ThrowStatement = base.SpreadElement = function(node, st, c) {
    return c(node.argument, st, "Expression");
};
base.TryStatement = function(node, st, c) {
    c(node.block, st, "Statement");
    if (node.handler) c(node.handler, st);
    if (node.finalizer) c(node.finalizer, st, "Statement");
};
base.CatchClause = function(node, st, c) {
    if (node.param) c(node.param, st, "Pattern");
    c(node.body, st, "Statement");
};
base.WhileStatement = base.DoWhileStatement = function(node, st, c) {
    c(node.test, st, "Expression");
    c(node.body, st, "Statement");
};
base.ForStatement = function(node, st, c) {
    if (node.init) c(node.init, st, "ForInit");
    if (node.test) c(node.test, st, "Expression");
    if (node.update) c(node.update, st, "Expression");
    c(node.body, st, "Statement");
};
base.ForInStatement = base.ForOfStatement = function(node, st, c) {
    c(node.left, st, "ForInit");
    c(node.right, st, "Expression");
    c(node.body, st, "Statement");
};
base.ForInit = function(node, st, c) {
    if (node.type === "VariableDeclaration") c(node, st);
    else c(node, st, "Expression");
};
base.DebuggerStatement = ignore;
base.FunctionDeclaration = function(node, st, c) {
    return c(node, st, "Function");
};
base.VariableDeclaration = function(node, st, c) {
    for(var i = 0, list = node.declarations; i < list.length; i += 1){
        var decl = list[i];
        c(decl, st);
    }
};
base.VariableDeclarator = function(node, st, c) {
    c(node.id, st, "Pattern");
    if (node.init) c(node.init, st, "Expression");
};
base.Function = function(node, st, c) {
    if (node.id) c(node.id, st, "Pattern");
    for(var i = 0, list = node.params; i < list.length; i += 1){
        var param = list[i];
        c(param, st, "Pattern");
    }
    c(node.body, st, node.expression ? "Expression" : "Statement");
};
base.Pattern = function(node, st, c) {
    if (node.type === "Identifier") c(node, st, "VariablePattern");
    else if (node.type === "MemberExpression") c(node, st, "MemberPattern");
    else c(node, st);
};
base.VariablePattern = ignore;
base.MemberPattern = skipThrough;
base.RestElement = function(node, st, c) {
    return c(node.argument, st, "Pattern");
};
base.ArrayPattern = function(node, st, c) {
    for(var i = 0, list = node.elements; i < list.length; i += 1){
        var elt = list[i];
        if (elt) c(elt, st, "Pattern");
    }
};
base.ObjectPattern = function(node, st, c) {
    for(var i = 0, list = node.properties; i < list.length; i += 1){
        var prop = list[i];
        if (prop.type === "Property") {
            if (prop.computed) c(prop.key, st, "Expression");
            c(prop.value, st, "Pattern");
        } else if (prop.type === "RestElement") c(prop.argument, st, "Pattern");
    }
};
base.Expression = skipThrough;
base.ThisExpression = base.Super = base.MetaProperty = ignore;
base.ArrayExpression = function(node, st, c) {
    for(var i = 0, list = node.elements; i < list.length; i += 1){
        var elt = list[i];
        if (elt) c(elt, st, "Expression");
    }
};
base.ObjectExpression = function(node, st, c) {
    for(var i = 0, list = node.properties; i < list.length; i += 1){
        var prop = list[i];
        c(prop, st);
    }
};
base.FunctionExpression = base.ArrowFunctionExpression = base.FunctionDeclaration;
base.SequenceExpression = function(node, st, c) {
    for(var i = 0, list = node.expressions; i < list.length; i += 1){
        var expr = list[i];
        c(expr, st, "Expression");
    }
};
base.TemplateLiteral = function(node, st, c) {
    for(var i = 0, list = node.quasis; i < list.length; i += 1){
        var quasi = list[i];
        c(quasi, st);
    }
    for(var i$1 = 0, list$1 = node.expressions; i$1 < list$1.length; i$1 += 1){
        var expr = list$1[i$1];
        c(expr, st, "Expression");
    }
};
base.TemplateElement = ignore;
base.UnaryExpression = base.UpdateExpression = function(node, st, c) {
    c(node.argument, st, "Expression");
};
base.BinaryExpression = base.LogicalExpression = function(node, st, c) {
    c(node.left, st, "Expression");
    c(node.right, st, "Expression");
};
base.AssignmentExpression = base.AssignmentPattern = function(node, st, c) {
    c(node.left, st, "Pattern");
    c(node.right, st, "Expression");
};
base.ConditionalExpression = function(node, st, c) {
    c(node.test, st, "Expression");
    c(node.consequent, st, "Expression");
    c(node.alternate, st, "Expression");
};
base.NewExpression = base.CallExpression = function(node, st, c) {
    c(node.callee, st, "Expression");
    if (node.arguments) for(var i = 0, list = node.arguments; i < list.length; i += 1){
        var arg = list[i];
        c(arg, st, "Expression");
    }
};
base.MemberExpression = function(node, st, c) {
    c(node.object, st, "Expression");
    if (node.computed) c(node.property, st, "Expression");
};
base.ExportNamedDeclaration = base.ExportDefaultDeclaration = function(node, st, c) {
    if (node.declaration) c(node.declaration, st, node.type === "ExportNamedDeclaration" || node.declaration.id ? "Statement" : "Expression");
    if (node.source) c(node.source, st, "Expression");
};
base.ExportAllDeclaration = function(node, st, c) {
    if (node.exported) c(node.exported, st);
    c(node.source, st, "Expression");
};
base.ImportDeclaration = function(node, st, c) {
    for(var i = 0, list = node.specifiers; i < list.length; i += 1){
        var spec = list[i];
        c(spec, st);
    }
    c(node.source, st, "Expression");
};
base.ImportExpression = function(node, st, c) {
    c(node.source, st, "Expression");
};
base.ImportSpecifier = base.ImportDefaultSpecifier = base.ImportNamespaceSpecifier = base.Identifier = base.Literal = ignore;
base.TaggedTemplateExpression = function(node, st, c) {
    c(node.tag, st, "Expression");
    c(node.quasi, st, "Expression");
};
base.ClassDeclaration = base.ClassExpression = function(node, st, c) {
    return c(node, st, "Class");
};
base.Class = function(node, st, c) {
    if (node.id) c(node.id, st, "Pattern");
    if (node.superClass) c(node.superClass, st, "Expression");
    c(node.body, st);
};
base.ClassBody = function(node, st, c) {
    for(var i = 0, list = node.body; i < list.length; i += 1){
        var elt = list[i];
        c(elt, st);
    }
};
base.MethodDefinition = base.Property = function(node, st, c) {
    if (node.computed) c(node.key, st, "Expression");
    c(node.value, st, "Expression");
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"kXKoJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _createDefaultValue = require("./createDefaultValue");
parcelHelpers.exportAll(_createDefaultValue, exports);
var _createFromRawDefaultProp = require("./createFromRawDefaultProp");
parcelHelpers.exportAll(_createFromRawDefaultProp, exports);

},{"./createDefaultValue":"2fCCY","./createFromRawDefaultProp":"gev9r","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"2fCCY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createDefaultValue", ()=>createDefaultValue);
var _docsTools = require("@storybook/docs-tools");
var _captions = require("../captions");
var _inspection = require("../inspection");
var _isHtmlTag = require("../isHtmlTag");
var _generateCode = require("../generateCode");
var _generateObject = require("./generateObject");
var _generateArray = require("./generateArray");
var _prettyIdentifier = require("./prettyIdentifier");
function generateFunc(_ref) {
    var inferredType = _ref.inferredType, ast = _ref.ast;
    var _ref2 = inferredType, identifier = _ref2.identifier;
    if (identifier != null) return (0, _docsTools.createSummaryValue)((0, _prettyIdentifier.getPrettyIdentifier)(inferredType), (0, _generateCode.generateCode)(ast));
    var prettyCaption = (0, _generateCode.generateCode)(ast, true);
    return !(0, _docsTools.isTooLongForDefaultValueSummary)(prettyCaption) ? (0, _docsTools.createSummaryValue)(prettyCaption) : (0, _docsTools.createSummaryValue)((0, _captions.FUNCTION_CAPTION), (0, _generateCode.generateCode)(ast));
} // All elements are JSX elements.
// JSX elements are not supported by escodegen.
function generateElement(defaultValue, inspectionResult) {
    var inferredType = inspectionResult.inferredType;
    var _ref3 = inferredType, identifier = _ref3.identifier;
    if (identifier != null) {
        if (!(0, _isHtmlTag.isHtmlTag)(identifier)) {
            var prettyIdentifier = (0, _prettyIdentifier.getPrettyIdentifier)(inferredType);
            return (0, _docsTools.createSummaryValue)(prettyIdentifier, defaultValue);
        }
    }
    return !(0, _docsTools.isTooLongForDefaultValueSummary)(defaultValue) ? (0, _docsTools.createSummaryValue)(defaultValue) : (0, _docsTools.createSummaryValue)((0, _captions.ELEMENT_CAPTION), defaultValue);
}
function createDefaultValue(defaultValue) {
    try {
        var inspectionResult = (0, _inspection.inspectValue)(defaultValue);
        switch(inspectionResult.inferredType.type){
            case (0, _inspection.InspectionType).OBJECT:
                return (0, _generateObject.generateObject)(inspectionResult);
            case (0, _inspection.InspectionType).FUNCTION:
                return generateFunc(inspectionResult);
            case (0, _inspection.InspectionType).ELEMENT:
                return generateElement(defaultValue, inspectionResult);
            case (0, _inspection.InspectionType).ARRAY:
                return (0, _generateArray.generateArray)(inspectionResult);
            default:
                return null;
        }
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
    }
    return null;
}

},{"@storybook/docs-tools":"c0Wnz","../captions":"2JqpQ","../inspection":"g7DSz","../isHtmlTag":"52X8w","../generateCode":"jxt4Z","./generateObject":"lVFxA","./generateArray":"dRFp0","./prettyIdentifier":"gbmPg","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"lVFxA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "generateObject", ()=>generateObject);
var _docsTools = require("@storybook/docs-tools");
var _captions = require("../captions");
var _generateCode = require("../generateCode");
function generateObject(_ref) {
    var inferredType = _ref.inferredType, ast = _ref.ast;
    var _ref2 = inferredType, depth = _ref2.depth;
    if (depth === 1) {
        var compactObject = (0, _generateCode.generateObjectCode)(ast, true);
        if (!(0, _docsTools.isTooLongForDefaultValueSummary)(compactObject)) return (0, _docsTools.createSummaryValue)(compactObject);
    }
    return (0, _docsTools.createSummaryValue)((0, _captions.OBJECT_CAPTION), (0, _generateCode.generateObjectCode)(ast));
}

},{"@storybook/docs-tools":"c0Wnz","../captions":"2JqpQ","../generateCode":"jxt4Z","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"dRFp0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "generateArray", ()=>generateArray);
var _docsTools = require("@storybook/docs-tools");
var _captions = require("../captions");
var _generateCode = require("../generateCode");
function generateArray(_ref) {
    var inferredType = _ref.inferredType, ast = _ref.ast;
    var _ref2 = inferredType, depth = _ref2.depth;
    if (depth <= 2) {
        var compactArray = (0, _generateCode.generateArrayCode)(ast, true);
        if (!(0, _docsTools.isTooLongForDefaultValueSummary)(compactArray)) return (0, _docsTools.createSummaryValue)(compactArray);
    }
    return (0, _docsTools.createSummaryValue)((0, _captions.ARRAY_CAPTION), (0, _generateCode.generateArrayCode)(ast));
}

},{"@storybook/docs-tools":"c0Wnz","../captions":"2JqpQ","../generateCode":"jxt4Z","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"gbmPg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getPrettyIdentifier", ()=>getPrettyIdentifier);
parcelHelpers.export(exports, "getPrettyFuncIdentifier", ()=>getPrettyFuncIdentifier);
parcelHelpers.export(exports, "getPrettyElementIdentifier", ()=>getPrettyElementIdentifier);
var _inspection = require("../inspection");
function getPrettyIdentifier(inferredType) {
    var type = inferredType.type, identifier = inferredType.identifier;
    switch(type){
        case (0, _inspection.InspectionType).FUNCTION:
            return getPrettyFuncIdentifier(identifier, inferredType.hasParams);
        case (0, _inspection.InspectionType).ELEMENT:
            return getPrettyElementIdentifier(identifier);
        default:
            return identifier;
    }
}
function getPrettyFuncIdentifier(identifier, hasArguments) {
    return hasArguments ? "".concat(identifier, "( ... )") : "".concat(identifier, "()");
}
function getPrettyElementIdentifier(identifier) {
    return "<".concat(identifier, " />");
}

},{"../inspection":"g7DSz","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"gev9r":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "extractFunctionName", ()=>extractFunctionName);
parcelHelpers.export(exports, "createTypeResolvers", ()=>createTypeResolvers) // When react-docgen cannot provide a defaultValue we take it from the raw defaultProp.
;
// It works fine for types that are not transpiled. For the types that are transpiled, we can only provide partial support.
// This means that:
//   - The detail might not be available.
//   - Identifiers might not be "prettified" for all the types.
parcelHelpers.export(exports, "createDefaultValueFromRawDefaultProp", ()=>createDefaultValueFromRawDefaultProp);
var _esFunctionNameJs = require("core-js/modules/es.function.name.js");
var _esRegexpExecJs = require("core-js/modules/es.regexp.exec.js");
var _esStringReplaceJs = require("core-js/modules/es.string.replace.js");
var _esObjectToStringJs = require("core-js/modules/es.object.to-string.js");
var _esRegexpToStringJs = require("core-js/modules/es.regexp.to-string.js");
var _esObjectAssignJs = require("core-js/modules/es.object.assign.js");
var _esSymbolJs = require("core-js/modules/es.symbol.js");
var _esSymbolDescriptionJs = require("core-js/modules/es.symbol.description.js");
var _esSymbolIteratorJs = require("core-js/modules/es.symbol.iterator.js");
var _esArrayIteratorJs = require("core-js/modules/es.array.iterator.js");
var _esStringIteratorJs = require("core-js/modules/es.string.iterator.js");
var _webDomCollectionsIteratorJs = require("core-js/modules/web.dom-collections.iterator.js");
var _isPlainObject = require("lodash/isPlainObject");
var _isPlainObjectDefault = parcelHelpers.interopDefault(_isPlainObject);
var _isFunction = require("lodash/isFunction");
var _isFunctionDefault = parcelHelpers.interopDefault(_isFunction);
var _isString = require("lodash/isString"); // @ts-ignore
var _isStringDefault = parcelHelpers.interopDefault(_isString);
var _reactElementToJsxString = require("react-element-to-jsx-string");
var _reactElementToJsxStringDefault = parcelHelpers.interopDefault(_reactElementToJsxString);
var _docsTools = require("@storybook/docs-tools");
var _inspection = require("../inspection");
var _generateObject = require("./generateObject");
var _generateArray = require("./generateArray");
var _prettyIdentifier = require("./prettyIdentifier");
var _captions = require("../captions");
var _isHtmlTag = require("../isHtmlTag");
function _typeof(obj) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
}
function isReactElement(element) {
    return element.$$typeof != null;
}
function extractFunctionName(func, propName) {
    var name = func.name; // Comparison with the prop name is to discard inferred function names.
    if (name !== "" && name !== "anonymous" && name !== propName) return name;
    return null;
}
var stringResolver = function stringResolver(rawDefaultProp) {
    return (0, _docsTools.createSummaryValue)(JSON.stringify(rawDefaultProp));
};
function generateReactObject(rawDefaultProp) {
    var type = rawDefaultProp.type;
    var displayName = type.displayName;
    var jsx = (0, _reactElementToJsxStringDefault.default)(rawDefaultProp, {});
    if (displayName != null) {
        var prettyIdentifier = (0, _prettyIdentifier.getPrettyElementIdentifier)(displayName);
        return (0, _docsTools.createSummaryValue)(prettyIdentifier, jsx);
    }
    if ((0, _isStringDefault.default)(type)) // This is an HTML element.
    {
        if ((0, _isHtmlTag.isHtmlTag)(type)) {
            var jsxCompact = (0, _reactElementToJsxStringDefault.default)(rawDefaultProp, {
                tabStop: 0
            });
            var jsxSummary = jsxCompact.replace(/\r?\n|\r/g, "");
            if (!(0, _docsTools.isTooLongForDefaultValueSummary)(jsxSummary)) return (0, _docsTools.createSummaryValue)(jsxSummary);
        }
    }
    return (0, _docsTools.createSummaryValue)((0, _captions.ELEMENT_CAPTION), jsx);
}
var objectResolver = function objectResolver(rawDefaultProp) {
    if (isReactElement(rawDefaultProp) && rawDefaultProp.type != null) return generateReactObject(rawDefaultProp);
    if ((0, _isPlainObjectDefault.default)(rawDefaultProp)) {
        var inspectionResult = (0, _inspection.inspectValue)(JSON.stringify(rawDefaultProp));
        return (0, _generateObject.generateObject)(inspectionResult);
    }
    if (Array.isArray(rawDefaultProp)) {
        var _inspectionResult = (0, _inspection.inspectValue)(JSON.stringify(rawDefaultProp));
        return (0, _generateArray.generateArray)(_inspectionResult);
    }
    return (0, _docsTools.createSummaryValue)((0, _captions.OBJECT_CAPTION));
};
var functionResolver = function functionResolver(rawDefaultProp, propDef) {
    var isElement = false;
    var inspectionResult; // Try to display the name of the component. The body of the component is omitted since the code has been transpiled.
    if ((0, _isFunctionDefault.default)(rawDefaultProp.render)) isElement = true;
    else if (rawDefaultProp.prototype != null && (0, _isFunctionDefault.default)(rawDefaultProp.prototype.render)) isElement = true;
    else {
        var innerElement;
        try {
            inspectionResult = (0, _inspection.inspectValue)(rawDefaultProp.toString());
            var _ref = inspectionResult.inferredType, hasParams = _ref.hasParams, params = _ref.params;
            if (hasParams) // It might be a functional component accepting props.
            {
                if (params.length === 1 && params[0].type === "ObjectPattern") innerElement = rawDefaultProp({});
            } else innerElement = rawDefaultProp();
            if (innerElement != null) {
                if (isReactElement(innerElement)) isElement = true;
            }
        } catch (e) {}
    }
    var funcName = extractFunctionName(rawDefaultProp, propDef.name);
    if (funcName != null) {
        if (isElement) return (0, _docsTools.createSummaryValue)((0, _prettyIdentifier.getPrettyElementIdentifier)(funcName));
        if (inspectionResult != null) inspectionResult = (0, _inspection.inspectValue)(rawDefaultProp.toString());
        var _ref2 = inspectionResult.inferredType, _hasParams = _ref2.hasParams;
        return (0, _docsTools.createSummaryValue)((0, _prettyIdentifier.getPrettyFuncIdentifier)(funcName, _hasParams));
    }
    return (0, _docsTools.createSummaryValue)(isElement ? (0, _captions.ELEMENT_CAPTION) : (0, _captions.FUNCTION_CAPTION));
};
var defaultResolver = function defaultResolver(rawDefaultProp) {
    return (0, _docsTools.createSummaryValue)(rawDefaultProp.toString());
};
var DEFAULT_TYPE_RESOLVERS = {
    string: stringResolver,
    object: objectResolver,
    function: functionResolver,
    default: defaultResolver
};
function createTypeResolvers() {
    var customResolvers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return Object.assign({}, DEFAULT_TYPE_RESOLVERS, customResolvers);
}
function createDefaultValueFromRawDefaultProp(rawDefaultProp, propDef) {
    var typeResolvers = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : DEFAULT_TYPE_RESOLVERS;
    try {
        // Keep the extra () otherwise it will fail for functions.
        switch(_typeof(rawDefaultProp)){
            case "string":
                return typeResolvers.string(rawDefaultProp, propDef);
            case "object":
                return typeResolvers.object(rawDefaultProp, propDef);
            case "function":
                return typeResolvers.function(rawDefaultProp, propDef);
            default:
                return typeResolvers.default(rawDefaultProp, propDef);
        }
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
    }
    return null;
}

},{"core-js/modules/es.function.name.js":"4LiLL","core-js/modules/es.regexp.exec.js":"5q56v","core-js/modules/es.string.replace.js":"bFiJG","core-js/modules/es.object.to-string.js":"lsA9p","core-js/modules/es.regexp.to-string.js":"bGzly","core-js/modules/es.object.assign.js":"8FU8M","core-js/modules/es.symbol.js":"ajw2f","core-js/modules/es.symbol.description.js":"wrlLc","core-js/modules/es.symbol.iterator.js":"fhNIb","core-js/modules/es.array.iterator.js":"ieU20","core-js/modules/es.string.iterator.js":"74a8v","core-js/modules/web.dom-collections.iterator.js":"aXR96","lodash/isPlainObject":"9m4Iw","lodash/isFunction":"9BLtw","lodash/isString":"cpMC2","react-element-to-jsx-string":"9CiTf","@storybook/docs-tools":"c0Wnz","../inspection":"g7DSz","./generateObject":"lVFxA","./generateArray":"dRFp0","./prettyIdentifier":"gbmPg","../captions":"2JqpQ","../isHtmlTag":"52X8w","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"cpMC2":[function(require,module,exports) {
var baseGetTag = require("b4b8a393acf14901"), isArray = require("46fdd4d2c5d7b4ab"), isObjectLike = require("36ebbb6a9d8b3fe4");
/** `Object#toString` result references. */ var stringTag = "[object String]";
/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */ function isString(value) {
    return typeof value == "string" || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
}
module.exports = isString;

},{"b4b8a393acf14901":"8STfc","46fdd4d2c5d7b4ab":"9EWOE","36ebbb6a9d8b3fe4":"65GJZ"}],"9CiTf":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var isPlainObject = require("1d245530f3f4b629");
var React = require("945717012d748ed1");
var prettyPrintObject = require("e85dec79cec9b05c");
var reactIs = require("49959fad3465d5db");
function _interopDefaultLegacy(e) {
    return e && typeof e === "object" && "default" in e ? e : {
        "default": e
    };
}
function _interopNamespace(e) {
    if (e && e.__esModule) return e;
    var n = Object.create(null);
    if (e) Object.keys(e).forEach(function(k) {
        if (k !== "default") {
            var d = Object.getOwnPropertyDescriptor(e, k);
            Object.defineProperty(n, k, d.get ? d : {
                enumerable: true,
                get: function() {
                    return e[k];
                }
            });
        }
    });
    n["default"] = e;
    return Object.freeze(n);
}
var React__namespace = /*#__PURE__*/ _interopNamespace(React);
var React__default = /*#__PURE__*/ _interopDefaultLegacy(React);
var spacer = function(times, tabStop) {
    if (times === 0) return "";
    return new Array(times * tabStop).fill(" ").join("");
};
function _typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function(obj) {
        return typeof obj;
    };
    else _typeof = function(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return _typeof(obj);
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function safeSortObject(value, seen) {
    // return non-object value as is
    if (value === null || _typeof(value) !== "object") return value;
     // return date, regexp and react element values as is
    if (value instanceof Date || value instanceof RegExp || /*#__PURE__*/ React__namespace.isValidElement(value)) return value;
    seen.add(value); // make a copy of array with each item passed through the sorting algorithm
    if (Array.isArray(value)) return value.map(function(v) {
        return safeSortObject(v, seen);
    });
     // make a copy of object with key sorted
    return Object.keys(value).sort().reduce(function(result, key) {
        if (key === "_owner") return result;
        if (key === "current" || seen.has(value[key])) // eslint-disable-next-line no-param-reassign
        result[key] = "[Circular]";
        else // eslint-disable-next-line no-param-reassign
        result[key] = safeSortObject(value[key], seen);
        return result;
    }, {});
}
function sortObject(value) {
    return safeSortObject(value, new WeakSet());
}
/* eslint-disable no-use-before-define */ var createStringTreeNode = function createStringTreeNode(value) {
    return {
        type: "string",
        value: value
    };
};
var createNumberTreeNode = function createNumberTreeNode(value) {
    return {
        type: "number",
        value: value
    };
};
var createReactElementTreeNode = function createReactElementTreeNode(displayName, props, defaultProps, childrens) {
    return {
        type: "ReactElement",
        displayName: displayName,
        props: props,
        defaultProps: defaultProps,
        childrens: childrens
    };
};
var createReactFragmentTreeNode = function createReactFragmentTreeNode(key, childrens) {
    return {
        type: "ReactFragment",
        key: key,
        childrens: childrens
    };
};
var supportFragment = Boolean(React.Fragment);
var getFunctionTypeName = function getFunctionTypeName(functionType) {
    if (!functionType.name || functionType.name === "_default") return "No Display Name";
    return functionType.name;
};
var getWrappedComponentDisplayName = function getWrappedComponentDisplayName(Component) {
    switch(true){
        case Boolean(Component.displayName):
            return Component.displayName;
        case Component.$$typeof === reactIs.Memo:
            return getWrappedComponentDisplayName(Component.type);
        case Component.$$typeof === reactIs.ForwardRef:
            return getWrappedComponentDisplayName(Component.render);
        default:
            return getFunctionTypeName(Component);
    }
}; // heavily inspired by:
// https://github.com/facebook/react/blob/3746eaf985dd92f8aa5f5658941d07b6b855e9d9/packages/react-devtools-shared/src/backend/renderer.js#L399-L496
var getReactElementDisplayName = function getReactElementDisplayName(element) {
    switch(true){
        case typeof element.type === "string":
            return element.type;
        case typeof element.type === "function":
            if (element.type.displayName) return element.type.displayName;
            return getFunctionTypeName(element.type);
        case reactIs.isForwardRef(element):
        case reactIs.isMemo(element):
            return getWrappedComponentDisplayName(element.type);
        case reactIs.isContextConsumer(element):
            return "".concat(element.type._context.displayName || "Context", ".Consumer");
        case reactIs.isContextProvider(element):
            return "".concat(element.type._context.displayName || "Context", ".Provider");
        case reactIs.isLazy(element):
            return "Lazy";
        case reactIs.isProfiler(element):
            return "Profiler";
        case reactIs.isStrictMode(element):
            return "StrictMode";
        case reactIs.isSuspense(element):
            return "Suspense";
        default:
            return "UnknownElementType";
    }
};
var noChildren = function noChildren(propsValue, propName) {
    return propName !== "children";
};
var onlyMeaningfulChildren = function onlyMeaningfulChildren(children) {
    return children !== true && children !== false && children !== null && children !== "";
};
var filterProps = function filterProps(originalProps, cb) {
    var filteredProps = {};
    Object.keys(originalProps).filter(function(key) {
        return cb(originalProps[key], key);
    }).forEach(function(key) {
        return filteredProps[key] = originalProps[key];
    });
    return filteredProps;
};
var parseReactElement = function parseReactElement(element, options) {
    var _options$displayName = options.displayName, displayNameFn = _options$displayName === void 0 ? getReactElementDisplayName : _options$displayName;
    if (typeof element === "string") return createStringTreeNode(element);
    else if (typeof element === "number") return createNumberTreeNode(element);
    else if (!/*#__PURE__*/ React__default["default"].isValidElement(element)) throw new Error("react-element-to-jsx-string: Expected a React.Element, got `".concat(_typeof(element), "`"));
    var displayName = displayNameFn(element);
    var props = filterProps(element.props, noChildren);
    if (element.ref !== null) props.ref = element.ref;
    var key = element.key;
    if (typeof key === "string" && key.search(/^\./)) // React automatically add key=".X" when there are some children
    props.key = key;
    var defaultProps = filterProps(element.type.defaultProps || {}, noChildren);
    var childrens = React__default["default"].Children.toArray(element.props.children).filter(onlyMeaningfulChildren).map(function(child) {
        return parseReactElement(child, options);
    });
    if (supportFragment && element.type === React.Fragment) return createReactFragmentTreeNode(key, childrens);
    return createReactElementTreeNode(displayName, props, defaultProps, childrens);
};
function noRefCheck() {}
var inlineFunction = function inlineFunction(fn) {
    return fn.toString().split("\n").map(function(line) {
        return line.trim();
    }).join("");
};
var preserveFunctionLineBreak = function preserveFunctionLineBreak(fn) {
    return fn.toString();
};
var defaultFunctionValue = inlineFunction;
var formatFunction = function(fn, options) {
    var _options$functionValu = options.functionValue, functionValue = _options$functionValu === void 0 ? defaultFunctionValue : _options$functionValu, showFunctions = options.showFunctions;
    if (!showFunctions && functionValue === defaultFunctionValue) return functionValue(noRefCheck);
    return functionValue(fn);
};
var formatComplexDataStructure = function(value, inline, lvl, options) {
    var normalizedValue = sortObject(value);
    var stringifiedValue = prettyPrintObject.prettyPrint(normalizedValue, {
        transform: function transform(currentObj, prop, originalResult) {
            var currentValue = currentObj[prop];
            if (currentValue && /*#__PURE__*/ React.isValidElement(currentValue)) return formatTreeNode(parseReactElement(currentValue, options), true, lvl, options);
            if (typeof currentValue === "function") return formatFunction(currentValue, options);
            return originalResult;
        }
    });
    if (inline) return stringifiedValue.replace(/\s+/g, " ").replace(/{ /g, "{").replace(/ }/g, "}").replace(/\[ /g, "[").replace(/ ]/g, "]");
     // Replace tabs with spaces, and add necessary indentation in front of each new line
    return stringifiedValue.replace(/\t/g, spacer(1, options.tabStop)).replace(/\n([^$])/g, "\n".concat(spacer(lvl + 1, options.tabStop), "$1"));
};
var escape$1 = function escape(s) {
    return s.replace(/"/g, "&quot;");
};
var formatPropValue = function formatPropValue(propValue, inline, lvl, options) {
    if (typeof propValue === "number") return "{".concat(String(propValue), "}");
    if (typeof propValue === "string") return '"'.concat(escape$1(propValue), '"');
     // > "Symbols (new in ECMAScript 2015, not yet supported in Flow)"
    // @see: https://flow.org/en/docs/types/primitives/
    // $FlowFixMe: Flow does not support Symbol
    if (_typeof(propValue) === "symbol") {
        var symbolDescription = propValue.valueOf().toString().replace(/Symbol\((.*)\)/, "$1");
        if (!symbolDescription) return "{Symbol()}";
        return "{Symbol('".concat(symbolDescription, "')}");
    }
    if (typeof propValue === "function") return "{".concat(formatFunction(propValue, options), "}");
    if (/*#__PURE__*/ React.isValidElement(propValue)) return "{".concat(formatTreeNode(parseReactElement(propValue, options), true, lvl, options), "}");
    if (propValue instanceof Date) {
        if (isNaN(propValue.valueOf())) return "{new Date(NaN)}";
        return '{new Date("'.concat(propValue.toISOString(), '")}');
    }
    if (isPlainObject.isPlainObject(propValue) || Array.isArray(propValue)) return "{".concat(formatComplexDataStructure(propValue, inline, lvl, options), "}");
    return "{".concat(String(propValue), "}");
};
var formatProp = function(name, hasValue, value, hasDefaultValue, defaultValue, inline, lvl, options) {
    if (!hasValue && !hasDefaultValue) throw new Error('The prop "'.concat(name, '" has no value and no default: could not be formatted'));
    var usedValue = hasValue ? value : defaultValue;
    var useBooleanShorthandSyntax = options.useBooleanShorthandSyntax, tabStop = options.tabStop;
    var formattedPropValue = formatPropValue(usedValue, inline, lvl, options);
    var attributeFormattedInline = " ";
    var attributeFormattedMultiline = "\n".concat(spacer(lvl + 1, tabStop));
    var isMultilineAttribute = formattedPropValue.includes("\n");
    if (useBooleanShorthandSyntax && formattedPropValue === "{false}" && !hasDefaultValue) {
        // If a boolean is false and not different from it's default, we do not render the attribute
        attributeFormattedInline = "";
        attributeFormattedMultiline = "";
    } else if (useBooleanShorthandSyntax && formattedPropValue === "{true}") {
        attributeFormattedInline += "".concat(name);
        attributeFormattedMultiline += "".concat(name);
    } else {
        attributeFormattedInline += "".concat(name, "=").concat(formattedPropValue);
        attributeFormattedMultiline += "".concat(name, "=").concat(formattedPropValue);
    }
    return {
        attributeFormattedInline: attributeFormattedInline,
        attributeFormattedMultiline: attributeFormattedMultiline,
        isMultilineAttribute: isMultilineAttribute
    };
};
var mergeSiblingPlainStringChildrenReducer = function(previousNodes, currentNode) {
    var nodes = previousNodes.slice(0, previousNodes.length > 0 ? previousNodes.length - 1 : 0);
    var previousNode = previousNodes[previousNodes.length - 1];
    if (previousNode && (currentNode.type === "string" || currentNode.type === "number") && (previousNode.type === "string" || previousNode.type === "number")) nodes.push(createStringTreeNode(String(previousNode.value) + String(currentNode.value)));
    else {
        if (previousNode) nodes.push(previousNode);
        nodes.push(currentNode);
    }
    return nodes;
};
var isKeyOrRefProps = function isKeyOrRefProps(propName) {
    return [
        "key",
        "ref"
    ].includes(propName);
};
var sortPropsByNames = function(shouldSortUserProps) {
    return function(props) {
        var haveKeyProp = props.includes("key");
        var haveRefProp = props.includes("ref");
        var userPropsOnly = props.filter(function(oneProp) {
            return !isKeyOrRefProps(oneProp);
        });
        var sortedProps = shouldSortUserProps ? _toConsumableArray(userPropsOnly.sort()) // We use basic lexical order
         : _toConsumableArray(userPropsOnly);
        if (haveRefProp) sortedProps.unshift("ref");
        if (haveKeyProp) sortedProps.unshift("key");
        return sortedProps;
    };
};
function createPropFilter(props, filter) {
    if (Array.isArray(filter)) return function(key) {
        return filter.indexOf(key) === -1;
    };
    else return function(key) {
        return filter(props[key], key);
    };
}
var compensateMultilineStringElementIndentation = function compensateMultilineStringElementIndentation(element, formattedElement, inline, lvl, options) {
    var tabStop = options.tabStop;
    if (element.type === "string") return formattedElement.split("\n").map(function(line, offset) {
        if (offset === 0) return line;
        return "".concat(spacer(lvl, tabStop)).concat(line);
    }).join("\n");
    return formattedElement;
};
var formatOneChildren = function formatOneChildren(inline, lvl, options) {
    return function(element) {
        return compensateMultilineStringElementIndentation(element, formatTreeNode(element, inline, lvl, options), inline, lvl, options);
    };
};
var onlyPropsWithOriginalValue = function onlyPropsWithOriginalValue(defaultProps, props) {
    return function(propName) {
        var haveDefaultValue = Object.keys(defaultProps).includes(propName);
        return !haveDefaultValue || haveDefaultValue && defaultProps[propName] !== props[propName];
    };
};
var isInlineAttributeTooLong = function isInlineAttributeTooLong(attributes, inlineAttributeString, lvl, tabStop, maxInlineAttributesLineLength) {
    if (!maxInlineAttributesLineLength) return attributes.length > 1;
    return spacer(lvl, tabStop).length + inlineAttributeString.length > maxInlineAttributesLineLength;
};
var shouldRenderMultilineAttr = function shouldRenderMultilineAttr(attributes, inlineAttributeString, containsMultilineAttr, inline, lvl, tabStop, maxInlineAttributesLineLength) {
    return (isInlineAttributeTooLong(attributes, inlineAttributeString, lvl, tabStop, maxInlineAttributesLineLength) || containsMultilineAttr) && !inline;
};
var formatReactElementNode = function(node, inline, lvl, options) {
    var type = node.type, _node$displayName = node.displayName, displayName = _node$displayName === void 0 ? "" : _node$displayName, childrens = node.childrens, _node$props = node.props, props = _node$props === void 0 ? {} : _node$props, _node$defaultProps = node.defaultProps, defaultProps = _node$defaultProps === void 0 ? {} : _node$defaultProps;
    if (type !== "ReactElement") throw new Error('The "formatReactElementNode" function could only format node of type "ReactElement". Given:  '.concat(type));
    var filterProps = options.filterProps, maxInlineAttributesLineLength = options.maxInlineAttributesLineLength, showDefaultProps = options.showDefaultProps, sortProps = options.sortProps, tabStop = options.tabStop;
    var out = "<".concat(displayName);
    var outInlineAttr = out;
    var outMultilineAttr = out;
    var containsMultilineAttr = false;
    var visibleAttributeNames = [];
    var propFilter = createPropFilter(props, filterProps);
    Object.keys(props).filter(propFilter).filter(onlyPropsWithOriginalValue(defaultProps, props)).forEach(function(propName) {
        return visibleAttributeNames.push(propName);
    });
    Object.keys(defaultProps).filter(propFilter).filter(function() {
        return showDefaultProps;
    }).filter(function(defaultPropName) {
        return !visibleAttributeNames.includes(defaultPropName);
    }).forEach(function(defaultPropName) {
        return visibleAttributeNames.push(defaultPropName);
    });
    var attributes = sortPropsByNames(sortProps)(visibleAttributeNames);
    attributes.forEach(function(attributeName) {
        var _formatProp = formatProp(attributeName, Object.keys(props).includes(attributeName), props[attributeName], Object.keys(defaultProps).includes(attributeName), defaultProps[attributeName], inline, lvl, options), attributeFormattedInline = _formatProp.attributeFormattedInline, attributeFormattedMultiline = _formatProp.attributeFormattedMultiline, isMultilineAttribute = _formatProp.isMultilineAttribute;
        if (isMultilineAttribute) containsMultilineAttr = true;
        outInlineAttr += attributeFormattedInline;
        outMultilineAttr += attributeFormattedMultiline;
    });
    outMultilineAttr += "\n".concat(spacer(lvl, tabStop));
    if (shouldRenderMultilineAttr(attributes, outInlineAttr, containsMultilineAttr, inline, lvl, tabStop, maxInlineAttributesLineLength)) out = outMultilineAttr;
    else out = outInlineAttr;
    if (childrens && childrens.length > 0) {
        var newLvl = lvl + 1;
        out += ">";
        if (!inline) {
            out += "\n";
            out += spacer(newLvl, tabStop);
        }
        out += childrens.reduce(mergeSiblingPlainStringChildrenReducer, []).map(formatOneChildren(inline, newLvl, options)).join(!inline ? "\n".concat(spacer(newLvl, tabStop)) : "");
        if (!inline) {
            out += "\n";
            out += spacer(newLvl - 1, tabStop);
        }
        out += "</".concat(displayName, ">");
    } else {
        if (!isInlineAttributeTooLong(attributes, outInlineAttr, lvl, tabStop, maxInlineAttributesLineLength)) out += " ";
        out += "/>";
    }
    return out;
};
var REACT_FRAGMENT_TAG_NAME_SHORT_SYNTAX = "";
var REACT_FRAGMENT_TAG_NAME_EXPLICIT_SYNTAX = "React.Fragment";
var toReactElementTreeNode = function toReactElementTreeNode(displayName, key, childrens) {
    var props = {};
    if (key) props = {
        key: key
    };
    return {
        type: "ReactElement",
        displayName: displayName,
        props: props,
        defaultProps: {},
        childrens: childrens
    };
};
var isKeyedFragment = function isKeyedFragment(_ref) {
    var key = _ref.key;
    return Boolean(key);
};
var hasNoChildren = function hasNoChildren(_ref2) {
    var childrens = _ref2.childrens;
    return childrens.length === 0;
};
var formatReactFragmentNode = function(node, inline, lvl, options) {
    var type = node.type, key = node.key, childrens = node.childrens;
    if (type !== "ReactFragment") throw new Error('The "formatReactFragmentNode" function could only format node of type "ReactFragment". Given: '.concat(type));
    var useFragmentShortSyntax = options.useFragmentShortSyntax;
    var displayName;
    if (useFragmentShortSyntax) {
        if (hasNoChildren(node) || isKeyedFragment(node)) displayName = REACT_FRAGMENT_TAG_NAME_EXPLICIT_SYNTAX;
        else displayName = REACT_FRAGMENT_TAG_NAME_SHORT_SYNTAX;
    } else displayName = REACT_FRAGMENT_TAG_NAME_EXPLICIT_SYNTAX;
    return formatReactElementNode(toReactElementTreeNode(displayName, key, childrens), inline, lvl, options);
};
var jsxStopChars = [
    "<",
    ">",
    "{",
    "}"
];
var shouldBeEscaped = function shouldBeEscaped(s) {
    return jsxStopChars.some(function(jsxStopChar) {
        return s.includes(jsxStopChar);
    });
};
var escape = function escape(s) {
    if (!shouldBeEscaped(s)) return s;
    return "{`".concat(s, "`}");
};
var preserveTrailingSpace = function preserveTrailingSpace(s) {
    var result = s;
    if (result.endsWith(" ")) result = result.replace(/^(.*?)(\s+)$/, "$1{'$2'}");
    if (result.startsWith(" ")) result = result.replace(/^(\s+)(.*)$/, "{'$1'}$2");
    return result;
};
var formatTreeNode = function(node, inline, lvl, options) {
    if (node.type === "number") return String(node.value);
    if (node.type === "string") return node.value ? "".concat(preserveTrailingSpace(escape(String(node.value)))) : "";
    if (node.type === "ReactElement") return formatReactElementNode(node, inline, lvl, options);
    if (node.type === "ReactFragment") return formatReactFragmentNode(node, inline, lvl, options);
    throw new TypeError('Unknow format type "'.concat(node.type, '"'));
};
var formatTree = function(node, options) {
    return formatTreeNode(node, false, 0, options);
};
var reactElementToJsxString = function reactElementToJsxString(element) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, _ref$filterProps = _ref.filterProps, filterProps = _ref$filterProps === void 0 ? [] : _ref$filterProps, _ref$showDefaultProps = _ref.showDefaultProps, showDefaultProps = _ref$showDefaultProps === void 0 ? true : _ref$showDefaultProps, _ref$showFunctions = _ref.showFunctions, showFunctions = _ref$showFunctions === void 0 ? false : _ref$showFunctions, functionValue = _ref.functionValue, _ref$tabStop = _ref.tabStop, tabStop = _ref$tabStop === void 0 ? 2 : _ref$tabStop, _ref$useBooleanShorth = _ref.useBooleanShorthandSyntax, useBooleanShorthandSyntax = _ref$useBooleanShorth === void 0 ? true : _ref$useBooleanShorth, _ref$useFragmentShort = _ref.useFragmentShortSyntax, useFragmentShortSyntax = _ref$useFragmentShort === void 0 ? true : _ref$useFragmentShort, _ref$sortProps = _ref.sortProps, sortProps = _ref$sortProps === void 0 ? true : _ref$sortProps, maxInlineAttributesLineLength = _ref.maxInlineAttributesLineLength, displayName = _ref.displayName;
    if (!element) throw new Error("react-element-to-jsx-string: Expected a ReactElement");
    var options = {
        filterProps: filterProps,
        showDefaultProps: showDefaultProps,
        showFunctions: showFunctions,
        functionValue: functionValue,
        tabStop: tabStop,
        useBooleanShorthandSyntax: useBooleanShorthandSyntax,
        useFragmentShortSyntax: useFragmentShortSyntax,
        sortProps: sortProps,
        maxInlineAttributesLineLength: maxInlineAttributesLineLength,
        displayName: displayName
    };
    return formatTree(parseReactElement(element, options), options);
};
exports["default"] = reactElementToJsxString;
exports.inlineFunction = inlineFunction;
exports.preserveFunctionLineBreak = preserveFunctionLineBreak;

},{"1d245530f3f4b629":"ihK27","945717012d748ed1":"9yzVZ","e85dec79cec9b05c":"2MytB","49959fad3465d5db":"lG2Oc"}],"ihK27":[function(require,module,exports) {
/*!
 * is-plain-object <https://github.com/jonschlinkert/is-plain-object>
 *
 * Copyright (c) 2014-2017, Jon Schlinkert.
 * Released under the MIT License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isPlainObject", ()=>isPlainObject);
function isObject(o) {
    return Object.prototype.toString.call(o) === "[object Object]";
}
function isPlainObject(o) {
    var ctor, prot;
    if (isObject(o) === false) return false;
    // If has modified constructor
    ctor = o.constructor;
    if (ctor === undefined) return true;
    // If has modified prototype
    prot = ctor.prototype;
    if (isObject(prot) === false) return false;
    // If constructor does not have an Object-specific method
    if (prot.hasOwnProperty("isPrototypeOf") === false) return false;
    // Most likely a plain Object
    return true;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"2MytB":[function(require,module,exports) {
"use strict";
var __assign = this && this.__assign || function() {
    __assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = this && this.__spreadArrays || function() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
var seen = [];
/**
 * Check if a value is an object or a function. Keep in mind that array, function, regexp, etc, are objects in JavaScript.
 *
 * @param value the value to check
 * @return true if the value is an object or a function
 */ function isObj(value) {
    var type = typeof value;
    return value !== null && (type === "object" || type === "function");
}
/**
 * Check if a value is a regular expression.
 *
 * @param value the value to check
 * @return true if the value is a regular expression
 */ function isRegexp(value) {
    return Object.prototype.toString.call(value) === "[object RegExp]";
}
/**
 * Get an array of all of the enumerable symbols for an object.
 *
 * @param object the object to get the enumerable symbols for
 */ function getOwnEnumPropSymbols(object) {
    return Object.getOwnPropertySymbols(object).filter(function(keySymbol) {
        return Object.prototype.propertyIsEnumerable.call(object, keySymbol);
    });
}
/**
 * pretty print an object
 *
 * @param input the object to pretty print
 * @param options the formatting options, transforms, and filters
 * @param pad the padding string
 */ function prettyPrint(input, options, pad) {
    if (pad === void 0) pad = "";
    // sensible option defaults
    var defaultOptions = {
        indent: "	",
        singleQuotes: true
    };
    var combinedOptions = __assign(__assign({}, defaultOptions), options);
    var tokens;
    if (combinedOptions.inlineCharacterLimit === undefined) tokens = {
        newLine: "\n",
        newLineOrSpace: "\n",
        pad: pad,
        indent: pad + combinedOptions.indent
    };
    else tokens = {
        newLine: "@@__PRETTY_PRINT_NEW_LINE__@@",
        newLineOrSpace: "@@__PRETTY_PRINT_NEW_LINE_OR_SPACE__@@",
        pad: "@@__PRETTY_PRINT_PAD__@@",
        indent: "@@__PRETTY_PRINT_INDENT__@@"
    };
    var expandWhiteSpace = function(string) {
        if (combinedOptions.inlineCharacterLimit === undefined) return string;
        var oneLined = string.replace(new RegExp(tokens.newLine, "g"), "").replace(new RegExp(tokens.newLineOrSpace, "g"), " ").replace(new RegExp(tokens.pad + "|" + tokens.indent, "g"), "");
        if (oneLined.length <= combinedOptions.inlineCharacterLimit) return oneLined;
        return string.replace(new RegExp(tokens.newLine + "|" + tokens.newLineOrSpace, "g"), "\n").replace(new RegExp(tokens.pad, "g"), pad).replace(new RegExp(tokens.indent, "g"), pad + combinedOptions.indent);
    };
    if (seen.indexOf(input) !== -1) return '"[Circular]"';
    if (input === null || input === undefined || typeof input === "number" || typeof input === "boolean" || typeof input === "function" || typeof input === "symbol" || isRegexp(input)) return String(input);
    if (input instanceof Date) return "new Date('" + input.toISOString() + "')";
    if (Array.isArray(input)) {
        if (input.length === 0) return "[]";
        seen.push(input);
        var ret = "[" + tokens.newLine + input.map(function(el, i) {
            var eol = input.length - 1 === i ? tokens.newLine : "," + tokens.newLineOrSpace;
            var value = prettyPrint(el, combinedOptions, pad + combinedOptions.indent);
            if (combinedOptions.transform) value = combinedOptions.transform(input, i, value);
            return tokens.indent + value + eol;
        }).join("") + tokens.pad + "]";
        seen.pop();
        return expandWhiteSpace(ret);
    }
    if (isObj(input)) {
        var objKeys_1 = __spreadArrays(Object.keys(input), getOwnEnumPropSymbols(input));
        if (combinedOptions.filter) objKeys_1 = objKeys_1.filter(function(el) {
            return combinedOptions.filter && combinedOptions.filter(input, el);
        });
        if (objKeys_1.length === 0) return "{}";
        seen.push(input);
        var ret = "{" + tokens.newLine + objKeys_1.map(function(el, i) {
            var eol = objKeys_1.length - 1 === i ? tokens.newLine : "," + tokens.newLineOrSpace;
            var isSymbol = typeof el === "symbol";
            var isClassic = !isSymbol && /^[a-z$_][a-z$_0-9]*$/i.test(el.toString());
            var key = isSymbol || isClassic ? el : prettyPrint(el, combinedOptions);
            var value = prettyPrint(input[el], combinedOptions, pad + combinedOptions.indent);
            if (combinedOptions.transform) value = combinedOptions.transform(input, el, value);
            return tokens.indent + String(key) + ": " + value + eol;
        }).join("") + tokens.pad + "}";
        seen.pop();
        return expandWhiteSpace(ret);
    }
    input = String(input).replace(/[\r\n]/g, function(x) {
        return x === "\n" ? "\\n" : "\\r";
    });
    if (!combinedOptions.singleQuotes) {
        input = input.replace(/"/g, '\\"');
        return '"' + input + '"';
    }
    input = input.replace(/\\?'/g, "\\'");
    return "'" + input + "'";
}
exports.prettyPrint = prettyPrint;

},{}],"lG2Oc":[function(require,module,exports) {
"use strict";
module.exports = require("2dea8365f8e8f77e");

},{"2dea8365f8e8f77e":"fouvz"}],"fouvz":[function(require,module,exports) {
/** @license React v17.0.2
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var b = 60103, c = 60106, d = 60107, e = 60108, f = 60114, g = 60109, h = 60110, k = 60112, l = 60113, m = 60120, n = 60115, p = 60116, q = 60121, r = 60122, u = 60117, v = 60129, w = 60131;
if ("function" === typeof Symbol && Symbol.for) {
    var x = Symbol.for;
    b = x("react.element");
    c = x("react.portal");
    d = x("react.fragment");
    e = x("react.strict_mode");
    f = x("react.profiler");
    g = x("react.provider");
    h = x("react.context");
    k = x("react.forward_ref");
    l = x("react.suspense");
    m = x("react.suspense_list");
    n = x("react.memo");
    p = x("react.lazy");
    q = x("react.block");
    r = x("react.server.block");
    u = x("react.fundamental");
    v = x("react.debug_trace_mode");
    w = x("react.legacy_hidden");
}
function y(a) {
    if ("object" === typeof a && null !== a) {
        var t = a.$$typeof;
        switch(t){
            case b:
                switch(a = a.type, a){
                    case d:
                    case f:
                    case e:
                    case l:
                    case m:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case h:
                            case k:
                            case p:
                            case n:
                            case g:
                                return a;
                            default:
                                return t;
                        }
                }
            case c:
                return t;
        }
    }
}
var z = g, A = b, B = k, C = d, D = p, E = n, F = c, G = f, H = e, I = l;
exports.ContextConsumer = h;
exports.ContextProvider = z;
exports.Element = A;
exports.ForwardRef = B;
exports.Fragment = C;
exports.Lazy = D;
exports.Memo = E;
exports.Portal = F;
exports.Profiler = G;
exports.StrictMode = H;
exports.Suspense = I;
exports.isAsyncMode = function() {
    return !1;
};
exports.isConcurrentMode = function() {
    return !1;
};
exports.isContextConsumer = function(a) {
    return y(a) === h;
};
exports.isContextProvider = function(a) {
    return y(a) === g;
};
exports.isElement = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === b;
};
exports.isForwardRef = function(a) {
    return y(a) === k;
};
exports.isFragment = function(a) {
    return y(a) === d;
};
exports.isLazy = function(a) {
    return y(a) === p;
};
exports.isMemo = function(a) {
    return y(a) === n;
};
exports.isPortal = function(a) {
    return y(a) === c;
};
exports.isProfiler = function(a) {
    return y(a) === f;
};
exports.isStrictMode = function(a) {
    return y(a) === e;
};
exports.isSuspense = function(a) {
    return y(a) === l;
};
exports.isValidElementType = function(a) {
    return "string" === typeof a || "function" === typeof a || a === d || a === f || a === v || a === e || a === l || a === m || a === w || "object" === typeof a && null !== a && (a.$$typeof === p || a.$$typeof === n || a.$$typeof === g || a.$$typeof === h || a.$$typeof === k || a.$$typeof === u || a.$$typeof === q || a[0] === r) ? !0 : !1;
};
exports.typeOf = y;

},{}],"iRLZl":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// react-docgen doesn't returned the props in the order they were defined in the "propTypes" object of the component.
// This function re-order them by their original definition order.
parcelHelpers.export(exports, "keepOriginalDefinitionOrder", ()=>keepOriginalDefinitionOrder);
var _esArrayFilterJs = require("core-js/modules/es.array.filter.js");
var _esObjectToStringJs = require("core-js/modules/es.object.to-string.js");
var _esArrayMapJs = require("core-js/modules/es.array.map.js");
var _esObjectKeysJs = require("core-js/modules/es.object.keys.js");
var _esArrayFindJs = require("core-js/modules/es.array.find.js");
var _esFunctionNameJs = require("core-js/modules/es.function.name.js");
function keepOriginalDefinitionOrder(extractedProps, component) {
    // eslint-disable-next-line react/forbid-foreign-prop-types
    var propTypes = component.propTypes;
    if (propTypes != null) return Object.keys(propTypes).map(function(x) {
        return extractedProps.find(function(y) {
            return y.name === x;
        });
    }).filter(function(x) {
        return x;
    });
    return extractedProps;
}

},{"core-js/modules/es.array.filter.js":"fD2da","core-js/modules/es.object.to-string.js":"lsA9p","core-js/modules/es.array.map.js":"jTP7e","core-js/modules/es.object.keys.js":"5Q2AT","core-js/modules/es.array.find.js":"hWBPu","core-js/modules/es.function.name.js":"4LiLL","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"g5Ptv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "rawDefaultPropTypeResolvers", ()=>rawDefaultPropTypeResolvers);
var _esFunctionNameJs = require("core-js/modules/es.function.name.js");
var _esObjectToStringJs = require("core-js/modules/es.object.to-string.js");
var _esRegexpToStringJs = require("core-js/modules/es.regexp.to-string.js");
var _docsTools = require("@storybook/docs-tools");
var _defaultValues = require("../lib/defaultValues");
var _lib = require("../lib");
var _prettyIdentifier = require("../lib/defaultValues/prettyIdentifier");
var _inspection = require("../lib/inspection");
var funcResolver = function funcResolver(rawDefaultProp, _ref) {
    var name = _ref.name, type = _ref.type;
    var isElement = type.summary === "element" || type.summary === "elementType";
    var funcName = (0, _defaultValues.extractFunctionName)(rawDefaultProp, name);
    if (funcName != null) {
        // Try to display the name of the component. The body of the component is omitted since the code has been transpiled.
        if (isElement) return (0, _docsTools.createSummaryValue)((0, _prettyIdentifier.getPrettyElementIdentifier)(funcName));
        var _ref2 = (0, _inspection.inspectValue)(rawDefaultProp.toString()).inferredType, hasParams = _ref2.hasParams;
        return (0, _docsTools.createSummaryValue)((0, _prettyIdentifier.getPrettyFuncIdentifier)(funcName, hasParams));
    }
    return (0, _docsTools.createSummaryValue)(isElement ? (0, _lib.ELEMENT_CAPTION) : (0, _lib.FUNCTION_CAPTION));
};
var rawDefaultPropTypeResolvers = (0, _defaultValues.createTypeResolvers)({
    function: funcResolver
});

},{"core-js/modules/es.function.name.js":"4LiLL","core-js/modules/es.object.to-string.js":"lsA9p","core-js/modules/es.regexp.to-string.js":"bGzly","@storybook/docs-tools":"c0Wnz","../lib/defaultValues":"kXKoJ","../lib":"1EkZw","../lib/defaultValues/prettyIdentifier":"gbmPg","../lib/inspection":"g7DSz","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"j7O5n":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "enhanceTypeScriptProp", ()=>enhanceTypeScriptProp);
parcelHelpers.export(exports, "enhanceTypeScriptProps", ()=>enhanceTypeScriptProps);
var _esArrayMapJs = require("core-js/modules/es.array.map.js");
var _defaultValues = require("../lib/defaultValues");
function enhanceTypeScriptProp(extractedProp, rawDefaultProp) {
    var propDef = extractedProp.propDef;
    var defaultValue = extractedProp.docgenInfo.defaultValue;
    if (defaultValue != null && defaultValue.value != null) {
        var newDefaultValue = (0, _defaultValues.createDefaultValue)(defaultValue.value);
        if (newDefaultValue != null) propDef.defaultValue = newDefaultValue;
    } else if (rawDefaultProp != null) {
        var _newDefaultValue = (0, _defaultValues.createDefaultValueFromRawDefaultProp)(rawDefaultProp, propDef);
        if (_newDefaultValue != null) propDef.defaultValue = _newDefaultValue;
    }
    return propDef;
}
function enhanceTypeScriptProps(extractedProps) {
    return extractedProps.map(function(prop) {
        return enhanceTypeScriptProp(prop);
    });
}

},{"core-js/modules/es.array.map.js":"jTP7e","../lib/defaultValues":"kXKoJ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"4wgBZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "renderJsx", ()=>renderJsx);
parcelHelpers.export(exports, "skipJsxRender", ()=>skipJsxRender);
parcelHelpers.export(exports, "jsxDecorator", ()=>jsxDecorator);
var _esArraySliceJs = require("core-js/modules/es.array.slice.js");
var _esObjectFreezeJs = require("core-js/modules/es.object.freeze.js");
var _esObjectKeysJs = require("core-js/modules/es.object.keys.js");
var _esSymbolJs = require("core-js/modules/es.symbol.js");
var _esSymbolDescriptionJs = require("core-js/modules/es.symbol.description.js");
var _esSymbolIteratorJs = require("core-js/modules/es.symbol.iterator.js");
var _esArrayIteratorJs = require("core-js/modules/es.array.iterator.js");
var _esStringIteratorJs = require("core-js/modules/es.string.iterator.js");
var _webDomCollectionsIteratorJs = require("core-js/modules/web.dom-collections.iterator.js");
var _esArrayFromJs = require("core-js/modules/es.array.from.js");
var _esFunctionNameJs = require("core-js/modules/es.function.name.js");
var _esObjectAssignJs = require("core-js/modules/es.object.assign.js");
var _esArrayJoinJs = require("core-js/modules/es.array.join.js");
var _esArrayMapJs = require("core-js/modules/es.array.map.js");
var _esObjectToStringJs = require("core-js/modules/es.object.to-string.js");
var _esRegexpToStringJs = require("core-js/modules/es.regexp.to-string.js");
var _esRegexpExecJs = require("core-js/modules/es.regexp.exec.js");
var _esStringMatchJs = require("core-js/modules/es.string.match.js");
var _webDomCollectionsForEachJs = require("core-js/modules/web.dom-collections.for-each.js");
var _esStringReplaceJs = require("core-js/modules/es.string.replace.js");
var _esArrayConcatJs = require("core-js/modules/es.array.concat.js");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactElementToJsxString = require("react-element-to-jsx-string");
var _reactElementToJsxStringDefault = parcelHelpers.interopDefault(_reactElementToJsxString);
var _tsDedent = require("ts-dedent");
var _tsDedentDefault = parcelHelpers.interopDefault(_tsDedent);
var _utilDeprecate = require("util-deprecate");
var _utilDeprecateDefault = parcelHelpers.interopDefault(_utilDeprecate);
var _addons = require("@storybook/addons");
var _docsTools = require("@storybook/docs-tools");
var _clientLogger = require("@storybook/client-logger");
var _lib = require("./lib");
var _excluded = [
    "mdxType",
    "originalType",
    "children"
];
var _templateObject;
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) raw = strings.slice(0);
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
/** Run the user supplied onBeforeRender function if it exists */ var applyBeforeRender = function applyBeforeRender(domString, options) {
    if (typeof options.onBeforeRender !== "function") return domString;
    var deprecatedOnBeforeRender = (0, _utilDeprecateDefault.default)(options.onBeforeRender, (0, _tsDedentDefault.default)(_templateObject || (_templateObject = _taggedTemplateLiteral([
        "\n      StoryFn.parameters.jsx.onBeforeRender was deprecated.\n      Prefer StoryFn.parameters.jsx.transformSource instead.\n      See https://github.com/storybookjs/storybook/blob/next/MIGRATION.md#deprecated-onbeforerender for details.\n    "
    ]))));
    return deprecatedOnBeforeRender(domString);
};
/** Run the user supplied transformSource function if it exists */ var applyTransformSource = function applyTransformSource(domString, options, context) {
    if (typeof options.transformSource !== "function") return domString;
    return options.transformSource(domString, context);
};
var renderJsx = function renderJsx(code, options) {
    if (typeof code === "undefined") {
        (0, _clientLogger.logger).warn("Too many skip or undefined component");
        return null;
    }
    var renderedJSX = code;
    var Type = renderedJSX.type;
    for(var i = 0; i < options.skip; i += 1){
        if (typeof renderedJSX === "undefined") {
            (0, _clientLogger.logger).warn("Cannot skip undefined element");
            return null;
        }
        if ((0, _reactDefault.default).Children.count(renderedJSX) > 1) {
            (0, _clientLogger.logger).warn("Trying to skip an array of elements");
            return null;
        }
        if (typeof renderedJSX.props.children === "undefined") {
            (0, _clientLogger.logger).warn("Not enough children to skip elements.");
            if (typeof renderedJSX.type === "function" && renderedJSX.type.name === "") renderedJSX = /*#__PURE__*/ (0, _reactDefault.default).createElement(Type, renderedJSX.props);
        } else if (typeof renderedJSX.props.children === "function") renderedJSX = renderedJSX.props.children();
        else renderedJSX = renderedJSX.props.children;
    }
    var displayNameDefaults = typeof options.displayName === "string" ? {
        showFunctions: true,
        displayName: function displayName() {
            return options.displayName;
        }
    } : {
        // To get exotic component names resolving properly
        displayName: function displayName(el) {
            return el.type.displayName || (0, _docsTools.getDocgenSection)(el.type, "displayName") || (el.type.name !== "_default" ? el.type.name : null) || (typeof el.type === "function" ? "No Display Name" : null) || ((0, _lib.isForwardRef)(el.type) ? el.type.render.name : null) || ((0, _lib.isMemo)(el.type) ? el.type.type.name : null) || el.type;
        }
    };
    var filterDefaults = {
        filterProps: function filterProps(value, key) {
            return value !== undefined;
        }
    };
    var opts = Object.assign({}, displayNameDefaults, filterDefaults, options);
    var result = (0, _reactDefault.default).Children.map(code, function(c) {
        // @ts-ignore FIXME: workaround react-element-to-jsx-string
        var child = typeof c === "number" ? c.toString() : c;
        var string = applyBeforeRender((0, _reactElementToJsxStringDefault.default)(child, opts), options);
        if (string.indexOf("&quot;") > -1) {
            var matches = string.match(/\S+=\\"([^"]*)\\"/g);
            if (matches) matches.forEach(function(match) {
                string = string.replace(match, match.replace(/&quot;/g, "'"));
            });
        }
        return string;
    }).join("\n");
    return result.replace(/function\s+noRefCheck\(\)\s+\{\}/, "() => {}");
};
var defaultOpts = {
    skip: 0,
    showFunctions: false,
    enableBeautify: true,
    showDefaultProps: false
};
var skipJsxRender = function skipJsxRender(context) {
    var _context$parameters$d;
    var sourceParams = context === null || context === void 0 ? void 0 : (_context$parameters$d = context.parameters.docs) === null || _context$parameters$d === void 0 ? void 0 : _context$parameters$d.source;
    var isArgsStory = context === null || context === void 0 ? void 0 : context.parameters.__isArgsStory; // always render if the user forces it
    if ((sourceParams === null || sourceParams === void 0 ? void 0 : sourceParams.type) === (0, _docsTools.SourceType).DYNAMIC) return false;
     // never render if the user is forcing the block to render code, or
    // if the user provides code, or if it's not an args story.
    return !isArgsStory || (sourceParams === null || sourceParams === void 0 ? void 0 : sourceParams.code) || (sourceParams === null || sourceParams === void 0 ? void 0 : sourceParams.type) === (0, _docsTools.SourceType).CODE;
};
var isMdx = function isMdx(node) {
    var _node$type, _node$props;
    return ((_node$type = node.type) === null || _node$type === void 0 ? void 0 : _node$type.displayName) === "MDXCreateElement" && !!((_node$props = node.props) !== null && _node$props !== void 0 && _node$props.mdxType);
};
var mdxToJsx = function mdxToJsx(node) {
    if (!isMdx(node)) return node;
    var _node$props2 = node.props, mdxType = _node$props2.mdxType, originalType = _node$props2.originalType, children = _node$props2.children, rest = _objectWithoutProperties(_node$props2, _excluded);
    var jsxChildren = [];
    if (children) {
        var array = Array.isArray(children) ? children : [
            children
        ];
        jsxChildren = array.map(mdxToJsx);
    }
    return /*#__PURE__*/ (0, _react.createElement).apply(void 0, [
        originalType,
        rest
    ].concat(_toConsumableArray(jsxChildren)));
};
var jsxDecorator = function jsxDecorator(storyFn, context) {
    var _context$parameters$d2, _context$parameters$d3;
    var channel = (0, _addons.addons).getChannel();
    var skip = skipJsxRender(context);
    var story = storyFn();
    var jsx = "";
    (0, _addons.useEffect)(function() {
        if (!skip) channel.emit((0, _docsTools.SNIPPET_RENDERED), (context || {}).id, jsx);
    }); // We only need to render JSX if the source block is actually going to
    // consume it. Otherwise it's just slowing us down.
    if (skip) return story;
    var options = Object.assign({}, defaultOpts, (context === null || context === void 0 ? void 0 : context.parameters.jsx) || {}); // Exclude decorators from source code snippet by default
    var storyJsx = context !== null && context !== void 0 && (_context$parameters$d2 = context.parameters.docs) !== null && _context$parameters$d2 !== void 0 && (_context$parameters$d3 = _context$parameters$d2.source) !== null && _context$parameters$d3 !== void 0 && _context$parameters$d3.excludeDecorators ? context.originalStoryFn(context.args, context) : story;
    var sourceJsx = mdxToJsx(storyJsx);
    var rendered = renderJsx(sourceJsx, options);
    if (rendered) jsx = applyTransformSource(rendered, options, context);
    return story;
};

},{"core-js/modules/es.array.slice.js":"8RRh9","core-js/modules/es.object.freeze.js":"9LVYO","core-js/modules/es.object.keys.js":"5Q2AT","core-js/modules/es.symbol.js":"ajw2f","core-js/modules/es.symbol.description.js":"wrlLc","core-js/modules/es.symbol.iterator.js":"fhNIb","core-js/modules/es.array.iterator.js":"ieU20","core-js/modules/es.string.iterator.js":"74a8v","core-js/modules/web.dom-collections.iterator.js":"aXR96","core-js/modules/es.array.from.js":"9UCQw","core-js/modules/es.function.name.js":"4LiLL","core-js/modules/es.object.assign.js":"8FU8M","core-js/modules/es.array.join.js":"1w71h","core-js/modules/es.array.map.js":"jTP7e","core-js/modules/es.object.to-string.js":"lsA9p","core-js/modules/es.regexp.to-string.js":"bGzly","core-js/modules/es.regexp.exec.js":"5q56v","core-js/modules/es.string.match.js":"e2YpX","core-js/modules/web.dom-collections.for-each.js":"iYT1M","core-js/modules/es.string.replace.js":"bFiJG","core-js/modules/es.array.concat.js":"g1t7q","react":"9yzVZ","react-element-to-jsx-string":"9CiTf","ts-dedent":"9RvVa","util-deprecate":"lYmRJ","@storybook/addons":"88cx9","@storybook/docs-tools":"c0Wnz","@storybook/client-logger":"iGRus","./lib":"1EkZw","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"4GgrA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "render", ()=>(0, _render.render));
parcelHelpers.export(exports, "renderToDOM", ()=>(0, _render.renderToDOM));
parcelHelpers.export(exports, "parameters", ()=>parameters);
var _render = require("./render");
var parameters = {
    framework: "react"
};

},{"./render":"bkYMe","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"ijWdZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _preview = require("./dist/esm/preset/preview");
parcelHelpers.exportAll(_preview, exports);

},{"./dist/esm/preset/preview":"dzQK5","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"dzQK5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _addDecorator = require("./addDecorator");
parcelHelpers.exportAll(_addDecorator, exports);
var _addArgs = require("./addArgs");
parcelHelpers.exportAll(_addArgs, exports);

},{"./addDecorator":"1MHNL","./addArgs":"gUc0C","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"1MHNL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "decorators", ()=>decorators);
var _index = require("../index");
var decorators = [
    (0, _index.withActions)
];

},{"../index":"coXbW","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"gUc0C":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "argsEnhancers", ()=>argsEnhancers);
var _addArgsHelpers = require("./addArgsHelpers");
var argsEnhancers = [
    (0, _addArgsHelpers.addActionsFromArgTypes),
    (0, _addArgsHelpers.inferActionsFromArgTypesRegex)
];

},{"./addArgsHelpers":"1RvqC","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"1RvqC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "inferActionsFromArgTypesRegex", ()=>inferActionsFromArgTypesRegex);
parcelHelpers.export(exports, "addActionsFromArgTypes", ()=>addActionsFromArgTypes);
var _esRegexpConstructorJs = require("core-js/modules/es.regexp.constructor.js");
var _esRegexpExecJs = require("core-js/modules/es.regexp.exec.js");
var _esRegexpToStringJs = require("core-js/modules/es.regexp.to-string.js");
var _esArrayFilterJs = require("core-js/modules/es.array.filter.js");
var _esObjectToStringJs = require("core-js/modules/es.object.to-string.js");
var _esObjectEntriesJs = require("core-js/modules/es.object.entries.js");
var _esSymbolJs = require("core-js/modules/es.symbol.js");
var _esSymbolDescriptionJs = require("core-js/modules/es.symbol.description.js");
var _esSymbolIteratorJs = require("core-js/modules/es.symbol.iterator.js");
var _esArrayIteratorJs = require("core-js/modules/es.array.iterator.js");
var _esStringIteratorJs = require("core-js/modules/es.string.iterator.js");
var _webDomCollectionsIteratorJs = require("core-js/modules/web.dom-collections.iterator.js");
var _esArraySliceJs = require("core-js/modules/es.array.slice.js");
var _esFunctionNameJs = require("core-js/modules/es.function.name.js");
var _esArrayFromJs = require("core-js/modules/es.array.from.js");
var _index = require("../index"); // interface ActionsParameter {
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
//   disable?: boolean;
//   argTypesRegex?: RegExp;
// }
var isInInitialArgs = function isInInitialArgs(name, initialArgs) {
    return typeof initialArgs[name] === "undefined" && !(name in initialArgs);
};
var inferActionsFromArgTypesRegex = function inferActionsFromArgTypesRegex(context) {
    var initialArgs = context.initialArgs, argTypes = context.argTypes, actions = context.parameters.actions;
    if (!actions || actions.disable || !actions.argTypesRegex || !argTypes) return {};
    var argTypesRegex = new RegExp(actions.argTypesRegex);
    var argTypesMatchingRegex = Object.entries(argTypes).filter(function(_ref) {
        var _ref2 = _slicedToArray(_ref, 1), name = _ref2[0];
        return !!argTypesRegex.test(name);
    });
    return argTypesMatchingRegex.reduce(function(acc, _ref3) {
        var _ref4 = _slicedToArray(_ref3, 2), name = _ref4[0], argType = _ref4[1];
        if (isInInitialArgs(name, initialArgs)) acc[name] = (0, _index.action)(name);
        return acc;
    }, {});
};
var addActionsFromArgTypes = function addActionsFromArgTypes(context) {
    var initialArgs = context.initialArgs, argTypes = context.argTypes, actions = context.parameters.actions;
    if (actions !== null && actions !== void 0 && actions.disable || !argTypes) return {};
    var argTypesWithAction = Object.entries(argTypes).filter(function(_ref5) {
        var _ref6 = _slicedToArray(_ref5, 2), name = _ref6[0], argType = _ref6[1];
        return !!argType.action;
    });
    return argTypesWithAction.reduce(function(acc, _ref7) {
        var _ref8 = _slicedToArray(_ref7, 2), name = _ref8[0], argType = _ref8[1];
        if (isInInitialArgs(name, initialArgs)) acc[name] = (0, _index.action)(typeof argType.action === "string" ? argType.action : name);
        return acc;
    }, {});
};

},{"core-js/modules/es.regexp.constructor.js":"eR7Pe","core-js/modules/es.regexp.exec.js":"5q56v","core-js/modules/es.regexp.to-string.js":"bGzly","core-js/modules/es.array.filter.js":"fD2da","core-js/modules/es.object.to-string.js":"lsA9p","core-js/modules/es.object.entries.js":"7Wf79","core-js/modules/es.symbol.js":"ajw2f","core-js/modules/es.symbol.description.js":"wrlLc","core-js/modules/es.symbol.iterator.js":"fhNIb","core-js/modules/es.array.iterator.js":"ieU20","core-js/modules/es.string.iterator.js":"74a8v","core-js/modules/web.dom-collections.iterator.js":"aXR96","core-js/modules/es.array.slice.js":"8RRh9","core-js/modules/es.function.name.js":"4LiLL","core-js/modules/es.array.from.js":"9UCQw","../index":"coXbW","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"knTti":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _preview = require("./dist/esm/preview");
parcelHelpers.exportAll(_preview, exports);

},{"./dist/esm/preview":"a57Bo","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"a57Bo":[function(require,module,exports) {
var _a11YRunner = require("./a11yRunner");
var _a11YHighlight = require("./a11yHighlight");

},{"./a11yRunner":"8VgfU","./a11yHighlight":"epxyH"}],"8VgfU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
var _esObjectToStringJs = require("core-js/modules/es.object.to-string.js");
var _esPromiseJs = require("core-js/modules/es.promise.js");
var _global = require("global");
var _globalDefault = parcelHelpers.interopDefault(_global);
var _addons = require("@storybook/addons");
var _constants = require("./constants");
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
var document = (0, _globalDefault.default).document, globalWindow = (0, _globalDefault.default).window;
if (module && module.hot && module.hot.decline) module.hot.decline();
var channel = (0, _addons.addons).getChannel(); // Holds axe core running state
var active = false; // Holds latest story we requested a run
var activeStoryId;
/**
 * Handle A11yContext events.
 * Because the event are sent without manual check, we split calls
 */ var handleRequest = /*#__PURE__*/ function() {
    var _ref = _asyncToGenerator(/*#__PURE__*/ regeneratorRuntime.mark(function _callee(storyId) {
        var _yield$getParams, manual;
        return regeneratorRuntime.wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    _context.next = 2;
                    return getParams(storyId);
                case 2:
                    _yield$getParams = _context.sent;
                    manual = _yield$getParams.manual;
                    if (manual) {
                        _context.next = 7;
                        break;
                    }
                    _context.next = 7;
                    return run(storyId);
                case 7:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return function handleRequest(_x) {
        return _ref.apply(this, arguments);
    };
}();
var run = /*#__PURE__*/ function() {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/ regeneratorRuntime.mark(function _callee2(storyId) {
        var input, axe, _input$element, element, config, _input$options, options, htmlElement, result;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while(true)switch(_context2.prev = _context2.next){
                case 0:
                    activeStoryId = storyId;
                    _context2.prev = 1;
                    _context2.next = 4;
                    return getParams(storyId);
                case 4:
                    input = _context2.sent;
                    if (active) {
                        _context2.next = 19;
                        break;
                    }
                    active = true;
                    channel.emit((0, _constants.EVENTS).RUNNING);
                    _context2.next = 10;
                    return require("bea7f20bc6e55379");
                case 10:
                    axe = _context2.sent.default;
                    _input$element = input.element, element = _input$element === void 0 ? "#root" : _input$element, config = input.config, _input$options = input.options, options = _input$options === void 0 ? {} : _input$options;
                    htmlElement = document.querySelector(element);
                    axe.reset();
                    if (config) axe.configure(config);
                    _context2.next = 17;
                    return axe.run(htmlElement, options);
                case 17:
                    result = _context2.sent;
                    // It's possible that we requested a new run on a different story.
                    // Unfortunately, axe doesn't support a cancel method to abort current run.
                    // We check if the story we run against is still the current one,
                    // if not, trigger a new run using the current story
                    if (activeStoryId === storyId) channel.emit((0, _constants.EVENTS).RESULT, result);
                    else {
                        active = false;
                        run(activeStoryId);
                    }
                case 19:
                    _context2.next = 24;
                    break;
                case 21:
                    _context2.prev = 21;
                    _context2.t0 = _context2["catch"](1);
                    channel.emit((0, _constants.EVENTS).ERROR, _context2.t0);
                case 24:
                    _context2.prev = 24;
                    active = false;
                    return _context2.finish(24);
                case 27:
                case "end":
                    return _context2.stop();
            }
        }, _callee2, null, [
            [
                1,
                21,
                24,
                27
            ]
        ]);
    }));
    return function run(_x2) {
        return _ref2.apply(this, arguments);
    };
}();
/** Returns story parameters or default ones. */ var getParams = /*#__PURE__*/ function() {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/ regeneratorRuntime.mark(function _callee3(storyId) {
        var _ref4, parameters;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
            while(true)switch(_context3.prev = _context3.next){
                case 0:
                    _context3.next = 2;
                    return globalWindow.__STORYBOOK_STORY_STORE__.loadStory({
                        storyId: storyId
                    });
                case 2:
                    _context3.t0 = _context3.sent;
                    if (_context3.t0) {
                        _context3.next = 5;
                        break;
                    }
                    _context3.t0 = {};
                case 5:
                    _ref4 = _context3.t0;
                    parameters = _ref4.parameters;
                    return _context3.abrupt("return", parameters.a11y || {
                        config: {},
                        options: {
                            restoreScroll: true
                        }
                    });
                case 8:
                case "end":
                    return _context3.stop();
            }
        }, _callee3);
    }));
    return function getParams(_x3) {
        return _ref3.apply(this, arguments);
    };
}();
channel.on((0, _constants.EVENTS).REQUEST, handleRequest);
channel.on((0, _constants.EVENTS).MANUAL, run);

},{"core-js/modules/es.object.to-string.js":"lsA9p","core-js/modules/es.promise.js":"2jax7","global":"5PzlO","@storybook/addons":"88cx9","./constants":"jpy5u","bea7f20bc6e55379":"y8YVg","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"jpy5u":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ADDON_ID", ()=>ADDON_ID);
parcelHelpers.export(exports, "PANEL_ID", ()=>PANEL_ID);
parcelHelpers.export(exports, "PARAM_KEY", ()=>PARAM_KEY);
parcelHelpers.export(exports, "HIGHLIGHT_STYLE_ID", ()=>HIGHLIGHT_STYLE_ID);
parcelHelpers.export(exports, "EVENTS", ()=>EVENTS);
var ADDON_ID = "storybook/a11y";
var PANEL_ID = "".concat(ADDON_ID, "/panel");
var PARAM_KEY = "a11y";
var HIGHLIGHT_STYLE_ID = "a11yHighlight";
var RESULT = "".concat(ADDON_ID, "/result");
var REQUEST = "".concat(ADDON_ID, "/request");
var RUNNING = "".concat(ADDON_ID, "/running");
var ERROR = "".concat(ADDON_ID, "/error");
var MANUAL = "".concat(ADDON_ID, "/manual");
var HIGHLIGHT = "".concat(ADDON_ID, "/highlight");
var EVENTS = {
    RESULT: RESULT,
    REQUEST: REQUEST,
    RUNNING: RUNNING,
    ERROR: ERROR,
    MANUAL: MANUAL,
    HIGHLIGHT: HIGHLIGHT
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"y8YVg":[function(require,module,exports) {
module.exports = require("ce9b1c9b9afa3567")(require("85b65c602c908393").resolve("3ZBjP")).then(()=>module.bundle.root("jnagv"));

},{"ce9b1c9b9afa3567":"egp6W","85b65c602c908393":"f7Lf0"}],"epxyH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
var _esArrayFromJs = require("core-js/modules/es.array.from.js");
var _esStringIteratorJs = require("core-js/modules/es.string.iterator.js");
var _esArrayIteratorJs = require("core-js/modules/es.array.iterator.js");
var _esObjectToStringJs = require("core-js/modules/es.object.to-string.js");
var _esSetJs = require("core-js/modules/es.set.js");
var _webDomCollectionsIteratorJs = require("core-js/modules/web.dom-collections.iterator.js");
var _esArrayJoinJs = require("core-js/modules/es.array.join.js");
var _esArrayMapJs = require("core-js/modules/es.array.map.js");
var _esArrayConcatJs = require("core-js/modules/es.array.concat.js");
var _global = require("global");
var _globalDefault = parcelHelpers.interopDefault(_global);
var _addons = require("@storybook/addons");
var _coreEvents = require("@storybook/core-events");
var _constants = require("./constants");
var _highlight = require("./highlight");
var document = (0, _globalDefault.default).document;
if (module && module.hot && module.hot.decline) module.hot.decline();
var channel = (0, _addons.addons).getChannel();
var highlight = function highlight(infos) {
    var id = (0, _constants.HIGHLIGHT_STYLE_ID);
    resetHighlight(); // Make sure there are no duplicated selectors
    var elements = Array.from(new Set(infos.elements));
    var sheet = document.createElement("style");
    sheet.setAttribute("id", id);
    sheet.innerHTML = elements.map(function(target) {
        return "".concat(target, "{\n          ").concat((0, _highlight.highlightStyle)(infos.color), "\n         }");
    }).join(" ");
    document.head.appendChild(sheet);
};
var resetHighlight = function resetHighlight() {
    var id = (0, _constants.HIGHLIGHT_STYLE_ID);
    var sheetToBeRemoved = document.getElementById(id);
    if (sheetToBeRemoved) sheetToBeRemoved.parentNode.removeChild(sheetToBeRemoved);
};
channel.on((0, _coreEvents.STORY_CHANGED), resetHighlight);
channel.on((0, _constants.EVENTS).HIGHLIGHT, highlight);

},{"core-js/modules/es.array.from.js":"9UCQw","core-js/modules/es.string.iterator.js":"74a8v","core-js/modules/es.array.iterator.js":"ieU20","core-js/modules/es.object.to-string.js":"lsA9p","core-js/modules/es.set.js":"6FW6g","core-js/modules/web.dom-collections.iterator.js":"aXR96","core-js/modules/es.array.join.js":"1w71h","core-js/modules/es.array.map.js":"jTP7e","core-js/modules/es.array.concat.js":"g1t7q","global":"5PzlO","@storybook/addons":"88cx9","@storybook/core-events":"bJpgo","./constants":"jpy5u","./highlight":"iCILw","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"iCILw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "highlightStyle", ()=>highlightStyle);
parcelHelpers.export(exports, "highlightObject", ()=>highlightObject);
var highlightStyle = function highlightStyle(color) {
    return "\n  outline: 2px dashed ".concat(color, ";\n  outline-offset: 2px;\n  box-shadow: 0 0 0 6px rgba(255,255,255,0.6);\n");
};
var highlightObject = function highlightObject(color) {
    return {
        outline: "2px dashed ".concat(color),
        outlineOffset: 2,
        boxShadow: "0 0 0 6px rgba(255,255,255,0.6),"
    };
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"iQ6hh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parameters", ()=>parameters);
parcelHelpers.export(exports, "decorators", ()=>decorators);
var _addonActions = require("@storybook/addon-actions");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _provider = require("./custom-addons/provider");
var _scrolling = require("./custom-addons/scrolling");
var _strictmode = require("./custom-addons/strictmode");
// decorator order matters, the last one will be the outer most
(0, _addonActions.configureActions)({
    depth: 10
});
const parameters = {
    options: {
        storySort: (a, b)=>a[1].kind === b[1].kind ? 0 : a[1].id.localeCompare(b[1].id, undefined, {
                numeric: true
            })
    },
    a11y: {
        config: {
            rules: [
                {
                    id: "aria-hidden-focus",
                    selector: 'body *:not([data-a11y-ignore="aria-hidden-focus"])'
                }
            ]
        }
    },
    layout: "fullscreen",
    // Stops infinite loop memory crash when saving CSF stories https://github.com/storybookjs/storybook/issues/12747#issuecomment-1151803506
    docs: {
        source: {
            type: "code"
        }
    }
};
const decorators = [
    (0, _scrolling.withScrollingSwitcher),
    (0, _provider.withProviderSwitcher)
];

},{"@storybook/addon-actions":"coXbW","react":"9yzVZ","./custom-addons/provider":"60ap4","./custom-addons/scrolling":"61mgK","./custom-addons/strictmode":"ddKKM","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"60ap4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "withProviderSwitcher", ()=>withProviderSwitcher);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _addons = require("@storybook/addons");
var _addonsDefault = parcelHelpers.interopDefault(_addons);
var _clientApi = require("@storybook/client-api");
var _provider = require("@react-spectrum/provider");
var _constants = require("../../constants");
document.body.style.margin = "0";
const providerValuesFromUrl = Object.entries((0, _clientApi.getQueryParams)()).reduce((acc, [k, v])=>{
    if (k.includes("providerSwitcher-")) return {
        ...acc,
        [k.replace("providerSwitcher-", "")]: v
    };
    return acc;
}, {});
function ProviderUpdater(props) {
    let [localeValue, setLocale] = (0, _react.useState)(providerValuesFromUrl.locale || undefined);
    let [themeValue, setTheme] = (0, _react.useState)(providerValuesFromUrl.theme || undefined);
    let [scaleValue, setScale] = (0, _react.useState)(providerValuesFromUrl.scale || undefined);
    let [expressValue, setExpress] = (0, _react.useState)(providerValuesFromUrl.express === "true");
    let [storyReady, setStoryReady] = (0, _react.useState)(window.parent === window || window.parent !== window.top); // reduce content flash because it takes a moment to get the provider details
    // Typically themes are provided with both light + dark, and both scales.
    // To build our selector to see all themes, we need to hack it a bit.
    let theme = (expressValue ? (0, _constants.expressThemes) : (0, _constants.themes))[themeValue || "light"] || (0, _constants.defaultTheme);
    let colorScheme = themeValue && themeValue.replace(/est$/, "");
    (0, _react.useEffect)(()=>{
        let channel = (0, _addonsDefault.default).getChannel();
        let providerUpdate = (event)=>{
            setLocale(event.locale);
            setTheme(event.theme === "Auto" ? undefined : event.theme);
            setScale(event.scale === "Auto" ? undefined : event.scale);
            setExpress(event.express);
            setStoryReady(true);
        };
        channel.on("provider/updated", providerUpdate);
        channel.emit("rsp/ready-for-update");
        return ()=>{
            channel.removeListener("provider/updated", providerUpdate);
        };
    }, []);
    if (props.options.mainElement == null) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _provider.Provider), {
        theme: theme,
        colorScheme: colorScheme,
        scale: scaleValue,
        locale: localeValue,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("main", {
            children: storyReady && props.children
        })
    });
    else return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _provider.Provider), {
        theme: theme,
        colorScheme: colorScheme,
        scale: scaleValue,
        locale: localeValue,
        children: storyReady && props.children
    });
}
const withProviderSwitcher = (0, _addons.makeDecorator)({
    name: "withProviderSwitcher",
    parameterName: "providerSwitcher",
    wrapper: (getStory, context, { options, parameters })=>{
        options = {
            ...options,
            ...parameters
        };
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)(ProviderUpdater, {
            options: options,
            context: context,
            children: getStory(context)
        });
    }
});

},{"react/jsx-runtime":"76HCq","react":"9yzVZ","@storybook/addons":"88cx9","@storybook/client-api":"5kgK6","@react-spectrum/provider":"5bCdp","../../constants":"dtvDh","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"76HCq":[function(require,module,exports) {
"use strict";
module.exports = require("e5e9711c2edf1a4e");

},{"e5e9711c2edf1a4e":"WjT8M"}],"WjT8M":[function(require,module,exports) {
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var f = require("3fd2a064dc1f3641"), k = Symbol.for("react.element"), l = Symbol.for("react.fragment"), m = Object.prototype.hasOwnProperty, n = f.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)m.call(a, b) && !p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: n.current
    };
}
exports.Fragment = l;
exports.jsx = q;
exports.jsxs = q;

},{"3fd2a064dc1f3641":"9yzVZ"}],"dtvDh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scales", ()=>scales);
parcelHelpers.export(exports, "defaultTheme", ()=>defaultTheme);
parcelHelpers.export(exports, "altTheme", ()=>altTheme);
parcelHelpers.export(exports, "themes", ()=>themes);
parcelHelpers.export(exports, "expressThemes", ()=>expressThemes);
parcelHelpers.export(exports, "locales", ()=>locales);
var _spectrumGlobalCss = require("@adobe/spectrum-css-temp/vars/spectrum-global.css");
var _spectrumGlobalCssDefault = parcelHelpers.interopDefault(_spectrumGlobalCss);
var _spectrumLightCss = require("@adobe/spectrum-css-temp/vars/spectrum-light.css");
var _spectrumLightCssDefault = parcelHelpers.interopDefault(_spectrumLightCss);
var _spectrumLightestCss = require("@adobe/spectrum-css-temp/vars/spectrum-lightest.css");
var _spectrumLightestCssDefault = parcelHelpers.interopDefault(_spectrumLightestCss);
var _spectrumDarkCss = require("@adobe/spectrum-css-temp/vars/spectrum-dark.css");
var _spectrumDarkCssDefault = parcelHelpers.interopDefault(_spectrumDarkCss);
var _spectrumDarkestCss = require("@adobe/spectrum-css-temp/vars/spectrum-darkest.css");
var _spectrumDarkestCssDefault = parcelHelpers.interopDefault(_spectrumDarkestCss);
var _spectrumMediumCss = require("@adobe/spectrum-css-temp/vars/spectrum-medium.css");
var _spectrumMediumCssDefault = parcelHelpers.interopDefault(_spectrumMediumCss);
var _spectrumLargeCss = require("@adobe/spectrum-css-temp/vars/spectrum-large.css");
var _spectrumLargeCssDefault = parcelHelpers.interopDefault(_spectrumLargeCss);
var _expressCss = require("@adobe/spectrum-css-temp/vars/express.css");
var _expressCssDefault = parcelHelpers.interopDefault(_expressCss);
const THEME = {
    global: (0, _spectrumGlobalCssDefault.default),
    light: (0, _spectrumLightCssDefault.default),
    lightest: (0, _spectrumLightestCssDefault.default),
    dark: (0, _spectrumDarkCssDefault.default),
    darkest: (0, _spectrumDarkestCssDefault.default)
};
const scales = {
    medium: (0, _spectrumMediumCssDefault.default),
    large: (0, _spectrumLargeCssDefault.default)
};
let defaultTheme = {
    global: THEME.global,
    light: THEME.light,
    dark: THEME.darkest,
    medium: scales.medium,
    large: scales.large
};
let altTheme = {
    global: THEME.global,
    light: THEME.lightest,
    dark: THEME.dark,
    medium: scales.medium,
    large: scales.large
};
let themes = {
    light: defaultTheme,
    dark: altTheme,
    lightest: altTheme,
    darkest: defaultTheme
};
let expressThemes = {};
for(let key in themes)expressThemes[key] = {
    ...themes[key],
    global: {
        ...themes[key].global,
        express: (0, _expressCssDefault.default).express
    },
    medium: {
        ...themes[key].medium,
        express: (0, _expressCssDefault.default).medium
    },
    large: {
        ...themes[key].large,
        express: (0, _expressCssDefault.default).large
    }
};
let locales = [
    {
        label: "Auto",
        value: ""
    },
    // Tier 1
    {
        label: "French (France)",
        value: "fr-FR"
    },
    {
        label: "French (Canada)",
        value: "fr-CA"
    },
    {
        label: "German (Germany)",
        value: "de-DE"
    },
    {
        label: "English (Great Britain)",
        value: "en-GB"
    },
    {
        label: "English (United States)",
        value: "en-US"
    },
    {
        label: "Japanese (Japan)",
        value: "ja-JP"
    },
    // // Tier 2
    {
        label: "Danish (Denmark)",
        value: "da-DK"
    },
    {
        label: "Dutch (Netherlands)",
        value: "nl-NL"
    },
    {
        label: "Finnish (Finland)",
        value: "fi-FI"
    },
    {
        label: "Italian (Italy)",
        value: "it-IT"
    },
    {
        label: "Norwegian (Norway)",
        value: "nb-NO"
    },
    {
        label: "Spanish (Spain)",
        value: "es-ES"
    },
    {
        label: "Swedish (Sweden)",
        value: "sv-SE"
    },
    {
        label: "Portuguese (Brazil)",
        value: "pt-BR"
    },
    // // Tier 3
    {
        label: "Chinese (Simplified)",
        value: "zh-CN"
    },
    {
        label: "Chinese (Traditional)",
        value: "zh-TW"
    },
    {
        label: "Korean (Korea)",
        value: "ko-KR"
    },
    // // Tier 4
    {
        label: "Bulgarian (Bulgaria)",
        value: "bg-BG"
    },
    {
        label: "Croatian (Croatia)",
        value: "hr-HR"
    },
    {
        label: "Czech (Czech Republic)",
        value: "cs-CZ"
    },
    {
        label: "Estonian (Estonia)",
        value: "et-EE"
    },
    {
        label: "Hungarian (Hungary)",
        value: "hu-HU"
    },
    {
        label: "Latvian (Latvia)",
        value: "lv-LV"
    },
    {
        label: "Lithuanian (Lithuania)",
        value: "lt-LT"
    },
    {
        label: "Polish (Poland)",
        value: "pl-PL"
    },
    {
        label: "Romanian (Romania)",
        value: "ro-RO"
    },
    {
        label: "Russian (Russia)",
        value: "ru-RU"
    },
    {
        label: "Serbian (Serbia)",
        value: "sr-SP"
    },
    {
        label: "Slovakian (Slovakia)",
        value: "sk-SK"
    },
    {
        label: "Slovenian (Slovenia)",
        value: "sl-SI"
    },
    {
        label: "Turkish (Turkey)",
        value: "tr-TR"
    },
    {
        label: "Ukrainian (Ukraine)",
        value: "uk-UA"
    },
    // // Tier 5
    {
        label: "Arabic (United Arab Emirates)",
        value: "ar-AE"
    },
    {
        label: "Greek (Greece)",
        value: "el-GR"
    },
    {
        label: "Hebrew (Israel)",
        value: "he-IL"
    }
];

},{"@adobe/spectrum-css-temp/vars/spectrum-global.css":"3JKS4","@adobe/spectrum-css-temp/vars/spectrum-light.css":"lgx8Y","@adobe/spectrum-css-temp/vars/spectrum-lightest.css":"heQSg","@adobe/spectrum-css-temp/vars/spectrum-dark.css":"hYcRq","@adobe/spectrum-css-temp/vars/spectrum-darkest.css":"gniV6","@adobe/spectrum-css-temp/vars/spectrum-medium.css":"8swdG","@adobe/spectrum-css-temp/vars/spectrum-large.css":"1BNjr","@adobe/spectrum-css-temp/vars/express.css":"5WKyD","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"heQSg":[function(require,module,exports) {
module.exports["spectrum--lightest"] = `NLciOW_spectrum--lightest`;

},{}],"hYcRq":[function(require,module,exports) {
module.exports["spectrum--dark"] = `_1qEKta_spectrum--dark`;

},{}],"61mgK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "withScrollingSwitcher", ()=>withScrollingSwitcher);
var _jsxRuntime = require("react/jsx-runtime");
var _addons = require("@storybook/addons");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _clientApi = require("@storybook/client-api");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
function ScrollingDecorator(props) {
    var _getQueryParams;
    let { children } = props;
    let [isScrolling, setScrolling] = (0, _react.useState)(((_getQueryParams = (0, _clientApi.getQueryParams)()) === null || _getQueryParams === void 0 ? void 0 : _getQueryParams.scrolling) === "true" || false);
    (0, _react.useEffect)(()=>{
        let channel = (0, _addons.addons).getChannel();
        let updateScrolling = (val)=>{
            setScrolling(val);
        };
        channel.on("scrolling/updated", updateScrolling);
        return ()=>{
            channel.removeListener("scrolling/updated", updateScrolling);
        };
    }, []);
    let styles = {
        alignItems: "center",
        boxSizing: "border-box",
        display: "flex",
        justifyContent: "center"
    };
    if (isScrolling) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        style: {
            overflow: "auto",
            height: "100vh",
            width: "100vw"
        },
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(StoryWrapper, {
            style: {
                ...styles,
                height: "300vh",
                width: "300vw"
            },
            children: children
        })
    });
    else return /*#__PURE__*/ (0, _jsxRuntime.jsx)(StoryWrapper, {
        style: {
            ...styles,
            minHeight: "100svh"
        },
        children: children
    });
}
function StoryWrapper({ children, className, style }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: (0, _clsxDefault.default)("react-spectrum-story", className),
        style: style,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                style: {
                    position: "absolute",
                    top: 0,
                    left: 0
                },
                children: (0, _reactDefault.default).version
            }),
            children
        ]
    });
}
const withScrollingSwitcher = (Story)=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(ScrollingDecorator, {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Story, {})
    });
};

},{"react/jsx-runtime":"76HCq","@storybook/addons":"88cx9","clsx":"fAYNK","@storybook/client-api":"5kgK6","react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}],"ddKKM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "withStrictModeSwitcher", ()=>withStrictModeSwitcher);
var _jsxRuntime = require("react/jsx-runtime");
var _addons = require("@storybook/addons");
var _clientApi = require("@storybook/client-api");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
function StrictModeDecorator(props) {
    var _getQueryParams;
    let { children } = props;
    let [isStrict, setStrict] = (0, _react.useState)(((_getQueryParams = (0, _clientApi.getQueryParams)()) === null || _getQueryParams === void 0 ? void 0 : _getQueryParams.strict) !== "false");
    (0, _react.useEffect)(()=>{
        let channel = (0, _addons.addons).getChannel();
        let updateStrict = (val)=>{
            setStrict(val);
        };
        channel.on("strict/updated", updateStrict);
        return ()=>{
            channel.removeListener("strict/updated", updateStrict);
        };
    }, []);
    return isStrict ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _react.StrictMode), {
        children: children
    }) : children;
}
const withStrictModeSwitcher = (0, _addons.makeDecorator)({
    name: "withStrictModeSwitcher",
    parameterName: "strictModeSwitcher",
    wrapper: (getStory, context)=>{
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)(StrictModeDecorator, {
            children: getStory(context)
        });
    }
});

},{"react/jsx-runtime":"76HCq","@storybook/addons":"88cx9","@storybook/client-api":"5kgK6","react":"9yzVZ","@parcel/transformer-js/src/esmodule-helpers.js":"9A7PF"}]},["f7EF9"], "f7EF9", "parcelRequire7f0c")

//# sourceMappingURL=iframe.b8198653.js.map
